export const countriesData = [
    {
        "id": 1,
        "name": "Afghanistan",
        "iso3": "AFG",
        "iso2": "AF",
        "numeric_code": "004",
        "phonecode": "93",
        "capital": "Kabul",
        "currency": "AFN",
        "currency_name": "Afghan afghani",
        "currency_symbol": "؋",
        "tld": ".af",
        "native": "افغانستان",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Southern Asia",
        "subregion_id": 14,
        "nationality": "Afghan",
        "timezones": [
            {
                "zoneName": "Asia\/Kabul",
                "gmtOffset": 16200,
                "gmtOffsetName": "UTC+04:30",
                "abbreviation": "AFT",
                "tzName": "Afghanistan Time"
            }
        ],
        "translations": {
            "br": "Afghanistan",
            "ko": "아프가니스탄",
            "pt-BR": "Afeganistão",
            "pt": "Afeganistão",
            "nl": "Afghanistan",
            "hr": "Afganistan",
            "fa": "افغانستان",
            "de": "Afghanistan",
            "es": "Afganistán",
            "fr": "Afghanistan",
            "ja": "アフガニスタン",
            "it": "Afghanistan",
            "zh-CN": "阿富汗",
            "tr": "Afganistan",
            "ru": "Афганистан",
            "uk": "Афганістан",
            "pl": "Afganistan"
        },
        "latitude": "33.00000000",
        "longitude": "65.00000000",
        "emoji": "🇦🇫",
        "emojiU": "U+1F1E6 U+1F1EB",
        "states": [
            {
                "id": 3901,
                "name": "Badakhshan",
                "iso2": "BDS",
                "latitude": "36.73477250",
                "longitude": "70.81199530",
                "type": "province",
                "cities": [
                    {
                        "id": 52,
                        "name": "Ashkāsham",
                        "latitude": "36.68333000",
                        "longitude": "71.53333000"
                    },
                    {
                        "id": 68,
                        "name": "Fayzabad",
                        "latitude": "37.11664000",
                        "longitude": "70.58002000"
                    },
                    {
                        "id": 78,
                        "name": "Jurm",
                        "latitude": "36.86477000",
                        "longitude": "70.83421000"
                    },
                    {
                        "id": 84,
                        "name": "Khandūd",
                        "latitude": "36.95127000",
                        "longitude": "72.31800000"
                    },
                    {
                        "id": 115,
                        "name": "Rāghistān",
                        "latitude": "37.66079000",
                        "longitude": "70.67346000"
                    },
                    {
                        "id": 131,
                        "name": "Wākhān",
                        "latitude": "37.05710000",
                        "longitude": "73.34928000"
                    }
                ]
            },
            {
                "id": 3871,
                "name": "Badghis",
                "iso2": "BDG",
                "latitude": "35.16713390",
                "longitude": "63.76953840",
                "type": "province",
                "cities": [
                    {
                        "id": 72,
                        "name": "Ghormach",
                        "latitude": "35.73062000",
                        "longitude": "63.78264000"
                    },
                    {
                        "id": 108,
                        "name": "Qala i Naw",
                        "latitude": "34.98735000",
                        "longitude": "63.12891000"
                    }
                ]
            },
            {
                "id": 3875,
                "name": "Baghlan",
                "iso2": "BGL",
                "latitude": "36.17890260",
                "longitude": "68.74530640",
                "type": "province",
                "cities": [
                    {
                        "id": 54,
                        "name": "Baghlān",
                        "latitude": "36.13068000",
                        "longitude": "68.70829000"
                    },
                    {
                        "id": 140,
                        "name": "Ḩukūmatī Dahanah-ye Ghōrī",
                        "latitude": "35.90617000",
                        "longitude": "68.48869000"
                    },
                    {
                        "id": 101,
                        "name": "Nahrīn",
                        "latitude": "36.06490000",
                        "longitude": "69.13343000"
                    },
                    {
                        "id": 105,
                        "name": "Pul-e Khumrī",
                        "latitude": "35.94458000",
                        "longitude": "68.71512000"
                    }
                ]
            },
            {
                "id": 3884,
                "name": "Balkh",
                "iso2": "BAL",
                "latitude": "36.75506030",
                "longitude": "66.89753720",
                "type": "province",
                "cities": [
                    {
                        "id": 55,
                        "name": "Balkh",
                        "latitude": "36.75635000",
                        "longitude": "66.89720000"
                    },
                    {
                        "id": 65,
                        "name": "Dowlatābād",
                        "latitude": "36.98821000",
                        "longitude": "66.82069000"
                    },
                    {
                        "id": 85,
                        "name": "Khulm",
                        "latitude": "36.69736000",
                        "longitude": "67.69826000"
                    },
                    {
                        "id": 91,
                        "name": "Lab-Sar",
                        "latitude": "36.02634000",
                        "longitude": "66.83799000"
                    },
                    {
                        "id": 97,
                        "name": "Mazār-e Sharīf",
                        "latitude": "36.70904000",
                        "longitude": "67.11087000"
                    },
                    {
                        "id": 112,
                        "name": "Qarchī Gak",
                        "latitude": "37.03999000",
                        "longitude": "66.78891000"
                    }
                ]
            },
            {
                "id": 3872,
                "name": "Bamyan",
                "iso2": "BAM",
                "latitude": "34.81000670",
                "longitude": "67.82121040",
                "type": "province",
                "cities": [
                    {
                        "id": 57,
                        "name": "Bāmyān",
                        "latitude": "34.82156000",
                        "longitude": "67.82734000"
                    },
                    {
                        "id": 104,
                        "name": "Panjāb",
                        "latitude": "34.38795000",
                        "longitude": "67.02327000"
                    }
                ]
            },
            {
                "id": 3892,
                "name": "Daykundi",
                "iso2": "DAY",
                "latitude": "33.66949500",
                "longitude": "66.04635340",
                "type": "province",
                "cities": [
                    {
                        "id": 102,
                        "name": "Nīlī",
                        "latitude": "33.76329000",
                        "longitude": "66.07617000"
                    }
                ]
            },
            {
                "id": 3899,
                "name": "Farah",
                "iso2": "FRA",
                "latitude": "32.49532800",
                "longitude": "62.26266270",
                "type": "province",
                "cities": [
                    {
                        "id": 66,
                        "name": "Farah",
                        "latitude": "32.37451000",
                        "longitude": "62.11638000"
                    }
                ]
            },
            {
                "id": 3889,
                "name": "Faryab",
                "iso2": "FYB",
                "latitude": "36.07956130",
                "longitude": "64.90595500",
                "type": "province",
                "cities": [
                    {
                        "id": 50,
                        "name": "Andkhoy",
                        "latitude": "36.95293000",
                        "longitude": "65.12376000"
                    },
                    {
                        "id": 96,
                        "name": "Maymana",
                        "latitude": "35.92139000",
                        "longitude": "64.78361000"
                    }
                ]
            },
            {
                "id": 3870,
                "name": "Ghazni",
                "iso2": "GHA",
                "latitude": "33.54505870",
                "longitude": "68.41739720",
                "type": "province",
                "cities": [
                    {
                        "id": 71,
                        "name": "Ghazni",
                        "latitude": "33.55391000",
                        "longitude": "68.42096000"
                    }
                ]
            },
            {
                "id": 3888,
                "name": "Ghōr",
                "iso2": "GHO",
                "latitude": "34.09957760",
                "longitude": "64.90595500",
                "type": "province",
                "cities": [
                    {
                        "id": 67,
                        "name": "Fayrōz Kōh",
                        "latitude": "34.51952000",
                        "longitude": "65.25093000"
                    },
                    {
                        "id": 121,
                        "name": "Shahrak",
                        "latitude": "34.10737000",
                        "longitude": "64.30520000"
                    }
                ]
            },
            {
                "id": 3873,
                "name": "Helmand",
                "iso2": "HEL",
                "latitude": "39.29893610",
                "longitude": "-76.61604720",
                "type": "province",
                "cities": [
                    {
                        "id": 141,
                        "name": "‘Alāqahdārī Dīshū",
                        "latitude": "30.43206000",
                        "longitude": "63.29802000"
                    },
                    {
                        "id": 70,
                        "name": "Gereshk",
                        "latitude": "31.82089000",
                        "longitude": "64.57005000"
                    },
                    {
                        "id": 93,
                        "name": "Lashkar Gāh",
                        "latitude": "31.59382000",
                        "longitude": "64.37161000"
                    },
                    {
                        "id": 95,
                        "name": "Markaz-e Ḩukūmat-e Darwēshān",
                        "latitude": "31.13231000",
                        "longitude": "64.19340000"
                    },
                    {
                        "id": 118,
                        "name": "Sangīn",
                        "latitude": "32.07275000",
                        "longitude": "64.83590000"
                    }
                ]
            },
            {
                "id": 3887,
                "name": "Herat",
                "iso2": "HER",
                "latitude": "34.35286500",
                "longitude": "62.20402870",
                "type": "province",
                "cities": [
                    {
                        "id": 60,
                        "name": "Chahār Burj",
                        "latitude": "34.24475000",
                        "longitude": "62.19165000"
                    },
                    {
                        "id": 73,
                        "name": "Ghōriyān",
                        "latitude": "34.34480000",
                        "longitude": "61.49321000"
                    },
                    {
                        "id": 74,
                        "name": "Herāt",
                        "latitude": "34.34817000",
                        "longitude": "62.19967000"
                    },
                    {
                        "id": 80,
                        "name": "Kafir Qala",
                        "latitude": "34.66667000",
                        "longitude": "61.06667000"
                    },
                    {
                        "id": 82,
                        "name": "Karukh",
                        "latitude": "34.48108000",
                        "longitude": "62.58630000"
                    },
                    {
                        "id": 88,
                        "name": "Kuhsān",
                        "latitude": "34.65389000",
                        "longitude": "61.19778000"
                    },
                    {
                        "id": 90,
                        "name": "Kushk",
                        "latitude": "33.29565000",
                        "longitude": "61.95221000"
                    },
                    {
                        "id": 111,
                        "name": "Qarah Bāgh",
                        "latitude": "34.94023000",
                        "longitude": "61.77589000"
                    },
                    {
                        "id": 123,
                        "name": "Shīnḏanḏ",
                        "latitude": "33.30294000",
                        "longitude": "62.14740000"
                    },
                    {
                        "id": 129,
                        "name": "Tīr Pul",
                        "latitude": "34.59431000",
                        "longitude": "61.26895000"
                    },
                    {
                        "id": 135,
                        "name": "Zindah Jān",
                        "latitude": "34.34264000",
                        "longitude": "61.74675000"
                    }
                ]
            },
            {
                "id": 3886,
                "name": "Jowzjan",
                "iso2": "JOW",
                "latitude": "36.89696920",
                "longitude": "65.66585680",
                "type": "province",
                "cities": [
                    {
                        "id": 136,
                        "name": "Āqchah",
                        "latitude": "36.90500000",
                        "longitude": "66.18341000"
                    },
                    {
                        "id": 63,
                        "name": "Darzāb",
                        "latitude": "35.97744000",
                        "longitude": "65.37828000"
                    },
                    {
                        "id": 113,
                        "name": "Qarqīn",
                        "latitude": "37.41853000",
                        "longitude": "66.04358000"
                    },
                    {
                        "id": 122,
                        "name": "Shibirghān",
                        "latitude": "36.66757000",
                        "longitude": "65.75290000"
                    }
                ]
            },
            {
                "id": 3902,
                "name": "Kabul",
                "iso2": "KAB",
                "latitude": "34.55534940",
                "longitude": "69.20748600",
                "type": "province",
                "cities": [
                    {
                        "id": 79,
                        "name": "Kabul",
                        "latitude": "34.52813000",
                        "longitude": "69.17233000"
                    },
                    {
                        "id": 99,
                        "name": "Mīr Bachah Kōṯ",
                        "latitude": "34.74999000",
                        "longitude": "69.11899000"
                    },
                    {
                        "id": 103,
                        "name": "Paghmān",
                        "latitude": "34.58787000",
                        "longitude": "68.95091000"
                    }
                ]
            },
            {
                "id": 3890,
                "name": "Kandahar",
                "iso2": "KAN",
                "latitude": "31.62887100",
                "longitude": "65.73717490",
                "type": "province",
                "cities": [
                    {
                        "id": 81,
                        "name": "Kandahār",
                        "latitude": "31.61332000",
                        "longitude": "65.71013000"
                    }
                ]
            },
            {
                "id": 3879,
                "name": "Kapisa",
                "iso2": "KAP",
                "latitude": "34.98105720",
                "longitude": "69.62145620",
                "type": "province",
                "cities": [
                    {
                        "id": 124,
                        "name": "Sidqābād",
                        "latitude": "35.02298000",
                        "longitude": "69.35112000"
                    }
                ]
            },
            {
                "id": 3878,
                "name": "Khost",
                "iso2": "KHO",
                "latitude": "33.33384720",
                "longitude": "69.93716730",
                "type": "province",
                "cities": [
                    {
                        "id": 87,
                        "name": "Khōst",
                        "latitude": "33.33951000",
                        "longitude": "69.92041000"
                    }
                ]
            },
            {
                "id": 3876,
                "name": "Kunar",
                "iso2": "KNR",
                "latitude": "34.84658930",
                "longitude": "71.09731700",
                "type": "province",
                "cities": [
                    {
                        "id": 51,
                        "name": "Asadabad",
                        "latitude": "34.87311000",
                        "longitude": "71.14697000"
                    },
                    {
                        "id": 138,
                        "name": "Āsmār",
                        "latitude": "35.03333000",
                        "longitude": "71.35809000"
                    }
                ]
            },
            {
                "id": 3900,
                "name": "Kunduz Province",
                "iso2": "KDZ",
                "latitude": "36.72855110",
                "longitude": "68.86789820",
                "type": "province",
                "cities": [
                    {
                        "id": 64,
                        "name": "Dasht-e Archī",
                        "latitude": "37.13333000",
                        "longitude": "69.16667000"
                    },
                    {
                        "id": 75,
                        "name": "Imām Şāḩib",
                        "latitude": "37.18897000",
                        "longitude": "68.93644000"
                    },
                    {
                        "id": 83,
                        "name": "Khanabad",
                        "latitude": "36.68250000",
                        "longitude": "69.11556000"
                    },
                    {
                        "id": 89,
                        "name": "Kunduz",
                        "latitude": "36.72895000",
                        "longitude": "68.85700000"
                    },
                    {
                        "id": 114,
                        "name": "Qarāwul",
                        "latitude": "37.21959000",
                        "longitude": "68.78020000"
                    }
                ]
            },
            {
                "id": 3891,
                "name": "Laghman",
                "iso2": "LAG",
                "latitude": "34.68976870",
                "longitude": "70.14558050",
                "type": "province",
                "cities": [
                    {
                        "id": 98,
                        "name": "Mehtar Lām",
                        "latitude": "34.67139000",
                        "longitude": "70.20944000"
                    }
                ]
            },
            {
                "id": 3897,
                "name": "Logar",
                "iso2": "LOG",
                "latitude": "34.01455180",
                "longitude": "69.19239160",
                "type": "province",
                "cities": [
                    {
                        "id": 56,
                        "name": "Baraki Barak",
                        "latitude": "33.96744000",
                        "longitude": "68.94920000"
                    },
                    {
                        "id": 139,
                        "name": "Ḩukūmatī Azrah",
                        "latitude": "34.17355000",
                        "longitude": "69.64573000"
                    },
                    {
                        "id": 106,
                        "name": "Pul-e ‘Alam",
                        "latitude": "33.99529000",
                        "longitude": "69.02274000"
                    }
                ]
            },
            {
                "id": 3882,
                "name": "Nangarhar",
                "iso2": "NAN",
                "latitude": "34.17183130",
                "longitude": "70.62167940",
                "type": "province",
                "cities": [
                    {
                        "id": 58,
                        "name": "Bāsawul",
                        "latitude": "34.24749000",
                        "longitude": "70.87218000"
                    },
                    {
                        "id": 77,
                        "name": "Jalālābād",
                        "latitude": "34.42647000",
                        "longitude": "70.45153000"
                    }
                ]
            },
            {
                "id": 3896,
                "name": "Nimruz",
                "iso2": "NIM",
                "latitude": "31.02614880",
                "longitude": "62.45041540",
                "type": "province",
                "cities": [
                    {
                        "id": 86,
                        "name": "Khāsh",
                        "latitude": "31.52919000",
                        "longitude": "62.79055000"
                    },
                    {
                        "id": 100,
                        "name": "Mīrābād",
                        "latitude": "30.43624000",
                        "longitude": "61.83830000"
                    },
                    {
                        "id": 116,
                        "name": "Rūdbār",
                        "latitude": "30.15000000",
                        "longitude": "62.60000000"
                    },
                    {
                        "id": 132,
                        "name": "Zaranj",
                        "latitude": "30.95962000",
                        "longitude": "61.86037000"
                    }
                ]
            },
            {
                "id": 3880,
                "name": "Nuristan",
                "iso2": "NUR",
                "latitude": "35.32502230",
                "longitude": "70.90712360",
                "type": "province",
                "cities": [
                    {
                        "id": 107,
                        "name": "Pārūn",
                        "latitude": "35.42064000",
                        "longitude": "70.92261000"
                    }
                ]
            },
            {
                "id": 3894,
                "name": "Paktia",
                "iso2": "PIA",
                "latitude": "33.70619900",
                "longitude": "69.38310790",
                "type": "province",
                "cities": [
                    {
                        "id": 69,
                        "name": "Gardez",
                        "latitude": "33.59744000",
                        "longitude": "69.22592000"
                    }
                ]
            },
            {
                "id": 3877,
                "name": "Paktika",
                "iso2": "PKA",
                "latitude": "32.26453860",
                "longitude": "68.52471490",
                "type": "province",
                "cities": [
                    {
                        "id": 120,
                        "name": "Saṟōbī",
                        "latitude": "32.75221000",
                        "longitude": "69.04587000"
                    },
                    {
                        "id": 134,
                        "name": "Zaṟah Sharan",
                        "latitude": "33.14641000",
                        "longitude": "68.79213000"
                    },
                    {
                        "id": 133,
                        "name": "Zarghūn Shahr",
                        "latitude": "32.84734000",
                        "longitude": "68.44573000"
                    }
                ]
            },
            {
                "id": 3881,
                "name": "Panjshir",
                "iso2": "PAN",
                "latitude": "38.88023910",
                "longitude": "-77.17172380",
                "type": "province",
                "cities": [
                    {
                        "id": 59,
                        "name": "Bāzārak",
                        "latitude": "35.31292000",
                        "longitude": "69.51519000"
                    }
                ]
            },
            {
                "id": 3895,
                "name": "Parwan",
                "iso2": "PAR",
                "latitude": "34.96309770",
                "longitude": "68.81088490",
                "type": "province",
                "cities": [
                    {
                        "id": 61,
                        "name": "Charikar",
                        "latitude": "35.01361000",
                        "longitude": "69.17139000"
                    },
                    {
                        "id": 76,
                        "name": "Jabal os Saraj",
                        "latitude": "35.11833000",
                        "longitude": "69.23778000"
                    }
                ]
            },
            {
                "id": 3883,
                "name": "Samangan",
                "iso2": "SAM",
                "latitude": "36.31555060",
                "longitude": "67.96428630",
                "type": "province",
                "cities": [
                    {
                        "id": 53,
                        "name": "Aībak",
                        "latitude": "36.26468000",
                        "longitude": "68.01551000"
                    }
                ]
            },
            {
                "id": 3885,
                "name": "Sar-e Pol",
                "iso2": "SAR",
                "latitude": "36.21662800",
                "longitude": "65.93336000",
                "type": "province",
                "cities": [
                    {
                        "id": 62,
                        "name": "Chīras",
                        "latitude": "35.41674000",
                        "longitude": "65.98234000"
                    },
                    {
                        "id": 92,
                        "name": "Larkird",
                        "latitude": "35.48936000",
                        "longitude": "66.66409000"
                    },
                    {
                        "id": 110,
                        "name": "Qal‘ah-ye Shahr",
                        "latitude": "35.54729000",
                        "longitude": "65.56760000"
                    },
                    {
                        "id": 117,
                        "name": "Sang-e Chārak",
                        "latitude": "35.84972000",
                        "longitude": "66.43694000"
                    },
                    {
                        "id": 119,
                        "name": "Sar-e Pul",
                        "latitude": "36.21544000",
                        "longitude": "65.93249000"
                    },
                    {
                        "id": 125,
                        "name": "Tagāw-Bāy",
                        "latitude": "35.69941000",
                        "longitude": "66.06164000"
                    },
                    {
                        "id": 128,
                        "name": "Tukzār",
                        "latitude": "35.94831000",
                        "longitude": "66.42132000"
                    }
                ]
            },
            {
                "id": 3893,
                "name": "Takhar",
                "iso2": "TAK",
                "latitude": "36.66980130",
                "longitude": "69.47845410",
                "type": "province",
                "cities": [
                    {
                        "id": 137,
                        "name": "Ārt Khwājah",
                        "latitude": "37.08571000",
                        "longitude": "69.47958000"
                    },
                    {
                        "id": 126,
                        "name": "Taloqan",
                        "latitude": "36.73605000",
                        "longitude": "69.53451000"
                    }
                ]
            },
            {
                "id": 3898,
                "name": "Urozgan",
                "iso2": "URU",
                "latitude": "32.92712870",
                "longitude": "66.14152630",
                "type": "province",
                "cities": [
                    {
                        "id": 127,
                        "name": "Tarinkot",
                        "latitude": "32.62998000",
                        "longitude": "65.87806000"
                    },
                    {
                        "id": 130,
                        "name": "Uruzgān",
                        "latitude": "32.92775000",
                        "longitude": "66.63253000"
                    }
                ]
            },
            {
                "id": 3874,
                "name": "Zabul",
                "iso2": "ZAB",
                "latitude": "32.19187820",
                "longitude": "67.18944880",
                "type": "province",
                "cities": [
                    {
                        "id": 109,
                        "name": "Qalāt",
                        "latitude": "32.10575000",
                        "longitude": "66.90833000"
                    }
                ]
            }
        ]
    },
    {
        "id": 2,
        "name": "Aland Islands",
        "iso3": "ALA",
        "iso2": "AX",
        "numeric_code": "248",
        "phonecode": "358",
        "capital": "Mariehamn",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".ax",
        "native": "Åland",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Aland Island",
        "timezones": [
            {
                "zoneName": "Europe\/Mariehamn",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Åland",
            "ko": "올란드 제도",
            "pt-BR": "Ilhas de Aland",
            "pt": "Ilhas de Aland",
            "nl": "Ålandeilanden",
            "hr": "Ålandski otoci",
            "fa": "جزایر الند",
            "de": "Åland",
            "es": "Alandia",
            "fr": "Åland",
            "ja": "オーランド諸島",
            "it": "Isole Aland",
            "zh-CN": "奥兰群岛",
            "tr": "Åland Adalari",
            "ru": "Аландские острова",
            "uk": "Аландські острови",
            "pl": "Wyspy Alandzkie"
        },
        "latitude": "60.11666700",
        "longitude": "19.90000000",
        "emoji": "🇦🇽",
        "emojiU": "U+1F1E6 U+1F1FD",
        "states": [
            {
                "id": 5298,
                "name": "Brändö",
                "iso2": null,
                "latitude": "60.41259080",
                "longitude": "21.02299420",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5294,
                "name": "Eckerö",
                "iso2": null,
                "latitude": "60.22318140",
                "longitude": "19.53893790",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5289,
                "name": "Finström",
                "iso2": null,
                "latitude": "60.22993210",
                "longitude": "19.96746360",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5295,
                "name": "Föglö",
                "iso2": null,
                "latitude": "60.01462770",
                "longitude": "20.39334070",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5296,
                "name": "Geta",
                "iso2": null,
                "latitude": "60.37497270",
                "longitude": "19.82659620",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5292,
                "name": "Hammarland",
                "iso2": null,
                "latitude": "60.21641830",
                "longitude": "19.71964030",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5288,
                "name": "Jomala",
                "iso2": null,
                "latitude": "60.15223910",
                "longitude": "19.87479810",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5301,
                "name": "Kökar",
                "iso2": null,
                "latitude": "59.92081700",
                "longitude": "20.88853020",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5300,
                "name": "Kumlinge",
                "iso2": null,
                "latitude": "60.25992720",
                "longitude": "20.75875000",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5290,
                "name": "Lemland",
                "iso2": null,
                "latitude": "60.06887050",
                "longitude": "20.06581400",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5299,
                "name": "Lumparland",
                "iso2": null,
                "latitude": "60.11523570",
                "longitude": "20.24142800",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5287,
                "name": "Mariehamn",
                "iso2": null,
                "latitude": "60.09455780",
                "longitude": "19.79505300",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5291,
                "name": "Saltvik",
                "iso2": null,
                "latitude": "60.27554460",
                "longitude": "20.04131920",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5302,
                "name": "Sottunga",
                "iso2": null,
                "latitude": "60.13079770",
                "longitude": "20.64598210",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5293,
                "name": "Sund",
                "iso2": null,
                "latitude": "60.23084760",
                "longitude": "19.82397050",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 5297,
                "name": "Vårdö",
                "iso2": null,
                "latitude": "60.24233960",
                "longitude": "20.35281050",
                "type": "municipality",
                "cities": []
            }
        ]
    },
    {
        "id": 3,
        "name": "Albania",
        "iso3": "ALB",
        "iso2": "AL",
        "numeric_code": "008",
        "phonecode": "355",
        "capital": "Tirana",
        "currency": "ALL",
        "currency_name": "Albanian lek",
        "currency_symbol": "Lek",
        "tld": ".al",
        "native": "Shqipëria",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Albanian ",
        "timezones": [
            {
                "zoneName": "Europe\/Tirane",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Albania",
            "ko": "알바니아",
            "pt-BR": "Albânia",
            "pt": "Albânia",
            "nl": "Albanië",
            "hr": "Albanija",
            "fa": "آلبانی",
            "de": "Albanien",
            "es": "Albania",
            "fr": "Albanie",
            "ja": "アルバニア",
            "it": "Albania",
            "zh-CN": "阿尔巴尼亚",
            "tr": "Arnavutluk",
            "ru": "Албания",
            "uk": "Албанія",
            "pl": "Albania"
        },
        "latitude": "41.00000000",
        "longitude": "20.00000000",
        "emoji": "🇦🇱",
        "emojiU": "U+1F1E6 U+1F1F1",
        "states": [
            {
                "id": 629,
                "name": "Berat",
                "iso2": "BR",
                "latitude": "40.70863770",
                "longitude": "19.94373140",
                "type": "district",
                "cities": [
                    {
                        "id": 153,
                        "name": "Banaj",
                        "latitude": "40.82492000",
                        "longitude": "19.84074000"
                    },
                    {
                        "id": 154,
                        "name": "Bashkia Berat",
                        "latitude": "40.69997000",
                        "longitude": "19.94983000"
                    },
                    {
                        "id": 170,
                        "name": "Bashkia Kuçovë",
                        "latitude": "40.82489000",
                        "longitude": "19.95350000"
                    },
                    {
                        "id": 180,
                        "name": "Bashkia Poliçan",
                        "latitude": "40.58608000",
                        "longitude": "20.04535000"
                    },
                    {
                        "id": 186,
                        "name": "Bashkia Skrapar",
                        "latitude": "40.56036000",
                        "longitude": "20.25477000"
                    },
                    {
                        "id": 191,
                        "name": "Berat",
                        "latitude": "40.70583000",
                        "longitude": "19.95222000"
                    },
                    {
                        "id": 280,
                        "name": "Çorovodë",
                        "latitude": "40.50417000",
                        "longitude": "20.22722000"
                    },
                    {
                        "id": 219,
                        "name": "Kuçovë",
                        "latitude": "40.80028000",
                        "longitude": "19.91667000"
                    },
                    {
                        "id": 238,
                        "name": "Poliçan",
                        "latitude": "40.61222000",
                        "longitude": "20.09806000"
                    },
                    {
                        "id": 242,
                        "name": "Rrethi i Beratit",
                        "latitude": "40.66667000",
                        "longitude": "20.00000000"
                    },
                    {
                        "id": 253,
                        "name": "Rrethi i Kuçovës",
                        "latitude": "40.83333000",
                        "longitude": "19.91667000"
                    },
                    {
                        "id": 258,
                        "name": "Rrethi i Skraparit",
                        "latitude": "40.55000000",
                        "longitude": "20.26667000"
                    },
                    {
                        "id": 273,
                        "name": "Ura Vajgurore",
                        "latitude": "40.76889000",
                        "longitude": "19.87778000"
                    }
                ]
            },
            {
                "id": 603,
                "name": "Berat",
                "iso2": "01",
                "latitude": "40.69530120",
                "longitude": "20.04496620",
                "type": "county",
                "cities": []
            },
            {
                "id": 607,
                "name": "Bulqizë",
                "iso2": "BU",
                "latitude": "41.49425870",
                "longitude": "20.21471570",
                "type": "district",
                "cities": []
            },
            {
                "id": 618,
                "name": "Delvinë",
                "iso2": "DL",
                "latitude": "39.94813640",
                "longitude": "20.09558910",
                "type": "district",
                "cities": []
            },
            {
                "id": 608,
                "name": "Devoll",
                "iso2": "DV",
                "latitude": "40.64473470",
                "longitude": "20.95066360",
                "type": "district",
                "cities": []
            },
            {
                "id": 610,
                "name": "Dibër",
                "iso2": "09",
                "latitude": "41.62158400",
                "longitude": "19.53462430",
                "type": "county",
                "cities": [
                    {
                        "id": 155,
                        "name": "Bashkia Bulqizë",
                        "latitude": "41.47152000",
                        "longitude": "20.33192000"
                    },
                    {
                        "id": 165,
                        "name": "Bashkia Klos",
                        "latitude": "41.50826000",
                        "longitude": "20.07107000"
                    },
                    {
                        "id": 176,
                        "name": "Bashkia Mat",
                        "latitude": "41.63317000",
                        "longitude": "20.01228000"
                    },
                    {
                        "id": 193,
                        "name": "Bulqizë",
                        "latitude": "41.49167000",
                        "longitude": "20.22194000"
                    },
                    {
                        "id": 194,
                        "name": "Burrel",
                        "latitude": "41.61028000",
                        "longitude": "20.00889000"
                    },
                    {
                        "id": 209,
                        "name": "Klos",
                        "latitude": "41.50694000",
                        "longitude": "20.08667000"
                    },
                    {
                        "id": 236,
                        "name": "Peshkopi",
                        "latitude": "41.68500000",
                        "longitude": "20.42889000"
                    },
                    {
                        "id": 243,
                        "name": "Rrethi i Bulqizës",
                        "latitude": "41.50000000",
                        "longitude": "20.33333000"
                    },
                    {
                        "id": 246,
                        "name": "Rrethi i Dibrës",
                        "latitude": "41.75000000",
                        "longitude": "20.33333000"
                    },
                    {
                        "id": 256,
                        "name": "Rrethi i Matit",
                        "latitude": "41.58333000",
                        "longitude": "20.08333000"
                    },
                    {
                        "id": 272,
                        "name": "Ulëz",
                        "latitude": "41.68278000",
                        "longitude": "19.89333000"
                    }
                ]
            },
            {
                "id": 605,
                "name": "Dibër",
                "iso2": "DI",
                "latitude": "41.73089580",
                "longitude": "20.02493810",
                "type": "district",
                "cities": []
            },
            {
                "id": 639,
                "name": "Durrës",
                "iso2": "DR",
                "latitude": "41.37065170",
                "longitude": "19.52110630",
                "type": "district",
                "cities": [
                    {
                        "id": 159,
                        "name": "Bashkia Durrës",
                        "latitude": "41.42743000",
                        "longitude": "19.48690000"
                    },
                    {
                        "id": 168,
                        "name": "Bashkia Krujë",
                        "latitude": "41.50091000",
                        "longitude": "19.72571000"
                    },
                    {
                        "id": 185,
                        "name": "Bashkia Shijak",
                        "latitude": "41.33558000",
                        "longitude": "19.58977000"
                    },
                    {
                        "id": 197,
                        "name": "Durrës",
                        "latitude": "41.32355000",
                        "longitude": "19.45469000"
                    },
                    {
                        "id": 198,
                        "name": "Durrës District",
                        "latitude": "41.31660000",
                        "longitude": "19.45000000"
                    },
                    {
                        "id": 203,
                        "name": "Fushë-Krujë",
                        "latitude": "41.47833000",
                        "longitude": "19.71778000"
                    },
                    {
                        "id": 214,
                        "name": "Krujë",
                        "latitude": "41.50917000",
                        "longitude": "19.79278000"
                    },
                    {
                        "id": 250,
                        "name": "Rrethi i Krujës",
                        "latitude": "41.55000000",
                        "longitude": "19.75000000"
                    },
                    {
                        "id": 265,
                        "name": "Shijak",
                        "latitude": "41.34556000",
                        "longitude": "19.56722000"
                    },
                    {
                        "id": 269,
                        "name": "Sukth",
                        "latitude": "41.38056000",
                        "longitude": "19.53778000"
                    }
                ]
            },
            {
                "id": 632,
                "name": "Durrës",
                "iso2": "02",
                "latitude": "41.50809720",
                "longitude": "19.61631850",
                "type": "county",
                "cities": []
            },
            {
                "id": 598,
                "name": "Elbasan",
                "iso2": "03",
                "latitude": "41.12666720",
                "longitude": "20.23556470",
                "type": "county",
                "cities": []
            },
            {
                "id": 627,
                "name": "Fier",
                "iso2": "FR",
                "latitude": "40.72750400",
                "longitude": "19.56275960",
                "type": "district",
                "cities": []
            },
            {
                "id": 631,
                "name": "Fier",
                "iso2": "04",
                "latitude": "40.91913920",
                "longitude": "19.66393090",
                "type": "county",
                "cities": [
                    {
                        "id": 152,
                        "name": "Ballsh",
                        "latitude": "40.59889000",
                        "longitude": "19.73472000"
                    },
                    {
                        "id": 157,
                        "name": "Bashkia Divjakë",
                        "latitude": "40.95716000",
                        "longitude": "19.52364000"
                    },
                    {
                        "id": 160,
                        "name": "Bashkia Fier",
                        "latitude": "40.72937000",
                        "longitude": "19.48690000"
                    },
                    {
                        "id": 174,
                        "name": "Bashkia Mallakastër",
                        "latitude": "40.55669000",
                        "longitude": "19.77347000"
                    },
                    {
                        "id": 179,
                        "name": "Bashkia Patos",
                        "latitude": "40.67793000",
                        "longitude": "19.65591000"
                    },
                    {
                        "id": 196,
                        "name": "Divjakë",
                        "latitude": "40.99667000",
                        "longitude": "19.52944000"
                    },
                    {
                        "id": 200,
                        "name": "Fier",
                        "latitude": "40.72389000",
                        "longitude": "19.55611000"
                    },
                    {
                        "id": 201,
                        "name": "Fier-Çifçi",
                        "latitude": "40.71667000",
                        "longitude": "19.56667000"
                    },
                    {
                        "id": 227,
                        "name": "Lushnjë",
                        "latitude": "40.94194000",
                        "longitude": "19.70500000"
                    },
                    {
                        "id": 234,
                        "name": "Patos",
                        "latitude": "40.68333000",
                        "longitude": "19.61944000"
                    },
                    {
                        "id": 235,
                        "name": "Patos Fshat",
                        "latitude": "40.64278000",
                        "longitude": "19.65083000"
                    },
                    {
                        "id": 241,
                        "name": "Roskovec",
                        "latitude": "40.73750000",
                        "longitude": "19.70222000"
                    },
                    {
                        "id": 254,
                        "name": "Rrethi i Mallakastrës",
                        "latitude": "40.55000000",
                        "longitude": "19.78333000"
                    }
                ]
            },
            {
                "id": 621,
                "name": "Gjirokastër",
                "iso2": "GJ",
                "latitude": "40.06728740",
                "longitude": "20.10452290",
                "type": "district",
                "cities": [
                    {
                        "id": 158,
                        "name": "Bashkia Dropull",
                        "latitude": "39.98584000",
                        "longitude": "20.30529000"
                    },
                    {
                        "id": 164,
                        "name": "Bashkia Kelcyrë",
                        "latitude": "40.36196000",
                        "longitude": "20.16476000"
                    },
                    {
                        "id": 172,
                        "name": "Bashkia Libohovë",
                        "latitude": "40.10754000",
                        "longitude": "20.25753000"
                    },
                    {
                        "id": 177,
                        "name": "Bashkia Memaliaj",
                        "latitude": "40.41524000",
                        "longitude": "19.96911000"
                    },
                    {
                        "id": 183,
                        "name": "Bashkia Përmet",
                        "latitude": "40.23246000",
                        "longitude": "20.41091000"
                    },
                    {
                        "id": 187,
                        "name": "Bashkia Tepelenë",
                        "latitude": "40.26736000",
                        "longitude": "19.97003000"
                    },
                    {
                        "id": 204,
                        "name": "Gjinkar",
                        "latitude": "40.19944000",
                        "longitude": "20.40611000"
                    },
                    {
                        "id": 205,
                        "name": "Gjirokastër",
                        "latitude": "40.07583000",
                        "longitude": "20.13889000"
                    },
                    {
                        "id": 220,
                        "name": "Këlcyrë",
                        "latitude": "40.31306000",
                        "longitude": "20.18944000"
                    },
                    {
                        "id": 221,
                        "name": "Lazarat",
                        "latitude": "40.04667000",
                        "longitude": "20.14750000"
                    },
                    {
                        "id": 225,
                        "name": "Libohovë",
                        "latitude": "40.03111000",
                        "longitude": "20.26306000"
                    },
                    {
                        "id": 231,
                        "name": "Memaliaj",
                        "latitude": "40.35167000",
                        "longitude": "19.98028000"
                    },
                    {
                        "id": 240,
                        "name": "Përmet",
                        "latitude": "40.23361000",
                        "longitude": "20.35167000"
                    },
                    {
                        "id": 270,
                        "name": "Tepelenë",
                        "latitude": "40.29583000",
                        "longitude": "20.01917000"
                    }
                ]
            },
            {
                "id": 604,
                "name": "Gjirokastër",
                "iso2": "05",
                "latitude": "40.15080030",
                "longitude": "19.52718080",
                "type": "county",
                "cities": []
            },
            {
                "id": 617,
                "name": "Gramsh",
                "iso2": "GR",
                "latitude": "40.86698730",
                "longitude": "20.18493230",
                "type": "district",
                "cities": []
            },
            {
                "id": 600,
                "name": "Has",
                "iso2": "HA",
                "latitude": "42.79013360",
                "longitude": "-83.61220120",
                "type": "district",
                "cities": []
            },
            {
                "id": 594,
                "name": "Kavajë",
                "iso2": "KA",
                "latitude": "41.18445290",
                "longitude": "19.56275960",
                "type": "district",
                "cities": []
            },
            {
                "id": 628,
                "name": "Kolonjë",
                "iso2": "ER",
                "latitude": "40.33732620",
                "longitude": "20.67946760",
                "type": "district",
                "cities": []
            },
            {
                "id": 630,
                "name": "Korçë",
                "iso2": "06",
                "latitude": "40.59056700",
                "longitude": "20.61689210",
                "type": "county",
                "cities": [
                    {
                        "id": 156,
                        "name": "Bashkia Devoll",
                        "latitude": "40.60078000",
                        "longitude": "20.93814000"
                    },
                    {
                        "id": 166,
                        "name": "Bashkia Kolonjë",
                        "latitude": "40.31420000",
                        "longitude": "20.61482000"
                    },
                    {
                        "id": 173,
                        "name": "Bashkia Maliq",
                        "latitude": "40.75508000",
                        "longitude": "20.60748000"
                    },
                    {
                        "id": 182,
                        "name": "Bashkia Pustec",
                        "latitude": "40.83591000",
                        "longitude": "20.89405000"
                    },
                    {
                        "id": 192,
                        "name": "Bilisht",
                        "latitude": "40.62750000",
                        "longitude": "20.99000000"
                    },
                    {
                        "id": 199,
                        "name": "Ersekë",
                        "latitude": "40.33778000",
                        "longitude": "20.67889000"
                    },
                    {
                        "id": 212,
                        "name": "Korçë",
                        "latitude": "40.61861000",
                        "longitude": "20.78083000"
                    },
                    {
                        "id": 223,
                        "name": "Leskovik",
                        "latitude": "40.15139000",
                        "longitude": "20.59722000"
                    },
                    {
                        "id": 226,
                        "name": "Libonik",
                        "latitude": "40.70444000",
                        "longitude": "20.70861000"
                    },
                    {
                        "id": 228,
                        "name": "Maliq",
                        "latitude": "40.70583000",
                        "longitude": "20.69972000"
                    },
                    {
                        "id": 230,
                        "name": "Mborje",
                        "latitude": "40.60333000",
                        "longitude": "20.80306000"
                    },
                    {
                        "id": 237,
                        "name": "Pogradec",
                        "latitude": "40.90250000",
                        "longitude": "20.65250000"
                    },
                    {
                        "id": 245,
                        "name": "Rrethi i Devollit",
                        "latitude": "40.58333000",
                        "longitude": "20.91667000"
                    },
                    {
                        "id": 249,
                        "name": "Rrethi i Kolonjës",
                        "latitude": "40.25000000",
                        "longitude": "20.66667000"
                    },
                    {
                        "id": 275,
                        "name": "Velçan",
                        "latitude": "40.95472000",
                        "longitude": "20.46222000"
                    },
                    {
                        "id": 278,
                        "name": "Voskopojë",
                        "latitude": "40.63306000",
                        "longitude": "20.58889000"
                    }
                ]
            },
            {
                "id": 597,
                "name": "Korçë",
                "iso2": "KO",
                "latitude": "40.56279250",
                "longitude": "20.29294150",
                "type": "district",
                "cities": []
            },
            {
                "id": 614,
                "name": "Krujë",
                "iso2": "KR",
                "latitude": "41.50947650",
                "longitude": "19.77107320",
                "type": "district",
                "cities": []
            },
            {
                "id": 612,
                "name": "Kuçovë",
                "iso2": "KC",
                "latitude": "40.78370630",
                "longitude": "19.87823480",
                "type": "district",
                "cities": []
            },
            {
                "id": 623,
                "name": "Kukës",
                "iso2": "KU",
                "latitude": "41.99748810",
                "longitude": "20.06373160",
                "type": "district",
                "cities": [
                    {
                        "id": 151,
                        "name": "Bajram Curri",
                        "latitude": "42.35734000",
                        "longitude": "20.07679000"
                    },
                    {
                        "id": 215,
                        "name": "Krumë",
                        "latitude": "42.19694000",
                        "longitude": "20.41333000"
                    },
                    {
                        "id": 217,
                        "name": "Kukës",
                        "latitude": "42.07694000",
                        "longitude": "20.42194000"
                    },
                    {
                        "id": 247,
                        "name": "Rrethi i Hasit",
                        "latitude": "42.16667000",
                        "longitude": "20.33333000"
                    },
                    {
                        "id": 251,
                        "name": "Rrethi i Kukësit",
                        "latitude": "42.00000000",
                        "longitude": "20.33333000"
                    }
                ]
            },
            {
                "id": 601,
                "name": "Kukës",
                "iso2": "07",
                "latitude": "42.18616880",
                "longitude": "19.55292880",
                "type": "county",
                "cities": []
            },
            {
                "id": 622,
                "name": "Kurbin",
                "iso2": "KB",
                "latitude": "41.64126440",
                "longitude": "19.70559500",
                "type": "district",
                "cities": []
            },
            {
                "id": 609,
                "name": "Lezhë",
                "iso2": "08",
                "latitude": "41.78137590",
                "longitude": "19.80679160",
                "type": "county",
                "cities": [
                    {
                        "id": 169,
                        "name": "Bashkia Kurbin",
                        "latitude": "41.62215000",
                        "longitude": "19.70734000"
                    },
                    {
                        "id": 171,
                        "name": "Bashkia Lezhë",
                        "latitude": "41.81320000",
                        "longitude": "19.64121000"
                    },
                    {
                        "id": 178,
                        "name": "Bashkia Mirditë",
                        "latitude": "41.80953000",
                        "longitude": "19.99024000"
                    },
                    {
                        "id": 218,
                        "name": "Kurbnesh",
                        "latitude": "41.77972000",
                        "longitude": "20.08361000"
                    },
                    {
                        "id": 222,
                        "name": "Laç",
                        "latitude": "41.63556000",
                        "longitude": "19.71306000"
                    },
                    {
                        "id": 224,
                        "name": "Lezhë",
                        "latitude": "41.78361000",
                        "longitude": "19.64361000"
                    },
                    {
                        "id": 229,
                        "name": "Mamurras",
                        "latitude": "41.57750000",
                        "longitude": "19.69222000"
                    },
                    {
                        "id": 232,
                        "name": "Milot",
                        "latitude": "41.68389000",
                        "longitude": "19.71556000"
                    },
                    {
                        "id": 261,
                        "name": "Rrëshen",
                        "latitude": "41.76750000",
                        "longitude": "19.87556000"
                    },
                    {
                        "id": 252,
                        "name": "Rrethi i Kurbinit",
                        "latitude": "41.63333000",
                        "longitude": "19.71667000"
                    },
                    {
                        "id": 262,
                        "name": "Rubik",
                        "latitude": "41.77444000",
                        "longitude": "19.78611000"
                    },
                    {
                        "id": 267,
                        "name": "Shëngjin",
                        "latitude": "41.81361000",
                        "longitude": "19.59389000"
                    }
                ]
            },
            {
                "id": 595,
                "name": "Lezhë",
                "iso2": "LE",
                "latitude": "41.78607300",
                "longitude": "19.64607580",
                "type": "district",
                "cities": []
            },
            {
                "id": 596,
                "name": "Librazhd",
                "iso2": "LB",
                "latitude": "41.18292320",
                "longitude": "20.31747690",
                "type": "district",
                "cities": []
            },
            {
                "id": 599,
                "name": "Lushnjë",
                "iso2": "LU",
                "latitude": "40.94198300",
                "longitude": "19.69964280",
                "type": "district",
                "cities": []
            },
            {
                "id": 602,
                "name": "Malësi e Madhe",
                "iso2": "MM",
                "latitude": "42.42451730",
                "longitude": "19.61631850",
                "type": "district",
                "cities": []
            },
            {
                "id": 637,
                "name": "Mallakastër",
                "iso2": "MK",
                "latitude": "40.52733760",
                "longitude": "19.78297910",
                "type": "district",
                "cities": []
            },
            {
                "id": 635,
                "name": "Mat",
                "iso2": "MT",
                "latitude": "41.59376750",
                "longitude": "19.99732440",
                "type": "district",
                "cities": []
            },
            {
                "id": 638,
                "name": "Mirditë",
                "iso2": "MR",
                "latitude": "41.76428600",
                "longitude": "19.90205090",
                "type": "district",
                "cities": []
            },
            {
                "id": 619,
                "name": "Peqin",
                "iso2": "PQ",
                "latitude": "41.04709020",
                "longitude": "19.75023840",
                "type": "district",
                "cities": []
            },
            {
                "id": 625,
                "name": "Përmet",
                "iso2": "PR",
                "latitude": "40.23618370",
                "longitude": "20.35173340",
                "type": "district",
                "cities": []
            },
            {
                "id": 606,
                "name": "Pogradec",
                "iso2": "PG",
                "latitude": "40.90153140",
                "longitude": "20.65562890",
                "type": "district",
                "cities": []
            },
            {
                "id": 620,
                "name": "Pukë",
                "iso2": "PU",
                "latitude": "42.04697720",
                "longitude": "19.89609680",
                "type": "district",
                "cities": []
            },
            {
                "id": 624,
                "name": "Sarandë",
                "iso2": "SR",
                "latitude": "39.85921190",
                "longitude": "20.02710010",
                "type": "district",
                "cities": []
            },
            {
                "id": 611,
                "name": "Shkodër",
                "iso2": "10",
                "latitude": "42.15037100",
                "longitude": "19.66393090",
                "type": "county",
                "cities": []
            },
            {
                "id": 626,
                "name": "Shkodër",
                "iso2": "SH",
                "latitude": "42.06929850",
                "longitude": "19.50325590",
                "type": "district",
                "cities": [
                    {
                        "id": 175,
                        "name": "Bashkia Malësi e Madhe",
                        "latitude": "42.36798000",
                        "longitude": "19.58977000"
                    },
                    {
                        "id": 181,
                        "name": "Bashkia Pukë",
                        "latitude": "42.02997000",
                        "longitude": "19.92778000"
                    },
                    {
                        "id": 188,
                        "name": "Bashkia Vau i Dejës",
                        "latitude": "42.04834000",
                        "longitude": "19.69999000"
                    },
                    {
                        "id": 202,
                        "name": "Fushë-Arrëz",
                        "latitude": "42.06222000",
                        "longitude": "20.01667000"
                    },
                    {
                        "id": 211,
                        "name": "Koplik",
                        "latitude": "42.21361000",
                        "longitude": "19.43639000"
                    },
                    {
                        "id": 239,
                        "name": "Pukë",
                        "latitude": "42.04444000",
                        "longitude": "19.89972000"
                    },
                    {
                        "id": 255,
                        "name": "Rrethi i Malësia e Madhe",
                        "latitude": "42.33333000",
                        "longitude": "19.58333000"
                    },
                    {
                        "id": 257,
                        "name": "Rrethi i Shkodrës",
                        "latitude": "42.06917000",
                        "longitude": "19.53506000"
                    },
                    {
                        "id": 266,
                        "name": "Shkodër",
                        "latitude": "42.06828000",
                        "longitude": "19.51258000"
                    },
                    {
                        "id": 274,
                        "name": "Vau i Dejës",
                        "latitude": "42.01000000",
                        "longitude": "19.62472000"
                    },
                    {
                        "id": 279,
                        "name": "Vukatanë",
                        "latitude": "42.02806000",
                        "longitude": "19.54778000"
                    }
                ]
            },
            {
                "id": 593,
                "name": "Skrapar",
                "iso2": "SK",
                "latitude": "40.53499460",
                "longitude": "20.28322170",
                "type": "district",
                "cities": []
            },
            {
                "id": 616,
                "name": "Tepelenë",
                "iso2": "TE",
                "latitude": "40.29666320",
                "longitude": "20.01816730",
                "type": "district",
                "cities": []
            },
            {
                "id": 633,
                "name": "Tirana",
                "iso2": "TR",
                "latitude": "41.32754590",
                "longitude": "19.81869820",
                "type": "district",
                "cities": [
                    {
                        "id": 163,
                        "name": "Bashkia Kavajë",
                        "latitude": "41.18127000",
                        "longitude": "19.55579000"
                    },
                    {
                        "id": 190,
                        "name": "Bashkia Vorë",
                        "latitude": "41.39804000",
                        "longitude": "19.67703000"
                    },
                    {
                        "id": 207,
                        "name": "Kamëz",
                        "latitude": "41.38167000",
                        "longitude": "19.76028000"
                    },
                    {
                        "id": 208,
                        "name": "Kavajë",
                        "latitude": "41.18556000",
                        "longitude": "19.55694000"
                    },
                    {
                        "id": 213,
                        "name": "Krrabë",
                        "latitude": "41.21556000",
                        "longitude": "19.97139000"
                    },
                    {
                        "id": 248,
                        "name": "Rrethi i Kavajës",
                        "latitude": "41.16667000",
                        "longitude": "19.58333000"
                    },
                    {
                        "id": 259,
                        "name": "Rrethi i Tiranës",
                        "latitude": "41.33333000",
                        "longitude": "19.91667000"
                    },
                    {
                        "id": 260,
                        "name": "Rrogozhinë",
                        "latitude": "41.07639000",
                        "longitude": "19.66528000"
                    },
                    {
                        "id": 268,
                        "name": "Sinaballaj",
                        "latitude": "41.06889000",
                        "longitude": "19.69944000"
                    },
                    {
                        "id": 271,
                        "name": "Tirana",
                        "latitude": "41.32750000",
                        "longitude": "19.81889000"
                    },
                    {
                        "id": 277,
                        "name": "Vorë",
                        "latitude": "41.39083000",
                        "longitude": "19.65500000"
                    }
                ]
            },
            {
                "id": 615,
                "name": "Tirana",
                "iso2": "11",
                "latitude": "41.24275980",
                "longitude": "19.80679160",
                "type": "county",
                "cities": []
            },
            {
                "id": 636,
                "name": "Tropojë",
                "iso2": "TP",
                "latitude": "42.39821510",
                "longitude": "20.16259550",
                "type": "district",
                "cities": []
            },
            {
                "id": 634,
                "name": "Vlorë",
                "iso2": "12",
                "latitude": "40.15009600",
                "longitude": "19.80679160",
                "type": "county",
                "cities": [
                    {
                        "id": 161,
                        "name": "Bashkia Finiq",
                        "latitude": "39.84393000",
                        "longitude": "20.16659000"
                    },
                    {
                        "id": 162,
                        "name": "Bashkia Himarë",
                        "latitude": "40.11581000",
                        "longitude": "19.81389000"
                    },
                    {
                        "id": 167,
                        "name": "Bashkia Konispol",
                        "latitude": "39.70064000",
                        "longitude": "20.13353000"
                    },
                    {
                        "id": 184,
                        "name": "Bashkia Selenicë",
                        "latitude": "40.39503000",
                        "longitude": "19.65958000"
                    },
                    {
                        "id": 189,
                        "name": "Bashkia Vlorë",
                        "latitude": "40.41340000",
                        "longitude": "19.49792000"
                    },
                    {
                        "id": 195,
                        "name": "Delvinë",
                        "latitude": "39.95111000",
                        "longitude": "20.09778000"
                    },
                    {
                        "id": 206,
                        "name": "Himarë",
                        "latitude": "40.10167000",
                        "longitude": "19.74472000"
                    },
                    {
                        "id": 210,
                        "name": "Konispol",
                        "latitude": "39.65889000",
                        "longitude": "20.18139000"
                    },
                    {
                        "id": 216,
                        "name": "Ksamil",
                        "latitude": "39.76889000",
                        "longitude": "19.99972000"
                    },
                    {
                        "id": 233,
                        "name": "Orikum",
                        "latitude": "40.32528000",
                        "longitude": "19.47139000"
                    },
                    {
                        "id": 244,
                        "name": "Rrethi i Delvinës",
                        "latitude": "39.91667000",
                        "longitude": "20.08333000"
                    },
                    {
                        "id": 263,
                        "name": "Sarandë",
                        "latitude": "39.87534000",
                        "longitude": "20.00477000"
                    },
                    {
                        "id": 264,
                        "name": "Selenicë",
                        "latitude": "40.53056000",
                        "longitude": "19.63583000"
                    },
                    {
                        "id": 276,
                        "name": "Vlorë",
                        "latitude": "40.46860000",
                        "longitude": "19.48318000"
                    }
                ]
            },
            {
                "id": 613,
                "name": "Vlorë",
                "iso2": "VL",
                "latitude": "40.46606680",
                "longitude": "19.49135600",
                "type": "district",
                "cities": []
            }
        ]
    },
    {
        "id": 4,
        "name": "Algeria",
        "iso3": "DZA",
        "iso2": "DZ",
        "numeric_code": "012",
        "phonecode": "213",
        "capital": "Algiers",
        "currency": "DZD",
        "currency_name": "Algerian dinar",
        "currency_symbol": "دج",
        "tld": ".dz",
        "native": "الجزائر",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Northern Africa",
        "subregion_id": 1,
        "nationality": "Algerian",
        "timezones": [
            {
                "zoneName": "Africa\/Algiers",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Aljeria",
            "ko": "알제리",
            "pt-BR": "Argélia",
            "pt": "Argélia",
            "nl": "Algerije",
            "hr": "Alžir",
            "fa": "الجزایر",
            "de": "Algerien",
            "es": "Argelia",
            "fr": "Algérie",
            "ja": "アルジェリア",
            "it": "Algeria",
            "zh-CN": "阿尔及利亚",
            "tr": "Cezayir",
            "ru": "Алжир",
            "uk": "Алжир",
            "pl": "Algieria"
        },
        "latitude": "28.00000000",
        "longitude": "3.00000000",
        "emoji": "🇩🇿",
        "emojiU": "U+1F1E9 U+1F1FF",
        "states": [
            {
                "id": 1118,
                "name": "Adrar",
                "iso2": "01",
                "latitude": "26.41813100",
                "longitude": "-0.60147170",
                "type": "province",
                "cities": [
                    {
                        "id": 31227,
                        "name": "Adrar",
                        "latitude": "27.87429000",
                        "longitude": "-0.29388000"
                    },
                    {
                        "id": 31234,
                        "name": "Aoulef",
                        "latitude": "26.96667000",
                        "longitude": "1.08333000"
                    },
                    {
                        "id": 31406,
                        "name": "Reggane",
                        "latitude": "26.71576000",
                        "longitude": "0.17140000"
                    },
                    {
                        "id": 31450,
                        "name": "Timimoun",
                        "latitude": "29.26388000",
                        "longitude": "0.23098000"
                    }
                ]
            },
            {
                "id": 1119,
                "name": "Aïn Defla",
                "iso2": "44",
                "latitude": "36.25094290",
                "longitude": "1.93938150",
                "type": "province",
                "cities": [
                    {
                        "id": 31243,
                        "name": "Aïn Defla",
                        "latitude": "36.26405000",
                        "longitude": "1.96790000"
                    },
                    {
                        "id": 31325,
                        "name": "El Abadia",
                        "latitude": "36.26951000",
                        "longitude": "1.68609000"
                    },
                    {
                        "id": 31331,
                        "name": "El Attaf",
                        "latitude": "36.22393000",
                        "longitude": "1.67187000"
                    },
                    {
                        "id": 31361,
                        "name": "Khemis Miliana",
                        "latitude": "36.26104000",
                        "longitude": "2.22015000"
                    },
                    {
                        "id": 31448,
                        "name": "Theniet el Had",
                        "latitude": "35.87111000",
                        "longitude": "2.02806000"
                    }
                ]
            },
            {
                "id": 1122,
                "name": "Aïn Témouchent",
                "iso2": "46",
                "latitude": "35.29926980",
                "longitude": "-1.13927920",
                "type": "province",
                "cities": [
                    {
                        "id": 31250,
                        "name": "Aïn Temouchent",
                        "latitude": "35.29749000",
                        "longitude": "-1.14037000"
                    },
                    {
                        "id": 31265,
                        "name": "Beni Saf",
                        "latitude": "35.30099000",
                        "longitude": "-1.38226000"
                    },
                    {
                        "id": 31329,
                        "name": "El Amria",
                        "latitude": "35.52439000",
                        "longitude": "-1.01577000"
                    },
                    {
                        "id": 31340,
                        "name": "El Malah",
                        "latitude": "35.39137000",
                        "longitude": "-1.09238000"
                    },
                    {
                        "id": 31351,
                        "name": "Hammam Bou Hadjar",
                        "latitude": "35.37889000",
                        "longitude": "-0.96778000"
                    }
                ]
            },
            {
                "id": 1144,
                "name": "Algiers",
                "iso2": "16",
                "latitude": "36.69972940",
                "longitude": "3.05761990",
                "type": "province",
                "cities": [
                    {
                        "id": 31249,
                        "name": "Aïn Taya",
                        "latitude": "36.79333000",
                        "longitude": "3.28694000"
                    },
                    {
                        "id": 31230,
                        "name": "Algiers",
                        "latitude": "36.73225000",
                        "longitude": "3.08746000"
                    },
                    {
                        "id": 31254,
                        "name": "Bab Ezzouar",
                        "latitude": "36.72615000",
                        "longitude": "3.18291000"
                    },
                    {
                        "id": 31274,
                        "name": "Birkhadem",
                        "latitude": "36.71499000",
                        "longitude": "3.05002000"
                    },
                    {
                        "id": 31281,
                        "name": "Bordj el Kiffan",
                        "latitude": "36.74871000",
                        "longitude": "3.19249000"
                    },
                    {
                        "id": 31312,
                        "name": "Dar el Beïda",
                        "latitude": "36.71333000",
                        "longitude": "3.21250000"
                    },
                    {
                        "id": 31413,
                        "name": "Rouiba",
                        "latitude": "36.73829000",
                        "longitude": "3.28079000"
                    }
                ]
            },
            {
                "id": 1103,
                "name": "Annaba",
                "iso2": "23",
                "latitude": "36.80205080",
                "longitude": "7.52472430",
                "type": "province",
                "cities": [
                    {
                        "id": 31233,
                        "name": "Annaba",
                        "latitude": "36.90000000",
                        "longitude": "7.76667000"
                    },
                    {
                        "id": 31267,
                        "name": "Berrahal",
                        "latitude": "36.83528000",
                        "longitude": "7.45333000"
                    },
                    {
                        "id": 31323,
                        "name": "Drean",
                        "latitude": "36.68482000",
                        "longitude": "7.75111000"
                    },
                    {
                        "id": 31334,
                        "name": "El Hadjar",
                        "latitude": "36.80377000",
                        "longitude": "7.73684000"
                    }
                ]
            },
            {
                "id": 1142,
                "name": "Batna",
                "iso2": "05",
                "latitude": "35.59659540",
                "longitude": "5.89871390",
                "type": "province",
                "cities": [
                    {
                        "id": 31251,
                        "name": "Aïn Touta",
                        "latitude": "35.37675000",
                        "longitude": "5.90001000"
                    },
                    {
                        "id": 31237,
                        "name": "Arris",
                        "latitude": "35.25881000",
                        "longitude": "6.34706000"
                    },
                    {
                        "id": 31257,
                        "name": "Barika",
                        "latitude": "35.38901000",
                        "longitude": "5.36584000"
                    },
                    {
                        "id": 31258,
                        "name": "Batna",
                        "latitude": "35.55597000",
                        "longitude": "6.17414000"
                    },
                    {
                        "id": 31292,
                        "name": "Boumagueur",
                        "latitude": "35.50520000",
                        "longitude": "5.55250000"
                    },
                    {
                        "id": 31382,
                        "name": "Merouana",
                        "latitude": "35.63106000",
                        "longitude": "5.91186000"
                    },
                    {
                        "id": 31415,
                        "name": "Râs el Aïoun",
                        "latitude": "35.67384000",
                        "longitude": "5.64530000"
                    },
                    {
                        "id": 31444,
                        "name": "Tazoult-Lambese",
                        "latitude": "35.48171000",
                        "longitude": "6.26074000"
                    }
                ]
            },
            {
                "id": 1108,
                "name": "Béchar",
                "iso2": "08",
                "latitude": "31.62380980",
                "longitude": "-2.21624430",
                "type": "province",
                "cities": [
                    {
                        "id": 31298,
                        "name": "Béchar",
                        "latitude": "31.61667000",
                        "longitude": "-2.21667000"
                    }
                ]
            },
            {
                "id": 1128,
                "name": "Béjaïa",
                "iso2": "06",
                "latitude": "36.75152580",
                "longitude": "5.05568370",
                "type": "province",
                "cities": [
                    {
                        "id": 31229,
                        "name": "Akbou",
                        "latitude": "36.45750000",
                        "longitude": "4.53494000"
                    },
                    {
                        "id": 31231,
                        "name": "Amizour",
                        "latitude": "36.64022000",
                        "longitude": "4.90131000"
                    },
                    {
                        "id": 31256,
                        "name": "Barbacha",
                        "latitude": "36.56667000",
                        "longitude": "4.96667000"
                    },
                    {
                        "id": 31259,
                        "name": "Bejaïa",
                        "latitude": "36.75587000",
                        "longitude": "5.08433000"
                    },
                    {
                        "id": 31467,
                        "name": "el hed",
                        "latitude": "36.65000000",
                        "longitude": "4.77361000"
                    },
                    {
                        "id": 31339,
                        "name": "El Kseur",
                        "latitude": "36.67942000",
                        "longitude": "4.85550000"
                    },
                    {
                        "id": 31344,
                        "name": "Feraoun",
                        "latitude": "36.56041000",
                        "longitude": "4.85454000"
                    },
                    {
                        "id": 31421,
                        "name": "Seddouk",
                        "latitude": "36.54722000",
                        "longitude": "4.68611000"
                    }
                ]
            },
            {
                "id": 4909,
                "name": "Béni Abbès",
                "iso2": "53",
                "latitude": "30.08310420",
                "longitude": "-2.83450520",
                "type": "province",
                "cities": []
            },
            {
                "id": 1114,
                "name": "Biskra",
                "iso2": "07",
                "latitude": "34.84494370",
                "longitude": "5.72485670",
                "type": "province",
                "cities": [
                    {
                        "id": 31275,
                        "name": "Biskra",
                        "latitude": "34.85038000",
                        "longitude": "5.72805000"
                    },
                    {
                        "id": 31405,
                        "name": "Oumache",
                        "latitude": "34.69292000",
                        "longitude": "5.68092000"
                    },
                    {
                        "id": 31427,
                        "name": "Sidi Khaled",
                        "latitude": "34.38700000",
                        "longitude": "4.98785000"
                    },
                    {
                        "id": 31430,
                        "name": "Sidi Okba",
                        "latitude": "34.74512000",
                        "longitude": "5.89833000"
                    },
                    {
                        "id": 31461,
                        "name": "Tolga",
                        "latitude": "34.72224000",
                        "longitude": "5.37845000"
                    },
                    {
                        "id": 31466,
                        "name": "Zeribet el Oued",
                        "latitude": "34.68284000",
                        "longitude": "6.51109000"
                    }
                ]
            },
            {
                "id": 1111,
                "name": "Blida",
                "iso2": "09",
                "latitude": "36.53112300",
                "longitude": "2.89762540",
                "type": "province",
                "cities": [
                    {
                        "id": 31263,
                        "name": "Beni Mered",
                        "latitude": "36.52389000",
                        "longitude": "2.86131000"
                    },
                    {
                        "id": 31276,
                        "name": "Blida",
                        "latitude": "36.47004000",
                        "longitude": "2.82770000"
                    },
                    {
                        "id": 31296,
                        "name": "Boû Arfa",
                        "latitude": "36.46298000",
                        "longitude": "2.81464000"
                    },
                    {
                        "id": 31287,
                        "name": "Boufarik",
                        "latitude": "36.57413000",
                        "longitude": "2.91214000"
                    },
                    {
                        "id": 31289,
                        "name": "Bougara",
                        "latitude": "36.54178000",
                        "longitude": "3.08100000"
                    },
                    {
                        "id": 31290,
                        "name": "Bouinan",
                        "latitude": "36.53167000",
                        "longitude": "2.99194000"
                    },
                    {
                        "id": 31301,
                        "name": "Chebli",
                        "latitude": "36.57722000",
                        "longitude": "3.00917000"
                    },
                    {
                        "id": 31307,
                        "name": "Chiffa",
                        "latitude": "36.46293000",
                        "longitude": "2.73873000"
                    },
                    {
                        "id": 31369,
                        "name": "Larbaâ",
                        "latitude": "36.56471000",
                        "longitude": "3.15434000"
                    },
                    {
                        "id": 31377,
                        "name": "Meftah",
                        "latitude": "36.62040000",
                        "longitude": "3.22248000"
                    },
                    {
                        "id": 31428,
                        "name": "Sidi Moussa",
                        "latitude": "36.60637000",
                        "longitude": "3.08783000"
                    },
                    {
                        "id": 31438,
                        "name": "Souma",
                        "latitude": "36.51833000",
                        "longitude": "2.90528000"
                    }
                ]
            },
            {
                "id": 4908,
                "name": "Bordj Baji Mokhtar",
                "iso2": "52",
                "latitude": "22.96633500",
                "longitude": "-3.94727320",
                "type": "province",
                "cities": []
            },
            {
                "id": 1116,
                "name": "Bordj Bou Arréridj",
                "iso2": "34",
                "latitude": "36.07399250",
                "longitude": "4.76302710",
                "type": "province",
                "cities": [
                    {
                        "id": 31278,
                        "name": "Bordj Bou Arreridj",
                        "latitude": "36.07321000",
                        "longitude": "4.76108000"
                    },
                    {
                        "id": 31279,
                        "name": "Bordj Ghdir",
                        "latitude": "35.90111000",
                        "longitude": "4.89806000"
                    },
                    {
                        "id": 31280,
                        "name": "Bordj Zemoura",
                        "latitude": "36.27462000",
                        "longitude": "4.85668000"
                    },
                    {
                        "id": 31327,
                        "name": "El Achir",
                        "latitude": "36.06386000",
                        "longitude": "4.62744000"
                    },
                    {
                        "id": 31373,
                        "name": "Mansourah",
                        "latitude": "36.08725000",
                        "longitude": "4.45192000"
                    },
                    {
                        "id": 31381,
                        "name": "Melouza",
                        "latitude": "35.97999000",
                        "longitude": "4.18665000"
                    },
                    {
                        "id": 31416,
                        "name": "Râs el Oued",
                        "latitude": "35.94410000",
                        "longitude": "5.03107000"
                    }
                ]
            },
            {
                "id": 1104,
                "name": "Bouïra",
                "iso2": "10",
                "latitude": "36.36918460",
                "longitude": "3.90061940",
                "type": "province",
                "cities": [
                    {
                        "id": 31241,
                        "name": "Aïn Bessem",
                        "latitude": "36.29333000",
                        "longitude": "3.67319000"
                    },
                    {
                        "id": 31295,
                        "name": "Bouïra",
                        "latitude": "36.37489000",
                        "longitude": "3.90200000"
                    },
                    {
                        "id": 31309,
                        "name": "Chorfa",
                        "latitude": "36.36505000",
                        "longitude": "4.32636000"
                    },
                    {
                        "id": 31322,
                        "name": "Draa el Mizan",
                        "latitude": "36.53628000",
                        "longitude": "3.83340000"
                    },
                    {
                        "id": 31368,
                        "name": "Lakhdaria",
                        "latitude": "36.56463000",
                        "longitude": "3.59330000"
                    },
                    {
                        "id": 31439,
                        "name": "Sour el Ghozlane",
                        "latitude": "36.14766000",
                        "longitude": "3.69123000"
                    }
                ]
            },
            {
                "id": 1125,
                "name": "Boumerdès",
                "iso2": "35",
                "latitude": "36.68395590",
                "longitude": "3.62178020",
                "type": "province",
                "cities": [
                    {
                        "id": 31235,
                        "name": "Arbatache",
                        "latitude": "36.63773000",
                        "longitude": "3.37127000"
                    },
                    {
                        "id": 31261,
                        "name": "Beni Amrane",
                        "latitude": "36.66774000",
                        "longitude": "3.59115000"
                    },
                    {
                        "id": 31286,
                        "name": "Boudouaou",
                        "latitude": "36.72735000",
                        "longitude": "3.40995000"
                    },
                    {
                        "id": 31294,
                        "name": "Boumerdas",
                        "latitude": "36.76639000",
                        "longitude": "3.47717000"
                    },
                    {
                        "id": 31299,
                        "name": "Chabet el Ameur",
                        "latitude": "36.63709000",
                        "longitude": "3.69474000"
                    },
                    {
                        "id": 31314,
                        "name": "Dellys",
                        "latitude": "36.91716000",
                        "longitude": "3.91311000"
                    },
                    {
                        "id": 31362,
                        "name": "Khemis el Khechna",
                        "latitude": "36.64997000",
                        "longitude": "3.33080000"
                    },
                    {
                        "id": 31372,
                        "name": "Makouda",
                        "latitude": "36.78567000",
                        "longitude": "4.06273000"
                    },
                    {
                        "id": 31393,
                        "name": "Naciria",
                        "latitude": "36.74625000",
                        "longitude": "3.83163000"
                    },
                    {
                        "id": 31403,
                        "name": "Ouled Moussa",
                        "latitude": "36.68394000",
                        "longitude": "3.36661000"
                    },
                    {
                        "id": 31407,
                        "name": "Reghaïa",
                        "latitude": "36.73587000",
                        "longitude": "3.34018000"
                    },
                    {
                        "id": 31441,
                        "name": "Tadmaït",
                        "latitude": "36.74413000",
                        "longitude": "3.90045000"
                    },
                    {
                        "id": 31447,
                        "name": "Thenia",
                        "latitude": "36.72544000",
                        "longitude": "3.55665000"
                    },
                    {
                        "id": 31456,
                        "name": "Tizi Gheniff",
                        "latitude": "36.58839000",
                        "longitude": "3.77445000"
                    }
                ]
            },
            {
                "id": 1105,
                "name": "Chlef",
                "iso2": "02",
                "latitude": "36.16935150",
                "longitude": "1.28910360",
                "type": "province",
                "cities": [
                    {
                        "id": 31226,
                        "name": "Abou el Hassan",
                        "latitude": "36.41657000",
                        "longitude": "1.19616000"
                    },
                    {
                        "id": 31291,
                        "name": "Boukadir",
                        "latitude": "36.06629000",
                        "longitude": "1.12602000"
                    },
                    {
                        "id": 31308,
                        "name": "Chlef",
                        "latitude": "36.16525000",
                        "longitude": "1.33452000"
                    },
                    {
                        "id": 31324,
                        "name": "Ech Chettia",
                        "latitude": "36.19591000",
                        "longitude": "1.25537000"
                    },
                    {
                        "id": 31397,
                        "name": "Oued Fodda",
                        "latitude": "36.18503000",
                        "longitude": "1.53299000"
                    },
                    {
                        "id": 31399,
                        "name": "Oued Sly",
                        "latitude": "36.10124000",
                        "longitude": "1.19949000"
                    },
                    {
                        "id": 31424,
                        "name": "Sidi Akkacha",
                        "latitude": "36.46472000",
                        "longitude": "1.30258000"
                    }
                ]
            },
            {
                "id": 1121,
                "name": "Constantine",
                "iso2": "25",
                "latitude": "36.33739110",
                "longitude": "6.66381200",
                "type": "province",
                "cities": [
                    {
                        "id": 31469,
                        "name": "’Aïn Abid",
                        "latitude": "36.23194000",
                        "longitude": "6.94333000"
                    },
                    {
                        "id": 31248,
                        "name": "Aïn Smara",
                        "latitude": "36.26740000",
                        "longitude": "6.50135000"
                    },
                    {
                        "id": 31310,
                        "name": "Constantine",
                        "latitude": "36.36500000",
                        "longitude": "6.61472000"
                    },
                    {
                        "id": 31315,
                        "name": "Didouche Mourad",
                        "latitude": "36.45250000",
                        "longitude": "6.63639000"
                    },
                    {
                        "id": 31338,
                        "name": "El Khroub",
                        "latitude": "36.26333000",
                        "longitude": "6.69361000"
                    },
                    {
                        "id": 31350,
                        "name": "Hamma Bouziane",
                        "latitude": "36.41205000",
                        "longitude": "6.59603000"
                    }
                ]
            },
            {
                "id": 4912,
                "name": "Djanet",
                "iso2": "56",
                "latitude": "23.83108720",
                "longitude": "8.70046720",
                "type": "province",
                "cities": []
            },
            {
                "id": 1098,
                "name": "Djelfa",
                "iso2": "17",
                "latitude": "34.67039560",
                "longitude": "3.25037610",
                "type": "province",
                "cities": [
                    {
                        "id": 31474,
                        "name": "’Aïn el Bell",
                        "latitude": "34.34381000",
                        "longitude": "3.22475000"
                    },
                    {
                        "id": 31246,
                        "name": "Aïn Oussera",
                        "latitude": "35.45139000",
                        "longitude": "2.90583000"
                    },
                    {
                        "id": 31273,
                        "name": "Birine",
                        "latitude": "35.63500000",
                        "longitude": "3.22500000"
                    },
                    {
                        "id": 31300,
                        "name": "Charef",
                        "latitude": "34.62098000",
                        "longitude": "2.79503000"
                    },
                    {
                        "id": 31311,
                        "name": "Dar Chioukh",
                        "latitude": "34.89638000",
                        "longitude": "3.48543000"
                    },
                    {
                        "id": 31318,
                        "name": "Djelfa",
                        "latitude": "34.67279000",
                        "longitude": "3.26300000"
                    },
                    {
                        "id": 31336,
                        "name": "El Idrissia",
                        "latitude": "34.44542000",
                        "longitude": "2.52749000"
                    },
                    {
                        "id": 31385,
                        "name": "Messaad",
                        "latitude": "34.15429000",
                        "longitude": "3.50309000"
                    }
                ]
            },
            {
                "id": 1129,
                "name": "El Bayadh",
                "iso2": "32",
                "latitude": "32.71488240",
                "longitude": "0.90566230",
                "type": "province",
                "cities": [
                    {
                        "id": 31297,
                        "name": "Brezina",
                        "latitude": "33.09892000",
                        "longitude": "1.26082000"
                    },
                    {
                        "id": 31326,
                        "name": "El Abiodh Sidi Cheikh",
                        "latitude": "32.89300000",
                        "longitude": "0.54839000"
                    },
                    {
                        "id": 31332,
                        "name": "El Bayadh",
                        "latitude": "33.68318000",
                        "longitude": "1.01927000"
                    }
                ]
            },
            {
                "id": 4905,
                "name": "El M'ghair",
                "iso2": "49",
                "latitude": "33.95405610",
                "longitude": "5.13464180",
                "type": "province",
                "cities": []
            },
            {
                "id": 4906,
                "name": "El Menia",
                "iso2": "50",
                "latitude": "31.36422500",
                "longitude": "2.57844950",
                "type": "province",
                "cities": []
            },
            {
                "id": 1099,
                "name": "El Oued",
                "iso2": "39",
                "latitude": "33.36781100",
                "longitude": "6.85165110",
                "type": "province",
                "cities": [
                    {
                        "id": 31313,
                        "name": "Debila",
                        "latitude": "33.51667000",
                        "longitude": "6.95000000"
                    },
                    {
                        "id": 31341,
                        "name": "El Oued",
                        "latitude": "33.35608000",
                        "longitude": "6.86319000"
                    },
                    {
                        "id": 31408,
                        "name": "Reguiba",
                        "latitude": "33.56391000",
                        "longitude": "6.70326000"
                    },
                    {
                        "id": 31411,
                        "name": "Robbah",
                        "latitude": "33.27967000",
                        "longitude": "6.90984000"
                    }
                ]
            },
            {
                "id": 1100,
                "name": "El Tarf",
                "iso2": "36",
                "latitude": "36.75766780",
                "longitude": "8.30763430",
                "type": "province",
                "cities": [
                    {
                        "id": 31260,
                        "name": "Ben Mehidi",
                        "latitude": "36.76967000",
                        "longitude": "7.90641000"
                    },
                    {
                        "id": 31270,
                        "name": "Besbes",
                        "latitude": "36.70222000",
                        "longitude": "7.84722000"
                    },
                    {
                        "id": 31337,
                        "name": "El Kala",
                        "latitude": "36.89556000",
                        "longitude": "8.44333000"
                    },
                    {
                        "id": 31342,
                        "name": "El Tarf",
                        "latitude": "36.76720000",
                        "longitude": "8.31377000"
                    }
                ]
            },
            {
                "id": 1127,
                "name": "Ghardaïa",
                "iso2": "47",
                "latitude": "32.49437410",
                "longitude": "3.64446000",
                "type": "province",
                "cities": [
                    {
                        "id": 31268,
                        "name": "Berriane",
                        "latitude": "32.82648000",
                        "longitude": "3.76689000"
                    },
                    {
                        "id": 31347,
                        "name": "Ghardaïa",
                        "latitude": "32.49094000",
                        "longitude": "3.67347000"
                    },
                    {
                        "id": 31386,
                        "name": "Metlili Chaamba",
                        "latitude": "32.26667000",
                        "longitude": "3.63333000"
                    }
                ]
            },
            {
                "id": 1137,
                "name": "Guelma",
                "iso2": "24",
                "latitude": "36.46274440",
                "longitude": "7.43308330",
                "type": "province",
                "cities": [
                    {
                        "id": 31293,
                        "name": "Boumahra Ahmed",
                        "latitude": "36.45833000",
                        "longitude": "7.51389000"
                    },
                    {
                        "id": 31348,
                        "name": "Guelma",
                        "latitude": "36.46214000",
                        "longitude": "7.42608000"
                    },
                    {
                        "id": 31355,
                        "name": "Héliopolis",
                        "latitude": "36.50361000",
                        "longitude": "7.44278000"
                    }
                ]
            },
            {
                "id": 1112,
                "name": "Illizi",
                "iso2": "33",
                "latitude": "26.16900050",
                "longitude": "8.48424650",
                "type": "province",
                "cities": [
                    {
                        "id": 31358,
                        "name": "Illizi",
                        "latitude": "26.48333000",
                        "longitude": "8.46667000"
                    }
                ]
            },
            {
                "id": 4914,
                "name": "In Guezzam",
                "iso2": "58",
                "latitude": "20.38643230",
                "longitude": "4.77893940",
                "type": "province",
                "cities": []
            },
            {
                "id": 4913,
                "name": "In Salah",
                "iso2": "57",
                "latitude": "27.21492290",
                "longitude": "1.84843960",
                "type": "province",
                "cities": []
            },
            {
                "id": 1113,
                "name": "Jijel",
                "iso2": "18",
                "latitude": "36.71796810",
                "longitude": "5.98325770",
                "type": "province",
                "cities": [
                    {
                        "id": 31359,
                        "name": "Jijel",
                        "latitude": "36.82055000",
                        "longitude": "5.76671000"
                    }
                ]
            },
            {
                "id": 1126,
                "name": "Khenchela",
                "iso2": "40",
                "latitude": "35.42694040",
                "longitude": "7.14601550",
                "type": "province",
                "cities": [
                    {
                        "id": 31363,
                        "name": "Khenchela",
                        "latitude": "35.43583000",
                        "longitude": "7.14333000"
                    }
                ]
            },
            {
                "id": 1138,
                "name": "Laghouat",
                "iso2": "03",
                "latitude": "33.80783410",
                "longitude": "2.86282940",
                "type": "province",
                "cities": [
                    {
                        "id": 31228,
                        "name": "Aflou",
                        "latitude": "34.11279000",
                        "longitude": "2.10228000"
                    },
                    {
                        "id": 31367,
                        "name": "Laghouat",
                        "latitude": "33.80000000",
                        "longitude": "2.86514000"
                    }
                ]
            },
            {
                "id": 1134,
                "name": "M'Sila",
                "iso2": "28",
                "latitude": "35.71866460",
                "longitude": "4.52334230",
                "type": "province",
                "cities": [
                    {
                        "id": 31468,
                        "name": "‘Aïn el Hadjel",
                        "latitude": "35.67003000",
                        "longitude": "3.88153000"
                    },
                    {
                        "id": 31477,
                        "name": "’Aïn el Melh",
                        "latitude": "34.84146000",
                        "longitude": "4.16383000"
                    },
                    {
                        "id": 31391,
                        "name": "M’Sila",
                        "latitude": "35.70583000",
                        "longitude": "4.54194000"
                    },
                    {
                        "id": 31426,
                        "name": "Sidi Aïssa",
                        "latitude": "35.88548000",
                        "longitude": "3.77236000"
                    }
                ]
            },
            {
                "id": 1124,
                "name": "Mascara",
                "iso2": "29",
                "latitude": "35.39041250",
                "longitude": "0.14949880",
                "type": "province",
                "cities": [
                    {
                        "id": 31282,
                        "name": "Bou Hanifia el Hamamat",
                        "latitude": "35.31473000",
                        "longitude": "-0.05037000"
                    },
                    {
                        "id": 31375,
                        "name": "Mascara",
                        "latitude": "35.39664000",
                        "longitude": "0.14027000"
                    },
                    {
                        "id": 31400,
                        "name": "Oued el Abtal",
                        "latitude": "35.45595000",
                        "longitude": "0.68778000"
                    },
                    {
                        "id": 31433,
                        "name": "Sig",
                        "latitude": "35.52832000",
                        "longitude": "-0.19369000"
                    }
                ]
            },
            {
                "id": 1109,
                "name": "Médéa",
                "iso2": "26",
                "latitude": "36.26370780",
                "longitude": "2.75878570",
                "type": "province",
                "cities": [
                    {
                        "id": 31471,
                        "name": "’Aïn Boucif",
                        "latitude": "35.89123000",
                        "longitude": "3.15850000"
                    },
                    {
                        "id": 31269,
                        "name": "Berrouaghia",
                        "latitude": "36.13516000",
                        "longitude": "2.91085000"
                    },
                    {
                        "id": 31366,
                        "name": "Ksar el Boukhari",
                        "latitude": "35.88889000",
                        "longitude": "2.74905000"
                    },
                    {
                        "id": 31390,
                        "name": "Médéa",
                        "latitude": "36.26417000",
                        "longitude": "2.75393000"
                    }
                ]
            },
            {
                "id": 1132,
                "name": "Mila",
                "iso2": "43",
                "latitude": "36.36479570",
                "longitude": "6.15269850",
                "type": "province",
                "cities": [
                    {
                        "id": 31302,
                        "name": "Chelghoum el Aïd",
                        "latitude": "36.16286000",
                        "longitude": "6.16651000"
                    },
                    {
                        "id": 31387,
                        "name": "Mila",
                        "latitude": "36.45028000",
                        "longitude": "6.26444000"
                    },
                    {
                        "id": 31412,
                        "name": "Rouached",
                        "latitude": "36.45774000",
                        "longitude": "6.04267000"
                    },
                    {
                        "id": 31429,
                        "name": "Sidi Mérouane",
                        "latitude": "36.52056000",
                        "longitude": "6.26111000"
                    },
                    {
                        "id": 31446,
                        "name": "Telerghma",
                        "latitude": "36.11653000",
                        "longitude": "6.35434000"
                    }
                ]
            },
            {
                "id": 1140,
                "name": "Mostaganem",
                "iso2": "27",
                "latitude": "35.95830540",
                "longitude": "0.33718890",
                "type": "province",
                "cities": [
                    {
                        "id": 31388,
                        "name": "Mostaganem",
                        "latitude": "35.93115000",
                        "longitude": "0.08918000"
                    }
                ]
            },
            {
                "id": 1102,
                "name": "Naama",
                "iso2": "45",
                "latitude": "33.26673170",
                "longitude": "-0.31286590",
                "type": "province",
                "cities": [
                    {
                        "id": 31247,
                        "name": "Aïn Sefra",
                        "latitude": "32.75000000",
                        "longitude": "-0.58333000"
                    },
                    {
                        "id": 31392,
                        "name": "Naama",
                        "latitude": "33.26667000",
                        "longitude": "-0.31667000"
                    }
                ]
            },
            {
                "id": 1101,
                "name": "Oran",
                "iso2": "31",
                "latitude": "35.60823510",
                "longitude": "-0.56360900",
                "type": "province",
                "cities": [
                    {
                        "id": 31478,
                        "name": "’Aïn el Turk",
                        "latitude": "35.74381000",
                        "longitude": "-0.76930000"
                    },
                    {
                        "id": 31252,
                        "name": "Aïn el Bya",
                        "latitude": "35.80389000",
                        "longitude": "-0.30178000"
                    },
                    {
                        "id": 31272,
                        "name": "Bir el Djir",
                        "latitude": "35.72000000",
                        "longitude": "-0.54500000"
                    },
                    {
                        "id": 31284,
                        "name": "Bou Tlelis",
                        "latitude": "35.57272000",
                        "longitude": "-0.89960000"
                    },
                    {
                        "id": 31343,
                        "name": "Es Senia",
                        "latitude": "35.64779000",
                        "longitude": "-0.62397000"
                    },
                    {
                        "id": 31383,
                        "name": "Mers el Kebir",
                        "latitude": "35.72790000",
                        "longitude": "-0.70810000"
                    },
                    {
                        "id": 31395,
                        "name": "Oran",
                        "latitude": "35.69906000",
                        "longitude": "-0.63588000"
                    },
                    {
                        "id": 31432,
                        "name": "Sidi ech Chahmi",
                        "latitude": "35.65903000",
                        "longitude": "-0.52168000"
                    }
                ]
            },
            {
                "id": 1139,
                "name": "Ouargla",
                "iso2": "30",
                "latitude": "32.22648630",
                "longitude": "5.72998210",
                "type": "province",
                "cities": [
                    {
                        "id": 31316,
                        "name": "Djamaa",
                        "latitude": "33.53388000",
                        "longitude": "5.99306000"
                    },
                    {
                        "id": 31335,
                        "name": "El Hadjira",
                        "latitude": "32.61336000",
                        "longitude": "5.51259000"
                    },
                    {
                        "id": 31353,
                        "name": "Hassi Messaoud",
                        "latitude": "31.68041000",
                        "longitude": "6.07286000"
                    },
                    {
                        "id": 31378,
                        "name": "Megarine",
                        "latitude": "33.19195000",
                        "longitude": "6.08695000"
                    },
                    {
                        "id": 31396,
                        "name": "Ouargla",
                        "latitude": "31.94932000",
                        "longitude": "5.32502000"
                    },
                    {
                        "id": 31414,
                        "name": "Rouissat",
                        "latitude": "31.92427000",
                        "longitude": "5.35018000"
                    },
                    {
                        "id": 31425,
                        "name": "Sidi Amrane",
                        "latitude": "33.49885000",
                        "longitude": "6.00803000"
                    },
                    {
                        "id": 31445,
                        "name": "Tebesbest",
                        "latitude": "33.11667000",
                        "longitude": "6.08333000"
                    },
                    {
                        "id": 31462,
                        "name": "Touggourt",
                        "latitude": "33.10527000",
                        "longitude": "6.05796000"
                    }
                ]
            },
            {
                "id": 4907,
                "name": "Ouled Djellal",
                "iso2": "51",
                "latitude": "34.41782210",
                "longitude": "4.96858430",
                "type": "province",
                "cities": []
            },
            {
                "id": 1136,
                "name": "Oum El Bouaghi",
                "iso2": "04",
                "latitude": "35.86887890",
                "longitude": "7.11082660",
                "type": "province",
                "cities": [
                    {
                        "id": 31242,
                        "name": "Aïn Beïda",
                        "latitude": "35.79639000",
                        "longitude": "7.39278000"
                    },
                    {
                        "id": 31244,
                        "name": "Aïn Fakroun",
                        "latitude": "35.97108000",
                        "longitude": "6.87374000"
                    },
                    {
                        "id": 31245,
                        "name": "Aïn Kercha",
                        "latitude": "35.92472000",
                        "longitude": "6.69528000"
                    },
                    {
                        "id": 31330,
                        "name": "El Aouinet",
                        "latitude": "35.86691000",
                        "longitude": "7.88673000"
                    },
                    {
                        "id": 31384,
                        "name": "Meskiana",
                        "latitude": "35.63058000",
                        "longitude": "7.66606000"
                    },
                    {
                        "id": 31404,
                        "name": "Oum el Bouaghi",
                        "latitude": "35.87541000",
                        "longitude": "7.11353000"
                    }
                ]
            },
            {
                "id": 1130,
                "name": "Relizane",
                "iso2": "48",
                "latitude": "35.73834050",
                "longitude": "0.75328090",
                "type": "province",
                "cities": [
                    {
                        "id": 31473,
                        "name": "’Aïn Merane",
                        "latitude": "36.16277000",
                        "longitude": "0.97037000"
                    },
                    {
                        "id": 31232,
                        "name": "Ammi Moussa",
                        "latitude": "35.86781000",
                        "longitude": "1.11143000"
                    },
                    {
                        "id": 31319,
                        "name": "Djidiouia",
                        "latitude": "35.92989000",
                        "longitude": "0.82871000"
                    },
                    {
                        "id": 31376,
                        "name": "Mazouna",
                        "latitude": "36.12232000",
                        "longitude": "0.89865000"
                    },
                    {
                        "id": 31398,
                        "name": "Oued Rhiou",
                        "latitude": "35.96124000",
                        "longitude": "0.91896000"
                    },
                    {
                        "id": 31409,
                        "name": "Relizane",
                        "latitude": "35.73734000",
                        "longitude": "0.55599000"
                    },
                    {
                        "id": 31435,
                        "name": "Smala",
                        "latitude": "35.71652000",
                        "longitude": "0.75437000"
                    },
                    {
                        "id": 31464,
                        "name": "Zemoura",
                        "latitude": "35.72251000",
                        "longitude": "0.75509000"
                    }
                ]
            },
            {
                "id": 1123,
                "name": "Saïda",
                "iso2": "20",
                "latitude": "34.84152070",
                "longitude": "0.14560550",
                "type": "province",
                "cities": [
                    {
                        "id": 31475,
                        "name": "’Aïn el Hadjar",
                        "latitude": "34.75846000",
                        "longitude": "0.14528000"
                    },
                    {
                        "id": 31419,
                        "name": "Saïda",
                        "latitude": "34.83033000",
                        "longitude": "0.15171000"
                    }
                ]
            },
            {
                "id": 1141,
                "name": "Sétif",
                "iso2": "19",
                "latitude": "36.30733890",
                "longitude": "5.56172790",
                "type": "province",
                "cities": [
                    {
                        "id": 31240,
                        "name": "Aïn Arnat",
                        "latitude": "36.18683000",
                        "longitude": "5.31347000"
                    },
                    {
                        "id": 31253,
                        "name": "BABOR - VILLE",
                        "latitude": "36.48994000",
                        "longitude": "5.53930000"
                    },
                    {
                        "id": 31288,
                        "name": "Bougaa",
                        "latitude": "36.33293000",
                        "longitude": "5.08843000"
                    },
                    {
                        "id": 31333,
                        "name": "El Eulma",
                        "latitude": "36.15281000",
                        "longitude": "5.69016000"
                    },
                    {
                        "id": 31417,
                        "name": "Salah Bey",
                        "latitude": "35.85451000",
                        "longitude": "5.29053000"
                    },
                    {
                        "id": 31440,
                        "name": "Sétif",
                        "latitude": "36.19112000",
                        "longitude": "5.41373000"
                    }
                ]
            },
            {
                "id": 4902,
                "name": "Sidi Bel Abbès",
                "iso2": "22",
                "latitude": "34.68060240",
                "longitude": "-1.09994950",
                "type": "province",
                "cities": [
                    {
                        "id": 146185,
                        "name": "Aïn El Berd District",
                        "latitude": "35.35000000",
                        "longitude": "-0.51667000"
                    },
                    {
                        "id": 146186,
                        "name": "Balidat Ameur",
                        "latitude": "32.95138900",
                        "longitude": "5.98055600"
                    },
                    {
                        "id": 146187,
                        "name": "Belarbi",
                        "latitude": "35.15149480",
                        "longitude": "-0.45679090"
                    },
                    {
                        "id": 146188,
                        "name": "Ben Badis Sid Bel Abbés",
                        "latitude": "34.95277778",
                        "longitude": "-0.91444444"
                    },
                    {
                        "id": 146189,
                        "name": "Djamaa",
                        "latitude": "33.53137870",
                        "longitude": "5.99098210"
                    },
                    {
                        "id": 146190,
                        "name": "El Bour",
                        "latitude": "32.16305556",
                        "longitude": "5.34527778"
                    },
                    {
                        "id": 146191,
                        "name": "El Hadjira",
                        "latitude": "32.61666667",
                        "longitude": "5.51666667"
                    },
                    {
                        "id": 146192,
                        "name": "Haoud El Hamra",
                        "latitude": "31.88944444",
                        "longitude": "5.97305556"
                    },
                    {
                        "id": 146193,
                        "name": "Hassi Messaoud",
                        "latitude": "31.70000000",
                        "longitude": "6.06666667"
                    },
                    {
                        "id": 146194,
                        "name": "Lamtar",
                        "latitude": "35.07062700",
                        "longitude": "-0.79814000"
                    },
                    {
                        "id": 146195,
                        "name": "Marhoum",
                        "latitude": "34.44600420",
                        "longitude": "-0.19502440"
                    },
                    {
                        "id": 146196,
                        "name": "Megarine",
                        "latitude": "33.19262320",
                        "longitude": "6.09346390"
                    },
                    {
                        "id": 146197,
                        "name": "Merine",
                        "latitude": "34.78074720",
                        "longitude": "-0.45104030"
                    },
                    {
                        "id": 146198,
                        "name": "Mezaourou",
                        "latitude": "34.81732670",
                        "longitude": "-0.62331890"
                    },
                    {
                        "id": 146199,
                        "name": "Moggar",
                        "latitude": "33.26722222",
                        "longitude": "6.06777778"
                    },
                    {
                        "id": 146200,
                        "name": "Moulay Slissen",
                        "latitude": "34.81666667",
                        "longitude": "-0.76666667"
                    },
                    {
                        "id": 146201,
                        "name": "N'Goussa",
                        "latitude": "32.14087970",
                        "longitude": "5.30828480"
                    },
                    {
                        "id": 146202,
                        "name": "Ouargla",
                        "latitude": "31.95000000",
                        "longitude": "5.31666667"
                    },
                    {
                        "id": 146203,
                        "name": "Rouissat",
                        "latitude": "31.93657600",
                        "longitude": "5.33540730"
                    },
                    {
                        "id": 146204,
                        "name": "Sfissef",
                        "latitude": "35.23440280",
                        "longitude": "-0.24341580"
                    },
                    {
                        "id": 146205,
                        "name": "Sidi Ali Boussidi",
                        "latitude": "35.10000000",
                        "longitude": "-0.83333333"
                    },
                    {
                        "id": 146206,
                        "name": "Sidi Amrane",
                        "latitude": "33.50000000",
                        "longitude": "6.01666667"
                    },
                    {
                        "id": 146207,
                        "name": "Sidi Bel Abbès",
                        "latitude": "35.20000000",
                        "longitude": "-0.63333333"
                    },
                    {
                        "id": 146208,
                        "name": "Sidi Brahim",
                        "latitude": "35.26055600",
                        "longitude": "-0.56750000"
                    },
                    {
                        "id": 146209,
                        "name": "Sidi Hamadouche",
                        "latitude": "35.29916667",
                        "longitude": "-0.54888889"
                    },
                    {
                        "id": 146210,
                        "name": "Sidi Slimane",
                        "latitude": "33.28861111",
                        "longitude": "6.09472222"
                    },
                    {
                        "id": 146211,
                        "name": "Sidi Yacoub",
                        "latitude": "35.13333333",
                        "longitude": "-0.78333333"
                    },
                    {
                        "id": 146212,
                        "name": "Sidi Yahia",
                        "latitude": "33.52166667",
                        "longitude": "5.94555556"
                    },
                    {
                        "id": 146213,
                        "name": "Tabia Sid Bel Abbés",
                        "latitude": "35.01783660",
                        "longitude": "-0.73385240"
                    },
                    {
                        "id": 146214,
                        "name": "Taibet",
                        "latitude": "33.08391890",
                        "longitude": "6.39996530"
                    },
                    {
                        "id": 146215,
                        "name": "Tamellaht",
                        "latitude": "33.01190000",
                        "longitude": "6.00972000"
                    },
                    {
                        "id": 146216,
                        "name": "Tamerna Djedida",
                        "latitude": "33.44640000",
                        "longitude": "5.95639000"
                    },
                    {
                        "id": 146217,
                        "name": "Tebesbest",
                        "latitude": "33.12001290",
                        "longitude": "6.08007430"
                    },
                    {
                        "id": 146218,
                        "name": "Teghalimet",
                        "latitude": "34.88283300",
                        "longitude": "-0.56000230"
                    },
                    {
                        "id": 146219,
                        "name": "Telagh",
                        "latitude": "34.78490640",
                        "longitude": "-0.57317730"
                    },
                    {
                        "id": 146220,
                        "name": "Tenezara",
                        "latitude": "34.96341170",
                        "longitude": "-0.61446190"
                    },
                    {
                        "id": 146221,
                        "name": "Tenira",
                        "latitude": "35.01966420",
                        "longitude": "-0.53206440"
                    },
                    {
                        "id": 146222,
                        "name": "Tessala",
                        "latitude": "35.24300000",
                        "longitude": "-0.77316300"
                    },
                    {
                        "id": 146223,
                        "name": "Touggourt",
                        "latitude": "33.10000000",
                        "longitude": "6.06666667"
                    },
                    {
                        "id": 146224,
                        "name": "Zerouala",
                        "latitude": "35.24232450",
                        "longitude": "-0.52219390"
                    }
                ]
            },
            {
                "id": 1110,
                "name": "Skikda",
                "iso2": "21",
                "latitude": "36.67211980",
                "longitude": "6.83509990",
                "type": "province",
                "cities": [
                    {
                        "id": 31239,
                        "name": "Azzaba",
                        "latitude": "36.73944000",
                        "longitude": "7.10528000"
                    },
                    {
                        "id": 31360,
                        "name": "Karkira",
                        "latitude": "36.92917000",
                        "longitude": "6.58556000"
                    },
                    {
                        "id": 31434,
                        "name": "Skikda",
                        "latitude": "36.87617000",
                        "longitude": "6.90921000"
                    },
                    {
                        "id": 31442,
                        "name": "Tamalous",
                        "latitude": "36.83763000",
                        "longitude": "6.64018000"
                    }
                ]
            },
            {
                "id": 1143,
                "name": "Souk Ahras",
                "iso2": "41",
                "latitude": "36.28010620",
                "longitude": "7.93840330",
                "type": "province",
                "cities": [
                    {
                        "id": 31422,
                        "name": "Sedrata",
                        "latitude": "36.12868000",
                        "longitude": "7.53376000"
                    },
                    {
                        "id": 31437,
                        "name": "Souk Ahras",
                        "latitude": "36.28639000",
                        "longitude": "7.95111000"
                    }
                ]
            },
            {
                "id": 1135,
                "name": "Tamanghasset",
                "iso2": "11",
                "latitude": "22.79029720",
                "longitude": "5.51932680",
                "type": "province",
                "cities": [
                    {
                        "id": 31356,
                        "name": "I-n-Salah",
                        "latitude": "27.19351000",
                        "longitude": "2.46069000"
                    },
                    {
                        "id": 31443,
                        "name": "Tamanrasset",
                        "latitude": "22.78500000",
                        "longitude": "5.52278000"
                    }
                ]
            },
            {
                "id": 1117,
                "name": "Tébessa",
                "iso2": "12",
                "latitude": "35.12906910",
                "longitude": "7.95928630",
                "type": "province",
                "cities": [
                    {
                        "id": 31271,
                        "name": "Bir el Ater",
                        "latitude": "34.74488000",
                        "longitude": "8.06024000"
                    },
                    {
                        "id": 31305,
                        "name": "Cheria",
                        "latitude": "35.27306000",
                        "longitude": "7.75194000"
                    },
                    {
                        "id": 31352,
                        "name": "Hammamet",
                        "latitude": "35.44862000",
                        "longitude": "7.95184000"
                    },
                    {
                        "id": 31463,
                        "name": "Tébessa",
                        "latitude": "35.40417000",
                        "longitude": "8.12417000"
                    }
                ]
            },
            {
                "id": 1106,
                "name": "Tiaret",
                "iso2": "14",
                "latitude": "35.37086890",
                "longitude": "1.32178520",
                "type": "province",
                "cities": [
                    {
                        "id": 31472,
                        "name": "’Aïn Deheb",
                        "latitude": "34.84218000",
                        "longitude": "1.54697000"
                    },
                    {
                        "id": 31317,
                        "name": "Djebilet Rosfa",
                        "latitude": "34.86375000",
                        "longitude": "0.83496000"
                    },
                    {
                        "id": 31346,
                        "name": "Frenda",
                        "latitude": "35.06544000",
                        "longitude": "1.04945000"
                    },
                    {
                        "id": 31365,
                        "name": "Ksar Chellala",
                        "latitude": "35.21222000",
                        "longitude": "2.31889000"
                    },
                    {
                        "id": 31379,
                        "name": "Mehdia daira de meghila",
                        "latitude": "35.43058000",
                        "longitude": "1.75714000"
                    },
                    {
                        "id": 31436,
                        "name": "Sougueur",
                        "latitude": "35.18568000",
                        "longitude": "1.49612000"
                    },
                    {
                        "id": 31449,
                        "name": "Tiaret",
                        "latitude": "35.37103000",
                        "longitude": "1.31699000"
                    }
                ]
            },
            {
                "id": 4910,
                "name": "Timimoun",
                "iso2": "54",
                "latitude": "29.67890600",
                "longitude": "0.50046080",
                "type": "province",
                "cities": []
            },
            {
                "id": 1120,
                "name": "Tindouf",
                "iso2": "37",
                "latitude": "27.80631190",
                "longitude": "-5.72998210",
                "type": "province",
                "cities": [
                    {
                        "id": 31452,
                        "name": "Tindouf",
                        "latitude": "27.67111000",
                        "longitude": "-8.14743000"
                    }
                ]
            },
            {
                "id": 1115,
                "name": "Tipasa",
                "iso2": "42",
                "latitude": "36.54626500",
                "longitude": "2.18432850",
                "type": "province",
                "cities": [
                    {
                        "id": 31470,
                        "name": "’Aïn Benian",
                        "latitude": "36.80277000",
                        "longitude": "2.92185000"
                    },
                    {
                        "id": 31255,
                        "name": "Baraki",
                        "latitude": "36.66655000",
                        "longitude": "3.09606000"
                    },
                    {
                        "id": 31283,
                        "name": "Bou Ismaïl",
                        "latitude": "36.64262000",
                        "longitude": "2.69007000"
                    },
                    {
                        "id": 31304,
                        "name": "Cheraga",
                        "latitude": "36.76775000",
                        "longitude": "2.95924000"
                    },
                    {
                        "id": 31320,
                        "name": "Douera",
                        "latitude": "36.67000000",
                        "longitude": "2.94444000"
                    },
                    {
                        "id": 31328,
                        "name": "El Affroun",
                        "latitude": "36.47010000",
                        "longitude": "2.62528000"
                    },
                    {
                        "id": 31349,
                        "name": "Hadjout",
                        "latitude": "36.51257000",
                        "longitude": "2.41382000"
                    },
                    {
                        "id": 31364,
                        "name": "Kolea",
                        "latitude": "36.63888000",
                        "longitude": "2.76845000"
                    },
                    {
                        "id": 31389,
                        "name": "Mouzaïa",
                        "latitude": "36.46695000",
                        "longitude": "2.68991000"
                    },
                    {
                        "id": 31401,
                        "name": "Oued el Alleug",
                        "latitude": "36.55528000",
                        "longitude": "2.79028000"
                    },
                    {
                        "id": 31418,
                        "name": "Saoula",
                        "latitude": "36.70456000",
                        "longitude": "3.02462000"
                    },
                    {
                        "id": 31453,
                        "name": "Tipasa",
                        "latitude": "36.58972000",
                        "longitude": "2.44750000"
                    },
                    {
                        "id": 31465,
                        "name": "Zeralda",
                        "latitude": "36.71169000",
                        "longitude": "2.84244000"
                    }
                ]
            },
            {
                "id": 1133,
                "name": "Tissemsilt",
                "iso2": "38",
                "latitude": "35.60537810",
                "longitude": "1.81309800",
                "type": "province",
                "cities": [
                    {
                        "id": 31370,
                        "name": "Lardjem",
                        "latitude": "35.74922000",
                        "longitude": "1.54778000"
                    },
                    {
                        "id": 31455,
                        "name": "Tissemsilt",
                        "latitude": "35.60722000",
                        "longitude": "1.81081000"
                    }
                ]
            },
            {
                "id": 1131,
                "name": "Tizi Ouzou",
                "iso2": "15",
                "latitude": "36.70691100",
                "longitude": "4.23333550",
                "type": "province",
                "cities": [
                    {
                        "id": 31476,
                        "name": "’Aïn el Hammam",
                        "latitude": "36.56471000",
                        "longitude": "4.30619000"
                    },
                    {
                        "id": 31236,
                        "name": "Arhribs",
                        "latitude": "36.79361000",
                        "longitude": "4.31158000"
                    },
                    {
                        "id": 31238,
                        "name": "Azazga",
                        "latitude": "36.74472000",
                        "longitude": "4.37222000"
                    },
                    {
                        "id": 31262,
                        "name": "Beni Douala",
                        "latitude": "36.61954000",
                        "longitude": "4.08282000"
                    },
                    {
                        "id": 31277,
                        "name": "Boghni",
                        "latitude": "36.54222000",
                        "longitude": "3.95306000"
                    },
                    {
                        "id": 31285,
                        "name": "Boudjima",
                        "latitude": "36.80218000",
                        "longitude": "4.15187000"
                    },
                    {
                        "id": 31303,
                        "name": "Chemini",
                        "latitude": "36.60000000",
                        "longitude": "4.61667000"
                    },
                    {
                        "id": 31321,
                        "name": "Draa Ben Khedda",
                        "latitude": "36.73436000",
                        "longitude": "3.96223000"
                    },
                    {
                        "id": 31345,
                        "name": "Freha",
                        "latitude": "36.75234000",
                        "longitude": "4.31550000"
                    },
                    {
                        "id": 31357,
                        "name": "Ighram",
                        "latitude": "36.46295000",
                        "longitude": "4.50532000"
                    },
                    {
                        "id": 31371,
                        "name": "L’Arbaa Naït Irathen",
                        "latitude": "36.63112000",
                        "longitude": "4.19864000"
                    },
                    {
                        "id": 31380,
                        "name": "Mekla",
                        "latitude": "36.68178000",
                        "longitude": "4.26378000"
                    },
                    {
                        "id": 31451,
                        "name": "Timizart",
                        "latitude": "36.80000000",
                        "longitude": "4.26667000"
                    },
                    {
                        "id": 31454,
                        "name": "Tirmitine",
                        "latitude": "36.65393000",
                        "longitude": "3.98143000"
                    },
                    {
                        "id": 31457,
                        "name": "Tizi Ouzou",
                        "latitude": "36.71182000",
                        "longitude": "4.04591000"
                    },
                    {
                        "id": 31458,
                        "name": "Tizi Rached",
                        "latitude": "36.67176000",
                        "longitude": "4.19176000"
                    },
                    {
                        "id": 31459,
                        "name": "Tizi-n-Tleta",
                        "latitude": "36.54569000",
                        "longitude": "4.05712000"
                    }
                ]
            },
            {
                "id": 1107,
                "name": "Tlemcen",
                "iso2": "13",
                "latitude": "34.67802840",
                "longitude": "-1.36621600",
                "type": "province",
                "cities": [
                    {
                        "id": 31264,
                        "name": "Beni Mester",
                        "latitude": "34.87045000",
                        "longitude": "-1.42319000"
                    },
                    {
                        "id": 31266,
                        "name": "Bensekrane",
                        "latitude": "35.07465000",
                        "longitude": "-1.22431000"
                    },
                    {
                        "id": 31306,
                        "name": "Chetouane",
                        "latitude": "34.92129000",
                        "longitude": "-1.29512000"
                    },
                    {
                        "id": 31354,
                        "name": "Hennaya",
                        "latitude": "34.95139000",
                        "longitude": "-1.36806000"
                    },
                    {
                        "id": 31374,
                        "name": "Mansoûra",
                        "latitude": "34.86158000",
                        "longitude": "-1.33935000"
                    },
                    {
                        "id": 31394,
                        "name": "Nedroma",
                        "latitude": "35.01361000",
                        "longitude": "-1.74799000"
                    },
                    {
                        "id": 31402,
                        "name": "Ouled Mimoun",
                        "latitude": "34.90472000",
                        "longitude": "-1.03394000"
                    },
                    {
                        "id": 31410,
                        "name": "Remchi",
                        "latitude": "35.06196000",
                        "longitude": "-1.43362000"
                    },
                    {
                        "id": 31420,
                        "name": "Sebdou",
                        "latitude": "34.63703000",
                        "longitude": "-1.33143000"
                    },
                    {
                        "id": 31423,
                        "name": "Sidi Abdelli",
                        "latitude": "35.06937000",
                        "longitude": "-1.13706000"
                    },
                    {
                        "id": 31431,
                        "name": "Sidi Senoussi سيدي سنوسي",
                        "latitude": "34.99691000",
                        "longitude": "-1.09449000"
                    },
                    {
                        "id": 31460,
                        "name": "Tlemcen",
                        "latitude": "34.87833000",
                        "longitude": "-1.31500000"
                    }
                ]
            },
            {
                "id": 4911,
                "name": "Touggourt",
                "iso2": "55",
                "latitude": "33.12484760",
                "longitude": "5.78327150",
                "type": "province",
                "cities": []
            }
        ]
    },
    {
        "id": 5,
        "name": "American Samoa",
        "iso3": "ASM",
        "iso2": "AS",
        "numeric_code": "016",
        "phonecode": "1",
        "capital": "Pago Pago",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".as",
        "native": "American Samoa",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Polynesia",
        "subregion_id": 22,
        "nationality": "American Samoan",
        "timezones": [
            {
                "zoneName": "Pacific\/Pago_Pago",
                "gmtOffset": -39600,
                "gmtOffsetName": "UTC-11:00",
                "abbreviation": "SST",
                "tzName": "Samoa Standard Time"
            }
        ],
        "translations": {
            "br": "Samoa Amerikan",
            "ko": "아메리칸사모아",
            "pt-BR": "Samoa Americana",
            "pt": "Samoa Americana",
            "nl": "Amerikaans Samoa",
            "hr": "Američka Samoa",
            "fa": "ساموآی آمریکا",
            "de": "Amerikanisch-Samoa",
            "es": "Samoa Americana",
            "fr": "Samoa américaines",
            "ja": "アメリカ領サモア",
            "it": "Samoa Americane",
            "zh-CN": "美属萨摩亚",
            "tr": "Amerikan Samoasi",
            "ru": "Американское Самоа",
            "uk": "Американське Самоа",
            "pl": "Samoa Amerykańskie"
        },
        "latitude": "-14.33333333",
        "longitude": "-170.00000000",
        "emoji": "🇦🇸",
        "emojiU": "U+1F1E6 U+1F1F8",
        "states": [
            {
                "id": 5375,
                "name": "Eastern",
                "iso2": "02",
                "latitude": "-14.27560390",
                "longitude": "-170.80855920",
                "type": "district",
                "cities": [
                    {
                        "id": 154920,
                        "name": "Ituʻau",
                        "latitude": "-14.30616430",
                        "longitude": "-170.80691440"
                    },
                    {
                        "id": 154921,
                        "name": "Maʻoputasi",
                        "latitude": "-14.25216850",
                        "longitude": "-170.74187670"
                    },
                    {
                        "id": 154924,
                        "name": "Saʻole",
                        "latitude": "-14.29995700",
                        "longitude": "-170.61763370"
                    },
                    {
                        "id": 154923,
                        "name": "Sua",
                        "latitude": "-14.27710880",
                        "longitude": "-170.71442630"
                    },
                    {
                        "id": 154922,
                        "name": "Vaifanua",
                        "latitude": "-14.25578040",
                        "longitude": "-170.76301810"
                    }
                ]
            },
            {
                "id": 5376,
                "name": "Manuʻa",
                "iso2": "03",
                "latitude": "-14.21126410",
                "longitude": "-169.71118920",
                "type": "district",
                "cities": [
                    {
                        "id": 154928,
                        "name": "Faleasao",
                        "latitude": "-14.20385490",
                        "longitude": "-169.54907370"
                    },
                    {
                        "id": 154929,
                        "name": "Fitiuta",
                        "latitude": "-14.20386340",
                        "longitude": "-169.51690440"
                    },
                    {
                        "id": 154925,
                        "name": "Ofu",
                        "latitude": "-14.17135950",
                        "longitude": "-169.71939120"
                    },
                    {
                        "id": 154926,
                        "name": "Olosega",
                        "latitude": "-14.17422270",
                        "longitude": "-169.63981240"
                    },
                    {
                        "id": 154927,
                        "name": "Tau",
                        "latitude": "-14.24215010",
                        "longitude": "-169.55101650"
                    }
                ]
            },
            {
                "id": 5378,
                "name": "Rose",
                "iso2": "05",
                "latitude": "-14.54491610",
                "longitude": "-168.17632920",
                "type": "atoll",
                "cities": []
            },
            {
                "id": 5377,
                "name": "Swains",
                "iso2": "04",
                "latitude": "-11.05658780",
                "longitude": "-171.08829090",
                "type": "atoll",
                "cities": []
            },
            {
                "id": 5374,
                "name": "Western",
                "iso2": "01",
                "latitude": "-14.33307510",
                "longitude": "-170.94315020",
                "type": "district",
                "cities": [
                    {
                        "id": 154916,
                        "name": "Lealataua",
                        "latitude": "-14.32261520",
                        "longitude": "-170.90849930"
                    },
                    {
                        "id": 154917,
                        "name": "Leasina",
                        "latitude": "-14.29581640",
                        "longitude": "-170.80459320"
                    },
                    {
                        "id": 154918,
                        "name": "Tualatai",
                        "latitude": "-14.37923540",
                        "longitude": "-170.81033120"
                    },
                    {
                        "id": 154919,
                        "name": "Tualauta",
                        "latitude": "-14.35876890",
                        "longitude": "-170.75583320"
                    }
                ]
            }
        ]
    },
    {
        "id": 6,
        "name": "Andorra",
        "iso3": "AND",
        "iso2": "AD",
        "numeric_code": "020",
        "phonecode": "376",
        "capital": "Andorra la Vella",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".ad",
        "native": "Andorra",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Andorran",
        "timezones": [
            {
                "zoneName": "Europe\/Andorra",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Andorra",
            "ko": "안도라",
            "pt-BR": "Andorra",
            "pt": "Andorra",
            "nl": "Andorra",
            "hr": "Andora",
            "fa": "آندورا",
            "de": "Andorra",
            "es": "Andorra",
            "fr": "Andorre",
            "ja": "アンドラ",
            "it": "Andorra",
            "zh-CN": "安道尔",
            "tr": "Andorra",
            "ru": "Андорра",
            "uk": "Андорра",
            "pl": "Andora"
        },
        "latitude": "42.50000000",
        "longitude": "1.50000000",
        "emoji": "🇦🇩",
        "emojiU": "U+1F1E6 U+1F1E9",
        "states": [
            {
                "id": 488,
                "name": "Andorra la Vella",
                "iso2": "07",
                "latitude": "42.50631740",
                "longitude": "1.52183550",
                "type": "parish",
                "cities": [
                    {
                        "id": 1,
                        "name": "Andorra la Vella",
                        "latitude": "42.50779000",
                        "longitude": "1.52109000"
                    }
                ]
            },
            {
                "id": 489,
                "name": "Canillo",
                "iso2": "02",
                "latitude": "42.59782490",
                "longitude": "1.65663770",
                "type": "parish",
                "cities": [
                    {
                        "id": 3,
                        "name": "Canillo",
                        "latitude": "42.56760000",
                        "longitude": "1.59756000"
                    },
                    {
                        "id": 4,
                        "name": "El Tarter",
                        "latitude": "42.57952000",
                        "longitude": "1.65362000"
                    }
                ]
            },
            {
                "id": 487,
                "name": "Encamp",
                "iso2": "03",
                "latitude": "42.53597640",
                "longitude": "1.58367730",
                "type": "parish",
                "cities": [
                    {
                        "id": 5,
                        "name": "Encamp",
                        "latitude": "42.53474000",
                        "longitude": "1.58014000"
                    },
                    {
                        "id": 7,
                        "name": "Pas de la Casa",
                        "latitude": "42.54277000",
                        "longitude": "1.73361000"
                    }
                ]
            },
            {
                "id": 492,
                "name": "Escaldes-Engordany",
                "iso2": "08",
                "latitude": "42.49093790",
                "longitude": "1.58869660",
                "type": "parish",
                "cities": [
                    {
                        "id": 10,
                        "name": "les Escaldes",
                        "latitude": "42.50729000",
                        "longitude": "1.53414000"
                    }
                ]
            },
            {
                "id": 493,
                "name": "La Massana",
                "iso2": "04",
                "latitude": "42.54562500",
                "longitude": "1.51473920",
                "type": "parish",
                "cities": [
                    {
                        "id": 2,
                        "name": "Arinsal",
                        "latitude": "42.57205000",
                        "longitude": "1.48453000"
                    },
                    {
                        "id": 9,
                        "name": "la Massana",
                        "latitude": "42.54499000",
                        "longitude": "1.51483000"
                    }
                ]
            },
            {
                "id": 491,
                "name": "Ordino",
                "iso2": "05",
                "latitude": "42.59944330",
                "longitude": "1.54023270",
                "type": "parish",
                "cities": [
                    {
                        "id": 6,
                        "name": "Ordino",
                        "latitude": "42.55623000",
                        "longitude": "1.53319000"
                    }
                ]
            },
            {
                "id": 490,
                "name": "Sant Julià de Lòria",
                "iso2": "06",
                "latitude": "42.45296310",
                "longitude": "1.49182350",
                "type": "parish",
                "cities": [
                    {
                        "id": 8,
                        "name": "Sant Julià de Lòria",
                        "latitude": "42.46372000",
                        "longitude": "1.49129000"
                    }
                ]
            }
        ]
    },
    {
        "id": 7,
        "name": "Angola",
        "iso3": "AGO",
        "iso2": "AO",
        "numeric_code": "024",
        "phonecode": "244",
        "capital": "Luanda",
        "currency": "AOA",
        "currency_name": "Angolan kwanza",
        "currency_symbol": "Kz",
        "tld": ".ao",
        "native": "Angola",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Middle Africa",
        "subregion_id": 2,
        "nationality": "Angolan",
        "timezones": [
            {
                "zoneName": "Africa\/Luanda",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "br": "Angola",
            "ko": "앙골라",
            "pt-BR": "Angola",
            "pt": "Angola",
            "nl": "Angola",
            "hr": "Angola",
            "fa": "آنگولا",
            "de": "Angola",
            "es": "Angola",
            "fr": "Angola",
            "ja": "アンゴラ",
            "it": "Angola",
            "zh-CN": "安哥拉",
            "tr": "Angola",
            "ru": "Ангола",
            "uk": "Ангола",
            "pl": "Angola"
        },
        "latitude": "-12.50000000",
        "longitude": "18.50000000",
        "emoji": "🇦🇴",
        "emojiU": "U+1F1E6 U+1F1F4",
        "states": [
            {
                "id": 221,
                "name": "Bengo",
                "iso2": "BGO",
                "latitude": "-9.10422570",
                "longitude": "13.72891670",
                "type": "province",
                "cities": [
                    {
                        "id": 153645,
                        "name": "Ambriz",
                        "latitude": "-7.85740000",
                        "longitude": "13.12510000"
                    },
                    {
                        "id": 153646,
                        "name": "Bula Atumba",
                        "latitude": "-7.31170000",
                        "longitude": "14.31470000"
                    },
                    {
                        "id": 598,
                        "name": "Caxito",
                        "latitude": "-8.57848000",
                        "longitude": "13.66425000"
                    },
                    {
                        "id": 153647,
                        "name": "Dande",
                        "latitude": "-8.11330000",
                        "longitude": "13.76520000"
                    },
                    {
                        "id": 153648,
                        "name": "Muxima",
                        "latitude": "-9.58790000",
                        "longitude": "13.52510000"
                    },
                    {
                        "id": 153649,
                        "name": "Nambuangongo",
                        "latitude": "-8.56560000",
                        "longitude": "13.65720000"
                    },
                    {
                        "id": 153650,
                        "name": "Pango Aluquém",
                        "latitude": "-8.55440000",
                        "longitude": "13.58150000"
                    },
                    {
                        "id": 153651,
                        "name": "Úcua",
                        "latitude": "-8.67240000",
                        "longitude": "13.68290000"
                    }
                ]
            },
            {
                "id": 218,
                "name": "Benguela",
                "iso2": "BGU",
                "latitude": "-12.80037440",
                "longitude": "13.91439900",
                "type": "province",
                "cities": [
                    {
                        "id": 153653,
                        "name": "Baía Farta",
                        "latitude": "-12.57660000",
                        "longitude": "13.47760000"
                    },
                    {
                        "id": 153654,
                        "name": "Balombo",
                        "latitude": "-12.90460000",
                        "longitude": "13.59590000"
                    },
                    {
                        "id": 590,
                        "name": "Benguela",
                        "latitude": "-12.57626000",
                        "longitude": "13.40547000"
                    },
                    {
                        "id": 153656,
                        "name": "Bocoio",
                        "latitude": "-12.53030000",
                        "longitude": "13.40420000"
                    },
                    {
                        "id": 153659,
                        "name": "Caimbambo",
                        "latitude": "-12.61330000",
                        "longitude": "14.41940000"
                    },
                    {
                        "id": 597,
                        "name": "Catumbela",
                        "latitude": "-12.43002000",
                        "longitude": "13.54677000"
                    },
                    {
                        "id": 153655,
                        "name": "Chongoroi",
                        "latitude": "-12.78880000",
                        "longitude": "13.79750000"
                    },
                    {
                        "id": 153658,
                        "name": "Cubal",
                        "latitude": "-12.58850000",
                        "longitude": "14.42670000"
                    },
                    {
                        "id": 153657,
                        "name": "Ganda",
                        "latitude": "-12.68250000",
                        "longitude": "14.42330000"
                    },
                    {
                        "id": 613,
                        "name": "Lobito",
                        "latitude": "-12.36440000",
                        "longitude": "13.53601000"
                    },
                    {
                        "id": 153660,
                        "name": "Sumbe",
                        "latitude": "-11.20610000",
                        "longitude": "13.84480000"
                    }
                ]
            },
            {
                "id": 212,
                "name": "Bié",
                "iso2": "BIE",
                "latitude": "-12.57279070",
                "longitude": "17.66888700",
                "type": "province",
                "cities": [
                    {
                        "id": 595,
                        "name": "Camacupa",
                        "latitude": "-12.01667000",
                        "longitude": "17.48333000"
                    },
                    {
                        "id": 596,
                        "name": "Catabola",
                        "latitude": "-12.15000000",
                        "longitude": "17.28333000"
                    },
                    {
                        "id": 605,
                        "name": "Chissamba",
                        "latitude": "-12.16667000",
                        "longitude": "17.33333000"
                    },
                    {
                        "id": 606,
                        "name": "Cuito",
                        "latitude": "-12.38333000",
                        "longitude": "16.93333000"
                    }
                ]
            },
            {
                "id": 228,
                "name": "Cabinda",
                "iso2": "CAB",
                "latitude": "-5.02487490",
                "longitude": "12.34638750",
                "type": "province",
                "cities": [
                    {
                        "id": 591,
                        "name": "Cabinda",
                        "latitude": "-5.55000000",
                        "longitude": "12.20000000"
                    }
                ]
            },
            {
                "id": 226,
                "name": "Cuando Cubango",
                "iso2": "CCU",
                "latitude": "-16.41808240",
                "longitude": "18.80761950",
                "type": "province",
                "cities": [
                    {
                        "id": 625,
                        "name": "Menongue",
                        "latitude": "-14.65850000",
                        "longitude": "17.69099000"
                    }
                ]
            },
            {
                "id": 216,
                "name": "Cuanza",
                "iso2": "CUS",
                "latitude": "-10.59519100",
                "longitude": "15.40680790",
                "type": "province",
                "cities": [
                    {
                        "id": 629,
                        "name": "Quibala",
                        "latitude": "-10.73366000",
                        "longitude": "14.97995000"
                    },
                    {
                        "id": 634,
                        "name": "Sumbe",
                        "latitude": "-11.20605000",
                        "longitude": "13.84371000"
                    },
                    {
                        "id": 635,
                        "name": "Uacu Cungo",
                        "latitude": "-11.35669000",
                        "longitude": "15.11719000"
                    }
                ]
            },
            {
                "id": 217,
                "name": "Cuanza Norte",
                "iso2": "CNO",
                "latitude": "-9.23985130",
                "longitude": "14.65878210",
                "type": "province",
                "cities": [
                    {
                        "id": 594,
                        "name": "Camabatela",
                        "latitude": "-8.18812000",
                        "longitude": "15.37495000"
                    },
                    {
                        "id": 627,
                        "name": "N’dalatando",
                        "latitude": "-9.29782000",
                        "longitude": "14.91162000"
                    }
                ]
            },
            {
                "id": 215,
                "name": "Cunene",
                "iso2": "CNN",
                "latitude": "-16.28022210",
                "longitude": "16.15809370",
                "type": "province",
                "cities": [
                    {
                        "id": 628,
                        "name": "Ondjiva",
                        "latitude": "-17.06667000",
                        "longitude": "15.73333000"
                    }
                ]
            },
            {
                "id": 213,
                "name": "Huambo",
                "iso2": "HUA",
                "latitude": "-12.52682210",
                "longitude": "15.59433880",
                "type": "province",
                "cities": [
                    {
                        "id": 600,
                        "name": "Caála",
                        "latitude": "-12.85250000",
                        "longitude": "15.56056000"
                    },
                    {
                        "id": 601,
                        "name": "Chela",
                        "latitude": "-12.30261000",
                        "longitude": "15.43358000"
                    },
                    {
                        "id": 609,
                        "name": "Huambo",
                        "latitude": "-12.77611000",
                        "longitude": "15.73917000"
                    },
                    {
                        "id": 614,
                        "name": "Longonjo",
                        "latitude": "-12.90667000",
                        "longitude": "15.25333000"
                    }
                ]
            },
            {
                "id": 225,
                "name": "Huíla",
                "iso2": "HUI",
                "latitude": "-14.92805530",
                "longitude": "14.65878210",
                "type": "province",
                "cities": [
                    {
                        "id": 592,
                        "name": "Caconda",
                        "latitude": "-13.73333000",
                        "longitude": "15.06667000"
                    },
                    {
                        "id": 593,
                        "name": "Caluquembe",
                        "latitude": "-13.92093000",
                        "longitude": "14.53476000"
                    },
                    {
                        "id": 602,
                        "name": "Chibia",
                        "latitude": "-15.23657000",
                        "longitude": "13.88468000"
                    },
                    {
                        "id": 603,
                        "name": "Chicomba",
                        "latitude": "-14.30788000",
                        "longitude": "14.98672000"
                    },
                    {
                        "id": 604,
                        "name": "Chipindo",
                        "latitude": "-13.86830000",
                        "longitude": "15.73277000"
                    },
                    {
                        "id": 607,
                        "name": "Cuvango",
                        "latitude": "-14.27693000",
                        "longitude": "16.31475000"
                    },
                    {
                        "id": 608,
                        "name": "Gambos",
                        "latitude": "-15.80926000",
                        "longitude": "14.07661000"
                    },
                    {
                        "id": 610,
                        "name": "Humpata",
                        "latitude": "-15.07250000",
                        "longitude": "13.36771000"
                    },
                    {
                        "id": 612,
                        "name": "Jamba",
                        "latitude": "-14.76294000",
                        "longitude": "15.83493000"
                    },
                    {
                        "id": 617,
                        "name": "Lubango",
                        "latitude": "-14.91717000",
                        "longitude": "13.49250000"
                    },
                    {
                        "id": 623,
                        "name": "Matala",
                        "latitude": "-15.23967000",
                        "longitude": "15.17246000"
                    },
                    {
                        "id": 630,
                        "name": "Quilengues",
                        "latitude": "-13.99213000",
                        "longitude": "13.76705000"
                    },
                    {
                        "id": 631,
                        "name": "Quipungo",
                        "latitude": "-15.12203000",
                        "longitude": "14.55953000"
                    }
                ]
            },
            {
                "id": 222,
                "name": "Luanda",
                "iso2": "LUA",
                "latitude": "-9.03508800",
                "longitude": "13.26634790",
                "type": "province",
                "cities": [
                    {
                        "id": 589,
                        "name": "Belas",
                        "latitude": "-9.06875000",
                        "longitude": "13.16072000"
                    },
                    {
                        "id": 153641,
                        "name": "Cacuaco",
                        "latitude": "-8.82960000",
                        "longitude": "13.29730000"
                    },
                    {
                        "id": 153642,
                        "name": "Cazenga",
                        "latitude": "-8.82860000",
                        "longitude": "13.26650000"
                    },
                    {
                        "id": 611,
                        "name": "Icolo e Bengo",
                        "latitude": "-9.24191000",
                        "longitude": "13.73549000"
                    },
                    {
                        "id": 615,
                        "name": "Luanda",
                        "latitude": "-8.83682000",
                        "longitude": "13.23432000"
                    },
                    {
                        "id": 153643,
                        "name": "Talatona",
                        "latitude": "-8.89570000",
                        "longitude": "13.19430000"
                    },
                    {
                        "id": 153644,
                        "name": "Viana",
                        "latitude": "-8.90210000",
                        "longitude": "13.28610000"
                    }
                ]
            },
            {
                "id": 223,
                "name": "Lunda Norte",
                "iso2": "LNO",
                "latitude": "-8.35250220",
                "longitude": "19.18800470",
                "type": "province",
                "cities": [
                    {
                        "id": 618,
                        "name": "Lucapa",
                        "latitude": "-8.68337000",
                        "longitude": "20.27045000"
                    }
                ]
            },
            {
                "id": 220,
                "name": "Lunda Sul",
                "iso2": "LSU",
                "latitude": "-9.89213630",
                "longitude": "19.08041200",
                "type": "province",
                "cities": [
                    {
                        "id": 599,
                        "name": "Cazaji",
                        "latitude": "-11.06715000",
                        "longitude": "20.70148000"
                    },
                    {
                        "id": 632,
                        "name": "Saurimo",
                        "latitude": "-9.66078000",
                        "longitude": "20.39155000"
                    }
                ]
            },
            {
                "id": 227,
                "name": "Malanje",
                "iso2": "MAL",
                "latitude": "-9.82511830",
                "longitude": "16.91225100",
                "type": "province",
                "cities": [
                    {
                        "id": 622,
                        "name": "Malanje",
                        "latitude": "-9.54015000",
                        "longitude": "16.34096000"
                    }
                ]
            },
            {
                "id": 219,
                "name": "Moxico",
                "iso2": "MOX",
                "latitude": "-13.42935790",
                "longitude": "20.33088140",
                "type": "province",
                "cities": [
                    {
                        "id": 621,
                        "name": "Léua",
                        "latitude": "-11.65000000",
                        "longitude": "20.45000000"
                    },
                    {
                        "id": 616,
                        "name": "Luau",
                        "latitude": "-10.70727000",
                        "longitude": "22.22466000"
                    },
                    {
                        "id": 619,
                        "name": "Luena",
                        "latitude": "-11.78333000",
                        "longitude": "19.91667000"
                    },
                    {
                        "id": 620,
                        "name": "Lumeje",
                        "latitude": "-11.55000000",
                        "longitude": "20.78333000"
                    }
                ]
            },
            {
                "id": 224,
                "name": "Uíge",
                "iso2": "UIG",
                "latitude": "-7.17367320",
                "longitude": "15.40680790",
                "type": "province",
                "cities": [
                    {
                        "id": 636,
                        "name": "Uíge",
                        "latitude": "-7.60874000",
                        "longitude": "15.06131000"
                    }
                ]
            },
            {
                "id": 214,
                "name": "Zaire",
                "iso2": "ZAI",
                "latitude": "-6.57334580",
                "longitude": "13.17403480",
                "type": "province",
                "cities": [
                    {
                        "id": 624,
                        "name": "Mbanza Congo",
                        "latitude": "-6.26703000",
                        "longitude": "14.24010000"
                    },
                    {
                        "id": 626,
                        "name": "N'zeto",
                        "latitude": "-7.23116000",
                        "longitude": "12.86660000"
                    },
                    {
                        "id": 633,
                        "name": "Soio",
                        "latitude": "-6.13490000",
                        "longitude": "12.36894000"
                    }
                ]
            }
        ]
    },
    {
        "id": 8,
        "name": "Anguilla",
        "iso3": "AIA",
        "iso2": "AI",
        "numeric_code": "660",
        "phonecode": "1",
        "capital": "The Valley",
        "currency": "XCD",
        "currency_name": "Eastern Caribbean dollar",
        "currency_symbol": "$",
        "tld": ".ai",
        "native": "Anguilla",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Anguillan",
        "timezones": [
            {
                "zoneName": "America\/Anguilla",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Anguilla",
            "ko": "앵귈라",
            "pt-BR": "Anguila",
            "pt": "Anguila",
            "nl": "Anguilla",
            "hr": "Angvila",
            "fa": "آنگویلا",
            "de": "Anguilla",
            "es": "Anguilla",
            "fr": "Anguilla",
            "ja": "アンギラ",
            "it": "Anguilla",
            "zh-CN": "安圭拉",
            "tr": "Anguilla",
            "ru": "Ангилья",
            "uk": "Ангілья",
            "pl": "Anguilla"
        },
        "latitude": "18.25000000",
        "longitude": "-63.16666666",
        "emoji": "🇦🇮",
        "emojiU": "U+1F1E6 U+1F1EE",
        "states": [
            {
                "id": 5273,
                "name": "Blowing Point",
                "iso2": null,
                "latitude": "18.17655530",
                "longitude": "-63.10212960",
                "type": "district",
                "cities": []
            },
            {
                "id": 5274,
                "name": "East End",
                "iso2": null,
                "latitude": "18.23561730",
                "longitude": "-63.01497150",
                "type": "district",
                "cities": []
            },
            {
                "id": 5275,
                "name": "George Hill",
                "iso2": null,
                "latitude": "18.19978110",
                "longitude": "-63.07761140",
                "type": "district",
                "cities": []
            },
            {
                "id": 5276,
                "name": "Island Harbour",
                "iso2": null,
                "latitude": "18.25521250",
                "longitude": "-63.01405900",
                "type": "district",
                "cities": []
            },
            {
                "id": 5277,
                "name": "North Hill",
                "iso2": null,
                "latitude": "18.20508630",
                "longitude": "-63.08584570",
                "type": "district",
                "cities": []
            },
            {
                "id": 5278,
                "name": "North Side",
                "iso2": null,
                "latitude": "18.23005440",
                "longitude": "-63.05188900",
                "type": "district",
                "cities": []
            },
            {
                "id": 5279,
                "name": "Sandy Ground",
                "iso2": null,
                "latitude": "18.20185510",
                "longitude": "-63.09734710",
                "type": "district",
                "cities": []
            },
            {
                "id": 5280,
                "name": "Sandy Hill",
                "iso2": null,
                "latitude": "18.21892100",
                "longitude": "-63.01299160",
                "type": "district",
                "cities": []
            },
            {
                "id": 5281,
                "name": "South Hill",
                "iso2": null,
                "latitude": "18.18924750",
                "longitude": "-63.09763670",
                "type": "district",
                "cities": []
            },
            {
                "id": 5282,
                "name": "Stoney Ground",
                "iso2": null,
                "latitude": "18.21791010",
                "longitude": "-63.04969860",
                "type": "district",
                "cities": []
            },
            {
                "id": 5283,
                "name": "The Farrington",
                "iso2": null,
                "latitude": "18.21347010",
                "longitude": "-63.02721620",
                "type": "district",
                "cities": []
            },
            {
                "id": 5284,
                "name": "The Quarter",
                "iso2": null,
                "latitude": "18.21453340",
                "longitude": "-63.05644890",
                "type": "district",
                "cities": []
            },
            {
                "id": 5285,
                "name": "The Valley",
                "iso2": null,
                "latitude": "18.21521660",
                "longitude": "-63.07006280",
                "type": "district",
                "cities": []
            },
            {
                "id": 5286,
                "name": "West End",
                "iso2": null,
                "latitude": "18.17153940",
                "longitude": "-63.17191270",
                "type": "district",
                "cities": []
            }
        ]
    },
    {
        "id": 9,
        "name": "Antarctica",
        "iso3": "ATA",
        "iso2": "AQ",
        "numeric_code": "010",
        "phonecode": "672",
        "capital": "",
        "currency": "AAD",
        "currency_name": "Antarctican dollar",
        "currency_symbol": "$",
        "tld": ".aq",
        "native": "Antarctica",
        "region": "Polar",
        "region_id": 6,
        "subregion": "",
        "subregion_id": 0,
        "nationality": "Antarctic",
        "timezones": [
            {
                "zoneName": "Antarctica\/Casey",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "AWST",
                "tzName": "Australian Western Standard Time"
            },
            {
                "zoneName": "Antarctica\/Davis",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "DAVT",
                "tzName": "Davis Time"
            },
            {
                "zoneName": "Antarctica\/DumontDUrville",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "DDUT",
                "tzName": "Dumont d'Urville Time"
            },
            {
                "zoneName": "Antarctica\/Mawson",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "MAWT",
                "tzName": "Mawson Station Time"
            },
            {
                "zoneName": "Antarctica\/McMurdo",
                "gmtOffset": 46800,
                "gmtOffsetName": "UTC+13:00",
                "abbreviation": "NZDT",
                "tzName": "New Zealand Daylight Time"
            },
            {
                "zoneName": "Antarctica\/Palmer",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "CLST",
                "tzName": "Chile Summer Time"
            },
            {
                "zoneName": "Antarctica\/Rothera",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ROTT",
                "tzName": "Rothera Research Station Time"
            },
            {
                "zoneName": "Antarctica\/Syowa",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "SYOT",
                "tzName": "Showa Station Time"
            },
            {
                "zoneName": "Antarctica\/Troll",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            },
            {
                "zoneName": "Antarctica\/Vostok",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "VOST",
                "tzName": "Vostok Station Time"
            }
        ],
        "translations": {
            "br": "Antarktika",
            "ko": "남극",
            "pt-BR": "Antártida",
            "pt": "Antárctida",
            "nl": "Antarctica",
            "hr": "Antarktika",
            "fa": "جنوبگان",
            "de": "Antarktika",
            "es": "Antártida",
            "fr": "Antarctique",
            "ja": "南極大陸",
            "it": "Antartide",
            "zh-CN": "南极洲",
            "tr": "Antartika",
            "ru": "Антарктида",
            "uk": "Антарктида",
            "pl": "Antarktyda"
        },
        "latitude": "-74.65000000",
        "longitude": "4.48000000",
        "emoji": "🇦🇶",
        "emojiU": "U+1F1E6 U+1F1F6",
        "states": []
    },
    {
        "id": 10,
        "name": "Antigua and Barbuda",
        "iso3": "ATG",
        "iso2": "AG",
        "numeric_code": "028",
        "phonecode": "1",
        "capital": "St. John's",
        "currency": "XCD",
        "currency_name": "Eastern Caribbean dollar",
        "currency_symbol": "$",
        "tld": ".ag",
        "native": "Antigua and Barbuda",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Antiguan or Barbudan",
        "timezones": [
            {
                "zoneName": "America\/Antigua",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Antigua-ha-Barbuda",
            "ko": "앤티가 바부다",
            "pt-BR": "Antígua e Barbuda",
            "pt": "Antígua e Barbuda",
            "nl": "Antigua en Barbuda",
            "hr": "Antigva i Barbuda",
            "fa": "آنتیگوا و باربودا",
            "de": "Antigua und Barbuda",
            "es": "Antigua y Barbuda",
            "fr": "Antigua-et-Barbuda",
            "ja": "アンティグア・バーブーダ",
            "it": "Antigua e Barbuda",
            "zh-CN": "安提瓜和巴布达",
            "tr": "Antigua Ve Barbuda",
            "ru": "Антигуа и Барбуда",
            "uk": "Антигуа і Барбуда",
            "pl": "Antigua i Barbuda"
        },
        "latitude": "17.05000000",
        "longitude": "-61.80000000",
        "emoji": "🇦🇬",
        "emojiU": "U+1F1E6 U+1F1EC",
        "states": [
            {
                "id": 3708,
                "name": "Barbuda",
                "iso2": "10",
                "latitude": "17.62662420",
                "longitude": "-61.77130280",
                "type": "dependency",
                "cities": [
                    {
                        "id": 144,
                        "name": "Codrington",
                        "latitude": "17.63333000",
                        "longitude": "-61.83333000"
                    }
                ]
            },
            {
                "id": 3703,
                "name": "Redonda",
                "iso2": "11",
                "latitude": "16.93841600",
                "longitude": "-62.34551480",
                "type": "dependency",
                "cities": []
            },
            {
                "id": 3709,
                "name": "Saint George",
                "iso2": "03",
                "latitude": "17.12619290",
                "longitude": "-61.81921830",
                "type": "parish",
                "cities": [
                    {
                        "id": 148,
                        "name": "Piggotts",
                        "latitude": "17.11667000",
                        "longitude": "-61.80000000"
                    }
                ]
            },
            {
                "id": 3706,
                "name": "Saint John",
                "iso2": "04",
                "latitude": "17.11363380",
                "longitude": "-61.92827140",
                "type": "parish",
                "cities": [
                    {
                        "id": 149,
                        "name": "Potters Village",
                        "latitude": "17.11337000",
                        "longitude": "-61.81962000"
                    },
                    {
                        "id": 150,
                        "name": "Saint John’s",
                        "latitude": "17.12096000",
                        "longitude": "-61.84329000"
                    }
                ]
            },
            {
                "id": 3707,
                "name": "Saint Mary",
                "iso2": "05",
                "latitude": "17.05443730",
                "longitude": "-61.89690370",
                "type": "parish",
                "cities": [
                    {
                        "id": 143,
                        "name": "Bolands",
                        "latitude": "17.06565000",
                        "longitude": "-61.87466000"
                    }
                ]
            },
            {
                "id": 3705,
                "name": "Saint Paul",
                "iso2": "06",
                "latitude": "17.03193840",
                "longitude": "-61.81266040",
                "type": "parish",
                "cities": [
                    {
                        "id": 145,
                        "name": "Falmouth",
                        "latitude": "17.02741000",
                        "longitude": "-61.78136000"
                    },
                    {
                        "id": 146,
                        "name": "Liberta",
                        "latitude": "17.04141000",
                        "longitude": "-61.79052000"
                    }
                ]
            },
            {
                "id": 3704,
                "name": "Saint Peter",
                "iso2": "07",
                "latitude": "17.10548380",
                "longitude": "-61.79123170",
                "type": "parish",
                "cities": [
                    {
                        "id": 142,
                        "name": "All Saints",
                        "latitude": "17.06671000",
                        "longitude": "-61.79303000"
                    },
                    {
                        "id": 147,
                        "name": "Parham",
                        "latitude": "17.09682000",
                        "longitude": "-61.77046000"
                    }
                ]
            },
            {
                "id": 3710,
                "name": "Saint Philip",
                "iso2": "08",
                "latitude": "17.06749130",
                "longitude": "-61.74190260",
                "type": "parish",
                "cities": []
            }
        ]
    },
    {
        "id": 11,
        "name": "Argentina",
        "iso3": "ARG",
        "iso2": "AR",
        "numeric_code": "032",
        "phonecode": "54",
        "capital": "Buenos Aires",
        "currency": "ARS",
        "currency_name": "Argentine peso",
        "currency_symbol": "$",
        "tld": ".ar",
        "native": "Argentina",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Argentine",
        "timezones": [
            {
                "zoneName": "America\/Argentina\/Buenos_Aires",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Catamarca",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Cordoba",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Jujuy",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/La_Rioja",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Mendoza",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Rio_Gallegos",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Salta",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/San_Juan",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/San_Luis",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Tucuman",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Ushuaia",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            }
        ],
        "translations": {
            "br": "Arc'hantina",
            "ko": "아르헨티나",
            "pt-BR": "Argentina",
            "pt": "Argentina",
            "nl": "Argentinië",
            "hr": "Argentina",
            "fa": "آرژانتین",
            "de": "Argentinien",
            "es": "Argentina",
            "fr": "Argentine",
            "ja": "アルゼンチン",
            "it": "Argentina",
            "zh-CN": "阿根廷",
            "tr": "Arjantin",
            "ru": "Аргентина",
            "uk": "Аргентина",
            "pl": "Argentyna"
        },
        "latitude": "-34.00000000",
        "longitude": "-64.00000000",
        "emoji": "🇦🇷",
        "emojiU": "U+1F1E6 U+1F1F7",
        "states": [
            {
                "id": 4880,
                "name": "Autonomous City of Buenos Aires",
                "iso2": "C",
                "latitude": "-34.60368440",
                "longitude": "-58.38155910",
                "type": "city",
                "cities": [
                    {
                        "id": 154263,
                        "name": "Agronomía",
                        "latitude": "-34.59222640",
                        "longitude": "-58.49997640"
                    },
                    {
                        "id": 154264,
                        "name": "Almagro",
                        "latitude": "-34.60985140",
                        "longitude": "-58.44322610"
                    },
                    {
                        "id": 154265,
                        "name": "Balvanera",
                        "latitude": "-34.60928550",
                        "longitude": "-58.42375890"
                    },
                    {
                        "id": 154266,
                        "name": "Barracas",
                        "latitude": "-34.64448730",
                        "longitude": "-58.40516880"
                    },
                    {
                        "id": 154267,
                        "name": "Belgrano",
                        "latitude": "-34.55543270",
                        "longitude": "-58.47138570"
                    },
                    {
                        "id": 154268,
                        "name": "Boedo",
                        "latitude": "-34.63038420",
                        "longitude": "-58.43974170"
                    },
                    {
                        "id": 154269,
                        "name": "Caballito",
                        "latitude": "-34.61661920",
                        "longitude": "-58.46532990"
                    },
                    {
                        "id": 154270,
                        "name": "Chacarita",
                        "latitude": "-34.58802750",
                        "longitude": "-58.47332730"
                    },
                    {
                        "id": 154271,
                        "name": "Coghlan",
                        "latitude": "-34.56017320",
                        "longitude": "-58.48536760"
                    },
                    {
                        "id": 154272,
                        "name": "Colegiales",
                        "latitude": "-34.57463180",
                        "longitude": "-58.46194700"
                    },
                    {
                        "id": 154273,
                        "name": "Constitución",
                        "latitude": "-34.62577020",
                        "longitude": "-58.39393470"
                    },
                    {
                        "id": 154274,
                        "name": "Flores",
                        "latitude": "-34.63528600",
                        "longitude": "-58.49881470"
                    },
                    {
                        "id": 154275,
                        "name": "Floresta",
                        "latitude": "-34.62778190",
                        "longitude": "-58.50535160"
                    },
                    {
                        "id": 154276,
                        "name": "La Boca",
                        "latitude": "-34.63755140",
                        "longitude": "-58.38229510"
                    },
                    {
                        "id": 154277,
                        "name": "La Paternal",
                        "latitude": "-34.59636130",
                        "longitude": "-58.47783340"
                    },
                    {
                        "id": 154278,
                        "name": "Liniers",
                        "latitude": "-34.64494830",
                        "longitude": "-58.53670290"
                    },
                    {
                        "id": 154279,
                        "name": "Mataderos",
                        "latitude": "-34.65888530",
                        "longitude": "-58.52288120"
                    },
                    {
                        "id": 154280,
                        "name": "Monserrat",
                        "latitude": "-34.61254060",
                        "longitude": "-58.38964190"
                    },
                    {
                        "id": 154281,
                        "name": "Monte Castro",
                        "latitude": "-34.61876990",
                        "longitude": "-58.51743230"
                    },
                    {
                        "id": 154282,
                        "name": "Nueva Pompeya",
                        "latitude": "-34.65005810",
                        "longitude": "-58.44252610"
                    },
                    {
                        "id": 154283,
                        "name": "Núñez",
                        "latitude": "-34.54270030",
                        "longitude": "-58.48169430"
                    },
                    {
                        "id": 154284,
                        "name": "Palermo",
                        "latitude": "-34.57335580",
                        "longitude": "-58.46221540"
                    },
                    {
                        "id": 154285,
                        "name": "Parque Avellaneda",
                        "latitude": "-34.65075370",
                        "longitude": "-58.49842840"
                    },
                    {
                        "id": 154286,
                        "name": "Parque Chacabuco",
                        "latitude": "-34.63713830",
                        "longitude": "-58.45953460"
                    },
                    {
                        "id": 154287,
                        "name": "Parque Chas",
                        "latitude": "-34.58486150",
                        "longitude": "-58.49010630"
                    },
                    {
                        "id": 154288,
                        "name": "Parque Patricios",
                        "latitude": "-34.63788690",
                        "longitude": "-58.42225860"
                    },
                    {
                        "id": 154289,
                        "name": "Puerto Madero",
                        "latitude": "-34.61358660",
                        "longitude": "-58.37286850"
                    },
                    {
                        "id": 154290,
                        "name": "Recoleta",
                        "latitude": "-34.58479060",
                        "longitude": "-58.41694250"
                    },
                    {
                        "id": 154291,
                        "name": "Retiro",
                        "latitude": "-34.58936080",
                        "longitude": "-58.39738800"
                    },
                    {
                        "id": 154292,
                        "name": "Saavedra",
                        "latitude": "-34.55431210",
                        "longitude": "-58.50975950"
                    },
                    {
                        "id": 154293,
                        "name": "San Cristóbal",
                        "latitude": "-34.62423930",
                        "longitude": "-58.41215650"
                    },
                    {
                        "id": 154294,
                        "name": "San Nicolás",
                        "latitude": "-34.60390370",
                        "longitude": "-58.39059120"
                    },
                    {
                        "id": 154295,
                        "name": "San Telmo",
                        "latitude": "-34.62254210",
                        "longitude": "-58.38055780"
                    },
                    {
                        "id": 154296,
                        "name": "Vélez Sársfield",
                        "latitude": "-34.63129820",
                        "longitude": "-58.51351920"
                    },
                    {
                        "id": 154297,
                        "name": "Versalles",
                        "latitude": "-34.62915440",
                        "longitude": "-58.52963820"
                    },
                    {
                        "id": 154298,
                        "name": "Villa Crespo",
                        "latitude": "-34.59811590",
                        "longitude": "-58.46174830"
                    },
                    {
                        "id": 154299,
                        "name": "Villa del Parque",
                        "latitude": "-34.60587650",
                        "longitude": "-58.51064410"
                    },
                    {
                        "id": 154300,
                        "name": "Villa Devoto",
                        "latitude": "-34.60046930",
                        "longitude": "-58.55443260"
                    },
                    {
                        "id": 154301,
                        "name": "Villa General Mitre",
                        "latitude": "-34.61048970",
                        "longitude": "-58.47974190"
                    },
                    {
                        "id": 154302,
                        "name": "Villa Lugano",
                        "latitude": "-34.67485910",
                        "longitude": "-58.49704580"
                    },
                    {
                        "id": 154303,
                        "name": "Villa Luro",
                        "latitude": "-34.63500670",
                        "longitude": "-58.52269370"
                    },
                    {
                        "id": 154304,
                        "name": "Villa Ortúzar",
                        "latitude": "-34.58148740",
                        "longitude": "-58.47898750"
                    },
                    {
                        "id": 154305,
                        "name": "Villa Pueyrredón",
                        "latitude": "-34.58182550",
                        "longitude": "-58.52264930"
                    },
                    {
                        "id": 154306,
                        "name": "Villa Real",
                        "latitude": "-34.61909340",
                        "longitude": "-58.53453420"
                    },
                    {
                        "id": 154307,
                        "name": "Villa Riachuelo",
                        "latitude": "-34.69266220",
                        "longitude": "-58.48434810"
                    },
                    {
                        "id": 154308,
                        "name": "Villa Santa Rita",
                        "latitude": "-34.61636020",
                        "longitude": "-58.49350310"
                    },
                    {
                        "id": 154309,
                        "name": "Villa Soldati",
                        "latitude": "-34.66789240",
                        "longitude": "-58.46756510"
                    },
                    {
                        "id": 154310,
                        "name": "Villa Urquiza",
                        "latitude": "-34.57192410",
                        "longitude": "-58.50934640"
                    }
                ]
            },
            {
                "id": 3656,
                "name": "Buenos Aires",
                "iso2": "B",
                "latitude": "-37.20172850",
                "longitude": "-59.84106970",
                "type": "province",
                "cities": [
                    {
                        "id": 154311,
                        "name": "Adolfo Alsina",
                        "latitude": "-37.16054780",
                        "longitude": "-64.22506020"
                    },
                    {
                        "id": 154312,
                        "name": "Adolfo Gonzáles Chaves",
                        "latitude": "-37.93801600",
                        "longitude": "-60.90296530"
                    },
                    {
                        "id": 154313,
                        "name": "Alberti",
                        "latitude": "-35.02768320",
                        "longitude": "-60.58411980"
                    },
                    {
                        "id": 154314,
                        "name": "Almirante Brown",
                        "latitude": "-34.83197240",
                        "longitude": "-58.45251410"
                    },
                    {
                        "id": 154315,
                        "name": "Arrecifes",
                        "latitude": "-34.00603330",
                        "longitude": "-60.33782350"
                    },
                    {
                        "id": 154316,
                        "name": "Avellaneda",
                        "latitude": "-34.66134140",
                        "longitude": "-58.38802660"
                    },
                    {
                        "id": 154317,
                        "name": "Ayacucho",
                        "latitude": "-36.97372280",
                        "longitude": "-59.08902220"
                    },
                    {
                        "id": 154318,
                        "name": "Azul",
                        "latitude": "-36.82779090",
                        "longitude": "-60.99253580"
                    },
                    {
                        "id": 154319,
                        "name": "Bahía Blanca",
                        "latitude": "-38.58796980",
                        "longitude": "-62.50794130"
                    },
                    {
                        "id": 154320,
                        "name": "Balcarce",
                        "latitude": "-37.75449560",
                        "longitude": "-58.93081520"
                    },
                    {
                        "id": 154321,
                        "name": "Baradero",
                        "latitude": "-33.90652010",
                        "longitude": "-59.81822290"
                    },
                    {
                        "id": 154322,
                        "name": "Benito Juárez",
                        "latitude": "-37.58593960",
                        "longitude": "-60.52379500"
                    },
                    {
                        "id": 154323,
                        "name": "Berazategui",
                        "latitude": "-34.84334610",
                        "longitude": "-58.30738810"
                    },
                    {
                        "id": 154324,
                        "name": "Berisso",
                        "latitude": "-34.89821320",
                        "longitude": "-57.90243650"
                    },
                    {
                        "id": 154325,
                        "name": "Bolívar",
                        "latitude": "-36.28911980",
                        "longitude": "-61.78736580"
                    },
                    {
                        "id": 154326,
                        "name": "Bragado",
                        "latitude": "-35.02574040",
                        "longitude": "-61.25370530"
                    },
                    {
                        "id": 154327,
                        "name": "Brandsen",
                        "latitude": "-35.19510090",
                        "longitude": "-58.49818770"
                    },
                    {
                        "id": 154328,
                        "name": "Campana",
                        "latitude": "-34.16079930",
                        "longitude": "-59.22022530"
                    },
                    {
                        "id": 154329,
                        "name": "Cañuelas",
                        "latitude": "-35.15525400",
                        "longitude": "-59.03069800"
                    },
                    {
                        "id": 154330,
                        "name": "Capitán Sarmiento",
                        "latitude": "-34.14170660",
                        "longitude": "-60.02221190"
                    },
                    {
                        "id": 154331,
                        "name": "Carlos Casares",
                        "latitude": "-35.72219790",
                        "longitude": "-62.03779560"
                    },
                    {
                        "id": 154332,
                        "name": "Carlos Tejedor",
                        "latitude": "-35.39445380",
                        "longitude": "-63.06241220"
                    },
                    {
                        "id": 154333,
                        "name": "Carmen de Areco",
                        "latitude": "-34.41836420",
                        "longitude": "-60.23786820"
                    },
                    {
                        "id": 154334,
                        "name": "Castelli",
                        "latitude": "-36.01838980",
                        "longitude": "-57.98088650"
                    },
                    {
                        "id": 154335,
                        "name": "Chacabuco",
                        "latitude": "-34.63340080",
                        "longitude": "-60.65114680"
                    },
                    {
                        "id": 154336,
                        "name": "Chascomús",
                        "latitude": "-35.59543280",
                        "longitude": "-58.56002660"
                    },
                    {
                        "id": 154337,
                        "name": "Chivilcoy",
                        "latitude": "-34.90790700",
                        "longitude": "-60.28432600"
                    },
                    {
                        "id": 154338,
                        "name": "Colón",
                        "latitude": "-33.85225870",
                        "longitude": "-61.40124400"
                    },
                    {
                        "id": 154339,
                        "name": "Coronel Dorrego",
                        "latitude": "-38.64031010",
                        "longitude": "-61.77287250"
                    },
                    {
                        "id": 154340,
                        "name": "Coronel Pringles",
                        "latitude": "-38.16604130",
                        "longitude": "-61.89518000"
                    },
                    {
                        "id": 154341,
                        "name": "Coronel Rosales",
                        "latitude": "-38.81492060",
                        "longitude": "-62.14727610"
                    },
                    {
                        "id": 154342,
                        "name": "Coronel Suárez",
                        "latitude": "-37.53029820",
                        "longitude": "-63.25323390"
                    },
                    {
                        "id": 154343,
                        "name": "Daireaux",
                        "latitude": "-36.61930860",
                        "longitude": "-62.52352980"
                    },
                    {
                        "id": 154344,
                        "name": "Dolores",
                        "latitude": "-36.41467360",
                        "longitude": "-58.32462490"
                    },
                    {
                        "id": 154345,
                        "name": "Ensenada",
                        "latitude": "-34.84156190",
                        "longitude": "-58.06269460"
                    },
                    {
                        "id": 154346,
                        "name": "Escobar",
                        "latitude": "-34.34251230",
                        "longitude": "-58.93997620"
                    },
                    {
                        "id": 154347,
                        "name": "Esteban Echeverríar",
                        "latitude": "-34.82406180",
                        "longitude": "-58.63358570"
                    },
                    {
                        "id": 154348,
                        "name": "Exaltación de la Cruz",
                        "latitude": "-34.31228650",
                        "longitude": "-59.31295630"
                    },
                    {
                        "id": 154349,
                        "name": "Ezeiza",
                        "latitude": "-34.87357520",
                        "longitude": "-58.73505670"
                    },
                    {
                        "id": 154350,
                        "name": "Florencio Varela",
                        "latitude": "-34.88873210",
                        "longitude": "-58.42115210"
                    },
                    {
                        "id": 154351,
                        "name": "Florentino Ameghino",
                        "latitude": "-34.88624610",
                        "longitude": "-62.70302560"
                    },
                    {
                        "id": 154352,
                        "name": "General Alvarado",
                        "latitude": "-38.19975330",
                        "longitude": "-58.38977980"
                    },
                    {
                        "id": 154353,
                        "name": "General Alvear",
                        "latitude": "-36.03836820",
                        "longitude": "-60.76716020"
                    },
                    {
                        "id": 154354,
                        "name": "General Arenales",
                        "latitude": "-34.23810350",
                        "longitude": "-61.61258250"
                    },
                    {
                        "id": 154355,
                        "name": "General Belgrano",
                        "latitude": "-35.84190100",
                        "longitude": "-59.04535800"
                    },
                    {
                        "id": 154356,
                        "name": "General Guido",
                        "latitude": "-36.67376360",
                        "longitude": "-58.63303620"
                    },
                    {
                        "id": 154357,
                        "name": "General La Madrid",
                        "latitude": "-37.39889560",
                        "longitude": "-61.97377640"
                    },
                    {
                        "id": 154358,
                        "name": "General Las Heras",
                        "latitude": "-34.90931560",
                        "longitude": "-59.32777060"
                    },
                    {
                        "id": 154359,
                        "name": "General Lavalle",
                        "latitude": "-36.67005230",
                        "longitude": "-57.67282310"
                    },
                    {
                        "id": 154360,
                        "name": "General Madariaga",
                        "latitude": "-37.15579700",
                        "longitude": "-57.90662040"
                    },
                    {
                        "id": 154361,
                        "name": "General Paz",
                        "latitude": "-35.47363710",
                        "longitude": "-58.69690130"
                    },
                    {
                        "id": 154362,
                        "name": "General Pinto",
                        "latitude": "-34.68311120",
                        "longitude": "-62.34048360"
                    },
                    {
                        "id": 154363,
                        "name": "General Pueyrredón",
                        "latitude": "-37.97153260",
                        "longitude": "-58.11219280"
                    },
                    {
                        "id": 154364,
                        "name": "General Rodríguez",
                        "latitude": "-34.63970400",
                        "longitude": "-59.16470220"
                    },
                    {
                        "id": 154365,
                        "name": "General San Martín",
                        "latitude": "-34.54379540",
                        "longitude": "-58.64700250"
                    },
                    {
                        "id": 154366,
                        "name": "General Viamonte",
                        "latitude": "-34.97753020",
                        "longitude": "-61.40151400"
                    },
                    {
                        "id": 154367,
                        "name": "General Villegas",
                        "latitude": "-34.87360000",
                        "longitude": "-63.48656420"
                    },
                    {
                        "id": 154368,
                        "name": "Guaminí",
                        "latitude": "-36.89982740",
                        "longitude": "-63.07273400"
                    },
                    {
                        "id": 154369,
                        "name": "Hipólito Yrigoyen",
                        "latitude": "-36.27101580",
                        "longitude": "-61.98866530"
                    },
                    {
                        "id": 154370,
                        "name": "Hurlingham",
                        "latitude": "-34.59796270",
                        "longitude": "-58.69618060"
                    },
                    {
                        "id": 154371,
                        "name": "Ituzaingó",
                        "latitude": "-34.63969570",
                        "longitude": "-58.77365750"
                    },
                    {
                        "id": 154372,
                        "name": "José C. Paz",
                        "latitude": "-34.50433760",
                        "longitude": "-58.85464360"
                    },
                    {
                        "id": 154373,
                        "name": "Junín",
                        "latitude": "-34.54605770",
                        "longitude": "-61.33077050"
                    },
                    {
                        "id": 154374,
                        "name": "La Costa",
                        "latitude": "-36.66068710",
                        "longitude": "-57.40162530"
                    },
                    {
                        "id": 154375,
                        "name": "La Matanza",
                        "latitude": "-34.77307590",
                        "longitude": "-58.78266180"
                    },
                    {
                        "id": 154376,
                        "name": "La Plata",
                        "latitude": "-34.70297680",
                        "longitude": "-58.67985840"
                    },
                    {
                        "id": 154377,
                        "name": "Lanús",
                        "latitude": "-34.70198040",
                        "longitude": "-58.47261230"
                    },
                    {
                        "id": 154378,
                        "name": "Laprida",
                        "latitude": "-37.49309250",
                        "longitude": "-61.42308300"
                    },
                    {
                        "id": 154379,
                        "name": "Las Flores",
                        "latitude": "-36.01628740",
                        "longitude": "-59.86327060"
                    },
                    {
                        "id": 154380,
                        "name": "Leandro N. Alem",
                        "latitude": "-34.49251120",
                        "longitude": "-61.95923550"
                    },
                    {
                        "id": 154381,
                        "name": "Lezama",
                        "latitude": "-35.86369450",
                        "longitude": "-58.15662470"
                    },
                    {
                        "id": 154382,
                        "name": "Lincoln",
                        "latitude": "-35.08589960",
                        "longitude": "-62.35863070"
                    },
                    {
                        "id": 154383,
                        "name": "Lobería",
                        "latitude": "-38.06737520",
                        "longitude": "-59.36333310"
                    },
                    {
                        "id": 154384,
                        "name": "Lobos",
                        "latitude": "-35.19779080",
                        "longitude": "-59.51022420"
                    },
                    {
                        "id": 154385,
                        "name": "Lomas de Zamora",
                        "latitude": "-34.75284350",
                        "longitude": "-58.50112000"
                    },
                    {
                        "id": 154386,
                        "name": "Luján",
                        "latitude": "-34.58755280",
                        "longitude": "-59.47602840"
                    },
                    {
                        "id": 154387,
                        "name": "Magdalena",
                        "latitude": "-35.18662720",
                        "longitude": "-57.99943530"
                    },
                    {
                        "id": 154388,
                        "name": "Maipú",
                        "latitude": "-36.88401400",
                        "longitude": "-58.25271870"
                    },
                    {
                        "id": 154389,
                        "name": "Malvinas Argentinas",
                        "latitude": "-34.48586020",
                        "longitude": "-58.79796800"
                    },
                    {
                        "id": 154390,
                        "name": "Mar Chiquita",
                        "latitude": "-37.50980390",
                        "longitude": "-58.30054500"
                    },
                    {
                        "id": 154391,
                        "name": "Marcos Paz",
                        "latitude": "-34.82080690",
                        "longitude": "-59.02873170"
                    },
                    {
                        "id": 154392,
                        "name": "Mercedes",
                        "latitude": "-34.69878490",
                        "longitude": "-59.77191470"
                    },
                    {
                        "id": 154393,
                        "name": "Merlo",
                        "latitude": "-34.70657840",
                        "longitude": "-58.83276710"
                    },
                    {
                        "id": 154394,
                        "name": "Monte",
                        "latitude": "-35.49862290",
                        "longitude": "-59.12519800"
                    },
                    {
                        "id": 154395,
                        "name": "Monte Hermoso",
                        "latitude": "-38.95737360",
                        "longitude": "-61.44530580"
                    },
                    {
                        "id": 154396,
                        "name": "Moreno",
                        "latitude": "-34.59681430",
                        "longitude": "-58.96697620"
                    },
                    {
                        "id": 154397,
                        "name": "Morón",
                        "latitude": "-34.64640300",
                        "longitude": "-58.69414610"
                    },
                    {
                        "id": 154398,
                        "name": "Navarro",
                        "latitude": "-35.02457590",
                        "longitude": "-59.77633880"
                    },
                    {
                        "id": 154399,
                        "name": "Necochea",
                        "latitude": "-38.17378930",
                        "longitude": "-59.80770580"
                    },
                    {
                        "id": 154400,
                        "name": "Nueve de Julio",
                        "latitude": "-35.45690360",
                        "longitude": "-60.92393850"
                    },
                    {
                        "id": 154401,
                        "name": "Olavarría",
                        "latitude": "-36.85692910",
                        "longitude": "-61.37189000"
                    },
                    {
                        "id": 154402,
                        "name": "Patagones",
                        "latitude": "-40.17288440",
                        "longitude": "-64.09569830"
                    },
                    {
                        "id": 154403,
                        "name": "Pehuajó",
                        "latitude": "-35.90670570",
                        "longitude": "-62.59308720"
                    },
                    {
                        "id": 154404,
                        "name": "Pellegrini",
                        "latitude": "-36.24270170",
                        "longitude": "-63.82182700"
                    },
                    {
                        "id": 154405,
                        "name": "Pergamino",
                        "latitude": "-33.85555800",
                        "longitude": "-61.20026950"
                    },
                    {
                        "id": 154406,
                        "name": "Pila",
                        "latitude": "-36.21422440",
                        "longitude": "-59.05999650"
                    },
                    {
                        "id": 154407,
                        "name": "Pilar",
                        "latitude": "-34.44243960",
                        "longitude": "-59.06160640"
                    },
                    {
                        "id": 154408,
                        "name": "Pinamar",
                        "latitude": "-37.10658290",
                        "longitude": "-57.03470380"
                    },
                    {
                        "id": 154409,
                        "name": "Presidente Perón",
                        "latitude": "-34.94225680",
                        "longitude": "-58.46566260"
                    },
                    {
                        "id": 154410,
                        "name": "Puan",
                        "latitude": "-38.09189020",
                        "longitude": "-64.30307990"
                    },
                    {
                        "id": 154411,
                        "name": "Punta Indio",
                        "latitude": "-35.45569760",
                        "longitude": "-57.79169470"
                    },
                    {
                        "id": 154412,
                        "name": "Quilmes",
                        "latitude": "-34.73973430",
                        "longitude": "-58.35320560"
                    },
                    {
                        "id": 154413,
                        "name": "Ramallo",
                        "latitude": "-33.58813140",
                        "longitude": "-60.38975740"
                    },
                    {
                        "id": 154414,
                        "name": "Rauch",
                        "latitude": "-36.59916740",
                        "longitude": "-59.55774850"
                    },
                    {
                        "id": 154415,
                        "name": "Rivadavia",
                        "latitude": "-35.57782590",
                        "longitude": "-63.66436280"
                    },
                    {
                        "id": 154416,
                        "name": "Rojas",
                        "latitude": "-34.19513250",
                        "longitude": "-61.12565120"
                    },
                    {
                        "id": 154417,
                        "name": "Roque Pérez",
                        "latitude": "-35.52006040",
                        "longitude": "-59.74705690"
                    },
                    {
                        "id": 154418,
                        "name": "Saavedra",
                        "latitude": "-37.73956430",
                        "longitude": "-63.12959180"
                    },
                    {
                        "id": 154419,
                        "name": "Saladillo",
                        "latitude": "-35.67906870",
                        "longitude": "-60.35942330"
                    },
                    {
                        "id": 154420,
                        "name": "Salliqueló",
                        "latitude": "-36.67026330",
                        "longitude": "-63.37763790"
                    },
                    {
                        "id": 154421,
                        "name": "Salto",
                        "latitude": "-34.24698560",
                        "longitude": "-60.61305280"
                    },
                    {
                        "id": 154422,
                        "name": "San Andrés de Giles",
                        "latitude": "-34.42586240",
                        "longitude": "-59.81017060"
                    },
                    {
                        "id": 154423,
                        "name": "San Antonio de Areco",
                        "latitude": "-34.20590450",
                        "longitude": "-59.85355590"
                    },
                    {
                        "id": 154424,
                        "name": "San Cayetano",
                        "latitude": "-38.40262680",
                        "longitude": "-60.27756580"
                    },
                    {
                        "id": 154425,
                        "name": "San Fernando",
                        "latitude": "-34.24511400",
                        "longitude": "-58.90071950"
                    },
                    {
                        "id": 154426,
                        "name": "San Isidro",
                        "latitude": "-34.48659380",
                        "longitude": "-58.62225340"
                    },
                    {
                        "id": 154427,
                        "name": "San Miguel",
                        "latitude": "-34.55334190",
                        "longitude": "-58.77405090"
                    },
                    {
                        "id": 154428,
                        "name": "San Nicolás",
                        "latitude": "-33.47155080",
                        "longitude": "-60.63886600"
                    },
                    {
                        "id": 154429,
                        "name": "San Pedro",
                        "latitude": "-33.79559030",
                        "longitude": "-60.11056980"
                    },
                    {
                        "id": 154430,
                        "name": "San Vicente",
                        "latitude": "-35.08097070",
                        "longitude": "-58.74801840"
                    },
                    {
                        "id": 154431,
                        "name": "Suipacha",
                        "latitude": "-34.73712310",
                        "longitude": "-60.03526020"
                    },
                    {
                        "id": 154432,
                        "name": "Tandil",
                        "latitude": "-37.33286290",
                        "longitude": "-59.85479050"
                    },
                    {
                        "id": 154433,
                        "name": "Tapalqué",
                        "latitude": "-36.36637830",
                        "longitude": "-60.81551140"
                    },
                    {
                        "id": 154434,
                        "name": "Tigre",
                        "latitude": "-34.40017610",
                        "longitude": "-58.75939520"
                    },
                    {
                        "id": 154435,
                        "name": "Tordillo",
                        "latitude": "-36.41238410",
                        "longitude": "-57.57341650"
                    },
                    {
                        "id": 154436,
                        "name": "Tornquist",
                        "latitude": "-38.26024950",
                        "longitude": "-62.95775910"
                    },
                    {
                        "id": 154437,
                        "name": "Trenque Lauquen",
                        "latitude": "-36.05316630",
                        "longitude": "-63.30255910"
                    },
                    {
                        "id": 154438,
                        "name": "Tres Arroyos",
                        "latitude": "-38.46994170",
                        "longitude": "-60.84561550"
                    },
                    {
                        "id": 154439,
                        "name": "Tres de Febrero",
                        "latitude": "-34.59999320",
                        "longitude": "-58.66706300"
                    },
                    {
                        "id": 154440,
                        "name": "Tres Lomas",
                        "latitude": "-36.48938820",
                        "longitude": "-63.19723280"
                    },
                    {
                        "id": 154441,
                        "name": "Veinticinco de Mayo",
                        "latitude": "-35.55138480",
                        "longitude": "-60.84646650"
                    },
                    {
                        "id": 154442,
                        "name": "Vicente López",
                        "latitude": "-34.52931400",
                        "longitude": "-58.58906610"
                    },
                    {
                        "id": 154443,
                        "name": "Villa Gesell",
                        "latitude": "-37.36616190",
                        "longitude": "-57.38978580"
                    },
                    {
                        "id": 154444,
                        "name": "Villarino",
                        "latitude": "-39.14254170",
                        "longitude": "-64.01619890"
                    },
                    {
                        "id": 154445,
                        "name": "Zárate",
                        "latitude": "-34.00225010",
                        "longitude": "-59.42188710"
                    }
                ]
            },
            {
                "id": 3647,
                "name": "Catamarca",
                "iso2": "K",
                "latitude": "-28.47158770",
                "longitude": "-65.78772090",
                "type": "province",
                "cities": [
                    {
                        "id": 659,
                        "name": "Ancasti",
                        "latitude": "-28.81247000",
                        "longitude": "-65.50145000"
                    },
                    {
                        "id": 661,
                        "name": "Andalgalá",
                        "latitude": "-27.58185000",
                        "longitude": "-66.31626000"
                    },
                    {
                        "id": 663,
                        "name": "Antofagasta de la Sierra",
                        "latitude": "-26.05940000",
                        "longitude": "-67.40636000"
                    },
                    {
                        "id": 726,
                        "name": "Capayán",
                        "latitude": "-28.77436000",
                        "longitude": "-66.04749000"
                    },
                    {
                        "id": 824,
                        "name": "Departamento de Ambato",
                        "latitude": "-28.00000000",
                        "longitude": "-65.91667000"
                    },
                    {
                        "id": 825,
                        "name": "Departamento de Ancasti",
                        "latitude": "-29.00000000",
                        "longitude": "-65.50000000"
                    },
                    {
                        "id": 826,
                        "name": "Departamento de Andalgalá",
                        "latitude": "-27.58333000",
                        "longitude": "-66.46667000"
                    },
                    {
                        "id": 829,
                        "name": "Departamento de Antofagasta de la Sierra",
                        "latitude": "-26.00000000",
                        "longitude": "-67.58333000"
                    },
                    {
                        "id": 846,
                        "name": "Departamento de Capayán",
                        "latitude": "-28.83333000",
                        "longitude": "-66.00000000"
                    },
                    {
                        "id": 849,
                        "name": "Departamento de Capital",
                        "latitude": "-28.41667000",
                        "longitude": "-65.80000000"
                    },
                    {
                        "id": 877,
                        "name": "Departamento de El Alto",
                        "latitude": "-28.41667000",
                        "longitude": "-65.41667000"
                    },
                    {
                        "id": 884,
                        "name": "Departamento de Fray Mamerto Esquiú",
                        "latitude": "-28.30000000",
                        "longitude": "-65.75000000"
                    },
                    {
                        "id": 918,
                        "name": "Departamento de La Paz",
                        "latitude": "-29.25000000",
                        "longitude": "-65.25000000"
                    },
                    {
                        "id": 959,
                        "name": "Departamento de Pomán",
                        "latitude": "-28.25000000",
                        "longitude": "-66.41667000"
                    },
                    {
                        "id": 1006,
                        "name": "Departamento de Santa María",
                        "latitude": "-26.66667000",
                        "longitude": "-66.41667000"
                    },
                    {
                        "id": 1007,
                        "name": "Departamento de Santa Rosa",
                        "latitude": "-28.08333000",
                        "longitude": "-65.25000000"
                    },
                    {
                        "id": 1020,
                        "name": "Departamento de Tinogasta",
                        "latitude": "-27.50000000",
                        "longitude": "-68.00000000"
                    },
                    {
                        "id": 1030,
                        "name": "Departamento de Valle Viejo",
                        "latitude": "-28.58333000",
                        "longitude": "-65.75000000"
                    },
                    {
                        "id": 1060,
                        "name": "El Rodeo",
                        "latitude": "-28.21518000",
                        "longitude": "-65.87420000"
                    },
                    {
                        "id": 1078,
                        "name": "Fiambalá",
                        "latitude": "-27.67225000",
                        "longitude": "-67.61870000"
                    },
                    {
                        "id": 1142,
                        "name": "Hualfín",
                        "latitude": "-27.22896000",
                        "longitude": "-66.83131000"
                    },
                    {
                        "id": 1145,
                        "name": "Huillapima",
                        "latitude": "-28.72533000",
                        "longitude": "-65.97870000"
                    },
                    {
                        "id": 1149,
                        "name": "Icaño",
                        "latitude": "-28.91934000",
                        "longitude": "-65.32817000"
                    },
                    {
                        "id": 1197,
                        "name": "La Puerta de San José",
                        "latitude": "-27.55000000",
                        "longitude": "-67.01667000"
                    },
                    {
                        "id": 1239,
                        "name": "Londres",
                        "latitude": "-27.71439000",
                        "longitude": "-67.13349000"
                    },
                    {
                        "id": 1243,
                        "name": "Los Altos",
                        "latitude": "-28.04845000",
                        "longitude": "-65.49945000"
                    },
                    {
                        "id": 1256,
                        "name": "Los Varela",
                        "latitude": "-27.93003000",
                        "longitude": "-65.87153000"
                    },
                    {
                        "id": 1294,
                        "name": "Mutquín",
                        "latitude": "-28.32104000",
                        "longitude": "-66.14253000"
                    },
                    {
                        "id": 1340,
                        "name": "Pomán",
                        "latitude": "-28.39455000",
                        "longitude": "-66.22052000"
                    },
                    {
                        "id": 1350,
                        "name": "Puerta de Corral Quemado",
                        "latitude": "-27.23000000",
                        "longitude": "-66.93635000"
                    },
                    {
                        "id": 1378,
                        "name": "Recreo",
                        "latitude": "-29.28184000",
                        "longitude": "-65.06096000"
                    },
                    {
                        "id": 1408,
                        "name": "San Antonio",
                        "latitude": "-28.01009000",
                        "longitude": "-65.70874000"
                    },
                    {
                        "id": 1421,
                        "name": "San Fernando del Valle de Catamarca",
                        "latitude": "-28.46957000",
                        "longitude": "-65.78524000"
                    },
                    {
                        "id": 1464,
                        "name": "Santa María",
                        "latitude": "-26.69547000",
                        "longitude": "-66.04732000"
                    },
                    {
                        "id": 1505,
                        "name": "Tinogasta",
                        "latitude": "-28.06319000",
                        "longitude": "-67.56488000"
                    }
                ]
            },
            {
                "id": 3640,
                "name": "Chaco",
                "iso2": "H",
                "latitude": "-27.42571750",
                "longitude": "-59.02437840",
                "type": "province",
                "cities": [
                    {
                        "id": 677,
                        "name": "Aviá Terai",
                        "latitude": "-26.68532000",
                        "longitude": "-60.72920000"
                    },
                    {
                        "id": 685,
                        "name": "Barranqueras",
                        "latitude": "-27.48132000",
                        "longitude": "-58.93925000"
                    },
                    {
                        "id": 686,
                        "name": "Basail",
                        "latitude": "-27.88539000",
                        "longitude": "-59.28245000"
                    },
                    {
                        "id": 719,
                        "name": "Campo Largo",
                        "latitude": "-26.80077000",
                        "longitude": "-60.84215000"
                    },
                    {
                        "id": 730,
                        "name": "Capitán Solari",
                        "latitude": "-26.80215000",
                        "longitude": "-59.56089000"
                    },
                    {
                        "id": 737,
                        "name": "Castelli",
                        "latitude": "-25.94679000",
                        "longitude": "-60.61947000"
                    },
                    {
                        "id": 753,
                        "name": "Charadai",
                        "latitude": "-27.65503000",
                        "longitude": "-59.86291000"
                    },
                    {
                        "id": 754,
                        "name": "Charata",
                        "latitude": "-27.21438000",
                        "longitude": "-61.18795000"
                    },
                    {
                        "id": 765,
                        "name": "Chorotis",
                        "latitude": "-27.91578000",
                        "longitude": "-61.39982000"
                    },
                    {
                        "id": 767,
                        "name": "Ciervo Petiso",
                        "latitude": "-26.58041000",
                        "longitude": "-59.63094000"
                    },
                    {
                        "id": 776,
                        "name": "Colonia Benítez",
                        "latitude": "-27.33099000",
                        "longitude": "-58.94622000"
                    },
                    {
                        "id": 778,
                        "name": "Colonia Elisa",
                        "latitude": "-26.93041000",
                        "longitude": "-59.51861000"
                    },
                    {
                        "id": 782,
                        "name": "Colonias Unidas",
                        "latitude": "-26.69825000",
                        "longitude": "-59.63154000"
                    },
                    {
                        "id": 791,
                        "name": "Concepción del Bermejo",
                        "latitude": "-26.59926000",
                        "longitude": "-60.94617000"
                    },
                    {
                        "id": 799,
                        "name": "Coronel Du Graty",
                        "latitude": "-27.68038000",
                        "longitude": "-60.91462000"
                    },
                    {
                        "id": 804,
                        "name": "Corzuela",
                        "latitude": "-26.95374000",
                        "longitude": "-60.96928000"
                    },
                    {
                        "id": 807,
                        "name": "Coté-Lai",
                        "latitude": "-27.50000000",
                        "longitude": "-59.60000000"
                    },
                    {
                        "id": 822,
                        "name": "Departamento de Almirante Brown",
                        "latitude": "-25.81662000",
                        "longitude": "-61.45576000"
                    },
                    {
                        "id": 837,
                        "name": "Departamento de Bermejo",
                        "latitude": "-27.00000000",
                        "longitude": "-58.66667000"
                    },
                    {
                        "id": 865,
                        "name": "Departamento de Comandante Fernández",
                        "latitude": "-26.83333000",
                        "longitude": "-60.50000000"
                    },
                    {
                        "id": 875,
                        "name": "Departamento de Doce de Octubre",
                        "latitude": "-27.41667000",
                        "longitude": "-61.33333000"
                    },
                    {
                        "id": 876,
                        "name": "Departamento de Dos de Abril",
                        "latitude": "-27.60932000",
                        "longitude": "-61.34473000"
                    },
                    {
                        "id": 890,
                        "name": "Departamento de General Donovan",
                        "latitude": "-27.16667000",
                        "longitude": "-59.33333000"
                    },
                    {
                        "id": 892,
                        "name": "Departamento de General Güemes",
                        "latitude": "-25.16667000",
                        "longitude": "-61.41667000"
                    },
                    {
                        "id": 909,
                        "name": "Departamento de Independencia",
                        "latitude": "-26.66667000",
                        "longitude": "-60.66667000"
                    },
                    {
                        "id": 928,
                        "name": "Departamento de Libertad",
                        "latitude": "-27.33333000",
                        "longitude": "-59.33333000"
                    },
                    {
                        "id": 937,
                        "name": "Departamento de Maipú",
                        "latitude": "-26.33333000",
                        "longitude": "-60.41667000"
                    },
                    {
                        "id": 950,
                        "name": "Departamento de Nueve de Julio",
                        "latitude": "-26.95331000",
                        "longitude": "-61.27627000"
                    },
                    {
                        "id": 954,
                        "name": "Departamento de O’Higgins",
                        "latitude": "-27.25000000",
                        "longitude": "-60.66667000"
                    },
                    {
                        "id": 960,
                        "name": "Departamento de Presidencia de la Plaza",
                        "latitude": "-27.00000000",
                        "longitude": "-59.75000000"
                    },
                    {
                        "id": 962,
                        "name": "Departamento de Quitilipi",
                        "latitude": "-26.66667000",
                        "longitude": "-60.16667000"
                    },
                    {
                        "id": 986,
                        "name": "Departamento de San Fernando",
                        "latitude": "-27.66667000",
                        "longitude": "-59.16667000"
                    },
                    {
                        "id": 994,
                        "name": "Departamento de San Lorenzo",
                        "latitude": "-27.33333000",
                        "longitude": "-60.41667000"
                    },
                    {
                        "id": 1010,
                        "name": "Departamento de Sargento Cabral",
                        "latitude": "-26.83333000",
                        "longitude": "-59.50000000"
                    },
                    {
                        "id": 1017,
                        "name": "Departamento de Tapenagá",
                        "latitude": "-27.50000000",
                        "longitude": "-59.75000000"
                    },
                    {
                        "id": 1081,
                        "name": "Fontana",
                        "latitude": "-27.41813000",
                        "longitude": "-59.02392000"
                    },
                    {
                        "id": 1088,
                        "name": "Gancedo",
                        "latitude": "-27.49038000",
                        "longitude": "-61.67571000"
                    },
                    {
                        "id": 1105,
                        "name": "General José de San Martín",
                        "latitude": "-26.53743000",
                        "longitude": "-59.34158000"
                    },
                    {
                        "id": 1109,
                        "name": "General Pinedo",
                        "latitude": "-27.31667000",
                        "longitude": "-61.28333000"
                    },
                    {
                        "id": 1114,
                        "name": "General Vedia",
                        "latitude": "-26.93382000",
                        "longitude": "-58.66040000"
                    },
                    {
                        "id": 1135,
                        "name": "Hermoso Campo",
                        "latitude": "-27.60816000",
                        "longitude": "-61.34441000"
                    },
                    {
                        "id": 1181,
                        "name": "La Clotilde",
                        "latitude": "-27.13333000",
                        "longitude": "-60.66667000"
                    },
                    {
                        "id": 1186,
                        "name": "La Eduvigis",
                        "latitude": "-26.83607000",
                        "longitude": "-59.06211000"
                    },
                    {
                        "id": 1187,
                        "name": "La Escondida",
                        "latitude": "-27.10724000",
                        "longitude": "-59.44784000"
                    },
                    {
                        "id": 1191,
                        "name": "La Leonesa",
                        "latitude": "-27.03786000",
                        "longitude": "-58.70347000"
                    },
                    {
                        "id": 1201,
                        "name": "La Tigra",
                        "latitude": "-27.10996000",
                        "longitude": "-60.58719000"
                    },
                    {
                        "id": 1203,
                        "name": "La Verde",
                        "latitude": "-27.12634000",
                        "longitude": "-59.37352000"
                    },
                    {
                        "id": 1208,
                        "name": "Laguna Limpia",
                        "latitude": "-26.49565000",
                        "longitude": "-59.68083000"
                    },
                    {
                        "id": 1213,
                        "name": "Lapachito",
                        "latitude": "-27.15997000",
                        "longitude": "-59.38605000"
                    },
                    {
                        "id": 1216,
                        "name": "Las Breñas",
                        "latitude": "-27.08966000",
                        "longitude": "-61.08161000"
                    },
                    {
                        "id": 1218,
                        "name": "Las Garcitas",
                        "latitude": "-26.61802000",
                        "longitude": "-59.80135000"
                    },
                    {
                        "id": 1249,
                        "name": "Los Frentones",
                        "latitude": "-26.40770000",
                        "longitude": "-61.41367000"
                    },
                    {
                        "id": 1260,
                        "name": "Machagai",
                        "latitude": "-26.92614000",
                        "longitude": "-60.04955000"
                    },
                    {
                        "id": 1264,
                        "name": "Makallé",
                        "latitude": "-27.20687000",
                        "longitude": "-59.28696000"
                    },
                    {
                        "id": 1270,
                        "name": "Margarita Belén",
                        "latitude": "-27.26160000",
                        "longitude": "-58.97219000"
                    },
                    {
                        "id": 1296,
                        "name": "Napenay",
                        "latitude": "-26.73333000",
                        "longitude": "-60.61667000"
                    },
                    {
                        "id": 1314,
                        "name": "Pampa Almirón",
                        "latitude": "-26.70039000",
                        "longitude": "-59.12331000"
                    },
                    {
                        "id": 1316,
                        "name": "Pampa del Indio",
                        "latitude": "-26.04982000",
                        "longitude": "-59.93728000"
                    },
                    {
                        "id": 1317,
                        "name": "Pampa del Infierno",
                        "latitude": "-26.50517000",
                        "longitude": "-61.17436000"
                    },
                    {
                        "id": 1347,
                        "name": "Presidencia de la Plaza",
                        "latitude": "-27.00147000",
                        "longitude": "-59.84243000"
                    },
                    {
                        "id": 1345,
                        "name": "Presidencia Roca",
                        "latitude": "-26.14090000",
                        "longitude": "-59.59541000"
                    },
                    {
                        "id": 1346,
                        "name": "Presidencia Roque Sáenz Peña",
                        "latitude": "-26.78522000",
                        "longitude": "-60.43876000"
                    },
                    {
                        "id": 1351,
                        "name": "Puerto Bermejo",
                        "latitude": "-26.92739000",
                        "longitude": "-58.50917000"
                    },
                    {
                        "id": 1363,
                        "name": "Puerto Tirol",
                        "latitude": "-27.37218000",
                        "longitude": "-59.08206000"
                    },
                    {
                        "id": 1364,
                        "name": "Puerto Vilelas",
                        "latitude": "-27.51414000",
                        "longitude": "-58.93906000"
                    },
                    {
                        "id": 1370,
                        "name": "Quitilipi",
                        "latitude": "-26.86913000",
                        "longitude": "-60.21683000"
                    },
                    {
                        "id": 1379,
                        "name": "Resistencia",
                        "latitude": "-27.46056000",
                        "longitude": "-58.98389000"
                    },
                    {
                        "id": 1405,
                        "name": "Samuhú",
                        "latitude": "-27.52116000",
                        "longitude": "-60.39167000"
                    },
                    {
                        "id": 1414,
                        "name": "San Bernardo",
                        "latitude": "-27.28782000",
                        "longitude": "-60.71252000"
                    },
                    {
                        "id": 1471,
                        "name": "Santa Sylvina",
                        "latitude": "-27.83261000",
                        "longitude": "-61.13747000"
                    },
                    {
                        "id": 1493,
                        "name": "Taco Pozo",
                        "latitude": "-25.61557000",
                        "longitude": "-63.26708000"
                    },
                    {
                        "id": 1515,
                        "name": "Tres Isletas",
                        "latitude": "-26.34067000",
                        "longitude": "-60.43207000"
                    },
                    {
                        "id": 1586,
                        "name": "Villa Ángela",
                        "latitude": "-27.57383000",
                        "longitude": "-60.71526000"
                    },
                    {
                        "id": 1542,
                        "name": "Villa Berthet",
                        "latitude": "-27.29174000",
                        "longitude": "-60.41263000"
                    }
                ]
            },
            {
                "id": 3651,
                "name": "Chubut",
                "iso2": "U",
                "latitude": "-43.29342460",
                "longitude": "-65.11148180",
                "type": "province",
                "cities": [
                    {
                        "id": 655,
                        "name": "Alto Río Senguer",
                        "latitude": "-45.04105000",
                        "longitude": "-70.81982000"
                    },
                    {
                        "id": 715,
                        "name": "Camarones",
                        "latitude": "-44.79709000",
                        "longitude": "-65.70994000"
                    },
                    {
                        "id": 787,
                        "name": "Comodoro Rivadavia",
                        "latitude": "-45.86413000",
                        "longitude": "-67.49656000"
                    },
                    {
                        "id": 839,
                        "name": "Departamento de Biedma",
                        "latitude": "-42.41667000",
                        "longitude": "-65.00000000"
                    },
                    {
                        "id": 873,
                        "name": "Departamento de Cushamen",
                        "latitude": "-42.50000000",
                        "longitude": "-70.83333000"
                    },
                    {
                        "id": 880,
                        "name": "Departamento de Escalante",
                        "latitude": "-45.33333000",
                        "longitude": "-67.33333000"
                    },
                    {
                        "id": 883,
                        "name": "Departamento de Florentino Ameghino",
                        "latitude": "-44.41667000",
                        "longitude": "-66.16667000"
                    },
                    {
                        "id": 885,
                        "name": "Departamento de Futaleufú",
                        "latitude": "-43.08333000",
                        "longitude": "-71.41667000"
                    },
                    {
                        "id": 886,
                        "name": "Departamento de Gaimán",
                        "latitude": "-43.33333000",
                        "longitude": "-66.33333000"
                    },
                    {
                        "id": 887,
                        "name": "Departamento de Gastre",
                        "latitude": "-42.83333000",
                        "longitude": "-68.66667000"
                    },
                    {
                        "id": 923,
                        "name": "Departamento de Languiñeo",
                        "latitude": "-43.33333000",
                        "longitude": "-70.66667000"
                    },
                    {
                        "id": 949,
                        "name": "Departamento de Mártires",
                        "latitude": "-43.83333000",
                        "longitude": "-67.16667000"
                    },
                    {
                        "id": 956,
                        "name": "Departamento de Paso de Indios",
                        "latitude": "-44.00000000",
                        "longitude": "-68.83333000"
                    },
                    {
                        "id": 963,
                        "name": "Departamento de Rawson",
                        "latitude": "-43.12342000",
                        "longitude": "-65.10179000"
                    },
                    {
                        "id": 979,
                        "name": "Departamento de Río Senguerr",
                        "latitude": "-45.33333000",
                        "longitude": "-70.83333000"
                    },
                    {
                        "id": 1012,
                        "name": "Departamento de Sarmiento",
                        "latitude": "-45.33333000",
                        "longitude": "-69.00000000"
                    },
                    {
                        "id": 1018,
                        "name": "Departamento de Tehuelches",
                        "latitude": "-44.22132000",
                        "longitude": "-70.25260000"
                    },
                    {
                        "id": 1019,
                        "name": "Departamento de Telsen",
                        "latitude": "-42.41667000",
                        "longitude": "-67.16667000"
                    },
                    {
                        "id": 1042,
                        "name": "Dolavón",
                        "latitude": "-43.30684000",
                        "longitude": "-65.70651000"
                    },
                    {
                        "id": 1058,
                        "name": "El Maitén",
                        "latitude": "-42.04924000",
                        "longitude": "-71.16693000"
                    },
                    {
                        "id": 1070,
                        "name": "Esquel",
                        "latitude": "-42.91147000",
                        "longitude": "-71.31947000"
                    },
                    {
                        "id": 1087,
                        "name": "Gaimán",
                        "latitude": "-43.28970000",
                        "longitude": "-65.49290000"
                    },
                    {
                        "id": 1092,
                        "name": "Gastre",
                        "latitude": "-42.26186000",
                        "longitude": "-69.22112000"
                    },
                    {
                        "id": 1115,
                        "name": "Gobernador Costa",
                        "latitude": "-44.04992000",
                        "longitude": "-70.59798000"
                    },
                    {
                        "id": 1141,
                        "name": "Hoyo de Epuyén",
                        "latitude": "-42.07189000",
                        "longitude": "-71.50811000"
                    },
                    {
                        "id": 1169,
                        "name": "José de San Martín",
                        "latitude": "-44.05032000",
                        "longitude": "-70.46967000"
                    },
                    {
                        "id": 1206,
                        "name": "Lago Puelo",
                        "latitude": "-42.06684000",
                        "longitude": "-71.60384000"
                    },
                    {
                        "id": 1229,
                        "name": "Las Plumas",
                        "latitude": "-43.72058000",
                        "longitude": "-67.28319000"
                    },
                    {
                        "id": 1359,
                        "name": "Puerto Madryn",
                        "latitude": "-42.76920000",
                        "longitude": "-65.03851000"
                    },
                    {
                        "id": 1371,
                        "name": "Rada Tilly",
                        "latitude": "-45.92462000",
                        "longitude": "-67.55424000"
                    },
                    {
                        "id": 1374,
                        "name": "Rawson",
                        "latitude": "-43.30016000",
                        "longitude": "-65.10228000"
                    },
                    {
                        "id": 1393,
                        "name": "Río Mayo",
                        "latitude": "-45.68573000",
                        "longitude": "-70.25797000"
                    },
                    {
                        "id": 1394,
                        "name": "Río Pico",
                        "latitude": "-44.17905000",
                        "longitude": "-71.36847000"
                    },
                    {
                        "id": 1477,
                        "name": "Sarmiento",
                        "latitude": "-45.58815000",
                        "longitude": "-69.06996000"
                    },
                    {
                        "id": 1499,
                        "name": "Tecka",
                        "latitude": "-43.49489000",
                        "longitude": "-70.81020000"
                    },
                    {
                        "id": 1512,
                        "name": "Trelew",
                        "latitude": "-43.24895000",
                        "longitude": "-65.30505000"
                    },
                    {
                        "id": 1516,
                        "name": "Trevelin",
                        "latitude": "-43.08580000",
                        "longitude": "-71.46386000"
                    }
                ]
            },
            {
                "id": 3642,
                "name": "Córdoba",
                "iso2": "X",
                "latitude": "-31.39928760",
                "longitude": "-64.26438420",
                "type": "province",
                "cities": [
                    {
                        "id": 639,
                        "name": "Achiras",
                        "latitude": "-33.17538000",
                        "longitude": "-64.99331000"
                    },
                    {
                        "id": 640,
                        "name": "Adelia María",
                        "latitude": "-33.63152000",
                        "longitude": "-64.02097000"
                    },
                    {
                        "id": 641,
                        "name": "Agua de Oro",
                        "latitude": "-31.06661000",
                        "longitude": "-64.30017000"
                    },
                    {
                        "id": 647,
                        "name": "Alejandro Roca",
                        "latitude": "-33.35369000",
                        "longitude": "-63.71849000"
                    },
                    {
                        "id": 648,
                        "name": "Alejo Ledesma",
                        "latitude": "-33.60643000",
                        "longitude": "-62.62304000"
                    },
                    {
                        "id": 651,
                        "name": "Almafuerte",
                        "latitude": "-32.19296000",
                        "longitude": "-64.25559000"
                    },
                    {
                        "id": 653,
                        "name": "Alta Gracia",
                        "latitude": "-31.65292000",
                        "longitude": "-64.42826000"
                    },
                    {
                        "id": 656,
                        "name": "Altos de Chipión",
                        "latitude": "-30.95590000",
                        "longitude": "-62.33727000"
                    },
                    {
                        "id": 668,
                        "name": "Arias",
                        "latitude": "-33.64411000",
                        "longitude": "-62.40272000"
                    },
                    {
                        "id": 671,
                        "name": "Arroyito",
                        "latitude": "-31.42022000",
                        "longitude": "-63.05002000"
                    },
                    {
                        "id": 672,
                        "name": "Arroyo Cabral",
                        "latitude": "-32.49119000",
                        "longitude": "-63.40126000"
                    },
                    {
                        "id": 681,
                        "name": "Balnearia",
                        "latitude": "-31.00880000",
                        "longitude": "-62.66733000"
                    },
                    {
                        "id": 688,
                        "name": "Bell Ville",
                        "latitude": "-32.62591000",
                        "longitude": "-62.68873000"
                    },
                    {
                        "id": 695,
                        "name": "Berrotarán",
                        "latitude": "-32.45100000",
                        "longitude": "-64.38867000"
                    },
                    {
                        "id": 701,
                        "name": "Brinkmann",
                        "latitude": "-30.86589000",
                        "longitude": "-62.03742000"
                    },
                    {
                        "id": 702,
                        "name": "Buchardo",
                        "latitude": "-34.72263000",
                        "longitude": "-63.50920000"
                    },
                    {
                        "id": 716,
                        "name": "Camilo Aldao",
                        "latitude": "-33.12745000",
                        "longitude": "-62.09453000"
                    },
                    {
                        "id": 744,
                        "name": "Cañada de Luque",
                        "latitude": "-30.73341000",
                        "longitude": "-63.72375000"
                    },
                    {
                        "id": 723,
                        "name": "Canals",
                        "latitude": "-33.56542000",
                        "longitude": "-62.88927000"
                    },
                    {
                        "id": 727,
                        "name": "Capilla del Monte",
                        "latitude": "-30.86088000",
                        "longitude": "-64.52515000"
                    },
                    {
                        "id": 733,
                        "name": "Carnerillo",
                        "latitude": "-32.91371000",
                        "longitude": "-64.02175000"
                    },
                    {
                        "id": 734,
                        "name": "Carrilobo",
                        "latitude": "-31.87296000",
                        "longitude": "-63.11715000"
                    },
                    {
                        "id": 742,
                        "name": "Cavanagh",
                        "latitude": "-33.47606000",
                        "longitude": "-62.33888000"
                    },
                    {
                        "id": 755,
                        "name": "Charras",
                        "latitude": "-33.02400000",
                        "longitude": "-64.04719000"
                    },
                    {
                        "id": 757,
                        "name": "Chazón",
                        "latitude": "-33.07872000",
                        "longitude": "-63.27657000"
                    },
                    {
                        "id": 769,
                        "name": "Cintra",
                        "latitude": "-32.30673000",
                        "longitude": "-62.65214000"
                    },
                    {
                        "id": 780,
                        "name": "Colonia La Tordilla",
                        "latitude": "-31.23746000",
                        "longitude": "-63.06134000"
                    },
                    {
                        "id": 781,
                        "name": "Colonia San Bartolomé",
                        "latitude": "-31.52780000",
                        "longitude": "-62.72436000"
                    },
                    {
                        "id": 815,
                        "name": "Córdoba",
                        "latitude": "-31.41350000",
                        "longitude": "-64.18105000"
                    },
                    {
                        "id": 797,
                        "name": "Coronel Baigorria",
                        "latitude": "-32.84770000",
                        "longitude": "-64.36107000"
                    },
                    {
                        "id": 800,
                        "name": "Coronel Moldes",
                        "latitude": "-33.62270000",
                        "longitude": "-64.59711000"
                    },
                    {
                        "id": 801,
                        "name": "Corral de Bustos",
                        "latitude": "-33.28205000",
                        "longitude": "-62.18463000"
                    },
                    {
                        "id": 802,
                        "name": "Corralito",
                        "latitude": "-32.02462000",
                        "longitude": "-64.19216000"
                    },
                    {
                        "id": 805,
                        "name": "Cosquín",
                        "latitude": "-31.24508000",
                        "longitude": "-64.46563000"
                    },
                    {
                        "id": 806,
                        "name": "Costa Sacate",
                        "latitude": "-31.64770000",
                        "longitude": "-63.75935000"
                    },
                    {
                        "id": 809,
                        "name": "Cruz Alta",
                        "latitude": "-33.00887000",
                        "longitude": "-61.80746000"
                    },
                    {
                        "id": 811,
                        "name": "Cruz del Eje",
                        "latitude": "-30.72644000",
                        "longitude": "-64.80387000"
                    },
                    {
                        "id": 812,
                        "name": "Cuesta Blanca",
                        "latitude": "-31.48658000",
                        "longitude": "-64.57150000"
                    },
                    {
                        "id": 816,
                        "name": "Dalmacio Vélez Sársfield",
                        "latitude": "-32.61072000",
                        "longitude": "-63.58038000"
                    },
                    {
                        "id": 1039,
                        "name": "Deán Funes",
                        "latitude": "-30.42036000",
                        "longitude": "-64.34984000"
                    },
                    {
                        "id": 818,
                        "name": "Del Campillo",
                        "latitude": "-34.37659000",
                        "longitude": "-64.49504000"
                    },
                    {
                        "id": 842,
                        "name": "Departamento de Calamuchita",
                        "latitude": "-32.25000000",
                        "longitude": "-64.58333000"
                    },
                    {
                        "id": 864,
                        "name": "Departamento de Colón",
                        "latitude": "-31.16667000",
                        "longitude": "-64.16667000"
                    },
                    {
                        "id": 871,
                        "name": "Departamento de Cruz del Eje",
                        "latitude": "-30.75000000",
                        "longitude": "-65.00000000"
                    },
                    {
                        "id": 896,
                        "name": "Departamento de General Roca",
                        "latitude": "-34.66667000",
                        "longitude": "-64.25000000"
                    },
                    {
                        "id": 897,
                        "name": "Departamento de General San Martín",
                        "latitude": "-32.50000000",
                        "longitude": "-63.33333000"
                    },
                    {
                        "id": 914,
                        "name": "Departamento de Juárez Celman",
                        "latitude": "-33.33333000",
                        "longitude": "-63.66667000"
                    },
                    {
                        "id": 939,
                        "name": "Departamento de Marcos Juárez",
                        "latitude": "-33.00000000",
                        "longitude": "-62.25000000"
                    },
                    {
                        "id": 943,
                        "name": "Departamento de Minas",
                        "latitude": "-31.00000000",
                        "longitude": "-65.33333000"
                    },
                    {
                        "id": 961,
                        "name": "Departamento de Presidente Roque Sáenz Peña",
                        "latitude": "-34.25000000",
                        "longitude": "-63.50000000"
                    },
                    {
                        "id": 974,
                        "name": "Departamento de Río Cuarto",
                        "latitude": "-33.33333000",
                        "longitude": "-64.50000000"
                    },
                    {
                        "id": 976,
                        "name": "Departamento de Río Primero",
                        "latitude": "-31.08333000",
                        "longitude": "-63.50000000"
                    },
                    {
                        "id": 977,
                        "name": "Departamento de Río Seco",
                        "latitude": "-30.08333000",
                        "longitude": "-63.00000000"
                    },
                    {
                        "id": 978,
                        "name": "Departamento de Río Segundo",
                        "latitude": "-31.75000000",
                        "longitude": "-63.50000000"
                    },
                    {
                        "id": 981,
                        "name": "Departamento de San Alberto",
                        "latitude": "-31.75000000",
                        "longitude": "-65.25000000"
                    },
                    {
                        "id": 990,
                        "name": "Departamento de San Javier",
                        "latitude": "-32.08333000",
                        "longitude": "-65.16667000"
                    },
                    {
                        "id": 991,
                        "name": "Departamento de San Justo",
                        "latitude": "-31.33333000",
                        "longitude": "-62.66667000"
                    },
                    {
                        "id": 1016,
                        "name": "Departamento de Sobremonte",
                        "latitude": "-29.66667000",
                        "longitude": "-64.08333000"
                    },
                    {
                        "id": 1022,
                        "name": "Departamento de Totoral",
                        "latitude": "-30.83333000",
                        "longitude": "-63.91667000"
                    },
                    {
                        "id": 1024,
                        "name": "Departamento de Tulumba",
                        "latitude": "-30.25000000",
                        "longitude": "-63.91667000"
                    },
                    {
                        "id": 1029,
                        "name": "Departamento de Unión",
                        "latitude": "-32.83333000",
                        "longitude": "-62.75000000"
                    },
                    {
                        "id": 1037,
                        "name": "Despeñaderos",
                        "latitude": "-31.81626000",
                        "longitude": "-64.28989000"
                    },
                    {
                        "id": 1038,
                        "name": "Devoto",
                        "latitude": "-31.40431000",
                        "longitude": "-62.30634000"
                    },
                    {
                        "id": 1049,
                        "name": "El Arañado",
                        "latitude": "-31.74120000",
                        "longitude": "-62.89322000"
                    },
                    {
                        "id": 1063,
                        "name": "El Tío",
                        "latitude": "-31.38357000",
                        "longitude": "-62.82938000"
                    },
                    {
                        "id": 1064,
                        "name": "Elena",
                        "latitude": "-32.57205000",
                        "longitude": "-64.39481000"
                    },
                    {
                        "id": 1066,
                        "name": "Embalse",
                        "latitude": "-32.18000000",
                        "longitude": "-64.41809000"
                    },
                    {
                        "id": 1073,
                        "name": "Etruria",
                        "latitude": "-32.94008000",
                        "longitude": "-63.24660000"
                    },
                    {
                        "id": 1096,
                        "name": "General Baldissera",
                        "latitude": "-33.12246000",
                        "longitude": "-62.30630000"
                    },
                    {
                        "id": 1097,
                        "name": "General Cabrera",
                        "latitude": "-32.81313000",
                        "longitude": "-63.87243000"
                    },
                    {
                        "id": 1106,
                        "name": "General Levalle",
                        "latitude": "-34.01472000",
                        "longitude": "-63.92413000"
                    },
                    {
                        "id": 1111,
                        "name": "General Roca",
                        "latitude": "-32.73196000",
                        "longitude": "-61.91599000"
                    },
                    {
                        "id": 1129,
                        "name": "Guatimozín",
                        "latitude": "-33.46149000",
                        "longitude": "-62.43844000"
                    },
                    {
                        "id": 1136,
                        "name": "Hernando",
                        "latitude": "-32.42657000",
                        "longitude": "-63.73333000"
                    },
                    {
                        "id": 1143,
                        "name": "Huanchillas",
                        "latitude": "-33.66653000",
                        "longitude": "-63.63701000"
                    },
                    {
                        "id": 1144,
                        "name": "Huerta Grande",
                        "latitude": "-31.07524000",
                        "longitude": "-64.49063000"
                    },
                    {
                        "id": 1146,
                        "name": "Huinca Renancó",
                        "latitude": "-34.84038000",
                        "longitude": "-64.37580000"
                    },
                    {
                        "id": 1150,
                        "name": "Idiazábal",
                        "latitude": "-32.81411000",
                        "longitude": "-63.03252000"
                    },
                    {
                        "id": 1156,
                        "name": "Inriville",
                        "latitude": "-32.94424000",
                        "longitude": "-62.23028000"
                    },
                    {
                        "id": 1159,
                        "name": "Isla Verde",
                        "latitude": "-33.24104000",
                        "longitude": "-62.40297000"
                    },
                    {
                        "id": 1160,
                        "name": "Italó",
                        "latitude": "-34.79237000",
                        "longitude": "-63.78199000"
                    },
                    {
                        "id": 1165,
                        "name": "James Craik",
                        "latitude": "-32.16120000",
                        "longitude": "-63.46688000"
                    },
                    {
                        "id": 1167,
                        "name": "Jesús María",
                        "latitude": "-30.98153000",
                        "longitude": "-64.09424000"
                    },
                    {
                        "id": 1173,
                        "name": "Justiniano Posse",
                        "latitude": "-32.88411000",
                        "longitude": "-62.67788000"
                    },
                    {
                        "id": 1178,
                        "name": "La Calera",
                        "latitude": "-31.34377000",
                        "longitude": "-64.33529000"
                    },
                    {
                        "id": 1179,
                        "name": "La Carlota",
                        "latitude": "-33.41993000",
                        "longitude": "-63.29769000"
                    },
                    {
                        "id": 1180,
                        "name": "La Cesira",
                        "latitude": "-33.95115000",
                        "longitude": "-62.97238000"
                    },
                    {
                        "id": 1185,
                        "name": "La Cumbre",
                        "latitude": "-30.98201000",
                        "longitude": "-64.49139000"
                    },
                    {
                        "id": 1188,
                        "name": "La Falda",
                        "latitude": "-31.08841000",
                        "longitude": "-64.48987000"
                    },
                    {
                        "id": 1189,
                        "name": "La Francia",
                        "latitude": "-31.40675000",
                        "longitude": "-62.63396000"
                    },
                    {
                        "id": 1190,
                        "name": "La Granja",
                        "latitude": "-31.00919000",
                        "longitude": "-64.26869000"
                    },
                    {
                        "id": 1194,
                        "name": "La Para",
                        "latitude": "-30.89416000",
                        "longitude": "-63.00107000"
                    },
                    {
                        "id": 1196,
                        "name": "La Playosa",
                        "latitude": "-32.10002000",
                        "longitude": "-63.03088000"
                    },
                    {
                        "id": 1204,
                        "name": "Laborde",
                        "latitude": "-33.15319000",
                        "longitude": "-62.85661000"
                    },
                    {
                        "id": 1205,
                        "name": "Laboulaye",
                        "latitude": "-34.12662000",
                        "longitude": "-63.39119000"
                    },
                    {
                        "id": 1207,
                        "name": "Laguna Larga",
                        "latitude": "-31.77652000",
                        "longitude": "-63.80104000"
                    },
                    {
                        "id": 1215,
                        "name": "Las Acequias",
                        "latitude": "-33.28155000",
                        "longitude": "-63.97610000"
                    },
                    {
                        "id": 1221,
                        "name": "Las Higueras",
                        "latitude": "-33.09231000",
                        "longitude": "-64.28899000"
                    },
                    {
                        "id": 1222,
                        "name": "Las Junturas",
                        "latitude": "-31.83125000",
                        "longitude": "-63.45016000"
                    },
                    {
                        "id": 1228,
                        "name": "Las Perdices",
                        "latitude": "-32.69794000",
                        "longitude": "-63.70634000"
                    },
                    {
                        "id": 1232,
                        "name": "Las Varas",
                        "latitude": "-31.80260000",
                        "longitude": "-62.61655000"
                    },
                    {
                        "id": 1233,
                        "name": "Las Varillas",
                        "latitude": "-31.87208000",
                        "longitude": "-62.71946000"
                    },
                    {
                        "id": 1234,
                        "name": "Leones",
                        "latitude": "-32.66174000",
                        "longitude": "-62.29678000"
                    },
                    {
                        "id": 1246,
                        "name": "Los Cocos",
                        "latitude": "-30.92497000",
                        "longitude": "-64.50207000"
                    },
                    {
                        "id": 1248,
                        "name": "Los Cóndores",
                        "latitude": "-32.31983000",
                        "longitude": "-64.27751000"
                    },
                    {
                        "id": 1254,
                        "name": "Los Surgentes",
                        "latitude": "-32.98454000",
                        "longitude": "-62.02191000"
                    },
                    {
                        "id": 1266,
                        "name": "Malagueño",
                        "latitude": "-31.46467000",
                        "longitude": "-64.35840000"
                    },
                    {
                        "id": 1267,
                        "name": "Malvinas Argentinas",
                        "latitude": "-31.38194000",
                        "longitude": "-64.05545000"
                    },
                    {
                        "id": 1269,
                        "name": "Marcos Juárez",
                        "latitude": "-32.69780000",
                        "longitude": "-62.10672000"
                    },
                    {
                        "id": 1273,
                        "name": "Marull",
                        "latitude": "-30.99471000",
                        "longitude": "-62.82576000"
                    },
                    {
                        "id": 1274,
                        "name": "Mattaldi",
                        "latitude": "-34.48194000",
                        "longitude": "-64.17255000"
                    },
                    {
                        "id": 1277,
                        "name": "Mendiolaza",
                        "latitude": "-31.26738000",
                        "longitude": "-64.30087000"
                    },
                    {
                        "id": 1282,
                        "name": "Mina Clavero",
                        "latitude": "-31.72101000",
                        "longitude": "-65.00619000"
                    },
                    {
                        "id": 1283,
                        "name": "Miramar",
                        "latitude": "-30.91859000",
                        "longitude": "-62.67814000"
                    },
                    {
                        "id": 1286,
                        "name": "Monte Buey",
                        "latitude": "-32.91642000",
                        "longitude": "-62.45669000"
                    },
                    {
                        "id": 1288,
                        "name": "Monte Cristo",
                        "latitude": "-31.34312000",
                        "longitude": "-63.94437000"
                    },
                    {
                        "id": 1289,
                        "name": "Monte Maíz",
                        "latitude": "-33.20462000",
                        "longitude": "-62.60085000"
                    },
                    {
                        "id": 1292,
                        "name": "Morrison",
                        "latitude": "-32.59480000",
                        "longitude": "-62.83455000"
                    },
                    {
                        "id": 1293,
                        "name": "Morteros",
                        "latitude": "-30.71164000",
                        "longitude": "-61.99862000"
                    },
                    {
                        "id": 1299,
                        "name": "Noetinger",
                        "latitude": "-32.36597000",
                        "longitude": "-62.31126000"
                    },
                    {
                        "id": 1305,
                        "name": "Obispo Trejo",
                        "latitude": "-30.78128000",
                        "longitude": "-63.41349000"
                    },
                    {
                        "id": 1306,
                        "name": "Oliva",
                        "latitude": "-32.04158000",
                        "longitude": "-63.56978000"
                    },
                    {
                        "id": 1307,
                        "name": "Oncativo",
                        "latitude": "-31.91353000",
                        "longitude": "-63.68201000"
                    },
                    {
                        "id": 1308,
                        "name": "Ordóñez",
                        "latitude": "-32.84057000",
                        "longitude": "-62.86552000"
                    },
                    {
                        "id": 1321,
                        "name": "Pascanas",
                        "latitude": "-33.12550000",
                        "longitude": "-63.04084000"
                    },
                    {
                        "id": 1322,
                        "name": "Pasco",
                        "latitude": "-32.74733000",
                        "longitude": "-63.34232000"
                    },
                    {
                        "id": 1333,
                        "name": "Pilar",
                        "latitude": "-31.67890000",
                        "longitude": "-63.87964000"
                    },
                    {
                        "id": 1335,
                        "name": "Piquillín",
                        "latitude": "-31.30158000",
                        "longitude": "-63.75788000"
                    },
                    {
                        "id": 1341,
                        "name": "Porteña",
                        "latitude": "-31.01391000",
                        "longitude": "-62.06650000"
                    },
                    {
                        "id": 1343,
                        "name": "Pozo del Molle",
                        "latitude": "-32.01860000",
                        "longitude": "-62.91984000"
                    },
                    {
                        "id": 1368,
                        "name": "Quilino",
                        "latitude": "-30.21397000",
                        "longitude": "-64.50063000"
                    },
                    {
                        "id": 1388,
                        "name": "Río Ceballos",
                        "latitude": "-31.16486000",
                        "longitude": "-64.32241000"
                    },
                    {
                        "id": 1390,
                        "name": "Río Cuarto",
                        "latitude": "-33.13067000",
                        "longitude": "-64.34992000"
                    },
                    {
                        "id": 1395,
                        "name": "Río Segundo",
                        "latitude": "-31.65260000",
                        "longitude": "-63.90990000"
                    },
                    {
                        "id": 1396,
                        "name": "Río Tercero",
                        "latitude": "-32.17301000",
                        "longitude": "-64.11405000"
                    },
                    {
                        "id": 1398,
                        "name": "Sacanta",
                        "latitude": "-31.66300000",
                        "longitude": "-63.04505000"
                    },
                    {
                        "id": 1400,
                        "name": "Saldán",
                        "latitude": "-31.30262000",
                        "longitude": "-64.30700000"
                    },
                    {
                        "id": 1401,
                        "name": "Salsacate",
                        "latitude": "-31.31842000",
                        "longitude": "-65.09003000"
                    },
                    {
                        "id": 1402,
                        "name": "Salsipuedes",
                        "latitude": "-31.13725000",
                        "longitude": "-64.29589000"
                    },
                    {
                        "id": 1404,
                        "name": "Sampacho",
                        "latitude": "-33.38390000",
                        "longitude": "-64.72211000"
                    },
                    {
                        "id": 1406,
                        "name": "San Agustín",
                        "latitude": "-31.97681000",
                        "longitude": "-64.37400000"
                    },
                    {
                        "id": 1410,
                        "name": "San Antonio de Litín",
                        "latitude": "-32.21377000",
                        "longitude": "-62.63237000"
                    },
                    {
                        "id": 1412,
                        "name": "San Basilio",
                        "latitude": "-33.49763000",
                        "longitude": "-64.31495000"
                    },
                    {
                        "id": 1415,
                        "name": "San Carlos",
                        "latitude": "-31.17761000",
                        "longitude": "-65.10245000"
                    },
                    {
                        "id": 1422,
                        "name": "San Francisco",
                        "latitude": "-31.42797000",
                        "longitude": "-62.08266000"
                    },
                    {
                        "id": 1424,
                        "name": "San Francisco del Chañar",
                        "latitude": "-29.78830000",
                        "longitude": "-63.94411000"
                    },
                    {
                        "id": 1432,
                        "name": "San José de la Dormida",
                        "latitude": "-30.35440000",
                        "longitude": "-63.94871000"
                    },
                    {
                        "id": 1457,
                        "name": "Santa Eufemia",
                        "latitude": "-33.17659000",
                        "longitude": "-63.28281000"
                    },
                    {
                        "id": 1462,
                        "name": "Santa Magdalena",
                        "latitude": "-34.51776000",
                        "longitude": "-63.94409000"
                    },
                    {
                        "id": 1467,
                        "name": "Santa Rosa de Calamuchita",
                        "latitude": "-32.06905000",
                        "longitude": "-64.53631000"
                    },
                    {
                        "id": 1468,
                        "name": "Santa Rosa de Río Primero",
                        "latitude": "-31.15231000",
                        "longitude": "-63.40191000"
                    },
                    {
                        "id": 1472,
                        "name": "Santiago Temple",
                        "latitude": "-31.38731000",
                        "longitude": "-63.41821000"
                    },
                    {
                        "id": 1479,
                        "name": "Saturnino M. Laspiur",
                        "latitude": "-31.70287000",
                        "longitude": "-62.48202000"
                    },
                    {
                        "id": 1481,
                        "name": "Sebastián Elcano",
                        "latitude": "-30.16105000",
                        "longitude": "-63.59360000"
                    },
                    {
                        "id": 1484,
                        "name": "Serrano",
                        "latitude": "-34.46971000",
                        "longitude": "-63.53842000"
                    },
                    {
                        "id": 1485,
                        "name": "Serrezuela",
                        "latitude": "-30.63761000",
                        "longitude": "-65.38692000"
                    },
                    {
                        "id": 1497,
                        "name": "Tancacha",
                        "latitude": "-32.24309000",
                        "longitude": "-63.98070000"
                    },
                    {
                        "id": 1502,
                        "name": "Ticino",
                        "latitude": "-32.69350000",
                        "longitude": "-63.43606000"
                    },
                    {
                        "id": 1517,
                        "name": "Tío Pujio",
                        "latitude": "-32.28790000",
                        "longitude": "-63.35598000"
                    },
                    {
                        "id": 1507,
                        "name": "Toledo",
                        "latitude": "-31.55574000",
                        "longitude": "-64.00947000"
                    },
                    {
                        "id": 1519,
                        "name": "Ucacha",
                        "latitude": "-33.03203000",
                        "longitude": "-63.50666000"
                    },
                    {
                        "id": 1521,
                        "name": "Unquillo",
                        "latitude": "-31.23073000",
                        "longitude": "-64.31615000"
                    },
                    {
                        "id": 1526,
                        "name": "Valle Hermoso",
                        "latitude": "-31.11732000",
                        "longitude": "-64.48084000"
                    },
                    {
                        "id": 1532,
                        "name": "Viamonte",
                        "latitude": "-33.74647000",
                        "longitude": "-63.09764000"
                    },
                    {
                        "id": 1535,
                        "name": "Vicuña Mackenna",
                        "latitude": "-33.91965000",
                        "longitude": "-64.39215000"
                    },
                    {
                        "id": 1537,
                        "name": "Villa Allende",
                        "latitude": "-31.29458000",
                        "longitude": "-64.29538000"
                    },
                    {
                        "id": 1538,
                        "name": "Villa Ascasubi",
                        "latitude": "-32.16351000",
                        "longitude": "-63.89157000"
                    },
                    {
                        "id": 1541,
                        "name": "Villa Berna",
                        "latitude": "-31.91419000",
                        "longitude": "-64.73249000"
                    },
                    {
                        "id": 1544,
                        "name": "Villa Carlos Paz",
                        "latitude": "-31.42414000",
                        "longitude": "-64.49778000"
                    },
                    {
                        "id": 1546,
                        "name": "Villa Concepción del Tío",
                        "latitude": "-31.32259000",
                        "longitude": "-62.81354000"
                    },
                    {
                        "id": 1548,
                        "name": "Villa Cura Brochero",
                        "latitude": "-31.70578000",
                        "longitude": "-65.01796000"
                    },
                    {
                        "id": 1581,
                        "name": "Villa de Soto",
                        "latitude": "-30.85523000",
                        "longitude": "-64.99947000"
                    },
                    {
                        "id": 1582,
                        "name": "Villa del Dique",
                        "latitude": "-32.17667000",
                        "longitude": "-64.45543000"
                    },
                    {
                        "id": 1583,
                        "name": "Villa del Rosario",
                        "latitude": "-31.55660000",
                        "longitude": "-63.53452000"
                    },
                    {
                        "id": 1585,
                        "name": "Villa del Totoral",
                        "latitude": "-30.81667000",
                        "longitude": "-63.71667000"
                    },
                    {
                        "id": 1549,
                        "name": "Villa Dolores",
                        "latitude": "-31.94585000",
                        "longitude": "-65.18958000"
                    },
                    {
                        "id": 1552,
                        "name": "Villa General Belgrano",
                        "latitude": "-31.97828000",
                        "longitude": "-64.55627000"
                    },
                    {
                        "id": 1556,
                        "name": "Villa Giardino",
                        "latitude": "-31.03333000",
                        "longitude": "-64.48333000"
                    },
                    {
                        "id": 1558,
                        "name": "Villa Huidobro",
                        "latitude": "-34.83826000",
                        "longitude": "-64.58686000"
                    },
                    {
                        "id": 1560,
                        "name": "Villa Las Rosas",
                        "latitude": "-31.95021000",
                        "longitude": "-65.05354000"
                    },
                    {
                        "id": 1563,
                        "name": "Villa María",
                        "latitude": "-32.40751000",
                        "longitude": "-63.24016000"
                    },
                    {
                        "id": 1567,
                        "name": "Villa Nueva",
                        "latitude": "-32.43293000",
                        "longitude": "-63.24763000"
                    },
                    {
                        "id": 1573,
                        "name": "Villa Reducción",
                        "latitude": "-33.20105000",
                        "longitude": "-63.86234000"
                    },
                    {
                        "id": 1575,
                        "name": "Villa Rumipal",
                        "latitude": "-32.18790000",
                        "longitude": "-64.48027000"
                    },
                    {
                        "id": 1578,
                        "name": "Villa Tulumba",
                        "latitude": "-30.39552000",
                        "longitude": "-64.12241000"
                    },
                    {
                        "id": 1580,
                        "name": "Villa Valeria",
                        "latitude": "-34.34093000",
                        "longitude": "-64.92030000"
                    },
                    {
                        "id": 1591,
                        "name": "Wenceslao Escalante",
                        "latitude": "-33.17303000",
                        "longitude": "-62.77078000"
                    }
                ]
            },
            {
                "id": 3638,
                "name": "Corrientes",
                "iso2": "W",
                "latitude": "-27.46921310",
                "longitude": "-58.83063490",
                "type": "province",
                "cities": [
                    {
                        "id": 658,
                        "name": "Alvear",
                        "latitude": "-29.09683000",
                        "longitude": "-56.55043000"
                    },
                    {
                        "id": 696,
                        "name": "Berón de Astrada",
                        "latitude": "-27.55067000",
                        "longitude": "-57.53460000"
                    },
                    {
                        "id": 698,
                        "name": "Bonpland",
                        "latitude": "-29.81708000",
                        "longitude": "-57.42974000"
                    },
                    {
                        "id": 756,
                        "name": "Chavarría",
                        "latitude": "-28.95489000",
                        "longitude": "-58.57277000"
                    },
                    {
                        "id": 789,
                        "name": "Concepción",
                        "latitude": "-28.39175000",
                        "longitude": "-57.88777000"
                    },
                    {
                        "id": 803,
                        "name": "Corrientes",
                        "latitude": "-27.46784000",
                        "longitude": "-58.83440000"
                    },
                    {
                        "id": 810,
                        "name": "Cruz de los Milagros",
                        "latitude": "-28.83646000",
                        "longitude": "-59.00476000"
                    },
                    {
                        "id": 813,
                        "name": "Curuzú Cuatiá",
                        "latitude": "-29.79171000",
                        "longitude": "-58.05460000"
                    },
                    {
                        "id": 836,
                        "name": "Departamento de Bella Vista",
                        "latitude": "-28.50000000",
                        "longitude": "-58.83333000"
                    },
                    {
                        "id": 838,
                        "name": "Departamento de Berón de Astrada",
                        "latitude": "-27.50000000",
                        "longitude": "-57.66667000"
                    },
                    {
                        "id": 847,
                        "name": "Departamento de Capital",
                        "latitude": "-27.50000000",
                        "longitude": "-58.75000000"
                    },
                    {
                        "id": 866,
                        "name": "Departamento de Concepción",
                        "latitude": "-28.33333000",
                        "longitude": "-58.00000000"
                    },
                    {
                        "id": 872,
                        "name": "Departamento de Curuzú Cuatiá",
                        "latitude": "-29.50000000",
                        "longitude": "-58.50000000"
                    },
                    {
                        "id": 879,
                        "name": "Departamento de Empedrado",
                        "latitude": "-27.83333000",
                        "longitude": "-58.66667000"
                    },
                    {
                        "id": 881,
                        "name": "Departamento de Esquina",
                        "latitude": "-30.00000000",
                        "longitude": "-59.33333000"
                    },
                    {
                        "id": 888,
                        "name": "Departamento de General Alvear",
                        "latitude": "-28.83333000",
                        "longitude": "-56.50000000"
                    },
                    {
                        "id": 895,
                        "name": "Departamento de General Paz",
                        "latitude": "-27.75000000",
                        "longitude": "-57.83333000"
                    },
                    {
                        "id": 899,
                        "name": "Departamento de Goya",
                        "latitude": "-29.50000000",
                        "longitude": "-59.50000000"
                    },
                    {
                        "id": 912,
                        "name": "Departamento de Itatí",
                        "latitude": "-27.33333000",
                        "longitude": "-58.00000000"
                    },
                    {
                        "id": 913,
                        "name": "Departamento de Ituzaingó",
                        "latitude": "-27.90085000",
                        "longitude": "-56.86604000"
                    },
                    {
                        "id": 925,
                        "name": "Departamento de Lavalle",
                        "latitude": "-29.00000000",
                        "longitude": "-58.91667000"
                    },
                    {
                        "id": 940,
                        "name": "Departamento de Mburucuyá",
                        "latitude": "-28.00000000",
                        "longitude": "-58.25000000"
                    },
                    {
                        "id": 941,
                        "name": "Departamento de Mercedes",
                        "latitude": "-29.00000000",
                        "longitude": "-57.83333000"
                    },
                    {
                        "id": 945,
                        "name": "Departamento de Monte Caseros",
                        "latitude": "-30.25000000",
                        "longitude": "-57.83333000"
                    },
                    {
                        "id": 957,
                        "name": "Departamento de Paso de los Libres",
                        "latitude": "-29.66667000",
                        "longitude": "-57.25000000"
                    },
                    {
                        "id": 980,
                        "name": "Departamento de Saladas",
                        "latitude": "-28.25000000",
                        "longitude": "-58.75000000"
                    },
                    {
                        "id": 984,
                        "name": "Departamento de San Cosme",
                        "latitude": "-27.33333000",
                        "longitude": "-58.50000000"
                    },
                    {
                        "id": 995,
                        "name": "Departamento de San Luis del Palmar",
                        "latitude": "-27.50000000",
                        "longitude": "-58.25000000"
                    },
                    {
                        "id": 996,
                        "name": "Departamento de San Martín",
                        "latitude": "-28.83333000",
                        "longitude": "-56.91667000"
                    },
                    {
                        "id": 1001,
                        "name": "Departamento de San Miguel",
                        "latitude": "-27.91667000",
                        "longitude": "-57.50000000"
                    },
                    {
                        "id": 1004,
                        "name": "Departamento de San Roque",
                        "latitude": "-28.66667000",
                        "longitude": "-58.75000000"
                    },
                    {
                        "id": 1009,
                        "name": "Departamento de Santo Tomé",
                        "latitude": "-28.25000000",
                        "longitude": "-56.25000000"
                    },
                    {
                        "id": 1014,
                        "name": "Departamento de Sauce",
                        "latitude": "-30.00000000",
                        "longitude": "-58.66667000"
                    },
                    {
                        "id": 1068,
                        "name": "Empedrado",
                        "latitude": "-27.95178000",
                        "longitude": "-58.80584000"
                    },
                    {
                        "id": 1071,
                        "name": "Esquina",
                        "latitude": "-30.01476000",
                        "longitude": "-59.52890000"
                    },
                    {
                        "id": 1077,
                        "name": "Felipe Yofré",
                        "latitude": "-29.10226000",
                        "longitude": "-58.33772000"
                    },
                    {
                        "id": 1089,
                        "name": "Garruchos",
                        "latitude": "-28.17208000",
                        "longitude": "-55.65406000"
                    },
                    {
                        "id": 1118,
                        "name": "Gobernador Juan E. Martínez",
                        "latitude": "-28.91161000",
                        "longitude": "-58.93594000"
                    },
                    {
                        "id": 1121,
                        "name": "Gobernador Virasora",
                        "latitude": "-28.05000000",
                        "longitude": "-56.03333000"
                    },
                    {
                        "id": 1123,
                        "name": "Goya",
                        "latitude": "-29.13995000",
                        "longitude": "-59.26343000"
                    },
                    {
                        "id": 1134,
                        "name": "Herlitzka",
                        "latitude": "-27.56516000",
                        "longitude": "-58.25557000"
                    },
                    {
                        "id": 1163,
                        "name": "Itá Ibaté",
                        "latitude": "-27.42573000",
                        "longitude": "-57.33758000"
                    },
                    {
                        "id": 1161,
                        "name": "Itatí",
                        "latitude": "-27.27043000",
                        "longitude": "-58.24458000"
                    },
                    {
                        "id": 1162,
                        "name": "Ituzaingó",
                        "latitude": "-27.58162000",
                        "longitude": "-56.68231000"
                    },
                    {
                        "id": 1171,
                        "name": "Juan Pujol",
                        "latitude": "-30.41873000",
                        "longitude": "-57.85612000"
                    },
                    {
                        "id": 1184,
                        "name": "La Cruz",
                        "latitude": "-29.17443000",
                        "longitude": "-56.64326000"
                    },
                    {
                        "id": 1235,
                        "name": "Libertad",
                        "latitude": "-30.04300000",
                        "longitude": "-57.82020000"
                    },
                    {
                        "id": 1237,
                        "name": "Lomas de Vallejos",
                        "latitude": "-27.73501000",
                        "longitude": "-57.91850000"
                    },
                    {
                        "id": 1242,
                        "name": "Loreto",
                        "latitude": "-27.76834000",
                        "longitude": "-57.27531000"
                    },
                    {
                        "id": 1271,
                        "name": "Mariano I. Loza",
                        "latitude": "-29.37667000",
                        "longitude": "-58.19436000"
                    },
                    {
                        "id": 1275,
                        "name": "Mburucuyá",
                        "latitude": "-28.04532000",
                        "longitude": "-58.22835000"
                    },
                    {
                        "id": 1279,
                        "name": "Mercedes",
                        "latitude": "-29.18416000",
                        "longitude": "-58.07519000"
                    },
                    {
                        "id": 1284,
                        "name": "Mocoretá",
                        "latitude": "-30.61891000",
                        "longitude": "-57.96344000"
                    },
                    {
                        "id": 1287,
                        "name": "Monte Caseros",
                        "latitude": "-30.25359000",
                        "longitude": "-57.63626000"
                    },
                    {
                        "id": 1301,
                        "name": "Nuestra Señora del Rosario de Caa Catí",
                        "latitude": "-27.75072000",
                        "longitude": "-57.62073000"
                    },
                    {
                        "id": 1303,
                        "name": "Nueve de Julio",
                        "latitude": "-28.84051000",
                        "longitude": "-58.82650000"
                    },
                    {
                        "id": 1311,
                        "name": "Palmar Grande",
                        "latitude": "-27.94195000",
                        "longitude": "-57.90057000"
                    },
                    {
                        "id": 1323,
                        "name": "Paso de la Patria",
                        "latitude": "-27.31676000",
                        "longitude": "-58.57197000"
                    },
                    {
                        "id": 1324,
                        "name": "Paso de los Libres",
                        "latitude": "-29.71251000",
                        "longitude": "-57.08771000"
                    },
                    {
                        "id": 1325,
                        "name": "Pedro R. Fernández",
                        "latitude": "-28.75097000",
                        "longitude": "-58.65583000"
                    },
                    {
                        "id": 1327,
                        "name": "Perugorría",
                        "latitude": "-29.34132000",
                        "longitude": "-58.61059000"
                    },
                    {
                        "id": 1349,
                        "name": "Pueblo Libertador",
                        "latitude": "-30.22087000",
                        "longitude": "-59.38981000"
                    },
                    {
                        "id": 1382,
                        "name": "Riachuelo",
                        "latitude": "-27.58191000",
                        "longitude": "-58.74497000"
                    },
                    {
                        "id": 1399,
                        "name": "Saladas",
                        "latitude": "-28.25384000",
                        "longitude": "-58.62591000"
                    },
                    {
                        "id": 1416,
                        "name": "San Carlos",
                        "latitude": "-27.74586000",
                        "longitude": "-55.89731000"
                    },
                    {
                        "id": 1419,
                        "name": "San Cosme",
                        "latitude": "-27.37123000",
                        "longitude": "-58.51214000"
                    },
                    {
                        "id": 1437,
                        "name": "San Lorenzo",
                        "latitude": "-28.13306000",
                        "longitude": "-58.76733000"
                    },
                    {
                        "id": 1439,
                        "name": "San Luis del Palmar",
                        "latitude": "-27.50790000",
                        "longitude": "-58.55454000"
                    },
                    {
                        "id": 1443,
                        "name": "San Miguel",
                        "latitude": "-27.99585000",
                        "longitude": "-57.58964000"
                    },
                    {
                        "id": 1461,
                        "name": "Santa Lucía",
                        "latitude": "-28.98746000",
                        "longitude": "-59.10287000"
                    },
                    {
                        "id": 1466,
                        "name": "Santa Rosa",
                        "latitude": "-28.26318000",
                        "longitude": "-58.11891000"
                    },
                    {
                        "id": 1476,
                        "name": "Santo Tomé",
                        "latitude": "-28.54939000",
                        "longitude": "-56.04077000"
                    },
                    {
                        "id": 1594,
                        "name": "Yapeyú",
                        "latitude": "-29.46914000",
                        "longitude": "-56.81841000"
                    },
                    {
                        "id": 1595,
                        "name": "Yataity Calle",
                        "latitude": "-29.01913000",
                        "longitude": "-58.90846000"
                    }
                ]
            },
            {
                "id": 3654,
                "name": "Entre Ríos",
                "iso2": "E",
                "latitude": "-31.77466540",
                "longitude": "-60.49564610",
                "type": "province",
                "cities": [
                    {
                        "id": 645,
                        "name": "Aldea San Antonio",
                        "latitude": "-32.62317000",
                        "longitude": "-58.70512000"
                    },
                    {
                        "id": 665,
                        "name": "Aranguren",
                        "latitude": "-32.24252000",
                        "longitude": "-60.16107000"
                    },
                    {
                        "id": 700,
                        "name": "Bovril",
                        "latitude": "-31.34311000",
                        "longitude": "-59.44512000"
                    },
                    {
                        "id": 735,
                        "name": "Caseros",
                        "latitude": "-32.46325000",
                        "longitude": "-58.47872000"
                    },
                    {
                        "id": 745,
                        "name": "Ceibas",
                        "latitude": "-33.43333000",
                        "longitude": "-58.75000000"
                    },
                    {
                        "id": 751,
                        "name": "Chajarí",
                        "latitude": "-30.75048000",
                        "longitude": "-57.97962000"
                    },
                    {
                        "id": 783,
                        "name": "Colón",
                        "latitude": "-32.22312000",
                        "longitude": "-58.14426000"
                    },
                    {
                        "id": 779,
                        "name": "Colonia Elía",
                        "latitude": "-32.67144000",
                        "longitude": "-58.32538000"
                    },
                    {
                        "id": 792,
                        "name": "Concepción del Uruguay",
                        "latitude": "-32.48463000",
                        "longitude": "-58.23217000"
                    },
                    {
                        "id": 793,
                        "name": "Concordia",
                        "latitude": "-31.39296000",
                        "longitude": "-58.02089000"
                    },
                    {
                        "id": 794,
                        "name": "Conscripto Bernardi",
                        "latitude": "-31.04837000",
                        "longitude": "-59.08435000"
                    },
                    {
                        "id": 808,
                        "name": "Crespo",
                        "latitude": "-32.02873000",
                        "longitude": "-60.30658000"
                    },
                    {
                        "id": 902,
                        "name": "Departamento de Gualeguaychú",
                        "latitude": "-33.25000000",
                        "longitude": "-59.00000000"
                    },
                    {
                        "id": 955,
                        "name": "Departamento de Paraná",
                        "latitude": "-31.66667000",
                        "longitude": "-60.00000000"
                    },
                    {
                        "id": 1040,
                        "name": "Diamante",
                        "latitude": "-32.06641000",
                        "longitude": "-60.63837000"
                    },
                    {
                        "id": 1043,
                        "name": "Domínguez",
                        "latitude": "-31.98710000",
                        "longitude": "-58.96197000"
                    },
                    {
                        "id": 1075,
                        "name": "Federación",
                        "latitude": "-31.00621000",
                        "longitude": "-57.89962000"
                    },
                    {
                        "id": 1076,
                        "name": "Federal",
                        "latitude": "-30.95465000",
                        "longitude": "-58.78326000"
                    },
                    {
                        "id": 1098,
                        "name": "General Campos",
                        "latitude": "-31.52311000",
                        "longitude": "-58.40490000"
                    },
                    {
                        "id": 1104,
                        "name": "General Galarza",
                        "latitude": "-32.72034000",
                        "longitude": "-59.39615000"
                    },
                    {
                        "id": 1110,
                        "name": "General Ramírez",
                        "latitude": "-32.17601000",
                        "longitude": "-60.20079000"
                    },
                    {
                        "id": 1119,
                        "name": "Gobernador Mansilla",
                        "latitude": "-32.54453000",
                        "longitude": "-59.35480000"
                    },
                    {
                        "id": 1126,
                        "name": "Gualeguay",
                        "latitude": "-33.14156000",
                        "longitude": "-59.30966000"
                    },
                    {
                        "id": 1127,
                        "name": "Gualeguaychú",
                        "latitude": "-33.00937000",
                        "longitude": "-58.51722000"
                    },
                    {
                        "id": 1132,
                        "name": "Hasenkamp",
                        "latitude": "-31.51226000",
                        "longitude": "-59.83545000"
                    },
                    {
                        "id": 1137,
                        "name": "Hernández",
                        "latitude": "-32.33730000",
                        "longitude": "-60.02160000"
                    },
                    {
                        "id": 1139,
                        "name": "Herrera",
                        "latitude": "-32.43401000",
                        "longitude": "-58.63177000"
                    },
                    {
                        "id": 1183,
                        "name": "La Criolla",
                        "latitude": "-31.26904000",
                        "longitude": "-58.10558000"
                    },
                    {
                        "id": 1195,
                        "name": "La Paz",
                        "latitude": "-30.74179000",
                        "longitude": "-59.64517000"
                    },
                    {
                        "id": 1214,
                        "name": "Larroque",
                        "latitude": "-33.03595000",
                        "longitude": "-59.00125000"
                    },
                    {
                        "id": 1245,
                        "name": "Los Charrúas",
                        "latitude": "-31.17548000",
                        "longitude": "-58.18774000"
                    },
                    {
                        "id": 1247,
                        "name": "Los Conquistadores",
                        "latitude": "-30.59080000",
                        "longitude": "-58.46773000"
                    },
                    {
                        "id": 1257,
                        "name": "Lucas González",
                        "latitude": "-32.38430000",
                        "longitude": "-59.53013000"
                    },
                    {
                        "id": 1261,
                        "name": "Maciá",
                        "latitude": "-32.17220000",
                        "longitude": "-59.39947000"
                    },
                    {
                        "id": 1300,
                        "name": "Nogoyá",
                        "latitude": "-32.39387000",
                        "longitude": "-59.78953000"
                    },
                    {
                        "id": 1309,
                        "name": "Oro Verde",
                        "latitude": "-31.82508000",
                        "longitude": "-60.51749000"
                    },
                    {
                        "id": 1319,
                        "name": "Paraná",
                        "latitude": "-31.73271000",
                        "longitude": "-60.52897000"
                    },
                    {
                        "id": 1332,
                        "name": "Piedras Blancas",
                        "latitude": "-31.18592000",
                        "longitude": "-59.95181000"
                    },
                    {
                        "id": 1348,
                        "name": "Pronunciamiento",
                        "latitude": "-32.34480000",
                        "longitude": "-58.44268000"
                    },
                    {
                        "id": 1355,
                        "name": "Puerto Ibicuy",
                        "latitude": "-33.75305000",
                        "longitude": "-59.17762000"
                    },
                    {
                        "id": 1365,
                        "name": "Puerto Yeruá",
                        "latitude": "-31.53713000",
                        "longitude": "-58.01527000"
                    },
                    {
                        "id": 1385,
                        "name": "Rosario del Tala",
                        "latitude": "-32.30286000",
                        "longitude": "-59.14545000"
                    },
                    {
                        "id": 1413,
                        "name": "San Benito",
                        "latitude": "-31.78371000",
                        "longitude": "-60.44156000"
                    },
                    {
                        "id": 1426,
                        "name": "San Gustavo",
                        "latitude": "-30.68961000",
                        "longitude": "-59.39840000"
                    },
                    {
                        "id": 1430,
                        "name": "San José de Feliciano",
                        "latitude": "-30.38452000",
                        "longitude": "-58.75167000"
                    },
                    {
                        "id": 1435,
                        "name": "San Justo",
                        "latitude": "-32.44654000",
                        "longitude": "-58.43569000"
                    },
                    {
                        "id": 1450,
                        "name": "San Salvador",
                        "latitude": "-31.62487000",
                        "longitude": "-58.50524000"
                    },
                    {
                        "id": 1453,
                        "name": "Santa Ana",
                        "latitude": "-30.90004000",
                        "longitude": "-57.93162000"
                    },
                    {
                        "id": 1454,
                        "name": "Santa Anita",
                        "latitude": "-32.17476000",
                        "longitude": "-58.78622000"
                    },
                    {
                        "id": 1456,
                        "name": "Santa Elena",
                        "latitude": "-30.94432000",
                        "longitude": "-59.78832000"
                    },
                    {
                        "id": 1480,
                        "name": "Sauce de Luna",
                        "latitude": "-31.23794000",
                        "longitude": "-59.21872000"
                    },
                    {
                        "id": 1482,
                        "name": "Seguí",
                        "latitude": "-31.95642000",
                        "longitude": "-60.12488000"
                    },
                    {
                        "id": 1492,
                        "name": "Tabossi",
                        "latitude": "-31.80135000",
                        "longitude": "-59.93477000"
                    },
                    {
                        "id": 1518,
                        "name": "Ubajay",
                        "latitude": "-31.79358000",
                        "longitude": "-58.31350000"
                    },
                    {
                        "id": 1522,
                        "name": "Urdinarrain",
                        "latitude": "-32.68573000",
                        "longitude": "-58.89323000"
                    },
                    {
                        "id": 1531,
                        "name": "Viale",
                        "latitude": "-31.86782000",
                        "longitude": "-60.00722000"
                    },
                    {
                        "id": 1533,
                        "name": "Victoria",
                        "latitude": "-32.61841000",
                        "longitude": "-60.15478000"
                    },
                    {
                        "id": 1584,
                        "name": "Villa del Rosario",
                        "latitude": "-30.79567000",
                        "longitude": "-57.91257000"
                    },
                    {
                        "id": 1550,
                        "name": "Villa Elisa",
                        "latitude": "-32.16320000",
                        "longitude": "-58.40082000"
                    },
                    {
                        "id": 1557,
                        "name": "Villa Hernandarias",
                        "latitude": "-31.23097000",
                        "longitude": "-59.98464000"
                    },
                    {
                        "id": 1562,
                        "name": "Villa Mantero",
                        "latitude": "-32.39727000",
                        "longitude": "-58.74596000"
                    },
                    {
                        "id": 1564,
                        "name": "Villa María Grande",
                        "latitude": "-31.66565000",
                        "longitude": "-59.90182000"
                    },
                    {
                        "id": 1571,
                        "name": "Villa Paranacito",
                        "latitude": "-33.71381000",
                        "longitude": "-58.65844000"
                    },
                    {
                        "id": 1579,
                        "name": "Villa Urquiza",
                        "latitude": "-31.64757000",
                        "longitude": "-60.37516000"
                    },
                    {
                        "id": 1587,
                        "name": "Villaguay",
                        "latitude": "-31.86530000",
                        "longitude": "-59.02689000"
                    }
                ]
            },
            {
                "id": 3652,
                "name": "Formosa",
                "iso2": "P",
                "latitude": "-26.18948040",
                "longitude": "-58.22428060",
                "type": "province",
                "cities": [
                    {
                        "id": 772,
                        "name": "Clorinda",
                        "latitude": "-25.28481000",
                        "longitude": "-57.71851000"
                    },
                    {
                        "id": 785,
                        "name": "Comandante Fontana",
                        "latitude": "-25.33453000",
                        "longitude": "-59.68212000"
                    },
                    {
                        "id": 958,
                        "name": "Departamento de Pilcomayo",
                        "latitude": "-25.50000000",
                        "longitude": "-58.08333000"
                    },
                    {
                        "id": 1053,
                        "name": "El Colorado",
                        "latitude": "-26.30808000",
                        "longitude": "-59.37291000"
                    },
                    {
                        "id": 1072,
                        "name": "Estanislao del Campo",
                        "latitude": "-25.05504000",
                        "longitude": "-60.09218000"
                    },
                    {
                        "id": 1082,
                        "name": "Formosa",
                        "latitude": "-26.18489000",
                        "longitude": "-58.17313000"
                    },
                    {
                        "id": 1102,
                        "name": "General Enrique Mosconi",
                        "latitude": "-23.21667000",
                        "longitude": "-62.30000000"
                    },
                    {
                        "id": 1138,
                        "name": "Herradura",
                        "latitude": "-26.48705000",
                        "longitude": "-58.31198000"
                    },
                    {
                        "id": 1148,
                        "name": "Ibarreta",
                        "latitude": "-25.21438000",
                        "longitude": "-59.85851000"
                    },
                    {
                        "id": 1151,
                        "name": "Ingeniero Guillermo N. Juárez",
                        "latitude": "-23.90000000",
                        "longitude": "-61.85000000"
                    },
                    {
                        "id": 1209,
                        "name": "Laguna Naick-Neck",
                        "latitude": "-25.24769000",
                        "longitude": "-58.09383000"
                    },
                    {
                        "id": 1211,
                        "name": "Laguna Yema",
                        "latitude": "-24.25391000",
                        "longitude": "-61.24466000"
                    },
                    {
                        "id": 1225,
                        "name": "Las Lomitas",
                        "latitude": "-24.70955000",
                        "longitude": "-60.59303000"
                    },
                    {
                        "id": 1312,
                        "name": "Palo Santo",
                        "latitude": "-25.56332000",
                        "longitude": "-59.33781000"
                    },
                    {
                        "id": 1336,
                        "name": "Pirané",
                        "latitude": "-25.73239000",
                        "longitude": "-59.10879000"
                    },
                    {
                        "id": 1344,
                        "name": "Pozo del Tigre",
                        "latitude": "-24.89682000",
                        "longitude": "-60.32359000"
                    },
                    {
                        "id": 1381,
                        "name": "Riacho Eh-Eh",
                        "latitude": "-25.36209000",
                        "longitude": "-58.27750000"
                    },
                    {
                        "id": 1423,
                        "name": "San Francisco de Laishí",
                        "latitude": "-26.24262000",
                        "longitude": "-58.63039000"
                    },
                    {
                        "id": 1551,
                        "name": "Villa Escolar",
                        "latitude": "-26.62209000",
                        "longitude": "-58.67134000"
                    },
                    {
                        "id": 1553,
                        "name": "Villa General Guemes",
                        "latitude": "-24.75530000",
                        "longitude": "-59.48940000"
                    }
                ]
            },
            {
                "id": 3645,
                "name": "Jujuy",
                "iso2": "Y",
                "latitude": "-24.18433970",
                "longitude": "-65.30217700",
                "type": "province",
                "cities": [
                    {
                        "id": 638,
                        "name": "Abra Pampa",
                        "latitude": "-22.72049000",
                        "longitude": "-65.69697000"
                    },
                    {
                        "id": 709,
                        "name": "Caimancito",
                        "latitude": "-23.74069000",
                        "longitude": "-64.59370000"
                    },
                    {
                        "id": 713,
                        "name": "Calilegua",
                        "latitude": "-23.77368000",
                        "longitude": "-64.77002000"
                    },
                    {
                        "id": 862,
                        "name": "Departamento de Cochinoca",
                        "latitude": "-23.00000000",
                        "longitude": "-65.83333000"
                    },
                    {
                        "id": 965,
                        "name": "Departamento de Rinconada",
                        "latitude": "-22.50000000",
                        "longitude": "-66.50000000"
                    },
                    {
                        "id": 1025,
                        "name": "Departamento de Tumbaya",
                        "latitude": "-23.71667000",
                        "longitude": "-65.66667000"
                    },
                    {
                        "id": 1047,
                        "name": "El Aguilar",
                        "latitude": "-23.21572000",
                        "longitude": "-65.68005000"
                    },
                    {
                        "id": 1083,
                        "name": "Fraile Pintado",
                        "latitude": "-23.94079000",
                        "longitude": "-64.79943000"
                    },
                    {
                        "id": 1147,
                        "name": "Humahuaca",
                        "latitude": "-23.20544000",
                        "longitude": "-65.35048000"
                    },
                    {
                        "id": 1155,
                        "name": "Ingenio La Esperanza",
                        "latitude": "-24.22554000",
                        "longitude": "-64.83896000"
                    },
                    {
                        "id": 1193,
                        "name": "La Mendieta",
                        "latitude": "-24.31187000",
                        "longitude": "-64.96377000"
                    },
                    {
                        "id": 1199,
                        "name": "La Quiaca",
                        "latitude": "-22.10236000",
                        "longitude": "-65.59299000"
                    },
                    {
                        "id": 1236,
                        "name": "Libertador General San Martín",
                        "latitude": "-23.80644000",
                        "longitude": "-64.78757000"
                    },
                    {
                        "id": 1262,
                        "name": "Maimará",
                        "latitude": "-23.62392000",
                        "longitude": "-65.40797000"
                    },
                    {
                        "id": 1310,
                        "name": "Palma Sola",
                        "latitude": "-23.97771000",
                        "longitude": "-64.30311000"
                    },
                    {
                        "id": 1313,
                        "name": "Palpalá",
                        "latitude": "-24.25647000",
                        "longitude": "-65.21163000"
                    },
                    {
                        "id": 1447,
                        "name": "San Pedro de Jujuy",
                        "latitude": "-24.23127000",
                        "longitude": "-64.86614000"
                    },
                    {
                        "id": 1451,
                        "name": "San Salvador de Jujuy",
                        "latitude": "-24.19457000",
                        "longitude": "-65.29712000"
                    },
                    {
                        "id": 1455,
                        "name": "Santa Clara",
                        "latitude": "-24.30921000",
                        "longitude": "-64.66253000"
                    },
                    {
                        "id": 1503,
                        "name": "Tilcara",
                        "latitude": "-23.57817000",
                        "longitude": "-65.39516000"
                    },
                    {
                        "id": 1597,
                        "name": "Yuto",
                        "latitude": "-23.64342000",
                        "longitude": "-64.47194000"
                    }
                ]
            },
            {
                "id": 3655,
                "name": "La Pampa",
                "iso2": "L",
                "latitude": "-36.61475730",
                "longitude": "-64.28392090",
                "type": "province",
                "cities": [
                    {
                        "id": 652,
                        "name": "Alpachiri",
                        "latitude": "-37.37704000",
                        "longitude": "-63.77445000"
                    },
                    {
                        "id": 654,
                        "name": "Alta Italia",
                        "latitude": "-35.33350000",
                        "longitude": "-64.11496000"
                    },
                    {
                        "id": 662,
                        "name": "Anguil",
                        "latitude": "-36.52567000",
                        "longitude": "-64.01025000"
                    },
                    {
                        "id": 666,
                        "name": "Arata",
                        "latitude": "-35.63895000",
                        "longitude": "-64.35621000"
                    },
                    {
                        "id": 692,
                        "name": "Bernardo Larroudé",
                        "latitude": "-35.02449000",
                        "longitude": "-63.58253000"
                    },
                    {
                        "id": 694,
                        "name": "Bernasconi",
                        "latitude": "-37.90459000",
                        "longitude": "-63.74240000"
                    },
                    {
                        "id": 712,
                        "name": "Caleufú",
                        "latitude": "-35.59559000",
                        "longitude": "-64.55778000"
                    },
                    {
                        "id": 740,
                        "name": "Catriló",
                        "latitude": "-36.40597000",
                        "longitude": "-63.42168000"
                    },
                    {
                        "id": 775,
                        "name": "Colonia Barón",
                        "latitude": "-36.15152000",
                        "longitude": "-63.85404000"
                    },
                    {
                        "id": 843,
                        "name": "Departamento de Caleu-Caleu",
                        "latitude": "-38.58333000",
                        "longitude": "-64.00000000"
                    },
                    {
                        "id": 1021,
                        "name": "Departamento de Toay",
                        "latitude": "-36.58333000",
                        "longitude": "-64.80000000"
                    },
                    {
                        "id": 1041,
                        "name": "Doblas",
                        "latitude": "-37.14967000",
                        "longitude": "-64.01183000"
                    },
                    {
                        "id": 1046,
                        "name": "Eduardo Castex",
                        "latitude": "-35.91501000",
                        "longitude": "-64.29448000"
                    },
                    {
                        "id": 1065,
                        "name": "Embajador Martini",
                        "latitude": "-35.38633000",
                        "longitude": "-64.28092000"
                    },
                    {
                        "id": 1094,
                        "name": "General Acha",
                        "latitude": "-37.37698000",
                        "longitude": "-64.60431000"
                    },
                    {
                        "id": 1107,
                        "name": "General Manuel J. Campos",
                        "latitude": "-37.46025000",
                        "longitude": "-63.58537000"
                    },
                    {
                        "id": 1108,
                        "name": "General Pico",
                        "latitude": "-35.65662000",
                        "longitude": "-63.75682000"
                    },
                    {
                        "id": 1113,
                        "name": "General San Martín",
                        "latitude": "-37.97904000",
                        "longitude": "-63.60449000"
                    },
                    {
                        "id": 1130,
                        "name": "Guatraché",
                        "latitude": "-37.66776000",
                        "longitude": "-63.53021000"
                    },
                    {
                        "id": 1153,
                        "name": "Ingeniero Luiggi",
                        "latitude": "-35.38585000",
                        "longitude": "-64.46519000"
                    },
                    {
                        "id": 1157,
                        "name": "Intendente Alvear",
                        "latitude": "-35.23383000",
                        "longitude": "-63.59205000"
                    },
                    {
                        "id": 1164,
                        "name": "Jacinto Arauz",
                        "latitude": "-38.08606000",
                        "longitude": "-63.43169000"
                    },
                    {
                        "id": 1175,
                        "name": "La Adela",
                        "latitude": "-38.98333000",
                        "longitude": "-64.08333000"
                    },
                    {
                        "id": 1192,
                        "name": "La Maruja",
                        "latitude": "-35.67360000",
                        "longitude": "-64.93997000"
                    },
                    {
                        "id": 1240,
                        "name": "Lonquimay",
                        "latitude": "-36.46546000",
                        "longitude": "-63.62429000"
                    },
                    {
                        "id": 1259,
                        "name": "Macachín",
                        "latitude": "-37.13598000",
                        "longitude": "-63.66650000"
                    },
                    {
                        "id": 1281,
                        "name": "Miguel Riglos",
                        "latitude": "-36.85398000",
                        "longitude": "-63.68842000"
                    },
                    {
                        "id": 1320,
                        "name": "Parera",
                        "latitude": "-35.14600000",
                        "longitude": "-64.50089000"
                    },
                    {
                        "id": 1367,
                        "name": "Quemú Quemú",
                        "latitude": "-36.05463000",
                        "longitude": "-63.56428000"
                    },
                    {
                        "id": 1373,
                        "name": "Rancul",
                        "latitude": "-35.06862000",
                        "longitude": "-64.68107000"
                    },
                    {
                        "id": 1375,
                        "name": "Realicó",
                        "latitude": "-35.03658000",
                        "longitude": "-64.24470000"
                    },
                    {
                        "id": 1459,
                        "name": "Santa Isabel",
                        "latitude": "-36.22724000",
                        "longitude": "-66.94240000"
                    },
                    {
                        "id": 1465,
                        "name": "Santa Rosa",
                        "latitude": "-36.61667000",
                        "longitude": "-64.28333000"
                    },
                    {
                        "id": 1500,
                        "name": "Telén",
                        "latitude": "-36.26429000",
                        "longitude": "-65.51018000"
                    },
                    {
                        "id": 1513,
                        "name": "Trenel",
                        "latitude": "-35.69837000",
                        "longitude": "-64.13218000"
                    },
                    {
                        "id": 1523,
                        "name": "Uriburu",
                        "latitude": "-36.50682000",
                        "longitude": "-63.86225000"
                    },
                    {
                        "id": 1527,
                        "name": "Veinticinco de Mayo",
                        "latitude": "-37.77410000",
                        "longitude": "-67.71638000"
                    },
                    {
                        "id": 1534,
                        "name": "Victorica",
                        "latitude": "-36.21505000",
                        "longitude": "-65.43586000"
                    },
                    {
                        "id": 1592,
                        "name": "Winifreda",
                        "latitude": "-36.22643000",
                        "longitude": "-64.23388000"
                    }
                ]
            },
            {
                "id": 3653,
                "name": "La Rioja",
                "iso2": "F",
                "latitude": "-29.41937930",
                "longitude": "-66.85599320",
                "type": "province",
                "cities": [
                    {
                        "id": 667,
                        "name": "Arauco",
                        "latitude": "-28.58071000",
                        "longitude": "-66.79250000"
                    },
                    {
                        "id": 738,
                        "name": "Castro Barros",
                        "latitude": "-30.57952000",
                        "longitude": "-65.72696000"
                    },
                    {
                        "id": 752,
                        "name": "Chamical",
                        "latitude": "-30.36002000",
                        "longitude": "-66.31399000"
                    },
                    {
                        "id": 761,
                        "name": "Chilecito",
                        "latitude": "-29.16195000",
                        "longitude": "-67.49740000"
                    },
                    {
                        "id": 831,
                        "name": "Departamento de Arauco",
                        "latitude": "-28.50000000",
                        "longitude": "-66.83333000"
                    },
                    {
                        "id": 893,
                        "name": "Departamento de General Lamadrid",
                        "latitude": "-28.83333000",
                        "longitude": "-68.66667000"
                    },
                    {
                        "id": 910,
                        "name": "Departamento de Independencia",
                        "latitude": "-30.16667000",
                        "longitude": "-67.41667000"
                    },
                    {
                        "id": 1200,
                        "name": "La Rioja",
                        "latitude": "-29.41105000",
                        "longitude": "-66.85067000"
                    },
                    {
                        "id": 1543,
                        "name": "Villa Bustos",
                        "latitude": "-29.28636000",
                        "longitude": "-67.02067000"
                    },
                    {
                        "id": 1588,
                        "name": "Vinchina",
                        "latitude": "-28.75964000",
                        "longitude": "-68.20692000"
                    }
                ]
            },
            {
                "id": 3646,
                "name": "Mendoza",
                "iso2": "M",
                "latitude": "-32.88945870",
                "longitude": "-68.84583860",
                "type": "province",
                "cities": [
                    {
                        "id": 850,
                        "name": "Departamento de Capital",
                        "latitude": "-32.88469000",
                        "longitude": "-68.85826000"
                    },
                    {
                        "id": 889,
                        "name": "Departamento de General Alvear",
                        "latitude": "-35.16667000",
                        "longitude": "-67.33333000"
                    },
                    {
                        "id": 898,
                        "name": "Departamento de Godoy Cruz",
                        "latitude": "-32.93333000",
                        "longitude": "-68.86667000"
                    },
                    {
                        "id": 905,
                        "name": "Departamento de Guaymallén",
                        "latitude": "-32.88333000",
                        "longitude": "-68.70000000"
                    },
                    {
                        "id": 919,
                        "name": "Departamento de La Paz",
                        "latitude": "-33.66667000",
                        "longitude": "-67.25000000"
                    },
                    {
                        "id": 924,
                        "name": "Departamento de Las Heras",
                        "latitude": "-32.50000000",
                        "longitude": "-69.50000000"
                    },
                    {
                        "id": 926,
                        "name": "Departamento de Lavalle",
                        "latitude": "-32.50000000",
                        "longitude": "-68.00000000"
                    },
                    {
                        "id": 932,
                        "name": "Departamento de Luján",
                        "latitude": "-33.00000000",
                        "longitude": "-69.33333000"
                    },
                    {
                        "id": 936,
                        "name": "Departamento de Maipú",
                        "latitude": "-33.00000000",
                        "longitude": "-68.58333000"
                    },
                    {
                        "id": 938,
                        "name": "Departamento de Malargüe",
                        "latitude": "-36.25000000",
                        "longitude": "-69.25000000"
                    },
                    {
                        "id": 967,
                        "name": "Departamento de Rivadavia",
                        "latitude": "-33.18000000",
                        "longitude": "-68.46600000"
                    },
                    {
                        "id": 983,
                        "name": "Departamento de San Carlos",
                        "latitude": "-34.00000000",
                        "longitude": "-69.00000000"
                    },
                    {
                        "id": 999,
                        "name": "Departamento de San Martín",
                        "latitude": "-32.83730000",
                        "longitude": "-68.24922000"
                    },
                    {
                        "id": 1003,
                        "name": "Departamento de San Rafael",
                        "latitude": "-35.00000000",
                        "longitude": "-68.83333000"
                    },
                    {
                        "id": 1008,
                        "name": "Departamento de Santa Rosa",
                        "latitude": "-33.50000000",
                        "longitude": "-68.00000000"
                    },
                    {
                        "id": 1026,
                        "name": "Departamento de Tunuyán",
                        "latitude": "-33.66667000",
                        "longitude": "-69.50000000"
                    },
                    {
                        "id": 1027,
                        "name": "Departamento de Tupungato",
                        "latitude": "-33.25000000",
                        "longitude": "-69.25000000"
                    },
                    {
                        "id": 1122,
                        "name": "Godoy Cruz",
                        "latitude": "-32.92863000",
                        "longitude": "-68.83510000"
                    },
                    {
                        "id": 1219,
                        "name": "Las Heras",
                        "latitude": "-32.85273000",
                        "longitude": "-68.82837000"
                    },
                    {
                        "id": 1278,
                        "name": "Mendoza",
                        "latitude": "-32.89084000",
                        "longitude": "-68.82717000"
                    },
                    {
                        "id": 1440,
                        "name": "San Martín",
                        "latitude": "-33.08103000",
                        "longitude": "-68.46814000"
                    },
                    {
                        "id": 1448,
                        "name": "San Rafael",
                        "latitude": "-34.61772000",
                        "longitude": "-68.33007000"
                    }
                ]
            },
            {
                "id": 3644,
                "name": "Misiones",
                "iso2": "N",
                "latitude": "-27.42692550",
                "longitude": "-55.94670760",
                "type": "province",
                "cities": [
                    {
                        "id": 643,
                        "name": "Alba Posse",
                        "latitude": "-27.56978000",
                        "longitude": "-54.68262000"
                    },
                    {
                        "id": 650,
                        "name": "Almafuerte",
                        "latitude": "-27.50825000",
                        "longitude": "-55.40258000"
                    },
                    {
                        "id": 669,
                        "name": "Aristóbulo del Valle",
                        "latitude": "-27.09625000",
                        "longitude": "-54.89626000"
                    },
                    {
                        "id": 674,
                        "name": "Arroyo del Medio",
                        "latitude": "-27.69748000",
                        "longitude": "-55.40376000"
                    },
                    {
                        "id": 678,
                        "name": "Azara",
                        "latitude": "-28.06160000",
                        "longitude": "-55.67797000"
                    },
                    {
                        "id": 693,
                        "name": "Bernardo de Irigoyen",
                        "latitude": "-26.25520000",
                        "longitude": "-53.64581000"
                    },
                    {
                        "id": 699,
                        "name": "Bonpland",
                        "latitude": "-27.48218000",
                        "longitude": "-55.47756000"
                    },
                    {
                        "id": 718,
                        "name": "Campo Grande",
                        "latitude": "-27.20770000",
                        "longitude": "-54.97977000"
                    },
                    {
                        "id": 721,
                        "name": "Campo Ramón",
                        "latitude": "-27.45490000",
                        "longitude": "-55.02122000"
                    },
                    {
                        "id": 722,
                        "name": "Campo Viera",
                        "latitude": "-27.33271000",
                        "longitude": "-55.05651000"
                    },
                    {
                        "id": 724,
                        "name": "Candelaria",
                        "latitude": "-27.45950000",
                        "longitude": "-55.74536000"
                    },
                    {
                        "id": 728,
                        "name": "Capioví",
                        "latitude": "-26.92998000",
                        "longitude": "-55.06084000"
                    },
                    {
                        "id": 731,
                        "name": "Caraguatay",
                        "latitude": "-26.60587000",
                        "longitude": "-54.78093000"
                    },
                    {
                        "id": 748,
                        "name": "Cerro Azul",
                        "latitude": "-27.63310000",
                        "longitude": "-55.49620000"
                    },
                    {
                        "id": 749,
                        "name": "Cerro Corá",
                        "latitude": "-27.51310000",
                        "longitude": "-55.60896000"
                    },
                    {
                        "id": 774,
                        "name": "Colonia Aurora",
                        "latitude": "-27.47428000",
                        "longitude": "-54.52498000"
                    },
                    {
                        "id": 790,
                        "name": "Concepción de la Sierra",
                        "latitude": "-27.98311000",
                        "longitude": "-55.52031000"
                    },
                    {
                        "id": 830,
                        "name": "Departamento de Apóstoles",
                        "latitude": "-27.91667000",
                        "longitude": "-55.75000000"
                    },
                    {
                        "id": 841,
                        "name": "Departamento de Cainguás",
                        "latitude": "-27.16667000",
                        "longitude": "-54.83333000"
                    },
                    {
                        "id": 845,
                        "name": "Departamento de Candelaria",
                        "latitude": "-27.50000000",
                        "longitude": "-55.50000000"
                    },
                    {
                        "id": 848,
                        "name": "Departamento de Capital",
                        "latitude": "-27.50000000",
                        "longitude": "-55.83333000"
                    },
                    {
                        "id": 867,
                        "name": "Departamento de Concepción de la Sierra",
                        "latitude": "-27.83333000",
                        "longitude": "-55.41667000"
                    },
                    {
                        "id": 878,
                        "name": "Departamento de Eldorado",
                        "latitude": "-26.25000000",
                        "longitude": "-54.41667000"
                    },
                    {
                        "id": 894,
                        "name": "Departamento de General Manuel Belgrano",
                        "latitude": "-26.16667000",
                        "longitude": "-53.91667000"
                    },
                    {
                        "id": 903,
                        "name": "Departamento de Guaraní",
                        "latitude": "-27.16667000",
                        "longitude": "-54.16667000"
                    },
                    {
                        "id": 908,
                        "name": "Departamento de Iguazú",
                        "latitude": "-25.86667000",
                        "longitude": "-54.36667000"
                    },
                    {
                        "id": 927,
                        "name": "Departamento de Leandro N. Alem",
                        "latitude": "-27.56667000",
                        "longitude": "-55.33333000"
                    },
                    {
                        "id": 929,
                        "name": "Departamento de Libertador General San Martín",
                        "latitude": "-26.91667000",
                        "longitude": "-54.91667000"
                    },
                    {
                        "id": 946,
                        "name": "Departamento de Montecarlo",
                        "latitude": "-26.71667000",
                        "longitude": "-54.58333000"
                    },
                    {
                        "id": 953,
                        "name": "Departamento de Oberá",
                        "latitude": "-27.55000000",
                        "longitude": "-55.08333000"
                    },
                    {
                        "id": 987,
                        "name": "Departamento de San Ignacio",
                        "latitude": "-27.25000000",
                        "longitude": "-55.33333000"
                    },
                    {
                        "id": 989,
                        "name": "Departamento de San Javier",
                        "latitude": "-27.77806000",
                        "longitude": "-55.13004000"
                    },
                    {
                        "id": 1002,
                        "name": "Departamento de San Pedro",
                        "latitude": "-26.66667000",
                        "longitude": "-54.00000000"
                    },
                    {
                        "id": 1031,
                        "name": "Departamento de Veinticinco de Mayo",
                        "latitude": "-27.41667000",
                        "longitude": "-54.66667000"
                    },
                    {
                        "id": 1044,
                        "name": "Dos Arroyos",
                        "latitude": "-27.69946000",
                        "longitude": "-55.25207000"
                    },
                    {
                        "id": 1045,
                        "name": "Dos de Mayo",
                        "latitude": "-27.02277000",
                        "longitude": "-54.68669000"
                    },
                    {
                        "id": 1048,
                        "name": "El Alcázar",
                        "latitude": "-26.71459000",
                        "longitude": "-54.81523000"
                    },
                    {
                        "id": 1061,
                        "name": "El Soberbio",
                        "latitude": "-27.29847000",
                        "longitude": "-54.19877000"
                    },
                    {
                        "id": 1080,
                        "name": "Florentino Ameghino",
                        "latitude": "-27.56667000",
                        "longitude": "-55.13333000"
                    },
                    {
                        "id": 1090,
                        "name": "Garuhapé",
                        "latitude": "-26.81768000",
                        "longitude": "-54.95665000"
                    },
                    {
                        "id": 1091,
                        "name": "Garupá",
                        "latitude": "-27.48171000",
                        "longitude": "-55.82921000"
                    },
                    {
                        "id": 1095,
                        "name": "General Alvear",
                        "latitude": "-27.42611000",
                        "longitude": "-55.16916000"
                    },
                    {
                        "id": 1120,
                        "name": "Gobernador Roca",
                        "latitude": "-27.18636000",
                        "longitude": "-55.46433000"
                    },
                    {
                        "id": 1128,
                        "name": "Guaraní",
                        "latitude": "-27.52323000",
                        "longitude": "-55.16077000"
                    },
                    {
                        "id": 1166,
                        "name": "Jardín América",
                        "latitude": "-27.04346000",
                        "longitude": "-55.22698000"
                    },
                    {
                        "id": 1241,
                        "name": "Loreto",
                        "latitude": "-27.33177000",
                        "longitude": "-55.52499000"
                    },
                    {
                        "id": 1250,
                        "name": "Los Helechos",
                        "latitude": "-27.55051000",
                        "longitude": "-55.07908000"
                    },
                    {
                        "id": 1295,
                        "name": "Mártires",
                        "latitude": "-27.42265000",
                        "longitude": "-55.37659000"
                    },
                    {
                        "id": 1285,
                        "name": "Mojón Grande",
                        "latitude": "-27.71165000",
                        "longitude": "-55.15631000"
                    },
                    {
                        "id": 1290,
                        "name": "Montecarlo",
                        "latitude": "-26.56620000",
                        "longitude": "-54.75700000"
                    },
                    {
                        "id": 1304,
                        "name": "Oberá",
                        "latitude": "-27.48706000",
                        "longitude": "-55.11994000"
                    },
                    {
                        "id": 1318,
                        "name": "Panambí",
                        "latitude": "-27.72369000",
                        "longitude": "-54.91515000"
                    },
                    {
                        "id": 1328,
                        "name": "Picada Gobernador López",
                        "latitude": "-27.67069000",
                        "longitude": "-55.24585000"
                    },
                    {
                        "id": 1342,
                        "name": "Posadas",
                        "latitude": "-27.36708000",
                        "longitude": "-55.89608000"
                    },
                    {
                        "id": 1353,
                        "name": "Puerto Eldorado",
                        "latitude": "-26.40843000",
                        "longitude": "-54.69463000"
                    },
                    {
                        "id": 1354,
                        "name": "Puerto Esperanza",
                        "latitude": "-26.02267000",
                        "longitude": "-54.61356000"
                    },
                    {
                        "id": 1356,
                        "name": "Puerto Iguazú",
                        "latitude": "-25.59912000",
                        "longitude": "-54.57355000"
                    },
                    {
                        "id": 1357,
                        "name": "Puerto Leoni",
                        "latitude": "-26.98762000",
                        "longitude": "-55.16569000"
                    },
                    {
                        "id": 1358,
                        "name": "Puerto Libertad",
                        "latitude": "-25.91958000",
                        "longitude": "-54.58229000"
                    },
                    {
                        "id": 1360,
                        "name": "Puerto Piray",
                        "latitude": "-26.46937000",
                        "longitude": "-54.70736000"
                    },
                    {
                        "id": 1361,
                        "name": "Puerto Rico",
                        "latitude": "-26.79598000",
                        "longitude": "-55.02402000"
                    },
                    {
                        "id": 1387,
                        "name": "Ruiz de Montoya",
                        "latitude": "-26.98333000",
                        "longitude": "-55.05000000"
                    },
                    {
                        "id": 1429,
                        "name": "San José",
                        "latitude": "-27.76979000",
                        "longitude": "-55.78260000"
                    },
                    {
                        "id": 1446,
                        "name": "San Pedro",
                        "latitude": "-26.62207000",
                        "longitude": "-54.10842000"
                    },
                    {
                        "id": 1452,
                        "name": "San Vicente",
                        "latitude": "-26.61667000",
                        "longitude": "-54.13333000"
                    },
                    {
                        "id": 1463,
                        "name": "Santa María",
                        "latitude": "-27.93490000",
                        "longitude": "-55.40742000"
                    },
                    {
                        "id": 1474,
                        "name": "Santo Pipó",
                        "latitude": "-27.14132000",
                        "longitude": "-55.40867000"
                    },
                    {
                        "id": 1514,
                        "name": "Tres Capones",
                        "latitude": "-28.00641000",
                        "longitude": "-55.60471000"
                    },
                    {
                        "id": 1528,
                        "name": "Veinticinco de Mayo",
                        "latitude": "-27.37679000",
                        "longitude": "-54.74312000"
                    },
                    {
                        "id": 1590,
                        "name": "Wanda",
                        "latitude": "-25.96879000",
                        "longitude": "-54.56285000"
                    }
                ]
            },
            {
                "id": 3648,
                "name": "Neuquén",
                "iso2": "Q",
                "latitude": "-38.94587000",
                "longitude": "-68.07309250",
                "type": "province",
                "cities": [
                    {
                        "id": 657,
                        "name": "Aluminé",
                        "latitude": "-39.23686000",
                        "longitude": "-70.91970000"
                    },
                    {
                        "id": 660,
                        "name": "Andacollo",
                        "latitude": "-37.17945000",
                        "longitude": "-70.66912000"
                    },
                    {
                        "id": 680,
                        "name": "Añelo",
                        "latitude": "-38.35441000",
                        "longitude": "-68.78840000"
                    },
                    {
                        "id": 684,
                        "name": "Barrancas",
                        "latitude": "-36.82344000",
                        "longitude": "-69.91564000"
                    },
                    {
                        "id": 706,
                        "name": "Buta Ranquil",
                        "latitude": "-37.05222000",
                        "longitude": "-69.87713000"
                    },
                    {
                        "id": 746,
                        "name": "Centenario",
                        "latitude": "-38.82955000",
                        "longitude": "-68.13180000"
                    },
                    {
                        "id": 766,
                        "name": "Chos Malal",
                        "latitude": "-37.37809000",
                        "longitude": "-70.27085000"
                    },
                    {
                        "id": 814,
                        "name": "Cutral-Có",
                        "latitude": "-38.93424000",
                        "longitude": "-69.23052000"
                    },
                    {
                        "id": 823,
                        "name": "Departamento de Aluminé",
                        "latitude": "-39.16667000",
                        "longitude": "-71.00000000"
                    },
                    {
                        "id": 833,
                        "name": "Departamento de Añelo",
                        "latitude": "-38.16667000",
                        "longitude": "-69.00000000"
                    },
                    {
                        "id": 855,
                        "name": "Departamento de Catán-Lil",
                        "latitude": "-39.50000000",
                        "longitude": "-70.33333000"
                    },
                    {
                        "id": 860,
                        "name": "Departamento de Chos-Malal",
                        "latitude": "-36.91667000",
                        "longitude": "-70.16667000"
                    },
                    {
                        "id": 863,
                        "name": "Departamento de Collón-Curá",
                        "latitude": "-40.08333000",
                        "longitude": "-70.16667000"
                    },
                    {
                        "id": 868,
                        "name": "Departamento de Confluencia",
                        "latitude": "-38.83333000",
                        "longitude": "-68.83333000"
                    },
                    {
                        "id": 934,
                        "name": "Departamento de Lácar",
                        "latitude": "-40.25000000",
                        "longitude": "-71.20000000"
                    },
                    {
                        "id": 944,
                        "name": "Departamento de Minas",
                        "latitude": "-36.83333000",
                        "longitude": "-70.83333000"
                    },
                    {
                        "id": 1035,
                        "name": "Departamento de Zapala",
                        "latitude": "-39.00000000",
                        "longitude": "-69.83333000"
                    },
                    {
                        "id": 1057,
                        "name": "El Huecú",
                        "latitude": "-37.64522000",
                        "longitude": "-70.58006000"
                    },
                    {
                        "id": 1172,
                        "name": "Junín de los Andes",
                        "latitude": "-39.95043000",
                        "longitude": "-71.06936000"
                    },
                    {
                        "id": 1217,
                        "name": "Las Coloradas",
                        "latitude": "-39.55534000",
                        "longitude": "-70.59491000"
                    },
                    {
                        "id": 1223,
                        "name": "Las Lajas",
                        "latitude": "-38.52322000",
                        "longitude": "-70.36745000"
                    },
                    {
                        "id": 1226,
                        "name": "Las Ovejas",
                        "latitude": "-36.98881000",
                        "longitude": "-70.74991000"
                    },
                    {
                        "id": 1238,
                        "name": "Loncopué",
                        "latitude": "-38.07284000",
                        "longitude": "-70.61609000"
                    },
                    {
                        "id": 1272,
                        "name": "Mariano Moreno",
                        "latitude": "-38.75029000",
                        "longitude": "-70.02367000"
                    },
                    {
                        "id": 1298,
                        "name": "Neuquén",
                        "latitude": "-38.95161000",
                        "longitude": "-68.05910000"
                    },
                    {
                        "id": 1330,
                        "name": "Picún Leufú",
                        "latitude": "-39.51614000",
                        "longitude": "-69.28765000"
                    },
                    {
                        "id": 1331,
                        "name": "Piedra del Águila",
                        "latitude": "-40.04811000",
                        "longitude": "-70.07410000"
                    },
                    {
                        "id": 1337,
                        "name": "Plaza Huincul",
                        "latitude": "-38.92598000",
                        "longitude": "-69.20863000"
                    },
                    {
                        "id": 1338,
                        "name": "Plottier",
                        "latitude": "-38.96667000",
                        "longitude": "-68.23333000"
                    },
                    {
                        "id": 1442,
                        "name": "San Martín de los Andes",
                        "latitude": "-40.15789000",
                        "longitude": "-71.35337000"
                    },
                    {
                        "id": 1483,
                        "name": "Senillosa",
                        "latitude": "-39.01412000",
                        "longitude": "-68.43281000"
                    },
                    {
                        "id": 1559,
                        "name": "Villa La Angostura",
                        "latitude": "-40.76173000",
                        "longitude": "-71.64631000"
                    },
                    {
                        "id": 1589,
                        "name": "Vista Alegre",
                        "latitude": "-38.75000000",
                        "longitude": "-68.18333000"
                    },
                    {
                        "id": 1598,
                        "name": "Zapala",
                        "latitude": "-38.89916000",
                        "longitude": "-70.05442000"
                    }
                ]
            },
            {
                "id": 3639,
                "name": "Río Negro",
                "iso2": "R",
                "latitude": "-40.82614340",
                "longitude": "-63.02663390",
                "type": "province",
                "cities": [
                    {
                        "id": 649,
                        "name": "Allen",
                        "latitude": "-38.97736000",
                        "longitude": "-67.82714000"
                    },
                    {
                        "id": 739,
                        "name": "Catriel",
                        "latitude": "-37.87907000",
                        "longitude": "-67.79560000"
                    },
                    {
                        "id": 750,
                        "name": "Cervantes",
                        "latitude": "-39.05444000",
                        "longitude": "-67.39426000"
                    },
                    {
                        "id": 759,
                        "name": "Chichinales",
                        "latitude": "-39.11505000",
                        "longitude": "-66.92714000"
                    },
                    {
                        "id": 763,
                        "name": "Chimpay",
                        "latitude": "-39.16482000",
                        "longitude": "-66.14236000"
                    },
                    {
                        "id": 764,
                        "name": "Choele Choel",
                        "latitude": "-39.28941000",
                        "longitude": "-65.66060000"
                    },
                    {
                        "id": 768,
                        "name": "Cinco Saltos",
                        "latitude": "-38.82225000",
                        "longitude": "-68.06293000"
                    },
                    {
                        "id": 770,
                        "name": "Cipolletti",
                        "latitude": "-38.93392000",
                        "longitude": "-67.99032000"
                    },
                    {
                        "id": 784,
                        "name": "Comallo",
                        "latitude": "-41.02993000",
                        "longitude": "-70.26784000"
                    },
                    {
                        "id": 795,
                        "name": "Contraalmirante Cordero",
                        "latitude": "-38.72423000",
                        "longitude": "-68.15284000"
                    },
                    {
                        "id": 798,
                        "name": "Coronel Belisle",
                        "latitude": "-39.18688000",
                        "longitude": "-65.95422000"
                    },
                    {
                        "id": 817,
                        "name": "Darwin",
                        "latitude": "-39.20334000",
                        "longitude": "-65.73952000"
                    },
                    {
                        "id": 832,
                        "name": "Departamento de Avellaneda",
                        "latitude": "-39.50000000",
                        "longitude": "-66.50000000"
                    },
                    {
                        "id": 1032,
                        "name": "Departamento de Veinticinco de Mayo",
                        "latitude": "-41.25000000",
                        "longitude": "-69.00000000"
                    },
                    {
                        "id": 1050,
                        "name": "El Bolsón",
                        "latitude": "-41.96051000",
                        "longitude": "-71.53336000"
                    },
                    {
                        "id": 1054,
                        "name": "El Cuy",
                        "latitude": "-39.92685000",
                        "longitude": "-68.34208000"
                    },
                    {
                        "id": 1085,
                        "name": "Fray Luis Beltrán",
                        "latitude": "-39.31369000",
                        "longitude": "-65.76002000"
                    },
                    {
                        "id": 1099,
                        "name": "General Conesa",
                        "latitude": "-40.10408000",
                        "longitude": "-64.45592000"
                    },
                    {
                        "id": 1100,
                        "name": "General Enrique Godoy",
                        "latitude": "-39.07891000",
                        "longitude": "-67.15807000"
                    },
                    {
                        "id": 1103,
                        "name": "General Fernández Oro",
                        "latitude": "-38.95297000",
                        "longitude": "-67.92489000"
                    },
                    {
                        "id": 1112,
                        "name": "General Roca",
                        "latitude": "-39.03333000",
                        "longitude": "-67.58333000"
                    },
                    {
                        "id": 1152,
                        "name": "Ingeniero Jacobacci",
                        "latitude": "-41.32920000",
                        "longitude": "-69.55015000"
                    },
                    {
                        "id": 1154,
                        "name": "Ingeniero Luis A. Huergo",
                        "latitude": "-39.07146000",
                        "longitude": "-67.23790000"
                    },
                    {
                        "id": 1212,
                        "name": "Lamarque",
                        "latitude": "-39.42304000",
                        "longitude": "-65.70208000"
                    },
                    {
                        "id": 1253,
                        "name": "Los Menucos",
                        "latitude": "-40.84402000",
                        "longitude": "-68.08718000"
                    },
                    {
                        "id": 1263,
                        "name": "Mainque",
                        "latitude": "-39.06667000",
                        "longitude": "-67.30000000"
                    },
                    {
                        "id": 1268,
                        "name": "Maquinchao",
                        "latitude": "-41.24912000",
                        "longitude": "-68.70321000"
                    },
                    {
                        "id": 1599,
                        "name": "Ñorquinco",
                        "latitude": "-41.85072000",
                        "longitude": "-70.90173000"
                    },
                    {
                        "id": 1334,
                        "name": "Pilcaniyeu",
                        "latitude": "-41.12288000",
                        "longitude": "-70.72152000"
                    },
                    {
                        "id": 1389,
                        "name": "Río Colorado",
                        "latitude": "-38.99397000",
                        "longitude": "-64.09295000"
                    },
                    {
                        "id": 1409,
                        "name": "San Antonio Oeste",
                        "latitude": "-40.73193000",
                        "longitude": "-64.94769000"
                    },
                    {
                        "id": 1418,
                        "name": "San Carlos de Bariloche",
                        "latitude": "-41.14557000",
                        "longitude": "-71.30822000"
                    },
                    {
                        "id": 1486,
                        "name": "Sierra Colorada",
                        "latitude": "-40.58487000",
                        "longitude": "-67.75674000"
                    },
                    {
                        "id": 1487,
                        "name": "Sierra Grande",
                        "latitude": "-41.60603000",
                        "longitude": "-65.35574000"
                    },
                    {
                        "id": 1525,
                        "name": "Valcheta",
                        "latitude": "-40.67989000",
                        "longitude": "-66.16283000"
                    },
                    {
                        "id": 1536,
                        "name": "Viedma",
                        "latitude": "-40.81345000",
                        "longitude": "-62.99668000"
                    },
                    {
                        "id": 1574,
                        "name": "Villa Regina",
                        "latitude": "-39.10000000",
                        "longitude": "-67.06667000"
                    }
                ]
            },
            {
                "id": 3643,
                "name": "Salta",
                "iso2": "A",
                "latitude": "-24.79976880",
                "longitude": "-65.41503670",
                "type": "province",
                "cities": [
                    {
                        "id": 664,
                        "name": "Apolinario Saravia",
                        "latitude": "-24.43276000",
                        "longitude": "-63.99535000"
                    },
                    {
                        "id": 707,
                        "name": "Cachí",
                        "latitude": "-25.12033000",
                        "longitude": "-66.16519000"
                    },
                    {
                        "id": 708,
                        "name": "Cafayate",
                        "latitude": "-26.08333000",
                        "longitude": "-65.83333000"
                    },
                    {
                        "id": 720,
                        "name": "Campo Quijano",
                        "latitude": "-24.90982000",
                        "longitude": "-65.63656000"
                    },
                    {
                        "id": 760,
                        "name": "Chicoana",
                        "latitude": "-25.10502000",
                        "longitude": "-65.53473000"
                    },
                    {
                        "id": 819,
                        "name": "Departamento Capital",
                        "latitude": "-24.83333000",
                        "longitude": "-65.33333000"
                    },
                    {
                        "id": 828,
                        "name": "Departamento de Anta",
                        "latitude": "-24.91667000",
                        "longitude": "-64.00000000"
                    },
                    {
                        "id": 857,
                        "name": "Departamento de Cerrillos",
                        "latitude": "-25.00000000",
                        "longitude": "-65.41667000"
                    },
                    {
                        "id": 858,
                        "name": "Departamento de Chicoana",
                        "latitude": "-25.11583000",
                        "longitude": "-65.59466000"
                    },
                    {
                        "id": 891,
                        "name": "Departamento de General Güemes",
                        "latitude": "-24.79464000",
                        "longitude": "-64.94393000"
                    },
                    {
                        "id": 901,
                        "name": "Departamento de Guachipas",
                        "latitude": "-25.66667000",
                        "longitude": "-65.50000000"
                    },
                    {
                        "id": 911,
                        "name": "Departamento de Iruya",
                        "latitude": "-22.80000000",
                        "longitude": "-64.91667000"
                    },
                    {
                        "id": 920,
                        "name": "Departamento de La Poma",
                        "latitude": "-24.16667000",
                        "longitude": "-66.16667000"
                    },
                    {
                        "id": 921,
                        "name": "Departamento de La Viña",
                        "latitude": "-25.50000000",
                        "longitude": "-65.66667000"
                    },
                    {
                        "id": 931,
                        "name": "Departamento de Los Andes",
                        "latitude": "-24.50000000",
                        "longitude": "-67.33333000"
                    },
                    {
                        "id": 942,
                        "name": "Departamento de Metán",
                        "latitude": "-25.50000000",
                        "longitude": "-64.66667000"
                    },
                    {
                        "id": 968,
                        "name": "Departamento de Rivadavia",
                        "latitude": "-23.66667000",
                        "longitude": "-62.91667000"
                    },
                    {
                        "id": 971,
                        "name": "Departamento de Rosario de la Frontera",
                        "latitude": "-25.91667000",
                        "longitude": "-64.83333000"
                    },
                    {
                        "id": 970,
                        "name": "Departamento de Rosario de Lerma",
                        "latitude": "-24.58333000",
                        "longitude": "-65.83333000"
                    },
                    {
                        "id": 982,
                        "name": "Departamento de San Carlos",
                        "latitude": "-25.75000000",
                        "longitude": "-66.08333000"
                    },
                    {
                        "id": 1052,
                        "name": "El Carril",
                        "latitude": "-25.07410000",
                        "longitude": "-65.49174000"
                    },
                    {
                        "id": 1055,
                        "name": "El Galpón",
                        "latitude": "-25.38069000",
                        "longitude": "-64.65259000"
                    },
                    {
                        "id": 1059,
                        "name": "El Quebrachal",
                        "latitude": "-25.28333000",
                        "longitude": "-64.06667000"
                    },
                    {
                        "id": 1067,
                        "name": "Embarcación",
                        "latitude": "-23.21003000",
                        "longitude": "-64.09965000"
                    },
                    {
                        "id": 1101,
                        "name": "General Enrique Mosconi",
                        "latitude": "-22.59588000",
                        "longitude": "-63.81255000"
                    },
                    {
                        "id": 1168,
                        "name": "Joaquín V. González",
                        "latitude": "-25.11364000",
                        "longitude": "-64.12628000"
                    },
                    {
                        "id": 1177,
                        "name": "La Caldera",
                        "latitude": "-24.58333000",
                        "longitude": "-65.41667000"
                    },
                    {
                        "id": 1224,
                        "name": "Las Lajitas",
                        "latitude": "-24.72762000",
                        "longitude": "-64.19335000"
                    },
                    {
                        "id": 1403,
                        "name": "Salta",
                        "latitude": "-24.78590000",
                        "longitude": "-65.41166000"
                    },
                    {
                        "id": 1411,
                        "name": "San Antonio de los Cobres",
                        "latitude": "-24.21804000",
                        "longitude": "-66.31877000"
                    },
                    {
                        "id": 1449,
                        "name": "San Ramón de la Nueva Orán",
                        "latitude": "-23.13705000",
                        "longitude": "-64.32426000"
                    },
                    {
                        "id": 1469,
                        "name": "Santa Rosa de Tastil",
                        "latitude": "-24.45166000",
                        "longitude": "-65.97452000"
                    },
                    {
                        "id": 1498,
                        "name": "Tartagal",
                        "latitude": "-22.51637000",
                        "longitude": "-63.80131000"
                    }
                ]
            },
            {
                "id": 3634,
                "name": "San Juan",
                "iso2": "J",
                "latitude": "-31.53169760",
                "longitude": "-68.56769620",
                "type": "province",
                "cities": [
                    {
                        "id": 644,
                        "name": "Albardón",
                        "latitude": "-31.43722000",
                        "longitude": "-68.52556000"
                    },
                    {
                        "id": 714,
                        "name": "Calingasta",
                        "latitude": "-31.33394000",
                        "longitude": "-69.42080000"
                    },
                    {
                        "id": 741,
                        "name": "Caucete",
                        "latitude": "-31.65179000",
                        "longitude": "-68.28105000"
                    },
                    {
                        "id": 762,
                        "name": "Chimbas",
                        "latitude": "-31.48333000",
                        "longitude": "-68.53333000"
                    },
                    {
                        "id": 821,
                        "name": "Departamento de Albardón",
                        "latitude": "-31.28333000",
                        "longitude": "-68.41667000"
                    },
                    {
                        "id": 827,
                        "name": "Departamento de Angaco",
                        "latitude": "-31.20000000",
                        "longitude": "-68.13333000"
                    },
                    {
                        "id": 844,
                        "name": "Departamento de Calingasta",
                        "latitude": "-31.50000000",
                        "longitude": "-69.75000000"
                    },
                    {
                        "id": 851,
                        "name": "Departamento de Capital",
                        "latitude": "-31.53333000",
                        "longitude": "-68.53333000"
                    },
                    {
                        "id": 856,
                        "name": "Departamento de Caucete",
                        "latitude": "-31.45000000",
                        "longitude": "-67.66667000"
                    },
                    {
                        "id": 859,
                        "name": "Departamento de Chimbas",
                        "latitude": "-31.48738000",
                        "longitude": "-68.52691000"
                    },
                    {
                        "id": 907,
                        "name": "Departamento de Iglesia",
                        "latitude": "-29.33333000",
                        "longitude": "-69.58333000"
                    },
                    {
                        "id": 915,
                        "name": "Departamento de Jáchal",
                        "latitude": "-30.50000000",
                        "longitude": "-68.50000000"
                    },
                    {
                        "id": 952,
                        "name": "Departamento de Nueve de Julio",
                        "latitude": "-31.65072000",
                        "longitude": "-68.38925000"
                    },
                    {
                        "id": 964,
                        "name": "Departamento de Rawson",
                        "latitude": "-31.70000000",
                        "longitude": "-68.46667000"
                    },
                    {
                        "id": 966,
                        "name": "Departamento de Rivadavia",
                        "latitude": "-31.56450000",
                        "longitude": "-68.65219000"
                    },
                    {
                        "id": 998,
                        "name": "Departamento de San Martín",
                        "latitude": "-31.50000000",
                        "longitude": "-68.25000000"
                    },
                    {
                        "id": 1005,
                        "name": "Departamento de Santa Lucía",
                        "latitude": "-31.53333000",
                        "longitude": "-68.46667000"
                    },
                    {
                        "id": 1013,
                        "name": "Departamento de Sarmiento",
                        "latitude": "-32.00000000",
                        "longitude": "-68.66667000"
                    },
                    {
                        "id": 1028,
                        "name": "Departamento de Ullúm",
                        "latitude": "-31.00000000",
                        "longitude": "-68.91667000"
                    },
                    {
                        "id": 1036,
                        "name": "Departamento de Zonda",
                        "latitude": "-31.68260000",
                        "longitude": "-68.89938000"
                    },
                    {
                        "id": 1302,
                        "name": "Nueve de Julio",
                        "latitude": "-31.66914000",
                        "longitude": "-68.39023000"
                    },
                    {
                        "id": 1339,
                        "name": "Pocito",
                        "latitude": "-31.68333000",
                        "longitude": "-68.58333000"
                    },
                    {
                        "id": 1407,
                        "name": "San Agustín de Valle Fértil",
                        "latitude": "-30.63353000",
                        "longitude": "-67.46821000"
                    },
                    {
                        "id": 1431,
                        "name": "San José de Jáchal",
                        "latitude": "-30.24057000",
                        "longitude": "-68.74693000"
                    },
                    {
                        "id": 1433,
                        "name": "San Juan",
                        "latitude": "-31.53750000",
                        "longitude": "-68.53639000"
                    },
                    {
                        "id": 1441,
                        "name": "San Martín",
                        "latitude": "-31.42957000",
                        "longitude": "-68.50065000"
                    },
                    {
                        "id": 1460,
                        "name": "Santa Lucía",
                        "latitude": "-31.53987000",
                        "longitude": "-68.49503000"
                    },
                    {
                        "id": 1540,
                        "name": "Villa Basilio Nievas",
                        "latitude": "-31.55000000",
                        "longitude": "-68.73333000"
                    },
                    {
                        "id": 1572,
                        "name": "Villa Paula de Sarmiento",
                        "latitude": "-31.49330000",
                        "longitude": "-68.53838000"
                    }
                ]
            },
            {
                "id": 3636,
                "name": "San Luis",
                "iso2": "D",
                "latitude": "-33.29620420",
                "longitude": "-66.32949480",
                "type": "province",
                "cities": [
                    {
                        "id": 703,
                        "name": "Buena Esperanza",
                        "latitude": "-34.75647000",
                        "longitude": "-65.25379000"
                    },
                    {
                        "id": 725,
                        "name": "Candelaria",
                        "latitude": "-32.06036000",
                        "longitude": "-65.82477000"
                    },
                    {
                        "id": 788,
                        "name": "Concarán",
                        "latitude": "-32.56009000",
                        "longitude": "-65.24270000"
                    },
                    {
                        "id": 1170,
                        "name": "Juan Martín de Pueyrredón",
                        "latitude": "-33.27544000",
                        "longitude": "-66.32017000"
                    },
                    {
                        "id": 1174,
                        "name": "Justo Daract",
                        "latitude": "-33.85940000",
                        "longitude": "-65.18277000"
                    },
                    {
                        "id": 1198,
                        "name": "La Punta",
                        "latitude": "-33.18368000",
                        "longitude": "-66.31270000"
                    },
                    {
                        "id": 1202,
                        "name": "La Toma",
                        "latitude": "-33.05258000",
                        "longitude": "-65.62385000"
                    },
                    {
                        "id": 1258,
                        "name": "Luján",
                        "latitude": "-32.36674000",
                        "longitude": "-65.93642000"
                    },
                    {
                        "id": 1280,
                        "name": "Merlo",
                        "latitude": "-32.34288000",
                        "longitude": "-65.01396000"
                    },
                    {
                        "id": 1297,
                        "name": "Naschel",
                        "latitude": "-32.91656000",
                        "longitude": "-65.37535000"
                    },
                    {
                        "id": 1425,
                        "name": "San Francisco del Monte de Oro",
                        "latitude": "-32.59825000",
                        "longitude": "-66.12539000"
                    },
                    {
                        "id": 1438,
                        "name": "San Luis",
                        "latitude": "-33.29501000",
                        "longitude": "-66.33563000"
                    },
                    {
                        "id": 1470,
                        "name": "Santa Rosa del Conlara",
                        "latitude": "-32.34286000",
                        "longitude": "-65.20323000"
                    },
                    {
                        "id": 1504,
                        "name": "Tilisarao",
                        "latitude": "-32.73292000",
                        "longitude": "-65.29109000"
                    },
                    {
                        "id": 1520,
                        "name": "Unión",
                        "latitude": "-35.15282000",
                        "longitude": "-65.94602000"
                    },
                    {
                        "id": 1555,
                        "name": "Villa General Roca",
                        "latitude": "-32.66535000",
                        "longitude": "-66.45052000"
                    },
                    {
                        "id": 1565,
                        "name": "Villa Mercedes",
                        "latitude": "-33.67571000",
                        "longitude": "-65.45783000"
                    }
                ]
            },
            {
                "id": 3649,
                "name": "Santa Cruz",
                "iso2": "Z",
                "latitude": "-51.63528210",
                "longitude": "-69.24743530",
                "type": "province",
                "cities": [
                    {
                        "id": 637,
                        "name": "28 de Noviembre",
                        "latitude": "-51.58390000",
                        "longitude": "-72.21382000"
                    },
                    {
                        "id": 711,
                        "name": "Caleta Olivia",
                        "latitude": "-46.43929000",
                        "longitude": "-67.52814000"
                    },
                    {
                        "id": 786,
                        "name": "Comandante Luis Piedra Buena",
                        "latitude": "-49.98513000",
                        "longitude": "-68.91467000"
                    },
                    {
                        "id": 874,
                        "name": "Departamento de Deseado",
                        "latitude": "-47.33333000",
                        "longitude": "-67.83333000"
                    },
                    {
                        "id": 906,
                        "name": "Departamento de Güer Aike",
                        "latitude": "-51.33333000",
                        "longitude": "-70.33333000"
                    },
                    {
                        "id": 922,
                        "name": "Departamento de Lago Argentino",
                        "latitude": "-49.75000000",
                        "longitude": "-72.00000000"
                    },
                    {
                        "id": 935,
                        "name": "Departamento de Magallanes",
                        "latitude": "-48.75000000",
                        "longitude": "-68.50000000"
                    },
                    {
                        "id": 972,
                        "name": "Departamento de Río Chico",
                        "latitude": "-48.25000000",
                        "longitude": "-71.00000000"
                    },
                    {
                        "id": 1051,
                        "name": "El Calafate",
                        "latitude": "-50.34075000",
                        "longitude": "-72.27682000"
                    },
                    {
                        "id": 1116,
                        "name": "Gobernador Gregores",
                        "latitude": "-48.75057000",
                        "longitude": "-70.24741000"
                    },
                    {
                        "id": 1220,
                        "name": "Las Heras",
                        "latitude": "-46.54186000",
                        "longitude": "-68.93593000"
                    },
                    {
                        "id": 1244,
                        "name": "Los Antiguos",
                        "latitude": "-46.54972000",
                        "longitude": "-71.63086000"
                    },
                    {
                        "id": 1326,
                        "name": "Perito Moreno",
                        "latitude": "-46.58995000",
                        "longitude": "-70.92975000"
                    },
                    {
                        "id": 1329,
                        "name": "Pico Truncado",
                        "latitude": "-46.79490000",
                        "longitude": "-67.95731000"
                    },
                    {
                        "id": 1352,
                        "name": "Puerto Deseado",
                        "latitude": "-47.75034000",
                        "longitude": "-65.89382000"
                    },
                    {
                        "id": 1362,
                        "name": "Puerto Santa Cruz",
                        "latitude": "-50.01910000",
                        "longitude": "-68.52321000"
                    },
                    {
                        "id": 1391,
                        "name": "Río Gallegos",
                        "latitude": "-51.62261000",
                        "longitude": "-69.21813000"
                    },
                    {
                        "id": 1397,
                        "name": "Río Turbio",
                        "latitude": "-51.53587000",
                        "longitude": "-72.33673000"
                    },
                    {
                        "id": 1434,
                        "name": "San Julián",
                        "latitude": "-49.30554000",
                        "longitude": "-67.72743000"
                    },
                    {
                        "id": 1593,
                        "name": "Yacimiento Río Turbio",
                        "latitude": "-51.57321000",
                        "longitude": "-72.35080000"
                    }
                ]
            },
            {
                "id": 3641,
                "name": "Santa Fe",
                "iso2": "S",
                "latitude": "-31.58551090",
                "longitude": "-60.72380160",
                "type": "province",
                "cities": [
                    {
                        "id": 670,
                        "name": "Armstrong",
                        "latitude": "-32.78215000",
                        "longitude": "-61.60222000"
                    },
                    {
                        "id": 673,
                        "name": "Arroyo Seco",
                        "latitude": "-33.15489000",
                        "longitude": "-60.50863000"
                    },
                    {
                        "id": 675,
                        "name": "Arrufó",
                        "latitude": "-30.23281000",
                        "longitude": "-61.72862000"
                    },
                    {
                        "id": 676,
                        "name": "Avellaneda",
                        "latitude": "-29.11761000",
                        "longitude": "-59.65834000"
                    },
                    {
                        "id": 689,
                        "name": "Bella Italia",
                        "latitude": "-31.28182000",
                        "longitude": "-61.41092000"
                    },
                    {
                        "id": 710,
                        "name": "Calchaquí",
                        "latitude": "-29.88767000",
                        "longitude": "-60.28697000"
                    },
                    {
                        "id": 743,
                        "name": "Cañada de Gómez",
                        "latitude": "-32.81636000",
                        "longitude": "-61.39493000"
                    },
                    {
                        "id": 729,
                        "name": "Capitán Bermúdez",
                        "latitude": "-32.82262000",
                        "longitude": "-60.71852000"
                    },
                    {
                        "id": 732,
                        "name": "Carcarañá",
                        "latitude": "-32.85679000",
                        "longitude": "-61.15331000"
                    },
                    {
                        "id": 736,
                        "name": "Casilda",
                        "latitude": "-33.04417000",
                        "longitude": "-61.16806000"
                    },
                    {
                        "id": 747,
                        "name": "Ceres",
                        "latitude": "-29.88100000",
                        "longitude": "-61.94504000"
                    },
                    {
                        "id": 758,
                        "name": "Chañar Ladeado",
                        "latitude": "-33.32524000",
                        "longitude": "-62.03831000"
                    },
                    {
                        "id": 796,
                        "name": "Coronda",
                        "latitude": "-31.97263000",
                        "longitude": "-60.91983000"
                    },
                    {
                        "id": 835,
                        "name": "Departamento de Belgrano",
                        "latitude": "-32.50000000",
                        "longitude": "-61.75000000"
                    },
                    {
                        "id": 853,
                        "name": "Departamento de Caseros",
                        "latitude": "-33.25000000",
                        "longitude": "-61.66667000"
                    },
                    {
                        "id": 854,
                        "name": "Departamento de Castellanos",
                        "latitude": "-31.16667000",
                        "longitude": "-61.66667000"
                    },
                    {
                        "id": 869,
                        "name": "Departamento de Constitución",
                        "latitude": "-33.50000000",
                        "longitude": "-60.91667000"
                    },
                    {
                        "id": 916,
                        "name": "Departamento de La Capital",
                        "latitude": "-31.50000000",
                        "longitude": "-60.66667000"
                    },
                    {
                        "id": 951,
                        "name": "Departamento de Nueve de Julio",
                        "latitude": "-28.83333000",
                        "longitude": "-61.33333000"
                    },
                    {
                        "id": 985,
                        "name": "Departamento de San Cristóbal",
                        "latitude": "-30.33333000",
                        "longitude": "-61.33333000"
                    },
                    {
                        "id": 988,
                        "name": "Departamento de San Javier",
                        "latitude": "-30.33333000",
                        "longitude": "-59.91667000"
                    },
                    {
                        "id": 992,
                        "name": "Departamento de San Justo",
                        "latitude": "-30.66667000",
                        "longitude": "-60.50000000"
                    },
                    {
                        "id": 993,
                        "name": "Departamento de San Lorenzo",
                        "latitude": "-33.00000000",
                        "longitude": "-61.00000000"
                    },
                    {
                        "id": 1000,
                        "name": "Departamento de San Martín",
                        "latitude": "-32.00000000",
                        "longitude": "-61.83333000"
                    },
                    {
                        "id": 1033,
                        "name": "Departamento de Vera",
                        "latitude": "-29.00000000",
                        "longitude": "-60.50000000"
                    },
                    {
                        "id": 1062,
                        "name": "El Trébol",
                        "latitude": "-32.20080000",
                        "longitude": "-61.70140000"
                    },
                    {
                        "id": 1069,
                        "name": "Esperanza",
                        "latitude": "-31.44880000",
                        "longitude": "-60.93173000"
                    },
                    {
                        "id": 1079,
                        "name": "Firmat",
                        "latitude": "-33.45937000",
                        "longitude": "-61.48320000"
                    },
                    {
                        "id": 1084,
                        "name": "Fray Luis A. Beltrán",
                        "latitude": "-32.79122000",
                        "longitude": "-60.72819000"
                    },
                    {
                        "id": 1086,
                        "name": "Funes",
                        "latitude": "-32.91568000",
                        "longitude": "-60.80995000"
                    },
                    {
                        "id": 1131,
                        "name": "Gálvez",
                        "latitude": "-32.02927000",
                        "longitude": "-61.22103000"
                    },
                    {
                        "id": 1093,
                        "name": "Gato Colorado",
                        "latitude": "-28.02219000",
                        "longitude": "-61.18663000"
                    },
                    {
                        "id": 1117,
                        "name": "Gobernador Gálvez",
                        "latitude": "-33.03016000",
                        "longitude": "-60.64045000"
                    },
                    {
                        "id": 1124,
                        "name": "Granadero Baigorria",
                        "latitude": "-32.85683000",
                        "longitude": "-60.71754000"
                    },
                    {
                        "id": 1133,
                        "name": "Helvecia",
                        "latitude": "-31.09834000",
                        "longitude": "-60.08830000"
                    },
                    {
                        "id": 1140,
                        "name": "Hersilia",
                        "latitude": "-30.00447000",
                        "longitude": "-61.84080000"
                    },
                    {
                        "id": 1158,
                        "name": "Iriondo Department",
                        "latitude": "-32.63333000",
                        "longitude": "-61.33333000"
                    },
                    {
                        "id": 1210,
                        "name": "Laguna Paiva",
                        "latitude": "-31.30391000",
                        "longitude": "-60.65894000"
                    },
                    {
                        "id": 1227,
                        "name": "Las Parejas",
                        "latitude": "-32.68478000",
                        "longitude": "-61.51637000"
                    },
                    {
                        "id": 1230,
                        "name": "Las Rosas",
                        "latitude": "-32.47661000",
                        "longitude": "-61.58041000"
                    },
                    {
                        "id": 1231,
                        "name": "Las Toscas",
                        "latitude": "-28.35290000",
                        "longitude": "-59.25795000"
                    },
                    {
                        "id": 1252,
                        "name": "Los Laureles",
                        "latitude": "-29.36847000",
                        "longitude": "-59.73634000"
                    },
                    {
                        "id": 1265,
                        "name": "Malabrigo",
                        "latitude": "-29.34636000",
                        "longitude": "-59.96957000"
                    },
                    {
                        "id": 1276,
                        "name": "Melincué",
                        "latitude": "-33.65847000",
                        "longitude": "-61.45459000"
                    },
                    {
                        "id": 1366,
                        "name": "Pérez",
                        "latitude": "-32.99835000",
                        "longitude": "-60.76791000"
                    },
                    {
                        "id": 1372,
                        "name": "Rafaela",
                        "latitude": "-31.25033000",
                        "longitude": "-61.48670000"
                    },
                    {
                        "id": 1376,
                        "name": "Reconquista",
                        "latitude": "-29.15000000",
                        "longitude": "-59.65000000"
                    },
                    {
                        "id": 1377,
                        "name": "Recreo",
                        "latitude": "-31.49076000",
                        "longitude": "-60.73299000"
                    },
                    {
                        "id": 1383,
                        "name": "Roldán",
                        "latitude": "-32.89846000",
                        "longitude": "-60.90681000"
                    },
                    {
                        "id": 1384,
                        "name": "Rosario",
                        "latitude": "-32.94682000",
                        "longitude": "-60.63932000"
                    },
                    {
                        "id": 1386,
                        "name": "Rufino",
                        "latitude": "-34.26827000",
                        "longitude": "-62.71262000"
                    },
                    {
                        "id": 1417,
                        "name": "San Carlos Centro",
                        "latitude": "-31.72864000",
                        "longitude": "-61.09192000"
                    },
                    {
                        "id": 1420,
                        "name": "San Cristóbal",
                        "latitude": "-30.31053000",
                        "longitude": "-61.23724000"
                    },
                    {
                        "id": 1427,
                        "name": "San Javier",
                        "latitude": "-30.57781000",
                        "longitude": "-59.93170000"
                    },
                    {
                        "id": 1428,
                        "name": "San Jorge",
                        "latitude": "-31.89618000",
                        "longitude": "-61.85984000"
                    },
                    {
                        "id": 1436,
                        "name": "San Justo",
                        "latitude": "-30.78913000",
                        "longitude": "-60.59189000"
                    },
                    {
                        "id": 1458,
                        "name": "Santa Fe",
                        "latitude": "-31.64881000",
                        "longitude": "-60.70868000"
                    },
                    {
                        "id": 1475,
                        "name": "Santo Tomé",
                        "latitude": "-31.66274000",
                        "longitude": "-60.76530000"
                    },
                    {
                        "id": 1478,
                        "name": "Sastre",
                        "latitude": "-31.76762000",
                        "longitude": "-61.82887000"
                    },
                    {
                        "id": 1490,
                        "name": "Sunchales",
                        "latitude": "-30.94404000",
                        "longitude": "-61.56148000"
                    },
                    {
                        "id": 1494,
                        "name": "Tacuarendí",
                        "latitude": "-28.41265000",
                        "longitude": "-59.26000000"
                    },
                    {
                        "id": 1509,
                        "name": "Tostado",
                        "latitude": "-29.23202000",
                        "longitude": "-61.76917000"
                    },
                    {
                        "id": 1510,
                        "name": "Totoras",
                        "latitude": "-32.58440000",
                        "longitude": "-61.16852000"
                    },
                    {
                        "id": 1529,
                        "name": "Venado Tuerto",
                        "latitude": "-33.74556000",
                        "longitude": "-61.96885000"
                    },
                    {
                        "id": 1530,
                        "name": "Vera",
                        "latitude": "-29.45930000",
                        "longitude": "-60.21261000"
                    },
                    {
                        "id": 1545,
                        "name": "Villa Cañás",
                        "latitude": "-34.00565000",
                        "longitude": "-61.60757000"
                    },
                    {
                        "id": 1547,
                        "name": "Villa Constitución",
                        "latitude": "-33.22778000",
                        "longitude": "-60.32970000"
                    },
                    {
                        "id": 1566,
                        "name": "Villa Mugueta",
                        "latitude": "-33.31129000",
                        "longitude": "-61.05515000"
                    },
                    {
                        "id": 1568,
                        "name": "Villa Ocampo",
                        "latitude": "-28.48752000",
                        "longitude": "-59.35515000"
                    },
                    {
                        "id": 1577,
                        "name": "Villa Trinidad",
                        "latitude": "-30.21329000",
                        "longitude": "-61.87597000"
                    }
                ]
            },
            {
                "id": 3635,
                "name": "Santiago del Estero",
                "iso2": "G",
                "latitude": "-27.78335740",
                "longitude": "-64.26416700",
                "type": "province",
                "cities": [
                    {
                        "id": 679,
                        "name": "Añatuya",
                        "latitude": "-28.46064000",
                        "longitude": "-62.83472000"
                    },
                    {
                        "id": 691,
                        "name": "Beltrán",
                        "latitude": "-27.82913000",
                        "longitude": "-64.06098000"
                    },
                    {
                        "id": 717,
                        "name": "Campo Gallo",
                        "latitude": "-26.58333000",
                        "longitude": "-62.85000000"
                    },
                    {
                        "id": 771,
                        "name": "Clodomira",
                        "latitude": "-27.57440000",
                        "longitude": "-64.13108000"
                    },
                    {
                        "id": 777,
                        "name": "Colonia Dora",
                        "latitude": "-28.60000000",
                        "longitude": "-62.95000000"
                    },
                    {
                        "id": 820,
                        "name": "Departamento de Aguirre",
                        "latitude": "-29.33333000",
                        "longitude": "-62.50000000"
                    },
                    {
                        "id": 834,
                        "name": "Departamento de Banda",
                        "latitude": "-27.50000000",
                        "longitude": "-64.33333000"
                    },
                    {
                        "id": 861,
                        "name": "Departamento de Choya",
                        "latitude": "-28.75000000",
                        "longitude": "-64.75000000"
                    },
                    {
                        "id": 904,
                        "name": "Departamento de Guasayán",
                        "latitude": "-28.00000000",
                        "longitude": "-64.83333000"
                    },
                    {
                        "id": 930,
                        "name": "Departamento de Loreto",
                        "latitude": "-28.55000000",
                        "longitude": "-64.33333000"
                    },
                    {
                        "id": 948,
                        "name": "Departamento de Moreno",
                        "latitude": "-27.33333000",
                        "longitude": "-62.50000000"
                    },
                    {
                        "id": 975,
                        "name": "Departamento de Río Hondo",
                        "latitude": "-27.58333000",
                        "longitude": "-64.75000000"
                    },
                    {
                        "id": 969,
                        "name": "Departamento de Robles",
                        "latitude": "-27.83333000",
                        "longitude": "-63.91667000"
                    },
                    {
                        "id": 997,
                        "name": "Departamento de San Martín",
                        "latitude": "-28.16667000",
                        "longitude": "-63.83333000"
                    },
                    {
                        "id": 1011,
                        "name": "Departamento de Sarmiento",
                        "latitude": "-28.08333000",
                        "longitude": "-63.41667000"
                    },
                    {
                        "id": 1056,
                        "name": "El Hoyo",
                        "latitude": "-27.02872000",
                        "longitude": "-63.23197000"
                    },
                    {
                        "id": 1176,
                        "name": "La Banda",
                        "latitude": "-27.73348000",
                        "longitude": "-64.24278000"
                    },
                    {
                        "id": 1251,
                        "name": "Los Juríes",
                        "latitude": "-28.46539000",
                        "longitude": "-62.10862000"
                    },
                    {
                        "id": 1255,
                        "name": "Los Telares",
                        "latitude": "-28.98479000",
                        "longitude": "-63.44889000"
                    },
                    {
                        "id": 1315,
                        "name": "Pampa de los Guanacos",
                        "latitude": "-26.23002000",
                        "longitude": "-61.83774000"
                    },
                    {
                        "id": 1369,
                        "name": "Quimilí",
                        "latitude": "-27.64615000",
                        "longitude": "-62.41655000"
                    },
                    {
                        "id": 1445,
                        "name": "San Pedro",
                        "latitude": "-27.95386000",
                        "longitude": "-65.16651000"
                    },
                    {
                        "id": 1473,
                        "name": "Santiago del Estero",
                        "latitude": "-27.79511000",
                        "longitude": "-64.26149000"
                    },
                    {
                        "id": 1489,
                        "name": "Sumampa",
                        "latitude": "-29.38470000",
                        "longitude": "-63.46907000"
                    },
                    {
                        "id": 1491,
                        "name": "Suncho Corral",
                        "latitude": "-27.93357000",
                        "longitude": "-63.42938000"
                    },
                    {
                        "id": 1501,
                        "name": "Termas de Río Hondo",
                        "latitude": "-27.49362000",
                        "longitude": "-64.85972000"
                    },
                    {
                        "id": 1506,
                        "name": "Tintina",
                        "latitude": "-27.02687000",
                        "longitude": "-62.70643000"
                    },
                    {
                        "id": 1539,
                        "name": "Villa Atamisqui",
                        "latitude": "-28.49609000",
                        "longitude": "-63.81609000"
                    },
                    {
                        "id": 1554,
                        "name": "Villa General Mitre",
                        "latitude": "-29.14310000",
                        "longitude": "-62.65248000"
                    },
                    {
                        "id": 1569,
                        "name": "Villa Ojo de Agua",
                        "latitude": "-29.50003000",
                        "longitude": "-63.69377000"
                    }
                ]
            },
            {
                "id": 3650,
                "name": "Tierra del Fuego",
                "iso2": "V",
                "latitude": "-54.80539980",
                "longitude": "-68.32420610",
                "type": "province",
                "cities": [
                    {
                        "id": 1392,
                        "name": "Río Grande",
                        "latitude": "-53.78769000",
                        "longitude": "-67.70946000"
                    },
                    {
                        "id": 1508,
                        "name": "Tolhuin",
                        "latitude": "-54.51083000",
                        "longitude": "-67.19550000"
                    },
                    {
                        "id": 1524,
                        "name": "Ushuaia",
                        "latitude": "-54.81084000",
                        "longitude": "-68.31591000"
                    }
                ]
            },
            {
                "id": 3637,
                "name": "Tucumán",
                "iso2": "T",
                "latitude": "-26.82211270",
                "longitude": "-65.21929030",
                "type": "province",
                "cities": [
                    {
                        "id": 642,
                        "name": "Aguilares",
                        "latitude": "-27.43380000",
                        "longitude": "-65.61427000"
                    },
                    {
                        "id": 646,
                        "name": "Alderetes",
                        "latitude": "-26.81667000",
                        "longitude": "-65.13333000"
                    },
                    {
                        "id": 690,
                        "name": "Bella Vista",
                        "latitude": "-27.03424000",
                        "longitude": "-65.30196000"
                    },
                    {
                        "id": 705,
                        "name": "Burruyacú",
                        "latitude": "-26.49918000",
                        "longitude": "-64.74206000"
                    },
                    {
                        "id": 840,
                        "name": "Departamento de Burruyacú",
                        "latitude": "-26.50000000",
                        "longitude": "-64.91667000"
                    },
                    {
                        "id": 852,
                        "name": "Departamento de Capital",
                        "latitude": "-26.82825000",
                        "longitude": "-65.21126000"
                    },
                    {
                        "id": 870,
                        "name": "Departamento de Cruz Alta",
                        "latitude": "-26.91667000",
                        "longitude": "-64.91667000"
                    },
                    {
                        "id": 882,
                        "name": "Departamento de Famaillá",
                        "latitude": "-26.91667000",
                        "longitude": "-65.50000000"
                    },
                    {
                        "id": 900,
                        "name": "Departamento de Graneros",
                        "latitude": "-27.75000000",
                        "longitude": "-65.33333000"
                    },
                    {
                        "id": 917,
                        "name": "Departamento de La Cocha",
                        "latitude": "-27.77784000",
                        "longitude": "-65.57109000"
                    },
                    {
                        "id": 933,
                        "name": "Departamento de Lules",
                        "latitude": "-26.92886000",
                        "longitude": "-65.33848000"
                    },
                    {
                        "id": 947,
                        "name": "Departamento de Monteros",
                        "latitude": "-27.16667000",
                        "longitude": "-65.58333000"
                    },
                    {
                        "id": 973,
                        "name": "Departamento de Río Chico",
                        "latitude": "-27.43368000",
                        "longitude": "-65.76671000"
                    },
                    {
                        "id": 1015,
                        "name": "Departamento de Simoca",
                        "latitude": "-27.26360000",
                        "longitude": "-65.35612000"
                    },
                    {
                        "id": 1023,
                        "name": "Departamento de Trancas",
                        "latitude": "-26.41667000",
                        "longitude": "-65.50000000"
                    },
                    {
                        "id": 1034,
                        "name": "Departamento de Yerba Buena",
                        "latitude": "-26.81826000",
                        "longitude": "-65.31733000"
                    },
                    {
                        "id": 1074,
                        "name": "Famaillá",
                        "latitude": "-27.05413000",
                        "longitude": "-65.40329000"
                    },
                    {
                        "id": 1125,
                        "name": "Graneros",
                        "latitude": "-27.64934000",
                        "longitude": "-65.43830000"
                    },
                    {
                        "id": 1182,
                        "name": "La Cocha",
                        "latitude": "-27.76927000",
                        "longitude": "-65.58711000"
                    },
                    {
                        "id": 1291,
                        "name": "Monteros",
                        "latitude": "-27.16741000",
                        "longitude": "-65.49832000"
                    },
                    {
                        "id": 1444,
                        "name": "San Miguel de Tucumán",
                        "latitude": "-26.82414000",
                        "longitude": "-65.22260000"
                    },
                    {
                        "id": 1488,
                        "name": "Simoca",
                        "latitude": "-27.26272000",
                        "longitude": "-65.35647000"
                    },
                    {
                        "id": 1496,
                        "name": "Tafí del Valle",
                        "latitude": "-26.85275000",
                        "longitude": "-65.70983000"
                    },
                    {
                        "id": 1495,
                        "name": "Tafí Viejo",
                        "latitude": "-26.73201000",
                        "longitude": "-65.25921000"
                    },
                    {
                        "id": 1511,
                        "name": "Trancas",
                        "latitude": "-26.23136000",
                        "longitude": "-65.28093000"
                    },
                    {
                        "id": 1596,
                        "name": "Yerba Buena",
                        "latitude": "-26.81667000",
                        "longitude": "-65.31667000"
                    }
                ]
            }
        ]
    },
    {
        "id": 12,
        "name": "Armenia",
        "iso3": "ARM",
        "iso2": "AM",
        "numeric_code": "051",
        "phonecode": "374",
        "capital": "Yerevan",
        "currency": "AMD",
        "currency_name": "Armenian dram",
        "currency_symbol": "֏",
        "tld": ".am",
        "native": "Հայաստան",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Armenian",
        "timezones": [
            {
                "zoneName": "Asia\/Yerevan",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "AMT",
                "tzName": "Armenia Time"
            }
        ],
        "translations": {
            "br": "Armenia",
            "ko": "아르메니아",
            "pt-BR": "Armênia",
            "pt": "Arménia",
            "nl": "Armenië",
            "hr": "Armenija",
            "fa": "ارمنستان",
            "de": "Armenien",
            "es": "Armenia",
            "fr": "Arménie",
            "ja": "アルメニア",
            "it": "Armenia",
            "zh-CN": "亚美尼亚",
            "tr": "Ermenistan",
            "ru": "Армения",
            "uk": "Вірменія",
            "pl": "Armenia"
        },
        "latitude": "40.00000000",
        "longitude": "45.00000000",
        "emoji": "🇦🇲",
        "emojiU": "U+1F1E6 U+1F1F2",
        "states": [
            {
                "id": 2023,
                "name": "Aragatsotn",
                "iso2": "AG",
                "latitude": "40.33473010",
                "longitude": "44.37482960",
                "type": "region",
                "cities": [
                    {
                        "id": 286,
                        "name": "Agarakavan",
                        "latitude": "40.33069000",
                        "longitude": "44.07233000"
                    },
                    {
                        "id": 303,
                        "name": "Aparan",
                        "latitude": "40.59323000",
                        "longitude": "44.35890000"
                    },
                    {
                        "id": 305,
                        "name": "Aragats",
                        "latitude": "40.48889000",
                        "longitude": "44.35290000"
                    },
                    {
                        "id": 329,
                        "name": "Arteni",
                        "latitude": "40.29730000",
                        "longitude": "43.76672000"
                    },
                    {
                        "id": 334,
                        "name": "Ashnak",
                        "latitude": "40.33069000",
                        "longitude": "43.91669000"
                    },
                    {
                        "id": 335,
                        "name": "Ashtarak",
                        "latitude": "40.29910000",
                        "longitude": "44.36204000"
                    },
                    {
                        "id": 361,
                        "name": "Byurakan",
                        "latitude": "40.33894000",
                        "longitude": "44.27275000"
                    },
                    {
                        "id": 412,
                        "name": "Hnaberd",
                        "latitude": "40.63721000",
                        "longitude": "44.14058000"
                    },
                    {
                        "id": 428,
                        "name": "Karbi",
                        "latitude": "40.33069000",
                        "longitude": "44.37793000"
                    },
                    {
                        "id": 430,
                        "name": "Kasakh",
                        "latitude": "40.53697000",
                        "longitude": "44.41046000"
                    },
                    {
                        "id": 434,
                        "name": "Kosh",
                        "latitude": "40.30011000",
                        "longitude": "44.16107000"
                    },
                    {
                        "id": 486,
                        "name": "Nor Yerznka",
                        "latitude": "40.30011000",
                        "longitude": "44.38892000"
                    },
                    {
                        "id": 497,
                        "name": "Oshakan",
                        "latitude": "40.26392000",
                        "longitude": "44.31671000"
                    },
                    {
                        "id": 512,
                        "name": "Sasunik",
                        "latitude": "40.25012000",
                        "longitude": "44.34448000"
                    },
                    {
                        "id": 520,
                        "name": "Shenavan",
                        "latitude": "40.48328000",
                        "longitude": "44.38348000"
                    },
                    {
                        "id": 546,
                        "name": "T’alin",
                        "latitude": "40.39172000",
                        "longitude": "43.87793000"
                    },
                    {
                        "id": 538,
                        "name": "Tsaghkahovit",
                        "latitude": "40.63428000",
                        "longitude": "44.22241000"
                    },
                    {
                        "id": 548,
                        "name": "Ushi",
                        "latitude": "40.34729000",
                        "longitude": "44.37512000"
                    },
                    {
                        "id": 570,
                        "name": "Voskevaz",
                        "latitude": "40.27508000",
                        "longitude": "44.30011000"
                    },
                    {
                        "id": 588,
                        "name": "Zovuni",
                        "latitude": "40.51111000",
                        "longitude": "44.43890000"
                    }
                ]
            },
            {
                "id": 2024,
                "name": "Ararat",
                "iso2": "AR",
                "latitude": "39.91394150",
                "longitude": "44.72000040",
                "type": "region",
                "cities": [
                    {
                        "id": 282,
                        "name": "Abovyan",
                        "latitude": "40.04851000",
                        "longitude": "44.54742000"
                    },
                    {
                        "id": 307,
                        "name": "Aralez",
                        "latitude": "39.90008000",
                        "longitude": "44.65570000"
                    },
                    {
                        "id": 309,
                        "name": "Ararat",
                        "latitude": "39.83069000",
                        "longitude": "44.70569000"
                    },
                    {
                        "id": 314,
                        "name": "Arevabuyr",
                        "latitude": "40.03607000",
                        "longitude": "44.46948000"
                    },
                    {
                        "id": 319,
                        "name": "Arevshat",
                        "latitude": "40.03963000",
                        "longitude": "44.54179000"
                    },
                    {
                        "id": 324,
                        "name": "Armash",
                        "latitude": "39.76672000",
                        "longitude": "44.81110000"
                    },
                    {
                        "id": 328,
                        "name": "Artashat",
                        "latitude": "39.96144000",
                        "longitude": "44.54447000"
                    },
                    {
                        "id": 337,
                        "name": "Avshar",
                        "latitude": "39.85553000",
                        "longitude": "44.65832000"
                    },
                    {
                        "id": 338,
                        "name": "Aygavan",
                        "latitude": "39.87327000",
                        "longitude": "44.66984000"
                    },
                    {
                        "id": 341,
                        "name": "Aygepat",
                        "latitude": "39.95845000",
                        "longitude": "44.59981000"
                    },
                    {
                        "id": 343,
                        "name": "Aygestan",
                        "latitude": "40.00293000",
                        "longitude": "44.55829000"
                    },
                    {
                        "id": 344,
                        "name": "Aygezard",
                        "latitude": "39.95436000",
                        "longitude": "44.60229000"
                    },
                    {
                        "id": 351,
                        "name": "Bardzrashen",
                        "latitude": "40.08533000",
                        "longitude": "44.57957000"
                    },
                    {
                        "id": 356,
                        "name": "Berk’anush",
                        "latitude": "39.97790000",
                        "longitude": "44.51672000"
                    },
                    {
                        "id": 359,
                        "name": "Burastan",
                        "latitude": "39.99157000",
                        "longitude": "44.49681000"
                    },
                    {
                        "id": 362,
                        "name": "Byuravan",
                        "latitude": "40.01604000",
                        "longitude": "44.51889000"
                    },
                    {
                        "id": 366,
                        "name": "Dalar",
                        "latitude": "39.97653000",
                        "longitude": "44.52649000"
                    },
                    {
                        "id": 368,
                        "name": "Darakert",
                        "latitude": "40.10553000",
                        "longitude": "44.41388000"
                    },
                    {
                        "id": 370,
                        "name": "Dashtavan",
                        "latitude": "40.10010000",
                        "longitude": "44.39172000"
                    },
                    {
                        "id": 373,
                        "name": "Dimitrov",
                        "latitude": "40.00848000",
                        "longitude": "44.49170000"
                    },
                    {
                        "id": 377,
                        "name": "Dvin",
                        "latitude": "40.01984000",
                        "longitude": "44.58376000"
                    },
                    {
                        "id": 395,
                        "name": "Getazat",
                        "latitude": "40.03844000",
                        "longitude": "44.56369000"
                    },
                    {
                        "id": 396,
                        "name": "Ghukasavan",
                        "latitude": "40.12793000",
                        "longitude": "44.41669000"
                    },
                    {
                        "id": 401,
                        "name": "Goravan",
                        "latitude": "39.90832000",
                        "longitude": "44.73328000"
                    },
                    {
                        "id": 409,
                        "name": "Hayanist",
                        "latitude": "40.12231000",
                        "longitude": "44.37793000"
                    },
                    {
                        "id": 415,
                        "name": "Hovtashat",
                        "latitude": "40.09729000",
                        "longitude": "44.34448000"
                    },
                    {
                        "id": 416,
                        "name": "Hovtashen",
                        "latitude": "40.02508000",
                        "longitude": "44.45007000"
                    },
                    {
                        "id": 421,
                        "name": "Jrahovit",
                        "latitude": "40.04730000",
                        "longitude": "44.47510000"
                    },
                    {
                        "id": 449,
                        "name": "Lusarrat",
                        "latitude": "39.87403000",
                        "longitude": "44.58678000"
                    },
                    {
                        "id": 455,
                        "name": "Marmarashen",
                        "latitude": "40.05829000",
                        "longitude": "44.47229000"
                    },
                    {
                        "id": 458,
                        "name": "Masis",
                        "latitude": "40.06542000",
                        "longitude": "44.41618000"
                    },
                    {
                        "id": 472,
                        "name": "Mrganush",
                        "latitude": "40.02857000",
                        "longitude": "44.55831000"
                    },
                    {
                        "id": 475,
                        "name": "Mrgavan",
                        "latitude": "39.97251000",
                        "longitude": "44.53565000"
                    },
                    {
                        "id": 476,
                        "name": "Mrgavet",
                        "latitude": "40.02789000",
                        "longitude": "44.48328000"
                    },
                    {
                        "id": 482,
                        "name": "Nizami",
                        "latitude": "40.09168000",
                        "longitude": "44.40570000"
                    },
                    {
                        "id": 487,
                        "name": "Norabats’",
                        "latitude": "40.10553000",
                        "longitude": "44.43329000"
                    },
                    {
                        "id": 489,
                        "name": "Noramarg",
                        "latitude": "40.02228000",
                        "longitude": "44.42511000"
                    },
                    {
                        "id": 491,
                        "name": "Norashen",
                        "latitude": "40.00130000",
                        "longitude": "44.59296000"
                    },
                    {
                        "id": 493,
                        "name": "Noyakert",
                        "latitude": "39.83069000",
                        "longitude": "44.66949000"
                    },
                    {
                        "id": 495,
                        "name": "Nshavan",
                        "latitude": "40.02787000",
                        "longitude": "44.52565000"
                    },
                    {
                        "id": 513,
                        "name": "Sayat’-Nova",
                        "latitude": "40.07507000",
                        "longitude": "44.40008000"
                    },
                    {
                        "id": 516,
                        "name": "Shahumyan",
                        "latitude": "39.94171000",
                        "longitude": "44.57233000"
                    },
                    {
                        "id": 525,
                        "name": "Sis",
                        "latitude": "40.05829000",
                        "longitude": "44.38892000"
                    },
                    {
                        "id": 526,
                        "name": "Sisavan",
                        "latitude": "39.90802000",
                        "longitude": "44.66721000"
                    },
                    {
                        "id": 531,
                        "name": "Surenavan",
                        "latitude": "39.79449000",
                        "longitude": "44.77508000"
                    },
                    {
                        "id": 560,
                        "name": "Vedi",
                        "latitude": "39.91388000",
                        "longitude": "44.72510000"
                    },
                    {
                        "id": 561,
                        "name": "Verin Artashat",
                        "latitude": "39.99731000",
                        "longitude": "44.58893000"
                    },
                    {
                        "id": 562,
                        "name": "Verin Dvin",
                        "latitude": "40.02434000",
                        "longitude": "44.59038000"
                    },
                    {
                        "id": 568,
                        "name": "Vosketap’",
                        "latitude": "39.88114000",
                        "longitude": "44.64917000"
                    },
                    {
                        "id": 571,
                        "name": "Vostan",
                        "latitude": "39.96515000",
                        "longitude": "44.55937000"
                    },
                    {
                        "id": 574,
                        "name": "Yeghegnavan",
                        "latitude": "39.83893000",
                        "longitude": "44.61951000"
                    },
                    {
                        "id": 582,
                        "name": "Zangakatun",
                        "latitude": "39.82233000",
                        "longitude": "45.04169000"
                    },
                    {
                        "id": 585,
                        "name": "Zorak",
                        "latitude": "40.09168000",
                        "longitude": "44.39447000"
                    }
                ]
            },
            {
                "id": 2026,
                "name": "Armavir",
                "iso2": "AV",
                "latitude": "40.15546310",
                "longitude": "44.03724460",
                "type": "region",
                "cities": [
                    {
                        "id": 289,
                        "name": "Aghavnatun",
                        "latitude": "40.23330000",
                        "longitude": "44.25295000"
                    },
                    {
                        "id": 292,
                        "name": "Aknalich",
                        "latitude": "40.14728000",
                        "longitude": "44.16669000"
                    },
                    {
                        "id": 293,
                        "name": "Aknashen",
                        "latitude": "40.09551000",
                        "longitude": "44.28604000"
                    },
                    {
                        "id": 297,
                        "name": "Alashkert",
                        "latitude": "40.10712000",
                        "longitude": "44.05108000"
                    },
                    {
                        "id": 302,
                        "name": "Apaga",
                        "latitude": "40.09729000",
                        "longitude": "44.25293000"
                    },
                    {
                        "id": 306,
                        "name": "Arak’s",
                        "latitude": "40.05548000",
                        "longitude": "44.30292000"
                    },
                    {
                        "id": 310,
                        "name": "Arazap’",
                        "latitude": "40.04169000",
                        "longitude": "44.14728000"
                    },
                    {
                        "id": 311,
                        "name": "Arbat’",
                        "latitude": "40.13892000",
                        "longitude": "44.40289000"
                    },
                    {
                        "id": 315,
                        "name": "Arevashat",
                        "latitude": "40.14447000",
                        "longitude": "44.37512000"
                    },
                    {
                        "id": 317,
                        "name": "Arevik",
                        "latitude": "40.10010000",
                        "longitude": "44.09448000"
                    },
                    {
                        "id": 322,
                        "name": "Argavand",
                        "latitude": "40.06110000",
                        "longitude": "44.09448000"
                    },
                    {
                        "id": 325,
                        "name": "Armavir",
                        "latitude": "40.15446000",
                        "longitude": "44.03815000"
                    },
                    {
                        "id": 327,
                        "name": "Arshaluys",
                        "latitude": "40.16949000",
                        "longitude": "44.21393000"
                    },
                    {
                        "id": 330,
                        "name": "Artimet",
                        "latitude": "40.15008000",
                        "longitude": "44.26672000"
                    },
                    {
                        "id": 340,
                        "name": "Aygek",
                        "latitude": "40.18890000",
                        "longitude": "44.38611000"
                    },
                    {
                        "id": 342,
                        "name": "Aygeshat",
                        "latitude": "40.07507000",
                        "longitude": "44.06110000"
                    },
                    {
                        "id": 347,
                        "name": "Baghramyan",
                        "latitude": "40.19452000",
                        "longitude": "44.36951000"
                    },
                    {
                        "id": 350,
                        "name": "Bambakashat",
                        "latitude": "40.10828000",
                        "longitude": "44.01947000"
                    },
                    {
                        "id": 367,
                        "name": "Dalarik",
                        "latitude": "40.22790000",
                        "longitude": "43.87793000"
                    },
                    {
                        "id": 374,
                        "name": "Doghs",
                        "latitude": "40.22229000",
                        "longitude": "44.27228000"
                    },
                    {
                        "id": 388,
                        "name": "Gay",
                        "latitude": "40.08444000",
                        "longitude": "44.30528000"
                    },
                    {
                        "id": 389,
                        "name": "Geghakert",
                        "latitude": "40.18516000",
                        "longitude": "44.24331000"
                    },
                    {
                        "id": 392,
                        "name": "Geghanist",
                        "latitude": "40.14587000",
                        "longitude": "44.43048000"
                    },
                    {
                        "id": 394,
                        "name": "Getashen",
                        "latitude": "40.04449000",
                        "longitude": "43.94171000"
                    },
                    {
                        "id": 398,
                        "name": "Gmbet’",
                        "latitude": "40.22369000",
                        "longitude": "44.25409000"
                    },
                    {
                        "id": 403,
                        "name": "Griboyedov",
                        "latitude": "40.11307000",
                        "longitude": "44.27169000"
                    },
                    {
                        "id": 410,
                        "name": "Haykashen",
                        "latitude": "40.07233000",
                        "longitude": "44.30829000"
                    },
                    {
                        "id": 414,
                        "name": "Hovtamej",
                        "latitude": "40.18329000",
                        "longitude": "44.25848000"
                    },
                    {
                        "id": 419,
                        "name": "Janfida",
                        "latitude": "40.04449000",
                        "longitude": "44.02789000"
                    },
                    {
                        "id": 433,
                        "name": "Khoronk’",
                        "latitude": "40.13611000",
                        "longitude": "44.24731000"
                    },
                    {
                        "id": 440,
                        "name": "Lenughi",
                        "latitude": "40.12512000",
                        "longitude": "43.96393000"
                    },
                    {
                        "id": 448,
                        "name": "Lukashin",
                        "latitude": "40.18726000",
                        "longitude": "44.00390000"
                    },
                    {
                        "id": 454,
                        "name": "Margara",
                        "latitude": "40.03332000",
                        "longitude": "44.18048000"
                    },
                    {
                        "id": 461,
                        "name": "Mayisyan",
                        "latitude": "40.15701000",
                        "longitude": "44.09192000"
                    },
                    {
                        "id": 465,
                        "name": "Merdzavan",
                        "latitude": "40.18140000",
                        "longitude": "44.40033000"
                    },
                    {
                        "id": 469,
                        "name": "Metsamor",
                        "latitude": "40.14447000",
                        "longitude": "44.11670000"
                    },
                    {
                        "id": 473,
                        "name": "Mrgashat",
                        "latitude": "40.13068000",
                        "longitude": "44.08069000"
                    },
                    {
                        "id": 477,
                        "name": "Musalerr",
                        "latitude": "40.15570000",
                        "longitude": "44.37793000"
                    },
                    {
                        "id": 478,
                        "name": "Myasnikyan",
                        "latitude": "40.18048000",
                        "longitude": "43.91949000"
                    },
                    {
                        "id": 479,
                        "name": "Nalbandyan",
                        "latitude": "40.06390000",
                        "longitude": "43.98889000"
                    },
                    {
                        "id": 483,
                        "name": "Nor Armavir",
                        "latitude": "40.08612000",
                        "longitude": "43.99451000"
                    },
                    {
                        "id": 488,
                        "name": "Norakert",
                        "latitude": "40.19733000",
                        "longitude": "44.35010000"
                    },
                    {
                        "id": 504,
                        "name": "P’shatavan",
                        "latitude": "40.03888000",
                        "longitude": "44.06671000"
                    },
                    {
                        "id": 502,
                        "name": "Ptghunk’",
                        "latitude": "40.16388000",
                        "longitude": "44.36389000"
                    },
                    {
                        "id": 509,
                        "name": "Sardarapat",
                        "latitude": "40.13206000",
                        "longitude": "44.00969000"
                    },
                    {
                        "id": 519,
                        "name": "Shenavan",
                        "latitude": "40.05548000",
                        "longitude": "43.93048000"
                    },
                    {
                        "id": 532,
                        "name": "Tandzut",
                        "latitude": "40.06952000",
                        "longitude": "44.07788000"
                    },
                    {
                        "id": 533,
                        "name": "Taronik",
                        "latitude": "40.13367000",
                        "longitude": "44.19957000"
                    },
                    {
                        "id": 539,
                        "name": "Tsaghkunk’",
                        "latitude": "40.18048000",
                        "longitude": "44.27228000"
                    },
                    {
                        "id": 540,
                        "name": "Tsiatsan",
                        "latitude": "40.18610000",
                        "longitude": "44.26947000"
                    },
                    {
                        "id": 549,
                        "name": "Vagharshapat",
                        "latitude": "40.16557000",
                        "longitude": "44.29462000"
                    },
                    {
                        "id": 567,
                        "name": "Voskehat",
                        "latitude": "40.14172000",
                        "longitude": "44.33069000"
                    },
                    {
                        "id": 575,
                        "name": "Yeghegnut",
                        "latitude": "40.08893000",
                        "longitude": "44.16669000"
                    },
                    {
                        "id": 579,
                        "name": "Yeraskhahun",
                        "latitude": "40.07233000",
                        "longitude": "44.21948000"
                    }
                ]
            },
            {
                "id": 2028,
                "name": "Gegharkunik",
                "iso2": "GR",
                "latitude": "40.35264260",
                "longitude": "45.12604140",
                "type": "region",
                "cities": [
                    {
                        "id": 296,
                        "name": "Akunk’",
                        "latitude": "40.15886000",
                        "longitude": "45.72568000"
                    },
                    {
                        "id": 336,
                        "name": "Astghadzor",
                        "latitude": "40.12231000",
                        "longitude": "45.35553000"
                    },
                    {
                        "id": 364,
                        "name": "Chambarak",
                        "latitude": "40.59655000",
                        "longitude": "45.35498000"
                    },
                    {
                        "id": 371,
                        "name": "Ddmashen",
                        "latitude": "40.57028000",
                        "longitude": "44.82295000"
                    },
                    {
                        "id": 375,
                        "name": "Drakhtik",
                        "latitude": "40.56497000",
                        "longitude": "45.23670000"
                    },
                    {
                        "id": 380,
                        "name": "Dzoragyugh",
                        "latitude": "40.16957000",
                        "longitude": "45.18337000"
                    },
                    {
                        "id": 384,
                        "name": "Gagarin",
                        "latitude": "40.54026000",
                        "longitude": "44.86962000"
                    },
                    {
                        "id": 385,
                        "name": "Gandzak",
                        "latitude": "40.31472000",
                        "longitude": "45.11139000"
                    },
                    {
                        "id": 387,
                        "name": "Gavarr",
                        "latitude": "40.35398000",
                        "longitude": "45.12386000"
                    },
                    {
                        "id": 390,
                        "name": "Geghamasar",
                        "latitude": "40.31091000",
                        "longitude": "45.67924000"
                    },
                    {
                        "id": 391,
                        "name": "Geghamavan",
                        "latitude": "40.56250000",
                        "longitude": "44.88892000"
                    },
                    {
                        "id": 427,
                        "name": "Karanlukh",
                        "latitude": "40.10444000",
                        "longitude": "45.28972000"
                    },
                    {
                        "id": 429,
                        "name": "Karchaghbyur",
                        "latitude": "40.17048000",
                        "longitude": "45.57785000"
                    },
                    {
                        "id": 437,
                        "name": "Lanjaghbyur",
                        "latitude": "40.26947000",
                        "longitude": "45.14447000"
                    },
                    {
                        "id": 438,
                        "name": "Lchap’",
                        "latitude": "40.45569000",
                        "longitude": "45.07507000"
                    },
                    {
                        "id": 439,
                        "name": "Lchashen",
                        "latitude": "40.51947000",
                        "longitude": "44.93048000"
                    },
                    {
                        "id": 446,
                        "name": "Lichk’",
                        "latitude": "40.15933000",
                        "longitude": "45.23467000"
                    },
                    {
                        "id": 450,
                        "name": "Madina",
                        "latitude": "40.07637000",
                        "longitude": "45.25507000"
                    },
                    {
                        "id": 457,
                        "name": "Martuni",
                        "latitude": "40.08333000",
                        "longitude": "45.25000000"
                    },
                    {
                        "id": 467,
                        "name": "Mets Masrik",
                        "latitude": "40.21948000",
                        "longitude": "45.76391000"
                    },
                    {
                        "id": 481,
                        "name": "Nerk’in Getashen",
                        "latitude": "40.14172000",
                        "longitude": "45.27087000"
                    },
                    {
                        "id": 492,
                        "name": "Noratus",
                        "latitude": "40.37793000",
                        "longitude": "45.18048000"
                    },
                    {
                        "id": 511,
                        "name": "Sarukhan",
                        "latitude": "40.29169000",
                        "longitude": "45.13068000"
                    },
                    {
                        "id": 514,
                        "name": "Sevan",
                        "latitude": "40.54730000",
                        "longitude": "44.94171000"
                    },
                    {
                        "id": 541,
                        "name": "Tsovagyugh",
                        "latitude": "40.63348000",
                        "longitude": "44.96112000"
                    },
                    {
                        "id": 542,
                        "name": "Tsovak",
                        "latitude": "40.18254000",
                        "longitude": "45.63286000"
                    },
                    {
                        "id": 543,
                        "name": "Tsovasar",
                        "latitude": "40.13820000",
                        "longitude": "45.19096000"
                    },
                    {
                        "id": 544,
                        "name": "Tsovazard",
                        "latitude": "40.47510000",
                        "longitude": "45.05011000"
                    },
                    {
                        "id": 545,
                        "name": "Tsovinar",
                        "latitude": "40.15959000",
                        "longitude": "45.46786000"
                    },
                    {
                        "id": 550,
                        "name": "Vaghashen",
                        "latitude": "40.13611000",
                        "longitude": "45.33069000"
                    },
                    {
                        "id": 552,
                        "name": "Vahan",
                        "latitude": "40.57549000",
                        "longitude": "45.39769000"
                    },
                    {
                        "id": 556,
                        "name": "Vardenik",
                        "latitude": "40.13348000",
                        "longitude": "45.44311000"
                    },
                    {
                        "id": 557,
                        "name": "Vardenis",
                        "latitude": "40.18329000",
                        "longitude": "45.73053000"
                    },
                    {
                        "id": 558,
                        "name": "Varser",
                        "latitude": "40.55548000",
                        "longitude": "44.90832000"
                    },
                    {
                        "id": 563,
                        "name": "Verin Getashen",
                        "latitude": "40.13068000",
                        "longitude": "45.25293000"
                    },
                    {
                        "id": 578,
                        "name": "Yeranos",
                        "latitude": "40.20428000",
                        "longitude": "45.19209000"
                    }
                ]
            },
            {
                "id": 2033,
                "name": "Kotayk",
                "iso2": "KT",
                "latitude": "40.54102140",
                "longitude": "44.76901480",
                "type": "region",
                "cities": [
                    {
                        "id": 281,
                        "name": "Abovyan",
                        "latitude": "40.27368000",
                        "longitude": "44.63348000"
                    },
                    {
                        "id": 287,
                        "name": "Aghavnadzor",
                        "latitude": "40.58195000",
                        "longitude": "44.69581000"
                    },
                    {
                        "id": 295,
                        "name": "Akunk’",
                        "latitude": "40.26672000",
                        "longitude": "44.68610000"
                    },
                    {
                        "id": 308,
                        "name": "Aramus",
                        "latitude": "40.25095000",
                        "longitude": "44.66351000"
                    },
                    {
                        "id": 323,
                        "name": "Argel",
                        "latitude": "40.37793000",
                        "longitude": "44.60010000"
                    },
                    {
                        "id": 332,
                        "name": "Arzakan",
                        "latitude": "40.45007000",
                        "longitude": "44.60828000"
                    },
                    {
                        "id": 333,
                        "name": "Arzni",
                        "latitude": "40.29730000",
                        "longitude": "44.59869000"
                    },
                    {
                        "id": 349,
                        "name": "Balahovit",
                        "latitude": "40.25153000",
                        "longitude": "44.60828000"
                    },
                    {
                        "id": 357,
                        "name": "Bjni",
                        "latitude": "40.45831000",
                        "longitude": "44.65008000"
                    },
                    {
                        "id": 360,
                        "name": "Buzhakan",
                        "latitude": "40.45569000",
                        "longitude": "44.51947000"
                    },
                    {
                        "id": 363,
                        "name": "Byureghavan",
                        "latitude": "40.31417000",
                        "longitude": "44.59333000"
                    },
                    {
                        "id": 379,
                        "name": "Dzoraghbyur",
                        "latitude": "40.20412000",
                        "longitude": "44.64150000"
                    },
                    {
                        "id": 382,
                        "name": "Fantan",
                        "latitude": "40.39447000",
                        "longitude": "44.68610000"
                    },
                    {
                        "id": 386,
                        "name": "Garrni",
                        "latitude": "40.11931000",
                        "longitude": "44.73442000"
                    },
                    {
                        "id": 400,
                        "name": "Goght’",
                        "latitude": "40.13470000",
                        "longitude": "44.78332000"
                    },
                    {
                        "id": 417,
                        "name": "Hrazdan",
                        "latitude": "40.49748000",
                        "longitude": "44.76620000"
                    },
                    {
                        "id": 426,
                        "name": "Kaputan",
                        "latitude": "40.32507000",
                        "longitude": "44.70007000"
                    },
                    {
                        "id": 435,
                        "name": "Kotayk’",
                        "latitude": "40.27789000",
                        "longitude": "44.66388000"
                    },
                    {
                        "id": 442,
                        "name": "Lerrnanist",
                        "latitude": "40.46676000",
                        "longitude": "44.79249000"
                    },
                    {
                        "id": 459,
                        "name": "Mayakovski",
                        "latitude": "40.25293000",
                        "longitude": "44.63892000"
                    },
                    {
                        "id": 462,
                        "name": "Meghradzor",
                        "latitude": "40.60611000",
                        "longitude": "44.65147000"
                    },
                    {
                        "id": 474,
                        "name": "Mrgashen",
                        "latitude": "40.28607000",
                        "longitude": "44.54449000"
                    },
                    {
                        "id": 484,
                        "name": "Nor Geghi",
                        "latitude": "40.32233000",
                        "longitude": "44.58331000"
                    },
                    {
                        "id": 485,
                        "name": "Nor Gyugh",
                        "latitude": "40.26672000",
                        "longitude": "44.65832000"
                    },
                    {
                        "id": 500,
                        "name": "Prroshyan",
                        "latitude": "40.24731000",
                        "longitude": "44.41949000"
                    },
                    {
                        "id": 501,
                        "name": "Ptghni",
                        "latitude": "40.25568000",
                        "longitude": "44.58612000"
                    },
                    {
                        "id": 527,
                        "name": "Solak",
                        "latitude": "40.46252000",
                        "longitude": "44.70709000"
                    },
                    {
                        "id": 537,
                        "name": "Tsaghkadzor",
                        "latitude": "40.53259000",
                        "longitude": "44.72025000"
                    },
                    {
                        "id": 577,
                        "name": "Yeghvard",
                        "latitude": "40.32507000",
                        "longitude": "44.48608000"
                    },
                    {
                        "id": 583,
                        "name": "Zarr",
                        "latitude": "40.25848000",
                        "longitude": "44.73328000"
                    },
                    {
                        "id": 586,
                        "name": "Zoravan",
                        "latitude": "40.35553000",
                        "longitude": "44.52228000"
                    },
                    {
                        "id": 587,
                        "name": "Zovaber",
                        "latitude": "40.56671000",
                        "longitude": "44.79028000"
                    }
                ]
            },
            {
                "id": 2029,
                "name": "Lori",
                "iso2": "LO",
                "latitude": "40.96984520",
                "longitude": "44.49001380",
                "type": "region",
                "cities": [
                    {
                        "id": 283,
                        "name": "Agarak",
                        "latitude": "41.01072000",
                        "longitude": "44.46845000"
                    },
                    {
                        "id": 290,
                        "name": "Akht’ala",
                        "latitude": "41.16838000",
                        "longitude": "44.75811000"
                    },
                    {
                        "id": 298,
                        "name": "Alaverdi",
                        "latitude": "41.09766000",
                        "longitude": "44.67316000"
                    },
                    {
                        "id": 316,
                        "name": "Arevashogh",
                        "latitude": "40.86039000",
                        "longitude": "44.27438000"
                    },
                    {
                        "id": 353,
                        "name": "Bazum",
                        "latitude": "40.86763000",
                        "longitude": "44.43978000"
                    },
                    {
                        "id": 365,
                        "name": "Chochkan",
                        "latitude": "41.18118000",
                        "longitude": "44.83217000"
                    },
                    {
                        "id": 369,
                        "name": "Darpas",
                        "latitude": "40.83674000",
                        "longitude": "44.42494000"
                    },
                    {
                        "id": 376,
                        "name": "Dsegh",
                        "latitude": "40.96170000",
                        "longitude": "44.65003000"
                    },
                    {
                        "id": 383,
                        "name": "Fioletovo",
                        "latitude": "40.72241000",
                        "longitude": "44.71769000"
                    },
                    {
                        "id": 399,
                        "name": "Gogaran",
                        "latitude": "40.89255000",
                        "longitude": "44.19915000"
                    },
                    {
                        "id": 404,
                        "name": "Gugark’",
                        "latitude": "40.80460000",
                        "longitude": "44.54025000"
                    },
                    {
                        "id": 405,
                        "name": "Gyulagarak",
                        "latitude": "40.96715000",
                        "longitude": "44.47144000"
                    },
                    {
                        "id": 423,
                        "name": "Jrashen",
                        "latitude": "40.79028000",
                        "longitude": "44.18664000"
                    },
                    {
                        "id": 443,
                        "name": "Lerrnants’k’",
                        "latitude": "40.79532000",
                        "longitude": "44.27435000"
                    },
                    {
                        "id": 444,
                        "name": "Lerrnapat",
                        "latitude": "40.81538000",
                        "longitude": "44.39344000"
                    },
                    {
                        "id": 445,
                        "name": "Lerrnavan",
                        "latitude": "40.78820000",
                        "longitude": "44.16024000"
                    },
                    {
                        "id": 447,
                        "name": "Lorut",
                        "latitude": "40.93717000",
                        "longitude": "44.77142000"
                    },
                    {
                        "id": 453,
                        "name": "Margahovit",
                        "latitude": "40.73381000",
                        "longitude": "44.68474000"
                    },
                    {
                        "id": 468,
                        "name": "Mets Parni",
                        "latitude": "40.83472000",
                        "longitude": "44.11108000"
                    },
                    {
                        "id": 470,
                        "name": "Metsavan",
                        "latitude": "41.20156000",
                        "longitude": "44.22877000"
                    },
                    {
                        "id": 490,
                        "name": "Norashen",
                        "latitude": "41.18886000",
                        "longitude": "44.33336000"
                    },
                    {
                        "id": 496,
                        "name": "Odzun",
                        "latitude": "41.05321000",
                        "longitude": "44.61341000"
                    },
                    {
                        "id": 506,
                        "name": "Sarahart’",
                        "latitude": "40.87043000",
                        "longitude": "44.21407000"
                    },
                    {
                        "id": 507,
                        "name": "Saramej",
                        "latitude": "40.77487000",
                        "longitude": "44.22220000"
                    },
                    {
                        "id": 517,
                        "name": "Shahumyan",
                        "latitude": "40.77482000",
                        "longitude": "44.54596000"
                    },
                    {
                        "id": 523,
                        "name": "Shirakamut",
                        "latitude": "40.86056000",
                        "longitude": "44.15278000"
                    },
                    {
                        "id": 524,
                        "name": "Shnogh",
                        "latitude": "41.14693000",
                        "longitude": "44.84043000"
                    },
                    {
                        "id": 529,
                        "name": "Spitak",
                        "latitude": "40.83221000",
                        "longitude": "44.26731000"
                    },
                    {
                        "id": 530,
                        "name": "Step’anavan",
                        "latitude": "41.00995000",
                        "longitude": "44.38531000"
                    },
                    {
                        "id": 534,
                        "name": "Tashir",
                        "latitude": "41.12072000",
                        "longitude": "44.28462000"
                    },
                    {
                        "id": 536,
                        "name": "Tsaghkaber",
                        "latitude": "40.79849000",
                        "longitude": "44.10144000"
                    },
                    {
                        "id": 547,
                        "name": "Urrut",
                        "latitude": "41.06778000",
                        "longitude": "44.39628000"
                    },
                    {
                        "id": 551,
                        "name": "Vahagni",
                        "latitude": "40.90698000",
                        "longitude": "44.60873000"
                    },
                    {
                        "id": 553,
                        "name": "Vanadzor",
                        "latitude": "40.80456000",
                        "longitude": "44.49390000"
                    },
                    {
                        "id": 554,
                        "name": "Vardablur",
                        "latitude": "40.97083000",
                        "longitude": "44.50889000"
                    },
                    {
                        "id": 576,
                        "name": "Yeghegnut",
                        "latitude": "40.90302000",
                        "longitude": "44.63155000"
                    }
                ]
            },
            {
                "id": 2031,
                "name": "Shirak",
                "iso2": "SH",
                "latitude": "40.96308140",
                "longitude": "43.81024610",
                "type": "region",
                "cities": [
                    {
                        "id": 291,
                        "name": "Akhuryan",
                        "latitude": "40.78003000",
                        "longitude": "43.90027000"
                    },
                    {
                        "id": 299,
                        "name": "Amasia",
                        "latitude": "40.95442000",
                        "longitude": "43.78720000"
                    },
                    {
                        "id": 301,
                        "name": "Anushavan",
                        "latitude": "40.65008000",
                        "longitude": "43.98053000"
                    },
                    {
                        "id": 318,
                        "name": "Arevik",
                        "latitude": "40.74170000",
                        "longitude": "43.90430000"
                    },
                    {
                        "id": 320,
                        "name": "Arevshat",
                        "latitude": "40.65345000",
                        "longitude": "44.04419000"
                    },
                    {
                        "id": 326,
                        "name": "Arrap’i",
                        "latitude": "40.78276000",
                        "longitude": "43.80583000"
                    },
                    {
                        "id": 346,
                        "name": "Azatan",
                        "latitude": "40.71959000",
                        "longitude": "43.82727000"
                    },
                    {
                        "id": 352,
                        "name": "Basen",
                        "latitude": "40.75767000",
                        "longitude": "43.99274000"
                    },
                    {
                        "id": 378,
                        "name": "Dzit’hank’ov",
                        "latitude": "40.50848000",
                        "longitude": "43.82092000"
                    },
                    {
                        "id": 406,
                        "name": "Gyumri",
                        "latitude": "40.79420000",
                        "longitude": "43.84528000"
                    },
                    {
                        "id": 411,
                        "name": "Haykavan",
                        "latitude": "40.80312000",
                        "longitude": "43.75173000"
                    },
                    {
                        "id": 413,
                        "name": "Horrom",
                        "latitude": "40.65973000",
                        "longitude": "43.89032000"
                    },
                    {
                        "id": 424,
                        "name": "Kamo",
                        "latitude": "40.82572000",
                        "longitude": "43.95071000"
                    },
                    {
                        "id": 441,
                        "name": "Lerrnakert",
                        "latitude": "40.56250000",
                        "longitude": "43.93890000"
                    },
                    {
                        "id": 452,
                        "name": "Maralik",
                        "latitude": "40.57507000",
                        "longitude": "43.87231000"
                    },
                    {
                        "id": 456,
                        "name": "Marmashen",
                        "latitude": "40.83486000",
                        "longitude": "43.77790000"
                    },
                    {
                        "id": 460,
                        "name": "Mayisyan",
                        "latitude": "40.84715000",
                        "longitude": "43.83938000"
                    },
                    {
                        "id": 463,
                        "name": "Meghrashen",
                        "latitude": "40.67230000",
                        "longitude": "43.95831000"
                    },
                    {
                        "id": 466,
                        "name": "Mets Mant’ash",
                        "latitude": "40.64376000",
                        "longitude": "44.05653000"
                    },
                    {
                        "id": 503,
                        "name": "P’ok’r Mant’ash",
                        "latitude": "40.64026000",
                        "longitude": "44.04666000"
                    },
                    {
                        "id": 499,
                        "name": "Pemzashen",
                        "latitude": "40.58612000",
                        "longitude": "43.94311000"
                    },
                    {
                        "id": 508,
                        "name": "Saratak",
                        "latitude": "40.67090000",
                        "longitude": "43.87231000"
                    },
                    {
                        "id": 522,
                        "name": "Shirak",
                        "latitude": "40.84042000",
                        "longitude": "43.91582000"
                    },
                    {
                        "id": 528,
                        "name": "Spandaryan",
                        "latitude": "40.66105000",
                        "longitude": "44.01551000"
                    },
                    {
                        "id": 566,
                        "name": "Voskehask",
                        "latitude": "40.76426000",
                        "longitude": "43.77474000"
                    },
                    {
                        "id": 580,
                        "name": "Yerazgavors",
                        "latitude": "40.69505000",
                        "longitude": "43.74722000"
                    }
                ]
            },
            {
                "id": 2027,
                "name": "Syunik",
                "iso2": "SU",
                "latitude": "39.51331120",
                "longitude": "46.33932340",
                "type": "region",
                "cities": [
                    {
                        "id": 284,
                        "name": "Agarak",
                        "latitude": "39.20684000",
                        "longitude": "46.54460000"
                    },
                    {
                        "id": 294,
                        "name": "Akner",
                        "latitude": "39.53491000",
                        "longitude": "46.30732000"
                    },
                    {
                        "id": 300,
                        "name": "Angeghakot’",
                        "latitude": "39.56952000",
                        "longitude": "45.94452000"
                    },
                    {
                        "id": 358,
                        "name": "Brrnakot’",
                        "latitude": "39.49742000",
                        "longitude": "45.97241000"
                    },
                    {
                        "id": 381,
                        "name": "Dzorastan",
                        "latitude": "39.27059000",
                        "longitude": "46.35720000"
                    },
                    {
                        "id": 402,
                        "name": "Goris",
                        "latitude": "39.51111000",
                        "longitude": "46.34168000"
                    },
                    {
                        "id": 408,
                        "name": "Hats’avan",
                        "latitude": "39.46405000",
                        "longitude": "45.97047000"
                    },
                    {
                        "id": 425,
                        "name": "Kapan",
                        "latitude": "39.20755000",
                        "longitude": "46.40576000"
                    },
                    {
                        "id": 432,
                        "name": "Khndzoresk",
                        "latitude": "39.50568000",
                        "longitude": "46.43610000"
                    },
                    {
                        "id": 464,
                        "name": "Meghri",
                        "latitude": "38.90292000",
                        "longitude": "46.24458000"
                    },
                    {
                        "id": 515,
                        "name": "Shaghat",
                        "latitude": "39.55698000",
                        "longitude": "45.90727000"
                    },
                    {
                        "id": 521,
                        "name": "Shinuhayr",
                        "latitude": "39.43670000",
                        "longitude": "46.31787000"
                    },
                    {
                        "id": 535,
                        "name": "Tegh",
                        "latitude": "39.55826000",
                        "longitude": "46.48054000"
                    },
                    {
                        "id": 564,
                        "name": "Verishen",
                        "latitude": "39.53543000",
                        "longitude": "46.32063000"
                    }
                ]
            },
            {
                "id": 2032,
                "name": "Tavush",
                "iso2": "TV",
                "latitude": "40.88662960",
                "longitude": "45.33934900",
                "type": "region",
                "cities": [
                    {
                        "id": 312,
                        "name": "Archis",
                        "latitude": "41.16351000",
                        "longitude": "44.87631000"
                    },
                    {
                        "id": 331,
                        "name": "Artsvaberd",
                        "latitude": "40.83947000",
                        "longitude": "45.47033000"
                    },
                    {
                        "id": 339,
                        "name": "Aygehovit",
                        "latitude": "40.97951000",
                        "longitude": "45.25033000"
                    },
                    {
                        "id": 345,
                        "name": "Azatamut",
                        "latitude": "40.98204000",
                        "longitude": "45.18551000"
                    },
                    {
                        "id": 348,
                        "name": "Bagratashen",
                        "latitude": "41.24358000",
                        "longitude": "44.81737000"
                    },
                    {
                        "id": 354,
                        "name": "Berd",
                        "latitude": "40.88135000",
                        "longitude": "45.38901000"
                    },
                    {
                        "id": 355,
                        "name": "Berdavan",
                        "latitude": "41.20503000",
                        "longitude": "44.99967000"
                    },
                    {
                        "id": 372,
                        "name": "Dilijan",
                        "latitude": "40.74170000",
                        "longitude": "44.85010000"
                    },
                    {
                        "id": 407,
                        "name": "Haghartsin",
                        "latitude": "40.77614000",
                        "longitude": "44.96847000"
                    },
                    {
                        "id": 418,
                        "name": "Ijevan",
                        "latitude": "40.87877000",
                        "longitude": "45.14851000"
                    },
                    {
                        "id": 431,
                        "name": "Khasht’arrak",
                        "latitude": "40.93668000",
                        "longitude": "45.18210000"
                    },
                    {
                        "id": 471,
                        "name": "Mosesgegh",
                        "latitude": "40.90534000",
                        "longitude": "45.48838000"
                    },
                    {
                        "id": 480,
                        "name": "Navur",
                        "latitude": "40.86695000",
                        "longitude": "45.34179000"
                    },
                    {
                        "id": 494,
                        "name": "Noyemberyan",
                        "latitude": "41.17244000",
                        "longitude": "44.99917000"
                    },
                    {
                        "id": 498,
                        "name": "Parravak’ar",
                        "latitude": "40.98248000",
                        "longitude": "45.36696000"
                    },
                    {
                        "id": 510,
                        "name": "Sarigyugh",
                        "latitude": "41.03531000",
                        "longitude": "45.14486000"
                    },
                    {
                        "id": 569,
                        "name": "Voskevan",
                        "latitude": "41.12081000",
                        "longitude": "45.06381000"
                    }
                ]
            },
            {
                "id": 2025,
                "name": "Vayots Dzor",
                "iso2": "VD",
                "latitude": "39.76419960",
                "longitude": "45.33375280",
                "type": "region",
                "cities": [
                    {
                        "id": 285,
                        "name": "Agarakadzor",
                        "latitude": "39.73608000",
                        "longitude": "45.35553000"
                    },
                    {
                        "id": 288,
                        "name": "Aghavnadzor",
                        "latitude": "39.78607000",
                        "longitude": "45.22790000"
                    },
                    {
                        "id": 313,
                        "name": "Areni",
                        "latitude": "39.71668000",
                        "longitude": "45.18329000"
                    },
                    {
                        "id": 393,
                        "name": "Getap’",
                        "latitude": "39.76392000",
                        "longitude": "45.30829000"
                    },
                    {
                        "id": 397,
                        "name": "Gladzor",
                        "latitude": "39.78070000",
                        "longitude": "45.34729000"
                    },
                    {
                        "id": 420,
                        "name": "Jermuk",
                        "latitude": "39.84168000",
                        "longitude": "45.66949000"
                    },
                    {
                        "id": 451,
                        "name": "Malishka",
                        "latitude": "39.74731000",
                        "longitude": "45.40570000"
                    },
                    {
                        "id": 505,
                        "name": "Rrind",
                        "latitude": "39.76111000",
                        "longitude": "45.17792000"
                    },
                    {
                        "id": 518,
                        "name": "Shatin",
                        "latitude": "39.83612000",
                        "longitude": "45.30292000"
                    },
                    {
                        "id": 559,
                        "name": "Vayk’",
                        "latitude": "39.68890000",
                        "longitude": "45.46668000"
                    },
                    {
                        "id": 565,
                        "name": "Vernashen",
                        "latitude": "39.79236000",
                        "longitude": "45.36389000"
                    },
                    {
                        "id": 572,
                        "name": "Yeghegis",
                        "latitude": "39.87231000",
                        "longitude": "45.35010000"
                    },
                    {
                        "id": 573,
                        "name": "Yeghegnadzor",
                        "latitude": "39.76389000",
                        "longitude": "45.33239000"
                    },
                    {
                        "id": 584,
                        "name": "Zarrit’ap’",
                        "latitude": "39.63892000",
                        "longitude": "45.51111000"
                    }
                ]
            },
            {
                "id": 2030,
                "name": "Yerevan",
                "iso2": "ER",
                "latitude": "40.18720230",
                "longitude": "44.51520900",
                "type": "city",
                "cities": [
                    {
                        "id": 304,
                        "name": "Arabkir",
                        "latitude": "40.20549000",
                        "longitude": "44.50699000"
                    },
                    {
                        "id": 321,
                        "name": "Argavand",
                        "latitude": "40.15289000",
                        "longitude": "44.43890000"
                    },
                    {
                        "id": 422,
                        "name": "Jrashen",
                        "latitude": "40.05275000",
                        "longitude": "44.51259000"
                    },
                    {
                        "id": 436,
                        "name": "K’anak’erravan",
                        "latitude": "40.24739000",
                        "longitude": "44.53511000"
                    },
                    {
                        "id": 555,
                        "name": "Vardadzor",
                        "latitude": "40.18701000",
                        "longitude": "45.19212000"
                    },
                    {
                        "id": 581,
                        "name": "Yerevan",
                        "latitude": "40.18111000",
                        "longitude": "44.51361000"
                    }
                ]
            }
        ]
    },
    {
        "id": 13,
        "name": "Aruba",
        "iso3": "ABW",
        "iso2": "AW",
        "numeric_code": "533",
        "phonecode": "297",
        "capital": "Oranjestad",
        "currency": "AWG",
        "currency_name": "Aruban florin",
        "currency_symbol": "ƒ",
        "tld": ".aw",
        "native": "Aruba",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Aruban",
        "timezones": [
            {
                "zoneName": "America\/Aruba",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Aruba",
            "ko": "아루바",
            "pt-BR": "Aruba",
            "pt": "Aruba",
            "nl": "Aruba",
            "hr": "Aruba",
            "fa": "آروبا",
            "de": "Aruba",
            "es": "Aruba",
            "fr": "Aruba",
            "ja": "アルバ",
            "it": "Aruba",
            "zh-CN": "阿鲁巴",
            "tr": "Aruba",
            "ru": "Аруба",
            "uk": "Аруба",
            "pl": "Aruba"
        },
        "latitude": "12.50000000",
        "longitude": "-69.96666666",
        "emoji": "🇦🇼",
        "emojiU": "U+1F1E6 U+1F1FC",
        "states": [
            {
                "id": 5243,
                "name": "Noord",
                "iso2": null,
                "latitude": "12.58243290",
                "longitude": "-70.06761180",
                "type": "region",
                "cities": []
            },
            {
                "id": 5341,
                "name": "Oranjestad",
                "iso2": null,
                "latitude": "12.50837050",
                "longitude": "-70.05452530",
                "type": "capital city",
                "cities": []
            },
            {
                "id": 5245,
                "name": "Oranjestad East",
                "iso2": null,
                "latitude": "12.51331810",
                "longitude": "-70.05048180",
                "type": "region",
                "cities": []
            },
            {
                "id": 5244,
                "name": "Oranjestad West",
                "iso2": null,
                "latitude": "12.53522930",
                "longitude": "-70.06284040",
                "type": "region",
                "cities": []
            },
            {
                "id": 5246,
                "name": "Paradera",
                "iso2": null,
                "latitude": "12.53628710",
                "longitude": "-70.01485110",
                "type": "region",
                "cities": []
            },
            {
                "id": 5247,
                "name": "San Nicolaas Noord",
                "iso2": null,
                "latitude": "12.46427170",
                "longitude": "-69.94349390",
                "type": "region",
                "cities": []
            },
            {
                "id": 5248,
                "name": "San Nicolaas Zuid",
                "iso2": null,
                "latitude": "12.42785580",
                "longitude": "-69.93810790",
                "type": "region",
                "cities": []
            },
            {
                "id": 5249,
                "name": "Santa Cruz",
                "iso2": null,
                "latitude": "12.51128360",
                "longitude": "-69.98769660",
                "type": "region",
                "cities": []
            },
            {
                "id": 5250,
                "name": "Savaneta",
                "iso2": null,
                "latitude": "12.46184190",
                "longitude": "-69.98558580",
                "type": "region",
                "cities": []
            }
        ]
    },
    {
        "id": 14,
        "name": "Australia",
        "iso3": "AUS",
        "iso2": "AU",
        "numeric_code": "036",
        "phonecode": "61",
        "capital": "Canberra",
        "currency": "AUD",
        "currency_name": "Australian dollar",
        "currency_symbol": "$",
        "tld": ".au",
        "native": "Australia",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Australia and New Zealand",
        "subregion_id": 19,
        "nationality": "Australian",
        "timezones": [
            {
                "zoneName": "Antarctica\/Macquarie",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "MIST",
                "tzName": "Macquarie Island Station Time"
            },
            {
                "zoneName": "Australia\/Adelaide",
                "gmtOffset": 37800,
                "gmtOffsetName": "UTC+10:30",
                "abbreviation": "ACDT",
                "tzName": "Australian Central Daylight Saving Time"
            },
            {
                "zoneName": "Australia\/Brisbane",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "AEST",
                "tzName": "Australian Eastern Standard Time"
            },
            {
                "zoneName": "Australia\/Broken_Hill",
                "gmtOffset": 37800,
                "gmtOffsetName": "UTC+10:30",
                "abbreviation": "ACDT",
                "tzName": "Australian Central Daylight Saving Time"
            },
            {
                "zoneName": "Australia\/Currie",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "AEDT",
                "tzName": "Australian Eastern Daylight Saving Time"
            },
            {
                "zoneName": "Australia\/Darwin",
                "gmtOffset": 34200,
                "gmtOffsetName": "UTC+09:30",
                "abbreviation": "ACST",
                "tzName": "Australian Central Standard Time"
            },
            {
                "zoneName": "Australia\/Eucla",
                "gmtOffset": 31500,
                "gmtOffsetName": "UTC+08:45",
                "abbreviation": "ACWST",
                "tzName": "Australian Central Western Standard Time (Unofficial)"
            },
            {
                "zoneName": "Australia\/Hobart",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "AEDT",
                "tzName": "Australian Eastern Daylight Saving Time"
            },
            {
                "zoneName": "Australia\/Lindeman",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "AEST",
                "tzName": "Australian Eastern Standard Time"
            },
            {
                "zoneName": "Australia\/Lord_Howe",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "LHST",
                "tzName": "Lord Howe Summer Time"
            },
            {
                "zoneName": "Australia\/Melbourne",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "AEDT",
                "tzName": "Australian Eastern Daylight Saving Time"
            },
            {
                "zoneName": "Australia\/Perth",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "AWST",
                "tzName": "Australian Western Standard Time"
            },
            {
                "zoneName": "Australia\/Sydney",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "AEDT",
                "tzName": "Australian Eastern Daylight Saving Time"
            }
        ],
        "translations": {
            "br": "Aostralia",
            "ko": "호주",
            "pt-BR": "Austrália",
            "pt": "Austrália",
            "nl": "Australië",
            "hr": "Australija",
            "fa": "استرالیا",
            "de": "Australien",
            "es": "Australia",
            "fr": "Australie",
            "ja": "オーストラリア",
            "it": "Australia",
            "zh-CN": "澳大利亚",
            "tr": "Avustralya",
            "ru": "Австралия",
            "uk": "Австралія",
            "pl": "Australia"
        },
        "latitude": "-27.00000000",
        "longitude": "133.00000000",
        "emoji": "🇦🇺",
        "emojiU": "U+1F1E6 U+1F1FA",
        "states": [
            {
                "id": 3907,
                "name": "Australian Capital Territory",
                "iso2": "ACT",
                "latitude": "-35.47346790",
                "longitude": "149.01236790",
                "type": "territory",
                "cities": [
                    {
                        "id": 3915,
                        "name": "Acton",
                        "latitude": "-35.27767000",
                        "longitude": "149.11829000"
                    },
                    {
                        "id": 3923,
                        "name": "Ainslie",
                        "latitude": "-35.26255000",
                        "longitude": "149.14370000"
                    },
                    {
                        "id": 3974,
                        "name": "Amaroo",
                        "latitude": "-35.16959000",
                        "longitude": "149.12802000"
                    },
                    {
                        "id": 3995,
                        "name": "Aranda",
                        "latitude": "-35.25817000",
                        "longitude": "149.08040000"
                    },
                    {
                        "id": 4098,
                        "name": "Banks",
                        "latitude": "-35.47194000",
                        "longitude": "149.09965000"
                    },
                    {
                        "id": 4129,
                        "name": "Barton",
                        "latitude": "-35.30489000",
                        "longitude": "149.14121000"
                    },
                    {
                        "id": 4184,
                        "name": "Belconnen",
                        "latitude": "-35.23798000",
                        "longitude": "149.06627000"
                    },
                    {
                        "id": 4331,
                        "name": "Bonner",
                        "latitude": "-35.16225000",
                        "longitude": "149.13855000"
                    },
                    {
                        "id": 4338,
                        "name": "Bonython",
                        "latitude": "-35.43326000",
                        "longitude": "149.07822000"
                    },
                    {
                        "id": 4377,
                        "name": "Braddon",
                        "latitude": "-35.27078000",
                        "longitude": "149.13569000"
                    },
                    {
                        "id": 4436,
                        "name": "Bruce",
                        "latitude": "-35.24405000",
                        "longitude": "149.09083000"
                    },
                    {
                        "id": 4536,
                        "name": "Calwell",
                        "latitude": "-35.44042000",
                        "longitude": "149.10707000"
                    },
                    {
                        "id": 4555,
                        "name": "Campbell",
                        "latitude": "-35.28907000",
                        "longitude": "149.15382000"
                    },
                    {
                        "id": 4566,
                        "name": "Canberra",
                        "latitude": "-35.28346000",
                        "longitude": "149.12807000"
                    },
                    {
                        "id": 4621,
                        "name": "Casey",
                        "latitude": "-35.16701000",
                        "longitude": "149.09470000"
                    },
                    {
                        "id": 4662,
                        "name": "Chapman",
                        "latitude": "-35.35621000",
                        "longitude": "149.03742000"
                    },
                    {
                        "id": 4669,
                        "name": "Charnwood",
                        "latitude": "-35.20019000",
                        "longitude": "149.03412000"
                    },
                    {
                        "id": 4687,
                        "name": "Chifley",
                        "latitude": "-35.35340000",
                        "longitude": "149.07684000"
                    },
                    {
                        "id": 4697,
                        "name": "Chisholm",
                        "latitude": "-35.41249000",
                        "longitude": "149.12825000"
                    },
                    {
                        "id": 4708,
                        "name": "City",
                        "latitude": "-35.28125000",
                        "longitude": "149.12927000"
                    },
                    {
                        "id": 4787,
                        "name": "Conder",
                        "latitude": "-35.45926000",
                        "longitude": "149.10422000"
                    },
                    {
                        "id": 4799,
                        "name": "Cook",
                        "latitude": "-35.26014000",
                        "longitude": "149.06566000"
                    },
                    {
                        "id": 4816,
                        "name": "Coombs",
                        "latitude": "-35.31634000",
                        "longitude": "149.03941000"
                    },
                    {
                        "id": 4855,
                        "name": "Crace",
                        "latitude": "-35.20282000",
                        "longitude": "149.10736000"
                    },
                    {
                        "id": 4916,
                        "name": "Curtin",
                        "latitude": "-35.32464000",
                        "longitude": "149.07763000"
                    },
                    {
                        "id": 4957,
                        "name": "Deakin",
                        "latitude": "-35.31927000",
                        "longitude": "149.10308000"
                    },
                    {
                        "id": 4989,
                        "name": "Dickson",
                        "latitude": "-35.25082000",
                        "longitude": "149.13932000"
                    },
                    {
                        "id": 5024,
                        "name": "Downer",
                        "latitude": "-35.24457000",
                        "longitude": "149.14468000"
                    },
                    {
                        "id": 5036,
                        "name": "Duffy",
                        "latitude": "-35.33459000",
                        "longitude": "149.03188000"
                    },
                    {
                        "id": 5046,
                        "name": "Dunlop",
                        "latitude": "-35.19402000",
                        "longitude": "149.01984000"
                    },
                    {
                        "id": 5197,
                        "name": "Evatt",
                        "latitude": "-35.21191000",
                        "longitude": "149.06891000"
                    },
                    {
                        "id": 5204,
                        "name": "Fadden",
                        "latitude": "-35.40500000",
                        "longitude": "149.11662000"
                    },
                    {
                        "id": 5219,
                        "name": "Farrer",
                        "latitude": "-35.37673000",
                        "longitude": "149.10500000"
                    },
                    {
                        "id": 5239,
                        "name": "Fisher",
                        "latitude": "-35.36126000",
                        "longitude": "149.05704000"
                    },
                    {
                        "id": 5257,
                        "name": "Florey",
                        "latitude": "-35.22588000",
                        "longitude": "149.05000000"
                    },
                    {
                        "id": 5258,
                        "name": "Flynn",
                        "latitude": "-35.20593000",
                        "longitude": "149.04389000"
                    },
                    {
                        "id": 5261,
                        "name": "Forde",
                        "latitude": "-35.16823000",
                        "longitude": "149.14607000"
                    },
                    {
                        "id": 5270,
                        "name": "Forrest",
                        "latitude": "-35.31499000",
                        "longitude": "149.12859000"
                    },
                    {
                        "id": 5278,
                        "name": "Franklin",
                        "latitude": "-35.19946000",
                        "longitude": "149.14329000"
                    },
                    {
                        "id": 5284,
                        "name": "Fraser",
                        "latitude": "-35.19170000",
                        "longitude": "149.04534000"
                    },
                    {
                        "id": 5306,
                        "name": "Garran",
                        "latitude": "-35.34206000",
                        "longitude": "149.10846000"
                    },
                    {
                        "id": 5336,
                        "name": "Gilmore",
                        "latitude": "-35.41994000",
                        "longitude": "149.13481000"
                    },
                    {
                        "id": 5340,
                        "name": "Giralang",
                        "latitude": "-35.21093000",
                        "longitude": "149.09600000"
                    },
                    {
                        "id": 5420,
                        "name": "Gordon",
                        "latitude": "-35.45676000",
                        "longitude": "149.08498000"
                    },
                    {
                        "id": 5429,
                        "name": "Gowrie",
                        "latitude": "-35.41187000",
                        "longitude": "149.10903000"
                    },
                    {
                        "id": 5461,
                        "name": "Greenway",
                        "latitude": "-35.41829000",
                        "longitude": "149.06658000"
                    },
                    {
                        "id": 5472,
                        "name": "Griffith",
                        "latitude": "-35.32533000",
                        "longitude": "149.13714000"
                    },
                    {
                        "id": 5485,
                        "name": "Gungahlin",
                        "latitude": "-35.18674000",
                        "longitude": "149.13619000"
                    },
                    {
                        "id": 5498,
                        "name": "Hackett",
                        "latitude": "-35.24948000",
                        "longitude": "149.16352000"
                    },
                    {
                        "id": 5531,
                        "name": "Harrison",
                        "latitude": "-35.19906000",
                        "longitude": "149.15631000"
                    },
                    {
                        "id": 5538,
                        "name": "Hawker",
                        "latitude": "-35.24707000",
                        "longitude": "149.03666000"
                    },
                    {
                        "id": 5592,
                        "name": "Higgins",
                        "latitude": "-35.23242000",
                        "longitude": "149.02720000"
                    },
                    {
                        "id": 5629,
                        "name": "Holder",
                        "latitude": "-35.33439000",
                        "longitude": "149.04614000"
                    },
                    {
                        "id": 5639,
                        "name": "Holt",
                        "latitude": "-35.22441000",
                        "longitude": "149.01188000"
                    },
                    {
                        "id": 5663,
                        "name": "Hughes",
                        "latitude": "-35.33269000",
                        "longitude": "149.09491000"
                    },
                    {
                        "id": 5707,
                        "name": "Isaacs",
                        "latitude": "-35.36862000",
                        "longitude": "149.11555000"
                    },
                    {
                        "id": 5708,
                        "name": "Isabella Plains",
                        "latitude": "-35.42829000",
                        "longitude": "149.08795000"
                    },
                    {
                        "id": 5758,
                        "name": "Kaleen",
                        "latitude": "-35.21814000",
                        "longitude": "149.10516000"
                    },
                    {
                        "id": 5768,
                        "name": "Kambah",
                        "latitude": "-35.38624000",
                        "longitude": "149.05804000"
                    },
                    {
                        "id": 5886,
                        "name": "Kingston",
                        "latitude": "-35.31525000",
                        "longitude": "149.14658000"
                    },
                    {
                        "id": 5980,
                        "name": "Latham",
                        "latitude": "-35.21652000",
                        "longitude": "149.03144000"
                    },
                    {
                        "id": 6091,
                        "name": "Lyneham",
                        "latitude": "-35.23980000",
                        "longitude": "149.13074000"
                    },
                    {
                        "id": 6093,
                        "name": "Lyons",
                        "latitude": "-35.34060000",
                        "longitude": "149.07396000"
                    },
                    {
                        "id": 6097,
                        "name": "Macarthur",
                        "latitude": "-35.40885000",
                        "longitude": "149.12696000"
                    },
                    {
                        "id": 6102,
                        "name": "Macgregor",
                        "latitude": "-35.20980000",
                        "longitude": "149.01101000"
                    },
                    {
                        "id": 6112,
                        "name": "Macquarie",
                        "latitude": "-35.25126000",
                        "longitude": "149.06363000"
                    },
                    {
                        "id": 6205,
                        "name": "Mawson",
                        "latitude": "-35.36340000",
                        "longitude": "149.09863000"
                    },
                    {
                        "id": 6218,
                        "name": "McKellar",
                        "latitude": "-35.21752000",
                        "longitude": "149.07704000"
                    },
                    {
                        "id": 6234,
                        "name": "Melba",
                        "latitude": "-35.21016000",
                        "longitude": "149.05405000"
                    },
                    {
                        "id": 6345,
                        "name": "Monash",
                        "latitude": "-35.41577000",
                        "longitude": "149.09063000"
                    },
                    {
                        "id": 6533,
                        "name": "Narrabundah",
                        "latitude": "-35.33570000",
                        "longitude": "149.14924000"
                    },
                    {
                        "id": 6583,
                        "name": "Ngunnawal",
                        "latitude": "-35.17280000",
                        "longitude": "149.11147000"
                    },
                    {
                        "id": 6587,
                        "name": "Nicholls",
                        "latitude": "-35.18733000",
                        "longitude": "149.09648000"
                    },
                    {
                        "id": 6691,
                        "name": "O'Connor",
                        "latitude": "-35.25645000",
                        "longitude": "149.11248000"
                    },
                    {
                        "id": 6749,
                        "name": "Oxley",
                        "latitude": "-35.40952000",
                        "longitude": "149.07860000"
                    },
                    {
                        "id": 6761,
                        "name": "Page",
                        "latitude": "-35.23864000",
                        "longitude": "149.04988000"
                    },
                    {
                        "id": 6770,
                        "name": "Palmerston",
                        "latitude": "-35.19447000",
                        "longitude": "149.11940000"
                    },
                    {
                        "id": 6820,
                        "name": "Pearce",
                        "latitude": "-35.36222000",
                        "longitude": "149.08338000"
                    },
                    {
                        "id": 6848,
                        "name": "Phillip",
                        "latitude": "-35.35035000",
                        "longitude": "149.09151000"
                    },
                    {
                        "id": 6977,
                        "name": "Red Hill",
                        "latitude": "-35.32624000",
                        "longitude": "149.11906000"
                    },
                    {
                        "id": 6992,
                        "name": "Reid",
                        "latitude": "-35.28578000",
                        "longitude": "149.13905000"
                    },
                    {
                        "id": 7004,
                        "name": "Richardson",
                        "latitude": "-35.42787000",
                        "longitude": "149.11377000"
                    },
                    {
                        "id": 7031,
                        "name": "Rivett",
                        "latitude": "-35.34709000",
                        "longitude": "149.03790000"
                    },
                    {
                        "id": 7157,
                        "name": "Scullin",
                        "latitude": "-35.23462000",
                        "longitude": "149.03900000"
                    },
                    {
                        "id": 7303,
                        "name": "Spence",
                        "latitude": "-35.19873000",
                        "longitude": "149.06438000"
                    },
                    {
                        "id": 7348,
                        "name": "Stirling",
                        "latitude": "-35.34969000",
                        "longitude": "149.04930000"
                    },
                    {
                        "id": 7498,
                        "name": "Theodore",
                        "latitude": "-35.44962000",
                        "longitude": "149.11971000"
                    },
                    {
                        "id": 7544,
                        "name": "Torrens",
                        "latitude": "-35.37203000",
                        "longitude": "149.08773000"
                    },
                    {
                        "id": 7582,
                        "name": "Turner",
                        "latitude": "-35.26881000",
                        "longitude": "149.12465000"
                    },
                    {
                        "id": 7693,
                        "name": "Wanniassa",
                        "latitude": "-35.39783000",
                        "longitude": "149.09086000"
                    },
                    {
                        "id": 7697,
                        "name": "Waramanga",
                        "latitude": "-35.35297000",
                        "longitude": "149.06214000"
                    },
                    {
                        "id": 7735,
                        "name": "Watson",
                        "latitude": "-35.23815000",
                        "longitude": "149.15271000"
                    },
                    {
                        "id": 7753,
                        "name": "Weetangera",
                        "latitude": "-35.25000000",
                        "longitude": "149.05000000"
                    },
                    {
                        "id": 7827,
                        "name": "Weston",
                        "latitude": "-35.33582000",
                        "longitude": "149.05929000"
                    },
                    {
                        "id": 7955,
                        "name": "Wright",
                        "latitude": "-35.32239000",
                        "longitude": "149.03456000"
                    },
                    {
                        "id": 8002,
                        "name": "Yarralumla",
                        "latitude": "-35.29980000",
                        "longitude": "149.10585000"
                    }
                ]
            },
            {
                "id": 3909,
                "name": "New South Wales",
                "iso2": "NSW",
                "latitude": "-31.25321830",
                "longitude": "146.92109900",
                "type": "state",
                "cities": [
                    {
                        "id": 3903,
                        "name": "Abbotsbury",
                        "latitude": "-33.87010000",
                        "longitude": "150.86119000"
                    },
                    {
                        "id": 3905,
                        "name": "Abbotsford",
                        "latitude": "-33.84889000",
                        "longitude": "151.12801000"
                    },
                    {
                        "id": 3906,
                        "name": "Abercrombie",
                        "latitude": "-33.38867000",
                        "longitude": "149.54580000"
                    },
                    {
                        "id": 3907,
                        "name": "Aberdare",
                        "latitude": "-32.84112000",
                        "longitude": "151.38168000"
                    },
                    {
                        "id": 3908,
                        "name": "Aberdeen",
                        "latitude": "-32.16588000",
                        "longitude": "150.89003000"
                    },
                    {
                        "id": 3911,
                        "name": "Aberglasslyn",
                        "latitude": "-32.70000000",
                        "longitude": "151.53333000"
                    },
                    {
                        "id": 3912,
                        "name": "Abermain",
                        "latitude": "-32.80740000",
                        "longitude": "151.42750000"
                    },
                    {
                        "id": 3913,
                        "name": "Acacia Gardens",
                        "latitude": "-33.73159000",
                        "longitude": "150.91636000"
                    },
                    {
                        "id": 3917,
                        "name": "Adamstown",
                        "latitude": "-32.93824000",
                        "longitude": "151.72541000"
                    },
                    {
                        "id": 3918,
                        "name": "Adamstown Heights",
                        "latitude": "-32.94906000",
                        "longitude": "151.71009000"
                    },
                    {
                        "id": 3924,
                        "name": "Airds",
                        "latitude": "-34.08599000",
                        "longitude": "150.83322000"
                    },
                    {
                        "id": 3937,
                        "name": "Albion Park",
                        "latitude": "-34.57132000",
                        "longitude": "150.77568000"
                    },
                    {
                        "id": 3938,
                        "name": "Albion Park Rail",
                        "latitude": "-34.56634000",
                        "longitude": "150.79177000"
                    },
                    {
                        "id": 3939,
                        "name": "Albury",
                        "latitude": "-36.07482000",
                        "longitude": "146.92401000"
                    },
                    {
                        "id": 3940,
                        "name": "Albury Municipality",
                        "latitude": "-36.01494000",
                        "longitude": "146.95684000"
                    },
                    {
                        "id": 3941,
                        "name": "Aldavilla",
                        "latitude": "-31.08180000",
                        "longitude": "152.76790000"
                    },
                    {
                        "id": 3950,
                        "name": "Alexandria",
                        "latitude": "-33.89989000",
                        "longitude": "151.19951000"
                    },
                    {
                        "id": 3952,
                        "name": "Alfords Point",
                        "latitude": "-33.98744000",
                        "longitude": "151.02526000"
                    },
                    {
                        "id": 3959,
                        "name": "Allambie Heights",
                        "latitude": "-33.76655000",
                        "longitude": "151.24981000"
                    },
                    {
                        "id": 3961,
                        "name": "Allawah",
                        "latitude": "-33.97257000",
                        "longitude": "151.11440000"
                    },
                    {
                        "id": 3968,
                        "name": "Alstonville",
                        "latitude": "-28.84186000",
                        "longitude": "153.44022000"
                    },
                    {
                        "id": 3975,
                        "name": "Ambarvale",
                        "latitude": "-34.08942000",
                        "longitude": "150.79656000"
                    },
                    {
                        "id": 3983,
                        "name": "Anna Bay",
                        "latitude": "-32.78135000",
                        "longitude": "152.08586000"
                    },
                    {
                        "id": 3984,
                        "name": "Annandale",
                        "latitude": "-33.88333000",
                        "longitude": "151.16667000"
                    },
                    {
                        "id": 3986,
                        "name": "Annangrove",
                        "latitude": "-33.65758000",
                        "longitude": "150.94755000"
                    },
                    {
                        "id": 3991,
                        "name": "Appin",
                        "latitude": "-34.20347000",
                        "longitude": "150.78644000"
                    },
                    {
                        "id": 3997,
                        "name": "Arcadia",
                        "latitude": "-33.61667000",
                        "longitude": "151.03333000"
                    },
                    {
                        "id": 3998,
                        "name": "Arcadia vale",
                        "latitude": "-33.06052000",
                        "longitude": "151.58408000"
                    },
                    {
                        "id": 4002,
                        "name": "Argenton",
                        "latitude": "-32.93505000",
                        "longitude": "151.63064000"
                    },
                    {
                        "id": 4005,
                        "name": "Armidale",
                        "latitude": "-30.50123000",
                        "longitude": "151.66553000"
                    },
                    {
                        "id": 4007,
                        "name": "Arncliffe",
                        "latitude": "-33.93627000",
                        "longitude": "151.14819000"
                    },
                    {
                        "id": 4009,
                        "name": "Artarmon",
                        "latitude": "-33.81667000",
                        "longitude": "151.18333000"
                    },
                    {
                        "id": 4018,
                        "name": "Ashbury",
                        "latitude": "-33.89785000",
                        "longitude": "151.11960000"
                    },
                    {
                        "id": 4020,
                        "name": "Ashcroft",
                        "latitude": "-33.91598000",
                        "longitude": "150.89985000"
                    },
                    {
                        "id": 4022,
                        "name": "Ashfield",
                        "latitude": "-33.88834000",
                        "longitude": "151.12274000"
                    },
                    {
                        "id": 4025,
                        "name": "Ashmont",
                        "latitude": "-35.12491000",
                        "longitude": "147.33172000"
                    },
                    {
                        "id": 4027,
                        "name": "Ashtonfield",
                        "latitude": "-32.77331000",
                        "longitude": "151.60583000"
                    },
                    {
                        "id": 4032,
                        "name": "Asquith",
                        "latitude": "-33.68705000",
                        "longitude": "151.11630000"
                    },
                    {
                        "id": 4040,
                        "name": "Auburn",
                        "latitude": "-33.85000000",
                        "longitude": "151.03333000"
                    },
                    {
                        "id": 4046,
                        "name": "Austinmer",
                        "latitude": "-34.30516000",
                        "longitude": "150.93335000"
                    },
                    {
                        "id": 4048,
                        "name": "Austral",
                        "latitude": "-33.92745000",
                        "longitude": "150.80811000"
                    },
                    {
                        "id": 4055,
                        "name": "Avoca Beach",
                        "latitude": "-33.46818000",
                        "longitude": "151.43390000"
                    },
                    {
                        "id": 4056,
                        "name": "Avondale",
                        "latitude": "-34.51750000",
                        "longitude": "150.75010000"
                    },
                    {
                        "id": 4074,
                        "name": "Balgowlah",
                        "latitude": "-33.79494000",
                        "longitude": "151.25720000"
                    },
                    {
                        "id": 4075,
                        "name": "Balgowlah Heights",
                        "latitude": "-33.80661000",
                        "longitude": "151.26243000"
                    },
                    {
                        "id": 4076,
                        "name": "Balgownie",
                        "latitude": "-34.39505000",
                        "longitude": "150.88051000"
                    },
                    {
                        "id": 4084,
                        "name": "Ballina",
                        "latitude": "-28.85273000",
                        "longitude": "153.48568000"
                    },
                    {
                        "id": 4085,
                        "name": "Balmain",
                        "latitude": "-33.85481000",
                        "longitude": "151.18330000"
                    },
                    {
                        "id": 4086,
                        "name": "Balmain East",
                        "latitude": "-33.85710000",
                        "longitude": "151.19282000"
                    },
                    {
                        "id": 4090,
                        "name": "Balranald",
                        "latitude": "-34.67839000",
                        "longitude": "143.56384000"
                    },
                    {
                        "id": 4095,
                        "name": "Bangalow",
                        "latitude": "-28.68634000",
                        "longitude": "153.52153000"
                    },
                    {
                        "id": 4096,
                        "name": "Bangor",
                        "latitude": "-34.01667000",
                        "longitude": "151.03333000"
                    },
                    {
                        "id": 4099,
                        "name": "Banksia",
                        "latitude": "-33.94601000",
                        "longitude": "151.14304000"
                    },
                    {
                        "id": 149215,
                        "name": "Banksmeadow",
                        "latitude": "-33.95603010",
                        "longitude": "151.19736200"
                    },
                    {
                        "id": 4103,
                        "name": "Bankstown",
                        "latitude": "-33.91667000",
                        "longitude": "151.03333000"
                    },
                    {
                        "id": 4105,
                        "name": "Banora Point",
                        "latitude": "-28.21298000",
                        "longitude": "153.53634000"
                    },
                    {
                        "id": 4108,
                        "name": "Bar Beach",
                        "latitude": "-32.94128000",
                        "longitude": "151.76544000"
                    },
                    {
                        "id": 4112,
                        "name": "Barden Ridge",
                        "latitude": "-34.03413000",
                        "longitude": "151.01194000"
                    },
                    {
                        "id": 4113,
                        "name": "Bardia",
                        "latitude": "-33.97789000",
                        "longitude": "150.86306000"
                    },
                    {
                        "id": 4115,
                        "name": "Bardwell Park",
                        "latitude": "-33.93534000",
                        "longitude": "151.12571000"
                    },
                    {
                        "id": 4116,
                        "name": "Bardwell Valley",
                        "latitude": "-33.93344000",
                        "longitude": "151.13668000"
                    },
                    {
                        "id": 4119,
                        "name": "Bargo",
                        "latitude": "-34.29301000",
                        "longitude": "150.57806000"
                    },
                    {
                        "id": 4120,
                        "name": "Barham",
                        "latitude": "-35.62647000",
                        "longitude": "144.12895000"
                    },
                    {
                        "id": 4124,
                        "name": "Barnsley",
                        "latitude": "-32.93333000",
                        "longitude": "151.58333000"
                    },
                    {
                        "id": 4125,
                        "name": "Barooga",
                        "latitude": "-35.90602000",
                        "longitude": "145.69585000"
                    },
                    {
                        "id": 4127,
                        "name": "Barraba",
                        "latitude": "-30.38547000",
                        "longitude": "150.60901000"
                    },
                    {
                        "id": 4128,
                        "name": "Barrack Heights",
                        "latitude": "-34.56464000",
                        "longitude": "150.85692000"
                    },
                    {
                        "id": 4132,
                        "name": "Basin View",
                        "latitude": "-35.08833000",
                        "longitude": "150.55534000"
                    },
                    {
                        "id": 4134,
                        "name": "Bass Hill",
                        "latitude": "-33.89863000",
                        "longitude": "150.99541000"
                    },
                    {
                        "id": 4136,
                        "name": "Bateau Bay",
                        "latitude": "-33.38334000",
                        "longitude": "151.46671000"
                    },
                    {
                        "id": 4137,
                        "name": "Batehaven",
                        "latitude": "-35.73757000",
                        "longitude": "150.19836000"
                    },
                    {
                        "id": 4139,
                        "name": "Batemans Bay",
                        "latitude": "-35.70658000",
                        "longitude": "150.17541000"
                    },
                    {
                        "id": 4140,
                        "name": "Bathurst",
                        "latitude": "-33.41665000",
                        "longitude": "149.58060000"
                    },
                    {
                        "id": 4142,
                        "name": "Bathurst city centre",
                        "latitude": "-33.41816000",
                        "longitude": "149.57621000"
                    },
                    {
                        "id": 4141,
                        "name": "Bathurst Regional",
                        "latitude": "-33.47310000",
                        "longitude": "149.51956000"
                    },
                    {
                        "id": 4143,
                        "name": "Batlow",
                        "latitude": "-35.51987000",
                        "longitude": "148.14727000"
                    },
                    {
                        "id": 4146,
                        "name": "Baulkham Hills",
                        "latitude": "-33.75881000",
                        "longitude": "150.99292000"
                    },
                    {
                        "id": 4149,
                        "name": "Bay View",
                        "latitude": "-33.65982000",
                        "longitude": "151.29878000"
                    },
                    {
                        "id": 4159,
                        "name": "Beacon Hill",
                        "latitude": "-33.75280000",
                        "longitude": "151.25857000"
                    },
                    {
                        "id": 4169,
                        "name": "Beaumont Hills",
                        "latitude": "-33.69993000",
                        "longitude": "150.94110000"
                    },
                    {
                        "id": 4177,
                        "name": "Beecroft",
                        "latitude": "-33.74954000",
                        "longitude": "151.06480000"
                    },
                    {
                        "id": 4181,
                        "name": "Bega",
                        "latitude": "-36.67392000",
                        "longitude": "149.84178000"
                    },
                    {
                        "id": 4182,
                        "name": "Bega Valley",
                        "latitude": "-36.81646000",
                        "longitude": "149.72060000"
                    },
                    {
                        "id": 4186,
                        "name": "Belfield",
                        "latitude": "-33.90354000",
                        "longitude": "151.08467000"
                    },
                    {
                        "id": 4193,
                        "name": "Bella Vista",
                        "latitude": "-33.74127000",
                        "longitude": "150.95456000"
                    },
                    {
                        "id": 4195,
                        "name": "Bellambi",
                        "latitude": "-34.36667000",
                        "longitude": "150.91667000"
                    },
                    {
                        "id": 4197,
                        "name": "Bellbird",
                        "latitude": "-32.85992000",
                        "longitude": "151.31873000"
                    },
                    {
                        "id": 4203,
                        "name": "Bellevue Hill",
                        "latitude": "-33.87899000",
                        "longitude": "151.25101000"
                    },
                    {
                        "id": 4205,
                        "name": "Bellingen",
                        "latitude": "-30.37394000",
                        "longitude": "152.72492000"
                    },
                    {
                        "id": 4207,
                        "name": "Belmont",
                        "latitude": "-33.02740000",
                        "longitude": "151.66010000"
                    },
                    {
                        "id": 4211,
                        "name": "Belmont North",
                        "latitude": "-33.02081000",
                        "longitude": "151.66849000"
                    },
                    {
                        "id": 4212,
                        "name": "Belmont South",
                        "latitude": "-33.04934000",
                        "longitude": "151.65695000"
                    },
                    {
                        "id": 4213,
                        "name": "Belmore",
                        "latitude": "-33.91901000",
                        "longitude": "151.08935000"
                    },
                    {
                        "id": 4214,
                        "name": "Belrose",
                        "latitude": "-33.73954000",
                        "longitude": "151.21033000"
                    },
                    {
                        "id": 4222,
                        "name": "Bensville",
                        "latitude": "-33.49757000",
                        "longitude": "151.38084000"
                    },
                    {
                        "id": 4227,
                        "name": "Berala",
                        "latitude": "-33.87197000",
                        "longitude": "151.03386000"
                    },
                    {
                        "id": 4228,
                        "name": "Beresfield",
                        "latitude": "-32.80000000",
                        "longitude": "151.65000000"
                    },
                    {
                        "id": 4230,
                        "name": "Berkeley",
                        "latitude": "-34.48333000",
                        "longitude": "150.85000000"
                    },
                    {
                        "id": 4231,
                        "name": "Berkeley Vale",
                        "latitude": "-33.35000000",
                        "longitude": "151.43333000"
                    },
                    {
                        "id": 4232,
                        "name": "Berkshire Park",
                        "latitude": "-33.67283000",
                        "longitude": "150.77523000"
                    },
                    {
                        "id": 4233,
                        "name": "Bermagui",
                        "latitude": "-36.41900000",
                        "longitude": "150.06355000"
                    },
                    {
                        "id": 4234,
                        "name": "Berowra",
                        "latitude": "-33.62078000",
                        "longitude": "151.15091000"
                    },
                    {
                        "id": 4235,
                        "name": "Berowra Heights",
                        "latitude": "-33.61211000",
                        "longitude": "151.13754000"
                    },
                    {
                        "id": 4238,
                        "name": "Berridale",
                        "latitude": "-36.36673000",
                        "longitude": "148.82772000"
                    },
                    {
                        "id": 4240,
                        "name": "Berrigan",
                        "latitude": "-35.75192000",
                        "longitude": "145.66984000"
                    },
                    {
                        "id": 4243,
                        "name": "Berry",
                        "latitude": "-34.77507000",
                        "longitude": "150.69436000"
                    },
                    {
                        "id": 4251,
                        "name": "Beverley Park",
                        "latitude": "-33.97707000",
                        "longitude": "151.13437000"
                    },
                    {
                        "id": 4252,
                        "name": "Beverly Hills",
                        "latitude": "-33.94799000",
                        "longitude": "151.07979000"
                    },
                    {
                        "id": 4253,
                        "name": "Bexley",
                        "latitude": "-33.95000000",
                        "longitude": "151.11667000"
                    },
                    {
                        "id": 4254,
                        "name": "Bexley North",
                        "latitude": "-33.93848000",
                        "longitude": "151.11385000"
                    },
                    {
                        "id": 4257,
                        "name": "Bidwill",
                        "latitude": "-33.73013000",
                        "longitude": "150.82219000"
                    },
                    {
                        "id": 4259,
                        "name": "Bilambil Heights",
                        "latitude": "-28.21610000",
                        "longitude": "153.48415000"
                    },
                    {
                        "id": 4260,
                        "name": "Bilgola Plateau",
                        "latitude": "-33.64781000",
                        "longitude": "151.31212000"
                    },
                    {
                        "id": 4265,
                        "name": "Bingara",
                        "latitude": "-29.86931000",
                        "longitude": "150.57204000"
                    },
                    {
                        "id": 4267,
                        "name": "Birchgrove",
                        "latitude": "-33.85164000",
                        "longitude": "151.18243000"
                    },
                    {
                        "id": 4271,
                        "name": "Birmingham Gardens",
                        "latitude": "-32.89368000",
                        "longitude": "151.69009000"
                    },
                    {
                        "id": 4272,
                        "name": "Birrong",
                        "latitude": "-33.89255000",
                        "longitude": "151.02075000"
                    },
                    {
                        "id": 4282,
                        "name": "Blackalls Park",
                        "latitude": "-32.99893000",
                        "longitude": "151.58018000"
                    },
                    {
                        "id": 4286,
                        "name": "Blackbutt",
                        "latitude": "-34.57164000",
                        "longitude": "150.83804000"
                    },
                    {
                        "id": 4287,
                        "name": "Blackett",
                        "latitude": "-33.73792000",
                        "longitude": "150.81812000"
                    },
                    {
                        "id": 4288,
                        "name": "Blackheath",
                        "latitude": "-33.63567000",
                        "longitude": "150.28318000"
                    },
                    {
                        "id": 4291,
                        "name": "Blacksmiths",
                        "latitude": "-33.07167000",
                        "longitude": "151.65533000"
                    },
                    {
                        "id": 4293,
                        "name": "Blacktown",
                        "latitude": "-33.74016000",
                        "longitude": "150.86253000"
                    },
                    {
                        "id": 4294,
                        "name": "Blackwall",
                        "latitude": "-33.50252000",
                        "longitude": "151.32786000"
                    },
                    {
                        "id": 4298,
                        "name": "Blair Athol",
                        "latitude": "-30.65000000",
                        "longitude": "150.20000000"
                    },
                    {
                        "id": 4300,
                        "name": "Blakehurst",
                        "latitude": "-33.99152000",
                        "longitude": "151.10876000"
                    },
                    {
                        "id": 4302,
                        "name": "Bland",
                        "latitude": "-33.91904000",
                        "longitude": "146.92718000"
                    },
                    {
                        "id": 4303,
                        "name": "Blaxland",
                        "latitude": "-33.75000000",
                        "longitude": "150.60000000"
                    },
                    {
                        "id": 4304,
                        "name": "Blayney",
                        "latitude": "-33.61653000",
                        "longitude": "149.13046000"
                    },
                    {
                        "id": 4306,
                        "name": "Bligh Park",
                        "latitude": "-33.63985000",
                        "longitude": "150.80248000"
                    },
                    {
                        "id": 4308,
                        "name": "Blue Bay",
                        "latitude": "-33.35413000",
                        "longitude": "151.50024000"
                    },
                    {
                        "id": 4309,
                        "name": "Blue Haven",
                        "latitude": "-33.21106000",
                        "longitude": "151.50351000"
                    },
                    {
                        "id": 4310,
                        "name": "Blue Mountains Municipality",
                        "latitude": "-33.63203000",
                        "longitude": "150.41293000"
                    },
                    {
                        "id": 4313,
                        "name": "Boambee",
                        "latitude": "-30.33981000",
                        "longitude": "153.06783000"
                    },
                    {
                        "id": 4314,
                        "name": "Boambee East",
                        "latitude": "-30.34662000",
                        "longitude": "153.07320000"
                    },
                    {
                        "id": 4316,
                        "name": "Bogan",
                        "latitude": "-31.57012000",
                        "longitude": "146.90617000"
                    },
                    {
                        "id": 4317,
                        "name": "Bogangar",
                        "latitude": "-28.32944000",
                        "longitude": "153.56860000"
                    },
                    {
                        "id": 4318,
                        "name": "Boggabri",
                        "latitude": "-30.70953000",
                        "longitude": "150.04121000"
                    },
                    {
                        "id": 4321,
                        "name": "Bolton Point",
                        "latitude": "-33.00177000",
                        "longitude": "151.61013000"
                    },
                    {
                        "id": 4322,
                        "name": "Bolwarra Heights",
                        "latitude": "-32.70100000",
                        "longitude": "151.58541000"
                    },
                    {
                        "id": 4323,
                        "name": "Bomaderry",
                        "latitude": "-34.84967000",
                        "longitude": "150.61093000"
                    },
                    {
                        "id": 4324,
                        "name": "Bombala",
                        "latitude": "-36.91212000",
                        "longitude": "149.23669000"
                    },
                    {
                        "id": 4326,
                        "name": "Bondi",
                        "latitude": "-33.89429000",
                        "longitude": "151.26444000"
                    },
                    {
                        "id": 4327,
                        "name": "Bondi Beach",
                        "latitude": "-33.89079000",
                        "longitude": "151.27852000"
                    },
                    {
                        "id": 4328,
                        "name": "Bondi Junction",
                        "latitude": "-33.89275000",
                        "longitude": "151.24723000"
                    },
                    {
                        "id": 4330,
                        "name": "Bonnells Bay",
                        "latitude": "-33.10973000",
                        "longitude": "151.53226000"
                    },
                    {
                        "id": 4332,
                        "name": "Bonnet Bay",
                        "latitude": "-34.01023000",
                        "longitude": "151.05253000"
                    },
                    {
                        "id": 4333,
                        "name": "Bonny Hills",
                        "latitude": "-31.59061000",
                        "longitude": "152.83908000"
                    },
                    {
                        "id": 4334,
                        "name": "Bonnyrigg",
                        "latitude": "-33.89357000",
                        "longitude": "150.88908000"
                    },
                    {
                        "id": 4335,
                        "name": "Bonnyrigg Heights",
                        "latitude": "-33.89117000",
                        "longitude": "150.86994000"
                    },
                    {
                        "id": 4337,
                        "name": "Bonville",
                        "latitude": "-30.38284000",
                        "longitude": "153.05959000"
                    },
                    {
                        "id": 4340,
                        "name": "Booker Bay",
                        "latitude": "-33.51250000",
                        "longitude": "151.34590000"
                    },
                    {
                        "id": 4344,
                        "name": "Booragul",
                        "latitude": "-32.97486000",
                        "longitude": "151.60978000"
                    },
                    {
                        "id": 4346,
                        "name": "Boorowa",
                        "latitude": "-34.43661000",
                        "longitude": "148.71634000"
                    },
                    {
                        "id": 4352,
                        "name": "Bossley Park",
                        "latitude": "-33.86184000",
                        "longitude": "150.88410000"
                    },
                    {
                        "id": 4354,
                        "name": "Botany",
                        "latitude": "-33.94599000",
                        "longitude": "151.19591000"
                    },
                    {
                        "id": 4355,
                        "name": "Botany Bay",
                        "latitude": "-33.94660000",
                        "longitude": "151.19874000"
                    },
                    {
                        "id": 4359,
                        "name": "Bourke",
                        "latitude": "-29.99584000",
                        "longitude": "145.36160000"
                    },
                    {
                        "id": 4360,
                        "name": "Bourkelands",
                        "latitude": "-35.15593000",
                        "longitude": "147.34704000"
                    },
                    {
                        "id": 4361,
                        "name": "Bow Bowing",
                        "latitude": "-34.01655000",
                        "longitude": "150.84030000"
                    },
                    {
                        "id": 4364,
                        "name": "Bowen Mountain",
                        "latitude": "-33.57192000",
                        "longitude": "150.62563000"
                    },
                    {
                        "id": 4365,
                        "name": "Bowenfels",
                        "latitude": "-33.48336000",
                        "longitude": "150.13444000"
                    },
                    {
                        "id": 4366,
                        "name": "Bowral",
                        "latitude": "-34.47750000",
                        "longitude": "150.42040000"
                    },
                    {
                        "id": 4367,
                        "name": "Bowraville",
                        "latitude": "-30.64997000",
                        "longitude": "152.85146000"
                    },
                    {
                        "id": 4376,
                        "name": "Bradbury",
                        "latitude": "-34.08540000",
                        "longitude": "150.81541000"
                    },
                    {
                        "id": 4379,
                        "name": "Braidwood",
                        "latitude": "-35.44148000",
                        "longitude": "149.79980000"
                    },
                    {
                        "id": 4382,
                        "name": "Branxton",
                        "latitude": "-32.65547000",
                        "longitude": "151.35113000"
                    },
                    {
                        "id": 4388,
                        "name": "Breakfast Point",
                        "latitude": "-33.84286000",
                        "longitude": "151.11072000"
                    },
                    {
                        "id": 4391,
                        "name": "Brewarrina",
                        "latitude": "-29.95055000",
                        "longitude": "147.14760000"
                    },
                    {
                        "id": 4406,
                        "name": "Brighton-Le-Sands",
                        "latitude": "-33.96009000",
                        "longitude": "151.15110000"
                    },
                    {
                        "id": 4408,
                        "name": "Bringelly",
                        "latitude": "-33.93333000",
                        "longitude": "150.73333000"
                    },
                    {
                        "id": 4415,
                        "name": "Broadmeadow",
                        "latitude": "-32.92371000",
                        "longitude": "151.72849000"
                    },
                    {
                        "id": 4420,
                        "name": "Broken Hill",
                        "latitude": "-31.96520000",
                        "longitude": "141.45120000"
                    },
                    {
                        "id": 4421,
                        "name": "Broken Hill Municipality",
                        "latitude": "-31.95000000",
                        "longitude": "141.43333000"
                    },
                    {
                        "id": 4423,
                        "name": "Bronte",
                        "latitude": "-33.90198000",
                        "longitude": "151.26556000"
                    },
                    {
                        "id": 4430,
                        "name": "Brookvale",
                        "latitude": "-33.76108000",
                        "longitude": "151.27446000"
                    },
                    {
                        "id": 4434,
                        "name": "Broulee",
                        "latitude": "-35.85469000",
                        "longitude": "150.17392000"
                    },
                    {
                        "id": 4441,
                        "name": "Brunswick Heads",
                        "latitude": "-28.54003000",
                        "longitude": "153.54573000"
                    },
                    {
                        "id": 4448,
                        "name": "Budgewoi",
                        "latitude": "-33.23390000",
                        "longitude": "151.55412000"
                    },
                    {
                        "id": 4449,
                        "name": "Buff Point",
                        "latitude": "-33.22285000",
                        "longitude": "151.53125000"
                    },
                    {
                        "id": 4450,
                        "name": "Bulahdelah",
                        "latitude": "-32.40698000",
                        "longitude": "152.21185000"
                    },
                    {
                        "id": 4454,
                        "name": "Bullaburra",
                        "latitude": "-33.72922000",
                        "longitude": "150.41766000"
                    },
                    {
                        "id": 4456,
                        "name": "Bulli",
                        "latitude": "-34.33834000",
                        "longitude": "150.91347000"
                    },
                    {
                        "id": 4468,
                        "name": "Bundanoon",
                        "latitude": "-34.65658000",
                        "longitude": "150.29623000"
                    },
                    {
                        "id": 4469,
                        "name": "Bundeena",
                        "latitude": "-34.08384000",
                        "longitude": "151.15016000"
                    },
                    {
                        "id": 4472,
                        "name": "Bungarribee",
                        "latitude": "-33.77704000",
                        "longitude": "150.86799000"
                    },
                    {
                        "id": 4473,
                        "name": "Bungendore",
                        "latitude": "-35.25382000",
                        "longitude": "149.44007000"
                    },
                    {
                        "id": 4490,
                        "name": "Buronga",
                        "latitude": "-34.17070000",
                        "longitude": "142.17350000"
                    },
                    {
                        "id": 4494,
                        "name": "Burradoo",
                        "latitude": "-34.50320000",
                        "longitude": "150.40900000"
                    },
                    {
                        "id": 4495,
                        "name": "Burraneer",
                        "latitude": "-34.05625000",
                        "longitude": "151.13810000"
                    },
                    {
                        "id": 4496,
                        "name": "Burrill Lake",
                        "latitude": "-35.38716000",
                        "longitude": "150.44952000"
                    },
                    {
                        "id": 4501,
                        "name": "Burwood",
                        "latitude": "-33.88536000",
                        "longitude": "151.10481000"
                    },
                    {
                        "id": 4503,
                        "name": "Busby",
                        "latitude": "-33.91124000",
                        "longitude": "150.88068000"
                    },
                    {
                        "id": 4508,
                        "name": "Buttaba",
                        "latitude": "-33.05327000",
                        "longitude": "151.57866000"
                    },
                    {
                        "id": 4509,
                        "name": "Buxton",
                        "latitude": "-34.26017000",
                        "longitude": "150.53288000"
                    },
                    {
                        "id": 4511,
                        "name": "Byron Bay",
                        "latitude": "-28.64989000",
                        "longitude": "153.61246000"
                    },
                    {
                        "id": 4512,
                        "name": "Byron Shire",
                        "latitude": "-28.61667000",
                        "longitude": "153.51667000"
                    },
                    {
                        "id": 4513,
                        "name": "Bywong",
                        "latitude": "-35.16476000",
                        "longitude": "149.32892000"
                    },
                    {
                        "id": 4514,
                        "name": "Cabarita",
                        "latitude": "-33.84721000",
                        "longitude": "151.11638000"
                    },
                    {
                        "id": 4517,
                        "name": "Cabonne",
                        "latitude": "-33.11076000",
                        "longitude": "148.82694000"
                    },
                    {
                        "id": 4520,
                        "name": "Cabramatta",
                        "latitude": "-33.89743000",
                        "longitude": "150.93446000"
                    },
                    {
                        "id": 4521,
                        "name": "Cabramatta West",
                        "latitude": "-33.89303000",
                        "longitude": "150.91190000"
                    },
                    {
                        "id": 4522,
                        "name": "Caddens",
                        "latitude": "-33.77415000",
                        "longitude": "150.74126000"
                    },
                    {
                        "id": 4527,
                        "name": "Calala",
                        "latitude": "-31.17356000",
                        "longitude": "150.98059000"
                    },
                    {
                        "id": 4531,
                        "name": "Callaghan",
                        "latitude": "-32.89205000",
                        "longitude": "151.70531000"
                    },
                    {
                        "id": 4532,
                        "name": "Callala Bay",
                        "latitude": "-34.99668000",
                        "longitude": "150.72281000"
                    },
                    {
                        "id": 4538,
                        "name": "Cambewarra Village",
                        "latitude": "-34.82335000",
                        "longitude": "150.55940000"
                    },
                    {
                        "id": 4542,
                        "name": "Cambridge Gardens",
                        "latitude": "-33.73801000",
                        "longitude": "150.72075000"
                    },
                    {
                        "id": 4543,
                        "name": "Cambridge Park",
                        "latitude": "-33.74784000",
                        "longitude": "150.72208000"
                    },
                    {
                        "id": 4544,
                        "name": "Camden",
                        "latitude": "-34.01610000",
                        "longitude": "150.72521000"
                    },
                    {
                        "id": 4545,
                        "name": "Camden Haven",
                        "latitude": "-31.64484000",
                        "longitude": "152.79462000"
                    },
                    {
                        "id": 4547,
                        "name": "Camden South",
                        "latitude": "-34.08312000",
                        "longitude": "150.69491000"
                    },
                    {
                        "id": 4548,
                        "name": "Cameron Park",
                        "latitude": "-32.90701000",
                        "longitude": "151.60528000"
                    },
                    {
                        "id": 4551,
                        "name": "Cammeray",
                        "latitude": "-33.82132000",
                        "longitude": "151.21609000"
                    },
                    {
                        "id": 4558,
                        "name": "Campbelltown",
                        "latitude": "-34.06667000",
                        "longitude": "150.81667000"
                    },
                    {
                        "id": 4560,
                        "name": "Campbelltown Municipality",
                        "latitude": "-34.08333000",
                        "longitude": "150.83333000"
                    },
                    {
                        "id": 4561,
                        "name": "Camperdown",
                        "latitude": "-33.88965000",
                        "longitude": "151.17642000"
                    },
                    {
                        "id": 4563,
                        "name": "Campsie",
                        "latitude": "-33.91250000",
                        "longitude": "151.10279000"
                    },
                    {
                        "id": 4564,
                        "name": "Canada Bay",
                        "latitude": "-33.86590000",
                        "longitude": "151.11591000"
                    },
                    {
                        "id": 4567,
                        "name": "Canley Heights",
                        "latitude": "-33.88262000",
                        "longitude": "150.92408000"
                    },
                    {
                        "id": 4568,
                        "name": "Canley Vale",
                        "latitude": "-33.88657000",
                        "longitude": "150.94802000"
                    },
                    {
                        "id": 4574,
                        "name": "Canowindra",
                        "latitude": "-33.56247000",
                        "longitude": "148.66434000"
                    },
                    {
                        "id": 4576,
                        "name": "Canterbury",
                        "latitude": "-33.91192000",
                        "longitude": "151.11862000"
                    },
                    {
                        "id": 4577,
                        "name": "Canton Beach",
                        "latitude": "-33.27443000",
                        "longitude": "151.54614000"
                    },
                    {
                        "id": 4585,
                        "name": "Cardiff",
                        "latitude": "-32.94201000",
                        "longitude": "151.65440000"
                    },
                    {
                        "id": 4586,
                        "name": "Cardiff Heights",
                        "latitude": "-32.93626000",
                        "longitude": "151.67227000"
                    },
                    {
                        "id": 4587,
                        "name": "Cardiff South",
                        "latitude": "-32.95470000",
                        "longitude": "151.66446000"
                    },
                    {
                        "id": 4595,
                        "name": "Caringbah",
                        "latitude": "-34.03534000",
                        "longitude": "151.12468000"
                    },
                    {
                        "id": 4596,
                        "name": "Caringbah South",
                        "latitude": "-34.05662000",
                        "longitude": "151.12149000"
                    },
                    {
                        "id": 4598,
                        "name": "Carlingford",
                        "latitude": "-33.78269000",
                        "longitude": "151.04888000"
                    },
                    {
                        "id": 4601,
                        "name": "Carlton",
                        "latitude": "-33.97107000",
                        "longitude": "151.12136000"
                    },
                    {
                        "id": 4606,
                        "name": "Carnes Hill",
                        "latitude": "-33.93846000",
                        "longitude": "150.84881000"
                    },
                    {
                        "id": 4609,
                        "name": "Carramar",
                        "latitude": "-33.88382000",
                        "longitude": "150.96153000"
                    },
                    {
                        "id": 4612,
                        "name": "Carrathool",
                        "latitude": "-33.62571000",
                        "longitude": "145.42523000"
                    },
                    {
                        "id": 4613,
                        "name": "Carrington",
                        "latitude": "-32.91501000",
                        "longitude": "151.76436000"
                    },
                    {
                        "id": 4617,
                        "name": "Carss Park",
                        "latitude": "-33.98667000",
                        "longitude": "151.11734000"
                    },
                    {
                        "id": 4618,
                        "name": "Cartwright",
                        "latitude": "-33.92498000",
                        "longitude": "150.88951000"
                    },
                    {
                        "id": 4619,
                        "name": "Carwoola",
                        "latitude": "-35.37836000",
                        "longitude": "149.32150000"
                    },
                    {
                        "id": 4623,
                        "name": "Casino",
                        "latitude": "-28.85819000",
                        "longitude": "153.04748000"
                    },
                    {
                        "id": 4626,
                        "name": "Castle Cove",
                        "latitude": "-33.78655000",
                        "longitude": "151.20925000"
                    },
                    {
                        "id": 4627,
                        "name": "Castle Hill",
                        "latitude": "-33.73333000",
                        "longitude": "151.00000000"
                    },
                    {
                        "id": 4628,
                        "name": "Castlecrag",
                        "latitude": "-33.79987000",
                        "longitude": "151.22310000"
                    },
                    {
                        "id": 4630,
                        "name": "Castlereagh",
                        "latitude": "-33.68981000",
                        "longitude": "150.67887000"
                    },
                    {
                        "id": 4632,
                        "name": "Casuarina",
                        "latitude": "-28.30042000",
                        "longitude": "153.57064000"
                    },
                    {
                        "id": 4634,
                        "name": "Casula",
                        "latitude": "-33.95222000",
                        "longitude": "150.89949000"
                    },
                    {
                        "id": 4635,
                        "name": "Catalina",
                        "latitude": "-35.73000000",
                        "longitude": "150.18494000"
                    },
                    {
                        "id": 4636,
                        "name": "Catherine Field",
                        "latitude": "-34.00439000",
                        "longitude": "150.77253000"
                    },
                    {
                        "id": 4642,
                        "name": "Caves Beach",
                        "latitude": "-33.10637000",
                        "longitude": "151.64402000"
                    },
                    {
                        "id": 4643,
                        "name": "Cecil Hills",
                        "latitude": "-33.88917000",
                        "longitude": "150.85137000"
                    },
                    {
                        "id": 4648,
                        "name": "Centennial Park",
                        "latitude": "-33.89794000",
                        "longitude": "151.23364000"
                    },
                    {
                        "id": 4650,
                        "name": "Central Darling",
                        "latitude": "-31.77155000",
                        "longitude": "143.62569000"
                    },
                    {
                        "id": 4655,
                        "name": "Cessnock",
                        "latitude": "-32.89391000",
                        "longitude": "151.21234000"
                    },
                    {
                        "id": 4657,
                        "name": "Chain Valley Bay",
                        "latitude": "-33.17241000",
                        "longitude": "151.57143000"
                    },
                    {
                        "id": 4665,
                        "name": "Charlestown",
                        "latitude": "-32.96828000",
                        "longitude": "151.69318000"
                    },
                    {
                        "id": 4668,
                        "name": "Charmhaven",
                        "latitude": "-33.22671000",
                        "longitude": "151.50284000"
                    },
                    {
                        "id": 4672,
                        "name": "Chatswood",
                        "latitude": "-33.80000000",
                        "longitude": "151.18333000"
                    },
                    {
                        "id": 4673,
                        "name": "Chatswood West",
                        "latitude": "-33.79402000",
                        "longitude": "151.16492000"
                    },
                    {
                        "id": 4683,
                        "name": "Cherrybrook",
                        "latitude": "-33.72197000",
                        "longitude": "151.04607000"
                    },
                    {
                        "id": 4684,
                        "name": "Chester Hill",
                        "latitude": "-33.87896000",
                        "longitude": "150.99945000"
                    },
                    {
                        "id": 4688,
                        "name": "Chifley",
                        "latitude": "-33.96696000",
                        "longitude": "151.24221000"
                    },
                    {
                        "id": 4693,
                        "name": "Chinderah",
                        "latitude": "-28.25456000",
                        "longitude": "153.53712000"
                    },
                    {
                        "id": 4694,
                        "name": "Chippendale",
                        "latitude": "-33.88673000",
                        "longitude": "151.19745000"
                    },
                    {
                        "id": 4695,
                        "name": "Chipping Norton",
                        "latitude": "-33.91801000",
                        "longitude": "150.95927000"
                    },
                    {
                        "id": 4698,
                        "name": "Chiswick",
                        "latitude": "-33.84996000",
                        "longitude": "151.13846000"
                    },
                    {
                        "id": 4699,
                        "name": "Chittaway Bay",
                        "latitude": "-33.32769000",
                        "longitude": "151.42971000"
                    },
                    {
                        "id": 4712,
                        "name": "City of Sydney",
                        "latitude": "-33.86778000",
                        "longitude": "151.20844000"
                    },
                    {
                        "id": 4719,
                        "name": "Claremont Meadows",
                        "latitude": "-33.77587000",
                        "longitude": "150.75193000"
                    },
                    {
                        "id": 4723,
                        "name": "Clarence Town",
                        "latitude": "-32.58395000",
                        "longitude": "151.77757000"
                    },
                    {
                        "id": 4724,
                        "name": "Clarence Valley",
                        "latitude": "-29.69444000",
                        "longitude": "152.78156000"
                    },
                    {
                        "id": 4729,
                        "name": "Claymore",
                        "latitude": "-34.04649000",
                        "longitude": "150.81114000"
                    },
                    {
                        "id": 4734,
                        "name": "Clemton Park",
                        "latitude": "-33.92616000",
                        "longitude": "151.10406000"
                    },
                    {
                        "id": 4745,
                        "name": "Clontarf",
                        "latitude": "-33.80554000",
                        "longitude": "151.25367000"
                    },
                    {
                        "id": 4746,
                        "name": "Clovelly",
                        "latitude": "-33.91214000",
                        "longitude": "151.25882000"
                    },
                    {
                        "id": 4752,
                        "name": "Coal Point",
                        "latitude": "-33.04225000",
                        "longitude": "151.61159000"
                    },
                    {
                        "id": 4753,
                        "name": "Cobar",
                        "latitude": "-31.96613000",
                        "longitude": "145.36063000"
                    },
                    {
                        "id": 4754,
                        "name": "Cobbitty",
                        "latitude": "-34.01592000",
                        "longitude": "150.67854000"
                    },
                    {
                        "id": 4763,
                        "name": "Coffs Harbour",
                        "latitude": "-30.17294000",
                        "longitude": "153.03262000"
                    },
                    {
                        "id": 4768,
                        "name": "Coleambally",
                        "latitude": "-34.80388000",
                        "longitude": "145.88036000"
                    },
                    {
                        "id": 4769,
                        "name": "Colebee",
                        "latitude": "-33.72769000",
                        "longitude": "150.84743000"
                    },
                    {
                        "id": 4770,
                        "name": "Coledale",
                        "latitude": "-34.29105000",
                        "longitude": "150.94470000"
                    },
                    {
                        "id": 4771,
                        "name": "Collaroy",
                        "latitude": "-33.73205000",
                        "longitude": "151.30118000"
                    },
                    {
                        "id": 4772,
                        "name": "Collaroy Plateau",
                        "latitude": "-33.72884000",
                        "longitude": "151.29075000"
                    },
                    {
                        "id": 4779,
                        "name": "Colo Vale",
                        "latitude": "-34.40095000",
                        "longitude": "150.48573000"
                    },
                    {
                        "id": 4781,
                        "name": "Colyton",
                        "latitude": "-33.78283000",
                        "longitude": "150.79679000"
                    },
                    {
                        "id": 4782,
                        "name": "Como",
                        "latitude": "-33.99941000",
                        "longitude": "151.06389000"
                    },
                    {
                        "id": 4784,
                        "name": "Concord",
                        "latitude": "-33.84722000",
                        "longitude": "151.10381000"
                    },
                    {
                        "id": 4785,
                        "name": "Concord West",
                        "latitude": "-33.84809000",
                        "longitude": "151.08609000"
                    },
                    {
                        "id": 4786,
                        "name": "Condell Park",
                        "latitude": "-33.92458000",
                        "longitude": "151.01093000"
                    },
                    {
                        "id": 4788,
                        "name": "Condobolin",
                        "latitude": "-33.08877000",
                        "longitude": "147.15139000"
                    },
                    {
                        "id": 4790,
                        "name": "Coniston",
                        "latitude": "-34.45000000",
                        "longitude": "150.88333000"
                    },
                    {
                        "id": 4791,
                        "name": "Connells Point",
                        "latitude": "-33.98827000",
                        "longitude": "151.09094000"
                    },
                    {
                        "id": 4793,
                        "name": "Constitution Hill",
                        "latitude": "-33.79259000",
                        "longitude": "150.97627000"
                    },
                    {
                        "id": 4798,
                        "name": "Coogee",
                        "latitude": "-33.92050000",
                        "longitude": "151.25522000"
                    },
                    {
                        "id": 4801,
                        "name": "Cooks Hill",
                        "latitude": "-32.93244000",
                        "longitude": "151.77114000"
                    },
                    {
                        "id": 4803,
                        "name": "Coolah",
                        "latitude": "-31.82787000",
                        "longitude": "149.71564000"
                    },
                    {
                        "id": 4804,
                        "name": "Coolamon",
                        "latitude": "-34.60046000",
                        "longitude": "147.13707000"
                    },
                    {
                        "id": 4813,
                        "name": "Cooma",
                        "latitude": "-36.23517000",
                        "longitude": "149.12408000"
                    },
                    {
                        "id": 4819,
                        "name": "Coonabarabran",
                        "latitude": "-31.27734000",
                        "longitude": "149.27904000"
                    },
                    {
                        "id": 4820,
                        "name": "Coonamble",
                        "latitude": "-30.86714000",
                        "longitude": "148.29053000"
                    },
                    {
                        "id": 4823,
                        "name": "Cooranbong",
                        "latitude": "-33.07622000",
                        "longitude": "151.45409000"
                    },
                    {
                        "id": 4828,
                        "name": "Cootamundra",
                        "latitude": "-34.64095000",
                        "longitude": "148.02838000"
                    },
                    {
                        "id": 4829,
                        "name": "Copacabana",
                        "latitude": "-33.48692000",
                        "longitude": "151.43587000"
                    },
                    {
                        "id": 4832,
                        "name": "Coraki",
                        "latitude": "-28.99260000",
                        "longitude": "153.28374000"
                    },
                    {
                        "id": 4835,
                        "name": "Cordeaux Heights",
                        "latitude": "-34.44043000",
                        "longitude": "150.83748000"
                    },
                    {
                        "id": 4837,
                        "name": "Corindi Beach",
                        "latitude": "-30.01668000",
                        "longitude": "153.18555000"
                    },
                    {
                        "id": 4839,
                        "name": "Corlette",
                        "latitude": "-32.72014000",
                        "longitude": "152.10846000"
                    },
                    {
                        "id": 4842,
                        "name": "Corowa",
                        "latitude": "-35.99704000",
                        "longitude": "146.38552000"
                    },
                    {
                        "id": 4844,
                        "name": "Corrimal",
                        "latitude": "-34.37864000",
                        "longitude": "150.90356000"
                    },
                    {
                        "id": 4849,
                        "name": "Coutts Crossing",
                        "latitude": "-29.82619000",
                        "longitude": "152.89156000"
                    },
                    {
                        "id": 4854,
                        "name": "Cowra",
                        "latitude": "-33.81138000",
                        "longitude": "148.78346000"
                    },
                    {
                        "id": 4871,
                        "name": "Cranebrook",
                        "latitude": "-33.70610000",
                        "longitude": "150.70940000"
                    },
                    {
                        "id": 4875,
                        "name": "Cremorne",
                        "latitude": "-33.82679000",
                        "longitude": "151.22633000"
                    },
                    {
                        "id": 4876,
                        "name": "Cremorne Point",
                        "latitude": "-33.84008000",
                        "longitude": "151.22698000"
                    },
                    {
                        "id": 4877,
                        "name": "Crescent Head",
                        "latitude": "-31.18870000",
                        "longitude": "152.97301000"
                    },
                    {
                        "id": 4880,
                        "name": "Crestwood",
                        "latitude": "-35.34844000",
                        "longitude": "149.21758000"
                    },
                    {
                        "id": 4883,
                        "name": "Cringila",
                        "latitude": "-34.47131000",
                        "longitude": "150.86755000"
                    },
                    {
                        "id": 4884,
                        "name": "Cromer",
                        "latitude": "-33.73120000",
                        "longitude": "151.26788000"
                    },
                    {
                        "id": 4885,
                        "name": "Cronulla",
                        "latitude": "-34.06251000",
                        "longitude": "151.14961000"
                    },
                    {
                        "id": 4886,
                        "name": "Crookwell",
                        "latitude": "-34.45925000",
                        "longitude": "149.47137000"
                    },
                    {
                        "id": 4887,
                        "name": "Crows Nest",
                        "latitude": "-33.82494000",
                        "longitude": "151.20398000"
                    },
                    {
                        "id": 4889,
                        "name": "Croydon",
                        "latitude": "-33.88333000",
                        "longitude": "151.11667000"
                    },
                    {
                        "id": 4899,
                        "name": "Culburra Beach",
                        "latitude": "-34.92788000",
                        "longitude": "150.75766000"
                    },
                    {
                        "id": 4900,
                        "name": "Culcairn",
                        "latitude": "-35.66669000",
                        "longitude": "147.03845000"
                    },
                    {
                        "id": 4901,
                        "name": "Cumbalum",
                        "latitude": "-28.82250000",
                        "longitude": "153.52840000"
                    },
                    {
                        "id": 4904,
                        "name": "Cundletown",
                        "latitude": "-31.89410000",
                        "longitude": "152.52141000"
                    },
                    {
                        "id": 4906,
                        "name": "Curl Curl",
                        "latitude": "-33.76886000",
                        "longitude": "151.28888000"
                    },
                    {
                        "id": 4910,
                        "name": "Currans Hill",
                        "latitude": "-34.04311000",
                        "longitude": "150.77301000"
                    },
                    {
                        "id": 4918,
                        "name": "Daceyville",
                        "latitude": "-33.92879000",
                        "longitude": "151.22577000"
                    },
                    {
                        "id": 4925,
                        "name": "Dalmeny",
                        "latitude": "-36.16608000",
                        "longitude": "150.12912000"
                    },
                    {
                        "id": 4933,
                        "name": "Dapto",
                        "latitude": "-34.50386000",
                        "longitude": "150.79416000"
                    },
                    {
                        "id": 4940,
                        "name": "Darling Point",
                        "latitude": "-33.87064000",
                        "longitude": "151.23895000"
                    },
                    {
                        "id": 4941,
                        "name": "Darlinghurst",
                        "latitude": "-33.87939000",
                        "longitude": "151.21925000"
                    },
                    {
                        "id": 4944,
                        "name": "Darlington",
                        "latitude": "-33.89103000",
                        "longitude": "151.19548000"
                    },
                    {
                        "id": 4945,
                        "name": "Darlington Point",
                        "latitude": "-34.56942000",
                        "longitude": "145.99870000"
                    },
                    {
                        "id": 4948,
                        "name": "Davidson",
                        "latitude": "-33.74297000",
                        "longitude": "151.20080000"
                    },
                    {
                        "id": 4949,
                        "name": "Davistown",
                        "latitude": "-33.48559000",
                        "longitude": "151.36151000"
                    },
                    {
                        "id": 4958,
                        "name": "Dean Park",
                        "latitude": "-33.73539000",
                        "longitude": "150.85958000"
                    },
                    {
                        "id": 4960,
                        "name": "Dee Why",
                        "latitude": "-33.75110000",
                        "longitude": "151.28886000"
                    },
                    {
                        "id": 4969,
                        "name": "Denham Court",
                        "latitude": "-33.98307000",
                        "longitude": "150.84606000"
                    },
                    {
                        "id": 4970,
                        "name": "Deniliquin",
                        "latitude": "-35.53245000",
                        "longitude": "144.95364000"
                    },
                    {
                        "id": 4971,
                        "name": "Denistone",
                        "latitude": "-33.79835000",
                        "longitude": "151.09051000"
                    },
                    {
                        "id": 4972,
                        "name": "Denistone East",
                        "latitude": "-33.79600000",
                        "longitude": "151.09740000"
                    },
                    {
                        "id": 4973,
                        "name": "Denman",
                        "latitude": "-32.38788000",
                        "longitude": "150.68935000"
                    },
                    {
                        "id": 4985,
                        "name": "Dharruk",
                        "latitude": "-33.74814000",
                        "longitude": "150.81561000"
                    },
                    {
                        "id": 5000,
                        "name": "Dolls Point",
                        "latitude": "-33.99341000",
                        "longitude": "151.14474000"
                    },
                    {
                        "id": 5011,
                        "name": "Doonside",
                        "latitude": "-33.76667000",
                        "longitude": "150.86667000"
                    },
                    {
                        "id": 5012,
                        "name": "Dora Creek",
                        "latitude": "-33.08139000",
                        "longitude": "151.49677000"
                    },
                    {
                        "id": 5014,
                        "name": "Dorrigo",
                        "latitude": "-30.34112000",
                        "longitude": "152.71394000"
                    },
                    {
                        "id": 5016,
                        "name": "Double Bay",
                        "latitude": "-33.87782000",
                        "longitude": "151.24354000"
                    },
                    {
                        "id": 5019,
                        "name": "Douglas Park",
                        "latitude": "-34.18496000",
                        "longitude": "150.71449000"
                    },
                    {
                        "id": 5021,
                        "name": "Dover Heights",
                        "latitude": "-33.87083000",
                        "longitude": "151.27917000"
                    },
                    {
                        "id": 5031,
                        "name": "Drummoyne",
                        "latitude": "-33.85237000",
                        "longitude": "151.15491000"
                    },
                    {
                        "id": 5033,
                        "name": "Dubbo",
                        "latitude": "-32.24295000",
                        "longitude": "148.60484000"
                    },
                    {
                        "id": 5034,
                        "name": "Dudley",
                        "latitude": "-32.99373000",
                        "longitude": "151.72197000"
                    },
                    {
                        "id": 5038,
                        "name": "Dulwich Hill",
                        "latitude": "-33.90410000",
                        "longitude": "151.13945000"
                    },
                    {
                        "id": 5042,
                        "name": "Dundas Valley",
                        "latitude": "-33.78826000",
                        "longitude": "151.05261000"
                    },
                    {
                        "id": 5044,
                        "name": "Dunedoo",
                        "latitude": "-32.01634000",
                        "longitude": "149.38710000"
                    },
                    {
                        "id": 5045,
                        "name": "Dungog",
                        "latitude": "-32.34619000",
                        "longitude": "151.61122000"
                    },
                    {
                        "id": 5050,
                        "name": "Dural",
                        "latitude": "-33.68333000",
                        "longitude": "151.01667000"
                    },
                    {
                        "id": 5056,
                        "name": "Eagle Vale",
                        "latitude": "-34.03747000",
                        "longitude": "150.81360000"
                    },
                    {
                        "id": 5061,
                        "name": "Earlwood",
                        "latitude": "-33.92090000",
                        "longitude": "151.12506000"
                    },
                    {
                        "id": 5062,
                        "name": "East Albury",
                        "latitude": "-36.08144000",
                        "longitude": "146.92991000"
                    },
                    {
                        "id": 5065,
                        "name": "East Ballina",
                        "latitude": "-28.85709000",
                        "longitude": "153.58736000"
                    },
                    {
                        "id": 5067,
                        "name": "East Branxton",
                        "latitude": "-32.65372000",
                        "longitude": "151.36559000"
                    },
                    {
                        "id": 5072,
                        "name": "East Corrimal",
                        "latitude": "-34.37606000",
                        "longitude": "150.91078000"
                    },
                    {
                        "id": 5077,
                        "name": "East Gosford",
                        "latitude": "-33.43874000",
                        "longitude": "151.35338000"
                    },
                    {
                        "id": 5078,
                        "name": "East Hills",
                        "latitude": "-33.96099000",
                        "longitude": "150.98822000"
                    },
                    {
                        "id": 5081,
                        "name": "East Jindabyne",
                        "latitude": "-36.39579000",
                        "longitude": "148.65137000"
                    },
                    {
                        "id": 5082,
                        "name": "East Kempsey",
                        "latitude": "-31.08242000",
                        "longitude": "152.85253000"
                    },
                    {
                        "id": 5083,
                        "name": "East Killara",
                        "latitude": "-33.75535000",
                        "longitude": "151.18154000"
                    },
                    {
                        "id": 5084,
                        "name": "East Kurrajong",
                        "latitude": "-33.50550000",
                        "longitude": "150.79427000"
                    },
                    {
                        "id": 5086,
                        "name": "East Lindfield",
                        "latitude": "-33.76664000",
                        "longitude": "151.18685000"
                    },
                    {
                        "id": 5087,
                        "name": "East Lismore",
                        "latitude": "-28.82591000",
                        "longitude": "153.28880000"
                    },
                    {
                        "id": 5089,
                        "name": "East Maitland",
                        "latitude": "-32.75000000",
                        "longitude": "151.58333000"
                    },
                    {
                        "id": 5093,
                        "name": "East Ryde",
                        "latitude": "-33.81031000",
                        "longitude": "151.13153000"
                    },
                    {
                        "id": 5095,
                        "name": "East Tamworth",
                        "latitude": "-31.08548000",
                        "longitude": "150.93721000"
                    },
                    {
                        "id": 5099,
                        "name": "Eastlakes",
                        "latitude": "-33.93196000",
                        "longitude": "151.21214000"
                    },
                    {
                        "id": 5100,
                        "name": "Eastwood",
                        "latitude": "-33.79176000",
                        "longitude": "151.08057000"
                    },
                    {
                        "id": 5105,
                        "name": "Eden",
                        "latitude": "-37.06675000",
                        "longitude": "149.90029000"
                    },
                    {
                        "id": 5110,
                        "name": "Edensor Park",
                        "latitude": "-33.87971000",
                        "longitude": "150.87778000"
                    },
                    {
                        "id": 5112,
                        "name": "Edgecliff",
                        "latitude": "-33.87952000",
                        "longitude": "151.23677000"
                    },
                    {
                        "id": 5114,
                        "name": "Edgeworth",
                        "latitude": "-32.92508000",
                        "longitude": "151.61612000"
                    },
                    {
                        "id": 5116,
                        "name": "Edmondson Park",
                        "latitude": "-33.95695000",
                        "longitude": "150.86134000"
                    },
                    {
                        "id": 5119,
                        "name": "Eglinton",
                        "latitude": "-33.37731000",
                        "longitude": "149.54654000"
                    },
                    {
                        "id": 5124,
                        "name": "Elanora Heights",
                        "latitude": "-33.70159000",
                        "longitude": "151.27965000"
                    },
                    {
                        "id": 5125,
                        "name": "Elderslie",
                        "latitude": "-34.05519000",
                        "longitude": "150.71367000"
                    },
                    {
                        "id": 5126,
                        "name": "Eleebana",
                        "latitude": "-32.98960000",
                        "longitude": "151.63642000"
                    },
                    {
                        "id": 5127,
                        "name": "Elermore Vale",
                        "latitude": "-32.91621000",
                        "longitude": "151.67665000"
                    },
                    {
                        "id": 5130,
                        "name": "Elizabeth Bay",
                        "latitude": "-33.87181000",
                        "longitude": "151.22706000"
                    },
                    {
                        "id": 5134,
                        "name": "Elizabeth Hills",
                        "latitude": "-33.89863000",
                        "longitude": "150.84761000"
                    },
                    {
                        "id": 5139,
                        "name": "Ellalong",
                        "latitude": "-32.91507000",
                        "longitude": "151.31161000"
                    },
                    {
                        "id": 5152,
                        "name": "Emerald Beach",
                        "latitude": "-30.16388000",
                        "longitude": "153.18190000"
                    },
                    {
                        "id": 5153,
                        "name": "Emerton",
                        "latitude": "-33.74411000",
                        "longitude": "150.80644000"
                    },
                    {
                        "id": 5154,
                        "name": "Empire Bay",
                        "latitude": "-33.49385000",
                        "longitude": "151.36290000"
                    },
                    {
                        "id": 5155,
                        "name": "Emu Heights",
                        "latitude": "-33.73453000",
                        "longitude": "150.64874000"
                    },
                    {
                        "id": 5157,
                        "name": "Emu Plains",
                        "latitude": "-33.75000000",
                        "longitude": "150.66667000"
                    },
                    {
                        "id": 5161,
                        "name": "Engadine",
                        "latitude": "-34.06564000",
                        "longitude": "151.01266000"
                    },
                    {
                        "id": 5162,
                        "name": "Enmore",
                        "latitude": "-33.90050000",
                        "longitude": "151.17314000"
                    },
                    {
                        "id": 5165,
                        "name": "Epping",
                        "latitude": "-33.77271000",
                        "longitude": "151.08184000"
                    },
                    {
                        "id": 5167,
                        "name": "Erina",
                        "latitude": "-33.43218000",
                        "longitude": "151.38972000"
                    },
                    {
                        "id": 5169,
                        "name": "Ermington",
                        "latitude": "-33.81483000",
                        "longitude": "151.05467000"
                    },
                    {
                        "id": 5171,
                        "name": "Erskine Park",
                        "latitude": "-33.81301000",
                        "longitude": "150.79773000"
                    },
                    {
                        "id": 5172,
                        "name": "Erskineville",
                        "latitude": "-33.90254000",
                        "longitude": "151.18579000"
                    },
                    {
                        "id": 5173,
                        "name": "Eschol Park",
                        "latitude": "-34.02982000",
                        "longitude": "150.80957000"
                    },
                    {
                        "id": 5180,
                        "name": "Estella",
                        "latitude": "-35.07254000",
                        "longitude": "147.35748000"
                    },
                    {
                        "id": 5183,
                        "name": "Ettalong",
                        "latitude": "-33.51301000",
                        "longitude": "151.33830000"
                    },
                    {
                        "id": 5184,
                        "name": "Ettalong Beach",
                        "latitude": "-33.51058000",
                        "longitude": "151.33044000"
                    },
                    {
                        "id": 5186,
                        "name": "Eulomogo",
                        "latitude": "-32.26667000",
                        "longitude": "148.68333000"
                    },
                    {
                        "id": 5190,
                        "name": "Eurobodalla",
                        "latitude": "-35.93307000",
                        "longitude": "149.92780000"
                    },
                    {
                        "id": 5193,
                        "name": "Evans Head",
                        "latitude": "-29.11777000",
                        "longitude": "153.43072000"
                    },
                    {
                        "id": 5206,
                        "name": "Fairfield",
                        "latitude": "-33.86742000",
                        "longitude": "150.90105000"
                    },
                    {
                        "id": 5208,
                        "name": "Fairfield East",
                        "latitude": "-33.86938000",
                        "longitude": "150.97129000"
                    },
                    {
                        "id": 5209,
                        "name": "Fairfield Heights",
                        "latitude": "-33.86445000",
                        "longitude": "150.93884000"
                    },
                    {
                        "id": 5210,
                        "name": "Fairfield West",
                        "latitude": "-33.86670000",
                        "longitude": "150.91700000"
                    },
                    {
                        "id": 5211,
                        "name": "Fairlight",
                        "latitude": "-33.79575000",
                        "longitude": "151.27346000"
                    },
                    {
                        "id": 5213,
                        "name": "Fairy Meadow",
                        "latitude": "-34.39303000",
                        "longitude": "150.89275000"
                    },
                    {
                        "id": 5217,
                        "name": "Farmborough Heights",
                        "latitude": "-34.45499000",
                        "longitude": "150.81308000"
                    },
                    {
                        "id": 5220,
                        "name": "Faulconbridge",
                        "latitude": "-33.70000000",
                        "longitude": "150.53333000"
                    },
                    {
                        "id": 5223,
                        "name": "Fennell Bay",
                        "latitude": "-32.99220000",
                        "longitude": "151.60008000"
                    },
                    {
                        "id": 5224,
                        "name": "Fern Bay",
                        "latitude": "-32.86428000",
                        "longitude": "151.81307000"
                    },
                    {
                        "id": 5225,
                        "name": "Fern Hill",
                        "latitude": "-34.38294000",
                        "longitude": "150.88567000"
                    },
                    {
                        "id": 5234,
                        "name": "Figtree",
                        "latitude": "-34.43556000",
                        "longitude": "150.85833000"
                    },
                    {
                        "id": 5236,
                        "name": "Fingal Bay",
                        "latitude": "-32.74969000",
                        "longitude": "152.17104000"
                    },
                    {
                        "id": 5237,
                        "name": "Finley",
                        "latitude": "-35.65498000",
                        "longitude": "145.57106000"
                    },
                    {
                        "id": 5244,
                        "name": "Five Dock",
                        "latitude": "-33.86740000",
                        "longitude": "151.12905000"
                    },
                    {
                        "id": 5247,
                        "name": "Fletcher",
                        "latitude": "-32.87232000",
                        "longitude": "151.64008000"
                    },
                    {
                        "id": 5248,
                        "name": "Flinders",
                        "latitude": "-34.58333000",
                        "longitude": "150.85516000"
                    },
                    {
                        "id": 5255,
                        "name": "Floraville",
                        "latitude": "-33.01116000",
                        "longitude": "151.66480000"
                    },
                    {
                        "id": 5260,
                        "name": "Forbes",
                        "latitude": "-33.37898000",
                        "longitude": "147.86448000"
                    },
                    {
                        "id": 5263,
                        "name": "Forest Hill",
                        "latitude": "-35.14810000",
                        "longitude": "147.46707000"
                    },
                    {
                        "id": 5266,
                        "name": "Forest Lodge",
                        "latitude": "-33.88137000",
                        "longitude": "151.18000000"
                    },
                    {
                        "id": 5269,
                        "name": "Forestville",
                        "latitude": "-33.76667000",
                        "longitude": "151.20833000"
                    },
                    {
                        "id": 5272,
                        "name": "Forresters Beach",
                        "latitude": "-33.40700000",
                        "longitude": "151.47600000"
                    },
                    {
                        "id": 5274,
                        "name": "Forster",
                        "latitude": "-32.18136000",
                        "longitude": "152.51715000"
                    },
                    {
                        "id": 5286,
                        "name": "Frederickton",
                        "latitude": "-31.03749000",
                        "longitude": "152.87530000"
                    },
                    {
                        "id": 5288,
                        "name": "Freemans Reach",
                        "latitude": "-33.55794000",
                        "longitude": "150.79553000"
                    },
                    {
                        "id": 5290,
                        "name": "Frenchs Forest",
                        "latitude": "-33.74821000",
                        "longitude": "151.22322000"
                    },
                    {
                        "id": 5292,
                        "name": "Freshwater",
                        "latitude": "-33.77867000",
                        "longitude": "151.28569000"
                    },
                    {
                        "id": 5300,
                        "name": "Galston",
                        "latitude": "-33.65297000",
                        "longitude": "151.04713000"
                    },
                    {
                        "id": 5304,
                        "name": "Garden Suburb",
                        "latitude": "-32.94368000",
                        "longitude": "151.68085000"
                    },
                    {
                        "id": 5307,
                        "name": "Gateshead",
                        "latitude": "-32.98208000",
                        "longitude": "151.69188000"
                    },
                    {
                        "id": 5325,
                        "name": "Georges Hall",
                        "latitude": "-33.90879000",
                        "longitude": "150.98852000"
                    },
                    {
                        "id": 5326,
                        "name": "Georgetown",
                        "latitude": "-32.90810000",
                        "longitude": "151.73119000"
                    },
                    {
                        "id": 5329,
                        "name": "Gerringong",
                        "latitude": "-34.74702000",
                        "longitude": "150.82809000"
                    },
                    {
                        "id": 5332,
                        "name": "Gilgandra",
                        "latitude": "-31.63297000",
                        "longitude": "148.70354000"
                    },
                    {
                        "id": 5335,
                        "name": "Gillieston Heights",
                        "latitude": "-32.76164000",
                        "longitude": "151.52863000"
                    },
                    {
                        "id": 5341,
                        "name": "Girards Hill",
                        "latitude": "-28.81693000",
                        "longitude": "153.27786000"
                    },
                    {
                        "id": 5342,
                        "name": "Girraween",
                        "latitude": "-33.79900000",
                        "longitude": "150.94300000"
                    },
                    {
                        "id": 5346,
                        "name": "Gladesville",
                        "latitude": "-33.83333000",
                        "longitude": "151.13333000"
                    },
                    {
                        "id": 5353,
                        "name": "Glebe",
                        "latitude": "-33.87884000",
                        "longitude": "151.18426000"
                    },
                    {
                        "id": 5354,
                        "name": "Glen Alpine",
                        "latitude": "-34.08600000",
                        "longitude": "150.78512000"
                    },
                    {
                        "id": 5359,
                        "name": "Glen Innes",
                        "latitude": "-29.73485000",
                        "longitude": "151.73850000"
                    },
                    {
                        "id": 5360,
                        "name": "Glen Innes Severn",
                        "latitude": "-29.63116000",
                        "longitude": "151.93957000"
                    },
                    {
                        "id": 5366,
                        "name": "Glenbrook",
                        "latitude": "-33.76667000",
                        "longitude": "150.61667000"
                    },
                    {
                        "id": 5367,
                        "name": "Glendale",
                        "latitude": "-32.93194000",
                        "longitude": "151.64103000"
                    },
                    {
                        "id": 5369,
                        "name": "Glendenning",
                        "latitude": "-33.74830000",
                        "longitude": "150.85411000"
                    },
                    {
                        "id": 5378,
                        "name": "Glenfield",
                        "latitude": "-33.96667000",
                        "longitude": "150.90000000"
                    },
                    {
                        "id": 5379,
                        "name": "Glenfield Park",
                        "latitude": "-35.13725000",
                        "longitude": "147.33285000"
                    },
                    {
                        "id": 5382,
                        "name": "Glenhaven",
                        "latitude": "-33.70000000",
                        "longitude": "151.00000000"
                    },
                    {
                        "id": 5383,
                        "name": "Glenmore Park",
                        "latitude": "-33.79068000",
                        "longitude": "150.66930000"
                    },
                    {
                        "id": 5384,
                        "name": "Glenning Valley",
                        "latitude": "-33.35369000",
                        "longitude": "151.42623000"
                    },
                    {
                        "id": 5386,
                        "name": "Glenorie",
                        "latitude": "-33.60177000",
                        "longitude": "151.00886000"
                    },
                    {
                        "id": 5388,
                        "name": "Glenroy",
                        "latitude": "-36.05021000",
                        "longitude": "146.91058000"
                    },
                    {
                        "id": 5393,
                        "name": "Glenwood",
                        "latitude": "-33.73333000",
                        "longitude": "150.93284000"
                    },
                    {
                        "id": 5394,
                        "name": "Glossodia",
                        "latitude": "-33.53618000",
                        "longitude": "150.77390000"
                    },
                    {
                        "id": 5395,
                        "name": "Gloucester",
                        "latitude": "-32.00770000",
                        "longitude": "151.96330000"
                    },
                    {
                        "id": 5399,
                        "name": "Gol Gol",
                        "latitude": "-34.17388000",
                        "longitude": "142.22187000"
                    },
                    {
                        "id": 5411,
                        "name": "Googong",
                        "latitude": "-35.43873000",
                        "longitude": "149.21310000"
                    },
                    {
                        "id": 5416,
                        "name": "Goonellabah",
                        "latitude": "-28.81667000",
                        "longitude": "153.31667000"
                    },
                    {
                        "id": 5418,
                        "name": "Gordon",
                        "latitude": "-33.75535000",
                        "longitude": "151.15115000"
                    },
                    {
                        "id": 5423,
                        "name": "Gorokan",
                        "latitude": "-33.25764000",
                        "longitude": "151.50970000"
                    },
                    {
                        "id": 5424,
                        "name": "Gosford",
                        "latitude": "-33.42440000",
                        "longitude": "151.34399000"
                    },
                    {
                        "id": 5426,
                        "name": "Goulburn",
                        "latitude": "-34.75155000",
                        "longitude": "149.72086000"
                    },
                    {
                        "id": 5427,
                        "name": "Goulburn Mulwaree",
                        "latitude": "-34.90250000",
                        "longitude": "149.90200000"
                    },
                    {
                        "id": 5434,
                        "name": "Grafton",
                        "latitude": "-29.68104000",
                        "longitude": "152.93394000"
                    },
                    {
                        "id": 5439,
                        "name": "Granville",
                        "latitude": "-33.84060000",
                        "longitude": "151.00748000"
                    },
                    {
                        "id": 5442,
                        "name": "Grasmere",
                        "latitude": "-34.05392000",
                        "longitude": "150.66602000"
                    },
                    {
                        "id": 5444,
                        "name": "Grays Point",
                        "latitude": "-34.05873000",
                        "longitude": "151.08604000"
                    },
                    {
                        "id": 5448,
                        "name": "Greater Hume Shire",
                        "latitude": "-35.75837000",
                        "longitude": "147.19731000"
                    },
                    {
                        "id": 5450,
                        "name": "Green Valley",
                        "latitude": "-33.90292000",
                        "longitude": "150.86713000"
                    },
                    {
                        "id": 5451,
                        "name": "Greenacre",
                        "latitude": "-33.90034000",
                        "longitude": "151.05563000"
                    },
                    {
                        "id": 5454,
                        "name": "Greenfield Park",
                        "latitude": "-33.87461000",
                        "longitude": "150.89189000"
                    },
                    {
                        "id": 5462,
                        "name": "Greenwell Point",
                        "latitude": "-34.90751000",
                        "longitude": "150.73113000"
                    },
                    {
                        "id": 5463,
                        "name": "Greenwich",
                        "latitude": "-33.83954000",
                        "longitude": "151.18300000"
                    },
                    {
                        "id": 5466,
                        "name": "Gregory Hills",
                        "latitude": "-34.02673000",
                        "longitude": "150.77070000"
                    },
                    {
                        "id": 5467,
                        "name": "Grenfell",
                        "latitude": "-33.89549000",
                        "longitude": "148.16438000"
                    },
                    {
                        "id": 5468,
                        "name": "Greta",
                        "latitude": "-32.67783000",
                        "longitude": "151.38924000"
                    },
                    {
                        "id": 5469,
                        "name": "Greystanes",
                        "latitude": "-33.82346000",
                        "longitude": "150.94607000"
                    },
                    {
                        "id": 5471,
                        "name": "Griffith",
                        "latitude": "-34.33448000",
                        "longitude": "146.02295000"
                    },
                    {
                        "id": 5473,
                        "name": "Grose Vale",
                        "latitude": "-33.58331000",
                        "longitude": "150.67440000"
                    },
                    {
                        "id": 5476,
                        "name": "Guildford West",
                        "latitude": "-33.84939000",
                        "longitude": "150.96475000"
                    },
                    {
                        "id": 5478,
                        "name": "Gulgong",
                        "latitude": "-32.36253000",
                        "longitude": "149.53201000"
                    },
                    {
                        "id": 5480,
                        "name": "Gulmarrad",
                        "latitude": "-29.48700000",
                        "longitude": "153.23341000"
                    },
                    {
                        "id": 5483,
                        "name": "Gundagai",
                        "latitude": "-35.02623000",
                        "longitude": "148.13457000"
                    },
                    {
                        "id": 5484,
                        "name": "Gundaroo",
                        "latitude": "-35.03333000",
                        "longitude": "149.25000000"
                    },
                    {
                        "id": 5487,
                        "name": "Gunnedah",
                        "latitude": "-31.02404000",
                        "longitude": "150.11548000"
                    },
                    {
                        "id": 5488,
                        "name": "Guyra",
                        "latitude": "-30.21680000",
                        "longitude": "151.66785000"
                    },
                    {
                        "id": 5489,
                        "name": "Gwandalan",
                        "latitude": "-33.13538000",
                        "longitude": "151.58285000"
                    },
                    {
                        "id": 5491,
                        "name": "Gwydir",
                        "latitude": "-29.49806000",
                        "longitude": "150.53813000"
                    },
                    {
                        "id": 5492,
                        "name": "Gwynneville",
                        "latitude": "-34.41667000",
                        "longitude": "150.88750000"
                    },
                    {
                        "id": 5493,
                        "name": "Gymea",
                        "latitude": "-34.03637000",
                        "longitude": "151.08528000"
                    },
                    {
                        "id": 5494,
                        "name": "Gymea Bay",
                        "latitude": "-34.05209000",
                        "longitude": "151.08795000"
                    },
                    {
                        "id": 5497,
                        "name": "Haberfield",
                        "latitude": "-33.88296000",
                        "longitude": "151.14389000"
                    },
                    {
                        "id": 5505,
                        "name": "Halekulani",
                        "latitude": "-33.21914000",
                        "longitude": "151.55251000"
                    },
                    {
                        "id": 5512,
                        "name": "Hamilton",
                        "latitude": "-32.92207000",
                        "longitude": "151.74711000"
                    },
                    {
                        "id": 5516,
                        "name": "Hamlyn Terrace",
                        "latitude": "-33.25125000",
                        "longitude": "151.47627000"
                    },
                    {
                        "id": 5518,
                        "name": "Hammondville",
                        "latitude": "-33.94827000",
                        "longitude": "150.95211000"
                    },
                    {
                        "id": 5524,
                        "name": "Hanwood",
                        "latitude": "-34.33095000",
                        "longitude": "146.04137000"
                    },
                    {
                        "id": 5527,
                        "name": "Harrington",
                        "latitude": "-31.88306000",
                        "longitude": "152.65924000"
                    },
                    {
                        "id": 5528,
                        "name": "Harrington Park",
                        "latitude": "-34.02405000",
                        "longitude": "150.73501000"
                    },
                    {
                        "id": 5529,
                        "name": "Harris Park",
                        "latitude": "-33.82285000",
                        "longitude": "151.00781000"
                    },
                    {
                        "id": 5534,
                        "name": "Hassall Grove",
                        "latitude": "-33.73349000",
                        "longitude": "150.83542000"
                    },
                    {
                        "id": 5539,
                        "name": "Hawkesbury",
                        "latitude": "-33.34078000",
                        "longitude": "150.78300000"
                    },
                    {
                        "id": 5540,
                        "name": "Hawks Nest",
                        "latitude": "-32.66755000",
                        "longitude": "152.17831000"
                    },
                    {
                        "id": 5547,
                        "name": "Hay",
                        "latitude": "-34.54276000",
                        "longitude": "144.83826000"
                    },
                    {
                        "id": 5550,
                        "name": "Haymarket",
                        "latitude": "-33.87868000",
                        "longitude": "151.20526000"
                    },
                    {
                        "id": 5551,
                        "name": "Hazelbrook",
                        "latitude": "-33.72446000",
                        "longitude": "150.45839000"
                    },
                    {
                        "id": 5556,
                        "name": "Heathcote",
                        "latitude": "-34.08410000",
                        "longitude": "151.01305000"
                    },
                    {
                        "id": 5563,
                        "name": "Hebersham",
                        "latitude": "-33.74582000",
                        "longitude": "150.82385000"
                    },
                    {
                        "id": 5564,
                        "name": "Heckenberg",
                        "latitude": "-33.90828000",
                        "longitude": "150.88982000"
                    },
                    {
                        "id": 5566,
                        "name": "Heddon Greta",
                        "latitude": "-32.80204000",
                        "longitude": "151.51327000"
                    },
                    {
                        "id": 5571,
                        "name": "Helensburgh",
                        "latitude": "-34.17836000",
                        "longitude": "150.99522000"
                    },
                    {
                        "id": 5579,
                        "name": "Henty",
                        "latitude": "-35.52094000",
                        "longitude": "147.03426000"
                    },
                    {
                        "id": 5604,
                        "name": "Hill Top",
                        "latitude": "-34.34792000",
                        "longitude": "150.49550000"
                    },
                    {
                        "id": 5611,
                        "name": "Hillsdale",
                        "latitude": "-33.95151000",
                        "longitude": "151.22784000"
                    },
                    {
                        "id": 5613,
                        "name": "Hillston",
                        "latitude": "-33.48266000",
                        "longitude": "145.53525000"
                    },
                    {
                        "id": 5614,
                        "name": "Hillvue",
                        "latitude": "-31.12756000",
                        "longitude": "150.90711000"
                    },
                    {
                        "id": 5617,
                        "name": "Hinchinbrook",
                        "latitude": "-33.91878000",
                        "longitude": "150.86314000"
                    },
                    {
                        "id": 5623,
                        "name": "Hobartville",
                        "latitude": "-33.60435000",
                        "longitude": "150.74299000"
                    },
                    {
                        "id": 5627,
                        "name": "Holbrook",
                        "latitude": "-35.72100000",
                        "longitude": "147.31605000"
                    },
                    {
                        "id": 5635,
                        "name": "Holmesville",
                        "latitude": "-32.91667000",
                        "longitude": "151.58333000"
                    },
                    {
                        "id": 5637,
                        "name": "Holroyd",
                        "latitude": "-33.83078000",
                        "longitude": "150.99725000"
                    },
                    {
                        "id": 5638,
                        "name": "Holsworthy",
                        "latitude": "-33.98333000",
                        "longitude": "150.96667000"
                    },
                    {
                        "id": 5642,
                        "name": "Homebush",
                        "latitude": "-33.86667000",
                        "longitude": "151.08333000"
                    },
                    {
                        "id": 5643,
                        "name": "Homebush West",
                        "latitude": "-33.86269000",
                        "longitude": "151.06696000"
                    },
                    {
                        "id": 5648,
                        "name": "Horningsea Park",
                        "latitude": "-33.94341000",
                        "longitude": "150.84528000"
                    },
                    {
                        "id": 5649,
                        "name": "Hornsby",
                        "latitude": "-33.70244000",
                        "longitude": "151.09931000"
                    },
                    {
                        "id": 5650,
                        "name": "Hornsby Heights",
                        "latitude": "-33.67130000",
                        "longitude": "151.09428000"
                    },
                    {
                        "id": 5651,
                        "name": "Hornsby Shire",
                        "latitude": "-33.58315000",
                        "longitude": "151.10953000"
                    },
                    {
                        "id": 5653,
                        "name": "Horsley",
                        "latitude": "-34.48763000",
                        "longitude": "150.77799000"
                    },
                    {
                        "id": 5654,
                        "name": "Horsley Park",
                        "latitude": "-33.84322000",
                        "longitude": "150.84889000"
                    },
                    {
                        "id": 5659,
                        "name": "Howlong",
                        "latitude": "-35.98197000",
                        "longitude": "146.63248000"
                    },
                    {
                        "id": 5661,
                        "name": "Hoxton Park",
                        "latitude": "-33.93126000",
                        "longitude": "150.85412000"
                    },
                    {
                        "id": 5667,
                        "name": "Hunters Hill",
                        "latitude": "-33.83437000",
                        "longitude": "151.14510000"
                    },
                    {
                        "id": 5668,
                        "name": "Hunterview",
                        "latitude": "-32.54343000",
                        "longitude": "151.17717000"
                    },
                    {
                        "id": 149308,
                        "name": "Huntingwood",
                        "latitude": "-33.79759320",
                        "longitude": "150.87480900"
                    },
                    {
                        "id": 5675,
                        "name": "Hurlstone Park",
                        "latitude": "-33.90988000",
                        "longitude": "151.12867000"
                    },
                    {
                        "id": 5677,
                        "name": "Hurstville",
                        "latitude": "-33.96770000",
                        "longitude": "151.10149000"
                    },
                    {
                        "id": 5678,
                        "name": "Hurstville Grove",
                        "latitude": "-33.97993000",
                        "longitude": "151.09029000"
                    },
                    {
                        "id": 5682,
                        "name": "Illawong",
                        "latitude": "-34.00000000",
                        "longitude": "151.03333000"
                    },
                    {
                        "id": 5684,
                        "name": "Iluka",
                        "latitude": "-29.40147000",
                        "longitude": "153.35112000"
                    },
                    {
                        "id": 5691,
                        "name": "Ingleburn",
                        "latitude": "-34.00000000",
                        "longitude": "150.86667000"
                    },
                    {
                        "id": 5697,
                        "name": "Inverell",
                        "latitude": "-29.31526000",
                        "longitude": "151.04187000"
                    },
                    {
                        "id": 5709,
                        "name": "Islington",
                        "latitude": "-32.91388000",
                        "longitude": "151.74739000"
                    },
                    {
                        "id": 5716,
                        "name": "Jamberoo",
                        "latitude": "-34.64745000",
                        "longitude": "150.77464000"
                    },
                    {
                        "id": 5719,
                        "name": "Jamisontown",
                        "latitude": "-33.76797000",
                        "longitude": "150.67681000"
                    },
                    {
                        "id": 5724,
                        "name": "Jannali",
                        "latitude": "-34.01643000",
                        "longitude": "151.06065000"
                    },
                    {
                        "id": 5727,
                        "name": "Jerilderie",
                        "latitude": "-35.35757000",
                        "longitude": "145.72962000"
                    },
                    {
                        "id": 5728,
                        "name": "Jerrabomberra",
                        "latitude": "-35.38441000",
                        "longitude": "149.20248000"
                    },
                    {
                        "id": 5730,
                        "name": "Jesmond",
                        "latitude": "-32.90275000",
                        "longitude": "151.69072000"
                    },
                    {
                        "id": 5731,
                        "name": "Jewells",
                        "latitude": "-33.01386000",
                        "longitude": "151.68308000"
                    },
                    {
                        "id": 5732,
                        "name": "Jilliby",
                        "latitude": "-33.22605000",
                        "longitude": "151.41684000"
                    },
                    {
                        "id": 5734,
                        "name": "Jindabyne",
                        "latitude": "-36.41745000",
                        "longitude": "148.62254000"
                    },
                    {
                        "id": 5737,
                        "name": "Jindera",
                        "latitude": "-35.95474000",
                        "longitude": "146.88852000"
                    },
                    {
                        "id": 5743,
                        "name": "Jordan Springs",
                        "latitude": "-33.72138000",
                        "longitude": "150.72873000"
                    },
                    {
                        "id": 5748,
                        "name": "Junction Hill",
                        "latitude": "-29.64113000",
                        "longitude": "152.92491000"
                    },
                    {
                        "id": 5750,
                        "name": "Junee",
                        "latitude": "-34.86819000",
                        "longitude": "147.58273000"
                    },
                    {
                        "id": 5754,
                        "name": "Kahibah",
                        "latitude": "-32.96175000",
                        "longitude": "151.71251000"
                    },
                    {
                        "id": 5772,
                        "name": "Kanahooka",
                        "latitude": "-34.49160000",
                        "longitude": "150.80817000"
                    },
                    {
                        "id": 5773,
                        "name": "Kandos",
                        "latitude": "-32.85772000",
                        "longitude": "149.96832000"
                    },
                    {
                        "id": 5779,
                        "name": "Kanwal",
                        "latitude": "-33.25300000",
                        "longitude": "151.49110000"
                    },
                    {
                        "id": 5780,
                        "name": "Kapooka",
                        "latitude": "-35.15693000",
                        "longitude": "147.28439000"
                    },
                    {
                        "id": 5782,
                        "name": "Karabar",
                        "latitude": "-35.37595000",
                        "longitude": "149.23280000"
                    },
                    {
                        "id": 5788,
                        "name": "Kareela",
                        "latitude": "-34.01336000",
                        "longitude": "151.08345000"
                    },
                    {
                        "id": 5789,
                        "name": "Kariong",
                        "latitude": "-33.43972000",
                        "longitude": "151.29453000"
                    },
                    {
                        "id": 5794,
                        "name": "Karuah",
                        "latitude": "-32.65389000",
                        "longitude": "151.96040000"
                    },
                    {
                        "id": 5800,
                        "name": "Katoomba",
                        "latitude": "-33.71977000",
                        "longitude": "150.30739000"
                    },
                    {
                        "id": 5805,
                        "name": "Kearns",
                        "latitude": "-34.02191000",
                        "longitude": "150.80082000"
                    },
                    {
                        "id": 5812,
                        "name": "Keiraville",
                        "latitude": "-34.41667000",
                        "longitude": "150.86667000"
                    },
                    {
                        "id": 5815,
                        "name": "Kellyville",
                        "latitude": "-33.71028000",
                        "longitude": "150.95095000"
                    },
                    {
                        "id": 5816,
                        "name": "Kellyville Ridge",
                        "latitude": "-33.70156000",
                        "longitude": "150.91790000"
                    },
                    {
                        "id": 5818,
                        "name": "Kelso",
                        "latitude": "-33.41667000",
                        "longitude": "149.60000000"
                    },
                    {
                        "id": 5821,
                        "name": "Kemps Creek",
                        "latitude": "-33.88059000",
                        "longitude": "150.78761000"
                    },
                    {
                        "id": 5822,
                        "name": "Kempsey",
                        "latitude": "-30.90553000",
                        "longitude": "152.68608000"
                    },
                    {
                        "id": 5823,
                        "name": "Kendall",
                        "latitude": "-31.63295000",
                        "longitude": "152.70393000"
                    },
                    {
                        "id": 5828,
                        "name": "Kensington",
                        "latitude": "-33.92019000",
                        "longitude": "151.22241000"
                    },
                    {
                        "id": 5834,
                        "name": "Kenthurst",
                        "latitude": "-33.65527000",
                        "longitude": "151.00503000"
                    },
                    {
                        "id": 5842,
                        "name": "Kew",
                        "latitude": "-31.63602000",
                        "longitude": "152.72662000"
                    },
                    {
                        "id": 5848,
                        "name": "Kiama",
                        "latitude": "-34.67124000",
                        "longitude": "150.84572000"
                    },
                    {
                        "id": 5849,
                        "name": "Kiama Downs",
                        "latitude": "-34.63341000",
                        "longitude": "150.85456000"
                    },
                    {
                        "id": 5852,
                        "name": "Kilaben Bay",
                        "latitude": "-33.02395000",
                        "longitude": "151.59197000"
                    },
                    {
                        "id": 5856,
                        "name": "Killara",
                        "latitude": "-33.76604000",
                        "longitude": "151.16213000"
                    },
                    {
                        "id": 5857,
                        "name": "Killarney Heights",
                        "latitude": "-33.77451000",
                        "longitude": "151.22028000"
                    },
                    {
                        "id": 5858,
                        "name": "Killarney Vale",
                        "latitude": "-33.36319000",
                        "longitude": "151.45799000"
                    },
                    {
                        "id": 5864,
                        "name": "King Creek",
                        "latitude": "-31.49237000",
                        "longitude": "152.75658000"
                    },
                    {
                        "id": 5871,
                        "name": "Kings Langley",
                        "latitude": "-33.75005000",
                        "longitude": "150.93542000"
                    },
                    {
                        "id": 5873,
                        "name": "Kings Park",
                        "latitude": "-33.74320000",
                        "longitude": "150.90761000"
                    },
                    {
                        "id": 5876,
                        "name": "Kingscliff",
                        "latitude": "-28.25983000",
                        "longitude": "153.57816000"
                    },
                    {
                        "id": 5878,
                        "name": "Kingsford",
                        "latitude": "-33.92399000",
                        "longitude": "151.22749000"
                    },
                    {
                        "id": 5879,
                        "name": "Kingsgrove",
                        "latitude": "-33.93932000",
                        "longitude": "151.09928000"
                    },
                    {
                        "id": 5890,
                        "name": "Kingswood Park",
                        "latitude": "-33.76651000",
                        "longitude": "150.71440000"
                    },
                    {
                        "id": 5894,
                        "name": "Kirrawee",
                        "latitude": "-34.03831000",
                        "longitude": "151.06903000"
                    },
                    {
                        "id": 5895,
                        "name": "Kirribilli",
                        "latitude": "-33.84867000",
                        "longitude": "151.21620000"
                    },
                    {
                        "id": 5901,
                        "name": "Kogarah",
                        "latitude": "-33.96810000",
                        "longitude": "151.13564000"
                    },
                    {
                        "id": 5902,
                        "name": "Kogarah Bay",
                        "latitude": "-33.97951000",
                        "longitude": "151.12119000"
                    },
                    {
                        "id": 5906,
                        "name": "Koonawarra",
                        "latitude": "-34.50212000",
                        "longitude": "150.80855000"
                    },
                    {
                        "id": 5911,
                        "name": "Kooringal",
                        "latitude": "-35.14069000",
                        "longitude": "147.37680000"
                    },
                    {
                        "id": 5912,
                        "name": "Kootingal",
                        "latitude": "-31.05857000",
                        "longitude": "151.05350000"
                    },
                    {
                        "id": 5914,
                        "name": "Korora",
                        "latitude": "-30.24620000",
                        "longitude": "153.11487000"
                    },
                    {
                        "id": 5916,
                        "name": "Kosciuszko National Park",
                        "latitude": "-36.26436000",
                        "longitude": "148.48179000"
                    },
                    {
                        "id": 5917,
                        "name": "Kotara",
                        "latitude": "-32.94282000",
                        "longitude": "151.69585000"
                    },
                    {
                        "id": 5918,
                        "name": "Kotara South",
                        "latitude": "-32.95261000",
                        "longitude": "151.69076000"
                    },
                    {
                        "id": 5920,
                        "name": "Ku-ring-gai",
                        "latitude": "-33.72701000",
                        "longitude": "151.14877000"
                    },
                    {
                        "id": 5926,
                        "name": "Kurnell",
                        "latitude": "-34.01088000",
                        "longitude": "151.20512000"
                    },
                    {
                        "id": 5927,
                        "name": "Kurraba Point",
                        "latitude": "-33.84235000",
                        "longitude": "151.22256000"
                    },
                    {
                        "id": 5928,
                        "name": "Kurrajong Heights",
                        "latitude": "-33.52772000",
                        "longitude": "150.62907000"
                    },
                    {
                        "id": 5930,
                        "name": "Kurri Kurri",
                        "latitude": "-32.81933000",
                        "longitude": "151.47908000"
                    },
                    {
                        "id": 5935,
                        "name": "Kyle Bay",
                        "latitude": "-33.98787000",
                        "longitude": "151.09939000"
                    },
                    {
                        "id": 5937,
                        "name": "Kyogle",
                        "latitude": "-28.64643000",
                        "longitude": "152.77871000"
                    },
                    {
                        "id": 5939,
                        "name": "Lachlan",
                        "latitude": "-32.79999000",
                        "longitude": "146.87556000"
                    },
                    {
                        "id": 5941,
                        "name": "Lake Albert",
                        "latitude": "-35.16667000",
                        "longitude": "147.38333000"
                    },
                    {
                        "id": 5942,
                        "name": "Lake Cargelligo",
                        "latitude": "-33.29884000",
                        "longitude": "146.37296000"
                    },
                    {
                        "id": 5943,
                        "name": "Lake Cathie",
                        "latitude": "-31.55183000",
                        "longitude": "152.85465000"
                    },
                    {
                        "id": 5946,
                        "name": "Lake Haven",
                        "latitude": "-33.24303000",
                        "longitude": "151.50434000"
                    },
                    {
                        "id": 5947,
                        "name": "Lake Heights",
                        "latitude": "-34.48433000",
                        "longitude": "150.86649000"
                    },
                    {
                        "id": 5948,
                        "name": "Lake Illawarra",
                        "latitude": "-34.54658000",
                        "longitude": "150.85645000"
                    },
                    {
                        "id": 5950,
                        "name": "Lake Macquarie Shire",
                        "latitude": "-33.03756000",
                        "longitude": "151.53470000"
                    },
                    {
                        "id": 5951,
                        "name": "Lake Munmorah",
                        "latitude": "-33.19716000",
                        "longitude": "151.58240000"
                    },
                    {
                        "id": 5954,
                        "name": "Lakelands",
                        "latitude": "-32.96185000",
                        "longitude": "151.64972000"
                    },
                    {
                        "id": 5955,
                        "name": "Lakemba",
                        "latitude": "-33.91972000",
                        "longitude": "151.07592000"
                    },
                    {
                        "id": 5957,
                        "name": "Lakewood",
                        "latitude": "-31.63210000",
                        "longitude": "152.75820000"
                    },
                    {
                        "id": 5959,
                        "name": "Lalor Park",
                        "latitude": "-33.76090000",
                        "longitude": "150.93123000"
                    },
                    {
                        "id": 5960,
                        "name": "Lambton",
                        "latitude": "-32.91667000",
                        "longitude": "151.70000000"
                    },
                    {
                        "id": 5966,
                        "name": "Lane Cove",
                        "latitude": "-33.82321000",
                        "longitude": "151.17028000"
                    },
                    {
                        "id": 5967,
                        "name": "Lane Cove North",
                        "latitude": "-33.80543000",
                        "longitude": "151.16638000"
                    },
                    {
                        "id": 5968,
                        "name": "Lane Cove West",
                        "latitude": "-33.81613000",
                        "longitude": "151.15145000"
                    },
                    {
                        "id": 5973,
                        "name": "Lansvale",
                        "latitude": "-33.90073000",
                        "longitude": "150.95078000"
                    },
                    {
                        "id": 5976,
                        "name": "Largs",
                        "latitude": "-32.70000000",
                        "longitude": "151.60000000"
                    },
                    {
                        "id": 5990,
                        "name": "Lavington",
                        "latitude": "-36.03976000",
                        "longitude": "146.93958000"
                    },
                    {
                        "id": 5992,
                        "name": "Lawrence",
                        "latitude": "-29.49210000",
                        "longitude": "153.09689000"
                    },
                    {
                        "id": 5993,
                        "name": "Lawson",
                        "latitude": "-33.72064000",
                        "longitude": "150.42975000"
                    },
                    {
                        "id": 5999,
                        "name": "Leeton",
                        "latitude": "-34.52967000",
                        "longitude": "146.26918000"
                    },
                    {
                        "id": 6002,
                        "name": "Leichhardt",
                        "latitude": "-33.88341000",
                        "longitude": "151.15625000"
                    },
                    {
                        "id": 6004,
                        "name": "Lemon Tree Passage",
                        "latitude": "-32.73047000",
                        "longitude": "152.03859000"
                    },
                    {
                        "id": 6006,
                        "name": "Lennox Head",
                        "latitude": "-28.79131000",
                        "longitude": "153.59201000"
                    },
                    {
                        "id": 6007,
                        "name": "Leonay",
                        "latitude": "-33.76542000",
                        "longitude": "150.64806000"
                    },
                    {
                        "id": 6011,
                        "name": "Leppington",
                        "latitude": "-33.96983000",
                        "longitude": "150.79675000"
                    },
                    {
                        "id": 6014,
                        "name": "Lethbridge Park",
                        "latitude": "-33.73716000",
                        "longitude": "150.80042000"
                    },
                    {
                        "id": 6015,
                        "name": "Leumeah",
                        "latitude": "-34.05000000",
                        "longitude": "150.83333000"
                    },
                    {
                        "id": 6016,
                        "name": "Leura",
                        "latitude": "-33.71667000",
                        "longitude": "150.33333000"
                    },
                    {
                        "id": 6017,
                        "name": "Lewisham",
                        "latitude": "-33.89719000",
                        "longitude": "151.14883000"
                    },
                    {
                        "id": 6019,
                        "name": "Liberty Grove",
                        "latitude": "-33.84095000",
                        "longitude": "151.08402000"
                    },
                    {
                        "id": 6020,
                        "name": "Lidcombe",
                        "latitude": "-33.86436000",
                        "longitude": "151.03970000"
                    },
                    {
                        "id": 6022,
                        "name": "Lightning Ridge",
                        "latitude": "-29.42743000",
                        "longitude": "147.97865000"
                    },
                    {
                        "id": 6023,
                        "name": "Lilli Pilli",
                        "latitude": "-34.06830000",
                        "longitude": "151.11574000"
                    },
                    {
                        "id": 6025,
                        "name": "Lilyfield",
                        "latitude": "-33.87499000",
                        "longitude": "151.16530000"
                    },
                    {
                        "id": 6027,
                        "name": "Lindfield",
                        "latitude": "-33.78333000",
                        "longitude": "151.16667000"
                    },
                    {
                        "id": 6029,
                        "name": "Lisarow",
                        "latitude": "-33.38333000",
                        "longitude": "151.36667000"
                    },
                    {
                        "id": 6030,
                        "name": "Lismore",
                        "latitude": "-28.81354000",
                        "longitude": "153.27730000"
                    },
                    {
                        "id": 6031,
                        "name": "Lismore Heights",
                        "latitude": "-28.80102000",
                        "longitude": "153.30048000"
                    },
                    {
                        "id": 6032,
                        "name": "Lismore Municipality",
                        "latitude": "-28.80000000",
                        "longitude": "153.26667000"
                    },
                    {
                        "id": 6034,
                        "name": "Lithgow",
                        "latitude": "-33.32025000",
                        "longitude": "150.18584000"
                    },
                    {
                        "id": 6035,
                        "name": "Little Bay",
                        "latitude": "-33.97899000",
                        "longitude": "151.24299000"
                    },
                    {
                        "id": 6040,
                        "name": "Liverpool",
                        "latitude": "-33.92418000",
                        "longitude": "150.91232000"
                    },
                    {
                        "id": 6041,
                        "name": "Liverpool Plains",
                        "latitude": "-31.47024000",
                        "longitude": "150.42001000"
                    },
                    {
                        "id": 6042,
                        "name": "Llanarth",
                        "latitude": "-33.39687000",
                        "longitude": "149.55105000"
                    },
                    {
                        "id": 6043,
                        "name": "Llandilo",
                        "latitude": "-33.71286000",
                        "longitude": "150.74650000"
                    },
                    {
                        "id": 6045,
                        "name": "Lockhart",
                        "latitude": "-35.32193000",
                        "longitude": "146.79354000"
                    },
                    {
                        "id": 6052,
                        "name": "Loftus",
                        "latitude": "-34.04467000",
                        "longitude": "151.04646000"
                    },
                    {
                        "id": 6060,
                        "name": "Londonderry",
                        "latitude": "-33.64656000",
                        "longitude": "150.73515000"
                    },
                    {
                        "id": 6061,
                        "name": "Long Beach",
                        "latitude": "-35.70833000",
                        "longitude": "150.24483000"
                    },
                    {
                        "id": 6063,
                        "name": "Long Jetty",
                        "latitude": "-33.35917000",
                        "longitude": "151.48834000"
                    },
                    {
                        "id": 6067,
                        "name": "Longueville",
                        "latitude": "-33.83285000",
                        "longitude": "151.16531000"
                    },
                    {
                        "id": 6069,
                        "name": "Lorn",
                        "latitude": "-32.72701000",
                        "longitude": "151.57245000"
                    },
                    {
                        "id": 6083,
                        "name": "Luddenham",
                        "latitude": "-33.87850000",
                        "longitude": "150.68863000"
                    },
                    {
                        "id": 6085,
                        "name": "Lugarno",
                        "latitude": "-33.98267000",
                        "longitude": "151.04184000"
                    },
                    {
                        "id": 6086,
                        "name": "Lurnea",
                        "latitude": "-33.93539000",
                        "longitude": "150.89673000"
                    },
                    {
                        "id": 6107,
                        "name": "Macksville",
                        "latitude": "-30.70780000",
                        "longitude": "152.92029000"
                    },
                    {
                        "id": 6108,
                        "name": "Maclean",
                        "latitude": "-29.45810000",
                        "longitude": "153.19753000"
                    },
                    {
                        "id": 6111,
                        "name": "Macmasters Beach",
                        "latitude": "-33.49663000",
                        "longitude": "151.42215000"
                    },
                    {
                        "id": 6113,
                        "name": "Macquarie Fields",
                        "latitude": "-33.99206000",
                        "longitude": "150.89307000"
                    },
                    {
                        "id": 6114,
                        "name": "Macquarie Hills",
                        "latitude": "-32.95111000",
                        "longitude": "151.64461000"
                    },
                    {
                        "id": 6115,
                        "name": "Macquarie Links",
                        "latitude": "-33.98454000",
                        "longitude": "150.87027000"
                    },
                    {
                        "id": 6116,
                        "name": "Macquarie Park",
                        "latitude": "-33.78105000",
                        "longitude": "151.12757000"
                    },
                    {
                        "id": 6129,
                        "name": "Maitland",
                        "latitude": "-32.73308000",
                        "longitude": "151.55740000"
                    },
                    {
                        "id": 6131,
                        "name": "Maitland city centre",
                        "latitude": "-32.73263000",
                        "longitude": "151.55331000"
                    },
                    {
                        "id": 6130,
                        "name": "Maitland Municipality",
                        "latitude": "-32.73333000",
                        "longitude": "151.55000000"
                    },
                    {
                        "id": 6132,
                        "name": "Malabar",
                        "latitude": "-33.96216000",
                        "longitude": "151.24796000"
                    },
                    {
                        "id": 6139,
                        "name": "Malua Bay",
                        "latitude": "-35.79382000",
                        "longitude": "150.22833000"
                    },
                    {
                        "id": 6145,
                        "name": "Mangerton",
                        "latitude": "-34.43667000",
                        "longitude": "150.87167000"
                    },
                    {
                        "id": 6148,
                        "name": "Manilla",
                        "latitude": "-30.74748000",
                        "longitude": "150.71974000"
                    },
                    {
                        "id": 6151,
                        "name": "Manly",
                        "latitude": "-33.79798000",
                        "longitude": "151.28826000"
                    },
                    {
                        "id": 6152,
                        "name": "Manly Vale",
                        "latitude": "-33.78457000",
                        "longitude": "151.26200000"
                    },
                    {
                        "id": 6154,
                        "name": "Mannering Park",
                        "latitude": "-33.15810000",
                        "longitude": "151.53477000"
                    },
                    {
                        "id": 6169,
                        "name": "Maraylya",
                        "latitude": "-33.59221000",
                        "longitude": "150.91979000"
                    },
                    {
                        "id": 6170,
                        "name": "Marayong",
                        "latitude": "-33.74824000",
                        "longitude": "150.89272000"
                    },
                    {
                        "id": 6174,
                        "name": "Mardi",
                        "latitude": "-33.29368000",
                        "longitude": "151.40150000"
                    },
                    {
                        "id": 6183,
                        "name": "Marks Point",
                        "latitude": "-33.05645000",
                        "longitude": "151.64955000"
                    },
                    {
                        "id": 6190,
                        "name": "Maroubra",
                        "latitude": "-33.95000000",
                        "longitude": "151.23333000"
                    },
                    {
                        "id": 6192,
                        "name": "Marrickville",
                        "latitude": "-33.90741000",
                        "longitude": "151.15546000"
                    },
                    {
                        "id": 6194,
                        "name": "Marsfield",
                        "latitude": "-33.77784000",
                        "longitude": "151.10574000"
                    },
                    {
                        "id": 6196,
                        "name": "Marulan",
                        "latitude": "-34.70836000",
                        "longitude": "150.00966000"
                    },
                    {
                        "id": 6199,
                        "name": "Maryland",
                        "latitude": "-32.87888000",
                        "longitude": "151.66143000"
                    },
                    {
                        "id": 6200,
                        "name": "Maryville",
                        "latitude": "-32.91121000",
                        "longitude": "151.75543000"
                    },
                    {
                        "id": 6201,
                        "name": "Mascot",
                        "latitude": "-33.92598000",
                        "longitude": "151.19347000"
                    },
                    {
                        "id": 6203,
                        "name": "Matraville",
                        "latitude": "-33.96344000",
                        "longitude": "151.23195000"
                    },
                    {
                        "id": 6208,
                        "name": "Mayfield",
                        "latitude": "-32.89793000",
                        "longitude": "151.73613000"
                    },
                    {
                        "id": 6209,
                        "name": "Mayfield East",
                        "latitude": "-32.90031000",
                        "longitude": "151.74972000"
                    },
                    {
                        "id": 6210,
                        "name": "Mayfield West",
                        "latitude": "-32.89195000",
                        "longitude": "151.72711000"
                    },
                    {
                        "id": 6216,
                        "name": "McGraths Hill",
                        "latitude": "-33.61551000",
                        "longitude": "150.83372000"
                    },
                    {
                        "id": 6223,
                        "name": "McMahons Point",
                        "latitude": "-33.84492000",
                        "longitude": "151.20307000"
                    },
                    {
                        "id": 6226,
                        "name": "Meadowbank",
                        "latitude": "-33.81668000",
                        "longitude": "151.08861000"
                    },
                    {
                        "id": 6232,
                        "name": "Medowie",
                        "latitude": "-32.74150000",
                        "longitude": "151.86760000"
                    },
                    {
                        "id": 6237,
                        "name": "Melrose Park",
                        "latitude": "-33.81491000",
                        "longitude": "151.07208000"
                    },
                    {
                        "id": 6243,
                        "name": "Menai",
                        "latitude": "-34.01667000",
                        "longitude": "151.01667000"
                    },
                    {
                        "id": 6244,
                        "name": "Menangle",
                        "latitude": "-34.12675000",
                        "longitude": "150.73868000"
                    },
                    {
                        "id": 6251,
                        "name": "Merewether",
                        "latitude": "-32.94801000",
                        "longitude": "151.74325000"
                    },
                    {
                        "id": 6252,
                        "name": "Merewether Heights",
                        "latitude": "-32.94733000",
                        "longitude": "151.73565000"
                    },
                    {
                        "id": 6254,
                        "name": "Merimbula",
                        "latitude": "-36.88901000",
                        "longitude": "149.90961000"
                    },
                    {
                        "id": 6261,
                        "name": "Merriwa",
                        "latitude": "-32.13922000",
                        "longitude": "150.35562000"
                    },
                    {
                        "id": 6263,
                        "name": "Merrylands",
                        "latitude": "-33.83333000",
                        "longitude": "150.98333000"
                    },
                    {
                        "id": 6264,
                        "name": "Merrylands West",
                        "latitude": "-33.83269000",
                        "longitude": "150.96906000"
                    },
                    {
                        "id": 6265,
                        "name": "Metford",
                        "latitude": "-32.76497000",
                        "longitude": "151.60940000"
                    },
                    {
                        "id": 6271,
                        "name": "Mid-Western Regional",
                        "latitude": "-32.60202000",
                        "longitude": "149.76748000"
                    },
                    {
                        "id": 6272,
                        "name": "Middle Cove",
                        "latitude": "-33.79280000",
                        "longitude": "151.21248000"
                    },
                    {
                        "id": 6279,
                        "name": "Middleton Grange",
                        "latitude": "-33.91704000",
                        "longitude": "150.84186000"
                    },
                    {
                        "id": 6292,
                        "name": "Miller",
                        "latitude": "-33.92089000",
                        "longitude": "150.88469000"
                    },
                    {
                        "id": 6293,
                        "name": "Millers Point",
                        "latitude": "-33.85957000",
                        "longitude": "151.20406000"
                    },
                    {
                        "id": 6300,
                        "name": "Millthorpe",
                        "latitude": "-33.44601000",
                        "longitude": "149.18539000"
                    },
                    {
                        "id": 6301,
                        "name": "Milperra",
                        "latitude": "-33.93934000",
                        "longitude": "150.98148000"
                    },
                    {
                        "id": 6302,
                        "name": "Milsons Point",
                        "latitude": "-33.84600000",
                        "longitude": "151.21192000"
                    },
                    {
                        "id": 6303,
                        "name": "Milton",
                        "latitude": "-35.31644000",
                        "longitude": "150.43610000"
                    },
                    {
                        "id": 6305,
                        "name": "Minchinbury",
                        "latitude": "-33.78724000",
                        "longitude": "150.82956000"
                    },
                    {
                        "id": 6311,
                        "name": "Minto",
                        "latitude": "-34.03333000",
                        "longitude": "150.85000000"
                    },
                    {
                        "id": 6314,
                        "name": "Miranda",
                        "latitude": "-34.03857000",
                        "longitude": "151.10005000"
                    },
                    {
                        "id": 6324,
                        "name": "Mitchell",
                        "latitude": "-33.42732000",
                        "longitude": "149.55674000"
                    },
                    {
                        "id": 6327,
                        "name": "Mittagong",
                        "latitude": "-34.45002000",
                        "longitude": "150.44572000"
                    },
                    {
                        "id": 6328,
                        "name": "Moama",
                        "latitude": "-36.10413000",
                        "longitude": "144.76080000"
                    },
                    {
                        "id": 6339,
                        "name": "Mollymook",
                        "latitude": "-35.34107000",
                        "longitude": "150.46952000"
                    },
                    {
                        "id": 6340,
                        "name": "Mollymook Beach",
                        "latitude": "-35.32966000",
                        "longitude": "150.47173000"
                    },
                    {
                        "id": 6341,
                        "name": "Molong",
                        "latitude": "-33.09233000",
                        "longitude": "148.87002000"
                    },
                    {
                        "id": 6342,
                        "name": "Mona Vale",
                        "latitude": "-33.67757000",
                        "longitude": "151.30307000"
                    },
                    {
                        "id": 6351,
                        "name": "Monterey",
                        "latitude": "-33.97250000",
                        "longitude": "151.14810000"
                    },
                    {
                        "id": 6360,
                        "name": "Moonbi",
                        "latitude": "-31.01775000",
                        "longitude": "151.07062000"
                    },
                    {
                        "id": 6361,
                        "name": "Moonee Beach",
                        "latitude": "-30.20575000",
                        "longitude": "153.15293000"
                    },
                    {
                        "id": 6370,
                        "name": "Moorebank",
                        "latitude": "-33.94372000",
                        "longitude": "150.95657000"
                    },
                    {
                        "id": 6380,
                        "name": "Moree",
                        "latitude": "-29.46278000",
                        "longitude": "149.84157000"
                    },
                    {
                        "id": 6381,
                        "name": "Moree Plains",
                        "latitude": "-29.32131000",
                        "longitude": "149.58121000"
                    },
                    {
                        "id": 6384,
                        "name": "Morisset",
                        "latitude": "-33.10801000",
                        "longitude": "151.48706000"
                    },
                    {
                        "id": 6391,
                        "name": "Morpeth",
                        "latitude": "-32.73333000",
                        "longitude": "151.63333000"
                    },
                    {
                        "id": 6394,
                        "name": "Mortdale",
                        "latitude": "-33.96897000",
                        "longitude": "151.07231000"
                    },
                    {
                        "id": 6396,
                        "name": "Mortlake",
                        "latitude": "-33.84217000",
                        "longitude": "151.10719000"
                    },
                    {
                        "id": 6397,
                        "name": "Moruya",
                        "latitude": "-35.91250000",
                        "longitude": "150.08144000"
                    },
                    {
                        "id": 6399,
                        "name": "Mosman",
                        "latitude": "-33.82845000",
                        "longitude": "151.24866000"
                    },
                    {
                        "id": 6401,
                        "name": "Moss Vale",
                        "latitude": "-34.55374000",
                        "longitude": "150.37115000"
                    },
                    {
                        "id": 6405,
                        "name": "Mount Annan",
                        "latitude": "-34.05287000",
                        "longitude": "150.75984000"
                    },
                    {
                        "id": 6406,
                        "name": "Mount Austin",
                        "latitude": "-35.13684000",
                        "longitude": "147.35304000"
                    },
                    {
                        "id": 6412,
                        "name": "Mount Colah",
                        "latitude": "-33.68333000",
                        "longitude": "151.11667000"
                    },
                    {
                        "id": 6418,
                        "name": "Mount Druitt",
                        "latitude": "-33.76667000",
                        "longitude": "150.81667000"
                    },
                    {
                        "id": 6428,
                        "name": "Mount Hutton",
                        "latitude": "-32.98329000",
                        "longitude": "151.67012000"
                    },
                    {
                        "id": 6430,
                        "name": "Mount Keira",
                        "latitude": "-34.39678000",
                        "longitude": "150.85268000"
                    },
                    {
                        "id": 6431,
                        "name": "Mount Kembla",
                        "latitude": "-34.42881000",
                        "longitude": "150.82161000"
                    },
                    {
                        "id": 6432,
                        "name": "Mount Kuring-Gai",
                        "latitude": "-33.64197000",
                        "longitude": "151.12865000"
                    },
                    {
                        "id": 6434,
                        "name": "Mount Lewis",
                        "latitude": "-33.91750000",
                        "longitude": "151.04828000"
                    },
                    {
                        "id": 6448,
                        "name": "Mount Ousley",
                        "latitude": "-34.40213000",
                        "longitude": "150.88786000"
                    },
                    {
                        "id": 6452,
                        "name": "Mount Pleasant",
                        "latitude": "-34.39531000",
                        "longitude": "150.86658000"
                    },
                    {
                        "id": 6453,
                        "name": "Mount Pritchard",
                        "latitude": "-33.90295000",
                        "longitude": "150.90465000"
                    },
                    {
                        "id": 6456,
                        "name": "Mount Riverview",
                        "latitude": "-33.73074000",
                        "longitude": "150.63532000"
                    },
                    {
                        "id": 6457,
                        "name": "Mount Saint Thomas",
                        "latitude": "-34.44333000",
                        "longitude": "150.87222000"
                    },
                    {
                        "id": 6461,
                        "name": "Mount Vernon",
                        "latitude": "-33.86036000",
                        "longitude": "150.81007000"
                    },
                    {
                        "id": 6463,
                        "name": "Mount Warrigal",
                        "latitude": "-34.54804000",
                        "longitude": "150.83752000"
                    },
                    {
                        "id": 6469,
                        "name": "Mudgee",
                        "latitude": "-32.59426000",
                        "longitude": "149.58710000"
                    },
                    {
                        "id": 6475,
                        "name": "Mulgoa",
                        "latitude": "-33.83800000",
                        "longitude": "150.64963000"
                    },
                    {
                        "id": 6478,
                        "name": "Mullumbimby",
                        "latitude": "-28.55236000",
                        "longitude": "153.49956000"
                    },
                    {
                        "id": 6479,
                        "name": "Mulwala",
                        "latitude": "-35.98536000",
                        "longitude": "146.00534000"
                    },
                    {
                        "id": 6498,
                        "name": "Murrumbateman",
                        "latitude": "-34.97199000",
                        "longitude": "149.02985000"
                    },
                    {
                        "id": 6500,
                        "name": "Murrurundi",
                        "latitude": "-31.76422000",
                        "longitude": "150.83575000"
                    },
                    {
                        "id": 6502,
                        "name": "Murwillumbah",
                        "latitude": "-28.32732000",
                        "longitude": "153.39339000"
                    },
                    {
                        "id": 6503,
                        "name": "Muswellbrook",
                        "latitude": "-32.48935000",
                        "longitude": "150.69839000"
                    },
                    {
                        "id": 6508,
                        "name": "Nabiac",
                        "latitude": "-32.09837000",
                        "longitude": "152.37627000"
                    },
                    {
                        "id": 6514,
                        "name": "Nambucca",
                        "latitude": "-30.63333000",
                        "longitude": "152.98333000"
                    },
                    {
                        "id": 6515,
                        "name": "Nambucca Heads",
                        "latitude": "-30.64318000",
                        "longitude": "153.00884000"
                    },
                    {
                        "id": 6516,
                        "name": "Nambucca Shire",
                        "latitude": "-30.70829000",
                        "longitude": "152.71024000"
                    },
                    {
                        "id": 6517,
                        "name": "Nana Glen",
                        "latitude": "-30.13333000",
                        "longitude": "153.01667000"
                    },
                    {
                        "id": 6525,
                        "name": "Narara",
                        "latitude": "-33.39593000",
                        "longitude": "151.33527000"
                    },
                    {
                        "id": 6526,
                        "name": "Narellan",
                        "latitude": "-34.04338000",
                        "longitude": "150.73236000"
                    },
                    {
                        "id": 6527,
                        "name": "Narellan Vale",
                        "latitude": "-34.04974000",
                        "longitude": "150.74392000"
                    },
                    {
                        "id": 6529,
                        "name": "Naremburn",
                        "latitude": "-33.81698000",
                        "longitude": "151.20079000"
                    },
                    {
                        "id": 6530,
                        "name": "Narooma",
                        "latitude": "-36.21783000",
                        "longitude": "150.13247000"
                    },
                    {
                        "id": 6531,
                        "name": "Narrabeen",
                        "latitude": "-33.71277000",
                        "longitude": "151.29736000"
                    },
                    {
                        "id": 6532,
                        "name": "Narrabri",
                        "latitude": "-30.32779000",
                        "longitude": "149.60242000"
                    },
                    {
                        "id": 6534,
                        "name": "Narrandera",
                        "latitude": "-34.59107000",
                        "longitude": "146.53197000"
                    },
                    {
                        "id": 6535,
                        "name": "Narrawallee",
                        "latitude": "-35.31243000",
                        "longitude": "150.46351000"
                    },
                    {
                        "id": 6536,
                        "name": "Narraweena",
                        "latitude": "-33.75519000",
                        "longitude": "151.27659000"
                    },
                    {
                        "id": 6541,
                        "name": "Narromine",
                        "latitude": "-32.23174000",
                        "longitude": "147.97591000"
                    },
                    {
                        "id": 6542,
                        "name": "Narwee",
                        "latitude": "-33.94653000",
                        "longitude": "151.06919000"
                    },
                    {
                        "id": 6549,
                        "name": "Nelson Bay",
                        "latitude": "-32.72043000",
                        "longitude": "152.14398000"
                    },
                    {
                        "id": 6553,
                        "name": "Neutral Bay",
                        "latitude": "-33.83784000",
                        "longitude": "151.21750000"
                    },
                    {
                        "id": 6558,
                        "name": "New Lambton",
                        "latitude": "-32.92838000",
                        "longitude": "151.70850000"
                    },
                    {
                        "id": 6559,
                        "name": "New Lambton Heights",
                        "latitude": "-32.92466000",
                        "longitude": "151.69364000"
                    },
                    {
                        "id": 6563,
                        "name": "Newcastle",
                        "latitude": "-32.92953000",
                        "longitude": "151.78010000"
                    },
                    {
                        "id": 6565,
                        "name": "Newcastle city centre",
                        "latitude": "-32.92885000",
                        "longitude": "151.77740000"
                    },
                    {
                        "id": 6564,
                        "name": "Newcastle East",
                        "latitude": "-32.92771000",
                        "longitude": "151.78840000"
                    },
                    {
                        "id": 6568,
                        "name": "Newington",
                        "latitude": "-33.83488000",
                        "longitude": "151.05703000"
                    },
                    {
                        "id": 6572,
                        "name": "Newport",
                        "latitude": "-33.65639000",
                        "longitude": "151.31401000"
                    },
                    {
                        "id": 6578,
                        "name": "Newtown",
                        "latitude": "-33.89835000",
                        "longitude": "151.17754000"
                    },
                    {
                        "id": 6586,
                        "name": "Niagara Park",
                        "latitude": "-33.37638000",
                        "longitude": "151.34860000"
                    },
                    {
                        "id": 6594,
                        "name": "Nimbin",
                        "latitude": "-28.59545000",
                        "longitude": "153.22336000"
                    },
                    {
                        "id": 6605,
                        "name": "Noraville",
                        "latitude": "-33.26785000",
                        "longitude": "151.55352000"
                    },
                    {
                        "id": 6609,
                        "name": "Normanhurst",
                        "latitude": "-33.72370000",
                        "longitude": "151.09576000"
                    },
                    {
                        "id": 6613,
                        "name": "North Albury",
                        "latitude": "-36.05745000",
                        "longitude": "146.92995000"
                    },
                    {
                        "id": 6614,
                        "name": "North Avoca",
                        "latitude": "-33.45608000",
                        "longitude": "151.43511000"
                    },
                    {
                        "id": 6615,
                        "name": "North Balgowlah",
                        "latitude": "-33.78631000",
                        "longitude": "151.24801000"
                    },
                    {
                        "id": 6618,
                        "name": "North Boambee Valley",
                        "latitude": "-30.31295000",
                        "longitude": "153.06925000"
                    },
                    {
                        "id": 6619,
                        "name": "North Bondi",
                        "latitude": "-33.88787000",
                        "longitude": "151.28075000"
                    },
                    {
                        "id": 6625,
                        "name": "North Curl Curl",
                        "latitude": "-33.76434000",
                        "longitude": "151.29727000"
                    },
                    {
                        "id": 6626,
                        "name": "North Epping",
                        "latitude": "-33.75944000",
                        "longitude": "151.09248000"
                    },
                    {
                        "id": 6629,
                        "name": "North Gosford",
                        "latitude": "-33.41400000",
                        "longitude": "151.35160000"
                    },
                    {
                        "id": 6630,
                        "name": "North Haven",
                        "latitude": "-31.63680000",
                        "longitude": "152.81357000"
                    },
                    {
                        "id": 6636,
                        "name": "North Lambton",
                        "latitude": "-32.90605000",
                        "longitude": "151.70574000"
                    },
                    {
                        "id": 6639,
                        "name": "North Manly",
                        "latitude": "-33.77561000",
                        "longitude": "151.26921000"
                    },
                    {
                        "id": 6641,
                        "name": "North Narrabeen",
                        "latitude": "-33.70935000",
                        "longitude": "151.29607000"
                    },
                    {
                        "id": 6642,
                        "name": "North Nowra",
                        "latitude": "-34.85822000",
                        "longitude": "150.57479000"
                    },
                    {
                        "id": 6643,
                        "name": "North Parramatta",
                        "latitude": "-33.79351000",
                        "longitude": "151.00124000"
                    },
                    {
                        "id": 6646,
                        "name": "North Richmond",
                        "latitude": "-33.58117000",
                        "longitude": "150.71942000"
                    },
                    {
                        "id": 6647,
                        "name": "North Rocks",
                        "latitude": "-33.77223000",
                        "longitude": "151.01718000"
                    },
                    {
                        "id": 6648,
                        "name": "North Ryde",
                        "latitude": "-33.79677000",
                        "longitude": "151.12436000"
                    },
                    {
                        "id": 6649,
                        "name": "North St Marys",
                        "latitude": "-33.75491000",
                        "longitude": "150.78435000"
                    },
                    {
                        "id": 6650,
                        "name": "North Strathfield",
                        "latitude": "-33.85693000",
                        "longitude": "151.09124000"
                    },
                    {
                        "id": 6651,
                        "name": "North Sydney",
                        "latitude": "-33.83422000",
                        "longitude": "151.21019000"
                    },
                    {
                        "id": 6652,
                        "name": "North Tamworth",
                        "latitude": "-31.07862000",
                        "longitude": "150.92219000"
                    },
                    {
                        "id": 6654,
                        "name": "North Turramurra",
                        "latitude": "-33.71313000",
                        "longitude": "151.14638000"
                    },
                    {
                        "id": 6655,
                        "name": "North Wahroonga",
                        "latitude": "-33.70531000",
                        "longitude": "151.12278000"
                    },
                    {
                        "id": 6658,
                        "name": "North Willoughby",
                        "latitude": "-33.79563000",
                        "longitude": "151.20067000"
                    },
                    {
                        "id": 6659,
                        "name": "North Wollongong",
                        "latitude": "-34.40569000",
                        "longitude": "150.89763000"
                    },
                    {
                        "id": 6663,
                        "name": "Northbridge",
                        "latitude": "-33.81313000",
                        "longitude": "151.21728000"
                    },
                    {
                        "id": 6672,
                        "name": "Northmead",
                        "latitude": "-33.78378000",
                        "longitude": "150.99858000"
                    },
                    {
                        "id": 6679,
                        "name": "Nowra",
                        "latitude": "-34.88422000",
                        "longitude": "150.60036000"
                    },
                    {
                        "id": 6680,
                        "name": "Nowra Hill",
                        "latitude": "-34.92845000",
                        "longitude": "150.57243000"
                    },
                    {
                        "id": 6689,
                        "name": "Nyngan",
                        "latitude": "-31.56375000",
                        "longitude": "147.19373000"
                    },
                    {
                        "id": 6693,
                        "name": "Oak Flats",
                        "latitude": "-34.56229000",
                        "longitude": "150.82193000"
                    },
                    {
                        "id": 6695,
                        "name": "Oakdale",
                        "latitude": "-34.07930000",
                        "longitude": "150.51320000"
                    },
                    {
                        "id": 6701,
                        "name": "Oakhurst",
                        "latitude": "-33.73883000",
                        "longitude": "150.83837000"
                    },
                    {
                        "id": 6706,
                        "name": "Oakville",
                        "latitude": "-33.61558000",
                        "longitude": "150.88006000"
                    },
                    {
                        "id": 6707,
                        "name": "Oatlands",
                        "latitude": "-33.79595000",
                        "longitude": "151.02712000"
                    },
                    {
                        "id": 6708,
                        "name": "Oatley",
                        "latitude": "-33.98004000",
                        "longitude": "151.07201000"
                    },
                    {
                        "id": 6709,
                        "name": "Oberon",
                        "latitude": "-33.84531000",
                        "longitude": "149.81795000"
                    },
                    {
                        "id": 6712,
                        "name": "Ocean Shores",
                        "latitude": "-28.50930000",
                        "longitude": "153.53760000"
                    },
                    {
                        "id": 6714,
                        "name": "Old Bar",
                        "latitude": "-31.96940000",
                        "longitude": "152.58807000"
                    },
                    {
                        "id": 6716,
                        "name": "Old Erowal Bay",
                        "latitude": "-35.08460000",
                        "longitude": "150.64568000"
                    },
                    {
                        "id": 6717,
                        "name": "Old Guildford",
                        "latitude": "-33.86429000",
                        "longitude": "150.98395000"
                    },
                    {
                        "id": 6720,
                        "name": "Old Toongabbie",
                        "latitude": "-33.78763000",
                        "longitude": "150.96897000"
                    },
                    {
                        "id": 6729,
                        "name": "Oran Park",
                        "latitude": "-34.00564000",
                        "longitude": "150.74032000"
                    },
                    {
                        "id": 6731,
                        "name": "Orange",
                        "latitude": "-33.28397000",
                        "longitude": "149.10018000"
                    },
                    {
                        "id": 6732,
                        "name": "Orange Municipality",
                        "latitude": "-33.32834000",
                        "longitude": "149.12294000"
                    },
                    {
                        "id": 6733,
                        "name": "Orangeville",
                        "latitude": "-34.03108000",
                        "longitude": "150.60179000"
                    },
                    {
                        "id": 6735,
                        "name": "Orchard Hills",
                        "latitude": "-33.78230000",
                        "longitude": "150.71088000"
                    },
                    {
                        "id": 6745,
                        "name": "Ourimbah",
                        "latitude": "-33.31424000",
                        "longitude": "151.33031000"
                    },
                    {
                        "id": 6750,
                        "name": "Oxley Park",
                        "latitude": "-33.77072000",
                        "longitude": "150.79502000"
                    },
                    {
                        "id": 6751,
                        "name": "Oxley Vale",
                        "latitude": "-31.06316000",
                        "longitude": "150.90060000"
                    },
                    {
                        "id": 6752,
                        "name": "Oyster Bay",
                        "latitude": "-34.00407000",
                        "longitude": "151.07588000"
                    },
                    {
                        "id": 6757,
                        "name": "Paddington",
                        "latitude": "-33.88419000",
                        "longitude": "151.23151000"
                    },
                    {
                        "id": 6759,
                        "name": "Padstow",
                        "latitude": "-33.95687000",
                        "longitude": "151.03191000"
                    },
                    {
                        "id": 6760,
                        "name": "Padstow Heights",
                        "latitude": "-33.96740000",
                        "longitude": "151.03991000"
                    },
                    {
                        "id": 6762,
                        "name": "Pagewood",
                        "latitude": "-33.94137000",
                        "longitude": "151.21093000"
                    },
                    {
                        "id": 6766,
                        "name": "Palm Beach",
                        "latitude": "-33.59664000",
                        "longitude": "151.32384000"
                    },
                    {
                        "id": 6773,
                        "name": "Panania",
                        "latitude": "-33.95366000",
                        "longitude": "150.99733000"
                    },
                    {
                        "id": 6794,
                        "name": "Parkes",
                        "latitude": "-32.82318000",
                        "longitude": "148.02514000"
                    },
                    {
                        "id": 6797,
                        "name": "Parklea",
                        "latitude": "-33.72439000",
                        "longitude": "150.91820000"
                    },
                    {
                        "id": 6805,
                        "name": "Parramatta",
                        "latitude": "-33.81248000",
                        "longitude": "151.00262000"
                    },
                    {
                        "id": 6816,
                        "name": "Peak Hill",
                        "latitude": "-32.72387000",
                        "longitude": "148.19052000"
                    },
                    {
                        "id": 6817,
                        "name": "Peakhurst",
                        "latitude": "-33.96288000",
                        "longitude": "151.05161000"
                    },
                    {
                        "id": 6818,
                        "name": "Peakhurst Heights",
                        "latitude": "-33.97735000",
                        "longitude": "151.05557000"
                    },
                    {
                        "id": 6826,
                        "name": "Pemulwuy",
                        "latitude": "-33.82274000",
                        "longitude": "150.92395000"
                    },
                    {
                        "id": 6827,
                        "name": "Pendle Hill",
                        "latitude": "-33.80402000",
                        "longitude": "150.95543000"
                    },
                    {
                        "id": 6829,
                        "name": "Pennant Hills",
                        "latitude": "-33.73783000",
                        "longitude": "151.07216000"
                    },
                    {
                        "id": 6832,
                        "name": "Penrith",
                        "latitude": "-33.75000000",
                        "longitude": "150.70000000"
                    },
                    {
                        "id": 6833,
                        "name": "Penrith Municipality",
                        "latitude": "-33.75000000",
                        "longitude": "150.70000000"
                    },
                    {
                        "id": 6834,
                        "name": "Penshurst",
                        "latitude": "-33.96667000",
                        "longitude": "151.08333000"
                    },
                    {
                        "id": 6844,
                        "name": "Petersham",
                        "latitude": "-33.89460000",
                        "longitude": "151.15495000"
                    },
                    {
                        "id": 6847,
                        "name": "Phillip",
                        "latitude": "-31.13333000",
                        "longitude": "150.85000000"
                    },
                    {
                        "id": 6853,
                        "name": "Picnic Point",
                        "latitude": "-33.98062000",
                        "longitude": "150.99661000"
                    },
                    {
                        "id": 6854,
                        "name": "Picton",
                        "latitude": "-34.16995000",
                        "longitude": "150.61168000"
                    },
                    {
                        "id": 6862,
                        "name": "Pitt Town",
                        "latitude": "-33.58718000",
                        "longitude": "150.85857000"
                    },
                    {
                        "id": 6869,
                        "name": "Plumpton",
                        "latitude": "-33.75184000",
                        "longitude": "150.83686000"
                    },
                    {
                        "id": 6872,
                        "name": "Point Clare",
                        "latitude": "-33.44378000",
                        "longitude": "151.32732000"
                    },
                    {
                        "id": 6874,
                        "name": "Point Frederick",
                        "latitude": "-33.44036000",
                        "longitude": "151.34322000"
                    },
                    {
                        "id": 6876,
                        "name": "Point Piper",
                        "latitude": "-33.86667000",
                        "longitude": "151.25000000"
                    },
                    {
                        "id": 6878,
                        "name": "Pokolbin",
                        "latitude": "-32.80000000",
                        "longitude": "151.28333000"
                    },
                    {
                        "id": 6891,
                        "name": "Port Hacking",
                        "latitude": "-34.06791000",
                        "longitude": "151.12561000"
                    },
                    {
                        "id": 6893,
                        "name": "Port Kembla",
                        "latitude": "-34.48180000",
                        "longitude": "150.90120000"
                    },
                    {
                        "id": 6896,
                        "name": "Port Macquarie",
                        "latitude": "-31.43084000",
                        "longitude": "152.90894000"
                    },
                    {
                        "id": 6897,
                        "name": "Port Macquarie-Hastings",
                        "latitude": "-31.42106000",
                        "longitude": "152.51916000"
                    },
                    {
                        "id": 6907,
                        "name": "Port Stephens Shire",
                        "latitude": "-32.72855000",
                        "longitude": "151.89952000"
                    },
                    {
                        "id": 6910,
                        "name": "Portland",
                        "latitude": "-33.35709000",
                        "longitude": "149.98148000"
                    },
                    {
                        "id": 6912,
                        "name": "Potts Point",
                        "latitude": "-33.86701000",
                        "longitude": "151.22586000"
                    },
                    {
                        "id": 6913,
                        "name": "Pottsville",
                        "latitude": "-28.38740000",
                        "longitude": "153.55857000"
                    },
                    {
                        "id": 6914,
                        "name": "Pottsville Beach",
                        "latitude": "-28.38853000",
                        "longitude": "153.56564000"
                    },
                    {
                        "id": 6916,
                        "name": "Prairiewood",
                        "latitude": "-33.86325000",
                        "longitude": "150.90521000"
                    },
                    {
                        "id": 6918,
                        "name": "Prestons",
                        "latitude": "-33.94185000",
                        "longitude": "150.87170000"
                    },
                    {
                        "id": 6919,
                        "name": "Primbee",
                        "latitude": "-34.50358000",
                        "longitude": "150.87950000"
                    },
                    {
                        "id": 6923,
                        "name": "Prospect",
                        "latitude": "-33.80154000",
                        "longitude": "150.91358000"
                    },
                    {
                        "id": 6927,
                        "name": "Punchbowl",
                        "latitude": "-33.92893000",
                        "longitude": "151.05111000"
                    },
                    {
                        "id": 6928,
                        "name": "Putney",
                        "latitude": "-33.82613000",
                        "longitude": "151.10630000"
                    },
                    {
                        "id": 6929,
                        "name": "Pymble",
                        "latitude": "-33.74386000",
                        "longitude": "151.14188000"
                    },
                    {
                        "id": 6931,
                        "name": "Pyrmont",
                        "latitude": "-33.86985000",
                        "longitude": "151.19402000"
                    },
                    {
                        "id": 6933,
                        "name": "Quakers Hill",
                        "latitude": "-33.73333000",
                        "longitude": "150.88333000"
                    },
                    {
                        "id": 6935,
                        "name": "Queanbeyan",
                        "latitude": "-35.35493000",
                        "longitude": "149.23200000"
                    },
                    {
                        "id": 6936,
                        "name": "Queanbeyan East",
                        "latitude": "-35.34625000",
                        "longitude": "149.24596000"
                    },
                    {
                        "id": 6937,
                        "name": "Queanbeyan West",
                        "latitude": "-35.35497000",
                        "longitude": "149.20412000"
                    },
                    {
                        "id": 6939,
                        "name": "Queens Park",
                        "latitude": "-33.89946000",
                        "longitude": "151.24724000"
                    },
                    {
                        "id": 6941,
                        "name": "Queenscliff",
                        "latitude": "-33.78278000",
                        "longitude": "151.28495000"
                    },
                    {
                        "id": 6949,
                        "name": "Quirindi",
                        "latitude": "-31.50763000",
                        "longitude": "150.67902000"
                    },
                    {
                        "id": 6951,
                        "name": "Raby",
                        "latitude": "-34.01846000",
                        "longitude": "150.81764000"
                    },
                    {
                        "id": 6953,
                        "name": "Raglan",
                        "latitude": "-33.41667000",
                        "longitude": "149.66667000"
                    },
                    {
                        "id": 6956,
                        "name": "Ramsgate",
                        "latitude": "-33.98220000",
                        "longitude": "151.14000000"
                    },
                    {
                        "id": 6957,
                        "name": "Ramsgate Beach",
                        "latitude": "-33.98523000",
                        "longitude": "151.14634000"
                    },
                    {
                        "id": 6958,
                        "name": "Randwick",
                        "latitude": "-33.91667000",
                        "longitude": "151.25000000"
                    },
                    {
                        "id": 6963,
                        "name": "Rankin Park",
                        "latitude": "-32.92516000",
                        "longitude": "151.68016000"
                    },
                    {
                        "id": 6966,
                        "name": "Rathmines",
                        "latitude": "-33.03773000",
                        "longitude": "151.58443000"
                    },
                    {
                        "id": 6972,
                        "name": "Raworth",
                        "latitude": "-32.73333000",
                        "longitude": "151.61667000"
                    },
                    {
                        "id": 6973,
                        "name": "Raymond Terrace",
                        "latitude": "-32.75952000",
                        "longitude": "151.75050000"
                    },
                    {
                        "id": 6974,
                        "name": "Razorback",
                        "latitude": "-34.15237000",
                        "longitude": "150.65308000"
                    },
                    {
                        "id": 6982,
                        "name": "Redfern",
                        "latitude": "-33.89279000",
                        "longitude": "151.20415000"
                    },
                    {
                        "id": 6983,
                        "name": "Redhead",
                        "latitude": "-33.01178000",
                        "longitude": "151.71142000"
                    },
                    {
                        "id": 6990,
                        "name": "Regents Park",
                        "latitude": "-33.88333000",
                        "longitude": "151.01667000"
                    },
                    {
                        "id": 6999,
                        "name": "Revesby",
                        "latitude": "-33.95000000",
                        "longitude": "151.01667000"
                    },
                    {
                        "id": 7000,
                        "name": "Revesby Heights",
                        "latitude": "-33.96710000",
                        "longitude": "151.01841000"
                    },
                    {
                        "id": 7003,
                        "name": "Rhodes",
                        "latitude": "-33.82663000",
                        "longitude": "151.08810000"
                    },
                    {
                        "id": 7006,
                        "name": "Richmond",
                        "latitude": "-33.59956000",
                        "longitude": "150.75142000"
                    },
                    {
                        "id": 7011,
                        "name": "Richmond Valley",
                        "latitude": "-29.02684000",
                        "longitude": "153.08625000"
                    },
                    {
                        "id": 7025,
                        "name": "Riverstone",
                        "latitude": "-33.68333000",
                        "longitude": "150.86667000"
                    },
                    {
                        "id": 7029,
                        "name": "Riverview",
                        "latitude": "-33.82465000",
                        "longitude": "151.16243000"
                    },
                    {
                        "id": 7030,
                        "name": "Riverwood",
                        "latitude": "-33.94725000",
                        "longitude": "151.04973000"
                    },
                    {
                        "id": 7034,
                        "name": "Robertson",
                        "latitude": "-34.58742000",
                        "longitude": "150.59116000"
                    },
                    {
                        "id": 7042,
                        "name": "Rockdale",
                        "latitude": "-33.96611000",
                        "longitude": "151.14342000"
                    },
                    {
                        "id": 7048,
                        "name": "Rodd Point",
                        "latitude": "-33.86662000",
                        "longitude": "151.13995000"
                    },
                    {
                        "id": 7055,
                        "name": "Rooty Hill",
                        "latitude": "-33.76667000",
                        "longitude": "150.83333000"
                    },
                    {
                        "id": 7057,
                        "name": "Ropes Crossing",
                        "latitude": "-33.73276000",
                        "longitude": "150.79104000"
                    },
                    {
                        "id": 7059,
                        "name": "Rose Bay",
                        "latitude": "-33.86877000",
                        "longitude": "151.27060000"
                    },
                    {
                        "id": 149144,
                        "name": "Rosebery",
                        "latitude": "-33.91855330",
                        "longitude": "151.19612440"
                    },
                    {
                        "id": 7065,
                        "name": "Rosehill",
                        "latitude": "-33.82009000",
                        "longitude": "151.02450000"
                    },
                    {
                        "id": 7066,
                        "name": "Roselands",
                        "latitude": "-33.93317000",
                        "longitude": "151.07320000"
                    },
                    {
                        "id": 7067,
                        "name": "Rosemeadow",
                        "latitude": "-34.10414000",
                        "longitude": "150.79282000"
                    },
                    {
                        "id": 7071,
                        "name": "Roseville",
                        "latitude": "-33.78333000",
                        "longitude": "151.18333000"
                    },
                    {
                        "id": 7072,
                        "name": "Roseville Chase",
                        "latitude": "-33.77852000",
                        "longitude": "151.19677000"
                    },
                    {
                        "id": 7082,
                        "name": "Rouse Hill",
                        "latitude": "-33.68207000",
                        "longitude": "150.91540000"
                    },
                    {
                        "id": 7088,
                        "name": "Rozelle",
                        "latitude": "-33.86141000",
                        "longitude": "151.17050000"
                    },
                    {
                        "id": 7092,
                        "name": "Ruse",
                        "latitude": "-34.06976000",
                        "longitude": "150.84168000"
                    },
                    {
                        "id": 7093,
                        "name": "Rushcutters Bay",
                        "latitude": "-33.87480000",
                        "longitude": "151.22799000"
                    },
                    {
                        "id": 7096,
                        "name": "Russell Lea",
                        "latitude": "-33.85889000",
                        "longitude": "151.14111000"
                    },
                    {
                        "id": 7097,
                        "name": "Russell Vale",
                        "latitude": "-34.35542000",
                        "longitude": "150.89434000"
                    },
                    {
                        "id": 7098,
                        "name": "Rutherford",
                        "latitude": "-32.71667000",
                        "longitude": "151.53333000"
                    },
                    {
                        "id": 7100,
                        "name": "Rydalmere",
                        "latitude": "-33.81453000",
                        "longitude": "151.03751000"
                    },
                    {
                        "id": 7101,
                        "name": "Ryde",
                        "latitude": "-33.80149000",
                        "longitude": "151.11205000"
                    },
                    {
                        "id": 7104,
                        "name": "Sadleir",
                        "latitude": "-33.91713000",
                        "longitude": "150.89093000"
                    },
                    {
                        "id": 7112,
                        "name": "Saint Ives",
                        "latitude": "-33.72976000",
                        "longitude": "151.15977000"
                    },
                    {
                        "id": 7116,
                        "name": "Saint Peters",
                        "latitude": "-33.91667000",
                        "longitude": "151.18333000"
                    },
                    {
                        "id": 7117,
                        "name": "Salamander Bay",
                        "latitude": "-32.72253000",
                        "longitude": "152.07945000"
                    },
                    {
                        "id": 7127,
                        "name": "Salt Ash",
                        "latitude": "-32.78333000",
                        "longitude": "151.91667000"
                    },
                    {
                        "id": 7132,
                        "name": "San Remo",
                        "latitude": "-33.21469000",
                        "longitude": "151.52102000"
                    },
                    {
                        "id": 7133,
                        "name": "Sanctuary Point",
                        "latitude": "-35.10361000",
                        "longitude": "150.62667000"
                    },
                    {
                        "id": 7138,
                        "name": "Sandringham",
                        "latitude": "-33.99447000",
                        "longitude": "151.13913000"
                    },
                    {
                        "id": 7142,
                        "name": "Sandy Beach",
                        "latitude": "-30.14681000",
                        "longitude": "153.19238000"
                    },
                    {
                        "id": 7143,
                        "name": "Sans Souci",
                        "latitude": "-33.98990000",
                        "longitude": "151.13334000"
                    },
                    {
                        "id": 7144,
                        "name": "Sapphire Beach",
                        "latitude": "-30.22614000",
                        "longitude": "153.13628000"
                    },
                    {
                        "id": 7145,
                        "name": "Saratoga",
                        "latitude": "-33.47564000",
                        "longitude": "151.35207000"
                    },
                    {
                        "id": 7148,
                        "name": "Sawtell",
                        "latitude": "-30.36459000",
                        "longitude": "153.10141000"
                    },
                    {
                        "id": 7153,
                        "name": "Schofields",
                        "latitude": "-33.71667000",
                        "longitude": "150.86667000"
                    },
                    {
                        "id": 7154,
                        "name": "Scone",
                        "latitude": "-32.05014000",
                        "longitude": "150.86893000"
                    },
                    {
                        "id": 7167,
                        "name": "Seaforth",
                        "latitude": "-33.80145000",
                        "longitude": "151.23981000"
                    },
                    {
                        "id": 7174,
                        "name": "Sefton",
                        "latitude": "-33.88773000",
                        "longitude": "151.01053000"
                    },
                    {
                        "id": 7184,
                        "name": "Seven Hills",
                        "latitude": "-33.78333000",
                        "longitude": "150.93333000"
                    },
                    {
                        "id": 7191,
                        "name": "Shalvey",
                        "latitude": "-33.72687000",
                        "longitude": "150.80529000"
                    },
                    {
                        "id": 7198,
                        "name": "Shell Cove",
                        "latitude": "-34.58994000",
                        "longitude": "150.86203000"
                    },
                    {
                        "id": 7200,
                        "name": "Shellharbour",
                        "latitude": "-34.58333000",
                        "longitude": "150.86667000"
                    },
                    {
                        "id": 7201,
                        "name": "Shelly Beach",
                        "latitude": "-33.36999000",
                        "longitude": "151.48522000"
                    },
                    {
                        "id": 7205,
                        "name": "Shoal Bay",
                        "latitude": "-32.72231000",
                        "longitude": "152.17498000"
                    },
                    {
                        "id": 7206,
                        "name": "Shoalhaven Heads",
                        "latitude": "-34.85086000",
                        "longitude": "150.74512000"
                    },
                    {
                        "id": 7207,
                        "name": "Shoalhaven Shire",
                        "latitude": "-35.14162000",
                        "longitude": "150.41295000"
                    },
                    {
                        "id": 7211,
                        "name": "Shortland",
                        "latitude": "-32.87883000",
                        "longitude": "151.69105000"
                    },
                    {
                        "id": 7215,
                        "name": "Silverdale",
                        "latitude": "-33.91520000",
                        "longitude": "150.60960000"
                    },
                    {
                        "id": 7216,
                        "name": "Silverwater",
                        "latitude": "-33.83343000",
                        "longitude": "151.04731000"
                    },
                    {
                        "id": 7219,
                        "name": "Singleton",
                        "latitude": "-32.60547000",
                        "longitude": "150.91872000"
                    },
                    {
                        "id": 7220,
                        "name": "Singleton Heights",
                        "latitude": "-32.54160000",
                        "longitude": "151.16089000"
                    },
                    {
                        "id": 7223,
                        "name": "Skennars Head",
                        "latitude": "-28.82888000",
                        "longitude": "153.60209000"
                    },
                    {
                        "id": 7228,
                        "name": "Smithfield",
                        "latitude": "-33.85000000",
                        "longitude": "150.93333000"
                    },
                    {
                        "id": 7230,
                        "name": "Smiths Lake",
                        "latitude": "-32.38043000",
                        "longitude": "152.50337000"
                    },
                    {
                        "id": 7237,
                        "name": "Soldiers Point",
                        "latitude": "-32.71050000",
                        "longitude": "152.06979000"
                    },
                    {
                        "id": 7240,
                        "name": "Somersby",
                        "latitude": "-33.36667000",
                        "longitude": "151.28333000"
                    },
                    {
                        "id": 7249,
                        "name": "South Albury",
                        "latitude": "-36.08654000",
                        "longitude": "146.90905000"
                    },
                    {
                        "id": 7250,
                        "name": "South Bathurst",
                        "latitude": "-33.43839000",
                        "longitude": "149.57203000"
                    },
                    {
                        "id": 7251,
                        "name": "South Bowenfels",
                        "latitude": "-33.51667000",
                        "longitude": "150.11667000"
                    },
                    {
                        "id": 7257,
                        "name": "South Coogee",
                        "latitude": "-33.93106000",
                        "longitude": "151.25599000"
                    },
                    {
                        "id": 7261,
                        "name": "South Grafton",
                        "latitude": "-29.70760000",
                        "longitude": "152.92627000"
                    },
                    {
                        "id": 7262,
                        "name": "South Granville",
                        "latitude": "-33.85864000",
                        "longitude": "151.01066000"
                    },
                    {
                        "id": 7266,
                        "name": "South Hurstville",
                        "latitude": "-33.97756000",
                        "longitude": "151.10550000"
                    },
                    {
                        "id": 7268,
                        "name": "South Kempsey",
                        "latitude": "-31.12302000",
                        "longitude": "152.83253000"
                    },
                    {
                        "id": 7273,
                        "name": "South Lismore",
                        "latitude": "-28.81629000",
                        "longitude": "153.25619000"
                    },
                    {
                        "id": 7278,
                        "name": "South Murwillumbah",
                        "latitude": "-28.33895000",
                        "longitude": "153.40004000"
                    },
                    {
                        "id": 7279,
                        "name": "South Nowra",
                        "latitude": "-34.90332000",
                        "longitude": "150.59827000"
                    },
                    {
                        "id": 7280,
                        "name": "South Penrith",
                        "latitude": "-33.77349000",
                        "longitude": "150.69466000"
                    },
                    {
                        "id": 7283,
                        "name": "South Tamworth",
                        "latitude": "-31.11000000",
                        "longitude": "150.92254000"
                    },
                    {
                        "id": 7286,
                        "name": "South Turramurra",
                        "latitude": "-33.74941000",
                        "longitude": "151.11257000"
                    },
                    {
                        "id": 7287,
                        "name": "South Wentworthville",
                        "latitude": "-33.81850000",
                        "longitude": "150.96344000"
                    },
                    {
                        "id": 7288,
                        "name": "South West Rocks",
                        "latitude": "-30.88553000",
                        "longitude": "153.04126000"
                    },
                    {
                        "id": 7289,
                        "name": "South Windsor",
                        "latitude": "-33.61808000",
                        "longitude": "150.80443000"
                    },
                    {
                        "id": 7302,
                        "name": "Speers Point",
                        "latitude": "-32.96383000",
                        "longitude": "151.62618000"
                    },
                    {
                        "id": 7307,
                        "name": "Spring Farm",
                        "latitude": "-34.06851000",
                        "longitude": "150.71182000"
                    },
                    {
                        "id": 7309,
                        "name": "Springdale Heights",
                        "latitude": "-36.03095000",
                        "longitude": "146.94783000"
                    },
                    {
                        "id": 7314,
                        "name": "Springvale",
                        "latitude": "-35.16687000",
                        "longitude": "147.33058000"
                    },
                    {
                        "id": 7317,
                        "name": "Springwood",
                        "latitude": "-33.70000000",
                        "longitude": "150.55000000"
                    },
                    {
                        "id": 7320,
                        "name": "St Andrews",
                        "latitude": "-34.02243000",
                        "longitude": "150.82958000"
                    },
                    {
                        "id": 7321,
                        "name": "St Clair",
                        "latitude": "-33.79728000",
                        "longitude": "150.78470000"
                    },
                    {
                        "id": 7327,
                        "name": "St Helens Park",
                        "latitude": "-34.10474000",
                        "longitude": "150.81368000"
                    },
                    {
                        "id": 7328,
                        "name": "St Huberts Island",
                        "latitude": "-33.49562000",
                        "longitude": "151.34616000"
                    },
                    {
                        "id": 7329,
                        "name": "St Ives Chase",
                        "latitude": "-33.70381000",
                        "longitude": "151.16460000"
                    },
                    {
                        "id": 7331,
                        "name": "St Johns Park",
                        "latitude": "-33.88295000",
                        "longitude": "150.90182000"
                    },
                    {
                        "id": 7334,
                        "name": "St Leonards",
                        "latitude": "-33.82344000",
                        "longitude": "151.19836000"
                    },
                    {
                        "id": 7338,
                        "name": "St. Georges Basin",
                        "latitude": "-35.08986000",
                        "longitude": "150.59801000"
                    },
                    {
                        "id": 7341,
                        "name": "Stanhope Gardens",
                        "latitude": "-33.72206000",
                        "longitude": "150.92597000"
                    },
                    {
                        "id": 7342,
                        "name": "Stanmore",
                        "latitude": "-33.89407000",
                        "longitude": "151.16424000"
                    },
                    {
                        "id": 7344,
                        "name": "Stanwell Park",
                        "latitude": "-34.22610000",
                        "longitude": "150.98583000"
                    },
                    {
                        "id": 7350,
                        "name": "Stockton",
                        "latitude": "-32.90908000",
                        "longitude": "151.78360000"
                    },
                    {
                        "id": 7359,
                        "name": "Strathfield",
                        "latitude": "-33.87978000",
                        "longitude": "151.07561000"
                    },
                    {
                        "id": 7360,
                        "name": "Strathfield South",
                        "latitude": "-33.89252000",
                        "longitude": "151.08334000"
                    },
                    {
                        "id": 7373,
                        "name": "Suffolk Park",
                        "latitude": "-28.68810000",
                        "longitude": "153.60977000"
                    },
                    {
                        "id": 7374,
                        "name": "Summer Hill",
                        "latitude": "-33.89146000",
                        "longitude": "151.13825000"
                    },
                    {
                        "id": 7376,
                        "name": "Summerland Point",
                        "latitude": "-33.14091000",
                        "longitude": "151.56561000"
                    },
                    {
                        "id": 7385,
                        "name": "Sunshine Bay",
                        "latitude": "-35.74540000",
                        "longitude": "150.20792000"
                    },
                    {
                        "id": 7392,
                        "name": "Surfside",
                        "latitude": "-35.69531000",
                        "longitude": "150.19949000"
                    },
                    {
                        "id": 7395,
                        "name": "Surry Hills",
                        "latitude": "-33.88374000",
                        "longitude": "151.21282000"
                    },
                    {
                        "id": 7396,
                        "name": "Sussex Inlet",
                        "latitude": "-35.15671000",
                        "longitude": "150.58533000"
                    },
                    {
                        "id": 7397,
                        "name": "Sutherland",
                        "latitude": "-34.03100000",
                        "longitude": "151.05532000"
                    },
                    {
                        "id": 7398,
                        "name": "Sutherland Shire",
                        "latitude": "-34.07202000",
                        "longitude": "151.07712000"
                    },
                    {
                        "id": 7399,
                        "name": "Sutton",
                        "latitude": "-35.16667000",
                        "longitude": "149.25000000"
                    },
                    {
                        "id": 7405,
                        "name": "Swansea",
                        "latitude": "-33.08765000",
                        "longitude": "151.63745000"
                    },
                    {
                        "id": 7407,
                        "name": "Sydenham",
                        "latitude": "-33.91669000",
                        "longitude": "151.16798000"
                    },
                    {
                        "id": 7408,
                        "name": "Sydney",
                        "latitude": "-33.86785000",
                        "longitude": "151.20732000"
                    },
                    {
                        "id": 7409,
                        "name": "Sydney Central Business District",
                        "latitude": "-33.86482000",
                        "longitude": "151.20773000"
                    },
                    {
                        "id": 7410,
                        "name": "Sydney Olympic Park",
                        "latitude": "-33.84983000",
                        "longitude": "151.06828000"
                    },
                    {
                        "id": 7411,
                        "name": "Sylvania",
                        "latitude": "-34.01242000",
                        "longitude": "151.09718000"
                    },
                    {
                        "id": 7412,
                        "name": "Sylvania Waters",
                        "latitude": "-34.01868000",
                        "longitude": "151.10860000"
                    },
                    {
                        "id": 7413,
                        "name": "Table Top",
                        "latitude": "-35.96667000",
                        "longitude": "147.00000000"
                    },
                    {
                        "id": 7414,
                        "name": "Tahmoor",
                        "latitude": "-34.22246000",
                        "longitude": "150.59467000"
                    },
                    {
                        "id": 7421,
                        "name": "Tamarama",
                        "latitude": "-33.89835000",
                        "longitude": "151.27059000"
                    },
                    {
                        "id": 7425,
                        "name": "Tamworth",
                        "latitude": "-31.09048000",
                        "longitude": "150.92905000"
                    },
                    {
                        "id": 7426,
                        "name": "Tamworth Municipality",
                        "latitude": "-30.92204000",
                        "longitude": "150.81526000"
                    },
                    {
                        "id": 7429,
                        "name": "Tanilba Bay",
                        "latitude": "-32.74706000",
                        "longitude": "151.99714000"
                    },
                    {
                        "id": 7437,
                        "name": "Taree",
                        "latitude": "-31.91099000",
                        "longitude": "152.45387000"
                    },
                    {
                        "id": 7438,
                        "name": "Taren Point",
                        "latitude": "-34.01936000",
                        "longitude": "151.11826000"
                    },
                    {
                        "id": 7443,
                        "name": "Tarrawanna",
                        "latitude": "-34.38152000",
                        "longitude": "150.88799000"
                    },
                    {
                        "id": 7444,
                        "name": "Tarro",
                        "latitude": "-32.80000000",
                        "longitude": "151.66667000"
                    },
                    {
                        "id": 7445,
                        "name": "Tascott",
                        "latitude": "-33.45017000",
                        "longitude": "151.31375000"
                    },
                    {
                        "id": 7447,
                        "name": "Tathra",
                        "latitude": "-36.73126000",
                        "longitude": "149.98328000"
                    },
                    {
                        "id": 7449,
                        "name": "Tatton",
                        "latitude": "-35.15990000",
                        "longitude": "147.35875000"
                    },
                    {
                        "id": 7453,
                        "name": "Tea Gardens",
                        "latitude": "-32.66351000",
                        "longitude": "152.15404000"
                    },
                    {
                        "id": 7457,
                        "name": "Telarah",
                        "latitude": "-32.72876000",
                        "longitude": "151.53453000"
                    },
                    {
                        "id": 7460,
                        "name": "Telopea",
                        "latitude": "-33.79279000",
                        "longitude": "151.03858000"
                    },
                    {
                        "id": 7461,
                        "name": "Temora",
                        "latitude": "-34.44834000",
                        "longitude": "147.53558000"
                    },
                    {
                        "id": 7462,
                        "name": "Temora Municipality",
                        "latitude": "-34.38314000",
                        "longitude": "147.47917000"
                    },
                    {
                        "id": 7463,
                        "name": "Tempe",
                        "latitude": "-33.92335000",
                        "longitude": "151.16020000"
                    },
                    {
                        "id": 7466,
                        "name": "Tenambit",
                        "latitude": "-32.73967000",
                        "longitude": "151.61293000"
                    },
                    {
                        "id": 7470,
                        "name": "Tennyson Point",
                        "latitude": "-33.83172000",
                        "longitude": "151.11682000"
                    },
                    {
                        "id": 7471,
                        "name": "Tenterfield",
                        "latitude": "-29.04946000",
                        "longitude": "152.01952000"
                    },
                    {
                        "id": 7472,
                        "name": "Tenterfield Municipality",
                        "latitude": "-29.06897000",
                        "longitude": "152.04803000"
                    },
                    {
                        "id": 7473,
                        "name": "Teralba",
                        "latitude": "-32.96667000",
                        "longitude": "151.60000000"
                    },
                    {
                        "id": 7475,
                        "name": "Terranora",
                        "latitude": "-28.23832000",
                        "longitude": "153.50078000"
                    },
                    {
                        "id": 7476,
                        "name": "Terrigal",
                        "latitude": "-33.44815000",
                        "longitude": "151.44665000"
                    },
                    {
                        "id": 7477,
                        "name": "Terry Hills",
                        "latitude": "-33.68333000",
                        "longitude": "151.23333000"
                    },
                    {
                        "id": 7482,
                        "name": "The Entrance",
                        "latitude": "-33.33876000",
                        "longitude": "151.49780000"
                    },
                    {
                        "id": 7483,
                        "name": "The Entrance North",
                        "latitude": "-33.33573000",
                        "longitude": "151.50335000"
                    },
                    {
                        "id": 7487,
                        "name": "The Hill",
                        "latitude": "-32.93089000",
                        "longitude": "151.77835000"
                    },
                    {
                        "id": 7488,
                        "name": "The Hills Shire",
                        "latitude": "-33.59118000",
                        "longitude": "150.96100000"
                    },
                    {
                        "id": 7489,
                        "name": "The Junction",
                        "latitude": "-32.93822000",
                        "longitude": "151.75909000"
                    },
                    {
                        "id": 7490,
                        "name": "The Oaks",
                        "latitude": "-34.07995000",
                        "longitude": "150.56998000"
                    },
                    {
                        "id": 7492,
                        "name": "The Ponds",
                        "latitude": "-33.70228000",
                        "longitude": "150.91086000"
                    },
                    {
                        "id": 7494,
                        "name": "The Rock",
                        "latitude": "-35.27302000",
                        "longitude": "147.11381000"
                    },
                    {
                        "id": 7495,
                        "name": "The Rocks",
                        "latitude": "-33.85923000",
                        "longitude": "151.20810000"
                    },
                    {
                        "id": 7499,
                        "name": "Thirlmere",
                        "latitude": "-34.20455000",
                        "longitude": "150.56767000"
                    },
                    {
                        "id": 7500,
                        "name": "Thirroul",
                        "latitude": "-34.31604000",
                        "longitude": "150.92142000"
                    },
                    {
                        "id": 7506,
                        "name": "Thornleigh",
                        "latitude": "-33.73228000",
                        "longitude": "151.07895000"
                    },
                    {
                        "id": 7508,
                        "name": "Thornton",
                        "latitude": "-32.78333000",
                        "longitude": "151.63333000"
                    },
                    {
                        "id": 7510,
                        "name": "Thurgoona",
                        "latitude": "-36.03626000",
                        "longitude": "146.99609000"
                    },
                    {
                        "id": 7513,
                        "name": "Tighes Hill",
                        "latitude": "-32.90732000",
                        "longitude": "151.75090000"
                    },
                    {
                        "id": 7518,
                        "name": "Tingira Heights",
                        "latitude": "-32.99725000",
                        "longitude": "151.67021000"
                    },
                    {
                        "id": 7519,
                        "name": "Tinonee",
                        "latitude": "-31.93634000",
                        "longitude": "152.41425000"
                    },
                    {
                        "id": 7523,
                        "name": "Tocumwal",
                        "latitude": "-35.81150000",
                        "longitude": "145.56922000"
                    },
                    {
                        "id": 7525,
                        "name": "Tolland",
                        "latitude": "-35.14521000",
                        "longitude": "147.35162000"
                    },
                    {
                        "id": 7527,
                        "name": "Tomakin",
                        "latitude": "-35.82335000",
                        "longitude": "150.18794000"
                    },
                    {
                        "id": 7528,
                        "name": "Tomerong",
                        "latitude": "-35.05231000",
                        "longitude": "150.58650000"
                    },
                    {
                        "id": 7533,
                        "name": "Toongabbie",
                        "latitude": "-33.78333000",
                        "longitude": "150.95000000"
                    },
                    {
                        "id": 7537,
                        "name": "Toormina",
                        "latitude": "-30.35384000",
                        "longitude": "153.08843000"
                    },
                    {
                        "id": 7541,
                        "name": "Toronto",
                        "latitude": "-33.01357000",
                        "longitude": "151.59373000"
                    },
                    {
                        "id": 7549,
                        "name": "Toukley",
                        "latitude": "-33.26367000",
                        "longitude": "151.53841000"
                    },
                    {
                        "id": 7553,
                        "name": "Towradgi",
                        "latitude": "-34.38667000",
                        "longitude": "150.90278000"
                    },
                    {
                        "id": 7555,
                        "name": "Trangie",
                        "latitude": "-32.03147000",
                        "longitude": "147.98344000"
                    },
                    {
                        "id": 7561,
                        "name": "Tregear",
                        "latitude": "-33.74562000",
                        "longitude": "150.79294000"
                    },
                    {
                        "id": 7572,
                        "name": "Tuggerawong",
                        "latitude": "-33.28040000",
                        "longitude": "151.48044000"
                    },
                    {
                        "id": 7576,
                        "name": "Tumbarumba",
                        "latitude": "-35.77806000",
                        "longitude": "148.01172000"
                    },
                    {
                        "id": 7577,
                        "name": "Tumbi Vmbi",
                        "latitude": "-33.36667000",
                        "longitude": "151.45000000"
                    },
                    {
                        "id": 7579,
                        "name": "Tumut",
                        "latitude": "-35.30642000",
                        "longitude": "148.21818000"
                    },
                    {
                        "id": 7580,
                        "name": "Tuncurry",
                        "latitude": "-32.17443000",
                        "longitude": "152.49876000"
                    },
                    {
                        "id": 7581,
                        "name": "Tura Beach",
                        "latitude": "-36.86358000",
                        "longitude": "149.93027000"
                    },
                    {
                        "id": 7584,
                        "name": "Tuross Head",
                        "latitude": "-36.05328000",
                        "longitude": "150.13322000"
                    },
                    {
                        "id": 7585,
                        "name": "Turramurra",
                        "latitude": "-33.73342000",
                        "longitude": "151.12849000"
                    },
                    {
                        "id": 7586,
                        "name": "Turrella",
                        "latitude": "-33.93033000",
                        "longitude": "151.14209000"
                    },
                    {
                        "id": 7587,
                        "name": "Turvey Park",
                        "latitude": "-35.12849000",
                        "longitude": "147.36264000"
                    },
                    {
                        "id": 7589,
                        "name": "Tweed",
                        "latitude": "-28.34991000",
                        "longitude": "153.34652000"
                    },
                    {
                        "id": 7590,
                        "name": "Tweed Heads",
                        "latitude": "-28.17671000",
                        "longitude": "153.54520000"
                    },
                    {
                        "id": 7591,
                        "name": "Tweed Heads South",
                        "latitude": "-28.19517000",
                        "longitude": "153.53964000"
                    },
                    {
                        "id": 7592,
                        "name": "Tweed Heads West",
                        "latitude": "-28.18736000",
                        "longitude": "153.52278000"
                    },
                    {
                        "id": 7597,
                        "name": "Ulladulla",
                        "latitude": "-35.35906000",
                        "longitude": "150.47247000"
                    },
                    {
                        "id": 7598,
                        "name": "Ultimo",
                        "latitude": "-33.87722000",
                        "longitude": "151.19720000"
                    },
                    {
                        "id": 7600,
                        "name": "Umina Beach",
                        "latitude": "-33.52314000",
                        "longitude": "151.31325000"
                    },
                    {
                        "id": 7601,
                        "name": "Unanderra",
                        "latitude": "-34.45306000",
                        "longitude": "150.84746000"
                    },
                    {
                        "id": 7610,
                        "name": "Upper Hunter Shire",
                        "latitude": "-31.98126000",
                        "longitude": "150.69282000"
                    },
                    {
                        "id": 7612,
                        "name": "Upper Lachlan Shire",
                        "latitude": "-34.41867000",
                        "longitude": "149.53061000"
                    },
                    {
                        "id": 7615,
                        "name": "Uralla",
                        "latitude": "-30.48548000",
                        "longitude": "151.35451000"
                    },
                    {
                        "id": 7618,
                        "name": "Urunga",
                        "latitude": "-30.49701000",
                        "longitude": "153.01422000"
                    },
                    {
                        "id": 7622,
                        "name": "Valentine",
                        "latitude": "-33.01504000",
                        "longitude": "151.64290000"
                    },
                    {
                        "id": 7623,
                        "name": "Valla Beach",
                        "latitude": "-30.59259000",
                        "longitude": "153.01131000"
                    },
                    {
                        "id": 7624,
                        "name": "Valley Heights",
                        "latitude": "-33.70000000",
                        "longitude": "150.58333000"
                    },
                    {
                        "id": 7628,
                        "name": "Vaucluse",
                        "latitude": "-33.85549000",
                        "longitude": "151.27754000"
                    },
                    {
                        "id": 7637,
                        "name": "Villawood",
                        "latitude": "-33.88434000",
                        "longitude": "150.98027000"
                    },
                    {
                        "id": 7640,
                        "name": "Vincentia",
                        "latitude": "-35.06825000",
                        "longitude": "150.67480000"
                    },
                    {
                        "id": 7641,
                        "name": "Vineyard",
                        "latitude": "-33.64995000",
                        "longitude": "150.85259000"
                    },
                    {
                        "id": 7646,
                        "name": "Voyager Point",
                        "latitude": "-33.95871000",
                        "longitude": "150.97417000"
                    },
                    {
                        "id": 7648,
                        "name": "Wadalba",
                        "latitude": "-33.27230000",
                        "longitude": "151.46487000"
                    },
                    {
                        "id": 7652,
                        "name": "Wagga Wagga",
                        "latitude": "-35.18587000",
                        "longitude": "147.35509000"
                    },
                    {
                        "id": 7656,
                        "name": "Wahroonga",
                        "latitude": "-33.71816000",
                        "longitude": "151.11561000"
                    },
                    {
                        "id": 7659,
                        "name": "Waitara",
                        "latitude": "-33.71092000",
                        "longitude": "151.10330000"
                    },
                    {
                        "id": 7661,
                        "name": "Wakeley",
                        "latitude": "-33.87427000",
                        "longitude": "150.90976000"
                    },
                    {
                        "id": 7663,
                        "name": "Walcha",
                        "latitude": "-31.19757000",
                        "longitude": "151.81854000"
                    },
                    {
                        "id": 7664,
                        "name": "Walgett",
                        "latitude": "-29.79031000",
                        "longitude": "148.13393000"
                    },
                    {
                        "id": 7669,
                        "name": "Wallacia",
                        "latitude": "-33.86577000",
                        "longitude": "150.64021000"
                    },
                    {
                        "id": 7670,
                        "name": "Wallalong",
                        "latitude": "-32.69556000",
                        "longitude": "151.64957000"
                    },
                    {
                        "id": 7673,
                        "name": "Wallerawang",
                        "latitude": "-33.41096000",
                        "longitude": "150.06456000"
                    },
                    {
                        "id": 7676,
                        "name": "Wallsend",
                        "latitude": "-32.90133000",
                        "longitude": "151.66432000"
                    },
                    {
                        "id": 7677,
                        "name": "Wamberal",
                        "latitude": "-33.41554000",
                        "longitude": "151.44559000"
                    },
                    {
                        "id": 7678,
                        "name": "Wamboin",
                        "latitude": "-35.25073000",
                        "longitude": "149.33284000"
                    },
                    {
                        "id": 7689,
                        "name": "Wangi Wangi",
                        "latitude": "-33.07185000",
                        "longitude": "151.59840000"
                    },
                    {
                        "id": 7696,
                        "name": "Warabrook",
                        "latitude": "-32.88885000",
                        "longitude": "151.71493000"
                    },
                    {
                        "id": 7699,
                        "name": "Waratah",
                        "latitude": "-32.90667000",
                        "longitude": "151.72647000"
                    },
                    {
                        "id": 7700,
                        "name": "Waratah West",
                        "latitude": "-32.90003000",
                        "longitude": "151.71170000"
                    },
                    {
                        "id": 7703,
                        "name": "Wareemba",
                        "latitude": "-33.85819000",
                        "longitude": "151.13085000"
                    },
                    {
                        "id": 7704,
                        "name": "Warialda",
                        "latitude": "-29.54354000",
                        "longitude": "150.57542000"
                    },
                    {
                        "id": 7705,
                        "name": "Warilla",
                        "latitude": "-34.55185000",
                        "longitude": "150.85831000"
                    },
                    {
                        "id": 7708,
                        "name": "Warners Bay",
                        "latitude": "-32.97251000",
                        "longitude": "151.65268000"
                    },
                    {
                        "id": 7712,
                        "name": "Warragamba",
                        "latitude": "-33.89191000",
                        "longitude": "150.60461000"
                    },
                    {
                        "id": 7717,
                        "name": "Warrawee",
                        "latitude": "-33.72884000",
                        "longitude": "151.12051000"
                    },
                    {
                        "id": 7718,
                        "name": "Warrawong",
                        "latitude": "-34.48500000",
                        "longitude": "150.88833000"
                    },
                    {
                        "id": 7719,
                        "name": "Warren",
                        "latitude": "-31.70224000",
                        "longitude": "147.83392000"
                    },
                    {
                        "id": 7720,
                        "name": "Warren Shire",
                        "latitude": "-31.29549000",
                        "longitude": "147.72853000"
                    },
                    {
                        "id": 7721,
                        "name": "Warriewood",
                        "latitude": "-33.68857000",
                        "longitude": "151.29534000"
                    },
                    {
                        "id": 7722,
                        "name": "Warrimoo",
                        "latitude": "-33.71667000",
                        "longitude": "150.60000000"
                    },
                    {
                        "id": 7724,
                        "name": "Warrumbungle Shire",
                        "latitude": "-31.45519000",
                        "longitude": "149.45377000"
                    },
                    {
                        "id": 7727,
                        "name": "Warwick Farm",
                        "latitude": "-33.91291000",
                        "longitude": "150.93701000"
                    },
                    {
                        "id": 7728,
                        "name": "Watanobbi",
                        "latitude": "-33.26772000",
                        "longitude": "151.42246000"
                    },
                    {
                        "id": 7733,
                        "name": "Waterview Heights",
                        "latitude": "-29.69775000",
                        "longitude": "152.83922000"
                    },
                    {
                        "id": 7738,
                        "name": "Wattle Grove",
                        "latitude": "-33.95443000",
                        "longitude": "150.94447000"
                    },
                    {
                        "id": 7741,
                        "name": "Wattle Ponds",
                        "latitude": "-32.52026000",
                        "longitude": "151.19359000"
                    },
                    {
                        "id": 7744,
                        "name": "Wauchope",
                        "latitude": "-31.45792000",
                        "longitude": "152.72617000"
                    },
                    {
                        "id": 7747,
                        "name": "Waverley",
                        "latitude": "-33.90181000",
                        "longitude": "151.25599000"
                    },
                    {
                        "id": 7749,
                        "name": "Waverton",
                        "latitude": "-33.83863000",
                        "longitude": "151.20046000"
                    },
                    {
                        "id": 7751,
                        "name": "Weddin",
                        "latitude": "-33.87903000",
                        "longitude": "148.01125000"
                    },
                    {
                        "id": 7752,
                        "name": "Wee Waa",
                        "latitude": "-30.22660000",
                        "longitude": "149.44041000"
                    },
                    {
                        "id": 7758,
                        "name": "Wellington",
                        "latitude": "-32.55588000",
                        "longitude": "148.94508000"
                    },
                    {
                        "id": 7763,
                        "name": "Wentworth",
                        "latitude": "-33.67106000",
                        "longitude": "142.33675000"
                    },
                    {
                        "id": 7764,
                        "name": "Wentworth Falls",
                        "latitude": "-33.71033000",
                        "longitude": "150.37534000"
                    },
                    {
                        "id": 7765,
                        "name": "Wentworth Point",
                        "latitude": "-33.83080000",
                        "longitude": "151.07441000"
                    },
                    {
                        "id": 7766,
                        "name": "Wentworthville",
                        "latitude": "-33.80652000",
                        "longitude": "150.96785000"
                    },
                    {
                        "id": 7769,
                        "name": "Werrington",
                        "latitude": "-33.75920000",
                        "longitude": "150.75266000"
                    },
                    {
                        "id": 7770,
                        "name": "Werrington County",
                        "latitude": "-33.74650000",
                        "longitude": "150.73929000"
                    },
                    {
                        "id": 7771,
                        "name": "Werrington Downs",
                        "latitude": "-33.74206000",
                        "longitude": "150.72779000"
                    },
                    {
                        "id": 7772,
                        "name": "Werris Creek",
                        "latitude": "-31.34908000",
                        "longitude": "150.64870000"
                    },
                    {
                        "id": 7774,
                        "name": "West Albury",
                        "latitude": "-36.07979000",
                        "longitude": "146.89227000"
                    },
                    {
                        "id": 7777,
                        "name": "West Ballina",
                        "latitude": "-28.86200000",
                        "longitude": "153.53291000"
                    },
                    {
                        "id": 7778,
                        "name": "West Bathurst",
                        "latitude": "-33.40920000",
                        "longitude": "149.56324000"
                    },
                    {
                        "id": 7787,
                        "name": "West Gosford",
                        "latitude": "-33.42578000",
                        "longitude": "151.31701000"
                    },
                    {
                        "id": 7788,
                        "name": "West Haven",
                        "latitude": "-31.63555000",
                        "longitude": "152.78378000"
                    },
                    {
                        "id": 7791,
                        "name": "West Hoxton",
                        "latitude": "-33.93388000",
                        "longitude": "150.83234000"
                    },
                    {
                        "id": 7792,
                        "name": "West Kempsey",
                        "latitude": "-31.05757000",
                        "longitude": "152.82794000"
                    },
                    {
                        "id": 7801,
                        "name": "West Nowra",
                        "latitude": "-34.88593000",
                        "longitude": "150.58333000"
                    },
                    {
                        "id": 7802,
                        "name": "West Pennant Hills",
                        "latitude": "-33.74570000",
                        "longitude": "151.04764000"
                    },
                    {
                        "id": 7804,
                        "name": "West Pymble",
                        "latitude": "-33.76667000",
                        "longitude": "151.13333000"
                    },
                    {
                        "id": 7806,
                        "name": "West Ryde",
                        "latitude": "-33.80543000",
                        "longitude": "151.07386000"
                    },
                    {
                        "id": 7808,
                        "name": "West Tamworth",
                        "latitude": "-31.10236000",
                        "longitude": "150.91447000"
                    },
                    {
                        "id": 7810,
                        "name": "West Wallsend",
                        "latitude": "-32.90000000",
                        "longitude": "151.58333000"
                    },
                    {
                        "id": 7813,
                        "name": "West Wollongong",
                        "latitude": "-34.42480000",
                        "longitude": "150.86417000"
                    },
                    {
                        "id": 7815,
                        "name": "West Wyalong",
                        "latitude": "-33.92373000",
                        "longitude": "147.20473000"
                    },
                    {
                        "id": 7820,
                        "name": "Westdale",
                        "latitude": "-31.09052000",
                        "longitude": "150.85678000"
                    },
                    {
                        "id": 7823,
                        "name": "Westleigh",
                        "latitude": "-33.71176000",
                        "longitude": "151.07139000"
                    },
                    {
                        "id": 7824,
                        "name": "Westmead",
                        "latitude": "-33.80383000",
                        "longitude": "150.98768000"
                    },
                    {
                        "id": 7829,
                        "name": "Wetherill Park",
                        "latitude": "-33.84277000",
                        "longitude": "150.90061000"
                    },
                    {
                        "id": 7830,
                        "name": "Whalan",
                        "latitude": "-33.75697000",
                        "longitude": "150.80402000"
                    },
                    {
                        "id": 149216,
                        "name": "Whale Beach",
                        "latitude": "-33.61241180",
                        "longitude": "151.32540650"
                    },
                    {
                        "id": 7831,
                        "name": "Wheeler Heights",
                        "latitude": "-33.73119000",
                        "longitude": "151.28049000"
                    },
                    {
                        "id": 7836,
                        "name": "Whitebridge",
                        "latitude": "-32.97436000",
                        "longitude": "151.71614000"
                    },
                    {
                        "id": 7849,
                        "name": "Wickham",
                        "latitude": "-32.91923000",
                        "longitude": "151.75693000"
                    },
                    {
                        "id": 7851,
                        "name": "Wilberforce",
                        "latitude": "-33.56256000",
                        "longitude": "150.83784000"
                    },
                    {
                        "id": 7852,
                        "name": "Wiley Park",
                        "latitude": "-33.92420000",
                        "longitude": "151.06737000"
                    },
                    {
                        "id": 7861,
                        "name": "Williamtown",
                        "latitude": "-32.80638000",
                        "longitude": "151.84361000"
                    },
                    {
                        "id": 7862,
                        "name": "Willmot",
                        "latitude": "-33.72534000",
                        "longitude": "150.79259000"
                    },
                    {
                        "id": 7863,
                        "name": "Willoughby",
                        "latitude": "-33.80167000",
                        "longitude": "151.18782000"
                    },
                    {
                        "id": 7864,
                        "name": "Willoughby East",
                        "latitude": "-33.79844000",
                        "longitude": "151.20518000"
                    },
                    {
                        "id": 7872,
                        "name": "Wilton",
                        "latitude": "-34.24053000",
                        "longitude": "150.69771000"
                    },
                    {
                        "id": 7875,
                        "name": "Windale",
                        "latitude": "-32.99277000",
                        "longitude": "151.68167000"
                    },
                    {
                        "id": 7876,
                        "name": "Windang",
                        "latitude": "-34.53333000",
                        "longitude": "150.86667000"
                    },
                    {
                        "id": 7878,
                        "name": "Windradyne",
                        "latitude": "-33.40539000",
                        "longitude": "149.54507000"
                    },
                    {
                        "id": 7881,
                        "name": "Windsor",
                        "latitude": "-33.61309000",
                        "longitude": "150.81416000"
                    },
                    {
                        "id": 7882,
                        "name": "Windsor Downs",
                        "latitude": "-33.65857000",
                        "longitude": "150.81079000"
                    },
                    {
                        "id": 7884,
                        "name": "Wingecarribee",
                        "latitude": "-34.49091000",
                        "longitude": "150.35486000"
                    },
                    {
                        "id": 7885,
                        "name": "Wingham",
                        "latitude": "-31.86676000",
                        "longitude": "152.36989000"
                    },
                    {
                        "id": 7886,
                        "name": "Winmalee",
                        "latitude": "-33.67847000",
                        "longitude": "150.61213000"
                    },
                    {
                        "id": 7888,
                        "name": "Winston Hills",
                        "latitude": "-33.77645000",
                        "longitude": "150.98051000"
                    },
                    {
                        "id": 7897,
                        "name": "Wolli Creek",
                        "latitude": "-33.93133000",
                        "longitude": "151.15222000"
                    },
                    {
                        "id": 7898,
                        "name": "Wollondilly",
                        "latitude": "-34.06958000",
                        "longitude": "150.46265000"
                    },
                    {
                        "id": 7899,
                        "name": "Wollongbar",
                        "latitude": "-28.81820000",
                        "longitude": "153.39686000"
                    },
                    {
                        "id": 7900,
                        "name": "Wollongong",
                        "latitude": "-34.42400000",
                        "longitude": "150.89345000"
                    },
                    {
                        "id": 7901,
                        "name": "Wollongong city centre",
                        "latitude": "-34.42790000",
                        "longitude": "150.89268000"
                    },
                    {
                        "id": 7902,
                        "name": "Wollstonecraft",
                        "latitude": "-33.83280000",
                        "longitude": "151.18981000"
                    },
                    {
                        "id": 7912,
                        "name": "Woodberry",
                        "latitude": "-32.79311000",
                        "longitude": "151.67687000"
                    },
                    {
                        "id": 7913,
                        "name": "Woodbine",
                        "latitude": "-34.04589000",
                        "longitude": "150.82146000"
                    },
                    {
                        "id": 7916,
                        "name": "Woodcroft",
                        "latitude": "-33.75637000",
                        "longitude": "150.88071000"
                    },
                    {
                        "id": 7920,
                        "name": "Woodford",
                        "latitude": "-33.73333000",
                        "longitude": "150.48333000"
                    },
                    {
                        "id": 7922,
                        "name": "Woodpark",
                        "latitude": "-33.84137000",
                        "longitude": "150.96055000"
                    },
                    {
                        "id": 7924,
                        "name": "Woodrising",
                        "latitude": "-32.98595000",
                        "longitude": "151.60657000"
                    },
                    {
                        "id": 7935,
                        "name": "Woolgoolga",
                        "latitude": "-30.11058000",
                        "longitude": "153.20067000"
                    },
                    {
                        "id": 7936,
                        "name": "Woollahra",
                        "latitude": "-33.87901000",
                        "longitude": "151.24706000"
                    },
                    {
                        "id": 7937,
                        "name": "Woolloomooloo",
                        "latitude": "-33.87042000",
                        "longitude": "151.21968000"
                    },
                    {
                        "id": 7939,
                        "name": "Woolooware",
                        "latitude": "-34.04583000",
                        "longitude": "151.14312000"
                    },
                    {
                        "id": 7942,
                        "name": "Woongarrah",
                        "latitude": "-33.24134000",
                        "longitude": "151.47563000"
                    },
                    {
                        "id": 7943,
                        "name": "Woonona",
                        "latitude": "-34.34932000",
                        "longitude": "150.91443000"
                    },
                    {
                        "id": 7951,
                        "name": "Woronora",
                        "latitude": "-34.02436000",
                        "longitude": "151.03862000"
                    },
                    {
                        "id": 7952,
                        "name": "Woronora Heights",
                        "latitude": "-34.03562000",
                        "longitude": "151.02734000"
                    },
                    {
                        "id": 7953,
                        "name": "Worrigee",
                        "latitude": "-34.90000000",
                        "longitude": "150.63333000"
                    },
                    {
                        "id": 7954,
                        "name": "Woy Woy",
                        "latitude": "-33.48433000",
                        "longitude": "151.32471000"
                    },
                    {
                        "id": 7967,
                        "name": "Wyee",
                        "latitude": "-33.18252000",
                        "longitude": "151.48804000"
                    },
                    {
                        "id": 7968,
                        "name": "Wyee Point",
                        "latitude": "-33.14585000",
                        "longitude": "151.50783000"
                    },
                    {
                        "id": 7976,
                        "name": "Wyoming",
                        "latitude": "-33.40387000",
                        "longitude": "151.36254000"
                    },
                    {
                        "id": 7977,
                        "name": "Wyong",
                        "latitude": "-33.28254000",
                        "longitude": "151.42327000"
                    },
                    {
                        "id": 7978,
                        "name": "Wyongah",
                        "latitude": "-33.27468000",
                        "longitude": "151.48898000"
                    },
                    {
                        "id": 7981,
                        "name": "Yagoona",
                        "latitude": "-33.90490000",
                        "longitude": "151.01996000"
                    },
                    {
                        "id": 149145,
                        "name": "Yallah",
                        "latitude": "-34.53375780",
                        "longitude": "150.77768450"
                    },
                    {
                        "id": 7989,
                        "name": "Yamba",
                        "latitude": "-29.43750000",
                        "longitude": "153.35914000"
                    },
                    {
                        "id": 8006,
                        "name": "Yarravel",
                        "latitude": "-31.04295000",
                        "longitude": "152.76191000"
                    },
                    {
                        "id": 8008,
                        "name": "Yarrawarrah",
                        "latitude": "-34.05351000",
                        "longitude": "151.03563000"
                    },
                    {
                        "id": 8011,
                        "name": "Yass",
                        "latitude": "-34.84036000",
                        "longitude": "148.90987000"
                    },
                    {
                        "id": 8012,
                        "name": "Yass Valley",
                        "latitude": "-34.92630000",
                        "longitude": "148.97240000"
                    },
                    {
                        "id": 8016,
                        "name": "Yenda",
                        "latitude": "-34.24525000",
                        "longitude": "146.20273000"
                    },
                    {
                        "id": 8017,
                        "name": "Yennora",
                        "latitude": "-33.86173000",
                        "longitude": "150.96865000"
                    },
                    {
                        "id": 8021,
                        "name": "Yerrinbool",
                        "latitude": "-34.36884000",
                        "longitude": "150.53848000"
                    },
                    {
                        "id": 8024,
                        "name": "Yoogali",
                        "latitude": "-34.29944000",
                        "longitude": "146.08443000"
                    },
                    {
                        "id": 8028,
                        "name": "Young",
                        "latitude": "-34.31350000",
                        "longitude": "148.30107000"
                    },
                    {
                        "id": 8030,
                        "name": "Yowie Bay",
                        "latitude": "-34.05116000",
                        "longitude": "151.10228000"
                    },
                    {
                        "id": 8033,
                        "name": "Zetland",
                        "latitude": "-33.90748000",
                        "longitude": "151.20857000"
                    }
                ]
            },
            {
                "id": 3910,
                "name": "Northern Territory",
                "iso2": "NT",
                "latitude": "-19.49141080",
                "longitude": "132.55096030",
                "type": "territory",
                "cities": [
                    {
                        "id": 3928,
                        "name": "Alawa",
                        "latitude": "-12.37954000",
                        "longitude": "130.87320000"
                    },
                    {
                        "id": 3957,
                        "name": "Alice Springs",
                        "latitude": "-23.69748000",
                        "longitude": "133.88362000"
                    },
                    {
                        "id": 3973,
                        "name": "Alyangula",
                        "latitude": "-13.85413000",
                        "longitude": "136.42129000"
                    },
                    {
                        "id": 3989,
                        "name": "Anula",
                        "latitude": "-12.39125000",
                        "longitude": "130.89047000"
                    },
                    {
                        "id": 3993,
                        "name": "Araluen",
                        "latitude": "-23.69601000",
                        "longitude": "133.85400000"
                    },
                    {
                        "id": 4067,
                        "name": "Bakewell",
                        "latitude": "-12.49684000",
                        "longitude": "130.99344000"
                    },
                    {
                        "id": 4121,
                        "name": "Barkly",
                        "latitude": "-19.54154000",
                        "longitude": "134.82364000"
                    },
                    {
                        "id": 4194,
                        "name": "Bellamack",
                        "latitude": "-12.51707000",
                        "longitude": "130.98355000"
                    },
                    {
                        "id": 4215,
                        "name": "Belyuen",
                        "latitude": "-12.53819000",
                        "longitude": "130.68317000"
                    },
                    {
                        "id": 4241,
                        "name": "Berrimah",
                        "latitude": "-12.43507000",
                        "longitude": "130.92606000"
                    },
                    {
                        "id": 4380,
                        "name": "Braitling",
                        "latitude": "-23.68005000",
                        "longitude": "133.86877000"
                    },
                    {
                        "id": 4409,
                        "name": "Brinkin",
                        "latitude": "-12.37057000",
                        "longitude": "130.86799000"
                    },
                    {
                        "id": 4651,
                        "name": "Central Desert",
                        "latitude": "-21.07203000",
                        "longitude": "133.49949000"
                    },
                    {
                        "id": 4761,
                        "name": "Coconut Grove",
                        "latitude": "-12.39602000",
                        "longitude": "130.85186000"
                    },
                    {
                        "id": 4814,
                        "name": "Coomalie",
                        "latitude": "-13.04322000",
                        "longitude": "131.08427000"
                    },
                    {
                        "id": 4846,
                        "name": "Cossack",
                        "latitude": "-14.45551000",
                        "longitude": "132.17482000"
                    },
                    {
                        "id": 4947,
                        "name": "Darwin",
                        "latitude": "-12.46113000",
                        "longitude": "130.84185000"
                    },
                    {
                        "id": 4982,
                        "name": "Desert Springs",
                        "latitude": "-23.71554000",
                        "longitude": "133.88768000"
                    },
                    {
                        "id": 5027,
                        "name": "Driver",
                        "latitude": "-12.48602000",
                        "longitude": "130.97539000"
                    },
                    {
                        "id": 5048,
                        "name": "Durack",
                        "latitude": "-12.47308000",
                        "longitude": "130.97208000"
                    },
                    {
                        "id": 5063,
                        "name": "East Arnhem",
                        "latitude": "-12.66175000",
                        "longitude": "135.82281000"
                    },
                    {
                        "id": 5094,
                        "name": "East Side",
                        "latitude": "-23.69195000",
                        "longitude": "133.89320000"
                    },
                    {
                        "id": 5216,
                        "name": "Fannie Bay",
                        "latitude": "-12.42275000",
                        "longitude": "130.83627000"
                    },
                    {
                        "id": 5218,
                        "name": "Farrar",
                        "latitude": "-12.48028000",
                        "longitude": "130.99820000"
                    },
                    {
                        "id": 5299,
                        "name": "Galiwinku",
                        "latitude": "-12.02811000",
                        "longitude": "135.56486000"
                    },
                    {
                        "id": 5333,
                        "name": "Gillen",
                        "latitude": "-23.70915000",
                        "longitude": "133.86596000"
                    },
                    {
                        "id": 5343,
                        "name": "Girraween",
                        "latitude": "-12.52528000",
                        "longitude": "131.09566000"
                    },
                    {
                        "id": 5443,
                        "name": "Gray",
                        "latitude": "-12.49036000",
                        "longitude": "130.98228000"
                    },
                    {
                        "id": 5482,
                        "name": "Gunbalanya",
                        "latitude": "-12.32474000",
                        "longitude": "133.05087000"
                    },
                    {
                        "id": 5486,
                        "name": "Gunn",
                        "latitude": "-12.48765000",
                        "longitude": "130.99322000"
                    },
                    {
                        "id": 5581,
                        "name": "Herbert",
                        "latitude": "-12.53414000",
                        "longitude": "131.16197000"
                    },
                    {
                        "id": 5640,
                        "name": "Holtze",
                        "latitude": "-12.44850000",
                        "longitude": "131.00556000"
                    },
                    {
                        "id": 5658,
                        "name": "Howard Springs",
                        "latitude": "-12.49576000",
                        "longitude": "131.04446000"
                    },
                    {
                        "id": 5666,
                        "name": "Humpty Doo",
                        "latitude": "-12.58406000",
                        "longitude": "131.13674000"
                    },
                    {
                        "id": 5712,
                        "name": "Jabiru",
                        "latitude": "-12.67049000",
                        "longitude": "132.83604000"
                    },
                    {
                        "id": 5738,
                        "name": "Jingili",
                        "latitude": "-12.38895000",
                        "longitude": "130.87281000"
                    },
                    {
                        "id": 5739,
                        "name": "Johnston",
                        "latitude": "-12.48764000",
                        "longitude": "131.01169000"
                    },
                    {
                        "id": 5784,
                        "name": "Karama",
                        "latitude": "-12.40219000",
                        "longitude": "130.91600000"
                    },
                    {
                        "id": 5797,
                        "name": "Katherine",
                        "latitude": "-14.65012000",
                        "longitude": "132.17414000"
                    },
                    {
                        "id": 5798,
                        "name": "Katherine East",
                        "latitude": "-14.46597000",
                        "longitude": "132.28556000"
                    },
                    {
                        "id": 5799,
                        "name": "Katherine South",
                        "latitude": "-14.46784000",
                        "longitude": "132.25848000"
                    },
                    {
                        "id": 5975,
                        "name": "Larapinta",
                        "latitude": "-23.69303000",
                        "longitude": "133.83137000"
                    },
                    {
                        "id": 5979,
                        "name": "Larrakeyah",
                        "latitude": "-12.45527000",
                        "longitude": "130.83172000"
                    },
                    {
                        "id": 5995,
                        "name": "Leanyer",
                        "latitude": "-12.36667000",
                        "longitude": "130.90000000"
                    },
                    {
                        "id": 6033,
                        "name": "Litchfield",
                        "latitude": "-12.50228000",
                        "longitude": "131.12785000"
                    },
                    {
                        "id": 6084,
                        "name": "Ludmilla",
                        "latitude": "-12.42032000",
                        "longitude": "130.85506000"
                    },
                    {
                        "id": 6094,
                        "name": "Lyons",
                        "latitude": "-12.35912000",
                        "longitude": "130.88852000"
                    },
                    {
                        "id": 6096,
                        "name": "MacDonnell",
                        "latitude": "-24.42671000",
                        "longitude": "133.49982000"
                    },
                    {
                        "id": 6133,
                        "name": "Malak",
                        "latitude": "-12.39288000",
                        "longitude": "130.90395000"
                    },
                    {
                        "id": 6149,
                        "name": "Maningrida",
                        "latitude": "-12.04830000",
                        "longitude": "134.22941000"
                    },
                    {
                        "id": 6191,
                        "name": "Marrara",
                        "latitude": "-12.40041000",
                        "longitude": "130.89290000"
                    },
                    {
                        "id": 6287,
                        "name": "Milingimbi",
                        "latitude": "-12.10188000",
                        "longitude": "134.91901000"
                    },
                    {
                        "id": 6297,
                        "name": "Millner",
                        "latitude": "-12.39186000",
                        "longitude": "130.86252000"
                    },
                    {
                        "id": 6336,
                        "name": "Moil",
                        "latitude": "-12.38850000",
                        "longitude": "130.88088000"
                    },
                    {
                        "id": 6403,
                        "name": "Moulden",
                        "latitude": "-12.50559000",
                        "longitude": "130.97313000"
                    },
                    {
                        "id": 6472,
                        "name": "Muirhead",
                        "latitude": "-12.35863000",
                        "longitude": "130.89352000"
                    },
                    {
                        "id": 6512,
                        "name": "Nakara",
                        "latitude": "-12.37054000",
                        "longitude": "130.87728000"
                    },
                    {
                        "id": 6582,
                        "name": "Ngukurr",
                        "latitude": "-14.73081000",
                        "longitude": "134.73102000"
                    },
                    {
                        "id": 6585,
                        "name": "Nhulunbuy",
                        "latitude": "-12.18165000",
                        "longitude": "136.77841000"
                    },
                    {
                        "id": 6592,
                        "name": "Nightcliff",
                        "latitude": "-12.38299000",
                        "longitude": "130.85170000"
                    },
                    {
                        "id": 6769,
                        "name": "Palmerston",
                        "latitude": "-12.49620000",
                        "longitude": "130.97797000"
                    },
                    {
                        "id": 6784,
                        "name": "Parap",
                        "latitude": "-12.43054000",
                        "longitude": "130.84142000"
                    },
                    {
                        "id": 6964,
                        "name": "Rapid Creek",
                        "latitude": "-12.38042000",
                        "longitude": "130.85919000"
                    },
                    {
                        "id": 7056,
                        "name": "Roper Gulf",
                        "latitude": "-15.30564000",
                        "longitude": "134.97356000"
                    },
                    {
                        "id": 7061,
                        "name": "Rosebery",
                        "latitude": "-12.51046000",
                        "longitude": "130.98780000"
                    },
                    {
                        "id": 7075,
                        "name": "Ross",
                        "latitude": "-23.74424000",
                        "longitude": "133.90358000"
                    },
                    {
                        "id": 7103,
                        "name": "Sadadeen",
                        "latitude": "-23.70399000",
                        "longitude": "133.90043000"
                    },
                    {
                        "id": 7369,
                        "name": "Stuart Park",
                        "latitude": "-12.44860000",
                        "longitude": "130.84249000"
                    },
                    {
                        "id": 7468,
                        "name": "Tennant Creek",
                        "latitude": "-19.64970000",
                        "longitude": "134.19147000"
                    },
                    {
                        "id": 7485,
                        "name": "The Gap",
                        "latitude": "-23.71333000",
                        "longitude": "133.87386000"
                    },
                    {
                        "id": 7521,
                        "name": "Tiwi",
                        "latitude": "-12.35876000",
                        "longitude": "130.87800000"
                    },
                    {
                        "id": 7522,
                        "name": "Tiwi Islands",
                        "latitude": "-11.55324000",
                        "longitude": "130.78178000"
                    },
                    {
                        "id": 7632,
                        "name": "Victoria Daly",
                        "latitude": "-15.92920000",
                        "longitude": "130.76166000"
                    },
                    {
                        "id": 7643,
                        "name": "Virginia",
                        "latitude": "-12.51895000",
                        "longitude": "131.02844000"
                    },
                    {
                        "id": 7649,
                        "name": "Wadeye",
                        "latitude": "-14.23834000",
                        "longitude": "129.52177000"
                    },
                    {
                        "id": 7650,
                        "name": "Wagait",
                        "latitude": "-12.44161000",
                        "longitude": "130.75370000"
                    },
                    {
                        "id": 7651,
                        "name": "Wagaman",
                        "latitude": "-12.38074000",
                        "longitude": "130.88538000"
                    },
                    {
                        "id": 7690,
                        "name": "Wanguri",
                        "latitude": "-12.37129000",
                        "longitude": "130.88815000"
                    },
                    {
                        "id": 7775,
                        "name": "West Arnhem",
                        "latitude": "-12.38723000",
                        "longitude": "133.37935000"
                    },
                    {
                        "id": 7925,
                        "name": "Woodroffe",
                        "latitude": "-12.50173000",
                        "longitude": "130.98016000"
                    },
                    {
                        "id": 7958,
                        "name": "Wulagi",
                        "latitude": "-12.38345000",
                        "longitude": "130.89543000"
                    },
                    {
                        "id": 7963,
                        "name": "Wurrumiyanga",
                        "latitude": "-11.76082000",
                        "longitude": "130.62555000"
                    },
                    {
                        "id": 8031,
                        "name": "Yulara",
                        "latitude": "-25.24060000",
                        "longitude": "130.98890000"
                    },
                    {
                        "id": 8036,
                        "name": "Zuccoli",
                        "latitude": "-12.50727000",
                        "longitude": "131.00694000"
                    }
                ]
            },
            {
                "id": 3905,
                "name": "Queensland",
                "iso2": "QLD",
                "latitude": "-20.91757380",
                "longitude": "142.70279560",
                "type": "state",
                "cities": [
                    {
                        "id": 3914,
                        "name": "Acacia Ridge",
                        "latitude": "-27.58333000",
                        "longitude": "153.03333000"
                    },
                    {
                        "id": 3922,
                        "name": "Agnes Water",
                        "latitude": "-24.21190000",
                        "longitude": "151.90350000"
                    },
                    {
                        "id": 3925,
                        "name": "Airlie Beach",
                        "latitude": "-20.26751000",
                        "longitude": "148.71471000"
                    },
                    {
                        "id": 3927,
                        "name": "Aitkenvale",
                        "latitude": "-19.30142000",
                        "longitude": "146.77082000"
                    },
                    {
                        "id": 3931,
                        "name": "Albany Creek",
                        "latitude": "-27.35364000",
                        "longitude": "152.96848000"
                    },
                    {
                        "id": 3942,
                        "name": "Alderley",
                        "latitude": "-27.42553000",
                        "longitude": "153.00102000"
                    },
                    {
                        "id": 3943,
                        "name": "Aldershot",
                        "latitude": "-25.46312000",
                        "longitude": "152.66348000"
                    },
                    {
                        "id": 3948,
                        "name": "Alexandra Headland",
                        "latitude": "-26.67154000",
                        "longitude": "153.10058000"
                    },
                    {
                        "id": 3949,
                        "name": "Alexandra Hills",
                        "latitude": "-27.53221000",
                        "longitude": "153.22889000"
                    },
                    {
                        "id": 3955,
                        "name": "Algester",
                        "latitude": "-27.61279000",
                        "longitude": "153.03239000"
                    },
                    {
                        "id": 3956,
                        "name": "Alice River",
                        "latitude": "-19.33437000",
                        "longitude": "146.61391000"
                    },
                    {
                        "id": 3963,
                        "name": "Allenstown",
                        "latitude": "-23.39403000",
                        "longitude": "150.50393000"
                    },
                    {
                        "id": 3964,
                        "name": "Alligator Creek",
                        "latitude": "-19.39176000",
                        "longitude": "146.93784000"
                    },
                    {
                        "id": 3965,
                        "name": "Allora",
                        "latitude": "-28.03484000",
                        "longitude": "151.98058000"
                    },
                    {
                        "id": 3969,
                        "name": "Alton Downs",
                        "latitude": "-23.30000000",
                        "longitude": "150.35000000"
                    },
                    {
                        "id": 3977,
                        "name": "Andergrove",
                        "latitude": "-21.08333000",
                        "longitude": "149.18333000"
                    },
                    {
                        "id": 3985,
                        "name": "Annandale",
                        "latitude": "-19.31503000",
                        "longitude": "146.79069000"
                    },
                    {
                        "id": 3987,
                        "name": "Annerley",
                        "latitude": "-27.51228000",
                        "longitude": "153.03248000"
                    },
                    {
                        "id": 3988,
                        "name": "Anstead",
                        "latitude": "-27.53781000",
                        "longitude": "152.86187000"
                    },
                    {
                        "id": 3994,
                        "name": "Arana Hills",
                        "latitude": "-27.39808000",
                        "longitude": "152.95797000"
                    },
                    {
                        "id": 4008,
                        "name": "Aroona",
                        "latitude": "-26.78173000",
                        "longitude": "153.11652000"
                    },
                    {
                        "id": 4010,
                        "name": "Arundel",
                        "latitude": "-27.93768000",
                        "longitude": "153.36302000"
                    },
                    {
                        "id": 4011,
                        "name": "Ascot",
                        "latitude": "-27.43154000",
                        "longitude": "153.05800000"
                    },
                    {
                        "id": 4024,
                        "name": "Ashgrove",
                        "latitude": "-27.44552000",
                        "longitude": "152.99200000"
                    },
                    {
                        "id": 4026,
                        "name": "Ashmore",
                        "latitude": "-27.98883000",
                        "longitude": "153.37647000"
                    },
                    {
                        "id": 4031,
                        "name": "Aspley",
                        "latitude": "-27.36667000",
                        "longitude": "153.01667000"
                    },
                    {
                        "id": 4034,
                        "name": "Atherton",
                        "latitude": "-17.26864000",
                        "longitude": "145.47522000"
                    },
                    {
                        "id": 4041,
                        "name": "Auchenflower",
                        "latitude": "-27.47443000",
                        "longitude": "152.99213000"
                    },
                    {
                        "id": 4044,
                        "name": "Augustine Heights",
                        "latitude": "-27.66047000",
                        "longitude": "152.87896000"
                    },
                    {
                        "id": 4045,
                        "name": "Aurukun",
                        "latitude": "-13.51263000",
                        "longitude": "141.82435000"
                    },
                    {
                        "id": 4052,
                        "name": "Avenell Heights",
                        "latitude": "-24.88960000",
                        "longitude": "152.36786000"
                    },
                    {
                        "id": 4054,
                        "name": "Avoca",
                        "latitude": "-24.87822000",
                        "longitude": "152.30794000"
                    },
                    {
                        "id": 4058,
                        "name": "Ayr",
                        "latitude": "-19.57393000",
                        "longitude": "147.40666000"
                    },
                    {
                        "id": 4059,
                        "name": "Babinda",
                        "latitude": "-17.34390000",
                        "longitude": "145.92265000"
                    },
                    {
                        "id": 4063,
                        "name": "Bahrs Scrub",
                        "latitude": "-27.73333000",
                        "longitude": "153.16667000"
                    },
                    {
                        "id": 4065,
                        "name": "Bakers Creek",
                        "latitude": "-21.21990000",
                        "longitude": "149.14681000"
                    },
                    {
                        "id": 4071,
                        "name": "Bald Hills",
                        "latitude": "-27.32112000",
                        "longitude": "153.00857000"
                    },
                    {
                        "id": 4087,
                        "name": "Balmoral",
                        "latitude": "-27.45341000",
                        "longitude": "153.06680000"
                    },
                    {
                        "id": 4089,
                        "name": "Balonne Shire",
                        "latitude": "-28.28481000",
                        "longitude": "148.17933000"
                    },
                    {
                        "id": 4093,
                        "name": "Bamaga",
                        "latitude": "-10.89197000",
                        "longitude": "142.38934000"
                    },
                    {
                        "id": 4094,
                        "name": "Banana",
                        "latitude": "-24.80653000",
                        "longitude": "149.89838000"
                    },
                    {
                        "id": 4100,
                        "name": "Banksia Beach",
                        "latitude": "-27.04027000",
                        "longitude": "153.14390000"
                    },
                    {
                        "id": 4106,
                        "name": "Banyo",
                        "latitude": "-27.38236000",
                        "longitude": "153.07903000"
                    },
                    {
                        "id": 4110,
                        "name": "Barcaldine",
                        "latitude": "-23.05203000",
                        "longitude": "145.43490000"
                    },
                    {
                        "id": 4111,
                        "name": "Barcoo",
                        "latitude": "-25.17292000",
                        "longitude": "142.46481000"
                    },
                    {
                        "id": 4114,
                        "name": "Bardon",
                        "latitude": "-27.46100000",
                        "longitude": "152.97920000"
                    },
                    {
                        "id": 4117,
                        "name": "Barellan Point",
                        "latitude": "-27.57196000",
                        "longitude": "152.84379000"
                    },
                    {
                        "id": 4118,
                        "name": "Bargara",
                        "latitude": "-24.81476000",
                        "longitude": "152.46257000"
                    },
                    {
                        "id": 4123,
                        "name": "Barney Point",
                        "latitude": "-23.84793000",
                        "longitude": "151.26577000"
                    },
                    {
                        "id": 4144,
                        "name": "Battery Hill",
                        "latitude": "-26.77878000",
                        "longitude": "153.12887000"
                    },
                    {
                        "id": 4156,
                        "name": "Bayview Heights",
                        "latitude": "-16.96229000",
                        "longitude": "145.72585000"
                    },
                    {
                        "id": 4158,
                        "name": "Beachmere",
                        "latitude": "-27.12808000",
                        "longitude": "153.05243000"
                    },
                    {
                        "id": 4163,
                        "name": "Beaconsfield",
                        "latitude": "-21.09121000",
                        "longitude": "149.16544000"
                    },
                    {
                        "id": 4165,
                        "name": "Beaudesert",
                        "latitude": "-27.98691000",
                        "longitude": "152.99657000"
                    },
                    {
                        "id": 4179,
                        "name": "Beenleigh",
                        "latitude": "-27.71137000",
                        "longitude": "153.20290000"
                    },
                    {
                        "id": 4180,
                        "name": "Beerwah",
                        "latitude": "-26.85881000",
                        "longitude": "152.96144000"
                    },
                    {
                        "id": 4187,
                        "name": "Belgian Gardens",
                        "latitude": "-19.24507000",
                        "longitude": "146.79455000"
                    },
                    {
                        "id": 4196,
                        "name": "Bellara",
                        "latitude": "-27.06392000",
                        "longitude": "153.14959000"
                    },
                    {
                        "id": 4198,
                        "name": "Bellbird Park",
                        "latitude": "-27.63674000",
                        "longitude": "152.88663000"
                    },
                    {
                        "id": 4199,
                        "name": "Bellbowrie",
                        "latitude": "-27.55939000",
                        "longitude": "152.88278000"
                    },
                    {
                        "id": 4206,
                        "name": "Bellmere",
                        "latitude": "-27.08441000",
                        "longitude": "152.89003000"
                    },
                    {
                        "id": 4208,
                        "name": "Belmont",
                        "latitude": "-27.49882000",
                        "longitude": "153.13400000"
                    },
                    {
                        "id": 4217,
                        "name": "Benaraby",
                        "latitude": "-24.00417000",
                        "longitude": "151.33410000"
                    },
                    {
                        "id": 4221,
                        "name": "Benowa",
                        "latitude": "-28.00770000",
                        "longitude": "153.38583000"
                    },
                    {
                        "id": 4226,
                        "name": "Bentley Park",
                        "latitude": "-17.00389000",
                        "longitude": "145.73819000"
                    },
                    {
                        "id": 4242,
                        "name": "Berrinba",
                        "latitude": "-27.65853000",
                        "longitude": "153.07888000"
                    },
                    {
                        "id": 4244,
                        "name": "Berserker",
                        "latitude": "-23.35817000",
                        "longitude": "150.52042000"
                    },
                    {
                        "id": 4258,
                        "name": "Biggera Waters",
                        "latitude": "-27.93239000",
                        "longitude": "153.40021000"
                    },
                    {
                        "id": 4261,
                        "name": "Bilinga",
                        "latitude": "-28.16667000",
                        "longitude": "153.51667000"
                    },
                    {
                        "id": 4263,
                        "name": "Biloela",
                        "latitude": "-24.39589000",
                        "longitude": "150.51504000"
                    },
                    {
                        "id": 4269,
                        "name": "Birkdale",
                        "latitude": "-27.48333000",
                        "longitude": "153.21667000"
                    },
                    {
                        "id": 4273,
                        "name": "Birtinya",
                        "latitude": "-26.74322000",
                        "longitude": "153.11913000"
                    },
                    {
                        "id": 4277,
                        "name": "Black Mountain",
                        "latitude": "-26.39886000",
                        "longitude": "152.87561000"
                    },
                    {
                        "id": 4278,
                        "name": "Black River",
                        "latitude": "-19.22517000",
                        "longitude": "146.61787000"
                    },
                    {
                        "id": 4280,
                        "name": "Blackall",
                        "latitude": "-24.42327000",
                        "longitude": "145.46303000"
                    },
                    {
                        "id": 4281,
                        "name": "Blackall Tambo",
                        "latitude": "-24.78795000",
                        "longitude": "145.97279000"
                    },
                    {
                        "id": 4290,
                        "name": "Blacks Beach",
                        "latitude": "-21.05466000",
                        "longitude": "149.18971000"
                    },
                    {
                        "id": 4295,
                        "name": "Blackwater",
                        "latitude": "-23.58351000",
                        "longitude": "148.87912000"
                    },
                    {
                        "id": 4305,
                        "name": "Bli Bli",
                        "latitude": "-26.61724000",
                        "longitude": "153.03665000"
                    },
                    {
                        "id": 4311,
                        "name": "Bluewater",
                        "latitude": "-19.18157000",
                        "longitude": "146.55820000"
                    },
                    {
                        "id": 4319,
                        "name": "Bohle Plains",
                        "latitude": "-19.31365000",
                        "longitude": "146.69186000"
                    },
                    {
                        "id": 4320,
                        "name": "Bokarina",
                        "latitude": "-26.73843000",
                        "longitude": "153.13049000"
                    },
                    {
                        "id": 4329,
                        "name": "Bongaree",
                        "latitude": "-27.08367000",
                        "longitude": "153.15942000"
                    },
                    {
                        "id": 4336,
                        "name": "Bonogin",
                        "latitude": "-28.13930000",
                        "longitude": "153.35297000"
                    },
                    {
                        "id": 4339,
                        "name": "Booie",
                        "latitude": "-26.53677000",
                        "longitude": "151.94181000"
                    },
                    {
                        "id": 4341,
                        "name": "Boonah",
                        "latitude": "-27.99724000",
                        "longitude": "152.68108000"
                    },
                    {
                        "id": 4342,
                        "name": "Boondall",
                        "latitude": "-27.35317000",
                        "longitude": "153.06092000"
                    },
                    {
                        "id": 4345,
                        "name": "Booral",
                        "latitude": "-25.36048000",
                        "longitude": "152.90810000"
                    },
                    {
                        "id": 4347,
                        "name": "Booval",
                        "latitude": "-27.61328000",
                        "longitude": "152.78944000"
                    },
                    {
                        "id": 4350,
                        "name": "Boronia Heights",
                        "latitude": "-27.68855000",
                        "longitude": "153.01959000"
                    },
                    {
                        "id": 4357,
                        "name": "Bouldercombe",
                        "latitude": "-23.57054000",
                        "longitude": "150.46951000"
                    },
                    {
                        "id": 4358,
                        "name": "Boulia",
                        "latitude": "-22.27908000",
                        "longitude": "139.62534000"
                    },
                    {
                        "id": 4362,
                        "name": "Bowen",
                        "latitude": "-20.01367000",
                        "longitude": "148.24754000"
                    },
                    {
                        "id": 4363,
                        "name": "Bowen Hills",
                        "latitude": "-27.44369000",
                        "longitude": "153.03728000"
                    },
                    {
                        "id": 4372,
                        "name": "Boyne Island",
                        "latitude": "-23.94829000",
                        "longitude": "151.35336000"
                    },
                    {
                        "id": 4375,
                        "name": "Bracken Ridge",
                        "latitude": "-27.31710000",
                        "longitude": "153.03097000"
                    },
                    {
                        "id": 4381,
                        "name": "Brandon",
                        "latitude": "-19.55389000",
                        "longitude": "147.35304000"
                    },
                    {
                        "id": 4383,
                        "name": "Branyan",
                        "latitude": "-24.91347000",
                        "longitude": "152.27251000"
                    },
                    {
                        "id": 4384,
                        "name": "Brassall",
                        "latitude": "-27.59753000",
                        "longitude": "152.74755000"
                    },
                    {
                        "id": 4385,
                        "name": "Bray Park",
                        "latitude": "-27.29246000",
                        "longitude": "152.96783000"
                    },
                    {
                        "id": 4389,
                        "name": "Brendale",
                        "latitude": "-27.32114000",
                        "longitude": "152.98393000"
                    },
                    {
                        "id": 4394,
                        "name": "Bridgeman Downs",
                        "latitude": "-27.35538000",
                        "longitude": "152.99432000"
                    },
                    {
                        "id": 4402,
                        "name": "Brighton",
                        "latitude": "-27.29582000",
                        "longitude": "153.05721000"
                    },
                    {
                        "id": 4410,
                        "name": "Brinsmead",
                        "latitude": "-16.89921000",
                        "longitude": "145.71554000"
                    },
                    {
                        "id": 4411,
                        "name": "Brisbane",
                        "latitude": "-27.46794000",
                        "longitude": "153.02809000"
                    },
                    {
                        "id": 4412,
                        "name": "Broadbeach",
                        "latitude": "-28.02782000",
                        "longitude": "153.43343000"
                    },
                    {
                        "id": 4413,
                        "name": "Broadbeach Waters",
                        "latitude": "-28.03498000",
                        "longitude": "153.42502000"
                    },
                    {
                        "id": 4426,
                        "name": "Brookfield",
                        "latitude": "-27.50000000",
                        "longitude": "152.90000000"
                    },
                    {
                        "id": 4431,
                        "name": "Brookwater",
                        "latitude": "-27.66128000",
                        "longitude": "152.89669000"
                    },
                    {
                        "id": 4443,
                        "name": "Bucasia",
                        "latitude": "-21.03494000",
                        "longitude": "149.15726000"
                    },
                    {
                        "id": 4444,
                        "name": "Bucca",
                        "latitude": "-24.86667000",
                        "longitude": "152.10000000"
                    },
                    {
                        "id": 4445,
                        "name": "Buccan",
                        "latitude": "-27.75000000",
                        "longitude": "153.13333000"
                    },
                    {
                        "id": 4446,
                        "name": "Buddina",
                        "latitude": "-26.69565000",
                        "longitude": "153.13302000"
                    },
                    {
                        "id": 4447,
                        "name": "Buderim",
                        "latitude": "-26.68443000",
                        "longitude": "153.05705000"
                    },
                    {
                        "id": 4452,
                        "name": "Bulimba",
                        "latitude": "-27.44990000",
                        "longitude": "153.05766000"
                    },
                    {
                        "id": 4457,
                        "name": "Bulloo",
                        "latitude": "-27.83079000",
                        "longitude": "142.91280000"
                    },
                    {
                        "id": 4461,
                        "name": "Bundaberg",
                        "latitude": "-24.97305000",
                        "longitude": "151.98442000"
                    },
                    {
                        "id": 4462,
                        "name": "Bundaberg East",
                        "latitude": "-24.85860000",
                        "longitude": "152.38003000"
                    },
                    {
                        "id": 4463,
                        "name": "Bundaberg North",
                        "latitude": "-24.84914000",
                        "longitude": "152.34638000"
                    },
                    {
                        "id": 4464,
                        "name": "Bundaberg South",
                        "latitude": "-24.87277000",
                        "longitude": "152.35986000"
                    },
                    {
                        "id": 4465,
                        "name": "Bundaberg West",
                        "latitude": "-24.87265000",
                        "longitude": "152.33647000"
                    },
                    {
                        "id": 4466,
                        "name": "Bundall",
                        "latitude": "-28.01111000",
                        "longitude": "153.40479000"
                    },
                    {
                        "id": 4467,
                        "name": "Bundamba",
                        "latitude": "-27.60947000",
                        "longitude": "152.81133000"
                    },
                    {
                        "id": 4471,
                        "name": "Bungalow",
                        "latitude": "-16.93855000",
                        "longitude": "145.75634000"
                    },
                    {
                        "id": 4475,
                        "name": "Bunya",
                        "latitude": "-27.36940000",
                        "longitude": "152.94331000"
                    },
                    {
                        "id": 4477,
                        "name": "Burbank",
                        "latitude": "-27.55584000",
                        "longitude": "153.14701000"
                    },
                    {
                        "id": 4478,
                        "name": "Burdekin",
                        "latitude": "-19.84934000",
                        "longitude": "147.27239000"
                    },
                    {
                        "id": 4479,
                        "name": "Burdell",
                        "latitude": "-19.25056000",
                        "longitude": "146.69877000"
                    },
                    {
                        "id": 4480,
                        "name": "Burke",
                        "latitude": "-18.06461000",
                        "longitude": "139.03748000"
                    },
                    {
                        "id": 4481,
                        "name": "Burleigh Heads",
                        "latitude": "-28.10000000",
                        "longitude": "153.45000000"
                    },
                    {
                        "id": 4482,
                        "name": "Burleigh Waters",
                        "latitude": "-28.09975000",
                        "longitude": "153.42463000"
                    },
                    {
                        "id": 4483,
                        "name": "Burnett Heads",
                        "latitude": "-24.76468000",
                        "longitude": "152.41270000"
                    },
                    {
                        "id": 4488,
                        "name": "Burnside",
                        "latitude": "-26.63255000",
                        "longitude": "152.94063000"
                    },
                    {
                        "id": 4491,
                        "name": "Burpengary",
                        "latitude": "-27.15746000",
                        "longitude": "152.95758000"
                    },
                    {
                        "id": 4492,
                        "name": "Burpengary East",
                        "latitude": "-27.14447000",
                        "longitude": "152.99968000"
                    },
                    {
                        "id": 4497,
                        "name": "Burrum Heads",
                        "latitude": "-25.18457000",
                        "longitude": "152.61263000"
                    },
                    {
                        "id": 4504,
                        "name": "Bushland Beach",
                        "latitude": "-19.19134000",
                        "longitude": "146.67682000"
                    },
                    {
                        "id": 4515,
                        "name": "Cabarlah",
                        "latitude": "-27.43333000",
                        "longitude": "152.00000000"
                    },
                    {
                        "id": 4518,
                        "name": "Caboolture",
                        "latitude": "-27.08465000",
                        "longitude": "152.95110000"
                    },
                    {
                        "id": 4519,
                        "name": "Caboolture South",
                        "latitude": "-27.09389000",
                        "longitude": "152.94874000"
                    },
                    {
                        "id": 4524,
                        "name": "Cairns",
                        "latitude": "-16.90268000",
                        "longitude": "145.75287000"
                    },
                    {
                        "id": 4525,
                        "name": "Cairns City",
                        "latitude": "-16.92069000",
                        "longitude": "145.77358000"
                    },
                    {
                        "id": 4526,
                        "name": "Cairns North",
                        "latitude": "-16.90406000",
                        "longitude": "145.75703000"
                    },
                    {
                        "id": 4528,
                        "name": "Calamvale",
                        "latitude": "-27.62329000",
                        "longitude": "153.04785000"
                    },
                    {
                        "id": 4533,
                        "name": "Calliope",
                        "latitude": "-24.00705000",
                        "longitude": "151.20033000"
                    },
                    {
                        "id": 4534,
                        "name": "Caloundra",
                        "latitude": "-26.80346000",
                        "longitude": "153.12195000"
                    },
                    {
                        "id": 4535,
                        "name": "Caloundra West",
                        "latitude": "-26.80634000",
                        "longitude": "153.10894000"
                    },
                    {
                        "id": 4539,
                        "name": "Cambooya",
                        "latitude": "-27.71454000",
                        "longitude": "151.86029000"
                    },
                    {
                        "id": 4550,
                        "name": "Camira",
                        "latitude": "-27.63461000",
                        "longitude": "152.92091000"
                    },
                    {
                        "id": 4552,
                        "name": "Camp Hill",
                        "latitude": "-27.49354000",
                        "longitude": "153.07629000"
                    },
                    {
                        "id": 4553,
                        "name": "Camp Mountain",
                        "latitude": "-27.40000000",
                        "longitude": "152.88333000"
                    },
                    {
                        "id": 4572,
                        "name": "Cannon Hill",
                        "latitude": "-27.47237000",
                        "longitude": "153.09475000"
                    },
                    {
                        "id": 4573,
                        "name": "Cannonvale",
                        "latitude": "-20.27681000",
                        "longitude": "148.69759000"
                    },
                    {
                        "id": 4578,
                        "name": "Canungra",
                        "latitude": "-28.01689000",
                        "longitude": "153.16525000"
                    },
                    {
                        "id": 4579,
                        "name": "Capalaba",
                        "latitude": "-27.54333000",
                        "longitude": "153.20287000"
                    },
                    {
                        "id": 4582,
                        "name": "Capella",
                        "latitude": "-23.08593000",
                        "longitude": "148.02206000"
                    },
                    {
                        "id": 4583,
                        "name": "Caravonica",
                        "latitude": "-16.87063000",
                        "longitude": "145.68099000"
                    },
                    {
                        "id": 4584,
                        "name": "Carbrook",
                        "latitude": "-27.68333000",
                        "longitude": "153.25000000"
                    },
                    {
                        "id": 4590,
                        "name": "Cardwell",
                        "latitude": "-18.26693000",
                        "longitude": "146.02804000"
                    },
                    {
                        "id": 4592,
                        "name": "Carina Heights",
                        "latitude": "-27.50721000",
                        "longitude": "153.09126000"
                    },
                    {
                        "id": 4593,
                        "name": "Carindale",
                        "latitude": "-27.50578000",
                        "longitude": "153.10236000"
                    },
                    {
                        "id": 4608,
                        "name": "Carpentaria",
                        "latitude": "-17.32216000",
                        "longitude": "141.35310000"
                    },
                    {
                        "id": 4611,
                        "name": "Carrara",
                        "latitude": "-28.02151000",
                        "longitude": "153.36635000"
                    },
                    {
                        "id": 4616,
                        "name": "Carseldine",
                        "latitude": "-27.34753000",
                        "longitude": "153.02307000"
                    },
                    {
                        "id": 4622,
                        "name": "Cashmere",
                        "latitude": "-27.29767000",
                        "longitude": "152.90662000"
                    },
                    {
                        "id": 4624,
                        "name": "Cassowary Coast",
                        "latitude": "-17.96785000",
                        "longitude": "145.96561000"
                    },
                    {
                        "id": 4644,
                        "name": "Cedar Grove",
                        "latitude": "-27.86667000",
                        "longitude": "152.98333000"
                    },
                    {
                        "id": 4645,
                        "name": "Cedar Vale",
                        "latitude": "-27.88923000",
                        "longitude": "153.02891000"
                    },
                    {
                        "id": 4647,
                        "name": "Centenary Heights",
                        "latitude": "-27.58684000",
                        "longitude": "151.96249000"
                    },
                    {
                        "id": 4654,
                        "name": "Central Highlands",
                        "latitude": "-24.06336000",
                        "longitude": "148.31958000"
                    },
                    {
                        "id": 4658,
                        "name": "Chambers Flat",
                        "latitude": "-27.74811000",
                        "longitude": "153.07764000"
                    },
                    {
                        "id": 4660,
                        "name": "Chandler",
                        "latitude": "-27.51398000",
                        "longitude": "153.14907000"
                    },
                    {
                        "id": 4661,
                        "name": "Chapel Hill",
                        "latitude": "-27.50264000",
                        "longitude": "152.95012000"
                    },
                    {
                        "id": 4666,
                        "name": "Charleville",
                        "latitude": "-26.40542000",
                        "longitude": "146.24274000"
                    },
                    {
                        "id": 4670,
                        "name": "Charters Towers",
                        "latitude": "-20.20927000",
                        "longitude": "145.81645000"
                    },
                    {
                        "id": 4671,
                        "name": "Charters Towers City",
                        "latitude": "-20.07774000",
                        "longitude": "146.26275000"
                    },
                    {
                        "id": 4674,
                        "name": "Chatsworth",
                        "latitude": "-26.14398000",
                        "longitude": "152.61503000"
                    },
                    {
                        "id": 4675,
                        "name": "Chelmer",
                        "latitude": "-27.51326000",
                        "longitude": "152.97524000"
                    },
                    {
                        "id": 4680,
                        "name": "Cherbourg",
                        "latitude": "-26.28750000",
                        "longitude": "151.93279000"
                    },
                    {
                        "id": 4681,
                        "name": "Chermside",
                        "latitude": "-27.38472000",
                        "longitude": "153.03062000"
                    },
                    {
                        "id": 4682,
                        "name": "Chermside West",
                        "latitude": "-27.38383000",
                        "longitude": "153.01586000"
                    },
                    {
                        "id": 4690,
                        "name": "Childers",
                        "latitude": "-25.23708000",
                        "longitude": "152.27876000"
                    },
                    {
                        "id": 4692,
                        "name": "Chinchilla",
                        "latitude": "-26.73787000",
                        "longitude": "150.62970000"
                    },
                    {
                        "id": 4703,
                        "name": "Churchill",
                        "latitude": "-27.64233000",
                        "longitude": "152.75022000"
                    },
                    {
                        "id": 4706,
                        "name": "Chuwar",
                        "latitude": "-27.56620000",
                        "longitude": "152.77844000"
                    },
                    {
                        "id": 4728,
                        "name": "Clayfield",
                        "latitude": "-27.41894000",
                        "longitude": "153.05818000"
                    },
                    {
                        "id": 4732,
                        "name": "Clear Island Waters",
                        "latitude": "-28.05308000",
                        "longitude": "153.39815000"
                    },
                    {
                        "id": 4735,
                        "name": "Clermont",
                        "latitude": "-22.82407000",
                        "longitude": "147.63635000"
                    },
                    {
                        "id": 4737,
                        "name": "Cleveland",
                        "latitude": "-27.52677000",
                        "longitude": "153.26516000"
                    },
                    {
                        "id": 4738,
                        "name": "Clifton",
                        "latitude": "-27.93374000",
                        "longitude": "151.90660000"
                    },
                    {
                        "id": 4739,
                        "name": "Clifton Beach",
                        "latitude": "-16.76313000",
                        "longitude": "145.67167000"
                    },
                    {
                        "id": 4742,
                        "name": "Clinton",
                        "latitude": "-23.87518000",
                        "longitude": "151.21793000"
                    },
                    {
                        "id": 4743,
                        "name": "Cloncurry",
                        "latitude": "-20.69889000",
                        "longitude": "140.27115000"
                    },
                    {
                        "id": 4744,
                        "name": "Clontarf",
                        "latitude": "-27.25341000",
                        "longitude": "153.07835000"
                    },
                    {
                        "id": 4762,
                        "name": "Coes Creek",
                        "latitude": "-26.64720000",
                        "longitude": "152.94943000"
                    },
                    {
                        "id": 4776,
                        "name": "Collingwood Park",
                        "latitude": "-27.61282000",
                        "longitude": "152.86008000"
                    },
                    {
                        "id": 4777,
                        "name": "Collinsville",
                        "latitude": "-20.55223000",
                        "longitude": "147.84399000"
                    },
                    {
                        "id": 4789,
                        "name": "Condon",
                        "latitude": "-19.32968000",
                        "longitude": "146.71663000"
                    },
                    {
                        "id": 4796,
                        "name": "Cooee Bay",
                        "latitude": "-23.14427000",
                        "longitude": "150.76113000"
                    },
                    {
                        "id": 4800,
                        "name": "Cook Shire",
                        "latitude": "-13.68149000",
                        "longitude": "143.53156000"
                    },
                    {
                        "id": 4802,
                        "name": "Cooktown",
                        "latitude": "-15.46570000",
                        "longitude": "145.24984000"
                    },
                    {
                        "id": 4805,
                        "name": "Coolangatta",
                        "latitude": "-28.16944000",
                        "longitude": "153.53471000"
                    },
                    {
                        "id": 4810,
                        "name": "Cooloola Cove",
                        "latitude": "-25.98640000",
                        "longitude": "152.99355000"
                    },
                    {
                        "id": 4812,
                        "name": "Coolum Beach",
                        "latitude": "-26.52830000",
                        "longitude": "153.08809000"
                    },
                    {
                        "id": 4815,
                        "name": "Coombabah",
                        "latitude": "-27.91073000",
                        "longitude": "153.37093000"
                    },
                    {
                        "id": 4817,
                        "name": "Coomera",
                        "latitude": "-27.84333000",
                        "longitude": "153.33901000"
                    },
                    {
                        "id": 4818,
                        "name": "Coominya",
                        "latitude": "-27.39009000",
                        "longitude": "152.50060000"
                    },
                    {
                        "id": 4821,
                        "name": "Coopers Plains",
                        "latitude": "-27.56463000",
                        "longitude": "153.04067000"
                    },
                    {
                        "id": 4822,
                        "name": "Cooran",
                        "latitude": "-26.33689000",
                        "longitude": "152.82246000"
                    },
                    {
                        "id": 4824,
                        "name": "Cooroibah",
                        "latitude": "-26.36316000",
                        "longitude": "152.98599000"
                    },
                    {
                        "id": 4826,
                        "name": "Cooroy",
                        "latitude": "-26.41778000",
                        "longitude": "152.91149000"
                    },
                    {
                        "id": 4827,
                        "name": "Coorparoo",
                        "latitude": "-27.49325000",
                        "longitude": "153.05826000"
                    },
                    {
                        "id": 4830,
                        "name": "Coppabella",
                        "latitude": "-21.94710000",
                        "longitude": "148.30050000"
                    },
                    {
                        "id": 4833,
                        "name": "Coral Cove",
                        "latitude": "-24.88309000",
                        "longitude": "152.48266000"
                    },
                    {
                        "id": 4836,
                        "name": "Corinda",
                        "latitude": "-27.54381000",
                        "longitude": "152.98215000"
                    },
                    {
                        "id": 4840,
                        "name": "Cornubia",
                        "latitude": "-27.66667000",
                        "longitude": "153.21667000"
                    },
                    {
                        "id": 4847,
                        "name": "Cotswold Hills",
                        "latitude": "-27.52241000",
                        "longitude": "151.89516000"
                    },
                    {
                        "id": 4861,
                        "name": "Craiglie",
                        "latitude": "-16.53789000",
                        "longitude": "145.46963000"
                    },
                    {
                        "id": 4863,
                        "name": "Craignish",
                        "latitude": "-25.28258000",
                        "longitude": "152.72429000"
                    },
                    {
                        "id": 4870,
                        "name": "Cranbrook",
                        "latitude": "-19.30553000",
                        "longitude": "146.75286000"
                    },
                    {
                        "id": 4872,
                        "name": "Cranley",
                        "latitude": "-27.51504000",
                        "longitude": "151.92300000"
                    },
                    {
                        "id": 4879,
                        "name": "Crestmead",
                        "latitude": "-27.68759000",
                        "longitude": "153.08444000"
                    },
                    {
                        "id": 4888,
                        "name": "Crows Nest",
                        "latitude": "-27.25993000",
                        "longitude": "152.05164000"
                    },
                    {
                        "id": 4891,
                        "name": "Croydon",
                        "latitude": "-18.51360000",
                        "longitude": "142.32249000"
                    },
                    {
                        "id": 4905,
                        "name": "Cunnamulla",
                        "latitude": "-28.06766000",
                        "longitude": "145.68439000"
                    },
                    {
                        "id": 4907,
                        "name": "Curra",
                        "latitude": "-26.06667000",
                        "longitude": "152.58333000"
                    },
                    {
                        "id": 4908,
                        "name": "Currajong",
                        "latitude": "-19.27566000",
                        "longitude": "146.77918000"
                    },
                    {
                        "id": 4912,
                        "name": "Currimundi",
                        "latitude": "-26.76925000",
                        "longitude": "153.12237000"
                    },
                    {
                        "id": 4913,
                        "name": "Currumbin",
                        "latitude": "-28.13649000",
                        "longitude": "153.48158000"
                    },
                    {
                        "id": 4914,
                        "name": "Currumbin Valley",
                        "latitude": "-28.20805000",
                        "longitude": "153.39424000"
                    },
                    {
                        "id": 4915,
                        "name": "Currumbin Waters",
                        "latitude": "-28.15442000",
                        "longitude": "153.47282000"
                    },
                    {
                        "id": 5054,
                        "name": "D’Aguilar",
                        "latitude": "-26.98333000",
                        "longitude": "152.80000000"
                    },
                    {
                        "id": 4920,
                        "name": "Daisy Hill",
                        "latitude": "-27.63026000",
                        "longitude": "153.15784000"
                    },
                    {
                        "id": 4921,
                        "name": "Dakabin",
                        "latitude": "-27.22594000",
                        "longitude": "152.99097000"
                    },
                    {
                        "id": 4922,
                        "name": "Dalby",
                        "latitude": "-27.18169000",
                        "longitude": "151.26205000"
                    },
                    {
                        "id": 4939,
                        "name": "Darling Heights",
                        "latitude": "-27.59659000",
                        "longitude": "151.93045000"
                    },
                    {
                        "id": 4946,
                        "name": "Darra",
                        "latitude": "-27.56693000",
                        "longitude": "152.95395000"
                    },
                    {
                        "id": 4953,
                        "name": "Dayboro",
                        "latitude": "-27.19632000",
                        "longitude": "152.82253000"
                    },
                    {
                        "id": 4956,
                        "name": "Deagon",
                        "latitude": "-27.32788000",
                        "longitude": "153.06126000"
                    },
                    {
                        "id": 4959,
                        "name": "Deception Bay",
                        "latitude": "-27.19354000",
                        "longitude": "153.02631000"
                    },
                    {
                        "id": 4961,
                        "name": "Deebing Heights",
                        "latitude": "-27.66719000",
                        "longitude": "152.74867000"
                    },
                    {
                        "id": 4963,
                        "name": "Deeragun",
                        "latitude": "-19.24741000",
                        "longitude": "146.67570000"
                    },
                    {
                        "id": 4966,
                        "name": "Delaneys Creek",
                        "latitude": "-27.00021000",
                        "longitude": "152.79553000"
                    },
                    {
                        "id": 4976,
                        "name": "Depot Hill",
                        "latitude": "-23.39024000",
                        "longitude": "150.52102000"
                    },
                    {
                        "id": 4986,
                        "name": "Diamantina",
                        "latitude": "-24.57676000",
                        "longitude": "140.07163000"
                    },
                    {
                        "id": 4990,
                        "name": "Dicky Beach",
                        "latitude": "-26.78364000",
                        "longitude": "153.13766000"
                    },
                    {
                        "id": 4991,
                        "name": "Diddillibah",
                        "latitude": "-26.64166000",
                        "longitude": "153.04959000"
                    },
                    {
                        "id": 4994,
                        "name": "Dimbulah",
                        "latitude": "-17.14752000",
                        "longitude": "145.10969000"
                    },
                    {
                        "id": 5008,
                        "name": "Doolandella",
                        "latitude": "-27.61328000",
                        "longitude": "152.98547000"
                    },
                    {
                        "id": 5009,
                        "name": "Doomadgee",
                        "latitude": "-17.63879000",
                        "longitude": "138.74359000"
                    },
                    {
                        "id": 5010,
                        "name": "Doonan",
                        "latitude": "-26.43964000",
                        "longitude": "152.99204000"
                    },
                    {
                        "id": 5018,
                        "name": "Douglas",
                        "latitude": "-19.32394000",
                        "longitude": "146.75234000"
                    },
                    {
                        "id": 5025,
                        "name": "Drayton",
                        "latitude": "-27.60011000",
                        "longitude": "151.90109000"
                    },
                    {
                        "id": 5026,
                        "name": "Drewvale",
                        "latitude": "-27.64768000",
                        "longitude": "153.05458000"
                    },
                    {
                        "id": 5043,
                        "name": "Dundowran Beach",
                        "latitude": "-25.26934000",
                        "longitude": "152.76232000"
                    },
                    {
                        "id": 5049,
                        "name": "Durack",
                        "latitude": "-27.58947000",
                        "longitude": "152.98577000"
                    },
                    {
                        "id": 5051,
                        "name": "Dutton Park",
                        "latitude": "-27.49662000",
                        "longitude": "153.02796000"
                    },
                    {
                        "id": 5053,
                        "name": "Dysart",
                        "latitude": "-22.58825000",
                        "longitude": "148.34924000"
                    },
                    {
                        "id": 149309,
                        "name": "Eagle Farm",
                        "latitude": "-27.43151850",
                        "longitude": "153.07229130"
                    },
                    {
                        "id": 5057,
                        "name": "Eagleby",
                        "latitude": "-27.68333000",
                        "longitude": "153.21667000"
                    },
                    {
                        "id": 5060,
                        "name": "Earlville",
                        "latitude": "-16.95078000",
                        "longitude": "145.73308000"
                    },
                    {
                        "id": 5068,
                        "name": "East Brisbane",
                        "latitude": "-27.48099000",
                        "longitude": "153.04401000"
                    },
                    {
                        "id": 5079,
                        "name": "East Innisfail",
                        "latitude": "-17.53324000",
                        "longitude": "146.03487000"
                    },
                    {
                        "id": 5080,
                        "name": "East Ipswich",
                        "latitude": "-27.60637000",
                        "longitude": "152.77232000"
                    },
                    {
                        "id": 5088,
                        "name": "East Mackay",
                        "latitude": "-21.14979000",
                        "longitude": "149.19640000"
                    },
                    {
                        "id": 5096,
                        "name": "East Toowoomba",
                        "latitude": "-27.57086000",
                        "longitude": "151.97422000"
                    },
                    {
                        "id": 5098,
                        "name": "Eastern Heights",
                        "latitude": "-27.62849000",
                        "longitude": "152.77828000"
                    },
                    {
                        "id": 5102,
                        "name": "Eatons Hill",
                        "latitude": "-27.33920000",
                        "longitude": "152.95990000"
                    },
                    {
                        "id": 5109,
                        "name": "Edens Landing",
                        "latitude": "-27.70270000",
                        "longitude": "153.16943000"
                    },
                    {
                        "id": 5111,
                        "name": "Edge Hill",
                        "latitude": "-16.90000000",
                        "longitude": "145.75000000"
                    },
                    {
                        "id": 5117,
                        "name": "Edmonton",
                        "latitude": "-17.01902000",
                        "longitude": "145.74443000"
                    },
                    {
                        "id": 5121,
                        "name": "Eight Mile Plains",
                        "latitude": "-27.58333000",
                        "longitude": "153.10000000"
                    },
                    {
                        "id": 5122,
                        "name": "Eimeo",
                        "latitude": "-21.03766000",
                        "longitude": "149.17630000"
                    },
                    {
                        "id": 5123,
                        "name": "Elanora",
                        "latitude": "-28.13577000",
                        "longitude": "153.44931000"
                    },
                    {
                        "id": 5128,
                        "name": "Eli Waters",
                        "latitude": "-25.27922000",
                        "longitude": "152.80910000"
                    },
                    {
                        "id": 5129,
                        "name": "Elimbah",
                        "latitude": "-27.01667000",
                        "longitude": "152.95000000"
                    },
                    {
                        "id": 5140,
                        "name": "Ellen Grove",
                        "latitude": "-27.61529000",
                        "longitude": "152.94385000"
                    },
                    {
                        "id": 5143,
                        "name": "Elliott Heads",
                        "latitude": "-24.91622000",
                        "longitude": "152.48988000"
                    },
                    {
                        "id": 5151,
                        "name": "Emerald",
                        "latitude": "-23.52296000",
                        "longitude": "148.15784000"
                    },
                    {
                        "id": 5156,
                        "name": "Emu Park",
                        "latitude": "-23.25680000",
                        "longitude": "150.82679000"
                    },
                    {
                        "id": 5163,
                        "name": "Enoggera",
                        "latitude": "-27.42832000",
                        "longitude": "152.97467000"
                    },
                    {
                        "id": 5174,
                        "name": "Esk",
                        "latitude": "-27.23895000",
                        "longitude": "152.42223000"
                    },
                    {
                        "id": 5182,
                        "name": "Etheridge",
                        "latitude": "-18.56276000",
                        "longitude": "143.53832000"
                    },
                    {
                        "id": 5185,
                        "name": "Eudlo",
                        "latitude": "-26.72963000",
                        "longitude": "152.95395000"
                    },
                    {
                        "id": 5188,
                        "name": "Eumundi",
                        "latitude": "-26.47737000",
                        "longitude": "152.95115000"
                    },
                    {
                        "id": 5199,
                        "name": "Everton Hills",
                        "latitude": "-27.38909000",
                        "longitude": "152.97126000"
                    },
                    {
                        "id": 5200,
                        "name": "Everton Park",
                        "latitude": "-27.40732000",
                        "longitude": "152.98840000"
                    },
                    {
                        "id": 5207,
                        "name": "Fairfield",
                        "latitude": "-27.50644000",
                        "longitude": "153.02479000"
                    },
                    {
                        "id": 5228,
                        "name": "Fernvale",
                        "latitude": "-27.45475000",
                        "longitude": "152.65321000"
                    },
                    {
                        "id": 5230,
                        "name": "Ferny Grove",
                        "latitude": "-27.40080000",
                        "longitude": "152.93475000"
                    },
                    {
                        "id": 5231,
                        "name": "Ferny Hills",
                        "latitude": "-27.39594000",
                        "longitude": "152.93737000"
                    },
                    {
                        "id": 5233,
                        "name": "Fig Tree Pocket",
                        "latitude": "-27.52784000",
                        "longitude": "152.96190000"
                    },
                    {
                        "id": 5240,
                        "name": "Fitzgibbon",
                        "latitude": "-27.33971000",
                        "longitude": "153.02921000"
                    },
                    {
                        "id": 5249,
                        "name": "Flinders",
                        "latitude": "-20.89030000",
                        "longitude": "144.38814000"
                    },
                    {
                        "id": 5253,
                        "name": "Flinders View",
                        "latitude": "-27.65046000",
                        "longitude": "152.77451000"
                    },
                    {
                        "id": 5262,
                        "name": "Forest Glen",
                        "latitude": "-26.68864000",
                        "longitude": "153.00453000"
                    },
                    {
                        "id": 5265,
                        "name": "Forest Lake",
                        "latitude": "-27.62563000",
                        "longitude": "152.96883000"
                    },
                    {
                        "id": 5267,
                        "name": "Forestdale",
                        "latitude": "-27.66334000",
                        "longitude": "153.00383000"
                    },
                    {
                        "id": 5275,
                        "name": "Fortitude Valley",
                        "latitude": "-27.45706000",
                        "longitude": "153.03178000"
                    },
                    {
                        "id": 5285,
                        "name": "Fraser Coast",
                        "latitude": "-25.34145000",
                        "longitude": "152.67024000"
                    },
                    {
                        "id": 5291,
                        "name": "Frenchville",
                        "latitude": "-23.34761000",
                        "longitude": "150.54450000"
                    },
                    {
                        "id": 5293,
                        "name": "Freshwater",
                        "latitude": "-16.88333000",
                        "longitude": "145.71667000"
                    },
                    {
                        "id": 5298,
                        "name": "Gailes",
                        "latitude": "-27.61133000",
                        "longitude": "152.91320000"
                    },
                    {
                        "id": 5302,
                        "name": "Garbutt",
                        "latitude": "-19.26602000",
                        "longitude": "146.78224000"
                    },
                    {
                        "id": 5308,
                        "name": "Gatton",
                        "latitude": "-27.55873000",
                        "longitude": "152.27618000"
                    },
                    {
                        "id": 5309,
                        "name": "Gaven",
                        "latitude": "-27.95651000",
                        "longitude": "153.33453000"
                    },
                    {
                        "id": 5313,
                        "name": "Gayndah",
                        "latitude": "-25.62522000",
                        "longitude": "151.61144000"
                    },
                    {
                        "id": 5314,
                        "name": "Gaythorne",
                        "latitude": "-27.41667000",
                        "longitude": "152.98333000"
                    },
                    {
                        "id": 5315,
                        "name": "Geebung",
                        "latitude": "-27.37246000",
                        "longitude": "153.04712000"
                    },
                    {
                        "id": 5337,
                        "name": "Gilston",
                        "latitude": "-28.03333000",
                        "longitude": "153.30000000"
                    },
                    {
                        "id": 5338,
                        "name": "Gin Gin",
                        "latitude": "-24.99363000",
                        "longitude": "151.95808000"
                    },
                    {
                        "id": 5347,
                        "name": "Gladstone",
                        "latitude": "-24.01869000",
                        "longitude": "151.65818000"
                    },
                    {
                        "id": 5348,
                        "name": "Gladstone Central",
                        "latitude": "-23.84281000",
                        "longitude": "151.24887000"
                    },
                    {
                        "id": 5352,
                        "name": "Glass House Mountains",
                        "latitude": "-26.89758000",
                        "longitude": "152.95319000"
                    },
                    {
                        "id": 5355,
                        "name": "Glen Eden",
                        "latitude": "-23.89738000",
                        "longitude": "151.27133000"
                    },
                    {
                        "id": 5370,
                        "name": "Gleneagle",
                        "latitude": "-27.93333000",
                        "longitude": "152.98333000"
                    },
                    {
                        "id": 5376,
                        "name": "Glenella",
                        "latitude": "-21.11768000",
                        "longitude": "149.14453000"
                    },
                    {
                        "id": 5391,
                        "name": "Glenvale",
                        "latitude": "-27.56818000",
                        "longitude": "151.89340000"
                    },
                    {
                        "id": 5392,
                        "name": "Glenview",
                        "latitude": "-26.76667000",
                        "longitude": "153.01667000"
                    },
                    {
                        "id": 5400,
                        "name": "Gold Coast",
                        "latitude": "-28.00029000",
                        "longitude": "153.43088000"
                    },
                    {
                        "id": 5402,
                        "name": "Golden Beach",
                        "latitude": "-26.82177000",
                        "longitude": "153.11972000"
                    },
                    {
                        "id": 5407,
                        "name": "Gooburrum",
                        "latitude": "-24.82312000",
                        "longitude": "152.33154000"
                    },
                    {
                        "id": 5408,
                        "name": "Goodna",
                        "latitude": "-27.61046000",
                        "longitude": "152.89896000"
                    },
                    {
                        "id": 5415,
                        "name": "Goondiwindi",
                        "latitude": "-28.46221000",
                        "longitude": "150.31345000"
                    },
                    {
                        "id": 5421,
                        "name": "Gordon Park",
                        "latitude": "-27.41899000",
                        "longitude": "153.02547000"
                    },
                    {
                        "id": 5422,
                        "name": "Gordonvale",
                        "latitude": "-17.09959000",
                        "longitude": "145.78038000"
                    },
                    {
                        "id": 5430,
                        "name": "Gowrie Junction",
                        "latitude": "-27.48333000",
                        "longitude": "151.88333000"
                    },
                    {
                        "id": 5432,
                        "name": "Gracemere",
                        "latitude": "-23.43792000",
                        "longitude": "150.45749000"
                    },
                    {
                        "id": 5433,
                        "name": "Graceville",
                        "latitude": "-27.52201000",
                        "longitude": "152.98222000"
                    },
                    {
                        "id": 5436,
                        "name": "Grange",
                        "latitude": "-27.42251000",
                        "longitude": "153.01527000"
                    },
                    {
                        "id": 5440,
                        "name": "Granville",
                        "latitude": "-25.54486000",
                        "longitude": "152.73346000"
                    },
                    {
                        "id": 5453,
                        "name": "Greenbank",
                        "latitude": "-27.71667000",
                        "longitude": "152.98333000"
                    },
                    {
                        "id": 5459,
                        "name": "Greenslopes",
                        "latitude": "-27.50815000",
                        "longitude": "153.04951000"
                    },
                    {
                        "id": 5470,
                        "name": "Griffin",
                        "latitude": "-27.27149000",
                        "longitude": "153.03942000"
                    },
                    {
                        "id": 5479,
                        "name": "Gulliver",
                        "latitude": "-19.28814000",
                        "longitude": "146.77691000"
                    },
                    {
                        "id": 5481,
                        "name": "Gumdale",
                        "latitude": "-27.49188000",
                        "longitude": "153.15315000"
                    },
                    {
                        "id": 5495,
                        "name": "Gympie",
                        "latitude": "-26.18979000",
                        "longitude": "152.66499000"
                    },
                    {
                        "id": 5496,
                        "name": "Gympie Regional Council",
                        "latitude": "-26.18881000",
                        "longitude": "152.65868000"
                    },
                    {
                        "id": 5513,
                        "name": "Hamilton",
                        "latitude": "-27.43896000",
                        "longitude": "153.06287000"
                    },
                    {
                        "id": 5526,
                        "name": "Harlaxton",
                        "latitude": "-27.53333000",
                        "longitude": "151.96667000"
                    },
                    {
                        "id": 5532,
                        "name": "Harristown",
                        "latitude": "-27.58333000",
                        "longitude": "151.93333000"
                    },
                    {
                        "id": 5536,
                        "name": "Hatton Vale",
                        "latitude": "-27.56667000",
                        "longitude": "152.46667000"
                    },
                    {
                        "id": 5546,
                        "name": "Hawthorne",
                        "latitude": "-27.46696000",
                        "longitude": "153.05779000"
                    },
                    {
                        "id": 5548,
                        "name": "Hay Point",
                        "latitude": "-21.29646000",
                        "longitude": "149.27368000"
                    },
                    {
                        "id": 5555,
                        "name": "Healy",
                        "latitude": "-20.74596000",
                        "longitude": "139.50010000"
                    },
                    {
                        "id": 5561,
                        "name": "Heathwood",
                        "latitude": "-27.63449000",
                        "longitude": "152.98814000"
                    },
                    {
                        "id": 5562,
                        "name": "Heatley",
                        "latitude": "-19.29035000",
                        "longitude": "146.75355000"
                    },
                    {
                        "id": 5572,
                        "name": "Helensvale",
                        "latitude": "-27.91828000",
                        "longitude": "153.33275000"
                    },
                    {
                        "id": 5573,
                        "name": "Helidon",
                        "latitude": "-27.55316000",
                        "longitude": "152.12398000"
                    },
                    {
                        "id": 5574,
                        "name": "Hemmant",
                        "latitude": "-27.44776000",
                        "longitude": "153.13174000"
                    },
                    {
                        "id": 5575,
                        "name": "Hendra",
                        "latitude": "-27.41775000",
                        "longitude": "153.07025000"
                    },
                    {
                        "id": 5583,
                        "name": "Heritage Park",
                        "latitude": "-27.68273000",
                        "longitude": "153.06082000"
                    },
                    {
                        "id": 5584,
                        "name": "Hermit Park",
                        "latitude": "-19.28741000",
                        "longitude": "146.80043000"
                    },
                    {
                        "id": 5587,
                        "name": "Herston",
                        "latitude": "-27.44453000",
                        "longitude": "153.01852000"
                    },
                    {
                        "id": 5588,
                        "name": "Hervey Bay",
                        "latitude": "-25.28762000",
                        "longitude": "152.76936000"
                    },
                    {
                        "id": 5596,
                        "name": "Highfields",
                        "latitude": "-27.46343000",
                        "longitude": "151.95386000"
                    },
                    {
                        "id": 5599,
                        "name": "Highgate Hill",
                        "latitude": "-27.48912000",
                        "longitude": "153.01878000"
                    },
                    {
                        "id": 5600,
                        "name": "Highland Park",
                        "latitude": "-28.01392000",
                        "longitude": "153.33312000"
                    },
                    {
                        "id": 5602,
                        "name": "Highvale",
                        "latitude": "-27.37227000",
                        "longitude": "152.80195000"
                    },
                    {
                        "id": 5608,
                        "name": "Hillcrest",
                        "latitude": "-27.66857000",
                        "longitude": "153.02614000"
                    },
                    {
                        "id": 5616,
                        "name": "Hinchinbrook",
                        "latitude": "-18.65840000",
                        "longitude": "146.12296000"
                    },
                    {
                        "id": 5626,
                        "name": "Hodgson Vale",
                        "latitude": "-27.66518000",
                        "longitude": "151.93251000"
                    },
                    {
                        "id": 5631,
                        "name": "Holland Park",
                        "latitude": "-27.51704000",
                        "longitude": "153.06744000"
                    },
                    {
                        "id": 5632,
                        "name": "Holland Park West",
                        "latitude": "-27.52625000",
                        "longitude": "153.06046000"
                    },
                    {
                        "id": 5633,
                        "name": "Holloways Beach",
                        "latitude": "-16.84209000",
                        "longitude": "145.73922000"
                    },
                    {
                        "id": 5634,
                        "name": "Hollywell",
                        "latitude": "-27.90076000",
                        "longitude": "153.39609000"
                    },
                    {
                        "id": 5636,
                        "name": "Holmview",
                        "latitude": "-27.71631000",
                        "longitude": "153.17045000"
                    },
                    {
                        "id": 5641,
                        "name": "Home Hill",
                        "latitude": "-19.65921000",
                        "longitude": "147.41232000"
                    },
                    {
                        "id": 5644,
                        "name": "Hope Island",
                        "latitude": "-27.87036000",
                        "longitude": "153.35164000"
                    },
                    {
                        "id": 5645,
                        "name": "Hope Vale",
                        "latitude": "-15.13588000",
                        "longitude": "145.19248000"
                    },
                    {
                        "id": 5657,
                        "name": "Howard",
                        "latitude": "-25.31934000",
                        "longitude": "152.55986000"
                    },
                    {
                        "id": 5662,
                        "name": "Hughenden",
                        "latitude": "-20.84399000",
                        "longitude": "144.20035000"
                    },
                    {
                        "id": 5679,
                        "name": "Hyde Park",
                        "latitude": "-19.27691000",
                        "longitude": "146.79653000"
                    },
                    {
                        "id": 5681,
                        "name": "Idalia",
                        "latitude": "-19.30682000",
                        "longitude": "146.81389000"
                    },
                    {
                        "id": 5685,
                        "name": "Inala",
                        "latitude": "-27.59715000",
                        "longitude": "152.97432000"
                    },
                    {
                        "id": 5688,
                        "name": "Indooroopilly",
                        "latitude": "-27.50302000",
                        "longitude": "152.97518000"
                    },
                    {
                        "id": 5689,
                        "name": "Ingham",
                        "latitude": "-18.64552000",
                        "longitude": "146.16248000"
                    },
                    {
                        "id": 5694,
                        "name": "Innes Park",
                        "latitude": "-24.86833000",
                        "longitude": "152.47992000"
                    },
                    {
                        "id": 5695,
                        "name": "Innisfail",
                        "latitude": "-17.52209000",
                        "longitude": "146.03102000"
                    },
                    {
                        "id": 5696,
                        "name": "Innisfail Estate",
                        "latitude": "-17.51830000",
                        "longitude": "146.04474000"
                    },
                    {
                        "id": 5702,
                        "name": "Ipswich",
                        "latitude": "-27.67790000",
                        "longitude": "152.66188000"
                    },
                    {
                        "id": 5706,
                        "name": "Isaac",
                        "latitude": "-22.24346000",
                        "longitude": "148.23672000"
                    },
                    {
                        "id": 5715,
                        "name": "Jacobs Well",
                        "latitude": "-27.77992000",
                        "longitude": "153.36153000"
                    },
                    {
                        "id": 5717,
                        "name": "Jamboree Heights",
                        "latitude": "-27.55634000",
                        "longitude": "152.93402000"
                    },
                    {
                        "id": 5722,
                        "name": "Jandowae",
                        "latitude": "-26.78411000",
                        "longitude": "151.11240000"
                    },
                    {
                        "id": 5726,
                        "name": "Jensen",
                        "latitude": "-19.24570000",
                        "longitude": "146.65289000"
                    },
                    {
                        "id": 5733,
                        "name": "Jimboomba",
                        "latitude": "-27.83118000",
                        "longitude": "153.02737000"
                    },
                    {
                        "id": 5736,
                        "name": "Jindalee",
                        "latitude": "-27.53446000",
                        "longitude": "152.93843000"
                    },
                    {
                        "id": 5745,
                        "name": "Joyner",
                        "latitude": "-27.27613000",
                        "longitude": "152.94471000"
                    },
                    {
                        "id": 5746,
                        "name": "Jubilee Pocket",
                        "latitude": "-20.28809000",
                        "longitude": "148.72938000"
                    },
                    {
                        "id": 5747,
                        "name": "Julatten",
                        "latitude": "-16.60720000",
                        "longitude": "145.34118000"
                    },
                    {
                        "id": 5756,
                        "name": "Kalbar",
                        "latitude": "-27.94169000",
                        "longitude": "152.62372000"
                    },
                    {
                        "id": 5762,
                        "name": "Kalinga",
                        "latitude": "-27.40957000",
                        "longitude": "153.05061000"
                    },
                    {
                        "id": 5763,
                        "name": "Kalkie",
                        "latitude": "-24.84426000",
                        "longitude": "152.38532000"
                    },
                    {
                        "id": 5764,
                        "name": "Kallangur",
                        "latitude": "-27.25204000",
                        "longitude": "152.99226000"
                    },
                    {
                        "id": 5771,
                        "name": "Kamerunga",
                        "latitude": "-16.87321000",
                        "longitude": "145.70130000"
                    },
                    {
                        "id": 5777,
                        "name": "Kangaroo Point",
                        "latitude": "-27.47679000",
                        "longitude": "153.03670000"
                    },
                    {
                        "id": 5778,
                        "name": "Kanimbla",
                        "latitude": "-16.92307000",
                        "longitude": "145.72158000"
                    },
                    {
                        "id": 5783,
                        "name": "Karalee",
                        "latitude": "-27.56485000",
                        "longitude": "152.82446000"
                    },
                    {
                        "id": 5785,
                        "name": "Karana Downs",
                        "latitude": "-27.54857000",
                        "longitude": "152.80728000"
                    },
                    {
                        "id": 5795,
                        "name": "Karumba",
                        "latitude": "-17.48691000",
                        "longitude": "140.84262000"
                    },
                    {
                        "id": 5801,
                        "name": "Kawana",
                        "latitude": "-23.33933000",
                        "longitude": "150.50493000"
                    },
                    {
                        "id": 5802,
                        "name": "Kawungan",
                        "latitude": "-25.29879000",
                        "longitude": "152.84600000"
                    },
                    {
                        "id": 5804,
                        "name": "Kearneys Spring",
                        "latitude": "-27.60495000",
                        "longitude": "151.94098000"
                    },
                    {
                        "id": 5806,
                        "name": "Kedron",
                        "latitude": "-27.40286000",
                        "longitude": "153.02969000"
                    },
                    {
                        "id": 5819,
                        "name": "Kelso",
                        "latitude": "-19.38932000",
                        "longitude": "146.71912000"
                    },
                    {
                        "id": 5820,
                        "name": "Kelvin Grove",
                        "latitude": "-27.44819000",
                        "longitude": "153.01337000"
                    },
                    {
                        "id": 5824,
                        "name": "Kenmore",
                        "latitude": "-27.50759000",
                        "longitude": "152.93879000"
                    },
                    {
                        "id": 5825,
                        "name": "Kenmore Hills",
                        "latitude": "-27.50420000",
                        "longitude": "152.93183000"
                    },
                    {
                        "id": 5830,
                        "name": "Kensington Grove",
                        "latitude": "-27.53278000",
                        "longitude": "152.47205000"
                    },
                    {
                        "id": 5837,
                        "name": "Keperra",
                        "latitude": "-27.41376000",
                        "longitude": "152.94703000"
                    },
                    {
                        "id": 5838,
                        "name": "Kepnock",
                        "latitude": "-24.87606000",
                        "longitude": "152.37518000"
                    },
                    {
                        "id": 5844,
                        "name": "Kewarra Beach",
                        "latitude": "-16.78219000",
                        "longitude": "145.68455000"
                    },
                    {
                        "id": 5854,
                        "name": "Kilcoy",
                        "latitude": "-26.94300000",
                        "longitude": "152.56545000"
                    },
                    {
                        "id": 5863,
                        "name": "Kin Kora",
                        "latitude": "-23.87705000",
                        "longitude": "151.24722000"
                    },
                    {
                        "id": 5866,
                        "name": "Kingaroy",
                        "latitude": "-26.53994000",
                        "longitude": "151.83730000"
                    },
                    {
                        "id": 5870,
                        "name": "Kings Beach",
                        "latitude": "-26.80166000",
                        "longitude": "153.14261000"
                    },
                    {
                        "id": 5881,
                        "name": "Kingsthorpe",
                        "latitude": "-27.47558000",
                        "longitude": "151.81409000"
                    },
                    {
                        "id": 5885,
                        "name": "Kingston",
                        "latitude": "-27.66667000",
                        "longitude": "153.11667000"
                    },
                    {
                        "id": 5892,
                        "name": "Kippa-Ring",
                        "latitude": "-27.22586000",
                        "longitude": "153.08350000"
                    },
                    {
                        "id": 5893,
                        "name": "Kirkwood",
                        "latitude": "-23.90327000",
                        "longitude": "151.23545000"
                    },
                    {
                        "id": 5896,
                        "name": "Kirwan",
                        "latitude": "-19.30323000",
                        "longitude": "146.72531000"
                    },
                    {
                        "id": 5897,
                        "name": "Kleinton",
                        "latitude": "-27.43333000",
                        "longitude": "151.95000000"
                    },
                    {
                        "id": 5908,
                        "name": "Koongal",
                        "latitude": "-23.36887000",
                        "longitude": "150.54917000"
                    },
                    {
                        "id": 5909,
                        "name": "Kooralbyn",
                        "latitude": "-28.07955000",
                        "longitude": "152.83974000"
                    },
                    {
                        "id": 5919,
                        "name": "Kowanyama",
                        "latitude": "-15.27882000",
                        "longitude": "141.81287000"
                    },
                    {
                        "id": 5922,
                        "name": "Kuluin",
                        "latitude": "-26.65779000",
                        "longitude": "153.05608000"
                    },
                    {
                        "id": 5924,
                        "name": "Kuraby",
                        "latitude": "-27.60683000",
                        "longitude": "153.09367000"
                    },
                    {
                        "id": 5925,
                        "name": "Kuranda",
                        "latitude": "-16.81978000",
                        "longitude": "145.63818000"
                    },
                    {
                        "id": 5932,
                        "name": "Kurwongbah",
                        "latitude": "-27.23250000",
                        "longitude": "152.97621000"
                    },
                    {
                        "id": 5938,
                        "name": "Labrador",
                        "latitude": "-27.94402000",
                        "longitude": "153.39815000"
                    },
                    {
                        "id": 5940,
                        "name": "Laidley",
                        "latitude": "-27.63278000",
                        "longitude": "152.39285000"
                    },
                    {
                        "id": 5949,
                        "name": "Lake Macdonald",
                        "latitude": "-26.38482000",
                        "longitude": "152.93213000"
                    },
                    {
                        "id": 5962,
                        "name": "Lammermoor",
                        "latitude": "-23.16076000",
                        "longitude": "150.76079000"
                    },
                    {
                        "id": 5964,
                        "name": "Landsborough",
                        "latitude": "-26.80666000",
                        "longitude": "152.96095000"
                    },
                    {
                        "id": 5991,
                        "name": "Lawnton",
                        "latitude": "-27.28333000",
                        "longitude": "152.98333000"
                    },
                    {
                        "id": 6001,
                        "name": "Leichhardt",
                        "latitude": "-27.62279000",
                        "longitude": "152.73373000"
                    },
                    {
                        "id": 6038,
                        "name": "Little Mountain",
                        "latitude": "-26.78436000",
                        "longitude": "153.09218000"
                    },
                    {
                        "id": 6046,
                        "name": "Lockhart River",
                        "latitude": "-13.01876000",
                        "longitude": "143.25024000"
                    },
                    {
                        "id": 6050,
                        "name": "Lockyer Valley",
                        "latitude": "-27.68139000",
                        "longitude": "152.23036000"
                    },
                    {
                        "id": 6053,
                        "name": "Logan",
                        "latitude": "-27.76294000",
                        "longitude": "153.04492000"
                    },
                    {
                        "id": 6054,
                        "name": "Logan Central",
                        "latitude": "-27.64385000",
                        "longitude": "153.10725000"
                    },
                    {
                        "id": 6055,
                        "name": "Logan City",
                        "latitude": "-27.63917000",
                        "longitude": "153.10944000"
                    },
                    {
                        "id": 6056,
                        "name": "Logan Reserve",
                        "latitude": "-27.72414000",
                        "longitude": "153.09002000"
                    },
                    {
                        "id": 6057,
                        "name": "Logan Village",
                        "latitude": "-27.76832000",
                        "longitude": "153.10762000"
                    },
                    {
                        "id": 6058,
                        "name": "Loganholme",
                        "latitude": "-27.68444000",
                        "longitude": "153.18640000"
                    },
                    {
                        "id": 6059,
                        "name": "Loganlea",
                        "latitude": "-27.67535000",
                        "longitude": "153.13472000"
                    },
                    {
                        "id": 6066,
                        "name": "Longreach",
                        "latitude": "-23.87600000",
                        "longitude": "143.86708000"
                    },
                    {
                        "id": 6071,
                        "name": "Lota",
                        "latitude": "-27.46923000",
                        "longitude": "153.18580000"
                    },
                    {
                        "id": 6073,
                        "name": "Lower Beechmont",
                        "latitude": "-28.04751000",
                        "longitude": "153.24572000"
                    },
                    {
                        "id": 6079,
                        "name": "Lowood",
                        "latitude": "-27.46555000",
                        "longitude": "152.57625000"
                    },
                    {
                        "id": 6088,
                        "name": "Lutwyche",
                        "latitude": "-27.42275000",
                        "longitude": "153.03354000"
                    },
                    {
                        "id": 6101,
                        "name": "Macgregor",
                        "latitude": "-27.56490000",
                        "longitude": "153.06650000"
                    },
                    {
                        "id": 6103,
                        "name": "Machans Beach",
                        "latitude": "-16.85849000",
                        "longitude": "145.74468000"
                    },
                    {
                        "id": 6104,
                        "name": "Mackay",
                        "latitude": "-21.08189000",
                        "longitude": "149.04265000"
                    },
                    {
                        "id": 6105,
                        "name": "Mackay City",
                        "latitude": "-21.14463000",
                        "longitude": "149.18678000"
                    },
                    {
                        "id": 6106,
                        "name": "Mackenzie",
                        "latitude": "-27.54351000",
                        "longitude": "153.12057000"
                    },
                    {
                        "id": 6109,
                        "name": "Macleay Island",
                        "latitude": "-27.61089000",
                        "longitude": "153.35996000"
                    },
                    {
                        "id": 6123,
                        "name": "Magnetic Island",
                        "latitude": "-19.15514000",
                        "longitude": "146.84850000"
                    },
                    {
                        "id": 6127,
                        "name": "Main Beach",
                        "latitude": "-27.97879000",
                        "longitude": "153.42660000"
                    },
                    {
                        "id": 6134,
                        "name": "Malanda",
                        "latitude": "-17.35228000",
                        "longitude": "145.59528000"
                    },
                    {
                        "id": 6136,
                        "name": "Maleny",
                        "latitude": "-26.76001000",
                        "longitude": "152.84926000"
                    },
                    {
                        "id": 6146,
                        "name": "Mango Hill",
                        "latitude": "-27.24349000",
                        "longitude": "153.02384000"
                    },
                    {
                        "id": 6153,
                        "name": "Manly West",
                        "latitude": "-27.47382000",
                        "longitude": "153.16641000"
                    },
                    {
                        "id": 6159,
                        "name": "Manoora",
                        "latitude": "-16.91706000",
                        "longitude": "145.73665000"
                    },
                    {
                        "id": 6160,
                        "name": "Mansfield",
                        "latitude": "-27.53929000",
                        "longitude": "153.09895000"
                    },
                    {
                        "id": 6163,
                        "name": "Manunda",
                        "latitude": "-16.91721000",
                        "longitude": "145.74920000"
                    },
                    {
                        "id": 6164,
                        "name": "Mapleton",
                        "latitude": "-26.62431000",
                        "longitude": "152.86784000"
                    },
                    {
                        "id": 6165,
                        "name": "Mapoon",
                        "latitude": "-12.10960000",
                        "longitude": "141.90216000"
                    },
                    {
                        "id": 6168,
                        "name": "Maranoa",
                        "latitude": "-26.39289000",
                        "longitude": "148.43098000"
                    },
                    {
                        "id": 6172,
                        "name": "Marcoola",
                        "latitude": "-26.58450000",
                        "longitude": "153.09465000"
                    },
                    {
                        "id": 6175,
                        "name": "Mareeba",
                        "latitude": "-16.99096000",
                        "longitude": "145.42306000"
                    },
                    {
                        "id": 6178,
                        "name": "Margate",
                        "latitude": "-27.24761000",
                        "longitude": "153.09809000"
                    },
                    {
                        "id": 6179,
                        "name": "Marian",
                        "latitude": "-21.14386000",
                        "longitude": "148.94209000"
                    },
                    {
                        "id": 6187,
                        "name": "Maroochy River",
                        "latitude": "-26.57767000",
                        "longitude": "153.01884000"
                    },
                    {
                        "id": 6188,
                        "name": "Maroochydore",
                        "latitude": "-26.66008000",
                        "longitude": "153.09953000"
                    },
                    {
                        "id": 6193,
                        "name": "Marsden",
                        "latitude": "-27.67342000",
                        "longitude": "153.09732000"
                    },
                    {
                        "id": 6198,
                        "name": "Maryborough",
                        "latitude": "-25.54073000",
                        "longitude": "152.70493000"
                    },
                    {
                        "id": 6204,
                        "name": "Maudsland",
                        "latitude": "-27.95000000",
                        "longitude": "153.26667000"
                    },
                    {
                        "id": 6215,
                        "name": "McDowall",
                        "latitude": "-27.38266000",
                        "longitude": "152.99194000"
                    },
                    {
                        "id": 6219,
                        "name": "McKinlay",
                        "latitude": "-20.59413000",
                        "longitude": "141.67448000"
                    },
                    {
                        "id": 6227,
                        "name": "Meadowbrook",
                        "latitude": "-27.66401000",
                        "longitude": "153.14465000"
                    },
                    {
                        "id": 6249,
                        "name": "Menzies",
                        "latitude": "-20.71809000",
                        "longitude": "139.49717000"
                    },
                    {
                        "id": 6253,
                        "name": "Meridan Plains",
                        "latitude": "-26.77351000",
                        "longitude": "153.06187000"
                    },
                    {
                        "id": 6255,
                        "name": "Meringandan West",
                        "latitude": "-27.41612000",
                        "longitude": "151.88727000"
                    },
                    {
                        "id": 6256,
                        "name": "Mermaid Beach",
                        "latitude": "-28.04411000",
                        "longitude": "153.43472000"
                    },
                    {
                        "id": 6257,
                        "name": "Mermaid Waters",
                        "latitude": "-28.04912000",
                        "longitude": "153.43081000"
                    },
                    {
                        "id": 6260,
                        "name": "Merrimac",
                        "latitude": "-28.05085000",
                        "longitude": "153.37307000"
                    },
                    {
                        "id": 6267,
                        "name": "Miami",
                        "latitude": "-28.07173000",
                        "longitude": "153.44158000"
                    },
                    {
                        "id": 6274,
                        "name": "Middle Park",
                        "latitude": "-27.55596000",
                        "longitude": "152.92223000"
                    },
                    {
                        "id": 6275,
                        "name": "Middle Ridge",
                        "latitude": "-27.60709000",
                        "longitude": "151.96688000"
                    },
                    {
                        "id": 6277,
                        "name": "Middlemount",
                        "latitude": "-22.81226000",
                        "longitude": "148.69926000"
                    },
                    {
                        "id": 6286,
                        "name": "Miles",
                        "latitude": "-26.65836000",
                        "longitude": "150.18822000"
                    },
                    {
                        "id": 6290,
                        "name": "Millbank",
                        "latitude": "-24.87536000",
                        "longitude": "152.32217000"
                    },
                    {
                        "id": 6296,
                        "name": "Millmerran",
                        "latitude": "-27.87913000",
                        "longitude": "151.27058000"
                    },
                    {
                        "id": 6298,
                        "name": "Millstream",
                        "latitude": "-17.65318000",
                        "longitude": "145.41401000"
                    },
                    {
                        "id": 6304,
                        "name": "Milton",
                        "latitude": "-27.47039000",
                        "longitude": "153.00312000"
                    },
                    {
                        "id": 6307,
                        "name": "Minden",
                        "latitude": "-27.55965000",
                        "longitude": "152.54493000"
                    },
                    {
                        "id": 6312,
                        "name": "Minyama",
                        "latitude": "-26.69573000",
                        "longitude": "153.12353000"
                    },
                    {
                        "id": 6315,
                        "name": "Mirani",
                        "latitude": "-21.15729000",
                        "longitude": "148.86217000"
                    },
                    {
                        "id": 6318,
                        "name": "Mission Beach",
                        "latitude": "-17.86885000",
                        "longitude": "146.10392000"
                    },
                    {
                        "id": 6319,
                        "name": "Mission River",
                        "latitude": "-12.59509000",
                        "longitude": "141.95760000"
                    },
                    {
                        "id": 6323,
                        "name": "Mitchell",
                        "latitude": "-26.48490000",
                        "longitude": "147.97420000"
                    },
                    {
                        "id": 6326,
                        "name": "Mitchelton",
                        "latitude": "-27.41667000",
                        "longitude": "152.96667000"
                    },
                    {
                        "id": 6334,
                        "name": "Moffat Beach",
                        "latitude": "-26.79048000",
                        "longitude": "153.13997000"
                    },
                    {
                        "id": 6335,
                        "name": "Moggill",
                        "latitude": "-27.58333000",
                        "longitude": "152.86667000"
                    },
                    {
                        "id": 6338,
                        "name": "Molendinar",
                        "latitude": "-27.97409000",
                        "longitude": "153.36069000"
                    },
                    {
                        "id": 6347,
                        "name": "Monkland",
                        "latitude": "-26.21191000",
                        "longitude": "152.68245000"
                    },
                    {
                        "id": 6353,
                        "name": "Monto",
                        "latitude": "-24.86477000",
                        "longitude": "151.12199000"
                    },
                    {
                        "id": 6356,
                        "name": "Montville",
                        "latitude": "-26.68333000",
                        "longitude": "152.88333000"
                    },
                    {
                        "id": 6358,
                        "name": "Mooloolaba",
                        "latitude": "-26.68164000",
                        "longitude": "153.11925000"
                    },
                    {
                        "id": 6369,
                        "name": "Moore Park Beach",
                        "latitude": "-24.71066000",
                        "longitude": "152.20905000"
                    },
                    {
                        "id": 6371,
                        "name": "Mooroobool",
                        "latitude": "-16.93489000",
                        "longitude": "145.73137000"
                    },
                    {
                        "id": 6373,
                        "name": "Moorooka",
                        "latitude": "-27.53436000",
                        "longitude": "153.02460000"
                    },
                    {
                        "id": 6376,
                        "name": "Moranbah",
                        "latitude": "-22.00163000",
                        "longitude": "148.04661000"
                    },
                    {
                        "id": 6378,
                        "name": "Morayfield",
                        "latitude": "-27.10876000",
                        "longitude": "152.94907000"
                    },
                    {
                        "id": 6383,
                        "name": "Moreton Bay",
                        "latitude": "-27.10731000",
                        "longitude": "152.92937000"
                    },
                    {
                        "id": 6386,
                        "name": "Morningside",
                        "latitude": "-27.46165000",
                        "longitude": "153.07511000"
                    },
                    {
                        "id": 6388,
                        "name": "Mornington",
                        "latitude": "-16.68436000",
                        "longitude": "139.46682000"
                    },
                    {
                        "id": 6402,
                        "name": "Mossman",
                        "latitude": "-16.46292000",
                        "longitude": "145.37144000"
                    },
                    {
                        "id": 6414,
                        "name": "Mount Coolum",
                        "latitude": "-26.56581000",
                        "longitude": "153.09139000"
                    },
                    {
                        "id": 6415,
                        "name": "Mount Cotton",
                        "latitude": "-27.63333000",
                        "longitude": "153.23333000"
                    },
                    {
                        "id": 6416,
                        "name": "Mount Crosby",
                        "latitude": "-27.53948000",
                        "longitude": "152.80583000"
                    },
                    {
                        "id": 6423,
                        "name": "Mount Gravatt",
                        "latitude": "-27.53333000",
                        "longitude": "153.08333000"
                    },
                    {
                        "id": 6424,
                        "name": "Mount Gravatt East",
                        "latitude": "-27.54050000",
                        "longitude": "153.08221000"
                    },
                    {
                        "id": 6429,
                        "name": "Mount Isa",
                        "latitude": "-20.72523000",
                        "longitude": "139.49727000"
                    },
                    {
                        "id": 6435,
                        "name": "Mount Lofty",
                        "latitude": "-27.54628000",
                        "longitude": "151.97218000"
                    },
                    {
                        "id": 6436,
                        "name": "Mount Louisa",
                        "latitude": "-19.27400000",
                        "longitude": "146.75091000"
                    },
                    {
                        "id": 6437,
                        "name": "Mount Low",
                        "latitude": "-19.23209000",
                        "longitude": "146.66951000"
                    },
                    {
                        "id": 6443,
                        "name": "Mount Morgan",
                        "latitude": "-23.64532000",
                        "longitude": "150.38902000"
                    },
                    {
                        "id": 6445,
                        "name": "Mount Nathan",
                        "latitude": "-27.96430000",
                        "longitude": "153.27198000"
                    },
                    {
                        "id": 6447,
                        "name": "Mount Ommaney",
                        "latitude": "-27.54609000",
                        "longitude": "152.93219000"
                    },
                    {
                        "id": 6451,
                        "name": "Mount Pleasant",
                        "latitude": "-21.11814000",
                        "longitude": "149.15965000"
                    },
                    {
                        "id": 6458,
                        "name": "Mount Sheridan",
                        "latitude": "-16.98608000",
                        "longitude": "145.73244000"
                    },
                    {
                        "id": 6462,
                        "name": "Mount Warren Park",
                        "latitude": "-27.73109000",
                        "longitude": "153.20549000"
                    },
                    {
                        "id": 6465,
                        "name": "Mountain Creek",
                        "latitude": "-26.70278000",
                        "longitude": "153.10133000"
                    },
                    {
                        "id": 6466,
                        "name": "Moura",
                        "latitude": "-24.57220000",
                        "longitude": "149.96729000"
                    },
                    {
                        "id": 6470,
                        "name": "Mudgeeraba",
                        "latitude": "-28.08333000",
                        "longitude": "153.36667000"
                    },
                    {
                        "id": 6471,
                        "name": "Mudjimba",
                        "latitude": "-26.61497000",
                        "longitude": "153.09890000"
                    },
                    {
                        "id": 6474,
                        "name": "Mulambin",
                        "latitude": "-23.18755000",
                        "longitude": "150.78933000"
                    },
                    {
                        "id": 6482,
                        "name": "Mundingburra",
                        "latitude": "-19.29851000",
                        "longitude": "146.79352000"
                    },
                    {
                        "id": 6483,
                        "name": "Mundoolun",
                        "latitude": "-27.89940000",
                        "longitude": "153.07150000"
                    },
                    {
                        "id": 6484,
                        "name": "Mundubbera",
                        "latitude": "-25.59266000",
                        "longitude": "151.30225000"
                    },
                    {
                        "id": 6487,
                        "name": "Munruben",
                        "latitude": "-27.74635000",
                        "longitude": "153.03119000"
                    },
                    {
                        "id": 6489,
                        "name": "Murarrie",
                        "latitude": "-27.46289000",
                        "longitude": "153.09809000"
                    },
                    {
                        "id": 6492,
                        "name": "Murgon",
                        "latitude": "-26.24170000",
                        "longitude": "151.94047000"
                    },
                    {
                        "id": 6494,
                        "name": "Murray",
                        "latitude": "-19.31803000",
                        "longitude": "146.79494000"
                    },
                    {
                        "id": 6497,
                        "name": "Murrumba Downs",
                        "latitude": "-27.26733000",
                        "longitude": "153.01053000"
                    },
                    {
                        "id": 6501,
                        "name": "Murweh",
                        "latitude": "-26.13609000",
                        "longitude": "146.60410000"
                    },
                    {
                        "id": 6513,
                        "name": "Nambour",
                        "latitude": "-26.62613000",
                        "longitude": "152.95941000"
                    },
                    {
                        "id": 6518,
                        "name": "Nanango",
                        "latitude": "-26.67157000",
                        "longitude": "152.00211000"
                    },
                    {
                        "id": 6520,
                        "name": "Nanum",
                        "latitude": "-12.64511000",
                        "longitude": "141.86221000"
                    },
                    {
                        "id": 6521,
                        "name": "Napranum",
                        "latitude": "-12.55322000",
                        "longitude": "142.06558000"
                    },
                    {
                        "id": 6524,
                        "name": "Narangba",
                        "latitude": "-27.20338000",
                        "longitude": "152.95923000"
                    },
                    {
                        "id": 6544,
                        "name": "Nathan",
                        "latitude": "-27.55888000",
                        "longitude": "153.06230000"
                    },
                    {
                        "id": 6545,
                        "name": "Nebo",
                        "latitude": "-21.68333000",
                        "longitude": "148.68333000"
                    },
                    {
                        "id": 6548,
                        "name": "Nelly Bay",
                        "latitude": "-19.15775000",
                        "longitude": "146.84977000"
                    },
                    {
                        "id": 6550,
                        "name": "Nerang",
                        "latitude": "-27.98941000",
                        "longitude": "153.33633000"
                    },
                    {
                        "id": 6554,
                        "name": "New Auckland",
                        "latitude": "-23.88359000",
                        "longitude": "151.23563000"
                    },
                    {
                        "id": 6555,
                        "name": "New Beith",
                        "latitude": "-27.79359000",
                        "longitude": "152.88443000"
                    },
                    {
                        "id": 6556,
                        "name": "New Farm",
                        "latitude": "-27.46777000",
                        "longitude": "153.04834000"
                    },
                    {
                        "id": 6570,
                        "name": "Newmarket",
                        "latitude": "-27.43534000",
                        "longitude": "153.00781000"
                    },
                    {
                        "id": 6574,
                        "name": "Newport",
                        "latitude": "-27.20731000",
                        "longitude": "153.10135000"
                    },
                    {
                        "id": 6576,
                        "name": "Newstead",
                        "latitude": "-27.45314000",
                        "longitude": "153.04183000"
                    },
                    {
                        "id": 6579,
                        "name": "Newtown",
                        "latitude": "-27.55602000",
                        "longitude": "151.93255000"
                    },
                    {
                        "id": 6595,
                        "name": "Ninderry",
                        "latitude": "-26.54094000",
                        "longitude": "152.97520000"
                    },
                    {
                        "id": 6596,
                        "name": "Ningi",
                        "latitude": "-27.06108000",
                        "longitude": "153.07883000"
                    },
                    {
                        "id": 6601,
                        "name": "Nome",
                        "latitude": "-19.36245000",
                        "longitude": "146.94672000"
                    },
                    {
                        "id": 6602,
                        "name": "Noosa Heads",
                        "latitude": "-26.39433000",
                        "longitude": "153.09010000"
                    },
                    {
                        "id": 6603,
                        "name": "Noosaville",
                        "latitude": "-26.40000000",
                        "longitude": "153.06667000"
                    },
                    {
                        "id": 6607,
                        "name": "Norman Gardens",
                        "latitude": "-23.33044000",
                        "longitude": "150.52747000"
                    },
                    {
                        "id": 6608,
                        "name": "Norman Park",
                        "latitude": "-27.47916000",
                        "longitude": "153.06250000"
                    },
                    {
                        "id": 6610,
                        "name": "Normanton",
                        "latitude": "-17.67183000",
                        "longitude": "141.07721000"
                    },
                    {
                        "id": 6620,
                        "name": "North Booval",
                        "latitude": "-27.60392000",
                        "longitude": "152.79485000"
                    },
                    {
                        "id": 6623,
                        "name": "North Burnett",
                        "latitude": "-25.24444000",
                        "longitude": "151.32301000"
                    },
                    {
                        "id": 6633,
                        "name": "North Ipswich",
                        "latitude": "-27.60286000",
                        "longitude": "152.76146000"
                    },
                    {
                        "id": 6635,
                        "name": "North Lakes",
                        "latitude": "-27.22426000",
                        "longitude": "153.02075000"
                    },
                    {
                        "id": 6637,
                        "name": "North Mackay",
                        "latitude": "-21.12009000",
                        "longitude": "149.17941000"
                    },
                    {
                        "id": 6638,
                        "name": "North Maclean",
                        "latitude": "-27.76759000",
                        "longitude": "153.01646000"
                    },
                    {
                        "id": 6653,
                        "name": "North Toowoomba",
                        "latitude": "-27.54415000",
                        "longitude": "151.96117000"
                    },
                    {
                        "id": 6656,
                        "name": "North Ward",
                        "latitude": "-19.24994000",
                        "longitude": "146.81477000"
                    },
                    {
                        "id": 6669,
                        "name": "Northern Peninsula Area",
                        "latitude": "-10.97190000",
                        "longitude": "142.35364000"
                    },
                    {
                        "id": 6673,
                        "name": "Norville",
                        "latitude": "-24.89310000",
                        "longitude": "152.34089000"
                    },
                    {
                        "id": 6681,
                        "name": "Nudgee",
                        "latitude": "-27.36910000",
                        "longitude": "153.08470000"
                    },
                    {
                        "id": 6686,
                        "name": "Nundah",
                        "latitude": "-27.40252000",
                        "longitude": "153.06165000"
                    },
                    {
                        "id": 6698,
                        "name": "Oakey",
                        "latitude": "-27.43305000",
                        "longitude": "151.72063000"
                    },
                    {
                        "id": 6700,
                        "name": "Oakhurst",
                        "latitude": "-25.51253000",
                        "longitude": "152.63583000"
                    },
                    {
                        "id": 6722,
                        "name": "One Mile",
                        "latitude": "-27.62902000",
                        "longitude": "152.73768000"
                    },
                    {
                        "id": 6727,
                        "name": "Oonoonba",
                        "latitude": "-19.29684000",
                        "longitude": "146.82091000"
                    },
                    {
                        "id": 6728,
                        "name": "Ooralea",
                        "latitude": "-21.17394000",
                        "longitude": "149.14797000"
                    },
                    {
                        "id": 6737,
                        "name": "Ormeau",
                        "latitude": "-27.76791000",
                        "longitude": "153.24280000"
                    },
                    {
                        "id": 6738,
                        "name": "Ormeau Hills",
                        "latitude": "-27.79653000",
                        "longitude": "153.25670000"
                    },
                    {
                        "id": 6739,
                        "name": "Ormiston",
                        "latitude": "-27.51667000",
                        "longitude": "153.25000000"
                    },
                    {
                        "id": 6747,
                        "name": "Oxenford",
                        "latitude": "-27.89033000",
                        "longitude": "153.31309000"
                    },
                    {
                        "id": 6748,
                        "name": "Oxley",
                        "latitude": "-27.55000000",
                        "longitude": "152.98333000"
                    },
                    {
                        "id": 6754,
                        "name": "Pacific Paradise",
                        "latitude": "-26.61807000",
                        "longitude": "153.07781000"
                    },
                    {
                        "id": 6755,
                        "name": "Pacific Pines",
                        "latitude": "-27.93994000",
                        "longitude": "153.31436000"
                    },
                    {
                        "id": 6758,
                        "name": "Paddington",
                        "latitude": "-27.45939000",
                        "longitude": "152.99509000"
                    },
                    {
                        "id": 6765,
                        "name": "Palm Beach",
                        "latitude": "-28.11694000",
                        "longitude": "153.46584000"
                    },
                    {
                        "id": 6767,
                        "name": "Palm Cove",
                        "latitude": "-16.75000000",
                        "longitude": "145.66667000"
                    },
                    {
                        "id": 6768,
                        "name": "Palm Island",
                        "latitude": "-18.74893000",
                        "longitude": "146.60379000"
                    },
                    {
                        "id": 6771,
                        "name": "Palmwoods",
                        "latitude": "-26.68584000",
                        "longitude": "152.96135000"
                    },
                    {
                        "id": 6781,
                        "name": "Paradise Point",
                        "latitude": "-27.88663000",
                        "longitude": "153.39330000"
                    },
                    {
                        "id": 6786,
                        "name": "Park Avenue",
                        "latitude": "-23.35327000",
                        "longitude": "150.51890000"
                    },
                    {
                        "id": 6790,
                        "name": "Park Ridge",
                        "latitude": "-27.71667000",
                        "longitude": "153.03333000"
                    },
                    {
                        "id": 6791,
                        "name": "Park Ridge South",
                        "latitude": "-27.72707000",
                        "longitude": "153.03320000"
                    },
                    {
                        "id": 6795,
                        "name": "Parkhurst",
                        "latitude": "-23.30000000",
                        "longitude": "150.51667000"
                    },
                    {
                        "id": 6796,
                        "name": "Parkinson",
                        "latitude": "-27.64340000",
                        "longitude": "153.02975000"
                    },
                    {
                        "id": 6798,
                        "name": "Parkside",
                        "latitude": "-20.73770000",
                        "longitude": "139.48865000"
                    },
                    {
                        "id": 6801,
                        "name": "Parkwood",
                        "latitude": "-27.95461000",
                        "longitude": "153.36304000"
                    },
                    {
                        "id": 6804,
                        "name": "Paroo",
                        "latitude": "-27.98742000",
                        "longitude": "145.71755000"
                    },
                    {
                        "id": 6806,
                        "name": "Parramatta Park",
                        "latitude": "-16.92598000",
                        "longitude": "145.76643000"
                    },
                    {
                        "id": 6807,
                        "name": "Parrearra",
                        "latitude": "-26.71152000",
                        "longitude": "153.12197000"
                    },
                    {
                        "id": 6815,
                        "name": "Peachester",
                        "latitude": "-26.84551000",
                        "longitude": "152.88400000"
                    },
                    {
                        "id": 6824,
                        "name": "Pelican Waters",
                        "latitude": "-26.83354000",
                        "longitude": "153.10013000"
                    },
                    {
                        "id": 6836,
                        "name": "Peregian Beach",
                        "latitude": "-26.48100000",
                        "longitude": "153.09600000"
                    },
                    {
                        "id": 6837,
                        "name": "Peregian Springs",
                        "latitude": "-26.48801000",
                        "longitude": "153.07577000"
                    },
                    {
                        "id": 6845,
                        "name": "Petrie",
                        "latitude": "-27.26667000",
                        "longitude": "152.98333000"
                    },
                    {
                        "id": 6846,
                        "name": "Petrie Terrace",
                        "latitude": "-27.46298000",
                        "longitude": "153.01312000"
                    },
                    {
                        "id": 6850,
                        "name": "Pialba",
                        "latitude": "-25.28700000",
                        "longitude": "152.84369000"
                    },
                    {
                        "id": 6855,
                        "name": "Pie Creek",
                        "latitude": "-26.22991000",
                        "longitude": "152.60774000"
                    },
                    {
                        "id": 6856,
                        "name": "Pimlico",
                        "latitude": "-19.28172000",
                        "longitude": "146.78803000"
                    },
                    {
                        "id": 6857,
                        "name": "Pimpama",
                        "latitude": "-27.81667000",
                        "longitude": "153.30000000"
                    },
                    {
                        "id": 6858,
                        "name": "Pine Mountain",
                        "latitude": "-27.55000000",
                        "longitude": "152.70000000"
                    },
                    {
                        "id": 6861,
                        "name": "Pioneer",
                        "latitude": "-20.72032000",
                        "longitude": "139.50812000"
                    },
                    {
                        "id": 6863,
                        "name": "Pittsworth",
                        "latitude": "-27.71638000",
                        "longitude": "151.63399000"
                    },
                    {
                        "id": 6864,
                        "name": "Plainland",
                        "latitude": "-27.56667000",
                        "longitude": "152.41667000"
                    },
                    {
                        "id": 6877,
                        "name": "Point Vernon",
                        "latitude": "-25.25727000",
                        "longitude": "152.81725000"
                    },
                    {
                        "id": 6879,
                        "name": "Pomona",
                        "latitude": "-26.36685000",
                        "longitude": "152.85574000"
                    },
                    {
                        "id": 6881,
                        "name": "Pormpuraaw",
                        "latitude": "-14.65705000",
                        "longitude": "141.83354000"
                    },
                    {
                        "id": 6888,
                        "name": "Port Douglas",
                        "latitude": "-16.48383000",
                        "longitude": "145.46725000"
                    },
                    {
                        "id": 6921,
                        "name": "Proserpine",
                        "latitude": "-20.40110000",
                        "longitude": "148.58020000"
                    },
                    {
                        "id": 6926,
                        "name": "Pullenvale",
                        "latitude": "-27.52283000",
                        "longitude": "152.88651000"
                    },
                    {
                        "id": 6945,
                        "name": "Queenton",
                        "latitude": "-20.07453000",
                        "longitude": "146.28170000"
                    },
                    {
                        "id": 6946,
                        "name": "Quilpie",
                        "latitude": "-26.15057000",
                        "longitude": "143.57936000"
                    },
                    {
                        "id": 6952,
                        "name": "Raceview",
                        "latitude": "-27.63472000",
                        "longitude": "152.77519000"
                    },
                    {
                        "id": 6954,
                        "name": "Railway Estate",
                        "latitude": "-19.27570000",
                        "longitude": "146.81962000"
                    },
                    {
                        "id": 6955,
                        "name": "Rainbow Beach",
                        "latitude": "-25.90432000",
                        "longitude": "153.09174000"
                    },
                    {
                        "id": 6960,
                        "name": "Rangeville",
                        "latitude": "-27.58318000",
                        "longitude": "151.97997000"
                    },
                    {
                        "id": 6962,
                        "name": "Rangewood",
                        "latitude": "-19.31138000",
                        "longitude": "146.63877000"
                    },
                    {
                        "id": 6965,
                        "name": "Rasmussen",
                        "latitude": "-19.35240000",
                        "longitude": "146.72280000"
                    },
                    {
                        "id": 6968,
                        "name": "Ravenshoe",
                        "latitude": "-17.60901000",
                        "longitude": "145.48413000"
                    },
                    {
                        "id": 6976,
                        "name": "Red Hill",
                        "latitude": "-20.31667000",
                        "longitude": "148.50000000"
                    },
                    {
                        "id": 6979,
                        "name": "Redbank",
                        "latitude": "-27.60000000",
                        "longitude": "152.86667000"
                    },
                    {
                        "id": 6980,
                        "name": "Redbank Plains",
                        "latitude": "-27.64613000",
                        "longitude": "152.85965000"
                    },
                    {
                        "id": 6984,
                        "name": "Redland",
                        "latitude": "-27.53791000",
                        "longitude": "153.24829000"
                    },
                    {
                        "id": 6985,
                        "name": "Redland Bay",
                        "latitude": "-27.61130000",
                        "longitude": "153.30022000"
                    },
                    {
                        "id": 6986,
                        "name": "Redlynch",
                        "latitude": "-16.92540000",
                        "longitude": "145.69559000"
                    },
                    {
                        "id": 6988,
                        "name": "Reedy Creek",
                        "latitude": "-28.11243000",
                        "longitude": "153.39638000"
                    },
                    {
                        "id": 6989,
                        "name": "Regency Downs",
                        "latitude": "-27.53359000",
                        "longitude": "152.44049000"
                    },
                    {
                        "id": 6991,
                        "name": "Regents Park",
                        "latitude": "-27.67664000",
                        "longitude": "153.04165000"
                    },
                    {
                        "id": 7005,
                        "name": "Richlands",
                        "latitude": "-27.59616000",
                        "longitude": "152.95321000"
                    },
                    {
                        "id": 7008,
                        "name": "Richmond",
                        "latitude": "-20.56967000",
                        "longitude": "142.91384000"
                    },
                    {
                        "id": 7022,
                        "name": "River Heads",
                        "latitude": "-25.41551000",
                        "longitude": "152.91315000"
                    },
                    {
                        "id": 7023,
                        "name": "Riverhills",
                        "latitude": "-27.55928000",
                        "longitude": "152.91106000"
                    },
                    {
                        "id": 7028,
                        "name": "Riverview",
                        "latitude": "-27.60000000",
                        "longitude": "152.85000000"
                    },
                    {
                        "id": 7033,
                        "name": "Robertson",
                        "latitude": "-27.56583000",
                        "longitude": "153.05738000"
                    },
                    {
                        "id": 7035,
                        "name": "Robina",
                        "latitude": "-28.07071000",
                        "longitude": "153.39329000"
                    },
                    {
                        "id": 7037,
                        "name": "Rochedale",
                        "latitude": "-27.56667000",
                        "longitude": "153.13333000"
                    },
                    {
                        "id": 7038,
                        "name": "Rochedale South",
                        "latitude": "-27.59521000",
                        "longitude": "153.12332000"
                    },
                    {
                        "id": 7043,
                        "name": "Rockhampton",
                        "latitude": "-23.38032000",
                        "longitude": "150.50595000"
                    },
                    {
                        "id": 7046,
                        "name": "Rocklea",
                        "latitude": "-27.53917000",
                        "longitude": "153.00402000"
                    },
                    {
                        "id": 7047,
                        "name": "Rockville",
                        "latitude": "-27.53611000",
                        "longitude": "151.93805000"
                    },
                    {
                        "id": 7052,
                        "name": "Roma",
                        "latitude": "-26.56741000",
                        "longitude": "148.78751000"
                    },
                    {
                        "id": 7068,
                        "name": "Rosemount",
                        "latitude": "-26.63030000",
                        "longitude": "152.99970000"
                    },
                    {
                        "id": 7069,
                        "name": "Rosenthal Heights",
                        "latitude": "-28.24013000",
                        "longitude": "152.01327000"
                    },
                    {
                        "id": 7074,
                        "name": "Rosewood",
                        "latitude": "-27.63350000",
                        "longitude": "152.58949000"
                    },
                    {
                        "id": 7077,
                        "name": "Rosslea",
                        "latitude": "-19.29871000",
                        "longitude": "146.79824000"
                    },
                    {
                        "id": 7081,
                        "name": "Rothwell",
                        "latitude": "-27.21433000",
                        "longitude": "153.04676000"
                    },
                    {
                        "id": 7089,
                        "name": "Runaway Bay",
                        "latitude": "-27.91386000",
                        "longitude": "153.39775000"
                    },
                    {
                        "id": 7090,
                        "name": "Runcorn",
                        "latitude": "-27.59756000",
                        "longitude": "153.07699000"
                    },
                    {
                        "id": 7091,
                        "name": "Rural View",
                        "latitude": "-21.06447000",
                        "longitude": "149.16460000"
                    },
                    {
                        "id": 7095,
                        "name": "Russell Island",
                        "latitude": "-27.64867000",
                        "longitude": "153.38124000"
                    },
                    {
                        "id": 7105,
                        "name": "Sadliers Crossing",
                        "latitude": "-27.61251000",
                        "longitude": "152.74577000"
                    },
                    {
                        "id": 7120,
                        "name": "Salisbury",
                        "latitude": "-27.55145000",
                        "longitude": "153.03250000"
                    },
                    {
                        "id": 7129,
                        "name": "Samford Valley",
                        "latitude": "-27.37270000",
                        "longitude": "152.86699000"
                    },
                    {
                        "id": 7135,
                        "name": "Sandgate",
                        "latitude": "-27.32198000",
                        "longitude": "153.06951000"
                    },
                    {
                        "id": 7140,
                        "name": "Sandstone Point",
                        "latitude": "-27.08374000",
                        "longitude": "153.13235000"
                    },
                    {
                        "id": 7146,
                        "name": "Sarina",
                        "latitude": "-21.41910000",
                        "longitude": "149.21677000"
                    },
                    {
                        "id": 7150,
                        "name": "Scarborough",
                        "latitude": "-27.20118000",
                        "longitude": "153.10939000"
                    },
                    {
                        "id": 7151,
                        "name": "Scarness",
                        "latitude": "-25.28405000",
                        "longitude": "152.85600000"
                    },
                    {
                        "id": 7152,
                        "name": "Scenic Rim",
                        "latitude": "-28.04021000",
                        "longitude": "152.80688000"
                    },
                    {
                        "id": 7183,
                        "name": "Seven Hills",
                        "latitude": "-27.48341000",
                        "longitude": "153.07474000"
                    },
                    {
                        "id": 7186,
                        "name": "Seventeen Mile Rocks",
                        "latitude": "-27.55070000",
                        "longitude": "152.95896000"
                    },
                    {
                        "id": 7190,
                        "name": "Shailer Park",
                        "latitude": "-27.64980000",
                        "longitude": "153.17753000"
                    },
                    {
                        "id": 7193,
                        "name": "Sharon",
                        "latitude": "-24.87593000",
                        "longitude": "152.26994000"
                    },
                    {
                        "id": 7197,
                        "name": "Sheldon",
                        "latitude": "-27.58436000",
                        "longitude": "153.20042000"
                    },
                    {
                        "id": 7210,
                        "name": "Shorncliffe",
                        "latitude": "-27.32759000",
                        "longitude": "153.08161000"
                    },
                    {
                        "id": 7212,
                        "name": "Silkstone",
                        "latitude": "-27.62126000",
                        "longitude": "152.78768000"
                    },
                    {
                        "id": 7221,
                        "name": "Sinnamon Park",
                        "latitude": "-27.54436000",
                        "longitude": "152.94890000"
                    },
                    {
                        "id": 7222,
                        "name": "Sippy Downs",
                        "latitude": "-26.71793000",
                        "longitude": "153.05475000"
                    },
                    {
                        "id": 7225,
                        "name": "Slacks Creek",
                        "latitude": "-27.65000000",
                        "longitude": "153.15000000"
                    },
                    {
                        "id": 7226,
                        "name": "Slade Point",
                        "latitude": "-21.07500000",
                        "longitude": "149.22500000"
                    },
                    {
                        "id": 7236,
                        "name": "Soldiers Hill",
                        "latitude": "-20.70533000",
                        "longitude": "139.48988000"
                    },
                    {
                        "id": 7241,
                        "name": "Somerset",
                        "latitude": "-27.01133000",
                        "longitude": "152.41521000"
                    },
                    {
                        "id": 7253,
                        "name": "South Brisbane",
                        "latitude": "-27.48034000",
                        "longitude": "153.02049000"
                    },
                    {
                        "id": 7255,
                        "name": "South Burnett",
                        "latitude": "-26.40077000",
                        "longitude": "151.60166000"
                    },
                    {
                        "id": 7260,
                        "name": "South Gladstone",
                        "latitude": "-23.86221000",
                        "longitude": "151.26801000"
                    },
                    {
                        "id": 7270,
                        "name": "South Kolan",
                        "latitude": "-24.93202000",
                        "longitude": "152.16790000"
                    },
                    {
                        "id": 7274,
                        "name": "South Mackay",
                        "latitude": "-21.16288000",
                        "longitude": "149.17751000"
                    },
                    {
                        "id": 7275,
                        "name": "South Maclean",
                        "latitude": "-27.79245000",
                        "longitude": "153.01603000"
                    },
                    {
                        "id": 7284,
                        "name": "South Toowoomba",
                        "latitude": "-27.57101000",
                        "longitude": "151.94650000"
                    },
                    {
                        "id": 7285,
                        "name": "South Townsville",
                        "latitude": "-19.26618000",
                        "longitude": "146.83331000"
                    },
                    {
                        "id": 7293,
                        "name": "Southern Downs",
                        "latitude": "-28.50265000",
                        "longitude": "151.92165000"
                    },
                    {
                        "id": 7298,
                        "name": "Southport",
                        "latitude": "-27.96724000",
                        "longitude": "153.39796000"
                    },
                    {
                        "id": 7299,
                        "name": "Southside",
                        "latitude": "-26.20997000",
                        "longitude": "152.64719000"
                    },
                    {
                        "id": 7308,
                        "name": "Spring Hill",
                        "latitude": "-27.46141000",
                        "longitude": "153.02311000"
                    },
                    {
                        "id": 7310,
                        "name": "Springfield",
                        "latitude": "-27.65365000",
                        "longitude": "152.91716000"
                    },
                    {
                        "id": 7311,
                        "name": "Springfield Lakes",
                        "latitude": "-27.66757000",
                        "longitude": "152.92488000"
                    },
                    {
                        "id": 7312,
                        "name": "Springsure",
                        "latitude": "-24.11478000",
                        "longitude": "148.08849000"
                    },
                    {
                        "id": 7316,
                        "name": "Springwood",
                        "latitude": "-27.61183000",
                        "longitude": "153.12899000"
                    },
                    {
                        "id": 7322,
                        "name": "St George",
                        "latitude": "-27.94763000",
                        "longitude": "148.60986000"
                    },
                    {
                        "id": 7339,
                        "name": "Stafford",
                        "latitude": "-27.41044000",
                        "longitude": "153.01105000"
                    },
                    {
                        "id": 7340,
                        "name": "Stafford Heights",
                        "latitude": "-27.39354000",
                        "longitude": "153.01050000"
                    },
                    {
                        "id": 7343,
                        "name": "Stanthorpe",
                        "latitude": "-28.65425000",
                        "longitude": "151.93388000"
                    },
                    {
                        "id": 7364,
                        "name": "Strathpine",
                        "latitude": "-27.30414000",
                        "longitude": "152.98977000"
                    },
                    {
                        "id": 7367,
                        "name": "Stretton",
                        "latitude": "-27.62205000",
                        "longitude": "153.06609000"
                    },
                    {
                        "id": 7368,
                        "name": "Stuart",
                        "latitude": "-19.34702000",
                        "longitude": "146.84378000"
                    },
                    {
                        "id": 7377,
                        "name": "Sun Valley",
                        "latitude": "-23.87516000",
                        "longitude": "151.25752000"
                    },
                    {
                        "id": 7379,
                        "name": "Sunnybank",
                        "latitude": "-27.58003000",
                        "longitude": "153.06064000"
                    },
                    {
                        "id": 7380,
                        "name": "Sunnybank Hills",
                        "latitude": "-27.61025000",
                        "longitude": "153.05388000"
                    },
                    {
                        "id": 7381,
                        "name": "Sunrise Beach",
                        "latitude": "-26.41646000",
                        "longitude": "153.10305000"
                    },
                    {
                        "id": 7382,
                        "name": "Sunset",
                        "latitude": "-20.71026000",
                        "longitude": "139.50824000"
                    },
                    {
                        "id": 7386,
                        "name": "Sunshine Beach",
                        "latitude": "-26.40579000",
                        "longitude": "153.10779000"
                    },
                    {
                        "id": 7387,
                        "name": "Sunshine Coast",
                        "latitude": "-26.56098000",
                        "longitude": "152.85113000"
                    },
                    {
                        "id": 7391,
                        "name": "Surfers Paradise",
                        "latitude": "-28.00274000",
                        "longitude": "153.42999000"
                    },
                    {
                        "id": 7400,
                        "name": "Svensson Heights",
                        "latitude": "-24.88566000",
                        "longitude": "152.33183000"
                    },
                    {
                        "id": 7415,
                        "name": "Taigum",
                        "latitude": "-27.34265000",
                        "longitude": "153.04444000"
                    },
                    {
                        "id": 7417,
                        "name": "Tallai",
                        "latitude": "-28.06407000",
                        "longitude": "153.32589000"
                    },
                    {
                        "id": 7419,
                        "name": "Tallebudgera",
                        "latitude": "-28.15000000",
                        "longitude": "153.43333000"
                    },
                    {
                        "id": 7420,
                        "name": "Tallebudgera Valley",
                        "latitude": "-28.19270000",
                        "longitude": "153.35489000"
                    },
                    {
                        "id": 7422,
                        "name": "Tamborine",
                        "latitude": "-27.88333000",
                        "longitude": "153.13333000"
                    },
                    {
                        "id": 7423,
                        "name": "Tamborine Mountain",
                        "latitude": "-27.96954000",
                        "longitude": "153.19937000"
                    },
                    {
                        "id": 7427,
                        "name": "Tanah Merah",
                        "latitude": "-27.67151000",
                        "longitude": "153.17019000"
                    },
                    {
                        "id": 7428,
                        "name": "Tanawha",
                        "latitude": "-26.71981000",
                        "longitude": "153.03018000"
                    },
                    {
                        "id": 7430,
                        "name": "Tannum Sands",
                        "latitude": "-23.94749000",
                        "longitude": "151.36749000"
                    },
                    {
                        "id": 7434,
                        "name": "Tara",
                        "latitude": "-27.27613000",
                        "longitude": "150.45676000"
                    },
                    {
                        "id": 7435,
                        "name": "Taranganba",
                        "latitude": "-23.14435000",
                        "longitude": "150.75139000"
                    },
                    {
                        "id": 7439,
                        "name": "Taringa",
                        "latitude": "-27.49061000",
                        "longitude": "152.97861000"
                    },
                    {
                        "id": 7442,
                        "name": "Tarragindi",
                        "latitude": "-27.52713000",
                        "longitude": "153.04556000"
                    },
                    {
                        "id": 7459,
                        "name": "Telina",
                        "latitude": "-23.88834000",
                        "longitude": "151.25379000"
                    },
                    {
                        "id": 7467,
                        "name": "Teneriffe",
                        "latitude": "-27.45587000",
                        "longitude": "153.04696000"
                    },
                    {
                        "id": 7478,
                        "name": "Tewantin",
                        "latitude": "-26.39104000",
                        "longitude": "153.03432000"
                    },
                    {
                        "id": 7479,
                        "name": "Thabeban",
                        "latitude": "-24.90000000",
                        "longitude": "152.35000000"
                    },
                    {
                        "id": 7484,
                        "name": "The Gap",
                        "latitude": "-27.44187000",
                        "longitude": "152.93861000"
                    },
                    {
                        "id": 7486,
                        "name": "The Gemfields",
                        "latitude": "-23.53014000",
                        "longitude": "147.79679000"
                    },
                    {
                        "id": 7493,
                        "name": "The Range",
                        "latitude": "-23.39200000",
                        "longitude": "150.49624000"
                    },
                    {
                        "id": 7504,
                        "name": "Thorneside",
                        "latitude": "-27.48777000",
                        "longitude": "153.19821000"
                    },
                    {
                        "id": 7505,
                        "name": "Thornlands",
                        "latitude": "-27.55751000",
                        "longitude": "153.26481000"
                    },
                    {
                        "id": 7511,
                        "name": "Thursday Island",
                        "latitude": "-10.58257000",
                        "longitude": "142.21949000"
                    },
                    {
                        "id": 7512,
                        "name": "Tieri",
                        "latitude": "-23.03829000",
                        "longitude": "148.34463000"
                    },
                    {
                        "id": 7515,
                        "name": "Tin Can Bay",
                        "latitude": "-25.91914000",
                        "longitude": "153.00320000"
                    },
                    {
                        "id": 7516,
                        "name": "Tinana",
                        "latitude": "-25.55196000",
                        "longitude": "152.66590000"
                    },
                    {
                        "id": 7517,
                        "name": "Tingalpa",
                        "latitude": "-27.47360000",
                        "longitude": "153.12704000"
                    },
                    {
                        "id": 7520,
                        "name": "Tivoli",
                        "latitude": "-27.59278000",
                        "longitude": "152.76798000"
                    },
                    {
                        "id": 7524,
                        "name": "Tolga",
                        "latitude": "-17.18557000",
                        "longitude": "145.47707000"
                    },
                    {
                        "id": 7531,
                        "name": "Toogoolawah",
                        "latitude": "-27.08661000",
                        "longitude": "152.37636000"
                    },
                    {
                        "id": 7532,
                        "name": "Toogoom",
                        "latitude": "-25.25637000",
                        "longitude": "152.69025000"
                    },
                    {
                        "id": 7539,
                        "name": "Toowong",
                        "latitude": "-27.48333000",
                        "longitude": "152.98333000"
                    },
                    {
                        "id": 7540,
                        "name": "Toowoomba",
                        "latitude": "-27.47958000",
                        "longitude": "151.47705000"
                    },
                    {
                        "id": 7542,
                        "name": "Torquay",
                        "latitude": "-25.28496000",
                        "longitude": "152.87886000"
                    },
                    {
                        "id": 7547,
                        "name": "Torres",
                        "latitude": "-10.57928000",
                        "longitude": "142.22059000"
                    },
                    {
                        "id": 7548,
                        "name": "Torres Strait Island Region",
                        "latitude": "-10.20141000",
                        "longitude": "142.27295000"
                    },
                    {
                        "id": 7550,
                        "name": "Townsville",
                        "latitude": "-19.26639000",
                        "longitude": "146.80569000"
                    },
                    {
                        "id": 7551,
                        "name": "Townview",
                        "latitude": "-20.73252000",
                        "longitude": "139.50482000"
                    },
                    {
                        "id": 7565,
                        "name": "Trinity Beach",
                        "latitude": "-16.78876000",
                        "longitude": "145.69682000"
                    },
                    {
                        "id": 7567,
                        "name": "Trinity Park",
                        "latitude": "-16.80684000",
                        "longitude": "145.70549000"
                    },
                    {
                        "id": 7570,
                        "name": "Trunding",
                        "latitude": "-12.63422000",
                        "longitude": "141.86963000"
                    },
                    {
                        "id": 7573,
                        "name": "Tugun",
                        "latitude": "-28.15000000",
                        "longitude": "153.50000000"
                    },
                    {
                        "id": 7575,
                        "name": "Tully",
                        "latitude": "-17.93264000",
                        "longitude": "145.92277000"
                    },
                    {
                        "id": 7593,
                        "name": "Twin Waters",
                        "latitude": "-26.63422000",
                        "longitude": "153.08114000"
                    },
                    {
                        "id": 7603,
                        "name": "Underwood",
                        "latitude": "-27.60885000",
                        "longitude": "153.11130000"
                    },
                    {
                        "id": 7607,
                        "name": "Upper Caboolture",
                        "latitude": "-27.11667000",
                        "longitude": "152.88333000"
                    },
                    {
                        "id": 7608,
                        "name": "Upper Coomera",
                        "latitude": "-27.87683000",
                        "longitude": "153.28572000"
                    },
                    {
                        "id": 7611,
                        "name": "Upper Kedron",
                        "latitude": "-27.41879000",
                        "longitude": "152.91777000"
                    },
                    {
                        "id": 7613,
                        "name": "Upper Mount Gravatt",
                        "latitude": "-27.56128000",
                        "longitude": "153.08453000"
                    },
                    {
                        "id": 7616,
                        "name": "Urangan",
                        "latitude": "-25.29214000",
                        "longitude": "152.90535000"
                    },
                    {
                        "id": 7617,
                        "name": "Urraween",
                        "latitude": "-25.29522000",
                        "longitude": "152.82206000"
                    },
                    {
                        "id": 7626,
                        "name": "Varsity Lakes",
                        "latitude": "-28.08940000",
                        "longitude": "153.41220000"
                    },
                    {
                        "id": 7635,
                        "name": "Victoria Point",
                        "latitude": "-27.58329000",
                        "longitude": "153.31172000"
                    },
                    {
                        "id": 7639,
                        "name": "Vincent",
                        "latitude": "-19.28341000",
                        "longitude": "146.76463000"
                    },
                    {
                        "id": 7644,
                        "name": "Virginia",
                        "latitude": "-27.38333000",
                        "longitude": "153.06667000"
                    },
                    {
                        "id": 7647,
                        "name": "Wacol",
                        "latitude": "-27.58333000",
                        "longitude": "152.93333000"
                    },
                    {
                        "id": 7662,
                        "name": "Wakerley",
                        "latitude": "-27.48300000",
                        "longitude": "153.15589000"
                    },
                    {
                        "id": 7665,
                        "name": "Walkerston",
                        "latitude": "-21.16097000",
                        "longitude": "149.05814000"
                    },
                    {
                        "id": 7666,
                        "name": "Walkervale",
                        "latitude": "-24.88266000",
                        "longitude": "152.35886000"
                    },
                    {
                        "id": 7675,
                        "name": "Walloon",
                        "latitude": "-27.60545000",
                        "longitude": "152.66429000"
                    },
                    {
                        "id": 7679,
                        "name": "Wamuran",
                        "latitude": "-27.03909000",
                        "longitude": "152.86542000"
                    },
                    {
                        "id": 7680,
                        "name": "Wandal",
                        "latitude": "-23.36878000",
                        "longitude": "150.49381000"
                    },
                    {
                        "id": 7686,
                        "name": "Wandoan",
                        "latitude": "-26.12285000",
                        "longitude": "149.96028000"
                    },
                    {
                        "id": 7698,
                        "name": "Warana",
                        "latitude": "-26.72273000",
                        "longitude": "153.12688000"
                    },
                    {
                        "id": 7707,
                        "name": "Warner",
                        "latitude": "-27.31222000",
                        "longitude": "152.94981000"
                    },
                    {
                        "id": 7725,
                        "name": "Warwick",
                        "latitude": "-28.21901000",
                        "longitude": "152.03438000"
                    },
                    {
                        "id": 7730,
                        "name": "Waterford West",
                        "latitude": "-27.69056000",
                        "longitude": "153.13319000"
                    },
                    {
                        "id": 7746,
                        "name": "Wavell Heights",
                        "latitude": "-27.39385000",
                        "longitude": "153.04698000"
                    },
                    {
                        "id": 7754,
                        "name": "Weipa",
                        "latitude": "-12.63671000",
                        "longitude": "141.87555000"
                    },
                    {
                        "id": 7756,
                        "name": "Wellesley Islands",
                        "latitude": "-16.63184000",
                        "longitude": "139.40140000"
                    },
                    {
                        "id": 7759,
                        "name": "Wellington Point",
                        "latitude": "-27.48333000",
                        "longitude": "153.25000000"
                    },
                    {
                        "id": 7784,
                        "name": "West End",
                        "latitude": "-27.47923000",
                        "longitude": "153.00960000"
                    },
                    {
                        "id": 7786,
                        "name": "West Gladstone",
                        "latitude": "-23.86123000",
                        "longitude": "151.24530000"
                    },
                    {
                        "id": 7798,
                        "name": "West Mackay",
                        "latitude": "-21.15467000",
                        "longitude": "149.16181000"
                    },
                    {
                        "id": 7805,
                        "name": "West Rockhampton",
                        "latitude": "-23.37941000",
                        "longitude": "150.48175000"
                    },
                    {
                        "id": 7814,
                        "name": "West Woombye",
                        "latitude": "-26.66644000",
                        "longitude": "152.92557000"
                    },
                    {
                        "id": 7817,
                        "name": "Westbrook",
                        "latitude": "-27.61667000",
                        "longitude": "151.86667000"
                    },
                    {
                        "id": 7819,
                        "name": "Westcourt",
                        "latitude": "-26.80000000",
                        "longitude": "150.15000000"
                    },
                    {
                        "id": 7821,
                        "name": "Western Downs",
                        "latitude": "-26.80665000",
                        "longitude": "150.38590000"
                    },
                    {
                        "id": 7822,
                        "name": "Westlake",
                        "latitude": "-27.54862000",
                        "longitude": "152.91276000"
                    },
                    {
                        "id": 7835,
                        "name": "White Rock",
                        "latitude": "-16.97438000",
                        "longitude": "145.76330000"
                    },
                    {
                        "id": 7838,
                        "name": "Whitfield",
                        "latitude": "-16.89508000",
                        "longitude": "145.73335000"
                    },
                    {
                        "id": 7839,
                        "name": "Whitsunday",
                        "latitude": "-20.69780000",
                        "longitude": "148.01349000"
                    },
                    {
                        "id": 7840,
                        "name": "Whitsundays",
                        "latitude": "-20.11943000",
                        "longitude": "148.91325000"
                    },
                    {
                        "id": 7865,
                        "name": "Willow Vale",
                        "latitude": "-27.84499000",
                        "longitude": "153.26310000"
                    },
                    {
                        "id": 7866,
                        "name": "Willowbank",
                        "latitude": "-27.68215000",
                        "longitude": "152.67407000"
                    },
                    {
                        "id": 7869,
                        "name": "Wilsonton",
                        "latitude": "-27.54312000",
                        "longitude": "151.91684000"
                    },
                    {
                        "id": 7870,
                        "name": "Wilsonton Heights",
                        "latitude": "-27.53227000",
                        "longitude": "151.92444000"
                    },
                    {
                        "id": 7871,
                        "name": "Wilston",
                        "latitude": "-27.43218000",
                        "longitude": "153.01904000"
                    },
                    {
                        "id": 7877,
                        "name": "Windaroo",
                        "latitude": "-27.74587000",
                        "longitude": "153.19339000"
                    },
                    {
                        "id": 7880,
                        "name": "Windsor",
                        "latitude": "-27.43631000",
                        "longitude": "153.02882000"
                    },
                    {
                        "id": 7887,
                        "name": "Winston",
                        "latitude": "-20.70374000",
                        "longitude": "139.49913000"
                    },
                    {
                        "id": 7890,
                        "name": "Winton",
                        "latitude": "-22.50749000",
                        "longitude": "142.66199000"
                    },
                    {
                        "id": 7891,
                        "name": "Wishart",
                        "latitude": "-27.55448000",
                        "longitude": "153.10107000"
                    },
                    {
                        "id": 7892,
                        "name": "Withcott",
                        "latitude": "-27.55408000",
                        "longitude": "152.02432000"
                    },
                    {
                        "id": 7894,
                        "name": "Witta",
                        "latitude": "-26.70000000",
                        "longitude": "152.81667000"
                    },
                    {
                        "id": 7903,
                        "name": "Wondai",
                        "latitude": "-26.31770000",
                        "longitude": "151.87242000"
                    },
                    {
                        "id": 7904,
                        "name": "Wondunna",
                        "latitude": "-25.31758000",
                        "longitude": "152.85912000"
                    },
                    {
                        "id": 7906,
                        "name": "Wongaling Beach",
                        "latitude": "-17.91327000",
                        "longitude": "146.09611000"
                    },
                    {
                        "id": 7908,
                        "name": "Wongawallan",
                        "latitude": "-27.87553000",
                        "longitude": "153.22865000"
                    },
                    {
                        "id": 7918,
                        "name": "Woodend",
                        "latitude": "-27.60554000",
                        "longitude": "152.75307000"
                    },
                    {
                        "id": 7919,
                        "name": "Woodford",
                        "latitude": "-26.95291000",
                        "longitude": "152.77747000"
                    },
                    {
                        "id": 7921,
                        "name": "Woodgate",
                        "latitude": "-25.10830000",
                        "longitude": "152.56254000"
                    },
                    {
                        "id": 7923,
                        "name": "Woodridge",
                        "latitude": "-27.63333000",
                        "longitude": "153.10000000"
                    },
                    {
                        "id": 7934,
                        "name": "Woody Point",
                        "latitude": "-27.25608000",
                        "longitude": "153.10427000"
                    },
                    {
                        "id": 7938,
                        "name": "Woolloongabba",
                        "latitude": "-27.48855000",
                        "longitude": "153.03655000"
                    },
                    {
                        "id": 7940,
                        "name": "Wooloowin",
                        "latitude": "-27.42244000",
                        "longitude": "153.04204000"
                    },
                    {
                        "id": 7941,
                        "name": "Woombye",
                        "latitude": "-26.66054000",
                        "longitude": "152.96947000"
                    },
                    {
                        "id": 7944,
                        "name": "Woorabinda",
                        "latitude": "-24.15010000",
                        "longitude": "149.44977000"
                    },
                    {
                        "id": 7946,
                        "name": "Woorim",
                        "latitude": "-27.06931000",
                        "longitude": "153.20427000"
                    },
                    {
                        "id": 7949,
                        "name": "Woree",
                        "latitude": "-16.95000000",
                        "longitude": "145.75000000"
                    },
                    {
                        "id": 7950,
                        "name": "Worongary",
                        "latitude": "-28.05000000",
                        "longitude": "153.35000000"
                    },
                    {
                        "id": 7957,
                        "name": "Wujal Wujal",
                        "latitude": "-15.96904000",
                        "longitude": "145.31520000"
                    },
                    {
                        "id": 7959,
                        "name": "Wulguru",
                        "latitude": "-19.32850000",
                        "longitude": "146.81842000"
                    },
                    {
                        "id": 7960,
                        "name": "Wulkuraka",
                        "latitude": "-27.61429000",
                        "longitude": "152.72191000"
                    },
                    {
                        "id": 7964,
                        "name": "Wurtulla",
                        "latitude": "-26.75648000",
                        "longitude": "153.12805000"
                    },
                    {
                        "id": 7973,
                        "name": "Wynnum",
                        "latitude": "-27.44527000",
                        "longitude": "153.15813000"
                    },
                    {
                        "id": 7974,
                        "name": "Wynnum West",
                        "latitude": "-27.45824000",
                        "longitude": "153.15319000"
                    },
                    {
                        "id": 7979,
                        "name": "Wyreema",
                        "latitude": "-27.65583000",
                        "longitude": "151.85532000"
                    },
                    {
                        "id": 7988,
                        "name": "Yamanto",
                        "latitude": "-27.66027000",
                        "longitude": "152.73863000"
                    },
                    {
                        "id": 7991,
                        "name": "Yandina",
                        "latitude": "-26.56165000",
                        "longitude": "152.95595000"
                    },
                    {
                        "id": 7994,
                        "name": "Yaroomba",
                        "latitude": "-26.55126000",
                        "longitude": "153.09701000"
                    },
                    {
                        "id": 7999,
                        "name": "Yarrabah",
                        "latitude": "-16.99463000",
                        "longitude": "145.88058000"
                    },
                    {
                        "id": 8000,
                        "name": "Yarrabilba",
                        "latitude": "-27.80864000",
                        "longitude": "153.11163000"
                    },
                    {
                        "id": 8004,
                        "name": "Yarraman",
                        "latitude": "-26.84167000",
                        "longitude": "151.98138000"
                    },
                    {
                        "id": 8013,
                        "name": "Yatala",
                        "latitude": "-27.71667000",
                        "longitude": "153.21667000"
                    },
                    {
                        "id": 8015,
                        "name": "Yeerongpilly",
                        "latitude": "-27.53097000",
                        "longitude": "153.00935000"
                    },
                    {
                        "id": 8018,
                        "name": "Yeppoon",
                        "latitude": "-23.12683000",
                        "longitude": "150.74406000"
                    },
                    {
                        "id": 8019,
                        "name": "Yeppoon city centre",
                        "latitude": "-23.12950000",
                        "longitude": "150.73639000"
                    },
                    {
                        "id": 8020,
                        "name": "Yeronga",
                        "latitude": "-27.51571000",
                        "longitude": "153.01642000"
                    },
                    {
                        "id": 8027,
                        "name": "Yorkeys Knob",
                        "latitude": "-16.80278000",
                        "longitude": "145.72083000"
                    },
                    {
                        "id": 8032,
                        "name": "Yungaburra",
                        "latitude": "-17.27058000",
                        "longitude": "145.58335000"
                    },
                    {
                        "id": 8034,
                        "name": "Zillmere",
                        "latitude": "-27.35591000",
                        "longitude": "153.04453000"
                    },
                    {
                        "id": 8035,
                        "name": "Zilzie",
                        "latitude": "-23.28867000",
                        "longitude": "150.79820000"
                    }
                ]
            },
            {
                "id": 3904,
                "name": "South Australia",
                "iso2": "SA",
                "latitude": "-30.00023150",
                "longitude": "136.20915470",
                "type": "state",
                "cities": [
                    {
                        "id": 3910,
                        "name": "Aberfoyle Park",
                        "latitude": "-35.07680000",
                        "longitude": "138.59163000"
                    },
                    {
                        "id": 3919,
                        "name": "Adelaide",
                        "latitude": "-34.92866000",
                        "longitude": "138.59863000"
                    },
                    {
                        "id": 3921,
                        "name": "Adelaide city centre",
                        "latitude": "-34.92873000",
                        "longitude": "138.60334000"
                    },
                    {
                        "id": 3920,
                        "name": "Adelaide Hills",
                        "latitude": "-34.90103000",
                        "longitude": "138.85457000"
                    },
                    {
                        "id": 3933,
                        "name": "Albert Park",
                        "latitude": "-34.87201000",
                        "longitude": "138.51966000"
                    },
                    {
                        "id": 3935,
                        "name": "Alberton",
                        "latitude": "-34.85925000",
                        "longitude": "138.52138000"
                    },
                    {
                        "id": 3944,
                        "name": "Aldgate",
                        "latitude": "-35.01667000",
                        "longitude": "138.73333000"
                    },
                    {
                        "id": 3945,
                        "name": "Aldinga Beach",
                        "latitude": "-35.27826000",
                        "longitude": "138.45802000"
                    },
                    {
                        "id": 3951,
                        "name": "Alexandrina",
                        "latitude": "-35.33769000",
                        "longitude": "138.83704000"
                    },
                    {
                        "id": 3962,
                        "name": "Allenby Gardens",
                        "latitude": "-34.89766000",
                        "longitude": "138.55425000"
                    },
                    {
                        "id": 3976,
                        "name": "Anangu Pitjantjatjara",
                        "latitude": "-27.05797000",
                        "longitude": "131.37314000"
                    },
                    {
                        "id": 3978,
                        "name": "Andrews Farm",
                        "latitude": "-34.67632000",
                        "longitude": "138.66197000"
                    },
                    {
                        "id": 3979,
                        "name": "Angaston",
                        "latitude": "-34.50129000",
                        "longitude": "139.04625000"
                    },
                    {
                        "id": 3980,
                        "name": "Angle Park",
                        "latitude": "-34.85989000",
                        "longitude": "138.55798000"
                    },
                    {
                        "id": 3981,
                        "name": "Angle Vale",
                        "latitude": "-34.64098000",
                        "longitude": "138.64610000"
                    },
                    {
                        "id": 4001,
                        "name": "Ardrossan",
                        "latitude": "-34.42217000",
                        "longitude": "137.91907000"
                    },
                    {
                        "id": 4014,
                        "name": "Ascot Park",
                        "latitude": "-34.99175000",
                        "longitude": "138.55768000"
                    },
                    {
                        "id": 4023,
                        "name": "Ashford",
                        "latitude": "-34.94859000",
                        "longitude": "138.57457000"
                    },
                    {
                        "id": 4033,
                        "name": "Athelstone",
                        "latitude": "-34.87019000",
                        "longitude": "138.69990000"
                    },
                    {
                        "id": 4035,
                        "name": "Athol Park",
                        "latitude": "-34.85608000",
                        "longitude": "138.54282000"
                    },
                    {
                        "id": 4069,
                        "name": "Balaklava",
                        "latitude": "-34.14542000",
                        "longitude": "138.41148000"
                    },
                    {
                        "id": 4077,
                        "name": "Balhannah",
                        "latitude": "-34.99094000",
                        "longitude": "138.82565000"
                    },
                    {
                        "id": 4102,
                        "name": "Banksia Park",
                        "latitude": "-34.81015000",
                        "longitude": "138.73570000"
                    },
                    {
                        "id": 4122,
                        "name": "Barmera",
                        "latitude": "-34.25562000",
                        "longitude": "140.46147000"
                    },
                    {
                        "id": 4126,
                        "name": "Barossa",
                        "latitude": "-34.61351000",
                        "longitude": "138.96169000"
                    },
                    {
                        "id": 4130,
                        "name": "Barunga West",
                        "latitude": "-33.79484000",
                        "longitude": "137.92311000"
                    },
                    {
                        "id": 4168,
                        "name": "Beaumont",
                        "latitude": "-34.94899000",
                        "longitude": "138.66188000"
                    },
                    {
                        "id": 4173,
                        "name": "Bedford Park",
                        "latitude": "-35.02204000",
                        "longitude": "138.56815000"
                    },
                    {
                        "id": 4183,
                        "name": "Belair",
                        "latitude": "-34.99766000",
                        "longitude": "138.62077000"
                    },
                    {
                        "id": 4202,
                        "name": "Bellevue Heights",
                        "latitude": "-35.03023000",
                        "longitude": "138.58314000"
                    },
                    {
                        "id": 4236,
                        "name": "Berri",
                        "latitude": "-34.28107000",
                        "longitude": "140.59958000"
                    },
                    {
                        "id": 4237,
                        "name": "Berri and Barmera",
                        "latitude": "-34.28788000",
                        "longitude": "140.49358000"
                    },
                    {
                        "id": 4247,
                        "name": "Beulah Park",
                        "latitude": "-34.91768000",
                        "longitude": "138.64522000"
                    },
                    {
                        "id": 4250,
                        "name": "Beverley",
                        "latitude": "-34.89512000",
                        "longitude": "138.54633000"
                    },
                    {
                        "id": 4268,
                        "name": "Birdwood",
                        "latitude": "-34.81826000",
                        "longitude": "138.96478000"
                    },
                    {
                        "id": 4270,
                        "name": "Birkenhead",
                        "latitude": "-34.83685000",
                        "longitude": "138.49788000"
                    },
                    {
                        "id": 4275,
                        "name": "Black Forest",
                        "latitude": "-34.96028000",
                        "longitude": "138.57668000"
                    },
                    {
                        "id": 4296,
                        "name": "Blackwood",
                        "latitude": "-35.02139000",
                        "longitude": "138.61429000"
                    },
                    {
                        "id": 4297,
                        "name": "Blair Athol",
                        "latitude": "-34.85889000",
                        "longitude": "138.59656000"
                    },
                    {
                        "id": 4301,
                        "name": "Blakeview",
                        "latitude": "-34.67566000",
                        "longitude": "138.71010000"
                    },
                    {
                        "id": 4348,
                        "name": "Bordertown",
                        "latitude": "-36.30768000",
                        "longitude": "140.77167000"
                    },
                    {
                        "id": 4378,
                        "name": "Brahma Lodge",
                        "latitude": "-34.77604000",
                        "longitude": "138.65306000"
                    },
                    {
                        "id": 4397,
                        "name": "Bridgewater",
                        "latitude": "-35.01397000",
                        "longitude": "138.76648000"
                    },
                    {
                        "id": 4401,
                        "name": "Brighton",
                        "latitude": "-35.01820000",
                        "longitude": "138.52351000"
                    },
                    {
                        "id": 4417,
                        "name": "Broadview",
                        "latitude": "-34.87589000",
                        "longitude": "138.61498000"
                    },
                    {
                        "id": 4422,
                        "name": "Brompton",
                        "latitude": "-34.89445000",
                        "longitude": "138.57820000"
                    },
                    {
                        "id": 4428,
                        "name": "Brooklyn Park",
                        "latitude": "-34.92847000",
                        "longitude": "138.53631000"
                    },
                    {
                        "id": 4486,
                        "name": "Burnside",
                        "latitude": "-34.93333000",
                        "longitude": "138.65000000"
                    },
                    {
                        "id": 4493,
                        "name": "Burra",
                        "latitude": "-33.67171000",
                        "longitude": "138.92835000"
                    },
                    {
                        "id": 4499,
                        "name": "Burton",
                        "latitude": "-34.73339000",
                        "longitude": "138.60247000"
                    },
                    {
                        "id": 4546,
                        "name": "Camden Park",
                        "latitude": "-34.96857000",
                        "longitude": "138.53957000"
                    },
                    {
                        "id": 4559,
                        "name": "Campbelltown",
                        "latitude": "-34.88545000",
                        "longitude": "138.68546000"
                    },
                    {
                        "id": 4646,
                        "name": "Ceduna",
                        "latitude": "-32.14736000",
                        "longitude": "133.86288000"
                    },
                    {
                        "id": 4664,
                        "name": "Charles Sturt",
                        "latitude": "-34.90067000",
                        "longitude": "138.53182000"
                    },
                    {
                        "id": 4678,
                        "name": "Cheltenham",
                        "latitude": "-34.86788000",
                        "longitude": "138.52336000"
                    },
                    {
                        "id": 4701,
                        "name": "Christie Downs",
                        "latitude": "-35.12999000",
                        "longitude": "138.49633000"
                    },
                    {
                        "id": 4702,
                        "name": "Christies Beach",
                        "latitude": "-35.13876000",
                        "longitude": "138.47232000"
                    },
                    {
                        "id": 4713,
                        "name": "City of West Torrens",
                        "latitude": "-34.93133000",
                        "longitude": "138.55090000"
                    },
                    {
                        "id": 4714,
                        "name": "Clapham",
                        "latitude": "-34.98989000",
                        "longitude": "138.60158000"
                    },
                    {
                        "id": 4715,
                        "name": "Clare",
                        "latitude": "-33.83325000",
                        "longitude": "138.61064000"
                    },
                    {
                        "id": 4716,
                        "name": "Clare and Gilbert Valleys",
                        "latitude": "-34.01462000",
                        "longitude": "138.75340000"
                    },
                    {
                        "id": 4721,
                        "name": "Clarence Gardens",
                        "latitude": "-34.97539000",
                        "longitude": "138.57983000"
                    },
                    {
                        "id": 4722,
                        "name": "Clarence Park",
                        "latitude": "-34.96416000",
                        "longitude": "138.58060000"
                    },
                    {
                        "id": 4733,
                        "name": "Clearview",
                        "latitude": "-34.85735000",
                        "longitude": "138.61327000"
                    },
                    {
                        "id": 4736,
                        "name": "Cleve",
                        "latitude": "-33.66078000",
                        "longitude": "136.28893000"
                    },
                    {
                        "id": 4747,
                        "name": "Clovelly Park",
                        "latitude": "-34.99951000",
                        "longitude": "138.57081000"
                    },
                    {
                        "id": 4778,
                        "name": "Collinswood",
                        "latitude": "-34.88730000",
                        "longitude": "138.61224000"
                    },
                    {
                        "id": 4780,
                        "name": "Colonel Light Gardens",
                        "latitude": "-34.98628000",
                        "longitude": "138.59746000"
                    },
                    {
                        "id": 4794,
                        "name": "Coober Pedy",
                        "latitude": "-29.01415000",
                        "longitude": "134.75495000"
                    },
                    {
                        "id": 4831,
                        "name": "Copper Coast",
                        "latitude": "-33.94287000",
                        "longitude": "137.71329000"
                    },
                    {
                        "id": 4841,
                        "name": "Coromandel Valley",
                        "latitude": "-35.05000000",
                        "longitude": "138.61667000"
                    },
                    {
                        "id": 4850,
                        "name": "Cowandilla",
                        "latitude": "-34.93221000",
                        "longitude": "138.55931000"
                    },
                    {
                        "id": 4852,
                        "name": "Cowell",
                        "latitude": "-33.68227000",
                        "longitude": "136.92117000"
                    },
                    {
                        "id": 4856,
                        "name": "Crafers",
                        "latitude": "-35.00000000",
                        "longitude": "138.70000000"
                    },
                    {
                        "id": 4857,
                        "name": "Crafers West",
                        "latitude": "-34.99136000",
                        "longitude": "138.68205000"
                    },
                    {
                        "id": 4858,
                        "name": "Craigburn Farm",
                        "latitude": "-35.04046000",
                        "longitude": "138.60490000"
                    },
                    {
                        "id": 4862,
                        "name": "Craigmore",
                        "latitude": "-34.70064000",
                        "longitude": "138.70956000"
                    },
                    {
                        "id": 4894,
                        "name": "Croydon Park",
                        "latitude": "-34.88028000",
                        "longitude": "138.56779000"
                    },
                    {
                        "id": 4896,
                        "name": "Crystal Brook",
                        "latitude": "-33.35256000",
                        "longitude": "138.20955000"
                    },
                    {
                        "id": 4902,
                        "name": "Cumberland Park",
                        "latitude": "-34.97204000",
                        "longitude": "138.58670000"
                    },
                    {
                        "id": 4942,
                        "name": "Darlington",
                        "latitude": "-35.03151000",
                        "longitude": "138.55527000"
                    },
                    {
                        "id": 4950,
                        "name": "Davoren Park",
                        "latitude": "-34.69063000",
                        "longitude": "138.66862000"
                    },
                    {
                        "id": 4951,
                        "name": "Daw Park",
                        "latitude": "-34.98975000",
                        "longitude": "138.58407000"
                    },
                    {
                        "id": 4979,
                        "name": "Dernancourt",
                        "latitude": "-34.86199000",
                        "longitude": "138.67658000"
                    },
                    {
                        "id": 5020,
                        "name": "Dover Gardens",
                        "latitude": "-35.02400000",
                        "longitude": "138.53695000"
                    },
                    {
                        "id": 5037,
                        "name": "Dulwich",
                        "latitude": "-34.93650000",
                        "longitude": "138.62720000"
                    },
                    {
                        "id": 5104,
                        "name": "Echunga",
                        "latitude": "-35.10354000",
                        "longitude": "138.79588000"
                    },
                    {
                        "id": 5107,
                        "name": "Eden Hills",
                        "latitude": "-35.02110000",
                        "longitude": "138.59567000"
                    },
                    {
                        "id": 5118,
                        "name": "Edwardstown",
                        "latitude": "-34.98018000",
                        "longitude": "138.56940000"
                    },
                    {
                        "id": 5131,
                        "name": "Elizabeth Downs",
                        "latitude": "-34.69982000",
                        "longitude": "138.69132000"
                    },
                    {
                        "id": 5132,
                        "name": "Elizabeth East",
                        "latitude": "-34.72513000",
                        "longitude": "138.68214000"
                    },
                    {
                        "id": 5133,
                        "name": "Elizabeth Grove",
                        "latitude": "-34.73528000",
                        "longitude": "138.66888000"
                    },
                    {
                        "id": 5135,
                        "name": "Elizabeth North",
                        "latitude": "-34.70678000",
                        "longitude": "138.67609000"
                    },
                    {
                        "id": 5136,
                        "name": "Elizabeth Park",
                        "latitude": "-34.70974000",
                        "longitude": "138.68604000"
                    },
                    {
                        "id": 5137,
                        "name": "Elizabeth South",
                        "latitude": "-34.73182000",
                        "longitude": "138.66192000"
                    },
                    {
                        "id": 5138,
                        "name": "Elizabeth Vale",
                        "latitude": "-34.74857000",
                        "longitude": "138.66819000"
                    },
                    {
                        "id": 5144,
                        "name": "Elliston",
                        "latitude": "-33.53931000",
                        "longitude": "135.09514000"
                    },
                    {
                        "id": 5158,
                        "name": "Encounter Bay",
                        "latitude": "-35.57419000",
                        "longitude": "138.60055000"
                    },
                    {
                        "id": 5160,
                        "name": "Enfield",
                        "latitude": "-34.85260000",
                        "longitude": "138.60255000"
                    },
                    {
                        "id": 5168,
                        "name": "Erindale",
                        "latitude": "-34.92785000",
                        "longitude": "138.66313000"
                    },
                    {
                        "id": 5181,
                        "name": "Ethelton",
                        "latitude": "-34.84869000",
                        "longitude": "138.49103000"
                    },
                    {
                        "id": 5192,
                        "name": "Evandale",
                        "latitude": "-34.90552000",
                        "longitude": "138.63542000"
                    },
                    {
                        "id": 5194,
                        "name": "Evanston",
                        "latitude": "-34.61657000",
                        "longitude": "138.73369000"
                    },
                    {
                        "id": 5195,
                        "name": "Evanston Gardens",
                        "latitude": "-34.62323000",
                        "longitude": "138.72166000"
                    },
                    {
                        "id": 5196,
                        "name": "Evanston Park",
                        "latitude": "-34.62284000",
                        "longitude": "138.74123000"
                    },
                    {
                        "id": 5198,
                        "name": "Everard Park",
                        "latitude": "-34.95196000",
                        "longitude": "138.57481000"
                    },
                    {
                        "id": 5201,
                        "name": "Exeter",
                        "latitude": "-34.83994000",
                        "longitude": "138.48902000"
                    },
                    {
                        "id": 5212,
                        "name": "Fairview Park",
                        "latitude": "-34.79998000",
                        "longitude": "138.72857000"
                    },
                    {
                        "id": 5222,
                        "name": "Felixstow",
                        "latitude": "-34.88902000",
                        "longitude": "138.64696000"
                    },
                    {
                        "id": 5232,
                        "name": "Ferryden Park",
                        "latitude": "-34.86616000",
                        "longitude": "138.56180000"
                    },
                    {
                        "id": 5235,
                        "name": "Findon",
                        "latitude": "-34.90000000",
                        "longitude": "138.53333000"
                    },
                    {
                        "id": 5238,
                        "name": "Firle",
                        "latitude": "-34.90459000",
                        "longitude": "138.65319000"
                    },
                    {
                        "id": 5245,
                        "name": "Flagstaff Hill",
                        "latitude": "-35.04861000",
                        "longitude": "138.58285000"
                    },
                    {
                        "id": 5251,
                        "name": "Flinders Park",
                        "latitude": "-34.91026000",
                        "longitude": "138.54322000"
                    },
                    {
                        "id": 5252,
                        "name": "Flinders Ranges",
                        "latitude": "-32.13341000",
                        "longitude": "138.33882000"
                    },
                    {
                        "id": 5268,
                        "name": "Forestville",
                        "latitude": "-34.94946000",
                        "longitude": "138.57845000"
                    },
                    {
                        "id": 5279,
                        "name": "Franklin Harbour",
                        "latitude": "-33.60164000",
                        "longitude": "136.94148000"
                    },
                    {
                        "id": 5287,
                        "name": "Freeling",
                        "latitude": "-34.45407000",
                        "longitude": "138.80868000"
                    },
                    {
                        "id": 5294,
                        "name": "Fulham",
                        "latitude": "-34.92737000",
                        "longitude": "138.51368000"
                    },
                    {
                        "id": 5295,
                        "name": "Fulham Gardens",
                        "latitude": "-34.91483000",
                        "longitude": "138.51324000"
                    },
                    {
                        "id": 5296,
                        "name": "Fullarton",
                        "latitude": "-34.95100000",
                        "longitude": "138.62900000"
                    },
                    {
                        "id": 5310,
                        "name": "Gawler",
                        "latitude": "-34.62109000",
                        "longitude": "138.73228000"
                    },
                    {
                        "id": 5311,
                        "name": "Gawler East",
                        "latitude": "-34.59889000",
                        "longitude": "138.76320000"
                    },
                    {
                        "id": 5312,
                        "name": "Gawler South",
                        "latitude": "-34.60712000",
                        "longitude": "138.74445000"
                    },
                    {
                        "id": 5331,
                        "name": "Gilberton",
                        "latitude": "-34.90051000",
                        "longitude": "138.61260000"
                    },
                    {
                        "id": 5334,
                        "name": "Gilles Plains",
                        "latitude": "-34.85000000",
                        "longitude": "138.65000000"
                    },
                    {
                        "id": 5351,
                        "name": "Glandore",
                        "latitude": "-34.96154000",
                        "longitude": "138.56832000"
                    },
                    {
                        "id": 5363,
                        "name": "Glen Osmond",
                        "latitude": "-34.95960000",
                        "longitude": "138.64873000"
                    },
                    {
                        "id": 5365,
                        "name": "Glenalta",
                        "latitude": "-35.00792000",
                        "longitude": "138.62592000"
                    },
                    {
                        "id": 5371,
                        "name": "Glenelg",
                        "latitude": "-34.98079000",
                        "longitude": "138.51500000"
                    },
                    {
                        "id": 5373,
                        "name": "Glenelg East",
                        "latitude": "-34.97640000",
                        "longitude": "138.52962000"
                    },
                    {
                        "id": 5374,
                        "name": "Glenelg North",
                        "latitude": "-34.96790000",
                        "longitude": "138.51751000"
                    },
                    {
                        "id": 5375,
                        "name": "Glenelg South",
                        "latitude": "-34.98964000",
                        "longitude": "138.51425000"
                    },
                    {
                        "id": 5381,
                        "name": "Glengowrie",
                        "latitude": "-34.98708000",
                        "longitude": "138.53674000"
                    },
                    {
                        "id": 5389,
                        "name": "Glenside",
                        "latitude": "-34.94275000",
                        "longitude": "138.63375000"
                    },
                    {
                        "id": 5390,
                        "name": "Glenunga",
                        "latitude": "-34.95013000",
                        "longitude": "138.63841000"
                    },
                    {
                        "id": 5396,
                        "name": "Glynde",
                        "latitude": "-34.89605000",
                        "longitude": "138.65253000"
                    },
                    {
                        "id": 5403,
                        "name": "Golden Grove",
                        "latitude": "-34.78333000",
                        "longitude": "138.73333000"
                    },
                    {
                        "id": 5410,
                        "name": "Goodwood",
                        "latitude": "-34.95092000",
                        "longitude": "138.59230000"
                    },
                    {
                        "id": 5412,
                        "name": "Goolwa",
                        "latitude": "-35.50159000",
                        "longitude": "138.78191000"
                    },
                    {
                        "id": 5413,
                        "name": "Goolwa Beach",
                        "latitude": "-35.50474000",
                        "longitude": "138.77320000"
                    },
                    {
                        "id": 5431,
                        "name": "Goyder",
                        "latitude": "-33.71640000",
                        "longitude": "139.01655000"
                    },
                    {
                        "id": 5435,
                        "name": "Grange",
                        "latitude": "-34.90223000",
                        "longitude": "138.49022000"
                    },
                    {
                        "id": 5437,
                        "name": "Grant",
                        "latitude": "-37.83642000",
                        "longitude": "140.63316000"
                    },
                    {
                        "id": 5452,
                        "name": "Greenacres",
                        "latitude": "-34.86855000",
                        "longitude": "138.62800000"
                    },
                    {
                        "id": 5457,
                        "name": "Greenock",
                        "latitude": "-34.45700000",
                        "longitude": "138.92719000"
                    },
                    {
                        "id": 5464,
                        "name": "Greenwith",
                        "latitude": "-34.76565000",
                        "longitude": "138.71383000"
                    },
                    {
                        "id": 5477,
                        "name": "Gulfview Heights",
                        "latitude": "-34.79545000",
                        "longitude": "138.66937000"
                    },
                    {
                        "id": 5499,
                        "name": "Hackham",
                        "latitude": "-35.15514000",
                        "longitude": "138.52509000"
                    },
                    {
                        "id": 5500,
                        "name": "Hackham West",
                        "latitude": "-35.14312000",
                        "longitude": "138.51442000"
                    },
                    {
                        "id": 5504,
                        "name": "Hahndorf",
                        "latitude": "-35.02863000",
                        "longitude": "138.80779000"
                    },
                    {
                        "id": 5507,
                        "name": "Hallett Cove",
                        "latitude": "-35.07923000",
                        "longitude": "138.51460000"
                    },
                    {
                        "id": 5519,
                        "name": "Hampstead Gardens",
                        "latitude": "-34.87448000",
                        "longitude": "138.62881000"
                    },
                    {
                        "id": 5525,
                        "name": "Happy Valley",
                        "latitude": "-35.08333000",
                        "longitude": "138.53333000"
                    },
                    {
                        "id": 5542,
                        "name": "Hawthorn",
                        "latitude": "-34.97384000",
                        "longitude": "138.60738000"
                    },
                    {
                        "id": 5545,
                        "name": "Hawthorndene",
                        "latitude": "-35.02229000",
                        "longitude": "138.63039000"
                    },
                    {
                        "id": 5549,
                        "name": "Hayborough",
                        "latitude": "-35.53129000",
                        "longitude": "138.65037000"
                    },
                    {
                        "id": 5553,
                        "name": "Hazelwood Park",
                        "latitude": "-34.93947000",
                        "longitude": "138.65879000"
                    },
                    {
                        "id": 5565,
                        "name": "Hectorville",
                        "latitude": "-34.89157000",
                        "longitude": "138.65892000"
                    },
                    {
                        "id": 5576,
                        "name": "Henley Beach",
                        "latitude": "-34.92029000",
                        "longitude": "138.49442000"
                    },
                    {
                        "id": 5577,
                        "name": "Henley Beach South",
                        "latitude": "-34.92591000",
                        "longitude": "138.49554000"
                    },
                    {
                        "id": 5589,
                        "name": "Hewett",
                        "latitude": "-34.57801000",
                        "longitude": "138.75242000"
                    },
                    {
                        "id": 5594,
                        "name": "Highbury",
                        "latitude": "-34.85287000",
                        "longitude": "138.69750000"
                    },
                    {
                        "id": 5598,
                        "name": "Highgate",
                        "latitude": "-34.96177000",
                        "longitude": "138.62180000"
                    },
                    {
                        "id": 5606,
                        "name": "Hillbank",
                        "latitude": "-34.73588000",
                        "longitude": "138.68723000"
                    },
                    {
                        "id": 5607,
                        "name": "Hillcrest",
                        "latitude": "-34.86252000",
                        "longitude": "138.64306000"
                    },
                    {
                        "id": 5619,
                        "name": "Hindmarsh Island",
                        "latitude": "-35.51014000",
                        "longitude": "138.86762000"
                    },
                    {
                        "id": 5628,
                        "name": "Holden Hill",
                        "latitude": "-34.85161000",
                        "longitude": "138.67232000"
                    },
                    {
                        "id": 5630,
                        "name": "Holdfast Bay",
                        "latitude": "-35.00244000",
                        "longitude": "138.52318000"
                    },
                    {
                        "id": 5646,
                        "name": "Hope Valley",
                        "latitude": "-34.83333000",
                        "longitude": "138.70000000"
                    },
                    {
                        "id": 5656,
                        "name": "Hove",
                        "latitude": "-35.00814000",
                        "longitude": "138.52120000"
                    },
                    {
                        "id": 5669,
                        "name": "Huntfield Heights",
                        "latitude": "-35.15452000",
                        "longitude": "138.51417000"
                    },
                    {
                        "id": 5680,
                        "name": "Hyde Park",
                        "latitude": "-34.95467000",
                        "longitude": "138.60107000"
                    },
                    {
                        "id": 5690,
                        "name": "Ingle Farm",
                        "latitude": "-34.83333000",
                        "longitude": "138.63333000"
                    },
                    {
                        "id": 5718,
                        "name": "Jamestown",
                        "latitude": "-33.20531000",
                        "longitude": "138.60503000"
                    },
                    {
                        "id": 5744,
                        "name": "Joslin",
                        "latitude": "-34.89967000",
                        "longitude": "138.62655000"
                    },
                    {
                        "id": 5753,
                        "name": "Kadina",
                        "latitude": "-33.96495000",
                        "longitude": "137.71634000"
                    },
                    {
                        "id": 5776,
                        "name": "Kangaroo Island",
                        "latitude": "-35.82390000",
                        "longitude": "137.33392000"
                    },
                    {
                        "id": 5781,
                        "name": "Kapunda",
                        "latitude": "-34.33871000",
                        "longitude": "138.91644000"
                    },
                    {
                        "id": 5791,
                        "name": "Karoonda East Murray",
                        "latitude": "-34.92846000",
                        "longitude": "140.02484000"
                    },
                    {
                        "id": 5813,
                        "name": "Keith",
                        "latitude": "-36.09910000",
                        "longitude": "140.35315000"
                    },
                    {
                        "id": 5829,
                        "name": "Kensington Gardens",
                        "latitude": "-34.92582000",
                        "longitude": "138.66145000"
                    },
                    {
                        "id": 5831,
                        "name": "Kensington Park",
                        "latitude": "-34.92022000",
                        "longitude": "138.65430000"
                    },
                    {
                        "id": 5833,
                        "name": "Kent Town",
                        "latitude": "-34.92155000",
                        "longitude": "138.62009000"
                    },
                    {
                        "id": 5840,
                        "name": "Kersbrook",
                        "latitude": "-34.78305000",
                        "longitude": "138.85091000"
                    },
                    {
                        "id": 5851,
                        "name": "Kidman Park",
                        "latitude": "-34.91224000",
                        "longitude": "138.52693000"
                    },
                    {
                        "id": 5853,
                        "name": "Kilburn",
                        "latitude": "-34.85970000",
                        "longitude": "138.58559000"
                    },
                    {
                        "id": 5855,
                        "name": "Kilkenny",
                        "latitude": "-34.87914000",
                        "longitude": "138.55290000"
                    },
                    {
                        "id": 5862,
                        "name": "Kimba",
                        "latitude": "-33.04817000",
                        "longitude": "136.31797000"
                    },
                    {
                        "id": 5877,
                        "name": "Kingscote",
                        "latitude": "-35.65590000",
                        "longitude": "137.63930000"
                    },
                    {
                        "id": 5883,
                        "name": "Kingston",
                        "latitude": "-36.64083000",
                        "longitude": "140.05093000"
                    },
                    {
                        "id": 5888,
                        "name": "Kingston South East",
                        "latitude": "-36.83073000",
                        "longitude": "139.85220000"
                    },
                    {
                        "id": 5898,
                        "name": "Klemzig",
                        "latitude": "-34.87928000",
                        "longitude": "138.63562000"
                    },
                    {
                        "id": 5929,
                        "name": "Kurralta Park",
                        "latitude": "-34.95142000",
                        "longitude": "138.56702000"
                    },
                    {
                        "id": 5977,
                        "name": "Largs Bay",
                        "latitude": "-34.82582000",
                        "longitude": "138.48619000"
                    },
                    {
                        "id": 5978,
                        "name": "Largs North",
                        "latitude": "-34.82050000",
                        "longitude": "138.49241000"
                    },
                    {
                        "id": 5994,
                        "name": "Leabrook",
                        "latitude": "-34.92976000",
                        "longitude": "138.65862000"
                    },
                    {
                        "id": 6018,
                        "name": "Lewiston",
                        "latitude": "-34.60449000",
                        "longitude": "138.59125000"
                    },
                    {
                        "id": 6021,
                        "name": "Light",
                        "latitude": "-34.40981000",
                        "longitude": "138.84367000"
                    },
                    {
                        "id": 6026,
                        "name": "Linden Park",
                        "latitude": "-34.94347000",
                        "longitude": "138.64728000"
                    },
                    {
                        "id": 6037,
                        "name": "Little Hampton",
                        "latitude": "-35.04225000",
                        "longitude": "138.86423000"
                    },
                    {
                        "id": 6044,
                        "name": "Lobethal",
                        "latitude": "-34.90455000",
                        "longitude": "138.87477000"
                    },
                    {
                        "id": 6047,
                        "name": "Lockleys",
                        "latitude": "-34.92588000",
                        "longitude": "138.52803000"
                    },
                    {
                        "id": 6075,
                        "name": "Lower Eyre Peninsula",
                        "latitude": "-34.48806000",
                        "longitude": "135.70114000"
                    },
                    {
                        "id": 6077,
                        "name": "Lower Mitcham",
                        "latitude": "-34.97731000",
                        "longitude": "138.60493000"
                    },
                    {
                        "id": 6080,
                        "name": "Loxton",
                        "latitude": "-34.45020000",
                        "longitude": "140.56908000"
                    },
                    {
                        "id": 6081,
                        "name": "Loxton Waikerie",
                        "latitude": "-34.48161000",
                        "longitude": "140.28346000"
                    },
                    {
                        "id": 6090,
                        "name": "Lyndoch",
                        "latitude": "-34.60124000",
                        "longitude": "138.89094000"
                    },
                    {
                        "id": 6098,
                        "name": "Macclesfield",
                        "latitude": "-35.17182000",
                        "longitude": "138.83589000"
                    },
                    {
                        "id": 6122,
                        "name": "Magill",
                        "latitude": "-34.90911000",
                        "longitude": "138.67498000"
                    },
                    {
                        "id": 6128,
                        "name": "Maitland",
                        "latitude": "-34.37386000",
                        "longitude": "137.67333000"
                    },
                    {
                        "id": 6138,
                        "name": "Mallala",
                        "latitude": "-34.51035000",
                        "longitude": "138.42783000"
                    },
                    {
                        "id": 6141,
                        "name": "Malvern",
                        "latitude": "-34.95915000",
                        "longitude": "138.61254000"
                    },
                    {
                        "id": 6157,
                        "name": "Manningham",
                        "latitude": "-34.87776000",
                        "longitude": "138.62206000"
                    },
                    {
                        "id": 6158,
                        "name": "Mannum",
                        "latitude": "-34.91529000",
                        "longitude": "139.30325000"
                    },
                    {
                        "id": 6162,
                        "name": "Mansfield Park",
                        "latitude": "-34.85655000",
                        "longitude": "138.55186000"
                    },
                    {
                        "id": 6166,
                        "name": "Maralinga Tjarutja",
                        "latitude": "-29.60092000",
                        "longitude": "130.84442000"
                    },
                    {
                        "id": 6173,
                        "name": "Marden",
                        "latitude": "-34.89569000",
                        "longitude": "138.63780000"
                    },
                    {
                        "id": 6181,
                        "name": "Marino",
                        "latitude": "-35.04468000",
                        "longitude": "138.51236000"
                    },
                    {
                        "id": 6182,
                        "name": "Marion",
                        "latitude": "-35.01322000",
                        "longitude": "138.55339000"
                    },
                    {
                        "id": 6184,
                        "name": "Marleston",
                        "latitude": "-34.94763000",
                        "longitude": "138.55957000"
                    },
                    {
                        "id": 6202,
                        "name": "Maslin Beach",
                        "latitude": "-35.22595000",
                        "longitude": "138.47984000"
                    },
                    {
                        "id": 6206,
                        "name": "Mawson Lakes",
                        "latitude": "-34.81589000",
                        "longitude": "138.60809000"
                    },
                    {
                        "id": 6212,
                        "name": "Maylands",
                        "latitude": "-34.91128000",
                        "longitude": "138.63671000"
                    },
                    {
                        "id": 6213,
                        "name": "McCracken",
                        "latitude": "-35.53580000",
                        "longitude": "138.63121000"
                    },
                    {
                        "id": 6221,
                        "name": "McLaren Flat",
                        "latitude": "-35.21667000",
                        "longitude": "138.58333000"
                    },
                    {
                        "id": 6222,
                        "name": "McLaren Vale",
                        "latitude": "-35.21895000",
                        "longitude": "138.54326000"
                    },
                    {
                        "id": 6228,
                        "name": "Meadows",
                        "latitude": "-35.18021000",
                        "longitude": "138.76250000"
                    },
                    {
                        "id": 6231,
                        "name": "Medindie",
                        "latitude": "-34.89600000",
                        "longitude": "138.60500000"
                    },
                    {
                        "id": 6238,
                        "name": "Melrose Park",
                        "latitude": "-34.98328000",
                        "longitude": "138.57541000"
                    },
                    {
                        "id": 6245,
                        "name": "Meningie",
                        "latitude": "-35.68637000",
                        "longitude": "139.34007000"
                    },
                    {
                        "id": 6270,
                        "name": "Mid Murray",
                        "latitude": "-34.41566000",
                        "longitude": "139.41639000"
                    },
                    {
                        "id": 6278,
                        "name": "Middleton",
                        "latitude": "-35.51047000",
                        "longitude": "138.70377000"
                    },
                    {
                        "id": 6285,
                        "name": "Mile End",
                        "latitude": "-34.92654000",
                        "longitude": "138.57033000"
                    },
                    {
                        "id": 6295,
                        "name": "Millicent",
                        "latitude": "-37.59389000",
                        "longitude": "140.34947000"
                    },
                    {
                        "id": 6299,
                        "name": "Millswood",
                        "latitude": "-34.95505000",
                        "longitude": "138.58888000"
                    },
                    {
                        "id": 6310,
                        "name": "Minlaton",
                        "latitude": "-34.77101000",
                        "longitude": "137.59576000"
                    },
                    {
                        "id": 6321,
                        "name": "Mitcham",
                        "latitude": "-35.00690000",
                        "longitude": "138.62218000"
                    },
                    {
                        "id": 6325,
                        "name": "Mitchell Park",
                        "latitude": "-35.01031000",
                        "longitude": "138.56266000"
                    },
                    {
                        "id": 6329,
                        "name": "Moana",
                        "latitude": "-35.19394000",
                        "longitude": "138.47614000"
                    },
                    {
                        "id": 6330,
                        "name": "Modbury",
                        "latitude": "-34.83333000",
                        "longitude": "138.68333000"
                    },
                    {
                        "id": 6331,
                        "name": "Modbury Heights",
                        "latitude": "-34.80969000",
                        "longitude": "138.68544000"
                    },
                    {
                        "id": 6332,
                        "name": "Modbury North",
                        "latitude": "-34.82848000",
                        "longitude": "138.67390000"
                    },
                    {
                        "id": 6343,
                        "name": "Monash",
                        "latitude": "-34.23840000",
                        "longitude": "140.56131000"
                    },
                    {
                        "id": 6364,
                        "name": "Moonta Bay",
                        "latitude": "-34.05000000",
                        "longitude": "137.56667000"
                    },
                    {
                        "id": 6368,
                        "name": "Moorak",
                        "latitude": "-37.86381000",
                        "longitude": "140.74263000"
                    },
                    {
                        "id": 6392,
                        "name": "Morphett Vale",
                        "latitude": "-35.13333000",
                        "longitude": "138.51667000"
                    },
                    {
                        "id": 6393,
                        "name": "Morphettville",
                        "latitude": "-34.98852000",
                        "longitude": "138.53979000"
                    },
                    {
                        "id": 6408,
                        "name": "Mount Barker",
                        "latitude": "-35.06907000",
                        "longitude": "138.86936000"
                    },
                    {
                        "id": 6413,
                        "name": "Mount Compass",
                        "latitude": "-35.34685000",
                        "longitude": "138.62032000"
                    },
                    {
                        "id": 6422,
                        "name": "Mount Gambier",
                        "latitude": "-37.82469000",
                        "longitude": "140.78191000"
                    },
                    {
                        "id": 6454,
                        "name": "Mount Remarkable",
                        "latitude": "-32.71813000",
                        "longitude": "138.17130000"
                    },
                    {
                        "id": 6485,
                        "name": "Munno Para",
                        "latitude": "-34.66792000",
                        "longitude": "138.70149000"
                    },
                    {
                        "id": 6486,
                        "name": "Munno Para West",
                        "latitude": "-34.66464000",
                        "longitude": "138.68066000"
                    },
                    {
                        "id": 6495,
                        "name": "Murray Bridge",
                        "latitude": "-35.20020000",
                        "longitude": "139.32090000"
                    },
                    {
                        "id": 6505,
                        "name": "Mylor",
                        "latitude": "-35.04303000",
                        "longitude": "138.75900000"
                    },
                    {
                        "id": 6506,
                        "name": "Myrtle Bank",
                        "latitude": "-34.96057000",
                        "longitude": "138.63377000"
                    },
                    {
                        "id": 6510,
                        "name": "Nailsworth",
                        "latitude": "-34.88437000",
                        "longitude": "138.60619000"
                    },
                    {
                        "id": 6511,
                        "name": "Nairne",
                        "latitude": "-35.03450000",
                        "longitude": "138.91154000"
                    },
                    {
                        "id": 6522,
                        "name": "Naracoorte",
                        "latitude": "-36.95785000",
                        "longitude": "140.73830000"
                    },
                    {
                        "id": 6523,
                        "name": "Naracoorte and Lucindale",
                        "latitude": "-36.99542000",
                        "longitude": "140.52791000"
                    },
                    {
                        "id": 6551,
                        "name": "Netherby",
                        "latitude": "-34.97048000",
                        "longitude": "138.62503000"
                    },
                    {
                        "id": 6552,
                        "name": "Netley",
                        "latitude": "-34.94887000",
                        "longitude": "138.54983000"
                    },
                    {
                        "id": 6577,
                        "name": "Newton",
                        "latitude": "-34.88207000",
                        "longitude": "138.68249000"
                    },
                    {
                        "id": 6597,
                        "name": "Noarlunga Downs",
                        "latitude": "-35.15040000",
                        "longitude": "138.50395000"
                    },
                    {
                        "id": 6611,
                        "name": "Normanville",
                        "latitude": "-35.44623000",
                        "longitude": "138.32130000"
                    },
                    {
                        "id": 6612,
                        "name": "North Adelaide",
                        "latitude": "-34.90733000",
                        "longitude": "138.59141000"
                    },
                    {
                        "id": 6622,
                        "name": "North Brighton",
                        "latitude": "-35.00279000",
                        "longitude": "138.52211000"
                    },
                    {
                        "id": 6631,
                        "name": "North Haven",
                        "latitude": "-34.78825000",
                        "longitude": "138.49162000"
                    },
                    {
                        "id": 6645,
                        "name": "North Plympton",
                        "latitude": "-34.95769000",
                        "longitude": "138.55343000"
                    },
                    {
                        "id": 6666,
                        "name": "Northern Areas",
                        "latitude": "-33.30074000",
                        "longitude": "138.47745000"
                    },
                    {
                        "id": 6670,
                        "name": "Northfield",
                        "latitude": "-34.84979000",
                        "longitude": "138.62550000"
                    },
                    {
                        "id": 6671,
                        "name": "Northgate",
                        "latitude": "-34.85784000",
                        "longitude": "138.62908000"
                    },
                    {
                        "id": 6675,
                        "name": "Norwood",
                        "latitude": "-34.92730000",
                        "longitude": "138.62849000"
                    },
                    {
                        "id": 6676,
                        "name": "Norwood Payneham St Peters",
                        "latitude": "-34.90800000",
                        "longitude": "138.63556000"
                    },
                    {
                        "id": 6678,
                        "name": "Novar Gardens",
                        "latitude": "-34.96626000",
                        "longitude": "138.53256000"
                    },
                    {
                        "id": 6688,
                        "name": "Nuriootpa",
                        "latitude": "-34.46825000",
                        "longitude": "138.99767000"
                    },
                    {
                        "id": 6692,
                        "name": "O'Sullivan Beach",
                        "latitude": "-35.11879000",
                        "longitude": "138.47340000"
                    },
                    {
                        "id": 6753,
                        "name": "O’Halloran Hill",
                        "latitude": "-35.06667000",
                        "longitude": "138.55000000"
                    },
                    {
                        "id": 6696,
                        "name": "Oakden",
                        "latitude": "-34.85280000",
                        "longitude": "138.64330000"
                    },
                    {
                        "id": 6702,
                        "name": "Oaklands Park",
                        "latitude": "-35.00671000",
                        "longitude": "138.54457000"
                    },
                    {
                        "id": 6718,
                        "name": "Old Noarlunga",
                        "latitude": "-35.18209000",
                        "longitude": "138.50138000"
                    },
                    {
                        "id": 6719,
                        "name": "Old Reynella",
                        "latitude": "-35.10353000",
                        "longitude": "138.53365000"
                    },
                    {
                        "id": 6723,
                        "name": "One Tree Hill",
                        "latitude": "-34.70000000",
                        "longitude": "138.76667000"
                    },
                    {
                        "id": 6724,
                        "name": "Onkaparinga",
                        "latitude": "-35.18680000",
                        "longitude": "138.57776000"
                    },
                    {
                        "id": 6725,
                        "name": "Onkaparinga Hills",
                        "latitude": "-35.13514000",
                        "longitude": "138.56697000"
                    },
                    {
                        "id": 6741,
                        "name": "Orroroo\/Carrieton",
                        "latitude": "-32.53181000",
                        "longitude": "138.66470000"
                    },
                    {
                        "id": 6742,
                        "name": "Osborne",
                        "latitude": "-34.79804000",
                        "longitude": "138.49796000"
                    },
                    {
                        "id": 6744,
                        "name": "Ottoway",
                        "latitude": "-34.84756000",
                        "longitude": "138.53575000"
                    },
                    {
                        "id": 6774,
                        "name": "Panorama",
                        "latitude": "-34.99080000",
                        "longitude": "138.59948000"
                    },
                    {
                        "id": 6776,
                        "name": "Para Hills",
                        "latitude": "-34.81210000",
                        "longitude": "138.65802000"
                    },
                    {
                        "id": 6777,
                        "name": "Para Hills West",
                        "latitude": "-34.80474000",
                        "longitude": "138.64283000"
                    },
                    {
                        "id": 6778,
                        "name": "Para Vista",
                        "latitude": "-34.82094000",
                        "longitude": "138.66111000"
                    },
                    {
                        "id": 6780,
                        "name": "Paradise",
                        "latitude": "-34.87361000",
                        "longitude": "138.66896000"
                    },
                    {
                        "id": 6782,
                        "name": "Parafield Gardens",
                        "latitude": "-34.78254000",
                        "longitude": "138.61077000"
                    },
                    {
                        "id": 6783,
                        "name": "Paralowie",
                        "latitude": "-34.75705000",
                        "longitude": "138.60819000"
                    },
                    {
                        "id": 6785,
                        "name": "Paringa",
                        "latitude": "-34.17644000",
                        "longitude": "140.78579000"
                    },
                    {
                        "id": 6788,
                        "name": "Park Holme",
                        "latitude": "-34.99443000",
                        "longitude": "138.55318000"
                    },
                    {
                        "id": 6799,
                        "name": "Parkside",
                        "latitude": "-34.94512000",
                        "longitude": "138.61304000"
                    },
                    {
                        "id": 6808,
                        "name": "Pasadena",
                        "latitude": "-35.00274000",
                        "longitude": "138.58862000"
                    },
                    {
                        "id": 6812,
                        "name": "Payneham",
                        "latitude": "-34.89724000",
                        "longitude": "138.64064000"
                    },
                    {
                        "id": 6813,
                        "name": "Payneham South",
                        "latitude": "-34.90481000",
                        "longitude": "138.64448000"
                    },
                    {
                        "id": 6830,
                        "name": "Pennington",
                        "latitude": "-34.85758000",
                        "longitude": "138.53160000"
                    },
                    {
                        "id": 6831,
                        "name": "Penola",
                        "latitude": "-37.37520000",
                        "longitude": "140.83678000"
                    },
                    {
                        "id": 6842,
                        "name": "Peterborough",
                        "latitude": "-32.84787000",
                        "longitude": "139.02608000"
                    },
                    {
                        "id": 6843,
                        "name": "Peterhead",
                        "latitude": "-34.83118000",
                        "longitude": "138.49892000"
                    },
                    {
                        "id": 6866,
                        "name": "Playford",
                        "latitude": "-34.69419000",
                        "longitude": "138.64210000"
                    },
                    {
                        "id": 6870,
                        "name": "Plympton",
                        "latitude": "-34.96200000",
                        "longitude": "138.55496000"
                    },
                    {
                        "id": 6871,
                        "name": "Plympton Park",
                        "latitude": "-34.98071000",
                        "longitude": "138.54918000"
                    },
                    {
                        "id": 6880,
                        "name": "Pooraka",
                        "latitude": "-34.82471000",
                        "longitude": "138.62637000"
                    },
                    {
                        "id": 6882,
                        "name": "Port Adelaide",
                        "latitude": "-34.84620000",
                        "longitude": "138.50302000"
                    },
                    {
                        "id": 6883,
                        "name": "Port Adelaide Enfield",
                        "latitude": "-34.84803000",
                        "longitude": "138.50773000"
                    },
                    {
                        "id": 6884,
                        "name": "Port Augusta",
                        "latitude": "-32.55530000",
                        "longitude": "137.71362000"
                    },
                    {
                        "id": 6885,
                        "name": "Port Augusta West",
                        "latitude": "-32.48611000",
                        "longitude": "137.75833000"
                    },
                    {
                        "id": 6886,
                        "name": "Port Broughton",
                        "latitude": "-33.60070000",
                        "longitude": "137.93597000"
                    },
                    {
                        "id": 6889,
                        "name": "Port Elliot",
                        "latitude": "-35.53017000",
                        "longitude": "138.67922000"
                    },
                    {
                        "id": 6895,
                        "name": "Port Lincoln",
                        "latitude": "-34.72854000",
                        "longitude": "135.85748000"
                    },
                    {
                        "id": 6899,
                        "name": "Port Noarlunga",
                        "latitude": "-35.14802000",
                        "longitude": "138.47099000"
                    },
                    {
                        "id": 6900,
                        "name": "Port Noarlunga South",
                        "latitude": "-35.17404000",
                        "longitude": "138.46859000"
                    },
                    {
                        "id": 6902,
                        "name": "Port Pirie",
                        "latitude": "-33.19176000",
                        "longitude": "138.01746000"
                    },
                    {
                        "id": 6903,
                        "name": "Port Pirie City and Dists",
                        "latitude": "-33.36513000",
                        "longitude": "138.10706000"
                    },
                    {
                        "id": 6904,
                        "name": "Port Pirie South",
                        "latitude": "-33.19797000",
                        "longitude": "138.01446000"
                    },
                    {
                        "id": 6905,
                        "name": "Port Pirie West",
                        "latitude": "-33.17790000",
                        "longitude": "137.99850000"
                    },
                    {
                        "id": 6908,
                        "name": "Port Willunga",
                        "latitude": "-35.26181000",
                        "longitude": "138.46436000"
                    },
                    {
                        "id": 6922,
                        "name": "Prospect",
                        "latitude": "-34.88457000",
                        "longitude": "138.60038000"
                    },
                    {
                        "id": 6944,
                        "name": "Queenstown",
                        "latitude": "-34.86091000",
                        "longitude": "138.51048000"
                    },
                    {
                        "id": 6950,
                        "name": "Quorn",
                        "latitude": "-32.34676000",
                        "longitude": "138.04176000"
                    },
                    {
                        "id": 6987,
                        "name": "Redwood Park",
                        "latitude": "-34.81155000",
                        "longitude": "138.70695000"
                    },
                    {
                        "id": 6993,
                        "name": "Renmark",
                        "latitude": "-34.17702000",
                        "longitude": "140.74697000"
                    },
                    {
                        "id": 6994,
                        "name": "Renmark Paringa",
                        "latitude": "-34.17485000",
                        "longitude": "140.74860000"
                    },
                    {
                        "id": 6995,
                        "name": "Renmark West",
                        "latitude": "-34.16531000",
                        "longitude": "140.70970000"
                    },
                    {
                        "id": 6996,
                        "name": "Renown Park",
                        "latitude": "-34.89174000",
                        "longitude": "138.57729000"
                    },
                    {
                        "id": 7001,
                        "name": "Reynella",
                        "latitude": "-35.09372000",
                        "longitude": "138.53082000"
                    },
                    {
                        "id": 7002,
                        "name": "Reynella East",
                        "latitude": "-35.09197000",
                        "longitude": "138.55742000"
                    },
                    {
                        "id": 7010,
                        "name": "Richmond",
                        "latitude": "-34.94199000",
                        "longitude": "138.56322000"
                    },
                    {
                        "id": 7012,
                        "name": "Ridgehaven",
                        "latitude": "-34.82126000",
                        "longitude": "138.70467000"
                    },
                    {
                        "id": 7014,
                        "name": "Ridleyton",
                        "latitude": "-34.89280000",
                        "longitude": "138.57159000"
                    },
                    {
                        "id": 7019,
                        "name": "Risdon Park",
                        "latitude": "-33.19661000",
                        "longitude": "137.99399000"
                    },
                    {
                        "id": 7020,
                        "name": "Risdon Park South",
                        "latitude": "-33.21104000",
                        "longitude": "137.99498000"
                    },
                    {
                        "id": 7032,
                        "name": "Robe",
                        "latitude": "-37.18616000",
                        "longitude": "139.99003000"
                    },
                    {
                        "id": 7060,
                        "name": "Rose Park",
                        "latitude": "-34.93039000",
                        "longitude": "138.62825000"
                    },
                    {
                        "id": 7073,
                        "name": "Rosewater",
                        "latitude": "-34.85200000",
                        "longitude": "138.52158000"
                    },
                    {
                        "id": 7078,
                        "name": "Rosslyn Park",
                        "latitude": "-34.92194000",
                        "longitude": "138.67553000"
                    },
                    {
                        "id": 7080,
                        "name": "Rostrevor",
                        "latitude": "-34.89386000",
                        "longitude": "138.69183000"
                    },
                    {
                        "id": 7085,
                        "name": "Roxby Downs",
                        "latitude": "-30.54892000",
                        "longitude": "136.88377000"
                    },
                    {
                        "id": 7086,
                        "name": "Royal Park",
                        "latitude": "-34.87415000",
                        "longitude": "138.51189000"
                    },
                    {
                        "id": 7087,
                        "name": "Royston Park",
                        "latitude": "-34.89757000",
                        "longitude": "138.63150000"
                    },
                    {
                        "id": 7119,
                        "name": "Salisbury",
                        "latitude": "-34.76827000",
                        "longitude": "138.60831000"
                    },
                    {
                        "id": 7121,
                        "name": "Salisbury Downs",
                        "latitude": "-34.76772000",
                        "longitude": "138.62210000"
                    },
                    {
                        "id": 7122,
                        "name": "Salisbury East",
                        "latitude": "-34.79052000",
                        "longitude": "138.65450000"
                    },
                    {
                        "id": 7123,
                        "name": "Salisbury Heights",
                        "latitude": "-34.76310000",
                        "longitude": "138.67591000"
                    },
                    {
                        "id": 7124,
                        "name": "Salisbury North",
                        "latitude": "-34.74956000",
                        "longitude": "138.62060000"
                    },
                    {
                        "id": 7125,
                        "name": "Salisbury Park",
                        "latitude": "-34.76155000",
                        "longitude": "138.67029000"
                    },
                    {
                        "id": 7126,
                        "name": "Salisbury Plain",
                        "latitude": "-34.77265000",
                        "longitude": "138.66330000"
                    },
                    {
                        "id": 7159,
                        "name": "Seacliff",
                        "latitude": "-35.03474000",
                        "longitude": "138.52288000"
                    },
                    {
                        "id": 7160,
                        "name": "Seacliff Park",
                        "latitude": "-35.02983000",
                        "longitude": "138.53129000"
                    },
                    {
                        "id": 7161,
                        "name": "Seacombe Gardens",
                        "latitude": "-35.02336000",
                        "longitude": "138.54580000"
                    },
                    {
                        "id": 7162,
                        "name": "Seacombe Heights",
                        "latitude": "-35.03264000",
                        "longitude": "138.54584000"
                    },
                    {
                        "id": 7164,
                        "name": "Seaford",
                        "latitude": "-35.18980000",
                        "longitude": "138.47589000"
                    },
                    {
                        "id": 7165,
                        "name": "Seaford Meadows",
                        "latitude": "-35.17276000",
                        "longitude": "138.48790000"
                    },
                    {
                        "id": 7166,
                        "name": "Seaford Rise",
                        "latitude": "-35.19296000",
                        "longitude": "138.48172000"
                    },
                    {
                        "id": 7169,
                        "name": "Seaton",
                        "latitude": "-34.90000000",
                        "longitude": "138.51667000"
                    },
                    {
                        "id": 7170,
                        "name": "Seaview Downs",
                        "latitude": "-35.03698000",
                        "longitude": "138.53796000"
                    },
                    {
                        "id": 7175,
                        "name": "Sefton Park",
                        "latitude": "-34.87405000",
                        "longitude": "138.60343000"
                    },
                    {
                        "id": 7177,
                        "name": "Sellicks Beach",
                        "latitude": "-35.33869000",
                        "longitude": "138.44734000"
                    },
                    {
                        "id": 7178,
                        "name": "Semaphore",
                        "latitude": "-34.83934000",
                        "longitude": "138.48228000"
                    },
                    {
                        "id": 7179,
                        "name": "Semaphore Park",
                        "latitude": "-34.85072000",
                        "longitude": "138.47889000"
                    },
                    {
                        "id": 7180,
                        "name": "Semaphore South",
                        "latitude": "-34.84975000",
                        "longitude": "138.47949000"
                    },
                    {
                        "id": 7196,
                        "name": "Sheidow Park",
                        "latitude": "-35.07928000",
                        "longitude": "138.52738000"
                    },
                    {
                        "id": 7227,
                        "name": "Smithfield",
                        "latitude": "-34.68333000",
                        "longitude": "138.68333000"
                    },
                    {
                        "id": 7229,
                        "name": "Smithfield Plains",
                        "latitude": "-34.67643000",
                        "longitude": "138.67785000"
                    },
                    {
                        "id": 7238,
                        "name": "Solomontown",
                        "latitude": "-33.18530000",
                        "longitude": "138.02364000"
                    },
                    {
                        "id": 7243,
                        "name": "Somerton Park",
                        "latitude": "-34.99705000",
                        "longitude": "138.52155000"
                    },
                    {
                        "id": 7252,
                        "name": "South Brighton",
                        "latitude": "-35.02765000",
                        "longitude": "138.52798000"
                    },
                    {
                        "id": 7282,
                        "name": "South Plympton",
                        "latitude": "-34.97682000",
                        "longitude": "138.55588000"
                    },
                    {
                        "id": 7295,
                        "name": "Southern Mallee",
                        "latitude": "-35.36733000",
                        "longitude": "140.52030000"
                    },
                    {
                        "id": 7318,
                        "name": "St Agnes",
                        "latitude": "-34.83075000",
                        "longitude": "138.71074000"
                    },
                    {
                        "id": 7324,
                        "name": "St Georges",
                        "latitude": "-34.95200000",
                        "longitude": "138.64787000"
                    },
                    {
                        "id": 7335,
                        "name": "St Marys",
                        "latitude": "-35.00423000",
                        "longitude": "138.57983000"
                    },
                    {
                        "id": 7336,
                        "name": "St Morris",
                        "latitude": "-34.91107000",
                        "longitude": "138.65360000"
                    },
                    {
                        "id": 7337,
                        "name": "St Peters",
                        "latitude": "-34.90498000",
                        "longitude": "138.62255000"
                    },
                    {
                        "id": 7346,
                        "name": "Stirling",
                        "latitude": "-35.00220000",
                        "longitude": "138.71956000"
                    },
                    {
                        "id": 7349,
                        "name": "Stirling North",
                        "latitude": "-32.47986000",
                        "longitude": "137.83804000"
                    },
                    {
                        "id": 7353,
                        "name": "Stonyfell",
                        "latitude": "-34.93422000",
                        "longitude": "138.67674000"
                    },
                    {
                        "id": 7355,
                        "name": "Strathalbyn",
                        "latitude": "-35.25979000",
                        "longitude": "138.89247000"
                    },
                    {
                        "id": 7366,
                        "name": "Streaky Bay",
                        "latitude": "-32.73808000",
                        "longitude": "134.55116000"
                    },
                    {
                        "id": 7370,
                        "name": "Sturt",
                        "latitude": "-35.02303000",
                        "longitude": "138.55476000"
                    },
                    {
                        "id": 7393,
                        "name": "Surrey Downs",
                        "latitude": "-34.79951000",
                        "longitude": "138.71154000"
                    },
                    {
                        "id": 7416,
                        "name": "Tailem Bend",
                        "latitude": "-35.25226000",
                        "longitude": "139.45546000"
                    },
                    {
                        "id": 7431,
                        "name": "Tanunda",
                        "latitude": "-34.52336000",
                        "longitude": "138.95982000"
                    },
                    {
                        "id": 7432,
                        "name": "Taperoo",
                        "latitude": "-34.80425000",
                        "longitude": "138.49593000"
                    },
                    {
                        "id": 7448,
                        "name": "Tatiara",
                        "latitude": "-36.22232000",
                        "longitude": "140.50748000"
                    },
                    {
                        "id": 7454,
                        "name": "Tea Tree Gully",
                        "latitude": "-34.80171000",
                        "longitude": "138.71994000"
                    },
                    {
                        "id": 7469,
                        "name": "Tennyson",
                        "latitude": "-34.88601000",
                        "longitude": "138.48588000"
                    },
                    {
                        "id": 7481,
                        "name": "The Coorong",
                        "latitude": "-35.71844000",
                        "longitude": "139.70329000"
                    },
                    {
                        "id": 7497,
                        "name": "Thebarton",
                        "latitude": "-34.91667000",
                        "longitude": "138.56667000"
                    },
                    {
                        "id": 7536,
                        "name": "Toorak Gardens",
                        "latitude": "-34.93478000",
                        "longitude": "138.63639000"
                    },
                    {
                        "id": 7545,
                        "name": "Torrens Park",
                        "latitude": "-34.97607000",
                        "longitude": "138.61034000"
                    },
                    {
                        "id": 7546,
                        "name": "Torrensville",
                        "latitude": "-34.92046000",
                        "longitude": "138.56149000"
                    },
                    {
                        "id": 7557,
                        "name": "Tranmere",
                        "latitude": "-34.90550000",
                        "longitude": "138.66212000"
                    },
                    {
                        "id": 7566,
                        "name": "Trinity Gardens",
                        "latitude": "-34.91438000",
                        "longitude": "138.64141000"
                    },
                    {
                        "id": 7568,
                        "name": "Trott Park",
                        "latitude": "-35.07576000",
                        "longitude": "138.54189000"
                    },
                    {
                        "id": 7578,
                        "name": "Tumby Bay",
                        "latitude": "-34.19697000",
                        "longitude": "136.13649000"
                    },
                    {
                        "id": 7588,
                        "name": "Tusmore",
                        "latitude": "-34.93894000",
                        "longitude": "138.65059000"
                    },
                    {
                        "id": 7595,
                        "name": "Two Wells",
                        "latitude": "-34.59327000",
                        "longitude": "138.51367000"
                    },
                    {
                        "id": 7602,
                        "name": "Underdale",
                        "latitude": "-34.91803000",
                        "longitude": "138.54704000"
                    },
                    {
                        "id": 7604,
                        "name": "Unley",
                        "latitude": "-34.95392000",
                        "longitude": "138.60798000"
                    },
                    {
                        "id": 7605,
                        "name": "Unley Park",
                        "latitude": "-34.96388000",
                        "longitude": "138.60776000"
                    },
                    {
                        "id": 7621,
                        "name": "Vale Park",
                        "latitude": "-34.88604000",
                        "longitude": "138.62714000"
                    },
                    {
                        "id": 7625,
                        "name": "Valley View",
                        "latitude": "-34.83994000",
                        "longitude": "138.66072000"
                    },
                    {
                        "id": 7631,
                        "name": "Victor Harbor",
                        "latitude": "-35.51605000",
                        "longitude": "138.54610000"
                    },
                    {
                        "id": 7642,
                        "name": "Virginia",
                        "latitude": "-34.66630000",
                        "longitude": "138.56027000"
                    },
                    {
                        "id": 7657,
                        "name": "Waikerie",
                        "latitude": "-34.18178000",
                        "longitude": "139.98552000"
                    },
                    {
                        "id": 7660,
                        "name": "Wakefield",
                        "latitude": "-34.00743000",
                        "longitude": "138.39455000"
                    },
                    {
                        "id": 7667,
                        "name": "Walkerville",
                        "latitude": "-34.89443000",
                        "longitude": "138.61626000"
                    },
                    {
                        "id": 7668,
                        "name": "Walkley Heights",
                        "latitude": "-34.83668000",
                        "longitude": "138.64368000"
                    },
                    {
                        "id": 7672,
                        "name": "Wallaroo",
                        "latitude": "-33.93881000",
                        "longitude": "137.63365000"
                    },
                    {
                        "id": 7711,
                        "name": "Warradale",
                        "latitude": "-34.99717000",
                        "longitude": "138.53155000"
                    },
                    {
                        "id": 7731,
                        "name": "Waterloo Corner",
                        "latitude": "-34.71667000",
                        "longitude": "138.58333000"
                    },
                    {
                        "id": 7740,
                        "name": "Wattle Park",
                        "latitude": "-34.92516000",
                        "longitude": "138.67501000"
                    },
                    {
                        "id": 7742,
                        "name": "Wattle Range",
                        "latitude": "-37.50804000",
                        "longitude": "140.42114000"
                    },
                    {
                        "id": 7750,
                        "name": "Wayville",
                        "latitude": "-34.94468000",
                        "longitude": "138.59132000"
                    },
                    {
                        "id": 7779,
                        "name": "West Beach",
                        "latitude": "-34.94597000",
                        "longitude": "138.50935000"
                    },
                    {
                        "id": 7783,
                        "name": "West Croydon",
                        "latitude": "-34.89448000",
                        "longitude": "138.55931000"
                    },
                    {
                        "id": 7789,
                        "name": "West Hindmarsh",
                        "latitude": "-34.90794000",
                        "longitude": "138.56412000"
                    },
                    {
                        "id": 7793,
                        "name": "West Lakes",
                        "latitude": "-34.87299000",
                        "longitude": "138.49458000"
                    },
                    {
                        "id": 7794,
                        "name": "West Lakes Shore",
                        "latitude": "-34.86010000",
                        "longitude": "138.48966000"
                    },
                    {
                        "id": 7816,
                        "name": "Westbourne Park",
                        "latitude": "-34.97165000",
                        "longitude": "138.59525000"
                    },
                    {
                        "id": 7843,
                        "name": "Whyalla",
                        "latitude": "-33.04569000",
                        "longitude": "137.54468000"
                    },
                    {
                        "id": 7844,
                        "name": "Whyalla Jenkins",
                        "latitude": "-33.02205000",
                        "longitude": "137.51269000"
                    },
                    {
                        "id": 7845,
                        "name": "Whyalla Norrie",
                        "latitude": "-33.02903000",
                        "longitude": "137.53922000"
                    },
                    {
                        "id": 7846,
                        "name": "Whyalla Playford",
                        "latitude": "-33.02788000",
                        "longitude": "137.56196000"
                    },
                    {
                        "id": 7847,
                        "name": "Whyalla Stuart",
                        "latitude": "-33.02493000",
                        "longitude": "137.52471000"
                    },
                    {
                        "id": 7854,
                        "name": "Willaston",
                        "latitude": "-34.58640000",
                        "longitude": "138.74124000"
                    },
                    {
                        "id": 7859,
                        "name": "Williamstown",
                        "latitude": "-34.67210000",
                        "longitude": "138.89108000"
                    },
                    {
                        "id": 7867,
                        "name": "Willunga",
                        "latitude": "-35.27127000",
                        "longitude": "138.55417000"
                    },
                    {
                        "id": 7883,
                        "name": "Windsor Gardens",
                        "latitude": "-34.86538000",
                        "longitude": "138.64703000"
                    },
                    {
                        "id": 7915,
                        "name": "Woodcroft",
                        "latitude": "-35.10236000",
                        "longitude": "138.56292000"
                    },
                    {
                        "id": 7926,
                        "name": "Woodside",
                        "latitude": "-34.95433000",
                        "longitude": "138.87901000"
                    },
                    {
                        "id": 7928,
                        "name": "Woodville",
                        "latitude": "-34.87700000",
                        "longitude": "138.54291000"
                    },
                    {
                        "id": 7929,
                        "name": "Woodville Gardens",
                        "latitude": "-34.86788000",
                        "longitude": "138.54798000"
                    },
                    {
                        "id": 7930,
                        "name": "Woodville North",
                        "latitude": "-34.87200000",
                        "longitude": "138.54309000"
                    },
                    {
                        "id": 7931,
                        "name": "Woodville Park",
                        "latitude": "-34.88696000",
                        "longitude": "138.54648000"
                    },
                    {
                        "id": 7932,
                        "name": "Woodville South",
                        "latitude": "-34.88186000",
                        "longitude": "138.53477000"
                    },
                    {
                        "id": 7933,
                        "name": "Woodville West",
                        "latitude": "-34.88640000",
                        "longitude": "138.53095000"
                    },
                    {
                        "id": 7956,
                        "name": "Wudinna",
                        "latitude": "-32.97747000",
                        "longitude": "135.39170000"
                    },
                    {
                        "id": 7972,
                        "name": "Wynn Vale",
                        "latitude": "-34.79942000",
                        "longitude": "138.68714000"
                    },
                    {
                        "id": 7993,
                        "name": "Yankalilla",
                        "latitude": "-35.49390000",
                        "longitude": "138.34225000"
                    },
                    {
                        "id": 8026,
                        "name": "Yorke Peninsula",
                        "latitude": "-34.70549000",
                        "longitude": "137.58179000"
                    }
                ]
            },
            {
                "id": 3908,
                "name": "Tasmania",
                "iso2": "TAS",
                "latitude": "-41.45451960",
                "longitude": "145.97066470",
                "type": "state",
                "cities": [
                    {
                        "id": 3916,
                        "name": "Acton Park",
                        "latitude": "-42.87932000",
                        "longitude": "147.48459000"
                    },
                    {
                        "id": 4047,
                        "name": "Austins Ferry",
                        "latitude": "-42.76667000",
                        "longitude": "147.25000000"
                    },
                    {
                        "id": 4062,
                        "name": "Bagdad",
                        "latitude": "-42.62968000",
                        "longitude": "147.22339000"
                    },
                    {
                        "id": 4145,
                        "name": "Battery Point",
                        "latitude": "-42.88995000",
                        "longitude": "147.33324000"
                    },
                    {
                        "id": 4160,
                        "name": "Beaconsfield",
                        "latitude": "-41.20227000",
                        "longitude": "146.81723000"
                    },
                    {
                        "id": 4170,
                        "name": "Beauty Point",
                        "latitude": "-41.16216000",
                        "longitude": "146.82146000"
                    },
                    {
                        "id": 4200,
                        "name": "Bellerive",
                        "latitude": "-42.87551000",
                        "longitude": "147.37030000"
                    },
                    {
                        "id": 4239,
                        "name": "Berriedale",
                        "latitude": "-42.81667000",
                        "longitude": "147.25000000"
                    },
                    {
                        "id": 4289,
                        "name": "Blackmans Bay",
                        "latitude": "-43.00311000",
                        "longitude": "147.31694000"
                    },
                    {
                        "id": 4292,
                        "name": "Blackstone Heights",
                        "latitude": "-41.45977000",
                        "longitude": "147.08407000"
                    },
                    {
                        "id": 4387,
                        "name": "Break O'Day",
                        "latitude": "-41.39069000",
                        "longitude": "147.97477000"
                    },
                    {
                        "id": 4398,
                        "name": "Bridgewater",
                        "latitude": "-42.73719000",
                        "longitude": "147.22784000"
                    },
                    {
                        "id": 4399,
                        "name": "Bridport",
                        "latitude": "-41.00046000",
                        "longitude": "147.39175000"
                    },
                    {
                        "id": 4404,
                        "name": "Brighton",
                        "latitude": "-42.72673000",
                        "longitude": "147.24233000"
                    },
                    {
                        "id": 4484,
                        "name": "Burnie",
                        "latitude": "-41.19650000",
                        "longitude": "145.81136000"
                    },
                    {
                        "id": 4540,
                        "name": "Cambridge",
                        "latitude": "-42.83333000",
                        "longitude": "147.45000000"
                    },
                    {
                        "id": 4649,
                        "name": "Central Coast",
                        "latitude": "-41.26999000",
                        "longitude": "146.05916000"
                    },
                    {
                        "id": 4653,
                        "name": "Central Highlands",
                        "latitude": "-42.19653000",
                        "longitude": "146.63934000"
                    },
                    {
                        "id": 4689,
                        "name": "Chigwell",
                        "latitude": "-42.80912000",
                        "longitude": "147.24480000"
                    },
                    {
                        "id": 4707,
                        "name": "Circular Head",
                        "latitude": "-41.01991000",
                        "longitude": "145.08366000"
                    },
                    {
                        "id": 4717,
                        "name": "Claremont",
                        "latitude": "-42.78333000",
                        "longitude": "147.25000000"
                    },
                    {
                        "id": 4720,
                        "name": "Clarence",
                        "latitude": "-42.87369000",
                        "longitude": "147.44725000"
                    },
                    {
                        "id": 4725,
                        "name": "Clarendon Vale",
                        "latitude": "-42.88988000",
                        "longitude": "147.44368000"
                    },
                    {
                        "id": 4878,
                        "name": "Cressy",
                        "latitude": "-41.68561000",
                        "longitude": "147.07792000"
                    },
                    {
                        "id": 4911,
                        "name": "Currie",
                        "latitude": "-39.92976000",
                        "longitude": "143.85385000"
                    },
                    {
                        "id": 4917,
                        "name": "Cygnet",
                        "latitude": "-43.15333000",
                        "longitude": "147.07253000"
                    },
                    {
                        "id": 4967,
                        "name": "Deloraine",
                        "latitude": "-41.52477000",
                        "longitude": "146.65701000"
                    },
                    {
                        "id": 4981,
                        "name": "Derwent Valley",
                        "latitude": "-42.80383000",
                        "longitude": "146.52970000"
                    },
                    {
                        "id": 4984,
                        "name": "Devonport",
                        "latitude": "-41.21296000",
                        "longitude": "146.32401000"
                    },
                    {
                        "id": 4999,
                        "name": "Dodges Ferry",
                        "latitude": "-42.85315000",
                        "longitude": "147.62263000"
                    },
                    {
                        "id": 5015,
                        "name": "Dorset",
                        "latitude": "-41.04789000",
                        "longitude": "147.73167000"
                    },
                    {
                        "id": 5052,
                        "name": "Dynnyrne",
                        "latitude": "-42.90541000",
                        "longitude": "147.31576000"
                    },
                    {
                        "id": 5073,
                        "name": "East Devonport",
                        "latitude": "-41.18792000",
                        "longitude": "146.38660000"
                    },
                    {
                        "id": 5085,
                        "name": "East Launceston",
                        "latitude": "-41.43843000",
                        "longitude": "147.15101000"
                    },
                    {
                        "id": 5191,
                        "name": "Evandale",
                        "latitude": "-41.56858000",
                        "longitude": "147.25271000"
                    },
                    {
                        "id": 5250,
                        "name": "Flinders",
                        "latitude": "-40.03799000",
                        "longitude": "148.13965000"
                    },
                    {
                        "id": 5277,
                        "name": "Franklin",
                        "latitude": "-43.08884000",
                        "longitude": "147.00906000"
                    },
                    {
                        "id": 5297,
                        "name": "Gagebrook",
                        "latitude": "-42.74770000",
                        "longitude": "147.26984000"
                    },
                    {
                        "id": 5319,
                        "name": "Geeveston",
                        "latitude": "-43.16337000",
                        "longitude": "146.92549000"
                    },
                    {
                        "id": 5320,
                        "name": "Geilston Bay",
                        "latitude": "-42.82955000",
                        "longitude": "147.34630000"
                    },
                    {
                        "id": 5324,
                        "name": "George Town",
                        "latitude": "-41.11982000",
                        "longitude": "147.01731000"
                    },
                    {
                        "id": 5350,
                        "name": "Glamorgan\/Spring Bay",
                        "latitude": "-42.27832000",
                        "longitude": "147.96675000"
                    },
                    {
                        "id": 5385,
                        "name": "Glenorchy",
                        "latitude": "-42.83188000",
                        "longitude": "147.22954000"
                    },
                    {
                        "id": 5409,
                        "name": "Goodwood",
                        "latitude": "-42.82822000",
                        "longitude": "147.29301000"
                    },
                    {
                        "id": 5438,
                        "name": "Granton",
                        "latitude": "-42.75149000",
                        "longitude": "147.22795000"
                    },
                    {
                        "id": 5503,
                        "name": "Hadspen",
                        "latitude": "-41.50059000",
                        "longitude": "147.07359000"
                    },
                    {
                        "id": 5582,
                        "name": "Herdsmans Cove",
                        "latitude": "-42.75066000",
                        "longitude": "147.26483000"
                    },
                    {
                        "id": 5609,
                        "name": "Hillcrest",
                        "latitude": "-41.06324000",
                        "longitude": "145.89437000"
                    },
                    {
                        "id": 5621,
                        "name": "Hobart",
                        "latitude": "-42.87936000",
                        "longitude": "147.32941000"
                    },
                    {
                        "id": 5622,
                        "name": "Hobart city centre",
                        "latitude": "-42.88280000",
                        "longitude": "147.32582000"
                    },
                    {
                        "id": 5660,
                        "name": "Howrah",
                        "latitude": "-42.88728000",
                        "longitude": "147.40554000"
                    },
                    {
                        "id": 5673,
                        "name": "Huon Valley",
                        "latitude": "-43.29385000",
                        "longitude": "146.56555000"
                    },
                    {
                        "id": 5674,
                        "name": "Huonville",
                        "latitude": "-43.03124000",
                        "longitude": "147.04813000"
                    },
                    {
                        "id": 5700,
                        "name": "Invermay",
                        "latitude": "-41.42036000",
                        "longitude": "147.13358000"
                    },
                    {
                        "id": 5835,
                        "name": "Kentish",
                        "latitude": "-41.46341000",
                        "longitude": "146.17726000"
                    },
                    {
                        "id": 5865,
                        "name": "King Island",
                        "latitude": "-39.87215000",
                        "longitude": "143.99153000"
                    },
                    {
                        "id": 5867,
                        "name": "Kingborough",
                        "latitude": "-42.97451000",
                        "longitude": "147.25113000"
                    },
                    {
                        "id": 5872,
                        "name": "Kings Meadows",
                        "latitude": "-41.47041000",
                        "longitude": "147.16196000"
                    },
                    {
                        "id": 5882,
                        "name": "Kingston",
                        "latitude": "-42.97638000",
                        "longitude": "147.30351000"
                    },
                    {
                        "id": 5887,
                        "name": "Kingston Beach",
                        "latitude": "-42.98021000",
                        "longitude": "147.31941000"
                    },
                    {
                        "id": 5982,
                        "name": "Latrobe",
                        "latitude": "-41.21551000",
                        "longitude": "146.40656000"
                    },
                    {
                        "id": 5984,
                        "name": "Lauderdale",
                        "latitude": "-42.91364000",
                        "longitude": "147.48747000"
                    },
                    {
                        "id": 5985,
                        "name": "Launceston",
                        "latitude": "-41.43876000",
                        "longitude": "147.13467000"
                    },
                    {
                        "id": 5986,
                        "name": "Launceston city centre",
                        "latitude": "-41.43352000",
                        "longitude": "147.13780000"
                    },
                    {
                        "id": 6000,
                        "name": "Legana",
                        "latitude": "-41.36572000",
                        "longitude": "147.04584000"
                    },
                    {
                        "id": 6005,
                        "name": "Lenah Valley",
                        "latitude": "-42.87146000",
                        "longitude": "147.27514000"
                    },
                    {
                        "id": 6028,
                        "name": "Lindisfarne",
                        "latitude": "-42.84837000",
                        "longitude": "147.36192000"
                    },
                    {
                        "id": 6064,
                        "name": "Longford",
                        "latitude": "-41.60512000",
                        "longitude": "147.11887000"
                    },
                    {
                        "id": 6087,
                        "name": "Lutana",
                        "latitude": "-42.83475000",
                        "longitude": "147.31152000"
                    },
                    {
                        "id": 6177,
                        "name": "Margate",
                        "latitude": "-43.02814000",
                        "longitude": "147.26256000"
                    },
                    {
                        "id": 6207,
                        "name": "Mayfield",
                        "latitude": "-41.38760000",
                        "longitude": "147.13052000"
                    },
                    {
                        "id": 6229,
                        "name": "Meander Valley",
                        "latitude": "-41.64952000",
                        "longitude": "146.54572000"
                    },
                    {
                        "id": 6268,
                        "name": "Miandetta",
                        "latitude": "-41.19550000",
                        "longitude": "146.35322000"
                    },
                    {
                        "id": 6282,
                        "name": "Midway Point",
                        "latitude": "-42.79480000",
                        "longitude": "147.52883000"
                    },
                    {
                        "id": 6350,
                        "name": "Montello",
                        "latitude": "-41.05762000",
                        "longitude": "145.89626000"
                    },
                    {
                        "id": 6355,
                        "name": "Montrose",
                        "latitude": "-42.82895000",
                        "longitude": "147.24735000"
                    },
                    {
                        "id": 6359,
                        "name": "Moonah",
                        "latitude": "-42.84617000",
                        "longitude": "147.30228000"
                    },
                    {
                        "id": 6389,
                        "name": "Mornington",
                        "latitude": "-42.86267000",
                        "longitude": "147.39819000"
                    },
                    {
                        "id": 6446,
                        "name": "Mount Nelson",
                        "latitude": "-42.92073000",
                        "longitude": "147.32069000"
                    },
                    {
                        "id": 6459,
                        "name": "Mount Stuart",
                        "latitude": "-42.87157000",
                        "longitude": "147.30164000"
                    },
                    {
                        "id": 6467,
                        "name": "Mowbray",
                        "latitude": "-41.40243000",
                        "longitude": "147.15059000"
                    },
                    {
                        "id": 6560,
                        "name": "New Norfolk",
                        "latitude": "-42.78261000",
                        "longitude": "147.05870000"
                    },
                    {
                        "id": 6561,
                        "name": "New Town",
                        "latitude": "-42.85758000",
                        "longitude": "147.30869000"
                    },
                    {
                        "id": 6571,
                        "name": "Newnham",
                        "latitude": "-41.38969000",
                        "longitude": "147.11397000"
                    },
                    {
                        "id": 6575,
                        "name": "Newstead",
                        "latitude": "-41.44108000",
                        "longitude": "147.16183000"
                    },
                    {
                        "id": 6632,
                        "name": "North Hobart",
                        "latitude": "-42.87406000",
                        "longitude": "147.31597000"
                    },
                    {
                        "id": 6668,
                        "name": "Northern Midlands",
                        "latitude": "-41.87988000",
                        "longitude": "147.45776000"
                    },
                    {
                        "id": 6674,
                        "name": "Norwood",
                        "latitude": "-41.45920000",
                        "longitude": "147.18077000"
                    },
                    {
                        "id": 6697,
                        "name": "Oakdowns",
                        "latitude": "-42.90178000",
                        "longitude": "147.45595000"
                    },
                    {
                        "id": 6715,
                        "name": "Old Beach",
                        "latitude": "-42.77758000",
                        "longitude": "147.26659000"
                    },
                    {
                        "id": 6787,
                        "name": "Park Grove",
                        "latitude": "-41.05478000",
                        "longitude": "145.88201000"
                    },
                    {
                        "id": 6828,
                        "name": "Penguin",
                        "latitude": "-41.12258000",
                        "longitude": "146.07318000"
                    },
                    {
                        "id": 6839,
                        "name": "Perth",
                        "latitude": "-41.57231000",
                        "longitude": "147.17096000"
                    },
                    {
                        "id": 6906,
                        "name": "Port Sorell",
                        "latitude": "-41.16652000",
                        "longitude": "146.55283000"
                    },
                    {
                        "id": 6924,
                        "name": "Prospect Vale",
                        "latitude": "-41.48100000",
                        "longitude": "147.10406000"
                    },
                    {
                        "id": 6943,
                        "name": "Queenstown",
                        "latitude": "-42.08050000",
                        "longitude": "145.55646000"
                    },
                    {
                        "id": 6959,
                        "name": "Ranelagh",
                        "latitude": "-43.00977000",
                        "longitude": "147.03764000"
                    },
                    {
                        "id": 6970,
                        "name": "Ravenswood",
                        "latitude": "-41.41593000",
                        "longitude": "147.18250000"
                    },
                    {
                        "id": 7009,
                        "name": "Richmond",
                        "latitude": "-42.73554000",
                        "longitude": "147.43833000"
                    },
                    {
                        "id": 7021,
                        "name": "Risdon Vale",
                        "latitude": "-42.81242000",
                        "longitude": "147.35654000"
                    },
                    {
                        "id": 7024,
                        "name": "Riverside",
                        "latitude": "-41.42105000",
                        "longitude": "147.05086000"
                    },
                    {
                        "id": 7039,
                        "name": "Rocherlea",
                        "latitude": "-41.38083000",
                        "longitude": "147.15738000"
                    },
                    {
                        "id": 7050,
                        "name": "Rokeby",
                        "latitude": "-42.89875000",
                        "longitude": "147.44917000"
                    },
                    {
                        "id": 7053,
                        "name": "Romaine",
                        "latitude": "-41.09944000",
                        "longitude": "145.89376000"
                    },
                    {
                        "id": 7070,
                        "name": "Rosetta",
                        "latitude": "-42.82105000",
                        "longitude": "147.25258000"
                    },
                    {
                        "id": 7115,
                        "name": "Saint Leonards",
                        "latitude": "-41.45672000",
                        "longitude": "147.19952000"
                    },
                    {
                        "id": 7134,
                        "name": "Sandford",
                        "latitude": "-42.93333000",
                        "longitude": "147.50000000"
                    },
                    {
                        "id": 7141,
                        "name": "Sandy Bay",
                        "latitude": "-42.89449000",
                        "longitude": "147.32439000"
                    },
                    {
                        "id": 7156,
                        "name": "Scottsdale",
                        "latitude": "-41.15780000",
                        "longitude": "147.51727000"
                    },
                    {
                        "id": 7185,
                        "name": "Seven Mile Beach",
                        "latitude": "-42.85863000",
                        "longitude": "147.50532000"
                    },
                    {
                        "id": 7194,
                        "name": "Shearwater",
                        "latitude": "-41.15673000",
                        "longitude": "146.53178000"
                    },
                    {
                        "id": 7195,
                        "name": "Sheffield",
                        "latitude": "-41.39947000",
                        "longitude": "146.33897000"
                    },
                    {
                        "id": 7209,
                        "name": "Shorewell Park",
                        "latitude": "-41.06990000",
                        "longitude": "145.87689000"
                    },
                    {
                        "id": 7231,
                        "name": "Smithton",
                        "latitude": "-40.84587000",
                        "longitude": "145.12498000"
                    },
                    {
                        "id": 7234,
                        "name": "Snug",
                        "latitude": "-43.06669000",
                        "longitude": "147.25468000"
                    },
                    {
                        "id": 7242,
                        "name": "Somerset",
                        "latitude": "-41.04065000",
                        "longitude": "145.83055000"
                    },
                    {
                        "id": 7246,
                        "name": "Sorell",
                        "latitude": "-42.78908000",
                        "longitude": "147.69488000"
                    },
                    {
                        "id": 7265,
                        "name": "South Hobart",
                        "latitude": "-42.89459000",
                        "longitude": "147.30924000"
                    },
                    {
                        "id": 7272,
                        "name": "South Launceston",
                        "latitude": "-41.45506000",
                        "longitude": "147.14556000"
                    },
                    {
                        "id": 7296,
                        "name": "Southern Midlands",
                        "latitude": "-42.41785000",
                        "longitude": "147.43414000"
                    },
                    {
                        "id": 7306,
                        "name": "Spreyton",
                        "latitude": "-41.23524000",
                        "longitude": "146.35108000"
                    },
                    {
                        "id": 7326,
                        "name": "St Helens",
                        "latitude": "-41.32028000",
                        "longitude": "148.23889000"
                    },
                    {
                        "id": 7375,
                        "name": "Summerhill",
                        "latitude": "-41.46747000",
                        "longitude": "147.12796000"
                    },
                    {
                        "id": 7441,
                        "name": "Taroona",
                        "latitude": "-42.94520000",
                        "longitude": "147.34840000"
                    },
                    {
                        "id": 7446,
                        "name": "Tasman Peninsula",
                        "latitude": "-43.16245000",
                        "longitude": "147.94739000"
                    },
                    {
                        "id": 7556,
                        "name": "Tranmere",
                        "latitude": "-42.92179000",
                        "longitude": "147.41701000"
                    },
                    {
                        "id": 7563,
                        "name": "Trevallyn",
                        "latitude": "-41.44246000",
                        "longitude": "147.10484000"
                    },
                    {
                        "id": 7583,
                        "name": "Turners Beach",
                        "latitude": "-41.16060000",
                        "longitude": "146.23193000"
                    },
                    {
                        "id": 7599,
                        "name": "Ulverstone",
                        "latitude": "-41.16026000",
                        "longitude": "146.18242000"
                    },
                    {
                        "id": 7606,
                        "name": "Upper Burnie",
                        "latitude": "-41.07139000",
                        "longitude": "145.89960000"
                    },
                    {
                        "id": 7701,
                        "name": "Waratah\/Wynyard",
                        "latitude": "-41.30709000",
                        "longitude": "145.45831000"
                    },
                    {
                        "id": 7715,
                        "name": "Warrane",
                        "latitude": "-42.85546000",
                        "longitude": "147.38297000"
                    },
                    {
                        "id": 7748,
                        "name": "Waverley",
                        "latitude": "-41.43602000",
                        "longitude": "147.18588000"
                    },
                    {
                        "id": 7782,
                        "name": "West Coast",
                        "latitude": "-42.45246000",
                        "longitude": "145.52264000"
                    },
                    {
                        "id": 7790,
                        "name": "West Hobart",
                        "latitude": "-42.87658000",
                        "longitude": "147.30688000"
                    },
                    {
                        "id": 7796,
                        "name": "West Launceston",
                        "latitude": "-41.45092000",
                        "longitude": "147.13114000"
                    },
                    {
                        "id": 7800,
                        "name": "West Moonah",
                        "latitude": "-42.84996000",
                        "longitude": "147.28181000"
                    },
                    {
                        "id": 7807,
                        "name": "West Tamar",
                        "latitude": "-41.26441000",
                        "longitude": "146.89123000"
                    },
                    {
                        "id": 7809,
                        "name": "West Ulverstone",
                        "latitude": "-41.14744000",
                        "longitude": "146.12670000"
                    },
                    {
                        "id": 7818,
                        "name": "Westbury",
                        "latitude": "-41.52914000",
                        "longitude": "146.83914000"
                    },
                    {
                        "id": 7975,
                        "name": "Wynyard",
                        "latitude": "-40.98970000",
                        "longitude": "145.72617000"
                    },
                    {
                        "id": 8029,
                        "name": "Youngtown",
                        "latitude": "-41.48332000",
                        "longitude": "147.17067000"
                    }
                ]
            },
            {
                "id": 3903,
                "name": "Victoria",
                "iso2": "VIC",
                "latitude": "-36.48564230",
                "longitude": "140.97794250",
                "type": "state",
                "cities": [
                    {
                        "id": 3904,
                        "name": "Abbotsford",
                        "latitude": "-37.80000000",
                        "longitude": "145.00000000"
                    },
                    {
                        "id": 3909,
                        "name": "Aberfeldie",
                        "latitude": "-37.75959000",
                        "longitude": "144.89740000"
                    },
                    {
                        "id": 3926,
                        "name": "Airport West",
                        "latitude": "-37.72470000",
                        "longitude": "144.88126000"
                    },
                    {
                        "id": 3929,
                        "name": "Albanvale",
                        "latitude": "-37.74609000",
                        "longitude": "144.76856000"
                    },
                    {
                        "id": 3934,
                        "name": "Albert Park",
                        "latitude": "-37.84107000",
                        "longitude": "144.95198000"
                    },
                    {
                        "id": 3936,
                        "name": "Albion",
                        "latitude": "-37.78017000",
                        "longitude": "144.81724000"
                    },
                    {
                        "id": 3947,
                        "name": "Alexandra",
                        "latitude": "-37.19132000",
                        "longitude": "145.71120000"
                    },
                    {
                        "id": 3954,
                        "name": "Alfredton",
                        "latitude": "-37.56667000",
                        "longitude": "143.81667000"
                    },
                    {
                        "id": 3960,
                        "name": "Allansford",
                        "latitude": "-38.38639000",
                        "longitude": "142.59431000"
                    },
                    {
                        "id": 3966,
                        "name": "Alphington",
                        "latitude": "-37.78333000",
                        "longitude": "145.03333000"
                    },
                    {
                        "id": 3967,
                        "name": "Alpine",
                        "latitude": "-36.83412000",
                        "longitude": "146.97936000"
                    },
                    {
                        "id": 3970,
                        "name": "Altona",
                        "latitude": "-37.86964000",
                        "longitude": "144.83036000"
                    },
                    {
                        "id": 3971,
                        "name": "Altona Meadows",
                        "latitude": "-37.88413000",
                        "longitude": "144.78367000"
                    },
                    {
                        "id": 3972,
                        "name": "Altona North",
                        "latitude": "-37.83487000",
                        "longitude": "144.84735000"
                    },
                    {
                        "id": 3982,
                        "name": "Anglesea",
                        "latitude": "-38.40730000",
                        "longitude": "144.18587000"
                    },
                    {
                        "id": 3990,
                        "name": "Apollo Bay",
                        "latitude": "-38.75940000",
                        "longitude": "143.67219000"
                    },
                    {
                        "id": 3996,
                        "name": "Ararat",
                        "latitude": "-37.48925000",
                        "longitude": "142.82239000"
                    },
                    {
                        "id": 3999,
                        "name": "Ardeer",
                        "latitude": "-37.77586000",
                        "longitude": "144.80144000"
                    },
                    {
                        "id": 4004,
                        "name": "Armadale",
                        "latitude": "-37.85544000",
                        "longitude": "145.02052000"
                    },
                    {
                        "id": 4006,
                        "name": "Armstrong Creek",
                        "latitude": "-38.23121000",
                        "longitude": "144.37374000"
                    },
                    {
                        "id": 4012,
                        "name": "Ascot",
                        "latitude": "-36.70000000",
                        "longitude": "144.33333000"
                    },
                    {
                        "id": 4015,
                        "name": "Ascot Vale",
                        "latitude": "-37.77988000",
                        "longitude": "144.92276000"
                    },
                    {
                        "id": 4016,
                        "name": "Ashburton",
                        "latitude": "-37.86667000",
                        "longitude": "145.08333000"
                    },
                    {
                        "id": 4028,
                        "name": "Ashwood",
                        "latitude": "-37.86659000",
                        "longitude": "145.10553000"
                    },
                    {
                        "id": 4029,
                        "name": "Aspendale",
                        "latitude": "-38.02913000",
                        "longitude": "145.10266000"
                    },
                    {
                        "id": 4030,
                        "name": "Aspendale Gardens",
                        "latitude": "-38.02277000",
                        "longitude": "145.11798000"
                    },
                    {
                        "id": 4037,
                        "name": "Attwood",
                        "latitude": "-37.66955000",
                        "longitude": "144.88675000"
                    },
                    {
                        "id": 4051,
                        "name": "Avenel",
                        "latitude": "-36.90088000",
                        "longitude": "145.23367000"
                    },
                    {
                        "id": 4053,
                        "name": "Avoca",
                        "latitude": "-37.09044000",
                        "longitude": "143.47365000"
                    },
                    {
                        "id": 4057,
                        "name": "Avondale Heights",
                        "latitude": "-37.76155000",
                        "longitude": "144.86261000"
                    },
                    {
                        "id": 4060,
                        "name": "Bacchus Marsh",
                        "latitude": "-37.67268000",
                        "longitude": "144.43829000"
                    },
                    {
                        "id": 4061,
                        "name": "Badger Creek",
                        "latitude": "-37.70000000",
                        "longitude": "145.51667000"
                    },
                    {
                        "id": 4064,
                        "name": "Bairnsdale",
                        "latitude": "-37.82289000",
                        "longitude": "147.61041000"
                    },
                    {
                        "id": 4068,
                        "name": "Balaclava",
                        "latitude": "-37.86667000",
                        "longitude": "145.00000000"
                    },
                    {
                        "id": 4079,
                        "name": "Ballan",
                        "latitude": "-37.59987000",
                        "longitude": "144.22890000"
                    },
                    {
                        "id": 4080,
                        "name": "Ballarat",
                        "latitude": "-37.56622000",
                        "longitude": "143.84957000"
                    },
                    {
                        "id": 4081,
                        "name": "Ballarat Central",
                        "latitude": "-37.56206000",
                        "longitude": "143.85082000"
                    },
                    {
                        "id": 4082,
                        "name": "Ballarat East",
                        "latitude": "-37.56667000",
                        "longitude": "143.86667000"
                    },
                    {
                        "id": 4083,
                        "name": "Ballarat North",
                        "latitude": "-37.51884000",
                        "longitude": "143.77284000"
                    },
                    {
                        "id": 4088,
                        "name": "Balnarring",
                        "latitude": "-38.36667000",
                        "longitude": "145.13333000"
                    },
                    {
                        "id": 4091,
                        "name": "Balwyn",
                        "latitude": "-37.80914000",
                        "longitude": "145.07890000"
                    },
                    {
                        "id": 4092,
                        "name": "Balwyn North",
                        "latitude": "-37.79086000",
                        "longitude": "145.09386000"
                    },
                    {
                        "id": 4104,
                        "name": "Bannockburn",
                        "latitude": "-38.04894000",
                        "longitude": "144.16882000"
                    },
                    {
                        "id": 4107,
                        "name": "Banyule",
                        "latitude": "-37.73386000",
                        "longitude": "145.08576000"
                    },
                    {
                        "id": 4109,
                        "name": "Baranduda",
                        "latitude": "-36.19114000",
                        "longitude": "146.95380000"
                    },
                    {
                        "id": 4131,
                        "name": "Barwon Heads",
                        "latitude": "-38.27448000",
                        "longitude": "144.48853000"
                    },
                    {
                        "id": 4133,
                        "name": "Bass Coast",
                        "latitude": "-38.48507000",
                        "longitude": "145.46390000"
                    },
                    {
                        "id": 4147,
                        "name": "Baw Baw",
                        "latitude": "-37.96998000",
                        "longitude": "146.14404000"
                    },
                    {
                        "id": 4148,
                        "name": "Baxter",
                        "latitude": "-38.20000000",
                        "longitude": "145.15000000"
                    },
                    {
                        "id": 4152,
                        "name": "Bayside",
                        "latitude": "-37.93986000",
                        "longitude": "145.01932000"
                    },
                    {
                        "id": 4153,
                        "name": "Bayswater",
                        "latitude": "-37.85000000",
                        "longitude": "145.26667000"
                    },
                    {
                        "id": 4155,
                        "name": "Bayswater North",
                        "latitude": "-37.82612000",
                        "longitude": "145.29831000"
                    },
                    {
                        "id": 4161,
                        "name": "Beaconsfield",
                        "latitude": "-38.05000000",
                        "longitude": "145.36667000"
                    },
                    {
                        "id": 4164,
                        "name": "Beaconsfield Upper",
                        "latitude": "-37.99415000",
                        "longitude": "145.41420000"
                    },
                    {
                        "id": 4166,
                        "name": "Beaufort",
                        "latitude": "-37.42996000",
                        "longitude": "143.38347000"
                    },
                    {
                        "id": 4167,
                        "name": "Beaumaris",
                        "latitude": "-37.98534000",
                        "longitude": "145.03361000"
                    },
                    {
                        "id": 4176,
                        "name": "Beechworth",
                        "latitude": "-36.35828000",
                        "longitude": "146.68584000"
                    },
                    {
                        "id": 4188,
                        "name": "Belgrave",
                        "latitude": "-37.91093000",
                        "longitude": "145.35359000"
                    },
                    {
                        "id": 4189,
                        "name": "Belgrave Heights",
                        "latitude": "-37.92624000",
                        "longitude": "145.34367000"
                    },
                    {
                        "id": 4190,
                        "name": "Belgrave South",
                        "latitude": "-37.93333000",
                        "longitude": "145.33333000"
                    },
                    {
                        "id": 4191,
                        "name": "Bell Park",
                        "latitude": "-38.10793000",
                        "longitude": "144.33839000"
                    },
                    {
                        "id": 4192,
                        "name": "Bell Post Hill",
                        "latitude": "-38.09564000",
                        "longitude": "144.31968000"
                    },
                    {
                        "id": 4204,
                        "name": "Bellfield",
                        "latitude": "-37.75309000",
                        "longitude": "145.03848000"
                    },
                    {
                        "id": 4210,
                        "name": "Belmont",
                        "latitude": "-38.17485000",
                        "longitude": "144.34276000"
                    },
                    {
                        "id": 4216,
                        "name": "Benalla",
                        "latitude": "-36.59041000",
                        "longitude": "146.02812000"
                    },
                    {
                        "id": 4218,
                        "name": "Bendigo",
                        "latitude": "-36.75818000",
                        "longitude": "144.28024000"
                    },
                    {
                        "id": 4219,
                        "name": "Bendigo city centre",
                        "latitude": "-36.75698000",
                        "longitude": "144.27957000"
                    },
                    {
                        "id": 4223,
                        "name": "Bentleigh",
                        "latitude": "-37.91806000",
                        "longitude": "145.03544000"
                    },
                    {
                        "id": 4224,
                        "name": "Bentleigh East",
                        "latitude": "-37.91928000",
                        "longitude": "145.05301000"
                    },
                    {
                        "id": 4246,
                        "name": "Berwick",
                        "latitude": "-38.03333000",
                        "longitude": "145.35000000"
                    },
                    {
                        "id": 4248,
                        "name": "Beveridge",
                        "latitude": "-37.48333000",
                        "longitude": "144.98333000"
                    },
                    {
                        "id": 4274,
                        "name": "Bittern",
                        "latitude": "-38.33333000",
                        "longitude": "145.16667000"
                    },
                    {
                        "id": 4276,
                        "name": "Black Hill",
                        "latitude": "-37.55000000",
                        "longitude": "143.86667000"
                    },
                    {
                        "id": 4279,
                        "name": "Black Rock",
                        "latitude": "-37.97357000",
                        "longitude": "145.01636000"
                    },
                    {
                        "id": 4283,
                        "name": "Blackburn",
                        "latitude": "-37.81901000",
                        "longitude": "145.15326000"
                    },
                    {
                        "id": 4284,
                        "name": "Blackburn North",
                        "latitude": "-37.80931000",
                        "longitude": "145.15180000"
                    },
                    {
                        "id": 4285,
                        "name": "Blackburn South",
                        "latitude": "-37.83975000",
                        "longitude": "145.15549000"
                    },
                    {
                        "id": 4299,
                        "name": "Blairgowrie",
                        "latitude": "-38.36131000",
                        "longitude": "144.77955000"
                    },
                    {
                        "id": 4307,
                        "name": "Blind Bight",
                        "latitude": "-38.21427000",
                        "longitude": "145.33770000"
                    },
                    {
                        "id": 4325,
                        "name": "Bonbeach",
                        "latitude": "-38.06528000",
                        "longitude": "145.12278000"
                    },
                    {
                        "id": 4349,
                        "name": "Boronia",
                        "latitude": "-37.86667000",
                        "longitude": "145.28333000"
                    },
                    {
                        "id": 4351,
                        "name": "Boroondara",
                        "latitude": "-37.82640000",
                        "longitude": "145.05299000"
                    },
                    {
                        "id": 4353,
                        "name": "Botanic Ridge",
                        "latitude": "-38.13922000",
                        "longitude": "145.26841000"
                    },
                    {
                        "id": 4368,
                        "name": "Box Hill",
                        "latitude": "-37.81887000",
                        "longitude": "145.12545000"
                    },
                    {
                        "id": 4369,
                        "name": "Box Hill North",
                        "latitude": "-37.80266000",
                        "longitude": "145.12656000"
                    },
                    {
                        "id": 4370,
                        "name": "Box Hill South",
                        "latitude": "-37.83236000",
                        "longitude": "145.12098000"
                    },
                    {
                        "id": 4386,
                        "name": "Braybrook",
                        "latitude": "-37.78671000",
                        "longitude": "144.85484000"
                    },
                    {
                        "id": 4392,
                        "name": "Briagolong",
                        "latitude": "-37.84356000",
                        "longitude": "147.07268000"
                    },
                    {
                        "id": 4393,
                        "name": "Briar Hill",
                        "latitude": "-37.70631000",
                        "longitude": "145.12100000"
                    },
                    {
                        "id": 4400,
                        "name": "Bright",
                        "latitude": "-36.72998000",
                        "longitude": "146.95978000"
                    },
                    {
                        "id": 4403,
                        "name": "Brighton",
                        "latitude": "-37.90561000",
                        "longitude": "145.00279000"
                    },
                    {
                        "id": 4405,
                        "name": "Brighton East",
                        "latitude": "-37.90232000",
                        "longitude": "145.01734000"
                    },
                    {
                        "id": 4407,
                        "name": "Brimbank",
                        "latitude": "-37.74287000",
                        "longitude": "144.81644000"
                    },
                    {
                        "id": 4414,
                        "name": "Broadford",
                        "latitude": "-37.20276000",
                        "longitude": "145.04837000"
                    },
                    {
                        "id": 4416,
                        "name": "Broadmeadows",
                        "latitude": "-37.68015000",
                        "longitude": "144.91877000"
                    },
                    {
                        "id": 4425,
                        "name": "Brookfield",
                        "latitude": "-37.70080000",
                        "longitude": "144.56025000"
                    },
                    {
                        "id": 4427,
                        "name": "Brooklyn",
                        "latitude": "-37.81609000",
                        "longitude": "144.84150000"
                    },
                    {
                        "id": 4435,
                        "name": "Brown Hill",
                        "latitude": "-37.54654000",
                        "longitude": "143.91553000"
                    },
                    {
                        "id": 4438,
                        "name": "Brunswick",
                        "latitude": "-37.76667000",
                        "longitude": "144.96667000"
                    },
                    {
                        "id": 4440,
                        "name": "Brunswick East",
                        "latitude": "-37.77255000",
                        "longitude": "144.97241000"
                    },
                    {
                        "id": 4442,
                        "name": "Brunswick West",
                        "latitude": "-37.76461000",
                        "longitude": "144.94383000"
                    },
                    {
                        "id": 4455,
                        "name": "Bulleen",
                        "latitude": "-37.76667000",
                        "longitude": "145.08333000"
                    },
                    {
                        "id": 4459,
                        "name": "Buloke",
                        "latitude": "-35.84638000",
                        "longitude": "143.05201000"
                    },
                    {
                        "id": 4470,
                        "name": "Bundoora",
                        "latitude": "-37.69825000",
                        "longitude": "145.05967000"
                    },
                    {
                        "id": 4474,
                        "name": "Buninyong",
                        "latitude": "-37.65019000",
                        "longitude": "143.88388000"
                    },
                    {
                        "id": 4476,
                        "name": "Bunyip",
                        "latitude": "-38.09789000",
                        "longitude": "145.71606000"
                    },
                    {
                        "id": 4487,
                        "name": "Burnside",
                        "latitude": "-37.74937000",
                        "longitude": "144.75301000"
                    },
                    {
                        "id": 4489,
                        "name": "Burnside Heights",
                        "latitude": "-37.72691000",
                        "longitude": "144.75225000"
                    },
                    {
                        "id": 4500,
                        "name": "Burwood",
                        "latitude": "-37.84978000",
                        "longitude": "145.11901000"
                    },
                    {
                        "id": 4502,
                        "name": "Burwood East",
                        "latitude": "-37.85000000",
                        "longitude": "145.15000000"
                    },
                    {
                        "id": 4523,
                        "name": "Cairnlea",
                        "latitude": "-37.75931000",
                        "longitude": "144.78781000"
                    },
                    {
                        "id": 4529,
                        "name": "California Gully",
                        "latitude": "-36.72887000",
                        "longitude": "144.26089000"
                    },
                    {
                        "id": 4537,
                        "name": "Camberwell",
                        "latitude": "-37.84205000",
                        "longitude": "145.06940000"
                    },
                    {
                        "id": 4554,
                        "name": "Campaspe",
                        "latitude": "-36.32338000",
                        "longitude": "144.70844000"
                    },
                    {
                        "id": 4556,
                        "name": "Campbellfield",
                        "latitude": "-37.66386000",
                        "longitude": "144.95953000"
                    },
                    {
                        "id": 4557,
                        "name": "Campbells Creek",
                        "latitude": "-37.08665000",
                        "longitude": "144.20203000"
                    },
                    {
                        "id": 4562,
                        "name": "Camperdown",
                        "latitude": "-38.23392000",
                        "longitude": "143.14983000"
                    },
                    {
                        "id": 4565,
                        "name": "Canadian",
                        "latitude": "-37.57606000",
                        "longitude": "143.87742000"
                    },
                    {
                        "id": 4575,
                        "name": "Canterbury",
                        "latitude": "-37.82470000",
                        "longitude": "145.08476000"
                    },
                    {
                        "id": 4580,
                        "name": "Cape Woolamai",
                        "latitude": "-38.54285000",
                        "longitude": "145.34407000"
                    },
                    {
                        "id": 4588,
                        "name": "Cardinia",
                        "latitude": "-38.09508000",
                        "longitude": "145.56455000"
                    },
                    {
                        "id": 4597,
                        "name": "Carisbrook",
                        "latitude": "-37.04808000",
                        "longitude": "143.81665000"
                    },
                    {
                        "id": 4600,
                        "name": "Carlton",
                        "latitude": "-37.80000000",
                        "longitude": "144.96667000"
                    },
                    {
                        "id": 4602,
                        "name": "Carlton North",
                        "latitude": "-37.78818000",
                        "longitude": "144.97014000"
                    },
                    {
                        "id": 4605,
                        "name": "Carnegie",
                        "latitude": "-37.89359000",
                        "longitude": "145.05534000"
                    },
                    {
                        "id": 4607,
                        "name": "Caroline Springs",
                        "latitude": "-37.74124000",
                        "longitude": "144.73631000"
                    },
                    {
                        "id": 4614,
                        "name": "Carrum",
                        "latitude": "-38.08333000",
                        "longitude": "145.13333000"
                    },
                    {
                        "id": 4615,
                        "name": "Carrum Downs",
                        "latitude": "-38.09968000",
                        "longitude": "145.17248000"
                    },
                    {
                        "id": 4620,
                        "name": "Casey",
                        "latitude": "-38.09519000",
                        "longitude": "145.32279000"
                    },
                    {
                        "id": 4625,
                        "name": "Casterton",
                        "latitude": "-37.58489000",
                        "longitude": "141.40297000"
                    },
                    {
                        "id": 4629,
                        "name": "Castlemaine",
                        "latitude": "-37.06709000",
                        "longitude": "144.21684000"
                    },
                    {
                        "id": 4637,
                        "name": "Caulfield",
                        "latitude": "-37.88251000",
                        "longitude": "145.02288000"
                    },
                    {
                        "id": 4638,
                        "name": "Caulfield East",
                        "latitude": "-37.88121000",
                        "longitude": "145.04208000"
                    },
                    {
                        "id": 4639,
                        "name": "Caulfield North",
                        "latitude": "-37.87390000",
                        "longitude": "145.02485000"
                    },
                    {
                        "id": 4640,
                        "name": "Caulfield South",
                        "latitude": "-37.89562000",
                        "longitude": "145.02597000"
                    },
                    {
                        "id": 4652,
                        "name": "Central Goldfields",
                        "latitude": "-36.97889000",
                        "longitude": "143.73857000"
                    },
                    {
                        "id": 4656,
                        "name": "Chadstone",
                        "latitude": "-37.88766000",
                        "longitude": "145.09519000"
                    },
                    {
                        "id": 4667,
                        "name": "Charlton",
                        "latitude": "-36.26437000",
                        "longitude": "143.34901000"
                    },
                    {
                        "id": 4676,
                        "name": "Chelsea",
                        "latitude": "-38.05000000",
                        "longitude": "145.11667000"
                    },
                    {
                        "id": 4677,
                        "name": "Chelsea Heights",
                        "latitude": "-38.03333000",
                        "longitude": "145.13333000"
                    },
                    {
                        "id": 4679,
                        "name": "Cheltenham",
                        "latitude": "-37.96944000",
                        "longitude": "145.04806000"
                    },
                    {
                        "id": 4685,
                        "name": "Chewton",
                        "latitude": "-37.08137000",
                        "longitude": "144.25682000"
                    },
                    {
                        "id": 4691,
                        "name": "Chiltern",
                        "latitude": "-36.15044000",
                        "longitude": "146.60843000"
                    },
                    {
                        "id": 4696,
                        "name": "Chirnside Park",
                        "latitude": "-37.73860000",
                        "longitude": "145.31431000"
                    },
                    {
                        "id": 4704,
                        "name": "Churchill",
                        "latitude": "-38.30776000",
                        "longitude": "146.41367000"
                    },
                    {
                        "id": 4726,
                        "name": "Clarinda",
                        "latitude": "-37.94066000",
                        "longitude": "145.10238000"
                    },
                    {
                        "id": 4730,
                        "name": "Clayton",
                        "latitude": "-37.91667000",
                        "longitude": "145.11667000"
                    },
                    {
                        "id": 4731,
                        "name": "Clayton South",
                        "latitude": "-37.93333000",
                        "longitude": "145.11667000"
                    },
                    {
                        "id": 4740,
                        "name": "Clifton Hill",
                        "latitude": "-37.79798000",
                        "longitude": "144.99533000"
                    },
                    {
                        "id": 4741,
                        "name": "Clifton Springs",
                        "latitude": "-38.15670000",
                        "longitude": "144.55510000"
                    },
                    {
                        "id": 4749,
                        "name": "Clunes",
                        "latitude": "-37.29473000",
                        "longitude": "143.78636000"
                    },
                    {
                        "id": 4750,
                        "name": "Clyde",
                        "latitude": "-38.13333000",
                        "longitude": "145.33333000"
                    },
                    {
                        "id": 4751,
                        "name": "Clyde North",
                        "latitude": "-38.11667000",
                        "longitude": "145.33333000"
                    },
                    {
                        "id": 4755,
                        "name": "Cobden",
                        "latitude": "-38.32860000",
                        "longitude": "143.07484000"
                    },
                    {
                        "id": 4756,
                        "name": "Cobram",
                        "latitude": "-35.92069000",
                        "longitude": "145.64066000"
                    },
                    {
                        "id": 4757,
                        "name": "Coburg",
                        "latitude": "-37.75000000",
                        "longitude": "144.96667000"
                    },
                    {
                        "id": 4758,
                        "name": "Coburg North",
                        "latitude": "-37.72867000",
                        "longitude": "144.96134000"
                    },
                    {
                        "id": 4759,
                        "name": "Cockatoo",
                        "latitude": "-37.93677000",
                        "longitude": "145.49376000"
                    },
                    {
                        "id": 4764,
                        "name": "Cohuna",
                        "latitude": "-35.80697000",
                        "longitude": "144.21886000"
                    },
                    {
                        "id": 4765,
                        "name": "Colac",
                        "latitude": "-38.33900000",
                        "longitude": "143.58489000"
                    },
                    {
                        "id": 4766,
                        "name": "Colac-Otway",
                        "latitude": "-38.43873000",
                        "longitude": "143.59669000"
                    },
                    {
                        "id": 4767,
                        "name": "Coldstream",
                        "latitude": "-37.72490000",
                        "longitude": "145.37804000"
                    },
                    {
                        "id": 4775,
                        "name": "Collingwood",
                        "latitude": "-37.80253000",
                        "longitude": "144.98872000"
                    },
                    {
                        "id": 4806,
                        "name": "Coolaroo",
                        "latitude": "-37.65675000",
                        "longitude": "144.93460000"
                    },
                    {
                        "id": 4834,
                        "name": "Corangamite",
                        "latitude": "-38.21596000",
                        "longitude": "143.23542000"
                    },
                    {
                        "id": 4838,
                        "name": "Corio",
                        "latitude": "-38.08333000",
                        "longitude": "144.38333000"
                    },
                    {
                        "id": 4845,
                        "name": "Corryong",
                        "latitude": "-36.19705000",
                        "longitude": "147.90256000"
                    },
                    {
                        "id": 4853,
                        "name": "Cowes",
                        "latitude": "-38.45231000",
                        "longitude": "145.23865000"
                    },
                    {
                        "id": 4860,
                        "name": "Craigieburn",
                        "latitude": "-37.60000000",
                        "longitude": "144.95000000"
                    },
                    {
                        "id": 4864,
                        "name": "Cranbourne",
                        "latitude": "-38.11342000",
                        "longitude": "145.28326000"
                    },
                    {
                        "id": 4865,
                        "name": "Cranbourne East",
                        "latitude": "-38.11531000",
                        "longitude": "145.29814000"
                    },
                    {
                        "id": 4866,
                        "name": "Cranbourne North",
                        "latitude": "-38.07758000",
                        "longitude": "145.29871000"
                    },
                    {
                        "id": 4867,
                        "name": "Cranbourne South",
                        "latitude": "-38.13502000",
                        "longitude": "145.23958000"
                    },
                    {
                        "id": 4868,
                        "name": "Cranbourne West",
                        "latitude": "-38.09650000",
                        "longitude": "145.26707000"
                    },
                    {
                        "id": 4874,
                        "name": "Cremorne",
                        "latitude": "-37.83180000",
                        "longitude": "144.99380000"
                    },
                    {
                        "id": 4881,
                        "name": "Creswick",
                        "latitude": "-37.42404000",
                        "longitude": "143.89470000"
                    },
                    {
                        "id": 4882,
                        "name": "Crib Point",
                        "latitude": "-38.35000000",
                        "longitude": "145.20000000"
                    },
                    {
                        "id": 4890,
                        "name": "Croydon",
                        "latitude": "-37.80000000",
                        "longitude": "145.28333000"
                    },
                    {
                        "id": 4892,
                        "name": "Croydon Hills",
                        "latitude": "-37.77651000",
                        "longitude": "145.26355000"
                    },
                    {
                        "id": 4893,
                        "name": "Croydon North",
                        "latitude": "-37.76741000",
                        "longitude": "145.29073000"
                    },
                    {
                        "id": 4895,
                        "name": "Croydon South",
                        "latitude": "-37.81232000",
                        "longitude": "145.26810000"
                    },
                    {
                        "id": 4924,
                        "name": "Dallas",
                        "latitude": "-37.67083000",
                        "longitude": "144.93542000"
                    },
                    {
                        "id": 4931,
                        "name": "Dandenong",
                        "latitude": "-37.98333000",
                        "longitude": "145.20000000"
                    },
                    {
                        "id": 4932,
                        "name": "Dandenong North",
                        "latitude": "-37.96649000",
                        "longitude": "145.20810000"
                    },
                    {
                        "id": 4936,
                        "name": "Darebin",
                        "latitude": "-37.75153000",
                        "longitude": "145.02193000"
                    },
                    {
                        "id": 4937,
                        "name": "Darley",
                        "latitude": "-37.65807000",
                        "longitude": "144.44344000"
                    },
                    {
                        "id": 4954,
                        "name": "Daylesford",
                        "latitude": "-37.34113000",
                        "longitude": "144.14256000"
                    },
                    {
                        "id": 4962,
                        "name": "Deer Park",
                        "latitude": "-37.76722000",
                        "longitude": "144.76657000"
                    },
                    {
                        "id": 4964,
                        "name": "Delacombe",
                        "latitude": "-37.58911000",
                        "longitude": "143.81472000"
                    },
                    {
                        "id": 4965,
                        "name": "Delahey",
                        "latitude": "-37.71980000",
                        "longitude": "144.77732000"
                    },
                    {
                        "id": 4975,
                        "name": "Dennington",
                        "latitude": "-38.35519000",
                        "longitude": "142.43361000"
                    },
                    {
                        "id": 4980,
                        "name": "Derrimut",
                        "latitude": "-37.79238000",
                        "longitude": "144.76994000"
                    },
                    {
                        "id": 4983,
                        "name": "Devon Meadows",
                        "latitude": "-38.16667000",
                        "longitude": "145.30000000"
                    },
                    {
                        "id": 4987,
                        "name": "Diamond Creek",
                        "latitude": "-37.66667000",
                        "longitude": "145.15000000"
                    },
                    {
                        "id": 4992,
                        "name": "Diggers Rest",
                        "latitude": "-37.62597000",
                        "longitude": "144.71881000"
                    },
                    {
                        "id": 4993,
                        "name": "Dimboola",
                        "latitude": "-36.45616000",
                        "longitude": "142.03287000"
                    },
                    {
                        "id": 4995,
                        "name": "Dingley Village",
                        "latitude": "-37.98270000",
                        "longitude": "145.13420000"
                    },
                    {
                        "id": 4996,
                        "name": "Dinner Plain",
                        "latitude": "-37.02360000",
                        "longitude": "147.24124000"
                    },
                    {
                        "id": 4998,
                        "name": "Docklands",
                        "latitude": "-37.81490000",
                        "longitude": "144.95052000"
                    },
                    {
                        "id": 5001,
                        "name": "Donald",
                        "latitude": "-36.36864000",
                        "longitude": "142.98106000"
                    },
                    {
                        "id": 5002,
                        "name": "Doncaster",
                        "latitude": "-37.78828000",
                        "longitude": "145.12373000"
                    },
                    {
                        "id": 5003,
                        "name": "Doncaster East",
                        "latitude": "-37.78761000",
                        "longitude": "145.14888000"
                    },
                    {
                        "id": 5007,
                        "name": "Donvale",
                        "latitude": "-37.78910000",
                        "longitude": "145.17488000"
                    },
                    {
                        "id": 5013,
                        "name": "Doreen",
                        "latitude": "-37.60000000",
                        "longitude": "145.15000000"
                    },
                    {
                        "id": 5022,
                        "name": "Doveton",
                        "latitude": "-37.99346000",
                        "longitude": "145.23891000"
                    },
                    {
                        "id": 5028,
                        "name": "Dromana",
                        "latitude": "-38.33375000",
                        "longitude": "144.96458000"
                    },
                    {
                        "id": 5029,
                        "name": "Drouin",
                        "latitude": "-38.13658000",
                        "longitude": "145.85838000"
                    },
                    {
                        "id": 5032,
                        "name": "Drysdale",
                        "latitude": "-38.17237000",
                        "longitude": "144.56988000"
                    },
                    {
                        "id": 5055,
                        "name": "Eagle Point",
                        "latitude": "-37.90000000",
                        "longitude": "147.68333000"
                    },
                    {
                        "id": 5058,
                        "name": "Eaglehawk",
                        "latitude": "-36.71611000",
                        "longitude": "144.25049000"
                    },
                    {
                        "id": 5059,
                        "name": "Eaglemont",
                        "latitude": "-37.76379000",
                        "longitude": "145.06380000"
                    },
                    {
                        "id": 5064,
                        "name": "East Bairnsdale",
                        "latitude": "-37.83426000",
                        "longitude": "147.65548000"
                    },
                    {
                        "id": 5066,
                        "name": "East Bendigo",
                        "latitude": "-36.74157000",
                        "longitude": "144.31894000"
                    },
                    {
                        "id": 5075,
                        "name": "East Geelong",
                        "latitude": "-38.15568000",
                        "longitude": "144.37202000"
                    },
                    {
                        "id": 5076,
                        "name": "East Gippsland",
                        "latitude": "-37.34564000",
                        "longitude": "148.58295000"
                    },
                    {
                        "id": 5090,
                        "name": "East Melbourne",
                        "latitude": "-37.81667000",
                        "longitude": "144.98790000"
                    },
                    {
                        "id": 5103,
                        "name": "Echuca",
                        "latitude": "-36.14057000",
                        "longitude": "144.75185000"
                    },
                    {
                        "id": 5108,
                        "name": "Eden Park",
                        "latitude": "-37.48333000",
                        "longitude": "145.08333000"
                    },
                    {
                        "id": 5115,
                        "name": "Edithvale",
                        "latitude": "-38.03724000",
                        "longitude": "145.10974000"
                    },
                    {
                        "id": 5142,
                        "name": "Elliminyt",
                        "latitude": "-38.37110000",
                        "longitude": "143.58003000"
                    },
                    {
                        "id": 5145,
                        "name": "Elsternwick",
                        "latitude": "-37.88639000",
                        "longitude": "145.00250000"
                    },
                    {
                        "id": 5146,
                        "name": "Eltham",
                        "latitude": "-37.73333000",
                        "longitude": "145.15000000"
                    },
                    {
                        "id": 5147,
                        "name": "Eltham North",
                        "latitude": "-37.70000000",
                        "longitude": "145.15000000"
                    },
                    {
                        "id": 5148,
                        "name": "Elwood",
                        "latitude": "-37.88214000",
                        "longitude": "144.98215000"
                    },
                    {
                        "id": 5150,
                        "name": "Emerald",
                        "latitude": "-37.93167000",
                        "longitude": "145.44093000"
                    },
                    {
                        "id": 5159,
                        "name": "Endeavour Hills",
                        "latitude": "-37.97695000",
                        "longitude": "145.25866000"
                    },
                    {
                        "id": 5164,
                        "name": "Epping",
                        "latitude": "-37.65000000",
                        "longitude": "145.03333000"
                    },
                    {
                        "id": 5166,
                        "name": "Epsom",
                        "latitude": "-36.71667000",
                        "longitude": "144.31667000"
                    },
                    {
                        "id": 5177,
                        "name": "Essendon",
                        "latitude": "-37.74981000",
                        "longitude": "144.91090000"
                    },
                    {
                        "id": 5178,
                        "name": "Essendon North",
                        "latitude": "-37.74225000",
                        "longitude": "144.90546000"
                    },
                    {
                        "id": 5179,
                        "name": "Essendon West",
                        "latitude": "-37.75489000",
                        "longitude": "144.88338000"
                    },
                    {
                        "id": 5187,
                        "name": "Eumemmerring",
                        "latitude": "-37.99780000",
                        "longitude": "145.24821000"
                    },
                    {
                        "id": 5189,
                        "name": "Euroa",
                        "latitude": "-36.75555000",
                        "longitude": "145.57075000"
                    },
                    {
                        "id": 5203,
                        "name": "Eynesbury",
                        "latitude": "-37.80043000",
                        "longitude": "144.57458000"
                    },
                    {
                        "id": 5205,
                        "name": "Fairfield",
                        "latitude": "-37.77977000",
                        "longitude": "145.01764000"
                    },
                    {
                        "id": 5215,
                        "name": "Falls Creek",
                        "latitude": "-36.86535000",
                        "longitude": "147.27782000"
                    },
                    {
                        "id": 5221,
                        "name": "Fawkner",
                        "latitude": "-37.71667000",
                        "longitude": "144.96667000"
                    },
                    {
                        "id": 5227,
                        "name": "Ferntree Gully",
                        "latitude": "-37.88461000",
                        "longitude": "145.29539000"
                    },
                    {
                        "id": 5229,
                        "name": "Ferny Creek",
                        "latitude": "-37.88333000",
                        "longitude": "145.33333000"
                    },
                    {
                        "id": 5241,
                        "name": "Fitzroy",
                        "latitude": "-37.79839000",
                        "longitude": "144.97833000"
                    },
                    {
                        "id": 5243,
                        "name": "Fitzroy North",
                        "latitude": "-37.78862000",
                        "longitude": "144.97885000"
                    },
                    {
                        "id": 5246,
                        "name": "Flemington",
                        "latitude": "-37.78825000",
                        "longitude": "144.93001000"
                    },
                    {
                        "id": 5254,
                        "name": "Flora Hill",
                        "latitude": "-36.78123000",
                        "longitude": "144.29562000"
                    },
                    {
                        "id": 5259,
                        "name": "Footscray",
                        "latitude": "-37.80000000",
                        "longitude": "144.90000000"
                    },
                    {
                        "id": 5264,
                        "name": "Forest Hill",
                        "latitude": "-37.83333000",
                        "longitude": "145.18333000"
                    },
                    {
                        "id": 5276,
                        "name": "Foster",
                        "latitude": "-38.65275000",
                        "longitude": "146.20073000"
                    },
                    {
                        "id": 5280,
                        "name": "Frankston",
                        "latitude": "-38.13402000",
                        "longitude": "145.16875000"
                    },
                    {
                        "id": 5281,
                        "name": "Frankston East",
                        "latitude": "-38.13333000",
                        "longitude": "145.13333000"
                    },
                    {
                        "id": 5282,
                        "name": "Frankston North",
                        "latitude": "-38.12352000",
                        "longitude": "145.14836000"
                    },
                    {
                        "id": 5283,
                        "name": "Frankston South",
                        "latitude": "-38.16604000",
                        "longitude": "145.13643000"
                    },
                    {
                        "id": 5301,
                        "name": "Gannawarra",
                        "latitude": "-35.73211000",
                        "longitude": "143.85316000"
                    },
                    {
                        "id": 5305,
                        "name": "Garfield",
                        "latitude": "-38.08985000",
                        "longitude": "145.67502000"
                    },
                    {
                        "id": 5316,
                        "name": "Geelong",
                        "latitude": "-38.14711000",
                        "longitude": "144.36069000"
                    },
                    {
                        "id": 5318,
                        "name": "Geelong city centre",
                        "latitude": "-38.14996000",
                        "longitude": "144.36176000"
                    },
                    {
                        "id": 5317,
                        "name": "Geelong West",
                        "latitude": "-38.13888000",
                        "longitude": "144.34842000"
                    },
                    {
                        "id": 5322,
                        "name": "Gembrook",
                        "latitude": "-37.95321000",
                        "longitude": "145.55536000"
                    },
                    {
                        "id": 5345,
                        "name": "Gisborne",
                        "latitude": "-37.48858000",
                        "longitude": "144.59421000"
                    },
                    {
                        "id": 5349,
                        "name": "Gladstone Park",
                        "latitude": "-37.68742000",
                        "longitude": "144.88675000"
                    },
                    {
                        "id": 5356,
                        "name": "Glen Eira",
                        "latitude": "-37.89949000",
                        "longitude": "145.04099000"
                    },
                    {
                        "id": 5358,
                        "name": "Glen Huntly",
                        "latitude": "-37.89237000",
                        "longitude": "145.04135000"
                    },
                    {
                        "id": 5362,
                        "name": "Glen Iris",
                        "latitude": "-37.86667000",
                        "longitude": "145.06667000"
                    },
                    {
                        "id": 5364,
                        "name": "Glen Waverley",
                        "latitude": "-37.87811000",
                        "longitude": "145.16476000"
                    },
                    {
                        "id": 5372,
                        "name": "Glenelg",
                        "latitude": "-37.89083000",
                        "longitude": "141.44238000"
                    },
                    {
                        "id": 5377,
                        "name": "Glenferrie",
                        "latitude": "-37.83333000",
                        "longitude": "145.05000000"
                    },
                    {
                        "id": 5380,
                        "name": "Glengarry",
                        "latitude": "-38.11667000",
                        "longitude": "146.56667000"
                    },
                    {
                        "id": 5387,
                        "name": "Glenroy",
                        "latitude": "-37.70000000",
                        "longitude": "144.93333000"
                    },
                    {
                        "id": 5404,
                        "name": "Golden Plains",
                        "latitude": "-37.85231000",
                        "longitude": "143.86352000"
                    },
                    {
                        "id": 5405,
                        "name": "Golden Point",
                        "latitude": "-37.57493000",
                        "longitude": "143.86870000"
                    },
                    {
                        "id": 5406,
                        "name": "Golden Square",
                        "latitude": "-36.77265000",
                        "longitude": "144.25271000"
                    },
                    {
                        "id": 5419,
                        "name": "Gordon",
                        "latitude": "-37.58230000",
                        "longitude": "144.10925000"
                    },
                    {
                        "id": 5428,
                        "name": "Gowanbrae",
                        "latitude": "-37.70823000",
                        "longitude": "144.89079000"
                    },
                    {
                        "id": 5445,
                        "name": "Greater Bendigo",
                        "latitude": "-36.72278000",
                        "longitude": "144.43974000"
                    },
                    {
                        "id": 5446,
                        "name": "Greater Dandenong",
                        "latitude": "-38.00112000",
                        "longitude": "145.19073000"
                    },
                    {
                        "id": 5447,
                        "name": "Greater Geelong",
                        "latitude": "-38.05182000",
                        "longitude": "144.46137000"
                    },
                    {
                        "id": 5449,
                        "name": "Greater Shepparton",
                        "latitude": "-36.42742000",
                        "longitude": "145.41519000"
                    },
                    {
                        "id": 5458,
                        "name": "Greensborough",
                        "latitude": "-37.70462000",
                        "longitude": "145.10302000"
                    },
                    {
                        "id": 5460,
                        "name": "Greenvale",
                        "latitude": "-37.63333000",
                        "longitude": "144.86667000"
                    },
                    {
                        "id": 5474,
                        "name": "Grovedale",
                        "latitude": "-38.20000000",
                        "longitude": "144.35000000"
                    },
                    {
                        "id": 5501,
                        "name": "Haddon",
                        "latitude": "-37.60000000",
                        "longitude": "143.71667000"
                    },
                    {
                        "id": 5502,
                        "name": "Hadfield",
                        "latitude": "-37.70728000",
                        "longitude": "144.94160000"
                    },
                    {
                        "id": 5506,
                        "name": "Hallam",
                        "latitude": "-38.01667000",
                        "longitude": "145.26667000"
                    },
                    {
                        "id": 5511,
                        "name": "Hamilton",
                        "latitude": "-37.74425000",
                        "longitude": "142.02202000"
                    },
                    {
                        "id": 5515,
                        "name": "Hamlyn Heights",
                        "latitude": "-38.12108000",
                        "longitude": "144.32799000"
                    },
                    {
                        "id": 5520,
                        "name": "Hampton",
                        "latitude": "-37.95000000",
                        "longitude": "145.00000000"
                    },
                    {
                        "id": 5521,
                        "name": "Hampton East",
                        "latitude": "-37.93695000",
                        "longitude": "145.02863000"
                    },
                    {
                        "id": 5522,
                        "name": "Hampton Park",
                        "latitude": "-38.03333000",
                        "longitude": "145.25000000"
                    },
                    {
                        "id": 5535,
                        "name": "Hastings",
                        "latitude": "-38.30000000",
                        "longitude": "145.18333000"
                    },
                    {
                        "id": 5537,
                        "name": "Haven",
                        "latitude": "-36.76072000",
                        "longitude": "142.19426000"
                    },
                    {
                        "id": 5541,
                        "name": "Hawthorn",
                        "latitude": "-37.81992000",
                        "longitude": "145.03580000"
                    },
                    {
                        "id": 5543,
                        "name": "Hawthorn East",
                        "latitude": "-37.82484000",
                        "longitude": "145.04640000"
                    },
                    {
                        "id": 5544,
                        "name": "Hawthorn South",
                        "latitude": "-37.83290000",
                        "longitude": "145.03670000"
                    },
                    {
                        "id": 5552,
                        "name": "Hazelwood North",
                        "latitude": "-38.26763000",
                        "longitude": "146.48286000"
                    },
                    {
                        "id": 5554,
                        "name": "Healesville",
                        "latitude": "-37.65395000",
                        "longitude": "145.51718000"
                    },
                    {
                        "id": 5557,
                        "name": "Heathcote",
                        "latitude": "-36.92214000",
                        "longitude": "144.70837000"
                    },
                    {
                        "id": 5558,
                        "name": "Heatherton",
                        "latitude": "-37.96667000",
                        "longitude": "145.10000000"
                    },
                    {
                        "id": 5559,
                        "name": "Heathmont",
                        "latitude": "-37.83333000",
                        "longitude": "145.25000000"
                    },
                    {
                        "id": 5567,
                        "name": "Heidelberg",
                        "latitude": "-37.75000000",
                        "longitude": "145.06667000"
                    },
                    {
                        "id": 5568,
                        "name": "Heidelberg Heights",
                        "latitude": "-37.74313000",
                        "longitude": "145.05695000"
                    },
                    {
                        "id": 5569,
                        "name": "Heidelberg West",
                        "latitude": "-37.73922000",
                        "longitude": "145.04034000"
                    },
                    {
                        "id": 5580,
                        "name": "Hepburn",
                        "latitude": "-37.31707000",
                        "longitude": "144.03355000"
                    },
                    {
                        "id": 5586,
                        "name": "Herne Hill",
                        "latitude": "-38.13427000",
                        "longitude": "144.32406000"
                    },
                    {
                        "id": 5590,
                        "name": "Heyfield",
                        "latitude": "-37.98130000",
                        "longitude": "146.78559000"
                    },
                    {
                        "id": 5591,
                        "name": "Heywood",
                        "latitude": "-38.13294000",
                        "longitude": "141.62949000"
                    },
                    {
                        "id": 5595,
                        "name": "Highett",
                        "latitude": "-37.95000000",
                        "longitude": "145.05000000"
                    },
                    {
                        "id": 5601,
                        "name": "Highton",
                        "latitude": "-38.17058000",
                        "longitude": "144.31140000"
                    },
                    {
                        "id": 5612,
                        "name": "Hillside",
                        "latitude": "-37.69047000",
                        "longitude": "144.74172000"
                    },
                    {
                        "id": 5618,
                        "name": "Hindmarsh",
                        "latitude": "-36.03293000",
                        "longitude": "141.73282000"
                    },
                    {
                        "id": 5620,
                        "name": "Hmas Cerberus",
                        "latitude": "-38.36491000",
                        "longitude": "145.20038000"
                    },
                    {
                        "id": 5624,
                        "name": "Hobsons Bay",
                        "latitude": "-37.85694000",
                        "longitude": "144.83347000"
                    },
                    {
                        "id": 5647,
                        "name": "Hoppers Crossing",
                        "latitude": "-37.88264000",
                        "longitude": "144.70030000"
                    },
                    {
                        "id": 5652,
                        "name": "Horsham",
                        "latitude": "-36.82857000",
                        "longitude": "142.11448000"
                    },
                    {
                        "id": 5655,
                        "name": "Hotham Heights",
                        "latitude": "-36.99298000",
                        "longitude": "147.15225000"
                    },
                    {
                        "id": 5664,
                        "name": "Hughesdale",
                        "latitude": "-37.90000000",
                        "longitude": "145.08333000"
                    },
                    {
                        "id": 5665,
                        "name": "Hume",
                        "latitude": "-37.59717000",
                        "longitude": "144.80511000"
                    },
                    {
                        "id": 5670,
                        "name": "Huntingdale",
                        "latitude": "-37.90766000",
                        "longitude": "145.10847000"
                    },
                    {
                        "id": 5672,
                        "name": "Huntly",
                        "latitude": "-36.66451000",
                        "longitude": "144.33382000"
                    },
                    {
                        "id": 5676,
                        "name": "Hurstbridge",
                        "latitude": "-37.64157000",
                        "longitude": "145.19408000"
                    },
                    {
                        "id": 5686,
                        "name": "Indented Head",
                        "latitude": "-38.14305000",
                        "longitude": "144.71343000"
                    },
                    {
                        "id": 5687,
                        "name": "Indigo",
                        "latitude": "-36.20854000",
                        "longitude": "146.68628000"
                    },
                    {
                        "id": 5698,
                        "name": "Inverleigh",
                        "latitude": "-38.10177000",
                        "longitude": "144.05132000"
                    },
                    {
                        "id": 5699,
                        "name": "Inverloch",
                        "latitude": "-38.62659000",
                        "longitude": "145.72260000"
                    },
                    {
                        "id": 5701,
                        "name": "Invermay Park",
                        "latitude": "-37.53063000",
                        "longitude": "143.85798000"
                    },
                    {
                        "id": 5703,
                        "name": "Ironbark",
                        "latitude": "-36.75478000",
                        "longitude": "144.26378000"
                    },
                    {
                        "id": 5705,
                        "name": "Irymple",
                        "latitude": "-34.23537000",
                        "longitude": "142.17101000"
                    },
                    {
                        "id": 5710,
                        "name": "Ivanhoe",
                        "latitude": "-37.76903000",
                        "longitude": "145.04308000"
                    },
                    {
                        "id": 5711,
                        "name": "Ivanhoe East",
                        "latitude": "-37.77340000",
                        "longitude": "145.06195000"
                    },
                    {
                        "id": 5713,
                        "name": "Jacana",
                        "latitude": "-37.68778000",
                        "longitude": "144.91111000"
                    },
                    {
                        "id": 5714,
                        "name": "Jackass Flat",
                        "latitude": "-36.71589000",
                        "longitude": "144.28597000"
                    },
                    {
                        "id": 5720,
                        "name": "Jan Juc",
                        "latitude": "-38.34455000",
                        "longitude": "144.29518000"
                    },
                    {
                        "id": 5749,
                        "name": "Junction Village",
                        "latitude": "-38.13636000",
                        "longitude": "145.29684000"
                    },
                    {
                        "id": 5751,
                        "name": "Junortoun",
                        "latitude": "-36.77106000",
                        "longitude": "144.36311000"
                    },
                    {
                        "id": 5761,
                        "name": "Kalimna",
                        "latitude": "-37.87011000",
                        "longitude": "147.96664000"
                    },
                    {
                        "id": 5766,
                        "name": "Kallista",
                        "latitude": "-37.89815000",
                        "longitude": "145.38226000"
                    },
                    {
                        "id": 5767,
                        "name": "Kalorama",
                        "latitude": "-37.81667000",
                        "longitude": "145.36667000"
                    },
                    {
                        "id": 5774,
                        "name": "Kangaroo Flat",
                        "latitude": "-36.80000000",
                        "longitude": "144.25000000"
                    },
                    {
                        "id": 5775,
                        "name": "Kangaroo Ground",
                        "latitude": "-37.68919000",
                        "longitude": "145.23170000"
                    },
                    {
                        "id": 5803,
                        "name": "Kealba",
                        "latitude": "-37.73710000",
                        "longitude": "144.82830000"
                    },
                    {
                        "id": 5807,
                        "name": "Keilor",
                        "latitude": "-37.71667000",
                        "longitude": "144.83333000"
                    },
                    {
                        "id": 5808,
                        "name": "Keilor Downs",
                        "latitude": "-37.72337000",
                        "longitude": "144.80839000"
                    },
                    {
                        "id": 5809,
                        "name": "Keilor East",
                        "latitude": "-37.73261000",
                        "longitude": "144.86504000"
                    },
                    {
                        "id": 5810,
                        "name": "Keilor Lodge",
                        "latitude": "-37.69997000",
                        "longitude": "144.80332000"
                    },
                    {
                        "id": 5811,
                        "name": "Keilor Park",
                        "latitude": "-37.72025000",
                        "longitude": "144.85422000"
                    },
                    {
                        "id": 5826,
                        "name": "Kennington",
                        "latitude": "-36.77128000",
                        "longitude": "144.30298000"
                    },
                    {
                        "id": 5827,
                        "name": "Kensington",
                        "latitude": "-37.79188000",
                        "longitude": "144.93114000"
                    },
                    {
                        "id": 5839,
                        "name": "Kerang",
                        "latitude": "-35.73489000",
                        "longitude": "143.92027000"
                    },
                    {
                        "id": 5841,
                        "name": "Kew",
                        "latitude": "-37.80639000",
                        "longitude": "145.03086000"
                    },
                    {
                        "id": 5843,
                        "name": "Kew East",
                        "latitude": "-37.79758000",
                        "longitude": "145.05378000"
                    },
                    {
                        "id": 5846,
                        "name": "Keysborough",
                        "latitude": "-37.99116000",
                        "longitude": "145.17385000"
                    },
                    {
                        "id": 5847,
                        "name": "Kialla",
                        "latitude": "-36.44729000",
                        "longitude": "145.41422000"
                    },
                    {
                        "id": 5859,
                        "name": "Kilmore",
                        "latitude": "-37.29577000",
                        "longitude": "144.95252000"
                    },
                    {
                        "id": 5860,
                        "name": "Kilsyth",
                        "latitude": "-37.80000000",
                        "longitude": "145.31667000"
                    },
                    {
                        "id": 5861,
                        "name": "Kilsyth South",
                        "latitude": "-37.82033000",
                        "longitude": "145.31599000"
                    },
                    {
                        "id": 5868,
                        "name": "Kinglake",
                        "latitude": "-37.53291000",
                        "longitude": "145.33964000"
                    },
                    {
                        "id": 5869,
                        "name": "Kinglake West",
                        "latitude": "-37.46667000",
                        "longitude": "145.23333000"
                    },
                    {
                        "id": 5874,
                        "name": "Kings Park",
                        "latitude": "-37.73397000",
                        "longitude": "144.77766000"
                    },
                    {
                        "id": 5875,
                        "name": "Kingsbury",
                        "latitude": "-37.71406000",
                        "longitude": "145.03509000"
                    },
                    {
                        "id": 5884,
                        "name": "Kingston",
                        "latitude": "-38.00450000",
                        "longitude": "145.09531000"
                    },
                    {
                        "id": 5889,
                        "name": "Kingsville",
                        "latitude": "-37.80819000",
                        "longitude": "144.87911000"
                    },
                    {
                        "id": 5899,
                        "name": "Knox",
                        "latitude": "-37.89895000",
                        "longitude": "145.26923000"
                    },
                    {
                        "id": 5900,
                        "name": "Knoxfield",
                        "latitude": "-37.88978000",
                        "longitude": "145.24962000"
                    },
                    {
                        "id": 5905,
                        "name": "Koo-Wee-Rup",
                        "latitude": "-38.19941000",
                        "longitude": "145.49081000"
                    },
                    {
                        "id": 5913,
                        "name": "Koroit",
                        "latitude": "-38.29180000",
                        "longitude": "142.36729000"
                    },
                    {
                        "id": 5915,
                        "name": "Korumburra",
                        "latitude": "-38.43194000",
                        "longitude": "145.82355000"
                    },
                    {
                        "id": 5931,
                        "name": "Kurunjang",
                        "latitude": "-37.67587000",
                        "longitude": "144.59690000"
                    },
                    {
                        "id": 5934,
                        "name": "Kyabram",
                        "latitude": "-36.31335000",
                        "longitude": "145.05035000"
                    },
                    {
                        "id": 5936,
                        "name": "Kyneton",
                        "latitude": "-37.24444000",
                        "longitude": "144.45148000"
                    },
                    {
                        "id": 5944,
                        "name": "Lake Gardens",
                        "latitude": "-37.54632000",
                        "longitude": "143.81653000"
                    },
                    {
                        "id": 5952,
                        "name": "Lake Wendouree",
                        "latitude": "-37.54993000",
                        "longitude": "143.84730000"
                    },
                    {
                        "id": 5956,
                        "name": "Lakes Entrance",
                        "latitude": "-37.86679000",
                        "longitude": "148.00159000"
                    },
                    {
                        "id": 5958,
                        "name": "Lalor",
                        "latitude": "-37.66667000",
                        "longitude": "145.01667000"
                    },
                    {
                        "id": 5963,
                        "name": "Lancefield",
                        "latitude": "-37.27733000",
                        "longitude": "144.73596000"
                    },
                    {
                        "id": 5969,
                        "name": "Lang Lang",
                        "latitude": "-38.26605000",
                        "longitude": "145.56210000"
                    },
                    {
                        "id": 5971,
                        "name": "Langwarrin",
                        "latitude": "-38.16667000",
                        "longitude": "145.16667000"
                    },
                    {
                        "id": 5972,
                        "name": "Langwarrin South",
                        "latitude": "-38.18947000",
                        "longitude": "145.19350000"
                    },
                    {
                        "id": 5974,
                        "name": "Lara",
                        "latitude": "-38.02388000",
                        "longitude": "144.40617000"
                    },
                    {
                        "id": 5983,
                        "name": "Latrobe",
                        "latitude": "-38.25379000",
                        "longitude": "146.46124000"
                    },
                    {
                        "id": 5987,
                        "name": "Launching Place",
                        "latitude": "-37.78058000",
                        "longitude": "145.56834000"
                    },
                    {
                        "id": 5988,
                        "name": "Laverton",
                        "latitude": "-37.86201000",
                        "longitude": "144.76979000"
                    },
                    {
                        "id": 6008,
                        "name": "Leongatha",
                        "latitude": "-38.47607000",
                        "longitude": "145.94685000"
                    },
                    {
                        "id": 6010,
                        "name": "Leopold",
                        "latitude": "-38.19001000",
                        "longitude": "144.46825000"
                    },
                    {
                        "id": 6024,
                        "name": "Lilydale",
                        "latitude": "-37.75000000",
                        "longitude": "145.35000000"
                    },
                    {
                        "id": 6039,
                        "name": "Little River",
                        "latitude": "-37.96667000",
                        "longitude": "144.50000000"
                    },
                    {
                        "id": 6051,
                        "name": "Loddon",
                        "latitude": "-36.40406000",
                        "longitude": "143.82964000"
                    },
                    {
                        "id": 6062,
                        "name": "Long Gully",
                        "latitude": "-36.74305000",
                        "longitude": "144.25788000"
                    },
                    {
                        "id": 6065,
                        "name": "Longford",
                        "latitude": "-38.16237000",
                        "longitude": "147.08591000"
                    },
                    {
                        "id": 6068,
                        "name": "Longwarry",
                        "latitude": "-38.11279000",
                        "longitude": "145.76849000"
                    },
                    {
                        "id": 6070,
                        "name": "Lorne",
                        "latitude": "-38.54043000",
                        "longitude": "143.97636000"
                    },
                    {
                        "id": 6072,
                        "name": "Lovely Banks",
                        "latitude": "-38.06667000",
                        "longitude": "144.33333000"
                    },
                    {
                        "id": 6078,
                        "name": "Lower Plenty",
                        "latitude": "-37.73333000",
                        "longitude": "145.11667000"
                    },
                    {
                        "id": 6082,
                        "name": "Lucknow",
                        "latitude": "-37.81667000",
                        "longitude": "147.65000000"
                    },
                    {
                        "id": 6089,
                        "name": "Lynbrook",
                        "latitude": "-38.05588000",
                        "longitude": "145.25615000"
                    },
                    {
                        "id": 6095,
                        "name": "Lysterfield",
                        "latitude": "-37.93333000",
                        "longitude": "145.30000000"
                    },
                    {
                        "id": 6099,
                        "name": "Macedon",
                        "latitude": "-37.41963000",
                        "longitude": "144.56242000"
                    },
                    {
                        "id": 6100,
                        "name": "Macedon Ranges",
                        "latitude": "-37.33343000",
                        "longitude": "144.61581000"
                    },
                    {
                        "id": 6110,
                        "name": "Macleod",
                        "latitude": "-37.73333000",
                        "longitude": "145.06667000"
                    },
                    {
                        "id": 6117,
                        "name": "Maddingley",
                        "latitude": "-37.68518000",
                        "longitude": "144.43245000"
                    },
                    {
                        "id": 6121,
                        "name": "Maffra",
                        "latitude": "-37.97132000",
                        "longitude": "146.98366000"
                    },
                    {
                        "id": 6125,
                        "name": "Maiden Gully",
                        "latitude": "-36.75389000",
                        "longitude": "144.20789000"
                    },
                    {
                        "id": 6126,
                        "name": "Maidstone",
                        "latitude": "-37.78035000",
                        "longitude": "144.87353000"
                    },
                    {
                        "id": 6135,
                        "name": "Maldon",
                        "latitude": "-36.99570000",
                        "longitude": "144.06834000"
                    },
                    {
                        "id": 6137,
                        "name": "Mallacoota",
                        "latitude": "-37.55896000",
                        "longitude": "149.75407000"
                    },
                    {
                        "id": 6140,
                        "name": "Malvern",
                        "latitude": "-37.86259000",
                        "longitude": "145.02811000"
                    },
                    {
                        "id": 6142,
                        "name": "Malvern East",
                        "latitude": "-37.87397000",
                        "longitude": "145.04253000"
                    },
                    {
                        "id": 6147,
                        "name": "Manifold Heights",
                        "latitude": "-38.13762000",
                        "longitude": "144.33369000"
                    },
                    {
                        "id": 6156,
                        "name": "Manningham",
                        "latitude": "-37.75710000",
                        "longitude": "145.18053000"
                    },
                    {
                        "id": 6161,
                        "name": "Mansfield",
                        "latitude": "-37.24130000",
                        "longitude": "146.14803000"
                    },
                    {
                        "id": 6180,
                        "name": "Maribyrnong",
                        "latitude": "-37.79141000",
                        "longitude": "144.87786000"
                    },
                    {
                        "id": 6186,
                        "name": "Marong",
                        "latitude": "-36.73333000",
                        "longitude": "144.13333000"
                    },
                    {
                        "id": 6189,
                        "name": "Maroondah",
                        "latitude": "-37.80288000",
                        "longitude": "145.26603000"
                    },
                    {
                        "id": 6197,
                        "name": "Maryborough",
                        "latitude": "-37.04562000",
                        "longitude": "143.73923000"
                    },
                    {
                        "id": 6214,
                        "name": "McCrae",
                        "latitude": "-38.34972000",
                        "longitude": "144.92806000"
                    },
                    {
                        "id": 6220,
                        "name": "McKinnon",
                        "latitude": "-37.91667000",
                        "longitude": "145.05000000"
                    },
                    {
                        "id": 6224,
                        "name": "Meadow Heights",
                        "latitude": "-37.65117000",
                        "longitude": "144.91855000"
                    },
                    {
                        "id": 6235,
                        "name": "Melbourne",
                        "latitude": "-37.81400000",
                        "longitude": "144.96332000"
                    },
                    {
                        "id": 6236,
                        "name": "Melbourne City Centre",
                        "latitude": "-37.81501000",
                        "longitude": "144.96657000"
                    },
                    {
                        "id": 6239,
                        "name": "Melton",
                        "latitude": "-37.68144000",
                        "longitude": "144.62292000"
                    },
                    {
                        "id": 6240,
                        "name": "Melton South",
                        "latitude": "-37.70773000",
                        "longitude": "144.57493000"
                    },
                    {
                        "id": 6241,
                        "name": "Melton West",
                        "latitude": "-37.67852000",
                        "longitude": "144.56883000"
                    },
                    {
                        "id": 6247,
                        "name": "Mentone",
                        "latitude": "-37.98333000",
                        "longitude": "145.06667000"
                    },
                    {
                        "id": 6250,
                        "name": "Merbein",
                        "latitude": "-34.16802000",
                        "longitude": "142.06599000"
                    },
                    {
                        "id": 6258,
                        "name": "Mernda",
                        "latitude": "-37.60075000",
                        "longitude": "145.09555000"
                    },
                    {
                        "id": 6266,
                        "name": "Metung",
                        "latitude": "-37.89154000",
                        "longitude": "147.85300000"
                    },
                    {
                        "id": 6269,
                        "name": "Mickleham",
                        "latitude": "-37.53664000",
                        "longitude": "144.90204000"
                    },
                    {
                        "id": 6273,
                        "name": "Middle Park",
                        "latitude": "-37.85116000",
                        "longitude": "144.96201000"
                    },
                    {
                        "id": 6283,
                        "name": "Mildura",
                        "latitude": "-34.18551000",
                        "longitude": "142.16251000"
                    },
                    {
                        "id": 6284,
                        "name": "Mildura Shire",
                        "latitude": "-34.86450000",
                        "longitude": "141.85232000"
                    },
                    {
                        "id": 6288,
                        "name": "Mill Park",
                        "latitude": "-37.66667000",
                        "longitude": "145.06667000"
                    },
                    {
                        "id": 6294,
                        "name": "Millgrove",
                        "latitude": "-37.75527000",
                        "longitude": "145.65347000"
                    },
                    {
                        "id": 6308,
                        "name": "Miners Rest",
                        "latitude": "-37.48080000",
                        "longitude": "143.80107000"
                    },
                    {
                        "id": 6316,
                        "name": "Mirboo North",
                        "latitude": "-38.40101000",
                        "longitude": "146.16135000"
                    },
                    {
                        "id": 6320,
                        "name": "Mitcham",
                        "latitude": "-37.81667000",
                        "longitude": "145.20000000"
                    },
                    {
                        "id": 6322,
                        "name": "Mitchell",
                        "latitude": "-37.17535000",
                        "longitude": "144.97999000"
                    },
                    {
                        "id": 6333,
                        "name": "Moe",
                        "latitude": "-38.17828000",
                        "longitude": "146.26099000"
                    },
                    {
                        "id": 6337,
                        "name": "Moira",
                        "latitude": "-36.05060000",
                        "longitude": "145.53815000"
                    },
                    {
                        "id": 6344,
                        "name": "Monash",
                        "latitude": "-37.89675000",
                        "longitude": "145.14714000"
                    },
                    {
                        "id": 6346,
                        "name": "Monbulk",
                        "latitude": "-37.87427000",
                        "longitude": "145.42592000"
                    },
                    {
                        "id": 6348,
                        "name": "Mont Albert",
                        "latitude": "-37.81788000",
                        "longitude": "145.10799000"
                    },
                    {
                        "id": 6349,
                        "name": "Mont Albert North",
                        "latitude": "-37.80043000",
                        "longitude": "145.10828000"
                    },
                    {
                        "id": 6352,
                        "name": "Montmorency",
                        "latitude": "-37.71667000",
                        "longitude": "145.11667000"
                    },
                    {
                        "id": 6354,
                        "name": "Montrose",
                        "latitude": "-37.81667000",
                        "longitude": "145.35000000"
                    },
                    {
                        "id": 6357,
                        "name": "Moolap",
                        "latitude": "-38.18333000",
                        "longitude": "144.43333000"
                    },
                    {
                        "id": 6362,
                        "name": "Moonee Ponds",
                        "latitude": "-37.76667000",
                        "longitude": "144.91667000"
                    },
                    {
                        "id": 6363,
                        "name": "Moonee Valley",
                        "latitude": "-37.74941000",
                        "longitude": "144.89325000"
                    },
                    {
                        "id": 6366,
                        "name": "Moorabbin",
                        "latitude": "-37.94146000",
                        "longitude": "145.05779000"
                    },
                    {
                        "id": 6367,
                        "name": "Moorabool",
                        "latitude": "-37.63338000",
                        "longitude": "144.21946000"
                    },
                    {
                        "id": 6372,
                        "name": "Moorooduc",
                        "latitude": "-38.21667000",
                        "longitude": "145.11667000"
                    },
                    {
                        "id": 6374,
                        "name": "Mooroolbark",
                        "latitude": "-37.78247000",
                        "longitude": "145.31682000"
                    },
                    {
                        "id": 6375,
                        "name": "Mooroopna",
                        "latitude": "-36.40000000",
                        "longitude": "145.35000000"
                    },
                    {
                        "id": 6379,
                        "name": "Mordialloc",
                        "latitude": "-38.00000000",
                        "longitude": "145.08333000"
                    },
                    {
                        "id": 6382,
                        "name": "Moreland",
                        "latitude": "-37.73557000",
                        "longitude": "144.93745000"
                    },
                    {
                        "id": 6387,
                        "name": "Mornington",
                        "latitude": "-38.21792000",
                        "longitude": "145.03876000"
                    },
                    {
                        "id": 6390,
                        "name": "Mornington Peninsula",
                        "latitude": "-38.34004000",
                        "longitude": "145.05455000"
                    },
                    {
                        "id": 6395,
                        "name": "Mortlake",
                        "latitude": "-38.08102000",
                        "longitude": "142.80827000"
                    },
                    {
                        "id": 6398,
                        "name": "Morwell",
                        "latitude": "-38.23476000",
                        "longitude": "146.39499000"
                    },
                    {
                        "id": 6404,
                        "name": "Mount Alexander",
                        "latitude": "-37.07607000",
                        "longitude": "144.18825000"
                    },
                    {
                        "id": 6409,
                        "name": "Mount Buller",
                        "latitude": "-37.14595000",
                        "longitude": "146.43694000"
                    },
                    {
                        "id": 6411,
                        "name": "Mount Clear",
                        "latitude": "-37.60000000",
                        "longitude": "143.88333000"
                    },
                    {
                        "id": 6417,
                        "name": "Mount Dandenong",
                        "latitude": "-37.83333000",
                        "longitude": "145.36667000"
                    },
                    {
                        "id": 6419,
                        "name": "Mount Duneed",
                        "latitude": "-38.24089000",
                        "longitude": "144.33748000"
                    },
                    {
                        "id": 6420,
                        "name": "Mount Eliza",
                        "latitude": "-38.18333000",
                        "longitude": "145.08333000"
                    },
                    {
                        "id": 6421,
                        "name": "Mount Evelyn",
                        "latitude": "-37.78333000",
                        "longitude": "145.38333000"
                    },
                    {
                        "id": 6426,
                        "name": "Mount Helen",
                        "latitude": "-37.62463000",
                        "longitude": "143.87890000"
                    },
                    {
                        "id": 6438,
                        "name": "Mount Macedon",
                        "latitude": "-37.40048000",
                        "longitude": "144.58412000"
                    },
                    {
                        "id": 6441,
                        "name": "Mount Martha",
                        "latitude": "-38.26667000",
                        "longitude": "145.01667000"
                    },
                    {
                        "id": 6449,
                        "name": "Mount Pleasant",
                        "latitude": "-37.58333000",
                        "longitude": "143.86667000"
                    },
                    {
                        "id": 6464,
                        "name": "Mount Waverley",
                        "latitude": "-37.87709000",
                        "longitude": "145.12939000"
                    },
                    {
                        "id": 6468,
                        "name": "Moyne",
                        "latitude": "-38.18785000",
                        "longitude": "142.46217000"
                    },
                    {
                        "id": 6476,
                        "name": "Mulgrave",
                        "latitude": "-37.92845000",
                        "longitude": "145.17708000"
                    },
                    {
                        "id": 6496,
                        "name": "Murrindindi",
                        "latitude": "-37.28104000",
                        "longitude": "145.67437000"
                    },
                    {
                        "id": 6499,
                        "name": "Murrumbeena",
                        "latitude": "-37.90000000",
                        "longitude": "145.06667000"
                    },
                    {
                        "id": 6507,
                        "name": "Myrtleford",
                        "latitude": "-36.56104000",
                        "longitude": "146.72371000"
                    },
                    {
                        "id": 6509,
                        "name": "Nagambie",
                        "latitude": "-36.78515000",
                        "longitude": "145.15375000"
                    },
                    {
                        "id": 6537,
                        "name": "Narre Warren",
                        "latitude": "-38.03333000",
                        "longitude": "145.30000000"
                    },
                    {
                        "id": 6538,
                        "name": "Narre Warren North",
                        "latitude": "-37.98333000",
                        "longitude": "145.31667000"
                    },
                    {
                        "id": 6539,
                        "name": "Narre Warren South",
                        "latitude": "-38.04369000",
                        "longitude": "145.29230000"
                    },
                    {
                        "id": 6543,
                        "name": "Nathalia",
                        "latitude": "-36.05772000",
                        "longitude": "145.20406000"
                    },
                    {
                        "id": 6547,
                        "name": "Neerim South",
                        "latitude": "-38.01683000",
                        "longitude": "145.95447000"
                    },
                    {
                        "id": 6557,
                        "name": "New Gisborne",
                        "latitude": "-37.46065000",
                        "longitude": "144.59930000"
                    },
                    {
                        "id": 6562,
                        "name": "Newborough",
                        "latitude": "-38.17171000",
                        "longitude": "146.29264000"
                    },
                    {
                        "id": 6566,
                        "name": "Newcomb",
                        "latitude": "-38.16623000",
                        "longitude": "144.39429000"
                    },
                    {
                        "id": 6567,
                        "name": "Newington",
                        "latitude": "-37.55846000",
                        "longitude": "143.82485000"
                    },
                    {
                        "id": 6573,
                        "name": "Newport",
                        "latitude": "-37.84427000",
                        "longitude": "144.88483000"
                    },
                    {
                        "id": 6580,
                        "name": "Newtown",
                        "latitude": "-38.15391000",
                        "longitude": "144.33507000"
                    },
                    {
                        "id": 6584,
                        "name": "Nhill",
                        "latitude": "-36.33333000",
                        "longitude": "141.65006000"
                    },
                    {
                        "id": 6588,
                        "name": "Nichols Point",
                        "latitude": "-34.21210000",
                        "longitude": "142.21443000"
                    },
                    {
                        "id": 6589,
                        "name": "Nicholson",
                        "latitude": "-37.81667000",
                        "longitude": "147.73333000"
                    },
                    {
                        "id": 6591,
                        "name": "Niddrie",
                        "latitude": "-37.73750000",
                        "longitude": "144.89212000"
                    },
                    {
                        "id": 6593,
                        "name": "Nillumbik",
                        "latitude": "-37.61474000",
                        "longitude": "145.21706000"
                    },
                    {
                        "id": 6598,
                        "name": "Noble Park",
                        "latitude": "-37.96667000",
                        "longitude": "145.16667000"
                    },
                    {
                        "id": 6599,
                        "name": "Noble Park North",
                        "latitude": "-37.94978000",
                        "longitude": "145.19257000"
                    },
                    {
                        "id": 6606,
                        "name": "Norlane",
                        "latitude": "-38.10139000",
                        "longitude": "144.35417000"
                    },
                    {
                        "id": 6617,
                        "name": "North Bendigo",
                        "latitude": "-36.74363000",
                        "longitude": "144.28791000"
                    },
                    {
                        "id": 6621,
                        "name": "North Brighton",
                        "latitude": "-37.90694000",
                        "longitude": "145.00528000"
                    },
                    {
                        "id": 6628,
                        "name": "North Geelong",
                        "latitude": "-38.10953000",
                        "longitude": "144.35134000"
                    },
                    {
                        "id": 6640,
                        "name": "North Melbourne",
                        "latitude": "-37.79798000",
                        "longitude": "144.94512000"
                    },
                    {
                        "id": 6657,
                        "name": "North Warrandyte",
                        "latitude": "-37.72924000",
                        "longitude": "145.21574000"
                    },
                    {
                        "id": 6660,
                        "name": "North Wonthaggi",
                        "latitude": "-38.57769000",
                        "longitude": "145.59302000"
                    },
                    {
                        "id": 6665,
                        "name": "Northcote",
                        "latitude": "-37.76667000",
                        "longitude": "145.00000000"
                    },
                    {
                        "id": 6667,
                        "name": "Northern Grampians",
                        "latitude": "-36.84962000",
                        "longitude": "142.87303000"
                    },
                    {
                        "id": 6677,
                        "name": "Notting Hill",
                        "latitude": "-37.90500000",
                        "longitude": "145.14270000"
                    },
                    {
                        "id": 6684,
                        "name": "Numurkah",
                        "latitude": "-36.08846000",
                        "longitude": "145.44215000"
                    },
                    {
                        "id": 6685,
                        "name": "Nunawading",
                        "latitude": "-37.82043000",
                        "longitude": "145.17308000"
                    },
                    {
                        "id": 6690,
                        "name": "Nyora",
                        "latitude": "-38.33364000",
                        "longitude": "145.67248000"
                    },
                    {
                        "id": 6694,
                        "name": "Oak Park",
                        "latitude": "-37.71842000",
                        "longitude": "144.91945000"
                    },
                    {
                        "id": 6703,
                        "name": "Oakleigh",
                        "latitude": "-37.89809000",
                        "longitude": "145.08837000"
                    },
                    {
                        "id": 6704,
                        "name": "Oakleigh East",
                        "latitude": "-37.90000000",
                        "longitude": "145.11667000"
                    },
                    {
                        "id": 6705,
                        "name": "Oakleigh South",
                        "latitude": "-37.92416000",
                        "longitude": "145.09146000"
                    },
                    {
                        "id": 6710,
                        "name": "Ocean Grove",
                        "latitude": "-38.25772000",
                        "longitude": "144.51919000"
                    },
                    {
                        "id": 6713,
                        "name": "Officer",
                        "latitude": "-38.05916000",
                        "longitude": "145.40947000"
                    },
                    {
                        "id": 6721,
                        "name": "Olinda",
                        "latitude": "-37.85000000",
                        "longitude": "145.36667000"
                    },
                    {
                        "id": 6734,
                        "name": "Orbost",
                        "latitude": "-37.69644000",
                        "longitude": "148.45700000"
                    },
                    {
                        "id": 6740,
                        "name": "Ormond",
                        "latitude": "-37.90000000",
                        "longitude": "145.03333000"
                    },
                    {
                        "id": 6746,
                        "name": "Ouyen",
                        "latitude": "-35.07087000",
                        "longitude": "142.32034000"
                    },
                    {
                        "id": 6763,
                        "name": "Pakenham",
                        "latitude": "-38.07018000",
                        "longitude": "145.47411000"
                    },
                    {
                        "id": 6764,
                        "name": "Pakenham Upper",
                        "latitude": "-38.01667000",
                        "longitude": "145.51667000"
                    },
                    {
                        "id": 6775,
                        "name": "Panton Hill",
                        "latitude": "-37.64082000",
                        "longitude": "145.23991000"
                    },
                    {
                        "id": 6789,
                        "name": "Park Orchards",
                        "latitude": "-37.77688000",
                        "longitude": "145.21463000"
                    },
                    {
                        "id": 6792,
                        "name": "Parkdale",
                        "latitude": "-37.99187000",
                        "longitude": "145.08128000"
                    },
                    {
                        "id": 6800,
                        "name": "Parkville",
                        "latitude": "-37.78333000",
                        "longitude": "144.95000000"
                    },
                    {
                        "id": 6809,
                        "name": "Pascoe Vale",
                        "latitude": "-37.73333000",
                        "longitude": "144.93333000"
                    },
                    {
                        "id": 6810,
                        "name": "Pascoe Vale South",
                        "latitude": "-37.73973000",
                        "longitude": "144.94615000"
                    },
                    {
                        "id": 6811,
                        "name": "Patterson Lakes",
                        "latitude": "-38.06934000",
                        "longitude": "145.14327000"
                    },
                    {
                        "id": 6814,
                        "name": "Paynesville",
                        "latitude": "-37.91886000",
                        "longitude": "147.71944000"
                    },
                    {
                        "id": 6821,
                        "name": "Pearcedale",
                        "latitude": "-38.20300000",
                        "longitude": "145.23488000"
                    },
                    {
                        "id": 6849,
                        "name": "Phillip Island",
                        "latitude": "-38.48349000",
                        "longitude": "145.23102000"
                    },
                    {
                        "id": 6867,
                        "name": "Plenty",
                        "latitude": "-37.66667000",
                        "longitude": "145.11667000"
                    },
                    {
                        "id": 6868,
                        "name": "Plumpton",
                        "latitude": "-37.68701000",
                        "longitude": "144.69082000"
                    },
                    {
                        "id": 6873,
                        "name": "Point Cook",
                        "latitude": "-37.91482000",
                        "longitude": "144.75088000"
                    },
                    {
                        "id": 6875,
                        "name": "Point Lonsdale",
                        "latitude": "-38.28173000",
                        "longitude": "144.61055000"
                    },
                    {
                        "id": 6890,
                        "name": "Port Fairy",
                        "latitude": "-38.38535000",
                        "longitude": "142.23710000"
                    },
                    {
                        "id": 6898,
                        "name": "Port Melbourne",
                        "latitude": "-37.83961000",
                        "longitude": "144.94228000"
                    },
                    {
                        "id": 6901,
                        "name": "Port Phillip",
                        "latitude": "-37.85159000",
                        "longitude": "144.96992000"
                    },
                    {
                        "id": 6909,
                        "name": "Portarlington",
                        "latitude": "-38.11542000",
                        "longitude": "144.65559000"
                    },
                    {
                        "id": 6911,
                        "name": "Portland",
                        "latitude": "-38.34620000",
                        "longitude": "141.60257000"
                    },
                    {
                        "id": 6915,
                        "name": "Prahran",
                        "latitude": "-37.85114000",
                        "longitude": "144.99318000"
                    },
                    {
                        "id": 6917,
                        "name": "Preston",
                        "latitude": "-37.75000000",
                        "longitude": "145.01667000"
                    },
                    {
                        "id": 6920,
                        "name": "Princes Hill",
                        "latitude": "-37.78185000",
                        "longitude": "144.96656000"
                    },
                    {
                        "id": 6925,
                        "name": "Puckapunyal",
                        "latitude": "-36.99493000",
                        "longitude": "145.04005000"
                    },
                    {
                        "id": 6930,
                        "name": "Pyrenees",
                        "latitude": "-37.32756000",
                        "longitude": "143.36472000"
                    },
                    {
                        "id": 6934,
                        "name": "Quarry Hill",
                        "latitude": "-36.77646000",
                        "longitude": "144.28024000"
                    },
                    {
                        "id": 6940,
                        "name": "Queenscliff",
                        "latitude": "-38.26789000",
                        "longitude": "144.66193000"
                    },
                    {
                        "id": 6942,
                        "name": "Queenscliffe",
                        "latitude": "-38.26896000",
                        "longitude": "144.66248000"
                    },
                    {
                        "id": 6967,
                        "name": "Ravenhall",
                        "latitude": "-37.76552000",
                        "longitude": "144.75105000"
                    },
                    {
                        "id": 6975,
                        "name": "Red Cliffs",
                        "latitude": "-34.30942000",
                        "longitude": "142.18971000"
                    },
                    {
                        "id": 6978,
                        "name": "Redan",
                        "latitude": "-37.57649000",
                        "longitude": "143.83862000"
                    },
                    {
                        "id": 6997,
                        "name": "Research",
                        "latitude": "-37.70000000",
                        "longitude": "145.18333000"
                    },
                    {
                        "id": 6998,
                        "name": "Reservoir",
                        "latitude": "-37.71667000",
                        "longitude": "145.00000000"
                    },
                    {
                        "id": 7007,
                        "name": "Richmond",
                        "latitude": "-37.81819000",
                        "longitude": "145.00176000"
                    },
                    {
                        "id": 7015,
                        "name": "Ringwood",
                        "latitude": "-37.81667000",
                        "longitude": "145.23333000"
                    },
                    {
                        "id": 7016,
                        "name": "Ringwood East",
                        "latitude": "-37.81667000",
                        "longitude": "145.25000000"
                    },
                    {
                        "id": 7017,
                        "name": "Ringwood North",
                        "latitude": "-37.80000000",
                        "longitude": "145.23333000"
                    },
                    {
                        "id": 7018,
                        "name": "Ripponlea",
                        "latitude": "-37.88333000",
                        "longitude": "145.00000000"
                    },
                    {
                        "id": 7036,
                        "name": "Robinvale",
                        "latitude": "-34.58356000",
                        "longitude": "142.77228000"
                    },
                    {
                        "id": 7040,
                        "name": "Rochester",
                        "latitude": "-36.36352000",
                        "longitude": "144.70077000"
                    },
                    {
                        "id": 7041,
                        "name": "Rockbank",
                        "latitude": "-37.73353000",
                        "longitude": "144.67003000"
                    },
                    {
                        "id": 7054,
                        "name": "Romsey",
                        "latitude": "-37.35075000",
                        "longitude": "144.74300000"
                    },
                    {
                        "id": 7058,
                        "name": "Rosanna",
                        "latitude": "-37.73895000",
                        "longitude": "145.06735000"
                    },
                    {
                        "id": 7062,
                        "name": "Rosebud",
                        "latitude": "-38.35542000",
                        "longitude": "144.90680000"
                    },
                    {
                        "id": 7063,
                        "name": "Rosebud West",
                        "latitude": "-38.36444000",
                        "longitude": "144.87748000"
                    },
                    {
                        "id": 7064,
                        "name": "Rosedale",
                        "latitude": "-38.15452000",
                        "longitude": "146.78860000"
                    },
                    {
                        "id": 7076,
                        "name": "Ross Creek",
                        "latitude": "-37.65000000",
                        "longitude": "143.75000000"
                    },
                    {
                        "id": 7083,
                        "name": "Rowville",
                        "latitude": "-37.93333000",
                        "longitude": "145.23333000"
                    },
                    {
                        "id": 7084,
                        "name": "Roxburgh Park",
                        "latitude": "-37.62581000",
                        "longitude": "144.92555000"
                    },
                    {
                        "id": 7094,
                        "name": "Rushworth",
                        "latitude": "-36.58669000",
                        "longitude": "145.01750000"
                    },
                    {
                        "id": 7099,
                        "name": "Rutherglen",
                        "latitude": "-36.05430000",
                        "longitude": "146.46212000"
                    },
                    {
                        "id": 7102,
                        "name": "Rye",
                        "latitude": "-38.38528000",
                        "longitude": "144.81221000"
                    },
                    {
                        "id": 7107,
                        "name": "Safety Beach",
                        "latitude": "-38.31535000",
                        "longitude": "145.00027000"
                    },
                    {
                        "id": 7108,
                        "name": "Saint Albans",
                        "latitude": "-37.73333000",
                        "longitude": "144.80000000"
                    },
                    {
                        "id": 7109,
                        "name": "Saint Andrews",
                        "latitude": "-37.60151000",
                        "longitude": "145.27235000"
                    },
                    {
                        "id": 7110,
                        "name": "Saint Andrews Beach",
                        "latitude": "-38.41410000",
                        "longitude": "144.82436000"
                    },
                    {
                        "id": 7111,
                        "name": "Saint Helena",
                        "latitude": "-37.70000000",
                        "longitude": "145.13333000"
                    },
                    {
                        "id": 7113,
                        "name": "Saint Kilda",
                        "latitude": "-37.86760000",
                        "longitude": "144.98099000"
                    },
                    {
                        "id": 7114,
                        "name": "Saint Leonards",
                        "latitude": "-38.17051000",
                        "longitude": "144.71803000"
                    },
                    {
                        "id": 7118,
                        "name": "Sale",
                        "latitude": "-38.11095000",
                        "longitude": "147.06802000"
                    },
                    {
                        "id": 7131,
                        "name": "San Remo",
                        "latitude": "-38.52547000",
                        "longitude": "145.37616000"
                    },
                    {
                        "id": 7136,
                        "name": "Sandhurst",
                        "latitude": "-38.08100000",
                        "longitude": "145.20767000"
                    },
                    {
                        "id": 7137,
                        "name": "Sandringham",
                        "latitude": "-37.95218000",
                        "longitude": "145.01129000"
                    },
                    {
                        "id": 7147,
                        "name": "Sassafras",
                        "latitude": "-37.86667000",
                        "longitude": "145.35000000"
                    },
                    {
                        "id": 7155,
                        "name": "Scoresby",
                        "latitude": "-37.90000000",
                        "longitude": "145.23333000"
                    },
                    {
                        "id": 7158,
                        "name": "Seabrook",
                        "latitude": "-37.88092000",
                        "longitude": "144.75866000"
                    },
                    {
                        "id": 7163,
                        "name": "Seaford",
                        "latitude": "-38.10000000",
                        "longitude": "145.13333000"
                    },
                    {
                        "id": 7168,
                        "name": "Seaholme",
                        "latitude": "-37.86400000",
                        "longitude": "144.84504000"
                    },
                    {
                        "id": 7171,
                        "name": "Sebastopol",
                        "latitude": "-37.58532000",
                        "longitude": "143.83953000"
                    },
                    {
                        "id": 7173,
                        "name": "Seddon",
                        "latitude": "-37.80607000",
                        "longitude": "144.89070000"
                    },
                    {
                        "id": 7176,
                        "name": "Selby",
                        "latitude": "-37.91667000",
                        "longitude": "145.38333000"
                    },
                    {
                        "id": 7187,
                        "name": "Seville",
                        "latitude": "-37.79802000",
                        "longitude": "145.48763000"
                    },
                    {
                        "id": 7189,
                        "name": "Seymour",
                        "latitude": "-37.02655000",
                        "longitude": "145.13924000"
                    },
                    {
                        "id": 7203,
                        "name": "Shepparton",
                        "latitude": "-36.38047000",
                        "longitude": "145.39867000"
                    },
                    {
                        "id": 7204,
                        "name": "Shepparton East",
                        "latitude": "-36.40156000",
                        "longitude": "145.47765000"
                    },
                    {
                        "id": 7213,
                        "name": "Silvan",
                        "latitude": "-37.81667000",
                        "longitude": "145.41667000"
                    },
                    {
                        "id": 7224,
                        "name": "Skye",
                        "latitude": "-38.10505000",
                        "longitude": "145.21630000"
                    },
                    {
                        "id": 7232,
                        "name": "Smythes Creek",
                        "latitude": "-37.60000000",
                        "longitude": "143.78333000"
                    },
                    {
                        "id": 7233,
                        "name": "Smythesdale",
                        "latitude": "-37.64308000",
                        "longitude": "143.68617000"
                    },
                    {
                        "id": 7235,
                        "name": "Soldiers Hill",
                        "latitude": "-37.54962000",
                        "longitude": "143.85872000"
                    },
                    {
                        "id": 7239,
                        "name": "Somers",
                        "latitude": "-38.38134000",
                        "longitude": "145.15898000"
                    },
                    {
                        "id": 7244,
                        "name": "Somerville",
                        "latitude": "-38.21667000",
                        "longitude": "145.16667000"
                    },
                    {
                        "id": 7247,
                        "name": "Sorrento",
                        "latitude": "-38.33958000",
                        "longitude": "144.74126000"
                    },
                    {
                        "id": 7259,
                        "name": "South Gippsland",
                        "latitude": "-38.69897000",
                        "longitude": "146.06702000"
                    },
                    {
                        "id": 7269,
                        "name": "South Kingsville",
                        "latitude": "-37.83018000",
                        "longitude": "144.87090000"
                    },
                    {
                        "id": 7276,
                        "name": "South Melbourne",
                        "latitude": "-37.83333000",
                        "longitude": "144.96667000"
                    },
                    {
                        "id": 7277,
                        "name": "South Morang",
                        "latitude": "-37.65000000",
                        "longitude": "145.10000000"
                    },
                    {
                        "id": 7290,
                        "name": "South Yarra",
                        "latitude": "-37.83834000",
                        "longitude": "144.99149000"
                    },
                    {
                        "id": 7292,
                        "name": "Southbank",
                        "latitude": "-37.82280000",
                        "longitude": "144.96434000"
                    },
                    {
                        "id": 7294,
                        "name": "Southern Grampians",
                        "latitude": "-37.52989000",
                        "longitude": "142.02533000"
                    },
                    {
                        "id": 7305,
                        "name": "Spotswood",
                        "latitude": "-37.82975000",
                        "longitude": "144.88516000"
                    },
                    {
                        "id": 7313,
                        "name": "Springvale",
                        "latitude": "-37.94853000",
                        "longitude": "145.15274000"
                    },
                    {
                        "id": 7315,
                        "name": "Springvale South",
                        "latitude": "-37.96667000",
                        "longitude": "145.15000000"
                    },
                    {
                        "id": 7319,
                        "name": "St Albans Park",
                        "latitude": "-38.18802000",
                        "longitude": "144.39207000"
                    },
                    {
                        "id": 7325,
                        "name": "St Helena",
                        "latitude": "-37.68988000",
                        "longitude": "145.12315000"
                    },
                    {
                        "id": 7332,
                        "name": "St Kilda East",
                        "latitude": "-37.86594000",
                        "longitude": "145.00018000"
                    },
                    {
                        "id": 7333,
                        "name": "St Kilda West",
                        "latitude": "-37.85988000",
                        "longitude": "144.97108000"
                    },
                    {
                        "id": 7345,
                        "name": "Stawell",
                        "latitude": "-37.05632000",
                        "longitude": "142.78088000"
                    },
                    {
                        "id": 7352,
                        "name": "Stonnington",
                        "latitude": "-37.86130000",
                        "longitude": "145.03776000"
                    },
                    {
                        "id": 7354,
                        "name": "Stratford",
                        "latitude": "-37.96340000",
                        "longitude": "147.08260000"
                    },
                    {
                        "id": 7357,
                        "name": "Strathbogie",
                        "latitude": "-36.72402000",
                        "longitude": "145.32938000"
                    },
                    {
                        "id": 7358,
                        "name": "Strathdale",
                        "latitude": "-36.76572000",
                        "longitude": "144.31548000"
                    },
                    {
                        "id": 7361,
                        "name": "Strathfieldsaye",
                        "latitude": "-36.80667000",
                        "longitude": "144.35487000"
                    },
                    {
                        "id": 7362,
                        "name": "Strathmerton",
                        "latitude": "-35.92533000",
                        "longitude": "145.47865000"
                    },
                    {
                        "id": 7363,
                        "name": "Strathmore",
                        "latitude": "-37.73563000",
                        "longitude": "144.92065000"
                    },
                    {
                        "id": 7378,
                        "name": "Sunbury",
                        "latitude": "-37.57742000",
                        "longitude": "144.72607000"
                    },
                    {
                        "id": 7384,
                        "name": "Sunshine",
                        "latitude": "-37.78333000",
                        "longitude": "144.83333000"
                    },
                    {
                        "id": 7388,
                        "name": "Sunshine North",
                        "latitude": "-37.76987000",
                        "longitude": "144.82787000"
                    },
                    {
                        "id": 7389,
                        "name": "Sunshine West",
                        "latitude": "-37.79117000",
                        "longitude": "144.81637000"
                    },
                    {
                        "id": 7390,
                        "name": "Surf Coast",
                        "latitude": "-38.33997000",
                        "longitude": "144.11530000"
                    },
                    {
                        "id": 7394,
                        "name": "Surrey Hills",
                        "latitude": "-37.81667000",
                        "longitude": "145.10000000"
                    },
                    {
                        "id": 7402,
                        "name": "Swan Hill",
                        "latitude": "-35.10061000",
                        "longitude": "143.16810000"
                    },
                    {
                        "id": 7406,
                        "name": "Sydenham",
                        "latitude": "-37.70000000",
                        "longitude": "144.76667000"
                    },
                    {
                        "id": 7418,
                        "name": "Tallangatta",
                        "latitude": "-36.21791000",
                        "longitude": "147.17699000"
                    },
                    {
                        "id": 7440,
                        "name": "Tarneit",
                        "latitude": "-37.83634000",
                        "longitude": "144.65952000"
                    },
                    {
                        "id": 7450,
                        "name": "Tatura",
                        "latitude": "-36.43962000",
                        "longitude": "145.22994000"
                    },
                    {
                        "id": 7451,
                        "name": "Taylors Hill",
                        "latitude": "-37.70988000",
                        "longitude": "144.75483000"
                    },
                    {
                        "id": 7452,
                        "name": "Taylors Lakes",
                        "latitude": "-37.69863000",
                        "longitude": "144.78631000"
                    },
                    {
                        "id": 7455,
                        "name": "Tecoma",
                        "latitude": "-37.90303000",
                        "longitude": "145.34468000"
                    },
                    {
                        "id": 7456,
                        "name": "Teesdale",
                        "latitude": "-38.03333000",
                        "longitude": "144.05000000"
                    },
                    {
                        "id": 7464,
                        "name": "Templestowe",
                        "latitude": "-37.75405000",
                        "longitude": "145.14864000"
                    },
                    {
                        "id": 7465,
                        "name": "Templestowe Lower",
                        "latitude": "-37.76667000",
                        "longitude": "145.11667000"
                    },
                    {
                        "id": 7474,
                        "name": "Terang",
                        "latitude": "-38.24084000",
                        "longitude": "142.92123000"
                    },
                    {
                        "id": 7480,
                        "name": "The Basin",
                        "latitude": "-37.85000000",
                        "longitude": "145.31667000"
                    },
                    {
                        "id": 7491,
                        "name": "The Patch",
                        "latitude": "-37.89187000",
                        "longitude": "145.40216000"
                    },
                    {
                        "id": 7501,
                        "name": "Thomastown",
                        "latitude": "-37.68333000",
                        "longitude": "145.01667000"
                    },
                    {
                        "id": 7502,
                        "name": "Thomson",
                        "latitude": "-38.16984000",
                        "longitude": "144.37890000"
                    },
                    {
                        "id": 7503,
                        "name": "Thornbury",
                        "latitude": "-37.75819000",
                        "longitude": "145.00583000"
                    },
                    {
                        "id": 7514,
                        "name": "Timboon",
                        "latitude": "-38.48434000",
                        "longitude": "142.98033000"
                    },
                    {
                        "id": 7529,
                        "name": "Tongala",
                        "latitude": "-36.25466000",
                        "longitude": "144.95622000"
                    },
                    {
                        "id": 7534,
                        "name": "Tooradin",
                        "latitude": "-38.21475000",
                        "longitude": "145.38325000"
                    },
                    {
                        "id": 7535,
                        "name": "Toorak",
                        "latitude": "-37.84165000",
                        "longitude": "145.01438000"
                    },
                    {
                        "id": 7538,
                        "name": "Tootgarook",
                        "latitude": "-38.37770000",
                        "longitude": "144.85015000"
                    },
                    {
                        "id": 7543,
                        "name": "Torquay",
                        "latitude": "-38.33085000",
                        "longitude": "144.32638000"
                    },
                    {
                        "id": 7552,
                        "name": "Towong",
                        "latitude": "-36.36587000",
                        "longitude": "147.62717000"
                    },
                    {
                        "id": 7554,
                        "name": "Trafalgar",
                        "latitude": "-38.20906000",
                        "longitude": "146.15347000"
                    },
                    {
                        "id": 7558,
                        "name": "Traralgon",
                        "latitude": "-38.19528000",
                        "longitude": "146.54150000"
                    },
                    {
                        "id": 7559,
                        "name": "Travancore",
                        "latitude": "-37.78076000",
                        "longitude": "144.93545000"
                    },
                    {
                        "id": 7562,
                        "name": "Trentham",
                        "latitude": "-37.38876000",
                        "longitude": "144.32164000"
                    },
                    {
                        "id": 7569,
                        "name": "Truganina",
                        "latitude": "-37.81667000",
                        "longitude": "144.75000000"
                    },
                    {
                        "id": 7574,
                        "name": "Tullamarine",
                        "latitude": "-37.70128000",
                        "longitude": "144.88100000"
                    },
                    {
                        "id": 7596,
                        "name": "Tyabb",
                        "latitude": "-38.25000000",
                        "longitude": "145.18333000"
                    },
                    {
                        "id": 7614,
                        "name": "Upwey",
                        "latitude": "-37.90000000",
                        "longitude": "145.33333000"
                    },
                    {
                        "id": 7629,
                        "name": "Vermont",
                        "latitude": "-37.83616000",
                        "longitude": "145.19428000"
                    },
                    {
                        "id": 7630,
                        "name": "Vermont South",
                        "latitude": "-37.85747000",
                        "longitude": "145.18270000"
                    },
                    {
                        "id": 7636,
                        "name": "Viewbank",
                        "latitude": "-37.73991000",
                        "longitude": "145.09323000"
                    },
                    {
                        "id": 7655,
                        "name": "Wahgunyah",
                        "latitude": "-36.01178000",
                        "longitude": "146.39714000"
                    },
                    {
                        "id": 7671,
                        "name": "Wallan",
                        "latitude": "-37.41625000",
                        "longitude": "144.97859000"
                    },
                    {
                        "id": 7674,
                        "name": "Wallington",
                        "latitude": "-38.22641000",
                        "longitude": "144.51199000"
                    },
                    {
                        "id": 7681,
                        "name": "Wandana Heights",
                        "latitude": "-38.17577000",
                        "longitude": "144.30387000"
                    },
                    {
                        "id": 7684,
                        "name": "Wandin North",
                        "latitude": "-37.78333000",
                        "longitude": "145.43333000"
                    },
                    {
                        "id": 7687,
                        "name": "Wandong",
                        "latitude": "-37.37190000",
                        "longitude": "145.03207000"
                    },
                    {
                        "id": 7688,
                        "name": "Wangaratta",
                        "latitude": "-36.61599000",
                        "longitude": "146.42839000"
                    },
                    {
                        "id": 7694,
                        "name": "Wantirna",
                        "latitude": "-37.85000000",
                        "longitude": "145.21667000"
                    },
                    {
                        "id": 7695,
                        "name": "Wantirna South",
                        "latitude": "-37.88333000",
                        "longitude": "145.21667000"
                    },
                    {
                        "id": 7702,
                        "name": "Warburton",
                        "latitude": "-37.75375000",
                        "longitude": "145.69037000"
                    },
                    {
                        "id": 7710,
                        "name": "Warracknabeal",
                        "latitude": "-36.25326000",
                        "longitude": "142.39281000"
                    },
                    {
                        "id": 7713,
                        "name": "Warragul",
                        "latitude": "-38.15912000",
                        "longitude": "145.93118000"
                    },
                    {
                        "id": 7714,
                        "name": "Warrandyte",
                        "latitude": "-37.75000000",
                        "longitude": "145.23333000"
                    },
                    {
                        "id": 7716,
                        "name": "Warranwood",
                        "latitude": "-37.77555000",
                        "longitude": "145.24728000"
                    },
                    {
                        "id": 7723,
                        "name": "Warrnambool",
                        "latitude": "-38.38176000",
                        "longitude": "142.48799000"
                    },
                    {
                        "id": 7734,
                        "name": "Waterways",
                        "latitude": "-38.01478000",
                        "longitude": "145.13050000"
                    },
                    {
                        "id": 7736,
                        "name": "Watsonia",
                        "latitude": "-37.71667000",
                        "longitude": "145.08333000"
                    },
                    {
                        "id": 7737,
                        "name": "Watsonia North",
                        "latitude": "-37.69981000",
                        "longitude": "145.08468000"
                    },
                    {
                        "id": 7743,
                        "name": "Wattleglen",
                        "latitude": "-37.66667000",
                        "longitude": "145.18333000"
                    },
                    {
                        "id": 7745,
                        "name": "Waurn Ponds",
                        "latitude": "-38.21667000",
                        "longitude": "144.28333000"
                    },
                    {
                        "id": 7757,
                        "name": "Wellington",
                        "latitude": "-38.03765000",
                        "longitude": "147.01697000"
                    },
                    {
                        "id": 7762,
                        "name": "Wendouree",
                        "latitude": "-37.53078000",
                        "longitude": "143.82838000"
                    },
                    {
                        "id": 7767,
                        "name": "Werribee",
                        "latitude": "-37.90000000",
                        "longitude": "144.66667000"
                    },
                    {
                        "id": 7768,
                        "name": "Werribee South",
                        "latitude": "-37.94750000",
                        "longitude": "144.71667000"
                    },
                    {
                        "id": 7773,
                        "name": "Wesburn",
                        "latitude": "-37.76667000",
                        "longitude": "145.63333000"
                    },
                    {
                        "id": 7785,
                        "name": "West Footscray",
                        "latitude": "-37.79746000",
                        "longitude": "144.87727000"
                    },
                    {
                        "id": 7799,
                        "name": "West Melbourne",
                        "latitude": "-37.81014000",
                        "longitude": "144.95000000"
                    },
                    {
                        "id": 7811,
                        "name": "West Wimmera",
                        "latitude": "-36.59921000",
                        "longitude": "141.40038000"
                    },
                    {
                        "id": 7812,
                        "name": "West Wodonga",
                        "latitude": "-36.12346000",
                        "longitude": "146.85193000"
                    },
                    {
                        "id": 7825,
                        "name": "Westmeadows",
                        "latitude": "-37.67604000",
                        "longitude": "144.88701000"
                    },
                    {
                        "id": 7832,
                        "name": "Wheelers Hill",
                        "latitude": "-37.90000000",
                        "longitude": "145.18333000"
                    },
                    {
                        "id": 7834,
                        "name": "White Hills",
                        "latitude": "-36.72875000",
                        "longitude": "144.30525000"
                    },
                    {
                        "id": 7837,
                        "name": "Whitehorse",
                        "latitude": "-37.82868000",
                        "longitude": "145.15432000"
                    },
                    {
                        "id": 7841,
                        "name": "Whittington",
                        "latitude": "-38.18080000",
                        "longitude": "144.39322000"
                    },
                    {
                        "id": 7842,
                        "name": "Whittlesea",
                        "latitude": "-37.55087000",
                        "longitude": "145.09375000"
                    },
                    {
                        "id": 7857,
                        "name": "Williams Landing",
                        "latitude": "-37.86190000",
                        "longitude": "144.74371000"
                    },
                    {
                        "id": 7858,
                        "name": "Williamstown",
                        "latitude": "-37.86349000",
                        "longitude": "144.89900000"
                    },
                    {
                        "id": 7860,
                        "name": "Williamstown North",
                        "latitude": "-37.85515000",
                        "longitude": "144.88259000"
                    },
                    {
                        "id": 7874,
                        "name": "Winchelsea",
                        "latitude": "-38.24485000",
                        "longitude": "143.98322000"
                    },
                    {
                        "id": 7879,
                        "name": "Windsor",
                        "latitude": "-37.85344000",
                        "longitude": "144.99241000"
                    },
                    {
                        "id": 7895,
                        "name": "Wodonga",
                        "latitude": "-36.14469000",
                        "longitude": "146.88818000"
                    },
                    {
                        "id": 7896,
                        "name": "Wollert",
                        "latitude": "-37.58333000",
                        "longitude": "145.03333000"
                    },
                    {
                        "id": 7905,
                        "name": "Wonga Park",
                        "latitude": "-37.73333000",
                        "longitude": "145.26667000"
                    },
                    {
                        "id": 7909,
                        "name": "Wonthaggi",
                        "latitude": "-38.60586000",
                        "longitude": "145.59355000"
                    },
                    {
                        "id": 7917,
                        "name": "Woodend",
                        "latitude": "-37.35469000",
                        "longitude": "144.52902000"
                    },
                    {
                        "id": 7945,
                        "name": "Woori Yallock",
                        "latitude": "-37.78062000",
                        "longitude": "145.53819000"
                    },
                    {
                        "id": 7962,
                        "name": "Wurruk",
                        "latitude": "-38.11667000",
                        "longitude": "147.03333000"
                    },
                    {
                        "id": 7965,
                        "name": "Wy Yung",
                        "latitude": "-37.80000000",
                        "longitude": "147.58333000"
                    },
                    {
                        "id": 7969,
                        "name": "Wyndham",
                        "latitude": "-37.89280000",
                        "longitude": "144.63573000"
                    },
                    {
                        "id": 7970,
                        "name": "Wyndham Vale",
                        "latitude": "-37.89138000",
                        "longitude": "144.62368000"
                    },
                    {
                        "id": 7980,
                        "name": "Yackandandah",
                        "latitude": "-36.31371000",
                        "longitude": "146.83958000"
                    },
                    {
                        "id": 7984,
                        "name": "Yallambie",
                        "latitude": "-37.72515000",
                        "longitude": "145.09352000"
                    },
                    {
                        "id": 7986,
                        "name": "Yallourn North",
                        "latitude": "-38.16053000",
                        "longitude": "146.36449000"
                    },
                    {
                        "id": 7995,
                        "name": "Yarra",
                        "latitude": "-37.80178000",
                        "longitude": "144.99593000"
                    },
                    {
                        "id": 7996,
                        "name": "Yarra Glen",
                        "latitude": "-37.65794000",
                        "longitude": "145.37416000"
                    },
                    {
                        "id": 7997,
                        "name": "Yarra Junction",
                        "latitude": "-37.78192000",
                        "longitude": "145.61430000"
                    },
                    {
                        "id": 7998,
                        "name": "Yarra Ranges",
                        "latitude": "-37.75006000",
                        "longitude": "145.73708000"
                    },
                    {
                        "id": 8001,
                        "name": "Yarragon",
                        "latitude": "-38.20525000",
                        "longitude": "146.06079000"
                    },
                    {
                        "id": 8003,
                        "name": "Yarram",
                        "latitude": "-38.56479000",
                        "longitude": "146.67557000"
                    },
                    {
                        "id": 8005,
                        "name": "Yarrambat",
                        "latitude": "-37.63751000",
                        "longitude": "145.13486000"
                    },
                    {
                        "id": 8007,
                        "name": "Yarraville",
                        "latitude": "-37.81667000",
                        "longitude": "144.90000000"
                    },
                    {
                        "id": 8009,
                        "name": "Yarrawonga",
                        "latitude": "-36.01923000",
                        "longitude": "145.99973000"
                    },
                    {
                        "id": 8010,
                        "name": "Yarriambiack",
                        "latitude": "-36.02618000",
                        "longitude": "142.40452000"
                    },
                    {
                        "id": 8014,
                        "name": "Yea",
                        "latitude": "-37.21067000",
                        "longitude": "145.42755000"
                    }
                ]
            },
            {
                "id": 3906,
                "name": "Western Australia",
                "iso2": "WA",
                "latitude": "-27.67281680",
                "longitude": "121.62830980",
                "type": "state",
                "cities": [
                    {
                        "id": 3902,
                        "name": "Abbey",
                        "latitude": "-33.66364000",
                        "longitude": "115.25635000"
                    },
                    {
                        "id": 3930,
                        "name": "Albany",
                        "latitude": "-34.70990000",
                        "longitude": "118.12345000"
                    },
                    {
                        "id": 3932,
                        "name": "Albany city centre",
                        "latitude": "-35.02479000",
                        "longitude": "117.88472000"
                    },
                    {
                        "id": 3946,
                        "name": "Alexander Heights",
                        "latitude": "-31.82758000",
                        "longitude": "115.86501000"
                    },
                    {
                        "id": 3953,
                        "name": "Alfred Cove",
                        "latitude": "-32.03316000",
                        "longitude": "115.81259000"
                    },
                    {
                        "id": 3958,
                        "name": "Alkimos",
                        "latitude": "-31.63039000",
                        "longitude": "115.68638000"
                    },
                    {
                        "id": 3992,
                        "name": "Applecross",
                        "latitude": "-32.01667000",
                        "longitude": "115.83333000"
                    },
                    {
                        "id": 4000,
                        "name": "Ardross",
                        "latitude": "-32.02696000",
                        "longitude": "115.83548000"
                    },
                    {
                        "id": 4003,
                        "name": "Armadale",
                        "latitude": "-32.17887000",
                        "longitude": "116.12750000"
                    },
                    {
                        "id": 4013,
                        "name": "Ascot",
                        "latitude": "-31.93818000",
                        "longitude": "115.92258000"
                    },
                    {
                        "id": 4017,
                        "name": "Ashburton",
                        "latitude": "-22.27674000",
                        "longitude": "116.90057000"
                    },
                    {
                        "id": 4019,
                        "name": "Ashby",
                        "latitude": "-31.73255000",
                        "longitude": "115.79768000"
                    },
                    {
                        "id": 4021,
                        "name": "Ashfield",
                        "latitude": "-31.91721000",
                        "longitude": "115.93796000"
                    },
                    {
                        "id": 4036,
                        "name": "Attadale",
                        "latitude": "-32.02489000",
                        "longitude": "115.80200000"
                    },
                    {
                        "id": 4038,
                        "name": "Atwell",
                        "latitude": "-32.14346000",
                        "longitude": "115.86528000"
                    },
                    {
                        "id": 4039,
                        "name": "Aubin Grove",
                        "latitude": "-32.16714000",
                        "longitude": "115.86264000"
                    },
                    {
                        "id": 4042,
                        "name": "Augusta",
                        "latitude": "-34.31566000",
                        "longitude": "115.15922000"
                    },
                    {
                        "id": 4043,
                        "name": "Augusta-Margaret River Shire",
                        "latitude": "-34.11520000",
                        "longitude": "115.32277000"
                    },
                    {
                        "id": 4049,
                        "name": "Australind",
                        "latitude": "-33.27920000",
                        "longitude": "115.71504000"
                    },
                    {
                        "id": 4050,
                        "name": "Aveley",
                        "latitude": "-31.78132000",
                        "longitude": "115.98959000"
                    },
                    {
                        "id": 149550,
                        "name": "Badgingarra",
                        "latitude": "-30.44367330",
                        "longitude": "115.47471450"
                    },
                    {
                        "id": 4066,
                        "name": "Bakers Hill",
                        "latitude": "-31.74692000",
                        "longitude": "116.45866000"
                    },
                    {
                        "id": 4070,
                        "name": "Balcatta",
                        "latitude": "-31.87501000",
                        "longitude": "115.82839000"
                    },
                    {
                        "id": 4072,
                        "name": "Baldivis",
                        "latitude": "-32.32889000",
                        "longitude": "115.83047000"
                    },
                    {
                        "id": 4073,
                        "name": "Balga",
                        "latitude": "-31.85497000",
                        "longitude": "115.83986000"
                    },
                    {
                        "id": 4078,
                        "name": "Ballajura",
                        "latitude": "-31.84062000",
                        "longitude": "115.89549000"
                    },
                    {
                        "id": 4097,
                        "name": "Banjup",
                        "latitude": "-32.14179000",
                        "longitude": "115.88671000"
                    },
                    {
                        "id": 4101,
                        "name": "Banksia Grove",
                        "latitude": "-31.69615000",
                        "longitude": "115.80501000"
                    },
                    {
                        "id": 4135,
                        "name": "Bassendean",
                        "latitude": "-31.90584000",
                        "longitude": "115.94501000"
                    },
                    {
                        "id": 4138,
                        "name": "Bateman",
                        "latitude": "-32.05547000",
                        "longitude": "115.84737000"
                    },
                    {
                        "id": 4150,
                        "name": "Baynton",
                        "latitude": "-20.75164000",
                        "longitude": "116.80139000"
                    },
                    {
                        "id": 4151,
                        "name": "Bayonet Head",
                        "latitude": "-34.97305000",
                        "longitude": "117.93446000"
                    },
                    {
                        "id": 4154,
                        "name": "Bayswater",
                        "latitude": "-31.91181000",
                        "longitude": "115.90870000"
                    },
                    {
                        "id": 4157,
                        "name": "Beachlands",
                        "latitude": "-28.78570000",
                        "longitude": "114.60192000"
                    },
                    {
                        "id": 4162,
                        "name": "Beaconsfield",
                        "latitude": "-32.06748000",
                        "longitude": "115.76401000"
                    },
                    {
                        "id": 4171,
                        "name": "Beckenham",
                        "latitude": "-32.02481000",
                        "longitude": "115.95989000"
                    },
                    {
                        "id": 4172,
                        "name": "Bedford",
                        "latitude": "-31.91132000",
                        "longitude": "115.88920000"
                    },
                    {
                        "id": 4174,
                        "name": "Bedfordale",
                        "latitude": "-32.17406000",
                        "longitude": "116.05040000"
                    },
                    {
                        "id": 4175,
                        "name": "Beechboro",
                        "latitude": "-31.86515000",
                        "longitude": "115.93661000"
                    },
                    {
                        "id": 4178,
                        "name": "Beeliar",
                        "latitude": "-32.13339000",
                        "longitude": "115.80637000"
                    },
                    {
                        "id": 4185,
                        "name": "Beldon",
                        "latitude": "-31.77466000",
                        "longitude": "115.76270000"
                    },
                    {
                        "id": 4201,
                        "name": "Bellevue",
                        "latitude": "-31.90116000",
                        "longitude": "116.02762000"
                    },
                    {
                        "id": 4209,
                        "name": "Belmont",
                        "latitude": "-31.95458000",
                        "longitude": "115.94218000"
                    },
                    {
                        "id": 4220,
                        "name": "Bennett Springs",
                        "latitude": "-31.85941000",
                        "longitude": "115.94512000"
                    },
                    {
                        "id": 4225,
                        "name": "Bentley",
                        "latitude": "-32.00224000",
                        "longitude": "115.92473000"
                    },
                    {
                        "id": 4229,
                        "name": "Beresford",
                        "latitude": "-28.75754000",
                        "longitude": "114.61965000"
                    },
                    {
                        "id": 4245,
                        "name": "Bertram",
                        "latitude": "-32.24369000",
                        "longitude": "115.84572000"
                    },
                    {
                        "id": 4249,
                        "name": "Beverley",
                        "latitude": "-32.10839000",
                        "longitude": "116.92736000"
                    },
                    {
                        "id": 4255,
                        "name": "Bibra Lake",
                        "latitude": "-32.09764000",
                        "longitude": "115.81921000"
                    },
                    {
                        "id": 4256,
                        "name": "Bicton",
                        "latitude": "-32.02778000",
                        "longitude": "115.78333000"
                    },
                    {
                        "id": 4262,
                        "name": "Bilingurr",
                        "latitude": "-17.90909000",
                        "longitude": "122.22921000"
                    },
                    {
                        "id": 4264,
                        "name": "Bindoon",
                        "latitude": "-31.38663000",
                        "longitude": "116.09664000"
                    },
                    {
                        "id": 4266,
                        "name": "Binningup",
                        "latitude": "-33.14830000",
                        "longitude": "115.69519000"
                    },
                    {
                        "id": 4312,
                        "name": "Bluff Point",
                        "latitude": "-28.73740000",
                        "longitude": "114.62278000"
                    },
                    {
                        "id": 4315,
                        "name": "Boddington",
                        "latitude": "-32.79195000",
                        "longitude": "116.41883000"
                    },
                    {
                        "id": 4343,
                        "name": "Booragoon",
                        "latitude": "-32.03945000",
                        "longitude": "115.83369000"
                    },
                    {
                        "id": 4356,
                        "name": "Boulder",
                        "latitude": "-30.78204000",
                        "longitude": "121.49120000"
                    },
                    {
                        "id": 4371,
                        "name": "Boyanup",
                        "latitude": "-33.48295000",
                        "longitude": "115.72838000"
                    },
                    {
                        "id": 4373,
                        "name": "Boyup Brook",
                        "latitude": "-33.88555000",
                        "longitude": "116.51885000"
                    },
                    {
                        "id": 4374,
                        "name": "Brabham",
                        "latitude": "-31.82728000",
                        "longitude": "115.97417000"
                    },
                    {
                        "id": 4390,
                        "name": "Brentwood",
                        "latitude": "-32.04347000",
                        "longitude": "115.85246000"
                    },
                    {
                        "id": 4395,
                        "name": "Bridgetown",
                        "latitude": "-33.96242000",
                        "longitude": "116.13598000"
                    },
                    {
                        "id": 4396,
                        "name": "Bridgetown-Greenbushes",
                        "latitude": "-33.99234000",
                        "longitude": "116.22502000"
                    },
                    {
                        "id": 4418,
                        "name": "Broadwater",
                        "latitude": "-33.66304000",
                        "longitude": "115.28420000"
                    },
                    {
                        "id": 4419,
                        "name": "Brockman",
                        "latitude": "-24.88126000",
                        "longitude": "113.65365000"
                    },
                    {
                        "id": 4424,
                        "name": "Brookdale",
                        "latitude": "-32.16696000",
                        "longitude": "116.00193000"
                    },
                    {
                        "id": 4429,
                        "name": "Brookton",
                        "latitude": "-32.35533000",
                        "longitude": "116.99994000"
                    },
                    {
                        "id": 4432,
                        "name": "Broome",
                        "latitude": "-17.94041000",
                        "longitude": "122.64038000"
                    },
                    {
                        "id": 4433,
                        "name": "Broomehill-Tambellup",
                        "latitude": "-34.01320000",
                        "longitude": "117.65297000"
                    },
                    {
                        "id": 4437,
                        "name": "Bruce Rock",
                        "latitude": "-31.96651000",
                        "longitude": "118.02385000"
                    },
                    {
                        "id": 4439,
                        "name": "Brunswick",
                        "latitude": "-33.23240000",
                        "longitude": "115.86282000"
                    },
                    {
                        "id": 4451,
                        "name": "Bulgarra",
                        "latitude": "-20.72584000",
                        "longitude": "116.85673000"
                    },
                    {
                        "id": 4453,
                        "name": "Bull Creek",
                        "latitude": "-32.05625000",
                        "longitude": "115.86242000"
                    },
                    {
                        "id": 4458,
                        "name": "Bullsbrook",
                        "latitude": "-31.66905000",
                        "longitude": "115.99990000"
                    },
                    {
                        "id": 4460,
                        "name": "Bunbury",
                        "latitude": "-33.32711000",
                        "longitude": "115.64137000"
                    },
                    {
                        "id": 4485,
                        "name": "Burns Beach",
                        "latitude": "-31.72060000",
                        "longitude": "115.72050000"
                    },
                    {
                        "id": 4498,
                        "name": "Burswood",
                        "latitude": "-31.95872000",
                        "longitude": "115.90396000"
                    },
                    {
                        "id": 4505,
                        "name": "Busselton",
                        "latitude": "-33.68477000",
                        "longitude": "115.37080000"
                    },
                    {
                        "id": 4506,
                        "name": "Busselton city cenre",
                        "latitude": "-33.65078000",
                        "longitude": "115.34932000"
                    },
                    {
                        "id": 4507,
                        "name": "Butler",
                        "latitude": "-31.64298000",
                        "longitude": "115.70431000"
                    },
                    {
                        "id": 4510,
                        "name": "Byford",
                        "latitude": "-32.22099000",
                        "longitude": "116.00900000"
                    },
                    {
                        "id": 4516,
                        "name": "Cable Beach",
                        "latitude": "-17.96098000",
                        "longitude": "122.21269000"
                    },
                    {
                        "id": 4530,
                        "name": "Calista",
                        "latitude": "-32.24100000",
                        "longitude": "115.79763000"
                    },
                    {
                        "id": 4541,
                        "name": "Cambridge",
                        "latitude": "-31.93542000",
                        "longitude": "115.79887000"
                    },
                    {
                        "id": 4549,
                        "name": "Camillo",
                        "latitude": "-32.11292000",
                        "longitude": "116.00205000"
                    },
                    {
                        "id": 4569,
                        "name": "Canning",
                        "latitude": "-32.04923000",
                        "longitude": "115.91943000"
                    },
                    {
                        "id": 4570,
                        "name": "Canning Vale",
                        "latitude": "-32.05799000",
                        "longitude": "115.91814000"
                    },
                    {
                        "id": 4571,
                        "name": "Cannington",
                        "latitude": "-32.01625000",
                        "longitude": "115.93648000"
                    },
                    {
                        "id": 4581,
                        "name": "Capel",
                        "latitude": "-33.52704000",
                        "longitude": "115.61813000"
                    },
                    {
                        "id": 4589,
                        "name": "Cardup",
                        "latitude": "-32.25802000",
                        "longitude": "115.98512000"
                    },
                    {
                        "id": 4591,
                        "name": "Carey Park",
                        "latitude": "-33.34878000",
                        "longitude": "115.64930000"
                    },
                    {
                        "id": 4594,
                        "name": "Carine",
                        "latitude": "-31.85230000",
                        "longitude": "115.78258000"
                    },
                    {
                        "id": 4599,
                        "name": "Carlisle",
                        "latitude": "-31.97945000",
                        "longitude": "115.91808000"
                    },
                    {
                        "id": 4603,
                        "name": "Carnamah",
                        "latitude": "-29.80411000",
                        "longitude": "115.59402000"
                    },
                    {
                        "id": 4604,
                        "name": "Carnarvon",
                        "latitude": "-24.88258000",
                        "longitude": "113.65713000"
                    },
                    {
                        "id": 4610,
                        "name": "Carramar",
                        "latitude": "-31.69023000",
                        "longitude": "115.77159000"
                    },
                    {
                        "id": 4631,
                        "name": "Castletown",
                        "latitude": "-33.83237000",
                        "longitude": "121.91563000"
                    },
                    {
                        "id": 4633,
                        "name": "Casuarina",
                        "latitude": "-32.24143000",
                        "longitude": "115.86980000"
                    },
                    {
                        "id": 149557,
                        "name": "Cataby",
                        "latitude": "-30.72744730",
                        "longitude": "115.43201600"
                    },
                    {
                        "id": 4641,
                        "name": "Caversham",
                        "latitude": "-31.88333000",
                        "longitude": "115.96667000"
                    },
                    {
                        "id": 149552,
                        "name": "Cervantes",
                        "latitude": "-30.50264750",
                        "longitude": "115.05417670"
                    },
                    {
                        "id": 4659,
                        "name": "Champion Lakes",
                        "latitude": "-32.11913000",
                        "longitude": "115.98617000"
                    },
                    {
                        "id": 4663,
                        "name": "Chapman Valley",
                        "latitude": "-28.27249000",
                        "longitude": "115.02794000"
                    },
                    {
                        "id": 4686,
                        "name": "Chidlow",
                        "latitude": "-31.86094000",
                        "longitude": "116.27243000"
                    },
                    {
                        "id": 4700,
                        "name": "Chittering",
                        "latitude": "-31.35829000",
                        "longitude": "116.05131000"
                    },
                    {
                        "id": 4705,
                        "name": "Churchlands",
                        "latitude": "-31.92142000",
                        "longitude": "115.79322000"
                    },
                    {
                        "id": 4709,
                        "name": "City Beach",
                        "latitude": "-31.93440000",
                        "longitude": "115.76174000"
                    },
                    {
                        "id": 4710,
                        "name": "City of Cockburn",
                        "latitude": "-32.10264000",
                        "longitude": "115.84431000"
                    },
                    {
                        "id": 4711,
                        "name": "City of Perth",
                        "latitude": "-31.94978000",
                        "longitude": "115.85383000"
                    },
                    {
                        "id": 4718,
                        "name": "Claremont",
                        "latitude": "-31.98127000",
                        "longitude": "115.77942000"
                    },
                    {
                        "id": 4727,
                        "name": "Clarkson",
                        "latitude": "-31.68282000",
                        "longitude": "115.72470000"
                    },
                    {
                        "id": 4748,
                        "name": "Cloverdale",
                        "latitude": "-31.96281000",
                        "longitude": "115.94428000"
                    },
                    {
                        "id": 4760,
                        "name": "Cockburn Central",
                        "latitude": "-32.12133000",
                        "longitude": "115.84776000"
                    },
                    {
                        "id": 4773,
                        "name": "College Grove",
                        "latitude": "-33.37587000",
                        "longitude": "115.65906000"
                    },
                    {
                        "id": 4774,
                        "name": "Collie",
                        "latitude": "-33.27353000",
                        "longitude": "116.16558000"
                    },
                    {
                        "id": 4783,
                        "name": "Como",
                        "latitude": "-31.99119000",
                        "longitude": "115.86336000"
                    },
                    {
                        "id": 4792,
                        "name": "Connolly",
                        "latitude": "-31.74864000",
                        "longitude": "115.75053000"
                    },
                    {
                        "id": 4795,
                        "name": "Coodanup",
                        "latitude": "-32.55187000",
                        "longitude": "115.75352000"
                    },
                    {
                        "id": 4797,
                        "name": "Coogee",
                        "latitude": "-32.11934000",
                        "longitude": "115.76650000"
                    },
                    {
                        "id": 4807,
                        "name": "Coolbellup",
                        "latitude": "-32.08124000",
                        "longitude": "115.80606000"
                    },
                    {
                        "id": 4808,
                        "name": "Coolbinia",
                        "latitude": "-31.91470000",
                        "longitude": "115.84894000"
                    },
                    {
                        "id": 4809,
                        "name": "Coolgardie",
                        "latitude": "-31.01438000",
                        "longitude": "121.20462000"
                    },
                    {
                        "id": 4811,
                        "name": "Cooloongup",
                        "latitude": "-32.31506000",
                        "longitude": "115.77772000"
                    },
                    {
                        "id": 4825,
                        "name": "Coorow",
                        "latitude": "-29.97865000",
                        "longitude": "115.65613000"
                    },
                    {
                        "id": 4843,
                        "name": "Corrigin",
                        "latitude": "-32.37599000",
                        "longitude": "117.81023000"
                    },
                    {
                        "id": 4848,
                        "name": "Cottesloe",
                        "latitude": "-31.99905000",
                        "longitude": "115.76089000"
                    },
                    {
                        "id": 4851,
                        "name": "Cowaramup",
                        "latitude": "-33.85036000",
                        "longitude": "115.10379000"
                    },
                    {
                        "id": 4859,
                        "name": "Craigie",
                        "latitude": "-31.78727000",
                        "longitude": "115.76989000"
                    },
                    {
                        "id": 4869,
                        "name": "Cranbrook",
                        "latitude": "-34.33414000",
                        "longitude": "117.32898000"
                    },
                    {
                        "id": 4873,
                        "name": "Crawley",
                        "latitude": "-31.98418000",
                        "longitude": "115.81603000"
                    },
                    {
                        "id": 4897,
                        "name": "Cuballing",
                        "latitude": "-32.74026000",
                        "longitude": "117.15497000"
                    },
                    {
                        "id": 4898,
                        "name": "Cue",
                        "latitude": "-27.22633000",
                        "longitude": "118.00496000"
                    },
                    {
                        "id": 4903,
                        "name": "Cunderdin",
                        "latitude": "-31.61259000",
                        "longitude": "117.11803000"
                    },
                    {
                        "id": 4909,
                        "name": "Currambine",
                        "latitude": "-31.73306000",
                        "longitude": "115.74766000"
                    },
                    {
                        "id": 4919,
                        "name": "Daglish",
                        "latitude": "-31.95177000",
                        "longitude": "115.80880000"
                    },
                    {
                        "id": 4923,
                        "name": "Dalkeith",
                        "latitude": "-31.99517000",
                        "longitude": "115.79980000"
                    },
                    {
                        "id": 4926,
                        "name": "Dalwallinu",
                        "latitude": "-30.12998000",
                        "longitude": "116.98401000"
                    },
                    {
                        "id": 4927,
                        "name": "Dalyellup",
                        "latitude": "-33.40844000",
                        "longitude": "115.61506000"
                    },
                    {
                        "id": 4928,
                        "name": "Dampier",
                        "latitude": "-20.66275000",
                        "longitude": "116.71256000"
                    },
                    {
                        "id": 4929,
                        "name": "Dampier Peninsula",
                        "latitude": "-16.93241000",
                        "longitude": "122.86559000"
                    },
                    {
                        "id": 4930,
                        "name": "Dandaragan",
                        "latitude": "-30.54142000",
                        "longitude": "115.46132000"
                    },
                    {
                        "id": 4934,
                        "name": "Darch",
                        "latitude": "-31.81255000",
                        "longitude": "115.84580000"
                    },
                    {
                        "id": 4935,
                        "name": "Dardanup",
                        "latitude": "-33.41611000",
                        "longitude": "115.87410000"
                    },
                    {
                        "id": 4938,
                        "name": "Darling Downs",
                        "latitude": "-32.19442000",
                        "longitude": "115.99187000"
                    },
                    {
                        "id": 4943,
                        "name": "Darlington",
                        "latitude": "-31.91906000",
                        "longitude": "116.08120000"
                    },
                    {
                        "id": 4952,
                        "name": "Dawesville",
                        "latitude": "-32.63229000",
                        "longitude": "115.62904000"
                    },
                    {
                        "id": 4955,
                        "name": "Dayton",
                        "latitude": "-31.85251000",
                        "longitude": "115.97494000"
                    },
                    {
                        "id": 4968,
                        "name": "Denham",
                        "latitude": "-25.92679000",
                        "longitude": "113.53327000"
                    },
                    {
                        "id": 4974,
                        "name": "Denmark",
                        "latitude": "-34.93473000",
                        "longitude": "117.37518000"
                    },
                    {
                        "id": 4977,
                        "name": "Derby",
                        "latitude": "-17.30295000",
                        "longitude": "123.62864000"
                    },
                    {
                        "id": 4978,
                        "name": "Derby-West Kimberley",
                        "latitude": "-17.50447000",
                        "longitude": "125.28014000"
                    },
                    {
                        "id": 4988,
                        "name": "Dianella",
                        "latitude": "-31.88822000",
                        "longitude": "115.87186000"
                    },
                    {
                        "id": 4997,
                        "name": "Djugun",
                        "latitude": "-17.95395000",
                        "longitude": "122.22792000"
                    },
                    {
                        "id": 5004,
                        "name": "Dongara",
                        "latitude": "-29.25818000",
                        "longitude": "114.93276000"
                    },
                    {
                        "id": 5005,
                        "name": "Donnybrook",
                        "latitude": "-33.57130000",
                        "longitude": "115.82446000"
                    },
                    {
                        "id": 5006,
                        "name": "Donnybrook-Balingup",
                        "latitude": "-33.70217000",
                        "longitude": "115.97778000"
                    },
                    {
                        "id": 5017,
                        "name": "Doubleview",
                        "latitude": "-31.89627000",
                        "longitude": "115.78155000"
                    },
                    {
                        "id": 5023,
                        "name": "Dowerin",
                        "latitude": "-31.11328000",
                        "longitude": "117.10566000"
                    },
                    {
                        "id": 5030,
                        "name": "Drummond Cove",
                        "latitude": "-28.67379000",
                        "longitude": "114.61280000"
                    },
                    {
                        "id": 5035,
                        "name": "Dudley Park",
                        "latitude": "-32.55221000",
                        "longitude": "115.73100000"
                    },
                    {
                        "id": 5039,
                        "name": "Dumbleyung Shire",
                        "latitude": "-33.21780000",
                        "longitude": "117.98750000"
                    },
                    {
                        "id": 5040,
                        "name": "Duncraig",
                        "latitude": "-31.83291000",
                        "longitude": "115.77590000"
                    },
                    {
                        "id": 5041,
                        "name": "Dundas",
                        "latitude": "-32.12502000",
                        "longitude": "124.50582000"
                    },
                    {
                        "id": 5047,
                        "name": "Dunsborough",
                        "latitude": "-33.61476000",
                        "longitude": "115.10445000"
                    },
                    {
                        "id": 5069,
                        "name": "East Bunbury",
                        "latitude": "-33.33619000",
                        "longitude": "115.66041000"
                    },
                    {
                        "id": 5070,
                        "name": "East Cannington",
                        "latitude": "-32.00980000",
                        "longitude": "115.95503000"
                    },
                    {
                        "id": 5071,
                        "name": "East Carnarvon",
                        "latitude": "-24.86397000",
                        "longitude": "113.67768000"
                    },
                    {
                        "id": 5074,
                        "name": "East Fremantle",
                        "latitude": "-32.03654000",
                        "longitude": "115.76714000"
                    },
                    {
                        "id": 5091,
                        "name": "East Perth",
                        "latitude": "-31.95872000",
                        "longitude": "115.87109000"
                    },
                    {
                        "id": 5092,
                        "name": "East Pilbara",
                        "latitude": "-21.61331000",
                        "longitude": "123.71368000"
                    },
                    {
                        "id": 5097,
                        "name": "East Victoria Park",
                        "latitude": "-31.98894000",
                        "longitude": "115.90388000"
                    },
                    {
                        "id": 5101,
                        "name": "Eaton",
                        "latitude": "-33.31664000",
                        "longitude": "115.70503000"
                    },
                    {
                        "id": 5106,
                        "name": "Eden Hill",
                        "latitude": "-31.88908000",
                        "longitude": "115.94675000"
                    },
                    {
                        "id": 5113,
                        "name": "Edgewater",
                        "latitude": "-31.76547000",
                        "longitude": "115.78223000"
                    },
                    {
                        "id": 5120,
                        "name": "Eglinton",
                        "latitude": "-31.58677000",
                        "longitude": "115.68878000"
                    },
                    {
                        "id": 5141,
                        "name": "Ellenbrook",
                        "latitude": "-31.76737000",
                        "longitude": "115.96936000"
                    },
                    {
                        "id": 5149,
                        "name": "Embleton",
                        "latitude": "-31.90355000",
                        "longitude": "115.90902000"
                    },
                    {
                        "id": 5170,
                        "name": "Erskine",
                        "latitude": "-32.55717000",
                        "longitude": "115.70657000"
                    },
                    {
                        "id": 5175,
                        "name": "Esperance",
                        "latitude": "-33.85919000",
                        "longitude": "121.89164000"
                    },
                    {
                        "id": 5176,
                        "name": "Esperance Shire",
                        "latitude": "-33.51970000",
                        "longitude": "122.15586000"
                    },
                    {
                        "id": 5202,
                        "name": "Exmouth",
                        "latitude": "-22.03643000",
                        "longitude": "114.04358000"
                    },
                    {
                        "id": 5214,
                        "name": "Falcon",
                        "latitude": "-32.58244000",
                        "longitude": "115.66199000"
                    },
                    {
                        "id": 5226,
                        "name": "Ferndale",
                        "latitude": "-32.03494000",
                        "longitude": "115.92233000"
                    },
                    {
                        "id": 5242,
                        "name": "Fitzroy Crossing",
                        "latitude": "-18.19714000",
                        "longitude": "125.56663000"
                    },
                    {
                        "id": 5256,
                        "name": "Floreat",
                        "latitude": "-31.93862000",
                        "longitude": "115.79211000"
                    },
                    {
                        "id": 5271,
                        "name": "Forrestdale",
                        "latitude": "-32.15520000",
                        "longitude": "115.93417000"
                    },
                    {
                        "id": 5273,
                        "name": "Forrestfield",
                        "latitude": "-31.98277000",
                        "longitude": "116.00673000"
                    },
                    {
                        "id": 5289,
                        "name": "Fremantle",
                        "latitude": "-32.05165000",
                        "longitude": "115.76379000"
                    },
                    {
                        "id": 5303,
                        "name": "Garden Island",
                        "latitude": "-32.24264000",
                        "longitude": "115.69505000"
                    },
                    {
                        "id": 5321,
                        "name": "Gelorup",
                        "latitude": "-33.42425000",
                        "longitude": "115.64094000"
                    },
                    {
                        "id": 5323,
                        "name": "Geographe",
                        "latitude": "-33.63974000",
                        "longitude": "115.38358000"
                    },
                    {
                        "id": 5327,
                        "name": "Geraldton",
                        "latitude": "-28.77897000",
                        "longitude": "114.61459000"
                    },
                    {
                        "id": 5328,
                        "name": "Geraldton city centre",
                        "latitude": "-28.77754000",
                        "longitude": "114.61494000"
                    },
                    {
                        "id": 5330,
                        "name": "Gidgegannup",
                        "latitude": "-31.75441000",
                        "longitude": "116.18746000"
                    },
                    {
                        "id": 5339,
                        "name": "Gingin",
                        "latitude": "-31.18435000",
                        "longitude": "115.65944000"
                    },
                    {
                        "id": 5344,
                        "name": "Girrawheen",
                        "latitude": "-31.84103000",
                        "longitude": "115.83978000"
                    },
                    {
                        "id": 5357,
                        "name": "Glen Forrest",
                        "latitude": "-31.91929000",
                        "longitude": "116.10726000"
                    },
                    {
                        "id": 5361,
                        "name": "Glen Iris",
                        "latitude": "-33.33713000",
                        "longitude": "115.67430000"
                    },
                    {
                        "id": 5368,
                        "name": "Glendalough",
                        "latitude": "-31.91991000",
                        "longitude": "115.81945000"
                    },
                    {
                        "id": 5397,
                        "name": "Gnangara",
                        "latitude": "-31.77612000",
                        "longitude": "115.86623000"
                    },
                    {
                        "id": 5398,
                        "name": "Gnowangerup",
                        "latitude": "-34.08658000",
                        "longitude": "118.29832000"
                    },
                    {
                        "id": 5401,
                        "name": "Golden Bay",
                        "latitude": "-32.42505000",
                        "longitude": "115.76099000"
                    },
                    {
                        "id": 5414,
                        "name": "Goomalling",
                        "latitude": "-31.23457000",
                        "longitude": "116.79142000"
                    },
                    {
                        "id": 5417,
                        "name": "Gooseberry Hill",
                        "latitude": "-31.95444000",
                        "longitude": "116.04920000"
                    },
                    {
                        "id": 5425,
                        "name": "Gosnells",
                        "latitude": "-32.06763000",
                        "longitude": "116.00203000"
                    },
                    {
                        "id": 5441,
                        "name": "Grasmere",
                        "latitude": "-35.01806000",
                        "longitude": "117.75556000"
                    },
                    {
                        "id": 149556,
                        "name": "Green Head",
                        "latitude": "-30.07749610",
                        "longitude": "114.95851290"
                    },
                    {
                        "id": 5455,
                        "name": "Greenfields",
                        "latitude": "-32.52429000",
                        "longitude": "115.76315000"
                    },
                    {
                        "id": 5456,
                        "name": "Greenmount",
                        "latitude": "-31.90072000",
                        "longitude": "116.04950000"
                    },
                    {
                        "id": 5465,
                        "name": "Greenwood",
                        "latitude": "-31.82723000",
                        "longitude": "115.80247000"
                    },
                    {
                        "id": 5475,
                        "name": "Guildford",
                        "latitude": "-31.90000000",
                        "longitude": "115.96667000"
                    },
                    {
                        "id": 5490,
                        "name": "Gwelup",
                        "latitude": "-31.87163000",
                        "longitude": "115.79484000"
                    },
                    {
                        "id": 5508,
                        "name": "Halls Creek",
                        "latitude": "-19.00069000",
                        "longitude": "127.45204000"
                    },
                    {
                        "id": 5509,
                        "name": "Halls Head",
                        "latitude": "-32.54315000",
                        "longitude": "115.69665000"
                    },
                    {
                        "id": 5510,
                        "name": "Hamersley",
                        "latitude": "-31.84898000",
                        "longitude": "115.80757000"
                    },
                    {
                        "id": 5514,
                        "name": "Hamilton Hill",
                        "latitude": "-32.08451000",
                        "longitude": "115.77946000"
                    },
                    {
                        "id": 5517,
                        "name": "Hammond Park",
                        "latitude": "-32.16853000",
                        "longitude": "115.85040000"
                    },
                    {
                        "id": 5523,
                        "name": "Hannans",
                        "latitude": "-30.71909000",
                        "longitude": "121.45480000"
                    },
                    {
                        "id": 5530,
                        "name": "Harrisdale",
                        "latitude": "-32.11084000",
                        "longitude": "115.93563000"
                    },
                    {
                        "id": 5533,
                        "name": "Harvey",
                        "latitude": "-33.14976000",
                        "longitude": "115.93376000"
                    },
                    {
                        "id": 5560,
                        "name": "Heathridge",
                        "latitude": "-31.76244000",
                        "longitude": "115.75895000"
                    },
                    {
                        "id": 5570,
                        "name": "Helena Valley",
                        "latitude": "-31.91938000",
                        "longitude": "116.03982000"
                    },
                    {
                        "id": 5578,
                        "name": "Henley Brook",
                        "latitude": "-31.81393000",
                        "longitude": "115.98807000"
                    },
                    {
                        "id": 5585,
                        "name": "Herne Hill",
                        "latitude": "-31.82553000",
                        "longitude": "116.02270000"
                    },
                    {
                        "id": 5593,
                        "name": "High Wycombe",
                        "latitude": "-31.94444000",
                        "longitude": "116.00340000"
                    },
                    {
                        "id": 5597,
                        "name": "Highgate",
                        "latitude": "-31.93971000",
                        "longitude": "115.87015000"
                    },
                    {
                        "id": 5603,
                        "name": "Hilbert",
                        "latitude": "-32.17818000",
                        "longitude": "115.98490000"
                    },
                    {
                        "id": 149559,
                        "name": "Hill River",
                        "latitude": "-30.25744110",
                        "longitude": "115.15365180"
                    },
                    {
                        "id": 5605,
                        "name": "Hillarys",
                        "latitude": "-31.80698000",
                        "longitude": "115.74045000"
                    },
                    {
                        "id": 5610,
                        "name": "Hillman",
                        "latitude": "-32.28327000",
                        "longitude": "115.76364000"
                    },
                    {
                        "id": 5615,
                        "name": "Hilton",
                        "latitude": "-32.06208000",
                        "longitude": "115.78049000"
                    },
                    {
                        "id": 5625,
                        "name": "Hocking",
                        "latitude": "-31.77012000",
                        "longitude": "115.81832000"
                    },
                    {
                        "id": 5671,
                        "name": "Huntingdale",
                        "latitude": "-32.08318000",
                        "longitude": "115.96614000"
                    },
                    {
                        "id": 5683,
                        "name": "Iluka",
                        "latitude": "-31.73554000",
                        "longitude": "115.73058000"
                    },
                    {
                        "id": 5692,
                        "name": "Inglewood",
                        "latitude": "-31.91663000",
                        "longitude": "115.87980000"
                    },
                    {
                        "id": 5693,
                        "name": "Innaloo",
                        "latitude": "-31.89272000",
                        "longitude": "115.79508000"
                    },
                    {
                        "id": 5704,
                        "name": "Irwin",
                        "latitude": "-29.34192000",
                        "longitude": "115.04561000"
                    },
                    {
                        "id": 5721,
                        "name": "Jandakot",
                        "latitude": "-32.10158000",
                        "longitude": "115.87083000"
                    },
                    {
                        "id": 5723,
                        "name": "Jane Brook",
                        "latitude": "-31.86368000",
                        "longitude": "116.05039000"
                    },
                    {
                        "id": 5725,
                        "name": "Jarrahdale",
                        "latitude": "-32.33580000",
                        "longitude": "116.05951000"
                    },
                    {
                        "id": 5729,
                        "name": "Jerramungup",
                        "latitude": "-34.03050000",
                        "longitude": "119.11369000"
                    },
                    {
                        "id": 5735,
                        "name": "Jindalee",
                        "latitude": "-31.64938000",
                        "longitude": "115.69496000"
                    },
                    {
                        "id": 5740,
                        "name": "Jolimont",
                        "latitude": "-31.94564000",
                        "longitude": "115.80947000"
                    },
                    {
                        "id": 5741,
                        "name": "Joondalup",
                        "latitude": "-31.77962000",
                        "longitude": "115.76498000"
                    },
                    {
                        "id": 5742,
                        "name": "Joondanna",
                        "latitude": "-31.90767000",
                        "longitude": "115.84233000"
                    },
                    {
                        "id": 5752,
                        "name": "Jurien Bay",
                        "latitude": "-30.30591000",
                        "longitude": "115.03825000"
                    },
                    {
                        "id": 5755,
                        "name": "Kalamunda",
                        "latitude": "-32.00398000",
                        "longitude": "116.13292000"
                    },
                    {
                        "id": 5757,
                        "name": "Kalbarri",
                        "latitude": "-27.71050000",
                        "longitude": "114.16505000"
                    },
                    {
                        "id": 5759,
                        "name": "Kalgoorlie",
                        "latitude": "-30.74614000",
                        "longitude": "121.47420000"
                    },
                    {
                        "id": 5760,
                        "name": "Kalgoorlie\/Boulder",
                        "latitude": "-30.77632000",
                        "longitude": "124.92347000"
                    },
                    {
                        "id": 5765,
                        "name": "Kallaroo",
                        "latitude": "-31.79098000",
                        "longitude": "115.75298000"
                    },
                    {
                        "id": 5769,
                        "name": "Kambalda East",
                        "latitude": "-31.20550000",
                        "longitude": "121.67011000"
                    },
                    {
                        "id": 5770,
                        "name": "Kambalda West",
                        "latitude": "-31.20169000",
                        "longitude": "121.63060000"
                    },
                    {
                        "id": 5786,
                        "name": "Karawara",
                        "latitude": "-32.00860000",
                        "longitude": "115.88114000"
                    },
                    {
                        "id": 5787,
                        "name": "Kardinya",
                        "latitude": "-32.06561000",
                        "longitude": "115.81483000"
                    },
                    {
                        "id": 5790,
                        "name": "Karnup",
                        "latitude": "-32.41894000",
                        "longitude": "115.79267000"
                    },
                    {
                        "id": 5792,
                        "name": "Karratha",
                        "latitude": "-20.73765000",
                        "longitude": "116.84629000"
                    },
                    {
                        "id": 5793,
                        "name": "Karrinyup",
                        "latitude": "-31.87233000",
                        "longitude": "115.77684000"
                    },
                    {
                        "id": 5796,
                        "name": "Katanning",
                        "latitude": "-33.62476000",
                        "longitude": "117.63965000"
                    },
                    {
                        "id": 5814,
                        "name": "Kellerberrin",
                        "latitude": "-31.57709000",
                        "longitude": "117.80561000"
                    },
                    {
                        "id": 5817,
                        "name": "Kelmscott",
                        "latitude": "-32.12434000",
                        "longitude": "116.02590000"
                    },
                    {
                        "id": 5832,
                        "name": "Kent Shire",
                        "latitude": "-33.53881000",
                        "longitude": "118.66993000"
                    },
                    {
                        "id": 5836,
                        "name": "Kenwick",
                        "latitude": "-32.03333000",
                        "longitude": "115.96667000"
                    },
                    {
                        "id": 5845,
                        "name": "Kewdale",
                        "latitude": "-31.97886000",
                        "longitude": "115.95159000"
                    },
                    {
                        "id": 5850,
                        "name": "Kiara",
                        "latitude": "-31.88156000",
                        "longitude": "115.93893000"
                    },
                    {
                        "id": 5880,
                        "name": "Kingsley",
                        "latitude": "-31.81036000",
                        "longitude": "115.80077000"
                    },
                    {
                        "id": 5891,
                        "name": "Kinross",
                        "latitude": "-31.71868000",
                        "longitude": "115.73839000"
                    },
                    {
                        "id": 5903,
                        "name": "Kojonup",
                        "latitude": "-33.92546000",
                        "longitude": "117.03982000"
                    },
                    {
                        "id": 5904,
                        "name": "Kondinin",
                        "latitude": "-32.48431000",
                        "longitude": "119.02420000"
                    },
                    {
                        "id": 5907,
                        "name": "Koondoola",
                        "latitude": "-31.84145000",
                        "longitude": "115.86654000"
                    },
                    {
                        "id": 5910,
                        "name": "Koorda",
                        "latitude": "-30.60412000",
                        "longitude": "117.40736000"
                    },
                    {
                        "id": 5921,
                        "name": "Kulin",
                        "latitude": "-32.66096000",
                        "longitude": "118.57544000"
                    },
                    {
                        "id": 5923,
                        "name": "Kununurra",
                        "latitude": "-15.77825000",
                        "longitude": "128.74208000"
                    },
                    {
                        "id": 5933,
                        "name": "Kwinana",
                        "latitude": "-32.23391000",
                        "longitude": "115.82785000"
                    },
                    {
                        "id": 5945,
                        "name": "Lake Grace",
                        "latitude": "-33.12910000",
                        "longitude": "119.42041000"
                    },
                    {
                        "id": 5953,
                        "name": "Lakelands",
                        "latitude": "-32.47157000",
                        "longitude": "115.77291000"
                    },
                    {
                        "id": 5961,
                        "name": "Lamington",
                        "latitude": "-30.73425000",
                        "longitude": "121.46163000"
                    },
                    {
                        "id": 149555,
                        "name": "Lancelin",
                        "latitude": "-31.02231270",
                        "longitude": "115.32398090"
                    },
                    {
                        "id": 5965,
                        "name": "Landsdale",
                        "latitude": "-31.80750000",
                        "longitude": "115.86599000"
                    },
                    {
                        "id": 5970,
                        "name": "Langford",
                        "latitude": "-32.04092000",
                        "longitude": "115.94157000"
                    },
                    {
                        "id": 5981,
                        "name": "Lathlain",
                        "latitude": "-31.96755000",
                        "longitude": "115.90631000"
                    },
                    {
                        "id": 5989,
                        "name": "Laverton",
                        "latitude": "-27.93793000",
                        "longitude": "125.27127000"
                    },
                    {
                        "id": 5996,
                        "name": "Leda",
                        "latitude": "-32.26766000",
                        "longitude": "115.79930000"
                    },
                    {
                        "id": 5997,
                        "name": "Leederville",
                        "latitude": "-31.93628000",
                        "longitude": "115.84190000"
                    },
                    {
                        "id": 149554,
                        "name": "Leeman",
                        "latitude": "-29.98735790",
                        "longitude": "114.95789040"
                    },
                    {
                        "id": 5998,
                        "name": "Leeming",
                        "latitude": "-32.07511000",
                        "longitude": "115.86613000"
                    },
                    {
                        "id": 6003,
                        "name": "Leinster",
                        "latitude": "-27.92028000",
                        "longitude": "120.69670000"
                    },
                    {
                        "id": 6009,
                        "name": "Leonora",
                        "latitude": "-28.39424000",
                        "longitude": "121.25960000"
                    },
                    {
                        "id": 6012,
                        "name": "Leschenault",
                        "latitude": "-33.24519000",
                        "longitude": "115.72510000"
                    },
                    {
                        "id": 6013,
                        "name": "Lesmurdie",
                        "latitude": "-32.00199000",
                        "longitude": "116.04821000"
                    },
                    {
                        "id": 6036,
                        "name": "Little Grove",
                        "latitude": "-35.06803000",
                        "longitude": "117.87197000"
                    },
                    {
                        "id": 6048,
                        "name": "Lockridge",
                        "latitude": "-31.88168000",
                        "longitude": "115.95031000"
                    },
                    {
                        "id": 6049,
                        "name": "Lockyer",
                        "latitude": "-35.00567000",
                        "longitude": "117.85875000"
                    },
                    {
                        "id": 6074,
                        "name": "Lower Chittering",
                        "latitude": "-31.58333000",
                        "longitude": "116.11667000"
                    },
                    {
                        "id": 6076,
                        "name": "Lower King",
                        "latitude": "-34.95778000",
                        "longitude": "117.93833000"
                    },
                    {
                        "id": 6092,
                        "name": "Lynwood",
                        "latitude": "-32.04013000",
                        "longitude": "115.92888000"
                    },
                    {
                        "id": 6118,
                        "name": "Maddington",
                        "latitude": "-32.05000000",
                        "longitude": "115.98333000"
                    },
                    {
                        "id": 6119,
                        "name": "Madeley",
                        "latitude": "-31.81110000",
                        "longitude": "115.82814000"
                    },
                    {
                        "id": 6120,
                        "name": "Madora Bay",
                        "latitude": "-32.46951000",
                        "longitude": "115.75264000"
                    },
                    {
                        "id": 6124,
                        "name": "Maida Vale",
                        "latitude": "-31.95187000",
                        "longitude": "116.02764000"
                    },
                    {
                        "id": 149549,
                        "name": "Malaga",
                        "latitude": "-31.85814290",
                        "longitude": "115.87986450"
                    },
                    {
                        "id": 6143,
                        "name": "Mandurah",
                        "latitude": "-32.52690000",
                        "longitude": "115.72170000"
                    },
                    {
                        "id": 6144,
                        "name": "Mandurah city centre",
                        "latitude": "-32.52644000",
                        "longitude": "115.73361000"
                    },
                    {
                        "id": 6150,
                        "name": "Manjimup",
                        "latitude": "-34.59789000",
                        "longitude": "116.26566000"
                    },
                    {
                        "id": 6155,
                        "name": "Manning",
                        "latitude": "-32.01594000",
                        "longitude": "115.86714000"
                    },
                    {
                        "id": 6167,
                        "name": "Marangaroo",
                        "latitude": "-31.82711000",
                        "longitude": "115.83843000"
                    },
                    {
                        "id": 6171,
                        "name": "Marble Bar",
                        "latitude": "-21.17067000",
                        "longitude": "119.74441000"
                    },
                    {
                        "id": 6176,
                        "name": "Margaret River",
                        "latitude": "-33.95504000",
                        "longitude": "115.07599000"
                    },
                    {
                        "id": 6185,
                        "name": "Marmion",
                        "latitude": "-31.84158000",
                        "longitude": "115.75692000"
                    },
                    {
                        "id": 6195,
                        "name": "Martin",
                        "latitude": "-32.07549000",
                        "longitude": "116.04536000"
                    },
                    {
                        "id": 6211,
                        "name": "Maylands",
                        "latitude": "-31.93097000",
                        "longitude": "115.89486000"
                    },
                    {
                        "id": 6217,
                        "name": "McKail",
                        "latitude": "-34.98533000",
                        "longitude": "117.83010000"
                    },
                    {
                        "id": 6225,
                        "name": "Meadow Springs",
                        "latitude": "-32.49718000",
                        "longitude": "115.75334000"
                    },
                    {
                        "id": 6230,
                        "name": "Medina",
                        "latitude": "-32.23406000",
                        "longitude": "115.79901000"
                    },
                    {
                        "id": 6233,
                        "name": "Meekatharra",
                        "latitude": "-25.30330000",
                        "longitude": "118.99974000"
                    },
                    {
                        "id": 6242,
                        "name": "Melville",
                        "latitude": "-32.04325000",
                        "longitude": "115.83408000"
                    },
                    {
                        "id": 6246,
                        "name": "Menora",
                        "latitude": "-31.91889000",
                        "longitude": "115.86208000"
                    },
                    {
                        "id": 6248,
                        "name": "Menzies",
                        "latitude": "-29.39176000",
                        "longitude": "123.71878000"
                    },
                    {
                        "id": 6259,
                        "name": "Merredin",
                        "latitude": "-31.46054000",
                        "longitude": "118.38509000"
                    },
                    {
                        "id": 6262,
                        "name": "Merriwa",
                        "latitude": "-31.66494000",
                        "longitude": "115.71273000"
                    },
                    {
                        "id": 6276,
                        "name": "Middle Swan",
                        "latitude": "-31.85000000",
                        "longitude": "116.01667000"
                    },
                    {
                        "id": 6280,
                        "name": "Midland",
                        "latitude": "-31.88909000",
                        "longitude": "116.01070000"
                    },
                    {
                        "id": 6281,
                        "name": "Midvale",
                        "latitude": "-31.88881000",
                        "longitude": "116.03288000"
                    },
                    {
                        "id": 6289,
                        "name": "Millars Well",
                        "latitude": "-20.74168000",
                        "longitude": "116.81731000"
                    },
                    {
                        "id": 6291,
                        "name": "Millbridge",
                        "latitude": "-33.30617000",
                        "longitude": "115.73500000"
                    },
                    {
                        "id": 6306,
                        "name": "Mindarie",
                        "latitude": "-31.68932000",
                        "longitude": "115.70698000"
                    },
                    {
                        "id": 6309,
                        "name": "Mingenew",
                        "latitude": "-29.14515000",
                        "longitude": "115.50123000"
                    },
                    {
                        "id": 6313,
                        "name": "Mira Mar",
                        "latitude": "-35.01517000",
                        "longitude": "117.90096000"
                    },
                    {
                        "id": 6317,
                        "name": "Mirrabooka",
                        "latitude": "-31.85963000",
                        "longitude": "115.86587000"
                    },
                    {
                        "id": 6365,
                        "name": "Moora",
                        "latitude": "-30.51218000",
                        "longitude": "116.20980000"
                    },
                    {
                        "id": 6377,
                        "name": "Morawa",
                        "latitude": "-29.03545000",
                        "longitude": "116.05643000"
                    },
                    {
                        "id": 6385,
                        "name": "Morley",
                        "latitude": "-31.88775000",
                        "longitude": "115.90990000"
                    },
                    {
                        "id": 6400,
                        "name": "Mosman Park",
                        "latitude": "-32.01421000",
                        "longitude": "115.76613000"
                    },
                    {
                        "id": 6407,
                        "name": "Mount Barker",
                        "latitude": "-34.63084000",
                        "longitude": "117.66606000"
                    },
                    {
                        "id": 6410,
                        "name": "Mount Claremont",
                        "latitude": "-31.96177000",
                        "longitude": "115.78337000"
                    },
                    {
                        "id": 6425,
                        "name": "Mount Hawthorn",
                        "latitude": "-31.92000000",
                        "longitude": "115.83509000"
                    },
                    {
                        "id": 6427,
                        "name": "Mount Helena",
                        "latitude": "-31.87606000",
                        "longitude": "116.21025000"
                    },
                    {
                        "id": 6433,
                        "name": "Mount Lawley",
                        "latitude": "-31.93439000",
                        "longitude": "115.87160000"
                    },
                    {
                        "id": 6439,
                        "name": "Mount Magnet",
                        "latitude": "-28.29082000",
                        "longitude": "117.96655000"
                    },
                    {
                        "id": 6440,
                        "name": "Mount Marshall",
                        "latitude": "-30.29376000",
                        "longitude": "118.00063000"
                    },
                    {
                        "id": 6442,
                        "name": "Mount Melville",
                        "latitude": "-35.02216000",
                        "longitude": "117.87137000"
                    },
                    {
                        "id": 6444,
                        "name": "Mount Nasura",
                        "latitude": "-32.13780000",
                        "longitude": "116.02473000"
                    },
                    {
                        "id": 6450,
                        "name": "Mount Pleasant",
                        "latitude": "-32.03974000",
                        "longitude": "115.84993000"
                    },
                    {
                        "id": 6455,
                        "name": "Mount Richon",
                        "latitude": "-32.17349000",
                        "longitude": "116.02137000"
                    },
                    {
                        "id": 6460,
                        "name": "Mount Tarcoola",
                        "latitude": "-28.79859000",
                        "longitude": "114.62530000"
                    },
                    {
                        "id": 149551,
                        "name": "Muchea",
                        "latitude": "-31.54936380",
                        "longitude": "115.87036200"
                    },
                    {
                        "id": 6473,
                        "name": "Mukinbudin",
                        "latitude": "-30.63684000",
                        "longitude": "118.28648000"
                    },
                    {
                        "id": 6477,
                        "name": "Mullaloo",
                        "latitude": "-31.77896000",
                        "longitude": "115.73676000"
                    },
                    {
                        "id": 6480,
                        "name": "Mundaring",
                        "latitude": "-31.88456000",
                        "longitude": "116.21551000"
                    },
                    {
                        "id": 6481,
                        "name": "Mundijong",
                        "latitude": "-32.29217000",
                        "longitude": "115.98564000"
                    },
                    {
                        "id": 6488,
                        "name": "Munster",
                        "latitude": "-32.13647000",
                        "longitude": "115.78302000"
                    },
                    {
                        "id": 6490,
                        "name": "Murchison",
                        "latitude": "-27.00893000",
                        "longitude": "116.41205000"
                    },
                    {
                        "id": 6491,
                        "name": "Murdoch",
                        "latitude": "-32.06987000",
                        "longitude": "115.83757000"
                    },
                    {
                        "id": 6493,
                        "name": "Murray",
                        "latitude": "-32.62391000",
                        "longitude": "115.96538000"
                    },
                    {
                        "id": 6504,
                        "name": "Myaree",
                        "latitude": "-32.04000000",
                        "longitude": "115.81761000"
                    },
                    {
                        "id": 6519,
                        "name": "Nannup",
                        "latitude": "-34.13466000",
                        "longitude": "115.67375000"
                    },
                    {
                        "id": 6528,
                        "name": "Narembeen",
                        "latitude": "-32.02206000",
                        "longitude": "118.68990000"
                    },
                    {
                        "id": 6540,
                        "name": "Narrogin",
                        "latitude": "-32.93282000",
                        "longitude": "117.17763000"
                    },
                    {
                        "id": 6546,
                        "name": "Nedlands",
                        "latitude": "-31.97994000",
                        "longitude": "115.79942000"
                    },
                    {
                        "id": 6569,
                        "name": "Newman",
                        "latitude": "-23.35644000",
                        "longitude": "119.73553000"
                    },
                    {
                        "id": 6581,
                        "name": "Ngaanyatjarraku",
                        "latitude": "-25.08871000",
                        "longitude": "126.83494000"
                    },
                    {
                        "id": 6590,
                        "name": "Nickol",
                        "latitude": "-20.74558000",
                        "longitude": "116.79540000"
                    },
                    {
                        "id": 6600,
                        "name": "Nollamara",
                        "latitude": "-31.88016000",
                        "longitude": "115.84543000"
                    },
                    {
                        "id": 6604,
                        "name": "Noranda",
                        "latitude": "-31.87333000",
                        "longitude": "115.89901000"
                    },
                    {
                        "id": 6616,
                        "name": "North Beach",
                        "latitude": "-31.86298000",
                        "longitude": "115.75624000"
                    },
                    {
                        "id": 6624,
                        "name": "North Coogee",
                        "latitude": "-32.09505000",
                        "longitude": "115.75972000"
                    },
                    {
                        "id": 6627,
                        "name": "North Fremantle",
                        "latitude": "-32.03333000",
                        "longitude": "115.75000000"
                    },
                    {
                        "id": 6634,
                        "name": "North Lake",
                        "latitude": "-32.08190000",
                        "longitude": "115.83567000"
                    },
                    {
                        "id": 6644,
                        "name": "North Perth",
                        "latitude": "-31.92724000",
                        "longitude": "115.85276000"
                    },
                    {
                        "id": 6661,
                        "name": "Northam",
                        "latitude": "-31.69898000",
                        "longitude": "116.64964000"
                    },
                    {
                        "id": 6662,
                        "name": "Northampton Shire",
                        "latitude": "-28.04956000",
                        "longitude": "114.49589000"
                    },
                    {
                        "id": 6664,
                        "name": "Northbridge",
                        "latitude": "-31.94784000",
                        "longitude": "115.85881000"
                    },
                    {
                        "id": 6682,
                        "name": "Nullagine",
                        "latitude": "-21.88972000",
                        "longitude": "120.11140000"
                    },
                    {
                        "id": 6683,
                        "name": "Nulsen",
                        "latitude": "-33.85696000",
                        "longitude": "121.87499000"
                    },
                    {
                        "id": 6687,
                        "name": "Nungarin",
                        "latitude": "-31.13714000",
                        "longitude": "118.21768000"
                    },
                    {
                        "id": 6699,
                        "name": "Oakford",
                        "latitude": "-32.20094000",
                        "longitude": "115.93391000"
                    },
                    {
                        "id": 6711,
                        "name": "Ocean Reef",
                        "latitude": "-31.75871000",
                        "longitude": "115.73601000"
                    },
                    {
                        "id": 6726,
                        "name": "Onslow",
                        "latitude": "-21.63764000",
                        "longitude": "115.11221000"
                    },
                    {
                        "id": 6730,
                        "name": "Orana",
                        "latitude": "-34.99601000",
                        "longitude": "117.85925000"
                    },
                    {
                        "id": 6736,
                        "name": "Orelia",
                        "latitude": "-32.23330000",
                        "longitude": "115.82227000"
                    },
                    {
                        "id": 6743,
                        "name": "Osborne Park",
                        "latitude": "-31.90066000",
                        "longitude": "115.81083000"
                    },
                    {
                        "id": 6756,
                        "name": "Padbury",
                        "latitude": "-31.80645000",
                        "longitude": "115.76880000"
                    },
                    {
                        "id": 6772,
                        "name": "Palmyra",
                        "latitude": "-32.04502000",
                        "longitude": "115.78589000"
                    },
                    {
                        "id": 6779,
                        "name": "Paraburdoo",
                        "latitude": "-23.20417000",
                        "longitude": "117.66973000"
                    },
                    {
                        "id": 6793,
                        "name": "Parkerville",
                        "latitude": "-31.87472000",
                        "longitude": "116.13800000"
                    },
                    {
                        "id": 6802,
                        "name": "Parkwood",
                        "latitude": "-32.04913000",
                        "longitude": "115.91838000"
                    },
                    {
                        "id": 6803,
                        "name": "Parmelia",
                        "latitude": "-32.25784000",
                        "longitude": "115.82208000"
                    },
                    {
                        "id": 6819,
                        "name": "Pearce",
                        "latitude": "-31.66667000",
                        "longitude": "116.01667000"
                    },
                    {
                        "id": 6822,
                        "name": "Pearsall",
                        "latitude": "-31.78117000",
                        "longitude": "115.81823000"
                    },
                    {
                        "id": 6823,
                        "name": "Pegs Creek",
                        "latitude": "-20.73830000",
                        "longitude": "116.83278000"
                    },
                    {
                        "id": 6825,
                        "name": "Pemberton",
                        "latitude": "-34.44311000",
                        "longitude": "116.03689000"
                    },
                    {
                        "id": 6835,
                        "name": "Peppermint Grove",
                        "latitude": "-31.99885000",
                        "longitude": "115.76697000"
                    },
                    {
                        "id": 6838,
                        "name": "Perenjori",
                        "latitude": "-29.39784000",
                        "longitude": "116.53543000"
                    },
                    {
                        "id": 6840,
                        "name": "Perth",
                        "latitude": "-31.95224000",
                        "longitude": "115.86140000"
                    },
                    {
                        "id": 6841,
                        "name": "Perth city centre",
                        "latitude": "-31.95289000",
                        "longitude": "115.85152000"
                    },
                    {
                        "id": 6851,
                        "name": "Piara Waters",
                        "latitude": "-32.13344000",
                        "longitude": "115.91634000"
                    },
                    {
                        "id": 6852,
                        "name": "Piccadilly",
                        "latitude": "-30.74280000",
                        "longitude": "121.46418000"
                    },
                    {
                        "id": 6859,
                        "name": "Pingelly",
                        "latitude": "-32.53174000",
                        "longitude": "117.20004000"
                    },
                    {
                        "id": 6860,
                        "name": "Pinjarra",
                        "latitude": "-32.62980000",
                        "longitude": "115.87351000"
                    },
                    {
                        "id": 6865,
                        "name": "Plantagenet Shire",
                        "latitude": "-34.62508000",
                        "longitude": "117.59753000"
                    },
                    {
                        "id": 6887,
                        "name": "Port Denison",
                        "latitude": "-29.27367000",
                        "longitude": "114.92068000"
                    },
                    {
                        "id": 6892,
                        "name": "Port Hedland",
                        "latitude": "-20.79258000",
                        "longitude": "118.63264000"
                    },
                    {
                        "id": 6894,
                        "name": "Port Kennedy",
                        "latitude": "-32.37342000",
                        "longitude": "115.75150000"
                    },
                    {
                        "id": 6932,
                        "name": "Quairading",
                        "latitude": "-32.01462000",
                        "longitude": "117.39835000"
                    },
                    {
                        "id": 6938,
                        "name": "Queens Park",
                        "latitude": "-32.00314000",
                        "longitude": "115.94621000"
                    },
                    {
                        "id": 6947,
                        "name": "Quindalup",
                        "latitude": "-33.63560000",
                        "longitude": "115.14899000"
                    },
                    {
                        "id": 6948,
                        "name": "Quinns Rocks",
                        "latitude": "-31.67379000",
                        "longitude": "115.70372000"
                    },
                    {
                        "id": 6961,
                        "name": "Rangeway",
                        "latitude": "-28.78665000",
                        "longitude": "114.63059000"
                    },
                    {
                        "id": 6969,
                        "name": "Ravensthorpe",
                        "latitude": "-33.68375000",
                        "longitude": "120.15338000"
                    },
                    {
                        "id": 6971,
                        "name": "Ravenswood",
                        "latitude": "-32.58240000",
                        "longitude": "115.83150000"
                    },
                    {
                        "id": 6981,
                        "name": "Redcliffe",
                        "latitude": "-31.93845000",
                        "longitude": "115.94645000"
                    },
                    {
                        "id": 149558,
                        "name": "Regans Ford",
                        "latitude": "-30.95552880",
                        "longitude": "115.60734050"
                    },
                    {
                        "id": 7013,
                        "name": "Ridgewood",
                        "latitude": "-31.66150000",
                        "longitude": "115.72261000"
                    },
                    {
                        "id": 7026,
                        "name": "Riverton",
                        "latitude": "-32.03468000",
                        "longitude": "115.89856000"
                    },
                    {
                        "id": 7027,
                        "name": "Rivervale",
                        "latitude": "-31.95546000",
                        "longitude": "115.91306000"
                    },
                    {
                        "id": 7044,
                        "name": "Rockingham",
                        "latitude": "-32.28239000",
                        "longitude": "115.73238000"
                    },
                    {
                        "id": 7045,
                        "name": "Rockingham city centre",
                        "latitude": "-32.28407000",
                        "longitude": "115.73540000"
                    },
                    {
                        "id": 7049,
                        "name": "Roebuck",
                        "latitude": "-18.17130000",
                        "longitude": "122.50116000"
                    },
                    {
                        "id": 7051,
                        "name": "Roleystone",
                        "latitude": "-32.11458000",
                        "longitude": "116.07060000"
                    },
                    {
                        "id": 7079,
                        "name": "Rossmoyne",
                        "latitude": "-32.03965000",
                        "longitude": "115.86781000"
                    },
                    {
                        "id": 7106,
                        "name": "Safety Bay",
                        "latitude": "-32.30463000",
                        "longitude": "115.74213000"
                    },
                    {
                        "id": 7128,
                        "name": "Salter Point",
                        "latitude": "-32.02384000",
                        "longitude": "115.86582000"
                    },
                    {
                        "id": 7130,
                        "name": "Samson",
                        "latitude": "-32.06996000",
                        "longitude": "115.79770000"
                    },
                    {
                        "id": 7139,
                        "name": "Sandstone",
                        "latitude": "-28.42189000",
                        "longitude": "118.98846000"
                    },
                    {
                        "id": 7149,
                        "name": "Scarborough",
                        "latitude": "-31.89578000",
                        "longitude": "115.76431000"
                    },
                    {
                        "id": 7172,
                        "name": "Secret Harbour",
                        "latitude": "-32.40589000",
                        "longitude": "115.75852000"
                    },
                    {
                        "id": 7181,
                        "name": "Serpentine",
                        "latitude": "-32.36051000",
                        "longitude": "115.97723000"
                    },
                    {
                        "id": 7182,
                        "name": "Serpentine-Jarrahdale",
                        "latitude": "-32.32452000",
                        "longitude": "116.04507000"
                    },
                    {
                        "id": 7188,
                        "name": "Seville Grove",
                        "latitude": "-32.13645000",
                        "longitude": "115.98905000"
                    },
                    {
                        "id": 7192,
                        "name": "Shark Bay",
                        "latitude": "-26.38916000",
                        "longitude": "114.21845000"
                    },
                    {
                        "id": 7199,
                        "name": "Shelley",
                        "latitude": "-32.02957000",
                        "longitude": "115.88664000"
                    },
                    {
                        "id": 7202,
                        "name": "Shenton Park",
                        "latitude": "-31.95575000",
                        "longitude": "115.79807000"
                    },
                    {
                        "id": 7208,
                        "name": "Shoalwater",
                        "latitude": "-32.29088000",
                        "longitude": "115.71101000"
                    },
                    {
                        "id": 7214,
                        "name": "Silver Sands",
                        "latitude": "-32.50857000",
                        "longitude": "115.73599000"
                    },
                    {
                        "id": 7217,
                        "name": "Sinagra",
                        "latitude": "-31.74261000",
                        "longitude": "115.80633000"
                    },
                    {
                        "id": 7218,
                        "name": "Singleton",
                        "latitude": "-32.44403000",
                        "longitude": "115.75725000"
                    },
                    {
                        "id": 7245,
                        "name": "Somerville",
                        "latitude": "-30.76979000",
                        "longitude": "121.45438000"
                    },
                    {
                        "id": 7248,
                        "name": "Sorrento",
                        "latitude": "-31.82533000",
                        "longitude": "115.75248000"
                    },
                    {
                        "id": 7254,
                        "name": "South Bunbury",
                        "latitude": "-33.34910000",
                        "longitude": "115.63359000"
                    },
                    {
                        "id": 7256,
                        "name": "South Carnarvon",
                        "latitude": "-24.89348000",
                        "longitude": "113.65846000"
                    },
                    {
                        "id": 7258,
                        "name": "South Fremantle",
                        "latitude": "-32.06907000",
                        "longitude": "115.75453000"
                    },
                    {
                        "id": 7263,
                        "name": "South Guildford",
                        "latitude": "-31.91220000",
                        "longitude": "115.96825000"
                    },
                    {
                        "id": 7264,
                        "name": "South Hedland",
                        "latitude": "-20.40655000",
                        "longitude": "118.60069000"
                    },
                    {
                        "id": 7267,
                        "name": "South Kalgoorlie",
                        "latitude": "-30.76507000",
                        "longitude": "121.47334000"
                    },
                    {
                        "id": 7271,
                        "name": "South Lake",
                        "latitude": "-32.11125000",
                        "longitude": "115.83873000"
                    },
                    {
                        "id": 7281,
                        "name": "South Perth",
                        "latitude": "-31.99884000",
                        "longitude": "115.87222000"
                    },
                    {
                        "id": 7291,
                        "name": "South Yunderup",
                        "latitude": "-32.58510000",
                        "longitude": "115.78015000"
                    },
                    {
                        "id": 7297,
                        "name": "Southern River",
                        "latitude": "-32.10658000",
                        "longitude": "115.95896000"
                    },
                    {
                        "id": 7300,
                        "name": "Spalding",
                        "latitude": "-28.73525000",
                        "longitude": "114.63651000"
                    },
                    {
                        "id": 7301,
                        "name": "Spearwood",
                        "latitude": "-32.10534000",
                        "longitude": "115.77797000"
                    },
                    {
                        "id": 7304,
                        "name": "Spencer Park",
                        "latitude": "-35.00515000",
                        "longitude": "117.90005000"
                    },
                    {
                        "id": 7323,
                        "name": "St George Ranges",
                        "latitude": "-18.98204000",
                        "longitude": "125.00873000"
                    },
                    {
                        "id": 7330,
                        "name": "St James",
                        "latitude": "-32.00004000",
                        "longitude": "115.90980000"
                    },
                    {
                        "id": 7347,
                        "name": "Stirling",
                        "latitude": "-31.87940000",
                        "longitude": "115.80929000"
                    },
                    {
                        "id": 7351,
                        "name": "Stoneville",
                        "latitude": "-30.86667000",
                        "longitude": "121.76667000"
                    },
                    {
                        "id": 7356,
                        "name": "Strathalbyn",
                        "latitude": "-28.75168000",
                        "longitude": "114.64576000"
                    },
                    {
                        "id": 7365,
                        "name": "Stratton",
                        "latitude": "-31.86828000",
                        "longitude": "116.04066000"
                    },
                    {
                        "id": 7371,
                        "name": "Subiaco",
                        "latitude": "-31.95964000",
                        "longitude": "115.81564000"
                    },
                    {
                        "id": 7372,
                        "name": "Success",
                        "latitude": "-32.14281000",
                        "longitude": "115.84999000"
                    },
                    {
                        "id": 7383,
                        "name": "Sunset Beach",
                        "latitude": "-28.71907000",
                        "longitude": "114.62297000"
                    },
                    {
                        "id": 7401,
                        "name": "Swan",
                        "latitude": "-31.77039000",
                        "longitude": "116.08746000"
                    },
                    {
                        "id": 7403,
                        "name": "Swan View",
                        "latitude": "-31.88333000",
                        "longitude": "116.05000000"
                    },
                    {
                        "id": 7404,
                        "name": "Swanbourne",
                        "latitude": "-31.96878000",
                        "longitude": "115.76730000"
                    },
                    {
                        "id": 7424,
                        "name": "Tammin",
                        "latitude": "-31.60512000",
                        "longitude": "117.48306000"
                    },
                    {
                        "id": 7433,
                        "name": "Tapping",
                        "latitude": "-31.71947000",
                        "longitude": "115.79559000"
                    },
                    {
                        "id": 7436,
                        "name": "Tarcoola Beach",
                        "latitude": "-28.81001000",
                        "longitude": "114.62236000"
                    },
                    {
                        "id": 7458,
                        "name": "Telfer",
                        "latitude": "-21.21169000",
                        "longitude": "123.26175000"
                    },
                    {
                        "id": 7496,
                        "name": "The Vines",
                        "latitude": "-31.75492000",
                        "longitude": "116.00238000"
                    },
                    {
                        "id": 7507,
                        "name": "Thornlie",
                        "latitude": "-32.06003000",
                        "longitude": "115.95500000"
                    },
                    {
                        "id": 7509,
                        "name": "Three Springs",
                        "latitude": "-29.51386000",
                        "longitude": "115.63158000"
                    },
                    {
                        "id": 7526,
                        "name": "Tom Price",
                        "latitude": "-22.69390000",
                        "longitude": "117.79310000"
                    },
                    {
                        "id": 7530,
                        "name": "Toodyay",
                        "latitude": "-31.46991000",
                        "longitude": "116.38804000"
                    },
                    {
                        "id": 7560,
                        "name": "Trayning",
                        "latitude": "-31.16681000",
                        "longitude": "117.83812000"
                    },
                    {
                        "id": 7564,
                        "name": "Trigg",
                        "latitude": "-31.86939000",
                        "longitude": "115.75710000"
                    },
                    {
                        "id": 7571,
                        "name": "Tuart Hill",
                        "latitude": "-31.89808000",
                        "longitude": "115.83495000"
                    },
                    {
                        "id": 7594,
                        "name": "Two Rocks",
                        "latitude": "-31.49985000",
                        "longitude": "115.58737000"
                    },
                    {
                        "id": 7609,
                        "name": "Upper Gascoyne",
                        "latitude": "-24.71935000",
                        "longitude": "116.33876000"
                    },
                    {
                        "id": 7619,
                        "name": "Usher",
                        "latitude": "-33.37982000",
                        "longitude": "115.62920000"
                    },
                    {
                        "id": 7620,
                        "name": "Utakarra",
                        "latitude": "-28.78333000",
                        "longitude": "114.65000000"
                    },
                    {
                        "id": 7627,
                        "name": "Vasse",
                        "latitude": "-33.69337000",
                        "longitude": "115.26780000"
                    },
                    {
                        "id": 7633,
                        "name": "Victoria Park",
                        "latitude": "-31.97651000",
                        "longitude": "115.90592000"
                    },
                    {
                        "id": 7634,
                        "name": "Victoria Plains",
                        "latitude": "-31.01632000",
                        "longitude": "116.28546000"
                    },
                    {
                        "id": 7638,
                        "name": "Vincent",
                        "latitude": "-31.93138000",
                        "longitude": "115.85412000"
                    },
                    {
                        "id": 7645,
                        "name": "Viveash",
                        "latitude": "-31.87861000",
                        "longitude": "115.99661000"
                    },
                    {
                        "id": 7653,
                        "name": "Waggrakine",
                        "latitude": "-28.71883000",
                        "longitude": "114.63924000"
                    },
                    {
                        "id": 7654,
                        "name": "Wagin",
                        "latitude": "-33.27501000",
                        "longitude": "117.38554000"
                    },
                    {
                        "id": 7658,
                        "name": "Waikiki",
                        "latitude": "-32.31606000",
                        "longitude": "115.75460000"
                    },
                    {
                        "id": 7682,
                        "name": "Wandering",
                        "latitude": "-32.52589000",
                        "longitude": "116.56668000"
                    },
                    {
                        "id": 7683,
                        "name": "Wandi",
                        "latitude": "-32.19430000",
                        "longitude": "115.87630000"
                    },
                    {
                        "id": 7685,
                        "name": "Wandina",
                        "latitude": "-28.81938000",
                        "longitude": "114.63464000"
                    },
                    {
                        "id": 7691,
                        "name": "Wannanup",
                        "latitude": "-32.59946000",
                        "longitude": "115.64488000"
                    },
                    {
                        "id": 7692,
                        "name": "Wanneroo",
                        "latitude": "-31.65293000",
                        "longitude": "115.72211000"
                    },
                    {
                        "id": 7706,
                        "name": "Warnbro",
                        "latitude": "-32.34017000",
                        "longitude": "115.74730000"
                    },
                    {
                        "id": 7709,
                        "name": "Waroona",
                        "latitude": "-32.84916000",
                        "longitude": "115.90429000"
                    },
                    {
                        "id": 7726,
                        "name": "Warwick",
                        "latitude": "-31.83974000",
                        "longitude": "115.80855000"
                    },
                    {
                        "id": 7729,
                        "name": "Waterford",
                        "latitude": "-32.01574000",
                        "longitude": "115.88662000"
                    },
                    {
                        "id": 7732,
                        "name": "Watermans Bay",
                        "latitude": "-31.84915000",
                        "longitude": "115.75590000"
                    },
                    {
                        "id": 7739,
                        "name": "Wattle Grove",
                        "latitude": "-32.00672000",
                        "longitude": "116.00046000"
                    },
                    {
                        "id": 7755,
                        "name": "Wellard",
                        "latitude": "-32.26667000",
                        "longitude": "115.83333000"
                    },
                    {
                        "id": 7760,
                        "name": "Wembley",
                        "latitude": "-31.93308000",
                        "longitude": "115.81783000"
                    },
                    {
                        "id": 7761,
                        "name": "Wembley Downs",
                        "latitude": "-31.91169000",
                        "longitude": "115.77358000"
                    },
                    {
                        "id": 7776,
                        "name": "West Arthur",
                        "latitude": "-33.44057000",
                        "longitude": "116.68597000"
                    },
                    {
                        "id": 7780,
                        "name": "West Beach",
                        "latitude": "-33.87464000",
                        "longitude": "121.89013000"
                    },
                    {
                        "id": 7781,
                        "name": "West Busselton",
                        "latitude": "-33.65792000",
                        "longitude": "115.32293000"
                    },
                    {
                        "id": 7795,
                        "name": "West Lamington",
                        "latitude": "-30.74707000",
                        "longitude": "121.45248000"
                    },
                    {
                        "id": 7797,
                        "name": "West Leederville",
                        "latitude": "-31.94141000",
                        "longitude": "115.83117000"
                    },
                    {
                        "id": 7803,
                        "name": "West Perth",
                        "latitude": "-31.94896000",
                        "longitude": "115.84199000"
                    },
                    {
                        "id": 7826,
                        "name": "Westminster",
                        "latitude": "-31.86744000",
                        "longitude": "115.83919000"
                    },
                    {
                        "id": 7828,
                        "name": "Westonia",
                        "latitude": "-30.88436000",
                        "longitude": "118.72974000"
                    },
                    {
                        "id": 7833,
                        "name": "White Gum Valley",
                        "latitude": "-32.06031000",
                        "longitude": "115.77058000"
                    },
                    {
                        "id": 7848,
                        "name": "Wickepin",
                        "latitude": "-32.82211000",
                        "longitude": "117.63996000"
                    },
                    {
                        "id": 7850,
                        "name": "Wickham",
                        "latitude": "-20.67474000",
                        "longitude": "117.13784000"
                    },
                    {
                        "id": 7853,
                        "name": "Willagee",
                        "latitude": "-32.05196000",
                        "longitude": "115.80533000"
                    },
                    {
                        "id": 7855,
                        "name": "Willetton",
                        "latitude": "-32.05251000",
                        "longitude": "115.88782000"
                    },
                    {
                        "id": 7856,
                        "name": "Williams",
                        "latitude": "-33.05217000",
                        "longitude": "116.70943000"
                    },
                    {
                        "id": 7868,
                        "name": "Wilson",
                        "latitude": "-32.02058000",
                        "longitude": "115.91181000"
                    },
                    {
                        "id": 7873,
                        "name": "Wiluna",
                        "latitude": "-25.36630000",
                        "longitude": "121.93243000"
                    },
                    {
                        "id": 7889,
                        "name": "Winthrop",
                        "latitude": "-32.05216000",
                        "longitude": "115.82972000"
                    },
                    {
                        "id": 7893,
                        "name": "Withers",
                        "latitude": "-33.36807000",
                        "longitude": "115.63050000"
                    },
                    {
                        "id": 7907,
                        "name": "Wongan-Ballidu",
                        "latitude": "-30.73138000",
                        "longitude": "116.84854000"
                    },
                    {
                        "id": 7910,
                        "name": "Wonthella",
                        "latitude": "-28.76689000",
                        "longitude": "114.63338000"
                    },
                    {
                        "id": 7911,
                        "name": "Woodanilling",
                        "latitude": "-33.51937000",
                        "longitude": "117.33580000"
                    },
                    {
                        "id": 7914,
                        "name": "Woodbridge",
                        "latitude": "-31.88695000",
                        "longitude": "115.99196000"
                    },
                    {
                        "id": 149553,
                        "name": "Woodridge",
                        "latitude": "-31.33143680",
                        "longitude": "115.58252470"
                    },
                    {
                        "id": 7927,
                        "name": "Woodvale",
                        "latitude": "-31.78928000",
                        "longitude": "115.79676000"
                    },
                    {
                        "id": 7947,
                        "name": "Wooroloo",
                        "latitude": "-31.80380000",
                        "longitude": "116.31311000"
                    },
                    {
                        "id": 7948,
                        "name": "Woorree",
                        "latitude": "-28.76677000",
                        "longitude": "114.65806000"
                    },
                    {
                        "id": 7961,
                        "name": "Wundowie",
                        "latitude": "-31.76163000",
                        "longitude": "116.37990000"
                    },
                    {
                        "id": 7966,
                        "name": "Wyalkatchem",
                        "latitude": "-31.19528000",
                        "longitude": "117.44682000"
                    },
                    {
                        "id": 7971,
                        "name": "Wyndham-East Kimberley",
                        "latitude": "-15.51291000",
                        "longitude": "126.58779000"
                    },
                    {
                        "id": 7982,
                        "name": "Yakamia",
                        "latitude": "-35.00392000",
                        "longitude": "117.87828000"
                    },
                    {
                        "id": 7983,
                        "name": "Yalgoo",
                        "latitude": "-28.48787000",
                        "longitude": "117.15818000"
                    },
                    {
                        "id": 7985,
                        "name": "Yallingup",
                        "latitude": "-33.64592000",
                        "longitude": "115.03514000"
                    },
                    {
                        "id": 7987,
                        "name": "Yalyalup",
                        "latitude": "-33.67496000",
                        "longitude": "115.41449000"
                    },
                    {
                        "id": 7990,
                        "name": "Yanchep",
                        "latitude": "-31.54678000",
                        "longitude": "115.63171000"
                    },
                    {
                        "id": 7992,
                        "name": "Yangebup",
                        "latitude": "-32.12065000",
                        "longitude": "115.81623000"
                    },
                    {
                        "id": 8022,
                        "name": "Yilgarn",
                        "latitude": "-30.90938000",
                        "longitude": "119.25881000"
                    },
                    {
                        "id": 8023,
                        "name": "Yokine",
                        "latitude": "-31.90113000",
                        "longitude": "115.85319000"
                    },
                    {
                        "id": 8025,
                        "name": "York",
                        "latitude": "-31.88809000",
                        "longitude": "116.76780000"
                    }
                ]
            }
        ]
    },
    {
        "id": 15,
        "name": "Austria",
        "iso3": "AUT",
        "iso2": "AT",
        "numeric_code": "040",
        "phonecode": "43",
        "capital": "Vienna",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".at",
        "native": "Österreich",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Western Europe",
        "subregion_id": 17,
        "nationality": "Austrian",
        "timezones": [
            {
                "zoneName": "Europe\/Vienna",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Aostria",
            "ko": "오스트리아",
            "pt-BR": "áustria",
            "pt": "áustria",
            "nl": "Oostenrijk",
            "hr": "Austrija",
            "fa": "اتریش",
            "de": "Österreich",
            "es": "Austria",
            "fr": "Autriche",
            "ja": "オーストリア",
            "it": "Austria",
            "zh-CN": "奥地利",
            "tr": "Avusturya",
            "ru": "Австрия",
            "uk": "Австрія",
            "pl": "Austria"
        },
        "latitude": "47.33333333",
        "longitude": "13.33333333",
        "emoji": "🇦🇹",
        "emojiU": "U+1F1E6 U+1F1F9",
        "states": [
            {
                "id": 2062,
                "name": "Burgenland",
                "iso2": "1",
                "latitude": "47.15371650",
                "longitude": "16.26887970",
                "type": "state",
                "cities": [
                    {
                        "id": 1657,
                        "name": "Andau",
                        "latitude": "47.77441000",
                        "longitude": "17.03293000"
                    },
                    {
                        "id": 1671,
                        "name": "Antau",
                        "latitude": "47.77377000",
                        "longitude": "16.47984000"
                    },
                    {
                        "id": 1673,
                        "name": "Apetlon",
                        "latitude": "47.74394000",
                        "longitude": "16.83020000"
                    },
                    {
                        "id": 1734,
                        "name": "Bad Sauerbrunn",
                        "latitude": "47.77439000",
                        "longitude": "16.32841000"
                    },
                    {
                        "id": 1737,
                        "name": "Bad Tatzmannsdorf",
                        "latitude": "47.33126000",
                        "longitude": "16.23067000"
                    },
                    {
                        "id": 1743,
                        "name": "Badersdorf",
                        "latitude": "47.20000000",
                        "longitude": "16.36667000"
                    },
                    {
                        "id": 1765,
                        "name": "Bernstein",
                        "latitude": "47.40000000",
                        "longitude": "16.25000000"
                    },
                    {
                        "id": 1787,
                        "name": "Bocksdorf",
                        "latitude": "47.14256000",
                        "longitude": "16.17784000"
                    },
                    {
                        "id": 1798,
                        "name": "Breitenbrunn",
                        "latitude": "47.94452000",
                        "longitude": "16.73149000"
                    },
                    {
                        "id": 1811,
                        "name": "Bruckneudorf",
                        "latitude": "48.01667000",
                        "longitude": "16.78333000"
                    },
                    {
                        "id": 1839,
                        "name": "Deutsch Jahrndorf",
                        "latitude": "48.01667000",
                        "longitude": "17.10000000"
                    },
                    {
                        "id": 1840,
                        "name": "Deutsch Kaltenbrunn",
                        "latitude": "47.09455000",
                        "longitude": "16.13145000"
                    },
                    {
                        "id": 1843,
                        "name": "Deutschkreutz",
                        "latitude": "47.60000000",
                        "longitude": "16.63333000"
                    },
                    {
                        "id": 1859,
                        "name": "Donnerskirchen",
                        "latitude": "47.89425000",
                        "longitude": "16.64635000"
                    },
                    {
                        "id": 1868,
                        "name": "Drassburg",
                        "latitude": "47.74645000",
                        "longitude": "16.48679000"
                    },
                    {
                        "id": 1888,
                        "name": "Eberau",
                        "latitude": "47.10764000",
                        "longitude": "16.46044000"
                    },
                    {
                        "id": 1902,
                        "name": "Edelstal",
                        "latitude": "48.10000000",
                        "longitude": "16.98333000"
                    },
                    {
                        "id": 1924,
                        "name": "Eisenstadt",
                        "latitude": "47.84565000",
                        "longitude": "16.52327000"
                    },
                    {
                        "id": 1925,
                        "name": "Eisenstadt Stadt",
                        "latitude": "47.84450000",
                        "longitude": "16.52575000"
                    },
                    {
                        "id": 1926,
                        "name": "Eisenstadt-Umgebung",
                        "latitude": "47.83333000",
                        "longitude": "16.58333000"
                    },
                    {
                        "id": 1934,
                        "name": "Eltendorf",
                        "latitude": "47.00870000",
                        "longitude": "16.20239000"
                    },
                    {
                        "id": 2005,
                        "name": "Forchtenstein",
                        "latitude": "47.71161000",
                        "longitude": "16.34525000"
                    },
                    {
                        "id": 2014,
                        "name": "Frauenkirchen",
                        "latitude": "47.83678000",
                        "longitude": "16.92581000"
                    },
                    {
                        "id": 2064,
                        "name": "Gattendorf",
                        "latitude": "48.01667000",
                        "longitude": "16.98333000"
                    },
                    {
                        "id": 2104,
                        "name": "Gols",
                        "latitude": "47.89689000",
                        "longitude": "16.91113000"
                    },
                    {
                        "id": 2111,
                        "name": "Grafenschachen",
                        "latitude": "47.36667000",
                        "longitude": "16.06667000"
                    },
                    {
                        "id": 2141,
                        "name": "Grosshöflein",
                        "latitude": "47.83586000",
                        "longitude": "16.48035000"
                    },
                    {
                        "id": 2142,
                        "name": "Grosspetersdorf",
                        "latitude": "47.23895000",
                        "longitude": "16.31783000"
                    },
                    {
                        "id": 2197,
                        "name": "Güssing",
                        "latitude": "47.05936000",
                        "longitude": "16.32431000"
                    },
                    {
                        "id": 2198,
                        "name": "Güttenbach",
                        "latitude": "47.15710000",
                        "longitude": "16.29230000"
                    },
                    {
                        "id": 2203,
                        "name": "Hackerberg",
                        "latitude": "47.20000000",
                        "longitude": "16.11667000"
                    },
                    {
                        "id": 2222,
                        "name": "Halbturn",
                        "latitude": "47.87019000",
                        "longitude": "16.97542000"
                    },
                    {
                        "id": 2228,
                        "name": "Hannersdorf",
                        "latitude": "47.22895000",
                        "longitude": "16.38250000"
                    },
                    {
                        "id": 2259,
                        "name": "Heiligenbrunn",
                        "latitude": "47.02705000",
                        "longitude": "16.41688000"
                    },
                    {
                        "id": 2263,
                        "name": "Heiligenkreuz im Lafnitztal",
                        "latitude": "46.98917000",
                        "longitude": "16.26083000"
                    },
                    {
                        "id": 2278,
                        "name": "Heugraben",
                        "latitude": "47.11783000",
                        "longitude": "16.19041000"
                    },
                    {
                        "id": 2290,
                        "name": "Hirm",
                        "latitude": "47.78652000",
                        "longitude": "16.45460000"
                    },
                    {
                        "id": 2330,
                        "name": "Horitschon",
                        "latitude": "47.58729000",
                        "longitude": "16.54696000"
                    },
                    {
                        "id": 2332,
                        "name": "Hornstein",
                        "latitude": "47.88049000",
                        "longitude": "16.44447000"
                    },
                    {
                        "id": 2351,
                        "name": "Illmitz",
                        "latitude": "47.76148000",
                        "longitude": "16.80024000"
                    },
                    {
                        "id": 2362,
                        "name": "Inzenhof",
                        "latitude": "47.01667000",
                        "longitude": "16.31667000"
                    },
                    {
                        "id": 2370,
                        "name": "Jabing",
                        "latitude": "47.23880000",
                        "longitude": "16.27659000"
                    },
                    {
                        "id": 2377,
                        "name": "Jennersdorf",
                        "latitude": "46.93848000",
                        "longitude": "16.14158000"
                    },
                    {
                        "id": 2381,
                        "name": "Jois",
                        "latitude": "47.96165000",
                        "longitude": "16.79604000"
                    },
                    {
                        "id": 2390,
                        "name": "Kaisersdorf",
                        "latitude": "47.53741000",
                        "longitude": "16.39198000"
                    },
                    {
                        "id": 2418,
                        "name": "Kemeten",
                        "latitude": "47.24859000",
                        "longitude": "16.15213000"
                    },
                    {
                        "id": 2442,
                        "name": "Kittsee",
                        "latitude": "48.09250000",
                        "longitude": "17.06389000"
                    },
                    {
                        "id": 2454,
                        "name": "Kleinhöflein im Burgenland",
                        "latitude": "47.84151000",
                        "longitude": "16.50413000"
                    },
                    {
                        "id": 2456,
                        "name": "Kleinmürbisch",
                        "latitude": "47.03299000",
                        "longitude": "16.32448000"
                    },
                    {
                        "id": 2460,
                        "name": "Klingenbach",
                        "latitude": "47.75202000",
                        "longitude": "16.54069000"
                    },
                    {
                        "id": 2467,
                        "name": "Kobersdorf",
                        "latitude": "47.59572000",
                        "longitude": "16.39173000"
                    },
                    {
                        "id": 2469,
                        "name": "Kohfidisch",
                        "latitude": "47.17472000",
                        "longitude": "16.35701000"
                    },
                    {
                        "id": 2509,
                        "name": "Königsdorf",
                        "latitude": "47.00000000",
                        "longitude": "16.16667000"
                    },
                    {
                        "id": 2487,
                        "name": "Krensdorf",
                        "latitude": "47.78552000",
                        "longitude": "16.41495000"
                    },
                    {
                        "id": 2504,
                        "name": "Kukmirn",
                        "latitude": "47.07544000",
                        "longitude": "16.21033000"
                    },
                    {
                        "id": 2523,
                        "name": "Lackenbach",
                        "latitude": "47.59042000",
                        "longitude": "16.46533000"
                    },
                    {
                        "id": 2524,
                        "name": "Lackendorf",
                        "latitude": "47.58996000",
                        "longitude": "16.50404000"
                    },
                    {
                        "id": 2568,
                        "name": "Leithaprodersdorf",
                        "latitude": "47.93348000",
                        "longitude": "16.47915000"
                    },
                    {
                        "id": 2606,
                        "name": "Litzelsdorf",
                        "latitude": "47.20826000",
                        "longitude": "16.17170000"
                    },
                    {
                        "id": 2608,
                        "name": "Lockenhaus",
                        "latitude": "47.40753000",
                        "longitude": "16.41623000"
                    },
                    {
                        "id": 2611,
                        "name": "Loipersbach im Burgenland",
                        "latitude": "47.69656000",
                        "longitude": "16.47919000"
                    },
                    {
                        "id": 2614,
                        "name": "Loretto",
                        "latitude": "47.91559000",
                        "longitude": "16.51790000"
                    },
                    {
                        "id": 2622,
                        "name": "Lutzmannsburg",
                        "latitude": "47.46373000",
                        "longitude": "16.63665000"
                    },
                    {
                        "id": 2631,
                        "name": "Mannersdorf an der Rabnitz",
                        "latitude": "47.42815000",
                        "longitude": "16.52678000"
                    },
                    {
                        "id": 2654,
                        "name": "Mariasdorf",
                        "latitude": "47.36580000",
                        "longitude": "16.23136000"
                    },
                    {
                        "id": 2661,
                        "name": "Markt Allhau",
                        "latitude": "47.28333000",
                        "longitude": "16.08333000"
                    },
                    {
                        "id": 2662,
                        "name": "Markt Neuhodis",
                        "latitude": "47.29565000",
                        "longitude": "16.39564000"
                    },
                    {
                        "id": 2664,
                        "name": "Markt Sankt Martin",
                        "latitude": "47.56205000",
                        "longitude": "16.42508000"
                    },
                    {
                        "id": 2666,
                        "name": "Marz",
                        "latitude": "47.71667000",
                        "longitude": "16.41667000"
                    },
                    {
                        "id": 2669,
                        "name": "Mattersburg",
                        "latitude": "47.73333000",
                        "longitude": "16.40000000"
                    },
                    {
                        "id": 2705,
                        "name": "Mischendorf",
                        "latitude": "47.19277000",
                        "longitude": "16.31444000"
                    },
                    {
                        "id": 2718,
                        "name": "Mitterpullendorf",
                        "latitude": "47.49325000",
                        "longitude": "16.52129000"
                    },
                    {
                        "id": 2722,
                        "name": "Mogersdorf",
                        "latitude": "46.94917000",
                        "longitude": "16.23222000"
                    },
                    {
                        "id": 2745,
                        "name": "Mönchhof",
                        "latitude": "47.88020000",
                        "longitude": "16.94126000"
                    },
                    {
                        "id": 2748,
                        "name": "Mörbisch am See",
                        "latitude": "47.75000000",
                        "longitude": "16.66667000"
                    },
                    {
                        "id": 2730,
                        "name": "Moschendorf",
                        "latitude": "47.05843000",
                        "longitude": "16.47728000"
                    },
                    {
                        "id": 2759,
                        "name": "Mühlgraben",
                        "latitude": "46.88972000",
                        "longitude": "16.04083000"
                    },
                    {
                        "id": 2760,
                        "name": "Müllendorf",
                        "latitude": "47.83943000",
                        "longitude": "16.46258000"
                    },
                    {
                        "id": 2776,
                        "name": "Neckenmarkt",
                        "latitude": "47.59964000",
                        "longitude": "16.54670000"
                    },
                    {
                        "id": 2787,
                        "name": "Neuberg im Burgenland",
                        "latitude": "47.16894000",
                        "longitude": "16.26054000"
                    },
                    {
                        "id": 2790,
                        "name": "Neudörfl",
                        "latitude": "47.79655000",
                        "longitude": "16.29770000"
                    },
                    {
                        "id": 2792,
                        "name": "Neufeld an der Leitha",
                        "latitude": "47.86558000",
                        "longitude": "16.37856000"
                    },
                    {
                        "id": 2795,
                        "name": "Neuhaus am Klausenbach",
                        "latitude": "46.86667000",
                        "longitude": "16.03333000"
                    },
                    {
                        "id": 2811,
                        "name": "Neusiedl am See",
                        "latitude": "47.94901000",
                        "longitude": "16.84170000"
                    },
                    {
                        "id": 2813,
                        "name": "Neustift an der Lafnitz",
                        "latitude": "47.36667000",
                        "longitude": "16.03333000"
                    },
                    {
                        "id": 2814,
                        "name": "Neustift bei Güssing",
                        "latitude": "47.02474000",
                        "longitude": "16.26041000"
                    },
                    {
                        "id": 2816,
                        "name": "Neutal",
                        "latitude": "47.54548000",
                        "longitude": "16.44619000"
                    },
                    {
                        "id": 2819,
                        "name": "Nickelsdorf",
                        "latitude": "47.94056000",
                        "longitude": "17.06944000"
                    },
                    {
                        "id": 2834,
                        "name": "Nikitsch",
                        "latitude": "47.53615000",
                        "longitude": "16.66017000"
                    },
                    {
                        "id": 2848,
                        "name": "Oberdorf im Burgenland",
                        "latitude": "47.21667000",
                        "longitude": "16.21667000"
                    },
                    {
                        "id": 2859,
                        "name": "Oberloisdorf",
                        "latitude": "47.44736000",
                        "longitude": "16.50764000"
                    },
                    {
                        "id": 2871,
                        "name": "Oberpullendorf",
                        "latitude": "47.50352000",
                        "longitude": "16.50447000"
                    },
                    {
                        "id": 2873,
                        "name": "Oberschützen",
                        "latitude": "47.35138000",
                        "longitude": "16.20732000"
                    },
                    {
                        "id": 2884,
                        "name": "Oberwart",
                        "latitude": "47.28971000",
                        "longitude": "16.20595000"
                    },
                    {
                        "id": 2896,
                        "name": "Oggau",
                        "latitude": "47.83333000",
                        "longitude": "16.66667000"
                    },
                    {
                        "id": 2898,
                        "name": "Olbendorf",
                        "latitude": "47.18333000",
                        "longitude": "16.20000000"
                    },
                    {
                        "id": 2899,
                        "name": "Ollersdorf im Burgenland",
                        "latitude": "47.18333000",
                        "longitude": "16.16667000"
                    },
                    {
                        "id": 2905,
                        "name": "Oslip",
                        "latitude": "47.82906000",
                        "longitude": "16.61957000"
                    },
                    {
                        "id": 2921,
                        "name": "Pama",
                        "latitude": "48.05000000",
                        "longitude": "17.03333000"
                    },
                    {
                        "id": 2922,
                        "name": "Pamhagen",
                        "latitude": "47.70092000",
                        "longitude": "16.90779000"
                    },
                    {
                        "id": 2924,
                        "name": "Parndorf",
                        "latitude": "47.99963000",
                        "longitude": "16.86049000"
                    },
                    {
                        "id": 2968,
                        "name": "Pilgersdorf",
                        "latitude": "47.44106000",
                        "longitude": "16.34920000"
                    },
                    {
                        "id": 2972,
                        "name": "Pinkafeld",
                        "latitude": "47.36667000",
                        "longitude": "16.11667000"
                    },
                    {
                        "id": 2975,
                        "name": "Piringsdorf",
                        "latitude": "47.44826000",
                        "longitude": "16.41516000"
                    },
                    {
                        "id": 2985,
                        "name": "Podersdorf am See",
                        "latitude": "47.85412000",
                        "longitude": "16.83706000"
                    },
                    {
                        "id": 3005,
                        "name": "Politischer Bezirk Güssing",
                        "latitude": "47.10164000",
                        "longitude": "16.30363000"
                    },
                    {
                        "id": 3013,
                        "name": "Politischer Bezirk Jennersdorf",
                        "latitude": "46.96667000",
                        "longitude": "16.15000000"
                    },
                    {
                        "id": 3027,
                        "name": "Politischer Bezirk Mattersburg",
                        "latitude": "47.73823000",
                        "longitude": "16.39486000"
                    },
                    {
                        "id": 3034,
                        "name": "Politischer Bezirk Neusiedl am See",
                        "latitude": "47.88853000",
                        "longitude": "16.92465000"
                    },
                    {
                        "id": 3035,
                        "name": "Politischer Bezirk Oberpullendorf",
                        "latitude": "47.50184000",
                        "longitude": "16.50593000"
                    },
                    {
                        "id": 3036,
                        "name": "Politischer Bezirk Oberwart",
                        "latitude": "47.28854000",
                        "longitude": "16.20861000"
                    },
                    {
                        "id": 3109,
                        "name": "Pöttelsdorf",
                        "latitude": "47.75369000",
                        "longitude": "16.43864000"
                    },
                    {
                        "id": 3111,
                        "name": "Pöttsching",
                        "latitude": "47.80445000",
                        "longitude": "16.37109000"
                    },
                    {
                        "id": 3070,
                        "name": "Potzneusiedl",
                        "latitude": "48.04504000",
                        "longitude": "16.94770000"
                    },
                    {
                        "id": 3098,
                        "name": "Purbach am Neusiedler See",
                        "latitude": "47.91289000",
                        "longitude": "16.69561000"
                    },
                    {
                        "id": 3129,
                        "name": "Raiding",
                        "latitude": "47.56581000",
                        "longitude": "16.53056000"
                    },
                    {
                        "id": 3156,
                        "name": "Rechnitz",
                        "latitude": "47.30467000",
                        "longitude": "16.44095000"
                    },
                    {
                        "id": 3190,
                        "name": "Riedlingsdorf",
                        "latitude": "47.35000000",
                        "longitude": "16.13333000"
                    },
                    {
                        "id": 3197,
                        "name": "Ritzing",
                        "latitude": "47.61316000",
                        "longitude": "16.49546000"
                    },
                    {
                        "id": 3198,
                        "name": "Rohr im Burgenland",
                        "latitude": "47.11667000",
                        "longitude": "16.16667000"
                    },
                    {
                        "id": 3204,
                        "name": "Rohrbach bei Mattersburg",
                        "latitude": "47.70520000",
                        "longitude": "16.43005000"
                    },
                    {
                        "id": 3213,
                        "name": "Rotenturm an der Pinka",
                        "latitude": "47.25000000",
                        "longitude": "16.25000000"
                    },
                    {
                        "id": 3216,
                        "name": "Rudersdorf",
                        "latitude": "47.05000000",
                        "longitude": "16.11667000"
                    },
                    {
                        "id": 3220,
                        "name": "Rust",
                        "latitude": "47.80122000",
                        "longitude": "16.67158000"
                    },
                    {
                        "id": 3221,
                        "name": "Rust Stadt",
                        "latitude": "47.80174000",
                        "longitude": "16.67210000"
                    },
                    {
                        "id": 3240,
                        "name": "Sankt Andrä am Zicksee",
                        "latitude": "47.78410000",
                        "longitude": "16.94195000"
                    },
                    {
                        "id": 3253,
                        "name": "Sankt Georgen am Leithagebirge",
                        "latitude": "47.85000000",
                        "longitude": "16.55000000"
                    },
                    {
                        "id": 3297,
                        "name": "Sankt Margarethen im Burgenland",
                        "latitude": "47.80335000",
                        "longitude": "16.60875000"
                    },
                    {
                        "id": 3305,
                        "name": "Sankt Martin an der Raab",
                        "latitude": "46.92250000",
                        "longitude": "16.13611000"
                    },
                    {
                        "id": 3309,
                        "name": "Sankt Michael im Burgenland",
                        "latitude": "47.12852000",
                        "longitude": "16.27148000"
                    },
                    {
                        "id": 3353,
                        "name": "Schachendorf",
                        "latitude": "47.26667000",
                        "longitude": "16.43333000"
                    },
                    {
                        "id": 3357,
                        "name": "Schandorf",
                        "latitude": "47.24183000",
                        "longitude": "16.42267000"
                    },
                    {
                        "id": 3362,
                        "name": "Schattendorf",
                        "latitude": "47.70973000",
                        "longitude": "16.50979000"
                    },
                    {
                        "id": 3424,
                        "name": "Schützen am Gebirge",
                        "latitude": "47.85233000",
                        "longitude": "16.62334000"
                    },
                    {
                        "id": 3449,
                        "name": "Siegendorf im Burgenland",
                        "latitude": "47.78098000",
                        "longitude": "16.54232000"
                    },
                    {
                        "id": 3451,
                        "name": "Sieggraben",
                        "latitude": "47.65128000",
                        "longitude": "16.37993000"
                    },
                    {
                        "id": 3456,
                        "name": "Sigless",
                        "latitude": "47.77533000",
                        "longitude": "16.39503000"
                    },
                    {
                        "id": 3492,
                        "name": "Stadtschlaining",
                        "latitude": "47.31667000",
                        "longitude": "16.28333000"
                    },
                    {
                        "id": 3509,
                        "name": "Stegersbach",
                        "latitude": "47.16667000",
                        "longitude": "16.16667000"
                    },
                    {
                        "id": 3516,
                        "name": "Steinbrunn",
                        "latitude": "47.83333000",
                        "longitude": "16.41667000"
                    },
                    {
                        "id": 3530,
                        "name": "Stinatz",
                        "latitude": "47.20266000",
                        "longitude": "16.13312000"
                    },
                    {
                        "id": 3535,
                        "name": "Stoob",
                        "latitude": "47.52845000",
                        "longitude": "16.47760000"
                    },
                    {
                        "id": 3536,
                        "name": "Stotzing",
                        "latitude": "47.90688000",
                        "longitude": "16.54580000"
                    },
                    {
                        "id": 3550,
                        "name": "Strem",
                        "latitude": "47.04498000",
                        "longitude": "16.41426000"
                    },
                    {
                        "id": 3568,
                        "name": "Tadten",
                        "latitude": "47.76667000",
                        "longitude": "16.98333000"
                    },
                    {
                        "id": 3605,
                        "name": "Tobaj",
                        "latitude": "47.08333000",
                        "longitude": "16.30000000"
                    },
                    {
                        "id": 3615,
                        "name": "Trausdorf an der Wulka",
                        "latitude": "47.81350000",
                        "longitude": "16.55760000"
                    },
                    {
                        "id": 3630,
                        "name": "Tschanigraben",
                        "latitude": "47.01667000",
                        "longitude": "16.30000000"
                    },
                    {
                        "id": 3652,
                        "name": "Unterfrauenhaid",
                        "latitude": "47.57116000",
                        "longitude": "16.49885000"
                    },
                    {
                        "id": 3654,
                        "name": "Unterkohlstätten",
                        "latitude": "47.38333000",
                        "longitude": "16.31667000"
                    },
                    {
                        "id": 3666,
                        "name": "Unterwart",
                        "latitude": "47.25000000",
                        "longitude": "16.23333000"
                    },
                    {
                        "id": 3737,
                        "name": "Wallern im Burgenland",
                        "latitude": "47.72847000",
                        "longitude": "16.93706000"
                    },
                    {
                        "id": 3756,
                        "name": "Weichselbaum",
                        "latitude": "46.94250000",
                        "longitude": "16.18750000"
                    },
                    {
                        "id": 3757,
                        "name": "Weiden am See",
                        "latitude": "47.92532000",
                        "longitude": "16.86899000"
                    },
                    {
                        "id": 3758,
                        "name": "Weiden bei Rechnitz",
                        "latitude": "47.30000000",
                        "longitude": "16.35000000"
                    },
                    {
                        "id": 3767,
                        "name": "Weingraben",
                        "latitude": "47.51393000",
                        "longitude": "16.36375000"
                    },
                    {
                        "id": 3791,
                        "name": "Weppersdorf",
                        "latitude": "47.57954000",
                        "longitude": "16.42679000"
                    },
                    {
                        "id": 3809,
                        "name": "Wiesen",
                        "latitude": "47.73776000",
                        "longitude": "16.33798000"
                    },
                    {
                        "id": 3810,
                        "name": "Wiesfleck",
                        "latitude": "47.38458000",
                        "longitude": "16.14552000"
                    },
                    {
                        "id": 3823,
                        "name": "Wimpassing an der Leitha",
                        "latitude": "47.91667000",
                        "longitude": "16.43333000"
                    },
                    {
                        "id": 3826,
                        "name": "Winden am See",
                        "latitude": "47.95000000",
                        "longitude": "16.75000000"
                    },
                    {
                        "id": 3838,
                        "name": "Wolfau",
                        "latitude": "47.25000000",
                        "longitude": "16.10000000"
                    },
                    {
                        "id": 3859,
                        "name": "Wörterberg",
                        "latitude": "47.21667000",
                        "longitude": "16.10000000"
                    },
                    {
                        "id": 3850,
                        "name": "Wulkaprodersdorf",
                        "latitude": "47.79753000",
                        "longitude": "16.50447000"
                    },
                    {
                        "id": 3866,
                        "name": "Zagersdorf",
                        "latitude": "47.76471000",
                        "longitude": "16.51382000"
                    },
                    {
                        "id": 3887,
                        "name": "Zillingtal",
                        "latitude": "47.81442000",
                        "longitude": "16.40928000"
                    },
                    {
                        "id": 3890,
                        "name": "Zurndorf",
                        "latitude": "47.98314000",
                        "longitude": "17.00315000"
                    }
                ]
            },
            {
                "id": 2057,
                "name": "Carinthia",
                "iso2": "2",
                "latitude": "46.72220300",
                "longitude": "14.18058820",
                "type": "state",
                "cities": [
                    {
                        "id": 143783,
                        "name": "Albeck",
                        "latitude": "46.81666667",
                        "longitude": "14.10000000"
                    },
                    {
                        "id": 1646,
                        "name": "Althofen",
                        "latitude": "46.87298000",
                        "longitude": "14.47449000"
                    },
                    {
                        "id": 1668,
                        "name": "Annabichl",
                        "latitude": "46.65000000",
                        "longitude": "14.31667000"
                    },
                    {
                        "id": 1679,
                        "name": "Arnoldstein",
                        "latitude": "46.54611000",
                        "longitude": "13.71000000"
                    },
                    {
                        "id": 1681,
                        "name": "Arriach",
                        "latitude": "46.72921000",
                        "longitude": "13.85046000"
                    },
                    {
                        "id": 1706,
                        "name": "Auen",
                        "latitude": "46.59963000",
                        "longitude": "13.84389000"
                    },
                    {
                        "id": 143785,
                        "name": "Bad Bleiberg",
                        "latitude": "46.62416667",
                        "longitude": "13.68777778"
                    },
                    {
                        "id": 143786,
                        "name": "Bad Eisenkappel",
                        "latitude": "46.48333333",
                        "longitude": "14.60000000"
                    },
                    {
                        "id": 143787,
                        "name": "Bad Kleinkirchheim",
                        "latitude": "46.81361111",
                        "longitude": "13.79277778"
                    },
                    {
                        "id": 1733,
                        "name": "Bad Sankt Leonhard im Lavanttal",
                        "latitude": "46.96278000",
                        "longitude": "14.79167000"
                    },
                    {
                        "id": 1746,
                        "name": "Baldramsdorf",
                        "latitude": "46.80111000",
                        "longitude": "13.45333000"
                    },
                    {
                        "id": 1755,
                        "name": "Berg im Drautal",
                        "latitude": "46.74915000",
                        "longitude": "13.13536000"
                    },
                    {
                        "id": 1781,
                        "name": "Bleiburg",
                        "latitude": "46.59000000",
                        "longitude": "14.79889000"
                    },
                    {
                        "id": 1788,
                        "name": "Bodensdorf",
                        "latitude": "46.69111000",
                        "longitude": "13.97111000"
                    },
                    {
                        "id": 1816,
                        "name": "Brückl",
                        "latitude": "46.75167000",
                        "longitude": "14.53667000"
                    },
                    {
                        "id": 1833,
                        "name": "Dellach",
                        "latitude": "46.66175000",
                        "longitude": "13.07965000"
                    },
                    {
                        "id": 1834,
                        "name": "Dellach im Drautal",
                        "latitude": "46.73750000",
                        "longitude": "13.07833000"
                    },
                    {
                        "id": 1838,
                        "name": "Deutsch Griffen",
                        "latitude": "46.85606000",
                        "longitude": "14.07501000"
                    },
                    {
                        "id": 143791,
                        "name": "Deutsch-Griffen",
                        "latitude": "46.85500000",
                        "longitude": "14.07388889"
                    },
                    {
                        "id": 1854,
                        "name": "Diex",
                        "latitude": "46.75000000",
                        "longitude": "14.60000000"
                    },
                    {
                        "id": 1871,
                        "name": "Döbriach",
                        "latitude": "46.78049000",
                        "longitude": "13.65738000"
                    },
                    {
                        "id": 1866,
                        "name": "Draschen",
                        "latitude": "46.76909000",
                        "longitude": "14.06758000"
                    },
                    {
                        "id": 1886,
                        "name": "Ebenthal",
                        "latitude": "46.60806000",
                        "longitude": "14.36417000"
                    },
                    {
                        "id": 1890,
                        "name": "Eberndorf",
                        "latitude": "46.59139000",
                        "longitude": "14.64361000"
                    },
                    {
                        "id": 1894,
                        "name": "Eberstein",
                        "latitude": "46.80806000",
                        "longitude": "14.56000000"
                    },
                    {
                        "id": 143792,
                        "name": "Ebriach",
                        "latitude": "46.46667000",
                        "longitude": "14.51667000"
                    },
                    {
                        "id": 143793,
                        "name": "Eisenkappel-Vellach",
                        "latitude": "46.48638889",
                        "longitude": "14.59611111"
                    },
                    {
                        "id": 1957,
                        "name": "Faak am See",
                        "latitude": "46.56806000",
                        "longitude": "13.90972000"
                    },
                    {
                        "id": 143794,
                        "name": "Feffernitz",
                        "latitude": "46.68333333",
                        "longitude": "13.70000000"
                    },
                    {
                        "id": 1966,
                        "name": "Feistritz an der Drau",
                        "latitude": "46.70157000",
                        "longitude": "13.66479000"
                    },
                    {
                        "id": 1967,
                        "name": "Feistritz an der Gail",
                        "latitude": "46.57750000",
                        "longitude": "13.60667000"
                    },
                    {
                        "id": 1969,
                        "name": "Feistritz im Rosental",
                        "latitude": "46.51667000",
                        "longitude": "14.16667000"
                    },
                    {
                        "id": 1970,
                        "name": "Feistritz ob Bleiburg",
                        "latitude": "46.55000000",
                        "longitude": "14.76667000"
                    },
                    {
                        "id": 1971,
                        "name": "Feld am See",
                        "latitude": "46.77639000",
                        "longitude": "13.74778000"
                    },
                    {
                        "id": 2998,
                        "name": "Feldkirchen District",
                        "latitude": "46.72127000",
                        "longitude": "14.09683000"
                    },
                    {
                        "id": 1976,
                        "name": "Feldkirchen in Kärnten",
                        "latitude": "46.72368000",
                        "longitude": "14.09580000"
                    },
                    {
                        "id": 1980,
                        "name": "Ferlach",
                        "latitude": "46.52694000",
                        "longitude": "14.30194000"
                    },
                    {
                        "id": 1981,
                        "name": "Ferndorf",
                        "latitude": "46.73651000",
                        "longitude": "13.62661000"
                    },
                    {
                        "id": 1988,
                        "name": "Finkenstein",
                        "latitude": "46.56155000",
                        "longitude": "13.87086000"
                    },
                    {
                        "id": 1989,
                        "name": "Finkenstein am Faaker See",
                        "latitude": "46.57904000",
                        "longitude": "13.93496000"
                    },
                    {
                        "id": 1997,
                        "name": "Flattach",
                        "latitude": "46.93861000",
                        "longitude": "13.13444000"
                    },
                    {
                        "id": 2033,
                        "name": "Föderlach I",
                        "latitude": "46.59998000",
                        "longitude": "13.96128000"
                    },
                    {
                        "id": 143797,
                        "name": "Frantschach-Sankt Gertraud",
                        "latitude": "46.86111111",
                        "longitude": "14.86027778"
                    },
                    {
                        "id": 2015,
                        "name": "Frauenstein",
                        "latitude": "46.81417000",
                        "longitude": "14.29417000"
                    },
                    {
                        "id": 2021,
                        "name": "Fresach",
                        "latitude": "46.71556000",
                        "longitude": "13.69083000"
                    },
                    {
                        "id": 2022,
                        "name": "Fresen",
                        "latitude": "46.70516000",
                        "longitude": "14.04513000"
                    },
                    {
                        "id": 2024,
                        "name": "Friesach",
                        "latitude": "46.95528000",
                        "longitude": "14.40583000"
                    },
                    {
                        "id": 2036,
                        "name": "Fürnitz",
                        "latitude": "46.56188000",
                        "longitude": "13.81732000"
                    },
                    {
                        "id": 2043,
                        "name": "Gailitz",
                        "latitude": "46.56083000",
                        "longitude": "13.70444000"
                    },
                    {
                        "id": 2046,
                        "name": "Gallizien",
                        "latitude": "46.55000000",
                        "longitude": "14.51667000"
                    },
                    {
                        "id": 143800,
                        "name": "Gemmersdorf",
                        "latitude": "46.75740000",
                        "longitude": "14.90220000"
                    },
                    {
                        "id": 143801,
                        "name": "Gerlamoos",
                        "latitude": "46.76391000",
                        "longitude": "13.27200000"
                    },
                    {
                        "id": 143802,
                        "name": "Gitschtal",
                        "latitude": "46.67972222",
                        "longitude": "13.26055556"
                    },
                    {
                        "id": 2083,
                        "name": "Glanegg",
                        "latitude": "46.72259000",
                        "longitude": "14.19893000"
                    },
                    {
                        "id": 2088,
                        "name": "Globasnitz",
                        "latitude": "46.55694000",
                        "longitude": "14.70278000"
                    },
                    {
                        "id": 2091,
                        "name": "Glödnitz",
                        "latitude": "46.87398000",
                        "longitude": "14.11915000"
                    },
                    {
                        "id": 2093,
                        "name": "Gmünd",
                        "latitude": "46.90722000",
                        "longitude": "13.52944000"
                    },
                    {
                        "id": 143803,
                        "name": "Gmünd in Kärnten",
                        "latitude": "46.91472000",
                        "longitude": "13.54670000"
                    },
                    {
                        "id": 2099,
                        "name": "Gnesau",
                        "latitude": "46.77544000",
                        "longitude": "13.96251000"
                    },
                    {
                        "id": 143806,
                        "name": "Görtschach",
                        "latitude": "46.61278000",
                        "longitude": "13.46500000"
                    },
                    {
                        "id": 2113,
                        "name": "Grafenstein",
                        "latitude": "46.61393000",
                        "longitude": "14.46719000"
                    },
                    {
                        "id": 2124,
                        "name": "Greifenburg",
                        "latitude": "46.75027000",
                        "longitude": "13.17982000"
                    },
                    {
                        "id": 2130,
                        "name": "Gries",
                        "latitude": "46.83160000",
                        "longitude": "14.85103000"
                    },
                    {
                        "id": 2135,
                        "name": "Griffen",
                        "latitude": "46.70444000",
                        "longitude": "14.73278000"
                    },
                    {
                        "id": 2155,
                        "name": "Großkirchheim",
                        "latitude": "46.97270000",
                        "longitude": "12.89589000"
                    },
                    {
                        "id": 2178,
                        "name": "Gurk",
                        "latitude": "46.87389000",
                        "longitude": "14.29167000"
                    },
                    {
                        "id": 2182,
                        "name": "Guttaring",
                        "latitude": "46.88536000",
                        "longitude": "14.51071000"
                    },
                    {
                        "id": 2258,
                        "name": "Heiligenblut",
                        "latitude": "47.03979000",
                        "longitude": "12.84345000"
                    },
                    {
                        "id": 2271,
                        "name": "Hermagor",
                        "latitude": "46.62722000",
                        "longitude": "13.36722000"
                    },
                    {
                        "id": 3008,
                        "name": "Hermagor District",
                        "latitude": "46.63137000",
                        "longitude": "13.13246000"
                    },
                    {
                        "id": 143807,
                        "name": "Hermagor-Pressegger See",
                        "latitude": "46.62722222",
                        "longitude": "13.36722222"
                    },
                    {
                        "id": 2282,
                        "name": "Himmelberg",
                        "latitude": "46.75667000",
                        "longitude": "14.03056000"
                    },
                    {
                        "id": 2319,
                        "name": "Hohenthurn",
                        "latitude": "46.55774000",
                        "longitude": "13.66038000"
                    },
                    {
                        "id": 2344,
                        "name": "Hörtendorf",
                        "latitude": "46.63333000",
                        "longitude": "14.40000000"
                    },
                    {
                        "id": 2348,
                        "name": "Hüttenberg",
                        "latitude": "46.94139000",
                        "longitude": "14.55000000"
                    },
                    {
                        "id": 2367,
                        "name": "Irschen",
                        "latitude": "46.75694000",
                        "longitude": "13.02528000"
                    },
                    {
                        "id": 2402,
                        "name": "Kappel am Krappfeld",
                        "latitude": "46.83861000",
                        "longitude": "14.48639000"
                    },
                    {
                        "id": 2420,
                        "name": "Keutschach am See",
                        "latitude": "46.59306000",
                        "longitude": "14.18889000"
                    },
                    {
                        "id": 2424,
                        "name": "Kirchbach",
                        "latitude": "46.64160000",
                        "longitude": "13.18454000"
                    },
                    {
                        "id": 143810,
                        "name": "Klagenfurt",
                        "latitude": "46.63873000",
                        "longitude": "14.29730000"
                    },
                    {
                        "id": 2446,
                        "name": "Klagenfurt am Wörthersee",
                        "latitude": "46.63333000",
                        "longitude": "14.30000000"
                    },
                    {
                        "id": 3016,
                        "name": "Klagenfurt-Land District",
                        "latitude": "46.56722000",
                        "longitude": "14.29295000"
                    },
                    {
                        "id": 143811,
                        "name": "Kleblach-Lind",
                        "latitude": "46.76722222",
                        "longitude": "13.35805556"
                    },
                    {
                        "id": 2449,
                        "name": "Klein Sankt Paul",
                        "latitude": "46.83611000",
                        "longitude": "14.54139000"
                    },
                    {
                        "id": 2453,
                        "name": "Kleinedling",
                        "latitude": "46.81417000",
                        "longitude": "14.82778000"
                    },
                    {
                        "id": 2514,
                        "name": "Kötschach",
                        "latitude": "46.68167000",
                        "longitude": "13.00694000"
                    },
                    {
                        "id": 143813,
                        "name": "Kötschach-Mauthen",
                        "latitude": "46.66666667",
                        "longitude": "13.00000000"
                    },
                    {
                        "id": 2515,
                        "name": "Köttmannsdorf",
                        "latitude": "46.56139000",
                        "longitude": "14.23389000"
                    },
                    {
                        "id": 143812,
                        "name": "Krems",
                        "latitude": "46.92250000",
                        "longitude": "13.56750000"
                    },
                    {
                        "id": 2500,
                        "name": "Krumpendorf",
                        "latitude": "46.63333000",
                        "longitude": "14.21667000"
                    },
                    {
                        "id": 2516,
                        "name": "Kühnsdorf",
                        "latitude": "46.62194000",
                        "longitude": "14.63639000"
                    },
                    {
                        "id": 143814,
                        "name": "Lamnitz",
                        "latitude": "46.86666667",
                        "longitude": "12.98333333"
                    },
                    {
                        "id": 2533,
                        "name": "Landskron",
                        "latitude": "46.61667000",
                        "longitude": "13.88333000"
                    },
                    {
                        "id": 2553,
                        "name": "Launsdorf",
                        "latitude": "46.77056000",
                        "longitude": "14.45194000"
                    },
                    {
                        "id": 2556,
                        "name": "Lavamünd",
                        "latitude": "46.64019000",
                        "longitude": "14.94733000"
                    },
                    {
                        "id": 2561,
                        "name": "Ledenitzen",
                        "latitude": "46.56639000",
                        "longitude": "13.96139000"
                    },
                    {
                        "id": 2574,
                        "name": "Lendorf",
                        "latitude": "46.83528000",
                        "longitude": "13.43028000"
                    },
                    {
                        "id": 143816,
                        "name": "Leppen",
                        "latitude": "46.48333000",
                        "longitude": "14.63333000"
                    },
                    {
                        "id": 143817,
                        "name": "Lesachtal",
                        "latitude": "46.69388889",
                        "longitude": "12.81583333"
                    },
                    {
                        "id": 2594,
                        "name": "Liebenfels",
                        "latitude": "46.73778000",
                        "longitude": "14.28667000"
                    },
                    {
                        "id": 2601,
                        "name": "Lind",
                        "latitude": "46.62244000",
                        "longitude": "13.84715000"
                    },
                    {
                        "id": 143818,
                        "name": "Lobersberg",
                        "latitude": "46.86500000",
                        "longitude": "12.91111111"
                    },
                    {
                        "id": 2618,
                        "name": "Ludmannsdorf",
                        "latitude": "46.54139000",
                        "longitude": "14.13425000"
                    },
                    {
                        "id": 143819,
                        "name": "Lurnfeld",
                        "latitude": "46.83333333",
                        "longitude": "13.36666667"
                    },
                    {
                        "id": 143820,
                        "name": "Magdalensberg",
                        "latitude": "46.70111111",
                        "longitude": "14.43111111"
                    },
                    {
                        "id": 143821,
                        "name": "Mallnitz",
                        "latitude": "46.98972222",
                        "longitude": "13.17000000"
                    },
                    {
                        "id": 143822,
                        "name": "Malta",
                        "latitude": "46.96666667",
                        "longitude": "13.51666667"
                    },
                    {
                        "id": 2646,
                        "name": "Maria Rain",
                        "latitude": "46.55389000",
                        "longitude": "14.29556000"
                    },
                    {
                        "id": 2647,
                        "name": "Maria Saal",
                        "latitude": "46.68083000",
                        "longitude": "14.34861000"
                    },
                    {
                        "id": 2650,
                        "name": "Maria Wörth",
                        "latitude": "46.61639000",
                        "longitude": "14.16306000"
                    },
                    {
                        "id": 2678,
                        "name": "Mautbrücken",
                        "latitude": "46.72037000",
                        "longitude": "14.19399000"
                    },
                    {
                        "id": 2692,
                        "name": "Metnitz",
                        "latitude": "46.98056000",
                        "longitude": "14.21667000"
                    },
                    {
                        "id": 2696,
                        "name": "Micheldorf",
                        "latitude": "46.91667000",
                        "longitude": "14.41667000"
                    },
                    {
                        "id": 2702,
                        "name": "Millstatt",
                        "latitude": "46.80417000",
                        "longitude": "13.58056000"
                    },
                    {
                        "id": 2742,
                        "name": "Mölbling",
                        "latitude": "46.85000000",
                        "longitude": "14.43333000"
                    },
                    {
                        "id": 2743,
                        "name": "Möllbrücke",
                        "latitude": "46.83639000",
                        "longitude": "13.37278000"
                    },
                    {
                        "id": 2726,
                        "name": "Moosburg",
                        "latitude": "46.65750000",
                        "longitude": "14.17472000"
                    },
                    {
                        "id": 2749,
                        "name": "Mörtschach",
                        "latitude": "46.92389000",
                        "longitude": "12.91778000"
                    },
                    {
                        "id": 2755,
                        "name": "Mühldorf",
                        "latitude": "46.86028000",
                        "longitude": "13.35361000"
                    },
                    {
                        "id": 2782,
                        "name": "Neu-Feffernitz",
                        "latitude": "46.68772000",
                        "longitude": "13.67914000"
                    },
                    {
                        "id": 2794,
                        "name": "Neuhaus",
                        "latitude": "46.63333000",
                        "longitude": "14.88333000"
                    },
                    {
                        "id": 2823,
                        "name": "Niederdorf",
                        "latitude": "46.61667000",
                        "longitude": "14.40000000"
                    },
                    {
                        "id": 143829,
                        "name": "Nötsch im Gailtal",
                        "latitude": "46.59000000",
                        "longitude": "13.62277778"
                    },
                    {
                        "id": 143830,
                        "name": "Oberdörfl",
                        "latitude": "46.55528000",
                        "longitude": "14.10806000"
                    },
                    {
                        "id": 2849,
                        "name": "Oberdrauburg",
                        "latitude": "46.74306000",
                        "longitude": "12.97028000"
                    },
                    {
                        "id": 143831,
                        "name": "Obermillstatt",
                        "latitude": "46.81060000",
                        "longitude": "13.59080000"
                    },
                    {
                        "id": 2879,
                        "name": "Obervellach",
                        "latitude": "46.93667000",
                        "longitude": "13.20417000"
                    },
                    {
                        "id": 2906,
                        "name": "Ossiach",
                        "latitude": "46.67435000",
                        "longitude": "13.98358000"
                    },
                    {
                        "id": 2928,
                        "name": "Paternion",
                        "latitude": "46.71417000",
                        "longitude": "13.63611000"
                    },
                    {
                        "id": 143832,
                        "name": "Pischeldorf",
                        "latitude": "46.68333000",
                        "longitude": "14.45000000"
                    },
                    {
                        "id": 143834,
                        "name": "Pöckau",
                        "latitude": "46.55000000",
                        "longitude": "13.73330000"
                    },
                    {
                        "id": 2986,
                        "name": "Poggersdorf",
                        "latitude": "46.65000000",
                        "longitude": "14.45000000"
                    },
                    {
                        "id": 3108,
                        "name": "Pörtschach am Wörthersee",
                        "latitude": "46.63639000",
                        "longitude": "14.14639000"
                    },
                    {
                        "id": 3078,
                        "name": "Preitenegg",
                        "latitude": "46.94000000",
                        "longitude": "14.92583000"
                    },
                    {
                        "id": 3081,
                        "name": "Priel",
                        "latitude": "46.82758000",
                        "longitude": "14.83330000"
                    },
                    {
                        "id": 143833,
                        "name": "Pusarnitz",
                        "latitude": "46.83333000",
                        "longitude": "13.40000000"
                    },
                    {
                        "id": 3123,
                        "name": "Radenthein",
                        "latitude": "46.80056000",
                        "longitude": "13.71167000"
                    },
                    {
                        "id": 3130,
                        "name": "Rain",
                        "latitude": "46.60528000",
                        "longitude": "14.38611000"
                    },
                    {
                        "id": 3137,
                        "name": "Rangersdorf",
                        "latitude": "46.86001000",
                        "longitude": "12.94923000"
                    },
                    {
                        "id": 3157,
                        "name": "Reding",
                        "latitude": "46.81667000",
                        "longitude": "14.85000000"
                    },
                    {
                        "id": 143835,
                        "name": "Reichenau",
                        "latitude": "46.85416667",
                        "longitude": "13.89305556"
                    },
                    {
                        "id": 3165,
                        "name": "Reichenfels",
                        "latitude": "47.00718000",
                        "longitude": "14.74425000"
                    },
                    {
                        "id": 143836,
                        "name": "Reißeck",
                        "latitude": "46.87694444",
                        "longitude": "13.30555556"
                    },
                    {
                        "id": 3178,
                        "name": "Rennweg am Katschberg",
                        "latitude": "47.01667000",
                        "longitude": "13.61667000"
                    },
                    {
                        "id": 143837,
                        "name": "Rittersdorf",
                        "latitude": "46.75111000",
                        "longitude": "13.03444000"
                    },
                    {
                        "id": 3210,
                        "name": "Rosegg",
                        "latitude": "46.58833000",
                        "longitude": "14.01718000"
                    },
                    {
                        "id": 3215,
                        "name": "Ruden",
                        "latitude": "46.65833000",
                        "longitude": "14.77639000"
                    },
                    {
                        "id": 3231,
                        "name": "Sachsenburg",
                        "latitude": "46.82917000",
                        "longitude": "13.35500000"
                    },
                    {
                        "id": 3239,
                        "name": "Sankt Andrä",
                        "latitude": "46.76829000",
                        "longitude": "14.81991000"
                    },
                    {
                        "id": 143839,
                        "name": "Sankt Egyden an der Drau",
                        "latitude": "46.57722000",
                        "longitude": "14.06167000"
                    },
                    {
                        "id": 3484,
                        "name": "Sankt Georgen am Längsee",
                        "latitude": "46.78061000",
                        "longitude": "14.43033000"
                    },
                    {
                        "id": 143840,
                        "name": "Sankt Georgen im Lavanttal",
                        "latitude": "46.71666667",
                        "longitude": "14.91666667"
                    },
                    {
                        "id": 143841,
                        "name": "Sankt Jakob",
                        "latitude": "46.54777778",
                        "longitude": "14.05722222"
                    },
                    {
                        "id": 143842,
                        "name": "Sankt Jakob im Rosental",
                        "latitude": "46.54777778",
                        "longitude": "14.05722222"
                    },
                    {
                        "id": 143843,
                        "name": "Sankt Kanzian am Klopeiner See",
                        "latitude": "46.61444444",
                        "longitude": "14.57583333"
                    },
                    {
                        "id": 3279,
                        "name": "Sankt Leonhard",
                        "latitude": "46.62528000",
                        "longitude": "13.85865000"
                    },
                    {
                        "id": 3288,
                        "name": "Sankt Magdalen",
                        "latitude": "46.61667000",
                        "longitude": "13.88333000"
                    },
                    {
                        "id": 3293,
                        "name": "Sankt Margareten im Rosental",
                        "latitude": "46.54417000",
                        "longitude": "14.42444000"
                    },
                    {
                        "id": 3301,
                        "name": "Sankt Martin",
                        "latitude": "46.61667000",
                        "longitude": "14.28333000"
                    },
                    {
                        "id": 3319,
                        "name": "Sankt Paul im Lavanttal",
                        "latitude": "46.70056000",
                        "longitude": "14.87556000"
                    },
                    {
                        "id": 3320,
                        "name": "Sankt Peter",
                        "latitude": "46.62978000",
                        "longitude": "14.34016000"
                    },
                    {
                        "id": 3332,
                        "name": "Sankt Ruprecht",
                        "latitude": "46.60000000",
                        "longitude": "14.31667000"
                    },
                    {
                        "id": 3334,
                        "name": "Sankt Stefan",
                        "latitude": "46.80750000",
                        "longitude": "14.85167000"
                    },
                    {
                        "id": 143844,
                        "name": "Sankt Stefan im Gailtal",
                        "latitude": "46.61666667",
                        "longitude": "13.51666667"
                    },
                    {
                        "id": 143845,
                        "name": "Sankt Urban",
                        "latitude": "46.75027778",
                        "longitude": "14.16916667"
                    },
                    {
                        "id": 3343,
                        "name": "Sankt Veit an der Glan",
                        "latitude": "46.76806000",
                        "longitude": "14.36028000"
                    },
                    {
                        "id": 3044,
                        "name": "Sankt Veit an der Glan District",
                        "latitude": "46.83333000",
                        "longitude": "14.40000000"
                    },
                    {
                        "id": 3369,
                        "name": "Schiefling am See",
                        "latitude": "46.60444000",
                        "longitude": "14.09750000"
                    },
                    {
                        "id": 3374,
                        "name": "Schleben",
                        "latitude": "46.62039000",
                        "longitude": "13.93301000"
                    },
                    {
                        "id": 3428,
                        "name": "Seebach",
                        "latitude": "46.61667000",
                        "longitude": "13.86667000"
                    },
                    {
                        "id": 3430,
                        "name": "Seeboden",
                        "latitude": "46.81909000",
                        "longitude": "13.51430000"
                    },
                    {
                        "id": 3439,
                        "name": "Seitenberg",
                        "latitude": "46.74801000",
                        "longitude": "14.08825000"
                    },
                    {
                        "id": 143848,
                        "name": "Sirnitz",
                        "latitude": "46.82361000",
                        "longitude": "14.05944000"
                    },
                    {
                        "id": 3464,
                        "name": "Sittersdorf",
                        "latitude": "46.54444000",
                        "longitude": "14.60583000"
                    },
                    {
                        "id": 3479,
                        "name": "Spittal an der Drau",
                        "latitude": "46.80000000",
                        "longitude": "13.50000000"
                    },
                    {
                        "id": 3048,
                        "name": "Spittal an der Drau District",
                        "latitude": "46.85000000",
                        "longitude": "13.33333000"
                    },
                    {
                        "id": 3483,
                        "name": "St. Agathen und Perau",
                        "latitude": "46.60627000",
                        "longitude": "13.85615000"
                    },
                    {
                        "id": 143849,
                        "name": "St. Andrä",
                        "latitude": "46.76473000",
                        "longitude": "14.82442000"
                    },
                    {
                        "id": 143850,
                        "name": "St. Margareten im Rosental",
                        "latitude": "46.52498000",
                        "longitude": "14.41600000"
                    },
                    {
                        "id": 143851,
                        "name": "St. Paul im Lavanttal",
                        "latitude": "46.69869000",
                        "longitude": "14.84877000"
                    },
                    {
                        "id": 143852,
                        "name": "St. Stefan im Gailtal",
                        "latitude": "46.60796000",
                        "longitude": "13.50973000"
                    },
                    {
                        "id": 143853,
                        "name": "St. Urban",
                        "latitude": "46.76128000",
                        "longitude": "14.16658000"
                    },
                    {
                        "id": 143854,
                        "name": "St. Veit an der Glan",
                        "latitude": "46.73536000",
                        "longitude": "14.35404000"
                    },
                    {
                        "id": 3486,
                        "name": "St. Veiter Vorstadt",
                        "latitude": "46.63170000",
                        "longitude": "14.30579000"
                    },
                    {
                        "id": 3496,
                        "name": "Stall",
                        "latitude": "46.89056000",
                        "longitude": "13.03694000"
                    },
                    {
                        "id": 3517,
                        "name": "Steindorf am Ossiacher See",
                        "latitude": "46.69833000",
                        "longitude": "14.00917000"
                    },
                    {
                        "id": 3519,
                        "name": "Steinfeld",
                        "latitude": "46.75812000",
                        "longitude": "13.24934000"
                    },
                    {
                        "id": 3526,
                        "name": "Steuerberg",
                        "latitude": "46.78804000",
                        "longitude": "14.11290000"
                    },
                    {
                        "id": 3532,
                        "name": "Stockenboi",
                        "latitude": "46.72611000",
                        "longitude": "13.52306000"
                    },
                    {
                        "id": 143857,
                        "name": "Straßburg",
                        "latitude": "46.89555556",
                        "longitude": "14.33083333"
                    },
                    {
                        "id": 3548,
                        "name": "Straßburg-Stadt",
                        "latitude": "46.89444000",
                        "longitude": "14.32861000"
                    },
                    {
                        "id": 143858,
                        "name": "Suetschach",
                        "latitude": "46.52694444",
                        "longitude": "14.15638889"
                    },
                    {
                        "id": 143859,
                        "name": "Techelsberg",
                        "latitude": "46.65861111",
                        "longitude": "14.10194444"
                    },
                    {
                        "id": 143860,
                        "name": "Timenitz",
                        "latitude": "46.68333000",
                        "longitude": "14.41667000"
                    },
                    {
                        "id": 3618,
                        "name": "Trebesing",
                        "latitude": "46.88639000",
                        "longitude": "13.51028000"
                    },
                    {
                        "id": 143862,
                        "name": "Treffen",
                        "latitude": "46.66833333",
                        "longitude": "13.85555556"
                    },
                    {
                        "id": 3620,
                        "name": "Treibach",
                        "latitude": "46.86667000",
                        "longitude": "14.46667000"
                    },
                    {
                        "id": 143863,
                        "name": "Tschachoritsch",
                        "latitude": "46.55352000",
                        "longitude": "14.21461000"
                    },
                    {
                        "id": 143864,
                        "name": "Umberg",
                        "latitude": "46.64833000",
                        "longitude": "13.95750000"
                    },
                    {
                        "id": 3649,
                        "name": "Untere Fellach",
                        "latitude": "46.62504000",
                        "longitude": "13.82681000"
                    },
                    {
                        "id": 143865,
                        "name": "Velden am Wörther See",
                        "latitude": "46.61250000",
                        "longitude": "14.04194444"
                    },
                    {
                        "id": 3675,
                        "name": "Velden am Wörthersee",
                        "latitude": "46.61301000",
                        "longitude": "14.04130000"
                    },
                    {
                        "id": 3684,
                        "name": "Viktring",
                        "latitude": "46.59194000",
                        "longitude": "14.26917000"
                    },
                    {
                        "id": 3685,
                        "name": "Viktringer Vorstadt",
                        "latitude": "46.61773000",
                        "longitude": "14.30931000"
                    },
                    {
                        "id": 3686,
                        "name": "Villach",
                        "latitude": "46.61028000",
                        "longitude": "13.85583000"
                    },
                    {
                        "id": 3688,
                        "name": "Villach-Innere Stadt",
                        "latitude": "46.61275000",
                        "longitude": "13.84638000"
                    },
                    {
                        "id": 3054,
                        "name": "Villach-Land District",
                        "latitude": "46.65308000",
                        "longitude": "13.77287000"
                    },
                    {
                        "id": 3689,
                        "name": "Villacher Vorstadt",
                        "latitude": "46.62368000",
                        "longitude": "14.28892000"
                    },
                    {
                        "id": 3705,
                        "name": "Völkendorf",
                        "latitude": "46.60806000",
                        "longitude": "13.83153000"
                    },
                    {
                        "id": 3706,
                        "name": "Völkermarkt",
                        "latitude": "46.66222000",
                        "longitude": "14.63444000"
                    },
                    {
                        "id": 3057,
                        "name": "Völkermarkt District",
                        "latitude": "46.59641000",
                        "longitude": "14.66664000"
                    },
                    {
                        "id": 3707,
                        "name": "Völkermarkter Vorstadt",
                        "latitude": "46.62418000",
                        "longitude": "14.32081000"
                    },
                    {
                        "id": 3721,
                        "name": "Waiern",
                        "latitude": "46.73028000",
                        "longitude": "14.08194000"
                    },
                    {
                        "id": 3744,
                        "name": "Warmbad-Judendorf",
                        "latitude": "46.60126000",
                        "longitude": "13.82241000"
                    },
                    {
                        "id": 143867,
                        "name": "Weißensee",
                        "latitude": "46.71666667",
                        "longitude": "13.30000000"
                    },
                    {
                        "id": 143868,
                        "name": "Weißenstein",
                        "latitude": "46.68222222",
                        "longitude": "13.72361111"
                    },
                    {
                        "id": 3776,
                        "name": "Weitensfeld",
                        "latitude": "46.84743000",
                        "longitude": "14.19213000"
                    },
                    {
                        "id": 143866,
                        "name": "Weitensfeld im Gurktal",
                        "latitude": "46.84861111",
                        "longitude": "14.19166667"
                    },
                    {
                        "id": 3794,
                        "name": "Wernberg",
                        "latitude": "46.61667000",
                        "longitude": "13.93333000"
                    },
                    {
                        "id": 3833,
                        "name": "Winklern",
                        "latitude": "46.87361000",
                        "longitude": "12.87472000"
                    },
                    {
                        "id": 3854,
                        "name": "Wölfnitz",
                        "latitude": "46.66639000",
                        "longitude": "14.25806000"
                    },
                    {
                        "id": 3842,
                        "name": "Wolfsberg",
                        "latitude": "46.84056000",
                        "longitude": "14.84417000"
                    },
                    {
                        "id": 3061,
                        "name": "Wolfsberg District",
                        "latitude": "46.83333000",
                        "longitude": "14.83333000"
                    },
                    {
                        "id": 3849,
                        "name": "Wudmath",
                        "latitude": "46.59634000",
                        "longitude": "13.98067000"
                    },
                    {
                        "id": 143871,
                        "name": "Zell",
                        "latitude": "46.47222222",
                        "longitude": "14.38888889"
                    }
                ]
            },
            {
                "id": 2065,
                "name": "Lower Austria",
                "iso2": "3",
                "latitude": "48.10807700",
                "longitude": "15.80495580",
                "type": "state",
                "cities": [
                    {
                        "id": 1602,
                        "name": "Absdorf",
                        "latitude": "48.40021000",
                        "longitude": "15.97874000"
                    },
                    {
                        "id": 1606,
                        "name": "Achau",
                        "latitude": "48.08026000",
                        "longitude": "16.38611000"
                    },
                    {
                        "id": 1608,
                        "name": "Aderklaa",
                        "latitude": "48.28333000",
                        "longitude": "16.53333000"
                    },
                    {
                        "id": 1614,
                        "name": "Aggsbach",
                        "latitude": "48.29404000",
                        "longitude": "15.40382000"
                    },
                    {
                        "id": 1627,
                        "name": "Alland",
                        "latitude": "48.05829000",
                        "longitude": "16.07901000"
                    },
                    {
                        "id": 1628,
                        "name": "Allentsteig",
                        "latitude": "48.69725000",
                        "longitude": "15.32756000"
                    },
                    {
                        "id": 1633,
                        "name": "Allhartsberg",
                        "latitude": "48.02633000",
                        "longitude": "14.79009000"
                    },
                    {
                        "id": 1638,
                        "name": "Altenburg",
                        "latitude": "48.64765000",
                        "longitude": "15.59295000"
                    },
                    {
                        "id": 1639,
                        "name": "Altendorf",
                        "latitude": "47.65000000",
                        "longitude": "16.01667000"
                    },
                    {
                        "id": 1641,
                        "name": "Altenmarkt an der Triesting",
                        "latitude": "48.01553000",
                        "longitude": "15.99661000"
                    },
                    {
                        "id": 1647,
                        "name": "Altlengbach",
                        "latitude": "48.15355000",
                        "longitude": "15.92606000"
                    },
                    {
                        "id": 1649,
                        "name": "Altlichtenwarth",
                        "latitude": "48.64442000",
                        "longitude": "16.79664000"
                    },
                    {
                        "id": 1650,
                        "name": "Altmelon",
                        "latitude": "48.46222000",
                        "longitude": "14.96552000"
                    },
                    {
                        "id": 1656,
                        "name": "Amstetten",
                        "latitude": "48.12290000",
                        "longitude": "14.87206000"
                    },
                    {
                        "id": 1659,
                        "name": "Andlersdorf",
                        "latitude": "48.18333000",
                        "longitude": "16.66667000"
                    },
                    {
                        "id": 1666,
                        "name": "Angern an der March",
                        "latitude": "48.37778000",
                        "longitude": "16.82806000"
                    },
                    {
                        "id": 1675,
                        "name": "Arbesbach",
                        "latitude": "48.49337000",
                        "longitude": "14.95308000"
                    },
                    {
                        "id": 1676,
                        "name": "Ardagger Stift",
                        "latitude": "48.15000000",
                        "longitude": "14.83333000"
                    },
                    {
                        "id": 1689,
                        "name": "Aschbach Markt",
                        "latitude": "48.07234000",
                        "longitude": "14.75395000"
                    },
                    {
                        "id": 1690,
                        "name": "Aspang Markt",
                        "latitude": "47.55000000",
                        "longitude": "16.08333000"
                    },
                    {
                        "id": 1691,
                        "name": "Asparn an der Zaya",
                        "latitude": "48.58333000",
                        "longitude": "16.50000000"
                    },
                    {
                        "id": 1692,
                        "name": "Asperhofen",
                        "latitude": "48.24583000",
                        "longitude": "15.92606000"
                    },
                    {
                        "id": 1699,
                        "name": "Atzenbrugg",
                        "latitude": "48.29119000",
                        "longitude": "15.90614000"
                    },
                    {
                        "id": 1703,
                        "name": "Au am Leithaberge",
                        "latitude": "47.92296000",
                        "longitude": "16.55794000"
                    },
                    {
                        "id": 1708,
                        "name": "Auersthal",
                        "latitude": "48.37373000",
                        "longitude": "16.63596000"
                    },
                    {
                        "id": 1718,
                        "name": "Bad Deutsch-Altenburg",
                        "latitude": "48.13425000",
                        "longitude": "16.90624000"
                    },
                    {
                        "id": 1719,
                        "name": "Bad Erlach",
                        "latitude": "47.72722000",
                        "longitude": "16.21444000"
                    },
                    {
                        "id": 1720,
                        "name": "Bad Fischau",
                        "latitude": "47.83137000",
                        "longitude": "16.16707000"
                    },
                    {
                        "id": 1731,
                        "name": "Bad Pirawarth",
                        "latitude": "48.45194000",
                        "longitude": "16.59833000"
                    },
                    {
                        "id": 1736,
                        "name": "Bad Schönau",
                        "latitude": "47.49473000",
                        "longitude": "16.23410000"
                    },
                    {
                        "id": 1738,
                        "name": "Bad Traunstein",
                        "latitude": "48.43850000",
                        "longitude": "15.11712000"
                    },
                    {
                        "id": 1739,
                        "name": "Bad Vöslau",
                        "latitude": "47.96533000",
                        "longitude": "16.21359000"
                    },
                    {
                        "id": 1742,
                        "name": "Baden",
                        "latitude": "48.00543000",
                        "longitude": "16.23264000"
                    },
                    {
                        "id": 1824,
                        "name": "Bärnkopf",
                        "latitude": "48.39046000",
                        "longitude": "15.00479000"
                    },
                    {
                        "id": 1752,
                        "name": "Behamberg",
                        "latitude": "48.01667000",
                        "longitude": "14.48333000"
                    },
                    {
                        "id": 1753,
                        "name": "Berg",
                        "latitude": "48.10147000",
                        "longitude": "17.03842000"
                    },
                    {
                        "id": 1759,
                        "name": "Bergland",
                        "latitude": "48.15595000",
                        "longitude": "15.18553000"
                    },
                    {
                        "id": 1761,
                        "name": "Berndorf",
                        "latitude": "47.94567000",
                        "longitude": "16.10973000"
                    },
                    {
                        "id": 1764,
                        "name": "Bernhardsthal",
                        "latitude": "48.69158000",
                        "longitude": "16.86951000"
                    },
                    {
                        "id": 1768,
                        "name": "Biberbach",
                        "latitude": "48.03006000",
                        "longitude": "14.70795000"
                    },
                    {
                        "id": 1771,
                        "name": "Biedermannsdorf",
                        "latitude": "48.08393000",
                        "longitude": "16.34542000"
                    },
                    {
                        "id": 1776,
                        "name": "Bisamberg",
                        "latitude": "48.33333000",
                        "longitude": "16.35000000"
                    },
                    {
                        "id": 1778,
                        "name": "Bischofstetten",
                        "latitude": "48.12222000",
                        "longitude": "15.46909000"
                    },
                    {
                        "id": 1782,
                        "name": "Blindenmarkt",
                        "latitude": "48.12749000",
                        "longitude": "14.98647000"
                    },
                    {
                        "id": 1786,
                        "name": "Bockfließ",
                        "latitude": "48.36000000",
                        "longitude": "16.60389000"
                    },
                    {
                        "id": 1825,
                        "name": "Böheimkirchen",
                        "latitude": "48.19779000",
                        "longitude": "15.76178000"
                    },
                    {
                        "id": 1796,
                        "name": "Breitenau",
                        "latitude": "47.73355000",
                        "longitude": "16.14338000"
                    },
                    {
                        "id": 1801,
                        "name": "Breitenfurt bei Wien",
                        "latitude": "48.13333000",
                        "longitude": "16.15000000"
                    },
                    {
                        "id": 1806,
                        "name": "Bromberg",
                        "latitude": "47.66539000",
                        "longitude": "16.20990000"
                    },
                    {
                        "id": 1809,
                        "name": "Bruck an der Leitha",
                        "latitude": "48.01667000",
                        "longitude": "16.76667000"
                    },
                    {
                        "id": 1813,
                        "name": "Brunn am Gebirge",
                        "latitude": "48.10697000",
                        "longitude": "16.28466000"
                    },
                    {
                        "id": 1814,
                        "name": "Brunn an der Schneebergbahn",
                        "latitude": "47.82376000",
                        "longitude": "16.15934000"
                    },
                    {
                        "id": 1815,
                        "name": "Brunn an der Wild",
                        "latitude": "48.69425000",
                        "longitude": "15.52008000"
                    },
                    {
                        "id": 1818,
                        "name": "Buchbach",
                        "latitude": "47.69648000",
                        "longitude": "15.98425000"
                    },
                    {
                        "id": 1841,
                        "name": "Deutsch-Wagram",
                        "latitude": "48.29972000",
                        "longitude": "16.56667000"
                    },
                    {
                        "id": 1855,
                        "name": "Dobersberg",
                        "latitude": "48.91510000",
                        "longitude": "15.32188000"
                    },
                    {
                        "id": 1864,
                        "name": "Dorfstetten",
                        "latitude": "48.32573000",
                        "longitude": "14.98218000"
                    },
                    {
                        "id": 1867,
                        "name": "Drasenhofen",
                        "latitude": "48.75000000",
                        "longitude": "16.65000000"
                    },
                    {
                        "id": 1870,
                        "name": "Drösing",
                        "latitude": "48.53900000",
                        "longitude": "16.90264000"
                    },
                    {
                        "id": 1869,
                        "name": "Droß",
                        "latitude": "48.46393000",
                        "longitude": "15.57561000"
                    },
                    {
                        "id": 1877,
                        "name": "Dürnkrut",
                        "latitude": "48.47315000",
                        "longitude": "16.85062000"
                    },
                    {
                        "id": 1878,
                        "name": "Dürnstein",
                        "latitude": "48.39582000",
                        "longitude": "15.51973000"
                    },
                    {
                        "id": 1884,
                        "name": "Ebenfurth",
                        "latitude": "47.87738000",
                        "longitude": "16.36731000"
                    },
                    {
                        "id": 1887,
                        "name": "Ebenthal",
                        "latitude": "48.43333000",
                        "longitude": "16.78333000"
                    },
                    {
                        "id": 1889,
                        "name": "Ebergassing",
                        "latitude": "48.04567000",
                        "longitude": "16.51709000"
                    },
                    {
                        "id": 1895,
                        "name": "Ebreichsdorf",
                        "latitude": "47.95579000",
                        "longitude": "16.40705000"
                    },
                    {
                        "id": 1897,
                        "name": "Echsenbach",
                        "latitude": "48.71667000",
                        "longitude": "15.21667000"
                    },
                    {
                        "id": 1898,
                        "name": "Eckartsau",
                        "latitude": "48.14507000",
                        "longitude": "16.79737000"
                    },
                    {
                        "id": 1904,
                        "name": "Edlitz",
                        "latitude": "47.59797000",
                        "longitude": "16.14052000"
                    },
                    {
                        "id": 1909,
                        "name": "Eggenburg",
                        "latitude": "48.63892000",
                        "longitude": "15.81903000"
                    },
                    {
                        "id": 1910,
                        "name": "Eggendorf",
                        "latitude": "47.85809000",
                        "longitude": "16.32182000"
                    },
                    {
                        "id": 1911,
                        "name": "Eggern",
                        "latitude": "48.90829000",
                        "longitude": "15.14877000"
                    },
                    {
                        "id": 1920,
                        "name": "Eichgraben",
                        "latitude": "48.17204000",
                        "longitude": "15.98391000"
                    },
                    {
                        "id": 1927,
                        "name": "Eisgarn",
                        "latitude": "48.91675000",
                        "longitude": "15.10320000"
                    },
                    {
                        "id": 1935,
                        "name": "Emmersdorf an der Donau",
                        "latitude": "48.24140000",
                        "longitude": "15.33721000"
                    },
                    {
                        "id": 1938,
                        "name": "Engelhartstetten",
                        "latitude": "48.18160000",
                        "longitude": "16.88367000"
                    },
                    {
                        "id": 1941,
                        "name": "Ennsdorf",
                        "latitude": "48.21181000",
                        "longitude": "14.50290000"
                    },
                    {
                        "id": 1942,
                        "name": "Enzenreith",
                        "latitude": "47.66839000",
                        "longitude": "15.95249000"
                    },
                    {
                        "id": 1943,
                        "name": "Enzersdorf an der Fischa",
                        "latitude": "48.08502000",
                        "longitude": "16.60832000"
                    },
                    {
                        "id": 1944,
                        "name": "Enzersfeld",
                        "latitude": "48.36338000",
                        "longitude": "16.42387000"
                    },
                    {
                        "id": 1947,
                        "name": "Erlauf",
                        "latitude": "48.18333000",
                        "longitude": "15.18333000"
                    },
                    {
                        "id": 1948,
                        "name": "Ernstbrunn",
                        "latitude": "48.53333000",
                        "longitude": "16.35000000"
                    },
                    {
                        "id": 1949,
                        "name": "Ernsthofen",
                        "latitude": "48.12915000",
                        "longitude": "14.48058000"
                    },
                    {
                        "id": 1950,
                        "name": "Erpersdorf",
                        "latitude": "48.34210000",
                        "longitude": "15.91747000"
                    },
                    {
                        "id": 1952,
                        "name": "Ertl",
                        "latitude": "47.97704000",
                        "longitude": "14.63134000"
                    },
                    {
                        "id": 1954,
                        "name": "Eschenau",
                        "latitude": "48.04825000",
                        "longitude": "15.56694000"
                    },
                    {
                        "id": 1956,
                        "name": "Euratsfeld",
                        "latitude": "48.08181000",
                        "longitude": "14.93154000"
                    },
                    {
                        "id": 1960,
                        "name": "Falkenstein",
                        "latitude": "48.71667000",
                        "longitude": "16.58333000"
                    },
                    {
                        "id": 1961,
                        "name": "Fallbach",
                        "latitude": "48.65000000",
                        "longitude": "16.41667000"
                    },
                    {
                        "id": 1965,
                        "name": "Feistritz am Wechsel",
                        "latitude": "47.60000000",
                        "longitude": "16.05000000"
                    },
                    {
                        "id": 1977,
                        "name": "Felixdorf",
                        "latitude": "47.88159000",
                        "longitude": "16.24208000"
                    },
                    {
                        "id": 1978,
                        "name": "Fels am Wagram",
                        "latitude": "48.43333000",
                        "longitude": "15.81667000"
                    },
                    {
                        "id": 1983,
                        "name": "Ferschnitz",
                        "latitude": "48.09419000",
                        "longitude": "14.98454000"
                    },
                    {
                        "id": 1990,
                        "name": "Fischamend-Markt",
                        "latitude": "48.11667000",
                        "longitude": "16.60000000"
                    },
                    {
                        "id": 2009,
                        "name": "Frankenfels",
                        "latitude": "47.98234000",
                        "longitude": "15.32593000"
                    },
                    {
                        "id": 2027,
                        "name": "Frohsdorf",
                        "latitude": "47.73333000",
                        "longitude": "16.25000000"
                    },
                    {
                        "id": 2029,
                        "name": "Furth an der Triesting",
                        "latitude": "47.97326000",
                        "longitude": "15.97326000"
                    },
                    {
                        "id": 2030,
                        "name": "Furth bei Göttweig",
                        "latitude": "48.37385000",
                        "longitude": "15.61408000"
                    },
                    {
                        "id": 2038,
                        "name": "Gaaden",
                        "latitude": "48.05364000",
                        "longitude": "16.20003000"
                    },
                    {
                        "id": 2041,
                        "name": "Gablitz",
                        "latitude": "48.22856000",
                        "longitude": "16.15437000"
                    },
                    {
                        "id": 2044,
                        "name": "Gainfarn",
                        "latitude": "47.96280000",
                        "longitude": "16.19368000"
                    },
                    {
                        "id": 2052,
                        "name": "Gaming",
                        "latitude": "47.92900000",
                        "longitude": "15.08818000"
                    },
                    {
                        "id": 2183,
                        "name": "Gänserndorf",
                        "latitude": "48.33925000",
                        "longitude": "16.72016000"
                    },
                    {
                        "id": 2058,
                        "name": "Gars am Kamp",
                        "latitude": "48.58899000",
                        "longitude": "15.65363000"
                    },
                    {
                        "id": 2063,
                        "name": "Gastern",
                        "latitude": "48.89446000",
                        "longitude": "15.22027000"
                    },
                    {
                        "id": 2065,
                        "name": "Gaubitsch",
                        "latitude": "48.65000000",
                        "longitude": "16.38333000"
                    },
                    {
                        "id": 2067,
                        "name": "Gaweinstal",
                        "latitude": "48.48003000",
                        "longitude": "16.58790000"
                    },
                    {
                        "id": 2069,
                        "name": "Gedersdorf",
                        "latitude": "48.43319000",
                        "longitude": "15.68865000"
                    },
                    {
                        "id": 2073,
                        "name": "Geras",
                        "latitude": "48.79725000",
                        "longitude": "15.67268000"
                    },
                    {
                        "id": 2074,
                        "name": "Gerasdorf bei Wien",
                        "latitude": "48.29447000",
                        "longitude": "16.46765000"
                    },
                    {
                        "id": 2075,
                        "name": "Gerersdorf",
                        "latitude": "48.20088000",
                        "longitude": "15.55613000"
                    },
                    {
                        "id": 2078,
                        "name": "Gerolding",
                        "latitude": "48.25000000",
                        "longitude": "15.41667000"
                    },
                    {
                        "id": 2080,
                        "name": "Gföhl",
                        "latitude": "48.51667000",
                        "longitude": "15.48333000"
                    },
                    {
                        "id": 2081,
                        "name": "Gießhübl",
                        "latitude": "48.09780000",
                        "longitude": "16.23479000"
                    },
                    {
                        "id": 2087,
                        "name": "Glinzendorf",
                        "latitude": "48.24605000",
                        "longitude": "16.64060000"
                    },
                    {
                        "id": 2089,
                        "name": "Gloggnitz",
                        "latitude": "47.67487000",
                        "longitude": "15.93893000"
                    },
                    {
                        "id": 2094,
                        "name": "Gmünd",
                        "latitude": "48.76830000",
                        "longitude": "14.98080000"
                    },
                    {
                        "id": 2095,
                        "name": "Gnadendorf",
                        "latitude": "48.61667000",
                        "longitude": "16.40000000"
                    },
                    {
                        "id": 2098,
                        "name": "Gneixendorf",
                        "latitude": "48.43751000",
                        "longitude": "15.61810000"
                    },
                    {
                        "id": 2185,
                        "name": "Göllersdorf",
                        "latitude": "48.49357000",
                        "longitude": "16.11943000"
                    },
                    {
                        "id": 2186,
                        "name": "Göpfritz an der Wild",
                        "latitude": "48.72497000",
                        "longitude": "15.40236000"
                    },
                    {
                        "id": 2191,
                        "name": "Göstling an der Ybbs",
                        "latitude": "47.80664000",
                        "longitude": "14.93797000"
                    },
                    {
                        "id": 2193,
                        "name": "Götzendorf an der Leitha",
                        "latitude": "48.01667000",
                        "longitude": "16.58333000"
                    },
                    {
                        "id": 2110,
                        "name": "Grafenegg",
                        "latitude": "48.43040000",
                        "longitude": "15.74907000"
                    },
                    {
                        "id": 2112,
                        "name": "Grafenschlag",
                        "latitude": "48.50000000",
                        "longitude": "15.16667000"
                    },
                    {
                        "id": 2114,
                        "name": "Grafenwörth",
                        "latitude": "48.40790000",
                        "longitude": "15.77826000"
                    },
                    {
                        "id": 2118,
                        "name": "Gramatneusiedl",
                        "latitude": "48.03040000",
                        "longitude": "16.48936000"
                    },
                    {
                        "id": 2126,
                        "name": "Greinsfurth",
                        "latitude": "48.10846000",
                        "longitude": "14.84390000"
                    },
                    {
                        "id": 2129,
                        "name": "Gresten",
                        "latitude": "47.98521000",
                        "longitude": "15.02552000"
                    },
                    {
                        "id": 2136,
                        "name": "Grimmenstein",
                        "latitude": "47.61635000",
                        "longitude": "16.12724000"
                    },
                    {
                        "id": 2146,
                        "name": "Groß-Engersdorf",
                        "latitude": "48.35873000",
                        "longitude": "16.56610000"
                    },
                    {
                        "id": 2147,
                        "name": "Groß-Enzersdorf",
                        "latitude": "48.20278000",
                        "longitude": "16.55083000"
                    },
                    {
                        "id": 2148,
                        "name": "Groß-Gerungs",
                        "latitude": "48.57422000",
                        "longitude": "14.95789000"
                    },
                    {
                        "id": 2149,
                        "name": "Groß-Schweinbarth",
                        "latitude": "48.41472000",
                        "longitude": "16.63194000"
                    },
                    {
                        "id": 2150,
                        "name": "Groß-Siegharts",
                        "latitude": "48.79180000",
                        "longitude": "15.40429000"
                    },
                    {
                        "id": 2152,
                        "name": "Großebersdorf",
                        "latitude": "48.36405000",
                        "longitude": "16.47076000"
                    },
                    {
                        "id": 2153,
                        "name": "Großharras",
                        "latitude": "48.66389000",
                        "longitude": "16.24556000"
                    },
                    {
                        "id": 2154,
                        "name": "Großhofen",
                        "latitude": "48.25834000",
                        "longitude": "16.61940000"
                    },
                    {
                        "id": 2157,
                        "name": "Großkrut",
                        "latitude": "48.64389000",
                        "longitude": "16.72361000"
                    },
                    {
                        "id": 2159,
                        "name": "Großmugl",
                        "latitude": "48.49917000",
                        "longitude": "16.23056000"
                    },
                    {
                        "id": 2160,
                        "name": "Großriedenthal",
                        "latitude": "48.48333000",
                        "longitude": "15.86667000"
                    },
                    {
                        "id": 2161,
                        "name": "Großrußbach",
                        "latitude": "48.47412000",
                        "longitude": "16.41649000"
                    },
                    {
                        "id": 2163,
                        "name": "Großweikersdorf",
                        "latitude": "48.47123000",
                        "longitude": "15.98251000"
                    },
                    {
                        "id": 2168,
                        "name": "Grünbach am Schneeberg",
                        "latitude": "47.79747000",
                        "longitude": "15.98785000"
                    },
                    {
                        "id": 2172,
                        "name": "Gugging",
                        "latitude": "48.31385000",
                        "longitude": "16.24852000"
                    },
                    {
                        "id": 2173,
                        "name": "Gumpoldskirchen",
                        "latitude": "48.04538000",
                        "longitude": "16.27710000"
                    },
                    {
                        "id": 2196,
                        "name": "Günselsdorf",
                        "latitude": "47.94395000",
                        "longitude": "16.26062000"
                    },
                    {
                        "id": 2176,
                        "name": "Guntersdorf",
                        "latitude": "48.65000000",
                        "longitude": "16.05000000"
                    },
                    {
                        "id": 2177,
                        "name": "Guntramsdorf",
                        "latitude": "48.04687000",
                        "longitude": "16.31384000"
                    },
                    {
                        "id": 2180,
                        "name": "Gutenbrunn",
                        "latitude": "48.36520000",
                        "longitude": "15.11899000"
                    },
                    {
                        "id": 2181,
                        "name": "Gutenstein",
                        "latitude": "47.87600000",
                        "longitude": "15.88881000"
                    },
                    {
                        "id": 2200,
                        "name": "Haag",
                        "latitude": "48.11362000",
                        "longitude": "14.56753000"
                    },
                    {
                        "id": 2204,
                        "name": "Hadersdorf am Kamp",
                        "latitude": "48.45000000",
                        "longitude": "15.71667000"
                    },
                    {
                        "id": 2205,
                        "name": "Hadres",
                        "latitude": "48.70965000",
                        "longitude": "16.13038000"
                    },
                    {
                        "id": 2207,
                        "name": "Hafnerbach",
                        "latitude": "48.21667000",
                        "longitude": "15.48333000"
                    },
                    {
                        "id": 2209,
                        "name": "Hagenbrunn",
                        "latitude": "48.33333000",
                        "longitude": "16.40000000"
                    },
                    {
                        "id": 2213,
                        "name": "Haidershofen",
                        "latitude": "48.07579000",
                        "longitude": "14.46131000"
                    },
                    {
                        "id": 2216,
                        "name": "Hainburg an der Donau",
                        "latitude": "48.14627000",
                        "longitude": "16.94504000"
                    },
                    {
                        "id": 2218,
                        "name": "Hainfeld",
                        "latitude": "48.03390000",
                        "longitude": "15.77414000"
                    },
                    {
                        "id": 2230,
                        "name": "Hardegg",
                        "latitude": "48.85000000",
                        "longitude": "15.85000000"
                    },
                    {
                        "id": 2231,
                        "name": "Haringsee",
                        "latitude": "48.19270000",
                        "longitude": "16.78741000"
                    },
                    {
                        "id": 2232,
                        "name": "Harland",
                        "latitude": "48.16162000",
                        "longitude": "15.63835000"
                    },
                    {
                        "id": 2233,
                        "name": "Harmannsdorf",
                        "latitude": "48.39724000",
                        "longitude": "16.37220000"
                    },
                    {
                        "id": 2235,
                        "name": "Hart",
                        "latitude": "48.15320000",
                        "longitude": "15.61569000"
                    },
                    {
                        "id": 2247,
                        "name": "Haugschlag",
                        "latitude": "48.98333000",
                        "longitude": "15.05000000"
                    },
                    {
                        "id": 2248,
                        "name": "Haugsdorf",
                        "latitude": "48.70762000",
                        "longitude": "16.07656000"
                    },
                    {
                        "id": 2249,
                        "name": "Haunoldstein",
                        "latitude": "48.20000000",
                        "longitude": "15.45000000"
                    },
                    {
                        "id": 2252,
                        "name": "Hausbrunn",
                        "latitude": "48.62602000",
                        "longitude": "16.82844000"
                    },
                    {
                        "id": 2253,
                        "name": "Hauskirchen",
                        "latitude": "48.60000000",
                        "longitude": "16.76667000"
                    },
                    {
                        "id": 2254,
                        "name": "Hausleiten",
                        "latitude": "48.38333000",
                        "longitude": "16.10000000"
                    },
                    {
                        "id": 2256,
                        "name": "Hausmening",
                        "latitude": "48.07074000",
                        "longitude": "14.81438000"
                    },
                    {
                        "id": 2257,
                        "name": "Heidenreichstein",
                        "latitude": "48.86667000",
                        "longitude": "15.11667000"
                    },
                    {
                        "id": 2260,
                        "name": "Heiligeneich",
                        "latitude": "48.29964000",
                        "longitude": "15.89413000"
                    },
                    {
                        "id": 2261,
                        "name": "Heiligenkreuz",
                        "latitude": "48.05559000",
                        "longitude": "16.12493000"
                    },
                    {
                        "id": 2270,
                        "name": "Hennersdorf",
                        "latitude": "48.11173000",
                        "longitude": "16.36311000"
                    },
                    {
                        "id": 2273,
                        "name": "Hernstein",
                        "latitude": "47.89465000",
                        "longitude": "16.10561000"
                    },
                    {
                        "id": 2274,
                        "name": "Herrnbaumgarten",
                        "latitude": "48.69606000",
                        "longitude": "16.68283000"
                    },
                    {
                        "id": 2275,
                        "name": "Herzogenburg",
                        "latitude": "48.28137000",
                        "longitude": "15.69431000"
                    },
                    {
                        "id": 2281,
                        "name": "Himberg",
                        "latitude": "48.08333000",
                        "longitude": "16.43333000"
                    },
                    {
                        "id": 2285,
                        "name": "Hinterbrühl",
                        "latitude": "48.08611000",
                        "longitude": "16.24809000"
                    },
                    {
                        "id": 2287,
                        "name": "Hinterleiten",
                        "latitude": "48.16513000",
                        "longitude": "15.96654000"
                    },
                    {
                        "id": 2292,
                        "name": "Hirschbach",
                        "latitude": "48.74329000",
                        "longitude": "15.12521000"
                    },
                    {
                        "id": 2294,
                        "name": "Hirtenberg",
                        "latitude": "47.93095000",
                        "longitude": "16.17908000"
                    },
                    {
                        "id": 2299,
                        "name": "Hochleithen",
                        "latitude": "48.45317000",
                        "longitude": "16.53090000"
                    },
                    {
                        "id": 2302,
                        "name": "Hochwolkersdorf",
                        "latitude": "47.66127000",
                        "longitude": "16.28072000"
                    },
                    {
                        "id": 2305,
                        "name": "Hof am Leithaberge",
                        "latitude": "47.95000000",
                        "longitude": "16.58333000"
                    },
                    {
                        "id": 2308,
                        "name": "Hofamt Priel",
                        "latitude": "48.19581000",
                        "longitude": "15.07746000"
                    },
                    {
                        "id": 2339,
                        "name": "Höflein",
                        "latitude": "48.06667000",
                        "longitude": "16.78333000"
                    },
                    {
                        "id": 2340,
                        "name": "Höfling",
                        "latitude": "48.05444000",
                        "longitude": "15.03672000"
                    },
                    {
                        "id": 2310,
                        "name": "Hofstetten",
                        "latitude": "48.09711000",
                        "longitude": "15.51149000"
                    },
                    {
                        "id": 2312,
                        "name": "Hohenau",
                        "latitude": "48.60420000",
                        "longitude": "16.90470000"
                    },
                    {
                        "id": 2314,
                        "name": "Hohenberg",
                        "latitude": "47.90679000",
                        "longitude": "15.61998000"
                    },
                    {
                        "id": 2315,
                        "name": "Hoheneich",
                        "latitude": "48.77195000",
                        "longitude": "15.02857000"
                    },
                    {
                        "id": 2317,
                        "name": "Hohenruppersdorf",
                        "latitude": "48.46439000",
                        "longitude": "16.65244000"
                    },
                    {
                        "id": 2321,
                        "name": "Hollabrunn",
                        "latitude": "48.55000000",
                        "longitude": "16.08333000"
                    },
                    {
                        "id": 2323,
                        "name": "Hollenstein an der Ybbs",
                        "latitude": "47.80305000",
                        "longitude": "14.77312000"
                    },
                    {
                        "id": 2324,
                        "name": "Hollenthon",
                        "latitude": "47.58938000",
                        "longitude": "16.26131000"
                    },
                    {
                        "id": 2331,
                        "name": "Horn",
                        "latitude": "48.66274000",
                        "longitude": "15.65663000"
                    },
                    {
                        "id": 2333,
                        "name": "Hundsheim",
                        "latitude": "48.11749000",
                        "longitude": "16.93581000"
                    },
                    {
                        "id": 2346,
                        "name": "Hürm",
                        "latitude": "48.15601000",
                        "longitude": "15.41262000"
                    },
                    {
                        "id": 2334,
                        "name": "Hutten",
                        "latitude": "48.17856000",
                        "longitude": "15.98579000"
                    },
                    {
                        "id": 2372,
                        "name": "Jaidhof",
                        "latitude": "48.53333000",
                        "longitude": "15.48333000"
                    },
                    {
                        "id": 2374,
                        "name": "Japons",
                        "latitude": "48.79250000",
                        "longitude": "15.56831000"
                    },
                    {
                        "id": 2375,
                        "name": "Jedenspeigen",
                        "latitude": "48.49807000",
                        "longitude": "16.87225000"
                    },
                    {
                        "id": 2394,
                        "name": "Kaltenleutgeben",
                        "latitude": "48.11646000",
                        "longitude": "16.19956000"
                    },
                    {
                        "id": 2398,
                        "name": "Kapelln",
                        "latitude": "48.25817000",
                        "longitude": "15.75731000"
                    },
                    {
                        "id": 2405,
                        "name": "Karlstetten",
                        "latitude": "48.25920000",
                        "longitude": "15.56544000"
                    },
                    {
                        "id": 2409,
                        "name": "Kasten bei Böheimkirchen",
                        "latitude": "48.15320000",
                        "longitude": "15.77946000"
                    },
                    {
                        "id": 2411,
                        "name": "Katzelsdorf",
                        "latitude": "47.78055000",
                        "longitude": "16.26985000"
                    },
                    {
                        "id": 2412,
                        "name": "Kaumberg",
                        "latitude": "48.02415000",
                        "longitude": "15.89842000"
                    },
                    {
                        "id": 2414,
                        "name": "Kautzen",
                        "latitude": "48.93000000",
                        "longitude": "15.23932000"
                    },
                    {
                        "id": 2416,
                        "name": "Kematen an der Ybbs",
                        "latitude": "48.02541000",
                        "longitude": "14.76468000"
                    },
                    {
                        "id": 2421,
                        "name": "Kierling",
                        "latitude": "48.30997000",
                        "longitude": "16.27616000"
                    },
                    {
                        "id": 2422,
                        "name": "Kilb",
                        "latitude": "48.10101000",
                        "longitude": "15.40850000"
                    },
                    {
                        "id": 2426,
                        "name": "Kirchberg am Wagram",
                        "latitude": "48.43182000",
                        "longitude": "15.89692000"
                    },
                    {
                        "id": 2427,
                        "name": "Kirchberg am Walde",
                        "latitude": "48.72477000",
                        "longitude": "15.08826000"
                    },
                    {
                        "id": 2428,
                        "name": "Kirchberg am Wechsel",
                        "latitude": "47.60738000",
                        "longitude": "15.99103000"
                    },
                    {
                        "id": 2429,
                        "name": "Kirchberg an der Pielach",
                        "latitude": "48.02690000",
                        "longitude": "15.42875000"
                    },
                    {
                        "id": 2437,
                        "name": "Kirchschlag",
                        "latitude": "48.39345000",
                        "longitude": "15.22285000"
                    },
                    {
                        "id": 2439,
                        "name": "Kirchschlag in der Buckligen Welt",
                        "latitude": "47.50000000",
                        "longitude": "16.28333000"
                    },
                    {
                        "id": 2440,
                        "name": "Kirchstetten",
                        "latitude": "48.18333000",
                        "longitude": "15.81667000"
                    },
                    {
                        "id": 2441,
                        "name": "Kirnberg an der Mank",
                        "latitude": "48.07246000",
                        "longitude": "15.32232000"
                    },
                    {
                        "id": 2448,
                        "name": "Klausen-Leopoldsdorf",
                        "latitude": "48.08771000",
                        "longitude": "16.01686000"
                    },
                    {
                        "id": 2450,
                        "name": "Klein-Neusiedl",
                        "latitude": "48.09379000",
                        "longitude": "16.60661000"
                    },
                    {
                        "id": 2451,
                        "name": "Klein-Pöchlarn",
                        "latitude": "48.21667000",
                        "longitude": "15.21667000"
                    },
                    {
                        "id": 2459,
                        "name": "Kleinzell",
                        "latitude": "47.97993000",
                        "longitude": "15.73620000"
                    },
                    {
                        "id": 2462,
                        "name": "Klosterneuburg",
                        "latitude": "48.30521000",
                        "longitude": "16.32522000"
                    },
                    {
                        "id": 2510,
                        "name": "Königstetten",
                        "latitude": "48.30198000",
                        "longitude": "16.14492000"
                    },
                    {
                        "id": 2476,
                        "name": "Korneuburg",
                        "latitude": "48.35000000",
                        "longitude": "16.33333000"
                    },
                    {
                        "id": 2477,
                        "name": "Kottingbrunn",
                        "latitude": "47.95096000",
                        "longitude": "16.22715000"
                    },
                    {
                        "id": 2483,
                        "name": "Krems an der Donau",
                        "latitude": "48.40921000",
                        "longitude": "15.61415000"
                    },
                    {
                        "id": 2484,
                        "name": "Krems an der Donau Stadt",
                        "latitude": "48.41040000",
                        "longitude": "15.60574000"
                    },
                    {
                        "id": 2491,
                        "name": "Kritzendorf",
                        "latitude": "48.32932000",
                        "longitude": "16.30011000"
                    },
                    {
                        "id": 2495,
                        "name": "Krumau am Kamp",
                        "latitude": "48.58879000",
                        "longitude": "15.44914000"
                    },
                    {
                        "id": 2497,
                        "name": "Krumbach Markt",
                        "latitude": "47.51667000",
                        "longitude": "16.18333000"
                    },
                    {
                        "id": 2499,
                        "name": "Krumnussbaum",
                        "latitude": "48.20877000",
                        "longitude": "15.16212000"
                    },
                    {
                        "id": 2517,
                        "name": "Laa an der Thaya",
                        "latitude": "48.71667000",
                        "longitude": "16.38333000"
                    },
                    {
                        "id": 2519,
                        "name": "Laab im Walde",
                        "latitude": "48.15486000",
                        "longitude": "16.17359000"
                    },
                    {
                        "id": 2525,
                        "name": "Ladendorf",
                        "latitude": "48.53333000",
                        "longitude": "16.48333000"
                    },
                    {
                        "id": 2531,
                        "name": "Landegg",
                        "latitude": "47.90000000",
                        "longitude": "16.40000000"
                    },
                    {
                        "id": 2535,
                        "name": "Langau",
                        "latitude": "48.83207000",
                        "longitude": "15.71560000"
                    },
                    {
                        "id": 2539,
                        "name": "Langenlebarn-Oberaigen",
                        "latitude": "48.33023000",
                        "longitude": "16.11059000"
                    },
                    {
                        "id": 2540,
                        "name": "Langenlois",
                        "latitude": "48.46667000",
                        "longitude": "15.66667000"
                    },
                    {
                        "id": 2541,
                        "name": "Langenrohr",
                        "latitude": "48.30489000",
                        "longitude": "16.01034000"
                    },
                    {
                        "id": 2544,
                        "name": "Langenzersdorf",
                        "latitude": "48.30432000",
                        "longitude": "16.36143000"
                    },
                    {
                        "id": 2546,
                        "name": "Langschlag",
                        "latitude": "48.57448000",
                        "longitude": "14.88459000"
                    },
                    {
                        "id": 2549,
                        "name": "Lanzendorf",
                        "latitude": "48.11056000",
                        "longitude": "16.44500000"
                    },
                    {
                        "id": 2550,
                        "name": "Lanzenkirchen",
                        "latitude": "47.73621000",
                        "longitude": "16.21985000"
                    },
                    {
                        "id": 2551,
                        "name": "Lassee",
                        "latitude": "48.22479000",
                        "longitude": "16.82230000"
                    },
                    {
                        "id": 2558,
                        "name": "Laxenburg",
                        "latitude": "48.06833000",
                        "longitude": "16.35607000"
                    },
                    {
                        "id": 2563,
                        "name": "Leiben",
                        "latitude": "48.24628000",
                        "longitude": "15.27460000"
                    },
                    {
                        "id": 2570,
                        "name": "Leitzersdorf",
                        "latitude": "48.41918000",
                        "longitude": "16.24513000"
                    },
                    {
                        "id": 2575,
                        "name": "Lengenfeld",
                        "latitude": "48.47187000",
                        "longitude": "15.59870000"
                    },
                    {
                        "id": 2579,
                        "name": "Leobendorf",
                        "latitude": "48.38333000",
                        "longitude": "16.31667000"
                    },
                    {
                        "id": 2580,
                        "name": "Leobersdorf",
                        "latitude": "47.92796000",
                        "longitude": "16.21651000"
                    },
                    {
                        "id": 2584,
                        "name": "Leopoldsdorf",
                        "latitude": "48.11557000",
                        "longitude": "16.39126000"
                    },
                    {
                        "id": 2585,
                        "name": "Leopoldsdorf im Marchfelde",
                        "latitude": "48.22261000",
                        "longitude": "16.68858000"
                    },
                    {
                        "id": 2586,
                        "name": "Lerchenfeld",
                        "latitude": "48.41234000",
                        "longitude": "15.63183000"
                    },
                    {
                        "id": 2590,
                        "name": "Lichtenegg",
                        "latitude": "47.60000000",
                        "longitude": "16.20000000"
                    },
                    {
                        "id": 2592,
                        "name": "Lichtenwörth",
                        "latitude": "47.82756000",
                        "longitude": "16.29873000"
                    },
                    {
                        "id": 2600,
                        "name": "Lilienfeld",
                        "latitude": "48.01312000",
                        "longitude": "15.59664000"
                    },
                    {
                        "id": 2605,
                        "name": "Litschau",
                        "latitude": "48.94409000",
                        "longitude": "15.04483000"
                    },
                    {
                        "id": 2610,
                        "name": "Loich",
                        "latitude": "47.99578000",
                        "longitude": "15.40163000"
                    },
                    {
                        "id": 2613,
                        "name": "Loosdorf",
                        "latitude": "48.20000000",
                        "longitude": "15.40000000"
                    },
                    {
                        "id": 2620,
                        "name": "Lunz am See",
                        "latitude": "47.86120000",
                        "longitude": "15.02998000"
                    },
                    {
                        "id": 2626,
                        "name": "Mailberg",
                        "latitude": "48.67379000",
                        "longitude": "16.18132000"
                    },
                    {
                        "id": 2628,
                        "name": "Maissau",
                        "latitude": "48.57300000",
                        "longitude": "15.83005000"
                    },
                    {
                        "id": 2629,
                        "name": "Mank",
                        "latitude": "48.11024000",
                        "longitude": "15.33915000"
                    },
                    {
                        "id": 2630,
                        "name": "Mannersdorf am Leithagebirge",
                        "latitude": "47.96667000",
                        "longitude": "16.60000000"
                    },
                    {
                        "id": 2633,
                        "name": "Mannsdorf an der Donau",
                        "latitude": "48.15200000",
                        "longitude": "16.66506000"
                    },
                    {
                        "id": 2634,
                        "name": "Mannswörth",
                        "latitude": "48.14547000",
                        "longitude": "16.51374000"
                    },
                    {
                        "id": 2635,
                        "name": "Marbach an der Donau",
                        "latitude": "48.21667000",
                        "longitude": "15.15000000"
                    },
                    {
                        "id": 2636,
                        "name": "Marchegg",
                        "latitude": "48.26217000",
                        "longitude": "16.91045000"
                    },
                    {
                        "id": 2638,
                        "name": "Margarethen am Moos",
                        "latitude": "48.03333000",
                        "longitude": "16.60000000"
                    },
                    {
                        "id": 2640,
                        "name": "Maria Ellend",
                        "latitude": "48.10000000",
                        "longitude": "16.68333000"
                    },
                    {
                        "id": 2641,
                        "name": "Maria Enzersdorf",
                        "latitude": "48.10000000",
                        "longitude": "16.28333000"
                    },
                    {
                        "id": 2642,
                        "name": "Maria Laach am Jauerling",
                        "latitude": "48.30412000",
                        "longitude": "15.34472000"
                    },
                    {
                        "id": 2644,
                        "name": "Maria Lanzendorf",
                        "latitude": "48.09923000",
                        "longitude": "16.41984000"
                    },
                    {
                        "id": 2649,
                        "name": "Maria Taferl",
                        "latitude": "48.22702000",
                        "longitude": "15.15954000"
                    },
                    {
                        "id": 2651,
                        "name": "Maria-Anzbach",
                        "latitude": "48.19012000",
                        "longitude": "15.93155000"
                    },
                    {
                        "id": 2659,
                        "name": "Markersdorf an der Pielach",
                        "latitude": "48.18333000",
                        "longitude": "15.50000000"
                    },
                    {
                        "id": 2660,
                        "name": "Markgrafneusiedl",
                        "latitude": "48.26667000",
                        "longitude": "16.63333000"
                    },
                    {
                        "id": 2663,
                        "name": "Markt Piesting",
                        "latitude": "47.87358000",
                        "longitude": "16.12510000"
                    },
                    {
                        "id": 2665,
                        "name": "Martinsberg",
                        "latitude": "48.37549000",
                        "longitude": "15.14997000"
                    },
                    {
                        "id": 2672,
                        "name": "Matzen",
                        "latitude": "48.40000000",
                        "longitude": "16.70000000"
                    },
                    {
                        "id": 2673,
                        "name": "Matzendorf",
                        "latitude": "47.89137000",
                        "longitude": "16.21393000"
                    },
                    {
                        "id": 2674,
                        "name": "Mauer bei Amstetten",
                        "latitude": "48.09643000",
                        "longitude": "14.80060000"
                    },
                    {
                        "id": 2675,
                        "name": "Mauerbach",
                        "latitude": "48.24514000",
                        "longitude": "16.16793000"
                    },
                    {
                        "id": 2679,
                        "name": "Mautern",
                        "latitude": "48.39319000",
                        "longitude": "15.57793000"
                    },
                    {
                        "id": 2688,
                        "name": "Melk",
                        "latitude": "48.22737000",
                        "longitude": "15.33186000"
                    },
                    {
                        "id": 2698,
                        "name": "Michelhausen",
                        "latitude": "48.29085000",
                        "longitude": "15.93893000"
                    },
                    {
                        "id": 2701,
                        "name": "Miesenbach",
                        "latitude": "47.84035000",
                        "longitude": "15.98236000"
                    },
                    {
                        "id": 2706,
                        "name": "Mistelbach",
                        "latitude": "48.57000000",
                        "longitude": "16.57667000"
                    },
                    {
                        "id": 2708,
                        "name": "Mitterbach am Erlaufsee",
                        "latitude": "47.81396000",
                        "longitude": "15.29537000"
                    },
                    {
                        "id": 2716,
                        "name": "Mitterndorf an der Fischa",
                        "latitude": "47.99739000",
                        "longitude": "16.47357000"
                    },
                    {
                        "id": 2740,
                        "name": "Mödling",
                        "latitude": "48.08605000",
                        "longitude": "16.28921000"
                    },
                    {
                        "id": 2744,
                        "name": "Möllersdorf",
                        "latitude": "48.02575000",
                        "longitude": "16.30508000"
                    },
                    {
                        "id": 2746,
                        "name": "Mönichkirchen",
                        "latitude": "47.51062000",
                        "longitude": "16.03425000"
                    },
                    {
                        "id": 2725,
                        "name": "Moosbrunn",
                        "latitude": "48.01667000",
                        "longitude": "16.45000000"
                    },
                    {
                        "id": 2731,
                        "name": "Muckendorf an der Donau",
                        "latitude": "48.33183000",
                        "longitude": "16.15540000"
                    },
                    {
                        "id": 2732,
                        "name": "Muggendorf",
                        "latitude": "47.91059000",
                        "longitude": "15.93533000"
                    },
                    {
                        "id": 2756,
                        "name": "Mühldorf",
                        "latitude": "48.37432000",
                        "longitude": "15.34672000"
                    },
                    {
                        "id": 2761,
                        "name": "Münchendorf",
                        "latitude": "48.03333000",
                        "longitude": "16.38333000"
                    },
                    {
                        "id": 2777,
                        "name": "Neidling",
                        "latitude": "48.24005000",
                        "longitude": "15.55591000"
                    },
                    {
                        "id": 2783,
                        "name": "Neu-Guntramsdorf",
                        "latitude": "48.06420000",
                        "longitude": "16.31573000"
                    },
                    {
                        "id": 2789,
                        "name": "Neudorf bei Staatz",
                        "latitude": "48.72083000",
                        "longitude": "16.49139000"
                    },
                    {
                        "id": 2793,
                        "name": "Neufurth",
                        "latitude": "48.07894000",
                        "longitude": "14.81180000"
                    },
                    {
                        "id": 2797,
                        "name": "Neuhofen an der Ybbs",
                        "latitude": "48.05795000",
                        "longitude": "14.85489000"
                    },
                    {
                        "id": 2803,
                        "name": "Neulengbach",
                        "latitude": "48.19745000",
                        "longitude": "15.90219000"
                    },
                    {
                        "id": 2805,
                        "name": "Neumarkt an der Ybbs",
                        "latitude": "48.14103000",
                        "longitude": "15.05758000"
                    },
                    {
                        "id": 2809,
                        "name": "Neunkirchen",
                        "latitude": "47.72096000",
                        "longitude": "16.08107000"
                    },
                    {
                        "id": 2810,
                        "name": "Neusiedl",
                        "latitude": "47.88769000",
                        "longitude": "15.96313000"
                    },
                    {
                        "id": 2812,
                        "name": "Neusiedl an der Zaya",
                        "latitude": "48.59920000",
                        "longitude": "16.77990000"
                    },
                    {
                        "id": 2824,
                        "name": "Niederhollabrunn",
                        "latitude": "48.43333000",
                        "longitude": "16.30000000"
                    },
                    {
                        "id": 2825,
                        "name": "Niederleis",
                        "latitude": "48.55000000",
                        "longitude": "16.40000000"
                    },
                    {
                        "id": 2839,
                        "name": "Nöchling",
                        "latitude": "48.22433000",
                        "longitude": "14.98123000"
                    },
                    {
                        "id": 2843,
                        "name": "Ober-Grafendorf",
                        "latitude": "48.15040000",
                        "longitude": "15.54531000"
                    },
                    {
                        "id": 2854,
                        "name": "Oberhausen",
                        "latitude": "48.17690000",
                        "longitude": "16.58506000"
                    },
                    {
                        "id": 2863,
                        "name": "Oberndorf an der Melk",
                        "latitude": "48.06386000",
                        "longitude": "15.22430000"
                    },
                    {
                        "id": 2867,
                        "name": "Oberndorf in der Ebene",
                        "latitude": "48.27040000",
                        "longitude": "15.68985000"
                    },
                    {
                        "id": 2874,
                        "name": "Obersdorf",
                        "latitude": "48.36667000",
                        "longitude": "16.51667000"
                    },
                    {
                        "id": 2875,
                        "name": "Obersiebenbrunn",
                        "latitude": "48.26537000",
                        "longitude": "16.71076000"
                    },
                    {
                        "id": 2881,
                        "name": "Oberwagram",
                        "latitude": "48.20157000",
                        "longitude": "15.64917000"
                    },
                    {
                        "id": 2882,
                        "name": "Oberwaltersdorf",
                        "latitude": "47.97567000",
                        "longitude": "16.32191000"
                    },
                    {
                        "id": 2886,
                        "name": "Oberwölbling",
                        "latitude": "48.31719000",
                        "longitude": "15.59166000"
                    },
                    {
                        "id": 2891,
                        "name": "Oehling",
                        "latitude": "48.10000000",
                        "longitude": "14.80000000"
                    },
                    {
                        "id": 2894,
                        "name": "Oeynhausen",
                        "latitude": "47.98533000",
                        "longitude": "16.29187000"
                    },
                    {
                        "id": 2901,
                        "name": "Opponitz",
                        "latitude": "47.87776000",
                        "longitude": "14.82283000"
                    },
                    {
                        "id": 2904,
                        "name": "Orth an der Donau",
                        "latitude": "48.14524000",
                        "longitude": "16.70089000"
                    },
                    {
                        "id": 2910,
                        "name": "Ottenschlag",
                        "latitude": "48.42393000",
                        "longitude": "15.21924000"
                    },
                    {
                        "id": 2913,
                        "name": "Ottenthal",
                        "latitude": "48.76100000",
                        "longitude": "16.57914000"
                    },
                    {
                        "id": 2914,
                        "name": "Otterthal",
                        "latitude": "47.61667000",
                        "longitude": "15.93333000"
                    },
                    {
                        "id": 2923,
                        "name": "Parbasdorf",
                        "latitude": "48.28333000",
                        "longitude": "16.60000000"
                    },
                    {
                        "id": 2931,
                        "name": "Paudorf",
                        "latitude": "48.35416000",
                        "longitude": "15.61853000"
                    },
                    {
                        "id": 2932,
                        "name": "Payerbach",
                        "latitude": "47.69209000",
                        "longitude": "15.86340000"
                    },
                    {
                        "id": 2935,
                        "name": "Penz",
                        "latitude": "48.03333000",
                        "longitude": "14.48333000"
                    },
                    {
                        "id": 2937,
                        "name": "Perchtoldsdorf",
                        "latitude": "48.11935000",
                        "longitude": "16.26607000"
                    },
                    {
                        "id": 2940,
                        "name": "Pernegg",
                        "latitude": "48.73333000",
                        "longitude": "15.61667000"
                    },
                    {
                        "id": 2942,
                        "name": "Pernersdorf",
                        "latitude": "48.70000000",
                        "longitude": "16.01667000"
                    },
                    {
                        "id": 2943,
                        "name": "Pernitz",
                        "latitude": "47.89759000",
                        "longitude": "15.96022000"
                    },
                    {
                        "id": 2944,
                        "name": "Persenbeug",
                        "latitude": "48.18733000",
                        "longitude": "15.08809000"
                    },
                    {
                        "id": 2947,
                        "name": "Petronell-Carnuntum",
                        "latitude": "48.11296000",
                        "longitude": "16.86582000"
                    },
                    {
                        "id": 2951,
                        "name": "Petzenkirchen",
                        "latitude": "48.14693000",
                        "longitude": "15.15465000"
                    },
                    {
                        "id": 2955,
                        "name": "Pfaffstätten",
                        "latitude": "48.01737000",
                        "longitude": "16.26354000"
                    },
                    {
                        "id": 2970,
                        "name": "Pillichsdorf",
                        "latitude": "48.35000000",
                        "longitude": "16.53333000"
                    },
                    {
                        "id": 2980,
                        "name": "Pitten",
                        "latitude": "47.71667000",
                        "longitude": "16.18333000"
                    },
                    {
                        "id": 3103,
                        "name": "Pöchlarn",
                        "latitude": "48.20000000",
                        "longitude": "15.20000000"
                    },
                    {
                        "id": 3104,
                        "name": "Pöggstall",
                        "latitude": "48.31734000",
                        "longitude": "15.20405000"
                    },
                    {
                        "id": 2987,
                        "name": "Politischer Bezirk Amstetten",
                        "latitude": "48.00000000",
                        "longitude": "14.76667000"
                    },
                    {
                        "id": 2988,
                        "name": "Politischer Bezirk Baden",
                        "latitude": "47.97729000",
                        "longitude": "16.19845000"
                    },
                    {
                        "id": 2992,
                        "name": "Politischer Bezirk Bruck an der Leitha",
                        "latitude": "48.06781000",
                        "longitude": "16.77284000"
                    },
                    {
                        "id": 3004,
                        "name": "Politischer Bezirk Gänserndorf",
                        "latitude": "48.39340000",
                        "longitude": "16.73892000"
                    },
                    {
                        "id": 3001,
                        "name": "Politischer Bezirk Gmünd",
                        "latitude": "48.74732000",
                        "longitude": "14.98166000"
                    },
                    {
                        "id": 3009,
                        "name": "Politischer Bezirk Hollabrunn",
                        "latitude": "48.65286000",
                        "longitude": "15.99701000"
                    },
                    {
                        "id": 3010,
                        "name": "Politischer Bezirk Horn",
                        "latitude": "48.71341000",
                        "longitude": "15.68712000"
                    },
                    {
                        "id": 3017,
                        "name": "Politischer Bezirk Korneuburg",
                        "latitude": "48.44343000",
                        "longitude": "16.24120000"
                    },
                    {
                        "id": 3018,
                        "name": "Politischer Bezirk Krems",
                        "latitude": "48.46582000",
                        "longitude": "15.52093000"
                    },
                    {
                        "id": 3025,
                        "name": "Politischer Bezirk Lilienfeld",
                        "latitude": "47.91667000",
                        "longitude": "15.60000000"
                    },
                    {
                        "id": 3028,
                        "name": "Politischer Bezirk Melk",
                        "latitude": "48.21314000",
                        "longitude": "15.24282000"
                    },
                    {
                        "id": 3029,
                        "name": "Politischer Bezirk Mistelbach",
                        "latitude": "48.59436000",
                        "longitude": "16.54730000"
                    },
                    {
                        "id": 3032,
                        "name": "Politischer Bezirk Mödling",
                        "latitude": "48.08517000",
                        "longitude": "16.24118000"
                    },
                    {
                        "id": 3033,
                        "name": "Politischer Bezirk Neunkirchen",
                        "latitude": "47.69424000",
                        "longitude": "15.93783000"
                    },
                    {
                        "id": 3043,
                        "name": "Politischer Bezirk Sankt Pölten",
                        "latitude": "48.16905000",
                        "longitude": "15.66508000"
                    },
                    {
                        "id": 3045,
                        "name": "Politischer Bezirk Scheibbs",
                        "latitude": "47.92316000",
                        "longitude": "15.10376000"
                    },
                    {
                        "id": 3052,
                        "name": "Politischer Bezirk Tulln",
                        "latitude": "48.30000000",
                        "longitude": "16.00000000"
                    },
                    {
                        "id": 3058,
                        "name": "Politischer Bezirk Waidhofen an der Thaya",
                        "latitude": "48.85925000",
                        "longitude": "15.35814000"
                    },
                    {
                        "id": 3060,
                        "name": "Politischer Bezirk Wiener Neustadt",
                        "latitude": "47.83203000",
                        "longitude": "16.14291000"
                    },
                    {
                        "id": 3063,
                        "name": "Politischer Bezirk Zwettl",
                        "latitude": "48.57435000",
                        "longitude": "15.17159000"
                    },
                    {
                        "id": 3066,
                        "name": "Pottenbrunn",
                        "latitude": "48.23333000",
                        "longitude": "15.70000000"
                    },
                    {
                        "id": 3067,
                        "name": "Pottendorf",
                        "latitude": "47.90000000",
                        "longitude": "16.38333000"
                    },
                    {
                        "id": 3068,
                        "name": "Pottenstein",
                        "latitude": "47.95820000",
                        "longitude": "16.09480000"
                    },
                    {
                        "id": 3069,
                        "name": "Pottschach",
                        "latitude": "47.69856000",
                        "longitude": "16.00725000"
                    },
                    {
                        "id": 3071,
                        "name": "Poysdorf",
                        "latitude": "48.66667000",
                        "longitude": "16.63333000"
                    },
                    {
                        "id": 3079,
                        "name": "Prellenkirchen",
                        "latitude": "48.07401000",
                        "longitude": "16.95233000"
                    },
                    {
                        "id": 3080,
                        "name": "Pressbaum",
                        "latitude": "48.18333000",
                        "longitude": "16.08333000"
                    },
                    {
                        "id": 3082,
                        "name": "Prigglitz",
                        "latitude": "47.70318000",
                        "longitude": "15.92794000"
                    },
                    {
                        "id": 3083,
                        "name": "Prinzersdorf",
                        "latitude": "48.20000000",
                        "longitude": "15.51667000"
                    },
                    {
                        "id": 3085,
                        "name": "Prottes",
                        "latitude": "48.38680000",
                        "longitude": "16.73890000"
                    },
                    {
                        "id": 3090,
                        "name": "Puchberg am Schneeberg",
                        "latitude": "47.78709000",
                        "longitude": "15.91352000"
                    },
                    {
                        "id": 3092,
                        "name": "Puchenstuben",
                        "latitude": "47.92819000",
                        "longitude": "15.28748000"
                    },
                    {
                        "id": 3096,
                        "name": "Pulkau",
                        "latitude": "48.70484000",
                        "longitude": "15.86031000"
                    },
                    {
                        "id": 3099,
                        "name": "Purgstall",
                        "latitude": "48.05841000",
                        "longitude": "15.13478000"
                    },
                    {
                        "id": 3100,
                        "name": "Purkersdorf",
                        "latitude": "48.20769000",
                        "longitude": "16.17539000"
                    },
                    {
                        "id": 3102,
                        "name": "Pyhra",
                        "latitude": "48.15910000",
                        "longitude": "15.68624000"
                    },
                    {
                        "id": 3116,
                        "name": "Raabs an der Thaya",
                        "latitude": "48.85000000",
                        "longitude": "15.50000000"
                    },
                    {
                        "id": 3117,
                        "name": "Raach am Hochgebirge",
                        "latitude": "47.63333000",
                        "longitude": "15.93333000"
                    },
                    {
                        "id": 3118,
                        "name": "Raasdorf",
                        "latitude": "48.24657000",
                        "longitude": "16.56532000"
                    },
                    {
                        "id": 3119,
                        "name": "Rabensburg",
                        "latitude": "48.65000000",
                        "longitude": "16.90000000"
                    },
                    {
                        "id": 3120,
                        "name": "Rabenstein an der Pielach",
                        "latitude": "48.06535000",
                        "longitude": "15.46772000"
                    },
                    {
                        "id": 3133,
                        "name": "Ramsau",
                        "latitude": "48.00313000",
                        "longitude": "15.80332000"
                    },
                    {
                        "id": 3136,
                        "name": "Randegg",
                        "latitude": "48.01198000",
                        "longitude": "14.97334000"
                    },
                    {
                        "id": 3141,
                        "name": "Rannersdorf",
                        "latitude": "48.12772000",
                        "longitude": "16.46379000"
                    },
                    {
                        "id": 3144,
                        "name": "Rappottenstein",
                        "latitude": "48.52161000",
                        "longitude": "15.07925000"
                    },
                    {
                        "id": 3146,
                        "name": "Rastenfeld",
                        "latitude": "48.57348000",
                        "longitude": "15.33176000"
                    },
                    {
                        "id": 3151,
                        "name": "Ratzersdorf an der Traisen",
                        "latitude": "48.22639000",
                        "longitude": "15.66629000"
                    },
                    {
                        "id": 3152,
                        "name": "Rauchenwarth",
                        "latitude": "48.08330000",
                        "longitude": "16.52794000"
                    },
                    {
                        "id": 3154,
                        "name": "Ravelsbach",
                        "latitude": "48.55000000",
                        "longitude": "15.85000000"
                    },
                    {
                        "id": 3155,
                        "name": "Raxendorf",
                        "latitude": "48.34108000",
                        "longitude": "15.27666000"
                    },
                    {
                        "id": 3161,
                        "name": "Rehberg",
                        "latitude": "48.43114000",
                        "longitude": "15.58702000"
                    },
                    {
                        "id": 3162,
                        "name": "Reichenau an der Rax",
                        "latitude": "47.69509000",
                        "longitude": "15.84572000"
                    },
                    {
                        "id": 3170,
                        "name": "Reingers",
                        "latitude": "48.96667000",
                        "longitude": "15.13333000"
                    },
                    {
                        "id": 3171,
                        "name": "Reinsberg",
                        "latitude": "47.98567000",
                        "longitude": "15.07067000"
                    },
                    {
                        "id": 3172,
                        "name": "Reisenberg",
                        "latitude": "47.99406000",
                        "longitude": "16.52018000"
                    },
                    {
                        "id": 3181,
                        "name": "Retz",
                        "latitude": "48.75712000",
                        "longitude": "15.95485000"
                    },
                    {
                        "id": 3199,
                        "name": "Rohr im Gebirge",
                        "latitude": "47.89471000",
                        "longitude": "15.73603000"
                    },
                    {
                        "id": 3201,
                        "name": "Rohrau",
                        "latitude": "48.06667000",
                        "longitude": "16.85000000"
                    },
                    {
                        "id": 3202,
                        "name": "Rohrbach an der Gölsen",
                        "latitude": "48.04699000",
                        "longitude": "15.74169000"
                    },
                    {
                        "id": 3223,
                        "name": "Röhrenbach",
                        "latitude": "48.65000000",
                        "longitude": "15.50000000"
                    },
                    {
                        "id": 3207,
                        "name": "Rohrendorf bei Krems",
                        "latitude": "48.41935000",
                        "longitude": "15.65772000"
                    },
                    {
                        "id": 3225,
                        "name": "Röschitz",
                        "latitude": "48.64312000",
                        "longitude": "15.81774000"
                    },
                    {
                        "id": 3211,
                        "name": "Rosenau am Sonntagberg",
                        "latitude": "48.00778000",
                        "longitude": "14.73927000"
                    },
                    {
                        "id": 3219,
                        "name": "Ruprechtshofen",
                        "latitude": "48.13648000",
                        "longitude": "15.27675000"
                    },
                    {
                        "id": 3233,
                        "name": "Sallingberg",
                        "latitude": "48.46667000",
                        "longitude": "15.23333000"
                    },
                    {
                        "id": 3238,
                        "name": "Sankt Aegyd am Neuwalde",
                        "latitude": "47.85383000",
                        "longitude": "15.56969000"
                    },
                    {
                        "id": 3242,
                        "name": "Sankt Andrä vor dem Hagenthale",
                        "latitude": "48.32202000",
                        "longitude": "16.20724000"
                    },
                    {
                        "id": 3247,
                        "name": "Sankt Corona am Wechsel",
                        "latitude": "47.58333000",
                        "longitude": "16.00000000"
                    },
                    {
                        "id": 3254,
                        "name": "Sankt Georgen am Ybbsfelde",
                        "latitude": "48.12892000",
                        "longitude": "14.95364000"
                    },
                    {
                        "id": 3256,
                        "name": "Sankt Georgen an der Leys",
                        "latitude": "48.03149000",
                        "longitude": "15.22722000"
                    },
                    {
                        "id": 3281,
                        "name": "Sankt Leonhard am Forst",
                        "latitude": "48.14232000",
                        "longitude": "15.28464000"
                    },
                    {
                        "id": 3282,
                        "name": "Sankt Leonhard am Hornerwald",
                        "latitude": "48.60000000",
                        "longitude": "15.53333000"
                    },
                    {
                        "id": 3295,
                        "name": "Sankt Margarethen an der Sierning",
                        "latitude": "48.15910000",
                        "longitude": "15.49055000"
                    },
                    {
                        "id": 3304,
                        "name": "Sankt Martin am Ybbsfelde",
                        "latitude": "48.16425000",
                        "longitude": "15.02076000"
                    },
                    {
                        "id": 3318,
                        "name": "Sankt Pantaleon",
                        "latitude": "48.21058000",
                        "longitude": "14.56804000"
                    },
                    {
                        "id": 3326,
                        "name": "Sankt Peter in der Au Markt",
                        "latitude": "48.04400000",
                        "longitude": "14.62182000"
                    },
                    {
                        "id": 3329,
                        "name": "Sankt Pölten",
                        "latitude": "48.20000000",
                        "longitude": "15.63333000"
                    },
                    {
                        "id": 3330,
                        "name": "Sankt Pölten Stadt",
                        "latitude": "48.20000000",
                        "longitude": "15.61667000"
                    },
                    {
                        "id": 3341,
                        "name": "Sankt Valentin",
                        "latitude": "48.16667000",
                        "longitude": "14.51667000"
                    },
                    {
                        "id": 3344,
                        "name": "Sankt Veit an der Gölsen",
                        "latitude": "48.04320000",
                        "longitude": "15.66942000"
                    },
                    {
                        "id": 3359,
                        "name": "Scharndorf",
                        "latitude": "48.09399000",
                        "longitude": "16.79883000"
                    },
                    {
                        "id": 3366,
                        "name": "Scheibbs",
                        "latitude": "48.00474000",
                        "longitude": "15.16817000"
                    },
                    {
                        "id": 3376,
                        "name": "Schleinbach",
                        "latitude": "48.41667000",
                        "longitude": "16.46667000"
                    },
                    {
                        "id": 3416,
                        "name": "Schönau an der Triesting",
                        "latitude": "47.93452000",
                        "longitude": "16.25376000"
                    },
                    {
                        "id": 3417,
                        "name": "Schönbach",
                        "latitude": "48.45000000",
                        "longitude": "15.03333000"
                    },
                    {
                        "id": 3421,
                        "name": "Schönkirchen-Reyersdorf",
                        "latitude": "48.35477000",
                        "longitude": "16.69115000"
                    },
                    {
                        "id": 3384,
                        "name": "Schottwien",
                        "latitude": "47.65683000",
                        "longitude": "15.87250000"
                    },
                    {
                        "id": 3385,
                        "name": "Schrattenbach",
                        "latitude": "47.77902000",
                        "longitude": "15.99060000"
                    },
                    {
                        "id": 3386,
                        "name": "Schrattenberg",
                        "latitude": "48.72359000",
                        "longitude": "16.72201000"
                    },
                    {
                        "id": 3387,
                        "name": "Schrattenthal",
                        "latitude": "48.70000000",
                        "longitude": "15.90000000"
                    },
                    {
                        "id": 3388,
                        "name": "Schrems",
                        "latitude": "48.78333000",
                        "longitude": "15.06667000"
                    },
                    {
                        "id": 3392,
                        "name": "Schwadorf",
                        "latitude": "48.06936000",
                        "longitude": "16.57957000"
                    },
                    {
                        "id": 3397,
                        "name": "Schwarzau am Steinfeld",
                        "latitude": "47.73183000",
                        "longitude": "16.17094000"
                    },
                    {
                        "id": 3398,
                        "name": "Schwarzau im Gebirge",
                        "latitude": "47.81223000",
                        "longitude": "15.70581000"
                    },
                    {
                        "id": 3400,
                        "name": "Schwarzenau",
                        "latitude": "48.74436000",
                        "longitude": "15.25838000"
                    },
                    {
                        "id": 3401,
                        "name": "Schwarzenbach",
                        "latitude": "47.63547000",
                        "longitude": "16.35109000"
                    },
                    {
                        "id": 3402,
                        "name": "Schwarzenbach an der Pielach",
                        "latitude": "47.93333000",
                        "longitude": "15.38333000"
                    },
                    {
                        "id": 3405,
                        "name": "Schwechat",
                        "latitude": "48.13333000",
                        "longitude": "16.46667000"
                    },
                    {
                        "id": 3406,
                        "name": "Schweiggers",
                        "latitude": "48.66667000",
                        "longitude": "15.06667000"
                    },
                    {
                        "id": 3429,
                        "name": "Seebenstein",
                        "latitude": "47.69936000",
                        "longitude": "16.14484000"
                    },
                    {
                        "id": 3437,
                        "name": "Seibersdorf",
                        "latitude": "47.95858000",
                        "longitude": "16.51842000"
                    },
                    {
                        "id": 3440,
                        "name": "Seitenstetten Markt",
                        "latitude": "48.03333000",
                        "longitude": "14.65000000"
                    },
                    {
                        "id": 3443,
                        "name": "Semmering",
                        "latitude": "47.63347000",
                        "longitude": "15.82993000"
                    },
                    {
                        "id": 3445,
                        "name": "Senftenberg",
                        "latitude": "48.43333000",
                        "longitude": "15.55000000"
                    },
                    {
                        "id": 3447,
                        "name": "Seyring",
                        "latitude": "48.33333000",
                        "longitude": "16.48333000"
                    },
                    {
                        "id": 3452,
                        "name": "Sieghartskirchen",
                        "latitude": "48.25531000",
                        "longitude": "16.01223000"
                    },
                    {
                        "id": 3453,
                        "name": "Sierndorf",
                        "latitude": "48.43024000",
                        "longitude": "16.16658000"
                    },
                    {
                        "id": 3457,
                        "name": "Sigmundsherberg",
                        "latitude": "48.68333000",
                        "longitude": "15.75000000"
                    },
                    {
                        "id": 3465,
                        "name": "Sitzendorf an der Schmida",
                        "latitude": "48.59841000",
                        "longitude": "15.94254000"
                    },
                    {
                        "id": 3467,
                        "name": "Sollenau",
                        "latitude": "47.89834000",
                        "longitude": "16.24833000"
                    },
                    {
                        "id": 3468,
                        "name": "Sommerein",
                        "latitude": "47.98333000",
                        "longitude": "16.65000000"
                    },
                    {
                        "id": 3470,
                        "name": "Sonntagberg",
                        "latitude": "47.99561000",
                        "longitude": "14.76065000"
                    },
                    {
                        "id": 3471,
                        "name": "Sooss",
                        "latitude": "47.98464000",
                        "longitude": "16.21737000"
                    },
                    {
                        "id": 3472,
                        "name": "Spannberg",
                        "latitude": "48.46393000",
                        "longitude": "16.73647000"
                    },
                    {
                        "id": 3476,
                        "name": "Spillern",
                        "latitude": "48.38333000",
                        "longitude": "16.25000000"
                    },
                    {
                        "id": 3480,
                        "name": "Spitz",
                        "latitude": "48.36560000",
                        "longitude": "15.41416000"
                    },
                    {
                        "id": 3481,
                        "name": "Spratzern",
                        "latitude": "48.17044000",
                        "longitude": "15.61844000"
                    },
                    {
                        "id": 3487,
                        "name": "Staatz",
                        "latitude": "48.67617000",
                        "longitude": "16.48726000"
                    },
                    {
                        "id": 3506,
                        "name": "Stattersdorf",
                        "latitude": "48.18333000",
                        "longitude": "15.63333000"
                    },
                    {
                        "id": 3507,
                        "name": "Statzendorf",
                        "latitude": "48.30752000",
                        "longitude": "15.64127000"
                    },
                    {
                        "id": 3511,
                        "name": "Stein an der Donau",
                        "latitude": "48.40163000",
                        "longitude": "15.58102000"
                    },
                    {
                        "id": 3512,
                        "name": "Steinabrückl",
                        "latitude": "47.87053000",
                        "longitude": "16.20277000"
                    },
                    {
                        "id": 3514,
                        "name": "Steinakirchen am Forst",
                        "latitude": "48.06965000",
                        "longitude": "15.04801000"
                    },
                    {
                        "id": 3523,
                        "name": "Stephanshart",
                        "latitude": "48.15000000",
                        "longitude": "14.81667000"
                    },
                    {
                        "id": 3524,
                        "name": "Stetteldorf am Wagram",
                        "latitude": "48.40815000",
                        "longitude": "16.01862000"
                    },
                    {
                        "id": 3525,
                        "name": "Stetten",
                        "latitude": "48.36667000",
                        "longitude": "16.38333000"
                    },
                    {
                        "id": 3533,
                        "name": "Stockerau",
                        "latitude": "48.38333000",
                        "longitude": "16.21667000"
                    },
                    {
                        "id": 3534,
                        "name": "Stollhofen",
                        "latitude": "48.35226000",
                        "longitude": "15.75963000"
                    },
                    {
                        "id": 3560,
                        "name": "Stössing",
                        "latitude": "48.12267000",
                        "longitude": "15.81379000"
                    },
                    {
                        "id": 3539,
                        "name": "Strass",
                        "latitude": "48.46667000",
                        "longitude": "15.73333000"
                    },
                    {
                        "id": 3544,
                        "name": "Strasshof an der Nordbahn",
                        "latitude": "48.31667000",
                        "longitude": "16.66667000"
                    },
                    {
                        "id": 3546,
                        "name": "Stratzing",
                        "latitude": "48.45000000",
                        "longitude": "15.60000000"
                    },
                    {
                        "id": 3551,
                        "name": "Strengberg",
                        "latitude": "48.14685000",
                        "longitude": "14.65147000"
                    },
                    {
                        "id": 3554,
                        "name": "Stronsdorf",
                        "latitude": "48.65157000",
                        "longitude": "16.29890000"
                    },
                    {
                        "id": 3573,
                        "name": "Tattendorf",
                        "latitude": "47.95000000",
                        "longitude": "16.30000000"
                    },
                    {
                        "id": 3579,
                        "name": "Teesdorf",
                        "latitude": "47.95000000",
                        "longitude": "16.28333000"
                    },
                    {
                        "id": 3584,
                        "name": "Ternitz",
                        "latitude": "47.71565000",
                        "longitude": "16.03575000"
                    },
                    {
                        "id": 3590,
                        "name": "Thaya",
                        "latitude": "48.85489000",
                        "longitude": "15.28902000"
                    },
                    {
                        "id": 3591,
                        "name": "Theresienfeld",
                        "latitude": "47.85000000",
                        "longitude": "16.23333000"
                    },
                    {
                        "id": 3592,
                        "name": "Thomasberg",
                        "latitude": "47.56667000",
                        "longitude": "16.13333000"
                    },
                    {
                        "id": 3598,
                        "name": "Tiefenbach",
                        "latitude": "47.53540000",
                        "longitude": "16.21346000"
                    },
                    {
                        "id": 3609,
                        "name": "Traisen",
                        "latitude": "48.03333000",
                        "longitude": "15.60000000"
                    },
                    {
                        "id": 3610,
                        "name": "Traiskirchen",
                        "latitude": "48.01485000",
                        "longitude": "16.29324000"
                    },
                    {
                        "id": 3611,
                        "name": "Traismauer",
                        "latitude": "48.35000000",
                        "longitude": "15.73333000"
                    },
                    {
                        "id": 3612,
                        "name": "Trattenbach",
                        "latitude": "47.60000000",
                        "longitude": "15.86667000"
                    },
                    {
                        "id": 3616,
                        "name": "Trautmannsdorf an der Leitha",
                        "latitude": "48.02357000",
                        "longitude": "16.63266000"
                    },
                    {
                        "id": 3621,
                        "name": "Tribuswinkel",
                        "latitude": "48.00623000",
                        "longitude": "16.27075000"
                    },
                    {
                        "id": 3627,
                        "name": "Trumau",
                        "latitude": "47.99348000",
                        "longitude": "16.34268000"
                    },
                    {
                        "id": 3631,
                        "name": "Tulbing",
                        "latitude": "48.29336000",
                        "longitude": "16.12226000"
                    },
                    {
                        "id": 3633,
                        "name": "Tulln",
                        "latitude": "48.32829000",
                        "longitude": "16.05858000"
                    },
                    {
                        "id": 3634,
                        "name": "Tullnerbach-Lawies",
                        "latitude": "48.18912000",
                        "longitude": "16.09117000"
                    },
                    {
                        "id": 3638,
                        "name": "Türnitz",
                        "latitude": "47.93095000",
                        "longitude": "15.49295000"
                    },
                    {
                        "id": 3642,
                        "name": "Ulrichskirchen",
                        "latitude": "48.40000000",
                        "longitude": "16.48333000"
                    },
                    {
                        "id": 3660,
                        "name": "Untersiebenbrunn",
                        "latitude": "48.25000000",
                        "longitude": "16.73333000"
                    },
                    {
                        "id": 3661,
                        "name": "Unterstinkenbrunn",
                        "latitude": "48.66770000",
                        "longitude": "16.34607000"
                    },
                    {
                        "id": 3664,
                        "name": "Unterwagram",
                        "latitude": "48.21243000",
                        "longitude": "15.64951000"
                    },
                    {
                        "id": 3665,
                        "name": "Unterwaltersdorf",
                        "latitude": "47.95000000",
                        "longitude": "16.41667000"
                    },
                    {
                        "id": 3676,
                        "name": "Velm",
                        "latitude": "48.03333000",
                        "longitude": "16.43333000"
                    },
                    {
                        "id": 3680,
                        "name": "Viehofen",
                        "latitude": "48.21667000",
                        "longitude": "15.61667000"
                    },
                    {
                        "id": 3692,
                        "name": "Vitis",
                        "latitude": "48.75964000",
                        "longitude": "15.18259000"
                    },
                    {
                        "id": 3709,
                        "name": "Vösendorf",
                        "latitude": "48.12107000",
                        "longitude": "16.34036000"
                    },
                    {
                        "id": 3716,
                        "name": "Waidhofen an der Thaya",
                        "latitude": "48.81667000",
                        "longitude": "15.28333000"
                    },
                    {
                        "id": 3717,
                        "name": "Waidhofen an der Ybbs",
                        "latitude": "47.96004000",
                        "longitude": "14.77361000"
                    },
                    {
                        "id": 3718,
                        "name": "Waidhofen an der Ybbs Stadt",
                        "latitude": "47.95999000",
                        "longitude": "14.77438000"
                    },
                    {
                        "id": 3719,
                        "name": "Waidmannsfeld",
                        "latitude": "47.87042000",
                        "longitude": "15.98116000"
                    },
                    {
                        "id": 3727,
                        "name": "Waldegg",
                        "latitude": "47.86852000",
                        "longitude": "16.05154000"
                    },
                    {
                        "id": 3728,
                        "name": "Waldenstein",
                        "latitude": "48.72845000",
                        "longitude": "15.01419000"
                    },
                    {
                        "id": 3729,
                        "name": "Waldhausen",
                        "latitude": "48.52183000",
                        "longitude": "15.26250000"
                    },
                    {
                        "id": 3732,
                        "name": "Waldkirchen an der Thaya",
                        "latitude": "48.93333000",
                        "longitude": "15.35000000"
                    },
                    {
                        "id": 3738,
                        "name": "Wallsee",
                        "latitude": "48.16667000",
                        "longitude": "14.71667000"
                    },
                    {
                        "id": 3739,
                        "name": "Walpersbach",
                        "latitude": "47.71667000",
                        "longitude": "16.23333000"
                    },
                    {
                        "id": 3743,
                        "name": "Wang",
                        "latitude": "48.04538000",
                        "longitude": "15.02672000"
                    },
                    {
                        "id": 3748,
                        "name": "Warth",
                        "latitude": "47.65000000",
                        "longitude": "16.11667000"
                    },
                    {
                        "id": 3750,
                        "name": "Wartmannstetten",
                        "latitude": "47.69359000",
                        "longitude": "16.07506000"
                    },
                    {
                        "id": 3759,
                        "name": "Weidling",
                        "latitude": "48.29100000",
                        "longitude": "16.30865000"
                    },
                    {
                        "id": 3760,
                        "name": "Weigelsdorf",
                        "latitude": "47.95000000",
                        "longitude": "16.40000000"
                    },
                    {
                        "id": 3761,
                        "name": "Weikendorf",
                        "latitude": "48.34438000",
                        "longitude": "16.76651000"
                    },
                    {
                        "id": 3762,
                        "name": "Weikersdorf am Steinfelde",
                        "latitude": "47.80612000",
                        "longitude": "16.14389000"
                    },
                    {
                        "id": 3765,
                        "name": "Weinburg",
                        "latitude": "48.11351000",
                        "longitude": "15.53295000"
                    },
                    {
                        "id": 3768,
                        "name": "Weinzierl am Walde",
                        "latitude": "48.43211000",
                        "longitude": "15.43210000"
                    },
                    {
                        "id": 3769,
                        "name": "Weinzierl bei Krems",
                        "latitude": "48.40000000",
                        "longitude": "15.60000000"
                    },
                    {
                        "id": 3772,
                        "name": "Weissenbach an der Triesting",
                        "latitude": "47.98211000",
                        "longitude": "16.03935000"
                    },
                    {
                        "id": 3783,
                        "name": "Weißenkirchen in der Wachau",
                        "latitude": "48.39790000",
                        "longitude": "15.46931000"
                    },
                    {
                        "id": 3774,
                        "name": "Weistrach",
                        "latitude": "48.05000000",
                        "longitude": "14.58333000"
                    },
                    {
                        "id": 3775,
                        "name": "Weiten",
                        "latitude": "48.29564000",
                        "longitude": "15.26010000"
                    },
                    {
                        "id": 3777,
                        "name": "Weitersfeld",
                        "latitude": "48.78097000",
                        "longitude": "15.81345000"
                    },
                    {
                        "id": 3779,
                        "name": "Weitra",
                        "latitude": "48.70000000",
                        "longitude": "14.88333000"
                    },
                    {
                        "id": 3803,
                        "name": "Wiener Neudorf",
                        "latitude": "48.08278000",
                        "longitude": "16.31384000"
                    },
                    {
                        "id": 3804,
                        "name": "Wiener Neustadt",
                        "latitude": "47.80485000",
                        "longitude": "16.23196000"
                    },
                    {
                        "id": 3805,
                        "name": "Wiener Neustadt Stadt",
                        "latitude": "47.80000000",
                        "longitude": "16.25000000"
                    },
                    {
                        "id": 3806,
                        "name": "Wienersdorf",
                        "latitude": "48.00819000",
                        "longitude": "16.29169000"
                    },
                    {
                        "id": 3808,
                        "name": "Wieselburg",
                        "latitude": "48.13333000",
                        "longitude": "15.13333000"
                    },
                    {
                        "id": 3812,
                        "name": "Wiesmath",
                        "latitude": "47.61667000",
                        "longitude": "16.28333000"
                    },
                    {
                        "id": 3817,
                        "name": "Wilfersdorf",
                        "latitude": "48.58333000",
                        "longitude": "16.63333000"
                    },
                    {
                        "id": 3818,
                        "name": "Wilfleinsdorf",
                        "latitude": "48.01667000",
                        "longitude": "16.71667000"
                    },
                    {
                        "id": 3819,
                        "name": "Wilhelmsburg",
                        "latitude": "48.10571000",
                        "longitude": "15.60539000"
                    },
                    {
                        "id": 3820,
                        "name": "Willendorf am Steinfelde",
                        "latitude": "47.78929000",
                        "longitude": "16.05686000"
                    },
                    {
                        "id": 3824,
                        "name": "Wimpassing im Schwarzatale",
                        "latitude": "47.70295000",
                        "longitude": "16.03334000"
                    },
                    {
                        "id": 3829,
                        "name": "Windhag",
                        "latitude": "47.97906000",
                        "longitude": "14.80245000"
                    },
                    {
                        "id": 3830,
                        "name": "Windigsteig",
                        "latitude": "48.76667000",
                        "longitude": "15.28333000"
                    },
                    {
                        "id": 3832,
                        "name": "Winklarn",
                        "latitude": "48.09135000",
                        "longitude": "14.84819000"
                    },
                    {
                        "id": 3835,
                        "name": "Winzendorf",
                        "latitude": "47.81154000",
                        "longitude": "16.11300000"
                    },
                    {
                        "id": 3840,
                        "name": "Wolfpassing",
                        "latitude": "48.07785000",
                        "longitude": "15.06453000"
                    },
                    {
                        "id": 3841,
                        "name": "Wolfsbach",
                        "latitude": "48.06667000",
                        "longitude": "14.66667000"
                    },
                    {
                        "id": 3845,
                        "name": "Wolfsgraben",
                        "latitude": "48.15870000",
                        "longitude": "16.12098000"
                    },
                    {
                        "id": 3846,
                        "name": "Wolfsthal",
                        "latitude": "48.13333000",
                        "longitude": "17.00000000"
                    },
                    {
                        "id": 3848,
                        "name": "Wolkersdorf im Weinviertel",
                        "latitude": "48.38333000",
                        "longitude": "16.51667000"
                    },
                    {
                        "id": 3855,
                        "name": "Wöllersdorf",
                        "latitude": "47.86500000",
                        "longitude": "16.17119000"
                    },
                    {
                        "id": 3856,
                        "name": "Wördern",
                        "latitude": "48.33400000",
                        "longitude": "16.21016000"
                    },
                    {
                        "id": 3851,
                        "name": "Wullersdorf",
                        "latitude": "48.62792000",
                        "longitude": "16.10089000"
                    },
                    {
                        "id": 3861,
                        "name": "Würflach",
                        "latitude": "47.77648000",
                        "longitude": "16.05463000"
                    },
                    {
                        "id": 3862,
                        "name": "Würmla",
                        "latitude": "48.25497000",
                        "longitude": "15.86031000"
                    },
                    {
                        "id": 3863,
                        "name": "Ybbs an der Donau",
                        "latitude": "48.16667000",
                        "longitude": "15.08333000"
                    },
                    {
                        "id": 3864,
                        "name": "Ybbsitz",
                        "latitude": "47.94745000",
                        "longitude": "14.89180000"
                    },
                    {
                        "id": 3865,
                        "name": "Ysper",
                        "latitude": "48.28865000",
                        "longitude": "15.06131000"
                    },
                    {
                        "id": 3869,
                        "name": "Zeillern",
                        "latitude": "48.13029000",
                        "longitude": "14.80760000"
                    },
                    {
                        "id": 3870,
                        "name": "Zeiselmauer",
                        "latitude": "48.32852000",
                        "longitude": "16.17565000"
                    },
                    {
                        "id": 3877,
                        "name": "Zell-Arzberg",
                        "latitude": "47.95191000",
                        "longitude": "14.79322000"
                    },
                    {
                        "id": 3878,
                        "name": "Zell-Markt",
                        "latitude": "47.95878000",
                        "longitude": "14.78318000"
                    },
                    {
                        "id": 3880,
                        "name": "Zellerndorf",
                        "latitude": "48.69657000",
                        "longitude": "15.95841000"
                    },
                    {
                        "id": 3885,
                        "name": "Ziersdorf",
                        "latitude": "48.53030000",
                        "longitude": "15.92691000"
                    },
                    {
                        "id": 3886,
                        "name": "Zillingdorf",
                        "latitude": "47.85000000",
                        "longitude": "16.33333000"
                    },
                    {
                        "id": 3889,
                        "name": "Zistersdorf",
                        "latitude": "48.54252000",
                        "longitude": "16.76136000"
                    },
                    {
                        "id": 3895,
                        "name": "Zöbern",
                        "latitude": "47.51459000",
                        "longitude": "16.13111000"
                    },
                    {
                        "id": 3891,
                        "name": "Zwentendorf",
                        "latitude": "48.34530000",
                        "longitude": "15.91026000"
                    },
                    {
                        "id": 3892,
                        "name": "Zwettl Stadt",
                        "latitude": "48.60726000",
                        "longitude": "15.16714000"
                    },
                    {
                        "id": 3894,
                        "name": "Zwölfaxing",
                        "latitude": "48.10990000",
                        "longitude": "16.46267000"
                    }
                ]
            },
            {
                "id": 2061,
                "name": "Salzburg",
                "iso2": "5",
                "latitude": "47.80949000",
                "longitude": "13.05501000",
                "type": "state",
                "cities": [
                    {
                        "id": 1603,
                        "name": "Abtenau",
                        "latitude": "47.56373000",
                        "longitude": "13.34599000"
                    },
                    {
                        "id": 1611,
                        "name": "Adnet",
                        "latitude": "47.69746000",
                        "longitude": "13.13115000"
                    },
                    {
                        "id": 1644,
                        "name": "Altenmarkt im Pongau",
                        "latitude": "47.38333000",
                        "longitude": "13.41667000"
                    },
                    {
                        "id": 1663,
                        "name": "Anger",
                        "latitude": "47.15593000",
                        "longitude": "13.10592000"
                    },
                    {
                        "id": 1667,
                        "name": "Anif",
                        "latitude": "47.75000000",
                        "longitude": "13.06667000"
                    },
                    {
                        "id": 1672,
                        "name": "Anthering",
                        "latitude": "47.88333000",
                        "longitude": "13.01667000"
                    },
                    {
                        "id": 1702,
                        "name": "Au",
                        "latitude": "47.70000000",
                        "longitude": "13.06667000"
                    },
                    {
                        "id": 1722,
                        "name": "Bad Gastein",
                        "latitude": "47.11547000",
                        "longitude": "13.13467000"
                    },
                    {
                        "id": 1726,
                        "name": "Bad Hofgastein",
                        "latitude": "47.17274000",
                        "longitude": "13.09871000"
                    },
                    {
                        "id": 1758,
                        "name": "Bergheim",
                        "latitude": "47.83333000",
                        "longitude": "13.03333000"
                    },
                    {
                        "id": 1763,
                        "name": "Berndorf bei Salzburg",
                        "latitude": "47.99532000",
                        "longitude": "13.06146000"
                    },
                    {
                        "id": 1777,
                        "name": "Bischofshofen",
                        "latitude": "47.41667000",
                        "longitude": "13.21667000"
                    },
                    {
                        "id": 1789,
                        "name": "Bramberg am Wildkogel",
                        "latitude": "47.26979000",
                        "longitude": "12.33850000"
                    },
                    {
                        "id": 1808,
                        "name": "Bruck an der Großglocknerstraße",
                        "latitude": "47.28494000",
                        "longitude": "12.82310000"
                    },
                    {
                        "id": 1821,
                        "name": "Burgfried",
                        "latitude": "47.68004000",
                        "longitude": "13.11175000"
                    },
                    {
                        "id": 1826,
                        "name": "Bürmoos",
                        "latitude": "47.98343000",
                        "longitude": "12.91786000"
                    },
                    {
                        "id": 1848,
                        "name": "Dienten am Hochkönig",
                        "latitude": "47.38324000",
                        "longitude": "13.00369000"
                    },
                    {
                        "id": 1862,
                        "name": "Dorfbeuern",
                        "latitude": "48.01667000",
                        "longitude": "13.01667000"
                    },
                    {
                        "id": 1863,
                        "name": "Dorfgastein",
                        "latitude": "47.24172000",
                        "longitude": "13.10223000"
                    },
                    {
                        "id": 1882,
                        "name": "Eben im Pongau",
                        "latitude": "47.40000000",
                        "longitude": "13.40000000"
                    },
                    {
                        "id": 1883,
                        "name": "Ebenau",
                        "latitude": "47.79073000",
                        "longitude": "13.17527000"
                    },
                    {
                        "id": 1896,
                        "name": "Eching",
                        "latitude": "47.97263000",
                        "longitude": "12.88786000"
                    },
                    {
                        "id": 1929,
                        "name": "Elixhausen",
                        "latitude": "47.86667000",
                        "longitude": "13.06667000"
                    },
                    {
                        "id": 1933,
                        "name": "Elsbethen",
                        "latitude": "47.76464000",
                        "longitude": "13.08104000"
                    },
                    {
                        "id": 1953,
                        "name": "Esch",
                        "latitude": "47.84030000",
                        "longitude": "13.09223000"
                    },
                    {
                        "id": 1955,
                        "name": "Eugendorf",
                        "latitude": "47.86765000",
                        "longitude": "13.12609000"
                    },
                    {
                        "id": 1958,
                        "name": "Faistenau",
                        "latitude": "47.77767000",
                        "longitude": "13.23393000"
                    },
                    {
                        "id": 1986,
                        "name": "Filzmoos",
                        "latitude": "47.43333000",
                        "longitude": "13.51667000"
                    },
                    {
                        "id": 1994,
                        "name": "Flachau",
                        "latitude": "47.34406000",
                        "longitude": "13.39148000"
                    },
                    {
                        "id": 2007,
                        "name": "Forstau",
                        "latitude": "47.37842000",
                        "longitude": "13.55558000"
                    },
                    {
                        "id": 2031,
                        "name": "Fuschl am See",
                        "latitude": "47.80000000",
                        "longitude": "13.30000000"
                    },
                    {
                        "id": 2072,
                        "name": "Georgenberg",
                        "latitude": "47.63333000",
                        "longitude": "13.15000000"
                    },
                    {
                        "id": 2082,
                        "name": "Glanegg",
                        "latitude": "47.75000000",
                        "longitude": "13.00000000"
                    },
                    {
                        "id": 2084,
                        "name": "Glasenbach",
                        "latitude": "47.76667000",
                        "longitude": "13.08333000"
                    },
                    {
                        "id": 2103,
                        "name": "Golling an der Salzach",
                        "latitude": "47.60000000",
                        "longitude": "13.16667000"
                    },
                    {
                        "id": 2166,
                        "name": "Grödig",
                        "latitude": "47.73833000",
                        "longitude": "13.03730000"
                    },
                    {
                        "id": 2139,
                        "name": "Grossarl",
                        "latitude": "47.23333000",
                        "longitude": "13.20000000"
                    },
                    {
                        "id": 2140,
                        "name": "Grossgmain",
                        "latitude": "47.72416000",
                        "longitude": "12.90851000"
                    },
                    {
                        "id": 2202,
                        "name": "Habach",
                        "latitude": "47.81753000",
                        "longitude": "13.16252000"
                    },
                    {
                        "id": 2225,
                        "name": "Hallein",
                        "latitude": "47.68333000",
                        "longitude": "13.10000000"
                    },
                    {
                        "id": 2226,
                        "name": "Hallwang",
                        "latitude": "47.85000000",
                        "longitude": "13.08333000"
                    },
                    {
                        "id": 2269,
                        "name": "Henndorf am Wallersee",
                        "latitude": "47.90000000",
                        "longitude": "13.18333000"
                    },
                    {
                        "id": 2283,
                        "name": "Himmelreich",
                        "latitude": "47.80000000",
                        "longitude": "12.98333000"
                    },
                    {
                        "id": 2286,
                        "name": "Hinterglemm",
                        "latitude": "47.37685000",
                        "longitude": "12.59583000"
                    },
                    {
                        "id": 2288,
                        "name": "Hintersee",
                        "latitude": "47.70000000",
                        "longitude": "13.28333000"
                    },
                    {
                        "id": 2304,
                        "name": "Hof",
                        "latitude": "47.35000000",
                        "longitude": "13.31667000"
                    },
                    {
                        "id": 2306,
                        "name": "Hof bei Salzburg",
                        "latitude": "47.81929000",
                        "longitude": "13.21488000"
                    },
                    {
                        "id": 2325,
                        "name": "Hollersbach im Pinzgau",
                        "latitude": "47.27658000",
                        "longitude": "12.42326000"
                    },
                    {
                        "id": 2347,
                        "name": "Hüttau",
                        "latitude": "47.41610000",
                        "longitude": "13.30775000"
                    },
                    {
                        "id": 2349,
                        "name": "Hüttschlag",
                        "latitude": "47.17635000",
                        "longitude": "13.23239000"
                    },
                    {
                        "id": 2366,
                        "name": "Irrsdorf",
                        "latitude": "47.96667000",
                        "longitude": "13.28333000"
                    },
                    {
                        "id": 2404,
                        "name": "Kaprun",
                        "latitude": "47.27239000",
                        "longitude": "12.75985000"
                    },
                    {
                        "id": 2452,
                        "name": "Kleinarl",
                        "latitude": "47.27725000",
                        "longitude": "13.31955000"
                    },
                    {
                        "id": 2475,
                        "name": "Koppl",
                        "latitude": "47.80808000",
                        "longitude": "13.15561000"
                    },
                    {
                        "id": 2513,
                        "name": "Köstendorf",
                        "latitude": "47.95000000",
                        "longitude": "13.20000000"
                    },
                    {
                        "id": 2489,
                        "name": "Krimml",
                        "latitude": "47.21799000",
                        "longitude": "12.17487000"
                    },
                    {
                        "id": 2490,
                        "name": "Krispl",
                        "latitude": "47.71667000",
                        "longitude": "13.18333000"
                    },
                    {
                        "id": 2502,
                        "name": "Kuchl",
                        "latitude": "47.62647000",
                        "longitude": "13.14480000"
                    },
                    {
                        "id": 2529,
                        "name": "Lamprechtshausen",
                        "latitude": "47.99098000",
                        "longitude": "12.95481000"
                    },
                    {
                        "id": 2562,
                        "name": "Lehen",
                        "latitude": "47.87083000",
                        "longitude": "13.01722000"
                    },
                    {
                        "id": 2572,
                        "name": "Lend",
                        "latitude": "47.29856000",
                        "longitude": "13.05176000"
                    },
                    {
                        "id": 2576,
                        "name": "Lengfelden",
                        "latitude": "47.85000000",
                        "longitude": "13.05000000"
                    },
                    {
                        "id": 2581,
                        "name": "Leogang",
                        "latitude": "47.43906000",
                        "longitude": "12.76109000"
                    },
                    {
                        "id": 2609,
                        "name": "Lofer",
                        "latitude": "47.58475000",
                        "longitude": "12.69333000"
                    },
                    {
                        "id": 2627,
                        "name": "Maishofen",
                        "latitude": "47.36667000",
                        "longitude": "12.80000000"
                    },
                    {
                        "id": 2639,
                        "name": "Maria Alm am Steinernen Meer",
                        "latitude": "47.40579000",
                        "longitude": "12.90121000"
                    },
                    {
                        "id": 2653,
                        "name": "Mariapfarr",
                        "latitude": "47.15000000",
                        "longitude": "13.75000000"
                    },
                    {
                        "id": 2671,
                        "name": "Mattsee",
                        "latitude": "47.96667000",
                        "longitude": "13.10000000"
                    },
                    {
                        "id": 2681,
                        "name": "Mauterndorf",
                        "latitude": "47.13451000",
                        "longitude": "13.67884000"
                    },
                    {
                        "id": 2709,
                        "name": "Mitterberghütten",
                        "latitude": "47.40000000",
                        "longitude": "13.21667000"
                    },
                    {
                        "id": 2712,
                        "name": "Mitterhofen",
                        "latitude": "47.38333000",
                        "longitude": "12.80000000"
                    },
                    {
                        "id": 2719,
                        "name": "Mittersill",
                        "latitude": "47.28333000",
                        "longitude": "12.48333000"
                    },
                    {
                        "id": 2752,
                        "name": "Mühlbach am Hochkönig",
                        "latitude": "47.37746000",
                        "longitude": "13.12926000"
                    },
                    {
                        "id": 2784,
                        "name": "Neualm",
                        "latitude": "47.69336000",
                        "longitude": "13.08758000"
                    },
                    {
                        "id": 2799,
                        "name": "Neukirchen am Großvenediger",
                        "latitude": "47.25046000",
                        "longitude": "12.27585000"
                    },
                    {
                        "id": 2804,
                        "name": "Neumarkt am Wallersee",
                        "latitude": "47.95000000",
                        "longitude": "13.23333000"
                    },
                    {
                        "id": 2820,
                        "name": "Niederalm",
                        "latitude": "47.72872000",
                        "longitude": "13.06223000"
                    },
                    {
                        "id": 2828,
                        "name": "Niedernsill",
                        "latitude": "47.28333000",
                        "longitude": "12.65000000"
                    },
                    {
                        "id": 2838,
                        "name": "Nußdorf am Haunsberg",
                        "latitude": "47.95944000",
                        "longitude": "13.00917000"
                    },
                    {
                        "id": 2845,
                        "name": "Oberalm",
                        "latitude": "47.70000000",
                        "longitude": "13.10000000"
                    },
                    {
                        "id": 2850,
                        "name": "Obergäu",
                        "latitude": "47.58955000",
                        "longitude": "13.17621000"
                    },
                    {
                        "id": 2864,
                        "name": "Oberndorf bei Salzburg",
                        "latitude": "47.95000000",
                        "longitude": "12.93333000"
                    },
                    {
                        "id": 2878,
                        "name": "Obertrum am See",
                        "latitude": "47.93722000",
                        "longitude": "13.07722000"
                    },
                    {
                        "id": 2957,
                        "name": "Pfarrwerfen",
                        "latitude": "47.45729000",
                        "longitude": "13.20531000"
                    },
                    {
                        "id": 2963,
                        "name": "Pichl",
                        "latitude": "47.28333000",
                        "longitude": "12.85000000"
                    },
                    {
                        "id": 2967,
                        "name": "Piesendorf",
                        "latitude": "47.29077000",
                        "longitude": "12.71839000"
                    },
                    {
                        "id": 2982,
                        "name": "Plainfeld",
                        "latitude": "47.83333000",
                        "longitude": "13.18333000"
                    },
                    {
                        "id": 2983,
                        "name": "Plankenau",
                        "latitude": "47.32673000",
                        "longitude": "13.19282000"
                    },
                    {
                        "id": 3006,
                        "name": "Politischer Bezirk Hallein",
                        "latitude": "47.60000000",
                        "longitude": "13.30000000"
                    },
                    {
                        "id": 3041,
                        "name": "Politischer Bezirk Salzburg-Umgebung",
                        "latitude": "47.84019000",
                        "longitude": "13.18799000"
                    },
                    {
                        "id": 3042,
                        "name": "Politischer Bezirk Sankt Johann im Pongau",
                        "latitude": "47.30000000",
                        "longitude": "13.30000000"
                    },
                    {
                        "id": 3051,
                        "name": "Politischer Bezirk Tamsweg",
                        "latitude": "47.15000000",
                        "longitude": "13.70000000"
                    },
                    {
                        "id": 3088,
                        "name": "Puch bei Hallein",
                        "latitude": "47.71536000",
                        "longitude": "13.09296000"
                    },
                    {
                        "id": 3125,
                        "name": "Radstadt",
                        "latitude": "47.38333000",
                        "longitude": "13.45000000"
                    },
                    {
                        "id": 3132,
                        "name": "Ramingstein",
                        "latitude": "47.07462000",
                        "longitude": "13.83642000"
                    },
                    {
                        "id": 3153,
                        "name": "Rauris",
                        "latitude": "47.22656000",
                        "longitude": "12.99459000"
                    },
                    {
                        "id": 3169,
                        "name": "Reinbach",
                        "latitude": "47.34673000",
                        "longitude": "13.19072000"
                    },
                    {
                        "id": 3173,
                        "name": "Reitberg",
                        "latitude": "47.85269000",
                        "longitude": "13.15730000"
                    },
                    {
                        "id": 3229,
                        "name": "Saalbach",
                        "latitude": "47.39138000",
                        "longitude": "12.63642000"
                    },
                    {
                        "id": 3230,
                        "name": "Saalfelden am Steinernen Meer",
                        "latitude": "47.42681000",
                        "longitude": "12.84800000"
                    },
                    {
                        "id": 3234,
                        "name": "Salzburg",
                        "latitude": "47.79941000",
                        "longitude": "13.04399000"
                    },
                    {
                        "id": 3235,
                        "name": "Salzburg Stadt",
                        "latitude": "47.80067000",
                        "longitude": "13.04532000"
                    },
                    {
                        "id": 3241,
                        "name": "Sankt Andrä im Lungau",
                        "latitude": "47.15000000",
                        "longitude": "13.78333000"
                    },
                    {
                        "id": 3262,
                        "name": "Sankt Gilgen",
                        "latitude": "47.76667000",
                        "longitude": "13.36667000"
                    },
                    {
                        "id": 3269,
                        "name": "Sankt Johann im Pongau",
                        "latitude": "47.35000000",
                        "longitude": "13.20000000"
                    },
                    {
                        "id": 3278,
                        "name": "Sankt Leonhard",
                        "latitude": "47.72587000",
                        "longitude": "13.04577000"
                    },
                    {
                        "id": 3298,
                        "name": "Sankt Margarethen im Lungau",
                        "latitude": "47.07927000",
                        "longitude": "13.69613000"
                    },
                    {
                        "id": 3306,
                        "name": "Sankt Martin bei Lofer",
                        "latitude": "47.56667000",
                        "longitude": "12.70000000"
                    },
                    {
                        "id": 3310,
                        "name": "Sankt Michael im Lungau",
                        "latitude": "47.10000000",
                        "longitude": "13.63333000"
                    },
                    {
                        "id": 3345,
                        "name": "Sankt Veit im Pongau",
                        "latitude": "47.33333000",
                        "longitude": "13.15000000"
                    },
                    {
                        "id": 3364,
                        "name": "Scheffau am Tennengebirge",
                        "latitude": "47.58831000",
                        "longitude": "13.22020000"
                    },
                    {
                        "id": 3375,
                        "name": "Schleedorf",
                        "latitude": "47.95000000",
                        "longitude": "13.15000000"
                    },
                    {
                        "id": 3396,
                        "name": "Schwarzach im Pongau",
                        "latitude": "47.32048000",
                        "longitude": "13.15171000"
                    },
                    {
                        "id": 3432,
                        "name": "Seeham",
                        "latitude": "47.96746000",
                        "longitude": "13.07699000"
                    },
                    {
                        "id": 3433,
                        "name": "Seekirchen am Wallersee",
                        "latitude": "47.90000000",
                        "longitude": "13.13333000"
                    },
                    {
                        "id": 3435,
                        "name": "Seewalchen",
                        "latitude": "47.90000000",
                        "longitude": "13.13333000"
                    },
                    {
                        "id": 3455,
                        "name": "Siezenheim",
                        "latitude": "47.81529000",
                        "longitude": "12.99039000"
                    },
                    {
                        "id": 3485,
                        "name": "St. Martin of Tennengebirge",
                        "latitude": "47.46500000",
                        "longitude": "13.37761000"
                    },
                    {
                        "id": 3545,
                        "name": "Strasswalchen",
                        "latitude": "47.97947000",
                        "longitude": "13.25535000"
                    },
                    {
                        "id": 3553,
                        "name": "Strobl",
                        "latitude": "47.71667000",
                        "longitude": "13.48333000"
                    },
                    {
                        "id": 3557,
                        "name": "Stuhlfelden",
                        "latitude": "47.28761000",
                        "longitude": "12.52755000"
                    },
                    {
                        "id": 3570,
                        "name": "Tamsweg",
                        "latitude": "47.12808000",
                        "longitude": "13.81102000"
                    },
                    {
                        "id": 3575,
                        "name": "Taugl",
                        "latitude": "47.64747000",
                        "longitude": "13.20282000"
                    },
                    {
                        "id": 3577,
                        "name": "Taxach",
                        "latitude": "47.72610000",
                        "longitude": "13.07184000"
                    },
                    {
                        "id": 3578,
                        "name": "Taxenbach",
                        "latitude": "47.29116000",
                        "longitude": "12.96215000"
                    },
                    {
                        "id": 3587,
                        "name": "Thalgau",
                        "latitude": "47.84142000",
                        "longitude": "13.25325000"
                    },
                    {
                        "id": 3593,
                        "name": "Thomatal",
                        "latitude": "47.06667000",
                        "longitude": "13.75000000"
                    },
                    {
                        "id": 3594,
                        "name": "Thumersbach",
                        "latitude": "47.32952000",
                        "longitude": "12.81675000"
                    },
                    {
                        "id": 3637,
                        "name": "Tweng",
                        "latitude": "47.18333000",
                        "longitude": "13.60000000"
                    },
                    {
                        "id": 3646,
                        "name": "Unken",
                        "latitude": "47.64966000",
                        "longitude": "12.72946000"
                    },
                    {
                        "id": 3657,
                        "name": "Unternberg",
                        "latitude": "47.11269000",
                        "longitude": "13.74261000"
                    },
                    {
                        "id": 3662,
                        "name": "Untertauern",
                        "latitude": "47.30000000",
                        "longitude": "13.50000000"
                    },
                    {
                        "id": 3669,
                        "name": "Uttendorf",
                        "latitude": "47.28333000",
                        "longitude": "12.56667000"
                    },
                    {
                        "id": 3678,
                        "name": "Viehhausen",
                        "latitude": "47.78333000",
                        "longitude": "12.98333000"
                    },
                    {
                        "id": 3679,
                        "name": "Viehhofen",
                        "latitude": "47.36667000",
                        "longitude": "12.73333000"
                    },
                    {
                        "id": 3682,
                        "name": "Vigaun",
                        "latitude": "47.66667000",
                        "longitude": "13.13333000"
                    },
                    {
                        "id": 3711,
                        "name": "Wagnergraben",
                        "latitude": "48.02036000",
                        "longitude": "13.02395000"
                    },
                    {
                        "id": 3713,
                        "name": "Wagrain",
                        "latitude": "47.33528000",
                        "longitude": "13.29889000"
                    },
                    {
                        "id": 3723,
                        "name": "Walchen",
                        "latitude": "47.28822000",
                        "longitude": "12.68739000"
                    },
                    {
                        "id": 3726,
                        "name": "Wald im Pinzgau",
                        "latitude": "47.25000000",
                        "longitude": "12.23333000"
                    },
                    {
                        "id": 3734,
                        "name": "Waldprechting",
                        "latitude": "47.90000000",
                        "longitude": "13.11667000"
                    },
                    {
                        "id": 3740,
                        "name": "Wals",
                        "latitude": "47.78333000",
                        "longitude": "12.96667000"
                    },
                    {
                        "id": 3741,
                        "name": "Walserfeld",
                        "latitude": "47.79222000",
                        "longitude": "12.98000000"
                    },
                    {
                        "id": 3792,
                        "name": "Werfen",
                        "latitude": "47.47585000",
                        "longitude": "13.19020000"
                    },
                    {
                        "id": 3793,
                        "name": "Werfenweng",
                        "latitude": "47.46204000",
                        "longitude": "13.25582000"
                    },
                    {
                        "id": 3868,
                        "name": "Zederhaus",
                        "latitude": "47.15570000",
                        "longitude": "13.50576000"
                    },
                    {
                        "id": 3874,
                        "name": "Zell am See",
                        "latitude": "47.32556000",
                        "longitude": "12.79444000"
                    }
                ]
            },
            {
                "id": 2059,
                "name": "Styria",
                "iso2": "6",
                "latitude": "47.35934420",
                "longitude": "14.46998270",
                "type": "state",
                "cities": [
                    {
                        "id": 1604,
                        "name": "Abtissendorf",
                        "latitude": "46.99583000",
                        "longitude": "15.45639000"
                    },
                    {
                        "id": 1610,
                        "name": "Admont",
                        "latitude": "47.57537000",
                        "longitude": "14.46075000"
                    },
                    {
                        "id": 1613,
                        "name": "Aflenz Kurort",
                        "latitude": "47.54211000",
                        "longitude": "15.23898000"
                    },
                    {
                        "id": 1616,
                        "name": "Aibl",
                        "latitude": "46.68145000",
                        "longitude": "15.22619000"
                    },
                    {
                        "id": 1618,
                        "name": "Aigen im Ennstal",
                        "latitude": "47.51667000",
                        "longitude": "14.13333000"
                    },
                    {
                        "id": 1624,
                        "name": "Albersdorf",
                        "latitude": "47.12166000",
                        "longitude": "15.69826000"
                    },
                    {
                        "id": 1629,
                        "name": "Allerheiligen bei Wildon",
                        "latitude": "46.91417000",
                        "longitude": "15.55444000"
                    },
                    {
                        "id": 1631,
                        "name": "Allerheiligen im Mürztal",
                        "latitude": "47.46667000",
                        "longitude": "15.40000000"
                    },
                    {
                        "id": 1636,
                        "name": "Altaussee",
                        "latitude": "47.63844000",
                        "longitude": "13.76278000"
                    },
                    {
                        "id": 1642,
                        "name": "Altenmarkt bei Fürstenfeld",
                        "latitude": "47.06638000",
                        "longitude": "16.04785000"
                    },
                    {
                        "id": 1643,
                        "name": "Altenmarkt bei Sankt Gallen",
                        "latitude": "47.72327000",
                        "longitude": "14.64838000"
                    },
                    {
                        "id": 1661,
                        "name": "Andritz",
                        "latitude": "47.11387000",
                        "longitude": "15.42348000"
                    },
                    {
                        "id": 1664,
                        "name": "Anger",
                        "latitude": "47.27422000",
                        "longitude": "15.69139000"
                    },
                    {
                        "id": 1674,
                        "name": "Apfelberg",
                        "latitude": "47.20000000",
                        "longitude": "14.83333000"
                    },
                    {
                        "id": 1677,
                        "name": "Ardning",
                        "latitude": "47.59120000",
                        "longitude": "14.36372000"
                    },
                    {
                        "id": 1678,
                        "name": "Arnfels",
                        "latitude": "46.67639000",
                        "longitude": "15.40306000"
                    },
                    {
                        "id": 1682,
                        "name": "Arzberg",
                        "latitude": "47.25000000",
                        "longitude": "15.51667000"
                    },
                    {
                        "id": 1694,
                        "name": "Attendorf",
                        "latitude": "47.00426000",
                        "longitude": "15.33897000"
                    },
                    {
                        "id": 1707,
                        "name": "Auersbach",
                        "latitude": "47.01667000",
                        "longitude": "15.86667000"
                    },
                    {
                        "id": 1716,
                        "name": "Bad Aussee",
                        "latitude": "47.60998000",
                        "longitude": "13.78243000"
                    },
                    {
                        "id": 1717,
                        "name": "Bad Blumau",
                        "latitude": "47.11667000",
                        "longitude": "16.05000000"
                    },
                    {
                        "id": 1721,
                        "name": "Bad Gams",
                        "latitude": "46.87111000",
                        "longitude": "15.22472000"
                    },
                    {
                        "id": 1723,
                        "name": "Bad Gleichenberg",
                        "latitude": "46.87556000",
                        "longitude": "15.90861000"
                    },
                    {
                        "id": 1732,
                        "name": "Bad Radkersburg",
                        "latitude": "46.68806000",
                        "longitude": "15.98806000"
                    },
                    {
                        "id": 1740,
                        "name": "Bad Waltersdorf",
                        "latitude": "47.16960000",
                        "longitude": "16.00870000"
                    },
                    {
                        "id": 1744,
                        "name": "Baierdorf-Umgebung",
                        "latitude": "47.28511000",
                        "longitude": "15.71045000"
                    },
                    {
                        "id": 1745,
                        "name": "Bairisch Kölldorf",
                        "latitude": "46.86667000",
                        "longitude": "15.93333000"
                    },
                    {
                        "id": 1823,
                        "name": "Bärnbach",
                        "latitude": "47.07141000",
                        "longitude": "15.12792000"
                    },
                    {
                        "id": 1750,
                        "name": "Baumgarten bei Gnas",
                        "latitude": "46.91667000",
                        "longitude": "15.76667000"
                    },
                    {
                        "id": 1762,
                        "name": "Berndorf",
                        "latitude": "47.41667000",
                        "longitude": "15.26667000"
                    },
                    {
                        "id": 1772,
                        "name": "Bierbaum am Auersbach",
                        "latitude": "46.82949000",
                        "longitude": "15.79237000"
                    },
                    {
                        "id": 1775,
                        "name": "Birkfeld",
                        "latitude": "47.35000000",
                        "longitude": "15.68333000"
                    },
                    {
                        "id": 1780,
                        "name": "Blaindorf",
                        "latitude": "47.17498000",
                        "longitude": "15.86795000"
                    },
                    {
                        "id": 1799,
                        "name": "Breitenfeld am Tannenriegel",
                        "latitude": "46.85000000",
                        "longitude": "15.63333000"
                    },
                    {
                        "id": 1800,
                        "name": "Breitenfeld an der Rittschein",
                        "latitude": "47.03333000",
                        "longitude": "15.95000000"
                    },
                    {
                        "id": 1803,
                        "name": "Bretstein",
                        "latitude": "47.33333000",
                        "longitude": "14.41667000"
                    },
                    {
                        "id": 1810,
                        "name": "Bruck an der Mur",
                        "latitude": "47.41667000",
                        "longitude": "15.28333000"
                    },
                    {
                        "id": 1812,
                        "name": "Brunn",
                        "latitude": "46.72944000",
                        "longitude": "15.30000000"
                    },
                    {
                        "id": 1820,
                        "name": "Burgau",
                        "latitude": "47.14268000",
                        "longitude": "16.09643000"
                    },
                    {
                        "id": 1832,
                        "name": "Dechantskirchen",
                        "latitude": "47.41667000",
                        "longitude": "16.01667000"
                    },
                    {
                        "id": 1836,
                        "name": "Deuchendorf",
                        "latitude": "47.46593000",
                        "longitude": "15.32172000"
                    },
                    {
                        "id": 1837,
                        "name": "Deutsch Goritz",
                        "latitude": "46.75083000",
                        "longitude": "15.82944000"
                    },
                    {
                        "id": 1842,
                        "name": "Deutschfeistritz",
                        "latitude": "47.19852000",
                        "longitude": "15.33623000"
                    },
                    {
                        "id": 1844,
                        "name": "Deutschlandsberg",
                        "latitude": "46.81528000",
                        "longitude": "15.22222000"
                    },
                    {
                        "id": 1846,
                        "name": "Diemlach",
                        "latitude": "47.43610000",
                        "longitude": "15.27460000"
                    },
                    {
                        "id": 1847,
                        "name": "Dienersdorf",
                        "latitude": "47.23979000",
                        "longitude": "15.90142000"
                    },
                    {
                        "id": 1852,
                        "name": "Dietersdorf",
                        "latitude": "47.20000000",
                        "longitude": "14.66667000"
                    },
                    {
                        "id": 1853,
                        "name": "Dietersdorf am Gnasbach",
                        "latitude": "46.80917000",
                        "longitude": "15.81167000"
                    },
                    {
                        "id": 1857,
                        "name": "Donawitz",
                        "latitude": "47.36667000",
                        "longitude": "15.06667000"
                    },
                    {
                        "id": 1858,
                        "name": "Donnersbach",
                        "latitude": "47.46139000",
                        "longitude": "14.12972000"
                    },
                    {
                        "id": 1879,
                        "name": "Dürnstein in der Steiermark",
                        "latitude": "46.98833000",
                        "longitude": "14.39167000"
                    },
                    {
                        "id": 1892,
                        "name": "Ebersdorf",
                        "latitude": "47.19852000",
                        "longitude": "15.96219000"
                    },
                    {
                        "id": 1899,
                        "name": "Edelsbach bei Feldbach",
                        "latitude": "46.98944000",
                        "longitude": "15.83694000"
                    },
                    {
                        "id": 1900,
                        "name": "Edelschrott",
                        "latitude": "47.02156000",
                        "longitude": "15.05266000"
                    },
                    {
                        "id": 1901,
                        "name": "Edelsgrub",
                        "latitude": "47.03333000",
                        "longitude": "15.60000000"
                    },
                    {
                        "id": 1903,
                        "name": "Edelstauden",
                        "latitude": "46.98333000",
                        "longitude": "15.61667000"
                    },
                    {
                        "id": 1908,
                        "name": "Eggenberg",
                        "latitude": "47.07000000",
                        "longitude": "15.39871000"
                    },
                    {
                        "id": 1912,
                        "name": "Eggersdorf bei Graz",
                        "latitude": "47.12338000",
                        "longitude": "15.60084000"
                    },
                    {
                        "id": 1914,
                        "name": "Ehrenhausen",
                        "latitude": "46.72417000",
                        "longitude": "15.58667000"
                    },
                    {
                        "id": 1916,
                        "name": "Eibiswald",
                        "latitude": "46.68667000",
                        "longitude": "15.24722000"
                    },
                    {
                        "id": 1917,
                        "name": "Eichberg",
                        "latitude": "47.38188000",
                        "longitude": "15.97356000"
                    },
                    {
                        "id": 1919,
                        "name": "Eichfeld",
                        "latitude": "46.72528000",
                        "longitude": "15.76806000"
                    },
                    {
                        "id": 1922,
                        "name": "Eisbach",
                        "latitude": "47.11667000",
                        "longitude": "15.26667000"
                    },
                    {
                        "id": 1923,
                        "name": "Eisenerz",
                        "latitude": "47.53333000",
                        "longitude": "14.88333000"
                    },
                    {
                        "id": 1936,
                        "name": "Empersdorf",
                        "latitude": "46.99892000",
                        "longitude": "15.59959000"
                    },
                    {
                        "id": 1945,
                        "name": "Eppenstein",
                        "latitude": "47.12833000",
                        "longitude": "14.73750000"
                    },
                    {
                        "id": 1959,
                        "name": "Falkenburg",
                        "latitude": "47.50000000",
                        "longitude": "14.08333000"
                    },
                    {
                        "id": 1962,
                        "name": "Farrach",
                        "latitude": "47.18333000",
                        "longitude": "14.73333000"
                    },
                    {
                        "id": 1964,
                        "name": "Fehring",
                        "latitude": "46.94000000",
                        "longitude": "16.00806000"
                    },
                    {
                        "id": 1968,
                        "name": "Feistritz bei Knittelfeld",
                        "latitude": "47.26802000",
                        "longitude": "14.89334000"
                    },
                    {
                        "id": 1972,
                        "name": "Feldbach",
                        "latitude": "46.95306000",
                        "longitude": "15.88833000"
                    },
                    {
                        "id": 1975,
                        "name": "Feldkirchen bei Graz",
                        "latitude": "47.01667000",
                        "longitude": "15.45000000"
                    },
                    {
                        "id": 1982,
                        "name": "Fernitz",
                        "latitude": "46.97389000",
                        "longitude": "15.50111000"
                    },
                    {
                        "id": 1991,
                        "name": "Fischbach",
                        "latitude": "47.44234000",
                        "longitude": "15.64972000"
                    },
                    {
                        "id": 1995,
                        "name": "Fladnitz im Raabtal",
                        "latitude": "46.99167000",
                        "longitude": "15.78528000"
                    },
                    {
                        "id": 1996,
                        "name": "Flatschach",
                        "latitude": "47.21667000",
                        "longitude": "14.75000000"
                    },
                    {
                        "id": 2001,
                        "name": "Floing",
                        "latitude": "47.26356000",
                        "longitude": "15.74650000"
                    },
                    {
                        "id": 2003,
                        "name": "Fohnsdorf",
                        "latitude": "47.20000000",
                        "longitude": "14.68333000"
                    },
                    {
                        "id": 2011,
                        "name": "Frannach",
                        "latitude": "46.91306000",
                        "longitude": "15.63361000"
                    },
                    {
                        "id": 2013,
                        "name": "Frauenberg",
                        "latitude": "47.42855000",
                        "longitude": "15.34206000"
                    },
                    {
                        "id": 2017,
                        "name": "Freidorf an der Laßnitz",
                        "latitude": "46.81667000",
                        "longitude": "15.25000000"
                    },
                    {
                        "id": 2018,
                        "name": "Freiland bei Deutschlandsberg",
                        "latitude": "46.83333000",
                        "longitude": "15.13333000"
                    },
                    {
                        "id": 2023,
                        "name": "Friedberg",
                        "latitude": "47.43333000",
                        "longitude": "16.05000000"
                    },
                    {
                        "id": 2026,
                        "name": "Frohnleiten",
                        "latitude": "47.26667000",
                        "longitude": "15.31667000"
                    },
                    {
                        "id": 2037,
                        "name": "Fürstenfeld",
                        "latitude": "47.05000000",
                        "longitude": "16.08333000"
                    },
                    {
                        "id": 2039,
                        "name": "Gaal",
                        "latitude": "47.27268000",
                        "longitude": "14.67003000"
                    },
                    {
                        "id": 2040,
                        "name": "Gabersdorf",
                        "latitude": "46.77722000",
                        "longitude": "15.58417000"
                    },
                    {
                        "id": 2047,
                        "name": "Gallmannsegg",
                        "latitude": "47.18333000",
                        "longitude": "15.06667000"
                    },
                    {
                        "id": 2053,
                        "name": "Gamlitz",
                        "latitude": "46.72028000",
                        "longitude": "15.55333000"
                    },
                    {
                        "id": 2055,
                        "name": "Gams bei Hieflau",
                        "latitude": "47.66667000",
                        "longitude": "14.78333000"
                    },
                    {
                        "id": 2056,
                        "name": "Ganz",
                        "latitude": "47.60000000",
                        "longitude": "15.68333000"
                    },
                    {
                        "id": 2057,
                        "name": "Garanas",
                        "latitude": "46.76667000",
                        "longitude": "15.11667000"
                    },
                    {
                        "id": 2061,
                        "name": "Gasen",
                        "latitude": "47.38333000",
                        "longitude": "15.56667000"
                    },
                    {
                        "id": 2070,
                        "name": "Geidorf",
                        "latitude": "47.08393000",
                        "longitude": "15.44400000"
                    },
                    {
                        "id": 2071,
                        "name": "Geistthal",
                        "latitude": "47.16667000",
                        "longitude": "15.16667000"
                    },
                    {
                        "id": 2079,
                        "name": "Gersdorf an der Feistritz",
                        "latitude": "47.16667000",
                        "longitude": "15.85000000"
                    },
                    {
                        "id": 2085,
                        "name": "Gleinstätten",
                        "latitude": "46.75361000",
                        "longitude": "15.36972000"
                    },
                    {
                        "id": 2086,
                        "name": "Gleisdorf",
                        "latitude": "47.10559000",
                        "longitude": "15.71011000"
                    },
                    {
                        "id": 2090,
                        "name": "Glojach",
                        "latitude": "46.86667000",
                        "longitude": "15.66667000"
                    },
                    {
                        "id": 2097,
                        "name": "Gnas",
                        "latitude": "46.87306000",
                        "longitude": "15.82528000"
                    },
                    {
                        "id": 2100,
                        "name": "Gniebing",
                        "latitude": "46.96252000",
                        "longitude": "15.85645000"
                    },
                    {
                        "id": 2106,
                        "name": "Gosdorf",
                        "latitude": "46.72778000",
                        "longitude": "15.79250000"
                    },
                    {
                        "id": 2187,
                        "name": "Göss",
                        "latitude": "47.35871000",
                        "longitude": "15.10015000"
                    },
                    {
                        "id": 2188,
                        "name": "Gössenberg",
                        "latitude": "47.41667000",
                        "longitude": "13.81667000"
                    },
                    {
                        "id": 2107,
                        "name": "Gossendorf",
                        "latitude": "46.91076000",
                        "longitude": "15.93043000"
                    },
                    {
                        "id": 2190,
                        "name": "Gösting",
                        "latitude": "47.09788000",
                        "longitude": "15.39777000"
                    },
                    {
                        "id": 2192,
                        "name": "Göttelsberg",
                        "latitude": "47.21667000",
                        "longitude": "15.60000000"
                    },
                    {
                        "id": 2108,
                        "name": "Grabersdorf",
                        "latitude": "46.84306000",
                        "longitude": "15.82472000"
                    },
                    {
                        "id": 2109,
                        "name": "Grafendorf bei Hartberg",
                        "latitude": "47.34028000",
                        "longitude": "15.99060000"
                    },
                    {
                        "id": 2115,
                        "name": "Gralla",
                        "latitude": "46.81404000",
                        "longitude": "15.55510000"
                    },
                    {
                        "id": 2119,
                        "name": "Grambach",
                        "latitude": "47.01473000",
                        "longitude": "15.50407000"
                    },
                    {
                        "id": 2120,
                        "name": "Gratkorn",
                        "latitude": "47.13333000",
                        "longitude": "15.35000000"
                    },
                    {
                        "id": 2121,
                        "name": "Gratwein",
                        "latitude": "47.11667000",
                        "longitude": "15.31667000"
                    },
                    {
                        "id": 2122,
                        "name": "Graz",
                        "latitude": "47.06667000",
                        "longitude": "15.45000000"
                    },
                    {
                        "id": 2123,
                        "name": "Graz Stadt",
                        "latitude": "47.06667000",
                        "longitude": "15.43333000"
                    },
                    {
                        "id": 2127,
                        "name": "Greisdorf",
                        "latitude": "46.92647000",
                        "longitude": "15.21906000"
                    },
                    {
                        "id": 2128,
                        "name": "Gressenberg",
                        "latitude": "46.80000000",
                        "longitude": "15.11667000"
                    },
                    {
                        "id": 2131,
                        "name": "Gries",
                        "latitude": "47.06236000",
                        "longitude": "15.42421000"
                    },
                    {
                        "id": 2165,
                        "name": "Gröbming",
                        "latitude": "47.44272000",
                        "longitude": "13.90122000"
                    },
                    {
                        "id": 2145,
                        "name": "Groß Sankt Florian",
                        "latitude": "46.82444000",
                        "longitude": "15.31861000"
                    },
                    {
                        "id": 2156,
                        "name": "Großklein",
                        "latitude": "46.73611000",
                        "longitude": "15.44444000"
                    },
                    {
                        "id": 2158,
                        "name": "Großlobming",
                        "latitude": "47.18333000",
                        "longitude": "14.80000000"
                    },
                    {
                        "id": 2162,
                        "name": "Großsölk",
                        "latitude": "47.41667000",
                        "longitude": "13.96667000"
                    },
                    {
                        "id": 2144,
                        "name": "Grosssulz",
                        "latitude": "46.94556000",
                        "longitude": "15.49028000"
                    },
                    {
                        "id": 2174,
                        "name": "Gundersdorf",
                        "latitude": "46.95000000",
                        "longitude": "15.23333000"
                    },
                    {
                        "id": 2206,
                        "name": "Hafendorf",
                        "latitude": "47.45653000",
                        "longitude": "15.31837000"
                    },
                    {
                        "id": 2217,
                        "name": "Hainersdorf",
                        "latitude": "47.11506000",
                        "longitude": "15.94374000"
                    },
                    {
                        "id": 2219,
                        "name": "Hainsdorf im Schwarzautal",
                        "latitude": "46.83583000",
                        "longitude": "15.64139000"
                    },
                    {
                        "id": 2221,
                        "name": "Halbenrain",
                        "latitude": "46.72194000",
                        "longitude": "15.94667000"
                    },
                    {
                        "id": 2223,
                        "name": "Hall bei Admont",
                        "latitude": "47.58700000",
                        "longitude": "14.46372000"
                    },
                    {
                        "id": 2236,
                        "name": "Hart bei Graz",
                        "latitude": "47.04311000",
                        "longitude": "15.51527000"
                    },
                    {
                        "id": 2238,
                        "name": "Hartberg",
                        "latitude": "47.28333000",
                        "longitude": "15.96667000"
                    },
                    {
                        "id": 2241,
                        "name": "Hartl",
                        "latitude": "47.18333000",
                        "longitude": "15.91667000"
                    },
                    {
                        "id": 2242,
                        "name": "Hartmannsdorf",
                        "latitude": "47.05461000",
                        "longitude": "15.83941000"
                    },
                    {
                        "id": 2246,
                        "name": "Hatzendorf",
                        "latitude": "46.97686000",
                        "longitude": "16.00107000"
                    },
                    {
                        "id": 2250,
                        "name": "Haus",
                        "latitude": "47.40997000",
                        "longitude": "13.76724000"
                    },
                    {
                        "id": 2251,
                        "name": "Haus im Ennstal",
                        "latitude": "47.41058000",
                        "longitude": "13.76759000"
                    },
                    {
                        "id": 2255,
                        "name": "Hausmannstätten",
                        "latitude": "46.99111000",
                        "longitude": "15.51139000"
                    },
                    {
                        "id": 2262,
                        "name": "Heiligenkreuz am Waasen",
                        "latitude": "46.95583000",
                        "longitude": "15.58806000"
                    },
                    {
                        "id": 2264,
                        "name": "Heimschuh",
                        "latitude": "46.76000000",
                        "longitude": "15.49306000"
                    },
                    {
                        "id": 2268,
                        "name": "Hengsberg",
                        "latitude": "46.86667000",
                        "longitude": "15.43333000"
                    },
                    {
                        "id": 2277,
                        "name": "Hetzendorf",
                        "latitude": "47.18333000",
                        "longitude": "14.68333000"
                    },
                    {
                        "id": 2279,
                        "name": "Hieflau",
                        "latitude": "47.60639000",
                        "longitude": "14.74503000"
                    },
                    {
                        "id": 2284,
                        "name": "Hinterberg",
                        "latitude": "47.36066000",
                        "longitude": "15.06951000"
                    },
                    {
                        "id": 2291,
                        "name": "Hirnsdorf",
                        "latitude": "47.19167000",
                        "longitude": "15.82868000"
                    },
                    {
                        "id": 2296,
                        "name": "Hitzendorf",
                        "latitude": "47.03333000",
                        "longitude": "15.30000000"
                    },
                    {
                        "id": 2301,
                        "name": "Hochtregist",
                        "latitude": "47.10000000",
                        "longitude": "15.13333000"
                    },
                    {
                        "id": 2337,
                        "name": "Höf",
                        "latitude": "47.13401000",
                        "longitude": "15.49092000"
                    },
                    {
                        "id": 2307,
                        "name": "Hof bei Straden",
                        "latitude": "46.80000000",
                        "longitude": "15.93333000"
                    },
                    {
                        "id": 2311,
                        "name": "Hofstätten an der Raab",
                        "latitude": "47.06667000",
                        "longitude": "15.73333000"
                    },
                    {
                        "id": 2313,
                        "name": "Hohenau an der Raab",
                        "latitude": "47.30000000",
                        "longitude": "15.55000000"
                    },
                    {
                        "id": 2318,
                        "name": "Hohentauern",
                        "latitude": "47.43333000",
                        "longitude": "14.48333000"
                    },
                    {
                        "id": 2322,
                        "name": "Hollenegg",
                        "latitude": "46.79147000",
                        "longitude": "15.21345000"
                    },
                    {
                        "id": 2341,
                        "name": "Hönigsberg",
                        "latitude": "47.58038000",
                        "longitude": "15.64808000"
                    },
                    {
                        "id": 2352,
                        "name": "Ilz",
                        "latitude": "47.08649000",
                        "longitude": "15.92676000"
                    },
                    {
                        "id": 2357,
                        "name": "Innere Stadt",
                        "latitude": "47.06650000",
                        "longitude": "15.44051000"
                    },
                    {
                        "id": 2365,
                        "name": "Irdning",
                        "latitude": "47.50529000",
                        "longitude": "14.10155000"
                    },
                    {
                        "id": 2371,
                        "name": "Jagerberg",
                        "latitude": "46.85361000",
                        "longitude": "15.73806000"
                    },
                    {
                        "id": 2373,
                        "name": "Jakomini",
                        "latitude": "47.05441000",
                        "longitude": "15.44984000"
                    },
                    {
                        "id": 2380,
                        "name": "Johnsbach",
                        "latitude": "47.53333000",
                        "longitude": "14.58333000"
                    },
                    {
                        "id": 2382,
                        "name": "Judenburg",
                        "latitude": "47.16667000",
                        "longitude": "14.66667000"
                    },
                    {
                        "id": 2383,
                        "name": "Judendorf",
                        "latitude": "47.40000000",
                        "longitude": "15.10000000"
                    },
                    {
                        "id": 2385,
                        "name": "Kaibing",
                        "latitude": "47.20000000",
                        "longitude": "15.83333000"
                    },
                    {
                        "id": 2386,
                        "name": "Kainach bei Voitsberg",
                        "latitude": "47.13637000",
                        "longitude": "15.09530000"
                    },
                    {
                        "id": 2387,
                        "name": "Kainbach",
                        "latitude": "47.08333000",
                        "longitude": "15.51667000"
                    },
                    {
                        "id": 2388,
                        "name": "Kaindorf",
                        "latitude": "47.22537000",
                        "longitude": "15.91125000"
                    },
                    {
                        "id": 2389,
                        "name": "Kaindorf an der Sulm",
                        "latitude": "46.79248000",
                        "longitude": "15.53879000"
                    },
                    {
                        "id": 2391,
                        "name": "Kalsdorf bei Graz",
                        "latitude": "46.96528000",
                        "longitude": "15.48028000"
                    },
                    {
                        "id": 2395,
                        "name": "Kalwang",
                        "latitude": "47.42678000",
                        "longitude": "14.75442000"
                    },
                    {
                        "id": 2396,
                        "name": "Kammern im Liesingtal",
                        "latitude": "47.39245000",
                        "longitude": "14.90407000"
                    },
                    {
                        "id": 2397,
                        "name": "Kapellen",
                        "latitude": "47.64784000",
                        "longitude": "15.62863000"
                    },
                    {
                        "id": 2399,
                        "name": "Kapfenberg",
                        "latitude": "47.44458000",
                        "longitude": "15.29331000"
                    },
                    {
                        "id": 2400,
                        "name": "Kapfenstein",
                        "latitude": "46.88611000",
                        "longitude": "15.97167000"
                    },
                    {
                        "id": 2423,
                        "name": "Kindberg",
                        "latitude": "47.50000000",
                        "longitude": "15.45000000"
                    },
                    {
                        "id": 2425,
                        "name": "Kirchbach in Steiermark",
                        "latitude": "46.93167000",
                        "longitude": "15.66194000"
                    },
                    {
                        "id": 2430,
                        "name": "Kirchberg an der Raab",
                        "latitude": "46.98583000",
                        "longitude": "15.76694000"
                    },
                    {
                        "id": 2436,
                        "name": "Kirchenviertel",
                        "latitude": "47.13124000",
                        "longitude": "15.34764000"
                    },
                    {
                        "id": 2444,
                        "name": "Kitzeck im Sausal",
                        "latitude": "46.78072000",
                        "longitude": "15.45384000"
                    },
                    {
                        "id": 2455,
                        "name": "Kleinlobming",
                        "latitude": "47.14954000",
                        "longitude": "14.84875000"
                    },
                    {
                        "id": 2457,
                        "name": "Kleinsöding",
                        "latitude": "47.00000000",
                        "longitude": "15.28333000"
                    },
                    {
                        "id": 2458,
                        "name": "Kleinsölk",
                        "latitude": "47.39444000",
                        "longitude": "13.93944000"
                    },
                    {
                        "id": 2463,
                        "name": "Klöch",
                        "latitude": "46.76472000",
                        "longitude": "15.96556000"
                    },
                    {
                        "id": 2461,
                        "name": "Kloster",
                        "latitude": "46.88333000",
                        "longitude": "15.08333000"
                    },
                    {
                        "id": 2465,
                        "name": "Knittelfeld",
                        "latitude": "47.21667000",
                        "longitude": "14.81667000"
                    },
                    {
                        "id": 2466,
                        "name": "Kobenz",
                        "latitude": "47.25000000",
                        "longitude": "14.85000000"
                    },
                    {
                        "id": 2508,
                        "name": "Köflach",
                        "latitude": "47.06667000",
                        "longitude": "15.08333000"
                    },
                    {
                        "id": 2470,
                        "name": "Kohlberg",
                        "latitude": "46.90000000",
                        "longitude": "15.78333000"
                    },
                    {
                        "id": 2471,
                        "name": "Kohlschwarz",
                        "latitude": "47.11667000",
                        "longitude": "15.11667000"
                    },
                    {
                        "id": 2478,
                        "name": "Krakaudorf",
                        "latitude": "47.18131000",
                        "longitude": "14.02061000"
                    },
                    {
                        "id": 2479,
                        "name": "Krakauhintermühlen",
                        "latitude": "47.18333000",
                        "longitude": "13.98333000"
                    },
                    {
                        "id": 2480,
                        "name": "Krakauschatten",
                        "latitude": "47.18333000",
                        "longitude": "13.96667000"
                    },
                    {
                        "id": 2482,
                        "name": "Kraubath an der Mur",
                        "latitude": "47.30000000",
                        "longitude": "14.93333000"
                    },
                    {
                        "id": 2488,
                        "name": "Krieglach",
                        "latitude": "47.54728000",
                        "longitude": "15.56248000"
                    },
                    {
                        "id": 2493,
                        "name": "Krottendorf",
                        "latitude": "47.20000000",
                        "longitude": "15.63333000"
                    },
                    {
                        "id": 2494,
                        "name": "Krottendorf bei Ligist",
                        "latitude": "47.01667000",
                        "longitude": "15.21667000"
                    },
                    {
                        "id": 2498,
                        "name": "Krumegg",
                        "latitude": "47.02111000",
                        "longitude": "15.63139000"
                    },
                    {
                        "id": 2501,
                        "name": "Krusdorf",
                        "latitude": "46.83944000",
                        "longitude": "15.86083000"
                    },
                    {
                        "id": 2505,
                        "name": "Kulm am Zirbitz",
                        "latitude": "47.05814000",
                        "longitude": "14.48702000"
                    },
                    {
                        "id": 2506,
                        "name": "Kumberg",
                        "latitude": "47.16422000",
                        "longitude": "15.53261000"
                    },
                    {
                        "id": 2522,
                        "name": "Labuch",
                        "latitude": "47.06667000",
                        "longitude": "15.66667000"
                    },
                    {
                        "id": 2527,
                        "name": "Lafnitz",
                        "latitude": "47.36792000",
                        "longitude": "16.01103000"
                    },
                    {
                        "id": 2532,
                        "name": "Landl",
                        "latitude": "47.65666000",
                        "longitude": "14.73189000"
                    },
                    {
                        "id": 2534,
                        "name": "Lang",
                        "latitude": "46.83765000",
                        "longitude": "15.50471000"
                    },
                    {
                        "id": 2536,
                        "name": "Langegg bei Graz",
                        "latitude": "47.05000000",
                        "longitude": "15.63333000"
                    },
                    {
                        "id": 2543,
                        "name": "Langenwang",
                        "latitude": "47.56667000",
                        "longitude": "15.61667000"
                    },
                    {
                        "id": 2547,
                        "name": "Lannach",
                        "latitude": "46.94611000",
                        "longitude": "15.33722000"
                    },
                    {
                        "id": 2552,
                        "name": "Lassnitzhöhe",
                        "latitude": "47.06667000",
                        "longitude": "15.58333000"
                    },
                    {
                        "id": 2564,
                        "name": "Leibnitz",
                        "latitude": "46.78161000",
                        "longitude": "15.53836000"
                    },
                    {
                        "id": 2566,
                        "name": "Leitendorf",
                        "latitude": "47.36667000",
                        "longitude": "15.08333000"
                    },
                    {
                        "id": 2567,
                        "name": "Leitersdorf im Raabtal",
                        "latitude": "46.94182000",
                        "longitude": "15.93365000"
                    },
                    {
                        "id": 2569,
                        "name": "Leitring",
                        "latitude": "46.76667000",
                        "longitude": "15.56667000"
                    },
                    {
                        "id": 2573,
                        "name": "Lend",
                        "latitude": "47.08256000",
                        "longitude": "15.41589000"
                    },
                    {
                        "id": 2578,
                        "name": "Leoben",
                        "latitude": "47.37650000",
                        "longitude": "15.09144000"
                    },
                    {
                        "id": 2589,
                        "name": "Leutschach",
                        "latitude": "46.66722000",
                        "longitude": "15.46889000"
                    },
                    {
                        "id": 2593,
                        "name": "Liebenau",
                        "latitude": "47.03333000",
                        "longitude": "15.46667000"
                    },
                    {
                        "id": 2595,
                        "name": "Lieboch",
                        "latitude": "46.97417000",
                        "longitude": "15.33750000"
                    },
                    {
                        "id": 2597,
                        "name": "Liesingtal",
                        "latitude": "47.34597000",
                        "longitude": "15.01352000"
                    },
                    {
                        "id": 2598,
                        "name": "Liezen",
                        "latitude": "47.56667000",
                        "longitude": "14.23333000"
                    },
                    {
                        "id": 2599,
                        "name": "Ligist",
                        "latitude": "46.99389000",
                        "longitude": "15.21083000"
                    },
                    {
                        "id": 2624,
                        "name": "Lödersdorf",
                        "latitude": "46.95861000",
                        "longitude": "15.94333000"
                    },
                    {
                        "id": 2612,
                        "name": "Loipersdorf bei Fürstenfeld",
                        "latitude": "47.00000000",
                        "longitude": "16.10000000"
                    },
                    {
                        "id": 2625,
                        "name": "Maierdorf",
                        "latitude": "46.89250000",
                        "longitude": "15.84972000"
                    },
                    {
                        "id": 2643,
                        "name": "Maria Lankowitz",
                        "latitude": "47.06220000",
                        "longitude": "15.06525000"
                    },
                    {
                        "id": 2652,
                        "name": "Mariahof",
                        "latitude": "47.10000000",
                        "longitude": "14.40000000"
                    },
                    {
                        "id": 2657,
                        "name": "Mariatrost",
                        "latitude": "47.10000000",
                        "longitude": "15.50000000"
                    },
                    {
                        "id": 2658,
                        "name": "Mariazell",
                        "latitude": "47.77306000",
                        "longitude": "15.31639000"
                    },
                    {
                        "id": 2680,
                        "name": "Mautern in Steiermark",
                        "latitude": "47.40000000",
                        "longitude": "14.83333000"
                    },
                    {
                        "id": 2689,
                        "name": "Mellach",
                        "latitude": "46.93333000",
                        "longitude": "15.51667000"
                    },
                    {
                        "id": 2691,
                        "name": "Merkendorf",
                        "latitude": "46.85722000",
                        "longitude": "15.90389000"
                    },
                    {
                        "id": 2693,
                        "name": "Mettersdorf am Saßbach",
                        "latitude": "46.80583000",
                        "longitude": "15.71111000"
                    },
                    {
                        "id": 2694,
                        "name": "Michaelerberg",
                        "latitude": "47.41083000",
                        "longitude": "13.89333000"
                    },
                    {
                        "id": 2710,
                        "name": "Mitterdorf an der Raab",
                        "latitude": "47.16667000",
                        "longitude": "15.60000000"
                    },
                    {
                        "id": 2711,
                        "name": "Mitterdorf im Mürztal",
                        "latitude": "47.53333000",
                        "longitude": "15.51667000"
                    },
                    {
                        "id": 2714,
                        "name": "Mitterlabill",
                        "latitude": "46.88917000",
                        "longitude": "15.63556000"
                    },
                    {
                        "id": 2717,
                        "name": "Mitterndorf im Steirischen Salzkammergut",
                        "latitude": "47.55556000",
                        "longitude": "13.93187000"
                    },
                    {
                        "id": 2721,
                        "name": "Modriach",
                        "latitude": "46.95000000",
                        "longitude": "15.05000000"
                    },
                    {
                        "id": 2747,
                        "name": "Mönichwald",
                        "latitude": "47.44655000",
                        "longitude": "15.88275000"
                    },
                    {
                        "id": 2728,
                        "name": "Mooskirchen",
                        "latitude": "46.98167000",
                        "longitude": "15.27889000"
                    },
                    {
                        "id": 2729,
                        "name": "Mortantsch",
                        "latitude": "47.20752000",
                        "longitude": "15.57954000"
                    },
                    {
                        "id": 2757,
                        "name": "Mühldorf bei Feldbach",
                        "latitude": "46.93861000",
                        "longitude": "15.90750000"
                    },
                    {
                        "id": 2758,
                        "name": "Mühlen",
                        "latitude": "47.03071000",
                        "longitude": "14.50848000"
                    },
                    {
                        "id": 2735,
                        "name": "Murau",
                        "latitude": "47.11056000",
                        "longitude": "14.16944000"
                    },
                    {
                        "id": 2736,
                        "name": "Mureck",
                        "latitude": "46.70806000",
                        "longitude": "15.77472000"
                    },
                    {
                        "id": 2765,
                        "name": "Mürzhofen",
                        "latitude": "47.48333000",
                        "longitude": "15.38333000"
                    },
                    {
                        "id": 2766,
                        "name": "Mürzsteg",
                        "latitude": "47.67556000",
                        "longitude": "15.49145000"
                    },
                    {
                        "id": 2767,
                        "name": "Mürzzuschlag",
                        "latitude": "47.60660000",
                        "longitude": "15.67226000"
                    },
                    {
                        "id": 2769,
                        "name": "Naas",
                        "latitude": "47.25086000",
                        "longitude": "15.59449000"
                    },
                    {
                        "id": 2780,
                        "name": "Nestelbach bei Graz",
                        "latitude": "47.06053000",
                        "longitude": "15.61140000"
                    },
                    {
                        "id": 2781,
                        "name": "Nestelbach im Ilztal",
                        "latitude": "47.08333000",
                        "longitude": "15.86667000"
                    },
                    {
                        "id": 2786,
                        "name": "Neuberg an der Mürz",
                        "latitude": "47.66423000",
                        "longitude": "15.57226000"
                    },
                    {
                        "id": 2788,
                        "name": "Neudau",
                        "latitude": "47.17554000",
                        "longitude": "16.10184000"
                    },
                    {
                        "id": 2808,
                        "name": "Neumarkt in Steiermark",
                        "latitude": "47.07398000",
                        "longitude": "14.42728000"
                    },
                    {
                        "id": 2817,
                        "name": "Neutillmitsch",
                        "latitude": "46.81667000",
                        "longitude": "15.53333000"
                    },
                    {
                        "id": 2833,
                        "name": "Niederöblarn",
                        "latitude": "47.47667000",
                        "longitude": "14.01937000"
                    },
                    {
                        "id": 2829,
                        "name": "Niederschöckl",
                        "latitude": "47.15000000",
                        "longitude": "15.50000000"
                    },
                    {
                        "id": 2832,
                        "name": "Niederwölz",
                        "latitude": "47.15126000",
                        "longitude": "14.37479000"
                    },
                    {
                        "id": 2835,
                        "name": "Niklasdorf",
                        "latitude": "47.38333000",
                        "longitude": "15.15000000"
                    },
                    {
                        "id": 2837,
                        "name": "Nitscha",
                        "latitude": "47.11667000",
                        "longitude": "15.75000000"
                    },
                    {
                        "id": 2842,
                        "name": "Obdach",
                        "latitude": "47.06667000",
                        "longitude": "14.68333000"
                    },
                    {
                        "id": 2844,
                        "name": "Oberaich",
                        "latitude": "47.40000000",
                        "longitude": "15.21667000"
                    },
                    {
                        "id": 2847,
                        "name": "Oberdorf am Hochegg",
                        "latitude": "46.97861000",
                        "longitude": "15.72167000"
                    },
                    {
                        "id": 2851,
                        "name": "Oberhaag",
                        "latitude": "46.68690000",
                        "longitude": "15.33202000"
                    },
                    {
                        "id": 2857,
                        "name": "Oberkurzheim",
                        "latitude": "47.23333000",
                        "longitude": "14.58333000"
                    },
                    {
                        "id": 2870,
                        "name": "Oberpremstätten",
                        "latitude": "46.97444000",
                        "longitude": "15.40444000"
                    },
                    {
                        "id": 2872,
                        "name": "Oberrettenbach",
                        "latitude": "47.15000000",
                        "longitude": "15.80000000"
                    },
                    {
                        "id": 2876,
                        "name": "Oberstorcha",
                        "latitude": "46.96667000",
                        "longitude": "15.80000000"
                    },
                    {
                        "id": 2880,
                        "name": "Obervogau",
                        "latitude": "46.74500000",
                        "longitude": "15.58472000"
                    },
                    {
                        "id": 2885,
                        "name": "Oberweg",
                        "latitude": "47.15000000",
                        "longitude": "14.63333000"
                    },
                    {
                        "id": 2887,
                        "name": "Oberwölz Stadt",
                        "latitude": "47.20117000",
                        "longitude": "14.28321000"
                    },
                    {
                        "id": 2888,
                        "name": "Oberzeiring",
                        "latitude": "47.25000000",
                        "longitude": "14.48333000"
                    },
                    {
                        "id": 3897,
                        "name": "Öblarn",
                        "latitude": "47.45938000",
                        "longitude": "13.99023000"
                    },
                    {
                        "id": 2900,
                        "name": "Oppenberg",
                        "latitude": "47.48333000",
                        "longitude": "14.26667000"
                    },
                    {
                        "id": 2903,
                        "name": "Ortgraben",
                        "latitude": "47.45000000",
                        "longitude": "16.05000000"
                    },
                    {
                        "id": 2908,
                        "name": "Osterwitz",
                        "latitude": "46.85943000",
                        "longitude": "15.08998000"
                    },
                    {
                        "id": 2917,
                        "name": "Pack",
                        "latitude": "46.97917000",
                        "longitude": "14.98417000"
                    },
                    {
                        "id": 2918,
                        "name": "Paldau",
                        "latitude": "46.94222000",
                        "longitude": "15.79583000"
                    },
                    {
                        "id": 2919,
                        "name": "Palfau",
                        "latitude": "47.70000000",
                        "longitude": "14.80000000"
                    },
                    {
                        "id": 2925,
                        "name": "Parschlug",
                        "latitude": "47.48090000",
                        "longitude": "15.28645000"
                    },
                    {
                        "id": 2927,
                        "name": "Passail",
                        "latitude": "47.28333000",
                        "longitude": "15.51667000"
                    },
                    {
                        "id": 2933,
                        "name": "Peggau",
                        "latitude": "47.20000000",
                        "longitude": "15.35000000"
                    },
                    {
                        "id": 2936,
                        "name": "Perchau am Sattel",
                        "latitude": "47.10000000",
                        "longitude": "14.45000000"
                    },
                    {
                        "id": 2939,
                        "name": "Perlsdorf",
                        "latitude": "46.91361000",
                        "longitude": "15.81417000"
                    },
                    {
                        "id": 2941,
                        "name": "Pernegg an der Mur",
                        "latitude": "47.35979000",
                        "longitude": "15.34236000"
                    },
                    {
                        "id": 2945,
                        "name": "Pertlstein",
                        "latitude": "46.94056000",
                        "longitude": "15.96167000"
                    },
                    {
                        "id": 2962,
                        "name": "Piberegg",
                        "latitude": "47.09424000",
                        "longitude": "15.11658000"
                    },
                    {
                        "id": 2965,
                        "name": "Pichling bei Köflach",
                        "latitude": "47.04785000",
                        "longitude": "15.07098000"
                    },
                    {
                        "id": 2971,
                        "name": "Pinggau",
                        "latitude": "47.44232000",
                        "longitude": "16.06713000"
                    },
                    {
                        "id": 2974,
                        "name": "Pirching am Traubenberg",
                        "latitude": "46.95000000",
                        "longitude": "15.60000000"
                    },
                    {
                        "id": 2976,
                        "name": "Pirka",
                        "latitude": "47.00000000",
                        "longitude": "15.38333000"
                    },
                    {
                        "id": 2977,
                        "name": "Pischelsdorf in der Steiermark",
                        "latitude": "47.17417000",
                        "longitude": "15.80572000"
                    },
                    {
                        "id": 2978,
                        "name": "Pistorf",
                        "latitude": "46.76667000",
                        "longitude": "15.36667000"
                    },
                    {
                        "id": 2979,
                        "name": "Pitschgau",
                        "latitude": "46.70000000",
                        "longitude": "15.26667000"
                    },
                    {
                        "id": 2993,
                        "name": "Politischer Bezirk Bruck-Mürzzuschlag",
                        "latitude": "47.41880000",
                        "longitude": "15.27512000"
                    },
                    {
                        "id": 2994,
                        "name": "Politischer Bezirk Deutschlandsberg",
                        "latitude": "46.75000000",
                        "longitude": "15.20000000"
                    },
                    {
                        "id": 3002,
                        "name": "Politischer Bezirk Graz-Umgebung",
                        "latitude": "47.13860000",
                        "longitude": "15.38823000"
                    },
                    {
                        "id": 3007,
                        "name": "Politischer Bezirk Hartberg-Fürstenfeld",
                        "latitude": "47.27923000",
                        "longitude": "15.98373000"
                    },
                    {
                        "id": 3021,
                        "name": "Politischer Bezirk Leibnitz",
                        "latitude": "46.79565000",
                        "longitude": "15.51849000"
                    },
                    {
                        "id": 3022,
                        "name": "Politischer Bezirk Leoben",
                        "latitude": "47.41667000",
                        "longitude": "14.91667000"
                    },
                    {
                        "id": 3024,
                        "name": "Politischer Bezirk Liezen",
                        "latitude": "47.53521000",
                        "longitude": "14.34314000"
                    },
                    {
                        "id": 3030,
                        "name": "Politischer Bezirk Murau",
                        "latitude": "47.13333000",
                        "longitude": "14.20000000"
                    },
                    {
                        "id": 3031,
                        "name": "Politischer Bezirk Murtal",
                        "latitude": "47.16964000",
                        "longitude": "14.66469000"
                    },
                    {
                        "id": 3050,
                        "name": "Politischer Bezirk Südoststeiermark",
                        "latitude": "46.94089000",
                        "longitude": "15.88623000"
                    },
                    {
                        "id": 3055,
                        "name": "Politischer Bezirk Voitsberg",
                        "latitude": "47.05000000",
                        "longitude": "15.10000000"
                    },
                    {
                        "id": 3059,
                        "name": "Politischer Bezirk Weiz",
                        "latitude": "47.30000000",
                        "longitude": "15.65000000"
                    },
                    {
                        "id": 3105,
                        "name": "Pöllau",
                        "latitude": "47.30000000",
                        "longitude": "15.83333000"
                    },
                    {
                        "id": 3106,
                        "name": "Pöllauberg",
                        "latitude": "47.31667000",
                        "longitude": "15.85000000"
                    },
                    {
                        "id": 3107,
                        "name": "Pöls",
                        "latitude": "47.21667000",
                        "longitude": "14.58333000"
                    },
                    {
                        "id": 3065,
                        "name": "Poppendorf",
                        "latitude": "46.85611000",
                        "longitude": "15.85639000"
                    },
                    {
                        "id": 3076,
                        "name": "Preding",
                        "latitude": "46.85861000",
                        "longitude": "15.40972000"
                    },
                    {
                        "id": 3084,
                        "name": "Proleb",
                        "latitude": "47.40000000",
                        "longitude": "15.13333000"
                    },
                    {
                        "id": 3086,
                        "name": "Pruggern",
                        "latitude": "47.42370000",
                        "longitude": "13.87625000"
                    },
                    {
                        "id": 3089,
                        "name": "Puch bei Weiz",
                        "latitude": "47.21667000",
                        "longitude": "15.71667000"
                    },
                    {
                        "id": 3097,
                        "name": "Puntigam",
                        "latitude": "47.03333000",
                        "longitude": "15.43333000"
                    },
                    {
                        "id": 3101,
                        "name": "Pusterwald",
                        "latitude": "47.30611000",
                        "longitude": "14.37556000"
                    },
                    {
                        "id": 3114,
                        "name": "Raaba",
                        "latitude": "47.03333000",
                        "longitude": "15.50000000"
                    },
                    {
                        "id": 3115,
                        "name": "Raabau",
                        "latitude": "46.96278000",
                        "longitude": "15.91167000"
                    },
                    {
                        "id": 3121,
                        "name": "Rabenwald",
                        "latitude": "47.40000000",
                        "longitude": "15.90000000"
                    },
                    {
                        "id": 3122,
                        "name": "Rachau",
                        "latitude": "47.21667000",
                        "longitude": "14.90000000"
                    },
                    {
                        "id": 3128,
                        "name": "Ragnitz",
                        "latitude": "46.83667000",
                        "longitude": "15.59278000"
                    },
                    {
                        "id": 3134,
                        "name": "Ramsau am Dachstein",
                        "latitude": "47.42150000",
                        "longitude": "13.65545000"
                    },
                    {
                        "id": 3139,
                        "name": "Raning",
                        "latitude": "46.85000000",
                        "longitude": "15.81667000"
                    },
                    {
                        "id": 3143,
                        "name": "Ranten",
                        "latitude": "47.15949000",
                        "longitude": "14.08349000"
                    },
                    {
                        "id": 3145,
                        "name": "Rassach",
                        "latitude": "46.86028000",
                        "longitude": "15.27000000"
                    },
                    {
                        "id": 3147,
                        "name": "Ratsch an der Weinstraße",
                        "latitude": "46.68944000",
                        "longitude": "15.57111000"
                    },
                    {
                        "id": 3148,
                        "name": "Ratschendorf",
                        "latitude": "46.74222000",
                        "longitude": "15.81583000"
                    },
                    {
                        "id": 3149,
                        "name": "Ratten",
                        "latitude": "47.48333000",
                        "longitude": "15.71667000"
                    },
                    {
                        "id": 3164,
                        "name": "Reichendorf",
                        "latitude": "47.18922000",
                        "longitude": "15.76160000"
                    },
                    {
                        "id": 3168,
                        "name": "Reifling",
                        "latitude": "47.13333000",
                        "longitude": "14.66667000"
                    },
                    {
                        "id": 3179,
                        "name": "Rettenegg",
                        "latitude": "47.52694000",
                        "longitude": "15.78104000"
                    },
                    {
                        "id": 3182,
                        "name": "Retznei",
                        "latitude": "46.73333000",
                        "longitude": "15.56667000"
                    },
                    {
                        "id": 3192,
                        "name": "Riegersburg",
                        "latitude": "47.00000000",
                        "longitude": "15.93028000"
                    },
                    {
                        "id": 3193,
                        "name": "Ries",
                        "latitude": "47.08315000",
                        "longitude": "15.48500000"
                    },
                    {
                        "id": 3203,
                        "name": "Rohrbach an der Lafnitz",
                        "latitude": "47.38333000",
                        "longitude": "16.00000000"
                    },
                    {
                        "id": 3212,
                        "name": "Rosental an der Kainach",
                        "latitude": "47.05192000",
                        "longitude": "15.12200000"
                    },
                    {
                        "id": 3226,
                        "name": "Röthelstein",
                        "latitude": "47.31667000",
                        "longitude": "15.36667000"
                    },
                    {
                        "id": 3214,
                        "name": "Rottenmann",
                        "latitude": "47.51667000",
                        "longitude": "14.35000000"
                    },
                    {
                        "id": 3232,
                        "name": "Salla",
                        "latitude": "47.10000000",
                        "longitude": "14.96667000"
                    },
                    {
                        "id": 3243,
                        "name": "Sankt Anna am Aigen",
                        "latitude": "46.83111000",
                        "longitude": "15.97139000"
                    },
                    {
                        "id": 3245,
                        "name": "Sankt Bartholomä",
                        "latitude": "47.05457000",
                        "longitude": "15.25889000"
                    },
                    {
                        "id": 3246,
                        "name": "Sankt Blasen",
                        "latitude": "47.08333000",
                        "longitude": "14.30000000"
                    },
                    {
                        "id": 3250,
                        "name": "Sankt Gallen",
                        "latitude": "47.68631000",
                        "longitude": "14.61705000"
                    },
                    {
                        "id": 3257,
                        "name": "Sankt Georgen an der Stiefing",
                        "latitude": "46.87333000",
                        "longitude": "15.57972000"
                    },
                    {
                        "id": 3260,
                        "name": "Sankt Georgen ob Judenburg",
                        "latitude": "47.20744000",
                        "longitude": "14.49736000"
                    },
                    {
                        "id": 3261,
                        "name": "Sankt Georgen ob Murau",
                        "latitude": "47.10000000",
                        "longitude": "14.10000000"
                    },
                    {
                        "id": 3264,
                        "name": "Sankt Ilgen",
                        "latitude": "47.55000000",
                        "longitude": "15.16667000"
                    },
                    {
                        "id": 3265,
                        "name": "Sankt Jakob im Walde",
                        "latitude": "47.46667000",
                        "longitude": "15.78333000"
                    },
                    {
                        "id": 3266,
                        "name": "Sankt Jakob-Breitenau",
                        "latitude": "47.39229000",
                        "longitude": "15.42970000"
                    },
                    {
                        "id": 3267,
                        "name": "Sankt Johann am Tauern",
                        "latitude": "47.35000000",
                        "longitude": "14.46667000"
                    },
                    {
                        "id": 3268,
                        "name": "Sankt Johann bei Herberstein",
                        "latitude": "47.20000000",
                        "longitude": "15.80000000"
                    },
                    {
                        "id": 3270,
                        "name": "Sankt Johann im Saggautal",
                        "latitude": "46.70389000",
                        "longitude": "15.40278000"
                    },
                    {
                        "id": 3272,
                        "name": "Sankt Johann in der Haide",
                        "latitude": "47.28080000",
                        "longitude": "16.02579000"
                    },
                    {
                        "id": 3273,
                        "name": "Sankt Josef (Weststeiermark)",
                        "latitude": "46.90917000",
                        "longitude": "15.33639000"
                    },
                    {
                        "id": 3274,
                        "name": "Sankt Katharein an der Laming",
                        "latitude": "47.47069000",
                        "longitude": "15.16319000"
                    },
                    {
                        "id": 3275,
                        "name": "Sankt Kathrein am Hauenstein",
                        "latitude": "47.48943000",
                        "longitude": "15.69414000"
                    },
                    {
                        "id": 3276,
                        "name": "Sankt Kathrein am Offenegg",
                        "latitude": "47.30000000",
                        "longitude": "15.58333000"
                    },
                    {
                        "id": 3277,
                        "name": "Sankt Lambrecht",
                        "latitude": "47.06667000",
                        "longitude": "14.30000000"
                    },
                    {
                        "id": 3280,
                        "name": "Sankt Leonhard",
                        "latitude": "47.06924000",
                        "longitude": "15.45784000"
                    },
                    {
                        "id": 3284,
                        "name": "Sankt Lorenzen am Wechsel",
                        "latitude": "47.44153000",
                        "longitude": "15.95498000"
                    },
                    {
                        "id": 3285,
                        "name": "Sankt Lorenzen bei Knittelfeld",
                        "latitude": "47.25078000",
                        "longitude": "14.89549000"
                    },
                    {
                        "id": 3286,
                        "name": "Sankt Lorenzen bei Scheifling",
                        "latitude": "47.14556000",
                        "longitude": "14.40583000"
                    },
                    {
                        "id": 3287,
                        "name": "Sankt Lorenzen im Mürztal",
                        "latitude": "47.48333000",
                        "longitude": "15.36667000"
                    },
                    {
                        "id": 3289,
                        "name": "Sankt Marein bei Graz",
                        "latitude": "47.01583000",
                        "longitude": "15.68389000"
                    },
                    {
                        "id": 3290,
                        "name": "Sankt Marein bei Knittelfeld",
                        "latitude": "47.27396000",
                        "longitude": "14.86085000"
                    },
                    {
                        "id": 3291,
                        "name": "Sankt Marein bei Neumarkt",
                        "latitude": "47.06591000",
                        "longitude": "14.42908000"
                    },
                    {
                        "id": 3292,
                        "name": "Sankt Marein im Mürztal",
                        "latitude": "47.46667000",
                        "longitude": "15.36667000"
                    },
                    {
                        "id": 3294,
                        "name": "Sankt Margarethen an der Raab",
                        "latitude": "47.05000000",
                        "longitude": "15.75000000"
                    },
                    {
                        "id": 3296,
                        "name": "Sankt Margarethen bei Knittelfeld",
                        "latitude": "47.21667000",
                        "longitude": "14.86667000"
                    },
                    {
                        "id": 3300,
                        "name": "Sankt Martin",
                        "latitude": "47.44667000",
                        "longitude": "15.28490000"
                    },
                    {
                        "id": 3303,
                        "name": "Sankt Martin am Grimming",
                        "latitude": "47.48873000",
                        "longitude": "13.98105000"
                    },
                    {
                        "id": 3308,
                        "name": "Sankt Martin im Sulmtal",
                        "latitude": "46.75611000",
                        "longitude": "15.29722000"
                    },
                    {
                        "id": 3311,
                        "name": "Sankt Michael in Obersteiermark",
                        "latitude": "47.33839000",
                        "longitude": "15.01784000"
                    },
                    {
                        "id": 3312,
                        "name": "Sankt Nikolai im Sausal",
                        "latitude": "46.82111000",
                        "longitude": "15.45194000"
                    },
                    {
                        "id": 3313,
                        "name": "Sankt Nikolai im Sölktal",
                        "latitude": "47.31667000",
                        "longitude": "14.05000000"
                    },
                    {
                        "id": 3314,
                        "name": "Sankt Nikolai ob Draßling",
                        "latitude": "46.80889000",
                        "longitude": "15.65083000"
                    },
                    {
                        "id": 3316,
                        "name": "Sankt Oswald bei Plankenwarth",
                        "latitude": "47.08701000",
                        "longitude": "15.27703000"
                    },
                    {
                        "id": 3317,
                        "name": "Sankt Oswald ob Eibiswald",
                        "latitude": "46.70833000",
                        "longitude": "15.14667000"
                    },
                    {
                        "id": 3321,
                        "name": "Sankt Peter",
                        "latitude": "47.05000000",
                        "longitude": "15.46667000"
                    },
                    {
                        "id": 3323,
                        "name": "Sankt Peter am Kammersberg",
                        "latitude": "47.18706000",
                        "longitude": "14.18464000"
                    },
                    {
                        "id": 3324,
                        "name": "Sankt Peter am Ottersbach",
                        "latitude": "46.79778000",
                        "longitude": "15.75917000"
                    },
                    {
                        "id": 3325,
                        "name": "Sankt Peter im Sulmtal",
                        "latitude": "46.75000000",
                        "longitude": "15.25000000"
                    },
                    {
                        "id": 3327,
                        "name": "Sankt Peter ob Judenburg",
                        "latitude": "47.18417000",
                        "longitude": "14.58639000"
                    },
                    {
                        "id": 3328,
                        "name": "Sankt Peter-Freienstein",
                        "latitude": "47.38333000",
                        "longitude": "15.01667000"
                    },
                    {
                        "id": 3331,
                        "name": "Sankt Radegund bei Graz",
                        "latitude": "47.18172000",
                        "longitude": "15.49192000"
                    },
                    {
                        "id": 3333,
                        "name": "Sankt Ruprecht an der Raab",
                        "latitude": "47.15336000",
                        "longitude": "15.66256000"
                    },
                    {
                        "id": 3335,
                        "name": "Sankt Stefan im Rosental",
                        "latitude": "46.90389000",
                        "longitude": "15.71000000"
                    },
                    {
                        "id": 3336,
                        "name": "Sankt Stefan ob Leoben",
                        "latitude": "47.31672000",
                        "longitude": "14.97831000"
                    },
                    {
                        "id": 3337,
                        "name": "Sankt Stefan ob Stainz",
                        "latitude": "46.92861000",
                        "longitude": "15.25889000"
                    },
                    {
                        "id": 3339,
                        "name": "Sankt Ulrich am Waasen",
                        "latitude": "46.93333000",
                        "longitude": "15.53333000"
                    },
                    {
                        "id": 3342,
                        "name": "Sankt Veit am Vogau",
                        "latitude": "46.74048000",
                        "longitude": "15.64217000"
                    },
                    {
                        "id": 3352,
                        "name": "Schachen bei Vorau",
                        "latitude": "47.38010000",
                        "longitude": "15.85816000"
                    },
                    {
                        "id": 3412,
                        "name": "Schäffern",
                        "latitude": "47.47771000",
                        "longitude": "16.10956000"
                    },
                    {
                        "id": 3367,
                        "name": "Scheifling",
                        "latitude": "47.15044000",
                        "longitude": "14.41278000"
                    },
                    {
                        "id": 3371,
                        "name": "Schladming",
                        "latitude": "47.39289000",
                        "longitude": "13.68699000"
                    },
                    {
                        "id": 3415,
                        "name": "Schöder",
                        "latitude": "47.18333000",
                        "longitude": "14.10000000"
                    },
                    {
                        "id": 3389,
                        "name": "Schrems bei Frohnleiten",
                        "latitude": "47.28109000",
                        "longitude": "15.35932000"
                    },
                    {
                        "id": 3393,
                        "name": "Schwanberg",
                        "latitude": "46.75833000",
                        "longitude": "15.20833000"
                    },
                    {
                        "id": 3399,
                        "name": "Schwarzau im Schwarzautal",
                        "latitude": "46.87886000",
                        "longitude": "15.66421000"
                    },
                    {
                        "id": 3425,
                        "name": "Sebersdorf",
                        "latitude": "47.18650000",
                        "longitude": "15.99360000"
                    },
                    {
                        "id": 3426,
                        "name": "Seckau",
                        "latitude": "47.26667000",
                        "longitude": "14.78333000"
                    },
                    {
                        "id": 3436,
                        "name": "Seggauberg",
                        "latitude": "46.76667000",
                        "longitude": "15.51667000"
                    },
                    {
                        "id": 3438,
                        "name": "Seiersberg",
                        "latitude": "47.00000000",
                        "longitude": "15.40000000"
                    },
                    {
                        "id": 3442,
                        "name": "Selzthal",
                        "latitude": "47.54988000",
                        "longitude": "14.31201000"
                    },
                    {
                        "id": 3444,
                        "name": "Semriach",
                        "latitude": "47.21667000",
                        "longitude": "15.40000000"
                    },
                    {
                        "id": 3450,
                        "name": "Siegersdorf bei Herberstein",
                        "latitude": "47.20000000",
                        "longitude": "15.78333000"
                    },
                    {
                        "id": 3462,
                        "name": "Sinabelkirchen",
                        "latitude": "47.10200000",
                        "longitude": "15.82795000"
                    },
                    {
                        "id": 3466,
                        "name": "Soboth",
                        "latitude": "46.68139000",
                        "longitude": "15.07833000"
                    },
                    {
                        "id": 3564,
                        "name": "Söchau",
                        "latitude": "47.03333000",
                        "longitude": "16.01667000"
                    },
                    {
                        "id": 3565,
                        "name": "Södingberg",
                        "latitude": "47.10703000",
                        "longitude": "15.17169000"
                    },
                    {
                        "id": 3473,
                        "name": "Spatenhof",
                        "latitude": "46.96250000",
                        "longitude": "15.36111000"
                    },
                    {
                        "id": 3474,
                        "name": "Spielberg bei Knittelfeld",
                        "latitude": "47.21667000",
                        "longitude": "14.78333000"
                    },
                    {
                        "id": 3475,
                        "name": "Spielfeld",
                        "latitude": "46.70556000",
                        "longitude": "15.63722000"
                    },
                    {
                        "id": 3478,
                        "name": "Spital am Semmering",
                        "latitude": "47.61345000",
                        "longitude": "15.75096000"
                    },
                    {
                        "id": 3488,
                        "name": "Stadl an der Mur",
                        "latitude": "47.08333000",
                        "longitude": "13.96667000"
                    },
                    {
                        "id": 3493,
                        "name": "Stainach",
                        "latitude": "47.53343000",
                        "longitude": "14.10872000"
                    },
                    {
                        "id": 3494,
                        "name": "Stainz",
                        "latitude": "46.89444000",
                        "longitude": "15.26722000"
                    },
                    {
                        "id": 3495,
                        "name": "Stainz bei Straden",
                        "latitude": "46.82444000",
                        "longitude": "15.89222000"
                    },
                    {
                        "id": 3498,
                        "name": "Stallhof",
                        "latitude": "46.88333000",
                        "longitude": "15.28333000"
                    },
                    {
                        "id": 3499,
                        "name": "Stallhofen",
                        "latitude": "47.05000000",
                        "longitude": "15.21667000"
                    },
                    {
                        "id": 3500,
                        "name": "Stambach",
                        "latitude": "47.33333000",
                        "longitude": "15.93333000"
                    },
                    {
                        "id": 3505,
                        "name": "Stattegg",
                        "latitude": "47.13333000",
                        "longitude": "15.41667000"
                    },
                    {
                        "id": 3510,
                        "name": "Stein",
                        "latitude": "46.99778000",
                        "longitude": "16.08694000"
                    },
                    {
                        "id": 3522,
                        "name": "Stenzengreith",
                        "latitude": "47.20000000",
                        "longitude": "15.51667000"
                    },
                    {
                        "id": 3531,
                        "name": "Stiwoll",
                        "latitude": "47.10000000",
                        "longitude": "15.21667000"
                    },
                    {
                        "id": 3537,
                        "name": "Straden",
                        "latitude": "46.80917000",
                        "longitude": "15.86806000"
                    },
                    {
                        "id": 3538,
                        "name": "Strallegg",
                        "latitude": "47.41165000",
                        "longitude": "15.72534000"
                    },
                    {
                        "id": 3547,
                        "name": "Straß in Steiermark",
                        "latitude": "46.72722000",
                        "longitude": "15.62444000"
                    },
                    {
                        "id": 3542,
                        "name": "Strassengel",
                        "latitude": "47.11573000",
                        "longitude": "15.33288000"
                    },
                    {
                        "id": 3549,
                        "name": "Straßgang",
                        "latitude": "47.03333000",
                        "longitude": "15.40000000"
                    },
                    {
                        "id": 3555,
                        "name": "Stubenberg",
                        "latitude": "47.24460000",
                        "longitude": "15.80027000"
                    },
                    {
                        "id": 3556,
                        "name": "Studenzen",
                        "latitude": "47.00583000",
                        "longitude": "15.75417000"
                    },
                    {
                        "id": 3563,
                        "name": "Sulztal an der Weinstraße",
                        "latitude": "46.68333000",
                        "longitude": "15.55000000"
                    },
                    {
                        "id": 3576,
                        "name": "Tauplitz",
                        "latitude": "47.56005000",
                        "longitude": "14.01293000"
                    },
                    {
                        "id": 3585,
                        "name": "Teufenbach",
                        "latitude": "47.12870000",
                        "longitude": "14.35913000"
                    },
                    {
                        "id": 3586,
                        "name": "Thal",
                        "latitude": "47.07644000",
                        "longitude": "15.36052000"
                    },
                    {
                        "id": 3596,
                        "name": "Thörl",
                        "latitude": "47.51952000",
                        "longitude": "15.22276000"
                    },
                    {
                        "id": 3600,
                        "name": "Tieschen",
                        "latitude": "46.78611000",
                        "longitude": "15.94222000"
                    },
                    {
                        "id": 3601,
                        "name": "Tillmitsch",
                        "latitude": "46.81195000",
                        "longitude": "15.51679000"
                    },
                    {
                        "id": 3602,
                        "name": "Tillmitsch Links der Laßnitz",
                        "latitude": "46.80955000",
                        "longitude": "15.52394000"
                    },
                    {
                        "id": 3606,
                        "name": "Traboch",
                        "latitude": "47.37705000",
                        "longitude": "14.98647000"
                    },
                    {
                        "id": 3608,
                        "name": "Trahütten",
                        "latitude": "46.82500000",
                        "longitude": "15.15694000"
                    },
                    {
                        "id": 3617,
                        "name": "Trautmannsdorf in Oststeiermark",
                        "latitude": "46.87530000",
                        "longitude": "15.88451000"
                    },
                    {
                        "id": 3619,
                        "name": "Treglwang",
                        "latitude": "47.47458000",
                        "longitude": "14.59083000"
                    },
                    {
                        "id": 3622,
                        "name": "Trieben",
                        "latitude": "47.48574000",
                        "longitude": "14.48744000"
                    },
                    {
                        "id": 3623,
                        "name": "Triebendorf",
                        "latitude": "47.11667000",
                        "longitude": "14.23333000"
                    },
                    {
                        "id": 3626,
                        "name": "Trofaiach",
                        "latitude": "47.42524000",
                        "longitude": "15.00681000"
                    },
                    {
                        "id": 3628,
                        "name": "Trössing",
                        "latitude": "46.81667000",
                        "longitude": "15.81667000"
                    },
                    {
                        "id": 3635,
                        "name": "Turnau",
                        "latitude": "47.55776000",
                        "longitude": "15.33739000"
                    },
                    {
                        "id": 3899,
                        "name": "Übelbach",
                        "latitude": "47.22534000",
                        "longitude": "15.23615000"
                    },
                    {
                        "id": 3901,
                        "name": "Übersbach",
                        "latitude": "47.02318000",
                        "longitude": "16.05517000"
                    },
                    {
                        "id": 3645,
                        "name": "Ungerdorf",
                        "latitude": "47.08333000",
                        "longitude": "15.66667000"
                    },
                    {
                        "id": 3647,
                        "name": "Unterauersbach",
                        "latitude": "46.86556000",
                        "longitude": "15.77028000"
                    },
                    {
                        "id": 3648,
                        "name": "Unterbergla",
                        "latitude": "46.80746000",
                        "longitude": "15.31516000"
                    },
                    {
                        "id": 3651,
                        "name": "Unterfladnitz",
                        "latitude": "47.18333000",
                        "longitude": "15.66667000"
                    },
                    {
                        "id": 3655,
                        "name": "Unterlamm",
                        "latitude": "46.97694000",
                        "longitude": "16.06389000"
                    },
                    {
                        "id": 3659,
                        "name": "Unterpremstätten",
                        "latitude": "46.96472000",
                        "longitude": "15.40417000"
                    },
                    {
                        "id": 3667,
                        "name": "Utschtal",
                        "latitude": "47.40000000",
                        "longitude": "15.20000000"
                    },
                    {
                        "id": 3673,
                        "name": "Vasoldsberg",
                        "latitude": "47.01634000",
                        "longitude": "15.55835000"
                    },
                    {
                        "id": 3674,
                        "name": "Veitsch",
                        "latitude": "47.57815000",
                        "longitude": "15.49450000"
                    },
                    {
                        "id": 3693,
                        "name": "Vogau",
                        "latitude": "46.73187000",
                        "longitude": "15.60837000"
                    },
                    {
                        "id": 3694,
                        "name": "Voitsberg",
                        "latitude": "47.04445000",
                        "longitude": "15.15313000"
                    },
                    {
                        "id": 3698,
                        "name": "Vorau",
                        "latitude": "47.40548000",
                        "longitude": "15.88754000"
                    },
                    {
                        "id": 3701,
                        "name": "Vordernberg",
                        "latitude": "47.48809000",
                        "longitude": "14.99436000"
                    },
                    {
                        "id": 3710,
                        "name": "Wagna",
                        "latitude": "46.76682000",
                        "longitude": "15.55906000"
                    },
                    {
                        "id": 3712,
                        "name": "Wagnitz",
                        "latitude": "46.98333000",
                        "longitude": "15.46667000"
                    },
                    {
                        "id": 3725,
                        "name": "Wald am Schoberpaß",
                        "latitude": "47.44936000",
                        "longitude": "14.67567000"
                    },
                    {
                        "id": 3742,
                        "name": "Waltendorf",
                        "latitude": "47.06667000",
                        "longitude": "15.46667000"
                    },
                    {
                        "id": 3745,
                        "name": "Wartberg",
                        "latitude": "47.52717000",
                        "longitude": "15.48095000"
                    },
                    {
                        "id": 3766,
                        "name": "Weinburg am Saßbach",
                        "latitude": "46.75361000",
                        "longitude": "15.72111000"
                    },
                    {
                        "id": 3781,
                        "name": "Weißenbach bei Liezen",
                        "latitude": "47.56667000",
                        "longitude": "14.21667000"
                    },
                    {
                        "id": 3784,
                        "name": "Weißkirchen in Steiermark",
                        "latitude": "47.15000000",
                        "longitude": "14.73333000"
                    },
                    {
                        "id": 3780,
                        "name": "Weiz",
                        "latitude": "47.21667000",
                        "longitude": "15.61667000"
                    },
                    {
                        "id": 3795,
                        "name": "Werndorf",
                        "latitude": "46.92417000",
                        "longitude": "15.49083000"
                    },
                    {
                        "id": 3796,
                        "name": "Wernersdorf",
                        "latitude": "46.71592000",
                        "longitude": "15.20718000"
                    },
                    {
                        "id": 3799,
                        "name": "Wettmannstätten",
                        "latitude": "46.83056000",
                        "longitude": "15.38722000"
                    },
                    {
                        "id": 3800,
                        "name": "Wetzelsdorf",
                        "latitude": "47.05293000",
                        "longitude": "15.39923000"
                    },
                    {
                        "id": 3807,
                        "name": "Wies",
                        "latitude": "46.72028000",
                        "longitude": "15.27194000"
                    },
                    {
                        "id": 3813,
                        "name": "Wildalpen",
                        "latitude": "47.65000000",
                        "longitude": "14.98333000"
                    },
                    {
                        "id": 3815,
                        "name": "Wildon",
                        "latitude": "46.88333000",
                        "longitude": "15.51667000"
                    },
                    {
                        "id": 3834,
                        "name": "Winklern bei Oberwölz",
                        "latitude": "47.20000000",
                        "longitude": "14.23333000"
                    },
                    {
                        "id": 3843,
                        "name": "Wolfsberg im Schwarzautal",
                        "latitude": "46.84389000",
                        "longitude": "15.65889000"
                    },
                    {
                        "id": 3858,
                        "name": "Wörschach",
                        "latitude": "47.55000000",
                        "longitude": "14.15000000"
                    },
                    {
                        "id": 3860,
                        "name": "Wörth an der Lafnitz",
                        "latitude": "47.21368000",
                        "longitude": "16.08081000"
                    },
                    {
                        "id": 3852,
                        "name": "Wundschuh",
                        "latitude": "46.92639000",
                        "longitude": "15.45111000"
                    },
                    {
                        "id": 3881,
                        "name": "Zeltweg",
                        "latitude": "47.18333000",
                        "longitude": "14.75000000"
                    },
                    {
                        "id": 3882,
                        "name": "Zerlach",
                        "latitude": "46.94593000",
                        "longitude": "15.65093000"
                    },
                    {
                        "id": 3883,
                        "name": "Zettling",
                        "latitude": "46.95220000",
                        "longitude": "15.43420000"
                    },
                    {
                        "id": 3884,
                        "name": "Zeutschach",
                        "latitude": "47.06667000",
                        "longitude": "14.36667000"
                    }
                ]
            },
            {
                "id": 2064,
                "name": "Tyrol",
                "iso2": "7",
                "latitude": "47.25374140",
                "longitude": "11.60148700",
                "type": "state",
                "cities": [
                    {
                        "id": 1600,
                        "name": "Abfaltersbach",
                        "latitude": "46.75715000",
                        "longitude": "12.52828000"
                    },
                    {
                        "id": 1601,
                        "name": "Absam",
                        "latitude": "47.29572000",
                        "longitude": "11.50593000"
                    },
                    {
                        "id": 1607,
                        "name": "Achenkirch",
                        "latitude": "47.52659000",
                        "longitude": "11.70559000"
                    },
                    {
                        "id": 1620,
                        "name": "Ainet",
                        "latitude": "46.86603000",
                        "longitude": "12.68968000"
                    },
                    {
                        "id": 1625,
                        "name": "Aldrans",
                        "latitude": "47.25000000",
                        "longitude": "11.45000000"
                    },
                    {
                        "id": 1634,
                        "name": "Alpbach",
                        "latitude": "47.39878000",
                        "longitude": "11.94373000"
                    },
                    {
                        "id": 1652,
                        "name": "Amlach",
                        "latitude": "46.81639000",
                        "longitude": "12.76361000"
                    },
                    {
                        "id": 1653,
                        "name": "Ampass",
                        "latitude": "47.26251000",
                        "longitude": "11.46226000"
                    },
                    {
                        "id": 1655,
                        "name": "Amras",
                        "latitude": "47.25000000",
                        "longitude": "11.41667000"
                    },
                    {
                        "id": 1662,
                        "name": "Angath",
                        "latitude": "47.50758000",
                        "longitude": "12.06513000"
                    },
                    {
                        "id": 1665,
                        "name": "Angerberg",
                        "latitude": "47.50563000",
                        "longitude": "12.03119000"
                    },
                    {
                        "id": 1669,
                        "name": "Anras",
                        "latitude": "46.77389000",
                        "longitude": "12.56083000"
                    },
                    {
                        "id": 1683,
                        "name": "Arzl",
                        "latitude": "47.28333000",
                        "longitude": "11.43333000"
                    },
                    {
                        "id": 1684,
                        "name": "Arzl im Pitztal",
                        "latitude": "47.20712000",
                        "longitude": "10.76261000"
                    },
                    {
                        "id": 1687,
                        "name": "Aschau",
                        "latitude": "47.26667000",
                        "longitude": "11.90000000"
                    },
                    {
                        "id": 1688,
                        "name": "Aschau im Zillertal",
                        "latitude": "47.26613000",
                        "longitude": "11.89536000"
                    },
                    {
                        "id": 1709,
                        "name": "Aurach",
                        "latitude": "47.41223000",
                        "longitude": "12.42734000"
                    },
                    {
                        "id": 1713,
                        "name": "Außervillgraten",
                        "latitude": "46.78750000",
                        "longitude": "12.43139000"
                    },
                    {
                        "id": 1714,
                        "name": "Axams",
                        "latitude": "47.23111000",
                        "longitude": "11.27892000"
                    },
                    {
                        "id": 1727,
                        "name": "Bad Häring",
                        "latitude": "47.51071000",
                        "longitude": "12.11912000"
                    },
                    {
                        "id": 1748,
                        "name": "Barwies",
                        "latitude": "47.30000000",
                        "longitude": "10.96667000"
                    },
                    {
                        "id": 1751,
                        "name": "Baumkirchen",
                        "latitude": "47.30000000",
                        "longitude": "11.56667000"
                    },
                    {
                        "id": 1766,
                        "name": "Berwang",
                        "latitude": "47.40807000",
                        "longitude": "10.74735000"
                    },
                    {
                        "id": 1769,
                        "name": "Biberwier",
                        "latitude": "47.38333000",
                        "longitude": "10.90000000"
                    },
                    {
                        "id": 1770,
                        "name": "Bichlbach",
                        "latitude": "47.42033000",
                        "longitude": "10.79042000"
                    },
                    {
                        "id": 1774,
                        "name": "Birgitz",
                        "latitude": "47.23536000",
                        "longitude": "11.29922000"
                    },
                    {
                        "id": 1791,
                        "name": "Brandenberg",
                        "latitude": "47.49053000",
                        "longitude": "11.89459000"
                    },
                    {
                        "id": 1797,
                        "name": "Breitenbach am Inn",
                        "latitude": "47.47829000",
                        "longitude": "11.97372000"
                    },
                    {
                        "id": 1802,
                        "name": "Breitenwang",
                        "latitude": "47.48713000",
                        "longitude": "10.73420000"
                    },
                    {
                        "id": 1804,
                        "name": "Brixen im Thale",
                        "latitude": "47.45000000",
                        "longitude": "12.25000000"
                    },
                    {
                        "id": 1805,
                        "name": "Brixlegg",
                        "latitude": "47.42942000",
                        "longitude": "11.87794000"
                    },
                    {
                        "id": 1807,
                        "name": "Bruck am Ziller",
                        "latitude": "47.38998000",
                        "longitude": "11.85124000"
                    },
                    {
                        "id": 1817,
                        "name": "Buch in Tirol",
                        "latitude": "47.37447000",
                        "longitude": "11.75400000"
                    },
                    {
                        "id": 1831,
                        "name": "Debant",
                        "latitude": "46.83333000",
                        "longitude": "12.81667000"
                    },
                    {
                        "id": 1872,
                        "name": "Dölsach",
                        "latitude": "46.82833000",
                        "longitude": "12.84528000"
                    },
                    {
                        "id": 1880,
                        "name": "Ebbs",
                        "latitude": "47.63333000",
                        "longitude": "12.21667000"
                    },
                    {
                        "id": 1881,
                        "name": "Eben am Achensee",
                        "latitude": "47.41380000",
                        "longitude": "11.76138000"
                    },
                    {
                        "id": 1913,
                        "name": "Ehenbichl",
                        "latitude": "47.46667000",
                        "longitude": "10.70000000"
                    },
                    {
                        "id": 1915,
                        "name": "Ehrwald",
                        "latitude": "47.40000000",
                        "longitude": "10.91667000"
                    },
                    {
                        "id": 1928,
                        "name": "Elbigenalp",
                        "latitude": "47.29041000",
                        "longitude": "10.43607000"
                    },
                    {
                        "id": 1930,
                        "name": "Ellbögen",
                        "latitude": "47.16667000",
                        "longitude": "11.45000000"
                    },
                    {
                        "id": 1931,
                        "name": "Ellmau",
                        "latitude": "47.51378000",
                        "longitude": "12.29937000"
                    },
                    {
                        "id": 1932,
                        "name": "Elmen",
                        "latitude": "47.34039000",
                        "longitude": "10.54318000"
                    },
                    {
                        "id": 1937,
                        "name": "Endach",
                        "latitude": "47.56796000",
                        "longitude": "12.15603000"
                    },
                    {
                        "id": 1946,
                        "name": "Erl",
                        "latitude": "47.68333000",
                        "longitude": "12.18333000"
                    },
                    {
                        "id": 1951,
                        "name": "Erpfendorf",
                        "latitude": "47.58333000",
                        "longitude": "12.46667000"
                    },
                    {
                        "id": 1979,
                        "name": "Fendels",
                        "latitude": "47.05390000",
                        "longitude": "10.67777000"
                    },
                    {
                        "id": 1984,
                        "name": "Fieberbrunn",
                        "latitude": "47.47626000",
                        "longitude": "12.54347000"
                    },
                    {
                        "id": 1985,
                        "name": "Fiecht",
                        "latitude": "47.35000000",
                        "longitude": "11.70000000"
                    },
                    {
                        "id": 1987,
                        "name": "Finkenberg",
                        "latitude": "47.15279000",
                        "longitude": "11.82212000"
                    },
                    {
                        "id": 1993,
                        "name": "Fiss",
                        "latitude": "47.05714000",
                        "longitude": "10.61747000"
                    },
                    {
                        "id": 1998,
                        "name": "Flaurling",
                        "latitude": "47.29143000",
                        "longitude": "11.12319000"
                    },
                    {
                        "id": 1999,
                        "name": "Fliess",
                        "latitude": "47.11667000",
                        "longitude": "10.61667000"
                    },
                    {
                        "id": 2000,
                        "name": "Flirsch",
                        "latitude": "47.15000000",
                        "longitude": "10.40000000"
                    },
                    {
                        "id": 2004,
                        "name": "Forchach",
                        "latitude": "47.41667000",
                        "longitude": "10.58333000"
                    },
                    {
                        "id": 2025,
                        "name": "Fritzens",
                        "latitude": "47.30535000",
                        "longitude": "11.58950000"
                    },
                    {
                        "id": 2034,
                        "name": "Fügen",
                        "latitude": "47.34700000",
                        "longitude": "11.84939000"
                    },
                    {
                        "id": 2035,
                        "name": "Fügenberg",
                        "latitude": "47.35210000",
                        "longitude": "11.84173000"
                    },
                    {
                        "id": 2028,
                        "name": "Fulpmes",
                        "latitude": "47.15202000",
                        "longitude": "11.34922000"
                    },
                    {
                        "id": 2050,
                        "name": "Gallzein",
                        "latitude": "47.36807000",
                        "longitude": "11.77159000"
                    },
                    {
                        "id": 2051,
                        "name": "Galtür",
                        "latitude": "46.96667000",
                        "longitude": "10.18333000"
                    },
                    {
                        "id": 2076,
                        "name": "Gerlos",
                        "latitude": "47.22464000",
                        "longitude": "12.03012000"
                    },
                    {
                        "id": 2077,
                        "name": "Gerlosberg",
                        "latitude": "47.21667000",
                        "longitude": "11.93333000"
                    },
                    {
                        "id": 2096,
                        "name": "Gnadenwald",
                        "latitude": "47.31667000",
                        "longitude": "11.56667000"
                    },
                    {
                        "id": 2101,
                        "name": "Going",
                        "latitude": "47.51332000",
                        "longitude": "12.33164000"
                    },
                    {
                        "id": 2194,
                        "name": "Götzens",
                        "latitude": "47.23606000",
                        "longitude": "11.31154000"
                    },
                    {
                        "id": 2116,
                        "name": "Gramais",
                        "latitude": "47.26667000",
                        "longitude": "10.53333000"
                    },
                    {
                        "id": 2164,
                        "name": "Grän",
                        "latitude": "47.50000000",
                        "longitude": "10.55000000"
                    },
                    {
                        "id": 2132,
                        "name": "Gries am Brenner",
                        "latitude": "47.03849000",
                        "longitude": "11.48131000"
                    },
                    {
                        "id": 2133,
                        "name": "Gries im Sellrain",
                        "latitude": "47.19554000",
                        "longitude": "11.15619000"
                    },
                    {
                        "id": 2137,
                        "name": "Grins",
                        "latitude": "47.14034000",
                        "longitude": "10.51409000"
                    },
                    {
                        "id": 2138,
                        "name": "Grinzens",
                        "latitude": "47.22927000",
                        "longitude": "11.25318000"
                    },
                    {
                        "id": 2170,
                        "name": "Gschnitz",
                        "latitude": "47.04469000",
                        "longitude": "11.35089000"
                    },
                    {
                        "id": 2215,
                        "name": "Haiming",
                        "latitude": "47.25000000",
                        "longitude": "10.88333000"
                    },
                    {
                        "id": 2220,
                        "name": "Hainzenberg",
                        "latitude": "47.21788000",
                        "longitude": "11.90034000"
                    },
                    {
                        "id": 2224,
                        "name": "Hall in Tirol",
                        "latitude": "47.28333000",
                        "longitude": "11.51667000"
                    },
                    {
                        "id": 2237,
                        "name": "Hart im Zillertal",
                        "latitude": "47.35106000",
                        "longitude": "11.86476000"
                    },
                    {
                        "id": 2335,
                        "name": "Häselgehr",
                        "latitude": "47.31667000",
                        "longitude": "10.50000000"
                    },
                    {
                        "id": 2245,
                        "name": "Hatting",
                        "latitude": "47.27870000",
                        "longitude": "11.16838000"
                    },
                    {
                        "id": 2265,
                        "name": "Heinfels",
                        "latitude": "46.75000000",
                        "longitude": "12.45000000"
                    },
                    {
                        "id": 2266,
                        "name": "Heiterwang",
                        "latitude": "47.45000000",
                        "longitude": "10.75000000"
                    },
                    {
                        "id": 2289,
                        "name": "Hippach",
                        "latitude": "47.20435000",
                        "longitude": "11.86523000"
                    },
                    {
                        "id": 2298,
                        "name": "Hochfilzen",
                        "latitude": "47.46667000",
                        "longitude": "12.61667000"
                    },
                    {
                        "id": 2338,
                        "name": "Höfen",
                        "latitude": "47.46667000",
                        "longitude": "10.68333000"
                    },
                    {
                        "id": 2326,
                        "name": "Holzgau",
                        "latitude": "47.26045000",
                        "longitude": "10.34419000"
                    },
                    {
                        "id": 2328,
                        "name": "Hopfgarten im Brixental",
                        "latitude": "47.44980000",
                        "longitude": "12.15659000"
                    },
                    {
                        "id": 2329,
                        "name": "Hopfgarten in Defereggen",
                        "latitude": "46.91917000",
                        "longitude": "12.53639000"
                    },
                    {
                        "id": 2345,
                        "name": "Hötting",
                        "latitude": "47.26815000",
                        "longitude": "11.36868000"
                    },
                    {
                        "id": 2350,
                        "name": "Igls",
                        "latitude": "47.23127000",
                        "longitude": "11.41018000"
                    },
                    {
                        "id": 2353,
                        "name": "Imst",
                        "latitude": "47.24504000",
                        "longitude": "10.73974000"
                    },
                    {
                        "id": 2354,
                        "name": "Imsterberg",
                        "latitude": "47.20517000",
                        "longitude": "10.69605000"
                    },
                    {
                        "id": 2359,
                        "name": "Innervillgraten",
                        "latitude": "46.81194000",
                        "longitude": "12.37472000"
                    },
                    {
                        "id": 2360,
                        "name": "Innsbruck",
                        "latitude": "47.26266000",
                        "longitude": "11.39454000"
                    },
                    {
                        "id": 2361,
                        "name": "Innsbruck Stadt",
                        "latitude": "47.28433000",
                        "longitude": "11.37706000"
                    },
                    {
                        "id": 2364,
                        "name": "Inzing",
                        "latitude": "47.27370000",
                        "longitude": "11.19751000"
                    },
                    {
                        "id": 2368,
                        "name": "Ischgl",
                        "latitude": "47.01257000",
                        "longitude": "10.29179000"
                    },
                    {
                        "id": 2369,
                        "name": "Itter",
                        "latitude": "47.46667000",
                        "longitude": "12.13333000"
                    },
                    {
                        "id": 2376,
                        "name": "Jenbach",
                        "latitude": "47.39173000",
                        "longitude": "11.77245000"
                    },
                    {
                        "id": 2378,
                        "name": "Jerzens",
                        "latitude": "47.15120000",
                        "longitude": "10.74686000"
                    },
                    {
                        "id": 2379,
                        "name": "Jochberg",
                        "latitude": "47.37920000",
                        "longitude": "12.41807000"
                    },
                    {
                        "id": 2384,
                        "name": "Jungholz",
                        "latitude": "47.57409000",
                        "longitude": "10.44723000"
                    },
                    {
                        "id": 2393,
                        "name": "Kaltenbach",
                        "latitude": "47.28333000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 2401,
                        "name": "Kapfing",
                        "latitude": "47.33333000",
                        "longitude": "11.85000000"
                    },
                    {
                        "id": 2403,
                        "name": "Kappl",
                        "latitude": "47.06667000",
                        "longitude": "10.38333000"
                    },
                    {
                        "id": 2406,
                        "name": "Karres",
                        "latitude": "47.21667000",
                        "longitude": "10.78333000"
                    },
                    {
                        "id": 2407,
                        "name": "Karrösten",
                        "latitude": "47.22540000",
                        "longitude": "10.76561000"
                    },
                    {
                        "id": 2408,
                        "name": "Kartitsch",
                        "latitude": "46.72889000",
                        "longitude": "12.50083000"
                    },
                    {
                        "id": 2413,
                        "name": "Kauns",
                        "latitude": "47.07822000",
                        "longitude": "10.69219000"
                    },
                    {
                        "id": 2417,
                        "name": "Kematen in Tirol",
                        "latitude": "47.25000000",
                        "longitude": "11.26667000"
                    },
                    {
                        "id": 2431,
                        "name": "Kirchberg in Tirol",
                        "latitude": "47.44539000",
                        "longitude": "12.31602000"
                    },
                    {
                        "id": 2433,
                        "name": "Kirchbichl",
                        "latitude": "47.51743000",
                        "longitude": "12.09629000"
                    },
                    {
                        "id": 2435,
                        "name": "Kirchdorf in Tirol",
                        "latitude": "47.55626000",
                        "longitude": "12.44511000"
                    },
                    {
                        "id": 2443,
                        "name": "Kitzbühel",
                        "latitude": "47.44637000",
                        "longitude": "12.39215000"
                    },
                    {
                        "id": 2472,
                        "name": "Kolsass",
                        "latitude": "47.30000000",
                        "longitude": "11.63333000"
                    },
                    {
                        "id": 2473,
                        "name": "Kolsassberg",
                        "latitude": "47.28150000",
                        "longitude": "11.65289000"
                    },
                    {
                        "id": 2512,
                        "name": "Kössen",
                        "latitude": "47.66990000",
                        "longitude": "12.40545000"
                    },
                    {
                        "id": 2481,
                        "name": "Kramsach",
                        "latitude": "47.44312000",
                        "longitude": "11.87545000"
                    },
                    {
                        "id": 2503,
                        "name": "Kufstein",
                        "latitude": "47.58333000",
                        "longitude": "12.16667000"
                    },
                    {
                        "id": 2507,
                        "name": "Kundl",
                        "latitude": "47.46667000",
                        "longitude": "11.98333000"
                    },
                    {
                        "id": 2526,
                        "name": "Ladis",
                        "latitude": "47.07459000",
                        "longitude": "10.64949000"
                    },
                    {
                        "id": 2530,
                        "name": "Landeck",
                        "latitude": "47.13988000",
                        "longitude": "10.56593000"
                    },
                    {
                        "id": 2623,
                        "name": "Längenfeld",
                        "latitude": "47.07398000",
                        "longitude": "10.96951000"
                    },
                    {
                        "id": 2548,
                        "name": "Lans",
                        "latitude": "47.23833000",
                        "longitude": "11.43139000"
                    },
                    {
                        "id": 2557,
                        "name": "Lavant",
                        "latitude": "46.79889000",
                        "longitude": "12.83806000"
                    },
                    {
                        "id": 2560,
                        "name": "Lechaschau",
                        "latitude": "47.48804000",
                        "longitude": "10.70652000"
                    },
                    {
                        "id": 2565,
                        "name": "Leisach",
                        "latitude": "46.81250000",
                        "longitude": "12.74861000"
                    },
                    {
                        "id": 2587,
                        "name": "Lermoos",
                        "latitude": "47.40358000",
                        "longitude": "10.88070000"
                    },
                    {
                        "id": 2588,
                        "name": "Leutasch",
                        "latitude": "47.36890000",
                        "longitude": "11.14404000"
                    },
                    {
                        "id": 2596,
                        "name": "Lienz",
                        "latitude": "46.82890000",
                        "longitude": "12.76903000"
                    },
                    {
                        "id": 2655,
                        "name": "Mariastein",
                        "latitude": "47.52772000",
                        "longitude": "12.05479000"
                    },
                    {
                        "id": 2656,
                        "name": "Mariatal",
                        "latitude": "47.44788000",
                        "longitude": "11.87210000"
                    },
                    {
                        "id": 2667,
                        "name": "Matrei am Brenner",
                        "latitude": "47.12794000",
                        "longitude": "11.45176000"
                    },
                    {
                        "id": 2668,
                        "name": "Matrei in Osttirol",
                        "latitude": "47.00000000",
                        "longitude": "12.53333000"
                    },
                    {
                        "id": 2677,
                        "name": "Maurach",
                        "latitude": "47.42124000",
                        "longitude": "11.75305000"
                    },
                    {
                        "id": 2682,
                        "name": "Mayrhofen",
                        "latitude": "47.16667000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 2683,
                        "name": "Medraz",
                        "latitude": "47.14256000",
                        "longitude": "11.34287000"
                    },
                    {
                        "id": 2699,
                        "name": "Mieders",
                        "latitude": "47.16667000",
                        "longitude": "11.38333000"
                    },
                    {
                        "id": 2700,
                        "name": "Mieming",
                        "latitude": "47.30000000",
                        "longitude": "10.98333000"
                    },
                    {
                        "id": 2703,
                        "name": "Mils bei Imst",
                        "latitude": "47.20616000",
                        "longitude": "10.67485000"
                    },
                    {
                        "id": 2704,
                        "name": "Mils bei Solbad Hall",
                        "latitude": "47.28333000",
                        "longitude": "11.53333000"
                    },
                    {
                        "id": 2715,
                        "name": "Mitterndorf",
                        "latitude": "47.57728000",
                        "longitude": "12.16968000"
                    },
                    {
                        "id": 2750,
                        "name": "Mötz",
                        "latitude": "47.28333000",
                        "longitude": "10.95000000"
                    },
                    {
                        "id": 2751,
                        "name": "Mühlau",
                        "latitude": "47.28333000",
                        "longitude": "11.40000000"
                    },
                    {
                        "id": 2753,
                        "name": "Mühlbachl",
                        "latitude": "47.13333000",
                        "longitude": "11.45000000"
                    },
                    {
                        "id": 2762,
                        "name": "Münster",
                        "latitude": "47.42164000",
                        "longitude": "11.83356000"
                    },
                    {
                        "id": 2737,
                        "name": "Musau",
                        "latitude": "47.53195000",
                        "longitude": "10.67339000"
                    },
                    {
                        "id": 2738,
                        "name": "Mutters",
                        "latitude": "47.23333000",
                        "longitude": "11.38333000"
                    },
                    {
                        "id": 2770,
                        "name": "Namlos",
                        "latitude": "47.35000000",
                        "longitude": "10.66667000"
                    },
                    {
                        "id": 2771,
                        "name": "Nassereith",
                        "latitude": "47.31667000",
                        "longitude": "10.83333000"
                    },
                    {
                        "id": 2773,
                        "name": "Natters",
                        "latitude": "47.23414000",
                        "longitude": "11.37342000"
                    },
                    {
                        "id": 2774,
                        "name": "Nauders",
                        "latitude": "46.88859000",
                        "longitude": "10.50126000"
                    },
                    {
                        "id": 2779,
                        "name": "Nesselwängle",
                        "latitude": "47.48333000",
                        "longitude": "10.61667000"
                    },
                    {
                        "id": 2815,
                        "name": "Neustift im Stubaital",
                        "latitude": "47.11667000",
                        "longitude": "11.31667000"
                    },
                    {
                        "id": 2821,
                        "name": "Niederau",
                        "latitude": "47.45000000",
                        "longitude": "12.08333000"
                    },
                    {
                        "id": 2822,
                        "name": "Niederbreitenbach",
                        "latitude": "47.53333000",
                        "longitude": "12.08333000"
                    },
                    {
                        "id": 2826,
                        "name": "Niederndorf",
                        "latitude": "47.65000000",
                        "longitude": "12.21667000"
                    },
                    {
                        "id": 2836,
                        "name": "Nikolsdorf",
                        "latitude": "46.78583000",
                        "longitude": "12.91333000"
                    },
                    {
                        "id": 2846,
                        "name": "Oberau",
                        "latitude": "47.44336000",
                        "longitude": "12.04891000"
                    },
                    {
                        "id": 2856,
                        "name": "Oberhofen im Inntal",
                        "latitude": "47.30000000",
                        "longitude": "11.08333000"
                    },
                    {
                        "id": 2858,
                        "name": "Oberlienz",
                        "latitude": "46.84722000",
                        "longitude": "12.73139000"
                    },
                    {
                        "id": 2860,
                        "name": "Obermieming",
                        "latitude": "47.30000000",
                        "longitude": "10.98333000"
                    },
                    {
                        "id": 2861,
                        "name": "Obernberg am Brenner",
                        "latitude": "47.01667000",
                        "longitude": "11.41667000"
                    },
                    {
                        "id": 2866,
                        "name": "Oberndorf in Tirol",
                        "latitude": "47.50000000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 2869,
                        "name": "Oberperfuss",
                        "latitude": "47.24451000",
                        "longitude": "11.24755000"
                    },
                    {
                        "id": 2877,
                        "name": "Obertilliach",
                        "latitude": "46.71056000",
                        "longitude": "12.61444000"
                    },
                    {
                        "id": 2889,
                        "name": "Obsteig",
                        "latitude": "47.30000000",
                        "longitude": "10.93333000"
                    },
                    {
                        "id": 2893,
                        "name": "Oetz",
                        "latitude": "47.20000000",
                        "longitude": "10.90000000"
                    },
                    {
                        "id": 3898,
                        "name": "Ötztal-Bahnhof",
                        "latitude": "47.23333000",
                        "longitude": "10.85000000"
                    },
                    {
                        "id": 2929,
                        "name": "Patsch",
                        "latitude": "47.20527000",
                        "longitude": "11.41510000"
                    },
                    {
                        "id": 2949,
                        "name": "Pettnau",
                        "latitude": "47.29204000",
                        "longitude": "11.15962000"
                    },
                    {
                        "id": 2950,
                        "name": "Pettneu",
                        "latitude": "47.14595000",
                        "longitude": "10.33655000"
                    },
                    {
                        "id": 2953,
                        "name": "Pfaffenhofen",
                        "latitude": "47.30000000",
                        "longitude": "11.08333000"
                    },
                    {
                        "id": 2958,
                        "name": "Pflach",
                        "latitude": "47.51667000",
                        "longitude": "10.71667000"
                    },
                    {
                        "id": 2959,
                        "name": "Pfons",
                        "latitude": "47.14201000",
                        "longitude": "11.46071000"
                    },
                    {
                        "id": 2960,
                        "name": "Pfunds",
                        "latitude": "46.96667000",
                        "longitude": "10.55000000"
                    },
                    {
                        "id": 2961,
                        "name": "Pians",
                        "latitude": "47.13486000",
                        "longitude": "10.51237000"
                    },
                    {
                        "id": 2969,
                        "name": "Pill",
                        "latitude": "47.32352000",
                        "longitude": "11.68018000"
                    },
                    {
                        "id": 3011,
                        "name": "Politischer Bezirk Imst",
                        "latitude": "47.08333000",
                        "longitude": "10.86667000"
                    },
                    {
                        "id": 3012,
                        "name": "Politischer Bezirk Innsbruck Land",
                        "latitude": "47.20000000",
                        "longitude": "11.33333000"
                    },
                    {
                        "id": 3015,
                        "name": "Politischer Bezirk Kitzbühel",
                        "latitude": "47.43333000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 3019,
                        "name": "Politischer Bezirk Kufstein",
                        "latitude": "47.50000000",
                        "longitude": "12.03333000"
                    },
                    {
                        "id": 3020,
                        "name": "Politischer Bezirk Landeck",
                        "latitude": "47.12575000",
                        "longitude": "10.56679000"
                    },
                    {
                        "id": 3023,
                        "name": "Politischer Bezirk Lienz",
                        "latitude": "46.90000000",
                        "longitude": "12.50000000"
                    },
                    {
                        "id": 3038,
                        "name": "Politischer Bezirk Reutte",
                        "latitude": "47.41667000",
                        "longitude": "10.55000000"
                    },
                    {
                        "id": 3046,
                        "name": "Politischer Bezirk Schwaz",
                        "latitude": "47.26667000",
                        "longitude": "11.76667000"
                    },
                    {
                        "id": 3064,
                        "name": "Polling in Tirol",
                        "latitude": "47.28333000",
                        "longitude": "11.15000000"
                    },
                    {
                        "id": 3072,
                        "name": "Pradl",
                        "latitude": "47.26539000",
                        "longitude": "11.41520000"
                    },
                    {
                        "id": 3087,
                        "name": "Prutz",
                        "latitude": "47.08333000",
                        "longitude": "10.66667000"
                    },
                    {
                        "id": 3124,
                        "name": "Radfeld",
                        "latitude": "47.44806000",
                        "longitude": "11.91424000"
                    },
                    {
                        "id": 3135,
                        "name": "Ramsau im Zillertal",
                        "latitude": "47.20383000",
                        "longitude": "11.87545000"
                    },
                    {
                        "id": 3138,
                        "name": "Ranggen",
                        "latitude": "47.25727000",
                        "longitude": "11.21120000"
                    },
                    {
                        "id": 3150,
                        "name": "Rattenberg",
                        "latitude": "47.43941000",
                        "longitude": "11.89407000"
                    },
                    {
                        "id": 3175,
                        "name": "Reith bei Kitzbühel",
                        "latitude": "47.46667000",
                        "longitude": "12.35000000"
                    },
                    {
                        "id": 3176,
                        "name": "Reith bei Seefeld",
                        "latitude": "47.30000000",
                        "longitude": "11.20000000"
                    },
                    {
                        "id": 3177,
                        "name": "Reith im Alpbachtal",
                        "latitude": "47.41694000",
                        "longitude": "11.87785000"
                    },
                    {
                        "id": 3180,
                        "name": "Rettenschöss",
                        "latitude": "47.65718000",
                        "longitude": "12.26872000"
                    },
                    {
                        "id": 3184,
                        "name": "Reutte",
                        "latitude": "47.48333000",
                        "longitude": "10.71667000"
                    },
                    {
                        "id": 3186,
                        "name": "Ried im Oberinntal",
                        "latitude": "47.05000000",
                        "longitude": "10.65000000"
                    },
                    {
                        "id": 3188,
                        "name": "Ried im Zillertal",
                        "latitude": "47.30000000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 3194,
                        "name": "Rietz",
                        "latitude": "47.28593000",
                        "longitude": "11.03075000"
                    },
                    {
                        "id": 3196,
                        "name": "Rinn",
                        "latitude": "47.25000000",
                        "longitude": "11.50000000"
                    },
                    {
                        "id": 3206,
                        "name": "Rohrberg",
                        "latitude": "47.23333000",
                        "longitude": "11.91667000"
                    },
                    {
                        "id": 3209,
                        "name": "Roppen",
                        "latitude": "47.21667000",
                        "longitude": "10.81667000"
                    },
                    {
                        "id": 3218,
                        "name": "Rum",
                        "latitude": "47.28333000",
                        "longitude": "11.45000000"
                    },
                    {
                        "id": 3271,
                        "name": "Sankt Johann in Tirol",
                        "latitude": "47.52330000",
                        "longitude": "12.42320000"
                    },
                    {
                        "id": 3338,
                        "name": "Sankt Ulrich am Pillersee",
                        "latitude": "47.52740000",
                        "longitude": "12.57239000"
                    },
                    {
                        "id": 3346,
                        "name": "Sankt Veit in Defereggen",
                        "latitude": "46.92722000",
                        "longitude": "12.42972000"
                    },
                    {
                        "id": 3351,
                        "name": "Sautens",
                        "latitude": "47.20000000",
                        "longitude": "10.86667000"
                    },
                    {
                        "id": 3360,
                        "name": "Scharnitz",
                        "latitude": "47.38899000",
                        "longitude": "11.26455000"
                    },
                    {
                        "id": 3363,
                        "name": "Schattwald",
                        "latitude": "47.51427000",
                        "longitude": "10.46143000"
                    },
                    {
                        "id": 3365,
                        "name": "Scheffau am Wilden Kaiser",
                        "latitude": "47.52943000",
                        "longitude": "12.25139000"
                    },
                    {
                        "id": 3372,
                        "name": "Schlaiten",
                        "latitude": "46.87944000",
                        "longitude": "12.65417000"
                    },
                    {
                        "id": 3379,
                        "name": "Schlitters",
                        "latitude": "47.38045000",
                        "longitude": "11.83888000"
                    },
                    {
                        "id": 3418,
                        "name": "Schönberg im Stubaital",
                        "latitude": "47.18333000",
                        "longitude": "11.41667000"
                    },
                    {
                        "id": 3422,
                        "name": "Schönwies",
                        "latitude": "47.19665000",
                        "longitude": "10.65742000"
                    },
                    {
                        "id": 3404,
                        "name": "Schwaz",
                        "latitude": "47.35169000",
                        "longitude": "11.71014000"
                    },
                    {
                        "id": 3408,
                        "name": "Schwendau",
                        "latitude": "47.19753000",
                        "longitude": "11.85897000"
                    },
                    {
                        "id": 3409,
                        "name": "Schwendt",
                        "latitude": "47.63182000",
                        "longitude": "12.39266000"
                    },
                    {
                        "id": 3411,
                        "name": "Schwoich",
                        "latitude": "47.54600000",
                        "longitude": "12.14049000"
                    },
                    {
                        "id": 3427,
                        "name": "See",
                        "latitude": "47.08333000",
                        "longitude": "10.46667000"
                    },
                    {
                        "id": 3431,
                        "name": "Seefeld in Tirol",
                        "latitude": "47.33016000",
                        "longitude": "11.18786000"
                    },
                    {
                        "id": 3441,
                        "name": "Sellrain",
                        "latitude": "47.21667000",
                        "longitude": "11.21667000"
                    },
                    {
                        "id": 3446,
                        "name": "Serfaus",
                        "latitude": "47.04018000",
                        "longitude": "10.60339000"
                    },
                    {
                        "id": 3459,
                        "name": "Sillian",
                        "latitude": "46.75278000",
                        "longitude": "12.42111000"
                    },
                    {
                        "id": 3460,
                        "name": "Silz",
                        "latitude": "47.26667000",
                        "longitude": "10.93333000"
                    },
                    {
                        "id": 3463,
                        "name": "Sistrans",
                        "latitude": "47.23333000",
                        "longitude": "11.45000000"
                    },
                    {
                        "id": 3566,
                        "name": "Sölden",
                        "latitude": "46.96667000",
                        "longitude": "11.00000000"
                    },
                    {
                        "id": 3567,
                        "name": "Söll",
                        "latitude": "47.50378000",
                        "longitude": "12.19221000"
                    },
                    {
                        "id": 3482,
                        "name": "St Anton am Arlberg",
                        "latitude": "47.12750000",
                        "longitude": "10.26372000"
                    },
                    {
                        "id": 3501,
                        "name": "Stams",
                        "latitude": "47.27603000",
                        "longitude": "10.98315000"
                    },
                    {
                        "id": 3502,
                        "name": "Stans",
                        "latitude": "47.36667000",
                        "longitude": "11.71667000"
                    },
                    {
                        "id": 3503,
                        "name": "Stanz bei Landeck",
                        "latitude": "47.14758000",
                        "longitude": "10.55340000"
                    },
                    {
                        "id": 3504,
                        "name": "Stanzach",
                        "latitude": "47.38333000",
                        "longitude": "10.56667000"
                    },
                    {
                        "id": 3508,
                        "name": "Steeg",
                        "latitude": "47.24393000",
                        "longitude": "10.29436000"
                    },
                    {
                        "id": 3513,
                        "name": "Steinach am Brenner",
                        "latitude": "47.08333000",
                        "longitude": "11.46667000"
                    },
                    {
                        "id": 3540,
                        "name": "Strass im Zillertal",
                        "latitude": "47.39556000",
                        "longitude": "11.81966000"
                    },
                    {
                        "id": 3541,
                        "name": "Strassen",
                        "latitude": "46.75389000",
                        "longitude": "12.48417000"
                    },
                    {
                        "id": 3552,
                        "name": "Strengen",
                        "latitude": "47.12589000",
                        "longitude": "10.46199000"
                    },
                    {
                        "id": 3558,
                        "name": "Stumm",
                        "latitude": "47.29052000",
                        "longitude": "11.88755000"
                    },
                    {
                        "id": 3559,
                        "name": "Stummerberg",
                        "latitude": "47.28333000",
                        "longitude": "11.91667000"
                    },
                    {
                        "id": 3571,
                        "name": "Tannheim",
                        "latitude": "47.49934000",
                        "longitude": "10.51641000"
                    },
                    {
                        "id": 3572,
                        "name": "Tarrenz",
                        "latitude": "47.26667000",
                        "longitude": "10.76667000"
                    },
                    {
                        "id": 3580,
                        "name": "Telfes im Stubai",
                        "latitude": "47.16667000",
                        "longitude": "11.36667000"
                    },
                    {
                        "id": 3581,
                        "name": "Telfs",
                        "latitude": "47.30707000",
                        "longitude": "11.06817000"
                    },
                    {
                        "id": 3582,
                        "name": "Terfens",
                        "latitude": "47.32355000",
                        "longitude": "11.64388000"
                    },
                    {
                        "id": 3589,
                        "name": "Thaur",
                        "latitude": "47.29476000",
                        "longitude": "11.47529000"
                    },
                    {
                        "id": 3595,
                        "name": "Thurn",
                        "latitude": "46.85056000",
                        "longitude": "12.76861000"
                    },
                    {
                        "id": 3604,
                        "name": "Tobadill",
                        "latitude": "47.12513000",
                        "longitude": "10.51404000"
                    },
                    {
                        "id": 3624,
                        "name": "Trins",
                        "latitude": "47.08333000",
                        "longitude": "11.41667000"
                    },
                    {
                        "id": 3625,
                        "name": "Tristach",
                        "latitude": "46.81611000",
                        "longitude": "12.78972000"
                    },
                    {
                        "id": 3632,
                        "name": "Tulfes",
                        "latitude": "47.25806000",
                        "longitude": "11.53333000"
                    },
                    {
                        "id": 3636,
                        "name": "Tux",
                        "latitude": "47.15559000",
                        "longitude": "11.72872000"
                    },
                    {
                        "id": 3639,
                        "name": "Uderns",
                        "latitude": "47.31667000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 3643,
                        "name": "Umhausen",
                        "latitude": "47.13503000",
                        "longitude": "10.92826000"
                    },
                    {
                        "id": 3656,
                        "name": "Unterlangkampfen",
                        "latitude": "47.55000000",
                        "longitude": "12.10000000"
                    },
                    {
                        "id": 3658,
                        "name": "Unterperfuss",
                        "latitude": "47.26667000",
                        "longitude": "11.25000000"
                    },
                    {
                        "id": 3663,
                        "name": "Untertilliach",
                        "latitude": "46.70346000",
                        "longitude": "12.67758000"
                    },
                    {
                        "id": 3671,
                        "name": "Vals",
                        "latitude": "47.04507000",
                        "longitude": "11.53281000"
                    },
                    {
                        "id": 3690,
                        "name": "Vils",
                        "latitude": "47.55000000",
                        "longitude": "10.63333000"
                    },
                    {
                        "id": 3691,
                        "name": "Virgen",
                        "latitude": "47.00159000",
                        "longitude": "12.45661000"
                    },
                    {
                        "id": 3695,
                        "name": "Volders",
                        "latitude": "47.28333000",
                        "longitude": "11.56667000"
                    },
                    {
                        "id": 3696,
                        "name": "Voldöpp",
                        "latitude": "47.44469000",
                        "longitude": "11.88343000"
                    },
                    {
                        "id": 3708,
                        "name": "Völs",
                        "latitude": "47.25000000",
                        "longitude": "11.33333000"
                    },
                    {
                        "id": 3697,
                        "name": "Vomp",
                        "latitude": "47.33333000",
                        "longitude": "11.68333000"
                    },
                    {
                        "id": 3700,
                        "name": "Vorderhornbach",
                        "latitude": "47.37009000",
                        "longitude": "10.53947000"
                    },
                    {
                        "id": 3702,
                        "name": "Vorderthiersee",
                        "latitude": "47.58333000",
                        "longitude": "12.10000000"
                    },
                    {
                        "id": 3720,
                        "name": "Waidring",
                        "latitude": "47.58333000",
                        "longitude": "12.56667000"
                    },
                    {
                        "id": 3724,
                        "name": "Walchsee",
                        "latitude": "47.65163000",
                        "longitude": "12.31868000"
                    },
                    {
                        "id": 3853,
                        "name": "Wängle",
                        "latitude": "47.48658000",
                        "longitude": "10.68995000"
                    },
                    {
                        "id": 3751,
                        "name": "Wattenberg",
                        "latitude": "47.28333000",
                        "longitude": "11.60000000"
                    },
                    {
                        "id": 3752,
                        "name": "Wattens",
                        "latitude": "47.29419000",
                        "longitude": "11.59070000"
                    },
                    {
                        "id": 3753,
                        "name": "Weer",
                        "latitude": "47.30375000",
                        "longitude": "11.64498000"
                    },
                    {
                        "id": 3754,
                        "name": "Weerberg",
                        "latitude": "47.29841000",
                        "longitude": "11.66592000"
                    },
                    {
                        "id": 3770,
                        "name": "Weissach",
                        "latitude": "47.57091000",
                        "longitude": "12.16255000"
                    },
                    {
                        "id": 3771,
                        "name": "Weissenbach am Lech",
                        "latitude": "47.44162000",
                        "longitude": "10.64071000"
                    },
                    {
                        "id": 3790,
                        "name": "Wenns",
                        "latitude": "47.16667000",
                        "longitude": "10.73333000"
                    },
                    {
                        "id": 3798,
                        "name": "Westendorf",
                        "latitude": "47.43208000",
                        "longitude": "12.21406000"
                    },
                    {
                        "id": 3811,
                        "name": "Wiesing",
                        "latitude": "47.40486000",
                        "longitude": "11.79708000"
                    },
                    {
                        "id": 3814,
                        "name": "Wildermieming",
                        "latitude": "47.31667000",
                        "longitude": "11.01667000"
                    },
                    {
                        "id": 3816,
                        "name": "Wildschönau",
                        "latitude": "47.40619000",
                        "longitude": "12.03784000"
                    },
                    {
                        "id": 3821,
                        "name": "Wilten",
                        "latitude": "47.25829000",
                        "longitude": "11.38808000"
                    },
                    {
                        "id": 3857,
                        "name": "Wörgl",
                        "latitude": "47.48906000",
                        "longitude": "12.06174000"
                    },
                    {
                        "id": 3867,
                        "name": "Zams",
                        "latitude": "47.15844000",
                        "longitude": "10.58970000"
                    },
                    {
                        "id": 3871,
                        "name": "Zell",
                        "latitude": "47.58333000",
                        "longitude": "12.15000000"
                    },
                    {
                        "id": 3875,
                        "name": "Zell am Ziller",
                        "latitude": "47.23333000",
                        "longitude": "11.88333000"
                    },
                    {
                        "id": 3879,
                        "name": "Zellberg",
                        "latitude": "47.23333000",
                        "longitude": "11.85000000"
                    },
                    {
                        "id": 3888,
                        "name": "Zirl",
                        "latitude": "47.27410000",
                        "longitude": "11.23961000"
                    },
                    {
                        "id": 3896,
                        "name": "Zöblen",
                        "latitude": "47.50772000",
                        "longitude": "10.47971000"
                    }
                ]
            },
            {
                "id": 2058,
                "name": "Upper Austria",
                "iso2": "4",
                "latitude": "48.02585400",
                "longitude": "13.97236650",
                "type": "state",
                "cities": [
                    {
                        "id": 1605,
                        "name": "Abwinden",
                        "latitude": "48.25903000",
                        "longitude": "14.42625000"
                    },
                    {
                        "id": 1609,
                        "name": "Adlwang",
                        "latitude": "47.99245000",
                        "longitude": "14.21742000"
                    },
                    {
                        "id": 1612,
                        "name": "Afiesl",
                        "latitude": "48.58229000",
                        "longitude": "14.12777000"
                    },
                    {
                        "id": 1615,
                        "name": "Ahorn",
                        "latitude": "48.52382000",
                        "longitude": "14.17408000"
                    },
                    {
                        "id": 1617,
                        "name": "Aichkirchen",
                        "latitude": "48.10944000",
                        "longitude": "13.79158000"
                    },
                    {
                        "id": 1619,
                        "name": "Aigen im Mühlkreis",
                        "latitude": "48.64578000",
                        "longitude": "13.97109000"
                    },
                    {
                        "id": 1621,
                        "name": "Aistersheim",
                        "latitude": "48.18680000",
                        "longitude": "13.74175000"
                    },
                    {
                        "id": 1622,
                        "name": "Alberndorf in der Riedmark",
                        "latitude": "48.40607000",
                        "longitude": "14.41441000"
                    },
                    {
                        "id": 1626,
                        "name": "Alkoven",
                        "latitude": "48.28753000",
                        "longitude": "14.10748000"
                    },
                    {
                        "id": 1630,
                        "name": "Allerheiligen im Mühlkreis",
                        "latitude": "48.30215000",
                        "longitude": "14.65061000"
                    },
                    {
                        "id": 1632,
                        "name": "Allhaming",
                        "latitude": "48.15246000",
                        "longitude": "14.17022000"
                    },
                    {
                        "id": 1637,
                        "name": "Altenberg bei Linz",
                        "latitude": "48.37284000",
                        "longitude": "14.35029000"
                    },
                    {
                        "id": 1640,
                        "name": "Altenfelden",
                        "latitude": "48.48555000",
                        "longitude": "13.96980000"
                    },
                    {
                        "id": 1645,
                        "name": "Altheim",
                        "latitude": "48.25154000",
                        "longitude": "13.23406000"
                    },
                    {
                        "id": 1648,
                        "name": "Altlichtenberg",
                        "latitude": "48.36001000",
                        "longitude": "14.25845000"
                    },
                    {
                        "id": 1651,
                        "name": "Altmünster",
                        "latitude": "47.90219000",
                        "longitude": "13.76415000"
                    },
                    {
                        "id": 1654,
                        "name": "Ampflwang",
                        "latitude": "48.08333000",
                        "longitude": "13.56667000"
                    },
                    {
                        "id": 1660,
                        "name": "Andorf",
                        "latitude": "48.37130000",
                        "longitude": "13.57412000"
                    },
                    {
                        "id": 1670,
                        "name": "Ansfelden",
                        "latitude": "48.20969000",
                        "longitude": "14.29004000"
                    },
                    {
                        "id": 1680,
                        "name": "Arnreit",
                        "latitude": "48.52513000",
                        "longitude": "13.99487000"
                    },
                    {
                        "id": 1685,
                        "name": "Aschach an der Donau",
                        "latitude": "48.36458000",
                        "longitude": "14.02044000"
                    },
                    {
                        "id": 1686,
                        "name": "Aschach an der Steyr",
                        "latitude": "48.01312000",
                        "longitude": "14.33544000"
                    },
                    {
                        "id": 1693,
                        "name": "Asten",
                        "latitude": "48.21941000",
                        "longitude": "14.41784000"
                    },
                    {
                        "id": 1695,
                        "name": "Attersee",
                        "latitude": "47.91646000",
                        "longitude": "13.53953000"
                    },
                    {
                        "id": 1696,
                        "name": "Attnang",
                        "latitude": "48.01667000",
                        "longitude": "13.71667000"
                    },
                    {
                        "id": 1697,
                        "name": "Attnang-Puchheim",
                        "latitude": "48.00833000",
                        "longitude": "13.71667000"
                    },
                    {
                        "id": 1698,
                        "name": "Atzbach",
                        "latitude": "48.08364000",
                        "longitude": "13.70347000"
                    },
                    {
                        "id": 1700,
                        "name": "Atzesberg",
                        "latitude": "48.53959000",
                        "longitude": "13.86936000"
                    },
                    {
                        "id": 1704,
                        "name": "Au an der Traun",
                        "latitude": "48.18020000",
                        "longitude": "14.11248000"
                    },
                    {
                        "id": 1705,
                        "name": "Audorf",
                        "latitude": "48.21810000",
                        "longitude": "14.27931000"
                    },
                    {
                        "id": 1710,
                        "name": "Aurach am Hongar",
                        "latitude": "47.95182000",
                        "longitude": "13.67291000"
                    },
                    {
                        "id": 1711,
                        "name": "Aurolzmünster",
                        "latitude": "48.24834000",
                        "longitude": "13.45533000"
                    },
                    {
                        "id": 1715,
                        "name": "Bachmanning",
                        "latitude": "48.13104000",
                        "longitude": "13.79436000"
                    },
                    {
                        "id": 1724,
                        "name": "Bad Goisern",
                        "latitude": "47.64252000",
                        "longitude": "13.61609000"
                    },
                    {
                        "id": 1725,
                        "name": "Bad Hall",
                        "latitude": "48.03832000",
                        "longitude": "14.20773000"
                    },
                    {
                        "id": 1728,
                        "name": "Bad Ischl",
                        "latitude": "47.71109000",
                        "longitude": "13.61893000"
                    },
                    {
                        "id": 1729,
                        "name": "Bad Kreuzen",
                        "latitude": "48.26737000",
                        "longitude": "14.80648000"
                    },
                    {
                        "id": 1730,
                        "name": "Bad Leonfelden",
                        "latitude": "48.52047000",
                        "longitude": "14.29459000"
                    },
                    {
                        "id": 1735,
                        "name": "Bad Schallerbach",
                        "latitude": "48.22999000",
                        "longitude": "13.91925000"
                    },
                    {
                        "id": 1741,
                        "name": "Bad Zell",
                        "latitude": "48.34906000",
                        "longitude": "14.66945000"
                    },
                    {
                        "id": 1754,
                        "name": "Berg",
                        "latitude": "48.29278000",
                        "longitude": "14.24778000"
                    },
                    {
                        "id": 1756,
                        "name": "Bergern",
                        "latitude": "48.16752000",
                        "longitude": "14.11153000"
                    },
                    {
                        "id": 1757,
                        "name": "Bergham",
                        "latitude": "48.28182000",
                        "longitude": "14.23141000"
                    },
                    {
                        "id": 1760,
                        "name": "Bernardin",
                        "latitude": "48.16042000",
                        "longitude": "14.00834000"
                    },
                    {
                        "id": 1792,
                        "name": "Brandln",
                        "latitude": "48.14510000",
                        "longitude": "13.99504000"
                    },
                    {
                        "id": 1794,
                        "name": "Braunau am Inn",
                        "latitude": "48.25628000",
                        "longitude": "13.04343000"
                    },
                    {
                        "id": 1793,
                        "name": "Braunau Neustadt",
                        "latitude": "48.24606000",
                        "longitude": "13.03583000"
                    },
                    {
                        "id": 1819,
                        "name": "Buchkirchen",
                        "latitude": "48.22427000",
                        "longitude": "14.02242000"
                    },
                    {
                        "id": 1822,
                        "name": "Burgfried",
                        "latitude": "48.51990000",
                        "longitude": "14.29570000"
                    },
                    {
                        "id": 1835,
                        "name": "Desselbrunn",
                        "latitude": "48.02145000",
                        "longitude": "13.77027000"
                    },
                    {
                        "id": 1845,
                        "name": "Dickerldorf",
                        "latitude": "48.17676000",
                        "longitude": "14.05705000"
                    },
                    {
                        "id": 1849,
                        "name": "Diesseits",
                        "latitude": "48.29216000",
                        "longitude": "13.43546000"
                    },
                    {
                        "id": 1850,
                        "name": "Dietach",
                        "latitude": "48.09018000",
                        "longitude": "14.41647000"
                    },
                    {
                        "id": 1851,
                        "name": "Dietachdorf",
                        "latitude": "48.08364000",
                        "longitude": "14.42874000"
                    },
                    {
                        "id": 1860,
                        "name": "Doppl",
                        "latitude": "48.24811000",
                        "longitude": "14.25416000"
                    },
                    {
                        "id": 1873,
                        "name": "Dörfl",
                        "latitude": "48.01245000",
                        "longitude": "13.65472000"
                    },
                    {
                        "id": 1876,
                        "name": "Dürnau",
                        "latitude": "47.99710000",
                        "longitude": "13.64459000"
                    },
                    {
                        "id": 1885,
                        "name": "Ebensee",
                        "latitude": "47.80716000",
                        "longitude": "13.77900000"
                    },
                    {
                        "id": 1891,
                        "name": "Eberschwang",
                        "latitude": "48.15504000",
                        "longitude": "13.56194000"
                    },
                    {
                        "id": 1893,
                        "name": "Eberstalzell",
                        "latitude": "48.04392000",
                        "longitude": "13.98319000"
                    },
                    {
                        "id": 1905,
                        "name": "Edt bei Lambach",
                        "latitude": "48.11667000",
                        "longitude": "13.88333000"
                    },
                    {
                        "id": 1906,
                        "name": "Eferding",
                        "latitude": "48.30866000",
                        "longitude": "14.02233000"
                    },
                    {
                        "id": 1921,
                        "name": "Eidenberg",
                        "latitude": "48.39439000",
                        "longitude": "14.23313000"
                    },
                    {
                        "id": 1939,
                        "name": "Engerwitzdorf",
                        "latitude": "48.34507000",
                        "longitude": "14.44204000"
                    },
                    {
                        "id": 1940,
                        "name": "Enns",
                        "latitude": "48.21346000",
                        "longitude": "14.47612000"
                    },
                    {
                        "id": 1974,
                        "name": "Feldkirchen an der Donau",
                        "latitude": "48.34524000",
                        "longitude": "14.05134000"
                    },
                    {
                        "id": 1992,
                        "name": "Fisching",
                        "latitude": "48.22301000",
                        "longitude": "14.42771000"
                    },
                    {
                        "id": 2006,
                        "name": "Fornach",
                        "latitude": "48.02277000",
                        "longitude": "13.42941000"
                    },
                    {
                        "id": 2008,
                        "name": "Frankenburg",
                        "latitude": "48.06844000",
                        "longitude": "13.49065000"
                    },
                    {
                        "id": 2010,
                        "name": "Frankenmarkt",
                        "latitude": "47.98333000",
                        "longitude": "13.41667000"
                    },
                    {
                        "id": 2019,
                        "name": "Freindorf",
                        "latitude": "48.22570000",
                        "longitude": "14.29510000"
                    },
                    {
                        "id": 2020,
                        "name": "Freistadt",
                        "latitude": "48.51103000",
                        "longitude": "14.50453000"
                    },
                    {
                        "id": 2042,
                        "name": "Gaflenz",
                        "latitude": "47.89511000",
                        "longitude": "14.72477000"
                    },
                    {
                        "id": 2048,
                        "name": "Gallneukirchen",
                        "latitude": "48.35363000",
                        "longitude": "14.41604000"
                    },
                    {
                        "id": 2049,
                        "name": "Gallspach",
                        "latitude": "48.20992000",
                        "longitude": "13.80981000"
                    },
                    {
                        "id": 2054,
                        "name": "Gampern",
                        "latitude": "47.98877000",
                        "longitude": "13.55430000"
                    },
                    {
                        "id": 2059,
                        "name": "Garsten",
                        "latitude": "48.02240000",
                        "longitude": "14.40747000"
                    },
                    {
                        "id": 2062,
                        "name": "Gaspoltshofen",
                        "latitude": "48.14324000",
                        "longitude": "13.73643000"
                    },
                    {
                        "id": 2066,
                        "name": "Gaumberg",
                        "latitude": "48.28085000",
                        "longitude": "14.26935000"
                    },
                    {
                        "id": 2068,
                        "name": "Geboltskirchen",
                        "latitude": "48.15338000",
                        "longitude": "13.63360000"
                    },
                    {
                        "id": 2092,
                        "name": "Gmunden",
                        "latitude": "47.91839000",
                        "longitude": "13.79933000"
                    },
                    {
                        "id": 2102,
                        "name": "Goldwörth",
                        "latitude": "48.32664000",
                        "longitude": "14.10112000"
                    },
                    {
                        "id": 2105,
                        "name": "Gosau",
                        "latitude": "47.58417000",
                        "longitude": "13.53447000"
                    },
                    {
                        "id": 2117,
                        "name": "Gramastetten",
                        "latitude": "48.38028000",
                        "longitude": "14.19185000"
                    },
                    {
                        "id": 2125,
                        "name": "Grein",
                        "latitude": "48.22862000",
                        "longitude": "14.85884000"
                    },
                    {
                        "id": 2134,
                        "name": "Grieskirchen",
                        "latitude": "48.23333000",
                        "longitude": "13.83333000"
                    },
                    {
                        "id": 2143,
                        "name": "Grossraming",
                        "latitude": "47.88333000",
                        "longitude": "14.55000000"
                    },
                    {
                        "id": 2167,
                        "name": "Grünau im Almtal",
                        "latitude": "47.85493000",
                        "longitude": "13.95573000"
                    },
                    {
                        "id": 2169,
                        "name": "Grünburg",
                        "latitude": "47.97234000",
                        "longitude": "14.26472000"
                    },
                    {
                        "id": 2171,
                        "name": "Gschwandt",
                        "latitude": "47.93515000",
                        "longitude": "13.84569000"
                    },
                    {
                        "id": 2175,
                        "name": "Gunskirchen",
                        "latitude": "48.13333000",
                        "longitude": "13.95000000"
                    },
                    {
                        "id": 2179,
                        "name": "Gutau",
                        "latitude": "48.41724000",
                        "longitude": "14.61285000"
                    },
                    {
                        "id": 2199,
                        "name": "Haag",
                        "latitude": "48.27063000",
                        "longitude": "14.26875000"
                    },
                    {
                        "id": 2201,
                        "name": "Haag am Hausruck",
                        "latitude": "48.18423000",
                        "longitude": "13.64373000"
                    },
                    {
                        "id": 2208,
                        "name": "Hagenberg im Mühlkreis",
                        "latitude": "48.36788000",
                        "longitude": "14.51689000"
                    },
                    {
                        "id": 2210,
                        "name": "Haibach im Mühlkreis",
                        "latitude": "48.44429000",
                        "longitude": "14.34411000"
                    },
                    {
                        "id": 2211,
                        "name": "Haid",
                        "latitude": "48.20477000",
                        "longitude": "14.25107000"
                    },
                    {
                        "id": 2212,
                        "name": "Haiden",
                        "latitude": "47.71790000",
                        "longitude": "13.56906000"
                    },
                    {
                        "id": 2214,
                        "name": "Haidl",
                        "latitude": "48.17267000",
                        "longitude": "14.05297000"
                    },
                    {
                        "id": 2227,
                        "name": "Handenberg",
                        "latitude": "48.13356000",
                        "longitude": "13.00751000"
                    },
                    {
                        "id": 2234,
                        "name": "Hart",
                        "latitude": "48.26526000",
                        "longitude": "14.25691000"
                    },
                    {
                        "id": 2239,
                        "name": "Hartheim",
                        "latitude": "48.28079000",
                        "longitude": "14.11426000"
                    },
                    {
                        "id": 2240,
                        "name": "Hartkirchen",
                        "latitude": "48.36349000",
                        "longitude": "14.00422000"
                    },
                    {
                        "id": 2243,
                        "name": "Haselbach",
                        "latitude": "48.25308000",
                        "longitude": "13.05614000"
                    },
                    {
                        "id": 2244,
                        "name": "Haslach an der Mühl",
                        "latitude": "48.57570000",
                        "longitude": "14.03984000"
                    },
                    {
                        "id": 2267,
                        "name": "Hellmonsödt",
                        "latitude": "48.43333000",
                        "longitude": "14.30000000"
                    },
                    {
                        "id": 2276,
                        "name": "Herzogsdorf",
                        "latitude": "48.43011000",
                        "longitude": "14.11280000"
                    },
                    {
                        "id": 2297,
                        "name": "Hochburg-Ach",
                        "latitude": "48.13001000",
                        "longitude": "12.87735000"
                    },
                    {
                        "id": 2300,
                        "name": "Hochpoint",
                        "latitude": "48.16139000",
                        "longitude": "14.03838000"
                    },
                    {
                        "id": 2303,
                        "name": "Hof",
                        "latitude": "47.86667000",
                        "longitude": "13.31667000"
                    },
                    {
                        "id": 2309,
                        "name": "Hofkirchen im Traunkreis",
                        "latitude": "48.14312000",
                        "longitude": "14.37776000"
                    },
                    {
                        "id": 2327,
                        "name": "Holzhausen",
                        "latitude": "48.22296000",
                        "longitude": "14.09683000"
                    },
                    {
                        "id": 2343,
                        "name": "Hörsching",
                        "latitude": "48.22627000",
                        "longitude": "14.17786000"
                    },
                    {
                        "id": 2358,
                        "name": "Innerschwand",
                        "latitude": "47.83333000",
                        "longitude": "13.40000000"
                    },
                    {
                        "id": 2363,
                        "name": "Inzersdorf im Kremstal",
                        "latitude": "47.92808000",
                        "longitude": "14.08104000"
                    },
                    {
                        "id": 2392,
                        "name": "Kaltenbach",
                        "latitude": "47.70618000",
                        "longitude": "13.60914000"
                    },
                    {
                        "id": 2410,
                        "name": "Katsdorf",
                        "latitude": "48.31791000",
                        "longitude": "14.47432000"
                    },
                    {
                        "id": 2415,
                        "name": "Kematen an der Krems",
                        "latitude": "48.11150000",
                        "longitude": "14.19391000"
                    },
                    {
                        "id": 2432,
                        "name": "Kirchberg ob der Donau",
                        "latitude": "48.44440000",
                        "longitude": "13.93805000"
                    },
                    {
                        "id": 2434,
                        "name": "Kirchdorf an der Krems",
                        "latitude": "47.90558000",
                        "longitude": "14.12228000"
                    },
                    {
                        "id": 2438,
                        "name": "Kirchschlag bei Linz",
                        "latitude": "48.41149000",
                        "longitude": "14.27656000"
                    },
                    {
                        "id": 2445,
                        "name": "Klaffer am Hochficht",
                        "latitude": "48.69544000",
                        "longitude": "13.88131000"
                    },
                    {
                        "id": 2511,
                        "name": "Königswiesen",
                        "latitude": "48.40453000",
                        "longitude": "14.83824000"
                    },
                    {
                        "id": 2474,
                        "name": "Kopfing im Innkreis",
                        "latitude": "48.43991000",
                        "longitude": "13.65841000"
                    },
                    {
                        "id": 2485,
                        "name": "Kremsdorf",
                        "latitude": "48.20031000",
                        "longitude": "14.26249000"
                    },
                    {
                        "id": 2486,
                        "name": "Kremsmünster",
                        "latitude": "48.05290000",
                        "longitude": "14.12919000"
                    },
                    {
                        "id": 2492,
                        "name": "Kronstorf",
                        "latitude": "48.14324000",
                        "longitude": "14.46307000"
                    },
                    {
                        "id": 2518,
                        "name": "Laab",
                        "latitude": "48.26110000",
                        "longitude": "13.05418000"
                    },
                    {
                        "id": 2520,
                        "name": "Laahen",
                        "latitude": "48.17192000",
                        "longitude": "14.00637000"
                    },
                    {
                        "id": 2521,
                        "name": "Laakirchen",
                        "latitude": "47.98188000",
                        "longitude": "13.82166000"
                    },
                    {
                        "id": 2528,
                        "name": "Lambach",
                        "latitude": "48.09276000",
                        "longitude": "13.87453000"
                    },
                    {
                        "id": 2542,
                        "name": "Langenstein",
                        "latitude": "48.25200000",
                        "longitude": "14.47655000"
                    },
                    {
                        "id": 2545,
                        "name": "Langholzfeld",
                        "latitude": "48.24297000",
                        "longitude": "14.24772000"
                    },
                    {
                        "id": 2554,
                        "name": "Laussa",
                        "latitude": "47.95000000",
                        "longitude": "14.45000000"
                    },
                    {
                        "id": 2571,
                        "name": "Lembach im Mühlkreis",
                        "latitude": "48.49517000",
                        "longitude": "13.89513000"
                    },
                    {
                        "id": 2577,
                        "name": "Lenzing",
                        "latitude": "47.97326000",
                        "longitude": "13.60846000"
                    },
                    {
                        "id": 2582,
                        "name": "Leonding",
                        "latitude": "48.27965000",
                        "longitude": "14.25330000"
                    },
                    {
                        "id": 2583,
                        "name": "Leonstein",
                        "latitude": "47.89666000",
                        "longitude": "14.23124000"
                    },
                    {
                        "id": 2591,
                        "name": "Lichtenegg",
                        "latitude": "48.15000000",
                        "longitude": "14.00000000"
                    },
                    {
                        "id": 2603,
                        "name": "Linz",
                        "latitude": "48.30639000",
                        "longitude": "14.28611000"
                    },
                    {
                        "id": 2604,
                        "name": "Linz Stadt",
                        "latitude": "48.30000000",
                        "longitude": "14.28333000"
                    },
                    {
                        "id": 2616,
                        "name": "Losenstein",
                        "latitude": "47.92428000",
                        "longitude": "14.43672000"
                    },
                    {
                        "id": 2619,
                        "name": "Luftenberg an der Donau",
                        "latitude": "48.27462000",
                        "longitude": "14.41303000"
                    },
                    {
                        "id": 2632,
                        "name": "Manning",
                        "latitude": "48.08851000",
                        "longitude": "13.66682000"
                    },
                    {
                        "id": 2637,
                        "name": "Marchtrenk",
                        "latitude": "48.19275000",
                        "longitude": "14.11394000"
                    },
                    {
                        "id": 2645,
                        "name": "Maria Neustift",
                        "latitude": "47.93333000",
                        "longitude": "14.60000000"
                    },
                    {
                        "id": 2648,
                        "name": "Maria Schmolln",
                        "latitude": "48.13820000",
                        "longitude": "13.21981000"
                    },
                    {
                        "id": 2670,
                        "name": "Mattighofen",
                        "latitude": "48.10732000",
                        "longitude": "13.15081000"
                    },
                    {
                        "id": 2676,
                        "name": "Mauerkirchen",
                        "latitude": "48.19173000",
                        "longitude": "13.13338000"
                    },
                    {
                        "id": 2684,
                        "name": "Meggenhofen",
                        "latitude": "48.18017000",
                        "longitude": "13.79582000"
                    },
                    {
                        "id": 2685,
                        "name": "Mehrnbach",
                        "latitude": "48.20809000",
                        "longitude": "13.43525000"
                    },
                    {
                        "id": 2695,
                        "name": "Michaelnbach",
                        "latitude": "48.28788000",
                        "longitude": "13.83144000"
                    },
                    {
                        "id": 2697,
                        "name": "Micheldorf in Oberösterreich",
                        "latitude": "47.87764000",
                        "longitude": "14.13357000"
                    },
                    {
                        "id": 2713,
                        "name": "Mitterkirchen im Machland",
                        "latitude": "48.18795000",
                        "longitude": "14.69593000"
                    },
                    {
                        "id": 2720,
                        "name": "Mittertreffling",
                        "latitude": "48.33868000",
                        "longitude": "14.36505000"
                    },
                    {
                        "id": 2723,
                        "name": "Molln",
                        "latitude": "47.88723000",
                        "longitude": "14.25819000"
                    },
                    {
                        "id": 2724,
                        "name": "Mondsee",
                        "latitude": "47.85648000",
                        "longitude": "13.34908000"
                    },
                    {
                        "id": 2727,
                        "name": "Moosdorf",
                        "latitude": "48.04492000",
                        "longitude": "12.98902000"
                    },
                    {
                        "id": 2754,
                        "name": "Mühldorf",
                        "latitude": "47.89689000",
                        "longitude": "13.95049000"
                    },
                    {
                        "id": 2733,
                        "name": "Munderfing",
                        "latitude": "48.07039000",
                        "longitude": "13.18162000"
                    },
                    {
                        "id": 2763,
                        "name": "Münzbach",
                        "latitude": "48.26737000",
                        "longitude": "14.71009000"
                    },
                    {
                        "id": 2764,
                        "name": "Münzkirchen",
                        "latitude": "48.48333000",
                        "longitude": "13.56667000"
                    },
                    {
                        "id": 2768,
                        "name": "Naarn im Machlande",
                        "latitude": "48.22553000",
                        "longitude": "14.60838000"
                    },
                    {
                        "id": 2772,
                        "name": "Natternbach",
                        "latitude": "48.39730000",
                        "longitude": "13.74965000"
                    },
                    {
                        "id": 2775,
                        "name": "Nebelberg",
                        "latitude": "48.62854000",
                        "longitude": "13.84629000"
                    },
                    {
                        "id": 2785,
                        "name": "Neubau",
                        "latitude": "48.21901000",
                        "longitude": "14.19301000"
                    },
                    {
                        "id": 2791,
                        "name": "Neue Heimat",
                        "latitude": "48.24565000",
                        "longitude": "13.04172000"
                    },
                    {
                        "id": 2796,
                        "name": "Neuhofen an der Krems",
                        "latitude": "48.13866000",
                        "longitude": "14.22764000"
                    },
                    {
                        "id": 2798,
                        "name": "Neukirchen",
                        "latitude": "47.87502000",
                        "longitude": "13.71111000"
                    },
                    {
                        "id": 2800,
                        "name": "Neukirchen am Walde",
                        "latitude": "48.40584000",
                        "longitude": "13.78158000"
                    },
                    {
                        "id": 2801,
                        "name": "Neukirchen an der Vöckla",
                        "latitude": "48.04053000",
                        "longitude": "13.53760000"
                    },
                    {
                        "id": 2802,
                        "name": "Neukirchen bei Lambach",
                        "latitude": "48.10000000",
                        "longitude": "13.81667000"
                    },
                    {
                        "id": 2806,
                        "name": "Neumarkt im Hausruckkreis",
                        "latitude": "48.27280000",
                        "longitude": "13.72836000"
                    },
                    {
                        "id": 2807,
                        "name": "Neumarkt im Mühlkreis",
                        "latitude": "48.42818000",
                        "longitude": "14.48444000"
                    },
                    {
                        "id": 2818,
                        "name": "Neuzeug",
                        "latitude": "48.05000000",
                        "longitude": "14.33333000"
                    },
                    {
                        "id": 2827,
                        "name": "Niederneukirchen",
                        "latitude": "48.16093000",
                        "longitude": "14.33965000"
                    },
                    {
                        "id": 2830,
                        "name": "Niederstraß",
                        "latitude": "48.01398000",
                        "longitude": "13.72956000"
                    },
                    {
                        "id": 2831,
                        "name": "Niederthalheim",
                        "latitude": "48.09901000",
                        "longitude": "13.76870000"
                    },
                    {
                        "id": 2840,
                        "name": "Nöstlbach",
                        "latitude": "48.16660000",
                        "longitude": "14.24609000"
                    },
                    {
                        "id": 2852,
                        "name": "Oberhaid",
                        "latitude": "48.17593000",
                        "longitude": "14.01495000"
                    },
                    {
                        "id": 2853,
                        "name": "Oberhart",
                        "latitude": "48.18333000",
                        "longitude": "14.05000000"
                    },
                    {
                        "id": 2855,
                        "name": "Oberhofen am Irrsee",
                        "latitude": "47.95000000",
                        "longitude": "13.30000000"
                    },
                    {
                        "id": 2862,
                        "name": "Obernberg am Inn",
                        "latitude": "48.32133000",
                        "longitude": "13.33427000"
                    },
                    {
                        "id": 2865,
                        "name": "Oberndorf bei Schwanenstadt",
                        "latitude": "48.05559000",
                        "longitude": "13.75677000"
                    },
                    {
                        "id": 2868,
                        "name": "Oberneukirchen",
                        "latitude": "48.46404000",
                        "longitude": "14.22275000"
                    },
                    {
                        "id": 2883,
                        "name": "Oberwang",
                        "latitude": "47.86667000",
                        "longitude": "13.43333000"
                    },
                    {
                        "id": 2890,
                        "name": "Oedt",
                        "latitude": "48.21335000",
                        "longitude": "14.21013000"
                    },
                    {
                        "id": 2892,
                        "name": "Oepping",
                        "latitude": "48.60284000",
                        "longitude": "13.94586000"
                    },
                    {
                        "id": 2895,
                        "name": "Offenhausen",
                        "latitude": "48.15000000",
                        "longitude": "13.83333000"
                    },
                    {
                        "id": 2897,
                        "name": "Ohlsdorf",
                        "latitude": "47.96073000",
                        "longitude": "13.79145000"
                    },
                    {
                        "id": 2902,
                        "name": "Ort im Innkreis",
                        "latitude": "48.31654000",
                        "longitude": "13.43362000"
                    },
                    {
                        "id": 2907,
                        "name": "Ostermiething",
                        "latitude": "48.04636000",
                        "longitude": "12.82937000"
                    },
                    {
                        "id": 2911,
                        "name": "Ottenschlag im Mühlkreis",
                        "latitude": "48.46632000",
                        "longitude": "14.38471000"
                    },
                    {
                        "id": 2912,
                        "name": "Ottensheim",
                        "latitude": "48.33246000",
                        "longitude": "14.17425000"
                    },
                    {
                        "id": 2915,
                        "name": "Ottnang am Hausruck",
                        "latitude": "48.09568000",
                        "longitude": "13.65841000"
                    },
                    {
                        "id": 2916,
                        "name": "Pabneukirchen",
                        "latitude": "48.32367000",
                        "longitude": "14.81747000"
                    },
                    {
                        "id": 2920,
                        "name": "Palting",
                        "latitude": "48.01542000",
                        "longitude": "13.12712000"
                    },
                    {
                        "id": 2926,
                        "name": "Pasching",
                        "latitude": "48.25931000",
                        "longitude": "14.20369000"
                    },
                    {
                        "id": 2930,
                        "name": "Pattigham",
                        "latitude": "48.15521000",
                        "longitude": "13.48443000"
                    },
                    {
                        "id": 2934,
                        "name": "Pennewang",
                        "latitude": "48.13333000",
                        "longitude": "13.85000000"
                    },
                    {
                        "id": 2938,
                        "name": "Perg",
                        "latitude": "48.25000000",
                        "longitude": "14.63333000"
                    },
                    {
                        "id": 2946,
                        "name": "Perwang am Grabensee",
                        "latitude": "48.00692000",
                        "longitude": "13.08300000"
                    },
                    {
                        "id": 2948,
                        "name": "Pettenbach",
                        "latitude": "47.96016000",
                        "longitude": "14.01692000"
                    },
                    {
                        "id": 2952,
                        "name": "Peuerbach",
                        "latitude": "48.34530000",
                        "longitude": "13.77205000"
                    },
                    {
                        "id": 2954,
                        "name": "Pfaffing",
                        "latitude": "48.01800000",
                        "longitude": "13.47507000"
                    },
                    {
                        "id": 2956,
                        "name": "Pfarrkirchen bei Bad Hall",
                        "latitude": "48.03046000",
                        "longitude": "14.19914000"
                    },
                    {
                        "id": 2964,
                        "name": "Pichl bei Wels",
                        "latitude": "48.18515000",
                        "longitude": "13.89882000"
                    },
                    {
                        "id": 2966,
                        "name": "Pierbach",
                        "latitude": "48.34815000",
                        "longitude": "14.75575000"
                    },
                    {
                        "id": 2973,
                        "name": "Pinsdorf",
                        "latitude": "47.92980000",
                        "longitude": "13.77068000"
                    },
                    {
                        "id": 2981,
                        "name": "Pitzenberg",
                        "latitude": "48.07361000",
                        "longitude": "13.72484000"
                    },
                    {
                        "id": 2984,
                        "name": "Plesching",
                        "latitude": "48.32099000",
                        "longitude": "14.33802000"
                    },
                    {
                        "id": 2990,
                        "name": "Politischer Bezirk Braunau am Inn",
                        "latitude": "48.11203000",
                        "longitude": "13.08924000"
                    },
                    {
                        "id": 2996,
                        "name": "Politischer Bezirk Eferding",
                        "latitude": "48.32168000",
                        "longitude": "13.98453000"
                    },
                    {
                        "id": 2999,
                        "name": "Politischer Bezirk Freistadt",
                        "latitude": "48.47006000",
                        "longitude": "14.64844000"
                    },
                    {
                        "id": 3000,
                        "name": "Politischer Bezirk Gmunden",
                        "latitude": "47.75000000",
                        "longitude": "13.75000000"
                    },
                    {
                        "id": 3003,
                        "name": "Politischer Bezirk Grieskirchen",
                        "latitude": "48.26667000",
                        "longitude": "13.80000000"
                    },
                    {
                        "id": 3014,
                        "name": "Politischer Bezirk Kirchdorf an der Krems",
                        "latitude": "47.84346000",
                        "longitude": "14.21346000"
                    },
                    {
                        "id": 3026,
                        "name": "Politischer Bezirk Linz-Land",
                        "latitude": "48.16667000",
                        "longitude": "14.30000000"
                    },
                    {
                        "id": 3037,
                        "name": "Politischer Bezirk Perg",
                        "latitude": "48.25724000",
                        "longitude": "14.71796000"
                    },
                    {
                        "id": 3039,
                        "name": "Politischer Bezirk Ried im Innkreis",
                        "latitude": "48.23333000",
                        "longitude": "13.46667000"
                    },
                    {
                        "id": 3040,
                        "name": "Politischer Bezirk Rohrbach",
                        "latitude": "48.55739000",
                        "longitude": "13.96926000"
                    },
                    {
                        "id": 3047,
                        "name": "Politischer Bezirk Schärding",
                        "latitude": "48.43333000",
                        "longitude": "13.60000000"
                    },
                    {
                        "id": 3049,
                        "name": "Politischer Bezirk Steyr-Land",
                        "latitude": "47.90000000",
                        "longitude": "14.46667000"
                    },
                    {
                        "id": 3053,
                        "name": "Politischer Bezirk Urfahr-Umgebung",
                        "latitude": "48.42512000",
                        "longitude": "14.27451000"
                    },
                    {
                        "id": 3056,
                        "name": "Politischer Bezirk Vöcklabruck",
                        "latitude": "48.00313000",
                        "longitude": "13.65772000"
                    },
                    {
                        "id": 3110,
                        "name": "Pötting",
                        "latitude": "48.28325000",
                        "longitude": "13.77059000"
                    },
                    {
                        "id": 3073,
                        "name": "Pram",
                        "latitude": "48.23536000",
                        "longitude": "13.60579000"
                    },
                    {
                        "id": 3074,
                        "name": "Prambachkirchen",
                        "latitude": "48.31711000",
                        "longitude": "13.90449000"
                    },
                    {
                        "id": 3075,
                        "name": "Pramet",
                        "latitude": "48.14295000",
                        "longitude": "13.48752000"
                    },
                    {
                        "id": 3077,
                        "name": "Pregarten",
                        "latitude": "48.35488000",
                        "longitude": "14.53217000"
                    },
                    {
                        "id": 3091,
                        "name": "Puchenau",
                        "latitude": "48.31214000",
                        "longitude": "14.23614000"
                    },
                    {
                        "id": 3093,
                        "name": "Puchheim",
                        "latitude": "48.00000000",
                        "longitude": "13.71667000"
                    },
                    {
                        "id": 3094,
                        "name": "Puchlkirchen am Trattberg",
                        "latitude": "48.04478000",
                        "longitude": "13.57198000"
                    },
                    {
                        "id": 3095,
                        "name": "Pucking",
                        "latitude": "48.18886000",
                        "longitude": "14.18824000"
                    },
                    {
                        "id": 3112,
                        "name": "Pühret",
                        "latitude": "48.03488000",
                        "longitude": "13.72252000"
                    },
                    {
                        "id": 3113,
                        "name": "Raab",
                        "latitude": "48.35243000",
                        "longitude": "13.64691000"
                    },
                    {
                        "id": 3126,
                        "name": "Raffelstetten",
                        "latitude": "48.23759000",
                        "longitude": "14.40273000"
                    },
                    {
                        "id": 3131,
                        "name": "Rainbach im Mühlkreis",
                        "latitude": "48.55758000",
                        "longitude": "14.47449000"
                    },
                    {
                        "id": 3142,
                        "name": "Ranshofen",
                        "latitude": "48.23308000",
                        "longitude": "13.01571000"
                    },
                    {
                        "id": 3158,
                        "name": "Redleiten",
                        "latitude": "48.08138000",
                        "longitude": "13.46894000"
                    },
                    {
                        "id": 3159,
                        "name": "Redlham",
                        "latitude": "48.02443000",
                        "longitude": "13.74738000"
                    },
                    {
                        "id": 3160,
                        "name": "Regau",
                        "latitude": "47.99078000",
                        "longitude": "13.68811000"
                    },
                    {
                        "id": 3163,
                        "name": "Reichenau im Mühlkreis",
                        "latitude": "48.45704000",
                        "longitude": "14.34875000"
                    },
                    {
                        "id": 3166,
                        "name": "Reichenthal",
                        "latitude": "48.54286000",
                        "longitude": "14.38471000"
                    },
                    {
                        "id": 3167,
                        "name": "Reichraming",
                        "latitude": "47.88333000",
                        "longitude": "14.45000000"
                    },
                    {
                        "id": 3174,
                        "name": "Reiterndorf",
                        "latitude": "47.70364000",
                        "longitude": "13.62914000"
                    },
                    {
                        "id": 3185,
                        "name": "Ried im Innkreis",
                        "latitude": "48.21123000",
                        "longitude": "13.48855000"
                    },
                    {
                        "id": 3187,
                        "name": "Ried im Traunkreis",
                        "latitude": "48.02581000",
                        "longitude": "14.07452000"
                    },
                    {
                        "id": 3189,
                        "name": "Ried in der Riedmark",
                        "latitude": "48.27114000",
                        "longitude": "14.52796000"
                    },
                    {
                        "id": 3200,
                        "name": "Rohr im Kremstal",
                        "latitude": "48.06864000",
                        "longitude": "14.19306000"
                    },
                    {
                        "id": 3205,
                        "name": "Rohrbach-Berg",
                        "latitude": "48.57275000",
                        "longitude": "13.98834000"
                    },
                    {
                        "id": 3208,
                        "name": "Roitham",
                        "latitude": "48.02432000",
                        "longitude": "13.82166000"
                    },
                    {
                        "id": 3217,
                        "name": "Rufling",
                        "latitude": "48.27839000",
                        "longitude": "14.21674000"
                    },
                    {
                        "id": 3228,
                        "name": "Rüstorf",
                        "latitude": "48.04326000",
                        "longitude": "13.78982000"
                    },
                    {
                        "id": 3222,
                        "name": "Rutzenham",
                        "latitude": "48.06076000",
                        "longitude": "13.71883000"
                    },
                    {
                        "id": 3236,
                        "name": "Sammersdorf",
                        "latitude": "48.18091000",
                        "longitude": "14.16670000"
                    },
                    {
                        "id": 3237,
                        "name": "Sankt Aegidi",
                        "latitude": "48.47929000",
                        "longitude": "13.73737000"
                    },
                    {
                        "id": 3248,
                        "name": "Sankt Dionysen",
                        "latitude": "48.22439000",
                        "longitude": "14.25485000"
                    },
                    {
                        "id": 3249,
                        "name": "Sankt Florian",
                        "latitude": "48.20568000",
                        "longitude": "14.37836000"
                    },
                    {
                        "id": 3252,
                        "name": "Sankt Georgen am Fillmannsbach",
                        "latitude": "48.12560000",
                        "longitude": "13.00811000"
                    },
                    {
                        "id": 3255,
                        "name": "Sankt Georgen an der Gusen",
                        "latitude": "48.27183000",
                        "longitude": "14.44951000"
                    },
                    {
                        "id": 3258,
                        "name": "Sankt Georgen bei Obernberg am Inn",
                        "latitude": "48.29193000",
                        "longitude": "13.33320000"
                    },
                    {
                        "id": 3259,
                        "name": "Sankt Georgen im Attergau",
                        "latitude": "47.93595000",
                        "longitude": "13.48306000"
                    },
                    {
                        "id": 3263,
                        "name": "Sankt Gotthard im Mühlkreis",
                        "latitude": "48.38020000",
                        "longitude": "14.13185000"
                    },
                    {
                        "id": 3283,
                        "name": "Sankt Lorenz",
                        "latitude": "47.83240000",
                        "longitude": "13.34839000"
                    },
                    {
                        "id": 3299,
                        "name": "Sankt Marien",
                        "latitude": "48.14805000",
                        "longitude": "14.27759000"
                    },
                    {
                        "id": 3302,
                        "name": "Sankt Martin",
                        "latitude": "48.23091000",
                        "longitude": "14.26781000"
                    },
                    {
                        "id": 3307,
                        "name": "Sankt Martin im Mühlkreis",
                        "latitude": "48.41553000",
                        "longitude": "14.03821000"
                    },
                    {
                        "id": 3315,
                        "name": "Sankt Oswald bei Freistadt",
                        "latitude": "48.50000000",
                        "longitude": "14.58333000"
                    },
                    {
                        "id": 3322,
                        "name": "Sankt Peter am Hart",
                        "latitude": "48.25268000",
                        "longitude": "13.09613000"
                    },
                    {
                        "id": 3340,
                        "name": "Sankt Ulrich bei Steyr",
                        "latitude": "48.02116000",
                        "longitude": "14.43685000"
                    },
                    {
                        "id": 3347,
                        "name": "Sankt Wolfgang im Salzkammergut",
                        "latitude": "47.73932000",
                        "longitude": "13.44666000"
                    },
                    {
                        "id": 3348,
                        "name": "Sarleinsbach",
                        "latitude": "48.54525000",
                        "longitude": "13.90491000"
                    },
                    {
                        "id": 3350,
                        "name": "Sattledt",
                        "latitude": "48.07372000",
                        "longitude": "14.05478000"
                    },
                    {
                        "id": 3354,
                        "name": "Schafwiesen",
                        "latitude": "48.16667000",
                        "longitude": "14.06667000"
                    },
                    {
                        "id": 3355,
                        "name": "Schalchen",
                        "latitude": "48.11924000",
                        "longitude": "13.15716000"
                    },
                    {
                        "id": 3356,
                        "name": "Schalchham",
                        "latitude": "47.99825000",
                        "longitude": "13.67188000"
                    },
                    {
                        "id": 3358,
                        "name": "Schardenberg",
                        "latitude": "48.52058000",
                        "longitude": "13.49791000"
                    },
                    {
                        "id": 3413,
                        "name": "Schärding",
                        "latitude": "48.45294000",
                        "longitude": "13.43722000"
                    },
                    {
                        "id": 3414,
                        "name": "Schärding Vorstadt",
                        "latitude": "48.45195000",
                        "longitude": "13.43946000"
                    },
                    {
                        "id": 3361,
                        "name": "Scharnstein",
                        "latitude": "47.90426000",
                        "longitude": "13.96135000"
                    },
                    {
                        "id": 3368,
                        "name": "Schenkenfelden",
                        "latitude": "48.50273000",
                        "longitude": "14.36188000"
                    },
                    {
                        "id": 3370,
                        "name": "Schildorn",
                        "latitude": "48.14564000",
                        "longitude": "13.46314000"
                    },
                    {
                        "id": 3373,
                        "name": "Schlatt",
                        "latitude": "48.07177000",
                        "longitude": "13.78904000"
                    },
                    {
                        "id": 3377,
                        "name": "Schlierbach",
                        "latitude": "47.93636000",
                        "longitude": "14.12018000"
                    },
                    {
                        "id": 3380,
                        "name": "Schlüsslberg",
                        "latitude": "48.21861000",
                        "longitude": "13.87161000"
                    },
                    {
                        "id": 3419,
                        "name": "Schöndorf",
                        "latitude": "48.00167000",
                        "longitude": "13.65880000"
                    },
                    {
                        "id": 3420,
                        "name": "Schönering",
                        "latitude": "48.29838000",
                        "longitude": "14.16103000"
                    },
                    {
                        "id": 3423,
                        "name": "Schörfling",
                        "latitude": "47.94544000",
                        "longitude": "13.60408000"
                    },
                    {
                        "id": 3394,
                        "name": "Schwanenstadt",
                        "latitude": "48.05537000",
                        "longitude": "13.77505000"
                    },
                    {
                        "id": 3407,
                        "name": "Schweinbach",
                        "latitude": "48.34033000",
                        "longitude": "14.42247000"
                    },
                    {
                        "id": 3410,
                        "name": "Schwertberg",
                        "latitude": "48.27340000",
                        "longitude": "14.58474000"
                    },
                    {
                        "id": 3434,
                        "name": "Seewalchen",
                        "latitude": "47.95246000",
                        "longitude": "13.58382000"
                    },
                    {
                        "id": 3454,
                        "name": "Sierning",
                        "latitude": "48.04343000",
                        "longitude": "14.30935000"
                    },
                    {
                        "id": 3469,
                        "name": "Sonnberg im Mühlkreis",
                        "latitude": "48.46080000",
                        "longitude": "14.31167000"
                    },
                    {
                        "id": 3477,
                        "name": "Spital am Pyhrn",
                        "latitude": "47.66487000",
                        "longitude": "14.34014000"
                    },
                    {
                        "id": 3489,
                        "name": "Stadl-Hausruck",
                        "latitude": "48.08255000",
                        "longitude": "13.85213000"
                    },
                    {
                        "id": 3490,
                        "name": "Stadl-Paura",
                        "latitude": "48.08333000",
                        "longitude": "13.86667000"
                    },
                    {
                        "id": 3491,
                        "name": "Stadl-Traun",
                        "latitude": "48.07963000",
                        "longitude": "13.86140000"
                    },
                    {
                        "id": 3515,
                        "name": "Steinbach am Attersee",
                        "latitude": "47.83087000",
                        "longitude": "13.54613000"
                    },
                    {
                        "id": 3518,
                        "name": "Steinerkirchen an der Traun",
                        "latitude": "48.07911000",
                        "longitude": "13.95796000"
                    },
                    {
                        "id": 3520,
                        "name": "Steinfeld",
                        "latitude": "47.71254000",
                        "longitude": "13.63260000"
                    },
                    {
                        "id": 3521,
                        "name": "Steinhaus",
                        "latitude": "48.11614000",
                        "longitude": "14.01890000"
                    },
                    {
                        "id": 3527,
                        "name": "Steyr",
                        "latitude": "48.04274000",
                        "longitude": "14.42127000"
                    },
                    {
                        "id": 3528,
                        "name": "Steyr Stadt",
                        "latitude": "48.03333000",
                        "longitude": "14.41667000"
                    },
                    {
                        "id": 3529,
                        "name": "Steyregg",
                        "latitude": "48.28513000",
                        "longitude": "14.36995000"
                    },
                    {
                        "id": 3543,
                        "name": "Strassham",
                        "latitude": "48.28348000",
                        "longitude": "14.14524000"
                    },
                    {
                        "id": 3569,
                        "name": "Taiskirchen im Innkreis",
                        "latitude": "48.26468000",
                        "longitude": "13.57318000"
                    },
                    {
                        "id": 3574,
                        "name": "Taufkirchen an der Trattnach",
                        "latitude": "48.24731000",
                        "longitude": "13.74767000"
                    },
                    {
                        "id": 3583,
                        "name": "Ternberg",
                        "latitude": "47.94518000",
                        "longitude": "14.35870000"
                    },
                    {
                        "id": 3588,
                        "name": "Thalheim bei Wels",
                        "latitude": "48.15000000",
                        "longitude": "14.03333000"
                    },
                    {
                        "id": 3599,
                        "name": "Tiefgraben",
                        "latitude": "47.87385000",
                        "longitude": "13.30591000"
                    },
                    {
                        "id": 3603,
                        "name": "Timelkam",
                        "latitude": "48.00394000",
                        "longitude": "13.60760000"
                    },
                    {
                        "id": 3607,
                        "name": "Tragwein",
                        "latitude": "48.33314000",
                        "longitude": "14.62237000"
                    },
                    {
                        "id": 3613,
                        "name": "Traun",
                        "latitude": "48.22656000",
                        "longitude": "14.23459000"
                    },
                    {
                        "id": 3614,
                        "name": "Traunkirchen",
                        "latitude": "47.84462000",
                        "longitude": "13.78939000"
                    },
                    {
                        "id": 3640,
                        "name": "Ufer",
                        "latitude": "48.24842000",
                        "longitude": "14.49977000"
                    },
                    {
                        "id": 3641,
                        "name": "Ulrichsberg",
                        "latitude": "48.67498000",
                        "longitude": "13.91049000"
                    },
                    {
                        "id": 3644,
                        "name": "Ungenach",
                        "latitude": "48.04756000",
                        "longitude": "13.61472000"
                    },
                    {
                        "id": 3650,
                        "name": "Untereisenfeld",
                        "latitude": "48.16800000",
                        "longitude": "14.04100000"
                    },
                    {
                        "id": 3653,
                        "name": "Unterjosefstal",
                        "latitude": "48.29216000",
                        "longitude": "14.57525000"
                    },
                    {
                        "id": 3668,
                        "name": "Uttendorf",
                        "latitude": "48.15887000",
                        "longitude": "13.12180000"
                    },
                    {
                        "id": 3670,
                        "name": "Utzenaich",
                        "latitude": "48.27622000",
                        "longitude": "13.46091000"
                    },
                    {
                        "id": 3677,
                        "name": "Viechtwang",
                        "latitude": "47.91531000",
                        "longitude": "13.96345000"
                    },
                    {
                        "id": 3703,
                        "name": "Vöcklabruck",
                        "latitude": "48.00279000",
                        "longitude": "13.65652000"
                    },
                    {
                        "id": 3704,
                        "name": "Vöcklamarkt",
                        "latitude": "48.00250000",
                        "longitude": "13.48383000"
                    },
                    {
                        "id": 3699,
                        "name": "Vorchdorf",
                        "latitude": "48.00388000",
                        "longitude": "13.92122000"
                    },
                    {
                        "id": 3714,
                        "name": "Wagrain",
                        "latitude": "48.00503000",
                        "longitude": "13.67163000"
                    },
                    {
                        "id": 3715,
                        "name": "Wagram",
                        "latitude": "48.23828000",
                        "longitude": "14.22996000"
                    },
                    {
                        "id": 3722,
                        "name": "Waizenkirchen",
                        "latitude": "48.33018000",
                        "longitude": "13.85754000"
                    },
                    {
                        "id": 3730,
                        "name": "Walding",
                        "latitude": "48.35209000",
                        "longitude": "14.15760000"
                    },
                    {
                        "id": 3731,
                        "name": "Waldkirchen am Wesen",
                        "latitude": "48.44059000",
                        "longitude": "13.82174000"
                    },
                    {
                        "id": 3733,
                        "name": "Waldneukirchen",
                        "latitude": "47.99854000",
                        "longitude": "14.25879000"
                    },
                    {
                        "id": 3735,
                        "name": "Waldzell",
                        "latitude": "48.13562000",
                        "longitude": "13.42701000"
                    },
                    {
                        "id": 3736,
                        "name": "Wallern an der Trattnach",
                        "latitude": "48.23296000",
                        "longitude": "13.94620000"
                    },
                    {
                        "id": 3746,
                        "name": "Wartberg an der Krems",
                        "latitude": "47.98909000",
                        "longitude": "14.11863000"
                    },
                    {
                        "id": 3747,
                        "name": "Wartberg ob der Aist",
                        "latitude": "48.34792000",
                        "longitude": "14.50796000"
                    },
                    {
                        "id": 3755,
                        "name": "Weibern",
                        "latitude": "48.18333000",
                        "longitude": "13.70000000"
                    },
                    {
                        "id": 3763,
                        "name": "Weilbach",
                        "latitude": "48.27725000",
                        "longitude": "13.37165000"
                    },
                    {
                        "id": 3782,
                        "name": "Weißenkirchen im Attergau",
                        "latitude": "47.94964000",
                        "longitude": "13.41843000"
                    },
                    {
                        "id": 3773,
                        "name": "Weisskirchen an der Traun",
                        "latitude": "48.16202000",
                        "longitude": "14.12395000"
                    },
                    {
                        "id": 3778,
                        "name": "Weitersfelden",
                        "latitude": "48.47730000",
                        "longitude": "14.72546000"
                    },
                    {
                        "id": 3785,
                        "name": "Wels",
                        "latitude": "48.16667000",
                        "longitude": "14.03333000"
                    },
                    {
                        "id": 3786,
                        "name": "Wels Stadt",
                        "latitude": "48.16082000",
                        "longitude": "14.02164000"
                    },
                    {
                        "id": 3787,
                        "name": "Wels-Land",
                        "latitude": "48.11660000",
                        "longitude": "13.96637000"
                    },
                    {
                        "id": 3788,
                        "name": "Wendling",
                        "latitude": "48.23182000",
                        "longitude": "13.66622000"
                    },
                    {
                        "id": 3789,
                        "name": "Weng im Innkreis",
                        "latitude": "48.23508000",
                        "longitude": "13.17801000"
                    },
                    {
                        "id": 3797,
                        "name": "Wernstein am Inn",
                        "latitude": "48.50802000",
                        "longitude": "13.46100000"
                    },
                    {
                        "id": 3801,
                        "name": "Weyer",
                        "latitude": "47.85717000",
                        "longitude": "14.66409000"
                    },
                    {
                        "id": 3802,
                        "name": "Weyregg",
                        "latitude": "47.90294000",
                        "longitude": "13.57193000"
                    },
                    {
                        "id": 3822,
                        "name": "Wimpassing",
                        "latitude": "48.16667000",
                        "longitude": "13.98333000"
                    },
                    {
                        "id": 3825,
                        "name": "Wimsbach",
                        "latitude": "48.06667000",
                        "longitude": "13.90000000"
                    },
                    {
                        "id": 3827,
                        "name": "Windhaag bei Freistadt",
                        "latitude": "48.58774000",
                        "longitude": "14.56186000"
                    },
                    {
                        "id": 3828,
                        "name": "Windhaag bei Perg",
                        "latitude": "48.28582000",
                        "longitude": "14.68091000"
                    },
                    {
                        "id": 3831,
                        "name": "Windischgarsten",
                        "latitude": "47.72223000",
                        "longitude": "14.32755000"
                    },
                    {
                        "id": 3836,
                        "name": "Wippenham",
                        "latitude": "48.22250000",
                        "longitude": "13.37920000"
                    },
                    {
                        "id": 3837,
                        "name": "Wispl",
                        "latitude": "48.16488000",
                        "longitude": "13.99753000"
                    },
                    {
                        "id": 3839,
                        "name": "Wolfern",
                        "latitude": "48.08278000",
                        "longitude": "14.37201000"
                    },
                    {
                        "id": 3844,
                        "name": "Wolfsegg am Hausruck",
                        "latitude": "48.10669000",
                        "longitude": "13.67274000"
                    },
                    {
                        "id": 3872,
                        "name": "Zell am Moos",
                        "latitude": "47.90000000",
                        "longitude": "13.31667000"
                    },
                    {
                        "id": 3873,
                        "name": "Zell am Pettenfirst",
                        "latitude": "48.08009000",
                        "longitude": "13.59936000"
                    },
                    {
                        "id": 3876,
                        "name": "Zell an der Pram",
                        "latitude": "48.31625000",
                        "longitude": "13.62923000"
                    },
                    {
                        "id": 3893,
                        "name": "Zwettl an der Rodl",
                        "latitude": "48.46552000",
                        "longitude": "14.27133000"
                    }
                ]
            },
            {
                "id": 2060,
                "name": "Vienna",
                "iso2": "9",
                "latitude": "48.20817430",
                "longitude": "16.37381890",
                "type": "state",
                "cities": [
                    {
                        "id": 1856,
                        "name": "Donaustadt",
                        "latitude": "48.23330000",
                        "longitude": "16.46002000"
                    },
                    {
                        "id": 1963,
                        "name": "Favoriten",
                        "latitude": "48.16116000",
                        "longitude": "16.38233000"
                    },
                    {
                        "id": 2002,
                        "name": "Floridsdorf",
                        "latitude": "48.25000000",
                        "longitude": "16.40000000"
                    },
                    {
                        "id": 2272,
                        "name": "Hernals",
                        "latitude": "48.23333000",
                        "longitude": "16.26667000"
                    },
                    {
                        "id": 2280,
                        "name": "Hietzing",
                        "latitude": "48.18623000",
                        "longitude": "16.29650000"
                    },
                    {
                        "id": 2356,
                        "name": "Innere Stadt",
                        "latitude": "48.20906000",
                        "longitude": "16.37135000"
                    },
                    {
                        "id": 2686,
                        "name": "Meidling",
                        "latitude": "48.16667000",
                        "longitude": "16.33333000"
                    },
                    {
                        "id": 2909,
                        "name": "Ottakring",
                        "latitude": "48.21667000",
                        "longitude": "16.30000000"
                    },
                    {
                        "id": 3461,
                        "name": "Simmering",
                        "latitude": "48.18333000",
                        "longitude": "16.43333000"
                    },
                    {
                        "id": 3681,
                        "name": "Vienna",
                        "latitude": "48.20849000",
                        "longitude": "16.37208000"
                    }
                ]
            },
            {
                "id": 2063,
                "name": "Vorarlberg",
                "iso2": "8",
                "latitude": "47.24974270",
                "longitude": "9.97973730",
                "type": "state",
                "cities": [
                    {
                        "id": 1623,
                        "name": "Alberschwende",
                        "latitude": "47.45025000",
                        "longitude": "9.83152000"
                    },
                    {
                        "id": 1635,
                        "name": "Altach",
                        "latitude": "47.35000000",
                        "longitude": "9.65000000"
                    },
                    {
                        "id": 1658,
                        "name": "Andelsbuch",
                        "latitude": "47.41167000",
                        "longitude": "9.89326000"
                    },
                    {
                        "id": 1701,
                        "name": "Au",
                        "latitude": "47.32176000",
                        "longitude": "9.98067000"
                    },
                    {
                        "id": 1712,
                        "name": "Ausserbraz",
                        "latitude": "47.14875000",
                        "longitude": "9.90066000"
                    },
                    {
                        "id": 1747,
                        "name": "Bartholomäberg",
                        "latitude": "47.08333000",
                        "longitude": "9.90000000"
                    },
                    {
                        "id": 1749,
                        "name": "Batschuns",
                        "latitude": "47.28306000",
                        "longitude": "9.65000000"
                    },
                    {
                        "id": 1767,
                        "name": "Bezau",
                        "latitude": "47.38478000",
                        "longitude": "9.90139000"
                    },
                    {
                        "id": 1773,
                        "name": "Bildstein",
                        "latitude": "47.45000000",
                        "longitude": "9.76667000"
                    },
                    {
                        "id": 1779,
                        "name": "Bizau",
                        "latitude": "47.36906000",
                        "longitude": "9.92839000"
                    },
                    {
                        "id": 1783,
                        "name": "Blons",
                        "latitude": "47.22327000",
                        "longitude": "9.83414000"
                    },
                    {
                        "id": 1784,
                        "name": "Bludenz",
                        "latitude": "47.15476000",
                        "longitude": "9.82255000"
                    },
                    {
                        "id": 1785,
                        "name": "Bludesch",
                        "latitude": "47.20000000",
                        "longitude": "9.73306000"
                    },
                    {
                        "id": 1790,
                        "name": "Brand",
                        "latitude": "47.10083000",
                        "longitude": "9.73722000"
                    },
                    {
                        "id": 1795,
                        "name": "Bregenz",
                        "latitude": "47.50311000",
                        "longitude": "9.74710000"
                    },
                    {
                        "id": 1827,
                        "name": "Bürs",
                        "latitude": "47.14972000",
                        "longitude": "9.80000000"
                    },
                    {
                        "id": 1828,
                        "name": "Bürserberg",
                        "latitude": "47.14644000",
                        "longitude": "9.77736000"
                    },
                    {
                        "id": 1829,
                        "name": "Dalaas",
                        "latitude": "47.12446000",
                        "longitude": "9.99104000"
                    },
                    {
                        "id": 1830,
                        "name": "Damüls",
                        "latitude": "47.28034000",
                        "longitude": "9.89164000"
                    },
                    {
                        "id": 1861,
                        "name": "Doren",
                        "latitude": "47.49278000",
                        "longitude": "9.87972000"
                    },
                    {
                        "id": 1865,
                        "name": "Dornbirn",
                        "latitude": "47.41427000",
                        "longitude": "9.74195000"
                    },
                    {
                        "id": 1874,
                        "name": "Düns",
                        "latitude": "47.22353000",
                        "longitude": "9.71663000"
                    },
                    {
                        "id": 1875,
                        "name": "Dünserberg",
                        "latitude": "47.22752000",
                        "longitude": "9.72372000"
                    },
                    {
                        "id": 1907,
                        "name": "Egg",
                        "latitude": "47.43154000",
                        "longitude": "9.89762000"
                    },
                    {
                        "id": 1918,
                        "name": "Eichenberg",
                        "latitude": "47.53333000",
                        "longitude": "9.78333000"
                    },
                    {
                        "id": 1973,
                        "name": "Feldkirch",
                        "latitude": "47.23306000",
                        "longitude": "9.60000000"
                    },
                    {
                        "id": 2012,
                        "name": "Frastanz",
                        "latitude": "47.21735000",
                        "longitude": "9.62995000"
                    },
                    {
                        "id": 2016,
                        "name": "Fraxern",
                        "latitude": "47.31498000",
                        "longitude": "9.67391000"
                    },
                    {
                        "id": 2032,
                        "name": "Fußach",
                        "latitude": "47.47933000",
                        "longitude": "9.66278000"
                    },
                    {
                        "id": 2045,
                        "name": "Gaißau",
                        "latitude": "47.46667000",
                        "longitude": "9.60000000"
                    },
                    {
                        "id": 2060,
                        "name": "Gaschurn",
                        "latitude": "46.98584000",
                        "longitude": "10.02702000"
                    },
                    {
                        "id": 2184,
                        "name": "Göfis",
                        "latitude": "47.23356000",
                        "longitude": "9.63458000"
                    },
                    {
                        "id": 2195,
                        "name": "Götzis",
                        "latitude": "47.33306000",
                        "longitude": "9.63306000"
                    },
                    {
                        "id": 2151,
                        "name": "Großdorf",
                        "latitude": "47.43361000",
                        "longitude": "9.91528000"
                    },
                    {
                        "id": 2229,
                        "name": "Hard",
                        "latitude": "47.48306000",
                        "longitude": "9.68306000"
                    },
                    {
                        "id": 2293,
                        "name": "Hirschegg",
                        "latitude": "47.34813000",
                        "longitude": "10.17137000"
                    },
                    {
                        "id": 2295,
                        "name": "Hittisau",
                        "latitude": "47.45781000",
                        "longitude": "9.95962000"
                    },
                    {
                        "id": 2336,
                        "name": "Höchst",
                        "latitude": "47.45934000",
                        "longitude": "9.64050000"
                    },
                    {
                        "id": 2316,
                        "name": "Hohenems",
                        "latitude": "47.36667000",
                        "longitude": "9.68306000"
                    },
                    {
                        "id": 2320,
                        "name": "Hohenweiler",
                        "latitude": "47.58333000",
                        "longitude": "9.78333000"
                    },
                    {
                        "id": 2342,
                        "name": "Hörbranz",
                        "latitude": "47.55000000",
                        "longitude": "9.75000000"
                    },
                    {
                        "id": 2355,
                        "name": "Innerbraz",
                        "latitude": "47.15000000",
                        "longitude": "9.91667000"
                    },
                    {
                        "id": 2419,
                        "name": "Kennelbach",
                        "latitude": "47.48306000",
                        "longitude": "9.76667000"
                    },
                    {
                        "id": 2447,
                        "name": "Klaus",
                        "latitude": "47.30913000",
                        "longitude": "9.64678000"
                    },
                    {
                        "id": 2464,
                        "name": "Klösterle",
                        "latitude": "47.13333000",
                        "longitude": "10.08333000"
                    },
                    {
                        "id": 2468,
                        "name": "Koblach",
                        "latitude": "47.33306000",
                        "longitude": "9.60000000"
                    },
                    {
                        "id": 2496,
                        "name": "Krumbach",
                        "latitude": "47.48306000",
                        "longitude": "9.93583000"
                    },
                    {
                        "id": 2537,
                        "name": "Langen",
                        "latitude": "47.51667000",
                        "longitude": "9.81667000"
                    },
                    {
                        "id": 2538,
                        "name": "Langenegg",
                        "latitude": "47.46922000",
                        "longitude": "9.89744000"
                    },
                    {
                        "id": 2555,
                        "name": "Lauterach",
                        "latitude": "47.47572000",
                        "longitude": "9.72941000"
                    },
                    {
                        "id": 2559,
                        "name": "Lech",
                        "latitude": "47.20797000",
                        "longitude": "10.14184000"
                    },
                    {
                        "id": 2602,
                        "name": "Lingenau",
                        "latitude": "47.45033000",
                        "longitude": "9.92166000"
                    },
                    {
                        "id": 2607,
                        "name": "Lochau",
                        "latitude": "47.53333000",
                        "longitude": "9.75000000"
                    },
                    {
                        "id": 2615,
                        "name": "Lorüns",
                        "latitude": "47.13306000",
                        "longitude": "9.85000000"
                    },
                    {
                        "id": 2617,
                        "name": "Ludesch",
                        "latitude": "47.20000000",
                        "longitude": "9.78306000"
                    },
                    {
                        "id": 2621,
                        "name": "Lustenau",
                        "latitude": "47.42642000",
                        "longitude": "9.65851000"
                    },
                    {
                        "id": 2739,
                        "name": "Mäder",
                        "latitude": "47.35000000",
                        "longitude": "9.61667000"
                    },
                    {
                        "id": 2687,
                        "name": "Meiningen",
                        "latitude": "47.29891000",
                        "longitude": "9.57862000"
                    },
                    {
                        "id": 2690,
                        "name": "Mellau",
                        "latitude": "47.35034000",
                        "longitude": "9.88149000"
                    },
                    {
                        "id": 2707,
                        "name": "Mittelberg",
                        "latitude": "47.35127000",
                        "longitude": "10.17197000"
                    },
                    {
                        "id": 2741,
                        "name": "Möggers",
                        "latitude": "47.56667000",
                        "longitude": "9.81667000"
                    },
                    {
                        "id": 2734,
                        "name": "Muntlix",
                        "latitude": "47.28296000",
                        "longitude": "9.65939000"
                    },
                    {
                        "id": 2778,
                        "name": "Nenzing",
                        "latitude": "47.18436000",
                        "longitude": "9.70539000"
                    },
                    {
                        "id": 2841,
                        "name": "Nüziders",
                        "latitude": "47.16667000",
                        "longitude": "9.80000000"
                    },
                    {
                        "id": 2989,
                        "name": "Politischer Bezirk Bludenz",
                        "latitude": "47.15144000",
                        "longitude": "9.82452000"
                    },
                    {
                        "id": 2991,
                        "name": "Politischer Bezirk Bregenz",
                        "latitude": "47.42069000",
                        "longitude": "9.91989000"
                    },
                    {
                        "id": 2995,
                        "name": "Politischer Bezirk Dornbirn",
                        "latitude": "47.38349000",
                        "longitude": "9.74940000"
                    },
                    {
                        "id": 2997,
                        "name": "Politischer Bezirk Feldkirch",
                        "latitude": "47.25535000",
                        "longitude": "9.58360000"
                    },
                    {
                        "id": 3127,
                        "name": "Raggal",
                        "latitude": "47.21082000",
                        "longitude": "9.83688000"
                    },
                    {
                        "id": 3140,
                        "name": "Rankweil",
                        "latitude": "47.27108000",
                        "longitude": "9.64308000"
                    },
                    {
                        "id": 3183,
                        "name": "Reuthe",
                        "latitude": "47.37113000",
                        "longitude": "9.89481000"
                    },
                    {
                        "id": 3191,
                        "name": "Riefensberg",
                        "latitude": "47.50137000",
                        "longitude": "9.95838000"
                    },
                    {
                        "id": 3195,
                        "name": "Riezlern",
                        "latitude": "47.35778000",
                        "longitude": "10.18759000"
                    },
                    {
                        "id": 3224,
                        "name": "Röns",
                        "latitude": "47.21667000",
                        "longitude": "9.70000000"
                    },
                    {
                        "id": 3227,
                        "name": "Röthis",
                        "latitude": "47.29332000",
                        "longitude": "9.65484000"
                    },
                    {
                        "id": 3244,
                        "name": "Sankt Anton im Montafon",
                        "latitude": "47.11667000",
                        "longitude": "9.86667000"
                    },
                    {
                        "id": 3251,
                        "name": "Sankt Gallenkirch",
                        "latitude": "47.02102000",
                        "longitude": "9.97335000"
                    },
                    {
                        "id": 3349,
                        "name": "Satteins",
                        "latitude": "47.21667000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 3378,
                        "name": "Schlins",
                        "latitude": "47.20000000",
                        "longitude": "9.70000000"
                    },
                    {
                        "id": 3381,
                        "name": "Schnepfau",
                        "latitude": "47.35206000",
                        "longitude": "9.94520000"
                    },
                    {
                        "id": 3382,
                        "name": "Schnifis",
                        "latitude": "47.21667000",
                        "longitude": "9.73306000"
                    },
                    {
                        "id": 3383,
                        "name": "Schoppernau",
                        "latitude": "47.31205000",
                        "longitude": "10.01646000"
                    },
                    {
                        "id": 3391,
                        "name": "Schröcken",
                        "latitude": "47.25755000",
                        "longitude": "10.09197000"
                    },
                    {
                        "id": 3390,
                        "name": "Schruns",
                        "latitude": "47.06667000",
                        "longitude": "9.91667000"
                    },
                    {
                        "id": 3395,
                        "name": "Schwarzach",
                        "latitude": "47.44904000",
                        "longitude": "9.76213000"
                    },
                    {
                        "id": 3403,
                        "name": "Schwarzenberg",
                        "latitude": "47.41415000",
                        "longitude": "9.85154000"
                    },
                    {
                        "id": 3448,
                        "name": "Sibratsgfäll",
                        "latitude": "47.42667000",
                        "longitude": "10.03806000"
                    },
                    {
                        "id": 3458,
                        "name": "Silbertal",
                        "latitude": "47.09368000",
                        "longitude": "9.98314000"
                    },
                    {
                        "id": 3497,
                        "name": "Stallehr",
                        "latitude": "47.13306000",
                        "longitude": "9.85000000"
                    },
                    {
                        "id": 3561,
                        "name": "Sulz",
                        "latitude": "47.28721000",
                        "longitude": "9.65183000"
                    },
                    {
                        "id": 3562,
                        "name": "Sulzberg",
                        "latitude": "47.52178000",
                        "longitude": "9.91353000"
                    },
                    {
                        "id": 3597,
                        "name": "Thüringen",
                        "latitude": "47.20000000",
                        "longitude": "9.76667000"
                    },
                    {
                        "id": 3629,
                        "name": "Tschagguns",
                        "latitude": "47.08333000",
                        "longitude": "9.90000000"
                    },
                    {
                        "id": 3900,
                        "name": "Übersaxen",
                        "latitude": "47.25284000",
                        "longitude": "9.67080000"
                    },
                    {
                        "id": 3672,
                        "name": "Vandans",
                        "latitude": "47.09569000",
                        "longitude": "9.86525000"
                    },
                    {
                        "id": 3683,
                        "name": "Viktorsberg",
                        "latitude": "47.30092000",
                        "longitude": "9.67484000"
                    },
                    {
                        "id": 3749,
                        "name": "Warth",
                        "latitude": "47.25000000",
                        "longitude": "10.18333000"
                    },
                    {
                        "id": 3764,
                        "name": "Weiler",
                        "latitude": "47.29972000",
                        "longitude": "9.65000000"
                    },
                    {
                        "id": 3847,
                        "name": "Wolfurt",
                        "latitude": "47.46667000",
                        "longitude": "9.75000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 16,
        "name": "Azerbaijan",
        "iso3": "AZE",
        "iso2": "AZ",
        "numeric_code": "031",
        "phonecode": "994",
        "capital": "Baku",
        "currency": "AZN",
        "currency_name": "Azerbaijani manat",
        "currency_symbol": "m",
        "tld": ".az",
        "native": "Azərbaycan",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Azerbaijani, Azeri",
        "timezones": [
            {
                "zoneName": "Asia\/Baku",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "AZT",
                "tzName": "Azerbaijan Time"
            }
        ],
        "translations": {
            "br": "Azerbaidjan",
            "ko": "아제르바이잔",
            "pt-BR": "Azerbaijão",
            "pt": "Azerbaijão",
            "nl": "Azerbeidzjan",
            "hr": "Azerbajdžan",
            "fa": "آذربایجان",
            "de": "Aserbaidschan",
            "es": "Azerbaiyán",
            "fr": "Azerbaïdjan",
            "ja": "アゼルバイジャン",
            "it": "Azerbaijan",
            "zh-CN": "阿塞拜疆",
            "tr": "Azerbaycan",
            "ru": "Азербайджан",
            "uk": "Азербайджан",
            "pl": "Azerbejdżan"
        },
        "latitude": "40.50000000",
        "longitude": "47.50000000",
        "emoji": "🇦🇿",
        "emojiU": "U+1F1E6 U+1F1FF",
        "states": [
            {
                "id": 540,
                "name": "Absheron",
                "iso2": "ABS",
                "latitude": "40.36296930",
                "longitude": "49.27368150",
                "type": "district",
                "cities": [
                    {
                        "id": 8069,
                        "name": "Ceyranbatan",
                        "latitude": "40.54194000",
                        "longitude": "49.66073000"
                    },
                    {
                        "id": 8073,
                        "name": "Digah",
                        "latitude": "40.49257000",
                        "longitude": "49.87477000"
                    },
                    {
                        "id": 8085,
                        "name": "Gyuzdek",
                        "latitude": "40.37444000",
                        "longitude": "49.68194000"
                    },
                    {
                        "id": 8099,
                        "name": "Khirdalan",
                        "latitude": "40.44808000",
                        "longitude": "49.75502000"
                    },
                    {
                        "id": 8148,
                        "name": "Qobu",
                        "latitude": "40.40472000",
                        "longitude": "49.71306000"
                    },
                    {
                        "id": 8169,
                        "name": "Saray",
                        "latitude": "40.53299000",
                        "longitude": "49.71681000"
                    }
                ]
            },
            {
                "id": 559,
                "name": "Agdam",
                "iso2": "AGM",
                "latitude": "39.99318530",
                "longitude": "46.99495620",
                "type": "district",
                "cities": [
                    {
                        "id": 8049,
                        "name": "Ağdam",
                        "latitude": "39.99096000",
                        "longitude": "46.92736000"
                    }
                ]
            },
            {
                "id": 553,
                "name": "Agdash",
                "iso2": "AGS",
                "latitude": "40.63354270",
                "longitude": "47.46743100",
                "type": "district",
                "cities": [
                    {
                        "id": 8050,
                        "name": "Ağdaş",
                        "latitude": "40.64699000",
                        "longitude": "47.47380000"
                    }
                ]
            },
            {
                "id": 577,
                "name": "Aghjabadi",
                "iso2": "AGC",
                "latitude": "28.78918410",
                "longitude": "77.51607880",
                "type": "district",
                "cities": [
                    {
                        "id": 8037,
                        "name": "Agdzhabedy",
                        "latitude": "40.05015000",
                        "longitude": "47.45937000"
                    },
                    {
                        "id": 8048,
                        "name": "Avşar",
                        "latitude": "39.97389000",
                        "longitude": "47.42389000"
                    }
                ]
            },
            {
                "id": 543,
                "name": "Agstafa",
                "iso2": "AGA",
                "latitude": "41.26559330",
                "longitude": "45.51342910",
                "type": "district",
                "cities": [
                    {
                        "id": 8038,
                        "name": "Aghstafa",
                        "latitude": "41.11889000",
                        "longitude": "45.45389000"
                    },
                    {
                        "id": 8163,
                        "name": "Saloğlu",
                        "latitude": "41.27524000",
                        "longitude": "45.35293000"
                    },
                    {
                        "id": 8188,
                        "name": "Vurğun",
                        "latitude": "41.09524000",
                        "longitude": "45.47111000"
                    }
                ]
            },
            {
                "id": 547,
                "name": "Agsu",
                "iso2": "AGU",
                "latitude": "40.52833390",
                "longitude": "48.36508350",
                "type": "district",
                "cities": [
                    {
                        "id": 8039,
                        "name": "Aghsu",
                        "latitude": "40.57028000",
                        "longitude": "48.40087000"
                    }
                ]
            },
            {
                "id": 528,
                "name": "Astara",
                "iso2": "AST",
                "latitude": "38.49378450",
                "longitude": "48.69443650",
                "type": "district",
                "cities": [
                    {
                        "id": 8047,
                        "name": "Astara",
                        "latitude": "38.45598000",
                        "longitude": "48.87498000"
                    },
                    {
                        "id": 8103,
                        "name": "Kizhaba",
                        "latitude": "38.53461000",
                        "longitude": "48.80546000"
                    }
                ]
            },
            {
                "id": 575,
                "name": "Babek",
                "iso2": "BAB",
                "latitude": "39.15076130",
                "longitude": "45.44853680",
                "type": "district",
                "cities": []
            },
            {
                "id": 552,
                "name": "Baku",
                "iso2": "BA",
                "latitude": "40.40926170",
                "longitude": "49.86709240",
                "type": "municipality",
                "cities": [
                    {
                        "id": 8042,
                        "name": "Amirdzhan",
                        "latitude": "40.42639000",
                        "longitude": "49.98361000"
                    },
                    {
                        "id": 8051,
                        "name": "Badamdar",
                        "latitude": "40.34024000",
                        "longitude": "49.80450000"
                    },
                    {
                        "id": 8053,
                        "name": "Bakıxanov",
                        "latitude": "40.41894000",
                        "longitude": "49.96693000"
                    },
                    {
                        "id": 8052,
                        "name": "Baku",
                        "latitude": "40.37767000",
                        "longitude": "49.89201000"
                    },
                    {
                        "id": 8054,
                        "name": "Balakhani",
                        "latitude": "40.46344000",
                        "longitude": "49.91893000"
                    },
                    {
                        "id": 8060,
                        "name": "Bilajari",
                        "latitude": "40.44440000",
                        "longitude": "49.80566000"
                    },
                    {
                        "id": 8061,
                        "name": "Bilajer",
                        "latitude": "40.56441000",
                        "longitude": "50.04002000"
                    },
                    {
                        "id": 8062,
                        "name": "Binagadi",
                        "latitude": "40.46602000",
                        "longitude": "49.82783000"
                    },
                    {
                        "id": 8063,
                        "name": "Biny Selo",
                        "latitude": "40.45076000",
                        "longitude": "50.08686000"
                    },
                    {
                        "id": 8066,
                        "name": "Buzovna",
                        "latitude": "40.51903000",
                        "longitude": "50.11438000"
                    },
                    {
                        "id": 8093,
                        "name": "Hövsan",
                        "latitude": "40.37444000",
                        "longitude": "50.08528000"
                    },
                    {
                        "id": 8100,
                        "name": "Khodzhi-Gasan",
                        "latitude": "40.41293000",
                        "longitude": "49.76904000"
                    },
                    {
                        "id": 8104,
                        "name": "Korgöz",
                        "latitude": "40.30446000",
                        "longitude": "49.62360000"
                    },
                    {
                        "id": 8111,
                        "name": "Lökbatan",
                        "latitude": "40.32560000",
                        "longitude": "49.73376000"
                    },
                    {
                        "id": 8113,
                        "name": "Mardakan",
                        "latitude": "40.49182000",
                        "longitude": "50.14292000"
                    },
                    {
                        "id": 8116,
                        "name": "Maştağa",
                        "latitude": "40.52983000",
                        "longitude": "50.00616000"
                    },
                    {
                        "id": 8121,
                        "name": "Nardaran",
                        "latitude": "40.55611000",
                        "longitude": "50.00556000"
                    },
                    {
                        "id": 8123,
                        "name": "Nizami Rayonu",
                        "latitude": "40.40970000",
                        "longitude": "49.91926000"
                    },
                    {
                        "id": 8131,
                        "name": "Pirallahı",
                        "latitude": "40.47013000",
                        "longitude": "50.32476000"
                    },
                    {
                        "id": 8134,
                        "name": "Puta",
                        "latitude": "40.29667000",
                        "longitude": "49.66028000"
                    },
                    {
                        "id": 8136,
                        "name": "Qala",
                        "latitude": "40.44256000",
                        "longitude": "50.16759000"
                    },
                    {
                        "id": 8142,
                        "name": "Qaraçuxur",
                        "latitude": "40.39667000",
                        "longitude": "49.97361000"
                    },
                    {
                        "id": 8149,
                        "name": "Qobustan",
                        "latitude": "40.08238000",
                        "longitude": "49.41205000"
                    },
                    {
                        "id": 8159,
                        "name": "Ramana",
                        "latitude": "40.44222000",
                        "longitude": "49.98056000"
                    },
                    {
                        "id": 8162,
                        "name": "Sabunçu",
                        "latitude": "40.44250000",
                        "longitude": "49.94806000"
                    },
                    {
                        "id": 8168,
                        "name": "Sanqaçal",
                        "latitude": "40.16991000",
                        "longitude": "49.46394000"
                    },
                    {
                        "id": 8184,
                        "name": "Türkan",
                        "latitude": "40.36460000",
                        "longitude": "50.22075000"
                    },
                    {
                        "id": 8197,
                        "name": "Yeni Suraxanı",
                        "latitude": "40.43026000",
                        "longitude": "50.03598000"
                    },
                    {
                        "id": 8201,
                        "name": "Zabrat",
                        "latitude": "40.47746000",
                        "longitude": "49.94174000"
                    },
                    {
                        "id": 8205,
                        "name": "Zyrya",
                        "latitude": "40.36613000",
                        "longitude": "50.29198000"
                    }
                ]
            },
            {
                "id": 560,
                "name": "Balakan",
                "iso2": "BAL",
                "latitude": "41.70375090",
                "longitude": "46.40442130",
                "type": "district",
                "cities": [
                    {
                        "id": 8058,
                        "name": "Belokany",
                        "latitude": "41.72626000",
                        "longitude": "46.40478000"
                    },
                    {
                        "id": 8135,
                        "name": "Qabaqçöl",
                        "latitude": "41.75259000",
                        "longitude": "46.27052000"
                    }
                ]
            },
            {
                "id": 569,
                "name": "Barda",
                "iso2": "BAR",
                "latitude": "40.37065550",
                "longitude": "47.13789090",
                "type": "district",
                "cities": [
                    {
                        "id": 8055,
                        "name": "Barda",
                        "latitude": "40.37577000",
                        "longitude": "47.12619000"
                    },
                    {
                        "id": 8167,
                        "name": "Samuxlu",
                        "latitude": "40.50833000",
                        "longitude": "47.16917000"
                    }
                ]
            },
            {
                "id": 554,
                "name": "Beylagan",
                "iso2": "BEY",
                "latitude": "39.77230730",
                "longitude": "47.61541660",
                "type": "district",
                "cities": [
                    {
                        "id": 8059,
                        "name": "Beylagan",
                        "latitude": "39.77556000",
                        "longitude": "47.61861000"
                    },
                    {
                        "id": 8064,
                        "name": "Birinci Aşıqlı",
                        "latitude": "39.81917000",
                        "longitude": "47.67944000"
                    },
                    {
                        "id": 8078,
                        "name": "Dünyamalılar",
                        "latitude": "39.77278000",
                        "longitude": "47.75889000"
                    },
                    {
                        "id": 8128,
                        "name": "Orjonikidze",
                        "latitude": "39.63571000",
                        "longitude": "47.71199000"
                    },
                    {
                        "id": 8200,
                        "name": "Yuxarı Aran",
                        "latitude": "39.73361000",
                        "longitude": "47.65500000"
                    }
                ]
            },
            {
                "id": 532,
                "name": "Bilasuvar",
                "iso2": "BIL",
                "latitude": "39.45988330",
                "longitude": "48.55098130",
                "type": "district",
                "cities": [
                    {
                        "id": 8133,
                        "name": "Pushkino",
                        "latitude": "39.45833000",
                        "longitude": "48.54500000"
                    }
                ]
            },
            {
                "id": 561,
                "name": "Dashkasan",
                "iso2": "DAS",
                "latitude": "40.52022570",
                "longitude": "46.07793040",
                "type": "district",
                "cities": [
                    {
                        "id": 8187,
                        "name": "Verkhniy Dashkesan",
                        "latitude": "40.49357000",
                        "longitude": "46.07175000"
                    },
                    {
                        "id": 8199,
                        "name": "Yukhary-Dashkesan",
                        "latitude": "40.52393000",
                        "longitude": "46.08186000"
                    }
                ]
            },
            {
                "id": 527,
                "name": "Fizuli",
                "iso2": "FUZ",
                "latitude": "39.53786050",
                "longitude": "47.30338770",
                "type": "district",
                "cities": [
                    {
                        "id": 8080,
                        "name": "Fizuli",
                        "latitude": "39.60094000",
                        "longitude": "47.14529000"
                    },
                    {
                        "id": 8092,
                        "name": "Horadiz",
                        "latitude": "39.45015000",
                        "longitude": "47.33496000"
                    }
                ]
            },
            {
                "id": 585,
                "name": "Ganja",
                "iso2": "GA",
                "latitude": "36.36873380",
                "longitude": "-95.99857670",
                "type": "municipality",
                "cities": [
                    {
                        "id": 8081,
                        "name": "Ganja",
                        "latitude": "40.68278000",
                        "longitude": "46.36056000"
                    }
                ]
            },
            {
                "id": 589,
                "name": "Gədəbəy",
                "iso2": "GAD",
                "latitude": "40.56996390",
                "longitude": "45.81068830",
                "type": "district",
                "cities": [
                    {
                        "id": 8044,
                        "name": "Arıqdam",
                        "latitude": "40.59313000",
                        "longitude": "45.79900000"
                    },
                    {
                        "id": 8045,
                        "name": "Arıqıran",
                        "latitude": "40.53971000",
                        "longitude": "45.61414000"
                    },
                    {
                        "id": 8067,
                        "name": "Böyük Qaramurad",
                        "latitude": "40.57626000",
                        "longitude": "45.63727000"
                    },
                    {
                        "id": 8105,
                        "name": "Kyadabek",
                        "latitude": "40.57055000",
                        "longitude": "45.81229000"
                    },
                    {
                        "id": 8124,
                        "name": "Novosaratovka",
                        "latitude": "40.59811000",
                        "longitude": "45.60079000"
                    }
                ]
            },
            {
                "id": 573,
                "name": "Gobustan",
                "iso2": "QOB",
                "latitude": "40.53261040",
                "longitude": "48.92737500",
                "type": "district",
                "cities": [
                    {
                        "id": 8150,
                        "name": "Qobustan",
                        "latitude": "40.53360000",
                        "longitude": "48.92819000"
                    }
                ]
            },
            {
                "id": 551,
                "name": "Goranboy",
                "iso2": "GOR",
                "latitude": "40.53805060",
                "longitude": "46.59908910",
                "type": "district",
                "cities": [
                    {
                        "id": 8084,
                        "name": "Goranboy",
                        "latitude": "40.61028000",
                        "longitude": "46.78972000"
                    },
                    {
                        "id": 8158,
                        "name": "Qızılhacılı",
                        "latitude": "40.57362000",
                        "longitude": "46.84900000"
                    }
                ]
            },
            {
                "id": 531,
                "name": "Goychay",
                "iso2": "GOY",
                "latitude": "40.62361680",
                "longitude": "47.74030340",
                "type": "district",
                "cities": [
                    {
                        "id": 8082,
                        "name": "Geoktschai",
                        "latitude": "40.65055000",
                        "longitude": "47.74219000"
                    }
                ]
            },
            {
                "id": 574,
                "name": "Goygol",
                "iso2": "GYG",
                "latitude": "40.55953780",
                "longitude": "46.33149530",
                "type": "district",
                "cities": [
                    {
                        "id": 8196,
                        "name": "Yelenendorf",
                        "latitude": "40.58584000",
                        "longitude": "46.31890000"
                    }
                ]
            },
            {
                "id": 571,
                "name": "Hajigabul",
                "iso2": "HAC",
                "latitude": "40.03937700",
                "longitude": "48.92025330",
                "type": "district",
                "cities": [
                    {
                        "id": 8088,
                        "name": "Hacıqabul",
                        "latitude": "40.03874000",
                        "longitude": "48.94286000"
                    },
                    {
                        "id": 8119,
                        "name": "Mughan",
                        "latitude": "40.09902000",
                        "longitude": "48.81886000"
                    }
                ]
            },
            {
                "id": 544,
                "name": "Imishli",
                "iso2": "IMI",
                "latitude": "39.86946860",
                "longitude": "48.06652180",
                "type": "district",
                "cities": [
                    {
                        "id": 8094,
                        "name": "Imishli",
                        "latitude": "39.87095000",
                        "longitude": "48.05995000"
                    }
                ]
            },
            {
                "id": 564,
                "name": "Ismailli",
                "iso2": "ISM",
                "latitude": "40.74299360",
                "longitude": "48.21255560",
                "type": "district",
                "cities": [
                    {
                        "id": 8056,
                        "name": "Basqal",
                        "latitude": "40.75520000",
                        "longitude": "48.39104000"
                    },
                    {
                        "id": 8210,
                        "name": "İsmayıllı",
                        "latitude": "40.78485000",
                        "longitude": "48.15141000"
                    }
                ]
            },
            {
                "id": 570,
                "name": "Jabrayil",
                "iso2": "CAB",
                "latitude": "39.26455440",
                "longitude": "46.96215620",
                "type": "district",
                "cities": [
                    {
                        "id": 8096,
                        "name": "Jebrail",
                        "latitude": "39.39917000",
                        "longitude": "47.02835000"
                    }
                ]
            },
            {
                "id": 578,
                "name": "Jalilabad",
                "iso2": "CAL",
                "latitude": "39.20516320",
                "longitude": "48.51006040",
                "type": "district",
                "cities": [
                    {
                        "id": 8095,
                        "name": "Jalilabad",
                        "latitude": "39.20963000",
                        "longitude": "48.49186000"
                    },
                    {
                        "id": 8132,
                        "name": "Prishibinskoye",
                        "latitude": "39.11998000",
                        "longitude": "48.59383000"
                    }
                ]
            },
            {
                "id": 572,
                "name": "Julfa",
                "iso2": "CUL",
                "latitude": "38.96049830",
                "longitude": "45.62929390",
                "type": "district",
                "cities": []
            },
            {
                "id": 525,
                "name": "Kalbajar",
                "iso2": "KAL",
                "latitude": "40.10243290",
                "longitude": "46.03648720",
                "type": "district",
                "cities": [
                    {
                        "id": 8098,
                        "name": "Kerbakhiar",
                        "latitude": "40.10984000",
                        "longitude": "46.04446000"
                    },
                    {
                        "id": 8186,
                        "name": "Vank",
                        "latitude": "40.05275000",
                        "longitude": "46.54419000"
                    }
                ]
            },
            {
                "id": 567,
                "name": "Kangarli",
                "iso2": "KAN",
                "latitude": "39.38719400",
                "longitude": "45.16398520",
                "type": "district",
                "cities": []
            },
            {
                "id": 590,
                "name": "Khachmaz",
                "iso2": "XAC",
                "latitude": "41.45911680",
                "longitude": "48.80206260",
                "type": "district",
                "cities": [
                    {
                        "id": 8189,
                        "name": "Xaçmaz",
                        "latitude": "41.46426000",
                        "longitude": "48.80565000"
                    },
                    {
                        "id": 8191,
                        "name": "Xudat",
                        "latitude": "41.63052000",
                        "longitude": "48.68161000"
                    }
                ]
            },
            {
                "id": 537,
                "name": "Khizi",
                "iso2": "XIZ",
                "latitude": "40.91094890",
                "longitude": "49.07292640",
                "type": "district",
                "cities": [
                    {
                        "id": 8041,
                        "name": "Altıağac",
                        "latitude": "40.85785000",
                        "longitude": "48.93540000"
                    },
                    {
                        "id": 8101,
                        "name": "Khyzy",
                        "latitude": "40.90847000",
                        "longitude": "49.07481000"
                    },
                    {
                        "id": 8102,
                        "name": "Kilyazi",
                        "latitude": "40.87392000",
                        "longitude": "49.34376000"
                    },
                    {
                        "id": 8213,
                        "name": "Şuraabad",
                        "latitude": "40.81990000",
                        "longitude": "49.46774000"
                    }
                ]
            },
            {
                "id": 524,
                "name": "Khojali",
                "iso2": "XCI",
                "latitude": "39.91325530",
                "longitude": "46.79430500",
                "type": "district",
                "cities": [
                    {
                        "id": 8046,
                        "name": "Askyaran",
                        "latitude": "39.93910000",
                        "longitude": "46.83161000"
                    },
                    {
                        "id": 8190,
                        "name": "Xocalı",
                        "latitude": "39.91297000",
                        "longitude": "46.79028000"
                    }
                ]
            },
            {
                "id": 549,
                "name": "Kurdamir",
                "iso2": "KUR",
                "latitude": "40.36986510",
                "longitude": "48.16446260",
                "type": "district",
                "cities": [
                    {
                        "id": 8106,
                        "name": "Kyurdarmir",
                        "latitude": "40.34257000",
                        "longitude": "48.15649000"
                    }
                ]
            },
            {
                "id": 541,
                "name": "Lachin",
                "iso2": "LAC",
                "latitude": "39.63834140",
                "longitude": "46.54608530",
                "type": "district",
                "cities": [
                    {
                        "id": 8109,
                        "name": "Laçın",
                        "latitude": "39.59881000",
                        "longitude": "46.55045000"
                    }
                ]
            },
            {
                "id": 587,
                "name": "Lankaran",
                "iso2": "LAN",
                "latitude": "38.75286690",
                "longitude": "48.84750150",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 558,
                "name": "Lankaran",
                "iso2": "LA",
                "latitude": "38.92311180",
                "longitude": "48.23148190",
                "type": "district",
                "cities": [
                    {
                        "id": 8090,
                        "name": "Haftoni",
                        "latitude": "38.76325000",
                        "longitude": "48.76223000"
                    },
                    {
                        "id": 8108,
                        "name": "Lankaran",
                        "latitude": "38.75428000",
                        "longitude": "48.85062000"
                    }
                ]
            },
            {
                "id": 546,
                "name": "Lerik",
                "iso2": "LER",
                "latitude": "38.77361920",
                "longitude": "48.41514830",
                "type": "district",
                "cities": [
                    {
                        "id": 8110,
                        "name": "Lerik",
                        "latitude": "38.77388000",
                        "longitude": "48.41497000"
                    }
                ]
            },
            {
                "id": 568,
                "name": "Martuni",
                "iso2": "XVD",
                "latitude": "39.79146930",
                "longitude": "47.11008140",
                "type": "district",
                "cities": [
                    {
                        "id": 8089,
                        "name": "Hadrut",
                        "latitude": "39.52003000",
                        "longitude": "47.03190000"
                    },
                    {
                        "id": 8125,
                        "name": "Novyy Karanlug",
                        "latitude": "39.79496000",
                        "longitude": "47.11170000"
                    },
                    {
                        "id": 8155,
                        "name": "Qırmızı Bazar",
                        "latitude": "39.67669000",
                        "longitude": "46.95123000"
                    }
                ]
            },
            {
                "id": 555,
                "name": "Masally",
                "iso2": "MAS",
                "latitude": "39.03407220",
                "longitude": "48.65893540",
                "type": "district",
                "cities": [
                    {
                        "id": 8065,
                        "name": "Boradigah",
                        "latitude": "38.93013000",
                        "longitude": "48.70920000"
                    },
                    {
                        "id": 8115,
                        "name": "Masally",
                        "latitude": "39.03532000",
                        "longitude": "48.66540000"
                    }
                ]
            },
            {
                "id": 580,
                "name": "Mingachevir",
                "iso2": "MI",
                "latitude": "40.77025630",
                "longitude": "47.04960150",
                "type": "municipality",
                "cities": [
                    {
                        "id": 8118,
                        "name": "Mingelchaur",
                        "latitude": "40.76395000",
                        "longitude": "47.05953000"
                    }
                ]
            },
            {
                "id": 562,
                "name": "Nakhchivan",
                "iso2": "NX",
                "latitude": "39.32568140",
                "longitude": "45.49126480",
                "type": "autonomous republic",
                "cities": [
                    {
                        "id": 8068,
                        "name": "Cahri",
                        "latitude": "39.34837000",
                        "longitude": "45.41557000"
                    },
                    {
                        "id": 8206,
                        "name": "Çalxanqala",
                        "latitude": "39.44167000",
                        "longitude": "45.28333000"
                    },
                    {
                        "id": 8071,
                        "name": "Culfa",
                        "latitude": "38.95397000",
                        "longitude": "45.62961000"
                    },
                    {
                        "id": 8072,
                        "name": "Deste",
                        "latitude": "38.88375000",
                        "longitude": "45.90963000"
                    },
                    {
                        "id": 8091,
                        "name": "Heydarabad",
                        "latitude": "39.72286000",
                        "longitude": "44.84846000"
                    },
                    {
                        "id": 8097,
                        "name": "Julfa Rayon",
                        "latitude": "39.16667000",
                        "longitude": "45.66667000"
                    },
                    {
                        "id": 8120,
                        "name": "Nakhchivan",
                        "latitude": "39.20889000",
                        "longitude": "45.41222000"
                    },
                    {
                        "id": 8129,
                        "name": "Oğlanqala",
                        "latitude": "39.58694000",
                        "longitude": "45.04611000"
                    },
                    {
                        "id": 8126,
                        "name": "Ordubad",
                        "latitude": "38.90961000",
                        "longitude": "46.02274000"
                    },
                    {
                        "id": 8127,
                        "name": "Ordubad Rayon",
                        "latitude": "39.08333000",
                        "longitude": "45.91667000"
                    },
                    {
                        "id": 8157,
                        "name": "Qıvraq",
                        "latitude": "39.39939000",
                        "longitude": "45.11513000"
                    },
                    {
                        "id": 8211,
                        "name": "Şahbuz",
                        "latitude": "39.40722000",
                        "longitude": "45.57389000"
                    },
                    {
                        "id": 8170,
                        "name": "Sedarak",
                        "latitude": "39.71427000",
                        "longitude": "44.88455000"
                    },
                    {
                        "id": 8172,
                        "name": "Shahbuz Rayon",
                        "latitude": "39.41667000",
                        "longitude": "45.58333000"
                    },
                    {
                        "id": 8175,
                        "name": "Sharur City",
                        "latitude": "39.55298000",
                        "longitude": "44.97993000"
                    },
                    {
                        "id": 8179,
                        "name": "Sumbatan-diza",
                        "latitude": "38.94804000",
                        "longitude": "45.82572000"
                    },
                    {
                        "id": 8181,
                        "name": "Tazakend",
                        "latitude": "39.15459000",
                        "longitude": "45.44282000"
                    },
                    {
                        "id": 8195,
                        "name": "Yaycı",
                        "latitude": "38.94052000",
                        "longitude": "45.73244000"
                    }
                ]
            },
            {
                "id": 530,
                "name": "Neftchala",
                "iso2": "NEF",
                "latitude": "39.38810520",
                "longitude": "49.24137430",
                "type": "district",
                "cities": [
                    {
                        "id": 8122,
                        "name": "Neftçala",
                        "latitude": "39.37680000",
                        "longitude": "49.24700000"
                    },
                    {
                        "id": 8171,
                        "name": "Severo-Vostotchnyi Bank",
                        "latitude": "39.41117000",
                        "longitude": "49.24792000"
                    },
                    {
                        "id": 8178,
                        "name": "Sovetabad",
                        "latitude": "39.33667000",
                        "longitude": "49.21414000"
                    },
                    {
                        "id": 8192,
                        "name": "Xıllı",
                        "latitude": "39.43012000",
                        "longitude": "49.10166000"
                    }
                ]
            },
            {
                "id": 556,
                "name": "Oghuz",
                "iso2": "OGU",
                "latitude": "41.07279240",
                "longitude": "47.46506720",
                "type": "district",
                "cities": [
                    {
                        "id": 8130,
                        "name": "Oğuz",
                        "latitude": "41.07128000",
                        "longitude": "47.46528000"
                    }
                ]
            },
            {
                "id": 534,
                "name": "Ordubad",
                "iso2": "ORD",
                "latitude": "38.90216220",
                "longitude": "46.02376250",
                "type": "district",
                "cities": []
            },
            {
                "id": 542,
                "name": "Qabala",
                "iso2": "QAB",
                "latitude": "40.92539250",
                "longitude": "47.80161060",
                "type": "district",
                "cities": [
                    {
                        "id": 8154,
                        "name": "Qutqashen",
                        "latitude": "40.98247000",
                        "longitude": "47.84909000"
                    }
                ]
            },
            {
                "id": 526,
                "name": "Qakh",
                "iso2": "QAX",
                "latitude": "41.42068270",
                "longitude": "46.93201840",
                "type": "district",
                "cities": [
                    {
                        "id": 8208,
                        "name": "Çinarlı",
                        "latitude": "41.46965000",
                        "longitude": "46.91582000"
                    },
                    {
                        "id": 8144,
                        "name": "Qax",
                        "latitude": "41.41826000",
                        "longitude": "46.92043000"
                    },
                    {
                        "id": 8145,
                        "name": "Qax İngiloy",
                        "latitude": "41.42412000",
                        "longitude": "46.93859000"
                    },
                    {
                        "id": 8146,
                        "name": "Qaxbaş",
                        "latitude": "41.43254000",
                        "longitude": "46.96460000"
                    }
                ]
            },
            {
                "id": 521,
                "name": "Qazakh",
                "iso2": "QAZ",
                "latitude": "41.09710740",
                "longitude": "45.35163310",
                "type": "district",
                "cities": [
                    {
                        "id": 8147,
                        "name": "Qazax",
                        "latitude": "41.09246000",
                        "longitude": "45.36561000"
                    }
                ]
            },
            {
                "id": 563,
                "name": "Quba",
                "iso2": "QBA",
                "latitude": "41.15642420",
                "longitude": "48.41350210",
                "type": "district",
                "cities": [
                    {
                        "id": 8087,
                        "name": "Hacıhüseynli",
                        "latitude": "41.45639000",
                        "longitude": "48.64889000"
                    },
                    {
                        "id": 8151,
                        "name": "Quba",
                        "latitude": "41.36108000",
                        "longitude": "48.51341000"
                    }
                ]
            },
            {
                "id": 548,
                "name": "Qubadli",
                "iso2": "QBI",
                "latitude": "39.27139960",
                "longitude": "46.63543120",
                "type": "district",
                "cities": [
                    {
                        "id": 8152,
                        "name": "Qubadlı",
                        "latitude": "39.34441000",
                        "longitude": "46.58183000"
                    }
                ]
            },
            {
                "id": 588,
                "name": "Qusar",
                "iso2": "QUS",
                "latitude": "41.42668860",
                "longitude": "48.43455770",
                "type": "district",
                "cities": [
                    {
                        "id": 8153,
                        "name": "Qusar",
                        "latitude": "41.42750000",
                        "longitude": "48.43020000"
                    },
                    {
                        "id": 8165,
                        "name": "Samur",
                        "latitude": "41.63671000",
                        "longitude": "48.43028000"
                    }
                ]
            },
            {
                "id": 557,
                "name": "Saatly",
                "iso2": "SAT",
                "latitude": "39.90955030",
                "longitude": "48.35951220",
                "type": "district",
                "cities": [
                    {
                        "id": 8214,
                        "name": "Əhmədbəyli",
                        "latitude": "39.88074000",
                        "longitude": "48.39158000"
                    },
                    {
                        "id": 8160,
                        "name": "Saatlı",
                        "latitude": "39.93214000",
                        "longitude": "48.36892000"
                    }
                ]
            },
            {
                "id": 565,
                "name": "Sabirabad",
                "iso2": "SAB",
                "latitude": "39.98706630",
                "longitude": "48.46925450",
                "type": "district",
                "cities": [
                    {
                        "id": 8161,
                        "name": "Sabirabad",
                        "latitude": "40.00869000",
                        "longitude": "48.47701000"
                    }
                ]
            },
            {
                "id": 522,
                "name": "Sadarak",
                "iso2": "SAD",
                "latitude": "39.71051140",
                "longitude": "44.88642770",
                "type": "district",
                "cities": []
            },
            {
                "id": 545,
                "name": "Salyan",
                "iso2": "SAL",
                "latitude": "28.35248110",
                "longitude": "82.12784000",
                "type": "district",
                "cities": [
                    {
                        "id": 8141,
                        "name": "Qaraçala",
                        "latitude": "39.81614000",
                        "longitude": "48.93792000"
                    },
                    {
                        "id": 8164,
                        "name": "Salyan",
                        "latitude": "39.59621000",
                        "longitude": "48.98479000"
                    }
                ]
            },
            {
                "id": 536,
                "name": "Samukh",
                "iso2": "SMX",
                "latitude": "40.76046310",
                "longitude": "46.40631810",
                "type": "district",
                "cities": [
                    {
                        "id": 8140,
                        "name": "Qarayeri",
                        "latitude": "40.78674000",
                        "longitude": "46.31365000"
                    },
                    {
                        "id": 8156,
                        "name": "Qırmızı Samux",
                        "latitude": "40.93972000",
                        "longitude": "46.37889000"
                    },
                    {
                        "id": 8166,
                        "name": "Samux",
                        "latitude": "40.76485000",
                        "longitude": "46.40868000"
                    }
                ]
            },
            {
                "id": 591,
                "name": "Shabran",
                "iso2": "SBN",
                "latitude": "41.22283760",
                "longitude": "48.84573040",
                "type": "district",
                "cities": [
                    {
                        "id": 8074,
                        "name": "Divichibazar",
                        "latitude": "41.20117000",
                        "longitude": "48.98712000"
                    }
                ]
            },
            {
                "id": 579,
                "name": "Shahbuz",
                "iso2": "SAH",
                "latitude": "39.44521030",
                "longitude": "45.65680090",
                "type": "district",
                "cities": []
            },
            {
                "id": 518,
                "name": "Shaki",
                "iso2": "SA",
                "latitude": "41.19747530",
                "longitude": "47.15712410",
                "type": "municipality",
                "cities": [
                    {
                        "id": 8176,
                        "name": "Sheki",
                        "latitude": "41.19194000",
                        "longitude": "47.17056000"
                    }
                ]
            },
            {
                "id": 586,
                "name": "Shaki",
                "iso2": "SAK",
                "latitude": "41.11346620",
                "longitude": "47.13169270",
                "type": "district",
                "cities": [
                    {
                        "id": 8057,
                        "name": "Baş Göynük",
                        "latitude": "41.32582000",
                        "longitude": "47.11357000"
                    }
                ]
            },
            {
                "id": 529,
                "name": "Shamakhi",
                "iso2": "SMI",
                "latitude": "40.63187310",
                "longitude": "48.63638010",
                "type": "district",
                "cities": [
                    {
                        "id": 8173,
                        "name": "Shamakhi",
                        "latitude": "40.63141000",
                        "longitude": "48.64137000"
                    }
                ]
            },
            {
                "id": 583,
                "name": "Shamkir",
                "iso2": "SKR",
                "latitude": "40.82881440",
                "longitude": "46.01668790",
                "type": "district",
                "cities": [
                    {
                        "id": 8075,
                        "name": "Dolyar",
                        "latitude": "40.86278000",
                        "longitude": "46.03493000"
                    },
                    {
                        "id": 8077,
                        "name": "Dzagam",
                        "latitude": "40.90330000",
                        "longitude": "45.88564000"
                    },
                    {
                        "id": 8143,
                        "name": "Qasım İsmayılov",
                        "latitude": "40.81243000",
                        "longitude": "46.25938000"
                    },
                    {
                        "id": 8174,
                        "name": "Shamkhor",
                        "latitude": "40.82975000",
                        "longitude": "46.01780000"
                    }
                ]
            },
            {
                "id": 535,
                "name": "Sharur",
                "iso2": "SAR",
                "latitude": "39.55363320",
                "longitude": "44.98456800",
                "type": "district",
                "cities": []
            },
            {
                "id": 520,
                "name": "Shirvan",
                "iso2": "SR",
                "latitude": "39.94697070",
                "longitude": "48.92239190",
                "type": "municipality",
                "cities": [
                    {
                        "id": 8212,
                        "name": "Şirvan",
                        "latitude": "39.93778000",
                        "longitude": "48.92900000"
                    }
                ]
            },
            {
                "id": 592,
                "name": "Shusha",
                "iso2": "SUS",
                "latitude": "39.75374380",
                "longitude": "46.74647550",
                "type": "district",
                "cities": [
                    {
                        "id": 8177,
                        "name": "Shushi",
                        "latitude": "39.76006000",
                        "longitude": "46.74989000"
                    }
                ]
            },
            {
                "id": 584,
                "name": "Siazan",
                "iso2": "SIY",
                "latitude": "41.07838330",
                "longitude": "49.11184770",
                "type": "district",
                "cities": [
                    {
                        "id": 8083,
                        "name": "Gilgilçay",
                        "latitude": "41.13932000",
                        "longitude": "49.09038000"
                    },
                    {
                        "id": 8107,
                        "name": "Kyzyl-Burun",
                        "latitude": "41.07811000",
                        "longitude": "49.11564000"
                    }
                ]
            },
            {
                "id": 582,
                "name": "Sumqayit",
                "iso2": "SM",
                "latitude": "40.58547650",
                "longitude": "49.63174110",
                "type": "municipality",
                "cities": [
                    {
                        "id": 8070,
                        "name": "Corat",
                        "latitude": "40.57176000",
                        "longitude": "49.70509000"
                    },
                    {
                        "id": 8086,
                        "name": "Hacı Zeynalabdin",
                        "latitude": "40.62333000",
                        "longitude": "49.55861000"
                    },
                    {
                        "id": 8180,
                        "name": "Sumqayıt",
                        "latitude": "40.58972000",
                        "longitude": "49.66861000"
                    }
                ]
            },
            {
                "id": 519,
                "name": "Tartar",
                "iso2": "TAR",
                "latitude": "40.34438750",
                "longitude": "46.93765190",
                "type": "district",
                "cities": [
                    {
                        "id": 8114,
                        "name": "Martakert",
                        "latitude": "40.21127000",
                        "longitude": "46.82135000"
                    },
                    {
                        "id": 8182,
                        "name": "Terter",
                        "latitude": "40.34201000",
                        "longitude": "46.93161000"
                    }
                ]
            },
            {
                "id": 533,
                "name": "Tovuz",
                "iso2": "TOV",
                "latitude": "40.99545230",
                "longitude": "45.61659070",
                "type": "district",
                "cities": [
                    {
                        "id": 8207,
                        "name": "Çatax",
                        "latitude": "40.72622000",
                        "longitude": "45.55919000"
                    },
                    {
                        "id": 8209,
                        "name": "Çobansığnaq",
                        "latitude": "40.75244000",
                        "longitude": "45.70645000"
                    },
                    {
                        "id": 8076,
                        "name": "Dondar Quşçu",
                        "latitude": "40.95390000",
                        "longitude": "45.61942000"
                    },
                    {
                        "id": 8139,
                        "name": "Qaraxanlı",
                        "latitude": "41.04358000",
                        "longitude": "45.65527000"
                    },
                    {
                        "id": 8183,
                        "name": "Tovuz",
                        "latitude": "40.99249000",
                        "longitude": "45.62838000"
                    },
                    {
                        "id": 8193,
                        "name": "Yanıqlı",
                        "latitude": "40.84320000",
                        "longitude": "45.68030000"
                    }
                ]
            },
            {
                "id": 539,
                "name": "Ujar",
                "iso2": "UCA",
                "latitude": "40.50675250",
                "longitude": "47.64896410",
                "type": "district",
                "cities": [
                    {
                        "id": 8185,
                        "name": "Ujar",
                        "latitude": "40.51902000",
                        "longitude": "47.65423000"
                    }
                ]
            },
            {
                "id": 550,
                "name": "Yardymli",
                "iso2": "YAR",
                "latitude": "38.90589170",
                "longitude": "48.24961270",
                "type": "district",
                "cities": [
                    {
                        "id": 8194,
                        "name": "Yardımlı",
                        "latitude": "38.90771000",
                        "longitude": "48.24052000"
                    }
                ]
            },
            {
                "id": 538,
                "name": "Yevlakh",
                "iso2": "YE",
                "latitude": "40.61966380",
                "longitude": "47.15003240",
                "type": "municipality",
                "cities": [
                    {
                        "id": 8198,
                        "name": "Yevlakh",
                        "latitude": "40.61832000",
                        "longitude": "47.15014000"
                    }
                ]
            },
            {
                "id": 523,
                "name": "Yevlakh",
                "iso2": "YEV",
                "latitude": "40.69332340",
                "longitude": "46.67311190",
                "type": "district",
                "cities": [
                    {
                        "id": 8043,
                        "name": "Aran",
                        "latitude": "40.62528000",
                        "longitude": "46.97556000"
                    },
                    {
                        "id": 8138,
                        "name": "Qaramanlı",
                        "latitude": "40.48135000",
                        "longitude": "46.99339000"
                    }
                ]
            },
            {
                "id": 581,
                "name": "Zangilan",
                "iso2": "ZAN",
                "latitude": "39.08568990",
                "longitude": "46.65247280",
                "type": "district",
                "cities": [
                    {
                        "id": 8117,
                        "name": "Mincivan",
                        "latitude": "39.03023000",
                        "longitude": "46.72329000"
                    },
                    {
                        "id": 8202,
                        "name": "Zangilan",
                        "latitude": "39.08371000",
                        "longitude": "46.65988000"
                    }
                ]
            },
            {
                "id": 566,
                "name": "Zaqatala",
                "iso2": "ZAQ",
                "latitude": "41.59068890",
                "longitude": "46.72403730",
                "type": "district",
                "cities": [
                    {
                        "id": 8040,
                        "name": "Aliabad",
                        "latitude": "41.48290000",
                        "longitude": "46.63483000"
                    },
                    {
                        "id": 8079,
                        "name": "Faldarlı",
                        "latitude": "41.46868000",
                        "longitude": "46.51579000"
                    },
                    {
                        "id": 8112,
                        "name": "Mamrux",
                        "latitude": "41.54243000",
                        "longitude": "46.76700000"
                    },
                    {
                        "id": 8137,
                        "name": "Qandax",
                        "latitude": "41.47546000",
                        "longitude": "46.54128000"
                    },
                    {
                        "id": 8203,
                        "name": "Zaqatala",
                        "latitude": "41.63160000",
                        "longitude": "46.64479000"
                    }
                ]
            },
            {
                "id": 576,
                "name": "Zardab",
                "iso2": "ZAR",
                "latitude": "40.21481140",
                "longitude": "47.71494400",
                "type": "district",
                "cities": [
                    {
                        "id": 8204,
                        "name": "Zardob",
                        "latitude": "40.21840000",
                        "longitude": "47.71214000"
                    }
                ]
            }
        ]
    },
    {
        "id": 18,
        "name": "Bahrain",
        "iso3": "BHR",
        "iso2": "BH",
        "numeric_code": "048",
        "phonecode": "973",
        "capital": "Manama",
        "currency": "BHD",
        "currency_name": "Bahraini dinar",
        "currency_symbol": ".د.ب",
        "tld": ".bh",
        "native": "‏البحرين",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Bahraini",
        "timezones": [
            {
                "zoneName": "Asia\/Bahrain",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "br": "Bahrein",
            "ko": "바레인",
            "pt-BR": "Bahrein",
            "pt": "Barém",
            "nl": "Bahrein",
            "hr": "Bahrein",
            "fa": "بحرین",
            "de": "Bahrain",
            "es": "Bahrein",
            "fr": "Bahreïn",
            "ja": "バーレーン",
            "it": "Bahrein",
            "zh-CN": "巴林",
            "tr": "Bahreyn",
            "ru": "Бахрейн",
            "uk": "Бахрейн",
            "pl": "Bahrajn"
        },
        "latitude": "26.00000000",
        "longitude": "50.55000000",
        "emoji": "🇧🇭",
        "emojiU": "U+1F1E7 U+1F1ED",
        "states": [
            {
                "id": 1992,
                "name": "Capital",
                "iso2": "13",
                "latitude": "26.19292740",
                "longitude": "50.49256700",
                "type": "governorate",
                "cities": [
                    {
                        "id": 9757,
                        "name": "Jidd Ḩafş",
                        "latitude": "26.21861000",
                        "longitude": "50.54778000"
                    },
                    {
                        "id": 9760,
                        "name": "Manama",
                        "latitude": "26.22787000",
                        "longitude": "50.58565000"
                    },
                    {
                        "id": 9761,
                        "name": "Sitrah",
                        "latitude": "26.15472000",
                        "longitude": "50.62056000"
                    }
                ]
            },
            {
                "id": 1996,
                "name": "Central",
                "iso2": "16",
                "latitude": "26.14260930",
                "longitude": "50.56532940",
                "type": "governorate",
                "cities": [
                    {
                        "id": 9758,
                        "name": "Madīnat Ḩamad",
                        "latitude": "26.11528000",
                        "longitude": "50.50694000"
                    }
                ]
            },
            {
                "id": 1995,
                "name": "Muharraq",
                "iso2": "15",
                "latitude": "26.26856530",
                "longitude": "50.64825170",
                "type": "governorate",
                "cities": [
                    {
                        "id": 9754,
                        "name": "Al Ḩadd",
                        "latitude": "26.24556000",
                        "longitude": "50.65417000"
                    },
                    {
                        "id": 9753,
                        "name": "Al Muharraq",
                        "latitude": "26.25722000",
                        "longitude": "50.61194000"
                    }
                ]
            },
            {
                "id": 1994,
                "name": "Northern",
                "iso2": "17",
                "latitude": "26.15519140",
                "longitude": "50.48251730",
                "type": "governorate",
                "cities": []
            },
            {
                "id": 1993,
                "name": "Southern",
                "iso2": "14",
                "latitude": "25.93810180",
                "longitude": "50.57568870",
                "type": "governorate",
                "cities": [
                    {
                        "id": 9755,
                        "name": "Ar Rifā‘",
                        "latitude": "26.13000000",
                        "longitude": "50.55500000"
                    },
                    {
                        "id": 9756,
                        "name": "Dār Kulayb",
                        "latitude": "26.06861000",
                        "longitude": "50.50389000"
                    },
                    {
                        "id": 9759,
                        "name": "Madīnat ‘Īsá",
                        "latitude": "26.17361000",
                        "longitude": "50.54778000"
                    }
                ]
            }
        ]
    },
    {
        "id": 19,
        "name": "Bangladesh",
        "iso3": "BGD",
        "iso2": "BD",
        "numeric_code": "050",
        "phonecode": "880",
        "capital": "Dhaka",
        "currency": "BDT",
        "currency_name": "Bangladeshi taka",
        "currency_symbol": "৳",
        "tld": ".bd",
        "native": "Bangladesh",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Southern Asia",
        "subregion_id": 14,
        "nationality": "Bangladeshi",
        "timezones": [
            {
                "zoneName": "Asia\/Dhaka",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "BDT",
                "tzName": "Bangladesh Standard Time"
            }
        ],
        "translations": {
            "br": "Bangladesh",
            "ko": "방글라데시",
            "pt-BR": "Bangladesh",
            "pt": "Bangladeche",
            "nl": "Bangladesh",
            "hr": "Bangladeš",
            "fa": "بنگلادش",
            "de": "Bangladesch",
            "es": "Bangladesh",
            "fr": "Bangladesh",
            "ja": "バングラデシュ",
            "it": "Bangladesh",
            "zh-CN": "孟加拉",
            "tr": "Bangladeş",
            "ru": "Бангладеш",
            "uk": "Бангладеш",
            "pl": "Bangladesz"
        },
        "latitude": "24.00000000",
        "longitude": "90.00000000",
        "emoji": "🇧🇩",
        "emojiU": "U+1F1E7 U+1F1E9",
        "states": [
            {
                "id": 807,
                "name": "Barisal ",
                "iso2": "A",
                "latitude": "22.38111310",
                "longitude": "90.33718890",
                "type": "division",
                "cities": [
                    {
                        "id": 153858,
                        "name": "Barguna ",
                        "latitude": "22.17167870",
                        "longitude": "89.79740240"
                    },
                    {
                        "id": 153857,
                        "name": "Barisal ",
                        "latitude": "22.42035790",
                        "longitude": "89.78250340"
                    },
                    {
                        "id": 153859,
                        "name": "Bhola ",
                        "latitude": "22.32452480",
                        "longitude": "90.10568470"
                    },
                    {
                        "id": 153860,
                        "name": "Jhalokati ",
                        "latitude": "22.56303520",
                        "longitude": "89.87191590"
                    },
                    {
                        "id": 153861,
                        "name": "Patuakhali ",
                        "latitude": "22.18709170",
                        "longitude": "89.71647060"
                    },
                    {
                        "id": 153862,
                        "name": "Pirojpur ",
                        "latitude": "22.50937910",
                        "longitude": "89.36434220"
                    }
                ]
            },
            {
                "id": 803,
                "name": "Chittagong ",
                "iso2": "B",
                "latitude": "23.17931570",
                "longitude": "91.98815270",
                "type": "division",
                "cities": [
                    {
                        "id": 8457,
                        "name": "Bandarban",
                        "latitude": "22.00000000",
                        "longitude": "92.33333000"
                    },
                    {
                        "id": 8470,
                        "name": "Brahmanbaria",
                        "latitude": "23.98333000",
                        "longitude": "91.16667000"
                    },
                    {
                        "id": 8474,
                        "name": "Chandpur",
                        "latitude": "23.25000000",
                        "longitude": "90.83333000"
                    },
                    {
                        "id": 8481,
                        "name": "Chittagong",
                        "latitude": "22.48750000",
                        "longitude": "91.96333000"
                    },
                    {
                        "id": 8483,
                        "name": "Comilla",
                        "latitude": "23.44170000",
                        "longitude": "91.00987000"
                    },
                    {
                        "id": 8484,
                        "name": "Cox's Bazar",
                        "latitude": "21.58389000",
                        "longitude": "92.01528000"
                    },
                    {
                        "id": 8492,
                        "name": "Feni",
                        "latitude": "22.96667000",
                        "longitude": "91.31667000"
                    },
                    {
                        "id": 8512,
                        "name": "Khagrachhari",
                        "latitude": "23.16667000",
                        "longitude": "91.90000000"
                    },
                    {
                        "id": 8521,
                        "name": "Lakshmipur",
                        "latitude": "22.91667000",
                        "longitude": "90.83333000"
                    },
                    {
                        "id": 8553,
                        "name": "Noakhali",
                        "latitude": "22.75000000",
                        "longitude": "91.16667000"
                    },
                    {
                        "id": 8576,
                        "name": "Rangamati",
                        "latitude": "22.63333000",
                        "longitude": "92.20000000"
                    }
                ]
            },
            {
                "id": 760,
                "name": "Dhaka ",
                "iso2": "C",
                "latitude": "23.95357420",
                "longitude": "90.14949880",
                "type": "division",
                "cities": [
                    {
                        "id": 153863,
                        "name": "Dhaka ",
                        "latitude": "23.78417980",
                        "longitude": "89.92859830"
                    },
                    {
                        "id": 153871,
                        "name": "Faridpur ",
                        "latitude": "23.45115240",
                        "longitude": "89.52820380"
                    },
                    {
                        "id": 153864,
                        "name": "Gazipur ",
                        "latitude": "24.10914520",
                        "longitude": "90.09596140"
                    },
                    {
                        "id": 153872,
                        "name": "Gopalganj ",
                        "latitude": "23.10660120",
                        "longitude": "89.57802710"
                    },
                    {
                        "id": 153865,
                        "name": "Kishoreganj ",
                        "latitude": "24.33888030",
                        "longitude": "90.58499800"
                    },
                    {
                        "id": 153873,
                        "name": "Madaripur ",
                        "latitude": "23.23455490",
                        "longitude": "89.81089030"
                    },
                    {
                        "id": 153866,
                        "name": "Manikganj ",
                        "latitude": "23.83174080",
                        "longitude": "89.64097890"
                    },
                    {
                        "id": 153867,
                        "name": "Munshiganj ",
                        "latitude": "23.52615230",
                        "longitude": "90.11590910"
                    },
                    {
                        "id": 153868,
                        "name": "Narayanganj ",
                        "latitude": "23.74880130",
                        "longitude": "90.25638500"
                    },
                    {
                        "id": 153869,
                        "name": "Narsingdi ",
                        "latitude": "24.00966000",
                        "longitude": "90.44480420"
                    },
                    {
                        "id": 153874,
                        "name": "Rajbari ",
                        "latitude": "23.73843000",
                        "longitude": "89.25547000"
                    },
                    {
                        "id": 153875,
                        "name": "Shariatpur ",
                        "latitude": "23.23124340",
                        "longitude": "90.08293470"
                    },
                    {
                        "id": 153870,
                        "name": "Tangail ",
                        "latitude": "24.37630700",
                        "longitude": "89.35804610"
                    }
                ]
            },
            {
                "id": 775,
                "name": "Khulna ",
                "iso2": "D",
                "latitude": "22.80878160",
                "longitude": "89.24671910",
                "type": "division",
                "cities": [
                    {
                        "id": 153876,
                        "name": "Bagerhat ",
                        "latitude": "22.34880590",
                        "longitude": "89.07470250"
                    },
                    {
                        "id": 153877,
                        "name": "Chuadanga ",
                        "latitude": "23.60352730",
                        "longitude": "88.48732400"
                    },
                    {
                        "id": 153878,
                        "name": "Jessore ",
                        "latitude": "23.08473560",
                        "longitude": "88.87480080"
                    },
                    {
                        "id": 153879,
                        "name": "Jhenaidah ",
                        "latitude": "23.49521270",
                        "longitude": "88.70694930"
                    },
                    {
                        "id": 153880,
                        "name": "Khulna ",
                        "latitude": "22.35351390",
                        "longitude": "88.83407090"
                    },
                    {
                        "id": 153881,
                        "name": "Kushtia ",
                        "latitude": "23.94595240",
                        "longitude": "88.70179290"
                    },
                    {
                        "id": 153882,
                        "name": "Magura ",
                        "latitude": "23.46557740",
                        "longitude": "89.11547300"
                    },
                    {
                        "id": 153883,
                        "name": "Meherpur ",
                        "latitude": "23.78972180",
                        "longitude": "88.39319490"
                    },
                    {
                        "id": 153884,
                        "name": "Narail ",
                        "latitude": "23.13175700",
                        "longitude": "89.26258440"
                    },
                    {
                        "id": 153885,
                        "name": "Satkhira ",
                        "latitude": "22.29898590",
                        "longitude": "88.47540870"
                    }
                ]
            },
            {
                "id": 758,
                "name": "Mymensingh ",
                "iso2": "H",
                "latitude": "24.71362000",
                "longitude": "90.45023680",
                "type": "division",
                "cities": [
                    {
                        "id": 153887,
                        "name": "Jamalpur ",
                        "latitude": "25.00108250",
                        "longitude": "89.26050130"
                    },
                    {
                        "id": 153886,
                        "name": "Mymensingh ",
                        "latitude": "24.72309850",
                        "longitude": "89.78411730"
                    },
                    {
                        "id": 153888,
                        "name": "Netrokona ",
                        "latitude": "24.87204810",
                        "longitude": "90.52293810"
                    },
                    {
                        "id": 153889,
                        "name": "Sherpur ",
                        "latitude": "25.09260380",
                        "longitude": "89.76352070"
                    }
                ]
            },
            {
                "id": 753,
                "name": "Rajshahi ",
                "iso2": "E",
                "latitude": "24.71057760",
                "longitude": "88.94138650",
                "type": "division",
                "cities": [
                    {
                        "id": 153894,
                        "name": "Bogra ",
                        "latitude": "24.82966450",
                        "longitude": "89.02598570"
                    },
                    {
                        "id": 153895,
                        "name": "Chapai Nawabganj",
                        "latitude": "24.69520750",
                        "longitude": "87.93021310"
                    },
                    {
                        "id": 153897,
                        "name": "Joypurhat ",
                        "latitude": "25.06567070",
                        "longitude": "88.76832650"
                    },
                    {
                        "id": 153896,
                        "name": "Naogaon ",
                        "latitude": "24.87425080",
                        "longitude": "88.43751910"
                    },
                    {
                        "id": 153890,
                        "name": "Natore ",
                        "latitude": "24.38021070",
                        "longitude": "88.76302520"
                    },
                    {
                        "id": 153893,
                        "name": "Pabna ",
                        "latitude": "24.08126720",
                        "longitude": "89.03724420"
                    },
                    {
                        "id": 153891,
                        "name": "Rajshahi ",
                        "latitude": "24.42073360",
                        "longitude": "88.29602140"
                    },
                    {
                        "id": 153892,
                        "name": "Sirajganj ",
                        "latitude": "24.39876240",
                        "longitude": "88.87641810"
                    }
                ]
            },
            {
                "id": 750,
                "name": "Rangpur ",
                "iso2": "F",
                "latitude": "25.84833880",
                "longitude": "88.94138650",
                "type": "division",
                "cities": [
                    {
                        "id": 153898,
                        "name": "Dinajpur ",
                        "latitude": "25.64261030",
                        "longitude": "88.18344620"
                    },
                    {
                        "id": 153900,
                        "name": "Gaibandha ",
                        "latitude": "25.34315570",
                        "longitude": "89.13978570"
                    },
                    {
                        "id": 153899,
                        "name": "Kurigram ",
                        "latitude": "25.80827220",
                        "longitude": "89.00915030"
                    },
                    {
                        "id": 153901,
                        "name": "Lalmonirhat ",
                        "latitude": "26.12442390",
                        "longitude": "88.91060900"
                    },
                    {
                        "id": 153902,
                        "name": "Nilphamari ",
                        "latitude": "26.02264250",
                        "longitude": "88.63412710"
                    },
                    {
                        "id": 153903,
                        "name": "Panchagarh ",
                        "latitude": "26.32032700",
                        "longitude": "26.32032700"
                    },
                    {
                        "id": 153904,
                        "name": "Rangpur ",
                        "latitude": "25.62390240",
                        "longitude": "88.90094980"
                    },
                    {
                        "id": 153905,
                        "name": "Thakurgaon ",
                        "latitude": "25.93648420",
                        "longitude": "88.03366640"
                    }
                ]
            },
            {
                "id": 765,
                "name": "Sylhet ",
                "iso2": "G",
                "latitude": "24.70498110",
                "longitude": "91.67606910",
                "type": "division",
                "cities": [
                    {
                        "id": 153906,
                        "name": "Habiganj ",
                        "latitude": "24.33481970",
                        "longitude": "90.74899010"
                    },
                    {
                        "id": 153907,
                        "name": "Moulvibazar ",
                        "latitude": "24.48617710",
                        "longitude": "91.28742410"
                    },
                    {
                        "id": 153908,
                        "name": "Sunamganj ",
                        "latitude": "24.88905540",
                        "longitude": "91.00248270"
                    },
                    {
                        "id": 153909,
                        "name": "Sylhet ",
                        "latitude": "24.89189110",
                        "longitude": "91.73554950"
                    }
                ]
            }
        ]
    },
    {
        "id": 20,
        "name": "Barbados",
        "iso3": "BRB",
        "iso2": "BB",
        "numeric_code": "052",
        "phonecode": "1",
        "capital": "Bridgetown",
        "currency": "BBD",
        "currency_name": "Barbadian dollar",
        "currency_symbol": "Bds$",
        "tld": ".bb",
        "native": "Barbados",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Barbadian",
        "timezones": [
            {
                "zoneName": "America\/Barbados",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Barbados",
            "ko": "바베이도스",
            "pt-BR": "Barbados",
            "pt": "Barbados",
            "nl": "Barbados",
            "hr": "Barbados",
            "fa": "باربادوس",
            "de": "Barbados",
            "es": "Barbados",
            "fr": "Barbade",
            "ja": "バルバドス",
            "it": "Barbados",
            "zh-CN": "巴巴多斯",
            "tr": "Barbados",
            "ru": "Барбадос",
            "uk": "Барбадос",
            "pl": "Barbados"
        },
        "latitude": "13.16666666",
        "longitude": "-59.53333333",
        "emoji": "🇧🇧",
        "emojiU": "U+1F1E7 U+1F1E7",
        "states": [
            {
                "id": 1228,
                "name": "Christ Church",
                "iso2": "01",
                "latitude": "13.08528990",
                "longitude": "-59.62390140",
                "type": "parish",
                "cities": [
                    {
                        "id": 8452,
                        "name": "Oistins",
                        "latitude": "13.07067000",
                        "longitude": "-59.54637000"
                    }
                ]
            },
            {
                "id": 1229,
                "name": "Saint Andrew",
                "iso2": "02",
                "latitude": "13.24946070",
                "longitude": "-59.61269570",
                "type": "parish",
                "cities": [
                    {
                        "id": 8450,
                        "name": "Greenland",
                        "latitude": "13.25808000",
                        "longitude": "-59.57763000"
                    }
                ]
            },
            {
                "id": 1226,
                "name": "Saint George",
                "iso2": "03",
                "latitude": "13.14038630",
                "longitude": "-59.58546770",
                "type": "parish",
                "cities": []
            },
            {
                "id": 1224,
                "name": "Saint James",
                "iso2": "04",
                "latitude": "13.18793480",
                "longitude": "-59.66224020",
                "type": "parish",
                "cities": [
                    {
                        "id": 8451,
                        "name": "Holetown",
                        "latitude": "13.18672000",
                        "longitude": "-59.63808000"
                    }
                ]
            },
            {
                "id": 1227,
                "name": "Saint John",
                "iso2": "05",
                "latitude": "13.17411180",
                "longitude": "-59.54045070",
                "type": "parish",
                "cities": []
            },
            {
                "id": 1223,
                "name": "Saint Joseph",
                "iso2": "06",
                "latitude": "13.20219120",
                "longitude": "-59.58385770",
                "type": "parish",
                "cities": [
                    {
                        "id": 8447,
                        "name": "Bathsheba",
                        "latitude": "13.21133000",
                        "longitude": "-59.52596000"
                    }
                ]
            },
            {
                "id": 1221,
                "name": "Saint Lucy",
                "iso2": "07",
                "latitude": "13.30458280",
                "longitude": "-59.65366180",
                "type": "parish",
                "cities": []
            },
            {
                "id": 1230,
                "name": "Saint Michael",
                "iso2": "08",
                "latitude": "13.11847670",
                "longitude": "-59.64349020",
                "type": "parish",
                "cities": [
                    {
                        "id": 8448,
                        "name": "Bridgetown",
                        "latitude": "13.10732000",
                        "longitude": "-59.62021000"
                    }
                ]
            },
            {
                "id": 1222,
                "name": "Saint Peter",
                "iso2": "09",
                "latitude": "13.26227090",
                "longitude": "-59.65113430",
                "type": "parish",
                "cities": [
                    {
                        "id": 8453,
                        "name": "Speightstown",
                        "latitude": "13.25072000",
                        "longitude": "-59.64396000"
                    }
                ]
            },
            {
                "id": 1220,
                "name": "Saint Philip",
                "iso2": "10",
                "latitude": "13.13095230",
                "longitude": "-59.50714670",
                "type": "parish",
                "cities": [
                    {
                        "id": 8449,
                        "name": "Crane",
                        "latitude": "13.10487000",
                        "longitude": "-59.44861000"
                    }
                ]
            },
            {
                "id": 1225,
                "name": "Saint Thomas",
                "iso2": "11",
                "latitude": "18.33809650",
                "longitude": "-64.89409460",
                "type": "parish",
                "cities": []
            }
        ]
    },
    {
        "id": 21,
        "name": "Belarus",
        "iso3": "BLR",
        "iso2": "BY",
        "numeric_code": "112",
        "phonecode": "375",
        "capital": "Minsk",
        "currency": "BYN",
        "currency_name": "Belarusian ruble",
        "currency_symbol": "Br",
        "tld": ".by",
        "native": "Белару́сь",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Belarusian",
        "timezones": [
            {
                "zoneName": "Europe\/Minsk",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "MSK",
                "tzName": "Moscow Time"
            }
        ],
        "translations": {
            "br": "Belarus",
            "ko": "벨라루스",
            "pt-BR": "Bielorrússia",
            "pt": "Bielorrússia",
            "nl": "Wit-Rusland",
            "hr": "Bjelorusija",
            "fa": "بلاروس",
            "de": "Weißrussland",
            "es": "Bielorrusia",
            "fr": "Biélorussie",
            "ja": "ベラルーシ",
            "it": "Bielorussia",
            "zh-CN": "白俄罗斯",
            "tr": "Belarus",
            "ru": "Беларусь",
            "uk": "Білорусь",
            "pl": "Białoruś"
        },
        "latitude": "53.00000000",
        "longitude": "28.00000000",
        "emoji": "🇧🇾",
        "emojiU": "U+1F1E7 U+1F1FE",
        "states": [
            {
                "id": 2959,
                "name": "Brest",
                "iso2": "BR",
                "latitude": "52.52966410",
                "longitude": "25.46064800",
                "type": "oblast",
                "cities": [
                    {
                        "id": 15805,
                        "name": "Antopal’",
                        "latitude": "52.20380000",
                        "longitude": "24.78630000"
                    },
                    {
                        "id": 15810,
                        "name": "Asnyezhytsy",
                        "latitude": "52.18910000",
                        "longitude": "26.12990000"
                    },
                    {
                        "id": 15820,
                        "name": "Baranovichi",
                        "latitude": "53.13270000",
                        "longitude": "26.01390000"
                    },
                    {
                        "id": 15821,
                        "name": "Baranovichskiy Rayon",
                        "latitude": "53.16667000",
                        "longitude": "25.83333000"
                    },
                    {
                        "id": 15833,
                        "name": "Brest",
                        "latitude": "52.09755000",
                        "longitude": "23.68775000"
                    },
                    {
                        "id": 15834,
                        "name": "Brestski Rayon",
                        "latitude": "52.00000000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 15841,
                        "name": "Byaroza",
                        "latitude": "52.53140000",
                        "longitude": "24.97860000"
                    },
                    {
                        "id": 15843,
                        "name": "Byarozawski Rayon",
                        "latitude": "52.50000000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 15844,
                        "name": "Byelaazyorsk",
                        "latitude": "52.47310000",
                        "longitude": "25.17840000"
                    },
                    {
                        "id": 15850,
                        "name": "Charnawchytsy",
                        "latitude": "52.21948000",
                        "longitude": "23.74043000"
                    },
                    {
                        "id": 15861,
                        "name": "Damachava",
                        "latitude": "51.75000000",
                        "longitude": "23.60000000"
                    },
                    {
                        "id": 15863,
                        "name": "Davyd-Haradok",
                        "latitude": "52.05660000",
                        "longitude": "27.21610000"
                    },
                    {
                        "id": 15868,
                        "name": "Drahichyn",
                        "latitude": "52.18740000",
                        "longitude": "25.15970000"
                    },
                    {
                        "id": 15869,
                        "name": "Drahichynski Rayon",
                        "latitude": "52.16667000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 15884,
                        "name": "Hantsavichy",
                        "latitude": "52.75800000",
                        "longitude": "26.43000000"
                    },
                    {
                        "id": 15885,
                        "name": "Hantsavitski Rayon",
                        "latitude": "52.66667000",
                        "longitude": "26.50000000"
                    },
                    {
                        "id": 15888,
                        "name": "Haradzishcha",
                        "latitude": "53.32470000",
                        "longitude": "26.01070000"
                    },
                    {
                        "id": 15897,
                        "name": "Horad Baranavichy",
                        "latitude": "53.13333000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 15898,
                        "name": "Horad Brest",
                        "latitude": "52.10000000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 15909,
                        "name": "Ivanava",
                        "latitude": "52.14510000",
                        "longitude": "25.53650000"
                    },
                    {
                        "id": 15910,
                        "name": "Ivanawski Rayon",
                        "latitude": "52.16667000",
                        "longitude": "25.58333000"
                    },
                    {
                        "id": 15911,
                        "name": "Ivatsevichy",
                        "latitude": "52.70900000",
                        "longitude": "25.34010000"
                    },
                    {
                        "id": 15917,
                        "name": "Kamyanyets",
                        "latitude": "52.40013000",
                        "longitude": "23.81000000"
                    },
                    {
                        "id": 15918,
                        "name": "Kamyanyetski Rayon",
                        "latitude": "52.41667000",
                        "longitude": "23.66667000"
                    },
                    {
                        "id": 15919,
                        "name": "Kamyanyuki",
                        "latitude": "52.55757000",
                        "longitude": "23.80525000"
                    },
                    {
                        "id": 15942,
                        "name": "Kobryn",
                        "latitude": "52.21380000",
                        "longitude": "24.35640000"
                    },
                    {
                        "id": 15946,
                        "name": "Kosava",
                        "latitude": "52.75830000",
                        "longitude": "25.15540000"
                    },
                    {
                        "id": 15957,
                        "name": "Lahishyn",
                        "latitude": "52.33900000",
                        "longitude": "25.98670000"
                    },
                    {
                        "id": 15964,
                        "name": "Luninyets",
                        "latitude": "52.24720000",
                        "longitude": "26.80470000"
                    },
                    {
                        "id": 15965,
                        "name": "Lyakhavichy",
                        "latitude": "53.03880000",
                        "longitude": "26.26560000"
                    },
                    {
                        "id": 15982,
                        "name": "Malaryta",
                        "latitude": "51.79050000",
                        "longitude": "24.07400000"
                    },
                    {
                        "id": 15988,
                        "name": "Mikashevichy",
                        "latitude": "52.21730000",
                        "longitude": "27.47600000"
                    },
                    {
                        "id": 15993,
                        "name": "Motal’",
                        "latitude": "52.31380000",
                        "longitude": "25.60720000"
                    },
                    {
                        "id": 16010,
                        "name": "Nyakhachava",
                        "latitude": "52.64400000",
                        "longitude": "25.20270000"
                    },
                    {
                        "id": 16021,
                        "name": "Pinsk",
                        "latitude": "52.12290000",
                        "longitude": "26.09510000"
                    },
                    {
                        "id": 16027,
                        "name": "Pruzhanski Rayon",
                        "latitude": "52.66667000",
                        "longitude": "24.58333000"
                    },
                    {
                        "id": 16028,
                        "name": "Pruzhany",
                        "latitude": "52.55600000",
                        "longitude": "24.45730000"
                    },
                    {
                        "id": 16044,
                        "name": "Ruzhany",
                        "latitude": "52.86322000",
                        "longitude": "24.89357000"
                    },
                    {
                        "id": 16075,
                        "name": "Stolin",
                        "latitude": "51.89115000",
                        "longitude": "26.84597000"
                    },
                    {
                        "id": 16076,
                        "name": "Stolinski Rayon",
                        "latitude": "52.00000000",
                        "longitude": "27.00000000"
                    },
                    {
                        "id": 16089,
                        "name": "Tsyelyakhany",
                        "latitude": "52.51750000",
                        "longitude": "25.84290000"
                    },
                    {
                        "id": 16114,
                        "name": "Vysokaye",
                        "latitude": "52.37091000",
                        "longitude": "23.37083000"
                    },
                    {
                        "id": 16122,
                        "name": "Zhabinka",
                        "latitude": "52.19840000",
                        "longitude": "24.01150000"
                    },
                    {
                        "id": 16123,
                        "name": "Zhabinkawski Rayon",
                        "latitude": "52.16667000",
                        "longitude": "24.08333000"
                    },
                    {
                        "id": 16130,
                        "name": "Znamenka",
                        "latitude": "51.88168000",
                        "longitude": "23.65545000"
                    }
                ]
            },
            {
                "id": 2955,
                "name": "Gomel",
                "iso2": "HO",
                "latitude": "52.16487540",
                "longitude": "29.13332510",
                "type": "oblast",
                "cities": [
                    {
                        "id": 15804,
                        "name": "Aktsyabrski",
                        "latitude": "52.64400000",
                        "longitude": "28.88010000"
                    },
                    {
                        "id": 15829,
                        "name": "Brahin",
                        "latitude": "51.78700000",
                        "longitude": "30.26770000"
                    },
                    {
                        "id": 15830,
                        "name": "Brahinski Rayon",
                        "latitude": "51.66667000",
                        "longitude": "30.33333000"
                    },
                    {
                        "id": 15835,
                        "name": "Buda-Kashalyova",
                        "latitude": "52.71790000",
                        "longitude": "30.57010000"
                    },
                    {
                        "id": 15848,
                        "name": "Chachersk",
                        "latitude": "52.91640000",
                        "longitude": "30.91790000"
                    },
                    {
                        "id": 15849,
                        "name": "Chacherski Rayon",
                        "latitude": "52.91667000",
                        "longitude": "31.08333000"
                    },
                    {
                        "id": 15864,
                        "name": "Dobrush",
                        "latitude": "52.40890000",
                        "longitude": "31.32370000"
                    },
                    {
                        "id": 15867,
                        "name": "Dowsk",
                        "latitude": "53.15710000",
                        "longitude": "30.46010000"
                    },
                    {
                        "id": 15895,
                        "name": "Homyel'",
                        "latitude": "52.43450000",
                        "longitude": "30.97540000"
                    },
                    {
                        "id": 15896,
                        "name": "Homyel’ski Rayon",
                        "latitude": "52.33333000",
                        "longitude": "31.00000000"
                    },
                    {
                        "id": 15915,
                        "name": "Kalinkavichy",
                        "latitude": "52.13230000",
                        "longitude": "29.32570000"
                    },
                    {
                        "id": 15923,
                        "name": "Karanyowka",
                        "latitude": "52.35060000",
                        "longitude": "31.11210000"
                    },
                    {
                        "id": 15926,
                        "name": "Karma",
                        "latitude": "53.13010000",
                        "longitude": "30.80160000"
                    },
                    {
                        "id": 15929,
                        "name": "Kastsyukowka",
                        "latitude": "52.53870000",
                        "longitude": "30.91730000"
                    },
                    {
                        "id": 15930,
                        "name": "Khal’ch",
                        "latitude": "52.56430000",
                        "longitude": "31.13640000"
                    },
                    {
                        "id": 15936,
                        "name": "Khoyniki",
                        "latitude": "51.89110000",
                        "longitude": "29.95520000"
                    },
                    {
                        "id": 15962,
                        "name": "Loyew",
                        "latitude": "51.94580000",
                        "longitude": "30.79530000"
                    },
                    {
                        "id": 15967,
                        "name": "Lyel’chytski Rayon",
                        "latitude": "51.83333000",
                        "longitude": "28.25000000"
                    },
                    {
                        "id": 15968,
                        "name": "Lyel’chytsy",
                        "latitude": "51.78620000",
                        "longitude": "28.32880000"
                    },
                    {
                        "id": 15985,
                        "name": "Mazyr",
                        "latitude": "52.04950000",
                        "longitude": "29.24560000"
                    },
                    {
                        "id": 15986,
                        "name": "Mazyrski Rayon",
                        "latitude": "52.00000000",
                        "longitude": "29.00000000"
                    },
                    {
                        "id": 16002,
                        "name": "Narowlya",
                        "latitude": "51.79610000",
                        "longitude": "29.50040000"
                    },
                    {
                        "id": 16005,
                        "name": "Novaya Huta",
                        "latitude": "52.10320000",
                        "longitude": "30.98370000"
                    },
                    {
                        "id": 16017,
                        "name": "Parychy",
                        "latitude": "52.80420000",
                        "longitude": "29.41760000"
                    },
                    {
                        "id": 16020,
                        "name": "Peramoga",
                        "latitude": "52.39730000",
                        "longitude": "31.07100000"
                    },
                    {
                        "id": 16033,
                        "name": "Pyetrykaw",
                        "latitude": "52.12890000",
                        "longitude": "28.49210000"
                    },
                    {
                        "id": 16035,
                        "name": "Rahachow",
                        "latitude": "53.09340000",
                        "longitude": "30.04950000"
                    },
                    {
                        "id": 16036,
                        "name": "Rahachowski Rayon",
                        "latitude": "53.16667000",
                        "longitude": "30.16667000"
                    },
                    {
                        "id": 16041,
                        "name": "Rechytsa",
                        "latitude": "52.36170000",
                        "longitude": "30.39160000"
                    },
                    {
                        "id": 16049,
                        "name": "Sasnovy Bor",
                        "latitude": "52.51940000",
                        "longitude": "29.59880000"
                    },
                    {
                        "id": 16081,
                        "name": "Svyetlahorsk",
                        "latitude": "52.63290000",
                        "longitude": "29.73890000"
                    },
                    {
                        "id": 16090,
                        "name": "Turaw",
                        "latitude": "52.06830000",
                        "longitude": "27.73500000"
                    },
                    {
                        "id": 16098,
                        "name": "Vasilyevichy",
                        "latitude": "52.25120000",
                        "longitude": "29.82880000"
                    },
                    {
                        "id": 16112,
                        "name": "Vyetka",
                        "latitude": "52.55910000",
                        "longitude": "31.17940000"
                    },
                    {
                        "id": 16113,
                        "name": "Vyetkawski Rayon",
                        "latitude": "52.66667000",
                        "longitude": "31.25000000"
                    },
                    {
                        "id": 16116,
                        "name": "Yel’sk",
                        "latitude": "51.81410000",
                        "longitude": "29.15220000"
                    },
                    {
                        "id": 16127,
                        "name": "Zhlobin",
                        "latitude": "52.89260000",
                        "longitude": "30.02400000"
                    },
                    {
                        "id": 16128,
                        "name": "Zhlobinski Rayon",
                        "latitude": "52.75000000",
                        "longitude": "29.83333000"
                    },
                    {
                        "id": 16129,
                        "name": "Zhytkavichy",
                        "latitude": "52.21680000",
                        "longitude": "27.85610000"
                    }
                ]
            },
            {
                "id": 2956,
                "name": "Grodno",
                "iso2": "HR",
                "latitude": "53.65999450",
                "longitude": "25.34485710",
                "type": "oblast",
                "cities": [
                    {
                        "id": 15806,
                        "name": "Ashmyanski Rayon",
                        "latitude": "54.41667000",
                        "longitude": "25.91667000"
                    },
                    {
                        "id": 15807,
                        "name": "Ashmyany",
                        "latitude": "54.42100000",
                        "longitude": "25.93600000"
                    },
                    {
                        "id": 15812,
                        "name": "Astravyets",
                        "latitude": "54.61378000",
                        "longitude": "25.95537000"
                    },
                    {
                        "id": 15813,
                        "name": "Astravyetski Rayon",
                        "latitude": "54.66667000",
                        "longitude": "26.00000000"
                    },
                    {
                        "id": 15823,
                        "name": "Baruny",
                        "latitude": "54.31710000",
                        "longitude": "26.13760000"
                    },
                    {
                        "id": 15842,
                        "name": "Byarozawka",
                        "latitude": "53.72406000",
                        "longitude": "25.49709000"
                    },
                    {
                        "id": 15876,
                        "name": "Dyatlovo",
                        "latitude": "53.46310000",
                        "longitude": "25.40680000"
                    },
                    {
                        "id": 15882,
                        "name": "Grodnenskiy Rayon",
                        "latitude": "53.66667000",
                        "longitude": "24.00000000"
                    },
                    {
                        "id": 15883,
                        "name": "Hal’shany",
                        "latitude": "54.25850000",
                        "longitude": "26.01440000"
                    },
                    {
                        "id": 15899,
                        "name": "Horad Hrodna",
                        "latitude": "53.68333000",
                        "longitude": "23.83333000"
                    },
                    {
                        "id": 15905,
                        "name": "Hrodna",
                        "latitude": "53.68840000",
                        "longitude": "23.82580000"
                    },
                    {
                        "id": 15906,
                        "name": "Hyeranyony",
                        "latitude": "54.11590000",
                        "longitude": "25.57730000"
                    },
                    {
                        "id": 15908,
                        "name": "Indura",
                        "latitude": "53.46050000",
                        "longitude": "23.88230000"
                    },
                    {
                        "id": 15913,
                        "name": "Iwye",
                        "latitude": "53.92990000",
                        "longitude": "25.77270000"
                    },
                    {
                        "id": 15924,
                        "name": "Karelichy",
                        "latitude": "53.56480000",
                        "longitude": "26.14060000"
                    },
                    {
                        "id": 15925,
                        "name": "Karelitski Rayon",
                        "latitude": "53.50000000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 15950,
                        "name": "Krasnosel’skiy",
                        "latitude": "53.26450000",
                        "longitude": "24.43010000"
                    },
                    {
                        "id": 15952,
                        "name": "Kreva",
                        "latitude": "54.31180000",
                        "longitude": "26.29160000"
                    },
                    {
                        "id": 15959,
                        "name": "Lida",
                        "latitude": "53.88333000",
                        "longitude": "25.29972000"
                    },
                    {
                        "id": 15960,
                        "name": "Lidski Rayon",
                        "latitude": "53.66667000",
                        "longitude": "25.25000000"
                    },
                    {
                        "id": 15977,
                        "name": "Lyubcha",
                        "latitude": "53.75220000",
                        "longitude": "26.06030000"
                    },
                    {
                        "id": 15990,
                        "name": "Mir",
                        "latitude": "53.45440000",
                        "longitude": "26.46700000"
                    },
                    {
                        "id": 15992,
                        "name": "Mosty",
                        "latitude": "53.41220000",
                        "longitude": "24.53870000"
                    },
                    {
                        "id": 16006,
                        "name": "Novogrudok",
                        "latitude": "53.59420000",
                        "longitude": "25.81910000"
                    },
                    {
                        "id": 16042,
                        "name": "Ross’",
                        "latitude": "53.28451000",
                        "longitude": "24.40335000"
                    },
                    {
                        "id": 16047,
                        "name": "Sapotskin",
                        "latitude": "53.83290000",
                        "longitude": "23.65980000"
                    },
                    {
                        "id": 16054,
                        "name": "Shchuchyn",
                        "latitude": "53.60140000",
                        "longitude": "24.74650000"
                    },
                    {
                        "id": 16055,
                        "name": "Shchuchynski Rayon",
                        "latitude": "53.58333000",
                        "longitude": "24.66667000"
                    },
                    {
                        "id": 16059,
                        "name": "Skidel’",
                        "latitude": "53.59040000",
                        "longitude": "24.24780000"
                    },
                    {
                        "id": 16062,
                        "name": "Slonim",
                        "latitude": "53.08690000",
                        "longitude": "25.31630000"
                    },
                    {
                        "id": 16066,
                        "name": "Smarhon’",
                        "latitude": "54.47980000",
                        "longitude": "26.39570000"
                    },
                    {
                        "id": 16069,
                        "name": "Soly",
                        "latitude": "54.51301000",
                        "longitude": "26.19381000"
                    },
                    {
                        "id": 16079,
                        "name": "Svislach",
                        "latitude": "53.03474000",
                        "longitude": "24.09829000"
                    },
                    {
                        "id": 16103,
                        "name": "Vishnyeva",
                        "latitude": "54.71020000",
                        "longitude": "26.52280000"
                    },
                    {
                        "id": 16106,
                        "name": "Volkovysk",
                        "latitude": "53.15610000",
                        "longitude": "24.45130000"
                    },
                    {
                        "id": 16107,
                        "name": "Voranava",
                        "latitude": "54.14920000",
                        "longitude": "25.31120000"
                    },
                    {
                        "id": 16108,
                        "name": "Vyalikaya Byerastavitsa",
                        "latitude": "53.19600000",
                        "longitude": "24.01660000"
                    },
                    {
                        "id": 16121,
                        "name": "Zel’va",
                        "latitude": "53.15040000",
                        "longitude": "24.81530000"
                    },
                    {
                        "id": 16124,
                        "name": "Zhaludok",
                        "latitude": "53.59740000",
                        "longitude": "24.98280000"
                    },
                    {
                        "id": 16126,
                        "name": "Zhirovichi",
                        "latitude": "53.01310000",
                        "longitude": "25.34430000"
                    }
                ]
            },
            {
                "id": 2957,
                "name": "Minsk",
                "iso2": "MI",
                "latitude": "54.10678890",
                "longitude": "27.41292450",
                "type": "oblast",
                "cities": [
                    {
                        "id": 15811,
                        "name": "Astrashytski Haradok",
                        "latitude": "54.06510000",
                        "longitude": "27.69500000"
                    },
                    {
                        "id": 15814,
                        "name": "Atolina",
                        "latitude": "53.78170000",
                        "longitude": "27.43460000"
                    },
                    {
                        "id": 15815,
                        "name": "Azyartso",
                        "latitude": "53.83970000",
                        "longitude": "27.39170000"
                    },
                    {
                        "id": 15819,
                        "name": "Bal’shavik",
                        "latitude": "54.00360000",
                        "longitude": "27.56690000"
                    },
                    {
                        "id": 15824,
                        "name": "Barysaw",
                        "latitude": "54.22790000",
                        "longitude": "28.50500000"
                    },
                    {
                        "id": 15825,
                        "name": "Barysawski Rayon",
                        "latitude": "54.33333000",
                        "longitude": "28.58333000"
                    },
                    {
                        "id": 15826,
                        "name": "Blon’",
                        "latitude": "53.52690000",
                        "longitude": "28.17320000"
                    },
                    {
                        "id": 15827,
                        "name": "Bobr",
                        "latitude": "54.34200000",
                        "longitude": "29.27360000"
                    },
                    {
                        "id": 15828,
                        "name": "Borovlyany",
                        "latitude": "54.00220000",
                        "longitude": "27.67540000"
                    },
                    {
                        "id": 15840,
                        "name": "Byarezinski Rayon",
                        "latitude": "53.83333000",
                        "longitude": "29.00000000"
                    },
                    {
                        "id": 15845,
                        "name": "Byerazino",
                        "latitude": "53.83910000",
                        "longitude": "28.98790000"
                    },
                    {
                        "id": 15855,
                        "name": "Chervyen’",
                        "latitude": "53.70590000",
                        "longitude": "28.43130000"
                    },
                    {
                        "id": 15856,
                        "name": "Chervyen’ski Rayon",
                        "latitude": "53.75000000",
                        "longitude": "28.50000000"
                    },
                    {
                        "id": 15859,
                        "name": "Chyrvonaya Slabada",
                        "latitude": "52.85220000",
                        "longitude": "27.16980000"
                    },
                    {
                        "id": 15860,
                        "name": "Chyst’",
                        "latitude": "54.26980000",
                        "longitude": "27.10670000"
                    },
                    {
                        "id": 15871,
                        "name": "Druzhny",
                        "latitude": "53.62380000",
                        "longitude": "27.89770000"
                    },
                    {
                        "id": 15875,
                        "name": "Dukora",
                        "latitude": "53.67860000",
                        "longitude": "27.94000000"
                    },
                    {
                        "id": 15878,
                        "name": "Dzyarzhynsk",
                        "latitude": "53.68320000",
                        "longitude": "27.13800000"
                    },
                    {
                        "id": 15879,
                        "name": "Enyerhyetykaw",
                        "latitude": "53.58710000",
                        "longitude": "27.05350000"
                    },
                    {
                        "id": 15880,
                        "name": "Fanipol",
                        "latitude": "53.74998000",
                        "longitude": "27.33338000"
                    },
                    {
                        "id": 15889,
                        "name": "Haradzyeya",
                        "latitude": "53.31210000",
                        "longitude": "26.53800000"
                    },
                    {
                        "id": 15890,
                        "name": "Hatava",
                        "latitude": "53.78290000",
                        "longitude": "27.64070000"
                    },
                    {
                        "id": 15900,
                        "name": "Horad Smalyavichy",
                        "latitude": "54.02490000",
                        "longitude": "28.08940000"
                    },
                    {
                        "id": 15901,
                        "name": "Horad Zhodzina",
                        "latitude": "54.09850000",
                        "longitude": "28.33310000"
                    },
                    {
                        "id": 15904,
                        "name": "Hotsk",
                        "latitude": "52.52150000",
                        "longitude": "27.13850000"
                    },
                    {
                        "id": 15907,
                        "name": "Il’ya",
                        "latitude": "54.41670000",
                        "longitude": "27.29580000"
                    },
                    {
                        "id": 15912,
                        "name": "Ivyanyets",
                        "latitude": "53.88640000",
                        "longitude": "26.74320000"
                    },
                    {
                        "id": 15916,
                        "name": "Kalodzishchy",
                        "latitude": "53.94400000",
                        "longitude": "27.78230000"
                    },
                    {
                        "id": 15921,
                        "name": "Kapyl’",
                        "latitude": "53.15160000",
                        "longitude": "27.09130000"
                    },
                    {
                        "id": 15922,
                        "name": "Kapyl’ski Rayon",
                        "latitude": "53.16667000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 15931,
                        "name": "Khatsyezhyna",
                        "latitude": "53.90940000",
                        "longitude": "27.30690000"
                    },
                    {
                        "id": 15933,
                        "name": "Kholopenichi",
                        "latitude": "54.51746000",
                        "longitude": "28.95645000"
                    },
                    {
                        "id": 15940,
                        "name": "Klyetsk",
                        "latitude": "53.06350000",
                        "longitude": "26.63210000"
                    },
                    {
                        "id": 15941,
                        "name": "Klyetski Rayon",
                        "latitude": "53.00000000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 15945,
                        "name": "Korolëv Stan",
                        "latitude": "53.98650000",
                        "longitude": "27.79820000"
                    },
                    {
                        "id": 15949,
                        "name": "Krasnaye",
                        "latitude": "54.24380000",
                        "longitude": "27.07580000"
                    },
                    {
                        "id": 15954,
                        "name": "Krupki",
                        "latitude": "54.31780000",
                        "longitude": "29.13740000"
                    },
                    {
                        "id": 15956,
                        "name": "Kryvichy",
                        "latitude": "54.71320000",
                        "longitude": "27.28860000"
                    },
                    {
                        "id": 15958,
                        "name": "Lahoysk",
                        "latitude": "54.20640000",
                        "longitude": "27.85120000"
                    },
                    {
                        "id": 15961,
                        "name": "Loshnitsa",
                        "latitude": "54.27960000",
                        "longitude": "28.76490000"
                    },
                    {
                        "id": 15963,
                        "name": "Luhavaya Slabada",
                        "latitude": "53.78230000",
                        "longitude": "27.84340000"
                    },
                    {
                        "id": 15966,
                        "name": "Lyasny",
                        "latitude": "54.00720000",
                        "longitude": "27.69630000"
                    },
                    {
                        "id": 15972,
                        "name": "Lyeskawka",
                        "latitude": "54.00240000",
                        "longitude": "27.71080000"
                    },
                    {
                        "id": 15976,
                        "name": "Lyuban’",
                        "latitude": "52.79850000",
                        "longitude": "28.00480000"
                    },
                    {
                        "id": 15978,
                        "name": "Machulishchy",
                        "latitude": "53.77880000",
                        "longitude": "27.59480000"
                    },
                    {
                        "id": 15981,
                        "name": "Maladzyechna",
                        "latitude": "54.31670000",
                        "longitude": "26.85400000"
                    },
                    {
                        "id": 15983,
                        "name": "Mar’’ina Horka",
                        "latitude": "53.50900000",
                        "longitude": "28.14700000"
                    },
                    {
                        "id": 15987,
                        "name": "Michanovichi",
                        "latitude": "53.73937000",
                        "longitude": "27.69276000"
                    },
                    {
                        "id": 15995,
                        "name": "Myadzyel",
                        "latitude": "54.87890000",
                        "longitude": "26.93710000"
                    },
                    {
                        "id": 15996,
                        "name": "Myadzyel’ski Rayon",
                        "latitude": "54.83333000",
                        "longitude": "27.00000000"
                    },
                    {
                        "id": 16001,
                        "name": "Narach",
                        "latitude": "54.91020000",
                        "longitude": "26.70800000"
                    },
                    {
                        "id": 16003,
                        "name": "Nasilava",
                        "latitude": "54.30441000",
                        "longitude": "26.78209000"
                    },
                    {
                        "id": 16008,
                        "name": "Novosel’ye",
                        "latitude": "53.91620000",
                        "longitude": "27.20090000"
                    },
                    {
                        "id": 16009,
                        "name": "Novy Svyerzhan’",
                        "latitude": "53.45420000",
                        "longitude": "26.73010000"
                    },
                    {
                        "id": 16011,
                        "name": "Nyasvizh",
                        "latitude": "53.21890000",
                        "longitude": "26.67790000"
                    },
                    {
                        "id": 16012,
                        "name": "Nyasvizhski Rayon",
                        "latitude": "53.25000000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 16022,
                        "name": "Plyeshchanitsy",
                        "latitude": "54.42350000",
                        "longitude": "27.83010000"
                    },
                    {
                        "id": 16026,
                        "name": "Prawdzinski",
                        "latitude": "53.52480000",
                        "longitude": "27.83030000"
                    },
                    {
                        "id": 16029,
                        "name": "Pryvol’ny",
                        "latitude": "53.79690000",
                        "longitude": "27.79670000"
                    },
                    {
                        "id": 16030,
                        "name": "Pukhavichy",
                        "latitude": "53.52970000",
                        "longitude": "28.24670000"
                    },
                    {
                        "id": 16031,
                        "name": "Pukhavichy Raion",
                        "latitude": "53.50000000",
                        "longitude": "28.00000000"
                    },
                    {
                        "id": 16032,
                        "name": "Pyatryshki",
                        "latitude": "54.06860000",
                        "longitude": "27.21790000"
                    },
                    {
                        "id": 16034,
                        "name": "Radashkovichy",
                        "latitude": "54.15540000",
                        "longitude": "27.24120000"
                    },
                    {
                        "id": 16037,
                        "name": "Rakaw",
                        "latitude": "53.96740000",
                        "longitude": "27.05620000"
                    },
                    {
                        "id": 16043,
                        "name": "Rudzyensk",
                        "latitude": "53.59830000",
                        "longitude": "27.86210000"
                    },
                    {
                        "id": 16045,
                        "name": "Salihorsk",
                        "latitude": "52.78760000",
                        "longitude": "27.54150000"
                    },
                    {
                        "id": 16046,
                        "name": "Samakhvalavichy",
                        "latitude": "53.73960000",
                        "longitude": "27.50370000"
                    },
                    {
                        "id": 16048,
                        "name": "Sarachy",
                        "latitude": "52.78670000",
                        "longitude": "28.01860000"
                    },
                    {
                        "id": 16051,
                        "name": "Schomyslitsa",
                        "latitude": "53.82110000",
                        "longitude": "27.45220000"
                    },
                    {
                        "id": 16060,
                        "name": "Slabada",
                        "latitude": "54.00870000",
                        "longitude": "27.88660000"
                    },
                    {
                        "id": 16063,
                        "name": "Slutsk",
                        "latitude": "53.02740000",
                        "longitude": "27.55970000"
                    },
                    {
                        "id": 16064,
                        "name": "Slutski Rayon",
                        "latitude": "53.00000000",
                        "longitude": "27.66667000"
                    },
                    {
                        "id": 16065,
                        "name": "Smalyavitski Rayon",
                        "latitude": "54.00000000",
                        "longitude": "28.16667000"
                    },
                    {
                        "id": 16067,
                        "name": "Smilavichy",
                        "latitude": "53.74960000",
                        "longitude": "28.01150000"
                    },
                    {
                        "id": 16068,
                        "name": "Snow",
                        "latitude": "53.22010000",
                        "longitude": "26.40100000"
                    },
                    {
                        "id": 16070,
                        "name": "Stan’kava",
                        "latitude": "53.62920000",
                        "longitude": "27.22900000"
                    },
                    {
                        "id": 16071,
                        "name": "Staradarozhski Rayon",
                        "latitude": "53.00000000",
                        "longitude": "28.16667000"
                    },
                    {
                        "id": 16072,
                        "name": "Starobin",
                        "latitude": "52.72670000",
                        "longitude": "27.46060000"
                    },
                    {
                        "id": 16073,
                        "name": "Staryya Darohi",
                        "latitude": "53.04020000",
                        "longitude": "28.26700000"
                    },
                    {
                        "id": 16074,
                        "name": "Stawbtsowski Rayon",
                        "latitude": "53.58333000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 16077,
                        "name": "Stowbtsy",
                        "latitude": "53.47850000",
                        "longitude": "26.74340000"
                    },
                    {
                        "id": 16078,
                        "name": "Svir",
                        "latitude": "54.85170000",
                        "longitude": "26.39500000"
                    },
                    {
                        "id": 16080,
                        "name": "Svislach",
                        "latitude": "53.64040000",
                        "longitude": "27.91990000"
                    },
                    {
                        "id": 16083,
                        "name": "Syenitsa",
                        "latitude": "53.83130000",
                        "longitude": "27.53430000"
                    },
                    {
                        "id": 16085,
                        "name": "Syomkava",
                        "latitude": "54.01010000",
                        "longitude": "27.44100000"
                    },
                    {
                        "id": 16088,
                        "name": "Tsimkavichy",
                        "latitude": "53.06720000",
                        "longitude": "26.99020000"
                    },
                    {
                        "id": 16091,
                        "name": "Turets-Bayary",
                        "latitude": "54.37850000",
                        "longitude": "26.65810000"
                    },
                    {
                        "id": 16092,
                        "name": "Urechcha",
                        "latitude": "52.94790000",
                        "longitude": "27.89300000"
                    },
                    {
                        "id": 16094,
                        "name": "Usiazh",
                        "latitude": "54.07598000",
                        "longitude": "28.00698000"
                    },
                    {
                        "id": 16095,
                        "name": "Uzda",
                        "latitude": "53.46270000",
                        "longitude": "27.21370000"
                    },
                    {
                        "id": 16096,
                        "name": "Uzdzyenski Rayon",
                        "latitude": "53.41667000",
                        "longitude": "27.33333000"
                    },
                    {
                        "id": 16097,
                        "name": "Valozhyn",
                        "latitude": "54.08920000",
                        "longitude": "26.52660000"
                    },
                    {
                        "id": 16101,
                        "name": "Vilyeyka",
                        "latitude": "54.49140000",
                        "longitude": "26.91110000"
                    },
                    {
                        "id": 16102,
                        "name": "Vilyeyski Rayon",
                        "latitude": "54.50000000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 16109,
                        "name": "Vyaliki Trastsyanets",
                        "latitude": "53.85100000",
                        "longitude": "27.71390000"
                    },
                    {
                        "id": 16117,
                        "name": "Yubilyeyny",
                        "latitude": "53.81910000",
                        "longitude": "27.52150000"
                    },
                    {
                        "id": 16118,
                        "name": "Zamostochye",
                        "latitude": "53.81980000",
                        "longitude": "27.86850000"
                    },
                    {
                        "id": 16119,
                        "name": "Zaslawye",
                        "latitude": "54.01140000",
                        "longitude": "27.26950000"
                    },
                    {
                        "id": 16125,
                        "name": "Zhdanovichy",
                        "latitude": "53.94320000",
                        "longitude": "27.42500000"
                    },
                    {
                        "id": 16131,
                        "name": "Zyembin",
                        "latitude": "54.35790000",
                        "longitude": "28.22070000"
                    },
                    {
                        "id": 16132,
                        "name": "Октябрьский",
                        "latitude": "54.04059000",
                        "longitude": "28.19813000"
                    }
                ]
            },
            {
                "id": 2958,
                "name": "Minsk",
                "iso2": "HM",
                "latitude": "53.90060110",
                "longitude": "27.55897200",
                "type": "city",
                "cities": [
                    {
                        "id": 15881,
                        "name": "Frunzyenski Rayon",
                        "latitude": "53.90056000",
                        "longitude": "27.49500000"
                    },
                    {
                        "id": 15927,
                        "name": "Kastrychnitski Rayon",
                        "latitude": "53.85667000",
                        "longitude": "27.54139000"
                    },
                    {
                        "id": 15969,
                        "name": "Lyeninski Rayon",
                        "latitude": "53.85944000",
                        "longitude": "27.58778000"
                    },
                    {
                        "id": 15984,
                        "name": "Maskowski Rayon",
                        "latitude": "53.87417000",
                        "longitude": "27.50278000"
                    },
                    {
                        "id": 15989,
                        "name": "Minsk",
                        "latitude": "53.90000000",
                        "longitude": "27.56667000"
                    },
                    {
                        "id": 16016,
                        "name": "Partyzanski Rayon",
                        "latitude": "53.88028000",
                        "longitude": "27.67000000"
                    },
                    {
                        "id": 16050,
                        "name": "Savyetski Rayon",
                        "latitude": "53.91778000",
                        "longitude": "27.59417000"
                    },
                    {
                        "id": 16087,
                        "name": "Tsentral’ny Rayon",
                        "latitude": "53.91778000",
                        "longitude": "27.56333000"
                    },
                    {
                        "id": 16120,
                        "name": "Zavodski Rayon",
                        "latitude": "53.86194000",
                        "longitude": "27.66222000"
                    }
                ]
            },
            {
                "id": 2954,
                "name": "Mogilev",
                "iso2": "MA",
                "latitude": "53.51017910",
                "longitude": "30.40064440",
                "type": "oblast",
                "cities": [
                    {
                        "id": 15808,
                        "name": "Asipovichy",
                        "latitude": "53.30110000",
                        "longitude": "28.63860000"
                    },
                    {
                        "id": 15809,
                        "name": "Asipovitski Rayon",
                        "latitude": "53.33333000",
                        "longitude": "28.75000000"
                    },
                    {
                        "id": 15816,
                        "name": "Babruysk",
                        "latitude": "53.13840000",
                        "longitude": "29.22140000"
                    },
                    {
                        "id": 15817,
                        "name": "Babruyski Rayon",
                        "latitude": "53.08333000",
                        "longitude": "29.16667000"
                    },
                    {
                        "id": 15836,
                        "name": "Buynichy",
                        "latitude": "53.85360000",
                        "longitude": "30.26710000"
                    },
                    {
                        "id": 15838,
                        "name": "Byalynichy",
                        "latitude": "53.99940000",
                        "longitude": "29.71410000"
                    },
                    {
                        "id": 15839,
                        "name": "Byalynitski Rayon",
                        "latitude": "54.00000000",
                        "longitude": "29.75000000"
                    },
                    {
                        "id": 15847,
                        "name": "Bykhaw",
                        "latitude": "53.52100000",
                        "longitude": "30.24540000"
                    },
                    {
                        "id": 15853,
                        "name": "Chavuski Rayon",
                        "latitude": "53.83333000",
                        "longitude": "30.91667000"
                    },
                    {
                        "id": 15854,
                        "name": "Chavusy",
                        "latitude": "53.80980000",
                        "longitude": "30.97170000"
                    },
                    {
                        "id": 15857,
                        "name": "Cherykaw",
                        "latitude": "53.56890000",
                        "longitude": "31.38310000"
                    },
                    {
                        "id": 15858,
                        "name": "Cherykawski Rayon",
                        "latitude": "53.66667000",
                        "longitude": "31.33333000"
                    },
                    {
                        "id": 15862,
                        "name": "Dashkawka",
                        "latitude": "53.73520000",
                        "longitude": "30.26250000"
                    },
                    {
                        "id": 15872,
                        "name": "Drybin",
                        "latitude": "54.11920000",
                        "longitude": "31.09390000"
                    },
                    {
                        "id": 15873,
                        "name": "Drybinski Rayon",
                        "latitude": "54.08333000",
                        "longitude": "31.00000000"
                    },
                    {
                        "id": 15891,
                        "name": "Hlusha",
                        "latitude": "53.08680000",
                        "longitude": "28.85670000"
                    },
                    {
                        "id": 15892,
                        "name": "Hlusk",
                        "latitude": "52.90300000",
                        "longitude": "28.68450000"
                    },
                    {
                        "id": 15902,
                        "name": "Horatski Rayon",
                        "latitude": "54.33333000",
                        "longitude": "31.00000000"
                    },
                    {
                        "id": 15903,
                        "name": "Horki",
                        "latitude": "54.28620000",
                        "longitude": "30.98630000"
                    },
                    {
                        "id": 15914,
                        "name": "Kadino",
                        "latitude": "53.88389000",
                        "longitude": "30.52028000"
                    },
                    {
                        "id": 15920,
                        "name": "Kamyennyya Lavy",
                        "latitude": "54.08980000",
                        "longitude": "30.29620000"
                    },
                    {
                        "id": 15928,
                        "name": "Kastsyukovichy",
                        "latitude": "53.35250000",
                        "longitude": "32.05140000"
                    },
                    {
                        "id": 15932,
                        "name": "Khodasy",
                        "latitude": "53.92660000",
                        "longitude": "31.47790000"
                    },
                    {
                        "id": 15934,
                        "name": "Khotsimsk",
                        "latitude": "53.40860000",
                        "longitude": "32.57800000"
                    },
                    {
                        "id": 15935,
                        "name": "Khotsimski Rayon",
                        "latitude": "53.41667000",
                        "longitude": "32.50000000"
                    },
                    {
                        "id": 15937,
                        "name": "Kirawsk",
                        "latitude": "53.26930000",
                        "longitude": "29.47520000"
                    },
                    {
                        "id": 15938,
                        "name": "Klichaw",
                        "latitude": "53.49230000",
                        "longitude": "29.33560000"
                    },
                    {
                        "id": 15939,
                        "name": "Klimavichy",
                        "latitude": "53.60790000",
                        "longitude": "31.95860000"
                    },
                    {
                        "id": 15948,
                        "name": "Krasnapol’ski Rayon",
                        "latitude": "53.33333000",
                        "longitude": "31.41667000"
                    },
                    {
                        "id": 15947,
                        "name": "Krasnapollye",
                        "latitude": "53.33530000",
                        "longitude": "31.39990000"
                    },
                    {
                        "id": 15951,
                        "name": "Krasnyy Bereg",
                        "latitude": "53.32910000",
                        "longitude": "30.19290000"
                    },
                    {
                        "id": 15953,
                        "name": "Kruhlaye",
                        "latitude": "54.24970000",
                        "longitude": "29.79680000"
                    },
                    {
                        "id": 15955,
                        "name": "Krychaw",
                        "latitude": "53.71250000",
                        "longitude": "31.71700000"
                    },
                    {
                        "id": 15979,
                        "name": "Mahilyow",
                        "latitude": "53.91680000",
                        "longitude": "30.34490000"
                    },
                    {
                        "id": 15980,
                        "name": "Mahilyowski Rayon",
                        "latitude": "53.83333000",
                        "longitude": "30.25000000"
                    },
                    {
                        "id": 15994,
                        "name": "Mstsislaw",
                        "latitude": "54.01850000",
                        "longitude": "31.72170000"
                    },
                    {
                        "id": 15997,
                        "name": "Myazhysyatki",
                        "latitude": "53.77760000",
                        "longitude": "30.17650000"
                    },
                    {
                        "id": 16000,
                        "name": "Myshkavichy",
                        "latitude": "53.21720000",
                        "longitude": "29.51200000"
                    },
                    {
                        "id": 16015,
                        "name": "Palykavichy Pyershyya",
                        "latitude": "53.98540000",
                        "longitude": "30.36000000"
                    },
                    {
                        "id": 16025,
                        "name": "Posëlok Voskhod",
                        "latitude": "53.77660000",
                        "longitude": "30.34970000"
                    },
                    {
                        "id": 16038,
                        "name": "Ramanavichy",
                        "latitude": "53.86530000",
                        "longitude": "30.55970000"
                    },
                    {
                        "id": 16056,
                        "name": "Shklow",
                        "latitude": "54.21310000",
                        "longitude": "30.28770000"
                    },
                    {
                        "id": 16057,
                        "name": "Shklowski Rayon",
                        "latitude": "54.16667000",
                        "longitude": "30.33333000"
                    },
                    {
                        "id": 16061,
                        "name": "Slawharad",
                        "latitude": "53.44290000",
                        "longitude": "31.00140000"
                    },
                    {
                        "id": 16099,
                        "name": "Veyno",
                        "latitude": "53.83333000",
                        "longitude": "30.38333000"
                    },
                    {
                        "id": 16104,
                        "name": "Vishow",
                        "latitude": "53.98050000",
                        "longitude": "29.99250000"
                    },
                    {
                        "id": 16115,
                        "name": "Yalizava",
                        "latitude": "53.39940000",
                        "longitude": "29.00480000"
                    }
                ]
            },
            {
                "id": 2960,
                "name": "Vitebsk",
                "iso2": "VI",
                "latitude": "55.29598330",
                "longitude": "28.75836270",
                "type": "oblast",
                "cities": [
                    {
                        "id": 15818,
                        "name": "Balbasava",
                        "latitude": "54.42070000",
                        "longitude": "30.29090000"
                    },
                    {
                        "id": 15822,
                        "name": "Baran’",
                        "latitude": "54.47840000",
                        "longitude": "30.31590000"
                    },
                    {
                        "id": 15831,
                        "name": "Braslaw",
                        "latitude": "55.64130000",
                        "longitude": "27.04180000"
                    },
                    {
                        "id": 15832,
                        "name": "Braslawski Rayon",
                        "latitude": "55.55972000",
                        "longitude": "27.00000000"
                    },
                    {
                        "id": 15837,
                        "name": "Byahoml’",
                        "latitude": "54.73160000",
                        "longitude": "28.05770000"
                    },
                    {
                        "id": 15846,
                        "name": "Byeshankovitski Rayon",
                        "latitude": "55.00000000",
                        "longitude": "29.50000000"
                    },
                    {
                        "id": 15851,
                        "name": "Chashniki",
                        "latitude": "54.85840000",
                        "longitude": "29.16080000"
                    },
                    {
                        "id": 15852,
                        "name": "Chashnitski Rayon",
                        "latitude": "54.75000000",
                        "longitude": "29.25000000"
                    },
                    {
                        "id": 15865,
                        "name": "Dokshytski Rayon",
                        "latitude": "54.83333000",
                        "longitude": "27.91667000"
                    },
                    {
                        "id": 15866,
                        "name": "Dokshytsy",
                        "latitude": "54.89180000",
                        "longitude": "27.76670000"
                    },
                    {
                        "id": 15870,
                        "name": "Druya",
                        "latitude": "55.79060000",
                        "longitude": "27.45050000"
                    },
                    {
                        "id": 15874,
                        "name": "Dubrowna",
                        "latitude": "54.57160000",
                        "longitude": "30.69100000"
                    },
                    {
                        "id": 15877,
                        "name": "Dzisna",
                        "latitude": "55.56760000",
                        "longitude": "28.20760000"
                    },
                    {
                        "id": 15886,
                        "name": "Haradok",
                        "latitude": "55.46240000",
                        "longitude": "29.98450000"
                    },
                    {
                        "id": 15887,
                        "name": "Haradotski Rayon",
                        "latitude": "55.66667000",
                        "longitude": "30.16667000"
                    },
                    {
                        "id": 15893,
                        "name": "Hlybokaye",
                        "latitude": "55.13840000",
                        "longitude": "27.69050000"
                    },
                    {
                        "id": 15894,
                        "name": "Hlybotski Rayon",
                        "latitude": "55.16667000",
                        "longitude": "27.83333000"
                    },
                    {
                        "id": 15943,
                        "name": "Kokhanava",
                        "latitude": "54.46110000",
                        "longitude": "30.00180000"
                    },
                    {
                        "id": 15944,
                        "name": "Konstantinovo",
                        "latitude": "54.65930000",
                        "longitude": "29.26840000"
                    },
                    {
                        "id": 15970,
                        "name": "Lyepyel’",
                        "latitude": "54.88140000",
                        "longitude": "28.69900000"
                    },
                    {
                        "id": 15971,
                        "name": "Lyepyel’ski Rayon",
                        "latitude": "54.83333000",
                        "longitude": "28.66667000"
                    },
                    {
                        "id": 15973,
                        "name": "Lyntupy",
                        "latitude": "55.05160000",
                        "longitude": "26.31030000"
                    },
                    {
                        "id": 15974,
                        "name": "Lyozna",
                        "latitude": "55.02470000",
                        "longitude": "30.79700000"
                    },
                    {
                        "id": 15975,
                        "name": "Lyoznyenski Rayon",
                        "latitude": "55.00000000",
                        "longitude": "30.66667000"
                    },
                    {
                        "id": 15991,
                        "name": "Mosar",
                        "latitude": "55.22320000",
                        "longitude": "27.46090000"
                    },
                    {
                        "id": 15998,
                        "name": "Myorski Rayon",
                        "latitude": "55.58333000",
                        "longitude": "27.83333000"
                    },
                    {
                        "id": 15999,
                        "name": "Myory",
                        "latitude": "55.62220000",
                        "longitude": "27.62810000"
                    },
                    {
                        "id": 16004,
                        "name": "Navapolatsk",
                        "latitude": "55.53180000",
                        "longitude": "28.59870000"
                    },
                    {
                        "id": 16007,
                        "name": "Novolukoml’",
                        "latitude": "54.66192000",
                        "longitude": "29.15016000"
                    },
                    {
                        "id": 16013,
                        "name": "Orsha",
                        "latitude": "54.50810000",
                        "longitude": "30.41720000"
                    },
                    {
                        "id": 16014,
                        "name": "Osveya",
                        "latitude": "56.01470000",
                        "longitude": "28.11049000"
                    },
                    {
                        "id": 16018,
                        "name": "Pastavy",
                        "latitude": "55.11676000",
                        "longitude": "26.83263000"
                    },
                    {
                        "id": 16019,
                        "name": "Pastawski Rayon",
                        "latitude": "55.08333000",
                        "longitude": "26.91667000"
                    },
                    {
                        "id": 16023,
                        "name": "Polatsk",
                        "latitude": "55.48790000",
                        "longitude": "28.78560000"
                    },
                    {
                        "id": 16024,
                        "name": "Polatski Rayon",
                        "latitude": "55.58333000",
                        "longitude": "29.00000000"
                    },
                    {
                        "id": 16039,
                        "name": "Rasonski Rayon",
                        "latitude": "55.83333000",
                        "longitude": "28.91667000"
                    },
                    {
                        "id": 16040,
                        "name": "Rasony",
                        "latitude": "55.90580000",
                        "longitude": "28.81350000"
                    },
                    {
                        "id": 16052,
                        "name": "Sharkawshchyna",
                        "latitude": "55.36890000",
                        "longitude": "27.46860000"
                    },
                    {
                        "id": 16053,
                        "name": "Sharkawshchynski Rayon",
                        "latitude": "55.41667000",
                        "longitude": "27.41667000"
                    },
                    {
                        "id": 16058,
                        "name": "Shumilinski Rayon",
                        "latitude": "55.33333000",
                        "longitude": "29.50000000"
                    },
                    {
                        "id": 16082,
                        "name": "Syanno",
                        "latitude": "54.81080000",
                        "longitude": "29.70860000"
                    },
                    {
                        "id": 16084,
                        "name": "Syennyenski Rayon",
                        "latitude": "54.83333000",
                        "longitude": "29.83333000"
                    },
                    {
                        "id": 16086,
                        "name": "Talachyn",
                        "latitude": "54.40870000",
                        "longitude": "29.69550000"
                    },
                    {
                        "id": 16093,
                        "name": "Ushachy",
                        "latitude": "55.17900000",
                        "longitude": "28.61580000"
                    },
                    {
                        "id": 16100,
                        "name": "Vidzy",
                        "latitude": "55.39450000",
                        "longitude": "26.63050000"
                    },
                    {
                        "id": 16105,
                        "name": "Vitebsk",
                        "latitude": "55.19040000",
                        "longitude": "30.20490000"
                    },
                    {
                        "id": 16110,
                        "name": "Vyerkhnyadzvinsk",
                        "latitude": "55.77770000",
                        "longitude": "27.93890000"
                    },
                    {
                        "id": 16111,
                        "name": "Vyerkhnyadzvinski Rayon",
                        "latitude": "55.75000000",
                        "longitude": "28.16667000"
                    }
                ]
            }
        ]
    },
    {
        "id": 22,
        "name": "Belgium",
        "iso3": "BEL",
        "iso2": "BE",
        "numeric_code": "056",
        "phonecode": "32",
        "capital": "Brussels",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".be",
        "native": "België",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Western Europe",
        "subregion_id": 17,
        "nationality": "Belgian",
        "timezones": [
            {
                "zoneName": "Europe\/Brussels",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Belgia",
            "ko": "벨기에",
            "pt-BR": "Bélgica",
            "pt": "Bélgica",
            "nl": "België",
            "hr": "Belgija",
            "fa": "بلژیک",
            "de": "Belgien",
            "es": "Bélgica",
            "fr": "Belgique",
            "ja": "ベルギー",
            "it": "Belgio",
            "zh-CN": "比利时",
            "tr": "Belçika",
            "ru": "Бельгия",
            "uk": "Бельгія",
            "pl": "Belgia"
        },
        "latitude": "50.83333333",
        "longitude": "4.00000000",
        "emoji": "🇧🇪",
        "emojiU": "U+1F1E7 U+1F1EA",
        "states": [
            {
                "id": 1381,
                "name": "Antwerp",
                "iso2": "VAN",
                "latitude": "51.21944750",
                "longitude": "4.40246430",
                "type": "province",
                "cities": []
            },
            {
                "id": 1376,
                "name": "Brussels-Capital ",
                "iso2": "BRU",
                "latitude": "50.85034630",
                "longitude": "4.35172110",
                "type": "region",
                "cities": [
                    {
                        "id": 8693,
                        "name": "Brussels",
                        "latitude": "50.85045000",
                        "longitude": "4.34878000"
                    }
                ]
            },
            {
                "id": 1377,
                "name": "East Flanders",
                "iso2": "VOV",
                "latitude": "51.03621010",
                "longitude": "3.73731240",
                "type": "province",
                "cities": []
            },
            {
                "id": 1373,
                "name": "Flanders",
                "iso2": "VLG",
                "latitude": "51.01087060",
                "longitude": "3.72646130",
                "type": "region",
                "cities": [
                    {
                        "id": 8608,
                        "name": "Aalst",
                        "latitude": "50.93604000",
                        "longitude": "4.03550000"
                    },
                    {
                        "id": 8609,
                        "name": "Aalter",
                        "latitude": "51.09017000",
                        "longitude": "3.44693000"
                    },
                    {
                        "id": 8610,
                        "name": "Aarschot",
                        "latitude": "50.98715000",
                        "longitude": "4.83695000"
                    },
                    {
                        "id": 8611,
                        "name": "Aartselaar",
                        "latitude": "51.13412000",
                        "longitude": "4.38678000"
                    },
                    {
                        "id": 8613,
                        "name": "Alken",
                        "latitude": "50.87553000",
                        "longitude": "5.30558000"
                    },
                    {
                        "id": 8614,
                        "name": "Alveringem",
                        "latitude": "51.01238000",
                        "longitude": "2.71117000"
                    },
                    {
                        "id": 8623,
                        "name": "Antwerpen",
                        "latitude": "51.21989000",
                        "longitude": "4.40346000"
                    },
                    {
                        "id": 8624,
                        "name": "Anzegem",
                        "latitude": "50.83700000",
                        "longitude": "3.47786000"
                    },
                    {
                        "id": 8625,
                        "name": "Ardooie",
                        "latitude": "50.97570000",
                        "longitude": "3.19736000"
                    },
                    {
                        "id": 8626,
                        "name": "Arendonk",
                        "latitude": "51.32267000",
                        "longitude": "5.08289000"
                    },
                    {
                        "id": 8628,
                        "name": "As",
                        "latitude": "51.00755000",
                        "longitude": "5.58453000"
                    },
                    {
                        "id": 8629,
                        "name": "Asse",
                        "latitude": "50.91011000",
                        "longitude": "4.19836000"
                    },
                    {
                        "id": 8630,
                        "name": "Assenede",
                        "latitude": "51.22598000",
                        "longitude": "3.75085000"
                    },
                    {
                        "id": 8636,
                        "name": "Avelgem",
                        "latitude": "50.77618000",
                        "longitude": "3.44502000"
                    },
                    {
                        "id": 8639,
                        "name": "Baarle-Hertog",
                        "latitude": "51.40504000",
                        "longitude": "4.89226000"
                    },
                    {
                        "id": 8641,
                        "name": "Balen",
                        "latitude": "51.16837000",
                        "longitude": "5.17027000"
                    },
                    {
                        "id": 8648,
                        "name": "Beernem",
                        "latitude": "51.13981000",
                        "longitude": "3.33896000"
                    },
                    {
                        "id": 8649,
                        "name": "Beerse",
                        "latitude": "51.31927000",
                        "longitude": "4.85304000"
                    },
                    {
                        "id": 8650,
                        "name": "Beersel",
                        "latitude": "50.76589000",
                        "longitude": "4.30020000"
                    },
                    {
                        "id": 8651,
                        "name": "Begijnendijk",
                        "latitude": "51.01942000",
                        "longitude": "4.78377000"
                    },
                    {
                        "id": 8652,
                        "name": "Bekkevoort",
                        "latitude": "50.94074000",
                        "longitude": "4.96900000"
                    },
                    {
                        "id": 8654,
                        "name": "Beringen",
                        "latitude": "51.04954000",
                        "longitude": "5.22606000"
                    },
                    {
                        "id": 8655,
                        "name": "Berlaar",
                        "latitude": "51.11760000",
                        "longitude": "4.65835000"
                    },
                    {
                        "id": 8656,
                        "name": "Berlare",
                        "latitude": "51.03333000",
                        "longitude": "4.00000000"
                    },
                    {
                        "id": 8659,
                        "name": "Bertem",
                        "latitude": "50.86403000",
                        "longitude": "4.62918000"
                    },
                    {
                        "id": 8662,
                        "name": "Bever",
                        "latitude": "50.91667000",
                        "longitude": "4.31667000"
                    },
                    {
                        "id": 8663,
                        "name": "Beveren",
                        "latitude": "51.21187000",
                        "longitude": "4.25633000"
                    },
                    {
                        "id": 8665,
                        "name": "Bierbeek",
                        "latitude": "50.82876000",
                        "longitude": "4.75949000"
                    },
                    {
                        "id": 8666,
                        "name": "Bilzen",
                        "latitude": "50.87325000",
                        "longitude": "5.51840000"
                    },
                    {
                        "id": 8669,
                        "name": "Blankenberge",
                        "latitude": "51.31306000",
                        "longitude": "3.13227000"
                    },
                    {
                        "id": 8671,
                        "name": "Bocholt",
                        "latitude": "51.17337000",
                        "longitude": "5.57994000"
                    },
                    {
                        "id": 8672,
                        "name": "Boechout",
                        "latitude": "51.15959000",
                        "longitude": "4.49195000"
                    },
                    {
                        "id": 8673,
                        "name": "Bonheiden",
                        "latitude": "51.02261000",
                        "longitude": "4.54714000"
                    },
                    {
                        "id": 8674,
                        "name": "Boom",
                        "latitude": "51.09242000",
                        "longitude": "4.37170000"
                    },
                    {
                        "id": 8675,
                        "name": "Boortmeerbeek",
                        "latitude": "50.97929000",
                        "longitude": "4.57443000"
                    },
                    {
                        "id": 8676,
                        "name": "Borgloon",
                        "latitude": "50.80505000",
                        "longitude": "5.34366000"
                    },
                    {
                        "id": 8677,
                        "name": "Bornem",
                        "latitude": "51.09716000",
                        "longitude": "4.24364000"
                    },
                    {
                        "id": 8678,
                        "name": "Borsbeek",
                        "latitude": "51.19661000",
                        "longitude": "4.48543000"
                    },
                    {
                        "id": 8681,
                        "name": "Boutersem",
                        "latitude": "50.83511000",
                        "longitude": "4.83450000"
                    },
                    {
                        "id": 8686,
                        "name": "Brasschaat",
                        "latitude": "51.29120000",
                        "longitude": "4.49182000"
                    },
                    {
                        "id": 8687,
                        "name": "Brecht",
                        "latitude": "51.35024000",
                        "longitude": "4.63829000"
                    },
                    {
                        "id": 8688,
                        "name": "Bredene",
                        "latitude": "51.23489000",
                        "longitude": "2.97559000"
                    },
                    {
                        "id": 8689,
                        "name": "Bree",
                        "latitude": "51.14152000",
                        "longitude": "5.59690000"
                    },
                    {
                        "id": 8691,
                        "name": "Brugge",
                        "latitude": "51.20892000",
                        "longitude": "3.22424000"
                    },
                    {
                        "id": 8694,
                        "name": "Buggenhout",
                        "latitude": "51.01590000",
                        "longitude": "4.20173000"
                    },
                    {
                        "id": 8718,
                        "name": "Damme",
                        "latitude": "51.25147000",
                        "longitude": "3.28144000"
                    },
                    {
                        "id": 8720,
                        "name": "De Haan",
                        "latitude": "51.27261000",
                        "longitude": "3.03446000"
                    },
                    {
                        "id": 8721,
                        "name": "De Panne",
                        "latitude": "51.09793000",
                        "longitude": "2.59368000"
                    },
                    {
                        "id": 8722,
                        "name": "De Pinte",
                        "latitude": "50.99339000",
                        "longitude": "3.64747000"
                    },
                    {
                        "id": 8723,
                        "name": "Deerlijk",
                        "latitude": "50.85337000",
                        "longitude": "3.35416000"
                    },
                    {
                        "id": 8724,
                        "name": "Deinze",
                        "latitude": "50.98175000",
                        "longitude": "3.53096000"
                    },
                    {
                        "id": 8725,
                        "name": "Denderleeuw",
                        "latitude": "50.88506000",
                        "longitude": "4.07601000"
                    },
                    {
                        "id": 8726,
                        "name": "Dendermonde",
                        "latitude": "51.02869000",
                        "longitude": "4.10106000"
                    },
                    {
                        "id": 8727,
                        "name": "Dentergem",
                        "latitude": "50.96429000",
                        "longitude": "3.41617000"
                    },
                    {
                        "id": 8728,
                        "name": "Dessel",
                        "latitude": "51.23855000",
                        "longitude": "5.11448000"
                    },
                    {
                        "id": 8729,
                        "name": "Destelbergen",
                        "latitude": "51.05952000",
                        "longitude": "3.79899000"
                    },
                    {
                        "id": 8730,
                        "name": "Deurne",
                        "latitude": "51.22134000",
                        "longitude": "4.46595000"
                    },
                    {
                        "id": 8731,
                        "name": "Diegem",
                        "latitude": "50.89727000",
                        "longitude": "4.43354000"
                    },
                    {
                        "id": 8732,
                        "name": "Diepenbeek",
                        "latitude": "50.90769000",
                        "longitude": "5.41875000"
                    },
                    {
                        "id": 8733,
                        "name": "Diest",
                        "latitude": "50.98923000",
                        "longitude": "5.05062000"
                    },
                    {
                        "id": 8734,
                        "name": "Diksmuide",
                        "latitude": "51.03248000",
                        "longitude": "2.86384000"
                    },
                    {
                        "id": 8735,
                        "name": "Dilbeek",
                        "latitude": "50.84799000",
                        "longitude": "4.25972000"
                    },
                    {
                        "id": 8741,
                        "name": "Drogenbos",
                        "latitude": "50.78733000",
                        "longitude": "4.31471000"
                    },
                    {
                        "id": 8742,
                        "name": "Duffel",
                        "latitude": "51.09554000",
                        "longitude": "4.50903000"
                    },
                    {
                        "id": 8744,
                        "name": "Edegem",
                        "latitude": "51.15662000",
                        "longitude": "4.44504000"
                    },
                    {
                        "id": 8745,
                        "name": "Eeklo",
                        "latitude": "51.18703000",
                        "longitude": "3.55654000"
                    },
                    {
                        "id": 8751,
                        "name": "Essen",
                        "latitude": "51.46791000",
                        "longitude": "4.46901000"
                    },
                    {
                        "id": 8755,
                        "name": "Evergem",
                        "latitude": "51.11306000",
                        "longitude": "3.70976000"
                    },
                    {
                        "id": 8773,
                        "name": "Galmaarden",
                        "latitude": "50.75389000",
                        "longitude": "3.97121000"
                    },
                    {
                        "id": 8774,
                        "name": "Gavere",
                        "latitude": "50.92917000",
                        "longitude": "3.66184000"
                    },
                    {
                        "id": 8776,
                        "name": "Geel",
                        "latitude": "51.16557000",
                        "longitude": "4.98917000"
                    },
                    {
                        "id": 8778,
                        "name": "Geetbets",
                        "latitude": "50.89431000",
                        "longitude": "5.11199000"
                    },
                    {
                        "id": 8781,
                        "name": "Genk",
                        "latitude": "50.96500000",
                        "longitude": "5.50082000"
                    },
                    {
                        "id": 8782,
                        "name": "Gent",
                        "latitude": "51.05000000",
                        "longitude": "3.71667000"
                    },
                    {
                        "id": 8783,
                        "name": "Geraardsbergen",
                        "latitude": "50.77343000",
                        "longitude": "3.88223000"
                    },
                    {
                        "id": 8786,
                        "name": "Gingelom",
                        "latitude": "50.74792000",
                        "longitude": "5.13422000"
                    },
                    {
                        "id": 8787,
                        "name": "Gistel",
                        "latitude": "51.15612000",
                        "longitude": "2.96387000"
                    },
                    {
                        "id": 8788,
                        "name": "Glabbeek",
                        "latitude": "50.87267000",
                        "longitude": "4.95615000"
                    },
                    {
                        "id": 8789,
                        "name": "Gooik",
                        "latitude": "50.79443000",
                        "longitude": "4.11378000"
                    },
                    {
                        "id": 8792,
                        "name": "Grimbergen",
                        "latitude": "50.93409000",
                        "longitude": "4.37213000"
                    },
                    {
                        "id": 8793,
                        "name": "Grobbendonk",
                        "latitude": "51.19043000",
                        "longitude": "4.73562000"
                    },
                    {
                        "id": 8794,
                        "name": "Haacht",
                        "latitude": "50.97737000",
                        "longitude": "4.63777000"
                    },
                    {
                        "id": 8795,
                        "name": "Haaltert",
                        "latitude": "50.90634000",
                        "longitude": "4.00093000"
                    },
                    {
                        "id": 8797,
                        "name": "Halen",
                        "latitude": "50.94837000",
                        "longitude": "5.11096000"
                    },
                    {
                        "id": 8798,
                        "name": "Halle",
                        "latitude": "50.73385000",
                        "longitude": "4.23454000"
                    },
                    {
                        "id": 8799,
                        "name": "Hamme",
                        "latitude": "51.09822000",
                        "longitude": "4.13705000"
                    },
                    {
                        "id": 8803,
                        "name": "Harelbeke",
                        "latitude": "50.85343000",
                        "longitude": "3.30935000"
                    },
                    {
                        "id": 8804,
                        "name": "Hasselt",
                        "latitude": "50.93106000",
                        "longitude": "5.33781000"
                    },
                    {
                        "id": 8807,
                        "name": "Heers",
                        "latitude": "50.75383000",
                        "longitude": "5.30210000"
                    },
                    {
                        "id": 8808,
                        "name": "Heist-op-den-Berg",
                        "latitude": "51.07537000",
                        "longitude": "4.72827000"
                    },
                    {
                        "id": 8809,
                        "name": "Helchteren",
                        "latitude": "51.05591000",
                        "longitude": "5.38244000"
                    },
                    {
                        "id": 8810,
                        "name": "Hemiksem",
                        "latitude": "51.14484000",
                        "longitude": "4.33874000"
                    },
                    {
                        "id": 8813,
                        "name": "Herent",
                        "latitude": "50.90861000",
                        "longitude": "4.67056000"
                    },
                    {
                        "id": 8814,
                        "name": "Herentals",
                        "latitude": "51.17655000",
                        "longitude": "4.83248000"
                    },
                    {
                        "id": 8815,
                        "name": "Herenthout",
                        "latitude": "51.14010000",
                        "longitude": "4.75572000"
                    },
                    {
                        "id": 8816,
                        "name": "Herk-de-Stad",
                        "latitude": "50.94013000",
                        "longitude": "5.16636000"
                    },
                    {
                        "id": 8817,
                        "name": "Herne",
                        "latitude": "50.72423000",
                        "longitude": "4.03481000"
                    },
                    {
                        "id": 8818,
                        "name": "Herselt",
                        "latitude": "51.05159000",
                        "longitude": "4.88231000"
                    },
                    {
                        "id": 8821,
                        "name": "Herzele",
                        "latitude": "50.88681000",
                        "longitude": "3.89014000"
                    },
                    {
                        "id": 8822,
                        "name": "Heusden",
                        "latitude": "51.03664000",
                        "longitude": "5.28013000"
                    },
                    {
                        "id": 8823,
                        "name": "Hoboken",
                        "latitude": "51.17611000",
                        "longitude": "4.34844000"
                    },
                    {
                        "id": 8824,
                        "name": "Hoegaarden",
                        "latitude": "50.77560000",
                        "longitude": "4.88952000"
                    },
                    {
                        "id": 8825,
                        "name": "Hoeilaart",
                        "latitude": "50.76730000",
                        "longitude": "4.46835000"
                    },
                    {
                        "id": 8826,
                        "name": "Hoeselt",
                        "latitude": "50.84714000",
                        "longitude": "5.48767000"
                    },
                    {
                        "id": 8827,
                        "name": "Holsbeek",
                        "latitude": "50.92097000",
                        "longitude": "4.75747000"
                    },
                    {
                        "id": 8828,
                        "name": "Hooglede",
                        "latitude": "50.98333000",
                        "longitude": "3.08333000"
                    },
                    {
                        "id": 8829,
                        "name": "Hoogstraten",
                        "latitude": "51.40029000",
                        "longitude": "4.76034000"
                    },
                    {
                        "id": 8832,
                        "name": "Houthalen",
                        "latitude": "51.03427000",
                        "longitude": "5.37429000"
                    },
                    {
                        "id": 8833,
                        "name": "Houthulst",
                        "latitude": "50.97824000",
                        "longitude": "2.95050000"
                    },
                    {
                        "id": 8835,
                        "name": "Hove",
                        "latitude": "51.15446000",
                        "longitude": "4.47070000"
                    },
                    {
                        "id": 8836,
                        "name": "Huldenberg",
                        "latitude": "50.78939000",
                        "longitude": "4.58310000"
                    },
                    {
                        "id": 8837,
                        "name": "Hulshout",
                        "latitude": "51.07451000",
                        "longitude": "4.79081000"
                    },
                    {
                        "id": 8840,
                        "name": "Ichtegem",
                        "latitude": "51.09572000",
                        "longitude": "3.01549000"
                    },
                    {
                        "id": 8841,
                        "name": "Ieper",
                        "latitude": "50.85114000",
                        "longitude": "2.88569000"
                    },
                    {
                        "id": 8843,
                        "name": "Ingelmunster",
                        "latitude": "50.92081000",
                        "longitude": "3.25571000"
                    },
                    {
                        "id": 8845,
                        "name": "Izegem",
                        "latitude": "50.91396000",
                        "longitude": "3.21378000"
                    },
                    {
                        "id": 8846,
                        "name": "Jabbeke",
                        "latitude": "51.18185000",
                        "longitude": "3.08935000"
                    },
                    {
                        "id": 8851,
                        "name": "Kalmthout",
                        "latitude": "51.38442000",
                        "longitude": "4.47556000"
                    },
                    {
                        "id": 8852,
                        "name": "Kampenhout",
                        "latitude": "50.94210000",
                        "longitude": "4.55103000"
                    },
                    {
                        "id": 8853,
                        "name": "Kapelle-op-den-Bos",
                        "latitude": "51.00970000",
                        "longitude": "4.36303000"
                    },
                    {
                        "id": 8854,
                        "name": "Kapellen",
                        "latitude": "51.31377000",
                        "longitude": "4.43539000"
                    },
                    {
                        "id": 8855,
                        "name": "Kaprijke",
                        "latitude": "51.21720000",
                        "longitude": "3.61519000"
                    },
                    {
                        "id": 8856,
                        "name": "Kasterlee",
                        "latitude": "51.24118000",
                        "longitude": "4.96651000"
                    },
                    {
                        "id": 8857,
                        "name": "Keerbergen",
                        "latitude": "51.00295000",
                        "longitude": "4.63434000"
                    },
                    {
                        "id": 8858,
                        "name": "Kinrooi",
                        "latitude": "51.14543000",
                        "longitude": "5.74207000"
                    },
                    {
                        "id": 8859,
                        "name": "Knesselare",
                        "latitude": "51.13932000",
                        "longitude": "3.41282000"
                    },
                    {
                        "id": 8860,
                        "name": "Knokke-Heist",
                        "latitude": "51.35000000",
                        "longitude": "3.26667000"
                    },
                    {
                        "id": 8861,
                        "name": "Koekelare",
                        "latitude": "51.09047000",
                        "longitude": "2.97830000"
                    },
                    {
                        "id": 8862,
                        "name": "Koksijde",
                        "latitude": "51.11642000",
                        "longitude": "2.63772000"
                    },
                    {
                        "id": 8863,
                        "name": "Kontich",
                        "latitude": "51.13213000",
                        "longitude": "4.44706000"
                    },
                    {
                        "id": 8864,
                        "name": "Kortemark",
                        "latitude": "51.02951000",
                        "longitude": "3.04112000"
                    },
                    {
                        "id": 8865,
                        "name": "Kortenaken",
                        "latitude": "50.90862000",
                        "longitude": "5.05968000"
                    },
                    {
                        "id": 8866,
                        "name": "Kortenberg",
                        "latitude": "50.88982000",
                        "longitude": "4.54353000"
                    },
                    {
                        "id": 8867,
                        "name": "Kortessem",
                        "latitude": "50.85890000",
                        "longitude": "5.38974000"
                    },
                    {
                        "id": 8868,
                        "name": "Kortrijk",
                        "latitude": "50.82803000",
                        "longitude": "3.26487000"
                    },
                    {
                        "id": 8869,
                        "name": "Kraainem",
                        "latitude": "50.86155000",
                        "longitude": "4.46946000"
                    },
                    {
                        "id": 8870,
                        "name": "Kruibeke",
                        "latitude": "51.17048000",
                        "longitude": "4.31444000"
                    },
                    {
                        "id": 8871,
                        "name": "Kruishoutem",
                        "latitude": "50.90168000",
                        "longitude": "3.52588000"
                    },
                    {
                        "id": 8872,
                        "name": "Kuurne",
                        "latitude": "50.85143000",
                        "longitude": "3.28240000"
                    },
                    {
                        "id": 8878,
                        "name": "Laarne",
                        "latitude": "51.03078000",
                        "longitude": "3.85077000"
                    },
                    {
                        "id": 8879,
                        "name": "Lanaken",
                        "latitude": "50.89318000",
                        "longitude": "5.64680000"
                    },
                    {
                        "id": 8880,
                        "name": "Landen",
                        "latitude": "50.75267000",
                        "longitude": "5.08200000"
                    },
                    {
                        "id": 8881,
                        "name": "Lebbeke",
                        "latitude": "51.00464000",
                        "longitude": "4.13457000"
                    },
                    {
                        "id": 8882,
                        "name": "Lede",
                        "latitude": "50.96626000",
                        "longitude": "3.98594000"
                    },
                    {
                        "id": 8883,
                        "name": "Ledeberg",
                        "latitude": "51.03859000",
                        "longitude": "3.74458000"
                    },
                    {
                        "id": 8884,
                        "name": "Ledegem",
                        "latitude": "50.85785000",
                        "longitude": "3.12409000"
                    },
                    {
                        "id": 8885,
                        "name": "Lendelede",
                        "latitude": "50.88626000",
                        "longitude": "3.23747000"
                    },
                    {
                        "id": 8887,
                        "name": "Leopoldsburg",
                        "latitude": "51.11667000",
                        "longitude": "5.25000000"
                    },
                    {
                        "id": 8889,
                        "name": "Leuven",
                        "latitude": "50.87959000",
                        "longitude": "4.70093000"
                    },
                    {
                        "id": 8891,
                        "name": "Lichtervelde",
                        "latitude": "51.03333000",
                        "longitude": "3.15000000"
                    },
                    {
                        "id": 8892,
                        "name": "Liedekerke",
                        "latitude": "50.86892000",
                        "longitude": "4.08743000"
                    },
                    {
                        "id": 8893,
                        "name": "Lier",
                        "latitude": "51.13128000",
                        "longitude": "4.57041000"
                    },
                    {
                        "id": 8895,
                        "name": "Lille",
                        "latitude": "51.24197000",
                        "longitude": "4.82313000"
                    },
                    {
                        "id": 8898,
                        "name": "Linkebeek",
                        "latitude": "50.76781000",
                        "longitude": "4.33688000"
                    },
                    {
                        "id": 8899,
                        "name": "Lint",
                        "latitude": "51.12707000",
                        "longitude": "4.49669000"
                    },
                    {
                        "id": 8902,
                        "name": "Lochristi",
                        "latitude": "51.09644000",
                        "longitude": "3.83194000"
                    },
                    {
                        "id": 8903,
                        "name": "Lokeren",
                        "latitude": "51.10364000",
                        "longitude": "3.99339000"
                    },
                    {
                        "id": 8904,
                        "name": "Lommel",
                        "latitude": "51.23074000",
                        "longitude": "5.31349000"
                    },
                    {
                        "id": 8905,
                        "name": "Londerzeel",
                        "latitude": "51.00468000",
                        "longitude": "4.30304000"
                    },
                    {
                        "id": 8908,
                        "name": "Lovendegem",
                        "latitude": "51.10168000",
                        "longitude": "3.61298000"
                    },
                    {
                        "id": 8909,
                        "name": "Lubbeek",
                        "latitude": "50.88278000",
                        "longitude": "4.83896000"
                    },
                    {
                        "id": 8910,
                        "name": "Lummen",
                        "latitude": "50.98772000",
                        "longitude": "5.19121000"
                    },
                    {
                        "id": 8912,
                        "name": "Maaseik",
                        "latitude": "51.09802000",
                        "longitude": "5.78379000"
                    },
                    {
                        "id": 8913,
                        "name": "Maasmechelen",
                        "latitude": "50.96545000",
                        "longitude": "5.69452000"
                    },
                    {
                        "id": 8914,
                        "name": "Machelen",
                        "latitude": "50.91061000",
                        "longitude": "4.44174000"
                    },
                    {
                        "id": 8915,
                        "name": "Maldegem",
                        "latitude": "51.20737000",
                        "longitude": "3.44511000"
                    },
                    {
                        "id": 8922,
                        "name": "Mechelen",
                        "latitude": "51.02574000",
                        "longitude": "4.47762000"
                    },
                    {
                        "id": 8923,
                        "name": "Meerhout",
                        "latitude": "51.13210000",
                        "longitude": "5.07842000"
                    },
                    {
                        "id": 8924,
                        "name": "Meise",
                        "latitude": "50.93934000",
                        "longitude": "4.32655000"
                    },
                    {
                        "id": 8926,
                        "name": "Melle",
                        "latitude": "51.00232000",
                        "longitude": "3.80526000"
                    },
                    {
                        "id": 8927,
                        "name": "Menen",
                        "latitude": "50.79722000",
                        "longitude": "3.12245000"
                    },
                    {
                        "id": 8929,
                        "name": "Merchtem",
                        "latitude": "50.95129000",
                        "longitude": "4.23197000"
                    },
                    {
                        "id": 8930,
                        "name": "Merelbeke",
                        "latitude": "50.99447000",
                        "longitude": "3.74621000"
                    },
                    {
                        "id": 8931,
                        "name": "Merksplas",
                        "latitude": "51.35851000",
                        "longitude": "4.86513000"
                    },
                    {
                        "id": 8934,
                        "name": "Meulebeke",
                        "latitude": "50.95136000",
                        "longitude": "3.28804000"
                    },
                    {
                        "id": 8935,
                        "name": "Middelkerke",
                        "latitude": "51.18532000",
                        "longitude": "2.82077000"
                    },
                    {
                        "id": 8937,
                        "name": "Moerbeke",
                        "latitude": "51.17409000",
                        "longitude": "3.93001000"
                    },
                    {
                        "id": 8938,
                        "name": "Mol",
                        "latitude": "51.19188000",
                        "longitude": "5.11662000"
                    },
                    {
                        "id": 8943,
                        "name": "Moorslede",
                        "latitude": "50.89190000",
                        "longitude": "3.06117000"
                    },
                    {
                        "id": 8945,
                        "name": "Mortsel",
                        "latitude": "51.16697000",
                        "longitude": "4.45127000"
                    },
                    {
                        "id": 8951,
                        "name": "Nazareth",
                        "latitude": "50.95686000",
                        "longitude": "3.59425000"
                    },
                    {
                        "id": 8952,
                        "name": "Neerpelt",
                        "latitude": "51.22807000",
                        "longitude": "5.44270000"
                    },
                    {
                        "id": 8954,
                        "name": "Nevele",
                        "latitude": "51.03531000",
                        "longitude": "3.54574000"
                    },
                    {
                        "id": 8955,
                        "name": "Niel",
                        "latitude": "51.11096000",
                        "longitude": "4.33428000"
                    },
                    {
                        "id": 8956,
                        "name": "Nieuwerkerken",
                        "latitude": "50.86380000",
                        "longitude": "5.19467000"
                    },
                    {
                        "id": 8957,
                        "name": "Nieuwpoort",
                        "latitude": "51.13008000",
                        "longitude": "2.75135000"
                    },
                    {
                        "id": 8958,
                        "name": "Nijlen",
                        "latitude": "51.16096000",
                        "longitude": "4.67008000"
                    },
                    {
                        "id": 8959,
                        "name": "Ninove",
                        "latitude": "50.82776000",
                        "longitude": "4.02657000"
                    },
                    {
                        "id": 8963,
                        "name": "Olen",
                        "latitude": "51.14391000",
                        "longitude": "4.85980000"
                    },
                    {
                        "id": 8966,
                        "name": "Oostduinkerke",
                        "latitude": "51.11565000",
                        "longitude": "2.68217000"
                    },
                    {
                        "id": 8967,
                        "name": "Oosterzele",
                        "latitude": "50.95261000",
                        "longitude": "3.79826000"
                    },
                    {
                        "id": 8968,
                        "name": "Oostkamp",
                        "latitude": "51.15432000",
                        "longitude": "3.23128000"
                    },
                    {
                        "id": 8969,
                        "name": "Oostmalle",
                        "latitude": "51.30000000",
                        "longitude": "4.73333000"
                    },
                    {
                        "id": 8970,
                        "name": "Oostrozebeke",
                        "latitude": "50.92093000",
                        "longitude": "3.33799000"
                    },
                    {
                        "id": 8971,
                        "name": "Opglabbeek",
                        "latitude": "51.04258000",
                        "longitude": "5.58346000"
                    },
                    {
                        "id": 8972,
                        "name": "Opwijk",
                        "latitude": "50.96724000",
                        "longitude": "4.18442000"
                    },
                    {
                        "id": 8974,
                        "name": "Ostend",
                        "latitude": "51.21551000",
                        "longitude": "2.92700000"
                    },
                    {
                        "id": 8976,
                        "name": "Oud-Heverlee",
                        "latitude": "50.83522000",
                        "longitude": "4.66421000"
                    },
                    {
                        "id": 8977,
                        "name": "Oud-Turnhout",
                        "latitude": "51.31978000",
                        "longitude": "4.98410000"
                    },
                    {
                        "id": 8978,
                        "name": "Oudenaarde",
                        "latitude": "50.85168000",
                        "longitude": "3.60891000"
                    },
                    {
                        "id": 8979,
                        "name": "Oudenburg",
                        "latitude": "51.18489000",
                        "longitude": "3.00035000"
                    },
                    {
                        "id": 8982,
                        "name": "Overijse",
                        "latitude": "50.77436000",
                        "longitude": "4.53461000"
                    },
                    {
                        "id": 8983,
                        "name": "Overpelt",
                        "latitude": "51.21038000",
                        "longitude": "5.41557000"
                    },
                    {
                        "id": 8986,
                        "name": "Peer",
                        "latitude": "51.13030000",
                        "longitude": "5.45952000"
                    },
                    {
                        "id": 8987,
                        "name": "Pepingen",
                        "latitude": "50.75922000",
                        "longitude": "4.15983000"
                    },
                    {
                        "id": 8989,
                        "name": "Perre",
                        "latitude": "50.88914000",
                        "longitude": "3.86098000"
                    },
                    {
                        "id": 8992,
                        "name": "Pittem",
                        "latitude": "50.99279000",
                        "longitude": "3.26317000"
                    },
                    {
                        "id": 8995,
                        "name": "Poperinge",
                        "latitude": "50.85386000",
                        "longitude": "2.72659000"
                    },
                    {
                        "id": 9002,
                        "name": "Provincie Antwerpen",
                        "latitude": "51.16558000",
                        "longitude": "4.83402000"
                    },
                    {
                        "id": 9003,
                        "name": "Provincie Limburg",
                        "latitude": "51.00000000",
                        "longitude": "5.50000000"
                    },
                    {
                        "id": 9004,
                        "name": "Provincie Oost-Vlaanderen",
                        "latitude": "51.00000000",
                        "longitude": "3.75000000"
                    },
                    {
                        "id": 9005,
                        "name": "Provincie Vlaams-Brabant",
                        "latitude": "50.91667000",
                        "longitude": "4.58333000"
                    },
                    {
                        "id": 9006,
                        "name": "Provincie West-Vlaanderen",
                        "latitude": "51.00000000",
                        "longitude": "3.00000000"
                    },
                    {
                        "id": 9007,
                        "name": "Putte",
                        "latitude": "51.05337000",
                        "longitude": "4.63263000"
                    },
                    {
                        "id": 9008,
                        "name": "Puurs",
                        "latitude": "51.07409000",
                        "longitude": "4.28844000"
                    },
                    {
                        "id": 9015,
                        "name": "Ranst",
                        "latitude": "51.18983000",
                        "longitude": "4.56533000"
                    },
                    {
                        "id": 9016,
                        "name": "Ravels",
                        "latitude": "51.37274000",
                        "longitude": "4.99210000"
                    },
                    {
                        "id": 9020,
                        "name": "Retie",
                        "latitude": "51.26652000",
                        "longitude": "5.08242000"
                    },
                    {
                        "id": 9021,
                        "name": "Riemst",
                        "latitude": "50.80995000",
                        "longitude": "5.60131000"
                    },
                    {
                        "id": 9022,
                        "name": "Rijkevorsel",
                        "latitude": "51.34795000",
                        "longitude": "4.76053000"
                    },
                    {
                        "id": 9025,
                        "name": "Roeselare",
                        "latitude": "50.94653000",
                        "longitude": "3.12269000"
                    },
                    {
                        "id": 9027,
                        "name": "Ronse",
                        "latitude": "50.74574000",
                        "longitude": "3.60050000"
                    },
                    {
                        "id": 9028,
                        "name": "Rotselaar",
                        "latitude": "50.95302000",
                        "longitude": "4.71665000"
                    },
                    {
                        "id": 9030,
                        "name": "Ruiselede",
                        "latitude": "51.04039000",
                        "longitude": "3.39416000"
                    },
                    {
                        "id": 9032,
                        "name": "Rumst",
                        "latitude": "51.08153000",
                        "longitude": "4.42217000"
                    },
                    {
                        "id": 9039,
                        "name": "Schelle",
                        "latitude": "51.12615000",
                        "longitude": "4.34114000"
                    },
                    {
                        "id": 9040,
                        "name": "Schilde",
                        "latitude": "51.24107000",
                        "longitude": "4.58336000"
                    },
                    {
                        "id": 9041,
                        "name": "Schoten",
                        "latitude": "51.25251000",
                        "longitude": "4.50268000"
                    },
                    {
                        "id": 9045,
                        "name": "Sint-Amands",
                        "latitude": "51.05645000",
                        "longitude": "4.20957000"
                    },
                    {
                        "id": 9046,
                        "name": "Sint-Genesius-Rode",
                        "latitude": "50.74645000",
                        "longitude": "4.35754000"
                    },
                    {
                        "id": 9047,
                        "name": "Sint-Gillis-Waas",
                        "latitude": "51.21914000",
                        "longitude": "4.12374000"
                    },
                    {
                        "id": 9048,
                        "name": "Sint-Joris",
                        "latitude": "50.87117000",
                        "longitude": "5.27200000"
                    },
                    {
                        "id": 9049,
                        "name": "Sint-Katelijne-Waver",
                        "latitude": "51.06691000",
                        "longitude": "4.53469000"
                    },
                    {
                        "id": 9050,
                        "name": "Sint-Kruis",
                        "latitude": "51.21399000",
                        "longitude": "3.24949000"
                    },
                    {
                        "id": 9051,
                        "name": "Sint-Laureins",
                        "latitude": "51.24202000",
                        "longitude": "3.52441000"
                    },
                    {
                        "id": 9052,
                        "name": "Sint-Lievens-Houtem",
                        "latitude": "50.91970000",
                        "longitude": "3.86225000"
                    },
                    {
                        "id": 9053,
                        "name": "Sint-Maria-Lierde",
                        "latitude": "50.81867000",
                        "longitude": "3.84436000"
                    },
                    {
                        "id": 9054,
                        "name": "Sint-Martens-Latem",
                        "latitude": "51.01459000",
                        "longitude": "3.63779000"
                    },
                    {
                        "id": 9055,
                        "name": "Sint-Martens-Lennik",
                        "latitude": "50.81158000",
                        "longitude": "4.16965000"
                    },
                    {
                        "id": 9056,
                        "name": "Sint-Niklaas",
                        "latitude": "51.16509000",
                        "longitude": "4.14370000"
                    },
                    {
                        "id": 9057,
                        "name": "Sint-Pieters-Leeuw",
                        "latitude": "50.77926000",
                        "longitude": "4.24355000"
                    },
                    {
                        "id": 9058,
                        "name": "Sint-Pieters-Voeren",
                        "latitude": "50.73863000",
                        "longitude": "5.82224000"
                    },
                    {
                        "id": 9059,
                        "name": "Sint-Truiden",
                        "latitude": "50.81679000",
                        "longitude": "5.18647000"
                    },
                    {
                        "id": 9066,
                        "name": "Stabroek",
                        "latitude": "51.33189000",
                        "longitude": "4.37127000"
                    },
                    {
                        "id": 9067,
                        "name": "Staden",
                        "latitude": "50.97456000",
                        "longitude": "3.01469000"
                    },
                    {
                        "id": 9069,
                        "name": "Steenokkerzeel",
                        "latitude": "50.91851000",
                        "longitude": "4.50989000"
                    },
                    {
                        "id": 9070,
                        "name": "Stekene",
                        "latitude": "51.20990000",
                        "longitude": "4.03651000"
                    },
                    {
                        "id": 9073,
                        "name": "Temse",
                        "latitude": "51.12794000",
                        "longitude": "4.21372000"
                    },
                    {
                        "id": 9075,
                        "name": "Terkoest",
                        "latitude": "50.89832000",
                        "longitude": "5.27623000"
                    },
                    {
                        "id": 9076,
                        "name": "Ternat",
                        "latitude": "50.86654000",
                        "longitude": "4.16682000"
                    },
                    {
                        "id": 9077,
                        "name": "Tervuren",
                        "latitude": "50.82372000",
                        "longitude": "4.51418000"
                    },
                    {
                        "id": 9078,
                        "name": "Tessenderlo",
                        "latitude": "51.06513000",
                        "longitude": "5.08856000"
                    },
                    {
                        "id": 9081,
                        "name": "Tielt",
                        "latitude": "50.99931000",
                        "longitude": "3.32707000"
                    },
                    {
                        "id": 9082,
                        "name": "Tienen",
                        "latitude": "50.80745000",
                        "longitude": "4.93780000"
                    },
                    {
                        "id": 9085,
                        "name": "Tongeren",
                        "latitude": "50.78054000",
                        "longitude": "5.46484000"
                    },
                    {
                        "id": 9086,
                        "name": "Torhout",
                        "latitude": "51.06560000",
                        "longitude": "3.10085000"
                    },
                    {
                        "id": 9088,
                        "name": "Tremelo",
                        "latitude": "50.99231000",
                        "longitude": "4.70807000"
                    },
                    {
                        "id": 9092,
                        "name": "Turnhout",
                        "latitude": "51.32254000",
                        "longitude": "4.94471000"
                    },
                    {
                        "id": 9096,
                        "name": "Veurne",
                        "latitude": "51.07316000",
                        "longitude": "2.66803000"
                    },
                    {
                        "id": 9100,
                        "name": "Vilvoorde",
                        "latitude": "50.92814000",
                        "longitude": "4.42938000"
                    },
                    {
                        "id": 9103,
                        "name": "Vorselaar",
                        "latitude": "51.20243000",
                        "longitude": "4.77259000"
                    },
                    {
                        "id": 9104,
                        "name": "Vosselaar",
                        "latitude": "51.30856000",
                        "longitude": "4.88960000"
                    },
                    {
                        "id": 9105,
                        "name": "Waarschoot",
                        "latitude": "51.15250000",
                        "longitude": "3.60500000"
                    },
                    {
                        "id": 9106,
                        "name": "Waasmunster",
                        "latitude": "51.10572000",
                        "longitude": "4.08573000"
                    },
                    {
                        "id": 9107,
                        "name": "Wachtebeke",
                        "latitude": "51.16852000",
                        "longitude": "3.87183000"
                    },
                    {
                        "id": 9112,
                        "name": "Waregem",
                        "latitude": "50.88898000",
                        "longitude": "3.42756000"
                    },
                    {
                        "id": 9118,
                        "name": "Wellen",
                        "latitude": "50.84096000",
                        "longitude": "5.33867000"
                    },
                    {
                        "id": 9120,
                        "name": "Wemmel",
                        "latitude": "50.90812000",
                        "longitude": "4.30613000"
                    },
                    {
                        "id": 9121,
                        "name": "Wenduine",
                        "latitude": "51.29830000",
                        "longitude": "3.08213000"
                    },
                    {
                        "id": 9122,
                        "name": "Wervik",
                        "latitude": "50.78069000",
                        "longitude": "3.03854000"
                    },
                    {
                        "id": 9123,
                        "name": "Westerlo",
                        "latitude": "51.09049000",
                        "longitude": "4.91544000"
                    },
                    {
                        "id": 9124,
                        "name": "Wetteren",
                        "latitude": "51.00526000",
                        "longitude": "3.88341000"
                    },
                    {
                        "id": 9125,
                        "name": "Wevelgem",
                        "latitude": "50.80000000",
                        "longitude": "3.16667000"
                    },
                    {
                        "id": 9126,
                        "name": "Wezembeek-Oppem",
                        "latitude": "50.83950000",
                        "longitude": "4.49427000"
                    },
                    {
                        "id": 9127,
                        "name": "Wichelen",
                        "latitude": "51.00526000",
                        "longitude": "3.97683000"
                    },
                    {
                        "id": 9128,
                        "name": "Wielsbeke",
                        "latitude": "50.90000000",
                        "longitude": "3.36667000"
                    },
                    {
                        "id": 9129,
                        "name": "Wijnegem",
                        "latitude": "51.22787000",
                        "longitude": "4.51895000"
                    },
                    {
                        "id": 9130,
                        "name": "Willebroek",
                        "latitude": "51.06041000",
                        "longitude": "4.36019000"
                    },
                    {
                        "id": 9131,
                        "name": "Wingene",
                        "latitude": "51.05782000",
                        "longitude": "3.27359000"
                    },
                    {
                        "id": 9132,
                        "name": "Wommelgem",
                        "latitude": "51.20452000",
                        "longitude": "4.52250000"
                    },
                    {
                        "id": 9133,
                        "name": "Wuustwezel",
                        "latitude": "51.39214000",
                        "longitude": "4.59546000"
                    },
                    {
                        "id": 9135,
                        "name": "Zandhoven",
                        "latitude": "51.21488000",
                        "longitude": "4.66164000"
                    },
                    {
                        "id": 9136,
                        "name": "Zaventem",
                        "latitude": "50.88365000",
                        "longitude": "4.47298000"
                    },
                    {
                        "id": 9137,
                        "name": "Zedelgem",
                        "latitude": "51.14236000",
                        "longitude": "3.13680000"
                    },
                    {
                        "id": 9138,
                        "name": "Zeebrugge",
                        "latitude": "51.32901000",
                        "longitude": "3.18188000"
                    },
                    {
                        "id": 9139,
                        "name": "Zele",
                        "latitude": "51.06566000",
                        "longitude": "4.04030000"
                    },
                    {
                        "id": 9140,
                        "name": "Zelzate",
                        "latitude": "51.18963000",
                        "longitude": "3.80777000"
                    },
                    {
                        "id": 9141,
                        "name": "Zemst",
                        "latitude": "50.98318000",
                        "longitude": "4.46079000"
                    },
                    {
                        "id": 9142,
                        "name": "Zingem",
                        "latitude": "50.90409000",
                        "longitude": "3.65305000"
                    },
                    {
                        "id": 9143,
                        "name": "Zoersel",
                        "latitude": "51.26825000",
                        "longitude": "4.71296000"
                    },
                    {
                        "id": 9144,
                        "name": "Zomergem",
                        "latitude": "51.11994000",
                        "longitude": "3.56496000"
                    },
                    {
                        "id": 9145,
                        "name": "Zonhoven",
                        "latitude": "50.99064000",
                        "longitude": "5.36819000"
                    },
                    {
                        "id": 9146,
                        "name": "Zonnebeke",
                        "latitude": "50.87260000",
                        "longitude": "2.98725000"
                    },
                    {
                        "id": 9147,
                        "name": "Zottegem",
                        "latitude": "50.86955000",
                        "longitude": "3.81052000"
                    },
                    {
                        "id": 9148,
                        "name": "Zoutleeuw",
                        "latitude": "50.83316000",
                        "longitude": "5.10376000"
                    },
                    {
                        "id": 9149,
                        "name": "Zuienkerke",
                        "latitude": "51.26511000",
                        "longitude": "3.15506000"
                    },
                    {
                        "id": 9150,
                        "name": "Zulte",
                        "latitude": "50.91954000",
                        "longitude": "3.44859000"
                    },
                    {
                        "id": 9151,
                        "name": "Zutendaal",
                        "latitude": "50.93306000",
                        "longitude": "5.57530000"
                    },
                    {
                        "id": 9152,
                        "name": "Zwevegem",
                        "latitude": "50.81268000",
                        "longitude": "3.33848000"
                    },
                    {
                        "id": 9153,
                        "name": "Zwijndrecht",
                        "latitude": "51.21979000",
                        "longitude": "4.32664000"
                    }
                ]
            },
            {
                "id": 1374,
                "name": "Flemish Brabant",
                "iso2": "VBR",
                "latitude": "50.88154340",
                "longitude": "4.56459700",
                "type": "province",
                "cities": []
            },
            {
                "id": 1375,
                "name": "Hainaut",
                "iso2": "WHT",
                "latitude": "50.52570760",
                "longitude": "4.06210170",
                "type": "province",
                "cities": []
            },
            {
                "id": 1384,
                "name": "Liège",
                "iso2": "WLG",
                "latitude": "50.63255740",
                "longitude": "5.57966620",
                "type": "province",
                "cities": []
            },
            {
                "id": 1372,
                "name": "Limburg",
                "iso2": "VLI",
                "latitude": "50.99594620",
                "longitude": "4.78626450",
                "type": "province",
                "cities": []
            },
            {
                "id": 1379,
                "name": "Luxembourg",
                "iso2": "WLX",
                "latitude": "49.96500000",
                "longitude": "5.50100000",
                "type": "province",
                "cities": []
            },
            {
                "id": 1378,
                "name": "Namur",
                "iso2": "WNA",
                "latitude": "50.46738830",
                "longitude": "4.87198540",
                "type": "province",
                "cities": []
            },
            {
                "id": 1380,
                "name": "Wallonia",
                "iso2": "WAL",
                "latitude": "50.41756370",
                "longitude": "4.45100660",
                "type": "region",
                "cities": [
                    {
                        "id": 8612,
                        "name": "Aiseau",
                        "latitude": "50.41158000",
                        "longitude": "4.58671000"
                    },
                    {
                        "id": 8615,
                        "name": "Amay",
                        "latitude": "50.54829000",
                        "longitude": "5.30974000"
                    },
                    {
                        "id": 8616,
                        "name": "Amblève",
                        "latitude": "50.35357000",
                        "longitude": "6.17002000"
                    },
                    {
                        "id": 8617,
                        "name": "Andenne",
                        "latitude": "50.48941000",
                        "longitude": "5.09513000"
                    },
                    {
                        "id": 8618,
                        "name": "Anderlues",
                        "latitude": "50.40704000",
                        "longitude": "4.27136000"
                    },
                    {
                        "id": 8619,
                        "name": "Anhée",
                        "latitude": "50.31039000",
                        "longitude": "4.87827000"
                    },
                    {
                        "id": 8620,
                        "name": "Ans",
                        "latitude": "50.66230000",
                        "longitude": "5.52029000"
                    },
                    {
                        "id": 8621,
                        "name": "Anthisnes",
                        "latitude": "50.48323000",
                        "longitude": "5.51900000"
                    },
                    {
                        "id": 8622,
                        "name": "Antoing",
                        "latitude": "50.56765000",
                        "longitude": "3.44920000"
                    },
                    {
                        "id": 8627,
                        "name": "Arlon",
                        "latitude": "49.68333000",
                        "longitude": "5.81667000"
                    },
                    {
                        "id": 8631,
                        "name": "Assesse",
                        "latitude": "50.36934000",
                        "longitude": "5.02204000"
                    },
                    {
                        "id": 8632,
                        "name": "Ath",
                        "latitude": "50.62937000",
                        "longitude": "3.77801000"
                    },
                    {
                        "id": 8633,
                        "name": "Attert",
                        "latitude": "49.75035000",
                        "longitude": "5.78634000"
                    },
                    {
                        "id": 8634,
                        "name": "Aubange",
                        "latitude": "49.56652000",
                        "longitude": "5.80492000"
                    },
                    {
                        "id": 8635,
                        "name": "Aubel",
                        "latitude": "50.70189000",
                        "longitude": "5.85812000"
                    },
                    {
                        "id": 8637,
                        "name": "Awans",
                        "latitude": "50.66774000",
                        "longitude": "5.46329000"
                    },
                    {
                        "id": 8638,
                        "name": "Aywaille",
                        "latitude": "50.47411000",
                        "longitude": "5.67684000"
                    },
                    {
                        "id": 8640,
                        "name": "Baelen",
                        "latitude": "50.63131000",
                        "longitude": "5.97433000"
                    },
                    {
                        "id": 8642,
                        "name": "Basse Lasne",
                        "latitude": "50.69503000",
                        "longitude": "4.49218000"
                    },
                    {
                        "id": 8643,
                        "name": "Bassenge",
                        "latitude": "50.75883000",
                        "longitude": "5.60989000"
                    },
                    {
                        "id": 8644,
                        "name": "Bastogne",
                        "latitude": "50.00347000",
                        "longitude": "5.71844000"
                    },
                    {
                        "id": 8645,
                        "name": "Beaumont",
                        "latitude": "50.23699000",
                        "longitude": "4.23926000"
                    },
                    {
                        "id": 8646,
                        "name": "Beauraing",
                        "latitude": "50.11042000",
                        "longitude": "4.95554000"
                    },
                    {
                        "id": 8647,
                        "name": "Beauvechain",
                        "latitude": "50.78195000",
                        "longitude": "4.77180000"
                    },
                    {
                        "id": 8653,
                        "name": "Beloeil",
                        "latitude": "50.55047000",
                        "longitude": "3.73484000"
                    },
                    {
                        "id": 8657,
                        "name": "Berloz",
                        "latitude": "50.69829000",
                        "longitude": "5.21236000"
                    },
                    {
                        "id": 8658,
                        "name": "Bernissart",
                        "latitude": "50.47460000",
                        "longitude": "3.64961000"
                    },
                    {
                        "id": 8660,
                        "name": "Bertogne",
                        "latitude": "50.08364000",
                        "longitude": "5.66689000"
                    },
                    {
                        "id": 8661,
                        "name": "Bertrix",
                        "latitude": "49.85596000",
                        "longitude": "5.25539000"
                    },
                    {
                        "id": 8664,
                        "name": "Beyne-Heusay",
                        "latitude": "50.62251000",
                        "longitude": "5.66508000"
                    },
                    {
                        "id": 8668,
                        "name": "Bièvre",
                        "latitude": "49.94085000",
                        "longitude": "5.01591000"
                    },
                    {
                        "id": 8667,
                        "name": "Binche",
                        "latitude": "50.41155000",
                        "longitude": "4.16469000"
                    },
                    {
                        "id": 8670,
                        "name": "Blégny",
                        "latitude": "50.67255000",
                        "longitude": "5.72508000"
                    },
                    {
                        "id": 8679,
                        "name": "Bouillon",
                        "latitude": "49.79324000",
                        "longitude": "5.06703000"
                    },
                    {
                        "id": 8680,
                        "name": "Boussu",
                        "latitude": "50.43417000",
                        "longitude": "3.79440000"
                    },
                    {
                        "id": 8682,
                        "name": "Braine-l'Alleud",
                        "latitude": "50.68363000",
                        "longitude": "4.36784000"
                    },
                    {
                        "id": 8683,
                        "name": "Braine-le-Château",
                        "latitude": "50.67990000",
                        "longitude": "4.27385000"
                    },
                    {
                        "id": 8684,
                        "name": "Braine-le-Comte",
                        "latitude": "50.60979000",
                        "longitude": "4.14658000"
                    },
                    {
                        "id": 8685,
                        "name": "Braives",
                        "latitude": "50.61745000",
                        "longitude": "5.13302000"
                    },
                    {
                        "id": 8690,
                        "name": "Brugelette",
                        "latitude": "50.59577000",
                        "longitude": "3.85363000"
                    },
                    {
                        "id": 8692,
                        "name": "Brunehault",
                        "latitude": "50.50524000",
                        "longitude": "4.43209000"
                    },
                    {
                        "id": 8695,
                        "name": "Bullange",
                        "latitude": "50.40731000",
                        "longitude": "6.25749000"
                    },
                    {
                        "id": 8696,
                        "name": "Burdinne",
                        "latitude": "50.58454000",
                        "longitude": "5.07663000"
                    },
                    {
                        "id": 8697,
                        "name": "Butgenbach",
                        "latitude": "50.42689000",
                        "longitude": "6.20504000"
                    },
                    {
                        "id": 8698,
                        "name": "Celles",
                        "latitude": "50.71229000",
                        "longitude": "3.45733000"
                    },
                    {
                        "id": 8699,
                        "name": "Cerfontaine",
                        "latitude": "50.17047000",
                        "longitude": "4.41028000"
                    },
                    {
                        "id": 8700,
                        "name": "Chapelle-lez-Herlaimont",
                        "latitude": "50.47130000",
                        "longitude": "4.28227000"
                    },
                    {
                        "id": 8701,
                        "name": "Charleroi",
                        "latitude": "50.41136000",
                        "longitude": "4.44448000"
                    },
                    {
                        "id": 8702,
                        "name": "Chastre-Villeroux-Blanmont",
                        "latitude": "50.60857000",
                        "longitude": "4.64198000"
                    },
                    {
                        "id": 8708,
                        "name": "Châtelet",
                        "latitude": "50.40338000",
                        "longitude": "4.52826000"
                    },
                    {
                        "id": 8703,
                        "name": "Chaudfontaine",
                        "latitude": "50.58280000",
                        "longitude": "5.63410000"
                    },
                    {
                        "id": 8704,
                        "name": "Chaumont-Gistoux",
                        "latitude": "50.67753000",
                        "longitude": "4.72120000"
                    },
                    {
                        "id": 8707,
                        "name": "Chièvres",
                        "latitude": "50.58787000",
                        "longitude": "3.80711000"
                    },
                    {
                        "id": 8705,
                        "name": "Chimay",
                        "latitude": "50.04856000",
                        "longitude": "4.31712000"
                    },
                    {
                        "id": 8706,
                        "name": "Chiny",
                        "latitude": "49.73833000",
                        "longitude": "5.34104000"
                    },
                    {
                        "id": 8709,
                        "name": "Ciney",
                        "latitude": "50.29449000",
                        "longitude": "5.10015000"
                    },
                    {
                        "id": 8710,
                        "name": "Clavier",
                        "latitude": "50.40069000",
                        "longitude": "5.35154000"
                    },
                    {
                        "id": 8711,
                        "name": "Colfontaine",
                        "latitude": "50.41410000",
                        "longitude": "3.85569000"
                    },
                    {
                        "id": 8712,
                        "name": "Comblain-au-Pont",
                        "latitude": "50.47488000",
                        "longitude": "5.57711000"
                    },
                    {
                        "id": 8713,
                        "name": "Courcelles",
                        "latitude": "50.46379000",
                        "longitude": "4.37470000"
                    },
                    {
                        "id": 8714,
                        "name": "Court-Saint-Étienne",
                        "latitude": "50.63378000",
                        "longitude": "4.56851000"
                    },
                    {
                        "id": 8715,
                        "name": "Couvin",
                        "latitude": "50.05284000",
                        "longitude": "4.49495000"
                    },
                    {
                        "id": 8716,
                        "name": "Crisnée",
                        "latitude": "50.71703000",
                        "longitude": "5.39802000"
                    },
                    {
                        "id": 8717,
                        "name": "Dalhem",
                        "latitude": "50.71315000",
                        "longitude": "5.72774000"
                    },
                    {
                        "id": 8719,
                        "name": "Daverdisse",
                        "latitude": "50.02161000",
                        "longitude": "5.11811000"
                    },
                    {
                        "id": 8736,
                        "name": "Dinant",
                        "latitude": "50.25807000",
                        "longitude": "4.91166000"
                    },
                    {
                        "id": 8737,
                        "name": "Dison",
                        "latitude": "50.61004000",
                        "longitude": "5.85340000"
                    },
                    {
                        "id": 8738,
                        "name": "Doische",
                        "latitude": "50.13356000",
                        "longitude": "4.73545000"
                    },
                    {
                        "id": 8739,
                        "name": "Donceel",
                        "latitude": "50.64827000",
                        "longitude": "5.32000000"
                    },
                    {
                        "id": 8740,
                        "name": "Dour",
                        "latitude": "50.39583000",
                        "longitude": "3.77792000"
                    },
                    {
                        "id": 8743,
                        "name": "Durbuy",
                        "latitude": "50.35291000",
                        "longitude": "5.45631000"
                    },
                    {
                        "id": 9154,
                        "name": "Écaussinnes-d’Enghien",
                        "latitude": "50.56822000",
                        "longitude": "4.16580000"
                    },
                    {
                        "id": 9155,
                        "name": "Éghezée",
                        "latitude": "50.59076000",
                        "longitude": "4.91175000"
                    },
                    {
                        "id": 8746,
                        "name": "Ellezelles",
                        "latitude": "50.73512000",
                        "longitude": "3.67985000"
                    },
                    {
                        "id": 8747,
                        "name": "Enghien",
                        "latitude": "50.68373000",
                        "longitude": "4.03284000"
                    },
                    {
                        "id": 8748,
                        "name": "Engis",
                        "latitude": "50.58156000",
                        "longitude": "5.39916000"
                    },
                    {
                        "id": 9156,
                        "name": "Érezée",
                        "latitude": "50.29292000",
                        "longitude": "5.55815000"
                    },
                    {
                        "id": 8749,
                        "name": "Erquelinnes",
                        "latitude": "50.30688000",
                        "longitude": "4.11129000"
                    },
                    {
                        "id": 8750,
                        "name": "Esneux",
                        "latitude": "50.53596000",
                        "longitude": "5.56775000"
                    },
                    {
                        "id": 8752,
                        "name": "Estaimpuis",
                        "latitude": "50.70485000",
                        "longitude": "3.26785000"
                    },
                    {
                        "id": 8753,
                        "name": "Estinnes-au-Val",
                        "latitude": "50.41016000",
                        "longitude": "4.10477000"
                    },
                    {
                        "id": 9157,
                        "name": "Étalle",
                        "latitude": "49.67385000",
                        "longitude": "5.60019000"
                    },
                    {
                        "id": 8754,
                        "name": "Eupen",
                        "latitude": "50.62790000",
                        "longitude": "6.03647000"
                    },
                    {
                        "id": 8756,
                        "name": "Faimes",
                        "latitude": "50.66252000",
                        "longitude": "5.26005000"
                    },
                    {
                        "id": 8757,
                        "name": "Farciennes",
                        "latitude": "50.43006000",
                        "longitude": "4.54152000"
                    },
                    {
                        "id": 8758,
                        "name": "Fauvillers",
                        "latitude": "49.85116000",
                        "longitude": "5.66405000"
                    },
                    {
                        "id": 8759,
                        "name": "Ferrières",
                        "latitude": "50.40157000",
                        "longitude": "5.61092000"
                    },
                    {
                        "id": 8760,
                        "name": "Fexhe-le-Haut-Clocher",
                        "latitude": "50.66540000",
                        "longitude": "5.39978000"
                    },
                    {
                        "id": 8766,
                        "name": "Flémalle-Haute",
                        "latitude": "50.59994000",
                        "longitude": "5.44471000"
                    },
                    {
                        "id": 8767,
                        "name": "Fléron",
                        "latitude": "50.61516000",
                        "longitude": "5.68062000"
                    },
                    {
                        "id": 8761,
                        "name": "Fleurus",
                        "latitude": "50.48351000",
                        "longitude": "4.55006000"
                    },
                    {
                        "id": 8762,
                        "name": "Flobecq",
                        "latitude": "50.73733000",
                        "longitude": "3.73876000"
                    },
                    {
                        "id": 8763,
                        "name": "Floreffe",
                        "latitude": "50.43452000",
                        "longitude": "4.75960000"
                    },
                    {
                        "id": 8764,
                        "name": "Florennes",
                        "latitude": "50.25127000",
                        "longitude": "4.60636000"
                    },
                    {
                        "id": 8765,
                        "name": "Florenville",
                        "latitude": "49.69983000",
                        "longitude": "5.30740000"
                    },
                    {
                        "id": 8768,
                        "name": "Forville",
                        "latitude": "50.57424000",
                        "longitude": "4.99861000"
                    },
                    {
                        "id": 8769,
                        "name": "Fosses-la-Ville",
                        "latitude": "50.39517000",
                        "longitude": "4.69623000"
                    },
                    {
                        "id": 8770,
                        "name": "Frameries",
                        "latitude": "50.40578000",
                        "longitude": "3.89603000"
                    },
                    {
                        "id": 8771,
                        "name": "Frasnes-lez-Buissenal",
                        "latitude": "50.66783000",
                        "longitude": "3.62047000"
                    },
                    {
                        "id": 8772,
                        "name": "Froidchapelle",
                        "latitude": "50.15106000",
                        "longitude": "4.32742000"
                    },
                    {
                        "id": 8775,
                        "name": "Gedinne",
                        "latitude": "49.98037000",
                        "longitude": "4.93674000"
                    },
                    {
                        "id": 8777,
                        "name": "Geer",
                        "latitude": "50.66990000",
                        "longitude": "5.17364000"
                    },
                    {
                        "id": 8779,
                        "name": "Gembloux",
                        "latitude": "50.56149000",
                        "longitude": "4.69889000"
                    },
                    {
                        "id": 8780,
                        "name": "Genappe",
                        "latitude": "50.61173000",
                        "longitude": "4.45152000"
                    },
                    {
                        "id": 8784,
                        "name": "Gerpinnes",
                        "latitude": "50.33789000",
                        "longitude": "4.52731000"
                    },
                    {
                        "id": 8785,
                        "name": "Gesves",
                        "latitude": "50.40146000",
                        "longitude": "5.07457000"
                    },
                    {
                        "id": 8790,
                        "name": "Gouvy",
                        "latitude": "50.18600000",
                        "longitude": "5.93917000"
                    },
                    {
                        "id": 8791,
                        "name": "Grez-Doiceau",
                        "latitude": "50.73901000",
                        "longitude": "4.69829000"
                    },
                    {
                        "id": 8796,
                        "name": "Habay-la-Vieille",
                        "latitude": "49.72329000",
                        "longitude": "5.61999000"
                    },
                    {
                        "id": 8800,
                        "name": "Hamoir",
                        "latitude": "50.42675000",
                        "longitude": "5.53304000"
                    },
                    {
                        "id": 8801,
                        "name": "Hamois",
                        "latitude": "50.34020000",
                        "longitude": "5.15619000"
                    },
                    {
                        "id": 8802,
                        "name": "Hannut",
                        "latitude": "50.67142000",
                        "longitude": "5.07898000"
                    },
                    {
                        "id": 8805,
                        "name": "Hastière-Lavaux",
                        "latitude": "50.21849000",
                        "longitude": "4.82446000"
                    },
                    {
                        "id": 8806,
                        "name": "Havelange",
                        "latitude": "50.38931000",
                        "longitude": "5.23816000"
                    },
                    {
                        "id": 8811,
                        "name": "Hensies",
                        "latitude": "50.43263000",
                        "longitude": "3.68411000"
                    },
                    {
                        "id": 8812,
                        "name": "Herbeumont",
                        "latitude": "49.78086000",
                        "longitude": "5.23580000"
                    },
                    {
                        "id": 8839,
                        "name": "Héron",
                        "latitude": "50.54731000",
                        "longitude": "5.09774000"
                    },
                    {
                        "id": 8819,
                        "name": "Herstal",
                        "latitude": "50.66415000",
                        "longitude": "5.62346000"
                    },
                    {
                        "id": 8820,
                        "name": "Herve",
                        "latitude": "50.64083000",
                        "longitude": "5.79353000"
                    },
                    {
                        "id": 8830,
                        "name": "Hotton",
                        "latitude": "50.26742000",
                        "longitude": "5.44609000"
                    },
                    {
                        "id": 8831,
                        "name": "Houffalize",
                        "latitude": "50.13235000",
                        "longitude": "5.78962000"
                    },
                    {
                        "id": 8834,
                        "name": "Houyet",
                        "latitude": "50.18619000",
                        "longitude": "5.00762000"
                    },
                    {
                        "id": 8838,
                        "name": "Huy",
                        "latitude": "50.51894000",
                        "longitude": "5.23284000"
                    },
                    {
                        "id": 8842,
                        "name": "Incourt",
                        "latitude": "50.69151000",
                        "longitude": "4.79816000"
                    },
                    {
                        "id": 8844,
                        "name": "Ittre",
                        "latitude": "50.64396000",
                        "longitude": "4.26476000"
                    },
                    {
                        "id": 8847,
                        "name": "Jalhay",
                        "latitude": "50.55876000",
                        "longitude": "5.96764000"
                    },
                    {
                        "id": 8848,
                        "name": "Jodoigne",
                        "latitude": "50.72357000",
                        "longitude": "4.86914000"
                    },
                    {
                        "id": 8849,
                        "name": "Juprelle",
                        "latitude": "50.70760000",
                        "longitude": "5.53127000"
                    },
                    {
                        "id": 8850,
                        "name": "Jurbise",
                        "latitude": "50.53100000",
                        "longitude": "3.90942000"
                    },
                    {
                        "id": 8873,
                        "name": "La Bruyère",
                        "latitude": "50.39478000",
                        "longitude": "4.61444000"
                    },
                    {
                        "id": 8874,
                        "name": "La Calamine",
                        "latitude": "50.71809000",
                        "longitude": "6.01107000"
                    },
                    {
                        "id": 8875,
                        "name": "La Hulpe",
                        "latitude": "50.73091000",
                        "longitude": "4.48577000"
                    },
                    {
                        "id": 8876,
                        "name": "La Louvière",
                        "latitude": "50.48657000",
                        "longitude": "4.18785000"
                    },
                    {
                        "id": 8877,
                        "name": "La Roche-en-Ardenne",
                        "latitude": "50.18361000",
                        "longitude": "5.57547000"
                    },
                    {
                        "id": 8911,
                        "name": "Léglise",
                        "latitude": "49.79985000",
                        "longitude": "5.53652000"
                    },
                    {
                        "id": 8886,
                        "name": "Lens",
                        "latitude": "50.55696000",
                        "longitude": "3.89946000"
                    },
                    {
                        "id": 8888,
                        "name": "Lessines",
                        "latitude": "50.71104000",
                        "longitude": "3.83579000"
                    },
                    {
                        "id": 8890,
                        "name": "Libin",
                        "latitude": "49.98107000",
                        "longitude": "5.25612000"
                    },
                    {
                        "id": 8900,
                        "name": "Liège",
                        "latitude": "50.63373000",
                        "longitude": "5.56749000"
                    },
                    {
                        "id": 8894,
                        "name": "Lierneux",
                        "latitude": "50.28477000",
                        "longitude": "5.79236000"
                    },
                    {
                        "id": 8896,
                        "name": "Limbourg",
                        "latitude": "50.61222000",
                        "longitude": "5.94120000"
                    },
                    {
                        "id": 8897,
                        "name": "Lincent",
                        "latitude": "50.71222000",
                        "longitude": "5.03654000"
                    },
                    {
                        "id": 8901,
                        "name": "Lobbes",
                        "latitude": "50.35258000",
                        "longitude": "4.26716000"
                    },
                    {
                        "id": 8906,
                        "name": "Lontzen",
                        "latitude": "50.68126000",
                        "longitude": "6.00712000"
                    },
                    {
                        "id": 8907,
                        "name": "Louvain-la-Neuve",
                        "latitude": "50.66829000",
                        "longitude": "4.61443000"
                    },
                    {
                        "id": 8916,
                        "name": "Malmédy",
                        "latitude": "50.42686000",
                        "longitude": "6.02794000"
                    },
                    {
                        "id": 8917,
                        "name": "Manage",
                        "latitude": "50.50312000",
                        "longitude": "4.23589000"
                    },
                    {
                        "id": 8918,
                        "name": "Manhay",
                        "latitude": "50.29219000",
                        "longitude": "5.67562000"
                    },
                    {
                        "id": 8919,
                        "name": "Marche-en-Famenne",
                        "latitude": "50.22678000",
                        "longitude": "5.34416000"
                    },
                    {
                        "id": 8920,
                        "name": "Marchin",
                        "latitude": "50.46707000",
                        "longitude": "5.24280000"
                    },
                    {
                        "id": 8921,
                        "name": "Martelange",
                        "latitude": "49.83195000",
                        "longitude": "5.73655000"
                    },
                    {
                        "id": 8925,
                        "name": "Meix-devant-Virton",
                        "latitude": "49.60581000",
                        "longitude": "5.48045000"
                    },
                    {
                        "id": 8928,
                        "name": "Merbes-le-Château",
                        "latitude": "50.32449000",
                        "longitude": "4.16489000"
                    },
                    {
                        "id": 8932,
                        "name": "Messancy",
                        "latitude": "49.59201000",
                        "longitude": "5.81879000"
                    },
                    {
                        "id": 8933,
                        "name": "Mettet",
                        "latitude": "50.32119000",
                        "longitude": "4.66232000"
                    },
                    {
                        "id": 8936,
                        "name": "Modave",
                        "latitude": "50.44614000",
                        "longitude": "5.29532000"
                    },
                    {
                        "id": 8939,
                        "name": "Momignies",
                        "latitude": "50.02710000",
                        "longitude": "4.16519000"
                    },
                    {
                        "id": 8940,
                        "name": "Mons",
                        "latitude": "50.45413000",
                        "longitude": "3.95229000"
                    },
                    {
                        "id": 8941,
                        "name": "Mons-lez-Liège",
                        "latitude": "50.61667000",
                        "longitude": "5.46667000"
                    },
                    {
                        "id": 8942,
                        "name": "Mont-Saint-Guibert",
                        "latitude": "50.63427000",
                        "longitude": "4.61061000"
                    },
                    {
                        "id": 8944,
                        "name": "Morlanwelz-Mariemont",
                        "latitude": "50.45502000",
                        "longitude": "4.24519000"
                    },
                    {
                        "id": 8946,
                        "name": "Mouscron",
                        "latitude": "50.74497000",
                        "longitude": "3.20639000"
                    },
                    {
                        "id": 8947,
                        "name": "Musson",
                        "latitude": "49.55835000",
                        "longitude": "5.70525000"
                    },
                    {
                        "id": 8948,
                        "name": "Namur",
                        "latitude": "50.46690000",
                        "longitude": "4.86746000"
                    },
                    {
                        "id": 8949,
                        "name": "Nandrin",
                        "latitude": "50.50675000",
                        "longitude": "5.41905000"
                    },
                    {
                        "id": 8950,
                        "name": "Nassogne",
                        "latitude": "50.12849000",
                        "longitude": "5.34274000"
                    },
                    {
                        "id": 8953,
                        "name": "Neufchâteau",
                        "latitude": "49.84074000",
                        "longitude": "5.43535000"
                    },
                    {
                        "id": 8960,
                        "name": "Nivelles",
                        "latitude": "50.59833000",
                        "longitude": "4.32848000"
                    },
                    {
                        "id": 8961,
                        "name": "Noville-les-Bois",
                        "latitude": "50.55702000",
                        "longitude": "4.98466000"
                    },
                    {
                        "id": 8962,
                        "name": "Ohey",
                        "latitude": "50.43570000",
                        "longitude": "5.12375000"
                    },
                    {
                        "id": 8964,
                        "name": "Olne",
                        "latitude": "50.58994000",
                        "longitude": "5.74662000"
                    },
                    {
                        "id": 8965,
                        "name": "Onhaye",
                        "latitude": "50.24148000",
                        "longitude": "4.84069000"
                    },
                    {
                        "id": 8973,
                        "name": "Oreye",
                        "latitude": "50.71749000",
                        "longitude": "5.34880000"
                    },
                    {
                        "id": 8975,
                        "name": "Ottignies",
                        "latitude": "50.66535000",
                        "longitude": "4.56679000"
                    },
                    {
                        "id": 8980,
                        "name": "Ouffet",
                        "latitude": "50.43870000",
                        "longitude": "5.46570000"
                    },
                    {
                        "id": 8981,
                        "name": "Oupeye",
                        "latitude": "50.71184000",
                        "longitude": "5.64680000"
                    },
                    {
                        "id": 8984,
                        "name": "Paliseul",
                        "latitude": "49.90395000",
                        "longitude": "5.13537000"
                    },
                    {
                        "id": 8985,
                        "name": "Pecq",
                        "latitude": "50.68619000",
                        "longitude": "3.33789000"
                    },
                    {
                        "id": 8988,
                        "name": "Pepinster",
                        "latitude": "50.57375000",
                        "longitude": "5.80490000"
                    },
                    {
                        "id": 9009,
                        "name": "Péruwelz",
                        "latitude": "50.50819000",
                        "longitude": "3.59373000"
                    },
                    {
                        "id": 8990,
                        "name": "Perwez",
                        "latitude": "50.62426000",
                        "longitude": "4.81354000"
                    },
                    {
                        "id": 8991,
                        "name": "Philippeville",
                        "latitude": "50.19612000",
                        "longitude": "4.54374000"
                    },
                    {
                        "id": 8993,
                        "name": "Plombières",
                        "latitude": "50.73656000",
                        "longitude": "5.95922000"
                    },
                    {
                        "id": 8994,
                        "name": "Pont-à-Celles",
                        "latitude": "50.50518000",
                        "longitude": "4.36887000"
                    },
                    {
                        "id": 8996,
                        "name": "Profondeville",
                        "latitude": "50.37581000",
                        "longitude": "4.86506000"
                    },
                    {
                        "id": 8997,
                        "name": "Province de Liège",
                        "latitude": "50.63427000",
                        "longitude": "5.56543000"
                    },
                    {
                        "id": 8998,
                        "name": "Province de Namur",
                        "latitude": "50.33333000",
                        "longitude": "4.83333000"
                    },
                    {
                        "id": 8999,
                        "name": "Province du Brabant Wallon",
                        "latitude": "50.75000000",
                        "longitude": "4.58333000"
                    },
                    {
                        "id": 9000,
                        "name": "Province du Hainaut",
                        "latitude": "50.50000000",
                        "longitude": "3.83333000"
                    },
                    {
                        "id": 9010,
                        "name": "Quaregnon",
                        "latitude": "50.44067000",
                        "longitude": "3.86530000"
                    },
                    {
                        "id": 9012,
                        "name": "Quévy-le-Petit",
                        "latitude": "50.36879000",
                        "longitude": "3.93602000"
                    },
                    {
                        "id": 9011,
                        "name": "Quiévrain",
                        "latitude": "50.40737000",
                        "longitude": "3.68351000"
                    },
                    {
                        "id": 9013,
                        "name": "Raeren",
                        "latitude": "50.66720000",
                        "longitude": "6.11535000"
                    },
                    {
                        "id": 9014,
                        "name": "Ramillies",
                        "latitude": "50.63395000",
                        "longitude": "4.90119000"
                    },
                    {
                        "id": 9017,
                        "name": "Rebecq-Rognon",
                        "latitude": "50.65147000",
                        "longitude": "4.10683000"
                    },
                    {
                        "id": 9018,
                        "name": "Remicourt",
                        "latitude": "50.68069000",
                        "longitude": "5.32785000"
                    },
                    {
                        "id": 9019,
                        "name": "Rendeux",
                        "latitude": "50.23423000",
                        "longitude": "5.50414000"
                    },
                    {
                        "id": 9023,
                        "name": "Rixensart",
                        "latitude": "50.71229000",
                        "longitude": "4.52529000"
                    },
                    {
                        "id": 9024,
                        "name": "Rochefort",
                        "latitude": "50.16310000",
                        "longitude": "5.22160000"
                    },
                    {
                        "id": 9026,
                        "name": "Roeulx",
                        "latitude": "50.50365000",
                        "longitude": "4.11163000"
                    },
                    {
                        "id": 9029,
                        "name": "Rouvroy",
                        "latitude": "49.53771000",
                        "longitude": "5.49031000"
                    },
                    {
                        "id": 9031,
                        "name": "Rumes",
                        "latitude": "50.55450000",
                        "longitude": "3.30535000"
                    },
                    {
                        "id": 9033,
                        "name": "Saint-Ghislain",
                        "latitude": "50.44816000",
                        "longitude": "3.81886000"
                    },
                    {
                        "id": 9034,
                        "name": "Saint-Hubert",
                        "latitude": "50.02668000",
                        "longitude": "5.37401000"
                    },
                    {
                        "id": 9035,
                        "name": "Saint-Léger",
                        "latitude": "49.61196000",
                        "longitude": "5.65688000"
                    },
                    {
                        "id": 9036,
                        "name": "Saint-Nicolas",
                        "latitude": "50.62837000",
                        "longitude": "5.53243000"
                    },
                    {
                        "id": 9037,
                        "name": "Saint-Vith",
                        "latitude": "50.28146000",
                        "longitude": "6.12724000"
                    },
                    {
                        "id": 9038,
                        "name": "Sainte-Ode",
                        "latitude": "50.01723000",
                        "longitude": "5.51926000"
                    },
                    {
                        "id": 9042,
                        "name": "Seneffe",
                        "latitude": "50.53135000",
                        "longitude": "4.26301000"
                    },
                    {
                        "id": 9043,
                        "name": "Seraing",
                        "latitude": "50.58362000",
                        "longitude": "5.50115000"
                    },
                    {
                        "id": 9044,
                        "name": "Silly",
                        "latitude": "50.64877000",
                        "longitude": "3.92363000"
                    },
                    {
                        "id": 9060,
                        "name": "Soignies",
                        "latitude": "50.57904000",
                        "longitude": "4.07129000"
                    },
                    {
                        "id": 9061,
                        "name": "Sombreffe",
                        "latitude": "50.52865000",
                        "longitude": "4.60087000"
                    },
                    {
                        "id": 9062,
                        "name": "Somme-Leuze",
                        "latitude": "50.33699000",
                        "longitude": "5.36705000"
                    },
                    {
                        "id": 9063,
                        "name": "Soumagne",
                        "latitude": "50.61385000",
                        "longitude": "5.74679000"
                    },
                    {
                        "id": 9064,
                        "name": "Spa",
                        "latitude": "50.48375000",
                        "longitude": "5.86674000"
                    },
                    {
                        "id": 9065,
                        "name": "Sprimont",
                        "latitude": "50.50922000",
                        "longitude": "5.65950000"
                    },
                    {
                        "id": 9068,
                        "name": "Stavelot",
                        "latitude": "50.39500000",
                        "longitude": "5.93124000"
                    },
                    {
                        "id": 9071,
                        "name": "Stoumont",
                        "latitude": "50.40667000",
                        "longitude": "5.80838000"
                    },
                    {
                        "id": 9072,
                        "name": "Tellin",
                        "latitude": "50.08038000",
                        "longitude": "5.21638000"
                    },
                    {
                        "id": 9074,
                        "name": "Tenneville",
                        "latitude": "50.09501000",
                        "longitude": "5.52895000"
                    },
                    {
                        "id": 9079,
                        "name": "Theux",
                        "latitude": "50.53323000",
                        "longitude": "5.81245000"
                    },
                    {
                        "id": 9080,
                        "name": "Thuin",
                        "latitude": "50.33933000",
                        "longitude": "4.28604000"
                    },
                    {
                        "id": 9083,
                        "name": "Tinlot",
                        "latitude": "50.47493000",
                        "longitude": "5.37755000"
                    },
                    {
                        "id": 9084,
                        "name": "Tintigny",
                        "latitude": "49.68326000",
                        "longitude": "5.51349000"
                    },
                    {
                        "id": 9087,
                        "name": "Tournai",
                        "latitude": "50.60715000",
                        "longitude": "3.38932000"
                    },
                    {
                        "id": 9089,
                        "name": "Trois-Ponts",
                        "latitude": "50.37128000",
                        "longitude": "5.87146000"
                    },
                    {
                        "id": 9090,
                        "name": "Trooz",
                        "latitude": "50.57026000",
                        "longitude": "5.69521000"
                    },
                    {
                        "id": 9091,
                        "name": "Tubize",
                        "latitude": "50.69059000",
                        "longitude": "4.20090000"
                    },
                    {
                        "id": 9093,
                        "name": "Vaux-sur-Sûre",
                        "latitude": "49.91100000",
                        "longitude": "5.57848000"
                    },
                    {
                        "id": 9094,
                        "name": "Verlaine",
                        "latitude": "50.60743000",
                        "longitude": "5.31740000"
                    },
                    {
                        "id": 9095,
                        "name": "Verviers",
                        "latitude": "50.58907000",
                        "longitude": "5.86241000"
                    },
                    {
                        "id": 9097,
                        "name": "Vielsalm",
                        "latitude": "50.28407000",
                        "longitude": "5.91502000"
                    },
                    {
                        "id": 9098,
                        "name": "Villers-la-Ville",
                        "latitude": "50.56667000",
                        "longitude": "4.51667000"
                    },
                    {
                        "id": 9099,
                        "name": "Villers-le-Bouillet",
                        "latitude": "50.57708000",
                        "longitude": "5.25945000"
                    },
                    {
                        "id": 9101,
                        "name": "Virton",
                        "latitude": "49.56824000",
                        "longitude": "5.53259000"
                    },
                    {
                        "id": 9102,
                        "name": "Visé",
                        "latitude": "50.73760000",
                        "longitude": "5.69907000"
                    },
                    {
                        "id": 9108,
                        "name": "Waimes",
                        "latitude": "50.41488000",
                        "longitude": "6.11207000"
                    },
                    {
                        "id": 9109,
                        "name": "Walcourt",
                        "latitude": "50.25401000",
                        "longitude": "4.43796000"
                    },
                    {
                        "id": 9110,
                        "name": "Walhain-Saint-Paul",
                        "latitude": "50.62627000",
                        "longitude": "4.69837000"
                    },
                    {
                        "id": 9111,
                        "name": "Wanze",
                        "latitude": "50.53907000",
                        "longitude": "5.20846000"
                    },
                    {
                        "id": 9113,
                        "name": "Waremme",
                        "latitude": "50.69760000",
                        "longitude": "5.25524000"
                    },
                    {
                        "id": 9114,
                        "name": "Wasseiges",
                        "latitude": "50.62186000",
                        "longitude": "5.00528000"
                    },
                    {
                        "id": 9115,
                        "name": "Waterloo",
                        "latitude": "50.71469000",
                        "longitude": "4.39910000"
                    },
                    {
                        "id": 9116,
                        "name": "Wavre",
                        "latitude": "50.71717000",
                        "longitude": "4.60138000"
                    },
                    {
                        "id": 9117,
                        "name": "Welkenraedt",
                        "latitude": "50.66050000",
                        "longitude": "5.97034000"
                    },
                    {
                        "id": 9119,
                        "name": "Wellin",
                        "latitude": "50.08133000",
                        "longitude": "5.11413000"
                    },
                    {
                        "id": 9134,
                        "name": "Yvoir",
                        "latitude": "50.32790000",
                        "longitude": "4.88059000"
                    }
                ]
            },
            {
                "id": 1382,
                "name": "Walloon Brabant",
                "iso2": "WBR",
                "latitude": "50.63324100",
                "longitude": "4.52431500",
                "type": "province",
                "cities": []
            },
            {
                "id": 1383,
                "name": "West Flanders",
                "iso2": "VWV",
                "latitude": "51.04047470",
                "longitude": "2.99942130",
                "type": "province",
                "cities": []
            }
        ]
    },
    {
        "id": 23,
        "name": "Belize",
        "iso3": "BLZ",
        "iso2": "BZ",
        "numeric_code": "084",
        "phonecode": "501",
        "capital": "Belmopan",
        "currency": "BZD",
        "currency_name": "Belize dollar",
        "currency_symbol": "$",
        "tld": ".bz",
        "native": "Belize",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Central America",
        "subregion_id": 9,
        "nationality": "Belizean",
        "timezones": [
            {
                "zoneName": "America\/Belize",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America)"
            }
        ],
        "translations": {
            "br": "Belize",
            "ko": "벨리즈",
            "pt-BR": "Belize",
            "pt": "Belize",
            "nl": "Belize",
            "hr": "Belize",
            "fa": "بلیز",
            "de": "Belize",
            "es": "Belice",
            "fr": "Belize",
            "ja": "ベリーズ",
            "it": "Belize",
            "zh-CN": "伯利兹",
            "tr": "Belize",
            "ru": "Белиз",
            "uk": "Беліз",
            "pl": "Belize"
        },
        "latitude": "17.25000000",
        "longitude": "-88.75000000",
        "emoji": "🇧🇿",
        "emojiU": "U+1F1E7 U+1F1FF",
        "states": [
            {
                "id": 264,
                "name": "Belize",
                "iso2": "BZ",
                "latitude": "17.56776790",
                "longitude": "-88.40160410",
                "type": "district",
                "cities": [
                    {
                        "id": 16133,
                        "name": "Belize City",
                        "latitude": "17.49952000",
                        "longitude": "-88.19756000"
                    },
                    {
                        "id": 16143,
                        "name": "San Pedro",
                        "latitude": "17.91598000",
                        "longitude": "-87.96590000"
                    }
                ]
            },
            {
                "id": 269,
                "name": "Cayo",
                "iso2": "CY",
                "latitude": "17.09844450",
                "longitude": "-88.94138650",
                "type": "district",
                "cities": [
                    {
                        "id": 16134,
                        "name": "Belmopan",
                        "latitude": "17.25000000",
                        "longitude": "-88.76667000"
                    },
                    {
                        "id": 16135,
                        "name": "Benque Viejo el Carmen",
                        "latitude": "17.07500000",
                        "longitude": "-89.13917000"
                    },
                    {
                        "id": 16142,
                        "name": "San Ignacio",
                        "latitude": "17.15880000",
                        "longitude": "-89.06960000"
                    },
                    {
                        "id": 16145,
                        "name": "Valley of Peace",
                        "latitude": "17.33472000",
                        "longitude": "-88.83472000"
                    }
                ]
            },
            {
                "id": 266,
                "name": "Corozal",
                "iso2": "CZL",
                "latitude": "18.13492380",
                "longitude": "-88.24611830",
                "type": "district",
                "cities": [
                    {
                        "id": 16136,
                        "name": "Corozal",
                        "latitude": "18.39375000",
                        "longitude": "-88.38849000"
                    }
                ]
            },
            {
                "id": 268,
                "name": "Orange Walk",
                "iso2": "OW",
                "latitude": "17.76035300",
                "longitude": "-88.86469800",
                "type": "district",
                "cities": [
                    {
                        "id": 16138,
                        "name": "Hopelchén",
                        "latitude": "17.80000000",
                        "longitude": "-89.10000000"
                    },
                    {
                        "id": 16139,
                        "name": "Orange Walk",
                        "latitude": "18.08124000",
                        "longitude": "-88.56328000"
                    },
                    {
                        "id": 16144,
                        "name": "Shipyard",
                        "latitude": "17.89382000",
                        "longitude": "-88.65452000"
                    }
                ]
            },
            {
                "id": 265,
                "name": "Stann Creek",
                "iso2": "SC",
                "latitude": "16.81166310",
                "longitude": "-88.40160410",
                "type": "district",
                "cities": [
                    {
                        "id": 16137,
                        "name": "Dangriga",
                        "latitude": "16.96970000",
                        "longitude": "-88.23313000"
                    },
                    {
                        "id": 16140,
                        "name": "Placencia",
                        "latitude": "16.51419000",
                        "longitude": "-88.36647000"
                    }
                ]
            },
            {
                "id": 267,
                "name": "Toledo",
                "iso2": "TOL",
                "latitude": "16.24919230",
                "longitude": "-88.86469800",
                "type": "district",
                "cities": [
                    {
                        "id": 16141,
                        "name": "Punta Gorda",
                        "latitude": "16.09835000",
                        "longitude": "-88.80970000"
                    }
                ]
            }
        ]
    },
    {
        "id": 24,
        "name": "Benin",
        "iso3": "BEN",
        "iso2": "BJ",
        "numeric_code": "204",
        "phonecode": "229",
        "capital": "Porto-Novo",
        "currency": "XOF",
        "currency_name": "West African CFA franc",
        "currency_symbol": "CFA",
        "tld": ".bj",
        "native": "Bénin",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Beninese, Beninois",
        "timezones": [
            {
                "zoneName": "Africa\/Porto-Novo",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "br": "Benin",
            "ko": "베냉",
            "pt-BR": "Benin",
            "pt": "Benim",
            "nl": "Benin",
            "hr": "Benin",
            "fa": "بنین",
            "de": "Benin",
            "es": "Benín",
            "fr": "Bénin",
            "ja": "ベナン",
            "it": "Benin",
            "zh-CN": "贝宁",
            "tr": "Benin",
            "ru": "Бенин",
            "uk": "Бенін",
            "pl": "Benin"
        },
        "latitude": "9.50000000",
        "longitude": "2.25000000",
        "emoji": "🇧🇯",
        "emojiU": "U+1F1E7 U+1F1EF",
        "states": [
            {
                "id": 3077,
                "name": "Alibori",
                "iso2": "AL",
                "latitude": "10.96810930",
                "longitude": "2.77798130",
                "type": "department",
                "cities": [
                    {
                        "id": 9782,
                        "name": "Banikoara",
                        "latitude": "11.29845000",
                        "longitude": "2.43856000"
                    },
                    {
                        "id": 9800,
                        "name": "Kandi",
                        "latitude": "11.13417000",
                        "longitude": "2.93861000"
                    },
                    {
                        "id": 9803,
                        "name": "Malanville",
                        "latitude": "11.86819000",
                        "longitude": "3.38327000"
                    }
                ]
            },
            {
                "id": 3076,
                "name": "Atakora",
                "iso2": "AK",
                "latitude": "10.79549310",
                "longitude": "1.67606910",
                "type": "department",
                "cities": [
                    {
                        "id": 9797,
                        "name": "Guilmaro",
                        "latitude": "10.56583000",
                        "longitude": "1.72444000"
                    },
                    {
                        "id": 9804,
                        "name": "Natitingou",
                        "latitude": "10.30416000",
                        "longitude": "1.37962000"
                    },
                    {
                        "id": 9813,
                        "name": "Tanguieta",
                        "latitude": "11.03621000",
                        "longitude": "1.41757000"
                    }
                ]
            },
            {
                "id": 3079,
                "name": "Atlantique",
                "iso2": "AQ",
                "latitude": "6.65883910",
                "longitude": "2.22366670",
                "type": "department",
                "cities": [
                    {
                        "id": 9780,
                        "name": "Abomey-Calavi",
                        "latitude": "6.44852000",
                        "longitude": "2.35566000"
                    },
                    {
                        "id": 9781,
                        "name": "Allada",
                        "latitude": "6.66547000",
                        "longitude": "2.15138000"
                    },
                    {
                        "id": 9799,
                        "name": "Hévié",
                        "latitude": "6.41667000",
                        "longitude": "2.25000000"
                    },
                    {
                        "id": 9798,
                        "name": "Hinvi",
                        "latitude": "6.76667000",
                        "longitude": "2.16667000"
                    },
                    {
                        "id": 9806,
                        "name": "Ouidah",
                        "latitude": "6.36307000",
                        "longitude": "2.08506000"
                    }
                ]
            },
            {
                "id": 3078,
                "name": "Borgou",
                "iso2": "BO",
                "latitude": "9.53408640",
                "longitude": "2.77798130",
                "type": "department",
                "cities": [
                    {
                        "id": 9784,
                        "name": "Bembèrèkè",
                        "latitude": "10.22827000",
                        "longitude": "2.66335000"
                    },
                    {
                        "id": 9786,
                        "name": "Bétérou",
                        "latitude": "9.19916000",
                        "longitude": "2.25855000"
                    },
                    {
                        "id": 9805,
                        "name": "Nikki",
                        "latitude": "9.94009000",
                        "longitude": "3.21075000"
                    },
                    {
                        "id": 9807,
                        "name": "Parakou",
                        "latitude": "9.33716000",
                        "longitude": "2.63031000"
                    },
                    {
                        "id": 9815,
                        "name": "Tchaourou",
                        "latitude": "8.88649000",
                        "longitude": "2.59753000"
                    }
                ]
            },
            {
                "id": 3070,
                "name": "Collines",
                "iso2": "CO",
                "latitude": "8.30222970",
                "longitude": "2.30244600",
                "type": "department",
                "cities": [
                    {
                        "id": 9790,
                        "name": "Comé",
                        "latitude": "6.40764000",
                        "longitude": "1.88198000"
                    },
                    {
                        "id": 9793,
                        "name": "Dassa-Zoumé",
                        "latitude": "7.75000000",
                        "longitude": "2.18333000"
                    },
                    {
                        "id": 9811,
                        "name": "Savalou",
                        "latitude": "7.92807000",
                        "longitude": "1.97558000"
                    },
                    {
                        "id": 9812,
                        "name": "Savé",
                        "latitude": "8.03424000",
                        "longitude": "2.48660000"
                    }
                ]
            },
            {
                "id": 3072,
                "name": "Donga",
                "iso2": "DO",
                "latitude": "9.71918670",
                "longitude": "1.67606910",
                "type": "department",
                "cities": [
                    {
                        "id": 9783,
                        "name": "Bassila",
                        "latitude": "9.00814000",
                        "longitude": "1.66540000"
                    },
                    {
                        "id": 9789,
                        "name": "Commune of Djougou",
                        "latitude": "9.64300000",
                        "longitude": "1.89600000"
                    },
                    {
                        "id": 9795,
                        "name": "Djougou",
                        "latitude": "9.70853000",
                        "longitude": "1.66598000"
                    }
                ]
            },
            {
                "id": 3071,
                "name": "Kouffo",
                "iso2": "KO",
                "latitude": "7.00358940",
                "longitude": "1.75388170",
                "type": "department",
                "cities": [
                    {
                        "id": 9794,
                        "name": "Djakotomey",
                        "latitude": "6.90000000",
                        "longitude": "1.71667000"
                    },
                    {
                        "id": 9796,
                        "name": "Dogbo",
                        "latitude": "6.79911000",
                        "longitude": "1.78073000"
                    }
                ]
            },
            {
                "id": 3081,
                "name": "Littoral",
                "iso2": "LI",
                "latitude": "6.38069730",
                "longitude": "2.44063870",
                "type": "department",
                "cities": [
                    {
                        "id": 9791,
                        "name": "Cotonou",
                        "latitude": "6.36536000",
                        "longitude": "2.41833000"
                    }
                ]
            },
            {
                "id": 3075,
                "name": "Mono",
                "iso2": "MO",
                "latitude": "37.92186080",
                "longitude": "-118.95286450",
                "type": "department",
                "cities": [
                    {
                        "id": 9788,
                        "name": "Commune of Athieme",
                        "latitude": "6.56924000",
                        "longitude": "1.70259000"
                    },
                    {
                        "id": 9802,
                        "name": "Lokossa",
                        "latitude": "6.63869000",
                        "longitude": "1.71674000"
                    }
                ]
            },
            {
                "id": 3080,
                "name": "Ouémé",
                "iso2": "OU",
                "latitude": "6.61481520",
                "longitude": "2.49999180",
                "type": "department",
                "cities": [
                    {
                        "id": 9809,
                        "name": "Porto-Novo",
                        "latitude": "6.49646000",
                        "longitude": "2.60359000"
                    }
                ]
            },
            {
                "id": 3074,
                "name": "Plateau",
                "iso2": "PL",
                "latitude": "7.34451410",
                "longitude": "2.53960300",
                "type": "department",
                "cities": [
                    {
                        "id": 9801,
                        "name": "Kétou",
                        "latitude": "7.36332000",
                        "longitude": "2.59978000"
                    },
                    {
                        "id": 9808,
                        "name": "Pobé",
                        "latitude": "6.98008000",
                        "longitude": "2.66490000"
                    },
                    {
                        "id": 9810,
                        "name": "Sakété",
                        "latitude": "6.73618000",
                        "longitude": "2.65866000"
                    }
                ]
            },
            {
                "id": 3073,
                "name": "Zou",
                "iso2": "ZO",
                "latitude": "7.34692680",
                "longitude": "2.06651970",
                "type": "department",
                "cities": [
                    {
                        "id": 9779,
                        "name": "Abomey",
                        "latitude": "7.18286000",
                        "longitude": "1.99119000"
                    },
                    {
                        "id": 9785,
                        "name": "Bohicon",
                        "latitude": "7.17826000",
                        "longitude": "2.06670000"
                    },
                    {
                        "id": 9787,
                        "name": "Commune of Agbangnizoun",
                        "latitude": "7.07600000",
                        "longitude": "1.96100000"
                    },
                    {
                        "id": 9792,
                        "name": "Cové",
                        "latitude": "7.22097000",
                        "longitude": "2.34017000"
                    }
                ]
            }
        ]
    },
    {
        "id": 25,
        "name": "Bermuda",
        "iso3": "BMU",
        "iso2": "BM",
        "numeric_code": "060",
        "phonecode": "1",
        "capital": "Hamilton",
        "currency": "BMD",
        "currency_name": "Bermudian dollar",
        "currency_symbol": "$",
        "tld": ".bm",
        "native": "Bermuda",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Northern America",
        "subregion_id": 6,
        "nationality": "Bermudian, Bermudan",
        "timezones": [
            {
                "zoneName": "Atlantic\/Bermuda",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Bermuda",
            "ko": "버뮤다",
            "pt-BR": "Bermudas",
            "pt": "Bermudas",
            "nl": "Bermuda",
            "hr": "Bermudi",
            "fa": "برمودا",
            "de": "Bermuda",
            "es": "Bermudas",
            "fr": "Bermudes",
            "ja": "バミューダ",
            "it": "Bermuda",
            "zh-CN": "百慕大",
            "tr": "Bermuda",
            "ru": "Бермуды",
            "uk": "Бермудські острови",
            "pl": "Bermudy"
        },
        "latitude": "32.33333333",
        "longitude": "-64.75000000",
        "emoji": "🇧🇲",
        "emojiU": "U+1F1E7 U+1F1F2",
        "states": [
            {
                "id": 4860,
                "name": "Devonshire",
                "iso2": "DEV",
                "latitude": "32.30380620",
                "longitude": "-64.76069540",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153518,
                        "name": "Devonshire",
                        "latitude": "32.29300000",
                        "longitude": "-64.80000000"
                    }
                ]
            },
            {
                "id": 4861,
                "name": "Hamilton",
                "iso2": "HA",
                "latitude": "32.34494320",
                "longitude": "-64.72365000",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153515,
                        "name": "Hamilton",
                        "latitude": "32.29400000",
                        "longitude": "-64.78300000"
                    }
                ]
            },
            {
                "id": 4863,
                "name": "Paget",
                "iso2": "PAG",
                "latitude": "32.28107400",
                "longitude": "-64.77847870",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153516,
                        "name": "Paget",
                        "latitude": "32.27800000",
                        "longitude": "-64.76900000"
                    }
                ]
            },
            {
                "id": 4864,
                "name": "Pembroke",
                "iso2": "PEM",
                "latitude": "32.30076720",
                "longitude": "-64.79626300",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4866,
                "name": "Saint George's",
                "iso2": "SGE",
                "latitude": "32.36008740",
                "longitude": "-64.72346170",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153514,
                        "name": "St. George's",
                        "latitude": "32.38100000",
                        "longitude": "-64.67400000"
                    },
                    {
                        "id": 153517,
                        "name": "Tucker’s Town",
                        "latitude": "32.33280000",
                        "longitude": "64.68810000"
                    }
                ]
            },
            {
                "id": 4867,
                "name": "Sandys",
                "iso2": "SAN",
                "latitude": "32.29995280",
                "longitude": "-64.86741030",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153513,
                        "name": "Somerset",
                        "latitude": "32.28200000",
                        "longitude": "-64.84400000"
                    }
                ]
            },
            {
                "id": 4868,
                "name": "Smith's",
                "iso2": "SMI",
                "latitude": "32.31339660",
                "longitude": "-64.73105880",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153512,
                        "name": "Flatts",
                        "latitude": "32.32800000",
                        "longitude": "-64.73600000"
                    }
                ]
            },
            {
                "id": 4869,
                "name": "Southampton",
                "iso2": "SOU",
                "latitude": "32.25400950",
                "longitude": "-64.82590580",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153511,
                        "name": "Southampton",
                        "latitude": "32.24900000",
                        "longitude": "-64.86100000"
                    }
                ]
            },
            {
                "id": 4870,
                "name": "Warwick",
                "iso2": "WAR",
                "latitude": "32.26615340",
                "longitude": "-64.80811980",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153510,
                        "name": "Warwick",
                        "latitude": "32.26700000",
                        "longitude": "-64.80600000"
                    }
                ]
            }
        ]
    },
    {
        "id": 26,
        "name": "Bhutan",
        "iso3": "BTN",
        "iso2": "BT",
        "numeric_code": "064",
        "phonecode": "975",
        "capital": "Thimphu",
        "currency": "BTN",
        "currency_name": "Bhutanese ngultrum",
        "currency_symbol": "Nu.",
        "tld": ".bt",
        "native": "ʼbrug-yul",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Southern Asia",
        "subregion_id": 14,
        "nationality": "Bhutanese",
        "timezones": [
            {
                "zoneName": "Asia\/Thimphu",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "BTT",
                "tzName": "Bhutan Time"
            }
        ],
        "translations": {
            "br": "Bhoutan",
            "ko": "부탄",
            "pt-BR": "Butão",
            "pt": "Butão",
            "nl": "Bhutan",
            "hr": "Butan",
            "fa": "بوتان",
            "de": "Bhutan",
            "es": "Bután",
            "fr": "Bhoutan",
            "ja": "ブータン",
            "it": "Bhutan",
            "zh-CN": "不丹",
            "tr": "Butan",
            "ru": "Бутан",
            "uk": "Бутан",
            "pl": "Bhutan"
        },
        "latitude": "27.50000000",
        "longitude": "90.50000000",
        "emoji": "🇧🇹",
        "emojiU": "U+1F1E7 U+1F1F9",
        "states": [
            {
                "id": 240,
                "name": "Bumthang ",
                "iso2": "33",
                "latitude": "27.64183900",
                "longitude": "90.67730460",
                "type": "district",
                "cities": [
                    {
                        "id": 15709,
                        "name": "Jakar",
                        "latitude": "27.54918000",
                        "longitude": "90.75250000"
                    },
                    {
                        "id": 153824,
                        "name": "Tang Valley",
                        "latitude": "27.50252420",
                        "longitude": "90.74495440"
                    }
                ]
            },
            {
                "id": 239,
                "name": "Chukha ",
                "iso2": "12",
                "latitude": "27.07843040",
                "longitude": "89.47421770",
                "type": "district",
                "cities": [
                    {
                        "id": 153825,
                        "name": "Chapchha",
                        "latitude": "27.20000000",
                        "longitude": "89.55000000"
                    },
                    {
                        "id": 15706,
                        "name": "Daphu",
                        "latitude": "26.96670000",
                        "longitude": "89.38330000"
                    },
                    {
                        "id": 153827,
                        "name": "Khitokha",
                        "latitude": "26.90000000",
                        "longitude": "89.61670000"
                    },
                    {
                        "id": 153826,
                        "name": "Lobnig",
                        "latitude": "27.15000000",
                        "longitude": "89.55000000"
                    },
                    {
                        "id": 15726,
                        "name": "Pachu",
                        "latitude": "26.90000000",
                        "longitude": "89.35000000"
                    },
                    {
                        "id": 15716,
                        "name": "Phuntsholing",
                        "latitude": "26.85164000",
                        "longitude": "89.38837000"
                    }
                ]
            },
            {
                "id": 238,
                "name": "Dagana ",
                "iso2": "22",
                "latitude": "27.03228610",
                "longitude": "89.88793040",
                "type": "district",
                "cities": [
                    {
                        "id": 15705,
                        "name": "Daga",
                        "latitude": "27.07529000",
                        "longitude": "89.87688000"
                    },
                    {
                        "id": 15728,
                        "name": "Sibsu",
                        "latitude": "27.00000000",
                        "longitude": "88.90000000"
                    },
                    {
                        "id": 153828,
                        "name": "Thumgaon",
                        "latitude": "26.98330000",
                        "longitude": "89.96670000"
                    }
                ]
            },
            {
                "id": 229,
                "name": "Gasa ",
                "iso2": "GA",
                "latitude": "28.01858860",
                "longitude": "89.92532330",
                "type": "district",
                "cities": [
                    {
                        "id": 15707,
                        "name": "Gasa",
                        "latitude": "27.90372000",
                        "longitude": "89.72689000"
                    }
                ]
            },
            {
                "id": 232,
                "name": "Haa ",
                "iso2": "13",
                "latitude": "27.26516690",
                "longitude": "89.17059980",
                "type": "district",
                "cities": [
                    {
                        "id": 15708,
                        "name": "Ha",
                        "latitude": "27.38747000",
                        "longitude": "89.28074000"
                    },
                    {
                        "id": 153829,
                        "name": "Naktsang",
                        "latitude": "27.38330000",
                        "longitude": "89.26670000"
                    },
                    {
                        "id": 153830,
                        "name": "Sangkari",
                        "latitude": "27.30000000",
                        "longitude": "89.31670000"
                    }
                ]
            },
            {
                "id": 234,
                "name": "Lhuntse ",
                "iso2": "44",
                "latitude": "27.82649890",
                "longitude": "91.13530200",
                "type": "district",
                "cities": [
                    {
                        "id": 15710,
                        "name": "Lhuentse",
                        "latitude": "27.66787000",
                        "longitude": "91.18393000"
                    }
                ]
            },
            {
                "id": 242,
                "name": "Mongar ",
                "iso2": "42",
                "latitude": "27.26170590",
                "longitude": "91.28910360",
                "type": "district",
                "cities": [
                    {
                        "id": 153832,
                        "name": "Kengkhar",
                        "latitude": "27.10000000",
                        "longitude": "91.25000000"
                    },
                    {
                        "id": 15711,
                        "name": "Mongar",
                        "latitude": "27.27471000",
                        "longitude": "91.23963000"
                    },
                    {
                        "id": 153831,
                        "name": "Thebong",
                        "latitude": "27.26670000",
                        "longitude": "91.26670000"
                    }
                ]
            },
            {
                "id": 237,
                "name": "Paro ",
                "iso2": "11",
                "latitude": "27.42859490",
                "longitude": "89.41665160",
                "type": "district",
                "cities": [
                    {
                        "id": 15714,
                        "name": "Paro",
                        "latitude": "27.43050000",
                        "longitude": "89.41334000"
                    },
                    {
                        "id": 153834,
                        "name": "Suchha",
                        "latitude": "27.23330000",
                        "longitude": "89.45000000"
                    },
                    {
                        "id": 153833,
                        "name": "Tshalunang",
                        "latitude": "27.43330000",
                        "longitude": "89.65000000"
                    }
                ]
            },
            {
                "id": 244,
                "name": "Pemagatshel ",
                "iso2": "43",
                "latitude": "27.00238200",
                "longitude": "91.34692470",
                "type": "district",
                "cities": [
                    {
                        "id": 153835,
                        "name": "Nganglam",
                        "latitude": "26.84181100",
                        "longitude": "91.24248490"
                    },
                    {
                        "id": 15715,
                        "name": "Pemagatshel",
                        "latitude": "27.03795000",
                        "longitude": "91.40305000"
                    }
                ]
            },
            {
                "id": 235,
                "name": "Punakha ",
                "iso2": "23",
                "latitude": "27.69037160",
                "longitude": "89.88793040",
                "type": "district",
                "cities": [
                    {
                        "id": 15712,
                        "name": "Pajo",
                        "latitude": "27.53333000",
                        "longitude": "89.88333000"
                    },
                    {
                        "id": 15717,
                        "name": "Punākha",
                        "latitude": "27.59137000",
                        "longitude": "89.87743000"
                    }
                ]
            },
            {
                "id": 243,
                "name": "Samdrup Jongkhar ",
                "iso2": "45",
                "latitude": "26.80356820",
                "longitude": "91.50392070",
                "type": "district",
                "cities": [
                    {
                        "id": 15718,
                        "name": "Samdrup Jongkhar",
                        "latitude": "26.80069000",
                        "longitude": "91.50519000"
                    }
                ]
            },
            {
                "id": 246,
                "name": "Samtse ",
                "iso2": "14",
                "latitude": "27.02918320",
                "longitude": "89.05615320",
                "type": "district",
                "cities": [
                    {
                        "id": 153838,
                        "name": "Denchukha",
                        "latitude": "27.01670000",
                        "longitude": "89.25000000"
                    },
                    {
                        "id": 153837,
                        "name": "Dorokha",
                        "latitude": "27.01670000",
                        "longitude": "89.21670000"
                    },
                    {
                        "id": 15719,
                        "name": "Samtse",
                        "latitude": "26.89903000",
                        "longitude": "89.09951000"
                    },
                    {
                        "id": 153836,
                        "name": "Tendu",
                        "latitude": "27.13330000",
                        "longitude": "88.88330000"
                    }
                ]
            },
            {
                "id": 247,
                "name": "Sarpang ",
                "iso2": "31",
                "latitude": "26.93730410",
                "longitude": "90.48799160",
                "type": "district",
                "cities": [
                    {
                        "id": 153841,
                        "name": "Bhurgaon",
                        "latitude": "26.90000000",
                        "longitude": "90.43330000"
                    },
                    {
                        "id": 153840,
                        "name": "Galechugaon",
                        "latitude": "27.00000000",
                        "longitude": "90.53330000"
                    },
                    {
                        "id": 153839,
                        "name": "Geylegphug",
                        "latitude": "26.87060000",
                        "longitude": "90.48560000"
                    },
                    {
                        "id": 15720,
                        "name": "Sarpang",
                        "latitude": "26.86395000",
                        "longitude": "90.26745000"
                    }
                ]
            },
            {
                "id": 241,
                "name": "Thimphu ",
                "iso2": "15",
                "latitude": "27.47122160",
                "longitude": "89.63390410",
                "type": "district",
                "cities": [
                    {
                        "id": 15722,
                        "name": "Thimphu",
                        "latitude": "27.46609000",
                        "longitude": "89.64191000"
                    }
                ]
            },
            {
                "id": 5242,
                "name": "Trashi Yangtse\t",
                "iso2": "TY",
                "latitude": "27.71758500",
                "longitude": "91.19811020",
                "type": "district",
                "cities": [
                    {
                        "id": 153842,
                        "name": "Shali",
                        "latitude": "27.48330000",
                        "longitude": "91.56670000"
                    },
                    {
                        "id": 153843,
                        "name": "Trashi Yangtse",
                        "latitude": "27.58330000",
                        "longitude": "91.46670000"
                    },
                    {
                        "id": 153844,
                        "name": "Yalang ",
                        "latitude": "27.43330000",
                        "longitude": "91.63330000"
                    }
                ]
            },
            {
                "id": 236,
                "name": "Trashigang ",
                "iso2": "41",
                "latitude": "27.25667950",
                "longitude": "91.75388170",
                "type": "district",
                "cities": [
                    {
                        "id": 153850,
                        "name": "Balfai",
                        "latitude": "27.21670320",
                        "longitude": "91.47940030"
                    },
                    {
                        "id": 153846,
                        "name": "Ghunkarah",
                        "latitude": "27.40000000",
                        "longitude": "91.56670000"
                    },
                    {
                        "id": 153845,
                        "name": "Ngalangkang",
                        "latitude": "27.45282330",
                        "longitude": "91.56477710"
                    },
                    {
                        "id": 153847,
                        "name": "Rungzyung",
                        "latitude": "27.35000000",
                        "longitude": "91.66670000"
                    },
                    {
                        "id": 153851,
                        "name": "Sassi",
                        "latitude": "27.13330000",
                        "longitude": "91.43330000"
                    },
                    {
                        "id": 153849,
                        "name": "Thrimshing",
                        "latitude": "27.13330000",
                        "longitude": "91.61670000"
                    },
                    {
                        "id": 15724,
                        "name": "Trashigang",
                        "latitude": "27.33310000",
                        "longitude": "91.55424000"
                    },
                    {
                        "id": 153848,
                        "name": "Wamrong",
                        "latitude": "27.13784530",
                        "longitude": "91.56044470"
                    }
                ]
            },
            {
                "id": 245,
                "name": "Trongsa ",
                "iso2": "32",
                "latitude": "27.50022690",
                "longitude": "90.50806340",
                "type": "district",
                "cities": [
                    {
                        "id": 153852,
                        "name": "Trongsa",
                        "latitude": "27.49940000",
                        "longitude": "90.50470000"
                    }
                ]
            },
            {
                "id": 230,
                "name": "Tsirang ",
                "iso2": "21",
                "latitude": "27.03220700",
                "longitude": "90.18696440",
                "type": "district",
                "cities": [
                    {
                        "id": 153854,
                        "name": "Beteni",
                        "latitude": "27.03330000",
                        "longitude": "90.23330000"
                    },
                    {
                        "id": 153853,
                        "name": "Dagapela",
                        "latitude": "26.93330000",
                        "longitude": "89.95000000"
                    },
                    {
                        "id": 15725,
                        "name": "Damphu",
                        "latitude": "27.01670000",
                        "longitude": "90.10000000"
                    },
                    {
                        "id": 15727,
                        "name": "Tsirang",
                        "latitude": "27.02190000",
                        "longitude": "90.12291000"
                    }
                ]
            },
            {
                "id": 231,
                "name": "Wangdue Phodrang ",
                "iso2": "24",
                "latitude": "27.45260460",
                "longitude": "90.06749280",
                "type": "district",
                "cities": [
                    {
                        "id": 153856,
                        "name": "Manikyangsa",
                        "latitude": "27.53330000",
                        "longitude": "90.10000000"
                    },
                    {
                        "id": 153855,
                        "name": "Ritang",
                        "latitude": "27.55000000",
                        "longitude": "90.16670000"
                    },
                    {
                        "id": 15723,
                        "name": "Wangdue Phodrang",
                        "latitude": "27.48330000",
                        "longitude": "89.90000000"
                    }
                ]
            },
            {
                "id": 233,
                "name": "Zhemgang ",
                "iso2": "34",
                "latitude": "27.07697500",
                "longitude": "90.82940020",
                "type": "district",
                "cities": [
                    {
                        "id": 15713,
                        "name": "Panbang",
                        "latitude": "26.86667000",
                        "longitude": "90.98333000"
                    },
                    {
                        "id": 15721,
                        "name": "Zhemgang",
                        "latitude": "27.21689000",
                        "longitude": "90.65793000"
                    }
                ]
            }
        ]
    },
    {
        "id": 27,
        "name": "Bolivia",
        "iso3": "BOL",
        "iso2": "BO",
        "numeric_code": "068",
        "phonecode": "591",
        "capital": "Sucre",
        "currency": "BOB",
        "currency_name": "Bolivian boliviano",
        "currency_symbol": "Bs.",
        "tld": ".bo",
        "native": "Bolivia",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Bolivian",
        "timezones": [
            {
                "zoneName": "America\/La_Paz",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "BOT",
                "tzName": "Bolivia Time"
            }
        ],
        "translations": {
            "br": "Bolivia",
            "ko": "볼리비아",
            "pt-BR": "Bolívia",
            "pt": "Bolívia",
            "nl": "Bolivia",
            "hr": "Bolivija",
            "fa": "بولیوی",
            "de": "Bolivien",
            "es": "Bolivia",
            "fr": "Bolivie",
            "ja": "ボリビア多民族国",
            "it": "Bolivia",
            "zh-CN": "玻利维亚",
            "tr": "Bolivya",
            "ru": "Боливия",
            "uk": "Болівія",
            "pl": "Boliwia"
        },
        "latitude": "-17.00000000",
        "longitude": "-65.00000000",
        "emoji": "🇧🇴",
        "emojiU": "U+1F1E7 U+1F1F4",
        "states": [
            {
                "id": 3375,
                "name": "Beni",
                "iso2": "B",
                "latitude": "-14.37827470",
                "longitude": "-65.09577920",
                "type": "department",
                "cities": [
                    {
                        "id": 9867,
                        "name": "Guayaramerín",
                        "latitude": "-10.82580000",
                        "longitude": "-65.35810000"
                    },
                    {
                        "id": 9920,
                        "name": "Provincia Cercado",
                        "latitude": "-14.50000000",
                        "longitude": "-64.33333000"
                    },
                    {
                        "id": 9932,
                        "name": "Provincia General José Ballivián",
                        "latitude": "-14.00000000",
                        "longitude": "-67.08333000"
                    },
                    {
                        "id": 9941,
                        "name": "Provincia Iténez",
                        "latitude": "-13.41667000",
                        "longitude": "-63.50000000"
                    },
                    {
                        "id": 9949,
                        "name": "Provincia Mamoré",
                        "latitude": "-13.00000000",
                        "longitude": "-64.91667000"
                    },
                    {
                        "id": 9953,
                        "name": "Provincia Marbán",
                        "latitude": "-15.66667000",
                        "longitude": "-64.33333000"
                    },
                    {
                        "id": 9956,
                        "name": "Provincia Moxos",
                        "latitude": "-15.16667000",
                        "longitude": "-65.50000000"
                    },
                    {
                        "id": 9990,
                        "name": "Provincia Vaca Diez",
                        "latitude": "-11.66667000",
                        "longitude": "-66.00000000"
                    },
                    {
                        "id": 9994,
                        "name": "Provincia Yacuma",
                        "latitude": "-13.50000000",
                        "longitude": "-66.00000000"
                    },
                    {
                        "id": 10005,
                        "name": "Reyes",
                        "latitude": "-14.29520000",
                        "longitude": "-67.33624000"
                    },
                    {
                        "id": 10006,
                        "name": "Riberalta",
                        "latitude": "-11.00654000",
                        "longitude": "-66.06312000"
                    },
                    {
                        "id": 10008,
                        "name": "Rurrenabaque",
                        "latitude": "-14.44125000",
                        "longitude": "-67.52781000"
                    },
                    {
                        "id": 10011,
                        "name": "San Borja",
                        "latitude": "-14.81667000",
                        "longitude": "-66.85000000"
                    },
                    {
                        "id": 10020,
                        "name": "San Ramón",
                        "latitude": "-13.28333000",
                        "longitude": "-64.71667000"
                    },
                    {
                        "id": 10021,
                        "name": "Santa Ana de Yacuma",
                        "latitude": "-13.74406000",
                        "longitude": "-65.42688000"
                    },
                    {
                        "id": 10025,
                        "name": "Santa Rosa",
                        "latitude": "-14.16667000",
                        "longitude": "-66.88333000"
                    },
                    {
                        "id": 10041,
                        "name": "Trinidad",
                        "latitude": "-14.83333000",
                        "longitude": "-64.90000000"
                    }
                ]
            },
            {
                "id": 3382,
                "name": "Chuquisaca",
                "iso2": "H",
                "latitude": "-20.02491440",
                "longitude": "-64.14782360",
                "type": "department",
                "cities": [
                    {
                        "id": 9839,
                        "name": "Camargo",
                        "latitude": "-20.64064000",
                        "longitude": "-65.20893000"
                    },
                    {
                        "id": 9887,
                        "name": "Monteagudo",
                        "latitude": "-19.79989000",
                        "longitude": "-63.95461000"
                    },
                    {
                        "id": 9892,
                        "name": "Padilla",
                        "latitude": "-19.30878000",
                        "longitude": "-64.30273000"
                    },
                    {
                        "id": 9909,
                        "name": "Provincia Azurduy",
                        "latitude": "-20.00000000",
                        "longitude": "-64.50000000"
                    },
                    {
                        "id": 9911,
                        "name": "Provincia Belisario Boeto",
                        "latitude": "-18.91667000",
                        "longitude": "-64.33333000"
                    },
                    {
                        "id": 9936,
                        "name": "Provincia Hernando Siles",
                        "latitude": "-20.16667000",
                        "longitude": "-64.25000000"
                    },
                    {
                        "id": 9947,
                        "name": "Provincia Luis Calvo",
                        "latitude": "-20.66667000",
                        "longitude": "-63.50000000"
                    },
                    {
                        "id": 9962,
                        "name": "Provincia Nor Cinti",
                        "latitude": "-20.33333000",
                        "longitude": "-65.00000000"
                    },
                    {
                        "id": 9966,
                        "name": "Provincia Oropeza",
                        "latitude": "-18.66667000",
                        "longitude": "-65.16667000"
                    },
                    {
                        "id": 9983,
                        "name": "Provincia Sud Cinti",
                        "latitude": "-20.91667000",
                        "longitude": "-64.91667000"
                    },
                    {
                        "id": 9987,
                        "name": "Provincia Tomina",
                        "latitude": "-19.50000000",
                        "longitude": "-64.16667000"
                    },
                    {
                        "id": 9995,
                        "name": "Provincia Yamparáez",
                        "latitude": "-19.16667000",
                        "longitude": "-64.91667000"
                    },
                    {
                        "id": 9996,
                        "name": "Provincia Zudáñez",
                        "latitude": "-18.91667000",
                        "longitude": "-64.83333000"
                    },
                    {
                        "id": 10031,
                        "name": "Sucre",
                        "latitude": "-19.03332000",
                        "longitude": "-65.26274000"
                    },
                    {
                        "id": 10033,
                        "name": "Tarabuco",
                        "latitude": "-19.18168000",
                        "longitude": "-64.91517000"
                    }
                ]
            },
            {
                "id": 3381,
                "name": "Cochabamba",
                "iso2": "C",
                "latitude": "-17.56816750",
                "longitude": "-65.47573600",
                "type": "department",
                "cities": [
                    {
                        "id": 9827,
                        "name": "Aiquile",
                        "latitude": "-18.20408000",
                        "longitude": "-65.18068000"
                    },
                    {
                        "id": 9829,
                        "name": "Arani",
                        "latitude": "-17.56854000",
                        "longitude": "-65.76883000"
                    },
                    {
                        "id": 9836,
                        "name": "Bolivar",
                        "latitude": "-17.96667000",
                        "longitude": "-66.53333000"
                    },
                    {
                        "id": 9841,
                        "name": "Capinota",
                        "latitude": "-17.71113000",
                        "longitude": "-66.26082000"
                    },
                    {
                        "id": 9845,
                        "name": "Chimoré",
                        "latitude": "-16.99417000",
                        "longitude": "-65.15330000"
                    },
                    {
                        "id": 9847,
                        "name": "Cliza",
                        "latitude": "-17.58777000",
                        "longitude": "-65.93253000"
                    },
                    {
                        "id": 9849,
                        "name": "Cochabamba",
                        "latitude": "-17.38950000",
                        "longitude": "-66.15680000"
                    },
                    {
                        "id": 9850,
                        "name": "Colchani",
                        "latitude": "-17.31667000",
                        "longitude": "-66.71667000"
                    },
                    {
                        "id": 9852,
                        "name": "Colomi",
                        "latitude": "-17.35000000",
                        "longitude": "-65.86667000"
                    },
                    {
                        "id": 9871,
                        "name": "Independencia",
                        "latitude": "-17.08389000",
                        "longitude": "-66.81804000"
                    },
                    {
                        "id": 9872,
                        "name": "Irpa Irpa",
                        "latitude": "-17.71667000",
                        "longitude": "-66.26667000"
                    },
                    {
                        "id": 9886,
                        "name": "Mizque",
                        "latitude": "-17.94101000",
                        "longitude": "-65.34016000"
                    },
                    {
                        "id": 9902,
                        "name": "Provincia Arani",
                        "latitude": "-17.50000000",
                        "longitude": "-65.50000000"
                    },
                    {
                        "id": 9905,
                        "name": "Provincia Arque",
                        "latitude": "-17.75000000",
                        "longitude": "-66.66667000"
                    },
                    {
                        "id": 9908,
                        "name": "Provincia Ayopaya",
                        "latitude": "-16.50000000",
                        "longitude": "-66.58333000"
                    },
                    {
                        "id": 9913,
                        "name": "Provincia Campero",
                        "latitude": "-18.33333000",
                        "longitude": "-65.00000000"
                    },
                    {
                        "id": 9914,
                        "name": "Provincia Capinota",
                        "latitude": "-17.83333000",
                        "longitude": "-66.16667000"
                    },
                    {
                        "id": 9916,
                        "name": "Provincia Carrasco",
                        "latitude": "-17.50000000",
                        "longitude": "-65.00000000"
                    },
                    {
                        "id": 9918,
                        "name": "Provincia Cercado",
                        "latitude": "-17.33333000",
                        "longitude": "-66.16667000"
                    },
                    {
                        "id": 9921,
                        "name": "Provincia Chaparé",
                        "latitude": "-16.50000000",
                        "longitude": "-65.50000000"
                    },
                    {
                        "id": 9927,
                        "name": "Provincia Esteban Arce",
                        "latitude": "-17.66667000",
                        "longitude": "-66.00000000"
                    },
                    {
                        "id": 9933,
                        "name": "Provincia Germán Jordán",
                        "latitude": "-17.58333000",
                        "longitude": "-65.91667000"
                    },
                    {
                        "id": 9954,
                        "name": "Provincia Mizque",
                        "latitude": "-17.90655000",
                        "longitude": "-65.39440000"
                    },
                    {
                        "id": 9971,
                        "name": "Provincia Punata",
                        "latitude": "-17.50000000",
                        "longitude": "-65.91667000"
                    },
                    {
                        "id": 9973,
                        "name": "Provincia Quillacollo",
                        "latitude": "-17.50000000",
                        "longitude": "-66.50000000"
                    },
                    {
                        "id": 9986,
                        "name": "Provincia Tapacarí",
                        "latitude": "-17.51146000",
                        "longitude": "-66.61965000"
                    },
                    {
                        "id": 10002,
                        "name": "Punata",
                        "latitude": "-17.54234000",
                        "longitude": "-65.83472000"
                    },
                    {
                        "id": 10003,
                        "name": "Quillacollo",
                        "latitude": "-17.39228000",
                        "longitude": "-66.27838000"
                    },
                    {
                        "id": 10009,
                        "name": "Sacaba",
                        "latitude": "-17.39799000",
                        "longitude": "-66.03825000"
                    },
                    {
                        "id": 10029,
                        "name": "Sipe Sipe",
                        "latitude": "-17.45000000",
                        "longitude": "-66.38333000"
                    },
                    {
                        "id": 10034,
                        "name": "Tarata",
                        "latitude": "-17.60898000",
                        "longitude": "-66.02135000"
                    },
                    {
                        "id": 10037,
                        "name": "Tiquipaya",
                        "latitude": "-17.33801000",
                        "longitude": "-66.21579000"
                    },
                    {
                        "id": 10038,
                        "name": "Tiraque Province",
                        "latitude": "-17.33333000",
                        "longitude": "-65.91667000"
                    },
                    {
                        "id": 10039,
                        "name": "Totora",
                        "latitude": "-17.72662000",
                        "longitude": "-65.19320000"
                    }
                ]
            },
            {
                "id": 3380,
                "name": "La Paz",
                "iso2": "L",
                "latitude": "-14.93157820",
                "longitude": "-70.82999670",
                "type": "department",
                "cities": [
                    {
                        "id": 9826,
                        "name": "Achacachi",
                        "latitude": "-16.05000000",
                        "longitude": "-68.68333000"
                    },
                    {
                        "id": 9828,
                        "name": "Amarete",
                        "latitude": "-15.23675000",
                        "longitude": "-68.98462000"
                    },
                    {
                        "id": 9833,
                        "name": "Batallas",
                        "latitude": "-16.30000000",
                        "longitude": "-68.53333000"
                    },
                    {
                        "id": 9842,
                        "name": "Caranavi",
                        "latitude": "-15.83652000",
                        "longitude": "-67.56901000"
                    },
                    {
                        "id": 9846,
                        "name": "Chulumani",
                        "latitude": "-16.40855000",
                        "longitude": "-67.52940000"
                    },
                    {
                        "id": 9854,
                        "name": "Colquiri",
                        "latitude": "-17.38918000",
                        "longitude": "-67.12671000"
                    },
                    {
                        "id": 9857,
                        "name": "Coripata",
                        "latitude": "-16.30000000",
                        "longitude": "-67.60000000"
                    },
                    {
                        "id": 9858,
                        "name": "Coroico",
                        "latitude": "-16.19386000",
                        "longitude": "-67.72998000"
                    },
                    {
                        "id": 9860,
                        "name": "Curahuara de Carangas",
                        "latitude": "-17.86667000",
                        "longitude": "-68.43333000"
                    },
                    {
                        "id": 9863,
                        "name": "Eucaliptus",
                        "latitude": "-17.58333000",
                        "longitude": "-67.51667000"
                    },
                    {
                        "id": 9865,
                        "name": "Guanay",
                        "latitude": "-15.49756000",
                        "longitude": "-67.88332000"
                    },
                    {
                        "id": 9869,
                        "name": "Huarina",
                        "latitude": "-16.20000000",
                        "longitude": "-68.63333000"
                    },
                    {
                        "id": 9870,
                        "name": "Huatajata",
                        "latitude": "-16.20000000",
                        "longitude": "-68.68333000"
                    },
                    {
                        "id": 9874,
                        "name": "José Manuel Pando",
                        "latitude": "-16.18970000",
                        "longitude": "-67.72664000"
                    },
                    {
                        "id": 9876,
                        "name": "La Paz",
                        "latitude": "-16.50000000",
                        "longitude": "-68.15000000"
                    },
                    {
                        "id": 9877,
                        "name": "Lahuachaca",
                        "latitude": "-17.37054000",
                        "longitude": "-67.67501000"
                    },
                    {
                        "id": 9884,
                        "name": "Mapiri",
                        "latitude": "-15.25000000",
                        "longitude": "-68.16667000"
                    },
                    {
                        "id": 9894,
                        "name": "Patacamaya",
                        "latitude": "-17.23580000",
                        "longitude": "-67.92169000"
                    },
                    {
                        "id": 9904,
                        "name": "Provincia Aroma",
                        "latitude": "-17.50000000",
                        "longitude": "-68.00000000"
                    },
                    {
                        "id": 9910,
                        "name": "Provincia Bautista Saavedra",
                        "latitude": "-15.00000000",
                        "longitude": "-68.91667000"
                    },
                    {
                        "id": 9912,
                        "name": "Provincia Camacho",
                        "latitude": "-15.50000000",
                        "longitude": "-69.00000000"
                    },
                    {
                        "id": 9929,
                        "name": "Provincia Franz Tamayo",
                        "latitude": "-14.50000000",
                        "longitude": "-68.33333000"
                    },
                    {
                        "id": 9935,
                        "name": "Provincia Gualberto Villarroel",
                        "latitude": "-17.58333000",
                        "longitude": "-68.00000000"
                    },
                    {
                        "id": 9938,
                        "name": "Provincia Ingavi",
                        "latitude": "-16.83333000",
                        "longitude": "-68.66667000"
                    },
                    {
                        "id": 9939,
                        "name": "Provincia Inquisivi",
                        "latitude": "-17.00000000",
                        "longitude": "-67.08333000"
                    },
                    {
                        "id": 9940,
                        "name": "Provincia Iturralde",
                        "latitude": "-13.00000000",
                        "longitude": "-68.00000000"
                    },
                    {
                        "id": 9943,
                        "name": "Provincia Larecaja",
                        "latitude": "-15.50000000",
                        "longitude": "-68.33333000"
                    },
                    {
                        "id": 9945,
                        "name": "Provincia Loayza",
                        "latitude": "-17.00000000",
                        "longitude": "-67.66667000"
                    },
                    {
                        "id": 9946,
                        "name": "Provincia Los Andes",
                        "latitude": "-16.33333000",
                        "longitude": "-68.50000000"
                    },
                    {
                        "id": 9950,
                        "name": "Provincia Manco Kapac",
                        "latitude": "-16.00000000",
                        "longitude": "-69.16667000"
                    },
                    {
                        "id": 9958,
                        "name": "Provincia Muñecas",
                        "latitude": "-15.33333000",
                        "longitude": "-68.66667000"
                    },
                    {
                        "id": 9957,
                        "name": "Provincia Murillo",
                        "latitude": "-16.33333000",
                        "longitude": "-68.00000000"
                    },
                    {
                        "id": 9964,
                        "name": "Provincia Nor Yungas",
                        "latitude": "-16.00000000",
                        "longitude": "-67.50000000"
                    },
                    {
                        "id": 9965,
                        "name": "Provincia Omasuyos",
                        "latitude": "-15.91667000",
                        "longitude": "-68.83333000"
                    },
                    {
                        "id": 9968,
                        "name": "Provincia Pacajes",
                        "latitude": "-17.50000000",
                        "longitude": "-69.00000000"
                    },
                    {
                        "id": 9985,
                        "name": "Provincia Sud Yungas",
                        "latitude": "-16.50000000",
                        "longitude": "-67.50000000"
                    },
                    {
                        "id": 10004,
                        "name": "Quime",
                        "latitude": "-16.98333000",
                        "longitude": "-67.21667000"
                    },
                    {
                        "id": 10017,
                        "name": "San Pablo",
                        "latitude": "-16.21667000",
                        "longitude": "-68.83333000"
                    },
                    {
                        "id": 10019,
                        "name": "San Pedro",
                        "latitude": "-16.23717000",
                        "longitude": "-68.85063000"
                    },
                    {
                        "id": 10030,
                        "name": "Sorata",
                        "latitude": "-15.77305000",
                        "longitude": "-68.64973000"
                    },
                    {
                        "id": 10036,
                        "name": "Tiahuanaco",
                        "latitude": "-16.55228000",
                        "longitude": "-68.67953000"
                    },
                    {
                        "id": 10049,
                        "name": "Viloco",
                        "latitude": "-16.95000000",
                        "longitude": "-67.55000000"
                    },
                    {
                        "id": 10052,
                        "name": "Yumani",
                        "latitude": "-16.03574000",
                        "longitude": "-69.14843000"
                    }
                ]
            },
            {
                "id": 3376,
                "name": "Oruro",
                "iso2": "O",
                "latitude": "-18.57115790",
                "longitude": "-67.76159830",
                "type": "department",
                "cities": [
                    {
                        "id": 9843,
                        "name": "Challapata",
                        "latitude": "-18.90208000",
                        "longitude": "-66.77048000"
                    },
                    {
                        "id": 9868,
                        "name": "Huanuni",
                        "latitude": "-18.28900000",
                        "longitude": "-66.83583000"
                    },
                    {
                        "id": 9879,
                        "name": "Litoral de Atacama",
                        "latitude": "-18.76071000",
                        "longitude": "-68.24295000"
                    },
                    {
                        "id": 9882,
                        "name": "Machacamarca",
                        "latitude": "-18.17251000",
                        "longitude": "-67.02099000"
                    },
                    {
                        "id": 9889,
                        "name": "Nor Carangas Province",
                        "latitude": "-17.83750000",
                        "longitude": "-67.94330000"
                    },
                    {
                        "id": 9891,
                        "name": "Oruro",
                        "latitude": "-17.98333000",
                        "longitude": "-67.15000000"
                    },
                    {
                        "id": 9896,
                        "name": "Poopó",
                        "latitude": "-18.38026000",
                        "longitude": "-66.96695000"
                    },
                    {
                        "id": 9906,
                        "name": "Provincia Avaroa",
                        "latitude": "-19.00000000",
                        "longitude": "-66.66667000"
                    },
                    {
                        "id": 9915,
                        "name": "Provincia Carangas",
                        "latitude": "-18.33333000",
                        "longitude": "-67.75000000"
                    },
                    {
                        "id": 9917,
                        "name": "Provincia Cercado",
                        "latitude": "-17.91667000",
                        "longitude": "-67.08333000"
                    },
                    {
                        "id": 9942,
                        "name": "Provincia Ladislao Cabrera",
                        "latitude": "-19.50000000",
                        "longitude": "-67.66667000"
                    },
                    {
                        "id": 9969,
                        "name": "Provincia Pantaleón Dalence",
                        "latitude": "-18.33333000",
                        "longitude": "-66.91667000"
                    },
                    {
                        "id": 9970,
                        "name": "Provincia Poopó",
                        "latitude": "-18.50000000",
                        "longitude": "-66.91667000"
                    },
                    {
                        "id": 9976,
                        "name": "Provincia Sabaya",
                        "latitude": "-19.00000000",
                        "longitude": "-68.58333000"
                    },
                    {
                        "id": 9977,
                        "name": "Provincia Sajama",
                        "latitude": "-18.20000000",
                        "longitude": "-68.55000000"
                    },
                    {
                        "id": 9978,
                        "name": "Provincia San Pedro de Totora",
                        "latitude": "-17.83333000",
                        "longitude": "-68.20000000"
                    },
                    {
                        "id": 9981,
                        "name": "Provincia Saucari",
                        "latitude": "-18.25000000",
                        "longitude": "-67.41667000"
                    },
                    {
                        "id": 9988,
                        "name": "Provincia Tomás Barron",
                        "latitude": "-17.83333000",
                        "longitude": "-68.25000000"
                    },
                    {
                        "id": 10000,
                        "name": "Puerto de Mejillones",
                        "latitude": "-18.99266000",
                        "longitude": "-68.68446000"
                    },
                    {
                        "id": 10028,
                        "name": "Sebastian Pagador Province",
                        "latitude": "-19.21667000",
                        "longitude": "-66.21667000"
                    },
                    {
                        "id": 10032,
                        "name": "Sud Carangas Province",
                        "latitude": "-18.50000000",
                        "longitude": "-68.25000000"
                    },
                    {
                        "id": 10040,
                        "name": "Totoral",
                        "latitude": "-18.49587000",
                        "longitude": "-66.87380000"
                    }
                ]
            },
            {
                "id": 3379,
                "name": "Pando",
                "iso2": "N",
                "latitude": "-10.79889010",
                "longitude": "-66.99880110",
                "type": "department",
                "cities": [
                    {
                        "id": 9848,
                        "name": "Cobija",
                        "latitude": "-11.02671000",
                        "longitude": "-68.76918000"
                    },
                    {
                        "id": 9899,
                        "name": "Provincia Abuná",
                        "latitude": "-10.50000000",
                        "longitude": "-66.50000000"
                    },
                    {
                        "id": 9931,
                        "name": "Provincia General Federico Román",
                        "latitude": "-10.33333000",
                        "longitude": "-65.88333000"
                    },
                    {
                        "id": 9948,
                        "name": "Provincia Madre de Dios",
                        "latitude": "-11.58333000",
                        "longitude": "-67.00000000"
                    },
                    {
                        "id": 9952,
                        "name": "Provincia Manuripi",
                        "latitude": "-11.33333000",
                        "longitude": "-67.50000000"
                    },
                    {
                        "id": 9960,
                        "name": "Provincia Nicolás Suárez",
                        "latitude": "-11.33333000",
                        "longitude": "-68.50000000"
                    }
                ]
            },
            {
                "id": 3383,
                "name": "Potosí",
                "iso2": "P",
                "latitude": "-20.62471300",
                "longitude": "-66.99880110",
                "type": "department",
                "cities": [
                    {
                        "id": 9832,
                        "name": "Atocha",
                        "latitude": "-20.93515000",
                        "longitude": "-66.22139000"
                    },
                    {
                        "id": 9835,
                        "name": "Betanzos",
                        "latitude": "-19.55293000",
                        "longitude": "-65.45395000"
                    },
                    {
                        "id": 9851,
                        "name": "Colchani",
                        "latitude": "-20.30000000",
                        "longitude": "-66.93333000"
                    },
                    {
                        "id": 9853,
                        "name": "Colquechaca",
                        "latitude": "-18.70031000",
                        "longitude": "-66.00397000"
                    },
                    {
                        "id": 9861,
                        "name": "Enrique Baldivieso",
                        "latitude": "-21.38323000",
                        "longitude": "-67.60368000"
                    },
                    {
                        "id": 9880,
                        "name": "Llallagua",
                        "latitude": "-18.42426000",
                        "longitude": "-66.58388000"
                    },
                    {
                        "id": 9898,
                        "name": "Potosí",
                        "latitude": "-19.58361000",
                        "longitude": "-65.75306000"
                    },
                    {
                        "id": 9900,
                        "name": "Provincia Alonzo de Ibáñez",
                        "latitude": "-18.50000000",
                        "longitude": "-66.33333000"
                    },
                    {
                        "id": 9922,
                        "name": "Provincia Charcas",
                        "latitude": "-18.33333000",
                        "longitude": "-65.83333000"
                    },
                    {
                        "id": 9923,
                        "name": "Provincia Chayanta",
                        "latitude": "-18.91667000",
                        "longitude": "-66.00000000"
                    },
                    {
                        "id": 9926,
                        "name": "Provincia Daniel Campos",
                        "latitude": "-20.25000000",
                        "longitude": "-68.25000000"
                    },
                    {
                        "id": 9930,
                        "name": "Provincia General Bilbao",
                        "latitude": "-18.08333000",
                        "longitude": "-66.00000000"
                    },
                    {
                        "id": 9944,
                        "name": "Provincia Linares",
                        "latitude": "-19.83333000",
                        "longitude": "-65.50000000"
                    },
                    {
                        "id": 9955,
                        "name": "Provincia Modesto Omiste",
                        "latitude": "-21.91667000",
                        "longitude": "-65.58333000"
                    },
                    {
                        "id": 9961,
                        "name": "Provincia Nor Chichas",
                        "latitude": "-20.66667000",
                        "longitude": "-66.00000000"
                    },
                    {
                        "id": 9963,
                        "name": "Provincia Nor Lípez",
                        "latitude": "-20.50000000",
                        "longitude": "-67.83333000"
                    },
                    {
                        "id": 9972,
                        "name": "Provincia Quijarro",
                        "latitude": "-20.00000000",
                        "longitude": "-66.33333000"
                    },
                    {
                        "id": 9974,
                        "name": "Provincia Rafael Bustillo",
                        "latitude": "-18.33333000",
                        "longitude": "-66.50000000"
                    },
                    {
                        "id": 9975,
                        "name": "Provincia Saavedra",
                        "latitude": "-19.25000000",
                        "longitude": "-65.50000000"
                    },
                    {
                        "id": 9982,
                        "name": "Provincia Sud Chichas",
                        "latitude": "-21.50000000",
                        "longitude": "-66.00000000"
                    },
                    {
                        "id": 9984,
                        "name": "Provincia Sud Lípez",
                        "latitude": "-22.00000000",
                        "longitude": "-67.50000000"
                    },
                    {
                        "id": 9989,
                        "name": "Provincia Tomás Frías",
                        "latitude": "-19.33333000",
                        "longitude": "-66.00000000"
                    },
                    {
                        "id": 10022,
                        "name": "Santa Bárbara",
                        "latitude": "-20.91667000",
                        "longitude": "-66.05000000"
                    },
                    {
                        "id": 10042,
                        "name": "Tupiza",
                        "latitude": "-21.44345000",
                        "longitude": "-65.71875000"
                    },
                    {
                        "id": 10044,
                        "name": "Uyuni",
                        "latitude": "-20.45967000",
                        "longitude": "-66.82503000"
                    },
                    {
                        "id": 10048,
                        "name": "Villazón",
                        "latitude": "-22.08659000",
                        "longitude": "-65.59422000"
                    }
                ]
            },
            {
                "id": 3377,
                "name": "Santa Cruz",
                "iso2": "S",
                "latitude": "-16.74760370",
                "longitude": "-62.07509980",
                "type": "department",
                "cities": [
                    {
                        "id": 9825,
                        "name": "Abapó",
                        "latitude": "-18.88279000",
                        "longitude": "-63.38026000"
                    },
                    {
                        "id": 9830,
                        "name": "Ascención de Guarayos",
                        "latitude": "-15.89299000",
                        "longitude": "-63.18855000"
                    },
                    {
                        "id": 9831,
                        "name": "Ascensión",
                        "latitude": "-15.70000000",
                        "longitude": "-63.08333000"
                    },
                    {
                        "id": 9837,
                        "name": "Boyuibe",
                        "latitude": "-20.43227000",
                        "longitude": "-63.28147000"
                    },
                    {
                        "id": 9838,
                        "name": "Buena Vista",
                        "latitude": "-17.45830000",
                        "longitude": "-63.67126000"
                    },
                    {
                        "id": 9840,
                        "name": "Camiri",
                        "latitude": "-20.03849000",
                        "longitude": "-63.51833000"
                    },
                    {
                        "id": 9844,
                        "name": "Charagua",
                        "latitude": "-19.79151000",
                        "longitude": "-63.19864000"
                    },
                    {
                        "id": 9855,
                        "name": "Comarapa",
                        "latitude": "-17.91537000",
                        "longitude": "-64.53163000"
                    },
                    {
                        "id": 9856,
                        "name": "Concepción",
                        "latitude": "-16.43333000",
                        "longitude": "-60.90000000"
                    },
                    {
                        "id": 9859,
                        "name": "Cotoca",
                        "latitude": "-17.81667000",
                        "longitude": "-63.05000000"
                    },
                    {
                        "id": 9864,
                        "name": "German Busch",
                        "latitude": "-17.77317000",
                        "longitude": "-63.19087000"
                    },
                    {
                        "id": 9866,
                        "name": "Guarayos",
                        "latitude": "-15.82132000",
                        "longitude": "-63.24280000"
                    },
                    {
                        "id": 9873,
                        "name": "Jorochito",
                        "latitude": "-18.05514000",
                        "longitude": "-63.42821000"
                    },
                    {
                        "id": 9875,
                        "name": "La Bélgica",
                        "latitude": "-17.55000000",
                        "longitude": "-63.21667000"
                    },
                    {
                        "id": 9878,
                        "name": "Limoncito",
                        "latitude": "-18.03104000",
                        "longitude": "-63.40523000"
                    },
                    {
                        "id": 9881,
                        "name": "Los Negros",
                        "latitude": "-17.73333000",
                        "longitude": "-63.43333000"
                    },
                    {
                        "id": 9883,
                        "name": "Mairana",
                        "latitude": "-18.11919000",
                        "longitude": "-63.95965000"
                    },
                    {
                        "id": 9885,
                        "name": "Mineros",
                        "latitude": "-17.11876000",
                        "longitude": "-63.23100000"
                    },
                    {
                        "id": 9888,
                        "name": "Montero",
                        "latitude": "-17.33866000",
                        "longitude": "-63.25050000"
                    },
                    {
                        "id": 9890,
                        "name": "Okinawa Número Uno",
                        "latitude": "-17.23333000",
                        "longitude": "-62.81667000"
                    },
                    {
                        "id": 9893,
                        "name": "Pailón",
                        "latitude": "-17.65000000",
                        "longitude": "-62.75000000"
                    },
                    {
                        "id": 9895,
                        "name": "Paurito",
                        "latitude": "-17.88333000",
                        "longitude": "-62.96667000"
                    },
                    {
                        "id": 9897,
                        "name": "Portachuelo",
                        "latitude": "-17.35168000",
                        "longitude": "-63.39282000"
                    },
                    {
                        "id": 9901,
                        "name": "Provincia Andrés Ibáñez",
                        "latitude": "-17.75000000",
                        "longitude": "-63.25000000"
                    },
                    {
                        "id": 9997,
                        "name": "Provincia Ángel Sandoval",
                        "latitude": "-17.50000000",
                        "longitude": "-58.50000000"
                    },
                    {
                        "id": 9924,
                        "name": "Provincia Chiquitos",
                        "latitude": "-18.00000000",
                        "longitude": "-60.00000000"
                    },
                    {
                        "id": 9925,
                        "name": "Provincia Cordillera",
                        "latitude": "-19.00000000",
                        "longitude": "-61.50000000"
                    },
                    {
                        "id": 9928,
                        "name": "Provincia Florida",
                        "latitude": "-18.00000000",
                        "longitude": "-63.91667000"
                    },
                    {
                        "id": 9937,
                        "name": "Provincia Ichilo",
                        "latitude": "-17.00000000",
                        "longitude": "-64.00000000"
                    },
                    {
                        "id": 9951,
                        "name": "Provincia Manuel María Caballero",
                        "latitude": "-17.83333000",
                        "longitude": "-64.41667000"
                    },
                    {
                        "id": 9998,
                        "name": "Provincia Ñuflo de Chávez",
                        "latitude": "-15.91667000",
                        "longitude": "-62.50000000"
                    },
                    {
                        "id": 9979,
                        "name": "Provincia Santiesteban",
                        "latitude": "-16.50000000",
                        "longitude": "-63.50000000"
                    },
                    {
                        "id": 9980,
                        "name": "Provincia Sara",
                        "latitude": "-16.83333000",
                        "longitude": "-63.91667000"
                    },
                    {
                        "id": 9991,
                        "name": "Provincia Vallegrande",
                        "latitude": "-18.50000000",
                        "longitude": "-64.16667000"
                    },
                    {
                        "id": 9992,
                        "name": "Provincia Velasco",
                        "latitude": "-15.50000000",
                        "longitude": "-61.00000000"
                    },
                    {
                        "id": 9993,
                        "name": "Provincia Warnes",
                        "latitude": "-17.33333000",
                        "longitude": "-63.00000000"
                    },
                    {
                        "id": 9999,
                        "name": "Puerto Quijarro",
                        "latitude": "-17.78333000",
                        "longitude": "-57.76667000"
                    },
                    {
                        "id": 10001,
                        "name": "Puesto de Pailas",
                        "latitude": "-17.65000000",
                        "longitude": "-62.80000000"
                    },
                    {
                        "id": 10007,
                        "name": "Roboré",
                        "latitude": "-18.33473000",
                        "longitude": "-59.76142000"
                    },
                    {
                        "id": 10010,
                        "name": "Samaipata",
                        "latitude": "-18.18005000",
                        "longitude": "-63.87552000"
                    },
                    {
                        "id": 10012,
                        "name": "San Carlos",
                        "latitude": "-17.40000000",
                        "longitude": "-63.75000000"
                    },
                    {
                        "id": 10013,
                        "name": "San Ignacio de Velasco",
                        "latitude": "-16.36667000",
                        "longitude": "-60.95000000"
                    },
                    {
                        "id": 10014,
                        "name": "San Juan del Surutú",
                        "latitude": "-17.48333000",
                        "longitude": "-63.70000000"
                    },
                    {
                        "id": 10015,
                        "name": "San Julian",
                        "latitude": "-17.78333000",
                        "longitude": "-62.86667000"
                    },
                    {
                        "id": 10016,
                        "name": "San Matías",
                        "latitude": "-16.36667000",
                        "longitude": "-58.40000000"
                    },
                    {
                        "id": 10018,
                        "name": "San Pedro",
                        "latitude": "-18.28333000",
                        "longitude": "-59.81667000"
                    },
                    {
                        "id": 10023,
                        "name": "Santa Cruz de la Sierra",
                        "latitude": "-17.78629000",
                        "longitude": "-63.18117000"
                    },
                    {
                        "id": 10024,
                        "name": "Santa Rita",
                        "latitude": "-17.96667000",
                        "longitude": "-63.35000000"
                    },
                    {
                        "id": 10026,
                        "name": "Santa Rosa del Sara",
                        "latitude": "-17.10916000",
                        "longitude": "-63.59514000"
                    },
                    {
                        "id": 10027,
                        "name": "Santiago del Torno",
                        "latitude": "-17.98674000",
                        "longitude": "-63.38118000"
                    },
                    {
                        "id": 10043,
                        "name": "Urubichá",
                        "latitude": "-15.39286000",
                        "longitude": "-62.94661000"
                    },
                    {
                        "id": 10045,
                        "name": "Vallegrande",
                        "latitude": "-18.48923000",
                        "longitude": "-64.10609000"
                    },
                    {
                        "id": 10046,
                        "name": "Villa Yapacaní",
                        "latitude": "-17.40000000",
                        "longitude": "-63.83333000"
                    },
                    {
                        "id": 10050,
                        "name": "Warnes",
                        "latitude": "-17.51630000",
                        "longitude": "-63.16778000"
                    }
                ]
            },
            {
                "id": 3378,
                "name": "Tarija",
                "iso2": "T",
                "latitude": "-21.58315950",
                "longitude": "-63.95861110",
                "type": "department",
                "cities": [
                    {
                        "id": 9834,
                        "name": "Bermejo",
                        "latitude": "-22.73206000",
                        "longitude": "-64.33724000"
                    },
                    {
                        "id": 9862,
                        "name": "Entre Ríos",
                        "latitude": "-21.52661000",
                        "longitude": "-64.17299000"
                    },
                    {
                        "id": 9903,
                        "name": "Provincia Arce",
                        "latitude": "-22.16667000",
                        "longitude": "-64.33333000"
                    },
                    {
                        "id": 9907,
                        "name": "Provincia Avilez",
                        "latitude": "-21.66667000",
                        "longitude": "-65.00000000"
                    },
                    {
                        "id": 9919,
                        "name": "Provincia Cercado",
                        "latitude": "-21.58333000",
                        "longitude": "-64.58333000"
                    },
                    {
                        "id": 9934,
                        "name": "Provincia Gran Chaco",
                        "latitude": "-21.66667000",
                        "longitude": "-63.00000000"
                    },
                    {
                        "id": 9959,
                        "name": "Provincia Méndez",
                        "latitude": "-21.16667000",
                        "longitude": "-64.91667000"
                    },
                    {
                        "id": 9967,
                        "name": "Provincia O’Connor",
                        "latitude": "-21.58333000",
                        "longitude": "-64.16667000"
                    },
                    {
                        "id": 10035,
                        "name": "Tarija",
                        "latitude": "-21.53549000",
                        "longitude": "-64.72956000"
                    },
                    {
                        "id": 10047,
                        "name": "Villamontes",
                        "latitude": "-21.26235000",
                        "longitude": "-63.46903000"
                    },
                    {
                        "id": 10051,
                        "name": "Yacuiba",
                        "latitude": "-22.01643000",
                        "longitude": "-63.67753000"
                    }
                ]
            }
        ]
    },
    {
        "id": 155,
        "name": "Bonaire, Sint Eustatius and Saba",
        "iso3": "BES",
        "iso2": "BQ",
        "numeric_code": "535",
        "phonecode": "599",
        "capital": "Kralendijk",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".an",
        "native": "Caribisch Nederland",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Bonaire",
        "timezones": [
            {
                "zoneName": "America\/Anguilla",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Izelvroioù ar C'harib",
            "ko": "보네르 섬",
            "pt-BR": "Bonaire",
            "pt": "Bonaire",
            "fa": "بونیر",
            "de": "Bonaire, Sint Eustatius und Saba",
            "fr": "Bonaire, Saint-Eustache et Saba",
            "it": "Bonaire, Saint-Eustache e Saba",
            "zh-CN": "博内尔岛、圣尤斯特歇斯和萨巴岛",
            "tr": "Karayip Hollandasi",
            "ru": "Бонайре, Синт-Эстатиус и Саба",
            "uk": "Бонайре, Сент-Естатіус і Саба",
            "pl": "Bonaire, Sint Eustatius i Saba"
        },
        "latitude": "12.15000000",
        "longitude": "-68.26666700",
        "emoji": "🇧🇶",
        "emojiU": "U+1F1E7 U+1F1F6",
        "states": [
            {
                "id": 5086,
                "name": "Bonaire",
                "iso2": "BQ1",
                "latitude": "12.20189020",
                "longitude": "-68.26238220",
                "type": "special municipality",
                "cities": [
                    {
                        "id": 150058,
                        "name": "Boven Bolivia",
                        "latitude": "12.18190000",
                        "longitude": "-68.21810000"
                    },
                    {
                        "id": 150059,
                        "name": "Dorp Tera Kora",
                        "latitude": "12.13333000",
                        "longitude": "-68.26667000"
                    },
                    {
                        "id": 150060,
                        "name": "Oranjestad",
                        "latitude": "17.48333333",
                        "longitude": "-62.98333333"
                    },
                    {
                        "id": 150061,
                        "name": "Rincon",
                        "latitude": "12.23833333",
                        "longitude": "-68.33250000"
                    },
                    {
                        "id": 150062,
                        "name": "St. Johns",
                        "latitude": "17.62100750",
                        "longitude": "-63.24316830"
                    },
                    {
                        "id": 150063,
                        "name": "The Bottom",
                        "latitude": "17.62611111",
                        "longitude": "-63.24916667"
                    },
                    {
                        "id": 150064,
                        "name": "Windwardside",
                        "latitude": "17.62864000",
                        "longitude": "-63.23136000"
                    },
                    {
                        "id": 150065,
                        "name": "Zion's Hill",
                        "latitude": "17.64300000",
                        "longitude": "-63.22649000"
                    }
                ]
            },
            {
                "id": 5087,
                "name": "Saba",
                "iso2": "BQ2",
                "latitude": "17.63546420",
                "longitude": "-63.23267630",
                "type": "special municipality",
                "cities": []
            },
            {
                "id": 5088,
                "name": "Sint Eustatius",
                "iso2": "BQ3",
                "latitude": "17.48903060",
                "longitude": "-62.97355500",
                "type": "special municipality",
                "cities": []
            }
        ]
    },
    {
        "id": 28,
        "name": "Bosnia and Herzegovina",
        "iso3": "BIH",
        "iso2": "BA",
        "numeric_code": "070",
        "phonecode": "387",
        "capital": "Sarajevo",
        "currency": "BAM",
        "currency_name": "Bosnia and Herzegovina convertible mark",
        "currency_symbol": "KM",
        "tld": ".ba",
        "native": "Bosna i Hercegovina",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Bosnian or Herzegovinian",
        "timezones": [
            {
                "zoneName": "Europe\/Sarajevo",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Bosnia-ha-Herzegovina",
            "ko": "보스니아 헤르체고비나",
            "pt-BR": "Bósnia e Herzegovina",
            "pt": "Bósnia e Herzegovina",
            "nl": "Bosnië en Herzegovina",
            "hr": "Bosna i Hercegovina",
            "fa": "بوسنی و هرزگوین",
            "de": "Bosnien und Herzegowina",
            "es": "Bosnia y Herzegovina",
            "fr": "Bosnie-Herzégovine",
            "ja": "ボスニア・ヘルツェゴビナ",
            "it": "Bosnia ed Erzegovina",
            "zh-CN": "波斯尼亚和黑塞哥维那",
            "tr": "Bosna Hersek",
            "ru": "Босния и Герцеговина",
            "uk": "Боснія і Герцеговина",
            "pl": "Bośnia i Hercegowina"
        },
        "latitude": "44.00000000",
        "longitude": "18.00000000",
        "emoji": "🇧🇦",
        "emojiU": "U+1F1E7 U+1F1E6",
        "states": [
            {
                "id": 472,
                "name": "Bosnian Podrinje",
                "iso2": "05",
                "latitude": "43.68749000",
                "longitude": "18.82443940",
                "type": "canton",
                "cities": []
            },
            {
                "id": 460,
                "name": "Brčko",
                "iso2": "BRC",
                "latitude": "44.84059440",
                "longitude": "18.74215300",
                "type": "district",
                "cities": [
                    {
                        "id": 8233,
                        "name": "Brčko",
                        "latitude": "44.86995000",
                        "longitude": "18.81012000"
                    },
                    {
                        "id": 8230,
                        "name": "Brka",
                        "latitude": "44.82837000",
                        "longitude": "18.72420000"
                    }
                ]
            },
            {
                "id": 471,
                "name": "Canton 10",
                "iso2": "10",
                "latitude": "43.95341550",
                "longitude": "16.94251870",
                "type": "canton",
                "cities": []
            },
            {
                "id": 462,
                "name": "Central Bosnia",
                "iso2": "06",
                "latitude": "44.13818560",
                "longitude": "17.68667140",
                "type": "canton",
                "cities": []
            },
            {
                "id": 467,
                "name": "Federation of Bosnia and Herzegovina",
                "iso2": "BIH",
                "latitude": "43.88748970",
                "longitude": "17.84279300",
                "type": "entity",
                "cities": [
                    {
                        "id": 8217,
                        "name": "Banovići",
                        "latitude": "44.40596000",
                        "longitude": "18.52648000"
                    },
                    {
                        "id": 8218,
                        "name": "Barice",
                        "latitude": "44.54065000",
                        "longitude": "18.48069000"
                    },
                    {
                        "id": 8219,
                        "name": "Bihać",
                        "latitude": "44.81694000",
                        "longitude": "15.87083000"
                    },
                    {
                        "id": 8220,
                        "name": "Bijela",
                        "latitude": "43.60871000",
                        "longitude": "17.95078000"
                    },
                    {
                        "id": 8222,
                        "name": "Bila",
                        "latitude": "43.78265000",
                        "longitude": "16.92676000"
                    },
                    {
                        "id": 8224,
                        "name": "Blagaj",
                        "latitude": "43.25892000",
                        "longitude": "17.88815000"
                    },
                    {
                        "id": 8226,
                        "name": "Bosanska Krupa",
                        "latitude": "44.88250000",
                        "longitude": "16.15139000"
                    },
                    {
                        "id": 8227,
                        "name": "Bosanski Petrovac",
                        "latitude": "44.55537000",
                        "longitude": "16.36897000"
                    },
                    {
                        "id": 8228,
                        "name": "Bosansko Grahovo",
                        "latitude": "44.17944000",
                        "longitude": "16.36389000"
                    },
                    {
                        "id": 8229,
                        "name": "Breza",
                        "latitude": "44.01862000",
                        "longitude": "18.26063000"
                    },
                    {
                        "id": 8234,
                        "name": "Bugojno",
                        "latitude": "44.05722000",
                        "longitude": "17.45083000"
                    },
                    {
                        "id": 8235,
                        "name": "Busovača",
                        "latitude": "44.09769000",
                        "longitude": "17.87830000"
                    },
                    {
                        "id": 8236,
                        "name": "Bužim",
                        "latitude": "45.05361000",
                        "longitude": "16.03254000"
                    },
                    {
                        "id": 8431,
                        "name": "Čapljina",
                        "latitude": "43.12139000",
                        "longitude": "17.68444000"
                    },
                    {
                        "id": 8237,
                        "name": "Cazin",
                        "latitude": "44.96694000",
                        "longitude": "15.94306000"
                    },
                    {
                        "id": 8433,
                        "name": "Čelić",
                        "latitude": "44.72524000",
                        "longitude": "18.81474000"
                    },
                    {
                        "id": 8238,
                        "name": "Cim",
                        "latitude": "43.35401000",
                        "longitude": "17.78045000"
                    },
                    {
                        "id": 8435,
                        "name": "Čitluk",
                        "latitude": "43.22861000",
                        "longitude": "17.70083000"
                    },
                    {
                        "id": 8429,
                        "name": "Ćoralići",
                        "latitude": "45.00694000",
                        "longitude": "15.87194000"
                    },
                    {
                        "id": 8239,
                        "name": "Crnići",
                        "latitude": "43.13156000",
                        "longitude": "17.86452000"
                    },
                    {
                        "id": 8241,
                        "name": "Divičani",
                        "latitude": "44.36682000",
                        "longitude": "17.32678000"
                    },
                    {
                        "id": 8243,
                        "name": "Dobrinje",
                        "latitude": "44.05008000",
                        "longitude": "18.11958000"
                    },
                    {
                        "id": 8245,
                        "name": "Domaljevac",
                        "latitude": "45.06110000",
                        "longitude": "18.58612000"
                    },
                    {
                        "id": 8246,
                        "name": "Donja Dubica",
                        "latitude": "45.07559000",
                        "longitude": "18.41023000"
                    },
                    {
                        "id": 8247,
                        "name": "Donja Mahala",
                        "latitude": "45.04327000",
                        "longitude": "18.66996000"
                    },
                    {
                        "id": 8248,
                        "name": "Donja Međiđa",
                        "latitude": "44.80235000",
                        "longitude": "18.40477000"
                    },
                    {
                        "id": 8249,
                        "name": "Donji Vakuf",
                        "latitude": "44.14361000",
                        "longitude": "17.40000000"
                    },
                    {
                        "id": 8250,
                        "name": "Drežnica",
                        "latitude": "43.52891000",
                        "longitude": "17.28120000"
                    },
                    {
                        "id": 8251,
                        "name": "Drinovci",
                        "latitude": "43.35454000",
                        "longitude": "17.32536000"
                    },
                    {
                        "id": 8252,
                        "name": "Drvar",
                        "latitude": "44.37389000",
                        "longitude": "16.38083000"
                    },
                    {
                        "id": 8253,
                        "name": "Dubrave Donje",
                        "latitude": "44.48060000",
                        "longitude": "18.69709000"
                    },
                    {
                        "id": 8254,
                        "name": "Dubrave Gornje",
                        "latitude": "44.47229000",
                        "longitude": "18.72685000"
                    },
                    {
                        "id": 8255,
                        "name": "Dubravica",
                        "latitude": "44.44131000",
                        "longitude": "18.11883000"
                    },
                    {
                        "id": 8257,
                        "name": "Fojnica",
                        "latitude": "43.95952000",
                        "longitude": "17.90288000"
                    },
                    {
                        "id": 8260,
                        "name": "Glamoč",
                        "latitude": "44.04583000",
                        "longitude": "16.84861000"
                    },
                    {
                        "id": 8261,
                        "name": "Gnojnica",
                        "latitude": "44.62058000",
                        "longitude": "18.44684000"
                    },
                    {
                        "id": 8262,
                        "name": "Goražde",
                        "latitude": "43.66795000",
                        "longitude": "18.97564000"
                    },
                    {
                        "id": 8263,
                        "name": "Gorica",
                        "latitude": "43.41833000",
                        "longitude": "17.28500000"
                    },
                    {
                        "id": 8264,
                        "name": "Gornja Breza",
                        "latitude": "44.03758000",
                        "longitude": "18.24564000"
                    },
                    {
                        "id": 8265,
                        "name": "Gornja Koprivna",
                        "latitude": "45.01091000",
                        "longitude": "15.95487000"
                    },
                    {
                        "id": 8266,
                        "name": "Gornja Tuzla",
                        "latitude": "44.55659000",
                        "longitude": "18.76159000"
                    },
                    {
                        "id": 8267,
                        "name": "Gornje Moštre",
                        "latitude": "44.01911000",
                        "longitude": "18.15477000"
                    },
                    {
                        "id": 8268,
                        "name": "Gornje Živinice",
                        "latitude": "44.42921000",
                        "longitude": "18.61667000"
                    },
                    {
                        "id": 8269,
                        "name": "Gornji Vakuf",
                        "latitude": "43.93806000",
                        "longitude": "17.58833000"
                    },
                    {
                        "id": 8270,
                        "name": "Gostovići",
                        "latitude": "44.41124000",
                        "longitude": "18.17029000"
                    },
                    {
                        "id": 8273,
                        "name": "Gračanica",
                        "latitude": "43.73333000",
                        "longitude": "18.28333000"
                    },
                    {
                        "id": 8271,
                        "name": "Gradačac",
                        "latitude": "44.87851000",
                        "longitude": "18.42764000"
                    },
                    {
                        "id": 8274,
                        "name": "Gromiljak",
                        "latitude": "43.96668000",
                        "longitude": "18.05504000"
                    },
                    {
                        "id": 8275,
                        "name": "Grude",
                        "latitude": "43.37208000",
                        "longitude": "17.41449000"
                    },
                    {
                        "id": 8276,
                        "name": "Hadžići",
                        "latitude": "43.82222000",
                        "longitude": "18.20667000"
                    },
                    {
                        "id": 8277,
                        "name": "Hercegovačko-Neretvanski Kanton",
                        "latitude": "43.45722000",
                        "longitude": "17.81250000"
                    },
                    {
                        "id": 8279,
                        "name": "Hotonj",
                        "latitude": "43.89341000",
                        "longitude": "18.37751000"
                    },
                    {
                        "id": 8281,
                        "name": "Ilići",
                        "latitude": "43.34765000",
                        "longitude": "17.76848000"
                    },
                    {
                        "id": 8280,
                        "name": "Ilijaš",
                        "latitude": "43.95128000",
                        "longitude": "18.27128000"
                    },
                    {
                        "id": 8283,
                        "name": "Izačić",
                        "latitude": "44.87485000",
                        "longitude": "15.78256000"
                    },
                    {
                        "id": 8284,
                        "name": "Jablanica",
                        "latitude": "43.66028000",
                        "longitude": "17.76167000"
                    },
                    {
                        "id": 8285,
                        "name": "Jajce",
                        "latitude": "44.34203000",
                        "longitude": "17.27059000"
                    },
                    {
                        "id": 8287,
                        "name": "Jelah",
                        "latitude": "44.65400000",
                        "longitude": "17.95897000"
                    },
                    {
                        "id": 8288,
                        "name": "Jezerski",
                        "latitude": "44.98172000",
                        "longitude": "16.09447000"
                    },
                    {
                        "id": 8293,
                        "name": "Kačuni",
                        "latitude": "44.06433000",
                        "longitude": "17.93894000"
                    },
                    {
                        "id": 8289,
                        "name": "Kakanj",
                        "latitude": "44.13311000",
                        "longitude": "18.12292000"
                    },
                    {
                        "id": 8291,
                        "name": "Kanton Sarajevo",
                        "latitude": "43.84333000",
                        "longitude": "18.24222000"
                    },
                    {
                        "id": 8292,
                        "name": "Karadaglije",
                        "latitude": "44.57065000",
                        "longitude": "18.01775000"
                    },
                    {
                        "id": 8294,
                        "name": "Kiseljak",
                        "latitude": "44.48904000",
                        "longitude": "18.56982000"
                    },
                    {
                        "id": 8295,
                        "name": "Kladanj",
                        "latitude": "44.22669000",
                        "longitude": "18.69274000"
                    },
                    {
                        "id": 8296,
                        "name": "Ključ",
                        "latitude": "44.53251000",
                        "longitude": "16.77682000"
                    },
                    {
                        "id": 8299,
                        "name": "Kobilja Glava",
                        "latitude": "43.88188000",
                        "longitude": "18.38864000"
                    },
                    {
                        "id": 8306,
                        "name": "Kočerin",
                        "latitude": "43.39005000",
                        "longitude": "17.48552000"
                    },
                    {
                        "id": 8300,
                        "name": "Konjic",
                        "latitude": "43.65126000",
                        "longitude": "17.96082000"
                    },
                    {
                        "id": 8304,
                        "name": "Kovači",
                        "latitude": "44.44874000",
                        "longitude": "18.20521000"
                    },
                    {
                        "id": 8310,
                        "name": "Liješnica",
                        "latitude": "44.49497000",
                        "longitude": "18.07644000"
                    },
                    {
                        "id": 8311,
                        "name": "Livno",
                        "latitude": "43.82695000",
                        "longitude": "17.00746000"
                    },
                    {
                        "id": 8313,
                        "name": "Ljubuški",
                        "latitude": "43.19694000",
                        "longitude": "17.54500000"
                    },
                    {
                        "id": 8314,
                        "name": "Lokvine",
                        "latitude": "44.20466000",
                        "longitude": "17.85665000"
                    },
                    {
                        "id": 8316,
                        "name": "Lukavac",
                        "latitude": "44.54245000",
                        "longitude": "18.52618000"
                    },
                    {
                        "id": 8317,
                        "name": "Lukavica",
                        "latitude": "44.76452000",
                        "longitude": "18.16887000"
                    },
                    {
                        "id": 8318,
                        "name": "Maglaj",
                        "latitude": "44.54771000",
                        "longitude": "18.10003000"
                    },
                    {
                        "id": 8320,
                        "name": "Mahala",
                        "latitude": "44.01194000",
                        "longitude": "18.25528000"
                    },
                    {
                        "id": 8321,
                        "name": "Mala Kladuša",
                        "latitude": "45.13443000",
                        "longitude": "15.85217000"
                    },
                    {
                        "id": 8322,
                        "name": "Malešići",
                        "latitude": "44.73824000",
                        "longitude": "18.27335000"
                    },
                    {
                        "id": 8327,
                        "name": "Mionica",
                        "latitude": "44.86646000",
                        "longitude": "18.46603000"
                    },
                    {
                        "id": 8329,
                        "name": "Mostar",
                        "latitude": "43.34333000",
                        "longitude": "17.80806000"
                    },
                    {
                        "id": 8330,
                        "name": "Mramor",
                        "latitude": "44.59234000",
                        "longitude": "18.56458000"
                    },
                    {
                        "id": 8332,
                        "name": "Neum",
                        "latitude": "42.92333000",
                        "longitude": "17.61556000"
                    },
                    {
                        "id": 8336,
                        "name": "Novi Šeher",
                        "latitude": "44.51031000",
                        "longitude": "18.02624000"
                    },
                    {
                        "id": 8335,
                        "name": "Novi Travnik",
                        "latitude": "44.17133000",
                        "longitude": "17.65816000"
                    },
                    {
                        "id": 8338,
                        "name": "Odžak",
                        "latitude": "45.02461000",
                        "longitude": "18.32107000"
                    },
                    {
                        "id": 8339,
                        "name": "Olovo",
                        "latitude": "44.12770000",
                        "longitude": "18.58065000"
                    },
                    {
                        "id": 8340,
                        "name": "Omanjska",
                        "latitude": "44.69831000",
                        "longitude": "17.95757000"
                    },
                    {
                        "id": 8344,
                        "name": "Orahovica Donja",
                        "latitude": "44.65345000",
                        "longitude": "18.36951000"
                    },
                    {
                        "id": 8345,
                        "name": "Orašac",
                        "latitude": "44.63039000",
                        "longitude": "16.07443000"
                    },
                    {
                        "id": 8346,
                        "name": "Orašje",
                        "latitude": "45.03366000",
                        "longitude": "18.69334000"
                    },
                    {
                        "id": 8347,
                        "name": "Orguz",
                        "latitude": "43.77414000",
                        "longitude": "16.86329000"
                    },
                    {
                        "id": 8348,
                        "name": "Ostrožac",
                        "latitude": "44.90866000",
                        "longitude": "15.94045000"
                    },
                    {
                        "id": 8349,
                        "name": "Otoka",
                        "latitude": "44.96000000",
                        "longitude": "16.17917000"
                    },
                    {
                        "id": 8351,
                        "name": "Pajić Polje",
                        "latitude": "43.97583000",
                        "longitude": "17.52750000"
                    },
                    {
                        "id": 8353,
                        "name": "Pazarić",
                        "latitude": "43.78882000",
                        "longitude": "18.16049000"
                    },
                    {
                        "id": 8356,
                        "name": "Peći",
                        "latitude": "44.63139000",
                        "longitude": "16.78250000"
                    },
                    {
                        "id": 8357,
                        "name": "Pećigrad",
                        "latitude": "45.05444000",
                        "longitude": "15.89694000"
                    },
                    {
                        "id": 8359,
                        "name": "Pjanići",
                        "latitude": "44.98568000",
                        "longitude": "15.82304000"
                    },
                    {
                        "id": 8361,
                        "name": "Podhum",
                        "latitude": "43.72295000",
                        "longitude": "16.99887000"
                    },
                    {
                        "id": 8362,
                        "name": "Podzvizd",
                        "latitude": "45.17417000",
                        "longitude": "15.87361000"
                    },
                    {
                        "id": 8363,
                        "name": "Polje",
                        "latitude": "43.88014000",
                        "longitude": "18.07452000"
                    },
                    {
                        "id": 8364,
                        "name": "Polje-Bijela",
                        "latitude": "43.63299000",
                        "longitude": "17.97216000"
                    },
                    {
                        "id": 8366,
                        "name": "Potoci",
                        "latitude": "43.40953000",
                        "longitude": "17.87855000"
                    },
                    {
                        "id": 8370,
                        "name": "Prozor",
                        "latitude": "43.82222000",
                        "longitude": "17.60917000"
                    },
                    {
                        "id": 8371,
                        "name": "Puračić",
                        "latitude": "44.54562000",
                        "longitude": "18.47865000"
                    },
                    {
                        "id": 8372,
                        "name": "Radišići",
                        "latitude": "43.22302000",
                        "longitude": "17.54056000"
                    },
                    {
                        "id": 8373,
                        "name": "Rodoč",
                        "latitude": "43.31453000",
                        "longitude": "17.80290000"
                    },
                    {
                        "id": 8376,
                        "name": "Rumboci",
                        "latitude": "43.83154000",
                        "longitude": "17.50273000"
                    },
                    {
                        "id": 8377,
                        "name": "Sanica",
                        "latitude": "44.61354000",
                        "longitude": "16.64062000"
                    },
                    {
                        "id": 8378,
                        "name": "Sanski Most",
                        "latitude": "44.76670000",
                        "longitude": "16.66700000"
                    },
                    {
                        "id": 8379,
                        "name": "Sapna",
                        "latitude": "44.50380000",
                        "longitude": "18.99818000"
                    },
                    {
                        "id": 8380,
                        "name": "Sarajevo",
                        "latitude": "43.84864000",
                        "longitude": "18.35644000"
                    },
                    {
                        "id": 8438,
                        "name": "Šerići",
                        "latitude": "44.46674000",
                        "longitude": "18.56370000"
                    },
                    {
                        "id": 8440,
                        "name": "Široki Brijeg",
                        "latitude": "43.38290000",
                        "longitude": "17.59416000"
                    },
                    {
                        "id": 8381,
                        "name": "Skokovi",
                        "latitude": "45.03139000",
                        "longitude": "15.91444000"
                    },
                    {
                        "id": 8382,
                        "name": "Sladna",
                        "latitude": "44.72897000",
                        "longitude": "18.42575000"
                    },
                    {
                        "id": 8384,
                        "name": "Solina",
                        "latitude": "44.56226000",
                        "longitude": "18.69322000"
                    },
                    {
                        "id": 8387,
                        "name": "Srebrenik",
                        "latitude": "44.70819000",
                        "longitude": "18.48834000"
                    },
                    {
                        "id": 8390,
                        "name": "Stijena",
                        "latitude": "44.93630000",
                        "longitude": "16.02224000"
                    },
                    {
                        "id": 8391,
                        "name": "Stjepan-Polje",
                        "latitude": "44.71634000",
                        "longitude": "18.25783000"
                    },
                    {
                        "id": 8392,
                        "name": "Stolac",
                        "latitude": "43.08400000",
                        "longitude": "17.95995000"
                    },
                    {
                        "id": 8441,
                        "name": "Šturlić",
                        "latitude": "45.06389000",
                        "longitude": "15.77806000"
                    },
                    {
                        "id": 8442,
                        "name": "Šumatac",
                        "latitude": "45.09743000",
                        "longitude": "15.85818000"
                    },
                    {
                        "id": 8394,
                        "name": "Tasovčići",
                        "latitude": "43.11333000",
                        "longitude": "17.72000000"
                    },
                    {
                        "id": 8396,
                        "name": "Tešanj",
                        "latitude": "44.61191000",
                        "longitude": "17.98552000"
                    },
                    {
                        "id": 8397,
                        "name": "Tešanjka",
                        "latitude": "44.67228000",
                        "longitude": "18.01109000"
                    },
                    {
                        "id": 8398,
                        "name": "Todorovo",
                        "latitude": "45.08833000",
                        "longitude": "15.93083000"
                    },
                    {
                        "id": 8399,
                        "name": "Tojšići",
                        "latitude": "44.50133000",
                        "longitude": "18.78523000"
                    },
                    {
                        "id": 8400,
                        "name": "Tomislavgrad",
                        "latitude": "43.71849000",
                        "longitude": "17.22515000"
                    },
                    {
                        "id": 8401,
                        "name": "Travnik",
                        "latitude": "44.22637000",
                        "longitude": "17.66583000"
                    },
                    {
                        "id": 8404,
                        "name": "Tržačka Raštela",
                        "latitude": "44.97597000",
                        "longitude": "15.78489000"
                    },
                    {
                        "id": 8405,
                        "name": "Turbe",
                        "latitude": "44.24352000",
                        "longitude": "17.57499000"
                    },
                    {
                        "id": 8406,
                        "name": "Tuzla",
                        "latitude": "44.53842000",
                        "longitude": "18.66709000"
                    },
                    {
                        "id": 8408,
                        "name": "Ustikolina",
                        "latitude": "43.58338000",
                        "longitude": "18.79106000"
                    },
                    {
                        "id": 8409,
                        "name": "Vareš",
                        "latitude": "44.16444000",
                        "longitude": "18.32833000"
                    },
                    {
                        "id": 8410,
                        "name": "Varoška Rijeka",
                        "latitude": "45.08936000",
                        "longitude": "16.01906000"
                    },
                    {
                        "id": 8411,
                        "name": "Velagići",
                        "latitude": "44.55618000",
                        "longitude": "16.73349000"
                    },
                    {
                        "id": 8412,
                        "name": "Velika Kladuša",
                        "latitude": "45.18497000",
                        "longitude": "15.80579000"
                    },
                    {
                        "id": 8414,
                        "name": "Vidoši",
                        "latitude": "43.77139000",
                        "longitude": "17.02833000"
                    },
                    {
                        "id": 8415,
                        "name": "Visoko",
                        "latitude": "43.98889000",
                        "longitude": "18.17806000"
                    },
                    {
                        "id": 8416,
                        "name": "Vitez",
                        "latitude": "44.15424000",
                        "longitude": "17.79009000"
                    },
                    {
                        "id": 8417,
                        "name": "Vitina",
                        "latitude": "43.23750000",
                        "longitude": "17.48389000"
                    },
                    {
                        "id": 8420,
                        "name": "Vogošća",
                        "latitude": "43.90225000",
                        "longitude": "18.34438000"
                    },
                    {
                        "id": 8421,
                        "name": "Voljevac",
                        "latitude": "43.87873000",
                        "longitude": "17.65861000"
                    },
                    {
                        "id": 8422,
                        "name": "Vrnograč",
                        "latitude": "45.16369000",
                        "longitude": "15.95444000"
                    },
                    {
                        "id": 8423,
                        "name": "Vukovije Donje",
                        "latitude": "44.46209000",
                        "longitude": "18.74941000"
                    },
                    {
                        "id": 8424,
                        "name": "Zabrišće",
                        "latitude": "43.79224000",
                        "longitude": "16.94224000"
                    },
                    {
                        "id": 8425,
                        "name": "Zavidovići",
                        "latitude": "44.44583000",
                        "longitude": "18.14972000"
                    },
                    {
                        "id": 8426,
                        "name": "Zborište",
                        "latitude": "45.14593000",
                        "longitude": "16.01728000"
                    },
                    {
                        "id": 8443,
                        "name": "Željezno Polje",
                        "latitude": "44.39875000",
                        "longitude": "17.94103000"
                    },
                    {
                        "id": 8427,
                        "name": "Zenica",
                        "latitude": "44.20169000",
                        "longitude": "17.90397000"
                    },
                    {
                        "id": 8444,
                        "name": "Žepče",
                        "latitude": "44.42667000",
                        "longitude": "18.03778000"
                    },
                    {
                        "id": 8445,
                        "name": "Živinice",
                        "latitude": "44.44929000",
                        "longitude": "18.64978000"
                    }
                ]
            },
            {
                "id": 463,
                "name": "Herzegovina-Neretva",
                "iso2": "07",
                "latitude": "43.52651590",
                "longitude": "17.76362100",
                "type": "canton",
                "cities": []
            },
            {
                "id": 464,
                "name": "Posavina",
                "iso2": "02",
                "latitude": "45.07520940",
                "longitude": "18.37763040",
                "type": "canton",
                "cities": []
            },
            {
                "id": 470,
                "name": "Republika Srpska",
                "iso2": "SRP",
                "latitude": "44.72801860",
                "longitude": "17.31481360",
                "type": "entity",
                "cities": [
                    {
                        "id": 8215,
                        "name": "Balatun",
                        "latitude": "44.86332000",
                        "longitude": "19.33931000"
                    },
                    {
                        "id": 8216,
                        "name": "Banja Luka",
                        "latitude": "44.77842000",
                        "longitude": "17.19386000"
                    },
                    {
                        "id": 8221,
                        "name": "Bijeljina",
                        "latitude": "44.76583000",
                        "longitude": "19.15083000"
                    },
                    {
                        "id": 8223,
                        "name": "Bileća",
                        "latitude": "42.87645000",
                        "longitude": "18.42967000"
                    },
                    {
                        "id": 8225,
                        "name": "Blatnica",
                        "latitude": "44.48677000",
                        "longitude": "17.82278000"
                    },
                    {
                        "id": 8231,
                        "name": "Brod",
                        "latitude": "45.13747000",
                        "longitude": "17.98722000"
                    },
                    {
                        "id": 8232,
                        "name": "Bronzani Majdan",
                        "latitude": "44.79237000",
                        "longitude": "16.94039000"
                    },
                    {
                        "id": 8430,
                        "name": "Čajniče",
                        "latitude": "43.55712000",
                        "longitude": "19.07186000"
                    },
                    {
                        "id": 8434,
                        "name": "Čečava",
                        "latitude": "44.67961000",
                        "longitude": "17.75780000"
                    },
                    {
                        "id": 8432,
                        "name": "Čelinac",
                        "latitude": "44.72453000",
                        "longitude": "17.32431000"
                    },
                    {
                        "id": 8240,
                        "name": "Derventa",
                        "latitude": "44.97839000",
                        "longitude": "17.90779000"
                    },
                    {
                        "id": 8242,
                        "name": "Doboj",
                        "latitude": "44.75944000",
                        "longitude": "18.06500000"
                    },
                    {
                        "id": 8244,
                        "name": "Dobrljin",
                        "latitude": "45.15106000",
                        "longitude": "16.47869000"
                    },
                    {
                        "id": 8256,
                        "name": "Dvorovi",
                        "latitude": "44.80753000",
                        "longitude": "19.25999000"
                    },
                    {
                        "id": 8258,
                        "name": "Foča",
                        "latitude": "43.50646000",
                        "longitude": "18.77854000"
                    },
                    {
                        "id": 8259,
                        "name": "Gacko",
                        "latitude": "43.16722000",
                        "longitude": "18.53528000"
                    },
                    {
                        "id": 8272,
                        "name": "Gradiška",
                        "latitude": "45.14484000",
                        "longitude": "17.25453000"
                    },
                    {
                        "id": 8278,
                        "name": "Hiseti",
                        "latitude": "44.76111000",
                        "longitude": "17.17944000"
                    },
                    {
                        "id": 8282,
                        "name": "Istočni Mostar",
                        "latitude": "43.42056000",
                        "longitude": "18.00833000"
                    },
                    {
                        "id": 8286,
                        "name": "Janja",
                        "latitude": "44.66554000",
                        "longitude": "19.24691000"
                    },
                    {
                        "id": 8290,
                        "name": "Kalenderovci Donji",
                        "latitude": "44.94673000",
                        "longitude": "17.83785000"
                    },
                    {
                        "id": 8297,
                        "name": "Kneževo",
                        "latitude": "44.49071000",
                        "longitude": "17.38161000"
                    },
                    {
                        "id": 8298,
                        "name": "Knežica",
                        "latitude": "45.10548000",
                        "longitude": "16.67668000"
                    },
                    {
                        "id": 8301,
                        "name": "Koran",
                        "latitude": "43.81038000",
                        "longitude": "18.56999000"
                    },
                    {
                        "id": 8302,
                        "name": "Kostajnica",
                        "latitude": "45.21956000",
                        "longitude": "16.53929000"
                    },
                    {
                        "id": 8303,
                        "name": "Kotor Varoš",
                        "latitude": "44.61831000",
                        "longitude": "17.37204000"
                    },
                    {
                        "id": 8305,
                        "name": "Kozarska Dubica",
                        "latitude": "45.17667000",
                        "longitude": "16.80944000"
                    },
                    {
                        "id": 8307,
                        "name": "Krupa na Vrbasu",
                        "latitude": "44.61875000",
                        "longitude": "17.14351000"
                    },
                    {
                        "id": 8308,
                        "name": "Laktaši",
                        "latitude": "44.90857000",
                        "longitude": "17.30135000"
                    },
                    {
                        "id": 8309,
                        "name": "Lamovita",
                        "latitude": "44.92018000",
                        "longitude": "16.89933000"
                    },
                    {
                        "id": 8312,
                        "name": "Ljubinje",
                        "latitude": "42.95120000",
                        "longitude": "18.08702000"
                    },
                    {
                        "id": 8315,
                        "name": "Lopare",
                        "latitude": "44.63498000",
                        "longitude": "18.84340000"
                    },
                    {
                        "id": 8319,
                        "name": "Maglajani",
                        "latitude": "44.94975000",
                        "longitude": "17.35014000"
                    },
                    {
                        "id": 8323,
                        "name": "Marićka",
                        "latitude": "44.86801000",
                        "longitude": "16.85510000"
                    },
                    {
                        "id": 8324,
                        "name": "Maslovare",
                        "latitude": "44.56594000",
                        "longitude": "17.53216000"
                    },
                    {
                        "id": 8325,
                        "name": "Mejdan - Obilićevo",
                        "latitude": "44.76324000",
                        "longitude": "17.19012000"
                    },
                    {
                        "id": 8326,
                        "name": "Milići",
                        "latitude": "44.17016000",
                        "longitude": "19.09195000"
                    },
                    {
                        "id": 8328,
                        "name": "Modriča",
                        "latitude": "44.95444000",
                        "longitude": "18.30361000"
                    },
                    {
                        "id": 8331,
                        "name": "Mrkonjić Grad",
                        "latitude": "44.41729000",
                        "longitude": "17.08288000"
                    },
                    {
                        "id": 8333,
                        "name": "Nevesinje",
                        "latitude": "43.25861000",
                        "longitude": "18.11333000"
                    },
                    {
                        "id": 8334,
                        "name": "Novi Grad",
                        "latitude": "45.04643000",
                        "longitude": "16.37782000"
                    },
                    {
                        "id": 8337,
                        "name": "Obudovac",
                        "latitude": "44.95215000",
                        "longitude": "18.59869000"
                    },
                    {
                        "id": 8341,
                        "name": "Omarska",
                        "latitude": "44.89170000",
                        "longitude": "16.89814000"
                    },
                    {
                        "id": 8342,
                        "name": "Opština Oštra Luka",
                        "latitude": "44.73278000",
                        "longitude": "16.82861000"
                    },
                    {
                        "id": 8343,
                        "name": "Opština Višegrad",
                        "latitude": "43.72167000",
                        "longitude": "19.31361000"
                    },
                    {
                        "id": 8350,
                        "name": "Oštra Luka",
                        "latitude": "44.99724000",
                        "longitude": "18.58464000"
                    },
                    {
                        "id": 8352,
                        "name": "Pale",
                        "latitude": "43.81664000",
                        "longitude": "18.56949000"
                    },
                    {
                        "id": 8354,
                        "name": "Pelagićevo",
                        "latitude": "44.90105000",
                        "longitude": "18.59185000"
                    },
                    {
                        "id": 8355,
                        "name": "Petkovci",
                        "latitude": "44.46849000",
                        "longitude": "19.07466000"
                    },
                    {
                        "id": 8358,
                        "name": "Piskavica",
                        "latitude": "44.86717000",
                        "longitude": "16.97464000"
                    },
                    {
                        "id": 8360,
                        "name": "Podbrdo",
                        "latitude": "44.44189000",
                        "longitude": "17.01495000"
                    },
                    {
                        "id": 8365,
                        "name": "Popovi",
                        "latitude": "44.76547000",
                        "longitude": "19.28667000"
                    },
                    {
                        "id": 8367,
                        "name": "Pribinić",
                        "latitude": "44.61010000",
                        "longitude": "17.68981000"
                    },
                    {
                        "id": 8368,
                        "name": "Priboj",
                        "latitude": "44.60233000",
                        "longitude": "18.93165000"
                    },
                    {
                        "id": 8369,
                        "name": "Prijedor",
                        "latitude": "44.97991000",
                        "longitude": "16.71401000"
                    },
                    {
                        "id": 8374,
                        "name": "Rogatica",
                        "latitude": "43.79894000",
                        "longitude": "19.00363000"
                    },
                    {
                        "id": 8375,
                        "name": "Rudo",
                        "latitude": "43.61781000",
                        "longitude": "19.36719000"
                    },
                    {
                        "id": 8436,
                        "name": "Šamac",
                        "latitude": "45.05987000",
                        "longitude": "18.46756000"
                    },
                    {
                        "id": 8437,
                        "name": "Šekovići",
                        "latitude": "44.29896000",
                        "longitude": "18.85532000"
                    },
                    {
                        "id": 8439,
                        "name": "Šipovo",
                        "latitude": "44.28237000",
                        "longitude": "17.08597000"
                    },
                    {
                        "id": 8383,
                        "name": "Sokolac",
                        "latitude": "43.93817000",
                        "longitude": "18.80079000"
                    },
                    {
                        "id": 8385,
                        "name": "Srbac",
                        "latitude": "45.09730000",
                        "longitude": "17.52331000"
                    },
                    {
                        "id": 8386,
                        "name": "Srebrenica",
                        "latitude": "44.10748000",
                        "longitude": "19.29669000"
                    },
                    {
                        "id": 8388,
                        "name": "Stanari",
                        "latitude": "44.74475000",
                        "longitude": "17.82714000"
                    },
                    {
                        "id": 8389,
                        "name": "Starcevica",
                        "latitude": "44.75708000",
                        "longitude": "17.21178000"
                    },
                    {
                        "id": 8393,
                        "name": "Svodna",
                        "latitude": "45.03770000",
                        "longitude": "16.54019000"
                    },
                    {
                        "id": 8395,
                        "name": "Teslić",
                        "latitude": "44.60639000",
                        "longitude": "17.85972000"
                    },
                    {
                        "id": 8402,
                        "name": "Trebinje",
                        "latitude": "42.71197000",
                        "longitude": "18.34362000"
                    },
                    {
                        "id": 8403,
                        "name": "Trn",
                        "latitude": "44.85829000",
                        "longitude": "17.23583000"
                    },
                    {
                        "id": 8407,
                        "name": "Ugljevik",
                        "latitude": "44.66361000",
                        "longitude": "19.02028000"
                    },
                    {
                        "id": 8413,
                        "name": "Velika Obarska",
                        "latitude": "44.80461000",
                        "longitude": "19.16183000"
                    },
                    {
                        "id": 8418,
                        "name": "Višegrad",
                        "latitude": "43.78260000",
                        "longitude": "19.29256000"
                    },
                    {
                        "id": 8419,
                        "name": "Vlasenica",
                        "latitude": "44.18183000",
                        "longitude": "18.94096000"
                    },
                    {
                        "id": 8446,
                        "name": "Živinice",
                        "latitude": "44.54765000",
                        "longitude": "17.37357000"
                    },
                    {
                        "id": 8428,
                        "name": "Zvornik",
                        "latitude": "44.38605000",
                        "longitude": "19.10247000"
                    }
                ]
            },
            {
                "id": 466,
                "name": "Sarajevo",
                "iso2": "09",
                "latitude": "43.85125640",
                "longitude": "18.29534420",
                "type": "canton",
                "cities": []
            },
            {
                "id": 461,
                "name": "Tuzla",
                "iso2": "03",
                "latitude": "44.53434630",
                "longitude": "18.69727970",
                "type": "canton",
                "cities": []
            },
            {
                "id": 465,
                "name": "Una-Sana",
                "iso2": "01",
                "latitude": "44.65031160",
                "longitude": "16.31716290",
                "type": "canton",
                "cities": []
            },
            {
                "id": 469,
                "name": "West Herzegovina",
                "iso2": "08",
                "latitude": "43.43692440",
                "longitude": "17.38488310",
                "type": "canton",
                "cities": []
            },
            {
                "id": 468,
                "name": "Zenica-Doboj",
                "iso2": "04",
                "latitude": "44.21271090",
                "longitude": "18.16046250",
                "type": "canton",
                "cities": []
            }
        ]
    },
    {
        "id": 29,
        "name": "Botswana",
        "iso3": "BWA",
        "iso2": "BW",
        "numeric_code": "072",
        "phonecode": "267",
        "capital": "Gaborone",
        "currency": "BWP",
        "currency_name": "Botswana pula",
        "currency_symbol": "P",
        "tld": ".bw",
        "native": "Botswana",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Southern Africa",
        "subregion_id": 5,
        "nationality": "Motswana, Botswanan",
        "timezones": [
            {
                "zoneName": "Africa\/Gaborone",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "br": "Botswana",
            "ko": "보츠와나",
            "pt-BR": "Botsuana",
            "pt": "Botsuana",
            "nl": "Botswana",
            "hr": "Bocvana",
            "fa": "بوتسوانا",
            "de": "Botswana",
            "es": "Botswana",
            "fr": "Botswana",
            "ja": "ボツワナ",
            "it": "Botswana",
            "zh-CN": "博茨瓦纳",
            "tr": "Botsvana",
            "ru": "Ботсвана",
            "uk": "Ботсвана",
            "pl": "Botswana"
        },
        "latitude": "-22.00000000",
        "longitude": "24.00000000",
        "emoji": "🇧🇼",
        "emojiU": "U+1F1E7 U+1F1FC",
        "states": [
            {
                "id": 3067,
                "name": "Central",
                "iso2": "CE",
                "latitude": "-21.46037160",
                "longitude": "23.98865420",
                "type": "district",
                "cities": [
                    {
                        "id": 15738,
                        "name": "Gobojango",
                        "latitude": "-21.83270000",
                        "longitude": "28.72882000"
                    },
                    {
                        "id": 15739,
                        "name": "Gweta",
                        "latitude": "-20.18333000",
                        "longitude": "25.23333000"
                    },
                    {
                        "id": 15742,
                        "name": "Kalamare",
                        "latitude": "-22.93369000",
                        "longitude": "26.57032000"
                    },
                    {
                        "id": 15750,
                        "name": "Letlhakane",
                        "latitude": "-21.41494000",
                        "longitude": "25.59263000"
                    },
                    {
                        "id": 15752,
                        "name": "Letsheng",
                        "latitude": "-22.66384000",
                        "longitude": "27.22390000"
                    },
                    {
                        "id": 15753,
                        "name": "Maapi",
                        "latitude": "-22.75785000",
                        "longitude": "27.35001000"
                    },
                    {
                        "id": 15754,
                        "name": "Machaneng",
                        "latitude": "-23.18621000",
                        "longitude": "27.48856000"
                    },
                    {
                        "id": 15755,
                        "name": "Mahalapye",
                        "latitude": "-23.10407000",
                        "longitude": "26.81421000"
                    },
                    {
                        "id": 15757,
                        "name": "Makobeng",
                        "latitude": "-22.99637000",
                        "longitude": "27.66766000"
                    },
                    {
                        "id": 15758,
                        "name": "Makwata",
                        "latitude": "-23.28333000",
                        "longitude": "27.30000000"
                    },
                    {
                        "id": 15761,
                        "name": "Mathakola",
                        "latitude": "-22.72125000",
                        "longitude": "27.31057000"
                    },
                    {
                        "id": 15762,
                        "name": "Mathambgwane",
                        "latitude": "-20.99075000",
                        "longitude": "27.33158000"
                    },
                    {
                        "id": 15763,
                        "name": "Mathathane",
                        "latitude": "-22.26875000",
                        "longitude": "28.74946000"
                    },
                    {
                        "id": 15765,
                        "name": "Maunatlala",
                        "latitude": "-22.59701000",
                        "longitude": "27.63006000"
                    },
                    {
                        "id": 15770,
                        "name": "Mogapi",
                        "latitude": "-22.32301000",
                        "longitude": "27.83492000"
                    },
                    {
                        "id": 15772,
                        "name": "Moijabana",
                        "latitude": "-22.43333000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 15774,
                        "name": "Mookane",
                        "latitude": "-23.68805000",
                        "longitude": "26.65948000"
                    },
                    {
                        "id": 15775,
                        "name": "Mopipi",
                        "latitude": "-21.18333000",
                        "longitude": "24.88333000"
                    },
                    {
                        "id": 15776,
                        "name": "Mosetse",
                        "latitude": "-20.75000000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 15778,
                        "name": "Nata",
                        "latitude": "-20.21667000",
                        "longitude": "26.18333000"
                    },
                    {
                        "id": 15781,
                        "name": "Orapa",
                        "latitude": "-21.31150000",
                        "longitude": "25.37642000"
                    },
                    {
                        "id": 15783,
                        "name": "Palapye",
                        "latitude": "-22.54605000",
                        "longitude": "27.12507000"
                    },
                    {
                        "id": 15786,
                        "name": "Pilikwe",
                        "latitude": "-22.79904000",
                        "longitude": "27.19376000"
                    },
                    {
                        "id": 15787,
                        "name": "Rakops",
                        "latitude": "-21.02257000",
                        "longitude": "24.36052000"
                    },
                    {
                        "id": 15788,
                        "name": "Ramokgonami",
                        "latitude": "-22.86450000",
                        "longitude": "27.42391000"
                    },
                    {
                        "id": 15790,
                        "name": "Ratholo",
                        "latitude": "-22.72454000",
                        "longitude": "27.57199000"
                    },
                    {
                        "id": 15792,
                        "name": "Sefophe",
                        "latitude": "-22.18333000",
                        "longitude": "27.96667000"
                    },
                    {
                        "id": 15795,
                        "name": "Serowe",
                        "latitude": "-22.38754000",
                        "longitude": "26.71077000"
                    },
                    {
                        "id": 15797,
                        "name": "Sua",
                        "latitude": "-20.05000000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 15798,
                        "name": "Tamasane",
                        "latitude": "-22.41840000",
                        "longitude": "27.40127000"
                    },
                    {
                        "id": 15800,
                        "name": "Tobane",
                        "latitude": "-21.95000000",
                        "longitude": "27.90000000"
                    },
                    {
                        "id": 15801,
                        "name": "Tonota",
                        "latitude": "-21.44236000",
                        "longitude": "27.46153000"
                    }
                ]
            },
            {
                "id": 3061,
                "name": "Ghanzi",
                "iso2": "GH",
                "latitude": "-21.86523140",
                "longitude": "21.85685860",
                "type": "district",
                "cities": [
                    {
                        "id": 15731,
                        "name": "Dekar",
                        "latitude": "-21.53333000",
                        "longitude": "21.93333000"
                    },
                    {
                        "id": 15737,
                        "name": "Ghanzi",
                        "latitude": "-21.69785000",
                        "longitude": "21.64581000"
                    }
                ]
            },
            {
                "id": 3066,
                "name": "Kgalagadi",
                "iso2": "KG",
                "latitude": "-24.75502850",
                "longitude": "21.85685860",
                "type": "district",
                "cities": [
                    {
                        "id": 15740,
                        "name": "Hukuntsi",
                        "latitude": "-23.99880000",
                        "longitude": "21.77962000"
                    },
                    {
                        "id": 15743,
                        "name": "Kang",
                        "latitude": "-23.67518000",
                        "longitude": "22.78762000"
                    },
                    {
                        "id": 15748,
                        "name": "Lehututu",
                        "latitude": "-23.96667000",
                        "longitude": "21.86667000"
                    },
                    {
                        "id": 15759,
                        "name": "Manyana",
                        "latitude": "-23.40000000",
                        "longitude": "21.71667000"
                    },
                    {
                        "id": 15802,
                        "name": "Tshabong",
                        "latitude": "-26.05000000",
                        "longitude": "22.45000000"
                    },
                    {
                        "id": 15803,
                        "name": "Werda",
                        "latitude": "-25.26667000",
                        "longitude": "23.28333000"
                    }
                ]
            },
            {
                "id": 3062,
                "name": "Kgatleng",
                "iso2": "KL",
                "latitude": "-24.19704450",
                "longitude": "26.23046160",
                "type": "district",
                "cities": [
                    {
                        "id": 15729,
                        "name": "Bokaa",
                        "latitude": "-24.45000000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 15767,
                        "name": "Mmathubudukwane",
                        "latitude": "-24.60000000",
                        "longitude": "26.43333000"
                    },
                    {
                        "id": 15769,
                        "name": "Mochudi",
                        "latitude": "-24.41667000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 15785,
                        "name": "Pilane",
                        "latitude": "-24.45000000",
                        "longitude": "26.13333000"
                    }
                ]
            },
            {
                "id": 3069,
                "name": "Kweneng",
                "iso2": "KW",
                "latitude": "-23.83672490",
                "longitude": "25.28375850",
                "type": "district",
                "cities": [
                    {
                        "id": 15730,
                        "name": "Botlhapatlou",
                        "latitude": "-24.02591000",
                        "longitude": "25.48976000"
                    },
                    {
                        "id": 15733,
                        "name": "Dutlwe",
                        "latitude": "-23.98333000",
                        "longitude": "23.90000000"
                    },
                    {
                        "id": 15734,
                        "name": "Gabane",
                        "latitude": "-24.66667000",
                        "longitude": "25.78222000"
                    },
                    {
                        "id": 15736,
                        "name": "Gaphatshwe",
                        "latitude": "-24.57389000",
                        "longitude": "25.83417000"
                    },
                    {
                        "id": 15746,
                        "name": "Khudumelapye",
                        "latitude": "-23.88333000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 15749,
                        "name": "Lenchwe Le Tau",
                        "latitude": "-24.38333000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 15751,
                        "name": "Letlhakeng",
                        "latitude": "-24.09442000",
                        "longitude": "25.02977000"
                    },
                    {
                        "id": 15766,
                        "name": "Metsemotlhaba",
                        "latitude": "-24.55139000",
                        "longitude": "25.80306000"
                    },
                    {
                        "id": 15768,
                        "name": "Mmopone",
                        "latitude": "-24.56694000",
                        "longitude": "25.87417000"
                    },
                    {
                        "id": 15771,
                        "name": "Mogoditshane",
                        "latitude": "-24.62694000",
                        "longitude": "25.86556000"
                    },
                    {
                        "id": 15773,
                        "name": "Molepolole",
                        "latitude": "-24.40659000",
                        "longitude": "25.49508000"
                    },
                    {
                        "id": 15779,
                        "name": "Nkoyaphiri",
                        "latitude": "-24.63222000",
                        "longitude": "25.83139000"
                    },
                    {
                        "id": 15799,
                        "name": "Thamaga",
                        "latitude": "-24.67014000",
                        "longitude": "25.53975000"
                    }
                ]
            },
            {
                "id": 3060,
                "name": "Ngamiland",
                "iso2": "NG",
                "latitude": "-19.19053210",
                "longitude": "23.00119890",
                "type": "city",
                "cities": []
            },
            {
                "id": 3068,
                "name": "North-East",
                "iso2": "NE",
                "latitude": "37.58844610",
                "longitude": "-94.68637820",
                "type": "district",
                "cities": [
                    {
                        "id": 15732,
                        "name": "Dukwe",
                        "latitude": "-20.58333000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 15756,
                        "name": "Makaleng",
                        "latitude": "-20.90000000",
                        "longitude": "27.28333000"
                    },
                    {
                        "id": 15760,
                        "name": "Masunga",
                        "latitude": "-20.62455000",
                        "longitude": "27.44875000"
                    },
                    {
                        "id": 15791,
                        "name": "Sebina",
                        "latitude": "-20.86667000",
                        "longitude": "27.25000000"
                    }
                ]
            },
            {
                "id": 3065,
                "name": "North-West",
                "iso2": "NW",
                "latitude": "-19.48362260",
                "longitude": "20.44725770",
                "type": "district",
                "cities": [
                    {
                        "id": 15764,
                        "name": "Maun",
                        "latitude": "-19.98333000",
                        "longitude": "23.41667000"
                    },
                    {
                        "id": 15780,
                        "name": "Nokaneng",
                        "latitude": "-19.66667000",
                        "longitude": "22.26667000"
                    },
                    {
                        "id": 15784,
                        "name": "Pandamatenga",
                        "latitude": "-18.52779000",
                        "longitude": "25.62698000"
                    },
                    {
                        "id": 15793,
                        "name": "Sehithwa",
                        "latitude": "-20.46667000",
                        "longitude": "22.71667000"
                    },
                    {
                        "id": 15796,
                        "name": "Shakawe",
                        "latitude": "-18.36536000",
                        "longitude": "21.84219000"
                    }
                ]
            },
            {
                "id": 3064,
                "name": "South-East",
                "iso2": "SE",
                "latitude": "-24.98668160",
                "longitude": "25.52908570",
                "type": "district",
                "cities": [
                    {
                        "id": 15735,
                        "name": "Gaborone",
                        "latitude": "-24.76234000",
                        "longitude": "25.79950000"
                    },
                    {
                        "id": 15741,
                        "name": "Janeng",
                        "latitude": "-25.41667000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 15747,
                        "name": "Kopong",
                        "latitude": "-24.48333000",
                        "longitude": "25.88333000"
                    },
                    {
                        "id": 15782,
                        "name": "Otse",
                        "latitude": "-25.01667000",
                        "longitude": "25.73333000"
                    },
                    {
                        "id": 15789,
                        "name": "Ramotswa",
                        "latitude": "-24.87158000",
                        "longitude": "25.86989000"
                    }
                ]
            },
            {
                "id": 3063,
                "name": "Southern",
                "iso2": "SO",
                "latitude": "-24.90962620",
                "longitude": "23.05419760",
                "type": "district",
                "cities": [
                    {
                        "id": 15744,
                        "name": "Kanye",
                        "latitude": "-24.96675000",
                        "longitude": "25.33273000"
                    },
                    {
                        "id": 15745,
                        "name": "Khakhea",
                        "latitude": "-24.68954000",
                        "longitude": "23.49403000"
                    },
                    {
                        "id": 15777,
                        "name": "Mosopa",
                        "latitude": "-24.77180000",
                        "longitude": "25.42156000"
                    },
                    {
                        "id": 15794,
                        "name": "Sekoma",
                        "latitude": "-24.40000000",
                        "longitude": "23.88333000"
                    }
                ]
            }
        ]
    },
    {
        "id": 30,
        "name": "Bouvet Island",
        "iso3": "BVT",
        "iso2": "BV",
        "numeric_code": "074",
        "phonecode": "0055",
        "capital": "",
        "currency": "NOK",
        "currency_name": "Norwegian krone",
        "currency_symbol": "ko",
        "tld": ".bv",
        "native": "Bouvetøya",
        "region": "",
        "region_id": 0,
        "subregion": "",
        "subregion_id": 0,
        "nationality": "Bouvet Island",
        "timezones": [
            {
                "zoneName": "Europe\/Oslo",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Enez Bouvet",
            "ko": "부벳 섬",
            "pt-BR": "Ilha Bouvet",
            "pt": "Ilha Bouvet",
            "nl": "Bouveteiland",
            "hr": "Otok Bouvet",
            "fa": "جزیره بووه",
            "de": "Bouvetinsel",
            "es": "Isla Bouvet",
            "fr": "Île Bouvet",
            "ja": "ブーベ島",
            "it": "Isola Bouvet",
            "zh-CN": "布维岛",
            "tr": "Bouvet Adasi",
            "ru": "Остров Буве",
            "uk": "Острів Буве",
            "pl": "Wyspa Bouveta"
        },
        "latitude": "-54.43333333",
        "longitude": "3.40000000",
        "emoji": "🇧🇻",
        "emojiU": "U+1F1E7 U+1F1FB",
        "states": []
    },
    {
        "id": 31,
        "name": "Brazil",
        "iso3": "BRA",
        "iso2": "BR",
        "numeric_code": "076",
        "phonecode": "55",
        "capital": "Brasilia",
        "currency": "BRL",
        "currency_name": "Brazilian real",
        "currency_symbol": "R$",
        "tld": ".br",
        "native": "Brasil",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Brazilian",
        "timezones": [
            {
                "zoneName": "America\/Araguaina",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "Brasília Time"
            },
            {
                "zoneName": "America\/Bahia",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "Brasília Time"
            },
            {
                "zoneName": "America\/Belem",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "Brasília Time"
            },
            {
                "zoneName": "America\/Boa_Vista",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AMT",
                "tzName": "Amazon Time (Brazil)[3"
            },
            {
                "zoneName": "America\/Campo_Grande",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AMT",
                "tzName": "Amazon Time (Brazil)[3"
            },
            {
                "zoneName": "America\/Cuiaba",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "BRT",
                "tzName": "Brasilia Time"
            },
            {
                "zoneName": "America\/Eirunepe",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "ACT",
                "tzName": "Acre Time"
            },
            {
                "zoneName": "America\/Fortaleza",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "Brasília Time"
            },
            {
                "zoneName": "America\/Maceio",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "Brasília Time"
            },
            {
                "zoneName": "America\/Manaus",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AMT",
                "tzName": "Amazon Time (Brazil)"
            },
            {
                "zoneName": "America\/Noronha",
                "gmtOffset": -7200,
                "gmtOffsetName": "UTC-02:00",
                "abbreviation": "FNT",
                "tzName": "Fernando de Noronha Time"
            },
            {
                "zoneName": "America\/Porto_Velho",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AMT",
                "tzName": "Amazon Time (Brazil)[3"
            },
            {
                "zoneName": "America\/Recife",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "Brasília Time"
            },
            {
                "zoneName": "America\/Rio_Branco",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "ACT",
                "tzName": "Acre Time"
            },
            {
                "zoneName": "America\/Santarem",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "Brasília Time"
            },
            {
                "zoneName": "America\/Sao_Paulo",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "Brasília Time"
            }
        ],
        "translations": {
            "br": "Brazil",
            "ko": "브라질",
            "pt-BR": "Brasil",
            "pt": "Brasil",
            "nl": "Brazilië",
            "hr": "Brazil",
            "fa": "برزیل",
            "de": "Brasilien",
            "es": "Brasil",
            "fr": "Brésil",
            "ja": "ブラジル",
            "it": "Brasile",
            "zh-CN": "巴西",
            "tr": "Brezilya",
            "ru": "Бразилия",
            "uk": "Бразилія",
            "pl": "Brazylia"
        },
        "latitude": "-10.00000000",
        "longitude": "-55.00000000",
        "emoji": "🇧🇷",
        "emojiU": "U+1F1E7 U+1F1F7",
        "states": [
            {
                "id": 2012,
                "name": "Acre",
                "iso2": "AC",
                "latitude": "-9.02379600",
                "longitude": "-70.81199500",
                "type": "state",
                "cities": [
                    {
                        "id": 10078,
                        "name": "Acrelândia",
                        "latitude": "-9.98045000",
                        "longitude": "-66.84388000"
                    },
                    {
                        "id": 10428,
                        "name": "Assis Brasil",
                        "latitude": "-10.88334000",
                        "longitude": "-70.01314000"
                    },
                    {
                        "id": 10774,
                        "name": "Brasiléia",
                        "latitude": "-11.01611000",
                        "longitude": "-68.74806000"
                    },
                    {
                        "id": 10819,
                        "name": "Bujari",
                        "latitude": "-9.57859000",
                        "longitude": "-68.17197000"
                    },
                    {
                        "id": 11091,
                        "name": "Capixaba",
                        "latitude": "-10.48782000",
                        "longitude": "-67.84831000"
                    },
                    {
                        "id": 11498,
                        "name": "Cruzeiro do Sul",
                        "latitude": "-7.62759000",
                        "longitude": "-72.67756000"
                    },
                    {
                        "id": 11713,
                        "name": "Epitaciolândia",
                        "latitude": "-10.93542000",
                        "longitude": "-68.44411000"
                    },
                    {
                        "id": 11788,
                        "name": "Feijó",
                        "latitude": "-8.16540000",
                        "longitude": "-70.35486000"
                    },
                    {
                        "id": 12647,
                        "name": "Jordão",
                        "latitude": "-9.09166000",
                        "longitude": "-71.84069000"
                    },
                    {
                        "id": 13291,
                        "name": "Mâncio Lima",
                        "latitude": "-7.61417000",
                        "longitude": "-72.89583000"
                    },
                    {
                        "id": 12954,
                        "name": "Manoel Urbano",
                        "latitude": "-8.83889000",
                        "longitude": "-69.25972000"
                    },
                    {
                        "id": 13001,
                        "name": "Marechal Thaumaturgo",
                        "latitude": "-8.94111000",
                        "longitude": "-72.79167000"
                    },
                    {
                        "id": 13945,
                        "name": "Plácido de Castro",
                        "latitude": "-10.33528000",
                        "longitude": "-67.18556000"
                    },
                    {
                        "id": 13993,
                        "name": "Porto Acre",
                        "latitude": "-9.65038000",
                        "longitude": "-67.77733000"
                    },
                    {
                        "id": 14022,
                        "name": "Porto Walter",
                        "latitude": "-8.26861000",
                        "longitude": "-72.74389000"
                    },
                    {
                        "id": 14263,
                        "name": "Rio Branco",
                        "latitude": "-9.97472000",
                        "longitude": "-67.81000000"
                    },
                    {
                        "id": 14333,
                        "name": "Rodrigues Alves",
                        "latitude": "-7.85286000",
                        "longitude": "-73.23613000"
                    },
                    {
                        "id": 14547,
                        "name": "Santa Rosa do Purus",
                        "latitude": "-9.47730000",
                        "longitude": "-70.39032000"
                    },
                    {
                        "id": 14692,
                        "name": "Sena Madureira",
                        "latitude": "-9.06341000",
                        "longitude": "-68.67245000"
                    },
                    {
                        "id": 14700,
                        "name": "Senador Guiomard",
                        "latitude": "-10.14970000",
                        "longitude": "-67.73741000"
                    },
                    {
                        "id": 15253,
                        "name": "Tarauacá",
                        "latitude": "-8.16139000",
                        "longitude": "-70.76556000"
                    },
                    {
                        "id": 15637,
                        "name": "Xapuri",
                        "latitude": "-10.59663000",
                        "longitude": "-68.64891000"
                    }
                ]
            },
            {
                "id": 2007,
                "name": "Alagoas",
                "iso2": "AL",
                "latitude": "-9.57130580",
                "longitude": "-36.78195050",
                "type": "state",
                "cities": [
                    {
                        "id": 15652,
                        "name": "Água Branca",
                        "latitude": "-9.26988000",
                        "longitude": "-37.91917000"
                    },
                    {
                        "id": 10227,
                        "name": "Anadia",
                        "latitude": "-9.67495000",
                        "longitude": "-36.33790000"
                    },
                    {
                        "id": 10337,
                        "name": "Arapiraca",
                        "latitude": "-9.74380000",
                        "longitude": "-36.59315000"
                    },
                    {
                        "id": 10434,
                        "name": "Atalaia",
                        "latitude": "-9.50194000",
                        "longitude": "-36.02278000"
                    },
                    {
                        "id": 10527,
                        "name": "Barra de Santo Antônio",
                        "latitude": "-9.40472000",
                        "longitude": "-35.50722000"
                    },
                    {
                        "id": 10529,
                        "name": "Barra de São Miguel",
                        "latitude": "-9.81230000",
                        "longitude": "-35.96087000"
                    },
                    {
                        "id": 10581,
                        "name": "Batalha",
                        "latitude": "-9.73256000",
                        "longitude": "-37.08877000"
                    },
                    {
                        "id": 10616,
                        "name": "Belém",
                        "latitude": "-9.54424000",
                        "longitude": "-36.50196000"
                    },
                    {
                        "id": 10609,
                        "name": "Belo Monte",
                        "latitude": "-9.80521000",
                        "longitude": "-37.19157000"
                    },
                    {
                        "id": 10677,
                        "name": "Boca da Mata",
                        "latitude": "-9.64651000",
                        "longitude": "-36.14134000"
                    },
                    {
                        "id": 10767,
                        "name": "Branquinha",
                        "latitude": "-9.21168000",
                        "longitude": "-36.08956000"
                    },
                    {
                        "id": 10883,
                        "name": "Cacimbinhas",
                        "latitude": "-9.40028000",
                        "longitude": "-36.99028000"
                    },
                    {
                        "id": 10919,
                        "name": "Cajueiro",
                        "latitude": "-9.71667000",
                        "longitude": "-36.45000000"
                    },
                    {
                        "id": 10957,
                        "name": "Campestre",
                        "latitude": "-8.89393000",
                        "longitude": "-35.53237000"
                    },
                    {
                        "id": 10976,
                        "name": "Campo Alegre",
                        "latitude": "-9.78194000",
                        "longitude": "-36.35083000"
                    },
                    {
                        "id": 10990,
                        "name": "Campo Grande",
                        "latitude": "-9.94997000",
                        "longitude": "-36.75593000"
                    },
                    {
                        "id": 11024,
                        "name": "Canapi",
                        "latitude": "-9.17327000",
                        "longitude": "-37.51985000"
                    },
                    {
                        "id": 11066,
                        "name": "Capela",
                        "latitude": "-9.39342000",
                        "longitude": "-36.12390000"
                    },
                    {
                        "id": 11160,
                        "name": "Carneiros",
                        "latitude": "-9.46467000",
                        "longitude": "-37.35559000"
                    },
                    {
                        "id": 11287,
                        "name": "Chã Preta",
                        "latitude": "-9.22921000",
                        "longitude": "-36.33049000"
                    },
                    {
                        "id": 11317,
                        "name": "Coité do Nóia",
                        "latitude": "-9.62616000",
                        "longitude": "-36.60044000"
                    },
                    {
                        "id": 11336,
                        "name": "Colônia Leopoldina",
                        "latitude": "-8.94183000",
                        "longitude": "-35.76005000"
                    },
                    {
                        "id": 11394,
                        "name": "Coqueiro Seco",
                        "latitude": "-9.64656000",
                        "longitude": "-35.80938000"
                    },
                    {
                        "id": 11445,
                        "name": "Coruripe",
                        "latitude": "-10.12556000",
                        "longitude": "-36.17556000"
                    },
                    {
                        "id": 11464,
                        "name": "Craíbas",
                        "latitude": "-9.60115000",
                        "longitude": "-36.80273000"
                    },
                    {
                        "id": 11569,
                        "name": "Delmiro Gouveia",
                        "latitude": "-9.38861000",
                        "longitude": "-37.99917000"
                    },
                    {
                        "id": 11619,
                        "name": "Dois Riachos",
                        "latitude": "-9.39250000",
                        "longitude": "-37.10056000"
                    },
                    {
                        "id": 11752,
                        "name": "Estrela de Alagoas",
                        "latitude": "-9.39858000",
                        "longitude": "-36.76219000"
                    },
                    {
                        "id": 11789,
                        "name": "Feira Grande",
                        "latitude": "-9.92470000",
                        "longitude": "-36.66953000"
                    },
                    {
                        "id": 11799,
                        "name": "Feliz Deserto",
                        "latitude": "-10.29080000",
                        "longitude": "-36.35367000"
                    },
                    {
                        "id": 11824,
                        "name": "Flexeiras",
                        "latitude": "-9.20061000",
                        "longitude": "-35.78000000"
                    },
                    {
                        "id": 11945,
                        "name": "Girau do Ponciano",
                        "latitude": "-9.88417000",
                        "longitude": "-36.82889000"
                    },
                    {
                        "id": 12123,
                        "name": "Ibateguara",
                        "latitude": "-8.97250000",
                        "longitude": "-35.93944000"
                    },
                    {
                        "id": 12177,
                        "name": "Igaci",
                        "latitude": "-9.53694000",
                        "longitude": "-36.63361000"
                    },
                    {
                        "id": 12193,
                        "name": "Igreja Nova",
                        "latitude": "-10.16660000",
                        "longitude": "-36.61724000"
                    },
                    {
                        "id": 12249,
                        "name": "Inhapi",
                        "latitude": "-9.22139000",
                        "longitude": "-37.74861000"
                    },
                    {
                        "id": 12522,
                        "name": "Jacaré dos Homens",
                        "latitude": "-9.67278000",
                        "longitude": "-37.22275000"
                    },
                    {
                        "id": 12535,
                        "name": "Jacuípe",
                        "latitude": "-8.87722000",
                        "longitude": "-35.45885000"
                    },
                    {
                        "id": 12566,
                        "name": "Japaratinga",
                        "latitude": "-9.09900000",
                        "longitude": "-35.29631000"
                    },
                    {
                        "id": 12582,
                        "name": "Jaramataia",
                        "latitude": "-9.65053000",
                        "longitude": "-36.96036000"
                    },
                    {
                        "id": 12618,
                        "name": "Jequiá da Praia",
                        "latitude": "-9.91151000",
                        "longitude": "-36.09896000"
                    },
                    {
                        "id": 12637,
                        "name": "Joaquim Gomes",
                        "latitude": "-9.10352000",
                        "longitude": "-35.73739000"
                    },
                    {
                        "id": 12686,
                        "name": "Jundiá",
                        "latitude": "-8.93472000",
                        "longitude": "-35.57361000"
                    },
                    {
                        "id": 12688,
                        "name": "Junqueiro",
                        "latitude": "-9.88524000",
                        "longitude": "-36.45640000"
                    },
                    {
                        "id": 12749,
                        "name": "Lagoa da Canoa",
                        "latitude": "-9.82972000",
                        "longitude": "-36.73778000"
                    },
                    {
                        "id": 12832,
                        "name": "Limoeiro de Anadia",
                        "latitude": "-9.72685000",
                        "longitude": "-36.45407000"
                    },
                    {
                        "id": 12896,
                        "name": "Maceió",
                        "latitude": "-9.66583000",
                        "longitude": "-35.73528000"
                    },
                    {
                        "id": 12921,
                        "name": "Major Isidoro",
                        "latitude": "-9.53222000",
                        "longitude": "-36.98500000"
                    },
                    {
                        "id": 12961,
                        "name": "Mar Vermelho",
                        "latitude": "-9.49247000",
                        "longitude": "-36.35042000"
                    },
                    {
                        "id": 12973,
                        "name": "Maragogi",
                        "latitude": "-9.01222000",
                        "longitude": "-35.22250000"
                    },
                    {
                        "id": 12985,
                        "name": "Maravilha",
                        "latitude": "-9.22305000",
                        "longitude": "-37.37936000"
                    },
                    {
                        "id": 12999,
                        "name": "Marechal Deodoro",
                        "latitude": "-9.71028000",
                        "longitude": "-35.89500000"
                    },
                    {
                        "id": 13011,
                        "name": "Maribondo",
                        "latitude": "-9.57722000",
                        "longitude": "-36.30528000"
                    },
                    {
                        "id": 13046,
                        "name": "Mata Grande",
                        "latitude": "-8.98543000",
                        "longitude": "-37.76150000"
                    },
                    {
                        "id": 13073,
                        "name": "Matriz de Camaragibe",
                        "latitude": "-9.15167000",
                        "longitude": "-35.53333000"
                    },
                    {
                        "id": 13106,
                        "name": "Messias",
                        "latitude": "-9.38333000",
                        "longitude": "-35.84167000"
                    },
                    {
                        "id": 13121,
                        "name": "Minador do Negrão",
                        "latitude": "-9.30528000",
                        "longitude": "-36.86472000"
                    },
                    {
                        "id": 13217,
                        "name": "Monteirópolis",
                        "latitude": "-9.62019000",
                        "longitude": "-37.29350000"
                    },
                    {
                        "id": 13280,
                        "name": "Murici",
                        "latitude": "-9.29835000",
                        "longitude": "-35.89999000"
                    },
                    {
                        "id": 13468,
                        "name": "Novo Lino",
                        "latitude": "-8.88091000",
                        "longitude": "-35.61948000"
                    },
                    {
                        "id": 13497,
                        "name": "Olho d'Água das Flores",
                        "latitude": "-9.54034000",
                        "longitude": "-37.25214000"
                    },
                    {
                        "id": 13498,
                        "name": "Olho d'Água do Casado",
                        "latitude": "-9.45648000",
                        "longitude": "-37.83496000"
                    },
                    {
                        "id": 13495,
                        "name": "Olho d'Água Grande",
                        "latitude": "-10.05622000",
                        "longitude": "-36.79522000"
                    },
                    {
                        "id": 13510,
                        "name": "Olivença",
                        "latitude": "-9.51861000",
                        "longitude": "-37.19056000"
                    },
                    {
                        "id": 13539,
                        "name": "Ouro Branco",
                        "latitude": "-9.12895000",
                        "longitude": "-37.37367000"
                    },
                    {
                        "id": 13575,
                        "name": "Palestina",
                        "latitude": "-9.67504000",
                        "longitude": "-37.33100000"
                    },
                    {
                        "id": 13594,
                        "name": "Palmeira dos Índios",
                        "latitude": "-9.40902000",
                        "longitude": "-36.60651000"
                    },
                    {
                        "id": 14119,
                        "name": "Pão de Açúcar",
                        "latitude": "-9.68353000",
                        "longitude": "-37.45431000"
                    },
                    {
                        "id": 13671,
                        "name": "Pariconha",
                        "latitude": "-9.22039000",
                        "longitude": "-38.01670000"
                    },
                    {
                        "id": 13674,
                        "name": "Paripueira",
                        "latitude": "-9.42940000",
                        "longitude": "-35.58979000"
                    },
                    {
                        "id": 13697,
                        "name": "Passo de Camaragibe",
                        "latitude": "-9.29865000",
                        "longitude": "-35.42788000"
                    },
                    {
                        "id": 13734,
                        "name": "Paulo Jacinto",
                        "latitude": "-9.36843000",
                        "longitude": "-36.39294000"
                    },
                    {
                        "id": 13795,
                        "name": "Penedo",
                        "latitude": "-10.24448000",
                        "longitude": "-36.46992000"
                    },
                    {
                        "id": 13827,
                        "name": "Piaçabuçu",
                        "latitude": "-10.40556000",
                        "longitude": "-36.43444000"
                    },
                    {
                        "id": 13837,
                        "name": "Pilar",
                        "latitude": "-9.61752000",
                        "longitude": "-36.06323000"
                    },
                    {
                        "id": 13852,
                        "name": "Pindoba",
                        "latitude": "-9.47492000",
                        "longitude": "-36.30343000"
                    },
                    {
                        "id": 13897,
                        "name": "Piranhas",
                        "latitude": "-9.54806000",
                        "longitude": "-37.74529000"
                    },
                    {
                        "id": 14051,
                        "name": "Poço das Trincheiras",
                        "latitude": "-9.31250000",
                        "longitude": "-37.28556000"
                    },
                    {
                        "id": 14001,
                        "name": "Porto Calvo",
                        "latitude": "-9.04500000",
                        "longitude": "-35.39833000"
                    },
                    {
                        "id": 14026,
                        "name": "Porto de Pedras",
                        "latitude": "-9.11562000",
                        "longitude": "-35.39158000"
                    },
                    {
                        "id": 14014,
                        "name": "Porto Real do Colégio",
                        "latitude": "-10.10538000",
                        "longitude": "-36.72695000"
                    },
                    {
                        "id": 14136,
                        "name": "Quebrangulo",
                        "latitude": "-9.31889000",
                        "longitude": "-36.47111000"
                    },
                    {
                        "id": 14279,
                        "name": "Rio Largo",
                        "latitude": "-9.47833000",
                        "longitude": "-35.85333000"
                    },
                    {
                        "id": 14356,
                        "name": "Roteiro",
                        "latitude": "-9.85906000",
                        "longitude": "-35.98311000"
                    },
                    {
                        "id": 14495,
                        "name": "Santa Luzia do Norte",
                        "latitude": "-9.61082000",
                        "longitude": "-35.82917000"
                    },
                    {
                        "id": 14582,
                        "name": "Santana do Ipanema",
                        "latitude": "-9.37833000",
                        "longitude": "-37.24528000"
                    },
                    {
                        "id": 14589,
                        "name": "Santana do Mundaú",
                        "latitude": "-9.16806000",
                        "longitude": "-36.22222000"
                    },
                    {
                        "id": 14850,
                        "name": "São Brás",
                        "latitude": "-10.12409000",
                        "longitude": "-36.85043000"
                    },
                    {
                        "id": 14944,
                        "name": "São José da Laje",
                        "latitude": "-9.00972000",
                        "longitude": "-36.05833000"
                    },
                    {
                        "id": 14947,
                        "name": "São José da Tapera",
                        "latitude": "-9.55833000",
                        "longitude": "-37.38111000"
                    },
                    {
                        "id": 15067,
                        "name": "São Luís do Quitunde",
                        "latitude": "-9.31833000",
                        "longitude": "-35.56111000"
                    },
                    {
                        "id": 15097,
                        "name": "São Miguel dos Campos",
                        "latitude": "-9.78111000",
                        "longitude": "-36.09361000"
                    },
                    {
                        "id": 15098,
                        "name": "São Miguel dos Milagres",
                        "latitude": "-9.25423000",
                        "longitude": "-35.38419000"
                    },
                    {
                        "id": 15136,
                        "name": "São Sebastião",
                        "latitude": "-9.96698000",
                        "longitude": "-36.55280000"
                    },
                    {
                        "id": 14673,
                        "name": "Satuba",
                        "latitude": "-9.56333000",
                        "longitude": "-35.82444000"
                    },
                    {
                        "id": 14706,
                        "name": "Senador Rui Palmeira",
                        "latitude": "-9.33827000",
                        "longitude": "-37.55968000"
                    },
                    {
                        "id": 15221,
                        "name": "Tanque d'Arca",
                        "latitude": "-9.56069000",
                        "longitude": "-36.40824000"
                    },
                    {
                        "id": 15243,
                        "name": "Taquarana",
                        "latitude": "-9.64342000",
                        "longitude": "-36.49419000"
                    },
                    {
                        "id": 15282,
                        "name": "Teotônio Vilela",
                        "latitude": "-9.99012000",
                        "longitude": "-36.43273000"
                    },
                    {
                        "id": 15347,
                        "name": "Traipu",
                        "latitude": "-9.89240000",
                        "longitude": "-36.97849000"
                    },
                    {
                        "id": 15463,
                        "name": "União dos Palmares",
                        "latitude": "-9.13251000",
                        "longitude": "-36.08182000"
                    },
                    {
                        "id": 15606,
                        "name": "Viçosa",
                        "latitude": "-9.36022000",
                        "longitude": "-36.32095000"
                    }
                ]
            },
            {
                "id": 1999,
                "name": "Amapá",
                "iso2": "AP",
                "latitude": "0.90199250",
                "longitude": "-52.00295650",
                "type": "state",
                "cities": [
                    {
                        "id": 10204,
                        "name": "Amapá",
                        "latitude": "1.85706000",
                        "longitude": "-50.84374000"
                    },
                    {
                        "id": 10933,
                        "name": "Calçoene",
                        "latitude": "2.36098000",
                        "longitude": "-51.45285000"
                    },
                    {
                        "id": 11541,
                        "name": "Cutias",
                        "latitude": "0.99713000",
                        "longitude": "-50.52041000"
                    },
                    {
                        "id": 11812,
                        "name": "Ferreira Gomes",
                        "latitude": "0.91012000",
                        "longitude": "-51.35442000"
                    },
                    {
                        "id": 12462,
                        "name": "Itaubal",
                        "latitude": "0.57732000",
                        "longitude": "-50.67833000"
                    },
                    {
                        "id": 12798,
                        "name": "Laranjal do Jari",
                        "latitude": "0.93828000",
                        "longitude": "-53.22949000"
                    },
                    {
                        "id": 12887,
                        "name": "Macapá",
                        "latitude": "0.03889000",
                        "longitude": "-51.06639000"
                    },
                    {
                        "id": 13088,
                        "name": "Mazagão",
                        "latitude": "-0.11500000",
                        "longitude": "-51.28944000"
                    },
                    {
                        "id": 13492,
                        "name": "Oiapoque",
                        "latitude": "2.70795000",
                        "longitude": "-52.16963000"
                    },
                    {
                        "id": 13751,
                        "name": "Pedra Branca do Amapari",
                        "latitude": "1.14843000",
                        "longitude": "-52.40118000"
                    },
                    {
                        "id": 14008,
                        "name": "Porto Grande",
                        "latitude": "0.56553000",
                        "longitude": "-51.71181000"
                    },
                    {
                        "id": 14058,
                        "name": "Pracuúba",
                        "latitude": "1.67076000",
                        "longitude": "-51.24490000"
                    },
                    {
                        "id": 14568,
                        "name": "Santana",
                        "latitude": "-0.05833000",
                        "longitude": "-51.18167000"
                    },
                    {
                        "id": 14739,
                        "name": "Serra do Navio",
                        "latitude": "1.65803000",
                        "longitude": "-52.28195000"
                    },
                    {
                        "id": 15255,
                        "name": "Tartarugalzinho",
                        "latitude": "1.26300000",
                        "longitude": "-51.10973000"
                    },
                    {
                        "id": 15602,
                        "name": "Vitória do Jari",
                        "latitude": "-0.95653000",
                        "longitude": "-52.03443000"
                    }
                ]
            },
            {
                "id": 2004,
                "name": "Amazonas",
                "iso2": "AM",
                "latitude": "-3.07000000",
                "longitude": "-61.66000000",
                "type": "state",
                "cities": [
                    {
                        "id": 10191,
                        "name": "Alvarães",
                        "latitude": "-3.22083000",
                        "longitude": "-64.80417000"
                    },
                    {
                        "id": 10212,
                        "name": "Amaturá",
                        "latitude": "-3.38926000",
                        "longitude": "-68.22698000"
                    },
                    {
                        "id": 10233,
                        "name": "Anamã",
                        "latitude": "-3.47990000",
                        "longitude": "-61.71689000"
                    },
                    {
                        "id": 10266,
                        "name": "Anori",
                        "latitude": "-3.77278000",
                        "longitude": "-61.64417000"
                    },
                    {
                        "id": 10303,
                        "name": "Apuí",
                        "latitude": "-7.78922000",
                        "longitude": "-59.34104000"
                    },
                    {
                        "id": 10436,
                        "name": "Atalaia do Norte",
                        "latitude": "-5.66448000",
                        "longitude": "-71.82776000"
                    },
                    {
                        "id": 10454,
                        "name": "Autazes",
                        "latitude": "-3.57972000",
                        "longitude": "-59.13056000"
                    },
                    {
                        "id": 10513,
                        "name": "Barcelos",
                        "latitude": "-0.97357000",
                        "longitude": "-62.92690000"
                    },
                    {
                        "id": 10553,
                        "name": "Barreirinha",
                        "latitude": "-2.79333000",
                        "longitude": "-57.07000000"
                    },
                    {
                        "id": 10626,
                        "name": "Benjamin Constant",
                        "latitude": "-4.37555000",
                        "longitude": "-70.03179000"
                    },
                    {
                        "id": 10641,
                        "name": "Beruri",
                        "latitude": "-4.34371000",
                        "longitude": "-61.75126000"
                    },
                    {
                        "id": 10674,
                        "name": "Boa Vista do Ramos",
                        "latitude": "-3.15779000",
                        "longitude": "-57.90517000"
                    },
                    {
                        "id": 10678,
                        "name": "Boca do Acre",
                        "latitude": "-8.75222000",
                        "longitude": "-67.39778000"
                    },
                    {
                        "id": 10749,
                        "name": "Borba",
                        "latitude": "-4.39143000",
                        "longitude": "-59.58864000"
                    },
                    {
                        "id": 10841,
                        "name": "Caapiranga",
                        "latitude": "-3.12981000",
                        "longitude": "-61.74406000"
                    },
                    {
                        "id": 11059,
                        "name": "Canutama",
                        "latitude": "-6.53389000",
                        "longitude": "-64.38306000"
                    },
                    {
                        "id": 11111,
                        "name": "Carauari",
                        "latitude": "-4.88278000",
                        "longitude": "-66.89583000"
                    },
                    {
                        "id": 11125,
                        "name": "Careiro",
                        "latitude": "-3.78706000",
                        "longitude": "-60.34790000"
                    },
                    {
                        "id": 11126,
                        "name": "Careiro da Várzea",
                        "latitude": "-3.19695000",
                        "longitude": "-59.82674000"
                    },
                    {
                        "id": 11304,
                        "name": "Coari",
                        "latitude": "-4.08500000",
                        "longitude": "-63.14139000"
                    },
                    {
                        "id": 11313,
                        "name": "Codajás",
                        "latitude": "-3.83667000",
                        "longitude": "-62.05694000"
                    },
                    {
                        "id": 11676,
                        "name": "Eirunepé",
                        "latitude": "-6.66028000",
                        "longitude": "-69.87361000"
                    },
                    {
                        "id": 11711,
                        "name": "Envira",
                        "latitude": "-7.30000000",
                        "longitude": "-70.21667000"
                    },
                    {
                        "id": 11848,
                        "name": "Fonte Boa",
                        "latitude": "-2.51389000",
                        "longitude": "-66.09167000"
                    },
                    {
                        "id": 12018,
                        "name": "Guajará",
                        "latitude": "-2.96667000",
                        "longitude": "-57.66667000"
                    },
                    {
                        "id": 12110,
                        "name": "Humaitá",
                        "latitude": "-7.51651000",
                        "longitude": "-63.03105000"
                    },
                    {
                        "id": 12281,
                        "name": "Ipixuna",
                        "latitude": "-7.11910000",
                        "longitude": "-71.37590000"
                    },
                    {
                        "id": 12306,
                        "name": "Iranduba",
                        "latitude": "-3.28472000",
                        "longitude": "-60.18611000"
                    },
                    {
                        "id": 12342,
                        "name": "Itacoatiara",
                        "latitude": "-3.13435000",
                        "longitude": "-58.43353000"
                    },
                    {
                        "id": 12378,
                        "name": "Itamarati",
                        "latitude": "-6.76472000",
                        "longitude": "-68.03926000"
                    },
                    {
                        "id": 12421,
                        "name": "Itapiranga",
                        "latitude": "-2.51600000",
                        "longitude": "-58.55730000"
                    },
                    {
                        "id": 12575,
                        "name": "Japurá",
                        "latitude": "-1.55349000",
                        "longitude": "-68.24526000"
                    },
                    {
                        "id": 12703,
                        "name": "Juruá",
                        "latitude": "-3.27526000",
                        "longitude": "-66.24211000"
                    },
                    {
                        "id": 12710,
                        "name": "Jutaí",
                        "latitude": "-5.18333000",
                        "longitude": "-68.90000000"
                    },
                    {
                        "id": 12883,
                        "name": "Lábrea",
                        "latitude": "-8.18437000",
                        "longitude": "-66.07500000"
                    },
                    {
                        "id": 12936,
                        "name": "Manacapuru",
                        "latitude": "-3.29972000",
                        "longitude": "-60.62056000"
                    },
                    {
                        "id": 12937,
                        "name": "Manaquiri",
                        "latitude": "-3.31667000",
                        "longitude": "-60.35000000"
                    },
                    {
                        "id": 12939,
                        "name": "Manaus",
                        "latitude": "-3.04361000",
                        "longitude": "-60.01282000"
                    },
                    {
                        "id": 12951,
                        "name": "Manicoré",
                        "latitude": "-5.80917000",
                        "longitude": "-61.30028000"
                    },
                    {
                        "id": 12988,
                        "name": "Maraã",
                        "latitude": "-1.82403000",
                        "longitude": "-65.35883000"
                    },
                    {
                        "id": 13085,
                        "name": "Maués",
                        "latitude": "-3.38361000",
                        "longitude": "-57.71861000"
                    },
                    {
                        "id": 13321,
                        "name": "Nhamundá",
                        "latitude": "-2.18611000",
                        "longitude": "-56.71306000"
                    },
                    {
                        "id": 13413,
                        "name": "Nova Olinda do Norte",
                        "latitude": "-3.89174000",
                        "longitude": "-59.09542000"
                    },
                    {
                        "id": 13451,
                        "name": "Novo Airão",
                        "latitude": "-1.98386000",
                        "longitude": "-61.78513000"
                    },
                    {
                        "id": 13453,
                        "name": "Novo Aripuanã",
                        "latitude": "-5.12056000",
                        "longitude": "-60.37972000"
                    },
                    {
                        "id": 13672,
                        "name": "Parintins",
                        "latitude": "-2.62833000",
                        "longitude": "-56.73583000"
                    },
                    {
                        "id": 13720,
                        "name": "Pauini",
                        "latitude": "-7.71361000",
                        "longitude": "-66.97639000"
                    },
                    {
                        "id": 14082,
                        "name": "Presidente Figueiredo",
                        "latitude": "-1.28344000",
                        "longitude": "-59.98317000"
                    },
                    {
                        "id": 14293,
                        "name": "Rio Preto da Eva",
                        "latitude": "-2.69795000",
                        "longitude": "-59.70172000"
                    },
                    {
                        "id": 14483,
                        "name": "Santa Isabel do Rio Negro",
                        "latitude": "-0.41389000",
                        "longitude": "-65.01917000"
                    },
                    {
                        "id": 14628,
                        "name": "Santo Antônio do Içá",
                        "latitude": "-3.10222000",
                        "longitude": "-67.93972000"
                    },
                    {
                        "id": 14909,
                        "name": "São Gabriel da Cachoeira",
                        "latitude": "-0.11810000",
                        "longitude": "-67.08527000"
                    },
                    {
                        "id": 15103,
                        "name": "São Paulo de Olivença",
                        "latitude": "-3.37833000",
                        "longitude": "-68.87250000"
                    },
                    {
                        "id": 15153,
                        "name": "São Sebastião do Uatumã",
                        "latitude": "-1.93197000",
                        "longitude": "-58.74216000"
                    },
                    {
                        "id": 14780,
                        "name": "Silves",
                        "latitude": "-2.76846000",
                        "longitude": "-58.62751000"
                    },
                    {
                        "id": 15184,
                        "name": "Tabatinga",
                        "latitude": "-3.96298000",
                        "longitude": "-69.60265000"
                    },
                    {
                        "id": 15225,
                        "name": "Tapauá",
                        "latitude": "-6.21423000",
                        "longitude": "-65.69985000"
                    },
                    {
                        "id": 15264,
                        "name": "Tefé",
                        "latitude": "-3.36841000",
                        "longitude": "-64.72054000"
                    },
                    {
                        "id": 15336,
                        "name": "Tonantins",
                        "latitude": "-2.87306000",
                        "longitude": "-67.80222000"
                    },
                    {
                        "id": 15423,
                        "name": "Uarini",
                        "latitude": "-3.14736000",
                        "longitude": "-65.42036000"
                    },
                    {
                        "id": 15475,
                        "name": "Urucará",
                        "latitude": "-2.53639000",
                        "longitude": "-57.76000000"
                    },
                    {
                        "id": 15477,
                        "name": "Urucurituba",
                        "latitude": "-3.12845000",
                        "longitude": "-58.15856000"
                    }
                ]
            },
            {
                "id": 2002,
                "name": "Bahia",
                "iso2": "BA",
                "latitude": "-11.40987400",
                "longitude": "-41.28085700",
                "type": "state",
                "cities": [
                    {
                        "id": 10061,
                        "name": "Abaíra",
                        "latitude": "-13.32129000",
                        "longitude": "-41.69759000"
                    },
                    {
                        "id": 10059,
                        "name": "Abaré",
                        "latitude": "-8.80961000",
                        "longitude": "-39.27062000"
                    },
                    {
                        "id": 10069,
                        "name": "Acajutiba",
                        "latitude": "-11.60682000",
                        "longitude": "-38.03594000"
                    },
                    {
                        "id": 10084,
                        "name": "Adustina",
                        "latitude": "-10.48227000",
                        "longitude": "-37.98446000"
                    },
                    {
                        "id": 15659,
                        "name": "Água Fria",
                        "latitude": "-11.74762000",
                        "longitude": "-38.73497000"
                    },
                    {
                        "id": 10103,
                        "name": "Aiquara",
                        "latitude": "-14.11135000",
                        "longitude": "-39.87641000"
                    },
                    {
                        "id": 10113,
                        "name": "Alagoinhas",
                        "latitude": "-12.00580000",
                        "longitude": "-38.36146000"
                    },
                    {
                        "id": 10118,
                        "name": "Alcobaça",
                        "latitude": "-17.46365000",
                        "longitude": "-39.37401000"
                    },
                    {
                        "id": 10139,
                        "name": "Almadina",
                        "latitude": "-14.67608000",
                        "longitude": "-39.69066000"
                    },
                    {
                        "id": 10211,
                        "name": "Amargosa",
                        "latitude": "-13.04970000",
                        "longitude": "-39.60720000"
                    },
                    {
                        "id": 10223,
                        "name": "Amélia Rodrigues",
                        "latitude": "-12.38975000",
                        "longitude": "-38.75153000"
                    },
                    {
                        "id": 10224,
                        "name": "América Dourada",
                        "latitude": "-11.46940000",
                        "longitude": "-41.47335000"
                    },
                    {
                        "id": 10228,
                        "name": "Anagé",
                        "latitude": "-14.66168000",
                        "longitude": "-41.14703000"
                    },
                    {
                        "id": 10242,
                        "name": "Andaraí",
                        "latitude": "-12.84167000",
                        "longitude": "-41.27679000"
                    },
                    {
                        "id": 10244,
                        "name": "Andorinha",
                        "latitude": "-10.22216000",
                        "longitude": "-39.86387000"
                    },
                    {
                        "id": 10253,
                        "name": "Angical",
                        "latitude": "-11.96280000",
                        "longitude": "-44.74980000"
                    },
                    {
                        "id": 10258,
                        "name": "Anguera",
                        "latitude": "-12.18221000",
                        "longitude": "-39.21384000"
                    },
                    {
                        "id": 10268,
                        "name": "Antas",
                        "latitude": "-10.42138000",
                        "longitude": "-38.30341000"
                    },
                    {
                        "id": 10272,
                        "name": "Antônio Cardoso",
                        "latitude": "-12.38641000",
                        "longitude": "-39.14549000"
                    },
                    {
                        "id": 10276,
                        "name": "Antônio Gonçalves",
                        "latitude": "-10.62282000",
                        "longitude": "-40.40933000"
                    },
                    {
                        "id": 10298,
                        "name": "Aporá",
                        "latitude": "-11.75439000",
                        "longitude": "-38.22784000"
                    },
                    {
                        "id": 10300,
                        "name": "Apuarema",
                        "latitude": "-13.83005000",
                        "longitude": "-39.73444000"
                    },
                    {
                        "id": 10374,
                        "name": "Araçás",
                        "latitude": "-12.14681000",
                        "longitude": "-38.17233000"
                    },
                    {
                        "id": 10310,
                        "name": "Aracatu",
                        "latitude": "-14.39011000",
                        "longitude": "-41.36331000"
                    },
                    {
                        "id": 10311,
                        "name": "Araci",
                        "latitude": "-11.13564000",
                        "longitude": "-39.07003000"
                    },
                    {
                        "id": 10330,
                        "name": "Aramari",
                        "latitude": "-12.04618000",
                        "longitude": "-38.55762000"
                    },
                    {
                        "id": 10359,
                        "name": "Arataca",
                        "latitude": "-15.24607000",
                        "longitude": "-39.42481000"
                    },
                    {
                        "id": 10362,
                        "name": "Aratuípe",
                        "latitude": "-13.09363000",
                        "longitude": "-39.08259000"
                    },
                    {
                        "id": 10447,
                        "name": "Aurelino Leal",
                        "latitude": "-14.36310000",
                        "longitude": "-39.47961000"
                    },
                    {
                        "id": 10475,
                        "name": "Baianópolis",
                        "latitude": "-12.48331000",
                        "longitude": "-44.53105000"
                    },
                    {
                        "id": 10476,
                        "name": "Baixa Grande",
                        "latitude": "-11.97735000",
                        "longitude": "-40.17993000"
                    },
                    {
                        "id": 10504,
                        "name": "Banzaê",
                        "latitude": "-10.61578000",
                        "longitude": "-38.62688000"
                    },
                    {
                        "id": 10515,
                        "name": "Barra",
                        "latitude": "-11.08944000",
                        "longitude": "-43.14167000"
                    },
                    {
                        "id": 10523,
                        "name": "Barra da Estiva",
                        "latitude": "-13.62611000",
                        "longitude": "-41.32694000"
                    },
                    {
                        "id": 10533,
                        "name": "Barra do Choça",
                        "latitude": "-15.01024000",
                        "longitude": "-40.66731000"
                    },
                    {
                        "id": 10538,
                        "name": "Barra do Mendes",
                        "latitude": "-12.16094000",
                        "longitude": "-42.03542000"
                    },
                    {
                        "id": 10544,
                        "name": "Barra do Rocha",
                        "latitude": "-14.07510000",
                        "longitude": "-39.59068000"
                    },
                    {
                        "id": 10551,
                        "name": "Barreiras",
                        "latitude": "-12.15278000",
                        "longitude": "-44.99000000"
                    },
                    {
                        "id": 10560,
                        "name": "Barro Alto",
                        "latitude": "-11.76083000",
                        "longitude": "-41.91167000"
                    },
                    {
                        "id": 10563,
                        "name": "Barro Preto",
                        "latitude": "-14.75795000",
                        "longitude": "-39.40711000"
                    },
                    {
                        "id": 10564,
                        "name": "Barrocas",
                        "latitude": "-11.60190000",
                        "longitude": "-39.12267000"
                    },
                    {
                        "id": 10592,
                        "name": "Beira Rio",
                        "latitude": "-12.25438000",
                        "longitude": "-42.75529000"
                    },
                    {
                        "id": 10604,
                        "name": "Belmonte",
                        "latitude": "-15.86126000",
                        "longitude": "-38.87982000"
                    },
                    {
                        "id": 10606,
                        "name": "Belo Campo",
                        "latitude": "-14.87419000",
                        "longitude": "-41.22671000"
                    },
                    {
                        "id": 10654,
                        "name": "Biritinga",
                        "latitude": "-11.67075000",
                        "longitude": "-38.78931000"
                    },
                    {
                        "id": 10663,
                        "name": "Boa Nova",
                        "latitude": "-14.36412000",
                        "longitude": "-40.22378000"
                    },
                    {
                        "id": 10676,
                        "name": "Boa Vista do Tupim",
                        "latitude": "-12.87313000",
                        "longitude": "-40.62823000"
                    },
                    {
                        "id": 10703,
                        "name": "Bom Jesus da Lapa",
                        "latitude": "-13.25500000",
                        "longitude": "-43.41806000"
                    },
                    {
                        "id": 10705,
                        "name": "Bom Jesus da Serra",
                        "latitude": "-14.38380000",
                        "longitude": "-40.53982000"
                    },
                    {
                        "id": 10735,
                        "name": "Boninal",
                        "latitude": "-12.80363000",
                        "longitude": "-41.68338000"
                    },
                    {
                        "id": 10739,
                        "name": "Bonito",
                        "latitude": "-12.00488000",
                        "longitude": "-41.31779000"
                    },
                    {
                        "id": 10747,
                        "name": "Boquira",
                        "latitude": "-12.82306000",
                        "longitude": "-42.73056000"
                    },
                    {
                        "id": 10760,
                        "name": "Botuporã",
                        "latitude": "-13.29549000",
                        "longitude": "-42.52593000"
                    },
                    {
                        "id": 10800,
                        "name": "Brejões",
                        "latitude": "-13.07059000",
                        "longitude": "-39.82099000"
                    },
                    {
                        "id": 10798,
                        "name": "Brejolândia",
                        "latitude": "-12.41237000",
                        "longitude": "-43.92822000"
                    },
                    {
                        "id": 10808,
                        "name": "Brotas de Macaúbas",
                        "latitude": "-12.10605000",
                        "longitude": "-42.51108000"
                    },
                    {
                        "id": 10810,
                        "name": "Brumado",
                        "latitude": "-14.20361000",
                        "longitude": "-41.66528000"
                    },
                    {
                        "id": 10817,
                        "name": "Buerarema",
                        "latitude": "-14.95944000",
                        "longitude": "-39.29972000"
                    },
                    {
                        "id": 10832,
                        "name": "Buritirama",
                        "latitude": "-10.57081000",
                        "longitude": "-43.68863000"
                    },
                    {
                        "id": 10844,
                        "name": "Caatiba",
                        "latitude": "-14.97610000",
                        "longitude": "-40.39048000"
                    },
                    {
                        "id": 10846,
                        "name": "Cabaceiras do Paraguaçu",
                        "latitude": "-12.55423000",
                        "longitude": "-39.19596000"
                    },
                    {
                        "id": 10861,
                        "name": "Cachoeira",
                        "latitude": "-12.60139000",
                        "longitude": "-38.96576000"
                    },
                    {
                        "id": 10887,
                        "name": "Caculé",
                        "latitude": "-14.38829000",
                        "longitude": "-42.41516000"
                    },
                    {
                        "id": 11225,
                        "name": "Caém",
                        "latitude": "-11.14182000",
                        "longitude": "-40.29142000"
                    },
                    {
                        "id": 10888,
                        "name": "Caetanos",
                        "latitude": "-14.29234000",
                        "longitude": "-41.01004000"
                    },
                    {
                        "id": 10890,
                        "name": "Caetité",
                        "latitude": "-13.97883000",
                        "longitude": "-42.49334000"
                    },
                    {
                        "id": 10893,
                        "name": "Cafarnaum",
                        "latitude": "-11.69361000",
                        "longitude": "-41.46833000"
                    },
                    {
                        "id": 10905,
                        "name": "Cairu",
                        "latitude": "-13.52662000",
                        "longitude": "-38.94814000"
                    },
                    {
                        "id": 10927,
                        "name": "Caldeirão Grande",
                        "latitude": "-11.04347000",
                        "longitude": "-40.29515000"
                    },
                    {
                        "id": 10934,
                        "name": "Camacan",
                        "latitude": "-15.42769000",
                        "longitude": "-39.50818000"
                    },
                    {
                        "id": 10943,
                        "name": "Camaçari",
                        "latitude": "-12.69750000",
                        "longitude": "-38.32417000"
                    },
                    {
                        "id": 10937,
                        "name": "Camamu",
                        "latitude": "-13.94472000",
                        "longitude": "-39.10389000"
                    },
                    {
                        "id": 10979,
                        "name": "Campo Alegre de Lourdes",
                        "latitude": "-9.50097000",
                        "longitude": "-42.98275000"
                    },
                    {
                        "id": 10988,
                        "name": "Campo Formoso",
                        "latitude": "-10.50750000",
                        "longitude": "-40.32139000"
                    },
                    {
                        "id": 11060,
                        "name": "Canápolis",
                        "latitude": "-13.12516000",
                        "longitude": "-44.25095000"
                    },
                    {
                        "id": 11025,
                        "name": "Canarana",
                        "latitude": "-11.68472000",
                        "longitude": "-41.76889000"
                    },
                    {
                        "id": 11029,
                        "name": "Canavieiras",
                        "latitude": "-15.67500000",
                        "longitude": "-38.94722000"
                    },
                    {
                        "id": 11032,
                        "name": "Candeal",
                        "latitude": "-11.89504000",
                        "longitude": "-39.20390000"
                    },
                    {
                        "id": 11033,
                        "name": "Candeias",
                        "latitude": "-12.65569000",
                        "longitude": "-38.48700000"
                    },
                    {
                        "id": 11037,
                        "name": "Candiba",
                        "latitude": "-14.46972000",
                        "longitude": "-42.87386000"
                    },
                    {
                        "id": 11549,
                        "name": "Cândido Sales",
                        "latitude": "-15.46082000",
                        "longitude": "-41.16353000"
                    },
                    {
                        "id": 11051,
                        "name": "Cansanção",
                        "latitude": "-10.73105000",
                        "longitude": "-39.47418000"
                    },
                    {
                        "id": 11057,
                        "name": "Canudos",
                        "latitude": "-9.87981000",
                        "longitude": "-39.14723000"
                    },
                    {
                        "id": 11070,
                        "name": "Capela do Alto Alegre",
                        "latitude": "-11.61838000",
                        "longitude": "-39.83227000"
                    },
                    {
                        "id": 11075,
                        "name": "Capim Grosso",
                        "latitude": "-11.38111000",
                        "longitude": "-40.01278000"
                    },
                    {
                        "id": 11116,
                        "name": "Caraíbas",
                        "latitude": "-14.60631000",
                        "longitude": "-41.25763000"
                    },
                    {
                        "id": 11112,
                        "name": "Caravelas",
                        "latitude": "-17.65842000",
                        "longitude": "-39.35989000"
                    },
                    {
                        "id": 11121,
                        "name": "Cardeal da Silva",
                        "latitude": "-11.99798000",
                        "longitude": "-37.92468000"
                    },
                    {
                        "id": 11131,
                        "name": "Carinhanha",
                        "latitude": "-14.30472000",
                        "longitude": "-43.76500000"
                    },
                    {
                        "id": 11173,
                        "name": "Casa Nova",
                        "latitude": "-9.10439000",
                        "longitude": "-41.15736000"
                    },
                    {
                        "id": 11192,
                        "name": "Castro Alves",
                        "latitude": "-12.74937000",
                        "longitude": "-39.37691000"
                    },
                    {
                        "id": 11204,
                        "name": "Catolândia",
                        "latitude": "-12.29613000",
                        "longitude": "-44.67528000"
                    },
                    {
                        "id": 11206,
                        "name": "Catu",
                        "latitude": "-12.35306000",
                        "longitude": "-38.37889000"
                    },
                    {
                        "id": 11209,
                        "name": "Caturama",
                        "latitude": "-13.18601000",
                        "longitude": "-42.30250000"
                    },
                    {
                        "id": 11238,
                        "name": "Central",
                        "latitude": "-11.15424000",
                        "longitude": "-42.08146000"
                    },
                    {
                        "id": 11280,
                        "name": "Chorrochó",
                        "latitude": "-9.30550000",
                        "longitude": "-39.15652000"
                    },
                    {
                        "id": 11552,
                        "name": "Cícero Dantas",
                        "latitude": "-10.60000000",
                        "longitude": "-38.38333000"
                    },
                    {
                        "id": 11295,
                        "name": "Cipó",
                        "latitude": "-11.09972000",
                        "longitude": "-38.51361000"
                    },
                    {
                        "id": 11303,
                        "name": "Coaraci",
                        "latitude": "-14.64083000",
                        "longitude": "-39.55111000"
                    },
                    {
                        "id": 11312,
                        "name": "Cocos",
                        "latitude": "-14.59438000",
                        "longitude": "-45.27960000"
                    },
                    {
                        "id": 11348,
                        "name": "Conceição da Feira",
                        "latitude": "-12.50583000",
                        "longitude": "-38.99861000"
                    },
                    {
                        "id": 11353,
                        "name": "Conceição do Almeida",
                        "latitude": "-12.77944000",
                        "longitude": "-39.17000000"
                    },
                    {
                        "id": 11357,
                        "name": "Conceição do Coité",
                        "latitude": "-11.56389000",
                        "longitude": "-39.28278000"
                    },
                    {
                        "id": 11358,
                        "name": "Conceição do Jacuípe",
                        "latitude": "-12.31667000",
                        "longitude": "-38.76667000"
                    },
                    {
                        "id": 11372,
                        "name": "Conde",
                        "latitude": "-11.81361000",
                        "longitude": "-37.61056000"
                    },
                    {
                        "id": 11373,
                        "name": "Condeúba",
                        "latitude": "-14.93275000",
                        "longitude": "-42.00693000"
                    },
                    {
                        "id": 11391,
                        "name": "Contendas do Sincorá",
                        "latitude": "-13.79599000",
                        "longitude": "-41.05002000"
                    },
                    {
                        "id": 11397,
                        "name": "Coração de Maria",
                        "latitude": "-12.23333000",
                        "longitude": "-38.75000000"
                    },
                    {
                        "id": 11400,
                        "name": "Cordeiros",
                        "latitude": "-14.99846000",
                        "longitude": "-41.89749000"
                    },
                    {
                        "id": 11408,
                        "name": "Coribe",
                        "latitude": "-13.72337000",
                        "longitude": "-44.43538000"
                    },
                    {
                        "id": 11423,
                        "name": "Coronel João Sá",
                        "latitude": "-10.38878000",
                        "longitude": "-37.94281000"
                    },
                    {
                        "id": 11436,
                        "name": "Correntina",
                        "latitude": "-13.34333000",
                        "longitude": "-44.63667000"
                    },
                    {
                        "id": 11451,
                        "name": "Cotegipe",
                        "latitude": "-11.58844000",
                        "longitude": "-44.17000000"
                    },
                    {
                        "id": 11463,
                        "name": "Cravolândia",
                        "latitude": "-13.47018000",
                        "longitude": "-39.75493000"
                    },
                    {
                        "id": 11482,
                        "name": "Crisópolis",
                        "latitude": "-11.45532000",
                        "longitude": "-38.13933000"
                    },
                    {
                        "id": 11480,
                        "name": "Cristópolis",
                        "latitude": "-12.21789000",
                        "longitude": "-44.24987000"
                    },
                    {
                        "id": 11491,
                        "name": "Cruz das Almas",
                        "latitude": "-12.67000000",
                        "longitude": "-39.10194000"
                    },
                    {
                        "id": 11521,
                        "name": "Curaçá",
                        "latitude": "-8.99028000",
                        "longitude": "-39.90944000"
                    },
                    {
                        "id": 11671,
                        "name": "Dário Meira",
                        "latitude": "-14.42340000",
                        "longitude": "-39.95935000"
                    },
                    {
                        "id": 11591,
                        "name": "Dias d'Ávila",
                        "latitude": "-12.60625000",
                        "longitude": "-38.33717000"
                    },
                    {
                        "id": 11623,
                        "name": "Dom Basílio",
                        "latitude": "-13.79717000",
                        "longitude": "-41.70877000"
                    },
                    {
                        "id": 11631,
                        "name": "Dom Macedo Costa",
                        "latitude": "-12.93379000",
                        "longitude": "-39.14621000"
                    },
                    {
                        "id": 11685,
                        "name": "Elísio Medrado",
                        "latitude": "-12.95431000",
                        "longitude": "-39.50579000"
                    },
                    {
                        "id": 11696,
                        "name": "Encruzilhada",
                        "latitude": "-15.56839000",
                        "longitude": "-40.90789000"
                    },
                    {
                        "id": 11705,
                        "name": "Entre Rios",
                        "latitude": "-11.94194000",
                        "longitude": "-38.08444000"
                    },
                    {
                        "id": 15682,
                        "name": "Érico Cardoso",
                        "latitude": "-13.43695000",
                        "longitude": "-42.10325000"
                    },
                    {
                        "id": 11737,
                        "name": "Esplanada",
                        "latitude": "-11.79611000",
                        "longitude": "-37.94500000"
                    },
                    {
                        "id": 11759,
                        "name": "Euclides da Cunha",
                        "latitude": "-10.50750000",
                        "longitude": "-39.01583000"
                    },
                    {
                        "id": 11763,
                        "name": "Eunápolis",
                        "latitude": "-16.37750000",
                        "longitude": "-39.58028000"
                    },
                    {
                        "id": 11907,
                        "name": "Fátima",
                        "latitude": "-10.54600000",
                        "longitude": "-38.22367000"
                    },
                    {
                        "id": 11793,
                        "name": "Feira da Mata",
                        "latitude": "-14.13203000",
                        "longitude": "-44.25281000"
                    },
                    {
                        "id": 11794,
                        "name": "Feira de Santana",
                        "latitude": "-12.26667000",
                        "longitude": "-38.96667000"
                    },
                    {
                        "id": 11821,
                        "name": "Filadélfia",
                        "latitude": "-10.76635000",
                        "longitude": "-40.20555000"
                    },
                    {
                        "id": 11822,
                        "name": "Firmino Alves",
                        "latitude": "-14.91360000",
                        "longitude": "-39.91192000"
                    },
                    {
                        "id": 11836,
                        "name": "Floresta Azul",
                        "latitude": "-14.84450000",
                        "longitude": "-39.75503000"
                    },
                    {
                        "id": 11855,
                        "name": "Formosa do Rio Preto",
                        "latitude": "-11.04833000",
                        "longitude": "-45.19306000"
                    },
                    {
                        "id": 11918,
                        "name": "Gandu",
                        "latitude": "-13.74389000",
                        "longitude": "-39.48667000"
                    },
                    {
                        "id": 11930,
                        "name": "Gavião",
                        "latitude": "-11.48891000",
                        "longitude": "-39.77412000"
                    },
                    {
                        "id": 11941,
                        "name": "Gentio do Ouro",
                        "latitude": "-11.36279000",
                        "longitude": "-42.54827000"
                    },
                    {
                        "id": 11950,
                        "name": "Glória",
                        "latitude": "-9.11097000",
                        "longitude": "-38.40655000"
                    },
                    {
                        "id": 11972,
                        "name": "Gongogi",
                        "latitude": "-14.29995000",
                        "longitude": "-39.60138000"
                    },
                    {
                        "id": 11987,
                        "name": "Governador Mangabeira",
                        "latitude": "-12.57719000",
                        "longitude": "-39.03115000"
                    },
                    {
                        "id": 12021,
                        "name": "Guajeru",
                        "latitude": "-14.57881000",
                        "longitude": "-42.03986000"
                    },
                    {
                        "id": 12024,
                        "name": "Guanambi",
                        "latitude": "-14.22333000",
                        "longitude": "-42.78139000"
                    },
                    {
                        "id": 12057,
                        "name": "Guaratinga",
                        "latitude": "-16.58564000",
                        "longitude": "-39.78189000"
                    },
                    {
                        "id": 12095,
                        "name": "Heliópolis",
                        "latitude": "-10.72863000",
                        "longitude": "-38.25490000"
                    },
                    {
                        "id": 12119,
                        "name": "Iaçu",
                        "latitude": "-12.76722000",
                        "longitude": "-40.21167000"
                    },
                    {
                        "id": 12131,
                        "name": "Ibiassucê",
                        "latitude": "-14.20285000",
                        "longitude": "-42.30214000"
                    },
                    {
                        "id": 12134,
                        "name": "Ibicaraí",
                        "latitude": "-14.86500000",
                        "longitude": "-39.58750000"
                    },
                    {
                        "id": 12136,
                        "name": "Ibicoara",
                        "latitude": "-13.37664000",
                        "longitude": "-41.34081000"
                    },
                    {
                        "id": 12138,
                        "name": "Ibicuí",
                        "latitude": "-14.84167000",
                        "longitude": "-39.98667000"
                    },
                    {
                        "id": 12140,
                        "name": "Ibipeba",
                        "latitude": "-11.64083000",
                        "longitude": "-42.01111000"
                    },
                    {
                        "id": 12141,
                        "name": "Ibipitanga",
                        "latitude": "-12.88655000",
                        "longitude": "-42.37115000"
                    },
                    {
                        "id": 12143,
                        "name": "Ibiquera",
                        "latitude": "-12.57265000",
                        "longitude": "-40.84158000"
                    },
                    {
                        "id": 12149,
                        "name": "Ibirapitanga",
                        "latitude": "-14.16417000",
                        "longitude": "-39.37361000"
                    },
                    {
                        "id": 12151,
                        "name": "Ibirapuã",
                        "latitude": "-17.75567000",
                        "longitude": "-39.97365000"
                    },
                    {
                        "id": 12153,
                        "name": "Ibirataia",
                        "latitude": "-14.06694000",
                        "longitude": "-39.64056000"
                    },
                    {
                        "id": 12158,
                        "name": "Ibitiara",
                        "latitude": "-12.56582000",
                        "longitude": "-42.38990000"
                    },
                    {
                        "id": 12161,
                        "name": "Ibititá",
                        "latitude": "-11.69354000",
                        "longitude": "-41.84148000"
                    },
                    {
                        "id": 12166,
                        "name": "Ibotirama",
                        "latitude": "-12.18528000",
                        "longitude": "-43.22056000"
                    },
                    {
                        "id": 12171,
                        "name": "Ichu",
                        "latitude": "-11.70344000",
                        "longitude": "-39.18722000"
                    },
                    {
                        "id": 12178,
                        "name": "Igaporã",
                        "latitude": "-13.89064000",
                        "longitude": "-42.76046000"
                    },
                    {
                        "id": 12192,
                        "name": "Igrapiúna",
                        "latitude": "-13.85607000",
                        "longitude": "-39.19363000"
                    },
                    {
                        "id": 12203,
                        "name": "Iguaí",
                        "latitude": "-14.75639000",
                        "longitude": "-40.08917000"
                    },
                    {
                        "id": 12214,
                        "name": "Ilhéus",
                        "latitude": "-14.79364000",
                        "longitude": "-39.03949000"
                    },
                    {
                        "id": 12247,
                        "name": "Inhambupe",
                        "latitude": "-11.78444000",
                        "longitude": "-38.35306000"
                    },
                    {
                        "id": 12268,
                        "name": "Ipecaetá",
                        "latitude": "-12.33777000",
                        "longitude": "-39.32835000"
                    },
                    {
                        "id": 12272,
                        "name": "Ipiaú",
                        "latitude": "-14.13449000",
                        "longitude": "-39.73948000"
                    },
                    {
                        "id": 12280,
                        "name": "Ipirá",
                        "latitude": "-12.15833000",
                        "longitude": "-39.73722000"
                    },
                    {
                        "id": 12297,
                        "name": "Ipupiara",
                        "latitude": "-11.76946000",
                        "longitude": "-42.43301000"
                    },
                    {
                        "id": 12304,
                        "name": "Irajuba",
                        "latitude": "-13.17999000",
                        "longitude": "-39.99530000"
                    },
                    {
                        "id": 12305,
                        "name": "Iramaia",
                        "latitude": "-13.54627000",
                        "longitude": "-40.82834000"
                    },
                    {
                        "id": 12310,
                        "name": "Iraquara",
                        "latitude": "-12.28624000",
                        "longitude": "-41.59153000"
                    },
                    {
                        "id": 12311,
                        "name": "Irará",
                        "latitude": "-12.05000000",
                        "longitude": "-38.76667000"
                    },
                    {
                        "id": 12317,
                        "name": "Irecê",
                        "latitude": "-11.30417000",
                        "longitude": "-41.85583000"
                    },
                    {
                        "id": 12328,
                        "name": "Itabela",
                        "latitude": "-16.71635000",
                        "longitude": "-39.57325000"
                    },
                    {
                        "id": 12329,
                        "name": "Itaberaba",
                        "latitude": "-12.52750000",
                        "longitude": "-40.30694000"
                    },
                    {
                        "id": 12337,
                        "name": "Itabuna",
                        "latitude": "-14.78556000",
                        "longitude": "-39.28028000"
                    },
                    {
                        "id": 12341,
                        "name": "Itacaré",
                        "latitude": "-14.27890000",
                        "longitude": "-38.99584000"
                    },
                    {
                        "id": 12346,
                        "name": "Itaeté",
                        "latitude": "-13.08598000",
                        "longitude": "-41.02566000"
                    },
                    {
                        "id": 12347,
                        "name": "Itagi",
                        "latitude": "-14.16278000",
                        "longitude": "-40.00611000"
                    },
                    {
                        "id": 12348,
                        "name": "Itagibá",
                        "latitude": "-14.28361000",
                        "longitude": "-39.84278000"
                    },
                    {
                        "id": 12349,
                        "name": "Itagimirim",
                        "latitude": "-16.13473000",
                        "longitude": "-39.81646000"
                    },
                    {
                        "id": 12356,
                        "name": "Itaguaçu da Bahia",
                        "latitude": "-10.64259000",
                        "longitude": "-42.21083000"
                    },
                    {
                        "id": 12369,
                        "name": "Itaju do Colônia",
                        "latitude": "-15.15505000",
                        "longitude": "-39.71598000"
                    },
                    {
                        "id": 12371,
                        "name": "Itajuípe",
                        "latitude": "-14.67806000",
                        "longitude": "-39.37500000"
                    },
                    {
                        "id": 12376,
                        "name": "Itamaraju",
                        "latitude": "-17.03917000",
                        "longitude": "-39.53111000"
                    },
                    {
                        "id": 12380,
                        "name": "Itamari",
                        "latitude": "-13.78590000",
                        "longitude": "-39.68416000"
                    },
                    {
                        "id": 12383,
                        "name": "Itambé",
                        "latitude": "-15.24500000",
                        "longitude": "-40.62444000"
                    },
                    {
                        "id": 12389,
                        "name": "Itanagra",
                        "latitude": "-12.30982000",
                        "longitude": "-38.11328000"
                    },
                    {
                        "id": 12394,
                        "name": "Itanhém",
                        "latitude": "-17.16639000",
                        "longitude": "-40.33000000"
                    },
                    {
                        "id": 12402,
                        "name": "Itaparica",
                        "latitude": "-12.90598000",
                        "longitude": "-38.66383000"
                    },
                    {
                        "id": 12441,
                        "name": "Itapé",
                        "latitude": "-14.91851000",
                        "longitude": "-39.48637000"
                    },
                    {
                        "id": 12403,
                        "name": "Itapebi",
                        "latitude": "-15.88751000",
                        "longitude": "-39.68792000"
                    },
                    {
                        "id": 12413,
                        "name": "Itapetinga",
                        "latitude": "-15.24889000",
                        "longitude": "-40.24778000"
                    },
                    {
                        "id": 12418,
                        "name": "Itapicuru",
                        "latitude": "-11.31667000",
                        "longitude": "-38.23333000"
                    },
                    {
                        "id": 12427,
                        "name": "Itapitanga",
                        "latitude": "-14.46369000",
                        "longitude": "-39.62565000"
                    },
                    {
                        "id": 12443,
                        "name": "Itaquara",
                        "latitude": "-13.44720000",
                        "longitude": "-39.91030000"
                    },
                    {
                        "id": 12448,
                        "name": "Itarantim",
                        "latitude": "-15.65972000",
                        "longitude": "-40.06556000"
                    },
                    {
                        "id": 12458,
                        "name": "Itatim",
                        "latitude": "-12.62835000",
                        "longitude": "-39.68234000"
                    },
                    {
                        "id": 12478,
                        "name": "Itiruçu",
                        "latitude": "-13.53167000",
                        "longitude": "-40.15028000"
                    },
                    {
                        "id": 12479,
                        "name": "Itiúba",
                        "latitude": "-10.79357000",
                        "longitude": "-39.80381000"
                    },
                    {
                        "id": 12481,
                        "name": "Itororó",
                        "latitude": "-15.11694000",
                        "longitude": "-40.07028000"
                    },
                    {
                        "id": 12483,
                        "name": "Ituaçu",
                        "latitude": "-13.81333000",
                        "longitude": "-41.29667000"
                    },
                    {
                        "id": 12484,
                        "name": "Ituberá",
                        "latitude": "-13.73538000",
                        "longitude": "-39.14785000"
                    },
                    {
                        "id": 12497,
                        "name": "Iuiu",
                        "latitude": "-14.65015000",
                        "longitude": "-43.64870000"
                    },
                    {
                        "id": 12510,
                        "name": "Jaborandi",
                        "latitude": "-14.03850000",
                        "longitude": "-45.18408000"
                    },
                    {
                        "id": 12517,
                        "name": "Jacaraci",
                        "latitude": "-14.83523000",
                        "longitude": "-42.40112000"
                    },
                    {
                        "id": 12527,
                        "name": "Jacobina",
                        "latitude": "-11.18143000",
                        "longitude": "-40.51372000"
                    },
                    {
                        "id": 12537,
                        "name": "Jaguaquara",
                        "latitude": "-13.53056000",
                        "longitude": "-39.97083000"
                    },
                    {
                        "id": 12538,
                        "name": "Jaguarari",
                        "latitude": "-10.26389000",
                        "longitude": "-40.19583000"
                    },
                    {
                        "id": 12545,
                        "name": "Jaguaripe",
                        "latitude": "-13.12834000",
                        "longitude": "-39.01339000"
                    },
                    {
                        "id": 12559,
                        "name": "Jandaíra",
                        "latitude": "-11.61099000",
                        "longitude": "-37.61845000"
                    },
                    {
                        "id": 12619,
                        "name": "Jequié",
                        "latitude": "-13.85875000",
                        "longitude": "-40.08512000"
                    },
                    {
                        "id": 12620,
                        "name": "Jeremoabo",
                        "latitude": "-9.92088000",
                        "longitude": "-38.72629000"
                    },
                    {
                        "id": 12632,
                        "name": "Jiquiriçá",
                        "latitude": "-13.31081000",
                        "longitude": "-39.58091000"
                    },
                    {
                        "id": 12633,
                        "name": "Jitaúna",
                        "latitude": "-14.01274000",
                        "longitude": "-39.89833000"
                    },
                    {
                        "id": 12661,
                        "name": "João Dourado",
                        "latitude": "-11.14883000",
                        "longitude": "-41.40438000"
                    },
                    {
                        "id": 12673,
                        "name": "Juazeiro",
                        "latitude": "-9.39679000",
                        "longitude": "-40.23381000"
                    },
                    {
                        "id": 12678,
                        "name": "Jucuruçu",
                        "latitude": "-16.84832000",
                        "longitude": "-40.08414000"
                    },
                    {
                        "id": 12705,
                        "name": "Jussara",
                        "latitude": "-10.96408000",
                        "longitude": "-41.85572000"
                    },
                    {
                        "id": 12708,
                        "name": "Jussari",
                        "latitude": "-15.15451000",
                        "longitude": "-39.51559000"
                    },
                    {
                        "id": 12709,
                        "name": "Jussiape",
                        "latitude": "-13.48810000",
                        "longitude": "-41.62335000"
                    },
                    {
                        "id": 12724,
                        "name": "Lafaiete Coutinho",
                        "latitude": "-13.62029000",
                        "longitude": "-40.20444000"
                    },
                    {
                        "id": 12742,
                        "name": "Lagoa Real",
                        "latitude": "-14.10985000",
                        "longitude": "-42.21697000"
                    },
                    {
                        "id": 12773,
                        "name": "Laje",
                        "latitude": "-10.18708000",
                        "longitude": "-40.97076000"
                    },
                    {
                        "id": 12783,
                        "name": "Lajedão",
                        "latitude": "-17.57112000",
                        "longitude": "-40.31123000"
                    },
                    {
                        "id": 12780,
                        "name": "Lajedinho",
                        "latitude": "-12.42698000",
                        "longitude": "-41.15097000"
                    },
                    {
                        "id": 12782,
                        "name": "Lajedo do Tabocal",
                        "latitude": "-13.37125000",
                        "longitude": "-40.23004000"
                    },
                    {
                        "id": 12787,
                        "name": "Lamarão",
                        "latitude": "-11.77625000",
                        "longitude": "-38.90341000"
                    },
                    {
                        "id": 12793,
                        "name": "Lapão",
                        "latitude": "-11.38333000",
                        "longitude": "-41.83194000"
                    },
                    {
                        "id": 12806,
                        "name": "Lauro de Freitas",
                        "latitude": "-12.89444000",
                        "longitude": "-38.32722000"
                    },
                    {
                        "id": 12817,
                        "name": "Lençóis",
                        "latitude": "-12.47259000",
                        "longitude": "-41.30815000"
                    },
                    {
                        "id": 12825,
                        "name": "Licínio de Almeida",
                        "latitude": "-14.70644000",
                        "longitude": "-42.50442000"
                    },
                    {
                        "id": 12843,
                        "name": "Livramento de Nossa Senhora",
                        "latitude": "-13.80680000",
                        "longitude": "-41.99709000"
                    },
                    {
                        "id": 12844,
                        "name": "Livramento do Brumado",
                        "latitude": "-13.65145000",
                        "longitude": "-41.84564000"
                    },
                    {
                        "id": 12881,
                        "name": "Luís Eduardo Magalhães",
                        "latitude": "-12.23208000",
                        "longitude": "-46.11460000"
                    },
                    {
                        "id": 12884,
                        "name": "Macajuba",
                        "latitude": "-12.14371000",
                        "longitude": "-40.30199000"
                    },
                    {
                        "id": 12888,
                        "name": "Macarani",
                        "latitude": "-15.55700000",
                        "longitude": "-40.39049000"
                    },
                    {
                        "id": 12894,
                        "name": "Macaúbas",
                        "latitude": "-13.01944000",
                        "longitude": "-42.69861000"
                    },
                    {
                        "id": 12904,
                        "name": "Macururé",
                        "latitude": "-9.28091000",
                        "longitude": "-38.91463000"
                    },
                    {
                        "id": 12907,
                        "name": "Madre de Deus",
                        "latitude": "-12.74083000",
                        "longitude": "-38.62083000"
                    },
                    {
                        "id": 12909,
                        "name": "Maetinga",
                        "latitude": "-14.66530000",
                        "longitude": "-41.49055000"
                    },
                    {
                        "id": 12915,
                        "name": "Maiquinique",
                        "latitude": "-15.69897000",
                        "longitude": "-40.26411000"
                    },
                    {
                        "id": 12916,
                        "name": "Mairi",
                        "latitude": "-11.71139000",
                        "longitude": "-40.14889000"
                    },
                    {
                        "id": 12925,
                        "name": "Malhada",
                        "latitude": "-14.19145000",
                        "longitude": "-43.63151000"
                    },
                    {
                        "id": 12926,
                        "name": "Malhada de Pedras",
                        "latitude": "-14.27766000",
                        "longitude": "-41.89207000"
                    },
                    {
                        "id": 12956,
                        "name": "Manoel Vitorino",
                        "latitude": "-14.00487000",
                        "longitude": "-40.48008000"
                    },
                    {
                        "id": 12957,
                        "name": "Mansidão",
                        "latitude": "-11.20780000",
                        "longitude": "-44.14109000"
                    },
                    {
                        "id": 12972,
                        "name": "Maracás",
                        "latitude": "-13.44111000",
                        "longitude": "-40.43083000"
                    },
                    {
                        "id": 12974,
                        "name": "Maragogipe",
                        "latitude": "-12.77778000",
                        "longitude": "-38.91944000"
                    },
                    {
                        "id": 12989,
                        "name": "Maraú",
                        "latitude": "-14.10395000",
                        "longitude": "-39.01490000"
                    },
                    {
                        "id": 12994,
                        "name": "Marcionílio Souza",
                        "latitude": "-13.11581000",
                        "longitude": "-40.62915000"
                    },
                    {
                        "id": 13040,
                        "name": "Mascote",
                        "latitude": "-15.56306000",
                        "longitude": "-39.30250000"
                    },
                    {
                        "id": 13049,
                        "name": "Mata de São João",
                        "latitude": "-12.53028000",
                        "longitude": "-38.29917000"
                    },
                    {
                        "id": 13059,
                        "name": "Matina",
                        "latitude": "-13.89342000",
                        "longitude": "-42.98279000"
                    },
                    {
                        "id": 13091,
                        "name": "Medeiros Neto",
                        "latitude": "-17.37389000",
                        "longitude": "-40.22056000"
                    },
                    {
                        "id": 13110,
                        "name": "Miguel Calmon",
                        "latitude": "-11.42889000",
                        "longitude": "-40.59500000"
                    },
                    {
                        "id": 13115,
                        "name": "Milagres",
                        "latitude": "-12.95591000",
                        "longitude": "-39.81783000"
                    },
                    {
                        "id": 13143,
                        "name": "Mirangaba",
                        "latitude": "-10.80362000",
                        "longitude": "-40.67056000"
                    },
                    {
                        "id": 13145,
                        "name": "Mirante",
                        "latitude": "-14.18613000",
                        "longitude": "-40.78310000"
                    },
                    {
                        "id": 13208,
                        "name": "Monte Santo",
                        "latitude": "-10.43778000",
                        "longitude": "-39.33278000"
                    },
                    {
                        "id": 13234,
                        "name": "Morpará",
                        "latitude": "-11.75265000",
                        "longitude": "-43.09133000"
                    },
                    {
                        "id": 13248,
                        "name": "Morro do Chapéu",
                        "latitude": "-11.54852000",
                        "longitude": "-41.15804000"
                    },
                    {
                        "id": 13252,
                        "name": "Mortugaba",
                        "latitude": "-14.98480000",
                        "longitude": "-42.40555000"
                    },
                    {
                        "id": 13261,
                        "name": "Mucugê",
                        "latitude": "-13.14869000",
                        "longitude": "-41.51742000"
                    },
                    {
                        "id": 13262,
                        "name": "Mucuri",
                        "latitude": "-18.08639000",
                        "longitude": "-39.55083000"
                    },
                    {
                        "id": 13268,
                        "name": "Mulungu do Morro",
                        "latitude": "-12.00797000",
                        "longitude": "-41.42582000"
                    },
                    {
                        "id": 13269,
                        "name": "Mundo Novo",
                        "latitude": "-11.85889000",
                        "longitude": "-40.47250000"
                    },
                    {
                        "id": 13274,
                        "name": "Muniz Ferreira",
                        "latitude": "-13.00146000",
                        "longitude": "-39.10601000"
                    },
                    {
                        "id": 13277,
                        "name": "Muquém de São Francisco",
                        "latitude": "-12.19886000",
                        "longitude": "-43.51311000"
                    },
                    {
                        "id": 13283,
                        "name": "Muritiba",
                        "latitude": "-12.91667000",
                        "longitude": "-39.25000000"
                    },
                    {
                        "id": 13287,
                        "name": "Mutuípe",
                        "latitude": "-13.22861000",
                        "longitude": "-39.50472000"
                    },
                    {
                        "id": 13311,
                        "name": "Nazaré",
                        "latitude": "-12.95002000",
                        "longitude": "-38.97869000"
                    },
                    {
                        "id": 13324,
                        "name": "Nilo Peçanha",
                        "latitude": "-13.64812000",
                        "longitude": "-39.23876000"
                    },
                    {
                        "id": 13334,
                        "name": "Nordestina",
                        "latitude": "-10.89685000",
                        "longitude": "-39.45141000"
                    },
                    {
                        "id": 13363,
                        "name": "Nova Canaã",
                        "latitude": "-14.84621000",
                        "longitude": "-40.17826000"
                    },
                    {
                        "id": 13381,
                        "name": "Nova Fátima",
                        "latitude": "-11.56608000",
                        "longitude": "-39.58609000"
                    },
                    {
                        "id": 13388,
                        "name": "Nova Ibiá",
                        "latitude": "-13.86230000",
                        "longitude": "-39.58877000"
                    },
                    {
                        "id": 13395,
                        "name": "Nova Itarana",
                        "latitude": "-13.04028000",
                        "longitude": "-40.00784000"
                    },
                    {
                        "id": 13425,
                        "name": "Nova Redenção",
                        "latitude": "-12.87403000",
                        "longitude": "-41.12335000"
                    },
                    {
                        "id": 13437,
                        "name": "Nova Soure",
                        "latitude": "-11.23333000",
                        "longitude": "-38.48333000"
                    },
                    {
                        "id": 13447,
                        "name": "Nova Viçosa",
                        "latitude": "-17.89194000",
                        "longitude": "-39.37194000"
                    },
                    {
                        "id": 13461,
                        "name": "Novo Horizonte",
                        "latitude": "-12.87886000",
                        "longitude": "-42.13834000"
                    },
                    {
                        "id": 13481,
                        "name": "Novo Triunfo",
                        "latitude": "-10.34787000",
                        "longitude": "-38.40211000"
                    },
                    {
                        "id": 13504,
                        "name": "Olindina",
                        "latitude": "-11.36667000",
                        "longitude": "-38.33333000"
                    },
                    {
                        "id": 13509,
                        "name": "Oliveira dos Brejinhos",
                        "latitude": "-12.31694000",
                        "longitude": "-42.89611000"
                    },
                    {
                        "id": 13536,
                        "name": "Ouriçangas",
                        "latitude": "-12.00343000",
                        "longitude": "-38.65208000"
                    },
                    {
                        "id": 13551,
                        "name": "Ourolândia",
                        "latitude": "-10.83804000",
                        "longitude": "-41.02839000"
                    },
                    {
                        "id": 13588,
                        "name": "Palmas de Monte Alto",
                        "latitude": "-14.26722000",
                        "longitude": "-43.16194000"
                    },
                    {
                        "id": 13597,
                        "name": "Palmeiras",
                        "latitude": "-12.51485000",
                        "longitude": "-41.57707000"
                    },
                    {
                        "id": 13634,
                        "name": "Paramirim",
                        "latitude": "-13.44250000",
                        "longitude": "-42.23889000"
                    },
                    {
                        "id": 13653,
                        "name": "Paratinga",
                        "latitude": "-12.69056000",
                        "longitude": "-43.18417000"
                    },
                    {
                        "id": 13673,
                        "name": "Paripiranga",
                        "latitude": "-10.68750000",
                        "longitude": "-37.86167000"
                    },
                    {
                        "id": 13714,
                        "name": "Pau Brasil",
                        "latitude": "-15.46417000",
                        "longitude": "-39.65111000"
                    },
                    {
                        "id": 13731,
                        "name": "Paulo Afonso",
                        "latitude": "-9.55234000",
                        "longitude": "-38.16905000"
                    },
                    {
                        "id": 14120,
                        "name": "Pé de Serra",
                        "latitude": "-11.88974000",
                        "longitude": "-39.61937000"
                    },
                    {
                        "id": 13786,
                        "name": "Pedrão",
                        "latitude": "-12.13311000",
                        "longitude": "-38.60621000"
                    },
                    {
                        "id": 13773,
                        "name": "Pedro Alexandre",
                        "latitude": "-9.97693000",
                        "longitude": "-37.91489000"
                    },
                    {
                        "id": 13825,
                        "name": "Piatã",
                        "latitude": "-13.12099000",
                        "longitude": "-41.89093000"
                    },
                    {
                        "id": 13840,
                        "name": "Pilão Arcado",
                        "latitude": "-10.00201000",
                        "longitude": "-43.39371000"
                    },
                    {
                        "id": 13851,
                        "name": "Pindaí",
                        "latitude": "-14.52319000",
                        "longitude": "-42.67822000"
                    },
                    {
                        "id": 13853,
                        "name": "Pindobaçu",
                        "latitude": "-10.74167000",
                        "longitude": "-40.36083000"
                    },
                    {
                        "id": 13875,
                        "name": "Pintadas",
                        "latitude": "-11.92312000",
                        "longitude": "-39.97782000"
                    },
                    {
                        "id": 13911,
                        "name": "Piraí do Norte",
                        "latitude": "-13.84971000",
                        "longitude": "-39.39208000"
                    },
                    {
                        "id": 13918,
                        "name": "Piripá",
                        "latitude": "-14.92617000",
                        "longitude": "-41.75304000"
                    },
                    {
                        "id": 13919,
                        "name": "Piritiba",
                        "latitude": "-11.73028000",
                        "longitude": "-40.55528000"
                    },
                    {
                        "id": 13936,
                        "name": "Planaltino",
                        "latitude": "-13.27349000",
                        "longitude": "-40.22316000"
                    },
                    {
                        "id": 13937,
                        "name": "Planalto",
                        "latitude": "-14.72862000",
                        "longitude": "-40.38025000"
                    },
                    {
                        "id": 14056,
                        "name": "Poções",
                        "latitude": "-14.52972000",
                        "longitude": "-40.36528000"
                    },
                    {
                        "id": 13949,
                        "name": "Pojuca",
                        "latitude": "-12.36588000",
                        "longitude": "-38.24332000"
                    },
                    {
                        "id": 13977,
                        "name": "Ponto Novo",
                        "latitude": "-10.86278000",
                        "longitude": "-40.13361000"
                    },
                    {
                        "id": 14017,
                        "name": "Porto Seguro",
                        "latitude": "-16.44972000",
                        "longitude": "-39.06472000"
                    },
                    {
                        "id": 14031,
                        "name": "Posto da Mata",
                        "latitude": "-17.88828000",
                        "longitude": "-39.85593000"
                    },
                    {
                        "id": 14034,
                        "name": "Potiraguá",
                        "latitude": "-15.70117000",
                        "longitude": "-39.76689000"
                    },
                    {
                        "id": 14059,
                        "name": "Prado",
                        "latitude": "-17.31655000",
                        "longitude": "-39.23355000"
                    },
                    {
                        "id": 14080,
                        "name": "Presidente Dutra",
                        "latitude": "-11.29503000",
                        "longitude": "-41.98563000"
                    },
                    {
                        "id": 14086,
                        "name": "Presidente Jânio Quadros",
                        "latitude": "-14.82942000",
                        "longitude": "-41.78616000"
                    },
                    {
                        "id": 14097,
                        "name": "Presidente Tancredo Neves",
                        "latitude": "-13.46145000",
                        "longitude": "-39.42126000"
                    },
                    {
                        "id": 14139,
                        "name": "Queimadas",
                        "latitude": "-10.97833000",
                        "longitude": "-39.62639000"
                    },
                    {
                        "id": 14148,
                        "name": "Quijingue",
                        "latitude": "-10.75250000",
                        "longitude": "-39.20917000"
                    },
                    {
                        "id": 14160,
                        "name": "Quixabeira",
                        "latitude": "-11.41345000",
                        "longitude": "-40.13302000"
                    },
                    {
                        "id": 14167,
                        "name": "Rafael Jambeiro",
                        "latitude": "-12.50087000",
                        "longitude": "-39.50915000"
                    },
                    {
                        "id": 14193,
                        "name": "Remanso",
                        "latitude": "-9.54115000",
                        "longitude": "-42.36956000"
                    },
                    {
                        "id": 14207,
                        "name": "Retirolândia",
                        "latitude": "-11.47733000",
                        "longitude": "-39.40649000"
                    },
                    {
                        "id": 14222,
                        "name": "Riachão das Neves",
                        "latitude": "-11.74611000",
                        "longitude": "-44.91000000"
                    },
                    {
                        "id": 14225,
                        "name": "Riachão do Jacuípe",
                        "latitude": "-11.80694000",
                        "longitude": "-39.38556000"
                    },
                    {
                        "id": 14213,
                        "name": "Riacho de Santana",
                        "latitude": "-13.60917000",
                        "longitude": "-42.93889000"
                    },
                    {
                        "id": 14232,
                        "name": "Ribeira do Amparo",
                        "latitude": "-11.00558000",
                        "longitude": "-38.38732000"
                    },
                    {
                        "id": 14234,
                        "name": "Ribeira do Pombal",
                        "latitude": "-10.83444000",
                        "longitude": "-38.53583000"
                    },
                    {
                        "id": 14248,
                        "name": "Ribeirão do Largo",
                        "latitude": "-15.38558000",
                        "longitude": "-40.65886000"
                    },
                    {
                        "id": 14308,
                        "name": "Rio de Contas",
                        "latitude": "-13.62169000",
                        "longitude": "-41.68702000"
                    },
                    {
                        "id": 14310,
                        "name": "Rio do Antônio",
                        "latitude": "-14.22674000",
                        "longitude": "-42.16613000"
                    },
                    {
                        "id": 14314,
                        "name": "Rio do Pires",
                        "latitude": "-13.11134000",
                        "longitude": "-42.17747000"
                    },
                    {
                        "id": 14295,
                        "name": "Rio Real",
                        "latitude": "-11.48472000",
                        "longitude": "-37.93278000"
                    },
                    {
                        "id": 14331,
                        "name": "Rodelas",
                        "latitude": "-9.21767000",
                        "longitude": "-38.64607000"
                    },
                    {
                        "id": 14364,
                        "name": "Ruy Barbosa",
                        "latitude": "-12.28389000",
                        "longitude": "-40.49389000"
                    },
                    {
                        "id": 14388,
                        "name": "Salinas da Margarida",
                        "latitude": "-12.90667000",
                        "longitude": "-38.78043000"
                    },
                    {
                        "id": 14404,
                        "name": "Salvador",
                        "latitude": "-12.97111000",
                        "longitude": "-38.51083000"
                    },
                    {
                        "id": 14422,
                        "name": "Santa Bárbara",
                        "latitude": "-11.91770000",
                        "longitude": "-38.99206000"
                    },
                    {
                        "id": 14421,
                        "name": "Santa Brígida",
                        "latitude": "-9.67904000",
                        "longitude": "-38.11371000"
                    },
                    {
                        "id": 14441,
                        "name": "Santa Cruz Cabrália",
                        "latitude": "-16.27806000",
                        "longitude": "-39.02472000"
                    },
                    {
                        "id": 14445,
                        "name": "Santa Cruz da Vitória",
                        "latitude": "-14.90311000",
                        "longitude": "-39.79148000"
                    },
                    {
                        "id": 14476,
                        "name": "Santa Inês",
                        "latitude": "-13.29222000",
                        "longitude": "-39.81889000"
                    },
                    {
                        "id": 14492,
                        "name": "Santa Luzia",
                        "latitude": "-15.46388000",
                        "longitude": "-39.27671000"
                    },
                    {
                        "id": 14507,
                        "name": "Santa Maria da Vitória",
                        "latitude": "-13.38814000",
                        "longitude": "-44.19868000"
                    },
                    {
                        "id": 14528,
                        "name": "Santa Rita de Cássia",
                        "latitude": "-11.02715000",
                        "longitude": "-44.59582000"
                    },
                    {
                        "id": 157015,
                        "name": "Santa Teresinha",
                        "latitude": "-12.77003560",
                        "longitude": "-39.54520560"
                    },
                    {
                        "id": 14557,
                        "name": "Santa Terezinha",
                        "latitude": "-12.67120000",
                        "longitude": "-39.55082000"
                    },
                    {
                        "id": 14567,
                        "name": "Santaluz",
                        "latitude": "-11.25583000",
                        "longitude": "-39.37472000"
                    },
                    {
                        "id": 14569,
                        "name": "Santana",
                        "latitude": "-14.46667000",
                        "longitude": "-41.80000000"
                    },
                    {
                        "id": 14597,
                        "name": "Santanópolis",
                        "latitude": "-12.02416000",
                        "longitude": "-38.88007000"
                    },
                    {
                        "id": 14603,
                        "name": "Santo Amaro",
                        "latitude": "-12.54667000",
                        "longitude": "-38.71194000"
                    },
                    {
                        "id": 14617,
                        "name": "Santo Antônio de Jesus",
                        "latitude": "-12.96889000",
                        "longitude": "-39.26139000"
                    },
                    {
                        "id": 14646,
                        "name": "Santo Estêvão",
                        "latitude": "-12.43028000",
                        "longitude": "-39.25139000"
                    },
                    {
                        "id": 14860,
                        "name": "São Desidério",
                        "latitude": "-12.36333000",
                        "longitude": "-44.97333000"
                    },
                    {
                        "id": 14863,
                        "name": "São Domingos",
                        "latitude": "-11.48464000",
                        "longitude": "-39.59916000"
                    },
                    {
                        "id": 14875,
                        "name": "São Felipe",
                        "latitude": "-14.83860000",
                        "longitude": "-41.39174000"
                    },
                    {
                        "id": 14899,
                        "name": "São Félix",
                        "latitude": "-12.67807000",
                        "longitude": "-38.99979000"
                    },
                    {
                        "id": 14903,
                        "name": "São Félix do Coribe",
                        "latitude": "-13.41471000",
                        "longitude": "-43.98138000"
                    },
                    {
                        "id": 14891,
                        "name": "São Francisco do Conde",
                        "latitude": "-12.64556000",
                        "longitude": "-38.63335000"
                    },
                    {
                        "id": 14907,
                        "name": "São Gabriel",
                        "latitude": "-10.95576000",
                        "longitude": "-41.55411000"
                    },
                    {
                        "id": 14926,
                        "name": "São Gonçalo dos Campos",
                        "latitude": "-12.43333000",
                        "longitude": "-38.96667000"
                    },
                    {
                        "id": 14949,
                        "name": "São José da Vitória",
                        "latitude": "-15.07185000",
                        "longitude": "-39.35016000"
                    },
                    {
                        "id": 14976,
                        "name": "São José do Jacuípe",
                        "latitude": "-11.46833000",
                        "longitude": "-39.90377000"
                    },
                    {
                        "id": 15082,
                        "name": "São Miguel das Matas",
                        "latitude": "-13.04308000",
                        "longitude": "-39.43403000"
                    },
                    {
                        "id": 15149,
                        "name": "São Sebastião do Passé",
                        "latitude": "-12.51250000",
                        "longitude": "-38.49528000"
                    },
                    {
                        "id": 14656,
                        "name": "Sapeaçu",
                        "latitude": "-12.77200000",
                        "longitude": "-39.23848000"
                    },
                    {
                        "id": 14830,
                        "name": "Sátiro Dias",
                        "latitude": "-11.63166000",
                        "longitude": "-38.48886000"
                    },
                    {
                        "id": 14675,
                        "name": "Saubara",
                        "latitude": "-12.73750000",
                        "longitude": "-38.76861000"
                    },
                    {
                        "id": 14678,
                        "name": "Saúde",
                        "latitude": "-10.84463000",
                        "longitude": "-40.37510000"
                    },
                    {
                        "id": 14680,
                        "name": "Seabra",
                        "latitude": "-12.41713000",
                        "longitude": "-41.77049000"
                    },
                    {
                        "id": 14684,
                        "name": "Sebastião Laranjeiras",
                        "latitude": "-14.56848000",
                        "longitude": "-43.13729000"
                    },
                    {
                        "id": 14710,
                        "name": "Senhor do Bonfim",
                        "latitude": "-10.46139000",
                        "longitude": "-40.18944000"
                    },
                    {
                        "id": 14715,
                        "name": "Sento Sé",
                        "latitude": "-10.21251000",
                        "longitude": "-41.57947000"
                    },
                    {
                        "id": 14740,
                        "name": "Serra do Ramalho",
                        "latitude": "-13.41101000",
                        "longitude": "-43.77849000"
                    },
                    {
                        "id": 14727,
                        "name": "Serra Dourada",
                        "latitude": "-12.91499000",
                        "longitude": "-43.79600000"
                    },
                    {
                        "id": 14732,
                        "name": "Serra Preta",
                        "latitude": "-12.06913000",
                        "longitude": "-39.30050000"
                    },
                    {
                        "id": 14751,
                        "name": "Serrinha",
                        "latitude": "-11.66417000",
                        "longitude": "-39.00750000"
                    },
                    {
                        "id": 14756,
                        "name": "Serrolândia",
                        "latitude": "-11.54018000",
                        "longitude": "-40.24783000"
                    },
                    {
                        "id": 14789,
                        "name": "Simões Filho",
                        "latitude": "-12.78444000",
                        "longitude": "-38.40389000"
                    },
                    {
                        "id": 15180,
                        "name": "Sítio do Mato",
                        "latitude": "-13.00385000",
                        "longitude": "-43.54537000"
                    },
                    {
                        "id": 15181,
                        "name": "Sítio do Quinto",
                        "latitude": "-10.34321000",
                        "longitude": "-38.07346000"
                    },
                    {
                        "id": 14795,
                        "name": "Sobradinho",
                        "latitude": "-12.83333000",
                        "longitude": "-39.10000000"
                    },
                    {
                        "id": 14816,
                        "name": "Souto Soares",
                        "latitude": "-11.94603000",
                        "longitude": "-41.94815000"
                    },
                    {
                        "id": 15188,
                        "name": "Tabocas do Brejo Velho",
                        "latitude": "-12.36943000",
                        "longitude": "-44.08362000"
                    },
                    {
                        "id": 15219,
                        "name": "Tanhaçu",
                        "latitude": "-14.07010000",
                        "longitude": "-41.13506000"
                    },
                    {
                        "id": 15220,
                        "name": "Tanque Novo",
                        "latitude": "-13.58365000",
                        "longitude": "-42.54311000"
                    },
                    {
                        "id": 15223,
                        "name": "Tanquinho",
                        "latitude": "-11.95674000",
                        "longitude": "-39.09608000"
                    },
                    {
                        "id": 15231,
                        "name": "Taperoá",
                        "latitude": "-13.56959000",
                        "longitude": "-39.22020000"
                    },
                    {
                        "id": 15235,
                        "name": "Tapiramutá",
                        "latitude": "-11.84722000",
                        "longitude": "-40.79139000"
                    },
                    {
                        "id": 15267,
                        "name": "Teixeira de Freitas",
                        "latitude": "-17.42402000",
                        "longitude": "-39.78697000"
                    },
                    {
                        "id": 15278,
                        "name": "Teodoro Sampaio",
                        "latitude": "-12.26547000",
                        "longitude": "-38.61211000"
                    },
                    {
                        "id": 15280,
                        "name": "Teofilândia",
                        "latitude": "-11.53412000",
                        "longitude": "-38.94519000"
                    },
                    {
                        "id": 15281,
                        "name": "Teolândia",
                        "latitude": "-13.57031000",
                        "longitude": "-39.46492000"
                    },
                    {
                        "id": 15292,
                        "name": "Terra Nova",
                        "latitude": "-12.38537000",
                        "longitude": "-38.61874000"
                    },
                    {
                        "id": 15353,
                        "name": "Tremedal",
                        "latitude": "-14.90080000",
                        "longitude": "-41.32339000"
                    },
                    {
                        "id": 15386,
                        "name": "Tucano",
                        "latitude": "-10.99427000",
                        "longitude": "-38.86249000"
                    },
                    {
                        "id": 15424,
                        "name": "Uauá",
                        "latitude": "-9.84143000",
                        "longitude": "-39.23025000"
                    },
                    {
                        "id": 15432,
                        "name": "Ubaíra",
                        "latitude": "-13.28700000",
                        "longitude": "-39.69347000"
                    },
                    {
                        "id": 15425,
                        "name": "Ubaitaba",
                        "latitude": "-14.31250000",
                        "longitude": "-39.32333000"
                    },
                    {
                        "id": 15430,
                        "name": "Ubatã",
                        "latitude": "-14.05629000",
                        "longitude": "-39.52278000"
                    },
                    {
                        "id": 15440,
                        "name": "Uibaí",
                        "latitude": "-11.39060000",
                        "longitude": "-42.15615000"
                    },
                    {
                        "id": 15447,
                        "name": "Umburanas",
                        "latitude": "-10.50860000",
                        "longitude": "-41.17419000"
                    },
                    {
                        "id": 15452,
                        "name": "Una",
                        "latitude": "-15.16451000",
                        "longitude": "-39.20568000"
                    },
                    {
                        "id": 15465,
                        "name": "Urandi",
                        "latitude": "-14.73400000",
                        "longitude": "-42.66544000"
                    },
                    {
                        "id": 15486,
                        "name": "Uruçuca",
                        "latitude": "-14.59306000",
                        "longitude": "-39.28444000"
                    },
                    {
                        "id": 15489,
                        "name": "Utinga",
                        "latitude": "-12.04274000",
                        "longitude": "-41.19475000"
                    },
                    {
                        "id": 15499,
                        "name": "Valença",
                        "latitude": "-13.37213000",
                        "longitude": "-39.24002000"
                    },
                    {
                        "id": 15497,
                        "name": "Valente",
                        "latitude": "-11.43393000",
                        "longitude": "-39.48472000"
                    },
                    {
                        "id": 15622,
                        "name": "Várzea da Roça",
                        "latitude": "-11.53905000",
                        "longitude": "-40.07647000"
                    },
                    {
                        "id": 15623,
                        "name": "Várzea do Poço",
                        "latitude": "-11.53021000",
                        "longitude": "-40.30918000"
                    },
                    {
                        "id": 15619,
                        "name": "Várzea Nova",
                        "latitude": "-11.05523000",
                        "longitude": "-41.23230000"
                    },
                    {
                        "id": 15522,
                        "name": "Varzedo",
                        "latitude": "-12.99662000",
                        "longitude": "-39.37091000"
                    },
                    {
                        "id": 15533,
                        "name": "Vera Cruz",
                        "latitude": "-13.02550000",
                        "longitude": "-38.70906000"
                    },
                    {
                        "id": 15541,
                        "name": "Vereda",
                        "latitude": "-17.14998000",
                        "longitude": "-40.04873000"
                    },
                    {
                        "id": 15599,
                        "name": "Vitória da Conquista",
                        "latitude": "-15.27953000",
                        "longitude": "-40.96575000"
                    },
                    {
                        "id": 15624,
                        "name": "Wagner",
                        "latitude": "-12.25930000",
                        "longitude": "-41.22095000"
                    },
                    {
                        "id": 15626,
                        "name": "Wanderley",
                        "latitude": "-11.76500000",
                        "longitude": "-43.99378000"
                    },
                    {
                        "id": 15630,
                        "name": "Wenceslau Guimarães",
                        "latitude": "-13.61819000",
                        "longitude": "-39.58092000"
                    },
                    {
                        "id": 15642,
                        "name": "Xique Xique",
                        "latitude": "-10.82294000",
                        "longitude": "-42.72815000"
                    },
                    {
                        "id": 15643,
                        "name": "Xique-Xique",
                        "latitude": "-10.83393000",
                        "longitude": "-42.56320000"
                    }
                ]
            },
            {
                "id": 2016,
                "name": "Ceará",
                "iso2": "CE",
                "latitude": "-5.49839770",
                "longitude": "-39.32062410",
                "type": "state",
                "cities": [
                    {
                        "id": 10058,
                        "name": "Abaiara",
                        "latitude": "-7.33642000",
                        "longitude": "-39.06129000"
                    },
                    {
                        "id": 10070,
                        "name": "Acarape",
                        "latitude": "-4.20565000",
                        "longitude": "-38.69160000"
                    },
                    {
                        "id": 10071,
                        "name": "Acaraú",
                        "latitude": "-2.95424000",
                        "longitude": "-40.08597000"
                    },
                    {
                        "id": 10076,
                        "name": "Acopiara",
                        "latitude": "-6.11312000",
                        "longitude": "-39.51756000"
                    },
                    {
                        "id": 10104,
                        "name": "Aiuaba",
                        "latitude": "-6.58896000",
                        "longitude": "-40.23948000"
                    },
                    {
                        "id": 10120,
                        "name": "Alcântaras",
                        "latitude": "-3.58733000",
                        "longitude": "-40.55517000"
                    },
                    {
                        "id": 10156,
                        "name": "Altaneira",
                        "latitude": "-6.98737000",
                        "longitude": "-39.72740000"
                    },
                    {
                        "id": 10183,
                        "name": "Alto Santo",
                        "latitude": "-5.52410000",
                        "longitude": "-38.20916000"
                    },
                    {
                        "id": 10216,
                        "name": "Amontada",
                        "latitude": "-3.27941000",
                        "longitude": "-39.80582000"
                    },
                    {
                        "id": 10270,
                        "name": "Antonina do Norte",
                        "latitude": "-6.73622000",
                        "longitude": "-39.97882000"
                    },
                    {
                        "id": 10302,
                        "name": "Apuiarés",
                        "latitude": "-3.95004000",
                        "longitude": "-39.30373000"
                    },
                    {
                        "id": 10306,
                        "name": "Aquiraz",
                        "latitude": "-3.90157000",
                        "longitude": "-38.39127000"
                    },
                    {
                        "id": 10309,
                        "name": "Aracati",
                        "latitude": "-4.56513000",
                        "longitude": "-37.76688000"
                    },
                    {
                        "id": 10313,
                        "name": "Aracoiaba",
                        "latitude": "-4.49045000",
                        "longitude": "-38.67765000"
                    },
                    {
                        "id": 10351,
                        "name": "Ararendá",
                        "latitude": "-4.77058000",
                        "longitude": "-40.75389000"
                    },
                    {
                        "id": 10354,
                        "name": "Araripe",
                        "latitude": "-7.20462000",
                        "longitude": "-40.11426000"
                    },
                    {
                        "id": 10361,
                        "name": "Aratuba",
                        "latitude": "-4.41898000",
                        "longitude": "-39.04818000"
                    },
                    {
                        "id": 10403,
                        "name": "Arneiroz",
                        "latitude": "-6.23607000",
                        "longitude": "-40.09400000"
                    },
                    {
                        "id": 10425,
                        "name": "Assaré",
                        "latitude": "-6.89746000",
                        "longitude": "-39.82906000"
                    },
                    {
                        "id": 10450,
                        "name": "Aurora",
                        "latitude": "-7.00011000",
                        "longitude": "-38.97042000"
                    },
                    {
                        "id": 10478,
                        "name": "Baixio",
                        "latitude": "-6.70726000",
                        "longitude": "-38.75748000"
                    },
                    {
                        "id": 10494,
                        "name": "Banabuiú",
                        "latitude": "-5.23555000",
                        "longitude": "-38.87457000"
                    },
                    {
                        "id": 10508,
                        "name": "Barbalha",
                        "latitude": "-7.43604000",
                        "longitude": "-39.35273000"
                    },
                    {
                        "id": 10550,
                        "name": "Barreira",
                        "latitude": "-4.37049000",
                        "longitude": "-38.61021000"
                    },
                    {
                        "id": 10559,
                        "name": "Barro",
                        "latitude": "-7.13537000",
                        "longitude": "-38.73373000"
                    },
                    {
                        "id": 10566,
                        "name": "Barroquinha",
                        "latitude": "-3.01889000",
                        "longitude": "-41.13611000"
                    },
                    {
                        "id": 10585,
                        "name": "Baturité",
                        "latitude": "-4.37308000",
                        "longitude": "-38.85915000"
                    },
                    {
                        "id": 10591,
                        "name": "Beberibe",
                        "latitude": "-4.17972000",
                        "longitude": "-38.13056000"
                    },
                    {
                        "id": 10593,
                        "name": "Bela Cruz",
                        "latitude": "-3.05056000",
                        "longitude": "-40.16778000"
                    },
                    {
                        "id": 10666,
                        "name": "Boa Viagem",
                        "latitude": "-5.02536000",
                        "longitude": "-39.84169000"
                    },
                    {
                        "id": 10792,
                        "name": "Brejo Santo",
                        "latitude": "-7.62229000",
                        "longitude": "-38.88195000"
                    },
                    {
                        "id": 10953,
                        "name": "Camocim",
                        "latitude": "-2.90222000",
                        "longitude": "-40.84111000"
                    },
                    {
                        "id": 11015,
                        "name": "Campos Sales",
                        "latitude": "-6.92527000",
                        "longitude": "-40.22188000"
                    },
                    {
                        "id": 11046,
                        "name": "Canindé",
                        "latitude": "-4.40473000",
                        "longitude": "-39.41746000"
                    },
                    {
                        "id": 11079,
                        "name": "Capistrano",
                        "latitude": "-4.46230000",
                        "longitude": "-38.92072000"
                    },
                    {
                        "id": 11129,
                        "name": "Caridade",
                        "latitude": "-4.20100000",
                        "longitude": "-39.14149000"
                    },
                    {
                        "id": 11135,
                        "name": "Cariré",
                        "latitude": "-3.93586000",
                        "longitude": "-40.54679000"
                    },
                    {
                        "id": 11134,
                        "name": "Caririaçu",
                        "latitude": "-7.04170000",
                        "longitude": "-39.25423000"
                    },
                    {
                        "id": 11136,
                        "name": "Cariús",
                        "latitude": "-6.65619000",
                        "longitude": "-39.47496000"
                    },
                    {
                        "id": 11155,
                        "name": "Carnaubal",
                        "latitude": "-4.12097000",
                        "longitude": "-41.01368000"
                    },
                    {
                        "id": 11177,
                        "name": "Cascavel",
                        "latitude": "-4.27004000",
                        "longitude": "-38.27377000"
                    },
                    {
                        "id": 11198,
                        "name": "Catarina",
                        "latitude": "-6.25016000",
                        "longitude": "-39.94870000"
                    },
                    {
                        "id": 11208,
                        "name": "Catunda",
                        "latitude": "-4.60469000",
                        "longitude": "-40.18630000"
                    },
                    {
                        "id": 11214,
                        "name": "Caucaia",
                        "latitude": "-3.73611000",
                        "longitude": "-38.65306000"
                    },
                    {
                        "id": 11230,
                        "name": "Cedro",
                        "latitude": "-6.59104000",
                        "longitude": "-39.12042000"
                    },
                    {
                        "id": 11273,
                        "name": "Chaval",
                        "latitude": "-3.07497000",
                        "longitude": "-41.23723000"
                    },
                    {
                        "id": 11281,
                        "name": "Choró",
                        "latitude": "-4.77277000",
                        "longitude": "-39.17779000"
                    },
                    {
                        "id": 11279,
                        "name": "Chorozinho",
                        "latitude": "-4.29181000",
                        "longitude": "-38.48895000"
                    },
                    {
                        "id": 11405,
                        "name": "Coreaú",
                        "latitude": "-3.68827000",
                        "longitude": "-40.72725000"
                    },
                    {
                        "id": 11460,
                        "name": "Crateús",
                        "latitude": "-5.25084000",
                        "longitude": "-40.74335000"
                    },
                    {
                        "id": 11461,
                        "name": "Crato",
                        "latitude": "-7.14714000",
                        "longitude": "-39.47132000"
                    },
                    {
                        "id": 11485,
                        "name": "Croatá",
                        "latitude": "-4.39092000",
                        "longitude": "-40.86795000"
                    },
                    {
                        "id": 11488,
                        "name": "Cruz",
                        "latitude": "-2.89619000",
                        "longitude": "-40.33573000"
                    },
                    {
                        "id": 11574,
                        "name": "Deputado Irapuan Pinheiro",
                        "latitude": "-5.88737000",
                        "longitude": "-39.25923000"
                    },
                    {
                        "id": 11717,
                        "name": "Ererê",
                        "latitude": "-5.99731000",
                        "longitude": "-38.31180000"
                    },
                    {
                        "id": 11764,
                        "name": "Eusébio",
                        "latitude": "-3.86950000",
                        "longitude": "-38.45545000"
                    },
                    {
                        "id": 11775,
                        "name": "Farias Brito",
                        "latitude": "-6.88662000",
                        "longitude": "-39.53406000"
                    },
                    {
                        "id": 11861,
                        "name": "Forquilha",
                        "latitude": "-3.83354000",
                        "longitude": "-40.23431000"
                    },
                    {
                        "id": 11863,
                        "name": "Fortaleza",
                        "latitude": "-3.71722000",
                        "longitude": "-38.54306000"
                    },
                    {
                        "id": 11868,
                        "name": "Fortim",
                        "latitude": "-4.44714000",
                        "longitude": "-37.85289000"
                    },
                    {
                        "id": 11888,
                        "name": "Frecheirinha",
                        "latitude": "-3.72816000",
                        "longitude": "-40.82027000"
                    },
                    {
                        "id": 11939,
                        "name": "General Sampaio",
                        "latitude": "-4.05016000",
                        "longitude": "-39.44451000"
                    },
                    {
                        "id": 12003,
                        "name": "Graça",
                        "latitude": "-4.06621000",
                        "longitude": "-40.79501000"
                    },
                    {
                        "id": 11998,
                        "name": "Granja",
                        "latitude": "-3.12028000",
                        "longitude": "-40.82611000"
                    },
                    {
                        "id": 11999,
                        "name": "Granjeiro",
                        "latitude": "-6.91745000",
                        "longitude": "-39.27944000"
                    },
                    {
                        "id": 12005,
                        "name": "Groaíras",
                        "latitude": "-3.92113000",
                        "longitude": "-40.37696000"
                    },
                    {
                        "id": 12017,
                        "name": "Guaiúba",
                        "latitude": "-4.03972000",
                        "longitude": "-38.63722000"
                    },
                    {
                        "id": 12039,
                        "name": "Guaraciaba do Norte",
                        "latitude": "-4.16694000",
                        "longitude": "-40.74750000"
                    },
                    {
                        "id": 12041,
                        "name": "Guaramiranga",
                        "latitude": "-4.22177000",
                        "longitude": "-38.96451000"
                    },
                    {
                        "id": 12101,
                        "name": "Hidrolândia",
                        "latitude": "-4.40806000",
                        "longitude": "-40.43778000"
                    },
                    {
                        "id": 12105,
                        "name": "Horizonte",
                        "latitude": "-4.11458000",
                        "longitude": "-38.51498000"
                    },
                    {
                        "id": 12122,
                        "name": "Ibaretama",
                        "latitude": "-4.75045000",
                        "longitude": "-38.66571000"
                    },
                    {
                        "id": 12129,
                        "name": "Ibiapina",
                        "latitude": "-3.93574000",
                        "longitude": "-40.92758000"
                    },
                    {
                        "id": 12137,
                        "name": "Ibicuitinga",
                        "latitude": "-4.96187000",
                        "longitude": "-38.52019000"
                    },
                    {
                        "id": 12167,
                        "name": "Icapuí",
                        "latitude": "-4.72337000",
                        "longitude": "-37.41335000"
                    },
                    {
                        "id": 12174,
                        "name": "Icó",
                        "latitude": "-6.35186000",
                        "longitude": "-38.75674000"
                    },
                    {
                        "id": 12201,
                        "name": "Iguatu",
                        "latitude": "-6.35550000",
                        "longitude": "-39.27683000"
                    },
                    {
                        "id": 12234,
                        "name": "Independência",
                        "latitude": "-5.47187000",
                        "longitude": "-40.32314000"
                    },
                    {
                        "id": 12263,
                        "name": "Ipaporanga",
                        "latitude": "-4.84741000",
                        "longitude": "-40.81027000"
                    },
                    {
                        "id": 12265,
                        "name": "Ipaumirim",
                        "latitude": "-6.80882000",
                        "longitude": "-38.73227000"
                    },
                    {
                        "id": 12288,
                        "name": "Ipu",
                        "latitude": "-4.34934000",
                        "longitude": "-40.65931000"
                    },
                    {
                        "id": 12293,
                        "name": "Ipueiras",
                        "latitude": "-4.62127000",
                        "longitude": "-40.82192000"
                    },
                    {
                        "id": 12300,
                        "name": "Iracema",
                        "latitude": "-5.81274000",
                        "longitude": "-38.35285000"
                    },
                    {
                        "id": 12314,
                        "name": "Irauçuba",
                        "latitude": "-3.74611000",
                        "longitude": "-39.78333000"
                    },
                    {
                        "id": 12364,
                        "name": "Itaiçaba",
                        "latitude": "-4.70171000",
                        "longitude": "-37.82908000"
                    },
                    {
                        "id": 12362,
                        "name": "Itaitinga",
                        "latitude": "-3.96944000",
                        "longitude": "-38.52806000"
                    },
                    {
                        "id": 12400,
                        "name": "Itapagé",
                        "latitude": "-3.68667000",
                        "longitude": "-39.58611000"
                    },
                    {
                        "id": 12401,
                        "name": "Itapajé",
                        "latitude": "-3.73339000",
                        "longitude": "-39.56508000"
                    },
                    {
                        "id": 12419,
                        "name": "Itapipoca",
                        "latitude": "-3.49444000",
                        "longitude": "-39.57861000"
                    },
                    {
                        "id": 12428,
                        "name": "Itapiúna",
                        "latitude": "-4.61918000",
                        "longitude": "-38.93130000"
                    },
                    {
                        "id": 12450,
                        "name": "Itarema",
                        "latitude": "-3.08336000",
                        "longitude": "-39.89698000"
                    },
                    {
                        "id": 12460,
                        "name": "Itatira",
                        "latitude": "-4.56784000",
                        "longitude": "-39.57820000"
                    },
                    {
                        "id": 12540,
                        "name": "Jaguaretama",
                        "latitude": "-5.48330000",
                        "longitude": "-38.75595000"
                    },
                    {
                        "id": 12543,
                        "name": "Jaguaribara",
                        "latitude": "-5.65027000",
                        "longitude": "-38.51031000"
                    },
                    {
                        "id": 12544,
                        "name": "Jaguaribe",
                        "latitude": "-5.97256000",
                        "longitude": "-38.68571000"
                    },
                    {
                        "id": 12547,
                        "name": "Jaguaruana",
                        "latitude": "-4.81405000",
                        "longitude": "-37.79248000"
                    },
                    {
                        "id": 12584,
                        "name": "Jardim",
                        "latitude": "-7.63821000",
                        "longitude": "-39.24037000"
                    },
                    {
                        "id": 12601,
                        "name": "Jati",
                        "latitude": "-7.70470000",
                        "longitude": "-38.94361000"
                    },
                    {
                        "id": 12631,
                        "name": "Jijoca de Jericoacoara",
                        "latitude": "-2.87137000",
                        "longitude": "-40.49161000"
                    },
                    {
                        "id": 12714,
                        "name": "Juá dos Vieiras",
                        "latitude": "-3.53333000",
                        "longitude": "-41.30000000"
                    },
                    {
                        "id": 12674,
                        "name": "Juazeiro do Norte",
                        "latitude": "-7.21306000",
                        "longitude": "-39.31528000"
                    },
                    {
                        "id": 12679,
                        "name": "Jucás",
                        "latitude": "-6.44677000",
                        "longitude": "-39.62005000"
                    },
                    {
                        "id": 12809,
                        "name": "Lavras da Mangabeira",
                        "latitude": "-6.75333000",
                        "longitude": "-38.96444000"
                    },
                    {
                        "id": 12834,
                        "name": "Limoeiro do Norte",
                        "latitude": "-5.17406000",
                        "longitude": "-38.02656000"
                    },
                    {
                        "id": 12905,
                        "name": "Madalena",
                        "latitude": "-4.87622000",
                        "longitude": "-39.47587000"
                    },
                    {
                        "id": 12968,
                        "name": "Maracanaú",
                        "latitude": "-3.87667000",
                        "longitude": "-38.62556000"
                    },
                    {
                        "id": 12977,
                        "name": "Maranguape",
                        "latitude": "-3.99581000",
                        "longitude": "-38.72969000"
                    },
                    {
                        "id": 12995,
                        "name": "Marco",
                        "latitude": "-3.18943000",
                        "longitude": "-40.26283000"
                    },
                    {
                        "id": 13034,
                        "name": "Martinópole",
                        "latitude": "-3.19761000",
                        "longitude": "-40.60948000"
                    },
                    {
                        "id": 13041,
                        "name": "Massapê",
                        "latitude": "-3.50912000",
                        "longitude": "-40.36655000"
                    },
                    {
                        "id": 13082,
                        "name": "Mauriti",
                        "latitude": "-7.38806000",
                        "longitude": "-38.63645000"
                    },
                    {
                        "id": 13103,
                        "name": "Meruoca",
                        "latitude": "-3.58604000",
                        "longitude": "-40.46730000"
                    },
                    {
                        "id": 13114,
                        "name": "Milagres",
                        "latitude": "-7.26057000",
                        "longitude": "-38.96244000"
                    },
                    {
                        "id": 13117,
                        "name": "Milhã",
                        "latitude": "-5.66904000",
                        "longitude": "-39.22525000"
                    },
                    {
                        "id": 13154,
                        "name": "Miraíma",
                        "latitude": "-3.56511000",
                        "longitude": "-39.90390000"
                    },
                    {
                        "id": 13158,
                        "name": "Missão Velha",
                        "latitude": "-7.23707000",
                        "longitude": "-39.11196000"
                    },
                    {
                        "id": 13172,
                        "name": "Mombaça",
                        "latitude": "-5.79217000",
                        "longitude": "-39.77985000"
                    },
                    {
                        "id": 13180,
                        "name": "Monsenhor Tabosa",
                        "latitude": "-4.96764000",
                        "longitude": "-40.06725000"
                    },
                    {
                        "id": 13227,
                        "name": "Morada Nova",
                        "latitude": "-5.10667000",
                        "longitude": "-38.37250000"
                    },
                    {
                        "id": 13229,
                        "name": "Moraújo",
                        "latitude": "-3.46006000",
                        "longitude": "-40.69958000"
                    },
                    {
                        "id": 13236,
                        "name": "Morrinhos",
                        "latitude": "-3.28421000",
                        "longitude": "-40.09125000"
                    },
                    {
                        "id": 13260,
                        "name": "Mucambo",
                        "latitude": "-3.90780000",
                        "longitude": "-40.76944000"
                    },
                    {
                        "id": 13267,
                        "name": "Mulungu",
                        "latitude": "-4.30636000",
                        "longitude": "-38.98955000"
                    },
                    {
                        "id": 13411,
                        "name": "Nova Olinda",
                        "latitude": "-7.08567000",
                        "longitude": "-39.67195000"
                    },
                    {
                        "id": 13430,
                        "name": "Nova Russas",
                        "latitude": "-4.72277000",
                        "longitude": "-40.59553000"
                    },
                    {
                        "id": 13471,
                        "name": "Novo Oriente",
                        "latitude": "-5.58278000",
                        "longitude": "-40.74014000"
                    },
                    {
                        "id": 13488,
                        "name": "Ocara",
                        "latitude": "-4.49083000",
                        "longitude": "-38.59667000"
                    },
                    {
                        "id": 13526,
                        "name": "Orós",
                        "latitude": "-6.25502000",
                        "longitude": "-38.96761000"
                    },
                    {
                        "id": 13555,
                        "name": "Pacajus",
                        "latitude": "-4.17250000",
                        "longitude": "-38.46056000"
                    },
                    {
                        "id": 13557,
                        "name": "Pacatuba",
                        "latitude": "-3.97623000",
                        "longitude": "-38.62922000"
                    },
                    {
                        "id": 13559,
                        "name": "Pacoti",
                        "latitude": "-4.19575000",
                        "longitude": "-38.90252000"
                    },
                    {
                        "id": 13560,
                        "name": "Pacujá",
                        "latitude": "-3.96747000",
                        "longitude": "-40.67686000"
                    },
                    {
                        "id": 13579,
                        "name": "Palhano",
                        "latitude": "-4.66056000",
                        "longitude": "-38.04453000"
                    },
                    {
                        "id": 13609,
                        "name": "Palmácia",
                        "latitude": "-4.12964000",
                        "longitude": "-38.84258000"
                    },
                    {
                        "id": 13625,
                        "name": "Paracuru",
                        "latitude": "-3.41000000",
                        "longitude": "-39.03056000"
                    },
                    {
                        "id": 13631,
                        "name": "Paraipaba",
                        "latitude": "-3.43944000",
                        "longitude": "-39.14833000"
                    },
                    {
                        "id": 13633,
                        "name": "Parambu",
                        "latitude": "-6.25405000",
                        "longitude": "-40.60876000"
                    },
                    {
                        "id": 13635,
                        "name": "Paramoti",
                        "latitude": "-4.14739000",
                        "longitude": "-39.36219000"
                    },
                    {
                        "id": 13749,
                        "name": "Pedra Branca",
                        "latitude": "-5.49336000",
                        "longitude": "-39.85259000"
                    },
                    {
                        "id": 13792,
                        "name": "Penaforte",
                        "latitude": "-7.80046000",
                        "longitude": "-39.04704000"
                    },
                    {
                        "id": 13797,
                        "name": "Pentecoste",
                        "latitude": "-3.85116000",
                        "longitude": "-39.19850000"
                    },
                    {
                        "id": 13807,
                        "name": "Pereiro",
                        "latitude": "-6.04085000",
                        "longitude": "-38.48892000"
                    },
                    {
                        "id": 13856,
                        "name": "Pindoretama",
                        "latitude": "-4.06156000",
                        "longitude": "-38.29450000"
                    },
                    {
                        "id": 13881,
                        "name": "Piquet Carneiro",
                        "latitude": "-5.86038000",
                        "longitude": "-39.45580000"
                    },
                    {
                        "id": 13915,
                        "name": "Pires Ferreira",
                        "latitude": "-4.25485000",
                        "longitude": "-40.59869000"
                    },
                    {
                        "id": 13981,
                        "name": "Poranga",
                        "latitude": "-4.76103000",
                        "longitude": "-40.93222000"
                    },
                    {
                        "id": 13987,
                        "name": "Porteiras",
                        "latitude": "-7.59509000",
                        "longitude": "-39.07443000"
                    },
                    {
                        "id": 14032,
                        "name": "Potengi",
                        "latitude": "-7.03279000",
                        "longitude": "-40.04012000"
                    },
                    {
                        "id": 14036,
                        "name": "Potiretama",
                        "latitude": "-5.75401000",
                        "longitude": "-38.18249000"
                    },
                    {
                        "id": 14157,
                        "name": "Quiterianópolis",
                        "latitude": "-5.88995000",
                        "longitude": "-40.72808000"
                    },
                    {
                        "id": 14161,
                        "name": "Quixadá",
                        "latitude": "-4.97056000",
                        "longitude": "-39.01812000"
                    },
                    {
                        "id": 14162,
                        "name": "Quixelô",
                        "latitude": "-6.15064000",
                        "longitude": "-39.11702000"
                    },
                    {
                        "id": 14163,
                        "name": "Quixeramobim",
                        "latitude": "-5.13424000",
                        "longitude": "-39.33459000"
                    },
                    {
                        "id": 14164,
                        "name": "Quixeré",
                        "latitude": "-5.07417000",
                        "longitude": "-37.98861000"
                    },
                    {
                        "id": 14183,
                        "name": "Redenção",
                        "latitude": "-4.22583000",
                        "longitude": "-38.73056000"
                    },
                    {
                        "id": 14196,
                        "name": "Reriutaba",
                        "latitude": "-4.13835000",
                        "longitude": "-40.61603000"
                    },
                    {
                        "id": 14363,
                        "name": "Russas",
                        "latitude": "-4.83990000",
                        "longitude": "-38.19597000"
                    },
                    {
                        "id": 14369,
                        "name": "Saboeiro",
                        "latitude": "-6.47813000",
                        "longitude": "-39.88569000"
                    },
                    {
                        "id": 14390,
                        "name": "Salitre",
                        "latitude": "-7.13795000",
                        "longitude": "-40.28978000"
                    },
                    {
                        "id": 14522,
                        "name": "Santa Quitéria",
                        "latitude": "-4.33194000",
                        "longitude": "-40.15667000"
                    },
                    {
                        "id": 14577,
                        "name": "Santana do Acaraú",
                        "latitude": "-3.46056000",
                        "longitude": "-40.21222000"
                    },
                    {
                        "id": 14579,
                        "name": "Santana do Cariri",
                        "latitude": "-7.17968000",
                        "longitude": "-39.78451000"
                    },
                    {
                        "id": 14831,
                        "name": "São Benedito",
                        "latitude": "-4.04957000",
                        "longitude": "-40.94585000"
                    },
                    {
                        "id": 14918,
                        "name": "São Gonçalo do Amarante",
                        "latitude": "-3.60722000",
                        "longitude": "-38.96833000"
                    },
                    {
                        "id": 15031,
                        "name": "São João do Jaguaribe",
                        "latitude": "-5.31884000",
                        "longitude": "-38.26878000"
                    },
                    {
                        "id": 15048,
                        "name": "São João dos Inhamuns",
                        "latitude": "-6.00000000",
                        "longitude": "-40.28333000"
                    },
                    {
                        "id": 15066,
                        "name": "São Luís do Curu",
                        "latitude": "-3.64119000",
                        "longitude": "-39.24877000"
                    },
                    {
                        "id": 14705,
                        "name": "Senador Pompeu",
                        "latitude": "-5.58806000",
                        "longitude": "-39.37167000"
                    },
                    {
                        "id": 14708,
                        "name": "Senador Sá",
                        "latitude": "-3.27654000",
                        "longitude": "-40.44418000"
                    },
                    {
                        "id": 14798,
                        "name": "Sobral",
                        "latitude": "-3.85932000",
                        "longitude": "-40.04376000"
                    },
                    {
                        "id": 14806,
                        "name": "Solonópole",
                        "latitude": "-5.87073000",
                        "longitude": "-39.01210000"
                    },
                    {
                        "id": 15192,
                        "name": "Tabuleiro do Norte",
                        "latitude": "-5.29109000",
                        "longitude": "-38.07247000"
                    },
                    {
                        "id": 15212,
                        "name": "Tamboril",
                        "latitude": "-4.83222000",
                        "longitude": "-40.32056000"
                    },
                    {
                        "id": 15254,
                        "name": "Tarrafas",
                        "latitude": "-6.73736000",
                        "longitude": "-39.72329000"
                    },
                    {
                        "id": 15261,
                        "name": "Tauá",
                        "latitude": "-5.90848000",
                        "longitude": "-40.27279000"
                    },
                    {
                        "id": 15271,
                        "name": "Tejuçuoca",
                        "latitude": "-3.93547000",
                        "longitude": "-39.64972000"
                    },
                    {
                        "id": 15303,
                        "name": "Tianguá",
                        "latitude": "-3.67295000",
                        "longitude": "-40.99014000"
                    },
                    {
                        "id": 15348,
                        "name": "Trairi",
                        "latitude": "-3.33156000",
                        "longitude": "-39.38032000"
                    },
                    {
                        "id": 15415,
                        "name": "Tururu",
                        "latitude": "-3.53335000",
                        "longitude": "-39.37556000"
                    },
                    {
                        "id": 15426,
                        "name": "Ubajara",
                        "latitude": "-3.84020000",
                        "longitude": "-40.93422000"
                    },
                    {
                        "id": 15444,
                        "name": "Umari",
                        "latitude": "-6.60924000",
                        "longitude": "-38.71952000"
                    },
                    {
                        "id": 15450,
                        "name": "Umirim",
                        "latitude": "-3.70599000",
                        "longitude": "-39.39689000"
                    },
                    {
                        "id": 15474,
                        "name": "Uruburetama",
                        "latitude": "-3.62829000",
                        "longitude": "-39.54760000"
                    },
                    {
                        "id": 15480,
                        "name": "Uruoca",
                        "latitude": "-3.31983000",
                        "longitude": "-40.72170000"
                    },
                    {
                        "id": 15518,
                        "name": "Varjota",
                        "latitude": "-4.19444000",
                        "longitude": "-40.47667000"
                    },
                    {
                        "id": 15615,
                        "name": "Várzea Alegre",
                        "latitude": "-5.35000000",
                        "longitude": "-40.38333000"
                    },
                    {
                        "id": 15608,
                        "name": "Viçosa do Ceará",
                        "latitude": "-3.56222000",
                        "longitude": "-41.09222000"
                    }
                ]
            },
            {
                "id": 2017,
                "name": "Distrito Federal",
                "iso2": "DF",
                "latitude": "-15.79976540",
                "longitude": "-47.86447150",
                "type": "federal district",
                "cities": [
                    {
                        "id": 10776,
                        "name": "Brasília",
                        "latitude": "-15.77972000",
                        "longitude": "-47.92972000"
                    },
                    {
                        "id": 13934,
                        "name": "Planaltina",
                        "latitude": "-15.61791000",
                        "longitude": "-47.64874000"
                    }
                ]
            },
            {
                "id": 2018,
                "name": "Espírito Santo",
                "iso2": "ES",
                "latitude": "-19.18342290",
                "longitude": "-40.30886260",
                "type": "state",
                "cities": [
                    {
                        "id": 10087,
                        "name": "Afonso Cláudio",
                        "latitude": "-20.10512000",
                        "longitude": "-41.12422000"
                    },
                    {
                        "id": 15658,
                        "name": "Água Doce do Norte",
                        "latitude": "-18.50646000",
                        "longitude": "-40.99190000"
                    },
                    {
                        "id": 15676,
                        "name": "Águia Branca",
                        "latitude": "-18.98306000",
                        "longitude": "-40.74028000"
                    },
                    {
                        "id": 10123,
                        "name": "Alegre",
                        "latitude": "-20.70897000",
                        "longitude": "-41.51937000"
                    },
                    {
                        "id": 10131,
                        "name": "Alfredo Chaves",
                        "latitude": "-20.54245000",
                        "longitude": "-40.82368000"
                    },
                    {
                        "id": 10182,
                        "name": "Alto Rio Novo",
                        "latitude": "-19.03248000",
                        "longitude": "-40.99144000"
                    },
                    {
                        "id": 10240,
                        "name": "Anchieta",
                        "latitude": "-20.73420000",
                        "longitude": "-40.70056000"
                    },
                    {
                        "id": 10292,
                        "name": "Apiacá",
                        "latitude": "-21.08025000",
                        "longitude": "-41.56100000"
                    },
                    {
                        "id": 10314,
                        "name": "Aracruz",
                        "latitude": "-19.81952000",
                        "longitude": "-40.19097000"
                    },
                    {
                        "id": 10441,
                        "name": "Atílio Vivacqua",
                        "latitude": "-20.95472000",
                        "longitude": "-41.19096000"
                    },
                    {
                        "id": 10479,
                        "name": "Baixo Guandu",
                        "latitude": "-19.51889000",
                        "longitude": "-41.01583000"
                    },
                    {
                        "id": 10528,
                        "name": "Barra de São Francisco",
                        "latitude": "-18.75500000",
                        "longitude": "-40.89083000"
                    },
                    {
                        "id": 10657,
                        "name": "Boa Esperança",
                        "latitude": "-18.54000000",
                        "longitude": "-40.29583000"
                    },
                    {
                        "id": 10712,
                        "name": "Bom Jesus do Norte",
                        "latitude": "-21.08831000",
                        "longitude": "-41.63939000"
                    },
                    {
                        "id": 10784,
                        "name": "Brejetuba",
                        "latitude": "-20.15621000",
                        "longitude": "-41.30650000"
                    },
                    {
                        "id": 10879,
                        "name": "Cachoeiro de Itapemirim",
                        "latitude": "-20.84889000",
                        "longitude": "-41.11278000"
                    },
                    {
                        "id": 11127,
                        "name": "Cariacica",
                        "latitude": "-20.30050000",
                        "longitude": "-40.46919000"
                    },
                    {
                        "id": 11187,
                        "name": "Castelo",
                        "latitude": "-20.60361000",
                        "longitude": "-41.18472000"
                    },
                    {
                        "id": 11320,
                        "name": "Colatina",
                        "latitude": "-19.53944000",
                        "longitude": "-40.63056000"
                    },
                    {
                        "id": 11346,
                        "name": "Conceição da Barra",
                        "latitude": "-18.58540000",
                        "longitude": "-39.73618000"
                    },
                    {
                        "id": 11356,
                        "name": "Conceição do Castelo",
                        "latitude": "-20.36226000",
                        "longitude": "-41.26622000"
                    },
                    {
                        "id": 11602,
                        "name": "Divino de São Lourenço",
                        "latitude": "-20.59751000",
                        "longitude": "-41.72185000"
                    },
                    {
                        "id": 11637,
                        "name": "Domingos Martins",
                        "latitude": "-20.36333000",
                        "longitude": "-40.65917000"
                    },
                    {
                        "id": 11646,
                        "name": "Dores do Rio Preto",
                        "latitude": "-20.63511000",
                        "longitude": "-41.81208000"
                    },
                    {
                        "id": 11673,
                        "name": "Ecoporanga",
                        "latitude": "-18.37333000",
                        "longitude": "-40.83056000"
                    },
                    {
                        "id": 11904,
                        "name": "Fundão",
                        "latitude": "-19.98985000",
                        "longitude": "-40.31579000"
                    },
                    {
                        "id": 11985,
                        "name": "Governador Lindenberg",
                        "latitude": "-19.20034000",
                        "longitude": "-40.49510000"
                    },
                    {
                        "id": 12075,
                        "name": "Guaçuí",
                        "latitude": "-20.76804000",
                        "longitude": "-41.71116000"
                    },
                    {
                        "id": 12051,
                        "name": "Guarapari",
                        "latitude": "-20.67182000",
                        "longitude": "-40.50196000"
                    },
                    {
                        "id": 12124,
                        "name": "Ibatiba",
                        "latitude": "-20.23389000",
                        "longitude": "-41.51056000"
                    },
                    {
                        "id": 12154,
                        "name": "Ibiraçu",
                        "latitude": "-19.83194000",
                        "longitude": "-40.36972000"
                    },
                    {
                        "id": 12160,
                        "name": "Ibitirama",
                        "latitude": "-20.51148000",
                        "longitude": "-41.66962000"
                    },
                    {
                        "id": 12172,
                        "name": "Iconha",
                        "latitude": "-20.74759000",
                        "longitude": "-40.86570000"
                    },
                    {
                        "id": 12321,
                        "name": "Irupi",
                        "latitude": "-20.34528000",
                        "longitude": "-41.64111000"
                    },
                    {
                        "id": 12355,
                        "name": "Itaguaçu",
                        "latitude": "-19.80194000",
                        "longitude": "-40.85556000"
                    },
                    {
                        "id": 12409,
                        "name": "Itapemirim",
                        "latitude": "-21.01111000",
                        "longitude": "-40.83389000"
                    },
                    {
                        "id": 12447,
                        "name": "Itarana",
                        "latitude": "-19.87389000",
                        "longitude": "-40.87528000"
                    },
                    {
                        "id": 12507,
                        "name": "Iúna",
                        "latitude": "-20.34583000",
                        "longitude": "-41.53583000"
                    },
                    {
                        "id": 12550,
                        "name": "Jaguaré",
                        "latitude": "-18.99187000",
                        "longitude": "-39.97521000"
                    },
                    {
                        "id": 12624,
                        "name": "Jerônimo Monteiro",
                        "latitude": "-20.81243000",
                        "longitude": "-41.39536000"
                    },
                    {
                        "id": 12628,
                        "name": "Jetibá",
                        "latitude": "-20.02069000",
                        "longitude": "-40.68145000"
                    },
                    {
                        "id": 12664,
                        "name": "João Neiva",
                        "latitude": "-19.75750000",
                        "longitude": "-40.38556000"
                    },
                    {
                        "id": 12794,
                        "name": "Laranja da Terra",
                        "latitude": "-19.89889000",
                        "longitude": "-41.05667000"
                    },
                    {
                        "id": 12840,
                        "name": "Linhares",
                        "latitude": "-19.39111000",
                        "longitude": "-40.07222000"
                    },
                    {
                        "id": 12959,
                        "name": "Mantenópolis",
                        "latitude": "-18.86250000",
                        "longitude": "-41.12278000"
                    },
                    {
                        "id": 12981,
                        "name": "Marataizes",
                        "latitude": "-21.04333000",
                        "longitude": "-40.82444000"
                    },
                    {
                        "id": 13000,
                        "name": "Marechal Floriano",
                        "latitude": "-20.41278000",
                        "longitude": "-40.68306000"
                    },
                    {
                        "id": 13016,
                        "name": "Marilândia",
                        "latitude": "-19.42199000",
                        "longitude": "-40.52021000"
                    },
                    {
                        "id": 13120,
                        "name": "Mimoso do Sul",
                        "latitude": "-21.10474000",
                        "longitude": "-41.37566000"
                    },
                    {
                        "id": 13183,
                        "name": "Montanha",
                        "latitude": "-18.12694000",
                        "longitude": "-40.36333000"
                    },
                    {
                        "id": 13263,
                        "name": "Mucurici",
                        "latitude": "-18.09333000",
                        "longitude": "-40.51583000"
                    },
                    {
                        "id": 13275,
                        "name": "Muniz Freire",
                        "latitude": "-20.46417000",
                        "longitude": "-41.41306000"
                    },
                    {
                        "id": 13276,
                        "name": "Muqui",
                        "latitude": "-20.91522000",
                        "longitude": "-41.30089000"
                    },
                    {
                        "id": 13446,
                        "name": "Nova Venécia",
                        "latitude": "-18.71056000",
                        "longitude": "-40.40056000"
                    },
                    {
                        "id": 13614,
                        "name": "Pancas",
                        "latitude": "-19.22500000",
                        "longitude": "-40.85139000"
                    },
                    {
                        "id": 13775,
                        "name": "Pedro Canário",
                        "latitude": "-18.20359000",
                        "longitude": "-40.03155000"
                    },
                    {
                        "id": 13872,
                        "name": "Pinheiros",
                        "latitude": "-18.34486000",
                        "longitude": "-40.20984000"
                    },
                    {
                        "id": 13931,
                        "name": "Piúma",
                        "latitude": "-20.83106000",
                        "longitude": "-40.72932000"
                    },
                    {
                        "id": 13975,
                        "name": "Ponto Belo",
                        "latitude": "-18.25222000",
                        "longitude": "-40.49863000"
                    },
                    {
                        "id": 14087,
                        "name": "Presidente Kennedy",
                        "latitude": "-21.14995000",
                        "longitude": "-41.07293000"
                    },
                    {
                        "id": 14259,
                        "name": "Rio Bananal",
                        "latitude": "-19.26500000",
                        "longitude": "-40.33333000"
                    },
                    {
                        "id": 14286,
                        "name": "Rio Novo do Sul",
                        "latitude": "-20.78326000",
                        "longitude": "-40.93976000"
                    },
                    {
                        "id": 14487,
                        "name": "Santa Leopoldina",
                        "latitude": "-20.10056000",
                        "longitude": "-40.52972000"
                    },
                    {
                        "id": 14510,
                        "name": "Santa Maria de Jetibá",
                        "latitude": "-20.02745000",
                        "longitude": "-40.74336000"
                    },
                    {
                        "id": 14551,
                        "name": "Santa Teresa",
                        "latitude": "-19.93556000",
                        "longitude": "-40.60028000"
                    },
                    {
                        "id": 14872,
                        "name": "São Domingos do Norte",
                        "latitude": "-19.12970000",
                        "longitude": "-40.55454000"
                    },
                    {
                        "id": 14910,
                        "name": "São Gabriel da Palha",
                        "latitude": "-18.97356000",
                        "longitude": "-40.52522000"
                    },
                    {
                        "id": 14964,
                        "name": "São José do Calçado",
                        "latitude": "-20.98599000",
                        "longitude": "-41.66419000"
                    },
                    {
                        "id": 15075,
                        "name": "São Mateus",
                        "latitude": "-18.72011000",
                        "longitude": "-39.85891000"
                    },
                    {
                        "id": 15133,
                        "name": "São Roque do Canaã",
                        "latitude": "-19.73027000",
                        "longitude": "-40.67143000"
                    },
                    {
                        "id": 14721,
                        "name": "Serra",
                        "latitude": "-20.10822000",
                        "longitude": "-40.30186000"
                    },
                    {
                        "id": 14810,
                        "name": "Sooretama",
                        "latitude": "-19.08218000",
                        "longitude": "-40.14134000"
                    },
                    {
                        "id": 15509,
                        "name": "Vargem Alta",
                        "latitude": "-20.64727000",
                        "longitude": "-41.00855000"
                    },
                    {
                        "id": 15526,
                        "name": "Venda Nova do Imigrante",
                        "latitude": "-20.38487000",
                        "longitude": "-41.13539000"
                    },
                    {
                        "id": 15553,
                        "name": "Viana",
                        "latitude": "-20.36757000",
                        "longitude": "-40.51413000"
                    },
                    {
                        "id": 15574,
                        "name": "Vila Pavão",
                        "latitude": "-18.61186000",
                        "longitude": "-40.65163000"
                    },
                    {
                        "id": 15577,
                        "name": "Vila Valério",
                        "latitude": "-18.97995000",
                        "longitude": "-40.36633000"
                    },
                    {
                        "id": 15578,
                        "name": "Vila Velha",
                        "latitude": "-20.32972000",
                        "longitude": "-40.29250000"
                    },
                    {
                        "id": 15597,
                        "name": "Vitória",
                        "latitude": "-20.31944000",
                        "longitude": "-40.33778000"
                    }
                ]
            },
            {
                "id": 2000,
                "name": "Goiás",
                "iso2": "GO",
                "latitude": "-15.82703690",
                "longitude": "-49.83622370",
                "type": "state",
                "cities": [
                    {
                        "id": 10053,
                        "name": "Abadia de Goiás",
                        "latitude": "-16.77762000",
                        "longitude": "-49.46841000"
                    },
                    {
                        "id": 10055,
                        "name": "Abadiânia",
                        "latitude": "-16.22632000",
                        "longitude": "-48.62681000"
                    },
                    {
                        "id": 10079,
                        "name": "Acreúna",
                        "latitude": "-17.43605000",
                        "longitude": "-50.26696000"
                    },
                    {
                        "id": 10081,
                        "name": "Adelândia",
                        "latitude": "-16.38577000",
                        "longitude": "-50.18846000"
                    },
                    {
                        "id": 15660,
                        "name": "Água Fria de Goiás",
                        "latitude": "-14.96056000",
                        "longitude": "-47.84963000"
                    },
                    {
                        "id": 15661,
                        "name": "Água Limpa",
                        "latitude": "-18.07999000",
                        "longitude": "-48.79951000"
                    },
                    {
                        "id": 15668,
                        "name": "Águas Lindas de Goiás",
                        "latitude": "-15.76613000",
                        "longitude": "-48.28611000"
                    },
                    {
                        "id": 10129,
                        "name": "Alexânia",
                        "latitude": "-16.14926000",
                        "longitude": "-48.45973000"
                    },
                    {
                        "id": 10146,
                        "name": "Aloândia",
                        "latitude": "-17.69411000",
                        "longitude": "-49.44985000"
                    },
                    {
                        "id": 10171,
                        "name": "Alto Horizonte",
                        "latitude": "-14.20236000",
                        "longitude": "-49.43500000"
                    },
                    {
                        "id": 10178,
                        "name": "Alto Paraíso de Goiás",
                        "latitude": "-14.18198000",
                        "longitude": "-47.45902000"
                    },
                    {
                        "id": 10199,
                        "name": "Alvorada do Norte",
                        "latitude": "-14.52424000",
                        "longitude": "-46.64133000"
                    },
                    {
                        "id": 10208,
                        "name": "Amaralina",
                        "latitude": "-13.81390000",
                        "longitude": "-49.63205000"
                    },
                    {
                        "id": 10214,
                        "name": "Americano do Brasil",
                        "latitude": "-16.26498000",
                        "longitude": "-49.99408000"
                    },
                    {
                        "id": 10217,
                        "name": "Amorinópolis",
                        "latitude": "-16.63420000",
                        "longitude": "-51.09852000"
                    },
                    {
                        "id": 10282,
                        "name": "Anápolis",
                        "latitude": "-16.32667000",
                        "longitude": "-48.95278000"
                    },
                    {
                        "id": 10260,
                        "name": "Anhanguera",
                        "latitude": "-18.31505000",
                        "longitude": "-48.22190000"
                    },
                    {
                        "id": 10263,
                        "name": "Anicuns",
                        "latitude": "-16.38582000",
                        "longitude": "-49.97942000"
                    },
                    {
                        "id": 10287,
                        "name": "Aparecida de Goiânia",
                        "latitude": "-16.82333000",
                        "longitude": "-49.24389000"
                    },
                    {
                        "id": 10288,
                        "name": "Aparecida do Rio Doce",
                        "latitude": "-18.22963000",
                        "longitude": "-51.24140000"
                    },
                    {
                        "id": 10299,
                        "name": "Aporé",
                        "latitude": "-18.74325000",
                        "longitude": "-52.06942000"
                    },
                    {
                        "id": 10372,
                        "name": "Araçu",
                        "latitude": "-16.38304000",
                        "longitude": "-49.70782000"
                    },
                    {
                        "id": 10315,
                        "name": "Aragarças",
                        "latitude": "-15.94743000",
                        "longitude": "-52.08069000"
                    },
                    {
                        "id": 10316,
                        "name": "Aragoiânia",
                        "latitude": "-16.95418000",
                        "longitude": "-49.40598000"
                    },
                    {
                        "id": 10323,
                        "name": "Araguapaz",
                        "latitude": "-15.12986000",
                        "longitude": "-50.49840000"
                    },
                    {
                        "id": 10391,
                        "name": "Arenópolis",
                        "latitude": "-16.36096000",
                        "longitude": "-51.60464000"
                    },
                    {
                        "id": 10418,
                        "name": "Aruanã",
                        "latitude": "-14.81020000",
                        "longitude": "-50.94501000"
                    },
                    {
                        "id": 10449,
                        "name": "Aurilândia",
                        "latitude": "-16.67681000",
                        "longitude": "-50.52582000"
                    },
                    {
                        "id": 10460,
                        "name": "Avelinópolis",
                        "latitude": "-16.49121000",
                        "longitude": "-49.76368000"
                    },
                    {
                        "id": 10483,
                        "name": "Baliza",
                        "latitude": "-16.36672000",
                        "longitude": "-52.43611000"
                    },
                    {
                        "id": 10561,
                        "name": "Barro Alto",
                        "latitude": "-14.91276000",
                        "longitude": "-48.87739000"
                    },
                    {
                        "id": 10596,
                        "name": "Bela Vista de Goiás",
                        "latitude": "-16.97278000",
                        "longitude": "-48.95333000"
                    },
                    {
                        "id": 10696,
                        "name": "Bom Jardim de Goiás",
                        "latitude": "-16.27033000",
                        "longitude": "-52.05682000"
                    },
                    {
                        "id": 10707,
                        "name": "Bom Jesus de Goiás",
                        "latitude": "-18.19213000",
                        "longitude": "-49.89536000"
                    },
                    {
                        "id": 10733,
                        "name": "Bonfinópolis",
                        "latitude": "-16.59726000",
                        "longitude": "-49.01486000"
                    },
                    {
                        "id": 10742,
                        "name": "Bonópolis",
                        "latitude": "-13.57725000",
                        "longitude": "-49.89702000"
                    },
                    {
                        "id": 10778,
                        "name": "Brazabrantes",
                        "latitude": "-16.37909000",
                        "longitude": "-49.38445000"
                    },
                    {
                        "id": 10803,
                        "name": "Britânia",
                        "latitude": "-15.21115000",
                        "longitude": "-51.14785000"
                    },
                    {
                        "id": 10824,
                        "name": "Buriti Alegre",
                        "latitude": "-18.14000000",
                        "longitude": "-49.04028000"
                    },
                    {
                        "id": 10826,
                        "name": "Buriti de Goiás",
                        "latitude": "-16.16439000",
                        "longitude": "-50.42918000"
                    },
                    {
                        "id": 10831,
                        "name": "Buritinópolis",
                        "latitude": "-14.40974000",
                        "longitude": "-46.31759000"
                    },
                    {
                        "id": 10848,
                        "name": "Cabeceiras",
                        "latitude": "-15.73747000",
                        "longitude": "-47.03428000"
                    },
                    {
                        "id": 10862,
                        "name": "Cachoeira Alta",
                        "latitude": "-18.54284000",
                        "longitude": "-50.98208000"
                    },
                    {
                        "id": 10868,
                        "name": "Cachoeira de Goiás",
                        "latitude": "-16.72507000",
                        "longitude": "-50.68613000"
                    },
                    {
                        "id": 10864,
                        "name": "Cachoeira Dourada",
                        "latitude": "-18.49516000",
                        "longitude": "-49.65104000"
                    },
                    {
                        "id": 11224,
                        "name": "Caçu",
                        "latitude": "-18.55667000",
                        "longitude": "-51.13083000"
                    },
                    {
                        "id": 10900,
                        "name": "Caiapônia",
                        "latitude": "-16.95987000",
                        "longitude": "-51.79148000"
                    },
                    {
                        "id": 10925,
                        "name": "Caldas Novas",
                        "latitude": "-17.73126000",
                        "longitude": "-48.65479000"
                    },
                    {
                        "id": 10926,
                        "name": "Caldazinha",
                        "latitude": "-16.74858000",
                        "longitude": "-49.00064000"
                    },
                    {
                        "id": 10960,
                        "name": "Campestre de Goiás",
                        "latitude": "-16.78337000",
                        "longitude": "-49.70958000"
                    },
                    {
                        "id": 10973,
                        "name": "Campinaçu",
                        "latitude": "-13.86371000",
                        "longitude": "-48.56754000"
                    },
                    {
                        "id": 10974,
                        "name": "Campinorte",
                        "latitude": "-14.04500000",
                        "longitude": "-48.97524000"
                    },
                    {
                        "id": 10978,
                        "name": "Campo Alegre de Goiás",
                        "latitude": "-17.67336000",
                        "longitude": "-47.77801000"
                    },
                    {
                        "id": 10995,
                        "name": "Campo Limpo de Goiás",
                        "latitude": "-16.30048000",
                        "longitude": "-49.09041000"
                    },
                    {
                        "id": 11009,
                        "name": "Campos Belos",
                        "latitude": "-13.03667000",
                        "longitude": "-46.77167000"
                    },
                    {
                        "id": 11016,
                        "name": "Campos Verdes",
                        "latitude": "-14.19022000",
                        "longitude": "-49.65835000"
                    },
                    {
                        "id": 11149,
                        "name": "Carmo do Rio Verde",
                        "latitude": "-15.35361000",
                        "longitude": "-49.70750000"
                    },
                    {
                        "id": 11189,
                        "name": "Castelândia",
                        "latitude": "-18.15581000",
                        "longitude": "-50.34000000"
                    },
                    {
                        "id": 11194,
                        "name": "Catalão",
                        "latitude": "-18.16583000",
                        "longitude": "-47.94639000"
                    },
                    {
                        "id": 11210,
                        "name": "Caturaí",
                        "latitude": "-16.46981000",
                        "longitude": "-49.59556000"
                    },
                    {
                        "id": 11215,
                        "name": "Cavalcante",
                        "latitude": "-13.79750000",
                        "longitude": "-47.45833000"
                    },
                    {
                        "id": 11245,
                        "name": "Ceres",
                        "latitude": "-15.27350000",
                        "longitude": "-49.64455000"
                    },
                    {
                        "id": 11257,
                        "name": "Cezarina",
                        "latitude": "-17.11818000",
                        "longitude": "-49.72995000"
                    },
                    {
                        "id": 11266,
                        "name": "Chapadão do Céu",
                        "latitude": "-18.37043000",
                        "longitude": "-52.56560000"
                    },
                    {
                        "id": 11291,
                        "name": "Cidade Ocidental",
                        "latitude": "-16.16178000",
                        "longitude": "-47.79998000"
                    },
                    {
                        "id": 11311,
                        "name": "Cocalzinho de Goiás",
                        "latitude": "-15.65900000",
                        "longitude": "-48.57595000"
                    },
                    {
                        "id": 11324,
                        "name": "Colinas do Sul",
                        "latitude": "-14.01221000",
                        "longitude": "-48.05124000"
                    },
                    {
                        "id": 11557,
                        "name": "Córrego do Ouro",
                        "latitude": "-16.39566000",
                        "longitude": "-50.57320000"
                    },
                    {
                        "id": 11443,
                        "name": "Corumbá de Goiás",
                        "latitude": "-15.92190000",
                        "longitude": "-48.62979000"
                    },
                    {
                        "id": 11440,
                        "name": "Corumbaíba",
                        "latitude": "-18.16664000",
                        "longitude": "-48.53205000"
                    },
                    {
                        "id": 11471,
                        "name": "Cristalina",
                        "latitude": "-16.76769000",
                        "longitude": "-47.61530000"
                    },
                    {
                        "id": 11475,
                        "name": "Cristianópolis",
                        "latitude": "-17.19669000",
                        "longitude": "-48.68114000"
                    },
                    {
                        "id": 11483,
                        "name": "Crixás",
                        "latitude": "-14.54889000",
                        "longitude": "-49.96917000"
                    },
                    {
                        "id": 11486,
                        "name": "Cromínia",
                        "latitude": "-17.24762000",
                        "longitude": "-49.32979000"
                    },
                    {
                        "id": 11512,
                        "name": "Cumari",
                        "latitude": "-18.31597000",
                        "longitude": "-48.16375000"
                    },
                    {
                        "id": 11559,
                        "name": "Damianópolis",
                        "latitude": "-14.54949000",
                        "longitude": "-46.19367000"
                    },
                    {
                        "id": 11561,
                        "name": "Damolândia",
                        "latitude": "-16.25109000",
                        "longitude": "-49.34505000"
                    },
                    {
                        "id": 11566,
                        "name": "Davinópolis",
                        "latitude": "-18.13603000",
                        "longitude": "-47.57750000"
                    },
                    {
                        "id": 11596,
                        "name": "Diorama",
                        "latitude": "-16.22318000",
                        "longitude": "-51.34971000"
                    },
                    {
                        "id": 11607,
                        "name": "Divinópolis de Goiás",
                        "latitude": "-13.22378000",
                        "longitude": "-46.52704000"
                    },
                    {
                        "id": 11661,
                        "name": "Doverlândia",
                        "latitude": "-16.87767000",
                        "longitude": "-52.49917000"
                    },
                    {
                        "id": 11674,
                        "name": "Edealina",
                        "latitude": "-17.43990000",
                        "longitude": "-49.73319000"
                    },
                    {
                        "id": 11675,
                        "name": "Edéia",
                        "latitude": "-17.33833000",
                        "longitude": "-49.93139000"
                    },
                    {
                        "id": 11755,
                        "name": "Estrela do Norte",
                        "latitude": "-13.78262000",
                        "longitude": "-49.10026000"
                    },
                    {
                        "id": 11772,
                        "name": "Faina",
                        "latitude": "-15.43697000",
                        "longitude": "-50.39151000"
                    },
                    {
                        "id": 11785,
                        "name": "Fazenda Nova",
                        "latitude": "-16.12866000",
                        "longitude": "-50.92604000"
                    },
                    {
                        "id": 11823,
                        "name": "Firminópolis",
                        "latitude": "-16.58194000",
                        "longitude": "-50.30500000"
                    },
                    {
                        "id": 11832,
                        "name": "Flores de Goiás",
                        "latitude": "-14.59003000",
                        "longitude": "-46.87853000"
                    },
                    {
                        "id": 11852,
                        "name": "Formosa",
                        "latitude": "-15.53722000",
                        "longitude": "-47.33444000"
                    },
                    {
                        "id": 11858,
                        "name": "Formoso",
                        "latitude": "-13.70339000",
                        "longitude": "-48.87538000"
                    },
                    {
                        "id": 11916,
                        "name": "Gameleira de Goiás",
                        "latitude": "-16.43131000",
                        "longitude": "-48.67456000"
                    },
                    {
                        "id": 11963,
                        "name": "Goianápolis",
                        "latitude": "-16.53041000",
                        "longitude": "-49.08769000"
                    },
                    {
                        "id": 11958,
                        "name": "Goiandira",
                        "latitude": "-18.10979000",
                        "longitude": "-48.14934000"
                    },
                    {
                        "id": 11964,
                        "name": "Goianésia",
                        "latitude": "-15.31750000",
                        "longitude": "-49.11750000"
                    },
                    {
                        "id": 11971,
                        "name": "Goiânia",
                        "latitude": "-16.67861000",
                        "longitude": "-49.25389000"
                    },
                    {
                        "id": 11960,
                        "name": "Goianira",
                        "latitude": "-16.49611000",
                        "longitude": "-49.42639000"
                    },
                    {
                        "id": 11970,
                        "name": "Goiás",
                        "latitude": "-15.93444000",
                        "longitude": "-50.14028000"
                    },
                    {
                        "id": 11967,
                        "name": "Goiatuba",
                        "latitude": "-18.01250000",
                        "longitude": "-49.35472000"
                    },
                    {
                        "id": 11977,
                        "name": "Gouvelândia",
                        "latitude": "-18.50777000",
                        "longitude": "-50.17554000"
                    },
                    {
                        "id": 12033,
                        "name": "Guapó",
                        "latitude": "-16.83056000",
                        "longitude": "-49.53194000"
                    },
                    {
                        "id": 12062,
                        "name": "Guaraíta",
                        "latitude": "-15.65961000",
                        "longitude": "-50.06663000"
                    },
                    {
                        "id": 12046,
                        "name": "Guarani de Goiás",
                        "latitude": "-13.88485000",
                        "longitude": "-46.50711000"
                    },
                    {
                        "id": 12067,
                        "name": "Guarinos",
                        "latitude": "-14.69976000",
                        "longitude": "-49.73100000"
                    },
                    {
                        "id": 12093,
                        "name": "Heitoraí",
                        "latitude": "-15.73416000",
                        "longitude": "-49.83108000"
                    },
                    {
                        "id": 12102,
                        "name": "Hidrolândia",
                        "latitude": "-16.96222000",
                        "longitude": "-49.22806000"
                    },
                    {
                        "id": 12100,
                        "name": "Hidrolina",
                        "latitude": "-14.75739000",
                        "longitude": "-49.35965000"
                    },
                    {
                        "id": 12114,
                        "name": "Iaciara",
                        "latitude": "-14.09583000",
                        "longitude": "-46.63167000"
                    },
                    {
                        "id": 12227,
                        "name": "Inaciolândia",
                        "latitude": "-18.49889000",
                        "longitude": "-49.90164000"
                    },
                    {
                        "id": 12240,
                        "name": "Indiara",
                        "latitude": "-17.18504000",
                        "longitude": "-49.96826000"
                    },
                    {
                        "id": 12253,
                        "name": "Inhumas",
                        "latitude": "-16.35778000",
                        "longitude": "-49.49611000"
                    },
                    {
                        "id": 12260,
                        "name": "Ipameri",
                        "latitude": "-17.72194000",
                        "longitude": "-48.15972000"
                    },
                    {
                        "id": 12276,
                        "name": "Ipiranga de Goiás",
                        "latitude": "-15.16876000",
                        "longitude": "-49.65047000"
                    },
                    {
                        "id": 12285,
                        "name": "Iporá",
                        "latitude": "-16.45543000",
                        "longitude": "-51.15977000"
                    },
                    {
                        "id": 12323,
                        "name": "Israelândia",
                        "latitude": "-16.35776000",
                        "longitude": "-50.89499000"
                    },
                    {
                        "id": 12330,
                        "name": "Itaberaí",
                        "latitude": "-16.02028000",
                        "longitude": "-49.81028000"
                    },
                    {
                        "id": 12352,
                        "name": "Itaguari",
                        "latitude": "-15.91179000",
                        "longitude": "-49.61834000"
                    },
                    {
                        "id": 12353,
                        "name": "Itaguaru",
                        "latitude": "-15.76944000",
                        "longitude": "-49.60042000"
                    },
                    {
                        "id": 12373,
                        "name": "Itajá",
                        "latitude": "-19.11554000",
                        "longitude": "-51.24473000"
                    },
                    {
                        "id": 12398,
                        "name": "Itapaci",
                        "latitude": "-14.95083000",
                        "longitude": "-49.54944000"
                    },
                    {
                        "id": 12423,
                        "name": "Itapirapuã",
                        "latitude": "-15.82333000",
                        "longitude": "-50.61333000"
                    },
                    {
                        "id": 12438,
                        "name": "Itapuranga",
                        "latitude": "-15.56944000",
                        "longitude": "-49.93481000"
                    },
                    {
                        "id": 12452,
                        "name": "Itarumã",
                        "latitude": "-18.87992000",
                        "longitude": "-51.32023000"
                    },
                    {
                        "id": 12464,
                        "name": "Itauçu",
                        "latitude": "-16.21434000",
                        "longitude": "-49.60066000"
                    },
                    {
                        "id": 12487,
                        "name": "Itumbiara",
                        "latitude": "-18.41917000",
                        "longitude": "-49.21528000"
                    },
                    {
                        "id": 12503,
                        "name": "Ivolândia",
                        "latitude": "-16.68830000",
                        "longitude": "-50.92660000"
                    },
                    {
                        "id": 12556,
                        "name": "Jandaia",
                        "latitude": "-17.12900000",
                        "longitude": "-50.19476000"
                    },
                    {
                        "id": 12580,
                        "name": "Jaraguá",
                        "latitude": "-15.75694000",
                        "longitude": "-49.33444000"
                    },
                    {
                        "id": 12598,
                        "name": "Jataí",
                        "latitude": "-17.85829000",
                        "longitude": "-51.70531000"
                    },
                    {
                        "id": 12605,
                        "name": "Jaupaci",
                        "latitude": "-16.16749000",
                        "longitude": "-51.10168000"
                    },
                    {
                        "id": 12627,
                        "name": "Jesúpolis",
                        "latitude": "-15.96458000",
                        "longitude": "-49.39461000"
                    },
                    {
                        "id": 12656,
                        "name": "Joviânia",
                        "latitude": "-17.78422000",
                        "longitude": "-49.58440000"
                    },
                    {
                        "id": 12707,
                        "name": "Jussara",
                        "latitude": "-15.58295000",
                        "longitude": "-51.32970000"
                    },
                    {
                        "id": 12745,
                        "name": "Lagoa Santa",
                        "latitude": "-19.21207000",
                        "longitude": "-51.25891000"
                    },
                    {
                        "id": 12821,
                        "name": "Leopoldo de Bulhões",
                        "latitude": "-16.58142000",
                        "longitude": "-48.90604000"
                    },
                    {
                        "id": 12877,
                        "name": "Luziânia",
                        "latitude": "-16.25250000",
                        "longitude": "-47.95028000"
                    },
                    {
                        "id": 12919,
                        "name": "Mairipotaba",
                        "latitude": "-17.32688000",
                        "longitude": "-49.50788000"
                    },
                    {
                        "id": 12932,
                        "name": "Mambaí",
                        "latitude": "-14.44220000",
                        "longitude": "-46.05807000"
                    },
                    {
                        "id": 12963,
                        "name": "Mara Rosa",
                        "latitude": "-14.01285000",
                        "longitude": "-49.39507000"
                    },
                    {
                        "id": 13038,
                        "name": "Marzagão",
                        "latitude": "-17.99103000",
                        "longitude": "-48.68316000"
                    },
                    {
                        "id": 13072,
                        "name": "Matrinchã",
                        "latitude": "-15.33819000",
                        "longitude": "-50.82655000"
                    },
                    {
                        "id": 13080,
                        "name": "Maurilândia",
                        "latitude": "-18.05037000",
                        "longitude": "-50.32935000"
                    },
                    {
                        "id": 13119,
                        "name": "Mimoso de Goiás",
                        "latitude": "-15.04832000",
                        "longitude": "-48.34448000"
                    },
                    {
                        "id": 13124,
                        "name": "Minaçu",
                        "latitude": "-13.42682000",
                        "longitude": "-48.38780000"
                    },
                    {
                        "id": 13126,
                        "name": "Mineiros",
                        "latitude": "-17.56944000",
                        "longitude": "-52.55111000"
                    },
                    {
                        "id": 13168,
                        "name": "Moiporá",
                        "latitude": "-16.50172000",
                        "longitude": "-50.76811000"
                    },
                    {
                        "id": 13188,
                        "name": "Monte Alegre de Goiás",
                        "latitude": "-13.26150000",
                        "longitude": "-46.84266000"
                    },
                    {
                        "id": 13221,
                        "name": "Montes Claros de Goiás",
                        "latitude": "-15.96248000",
                        "longitude": "-51.50601000"
                    },
                    {
                        "id": 13223,
                        "name": "Montividiu",
                        "latitude": "-17.25815000",
                        "longitude": "-51.15739000"
                    },
                    {
                        "id": 13224,
                        "name": "Montividiu do Norte",
                        "latitude": "-13.09232000",
                        "longitude": "-48.74161000"
                    },
                    {
                        "id": 13237,
                        "name": "Morrinhos",
                        "latitude": "-17.79922000",
                        "longitude": "-49.09225000"
                    },
                    {
                        "id": 13240,
                        "name": "Morro Agudo de Goiás",
                        "latitude": "-15.32310000",
                        "longitude": "-50.01578000"
                    },
                    {
                        "id": 13255,
                        "name": "Mossâmedes",
                        "latitude": "-16.16495000",
                        "longitude": "-50.17004000"
                    },
                    {
                        "id": 13258,
                        "name": "Mozarlândia",
                        "latitude": "-14.74472000",
                        "longitude": "-50.57056000"
                    },
                    {
                        "id": 13271,
                        "name": "Mundo Novo",
                        "latitude": "-13.71649000",
                        "longitude": "-50.23715000"
                    },
                    {
                        "id": 13286,
                        "name": "Mutunópolis",
                        "latitude": "-13.70257000",
                        "longitude": "-49.29995000"
                    },
                    {
                        "id": 13316,
                        "name": "Nazário",
                        "latitude": "-16.58010000",
                        "longitude": "-49.86543000"
                    },
                    {
                        "id": 13318,
                        "name": "Nerópolis",
                        "latitude": "-16.43883000",
                        "longitude": "-49.18117000"
                    },
                    {
                        "id": 13330,
                        "name": "Niquelândia",
                        "latitude": "-14.47389000",
                        "longitude": "-48.45972000"
                    },
                    {
                        "id": 13349,
                        "name": "Nova América",
                        "latitude": "-15.05098000",
                        "longitude": "-49.92499000"
                    },
                    {
                        "id": 13354,
                        "name": "Nova Aurora",
                        "latitude": "-18.10107000",
                        "longitude": "-48.27661000"
                    },
                    {
                        "id": 13370,
                        "name": "Nova Crixás",
                        "latitude": "-14.27678000",
                        "longitude": "-50.57649000"
                    },
                    {
                        "id": 13383,
                        "name": "Nova Glória",
                        "latitude": "-15.06360000",
                        "longitude": "-49.48353000"
                    },
                    {
                        "id": 13390,
                        "name": "Nova Iguaçu de Goiás",
                        "latitude": "-14.29731000",
                        "longitude": "-49.31188000"
                    },
                    {
                        "id": 13427,
                        "name": "Nova Roma",
                        "latitude": "-13.84078000",
                        "longitude": "-47.00832000"
                    },
                    {
                        "id": 13445,
                        "name": "Nova Veneza",
                        "latitude": "-16.35456000",
                        "longitude": "-49.30001000"
                    },
                    {
                        "id": 13455,
                        "name": "Novo Brasil",
                        "latitude": "-16.04806000",
                        "longitude": "-50.63638000"
                    },
                    {
                        "id": 13458,
                        "name": "Novo Gama",
                        "latitude": "-16.12535000",
                        "longitude": "-48.07041000"
                    },
                    {
                        "id": 13474,
                        "name": "Novo Planalto",
                        "latitude": "-13.38362000",
                        "longitude": "-49.76104000"
                    },
                    {
                        "id": 13519,
                        "name": "Orizona",
                        "latitude": "-17.03139000",
                        "longitude": "-48.29583000"
                    },
                    {
                        "id": 13547,
                        "name": "Ouro Verde de Goiás",
                        "latitude": "-16.23604000",
                        "longitude": "-49.22771000"
                    },
                    {
                        "id": 13553,
                        "name": "Ouvidor",
                        "latitude": "-18.20107000",
                        "longitude": "-47.71513000"
                    },
                    {
                        "id": 13561,
                        "name": "Padre Bernardo",
                        "latitude": "-15.16595000",
                        "longitude": "-48.28281000"
                    },
                    {
                        "id": 13577,
                        "name": "Palestina de Goiás",
                        "latitude": "-16.72854000",
                        "longitude": "-51.45851000"
                    },
                    {
                        "id": 13598,
                        "name": "Palmeiras de Goiás",
                        "latitude": "-16.80500000",
                        "longitude": "-49.92583000"
                    },
                    {
                        "id": 13603,
                        "name": "Palmelo",
                        "latitude": "-17.31937000",
                        "longitude": "-48.39429000"
                    },
                    {
                        "id": 13604,
                        "name": "Palminópolis",
                        "latitude": "-16.83157000",
                        "longitude": "-50.24267000"
                    },
                    {
                        "id": 13613,
                        "name": "Panamá",
                        "latitude": "-18.20132000",
                        "longitude": "-49.38890000"
                    },
                    {
                        "id": 13638,
                        "name": "Paranaiguara",
                        "latitude": "-18.77492000",
                        "longitude": "-50.61841000"
                    },
                    {
                        "id": 13666,
                        "name": "Paraúna",
                        "latitude": "-16.94778000",
                        "longitude": "-50.44861000"
                    },
                    {
                        "id": 13813,
                        "name": "Perolândia",
                        "latitude": "-17.52861000",
                        "longitude": "-52.06417000"
                    },
                    {
                        "id": 13818,
                        "name": "Petrolina de Goiás",
                        "latitude": "-16.09500000",
                        "longitude": "-49.33806000"
                    },
                    {
                        "id": 13838,
                        "name": "Pilar de Goiás",
                        "latitude": "-14.52999000",
                        "longitude": "-49.51094000"
                    },
                    {
                        "id": 13884,
                        "name": "Piracanjuba",
                        "latitude": "-17.30278000",
                        "longitude": "-49.01667000"
                    },
                    {
                        "id": 13896,
                        "name": "Piranhas",
                        "latitude": "-16.42694000",
                        "longitude": "-51.82222000"
                    },
                    {
                        "id": 13914,
                        "name": "Pirenópolis",
                        "latitude": "-15.85072000",
                        "longitude": "-48.96087000"
                    },
                    {
                        "id": 13916,
                        "name": "Pires do Rio",
                        "latitude": "-17.29972000",
                        "longitude": "-48.27944000"
                    },
                    {
                        "id": 13933,
                        "name": "Planaltina",
                        "latitude": "-15.45278000",
                        "longitude": "-47.61417000"
                    },
                    {
                        "id": 13963,
                        "name": "Pontalina",
                        "latitude": "-17.52500000",
                        "longitude": "-49.44722000"
                    },
                    {
                        "id": 13983,
                        "name": "Porangatu",
                        "latitude": "-13.44083000",
                        "longitude": "-49.14861000"
                    },
                    {
                        "id": 13989,
                        "name": "Porteirão",
                        "latitude": "-17.90236000",
                        "longitude": "-50.15667000"
                    },
                    {
                        "id": 13991,
                        "name": "Portelândia",
                        "latitude": "-17.35610000",
                        "longitude": "-52.67861000"
                    },
                    {
                        "id": 14030,
                        "name": "Posse",
                        "latitude": "-14.09306000",
                        "longitude": "-46.36944000"
                    },
                    {
                        "id": 14108,
                        "name": "Professor Jamil",
                        "latitude": "-17.29408000",
                        "longitude": "-49.25572000"
                    },
                    {
                        "id": 14154,
                        "name": "Quirinópolis",
                        "latitude": "-18.44833000",
                        "longitude": "-50.45167000"
                    },
                    {
                        "id": 14227,
                        "name": "Rialma",
                        "latitude": "-15.31500000",
                        "longitude": "-49.58444000"
                    },
                    {
                        "id": 14228,
                        "name": "Rianápolis",
                        "latitude": "-15.47467000",
                        "longitude": "-49.44786000"
                    },
                    {
                        "id": 14294,
                        "name": "Rio Quente",
                        "latitude": "-17.81769000",
                        "longitude": "-48.80202000"
                    },
                    {
                        "id": 14300,
                        "name": "Rio Verde",
                        "latitude": "-17.71888000",
                        "longitude": "-51.04215000"
                    },
                    {
                        "id": 14358,
                        "name": "Rubiataba",
                        "latitude": "-15.16444000",
                        "longitude": "-49.80333000"
                    },
                    {
                        "id": 14411,
                        "name": "Sanclerlândia",
                        "latitude": "-16.28223000",
                        "longitude": "-50.37210000"
                    },
                    {
                        "id": 14425,
                        "name": "Santa Bárbara de Goiás",
                        "latitude": "-16.60228000",
                        "longitude": "-49.68624000"
                    },
                    {
                        "id": 14447,
                        "name": "Santa Cruz de Goiás",
                        "latitude": "-17.45147000",
                        "longitude": "-48.57101000"
                    },
                    {
                        "id": 14465,
                        "name": "Santa Fé de Goiás",
                        "latitude": "-15.62304000",
                        "longitude": "-51.13850000"
                    },
                    {
                        "id": 14474,
                        "name": "Santa Helena de Goiás",
                        "latitude": "-17.80542000",
                        "longitude": "-50.53885000"
                    },
                    {
                        "id": 14481,
                        "name": "Santa Isabel",
                        "latitude": "-15.26996000",
                        "longitude": "-49.37797000"
                    },
                    {
                        "id": 14532,
                        "name": "Santa Rita do Araguaia",
                        "latitude": "-17.23294000",
                        "longitude": "-53.07676000"
                    },
                    {
                        "id": 14534,
                        "name": "Santa Rita do Novo Destino",
                        "latitude": "-14.82658000",
                        "longitude": "-49.05935000"
                    },
                    {
                        "id": 14542,
                        "name": "Santa Rosa de Goiás",
                        "latitude": "-16.06989000",
                        "longitude": "-49.48147000"
                    },
                    {
                        "id": 14554,
                        "name": "Santa Tereza de Goiás",
                        "latitude": "-13.55111000",
                        "longitude": "-48.99503000"
                    },
                    {
                        "id": 14561,
                        "name": "Santa Terezinha de Goiás",
                        "latitude": "-14.31049000",
                        "longitude": "-49.71445000"
                    },
                    {
                        "id": 14612,
                        "name": "Santo Antônio da Barra",
                        "latitude": "-17.51225000",
                        "longitude": "-50.63068000"
                    },
                    {
                        "id": 14616,
                        "name": "Santo Antônio de Goiás",
                        "latitude": "-16.50007000",
                        "longitude": "-49.31097000"
                    },
                    {
                        "id": 14625,
                        "name": "Santo Antônio do Descoberto",
                        "latitude": "-16.08073000",
                        "longitude": "-48.29596000"
                    },
                    {
                        "id": 14861,
                        "name": "São Domingos",
                        "latitude": "-13.39833000",
                        "longitude": "-46.31833000"
                    },
                    {
                        "id": 14885,
                        "name": "São Francisco de Goiás",
                        "latitude": "-15.95223000",
                        "longitude": "-49.24888000"
                    },
                    {
                        "id": 15005,
                        "name": "São João d'Aliança",
                        "latitude": "-14.42907000",
                        "longitude": "-47.41407000"
                    },
                    {
                        "id": 15012,
                        "name": "São João da Paraúna",
                        "latitude": "-16.82392000",
                        "longitude": "-50.35316000"
                    },
                    {
                        "id": 15065,
                        "name": "São Luís de Montes Belos",
                        "latitude": "-16.52500000",
                        "longitude": "-50.37222000"
                    },
                    {
                        "id": 15061,
                        "name": "São Luiz do Norte",
                        "latitude": "-14.89284000",
                        "longitude": "-49.28212000"
                    },
                    {
                        "id": 15087,
                        "name": "São Miguel do Araguaia",
                        "latitude": "-13.27500000",
                        "longitude": "-50.16278000"
                    },
                    {
                        "id": 15094,
                        "name": "São Miguel do Passa Quatro",
                        "latitude": "-16.99955000",
                        "longitude": "-48.66188000"
                    },
                    {
                        "id": 15100,
                        "name": "São Patrício",
                        "latitude": "-15.34426000",
                        "longitude": "-49.83291000"
                    },
                    {
                        "id": 15157,
                        "name": "São Simão",
                        "latitude": "-19.01080000",
                        "longitude": "-50.60612000"
                    },
                    {
                        "id": 14695,
                        "name": "Senador Canedo",
                        "latitude": "-16.70806000",
                        "longitude": "-49.09306000"
                    },
                    {
                        "id": 14747,
                        "name": "Serranópolis",
                        "latitude": "-18.27044000",
                        "longitude": "-52.24749000"
                    },
                    {
                        "id": 14782,
                        "name": "Silvânia",
                        "latitude": "-16.65889000",
                        "longitude": "-48.60806000"
                    },
                    {
                        "id": 14783,
                        "name": "Simolândia",
                        "latitude": "-14.43819000",
                        "longitude": "-46.59232000"
                    },
                    {
                        "id": 15179,
                        "name": "Sítio d'Abadia",
                        "latitude": "-14.75201000",
                        "longitude": "-46.27003000"
                    },
                    {
                        "id": 15242,
                        "name": "Taquaral de Goiás",
                        "latitude": "-16.05820000",
                        "longitude": "-49.59040000"
                    },
                    {
                        "id": 15285,
                        "name": "Teresina de Goiás",
                        "latitude": "-13.73244000",
                        "longitude": "-47.25266000"
                    },
                    {
                        "id": 15288,
                        "name": "Terezópolis de Goiás",
                        "latitude": "-16.42797000",
                        "longitude": "-49.07425000"
                    },
                    {
                        "id": 15382,
                        "name": "Três Ranchos",
                        "latitude": "-18.36835000",
                        "longitude": "-47.79850000"
                    },
                    {
                        "id": 15358,
                        "name": "Trindade",
                        "latitude": "-16.64944000",
                        "longitude": "-49.48889000"
                    },
                    {
                        "id": 15367,
                        "name": "Trombas",
                        "latitude": "-13.40409000",
                        "longitude": "-48.77287000"
                    },
                    {
                        "id": 15421,
                        "name": "Turvânia",
                        "latitude": "-16.55807000",
                        "longitude": "-50.16909000"
                    },
                    {
                        "id": 15417,
                        "name": "Turvelândia",
                        "latitude": "-17.79588000",
                        "longitude": "-50.29695000"
                    },
                    {
                        "id": 15441,
                        "name": "Uirapuru",
                        "latitude": "-14.14128000",
                        "longitude": "-49.93396000"
                    },
                    {
                        "id": 15472,
                        "name": "Uruaçu",
                        "latitude": "-14.42245000",
                        "longitude": "-49.06374000"
                    },
                    {
                        "id": 15469,
                        "name": "Uruana",
                        "latitude": "-15.56368000",
                        "longitude": "-49.64028000"
                    },
                    {
                        "id": 15485,
                        "name": "Urutaí",
                        "latitude": "-17.41664000",
                        "longitude": "-48.19794000"
                    },
                    {
                        "id": 15504,
                        "name": "Valparaíso de Goiás",
                        "latitude": "-16.09899000",
                        "longitude": "-47.98813000"
                    },
                    {
                        "id": 15519,
                        "name": "Varjão",
                        "latitude": "-17.07758000",
                        "longitude": "-49.62111000"
                    },
                    {
                        "id": 15554,
                        "name": "Vianópolis",
                        "latitude": "-16.85286000",
                        "longitude": "-48.45647000"
                    },
                    {
                        "id": 15557,
                        "name": "Vicentinópolis",
                        "latitude": "-17.70714000",
                        "longitude": "-49.90768000"
                    },
                    {
                        "id": 15566,
                        "name": "Vila Boa",
                        "latitude": "-14.97912000",
                        "longitude": "-47.09259000"
                    },
                    {
                        "id": 15575,
                        "name": "Vila Propício",
                        "latitude": "-15.20221000",
                        "longitude": "-48.77569000"
                    }
                ]
            },
            {
                "id": 2015,
                "name": "Maranhão",
                "iso2": "MA",
                "latitude": "-4.96094980",
                "longitude": "-45.27441590",
                "type": "state",
                "cities": [
                    {
                        "id": 10463,
                        "name": "Açailândia",
                        "latitude": "-4.69214000",
                        "longitude": "-47.34302000"
                    },
                    {
                        "id": 10088,
                        "name": "Afonso Cunha",
                        "latitude": "-4.21479000",
                        "longitude": "-43.29743000"
                    },
                    {
                        "id": 15657,
                        "name": "Água Doce do Maranhão",
                        "latitude": "-2.91251000",
                        "longitude": "-42.14125000"
                    },
                    {
                        "id": 10119,
                        "name": "Alcântara",
                        "latitude": "-2.32768000",
                        "longitude": "-44.50617000"
                    },
                    {
                        "id": 10121,
                        "name": "Aldeias Altas",
                        "latitude": "-4.58522000",
                        "longitude": "-43.46277000"
                    },
                    {
                        "id": 10154,
                        "name": "Altamira do Maranhão",
                        "latitude": "-4.14072000",
                        "longitude": "-45.46154000"
                    },
                    {
                        "id": 10162,
                        "name": "Alto Alegre do Maranhão",
                        "latitude": "-4.20288000",
                        "longitude": "-44.41966000"
                    },
                    {
                        "id": 10163,
                        "name": "Alto Alegre do Pindaré",
                        "latitude": "-3.83592000",
                        "longitude": "-46.03871000"
                    },
                    {
                        "id": 10179,
                        "name": "Alto Parnaíba",
                        "latitude": "-9.53480000",
                        "longitude": "-46.13899000"
                    },
                    {
                        "id": 10205,
                        "name": "Amapá do Maranhão",
                        "latitude": "-1.69470000",
                        "longitude": "-45.92994000"
                    },
                    {
                        "id": 10210,
                        "name": "Amarante do Maranhão",
                        "latitude": "-5.56939000",
                        "longitude": "-46.64105000"
                    },
                    {
                        "id": 10230,
                        "name": "Anajatuba",
                        "latitude": "-3.27409000",
                        "longitude": "-44.53278000"
                    },
                    {
                        "id": 10237,
                        "name": "Anapurus",
                        "latitude": "-3.56073000",
                        "longitude": "-43.04307000"
                    },
                    {
                        "id": 10295,
                        "name": "Apicum-Açu",
                        "latitude": "-1.48035000",
                        "longitude": "-45.08540000"
                    },
                    {
                        "id": 10321,
                        "name": "Araguanã",
                        "latitude": "-3.04178000",
                        "longitude": "-45.75874000"
                    },
                    {
                        "id": 10328,
                        "name": "Araioses",
                        "latitude": "-2.89792000",
                        "longitude": "-42.02298000"
                    },
                    {
                        "id": 10332,
                        "name": "Arame",
                        "latitude": "-5.03155000",
                        "longitude": "-45.86324000"
                    },
                    {
                        "id": 10352,
                        "name": "Arari",
                        "latitude": "-3.45361000",
                        "longitude": "-44.78000000"
                    },
                    {
                        "id": 10440,
                        "name": "Atins",
                        "latitude": "-2.57017000",
                        "longitude": "-42.74229000"
                    },
                    {
                        "id": 10461,
                        "name": "Axixá",
                        "latitude": "-2.84586000",
                        "longitude": "-44.10516000"
                    },
                    {
                        "id": 10467,
                        "name": "Bacabal",
                        "latitude": "-4.29167000",
                        "longitude": "-44.79167000"
                    },
                    {
                        "id": 10468,
                        "name": "Bacabeira",
                        "latitude": "-2.86866000",
                        "longitude": "-44.34505000"
                    },
                    {
                        "id": 10469,
                        "name": "Bacuri",
                        "latitude": "-1.65142000",
                        "longitude": "-45.21995000"
                    },
                    {
                        "id": 10470,
                        "name": "Bacurituba",
                        "latitude": "-2.64645000",
                        "longitude": "-44.65477000"
                    },
                    {
                        "id": 10492,
                        "name": "Balsas",
                        "latitude": "-7.53250000",
                        "longitude": "-46.03556000"
                    },
                    {
                        "id": 10574,
                        "name": "Barão de Grajaú",
                        "latitude": "-6.62978000",
                        "longitude": "-43.20317000"
                    },
                    {
                        "id": 10534,
                        "name": "Barra do Corda",
                        "latitude": "-5.50556000",
                        "longitude": "-45.24333000"
                    },
                    {
                        "id": 10554,
                        "name": "Barreirinhas",
                        "latitude": "-2.75136000",
                        "longitude": "-42.83432000"
                    },
                    {
                        "id": 10598,
                        "name": "Bela Vista do Maranhão",
                        "latitude": "-3.79140000",
                        "longitude": "-45.29546000"
                    },
                    {
                        "id": 10613,
                        "name": "Belágua",
                        "latitude": "-3.08799000",
                        "longitude": "-43.45673000"
                    },
                    {
                        "id": 10623,
                        "name": "Benedito Leite",
                        "latitude": "-7.10697000",
                        "longitude": "-44.58763000"
                    },
                    {
                        "id": 10631,
                        "name": "Bequimão",
                        "latitude": "-2.44889000",
                        "longitude": "-44.78250000"
                    },
                    {
                        "id": 10637,
                        "name": "Bernardo do Mearim",
                        "latitude": "-4.67175000",
                        "longitude": "-44.64279000"
                    },
                    {
                        "id": 10672,
                        "name": "Boa Vista do Gurupi",
                        "latitude": "-1.73082000",
                        "longitude": "-46.19635000"
                    },
                    {
                        "id": 10693,
                        "name": "Bom Jardim",
                        "latitude": "-3.77409000",
                        "longitude": "-46.21707000"
                    },
                    {
                        "id": 10706,
                        "name": "Bom Jesus das Selvas",
                        "latitude": "-4.51333000",
                        "longitude": "-46.60686000"
                    },
                    {
                        "id": 10718,
                        "name": "Bom Lugar",
                        "latitude": "-4.34667000",
                        "longitude": "-45.02098000"
                    },
                    {
                        "id": 10788,
                        "name": "Brejo",
                        "latitude": "-3.68444000",
                        "longitude": "-42.75028000"
                    },
                    {
                        "id": 10794,
                        "name": "Brejo de Areia",
                        "latitude": "-4.32450000",
                        "longitude": "-45.53970000"
                    },
                    {
                        "id": 10823,
                        "name": "Buriti",
                        "latitude": "-3.94799000",
                        "longitude": "-42.85810000"
                    },
                    {
                        "id": 10825,
                        "name": "Buriti Bravo",
                        "latitude": "-5.83722000",
                        "longitude": "-43.83361000"
                    },
                    {
                        "id": 10830,
                        "name": "Buriticupu",
                        "latitude": "-4.51967000",
                        "longitude": "-46.37712000"
                    },
                    {
                        "id": 10833,
                        "name": "Buritirana",
                        "latitude": "-5.59248000",
                        "longitude": "-46.99721000"
                    },
                    {
                        "id": 10865,
                        "name": "Cachoeira Grande",
                        "latitude": "-3.12007000",
                        "longitude": "-43.93132000"
                    },
                    {
                        "id": 10912,
                        "name": "Cajapió",
                        "latitude": "-2.86374000",
                        "longitude": "-44.57287000"
                    },
                    {
                        "id": 10913,
                        "name": "Cajari",
                        "latitude": "-3.38514000",
                        "longitude": "-45.02197000"
                    },
                    {
                        "id": 10961,
                        "name": "Campestre do Maranhão",
                        "latitude": "-6.15156000",
                        "longitude": "-47.23427000"
                    },
                    {
                        "id": 11546,
                        "name": "Cândido Mendes",
                        "latitude": "-1.44667000",
                        "longitude": "-45.71667000"
                    },
                    {
                        "id": 11055,
                        "name": "Cantanhede",
                        "latitude": "-3.63333000",
                        "longitude": "-44.37667000"
                    },
                    {
                        "id": 11077,
                        "name": "Capinzal do Norte",
                        "latitude": "-4.74767000",
                        "longitude": "-44.25167000"
                    },
                    {
                        "id": 11161,
                        "name": "Carolina",
                        "latitude": "-7.33561000",
                        "longitude": "-47.46218000"
                    },
                    {
                        "id": 11167,
                        "name": "Carutapera",
                        "latitude": "-1.18025000",
                        "longitude": "-45.95966000"
                    },
                    {
                        "id": 11218,
                        "name": "Caxias",
                        "latitude": "-4.85889000",
                        "longitude": "-43.35611000"
                    },
                    {
                        "id": 11228,
                        "name": "Cedral",
                        "latitude": "-1.96086000",
                        "longitude": "-44.57424000"
                    },
                    {
                        "id": 11240,
                        "name": "Central do Maranhão",
                        "latitude": "-2.25521000",
                        "longitude": "-44.84104000"
                    },
                    {
                        "id": 11243,
                        "name": "Centro do Guilherme",
                        "latitude": "-2.28072000",
                        "longitude": "-46.07349000"
                    },
                    {
                        "id": 11242,
                        "name": "Centro Novo do Maranhão",
                        "latitude": "-3.31669000",
                        "longitude": "-46.79364000"
                    },
                    {
                        "id": 11265,
                        "name": "Chapadinha",
                        "latitude": "-3.74167000",
                        "longitude": "-43.36028000"
                    },
                    {
                        "id": 11292,
                        "name": "Cidelândia",
                        "latitude": "-5.05234000",
                        "longitude": "-47.86857000"
                    },
                    {
                        "id": 11314,
                        "name": "Codó",
                        "latitude": "-4.45528000",
                        "longitude": "-43.88556000"
                    },
                    {
                        "id": 11315,
                        "name": "Coelho Neto",
                        "latitude": "-4.25667000",
                        "longitude": "-43.01278000"
                    },
                    {
                        "id": 11322,
                        "name": "Colinas",
                        "latitude": "-6.02583000",
                        "longitude": "-44.24917000"
                    },
                    {
                        "id": 11359,
                        "name": "Conceição do Lago-Açu",
                        "latitude": "-3.73591000",
                        "longitude": "-44.79669000"
                    },
                    {
                        "id": 11413,
                        "name": "Coroatá",
                        "latitude": "-4.13000000",
                        "longitude": "-44.12417000"
                    },
                    {
                        "id": 11535,
                        "name": "Cururupu",
                        "latitude": "-1.82833000",
                        "longitude": "-44.86833000"
                    },
                    {
                        "id": 11565,
                        "name": "Davinópolis",
                        "latitude": "-5.57008000",
                        "longitude": "-47.30640000"
                    },
                    {
                        "id": 11633,
                        "name": "Dom Pedro",
                        "latitude": "-5.03749000",
                        "longitude": "-44.43857000"
                    },
                    {
                        "id": 11668,
                        "name": "Duque Bacelar",
                        "latitude": "-4.11143000",
                        "longitude": "-43.03176000"
                    },
                    {
                        "id": 11730,
                        "name": "Esperantinópolis",
                        "latitude": "-4.86667000",
                        "longitude": "-44.70833000"
                    },
                    {
                        "id": 11747,
                        "name": "Estreito",
                        "latitude": "-5.78333000",
                        "longitude": "-43.25000000"
                    },
                    {
                        "id": 11792,
                        "name": "Feira Nova do Maranhão",
                        "latitude": "-6.99561000",
                        "longitude": "-46.64999000"
                    },
                    {
                        "id": 11804,
                        "name": "Fernando Falcão",
                        "latitude": "-6.35293000",
                        "longitude": "-45.32810000"
                    },
                    {
                        "id": 11853,
                        "name": "Formosa da Serra Negra",
                        "latitude": "-6.69535000",
                        "longitude": "-46.19540000"
                    },
                    {
                        "id": 11866,
                        "name": "Fortaleza dos Nogueiras",
                        "latitude": "-6.86722000",
                        "longitude": "-46.02100000"
                    },
                    {
                        "id": 11869,
                        "name": "Fortuna",
                        "latitude": "-5.73333000",
                        "longitude": "-44.15833000"
                    },
                    {
                        "id": 11954,
                        "name": "Godofredo Viana",
                        "latitude": "-1.27605000",
                        "longitude": "-45.76550000"
                    },
                    {
                        "id": 11975,
                        "name": "Gonçalves Dias",
                        "latitude": "-5.15671000",
                        "longitude": "-44.28658000"
                    },
                    {
                        "id": 11978,
                        "name": "Governador Archer",
                        "latitude": "-4.98399000",
                        "longitude": "-44.20513000"
                    },
                    {
                        "id": 11982,
                        "name": "Governador Edison Lobão",
                        "latitude": "-5.74311000",
                        "longitude": "-47.32545000"
                    },
                    {
                        "id": 11983,
                        "name": "Governador Eugênio Barros",
                        "latitude": "-5.42581000",
                        "longitude": "-43.88031000"
                    },
                    {
                        "id": 11986,
                        "name": "Governador Luiz Rocha",
                        "latitude": "-5.52826000",
                        "longitude": "-44.11154000"
                    },
                    {
                        "id": 11988,
                        "name": "Governador Newton Bello",
                        "latitude": "-3.36796000",
                        "longitude": "-45.65707000"
                    },
                    {
                        "id": 11989,
                        "name": "Governador Nunes Freire",
                        "latitude": "-2.00992000",
                        "longitude": "-45.84278000"
                    },
                    {
                        "id": 12004,
                        "name": "Graça Aranha",
                        "latitude": "-5.44492000",
                        "longitude": "-44.25169000"
                    },
                    {
                        "id": 11992,
                        "name": "Grajaú",
                        "latitude": "-5.81944000",
                        "longitude": "-46.13861000"
                    },
                    {
                        "id": 12082,
                        "name": "Guimarães",
                        "latitude": "-2.11990000",
                        "longitude": "-44.63479000"
                    },
                    {
                        "id": 12112,
                        "name": "Humberto de Campos",
                        "latitude": "-2.59833000",
                        "longitude": "-43.46111000"
                    },
                    {
                        "id": 12170,
                        "name": "Icatu",
                        "latitude": "-2.77583000",
                        "longitude": "-44.06583000"
                    },
                    {
                        "id": 12185,
                        "name": "Igarapé do Meio",
                        "latitude": "-3.72514000",
                        "longitude": "-45.10975000"
                    },
                    {
                        "id": 12183,
                        "name": "Igarapé Grande",
                        "latitude": "-4.64974000",
                        "longitude": "-44.83905000"
                    },
                    {
                        "id": 12226,
                        "name": "Imperatriz",
                        "latitude": "-5.52639000",
                        "longitude": "-47.49167000"
                    },
                    {
                        "id": 12359,
                        "name": "Itaipava do Grajaú",
                        "latitude": "-5.22087000",
                        "longitude": "-45.78512000"
                    },
                    {
                        "id": 12406,
                        "name": "Itapecuru Mirim",
                        "latitude": "-3.39250000",
                        "longitude": "-44.35861000"
                    },
                    {
                        "id": 12474,
                        "name": "Itinga do Maranhão",
                        "latitude": "-4.52832000",
                        "longitude": "-47.48859000"
                    },
                    {
                        "id": 12603,
                        "name": "Jatobá",
                        "latitude": "-5.86233000",
                        "longitude": "-44.26917000"
                    },
                    {
                        "id": 12613,
                        "name": "Jenipapo dos Vieiras",
                        "latitude": "-5.50699000",
                        "longitude": "-45.54241000"
                    },
                    {
                        "id": 12662,
                        "name": "João Lisboa",
                        "latitude": "-5.22723000",
                        "longitude": "-47.18260000"
                    },
                    {
                        "id": 12648,
                        "name": "Joselândia",
                        "latitude": "-5.00747000",
                        "longitude": "-44.73158000"
                    },
                    {
                        "id": 12682,
                        "name": "Junco do Maranhão",
                        "latitude": "-1.94176000",
                        "longitude": "-46.11711000"
                    },
                    {
                        "id": 12729,
                        "name": "Lago da Pedra",
                        "latitude": "-4.28674000",
                        "longitude": "-45.23824000"
                    },
                    {
                        "id": 12730,
                        "name": "Lago do Junco",
                        "latitude": "-4.47033000",
                        "longitude": "-44.91005000"
                    },
                    {
                        "id": 12731,
                        "name": "Lago dos Rodrigues",
                        "latitude": "-4.61099000",
                        "longitude": "-44.97837000"
                    },
                    {
                        "id": 12728,
                        "name": "Lago Verde",
                        "latitude": "-3.99073000",
                        "longitude": "-44.88312000"
                    },
                    {
                        "id": 12760,
                        "name": "Lagoa do Mato",
                        "latitude": "-5.95535000",
                        "longitude": "-43.63105000"
                    },
                    {
                        "id": 12740,
                        "name": "Lagoa Grande do Maranhão",
                        "latitude": "-4.93168000",
                        "longitude": "-45.34950000"
                    },
                    {
                        "id": 12778,
                        "name": "Lajeado Novo",
                        "latitude": "-6.10634000",
                        "longitude": "-46.90224000"
                    },
                    {
                        "id": 12827,
                        "name": "Lima Campos",
                        "latitude": "-4.55295000",
                        "longitude": "-44.47986000"
                    },
                    {
                        "id": 12853,
                        "name": "Loreto",
                        "latitude": "-7.11921000",
                        "longitude": "-45.23138000"
                    },
                    {
                        "id": 12880,
                        "name": "Luís Domingues",
                        "latitude": "-1.26964000",
                        "longitude": "-45.83792000"
                    },
                    {
                        "id": 12912,
                        "name": "Magalhães de Almeida",
                        "latitude": "-3.32329000",
                        "longitude": "-42.12855000"
                    },
                    {
                        "id": 12970,
                        "name": "Maracaçumé",
                        "latitude": "-2.04278000",
                        "longitude": "-45.95917000"
                    },
                    {
                        "id": 12976,
                        "name": "Marajá do Sena",
                        "latitude": "-4.70009000",
                        "longitude": "-45.63144000"
                    },
                    {
                        "id": 12978,
                        "name": "Maranhãozinho",
                        "latitude": "-2.45247000",
                        "longitude": "-45.98846000"
                    },
                    {
                        "id": 13047,
                        "name": "Mata Roma",
                        "latitude": "-3.58219000",
                        "longitude": "-43.23178000"
                    },
                    {
                        "id": 13060,
                        "name": "Matinha",
                        "latitude": "-3.10056000",
                        "longitude": "-45.03361000"
                    },
                    {
                        "id": 13078,
                        "name": "Matões",
                        "latitude": "-5.41542000",
                        "longitude": "-43.40049000"
                    },
                    {
                        "id": 13079,
                        "name": "Matões do Norte",
                        "latitude": "-3.77876000",
                        "longitude": "-44.40753000"
                    },
                    {
                        "id": 13116,
                        "name": "Milagres do Maranhão",
                        "latitude": "-3.50554000",
                        "longitude": "-42.86468000"
                    },
                    {
                        "id": 13134,
                        "name": "Mirador",
                        "latitude": "-6.47266000",
                        "longitude": "-45.11312000"
                    },
                    {
                        "id": 13139,
                        "name": "Miranda do Norte",
                        "latitude": "-3.53142000",
                        "longitude": "-44.52685000"
                    },
                    {
                        "id": 13156,
                        "name": "Mirinzal",
                        "latitude": "-2.04774000",
                        "longitude": "-44.77403000"
                    },
                    {
                        "id": 13225,
                        "name": "Monção",
                        "latitude": "-3.53292000",
                        "longitude": "-45.30690000"
                    },
                    {
                        "id": 13219,
                        "name": "Montes Altos",
                        "latitude": "-5.83333000",
                        "longitude": "-47.06667000"
                    },
                    {
                        "id": 13251,
                        "name": "Morros",
                        "latitude": "-2.96159000",
                        "longitude": "-43.87725000"
                    },
                    {
                        "id": 13326,
                        "name": "Nina Rodrigues",
                        "latitude": "-3.46375000",
                        "longitude": "-43.77165000"
                    },
                    {
                        "id": 13369,
                        "name": "Nova Colinas",
                        "latitude": "-7.26656000",
                        "longitude": "-46.29184000"
                    },
                    {
                        "id": 13392,
                        "name": "Nova Iorque",
                        "latitude": "-6.74961000",
                        "longitude": "-44.03977000"
                    },
                    {
                        "id": 13412,
                        "name": "Nova Olinda do Maranhão",
                        "latitude": "-2.84498000",
                        "longitude": "-45.92010000"
                    },
                    {
                        "id": 13496,
                        "name": "Olho d'Água das Cunhãs",
                        "latitude": "-4.02629000",
                        "longitude": "-45.04831000"
                    },
                    {
                        "id": 13503,
                        "name": "Olinda Nova do Maranhão",
                        "latitude": "-2.99757000",
                        "longitude": "-44.96574000"
                    },
                    {
                        "id": 13742,
                        "name": "Paço do Lumiar",
                        "latitude": "-2.48019000",
                        "longitude": "-44.11054000"
                    },
                    {
                        "id": 13601,
                        "name": "Palmeirândia",
                        "latitude": "-2.65916000",
                        "longitude": "-45.06713000"
                    },
                    {
                        "id": 13629,
                        "name": "Paraibano",
                        "latitude": "-6.40952000",
                        "longitude": "-43.84714000"
                    },
                    {
                        "id": 13681,
                        "name": "Parnarama",
                        "latitude": "-5.52914000",
                        "longitude": "-43.60353000"
                    },
                    {
                        "id": 13693,
                        "name": "Passagem Franca",
                        "latitude": "-6.10747000",
                        "longitude": "-43.75355000"
                    },
                    {
                        "id": 13702,
                        "name": "Pastos Bons",
                        "latitude": "-6.76600000",
                        "longitude": "-44.24234000"
                    },
                    {
                        "id": 13724,
                        "name": "Paulino Neves",
                        "latitude": "-2.88588000",
                        "longitude": "-42.58808000"
                    },
                    {
                        "id": 13736,
                        "name": "Paulo Ramos",
                        "latitude": "-4.44876000",
                        "longitude": "-45.23758000"
                    },
                    {
                        "id": 13768,
                        "name": "Pedreiras",
                        "latitude": "-4.58272000",
                        "longitude": "-44.59924000"
                    },
                    {
                        "id": 13785,
                        "name": "Pedro do Rosário",
                        "latitude": "-2.97390000",
                        "longitude": "-45.45250000"
                    },
                    {
                        "id": 13793,
                        "name": "Penalva",
                        "latitude": "-3.29417000",
                        "longitude": "-45.17361000"
                    },
                    {
                        "id": 13808,
                        "name": "Peri Mirim",
                        "latitude": "-2.54231000",
                        "longitude": "-44.93384000"
                    },
                    {
                        "id": 13811,
                        "name": "Peritoró",
                        "latitude": "-4.44047000",
                        "longitude": "-44.28178000"
                    },
                    {
                        "id": 13849,
                        "name": "Pindaré Mirim",
                        "latitude": "-3.60833000",
                        "longitude": "-45.34333000"
                    },
                    {
                        "id": 13850,
                        "name": "Pindaré-Mirim",
                        "latitude": "-3.62515000",
                        "longitude": "-45.39384000"
                    },
                    {
                        "id": 13868,
                        "name": "Pinheiro",
                        "latitude": "-2.69907000",
                        "longitude": "-45.12244000"
                    },
                    {
                        "id": 13879,
                        "name": "Pio XII",
                        "latitude": "-3.89451000",
                        "longitude": "-45.16617000"
                    },
                    {
                        "id": 13898,
                        "name": "Pirapemas",
                        "latitude": "-3.77957000",
                        "longitude": "-44.27746000"
                    },
                    {
                        "id": 14055,
                        "name": "Poção de Pedras",
                        "latitude": "-4.78496000",
                        "longitude": "-44.91232000"
                    },
                    {
                        "id": 14007,
                        "name": "Porto Franco",
                        "latitude": "-6.34635000",
                        "longitude": "-47.07258000"
                    },
                    {
                        "id": 14016,
                        "name": "Porto Rico do Maranhão",
                        "latitude": "-1.85517000",
                        "longitude": "-44.60930000"
                    },
                    {
                        "id": 14079,
                        "name": "Presidente Dutra",
                        "latitude": "-5.30484000",
                        "longitude": "-44.50508000"
                    },
                    {
                        "id": 14084,
                        "name": "Presidente Juscelino",
                        "latitude": "-3.08609000",
                        "longitude": "-44.07739000"
                    },
                    {
                        "id": 14092,
                        "name": "Presidente Médici",
                        "latitude": "-2.38729000",
                        "longitude": "-45.84126000"
                    },
                    {
                        "id": 14096,
                        "name": "Presidente Sarney",
                        "latitude": "-2.62072000",
                        "longitude": "-45.43931000"
                    },
                    {
                        "id": 14098,
                        "name": "Presidente Vargas",
                        "latitude": "-3.42385000",
                        "longitude": "-44.01015000"
                    },
                    {
                        "id": 14104,
                        "name": "Primeira Cruz",
                        "latitude": "-2.65082000",
                        "longitude": "-43.32895000"
                    },
                    {
                        "id": 14174,
                        "name": "Raposa",
                        "latitude": "-6.51667000",
                        "longitude": "-44.18333000"
                    },
                    {
                        "id": 14220,
                        "name": "Riachão",
                        "latitude": "-7.36194000",
                        "longitude": "-46.61722000"
                    },
                    {
                        "id": 14229,
                        "name": "Ribamar Fiquene",
                        "latitude": "-5.93436000",
                        "longitude": "-47.29792000"
                    },
                    {
                        "id": 14350,
                        "name": "Rosário",
                        "latitude": "-2.96001000",
                        "longitude": "-44.17429000"
                    },
                    {
                        "id": 14408,
                        "name": "Sambaíba",
                        "latitude": "-7.61486000",
                        "longitude": "-45.67749000"
                    },
                    {
                        "id": 14463,
                        "name": "Santa Filomena do Maranhão",
                        "latitude": "-5.48267000",
                        "longitude": "-44.55176000"
                    },
                    {
                        "id": 14470,
                        "name": "Santa Helena",
                        "latitude": "-2.42660000",
                        "longitude": "-45.38362000"
                    },
                    {
                        "id": 14477,
                        "name": "Santa Inês",
                        "latitude": "-3.75659000",
                        "longitude": "-45.40393000"
                    },
                    {
                        "id": 14491,
                        "name": "Santa Luzia",
                        "latitude": "-4.18778000",
                        "longitude": "-45.87797000"
                    },
                    {
                        "id": 14496,
                        "name": "Santa Luzia do Paruá",
                        "latitude": "-2.54684000",
                        "longitude": "-45.75943000"
                    },
                    {
                        "id": 14523,
                        "name": "Santa Quitéria do Maranhão",
                        "latitude": "-3.30241000",
                        "longitude": "-42.95484000"
                    },
                    {
                        "id": 14524,
                        "name": "Santa Rita",
                        "latitude": "-3.16346000",
                        "longitude": "-44.32883000"
                    },
                    {
                        "id": 14587,
                        "name": "Santana do Maranhão",
                        "latitude": "-3.13508000",
                        "longitude": "-42.74876000"
                    },
                    {
                        "id": 14606,
                        "name": "Santo Amaro do Maranhão",
                        "latitude": "-2.62026000",
                        "longitude": "-43.16505000"
                    },
                    {
                        "id": 14642,
                        "name": "Santo Antônio dos Lopes",
                        "latitude": "-4.82567000",
                        "longitude": "-44.47506000"
                    },
                    {
                        "id": 14832,
                        "name": "São Benedito do Rio Preto",
                        "latitude": "-3.33098000",
                        "longitude": "-43.74036000"
                    },
                    {
                        "id": 14835,
                        "name": "São Bento",
                        "latitude": "-2.69583000",
                        "longitude": "-44.82139000"
                    },
                    {
                        "id": 14845,
                        "name": "São Bernardo",
                        "latitude": "-3.43614000",
                        "longitude": "-42.40555000"
                    },
                    {
                        "id": 14868,
                        "name": "São Domingos do Azeitão",
                        "latitude": "-6.85798000",
                        "longitude": "-44.58281000"
                    },
                    {
                        "id": 14871,
                        "name": "São Domingos do Maranhão",
                        "latitude": "-5.57583000",
                        "longitude": "-44.38528000"
                    },
                    {
                        "id": 14900,
                        "name": "São Félix de Balsas",
                        "latitude": "-6.94884000",
                        "longitude": "-44.83461000"
                    },
                    {
                        "id": 14890,
                        "name": "São Francisco do Brejão",
                        "latitude": "-5.13880000",
                        "longitude": "-47.34887000"
                    },
                    {
                        "id": 14894,
                        "name": "São Francisco do Maranhão",
                        "latitude": "-6.23353000",
                        "longitude": "-42.95249000"
                    },
                    {
                        "id": 15000,
                        "name": "São João Batista",
                        "latitude": "-2.95528000",
                        "longitude": "-44.80694000"
                    },
                    {
                        "id": 15028,
                        "name": "São João do Carú",
                        "latitude": "-3.55923000",
                        "longitude": "-46.39242000"
                    },
                    {
                        "id": 15037,
                        "name": "São João do Paraíso",
                        "latitude": "-6.40174000",
                        "longitude": "-46.88929000"
                    },
                    {
                        "id": 15044,
                        "name": "São João do Soter",
                        "latitude": "-4.96497000",
                        "longitude": "-43.73953000"
                    },
                    {
                        "id": 15049,
                        "name": "São João dos Patos",
                        "latitude": "-6.49500000",
                        "longitude": "-43.70222000"
                    },
                    {
                        "id": 14957,
                        "name": "São José de Ribamar",
                        "latitude": "-2.56194000",
                        "longitude": "-44.05417000"
                    },
                    {
                        "id": 14992,
                        "name": "São José dos Basílios",
                        "latitude": "-5.05917000",
                        "longitude": "-44.59458000"
                    },
                    {
                        "id": 15063,
                        "name": "São Luís",
                        "latitude": "-2.52972000",
                        "longitude": "-44.30278000"
                    },
                    {
                        "id": 15064,
                        "name": "São Luís Gonzaga do Maranhão",
                        "latitude": "-4.37871000",
                        "longitude": "-44.71595000"
                    },
                    {
                        "id": 15076,
                        "name": "São Mateus do Maranhão",
                        "latitude": "-4.04167000",
                        "longitude": "-44.47500000"
                    },
                    {
                        "id": 15112,
                        "name": "São Pedro da Água Branca",
                        "latitude": "-5.16149000",
                        "longitude": "-48.36104000"
                    },
                    {
                        "id": 15123,
                        "name": "São Pedro dos Crentes",
                        "latitude": "-6.81958000",
                        "longitude": "-46.70736000"
                    },
                    {
                        "id": 15127,
                        "name": "São Raimundo das Mangabeiras",
                        "latitude": "-7.02194000",
                        "longitude": "-45.48111000"
                    },
                    {
                        "id": 15128,
                        "name": "São Raimundo do Doca Bezerra",
                        "latitude": "-5.11025000",
                        "longitude": "-45.06894000"
                    },
                    {
                        "id": 15129,
                        "name": "São Roberto",
                        "latitude": "-4.98137000",
                        "longitude": "-44.99100000"
                    },
                    {
                        "id": 15170,
                        "name": "São Vicente Ferrer",
                        "latitude": "-2.87717000",
                        "longitude": "-44.93960000"
                    },
                    {
                        "id": 14674,
                        "name": "Satubinha",
                        "latitude": "-3.84804000",
                        "longitude": "-45.25543000"
                    },
                    {
                        "id": 14693,
                        "name": "Senador Alexandre Costa",
                        "latitude": "-5.29207000",
                        "longitude": "-43.87491000"
                    },
                    {
                        "id": 14703,
                        "name": "Senador La Rocque",
                        "latitude": "-5.42661000",
                        "longitude": "-47.17194000"
                    },
                    {
                        "id": 14745,
                        "name": "Serrano do Maranhão",
                        "latitude": "-1.85659000",
                        "longitude": "-45.08514000"
                    },
                    {
                        "id": 15176,
                        "name": "Sítio Novo",
                        "latitude": "-6.15590000",
                        "longitude": "-46.67216000"
                    },
                    {
                        "id": 14818,
                        "name": "Sucupira do Norte",
                        "latitude": "-6.46683000",
                        "longitude": "-44.28011000"
                    },
                    {
                        "id": 14819,
                        "name": "Sucupira do Riachão",
                        "latitude": "-6.46791000",
                        "longitude": "-43.49722000"
                    },
                    {
                        "id": 15258,
                        "name": "Tasso Fragoso",
                        "latitude": "-8.28599000",
                        "longitude": "-45.85295000"
                    },
                    {
                        "id": 15313,
                        "name": "Timbiras",
                        "latitude": "-4.19692000",
                        "longitude": "-43.82569000"
                    },
                    {
                        "id": 15318,
                        "name": "Timon",
                        "latitude": "-5.19778000",
                        "longitude": "-42.88047000"
                    },
                    {
                        "id": 15366,
                        "name": "Trizidela do Vale",
                        "latitude": "-4.52222000",
                        "longitude": "-44.61751000"
                    },
                    {
                        "id": 15390,
                        "name": "Tufilândia",
                        "latitude": "-3.76611000",
                        "longitude": "-45.55606000"
                    },
                    {
                        "id": 15396,
                        "name": "Tuntum",
                        "latitude": "-5.60041000",
                        "longitude": "-44.85537000"
                    },
                    {
                        "id": 15410,
                        "name": "Turiaçu",
                        "latitude": "-1.66333000",
                        "longitude": "-45.37167000"
                    },
                    {
                        "id": 15411,
                        "name": "Turilândia",
                        "latitude": "-2.12411000",
                        "longitude": "-45.34721000"
                    },
                    {
                        "id": 15422,
                        "name": "Tutóia",
                        "latitude": "-2.76194000",
                        "longitude": "-42.27444000"
                    },
                    {
                        "id": 15467,
                        "name": "Urbano Santos",
                        "latitude": "-3.37970000",
                        "longitude": "-43.38142000"
                    },
                    {
                        "id": 15512,
                        "name": "Vargem Grande",
                        "latitude": "-3.60095000",
                        "longitude": "-43.85169000"
                    },
                    {
                        "id": 15552,
                        "name": "Viana",
                        "latitude": "-3.19698000",
                        "longitude": "-45.00551000"
                    },
                    {
                        "id": 15573,
                        "name": "Vila Nova dos Martírios",
                        "latitude": "-5.06154000",
                        "longitude": "-48.06797000"
                    },
                    {
                        "id": 15603,
                        "name": "Vitória do Mearim",
                        "latitude": "-3.46222000",
                        "longitude": "-44.87056000"
                    },
                    {
                        "id": 15596,
                        "name": "Vitorino Freire",
                        "latitude": "-4.21879000",
                        "longitude": "-45.31980000"
                    },
                    {
                        "id": 15647,
                        "name": "Zé Doca",
                        "latitude": "-3.22589000",
                        "longitude": "-46.05729000"
                    }
                ]
            },
            {
                "id": 2011,
                "name": "Mato Grosso",
                "iso2": "MT",
                "latitude": "-12.68187120",
                "longitude": "-56.92109900",
                "type": "state",
                "cities": [
                    {
                        "id": 10077,
                        "name": "Acorizal",
                        "latitude": "-15.17336000",
                        "longitude": "-56.30434000"
                    },
                    {
                        "id": 15649,
                        "name": "Água Boa",
                        "latitude": "-14.13584000",
                        "longitude": "-52.49093000"
                    },
                    {
                        "id": 10150,
                        "name": "Alta Floresta",
                        "latitude": "-9.87556000",
                        "longitude": "-56.08611000"
                    },
                    {
                        "id": 10165,
                        "name": "Alto Araguaia",
                        "latitude": "-17.48438000",
                        "longitude": "-53.40594000"
                    },
                    {
                        "id": 10167,
                        "name": "Alto Boa Vista",
                        "latitude": "-11.82825000",
                        "longitude": "-51.74596000"
                    },
                    {
                        "id": 10170,
                        "name": "Alto Garças",
                        "latitude": "-16.81961000",
                        "longitude": "-53.62461000"
                    },
                    {
                        "id": 10174,
                        "name": "Alto Paraguai",
                        "latitude": "-14.76851000",
                        "longitude": "-56.72113000"
                    },
                    {
                        "id": 10184,
                        "name": "Alto Taquari",
                        "latitude": "-17.76618000",
                        "longitude": "-53.28010000"
                    },
                    {
                        "id": 10293,
                        "name": "Apiacás",
                        "latitude": "-9.03962000",
                        "longitude": "-57.75949000"
                    },
                    {
                        "id": 10319,
                        "name": "Araguaiana",
                        "latitude": "-15.73389000",
                        "longitude": "-51.83139000"
                    },
                    {
                        "id": 10320,
                        "name": "Araguainha",
                        "latitude": "-16.78427000",
                        "longitude": "-53.07981000"
                    },
                    {
                        "id": 10343,
                        "name": "Araputanga",
                        "latitude": "-15.17477000",
                        "longitude": "-58.49729000"
                    },
                    {
                        "id": 10390,
                        "name": "Arenápolis",
                        "latitude": "-14.45028000",
                        "longitude": "-56.84611000"
                    },
                    {
                        "id": 10395,
                        "name": "Aripuanã",
                        "latitude": "-9.16667000",
                        "longitude": "-60.63333000"
                    },
                    {
                        "id": 10575,
                        "name": "Barão de Melgaço",
                        "latitude": "-16.19444000",
                        "longitude": "-55.96750000"
                    },
                    {
                        "id": 10531,
                        "name": "Barra do Bugres",
                        "latitude": "-15.07250000",
                        "longitude": "-57.18111000"
                    },
                    {
                        "id": 10535,
                        "name": "Barra do Garças",
                        "latitude": "-15.89000000",
                        "longitude": "-52.25667000"
                    },
                    {
                        "id": 10709,
                        "name": "Bom Jesus do Araguaia",
                        "latitude": "-12.27879000",
                        "longitude": "-51.75156000"
                    },
                    {
                        "id": 10775,
                        "name": "Brasnorte",
                        "latitude": "-12.24899000",
                        "longitude": "-58.00289000"
                    },
                    {
                        "id": 11542,
                        "name": "Cáceres",
                        "latitude": "-16.42263000",
                        "longitude": "-57.71082000"
                    },
                    {
                        "id": 10975,
                        "name": "Campinápolis",
                        "latitude": "-14.30712000",
                        "longitude": "-53.15586000"
                    },
                    {
                        "id": 11001,
                        "name": "Campo Novo do Parecis",
                        "latitude": "-13.62657000",
                        "longitude": "-58.02125000"
                    },
                    {
                        "id": 11004,
                        "name": "Campo Verde",
                        "latitude": "-15.37926000",
                        "longitude": "-54.92950000"
                    },
                    {
                        "id": 11017,
                        "name": "Campos de Júlio",
                        "latitude": "-13.63297000",
                        "longitude": "-59.17849000"
                    },
                    {
                        "id": 11022,
                        "name": "CanaBrava do Norte",
                        "latitude": "-11.18113000",
                        "longitude": "-51.86378000"
                    },
                    {
                        "id": 11026,
                        "name": "Canarana",
                        "latitude": "-13.17747000",
                        "longitude": "-52.37104000"
                    },
                    {
                        "id": 11137,
                        "name": "Carlinda",
                        "latitude": "-10.03792000",
                        "longitude": "-55.85086000"
                    },
                    {
                        "id": 11185,
                        "name": "Castanheira",
                        "latitude": "-10.87932000",
                        "longitude": "-58.65100000"
                    },
                    {
                        "id": 11264,
                        "name": "Chapada dos Guimarães",
                        "latitude": "-15.02015000",
                        "longitude": "-55.53735000"
                    },
                    {
                        "id": 11301,
                        "name": "Cláudia",
                        "latitude": "-11.45086000",
                        "longitude": "-54.99828000"
                    },
                    {
                        "id": 11310,
                        "name": "Cocalinho",
                        "latitude": "-13.80273000",
                        "longitude": "-51.15344000"
                    },
                    {
                        "id": 11333,
                        "name": "Colíder",
                        "latitude": "-10.56333000",
                        "longitude": "-55.44573000"
                    },
                    {
                        "id": 11327,
                        "name": "Colniza",
                        "latitude": "-9.29188000",
                        "longitude": "-60.30457000"
                    },
                    {
                        "id": 11343,
                        "name": "Comodoro",
                        "latitude": "-13.32583000",
                        "longitude": "-59.82145000"
                    },
                    {
                        "id": 11376,
                        "name": "Confresa",
                        "latitude": "-10.30959000",
                        "longitude": "-51.73651000"
                    },
                    {
                        "id": 11383,
                        "name": "Conquista D'oeste",
                        "latitude": "-14.61506000",
                        "longitude": "-59.26741000"
                    },
                    {
                        "id": 11454,
                        "name": "Cotriguaçu",
                        "latitude": "-9.50334000",
                        "longitude": "-58.79134000"
                    },
                    {
                        "id": 11507,
                        "name": "Cuiabá",
                        "latitude": "-15.41924000",
                        "longitude": "-55.89023000"
                    },
                    {
                        "id": 11539,
                        "name": "Curvelândia",
                        "latitude": "-15.63715000",
                        "longitude": "-57.84548000"
                    },
                    {
                        "id": 11572,
                        "name": "Denise",
                        "latitude": "-14.75742000",
                        "longitude": "-56.95115000"
                    },
                    {
                        "id": 11589,
                        "name": "Diamantino",
                        "latitude": "-14.02239000",
                        "longitude": "-56.77742000"
                    },
                    {
                        "id": 11622,
                        "name": "Dom Aquino",
                        "latitude": "-15.72098000",
                        "longitude": "-54.83043000"
                    },
                    {
                        "id": 11800,
                        "name": "Feliz Natal",
                        "latitude": "-11.93599000",
                        "longitude": "-54.23925000"
                    },
                    {
                        "id": 11819,
                        "name": "Figueirópolis d'Oeste",
                        "latitude": "-15.48700000",
                        "longitude": "-58.69723000"
                    },
                    {
                        "id": 11932,
                        "name": "Gaúcha do Norte",
                        "latitude": "-12.99365000",
                        "longitude": "-53.52264000"
                    },
                    {
                        "id": 11935,
                        "name": "General Carneiro",
                        "latitude": "-15.51539000",
                        "longitude": "-53.29790000"
                    },
                    {
                        "id": 11951,
                        "name": "Glória d'Oeste",
                        "latitude": "-15.91309000",
                        "longitude": "-58.30449000"
                    },
                    {
                        "id": 12049,
                        "name": "Guarantã do Norte",
                        "latitude": "-9.75597000",
                        "longitude": "-54.72890000"
                    },
                    {
                        "id": 12083,
                        "name": "Guiratinga",
                        "latitude": "-16.34534000",
                        "longitude": "-53.76177000"
                    },
                    {
                        "id": 12242,
                        "name": "Indiavaí",
                        "latitude": "-15.31484000",
                        "longitude": "-58.62960000"
                    },
                    {
                        "id": 12277,
                        "name": "Ipiranga do Norte",
                        "latitude": "-12.24000000",
                        "longitude": "-56.14000000"
                    },
                    {
                        "id": 12391,
                        "name": "Itanhangá",
                        "latitude": "-12.17000000",
                        "longitude": "-56.68000000"
                    },
                    {
                        "id": 12470,
                        "name": "Itaúba",
                        "latitude": "-11.09537000",
                        "longitude": "-55.58848000"
                    },
                    {
                        "id": 12475,
                        "name": "Itiquira",
                        "latitude": "-17.39441000",
                        "longitude": "-54.76988000"
                    },
                    {
                        "id": 12524,
                        "name": "Jaciara",
                        "latitude": "-15.96528000",
                        "longitude": "-54.96833000"
                    },
                    {
                        "id": 12562,
                        "name": "Jangada",
                        "latitude": "-15.33758000",
                        "longitude": "-56.54282000"
                    },
                    {
                        "id": 12606,
                        "name": "Jauru",
                        "latitude": "-15.32452000",
                        "longitude": "-58.84580000"
                    },
                    {
                        "id": 12668,
                        "name": "Juara",
                        "latitude": "-11.09828000",
                        "longitude": "-57.49159000"
                    },
                    {
                        "id": 12715,
                        "name": "Juína",
                        "latitude": "-11.40329000",
                        "longitude": "-59.50810000"
                    },
                    {
                        "id": 12701,
                        "name": "Juruena",
                        "latitude": "-10.28992000",
                        "longitude": "-58.65303000"
                    },
                    {
                        "id": 12704,
                        "name": "Juscimeira",
                        "latitude": "-16.20525000",
                        "longitude": "-54.88029000"
                    },
                    {
                        "id": 12789,
                        "name": "Lambari d'Oeste",
                        "latitude": "-15.65457000",
                        "longitude": "-57.78813000"
                    },
                    {
                        "id": 12856,
                        "name": "Lucas",
                        "latitude": "-16.33333000",
                        "longitude": "-55.93333000"
                    },
                    {
                        "id": 12857,
                        "name": "Lucas do Rio Verde",
                        "latitude": "-13.04098000",
                        "longitude": "-56.15577000"
                    },
                    {
                        "id": 12860,
                        "name": "Luciara",
                        "latitude": "-11.01415000",
                        "longitude": "-50.94299000"
                    },
                    {
                        "id": 12993,
                        "name": "Marcelândia",
                        "latitude": "-11.00372000",
                        "longitude": "-54.13318000"
                    },
                    {
                        "id": 13074,
                        "name": "Matupá",
                        "latitude": "-10.01532000",
                        "longitude": "-54.35496000"
                    },
                    {
                        "id": 13150,
                        "name": "Mirassol d'Oeste",
                        "latitude": "-15.63523000",
                        "longitude": "-58.00508000"
                    },
                    {
                        "id": 13332,
                        "name": "Nobres",
                        "latitude": "-14.72028000",
                        "longitude": "-56.32750000"
                    },
                    {
                        "id": 13335,
                        "name": "Nortelândia",
                        "latitude": "-14.45472000",
                        "longitude": "-56.80278000"
                    },
                    {
                        "id": 13342,
                        "name": "Nossa Senhora do Livramento",
                        "latitude": "-15.93447000",
                        "longitude": "-56.54590000"
                    },
                    {
                        "id": 13355,
                        "name": "Nova Bandeirantes",
                        "latitude": "-9.68571000",
                        "longitude": "-58.01840000"
                    },
                    {
                        "id": 13359,
                        "name": "Nova Brasilândia",
                        "latitude": "-14.75742000",
                        "longitude": "-55.10534000"
                    },
                    {
                        "id": 13365,
                        "name": "Nova Canaã do Norte",
                        "latitude": "-10.71987000",
                        "longitude": "-56.03436000"
                    },
                    {
                        "id": 13385,
                        "name": "Nova Guarita",
                        "latitude": "-10.28525000",
                        "longitude": "-55.33730000"
                    },
                    {
                        "id": 13396,
                        "name": "Nova Lacerda",
                        "latitude": "-14.26732000",
                        "longitude": "-59.79280000"
                    },
                    {
                        "id": 13402,
                        "name": "Nova Marilândia",
                        "latitude": "-14.31258000",
                        "longitude": "-57.26088000"
                    },
                    {
                        "id": 13403,
                        "name": "Nova Maringá",
                        "latitude": "-12.98384000",
                        "longitude": "-57.19167000"
                    },
                    {
                        "id": 13404,
                        "name": "Nova Monte Verde",
                        "latitude": "-9.99743000",
                        "longitude": "-57.29768000"
                    },
                    {
                        "id": 13405,
                        "name": "Nova Mutum",
                        "latitude": "-13.58906000",
                        "longitude": "-56.15193000"
                    },
                    {
                        "id": 13407,
                        "name": "Nova Nazaré",
                        "latitude": "-14.14648000",
                        "longitude": "-51.79821000"
                    },
                    {
                        "id": 13414,
                        "name": "Nova Olímpia",
                        "latitude": "-14.79722000",
                        "longitude": "-57.28806000"
                    },
                    {
                        "id": 13432,
                        "name": "Nova Santa Helena",
                        "latitude": "-10.92036000",
                        "longitude": "-54.90636000"
                    },
                    {
                        "id": 13441,
                        "name": "Nova Ubiratã",
                        "latitude": "-12.68233000",
                        "longitude": "-54.47729000"
                    },
                    {
                        "id": 13448,
                        "name": "Nova Xavantina",
                        "latitude": "-14.66463000",
                        "longitude": "-52.35558000"
                    },
                    {
                        "id": 13463,
                        "name": "Novo Horizonte do Norte",
                        "latitude": "-11.37917000",
                        "longitude": "-57.28359000"
                    },
                    {
                        "id": 13470,
                        "name": "Novo Mundo",
                        "latitude": "-9.83661000",
                        "longitude": "-55.31349000"
                    },
                    {
                        "id": 13478,
                        "name": "Novo Santo Antônio",
                        "latitude": "-12.32606000",
                        "longitude": "-50.91431000"
                    },
                    {
                        "id": 13479,
                        "name": "Novo São Joaquim",
                        "latitude": "-15.09570000",
                        "longitude": "-53.29575000"
                    },
                    {
                        "id": 13646,
                        "name": "Paranaíta",
                        "latitude": "-9.56371000",
                        "longitude": "-56.76536000"
                    },
                    {
                        "id": 13643,
                        "name": "Paranatinga",
                        "latitude": "-13.34326000",
                        "longitude": "-54.01552000"
                    },
                    {
                        "id": 13757,
                        "name": "Pedra Preta",
                        "latitude": "-16.76381000",
                        "longitude": "-54.16343000"
                    },
                    {
                        "id": 13789,
                        "name": "Peixoto de Azevedo",
                        "latitude": "-10.14722000",
                        "longitude": "-53.58639000"
                    },
                    {
                        "id": 13942,
                        "name": "Planalto da Serra",
                        "latitude": "-14.56524000",
                        "longitude": "-54.67771000"
                    },
                    {
                        "id": 13947,
                        "name": "Poconé",
                        "latitude": "-16.25667000",
                        "longitude": "-56.62278000"
                    },
                    {
                        "id": 13961,
                        "name": "Pontal do Araguaia",
                        "latitude": "-15.96755000",
                        "longitude": "-52.75421000"
                    },
                    {
                        "id": 13969,
                        "name": "Ponte Branca",
                        "latitude": "-16.65050000",
                        "longitude": "-52.90238000"
                    },
                    {
                        "id": 13974,
                        "name": "Pontes e Lacerda",
                        "latitude": "-15.22611000",
                        "longitude": "-59.33528000"
                    },
                    {
                        "id": 13995,
                        "name": "Porto Alegre do Norte",
                        "latitude": "-10.85081000",
                        "longitude": "-51.76934000"
                    },
                    {
                        "id": 14028,
                        "name": "Porto dos Gaúchos",
                        "latitude": "-11.76043000",
                        "longitude": "-56.85721000"
                    },
                    {
                        "id": 14002,
                        "name": "Porto Esperidião",
                        "latitude": "-15.88622000",
                        "longitude": "-58.97107000"
                    },
                    {
                        "id": 14003,
                        "name": "Porto Estrela",
                        "latitude": "-15.51966000",
                        "longitude": "-57.22942000"
                    },
                    {
                        "id": 14042,
                        "name": "Poxoréo",
                        "latitude": "-15.83722000",
                        "longitude": "-54.38917000"
                    },
                    {
                        "id": 14043,
                        "name": "Poxoréu",
                        "latitude": "-15.75635000",
                        "longitude": "-54.11866000"
                    },
                    {
                        "id": 14103,
                        "name": "Primavera do Leste",
                        "latitude": "-15.14064000",
                        "longitude": "-54.19501000"
                    },
                    {
                        "id": 14145,
                        "name": "Querência",
                        "latitude": "-12.32120000",
                        "longitude": "-52.54760000"
                    },
                    {
                        "id": 14200,
                        "name": "Reserva do Cabaçal",
                        "latitude": "-14.92946000",
                        "longitude": "-58.45849000"
                    },
                    {
                        "id": 14239,
                        "name": "Ribeirão Cascalheira",
                        "latitude": "-12.73516000",
                        "longitude": "-51.71456000"
                    },
                    {
                        "id": 14252,
                        "name": "Ribeirãozinho",
                        "latitude": "-16.50143000",
                        "longitude": "-52.75910000"
                    },
                    {
                        "id": 14264,
                        "name": "Rio Branco",
                        "latitude": "-15.31117000",
                        "longitude": "-58.12450000"
                    },
                    {
                        "id": 14343,
                        "name": "Rondolândia",
                        "latitude": "-10.27573000",
                        "longitude": "-61.06224000"
                    },
                    {
                        "id": 14346,
                        "name": "Rondonópolis",
                        "latitude": "-16.47083000",
                        "longitude": "-54.63556000"
                    },
                    {
                        "id": 14351,
                        "name": "Rosário Oeste",
                        "latitude": "-14.83611000",
                        "longitude": "-56.42750000"
                    },
                    {
                        "id": 14400,
                        "name": "Salto do Céu",
                        "latitude": "-15.13439000",
                        "longitude": "-57.95902000"
                    },
                    {
                        "id": 14431,
                        "name": "Santa Carmem",
                        "latitude": "-11.90602000",
                        "longitude": "-54.80769000"
                    },
                    {
                        "id": 14457,
                        "name": "Santa Cruz do Xingu",
                        "latitude": "-10.15595000",
                        "longitude": "-52.49799000"
                    },
                    {
                        "id": 14539,
                        "name": "Santa Rita do Trivelato",
                        "latitude": "-13.71416000",
                        "longitude": "-55.40171000"
                    },
                    {
                        "id": 14560,
                        "name": "Santa Terezinha",
                        "latitude": "-10.39138000",
                        "longitude": "-50.83261000"
                    },
                    {
                        "id": 14602,
                        "name": "Santo Afonso",
                        "latitude": "-14.46134000",
                        "longitude": "-57.38575000"
                    },
                    {
                        "id": 14631,
                        "name": "Santo Antônio do Leste",
                        "latitude": "-14.82454000",
                        "longitude": "-53.74136000"
                    },
                    {
                        "id": 14632,
                        "name": "Santo Antônio do Leverger",
                        "latitude": "-16.78576000",
                        "longitude": "-55.31327000"
                    },
                    {
                        "id": 14902,
                        "name": "São Félix do Araguaia",
                        "latitude": "-11.44230000",
                        "longitude": "-52.13916000"
                    },
                    {
                        "id": 14982,
                        "name": "São José do Povo",
                        "latitude": "-16.44547000",
                        "longitude": "-54.28499000"
                    },
                    {
                        "id": 14983,
                        "name": "São José do Rio Claro",
                        "latitude": "-13.52704000",
                        "longitude": "-56.85065000"
                    },
                    {
                        "id": 14990,
                        "name": "São José do Xingu",
                        "latitude": "-10.72794000",
                        "longitude": "-52.62112000"
                    },
                    {
                        "id": 14996,
                        "name": "São José dos Quatro Marcos",
                        "latitude": "-15.56664000",
                        "longitude": "-58.29717000"
                    },
                    {
                        "id": 15109,
                        "name": "São Pedro da Cipa",
                        "latitude": "-15.95162000",
                        "longitude": "-54.77958000"
                    },
                    {
                        "id": 14657,
                        "name": "Sapezal",
                        "latitude": "-13.16448000",
                        "longitude": "-58.68788000"
                    },
                    {
                        "id": 14731,
                        "name": "Serra Nova Dourada",
                        "latitude": "-12.02901000",
                        "longitude": "-51.33412000"
                    },
                    {
                        "id": 14791,
                        "name": "Sinop",
                        "latitude": "-11.86417000",
                        "longitude": "-55.50250000"
                    },
                    {
                        "id": 14812,
                        "name": "Sorriso",
                        "latitude": "-12.68167000",
                        "longitude": "-55.69953000"
                    },
                    {
                        "id": 15182,
                        "name": "Tabaporã",
                        "latitude": "-11.05295000",
                        "longitude": "-56.64189000"
                    },
                    {
                        "id": 15217,
                        "name": "Tangará da Serra",
                        "latitude": "-14.52323000",
                        "longitude": "-58.09862000"
                    },
                    {
                        "id": 15239,
                        "name": "Tapurah",
                        "latitude": "-12.74260000",
                        "longitude": "-56.46149000"
                    },
                    {
                        "id": 15293,
                        "name": "Terra Nova do Norte",
                        "latitude": "-10.49541000",
                        "longitude": "-54.95547000"
                    },
                    {
                        "id": 15299,
                        "name": "Tesouro",
                        "latitude": "-15.94904000",
                        "longitude": "-53.43342000"
                    },
                    {
                        "id": 15338,
                        "name": "Torixoréu",
                        "latitude": "-16.27591000",
                        "longitude": "-52.88117000"
                    },
                    {
                        "id": 15462,
                        "name": "União do Sul",
                        "latitude": "-11.47198000",
                        "longitude": "-54.18806000"
                    },
                    {
                        "id": 15493,
                        "name": "Vale de São Domingos",
                        "latitude": "-14.97590000",
                        "longitude": "-58.96377000"
                    },
                    {
                        "id": 15618,
                        "name": "Várzea Grande",
                        "latitude": "-15.56582000",
                        "longitude": "-56.24391000"
                    },
                    {
                        "id": 15531,
                        "name": "Vera",
                        "latitude": "-12.46612000",
                        "longitude": "-55.34810000"
                    },
                    {
                        "id": 15565,
                        "name": "Vila Bela da Santíssima Trindade",
                        "latitude": "-14.89148000",
                        "longitude": "-60.05777000"
                    },
                    {
                        "id": 15576,
                        "name": "Vila Rica",
                        "latitude": "-10.13413000",
                        "longitude": "-51.41369000"
                    }
                ]
            },
            {
                "id": 2010,
                "name": "Mato Grosso do Sul",
                "iso2": "MS",
                "latitude": "-20.77222950",
                "longitude": "-54.78515310",
                "type": "state",
                "cities": [
                    {
                        "id": 15654,
                        "name": "Água Clara",
                        "latitude": "-19.89787000",
                        "longitude": "-52.95089000"
                    },
                    {
                        "id": 10117,
                        "name": "Alcinópolis",
                        "latitude": "-18.19955000",
                        "longitude": "-53.75814000"
                    },
                    {
                        "id": 10202,
                        "name": "Amambai",
                        "latitude": "-23.12710000",
                        "longitude": "-54.95790000"
                    },
                    {
                        "id": 10238,
                        "name": "Anastácio",
                        "latitude": "-20.76269000",
                        "longitude": "-55.73052000"
                    },
                    {
                        "id": 10239,
                        "name": "Anaurilândia",
                        "latitude": "-22.14199000",
                        "longitude": "-52.72011000"
                    },
                    {
                        "id": 10259,
                        "name": "Angélica",
                        "latitude": "-22.02780000",
                        "longitude": "-53.86668000"
                    },
                    {
                        "id": 10277,
                        "name": "Antônio João",
                        "latitude": "-22.20114000",
                        "longitude": "-55.93897000"
                    },
                    {
                        "id": 10290,
                        "name": "Aparecida do Taboado",
                        "latitude": "-20.00909000",
                        "longitude": "-51.34632000"
                    },
                    {
                        "id": 10305,
                        "name": "Aquidauana",
                        "latitude": "-20.45790000",
                        "longitude": "-55.83801000"
                    },
                    {
                        "id": 10329,
                        "name": "Aral Moreira",
                        "latitude": "-22.90946000",
                        "longitude": "-55.37007000"
                    },
                    {
                        "id": 10501,
                        "name": "Bandeirantes",
                        "latitude": "-19.80863000",
                        "longitude": "-54.33095000"
                    },
                    {
                        "id": 10579,
                        "name": "Bataguassu",
                        "latitude": "-21.78550000",
                        "longitude": "-52.56542000"
                    },
                    {
                        "id": 10580,
                        "name": "Bataiporã",
                        "latitude": "-22.29528000",
                        "longitude": "-53.27111000"
                    },
                    {
                        "id": 10584,
                        "name": "Batayporã",
                        "latitude": "-22.46496000",
                        "longitude": "-53.17683000"
                    },
                    {
                        "id": 10594,
                        "name": "Bela Vista",
                        "latitude": "-22.10889000",
                        "longitude": "-56.52111000"
                    },
                    {
                        "id": 10686,
                        "name": "Bodoquena",
                        "latitude": "-20.48226000",
                        "longitude": "-56.65893000"
                    },
                    {
                        "id": 10737,
                        "name": "Bonito",
                        "latitude": "-21.12111000",
                        "longitude": "-56.48194000"
                    },
                    {
                        "id": 10770,
                        "name": "Brasilândia",
                        "latitude": "-21.11993000",
                        "longitude": "-52.43829000"
                    },
                    {
                        "id": 10843,
                        "name": "Caarapó",
                        "latitude": "-22.63417000",
                        "longitude": "-54.82222000"
                    },
                    {
                        "id": 10939,
                        "name": "Camapuã",
                        "latitude": "-19.05769000",
                        "longitude": "-53.85781000"
                    },
                    {
                        "id": 10989,
                        "name": "Campo Grande",
                        "latitude": "-20.44278000",
                        "longitude": "-54.64639000"
                    },
                    {
                        "id": 11003,
                        "name": "Campo Verde",
                        "latitude": "-20.41667000",
                        "longitude": "-54.06667000"
                    },
                    {
                        "id": 11102,
                        "name": "Caracol",
                        "latitude": "-21.96712000",
                        "longitude": "-57.12672000"
                    },
                    {
                        "id": 11183,
                        "name": "Cassilândia",
                        "latitude": "-19.11333000",
                        "longitude": "-51.73417000"
                    },
                    {
                        "id": 11268,
                        "name": "Chapadão do Sul",
                        "latitude": "-19.06696000",
                        "longitude": "-52.74056000"
                    },
                    {
                        "id": 11407,
                        "name": "Corguinho",
                        "latitude": "-19.81861000",
                        "longitude": "-55.00199000"
                    },
                    {
                        "id": 11429,
                        "name": "Coronel Sapucaia",
                        "latitude": "-23.33759000",
                        "longitude": "-55.38899000"
                    },
                    {
                        "id": 11442,
                        "name": "Corumbá",
                        "latitude": "-19.00917000",
                        "longitude": "-57.65333000"
                    },
                    {
                        "id": 11449,
                        "name": "Costa Rica",
                        "latitude": "-18.63739000",
                        "longitude": "-53.27361000"
                    },
                    {
                        "id": 11458,
                        "name": "Coxim",
                        "latitude": "-18.50667000",
                        "longitude": "-54.76000000"
                    },
                    {
                        "id": 11573,
                        "name": "Deodápolis",
                        "latitude": "-22.08040000",
                        "longitude": "-54.20322000"
                    },
                    {
                        "id": 11616,
                        "name": "Dois Irmãos do Buriti",
                        "latitude": "-20.57189000",
                        "longitude": "-55.36839000"
                    },
                    {
                        "id": 11651,
                        "name": "Douradina",
                        "latitude": "-21.98525000",
                        "longitude": "-54.58145000"
                    },
                    {
                        "id": 11654,
                        "name": "Dourados",
                        "latitude": "-22.22111000",
                        "longitude": "-54.80556000"
                    },
                    {
                        "id": 11677,
                        "name": "Eldorado",
                        "latitude": "-23.78694000",
                        "longitude": "-54.28361000"
                    },
                    {
                        "id": 11908,
                        "name": "Fátima do Sul",
                        "latitude": "-22.34424000",
                        "longitude": "-54.37064000"
                    },
                    {
                        "id": 11817,
                        "name": "Figueirão",
                        "latitude": "-18.67500000",
                        "longitude": "-53.64250000"
                    },
                    {
                        "id": 11952,
                        "name": "Glória de Dourados",
                        "latitude": "-22.48388000",
                        "longitude": "-54.09006000"
                    },
                    {
                        "id": 12079,
                        "name": "Guia Lopes da Laguna",
                        "latitude": "-21.61081000",
                        "longitude": "-55.93458000"
                    },
                    {
                        "id": 12200,
                        "name": "Iguatemi",
                        "latitude": "-23.42596000",
                        "longitude": "-54.55844000"
                    },
                    {
                        "id": 12255,
                        "name": "Inocência",
                        "latitude": "-19.67150000",
                        "longitude": "-52.04393000"
                    },
                    {
                        "id": 12433,
                        "name": "Itaporã",
                        "latitude": "-21.92184000",
                        "longitude": "-54.81409000"
                    },
                    {
                        "id": 12445,
                        "name": "Itaquiraí",
                        "latitude": "-23.47080000",
                        "longitude": "-54.19281000"
                    },
                    {
                        "id": 12502,
                        "name": "Ivinhema",
                        "latitude": "-22.38076000",
                        "longitude": "-53.75565000"
                    },
                    {
                        "id": 12574,
                        "name": "Japorã",
                        "latitude": "-23.79410000",
                        "longitude": "-54.54402000"
                    },
                    {
                        "id": 12579,
                        "name": "Jaraguari",
                        "latitude": "-20.27238000",
                        "longitude": "-54.23743000"
                    },
                    {
                        "id": 12583,
                        "name": "Jardim",
                        "latitude": "-21.48028000",
                        "longitude": "-56.13806000"
                    },
                    {
                        "id": 12600,
                        "name": "Jateí",
                        "latitude": "-22.73989000",
                        "longitude": "-53.81496000"
                    },
                    {
                        "id": 12711,
                        "name": "Juti",
                        "latitude": "-22.85356000",
                        "longitude": "-54.52155000"
                    },
                    {
                        "id": 12723,
                        "name": "Ladário",
                        "latitude": "-19.10505000",
                        "longitude": "-57.58416000"
                    },
                    {
                        "id": 12772,
                        "name": "Laguna Carapã",
                        "latitude": "-22.71043000",
                        "longitude": "-55.08248000"
                    },
                    {
                        "id": 12966,
                        "name": "Maracaju",
                        "latitude": "-21.61444000",
                        "longitude": "-55.16833000"
                    },
                    {
                        "id": 13138,
                        "name": "Miranda",
                        "latitude": "-20.24056000",
                        "longitude": "-56.37833000"
                    },
                    {
                        "id": 13270,
                        "name": "Mundo Novo",
                        "latitude": "-23.92628000",
                        "longitude": "-54.25746000"
                    },
                    {
                        "id": 13307,
                        "name": "Naviraí",
                        "latitude": "-23.06500000",
                        "longitude": "-54.19056000"
                    },
                    {
                        "id": 13328,
                        "name": "Nioaque",
                        "latitude": "-21.18151000",
                        "longitude": "-55.75856000"
                    },
                    {
                        "id": 13348,
                        "name": "Nova Alvorada do Sul",
                        "latitude": "-21.48079000",
                        "longitude": "-54.15260000"
                    },
                    {
                        "id": 13351,
                        "name": "Nova Andradina",
                        "latitude": "-21.88205000",
                        "longitude": "-53.46637000"
                    },
                    {
                        "id": 13465,
                        "name": "Novo Horizonte do Sul",
                        "latitude": "-22.63068000",
                        "longitude": "-53.73643000"
                    },
                    {
                        "id": 13661,
                        "name": "Paraíso das Águas",
                        "latitude": "-19.01750000",
                        "longitude": "-53.01222000"
                    },
                    {
                        "id": 13645,
                        "name": "Paranaíba",
                        "latitude": "-19.67722000",
                        "longitude": "-51.19083000"
                    },
                    {
                        "id": 13647,
                        "name": "Paranhos",
                        "latitude": "-23.89278000",
                        "longitude": "-55.43111000"
                    },
                    {
                        "id": 13776,
                        "name": "Pedro Gomes",
                        "latitude": "-17.83882000",
                        "longitude": "-54.12943000"
                    },
                    {
                        "id": 13958,
                        "name": "Ponta Porã",
                        "latitude": "-22.53611000",
                        "longitude": "-55.72556000"
                    },
                    {
                        "id": 14123,
                        "name": "Pôrto Barra do Ivinheima",
                        "latitude": "-22.96667000",
                        "longitude": "-53.66667000"
                    },
                    {
                        "id": 14011,
                        "name": "Porto Murtinho",
                        "latitude": "-21.69889000",
                        "longitude": "-57.88250000"
                    },
                    {
                        "id": 14230,
                        "name": "Ribas do Rio Pardo",
                        "latitude": "-20.44306000",
                        "longitude": "-53.75917000"
                    },
                    {
                        "id": 14267,
                        "name": "Rio Brilhante",
                        "latitude": "-21.80194000",
                        "longitude": "-54.54639000"
                    },
                    {
                        "id": 14284,
                        "name": "Rio Negro",
                        "latitude": "-19.44620000",
                        "longitude": "-54.97947000"
                    },
                    {
                        "id": 14301,
                        "name": "Rio Verde de Mato Grosso",
                        "latitude": "-18.91806000",
                        "longitude": "-54.84417000"
                    },
                    {
                        "id": 14326,
                        "name": "Rochedo",
                        "latitude": "-19.98799000",
                        "longitude": "-54.78184000"
                    },
                    {
                        "id": 14535,
                        "name": "Santa Rita do Pardo",
                        "latitude": "-21.35479000",
                        "longitude": "-52.69315000"
                    },
                    {
                        "id": 14911,
                        "name": "São Gabriel do Oeste",
                        "latitude": "-19.13170000",
                        "longitude": "-54.44865000"
                    },
                    {
                        "id": 14690,
                        "name": "Selvíria",
                        "latitude": "-20.24958000",
                        "longitude": "-51.83228000"
                    },
                    {
                        "id": 14766,
                        "name": "Sete Quedas",
                        "latitude": "-23.88066000",
                        "longitude": "-55.02727000"
                    },
                    {
                        "id": 14773,
                        "name": "Sidrolândia",
                        "latitude": "-20.93194000",
                        "longitude": "-54.96139000"
                    },
                    {
                        "id": 14809,
                        "name": "Sonora",
                        "latitude": "-17.67403000",
                        "longitude": "-54.45326000"
                    },
                    {
                        "id": 15197,
                        "name": "Tacuru",
                        "latitude": "-23.68722000",
                        "longitude": "-54.91099000"
                    },
                    {
                        "id": 15250,
                        "name": "Taquarussu",
                        "latitude": "-22.73419000",
                        "longitude": "-53.48002000"
                    },
                    {
                        "id": 15283,
                        "name": "Terenos",
                        "latitude": "-20.42068000",
                        "longitude": "-55.10602000"
                    },
                    {
                        "id": 15377,
                        "name": "Três Lagoas",
                        "latitude": "-20.37964000",
                        "longitude": "-52.25961000"
                    },
                    {
                        "id": 15556,
                        "name": "Vicentina",
                        "latitude": "-22.49155000",
                        "longitude": "-54.46183000"
                    }
                ]
            },
            {
                "id": 1998,
                "name": "Minas Gerais",
                "iso2": "MG",
                "latitude": "-18.51217800",
                "longitude": "-44.55503080",
                "type": "state",
                "cities": [
                    {
                        "id": 10054,
                        "name": "Abadia dos Dourados",
                        "latitude": "-18.36347000",
                        "longitude": "-47.46997000"
                    },
                    {
                        "id": 10057,
                        "name": "Abaeté",
                        "latitude": "-19.11099000",
                        "longitude": "-45.43051000"
                    },
                    {
                        "id": 10065,
                        "name": "Abre Campo",
                        "latitude": "-20.27265000",
                        "longitude": "-42.43908000"
                    },
                    {
                        "id": 10068,
                        "name": "Acaiaca",
                        "latitude": "-20.40360000",
                        "longitude": "-43.10077000"
                    },
                    {
                        "id": 10465,
                        "name": "Açucena",
                        "latitude": "-19.07306000",
                        "longitude": "-42.54639000"
                    },
                    {
                        "id": 15650,
                        "name": "Água Boa",
                        "latitude": "-18.06423000",
                        "longitude": "-42.23027000"
                    },
                    {
                        "id": 15655,
                        "name": "Água Comprida",
                        "latitude": "-19.99124000",
                        "longitude": "-48.11035000"
                    },
                    {
                        "id": 10095,
                        "name": "Aguanil",
                        "latitude": "-20.96959000",
                        "longitude": "-45.41717000"
                    },
                    {
                        "id": 15666,
                        "name": "Águas Formosas",
                        "latitude": "-17.08222000",
                        "longitude": "-40.93583000"
                    },
                    {
                        "id": 15670,
                        "name": "Águas Vermelhas",
                        "latitude": "-15.74722000",
                        "longitude": "-41.46000000"
                    },
                    {
                        "id": 10102,
                        "name": "Aimorés",
                        "latitude": "-19.62552000",
                        "longitude": "-41.20955000"
                    },
                    {
                        "id": 10105,
                        "name": "Aiuruoca",
                        "latitude": "-21.94703000",
                        "longitude": "-44.64779000"
                    },
                    {
                        "id": 10107,
                        "name": "Alagoa",
                        "latitude": "-22.18147000",
                        "longitude": "-44.66024000"
                    },
                    {
                        "id": 10115,
                        "name": "Albertina",
                        "latitude": "-22.19908000",
                        "longitude": "-46.62076000"
                    },
                    {
                        "id": 10201,
                        "name": "Além Paraíba",
                        "latitude": "-21.80936000",
                        "longitude": "-42.75740000"
                    },
                    {
                        "id": 10130,
                        "name": "Alfenas",
                        "latitude": "-21.39287000",
                        "longitude": "-45.99521000"
                    },
                    {
                        "id": 10133,
                        "name": "Alfredo Vasconcelos",
                        "latitude": "-21.14240000",
                        "longitude": "-43.71114000"
                    },
                    {
                        "id": 10142,
                        "name": "Almenara",
                        "latitude": "-16.10053000",
                        "longitude": "-40.71006000"
                    },
                    {
                        "id": 10147,
                        "name": "Alpercata",
                        "latitude": "-18.98379000",
                        "longitude": "-42.00135000"
                    },
                    {
                        "id": 10149,
                        "name": "Alpinópolis",
                        "latitude": "-20.81822000",
                        "longitude": "-46.37937000"
                    },
                    {
                        "id": 10157,
                        "name": "Alterosa",
                        "latitude": "-21.21904000",
                        "longitude": "-46.18694000"
                    },
                    {
                        "id": 10168,
                        "name": "Alto Caparaó",
                        "latitude": "-20.44669000",
                        "longitude": "-41.87096000"
                    },
                    {
                        "id": 10172,
                        "name": "Alto Jequitibá",
                        "latitude": "-20.43703000",
                        "longitude": "-41.95113000"
                    },
                    {
                        "id": 10181,
                        "name": "Alto Rio Doce",
                        "latitude": "-21.01929000",
                        "longitude": "-43.40538000"
                    },
                    {
                        "id": 10190,
                        "name": "Alvarenga",
                        "latitude": "-19.39870000",
                        "longitude": "-41.68138000"
                    },
                    {
                        "id": 10193,
                        "name": "Alvinópolis",
                        "latitude": "-20.12078000",
                        "longitude": "-43.15399000"
                    },
                    {
                        "id": 10197,
                        "name": "Alvorada de Minas",
                        "latitude": "-18.79532000",
                        "longitude": "-43.37002000"
                    },
                    {
                        "id": 10220,
                        "name": "Amparo da Serra",
                        "latitude": "-20.52383000",
                        "longitude": "-42.79878000"
                    },
                    {
                        "id": 10245,
                        "name": "Andradas",
                        "latitude": "-22.06984000",
                        "longitude": "-46.57230000"
                    },
                    {
                        "id": 10247,
                        "name": "Andrelândia",
                        "latitude": "-21.71132000",
                        "longitude": "-44.27912000"
                    },
                    {
                        "id": 10252,
                        "name": "Angelândia",
                        "latitude": "-17.72394000",
                        "longitude": "-42.26234000"
                    },
                    {
                        "id": 10273,
                        "name": "Antônio Carlos",
                        "latitude": "-21.40838000",
                        "longitude": "-43.76937000"
                    },
                    {
                        "id": 10275,
                        "name": "Antônio Dias",
                        "latitude": "-19.56225000",
                        "longitude": "-42.88855000"
                    },
                    {
                        "id": 10281,
                        "name": "Antônio Prado de Minas",
                        "latitude": "-21.02658000",
                        "longitude": "-42.15497000"
                    },
                    {
                        "id": 10369,
                        "name": "Araçaí",
                        "latitude": "-19.24200000",
                        "longitude": "-44.22429000"
                    },
                    {
                        "id": 10312,
                        "name": "Aracitaba",
                        "latitude": "-21.35243000",
                        "longitude": "-43.40862000"
                    },
                    {
                        "id": 10373,
                        "name": "Araçuaí",
                        "latitude": "-16.90822000",
                        "longitude": "-41.98596000"
                    },
                    {
                        "id": 10324,
                        "name": "Araguari",
                        "latitude": "-18.64722000",
                        "longitude": "-48.18722000"
                    },
                    {
                        "id": 10335,
                        "name": "Arantina",
                        "latitude": "-21.89632000",
                        "longitude": "-44.22633000"
                    },
                    {
                        "id": 10339,
                        "name": "Araponga",
                        "latitude": "-20.66607000",
                        "longitude": "-42.51113000"
                    },
                    {
                        "id": 10341,
                        "name": "Araporã",
                        "latitude": "-18.49061000",
                        "longitude": "-49.13761000"
                    },
                    {
                        "id": 10344,
                        "name": "Arapuá",
                        "latitude": "-19.03065000",
                        "longitude": "-46.09585000"
                    },
                    {
                        "id": 10375,
                        "name": "Araújos",
                        "latitude": "-19.87542000",
                        "longitude": "-45.15682000"
                    },
                    {
                        "id": 10365,
                        "name": "Araxá",
                        "latitude": "-19.59333000",
                        "longitude": "-46.94056000"
                    },
                    {
                        "id": 10376,
                        "name": "Arceburgo",
                        "latitude": "-21.36655000",
                        "longitude": "-46.94472000"
                    },
                    {
                        "id": 10378,
                        "name": "Arcos",
                        "latitude": "-20.24351000",
                        "longitude": "-45.56760000"
                    },
                    {
                        "id": 10380,
                        "name": "Areado",
                        "latitude": "-21.33401000",
                        "longitude": "-46.16798000"
                    },
                    {
                        "id": 10392,
                        "name": "Argirita",
                        "latitude": "-21.63912000",
                        "longitude": "-42.82857000"
                    },
                    {
                        "id": 10393,
                        "name": "Aricanduva",
                        "latitude": "-17.85789000",
                        "longitude": "-42.59791000"
                    },
                    {
                        "id": 10394,
                        "name": "Arinos",
                        "latitude": "-15.80332000",
                        "longitude": "-45.94198000"
                    },
                    {
                        "id": 10432,
                        "name": "Astolfo Dutra",
                        "latitude": "-21.30413000",
                        "longitude": "-42.88194000"
                    },
                    {
                        "id": 10438,
                        "name": "Ataléia",
                        "latitude": "-18.18353000",
                        "longitude": "-41.16721000"
                    },
                    {
                        "id": 10446,
                        "name": "Augusto de Lima",
                        "latitude": "-18.10720000",
                        "longitude": "-44.16792000"
                    },
                    {
                        "id": 10472,
                        "name": "Baependi",
                        "latitude": "-21.97623000",
                        "longitude": "-44.85558000"
                    },
                    {
                        "id": 10482,
                        "name": "Baldim",
                        "latitude": "-19.23659000",
                        "longitude": "-43.84684000"
                    },
                    {
                        "id": 10493,
                        "name": "Bambuí",
                        "latitude": "-20.10451000",
                        "longitude": "-45.98743000"
                    },
                    {
                        "id": 10497,
                        "name": "Bandeira",
                        "latitude": "-15.88042000",
                        "longitude": "-40.59969000"
                    },
                    {
                        "id": 10498,
                        "name": "Bandeira do Sul",
                        "latitude": "-21.72907000",
                        "longitude": "-46.38283000"
                    },
                    {
                        "id": 10572,
                        "name": "Barão de Cocais",
                        "latitude": "-19.87980000",
                        "longitude": "-43.49476000"
                    },
                    {
                        "id": 10576,
                        "name": "Barão de Monte Alto",
                        "latitude": "-21.26536000",
                        "longitude": "-42.27886000"
                    },
                    {
                        "id": 10507,
                        "name": "Barbacena",
                        "latitude": "-21.25031000",
                        "longitude": "-43.84171000"
                    },
                    {
                        "id": 10519,
                        "name": "Barra Longa",
                        "latitude": "-20.27861000",
                        "longitude": "-43.07170000"
                    },
                    {
                        "id": 10555,
                        "name": "Barreiro do Jaíba",
                        "latitude": "-15.61532000",
                        "longitude": "-43.59187000"
                    },
                    {
                        "id": 10568,
                        "name": "Barroso",
                        "latitude": "-21.17886000",
                        "longitude": "-43.95708000"
                    },
                    {
                        "id": 10597,
                        "name": "Bela Vista de Minas",
                        "latitude": "-19.80136000",
                        "longitude": "-43.10273000"
                    },
                    {
                        "id": 10603,
                        "name": "Belmiro Braga",
                        "latitude": "-21.96440000",
                        "longitude": "-43.45933000"
                    },
                    {
                        "id": 10607,
                        "name": "Belo Horizonte",
                        "latitude": "-19.92083000",
                        "longitude": "-43.93778000"
                    },
                    {
                        "id": 10610,
                        "name": "Belo Oriente",
                        "latitude": "-19.25558000",
                        "longitude": "-42.44289000"
                    },
                    {
                        "id": 10611,
                        "name": "Belo Vale",
                        "latitude": "-20.41584000",
                        "longitude": "-44.06470000"
                    },
                    {
                        "id": 10632,
                        "name": "Berilo",
                        "latitude": "-16.86340000",
                        "longitude": "-42.48889000"
                    },
                    {
                        "id": 10633,
                        "name": "Berizal",
                        "latitude": "-15.67761000",
                        "longitude": "-41.77137000"
                    },
                    {
                        "id": 10640,
                        "name": "Bertópolis",
                        "latitude": "-16.95442000",
                        "longitude": "-40.56435000"
                    },
                    {
                        "id": 10642,
                        "name": "Betim",
                        "latitude": "-19.96778000",
                        "longitude": "-44.19833000"
                    },
                    {
                        "id": 10646,
                        "name": "Bias Fortes",
                        "latitude": "-21.63008000",
                        "longitude": "-43.75508000"
                    },
                    {
                        "id": 10647,
                        "name": "Bicas",
                        "latitude": "-21.73237000",
                        "longitude": "-43.10454000"
                    },
                    {
                        "id": 10650,
                        "name": "Biquinhas",
                        "latitude": "-18.76231000",
                        "longitude": "-45.54853000"
                    },
                    {
                        "id": 10658,
                        "name": "Boa Esperança",
                        "latitude": "-21.08132000",
                        "longitude": "-45.62433000"
                    },
                    {
                        "id": 10681,
                        "name": "Bocaina de Minas",
                        "latitude": "-22.23436000",
                        "longitude": "-44.49342000"
                    },
                    {
                        "id": 10683,
                        "name": "Bocaiúva",
                        "latitude": "-17.38916000",
                        "longitude": "-43.83571000"
                    },
                    {
                        "id": 10691,
                        "name": "Bom Despacho",
                        "latitude": "-19.69145000",
                        "longitude": "-45.25297000"
                    },
                    {
                        "id": 10697,
                        "name": "Bom Jardim de Minas",
                        "latitude": "-21.94390000",
                        "longitude": "-44.12193000"
                    },
                    {
                        "id": 10704,
                        "name": "Bom Jesus da Penha",
                        "latitude": "-20.99902000",
                        "longitude": "-46.54769000"
                    },
                    {
                        "id": 10708,
                        "name": "Bom Jesus do Amparo",
                        "latitude": "-19.71668000",
                        "longitude": "-43.46840000"
                    },
                    {
                        "id": 10710,
                        "name": "Bom Jesus do Galho",
                        "latitude": "-19.71687000",
                        "longitude": "-42.37558000"
                    },
                    {
                        "id": 10722,
                        "name": "Bom Repouso",
                        "latitude": "-22.44963000",
                        "longitude": "-46.18632000"
                    },
                    {
                        "id": 10726,
                        "name": "Bom Sucesso",
                        "latitude": "-21.03029000",
                        "longitude": "-44.79501000"
                    },
                    {
                        "id": 10731,
                        "name": "Bonfim",
                        "latitude": "-20.31591000",
                        "longitude": "-44.20740000"
                    },
                    {
                        "id": 10734,
                        "name": "Bonfinópolis de Minas",
                        "latitude": "-16.54416000",
                        "longitude": "-46.13266000"
                    },
                    {
                        "id": 10740,
                        "name": "Bonito de Minas",
                        "latitude": "-14.91015000",
                        "longitude": "-44.88471000"
                    },
                    {
                        "id": 10752,
                        "name": "Borda da Mata",
                        "latitude": "-22.25106000",
                        "longitude": "-46.16707000"
                    },
                    {
                        "id": 10757,
                        "name": "Botelhos",
                        "latitude": "-21.64903000",
                        "longitude": "-46.42831000"
                    },
                    {
                        "id": 10759,
                        "name": "Botumirim",
                        "latitude": "-16.90950000",
                        "longitude": "-43.00848000"
                    },
                    {
                        "id": 10813,
                        "name": "Brás Pires",
                        "latitude": "-20.87837000",
                        "longitude": "-43.22442000"
                    },
                    {
                        "id": 10771,
                        "name": "Brasilândia de Minas",
                        "latitude": "-16.93061000",
                        "longitude": "-45.96385000"
                    },
                    {
                        "id": 10777,
                        "name": "Brasília de Minas",
                        "latitude": "-16.25246000",
                        "longitude": "-44.45712000"
                    },
                    {
                        "id": 10783,
                        "name": "Braúnas",
                        "latitude": "-19.02181000",
                        "longitude": "-42.71399000"
                    },
                    {
                        "id": 10779,
                        "name": "Brazópolis",
                        "latitude": "-22.48169000",
                        "longitude": "-45.62802000"
                    },
                    {
                        "id": 10809,
                        "name": "Brumadinho",
                        "latitude": "-20.20447000",
                        "longitude": "-44.15388000"
                    },
                    {
                        "id": 10814,
                        "name": "Bueno Brandão",
                        "latitude": "-22.50459000",
                        "longitude": "-46.35271000"
                    },
                    {
                        "id": 10816,
                        "name": "Buenópolis",
                        "latitude": "-17.87455000",
                        "longitude": "-44.02374000"
                    },
                    {
                        "id": 10818,
                        "name": "Bugre",
                        "latitude": "-19.36701000",
                        "longitude": "-42.30815000"
                    },
                    {
                        "id": 10835,
                        "name": "Buritis",
                        "latitude": "-15.41389000",
                        "longitude": "-46.55470000"
                    },
                    {
                        "id": 10837,
                        "name": "Buritizeiro",
                        "latitude": "-17.40582000",
                        "longitude": "-45.30446000"
                    },
                    {
                        "id": 10847,
                        "name": "Cabeceira Grande",
                        "latitude": "-16.06178000",
                        "longitude": "-47.17573000"
                    },
                    {
                        "id": 10854,
                        "name": "Cabo Verde",
                        "latitude": "-21.48702000",
                        "longitude": "-46.37999000"
                    },
                    {
                        "id": 10867,
                        "name": "Cachoeira da Prata",
                        "latitude": "-19.51865000",
                        "longitude": "-44.46250000"
                    },
                    {
                        "id": 10869,
                        "name": "Cachoeira de Minas",
                        "latitude": "-22.35563000",
                        "longitude": "-45.79447000"
                    },
                    {
                        "id": 10870,
                        "name": "Cachoeira de Pajeú",
                        "latitude": "-15.97163000",
                        "longitude": "-41.49303000"
                    },
                    {
                        "id": 10863,
                        "name": "Cachoeira Dourada",
                        "latitude": "-18.59094000",
                        "longitude": "-49.47013000"
                    },
                    {
                        "id": 10889,
                        "name": "Caetanópolis",
                        "latitude": "-19.33473000",
                        "longitude": "-44.41002000"
                    },
                    {
                        "id": 10891,
                        "name": "Caeté",
                        "latitude": "-19.87017000",
                        "longitude": "-43.65060000"
                    },
                    {
                        "id": 10899,
                        "name": "Caiana",
                        "latitude": "-20.73080000",
                        "longitude": "-41.90016000"
                    },
                    {
                        "id": 10921,
                        "name": "Cajuri",
                        "latitude": "-20.78744000",
                        "longitude": "-42.76259000"
                    },
                    {
                        "id": 10923,
                        "name": "Caldas",
                        "latitude": "-21.88671000",
                        "longitude": "-46.35924000"
                    },
                    {
                        "id": 10935,
                        "name": "Camacho",
                        "latitude": "-20.64216000",
                        "longitude": "-45.14334000"
                    },
                    {
                        "id": 10938,
                        "name": "Camanducaia",
                        "latitude": "-22.75528000",
                        "longitude": "-46.14472000"
                    },
                    {
                        "id": 10950,
                        "name": "Cambuí",
                        "latitude": "-22.58243000",
                        "longitude": "-46.06121000"
                    },
                    {
                        "id": 10949,
                        "name": "Cambuquira",
                        "latitude": "-21.85379000",
                        "longitude": "-45.27170000"
                    },
                    {
                        "id": 10956,
                        "name": "Campanário",
                        "latitude": "-18.27490000",
                        "longitude": "-41.73907000"
                    },
                    {
                        "id": 10955,
                        "name": "Campanha",
                        "latitude": "-21.81412000",
                        "longitude": "-45.39753000"
                    },
                    {
                        "id": 10958,
                        "name": "Campestre",
                        "latitude": "-21.73436000",
                        "longitude": "-46.22571000"
                    },
                    {
                        "id": 10964,
                        "name": "Campina Verde",
                        "latitude": "-19.46113000",
                        "longitude": "-49.73967000"
                    },
                    {
                        "id": 10981,
                        "name": "Campo Azul",
                        "latitude": "-16.52161000",
                        "longitude": "-44.80679000"
                    },
                    {
                        "id": 10982,
                        "name": "Campo Belo",
                        "latitude": "-20.89722000",
                        "longitude": "-45.27722000"
                    },
                    {
                        "id": 11006,
                        "name": "Campo do Meio",
                        "latitude": "-21.12604000",
                        "longitude": "-45.79572000"
                    },
                    {
                        "id": 10987,
                        "name": "Campo Florido",
                        "latitude": "-19.69262000",
                        "longitude": "-48.65664000"
                    },
                    {
                        "id": 11008,
                        "name": "Campos Altos",
                        "latitude": "-19.63694000",
                        "longitude": "-46.19815000"
                    },
                    {
                        "id": 11011,
                        "name": "Campos Gerais",
                        "latitude": "-21.23500000",
                        "longitude": "-45.75861000"
                    },
                    {
                        "id": 11021,
                        "name": "Cana Verde",
                        "latitude": "-21.02062000",
                        "longitude": "-45.18335000"
                    },
                    {
                        "id": 11030,
                        "name": "Canaã",
                        "latitude": "-20.66128000",
                        "longitude": "-42.63787000"
                    },
                    {
                        "id": 11061,
                        "name": "Canápolis",
                        "latitude": "-18.77777000",
                        "longitude": "-49.27579000"
                    },
                    {
                        "id": 11034,
                        "name": "Candeias",
                        "latitude": "-20.73894000",
                        "longitude": "-45.28719000"
                    },
                    {
                        "id": 11053,
                        "name": "Cantagalo",
                        "latitude": "-18.51033000",
                        "longitude": "-42.64980000"
                    },
                    {
                        "id": 11064,
                        "name": "Caparaó",
                        "latitude": "-20.52613000",
                        "longitude": "-41.90220000"
                    },
                    {
                        "id": 11067,
                        "name": "Capela Nova",
                        "latitude": "-20.91843000",
                        "longitude": "-43.61587000"
                    },
                    {
                        "id": 11071,
                        "name": "Capelinha",
                        "latitude": "-17.69167000",
                        "longitude": "-42.50214000"
                    },
                    {
                        "id": 11072,
                        "name": "Capetinga",
                        "latitude": "-20.65301000",
                        "longitude": "-47.01826000"
                    },
                    {
                        "id": 11074,
                        "name": "Capim Branco",
                        "latitude": "-19.57826000",
                        "longitude": "-44.16662000"
                    },
                    {
                        "id": 11078,
                        "name": "Capinópolis",
                        "latitude": "-18.69222000",
                        "longitude": "-49.57943000"
                    },
                    {
                        "id": 11081,
                        "name": "Capitão Andrade",
                        "latitude": "-19.04293000",
                        "longitude": "-41.82608000"
                    },
                    {
                        "id": 11082,
                        "name": "Capitão Enéas",
                        "latitude": "-16.05629000",
                        "longitude": "-43.67470000"
                    },
                    {
                        "id": 11087,
                        "name": "Capitólio",
                        "latitude": "-20.61528000",
                        "longitude": "-46.05000000"
                    },
                    {
                        "id": 11093,
                        "name": "Caputira",
                        "latitude": "-20.18512000",
                        "longitude": "-42.25284000"
                    },
                    {
                        "id": 11115,
                        "name": "Caraí",
                        "latitude": "-17.18089000",
                        "longitude": "-41.54964000"
                    },
                    {
                        "id": 11105,
                        "name": "Caranaíba",
                        "latitude": "-20.88526000",
                        "longitude": "-43.71231000"
                    },
                    {
                        "id": 11106,
                        "name": "Carandaí",
                        "latitude": "-20.98840000",
                        "longitude": "-43.83413000"
                    },
                    {
                        "id": 11107,
                        "name": "Carangola",
                        "latitude": "-20.70784000",
                        "longitude": "-42.10486000"
                    },
                    {
                        "id": 11110,
                        "name": "Caratinga",
                        "latitude": "-19.68877000",
                        "longitude": "-41.88778000"
                    },
                    {
                        "id": 11120,
                        "name": "Carbonita",
                        "latitude": "-17.47884000",
                        "longitude": "-43.04885000"
                    },
                    {
                        "id": 11124,
                        "name": "Careaçu",
                        "latitude": "-22.07964000",
                        "longitude": "-45.66541000"
                    },
                    {
                        "id": 11139,
                        "name": "Carlos Chagas",
                        "latitude": "-17.67817000",
                        "longitude": "-40.88519000"
                    },
                    {
                        "id": 11151,
                        "name": "Carmésia",
                        "latitude": "-19.06534000",
                        "longitude": "-43.18402000"
                    },
                    {
                        "id": 11143,
                        "name": "Carmo da Cachoeira",
                        "latitude": "-21.43323000",
                        "longitude": "-45.18036000"
                    },
                    {
                        "id": 11144,
                        "name": "Carmo da Mata",
                        "latitude": "-20.56847000",
                        "longitude": "-44.88516000"
                    },
                    {
                        "id": 11145,
                        "name": "Carmo de Minas",
                        "latitude": "-22.08863000",
                        "longitude": "-45.14949000"
                    },
                    {
                        "id": 11146,
                        "name": "Carmo do Cajuru",
                        "latitude": "-20.18782000",
                        "longitude": "-44.71399000"
                    },
                    {
                        "id": 11147,
                        "name": "Carmo do Paranaíba",
                        "latitude": "-18.87335000",
                        "longitude": "-46.14425000"
                    },
                    {
                        "id": 11148,
                        "name": "Carmo do Rio Claro",
                        "latitude": "-20.97974000",
                        "longitude": "-46.10445000"
                    },
                    {
                        "id": 11153,
                        "name": "Carmópolis de Minas",
                        "latitude": "-20.54914000",
                        "longitude": "-44.64527000"
                    },
                    {
                        "id": 11159,
                        "name": "Carneirinho",
                        "latitude": "-19.71424000",
                        "longitude": "-50.80874000"
                    },
                    {
                        "id": 11163,
                        "name": "Carrancas",
                        "latitude": "-21.49589000",
                        "longitude": "-44.61042000"
                    },
                    {
                        "id": 11169,
                        "name": "Carvalhópolis",
                        "latitude": "-21.77488000",
                        "longitude": "-45.82688000"
                    },
                    {
                        "id": 11168,
                        "name": "Carvalhos",
                        "latitude": "-22.03096000",
                        "longitude": "-44.47544000"
                    },
                    {
                        "id": 11172,
                        "name": "Casa Grande",
                        "latitude": "-20.84072000",
                        "longitude": "-43.93951000"
                    },
                    {
                        "id": 11175,
                        "name": "Cascalho Rico",
                        "latitude": "-18.54617000",
                        "longitude": "-47.85132000"
                    },
                    {
                        "id": 11543,
                        "name": "Cássia",
                        "latitude": "-20.59294000",
                        "longitude": "-46.91761000"
                    },
                    {
                        "id": 11193,
                        "name": "Cataguases",
                        "latitude": "-21.34548000",
                        "longitude": "-42.64976000"
                    },
                    {
                        "id": 11199,
                        "name": "Catas Altas",
                        "latitude": "-20.07049000",
                        "longitude": "-43.42197000"
                    },
                    {
                        "id": 11200,
                        "name": "Catas Altas da Noruega",
                        "latitude": "-20.68094000",
                        "longitude": "-43.49780000"
                    },
                    {
                        "id": 11207,
                        "name": "Catuji",
                        "latitude": "-17.36328000",
                        "longitude": "-41.48183000"
                    },
                    {
                        "id": 11212,
                        "name": "Catuti",
                        "latitude": "-15.32360000",
                        "longitude": "-43.11391000"
                    },
                    {
                        "id": 11216,
                        "name": "Caxambu",
                        "latitude": "-21.97722000",
                        "longitude": "-44.93250000"
                    },
                    {
                        "id": 11233,
                        "name": "Cedro do Abaeté",
                        "latitude": "-19.11465000",
                        "longitude": "-45.70070000"
                    },
                    {
                        "id": 11239,
                        "name": "Central de Minas",
                        "latitude": "-18.76784000",
                        "longitude": "-41.28963000"
                    },
                    {
                        "id": 11241,
                        "name": "Centralina",
                        "latitude": "-18.60922000",
                        "longitude": "-49.16062000"
                    },
                    {
                        "id": 11285,
                        "name": "Chácara",
                        "latitude": "-21.67919000",
                        "longitude": "-43.21835000"
                    },
                    {
                        "id": 11258,
                        "name": "Chalé",
                        "latitude": "-20.03354000",
                        "longitude": "-41.67809000"
                    },
                    {
                        "id": 11263,
                        "name": "Chapada do Norte",
                        "latitude": "-17.16293000",
                        "longitude": "-42.37718000"
                    },
                    {
                        "id": 11260,
                        "name": "Chapada Gaúcha",
                        "latitude": "-15.57934000",
                        "longitude": "-45.41242000"
                    },
                    {
                        "id": 11276,
                        "name": "Chiador",
                        "latitude": "-21.97253000",
                        "longitude": "-43.00735000"
                    },
                    {
                        "id": 11294,
                        "name": "Cipotânea",
                        "latitude": "-20.93027000",
                        "longitude": "-43.36547000"
                    },
                    {
                        "id": 11297,
                        "name": "Claraval",
                        "latitude": "-20.35681000",
                        "longitude": "-47.25241000"
                    },
                    {
                        "id": 11298,
                        "name": "Claro dos Poções",
                        "latitude": "-17.09679000",
                        "longitude": "-44.23300000"
                    },
                    {
                        "id": 11302,
                        "name": "Cláudio",
                        "latitude": "-20.39006000",
                        "longitude": "-44.79135000"
                    },
                    {
                        "id": 11316,
                        "name": "Coimbra",
                        "latitude": "-20.84494000",
                        "longitude": "-42.79834000"
                    },
                    {
                        "id": 11332,
                        "name": "Coluna",
                        "latitude": "-18.26842000",
                        "longitude": "-42.82813000"
                    },
                    {
                        "id": 11340,
                        "name": "Comendador Gomes",
                        "latitude": "-19.65330000",
                        "longitude": "-49.08738000"
                    },
                    {
                        "id": 11342,
                        "name": "Comercinho",
                        "latitude": "-16.28896000",
                        "longitude": "-41.77346000"
                    },
                    {
                        "id": 11345,
                        "name": "Conceição da Aparecida",
                        "latitude": "-21.10120000",
                        "longitude": "-46.22626000"
                    },
                    {
                        "id": 11347,
                        "name": "Conceição da Barra de Minas",
                        "latitude": "-21.14228000",
                        "longitude": "-44.48863000"
                    },
                    {
                        "id": 11349,
                        "name": "Conceição das Alagoas",
                        "latitude": "-19.95627000",
                        "longitude": "-48.30510000"
                    },
                    {
                        "id": 11350,
                        "name": "Conceição das Pedras",
                        "latitude": "-22.13866000",
                        "longitude": "-45.42694000"
                    },
                    {
                        "id": 11351,
                        "name": "Conceição de Ipanema",
                        "latitude": "-19.91781000",
                        "longitude": "-41.70024000"
                    },
                    {
                        "id": 11360,
                        "name": "Conceição do Mato Dentro",
                        "latitude": "-18.90010000",
                        "longitude": "-43.50229000"
                    },
                    {
                        "id": 11361,
                        "name": "Conceição do Pará",
                        "latitude": "-19.78550000",
                        "longitude": "-44.87016000"
                    },
                    {
                        "id": 11362,
                        "name": "Conceição do Rio Verde",
                        "latitude": "-21.90132000",
                        "longitude": "-45.07975000"
                    },
                    {
                        "id": 11364,
                        "name": "Conceição dos Ouros",
                        "latitude": "-22.45037000",
                        "longitude": "-45.77976000"
                    },
                    {
                        "id": 11558,
                        "name": "Cônego Marinho",
                        "latitude": "-14.98755000",
                        "longitude": "-44.60965000"
                    },
                    {
                        "id": 11375,
                        "name": "Confins",
                        "latitude": "-19.65686000",
                        "longitude": "-43.98131000"
                    },
                    {
                        "id": 11378,
                        "name": "Congonhal",
                        "latitude": "-22.13543000",
                        "longitude": "-46.03992000"
                    },
                    {
                        "id": 11379,
                        "name": "Congonhas",
                        "latitude": "-20.50525000",
                        "longitude": "-43.85880000"
                    },
                    {
                        "id": 11380,
                        "name": "Congonhas do Norte",
                        "latitude": "-18.88604000",
                        "longitude": "-43.69620000"
                    },
                    {
                        "id": 11382,
                        "name": "Conquista",
                        "latitude": "-19.86841000",
                        "longitude": "-47.63352000"
                    },
                    {
                        "id": 11384,
                        "name": "Conselheiro Lafaiete",
                        "latitude": "-20.66028000",
                        "longitude": "-43.78611000"
                    },
                    {
                        "id": 11386,
                        "name": "Conselheiro Pena",
                        "latitude": "-19.17411000",
                        "longitude": "-41.45800000"
                    },
                    {
                        "id": 11387,
                        "name": "Consolação",
                        "latitude": "-22.54002000",
                        "longitude": "-45.90414000"
                    },
                    {
                        "id": 11389,
                        "name": "Contagem",
                        "latitude": "-19.93167000",
                        "longitude": "-44.05361000"
                    },
                    {
                        "id": 11392,
                        "name": "Coqueiral",
                        "latitude": "-21.17947000",
                        "longitude": "-45.43619000"
                    },
                    {
                        "id": 11396,
                        "name": "Coração de Jesus",
                        "latitude": "-16.68619000",
                        "longitude": "-44.36279000"
                    },
                    {
                        "id": 11403,
                        "name": "Cordisburgo",
                        "latitude": "-19.09925000",
                        "longitude": "-44.16458000"
                    },
                    {
                        "id": 11404,
                        "name": "Cordislândia",
                        "latitude": "-21.78750000",
                        "longitude": "-45.67156000"
                    },
                    {
                        "id": 11409,
                        "name": "Corinto",
                        "latitude": "-18.35246000",
                        "longitude": "-44.60589000"
                    },
                    {
                        "id": 11411,
                        "name": "Coroaci",
                        "latitude": "-18.61187000",
                        "longitude": "-42.25835000"
                    },
                    {
                        "id": 11414,
                        "name": "Coromandel",
                        "latitude": "-18.40456000",
                        "longitude": "-47.15161000"
                    },
                    {
                        "id": 11419,
                        "name": "Coronel Fabriciano",
                        "latitude": "-19.51861000",
                        "longitude": "-42.62889000"
                    },
                    {
                        "id": 11426,
                        "name": "Coronel Murta",
                        "latitude": "-16.58925000",
                        "longitude": "-42.19742000"
                    },
                    {
                        "id": 11427,
                        "name": "Coronel Pacheco",
                        "latitude": "-21.60865000",
                        "longitude": "-43.29006000"
                    },
                    {
                        "id": 11431,
                        "name": "Coronel Xavier Chaves",
                        "latitude": "-21.02869000",
                        "longitude": "-44.20221000"
                    },
                    {
                        "id": 11553,
                        "name": "Córrego Danta",
                        "latitude": "-19.81349000",
                        "longitude": "-45.96149000"
                    },
                    {
                        "id": 11556,
                        "name": "Córrego do Bom Jesus",
                        "latitude": "-22.62998000",
                        "longitude": "-45.99681000"
                    },
                    {
                        "id": 11554,
                        "name": "Córrego Fundo",
                        "latitude": "-20.45029000",
                        "longitude": "-45.53592000"
                    },
                    {
                        "id": 11555,
                        "name": "Córrego Novo",
                        "latitude": "-19.82874000",
                        "longitude": "-42.44214000"
                    },
                    {
                        "id": 11456,
                        "name": "Couto de Magalhães de Minas",
                        "latitude": "-18.11856000",
                        "longitude": "-43.41813000"
                    },
                    {
                        "id": 11481,
                        "name": "Crisólita",
                        "latitude": "-17.24147000",
                        "longitude": "-40.97498000"
                    },
                    {
                        "id": 11467,
                        "name": "Cristais",
                        "latitude": "-20.80957000",
                        "longitude": "-45.52448000"
                    },
                    {
                        "id": 11479,
                        "name": "Cristália",
                        "latitude": "-16.72547000",
                        "longitude": "-42.81870000"
                    },
                    {
                        "id": 11474,
                        "name": "Cristiano Otoni",
                        "latitude": "-20.83688000",
                        "longitude": "-43.82931000"
                    },
                    {
                        "id": 11476,
                        "name": "Cristina",
                        "latitude": "-22.21592000",
                        "longitude": "-45.28820000"
                    },
                    {
                        "id": 11487,
                        "name": "Crucilândia",
                        "latitude": "-20.40660000",
                        "longitude": "-44.35991000"
                    },
                    {
                        "id": 11495,
                        "name": "Cruzeiro da Fortaleza",
                        "latitude": "-18.96712000",
                        "longitude": "-46.65779000"
                    },
                    {
                        "id": 11504,
                        "name": "Cruzília",
                        "latitude": "-21.73596000",
                        "longitude": "-44.79827000"
                    },
                    {
                        "id": 11519,
                        "name": "Cuparaque",
                        "latitude": "-18.99664000",
                        "longitude": "-41.13368000"
                    },
                    {
                        "id": 11532,
                        "name": "Curral de Dentro",
                        "latitude": "-15.84632000",
                        "longitude": "-41.75405000"
                    },
                    {
                        "id": 11538,
                        "name": "Curvelo",
                        "latitude": "-18.78525000",
                        "longitude": "-44.41599000"
                    },
                    {
                        "id": 11563,
                        "name": "Datas",
                        "latitude": "-18.48073000",
                        "longitude": "-43.65216000"
                    },
                    {
                        "id": 11567,
                        "name": "Delfim Moreira",
                        "latitude": "-22.51165000",
                        "longitude": "-45.28972000"
                    },
                    {
                        "id": 11568,
                        "name": "Delfinópolis",
                        "latitude": "-20.34248000",
                        "longitude": "-46.83952000"
                    },
                    {
                        "id": 11570,
                        "name": "Delta",
                        "latitude": "-19.93414000",
                        "longitude": "-47.80435000"
                    },
                    {
                        "id": 11578,
                        "name": "Descoberto",
                        "latitude": "-21.45167000",
                        "longitude": "-42.97128000"
                    },
                    {
                        "id": 11580,
                        "name": "Desterro de Entre Rios",
                        "latitude": "-20.64186000",
                        "longitude": "-44.28135000"
                    },
                    {
                        "id": 11581,
                        "name": "Desterro do Melo",
                        "latitude": "-21.14290000",
                        "longitude": "-43.52011000"
                    },
                    {
                        "id": 11588,
                        "name": "Diamantina",
                        "latitude": "-17.97795000",
                        "longitude": "-43.60415000"
                    },
                    {
                        "id": 11593,
                        "name": "Diogo de Vasconcelos",
                        "latitude": "-20.47593000",
                        "longitude": "-43.19094000"
                    },
                    {
                        "id": 11594,
                        "name": "Dionísio",
                        "latitude": "-19.83679000",
                        "longitude": "-42.68817000"
                    },
                    {
                        "id": 11605,
                        "name": "Divinésia",
                        "latitude": "-20.99465000",
                        "longitude": "-42.99513000"
                    },
                    {
                        "id": 11600,
                        "name": "Divino",
                        "latitude": "-20.58996000",
                        "longitude": "-42.17550000"
                    },
                    {
                        "id": 11601,
                        "name": "Divino das Laranjeiras",
                        "latitude": "-18.77778000",
                        "longitude": "-41.47972000"
                    },
                    {
                        "id": 11604,
                        "name": "Divinolândia de Minas",
                        "latitude": "-18.77559000",
                        "longitude": "-42.57075000"
                    },
                    {
                        "id": 11606,
                        "name": "Divinópolis",
                        "latitude": "-20.14355000",
                        "longitude": "-44.89065000"
                    },
                    {
                        "id": 11609,
                        "name": "Divisa Alegre",
                        "latitude": "-15.69447000",
                        "longitude": "-41.39107000"
                    },
                    {
                        "id": 11610,
                        "name": "Divisa Nova",
                        "latitude": "-21.52382000",
                        "longitude": "-46.24417000"
                    },
                    {
                        "id": 11611,
                        "name": "Divisópolis",
                        "latitude": "-15.76740000",
                        "longitude": "-40.92393000"
                    },
                    {
                        "id": 11624,
                        "name": "Dom Bosco",
                        "latitude": "-16.81133000",
                        "longitude": "-46.28457000"
                    },
                    {
                        "id": 11625,
                        "name": "Dom Cavati",
                        "latitude": "-19.38835000",
                        "longitude": "-42.09365000"
                    },
                    {
                        "id": 11630,
                        "name": "Dom Joaquim",
                        "latitude": "-18.92927000",
                        "longitude": "-43.26602000"
                    },
                    {
                        "id": 11635,
                        "name": "Dom Silvério",
                        "latitude": "-20.12728000",
                        "longitude": "-42.94651000"
                    },
                    {
                        "id": 11636,
                        "name": "Dom Viçoso",
                        "latitude": "-22.23185000",
                        "longitude": "-45.14880000"
                    },
                    {
                        "id": 11640,
                        "name": "Dona Eusébia",
                        "latitude": "-21.32337000",
                        "longitude": "-42.80829000"
                    },
                    {
                        "id": 11643,
                        "name": "Dores de Campos",
                        "latitude": "-21.11373000",
                        "longitude": "-43.99358000"
                    },
                    {
                        "id": 11644,
                        "name": "Dores de Guanhães",
                        "latitude": "-19.04398000",
                        "longitude": "-42.92816000"
                    },
                    {
                        "id": 11645,
                        "name": "Dores do Indaiá",
                        "latitude": "-19.47427000",
                        "longitude": "-45.54046000"
                    },
                    {
                        "id": 11647,
                        "name": "Dores do Turvo",
                        "latitude": "-21.02779000",
                        "longitude": "-43.16365000"
                    },
                    {
                        "id": 11648,
                        "name": "Doresópolis",
                        "latitude": "-20.29693000",
                        "longitude": "-45.86864000"
                    },
                    {
                        "id": 11653,
                        "name": "Douradoquara",
                        "latitude": "-18.44204000",
                        "longitude": "-47.61478000"
                    },
                    {
                        "id": 11670,
                        "name": "Durandé",
                        "latitude": "-20.15179000",
                        "longitude": "-41.78240000"
                    },
                    {
                        "id": 11686,
                        "name": "Elói Mendes",
                        "latitude": "-21.60067000",
                        "longitude": "-45.59466000"
                    },
                    {
                        "id": 11699,
                        "name": "Engenheiro Caldas",
                        "latitude": "-19.11350000",
                        "longitude": "-42.01786000"
                    },
                    {
                        "id": 11701,
                        "name": "Engenheiro Navarro",
                        "latitude": "-17.30933000",
                        "longitude": "-44.03465000"
                    },
                    {
                        "id": 11704,
                        "name": "Entre Folhas",
                        "latitude": "-19.65964000",
                        "longitude": "-42.24102000"
                    },
                    {
                        "id": 11707,
                        "name": "Entre Rios de Minas",
                        "latitude": "-20.70275000",
                        "longitude": "-44.10687000"
                    },
                    {
                        "id": 11723,
                        "name": "Ervália",
                        "latitude": "-20.84684000",
                        "longitude": "-42.61968000"
                    },
                    {
                        "id": 11726,
                        "name": "Esmeraldas",
                        "latitude": "-19.76250000",
                        "longitude": "-44.31389000"
                    },
                    {
                        "id": 11727,
                        "name": "Espera Feliz",
                        "latitude": "-20.59349000",
                        "longitude": "-41.91981000"
                    },
                    {
                        "id": 11736,
                        "name": "Espinosa",
                        "latitude": "-14.85978000",
                        "longitude": "-42.99177000"
                    },
                    {
                        "id": 11740,
                        "name": "Espírito Santo do Dourado",
                        "latitude": "-22.00600000",
                        "longitude": "-45.99000000"
                    },
                    {
                        "id": 11745,
                        "name": "Estiva",
                        "latitude": "-22.45283000",
                        "longitude": "-46.02238000"
                    },
                    {
                        "id": 11749,
                        "name": "Estrela Dalva",
                        "latitude": "-21.69328000",
                        "longitude": "-42.46834000"
                    },
                    {
                        "id": 11753,
                        "name": "Estrela do Indaiá",
                        "latitude": "-19.58083000",
                        "longitude": "-45.81189000"
                    },
                    {
                        "id": 11756,
                        "name": "Estrela do Sul",
                        "latitude": "-18.72229000",
                        "longitude": "-47.69732000"
                    },
                    {
                        "id": 11761,
                        "name": "Eugenópolis",
                        "latitude": "-20.99897000",
                        "longitude": "-42.24618000"
                    },
                    {
                        "id": 11765,
                        "name": "Ewbank da Câmara",
                        "latitude": "-21.57233000",
                        "longitude": "-43.55342000"
                    },
                    {
                        "id": 11767,
                        "name": "Extrema",
                        "latitude": "-22.82650000",
                        "longitude": "-46.28351000"
                    },
                    {
                        "id": 11773,
                        "name": "Fama",
                        "latitude": "-21.46845000",
                        "longitude": "-45.82005000"
                    },
                    {
                        "id": 11774,
                        "name": "Faria Lemos",
                        "latitude": "-20.78262000",
                        "longitude": "-42.02787000"
                    },
                    {
                        "id": 11801,
                        "name": "Felício dos Santos",
                        "latitude": "-18.15506000",
                        "longitude": "-43.24046000"
                    },
                    {
                        "id": 11796,
                        "name": "Felisburgo",
                        "latitude": "-16.66153000",
                        "longitude": "-40.71814000"
                    },
                    {
                        "id": 11797,
                        "name": "Felixlândia",
                        "latitude": "-18.69406000",
                        "longitude": "-44.91938000"
                    },
                    {
                        "id": 11803,
                        "name": "Fernandes Tourinho",
                        "latitude": "-19.10298000",
                        "longitude": "-42.09459000"
                    },
                    {
                        "id": 11814,
                        "name": "Ferros",
                        "latitude": "-19.23796000",
                        "longitude": "-42.97023000"
                    },
                    {
                        "id": 11815,
                        "name": "Fervedouro",
                        "latitude": "-20.68788000",
                        "longitude": "-42.34214000"
                    },
                    {
                        "id": 11839,
                        "name": "Florestal",
                        "latitude": "-19.86521000",
                        "longitude": "-44.44251000"
                    },
                    {
                        "id": 11850,
                        "name": "Formiga",
                        "latitude": "-20.46444000",
                        "longitude": "-45.42639000"
                    },
                    {
                        "id": 11857,
                        "name": "Formoso",
                        "latitude": "-15.14747000",
                        "longitude": "-46.09371000"
                    },
                    {
                        "id": 11864,
                        "name": "Fortaleza de Minas",
                        "latitude": "-20.88169000",
                        "longitude": "-46.77437000"
                    },
                    {
                        "id": 11870,
                        "name": "Fortuna de Minas",
                        "latitude": "-19.54845000",
                        "longitude": "-44.50230000"
                    },
                    {
                        "id": 11878,
                        "name": "Francisco Badaró",
                        "latitude": "-16.95297000",
                        "longitude": "-42.28055000"
                    },
                    {
                        "id": 11881,
                        "name": "Francisco Dumont",
                        "latitude": "-17.39766000",
                        "longitude": "-44.21775000"
                    },
                    {
                        "id": 11885,
                        "name": "Francisco Sá",
                        "latitude": "-16.47583000",
                        "longitude": "-43.48833000"
                    },
                    {
                        "id": 11886,
                        "name": "Franciscópolis",
                        "latitude": "-18.00982000",
                        "longitude": "-41.98437000"
                    },
                    {
                        "id": 11891,
                        "name": "Frei Gaspar",
                        "latitude": "-18.14006000",
                        "longitude": "-41.49292000"
                    },
                    {
                        "id": 11892,
                        "name": "Frei Inocêncio",
                        "latitude": "-18.51403000",
                        "longitude": "-41.87101000"
                    },
                    {
                        "id": 11893,
                        "name": "Frei Lagonegro",
                        "latitude": "-18.14293000",
                        "longitude": "-42.76064000"
                    },
                    {
                        "id": 11898,
                        "name": "Fronteira",
                        "latitude": "-20.22276000",
                        "longitude": "-49.17640000"
                    },
                    {
                        "id": 11899,
                        "name": "Fronteira dos Vales",
                        "latitude": "-16.89172000",
                        "longitude": "-40.83008000"
                    },
                    {
                        "id": 11901,
                        "name": "Fruta de Leite",
                        "latitude": "-16.16212000",
                        "longitude": "-42.52859000"
                    },
                    {
                        "id": 11902,
                        "name": "Frutal",
                        "latitude": "-20.02472000",
                        "longitude": "-48.94056000"
                    },
                    {
                        "id": 11905,
                        "name": "Funilândia",
                        "latitude": "-19.35187000",
                        "longitude": "-44.08205000"
                    },
                    {
                        "id": 11912,
                        "name": "Galiléia",
                        "latitude": "-18.86897000",
                        "longitude": "-41.52503000"
                    },
                    {
                        "id": 11917,
                        "name": "Gameleiras",
                        "latitude": "-14.97096000",
                        "longitude": "-43.30610000"
                    },
                    {
                        "id": 11947,
                        "name": "Glaucilândia",
                        "latitude": "-16.89532000",
                        "longitude": "-43.66081000"
                    },
                    {
                        "id": 11956,
                        "name": "Goiabeira",
                        "latitude": "-19.02964000",
                        "longitude": "-41.22725000"
                    },
                    {
                        "id": 11962,
                        "name": "Goianá",
                        "latitude": "-21.56063000",
                        "longitude": "-43.18511000"
                    },
                    {
                        "id": 11974,
                        "name": "Gonçalves",
                        "latitude": "-22.67479000",
                        "longitude": "-45.83780000"
                    },
                    {
                        "id": 11973,
                        "name": "Gonzaga",
                        "latitude": "-18.87874000",
                        "longitude": "-42.49507000"
                    },
                    {
                        "id": 11976,
                        "name": "Gouveia",
                        "latitude": "-18.53580000",
                        "longitude": "-43.85363000"
                    },
                    {
                        "id": 11990,
                        "name": "Governador Valadares",
                        "latitude": "-18.85111000",
                        "longitude": "-41.94944000"
                    },
                    {
                        "id": 12008,
                        "name": "Grão Mogol",
                        "latitude": "-16.49009000",
                        "longitude": "-42.96535000"
                    },
                    {
                        "id": 12007,
                        "name": "Grupiara",
                        "latitude": "-18.47962000",
                        "longitude": "-47.77141000"
                    },
                    {
                        "id": 12025,
                        "name": "Guanhães",
                        "latitude": "-18.85705000",
                        "longitude": "-42.80520000"
                    },
                    {
                        "id": 12032,
                        "name": "Guapé",
                        "latitude": "-20.77404000",
                        "longitude": "-45.89935000"
                    },
                    {
                        "id": 12037,
                        "name": "Guaraciaba",
                        "latitude": "-20.56919000",
                        "longitude": "-43.01146000"
                    },
                    {
                        "id": 12040,
                        "name": "Guaraciama",
                        "latitude": "-17.08074000",
                        "longitude": "-43.60308000"
                    },
                    {
                        "id": 12050,
                        "name": "Guaranésia",
                        "latitude": "-21.28820000",
                        "longitude": "-46.82229000"
                    },
                    {
                        "id": 12043,
                        "name": "Guarani",
                        "latitude": "-21.35038000",
                        "longitude": "-43.05888000"
                    },
                    {
                        "id": 12056,
                        "name": "Guarará",
                        "latitude": "-21.75802000",
                        "longitude": "-43.02469000"
                    },
                    {
                        "id": 12063,
                        "name": "Guarda-Mor",
                        "latitude": "-17.76393000",
                        "longitude": "-47.14784000"
                    },
                    {
                        "id": 12074,
                        "name": "Guaxupé",
                        "latitude": "-21.29181000",
                        "longitude": "-46.68110000"
                    },
                    {
                        "id": 12080,
                        "name": "Guidoval",
                        "latitude": "-21.17678000",
                        "longitude": "-42.79015000"
                    },
                    {
                        "id": 12081,
                        "name": "Guimarânia",
                        "latitude": "-18.81689000",
                        "longitude": "-46.73553000"
                    },
                    {
                        "id": 12084,
                        "name": "Guiricema",
                        "latitude": "-21.01294000",
                        "longitude": "-42.69893000"
                    },
                    {
                        "id": 12085,
                        "name": "Gurinhatã",
                        "latitude": "-19.06643000",
                        "longitude": "-49.86875000"
                    },
                    {
                        "id": 12094,
                        "name": "Heliodora",
                        "latitude": "-22.04159000",
                        "longitude": "-45.54430000"
                    },
                    {
                        "id": 12116,
                        "name": "Iapu",
                        "latitude": "-19.35090000",
                        "longitude": "-42.23727000"
                    },
                    {
                        "id": 12127,
                        "name": "Ibertioga",
                        "latitude": "-21.45140000",
                        "longitude": "-43.94316000"
                    },
                    {
                        "id": 12164,
                        "name": "Ibiá",
                        "latitude": "-19.54368000",
                        "longitude": "-46.61732000"
                    },
                    {
                        "id": 12133,
                        "name": "Ibiaí",
                        "latitude": "-16.81004000",
                        "longitude": "-44.79235000"
                    },
                    {
                        "id": 12144,
                        "name": "Ibiracatu",
                        "latitude": "-15.66695000",
                        "longitude": "-44.13281000"
                    },
                    {
                        "id": 12145,
                        "name": "Ibiraci",
                        "latitude": "-20.40137000",
                        "longitude": "-47.14267000"
                    },
                    {
                        "id": 12155,
                        "name": "Ibirité",
                        "latitude": "-20.02194000",
                        "longitude": "-44.05889000"
                    },
                    {
                        "id": 12162,
                        "name": "Ibitiúra de Minas",
                        "latitude": "-22.06721000",
                        "longitude": "-46.40735000"
                    },
                    {
                        "id": 12163,
                        "name": "Ibituruna",
                        "latitude": "-21.16363000",
                        "longitude": "-44.77552000"
                    },
                    {
                        "id": 12168,
                        "name": "Icaraí de Minas",
                        "latitude": "-16.22108000",
                        "longitude": "-44.85922000"
                    },
                    {
                        "id": 12181,
                        "name": "Igarapé",
                        "latitude": "-20.05423000",
                        "longitude": "-44.31636000"
                    },
                    {
                        "id": 12189,
                        "name": "Igaratinga",
                        "latitude": "-19.96011000",
                        "longitude": "-44.72106000"
                    },
                    {
                        "id": 12199,
                        "name": "Iguatama",
                        "latitude": "-20.14528000",
                        "longitude": "-45.74194000"
                    },
                    {
                        "id": 12204,
                        "name": "Ijaci",
                        "latitude": "-21.18351000",
                        "longitude": "-44.92240000"
                    },
                    {
                        "id": 12215,
                        "name": "Ilicínea",
                        "latitude": "-20.93023000",
                        "longitude": "-45.81821000"
                    },
                    {
                        "id": 12224,
                        "name": "Imbé de Minas",
                        "latitude": "-19.61863000",
                        "longitude": "-41.96773000"
                    },
                    {
                        "id": 12230,
                        "name": "Inconfidentes",
                        "latitude": "-22.34042000",
                        "longitude": "-46.28495000"
                    },
                    {
                        "id": 12231,
                        "name": "Indaiabira",
                        "latitude": "-15.57633000",
                        "longitude": "-42.15728000"
                    },
                    {
                        "id": 12237,
                        "name": "Indianópolis",
                        "latitude": "-18.97216000",
                        "longitude": "-47.88555000"
                    },
                    {
                        "id": 12244,
                        "name": "Ingaí",
                        "latitude": "-21.41317000",
                        "longitude": "-44.93685000"
                    },
                    {
                        "id": 12250,
                        "name": "Inhapim",
                        "latitude": "-19.48349000",
                        "longitude": "-42.10953000"
                    },
                    {
                        "id": 12251,
                        "name": "Inhaúma",
                        "latitude": "-19.49972000",
                        "longitude": "-44.42415000"
                    },
                    {
                        "id": 12254,
                        "name": "Inimutaba",
                        "latitude": "-18.71149000",
                        "longitude": "-44.27571000"
                    },
                    {
                        "id": 12259,
                        "name": "Ipaba",
                        "latitude": "-19.40560000",
                        "longitude": "-42.36072000"
                    },
                    {
                        "id": 12261,
                        "name": "Ipanema",
                        "latitude": "-19.75724000",
                        "longitude": "-41.76801000"
                    },
                    {
                        "id": 12264,
                        "name": "Ipatinga",
                        "latitude": "-19.46833000",
                        "longitude": "-42.53667000"
                    },
                    {
                        "id": 12271,
                        "name": "Ipiaçu",
                        "latitude": "-18.70679000",
                        "longitude": "-49.91749000"
                    },
                    {
                        "id": 12295,
                        "name": "Ipuiúna",
                        "latitude": "-22.00732000",
                        "longitude": "-46.12468000"
                    },
                    {
                        "id": 12316,
                        "name": "Iraí de Minas",
                        "latitude": "-19.06330000",
                        "longitude": "-47.43698000"
                    },
                    {
                        "id": 12333,
                        "name": "Itabira",
                        "latitude": "-19.61917000",
                        "longitude": "-43.22694000"
                    },
                    {
                        "id": 12334,
                        "name": "Itabirinha",
                        "latitude": "-18.52982000",
                        "longitude": "-41.25370000"
                    },
                    {
                        "id": 12335,
                        "name": "Itabirito",
                        "latitude": "-20.23843000",
                        "longitude": "-43.78016000"
                    },
                    {
                        "id": 12339,
                        "name": "Itacambira",
                        "latitude": "-16.88654000",
                        "longitude": "-43.30766000"
                    },
                    {
                        "id": 12340,
                        "name": "Itacarambi",
                        "latitude": "-15.10222000",
                        "longitude": "-44.09194000"
                    },
                    {
                        "id": 12351,
                        "name": "Itaguara",
                        "latitude": "-20.37868000",
                        "longitude": "-44.54609000"
                    },
                    {
                        "id": 12361,
                        "name": "Itaipé",
                        "latitude": "-17.42738000",
                        "longitude": "-41.65509000"
                    },
                    {
                        "id": 12370,
                        "name": "Itajubá",
                        "latitude": "-22.42051000",
                        "longitude": "-45.42137000"
                    },
                    {
                        "id": 12377,
                        "name": "Itamarandiba",
                        "latitude": "-17.85429000",
                        "longitude": "-42.89409000"
                    },
                    {
                        "id": 12379,
                        "name": "Itamarati de Minas",
                        "latitude": "-21.41883000",
                        "longitude": "-42.83387000"
                    },
                    {
                        "id": 12381,
                        "name": "Itambacuri",
                        "latitude": "-18.18510000",
                        "longitude": "-41.88894000"
                    },
                    {
                        "id": 12386,
                        "name": "Itambé do Mato Dentro",
                        "latitude": "-19.40318000",
                        "longitude": "-43.34103000"
                    },
                    {
                        "id": 12387,
                        "name": "Itamogi",
                        "latitude": "-21.08608000",
                        "longitude": "-47.05061000"
                    },
                    {
                        "id": 12388,
                        "name": "Itamonte",
                        "latitude": "-22.28733000",
                        "longitude": "-44.75274000"
                    },
                    {
                        "id": 12390,
                        "name": "Itanhandu",
                        "latitude": "-22.29583000",
                        "longitude": "-44.93472000"
                    },
                    {
                        "id": 12393,
                        "name": "Itanhomi",
                        "latitude": "-19.15484000",
                        "longitude": "-41.83333000"
                    },
                    {
                        "id": 12395,
                        "name": "Itaobim",
                        "latitude": "-16.56326000",
                        "longitude": "-41.53486000"
                    },
                    {
                        "id": 12399,
                        "name": "Itapagipe",
                        "latitude": "-19.75086000",
                        "longitude": "-49.42853000"
                    },
                    {
                        "id": 12404,
                        "name": "Itapecerica",
                        "latitude": "-20.45398000",
                        "longitude": "-45.08814000"
                    },
                    {
                        "id": 12415,
                        "name": "Itapeva",
                        "latitude": "-22.69829000",
                        "longitude": "-46.21291000"
                    },
                    {
                        "id": 12455,
                        "name": "Itatiaiuçu",
                        "latitude": "-20.22155000",
                        "longitude": "-44.46588000"
                    },
                    {
                        "id": 12469,
                        "name": "Itaú de Minas",
                        "latitude": "-20.71790000",
                        "longitude": "-46.77932000"
                    },
                    {
                        "id": 12471,
                        "name": "Itaúna",
                        "latitude": "-20.07440000",
                        "longitude": "-44.58626000"
                    },
                    {
                        "id": 12465,
                        "name": "Itaverava",
                        "latitude": "-20.70813000",
                        "longitude": "-43.59276000"
                    },
                    {
                        "id": 12473,
                        "name": "Itinga",
                        "latitude": "-16.60721000",
                        "longitude": "-41.83181000"
                    },
                    {
                        "id": 12485,
                        "name": "Itueta",
                        "latitude": "-19.37775000",
                        "longitude": "-41.09757000"
                    },
                    {
                        "id": 12486,
                        "name": "Ituiutaba",
                        "latitude": "-19.01507000",
                        "longitude": "-49.55042000"
                    },
                    {
                        "id": 12488,
                        "name": "Itumirim",
                        "latitude": "-21.28468000",
                        "longitude": "-44.83316000"
                    },
                    {
                        "id": 12492,
                        "name": "Iturama",
                        "latitude": "-19.69460000",
                        "longitude": "-50.38219000"
                    },
                    {
                        "id": 12493,
                        "name": "Itutinga",
                        "latitude": "-21.34817000",
                        "longitude": "-44.72387000"
                    },
                    {
                        "id": 12516,
                        "name": "Jaboticatubas",
                        "latitude": "-19.41909000",
                        "longitude": "-43.74554000"
                    },
                    {
                        "id": 12525,
                        "name": "Jacinto",
                        "latitude": "-16.19209000",
                        "longitude": "-40.33175000"
                    },
                    {
                        "id": 12534,
                        "name": "Jacuí",
                        "latitude": "-21.01103000",
                        "longitude": "-46.71842000"
                    },
                    {
                        "id": 12533,
                        "name": "Jacutinga",
                        "latitude": "-22.29632000",
                        "longitude": "-46.61044000"
                    },
                    {
                        "id": 12539,
                        "name": "Jaguaraçu",
                        "latitude": "-19.63591000",
                        "longitude": "-42.71705000"
                    },
                    {
                        "id": 12608,
                        "name": "Jaíba",
                        "latitude": "-15.21645000",
                        "longitude": "-43.67032000"
                    },
                    {
                        "id": 12554,
                        "name": "Jampruca",
                        "latitude": "-18.47226000",
                        "longitude": "-41.75735000"
                    },
                    {
                        "id": 12555,
                        "name": "Janaúba",
                        "latitude": "-15.77877000",
                        "longitude": "-43.36757000"
                    },
                    {
                        "id": 12564,
                        "name": "Januária",
                        "latitude": "-15.32133000",
                        "longitude": "-45.20135000"
                    },
                    {
                        "id": 12568,
                        "name": "Japaraíba",
                        "latitude": "-20.12931000",
                        "longitude": "-45.53733000"
                    },
                    {
                        "id": 12573,
                        "name": "Japonvar",
                        "latitude": "-15.94720000",
                        "longitude": "-44.34835000"
                    },
                    {
                        "id": 12611,
                        "name": "Jeceaba",
                        "latitude": "-20.55578000",
                        "longitude": "-44.03107000"
                    },
                    {
                        "id": 12612,
                        "name": "Jenipapo de Minas",
                        "latitude": "-17.18727000",
                        "longitude": "-42.21222000"
                    },
                    {
                        "id": 12614,
                        "name": "Jequeri",
                        "latitude": "-20.48079000",
                        "longitude": "-42.61567000"
                    },
                    {
                        "id": 12615,
                        "name": "Jequitaí",
                        "latitude": "-17.16894000",
                        "longitude": "-44.46191000"
                    },
                    {
                        "id": 12616,
                        "name": "Jequitibá",
                        "latitude": "-19.21472000",
                        "longitude": "-44.03049000"
                    },
                    {
                        "id": 12617,
                        "name": "Jequitinhonha",
                        "latitude": "-16.40683000",
                        "longitude": "-41.05778000"
                    },
                    {
                        "id": 12625,
                        "name": "Jesuânia",
                        "latitude": "-22.00846000",
                        "longitude": "-45.28235000"
                    },
                    {
                        "id": 12642,
                        "name": "Joaíma",
                        "latitude": "-16.80375000",
                        "longitude": "-41.01105000"
                    },
                    {
                        "id": 12634,
                        "name": "Joanésia",
                        "latitude": "-19.20319000",
                        "longitude": "-42.70665000"
                    },
                    {
                        "id": 12663,
                        "name": "João Monlevade",
                        "latitude": "-19.83861000",
                        "longitude": "-43.15561000"
                    },
                    {
                        "id": 12666,
                        "name": "João Pinheiro",
                        "latitude": "-17.55732000",
                        "longitude": "-45.97307000"
                    },
                    {
                        "id": 12636,
                        "name": "Joaquim Felício",
                        "latitude": "-17.62324000",
                        "longitude": "-44.09366000"
                    },
                    {
                        "id": 12646,
                        "name": "Jordânia",
                        "latitude": "-15.87487000",
                        "longitude": "-40.30532000"
                    },
                    {
                        "id": 12652,
                        "name": "José Gonçalves de Minas",
                        "latitude": "-16.90496000",
                        "longitude": "-42.66905000"
                    },
                    {
                        "id": 12653,
                        "name": "José Raydan",
                        "latitude": "-18.26371000",
                        "longitude": "-42.46528000"
                    },
                    {
                        "id": 12649,
                        "name": "Josenópolis",
                        "latitude": "-16.55307000",
                        "longitude": "-42.51701000"
                    },
                    {
                        "id": 12671,
                        "name": "Juatuba",
                        "latitude": "-19.95194000",
                        "longitude": "-44.34278000"
                    },
                    {
                        "id": 12680,
                        "name": "Juiz de Fora",
                        "latitude": "-21.76417000",
                        "longitude": "-43.35028000"
                    },
                    {
                        "id": 12694,
                        "name": "Juramento",
                        "latitude": "-16.83343000",
                        "longitude": "-43.58833000"
                    },
                    {
                        "id": 12700,
                        "name": "Juruaia",
                        "latitude": "-21.22649000",
                        "longitude": "-46.51449000"
                    },
                    {
                        "id": 12712,
                        "name": "Juvenília",
                        "latitude": "-14.39930000",
                        "longitude": "-43.95055000"
                    },
                    {
                        "id": 12722,
                        "name": "Ladainha",
                        "latitude": "-17.64365000",
                        "longitude": "-41.83262000"
                    },
                    {
                        "id": 12725,
                        "name": "Lagamar",
                        "latitude": "-17.97706000",
                        "longitude": "-46.70095000"
                    },
                    {
                        "id": 12751,
                        "name": "Lagoa da Prata",
                        "latitude": "-19.99802000",
                        "longitude": "-45.49952000"
                    },
                    {
                        "id": 12766,
                        "name": "Lagoa dos Patos",
                        "latitude": "-17.01433000",
                        "longitude": "-44.66633000"
                    },
                    {
                        "id": 12736,
                        "name": "Lagoa Dourada",
                        "latitude": "-20.91034000",
                        "longitude": "-44.06512000"
                    },
                    {
                        "id": 12737,
                        "name": "Lagoa Formosa",
                        "latitude": "-18.76494000",
                        "longitude": "-46.29006000"
                    },
                    {
                        "id": 12739,
                        "name": "Lagoa Grande",
                        "latitude": "-17.74523000",
                        "longitude": "-46.53558000"
                    },
                    {
                        "id": 12744,
                        "name": "Lagoa Santa",
                        "latitude": "-19.62683000",
                        "longitude": "-43.87993000"
                    },
                    {
                        "id": 12786,
                        "name": "Lajinha",
                        "latitude": "-20.12411000",
                        "longitude": "-41.61531000"
                    },
                    {
                        "id": 12788,
                        "name": "Lambari",
                        "latitude": "-21.98590000",
                        "longitude": "-45.35167000"
                    },
                    {
                        "id": 12790,
                        "name": "Lamim",
                        "latitude": "-20.77481000",
                        "longitude": "-43.48487000"
                    },
                    {
                        "id": 12795,
                        "name": "Laranjal",
                        "latitude": "-21.35920000",
                        "longitude": "-42.45663000"
                    },
                    {
                        "id": 12801,
                        "name": "Lassance",
                        "latitude": "-17.91014000",
                        "longitude": "-44.70859000"
                    },
                    {
                        "id": 12808,
                        "name": "Lavras",
                        "latitude": "-21.26738000",
                        "longitude": "-45.04190000"
                    },
                    {
                        "id": 12813,
                        "name": "Leandro Ferreira",
                        "latitude": "-19.67492000",
                        "longitude": "-45.06134000"
                    },
                    {
                        "id": 12816,
                        "name": "Leme do Prado",
                        "latitude": "-17.05253000",
                        "longitude": "-42.74591000"
                    },
                    {
                        "id": 12820,
                        "name": "Leopoldina",
                        "latitude": "-21.53489000",
                        "longitude": "-42.64473000"
                    },
                    {
                        "id": 12824,
                        "name": "Liberdade",
                        "latitude": "-22.01634000",
                        "longitude": "-44.34756000"
                    },
                    {
                        "id": 12828,
                        "name": "Lima Duarte",
                        "latitude": "-21.79037000",
                        "longitude": "-43.89583000"
                    },
                    {
                        "id": 12830,
                        "name": "Limeira do Oeste",
                        "latitude": "-19.38786000",
                        "longitude": "-50.61280000"
                    },
                    {
                        "id": 12850,
                        "name": "Lontra",
                        "latitude": "-15.83942000",
                        "longitude": "-44.27821000"
                    },
                    {
                        "id": 12863,
                        "name": "Luisburgo",
                        "latitude": "-20.44641000",
                        "longitude": "-42.07286000"
                    },
                    {
                        "id": 12864,
                        "name": "Luislândia",
                        "latitude": "-16.19922000",
                        "longitude": "-44.60969000"
                    },
                    {
                        "id": 12868,
                        "name": "Luminárias",
                        "latitude": "-21.51526000",
                        "longitude": "-44.92617000"
                    },
                    {
                        "id": 12873,
                        "name": "Luz",
                        "latitude": "-19.84190000",
                        "longitude": "-45.67539000"
                    },
                    {
                        "id": 12897,
                        "name": "Machacalis",
                        "latitude": "-17.08810000",
                        "longitude": "-40.71826000"
                    },
                    {
                        "id": 12900,
                        "name": "Machado",
                        "latitude": "-21.69549000",
                        "longitude": "-45.88809000"
                    },
                    {
                        "id": 12908,
                        "name": "Madre de Deus de Minas",
                        "latitude": "-21.48464000",
                        "longitude": "-44.33264000"
                    },
                    {
                        "id": 12924,
                        "name": "Malacacheta",
                        "latitude": "-17.83800000",
                        "longitude": "-42.08895000"
                    },
                    {
                        "id": 12934,
                        "name": "Mamonas",
                        "latitude": "-15.03302000",
                        "longitude": "-42.94513000"
                    },
                    {
                        "id": 12946,
                        "name": "Manga",
                        "latitude": "-14.65871000",
                        "longitude": "-44.12621000"
                    },
                    {
                        "id": 12949,
                        "name": "Manhuaçu",
                        "latitude": "-20.18647000",
                        "longitude": "-42.08653000"
                    },
                    {
                        "id": 12950,
                        "name": "Manhumirim",
                        "latitude": "-20.34755000",
                        "longitude": "-41.93559000"
                    },
                    {
                        "id": 12958,
                        "name": "Mantena",
                        "latitude": "-18.68550000",
                        "longitude": "-41.10755000"
                    },
                    {
                        "id": 12962,
                        "name": "Mar de Espanha",
                        "latitude": "-21.87597000",
                        "longitude": "-43.02192000"
                    },
                    {
                        "id": 12987,
                        "name": "Maravilhas",
                        "latitude": "-19.51232000",
                        "longitude": "-44.67995000"
                    },
                    {
                        "id": 13005,
                        "name": "Maria da Fé",
                        "latitude": "-22.32718000",
                        "longitude": "-45.31720000"
                    },
                    {
                        "id": 13007,
                        "name": "Mariana",
                        "latitude": "-20.37778000",
                        "longitude": "-43.41611000"
                    },
                    {
                        "id": 13013,
                        "name": "Marilac",
                        "latitude": "-18.49516000",
                        "longitude": "-42.06556000"
                    },
                    {
                        "id": 13290,
                        "name": "Mário Campos",
                        "latitude": "-20.07230000",
                        "longitude": "-44.17602000"
                    },
                    {
                        "id": 13021,
                        "name": "Maripá de Minas",
                        "latitude": "-21.70096000",
                        "longitude": "-42.95929000"
                    },
                    {
                        "id": 13026,
                        "name": "Marliéria",
                        "latitude": "-19.69241000",
                        "longitude": "-42.62724000"
                    },
                    {
                        "id": 13028,
                        "name": "Marmelópolis",
                        "latitude": "-22.45970000",
                        "longitude": "-45.16973000"
                    },
                    {
                        "id": 13031,
                        "name": "Martinho Campos",
                        "latitude": "-19.42013000",
                        "longitude": "-45.17974000"
                    },
                    {
                        "id": 13033,
                        "name": "Martins Soares",
                        "latitude": "-20.25994000",
                        "longitude": "-41.83980000"
                    },
                    {
                        "id": 13048,
                        "name": "Mata Verde",
                        "latitude": "-15.76794000",
                        "longitude": "-40.69882000"
                    },
                    {
                        "id": 13053,
                        "name": "Materlândia",
                        "latitude": "-18.44658000",
                        "longitude": "-43.01437000"
                    },
                    {
                        "id": 13054,
                        "name": "Mateus Leme",
                        "latitude": "-20.01630000",
                        "longitude": "-44.43422000"
                    },
                    {
                        "id": 13055,
                        "name": "Mathias Lobato",
                        "latitude": "-18.60479000",
                        "longitude": "-41.96192000"
                    },
                    {
                        "id": 13056,
                        "name": "Matias Barbosa",
                        "latitude": "-21.87484000",
                        "longitude": "-43.30507000"
                    },
                    {
                        "id": 13057,
                        "name": "Matias Cardoso",
                        "latitude": "-14.84562000",
                        "longitude": "-43.69791000"
                    },
                    {
                        "id": 13063,
                        "name": "Matipó",
                        "latitude": "-20.30226000",
                        "longitude": "-42.31613000"
                    },
                    {
                        "id": 13069,
                        "name": "Mato Verde",
                        "latitude": "-15.42884000",
                        "longitude": "-42.87463000"
                    },
                    {
                        "id": 13071,
                        "name": "Matozinhos",
                        "latitude": "-19.52070000",
                        "longitude": "-44.05031000"
                    },
                    {
                        "id": 13076,
                        "name": "Matutina",
                        "latitude": "-19.19364000",
                        "longitude": "-45.99564000"
                    },
                    {
                        "id": 13090,
                        "name": "Medeiros",
                        "latitude": "-20.01139000",
                        "longitude": "-46.35800000"
                    },
                    {
                        "id": 13094,
                        "name": "Medina",
                        "latitude": "-16.30152000",
                        "longitude": "-41.53818000"
                    },
                    {
                        "id": 13098,
                        "name": "Mendes Pimentel",
                        "latitude": "-18.62642000",
                        "longitude": "-41.34871000"
                    },
                    {
                        "id": 13101,
                        "name": "Mercês",
                        "latitude": "-21.18716000",
                        "longitude": "-43.33657000"
                    },
                    {
                        "id": 13105,
                        "name": "Mesquita",
                        "latitude": "-19.24964000",
                        "longitude": "-42.61603000"
                    },
                    {
                        "id": 13122,
                        "name": "Minas Novas",
                        "latitude": "-17.35500000",
                        "longitude": "-42.40892000"
                    },
                    {
                        "id": 13125,
                        "name": "Minduri",
                        "latitude": "-21.66835000",
                        "longitude": "-44.59475000"
                    },
                    {
                        "id": 13130,
                        "name": "Mirabela",
                        "latitude": "-16.27910000",
                        "longitude": "-44.16713000"
                    },
                    {
                        "id": 13136,
                        "name": "Miradouro",
                        "latitude": "-20.85191000",
                        "longitude": "-42.38714000"
                    },
                    {
                        "id": 13153,
                        "name": "Miraí",
                        "latitude": "-21.14581000",
                        "longitude": "-42.60077000"
                    },
                    {
                        "id": 13152,
                        "name": "Miravânia",
                        "latitude": "-14.75285000",
                        "longitude": "-44.42057000"
                    },
                    {
                        "id": 13162,
                        "name": "Moeda",
                        "latitude": "-20.33273000",
                        "longitude": "-44.01660000"
                    },
                    {
                        "id": 13163,
                        "name": "Moema",
                        "latitude": "-19.84295000",
                        "longitude": "-45.42119000"
                    },
                    {
                        "id": 13176,
                        "name": "Monjolos",
                        "latitude": "-18.37562000",
                        "longitude": "-44.02596000"
                    },
                    {
                        "id": 13179,
                        "name": "Monsenhor Paulo",
                        "latitude": "-21.72267000",
                        "longitude": "-45.46795000"
                    },
                    {
                        "id": 13182,
                        "name": "Montalvânia",
                        "latitude": "-14.41086000",
                        "longitude": "-44.44214000"
                    },
                    {
                        "id": 13189,
                        "name": "Monte Alegre de Minas",
                        "latitude": "-18.81882000",
                        "longitude": "-48.91823000"
                    },
                    {
                        "id": 13196,
                        "name": "Monte Azul",
                        "latitude": "-15.21266000",
                        "longitude": "-43.02334000"
                    },
                    {
                        "id": 13198,
                        "name": "Monte Belo",
                        "latitude": "-21.32001000",
                        "longitude": "-46.33519000"
                    },
                    {
                        "id": 13201,
                        "name": "Monte Carmelo",
                        "latitude": "-18.63960000",
                        "longitude": "-47.49788000"
                    },
                    {
                        "id": 13204,
                        "name": "Monte Formoso",
                        "latitude": "-16.87599000",
                        "longitude": "-41.27134000"
                    },
                    {
                        "id": 13209,
                        "name": "Monte Santo de Minas",
                        "latitude": "-21.20428000",
                        "longitude": "-46.95403000"
                    },
                    {
                        "id": 13211,
                        "name": "Monte Sião",
                        "latitude": "-22.43134000",
                        "longitude": "-46.56796000"
                    },
                    {
                        "id": 13212,
                        "name": "Monte Verde",
                        "latitude": "-22.86417000",
                        "longitude": "-46.03500000"
                    },
                    {
                        "id": 13220,
                        "name": "Montes Claros",
                        "latitude": "-16.58789000",
                        "longitude": "-43.89995000"
                    },
                    {
                        "id": 13222,
                        "name": "Montezuma",
                        "latitude": "-15.19248000",
                        "longitude": "-42.48132000"
                    },
                    {
                        "id": 13228,
                        "name": "Morada Nova de Minas",
                        "latitude": "-18.56612000",
                        "longitude": "-45.47222000"
                    },
                    {
                        "id": 13247,
                        "name": "Morro da Garça",
                        "latitude": "-18.61746000",
                        "longitude": "-44.63238000"
                    },
                    {
                        "id": 13250,
                        "name": "Morro do Pilar",
                        "latitude": "-19.23372000",
                        "longitude": "-43.40140000"
                    },
                    {
                        "id": 13272,
                        "name": "Munhoz",
                        "latitude": "-22.62898000",
                        "longitude": "-46.30889000"
                    },
                    {
                        "id": 13278,
                        "name": "Muriaé",
                        "latitude": "-21.13056000",
                        "longitude": "-42.36639000"
                    },
                    {
                        "id": 13285,
                        "name": "Mutum",
                        "latitude": "-19.92677000",
                        "longitude": "-41.44835000"
                    },
                    {
                        "id": 13288,
                        "name": "Muzambinho",
                        "latitude": "-21.35240000",
                        "longitude": "-46.51842000"
                    },
                    {
                        "id": 13294,
                        "name": "Nacip Raydan",
                        "latitude": "-18.47447000",
                        "longitude": "-42.17506000"
                    },
                    {
                        "id": 13296,
                        "name": "Nanuque",
                        "latitude": "-17.73565000",
                        "longitude": "-40.44441000"
                    },
                    {
                        "id": 13297,
                        "name": "Naque",
                        "latitude": "-19.18321000",
                        "longitude": "-42.33843000"
                    },
                    {
                        "id": 13300,
                        "name": "Natalândia",
                        "latitude": "-16.56307000",
                        "longitude": "-46.51392000"
                    },
                    {
                        "id": 13305,
                        "name": "Natércia",
                        "latitude": "-22.13227000",
                        "longitude": "-45.49689000"
                    },
                    {
                        "id": 13308,
                        "name": "Nazareno",
                        "latitude": "-21.20793000",
                        "longitude": "-44.60851000"
                    },
                    {
                        "id": 13317,
                        "name": "Nepomuceno",
                        "latitude": "-21.24027000",
                        "longitude": "-45.24015000"
                    },
                    {
                        "id": 13327,
                        "name": "Ninheira",
                        "latitude": "-15.42231000",
                        "longitude": "-41.65775000"
                    },
                    {
                        "id": 13357,
                        "name": "Nova Belém",
                        "latitude": "-18.49977000",
                        "longitude": "-41.11879000"
                    },
                    {
                        "id": 13372,
                        "name": "Nova Era",
                        "latitude": "-19.70970000",
                        "longitude": "-43.01401000"
                    },
                    {
                        "id": 13398,
                        "name": "Nova Lima",
                        "latitude": "-19.98556000",
                        "longitude": "-43.84667000"
                    },
                    {
                        "id": 13406,
                        "name": "Nova Módica",
                        "latitude": "-18.45009000",
                        "longitude": "-41.51304000"
                    },
                    {
                        "id": 13419,
                        "name": "Nova Ponte",
                        "latitude": "-19.28646000",
                        "longitude": "-47.71367000"
                    },
                    {
                        "id": 13420,
                        "name": "Nova Porteirinha",
                        "latitude": "-15.71578000",
                        "longitude": "-43.28155000"
                    },
                    {
                        "id": 13426,
                        "name": "Nova Resende",
                        "latitude": "-21.09898000",
                        "longitude": "-46.41684000"
                    },
                    {
                        "id": 13436,
                        "name": "Nova Serrana",
                        "latitude": "-19.84529000",
                        "longitude": "-44.97669000"
                    },
                    {
                        "id": 13443,
                        "name": "Nova União",
                        "latitude": "-19.64356000",
                        "longitude": "-43.57796000"
                    },
                    {
                        "id": 13457,
                        "name": "Novo Cruzeiro",
                        "latitude": "-17.39233000",
                        "longitude": "-41.96978000"
                    },
                    {
                        "id": 13472,
                        "name": "Novo Oriente de Minas",
                        "latitude": "-17.25169000",
                        "longitude": "-41.22927000"
                    },
                    {
                        "id": 13483,
                        "name": "Novorizonte",
                        "latitude": "-16.01733000",
                        "longitude": "-42.38889000"
                    },
                    {
                        "id": 13493,
                        "name": "Olaria",
                        "latitude": "-21.90638000",
                        "longitude": "-43.96851000"
                    },
                    {
                        "id": 13501,
                        "name": "Olhos-d'Água",
                        "latitude": "-17.48888000",
                        "longitude": "-43.54347000"
                    },
                    {
                        "id": 13512,
                        "name": "Olímpio Noronha",
                        "latitude": "-22.08551000",
                        "longitude": "-45.28730000"
                    },
                    {
                        "id": 13506,
                        "name": "Oliveira",
                        "latitude": "-20.73820000",
                        "longitude": "-44.71612000"
                    },
                    {
                        "id": 13507,
                        "name": "Oliveira Fortes",
                        "latitude": "-21.33869000",
                        "longitude": "-43.51985000"
                    },
                    {
                        "id": 13514,
                        "name": "Onça de Pitangui",
                        "latitude": "-19.71041000",
                        "longitude": "-44.74654000"
                    },
                    {
                        "id": 13515,
                        "name": "Oratórios",
                        "latitude": "-20.43729000",
                        "longitude": "-42.79741000"
                    },
                    {
                        "id": 13520,
                        "name": "Orizânia",
                        "latitude": "-20.50549000",
                        "longitude": "-42.21156000"
                    },
                    {
                        "id": 13540,
                        "name": "Ouro Branco",
                        "latitude": "-20.52994000",
                        "longitude": "-43.69422000"
                    },
                    {
                        "id": 13541,
                        "name": "Ouro Fino",
                        "latitude": "-22.25689000",
                        "longitude": "-46.37384000"
                    },
                    {
                        "id": 13542,
                        "name": "Ouro Preto",
                        "latitude": "-20.39304000",
                        "longitude": "-43.64191000"
                    },
                    {
                        "id": 13548,
                        "name": "Ouro Verde de Minas",
                        "latitude": "-18.03431000",
                        "longitude": "-41.29473000"
                    },
                    {
                        "id": 13562,
                        "name": "Padre Carvalho",
                        "latitude": "-16.26316000",
                        "longitude": "-42.60251000"
                    },
                    {
                        "id": 13564,
                        "name": "Padre Paraíso",
                        "latitude": "-17.06100000",
                        "longitude": "-41.53826000"
                    },
                    {
                        "id": 13566,
                        "name": "Pai Pedro",
                        "latitude": "-15.32734000",
                        "longitude": "-43.19505000"
                    },
                    {
                        "id": 13569,
                        "name": "Paineiras",
                        "latitude": "-18.91817000",
                        "longitude": "-45.53737000"
                    },
                    {
                        "id": 13571,
                        "name": "Pains",
                        "latitude": "-20.37374000",
                        "longitude": "-45.73139000"
                    },
                    {
                        "id": 13572,
                        "name": "Paiva",
                        "latitude": "-21.28809000",
                        "longitude": "-43.41715000"
                    },
                    {
                        "id": 13581,
                        "name": "Palma",
                        "latitude": "-21.43106000",
                        "longitude": "-42.32065000"
                    },
                    {
                        "id": 13610,
                        "name": "Palmópolis",
                        "latitude": "-16.77843000",
                        "longitude": "-40.37475000"
                    },
                    {
                        "id": 13620,
                        "name": "Papagaios",
                        "latitude": "-19.39686000",
                        "longitude": "-44.69502000"
                    },
                    {
                        "id": 13684,
                        "name": "Pará de Minas",
                        "latitude": "-19.82122000",
                        "longitude": "-44.61286000"
                    },
                    {
                        "id": 13624,
                        "name": "Paracatu",
                        "latitude": "-17.13285000",
                        "longitude": "-46.88258000"
                    },
                    {
                        "id": 13627,
                        "name": "Paraguaçu",
                        "latitude": "-21.58081000",
                        "longitude": "-45.74296000"
                    },
                    {
                        "id": 13632,
                        "name": "Paraisópolis",
                        "latitude": "-22.57668000",
                        "longitude": "-45.84583000"
                    },
                    {
                        "id": 13650,
                        "name": "Paraopeba",
                        "latitude": "-19.27228000",
                        "longitude": "-44.45274000"
                    },
                    {
                        "id": 13685,
                        "name": "Passa Quatro",
                        "latitude": "-22.40871000",
                        "longitude": "-44.95994000"
                    },
                    {
                        "id": 13687,
                        "name": "Passa Tempo",
                        "latitude": "-20.64350000",
                        "longitude": "-44.49857000"
                    },
                    {
                        "id": 13689,
                        "name": "Passa-Vinte",
                        "latitude": "-22.17877000",
                        "longitude": "-44.26002000"
                    },
                    {
                        "id": 13690,
                        "name": "Passabém",
                        "latitude": "-19.35651000",
                        "longitude": "-43.18735000"
                    },
                    {
                        "id": 13700,
                        "name": "Passos",
                        "latitude": "-20.71889000",
                        "longitude": "-46.60972000"
                    },
                    {
                        "id": 13703,
                        "name": "Patis",
                        "latitude": "-16.05798000",
                        "longitude": "-44.11137000"
                    },
                    {
                        "id": 13707,
                        "name": "Patos de Minas",
                        "latitude": "-18.57889000",
                        "longitude": "-46.51806000"
                    },
                    {
                        "id": 13709,
                        "name": "Patrocínio",
                        "latitude": "-19.01305000",
                        "longitude": "-47.06790000"
                    },
                    {
                        "id": 13711,
                        "name": "Patrocínio do Muriaé",
                        "latitude": "-21.16714000",
                        "longitude": "-42.25572000"
                    },
                    {
                        "id": 13721,
                        "name": "Paula Cândido",
                        "latitude": "-20.86034000",
                        "longitude": "-42.98154000"
                    },
                    {
                        "id": 13729,
                        "name": "Paulistas",
                        "latitude": "-18.43393000",
                        "longitude": "-42.86603000"
                    },
                    {
                        "id": 13741,
                        "name": "Pavão",
                        "latitude": "-17.46780000",
                        "longitude": "-41.07743000"
                    },
                    {
                        "id": 13822,
                        "name": "Peçanha",
                        "latitude": "-18.54540000",
                        "longitude": "-42.49385000"
                    },
                    {
                        "id": 13746,
                        "name": "Pedra Azul",
                        "latitude": "-15.96404000",
                        "longitude": "-41.22145000"
                    },
                    {
                        "id": 13748,
                        "name": "Pedra Bonita",
                        "latitude": "-20.46665000",
                        "longitude": "-42.37756000"
                    },
                    {
                        "id": 13758,
                        "name": "Pedra do Anta",
                        "latitude": "-20.59796000",
                        "longitude": "-42.71247000"
                    },
                    {
                        "id": 13759,
                        "name": "Pedra do Indaiá",
                        "latitude": "-20.28200000",
                        "longitude": "-45.21859000"
                    },
                    {
                        "id": 13752,
                        "name": "Pedra Dourada",
                        "latitude": "-20.82636000",
                        "longitude": "-42.15154000"
                    },
                    {
                        "id": 13760,
                        "name": "Pedralva",
                        "latitude": "-22.25067000",
                        "longitude": "-45.45324000"
                    },
                    {
                        "id": 13765,
                        "name": "Pedras de Maria da Cruz",
                        "latitude": "-15.63347000",
                        "longitude": "-44.30841000"
                    },
                    {
                        "id": 13771,
                        "name": "Pedrinópolis",
                        "latitude": "-19.19064000",
                        "longitude": "-47.50212000"
                    },
                    {
                        "id": 13779,
                        "name": "Pedro Leopoldo",
                        "latitude": "-19.64468000",
                        "longitude": "-44.03938000"
                    },
                    {
                        "id": 13782,
                        "name": "Pedro Teixeira",
                        "latitude": "-21.72800000",
                        "longitude": "-43.72046000"
                    },
                    {
                        "id": 13799,
                        "name": "Pequeri",
                        "latitude": "-21.81623000",
                        "longitude": "-43.14007000"
                    },
                    {
                        "id": 13800,
                        "name": "Pequi",
                        "latitude": "-19.61044000",
                        "longitude": "-44.63355000"
                    },
                    {
                        "id": 13802,
                        "name": "Perdigão",
                        "latitude": "-19.92135000",
                        "longitude": "-45.08070000"
                    },
                    {
                        "id": 13803,
                        "name": "Perdizes",
                        "latitude": "-19.36522000",
                        "longitude": "-47.15986000"
                    },
                    {
                        "id": 13804,
                        "name": "Perdões",
                        "latitude": "-21.07090000",
                        "longitude": "-45.06710000"
                    },
                    {
                        "id": 13809,
                        "name": "Periquito",
                        "latitude": "-19.04695000",
                        "longitude": "-42.21606000"
                    },
                    {
                        "id": 13815,
                        "name": "Pescador",
                        "latitude": "-18.32119000",
                        "longitude": "-41.55163000"
                    },
                    {
                        "id": 13826,
                        "name": "Piau",
                        "latitude": "-21.50206000",
                        "longitude": "-43.31473000"
                    },
                    {
                        "id": 13832,
                        "name": "Piedade de Caratinga",
                        "latitude": "-19.75899000",
                        "longitude": "-42.03936000"
                    },
                    {
                        "id": 13833,
                        "name": "Piedade de Ponte Nova",
                        "latitude": "-20.24410000",
                        "longitude": "-42.71587000"
                    },
                    {
                        "id": 13834,
                        "name": "Piedade do Rio Grande",
                        "latitude": "-21.50287000",
                        "longitude": "-44.16154000"
                    },
                    {
                        "id": 13835,
                        "name": "Piedade dos Gerais",
                        "latitude": "-20.48078000",
                        "longitude": "-44.25310000"
                    },
                    {
                        "id": 13844,
                        "name": "Pimenta",
                        "latitude": "-20.48505000",
                        "longitude": "-45.83344000"
                    },
                    {
                        "id": 13857,
                        "name": "Pingo-d'Água",
                        "latitude": "-19.73720000",
                        "longitude": "-42.42838000"
                    },
                    {
                        "id": 13877,
                        "name": "Pintópolis",
                        "latitude": "-16.01120000",
                        "longitude": "-45.21931000"
                    },
                    {
                        "id": 13885,
                        "name": "Piracema",
                        "latitude": "-20.51921000",
                        "longitude": "-44.41751000"
                    },
                    {
                        "id": 13889,
                        "name": "Pirajuba",
                        "latitude": "-19.94073000",
                        "longitude": "-48.70306000"
                    },
                    {
                        "id": 13892,
                        "name": "Piranga",
                        "latitude": "-20.62892000",
                        "longitude": "-43.28354000"
                    },
                    {
                        "id": 13895,
                        "name": "Piranguçu",
                        "latitude": "-22.56347000",
                        "longitude": "-45.51039000"
                    },
                    {
                        "id": 13894,
                        "name": "Piranguinho",
                        "latitude": "-22.34876000",
                        "longitude": "-45.59462000"
                    },
                    {
                        "id": 13899,
                        "name": "Pirapetinga",
                        "latitude": "-21.66797000",
                        "longitude": "-42.36515000"
                    },
                    {
                        "id": 13900,
                        "name": "Pirapora",
                        "latitude": "-17.41957000",
                        "longitude": "-44.85974000"
                    },
                    {
                        "id": 13913,
                        "name": "Piraúba",
                        "latitude": "-21.26468000",
                        "longitude": "-43.01397000"
                    },
                    {
                        "id": 13924,
                        "name": "Pitangui",
                        "latitude": "-19.57287000",
                        "longitude": "-44.87568000"
                    },
                    {
                        "id": 13928,
                        "name": "Piuí",
                        "latitude": "-20.46528000",
                        "longitude": "-45.95806000"
                    },
                    {
                        "id": 13927,
                        "name": "Piumhi",
                        "latitude": "-20.43261000",
                        "longitude": "-46.06077000"
                    },
                    {
                        "id": 13943,
                        "name": "Planura",
                        "latitude": "-20.06924000",
                        "longitude": "-48.67523000"
                    },
                    {
                        "id": 14047,
                        "name": "Poço Fundo",
                        "latitude": "-21.82067000",
                        "longitude": "-45.98826000"
                    },
                    {
                        "id": 14053,
                        "name": "Poços de Caldas",
                        "latitude": "-21.79340000",
                        "longitude": "-46.53571000"
                    },
                    {
                        "id": 13948,
                        "name": "Pocrane",
                        "latitude": "-19.57501000",
                        "longitude": "-41.56271000"
                    },
                    {
                        "id": 13955,
                        "name": "Pompéu",
                        "latitude": "-19.14952000",
                        "longitude": "-44.91485000"
                    },
                    {
                        "id": 13970,
                        "name": "Ponte Nova",
                        "latitude": "-20.40703000",
                        "longitude": "-42.92058000"
                    },
                    {
                        "id": 13976,
                        "name": "Ponto Chique",
                        "latitude": "-16.63769000",
                        "longitude": "-44.93803000"
                    },
                    {
                        "id": 13978,
                        "name": "Ponto dos Volantes",
                        "latitude": "-16.85440000",
                        "longitude": "-41.46344000"
                    },
                    {
                        "id": 13988,
                        "name": "Porteirinha",
                        "latitude": "-15.68690000",
                        "longitude": "-43.14041000"
                    },
                    {
                        "id": 14006,
                        "name": "Porto Firme",
                        "latitude": "-20.66732000",
                        "longitude": "-43.06871000"
                    },
                    {
                        "id": 14037,
                        "name": "Poté",
                        "latitude": "-17.79279000",
                        "longitude": "-41.76522000"
                    },
                    {
                        "id": 14038,
                        "name": "Pouso Alegre",
                        "latitude": "-22.23000000",
                        "longitude": "-45.93639000"
                    },
                    {
                        "id": 14039,
                        "name": "Pouso Alto",
                        "latitude": "-22.17957000",
                        "longitude": "-44.95271000"
                    },
                    {
                        "id": 14061,
                        "name": "Prados",
                        "latitude": "-21.10761000",
                        "longitude": "-44.06479000"
                    },
                    {
                        "id": 14069,
                        "name": "Prata",
                        "latitude": "-19.37346000",
                        "longitude": "-48.94362000"
                    },
                    {
                        "id": 14072,
                        "name": "Pratápolis",
                        "latitude": "-20.78572000",
                        "longitude": "-46.84447000"
                    },
                    {
                        "id": 14071,
                        "name": "Pratinha",
                        "latitude": "-19.74704000",
                        "longitude": "-46.42881000"
                    },
                    {
                        "id": 14076,
                        "name": "Presidente Bernardes",
                        "latitude": "-20.77329000",
                        "longitude": "-43.16210000"
                    },
                    {
                        "id": 14085,
                        "name": "Presidente Juscelino",
                        "latitude": "-18.73883000",
                        "longitude": "-44.07767000"
                    },
                    {
                        "id": 14089,
                        "name": "Presidente Kubitschek",
                        "latitude": "-18.64982000",
                        "longitude": "-43.57979000"
                    },
                    {
                        "id": 14094,
                        "name": "Presidente Olegário",
                        "latitude": "-18.16191000",
                        "longitude": "-46.40629000"
                    },
                    {
                        "id": 14113,
                        "name": "Prudente de Morais",
                        "latitude": "-19.46809000",
                        "longitude": "-44.11363000"
                    },
                    {
                        "id": 14127,
                        "name": "Quartel Geral",
                        "latitude": "-19.28715000",
                        "longitude": "-45.58434000"
                    },
                    {
                        "id": 14144,
                        "name": "Queluzito",
                        "latitude": "-20.73147000",
                        "longitude": "-43.89355000"
                    },
                    {
                        "id": 14175,
                        "name": "Raposos",
                        "latitude": "-19.97619000",
                        "longitude": "-43.79018000"
                    },
                    {
                        "id": 14176,
                        "name": "Raul Soares",
                        "latitude": "-20.01424000",
                        "longitude": "-42.40893000"
                    },
                    {
                        "id": 14180,
                        "name": "Recreio",
                        "latitude": "-21.52854000",
                        "longitude": "-42.44327000"
                    },
                    {
                        "id": 14187,
                        "name": "Reduto",
                        "latitude": "-20.22867000",
                        "longitude": "-41.94273000"
                    },
                    {
                        "id": 14198,
                        "name": "Resende Costa",
                        "latitude": "-20.84128000",
                        "longitude": "-44.28110000"
                    },
                    {
                        "id": 14203,
                        "name": "Resplendor",
                        "latitude": "-19.20265000",
                        "longitude": "-41.14336000"
                    },
                    {
                        "id": 14204,
                        "name": "Ressaquinha",
                        "latitude": "-21.09458000",
                        "longitude": "-43.78435000"
                    },
                    {
                        "id": 14209,
                        "name": "Riachinho",
                        "latitude": "-16.24455000",
                        "longitude": "-45.89421000"
                    },
                    {
                        "id": 14217,
                        "name": "Riacho dos Machados",
                        "latitude": "-16.06608000",
                        "longitude": "-42.97549000"
                    },
                    {
                        "id": 14247,
                        "name": "Ribeirão das Neves",
                        "latitude": "-19.76694000",
                        "longitude": "-44.08667000"
                    },
                    {
                        "id": 14245,
                        "name": "Ribeirão Vermelho",
                        "latitude": "-21.15385000",
                        "longitude": "-45.07881000"
                    },
                    {
                        "id": 14257,
                        "name": "Rio Acima",
                        "latitude": "-20.11704000",
                        "longitude": "-43.76542000"
                    },
                    {
                        "id": 14268,
                        "name": "Rio Casca",
                        "latitude": "-20.12888000",
                        "longitude": "-42.66076000"
                    },
                    {
                        "id": 14315,
                        "name": "Rio do Prado",
                        "latitude": "-16.68344000",
                        "longitude": "-40.56002000"
                    },
                    {
                        "id": 14272,
                        "name": "Rio Doce",
                        "latitude": "-20.20614000",
                        "longitude": "-42.89246000"
                    },
                    {
                        "id": 14273,
                        "name": "Rio Espera",
                        "latitude": "-20.85358000",
                        "longitude": "-43.52051000"
                    },
                    {
                        "id": 14280,
                        "name": "Rio Manso",
                        "latitude": "-20.24916000",
                        "longitude": "-44.34028000"
                    },
                    {
                        "id": 14285,
                        "name": "Rio Novo",
                        "latitude": "-21.47241000",
                        "longitude": "-43.15069000"
                    },
                    {
                        "id": 14287,
                        "name": "Rio Paranaíba",
                        "latitude": "-19.19894000",
                        "longitude": "-46.29215000"
                    },
                    {
                        "id": 14289,
                        "name": "Rio Pardo de Minas",
                        "latitude": "-15.73003000",
                        "longitude": "-42.57320000"
                    },
                    {
                        "id": 14290,
                        "name": "Rio Piracicaba",
                        "latitude": "-19.97486000",
                        "longitude": "-43.16111000"
                    },
                    {
                        "id": 14291,
                        "name": "Rio Pomba",
                        "latitude": "-21.25409000",
                        "longitude": "-43.17161000"
                    },
                    {
                        "id": 14292,
                        "name": "Rio Preto",
                        "latitude": "-22.04485000",
                        "longitude": "-43.86975000"
                    },
                    {
                        "id": 14302,
                        "name": "Rio Vermelho",
                        "latitude": "-18.26867000",
                        "longitude": "-43.07424000"
                    },
                    {
                        "id": 14323,
                        "name": "Ritápolis",
                        "latitude": "-20.99288000",
                        "longitude": "-44.37052000"
                    },
                    {
                        "id": 14327,
                        "name": "Rochedo de Minas",
                        "latitude": "-21.64268000",
                        "longitude": "-43.03311000"
                    },
                    {
                        "id": 14330,
                        "name": "Rodeiro",
                        "latitude": "-21.21255000",
                        "longitude": "-42.84086000"
                    },
                    {
                        "id": 14338,
                        "name": "Romaria",
                        "latitude": "-18.89336000",
                        "longitude": "-47.58130000"
                    },
                    {
                        "id": 14352,
                        "name": "Rosário da Limeira",
                        "latitude": "-20.98600000",
                        "longitude": "-42.51507000"
                    },
                    {
                        "id": 14357,
                        "name": "Rubelita",
                        "latitude": "-16.34214000",
                        "longitude": "-42.22800000"
                    },
                    {
                        "id": 14359,
                        "name": "Rubim",
                        "latitude": "-16.45147000",
                        "longitude": "-40.49301000"
                    },
                    {
                        "id": 14366,
                        "name": "Sabará",
                        "latitude": "-19.85393000",
                        "longitude": "-43.78326000"
                    },
                    {
                        "id": 14368,
                        "name": "Sabinópolis",
                        "latitude": "-18.64885000",
                        "longitude": "-43.06554000"
                    },
                    {
                        "id": 14372,
                        "name": "Sacramento",
                        "latitude": "-19.88039000",
                        "longitude": "-47.22600000"
                    },
                    {
                        "id": 14387,
                        "name": "Salinas",
                        "latitude": "-16.11853000",
                        "longitude": "-42.17403000"
                    },
                    {
                        "id": 14398,
                        "name": "Salto da Divisa",
                        "latitude": "-16.08589000",
                        "longitude": "-40.04463000"
                    },
                    {
                        "id": 14423,
                        "name": "Santa Bárbara",
                        "latitude": "-20.02361000",
                        "longitude": "-43.44495000"
                    },
                    {
                        "id": 14426,
                        "name": "Santa Bárbara do Leste",
                        "latitude": "-19.94064000",
                        "longitude": "-42.10329000"
                    },
                    {
                        "id": 14427,
                        "name": "Santa Bárbara do Monte Verde",
                        "latitude": "-21.97690000",
                        "longitude": "-43.69324000"
                    },
                    {
                        "id": 14430,
                        "name": "Santa Bárbara do Tugúrio",
                        "latitude": "-21.23902000",
                        "longitude": "-43.52380000"
                    },
                    {
                        "id": 14448,
                        "name": "Santa Cruz de Minas",
                        "latitude": "-21.12001000",
                        "longitude": "-44.21369000"
                    },
                    {
                        "id": 14450,
                        "name": "Santa Cruz de Salinas",
                        "latitude": "-16.06175000",
                        "longitude": "-41.79919000"
                    },
                    {
                        "id": 14453,
                        "name": "Santa Cruz do Escalvado",
                        "latitude": "-20.23339000",
                        "longitude": "-42.82110000"
                    },
                    {
                        "id": 14459,
                        "name": "Santa Efigênia de Minas",
                        "latitude": "-18.86234000",
                        "longitude": "-42.40032000"
                    },
                    {
                        "id": 14466,
                        "name": "Santa Fé de Minas",
                        "latitude": "-16.68124000",
                        "longitude": "-45.59725000"
                    },
                    {
                        "id": 14475,
                        "name": "Santa Helena de Minas",
                        "latitude": "-16.90289000",
                        "longitude": "-40.66215000"
                    },
                    {
                        "id": 14486,
                        "name": "Santa Juliana",
                        "latitude": "-19.35572000",
                        "longitude": "-47.53705000"
                    },
                    {
                        "id": 14490,
                        "name": "Santa Luzia",
                        "latitude": "-19.76972000",
                        "longitude": "-43.85139000"
                    },
                    {
                        "id": 14500,
                        "name": "Santa Margarida",
                        "latitude": "-20.43571000",
                        "longitude": "-42.27056000"
                    },
                    {
                        "id": 14509,
                        "name": "Santa Maria de Itabira",
                        "latitude": "-19.43588000",
                        "longitude": "-43.06843000"
                    },
                    {
                        "id": 14515,
                        "name": "Santa Maria do Salto",
                        "latitude": "-16.30440000",
                        "longitude": "-40.11096000"
                    },
                    {
                        "id": 14516,
                        "name": "Santa Maria do Suaçuí",
                        "latitude": "-18.25258000",
                        "longitude": "-42.33882000"
                    },
                    {
                        "id": 14527,
                        "name": "Santa Rita de Caldas",
                        "latitude": "-22.01936000",
                        "longitude": "-46.27369000"
                    },
                    {
                        "id": 14529,
                        "name": "Santa Rita de Ibitipoca",
                        "latitude": "-21.56153000",
                        "longitude": "-43.95797000"
                    },
                    {
                        "id": 14530,
                        "name": "Santa Rita de Jacutinga",
                        "latitude": "-22.10905000",
                        "longitude": "-44.10325000"
                    },
                    {
                        "id": 14531,
                        "name": "Santa Rita de Minas",
                        "latitude": "-19.86922000",
                        "longitude": "-42.12700000"
                    },
                    {
                        "id": 14533,
                        "name": "Santa Rita do Itueto",
                        "latitude": "-19.41798000",
                        "longitude": "-41.40277000"
                    },
                    {
                        "id": 14537,
                        "name": "Santa Rita do Sapucaí",
                        "latitude": "-22.25623000",
                        "longitude": "-45.67459000"
                    },
                    {
                        "id": 14541,
                        "name": "Santa Rosa da Serra",
                        "latitude": "-19.53874000",
                        "longitude": "-45.98000000"
                    },
                    {
                        "id": 14565,
                        "name": "Santa Vitória",
                        "latitude": "-19.09193000",
                        "longitude": "-50.29906000"
                    },
                    {
                        "id": 14572,
                        "name": "Santana da Vargem",
                        "latitude": "-21.26761000",
                        "longitude": "-45.48969000"
                    },
                    {
                        "id": 14573,
                        "name": "Santana de Cataguases",
                        "latitude": "-21.28322000",
                        "longitude": "-42.56580000"
                    },
                    {
                        "id": 14576,
                        "name": "Santana de Pirapama",
                        "latitude": "-18.90777000",
                        "longitude": "-43.92702000"
                    },
                    {
                        "id": 14580,
                        "name": "Santana do Deserto",
                        "latitude": "-21.94535000",
                        "longitude": "-43.17445000"
                    },
                    {
                        "id": 14581,
                        "name": "Santana do Garambéu",
                        "latitude": "-21.64675000",
                        "longitude": "-44.06937000"
                    },
                    {
                        "id": 14584,
                        "name": "Santana do Jacaré",
                        "latitude": "-20.88867000",
                        "longitude": "-45.07914000"
                    },
                    {
                        "id": 14586,
                        "name": "Santana do Manhuaçu",
                        "latitude": "-20.05562000",
                        "longitude": "-41.89770000"
                    },
                    {
                        "id": 14590,
                        "name": "Santana do Paraíso",
                        "latitude": "-19.38010000",
                        "longitude": "-42.54068000"
                    },
                    {
                        "id": 14592,
                        "name": "Santana do Riacho",
                        "latitude": "-19.18420000",
                        "longitude": "-43.68380000"
                    },
                    {
                        "id": 14596,
                        "name": "Santana dos Montes",
                        "latitude": "-20.79856000",
                        "longitude": "-43.64577000"
                    },
                    {
                        "id": 14621,
                        "name": "Santo Antônio do Amparo",
                        "latitude": "-20.91660000",
                        "longitude": "-44.95511000"
                    },
                    {
                        "id": 14623,
                        "name": "Santo Antônio do Aventureiro",
                        "latitude": "-21.74424000",
                        "longitude": "-42.81100000"
                    },
                    {
                        "id": 14626,
                        "name": "Santo Antônio do Grama",
                        "latitude": "-20.32329000",
                        "longitude": "-42.61551000"
                    },
                    {
                        "id": 14627,
                        "name": "Santo Antônio do Itambé",
                        "latitude": "-18.49169000",
                        "longitude": "-43.26278000"
                    },
                    {
                        "id": 14629,
                        "name": "Santo Antônio do Jacinto",
                        "latitude": "-16.50934000",
                        "longitude": "-40.27997000"
                    },
                    {
                        "id": 14633,
                        "name": "Santo Antônio do Monte",
                        "latitude": "-20.07993000",
                        "longitude": "-45.30587000"
                    },
                    {
                        "id": 14638,
                        "name": "Santo Antônio do Retiro",
                        "latitude": "-15.30144000",
                        "longitude": "-42.64417000"
                    },
                    {
                        "id": 14639,
                        "name": "Santo Antônio do Rio Abaixo",
                        "latitude": "-19.25051000",
                        "longitude": "-43.25300000"
                    },
                    {
                        "id": 14649,
                        "name": "Santo Hipólito",
                        "latitude": "-18.38378000",
                        "longitude": "-44.17728000"
                    },
                    {
                        "id": 14654,
                        "name": "Santos Dumont",
                        "latitude": "-21.46453000",
                        "longitude": "-43.52573000"
                    },
                    {
                        "id": 14837,
                        "name": "São Bento Abade",
                        "latitude": "-21.55981000",
                        "longitude": "-45.06653000"
                    },
                    {
                        "id": 14851,
                        "name": "São Brás do Suaçuí",
                        "latitude": "-20.62195000",
                        "longitude": "-43.96923000"
                    },
                    {
                        "id": 14866,
                        "name": "São Domingos das Dores",
                        "latitude": "-19.51985000",
                        "longitude": "-42.03401000"
                    },
                    {
                        "id": 14873,
                        "name": "São Domingos do Prata",
                        "latitude": "-19.89785000",
                        "longitude": "-42.88422000"
                    },
                    {
                        "id": 14901,
                        "name": "São Félix de Minas",
                        "latitude": "-18.55894000",
                        "longitude": "-41.44459000"
                    },
                    {
                        "id": 14882,
                        "name": "São Francisco",
                        "latitude": "-15.88365000",
                        "longitude": "-44.84306000"
                    },
                    {
                        "id": 14888,
                        "name": "São Francisco de Paula",
                        "latitude": "-20.71868000",
                        "longitude": "-44.99234000"
                    },
                    {
                        "id": 14889,
                        "name": "São Francisco de Sales",
                        "latitude": "-19.77179000",
                        "longitude": "-49.81040000"
                    },
                    {
                        "id": 14892,
                        "name": "São Francisco do Glória",
                        "latitude": "-20.78528000",
                        "longitude": "-42.28488000"
                    },
                    {
                        "id": 14912,
                        "name": "São Geraldo",
                        "latitude": "-20.90833000",
                        "longitude": "-42.82833000"
                    },
                    {
                        "id": 14913,
                        "name": "São Geraldo da Piedade",
                        "latitude": "-18.91396000",
                        "longitude": "-42.31056000"
                    },
                    {
                        "id": 14915,
                        "name": "São Geraldo do Baixio",
                        "latitude": "-18.91798000",
                        "longitude": "-41.36253000"
                    },
                    {
                        "id": 14917,
                        "name": "São Gonçalo do Abaeté",
                        "latitude": "-18.23315000",
                        "longitude": "-45.61317000"
                    },
                    {
                        "id": 14921,
                        "name": "São Gonçalo do Pará",
                        "latitude": "-19.97290000",
                        "longitude": "-44.84024000"
                    },
                    {
                        "id": 14923,
                        "name": "São Gonçalo do Rio Abaixo",
                        "latitude": "-19.81182000",
                        "longitude": "-43.32838000"
                    },
                    {
                        "id": 14924,
                        "name": "São Gonçalo do Rio Preto",
                        "latitude": "-18.07630000",
                        "longitude": "-43.35534000"
                    },
                    {
                        "id": 14925,
                        "name": "São Gonçalo do Sapucaí",
                        "latitude": "-21.91053000",
                        "longitude": "-45.60119000"
                    },
                    {
                        "id": 14927,
                        "name": "São Gotardo",
                        "latitude": "-19.31111000",
                        "longitude": "-46.04889000"
                    },
                    {
                        "id": 15002,
                        "name": "São João Batista do Glória",
                        "latitude": "-20.53122000",
                        "longitude": "-46.44580000"
                    },
                    {
                        "id": 15010,
                        "name": "São João da Lagoa",
                        "latitude": "-16.87872000",
                        "longitude": "-44.34205000"
                    },
                    {
                        "id": 15011,
                        "name": "São João da Mata",
                        "latitude": "-21.93521000",
                        "longitude": "-45.93300000"
                    },
                    {
                        "id": 15014,
                        "name": "São João da Ponte",
                        "latitude": "-15.90314000",
                        "longitude": "-43.83053000"
                    },
                    {
                        "id": 15019,
                        "name": "São João das Missões",
                        "latitude": "-14.88665000",
                        "longitude": "-44.21265000"
                    },
                    {
                        "id": 15023,
                        "name": "São João del Rei",
                        "latitude": "-21.25033000",
                        "longitude": "-44.24481000"
                    },
                    {
                        "id": 15032,
                        "name": "São João do Manhuaçu",
                        "latitude": "-20.38351000",
                        "longitude": "-42.15632000"
                    },
                    {
                        "id": 15033,
                        "name": "São João do Manteninha",
                        "latitude": "-18.73950000",
                        "longitude": "-41.15749000"
                    },
                    {
                        "id": 15035,
                        "name": "São João do Oriente",
                        "latitude": "-19.34848000",
                        "longitude": "-42.17407000"
                    },
                    {
                        "id": 15036,
                        "name": "São João do Pacuí",
                        "latitude": "-16.53392000",
                        "longitude": "-44.54062000"
                    },
                    {
                        "id": 15038,
                        "name": "São João do Paraíso",
                        "latitude": "-15.37652000",
                        "longitude": "-41.95693000"
                    },
                    {
                        "id": 15003,
                        "name": "São João Evangelista",
                        "latitude": "-18.50849000",
                        "longitude": "-42.78221000"
                    },
                    {
                        "id": 15004,
                        "name": "São João Nepomuceno",
                        "latitude": "-21.58615000",
                        "longitude": "-43.01503000"
                    },
                    {
                        "id": 14932,
                        "name": "São Joaquim de Bicas",
                        "latitude": "-20.05781000",
                        "longitude": "-44.24979000"
                    },
                    {
                        "id": 14939,
                        "name": "São José da Barra",
                        "latitude": "-20.75050000",
                        "longitude": "-46.28526000"
                    },
                    {
                        "id": 14945,
                        "name": "São José da Lapa",
                        "latitude": "-19.69017000",
                        "longitude": "-43.99106000"
                    },
                    {
                        "id": 14946,
                        "name": "São José da Safira",
                        "latitude": "-18.33059000",
                        "longitude": "-42.10391000"
                    },
                    {
                        "id": 14948,
                        "name": "São José da Varginha",
                        "latitude": "-19.68910000",
                        "longitude": "-44.55308000"
                    },
                    {
                        "id": 14959,
                        "name": "São José do Alegre",
                        "latitude": "-22.34058000",
                        "longitude": "-45.52023000"
                    },
                    {
                        "id": 14969,
                        "name": "São José do Divino",
                        "latitude": "-18.40103000",
                        "longitude": "-41.37248000"
                    },
                    {
                        "id": 14971,
                        "name": "São José do Goiabal",
                        "latitude": "-19.92360000",
                        "longitude": "-42.69184000"
                    },
                    {
                        "id": 14975,
                        "name": "São José do Jacuri",
                        "latitude": "-18.25160000",
                        "longitude": "-42.67396000"
                    },
                    {
                        "id": 14977,
                        "name": "São José do Mantimento",
                        "latitude": "-20.02453000",
                        "longitude": "-41.76334000"
                    },
                    {
                        "id": 15052,
                        "name": "São Lourenço",
                        "latitude": "-22.11746000",
                        "longitude": "-45.03226000"
                    },
                    {
                        "id": 15086,
                        "name": "São Miguel do Anta",
                        "latitude": "-20.73482000",
                        "longitude": "-42.69789000"
                    },
                    {
                        "id": 15111,
                        "name": "São Pedro da União",
                        "latitude": "-21.11290000",
                        "longitude": "-46.64760000"
                    },
                    {
                        "id": 15120,
                        "name": "São Pedro do Suaçuí",
                        "latitude": "-18.35451000",
                        "longitude": "-42.59570000"
                    },
                    {
                        "id": 15124,
                        "name": "São Pedro dos Ferros",
                        "latitude": "-20.06522000",
                        "longitude": "-42.56304000"
                    },
                    {
                        "id": 15130,
                        "name": "São Romão",
                        "latitude": "-16.35912000",
                        "longitude": "-45.46775000"
                    },
                    {
                        "id": 15132,
                        "name": "São Roque de Minas",
                        "latitude": "-20.16741000",
                        "longitude": "-46.47292000"
                    },
                    {
                        "id": 15138,
                        "name": "São Sebastião da Bela Vista",
                        "latitude": "-22.16425000",
                        "longitude": "-45.78515000"
                    },
                    {
                        "id": 15141,
                        "name": "São Sebastião da Vargem Alegre",
                        "latitude": "-21.02882000",
                        "longitude": "-42.59877000"
                    },
                    {
                        "id": 15144,
                        "name": "São Sebastião do Anta",
                        "latitude": "-19.51787000",
                        "longitude": "-41.93921000"
                    },
                    {
                        "id": 15146,
                        "name": "São Sebastião do Maranhão",
                        "latitude": "-18.06833000",
                        "longitude": "-42.53730000"
                    },
                    {
                        "id": 15147,
                        "name": "São Sebastião do Oeste",
                        "latitude": "-20.24378000",
                        "longitude": "-45.04068000"
                    },
                    {
                        "id": 15148,
                        "name": "São Sebastião do Paraíso",
                        "latitude": "-20.91694000",
                        "longitude": "-46.99139000"
                    },
                    {
                        "id": 15150,
                        "name": "São Sebastião do Rio Preto",
                        "latitude": "-19.29918000",
                        "longitude": "-43.22996000"
                    },
                    {
                        "id": 15151,
                        "name": "São Sebastião do Rio Verde",
                        "latitude": "-22.21276000",
                        "longitude": "-45.02049000"
                    },
                    {
                        "id": 15158,
                        "name": "São Thomé das Letras",
                        "latitude": "-21.73939000",
                        "longitude": "-44.96812000"
                    },
                    {
                        "id": 15159,
                        "name": "São Tiago",
                        "latitude": "-20.93607000",
                        "longitude": "-44.55961000"
                    },
                    {
                        "id": 15160,
                        "name": "São Tomás de Aquino",
                        "latitude": "-20.80317000",
                        "longitude": "-47.13081000"
                    },
                    {
                        "id": 15172,
                        "name": "São Vicente de Minas",
                        "latitude": "-21.67023000",
                        "longitude": "-44.46650000"
                    },
                    {
                        "id": 14664,
                        "name": "Sapucaí-Mirim",
                        "latitude": "-22.79166000",
                        "longitude": "-45.84222000"
                    },
                    {
                        "id": 14670,
                        "name": "Sardoá",
                        "latitude": "-18.77353000",
                        "longitude": "-42.40303000"
                    },
                    {
                        "id": 14672,
                        "name": "Sarzedo",
                        "latitude": "-20.04463000",
                        "longitude": "-44.13442000"
                    },
                    {
                        "id": 14691,
                        "name": "Sem-Peixe",
                        "latitude": "-20.07337000",
                        "longitude": "-42.81556000"
                    },
                    {
                        "id": 14694,
                        "name": "Senador Amaral",
                        "latitude": "-22.55358000",
                        "longitude": "-46.22421000"
                    },
                    {
                        "id": 14696,
                        "name": "Senador Cortes",
                        "latitude": "-21.76164000",
                        "longitude": "-42.91138000"
                    },
                    {
                        "id": 14698,
                        "name": "Senador Firmino",
                        "latitude": "-20.89680000",
                        "longitude": "-43.11033000"
                    },
                    {
                        "id": 14701,
                        "name": "Senador José Bento",
                        "latitude": "-22.15837000",
                        "longitude": "-46.14282000"
                    },
                    {
                        "id": 14704,
                        "name": "Senador Modestino Gonçalves",
                        "latitude": "-17.91341000",
                        "longitude": "-43.21328000"
                    },
                    {
                        "id": 14711,
                        "name": "Senhora de Oliveira",
                        "latitude": "-20.80180000",
                        "longitude": "-43.34536000"
                    },
                    {
                        "id": 14712,
                        "name": "Senhora do Porto",
                        "latitude": "-18.90274000",
                        "longitude": "-43.08578000"
                    },
                    {
                        "id": 14713,
                        "name": "Senhora dos Remédios",
                        "latitude": "-21.02878000",
                        "longitude": "-43.59680000"
                    },
                    {
                        "id": 14717,
                        "name": "Sericita",
                        "latitude": "-20.49536000",
                        "longitude": "-42.45991000"
                    },
                    {
                        "id": 14719,
                        "name": "Seritinga",
                        "latitude": "-21.91887000",
                        "longitude": "-44.46300000"
                    },
                    {
                        "id": 14724,
                        "name": "Serra Azul de Minas",
                        "latitude": "-18.38225000",
                        "longitude": "-43.20251000"
                    },
                    {
                        "id": 14736,
                        "name": "Serra da Saudade",
                        "latitude": "-19.38394000",
                        "longitude": "-45.80002000"
                    },
                    {
                        "id": 14741,
                        "name": "Serra do Salitre",
                        "latitude": "-19.14990000",
                        "longitude": "-46.65307000"
                    },
                    {
                        "id": 14742,
                        "name": "Serra dos Aimorés",
                        "latitude": "-17.75022000",
                        "longitude": "-40.27113000"
                    },
                    {
                        "id": 14744,
                        "name": "Serrania",
                        "latitude": "-21.55510000",
                        "longitude": "-46.10712000"
                    },
                    {
                        "id": 14748,
                        "name": "Serranópolis de Minas",
                        "latitude": "-15.89984000",
                        "longitude": "-42.85134000"
                    },
                    {
                        "id": 14746,
                        "name": "Serranos",
                        "latitude": "-21.82389000",
                        "longitude": "-44.54236000"
                    },
                    {
                        "id": 14755,
                        "name": "Serro",
                        "latitude": "-18.52041000",
                        "longitude": "-43.38075000"
                    },
                    {
                        "id": 14765,
                        "name": "Sete Lagoas",
                        "latitude": "-19.46583000",
                        "longitude": "-44.24667000"
                    },
                    {
                        "id": 14768,
                        "name": "Setubinha",
                        "latitude": "-17.66692000",
                        "longitude": "-42.19505000"
                    },
                    {
                        "id": 14779,
                        "name": "Silveirânia",
                        "latitude": "-21.14447000",
                        "longitude": "-43.19826000"
                    },
                    {
                        "id": 14781,
                        "name": "Silvianópolis",
                        "latitude": "-22.05297000",
                        "longitude": "-45.81579000"
                    },
                    {
                        "id": 14787,
                        "name": "Simão Pereira",
                        "latitude": "-21.96631000",
                        "longitude": "-43.29030000"
                    },
                    {
                        "id": 14784,
                        "name": "Simonésia",
                        "latitude": "-19.99894000",
                        "longitude": "-41.98726000"
                    },
                    {
                        "id": 14799,
                        "name": "Sobrália",
                        "latitude": "-19.21309000",
                        "longitude": "-42.14818000"
                    },
                    {
                        "id": 14804,
                        "name": "Soledade de Minas",
                        "latitude": "-22.02216000",
                        "longitude": "-45.04271000"
                    },
                    {
                        "id": 15191,
                        "name": "Tabuleiro",
                        "latitude": "-21.35779000",
                        "longitude": "-43.24828000"
                    },
                    {
                        "id": 15202,
                        "name": "Taiobeiras",
                        "latitude": "-15.83800000",
                        "longitude": "-42.09039000"
                    },
                    {
                        "id": 15224,
                        "name": "Taparuba",
                        "latitude": "-19.72752000",
                        "longitude": "-41.60277000"
                    },
                    {
                        "id": 15233,
                        "name": "Tapira",
                        "latitude": "-19.93370000",
                        "longitude": "-46.91795000"
                    },
                    {
                        "id": 15237,
                        "name": "Tapiraí",
                        "latitude": "-19.87272000",
                        "longitude": "-46.13291000"
                    },
                    {
                        "id": 15244,
                        "name": "Taquaraçu de Minas",
                        "latitude": "-19.63354000",
                        "longitude": "-43.69161000"
                    },
                    {
                        "id": 15256,
                        "name": "Tarumirim",
                        "latitude": "-19.30041000",
                        "longitude": "-41.91984000"
                    },
                    {
                        "id": 15268,
                        "name": "Teixeiras",
                        "latitude": "-20.63003000",
                        "longitude": "-42.85443000"
                    },
                    {
                        "id": 15301,
                        "name": "Teófilo Otoni",
                        "latitude": "-17.67910000",
                        "longitude": "-41.33738000"
                    },
                    {
                        "id": 15319,
                        "name": "Timóteo",
                        "latitude": "-19.58106000",
                        "longitude": "-42.64953000"
                    },
                    {
                        "id": 15321,
                        "name": "Tiradentes",
                        "latitude": "-21.11854000",
                        "longitude": "-44.16072000"
                    },
                    {
                        "id": 15323,
                        "name": "Tiros",
                        "latitude": "-18.85727000",
                        "longitude": "-45.84049000"
                    },
                    {
                        "id": 15325,
                        "name": "Tocantins",
                        "latitude": "-21.18115000",
                        "longitude": "-43.02555000"
                    },
                    {
                        "id": 15328,
                        "name": "Tocos do Moji",
                        "latitude": "-22.35665000",
                        "longitude": "-46.14951000"
                    },
                    {
                        "id": 15330,
                        "name": "Toledo",
                        "latitude": "-22.70569000",
                        "longitude": "-46.39041000"
                    },
                    {
                        "id": 15333,
                        "name": "Tombos",
                        "latitude": "-20.88046000",
                        "longitude": "-42.06821000"
                    },
                    {
                        "id": 15373,
                        "name": "Três Corações",
                        "latitude": "-21.70260000",
                        "longitude": "-45.21421000"
                    },
                    {
                        "id": 15378,
                        "name": "Três Marias",
                        "latitude": "-18.28891000",
                        "longitude": "-45.02559000"
                    },
                    {
                        "id": 15381,
                        "name": "Três Pontas",
                        "latitude": "-21.40521000",
                        "longitude": "-45.49443000"
                    },
                    {
                        "id": 15392,
                        "name": "Tumiritinga",
                        "latitude": "-19.02399000",
                        "longitude": "-41.72297000"
                    },
                    {
                        "id": 15398,
                        "name": "Tupaciguara",
                        "latitude": "-18.59222000",
                        "longitude": "-48.70500000"
                    },
                    {
                        "id": 15413,
                        "name": "Turmalina",
                        "latitude": "-17.25347000",
                        "longitude": "-42.83041000"
                    },
                    {
                        "id": 15420,
                        "name": "Turvolândia",
                        "latitude": "-21.87243000",
                        "longitude": "-45.80089000"
                    },
                    {
                        "id": 15438,
                        "name": "Ubá",
                        "latitude": "-21.12000000",
                        "longitude": "-42.94278000"
                    },
                    {
                        "id": 15431,
                        "name": "Ubaí",
                        "latitude": "-16.38337000",
                        "longitude": "-44.85525000"
                    },
                    {
                        "id": 15427,
                        "name": "Ubaporanga",
                        "latitude": "-19.66187000",
                        "longitude": "-42.05903000"
                    },
                    {
                        "id": 15433,
                        "name": "Uberaba",
                        "latitude": "-19.54826000",
                        "longitude": "-47.94144000"
                    },
                    {
                        "id": 15434,
                        "name": "Uberlândia",
                        "latitude": "-19.02333000",
                        "longitude": "-48.33477000"
                    },
                    {
                        "id": 15448,
                        "name": "Umburatiba",
                        "latitude": "-17.25657000",
                        "longitude": "-40.66878000"
                    },
                    {
                        "id": 15453,
                        "name": "Unaí",
                        "latitude": "-16.58634000",
                        "longitude": "-46.77009000"
                    },
                    {
                        "id": 15460,
                        "name": "União de Minas",
                        "latitude": "-19.34087000",
                        "longitude": "-50.35738000"
                    },
                    {
                        "id": 15470,
                        "name": "Uruana de Minas",
                        "latitude": "-16.07488000",
                        "longitude": "-46.33829000"
                    },
                    {
                        "id": 15478,
                        "name": "Urucânia",
                        "latitude": "-20.32243000",
                        "longitude": "-42.71972000"
                    },
                    {
                        "id": 15476,
                        "name": "Urucuia",
                        "latitude": "-16.01822000",
                        "longitude": "-45.61731000"
                    },
                    {
                        "id": 15508,
                        "name": "Vargem Alegre",
                        "latitude": "-19.60085000",
                        "longitude": "-42.32330000"
                    },
                    {
                        "id": 15510,
                        "name": "Vargem Bonita",
                        "latitude": "-20.40556000",
                        "longitude": "-46.31426000"
                    },
                    {
                        "id": 15514,
                        "name": "Vargem Grande do Rio Pardo",
                        "latitude": "-15.34182000",
                        "longitude": "-42.30107000"
                    },
                    {
                        "id": 15517,
                        "name": "Varginha",
                        "latitude": "-21.55139000",
                        "longitude": "-45.43028000"
                    },
                    {
                        "id": 15520,
                        "name": "Varjão de MInas",
                        "latitude": "-18.45617000",
                        "longitude": "-45.89854000"
                    },
                    {
                        "id": 15621,
                        "name": "Várzea da Palma",
                        "latitude": "-17.46025000",
                        "longitude": "-44.74043000"
                    },
                    {
                        "id": 15523,
                        "name": "Varzelândia",
                        "latitude": "-15.65541000",
                        "longitude": "-43.92043000"
                    },
                    {
                        "id": 15525,
                        "name": "Vazante",
                        "latitude": "-17.78783000",
                        "longitude": "-46.79546000"
                    },
                    {
                        "id": 15540,
                        "name": "Verdelândia",
                        "latitude": "-15.54677000",
                        "longitude": "-43.68013000"
                    },
                    {
                        "id": 15542,
                        "name": "Veredinha",
                        "latitude": "-17.50571000",
                        "longitude": "-42.74858000"
                    },
                    {
                        "id": 15547,
                        "name": "Veríssimo",
                        "latitude": "-19.59178000",
                        "longitude": "-48.35893000"
                    },
                    {
                        "id": 15543,
                        "name": "Vermelho Novo",
                        "latitude": "-20.03087000",
                        "longitude": "-42.27068000"
                    },
                    {
                        "id": 15548,
                        "name": "Vespasiano",
                        "latitude": "-19.69194000",
                        "longitude": "-43.92333000"
                    },
                    {
                        "id": 15607,
                        "name": "Viçosa",
                        "latitude": "-20.73527000",
                        "longitude": "-42.89525000"
                    },
                    {
                        "id": 15562,
                        "name": "Vieiras",
                        "latitude": "-20.90888000",
                        "longitude": "-42.28015000"
                    },
                    {
                        "id": 15582,
                        "name": "Virgem da Lapa",
                        "latitude": "-16.71637000",
                        "longitude": "-42.34853000"
                    },
                    {
                        "id": 15585,
                        "name": "Virgínia",
                        "latitude": "-22.35515000",
                        "longitude": "-45.11577000"
                    },
                    {
                        "id": 15583,
                        "name": "Virginópolis",
                        "latitude": "-18.81508000",
                        "longitude": "-42.66943000"
                    },
                    {
                        "id": 15584,
                        "name": "Virgolândia",
                        "latitude": "-18.44284000",
                        "longitude": "-42.30736000"
                    },
                    {
                        "id": 15587,
                        "name": "Visconde do Rio Branco",
                        "latitude": "-20.99510000",
                        "longitude": "-42.85289000"
                    },
                    {
                        "id": 15609,
                        "name": "Volta Grande",
                        "latitude": "-21.75298000",
                        "longitude": "-42.57357000"
                    },
                    {
                        "id": 15628,
                        "name": "Wenceslau Braz",
                        "latitude": "-22.53974000",
                        "longitude": "-45.40214000"
                    }
                ]
            },
            {
                "id": 2009,
                "name": "Pará",
                "iso2": "PA",
                "latitude": "-1.99812710",
                "longitude": "-54.93061520",
                "type": "state",
                "cities": [
                    {
                        "id": 10056,
                        "name": "Abaetetuba",
                        "latitude": "-1.71806000",
                        "longitude": "-48.88250000"
                    },
                    {
                        "id": 10063,
                        "name": "Abel Figueiredo",
                        "latitude": "-4.94378000",
                        "longitude": "-48.42275000"
                    },
                    {
                        "id": 10073,
                        "name": "Acará",
                        "latitude": "-1.96083000",
                        "longitude": "-48.19667000"
                    },
                    {
                        "id": 10090,
                        "name": "Afuá",
                        "latitude": "-0.15667000",
                        "longitude": "-50.38667000"
                    },
                    {
                        "id": 15648,
                        "name": "Água Azul do Norte",
                        "latitude": "-6.63125000",
                        "longitude": "-50.62146000"
                    },
                    {
                        "id": 10127,
                        "name": "Alenquer",
                        "latitude": "-0.85422000",
                        "longitude": "-54.94506000"
                    },
                    {
                        "id": 10141,
                        "name": "Almeirim",
                        "latitude": "0.47621000",
                        "longitude": "-53.87297000"
                    },
                    {
                        "id": 10153,
                        "name": "Altamira",
                        "latitude": "-3.20333000",
                        "longitude": "-52.20639000"
                    },
                    {
                        "id": 10231,
                        "name": "Anajás",
                        "latitude": "-0.86015000",
                        "longitude": "-50.03970000"
                    },
                    {
                        "id": 10234,
                        "name": "Ananindeua",
                        "latitude": "-1.34611000",
                        "longitude": "-48.38287000"
                    },
                    {
                        "id": 10236,
                        "name": "Anapu",
                        "latitude": "-3.88583000",
                        "longitude": "-51.33796000"
                    },
                    {
                        "id": 10443,
                        "name": "Augusto Corrêa",
                        "latitude": "-1.02167000",
                        "longitude": "-46.63500000"
                    },
                    {
                        "id": 10452,
                        "name": "Aurora do Pará",
                        "latitude": "-2.30323000",
                        "longitude": "-47.75621000"
                    },
                    {
                        "id": 10458,
                        "name": "Aveiro",
                        "latitude": "-3.66721000",
                        "longitude": "-56.01637000"
                    },
                    {
                        "id": 10473,
                        "name": "Bagre",
                        "latitude": "-2.40166000",
                        "longitude": "-50.16628000"
                    },
                    {
                        "id": 10480,
                        "name": "Baião",
                        "latitude": "-2.79056000",
                        "longitude": "-49.67167000"
                    },
                    {
                        "id": 10503,
                        "name": "Bannach",
                        "latitude": "-7.46864000",
                        "longitude": "-50.65904000"
                    },
                    {
                        "id": 10511,
                        "name": "Barcarena",
                        "latitude": "-1.54656000",
                        "longitude": "-48.63248000"
                    },
                    {
                        "id": 10615,
                        "name": "Belém",
                        "latitude": "-1.45583000",
                        "longitude": "-48.50444000"
                    },
                    {
                        "id": 10612,
                        "name": "Belterra",
                        "latitude": "-3.01258000",
                        "longitude": "-54.99128000"
                    },
                    {
                        "id": 10625,
                        "name": "Benevides",
                        "latitude": "-1.36139000",
                        "longitude": "-48.24472000"
                    },
                    {
                        "id": 10716,
                        "name": "Bom Jesus do Tocantins",
                        "latitude": "-4.99184000",
                        "longitude": "-48.82370000"
                    },
                    {
                        "id": 10738,
                        "name": "Bonito",
                        "latitude": "-1.42927000",
                        "longitude": "-47.33735000"
                    },
                    {
                        "id": 10765,
                        "name": "Bragança",
                        "latitude": "-0.96813000",
                        "longitude": "-46.73377000"
                    },
                    {
                        "id": 10768,
                        "name": "Brasil Novo",
                        "latitude": "-3.33767000",
                        "longitude": "-52.57451000"
                    },
                    {
                        "id": 10791,
                        "name": "Brejo Grande do Araguaia",
                        "latitude": "-5.74369000",
                        "longitude": "-48.45573000"
                    },
                    {
                        "id": 10801,
                        "name": "Breu Branco",
                        "latitude": "-3.73348000",
                        "longitude": "-49.37122000"
                    },
                    {
                        "id": 10802,
                        "name": "Breves",
                        "latitude": "-1.68222000",
                        "longitude": "-50.48028000"
                    },
                    {
                        "id": 10820,
                        "name": "Bujaru",
                        "latitude": "-1.51500000",
                        "longitude": "-48.04472000"
                    },
                    {
                        "id": 10871,
                        "name": "Cachoeira do Arari",
                        "latitude": "-0.84609000",
                        "longitude": "-48.93118000"
                    },
                    {
                        "id": 10872,
                        "name": "Cachoeira do Piriá",
                        "latitude": "-1.94037000",
                        "longitude": "-46.46914000"
                    },
                    {
                        "id": 10952,
                        "name": "Cametá",
                        "latitude": "-2.29582000",
                        "longitude": "-49.49213000"
                    },
                    {
                        "id": 11031,
                        "name": "Canaã dos Carajás",
                        "latitude": "-6.49873000",
                        "longitude": "-50.09334000"
                    },
                    {
                        "id": 11062,
                        "name": "Capanema",
                        "latitude": "-1.19583000",
                        "longitude": "-47.18083000"
                    },
                    {
                        "id": 11085,
                        "name": "Capitão Poço",
                        "latitude": "-1.74639000",
                        "longitude": "-47.05944000"
                    },
                    {
                        "id": 11184,
                        "name": "Castanhal",
                        "latitude": "-1.27231000",
                        "longitude": "-47.85627000"
                    },
                    {
                        "id": 11275,
                        "name": "Chaves",
                        "latitude": "-0.06289000",
                        "longitude": "-49.64787000"
                    },
                    {
                        "id": 11319,
                        "name": "Colares",
                        "latitude": "-0.90894000",
                        "longitude": "-48.25340000"
                    },
                    {
                        "id": 11354,
                        "name": "Conceição do Araguaia",
                        "latitude": "-8.26441000",
                        "longitude": "-49.26982000"
                    },
                    {
                        "id": 11368,
                        "name": "Concórdia do Pará",
                        "latitude": "-1.86154000",
                        "longitude": "-47.96322000"
                    },
                    {
                        "id": 11514,
                        "name": "Cumaru do Norte",
                        "latitude": "-8.39144000",
                        "longitude": "-51.24084000"
                    },
                    {
                        "id": 11523,
                        "name": "Curionópolis",
                        "latitude": "-6.18137000",
                        "longitude": "-49.66441000"
                    },
                    {
                        "id": 11533,
                        "name": "Curralinho",
                        "latitude": "-1.58236000",
                        "longitude": "-49.98697000"
                    },
                    {
                        "id": 11536,
                        "name": "Curuá",
                        "latitude": "-1.73821000",
                        "longitude": "-55.11492000"
                    },
                    {
                        "id": 11537,
                        "name": "Curuçá",
                        "latitude": "-0.69787000",
                        "longitude": "-47.86755000"
                    },
                    {
                        "id": 11626,
                        "name": "Dom Eliseu",
                        "latitude": "-4.08267000",
                        "longitude": "-47.89052000"
                    },
                    {
                        "id": 11679,
                        "name": "Eldorado do Carajás",
                        "latitude": "-6.10586000",
                        "longitude": "-49.30329000"
                    },
                    {
                        "id": 11776,
                        "name": "Faro",
                        "latitude": "-1.11536000",
                        "longitude": "-57.77412000"
                    },
                    {
                        "id": 11837,
                        "name": "Floresta do Araguaia",
                        "latitude": "-7.57944000",
                        "longitude": "-49.52862000"
                    },
                    {
                        "id": 11923,
                        "name": "Garrafão do Norte",
                        "latitude": "-2.21516000",
                        "longitude": "-47.11722000"
                    },
                    {
                        "id": 11965,
                        "name": "Goianésia do Pará",
                        "latitude": "-3.94920000",
                        "longitude": "-48.87355000"
                    },
                    {
                        "id": 12089,
                        "name": "Gurupá",
                        "latitude": "-1.16555000",
                        "longitude": "-51.62743000"
                    },
                    {
                        "id": 12182,
                        "name": "Igarapé Açu",
                        "latitude": "-1.12889000",
                        "longitude": "-47.62000000"
                    },
                    {
                        "id": 12184,
                        "name": "Igarapé Miri",
                        "latitude": "-1.97500000",
                        "longitude": "-48.95972000"
                    },
                    {
                        "id": 12186,
                        "name": "Igarapé-Açu",
                        "latitude": "-1.14164000",
                        "longitude": "-47.51366000"
                    },
                    {
                        "id": 12187,
                        "name": "Igarapé-Miri",
                        "latitude": "-2.07705000",
                        "longitude": "-49.14772000"
                    },
                    {
                        "id": 12248,
                        "name": "Inhangapi",
                        "latitude": "-1.46284000",
                        "longitude": "-47.94974000"
                    },
                    {
                        "id": 12282,
                        "name": "Ipixuna do Pará",
                        "latitude": "-2.98149000",
                        "longitude": "-48.11946000"
                    },
                    {
                        "id": 12320,
                        "name": "Irituia",
                        "latitude": "-1.77048000",
                        "longitude": "-47.42145000"
                    },
                    {
                        "id": 12363,
                        "name": "Itaituba",
                        "latitude": "-5.86018000",
                        "longitude": "-56.23176000"
                    },
                    {
                        "id": 12490,
                        "name": "Itupiranga",
                        "latitude": "-5.23295000",
                        "longitude": "-49.94952000"
                    },
                    {
                        "id": 12519,
                        "name": "Jacareacanga",
                        "latitude": "-6.22222000",
                        "longitude": "-57.75278000"
                    },
                    {
                        "id": 12530,
                        "name": "Jacundá",
                        "latitude": "-4.56883000",
                        "longitude": "-49.22284000"
                    },
                    {
                        "id": 12702,
                        "name": "Juruti",
                        "latitude": "-2.33065000",
                        "longitude": "-56.02742000"
                    },
                    {
                        "id": 12833,
                        "name": "Limoeiro do Ajuru",
                        "latitude": "-1.89647000",
                        "longitude": "-49.51015000"
                    },
                    {
                        "id": 13293,
                        "name": "Mãe do Rio",
                        "latitude": "-1.98328000",
                        "longitude": "-47.51572000"
                    },
                    {
                        "id": 12911,
                        "name": "Magalhães Barata",
                        "latitude": "-0.81838000",
                        "longitude": "-47.62990000"
                    },
                    {
                        "id": 12964,
                        "name": "Marabá",
                        "latitude": "-5.38146000",
                        "longitude": "-49.13232000"
                    },
                    {
                        "id": 12969,
                        "name": "Maracanã",
                        "latitude": "-0.75819000",
                        "longitude": "-47.48755000"
                    },
                    {
                        "id": 12979,
                        "name": "Marapanim",
                        "latitude": "-0.84063000",
                        "longitude": "-47.70897000"
                    },
                    {
                        "id": 13022,
                        "name": "Marituba",
                        "latitude": "-1.37399000",
                        "longitude": "-48.31420000"
                    },
                    {
                        "id": 13093,
                        "name": "Medicilândia",
                        "latitude": "-3.15674000",
                        "longitude": "-53.17769000"
                    },
                    {
                        "id": 13096,
                        "name": "Melgaço",
                        "latitude": "-1.66163000",
                        "longitude": "-51.05884000"
                    },
                    {
                        "id": 13159,
                        "name": "Mocajuba",
                        "latitude": "-2.58417000",
                        "longitude": "-49.50722000"
                    },
                    {
                        "id": 13170,
                        "name": "Moju",
                        "latitude": "-1.88389000",
                        "longitude": "-48.76889000"
                    },
                    {
                        "id": 13171,
                        "name": "Mojuí Dos Campos",
                        "latitude": "-3.07044000",
                        "longitude": "-54.57515000"
                    },
                    {
                        "id": 13187,
                        "name": "Monte Alegre",
                        "latitude": "-2.00082000",
                        "longitude": "-54.08102000"
                    },
                    {
                        "id": 13259,
                        "name": "Muaná",
                        "latitude": "-1.52833000",
                        "longitude": "-49.21667000"
                    },
                    {
                        "id": 13375,
                        "name": "Nova Esperança do Piriá",
                        "latitude": "-2.45364000",
                        "longitude": "-46.97384000"
                    },
                    {
                        "id": 13393,
                        "name": "Nova Ipixuna",
                        "latitude": "-4.98779000",
                        "longitude": "-49.19861000"
                    },
                    {
                        "id": 13439,
                        "name": "Nova Timboteua",
                        "latitude": "-1.12059000",
                        "longitude": "-47.42089000"
                    },
                    {
                        "id": 13475,
                        "name": "Novo Progresso",
                        "latitude": "-7.75396000",
                        "longitude": "-55.51343000"
                    },
                    {
                        "id": 13476,
                        "name": "Novo Repartimento",
                        "latitude": "-4.70032000",
                        "longitude": "-50.52220000"
                    },
                    {
                        "id": 15683,
                        "name": "Óbidos",
                        "latitude": "0.13240000",
                        "longitude": "-55.82386000"
                    },
                    {
                        "id": 13491,
                        "name": "Oeiras do Pará",
                        "latitude": "-2.00306000",
                        "longitude": "-49.85444000"
                    },
                    {
                        "id": 13518,
                        "name": "Oriximiná",
                        "latitude": "-1.76556000",
                        "longitude": "-55.86611000"
                    },
                    {
                        "id": 13552,
                        "name": "Ourém",
                        "latitude": "-1.55194000",
                        "longitude": "-47.11444000"
                    },
                    {
                        "id": 13533,
                        "name": "Ourilândia do Norte",
                        "latitude": "-7.59565000",
                        "longitude": "-51.43201000"
                    },
                    {
                        "id": 13556,
                        "name": "Pacajá",
                        "latitude": "-3.70172000",
                        "longitude": "-50.77844000"
                    },
                    {
                        "id": 13578,
                        "name": "Palestina do Pará",
                        "latitude": "-5.97518000",
                        "longitude": "-48.38544000"
                    },
                    {
                        "id": 13626,
                        "name": "Paragominas",
                        "latitude": "-2.96667000",
                        "longitude": "-47.48333000"
                    },
                    {
                        "id": 13655,
                        "name": "Parauapebas",
                        "latitude": "-6.18558000",
                        "longitude": "-50.55474000"
                    },
                    {
                        "id": 13717,
                        "name": "Pau d'Arco",
                        "latitude": "-7.73913000",
                        "longitude": "-50.14638000"
                    },
                    {
                        "id": 13788,
                        "name": "Peixe-Boi",
                        "latitude": "-1.10168000",
                        "longitude": "-47.27259000"
                    },
                    {
                        "id": 13929,
                        "name": "Piçarra",
                        "latitude": "-6.47338000",
                        "longitude": "-48.95039000"
                    },
                    {
                        "id": 13932,
                        "name": "Placas",
                        "latitude": "-3.97715000",
                        "longitude": "-54.52418000"
                    },
                    {
                        "id": 13959,
                        "name": "Ponta de Pedras",
                        "latitude": "-1.05304000",
                        "longitude": "-49.15491000"
                    },
                    {
                        "id": 13990,
                        "name": "Portel",
                        "latitude": "-1.93556000",
                        "longitude": "-50.82111000"
                    },
                    {
                        "id": 14025,
                        "name": "Porto de Moz",
                        "latitude": "-1.74833000",
                        "longitude": "-52.23833000"
                    },
                    {
                        "id": 14066,
                        "name": "Prainha",
                        "latitude": "-2.20147000",
                        "longitude": "-53.49329000"
                    },
                    {
                        "id": 14100,
                        "name": "Primavera",
                        "latitude": "-0.94947000",
                        "longitude": "-47.11040000"
                    },
                    {
                        "id": 14130,
                        "name": "Quatipuru",
                        "latitude": "-0.82554000",
                        "longitude": "-47.01043000"
                    },
                    {
                        "id": 14184,
                        "name": "Redenção",
                        "latitude": "-8.06010000",
                        "longitude": "-50.18116000"
                    },
                    {
                        "id": 14281,
                        "name": "Rio Maria",
                        "latitude": "-7.40968000",
                        "longitude": "-49.82886000"
                    },
                    {
                        "id": 14345,
                        "name": "Rondon do Pará",
                        "latitude": "-4.43977000",
                        "longitude": "-48.59233000"
                    },
                    {
                        "id": 14362,
                        "name": "Rurópolis",
                        "latitude": "-4.18795000",
                        "longitude": "-55.18406000"
                    },
                    {
                        "id": 14389,
                        "name": "Salinópolis",
                        "latitude": "-0.61361000",
                        "longitude": "-47.35611000"
                    },
                    {
                        "id": 14407,
                        "name": "Salvaterra",
                        "latitude": "-0.78848000",
                        "longitude": "-48.61953000"
                    },
                    {
                        "id": 14428,
                        "name": "Santa Bárbara do Pará",
                        "latitude": "-1.19832000",
                        "longitude": "-48.25095000"
                    },
                    {
                        "id": 14451,
                        "name": "Santa Cruz do Arari",
                        "latitude": "-0.59603000",
                        "longitude": "-49.29289000"
                    },
                    {
                        "id": 14485,
                        "name": "Santa Isabel do Pará",
                        "latitude": "-1.37975000",
                        "longitude": "-48.12221000"
                    },
                    {
                        "id": 14497,
                        "name": "Santa Luzia do Pará",
                        "latitude": "-1.65750000",
                        "longitude": "-46.92715000"
                    },
                    {
                        "id": 14508,
                        "name": "Santa Maria das Barreiras",
                        "latitude": "-8.63667000",
                        "longitude": "-50.26578000"
                    },
                    {
                        "id": 14514,
                        "name": "Santa Maria do Pará",
                        "latitude": "-1.35028000",
                        "longitude": "-47.57556000"
                    },
                    {
                        "id": 14578,
                        "name": "Santana do Araguaia",
                        "latitude": "-9.13867000",
                        "longitude": "-50.67300000"
                    },
                    {
                        "id": 14598,
                        "name": "Santarém",
                        "latitude": "-2.44306000",
                        "longitude": "-54.70833000"
                    },
                    {
                        "id": 14599,
                        "name": "Santarém Novo",
                        "latitude": "-0.88782000",
                        "longitude": "-47.36301000"
                    },
                    {
                        "id": 14641,
                        "name": "Santo Antônio do Tauá",
                        "latitude": "-1.15194000",
                        "longitude": "-48.12944000"
                    },
                    {
                        "id": 14852,
                        "name": "São Caetano de Odivelas",
                        "latitude": "-0.75000000",
                        "longitude": "-48.02000000"
                    },
                    {
                        "id": 14867,
                        "name": "São Domingos do Araguaia",
                        "latitude": "-5.71930000",
                        "longitude": "-48.72755000"
                    },
                    {
                        "id": 14869,
                        "name": "São Domingos do Capim",
                        "latitude": "-1.87163000",
                        "longitude": "-47.77837000"
                    },
                    {
                        "id": 14906,
                        "name": "São Félix do Xingu",
                        "latitude": "-6.64472000",
                        "longitude": "-51.99500000"
                    },
                    {
                        "id": 14896,
                        "name": "São Francisco do Pará",
                        "latitude": "-1.14641000",
                        "longitude": "-47.75713000"
                    },
                    {
                        "id": 14914,
                        "name": "São Geraldo do Araguaia",
                        "latitude": "-6.40056000",
                        "longitude": "-48.55500000"
                    },
                    {
                        "id": 15013,
                        "name": "São João da Ponta",
                        "latitude": "-0.85361000",
                        "longitude": "-47.97803000"
                    },
                    {
                        "id": 15022,
                        "name": "São João de Pirabas",
                        "latitude": "-0.77472000",
                        "longitude": "-47.17722000"
                    },
                    {
                        "id": 15024,
                        "name": "São João do Araguaia",
                        "latitude": "-5.44300000",
                        "longitude": "-48.74932000"
                    },
                    {
                        "id": 15090,
                        "name": "São Miguel do Guamá",
                        "latitude": "-1.62667000",
                        "longitude": "-47.48333000"
                    },
                    {
                        "id": 15139,
                        "name": "São Sebastião da Boa Vista",
                        "latitude": "-1.47873000",
                        "longitude": "-49.62629000"
                    },
                    {
                        "id": 14661,
                        "name": "Sapucaia",
                        "latitude": "-6.84790000",
                        "longitude": "-49.50056000"
                    },
                    {
                        "id": 14702,
                        "name": "Senador José Porfírio",
                        "latitude": "-2.59083000",
                        "longitude": "-51.95417000"
                    },
                    {
                        "id": 14814,
                        "name": "Soure",
                        "latitude": "-0.71667000",
                        "longitude": "-48.52333000"
                    },
                    {
                        "id": 15201,
                        "name": "Tailândia",
                        "latitude": "-2.87235000",
                        "longitude": "-48.75748000"
                    },
                    {
                        "id": 15289,
                        "name": "Terra Alta",
                        "latitude": "-0.99306000",
                        "longitude": "-47.84447000"
                    },
                    {
                        "id": 15297,
                        "name": "Terra Santa",
                        "latitude": "-2.10417000",
                        "longitude": "-56.48694000"
                    },
                    {
                        "id": 15334,
                        "name": "Tomé Açu",
                        "latitude": "-2.41889000",
                        "longitude": "-48.15222000"
                    },
                    {
                        "id": 15335,
                        "name": "Tomé-Açu",
                        "latitude": "-2.62132000",
                        "longitude": "-48.24098000"
                    },
                    {
                        "id": 15345,
                        "name": "Tracuateua",
                        "latitude": "-0.98894000",
                        "longitude": "-46.93973000"
                    },
                    {
                        "id": 15349,
                        "name": "Trairão",
                        "latitude": "-5.10250000",
                        "longitude": "-55.95821000"
                    },
                    {
                        "id": 15387,
                        "name": "Tucumã",
                        "latitude": "-6.83470000",
                        "longitude": "-51.44562000"
                    },
                    {
                        "id": 15389,
                        "name": "Tucuruí",
                        "latitude": "-3.76585000",
                        "longitude": "-49.67923000"
                    },
                    {
                        "id": 15443,
                        "name": "Ulianópolis",
                        "latitude": "-3.81225000",
                        "longitude": "-47.50094000"
                    },
                    {
                        "id": 15471,
                        "name": "Uruará",
                        "latitude": "-3.63212000",
                        "longitude": "-53.78023000"
                    },
                    {
                        "id": 15564,
                        "name": "Vigia",
                        "latitude": "-0.85833000",
                        "longitude": "-48.14167000"
                    },
                    {
                        "id": 15588,
                        "name": "Viseu",
                        "latitude": "-1.19667000",
                        "longitude": "-46.14000000"
                    },
                    {
                        "id": 15604,
                        "name": "Vitória do Xingu",
                        "latitude": "-3.22032000",
                        "longitude": "-51.88508000"
                    },
                    {
                        "id": 15641,
                        "name": "Xinguara",
                        "latitude": "-6.84897000",
                        "longitude": "-49.25573000"
                    }
                ]
            },
            {
                "id": 2005,
                "name": "Paraíba",
                "iso2": "PB",
                "latitude": "-7.23996090",
                "longitude": "-36.78195050",
                "type": "state",
                "cities": [
                    {
                        "id": 15653,
                        "name": "Água Branca",
                        "latitude": "-7.46957000",
                        "longitude": "-37.66100000"
                    },
                    {
                        "id": 10100,
                        "name": "Aguiar",
                        "latitude": "-7.07620000",
                        "longitude": "-38.24255000"
                    },
                    {
                        "id": 10108,
                        "name": "Alagoa Grande",
                        "latitude": "-7.07831000",
                        "longitude": "-35.59525000"
                    },
                    {
                        "id": 10109,
                        "name": "Alagoa Nova",
                        "latitude": "-7.04733000",
                        "longitude": "-35.75397000"
                    },
                    {
                        "id": 10110,
                        "name": "Alagoinha",
                        "latitude": "-6.96256000",
                        "longitude": "-35.51465000"
                    },
                    {
                        "id": 10116,
                        "name": "Alcantil",
                        "latitude": "-7.69816000",
                        "longitude": "-36.06604000"
                    },
                    {
                        "id": 10135,
                        "name": "Algodão de Jandaíra",
                        "latitude": "-6.86987000",
                        "longitude": "-35.97724000"
                    },
                    {
                        "id": 10136,
                        "name": "Alhandra",
                        "latitude": "-7.35043000",
                        "longitude": "-34.92835000"
                    },
                    {
                        "id": 10219,
                        "name": "Amparo",
                        "latitude": "-7.55889000",
                        "longitude": "-37.03372000"
                    },
                    {
                        "id": 10284,
                        "name": "Aparecida",
                        "latitude": "-6.80925000",
                        "longitude": "-38.07182000"
                    },
                    {
                        "id": 10366,
                        "name": "Araçagi",
                        "latitude": "-6.85419000",
                        "longitude": "-35.36047000"
                    },
                    {
                        "id": 10347,
                        "name": "Arara",
                        "latitude": "-6.82833000",
                        "longitude": "-35.75833000"
                    },
                    {
                        "id": 10357,
                        "name": "Araruna",
                        "latitude": "-6.55833000",
                        "longitude": "-35.74167000"
                    },
                    {
                        "id": 10383,
                        "name": "Areia",
                        "latitude": "-6.94723000",
                        "longitude": "-35.66927000"
                    },
                    {
                        "id": 10386,
                        "name": "Areia de Baraúnas",
                        "latitude": "-7.11328000",
                        "longitude": "-36.97177000"
                    },
                    {
                        "id": 10387,
                        "name": "Areial",
                        "latitude": "-7.04397000",
                        "longitude": "-35.92622000"
                    },
                    {
                        "id": 10405,
                        "name": "Aroeiras",
                        "latitude": "-7.52057000",
                        "longitude": "-35.69927000"
                    },
                    {
                        "id": 10430,
                        "name": "Assunção",
                        "latitude": "-7.07371000",
                        "longitude": "-36.69894000"
                    },
                    {
                        "id": 10589,
                        "name": "Baía da Traição",
                        "latitude": "-6.66287000",
                        "longitude": "-34.97272000"
                    },
                    {
                        "id": 10496,
                        "name": "Bananeiras",
                        "latitude": "-6.75000000",
                        "longitude": "-35.63333000"
                    },
                    {
                        "id": 10505,
                        "name": "Baraúna",
                        "latitude": "-6.61853000",
                        "longitude": "-36.26964000"
                    },
                    {
                        "id": 10525,
                        "name": "Barra de Santa Rosa",
                        "latitude": "-6.79042000",
                        "longitude": "-36.00175000"
                    },
                    {
                        "id": 10526,
                        "name": "Barra de Santana",
                        "latitude": "-7.59054000",
                        "longitude": "-35.98824000"
                    },
                    {
                        "id": 10530,
                        "name": "Barra de São Miguel",
                        "latitude": "-7.71640000",
                        "longitude": "-36.25481000"
                    },
                    {
                        "id": 10587,
                        "name": "Bayeux",
                        "latitude": "-7.12136000",
                        "longitude": "-34.91725000"
                    },
                    {
                        "id": 10614,
                        "name": "Belém",
                        "latitude": "-6.69167000",
                        "longitude": "-35.53333000"
                    },
                    {
                        "id": 10619,
                        "name": "Belém do Brejo do Cruz",
                        "latitude": "-6.18861000",
                        "longitude": "-37.53583000"
                    },
                    {
                        "id": 10634,
                        "name": "Bernardino Batista",
                        "latitude": "-6.47656000",
                        "longitude": "-38.56998000"
                    },
                    {
                        "id": 10664,
                        "name": "Boa Ventura",
                        "latitude": "-7.45676000",
                        "longitude": "-38.17678000"
                    },
                    {
                        "id": 10667,
                        "name": "Boa Vista",
                        "latitude": "-7.26995000",
                        "longitude": "-36.15741000"
                    },
                    {
                        "id": 10700,
                        "name": "Bom Jesus",
                        "latitude": "-6.81845000",
                        "longitude": "-38.62549000"
                    },
                    {
                        "id": 10725,
                        "name": "Bom Sucesso",
                        "latitude": "-6.47349000",
                        "longitude": "-37.95770000"
                    },
                    {
                        "id": 10741,
                        "name": "Bonito de Santa Fé",
                        "latitude": "-7.28940000",
                        "longitude": "-38.47977000"
                    },
                    {
                        "id": 10743,
                        "name": "Boqueirão",
                        "latitude": "-7.48237000",
                        "longitude": "-36.13422000"
                    },
                    {
                        "id": 10751,
                        "name": "Borborema",
                        "latitude": "-6.79913000",
                        "longitude": "-35.62094000"
                    },
                    {
                        "id": 10795,
                        "name": "Brejo do Cruz",
                        "latitude": "-6.32578000",
                        "longitude": "-37.49716000"
                    },
                    {
                        "id": 10797,
                        "name": "Brejo dos Santos",
                        "latitude": "-6.39546000",
                        "longitude": "-37.86070000"
                    },
                    {
                        "id": 10842,
                        "name": "Caaporã",
                        "latitude": "-7.51556000",
                        "longitude": "-34.90833000"
                    },
                    {
                        "id": 10845,
                        "name": "Cabaceiras",
                        "latitude": "-7.50856000",
                        "longitude": "-36.33351000"
                    },
                    {
                        "id": 10850,
                        "name": "Cabedelo",
                        "latitude": "-6.98111000",
                        "longitude": "-34.83389000"
                    },
                    {
                        "id": 10874,
                        "name": "Cachoeira dos Índios",
                        "latitude": "-6.94486000",
                        "longitude": "-38.69902000"
                    },
                    {
                        "id": 10880,
                        "name": "Cacimba de Areia",
                        "latitude": "-7.13451000",
                        "longitude": "-37.15370000"
                    },
                    {
                        "id": 10881,
                        "name": "Cacimba de Dentro",
                        "latitude": "-6.64167000",
                        "longitude": "-35.79000000"
                    },
                    {
                        "id": 10882,
                        "name": "Cacimbas",
                        "latitude": "-7.23180000",
                        "longitude": "-37.09984000"
                    },
                    {
                        "id": 10907,
                        "name": "Caiçara",
                        "latitude": "-6.59631000",
                        "longitude": "-35.39497000"
                    },
                    {
                        "id": 10915,
                        "name": "Cajazeiras",
                        "latitude": "-6.89028000",
                        "longitude": "-38.55528000"
                    },
                    {
                        "id": 10917,
                        "name": "Cajazeirinhas",
                        "latitude": "-6.94633000",
                        "longitude": "-37.81454000"
                    },
                    {
                        "id": 10924,
                        "name": "Caldas Brandão",
                        "latitude": "-7.15105000",
                        "longitude": "-35.34870000"
                    },
                    {
                        "id": 10936,
                        "name": "Camalaú",
                        "latitude": "-7.92695000",
                        "longitude": "-36.74211000"
                    },
                    {
                        "id": 10962,
                        "name": "Campina Grande",
                        "latitude": "-7.23056000",
                        "longitude": "-35.88111000"
                    },
                    {
                        "id": 11073,
                        "name": "Capim",
                        "latitude": "-6.89150000",
                        "longitude": "-35.18300000"
                    },
                    {
                        "id": 11118,
                        "name": "Caraúbas",
                        "latitude": "-7.79092000",
                        "longitude": "-36.50278000"
                    },
                    {
                        "id": 11164,
                        "name": "Carrapateira",
                        "latitude": "-7.02919000",
                        "longitude": "-38.32951000"
                    },
                    {
                        "id": 11182,
                        "name": "Casserengue",
                        "latitude": "-6.78130000",
                        "longitude": "-35.81676000"
                    },
                    {
                        "id": 11203,
                        "name": "Catingueira",
                        "latitude": "-7.13699000",
                        "longitude": "-37.59654000"
                    },
                    {
                        "id": 11205,
                        "name": "Catolé do Rocha",
                        "latitude": "-6.34389000",
                        "longitude": "-37.74667000"
                    },
                    {
                        "id": 11211,
                        "name": "Caturité",
                        "latitude": "-7.41991000",
                        "longitude": "-36.04194000"
                    },
                    {
                        "id": 11344,
                        "name": "Conceição",
                        "latitude": "-7.49917000",
                        "longitude": "-38.51375000"
                    },
                    {
                        "id": 11370,
                        "name": "Condado",
                        "latitude": "-6.85244000",
                        "longitude": "-37.61864000"
                    },
                    {
                        "id": 11371,
                        "name": "Conde",
                        "latitude": "-7.25972000",
                        "longitude": "-34.90750000"
                    },
                    {
                        "id": 11377,
                        "name": "Congo",
                        "latitude": "-7.79578000",
                        "longitude": "-36.63487000"
                    },
                    {
                        "id": 11406,
                        "name": "Coremas",
                        "latitude": "-7.01444000",
                        "longitude": "-37.94583000"
                    },
                    {
                        "id": 11459,
                        "name": "Coxixola",
                        "latitude": "-7.66749000",
                        "longitude": "-36.61824000"
                    },
                    {
                        "id": 11492,
                        "name": "Cruz do Espírito Santo",
                        "latitude": "-7.14000000",
                        "longitude": "-35.08639000"
                    },
                    {
                        "id": 11505,
                        "name": "Cubati",
                        "latitude": "-6.86116000",
                        "longitude": "-36.33415000"
                    },
                    {
                        "id": 11509,
                        "name": "Cuité",
                        "latitude": "-6.48361000",
                        "longitude": "-36.15361000"
                    },
                    {
                        "id": 11510,
                        "name": "Cuité de Mamanguape",
                        "latitude": "-6.89788000",
                        "longitude": "-35.26042000"
                    },
                    {
                        "id": 11508,
                        "name": "Cuitegi",
                        "latitude": "-6.90639000",
                        "longitude": "-35.53423000"
                    },
                    {
                        "id": 11531,
                        "name": "Curral de Cima",
                        "latitude": "-6.72359000",
                        "longitude": "-35.28596000"
                    },
                    {
                        "id": 11530,
                        "name": "Curral Velho",
                        "latitude": "-7.55796000",
                        "longitude": "-38.19847000"
                    },
                    {
                        "id": 11560,
                        "name": "Damião",
                        "latitude": "-6.67843000",
                        "longitude": "-35.92205000"
                    },
                    {
                        "id": 11579,
                        "name": "Desterro",
                        "latitude": "-7.29056000",
                        "longitude": "-37.09389000"
                    },
                    {
                        "id": 11584,
                        "name": "Diamante",
                        "latitude": "-7.41004000",
                        "longitude": "-38.30873000"
                    },
                    {
                        "id": 11642,
                        "name": "Dona Inês",
                        "latitude": "-6.61354000",
                        "longitude": "-35.62654000"
                    },
                    {
                        "id": 11665,
                        "name": "Duas Estradas",
                        "latitude": "-6.71946000",
                        "longitude": "-35.39737000"
                    },
                    {
                        "id": 11687,
                        "name": "Emas",
                        "latitude": "-7.12680000",
                        "longitude": "-37.73881000"
                    },
                    {
                        "id": 11731,
                        "name": "Esperança",
                        "latitude": "-6.99864000",
                        "longitude": "-35.90777000"
                    },
                    {
                        "id": 11770,
                        "name": "Fagundes",
                        "latitude": "-7.35500000",
                        "longitude": "-35.77500000"
                    },
                    {
                        "id": 11894,
                        "name": "Frei Martinho",
                        "latitude": "-6.44605000",
                        "longitude": "-36.48061000"
                    },
                    {
                        "id": 11911,
                        "name": "Gado Bravo",
                        "latitude": "-7.59984000",
                        "longitude": "-35.81967000"
                    },
                    {
                        "id": 12034,
                        "name": "Guarabira",
                        "latitude": "-6.85472000",
                        "longitude": "-35.49000000"
                    },
                    {
                        "id": 12086,
                        "name": "Gurinhém",
                        "latitude": "-7.12389000",
                        "longitude": "-35.42444000"
                    },
                    {
                        "id": 12087,
                        "name": "Gurjão",
                        "latitude": "-7.26100000",
                        "longitude": "-36.50008000"
                    },
                    {
                        "id": 12130,
                        "name": "Ibiara",
                        "latitude": "-7.48251000",
                        "longitude": "-38.38051000"
                    },
                    {
                        "id": 12179,
                        "name": "Igaracy",
                        "latitude": "-7.13856000",
                        "longitude": "-38.13526000"
                    },
                    {
                        "id": 12217,
                        "name": "Imaculada",
                        "latitude": "-7.38972000",
                        "longitude": "-37.50917000"
                    },
                    {
                        "id": 12245,
                        "name": "Ingá",
                        "latitude": "-7.25441000",
                        "longitude": "-35.62897000"
                    },
                    {
                        "id": 12325,
                        "name": "Itabaiana",
                        "latitude": "-7.32861000",
                        "longitude": "-35.33250000"
                    },
                    {
                        "id": 12430,
                        "name": "Itaporanga",
                        "latitude": "-7.30035000",
                        "longitude": "-38.25159000"
                    },
                    {
                        "id": 12432,
                        "name": "Itapororoca",
                        "latitude": "-6.81152000",
                        "longitude": "-35.24478000"
                    },
                    {
                        "id": 12461,
                        "name": "Itatuba",
                        "latitude": "-7.37500000",
                        "longitude": "-35.62833000"
                    },
                    {
                        "id": 12518,
                        "name": "Jacaraú",
                        "latitude": "-6.61222000",
                        "longitude": "-35.29278000"
                    },
                    {
                        "id": 12621,
                        "name": "Jericó",
                        "latitude": "-6.50746000",
                        "longitude": "-37.80665000"
                    },
                    {
                        "id": 12665,
                        "name": "João Pessoa",
                        "latitude": "-7.11500000",
                        "longitude": "-34.86306000"
                    },
                    {
                        "id": 12643,
                        "name": "Joca Claudino",
                        "latitude": "-6.48432000",
                        "longitude": "-38.46407000"
                    },
                    {
                        "id": 12669,
                        "name": "Juarez Távora",
                        "latitude": "-7.15975000",
                        "longitude": "-35.57160000"
                    },
                    {
                        "id": 12672,
                        "name": "Juazeirinho",
                        "latitude": "-6.99463000",
                        "longitude": "-36.60213000"
                    },
                    {
                        "id": 12683,
                        "name": "Junco do Seridó",
                        "latitude": "-6.97843000",
                        "longitude": "-36.72769000"
                    },
                    {
                        "id": 12698,
                        "name": "Juripiranga",
                        "latitude": "-7.35000000",
                        "longitude": "-35.22087000"
                    },
                    {
                        "id": 12699,
                        "name": "Juru",
                        "latitude": "-7.49131000",
                        "longitude": "-37.78854000"
                    },
                    {
                        "id": 12733,
                        "name": "Lagoa",
                        "latitude": "-6.59521000",
                        "longitude": "-37.84991000"
                    },
                    {
                        "id": 12752,
                        "name": "Lagoa de Dentro",
                        "latitude": "-6.68308000",
                        "longitude": "-35.35907000"
                    },
                    {
                        "id": 12746,
                        "name": "Lagoa Seca",
                        "latitude": "-7.17083000",
                        "longitude": "-35.85361000"
                    },
                    {
                        "id": 12802,
                        "name": "Lastro",
                        "latitude": "-6.53740000",
                        "longitude": "-38.18946000"
                    },
                    {
                        "id": 12842,
                        "name": "Livramento",
                        "latitude": "-7.34008000",
                        "longitude": "-36.93209000"
                    },
                    {
                        "id": 12848,
                        "name": "Logradouro",
                        "latitude": "-6.55268000",
                        "longitude": "-35.42864000"
                    },
                    {
                        "id": 12858,
                        "name": "Lucena",
                        "latitude": "-6.92461000",
                        "longitude": "-34.90267000"
                    },
                    {
                        "id": 13292,
                        "name": "Mãe d'Água",
                        "latitude": "-7.21990000",
                        "longitude": "-37.45284000"
                    },
                    {
                        "id": 12930,
                        "name": "Malta",
                        "latitude": "-6.90400000",
                        "longitude": "-37.51251000"
                    },
                    {
                        "id": 12931,
                        "name": "Mamanguape",
                        "latitude": "-6.83861000",
                        "longitude": "-35.12611000"
                    },
                    {
                        "id": 12940,
                        "name": "Manaíra",
                        "latitude": "-7.70611000",
                        "longitude": "-38.15444000"
                    },
                    {
                        "id": 12990,
                        "name": "Marcação",
                        "latitude": "-6.74717000",
                        "longitude": "-34.99103000"
                    },
                    {
                        "id": 13003,
                        "name": "Mari",
                        "latitude": "-7.07138000",
                        "longitude": "-35.30258000"
                    },
                    {
                        "id": 13023,
                        "name": "Marizópolis",
                        "latitude": "-6.82133000",
                        "longitude": "-38.33496000"
                    },
                    {
                        "id": 13043,
                        "name": "Massaranduba",
                        "latitude": "-7.20476000",
                        "longitude": "-35.78379000"
                    },
                    {
                        "id": 13050,
                        "name": "Mataraca",
                        "latitude": "-6.55476000",
                        "longitude": "-35.03690000"
                    },
                    {
                        "id": 13061,
                        "name": "Matinhas",
                        "latitude": "-7.12428000",
                        "longitude": "-35.76070000"
                    },
                    {
                        "id": 13065,
                        "name": "Mato Grosso",
                        "latitude": "-6.54728000",
                        "longitude": "-37.75067000"
                    },
                    {
                        "id": 13075,
                        "name": "Maturéia",
                        "latitude": "-7.27175000",
                        "longitude": "-37.33940000"
                    },
                    {
                        "id": 13164,
                        "name": "Mogeiro",
                        "latitude": "-7.29944000",
                        "longitude": "-35.47944000"
                    },
                    {
                        "id": 13181,
                        "name": "Montadas",
                        "latitude": "-7.08947000",
                        "longitude": "-35.90300000"
                    },
                    {
                        "id": 13205,
                        "name": "Monte Horebe",
                        "latitude": "-7.20792000",
                        "longitude": "-38.52503000"
                    },
                    {
                        "id": 13215,
                        "name": "Monteiro",
                        "latitude": "-7.91637000",
                        "longitude": "-37.17496000"
                    },
                    {
                        "id": 13266,
                        "name": "Mulungu",
                        "latitude": "-7.02444000",
                        "longitude": "-35.46194000"
                    },
                    {
                        "id": 13304,
                        "name": "Natuba",
                        "latitude": "-7.64139000",
                        "longitude": "-35.55000000"
                    },
                    {
                        "id": 13309,
                        "name": "Nazarezinho",
                        "latitude": "-6.91991000",
                        "longitude": "-38.32592000"
                    },
                    {
                        "id": 13379,
                        "name": "Nova Floresta",
                        "latitude": "-6.48792000",
                        "longitude": "-36.20101000"
                    },
                    {
                        "id": 13410,
                        "name": "Nova Olinda",
                        "latitude": "-7.45231000",
                        "longitude": "-38.01122000"
                    },
                    {
                        "id": 13417,
                        "name": "Nova Palmeira",
                        "latitude": "-6.67346000",
                        "longitude": "-36.44186000"
                    },
                    {
                        "id": 13494,
                        "name": "Olho d'Água",
                        "latitude": "-7.26106000",
                        "longitude": "-37.73242000"
                    },
                    {
                        "id": 13505,
                        "name": "Olivedos",
                        "latitude": "-6.99403000",
                        "longitude": "-36.23822000"
                    },
                    {
                        "id": 13544,
                        "name": "Ouro Velho",
                        "latitude": "-7.60554000",
                        "longitude": "-37.13565000"
                    },
                    {
                        "id": 13652,
                        "name": "Parari",
                        "latitude": "-7.31136000",
                        "longitude": "-36.67699000"
                    },
                    {
                        "id": 13692,
                        "name": "Passagem",
                        "latitude": "-7.11889000",
                        "longitude": "-37.03671000"
                    },
                    {
                        "id": 13706,
                        "name": "Patos",
                        "latitude": "-7.02444000",
                        "longitude": "-37.28000000"
                    },
                    {
                        "id": 13726,
                        "name": "Paulista",
                        "latitude": "-6.59504000",
                        "longitude": "-37.60966000"
                    },
                    {
                        "id": 13750,
                        "name": "Pedra Branca",
                        "latitude": "-7.46068000",
                        "longitude": "-38.07996000"
                    },
                    {
                        "id": 13754,
                        "name": "Pedra Lavrada",
                        "latitude": "-6.78024000",
                        "longitude": "-36.44200000"
                    },
                    {
                        "id": 13764,
                        "name": "Pedras de Fogo",
                        "latitude": "-7.40194000",
                        "longitude": "-35.11639000"
                    },
                    {
                        "id": 13781,
                        "name": "Pedro Régis",
                        "latitude": "-6.67047000",
                        "longitude": "-35.31031000"
                    },
                    {
                        "id": 13824,
                        "name": "Piancó",
                        "latitude": "-7.19806000",
                        "longitude": "-37.92917000"
                    },
                    {
                        "id": 13830,
                        "name": "Picuí",
                        "latitude": "-6.51056000",
                        "longitude": "-36.34694000"
                    },
                    {
                        "id": 13836,
                        "name": "Pilar",
                        "latitude": "-7.25739000",
                        "longitude": "-35.26971000"
                    },
                    {
                        "id": 13841,
                        "name": "Pilões",
                        "latitude": "-6.89446000",
                        "longitude": "-35.59432000"
                    },
                    {
                        "id": 13843,
                        "name": "Pilõezinhos",
                        "latitude": "-6.85269000",
                        "longitude": "-35.54455000"
                    },
                    {
                        "id": 13920,
                        "name": "Pirpirituba",
                        "latitude": "-6.78000000",
                        "longitude": "-35.49861000"
                    },
                    {
                        "id": 13925,
                        "name": "Pitimbu",
                        "latitude": "-7.41381000",
                        "longitude": "-34.83686000"
                    },
                    {
                        "id": 13946,
                        "name": "Pocinhos",
                        "latitude": "-7.07667000",
                        "longitude": "-36.06111000"
                    },
                    {
                        "id": 14046,
                        "name": "Poço Dantas",
                        "latitude": "-6.38792000",
                        "longitude": "-38.53359000"
                    },
                    {
                        "id": 14052,
                        "name": "Poço de José de Moura",
                        "latitude": "-6.59957000",
                        "longitude": "-38.50574000"
                    },
                    {
                        "id": 13951,
                        "name": "Pombal",
                        "latitude": "-6.77028000",
                        "longitude": "-37.80167000"
                    },
                    {
                        "id": 14068,
                        "name": "Prata",
                        "latitude": "-7.71250000",
                        "longitude": "-37.09411000"
                    },
                    {
                        "id": 14107,
                        "name": "Princesa Isabel",
                        "latitude": "-7.73667000",
                        "longitude": "-37.99333000"
                    },
                    {
                        "id": 14118,
                        "name": "Puxinanã",
                        "latitude": "-7.16111000",
                        "longitude": "-35.96056000"
                    },
                    {
                        "id": 14140,
                        "name": "Queimadas",
                        "latitude": "-7.42696000",
                        "longitude": "-35.89774000"
                    },
                    {
                        "id": 14158,
                        "name": "Quixaba",
                        "latitude": "-7.05081000",
                        "longitude": "-37.11783000"
                    },
                    {
                        "id": 14194,
                        "name": "Remígio",
                        "latitude": "-6.94646000",
                        "longitude": "-35.78039000"
                    },
                    {
                        "id": 14221,
                        "name": "Riachão",
                        "latitude": "-6.55515000",
                        "longitude": "-35.62324000"
                    },
                    {
                        "id": 14223,
                        "name": "Riachão do Bacamarte",
                        "latitude": "-7.26337000",
                        "longitude": "-35.67518000"
                    },
                    {
                        "id": 14226,
                        "name": "Riachão do Poço",
                        "latitude": "-7.17041000",
                        "longitude": "-35.30300000"
                    },
                    {
                        "id": 14215,
                        "name": "Riacho de Santo Antônio",
                        "latitude": "-7.66143000",
                        "longitude": "-36.13551000"
                    },
                    {
                        "id": 14216,
                        "name": "Riacho dos Cavalos",
                        "latitude": "-6.47140000",
                        "longitude": "-37.64024000"
                    },
                    {
                        "id": 14299,
                        "name": "Rio Tinto",
                        "latitude": "-6.79673000",
                        "longitude": "-35.03715000"
                    },
                    {
                        "id": 14382,
                        "name": "Salgadinho",
                        "latitude": "-7.08934000",
                        "longitude": "-36.86318000"
                    },
                    {
                        "id": 14385,
                        "name": "Salgado de São Félix",
                        "latitude": "-7.35694000",
                        "longitude": "-35.44056000"
                    },
                    {
                        "id": 14433,
                        "name": "Santa Cecília",
                        "latitude": "-7.72027000",
                        "longitude": "-35.93681000"
                    },
                    {
                        "id": 14440,
                        "name": "Santa Cruz",
                        "latitude": "-6.54542000",
                        "longitude": "-38.04968000"
                    },
                    {
                        "id": 14471,
                        "name": "Santa Helena",
                        "latitude": "-6.72745000",
                        "longitude": "-38.59506000"
                    },
                    {
                        "id": 14478,
                        "name": "Santa Inês",
                        "latitude": "-7.68334000",
                        "longitude": "-38.59346000"
                    },
                    {
                        "id": 14489,
                        "name": "Santa Luzia",
                        "latitude": "-6.87222000",
                        "longitude": "-36.91861000"
                    },
                    {
                        "id": 14525,
                        "name": "Santa Rita",
                        "latitude": "-7.10437000",
                        "longitude": "-34.97387000"
                    },
                    {
                        "id": 14552,
                        "name": "Santa Teresinha",
                        "latitude": "-7.12089000",
                        "longitude": "-37.49654000"
                    },
                    {
                        "id": 14574,
                        "name": "Santana de Mangueira",
                        "latitude": "-7.66593000",
                        "longitude": "-38.35848000"
                    },
                    {
                        "id": 14595,
                        "name": "Santana dos Garrotes",
                        "latitude": "-7.38163000",
                        "longitude": "-37.95386000"
                    },
                    {
                        "id": 14608,
                        "name": "Santo André",
                        "latitude": "-7.24178000",
                        "longitude": "-36.61460000"
                    },
                    {
                        "id": 14834,
                        "name": "São Bentinho",
                        "latitude": "-6.88452000",
                        "longitude": "-37.75898000"
                    },
                    {
                        "id": 14836,
                        "name": "São Bento",
                        "latitude": "-6.47344000",
                        "longitude": "-37.47144000"
                    },
                    {
                        "id": 14862,
                        "name": "São Domingos",
                        "latitude": "-6.80733000",
                        "longitude": "-37.91657000"
                    },
                    {
                        "id": 14870,
                        "name": "São Domingos do Cariri",
                        "latitude": "-7.56749000",
                        "longitude": "-36.36393000"
                    },
                    {
                        "id": 14879,
                        "name": "São Francisco",
                        "latitude": "-6.63302000",
                        "longitude": "-38.03780000"
                    },
                    {
                        "id": 15027,
                        "name": "São João do Cariri",
                        "latitude": "-7.48465000",
                        "longitude": "-36.48602000"
                    },
                    {
                        "id": 15042,
                        "name": "São João do Rio do Peixe",
                        "latitude": "-6.71851000",
                        "longitude": "-38.42942000"
                    },
                    {
                        "id": 15046,
                        "name": "São João do Tigre",
                        "latitude": "-8.10906000",
                        "longitude": "-36.79766000"
                    },
                    {
                        "id": 14943,
                        "name": "São José da Lagoa Tapada",
                        "latitude": "-6.94245000",
                        "longitude": "-38.09393000"
                    },
                    {
                        "id": 14952,
                        "name": "São José de Caiana",
                        "latitude": "-7.25916000",
                        "longitude": "-38.34483000"
                    },
                    {
                        "id": 14953,
                        "name": "São José de Espinharas",
                        "latitude": "-6.80244000",
                        "longitude": "-37.38224000"
                    },
                    {
                        "id": 14955,
                        "name": "São José de Piranhas",
                        "latitude": "-7.12056000",
                        "longitude": "-38.50194000"
                    },
                    {
                        "id": 14956,
                        "name": "São José de Princesa",
                        "latitude": "-7.70649000",
                        "longitude": "-38.08465000"
                    },
                    {
                        "id": 14962,
                        "name": "São José do Bonfim",
                        "latitude": "-7.13715000",
                        "longitude": "-37.31607000"
                    },
                    {
                        "id": 14963,
                        "name": "São José do Brejo do Cruz",
                        "latitude": "-6.23731000",
                        "longitude": "-37.37932000"
                    },
                    {
                        "id": 14986,
                        "name": "São José do Sabugi",
                        "latitude": "-6.82784000",
                        "longitude": "-36.80335000"
                    },
                    {
                        "id": 14994,
                        "name": "São José dos Cordeiros",
                        "latitude": "-7.41638000",
                        "longitude": "-36.84773000"
                    },
                    {
                        "id": 14997,
                        "name": "São José dos Ramos",
                        "latitude": "-7.25103000",
                        "longitude": "-35.37410000"
                    },
                    {
                        "id": 15068,
                        "name": "São Mamede",
                        "latitude": "-6.92111000",
                        "longitude": "-37.09131000"
                    },
                    {
                        "id": 15084,
                        "name": "São Miguel de Taipu",
                        "latitude": "-7.21706000",
                        "longitude": "-35.20175000"
                    },
                    {
                        "id": 15142,
                        "name": "São Sebastião de Lagoa de Roça",
                        "latitude": "-7.08497000",
                        "longitude": "-35.84445000"
                    },
                    {
                        "id": 15154,
                        "name": "São Sebastião do Umbuzeiro",
                        "latitude": "-8.15690000",
                        "longitude": "-37.02220000"
                    },
                    {
                        "id": 15173,
                        "name": "São Vicente do Seridó",
                        "latitude": "-6.88683000",
                        "longitude": "-36.42652000"
                    },
                    {
                        "id": 14665,
                        "name": "Sapé",
                        "latitude": "-7.07937000",
                        "longitude": "-35.21734000"
                    },
                    {
                        "id": 14725,
                        "name": "Serra Branca",
                        "latitude": "-6.53333000",
                        "longitude": "-38.26667000"
                    },
                    {
                        "id": 14735,
                        "name": "Serra da Raiz",
                        "latitude": "-6.69703000",
                        "longitude": "-35.43579000"
                    },
                    {
                        "id": 14728,
                        "name": "Serra Grande",
                        "latitude": "-7.25090000",
                        "longitude": "-38.39588000"
                    },
                    {
                        "id": 14733,
                        "name": "Serra Redonda",
                        "latitude": "-7.15665000",
                        "longitude": "-35.67628000"
                    },
                    {
                        "id": 14750,
                        "name": "Serraria",
                        "latitude": "-6.86365000",
                        "longitude": "-35.66926000"
                    },
                    {
                        "id": 14763,
                        "name": "Sertãozinho",
                        "latitude": "-6.73939000",
                        "longitude": "-35.41628000"
                    },
                    {
                        "id": 14797,
                        "name": "Sobrado",
                        "latitude": "-7.16887000",
                        "longitude": "-35.23251000"
                    },
                    {
                        "id": 14807,
                        "name": "Solânea",
                        "latitude": "-6.73321000",
                        "longitude": "-35.69495000"
                    },
                    {
                        "id": 14802,
                        "name": "Soledade",
                        "latitude": "-7.05722000",
                        "longitude": "-36.36278000"
                    },
                    {
                        "id": 14813,
                        "name": "Sossêgo",
                        "latitude": "-6.67592000",
                        "longitude": "-36.17875000"
                    },
                    {
                        "id": 14815,
                        "name": "Sousa",
                        "latitude": "-6.73098000",
                        "longitude": "-38.18614000"
                    },
                    {
                        "id": 14825,
                        "name": "Sumé",
                        "latitude": "-7.67167000",
                        "longitude": "-36.88000000"
                    },
                    {
                        "id": 15196,
                        "name": "Tacima",
                        "latitude": "-6.53805000",
                        "longitude": "-35.52277000"
                    },
                    {
                        "id": 15230,
                        "name": "Taperoá",
                        "latitude": "-7.16870000",
                        "longitude": "-36.79197000"
                    },
                    {
                        "id": 15262,
                        "name": "Tavares",
                        "latitude": "-7.61418000",
                        "longitude": "-37.87959000"
                    },
                    {
                        "id": 15265,
                        "name": "Teixeira",
                        "latitude": "-7.24821000",
                        "longitude": "-37.27523000"
                    },
                    {
                        "id": 15277,
                        "name": "Tenório",
                        "latitude": "-6.97568000",
                        "longitude": "-36.62216000"
                    },
                    {
                        "id": 15362,
                        "name": "Triunfo",
                        "latitude": "-6.58475000",
                        "longitude": "-38.57827000"
                    },
                    {
                        "id": 15442,
                        "name": "Uiraúna",
                        "latitude": "-6.49650000",
                        "longitude": "-38.38015000"
                    },
                    {
                        "id": 15449,
                        "name": "Umbuzeiro",
                        "latitude": "-7.67111000",
                        "longitude": "-35.73927000"
                    },
                    {
                        "id": 15613,
                        "name": "Várzea",
                        "latitude": "-6.80276000",
                        "longitude": "-37.03707000"
                    },
                    {
                        "id": 15563,
                        "name": "Vieirópolis",
                        "latitude": "-6.55838000",
                        "longitude": "-38.27091000"
                    },
                    {
                        "id": 15593,
                        "name": "Vista Serrana",
                        "latitude": "-6.74167000",
                        "longitude": "-37.57597000"
                    },
                    {
                        "id": 15644,
                        "name": "Zabelê",
                        "latitude": "-8.07634000",
                        "longitude": "-37.05635000"
                    }
                ]
            },
            {
                "id": 2022,
                "name": "Paraná",
                "iso2": "PR",
                "latitude": "-25.25208880",
                "longitude": "-52.02154150",
                "type": "state",
                "cities": [
                    {
                        "id": 10060,
                        "name": "Abatiá",
                        "latitude": "-23.29903000",
                        "longitude": "-50.32176000"
                    },
                    {
                        "id": 10083,
                        "name": "Adrianópolis",
                        "latitude": "-24.76632000",
                        "longitude": "-48.79998000"
                    },
                    {
                        "id": 10099,
                        "name": "Agudos do Sul",
                        "latitude": "-26.04616000",
                        "longitude": "-49.31186000"
                    },
                    {
                        "id": 10144,
                        "name": "Almirante Tamandaré",
                        "latitude": "-25.32472000",
                        "longitude": "-49.31000000"
                    },
                    {
                        "id": 10155,
                        "name": "Altamira do Paraná",
                        "latitude": "-24.81257000",
                        "longitude": "-52.70740000"
                    },
                    {
                        "id": 10187,
                        "name": "Altãnia",
                        "latitude": "-23.87444000",
                        "longitude": "-53.90167000"
                    },
                    {
                        "id": 10177,
                        "name": "Alto Paraíso",
                        "latitude": "-23.55498000",
                        "longitude": "-53.80770000"
                    },
                    {
                        "id": 10175,
                        "name": "Alto Paraná",
                        "latitude": "-23.06783000",
                        "longitude": "-52.31196000"
                    },
                    {
                        "id": 10180,
                        "name": "Alto Piquiri",
                        "latitude": "-24.12973000",
                        "longitude": "-53.34661000"
                    },
                    {
                        "id": 10188,
                        "name": "Altônia",
                        "latitude": "-23.88648000",
                        "longitude": "-53.96852000"
                    },
                    {
                        "id": 10200,
                        "name": "Alvorada do Sul",
                        "latitude": "-22.80928000",
                        "longitude": "-51.27421000"
                    },
                    {
                        "id": 10203,
                        "name": "Amaporã",
                        "latitude": "-23.13633000",
                        "longitude": "-52.83810000"
                    },
                    {
                        "id": 10222,
                        "name": "Ampére",
                        "latitude": "-25.91242000",
                        "longitude": "-53.49366000"
                    },
                    {
                        "id": 10229,
                        "name": "Anahy",
                        "latitude": "-24.66517000",
                        "longitude": "-53.13229000"
                    },
                    {
                        "id": 10243,
                        "name": "Andirá",
                        "latitude": "-23.03931000",
                        "longitude": "-50.27404000"
                    },
                    {
                        "id": 15681,
                        "name": "Ângulo",
                        "latitude": "-23.21625000",
                        "longitude": "-51.93851000"
                    },
                    {
                        "id": 10269,
                        "name": "Antonina",
                        "latitude": "-25.28425000",
                        "longitude": "-48.72037000"
                    },
                    {
                        "id": 10279,
                        "name": "Antônio Olinto",
                        "latitude": "-25.96435000",
                        "longitude": "-50.12992000"
                    },
                    {
                        "id": 10301,
                        "name": "Apucarana",
                        "latitude": "-23.56159000",
                        "longitude": "-51.45358000"
                    },
                    {
                        "id": 10340,
                        "name": "Arapongas",
                        "latitude": "-23.41944000",
                        "longitude": "-51.42444000"
                    },
                    {
                        "id": 10342,
                        "name": "Arapoti",
                        "latitude": "-24.06902000",
                        "longitude": "-50.03733000"
                    },
                    {
                        "id": 10345,
                        "name": "Arapuã",
                        "latitude": "-24.31991000",
                        "longitude": "-51.81138000"
                    },
                    {
                        "id": 10358,
                        "name": "Araruna",
                        "latitude": "-23.97219000",
                        "longitude": "-52.59131000"
                    },
                    {
                        "id": 10363,
                        "name": "Araucária",
                        "latitude": "-25.59306000",
                        "longitude": "-49.41028000"
                    },
                    {
                        "id": 10398,
                        "name": "Ariranha do Ivaí",
                        "latitude": "-24.35185000",
                        "longitude": "-51.53194000"
                    },
                    {
                        "id": 10426,
                        "name": "Assaí",
                        "latitude": "-23.37333000",
                        "longitude": "-50.84139000"
                    },
                    {
                        "id": 10429,
                        "name": "Assis Chateaubriand",
                        "latitude": "-24.40824000",
                        "longitude": "-53.53328000"
                    },
                    {
                        "id": 10433,
                        "name": "Astorga",
                        "latitude": "-23.24011000",
                        "longitude": "-51.69541000"
                    },
                    {
                        "id": 10435,
                        "name": "Atalaia",
                        "latitude": "-23.12728000",
                        "longitude": "-52.04286000"
                    },
                    {
                        "id": 10491,
                        "name": "Balsa Nova",
                        "latitude": "-25.52151000",
                        "longitude": "-49.67738000"
                    },
                    {
                        "id": 10500,
                        "name": "Bandeirantes",
                        "latitude": "-23.15516000",
                        "longitude": "-50.33873000"
                    },
                    {
                        "id": 10510,
                        "name": "Barbosa Ferraz",
                        "latitude": "-24.06134000",
                        "longitude": "-52.05494000"
                    },
                    {
                        "id": 10537,
                        "name": "Barra do Jacaré",
                        "latitude": "-23.11066000",
                        "longitude": "-50.15719000"
                    },
                    {
                        "id": 10547,
                        "name": "Barracão",
                        "latitude": "-26.24009000",
                        "longitude": "-53.52586000"
                    },
                    {
                        "id": 10595,
                        "name": "Bela Vista da Caroba",
                        "latitude": "-25.87398000",
                        "longitude": "-53.62755000"
                    },
                    {
                        "id": 10599,
                        "name": "Bela Vista do Paraíso",
                        "latitude": "-22.99667000",
                        "longitude": "-51.19056000"
                    },
                    {
                        "id": 10655,
                        "name": "Bituruna",
                        "latitude": "-26.18538000",
                        "longitude": "-51.54497000"
                    },
                    {
                        "id": 10659,
                        "name": "Boa Esperança",
                        "latitude": "-24.24372000",
                        "longitude": "-52.73574000"
                    },
                    {
                        "id": 10660,
                        "name": "Boa Esperança do Iguaçu",
                        "latitude": "-25.63520000",
                        "longitude": "-53.22621000"
                    },
                    {
                        "id": 10665,
                        "name": "Boa Ventura de São Roque",
                        "latitude": "-24.84082000",
                        "longitude": "-51.55638000"
                    },
                    {
                        "id": 10668,
                        "name": "Boa Vista da Aparecida",
                        "latitude": "-25.43709000",
                        "longitude": "-53.41293000"
                    },
                    {
                        "id": 10684,
                        "name": "Bocaiúva do Sul",
                        "latitude": "-25.10040000",
                        "longitude": "-48.87116000"
                    },
                    {
                        "id": 10714,
                        "name": "Bom Jesus do Sul",
                        "latitude": "-26.15280000",
                        "longitude": "-53.54963000"
                    },
                    {
                        "id": 10727,
                        "name": "Bom Sucesso",
                        "latitude": "-23.69506000",
                        "longitude": "-51.81945000"
                    },
                    {
                        "id": 10729,
                        "name": "Bom Sucesso do Sul",
                        "latitude": "-26.08239000",
                        "longitude": "-52.85103000"
                    },
                    {
                        "id": 10754,
                        "name": "Borrazópolis",
                        "latitude": "-23.93931000",
                        "longitude": "-51.60141000"
                    },
                    {
                        "id": 10764,
                        "name": "Braganey",
                        "latitude": "-24.79019000",
                        "longitude": "-53.08864000"
                    },
                    {
                        "id": 10772,
                        "name": "Brasilândia do Sul",
                        "latitude": "-24.21682000",
                        "longitude": "-53.57250000"
                    },
                    {
                        "id": 10894,
                        "name": "Cafeara",
                        "latitude": "-22.79980000",
                        "longitude": "-51.71428000"
                    },
                    {
                        "id": 10896,
                        "name": "Cafelândia",
                        "latitude": "-24.69297000",
                        "longitude": "-53.35090000"
                    },
                    {
                        "id": 10897,
                        "name": "Cafezal do Sul",
                        "latitude": "-23.95645000",
                        "longitude": "-53.60910000"
                    },
                    {
                        "id": 10929,
                        "name": "Califórnia",
                        "latitude": "-23.66340000",
                        "longitude": "-51.32824000"
                    },
                    {
                        "id": 10944,
                        "name": "Cambará",
                        "latitude": "-23.00420000",
                        "longitude": "-50.08819000"
                    },
                    {
                        "id": 10951,
                        "name": "Cambé",
                        "latitude": "-23.27583000",
                        "longitude": "-51.27833000"
                    },
                    {
                        "id": 10946,
                        "name": "Cambira",
                        "latitude": "-23.63164000",
                        "longitude": "-51.56671000"
                    },
                    {
                        "id": 10965,
                        "name": "Campina da Lagoa",
                        "latitude": "-24.60154000",
                        "longitude": "-52.78545000"
                    },
                    {
                        "id": 10968,
                        "name": "Campina do Simão",
                        "latitude": "-25.08478000",
                        "longitude": "-51.78423000"
                    },
                    {
                        "id": 10963,
                        "name": "Campina Grande do Sul",
                        "latitude": "-25.30556000",
                        "longitude": "-49.05528000"
                    },
                    {
                        "id": 10985,
                        "name": "Campo Bonito",
                        "latitude": "-24.88808000",
                        "longitude": "-53.01009000"
                    },
                    {
                        "id": 11007,
                        "name": "Campo do Tenente",
                        "latitude": "-25.95791000",
                        "longitude": "-49.65936000"
                    },
                    {
                        "id": 10992,
                        "name": "Campo Largo",
                        "latitude": "-25.45955000",
                        "longitude": "-49.53014000"
                    },
                    {
                        "id": 10996,
                        "name": "Campo Magro",
                        "latitude": "-25.26822000",
                        "longitude": "-49.47580000"
                    },
                    {
                        "id": 10998,
                        "name": "Campo Mourão",
                        "latitude": "-24.04309000",
                        "longitude": "-52.37929000"
                    },
                    {
                        "id": 11550,
                        "name": "Cândido de Abreu",
                        "latitude": "-24.56694000",
                        "longitude": "-51.33333000"
                    },
                    {
                        "id": 11039,
                        "name": "Candói",
                        "latitude": "-25.51315000",
                        "longitude": "-52.02243000"
                    },
                    {
                        "id": 11054,
                        "name": "Cantagalo",
                        "latitude": "-25.29530000",
                        "longitude": "-52.15269000"
                    },
                    {
                        "id": 11063,
                        "name": "Capanema",
                        "latitude": "-25.61839000",
                        "longitude": "-53.79262000"
                    },
                    {
                        "id": 11084,
                        "name": "Capitão Leônidas Marques",
                        "latitude": "-25.47998000",
                        "longitude": "-53.58797000"
                    },
                    {
                        "id": 11104,
                        "name": "Carambeí",
                        "latitude": "-24.95260000",
                        "longitude": "-50.11590000"
                    },
                    {
                        "id": 11141,
                        "name": "Carlópolis",
                        "latitude": "-23.44971000",
                        "longitude": "-49.70142000"
                    },
                    {
                        "id": 11176,
                        "name": "Cascavel",
                        "latitude": "-24.95583000",
                        "longitude": "-53.45528000"
                    },
                    {
                        "id": 11191,
                        "name": "Castro",
                        "latitude": "-24.83040000",
                        "longitude": "-49.85535000"
                    },
                    {
                        "id": 11196,
                        "name": "Catanduvas",
                        "latitude": "-25.26047000",
                        "longitude": "-53.17016000"
                    },
                    {
                        "id": 11237,
                        "name": "Centenário do Sul",
                        "latitude": "-22.82111000",
                        "longitude": "-51.59528000"
                    },
                    {
                        "id": 11249,
                        "name": "Cerro Azul",
                        "latitude": "-24.85878000",
                        "longitude": "-49.29561000"
                    },
                    {
                        "id": 11551,
                        "name": "Céu Azul",
                        "latitude": "-25.29831000",
                        "longitude": "-53.74848000"
                    },
                    {
                        "id": 11278,
                        "name": "Chopinzinho",
                        "latitude": "-25.81428000",
                        "longitude": "-52.45682000"
                    },
                    {
                        "id": 11289,
                        "name": "Cianorte",
                        "latitude": "-23.66333000",
                        "longitude": "-52.60500000"
                    },
                    {
                        "id": 11290,
                        "name": "Cidade Gaúcha",
                        "latitude": "-23.36535000",
                        "longitude": "-52.97466000"
                    },
                    {
                        "id": 11300,
                        "name": "Clevelândia",
                        "latitude": "-26.39583000",
                        "longitude": "-52.47083000"
                    },
                    {
                        "id": 11328,
                        "name": "Colombo",
                        "latitude": "-25.30126000",
                        "longitude": "-49.16965000"
                    },
                    {
                        "id": 11329,
                        "name": "Colorado",
                        "latitude": "-22.83750000",
                        "longitude": "-51.97306000"
                    },
                    {
                        "id": 11381,
                        "name": "Congonhinhas",
                        "latitude": "-23.62943000",
                        "longitude": "-50.49858000"
                    },
                    {
                        "id": 11385,
                        "name": "Conselheiro Mairinck",
                        "latitude": "-23.58771000",
                        "longitude": "-50.11629000"
                    },
                    {
                        "id": 11390,
                        "name": "Contenda",
                        "latitude": "-25.71409000",
                        "longitude": "-49.50798000"
                    },
                    {
                        "id": 11398,
                        "name": "Corbélia",
                        "latitude": "-24.79889000",
                        "longitude": "-53.30667000"
                    },
                    {
                        "id": 11410,
                        "name": "Cornélio Procópio",
                        "latitude": "-23.18111000",
                        "longitude": "-50.64667000"
                    },
                    {
                        "id": 11417,
                        "name": "Coronel Domingos Soares",
                        "latitude": "-26.18290000",
                        "longitude": "-51.97777000"
                    },
                    {
                        "id": 11430,
                        "name": "Coronel Vivida",
                        "latitude": "-25.97972000",
                        "longitude": "-52.56778000"
                    },
                    {
                        "id": 11439,
                        "name": "Corumbataí do Sul",
                        "latitude": "-24.12007000",
                        "longitude": "-52.14622000"
                    },
                    {
                        "id": 11490,
                        "name": "Cruz Machado",
                        "latitude": "-25.91086000",
                        "longitude": "-51.22563000"
                    },
                    {
                        "id": 11496,
                        "name": "Cruzeiro do Iguaçu",
                        "latitude": "-25.60303000",
                        "longitude": "-53.12736000"
                    },
                    {
                        "id": 11497,
                        "name": "Cruzeiro do Oeste",
                        "latitude": "-23.78500000",
                        "longitude": "-53.07333000"
                    },
                    {
                        "id": 11499,
                        "name": "Cruzeiro do Sul",
                        "latitude": "-22.97418000",
                        "longitude": "-52.15969000"
                    },
                    {
                        "id": 11502,
                        "name": "Cruzmaltina",
                        "latitude": "-24.02357000",
                        "longitude": "-51.48481000"
                    },
                    {
                        "id": 11524,
                        "name": "Curitiba",
                        "latitude": "-25.42778000",
                        "longitude": "-49.27306000"
                    },
                    {
                        "id": 11526,
                        "name": "Curiúva",
                        "latitude": "-24.00386000",
                        "longitude": "-50.46541000"
                    },
                    {
                        "id": 11585,
                        "name": "Diamante d'Oeste",
                        "latitude": "-24.94559000",
                        "longitude": "-54.10349000"
                    },
                    {
                        "id": 11586,
                        "name": "Diamante do Norte",
                        "latitude": "-22.63752000",
                        "longitude": "-52.87280000"
                    },
                    {
                        "id": 11587,
                        "name": "Diamante do Sul",
                        "latitude": "-24.98680000",
                        "longitude": "-52.70134000"
                    },
                    {
                        "id": 11620,
                        "name": "Dois Vizinhos",
                        "latitude": "-25.73361000",
                        "longitude": "-53.05722000"
                    },
                    {
                        "id": 11650,
                        "name": "Douradina",
                        "latitude": "-23.34040000",
                        "longitude": "-53.27489000"
                    },
                    {
                        "id": 11655,
                        "name": "Doutor Camargo",
                        "latitude": "-23.56158000",
                        "longitude": "-52.22341000"
                    },
                    {
                        "id": 11660,
                        "name": "Doutor Ulysses",
                        "latitude": "-24.63500000",
                        "longitude": "-49.40020000"
                    },
                    {
                        "id": 11712,
                        "name": "Enéas Marques",
                        "latitude": "-25.86454000",
                        "longitude": "-53.15902000"
                    },
                    {
                        "id": 11698,
                        "name": "Engenheiro Beltrão",
                        "latitude": "-23.79722000",
                        "longitude": "-52.26917000"
                    },
                    {
                        "id": 11708,
                        "name": "Entre Rios do Oeste",
                        "latitude": "-24.70408000",
                        "longitude": "-54.21562000"
                    },
                    {
                        "id": 11732,
                        "name": "Esperança Nova",
                        "latitude": "-23.71008000",
                        "longitude": "-53.79362000"
                    },
                    {
                        "id": 11734,
                        "name": "Espigão Alto do Iguaçu",
                        "latitude": "-25.35011000",
                        "longitude": "-52.77923000"
                    },
                    {
                        "id": 11777,
                        "name": "Farol",
                        "latitude": "-24.10348000",
                        "longitude": "-52.66314000"
                    },
                    {
                        "id": 11781,
                        "name": "Faxinal",
                        "latitude": "-24.00028000",
                        "longitude": "-51.31944000"
                    },
                    {
                        "id": 11786,
                        "name": "Fazenda Rio Grande",
                        "latitude": "-25.66466000",
                        "longitude": "-49.30426000"
                    },
                    {
                        "id": 11909,
                        "name": "Fênix",
                        "latitude": "-23.90551000",
                        "longitude": "-52.03998000"
                    },
                    {
                        "id": 11802,
                        "name": "Fernandes Pinheiro",
                        "latitude": "-25.44403000",
                        "longitude": "-50.51811000"
                    },
                    {
                        "id": 11816,
                        "name": "Figueira",
                        "latitude": "-23.86125000",
                        "longitude": "-50.42076000"
                    },
                    {
                        "id": 11825,
                        "name": "Flor da Serra do Sul",
                        "latitude": "-26.23081000",
                        "longitude": "-53.30368000"
                    },
                    {
                        "id": 11828,
                        "name": "Floraí",
                        "latitude": "-23.32830000",
                        "longitude": "-52.32422000"
                    },
                    {
                        "id": 11835,
                        "name": "Floresta",
                        "latitude": "-23.63014000",
                        "longitude": "-52.07630000"
                    },
                    {
                        "id": 11840,
                        "name": "Florestópolis",
                        "latitude": "-22.86333000",
                        "longitude": "-51.38722000"
                    },
                    {
                        "id": 11846,
                        "name": "Flórida",
                        "latitude": "-23.11265000",
                        "longitude": "-51.97861000"
                    },
                    {
                        "id": 11854,
                        "name": "Formosa do Oeste",
                        "latitude": "-24.30836000",
                        "longitude": "-53.32776000"
                    },
                    {
                        "id": 11871,
                        "name": "Foz do Iguaçu",
                        "latitude": "-25.54778000",
                        "longitude": "-54.58806000"
                    },
                    {
                        "id": 11872,
                        "name": "Foz do Jordão",
                        "latitude": "-25.69523000",
                        "longitude": "-52.06075000"
                    },
                    {
                        "id": 11876,
                        "name": "Francisco Alves",
                        "latitude": "-24.06510000",
                        "longitude": "-53.88444000"
                    },
                    {
                        "id": 11879,
                        "name": "Francisco Beltrão",
                        "latitude": "-26.08111000",
                        "longitude": "-53.05500000"
                    },
                    {
                        "id": 11934,
                        "name": "General Carneiro",
                        "latitude": "-26.43749000",
                        "longitude": "-51.40075000"
                    },
                    {
                        "id": 11955,
                        "name": "Godoy Moreira",
                        "latitude": "-24.14813000",
                        "longitude": "-51.91555000"
                    },
                    {
                        "id": 11968,
                        "name": "Goioerê",
                        "latitude": "-24.18868000",
                        "longitude": "-53.09916000"
                    },
                    {
                        "id": 11969,
                        "name": "Goioxim",
                        "latitude": "-25.09533000",
                        "longitude": "-52.00812000"
                    },
                    {
                        "id": 11996,
                        "name": "Grandes Rios",
                        "latitude": "-24.18645000",
                        "longitude": "-51.43460000"
                    },
                    {
                        "id": 12078,
                        "name": "Guaíra",
                        "latitude": "-24.26175000",
                        "longitude": "-54.23821000"
                    },
                    {
                        "id": 12015,
                        "name": "Guairaçá",
                        "latitude": "-22.90548000",
                        "longitude": "-52.74878000"
                    },
                    {
                        "id": 12023,
                        "name": "Guamiranga",
                        "latitude": "-25.15028000",
                        "longitude": "-50.86182000"
                    },
                    {
                        "id": 12029,
                        "name": "Guapirama",
                        "latitude": "-23.46840000",
                        "longitude": "-50.09128000"
                    },
                    {
                        "id": 12030,
                        "name": "Guaporema",
                        "latitude": "-23.31022000",
                        "longitude": "-52.82479000"
                    },
                    {
                        "id": 12036,
                        "name": "Guaraci",
                        "latitude": "-22.97343000",
                        "longitude": "-51.69739000"
                    },
                    {
                        "id": 12047,
                        "name": "Guaraniaçu",
                        "latitude": "-25.10083000",
                        "longitude": "-52.87806000"
                    },
                    {
                        "id": 12052,
                        "name": "Guarapuava",
                        "latitude": "-25.39048000",
                        "longitude": "-51.46541000"
                    },
                    {
                        "id": 12053,
                        "name": "Guaraqueçaba",
                        "latitude": "-25.15156000",
                        "longitude": "-48.35949000"
                    },
                    {
                        "id": 12059,
                        "name": "Guaratuba",
                        "latitude": "-25.88278000",
                        "longitude": "-48.57472000"
                    },
                    {
                        "id": 12104,
                        "name": "Honório Serpa",
                        "latitude": "-26.13779000",
                        "longitude": "-52.39614000"
                    },
                    {
                        "id": 12120,
                        "name": "Ibaiti",
                        "latitude": "-23.84861000",
                        "longitude": "-50.18778000"
                    },
                    {
                        "id": 12126,
                        "name": "Ibema",
                        "latitude": "-25.16493000",
                        "longitude": "-53.01268000"
                    },
                    {
                        "id": 12142,
                        "name": "Ibiporã",
                        "latitude": "-23.26917000",
                        "longitude": "-51.04806000"
                    },
                    {
                        "id": 12169,
                        "name": "Icaraíma",
                        "latitude": "-23.37235000",
                        "longitude": "-53.59492000"
                    },
                    {
                        "id": 12198,
                        "name": "Iguaraçu",
                        "latitude": "-23.23375000",
                        "longitude": "-51.85341000"
                    },
                    {
                        "id": 12202,
                        "name": "Iguatu",
                        "latitude": "-24.68784000",
                        "longitude": "-53.08691000"
                    },
                    {
                        "id": 12219,
                        "name": "Imbaú",
                        "latitude": "-24.44336000",
                        "longitude": "-50.73882000"
                    },
                    {
                        "id": 12221,
                        "name": "Imbituva",
                        "latitude": "-25.23000000",
                        "longitude": "-50.60444000"
                    },
                    {
                        "id": 12256,
                        "name": "Inácio Martins",
                        "latitude": "-25.64000000",
                        "longitude": "-51.22000000"
                    },
                    {
                        "id": 12229,
                        "name": "Inajá",
                        "latitude": "-22.71509000",
                        "longitude": "-52.24126000"
                    },
                    {
                        "id": 12238,
                        "name": "Indianópolis",
                        "latitude": "-23.47975000",
                        "longitude": "-52.64153000"
                    },
                    {
                        "id": 12275,
                        "name": "Ipiranga",
                        "latitude": "-25.01590000",
                        "longitude": "-50.55475000"
                    },
                    {
                        "id": 12286,
                        "name": "Iporã",
                        "latitude": "-24.04512000",
                        "longitude": "-53.71983000"
                    },
                    {
                        "id": 12301,
                        "name": "Iracema do Oeste",
                        "latitude": "-24.43665000",
                        "longitude": "-53.33842000"
                    },
                    {
                        "id": 12312,
                        "name": "Irati",
                        "latitude": "-25.46722000",
                        "longitude": "-50.65111000"
                    },
                    {
                        "id": 12318,
                        "name": "Iretama",
                        "latitude": "-24.34412000",
                        "longitude": "-52.10655000"
                    },
                    {
                        "id": 12350,
                        "name": "Itaguajé",
                        "latitude": "-22.66099000",
                        "longitude": "-51.98288000"
                    },
                    {
                        "id": 12360,
                        "name": "Itaipulândia",
                        "latitude": "-25.16335000",
                        "longitude": "-54.34354000"
                    },
                    {
                        "id": 12382,
                        "name": "Itambaracá",
                        "latitude": "-22.98385000",
                        "longitude": "-50.42715000"
                    },
                    {
                        "id": 12384,
                        "name": "Itambé",
                        "latitude": "-23.68805000",
                        "longitude": "-52.01227000"
                    },
                    {
                        "id": 12407,
                        "name": "Itapejara d'Oeste",
                        "latitude": "-25.97797000",
                        "longitude": "-52.82583000"
                    },
                    {
                        "id": 12411,
                        "name": "Itaperuçu",
                        "latitude": "-25.22000000",
                        "longitude": "-49.34778000"
                    },
                    {
                        "id": 12472,
                        "name": "Itaúna do Sul",
                        "latitude": "-22.73684000",
                        "longitude": "-52.89236000"
                    },
                    {
                        "id": 12501,
                        "name": "Ivaí",
                        "latitude": "-24.99384000",
                        "longitude": "-50.86192000"
                    },
                    {
                        "id": 12498,
                        "name": "Ivaiporã",
                        "latitude": "-24.28230000",
                        "longitude": "-51.63284000"
                    },
                    {
                        "id": 12500,
                        "name": "Ivaté",
                        "latitude": "-23.33716000",
                        "longitude": "-53.42407000"
                    },
                    {
                        "id": 12499,
                        "name": "Ivatuba",
                        "latitude": "-23.59716000",
                        "longitude": "-52.19434000"
                    },
                    {
                        "id": 12513,
                        "name": "Jaboti",
                        "latitude": "-23.69532000",
                        "longitude": "-50.07376000"
                    },
                    {
                        "id": 12520,
                        "name": "Jacarezinho",
                        "latitude": "-23.19072000",
                        "longitude": "-49.95410000"
                    },
                    {
                        "id": 12536,
                        "name": "Jaguapitã",
                        "latitude": "-23.07631000",
                        "longitude": "-51.58296000"
                    },
                    {
                        "id": 12542,
                        "name": "Jaguariaíva",
                        "latitude": "-24.24423000",
                        "longitude": "-49.70932000"
                    },
                    {
                        "id": 12557,
                        "name": "Jandaia do Sul",
                        "latitude": "-23.60306000",
                        "longitude": "-51.64333000"
                    },
                    {
                        "id": 12563,
                        "name": "Janiópolis",
                        "latitude": "-24.08843000",
                        "longitude": "-52.80294000"
                    },
                    {
                        "id": 12571,
                        "name": "Japira",
                        "latitude": "-23.69047000",
                        "longitude": "-50.18011000"
                    },
                    {
                        "id": 12576,
                        "name": "Japurá",
                        "latitude": "-23.41860000",
                        "longitude": "-52.56220000"
                    },
                    {
                        "id": 12585,
                        "name": "Jardim Alegre",
                        "latitude": "-24.21451000",
                        "longitude": "-51.72270000"
                    },
                    {
                        "id": 12586,
                        "name": "Jardim Olinda",
                        "latitude": "-22.56938000",
                        "longitude": "-52.06520000"
                    },
                    {
                        "id": 12597,
                        "name": "Jataizinho",
                        "latitude": "-23.25417000",
                        "longitude": "-50.98000000"
                    },
                    {
                        "id": 12626,
                        "name": "Jesuítas",
                        "latitude": "-24.41301000",
                        "longitude": "-53.41344000"
                    },
                    {
                        "id": 12640,
                        "name": "Joaquim Távora",
                        "latitude": "-23.42218000",
                        "longitude": "-49.90251000"
                    },
                    {
                        "id": 12685,
                        "name": "Jundiaí do Sul",
                        "latitude": "-23.47919000",
                        "longitude": "-50.18065000"
                    },
                    {
                        "id": 12695,
                        "name": "Juranda",
                        "latitude": "-24.41323000",
                        "longitude": "-52.82730000"
                    },
                    {
                        "id": 12706,
                        "name": "Jussara",
                        "latitude": "-23.62121000",
                        "longitude": "-52.47084000"
                    },
                    {
                        "id": 12720,
                        "name": "Kaloré",
                        "latitude": "-23.86713000",
                        "longitude": "-51.68029000"
                    },
                    {
                        "id": 12792,
                        "name": "Lapa",
                        "latitude": "-25.76972000",
                        "longitude": "-49.71583000"
                    },
                    {
                        "id": 12796,
                        "name": "Laranjal",
                        "latitude": "-24.92573000",
                        "longitude": "-52.45952000"
                    },
                    {
                        "id": 12800,
                        "name": "Laranjeiras do Sul",
                        "latitude": "-25.40778000",
                        "longitude": "-52.41611000"
                    },
                    {
                        "id": 12822,
                        "name": "Leópolis",
                        "latitude": "-23.02502000",
                        "longitude": "-50.72558000"
                    },
                    {
                        "id": 12826,
                        "name": "Lidianópolis",
                        "latitude": "-24.08135000",
                        "longitude": "-51.64406000"
                    },
                    {
                        "id": 12835,
                        "name": "Lindoeste",
                        "latitude": "-25.26796000",
                        "longitude": "-53.56870000"
                    },
                    {
                        "id": 12846,
                        "name": "Loanda",
                        "latitude": "-22.92306000",
                        "longitude": "-53.13722000"
                    },
                    {
                        "id": 12847,
                        "name": "Lobato",
                        "latitude": "-22.96387000",
                        "longitude": "-52.00714000"
                    },
                    {
                        "id": 12849,
                        "name": "Londrina",
                        "latitude": "-23.31028000",
                        "longitude": "-51.16278000"
                    },
                    {
                        "id": 12866,
                        "name": "Luiziana",
                        "latitude": "-24.34081000",
                        "longitude": "-52.27043000"
                    },
                    {
                        "id": 12869,
                        "name": "Lunardelli",
                        "latitude": "-24.07214000",
                        "longitude": "-51.76003000"
                    },
                    {
                        "id": 12870,
                        "name": "Lupionópolis",
                        "latitude": "-22.73847000",
                        "longitude": "-51.68386000"
                    },
                    {
                        "id": 12929,
                        "name": "Mallet",
                        "latitude": "-25.90209000",
                        "longitude": "-50.83050000"
                    },
                    {
                        "id": 12933,
                        "name": "Mamborê",
                        "latitude": "-24.40607000",
                        "longitude": "-52.61692000"
                    },
                    {
                        "id": 12942,
                        "name": "Mandaguaçu",
                        "latitude": "-23.34722000",
                        "longitude": "-52.09528000"
                    },
                    {
                        "id": 12941,
                        "name": "Mandaguari",
                        "latitude": "-23.54750000",
                        "longitude": "-51.67083000"
                    },
                    {
                        "id": 12943,
                        "name": "Mandirituba",
                        "latitude": "-25.84677000",
                        "longitude": "-49.32704000"
                    },
                    {
                        "id": 12945,
                        "name": "Manfrinópolis",
                        "latitude": "-26.10011000",
                        "longitude": "-53.35828000"
                    },
                    {
                        "id": 12948,
                        "name": "Mangueirinha",
                        "latitude": "-26.03649000",
                        "longitude": "-52.22257000"
                    },
                    {
                        "id": 12953,
                        "name": "Manoel Ribas",
                        "latitude": "-24.52402000",
                        "longitude": "-51.63111000"
                    },
                    {
                        "id": 12998,
                        "name": "Marechal Cândido Rondon",
                        "latitude": "-24.55611000",
                        "longitude": "-54.05667000"
                    },
                    {
                        "id": 13004,
                        "name": "Maria Helena",
                        "latitude": "-23.55348000",
                        "longitude": "-53.23153000"
                    },
                    {
                        "id": 13006,
                        "name": "Marialva",
                        "latitude": "-23.48500000",
                        "longitude": "-51.79167000"
                    },
                    {
                        "id": 13017,
                        "name": "Marilândia do Sul",
                        "latitude": "-23.74380000",
                        "longitude": "-51.29410000"
                    },
                    {
                        "id": 13014,
                        "name": "Marilena",
                        "latitude": "-22.72742000",
                        "longitude": "-53.08170000"
                    },
                    {
                        "id": 13015,
                        "name": "Mariluz",
                        "latitude": "-24.06183000",
                        "longitude": "-53.22984000"
                    },
                    {
                        "id": 13018,
                        "name": "Maringá",
                        "latitude": "-23.42528000",
                        "longitude": "-51.93861000"
                    },
                    {
                        "id": 13025,
                        "name": "Mariópolis",
                        "latitude": "-26.31630000",
                        "longitude": "-52.57421000"
                    },
                    {
                        "id": 13020,
                        "name": "Maripá",
                        "latitude": "-24.46267000",
                        "longitude": "-53.80179000"
                    },
                    {
                        "id": 13027,
                        "name": "Marmeleiro",
                        "latitude": "-26.23791000",
                        "longitude": "-53.09751000"
                    },
                    {
                        "id": 13030,
                        "name": "Marquinho",
                        "latitude": "-25.10570000",
                        "longitude": "-52.25677000"
                    },
                    {
                        "id": 13037,
                        "name": "Marumbi",
                        "latitude": "-23.76658000",
                        "longitude": "-51.66062000"
                    },
                    {
                        "id": 13052,
                        "name": "Matelândia",
                        "latitude": "-25.24083000",
                        "longitude": "-53.99639000"
                    },
                    {
                        "id": 13062,
                        "name": "Matinhos",
                        "latitude": "-25.76114000",
                        "longitude": "-48.57290000"
                    },
                    {
                        "id": 13068,
                        "name": "Mato Rico",
                        "latitude": "-24.70689000",
                        "longitude": "-52.24085000"
                    },
                    {
                        "id": 13084,
                        "name": "Mauá da Serra",
                        "latitude": "-23.91107000",
                        "longitude": "-51.18026000"
                    },
                    {
                        "id": 13092,
                        "name": "Medianeira",
                        "latitude": "-25.29528000",
                        "longitude": "-54.09389000"
                    },
                    {
                        "id": 13100,
                        "name": "Mercedes",
                        "latitude": "-24.42600000",
                        "longitude": "-54.17683000"
                    },
                    {
                        "id": 13135,
                        "name": "Mirador",
                        "latitude": "-23.21282000",
                        "longitude": "-52.75351000"
                    },
                    {
                        "id": 13148,
                        "name": "Miraselva",
                        "latitude": "-22.97660000",
                        "longitude": "-51.47042000"
                    },
                    {
                        "id": 13157,
                        "name": "Missal",
                        "latitude": "-25.11125000",
                        "longitude": "-54.25786000"
                    },
                    {
                        "id": 13231,
                        "name": "Moreira Sales",
                        "latitude": "-24.06222000",
                        "longitude": "-53.00694000"
                    },
                    {
                        "id": 13235,
                        "name": "Morretes",
                        "latitude": "-25.53075000",
                        "longitude": "-48.87427000"
                    },
                    {
                        "id": 13273,
                        "name": "Munhoz de Melo",
                        "latitude": "-23.11288000",
                        "longitude": "-51.73192000"
                    },
                    {
                        "id": 13339,
                        "name": "Nossa Senhora das Graças",
                        "latitude": "-22.93036000",
                        "longitude": "-51.80240000"
                    },
                    {
                        "id": 13346,
                        "name": "Nova Aliança do Ivaí",
                        "latitude": "-23.18670000",
                        "longitude": "-52.62571000"
                    },
                    {
                        "id": 13350,
                        "name": "Nova América da Colina",
                        "latitude": "-23.33377000",
                        "longitude": "-50.69624000"
                    },
                    {
                        "id": 13353,
                        "name": "Nova Aurora",
                        "latitude": "-22.86667000",
                        "longitude": "-52.56667000"
                    },
                    {
                        "id": 13367,
                        "name": "Nova Cantu",
                        "latitude": "-24.65652000",
                        "longitude": "-52.56315000"
                    },
                    {
                        "id": 13374,
                        "name": "Nova Esperança",
                        "latitude": "-23.18311000",
                        "longitude": "-52.25446000"
                    },
                    {
                        "id": 13376,
                        "name": "Nova Esperança do Sudoeste",
                        "latitude": "-25.88851000",
                        "longitude": "-53.26030000"
                    },
                    {
                        "id": 13382,
                        "name": "Nova Fátima",
                        "latitude": "-23.39579000",
                        "longitude": "-50.53565000"
                    },
                    {
                        "id": 13397,
                        "name": "Nova Laranjeiras",
                        "latitude": "-25.21942000",
                        "longitude": "-52.57752000"
                    },
                    {
                        "id": 13399,
                        "name": "Nova Londrina",
                        "latitude": "-22.76583000",
                        "longitude": "-52.98500000"
                    },
                    {
                        "id": 13415,
                        "name": "Nova Olímpia",
                        "latitude": "-23.43206000",
                        "longitude": "-53.03895000"
                    },
                    {
                        "id": 13422,
                        "name": "Nova Prata do Iguaçu",
                        "latitude": "-25.60849000",
                        "longitude": "-53.38052000"
                    },
                    {
                        "id": 13431,
                        "name": "Nova Santa Bárbara",
                        "latitude": "-23.60238000",
                        "longitude": "-50.75450000"
                    },
                    {
                        "id": 13435,
                        "name": "Nova Santa Rosa",
                        "latitude": "-24.44687000",
                        "longitude": "-53.99553000"
                    },
                    {
                        "id": 13438,
                        "name": "Nova Tebas",
                        "latitude": "-24.43082000",
                        "longitude": "-51.94584000"
                    },
                    {
                        "id": 13466,
                        "name": "Novo Itacolomi",
                        "latitude": "-23.77560000",
                        "longitude": "-51.53874000"
                    },
                    {
                        "id": 13525,
                        "name": "Ortigueira",
                        "latitude": "-24.20833000",
                        "longitude": "-50.94944000"
                    },
                    {
                        "id": 13535,
                        "name": "Ourizona",
                        "latitude": "-23.48358000",
                        "longitude": "-52.24274000"
                    },
                    {
                        "id": 13549,
                        "name": "Ouro Verde do Oeste",
                        "latitude": "-24.79690000",
                        "longitude": "-53.93681000"
                    },
                    {
                        "id": 13573,
                        "name": "Paiçandu",
                        "latitude": "-23.45750000",
                        "longitude": "-52.04861000"
                    },
                    {
                        "id": 13586,
                        "name": "Palmas",
                        "latitude": "-26.48417000",
                        "longitude": "-51.99056000"
                    },
                    {
                        "id": 13589,
                        "name": "Palmeira",
                        "latitude": "-25.42944000",
                        "longitude": "-50.00639000"
                    },
                    {
                        "id": 13606,
                        "name": "Palmital",
                        "latitude": "-24.84260000",
                        "longitude": "-52.25370000"
                    },
                    {
                        "id": 13611,
                        "name": "Palotina",
                        "latitude": "-24.28389000",
                        "longitude": "-53.84000000"
                    },
                    {
                        "id": 13662,
                        "name": "Paraíso do Norte",
                        "latitude": "-23.25410000",
                        "longitude": "-52.63634000"
                    },
                    {
                        "id": 13636,
                        "name": "Paranacity",
                        "latitude": "-22.84648000",
                        "longitude": "-52.13457000"
                    },
                    {
                        "id": 13637,
                        "name": "Paranaguá",
                        "latitude": "-25.51626000",
                        "longitude": "-48.52537000"
                    },
                    {
                        "id": 13640,
                        "name": "Paranapoema",
                        "latitude": "-22.65624000",
                        "longitude": "-52.07598000"
                    },
                    {
                        "id": 13644,
                        "name": "Paranavaí",
                        "latitude": "-23.07306000",
                        "longitude": "-52.46528000"
                    },
                    {
                        "id": 13704,
                        "name": "Pato Bragado",
                        "latitude": "-24.64323000",
                        "longitude": "-54.22745000"
                    },
                    {
                        "id": 13705,
                        "name": "Pato Branco",
                        "latitude": "-26.22861000",
                        "longitude": "-52.67056000"
                    },
                    {
                        "id": 13722,
                        "name": "Paula Freitas",
                        "latitude": "-26.17808000",
                        "longitude": "-50.84807000"
                    },
                    {
                        "id": 13733,
                        "name": "Paulo Frontin",
                        "latitude": "-26.04279000",
                        "longitude": "-50.74770000"
                    },
                    {
                        "id": 13743,
                        "name": "Peabiru",
                        "latitude": "-23.91278000",
                        "longitude": "-52.34306000"
                    },
                    {
                        "id": 13812,
                        "name": "Perobal",
                        "latitude": "-23.97015000",
                        "longitude": "-53.32376000"
                    },
                    {
                        "id": 14121,
                        "name": "Pérola",
                        "latitude": "-23.84076000",
                        "longitude": "-53.70733000"
                    },
                    {
                        "id": 14122,
                        "name": "Pérola d'Oeste",
                        "latitude": "-25.84683000",
                        "longitude": "-53.75640000"
                    },
                    {
                        "id": 13930,
                        "name": "Piên",
                        "latitude": "-26.08649000",
                        "longitude": "-49.45641000"
                    },
                    {
                        "id": 13858,
                        "name": "Pinhais",
                        "latitude": "-25.44472000",
                        "longitude": "-49.19250000"
                    },
                    {
                        "id": 13862,
                        "name": "Pinhal de São Bento",
                        "latitude": "-26.00683000",
                        "longitude": "-53.48906000"
                    },
                    {
                        "id": 13865,
                        "name": "Pinhalão",
                        "latitude": "-23.92456000",
                        "longitude": "-50.05444000"
                    },
                    {
                        "id": 13873,
                        "name": "Pinhão",
                        "latitude": "-25.69556000",
                        "longitude": "-51.65972000"
                    },
                    {
                        "id": 13912,
                        "name": "Piraí do Sul",
                        "latitude": "-24.52611000",
                        "longitude": "-49.94861000"
                    },
                    {
                        "id": 13904,
                        "name": "Piraquara",
                        "latitude": "-25.44227000",
                        "longitude": "-49.06795000"
                    },
                    {
                        "id": 13921,
                        "name": "Pitanga",
                        "latitude": "-24.75722000",
                        "longitude": "-51.76139000"
                    },
                    {
                        "id": 13922,
                        "name": "Pitangueiras",
                        "latitude": "-23.19194000",
                        "longitude": "-51.56836000"
                    },
                    {
                        "id": 13935,
                        "name": "Planaltina do Paraná",
                        "latitude": "-23.09388000",
                        "longitude": "-52.92823000"
                    },
                    {
                        "id": 13938,
                        "name": "Planalto",
                        "latitude": "-25.72679000",
                        "longitude": "-53.72859000"
                    },
                    {
                        "id": 13957,
                        "name": "Ponta Grossa",
                        "latitude": "-25.09500000",
                        "longitude": "-50.16194000"
                    },
                    {
                        "id": 13962,
                        "name": "Pontal do Paraná",
                        "latitude": "-25.67361000",
                        "longitude": "-48.51111000"
                    },
                    {
                        "id": 13985,
                        "name": "Porecatu",
                        "latitude": "-22.75583000",
                        "longitude": "-51.37917000"
                    },
                    {
                        "id": 13998,
                        "name": "Porto Amazonas",
                        "latitude": "-25.53897000",
                        "longitude": "-49.90183000"
                    },
                    {
                        "id": 13999,
                        "name": "Porto Barreiro",
                        "latitude": "-25.58093000",
                        "longitude": "-52.39206000"
                    },
                    {
                        "id": 14015,
                        "name": "Porto Rico",
                        "latitude": "-22.82902000",
                        "longitude": "-53.31785000"
                    },
                    {
                        "id": 14021,
                        "name": "Porto Vitória",
                        "latitude": "-26.25338000",
                        "longitude": "-51.24188000"
                    },
                    {
                        "id": 14060,
                        "name": "Prado Ferreira",
                        "latitude": "-23.02439000",
                        "longitude": "-51.37909000"
                    },
                    {
                        "id": 14067,
                        "name": "Pranchita",
                        "latitude": "-25.96586000",
                        "longitude": "-53.69675000"
                    },
                    {
                        "id": 14078,
                        "name": "Presidente Castelo Branco",
                        "latitude": "-23.26207000",
                        "longitude": "-52.14511000"
                    },
                    {
                        "id": 14105,
                        "name": "Primeiro de Maio",
                        "latitude": "-22.87095000",
                        "longitude": "-51.08897000"
                    },
                    {
                        "id": 14114,
                        "name": "Prudentópolis",
                        "latitude": "-25.21306000",
                        "longitude": "-50.97778000"
                    },
                    {
                        "id": 14128,
                        "name": "Quarto Centenário",
                        "latitude": "-24.29608000",
                        "longitude": "-53.11994000"
                    },
                    {
                        "id": 14129,
                        "name": "Quatiguá",
                        "latitude": "-23.55499000",
                        "longitude": "-49.91985000"
                    },
                    {
                        "id": 14132,
                        "name": "Quatro Barras",
                        "latitude": "-25.36556000",
                        "longitude": "-49.07694000"
                    },
                    {
                        "id": 14134,
                        "name": "Quatro Pontes",
                        "latitude": "-24.50435000",
                        "longitude": "-54.00566000"
                    },
                    {
                        "id": 14137,
                        "name": "Quedas do Iguaçu",
                        "latitude": "-25.43169000",
                        "longitude": "-52.98265000"
                    },
                    {
                        "id": 14146,
                        "name": "Querência do Norte",
                        "latitude": "-23.10147000",
                        "longitude": "-53.56278000"
                    },
                    {
                        "id": 14150,
                        "name": "Quinta do Sol",
                        "latitude": "-23.79814000",
                        "longitude": "-52.15746000"
                    },
                    {
                        "id": 14156,
                        "name": "Quitandinha",
                        "latitude": "-25.90132000",
                        "longitude": "-49.50522000"
                    },
                    {
                        "id": 14169,
                        "name": "Ramilândia",
                        "latitude": "-25.09153000",
                        "longitude": "-54.00622000"
                    },
                    {
                        "id": 14171,
                        "name": "Rancho Alegre",
                        "latitude": "-23.05892000",
                        "longitude": "-50.91888000"
                    },
                    {
                        "id": 14172,
                        "name": "Rancho Alegre d'Oeste",
                        "latitude": "-24.30404000",
                        "longitude": "-52.98349000"
                    },
                    {
                        "id": 14177,
                        "name": "Realeza",
                        "latitude": "-25.67431000",
                        "longitude": "-53.54659000"
                    },
                    {
                        "id": 14178,
                        "name": "Rebouças",
                        "latitude": "-25.68296000",
                        "longitude": "-50.63115000"
                    },
                    {
                        "id": 14195,
                        "name": "Renascença",
                        "latitude": "-26.21457000",
                        "longitude": "-52.93431000"
                    },
                    {
                        "id": 14199,
                        "name": "Reserva",
                        "latitude": "-24.57312000",
                        "longitude": "-50.93141000"
                    },
                    {
                        "id": 14201,
                        "name": "Reserva do Iguaçu",
                        "latitude": "-25.84778000",
                        "longitude": "-51.94646000"
                    },
                    {
                        "id": 14240,
                        "name": "Ribeirão Claro",
                        "latitude": "-23.29564000",
                        "longitude": "-49.78622000"
                    },
                    {
                        "id": 14249,
                        "name": "Ribeirão do Pinhal",
                        "latitude": "-23.38629000",
                        "longitude": "-50.43197000"
                    },
                    {
                        "id": 14258,
                        "name": "Rio Azul",
                        "latitude": "-25.74072000",
                        "longitude": "-50.73497000"
                    },
                    {
                        "id": 14260,
                        "name": "Rio Bom",
                        "latitude": "-23.80220000",
                        "longitude": "-51.44616000"
                    },
                    {
                        "id": 14262,
                        "name": "Rio Bonito do Iguaçu",
                        "latitude": "-25.54822000",
                        "longitude": "-52.62154000"
                    },
                    {
                        "id": 14265,
                        "name": "Rio Branco do Ivaí",
                        "latitude": "-24.35602000",
                        "longitude": "-51.34215000"
                    },
                    {
                        "id": 14266,
                        "name": "Rio Branco do Sul",
                        "latitude": "-25.19000000",
                        "longitude": "-49.31417000"
                    },
                    {
                        "id": 14283,
                        "name": "Rio Negro",
                        "latitude": "-26.09001000",
                        "longitude": "-49.71582000"
                    },
                    {
                        "id": 14337,
                        "name": "Rolândia",
                        "latitude": "-23.30972000",
                        "longitude": "-51.36917000"
                    },
                    {
                        "id": 14340,
                        "name": "Roncador",
                        "latitude": "-24.56358000",
                        "longitude": "-52.22448000"
                    },
                    {
                        "id": 14344,
                        "name": "Rondon",
                        "latitude": "-23.47457000",
                        "longitude": "-52.84502000"
                    },
                    {
                        "id": 14354,
                        "name": "Rosário do Ivaí",
                        "latitude": "-24.30569000",
                        "longitude": "-51.22024000"
                    },
                    {
                        "id": 14370,
                        "name": "Sabáudia",
                        "latitude": "-23.36584000",
                        "longitude": "-51.60539000"
                    },
                    {
                        "id": 14384,
                        "name": "Salgado Filho",
                        "latitude": "-26.12101000",
                        "longitude": "-53.43938000"
                    },
                    {
                        "id": 14401,
                        "name": "Salto do Itararé",
                        "latitude": "-23.61939000",
                        "longitude": "-49.68219000"
                    },
                    {
                        "id": 14403,
                        "name": "Salto do Lontra",
                        "latitude": "-25.77035000",
                        "longitude": "-53.29978000"
                    },
                    {
                        "id": 14419,
                        "name": "Santa Amélia",
                        "latitude": "-23.26039000",
                        "longitude": "-50.41329000"
                    },
                    {
                        "id": 14434,
                        "name": "Santa Cecília do Pavão",
                        "latitude": "-23.54436000",
                        "longitude": "-50.82283000"
                    },
                    {
                        "id": 14449,
                        "name": "Santa Cruz de Monte Castelo",
                        "latitude": "-23.14407000",
                        "longitude": "-53.36640000"
                    },
                    {
                        "id": 14464,
                        "name": "Santa Fé",
                        "latitude": "-23.03990000",
                        "longitude": "-51.81359000"
                    },
                    {
                        "id": 14472,
                        "name": "Santa Helena",
                        "latitude": "-24.90689000",
                        "longitude": "-54.28722000"
                    },
                    {
                        "id": 14479,
                        "name": "Santa Inês",
                        "latitude": "-22.68740000",
                        "longitude": "-51.89746000"
                    },
                    {
                        "id": 14482,
                        "name": "Santa Isabel do Ivaí",
                        "latitude": "-23.13820000",
                        "longitude": "-53.25909000"
                    },
                    {
                        "id": 14484,
                        "name": "Santa Izabel do Oeste",
                        "latitude": "-25.77567000",
                        "longitude": "-53.41047000"
                    },
                    {
                        "id": 14499,
                        "name": "Santa Lúcia",
                        "latitude": "-25.41465000",
                        "longitude": "-53.55213000"
                    },
                    {
                        "id": 14513,
                        "name": "Santa Maria do Oeste",
                        "latitude": "-24.92004000",
                        "longitude": "-51.96628000"
                    },
                    {
                        "id": 14518,
                        "name": "Santa Mariana",
                        "latitude": "-23.04831000",
                        "longitude": "-50.52939000"
                    },
                    {
                        "id": 14521,
                        "name": "Santa Mônica",
                        "latitude": "-23.16554000",
                        "longitude": "-53.11244000"
                    },
                    {
                        "id": 14555,
                        "name": "Santa Tereza do Oeste",
                        "latitude": "-25.04438000",
                        "longitude": "-53.61939000"
                    },
                    {
                        "id": 14562,
                        "name": "Santa Terezinha de Itaipu",
                        "latitude": "-25.41349000",
                        "longitude": "-54.42251000"
                    },
                    {
                        "id": 14583,
                        "name": "Santana do Itararé",
                        "latitude": "-23.73441000",
                        "longitude": "-49.61942000"
                    },
                    {
                        "id": 14614,
                        "name": "Santo Antônio da Platina",
                        "latitude": "-23.29500000",
                        "longitude": "-50.07722000"
                    },
                    {
                        "id": 14624,
                        "name": "Santo Antônio do Caiuá",
                        "latitude": "-22.69373000",
                        "longitude": "-52.30897000"
                    },
                    {
                        "id": 14635,
                        "name": "Santo Antônio do Paraíso",
                        "latitude": "-23.56361000",
                        "longitude": "-50.61940000"
                    },
                    {
                        "id": 14640,
                        "name": "Santo Antônio do Sudoeste",
                        "latitude": "-26.07361000",
                        "longitude": "-53.72528000"
                    },
                    {
                        "id": 14650,
                        "name": "Santo Inácio",
                        "latitude": "-22.72365000",
                        "longitude": "-51.80606000"
                    },
                    {
                        "id": 14857,
                        "name": "São Carlos do Ivaí",
                        "latitude": "-23.35478000",
                        "longitude": "-52.52074000"
                    },
                    {
                        "id": 14929,
                        "name": "São Jerônimo da Serra",
                        "latitude": "-23.68708000",
                        "longitude": "-50.78987000"
                    },
                    {
                        "id": 14998,
                        "name": "São João",
                        "latitude": "-25.78385000",
                        "longitude": "-52.80418000"
                    },
                    {
                        "id": 15026,
                        "name": "São João do Caiuá",
                        "latitude": "-22.82937000",
                        "longitude": "-52.28543000"
                    },
                    {
                        "id": 15030,
                        "name": "São João do Ivaí",
                        "latitude": "-23.97916000",
                        "longitude": "-51.88263000"
                    },
                    {
                        "id": 15047,
                        "name": "São João do Triunfo",
                        "latitude": "-25.70410000",
                        "longitude": "-50.26243000"
                    },
                    {
                        "id": 14935,
                        "name": "São Jorge d'Oeste",
                        "latitude": "-25.66317000",
                        "longitude": "-52.94857000"
                    },
                    {
                        "id": 14936,
                        "name": "São Jorge do Ivaí",
                        "latitude": "-23.43841000",
                        "longitude": "-52.30359000"
                    },
                    {
                        "id": 14937,
                        "name": "São Jorge do Patrocínio",
                        "latitude": "-23.74952000",
                        "longitude": "-53.88553000"
                    },
                    {
                        "id": 14941,
                        "name": "São José da Boa Vista",
                        "latitude": "-23.96483000",
                        "longitude": "-49.65190000"
                    },
                    {
                        "id": 14951,
                        "name": "São José das Palmeiras",
                        "latitude": "-24.83457000",
                        "longitude": "-54.12721000"
                    },
                    {
                        "id": 14995,
                        "name": "São José dos Pinhais",
                        "latitude": "-25.53020000",
                        "longitude": "-49.20836000"
                    },
                    {
                        "id": 15069,
                        "name": "São Manoel do Paraná",
                        "latitude": "-23.38356000",
                        "longitude": "-52.58889000"
                    },
                    {
                        "id": 15077,
                        "name": "São Mateus do Sul",
                        "latitude": "-25.87417000",
                        "longitude": "-50.38278000"
                    },
                    {
                        "id": 15092,
                        "name": "São Miguel do Iguaçu",
                        "latitude": "-25.34806000",
                        "longitude": "-54.23778000"
                    },
                    {
                        "id": 15116,
                        "name": "São Pedro do Iguaçu",
                        "latitude": "-24.90931000",
                        "longitude": "-53.88765000"
                    },
                    {
                        "id": 15117,
                        "name": "São Pedro do Ivaí",
                        "latitude": "-23.83342000",
                        "longitude": "-51.86952000"
                    },
                    {
                        "id": 15118,
                        "name": "São Pedro do Paraná",
                        "latitude": "-22.76847000",
                        "longitude": "-53.16580000"
                    },
                    {
                        "id": 15137,
                        "name": "São Sebastião da Amoreira",
                        "latitude": "-23.45392000",
                        "longitude": "-50.71309000"
                    },
                    {
                        "id": 15162,
                        "name": "São Tomé",
                        "latitude": "-23.52364000",
                        "longitude": "-52.51400000"
                    },
                    {
                        "id": 14659,
                        "name": "Sapopema",
                        "latitude": "-23.87746000",
                        "longitude": "-50.61022000"
                    },
                    {
                        "id": 14668,
                        "name": "Sarandi",
                        "latitude": "-23.44361000",
                        "longitude": "-51.87389000"
                    },
                    {
                        "id": 14676,
                        "name": "Saudade do Iguaçu",
                        "latitude": "-25.70473000",
                        "longitude": "-52.60816000"
                    },
                    {
                        "id": 14709,
                        "name": "Sengés",
                        "latitude": "-24.11335000",
                        "longitude": "-49.46315000"
                    },
                    {
                        "id": 14749,
                        "name": "Serranópolis do Iguaçu",
                        "latitude": "-25.47001000",
                        "longitude": "-54.01644000"
                    },
                    {
                        "id": 14757,
                        "name": "Sertaneja",
                        "latitude": "-22.95832000",
                        "longitude": "-50.88804000"
                    },
                    {
                        "id": 14758,
                        "name": "Sertanópolis",
                        "latitude": "-23.05861000",
                        "longitude": "-51.03639000"
                    },
                    {
                        "id": 14792,
                        "name": "Siqueira Campos",
                        "latitude": "-23.68889000",
                        "longitude": "-49.83389000"
                    },
                    {
                        "id": 14822,
                        "name": "Sulina",
                        "latitude": "-25.67144000",
                        "longitude": "-52.68373000"
                    },
                    {
                        "id": 15209,
                        "name": "Tamarana",
                        "latitude": "-23.82556000",
                        "longitude": "-51.04683000"
                    },
                    {
                        "id": 15211,
                        "name": "Tamboara",
                        "latitude": "-23.19886000",
                        "longitude": "-52.46715000"
                    },
                    {
                        "id": 15226,
                        "name": "Tapejara",
                        "latitude": "-23.62534000",
                        "longitude": "-52.91113000"
                    },
                    {
                        "id": 15234,
                        "name": "Tapira",
                        "latitude": "-23.30639000",
                        "longitude": "-53.13632000"
                    },
                    {
                        "id": 15266,
                        "name": "Teixeira Soares",
                        "latitude": "-25.27813000",
                        "longitude": "-50.43158000"
                    },
                    {
                        "id": 15273,
                        "name": "Telêmaco Borba",
                        "latitude": "-24.22442000",
                        "longitude": "-50.54151000"
                    },
                    {
                        "id": 15290,
                        "name": "Terra Boa",
                        "latitude": "-23.67940000",
                        "longitude": "-52.34426000"
                    },
                    {
                        "id": 15294,
                        "name": "Terra Rica",
                        "latitude": "-22.73272000",
                        "longitude": "-52.68457000"
                    },
                    {
                        "id": 15295,
                        "name": "Terra Roxa",
                        "latitude": "-24.22292000",
                        "longitude": "-54.09087000"
                    },
                    {
                        "id": 15304,
                        "name": "Tibagi",
                        "latitude": "-24.65805000",
                        "longitude": "-50.51861000"
                    },
                    {
                        "id": 15310,
                        "name": "Tijucas do Sul",
                        "latitude": "-25.89852000",
                        "longitude": "-49.11779000"
                    },
                    {
                        "id": 15329,
                        "name": "Toledo",
                        "latitude": "-24.71361000",
                        "longitude": "-53.74306000"
                    },
                    {
                        "id": 15332,
                        "name": "Tomazina",
                        "latitude": "-23.77655000",
                        "longitude": "-49.95552000"
                    },
                    {
                        "id": 15371,
                        "name": "Três Barras do Paraná",
                        "latitude": "-25.42222000",
                        "longitude": "-53.23148000"
                    },
                    {
                        "id": 15394,
                        "name": "Tunas do Paraná",
                        "latitude": "-24.96753000",
                        "longitude": "-48.86604000"
                    },
                    {
                        "id": 15395,
                        "name": "Tuneiras do Oeste",
                        "latitude": "-23.90168000",
                        "longitude": "-52.83572000"
                    },
                    {
                        "id": 15409,
                        "name": "Tupãssi",
                        "latitude": "-24.63318000",
                        "longitude": "-53.49207000"
                    },
                    {
                        "id": 15418,
                        "name": "Turvo",
                        "latitude": "-24.97002000",
                        "longitude": "-51.50860000"
                    },
                    {
                        "id": 15436,
                        "name": "Ubiratã",
                        "latitude": "-24.50395000",
                        "longitude": "-53.01934000"
                    },
                    {
                        "id": 15451,
                        "name": "Umuarama",
                        "latitude": "-23.76639000",
                        "longitude": "-53.32500000"
                    },
                    {
                        "id": 15459,
                        "name": "União da Vitória",
                        "latitude": "-26.09211000",
                        "longitude": "-51.11212000"
                    },
                    {
                        "id": 15454,
                        "name": "Uniflor",
                        "latitude": "-23.06016000",
                        "longitude": "-52.09077000"
                    },
                    {
                        "id": 15466,
                        "name": "Uraí",
                        "latitude": "-23.19291000",
                        "longitude": "-50.79419000"
                    },
                    {
                        "id": 15528,
                        "name": "Ventania",
                        "latitude": "-24.14204000",
                        "longitude": "-50.22365000"
                    },
                    {
                        "id": 15536,
                        "name": "Vera Cruz do Oeste",
                        "latitude": "-24.94088000",
                        "longitude": "-53.92809000"
                    },
                    {
                        "id": 15546,
                        "name": "Verê",
                        "latitude": "-25.85329000",
                        "longitude": "-52.95920000"
                    },
                    {
                        "id": 15586,
                        "name": "Virmond",
                        "latitude": "-25.43010000",
                        "longitude": "-52.23673000"
                    },
                    {
                        "id": 15595,
                        "name": "Vitorino",
                        "latitude": "-26.24047000",
                        "longitude": "-52.81976000"
                    },
                    {
                        "id": 15629,
                        "name": "Wenceslau Braz",
                        "latitude": "-23.88811000",
                        "longitude": "-49.79148000"
                    },
                    {
                        "id": 15634,
                        "name": "Xambrê",
                        "latitude": "-23.73853000",
                        "longitude": "-53.60400000"
                    }
                ]
            },
            {
                "id": 2006,
                "name": "Pernambuco",
                "iso2": "PE",
                "latitude": "-8.81371730",
                "longitude": "-36.95410700",
                "type": "state",
                "cities": [
                    {
                        "id": 10066,
                        "name": "Abreu e Lima",
                        "latitude": "-7.86865000",
                        "longitude": "-35.08171000"
                    },
                    {
                        "id": 10085,
                        "name": "Afogados da Ingazeira",
                        "latitude": "-7.72298000",
                        "longitude": "-37.61781000"
                    },
                    {
                        "id": 10089,
                        "name": "Afrânio",
                        "latitude": "-8.62589000",
                        "longitude": "-41.05768000"
                    },
                    {
                        "id": 10091,
                        "name": "Agrestina",
                        "latitude": "-8.45191000",
                        "longitude": "-35.93238000"
                    },
                    {
                        "id": 15663,
                        "name": "Água Preta",
                        "latitude": "-8.70750000",
                        "longitude": "-35.53056000"
                    },
                    {
                        "id": 15665,
                        "name": "Águas Belas",
                        "latitude": "-9.11139000",
                        "longitude": "-37.12306000"
                    },
                    {
                        "id": 10111,
                        "name": "Alagoinha",
                        "latitude": "-8.53497000",
                        "longitude": "-36.75607000"
                    },
                    {
                        "id": 10137,
                        "name": "Aliança",
                        "latitude": "-7.59698000",
                        "longitude": "-35.16536000"
                    },
                    {
                        "id": 10158,
                        "name": "Altinho",
                        "latitude": "-8.45151000",
                        "longitude": "-36.08155000"
                    },
                    {
                        "id": 10206,
                        "name": "Amaraji",
                        "latitude": "-8.37192000",
                        "longitude": "-35.48991000"
                    },
                    {
                        "id": 10250,
                        "name": "Angelim",
                        "latitude": "-8.89154000",
                        "longitude": "-36.27674000"
                    },
                    {
                        "id": 10370,
                        "name": "Araçoiaba",
                        "latitude": "-7.79387000",
                        "longitude": "-35.07645000"
                    },
                    {
                        "id": 10355,
                        "name": "Araripina",
                        "latitude": "-7.57611000",
                        "longitude": "-40.49833000"
                    },
                    {
                        "id": 10379,
                        "name": "Arcoverde",
                        "latitude": "-8.41889000",
                        "longitude": "-37.05389000"
                    },
                    {
                        "id": 10524,
                        "name": "Barra de Guabiraba",
                        "latitude": "-8.39450000",
                        "longitude": "-35.62054000"
                    },
                    {
                        "id": 10556,
                        "name": "Barreiros",
                        "latitude": "-8.81833000",
                        "longitude": "-35.18639000"
                    },
                    {
                        "id": 10617,
                        "name": "Belém de Maria",
                        "latitude": "-8.57849000",
                        "longitude": "-35.82495000"
                    },
                    {
                        "id": 10618,
                        "name": "Belém de São Francisco",
                        "latitude": "-8.75389000",
                        "longitude": "-38.96583000"
                    },
                    {
                        "id": 10621,
                        "name": "Belém do São Francisco",
                        "latitude": "-8.53386000",
                        "longitude": "-38.98166000"
                    },
                    {
                        "id": 10608,
                        "name": "Belo Jardim",
                        "latitude": "-8.33556000",
                        "longitude": "-36.42417000"
                    },
                    {
                        "id": 10643,
                        "name": "Betânia",
                        "latitude": "-8.28789000",
                        "longitude": "-37.97622000"
                    },
                    {
                        "id": 10645,
                        "name": "Bezerros",
                        "latitude": "-8.23333000",
                        "longitude": "-35.79694000"
                    },
                    {
                        "id": 10685,
                        "name": "Bodocó",
                        "latitude": "-7.78881000",
                        "longitude": "-39.95255000"
                    },
                    {
                        "id": 10690,
                        "name": "Bom Conselho",
                        "latitude": "-9.16972000",
                        "longitude": "-36.67972000"
                    },
                    {
                        "id": 10692,
                        "name": "Bom Jardim",
                        "latitude": "-7.79583000",
                        "longitude": "-35.58722000"
                    },
                    {
                        "id": 10736,
                        "name": "Bonito",
                        "latitude": "-8.47028000",
                        "longitude": "-35.72861000"
                    },
                    {
                        "id": 10799,
                        "name": "Brejão",
                        "latitude": "-9.03600000",
                        "longitude": "-36.56056000"
                    },
                    {
                        "id": 10786,
                        "name": "Brejinho",
                        "latitude": "-7.34462000",
                        "longitude": "-37.33463000"
                    },
                    {
                        "id": 10793,
                        "name": "Brejo da Madre de Deus",
                        "latitude": "-8.14583000",
                        "longitude": "-36.37111000"
                    },
                    {
                        "id": 10815,
                        "name": "Buenos Aires",
                        "latitude": "-7.72000000",
                        "longitude": "-35.32000000"
                    },
                    {
                        "id": 10839,
                        "name": "Buíque",
                        "latitude": "-8.62306000",
                        "longitude": "-37.15583000"
                    },
                    {
                        "id": 10852,
                        "name": "Cabo",
                        "latitude": "-8.28333000",
                        "longitude": "-35.03333000"
                    },
                    {
                        "id": 10855,
                        "name": "Cabo de Santo Agostinho",
                        "latitude": "-8.27727000",
                        "longitude": "-35.09090000"
                    },
                    {
                        "id": 10857,
                        "name": "Cabrobó",
                        "latitude": "-8.51417000",
                        "longitude": "-39.31000000"
                    },
                    {
                        "id": 10876,
                        "name": "Cachoeirinha",
                        "latitude": "-8.48639000",
                        "longitude": "-36.23306000"
                    },
                    {
                        "id": 10892,
                        "name": "Caetés",
                        "latitude": "-8.77306000",
                        "longitude": "-36.62250000"
                    },
                    {
                        "id": 10932,
                        "name": "Calçado",
                        "latitude": "-8.73580000",
                        "longitude": "-36.33149000"
                    },
                    {
                        "id": 10931,
                        "name": "Calumbi",
                        "latitude": "-8.01910000",
                        "longitude": "-38.09799000"
                    },
                    {
                        "id": 10941,
                        "name": "Camaragibe",
                        "latitude": "-7.98780000",
                        "longitude": "-34.99136000"
                    },
                    {
                        "id": 10954,
                        "name": "Camocim de São Félix",
                        "latitude": "-8.35861000",
                        "longitude": "-35.76194000"
                    },
                    {
                        "id": 11020,
                        "name": "Camutanga",
                        "latitude": "-7.43515000",
                        "longitude": "-35.30172000"
                    },
                    {
                        "id": 11045,
                        "name": "Canhotinho",
                        "latitude": "-8.88222000",
                        "longitude": "-36.19111000"
                    },
                    {
                        "id": 11092,
                        "name": "Capoeiras",
                        "latitude": "-8.73472000",
                        "longitude": "-36.62667000"
                    },
                    {
                        "id": 11157,
                        "name": "Carnaíba",
                        "latitude": "-8.70000000",
                        "longitude": "-37.66667000"
                    },
                    {
                        "id": 11156,
                        "name": "Carnaubeira da Penha",
                        "latitude": "-8.42648000",
                        "longitude": "-38.76523000"
                    },
                    {
                        "id": 11162,
                        "name": "Carpina",
                        "latitude": "-7.85083000",
                        "longitude": "-35.25472000"
                    },
                    {
                        "id": 11166,
                        "name": "Caruaru",
                        "latitude": "-8.17924000",
                        "longitude": "-36.02794000"
                    },
                    {
                        "id": 11181,
                        "name": "Casinhas",
                        "latitude": "-7.75811000",
                        "longitude": "-35.69922000"
                    },
                    {
                        "id": 11201,
                        "name": "Catende",
                        "latitude": "-8.66667000",
                        "longitude": "-35.71667000"
                    },
                    {
                        "id": 11231,
                        "name": "Cedro",
                        "latitude": "-7.71879000",
                        "longitude": "-39.23334000"
                    },
                    {
                        "id": 11288,
                        "name": "Chã de Alegria",
                        "latitude": "-7.99013000",
                        "longitude": "-35.18974000"
                    },
                    {
                        "id": 11286,
                        "name": "Chã Grande",
                        "latitude": "-8.23833000",
                        "longitude": "-35.46167000"
                    },
                    {
                        "id": 11335,
                        "name": "Colônia Leopoldina",
                        "latitude": "-8.90889000",
                        "longitude": "-35.72500000"
                    },
                    {
                        "id": 11369,
                        "name": "Condado",
                        "latitude": "-7.58583000",
                        "longitude": "-35.10583000"
                    },
                    {
                        "id": 11435,
                        "name": "Correntes",
                        "latitude": "-9.13378000",
                        "longitude": "-36.32033000"
                    },
                    {
                        "id": 11437,
                        "name": "Cortês",
                        "latitude": "-8.44254000",
                        "longitude": "-35.53378000"
                    },
                    {
                        "id": 11513,
                        "name": "Cumaru",
                        "latitude": "-8.00611000",
                        "longitude": "-35.69722000"
                    },
                    {
                        "id": 11520,
                        "name": "Cupira",
                        "latitude": "-8.61667000",
                        "longitude": "-35.95000000"
                    },
                    {
                        "id": 11540,
                        "name": "Custódia",
                        "latitude": "-8.12882000",
                        "longitude": "-37.66208000"
                    },
                    {
                        "id": 11649,
                        "name": "Dormentes",
                        "latitude": "-8.43020000",
                        "longitude": "-40.59717000"
                    },
                    {
                        "id": 11724,
                        "name": "Escada",
                        "latitude": "-8.35917000",
                        "longitude": "-35.22361000"
                    },
                    {
                        "id": 11769,
                        "name": "Exu",
                        "latitude": "-7.51194000",
                        "longitude": "-39.72417000"
                    },
                    {
                        "id": 11790,
                        "name": "Feira Nova",
                        "latitude": "-7.93474000",
                        "longitude": "-35.39248000"
                    },
                    {
                        "id": 11807,
                        "name": "Fernando de Noronha",
                        "latitude": "-3.85071000",
                        "longitude": "-32.41997000"
                    },
                    {
                        "id": 11808,
                        "name": "Fernando de Noronha (Distrito Estadual)",
                        "latitude": "-3.84028000",
                        "longitude": "-32.41083000"
                    },
                    {
                        "id": 11813,
                        "name": "Ferreiros",
                        "latitude": "-7.48644000",
                        "longitude": "-35.19997000"
                    },
                    {
                        "id": 11830,
                        "name": "Flores",
                        "latitude": "-7.86806000",
                        "longitude": "-37.97472000"
                    },
                    {
                        "id": 11834,
                        "name": "Floresta",
                        "latitude": "-8.60111000",
                        "longitude": "-38.56861000"
                    },
                    {
                        "id": 11895,
                        "name": "Frei Miguelinho",
                        "latitude": "-7.94208000",
                        "longitude": "-35.89073000"
                    },
                    {
                        "id": 11915,
                        "name": "Gameleira",
                        "latitude": "-8.58444000",
                        "longitude": "-35.38667000"
                    },
                    {
                        "id": 11919,
                        "name": "Garanhuns",
                        "latitude": "-8.88202000",
                        "longitude": "-36.50216000"
                    },
                    {
                        "id": 11953,
                        "name": "Glória do Goitá",
                        "latitude": "-8.03865000",
                        "longitude": "-35.34006000"
                    },
                    {
                        "id": 11957,
                        "name": "Goiana",
                        "latitude": "-7.56056000",
                        "longitude": "-35.00250000"
                    },
                    {
                        "id": 11997,
                        "name": "Granito",
                        "latitude": "-7.74380000",
                        "longitude": "-39.64021000"
                    },
                    {
                        "id": 12002,
                        "name": "Gravatá",
                        "latitude": "-8.20111000",
                        "longitude": "-35.56472000"
                    },
                    {
                        "id": 12011,
                        "name": "Guabiraba",
                        "latitude": "-8.41667000",
                        "longitude": "-35.66667000"
                    },
                    {
                        "id": 12118,
                        "name": "Iati",
                        "latitude": "-9.19129000",
                        "longitude": "-36.94946000"
                    },
                    {
                        "id": 12139,
                        "name": "Ibimirim",
                        "latitude": "-8.54056000",
                        "longitude": "-37.69028000"
                    },
                    {
                        "id": 12147,
                        "name": "Ibirajuba",
                        "latitude": "-8.61290000",
                        "longitude": "-36.15399000"
                    },
                    {
                        "id": 12188,
                        "name": "Igarassu",
                        "latitude": "-7.83417000",
                        "longitude": "-34.90639000"
                    },
                    {
                        "id": 12197,
                        "name": "Iguaraci",
                        "latitude": "-7.84183000",
                        "longitude": "-37.40822000"
                    },
                    {
                        "id": 12211,
                        "name": "Ilha de Itamaracá",
                        "latitude": "-7.74665000",
                        "longitude": "-34.84728000"
                    },
                    {
                        "id": 12228,
                        "name": "Inajá",
                        "latitude": "-8.78778000",
                        "longitude": "-37.78853000"
                    },
                    {
                        "id": 12243,
                        "name": "Ingazeira",
                        "latitude": "-7.71728000",
                        "longitude": "-37.42461000"
                    },
                    {
                        "id": 12283,
                        "name": "Ipojuca",
                        "latitude": "-8.39889000",
                        "longitude": "-35.06389000"
                    },
                    {
                        "id": 12290,
                        "name": "Ipubi",
                        "latitude": "-7.65194000",
                        "longitude": "-40.14889000"
                    },
                    {
                        "id": 12344,
                        "name": "Itacuruba",
                        "latitude": "-8.76952000",
                        "longitude": "-38.71917000"
                    },
                    {
                        "id": 12467,
                        "name": "Itaíba",
                        "latitude": "-8.94750000",
                        "longitude": "-37.42278000"
                    },
                    {
                        "id": 12375,
                        "name": "Itamaracá",
                        "latitude": "-7.74778000",
                        "longitude": "-34.82556000"
                    },
                    {
                        "id": 12385,
                        "name": "Itambé",
                        "latitude": "-7.44733000",
                        "longitude": "-35.17356000"
                    },
                    {
                        "id": 12412,
                        "name": "Itapetim",
                        "latitude": "-7.39642000",
                        "longitude": "-37.13113000"
                    },
                    {
                        "id": 12426,
                        "name": "Itapissuma",
                        "latitude": "-7.77639000",
                        "longitude": "-34.89222000"
                    },
                    {
                        "id": 12446,
                        "name": "Itaquitinga",
                        "latitude": "-7.66778000",
                        "longitude": "-35.10167000"
                    },
                    {
                        "id": 12508,
                        "name": "Jaboatão",
                        "latitude": "-8.18028000",
                        "longitude": "-35.00139000"
                    },
                    {
                        "id": 12509,
                        "name": "Jaboatão dos Guararapes",
                        "latitude": "-8.14568000",
                        "longitude": "-34.97381000"
                    },
                    {
                        "id": 12577,
                        "name": "Jaqueira",
                        "latitude": "-8.73880000",
                        "longitude": "-35.79850000"
                    },
                    {
                        "id": 12599,
                        "name": "Jataúba",
                        "latitude": "-8.05299000",
                        "longitude": "-36.57103000"
                    },
                    {
                        "id": 12602,
                        "name": "Jatobá",
                        "latitude": "-9.18306000",
                        "longitude": "-38.26889000"
                    },
                    {
                        "id": 12657,
                        "name": "João Alfredo",
                        "latitude": "-7.85583000",
                        "longitude": "-35.58833000"
                    },
                    {
                        "id": 12638,
                        "name": "Joaquim Nabuco",
                        "latitude": "-8.62444000",
                        "longitude": "-35.53333000"
                    },
                    {
                        "id": 12676,
                        "name": "Jucati",
                        "latitude": "-8.75067000",
                        "longitude": "-36.47750000"
                    },
                    {
                        "id": 12690,
                        "name": "Jupi",
                        "latitude": "-8.71547000",
                        "longitude": "-36.39397000"
                    },
                    {
                        "id": 12697,
                        "name": "Jurema",
                        "latitude": "-8.78579000",
                        "longitude": "-36.13364000"
                    },
                    {
                        "id": 12753,
                        "name": "Lagoa de Itaenga",
                        "latitude": "-7.90293000",
                        "longitude": "-35.29323000"
                    },
                    {
                        "id": 12758,
                        "name": "Lagoa do Carro",
                        "latitude": "-7.85419000",
                        "longitude": "-35.33637000"
                    },
                    {
                        "id": 12759,
                        "name": "Lagoa do Itaenga",
                        "latitude": "-7.93611000",
                        "longitude": "-35.29028000"
                    },
                    {
                        "id": 12761,
                        "name": "Lagoa do Ouro",
                        "latitude": "-9.16636000",
                        "longitude": "-36.48221000"
                    },
                    {
                        "id": 12765,
                        "name": "Lagoa dos Gatos",
                        "latitude": "-8.67965000",
                        "longitude": "-35.88979000"
                    },
                    {
                        "id": 12738,
                        "name": "Lagoa Grande",
                        "latitude": "-8.78698000",
                        "longitude": "-40.25356000"
                    },
                    {
                        "id": 12781,
                        "name": "Lajedo",
                        "latitude": "-8.66361000",
                        "longitude": "-36.32000000"
                    },
                    {
                        "id": 12831,
                        "name": "Limoeiro",
                        "latitude": "-7.85092000",
                        "longitude": "-35.44512000"
                    },
                    {
                        "id": 12886,
                        "name": "Macaparana",
                        "latitude": "-7.52866000",
                        "longitude": "-35.44430000"
                    },
                    {
                        "id": 12901,
                        "name": "Machados",
                        "latitude": "-7.71477000",
                        "longitude": "-35.51882000"
                    },
                    {
                        "id": 12938,
                        "name": "Manari",
                        "latitude": "-8.88175000",
                        "longitude": "-37.58760000"
                    },
                    {
                        "id": 12975,
                        "name": "Maraial",
                        "latitude": "-8.78250000",
                        "longitude": "-35.80889000"
                    },
                    {
                        "id": 13140,
                        "name": "Mirandiba",
                        "latitude": "-8.13454000",
                        "longitude": "-38.74089000"
                    },
                    {
                        "id": 13230,
                        "name": "Moreilândia",
                        "latitude": "-7.63092000",
                        "longitude": "-39.52167000"
                    },
                    {
                        "id": 13232,
                        "name": "Moreno",
                        "latitude": "-8.11861000",
                        "longitude": "-35.09222000"
                    },
                    {
                        "id": 13313,
                        "name": "Nazaré da Mata",
                        "latitude": "-7.74167000",
                        "longitude": "-35.22778000"
                    },
                    {
                        "id": 13502,
                        "name": "Olinda",
                        "latitude": "-8.00889000",
                        "longitude": "-34.85528000"
                    },
                    {
                        "id": 13523,
                        "name": "Orobó",
                        "latitude": "-7.74500000",
                        "longitude": "-35.60222000"
                    },
                    {
                        "id": 13524,
                        "name": "Orocó",
                        "latitude": "-8.49405000",
                        "longitude": "-39.57790000"
                    },
                    {
                        "id": 13532,
                        "name": "Ouricuri",
                        "latitude": "-7.88250000",
                        "longitude": "-40.08167000"
                    },
                    {
                        "id": 13583,
                        "name": "Palmares",
                        "latitude": "-8.68333000",
                        "longitude": "-35.59167000"
                    },
                    {
                        "id": 13600,
                        "name": "Palmeirina",
                        "latitude": "-9.02961000",
                        "longitude": "-36.24198000"
                    },
                    {
                        "id": 13615,
                        "name": "Panelas",
                        "latitude": "-8.66651000",
                        "longitude": "-36.04783000"
                    },
                    {
                        "id": 13642,
                        "name": "Paranatama",
                        "latitude": "-8.89811000",
                        "longitude": "-36.68199000"
                    },
                    {
                        "id": 13679,
                        "name": "Parnamirim",
                        "latitude": "-8.09056000",
                        "longitude": "-39.57833000"
                    },
                    {
                        "id": 13695,
                        "name": "Passira",
                        "latitude": "-7.99500000",
                        "longitude": "-35.58056000"
                    },
                    {
                        "id": 13719,
                        "name": "Paudalho",
                        "latitude": "-7.94302000",
                        "longitude": "-35.13559000"
                    },
                    {
                        "id": 13725,
                        "name": "Paulista",
                        "latitude": "-7.94083000",
                        "longitude": "-34.87306000"
                    },
                    {
                        "id": 13745,
                        "name": "Pedra",
                        "latitude": "-8.49694000",
                        "longitude": "-36.94083000"
                    },
                    {
                        "id": 13816,
                        "name": "Pesqueira",
                        "latitude": "-8.35778000",
                        "longitude": "-36.69639000"
                    },
                    {
                        "id": 13819,
                        "name": "Petrolândia",
                        "latitude": "-8.84265000",
                        "longitude": "-38.30348000"
                    },
                    {
                        "id": 13817,
                        "name": "Petrolina",
                        "latitude": "-9.39861000",
                        "longitude": "-40.50083000"
                    },
                    {
                        "id": 14054,
                        "name": "Poção",
                        "latitude": "-8.21385000",
                        "longitude": "-36.72266000"
                    },
                    {
                        "id": 13952,
                        "name": "Pombos",
                        "latitude": "-8.22536000",
                        "longitude": "-35.41692000"
                    },
                    {
                        "id": 14101,
                        "name": "Primavera",
                        "latitude": "-8.33678000",
                        "longitude": "-35.37539000"
                    },
                    {
                        "id": 14153,
                        "name": "Quipapá",
                        "latitude": "-8.82778000",
                        "longitude": "-36.01167000"
                    },
                    {
                        "id": 14159,
                        "name": "Quixaba",
                        "latitude": "-7.72105000",
                        "longitude": "-37.87276000"
                    },
                    {
                        "id": 14179,
                        "name": "Recife",
                        "latitude": "-8.05389000",
                        "longitude": "-34.88111000"
                    },
                    {
                        "id": 14212,
                        "name": "Riacho das Almas",
                        "latitude": "-8.05397000",
                        "longitude": "-35.82633000"
                    },
                    {
                        "id": 14236,
                        "name": "Ribeirão",
                        "latitude": "-8.50755000",
                        "longitude": "-35.39342000"
                    },
                    {
                        "id": 14274,
                        "name": "Rio Formoso",
                        "latitude": "-8.66877000",
                        "longitude": "-35.16277000"
                    },
                    {
                        "id": 14375,
                        "name": "Sairé",
                        "latitude": "-8.30128000",
                        "longitude": "-35.68372000"
                    },
                    {
                        "id": 14381,
                        "name": "Salgadinho",
                        "latitude": "-7.92406000",
                        "longitude": "-35.59677000"
                    },
                    {
                        "id": 14386,
                        "name": "Salgueiro",
                        "latitude": "-8.07417000",
                        "longitude": "-39.11917000"
                    },
                    {
                        "id": 14392,
                        "name": "Saloá",
                        "latitude": "-9.06487000",
                        "longitude": "-36.76158000"
                    },
                    {
                        "id": 14415,
                        "name": "Sanharó",
                        "latitude": "-8.29191000",
                        "longitude": "-36.52169000"
                    },
                    {
                        "id": 14439,
                        "name": "Santa Cruz",
                        "latitude": "-8.30615000",
                        "longitude": "-40.31890000"
                    },
                    {
                        "id": 14442,
                        "name": "Santa Cruz da Baixa Verde",
                        "latitude": "-7.84821000",
                        "longitude": "-38.15341000"
                    },
                    {
                        "id": 14452,
                        "name": "Santa Cruz do Capibaribe",
                        "latitude": "-7.95750000",
                        "longitude": "-36.20472000"
                    },
                    {
                        "id": 14462,
                        "name": "Santa Filomena",
                        "latitude": "-8.28797000",
                        "longitude": "-40.59304000"
                    },
                    {
                        "id": 14505,
                        "name": "Santa Maria da Boa Vista",
                        "latitude": "-8.80778000",
                        "longitude": "-39.82556000"
                    },
                    {
                        "id": 14511,
                        "name": "Santa Maria do Cambucá",
                        "latitude": "-7.81441000",
                        "longitude": "-35.88175000"
                    },
                    {
                        "id": 14558,
                        "name": "Santa Terezinha",
                        "latitude": "-7.42664000",
                        "longitude": "-37.44422000"
                    },
                    {
                        "id": 14833,
                        "name": "São Benedito do Sul",
                        "latitude": "-8.77212000",
                        "longitude": "-35.90168000"
                    },
                    {
                        "id": 14843,
                        "name": "São Bento do Una",
                        "latitude": "-8.53733000",
                        "longitude": "-36.48122000"
                    },
                    {
                        "id": 14854,
                        "name": "São Caitano",
                        "latitude": "-8.33931000",
                        "longitude": "-36.16156000"
                    },
                    {
                        "id": 14999,
                        "name": "São João",
                        "latitude": "-8.86322000",
                        "longitude": "-36.39102000"
                    },
                    {
                        "id": 14933,
                        "name": "São Joaquim do Monte",
                        "latitude": "-8.43250000",
                        "longitude": "-35.80444000"
                    },
                    {
                        "id": 14942,
                        "name": "São José da Coroa Grande",
                        "latitude": "-8.89778000",
                        "longitude": "-35.14778000"
                    },
                    {
                        "id": 14961,
                        "name": "São José do Belmonte",
                        "latitude": "-7.86139000",
                        "longitude": "-38.75972000"
                    },
                    {
                        "id": 14970,
                        "name": "São José do Egito",
                        "latitude": "-7.47889000",
                        "longitude": "-37.27444000"
                    },
                    {
                        "id": 15053,
                        "name": "São Lourenço da Mata",
                        "latitude": "-8.00222000",
                        "longitude": "-35.01833000"
                    },
                    {
                        "id": 15171,
                        "name": "São Vicente Férrer",
                        "latitude": "-7.60222000",
                        "longitude": "-35.50216000"
                    },
                    {
                        "id": 14734,
                        "name": "Serra Talhada",
                        "latitude": "-7.99194000",
                        "longitude": "-38.29833000"
                    },
                    {
                        "id": 14754,
                        "name": "Serrita",
                        "latitude": "-7.84008000",
                        "longitude": "-39.40812000"
                    },
                    {
                        "id": 14759,
                        "name": "Sertânia",
                        "latitude": "-8.07361000",
                        "longitude": "-37.26444000"
                    },
                    {
                        "id": 14793,
                        "name": "Sirinhaém",
                        "latitude": "-8.59083000",
                        "longitude": "-35.11611000"
                    },
                    {
                        "id": 14805,
                        "name": "Solidão",
                        "latitude": "-7.59117000",
                        "longitude": "-37.65945000"
                    },
                    {
                        "id": 14826,
                        "name": "Surubim",
                        "latitude": "-7.83306000",
                        "longitude": "-35.75472000"
                    },
                    {
                        "id": 15187,
                        "name": "Tabira",
                        "latitude": "-7.59075000",
                        "longitude": "-37.49202000"
                    },
                    {
                        "id": 15193,
                        "name": "Tacaimbó",
                        "latitude": "-8.32284000",
                        "longitude": "-36.24711000"
                    },
                    {
                        "id": 15194,
                        "name": "Tacaratu",
                        "latitude": "-8.95680000",
                        "longitude": "-38.07649000"
                    },
                    {
                        "id": 15208,
                        "name": "Tamandaré",
                        "latitude": "-8.74874000",
                        "longitude": "-35.13941000"
                    },
                    {
                        "id": 15247,
                        "name": "Taquaritinga do Norte",
                        "latitude": "-7.84571000",
                        "longitude": "-36.12633000"
                    },
                    {
                        "id": 15287,
                        "name": "Terezinha",
                        "latitude": "-9.08773000",
                        "longitude": "-36.61210000"
                    },
                    {
                        "id": 15291,
                        "name": "Terra Nova",
                        "latitude": "-8.16981000",
                        "longitude": "-39.39098000"
                    },
                    {
                        "id": 15311,
                        "name": "Timbaúba",
                        "latitude": "-7.53194000",
                        "longitude": "-35.35625000"
                    },
                    {
                        "id": 15337,
                        "name": "Toritama",
                        "latitude": "-7.99823000",
                        "longitude": "-36.06332000"
                    },
                    {
                        "id": 15346,
                        "name": "Tracunhaém",
                        "latitude": "-7.72460000",
                        "longitude": "-35.15480000"
                    },
                    {
                        "id": 15360,
                        "name": "Trindade",
                        "latitude": "-7.78327000",
                        "longitude": "-40.33408000"
                    },
                    {
                        "id": 15363,
                        "name": "Triunfo",
                        "latitude": "-7.84766000",
                        "longitude": "-38.05176000"
                    },
                    {
                        "id": 15399,
                        "name": "Tupanatinga",
                        "latitude": "-8.67328000",
                        "longitude": "-37.34532000"
                    },
                    {
                        "id": 15404,
                        "name": "Tuparetama",
                        "latitude": "-7.71335000",
                        "longitude": "-37.24523000"
                    },
                    {
                        "id": 15529,
                        "name": "Venturosa",
                        "latitude": "-8.60330000",
                        "longitude": "-36.79818000"
                    },
                    {
                        "id": 15539,
                        "name": "Verdejante",
                        "latitude": "-7.98470000",
                        "longitude": "-38.99816000"
                    },
                    {
                        "id": 15544,
                        "name": "Vertente do Lério",
                        "latitude": "-7.78986000",
                        "longitude": "-35.80318000"
                    },
                    {
                        "id": 15545,
                        "name": "Vertentes",
                        "latitude": "-7.90936000",
                        "longitude": "-35.97775000"
                    },
                    {
                        "id": 15559,
                        "name": "Vicência",
                        "latitude": "-7.65645000",
                        "longitude": "-35.39117000"
                    },
                    {
                        "id": 15601,
                        "name": "Vitória de Santo Antão",
                        "latitude": "-8.11806000",
                        "longitude": "-35.29139000"
                    },
                    {
                        "id": 15640,
                        "name": "Xexéu",
                        "latitude": "-8.86469000",
                        "longitude": "-35.64275000"
                    }
                ]
            },
            {
                "id": 2008,
                "name": "Piauí",
                "iso2": "PI",
                "latitude": "-7.71834010",
                "longitude": "-42.72892360",
                "type": "state",
                "cities": [
                    {
                        "id": 10074,
                        "name": "Acauã",
                        "latitude": "-8.31552000",
                        "longitude": "-40.91283000"
                    },
                    {
                        "id": 10092,
                        "name": "Agricolândia",
                        "latitude": "-5.74819000",
                        "longitude": "-42.67458000"
                    },
                    {
                        "id": 15651,
                        "name": "Água Branca",
                        "latitude": "-5.89222000",
                        "longitude": "-42.63611000"
                    },
                    {
                        "id": 10112,
                        "name": "Alagoinha do Piauí",
                        "latitude": "-6.98016000",
                        "longitude": "-40.91814000"
                    },
                    {
                        "id": 10125,
                        "name": "Alegrete do Piauí",
                        "latitude": "-7.16226000",
                        "longitude": "-40.82488000"
                    },
                    {
                        "id": 10173,
                        "name": "Alto Longá",
                        "latitude": "-5.40788000",
                        "longitude": "-42.06612000"
                    },
                    {
                        "id": 10186,
                        "name": "Altos",
                        "latitude": "-5.03806000",
                        "longitude": "-42.46000000"
                    },
                    {
                        "id": 10198,
                        "name": "Alvorada do Gurguéia",
                        "latitude": "-8.38553000",
                        "longitude": "-43.83237000"
                    },
                    {
                        "id": 10209,
                        "name": "Amarante",
                        "latitude": "-6.37020000",
                        "longitude": "-42.78806000"
                    },
                    {
                        "id": 10254,
                        "name": "Angical do Piauí",
                        "latitude": "-6.09884000",
                        "longitude": "-42.72022000"
                    },
                    {
                        "id": 10283,
                        "name": "Anísio de Abreu",
                        "latitude": "-9.24779000",
                        "longitude": "-43.05238000"
                    },
                    {
                        "id": 10271,
                        "name": "Antônio Almeida",
                        "latitude": "-7.12211000",
                        "longitude": "-44.25307000"
                    },
                    {
                        "id": 10404,
                        "name": "Aroazes",
                        "latitude": "-6.20348000",
                        "longitude": "-41.86926000"
                    },
                    {
                        "id": 10406,
                        "name": "Aroeiras do Itaim",
                        "latitude": "-7.27000000",
                        "longitude": "-41.56000000"
                    },
                    {
                        "id": 10407,
                        "name": "Arraial",
                        "latitude": "-6.62721000",
                        "longitude": "-42.49393000"
                    },
                    {
                        "id": 10431,
                        "name": "Assunção do Piauí",
                        "latitude": "-5.85575000",
                        "longitude": "-40.94796000"
                    },
                    {
                        "id": 10459,
                        "name": "Avelino Lopes",
                        "latitude": "-10.11463000",
                        "longitude": "-43.89286000"
                    },
                    {
                        "id": 10477,
                        "name": "Baixa Grande do Ribeiro",
                        "latitude": "-8.69171000",
                        "longitude": "-45.12583000"
                    },
                    {
                        "id": 10522,
                        "name": "Barra d'Alcântara",
                        "latitude": "-6.54095000",
                        "longitude": "-42.11504000"
                    },
                    {
                        "id": 10549,
                        "name": "Barras",
                        "latitude": "-4.24444000",
                        "longitude": "-42.29444000"
                    },
                    {
                        "id": 10552,
                        "name": "Barreiras do Piauí",
                        "latitude": "-9.99042000",
                        "longitude": "-45.69329000"
                    },
                    {
                        "id": 10562,
                        "name": "Barro Duro",
                        "latitude": "-5.85063000",
                        "longitude": "-42.45878000"
                    },
                    {
                        "id": 10582,
                        "name": "Batalha",
                        "latitude": "-3.99736000",
                        "longitude": "-42.10645000"
                    },
                    {
                        "id": 10600,
                        "name": "Bela Vista do Piauí",
                        "latitude": "-7.91606000",
                        "longitude": "-41.90091000"
                    },
                    {
                        "id": 10620,
                        "name": "Belém do Piauí",
                        "latitude": "-7.40657000",
                        "longitude": "-40.98873000"
                    },
                    {
                        "id": 10622,
                        "name": "Beneditinos",
                        "latitude": "-5.45000000",
                        "longitude": "-42.36667000"
                    },
                    {
                        "id": 10639,
                        "name": "Bertolínia",
                        "latitude": "-7.75477000",
                        "longitude": "-43.79588000"
                    },
                    {
                        "id": 10644,
                        "name": "Betânia do Piauí",
                        "latitude": "-8.06430000",
                        "longitude": "-40.85924000"
                    },
                    {
                        "id": 10662,
                        "name": "Boa Hora",
                        "latitude": "-4.35576000",
                        "longitude": "-42.14109000"
                    },
                    {
                        "id": 10679,
                        "name": "Bocaina",
                        "latitude": "-6.89508000",
                        "longitude": "-41.32746000"
                    },
                    {
                        "id": 10698,
                        "name": "Bom Jesus",
                        "latitude": "-9.07444000",
                        "longitude": "-44.35861000"
                    },
                    {
                        "id": 10720,
                        "name": "Bom Princípio do Piauí",
                        "latitude": "-3.23751000",
                        "longitude": "-41.64572000"
                    },
                    {
                        "id": 10732,
                        "name": "Bonfim do Piauí",
                        "latitude": "-9.16462000",
                        "longitude": "-42.88253000"
                    },
                    {
                        "id": 10745,
                        "name": "Boqueirão do Piauí",
                        "latitude": "-4.56650000",
                        "longitude": "-42.13601000"
                    },
                    {
                        "id": 10769,
                        "name": "Brasileira",
                        "latitude": "-4.13325000",
                        "longitude": "-41.58774000"
                    },
                    {
                        "id": 10796,
                        "name": "Brejo do Piauí",
                        "latitude": "-8.26858000",
                        "longitude": "-42.78801000"
                    },
                    {
                        "id": 10828,
                        "name": "Buriti dos Lopes",
                        "latitude": "-3.17500000",
                        "longitude": "-41.86694000"
                    },
                    {
                        "id": 10829,
                        "name": "Buriti dos Montes",
                        "latitude": "-5.20888000",
                        "longitude": "-41.25078000"
                    },
                    {
                        "id": 10849,
                        "name": "Cabeceiras do Piauí",
                        "latitude": "-4.43347000",
                        "longitude": "-42.23060000"
                    },
                    {
                        "id": 10916,
                        "name": "Cajazeiras do Piauí",
                        "latitude": "-6.78182000",
                        "longitude": "-42.39243000"
                    },
                    {
                        "id": 10920,
                        "name": "Cajueiro da Praia",
                        "latitude": "-2.98747000",
                        "longitude": "-41.35439000"
                    },
                    {
                        "id": 10928,
                        "name": "Caldeirão Grande do Piauí",
                        "latitude": "-7.34361000",
                        "longitude": "-40.58774000"
                    },
                    {
                        "id": 10971,
                        "name": "Campinas do Piauí",
                        "latitude": "-7.67905000",
                        "longitude": "-41.87938000"
                    },
                    {
                        "id": 10980,
                        "name": "Campo Alegre do Fidalgo",
                        "latitude": "-8.31452000",
                        "longitude": "-41.79184000"
                    },
                    {
                        "id": 10991,
                        "name": "Campo Grande do Piauí",
                        "latitude": "-7.22070000",
                        "longitude": "-41.04511000"
                    },
                    {
                        "id": 10993,
                        "name": "Campo Largo do Piauí",
                        "latitude": "-3.85518000",
                        "longitude": "-42.60317000"
                    },
                    {
                        "id": 10997,
                        "name": "Campo Maior",
                        "latitude": "-4.82778000",
                        "longitude": "-42.16861000"
                    },
                    {
                        "id": 11028,
                        "name": "Canavieira",
                        "latitude": "-7.50756000",
                        "longitude": "-43.68630000"
                    },
                    {
                        "id": 11056,
                        "name": "Canto do Buriti",
                        "latitude": "-8.11000000",
                        "longitude": "-42.94444000"
                    },
                    {
                        "id": 11086,
                        "name": "Capitão de Campos",
                        "latitude": "-4.47203000",
                        "longitude": "-41.88512000"
                    },
                    {
                        "id": 11083,
                        "name": "Capitão Gervásio Oliveira",
                        "latitude": "-8.52938000",
                        "longitude": "-41.90126000"
                    },
                    {
                        "id": 11101,
                        "name": "Caracol",
                        "latitude": "-9.34943000",
                        "longitude": "-43.27078000"
                    },
                    {
                        "id": 11119,
                        "name": "Caraúbas do Piauí",
                        "latitude": "-3.53699000",
                        "longitude": "-41.84588000"
                    },
                    {
                        "id": 11130,
                        "name": "Caridade do Piauí",
                        "latitude": "-7.70139000",
                        "longitude": "-40.89597000"
                    },
                    {
                        "id": 11188,
                        "name": "Castelo do Piauí",
                        "latitude": "-5.21580000",
                        "longitude": "-41.55735000"
                    },
                    {
                        "id": 11220,
                        "name": "Caxingó",
                        "latitude": "-3.40863000",
                        "longitude": "-41.88771000"
                    },
                    {
                        "id": 11306,
                        "name": "Cocal",
                        "latitude": "-3.43751000",
                        "longitude": "-41.54594000"
                    },
                    {
                        "id": 11307,
                        "name": "Cocal de Telha",
                        "latitude": "-4.64857000",
                        "longitude": "-41.99568000"
                    },
                    {
                        "id": 11309,
                        "name": "Cocal dos Alves",
                        "latitude": "-3.57383000",
                        "longitude": "-41.45183000"
                    },
                    {
                        "id": 11318,
                        "name": "Coivaras",
                        "latitude": "-5.11661000",
                        "longitude": "-42.26583000"
                    },
                    {
                        "id": 11337,
                        "name": "Colônia do Gurguéia",
                        "latitude": "-8.14465000",
                        "longitude": "-43.77459000"
                    },
                    {
                        "id": 11338,
                        "name": "Colônia do Piauí",
                        "latitude": "-7.22638000",
                        "longitude": "-42.21262000"
                    },
                    {
                        "id": 11355,
                        "name": "Conceição do Canindé",
                        "latitude": "-7.98695000",
                        "longitude": "-41.57544000"
                    },
                    {
                        "id": 11421,
                        "name": "Coronel José Dias",
                        "latitude": "-9.07216000",
                        "longitude": "-42.27241000"
                    },
                    {
                        "id": 11434,
                        "name": "Corrente",
                        "latitude": "-10.47219000",
                        "longitude": "-45.04691000"
                    },
                    {
                        "id": 11473,
                        "name": "Cristalândia do Piauí",
                        "latitude": "-10.82007000",
                        "longitude": "-45.11052000"
                    },
                    {
                        "id": 11477,
                        "name": "Cristino Castro",
                        "latitude": "-8.69043000",
                        "longitude": "-44.04806000"
                    },
                    {
                        "id": 11522,
                        "name": "Curimatá",
                        "latitude": "-9.86209000",
                        "longitude": "-44.38994000"
                    },
                    {
                        "id": 11527,
                        "name": "Currais",
                        "latitude": "-8.73985000",
                        "longitude": "-44.86466000"
                    },
                    {
                        "id": 11529,
                        "name": "Curral Novo do Piauí",
                        "latitude": "-7.88978000",
                        "longitude": "-40.76427000"
                    },
                    {
                        "id": 11534,
                        "name": "Curralinhos",
                        "latitude": "-5.58488000",
                        "longitude": "-42.86082000"
                    },
                    {
                        "id": 11571,
                        "name": "Demerval Lobão",
                        "latitude": "-5.35833000",
                        "longitude": "-42.67639000"
                    },
                    {
                        "id": 11598,
                        "name": "Dirceu Arcoverde",
                        "latitude": "-9.33230000",
                        "longitude": "-42.43422000"
                    },
                    {
                        "id": 11627,
                        "name": "Dom Expedito Lopes",
                        "latitude": "-6.95806000",
                        "longitude": "-41.71629000"
                    },
                    {
                        "id": 11629,
                        "name": "Dom Inocêncio",
                        "latitude": "-8.88480000",
                        "longitude": "-41.72000000"
                    },
                    {
                        "id": 11638,
                        "name": "Domingos Mourão",
                        "latitude": "-4.19141000",
                        "longitude": "-41.34833000"
                    },
                    {
                        "id": 11681,
                        "name": "Elesbão Veloso",
                        "latitude": "-6.19359000",
                        "longitude": "-42.16607000"
                    },
                    {
                        "id": 11683,
                        "name": "Eliseu Martins",
                        "latitude": "-7.90155000",
                        "longitude": "-43.77769000"
                    },
                    {
                        "id": 11729,
                        "name": "Esperantina",
                        "latitude": "-3.84898000",
                        "longitude": "-42.17102000"
                    },
                    {
                        "id": 11780,
                        "name": "Fartura do Piauí",
                        "latitude": "-9.52033000",
                        "longitude": "-42.78927000"
                    },
                    {
                        "id": 11833,
                        "name": "Flores do Piauí",
                        "latitude": "-7.64121000",
                        "longitude": "-42.84551000"
                    },
                    {
                        "id": 11838,
                        "name": "Floresta do Piauí",
                        "latitude": "-7.47628000",
                        "longitude": "-41.84428000"
                    },
                    {
                        "id": 11841,
                        "name": "Floriano",
                        "latitude": "-6.76694000",
                        "longitude": "-43.02250000"
                    },
                    {
                        "id": 11875,
                        "name": "Francinópolis",
                        "latitude": "-6.41032000",
                        "longitude": "-42.24638000"
                    },
                    {
                        "id": 11877,
                        "name": "Francisco Ayres",
                        "latitude": "-6.69130000",
                        "longitude": "-42.69202000"
                    },
                    {
                        "id": 11882,
                        "name": "Francisco Macedo",
                        "latitude": "-7.35845000",
                        "longitude": "-40.77056000"
                    },
                    {
                        "id": 11884,
                        "name": "Francisco Santos",
                        "latitude": "-7.10293000",
                        "longitude": "-41.14500000"
                    },
                    {
                        "id": 11900,
                        "name": "Fronteiras",
                        "latitude": "-7.01250000",
                        "longitude": "-40.56213000"
                    },
                    {
                        "id": 11933,
                        "name": "Geminiano",
                        "latitude": "-7.16595000",
                        "longitude": "-41.38802000"
                    },
                    {
                        "id": 11944,
                        "name": "Gilbués",
                        "latitude": "-9.72737000",
                        "longitude": "-45.52017000"
                    },
                    {
                        "id": 12013,
                        "name": "Guadalupe",
                        "latitude": "-6.82297000",
                        "longitude": "-43.77762000"
                    },
                    {
                        "id": 12066,
                        "name": "Guaribas",
                        "latitude": "-9.28870000",
                        "longitude": "-43.58188000"
                    },
                    {
                        "id": 12108,
                        "name": "Hugo Napoleão",
                        "latitude": "-6.03293000",
                        "longitude": "-42.46773000"
                    },
                    {
                        "id": 12208,
                        "name": "Ilha Grande",
                        "latitude": "-2.84022000",
                        "longitude": "-41.82881000"
                    },
                    {
                        "id": 12252,
                        "name": "Inhuma",
                        "latitude": "-6.66187000",
                        "longitude": "-41.68135000"
                    },
                    {
                        "id": 12278,
                        "name": "Ipiranga do Piauí",
                        "latitude": "-6.84634000",
                        "longitude": "-41.74687000"
                    },
                    {
                        "id": 12292,
                        "name": "Ipueiras",
                        "latitude": "-7.03333000",
                        "longitude": "-40.45000000"
                    },
                    {
                        "id": 12322,
                        "name": "Isaías Coelho",
                        "latitude": "-7.54521000",
                        "longitude": "-41.64289000"
                    },
                    {
                        "id": 12358,
                        "name": "Itainópolis",
                        "latitude": "-7.45524000",
                        "longitude": "-41.54165000"
                    },
                    {
                        "id": 12463,
                        "name": "Itaueira",
                        "latitude": "-7.60333000",
                        "longitude": "-43.02556000"
                    },
                    {
                        "id": 12528,
                        "name": "Jacobina do Piauí",
                        "latitude": "-7.96488000",
                        "longitude": "-41.17396000"
                    },
                    {
                        "id": 12551,
                        "name": "Jaicós",
                        "latitude": "-7.45645000",
                        "longitude": "-41.22016000"
                    },
                    {
                        "id": 12590,
                        "name": "Jardim do Mulato",
                        "latitude": "-6.15734000",
                        "longitude": "-42.47763000"
                    },
                    {
                        "id": 12604,
                        "name": "Jatobá do Piauí",
                        "latitude": "-4.80296000",
                        "longitude": "-41.89545000"
                    },
                    {
                        "id": 12623,
                        "name": "Jerumenha",
                        "latitude": "-7.09885000",
                        "longitude": "-43.54675000"
                    },
                    {
                        "id": 12658,
                        "name": "João Costa",
                        "latitude": "-8.54315000",
                        "longitude": "-42.41513000"
                    },
                    {
                        "id": 12639,
                        "name": "Joaquim Pires",
                        "latitude": "-3.53692000",
                        "longitude": "-42.07750000"
                    },
                    {
                        "id": 12644,
                        "name": "Joca Marques",
                        "latitude": "-3.54211000",
                        "longitude": "-42.43579000"
                    },
                    {
                        "id": 12655,
                        "name": "José de Freitas",
                        "latitude": "-4.72992000",
                        "longitude": "-42.61373000"
                    },
                    {
                        "id": 12675,
                        "name": "Juazeiro do Piauí",
                        "latitude": "-5.02486000",
                        "longitude": "-41.52841000"
                    },
                    {
                        "id": 12717,
                        "name": "Júlio Borges",
                        "latitude": "-10.51580000",
                        "longitude": "-44.19178000"
                    },
                    {
                        "id": 12696,
                        "name": "Jurema",
                        "latitude": "-9.29862000",
                        "longitude": "-43.15301000"
                    },
                    {
                        "id": 12734,
                        "name": "Lagoa Alegre",
                        "latitude": "-4.49510000",
                        "longitude": "-42.56555000"
                    },
                    {
                        "id": 12755,
                        "name": "Lagoa de São Francisco",
                        "latitude": "-4.35468000",
                        "longitude": "-41.59168000"
                    },
                    {
                        "id": 12757,
                        "name": "Lagoa do Barro do Piauí",
                        "latitude": "-8.73535000",
                        "longitude": "-41.54813000"
                    },
                    {
                        "id": 12762,
                        "name": "Lagoa do Piauí",
                        "latitude": "-5.47513000",
                        "longitude": "-42.54814000"
                    },
                    {
                        "id": 12763,
                        "name": "Lagoa do Sítio",
                        "latitude": "-6.51918000",
                        "longitude": "-41.42058000"
                    },
                    {
                        "id": 12769,
                        "name": "Lagoinha do Piauí",
                        "latitude": "-5.80702000",
                        "longitude": "-42.62796000"
                    },
                    {
                        "id": 12791,
                        "name": "Landri Sales",
                        "latitude": "-7.23268000",
                        "longitude": "-43.86456000"
                    },
                    {
                        "id": 12879,
                        "name": "Luís Correia",
                        "latitude": "-3.03117000",
                        "longitude": "-41.51665000"
                    },
                    {
                        "id": 12875,
                        "name": "Luzilândia",
                        "latitude": "-3.60743000",
                        "longitude": "-42.36456000"
                    },
                    {
                        "id": 12906,
                        "name": "Madeiro",
                        "latitude": "-3.54658000",
                        "longitude": "-42.51114000"
                    },
                    {
                        "id": 12952,
                        "name": "Manoel Emídio",
                        "latitude": "-8.16469000",
                        "longitude": "-43.83360000"
                    },
                    {
                        "id": 12996,
                        "name": "Marcolândia",
                        "latitude": "-7.40891000",
                        "longitude": "-40.74945000"
                    },
                    {
                        "id": 12997,
                        "name": "Marcos Parente",
                        "latitude": "-7.05412000",
                        "longitude": "-43.91664000"
                    },
                    {
                        "id": 13042,
                        "name": "Massapê do Piauí",
                        "latitude": "-7.53879000",
                        "longitude": "-41.01755000"
                    },
                    {
                        "id": 13058,
                        "name": "Matias Olímpio",
                        "latitude": "-3.68774000",
                        "longitude": "-42.60695000"
                    },
                    {
                        "id": 13109,
                        "name": "Miguel Alves",
                        "latitude": "-4.15790000",
                        "longitude": "-42.77263000"
                    },
                    {
                        "id": 13111,
                        "name": "Miguel Leão",
                        "latitude": "-5.72867000",
                        "longitude": "-42.68942000"
                    },
                    {
                        "id": 13118,
                        "name": "Milton Brandão",
                        "latitude": "-4.74021000",
                        "longitude": "-41.59457000"
                    },
                    {
                        "id": 13177,
                        "name": "Monsenhor Gil",
                        "latitude": "-5.64162000",
                        "longitude": "-42.54879000"
                    },
                    {
                        "id": 13178,
                        "name": "Monsenhor Hipólito",
                        "latitude": "-6.94982000",
                        "longitude": "-41.03155000"
                    },
                    {
                        "id": 13191,
                        "name": "Monte Alegre do Piauí",
                        "latitude": "-9.74213000",
                        "longitude": "-44.98266000"
                    },
                    {
                        "id": 13241,
                        "name": "Morro Cabeça no Tempo",
                        "latitude": "-9.87713000",
                        "longitude": "-43.90657000"
                    },
                    {
                        "id": 13249,
                        "name": "Morro do Chapéu do Piauí",
                        "latitude": "-3.68694000",
                        "longitude": "-42.22185000"
                    },
                    {
                        "id": 13281,
                        "name": "Murici dos Portelas",
                        "latitude": "-3.36504000",
                        "longitude": "-42.00218000"
                    },
                    {
                        "id": 13314,
                        "name": "Nazaré do Piauí",
                        "latitude": "-7.03279000",
                        "longitude": "-42.73216000"
                    },
                    {
                        "id": 13315,
                        "name": "Nazária",
                        "latitude": "-5.44546000",
                        "longitude": "-42.86840000"
                    },
                    {
                        "id": 13341,
                        "name": "Nossa Senhora de Nazaré",
                        "latitude": "-4.63841000",
                        "longitude": "-42.19017000"
                    },
                    {
                        "id": 13344,
                        "name": "Nossa Senhora dos Remédios",
                        "latitude": "-4.05765000",
                        "longitude": "-42.60651000"
                    },
                    {
                        "id": 13433,
                        "name": "Nova Santa Rita",
                        "latitude": "-8.11204000",
                        "longitude": "-42.01361000"
                    },
                    {
                        "id": 13473,
                        "name": "Novo Oriente do Piauí",
                        "latitude": "-6.55034000",
                        "longitude": "-41.98555000"
                    },
                    {
                        "id": 13477,
                        "name": "Novo Santo Antônio",
                        "latitude": "-5.32848000",
                        "longitude": "-41.96256000"
                    },
                    {
                        "id": 13490,
                        "name": "Oeiras",
                        "latitude": "-6.90686000",
                        "longitude": "-42.17529000"
                    },
                    {
                        "id": 13499,
                        "name": "Olho d'Água do Piauí",
                        "latitude": "-5.84854000",
                        "longitude": "-42.53937000"
                    },
                    {
                        "id": 13563,
                        "name": "Padre Marcos",
                        "latitude": "-7.36533000",
                        "longitude": "-40.93416000"
                    },
                    {
                        "id": 13565,
                        "name": "Paes Landim",
                        "latitude": "-7.77461000",
                        "longitude": "-42.35087000"
                    },
                    {
                        "id": 13574,
                        "name": "Pajeú do Piauí",
                        "latitude": "-8.05364000",
                        "longitude": "-42.86625000"
                    },
                    {
                        "id": 13593,
                        "name": "Palmeira do Piauí",
                        "latitude": "-8.51549000",
                        "longitude": "-44.43642000"
                    },
                    {
                        "id": 13595,
                        "name": "Palmeirais",
                        "latitude": "-5.78548000",
                        "longitude": "-43.02434000"
                    },
                    {
                        "id": 13622,
                        "name": "Paquetá",
                        "latitude": "-7.10746000",
                        "longitude": "-41.64719000"
                    },
                    {
                        "id": 13678,
                        "name": "Parnaguá",
                        "latitude": "-10.12155000",
                        "longitude": "-44.56012000"
                    },
                    {
                        "id": 13682,
                        "name": "Parnaíba",
                        "latitude": "-2.92278000",
                        "longitude": "-41.73536000"
                    },
                    {
                        "id": 13694,
                        "name": "Passagem Franca do Piauí",
                        "latitude": "-5.82734000",
                        "longitude": "-42.40584000"
                    },
                    {
                        "id": 13708,
                        "name": "Patos do Piauí",
                        "latitude": "-7.60918000",
                        "longitude": "-41.29464000"
                    },
                    {
                        "id": 13715,
                        "name": "Pau D'arco do Piauí",
                        "latitude": "-5.24511000",
                        "longitude": "-42.45473000"
                    },
                    {
                        "id": 13728,
                        "name": "Paulistana",
                        "latitude": "-8.22526000",
                        "longitude": "-41.22746000"
                    },
                    {
                        "id": 13740,
                        "name": "Pavussu",
                        "latitude": "-7.88646000",
                        "longitude": "-43.19694000"
                    },
                    {
                        "id": 13777,
                        "name": "Pedro II",
                        "latitude": "-4.49028000",
                        "longitude": "-41.39962000"
                    },
                    {
                        "id": 13778,
                        "name": "Pedro Laurentino",
                        "latitude": "-8.11766000",
                        "longitude": "-42.23542000"
                    },
                    {
                        "id": 13829,
                        "name": "Picos",
                        "latitude": "-7.10697000",
                        "longitude": "-41.51271000"
                    },
                    {
                        "id": 13846,
                        "name": "Pimenteiras",
                        "latitude": "-6.24528000",
                        "longitude": "-41.41917000"
                    },
                    {
                        "id": 13878,
                        "name": "Pio IX",
                        "latitude": "-6.86982000",
                        "longitude": "-40.59717000"
                    },
                    {
                        "id": 13887,
                        "name": "Piracuruca",
                        "latitude": "-3.86656000",
                        "longitude": "-41.74153000"
                    },
                    {
                        "id": 13917,
                        "name": "Piripiri",
                        "latitude": "-4.39488000",
                        "longitude": "-41.78819000"
                    },
                    {
                        "id": 13992,
                        "name": "Porto",
                        "latitude": "-3.94558000",
                        "longitude": "-42.68879000"
                    },
                    {
                        "id": 13996,
                        "name": "Porto Alegre do Piauí",
                        "latitude": "-6.95931000",
                        "longitude": "-44.07411000"
                    },
                    {
                        "id": 14070,
                        "name": "Prata do Piauí",
                        "latitude": "-5.71099000",
                        "longitude": "-42.15331000"
                    },
                    {
                        "id": 14138,
                        "name": "Queimada Nova",
                        "latitude": "-8.53997000",
                        "longitude": "-41.24753000"
                    },
                    {
                        "id": 14186,
                        "name": "Redenção do Gurguéia",
                        "latitude": "-9.58205000",
                        "longitude": "-44.53802000"
                    },
                    {
                        "id": 14188,
                        "name": "Regeneração",
                        "latitude": "-6.27844000",
                        "longitude": "-42.48165000"
                    },
                    {
                        "id": 14210,
                        "name": "Riacho Frio",
                        "latitude": "-9.83660000",
                        "longitude": "-44.67899000"
                    },
                    {
                        "id": 14233,
                        "name": "Ribeira do Piauí",
                        "latitude": "-8.09706000",
                        "longitude": "-42.57609000"
                    },
                    {
                        "id": 14235,
                        "name": "Ribeiro Gonçalves",
                        "latitude": "-8.08721000",
                        "longitude": "-45.47197000"
                    },
                    {
                        "id": 14278,
                        "name": "Rio Grande do Piauí",
                        "latitude": "-7.86062000",
                        "longitude": "-43.14551000"
                    },
                    {
                        "id": 14454,
                        "name": "Santa Cruz do Piauí",
                        "latitude": "-7.26490000",
                        "longitude": "-41.76380000"
                    },
                    {
                        "id": 14458,
                        "name": "Santa Cruz dos Milagres",
                        "latitude": "-5.83227000",
                        "longitude": "-41.95795000"
                    },
                    {
                        "id": 14461,
                        "name": "Santa Filomena",
                        "latitude": "-8.89582000",
                        "longitude": "-45.66715000"
                    },
                    {
                        "id": 14488,
                        "name": "Santa Luz",
                        "latitude": "-8.97437000",
                        "longitude": "-44.27778000"
                    },
                    {
                        "id": 14546,
                        "name": "Santa Rosa do Piauí",
                        "latitude": "-6.82877000",
                        "longitude": "-42.24627000"
                    },
                    {
                        "id": 14591,
                        "name": "Santana do Piauí",
                        "latitude": "-6.95247000",
                        "longitude": "-41.46185000"
                    },
                    {
                        "id": 14618,
                        "name": "Santo Antônio de Lisboa",
                        "latitude": "-6.87642000",
                        "longitude": "-41.18103000"
                    },
                    {
                        "id": 14643,
                        "name": "Santo Antônio dos Milagres",
                        "latitude": "-6.05399000",
                        "longitude": "-42.70083000"
                    },
                    {
                        "id": 14651,
                        "name": "Santo Inácio do Piauí",
                        "latitude": "-7.46906000",
                        "longitude": "-41.91794000"
                    },
                    {
                        "id": 14849,
                        "name": "São Braz do Piauí",
                        "latitude": "-8.97380000",
                        "longitude": "-42.97568000"
                    },
                    {
                        "id": 14904,
                        "name": "São Félix do Piauí",
                        "latitude": "-5.88422000",
                        "longitude": "-42.10830000"
                    },
                    {
                        "id": 14884,
                        "name": "São Francisco de Assis do Piauí",
                        "latitude": "-8.12334000",
                        "longitude": "-41.48056000"
                    },
                    {
                        "id": 14897,
                        "name": "São Francisco do Piauí",
                        "latitude": "-7.16899000",
                        "longitude": "-42.55086000"
                    },
                    {
                        "id": 14920,
                        "name": "São Gonçalo do Gurguéia",
                        "latitude": "-10.07630000",
                        "longitude": "-45.42387000"
                    },
                    {
                        "id": 14922,
                        "name": "São Gonçalo do Piauí",
                        "latitude": "-6.02033000",
                        "longitude": "-42.67020000"
                    },
                    {
                        "id": 15008,
                        "name": "São João da Canabrava",
                        "latitude": "-6.72756000",
                        "longitude": "-41.38226000"
                    },
                    {
                        "id": 15009,
                        "name": "São João da Fronteira",
                        "latitude": "-4.09363000",
                        "longitude": "-41.21552000"
                    },
                    {
                        "id": 15015,
                        "name": "São João da Serra",
                        "latitude": "-5.44173000",
                        "longitude": "-41.85793000"
                    },
                    {
                        "id": 15017,
                        "name": "São João da Varjota",
                        "latitude": "-6.94733000",
                        "longitude": "-41.92917000"
                    },
                    {
                        "id": 15025,
                        "name": "São João do Arraial",
                        "latitude": "-3.80325000",
                        "longitude": "-42.46973000"
                    },
                    {
                        "id": 15040,
                        "name": "São João do Piauí",
                        "latitude": "-8.27575000",
                        "longitude": "-42.34005000"
                    },
                    {
                        "id": 14968,
                        "name": "São José do Divino",
                        "latitude": "-3.74297000",
                        "longitude": "-41.90119000"
                    },
                    {
                        "id": 14980,
                        "name": "São José do Peixe",
                        "latitude": "-7.49544000",
                        "longitude": "-42.49355000"
                    },
                    {
                        "id": 14981,
                        "name": "São José do Piauí",
                        "latitude": "-6.84096000",
                        "longitude": "-41.51702000"
                    },
                    {
                        "id": 15050,
                        "name": "São Julião",
                        "latitude": "-7.05987000",
                        "longitude": "-40.79725000"
                    },
                    {
                        "id": 15056,
                        "name": "São Lourenço do Piauí",
                        "latitude": "-9.13336000",
                        "longitude": "-42.40297000"
                    },
                    {
                        "id": 15059,
                        "name": "São Luis do Piauí",
                        "latitude": "-6.77801000",
                        "longitude": "-41.27650000"
                    },
                    {
                        "id": 15080,
                        "name": "São Miguel da Baixa Grande",
                        "latitude": "-5.81791000",
                        "longitude": "-42.27077000"
                    },
                    {
                        "id": 15088,
                        "name": "São Miguel do Fidalgo",
                        "latitude": "-7.59935000",
                        "longitude": "-42.38796000"
                    },
                    {
                        "id": 15095,
                        "name": "São Miguel do Tapuio",
                        "latitude": "-5.70486000",
                        "longitude": "-41.61634000"
                    },
                    {
                        "id": 15119,
                        "name": "São Pedro do Piauí",
                        "latitude": "-5.82135000",
                        "longitude": "-42.77168000"
                    },
                    {
                        "id": 15126,
                        "name": "São Raimundo Nonato",
                        "latitude": "-9.05220000",
                        "longitude": "-42.60836000"
                    },
                    {
                        "id": 14683,
                        "name": "Sebastião Barros",
                        "latitude": "-10.59755000",
                        "longitude": "-44.83609000"
                    },
                    {
                        "id": 14685,
                        "name": "Sebastião Leal",
                        "latitude": "-7.51324000",
                        "longitude": "-44.02545000"
                    },
                    {
                        "id": 14774,
                        "name": "Sigefredo Pacheco",
                        "latitude": "-4.79886000",
                        "longitude": "-41.78459000"
                    },
                    {
                        "id": 14788,
                        "name": "Simões",
                        "latitude": "-7.59889000",
                        "longitude": "-40.81778000"
                    },
                    {
                        "id": 14785,
                        "name": "Simplício Mendes",
                        "latitude": "-7.85389000",
                        "longitude": "-41.91028000"
                    },
                    {
                        "id": 14801,
                        "name": "Socorro do Piauí",
                        "latitude": "-7.89820000",
                        "longitude": "-42.50745000"
                    },
                    {
                        "id": 14827,
                        "name": "Sussuapara",
                        "latitude": "-7.00335000",
                        "longitude": "-41.39182000"
                    },
                    {
                        "id": 15213,
                        "name": "Tamboril do Piauí",
                        "latitude": "-8.40278000",
                        "longitude": "-43.09084000"
                    },
                    {
                        "id": 15222,
                        "name": "Tanque do Piauí",
                        "latitude": "-6.69614000",
                        "longitude": "-42.18310000"
                    },
                    {
                        "id": 15284,
                        "name": "Teresina",
                        "latitude": "-5.10252000",
                        "longitude": "-42.74070000"
                    },
                    {
                        "id": 15456,
                        "name": "União",
                        "latitude": "-4.59646000",
                        "longitude": "-42.86468000"
                    },
                    {
                        "id": 15487,
                        "name": "Uruçuí",
                        "latitude": "-7.34206000",
                        "longitude": "-44.58334000"
                    },
                    {
                        "id": 15501,
                        "name": "Valença do Piauí",
                        "latitude": "-6.27870000",
                        "longitude": "-41.81385000"
                    },
                    {
                        "id": 15616,
                        "name": "Várzea Branca",
                        "latitude": "-9.34411000",
                        "longitude": "-42.95158000"
                    },
                    {
                        "id": 15617,
                        "name": "Várzea Grande",
                        "latitude": "-6.56374000",
                        "longitude": "-42.17729000"
                    },
                    {
                        "id": 15537,
                        "name": "Vera Mendes",
                        "latitude": "-7.55480000",
                        "longitude": "-41.50596000"
                    },
                    {
                        "id": 15571,
                        "name": "Vila Nova do Piauí",
                        "latitude": "-7.18671000",
                        "longitude": "-40.93621000"
                    },
                    {
                        "id": 15625,
                        "name": "Wall Ferraz",
                        "latitude": "-7.29532000",
                        "longitude": "-41.83730000"
                    }
                ]
            },
            {
                "id": 1997,
                "name": "Rio de Janeiro",
                "iso2": "RJ",
                "latitude": "-22.90684670",
                "longitude": "-43.17289650",
                "type": "state",
                "cities": [
                    {
                        "id": 10257,
                        "name": "Angra dos Reis",
                        "latitude": "-23.00667000",
                        "longitude": "-44.31806000"
                    },
                    {
                        "id": 10291,
                        "name": "Aperibé",
                        "latitude": "-21.64148000",
                        "longitude": "-42.12753000"
                    },
                    {
                        "id": 10356,
                        "name": "Araruama",
                        "latitude": "-22.87278000",
                        "longitude": "-42.34306000"
                    },
                    {
                        "id": 10381,
                        "name": "Areal",
                        "latitude": "-22.23056000",
                        "longitude": "-43.10556000"
                    },
                    {
                        "id": 10402,
                        "name": "Armação dos Búzios",
                        "latitude": "-22.76948000",
                        "longitude": "-41.90965000"
                    },
                    {
                        "id": 10408,
                        "name": "Arraial do Cabo",
                        "latitude": "-22.95505000",
                        "longitude": "-42.06098000"
                    },
                    {
                        "id": 10540,
                        "name": "Barra do Piraí",
                        "latitude": "-22.47000000",
                        "longitude": "-43.82556000"
                    },
                    {
                        "id": 10520,
                        "name": "Barra Mansa",
                        "latitude": "-22.54417000",
                        "longitude": "-44.17139000"
                    },
                    {
                        "id": 10602,
                        "name": "Belford Roxo",
                        "latitude": "-22.76417000",
                        "longitude": "-43.39944000"
                    },
                    {
                        "id": 10694,
                        "name": "Bom Jardim",
                        "latitude": "-22.17871000",
                        "longitude": "-42.33515000"
                    },
                    {
                        "id": 10711,
                        "name": "Bom Jesus do Itabapoana",
                        "latitude": "-21.13389000",
                        "longitude": "-41.67972000"
                    },
                    {
                        "id": 10853,
                        "name": "Cabo Frio",
                        "latitude": "-22.88717000",
                        "longitude": "-42.02622000"
                    },
                    {
                        "id": 10875,
                        "name": "Cachoeiras de Macacu",
                        "latitude": "-22.46250000",
                        "longitude": "-42.65306000"
                    },
                    {
                        "id": 10948,
                        "name": "Cambuci",
                        "latitude": "-21.57528000",
                        "longitude": "-41.91111000"
                    },
                    {
                        "id": 11019,
                        "name": "Campos dos Goytacazes",
                        "latitude": "-21.75227000",
                        "longitude": "-41.33044000"
                    },
                    {
                        "id": 11052,
                        "name": "Cantagalo",
                        "latitude": "-21.98111000",
                        "longitude": "-42.36806000"
                    },
                    {
                        "id": 11108,
                        "name": "Carapebus",
                        "latitude": "-22.22429000",
                        "longitude": "-41.61306000"
                    },
                    {
                        "id": 11123,
                        "name": "Cardoso Moreira",
                        "latitude": "-21.51166000",
                        "longitude": "-41.46121000"
                    },
                    {
                        "id": 11142,
                        "name": "Carmo",
                        "latitude": "-21.89966000",
                        "longitude": "-42.53760000"
                    },
                    {
                        "id": 11180,
                        "name": "Casimiro de Abreu",
                        "latitude": "-22.48056000",
                        "longitude": "-42.20417000"
                    },
                    {
                        "id": 11341,
                        "name": "Comendador Levy Gasparian",
                        "latitude": "-22.03655000",
                        "longitude": "-43.25312000"
                    },
                    {
                        "id": 11352,
                        "name": "Conceição de Macabu",
                        "latitude": "-22.12612000",
                        "longitude": "-41.85341000"
                    },
                    {
                        "id": 11399,
                        "name": "Cordeiro",
                        "latitude": "-22.02861000",
                        "longitude": "-42.36083000"
                    },
                    {
                        "id": 11664,
                        "name": "Duas Barras",
                        "latitude": "-22.07281000",
                        "longitude": "-42.52467000"
                    },
                    {
                        "id": 11669,
                        "name": "Duque de Caxias",
                        "latitude": "-22.78556000",
                        "longitude": "-43.31167000"
                    },
                    {
                        "id": 11702,
                        "name": "Engenheiro Paulo de Frontin",
                        "latitude": "-22.54807000",
                        "longitude": "-43.67270000"
                    },
                    {
                        "id": 12028,
                        "name": "Guapimirim",
                        "latitude": "-22.58914000",
                        "longitude": "-42.97530000"
                    },
                    {
                        "id": 12195,
                        "name": "Iguaba Grande",
                        "latitude": "-22.83917000",
                        "longitude": "-42.22889000"
                    },
                    {
                        "id": 12207,
                        "name": "Ilha Grande",
                        "latitude": "-23.15236000",
                        "longitude": "-44.23164000"
                    },
                    {
                        "id": 12336,
                        "name": "Itaboraí",
                        "latitude": "-22.74444000",
                        "longitude": "-42.85944000"
                    },
                    {
                        "id": 12357,
                        "name": "Itaguaí",
                        "latitude": "-22.85222000",
                        "longitude": "-43.77528000"
                    },
                    {
                        "id": 12374,
                        "name": "Italva",
                        "latitude": "-21.38401000",
                        "longitude": "-41.66728000"
                    },
                    {
                        "id": 12397,
                        "name": "Itaocara",
                        "latitude": "-21.77006000",
                        "longitude": "-42.07488000"
                    },
                    {
                        "id": 12410,
                        "name": "Itaperuna",
                        "latitude": "-21.20500000",
                        "longitude": "-41.88778000"
                    },
                    {
                        "id": 12454,
                        "name": "Itatiaia",
                        "latitude": "-22.41099000",
                        "longitude": "-44.57621000"
                    },
                    {
                        "id": 12569,
                        "name": "Japeri",
                        "latitude": "-22.64306000",
                        "longitude": "-43.65333000"
                    },
                    {
                        "id": 12774,
                        "name": "Laje do Muriaé",
                        "latitude": "-21.23762000",
                        "longitude": "-42.13269000"
                    },
                    {
                        "id": 12892,
                        "name": "Macaé",
                        "latitude": "-22.38484000",
                        "longitude": "-41.78324000"
                    },
                    {
                        "id": 12903,
                        "name": "Macuco",
                        "latitude": "-22.02427000",
                        "longitude": "-42.27369000"
                    },
                    {
                        "id": 12914,
                        "name": "Magé",
                        "latitude": "-22.63490000",
                        "longitude": "-43.12056000"
                    },
                    {
                        "id": 12947,
                        "name": "Mangaratiba",
                        "latitude": "-22.95972000",
                        "longitude": "-44.04056000"
                    },
                    {
                        "id": 13012,
                        "name": "Maricá",
                        "latitude": "-22.91630000",
                        "longitude": "-42.82203000"
                    },
                    {
                        "id": 13097,
                        "name": "Mendes",
                        "latitude": "-22.54316000",
                        "longitude": "-43.74899000"
                    },
                    {
                        "id": 13104,
                        "name": "Mesquita",
                        "latitude": "-22.78993000",
                        "longitude": "-43.45966000"
                    },
                    {
                        "id": 13112,
                        "name": "Miguel Pereira",
                        "latitude": "-22.45389000",
                        "longitude": "-43.46889000"
                    },
                    {
                        "id": 13132,
                        "name": "Miracema",
                        "latitude": "-21.37442000",
                        "longitude": "-42.15048000"
                    },
                    {
                        "id": 13301,
                        "name": "Natividade",
                        "latitude": "-21.04222000",
                        "longitude": "-41.97333000"
                    },
                    {
                        "id": 13325,
                        "name": "Nilópolis",
                        "latitude": "-22.82106000",
                        "longitude": "-43.42703000"
                    },
                    {
                        "id": 13331,
                        "name": "Niterói",
                        "latitude": "-22.91715000",
                        "longitude": "-43.08391000"
                    },
                    {
                        "id": 13380,
                        "name": "Nova Friburgo",
                        "latitude": "-22.28194000",
                        "longitude": "-42.53111000"
                    },
                    {
                        "id": 13389,
                        "name": "Nova Iguaçu",
                        "latitude": "-22.75917000",
                        "longitude": "-43.45111000"
                    },
                    {
                        "id": 13623,
                        "name": "Paracambi",
                        "latitude": "-22.60829000",
                        "longitude": "-43.70840000"
                    },
                    {
                        "id": 13658,
                        "name": "Paraíba do Sul",
                        "latitude": "-22.15847000",
                        "longitude": "-43.29321000"
                    },
                    {
                        "id": 13654,
                        "name": "Paraty",
                        "latitude": "-23.21778000",
                        "longitude": "-44.71306000"
                    },
                    {
                        "id": 13713,
                        "name": "Paty do Alferes",
                        "latitude": "-22.42861000",
                        "longitude": "-43.41861000"
                    },
                    {
                        "id": 13821,
                        "name": "Petrópolis",
                        "latitude": "-22.38219000",
                        "longitude": "-43.15909000"
                    },
                    {
                        "id": 13866,
                        "name": "Pinheiral",
                        "latitude": "-22.51278000",
                        "longitude": "-44.00056000"
                    },
                    {
                        "id": 13910,
                        "name": "Piraí",
                        "latitude": "-22.62917000",
                        "longitude": "-43.89806000"
                    },
                    {
                        "id": 13984,
                        "name": "Porciúncula",
                        "latitude": "-20.96278000",
                        "longitude": "-42.04083000"
                    },
                    {
                        "id": 14013,
                        "name": "Porto Real",
                        "latitude": "-22.41972000",
                        "longitude": "-44.29028000"
                    },
                    {
                        "id": 14131,
                        "name": "Quatis",
                        "latitude": "-22.40722000",
                        "longitude": "-44.25806000"
                    },
                    {
                        "id": 14141,
                        "name": "Queimados",
                        "latitude": "-22.71611000",
                        "longitude": "-43.55528000"
                    },
                    {
                        "id": 14155,
                        "name": "Quissamã",
                        "latitude": "-22.09574000",
                        "longitude": "-41.39137000"
                    },
                    {
                        "id": 14197,
                        "name": "Resende",
                        "latitude": "-22.46889000",
                        "longitude": "-44.44667000"
                    },
                    {
                        "id": 14261,
                        "name": "Rio Bonito",
                        "latitude": "-22.74390000",
                        "longitude": "-42.61916000"
                    },
                    {
                        "id": 14270,
                        "name": "Rio Claro",
                        "latitude": "-22.77976000",
                        "longitude": "-44.07721000"
                    },
                    {
                        "id": 14305,
                        "name": "Rio das Flores",
                        "latitude": "-22.16104000",
                        "longitude": "-43.57579000"
                    },
                    {
                        "id": 14306,
                        "name": "Rio das Ostras",
                        "latitude": "-22.52694000",
                        "longitude": "-41.94500000"
                    },
                    {
                        "id": 14309,
                        "name": "Rio de Janeiro",
                        "latitude": "-22.92008000",
                        "longitude": "-43.33069000"
                    },
                    {
                        "id": 14504,
                        "name": "Santa Maria Madalena",
                        "latitude": "-21.95791000",
                        "longitude": "-41.90903000"
                    },
                    {
                        "id": 14620,
                        "name": "Santo Antônio de Pádua",
                        "latitude": "-21.57245000",
                        "longitude": "-42.21090000"
                    },
                    {
                        "id": 14878,
                        "name": "São Fidélis",
                        "latitude": "-21.64611000",
                        "longitude": "-41.74694000"
                    },
                    {
                        "id": 14886,
                        "name": "São Francisco de Itabapoana",
                        "latitude": "-21.38002000",
                        "longitude": "-41.14905000"
                    },
                    {
                        "id": 14916,
                        "name": "São Gonçalo",
                        "latitude": "-22.82694000",
                        "longitude": "-43.05389000"
                    },
                    {
                        "id": 15006,
                        "name": "São João da Barra",
                        "latitude": "-21.64028000",
                        "longitude": "-41.05111000"
                    },
                    {
                        "id": 15021,
                        "name": "São João de Meriti",
                        "latitude": "-22.80389000",
                        "longitude": "-43.37222000"
                    },
                    {
                        "id": 14958,
                        "name": "São José de Ubá",
                        "latitude": "-21.37831000",
                        "longitude": "-41.95256000"
                    },
                    {
                        "id": 14989,
                        "name": "São José do Vale do Rio Preto",
                        "latitude": "-22.17062000",
                        "longitude": "-42.91651000"
                    },
                    {
                        "id": 15105,
                        "name": "São Pedro",
                        "latitude": "-22.42313000",
                        "longitude": "-42.96612000"
                    },
                    {
                        "id": 15108,
                        "name": "São Pedro da Aldeia",
                        "latitude": "-22.83917000",
                        "longitude": "-42.10278000"
                    },
                    {
                        "id": 15143,
                        "name": "São Sebastião do Alto",
                        "latitude": "-21.86591000",
                        "longitude": "-42.09585000"
                    },
                    {
                        "id": 14662,
                        "name": "Sapucaia",
                        "latitude": "-22.04085000",
                        "longitude": "-42.81392000"
                    },
                    {
                        "id": 14666,
                        "name": "Saquarema",
                        "latitude": "-22.92000000",
                        "longitude": "-42.51028000"
                    },
                    {
                        "id": 14720,
                        "name": "Seropédica",
                        "latitude": "-22.73876000",
                        "longitude": "-43.70855000"
                    },
                    {
                        "id": 14775,
                        "name": "Silva Jardim",
                        "latitude": "-22.65083000",
                        "longitude": "-42.39167000"
                    },
                    {
                        "id": 14824,
                        "name": "Sumidouro",
                        "latitude": "-22.13179000",
                        "longitude": "-42.66127000"
                    },
                    {
                        "id": 15218,
                        "name": "Tanguá",
                        "latitude": "-22.79184000",
                        "longitude": "-42.71941000"
                    },
                    {
                        "id": 15286,
                        "name": "Teresópolis",
                        "latitude": "-22.31349000",
                        "longitude": "-42.87414000"
                    },
                    {
                        "id": 15350,
                        "name": "Trajano de Moraes",
                        "latitude": "-22.15204000",
                        "longitude": "-42.18834000"
                    },
                    {
                        "id": 15383,
                        "name": "Três Rios",
                        "latitude": "-22.12121000",
                        "longitude": "-43.06617000"
                    },
                    {
                        "id": 15500,
                        "name": "Valença",
                        "latitude": "-22.24020000",
                        "longitude": "-43.87843000"
                    },
                    {
                        "id": 15521,
                        "name": "Varre-Sai",
                        "latitude": "-20.89839000",
                        "longitude": "-41.81982000"
                    },
                    {
                        "id": 15524,
                        "name": "Vassouras",
                        "latitude": "-22.35995000",
                        "longitude": "-43.59809000"
                    },
                    {
                        "id": 15610,
                        "name": "Volta Redonda",
                        "latitude": "-22.52306000",
                        "longitude": "-44.10417000"
                    }
                ]
            },
            {
                "id": 2019,
                "name": "Rio Grande do Norte",
                "iso2": "RN",
                "latitude": "-5.40258030",
                "longitude": "-36.95410700",
                "type": "state",
                "cities": [
                    {
                        "id": 10072,
                        "name": "Acari",
                        "latitude": "-6.38547000",
                        "longitude": "-36.63908000"
                    },
                    {
                        "id": 10464,
                        "name": "Açu",
                        "latitude": "-5.57667000",
                        "longitude": "-36.90861000"
                    },
                    {
                        "id": 10086,
                        "name": "Afonso Bezerra",
                        "latitude": "-5.43183000",
                        "longitude": "-36.65619000"
                    },
                    {
                        "id": 15662,
                        "name": "Água Nova",
                        "latitude": "-6.21312000",
                        "longitude": "-38.30634000"
                    },
                    {
                        "id": 10128,
                        "name": "Alexandria",
                        "latitude": "-6.39998000",
                        "longitude": "-37.96862000"
                    },
                    {
                        "id": 10143,
                        "name": "Almino Afonso",
                        "latitude": "-6.16686000",
                        "longitude": "-37.77116000"
                    },
                    {
                        "id": 10185,
                        "name": "Alto do Rodrigues",
                        "latitude": "-5.34902000",
                        "longitude": "-36.79683000"
                    },
                    {
                        "id": 10256,
                        "name": "Angicos",
                        "latitude": "-5.67403000",
                        "longitude": "-36.54881000"
                    },
                    {
                        "id": 10278,
                        "name": "Antônio Martins",
                        "latitude": "-6.20609000",
                        "longitude": "-37.92136000"
                    },
                    {
                        "id": 10297,
                        "name": "Apodi",
                        "latitude": "-5.66690000",
                        "longitude": "-37.92339000"
                    },
                    {
                        "id": 10384,
                        "name": "Areia Branca",
                        "latitude": "-4.95611000",
                        "longitude": "-37.13694000"
                    },
                    {
                        "id": 10422,
                        "name": "Arês",
                        "latitude": "-6.19444000",
                        "longitude": "-35.16028000"
                    },
                    {
                        "id": 10445,
                        "name": "Augusto Severo",
                        "latitude": "-5.90516000",
                        "longitude": "-37.30121000"
                    },
                    {
                        "id": 10588,
                        "name": "Baía Formosa",
                        "latitude": "-6.43006000",
                        "longitude": "-35.05050000"
                    },
                    {
                        "id": 10506,
                        "name": "Baraúna",
                        "latitude": "-4.97189000",
                        "longitude": "-37.52234000"
                    },
                    {
                        "id": 10512,
                        "name": "Barcelona",
                        "latitude": "-5.94268000",
                        "longitude": "-35.92019000"
                    },
                    {
                        "id": 10628,
                        "name": "Bento Fernandes",
                        "latitude": "-5.63426000",
                        "longitude": "-35.81702000"
                    },
                    {
                        "id": 12565,
                        "name": "Boa Saúde",
                        "latitude": "-6.15714000",
                        "longitude": "-35.61758000"
                    },
                    {
                        "id": 10687,
                        "name": "Bodó",
                        "latitude": "-5.93390000",
                        "longitude": "-36.39716000"
                    },
                    {
                        "id": 10699,
                        "name": "Bom Jesus",
                        "latitude": "-6.00882000",
                        "longitude": "-35.58384000"
                    },
                    {
                        "id": 10785,
                        "name": "Brejinho",
                        "latitude": "-6.19083000",
                        "longitude": "-35.35667000"
                    },
                    {
                        "id": 10909,
                        "name": "Caiçara do Norte",
                        "latitude": "-5.17530000",
                        "longitude": "-36.08369000"
                    },
                    {
                        "id": 10910,
                        "name": "Caiçara do Rio do Vento",
                        "latitude": "-5.80605000",
                        "longitude": "-36.02549000"
                    },
                    {
                        "id": 10903,
                        "name": "Caicó",
                        "latitude": "-6.45833000",
                        "longitude": "-37.09778000"
                    },
                    {
                        "id": 11981,
                        "name": "Campo Grande",
                        "latitude": "-5.89722070",
                        "longitude": "-37.48004980"
                    },
                    {
                        "id": 11002,
                        "name": "Campo Redondo",
                        "latitude": "-6.24582000",
                        "longitude": "-36.21969000"
                    },
                    {
                        "id": 11042,
                        "name": "Canguaretama",
                        "latitude": "-6.38000000",
                        "longitude": "-35.12889000"
                    },
                    {
                        "id": 11117,
                        "name": "Caraúbas",
                        "latitude": "-5.79250000",
                        "longitude": "-37.55667000"
                    },
                    {
                        "id": 11158,
                        "name": "Carnaúba dos Dantas",
                        "latitude": "-6.56162000",
                        "longitude": "-36.52903000"
                    },
                    {
                        "id": 11154,
                        "name": "Carnaubais",
                        "latitude": "-5.26459000",
                        "longitude": "-36.79459000"
                    },
                    {
                        "id": 11226,
                        "name": "Ceará Mirim",
                        "latitude": "-5.63444000",
                        "longitude": "-35.42556000"
                    },
                    {
                        "id": 11227,
                        "name": "Ceará-Mirim",
                        "latitude": "-5.55046000",
                        "longitude": "-35.37667000"
                    },
                    {
                        "id": 11251,
                        "name": "Cerro Corá",
                        "latitude": "-6.04556000",
                        "longitude": "-36.34583000"
                    },
                    {
                        "id": 11418,
                        "name": "Coronel Ezequiel",
                        "latitude": "-6.31992000",
                        "longitude": "-36.22997000"
                    },
                    {
                        "id": 11422,
                        "name": "Coronel João Pessoa",
                        "latitude": "-6.26217000",
                        "longitude": "-38.41730000"
                    },
                    {
                        "id": 11501,
                        "name": "Cruzeta",
                        "latitude": "-6.32021000",
                        "longitude": "-36.84725000"
                    },
                    {
                        "id": 11528,
                        "name": "Currais Novos",
                        "latitude": "-6.21399000",
                        "longitude": "-36.48400000"
                    },
                    {
                        "id": 11659,
                        "name": "Doutor Severiano",
                        "latitude": "-6.11208000",
                        "longitude": "-38.39660000"
                    },
                    {
                        "id": 11695,
                        "name": "Encanto",
                        "latitude": "-6.11638000",
                        "longitude": "-38.31133000"
                    },
                    {
                        "id": 11714,
                        "name": "Equador",
                        "latitude": "-6.88585000",
                        "longitude": "-36.66174000"
                    },
                    {
                        "id": 11739,
                        "name": "Espírito Santo",
                        "latitude": "-6.28385000",
                        "longitude": "-35.32578000"
                    },
                    {
                        "id": 11768,
                        "name": "Extremoz",
                        "latitude": "-5.69421000",
                        "longitude": "-35.25248000"
                    },
                    {
                        "id": 11795,
                        "name": "Felipe Guerra",
                        "latitude": "-5.53917000",
                        "longitude": "-37.64271000"
                    },
                    {
                        "id": 11805,
                        "name": "Fernando Pedroza",
                        "latitude": "-5.72020000",
                        "longitude": "-36.39743000"
                    },
                    {
                        "id": 11844,
                        "name": "Florânia",
                        "latitude": "-6.15287000",
                        "longitude": "-36.80058000"
                    },
                    {
                        "id": 11880,
                        "name": "Francisco Dantas",
                        "latitude": "-6.01644000",
                        "longitude": "-38.12624000"
                    },
                    {
                        "id": 11903,
                        "name": "Frutuoso Gomes",
                        "latitude": "-6.16261000",
                        "longitude": "-37.84430000"
                    },
                    {
                        "id": 11913,
                        "name": "Galinhos",
                        "latitude": "-5.12167000",
                        "longitude": "-36.26313000"
                    },
                    {
                        "id": 11959,
                        "name": "Goianinha",
                        "latitude": "-6.26977000",
                        "longitude": "-35.18265000"
                    },
                    {
                        "id": 11980,
                        "name": "Governador Dix Sept Rosado",
                        "latitude": "-5.45889000",
                        "longitude": "-37.52083000"
                    },
                    {
                        "id": 12006,
                        "name": "Grossos",
                        "latitude": "-4.95242000",
                        "longitude": "-37.20023000"
                    },
                    {
                        "id": 12022,
                        "name": "Guamaré",
                        "latitude": "-5.13423000",
                        "longitude": "-36.31854000"
                    },
                    {
                        "id": 12175,
                        "name": "Ielmo Marinho",
                        "latitude": "-5.76778000",
                        "longitude": "-35.52812000"
                    },
                    {
                        "id": 12262,
                        "name": "Ipanguaçu",
                        "latitude": "-5.49833000",
                        "longitude": "-36.85500000"
                    },
                    {
                        "id": 12291,
                        "name": "Ipueira",
                        "latitude": "-6.78038000",
                        "longitude": "-37.14971000"
                    },
                    {
                        "id": 12372,
                        "name": "Itajá",
                        "latitude": "-5.69944000",
                        "longitude": "-36.79373000"
                    },
                    {
                        "id": 12468,
                        "name": "Itaú",
                        "latitude": "-5.84190000",
                        "longitude": "-37.92490000"
                    },
                    {
                        "id": 12607,
                        "name": "Jaçanã",
                        "latitude": "-6.41673000",
                        "longitude": "-36.19402000"
                    },
                    {
                        "id": 12558,
                        "name": "Jandaíra",
                        "latitude": "-5.37894000",
                        "longitude": "-36.09833000"
                    },
                    {
                        "id": 12561,
                        "name": "Janduís",
                        "latitude": "-5.93587000",
                        "longitude": "-37.51496000"
                    },
                    {
                        "id": 12570,
                        "name": "Japi",
                        "latitude": "-6.43798000",
                        "longitude": "-35.92194000"
                    },
                    {
                        "id": 12588,
                        "name": "Jardim de Angicos",
                        "latitude": "-5.63861000",
                        "longitude": "-35.95027000"
                    },
                    {
                        "id": 12589,
                        "name": "Jardim de Piranhas",
                        "latitude": "-6.37861000",
                        "longitude": "-37.35194000"
                    },
                    {
                        "id": 12591,
                        "name": "Jardim do Seridó",
                        "latitude": "-6.58444000",
                        "longitude": "-36.77444000"
                    },
                    {
                        "id": 12659,
                        "name": "João Câmara",
                        "latitude": "-5.56075000",
                        "longitude": "-35.81502000"
                    },
                    {
                        "id": 12660,
                        "name": "João Dias",
                        "latitude": "-6.28506000",
                        "longitude": "-37.79365000"
                    },
                    {
                        "id": 12654,
                        "name": "José da Penha",
                        "latitude": "-6.32865000",
                        "longitude": "-38.32030000"
                    },
                    {
                        "id": 12677,
                        "name": "Jucurutu",
                        "latitude": "-6.03389000",
                        "longitude": "-37.02028000"
                    },
                    {
                        "id": 12687,
                        "name": "Jundiá",
                        "latitude": "-6.25532000",
                        "longitude": "-35.34358000"
                    },
                    {
                        "id": 12748,
                        "name": "Lagoa d'Anta",
                        "latitude": "-6.37037000",
                        "longitude": "-35.63637000"
                    },
                    {
                        "id": 12754,
                        "name": "Lagoa de Pedras",
                        "latitude": "-6.16608000",
                        "longitude": "-35.45319000"
                    },
                    {
                        "id": 12756,
                        "name": "Lagoa de Velhos",
                        "latitude": "-6.00816000",
                        "longitude": "-35.82312000"
                    },
                    {
                        "id": 12741,
                        "name": "Lagoa Nova",
                        "latitude": "-6.11020000",
                        "longitude": "-36.54607000"
                    },
                    {
                        "id": 12743,
                        "name": "Lagoa Salgada",
                        "latitude": "-6.12321000",
                        "longitude": "-35.49513000"
                    },
                    {
                        "id": 12784,
                        "name": "Lajes",
                        "latitude": "-5.78338000",
                        "longitude": "-36.17286000"
                    },
                    {
                        "id": 12785,
                        "name": "Lajes Pintadas",
                        "latitude": "-6.12734000",
                        "longitude": "-36.12516000"
                    },
                    {
                        "id": 12861,
                        "name": "Lucrécia",
                        "latitude": "-6.10358000",
                        "longitude": "-37.82437000"
                    },
                    {
                        "id": 12882,
                        "name": "Luís Gomes",
                        "latitude": "-6.38626000",
                        "longitude": "-38.41895000"
                    },
                    {
                        "id": 12893,
                        "name": "Macaíba",
                        "latitude": "-5.94094000",
                        "longitude": "-35.39833000"
                    },
                    {
                        "id": 12890,
                        "name": "Macau",
                        "latitude": "-5.11500000",
                        "longitude": "-36.63444000"
                    },
                    {
                        "id": 12922,
                        "name": "Major Sales",
                        "latitude": "-6.40617000",
                        "longitude": "-38.30965000"
                    },
                    {
                        "id": 12992,
                        "name": "Marcelino Vieira",
                        "latitude": "-6.32176000",
                        "longitude": "-38.14275000"
                    },
                    {
                        "id": 13032,
                        "name": "Martins",
                        "latitude": "-6.09212000",
                        "longitude": "-37.92472000"
                    },
                    {
                        "id": 13086,
                        "name": "Maxaranguape",
                        "latitude": "-5.46874000",
                        "longitude": "-35.35657000"
                    },
                    {
                        "id": 13107,
                        "name": "Messias Targino",
                        "latitude": "-6.08097000",
                        "longitude": "-37.48508000"
                    },
                    {
                        "id": 13184,
                        "name": "Montanhas",
                        "latitude": "-6.48583000",
                        "longitude": "-35.28750000"
                    },
                    {
                        "id": 13186,
                        "name": "Monte Alegre",
                        "latitude": "-5.88972000",
                        "longitude": "-36.30139000"
                    },
                    {
                        "id": 13213,
                        "name": "Monte das Gameleiras",
                        "latitude": "-6.43448000",
                        "longitude": "-35.79888000"
                    },
                    {
                        "id": 13254,
                        "name": "Mossoró",
                        "latitude": "-5.18750000",
                        "longitude": "-37.34417000"
                    },
                    {
                        "id": 13299,
                        "name": "Natal",
                        "latitude": "-5.81010000",
                        "longitude": "-35.22674000"
                    },
                    {
                        "id": 13487,
                        "name": "Nísia Floresta",
                        "latitude": "-6.09111000",
                        "longitude": "-35.20861000"
                    },
                    {
                        "id": 13371,
                        "name": "Nova Cruz",
                        "latitude": "-6.46807000",
                        "longitude": "-35.45455000"
                    },
                    {
                        "id": 13500,
                        "name": "Olho-d'Água do Borges",
                        "latitude": "-5.99658000",
                        "longitude": "-37.73631000"
                    },
                    {
                        "id": 13538,
                        "name": "Ouro Branco",
                        "latitude": "-6.65601000",
                        "longitude": "-36.91455000"
                    },
                    {
                        "id": 13648,
                        "name": "Paraná",
                        "latitude": "-6.44702000",
                        "longitude": "-38.29980000"
                    },
                    {
                        "id": 13665,
                        "name": "Paraú",
                        "latitude": "-5.73216000",
                        "longitude": "-37.13664000"
                    },
                    {
                        "id": 13656,
                        "name": "Parazinho",
                        "latitude": "-5.27717000",
                        "longitude": "-35.93239000"
                    },
                    {
                        "id": 13670,
                        "name": "Parelhas",
                        "latitude": "-6.68778000",
                        "longitude": "-36.65750000"
                    },
                    {
                        "id": 13680,
                        "name": "Parnamirim",
                        "latitude": "-5.92446000",
                        "longitude": "-35.20566000"
                    },
                    {
                        "id": 13688,
                        "name": "Passa e Fica",
                        "latitude": "-6.45302000",
                        "longitude": "-35.62625000"
                    },
                    {
                        "id": 13691,
                        "name": "Passagem",
                        "latitude": "-6.27254000",
                        "longitude": "-35.39534000"
                    },
                    {
                        "id": 13712,
                        "name": "Patu",
                        "latitude": "-6.12305000",
                        "longitude": "-37.62573000"
                    },
                    {
                        "id": 13718,
                        "name": "Pau dos Ferros",
                        "latitude": "-6.11628000",
                        "longitude": "-38.19653000"
                    },
                    {
                        "id": 13753,
                        "name": "Pedra Grande",
                        "latitude": "-5.09384000",
                        "longitude": "-35.85092000"
                    },
                    {
                        "id": 13756,
                        "name": "Pedra Preta",
                        "latitude": "-5.52791000",
                        "longitude": "-36.07481000"
                    },
                    {
                        "id": 13774,
                        "name": "Pedro Avelino",
                        "latitude": "-5.44022000",
                        "longitude": "-36.34590000"
                    },
                    {
                        "id": 13783,
                        "name": "Pedro Velho",
                        "latitude": "-6.43917000",
                        "longitude": "-35.22139000"
                    },
                    {
                        "id": 13794,
                        "name": "Pendências",
                        "latitude": "-5.26000000",
                        "longitude": "-36.72222000"
                    },
                    {
                        "id": 13842,
                        "name": "Pilões",
                        "latitude": "-6.28833000",
                        "longitude": "-38.01911000"
                    },
                    {
                        "id": 14045,
                        "name": "Poço Branco",
                        "latitude": "-5.62278000",
                        "longitude": "-35.66278000"
                    },
                    {
                        "id": 13986,
                        "name": "Portalegre",
                        "latitude": "-6.00548000",
                        "longitude": "-38.00212000"
                    },
                    {
                        "id": 14027,
                        "name": "Porto do Mangue",
                        "latitude": "-5.07778000",
                        "longitude": "-36.78375000"
                    },
                    {
                        "id": 14116,
                        "name": "Pureza",
                        "latitude": "-5.42517000",
                        "longitude": "-35.59285000"
                    },
                    {
                        "id": 14165,
                        "name": "Rafael Fernandes",
                        "latitude": "-6.19713000",
                        "longitude": "-38.19794000"
                    },
                    {
                        "id": 14166,
                        "name": "Rafael Godeiro",
                        "latitude": "-6.04885000",
                        "longitude": "-37.73693000"
                    },
                    {
                        "id": 14211,
                        "name": "Riacho da Cruz",
                        "latitude": "-5.92628000",
                        "longitude": "-37.97556000"
                    },
                    {
                        "id": 14214,
                        "name": "Riacho de Santana",
                        "latitude": "-6.28279000",
                        "longitude": "-38.33135000"
                    },
                    {
                        "id": 14219,
                        "name": "Riachuelo",
                        "latitude": "-5.83598000",
                        "longitude": "-35.88131000"
                    },
                    {
                        "id": 14312,
                        "name": "Rio do Fogo",
                        "latitude": "-5.38232000",
                        "longitude": "-35.38379000"
                    },
                    {
                        "id": 14332,
                        "name": "Rodolfo Fernandes",
                        "latitude": "-5.85656000",
                        "longitude": "-38.09336000"
                    },
                    {
                        "id": 14365,
                        "name": "Ruy Barbosa",
                        "latitude": "-5.88561000",
                        "longitude": "-35.91551000"
                    },
                    {
                        "id": 14438,
                        "name": "Santa Cruz",
                        "latitude": "-6.22944000",
                        "longitude": "-36.02278000"
                    },
                    {
                        "id": 14503,
                        "name": "Santa Maria",
                        "latitude": "-5.84531000",
                        "longitude": "-35.71995000"
                    },
                    {
                        "id": 14588,
                        "name": "Santana do Matos",
                        "latitude": "-5.95750000",
                        "longitude": "-36.65556000"
                    },
                    {
                        "id": 14593,
                        "name": "Santana do Seridó",
                        "latitude": "-6.75207000",
                        "longitude": "-36.76599000"
                    },
                    {
                        "id": 14610,
                        "name": "Santo Antônio",
                        "latitude": "-6.31056000",
                        "longitude": "-35.47889000"
                    },
                    {
                        "id": 14838,
                        "name": "São Bento do Norte",
                        "latitude": "-5.14414000",
                        "longitude": "-35.98910000"
                    },
                    {
                        "id": 14842,
                        "name": "São Bento do Trairí",
                        "latitude": "-6.39968000",
                        "longitude": "-36.05920000"
                    },
                    {
                        "id": 14877,
                        "name": "São Fernando",
                        "latitude": "-6.29726000",
                        "longitude": "-37.13895000"
                    },
                    {
                        "id": 14895,
                        "name": "São Francisco do Oeste",
                        "latitude": "-5.96836000",
                        "longitude": "-38.16251000"
                    },
                    {
                        "id": 14919,
                        "name": "São Gonçalo do Amarante",
                        "latitude": "-5.77241000",
                        "longitude": "-35.33245000"
                    },
                    {
                        "id": 15043,
                        "name": "São João do Sabugi",
                        "latitude": "-6.69650000",
                        "longitude": "-37.15433000"
                    },
                    {
                        "id": 14954,
                        "name": "São José de Mipibu",
                        "latitude": "-6.04284000",
                        "longitude": "-35.30608000"
                    },
                    {
                        "id": 14965,
                        "name": "São José do Campestre",
                        "latitude": "-6.31556000",
                        "longitude": "-35.71389000"
                    },
                    {
                        "id": 14987,
                        "name": "São José do Seridó",
                        "latitude": "-6.50251000",
                        "longitude": "-36.85104000"
                    },
                    {
                        "id": 15078,
                        "name": "São Miguel",
                        "latitude": "-5.46667000",
                        "longitude": "-35.36667000"
                    },
                    {
                        "id": 15089,
                        "name": "São Miguel do Gostoso",
                        "latitude": "-5.18658000",
                        "longitude": "-35.71303000"
                    },
                    {
                        "id": 15104,
                        "name": "São Paulo do Potengi",
                        "latitude": "-5.88988000",
                        "longitude": "-35.75325000"
                    },
                    {
                        "id": 15107,
                        "name": "São Pedro",
                        "latitude": "-5.85598000",
                        "longitude": "-35.62554000"
                    },
                    {
                        "id": 15125,
                        "name": "São Rafael",
                        "latitude": "-5.85664000",
                        "longitude": "-36.89520000"
                    },
                    {
                        "id": 15161,
                        "name": "São Tomé",
                        "latitude": "-5.97250000",
                        "longitude": "-36.07528000"
                    },
                    {
                        "id": 15169,
                        "name": "São Vicente",
                        "latitude": "-6.22380000",
                        "longitude": "-36.65694000"
                    },
                    {
                        "id": 14697,
                        "name": "Senador Elói de Souza",
                        "latitude": "-6.04008000",
                        "longitude": "-35.65731000"
                    },
                    {
                        "id": 14699,
                        "name": "Senador Georgino Avelino",
                        "latitude": "-6.14835000",
                        "longitude": "-35.13347000"
                    },
                    {
                        "id": 14726,
                        "name": "Serra Caiada",
                        "latitude": "-6.14234000",
                        "longitude": "-35.66845000"
                    },
                    {
                        "id": 14737,
                        "name": "Serra de São Bento",
                        "latitude": "-6.43702000",
                        "longitude": "-35.71194000"
                    },
                    {
                        "id": 14738,
                        "name": "Serra do Mel",
                        "latitude": "-5.12203000",
                        "longitude": "-37.03121000"
                    },
                    {
                        "id": 14730,
                        "name": "Serra Negra do Norte",
                        "latitude": "-6.57598000",
                        "longitude": "-37.39418000"
                    },
                    {
                        "id": 14752,
                        "name": "Serrinha",
                        "latitude": "-6.25327000",
                        "longitude": "-35.59475000"
                    },
                    {
                        "id": 14753,
                        "name": "Serrinha dos Pintos",
                        "latitude": "-6.15256000",
                        "longitude": "-37.98860000"
                    },
                    {
                        "id": 14769,
                        "name": "Severiano Melo",
                        "latitude": "-5.77722000",
                        "longitude": "-37.95778000"
                    },
                    {
                        "id": 15177,
                        "name": "Sítio Novo",
                        "latitude": "-6.12604000",
                        "longitude": "-35.97108000"
                    },
                    {
                        "id": 15189,
                        "name": "Taboleiro Grande",
                        "latitude": "-5.92608000",
                        "longitude": "-38.05352000"
                    },
                    {
                        "id": 15204,
                        "name": "Taipu",
                        "latitude": "-5.51936000",
                        "longitude": "-35.58130000"
                    },
                    {
                        "id": 15215,
                        "name": "Tangará",
                        "latitude": "-6.23847000",
                        "longitude": "-35.79625000"
                    },
                    {
                        "id": 15274,
                        "name": "Tenente Ananias",
                        "latitude": "-6.46946000",
                        "longitude": "-38.16177000"
                    },
                    {
                        "id": 15275,
                        "name": "Tenente Laurentino Cruz",
                        "latitude": "-6.14845000",
                        "longitude": "-36.72240000"
                    },
                    {
                        "id": 15305,
                        "name": "Tibau",
                        "latitude": "-4.91150000",
                        "longitude": "-37.31347000"
                    },
                    {
                        "id": 15306,
                        "name": "Tibau do Sul",
                        "latitude": "-6.18641000",
                        "longitude": "-35.09050000"
                    },
                    {
                        "id": 15312,
                        "name": "Timbaúba dos Batistas",
                        "latitude": "-6.48262000",
                        "longitude": "-37.23278000"
                    },
                    {
                        "id": 15343,
                        "name": "Touros",
                        "latitude": "-5.26111000",
                        "longitude": "-35.60459000"
                    },
                    {
                        "id": 15365,
                        "name": "Triunfo Potiguar",
                        "latitude": "-5.94356000",
                        "longitude": "-37.13994000"
                    },
                    {
                        "id": 15445,
                        "name": "Umarizal",
                        "latitude": "-6.00593000",
                        "longitude": "-37.80698000"
                    },
                    {
                        "id": 15464,
                        "name": "Upanema",
                        "latitude": "-5.69921000",
                        "longitude": "-37.26798000"
                    },
                    {
                        "id": 15614,
                        "name": "Várzea",
                        "latitude": "-6.35146000",
                        "longitude": "-35.36839000"
                    },
                    {
                        "id": 15527,
                        "name": "Venha-Ver",
                        "latitude": "-6.34075000",
                        "longitude": "-38.53731000"
                    },
                    {
                        "id": 15532,
                        "name": "Vera Cruz",
                        "latitude": "-6.03261000",
                        "longitude": "-35.44416000"
                    },
                    {
                        "id": 15605,
                        "name": "Viçosa",
                        "latitude": "-5.99110000",
                        "longitude": "-37.96495000"
                    },
                    {
                        "id": 15567,
                        "name": "Vila Flor",
                        "latitude": "-6.29375000",
                        "longitude": "-35.08453000"
                    }
                ]
            },
            {
                "id": 2001,
                "name": "Rio Grande do Sul",
                "iso2": "RS",
                "latitude": "-30.03463160",
                "longitude": "-51.21769860",
                "type": "state",
                "cities": [
                    {
                        "id": 10075,
                        "name": "Aceguá",
                        "latitude": "-31.64597000",
                        "longitude": "-54.10715000"
                    },
                    {
                        "id": 15664,
                        "name": "Água Santa",
                        "latitude": "-28.18543000",
                        "longitude": "-52.01286000"
                    },
                    {
                        "id": 10097,
                        "name": "Agudo",
                        "latitude": "-29.62631000",
                        "longitude": "-53.22404000"
                    },
                    {
                        "id": 10106,
                        "name": "Ajuricaba",
                        "latitude": "-28.20723000",
                        "longitude": "-53.74458000"
                    },
                    {
                        "id": 10122,
                        "name": "Alecrim",
                        "latitude": "-27.65897000",
                        "longitude": "-54.75943000"
                    },
                    {
                        "id": 10124,
                        "name": "Alegrete",
                        "latitude": "-29.78306000",
                        "longitude": "-55.79194000"
                    },
                    {
                        "id": 10126,
                        "name": "Alegria",
                        "latitude": "-27.79967000",
                        "longitude": "-54.05855000"
                    },
                    {
                        "id": 10145,
                        "name": "Almirante Tamandaré do Sul",
                        "latitude": "-28.15104000",
                        "longitude": "-52.91142000"
                    },
                    {
                        "id": 10148,
                        "name": "Alpestre",
                        "latitude": "-27.22135000",
                        "longitude": "-53.05749000"
                    },
                    {
                        "id": 10161,
                        "name": "Alto Alegre",
                        "latitude": "-28.79752000",
                        "longitude": "-52.98177000"
                    },
                    {
                        "id": 10169,
                        "name": "Alto Feliz",
                        "latitude": "-29.36438000",
                        "longitude": "-51.30068000"
                    },
                    {
                        "id": 10195,
                        "name": "Alvorada",
                        "latitude": "-29.98897000",
                        "longitude": "-51.03717000"
                    },
                    {
                        "id": 10207,
                        "name": "Amaral Ferrador",
                        "latitude": "-30.80769000",
                        "longitude": "-52.29964000"
                    },
                    {
                        "id": 10215,
                        "name": "Ametista do Sul",
                        "latitude": "-27.36698000",
                        "longitude": "-53.18701000"
                    },
                    {
                        "id": 10248,
                        "name": "André da Rocha",
                        "latitude": "-28.58832000",
                        "longitude": "-51.49976000"
                    },
                    {
                        "id": 10267,
                        "name": "Anta Gorda",
                        "latitude": "-28.96836000",
                        "longitude": "-51.97107000"
                    },
                    {
                        "id": 10280,
                        "name": "Antônio Prado",
                        "latitude": "-28.87322000",
                        "longitude": "-51.31744000"
                    },
                    {
                        "id": 10331,
                        "name": "Arambaré",
                        "latitude": "-30.91331000",
                        "longitude": "-51.55614000"
                    },
                    {
                        "id": 10353,
                        "name": "Araricá",
                        "latitude": "-29.64987000",
                        "longitude": "-50.93350000"
                    },
                    {
                        "id": 10360,
                        "name": "Aratiba",
                        "latitude": "-27.37708000",
                        "longitude": "-52.29009000"
                    },
                    {
                        "id": 10412,
                        "name": "Arroio do Meio",
                        "latitude": "-29.40111000",
                        "longitude": "-51.94500000"
                    },
                    {
                        "id": 10413,
                        "name": "Arroio do Padre",
                        "latitude": "-31.43927000",
                        "longitude": "-52.39642000"
                    },
                    {
                        "id": 10414,
                        "name": "Arroio do Sal",
                        "latitude": "-29.52930000",
                        "longitude": "-49.89148000"
                    },
                    {
                        "id": 10415,
                        "name": "Arroio do Tigre",
                        "latitude": "-29.26209000",
                        "longitude": "-53.06060000"
                    },
                    {
                        "id": 10416,
                        "name": "Arroio dos Ratos",
                        "latitude": "-30.07722000",
                        "longitude": "-51.72917000"
                    },
                    {
                        "id": 10410,
                        "name": "Arroio Grande",
                        "latitude": "-32.17945000",
                        "longitude": "-52.86652000"
                    },
                    {
                        "id": 10421,
                        "name": "Arvorezinha",
                        "latitude": "-28.86971000",
                        "longitude": "-52.19631000"
                    },
                    {
                        "id": 10444,
                        "name": "Augusto Pestana",
                        "latitude": "-28.54034000",
                        "longitude": "-53.97927000"
                    },
                    {
                        "id": 15680,
                        "name": "Áurea",
                        "latitude": "-27.69538000",
                        "longitude": "-52.06560000"
                    },
                    {
                        "id": 10474,
                        "name": "Bagé",
                        "latitude": "-31.33139000",
                        "longitude": "-54.10694000"
                    },
                    {
                        "id": 10488,
                        "name": "Balneário Pinhal",
                        "latitude": "-30.21275000",
                        "longitude": "-50.29309000"
                    },
                    {
                        "id": 10570,
                        "name": "Barão",
                        "latitude": "-29.39636000",
                        "longitude": "-51.54620000"
                    },
                    {
                        "id": 10573,
                        "name": "Barão de Cotegipe",
                        "latitude": "-27.55108000",
                        "longitude": "-52.44751000"
                    },
                    {
                        "id": 10577,
                        "name": "Barão do Triunfo",
                        "latitude": "-30.39257000",
                        "longitude": "-51.79493000"
                    },
                    {
                        "id": 10536,
                        "name": "Barra do Guarita",
                        "latitude": "-27.21739000",
                        "longitude": "-53.76461000"
                    },
                    {
                        "id": 10541,
                        "name": "Barra do Quaraí",
                        "latitude": "-30.17445000",
                        "longitude": "-57.31007000"
                    },
                    {
                        "id": 10542,
                        "name": "Barra do Ribeiro",
                        "latitude": "-30.34435000",
                        "longitude": "-51.36125000"
                    },
                    {
                        "id": 10543,
                        "name": "Barra do Rio Azul",
                        "latitude": "-27.39848000",
                        "longitude": "-52.40887000"
                    },
                    {
                        "id": 10518,
                        "name": "Barra Funda",
                        "latitude": "-27.91562000",
                        "longitude": "-53.03286000"
                    },
                    {
                        "id": 10548,
                        "name": "Barracão",
                        "latitude": "-27.73726000",
                        "longitude": "-51.44229000"
                    },
                    {
                        "id": 10567,
                        "name": "Barros Cassal",
                        "latitude": "-29.13534000",
                        "longitude": "-52.57508000"
                    },
                    {
                        "id": 10627,
                        "name": "Benjamin Constant do Sul",
                        "latitude": "-27.48726000",
                        "longitude": "-52.65470000"
                    },
                    {
                        "id": 10629,
                        "name": "Bento Gonçalves",
                        "latitude": "-29.09958000",
                        "longitude": "-51.54344000"
                    },
                    {
                        "id": 10669,
                        "name": "Boa Vista das Missões",
                        "latitude": "-27.69239000",
                        "longitude": "-53.35253000"
                    },
                    {
                        "id": 10670,
                        "name": "Boa Vista do Buricá",
                        "latitude": "-27.68021000",
                        "longitude": "-54.10928000"
                    },
                    {
                        "id": 10671,
                        "name": "Boa Vista do Cadeado",
                        "latitude": "-28.62211000",
                        "longitude": "-53.81616000"
                    },
                    {
                        "id": 10673,
                        "name": "Boa Vista do Incra",
                        "latitude": "-28.84193000",
                        "longitude": "-53.45649000"
                    },
                    {
                        "id": 10675,
                        "name": "Boa Vista do Sul",
                        "latitude": "-29.34197000",
                        "longitude": "-51.68079000"
                    },
                    {
                        "id": 10701,
                        "name": "Bom Jesus",
                        "latitude": "-28.59981000",
                        "longitude": "-50.46197000"
                    },
                    {
                        "id": 10719,
                        "name": "Bom Princípio",
                        "latitude": "-29.46171000",
                        "longitude": "-51.36405000"
                    },
                    {
                        "id": 10721,
                        "name": "Bom Progresso",
                        "latitude": "-27.54223000",
                        "longitude": "-53.82889000"
                    },
                    {
                        "id": 10724,
                        "name": "Bom Retiro do Sul",
                        "latitude": "-29.63558000",
                        "longitude": "-51.91097000"
                    },
                    {
                        "id": 10744,
                        "name": "Boqueirão do Leão",
                        "latitude": "-29.31252000",
                        "longitude": "-52.39841000"
                    },
                    {
                        "id": 10756,
                        "name": "Bossoroca",
                        "latitude": "-28.67113000",
                        "longitude": "-54.96188000"
                    },
                    {
                        "id": 10762,
                        "name": "Bozano",
                        "latitude": "-28.36580000",
                        "longitude": "-53.76893000"
                    },
                    {
                        "id": 10763,
                        "name": "Braga",
                        "latitude": "-27.57218000",
                        "longitude": "-53.76214000"
                    },
                    {
                        "id": 10804,
                        "name": "Brochier",
                        "latitude": "-29.55754000",
                        "longitude": "-51.59193000"
                    },
                    {
                        "id": 10838,
                        "name": "Butiá",
                        "latitude": "-30.11972000",
                        "longitude": "-51.96222000"
                    },
                    {
                        "id": 11223,
                        "name": "Caçapava do Sul",
                        "latitude": "-30.61002000",
                        "longitude": "-53.47227000"
                    },
                    {
                        "id": 10860,
                        "name": "Cacequi",
                        "latitude": "-29.88361000",
                        "longitude": "-54.82500000"
                    },
                    {
                        "id": 10873,
                        "name": "Cachoeira do Sul",
                        "latitude": "-30.20808000",
                        "longitude": "-52.97067000"
                    },
                    {
                        "id": 10877,
                        "name": "Cachoeirinha",
                        "latitude": "-29.95111000",
                        "longitude": "-51.09389000"
                    },
                    {
                        "id": 10884,
                        "name": "Cacique Doble",
                        "latitude": "-27.81730000",
                        "longitude": "-51.68271000"
                    },
                    {
                        "id": 10901,
                        "name": "Caibaté",
                        "latitude": "-28.30429000",
                        "longitude": "-54.65585000"
                    },
                    {
                        "id": 10908,
                        "name": "Caiçara",
                        "latitude": "-27.24828000",
                        "longitude": "-53.45824000"
                    },
                    {
                        "id": 10940,
                        "name": "Camaquã",
                        "latitude": "-30.91965000",
                        "longitude": "-51.85302000"
                    },
                    {
                        "id": 10942,
                        "name": "Camargo",
                        "latitude": "-28.61437000",
                        "longitude": "-52.21986000"
                    },
                    {
                        "id": 10945,
                        "name": "Cambará do Sul",
                        "latitude": "-29.06727000",
                        "longitude": "-50.11848000"
                    },
                    {
                        "id": 10959,
                        "name": "Campestre da Serra",
                        "latitude": "-28.70645000",
                        "longitude": "-51.11921000"
                    },
                    {
                        "id": 10966,
                        "name": "Campina das Missões",
                        "latitude": "-27.98729000",
                        "longitude": "-54.83020000"
                    },
                    {
                        "id": 10972,
                        "name": "Campinas do Sul",
                        "latitude": "-27.70629000",
                        "longitude": "-52.63937000"
                    },
                    {
                        "id": 10984,
                        "name": "Campo Bom",
                        "latitude": "-29.66716000",
                        "longitude": "-51.05054000"
                    },
                    {
                        "id": 10999,
                        "name": "Campo Novo",
                        "latitude": "-27.67313000",
                        "longitude": "-53.81745000"
                    },
                    {
                        "id": 11010,
                        "name": "Campos Borges",
                        "latitude": "-28.89387000",
                        "longitude": "-53.02543000"
                    },
                    {
                        "id": 11036,
                        "name": "Candelária",
                        "latitude": "-29.71623000",
                        "longitude": "-52.80968000"
                    },
                    {
                        "id": 11545,
                        "name": "Cândido Godói",
                        "latitude": "-27.89509000",
                        "longitude": "-54.74128000"
                    },
                    {
                        "id": 11038,
                        "name": "Candiota",
                        "latitude": "-31.49089000",
                        "longitude": "-53.70274000"
                    },
                    {
                        "id": 11040,
                        "name": "Canela",
                        "latitude": "-29.34715000",
                        "longitude": "-50.77536000"
                    },
                    {
                        "id": 11043,
                        "name": "Canguçu",
                        "latitude": "-31.39500000",
                        "longitude": "-52.67556000"
                    },
                    {
                        "id": 11049,
                        "name": "Canoas",
                        "latitude": "-29.91778000",
                        "longitude": "-51.18361000"
                    },
                    {
                        "id": 11058,
                        "name": "Canudos do Vale",
                        "latitude": "-29.32055000",
                        "longitude": "-52.22476000"
                    },
                    {
                        "id": 11097,
                        "name": "Capão Bonito do Sul",
                        "latitude": "-28.17432000",
                        "longitude": "-51.42298000"
                    },
                    {
                        "id": 11098,
                        "name": "Capão da Canoa",
                        "latitude": "-29.66118000",
                        "longitude": "-50.01422000"
                    },
                    {
                        "id": 11099,
                        "name": "Capão do Cipó",
                        "latitude": "-28.94987000",
                        "longitude": "-54.60368000"
                    },
                    {
                        "id": 11100,
                        "name": "Capão do Leão",
                        "latitude": "-31.84324000",
                        "longitude": "-52.55323000"
                    },
                    {
                        "id": 11068,
                        "name": "Capela de Santana",
                        "latitude": "-29.71236000",
                        "longitude": "-51.38078000"
                    },
                    {
                        "id": 11080,
                        "name": "Capitão",
                        "latitude": "-29.28020000",
                        "longitude": "-51.98317000"
                    },
                    {
                        "id": 11090,
                        "name": "Capivari do Sul",
                        "latitude": "-30.17289000",
                        "longitude": "-50.48702000"
                    },
                    {
                        "id": 11114,
                        "name": "Caraá",
                        "latitude": "-29.77397000",
                        "longitude": "-50.35369000"
                    },
                    {
                        "id": 11113,
                        "name": "Carazinho",
                        "latitude": "-28.28389000",
                        "longitude": "-52.78639000"
                    },
                    {
                        "id": 11138,
                        "name": "Carlos Barbosa",
                        "latitude": "-29.29750000",
                        "longitude": "-51.50361000"
                    },
                    {
                        "id": 11140,
                        "name": "Carlos Gomes",
                        "latitude": "-27.71183000",
                        "longitude": "-51.90645000"
                    },
                    {
                        "id": 11174,
                        "name": "Casca",
                        "latitude": "-28.57590000",
                        "longitude": "-51.91980000"
                    },
                    {
                        "id": 11179,
                        "name": "Caseiros",
                        "latitude": "-28.23222000",
                        "longitude": "-51.78157000"
                    },
                    {
                        "id": 11213,
                        "name": "Catuípe",
                        "latitude": "-28.19806000",
                        "longitude": "-54.05868000"
                    },
                    {
                        "id": 11219,
                        "name": "Caxias do Sul",
                        "latitude": "-29.16806000",
                        "longitude": "-51.17944000"
                    },
                    {
                        "id": 11236,
                        "name": "Centenário",
                        "latitude": "-27.78654000",
                        "longitude": "-52.00905000"
                    },
                    {
                        "id": 11248,
                        "name": "Cerrito",
                        "latitude": "-31.73952000",
                        "longitude": "-52.78378000"
                    },
                    {
                        "id": 11250,
                        "name": "Cerro Branco",
                        "latitude": "-29.63374000",
                        "longitude": "-52.98725000"
                    },
                    {
                        "id": 11252,
                        "name": "Cerro Grande",
                        "latitude": "-27.62261000",
                        "longitude": "-53.16028000"
                    },
                    {
                        "id": 11253,
                        "name": "Cerro Grande do Sul",
                        "latitude": "-30.58623000",
                        "longitude": "-51.74239000"
                    },
                    {
                        "id": 11254,
                        "name": "Cerro Largo",
                        "latitude": "-28.13490000",
                        "longitude": "-54.73667000"
                    },
                    {
                        "id": 11259,
                        "name": "Chapada",
                        "latitude": "-28.10434000",
                        "longitude": "-53.08861000"
                    },
                    {
                        "id": 11271,
                        "name": "Charqueadas",
                        "latitude": "-29.95472000",
                        "longitude": "-51.62528000"
                    },
                    {
                        "id": 11272,
                        "name": "Charrua",
                        "latitude": "-27.94543000",
                        "longitude": "-51.99053000"
                    },
                    {
                        "id": 11277,
                        "name": "Chiapetta",
                        "latitude": "-27.97630000",
                        "longitude": "-53.92051000"
                    },
                    {
                        "id": 11284,
                        "name": "Chuí",
                        "latitude": "-33.69111000",
                        "longitude": "-53.45667000"
                    },
                    {
                        "id": 11283,
                        "name": "Chuvisca",
                        "latitude": "-30.77649000",
                        "longitude": "-52.00221000"
                    },
                    {
                        "id": 11293,
                        "name": "Cidreira",
                        "latitude": "-30.09103000",
                        "longitude": "-50.26938000"
                    },
                    {
                        "id": 11296,
                        "name": "Ciríaco",
                        "latitude": "-28.37066000",
                        "longitude": "-51.91242000"
                    },
                    {
                        "id": 11323,
                        "name": "Colinas",
                        "latitude": "-29.39282000",
                        "longitude": "-51.86831000"
                    },
                    {
                        "id": 11330,
                        "name": "Colorado",
                        "latitude": "-28.48320000",
                        "longitude": "-52.99088000"
                    },
                    {
                        "id": 11374,
                        "name": "Condor",
                        "latitude": "-28.19261000",
                        "longitude": "-53.49261000"
                    },
                    {
                        "id": 11388,
                        "name": "Constantina",
                        "latitude": "-27.70625000",
                        "longitude": "-53.00221000"
                    },
                    {
                        "id": 11393,
                        "name": "Coqueiro Baixo",
                        "latitude": "-29.17479000",
                        "longitude": "-52.10209000"
                    },
                    {
                        "id": 11395,
                        "name": "Coqueiros do Sul",
                        "latitude": "-28.13683000",
                        "longitude": "-52.76136000"
                    },
                    {
                        "id": 11415,
                        "name": "Coronel Barros",
                        "latitude": "-28.39445000",
                        "longitude": "-54.06367000"
                    },
                    {
                        "id": 11416,
                        "name": "Coronel Bicaco",
                        "latitude": "-27.79949000",
                        "longitude": "-53.65310000"
                    },
                    {
                        "id": 11428,
                        "name": "Coronel Pilar",
                        "latitude": "-29.25977000",
                        "longitude": "-51.71821000"
                    },
                    {
                        "id": 11453,
                        "name": "Cotiporã",
                        "latitude": "-29.00719000",
                        "longitude": "-51.69528000"
                    },
                    {
                        "id": 11457,
                        "name": "Coxilha",
                        "latitude": "-28.10327000",
                        "longitude": "-52.36576000"
                    },
                    {
                        "id": 11466,
                        "name": "Crissiumal",
                        "latitude": "-27.48087000",
                        "longitude": "-54.14173000"
                    },
                    {
                        "id": 11469,
                        "name": "Cristal",
                        "latitude": "-31.02454000",
                        "longitude": "-52.02929000"
                    },
                    {
                        "id": 11470,
                        "name": "Cristal do Sul",
                        "latitude": "-27.42515000",
                        "longitude": "-53.24362000"
                    },
                    {
                        "id": 11489,
                        "name": "Cruz Alta",
                        "latitude": "-28.64397000",
                        "longitude": "-53.60633000"
                    },
                    {
                        "id": 11493,
                        "name": "Cruzaltense",
                        "latitude": "-27.64105000",
                        "longitude": "-52.63264000"
                    },
                    {
                        "id": 11500,
                        "name": "Cruzeiro do Sul",
                        "latitude": "-29.56709000",
                        "longitude": "-52.03042000"
                    },
                    {
                        "id": 11564,
                        "name": "David Canabarro",
                        "latitude": "-28.41776000",
                        "longitude": "-51.81680000"
                    },
                    {
                        "id": 11575,
                        "name": "Derrubadas",
                        "latitude": "-27.25025000",
                        "longitude": "-53.88415000"
                    },
                    {
                        "id": 11582,
                        "name": "Dezesseis de Novembro",
                        "latitude": "-28.19125000",
                        "longitude": "-55.07548000"
                    },
                    {
                        "id": 11592,
                        "name": "Dilermando de Aguiar",
                        "latitude": "-29.80603000",
                        "longitude": "-54.15398000"
                    },
                    {
                        "id": 11614,
                        "name": "Dois Irmãos",
                        "latitude": "-29.61158000",
                        "longitude": "-51.09333000"
                    },
                    {
                        "id": 11615,
                        "name": "Dois Irmãos das Missões",
                        "latitude": "-27.68117000",
                        "longitude": "-53.51477000"
                    },
                    {
                        "id": 11618,
                        "name": "Dois Lajeados",
                        "latitude": "-28.97092000",
                        "longitude": "-51.84970000"
                    },
                    {
                        "id": 11628,
                        "name": "Dom Feliciano",
                        "latitude": "-30.61390000",
                        "longitude": "-52.19315000"
                    },
                    {
                        "id": 11632,
                        "name": "Dom Pedrito",
                        "latitude": "-30.98278000",
                        "longitude": "-54.67306000"
                    },
                    {
                        "id": 11634,
                        "name": "Dom Pedro de Alcântara",
                        "latitude": "-29.35681000",
                        "longitude": "-49.87288000"
                    },
                    {
                        "id": 11641,
                        "name": "Dona Francisca",
                        "latitude": "-29.58683000",
                        "longitude": "-53.33964000"
                    },
                    {
                        "id": 11656,
                        "name": "Doutor Maurício Cardoso",
                        "latitude": "-27.49540000",
                        "longitude": "-54.36400000"
                    },
                    {
                        "id": 11658,
                        "name": "Doutor Ricardo",
                        "latitude": "-29.10117000",
                        "longitude": "-51.97440000"
                    },
                    {
                        "id": 11680,
                        "name": "Eldorado do Sul",
                        "latitude": "-30.08896000",
                        "longitude": "-51.53400000"
                    },
                    {
                        "id": 11694,
                        "name": "Encantado",
                        "latitude": "-29.23611000",
                        "longitude": "-51.86972000"
                    },
                    {
                        "id": 11697,
                        "name": "Encruzilhada do Sul",
                        "latitude": "-30.60368000",
                        "longitude": "-52.68280000"
                    },
                    {
                        "id": 11703,
                        "name": "Engenho Velho",
                        "latitude": "-27.67698000",
                        "longitude": "-52.91040000"
                    },
                    {
                        "id": 11709,
                        "name": "Entre Rios do Sul",
                        "latitude": "-27.50821000",
                        "longitude": "-52.72855000"
                    },
                    {
                        "id": 11710,
                        "name": "Entre-Ijuís",
                        "latitude": "-28.46066000",
                        "longitude": "-54.30321000"
                    },
                    {
                        "id": 11715,
                        "name": "Erebango",
                        "latitude": "-27.82558000",
                        "longitude": "-52.31909000"
                    },
                    {
                        "id": 11716,
                        "name": "Erechim",
                        "latitude": "-27.63461000",
                        "longitude": "-52.27540000"
                    },
                    {
                        "id": 11719,
                        "name": "Ernestina",
                        "latitude": "-28.42323000",
                        "longitude": "-52.57365000"
                    },
                    {
                        "id": 11720,
                        "name": "Erval Grande",
                        "latitude": "-27.36138000",
                        "longitude": "-52.57486000"
                    },
                    {
                        "id": 11721,
                        "name": "Erval Seco",
                        "latitude": "-27.49433000",
                        "longitude": "-53.52792000"
                    },
                    {
                        "id": 11725,
                        "name": "Esmeralda",
                        "latitude": "-27.98347000",
                        "longitude": "-51.19413000"
                    },
                    {
                        "id": 11733,
                        "name": "Esperança do Sul",
                        "latitude": "-27.32100000",
                        "longitude": "-54.01108000"
                    },
                    {
                        "id": 11738,
                        "name": "Espumoso",
                        "latitude": "-28.72472000",
                        "longitude": "-52.84972000"
                    },
                    {
                        "id": 11743,
                        "name": "Estação",
                        "latitude": "-27.93562000",
                        "longitude": "-52.29516000"
                    },
                    {
                        "id": 11758,
                        "name": "Estância Velha",
                        "latitude": "-29.64833000",
                        "longitude": "-51.17389000"
                    },
                    {
                        "id": 11744,
                        "name": "Esteio",
                        "latitude": "-29.86139000",
                        "longitude": "-51.17917000"
                    },
                    {
                        "id": 11748,
                        "name": "Estrela",
                        "latitude": "-28.06111000",
                        "longitude": "-50.93833000"
                    },
                    {
                        "id": 11750,
                        "name": "Estrela Velha",
                        "latitude": "-29.22360000",
                        "longitude": "-53.17076000"
                    },
                    {
                        "id": 11762,
                        "name": "Eugênio de Castro",
                        "latitude": "-28.57179000",
                        "longitude": "-54.26582000"
                    },
                    {
                        "id": 11771,
                        "name": "Fagundes Varela",
                        "latitude": "-28.88133000",
                        "longitude": "-51.72861000"
                    },
                    {
                        "id": 11778,
                        "name": "Farroupilha",
                        "latitude": "-29.22500000",
                        "longitude": "-51.34778000"
                    },
                    {
                        "id": 11782,
                        "name": "Faxinal do Soturno",
                        "latitude": "-29.57197000",
                        "longitude": "-53.47332000"
                    },
                    {
                        "id": 11784,
                        "name": "Faxinalzinho",
                        "latitude": "-27.37178000",
                        "longitude": "-52.66899000"
                    },
                    {
                        "id": 11787,
                        "name": "Fazenda Vilanova",
                        "latitude": "-29.59817000",
                        "longitude": "-51.84244000"
                    },
                    {
                        "id": 11798,
                        "name": "Feliz",
                        "latitude": "-29.45459000",
                        "longitude": "-51.27775000"
                    },
                    {
                        "id": 11831,
                        "name": "Flores da Cunha",
                        "latitude": "-29.02889000",
                        "longitude": "-51.18167000"
                    },
                    {
                        "id": 11842,
                        "name": "Floriano Peixoto",
                        "latitude": "-27.85241000",
                        "longitude": "-52.03361000"
                    },
                    {
                        "id": 11849,
                        "name": "Fontoura Xavier",
                        "latitude": "-29.01054000",
                        "longitude": "-52.36771000"
                    },
                    {
                        "id": 11851,
                        "name": "Formigueiro",
                        "latitude": "-29.96944000",
                        "longitude": "-53.46743000"
                    },
                    {
                        "id": 11860,
                        "name": "Forquetinha",
                        "latitude": "-29.39695000",
                        "longitude": "-52.11762000"
                    },
                    {
                        "id": 11867,
                        "name": "Fortaleza dos Valos",
                        "latitude": "-28.91268000",
                        "longitude": "-53.33891000"
                    },
                    {
                        "id": 11889,
                        "name": "Frederico Westphalen",
                        "latitude": "-27.35917000",
                        "longitude": "-53.39444000"
                    },
                    {
                        "id": 11921,
                        "name": "Garibaldi",
                        "latitude": "-29.25611000",
                        "longitude": "-51.53361000"
                    },
                    {
                        "id": 11924,
                        "name": "Garruchos",
                        "latitude": "-28.25602000",
                        "longitude": "-55.51556000"
                    },
                    {
                        "id": 11929,
                        "name": "Gaurama",
                        "latitude": "-27.61693000",
                        "longitude": "-52.10405000"
                    },
                    {
                        "id": 11936,
                        "name": "General Câmara",
                        "latitude": "-29.83922000",
                        "longitude": "-51.94718000"
                    },
                    {
                        "id": 11940,
                        "name": "Gentil",
                        "latitude": "-28.38797000",
                        "longitude": "-52.04926000"
                    },
                    {
                        "id": 11943,
                        "name": "Getúlio Vargas",
                        "latitude": "-27.87411000",
                        "longitude": "-52.16526000"
                    },
                    {
                        "id": 11946,
                        "name": "Giruá",
                        "latitude": "-28.01046000",
                        "longitude": "-54.30456000"
                    },
                    {
                        "id": 11949,
                        "name": "Glorinha",
                        "latitude": "-29.85685000",
                        "longitude": "-50.75086000"
                    },
                    {
                        "id": 11993,
                        "name": "Gramado",
                        "latitude": "-29.36252000",
                        "longitude": "-50.90318000"
                    },
                    {
                        "id": 11995,
                        "name": "Gramado dos Loureiros",
                        "latitude": "-27.45441000",
                        "longitude": "-52.91705000"
                    },
                    {
                        "id": 11994,
                        "name": "Gramado Xavier",
                        "latitude": "-29.28655000",
                        "longitude": "-52.61202000"
                    },
                    {
                        "id": 12001,
                        "name": "Gravataí",
                        "latitude": "-29.94218000",
                        "longitude": "-50.99278000"
                    },
                    {
                        "id": 12010,
                        "name": "Guabiju",
                        "latitude": "-28.58817000",
                        "longitude": "-51.64765000"
                    },
                    {
                        "id": 12076,
                        "name": "Guaíba",
                        "latitude": "-30.11389000",
                        "longitude": "-51.32500000"
                    },
                    {
                        "id": 12031,
                        "name": "Guaporé",
                        "latitude": "-28.84191000",
                        "longitude": "-51.91880000"
                    },
                    {
                        "id": 12045,
                        "name": "Guarani das Missões",
                        "latitude": "-28.15071000",
                        "longitude": "-54.60026000"
                    },
                    {
                        "id": 12092,
                        "name": "Harmonia",
                        "latitude": "-29.54904000",
                        "longitude": "-51.42357000"
                    },
                    {
                        "id": 12097,
                        "name": "Herval",
                        "latitude": "-32.02361000",
                        "longitude": "-53.39556000"
                    },
                    {
                        "id": 12099,
                        "name": "Herveiras",
                        "latitude": "-29.43864000",
                        "longitude": "-52.67366000"
                    },
                    {
                        "id": 12106,
                        "name": "Horizontina",
                        "latitude": "-27.62583000",
                        "longitude": "-54.30778000"
                    },
                    {
                        "id": 12109,
                        "name": "Hulha Negra",
                        "latitude": "-31.57199000",
                        "longitude": "-53.86271000"
                    },
                    {
                        "id": 12111,
                        "name": "Humaitá",
                        "latitude": "-27.58561000",
                        "longitude": "-53.99627000"
                    },
                    {
                        "id": 12121,
                        "name": "Ibarama",
                        "latitude": "-29.40889000",
                        "longitude": "-53.18252000"
                    },
                    {
                        "id": 12132,
                        "name": "Ibiaçá",
                        "latitude": "-28.10474000",
                        "longitude": "-51.80283000"
                    },
                    {
                        "id": 12146,
                        "name": "Ibiraiaras",
                        "latitude": "-28.38729000",
                        "longitude": "-51.62710000"
                    },
                    {
                        "id": 12150,
                        "name": "Ibirapuitã",
                        "latitude": "-28.61696000",
                        "longitude": "-52.47077000"
                    },
                    {
                        "id": 12156,
                        "name": "Ibirubá",
                        "latitude": "-28.62750000",
                        "longitude": "-53.08972000"
                    },
                    {
                        "id": 12194,
                        "name": "Igrejinha",
                        "latitude": "-29.57444000",
                        "longitude": "-50.79028000"
                    },
                    {
                        "id": 12205,
                        "name": "Ijuí",
                        "latitude": "-28.38778000",
                        "longitude": "-53.91472000"
                    },
                    {
                        "id": 12216,
                        "name": "Ilópolis",
                        "latitude": "-28.91690000",
                        "longitude": "-52.14813000"
                    },
                    {
                        "id": 12223,
                        "name": "Imbé",
                        "latitude": "-29.92719000",
                        "longitude": "-50.12826000"
                    },
                    {
                        "id": 12225,
                        "name": "Imigrante",
                        "latitude": "-29.34023000",
                        "longitude": "-51.75667000"
                    },
                    {
                        "id": 12235,
                        "name": "Independência",
                        "latitude": "-27.89333000",
                        "longitude": "-54.19784000"
                    },
                    {
                        "id": 12246,
                        "name": "Inhacorá",
                        "latitude": "-27.91435000",
                        "longitude": "-54.03786000"
                    },
                    {
                        "id": 12299,
                        "name": "Ipê",
                        "latitude": "-28.71616000",
                        "longitude": "-51.27787000"
                    },
                    {
                        "id": 12279,
                        "name": "Ipiranga do Sul",
                        "latitude": "-27.94208000",
                        "longitude": "-52.43068000"
                    },
                    {
                        "id": 12315,
                        "name": "Iraí",
                        "latitude": "-27.27078000",
                        "longitude": "-53.23696000"
                    },
                    {
                        "id": 12324,
                        "name": "Itaara",
                        "latitude": "-29.56305000",
                        "longitude": "-53.74584000"
                    },
                    {
                        "id": 12345,
                        "name": "Itacurubi",
                        "latitude": "-28.78540000",
                        "longitude": "-55.26568000"
                    },
                    {
                        "id": 12436,
                        "name": "Itapuca",
                        "latitude": "-28.77178000",
                        "longitude": "-52.20012000"
                    },
                    {
                        "id": 12444,
                        "name": "Itaqui",
                        "latitude": "-29.12528000",
                        "longitude": "-56.55306000"
                    },
                    {
                        "id": 12453,
                        "name": "Itati",
                        "latitude": "-29.42840000",
                        "longitude": "-50.17775000"
                    },
                    {
                        "id": 12457,
                        "name": "Itatiba do Sul",
                        "latitude": "-27.36303000",
                        "longitude": "-52.49074000"
                    },
                    {
                        "id": 12504,
                        "name": "Ivorá",
                        "latitude": "-29.50743000",
                        "longitude": "-53.56819000"
                    },
                    {
                        "id": 12505,
                        "name": "Ivoti",
                        "latitude": "-29.59111000",
                        "longitude": "-51.16056000"
                    },
                    {
                        "id": 12514,
                        "name": "Jaboticaba",
                        "latitude": "-27.60969000",
                        "longitude": "-53.27016000"
                    },
                    {
                        "id": 12529,
                        "name": "Jacuizinho",
                        "latitude": "-29.03095000",
                        "longitude": "-53.06796000"
                    },
                    {
                        "id": 12532,
                        "name": "Jacutinga",
                        "latitude": "-27.77469000",
                        "longitude": "-52.52224000"
                    },
                    {
                        "id": 12549,
                        "name": "Jaguarão",
                        "latitude": "-32.56611000",
                        "longitude": "-53.37583000"
                    },
                    {
                        "id": 12541,
                        "name": "Jaguari",
                        "latitude": "-29.45245000",
                        "longitude": "-54.64626000"
                    },
                    {
                        "id": 12578,
                        "name": "Jaquirana",
                        "latitude": "-28.93470000",
                        "longitude": "-50.36430000"
                    },
                    {
                        "id": 12594,
                        "name": "Jari",
                        "latitude": "-29.28796000",
                        "longitude": "-54.29784000"
                    },
                    {
                        "id": 12716,
                        "name": "Jóia",
                        "latitude": "-28.72932000",
                        "longitude": "-54.12253000"
                    },
                    {
                        "id": 12719,
                        "name": "Júlio de Castilhos",
                        "latitude": "-29.26449000",
                        "longitude": "-53.62459000"
                    },
                    {
                        "id": 12735,
                        "name": "Lagoa Bonita do Sul",
                        "latitude": "-29.49396000",
                        "longitude": "-53.03470000"
                    },
                    {
                        "id": 12767,
                        "name": "Lagoa dos Três Cantos",
                        "latitude": "-28.56607000",
                        "longitude": "-52.84650000"
                    },
                    {
                        "id": 12747,
                        "name": "Lagoa Vermelha",
                        "latitude": "-28.21995000",
                        "longitude": "-51.47225000"
                    },
                    {
                        "id": 12770,
                        "name": "Lagoão",
                        "latitude": "-29.25902000",
                        "longitude": "-52.76687000"
                    },
                    {
                        "id": 12775,
                        "name": "Lajeado",
                        "latitude": "-29.46694000",
                        "longitude": "-51.96139000"
                    },
                    {
                        "id": 12779,
                        "name": "Lajeado do Bugre",
                        "latitude": "-27.70327000",
                        "longitude": "-53.20742000"
                    },
                    {
                        "id": 12810,
                        "name": "Lavras do Sul",
                        "latitude": "-30.84980000",
                        "longitude": "-54.02830000"
                    },
                    {
                        "id": 12823,
                        "name": "Liberato Salzano",
                        "latitude": "-27.53845000",
                        "longitude": "-53.07401000"
                    },
                    {
                        "id": 12836,
                        "name": "Lindolfo Collor",
                        "latitude": "-29.57482000",
                        "longitude": "-51.22786000"
                    },
                    {
                        "id": 12839,
                        "name": "Linha Nova",
                        "latitude": "-29.45535000",
                        "longitude": "-51.21876000"
                    },
                    {
                        "id": 13089,
                        "name": "Maçambará",
                        "latitude": "-29.05822000",
                        "longitude": "-55.61102000"
                    },
                    {
                        "id": 12898,
                        "name": "Machadinho",
                        "latitude": "-27.59183000",
                        "longitude": "-51.68758000"
                    },
                    {
                        "id": 12935,
                        "name": "Mampituba",
                        "latitude": "-29.26145000",
                        "longitude": "-50.01070000"
                    },
                    {
                        "id": 12955,
                        "name": "Manoel Viana",
                        "latitude": "-29.40696000",
                        "longitude": "-55.56870000"
                    },
                    {
                        "id": 12960,
                        "name": "Maquiné",
                        "latitude": "-29.57608000",
                        "longitude": "-50.25993000"
                    },
                    {
                        "id": 12983,
                        "name": "Maratá",
                        "latitude": "-29.54921000",
                        "longitude": "-51.55693000"
                    },
                    {
                        "id": 12984,
                        "name": "Marau",
                        "latitude": "-28.44217000",
                        "longitude": "-52.27411000"
                    },
                    {
                        "id": 12991,
                        "name": "Marcelino Ramos",
                        "latitude": "-27.47851000",
                        "longitude": "-51.95065000"
                    },
                    {
                        "id": 13008,
                        "name": "Mariana Pimentel",
                        "latitude": "-30.30220000",
                        "longitude": "-51.58133000"
                    },
                    {
                        "id": 13009,
                        "name": "Mariano Moro",
                        "latitude": "-27.35013000",
                        "longitude": "-52.18363000"
                    },
                    {
                        "id": 13029,
                        "name": "Marques de Souza",
                        "latitude": "-29.27327000",
                        "longitude": "-52.15720000"
                    },
                    {
                        "id": 13045,
                        "name": "Mata",
                        "latitude": "-29.54895000",
                        "longitude": "-54.44545000"
                    },
                    {
                        "id": 13064,
                        "name": "Mato Castelhano",
                        "latitude": "-28.27248000",
                        "longitude": "-52.17628000"
                    },
                    {
                        "id": 13066,
                        "name": "Mato Leitão",
                        "latitude": "-29.51457000",
                        "longitude": "-52.13856000"
                    },
                    {
                        "id": 13067,
                        "name": "Mato Queimado",
                        "latitude": "-28.25680000",
                        "longitude": "-54.67109000"
                    },
                    {
                        "id": 13087,
                        "name": "Maximiliano de Almeida",
                        "latitude": "-27.58802000",
                        "longitude": "-51.80358000"
                    },
                    {
                        "id": 13123,
                        "name": "Minas do Leão",
                        "latitude": "-30.07189000",
                        "longitude": "-52.11996000"
                    },
                    {
                        "id": 13137,
                        "name": "Miraguaí",
                        "latitude": "-27.48658000",
                        "longitude": "-53.75549000"
                    },
                    {
                        "id": 13185,
                        "name": "Montauri",
                        "latitude": "-28.66498000",
                        "longitude": "-52.05388000"
                    },
                    {
                        "id": 13193,
                        "name": "Monte Alegre dos Campos",
                        "latitude": "-28.70177000",
                        "longitude": "-50.80405000"
                    },
                    {
                        "id": 13199,
                        "name": "Monte Belo do Sul",
                        "latitude": "-29.13180000",
                        "longitude": "-51.64287000"
                    },
                    {
                        "id": 13218,
                        "name": "Montenegro",
                        "latitude": "-29.68861000",
                        "longitude": "-51.46111000"
                    },
                    {
                        "id": 13233,
                        "name": "Mormaço",
                        "latitude": "-28.69004000",
                        "longitude": "-52.66928000"
                    },
                    {
                        "id": 13238,
                        "name": "Morrinhos do Sul",
                        "latitude": "-29.34362000",
                        "longitude": "-49.96435000"
                    },
                    {
                        "id": 13243,
                        "name": "Morro Redondo",
                        "latitude": "-31.63833000",
                        "longitude": "-52.63569000"
                    },
                    {
                        "id": 13244,
                        "name": "Morro Reuter",
                        "latitude": "-29.51567000",
                        "longitude": "-51.01861000"
                    },
                    {
                        "id": 13256,
                        "name": "Mostardas",
                        "latitude": "-30.92226000",
                        "longitude": "-50.85421000"
                    },
                    {
                        "id": 13289,
                        "name": "Muçum",
                        "latitude": "-29.14017000",
                        "longitude": "-51.82330000"
                    },
                    {
                        "id": 13264,
                        "name": "Muitos Capões",
                        "latitude": "-28.43447000",
                        "longitude": "-51.24691000"
                    },
                    {
                        "id": 13265,
                        "name": "Muliterno",
                        "latitude": "-28.31235000",
                        "longitude": "-51.78652000"
                    },
                    {
                        "id": 13485,
                        "name": "Não Me Toque",
                        "latitude": "-28.45917000",
                        "longitude": "-52.82083000"
                    },
                    {
                        "id": 13486,
                        "name": "Não-Me-Toque",
                        "latitude": "-28.47423000",
                        "longitude": "-52.80396000"
                    },
                    {
                        "id": 13323,
                        "name": "Nicolau Vergueiro",
                        "latitude": "-28.52442000",
                        "longitude": "-52.44444000"
                    },
                    {
                        "id": 13333,
                        "name": "Nonoai",
                        "latitude": "-27.36903000",
                        "longitude": "-52.87590000"
                    },
                    {
                        "id": 13347,
                        "name": "Nova Alvorada",
                        "latitude": "-28.70497000",
                        "longitude": "-52.16616000"
                    },
                    {
                        "id": 13352,
                        "name": "Nova Araçá",
                        "latitude": "-28.64411000",
                        "longitude": "-51.73489000"
                    },
                    {
                        "id": 13356,
                        "name": "Nova Bassano",
                        "latitude": "-28.70293000",
                        "longitude": "-51.80542000"
                    },
                    {
                        "id": 13358,
                        "name": "Nova Boa Vista",
                        "latitude": "-28.00887000",
                        "longitude": "-52.98206000"
                    },
                    {
                        "id": 13361,
                        "name": "Nova Bréscia",
                        "latitude": "-29.20206000",
                        "longitude": "-52.04822000"
                    },
                    {
                        "id": 13366,
                        "name": "Nova Candelária",
                        "latitude": "-27.59344000",
                        "longitude": "-54.12172000"
                    },
                    {
                        "id": 13377,
                        "name": "Nova Esperança do Sul",
                        "latitude": "-29.39225000",
                        "longitude": "-54.83460000"
                    },
                    {
                        "id": 13387,
                        "name": "Nova Hartz",
                        "latitude": "-29.59640000",
                        "longitude": "-50.90836000"
                    },
                    {
                        "id": 13423,
                        "name": "Nova Pádua",
                        "latitude": "-29.01222000",
                        "longitude": "-51.31451000"
                    },
                    {
                        "id": 13416,
                        "name": "Nova Palma",
                        "latitude": "-29.40710000",
                        "longitude": "-53.43240000"
                    },
                    {
                        "id": 13418,
                        "name": "Nova Petrópolis",
                        "latitude": "-29.37639000",
                        "longitude": "-51.11444000"
                    },
                    {
                        "id": 13421,
                        "name": "Nova Prata",
                        "latitude": "-28.78389000",
                        "longitude": "-51.61000000"
                    },
                    {
                        "id": 13424,
                        "name": "Nova Ramada",
                        "latitude": "-28.09297000",
                        "longitude": "-53.69502000"
                    },
                    {
                        "id": 13428,
                        "name": "Nova Roma do Sul",
                        "latitude": "-28.99091000",
                        "longitude": "-51.41443000"
                    },
                    {
                        "id": 13434,
                        "name": "Nova Santa Rita",
                        "latitude": "-29.83265000",
                        "longitude": "-51.27431000"
                    },
                    {
                        "id": 13454,
                        "name": "Novo Barreiro",
                        "latitude": "-27.89154000",
                        "longitude": "-53.11220000"
                    },
                    {
                        "id": 13456,
                        "name": "Novo Cabrais",
                        "latitude": "-29.76161000",
                        "longitude": "-52.98402000"
                    },
                    {
                        "id": 13459,
                        "name": "Novo Hamburgo",
                        "latitude": "-29.67833000",
                        "longitude": "-51.13056000"
                    },
                    {
                        "id": 13469,
                        "name": "Novo Machado",
                        "latitude": "-27.55482000",
                        "longitude": "-54.53613000"
                    },
                    {
                        "id": 13480,
                        "name": "Novo Tiradentes",
                        "latitude": "-27.55948000",
                        "longitude": "-53.15567000"
                    },
                    {
                        "id": 13482,
                        "name": "Novo Xingu",
                        "latitude": "-27.74556000",
                        "longitude": "-53.04043000"
                    },
                    {
                        "id": 13530,
                        "name": "Osório",
                        "latitude": "-29.89454000",
                        "longitude": "-50.23467000"
                    },
                    {
                        "id": 13568,
                        "name": "Paim Filho",
                        "latitude": "-27.72984000",
                        "longitude": "-51.78102000"
                    },
                    {
                        "id": 13585,
                        "name": "Palmares do Sul",
                        "latitude": "-30.25778000",
                        "longitude": "-50.50972000"
                    },
                    {
                        "id": 13592,
                        "name": "Palmeira das Missões",
                        "latitude": "-27.89944000",
                        "longitude": "-53.31361000"
                    },
                    {
                        "id": 13607,
                        "name": "Palmitinho",
                        "latitude": "-27.32268000",
                        "longitude": "-53.59220000"
                    },
                    {
                        "id": 13612,
                        "name": "Panambi",
                        "latitude": "-28.29250000",
                        "longitude": "-53.50167000"
                    },
                    {
                        "id": 13618,
                        "name": "Pantano Grande",
                        "latitude": "-30.25817000",
                        "longitude": "-52.34168000"
                    },
                    {
                        "id": 13657,
                        "name": "Paraí",
                        "latitude": "-28.59575000",
                        "longitude": "-51.79731000"
                    },
                    {
                        "id": 13663,
                        "name": "Paraíso do Sul",
                        "latitude": "-29.72404000",
                        "longitude": "-53.11162000"
                    },
                    {
                        "id": 13668,
                        "name": "Pareci Novo",
                        "latitude": "-29.61153000",
                        "longitude": "-51.42691000"
                    },
                    {
                        "id": 13683,
                        "name": "Parobé",
                        "latitude": "-29.62861000",
                        "longitude": "-50.83472000"
                    },
                    {
                        "id": 13686,
                        "name": "Passa Sete",
                        "latitude": "-29.43060000",
                        "longitude": "-52.86514000"
                    },
                    {
                        "id": 13699,
                        "name": "Passo do Sobrado",
                        "latitude": "-29.73133000",
                        "longitude": "-52.23175000"
                    },
                    {
                        "id": 13696,
                        "name": "Passo Fundo",
                        "latitude": "-28.26278000",
                        "longitude": "-52.40667000"
                    },
                    {
                        "id": 13732,
                        "name": "Paulo Bento",
                        "latitude": "-27.73673000",
                        "longitude": "-52.39667000"
                    },
                    {
                        "id": 13739,
                        "name": "Paverama",
                        "latitude": "-29.59556000",
                        "longitude": "-51.72344000"
                    },
                    {
                        "id": 13762,
                        "name": "Pedras Altas",
                        "latitude": "-31.83276000",
                        "longitude": "-53.63272000"
                    },
                    {
                        "id": 13780,
                        "name": "Pedro Osório",
                        "latitude": "-31.95760000",
                        "longitude": "-52.89419000"
                    },
                    {
                        "id": 13790,
                        "name": "Pejuçara",
                        "latitude": "-28.45442000",
                        "longitude": "-53.61044000"
                    },
                    {
                        "id": 13791,
                        "name": "Pelotas",
                        "latitude": "-31.76997000",
                        "longitude": "-52.34101000"
                    },
                    {
                        "id": 13828,
                        "name": "Picada Café",
                        "latitude": "-29.44757000",
                        "longitude": "-51.11522000"
                    },
                    {
                        "id": 13859,
                        "name": "Pinhal",
                        "latitude": "-27.52636000",
                        "longitude": "-53.23425000"
                    },
                    {
                        "id": 13861,
                        "name": "Pinhal da Serra",
                        "latitude": "-27.88164000",
                        "longitude": "-51.22450000"
                    },
                    {
                        "id": 13860,
                        "name": "Pinhal Grande",
                        "latitude": "-29.27075000",
                        "longitude": "-53.34587000"
                    },
                    {
                        "id": 13867,
                        "name": "Pinheirinho do Vale",
                        "latitude": "-27.22637000",
                        "longitude": "-53.63352000"
                    },
                    {
                        "id": 13869,
                        "name": "Pinheiro Machado",
                        "latitude": "-31.57833000",
                        "longitude": "-53.38111000"
                    },
                    {
                        "id": 13871,
                        "name": "Pinheiros",
                        "latitude": "-29.78333000",
                        "longitude": "-52.73333000"
                    },
                    {
                        "id": 13876,
                        "name": "Pinto Bandeira",
                        "latitude": "-29.09289000",
                        "longitude": "-51.46180000"
                    },
                    {
                        "id": 13903,
                        "name": "Pirapó",
                        "latitude": "-28.05287000",
                        "longitude": "-55.23460000"
                    },
                    {
                        "id": 13907,
                        "name": "Piratini",
                        "latitude": "-31.41655000",
                        "longitude": "-53.11163000"
                    },
                    {
                        "id": 13940,
                        "name": "Planalto",
                        "latitude": "-27.34391000",
                        "longitude": "-53.08947000"
                    },
                    {
                        "id": 14050,
                        "name": "Poço das Antas",
                        "latitude": "-29.45339000",
                        "longitude": "-51.66969000"
                    },
                    {
                        "id": 13979,
                        "name": "Pontão",
                        "latitude": "-28.04977000",
                        "longitude": "-52.63740000"
                    },
                    {
                        "id": 13971,
                        "name": "Ponte Preta",
                        "latitude": "-27.67688000",
                        "longitude": "-52.51736000"
                    },
                    {
                        "id": 14029,
                        "name": "Portão",
                        "latitude": "-29.70746000",
                        "longitude": "-51.23572000"
                    },
                    {
                        "id": 13994,
                        "name": "Porto Alegre",
                        "latitude": "-30.03283000",
                        "longitude": "-51.23019000"
                    },
                    {
                        "id": 14009,
                        "name": "Porto Lucena",
                        "latitude": "-27.84663000",
                        "longitude": "-54.96059000"
                    },
                    {
                        "id": 14010,
                        "name": "Porto Mauá",
                        "latitude": "-27.59808000",
                        "longitude": "-54.65773000"
                    },
                    {
                        "id": 14020,
                        "name": "Porto Vera Cruz",
                        "latitude": "-27.76244000",
                        "longitude": "-54.90094000"
                    },
                    {
                        "id": 14023,
                        "name": "Porto Xavier",
                        "latitude": "-27.93317000",
                        "longitude": "-55.15422000"
                    },
                    {
                        "id": 14040,
                        "name": "Pouso Novo",
                        "latitude": "-29.16777000",
                        "longitude": "-52.22165000"
                    },
                    {
                        "id": 14090,
                        "name": "Presidente Lucena",
                        "latitude": "-29.52778000",
                        "longitude": "-51.19285000"
                    },
                    {
                        "id": 14109,
                        "name": "Progresso",
                        "latitude": "-29.22873000",
                        "longitude": "-52.30960000"
                    },
                    {
                        "id": 14112,
                        "name": "Protásio Alves",
                        "latitude": "-28.74413000",
                        "longitude": "-51.49620000"
                    },
                    {
                        "id": 14117,
                        "name": "Putinga",
                        "latitude": "-29.04776000",
                        "longitude": "-52.16503000"
                    },
                    {
                        "id": 14126,
                        "name": "Quaraí",
                        "latitude": "-30.38750000",
                        "longitude": "-56.45139000"
                    },
                    {
                        "id": 14133,
                        "name": "Quatro Irmãos",
                        "latitude": "-27.81251000",
                        "longitude": "-52.46069000"
                    },
                    {
                        "id": 14147,
                        "name": "Quevedos",
                        "latitude": "-29.30670000",
                        "longitude": "-54.07002000"
                    },
                    {
                        "id": 14152,
                        "name": "Quinze de Novembro",
                        "latitude": "-28.74442000",
                        "longitude": "-53.11648000"
                    },
                    {
                        "id": 14182,
                        "name": "Redentora",
                        "latitude": "-27.56833000",
                        "longitude": "-53.60924000"
                    },
                    {
                        "id": 14192,
                        "name": "Relvado",
                        "latitude": "-29.12666000",
                        "longitude": "-52.05393000"
                    },
                    {
                        "id": 14206,
                        "name": "Restinga Sêca",
                        "latitude": "-29.82715000",
                        "longitude": "-53.34008000"
                    },
                    {
                        "id": 14319,
                        "name": "Rio dos Índios",
                        "latitude": "-27.25523000",
                        "longitude": "-52.87641000"
                    },
                    {
                        "id": 14276,
                        "name": "Rio Grande",
                        "latitude": "-32.07811000",
                        "longitude": "-52.35014000"
                    },
                    {
                        "id": 14288,
                        "name": "Rio Pardo",
                        "latitude": "-29.98972000",
                        "longitude": "-52.37806000"
                    },
                    {
                        "id": 14321,
                        "name": "Riozinho",
                        "latitude": "-29.59847000",
                        "longitude": "-50.39225000"
                    },
                    {
                        "id": 14325,
                        "name": "Roca Sales",
                        "latitude": "-29.22637000",
                        "longitude": "-51.82440000"
                    },
                    {
                        "id": 14329,
                        "name": "Rodeio Bonito",
                        "latitude": "-27.46968000",
                        "longitude": "-53.17038000"
                    },
                    {
                        "id": 14334,
                        "name": "Rolador",
                        "latitude": "-28.27096000",
                        "longitude": "-54.85608000"
                    },
                    {
                        "id": 14335,
                        "name": "Rolante",
                        "latitude": "-29.65056000",
                        "longitude": "-50.57583000"
                    },
                    {
                        "id": 14341,
                        "name": "Ronda Alta",
                        "latitude": "-27.82614000",
                        "longitude": "-52.72873000"
                    },
                    {
                        "id": 14342,
                        "name": "Rondinha",
                        "latitude": "-27.83287000",
                        "longitude": "-52.91661000"
                    },
                    {
                        "id": 14347,
                        "name": "Roque Gonzales",
                        "latitude": "-28.05673000",
                        "longitude": "-55.12048000"
                    },
                    {
                        "id": 14355,
                        "name": "Rosário do Sul",
                        "latitude": "-30.25833000",
                        "longitude": "-54.91417000"
                    },
                    {
                        "id": 14373,
                        "name": "Sagrada Família",
                        "latitude": "-27.71478000",
                        "longitude": "-53.12850000"
                    },
                    {
                        "id": 14376,
                        "name": "Saldanha Marinho",
                        "latitude": "-28.38701000",
                        "longitude": "-53.09584000"
                    },
                    {
                        "id": 14402,
                        "name": "Salto do Jacuí",
                        "latitude": "-29.04212000",
                        "longitude": "-53.16909000"
                    },
                    {
                        "id": 14405,
                        "name": "Salvador das Missões",
                        "latitude": "-28.07697000",
                        "longitude": "-54.82880000"
                    },
                    {
                        "id": 14406,
                        "name": "Salvador do Sul",
                        "latitude": "-29.48006000",
                        "longitude": "-51.51407000"
                    },
                    {
                        "id": 14410,
                        "name": "Sananduva",
                        "latitude": "-27.94972000",
                        "longitude": "-51.80667000"
                    },
                    {
                        "id": 14416,
                        "name": "Sant'Ana do Livramento",
                        "latitude": "-30.78069000",
                        "longitude": "-55.48158000"
                    },
                    {
                        "id": 14429,
                        "name": "Santa Bárbara do Sul",
                        "latitude": "-28.37429000",
                        "longitude": "-53.25738000"
                    },
                    {
                        "id": 14435,
                        "name": "Santa Cecília do Sul",
                        "latitude": "-28.17256000",
                        "longitude": "-51.92401000"
                    },
                    {
                        "id": 14437,
                        "name": "Santa Clara do Sul",
                        "latitude": "-29.45575000",
                        "longitude": "-52.14362000"
                    },
                    {
                        "id": 14456,
                        "name": "Santa Cruz do Sul",
                        "latitude": "-29.71750000",
                        "longitude": "-52.42583000"
                    },
                    {
                        "id": 14501,
                        "name": "Santa Margarida do Sul",
                        "latitude": "-30.36744000",
                        "longitude": "-54.10999000"
                    },
                    {
                        "id": 14502,
                        "name": "Santa Maria",
                        "latitude": "-29.68417000",
                        "longitude": "-53.80694000"
                    },
                    {
                        "id": 14512,
                        "name": "Santa Maria do Herval",
                        "latitude": "-29.47954000",
                        "longitude": "-50.98806000"
                    },
                    {
                        "id": 14540,
                        "name": "Santa Rosa",
                        "latitude": "-27.87083000",
                        "longitude": "-54.48139000"
                    },
                    {
                        "id": 14553,
                        "name": "Santa Tereza",
                        "latitude": "-29.15063000",
                        "longitude": "-51.72160000"
                    },
                    {
                        "id": 14566,
                        "name": "Santa Vitória do Palmar",
                        "latitude": "-33.51889000",
                        "longitude": "-53.36806000"
                    },
                    {
                        "id": 14570,
                        "name": "Santana da Boa Vista",
                        "latitude": "-30.76195000",
                        "longitude": "-53.18297000"
                    },
                    {
                        "id": 14585,
                        "name": "Santana do Livramento",
                        "latitude": "-30.89083000",
                        "longitude": "-55.53278000"
                    },
                    {
                        "id": 14600,
                        "name": "Santiago",
                        "latitude": "-29.11368000",
                        "longitude": "-54.73359000"
                    },
                    {
                        "id": 14652,
                        "name": "Santo Ângelo",
                        "latitude": "-28.29917000",
                        "longitude": "-54.26306000"
                    },
                    {
                        "id": 14613,
                        "name": "Santo Antônio da Patrulha",
                        "latitude": "-29.82214000",
                        "longitude": "-50.56024000"
                    },
                    {
                        "id": 14615,
                        "name": "Santo Antônio das Missões",
                        "latitude": "-28.47797000",
                        "longitude": "-55.40876000"
                    },
                    {
                        "id": 14634,
                        "name": "Santo Antônio do Palma",
                        "latitude": "-28.48630000",
                        "longitude": "-52.01930000"
                    },
                    {
                        "id": 14637,
                        "name": "Santo Antônio do Planalto",
                        "latitude": "-28.38607000",
                        "longitude": "-52.66579000"
                    },
                    {
                        "id": 14644,
                        "name": "Santo Augusto",
                        "latitude": "-27.85083000",
                        "longitude": "-53.77722000"
                    },
                    {
                        "id": 14645,
                        "name": "Santo Cristo",
                        "latitude": "-27.78844000",
                        "longitude": "-54.70378000"
                    },
                    {
                        "id": 14648,
                        "name": "Santo Expedito do Sul",
                        "latitude": "-27.92306000",
                        "longitude": "-51.67042000"
                    },
                    {
                        "id": 14848,
                        "name": "São Borja",
                        "latitude": "-28.66056000",
                        "longitude": "-56.00444000"
                    },
                    {
                        "id": 14874,
                        "name": "São Domingos do Sul",
                        "latitude": "-28.54446000",
                        "longitude": "-51.87330000"
                    },
                    {
                        "id": 14883,
                        "name": "São Francisco de Assis",
                        "latitude": "-29.55028000",
                        "longitude": "-55.13111000"
                    },
                    {
                        "id": 14887,
                        "name": "São Francisco de Paula",
                        "latitude": "-29.24246000",
                        "longitude": "-50.44928000"
                    },
                    {
                        "id": 14908,
                        "name": "São Gabriel",
                        "latitude": "-30.33369000",
                        "longitude": "-54.33029000"
                    },
                    {
                        "id": 14928,
                        "name": "São Jerônimo",
                        "latitude": "-29.95917000",
                        "longitude": "-51.72222000"
                    },
                    {
                        "id": 15016,
                        "name": "São João da Urtiga",
                        "latitude": "-27.79677000",
                        "longitude": "-51.83882000"
                    },
                    {
                        "id": 15041,
                        "name": "São João do Polêsine",
                        "latitude": "-29.64559000",
                        "longitude": "-53.47291000"
                    },
                    {
                        "id": 14934,
                        "name": "São Jorge",
                        "latitude": "-28.49890000",
                        "longitude": "-51.73076000"
                    },
                    {
                        "id": 14950,
                        "name": "São José das Missões",
                        "latitude": "-27.79738000",
                        "longitude": "-53.12963000"
                    },
                    {
                        "id": 14972,
                        "name": "São José do Herval",
                        "latitude": "-29.06441000",
                        "longitude": "-52.27281000"
                    },
                    {
                        "id": 14973,
                        "name": "São José do Hortêncio",
                        "latitude": "-29.54364000",
                        "longitude": "-51.24977000"
                    },
                    {
                        "id": 14974,
                        "name": "São José do Inhacorá",
                        "latitude": "-27.73525000",
                        "longitude": "-54.12155000"
                    },
                    {
                        "id": 14978,
                        "name": "São José do Norte",
                        "latitude": "-31.80089000",
                        "longitude": "-51.76198000"
                    },
                    {
                        "id": 14979,
                        "name": "São José do Ouro",
                        "latitude": "-27.75580000",
                        "longitude": "-51.55722000"
                    },
                    {
                        "id": 14988,
                        "name": "São José do Sul",
                        "latitude": "-29.54416000",
                        "longitude": "-51.49254000"
                    },
                    {
                        "id": 14991,
                        "name": "São José dos Ausentes",
                        "latitude": "-28.68307000",
                        "longitude": "-49.94674000"
                    },
                    {
                        "id": 15051,
                        "name": "São Leopoldo",
                        "latitude": "-29.76028000",
                        "longitude": "-51.14722000"
                    },
                    {
                        "id": 15057,
                        "name": "São Lourenço do Sul",
                        "latitude": "-31.36528000",
                        "longitude": "-51.97833000"
                    },
                    {
                        "id": 15060,
                        "name": "São Luiz Gonzaga",
                        "latitude": "-28.40833000",
                        "longitude": "-54.96083000"
                    },
                    {
                        "id": 15071,
                        "name": "São Marcos",
                        "latitude": "-28.96872000",
                        "longitude": "-51.04900000"
                    },
                    {
                        "id": 15072,
                        "name": "São Martinho",
                        "latitude": "-27.72779000",
                        "longitude": "-53.96611000"
                    },
                    {
                        "id": 15074,
                        "name": "São Martinho da Serra",
                        "latitude": "-29.45793000",
                        "longitude": "-53.88452000"
                    },
                    {
                        "id": 15083,
                        "name": "São Miguel das Missões",
                        "latitude": "-28.72430000",
                        "longitude": "-54.50818000"
                    },
                    {
                        "id": 15099,
                        "name": "São Nicolau",
                        "latitude": "-28.22363000",
                        "longitude": "-55.25589000"
                    },
                    {
                        "id": 15102,
                        "name": "São Paulo das Missões",
                        "latitude": "-27.96215000",
                        "longitude": "-54.95513000"
                    },
                    {
                        "id": 15110,
                        "name": "São Pedro da Serra",
                        "latitude": "-29.42131000",
                        "longitude": "-51.51442000"
                    },
                    {
                        "id": 15113,
                        "name": "São Pedro das Missões",
                        "latitude": "-27.79277000",
                        "longitude": "-53.24444000"
                    },
                    {
                        "id": 15115,
                        "name": "São Pedro do Butiá",
                        "latitude": "-28.15561000",
                        "longitude": "-54.90336000"
                    },
                    {
                        "id": 15121,
                        "name": "São Pedro do Sul",
                        "latitude": "-29.62056000",
                        "longitude": "-54.17889000"
                    },
                    {
                        "id": 15145,
                        "name": "São Sebastião do Caí",
                        "latitude": "-29.58667000",
                        "longitude": "-51.37556000"
                    },
                    {
                        "id": 15155,
                        "name": "São Sepé",
                        "latitude": "-30.16056000",
                        "longitude": "-53.56528000"
                    },
                    {
                        "id": 15163,
                        "name": "São Valentim",
                        "latitude": "-27.55106000",
                        "longitude": "-52.58722000"
                    },
                    {
                        "id": 15164,
                        "name": "São Valentim do Sul",
                        "latitude": "-29.06303000",
                        "longitude": "-51.73687000"
                    },
                    {
                        "id": 15166,
                        "name": "São Valério do Sul",
                        "latitude": "-27.81235000",
                        "longitude": "-53.92050000"
                    },
                    {
                        "id": 15167,
                        "name": "São Vendelino",
                        "latitude": "-29.38319000",
                        "longitude": "-51.37289000"
                    },
                    {
                        "id": 15174,
                        "name": "São Vicente do Sul",
                        "latitude": "-29.71725000",
                        "longitude": "-54.76241000"
                    },
                    {
                        "id": 14658,
                        "name": "Sapiranga",
                        "latitude": "-29.63806000",
                        "longitude": "-51.00694000"
                    },
                    {
                        "id": 14660,
                        "name": "Sapucaia",
                        "latitude": "-29.83333000",
                        "longitude": "-51.15000000"
                    },
                    {
                        "id": 14663,
                        "name": "Sapucaia do Sul",
                        "latitude": "-29.81826000",
                        "longitude": "-51.15527000"
                    },
                    {
                        "id": 14667,
                        "name": "Sarandi",
                        "latitude": "-27.94389000",
                        "longitude": "-52.92306000"
                    },
                    {
                        "id": 14686,
                        "name": "Seberi",
                        "latitude": "-27.50884000",
                        "longitude": "-53.36482000"
                    },
                    {
                        "id": 14687,
                        "name": "Sede Nova",
                        "latitude": "-27.64490000",
                        "longitude": "-53.96149000"
                    },
                    {
                        "id": 14688,
                        "name": "Segredo",
                        "latitude": "-29.29705000",
                        "longitude": "-52.92281000"
                    },
                    {
                        "id": 14689,
                        "name": "Selbach",
                        "latitude": "-28.67641000",
                        "longitude": "-52.98236000"
                    },
                    {
                        "id": 14707,
                        "name": "Senador Salgado Filho",
                        "latitude": "-28.02951000",
                        "longitude": "-54.52396000"
                    },
                    {
                        "id": 14714,
                        "name": "Sentinela do Sul",
                        "latitude": "-30.60341000",
                        "longitude": "-51.62096000"
                    },
                    {
                        "id": 14716,
                        "name": "Serafina Corrêa",
                        "latitude": "-28.69115000",
                        "longitude": "-51.92671000"
                    },
                    {
                        "id": 15175,
                        "name": "Sério",
                        "latitude": "-29.40642000",
                        "longitude": "-52.24358000"
                    },
                    {
                        "id": 14760,
                        "name": "Sertão",
                        "latitude": "-28.00412000",
                        "longitude": "-52.35664000"
                    },
                    {
                        "id": 14761,
                        "name": "Sertão Santana",
                        "latitude": "-30.49105000",
                        "longitude": "-51.66541000"
                    },
                    {
                        "id": 14767,
                        "name": "Sete de Setembro",
                        "latitude": "-28.12546000",
                        "longitude": "-54.47905000"
                    },
                    {
                        "id": 14770,
                        "name": "Severiano de Almeida",
                        "latitude": "-27.40649000",
                        "longitude": "-52.10747000"
                    },
                    {
                        "id": 14777,
                        "name": "Silveira Martins",
                        "latitude": "-29.63635000",
                        "longitude": "-53.54609000"
                    },
                    {
                        "id": 14790,
                        "name": "Sinimbu",
                        "latitude": "-29.41512000",
                        "longitude": "-52.60499000"
                    },
                    {
                        "id": 14796,
                        "name": "Sobradinho",
                        "latitude": "-29.41325000",
                        "longitude": "-53.02018000"
                    },
                    {
                        "id": 14803,
                        "name": "Soledade",
                        "latitude": "-28.84047000",
                        "longitude": "-52.51015000"
                    },
                    {
                        "id": 15186,
                        "name": "Tabaí",
                        "latitude": "-29.66719000",
                        "longitude": "-51.72796000"
                    },
                    {
                        "id": 15227,
                        "name": "Tapejara",
                        "latitude": "-28.06426000",
                        "longitude": "-52.00823000"
                    },
                    {
                        "id": 15229,
                        "name": "Tapera",
                        "latitude": "-28.66758000",
                        "longitude": "-52.86620000"
                    },
                    {
                        "id": 15232,
                        "name": "Tapes",
                        "latitude": "-30.67333000",
                        "longitude": "-51.39583000"
                    },
                    {
                        "id": 15240,
                        "name": "Taquara",
                        "latitude": "-29.66336000",
                        "longitude": "-50.76365000"
                    },
                    {
                        "id": 15245,
                        "name": "Taquari",
                        "latitude": "-29.79972000",
                        "longitude": "-51.86444000"
                    },
                    {
                        "id": 15251,
                        "name": "Taquaruçu do Sul",
                        "latitude": "-27.40719000",
                        "longitude": "-53.49914000"
                    },
                    {
                        "id": 15263,
                        "name": "Tavares",
                        "latitude": "-31.27291000",
                        "longitude": "-51.07758000"
                    },
                    {
                        "id": 15276,
                        "name": "Tenente Portela",
                        "latitude": "-27.36291000",
                        "longitude": "-53.77115000"
                    },
                    {
                        "id": 15298,
                        "name": "Terra de Areia",
                        "latitude": "-29.58443000",
                        "longitude": "-50.06135000"
                    },
                    {
                        "id": 15300,
                        "name": "Teutônia",
                        "latitude": "-29.46814000",
                        "longitude": "-51.77144000"
                    },
                    {
                        "id": 15320,
                        "name": "Tio Hugo",
                        "latitude": "-28.58180000",
                        "longitude": "-52.59736000"
                    },
                    {
                        "id": 15322,
                        "name": "Tiradentes do Sul",
                        "latitude": "-27.38183000",
                        "longitude": "-54.11303000"
                    },
                    {
                        "id": 15339,
                        "name": "Toropi",
                        "latitude": "-29.47869000",
                        "longitude": "-54.29307000"
                    },
                    {
                        "id": 15341,
                        "name": "Torres",
                        "latitude": "-29.29667000",
                        "longitude": "-49.81982000"
                    },
                    {
                        "id": 15351,
                        "name": "Tramandaí",
                        "latitude": "-30.03977000",
                        "longitude": "-50.23016000"
                    },
                    {
                        "id": 15352,
                        "name": "Travesseiro",
                        "latitude": "-29.28808000",
                        "longitude": "-52.09974000"
                    },
                    {
                        "id": 15369,
                        "name": "Três Arroios",
                        "latitude": "-27.48222000",
                        "longitude": "-52.18370000"
                    },
                    {
                        "id": 15372,
                        "name": "Três Cachoeiras",
                        "latitude": "-29.47525000",
                        "longitude": "-49.98487000"
                    },
                    {
                        "id": 15374,
                        "name": "Três Coroas",
                        "latitude": "-29.46604000",
                        "longitude": "-50.77684000"
                    },
                    {
                        "id": 15384,
                        "name": "Três de Maio",
                        "latitude": "-27.73449000",
                        "longitude": "-54.26018000"
                    },
                    {
                        "id": 15375,
                        "name": "Três Forquilhas",
                        "latitude": "-29.43246000",
                        "longitude": "-50.08341000"
                    },
                    {
                        "id": 15379,
                        "name": "Três Palmeiras",
                        "latitude": "-27.61276000",
                        "longitude": "-52.86635000"
                    },
                    {
                        "id": 15380,
                        "name": "Três Passos",
                        "latitude": "-27.43083000",
                        "longitude": "-53.92238000"
                    },
                    {
                        "id": 15361,
                        "name": "Trindade do Sul",
                        "latitude": "-27.52679000",
                        "longitude": "-52.91351000"
                    },
                    {
                        "id": 15364,
                        "name": "Triunfo",
                        "latitude": "-29.82246000",
                        "longitude": "-51.56027000"
                    },
                    {
                        "id": 15388,
                        "name": "Tucunduva",
                        "latitude": "-27.64923000",
                        "longitude": "-54.43972000"
                    },
                    {
                        "id": 15393,
                        "name": "Tunas",
                        "latitude": "-29.10586000",
                        "longitude": "-52.89867000"
                    },
                    {
                        "id": 15400,
                        "name": "Tupanci do Sul",
                        "latitude": "-27.92640000",
                        "longitude": "-51.54450000"
                    },
                    {
                        "id": 15401,
                        "name": "Tupanciretã",
                        "latitude": "-29.02190000",
                        "longitude": "-53.97471000"
                    },
                    {
                        "id": 15402,
                        "name": "Tupandi",
                        "latitude": "-29.48000000",
                        "longitude": "-51.43044000"
                    },
                    {
                        "id": 15403,
                        "name": "Tuparendi",
                        "latitude": "-27.68918000",
                        "longitude": "-54.55912000"
                    },
                    {
                        "id": 15416,
                        "name": "Turuçu",
                        "latitude": "-31.52317000",
                        "longitude": "-52.12870000"
                    },
                    {
                        "id": 15437,
                        "name": "Ubiretama",
                        "latitude": "-28.05186000",
                        "longitude": "-54.66252000"
                    },
                    {
                        "id": 15458,
                        "name": "União da Serra",
                        "latitude": "-28.78526000",
                        "longitude": "-52.03971000"
                    },
                    {
                        "id": 15455,
                        "name": "Unistalda",
                        "latitude": "-29.08248000",
                        "longitude": "-55.19194000"
                    },
                    {
                        "id": 15479,
                        "name": "Uruguaiana",
                        "latitude": "-29.82797000",
                        "longitude": "-56.63224000"
                    },
                    {
                        "id": 15490,
                        "name": "Vacaria",
                        "latitude": "-28.41223000",
                        "longitude": "-50.94431000"
                    },
                    {
                        "id": 15496,
                        "name": "Vale do Sol",
                        "latitude": "-29.58160000",
                        "longitude": "-52.68161000"
                    },
                    {
                        "id": 15491,
                        "name": "Vale Real",
                        "latitude": "-29.34986000",
                        "longitude": "-51.23013000"
                    },
                    {
                        "id": 15492,
                        "name": "Vale Verde",
                        "latitude": "-29.83509000",
                        "longitude": "-52.10562000"
                    },
                    {
                        "id": 15505,
                        "name": "Vanini",
                        "latitude": "-28.48831000",
                        "longitude": "-51.83316000"
                    },
                    {
                        "id": 15530,
                        "name": "Venâncio Aires",
                        "latitude": "-29.54206000",
                        "longitude": "-52.21959000"
                    },
                    {
                        "id": 15534,
                        "name": "Vera Cruz",
                        "latitude": "-29.77275000",
                        "longitude": "-52.52818000"
                    },
                    {
                        "id": 15538,
                        "name": "Veranópolis",
                        "latitude": "-28.97791000",
                        "longitude": "-51.55656000"
                    },
                    {
                        "id": 15549,
                        "name": "Vespasiano Corrêa",
                        "latitude": "-29.07064000",
                        "longitude": "-51.86646000"
                    },
                    {
                        "id": 15550,
                        "name": "Viadutos",
                        "latitude": "-27.57743000",
                        "longitude": "-51.98735000"
                    },
                    {
                        "id": 15551,
                        "name": "Viamão",
                        "latitude": "-30.08111000",
                        "longitude": "-51.02333000"
                    },
                    {
                        "id": 15555,
                        "name": "Vicente Dutra",
                        "latitude": "-27.17975000",
                        "longitude": "-53.39966000"
                    },
                    {
                        "id": 15558,
                        "name": "Victor Graeff",
                        "latitude": "-28.54502000",
                        "longitude": "-52.68069000"
                    },
                    {
                        "id": 15568,
                        "name": "Vila Flores",
                        "latitude": "-28.86838000",
                        "longitude": "-51.52935000"
                    },
                    {
                        "id": 15569,
                        "name": "Vila Lângaro",
                        "latitude": "-28.12778000",
                        "longitude": "-52.14152000"
                    },
                    {
                        "id": 15570,
                        "name": "Vila Maria",
                        "latitude": "-28.55505000",
                        "longitude": "-52.16380000"
                    },
                    {
                        "id": 15572,
                        "name": "Vila Nova do Sul",
                        "latitude": "-30.33711000",
                        "longitude": "-53.88004000"
                    },
                    {
                        "id": 15589,
                        "name": "Vista Alegre",
                        "latitude": "-27.31083000",
                        "longitude": "-53.51572000"
                    },
                    {
                        "id": 15591,
                        "name": "Vista Alegre do Prata",
                        "latitude": "-28.83075000",
                        "longitude": "-51.79221000"
                    },
                    {
                        "id": 15592,
                        "name": "Vista Gaúcha",
                        "latitude": "-27.26738000",
                        "longitude": "-53.69737000"
                    },
                    {
                        "id": 15600,
                        "name": "Vitória das Missões",
                        "latitude": "-28.35473000",
                        "longitude": "-54.48174000"
                    },
                    {
                        "id": 15631,
                        "name": "Westfália",
                        "latitude": "-29.42302000",
                        "longitude": "-51.75617000"
                    },
                    {
                        "id": 15635,
                        "name": "Xangri-lá",
                        "latitude": "-29.81049000",
                        "longitude": "-50.09223000"
                    }
                ]
            },
            {
                "id": 2013,
                "name": "Rondônia",
                "iso2": "RO",
                "latitude": "-11.50573410",
                "longitude": "-63.58061100",
                "type": "state",
                "cities": [
                    {
                        "id": 10151,
                        "name": "Alta Floresta d'Oeste",
                        "latitude": "-12.47107000",
                        "longitude": "-62.13705000"
                    },
                    {
                        "id": 10164,
                        "name": "Alto Alegre dos Parecis",
                        "latitude": "-12.75601000",
                        "longitude": "-61.97971000"
                    },
                    {
                        "id": 10176,
                        "name": "Alto Paraíso",
                        "latitude": "-9.65996000",
                        "longitude": "-63.58719000"
                    },
                    {
                        "id": 10196,
                        "name": "Alvorada d'Oeste",
                        "latitude": "-11.29925000",
                        "longitude": "-62.50152000"
                    },
                    {
                        "id": 10396,
                        "name": "Ariquemes",
                        "latitude": "-9.91333000",
                        "longitude": "-63.04083000"
                    },
                    {
                        "id": 10834,
                        "name": "Buritis",
                        "latitude": "-10.09215000",
                        "longitude": "-63.96964000"
                    },
                    {
                        "id": 10851,
                        "name": "Cabixi",
                        "latitude": "-13.51083000",
                        "longitude": "-60.60257000"
                    },
                    {
                        "id": 10859,
                        "name": "Cacaulândia",
                        "latitude": "-10.32583000",
                        "longitude": "-63.14953000"
                    },
                    {
                        "id": 10885,
                        "name": "Cacoal",
                        "latitude": "-11.43861000",
                        "longitude": "-61.44722000"
                    },
                    {
                        "id": 11000,
                        "name": "Campo Novo de Rondônia",
                        "latitude": "-10.48146000",
                        "longitude": "-63.85192000"
                    },
                    {
                        "id": 11035,
                        "name": "Candeias do Jamari",
                        "latitude": "-8.94512000",
                        "longitude": "-63.35731000"
                    },
                    {
                        "id": 11186,
                        "name": "Castanheiras",
                        "latitude": "-11.42661000",
                        "longitude": "-61.88918000"
                    },
                    {
                        "id": 11244,
                        "name": "Cerejeiras",
                        "latitude": "-13.18319000",
                        "longitude": "-61.47518000"
                    },
                    {
                        "id": 11282,
                        "name": "Chupinguaia",
                        "latitude": "-12.67240000",
                        "longitude": "-60.92622000"
                    },
                    {
                        "id": 11331,
                        "name": "Colorado do Oeste",
                        "latitude": "-13.08252000",
                        "longitude": "-60.49419000"
                    },
                    {
                        "id": 11441,
                        "name": "Corumbiara",
                        "latitude": "-12.87592000",
                        "longitude": "-61.11993000"
                    },
                    {
                        "id": 11448,
                        "name": "Costa Marques",
                        "latitude": "-12.06168000",
                        "longitude": "-64.07323000"
                    },
                    {
                        "id": 11511,
                        "name": "Cujubim",
                        "latitude": "-8.97819000",
                        "longitude": "-62.44252000"
                    },
                    {
                        "id": 11735,
                        "name": "Espigão d'Oeste",
                        "latitude": "-11.46622000",
                        "longitude": "-60.69924000"
                    },
                    {
                        "id": 11766,
                        "name": "Extrema",
                        "latitude": "-9.77136000",
                        "longitude": "-66.35583000"
                    },
                    {
                        "id": 11984,
                        "name": "Governador Jorge Teixeira",
                        "latitude": "-10.78462000",
                        "longitude": "-63.04433000"
                    },
                    {
                        "id": 12019,
                        "name": "Guajará Mirim",
                        "latitude": "-10.78356000",
                        "longitude": "-65.33552000"
                    },
                    {
                        "id": 12020,
                        "name": "Guajará-Mirim",
                        "latitude": "-11.33108000",
                        "longitude": "-64.44095000"
                    },
                    {
                        "id": 12439,
                        "name": "Itapuã do Oeste",
                        "latitude": "-9.03389000",
                        "longitude": "-63.23215000"
                    },
                    {
                        "id": 12596,
                        "name": "Jaru",
                        "latitude": "-10.43889000",
                        "longitude": "-62.46639000"
                    },
                    {
                        "id": 12629,
                        "name": "Ji Paraná",
                        "latitude": "-10.88528000",
                        "longitude": "-61.95167000"
                    },
                    {
                        "id": 12630,
                        "name": "Ji-Paraná",
                        "latitude": "-10.83398000",
                        "longitude": "-61.96014000"
                    },
                    {
                        "id": 12899,
                        "name": "Machadinho d'Oeste",
                        "latitude": "-9.23953000",
                        "longitude": "-62.11241000"
                    },
                    {
                        "id": 13128,
                        "name": "Ministro Andreazza",
                        "latitude": "-11.16029000",
                        "longitude": "-61.56897000"
                    },
                    {
                        "id": 13146,
                        "name": "Mirante da Serra",
                        "latitude": "-11.13706000",
                        "longitude": "-62.86154000"
                    },
                    {
                        "id": 13207,
                        "name": "Monte Negro",
                        "latitude": "-10.30450000",
                        "longitude": "-63.35402000"
                    },
                    {
                        "id": 13360,
                        "name": "Nova Brasilândia d'Oeste",
                        "latitude": "-11.49111000",
                        "longitude": "-62.16495000"
                    },
                    {
                        "id": 13401,
                        "name": "Nova Mamoré",
                        "latitude": "-10.53837000",
                        "longitude": "-64.49429000"
                    },
                    {
                        "id": 13442,
                        "name": "Nova União",
                        "latitude": "-10.94938000",
                        "longitude": "-62.51087000"
                    },
                    {
                        "id": 13464,
                        "name": "Novo Horizonte do Oeste",
                        "latitude": "-11.70769000",
                        "longitude": "-62.07989000"
                    },
                    {
                        "id": 13543,
                        "name": "Ouro Preto do Oeste",
                        "latitude": "-10.74806000",
                        "longitude": "-62.21583000"
                    },
                    {
                        "id": 13669,
                        "name": "Parecis",
                        "latitude": "-12.28659000",
                        "longitude": "-61.31662000"
                    },
                    {
                        "id": 13845,
                        "name": "Pimenta Bueno",
                        "latitude": "-11.67250000",
                        "longitude": "-61.19361000"
                    },
                    {
                        "id": 13847,
                        "name": "Pimenteiras do Oeste",
                        "latitude": "-13.01273000",
                        "longitude": "-61.73762000"
                    },
                    {
                        "id": 14019,
                        "name": "Porto Velho",
                        "latitude": "-9.20787000",
                        "longitude": "-64.31064000"
                    },
                    {
                        "id": 14124,
                        "name": "Pôsto Fiscal Rolim de Moura",
                        "latitude": "-13.08271000",
                        "longitude": "-62.27726000"
                    },
                    {
                        "id": 14091,
                        "name": "Presidente Médici",
                        "latitude": "-11.18523000",
                        "longitude": "-61.94072000"
                    },
                    {
                        "id": 14102,
                        "name": "Primavera de Rondônia",
                        "latitude": "-11.92939000",
                        "longitude": "-61.30611000"
                    },
                    {
                        "id": 14271,
                        "name": "Rio Crespo",
                        "latitude": "-9.71880000",
                        "longitude": "-62.74641000"
                    },
                    {
                        "id": 14336,
                        "name": "Rolim de Moura",
                        "latitude": "-11.75260000",
                        "longitude": "-61.78967000"
                    },
                    {
                        "id": 14493,
                        "name": "Santa Luzia d'Oeste",
                        "latitude": "-12.10467000",
                        "longitude": "-61.79440000"
                    },
                    {
                        "id": 14876,
                        "name": "São Felipe d'Oeste",
                        "latitude": "-11.89774000",
                        "longitude": "-61.47739000"
                    },
                    {
                        "id": 14893,
                        "name": "São Francisco do Guaporé",
                        "latitude": "-12.38313000",
                        "longitude": "-63.12648000"
                    },
                    {
                        "id": 15091,
                        "name": "São Miguel do Guaporé",
                        "latitude": "-11.70783000",
                        "longitude": "-62.93532000"
                    },
                    {
                        "id": 14718,
                        "name": "Seringueiras",
                        "latitude": "-11.92491000",
                        "longitude": "-63.18938000"
                    },
                    {
                        "id": 15269,
                        "name": "Teixeirópolis",
                        "latitude": "-10.99266000",
                        "longitude": "-62.24735000"
                    },
                    {
                        "id": 15302,
                        "name": "Theobroma",
                        "latitude": "-10.10159000",
                        "longitude": "-62.28094000"
                    },
                    {
                        "id": 15482,
                        "name": "Urupá",
                        "latitude": "-11.07917000",
                        "longitude": "-62.38127000"
                    },
                    {
                        "id": 15494,
                        "name": "Vale do Anari",
                        "latitude": "-9.73244000",
                        "longitude": "-61.93919000"
                    },
                    {
                        "id": 15495,
                        "name": "Vale do Paraíso",
                        "latitude": "-10.20652000",
                        "longitude": "-62.06993000"
                    },
                    {
                        "id": 15579,
                        "name": "Vilhena",
                        "latitude": "-12.02062000",
                        "longitude": "-60.27526000"
                    }
                ]
            },
            {
                "id": 4858,
                "name": "Roraima",
                "iso2": "RR",
                "latitude": "2.73759710",
                "longitude": "-62.07509980",
                "type": "state",
                "cities": [
                    {
                        "id": 157014,
                        "name": "Alto Alegre",
                        "latitude": "2.98862450",
                        "longitude": "-61.32004260"
                    },
                    {
                        "id": 142968,
                        "name": "Amajari",
                        "latitude": "3.65416667",
                        "longitude": "-61.41694444"
                    },
                    {
                        "id": 142969,
                        "name": "Boa Vista",
                        "latitude": "2.82000000",
                        "longitude": "-60.67194444"
                    },
                    {
                        "id": 142970,
                        "name": "Bonfim",
                        "latitude": "3.36000000",
                        "longitude": "-59.83277778"
                    },
                    {
                        "id": 142971,
                        "name": "Cantá",
                        "latitude": "2.61000000",
                        "longitude": "-60.59694444"
                    },
                    {
                        "id": 142972,
                        "name": "Caracaraí",
                        "latitude": "1.81583333",
                        "longitude": "-61.12777778"
                    },
                    {
                        "id": 142973,
                        "name": "Caroebe",
                        "latitude": "0.88388889",
                        "longitude": "-59.69583333"
                    },
                    {
                        "id": 142974,
                        "name": "Iracema",
                        "latitude": "2.18194444",
                        "longitude": "-61.04083333"
                    },
                    {
                        "id": 142975,
                        "name": "Mucajaí",
                        "latitude": "2.43000000",
                        "longitude": "-60.90000000"
                    },
                    {
                        "id": 142976,
                        "name": "Normandia",
                        "latitude": "3.88083333",
                        "longitude": "-59.62277778"
                    },
                    {
                        "id": 142977,
                        "name": "Pacaraima",
                        "latitude": "4.43083333",
                        "longitude": "-61.14583333"
                    },
                    {
                        "id": 142978,
                        "name": "Rorainópolis",
                        "latitude": "0.94583333",
                        "longitude": "-60.41777778"
                    },
                    {
                        "id": 142979,
                        "name": "São João da Baliza",
                        "latitude": "0.95083333",
                        "longitude": "-59.91083333"
                    },
                    {
                        "id": 142980,
                        "name": "São Luís",
                        "latitude": "1.00500000",
                        "longitude": "-60.15888889"
                    },
                    {
                        "id": 142981,
                        "name": "Uiramutã",
                        "latitude": "4.59583333",
                        "longitude": "-60.16777778"
                    }
                ]
            },
            {
                "id": 2014,
                "name": "Santa Catarina",
                "iso2": "SC",
                "latitude": "-27.33000000",
                "longitude": "-49.44000000",
                "type": "state",
                "cities": [
                    {
                        "id": 10062,
                        "name": "Abdon Batista",
                        "latitude": "-27.58981000",
                        "longitude": "-51.04023000"
                    },
                    {
                        "id": 10064,
                        "name": "Abelardo Luz",
                        "latitude": "-26.59825000",
                        "longitude": "-52.22321000"
                    },
                    {
                        "id": 10093,
                        "name": "Agrolândia",
                        "latitude": "-27.46387000",
                        "longitude": "-49.83759000"
                    },
                    {
                        "id": 10094,
                        "name": "Agronômica",
                        "latitude": "-27.31658000",
                        "longitude": "-49.73117000"
                    },
                    {
                        "id": 15656,
                        "name": "Água Doce",
                        "latitude": "-26.79693000",
                        "longitude": "-51.63639000"
                    },
                    {
                        "id": 15672,
                        "name": "Águas de Chapecó",
                        "latitude": "-27.07229000",
                        "longitude": "-52.96389000"
                    },
                    {
                        "id": 15667,
                        "name": "Águas Frias",
                        "latitude": "-26.85757000",
                        "longitude": "-52.85062000"
                    },
                    {
                        "id": 15669,
                        "name": "Águas Mornas",
                        "latitude": "-27.74227000",
                        "longitude": "-48.92023000"
                    },
                    {
                        "id": 10134,
                        "name": "Alfredo Wagner",
                        "latitude": "-27.70481000",
                        "longitude": "-49.34069000"
                    },
                    {
                        "id": 10166,
                        "name": "Alto Bela Vista",
                        "latitude": "-27.40999000",
                        "longitude": "-51.93145000"
                    },
                    {
                        "id": 10241,
                        "name": "Anchieta",
                        "latitude": "-26.52666000",
                        "longitude": "-53.35459000"
                    },
                    {
                        "id": 10251,
                        "name": "Angelina",
                        "latitude": "-27.53450000",
                        "longitude": "-49.08558000"
                    },
                    {
                        "id": 10264,
                        "name": "Anita Garibaldi",
                        "latitude": "-27.72616000",
                        "longitude": "-51.05838000"
                    },
                    {
                        "id": 10265,
                        "name": "Anitápolis",
                        "latitude": "-27.90194000",
                        "longitude": "-49.12861000"
                    },
                    {
                        "id": 10274,
                        "name": "Antônio Carlos",
                        "latitude": "-27.49807000",
                        "longitude": "-48.83918000"
                    },
                    {
                        "id": 10296,
                        "name": "Apiúna",
                        "latitude": "-27.10736000",
                        "longitude": "-49.38129000"
                    },
                    {
                        "id": 10307,
                        "name": "Arabutã",
                        "latitude": "-27.14142000",
                        "longitude": "-52.18125000"
                    },
                    {
                        "id": 10346,
                        "name": "Araquari",
                        "latitude": "-26.46833000",
                        "longitude": "-48.80083000"
                    },
                    {
                        "id": 10348,
                        "name": "Araranguá",
                        "latitude": "-28.93954000",
                        "longitude": "-49.51119000"
                    },
                    {
                        "id": 10400,
                        "name": "Armação",
                        "latitude": "-27.74963000",
                        "longitude": "-48.50713000"
                    },
                    {
                        "id": 10399,
                        "name": "Armazém",
                        "latitude": "-28.22409000",
                        "longitude": "-49.00779000"
                    },
                    {
                        "id": 10411,
                        "name": "Arroio Trinta",
                        "latitude": "-26.91617000",
                        "longitude": "-51.34527000"
                    },
                    {
                        "id": 10420,
                        "name": "Arvoredo",
                        "latitude": "-27.06908000",
                        "longitude": "-52.44892000"
                    },
                    {
                        "id": 10423,
                        "name": "Ascurra",
                        "latitude": "-26.98578000",
                        "longitude": "-49.37084000"
                    },
                    {
                        "id": 10437,
                        "name": "Atalanta",
                        "latitude": "-27.44296000",
                        "longitude": "-49.76089000"
                    },
                    {
                        "id": 10451,
                        "name": "Aurora",
                        "latitude": "-27.33930000",
                        "longitude": "-49.57823000"
                    },
                    {
                        "id": 10484,
                        "name": "Balneário Arroio do Silva",
                        "latitude": "-29.00699000",
                        "longitude": "-49.47849000"
                    },
                    {
                        "id": 10485,
                        "name": "Balneário Barra do Sul",
                        "latitude": "-26.41890000",
                        "longitude": "-48.65147000"
                    },
                    {
                        "id": 10486,
                        "name": "Balneário Camboriú",
                        "latitude": "-26.99056000",
                        "longitude": "-48.63472000"
                    },
                    {
                        "id": 10487,
                        "name": "Balneário Gaivota",
                        "latitude": "-29.13006000",
                        "longitude": "-49.61187000"
                    },
                    {
                        "id": 10489,
                        "name": "Balneário Piçarras",
                        "latitude": "-26.75580000",
                        "longitude": "-48.76000000"
                    },
                    {
                        "id": 10490,
                        "name": "Balneário Rincão",
                        "latitude": "-28.82679000",
                        "longitude": "-49.25425000"
                    },
                    {
                        "id": 10499,
                        "name": "Bandeirante",
                        "latitude": "-26.76857000",
                        "longitude": "-53.64907000"
                    },
                    {
                        "id": 10517,
                        "name": "Barra Bonita",
                        "latitude": "-26.68537000",
                        "longitude": "-53.41393000"
                    },
                    {
                        "id": 10521,
                        "name": "Barra Velha",
                        "latitude": "-26.63222000",
                        "longitude": "-48.68472000"
                    },
                    {
                        "id": 10601,
                        "name": "Bela Vista do Toldo",
                        "latitude": "-26.45944000",
                        "longitude": "-50.51061000"
                    },
                    {
                        "id": 10605,
                        "name": "Belmonte",
                        "latitude": "-26.85317000",
                        "longitude": "-53.61399000"
                    },
                    {
                        "id": 10624,
                        "name": "Benedito Novo",
                        "latitude": "-26.78592000",
                        "longitude": "-49.43603000"
                    },
                    {
                        "id": 10648,
                        "name": "Biguaçu",
                        "latitude": "-27.49417000",
                        "longitude": "-48.65556000"
                    },
                    {
                        "id": 10656,
                        "name": "Blumenau",
                        "latitude": "-26.91944000",
                        "longitude": "-49.06611000"
                    },
                    {
                        "id": 10682,
                        "name": "Bocaina do Sul",
                        "latitude": "-27.73891000",
                        "longitude": "-49.91707000"
                    },
                    {
                        "id": 10695,
                        "name": "Bom Jardim da Serra",
                        "latitude": "-28.36743000",
                        "longitude": "-49.64216000"
                    },
                    {
                        "id": 10702,
                        "name": "Bom Jesus",
                        "latitude": "-26.74082000",
                        "longitude": "-52.39184000"
                    },
                    {
                        "id": 10713,
                        "name": "Bom Jesus do Oeste",
                        "latitude": "-26.69047000",
                        "longitude": "-53.09669000"
                    },
                    {
                        "id": 10723,
                        "name": "Bom Retiro",
                        "latitude": "-27.76046000",
                        "longitude": "-49.61964000"
                    },
                    {
                        "id": 10730,
                        "name": "Bombinhas",
                        "latitude": "-27.17876000",
                        "longitude": "-48.50195000"
                    },
                    {
                        "id": 10761,
                        "name": "Botuverá",
                        "latitude": "-27.20456000",
                        "longitude": "-49.11175000"
                    },
                    {
                        "id": 10780,
                        "name": "Braço do Norte",
                        "latitude": "-28.27500000",
                        "longitude": "-49.16556000"
                    },
                    {
                        "id": 10781,
                        "name": "Braço do Trombudo",
                        "latitude": "-27.37888000",
                        "longitude": "-49.91379000"
                    },
                    {
                        "id": 10811,
                        "name": "Brunópolis",
                        "latitude": "-27.34781000",
                        "longitude": "-50.83631000"
                    },
                    {
                        "id": 10812,
                        "name": "Brusque",
                        "latitude": "-27.09795000",
                        "longitude": "-48.91281000"
                    },
                    {
                        "id": 11221,
                        "name": "Caçador",
                        "latitude": "-26.77528000",
                        "longitude": "-51.01500000"
                    },
                    {
                        "id": 10902,
                        "name": "Caibi",
                        "latitude": "-27.03422000",
                        "longitude": "-53.27842000"
                    },
                    {
                        "id": 10930,
                        "name": "Calmon",
                        "latitude": "-26.64037000",
                        "longitude": "-51.02439000"
                    },
                    {
                        "id": 10947,
                        "name": "Camboriú",
                        "latitude": "-27.07562000",
                        "longitude": "-48.71530000"
                    },
                    {
                        "id": 10977,
                        "name": "Campo Alegre",
                        "latitude": "-26.08532000",
                        "longitude": "-49.18746000"
                    },
                    {
                        "id": 10983,
                        "name": "Campo Belo do Sul",
                        "latitude": "-27.83940000",
                        "longitude": "-50.76583000"
                    },
                    {
                        "id": 10986,
                        "name": "Campo Erê",
                        "latitude": "-26.45834000",
                        "longitude": "-53.18257000"
                    },
                    {
                        "id": 11013,
                        "name": "Campos Novos",
                        "latitude": "-27.40167000",
                        "longitude": "-51.22500000"
                    },
                    {
                        "id": 11041,
                        "name": "Canelinha",
                        "latitude": "-27.24874000",
                        "longitude": "-48.78781000"
                    },
                    {
                        "id": 11050,
                        "name": "Canoinhas",
                        "latitude": "-26.17722000",
                        "longitude": "-50.39000000"
                    },
                    {
                        "id": 11095,
                        "name": "Capão Alto",
                        "latitude": "-28.06834000",
                        "longitude": "-50.62921000"
                    },
                    {
                        "id": 11076,
                        "name": "Capinzal",
                        "latitude": "-27.34361000",
                        "longitude": "-51.61194000"
                    },
                    {
                        "id": 11089,
                        "name": "Capivari de Baixo",
                        "latitude": "-28.45237000",
                        "longitude": "-48.95364000"
                    },
                    {
                        "id": 11128,
                        "name": "Carianos",
                        "latitude": "-27.66088000",
                        "longitude": "-48.54318000"
                    },
                    {
                        "id": 11170,
                        "name": "Carvoeira",
                        "latitude": "-27.59898000",
                        "longitude": "-48.52618000"
                    },
                    {
                        "id": 11197,
                        "name": "Catanduvas",
                        "latitude": "-27.05390000",
                        "longitude": "-51.72395000"
                    },
                    {
                        "id": 11217,
                        "name": "Caxambu do Sul",
                        "latitude": "-27.13095000",
                        "longitude": "-52.91856000"
                    },
                    {
                        "id": 11234,
                        "name": "Celso Ramos",
                        "latitude": "-27.63444000",
                        "longitude": "-51.33639000"
                    },
                    {
                        "id": 11255,
                        "name": "Cerro Negro",
                        "latitude": "-27.77270000",
                        "longitude": "-50.94035000"
                    },
                    {
                        "id": 11267,
                        "name": "Chapadão do Lageado",
                        "latitude": "-27.58487000",
                        "longitude": "-49.55644000"
                    },
                    {
                        "id": 11269,
                        "name": "Chapecó",
                        "latitude": "-27.09639000",
                        "longitude": "-52.61833000"
                    },
                    {
                        "id": 11305,
                        "name": "Cocal",
                        "latitude": "-28.60321000",
                        "longitude": "-49.32767000"
                    },
                    {
                        "id": 11308,
                        "name": "Cocal do Sul",
                        "latitude": "-28.59988000",
                        "longitude": "-49.32582000"
                    },
                    {
                        "id": 11367,
                        "name": "Concórdia",
                        "latitude": "-27.22936000",
                        "longitude": "-52.00106000"
                    },
                    {
                        "id": 11402,
                        "name": "Cordilheira Alta",
                        "latitude": "-26.97554000",
                        "longitude": "-52.63305000"
                    },
                    {
                        "id": 11420,
                        "name": "Coronel Freitas",
                        "latitude": "-26.89431000",
                        "longitude": "-52.76329000"
                    },
                    {
                        "id": 11425,
                        "name": "Coronel Martins",
                        "latitude": "-26.54773000",
                        "longitude": "-52.67392000"
                    },
                    {
                        "id": 11432,
                        "name": "Corrego Grande",
                        "latitude": "-27.60141000",
                        "longitude": "-48.50593000"
                    },
                    {
                        "id": 11433,
                        "name": "Correia Pinto",
                        "latitude": "-27.58472000",
                        "longitude": "-50.36111000"
                    },
                    {
                        "id": 11444,
                        "name": "Corupá",
                        "latitude": "-26.42528000",
                        "longitude": "-49.24306000"
                    },
                    {
                        "id": 11450,
                        "name": "Costeira do Pirajubae",
                        "latitude": "-27.63586000",
                        "longitude": "-48.52120000"
                    },
                    {
                        "id": 11465,
                        "name": "Criciúma",
                        "latitude": "-28.67750000",
                        "longitude": "-49.36972000"
                    },
                    {
                        "id": 11517,
                        "name": "Cunha Porã",
                        "latitude": "-26.86612000",
                        "longitude": "-53.21020000"
                    },
                    {
                        "id": 11518,
                        "name": "Cunhataí",
                        "latitude": "-26.97742000",
                        "longitude": "-53.10785000"
                    },
                    {
                        "id": 11525,
                        "name": "Curitibanos",
                        "latitude": "-27.27414000",
                        "longitude": "-50.60962000"
                    },
                    {
                        "id": 11577,
                        "name": "Descanso",
                        "latitude": "-26.87384000",
                        "longitude": "-53.48415000"
                    },
                    {
                        "id": 11595,
                        "name": "Dionísio Cerqueira",
                        "latitude": "-26.33340000",
                        "longitude": "-53.53403000"
                    },
                    {
                        "id": 11639,
                        "name": "Dona Emma",
                        "latitude": "-26.97694000",
                        "longitude": "-49.81076000"
                    },
                    {
                        "id": 11657,
                        "name": "Doutor Pedrinho",
                        "latitude": "-26.71142000",
                        "longitude": "-49.55827000"
                    },
                    {
                        "id": 11706,
                        "name": "Entre Rios",
                        "latitude": "-26.73140000",
                        "longitude": "-52.59697000"
                    },
                    {
                        "id": 11718,
                        "name": "Ermo",
                        "latitude": "-28.97440000",
                        "longitude": "-49.64940000"
                    },
                    {
                        "id": 11722,
                        "name": "Erval Velho",
                        "latitude": "-27.29027000",
                        "longitude": "-51.38648000"
                    },
                    {
                        "id": 11783,
                        "name": "Faxinal dos Guedes",
                        "latitude": "-26.83150000",
                        "longitude": "-52.26214000"
                    },
                    {
                        "id": 11826,
                        "name": "Flor do Sertão",
                        "latitude": "-26.75638000",
                        "longitude": "-53.33675000"
                    },
                    {
                        "id": 11843,
                        "name": "Florianópolis",
                        "latitude": "-27.59667000",
                        "longitude": "-48.54917000"
                    },
                    {
                        "id": 11856,
                        "name": "Formosa do Sul",
                        "latitude": "-26.64697000",
                        "longitude": "-52.80427000"
                    },
                    {
                        "id": 11862,
                        "name": "Forquilhinha",
                        "latitude": "-28.74750000",
                        "longitude": "-49.47222000"
                    },
                    {
                        "id": 11873,
                        "name": "Fraiburgo",
                        "latitude": "-27.04790000",
                        "longitude": "-50.80694000"
                    },
                    {
                        "id": 11890,
                        "name": "Freguesia do Ribeirao da Ilha",
                        "latitude": "-27.71773000",
                        "longitude": "-48.56266000"
                    },
                    {
                        "id": 11897,
                        "name": "Frei Rogério",
                        "latitude": "-27.21783000",
                        "longitude": "-50.77022000"
                    },
                    {
                        "id": 11914,
                        "name": "Galvão",
                        "latitude": "-26.45882000",
                        "longitude": "-52.68535000"
                    },
                    {
                        "id": 11922,
                        "name": "Garopaba",
                        "latitude": "-28.02744000",
                        "longitude": "-48.61450000"
                    },
                    {
                        "id": 11925,
                        "name": "Garuva",
                        "latitude": "-26.06047000",
                        "longitude": "-48.87082000"
                    },
                    {
                        "id": 11927,
                        "name": "Gaspar",
                        "latitude": "-26.93139000",
                        "longitude": "-48.95889000"
                    },
                    {
                        "id": 11979,
                        "name": "Governador Celso Ramos",
                        "latitude": "-27.37201000",
                        "longitude": "-48.57908000"
                    },
                    {
                        "id": 12009,
                        "name": "Grão Pará",
                        "latitude": "-28.13580000",
                        "longitude": "-49.31612000"
                    },
                    {
                        "id": 12000,
                        "name": "Gravatal",
                        "latitude": "-28.31534000",
                        "longitude": "-49.04351000"
                    },
                    {
                        "id": 12012,
                        "name": "Guabiruba",
                        "latitude": "-27.11189000",
                        "longitude": "-49.02215000"
                    },
                    {
                        "id": 12038,
                        "name": "Guaraciaba",
                        "latitude": "-26.57386000",
                        "longitude": "-53.59786000"
                    },
                    {
                        "id": 12042,
                        "name": "Guaramirim",
                        "latitude": "-26.47306000",
                        "longitude": "-49.00278000"
                    },
                    {
                        "id": 12069,
                        "name": "Guarujá do Sul",
                        "latitude": "-26.40561000",
                        "longitude": "-53.47207000"
                    },
                    {
                        "id": 12072,
                        "name": "Guatambú",
                        "latitude": "-27.11045000",
                        "longitude": "-52.78938000"
                    },
                    {
                        "id": 12098,
                        "name": "Herval d'Oeste",
                        "latitude": "-27.20408000",
                        "longitude": "-51.42029000"
                    },
                    {
                        "id": 12128,
                        "name": "Ibiam",
                        "latitude": "-27.20944000",
                        "longitude": "-51.22230000"
                    },
                    {
                        "id": 12135,
                        "name": "Ibicaré",
                        "latitude": "-27.09743000",
                        "longitude": "-51.37144000"
                    },
                    {
                        "id": 12148,
                        "name": "Ibirama",
                        "latitude": "-27.05694000",
                        "longitude": "-49.51778000"
                    },
                    {
                        "id": 12506,
                        "name": "Içara",
                        "latitude": "-28.71333000",
                        "longitude": "-49.30000000"
                    },
                    {
                        "id": 12213,
                        "name": "Ilhota",
                        "latitude": "-26.85404000",
                        "longitude": "-48.88648000"
                    },
                    {
                        "id": 12218,
                        "name": "Imaruí",
                        "latitude": "-28.19624000",
                        "longitude": "-48.82316000"
                    },
                    {
                        "id": 12220,
                        "name": "Imbituba",
                        "latitude": "-28.24000000",
                        "longitude": "-48.67028000"
                    },
                    {
                        "id": 12222,
                        "name": "Imbuia",
                        "latitude": "-27.51118000",
                        "longitude": "-49.40656000"
                    },
                    {
                        "id": 12232,
                        "name": "Indaial",
                        "latitude": "-26.89778000",
                        "longitude": "-49.23167000"
                    },
                    {
                        "id": 12258,
                        "name": "Iomerê",
                        "latitude": "-26.98588000",
                        "longitude": "-51.26049000"
                    },
                    {
                        "id": 12274,
                        "name": "Ipira",
                        "latitude": "-27.38715000",
                        "longitude": "-51.79708000"
                    },
                    {
                        "id": 12287,
                        "name": "Iporã do Oeste",
                        "latitude": "-26.99157000",
                        "longitude": "-53.49023000"
                    },
                    {
                        "id": 12289,
                        "name": "Ipuaçu",
                        "latitude": "-26.67076000",
                        "longitude": "-52.48261000"
                    },
                    {
                        "id": 12296,
                        "name": "Ipumirim",
                        "latitude": "-27.04778000",
                        "longitude": "-52.14024000"
                    },
                    {
                        "id": 12302,
                        "name": "Iraceminha",
                        "latitude": "-26.85495000",
                        "longitude": "-53.31848000"
                    },
                    {
                        "id": 12307,
                        "name": "Irani",
                        "latitude": "-27.03626000",
                        "longitude": "-51.91783000"
                    },
                    {
                        "id": 12313,
                        "name": "Irati",
                        "latitude": "-26.64113000",
                        "longitude": "-52.89959000"
                    },
                    {
                        "id": 12319,
                        "name": "Irineópolis",
                        "latitude": "-26.33324000",
                        "longitude": "-50.78333000"
                    },
                    {
                        "id": 12495,
                        "name": "Itá",
                        "latitude": "-27.24410000",
                        "longitude": "-52.33213000"
                    },
                    {
                        "id": 12343,
                        "name": "Itacorubi",
                        "latitude": "-27.58315000",
                        "longitude": "-48.49503000"
                    },
                    {
                        "id": 12365,
                        "name": "Itaiópolis",
                        "latitude": "-26.47612000",
                        "longitude": "-49.90456000"
                    },
                    {
                        "id": 12366,
                        "name": "Itajaí",
                        "latitude": "-26.90778000",
                        "longitude": "-48.66194000"
                    },
                    {
                        "id": 12408,
                        "name": "Itapema",
                        "latitude": "-27.10715000",
                        "longitude": "-48.62440000"
                    },
                    {
                        "id": 12422,
                        "name": "Itapiranga",
                        "latitude": "-27.10055000",
                        "longitude": "-53.72164000"
                    },
                    {
                        "id": 12435,
                        "name": "Itapoá",
                        "latitude": "-26.04546000",
                        "longitude": "-48.66869000"
                    },
                    {
                        "id": 12491,
                        "name": "Ituporanga",
                        "latitude": "-27.48272000",
                        "longitude": "-49.49128000"
                    },
                    {
                        "id": 12512,
                        "name": "Jaborá",
                        "latitude": "-27.12846000",
                        "longitude": "-51.79869000"
                    },
                    {
                        "id": 12526,
                        "name": "Jacinto Machado",
                        "latitude": "-29.01184000",
                        "longitude": "-49.88785000"
                    },
                    {
                        "id": 12548,
                        "name": "Jaguaruna",
                        "latitude": "-28.62145000",
                        "longitude": "-49.02529000"
                    },
                    {
                        "id": 12581,
                        "name": "Jaraguá do Sul",
                        "latitude": "-26.48611000",
                        "longitude": "-49.06667000"
                    },
                    {
                        "id": 12593,
                        "name": "Jardinópolis",
                        "latitude": "-26.73553000",
                        "longitude": "-52.89460000"
                    },
                    {
                        "id": 12641,
                        "name": "Joaçaba",
                        "latitude": "-27.17806000",
                        "longitude": "-51.50472000"
                    },
                    {
                        "id": 12645,
                        "name": "Joinville",
                        "latitude": "-26.30444000",
                        "longitude": "-48.84556000"
                    },
                    {
                        "id": 12650,
                        "name": "José Boiteux",
                        "latitude": "-26.83852000",
                        "longitude": "-49.64618000"
                    },
                    {
                        "id": 12691,
                        "name": "Jupiá",
                        "latitude": "-26.41103000",
                        "longitude": "-52.73097000"
                    },
                    {
                        "id": 12721,
                        "name": "Lacerdópolis",
                        "latitude": "-27.25354000",
                        "longitude": "-51.58504000"
                    },
                    {
                        "id": 12727,
                        "name": "Lages",
                        "latitude": "-27.81611000",
                        "longitude": "-50.32611000"
                    },
                    {
                        "id": 12732,
                        "name": "Lagoa",
                        "latitude": "-27.60491000",
                        "longitude": "-48.46713000"
                    },
                    {
                        "id": 12771,
                        "name": "Laguna",
                        "latitude": "-28.48250000",
                        "longitude": "-48.78083000"
                    },
                    {
                        "id": 12777,
                        "name": "Lajeado Grande",
                        "latitude": "-26.85054000",
                        "longitude": "-52.54065000"
                    },
                    {
                        "id": 12803,
                        "name": "Laurentino",
                        "latitude": "-27.20853000",
                        "longitude": "-49.73411000"
                    },
                    {
                        "id": 12804,
                        "name": "Lauro Muller",
                        "latitude": "-28.39278000",
                        "longitude": "-49.39667000"
                    },
                    {
                        "id": 12814,
                        "name": "Lebon Régis",
                        "latitude": "-26.88524000",
                        "longitude": "-50.67811000"
                    },
                    {
                        "id": 12819,
                        "name": "Leoberto Leal",
                        "latitude": "-27.48804000",
                        "longitude": "-49.25121000"
                    },
                    {
                        "id": 12838,
                        "name": "Lindóia do Sul",
                        "latitude": "-27.03246000",
                        "longitude": "-52.04059000"
                    },
                    {
                        "id": 12851,
                        "name": "Lontras",
                        "latitude": "-27.17928000",
                        "longitude": "-49.49924000"
                    },
                    {
                        "id": 12865,
                        "name": "Luiz Alves",
                        "latitude": "-26.73625000",
                        "longitude": "-48.88531000"
                    },
                    {
                        "id": 12874,
                        "name": "Luzerna",
                        "latitude": "-27.07656000",
                        "longitude": "-51.49348000"
                    },
                    {
                        "id": 12902,
                        "name": "Macieira",
                        "latitude": "-26.81070000",
                        "longitude": "-51.34343000"
                    },
                    {
                        "id": 12910,
                        "name": "Mafra",
                        "latitude": "-26.11139000",
                        "longitude": "-49.80528000"
                    },
                    {
                        "id": 12920,
                        "name": "Major Gercino",
                        "latitude": "-27.42331000",
                        "longitude": "-49.05744000"
                    },
                    {
                        "id": 12923,
                        "name": "Major Vieira",
                        "latitude": "-26.49482000",
                        "longitude": "-50.32712000"
                    },
                    {
                        "id": 12967,
                        "name": "Maracajá",
                        "latitude": "-28.85185000",
                        "longitude": "-49.46443000"
                    },
                    {
                        "id": 12986,
                        "name": "Maravilha",
                        "latitude": "-26.75798000",
                        "longitude": "-53.18283000"
                    },
                    {
                        "id": 13002,
                        "name": "Marema",
                        "latitude": "-26.79773000",
                        "longitude": "-52.62047000"
                    },
                    {
                        "id": 13044,
                        "name": "Massaranduba",
                        "latitude": "-26.61983000",
                        "longitude": "-48.98214000"
                    },
                    {
                        "id": 13070,
                        "name": "Matos Costa",
                        "latitude": "-26.48360000",
                        "longitude": "-51.16293000"
                    },
                    {
                        "id": 13095,
                        "name": "Meleiro",
                        "latitude": "-28.85788000",
                        "longitude": "-49.59973000"
                    },
                    {
                        "id": 13155,
                        "name": "Mirim Doce",
                        "latitude": "-27.17316000",
                        "longitude": "-50.18872000"
                    },
                    {
                        "id": 13161,
                        "name": "Modelo",
                        "latitude": "-26.77290000",
                        "longitude": "-53.05042000"
                    },
                    {
                        "id": 13174,
                        "name": "Mondaí",
                        "latitude": "-27.08404000",
                        "longitude": "-53.43972000"
                    },
                    {
                        "id": 13200,
                        "name": "Monte Carlo",
                        "latitude": "-27.18677000",
                        "longitude": "-50.92110000"
                    },
                    {
                        "id": 13203,
                        "name": "Monte Castelo",
                        "latitude": "-26.61655000",
                        "longitude": "-50.28851000"
                    },
                    {
                        "id": 13245,
                        "name": "Morro da Cruz",
                        "latitude": "-27.58490000",
                        "longitude": "-48.53562000"
                    },
                    {
                        "id": 13246,
                        "name": "Morro da Fumaça",
                        "latitude": "-28.65083000",
                        "longitude": "-49.21000000"
                    },
                    {
                        "id": 13242,
                        "name": "Morro Grande",
                        "latitude": "-28.72547000",
                        "longitude": "-49.74789000"
                    },
                    {
                        "id": 13306,
                        "name": "Navegantes",
                        "latitude": "-26.89889000",
                        "longitude": "-48.65417000"
                    },
                    {
                        "id": 13373,
                        "name": "Nova Erechim",
                        "latitude": "-26.91297000",
                        "longitude": "-52.89851000"
                    },
                    {
                        "id": 13394,
                        "name": "Nova Itaberaba",
                        "latitude": "-26.93156000",
                        "longitude": "-52.84006000"
                    },
                    {
                        "id": 13440,
                        "name": "Nova Trento",
                        "latitude": "-27.30470000",
                        "longitude": "-49.04260000"
                    },
                    {
                        "id": 13444,
                        "name": "Nova Veneza",
                        "latitude": "-28.70447000",
                        "longitude": "-49.58779000"
                    },
                    {
                        "id": 13462,
                        "name": "Novo Horizonte",
                        "latitude": "-26.49656000",
                        "longitude": "-52.78100000"
                    },
                    {
                        "id": 13521,
                        "name": "Orleans",
                        "latitude": "-28.30008000",
                        "longitude": "-49.35423000"
                    },
                    {
                        "id": 13531,
                        "name": "Otacílio Costa",
                        "latitude": "-27.48306000",
                        "longitude": "-50.12194000"
                    },
                    {
                        "id": 13537,
                        "name": "Ouro",
                        "latitude": "-27.28699000",
                        "longitude": "-51.68164000"
                    },
                    {
                        "id": 13546,
                        "name": "Ouro Verde",
                        "latitude": "-26.73257000",
                        "longitude": "-52.27153000"
                    },
                    {
                        "id": 13567,
                        "name": "Paial",
                        "latitude": "-27.20297000",
                        "longitude": "-52.47551000"
                    },
                    {
                        "id": 13570,
                        "name": "Painel",
                        "latitude": "-27.97471000",
                        "longitude": "-50.05976000"
                    },
                    {
                        "id": 13580,
                        "name": "Palhoça",
                        "latitude": "-27.64528000",
                        "longitude": "-48.66778000"
                    },
                    {
                        "id": 13582,
                        "name": "Palma Sola",
                        "latitude": "-26.39154000",
                        "longitude": "-53.33171000"
                    },
                    {
                        "id": 13590,
                        "name": "Palmeira",
                        "latitude": "-27.55649000",
                        "longitude": "-50.16497000"
                    },
                    {
                        "id": 13608,
                        "name": "Palmitos",
                        "latitude": "-27.08066000",
                        "longitude": "-53.17812000"
                    },
                    {
                        "id": 13617,
                        "name": "Pantanal",
                        "latitude": "-27.60985000",
                        "longitude": "-48.51648000"
                    },
                    {
                        "id": 13619,
                        "name": "Pantano do Sul",
                        "latitude": "-27.77972000",
                        "longitude": "-48.50861000"
                    },
                    {
                        "id": 13621,
                        "name": "Papanduva",
                        "latitude": "-26.47628000",
                        "longitude": "-50.17467000"
                    },
                    {
                        "id": 13660,
                        "name": "Paraíso",
                        "latitude": "-26.66872000",
                        "longitude": "-53.68550000"
                    },
                    {
                        "id": 13698,
                        "name": "Passo de Torres",
                        "latitude": "-29.29393000",
                        "longitude": "-49.74094000"
                    },
                    {
                        "id": 13701,
                        "name": "Passos Maia",
                        "latitude": "-26.70774000",
                        "longitude": "-51.94716000"
                    },
                    {
                        "id": 13735,
                        "name": "Paulo Lopes",
                        "latitude": "-27.94684000",
                        "longitude": "-48.74058000"
                    },
                    {
                        "id": 13763,
                        "name": "Pedras Grandes",
                        "latitude": "-28.48270000",
                        "longitude": "-49.22027000"
                    },
                    {
                        "id": 13796,
                        "name": "Penha",
                        "latitude": "-26.80226000",
                        "longitude": "-48.62710000"
                    },
                    {
                        "id": 13810,
                        "name": "Peritiba",
                        "latitude": "-27.34845000",
                        "longitude": "-51.88687000"
                    },
                    {
                        "id": 13820,
                        "name": "Petrolândia",
                        "latitude": "-27.53735000",
                        "longitude": "-49.67274000"
                    },
                    {
                        "id": 13864,
                        "name": "Pinhalzinho",
                        "latitude": "-26.81930000",
                        "longitude": "-52.97639000"
                    },
                    {
                        "id": 13870,
                        "name": "Pinheiro Preto",
                        "latitude": "-27.05458000",
                        "longitude": "-51.22708000"
                    },
                    {
                        "id": 13909,
                        "name": "Piratuba",
                        "latitude": "-27.45623000",
                        "longitude": "-51.77474000"
                    },
                    {
                        "id": 13941,
                        "name": "Planalto Alegre",
                        "latitude": "-27.07348000",
                        "longitude": "-52.85503000"
                    },
                    {
                        "id": 13953,
                        "name": "Pomerode",
                        "latitude": "-26.72404000",
                        "longitude": "-49.16897000"
                    },
                    {
                        "id": 13965,
                        "name": "Ponte Alta",
                        "latitude": "-27.42574000",
                        "longitude": "-50.29365000"
                    },
                    {
                        "id": 13967,
                        "name": "Ponte Alta do Norte",
                        "latitude": "-27.18129000",
                        "longitude": "-50.43580000"
                    },
                    {
                        "id": 13972,
                        "name": "Ponte Serrada",
                        "latitude": "-26.86053000",
                        "longitude": "-51.91066000"
                    },
                    {
                        "id": 14000,
                        "name": "Porto Belo",
                        "latitude": "-27.15778000",
                        "longitude": "-48.55306000"
                    },
                    {
                        "id": 14018,
                        "name": "Porto União",
                        "latitude": "-26.23806000",
                        "longitude": "-51.07833000"
                    },
                    {
                        "id": 14041,
                        "name": "Pouso Redondo",
                        "latitude": "-27.30394000",
                        "longitude": "-49.98473000"
                    },
                    {
                        "id": 14064,
                        "name": "Praia Grande",
                        "latitude": "-29.20318000",
                        "longitude": "-50.03412000"
                    },
                    {
                        "id": 14077,
                        "name": "Presidente Castello Branco",
                        "latitude": "-27.23647000",
                        "longitude": "-51.77999000"
                    },
                    {
                        "id": 14083,
                        "name": "Presidente Getúlio",
                        "latitude": "-27.06188000",
                        "longitude": "-49.71403000"
                    },
                    {
                        "id": 14093,
                        "name": "Presidente Nereu",
                        "latitude": "-27.26320000",
                        "longitude": "-49.32267000"
                    },
                    {
                        "id": 14106,
                        "name": "Princesa",
                        "latitude": "-26.43219000",
                        "longitude": "-53.62477000"
                    },
                    {
                        "id": 14149,
                        "name": "Quilombo",
                        "latitude": "-26.72644000",
                        "longitude": "-52.67673000"
                    },
                    {
                        "id": 14173,
                        "name": "Rancho Queimado",
                        "latitude": "-27.70731000",
                        "longitude": "-49.07164000"
                    },
                    {
                        "id": 14202,
                        "name": "Residencia Moacir PU5BHV",
                        "latitude": "-26.90967000",
                        "longitude": "-49.36547000"
                    },
                    {
                        "id": 14246,
                        "name": "Ribeirão da Ilha",
                        "latitude": "-27.69934000",
                        "longitude": "-48.53219000"
                    },
                    {
                        "id": 14304,
                        "name": "Rio das Antas",
                        "latitude": "-26.90733000",
                        "longitude": "-51.02961000"
                    },
                    {
                        "id": 14311,
                        "name": "Rio do Campo",
                        "latitude": "-26.86090000",
                        "longitude": "-50.11202000"
                    },
                    {
                        "id": 14313,
                        "name": "Rio do Oeste",
                        "latitude": "-27.14870000",
                        "longitude": "-49.84549000"
                    },
                    {
                        "id": 14316,
                        "name": "Rio do Sul",
                        "latitude": "-27.21417000",
                        "longitude": "-49.64306000"
                    },
                    {
                        "id": 14318,
                        "name": "Rio dos Cedros",
                        "latitude": "-26.61087000",
                        "longitude": "-49.37226000"
                    },
                    {
                        "id": 14275,
                        "name": "Rio Fortuna",
                        "latitude": "-28.08443000",
                        "longitude": "-49.20120000"
                    },
                    {
                        "id": 14282,
                        "name": "Rio Negrinho",
                        "latitude": "-26.25444000",
                        "longitude": "-49.51833000"
                    },
                    {
                        "id": 14296,
                        "name": "Rio Rufino",
                        "latitude": "-27.95567000",
                        "longitude": "-49.77920000"
                    },
                    {
                        "id": 14298,
                        "name": "Rio Tavares",
                        "latitude": "-27.64529000",
                        "longitude": "-48.47486000"
                    },
                    {
                        "id": 14322,
                        "name": "Riqueza",
                        "latitude": "-26.98193000",
                        "longitude": "-53.33956000"
                    },
                    {
                        "id": 14328,
                        "name": "Rodeio",
                        "latitude": "-26.92278000",
                        "longitude": "-49.36639000"
                    },
                    {
                        "id": 14339,
                        "name": "Romelândia",
                        "latitude": "-26.67239000",
                        "longitude": "-53.31093000"
                    },
                    {
                        "id": 14371,
                        "name": "Saco dos Limoes",
                        "latitude": "-27.60864000",
                        "longitude": "-48.53605000"
                    },
                    {
                        "id": 14380,
                        "name": "Salete",
                        "latitude": "-26.93760000",
                        "longitude": "-49.99718000"
                    },
                    {
                        "id": 14394,
                        "name": "Saltinho",
                        "latitude": "-26.58366000",
                        "longitude": "-53.02568000"
                    },
                    {
                        "id": 14397,
                        "name": "Salto Veloso",
                        "latitude": "-26.90818000",
                        "longitude": "-51.41468000"
                    },
                    {
                        "id": 14414,
                        "name": "Sangão",
                        "latitude": "-28.67007000",
                        "longitude": "-49.12209000"
                    },
                    {
                        "id": 14432,
                        "name": "Santa Cecília",
                        "latitude": "-26.96083000",
                        "longitude": "-50.42694000"
                    },
                    {
                        "id": 14473,
                        "name": "Santa Helena",
                        "latitude": "-26.92350000",
                        "longitude": "-53.60898000"
                    },
                    {
                        "id": 14520,
                        "name": "Santa Monica",
                        "latitude": "-27.59137000",
                        "longitude": "-48.50756000"
                    },
                    {
                        "id": 14544,
                        "name": "Santa Rosa de Lima",
                        "latitude": "-28.01252000",
                        "longitude": "-49.18941000"
                    },
                    {
                        "id": 14548,
                        "name": "Santa Rosa do Sul",
                        "latitude": "-29.09751000",
                        "longitude": "-49.73510000"
                    },
                    {
                        "id": 14559,
                        "name": "Santa Terezinha",
                        "latitude": "-26.66961000",
                        "longitude": "-50.01340000"
                    },
                    {
                        "id": 14563,
                        "name": "Santa Terezinha do Progresso",
                        "latitude": "-26.59871000",
                        "longitude": "-53.18418000"
                    },
                    {
                        "id": 14601,
                        "name": "Santiago do Sul",
                        "latitude": "-26.63060000",
                        "longitude": "-52.67466000"
                    },
                    {
                        "id": 14604,
                        "name": "Santo Amaro da Imperatriz",
                        "latitude": "-27.68806000",
                        "longitude": "-48.77861000"
                    },
                    {
                        "id": 14840,
                        "name": "São Bento do Sul",
                        "latitude": "-26.25028000",
                        "longitude": "-49.37861000"
                    },
                    {
                        "id": 14844,
                        "name": "São Bernardino",
                        "latitude": "-26.46259000",
                        "longitude": "-52.96921000"
                    },
                    {
                        "id": 14847,
                        "name": "São Bonifácio",
                        "latitude": "-27.95656000",
                        "longitude": "-48.93970000"
                    },
                    {
                        "id": 14856,
                        "name": "São Carlos",
                        "latitude": "-27.04450000",
                        "longitude": "-53.03549000"
                    },
                    {
                        "id": 14859,
                        "name": "São Cristóvão do Sul",
                        "latitude": "-27.26707000",
                        "longitude": "-50.37731000"
                    },
                    {
                        "id": 14864,
                        "name": "São Domingos",
                        "latitude": "-26.56428000",
                        "longitude": "-52.55695000"
                    },
                    {
                        "id": 14898,
                        "name": "São Francisco do Sul",
                        "latitude": "-26.24333000",
                        "longitude": "-48.63806000"
                    },
                    {
                        "id": 15001,
                        "name": "São João Batista",
                        "latitude": "-27.27611000",
                        "longitude": "-48.84944000"
                    },
                    {
                        "id": 15029,
                        "name": "São João do Itaperiú",
                        "latitude": "-26.60265000",
                        "longitude": "-48.80051000"
                    },
                    {
                        "id": 15034,
                        "name": "São João do Oeste",
                        "latitude": "-27.08310000",
                        "longitude": "-53.59218000"
                    },
                    {
                        "id": 15045,
                        "name": "São João do Sul",
                        "latitude": "-29.20713000",
                        "longitude": "-49.85103000"
                    },
                    {
                        "id": 14930,
                        "name": "São Joaquim",
                        "latitude": "-28.29389000",
                        "longitude": "-49.93167000"
                    },
                    {
                        "id": 14938,
                        "name": "São José",
                        "latitude": "-28.21171000",
                        "longitude": "-49.16320000"
                    },
                    {
                        "id": 14966,
                        "name": "São José do Cedro",
                        "latitude": "-26.48127000",
                        "longitude": "-53.56285000"
                    },
                    {
                        "id": 14967,
                        "name": "São José do Cerrito",
                        "latitude": "-27.60401000",
                        "longitude": "-50.65663000"
                    },
                    {
                        "id": 15055,
                        "name": "São Lourenço do Oeste",
                        "latitude": "-26.35917000",
                        "longitude": "-52.85111000"
                    },
                    {
                        "id": 15058,
                        "name": "São Ludgero",
                        "latitude": "-28.34254000",
                        "longitude": "-49.17537000"
                    },
                    {
                        "id": 15073,
                        "name": "São Martinho",
                        "latitude": "-28.10511000",
                        "longitude": "-48.98564000"
                    },
                    {
                        "id": 15081,
                        "name": "São Miguel da Boa Vista",
                        "latitude": "-26.68603000",
                        "longitude": "-53.25718000"
                    },
                    {
                        "id": 15093,
                        "name": "São Miguel do Oeste",
                        "latitude": "-26.71868000",
                        "longitude": "-53.51940000"
                    },
                    {
                        "id": 15114,
                        "name": "São Pedro de Alcântara",
                        "latitude": "-27.57276000",
                        "longitude": "-48.83917000"
                    },
                    {
                        "id": 14677,
                        "name": "Saudades",
                        "latitude": "-26.87900000",
                        "longitude": "-53.04038000"
                    },
                    {
                        "id": 14679,
                        "name": "Schroeder",
                        "latitude": "-26.41250000",
                        "longitude": "-49.07306000"
                    },
                    {
                        "id": 14681,
                        "name": "Seara",
                        "latitude": "-27.14478000",
                        "longitude": "-52.34857000"
                    },
                    {
                        "id": 14722,
                        "name": "Serra Alta",
                        "latitude": "-26.70236000",
                        "longitude": "-53.01399000"
                    },
                    {
                        "id": 14772,
                        "name": "Siderópolis",
                        "latitude": "-28.59778000",
                        "longitude": "-49.42444000"
                    },
                    {
                        "id": 14808,
                        "name": "Sombrio",
                        "latitude": "-29.11389000",
                        "longitude": "-49.61667000"
                    },
                    {
                        "id": 14821,
                        "name": "Sul Brasil",
                        "latitude": "-26.70686000",
                        "longitude": "-52.94355000"
                    },
                    {
                        "id": 15205,
                        "name": "Taió",
                        "latitude": "-27.08902000",
                        "longitude": "-50.09933000"
                    },
                    {
                        "id": 15216,
                        "name": "Tangará",
                        "latitude": "-27.12587000",
                        "longitude": "-51.09938000"
                    },
                    {
                        "id": 15228,
                        "name": "Tapera",
                        "latitude": "-27.68528000",
                        "longitude": "-48.55124000"
                    },
                    {
                        "id": 15308,
                        "name": "Tigrinhos",
                        "latitude": "-26.66573000",
                        "longitude": "-53.16125000"
                    },
                    {
                        "id": 15309,
                        "name": "Tijucas",
                        "latitude": "-27.24701000",
                        "longitude": "-48.71619000"
                    },
                    {
                        "id": 15315,
                        "name": "Timbé do Sul",
                        "latitude": "-28.79089000",
                        "longitude": "-49.89509000"
                    },
                    {
                        "id": 15316,
                        "name": "Timbó",
                        "latitude": "-26.82056000",
                        "longitude": "-49.28734000"
                    },
                    {
                        "id": 15317,
                        "name": "Timbó Grande",
                        "latitude": "-26.62458000",
                        "longitude": "-50.63553000"
                    },
                    {
                        "id": 15370,
                        "name": "Três Barras",
                        "latitude": "-26.16511000",
                        "longitude": "-50.27142000"
                    },
                    {
                        "id": 15355,
                        "name": "Treviso",
                        "latitude": "-28.49941000",
                        "longitude": "-49.50360000"
                    },
                    {
                        "id": 15357,
                        "name": "Treze de Maio",
                        "latitude": "-28.53919000",
                        "longitude": "-49.14504000"
                    },
                    {
                        "id": 15356,
                        "name": "Treze Tílias",
                        "latitude": "-26.95726000",
                        "longitude": "-51.43183000"
                    },
                    {
                        "id": 15359,
                        "name": "Trindade",
                        "latitude": "-27.58612000",
                        "longitude": "-48.52335000"
                    },
                    {
                        "id": 15368,
                        "name": "Trombudo Central",
                        "latitude": "-27.30803000",
                        "longitude": "-49.81251000"
                    },
                    {
                        "id": 15385,
                        "name": "Tubarão",
                        "latitude": "-28.46667000",
                        "longitude": "-49.00694000"
                    },
                    {
                        "id": 15397,
                        "name": "Tunápolis",
                        "latitude": "-26.99245000",
                        "longitude": "-53.65618000"
                    },
                    {
                        "id": 15419,
                        "name": "Turvo",
                        "latitude": "-28.89831000",
                        "longitude": "-49.68268000"
                    },
                    {
                        "id": 15461,
                        "name": "União do Oeste",
                        "latitude": "-26.79980000",
                        "longitude": "-52.89258000"
                    },
                    {
                        "id": 15473,
                        "name": "Urubici",
                        "latitude": "-28.04998000",
                        "longitude": "-49.57417000"
                    },
                    {
                        "id": 15481,
                        "name": "Urupema",
                        "latitude": "-28.04160000",
                        "longitude": "-49.92971000"
                    },
                    {
                        "id": 15484,
                        "name": "Urussanga",
                        "latitude": "-28.47460000",
                        "longitude": "-49.31252000"
                    },
                    {
                        "id": 15516,
                        "name": "Vargeão",
                        "latitude": "-26.84426000",
                        "longitude": "-52.15332000"
                    },
                    {
                        "id": 15507,
                        "name": "Vargem",
                        "latitude": "-27.45675000",
                        "longitude": "-50.95789000"
                    },
                    {
                        "id": 15511,
                        "name": "Vargem Bonita",
                        "latitude": "-26.93296000",
                        "longitude": "-51.74642000"
                    },
                    {
                        "id": 15560,
                        "name": "Vidal Ramos",
                        "latitude": "-27.38973000",
                        "longitude": "-49.33820000"
                    },
                    {
                        "id": 15561,
                        "name": "Videira",
                        "latitude": "-27.03437000",
                        "longitude": "-51.10156000"
                    },
                    {
                        "id": 15594,
                        "name": "Vitor Meireles",
                        "latitude": "-26.82672000",
                        "longitude": "-49.85522000"
                    },
                    {
                        "id": 15632,
                        "name": "Witmarsum",
                        "latitude": "-26.95010000",
                        "longitude": "-49.85590000"
                    },
                    {
                        "id": 15636,
                        "name": "Xanxerê",
                        "latitude": "-26.86668000",
                        "longitude": "-52.41490000"
                    },
                    {
                        "id": 15638,
                        "name": "Xavantina",
                        "latitude": "-26.98819000",
                        "longitude": "-52.32905000"
                    },
                    {
                        "id": 15639,
                        "name": "Xaxim",
                        "latitude": "-26.98685000",
                        "longitude": "-52.51611000"
                    },
                    {
                        "id": 15646,
                        "name": "Zortéa",
                        "latitude": "-27.49740000",
                        "longitude": "-51.50863000"
                    }
                ]
            },
            {
                "id": 2021,
                "name": "São Paulo",
                "iso2": "SP",
                "latitude": "-23.55051990",
                "longitude": "-46.63330940",
                "type": "state",
                "cities": [
                    {
                        "id": 10080,
                        "name": "Adamantina",
                        "latitude": "-21.59136000",
                        "longitude": "-51.06669000"
                    },
                    {
                        "id": 10082,
                        "name": "Adolfo",
                        "latitude": "-21.28535000",
                        "longitude": "-49.65497000"
                    },
                    {
                        "id": 10096,
                        "name": "Aguaí",
                        "latitude": "-22.02590000",
                        "longitude": "-47.06702000"
                    },
                    {
                        "id": 15671,
                        "name": "Águas da Prata",
                        "latitude": "-21.91623000",
                        "longitude": "-46.68666000"
                    },
                    {
                        "id": 15673,
                        "name": "Águas de Lindóia",
                        "latitude": "-22.47639000",
                        "longitude": "-46.63278000"
                    },
                    {
                        "id": 15674,
                        "name": "Águas de Santa Bárbara",
                        "latitude": "-22.85764000",
                        "longitude": "-49.25362000"
                    },
                    {
                        "id": 15675,
                        "name": "Águas de São Pedro",
                        "latitude": "-22.60238000",
                        "longitude": "-47.87481000"
                    },
                    {
                        "id": 10098,
                        "name": "Agudos",
                        "latitude": "-22.58942000",
                        "longitude": "-49.16164000"
                    },
                    {
                        "id": 10114,
                        "name": "Alambari",
                        "latitude": "-23.53745000",
                        "longitude": "-47.86273000"
                    },
                    {
                        "id": 10132,
                        "name": "Alfredo Marcondes",
                        "latitude": "-21.92954000",
                        "longitude": "-51.39519000"
                    },
                    {
                        "id": 10152,
                        "name": "Altair",
                        "latitude": "-20.53889000",
                        "longitude": "-49.10219000"
                    },
                    {
                        "id": 10159,
                        "name": "Altinópolis",
                        "latitude": "-21.00412000",
                        "longitude": "-47.39795000"
                    },
                    {
                        "id": 10160,
                        "name": "Alto Alegre",
                        "latitude": "-21.63149000",
                        "longitude": "-50.19601000"
                    },
                    {
                        "id": 10189,
                        "name": "Alumínio",
                        "latitude": "-23.52259000",
                        "longitude": "-47.28373000"
                    },
                    {
                        "id": 15677,
                        "name": "Álvares Florence",
                        "latitude": "-20.27757000",
                        "longitude": "-49.91405000"
                    },
                    {
                        "id": 15678,
                        "name": "Álvares Machado",
                        "latitude": "-22.07944000",
                        "longitude": "-51.47194000"
                    },
                    {
                        "id": 15679,
                        "name": "Álvaro de Carvalho",
                        "latitude": "-22.08676000",
                        "longitude": "-49.73512000"
                    },
                    {
                        "id": 10192,
                        "name": "Alvinlândia",
                        "latitude": "-22.45669000",
                        "longitude": "-49.76243000"
                    },
                    {
                        "id": 10213,
                        "name": "Americana",
                        "latitude": "-22.71408000",
                        "longitude": "-47.29009000"
                    },
                    {
                        "id": 10225,
                        "name": "Américo Brasiliense",
                        "latitude": "-21.71797000",
                        "longitude": "-48.01568000"
                    },
                    {
                        "id": 10226,
                        "name": "Américo de Campos",
                        "latitude": "-20.27453000",
                        "longitude": "-49.75539000"
                    },
                    {
                        "id": 10218,
                        "name": "Amparo",
                        "latitude": "-22.70111000",
                        "longitude": "-46.76444000"
                    },
                    {
                        "id": 10232,
                        "name": "Analândia",
                        "latitude": "-22.12002000",
                        "longitude": "-47.68938000"
                    },
                    {
                        "id": 10246,
                        "name": "Andradina",
                        "latitude": "-20.86545000",
                        "longitude": "-51.31567000"
                    },
                    {
                        "id": 10249,
                        "name": "Angatuba",
                        "latitude": "-23.47450000",
                        "longitude": "-48.42565000"
                    },
                    {
                        "id": 10261,
                        "name": "Anhembi",
                        "latitude": "-22.83293000",
                        "longitude": "-48.16384000"
                    },
                    {
                        "id": 10262,
                        "name": "Anhumas",
                        "latitude": "-22.34571000",
                        "longitude": "-51.42761000"
                    },
                    {
                        "id": 10285,
                        "name": "Aparecida",
                        "latitude": "-22.90434000",
                        "longitude": "-45.23562000"
                    },
                    {
                        "id": 10286,
                        "name": "Aparecida d'Oeste",
                        "latitude": "-20.48414000",
                        "longitude": "-50.91883000"
                    },
                    {
                        "id": 10294,
                        "name": "Apiaí",
                        "latitude": "-24.39767000",
                        "longitude": "-48.82237000"
                    },
                    {
                        "id": 10367,
                        "name": "Araçariguama",
                        "latitude": "-23.42294000",
                        "longitude": "-47.07816000"
                    },
                    {
                        "id": 10368,
                        "name": "Araçatuba",
                        "latitude": "-21.14986000",
                        "longitude": "-50.57470000"
                    },
                    {
                        "id": 10371,
                        "name": "Araçoiaba da Serra",
                        "latitude": "-23.56602000",
                        "longitude": "-47.66733000"
                    },
                    {
                        "id": 10333,
                        "name": "Aramina",
                        "latitude": "-20.16724000",
                        "longitude": "-47.82645000"
                    },
                    {
                        "id": 10334,
                        "name": "Arandu",
                        "latitude": "-23.17065000",
                        "longitude": "-49.05861000"
                    },
                    {
                        "id": 10336,
                        "name": "Arapeí",
                        "latitude": "-22.66504000",
                        "longitude": "-44.43858000"
                    },
                    {
                        "id": 10349,
                        "name": "Araraquara",
                        "latitude": "-21.79444000",
                        "longitude": "-48.17556000"
                    },
                    {
                        "id": 10350,
                        "name": "Araras",
                        "latitude": "-22.35694000",
                        "longitude": "-47.38417000"
                    },
                    {
                        "id": 10377,
                        "name": "Arco-Íris",
                        "latitude": "-21.74342000",
                        "longitude": "-50.42979000"
                    },
                    {
                        "id": 10382,
                        "name": "Arealva",
                        "latitude": "-22.06881000",
                        "longitude": "-48.99294000"
                    },
                    {
                        "id": 10388,
                        "name": "Areias",
                        "latitude": "-22.66811000",
                        "longitude": "-44.71651000"
                    },
                    {
                        "id": 10389,
                        "name": "Areiópolis",
                        "latitude": "-22.60627000",
                        "longitude": "-48.65273000"
                    },
                    {
                        "id": 10397,
                        "name": "Ariranha",
                        "latitude": "-21.17685000",
                        "longitude": "-48.77771000"
                    },
                    {
                        "id": 10417,
                        "name": "Artur Nogueira",
                        "latitude": "-22.57306000",
                        "longitude": "-47.17250000"
                    },
                    {
                        "id": 10419,
                        "name": "Arujá",
                        "latitude": "-23.39611000",
                        "longitude": "-46.32083000"
                    },
                    {
                        "id": 10424,
                        "name": "Aspásia",
                        "latitude": "-20.18385000",
                        "longitude": "-50.73117000"
                    },
                    {
                        "id": 10427,
                        "name": "Assis",
                        "latitude": "-22.66167000",
                        "longitude": "-50.41222000"
                    },
                    {
                        "id": 10439,
                        "name": "Atibaia",
                        "latitude": "-23.13099000",
                        "longitude": "-46.58896000"
                    },
                    {
                        "id": 10448,
                        "name": "Auriflama",
                        "latitude": "-20.68556000",
                        "longitude": "-50.55472000"
                    },
                    {
                        "id": 10457,
                        "name": "Avaí",
                        "latitude": "-22.17789000",
                        "longitude": "-49.30511000"
                    },
                    {
                        "id": 10455,
                        "name": "Avanhandava",
                        "latitude": "-21.46596000",
                        "longitude": "-49.94791000"
                    },
                    {
                        "id": 10456,
                        "name": "Avaré",
                        "latitude": "-23.03402000",
                        "longitude": "-48.88802000"
                    },
                    {
                        "id": 10471,
                        "name": "Bady Bassitt",
                        "latitude": "-20.91806000",
                        "longitude": "-49.44528000"
                    },
                    {
                        "id": 10481,
                        "name": "Balbinos",
                        "latitude": "-21.90089000",
                        "longitude": "-49.33509000"
                    },
                    {
                        "id": 10840,
                        "name": "Bálsamo",
                        "latitude": "-20.70239000",
                        "longitude": "-49.55045000"
                    },
                    {
                        "id": 10495,
                        "name": "Bananal",
                        "latitude": "-22.73751000",
                        "longitude": "-44.33413000"
                    },
                    {
                        "id": 10571,
                        "name": "Barão de Antonina",
                        "latitude": "-23.57097000",
                        "longitude": "-49.56660000"
                    },
                    {
                        "id": 10509,
                        "name": "Barbosa",
                        "latitude": "-21.29619000",
                        "longitude": "-49.92293000"
                    },
                    {
                        "id": 10514,
                        "name": "Bariri",
                        "latitude": "-22.07444000",
                        "longitude": "-48.74028000"
                    },
                    {
                        "id": 10516,
                        "name": "Barra Bonita",
                        "latitude": "-22.49472000",
                        "longitude": "-48.55806000"
                    },
                    {
                        "id": 10532,
                        "name": "Barra do Chapéu",
                        "latitude": "-24.44047000",
                        "longitude": "-49.08615000"
                    },
                    {
                        "id": 10545,
                        "name": "Barra do Turvo",
                        "latitude": "-24.89045000",
                        "longitude": "-48.40790000"
                    },
                    {
                        "id": 10557,
                        "name": "Barretos",
                        "latitude": "-20.55722000",
                        "longitude": "-48.56778000"
                    },
                    {
                        "id": 10558,
                        "name": "Barrinha",
                        "latitude": "-21.19361000",
                        "longitude": "-48.16389000"
                    },
                    {
                        "id": 10569,
                        "name": "Barueri",
                        "latitude": "-23.51056000",
                        "longitude": "-46.87611000"
                    },
                    {
                        "id": 10578,
                        "name": "Bastos",
                        "latitude": "-21.92194000",
                        "longitude": "-50.73389000"
                    },
                    {
                        "id": 10583,
                        "name": "Batatais",
                        "latitude": "-20.83515000",
                        "longitude": "-47.56742000"
                    },
                    {
                        "id": 10586,
                        "name": "Bauru",
                        "latitude": "-22.31472000",
                        "longitude": "-49.06056000"
                    },
                    {
                        "id": 10590,
                        "name": "Bebedouro",
                        "latitude": "-20.94944000",
                        "longitude": "-48.47917000"
                    },
                    {
                        "id": 10630,
                        "name": "Bento de Abreu",
                        "latitude": "-21.34057000",
                        "longitude": "-50.86542000"
                    },
                    {
                        "id": 10635,
                        "name": "Bernardino de Campos",
                        "latitude": "-23.02698000",
                        "longitude": "-49.49277000"
                    },
                    {
                        "id": 10638,
                        "name": "Bertioga",
                        "latitude": "-23.85444000",
                        "longitude": "-46.13861000"
                    },
                    {
                        "id": 10649,
                        "name": "Bilac",
                        "latitude": "-21.42076000",
                        "longitude": "-50.47862000"
                    },
                    {
                        "id": 10651,
                        "name": "Birigui",
                        "latitude": "-21.28861000",
                        "longitude": "-50.34000000"
                    },
                    {
                        "id": 10652,
                        "name": "Biritiba Mirim",
                        "latitude": "-23.57250000",
                        "longitude": "-46.03861000"
                    },
                    {
                        "id": 10653,
                        "name": "Biritiba-Mirim",
                        "latitude": "-23.62009000",
                        "longitude": "-46.01938000"
                    },
                    {
                        "id": 10661,
                        "name": "Boa Esperança do Sul",
                        "latitude": "-21.99250000",
                        "longitude": "-48.39083000"
                    },
                    {
                        "id": 10680,
                        "name": "Bocaina",
                        "latitude": "-22.09830000",
                        "longitude": "-48.51952000"
                    },
                    {
                        "id": 10688,
                        "name": "Bofete",
                        "latitude": "-23.12244000",
                        "longitude": "-48.28058000"
                    },
                    {
                        "id": 10689,
                        "name": "Boituva",
                        "latitude": "-23.28333000",
                        "longitude": "-47.67222000"
                    },
                    {
                        "id": 10717,
                        "name": "Bom Jesus dos Perdões",
                        "latitude": "-23.13500000",
                        "longitude": "-46.46528000"
                    },
                    {
                        "id": 10728,
                        "name": "Bom Sucesso de Itararé",
                        "latitude": "-24.31225000",
                        "longitude": "-49.16700000"
                    },
                    {
                        "id": 10755,
                        "name": "Borá",
                        "latitude": "-22.23881000",
                        "longitude": "-50.49252000"
                    },
                    {
                        "id": 10748,
                        "name": "Boracéia",
                        "latitude": "-22.19306000",
                        "longitude": "-48.77889000"
                    },
                    {
                        "id": 10750,
                        "name": "Borborema",
                        "latitude": "-21.61972000",
                        "longitude": "-49.07361000"
                    },
                    {
                        "id": 10753,
                        "name": "Borebi",
                        "latitude": "-22.67635000",
                        "longitude": "-48.98476000"
                    },
                    {
                        "id": 10758,
                        "name": "Botucatu",
                        "latitude": "-22.88583000",
                        "longitude": "-48.44500000"
                    },
                    {
                        "id": 10766,
                        "name": "Bragança Paulista",
                        "latitude": "-22.95270000",
                        "longitude": "-46.54418000"
                    },
                    {
                        "id": 10782,
                        "name": "Braúna",
                        "latitude": "-21.56582000",
                        "longitude": "-50.35227000"
                    },
                    {
                        "id": 10789,
                        "name": "Brejo Alegre",
                        "latitude": "-21.17757000",
                        "longitude": "-50.21805000"
                    },
                    {
                        "id": 10806,
                        "name": "Brodósqui",
                        "latitude": "-20.99139000",
                        "longitude": "-47.65861000"
                    },
                    {
                        "id": 10805,
                        "name": "Brodowski",
                        "latitude": "-21.05060000",
                        "longitude": "-47.61728000"
                    },
                    {
                        "id": 10807,
                        "name": "Brotas",
                        "latitude": "-22.27942000",
                        "longitude": "-48.08744000"
                    },
                    {
                        "id": 10821,
                        "name": "Buri",
                        "latitude": "-23.79750000",
                        "longitude": "-48.59278000"
                    },
                    {
                        "id": 10822,
                        "name": "Buritama",
                        "latitude": "-21.06611000",
                        "longitude": "-50.14722000"
                    },
                    {
                        "id": 10836,
                        "name": "Buritizal",
                        "latitude": "-20.21345000",
                        "longitude": "-47.70776000"
                    },
                    {
                        "id": 10858,
                        "name": "Cabrália Paulista",
                        "latitude": "-22.49155000",
                        "longitude": "-49.38637000"
                    },
                    {
                        "id": 10856,
                        "name": "Cabreúva",
                        "latitude": "-23.30750000",
                        "longitude": "-47.13278000"
                    },
                    {
                        "id": 11222,
                        "name": "Caçapava",
                        "latitude": "-23.10083000",
                        "longitude": "-45.70694000"
                    },
                    {
                        "id": 10866,
                        "name": "Cachoeira Paulista",
                        "latitude": "-22.70115000",
                        "longitude": "-44.99229000"
                    },
                    {
                        "id": 10886,
                        "name": "Caconde",
                        "latitude": "-21.52944000",
                        "longitude": "-46.64389000"
                    },
                    {
                        "id": 10895,
                        "name": "Cafelândia",
                        "latitude": "-21.74295000",
                        "longitude": "-49.57061000"
                    },
                    {
                        "id": 10898,
                        "name": "Caiabu",
                        "latitude": "-21.93822000",
                        "longitude": "-51.23232000"
                    },
                    {
                        "id": 10904,
                        "name": "Caieiras",
                        "latitude": "-23.36417000",
                        "longitude": "-46.74056000"
                    },
                    {
                        "id": 10906,
                        "name": "Caiuá",
                        "latitude": "-21.76518000",
                        "longitude": "-51.95903000"
                    },
                    {
                        "id": 10911,
                        "name": "Cajamar",
                        "latitude": "-23.35193000",
                        "longitude": "-46.88129000"
                    },
                    {
                        "id": 10914,
                        "name": "Cajati",
                        "latitude": "-24.73611000",
                        "longitude": "-48.12278000"
                    },
                    {
                        "id": 10918,
                        "name": "Cajobi",
                        "latitude": "-20.88622000",
                        "longitude": "-48.85175000"
                    },
                    {
                        "id": 10922,
                        "name": "Cajuru",
                        "latitude": "-21.27528000",
                        "longitude": "-47.30417000"
                    },
                    {
                        "id": 10967,
                        "name": "Campina do Monte Alegre",
                        "latitude": "-23.61364000",
                        "longitude": "-48.45388000"
                    },
                    {
                        "id": 10970,
                        "name": "Campinas",
                        "latitude": "-22.90556000",
                        "longitude": "-47.06083000"
                    },
                    {
                        "id": 10994,
                        "name": "Campo Limpo Paulista",
                        "latitude": "-23.21599000",
                        "longitude": "-46.75842000"
                    },
                    {
                        "id": 11018,
                        "name": "Campos do Jordão",
                        "latitude": "-22.73944000",
                        "longitude": "-45.59139000"
                    },
                    {
                        "id": 11014,
                        "name": "Campos Novos Paulista",
                        "latitude": "-22.62889000",
                        "longitude": "-50.01282000"
                    },
                    {
                        "id": 11023,
                        "name": "Cananéia",
                        "latitude": "-25.01472000",
                        "longitude": "-47.92667000"
                    },
                    {
                        "id": 11027,
                        "name": "Canas",
                        "latitude": "-22.73999000",
                        "longitude": "-45.03208000"
                    },
                    {
                        "id": 11547,
                        "name": "Cândido Mota",
                        "latitude": "-22.74639000",
                        "longitude": "-50.38694000"
                    },
                    {
                        "id": 11548,
                        "name": "Cândido Rodrigues",
                        "latitude": "-21.34194000",
                        "longitude": "-48.63294000"
                    },
                    {
                        "id": 11048,
                        "name": "Canitar",
                        "latitude": "-23.01421000",
                        "longitude": "-49.78705000"
                    },
                    {
                        "id": 11094,
                        "name": "Capão Bonito",
                        "latitude": "-24.00583000",
                        "longitude": "-48.34944000"
                    },
                    {
                        "id": 11069,
                        "name": "Capela do Alto",
                        "latitude": "-23.47056000",
                        "longitude": "-47.73472000"
                    },
                    {
                        "id": 11088,
                        "name": "Capivari",
                        "latitude": "-22.99500000",
                        "longitude": "-47.50778000"
                    },
                    {
                        "id": 11103,
                        "name": "Caraguatatuba",
                        "latitude": "-23.62028000",
                        "longitude": "-45.41306000"
                    },
                    {
                        "id": 11109,
                        "name": "Carapicuíba",
                        "latitude": "-23.55339000",
                        "longitude": "-46.84852000"
                    },
                    {
                        "id": 11122,
                        "name": "Cardoso",
                        "latitude": "-20.08194000",
                        "longitude": "-49.91417000"
                    },
                    {
                        "id": 11171,
                        "name": "Casa Branca",
                        "latitude": "-21.81396000",
                        "longitude": "-47.08264000"
                    },
                    {
                        "id": 11544,
                        "name": "Cássia dos Coqueiros",
                        "latitude": "-21.25917000",
                        "longitude": "-47.13783000"
                    },
                    {
                        "id": 11190,
                        "name": "Castilho",
                        "latitude": "-20.87222000",
                        "longitude": "-51.48750000"
                    },
                    {
                        "id": 11195,
                        "name": "Catanduva",
                        "latitude": "-21.13778000",
                        "longitude": "-48.97278000"
                    },
                    {
                        "id": 11202,
                        "name": "Catiguá",
                        "latitude": "-21.06536000",
                        "longitude": "-49.04977000"
                    },
                    {
                        "id": 11229,
                        "name": "Cedral",
                        "latitude": "-20.90742000",
                        "longitude": "-49.25495000"
                    },
                    {
                        "id": 11246,
                        "name": "Cerqueira César",
                        "latitude": "-23.03556000",
                        "longitude": "-49.16611000"
                    },
                    {
                        "id": 11247,
                        "name": "Cerquilho",
                        "latitude": "-23.16500000",
                        "longitude": "-47.74361000"
                    },
                    {
                        "id": 11256,
                        "name": "Cesário Lange",
                        "latitude": "-23.21195000",
                        "longitude": "-47.88465000"
                    },
                    {
                        "id": 11270,
                        "name": "Charqueada",
                        "latitude": "-22.53724000",
                        "longitude": "-47.73770000"
                    },
                    {
                        "id": 11274,
                        "name": "Chavantes",
                        "latitude": "-23.03889000",
                        "longitude": "-49.70944000"
                    },
                    {
                        "id": 11299,
                        "name": "Clementina",
                        "latitude": "-21.57634000",
                        "longitude": "-50.46202000"
                    },
                    {
                        "id": 11321,
                        "name": "Colina",
                        "latitude": "-20.75233000",
                        "longitude": "-48.58162000"
                    },
                    {
                        "id": 11334,
                        "name": "Colômbia",
                        "latitude": "-20.29302000",
                        "longitude": "-48.72328000"
                    },
                    {
                        "id": 11365,
                        "name": "Conchal",
                        "latitude": "-22.34611000",
                        "longitude": "-47.13620000"
                    },
                    {
                        "id": 11366,
                        "name": "Conchas",
                        "latitude": "-23.01528000",
                        "longitude": "-48.01056000"
                    },
                    {
                        "id": 11401,
                        "name": "Cordeirópolis",
                        "latitude": "-22.48194000",
                        "longitude": "-47.45667000"
                    },
                    {
                        "id": 11412,
                        "name": "Coroados",
                        "latitude": "-21.37115000",
                        "longitude": "-50.31271000"
                    },
                    {
                        "id": 11424,
                        "name": "Coronel Macedo",
                        "latitude": "-23.62092000",
                        "longitude": "-49.30305000"
                    },
                    {
                        "id": 11438,
                        "name": "Corumbataí",
                        "latitude": "-22.21698000",
                        "longitude": "-47.59961000"
                    },
                    {
                        "id": 11447,
                        "name": "Cosmópolis",
                        "latitude": "-22.64583000",
                        "longitude": "-47.19611000"
                    },
                    {
                        "id": 11446,
                        "name": "Cosmorama",
                        "latitude": "-20.40934000",
                        "longitude": "-49.74905000"
                    },
                    {
                        "id": 11452,
                        "name": "Cotia",
                        "latitude": "-23.60389000",
                        "longitude": "-46.91917000"
                    },
                    {
                        "id": 11462,
                        "name": "Cravinhos",
                        "latitude": "-21.34028000",
                        "longitude": "-47.72944000"
                    },
                    {
                        "id": 11468,
                        "name": "Cristais Paulista",
                        "latitude": "-20.36538000",
                        "longitude": "-47.37300000"
                    },
                    {
                        "id": 11503,
                        "name": "Cruzália",
                        "latitude": "-22.73707000",
                        "longitude": "-50.75793000"
                    },
                    {
                        "id": 11494,
                        "name": "Cruzeiro",
                        "latitude": "-22.57316000",
                        "longitude": "-44.97108000"
                    },
                    {
                        "id": 11506,
                        "name": "Cubatão",
                        "latitude": "-23.89500000",
                        "longitude": "-46.42528000"
                    },
                    {
                        "id": 11516,
                        "name": "Cunha",
                        "latitude": "-23.07444000",
                        "longitude": "-44.95972000"
                    },
                    {
                        "id": 11576,
                        "name": "Descalvado",
                        "latitude": "-21.90389000",
                        "longitude": "-47.61944000"
                    },
                    {
                        "id": 11583,
                        "name": "Diadema",
                        "latitude": "-23.68611000",
                        "longitude": "-46.62278000"
                    },
                    {
                        "id": 11597,
                        "name": "Dirce Reis",
                        "latitude": "-20.45591000",
                        "longitude": "-50.62798000"
                    },
                    {
                        "id": 11603,
                        "name": "Divinolândia",
                        "latitude": "-21.66459000",
                        "longitude": "-46.70450000"
                    },
                    {
                        "id": 11612,
                        "name": "Dobrada",
                        "latitude": "-21.51531000",
                        "longitude": "-48.37033000"
                    },
                    {
                        "id": 11613,
                        "name": "Dois Córregos",
                        "latitude": "-22.36611000",
                        "longitude": "-48.38028000"
                    },
                    {
                        "id": 11621,
                        "name": "Dolcinópolis",
                        "latitude": "-20.11666000",
                        "longitude": "-50.52771000"
                    },
                    {
                        "id": 11652,
                        "name": "Dourado",
                        "latitude": "-22.11665000",
                        "longitude": "-48.35204000"
                    },
                    {
                        "id": 11662,
                        "name": "Dracena",
                        "latitude": "-21.57936000",
                        "longitude": "-51.59598000"
                    },
                    {
                        "id": 11663,
                        "name": "Duartina",
                        "latitude": "-22.41444000",
                        "longitude": "-49.40389000"
                    },
                    {
                        "id": 11667,
                        "name": "Dumont",
                        "latitude": "-21.24438000",
                        "longitude": "-47.99598000"
                    },
                    {
                        "id": 11672,
                        "name": "Echaporã",
                        "latitude": "-22.41080000",
                        "longitude": "-50.18262000"
                    },
                    {
                        "id": 11678,
                        "name": "Eldorado",
                        "latitude": "-24.50057000",
                        "longitude": "-48.25601000"
                    },
                    {
                        "id": 11682,
                        "name": "Elias Fausto",
                        "latitude": "-23.05880000",
                        "longitude": "-47.38776000"
                    },
                    {
                        "id": 11684,
                        "name": "Elisiário",
                        "latitude": "-21.15517000",
                        "longitude": "-49.09106000"
                    },
                    {
                        "id": 11688,
                        "name": "Embaúba",
                        "latitude": "-20.94301000",
                        "longitude": "-48.85819000"
                    },
                    {
                        "id": 11689,
                        "name": "Embu",
                        "latitude": "-23.64889000",
                        "longitude": "-46.85222000"
                    },
                    {
                        "id": 11691,
                        "name": "Embu das Artes",
                        "latitude": "-23.64664000",
                        "longitude": "-46.85386000"
                    },
                    {
                        "id": 11690,
                        "name": "Embu Guaçu",
                        "latitude": "-23.83222000",
                        "longitude": "-46.81139000"
                    },
                    {
                        "id": 11692,
                        "name": "Embu-Guaçu",
                        "latitude": "-23.85336000",
                        "longitude": "-46.83957000"
                    },
                    {
                        "id": 11693,
                        "name": "Emilianópolis",
                        "latitude": "-21.78179000",
                        "longitude": "-51.47959000"
                    },
                    {
                        "id": 11700,
                        "name": "Engenheiro Coelho",
                        "latitude": "-22.48904000",
                        "longitude": "-47.17256000"
                    },
                    {
                        "id": 11741,
                        "name": "Espírito Santo do Pinhal",
                        "latitude": "-22.18900000",
                        "longitude": "-46.78421000"
                    },
                    {
                        "id": 11742,
                        "name": "Espírito Santo do Turvo",
                        "latitude": "-22.66810000",
                        "longitude": "-49.42175000"
                    },
                    {
                        "id": 11746,
                        "name": "Estiva Gerbi",
                        "latitude": "-22.22052000",
                        "longitude": "-46.93878000"
                    },
                    {
                        "id": 11751,
                        "name": "Estrela d'Oeste",
                        "latitude": "-20.27767000",
                        "longitude": "-50.40807000"
                    },
                    {
                        "id": 11754,
                        "name": "Estrela do Norte",
                        "latitude": "-22.47843000",
                        "longitude": "-51.67954000"
                    },
                    {
                        "id": 11760,
                        "name": "Euclides da Cunha Paulista",
                        "latitude": "-22.51710000",
                        "longitude": "-52.59099000"
                    },
                    {
                        "id": 11779,
                        "name": "Fartura",
                        "latitude": "-23.38833000",
                        "longitude": "-49.51000000"
                    },
                    {
                        "id": 11806,
                        "name": "Fernando Prestes",
                        "latitude": "-21.30945000",
                        "longitude": "-48.69583000"
                    },
                    {
                        "id": 11809,
                        "name": "Fernandópolis",
                        "latitude": "-20.28389000",
                        "longitude": "-50.24639000"
                    },
                    {
                        "id": 11810,
                        "name": "Fernão",
                        "latitude": "-22.37381000",
                        "longitude": "-49.55434000"
                    },
                    {
                        "id": 11811,
                        "name": "Ferraz de Vasconcelos",
                        "latitude": "-23.56153000",
                        "longitude": "-46.37490000"
                    },
                    {
                        "id": 11827,
                        "name": "Flora Rica",
                        "latitude": "-21.70103000",
                        "longitude": "-51.37786000"
                    },
                    {
                        "id": 11829,
                        "name": "Floreal",
                        "latitude": "-20.65394000",
                        "longitude": "-50.15844000"
                    },
                    {
                        "id": 11847,
                        "name": "Flórida Paulista",
                        "latitude": "-21.54193000",
                        "longitude": "-51.18066000"
                    },
                    {
                        "id": 11845,
                        "name": "Florínea",
                        "latitude": "-22.87222000",
                        "longitude": "-50.68979000"
                    },
                    {
                        "id": 11874,
                        "name": "Franca",
                        "latitude": "-20.53861000",
                        "longitude": "-47.40083000"
                    },
                    {
                        "id": 11883,
                        "name": "Francisco Morato",
                        "latitude": "-23.26924000",
                        "longitude": "-46.70889000"
                    },
                    {
                        "id": 11887,
                        "name": "Franco da Rocha",
                        "latitude": "-23.30277000",
                        "longitude": "-46.73089000"
                    },
                    {
                        "id": 11910,
                        "name": "Gabriel Monteiro",
                        "latitude": "-21.49989000",
                        "longitude": "-50.56997000"
                    },
                    {
                        "id": 12091,
                        "name": "Gália",
                        "latitude": "-22.34323000",
                        "longitude": "-49.57865000"
                    },
                    {
                        "id": 11926,
                        "name": "Garça",
                        "latitude": "-22.21056000",
                        "longitude": "-49.65611000"
                    },
                    {
                        "id": 11928,
                        "name": "Gastão Vidigal",
                        "latitude": "-20.80633000",
                        "longitude": "-50.19238000"
                    },
                    {
                        "id": 11931,
                        "name": "Gavião Peixoto",
                        "latitude": "-21.80879000",
                        "longitude": "-48.46904000"
                    },
                    {
                        "id": 11938,
                        "name": "General Salgado",
                        "latitude": "-20.64833000",
                        "longitude": "-50.36056000"
                    },
                    {
                        "id": 11942,
                        "name": "Getulina",
                        "latitude": "-21.76343000",
                        "longitude": "-50.06225000"
                    },
                    {
                        "id": 11948,
                        "name": "Glicério",
                        "latitude": "-21.31866000",
                        "longitude": "-50.17782000"
                    },
                    {
                        "id": 12016,
                        "name": "Guaiçara",
                        "latitude": "-21.55410000",
                        "longitude": "-49.76263000"
                    },
                    {
                        "id": 12014,
                        "name": "Guaimbê",
                        "latitude": "-21.86204000",
                        "longitude": "-49.84959000"
                    },
                    {
                        "id": 12077,
                        "name": "Guaíra",
                        "latitude": "-20.31833000",
                        "longitude": "-48.31056000"
                    },
                    {
                        "id": 12027,
                        "name": "Guapiaçu",
                        "latitude": "-20.79500000",
                        "longitude": "-49.22028000"
                    },
                    {
                        "id": 12026,
                        "name": "Guapiara",
                        "latitude": "-24.21726000",
                        "longitude": "-48.54523000"
                    },
                    {
                        "id": 12071,
                        "name": "Guará",
                        "latitude": "-20.42833000",
                        "longitude": "-47.82417000"
                    },
                    {
                        "id": 12060,
                        "name": "Guaraçaí",
                        "latitude": "-21.10820000",
                        "longitude": "-51.30124000"
                    },
                    {
                        "id": 12035,
                        "name": "Guaraci",
                        "latitude": "-20.41648000",
                        "longitude": "-49.00521000"
                    },
                    {
                        "id": 12044,
                        "name": "Guarani d'Oeste",
                        "latitude": "-20.07032000",
                        "longitude": "-50.36292000"
                    },
                    {
                        "id": 12048,
                        "name": "Guarantã",
                        "latitude": "-21.92281000",
                        "longitude": "-49.58519000"
                    },
                    {
                        "id": 12054,
                        "name": "Guararapes",
                        "latitude": "-21.26083000",
                        "longitude": "-50.64278000"
                    },
                    {
                        "id": 12055,
                        "name": "Guararema",
                        "latitude": "-23.41500000",
                        "longitude": "-46.03500000"
                    },
                    {
                        "id": 12058,
                        "name": "Guaratinguetá",
                        "latitude": "-22.81639000",
                        "longitude": "-45.19250000"
                    },
                    {
                        "id": 12064,
                        "name": "Guareí",
                        "latitude": "-23.37338000",
                        "longitude": "-48.22466000"
                    },
                    {
                        "id": 12065,
                        "name": "Guariba",
                        "latitude": "-21.39568000",
                        "longitude": "-48.20427000"
                    },
                    {
                        "id": 12068,
                        "name": "Guarujá",
                        "latitude": "-23.99306000",
                        "longitude": "-46.25639000"
                    },
                    {
                        "id": 12070,
                        "name": "Guarulhos",
                        "latitude": "-23.46278000",
                        "longitude": "-46.53333000"
                    },
                    {
                        "id": 12073,
                        "name": "Guatapará",
                        "latitude": "-21.47231000",
                        "longitude": "-47.99142000"
                    },
                    {
                        "id": 12090,
                        "name": "Guzolândia",
                        "latitude": "-20.62040000",
                        "longitude": "-50.71925000"
                    },
                    {
                        "id": 12096,
                        "name": "Herculândia",
                        "latitude": "-21.96198000",
                        "longitude": "-50.38482000"
                    },
                    {
                        "id": 12103,
                        "name": "Holambra",
                        "latitude": "-22.63825000",
                        "longitude": "-47.06501000"
                    },
                    {
                        "id": 12107,
                        "name": "Hortolândia",
                        "latitude": "-22.85833000",
                        "longitude": "-47.22000000"
                    },
                    {
                        "id": 12113,
                        "name": "Iacanga",
                        "latitude": "-21.90745000",
                        "longitude": "-49.05917000"
                    },
                    {
                        "id": 12115,
                        "name": "Iacri",
                        "latitude": "-21.77798000",
                        "longitude": "-50.61517000"
                    },
                    {
                        "id": 12117,
                        "name": "Iaras",
                        "latitude": "-22.83679000",
                        "longitude": "-49.10928000"
                    },
                    {
                        "id": 12125,
                        "name": "Ibaté",
                        "latitude": "-21.95472000",
                        "longitude": "-47.99667000"
                    },
                    {
                        "id": 12157,
                        "name": "Ibirá",
                        "latitude": "-21.08880000",
                        "longitude": "-49.21879000"
                    },
                    {
                        "id": 12152,
                        "name": "Ibirarema",
                        "latitude": "-22.80911000",
                        "longitude": "-50.07816000"
                    },
                    {
                        "id": 12159,
                        "name": "Ibitinga",
                        "latitude": "-21.75778000",
                        "longitude": "-48.82889000"
                    },
                    {
                        "id": 12165,
                        "name": "Ibiúna",
                        "latitude": "-23.65639000",
                        "longitude": "-47.22250000"
                    },
                    {
                        "id": 12173,
                        "name": "Icém",
                        "latitude": "-20.38003000",
                        "longitude": "-49.20507000"
                    },
                    {
                        "id": 12176,
                        "name": "Iepê",
                        "latitude": "-22.65726000",
                        "longitude": "-51.04385000"
                    },
                    {
                        "id": 12191,
                        "name": "Igaraçu do Tietê",
                        "latitude": "-22.50917000",
                        "longitude": "-48.55778000"
                    },
                    {
                        "id": 12180,
                        "name": "Igarapava",
                        "latitude": "-20.03833000",
                        "longitude": "-47.74694000"
                    },
                    {
                        "id": 12190,
                        "name": "Igaratá",
                        "latitude": "-23.12994000",
                        "longitude": "-46.14647000"
                    },
                    {
                        "id": 12196,
                        "name": "Iguape",
                        "latitude": "-24.70806000",
                        "longitude": "-47.55528000"
                    },
                    {
                        "id": 12206,
                        "name": "Ilha Comprida",
                        "latitude": "-24.87792000",
                        "longitude": "-47.74757000"
                    },
                    {
                        "id": 12209,
                        "name": "Ilha Solteira",
                        "latitude": "-20.43278000",
                        "longitude": "-51.34250000"
                    },
                    {
                        "id": 12212,
                        "name": "Ilhabela",
                        "latitude": "-23.77806000",
                        "longitude": "-45.35806000"
                    },
                    {
                        "id": 12233,
                        "name": "Indaiatuba",
                        "latitude": "-23.08842000",
                        "longitude": "-47.21190000"
                    },
                    {
                        "id": 12236,
                        "name": "Indiana",
                        "latitude": "-22.12587000",
                        "longitude": "-51.26047000"
                    },
                    {
                        "id": 12239,
                        "name": "Indiaporã",
                        "latitude": "-19.95987000",
                        "longitude": "-50.24419000"
                    },
                    {
                        "id": 12257,
                        "name": "Inúbia Paulista",
                        "latitude": "-21.72002000",
                        "longitude": "-50.94738000"
                    },
                    {
                        "id": 12267,
                        "name": "Ipauçu",
                        "latitude": "-23.05667000",
                        "longitude": "-49.62639000"
                    },
                    {
                        "id": 12266,
                        "name": "Ipaussu",
                        "latitude": "-23.08202000",
                        "longitude": "-49.60370000"
                    },
                    {
                        "id": 12269,
                        "name": "Iperó",
                        "latitude": "-23.35028000",
                        "longitude": "-47.68861000"
                    },
                    {
                        "id": 12270,
                        "name": "Ipeúna",
                        "latitude": "-22.44376000",
                        "longitude": "-47.69449000"
                    },
                    {
                        "id": 12273,
                        "name": "Ipiguá",
                        "latitude": "-20.63984000",
                        "longitude": "-49.39781000"
                    },
                    {
                        "id": 12284,
                        "name": "Iporanga",
                        "latitude": "-24.50438000",
                        "longitude": "-48.55248000"
                    },
                    {
                        "id": 12298,
                        "name": "Ipuã",
                        "latitude": "-20.43806000",
                        "longitude": "-48.01222000"
                    },
                    {
                        "id": 12303,
                        "name": "Iracemápolis",
                        "latitude": "-22.58056000",
                        "longitude": "-47.51861000"
                    },
                    {
                        "id": 12309,
                        "name": "Irapuã",
                        "latitude": "-21.25013000",
                        "longitude": "-49.40247000"
                    },
                    {
                        "id": 12308,
                        "name": "Irapuru",
                        "latitude": "-21.44903000",
                        "longitude": "-51.33959000"
                    },
                    {
                        "id": 12331,
                        "name": "Itaberá",
                        "latitude": "-23.86194000",
                        "longitude": "-49.13722000"
                    },
                    {
                        "id": 12466,
                        "name": "Itaí",
                        "latitude": "-23.41778000",
                        "longitude": "-49.09056000"
                    },
                    {
                        "id": 12367,
                        "name": "Itajobi",
                        "latitude": "-21.31806000",
                        "longitude": "-49.05444000"
                    },
                    {
                        "id": 12368,
                        "name": "Itaju",
                        "latitude": "-21.92879000",
                        "longitude": "-48.78312000"
                    },
                    {
                        "id": 12392,
                        "name": "Itanhaém",
                        "latitude": "-24.18306000",
                        "longitude": "-46.78889000"
                    },
                    {
                        "id": 12396,
                        "name": "Itaoca",
                        "latitude": "-24.61155000",
                        "longitude": "-48.84390000"
                    },
                    {
                        "id": 12405,
                        "name": "Itapecerica da Serra",
                        "latitude": "-23.71694000",
                        "longitude": "-46.84917000"
                    },
                    {
                        "id": 12414,
                        "name": "Itapetininga",
                        "latitude": "-23.59167000",
                        "longitude": "-48.05306000"
                    },
                    {
                        "id": 12416,
                        "name": "Itapeva",
                        "latitude": "-23.94696000",
                        "longitude": "-48.83835000"
                    },
                    {
                        "id": 12417,
                        "name": "Itapevi",
                        "latitude": "-23.54889000",
                        "longitude": "-46.93417000"
                    },
                    {
                        "id": 12420,
                        "name": "Itapira",
                        "latitude": "-22.43611000",
                        "longitude": "-46.82167000"
                    },
                    {
                        "id": 12424,
                        "name": "Itapirapuã Paulista",
                        "latitude": "-24.55985000",
                        "longitude": "-49.22435000"
                    },
                    {
                        "id": 12496,
                        "name": "Itápolis",
                        "latitude": "-21.59556000",
                        "longitude": "-48.81278000"
                    },
                    {
                        "id": 12429,
                        "name": "Itaporanga",
                        "latitude": "-23.70778000",
                        "longitude": "-49.48972000"
                    },
                    {
                        "id": 12440,
                        "name": "Itapuí",
                        "latitude": "-22.23333000",
                        "longitude": "-48.71917000"
                    },
                    {
                        "id": 12437,
                        "name": "Itapura",
                        "latitude": "-20.59626000",
                        "longitude": "-51.42537000"
                    },
                    {
                        "id": 12442,
                        "name": "Itaquaquecetuba",
                        "latitude": "-23.45806000",
                        "longitude": "-46.32917000"
                    },
                    {
                        "id": 12449,
                        "name": "Itararé",
                        "latitude": "-24.11250000",
                        "longitude": "-49.33167000"
                    },
                    {
                        "id": 12451,
                        "name": "Itariri",
                        "latitude": "-24.28880000",
                        "longitude": "-47.13325000"
                    },
                    {
                        "id": 12456,
                        "name": "Itatiba",
                        "latitude": "-23.00583000",
                        "longitude": "-46.83889000"
                    },
                    {
                        "id": 12459,
                        "name": "Itatinga",
                        "latitude": "-23.10167000",
                        "longitude": "-48.61583000"
                    },
                    {
                        "id": 12476,
                        "name": "Itirapina",
                        "latitude": "-22.25278000",
                        "longitude": "-47.82278000"
                    },
                    {
                        "id": 12477,
                        "name": "Itirapuã",
                        "latitude": "-20.65755000",
                        "longitude": "-47.16859000"
                    },
                    {
                        "id": 12480,
                        "name": "Itobi",
                        "latitude": "-21.74902000",
                        "longitude": "-46.93051000"
                    },
                    {
                        "id": 12482,
                        "name": "Itu",
                        "latitude": "-23.26417000",
                        "longitude": "-47.29917000"
                    },
                    {
                        "id": 12489,
                        "name": "Itupeva",
                        "latitude": "-23.15306000",
                        "longitude": "-47.05778000"
                    },
                    {
                        "id": 12494,
                        "name": "Ituverava",
                        "latitude": "-20.33944000",
                        "longitude": "-47.78056000"
                    },
                    {
                        "id": 12511,
                        "name": "Jaborandi",
                        "latitude": "-20.66618000",
                        "longitude": "-48.40164000"
                    },
                    {
                        "id": 12515,
                        "name": "Jaboticabal",
                        "latitude": "-21.25472000",
                        "longitude": "-48.32222000"
                    },
                    {
                        "id": 12521,
                        "name": "Jacareí",
                        "latitude": "-23.30528000",
                        "longitude": "-45.96583000"
                    },
                    {
                        "id": 12523,
                        "name": "Jaci",
                        "latitude": "-20.94747000",
                        "longitude": "-49.57606000"
                    },
                    {
                        "id": 12531,
                        "name": "Jacupiranga",
                        "latitude": "-24.69250000",
                        "longitude": "-48.00222000"
                    },
                    {
                        "id": 12546,
                        "name": "Jaguariúna",
                        "latitude": "-22.70556000",
                        "longitude": "-46.98583000"
                    },
                    {
                        "id": 12552,
                        "name": "Jales",
                        "latitude": "-20.26889000",
                        "longitude": "-50.54583000"
                    },
                    {
                        "id": 12553,
                        "name": "Jambeiro",
                        "latitude": "-23.28154000",
                        "longitude": "-45.71217000"
                    },
                    {
                        "id": 12560,
                        "name": "Jandira",
                        "latitude": "-23.54082000",
                        "longitude": "-46.89571000"
                    },
                    {
                        "id": 12587,
                        "name": "Jardim Paulista",
                        "latitude": "-23.56675000",
                        "longitude": "-46.66439000"
                    },
                    {
                        "id": 12592,
                        "name": "Jardinópolis",
                        "latitude": "-21.01778000",
                        "longitude": "-47.76389000"
                    },
                    {
                        "id": 12595,
                        "name": "Jarinu",
                        "latitude": "-23.10139000",
                        "longitude": "-46.72833000"
                    },
                    {
                        "id": 12609,
                        "name": "Jaú",
                        "latitude": "-22.29639000",
                        "longitude": "-48.55778000"
                    },
                    {
                        "id": 12622,
                        "name": "Jeriquara",
                        "latitude": "-20.33455000",
                        "longitude": "-47.57121000"
                    },
                    {
                        "id": 12635,
                        "name": "Joanópolis",
                        "latitude": "-22.93028000",
                        "longitude": "-46.27556000"
                    },
                    {
                        "id": 12667,
                        "name": "João Ramalho",
                        "latitude": "-22.24440000",
                        "longitude": "-50.78747000"
                    },
                    {
                        "id": 12651,
                        "name": "José Bonifácio",
                        "latitude": "-21.08986000",
                        "longitude": "-49.77293000"
                    },
                    {
                        "id": 12718,
                        "name": "Júlio Mesquita",
                        "latitude": "-21.97689000",
                        "longitude": "-49.78623000"
                    },
                    {
                        "id": 12681,
                        "name": "Jumirim",
                        "latitude": "-23.10825000",
                        "longitude": "-47.79820000"
                    },
                    {
                        "id": 12684,
                        "name": "Jundiaí",
                        "latitude": "-23.18639000",
                        "longitude": "-46.88417000"
                    },
                    {
                        "id": 12689,
                        "name": "Junqueirópolis",
                        "latitude": "-21.51472000",
                        "longitude": "-51.43361000"
                    },
                    {
                        "id": 12693,
                        "name": "Juquiá",
                        "latitude": "-24.32083000",
                        "longitude": "-47.63472000"
                    },
                    {
                        "id": 12692,
                        "name": "Juquitiba",
                        "latitude": "-23.95860000",
                        "longitude": "-47.01366000"
                    },
                    {
                        "id": 12768,
                        "name": "Lagoinha",
                        "latitude": "-23.08443000",
                        "longitude": "-45.19973000"
                    },
                    {
                        "id": 12797,
                        "name": "Laranjal Paulista",
                        "latitude": "-23.04972000",
                        "longitude": "-47.83667000"
                    },
                    {
                        "id": 12812,
                        "name": "Lavínia",
                        "latitude": "-21.17069000",
                        "longitude": "-51.05184000"
                    },
                    {
                        "id": 12811,
                        "name": "Lavrinhas",
                        "latitude": "-22.51707000",
                        "longitude": "-44.88055000"
                    },
                    {
                        "id": 12815,
                        "name": "Leme",
                        "latitude": "-22.18556000",
                        "longitude": "-47.39028000"
                    },
                    {
                        "id": 12818,
                        "name": "Lençóis Paulista",
                        "latitude": "-22.59861000",
                        "longitude": "-48.80028000"
                    },
                    {
                        "id": 12829,
                        "name": "Limeira",
                        "latitude": "-22.56472000",
                        "longitude": "-47.40167000"
                    },
                    {
                        "id": 12837,
                        "name": "Lindóia",
                        "latitude": "-22.51250000",
                        "longitude": "-46.65352000"
                    },
                    {
                        "id": 12841,
                        "name": "Lins",
                        "latitude": "-21.67861000",
                        "longitude": "-49.74250000"
                    },
                    {
                        "id": 12852,
                        "name": "Lorena",
                        "latitude": "-22.73083000",
                        "longitude": "-45.12472000"
                    },
                    {
                        "id": 12854,
                        "name": "Lourdes",
                        "latitude": "-20.94345000",
                        "longitude": "-50.23799000"
                    },
                    {
                        "id": 12855,
                        "name": "Louveira",
                        "latitude": "-23.08252000",
                        "longitude": "-46.93308000"
                    },
                    {
                        "id": 12862,
                        "name": "Lucélia",
                        "latitude": "-21.72028000",
                        "longitude": "-51.01889000"
                    },
                    {
                        "id": 12859,
                        "name": "Lucianópolis",
                        "latitude": "-22.48385000",
                        "longitude": "-49.54507000"
                    },
                    {
                        "id": 12878,
                        "name": "Luís Antônio",
                        "latitude": "-21.55997000",
                        "longitude": "-47.81156000"
                    },
                    {
                        "id": 12867,
                        "name": "Luiziânia",
                        "latitude": "-21.68237000",
                        "longitude": "-50.35305000"
                    },
                    {
                        "id": 12871,
                        "name": "Lupércio",
                        "latitude": "-22.42771000",
                        "longitude": "-49.81232000"
                    },
                    {
                        "id": 12872,
                        "name": "Lutécia",
                        "latitude": "-22.30652000",
                        "longitude": "-50.37817000"
                    },
                    {
                        "id": 12889,
                        "name": "Macatuba",
                        "latitude": "-22.50222000",
                        "longitude": "-48.71139000"
                    },
                    {
                        "id": 12891,
                        "name": "Macaubal",
                        "latitude": "-20.86271000",
                        "longitude": "-49.98530000"
                    },
                    {
                        "id": 12895,
                        "name": "Macedônia",
                        "latitude": "-20.08825000",
                        "longitude": "-50.17318000"
                    },
                    {
                        "id": 12913,
                        "name": "Magda",
                        "latitude": "-20.57602000",
                        "longitude": "-50.22413000"
                    },
                    {
                        "id": 12917,
                        "name": "Mairinque",
                        "latitude": "-23.54583000",
                        "longitude": "-47.18333000"
                    },
                    {
                        "id": 12918,
                        "name": "Mairiporã",
                        "latitude": "-23.31861000",
                        "longitude": "-46.58667000"
                    },
                    {
                        "id": 12944,
                        "name": "Manduri",
                        "latitude": "-23.05388000",
                        "longitude": "-49.30262000"
                    },
                    {
                        "id": 12965,
                        "name": "Marabá Paulista",
                        "latitude": "-22.11727000",
                        "longitude": "-52.05131000"
                    },
                    {
                        "id": 12971,
                        "name": "Maracaí",
                        "latitude": "-22.61056000",
                        "longitude": "-50.66722000"
                    },
                    {
                        "id": 12980,
                        "name": "Marapoama",
                        "latitude": "-21.25761000",
                        "longitude": "-49.14859000"
                    },
                    {
                        "id": 13024,
                        "name": "Mariápolis",
                        "latitude": "-21.77944000",
                        "longitude": "-51.16754000"
                    },
                    {
                        "id": 13039,
                        "name": "Marília",
                        "latitude": "-22.21389000",
                        "longitude": "-49.94583000"
                    },
                    {
                        "id": 13019,
                        "name": "Marinópolis",
                        "latitude": "-20.48780000",
                        "longitude": "-50.83467000"
                    },
                    {
                        "id": 13035,
                        "name": "Martinópolis",
                        "latitude": "-22.14583000",
                        "longitude": "-51.17083000"
                    },
                    {
                        "id": 13077,
                        "name": "Matão",
                        "latitude": "-21.59547000",
                        "longitude": "-48.45033000"
                    },
                    {
                        "id": 13083,
                        "name": "Mauá",
                        "latitude": "-23.66364000",
                        "longitude": "-46.44656000"
                    },
                    {
                        "id": 13099,
                        "name": "Mendonça",
                        "latitude": "-21.19620000",
                        "longitude": "-49.56427000"
                    },
                    {
                        "id": 13102,
                        "name": "Meridiano",
                        "latitude": "-20.41766000",
                        "longitude": "-50.20536000"
                    },
                    {
                        "id": 13108,
                        "name": "Mesópolis",
                        "latitude": "-19.95808000",
                        "longitude": "-50.60938000"
                    },
                    {
                        "id": 13113,
                        "name": "Miguelópolis",
                        "latitude": "-20.17944000",
                        "longitude": "-48.03194000"
                    },
                    {
                        "id": 13127,
                        "name": "Mineiros do Tietê",
                        "latitude": "-22.44860000",
                        "longitude": "-48.44074000"
                    },
                    {
                        "id": 13129,
                        "name": "Mira Estrela",
                        "latitude": "-19.97244000",
                        "longitude": "-50.13043000"
                    },
                    {
                        "id": 13131,
                        "name": "Miracatu",
                        "latitude": "-24.28139000",
                        "longitude": "-47.45972000"
                    },
                    {
                        "id": 13141,
                        "name": "Mirandopólis",
                        "latitude": "-21.13361000",
                        "longitude": "-51.10167000"
                    },
                    {
                        "id": 13147,
                        "name": "Mirante do Paranapanema",
                        "latitude": "-22.29194000",
                        "longitude": "-51.90639000"
                    },
                    {
                        "id": 13149,
                        "name": "Mirassol",
                        "latitude": "-20.84158000",
                        "longitude": "-49.50879000"
                    },
                    {
                        "id": 13151,
                        "name": "Mirassolândia",
                        "latitude": "-20.59295000",
                        "longitude": "-49.48426000"
                    },
                    {
                        "id": 13160,
                        "name": "Mococa",
                        "latitude": "-21.46778000",
                        "longitude": "-47.00472000"
                    },
                    {
                        "id": 13167,
                        "name": "Mogi das Cruzes",
                        "latitude": "-23.56813000",
                        "longitude": "-46.18770000"
                    },
                    {
                        "id": 13165,
                        "name": "Mogi Guaçu",
                        "latitude": "-22.36770000",
                        "longitude": "-46.94552000"
                    },
                    {
                        "id": 13166,
                        "name": "Mogi Mirim",
                        "latitude": "-22.43194000",
                        "longitude": "-46.95778000"
                    },
                    {
                        "id": 13173,
                        "name": "Mombuca",
                        "latitude": "-22.95107000",
                        "longitude": "-47.60238000"
                    },
                    {
                        "id": 13226,
                        "name": "Monções",
                        "latitude": "-20.86875000",
                        "longitude": "-50.08331000"
                    },
                    {
                        "id": 13175,
                        "name": "Mongaguá",
                        "latitude": "-24.09306000",
                        "longitude": "-46.62083000"
                    },
                    {
                        "id": 13192,
                        "name": "Monte Alegre do Sul",
                        "latitude": "-22.71002000",
                        "longitude": "-46.67181000"
                    },
                    {
                        "id": 13194,
                        "name": "Monte Alto",
                        "latitude": "-21.26111000",
                        "longitude": "-48.49639000"
                    },
                    {
                        "id": 13195,
                        "name": "Monte Aprazível",
                        "latitude": "-20.77250000",
                        "longitude": "-49.71417000"
                    },
                    {
                        "id": 13197,
                        "name": "Monte Azul Paulista",
                        "latitude": "-20.90722000",
                        "longitude": "-48.64139000"
                    },
                    {
                        "id": 13202,
                        "name": "Monte Castelo",
                        "latitude": "-21.22773000",
                        "longitude": "-51.57141000"
                    },
                    {
                        "id": 13206,
                        "name": "Monte Mor",
                        "latitude": "-22.94667000",
                        "longitude": "-47.31583000"
                    },
                    {
                        "id": 13216,
                        "name": "Monteiro Lobato",
                        "latitude": "-22.93300000",
                        "longitude": "-45.80525000"
                    },
                    {
                        "id": 13239,
                        "name": "Morro Agudo",
                        "latitude": "-20.73139000",
                        "longitude": "-48.05778000"
                    },
                    {
                        "id": 13253,
                        "name": "Morungaba",
                        "latitude": "-22.88318000",
                        "longitude": "-46.78699000"
                    },
                    {
                        "id": 13257,
                        "name": "Motuca",
                        "latitude": "-21.48936000",
                        "longitude": "-48.15669000"
                    },
                    {
                        "id": 13284,
                        "name": "Murutinga do Sul",
                        "latitude": "-20.99638000",
                        "longitude": "-51.30376000"
                    },
                    {
                        "id": 13295,
                        "name": "Nantes",
                        "latitude": "-22.60334000",
                        "longitude": "-51.20840000"
                    },
                    {
                        "id": 13298,
                        "name": "Narandiba",
                        "latitude": "-22.53395000",
                        "longitude": "-51.50976000"
                    },
                    {
                        "id": 13303,
                        "name": "Natividade da Serra",
                        "latitude": "-23.39447000",
                        "longitude": "-45.39368000"
                    },
                    {
                        "id": 13312,
                        "name": "Nazaré Paulista",
                        "latitude": "-23.18203000",
                        "longitude": "-46.36202000"
                    },
                    {
                        "id": 13319,
                        "name": "Neves Paulista",
                        "latitude": "-20.87439000",
                        "longitude": "-49.64850000"
                    },
                    {
                        "id": 13322,
                        "name": "Nhandeara",
                        "latitude": "-20.68970000",
                        "longitude": "-50.04070000"
                    },
                    {
                        "id": 13329,
                        "name": "Nipoã",
                        "latitude": "-20.89366000",
                        "longitude": "-49.78133000"
                    },
                    {
                        "id": 13345,
                        "name": "Nova Aliança",
                        "latitude": "-21.06591000",
                        "longitude": "-49.52593000"
                    },
                    {
                        "id": 13362,
                        "name": "Nova Campina",
                        "latitude": "-24.20918000",
                        "longitude": "-48.98456000"
                    },
                    {
                        "id": 13364,
                        "name": "Nova Canaã Paulista",
                        "latitude": "-20.37020000",
                        "longitude": "-50.90616000"
                    },
                    {
                        "id": 13368,
                        "name": "Nova Castilho",
                        "latitude": "-20.78530000",
                        "longitude": "-50.34957000"
                    },
                    {
                        "id": 13378,
                        "name": "Nova Europa",
                        "latitude": "-21.79214000",
                        "longitude": "-48.56880000"
                    },
                    {
                        "id": 13384,
                        "name": "Nova Granada",
                        "latitude": "-20.53389000",
                        "longitude": "-49.31417000"
                    },
                    {
                        "id": 13386,
                        "name": "Nova Guataporanga",
                        "latitude": "-21.31898000",
                        "longitude": "-51.64323000"
                    },
                    {
                        "id": 13391,
                        "name": "Nova Independência",
                        "latitude": "-21.15481000",
                        "longitude": "-51.52759000"
                    },
                    {
                        "id": 13400,
                        "name": "Nova Luzitânia",
                        "latitude": "-20.87304000",
                        "longitude": "-50.24297000"
                    },
                    {
                        "id": 13408,
                        "name": "Nova Odessa",
                        "latitude": "-22.77750000",
                        "longitude": "-47.29583000"
                    },
                    {
                        "id": 13449,
                        "name": "Novais",
                        "latitude": "-20.97660000",
                        "longitude": "-48.90985000"
                    },
                    {
                        "id": 13460,
                        "name": "Novo Horizonte",
                        "latitude": "-21.46806000",
                        "longitude": "-49.22083000"
                    },
                    {
                        "id": 13484,
                        "name": "Nuporanga",
                        "latitude": "-20.73095000",
                        "longitude": "-47.75177000"
                    },
                    {
                        "id": 13489,
                        "name": "Ocauçu",
                        "latitude": "-22.43034000",
                        "longitude": "-49.95170000"
                    },
                    {
                        "id": 15684,
                        "name": "Óleo",
                        "latitude": "-22.94964000",
                        "longitude": "-49.38996000"
                    },
                    {
                        "id": 13511,
                        "name": "Olímpia",
                        "latitude": "-20.73722000",
                        "longitude": "-48.91472000"
                    },
                    {
                        "id": 13513,
                        "name": "Onda Verde",
                        "latitude": "-20.61043000",
                        "longitude": "-49.24474000"
                    },
                    {
                        "id": 13516,
                        "name": "Oriente",
                        "latitude": "-22.15005000",
                        "longitude": "-50.09676000"
                    },
                    {
                        "id": 13517,
                        "name": "Orindiúva",
                        "latitude": "-20.22235000",
                        "longitude": "-49.37594000"
                    },
                    {
                        "id": 13522,
                        "name": "Orlândia",
                        "latitude": "-20.72028000",
                        "longitude": "-47.88667000"
                    },
                    {
                        "id": 13527,
                        "name": "Osasco",
                        "latitude": "-23.53250000",
                        "longitude": "-46.79167000"
                    },
                    {
                        "id": 13528,
                        "name": "Oscar Bressane",
                        "latitude": "-22.29031000",
                        "longitude": "-50.25646000"
                    },
                    {
                        "id": 13529,
                        "name": "Osvaldo Cruz",
                        "latitude": "-21.67502000",
                        "longitude": "-50.84203000"
                    },
                    {
                        "id": 13534,
                        "name": "Ourinhos",
                        "latitude": "-22.97889000",
                        "longitude": "-49.87056000"
                    },
                    {
                        "id": 13545,
                        "name": "Ouro Verde",
                        "latitude": "-21.52766000",
                        "longitude": "-51.75119000"
                    },
                    {
                        "id": 13550,
                        "name": "Ouroeste",
                        "latitude": "-19.93760000",
                        "longitude": "-50.41455000"
                    },
                    {
                        "id": 13554,
                        "name": "Pacaembu",
                        "latitude": "-21.56222000",
                        "longitude": "-51.26056000"
                    },
                    {
                        "id": 13576,
                        "name": "Palestina",
                        "latitude": "-20.29911000",
                        "longitude": "-49.52000000"
                    },
                    {
                        "id": 13584,
                        "name": "Palmares Paulista",
                        "latitude": "-21.10148000",
                        "longitude": "-48.82032000"
                    },
                    {
                        "id": 13591,
                        "name": "Palmeira d'Oeste",
                        "latitude": "-20.45046000",
                        "longitude": "-50.75181000"
                    },
                    {
                        "id": 13605,
                        "name": "Palmital",
                        "latitude": "-22.78889000",
                        "longitude": "-50.21750000"
                    },
                    {
                        "id": 13616,
                        "name": "Panorama",
                        "latitude": "-21.35639000",
                        "longitude": "-51.85972000"
                    },
                    {
                        "id": 13628,
                        "name": "Paraguaçu Paulista",
                        "latitude": "-22.41278000",
                        "longitude": "-50.57583000"
                    },
                    {
                        "id": 13630,
                        "name": "Paraibuna",
                        "latitude": "-23.48123000",
                        "longitude": "-45.63778000"
                    },
                    {
                        "id": 13659,
                        "name": "Paraíso",
                        "latitude": "-21.01639000",
                        "longitude": "-48.77361000"
                    },
                    {
                        "id": 13639,
                        "name": "Paranapanema",
                        "latitude": "-23.38630000",
                        "longitude": "-48.72441000"
                    },
                    {
                        "id": 13641,
                        "name": "Paranapuã",
                        "latitude": "-20.05940000",
                        "longitude": "-50.59676000"
                    },
                    {
                        "id": 13651,
                        "name": "Parapuã",
                        "latitude": "-21.84482000",
                        "longitude": "-50.83410000"
                    },
                    {
                        "id": 13667,
                        "name": "Pardinho",
                        "latitude": "-23.08987000",
                        "longitude": "-48.38420000"
                    },
                    {
                        "id": 13675,
                        "name": "Pariquera Açu",
                        "latitude": "-24.71500000",
                        "longitude": "-47.88111000"
                    },
                    {
                        "id": 13676,
                        "name": "Pariquera-Açu",
                        "latitude": "-24.66388000",
                        "longitude": "-47.84553000"
                    },
                    {
                        "id": 13677,
                        "name": "Parisi",
                        "latitude": "-20.26554000",
                        "longitude": "-50.03904000"
                    },
                    {
                        "id": 13710,
                        "name": "Patrocínio Paulista",
                        "latitude": "-20.68707000",
                        "longitude": "-47.28437000"
                    },
                    {
                        "id": 13723,
                        "name": "Paulicéia",
                        "latitude": "-21.17172000",
                        "longitude": "-51.75418000"
                    },
                    {
                        "id": 13738,
                        "name": "Paulínia",
                        "latitude": "-22.76111000",
                        "longitude": "-47.15417000"
                    },
                    {
                        "id": 13727,
                        "name": "Paulista Flórida",
                        "latitude": "-21.60000000",
                        "longitude": "-51.20000000"
                    },
                    {
                        "id": 13730,
                        "name": "Paulistânia",
                        "latitude": "-22.57816000",
                        "longitude": "-49.29587000"
                    },
                    {
                        "id": 13737,
                        "name": "Paulo de Faria",
                        "latitude": "-20.09639000",
                        "longitude": "-49.48849000"
                    },
                    {
                        "id": 13744,
                        "name": "Pederneiras",
                        "latitude": "-22.35167000",
                        "longitude": "-48.77500000"
                    },
                    {
                        "id": 13747,
                        "name": "Pedra Bela",
                        "latitude": "-22.76397000",
                        "longitude": "-46.43708000"
                    },
                    {
                        "id": 13761,
                        "name": "Pedranópolis",
                        "latitude": "-20.19986000",
                        "longitude": "-50.08987000"
                    },
                    {
                        "id": 13766,
                        "name": "Pedregulho",
                        "latitude": "-20.25694000",
                        "longitude": "-47.47667000"
                    },
                    {
                        "id": 13767,
                        "name": "Pedreira",
                        "latitude": "-22.74194000",
                        "longitude": "-46.90139000"
                    },
                    {
                        "id": 13770,
                        "name": "Pedrinhas Paulista",
                        "latitude": "-22.80731000",
                        "longitude": "-50.82055000"
                    },
                    {
                        "id": 13784,
                        "name": "Pedro de Toledo",
                        "latitude": "-24.17020000",
                        "longitude": "-47.17239000"
                    },
                    {
                        "id": 13798,
                        "name": "Penápolis",
                        "latitude": "-21.41972000",
                        "longitude": "-50.07750000"
                    },
                    {
                        "id": 13805,
                        "name": "Pereira Barreto",
                        "latitude": "-20.63833000",
                        "longitude": "-51.10917000"
                    },
                    {
                        "id": 13806,
                        "name": "Pereiras",
                        "latitude": "-23.12150000",
                        "longitude": "-47.97614000"
                    },
                    {
                        "id": 13814,
                        "name": "Peruíbe",
                        "latitude": "-24.32000000",
                        "longitude": "-46.99833000"
                    },
                    {
                        "id": 13823,
                        "name": "Piacatu",
                        "latitude": "-21.57301000",
                        "longitude": "-50.65835000"
                    },
                    {
                        "id": 13831,
                        "name": "Piedade",
                        "latitude": "-23.71194000",
                        "longitude": "-47.42778000"
                    },
                    {
                        "id": 13839,
                        "name": "Pilar do Sul",
                        "latitude": "-23.81306000",
                        "longitude": "-47.71639000"
                    },
                    {
                        "id": 13848,
                        "name": "Pindamonhangaba",
                        "latitude": "-22.92389000",
                        "longitude": "-45.46167000"
                    },
                    {
                        "id": 13854,
                        "name": "Pindorama",
                        "latitude": "-21.18583000",
                        "longitude": "-48.90722000"
                    },
                    {
                        "id": 13863,
                        "name": "Pinhalzinho",
                        "latitude": "-22.78213000",
                        "longitude": "-46.57177000"
                    },
                    {
                        "id": 13880,
                        "name": "Piquerobi",
                        "latitude": "-21.84262000",
                        "longitude": "-51.74581000"
                    },
                    {
                        "id": 13882,
                        "name": "Piquete",
                        "latitude": "-22.61361000",
                        "longitude": "-45.17611000"
                    },
                    {
                        "id": 13883,
                        "name": "Piracaia",
                        "latitude": "-23.05389000",
                        "longitude": "-46.35806000"
                    },
                    {
                        "id": 13886,
                        "name": "Piracicaba",
                        "latitude": "-22.71579000",
                        "longitude": "-47.77297000"
                    },
                    {
                        "id": 13888,
                        "name": "Piraju",
                        "latitude": "-23.19361000",
                        "longitude": "-49.38389000"
                    },
                    {
                        "id": 13890,
                        "name": "Pirajuí",
                        "latitude": "-21.99861000",
                        "longitude": "-49.45722000"
                    },
                    {
                        "id": 13893,
                        "name": "Pirangi",
                        "latitude": "-21.08566000",
                        "longitude": "-48.67186000"
                    },
                    {
                        "id": 13901,
                        "name": "Pirapora do Bom Jesus",
                        "latitude": "-23.37201000",
                        "longitude": "-46.97798000"
                    },
                    {
                        "id": 13902,
                        "name": "Pirapozinho",
                        "latitude": "-22.27528000",
                        "longitude": "-51.50000000"
                    },
                    {
                        "id": 13906,
                        "name": "Pirassununga",
                        "latitude": "-21.99611000",
                        "longitude": "-47.42583000"
                    },
                    {
                        "id": 13908,
                        "name": "Piratininga",
                        "latitude": "-22.42279000",
                        "longitude": "-49.19329000"
                    },
                    {
                        "id": 13923,
                        "name": "Pitangueiras",
                        "latitude": "-21.01395000",
                        "longitude": "-48.26197000"
                    },
                    {
                        "id": 13939,
                        "name": "Planalto",
                        "latitude": "-21.00411000",
                        "longitude": "-49.93965000"
                    },
                    {
                        "id": 13944,
                        "name": "Platina",
                        "latitude": "-22.62809000",
                        "longitude": "-50.22211000"
                    },
                    {
                        "id": 14044,
                        "name": "Poá",
                        "latitude": "-23.53459000",
                        "longitude": "-46.34662000"
                    },
                    {
                        "id": 13950,
                        "name": "Poloni",
                        "latitude": "-20.72938000",
                        "longitude": "-49.81550000"
                    },
                    {
                        "id": 13954,
                        "name": "Pompéia",
                        "latitude": "-22.10861000",
                        "longitude": "-50.17167000"
                    },
                    {
                        "id": 13956,
                        "name": "Pongaí",
                        "latitude": "-21.73364000",
                        "longitude": "-49.36396000"
                    },
                    {
                        "id": 13960,
                        "name": "Pontal",
                        "latitude": "-21.02250000",
                        "longitude": "-48.03722000"
                    },
                    {
                        "id": 13964,
                        "name": "Pontalinda",
                        "latitude": "-20.46316000",
                        "longitude": "-50.52208000"
                    },
                    {
                        "id": 13973,
                        "name": "Pontes Gestal",
                        "latitude": "-20.17009000",
                        "longitude": "-49.75902000"
                    },
                    {
                        "id": 13980,
                        "name": "Populina",
                        "latitude": "-19.92212000",
                        "longitude": "-50.51727000"
                    },
                    {
                        "id": 13982,
                        "name": "Porangaba",
                        "latitude": "-23.17583000",
                        "longitude": "-48.12500000"
                    },
                    {
                        "id": 14004,
                        "name": "Porto Feliz",
                        "latitude": "-23.21472000",
                        "longitude": "-47.52389000"
                    },
                    {
                        "id": 14005,
                        "name": "Porto Ferreira",
                        "latitude": "-21.85389000",
                        "longitude": "-47.47917000"
                    },
                    {
                        "id": 14033,
                        "name": "Potim",
                        "latitude": "-22.82497000",
                        "longitude": "-45.30614000"
                    },
                    {
                        "id": 14035,
                        "name": "Potirendaba",
                        "latitude": "-21.10737000",
                        "longitude": "-49.39808000"
                    },
                    {
                        "id": 14057,
                        "name": "Pracinha",
                        "latitude": "-21.84003000",
                        "longitude": "-51.08033000"
                    },
                    {
                        "id": 14062,
                        "name": "Pradópolis",
                        "latitude": "-21.35944000",
                        "longitude": "-48.06556000"
                    },
                    {
                        "id": 14063,
                        "name": "Praia Grande",
                        "latitude": "-24.00583000",
                        "longitude": "-46.40278000"
                    },
                    {
                        "id": 14073,
                        "name": "Pratânia",
                        "latitude": "-22.81737000",
                        "longitude": "-48.68698000"
                    },
                    {
                        "id": 14074,
                        "name": "Presidente Alves",
                        "latitude": "-22.10947000",
                        "longitude": "-49.40588000"
                    },
                    {
                        "id": 14075,
                        "name": "Presidente Bernardes",
                        "latitude": "-22.00611000",
                        "longitude": "-51.55306000"
                    },
                    {
                        "id": 14081,
                        "name": "Presidente Epitácio",
                        "latitude": "-21.76333000",
                        "longitude": "-52.11556000"
                    },
                    {
                        "id": 14095,
                        "name": "Presidente Prudente",
                        "latitude": "-22.12556000",
                        "longitude": "-51.38889000"
                    },
                    {
                        "id": 14099,
                        "name": "Presidente Venceslau",
                        "latitude": "-21.87611000",
                        "longitude": "-51.84389000"
                    },
                    {
                        "id": 14110,
                        "name": "Promissão",
                        "latitude": "-21.53667000",
                        "longitude": "-49.85806000"
                    },
                    {
                        "id": 14125,
                        "name": "Quadra",
                        "latitude": "-23.30027000",
                        "longitude": "-48.04264000"
                    },
                    {
                        "id": 14135,
                        "name": "Quatá",
                        "latitude": "-22.24750000",
                        "longitude": "-50.69833000"
                    },
                    {
                        "id": 14142,
                        "name": "Queiroz",
                        "latitude": "-21.79287000",
                        "longitude": "-50.23587000"
                    },
                    {
                        "id": 14143,
                        "name": "Queluz",
                        "latitude": "-22.51320000",
                        "longitude": "-44.78091000"
                    },
                    {
                        "id": 14151,
                        "name": "Quintana",
                        "latitude": "-22.09720000",
                        "longitude": "-50.37082000"
                    },
                    {
                        "id": 14168,
                        "name": "Rafard",
                        "latitude": "-23.03281000",
                        "longitude": "-47.58676000"
                    },
                    {
                        "id": 14170,
                        "name": "Rancharia",
                        "latitude": "-22.22917000",
                        "longitude": "-50.89306000"
                    },
                    {
                        "id": 14185,
                        "name": "Redenção da Serra",
                        "latitude": "-23.25672000",
                        "longitude": "-45.50200000"
                    },
                    {
                        "id": 14189,
                        "name": "Regente Feijó",
                        "latitude": "-22.22139000",
                        "longitude": "-51.30278000"
                    },
                    {
                        "id": 14190,
                        "name": "Reginópolis",
                        "latitude": "-21.87493000",
                        "longitude": "-49.19025000"
                    },
                    {
                        "id": 14191,
                        "name": "Registro",
                        "latitude": "-24.48750000",
                        "longitude": "-47.84361000"
                    },
                    {
                        "id": 14205,
                        "name": "Restinga",
                        "latitude": "-20.67652000",
                        "longitude": "-47.52058000"
                    },
                    {
                        "id": 14231,
                        "name": "Ribeira",
                        "latitude": "-24.61113000",
                        "longitude": "-49.03616000"
                    },
                    {
                        "id": 14237,
                        "name": "Ribeirão Bonito",
                        "latitude": "-22.06667000",
                        "longitude": "-48.17611000"
                    },
                    {
                        "id": 14238,
                        "name": "Ribeirão Branco",
                        "latitude": "-24.22083000",
                        "longitude": "-48.76556000"
                    },
                    {
                        "id": 14241,
                        "name": "Ribeirão Corrente",
                        "latitude": "-20.44247000",
                        "longitude": "-47.57152000"
                    },
                    {
                        "id": 14250,
                        "name": "Ribeirão do Sul",
                        "latitude": "-22.74112000",
                        "longitude": "-49.94632000"
                    },
                    {
                        "id": 14251,
                        "name": "Ribeirão dos Índios",
                        "latitude": "-21.78470000",
                        "longitude": "-51.57840000"
                    },
                    {
                        "id": 14242,
                        "name": "Ribeirão Grande",
                        "latitude": "-24.17568000",
                        "longitude": "-48.34008000"
                    },
                    {
                        "id": 14243,
                        "name": "Ribeirão Pires",
                        "latitude": "-23.70411000",
                        "longitude": "-46.39991000"
                    },
                    {
                        "id": 14244,
                        "name": "Ribeirão Preto",
                        "latitude": "-21.17750000",
                        "longitude": "-47.81028000"
                    },
                    {
                        "id": 14254,
                        "name": "Rifaina",
                        "latitude": "-20.07816000",
                        "longitude": "-47.43839000"
                    },
                    {
                        "id": 14255,
                        "name": "Rincão",
                        "latitude": "-21.57394000",
                        "longitude": "-47.99687000"
                    },
                    {
                        "id": 14256,
                        "name": "Rinópolis",
                        "latitude": "-21.66311000",
                        "longitude": "-50.72038000"
                    },
                    {
                        "id": 14269,
                        "name": "Rio Claro",
                        "latitude": "-22.41139000",
                        "longitude": "-47.56139000"
                    },
                    {
                        "id": 14307,
                        "name": "Rio das Pedras",
                        "latitude": "-22.84082000",
                        "longitude": "-47.59724000"
                    },
                    {
                        "id": 14277,
                        "name": "Rio Grande da Serra",
                        "latitude": "-23.73345000",
                        "longitude": "-46.37351000"
                    },
                    {
                        "id": 14320,
                        "name": "Riolândia",
                        "latitude": "-19.98083000",
                        "longitude": "-49.68194000"
                    },
                    {
                        "id": 14324,
                        "name": "Riversul",
                        "latitude": "-23.84439000",
                        "longitude": "-49.44354000"
                    },
                    {
                        "id": 14348,
                        "name": "Rosana",
                        "latitude": "-22.49250000",
                        "longitude": "-52.81942000"
                    },
                    {
                        "id": 14349,
                        "name": "Roseira",
                        "latitude": "-22.93295000",
                        "longitude": "-45.29982000"
                    },
                    {
                        "id": 14361,
                        "name": "Rubiácea",
                        "latitude": "-21.36114000",
                        "longitude": "-50.78593000"
                    },
                    {
                        "id": 14360,
                        "name": "Rubinéia",
                        "latitude": "-20.24994000",
                        "longitude": "-51.01836000"
                    },
                    {
                        "id": 14367,
                        "name": "Sabino",
                        "latitude": "-21.47970000",
                        "longitude": "-49.57650000"
                    },
                    {
                        "id": 14374,
                        "name": "Sagres",
                        "latitude": "-21.86529000",
                        "longitude": "-51.00502000"
                    },
                    {
                        "id": 14377,
                        "name": "Sales",
                        "latitude": "-21.33848000",
                        "longitude": "-49.51847000"
                    },
                    {
                        "id": 14378,
                        "name": "Sales Oliveira",
                        "latitude": "-20.83364000",
                        "longitude": "-47.84079000"
                    },
                    {
                        "id": 14379,
                        "name": "Salesópolis",
                        "latitude": "-23.58753000",
                        "longitude": "-45.84743000"
                    },
                    {
                        "id": 14391,
                        "name": "Salmourão",
                        "latitude": "-21.58291000",
                        "longitude": "-50.87491000"
                    },
                    {
                        "id": 14393,
                        "name": "Saltinho",
                        "latitude": "-22.86275000",
                        "longitude": "-47.72668000"
                    },
                    {
                        "id": 14395,
                        "name": "Salto",
                        "latitude": "-23.20083000",
                        "longitude": "-47.28694000"
                    },
                    {
                        "id": 14399,
                        "name": "Salto de Pirapora",
                        "latitude": "-23.64889000",
                        "longitude": "-47.57333000"
                    },
                    {
                        "id": 14396,
                        "name": "Salto Grande",
                        "latitude": "-22.87363000",
                        "longitude": "-49.96190000"
                    },
                    {
                        "id": 14413,
                        "name": "Sandovalina",
                        "latitude": "-22.45478000",
                        "longitude": "-51.85322000"
                    },
                    {
                        "id": 14417,
                        "name": "Santa Adélia",
                        "latitude": "-21.24278000",
                        "longitude": "-48.80417000"
                    },
                    {
                        "id": 14418,
                        "name": "Santa Albertina",
                        "latitude": "-20.03496000",
                        "longitude": "-50.71776000"
                    },
                    {
                        "id": 14424,
                        "name": "Santa Bárbara d'Oeste",
                        "latitude": "-22.75361000",
                        "longitude": "-47.41361000"
                    },
                    {
                        "id": 14420,
                        "name": "Santa Branca",
                        "latitude": "-23.39667000",
                        "longitude": "-45.88389000"
                    },
                    {
                        "id": 14436,
                        "name": "Santa Clara d'Oeste",
                        "latitude": "-20.07534000",
                        "longitude": "-50.89870000"
                    },
                    {
                        "id": 14443,
                        "name": "Santa Cruz da Conceição",
                        "latitude": "-22.12608000",
                        "longitude": "-47.49276000"
                    },
                    {
                        "id": 14444,
                        "name": "Santa Cruz da Esperança",
                        "latitude": "-21.26170000",
                        "longitude": "-47.44749000"
                    },
                    {
                        "id": 14446,
                        "name": "Santa Cruz das Palmeiras",
                        "latitude": "-21.82694000",
                        "longitude": "-47.24861000"
                    },
                    {
                        "id": 14455,
                        "name": "Santa Cruz do Rio Pardo",
                        "latitude": "-22.89889000",
                        "longitude": "-49.63250000"
                    },
                    {
                        "id": 14460,
                        "name": "Santa Ernestina",
                        "latitude": "-21.45303000",
                        "longitude": "-48.37797000"
                    },
                    {
                        "id": 14468,
                        "name": "Santa Fé do Sul",
                        "latitude": "-20.21111000",
                        "longitude": "-50.92583000"
                    },
                    {
                        "id": 14469,
                        "name": "Santa Gertrudes",
                        "latitude": "-22.45667000",
                        "longitude": "-47.53028000"
                    },
                    {
                        "id": 14480,
                        "name": "Santa Isabel",
                        "latitude": "-23.29440000",
                        "longitude": "-46.24151000"
                    },
                    {
                        "id": 14498,
                        "name": "Santa Lúcia",
                        "latitude": "-21.66472000",
                        "longitude": "-48.08283000"
                    },
                    {
                        "id": 14506,
                        "name": "Santa Maria da Serra",
                        "latitude": "-22.53752000",
                        "longitude": "-48.14455000"
                    },
                    {
                        "id": 14519,
                        "name": "Santa Mercedes",
                        "latitude": "-21.31829000",
                        "longitude": "-51.74637000"
                    },
                    {
                        "id": 14526,
                        "name": "Santa Rita d'Oeste",
                        "latitude": "-20.08064000",
                        "longitude": "-50.81371000"
                    },
                    {
                        "id": 14536,
                        "name": "Santa Rita do Passa Quatro",
                        "latitude": "-21.71028000",
                        "longitude": "-47.47806000"
                    },
                    {
                        "id": 14545,
                        "name": "Santa Rosa de Viterbo",
                        "latitude": "-21.47278000",
                        "longitude": "-47.36306000"
                    },
                    {
                        "id": 14550,
                        "name": "Santa Salete",
                        "latitude": "-20.27360000",
                        "longitude": "-50.72826000"
                    },
                    {
                        "id": 14571,
                        "name": "Santana da Ponte Pensa",
                        "latitude": "-20.25649000",
                        "longitude": "-50.79852000"
                    },
                    {
                        "id": 14575,
                        "name": "Santana de Parnaíba",
                        "latitude": "-23.44417000",
                        "longitude": "-46.91778000"
                    },
                    {
                        "id": 14607,
                        "name": "Santo Anastácio",
                        "latitude": "-22.01522000",
                        "longitude": "-51.70097000"
                    },
                    {
                        "id": 14609,
                        "name": "Santo André",
                        "latitude": "-23.71057000",
                        "longitude": "-46.50460000"
                    },
                    {
                        "id": 14611,
                        "name": "Santo Antônio da Alegria",
                        "latitude": "-21.09238000",
                        "longitude": "-47.20360000"
                    },
                    {
                        "id": 14619,
                        "name": "Santo Antônio de Posse",
                        "latitude": "-22.60611000",
                        "longitude": "-46.91944000"
                    },
                    {
                        "id": 14622,
                        "name": "Santo Antônio do Aracanguá",
                        "latitude": "-20.85619000",
                        "longitude": "-50.53106000"
                    },
                    {
                        "id": 14630,
                        "name": "Santo Antônio do Jardim",
                        "latitude": "-22.12625000",
                        "longitude": "-46.67237000"
                    },
                    {
                        "id": 14636,
                        "name": "Santo Antônio do Pinhal",
                        "latitude": "-22.82143000",
                        "longitude": "-45.69968000"
                    },
                    {
                        "id": 14647,
                        "name": "Santo Expedito",
                        "latitude": "-21.82978000",
                        "longitude": "-51.36993000"
                    },
                    {
                        "id": 14655,
                        "name": "Santópolis do Aguapeí",
                        "latitude": "-21.67058000",
                        "longitude": "-50.52029000"
                    },
                    {
                        "id": 14653,
                        "name": "Santos",
                        "latitude": "-23.85663000",
                        "longitude": "-46.27055000"
                    },
                    {
                        "id": 14839,
                        "name": "São Bento do Sapucaí",
                        "latitude": "-22.67091000",
                        "longitude": "-45.68394000"
                    },
                    {
                        "id": 14846,
                        "name": "São Bernardo do Campo",
                        "latitude": "-23.69389000",
                        "longitude": "-46.56500000"
                    },
                    {
                        "id": 14853,
                        "name": "São Caetano do Sul",
                        "latitude": "-23.62429000",
                        "longitude": "-46.56241000"
                    },
                    {
                        "id": 14855,
                        "name": "São Carlos",
                        "latitude": "-22.01750000",
                        "longitude": "-47.89083000"
                    },
                    {
                        "id": 14881,
                        "name": "São Francisco",
                        "latitude": "-20.36457000",
                        "longitude": "-50.67463000"
                    },
                    {
                        "id": 15007,
                        "name": "São João da Boa Vista",
                        "latitude": "-21.96917000",
                        "longitude": "-46.79806000"
                    },
                    {
                        "id": 15018,
                        "name": "São João das Duas Pontes",
                        "latitude": "-20.41912000",
                        "longitude": "-50.38960000"
                    },
                    {
                        "id": 15020,
                        "name": "São João de Iracema",
                        "latitude": "-20.51199000",
                        "longitude": "-50.36102000"
                    },
                    {
                        "id": 15039,
                        "name": "São João do Pau d'Alho",
                        "latitude": "-21.20519000",
                        "longitude": "-51.66857000"
                    },
                    {
                        "id": 14931,
                        "name": "São Joaquim da Barra",
                        "latitude": "-20.58139000",
                        "longitude": "-47.85472000"
                    },
                    {
                        "id": 14940,
                        "name": "São José da Bela Vista",
                        "latitude": "-20.59934000",
                        "longitude": "-47.62940000"
                    },
                    {
                        "id": 14960,
                        "name": "São José do Barreiro",
                        "latitude": "-22.73717000",
                        "longitude": "-44.58545000"
                    },
                    {
                        "id": 14984,
                        "name": "São José do Rio Pardo",
                        "latitude": "-21.59556000",
                        "longitude": "-46.88861000"
                    },
                    {
                        "id": 14985,
                        "name": "São José do Rio Preto",
                        "latitude": "-20.81972000",
                        "longitude": "-49.37944000"
                    },
                    {
                        "id": 14993,
                        "name": "São José dos Campos",
                        "latitude": "-23.17944000",
                        "longitude": "-45.88694000"
                    },
                    {
                        "id": 15054,
                        "name": "São Lourenço da Serra",
                        "latitude": "-23.84783000",
                        "longitude": "-46.93930000"
                    },
                    {
                        "id": 15062,
                        "name": "São Luiz do Paraitinga",
                        "latitude": "-23.26061000",
                        "longitude": "-45.22724000"
                    },
                    {
                        "id": 15070,
                        "name": "São Manuel",
                        "latitude": "-22.73111000",
                        "longitude": "-48.57056000"
                    },
                    {
                        "id": 15079,
                        "name": "São Miguel Arcanjo",
                        "latitude": "-23.93766000",
                        "longitude": "-47.99988000"
                    },
                    {
                        "id": 15101,
                        "name": "São Paulo",
                        "latitude": "-23.54750000",
                        "longitude": "-46.63611000"
                    },
                    {
                        "id": 15106,
                        "name": "São Pedro",
                        "latitude": "-22.55963000",
                        "longitude": "-47.90443000"
                    },
                    {
                        "id": 15122,
                        "name": "São Pedro do Turvo",
                        "latitude": "-22.69638000",
                        "longitude": "-49.74295000"
                    },
                    {
                        "id": 15131,
                        "name": "São Roque",
                        "latitude": "-23.54011000",
                        "longitude": "-47.11280000"
                    },
                    {
                        "id": 15135,
                        "name": "São Sebastião",
                        "latitude": "-23.76000000",
                        "longitude": "-45.40972000"
                    },
                    {
                        "id": 15140,
                        "name": "São Sebastião da Grama",
                        "latitude": "-21.74730000",
                        "longitude": "-46.75934000"
                    },
                    {
                        "id": 15156,
                        "name": "São Simão",
                        "latitude": "-21.47917000",
                        "longitude": "-47.55083000"
                    },
                    {
                        "id": 15168,
                        "name": "São Vicente",
                        "latitude": "-23.96506000",
                        "longitude": "-46.49683000"
                    },
                    {
                        "id": 14669,
                        "name": "Sarapuí",
                        "latitude": "-23.65898000",
                        "longitude": "-47.77095000"
                    },
                    {
                        "id": 14671,
                        "name": "Sarutaiá",
                        "latitude": "-23.25823000",
                        "longitude": "-49.48372000"
                    },
                    {
                        "id": 14682,
                        "name": "Sebastianópolis do Sul",
                        "latitude": "-20.61558000",
                        "longitude": "-49.90753000"
                    },
                    {
                        "id": 14723,
                        "name": "Serra Azul",
                        "latitude": "-21.28755000",
                        "longitude": "-47.53885000"
                    },
                    {
                        "id": 14729,
                        "name": "Serra Negra",
                        "latitude": "-22.61222000",
                        "longitude": "-46.70056000"
                    },
                    {
                        "id": 14743,
                        "name": "Serrana",
                        "latitude": "-21.21139000",
                        "longitude": "-47.59556000"
                    },
                    {
                        "id": 14762,
                        "name": "Sertãozinho",
                        "latitude": "-21.13778000",
                        "longitude": "-47.99028000"
                    },
                    {
                        "id": 14764,
                        "name": "Sete Barras",
                        "latitude": "-24.27723000",
                        "longitude": "-47.95013000"
                    },
                    {
                        "id": 14771,
                        "name": "Severínia",
                        "latitude": "-20.78066000",
                        "longitude": "-48.79037000"
                    },
                    {
                        "id": 14778,
                        "name": "Silveiras",
                        "latitude": "-22.73649000",
                        "longitude": "-44.84778000"
                    },
                    {
                        "id": 14800,
                        "name": "Socorro",
                        "latitude": "-22.59139000",
                        "longitude": "-46.52889000"
                    },
                    {
                        "id": 14811,
                        "name": "Sorocaba",
                        "latitude": "-23.50167000",
                        "longitude": "-47.45806000"
                    },
                    {
                        "id": 14820,
                        "name": "Sud Mennucci",
                        "latitude": "-20.61860000",
                        "longitude": "-50.88011000"
                    },
                    {
                        "id": 14823,
                        "name": "Sumaré",
                        "latitude": "-22.82194000",
                        "longitude": "-47.26694000"
                    },
                    {
                        "id": 14829,
                        "name": "Suzanápolis",
                        "latitude": "-20.51030000",
                        "longitude": "-51.07079000"
                    },
                    {
                        "id": 14828,
                        "name": "Suzano",
                        "latitude": "-23.54250000",
                        "longitude": "-46.31083000"
                    },
                    {
                        "id": 15183,
                        "name": "Tabapuã",
                        "latitude": "-20.92377000",
                        "longitude": "-49.02475000"
                    },
                    {
                        "id": 15185,
                        "name": "Tabatinga",
                        "latitude": "-21.74210000",
                        "longitude": "-48.64589000"
                    },
                    {
                        "id": 15190,
                        "name": "Taboão da Serra",
                        "latitude": "-23.62611000",
                        "longitude": "-46.79167000"
                    },
                    {
                        "id": 15195,
                        "name": "Taciba",
                        "latitude": "-22.49676000",
                        "longitude": "-51.33241000"
                    },
                    {
                        "id": 15199,
                        "name": "Taguaí",
                        "latitude": "-23.48512000",
                        "longitude": "-49.40781000"
                    },
                    {
                        "id": 15200,
                        "name": "Taiaçu",
                        "latitude": "-21.13217000",
                        "longitude": "-48.53092000"
                    },
                    {
                        "id": 15206,
                        "name": "Taiúva",
                        "latitude": "-21.12737000",
                        "longitude": "-48.42696000"
                    },
                    {
                        "id": 15210,
                        "name": "Tambaú",
                        "latitude": "-21.58688000",
                        "longitude": "-47.22761000"
                    },
                    {
                        "id": 15214,
                        "name": "Tanabi",
                        "latitude": "-20.50212000",
                        "longitude": "-49.64584000"
                    },
                    {
                        "id": 15238,
                        "name": "Tapiraí",
                        "latitude": "-24.01487000",
                        "longitude": "-47.62583000"
                    },
                    {
                        "id": 15236,
                        "name": "Tapiratiba",
                        "latitude": "-21.44656000",
                        "longitude": "-46.73214000"
                    },
                    {
                        "id": 15241,
                        "name": "Taquaral",
                        "latitude": "-21.06760000",
                        "longitude": "-48.39336000"
                    },
                    {
                        "id": 15246,
                        "name": "Taquaritinga",
                        "latitude": "-21.43270000",
                        "longitude": "-48.54735000"
                    },
                    {
                        "id": 15248,
                        "name": "Taquarituba",
                        "latitude": "-23.52998000",
                        "longitude": "-49.21441000"
                    },
                    {
                        "id": 15249,
                        "name": "Taquarivaí",
                        "latitude": "-23.95095000",
                        "longitude": "-48.67524000"
                    },
                    {
                        "id": 15252,
                        "name": "Tarabai",
                        "latitude": "-22.35043000",
                        "longitude": "-51.62019000"
                    },
                    {
                        "id": 15257,
                        "name": "Tarumã",
                        "latitude": "-22.76111000",
                        "longitude": "-50.60332000"
                    },
                    {
                        "id": 15259,
                        "name": "Tatuí",
                        "latitude": "-23.35556000",
                        "longitude": "-47.85694000"
                    },
                    {
                        "id": 15260,
                        "name": "Taubaté",
                        "latitude": "-23.02639000",
                        "longitude": "-45.55528000"
                    },
                    {
                        "id": 15270,
                        "name": "Tejupá",
                        "latitude": "-23.35231000",
                        "longitude": "-49.30721000"
                    },
                    {
                        "id": 15279,
                        "name": "Teodoro Sampaio",
                        "latitude": "-22.41617000",
                        "longitude": "-52.36402000"
                    },
                    {
                        "id": 15296,
                        "name": "Terra Roxa",
                        "latitude": "-20.76175000",
                        "longitude": "-48.36899000"
                    },
                    {
                        "id": 15307,
                        "name": "Tietê",
                        "latitude": "-23.04197000",
                        "longitude": "-47.71430000"
                    },
                    {
                        "id": 15314,
                        "name": "Timburi",
                        "latitude": "-23.19265000",
                        "longitude": "-49.61224000"
                    },
                    {
                        "id": 15340,
                        "name": "Torre de Pedra",
                        "latitude": "-23.24640000",
                        "longitude": "-48.21328000"
                    },
                    {
                        "id": 15342,
                        "name": "Torrinha",
                        "latitude": "-22.47144000",
                        "longitude": "-48.15338000"
                    },
                    {
                        "id": 15344,
                        "name": "Trabiju",
                        "latitude": "-22.03023000",
                        "longitude": "-48.36861000"
                    },
                    {
                        "id": 15354,
                        "name": "Tremembé",
                        "latitude": "-22.92410000",
                        "longitude": "-45.61503000"
                    },
                    {
                        "id": 15376,
                        "name": "Três Fronteiras",
                        "latitude": "-20.29093000",
                        "longitude": "-50.87027000"
                    },
                    {
                        "id": 15391,
                        "name": "Tuiuti",
                        "latitude": "-22.84505000",
                        "longitude": "-46.69618000"
                    },
                    {
                        "id": 15408,
                        "name": "Tupã",
                        "latitude": "-21.95443000",
                        "longitude": "-50.53493000"
                    },
                    {
                        "id": 15405,
                        "name": "Tupi Paulista",
                        "latitude": "-21.38916000",
                        "longitude": "-51.58294000"
                    },
                    {
                        "id": 15412,
                        "name": "Turiúba",
                        "latitude": "-20.94735000",
                        "longitude": "-50.09803000"
                    },
                    {
                        "id": 15414,
                        "name": "Turmalina",
                        "latitude": "-20.05953000",
                        "longitude": "-50.45595000"
                    },
                    {
                        "id": 15428,
                        "name": "Ubarana",
                        "latitude": "-21.22036000",
                        "longitude": "-49.72981000"
                    },
                    {
                        "id": 15429,
                        "name": "Ubatuba",
                        "latitude": "-23.43389000",
                        "longitude": "-45.07111000"
                    },
                    {
                        "id": 15435,
                        "name": "Ubirajara",
                        "latitude": "-22.55131000",
                        "longitude": "-49.66278000"
                    },
                    {
                        "id": 15439,
                        "name": "Uchoa",
                        "latitude": "-20.91850000",
                        "longitude": "-49.13654000"
                    },
                    {
                        "id": 15457,
                        "name": "União Paulista",
                        "latitude": "-20.88795000",
                        "longitude": "-49.89135000"
                    },
                    {
                        "id": 15488,
                        "name": "Urânia",
                        "latitude": "-20.20908000",
                        "longitude": "-50.66093000"
                    },
                    {
                        "id": 15468,
                        "name": "Uru",
                        "latitude": "-21.76519000",
                        "longitude": "-49.29720000"
                    },
                    {
                        "id": 15483,
                        "name": "Urupês",
                        "latitude": "-21.18413000",
                        "longitude": "-49.28069000"
                    },
                    {
                        "id": 15498,
                        "name": "Valentim Gentil",
                        "latitude": "-20.43138000",
                        "longitude": "-50.12129000"
                    },
                    {
                        "id": 15502,
                        "name": "Valinhos",
                        "latitude": "-22.97056000",
                        "longitude": "-46.99583000"
                    },
                    {
                        "id": 15503,
                        "name": "Valparaíso",
                        "latitude": "-21.21512000",
                        "longitude": "-50.94698000"
                    },
                    {
                        "id": 15506,
                        "name": "Vargem",
                        "latitude": "-22.89117000",
                        "longitude": "-46.41556000"
                    },
                    {
                        "id": 15515,
                        "name": "Vargem Grande do Sul",
                        "latitude": "-21.87152000",
                        "longitude": "-46.89073000"
                    },
                    {
                        "id": 15513,
                        "name": "Vargem Grande Paulista",
                        "latitude": "-23.62856000",
                        "longitude": "-47.01914000"
                    },
                    {
                        "id": 15620,
                        "name": "Várzea Paulista",
                        "latitude": "-23.21139000",
                        "longitude": "-46.82833000"
                    },
                    {
                        "id": 15535,
                        "name": "Vera Cruz",
                        "latitude": "-22.23340000",
                        "longitude": "-49.83281000"
                    },
                    {
                        "id": 15580,
                        "name": "Vinhedo",
                        "latitude": "-23.05397000",
                        "longitude": "-46.98135000"
                    },
                    {
                        "id": 15581,
                        "name": "Viradouro",
                        "latitude": "-20.87625000",
                        "longitude": "-48.31479000"
                    },
                    {
                        "id": 15590,
                        "name": "Vista Alegre do Alto",
                        "latitude": "-21.18019000",
                        "longitude": "-48.65482000"
                    },
                    {
                        "id": 15598,
                        "name": "Vitória Brasil",
                        "latitude": "-20.19354000",
                        "longitude": "-50.47940000"
                    },
                    {
                        "id": 15611,
                        "name": "Votorantim",
                        "latitude": "-23.54667000",
                        "longitude": "-47.43778000"
                    },
                    {
                        "id": 15612,
                        "name": "Votuporanga",
                        "latitude": "-20.48010000",
                        "longitude": "-50.01266000"
                    },
                    {
                        "id": 15645,
                        "name": "Zacarias",
                        "latitude": "-21.11651000",
                        "longitude": "-50.06154000"
                    }
                ]
            },
            {
                "id": 2003,
                "name": "Sergipe",
                "iso2": "SE",
                "latitude": "-10.57409340",
                "longitude": "-37.38565810",
                "type": "state",
                "cities": [
                    {
                        "id": 10221,
                        "name": "Amparo de São Francisco",
                        "latitude": "-10.13736000",
                        "longitude": "-36.92219000"
                    },
                    {
                        "id": 10304,
                        "name": "Aquidabã",
                        "latitude": "-10.31619000",
                        "longitude": "-37.10451000"
                    },
                    {
                        "id": 10308,
                        "name": "Aracaju",
                        "latitude": "-10.98232000",
                        "longitude": "-37.10333000"
                    },
                    {
                        "id": 10364,
                        "name": "Arauá",
                        "latitude": "-11.26222000",
                        "longitude": "-37.61972000"
                    },
                    {
                        "id": 10385,
                        "name": "Areia Branca",
                        "latitude": "-10.75778000",
                        "longitude": "-37.31528000"
                    },
                    {
                        "id": 10546,
                        "name": "Barra dos Coqueiros",
                        "latitude": "-10.90889000",
                        "longitude": "-37.03861000"
                    },
                    {
                        "id": 10746,
                        "name": "Boquim",
                        "latitude": "-11.14694000",
                        "longitude": "-37.62056000"
                    },
                    {
                        "id": 10790,
                        "name": "Brejo Grande",
                        "latitude": "-10.49241000",
                        "longitude": "-36.45883000"
                    },
                    {
                        "id": 11005,
                        "name": "Campo do Brito",
                        "latitude": "-10.73333000",
                        "longitude": "-37.49333000"
                    },
                    {
                        "id": 11044,
                        "name": "Canhoba",
                        "latitude": "-10.14847000",
                        "longitude": "-37.00031000"
                    },
                    {
                        "id": 11047,
                        "name": "Canindé de São Francisco",
                        "latitude": "-9.66000000",
                        "longitude": "-37.78944000"
                    },
                    {
                        "id": 11065,
                        "name": "Capela",
                        "latitude": "-10.50333000",
                        "longitude": "-37.05278000"
                    },
                    {
                        "id": 11132,
                        "name": "Carira",
                        "latitude": "-10.36555000",
                        "longitude": "-37.74990000"
                    },
                    {
                        "id": 11152,
                        "name": "Carmópolis",
                        "latitude": "-10.66710000",
                        "longitude": "-36.95751000"
                    },
                    {
                        "id": 11232,
                        "name": "Cedro de São João",
                        "latitude": "-10.28046000",
                        "longitude": "-36.88830000"
                    },
                    {
                        "id": 11478,
                        "name": "Cristinápolis",
                        "latitude": "-11.47556000",
                        "longitude": "-37.75528000"
                    },
                    {
                        "id": 11515,
                        "name": "Cumbe",
                        "latitude": "-10.34959000",
                        "longitude": "-37.17665000"
                    },
                    {
                        "id": 11599,
                        "name": "Divina Pastora",
                        "latitude": "-10.67935000",
                        "longitude": "-37.16817000"
                    },
                    {
                        "id": 11757,
                        "name": "Estância",
                        "latitude": "-11.23831000",
                        "longitude": "-37.42046000"
                    },
                    {
                        "id": 11791,
                        "name": "Feira Nova",
                        "latitude": "-10.31724000",
                        "longitude": "-37.33850000"
                    },
                    {
                        "id": 11896,
                        "name": "Frei Paulo",
                        "latitude": "-10.52224000",
                        "longitude": "-37.58028000"
                    },
                    {
                        "id": 11920,
                        "name": "Gararu",
                        "latitude": "-9.96750000",
                        "longitude": "-37.08333000"
                    },
                    {
                        "id": 11937,
                        "name": "General Maynard",
                        "latitude": "-10.69412000",
                        "longitude": "-36.98304000"
                    },
                    {
                        "id": 11991,
                        "name": "Gracho Cardoso",
                        "latitude": "-10.23500000",
                        "longitude": "-37.20389000"
                    },
                    {
                        "id": 12210,
                        "name": "Ilha das Flores",
                        "latitude": "-10.44455000",
                        "longitude": "-36.56429000"
                    },
                    {
                        "id": 12241,
                        "name": "Indiaroba",
                        "latitude": "-11.51917000",
                        "longitude": "-37.51167000"
                    },
                    {
                        "id": 12326,
                        "name": "Itabaiana",
                        "latitude": "-10.68500000",
                        "longitude": "-37.42528000"
                    },
                    {
                        "id": 12327,
                        "name": "Itabaianinha",
                        "latitude": "-11.26994000",
                        "longitude": "-37.79205000"
                    },
                    {
                        "id": 12332,
                        "name": "Itabi",
                        "latitude": "-10.10882000",
                        "longitude": "-37.20004000"
                    },
                    {
                        "id": 12431,
                        "name": "Itaporanga d'Ajuda",
                        "latitude": "-11.07087000",
                        "longitude": "-37.33296000"
                    },
                    {
                        "id": 12567,
                        "name": "Japaratuba",
                        "latitude": "-10.59333000",
                        "longitude": "-36.94028000"
                    },
                    {
                        "id": 12572,
                        "name": "Japoatã",
                        "latitude": "-10.34667000",
                        "longitude": "-36.80111000"
                    },
                    {
                        "id": 12726,
                        "name": "Lagarto",
                        "latitude": "-10.89844000",
                        "longitude": "-37.67993000"
                    },
                    {
                        "id": 12799,
                        "name": "Laranjeiras",
                        "latitude": "-10.80700000",
                        "longitude": "-37.16896000"
                    },
                    {
                        "id": 12885,
                        "name": "Macambira",
                        "latitude": "-10.68545000",
                        "longitude": "-37.60003000"
                    },
                    {
                        "id": 12927,
                        "name": "Malhada dos Bois",
                        "latitude": "-10.32806000",
                        "longitude": "-36.93573000"
                    },
                    {
                        "id": 12928,
                        "name": "Malhador",
                        "latitude": "-10.65778000",
                        "longitude": "-37.30472000"
                    },
                    {
                        "id": 13036,
                        "name": "Maruim",
                        "latitude": "-10.73750000",
                        "longitude": "-37.08167000"
                    },
                    {
                        "id": 13169,
                        "name": "Moita Bonita",
                        "latitude": "-10.57750000",
                        "longitude": "-37.34278000"
                    },
                    {
                        "id": 13190,
                        "name": "Monte Alegre de Sergipe",
                        "latitude": "-10.07263000",
                        "longitude": "-37.60470000"
                    },
                    {
                        "id": 13279,
                        "name": "Muribeca",
                        "latitude": "-10.38925000",
                        "longitude": "-36.97628000"
                    },
                    {
                        "id": 13320,
                        "name": "Neópolis",
                        "latitude": "-10.35698000",
                        "longitude": "-36.66870000"
                    },
                    {
                        "id": 13336,
                        "name": "Nossa Senhora Aparecida",
                        "latitude": "-10.29846000",
                        "longitude": "-37.48812000"
                    },
                    {
                        "id": 13337,
                        "name": "Nossa Senhora da Glória",
                        "latitude": "-10.19293000",
                        "longitude": "-37.53292000"
                    },
                    {
                        "id": 13338,
                        "name": "Nossa Senhora das Dores",
                        "latitude": "-10.45356000",
                        "longitude": "-37.24677000"
                    },
                    {
                        "id": 13340,
                        "name": "Nossa Senhora de Lourdes",
                        "latitude": "-10.10241000",
                        "longitude": "-37.02768000"
                    },
                    {
                        "id": 13343,
                        "name": "Nossa Senhora do Socorro",
                        "latitude": "-10.85500000",
                        "longitude": "-37.12611000"
                    },
                    {
                        "id": 13558,
                        "name": "Pacatuba",
                        "latitude": "-10.49466000",
                        "longitude": "-36.60382000"
                    },
                    {
                        "id": 13755,
                        "name": "Pedra Mole",
                        "latitude": "-10.66490000",
                        "longitude": "-37.68505000"
                    },
                    {
                        "id": 13769,
                        "name": "Pedrinhas",
                        "latitude": "-11.21666000",
                        "longitude": "-37.65664000"
                    },
                    {
                        "id": 13874,
                        "name": "Pinhão",
                        "latitude": "-10.57105000",
                        "longitude": "-37.78582000"
                    },
                    {
                        "id": 13891,
                        "name": "Pirambu",
                        "latitude": "-10.69075000",
                        "longitude": "-36.84859000"
                    },
                    {
                        "id": 14048,
                        "name": "Poço Redondo",
                        "latitude": "-9.88033000",
                        "longitude": "-37.77612000"
                    },
                    {
                        "id": 14049,
                        "name": "Poço Verde",
                        "latitude": "-10.81636000",
                        "longitude": "-38.15053000"
                    },
                    {
                        "id": 14024,
                        "name": "Porto da Folha",
                        "latitude": "-9.98927000",
                        "longitude": "-37.48059000"
                    },
                    {
                        "id": 14111,
                        "name": "Propriá",
                        "latitude": "-10.25379000",
                        "longitude": "-36.78579000"
                    },
                    {
                        "id": 14224,
                        "name": "Riachão do Dantas",
                        "latitude": "-11.01281000",
                        "longitude": "-37.78679000"
                    },
                    {
                        "id": 14218,
                        "name": "Riachuelo",
                        "latitude": "-10.71605000",
                        "longitude": "-37.22502000"
                    },
                    {
                        "id": 14253,
                        "name": "Ribeirópolis",
                        "latitude": "-10.52176000",
                        "longitude": "-37.37833000"
                    },
                    {
                        "id": 14353,
                        "name": "Rosário do Catete",
                        "latitude": "-10.68551000",
                        "longitude": "-37.03447000"
                    },
                    {
                        "id": 14383,
                        "name": "Salgado",
                        "latitude": "-11.03194000",
                        "longitude": "-37.47500000"
                    },
                    {
                        "id": 14494,
                        "name": "Santa Luzia do Itanhy",
                        "latitude": "-11.36149000",
                        "longitude": "-37.47848000"
                    },
                    {
                        "id": 14543,
                        "name": "Santa Rosa de Lima",
                        "latitude": "-10.63139000",
                        "longitude": "-37.22866000"
                    },
                    {
                        "id": 14594,
                        "name": "Santana do São Francisco",
                        "latitude": "-10.27648000",
                        "longitude": "-36.63314000"
                    },
                    {
                        "id": 14605,
                        "name": "Santo Amaro das Brotas",
                        "latitude": "-10.78889000",
                        "longitude": "-37.05444000"
                    },
                    {
                        "id": 14858,
                        "name": "São Cristóvão",
                        "latitude": "-11.01472000",
                        "longitude": "-37.20639000"
                    },
                    {
                        "id": 14865,
                        "name": "São Domingos",
                        "latitude": "-10.78191000",
                        "longitude": "-37.56218000"
                    },
                    {
                        "id": 14880,
                        "name": "São Francisco",
                        "latitude": "-10.33062000",
                        "longitude": "-36.86390000"
                    },
                    {
                        "id": 15085,
                        "name": "São Miguel do Aleixo",
                        "latitude": "-10.36859000",
                        "longitude": "-37.35856000"
                    },
                    {
                        "id": 14786,
                        "name": "Simão Dias",
                        "latitude": "-10.71163000",
                        "longitude": "-37.77142000"
                    },
                    {
                        "id": 14794,
                        "name": "Siriri",
                        "latitude": "-10.58724000",
                        "longitude": "-37.12123000"
                    },
                    {
                        "id": 15272,
                        "name": "Telha",
                        "latitude": "-10.17943000",
                        "longitude": "-36.86754000"
                    },
                    {
                        "id": 15324,
                        "name": "Tobias Barreto",
                        "latitude": "-11.07792000",
                        "longitude": "-38.02178000"
                    },
                    {
                        "id": 15331,
                        "name": "Tomar do Geru",
                        "latitude": "-11.37415000",
                        "longitude": "-37.87537000"
                    },
                    {
                        "id": 15446,
                        "name": "Umbaúba",
                        "latitude": "-11.40045000",
                        "longitude": "-37.66270000"
                    }
                ]
            },
            {
                "id": 2020,
                "name": "Tocantins",
                "iso2": "TO",
                "latitude": "-10.17528000",
                "longitude": "-48.29824740",
                "type": "state",
                "cities": [
                    {
                        "id": 10067,
                        "name": "Abreulândia",
                        "latitude": "-9.43672000",
                        "longitude": "-49.31733000"
                    },
                    {
                        "id": 10101,
                        "name": "Aguiarnópolis",
                        "latitude": "-6.48176000",
                        "longitude": "-47.51435000"
                    },
                    {
                        "id": 10138,
                        "name": "Aliança do Tocantins",
                        "latitude": "-11.32864000",
                        "longitude": "-48.95855000"
                    },
                    {
                        "id": 10140,
                        "name": "Almas",
                        "latitude": "-11.43527000",
                        "longitude": "-47.23635000"
                    },
                    {
                        "id": 10194,
                        "name": "Alvorada",
                        "latitude": "-12.48000000",
                        "longitude": "-49.12472000"
                    },
                    {
                        "id": 10235,
                        "name": "Ananás",
                        "latitude": "-6.14621000",
                        "longitude": "-48.21505000"
                    },
                    {
                        "id": 10255,
                        "name": "Angico",
                        "latitude": "-6.34335000",
                        "longitude": "-47.93112000"
                    },
                    {
                        "id": 10289,
                        "name": "Aparecida do Rio Negro",
                        "latitude": "-10.06183000",
                        "longitude": "-47.96514000"
                    },
                    {
                        "id": 10317,
                        "name": "Aragominas",
                        "latitude": "-6.89259000",
                        "longitude": "-48.61589000"
                    },
                    {
                        "id": 10318,
                        "name": "Araguacema",
                        "latitude": "-8.91352000",
                        "longitude": "-49.40915000"
                    },
                    {
                        "id": 10326,
                        "name": "Araguaçu",
                        "latitude": "-12.72579000",
                        "longitude": "-49.74942000"
                    },
                    {
                        "id": 10327,
                        "name": "Araguaína",
                        "latitude": "-7.31139000",
                        "longitude": "-48.62113000"
                    },
                    {
                        "id": 10322,
                        "name": "Araguanã",
                        "latitude": "-6.76634000",
                        "longitude": "-48.52702000"
                    },
                    {
                        "id": 10325,
                        "name": "Araguatins",
                        "latitude": "-5.64071000",
                        "longitude": "-48.08859000"
                    },
                    {
                        "id": 10338,
                        "name": "Arapoema",
                        "latitude": "-7.71941000",
                        "longitude": "-49.03285000"
                    },
                    {
                        "id": 10409,
                        "name": "Arraias",
                        "latitude": "-12.84110000",
                        "longitude": "-46.90868000"
                    },
                    {
                        "id": 10442,
                        "name": "Augustinópolis",
                        "latitude": "-5.51080000",
                        "longitude": "-47.91538000"
                    },
                    {
                        "id": 10453,
                        "name": "Aurora do Tocantins",
                        "latitude": "-12.61624000",
                        "longitude": "-46.44441000"
                    },
                    {
                        "id": 10462,
                        "name": "Axixá do Tocantins",
                        "latitude": "-5.64850000",
                        "longitude": "-47.77278000"
                    },
                    {
                        "id": 10466,
                        "name": "Babaçulândia",
                        "latitude": "-7.20516000",
                        "longitude": "-47.76821000"
                    },
                    {
                        "id": 10502,
                        "name": "Bandeirantes do Tocantins",
                        "latitude": "-8.00418000",
                        "longitude": "-48.68223000"
                    },
                    {
                        "id": 10539,
                        "name": "Barra do Ouro",
                        "latitude": "-7.75845000",
                        "longitude": "-47.58781000"
                    },
                    {
                        "id": 10565,
                        "name": "Barrolândia",
                        "latitude": "-9.84999000",
                        "longitude": "-48.83437000"
                    },
                    {
                        "id": 10636,
                        "name": "Bernardo Sayão",
                        "latitude": "-7.97377000",
                        "longitude": "-48.98609000"
                    },
                    {
                        "id": 10715,
                        "name": "Bom Jesus do Tocantins",
                        "latitude": "-9.01838000",
                        "longitude": "-47.86969000"
                    },
                    {
                        "id": 10773,
                        "name": "Brasilândia do Tocantins",
                        "latitude": "-8.26045000",
                        "longitude": "-48.43450000"
                    },
                    {
                        "id": 10787,
                        "name": "Brejinho de Nazaré",
                        "latitude": "-11.01872000",
                        "longitude": "-48.64695000"
                    },
                    {
                        "id": 10827,
                        "name": "Buriti do Tocantins",
                        "latitude": "-5.37057000",
                        "longitude": "-48.13476000"
                    },
                    {
                        "id": 10878,
                        "name": "Cachoeirinha",
                        "latitude": "-6.09807000",
                        "longitude": "-47.87888000"
                    },
                    {
                        "id": 11012,
                        "name": "Campos Lindos",
                        "latitude": "-8.22553000",
                        "longitude": "-46.84507000"
                    },
                    {
                        "id": 11133,
                        "name": "Cariri do Tocantins",
                        "latitude": "-11.94500000",
                        "longitude": "-49.20796000"
                    },
                    {
                        "id": 11150,
                        "name": "Carmolândia",
                        "latitude": "-7.03001000",
                        "longitude": "-48.35627000"
                    },
                    {
                        "id": 11165,
                        "name": "Carrasco Bonito",
                        "latitude": "-5.31027000",
                        "longitude": "-48.03360000"
                    },
                    {
                        "id": 11178,
                        "name": "Caseara",
                        "latitude": "-9.45982000",
                        "longitude": "-49.83604000"
                    },
                    {
                        "id": 11235,
                        "name": "Centenário",
                        "latitude": "-9.15331000",
                        "longitude": "-47.44772000"
                    },
                    {
                        "id": 11261,
                        "name": "Chapada da Natividade",
                        "latitude": "-11.54159000",
                        "longitude": "-47.88094000"
                    },
                    {
                        "id": 11262,
                        "name": "Chapada de Areia",
                        "latitude": "-10.14838000",
                        "longitude": "-49.19998000"
                    },
                    {
                        "id": 11325,
                        "name": "Colinas do Tocantins",
                        "latitude": "-8.09451000",
                        "longitude": "-48.52143000"
                    },
                    {
                        "id": 11326,
                        "name": "Colméia",
                        "latitude": "-8.87655000",
                        "longitude": "-48.75788000"
                    },
                    {
                        "id": 11339,
                        "name": "Combinado",
                        "latitude": "-12.82321000",
                        "longitude": "-46.53424000"
                    },
                    {
                        "id": 11363,
                        "name": "Conceição do Tocantins",
                        "latitude": "-12.09878000",
                        "longitude": "-47.27047000"
                    },
                    {
                        "id": 11455,
                        "name": "Couto de Magalhães",
                        "latitude": "-8.50138000",
                        "longitude": "-49.17287000"
                    },
                    {
                        "id": 11472,
                        "name": "Cristalândia",
                        "latitude": "-10.62568000",
                        "longitude": "-49.36863000"
                    },
                    {
                        "id": 11484,
                        "name": "Crixás do Tocantins",
                        "latitude": "-11.16426000",
                        "longitude": "-49.07254000"
                    },
                    {
                        "id": 11562,
                        "name": "Darcinópolis",
                        "latitude": "-6.76072000",
                        "longitude": "-47.75687000"
                    },
                    {
                        "id": 11590,
                        "name": "Dianópolis",
                        "latitude": "-11.69578000",
                        "longitude": "-46.73544000"
                    },
                    {
                        "id": 11608,
                        "name": "Divinópolis do Tocantins",
                        "latitude": "-9.65731000",
                        "longitude": "-49.38737000"
                    },
                    {
                        "id": 11617,
                        "name": "Dois Irmãos do Tocantins",
                        "latitude": "-9.29074000",
                        "longitude": "-49.15573000"
                    },
                    {
                        "id": 11666,
                        "name": "Dueré",
                        "latitude": "-11.35537000",
                        "longitude": "-49.46137000"
                    },
                    {
                        "id": 11728,
                        "name": "Esperantina",
                        "latitude": "-5.30432000",
                        "longitude": "-48.54762000"
                    },
                    {
                        "id": 11906,
                        "name": "Fátima",
                        "latitude": "-10.81953000",
                        "longitude": "-48.86757000"
                    },
                    {
                        "id": 11818,
                        "name": "Figueirópolis",
                        "latitude": "-12.26857000",
                        "longitude": "-49.28976000"
                    },
                    {
                        "id": 11820,
                        "name": "Filadélfia",
                        "latitude": "-7.48804000",
                        "longitude": "-47.85623000"
                    },
                    {
                        "id": 11859,
                        "name": "Formoso do Araguaia",
                        "latitude": "-11.95898000",
                        "longitude": "-50.09809000"
                    },
                    {
                        "id": 11865,
                        "name": "Fortaleza do Tabocão",
                        "latitude": "-9.08805000",
                        "longitude": "-48.55638000"
                    },
                    {
                        "id": 11961,
                        "name": "Goianorte",
                        "latitude": "-8.83664000",
                        "longitude": "-48.99356000"
                    },
                    {
                        "id": 11966,
                        "name": "Goiatins",
                        "latitude": "-8.04432000",
                        "longitude": "-47.47183000"
                    },
                    {
                        "id": 12061,
                        "name": "Guaraí",
                        "latitude": "-8.70233000",
                        "longitude": "-48.40251000"
                    },
                    {
                        "id": 12088,
                        "name": "Gurupi",
                        "latitude": "-11.72917000",
                        "longitude": "-49.06861000"
                    },
                    {
                        "id": 12294,
                        "name": "Ipueiras",
                        "latitude": "-11.15847000",
                        "longitude": "-48.37886000"
                    },
                    {
                        "id": 12338,
                        "name": "Itacajá",
                        "latitude": "-8.55538000",
                        "longitude": "-47.62201000"
                    },
                    {
                        "id": 12354,
                        "name": "Itaguatins",
                        "latitude": "-5.81408000",
                        "longitude": "-47.65425000"
                    },
                    {
                        "id": 12425,
                        "name": "Itapiratins",
                        "latitude": "-8.35820000",
                        "longitude": "-47.99703000"
                    },
                    {
                        "id": 12434,
                        "name": "Itaporã do Tocantins",
                        "latitude": "-8.50178000",
                        "longitude": "-48.75214000"
                    },
                    {
                        "id": 12610,
                        "name": "Jaú do Tocantins",
                        "latitude": "-12.83943000",
                        "longitude": "-48.63203000"
                    },
                    {
                        "id": 12670,
                        "name": "Juarina",
                        "latitude": "-8.10180000",
                        "longitude": "-49.07995000"
                    },
                    {
                        "id": 12750,
                        "name": "Lagoa da Confusão",
                        "latitude": "-10.99307000",
                        "longitude": "-49.93702000"
                    },
                    {
                        "id": 12764,
                        "name": "Lagoa do Tocantins",
                        "latitude": "-10.33721000",
                        "longitude": "-47.48133000"
                    },
                    {
                        "id": 12776,
                        "name": "Lajeado",
                        "latitude": "-9.86927000",
                        "longitude": "-48.28058000"
                    },
                    {
                        "id": 12807,
                        "name": "Lavandeira",
                        "latitude": "-12.83658000",
                        "longitude": "-46.39307000"
                    },
                    {
                        "id": 12845,
                        "name": "Lizarda",
                        "latitude": "-9.52341000",
                        "longitude": "-46.97679000"
                    },
                    {
                        "id": 12876,
                        "name": "Luzinópolis",
                        "latitude": "-6.20636000",
                        "longitude": "-47.83045000"
                    },
                    {
                        "id": 13010,
                        "name": "Marianópolis do Tocantins",
                        "latitude": "-9.81443000",
                        "longitude": "-49.71607000"
                    },
                    {
                        "id": 13051,
                        "name": "Mateiros",
                        "latitude": "-10.41802000",
                        "longitude": "-46.48380000"
                    },
                    {
                        "id": 13081,
                        "name": "Maurilândia do Tocantins",
                        "latitude": "-5.98609000",
                        "longitude": "-47.57986000"
                    },
                    {
                        "id": 13133,
                        "name": "Miracema do Tocantins",
                        "latitude": "-9.76855000",
                        "longitude": "-48.58348000"
                    },
                    {
                        "id": 13144,
                        "name": "Miranorte",
                        "latitude": "-9.39114000",
                        "longitude": "-48.66598000"
                    },
                    {
                        "id": 13214,
                        "name": "Monte do Carmo",
                        "latitude": "-10.72034000",
                        "longitude": "-48.01807000"
                    },
                    {
                        "id": 13210,
                        "name": "Monte Santo do Tocantins",
                        "latitude": "-10.00972000",
                        "longitude": "-49.12747000"
                    },
                    {
                        "id": 13282,
                        "name": "Muricilândia",
                        "latitude": "-6.98598000",
                        "longitude": "-48.79167000"
                    },
                    {
                        "id": 13302,
                        "name": "Natividade",
                        "latitude": "-11.75889000",
                        "longitude": "-47.64485000"
                    },
                    {
                        "id": 13310,
                        "name": "Nazaré",
                        "latitude": "-6.31311000",
                        "longitude": "-47.78944000"
                    },
                    {
                        "id": 13409,
                        "name": "Nova Olinda",
                        "latitude": "-7.68973000",
                        "longitude": "-48.28152000"
                    },
                    {
                        "id": 13429,
                        "name": "Nova Rosalândia",
                        "latitude": "-10.56285000",
                        "longitude": "-48.97053000"
                    },
                    {
                        "id": 13450,
                        "name": "Novo Acordo",
                        "latitude": "-10.15197000",
                        "longitude": "-47.47165000"
                    },
                    {
                        "id": 13452,
                        "name": "Novo Alegre",
                        "latitude": "-12.87311000",
                        "longitude": "-46.56936000"
                    },
                    {
                        "id": 13467,
                        "name": "Novo Jardim",
                        "latitude": "-11.75148000",
                        "longitude": "-46.54138000"
                    },
                    {
                        "id": 13508,
                        "name": "Oliveira de Fátima",
                        "latitude": "-10.67053000",
                        "longitude": "-48.90783000"
                    },
                    {
                        "id": 13587,
                        "name": "Palmas",
                        "latitude": "-10.16745000",
                        "longitude": "-48.32766000"
                    },
                    {
                        "id": 13596,
                        "name": "Palmeirante",
                        "latitude": "-7.86937000",
                        "longitude": "-48.17585000"
                    },
                    {
                        "id": 13599,
                        "name": "Palmeiras do Tocantins",
                        "latitude": "-6.61304000",
                        "longitude": "-47.66259000"
                    },
                    {
                        "id": 13602,
                        "name": "Palmeirópolis",
                        "latitude": "-13.06026000",
                        "longitude": "-48.38866000"
                    },
                    {
                        "id": 13664,
                        "name": "Paraíso do Tocantins",
                        "latitude": "-10.23212000",
                        "longitude": "-48.88032000"
                    },
                    {
                        "id": 13649,
                        "name": "Paranã",
                        "latitude": "-12.73875000",
                        "longitude": "-47.94338000"
                    },
                    {
                        "id": 13716,
                        "name": "Pau d'Arco",
                        "latitude": "-7.55877000",
                        "longitude": "-48.93697000"
                    },
                    {
                        "id": 13772,
                        "name": "Pedro Afonso",
                        "latitude": "-9.20623000",
                        "longitude": "-47.97805000"
                    },
                    {
                        "id": 13787,
                        "name": "Peixe",
                        "latitude": "-11.99612000",
                        "longitude": "-48.53284000"
                    },
                    {
                        "id": 13801,
                        "name": "Pequizeiro",
                        "latitude": "-8.40977000",
                        "longitude": "-48.94148000"
                    },
                    {
                        "id": 13855,
                        "name": "Pindorama do Tocantins",
                        "latitude": "-11.13233000",
                        "longitude": "-47.56170000"
                    },
                    {
                        "id": 13905,
                        "name": "Piraquê",
                        "latitude": "-6.68862000",
                        "longitude": "-48.23711000"
                    },
                    {
                        "id": 13926,
                        "name": "Pium",
                        "latitude": "-10.07399000",
                        "longitude": "-49.69857000"
                    },
                    {
                        "id": 13966,
                        "name": "Ponte Alta do Bom Jesus",
                        "latitude": "-12.09696000",
                        "longitude": "-46.62629000"
                    },
                    {
                        "id": 13968,
                        "name": "Ponte Alta do Tocantins",
                        "latitude": "-10.78604000",
                        "longitude": "-47.18130000"
                    },
                    {
                        "id": 13997,
                        "name": "Porto Alegre do Tocantins",
                        "latitude": "-11.53239000",
                        "longitude": "-47.03453000"
                    },
                    {
                        "id": 14012,
                        "name": "Porto Nacional",
                        "latitude": "-10.52826000",
                        "longitude": "-48.47443000"
                    },
                    {
                        "id": 14065,
                        "name": "Praia Norte",
                        "latitude": "-5.46958000",
                        "longitude": "-47.79732000"
                    },
                    {
                        "id": 14088,
                        "name": "Presidente Kennedy",
                        "latitude": "-8.48264000",
                        "longitude": "-48.44075000"
                    },
                    {
                        "id": 14115,
                        "name": "Pugmil",
                        "latitude": "-10.42875000",
                        "longitude": "-48.85558000"
                    },
                    {
                        "id": 14181,
                        "name": "Recursolândia",
                        "latitude": "-8.66852000",
                        "longitude": "-47.07333000"
                    },
                    {
                        "id": 14208,
                        "name": "Riachinho",
                        "latitude": "-6.46034000",
                        "longitude": "-48.13618000"
                    },
                    {
                        "id": 14303,
                        "name": "Rio da Conceição",
                        "latitude": "-11.36815000",
                        "longitude": "-46.77445000"
                    },
                    {
                        "id": 14317,
                        "name": "Rio dos Bois",
                        "latitude": "-9.20901000",
                        "longitude": "-48.44308000"
                    },
                    {
                        "id": 14297,
                        "name": "Rio Sono",
                        "latitude": "-9.64479000",
                        "longitude": "-47.38387000"
                    },
                    {
                        "id": 14409,
                        "name": "Sampaio",
                        "latitude": "-5.36587000",
                        "longitude": "-47.91898000"
                    },
                    {
                        "id": 14412,
                        "name": "Sandolândia",
                        "latitude": "-12.40743000",
                        "longitude": "-49.85491000"
                    },
                    {
                        "id": 14467,
                        "name": "Santa Fé do Araguaia",
                        "latitude": "-7.10746000",
                        "longitude": "-48.95580000"
                    },
                    {
                        "id": 14517,
                        "name": "Santa Maria do Tocantins",
                        "latitude": "-8.81566000",
                        "longitude": "-47.85337000"
                    },
                    {
                        "id": 14538,
                        "name": "Santa Rita do Tocantins",
                        "latitude": "-10.97360000",
                        "longitude": "-49.37112000"
                    },
                    {
                        "id": 14549,
                        "name": "Santa Rosa do Tocantins",
                        "latitude": "-11.38278000",
                        "longitude": "-48.07295000"
                    },
                    {
                        "id": 14556,
                        "name": "Santa Tereza do Tocantins",
                        "latitude": "-10.29980000",
                        "longitude": "-47.72597000"
                    },
                    {
                        "id": 14564,
                        "name": "Santa Terezinha do Tocantins",
                        "latitude": "-6.48040000",
                        "longitude": "-47.70055000"
                    },
                    {
                        "id": 14841,
                        "name": "São Bento do Tocantins",
                        "latitude": "-5.95028000",
                        "longitude": "-47.99630000"
                    },
                    {
                        "id": 14905,
                        "name": "São Félix do Tocantins",
                        "latitude": "-10.06488000",
                        "longitude": "-46.72778000"
                    },
                    {
                        "id": 15096,
                        "name": "São Miguel do Tocantins",
                        "latitude": "-5.53458000",
                        "longitude": "-47.60820000"
                    },
                    {
                        "id": 15134,
                        "name": "São Salvador do Tocantins",
                        "latitude": "-12.54945000",
                        "longitude": "-48.40184000"
                    },
                    {
                        "id": 15152,
                        "name": "São Sebastião do Tocantins",
                        "latitude": "-5.25181000",
                        "longitude": "-48.34602000"
                    },
                    {
                        "id": 15165,
                        "name": "São Valério da Natividade",
                        "latitude": "-11.86029000",
                        "longitude": "-48.13995000"
                    },
                    {
                        "id": 14776,
                        "name": "Silvanópolis",
                        "latitude": "-11.11343000",
                        "longitude": "-48.22341000"
                    },
                    {
                        "id": 15178,
                        "name": "Sítio Novo do Tocantins",
                        "latitude": "-5.62990000",
                        "longitude": "-47.68644000"
                    },
                    {
                        "id": 14817,
                        "name": "Sucupira",
                        "latitude": "-12.01900000",
                        "longitude": "-48.84477000"
                    },
                    {
                        "id": 15198,
                        "name": "Taguatinga",
                        "latitude": "-12.38568000",
                        "longitude": "-46.57110000"
                    },
                    {
                        "id": 15203,
                        "name": "Taipas do Tocantins",
                        "latitude": "-12.15677000",
                        "longitude": "-47.03342000"
                    },
                    {
                        "id": 15207,
                        "name": "Talismã",
                        "latitude": "-12.67795000",
                        "longitude": "-49.07863000"
                    },
                    {
                        "id": 15327,
                        "name": "Tocantínia",
                        "latitude": "-9.56440000",
                        "longitude": "-48.18709000"
                    },
                    {
                        "id": 15326,
                        "name": "Tocantinópolis",
                        "latitude": "-6.26254000",
                        "longitude": "-47.55767000"
                    },
                    {
                        "id": 15406,
                        "name": "Tupirama",
                        "latitude": "-8.91920000",
                        "longitude": "-48.27661000"
                    },
                    {
                        "id": 15407,
                        "name": "Tupiratins",
                        "latitude": "-8.38578000",
                        "longitude": "-48.22299000"
                    },
                    {
                        "id": 15627,
                        "name": "Wanderlândia",
                        "latitude": "-6.79803000",
                        "longitude": "-48.00415000"
                    },
                    {
                        "id": 15633,
                        "name": "Xambioá",
                        "latitude": "-6.59413000",
                        "longitude": "-48.43142000"
                    }
                ]
            }
        ]
    },
    {
        "id": 32,
        "name": "British Indian Ocean Territory",
        "iso3": "IOT",
        "iso2": "IO",
        "numeric_code": "086",
        "phonecode": "246",
        "capital": "Diego Garcia",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".io",
        "native": "British Indian Ocean Territory",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "BIOT",
        "timezones": [
            {
                "zoneName": "Indian\/Chagos",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "IOT",
                "tzName": "Indian Ocean Time"
            }
        ],
        "translations": {
            "br": "Tiriad Meurvor Indez Breizh-Veur",
            "ko": "영국령 인도양 지역",
            "pt-BR": "Território Britânico do Oceano íÍdico",
            "pt": "Território Britânico do Oceano Índico",
            "nl": "Britse Gebieden in de Indische Oceaan",
            "hr": "Britanski Indijskooceanski teritorij",
            "fa": "قلمرو بریتانیا در اقیانوس هند",
            "de": "Britisches Territorium im Indischen Ozean",
            "es": "Territorio Británico del Océano Índico",
            "fr": "Territoire britannique de l'océan Indien",
            "ja": "イギリス領インド洋地域",
            "it": "Territorio britannico dell'oceano indiano",
            "zh-CN": "英属印度洋领地",
            "tr": "Britanya Hint Okyanusu Topraklari",
            "ru": "Британская территория в Индийском океане",
            "uk": "Британська територія в Індійському океані",
            "pl": "Brytyjskie Terytorium Oceanu Indyjskiego"
        },
        "latitude": "-6.00000000",
        "longitude": "71.50000000",
        "emoji": "🇮🇴",
        "emojiU": "U+1F1EE U+1F1F4",
        "states": []
    },
    {
        "id": 33,
        "name": "Brunei",
        "iso3": "BRN",
        "iso2": "BN",
        "numeric_code": "096",
        "phonecode": "673",
        "capital": "Bandar Seri Begawan",
        "currency": "BND",
        "currency_name": "Brunei dollar",
        "currency_symbol": "B$",
        "tld": ".bn",
        "native": "Negara Brunei Darussalam",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Bruneian",
        "timezones": [
            {
                "zoneName": "Asia\/Brunei",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "BNT",
                "tzName": "Brunei Darussalam Time"
            }
        ],
        "translations": {
            "br": "Brunei",
            "ko": "브루나이",
            "pt-BR": "Brunei",
            "pt": "Brunei",
            "nl": "Brunei",
            "hr": "Brunej",
            "fa": "برونئی",
            "de": "Brunei",
            "es": "Brunei",
            "fr": "Brunei",
            "ja": "ブルネイ・ダルサラーム",
            "it": "Brunei",
            "zh-CN": "文莱",
            "tr": "Brunei",
            "ru": "Бруней",
            "uk": "Бруней",
            "pl": "Brunei"
        },
        "latitude": "4.50000000",
        "longitude": "114.66666666",
        "emoji": "🇧🇳",
        "emojiU": "U+1F1E7 U+1F1F3",
        "states": [
            {
                "id": 1217,
                "name": "Belait",
                "iso2": "BE",
                "latitude": "4.37507490",
                "longitude": "114.61928990",
                "type": "district",
                "cities": [
                    {
                        "id": 9820,
                        "name": "Kuala Belait",
                        "latitude": "4.58361000",
                        "longitude": "114.23120000"
                    },
                    {
                        "id": 9823,
                        "name": "Seria",
                        "latitude": "4.60637000",
                        "longitude": "114.32476000"
                    }
                ]
            },
            {
                "id": 1216,
                "name": "Brunei-Muara",
                "iso2": "BM",
                "latitude": "4.93112060",
                "longitude": "114.95168690",
                "type": "district",
                "cities": [
                    {
                        "id": 9816,
                        "name": "Bandar Seri Begawan",
                        "latitude": "4.89035000",
                        "longitude": "114.94006000"
                    },
                    {
                        "id": 9818,
                        "name": "Berakas A",
                        "latitude": "4.97032000",
                        "longitude": "114.92989000"
                    },
                    {
                        "id": 9819,
                        "name": "Kapok",
                        "latitude": "5.02447000",
                        "longitude": "115.04664000"
                    },
                    {
                        "id": 9821,
                        "name": "Mentiri",
                        "latitude": "4.97058000",
                        "longitude": "115.02078000"
                    },
                    {
                        "id": 9822,
                        "name": "Serasa",
                        "latitude": "5.01718000",
                        "longitude": "115.05841000"
                    }
                ]
            },
            {
                "id": 1218,
                "name": "Temburong",
                "iso2": "TE",
                "latitude": "4.62041280",
                "longitude": "115.14148400",
                "type": "district",
                "cities": [
                    {
                        "id": 9817,
                        "name": "Bangar",
                        "latitude": "4.70861000",
                        "longitude": "115.07167000"
                    }
                ]
            },
            {
                "id": 1219,
                "name": "Tutong",
                "iso2": "TU",
                "latitude": "4.71403730",
                "longitude": "114.66679390",
                "type": "district",
                "cities": [
                    {
                        "id": 9824,
                        "name": "Tutong",
                        "latitude": "4.80278000",
                        "longitude": "114.64917000"
                    }
                ]
            }
        ]
    },
    {
        "id": 34,
        "name": "Bulgaria",
        "iso3": "BGR",
        "iso2": "BG",
        "numeric_code": "100",
        "phonecode": "359",
        "capital": "Sofia",
        "currency": "BGN",
        "currency_name": "Bulgarian lev",
        "currency_symbol": "Лв.",
        "tld": ".bg",
        "native": "България",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Bulgarian",
        "timezones": [
            {
                "zoneName": "Europe\/Sofia",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Bulgaria",
            "ko": "불가리아",
            "pt-BR": "Bulgária",
            "pt": "Bulgária",
            "nl": "Bulgarije",
            "hr": "Bugarska",
            "fa": "بلغارستان",
            "de": "Bulgarien",
            "es": "Bulgaria",
            "fr": "Bulgarie",
            "ja": "ブルガリア",
            "it": "Bulgaria",
            "zh-CN": "保加利亚",
            "tr": "Bulgaristan",
            "ru": "Болгария",
            "uk": "Болгарія",
            "pl": "Bułgaria"
        },
        "latitude": "43.00000000",
        "longitude": "25.00000000",
        "emoji": "🇧🇬",
        "emojiU": "U+1F1E7 U+1F1EC",
        "states": [
            {
                "id": 4699,
                "name": "Blagoevgrad",
                "iso2": "01",
                "latitude": "42.02086140",
                "longitude": "23.09433560",
                "type": "district",
                "cities": [
                    {
                        "id": 9265,
                        "name": "Bansko",
                        "latitude": "41.83830000",
                        "longitude": "23.48851000"
                    },
                    {
                        "id": 9270,
                        "name": "Belitsa",
                        "latitude": "41.95694000",
                        "longitude": "23.57250000"
                    },
                    {
                        "id": 9275,
                        "name": "Blagoevgrad",
                        "latitude": "42.01667000",
                        "longitude": "23.10000000"
                    },
                    {
                        "id": 9329,
                        "name": "Garmen",
                        "latitude": "41.60000000",
                        "longitude": "23.81667000"
                    },
                    {
                        "id": 9335,
                        "name": "Gotse Delchev",
                        "latitude": "41.56667000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 9341,
                        "name": "Hadzhidimovo",
                        "latitude": "41.52222000",
                        "longitude": "23.86861000"
                    },
                    {
                        "id": 9368,
                        "name": "Kolarovo",
                        "latitude": "41.36385000",
                        "longitude": "23.10669000"
                    },
                    {
                        "id": 9374,
                        "name": "Kresna",
                        "latitude": "41.73333000",
                        "longitude": "23.15000000"
                    },
                    {
                        "id": 9422,
                        "name": "Obshtina Bansko",
                        "latitude": "41.80000000",
                        "longitude": "23.60000000"
                    },
                    {
                        "id": 9425,
                        "name": "Obshtina Belitsa",
                        "latitude": "42.01667000",
                        "longitude": "23.58333000"
                    },
                    {
                        "id": 9429,
                        "name": "Obshtina Blagoevgrad",
                        "latitude": "42.01667000",
                        "longitude": "23.16667000"
                    },
                    {
                        "id": 9476,
                        "name": "Obshtina Garmen",
                        "latitude": "41.70000000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 9482,
                        "name": "Obshtina Gotse Delchev",
                        "latitude": "41.63333000",
                        "longitude": "23.68333000"
                    },
                    {
                        "id": 9511,
                        "name": "Obshtina Kresna",
                        "latitude": "41.76667000",
                        "longitude": "23.23333000"
                    },
                    {
                        "id": 9555,
                        "name": "Obshtina Petrich",
                        "latitude": "41.45000000",
                        "longitude": "23.16667000"
                    },
                    {
                        "id": 9571,
                        "name": "Obshtina Razlog",
                        "latitude": "41.95000000",
                        "longitude": "23.46667000"
                    },
                    {
                        "id": 9582,
                        "name": "Obshtina Sandanski",
                        "latitude": "41.56667000",
                        "longitude": "23.45000000"
                    },
                    {
                        "id": 9584,
                        "name": "Obshtina Satovcha",
                        "latitude": "41.59848000",
                        "longitude": "24.00781000"
                    },
                    {
                        "id": 9589,
                        "name": "Obshtina Simitli",
                        "latitude": "41.88333000",
                        "longitude": "23.16667000"
                    },
                    {
                        "id": 9603,
                        "name": "Obshtina Strumyani",
                        "latitude": "41.63333000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 9633,
                        "name": "Obshtina Yakoruda",
                        "latitude": "42.08333000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 9653,
                        "name": "Petrich",
                        "latitude": "41.39846000",
                        "longitude": "23.20702000"
                    },
                    {
                        "id": 9670,
                        "name": "Razlog",
                        "latitude": "41.88630000",
                        "longitude": "23.46714000"
                    },
                    {
                        "id": 9681,
                        "name": "Sandanski",
                        "latitude": "41.56667000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 9686,
                        "name": "Satovcha",
                        "latitude": "41.61667000",
                        "longitude": "23.98333000"
                    },
                    {
                        "id": 9694,
                        "name": "Simitli",
                        "latitude": "41.88333000",
                        "longitude": "23.11667000"
                    },
                    {
                        "id": 9705,
                        "name": "Stara Kresna",
                        "latitude": "41.80000000",
                        "longitude": "23.18333000"
                    },
                    {
                        "id": 9711,
                        "name": "Strumyani",
                        "latitude": "41.63333000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 9745,
                        "name": "Yakoruda",
                        "latitude": "42.02528000",
                        "longitude": "23.68417000"
                    }
                ]
            },
            {
                "id": 4715,
                "name": "Burgas",
                "iso2": "02",
                "latitude": "42.50480000",
                "longitude": "27.46260790",
                "type": "district",
                "cities": [
                    {
                        "id": 9250,
                        "name": "Aheloy",
                        "latitude": "42.64987000",
                        "longitude": "27.64838000"
                    },
                    {
                        "id": 9251,
                        "name": "Ahtopol",
                        "latitude": "42.09768000",
                        "longitude": "27.93961000"
                    },
                    {
                        "id": 9261,
                        "name": "Aytos",
                        "latitude": "42.70000000",
                        "longitude": "27.25000000"
                    },
                    {
                        "id": 9266,
                        "name": "Bata",
                        "latitude": "42.73802000",
                        "longitude": "27.49643000"
                    },
                    {
                        "id": 9292,
                        "name": "Burgas",
                        "latitude": "42.50606000",
                        "longitude": "27.46781000"
                    },
                    {
                        "id": 9299,
                        "name": "Chernomorets",
                        "latitude": "42.44408000",
                        "longitude": "27.63902000"
                    },
                    {
                        "id": 9353,
                        "name": "Kameno",
                        "latitude": "42.57084000",
                        "longitude": "27.29875000"
                    },
                    {
                        "id": 9356,
                        "name": "Karnobat",
                        "latitude": "42.65000000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 9363,
                        "name": "Kiten",
                        "latitude": "42.23424000",
                        "longitude": "27.77490000"
                    },
                    {
                        "id": 9397,
                        "name": "Malko Tarnovo",
                        "latitude": "41.97958000",
                        "longitude": "27.52477000"
                    },
                    {
                        "id": 9406,
                        "name": "Nesebar",
                        "latitude": "42.65921000",
                        "longitude": "27.73602000"
                    },
                    {
                        "id": 9419,
                        "name": "Obshtina Aytos",
                        "latitude": "42.70000000",
                        "longitude": "27.25000000"
                    },
                    {
                        "id": 9442,
                        "name": "Obshtina Burgas",
                        "latitude": "42.50000000",
                        "longitude": "27.46667000"
                    },
                    {
                        "id": 9495,
                        "name": "Obshtina Kameno",
                        "latitude": "42.51667000",
                        "longitude": "27.18333000"
                    },
                    {
                        "id": 9498,
                        "name": "Obshtina Karnobat",
                        "latitude": "42.65000000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 9529,
                        "name": "Obshtina Malko Tarnovo",
                        "latitude": "42.08333000",
                        "longitude": "27.53333000"
                    },
                    {
                        "id": 9538,
                        "name": "Obshtina Nesebar",
                        "latitude": "42.78333000",
                        "longitude": "27.73333000"
                    },
                    {
                        "id": 9560,
                        "name": "Obshtina Pomorie",
                        "latitude": "42.73333000",
                        "longitude": "27.55000000"
                    },
                    {
                        "id": 9564,
                        "name": "Obshtina Primorsko",
                        "latitude": "42.25000000",
                        "longitude": "27.63333000"
                    },
                    {
                        "id": 9596,
                        "name": "Obshtina Sozopol",
                        "latitude": "42.31123000",
                        "longitude": "27.51733000"
                    },
                    {
                        "id": 9605,
                        "name": "Obshtina Sungurlare",
                        "latitude": "42.83333000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 9640,
                        "name": "Obzor",
                        "latitude": "42.81998000",
                        "longitude": "27.88007000"
                    },
                    {
                        "id": 9658,
                        "name": "Pomorie",
                        "latitude": "42.56326000",
                        "longitude": "27.62986000"
                    },
                    {
                        "id": 9662,
                        "name": "Primorsko",
                        "latitude": "42.26791000",
                        "longitude": "27.75611000"
                    },
                    {
                        "id": 9668,
                        "name": "Ravda",
                        "latitude": "42.64185000",
                        "longitude": "27.67713000"
                    },
                    {
                        "id": 9674,
                        "name": "Ruen",
                        "latitude": "42.80000000",
                        "longitude": "27.28333000"
                    },
                    {
                        "id": 9683,
                        "name": "Sarafovo",
                        "latitude": "42.56079000",
                        "longitude": "27.52195000"
                    },
                    {
                        "id": 9702,
                        "name": "Sozopol",
                        "latitude": "42.41801000",
                        "longitude": "27.69560000"
                    },
                    {
                        "id": 9703,
                        "name": "Sredets",
                        "latitude": "42.34747000",
                        "longitude": "27.17898000"
                    },
                    {
                        "id": 9713,
                        "name": "Sungurlare",
                        "latitude": "42.76667000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 9715,
                        "name": "Sveti Vlas",
                        "latitude": "42.71360000",
                        "longitude": "27.75867000"
                    },
                    {
                        "id": 9728,
                        "name": "Tsarevo",
                        "latitude": "42.16955000",
                        "longitude": "27.84541000"
                    }
                ]
            },
            {
                "id": 4718,
                "name": "Dobrich",
                "iso2": "08",
                "latitude": "43.57278600",
                "longitude": "27.82728020",
                "type": "district",
                "cities": [
                    {
                        "id": 9262,
                        "name": "Balchik",
                        "latitude": "43.42166000",
                        "longitude": "28.15848000"
                    },
                    {
                        "id": 9310,
                        "name": "Dobrich",
                        "latitude": "43.56667000",
                        "longitude": "27.83333000"
                    },
                    {
                        "id": 9330,
                        "name": "General Toshevo",
                        "latitude": "43.70123000",
                        "longitude": "28.03787000"
                    },
                    {
                        "id": 9357,
                        "name": "Kavarna",
                        "latitude": "43.43601000",
                        "longitude": "28.33953000"
                    },
                    {
                        "id": 9378,
                        "name": "Krushari",
                        "latitude": "43.81675000",
                        "longitude": "27.75552000"
                    },
                    {
                        "id": 9420,
                        "name": "Obshtina Balchik",
                        "latitude": "43.50000000",
                        "longitude": "28.13333000"
                    },
                    {
                        "id": 9457,
                        "name": "Obshtina Dobrich",
                        "latitude": "43.57763000",
                        "longitude": "27.80628000"
                    },
                    {
                        "id": 9458,
                        "name": "Obshtina Dobrich-Selska",
                        "latitude": "43.63333000",
                        "longitude": "27.73333000"
                    },
                    {
                        "id": 9477,
                        "name": "Obshtina General Toshevo",
                        "latitude": "43.73333000",
                        "longitude": "28.08333000"
                    },
                    {
                        "id": 9499,
                        "name": "Obshtina Kavarna",
                        "latitude": "43.50000000",
                        "longitude": "28.38333000"
                    },
                    {
                        "id": 9514,
                        "name": "Obshtina Krushari",
                        "latitude": "43.88333000",
                        "longitude": "27.75000000"
                    },
                    {
                        "id": 9587,
                        "name": "Obshtina Shabla",
                        "latitude": "43.61667000",
                        "longitude": "28.51667000"
                    },
                    {
                        "id": 9611,
                        "name": "Obshtina Tervel",
                        "latitude": "43.75000000",
                        "longitude": "27.40000000"
                    },
                    {
                        "id": 9690,
                        "name": "Shabla",
                        "latitude": "43.53983000",
                        "longitude": "28.53429000"
                    },
                    {
                        "id": 9720,
                        "name": "Tervel",
                        "latitude": "43.74789000",
                        "longitude": "27.40911000"
                    }
                ]
            },
            {
                "id": 4693,
                "name": "Gabrovo",
                "iso2": "07",
                "latitude": "42.86847000",
                "longitude": "25.31688900",
                "type": "district",
                "cities": [
                    {
                        "id": 9318,
                        "name": "Dryanovo",
                        "latitude": "42.97897000",
                        "longitude": "25.47850000"
                    },
                    {
                        "id": 9328,
                        "name": "Gabrovo",
                        "latitude": "42.87472000",
                        "longitude": "25.33417000"
                    },
                    {
                        "id": 9465,
                        "name": "Obshtina Dryanovo",
                        "latitude": "43.00000000",
                        "longitude": "25.46667000"
                    },
                    {
                        "id": 9474,
                        "name": "Obshtina Gabrovo",
                        "latitude": "42.90000000",
                        "longitude": "25.30000000"
                    },
                    {
                        "id": 9586,
                        "name": "Obshtina Sevlievo",
                        "latitude": "43.01667000",
                        "longitude": "25.10000000"
                    },
                    {
                        "id": 9615,
                        "name": "Obshtina Tryavna",
                        "latitude": "42.85000000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 9689,
                        "name": "Sevlievo",
                        "latitude": "43.02583000",
                        "longitude": "25.11361000"
                    },
                    {
                        "id": 9726,
                        "name": "Tryavna",
                        "latitude": "42.86667000",
                        "longitude": "25.50000000"
                    }
                ]
            },
            {
                "id": 4704,
                "name": "Haskovo",
                "iso2": "26",
                "latitude": "41.93441780",
                "longitude": "25.55546720",
                "type": "district",
                "cities": [
                    {
                        "id": 9308,
                        "name": "Dimitrovgrad",
                        "latitude": "42.05000000",
                        "longitude": "25.60000000"
                    },
                    {
                        "id": 9342,
                        "name": "Harmanli",
                        "latitude": "41.93333000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 9343,
                        "name": "Haskovo",
                        "latitude": "41.93415000",
                        "longitude": "25.55557000"
                    },
                    {
                        "id": 9350,
                        "name": "Ivaylovgrad",
                        "latitude": "41.52672000",
                        "longitude": "26.12490000"
                    },
                    {
                        "id": 9392,
                        "name": "Lyubimets",
                        "latitude": "41.83333000",
                        "longitude": "26.08333000"
                    },
                    {
                        "id": 9394,
                        "name": "Madzharovo",
                        "latitude": "41.63461000",
                        "longitude": "25.86439000"
                    },
                    {
                        "id": 9401,
                        "name": "Mineralni Bani",
                        "latitude": "41.91667000",
                        "longitude": "25.35000000"
                    },
                    {
                        "id": 9455,
                        "name": "Obshtina Dimitrovgrad",
                        "latitude": "42.05000000",
                        "longitude": "25.60000000"
                    },
                    {
                        "id": 9486,
                        "name": "Obshtina Harmanli",
                        "latitude": "41.93333000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 9487,
                        "name": "Obshtina Haskovo",
                        "latitude": "41.88333000",
                        "longitude": "25.61667000"
                    },
                    {
                        "id": 9493,
                        "name": "Obshtina Ivaylovgrad",
                        "latitude": "41.48333000",
                        "longitude": "26.00000000"
                    },
                    {
                        "id": 9527,
                        "name": "Obshtina Madzharovo",
                        "latitude": "41.68333000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 9532,
                        "name": "Obshtina Mineralni Bani",
                        "latitude": "41.90000000",
                        "longitude": "25.33333000"
                    },
                    {
                        "id": 9598,
                        "name": "Obshtina Stambolovo",
                        "latitude": "41.73333000",
                        "longitude": "25.70000000"
                    },
                    {
                        "id": 9607,
                        "name": "Obshtina Svilengrad",
                        "latitude": "41.86667000",
                        "longitude": "26.31667000"
                    },
                    {
                        "id": 9613,
                        "name": "Obshtina Topolovgrad",
                        "latitude": "42.08333000",
                        "longitude": "26.33333000"
                    },
                    {
                        "id": 9693,
                        "name": "Simeonovgrad",
                        "latitude": "42.03333000",
                        "longitude": "25.83333000"
                    },
                    {
                        "id": 9716,
                        "name": "Svilengrad",
                        "latitude": "41.76667000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 9722,
                        "name": "Topolovgrad",
                        "latitude": "42.08333000",
                        "longitude": "26.33333000"
                    }
                ]
            },
            {
                "id": 4702,
                "name": "Kardzhali",
                "iso2": "09",
                "latitude": "41.63384160",
                "longitude": "25.37766870",
                "type": "district",
                "cities": [
                    {
                        "id": 9257,
                        "name": "Ardino",
                        "latitude": "41.58333000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 9323,
                        "name": "Dzhebel",
                        "latitude": "41.49566000",
                        "longitude": "25.30363000"
                    },
                    {
                        "id": 9354,
                        "name": "Kardzhali",
                        "latitude": "41.65000000",
                        "longitude": "25.36667000"
                    },
                    {
                        "id": 9362,
                        "name": "Kirkovo",
                        "latitude": "41.32715000",
                        "longitude": "25.36379000"
                    },
                    {
                        "id": 9377,
                        "name": "Krumovgrad",
                        "latitude": "41.47127000",
                        "longitude": "25.65485000"
                    },
                    {
                        "id": 9416,
                        "name": "Obshtina Ardino",
                        "latitude": "41.60000000",
                        "longitude": "25.15000000"
                    },
                    {
                        "id": 9448,
                        "name": "Obshtina Chernoochene",
                        "latitude": "41.78333000",
                        "longitude": "25.25000000"
                    },
                    {
                        "id": 9469,
                        "name": "Obshtina Dzhebel",
                        "latitude": "41.50000000",
                        "longitude": "25.26667000"
                    },
                    {
                        "id": 9496,
                        "name": "Obshtina Kardzhali",
                        "latitude": "41.68333000",
                        "longitude": "25.43333000"
                    },
                    {
                        "id": 9502,
                        "name": "Obshtina Kirkovo",
                        "latitude": "41.35816000",
                        "longitude": "25.33731000"
                    },
                    {
                        "id": 9535,
                        "name": "Obshtina Momchilgrad",
                        "latitude": "41.53333000",
                        "longitude": "25.50000000"
                    }
                ]
            },
            {
                "id": 4703,
                "name": "Kyustendil",
                "iso2": "10",
                "latitude": "42.28687990",
                "longitude": "22.69396350",
                "type": "district",
                "cities": [
                    {
                        "id": 9276,
                        "name": "Boboshevo",
                        "latitude": "42.15296000",
                        "longitude": "23.00146000"
                    },
                    {
                        "id": 9277,
                        "name": "Bobov Dol",
                        "latitude": "42.36256000",
                        "longitude": "23.00324000"
                    },
                    {
                        "id": 9321,
                        "name": "Dupnitsa",
                        "latitude": "42.26667000",
                        "longitude": "23.11667000"
                    },
                    {
                        "id": 9367,
                        "name": "Kocherinovo",
                        "latitude": "42.08439000",
                        "longitude": "23.05710000"
                    },
                    {
                        "id": 9381,
                        "name": "Kyustendil",
                        "latitude": "42.28389000",
                        "longitude": "22.69111000"
                    },
                    {
                        "id": 9407,
                        "name": "Nevestino",
                        "latitude": "42.25551000",
                        "longitude": "22.85175000"
                    },
                    {
                        "id": 9430,
                        "name": "Obshtina Boboshevo",
                        "latitude": "42.18333000",
                        "longitude": "23.02731000"
                    },
                    {
                        "id": 9431,
                        "name": "Obshtina Bobov Dol",
                        "latitude": "42.31667000",
                        "longitude": "22.98333000"
                    },
                    {
                        "id": 9467,
                        "name": "Obshtina Dupnitsa",
                        "latitude": "42.28333000",
                        "longitude": "23.15000000"
                    },
                    {
                        "id": 9504,
                        "name": "Obshtina Kocherinovo",
                        "latitude": "42.09909000",
                        "longitude": "23.02942000"
                    },
                    {
                        "id": 9518,
                        "name": "Obshtina Kyustendil",
                        "latitude": "42.28333000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 9539,
                        "name": "Obshtina Nevestino",
                        "latitude": "42.16667000",
                        "longitude": "22.83333000"
                    },
                    {
                        "id": 9572,
                        "name": "Obshtina Rila",
                        "latitude": "42.15000000",
                        "longitude": "23.31667000"
                    },
                    {
                        "id": 9583,
                        "name": "Obshtina Sapareva Banya",
                        "latitude": "42.28333000",
                        "longitude": "23.31667000"
                    },
                    {
                        "id": 9614,
                        "name": "Obshtina Treklyano",
                        "latitude": "42.55000000",
                        "longitude": "22.60000000"
                    },
                    {
                        "id": 9671,
                        "name": "Rila",
                        "latitude": "42.13333000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 9682,
                        "name": "Sapareva Banya",
                        "latitude": "42.28333000",
                        "longitude": "23.26667000"
                    }
                ]
            },
            {
                "id": 4710,
                "name": "Lovech",
                "iso2": "11",
                "latitude": "43.13677980",
                "longitude": "24.71393350",
                "type": "district",
                "cities": [
                    {
                        "id": 9256,
                        "name": "Apriltsi",
                        "latitude": "42.84142000",
                        "longitude": "24.91759000"
                    },
                    {
                        "id": 9385,
                        "name": "Letnitsa",
                        "latitude": "43.31167000",
                        "longitude": "25.07333000"
                    },
                    {
                        "id": 9388,
                        "name": "Lovech",
                        "latitude": "43.13333000",
                        "longitude": "24.71667000"
                    },
                    {
                        "id": 9390,
                        "name": "Lukovit",
                        "latitude": "43.20000000",
                        "longitude": "24.16667000"
                    },
                    {
                        "id": 9523,
                        "name": "Obshtina Lovech",
                        "latitude": "43.16667000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 9612,
                        "name": "Obshtina Teteven",
                        "latitude": "42.91667000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 9621,
                        "name": "Obshtina Ugarchin",
                        "latitude": "43.10000000",
                        "longitude": "24.41667000"
                    },
                    {
                        "id": 9721,
                        "name": "Teteven",
                        "latitude": "42.91667000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 9725,
                        "name": "Troyan",
                        "latitude": "42.89427000",
                        "longitude": "24.71589000"
                    },
                    {
                        "id": 9732,
                        "name": "Ugarchin",
                        "latitude": "43.10000000",
                        "longitude": "24.41667000"
                    },
                    {
                        "id": 9743,
                        "name": "Yablanitsa",
                        "latitude": "43.03139000",
                        "longitude": "24.11278000"
                    }
                ]
            },
            {
                "id": 4696,
                "name": "Montana",
                "iso2": "12",
                "latitude": "43.40851480",
                "longitude": "23.22575890",
                "type": "district",
                "cities": [
                    {
                        "id": 9274,
                        "name": "Berkovitsa",
                        "latitude": "43.23581000",
                        "longitude": "23.12738000"
                    },
                    {
                        "id": 9283,
                        "name": "Boychinovtsi",
                        "latitude": "43.47222000",
                        "longitude": "23.33583000"
                    },
                    {
                        "id": 9290,
                        "name": "Brusartsi",
                        "latitude": "43.66075000",
                        "longitude": "23.06732000"
                    },
                    {
                        "id": 9301,
                        "name": "Chiprovtsi",
                        "latitude": "43.38417000",
                        "longitude": "22.88083000"
                    },
                    {
                        "id": 9387,
                        "name": "Lom",
                        "latitude": "43.82106000",
                        "longitude": "23.23677000"
                    },
                    {
                        "id": 9398,
                        "name": "Medkovets",
                        "latitude": "43.62403000",
                        "longitude": "23.16876000"
                    },
                    {
                        "id": 9404,
                        "name": "Montana",
                        "latitude": "43.41250000",
                        "longitude": "23.22500000"
                    },
                    {
                        "id": 9437,
                        "name": "Obshtina Boychinovtsi",
                        "latitude": "43.53333000",
                        "longitude": "23.43333000"
                    },
                    {
                        "id": 9450,
                        "name": "Obshtina Chiprovtsi",
                        "latitude": "43.41667000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 9478,
                        "name": "Obshtina Georgi Damyanovo",
                        "latitude": "43.35000000",
                        "longitude": "23.00000000"
                    },
                    {
                        "id": 9522,
                        "name": "Obshtina Lom",
                        "latitude": "43.81667000",
                        "longitude": "23.23333000"
                    },
                    {
                        "id": 9536,
                        "name": "Obshtina Montana",
                        "latitude": "43.46667000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 9622,
                        "name": "Obshtina Valchedram",
                        "latitude": "43.71667000",
                        "longitude": "23.51667000"
                    },
                    {
                        "id": 9625,
                        "name": "Obshtina Varshets",
                        "latitude": "43.21667000",
                        "longitude": "23.33333000"
                    },
                    {
                        "id": 9632,
                        "name": "Obshtina Yakimovo",
                        "latitude": "43.63333000",
                        "longitude": "23.33333000"
                    },
                    {
                        "id": 9733,
                        "name": "Valchedram",
                        "latitude": "43.69281000",
                        "longitude": "23.44518000"
                    },
                    {
                        "id": 9736,
                        "name": "Varshets",
                        "latitude": "43.19356000",
                        "longitude": "23.28680000"
                    },
                    {
                        "id": 9744,
                        "name": "Yakimovo",
                        "latitude": "43.63472000",
                        "longitude": "23.35350000"
                    }
                ]
            },
            {
                "id": 4712,
                "name": "Pazardzhik",
                "iso2": "13",
                "latitude": "42.19275670",
                "longitude": "24.33362260",
                "type": "district",
                "cities": [
                    {
                        "id": 9267,
                        "name": "Batak",
                        "latitude": "41.94225000",
                        "longitude": "24.21843000"
                    },
                    {
                        "id": 9273,
                        "name": "Belovo",
                        "latitude": "42.21239000",
                        "longitude": "24.02081000"
                    },
                    {
                        "id": 9286,
                        "name": "Bratsigovo",
                        "latitude": "42.01667000",
                        "longitude": "24.36667000"
                    },
                    {
                        "id": 9384,
                        "name": "Lesichovo",
                        "latitude": "42.35626000",
                        "longitude": "24.11190000"
                    },
                    {
                        "id": 9423,
                        "name": "Obshtina Batak",
                        "latitude": "41.86667000",
                        "longitude": "24.21667000"
                    },
                    {
                        "id": 9428,
                        "name": "Obshtina Belovo",
                        "latitude": "42.20000000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 9440,
                        "name": "Obshtina Bratsigovo",
                        "latitude": "42.00000000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 9520,
                        "name": "Obshtina Lesichovo",
                        "latitude": "42.36667000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 9547,
                        "name": "Obshtina Panagyurishte",
                        "latitude": "42.50000000",
                        "longitude": "24.16667000"
                    },
                    {
                        "id": 9551,
                        "name": "Obshtina Pazardzhik",
                        "latitude": "42.20000000",
                        "longitude": "24.33333000"
                    },
                    {
                        "id": 9554,
                        "name": "Obshtina Peshtera",
                        "latitude": "42.03333000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 9568,
                        "name": "Obshtina Rakitovo",
                        "latitude": "41.99965000",
                        "longitude": "24.10877000"
                    },
                    {
                        "id": 9585,
                        "name": "Obshtina Septemvri",
                        "latitude": "42.26667000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 9602,
                        "name": "Obshtina Strelcha",
                        "latitude": "42.46667000",
                        "longitude": "24.36667000"
                    },
                    {
                        "id": 9627,
                        "name": "Obshtina Velingrad",
                        "latitude": "41.96667000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 9644,
                        "name": "Panagyurishte",
                        "latitude": "42.49518000",
                        "longitude": "24.19021000"
                    },
                    {
                        "id": 9649,
                        "name": "Pazardzhik",
                        "latitude": "42.20000000",
                        "longitude": "24.33333000"
                    },
                    {
                        "id": 9652,
                        "name": "Peshtera",
                        "latitude": "42.03372000",
                        "longitude": "24.29995000"
                    },
                    {
                        "id": 9666,
                        "name": "Rakitovo",
                        "latitude": "41.99012000",
                        "longitude": "24.08730000"
                    },
                    {
                        "id": 9684,
                        "name": "Sarnitsa",
                        "latitude": "41.73835000",
                        "longitude": "24.02435000"
                    },
                    {
                        "id": 9685,
                        "name": "Sarnitsa Obshtina",
                        "latitude": "41.73333000",
                        "longitude": "24.03333000"
                    },
                    {
                        "id": 9688,
                        "name": "Septemvri",
                        "latitude": "42.21138000",
                        "longitude": "24.12946000"
                    },
                    {
                        "id": 9710,
                        "name": "Strelcha",
                        "latitude": "42.50000000",
                        "longitude": "24.31667000"
                    },
                    {
                        "id": 9738,
                        "name": "Velingrad",
                        "latitude": "42.02754000",
                        "longitude": "23.99155000"
                    }
                ]
            },
            {
                "id": 4695,
                "name": "Pernik",
                "iso2": "14",
                "latitude": "42.60519900",
                "longitude": "23.03779160",
                "type": "district",
                "cities": [
                    {
                        "id": 9268,
                        "name": "Batanovtsi",
                        "latitude": "42.59692000",
                        "longitude": "22.95634000"
                    },
                    {
                        "id": 9288,
                        "name": "Breznik",
                        "latitude": "42.74085000",
                        "longitude": "22.90723000"
                    },
                    {
                        "id": 9509,
                        "name": "Obshtina Kovachevtsi",
                        "latitude": "42.55000000",
                        "longitude": "22.83333000"
                    },
                    {
                        "id": 9552,
                        "name": "Obshtina Pernik",
                        "latitude": "42.61667000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 9567,
                        "name": "Obshtina Radomir",
                        "latitude": "42.46667000",
                        "longitude": "23.01667000"
                    },
                    {
                        "id": 9636,
                        "name": "Obshtina Zemen",
                        "latitude": "42.55067000",
                        "longitude": "22.71440000"
                    },
                    {
                        "id": 9650,
                        "name": "Pernik",
                        "latitude": "42.60000000",
                        "longitude": "23.03333000"
                    },
                    {
                        "id": 9665,
                        "name": "Radomir",
                        "latitude": "42.54565000",
                        "longitude": "22.96553000"
                    },
                    {
                        "id": 9724,
                        "name": "Tran",
                        "latitude": "42.83528000",
                        "longitude": "22.65167000"
                    },
                    {
                        "id": 9748,
                        "name": "Zemen",
                        "latitude": "42.47889000",
                        "longitude": "22.74917000"
                    }
                ]
            },
            {
                "id": 4706,
                "name": "Pleven",
                "iso2": "15",
                "latitude": "43.41701690",
                "longitude": "24.60667080",
                "type": "district",
                "cities": [
                    {
                        "id": 9269,
                        "name": "Belene",
                        "latitude": "43.64594000",
                        "longitude": "25.12627000"
                    },
                    {
                        "id": 9300,
                        "name": "Cherven Bryag",
                        "latitude": "43.26667000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 9312,
                        "name": "Dolna Mitropolia",
                        "latitude": "43.46667000",
                        "longitude": "24.53333000"
                    },
                    {
                        "id": 9314,
                        "name": "Dolni Dabnik",
                        "latitude": "43.40000000",
                        "longitude": "24.43333000"
                    },
                    {
                        "id": 9337,
                        "name": "Gulyantsi",
                        "latitude": "43.64109000",
                        "longitude": "24.69368000"
                    },
                    {
                        "id": 9347,
                        "name": "Iskar",
                        "latitude": "43.45000000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 9366,
                        "name": "Knezha",
                        "latitude": "43.50000000",
                        "longitude": "24.08333000"
                    },
                    {
                        "id": 9372,
                        "name": "Koynare",
                        "latitude": "43.35000000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 9386,
                        "name": "Levski",
                        "latitude": "43.36667000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 9409,
                        "name": "Nikopol",
                        "latitude": "43.70528000",
                        "longitude": "24.89521000"
                    },
                    {
                        "id": 9424,
                        "name": "Obshtina Belene",
                        "latitude": "43.63333000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 9449,
                        "name": "Obshtina Cherven Bryag",
                        "latitude": "43.33333000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 9460,
                        "name": "Obshtina Dolna Mitropolia",
                        "latitude": "43.58333000",
                        "longitude": "24.41667000"
                    },
                    {
                        "id": 9462,
                        "name": "Obshtina Dolni Dabnik",
                        "latitude": "43.36667000",
                        "longitude": "24.41667000"
                    },
                    {
                        "id": 9484,
                        "name": "Obshtina Gulyantsi",
                        "latitude": "43.68333000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 9490,
                        "name": "Obshtina Iskar",
                        "latitude": "43.50000000",
                        "longitude": "24.28333000"
                    },
                    {
                        "id": 9503,
                        "name": "Obshtina Knezha",
                        "latitude": "43.50000000",
                        "longitude": "24.11667000"
                    },
                    {
                        "id": 9521,
                        "name": "Obshtina Levski",
                        "latitude": "43.43333000",
                        "longitude": "25.10000000"
                    },
                    {
                        "id": 9541,
                        "name": "Obshtina Nikopol",
                        "latitude": "43.60000000",
                        "longitude": "24.93333000"
                    },
                    {
                        "id": 9557,
                        "name": "Obshtina Pleven",
                        "latitude": "43.40000000",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 9562,
                        "name": "Obshtina Pordim",
                        "latitude": "43.38333000",
                        "longitude": "24.90000000"
                    },
                    {
                        "id": 9655,
                        "name": "Pleven",
                        "latitude": "43.41667000",
                        "longitude": "24.61667000"
                    },
                    {
                        "id": 9660,
                        "name": "Pordim",
                        "latitude": "43.38333000",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 9696,
                        "name": "Slavyanovo",
                        "latitude": "43.46667000",
                        "longitude": "24.86667000"
                    }
                ]
            },
            {
                "id": 4701,
                "name": "Plovdiv",
                "iso2": "16",
                "latitude": "42.13540790",
                "longitude": "24.74529040",
                "type": "district",
                "cities": [
                    {
                        "id": 9259,
                        "name": "Asenovgrad",
                        "latitude": "42.01667000",
                        "longitude": "24.86667000"
                    },
                    {
                        "id": 9289,
                        "name": "Brezovo",
                        "latitude": "42.35000000",
                        "longitude": "25.08333000"
                    },
                    {
                        "id": 9345,
                        "name": "Hisarya",
                        "latitude": "42.50000000",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 9351,
                        "name": "Kalofer",
                        "latitude": "42.61667000",
                        "longitude": "24.98333000"
                    },
                    {
                        "id": 9352,
                        "name": "Kaloyanovo",
                        "latitude": "42.35000000",
                        "longitude": "24.73333000"
                    },
                    {
                        "id": 9355,
                        "name": "Karlovo",
                        "latitude": "42.63333000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 9365,
                        "name": "Klisura",
                        "latitude": "42.70000000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 9375,
                        "name": "Krichim",
                        "latitude": "42.05000000",
                        "longitude": "24.46667000"
                    },
                    {
                        "id": 9383,
                        "name": "Laki",
                        "latitude": "41.85000000",
                        "longitude": "24.81667000"
                    },
                    {
                        "id": 9417,
                        "name": "Obshtina Asenovgrad",
                        "latitude": "41.95000000",
                        "longitude": "24.96667000"
                    },
                    {
                        "id": 9489,
                        "name": "Obshtina Hisarya",
                        "latitude": "42.50000000",
                        "longitude": "24.60000000"
                    },
                    {
                        "id": 9494,
                        "name": "Obshtina Kaloyanovo",
                        "latitude": "42.38333000",
                        "longitude": "24.81667000"
                    },
                    {
                        "id": 9497,
                        "name": "Obshtina Karlovo",
                        "latitude": "42.68333000",
                        "longitude": "24.66667000"
                    },
                    {
                        "id": 9512,
                        "name": "Obshtina Krichim",
                        "latitude": "42.00439000",
                        "longitude": "24.47235000"
                    },
                    {
                        "id": 9516,
                        "name": "Obshtina Kuklen",
                        "latitude": "42.03725000",
                        "longitude": "24.77949000"
                    },
                    {
                        "id": 9519,
                        "name": "Obshtina Laki",
                        "latitude": "41.81667000",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 9530,
                        "name": "Obshtina Maritsa",
                        "latitude": "42.23333000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 9548,
                        "name": "Obshtina Parvomay",
                        "latitude": "42.03333000",
                        "longitude": "25.20000000"
                    },
                    {
                        "id": 9553,
                        "name": "Obshtina Perushtitsa",
                        "latitude": "42.06667000",
                        "longitude": "24.55000000"
                    },
                    {
                        "id": 9558,
                        "name": "Obshtina Plovdiv",
                        "latitude": "42.15000000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 9569,
                        "name": "Obshtina Rakovski",
                        "latitude": "42.26667000",
                        "longitude": "24.98333000"
                    },
                    {
                        "id": 9573,
                        "name": "Obshtina Rodopi",
                        "latitude": "42.03333000",
                        "longitude": "24.68333000"
                    },
                    {
                        "id": 9578,
                        "name": "Obshtina Sadovo",
                        "latitude": "42.13333000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 9579,
                        "name": "Obshtina Saedinenie",
                        "latitude": "42.31667000",
                        "longitude": "24.58333000"
                    },
                    {
                        "id": 9595,
                        "name": "Obshtina Sopot",
                        "latitude": "42.65214000",
                        "longitude": "24.74310000"
                    },
                    {
                        "id": 9597,
                        "name": "Obshtina Stamboliyski",
                        "latitude": "42.11667000",
                        "longitude": "24.51667000"
                    },
                    {
                        "id": 9645,
                        "name": "Parvomay",
                        "latitude": "42.10000000",
                        "longitude": "25.21667000"
                    },
                    {
                        "id": 9651,
                        "name": "Perushtitsa",
                        "latitude": "42.05000000",
                        "longitude": "24.55000000"
                    },
                    {
                        "id": 9656,
                        "name": "Plovdiv",
                        "latitude": "42.15000000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 9667,
                        "name": "Rakovski",
                        "latitude": "42.27408000",
                        "longitude": "24.94083000"
                    },
                    {
                        "id": 9677,
                        "name": "Sadovo",
                        "latitude": "42.13178000",
                        "longitude": "24.93999000"
                    },
                    {
                        "id": 9678,
                        "name": "Saedinenie",
                        "latitude": "42.26667000",
                        "longitude": "24.55000000"
                    },
                    {
                        "id": 9704,
                        "name": "Stamboliyski",
                        "latitude": "42.13333000",
                        "longitude": "24.53333000"
                    },
                    {
                        "id": 9723,
                        "name": "Topolovo",
                        "latitude": "41.90000000",
                        "longitude": "25.00000000"
                    }
                ]
            },
            {
                "id": 4698,
                "name": "Razgrad",
                "iso2": "17",
                "latitude": "43.52717050",
                "longitude": "26.52412280",
                "type": "district",
                "cities": [
                    {
                        "id": 9348,
                        "name": "Isperih",
                        "latitude": "43.71667000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 9379,
                        "name": "Kubrat",
                        "latitude": "43.79658000",
                        "longitude": "26.50063000"
                    },
                    {
                        "id": 9389,
                        "name": "Loznitsa",
                        "latitude": "43.36667000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 9399,
                        "name": "Medovene",
                        "latitude": "43.76667000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 9491,
                        "name": "Obshtina Isperih",
                        "latitude": "43.71667000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 9515,
                        "name": "Obshtina Kubrat",
                        "latitude": "43.86667000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 9524,
                        "name": "Obshtina Loznitsa",
                        "latitude": "43.41667000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 9570,
                        "name": "Obshtina Razgrad",
                        "latitude": "43.53333000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 9581,
                        "name": "Obshtina Samuil",
                        "latitude": "43.60000000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 9616,
                        "name": "Obshtina Tsar Kaloyan",
                        "latitude": "43.60000000",
                        "longitude": "26.21667000"
                    },
                    {
                        "id": 9635,
                        "name": "Obshtina Zavet",
                        "latitude": "43.76667000",
                        "longitude": "26.68333000"
                    },
                    {
                        "id": 9669,
                        "name": "Razgrad",
                        "latitude": "43.53333000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 9680,
                        "name": "Samuil",
                        "latitude": "43.51667000",
                        "longitude": "26.75000000"
                    },
                    {
                        "id": 9727,
                        "name": "Tsar Kaloyan",
                        "latitude": "43.61667000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 9747,
                        "name": "Zavet",
                        "latitude": "43.76036000",
                        "longitude": "26.68063000"
                    }
                ]
            },
            {
                "id": 4713,
                "name": "Ruse",
                "iso2": "18",
                "latitude": "43.83559640",
                "longitude": "25.96561440",
                "type": "district",
                "cities": [
                    {
                        "id": 9281,
                        "name": "Borovo",
                        "latitude": "43.50086000",
                        "longitude": "25.80992000"
                    },
                    {
                        "id": 9322,
                        "name": "Dve Mogili",
                        "latitude": "43.59258000",
                        "longitude": "25.87486000"
                    },
                    {
                        "id": 9349,
                        "name": "Ivanovo",
                        "latitude": "43.68568000",
                        "longitude": "25.95565000"
                    },
                    {
                        "id": 9435,
                        "name": "Obshtina Borovo",
                        "latitude": "43.60000000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 9443,
                        "name": "Obshtina Byala",
                        "latitude": "43.41667000",
                        "longitude": "25.83333000"
                    },
                    {
                        "id": 9468,
                        "name": "Obshtina Dve Mogili",
                        "latitude": "43.51667000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 9492,
                        "name": "Obshtina Ivanovo",
                        "latitude": "43.70000000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 9576,
                        "name": "Obshtina Ruse",
                        "latitude": "43.85000000",
                        "longitude": "26.08333000"
                    },
                    {
                        "id": 9593,
                        "name": "Obshtina Slivo Pole",
                        "latitude": "43.96667000",
                        "longitude": "26.30000000"
                    },
                    {
                        "id": 9617,
                        "name": "Obshtina Tsenovo",
                        "latitude": "43.58333000",
                        "longitude": "25.61667000"
                    },
                    {
                        "id": 9628,
                        "name": "Obshtina Vetovo",
                        "latitude": "43.71667000",
                        "longitude": "26.33333000"
                    },
                    {
                        "id": 9675,
                        "name": "Ruse",
                        "latitude": "43.84872000",
                        "longitude": "25.95340000"
                    },
                    {
                        "id": 9687,
                        "name": "Senovo",
                        "latitude": "43.65000000",
                        "longitude": "26.36667000"
                    },
                    {
                        "id": 9699,
                        "name": "Slivo Pole",
                        "latitude": "43.94248000",
                        "longitude": "26.20464000"
                    },
                    {
                        "id": 9729,
                        "name": "Tsenovo",
                        "latitude": "43.53588000",
                        "longitude": "25.65764000"
                    },
                    {
                        "id": 9739,
                        "name": "Vetovo",
                        "latitude": "43.70000000",
                        "longitude": "26.26667000"
                    }
                ]
            },
            {
                "id": 4882,
                "name": "Shumen",
                "iso2": "27",
                "latitude": "43.27123980",
                "longitude": "26.93612860",
                "type": "district",
                "cities": [
                    {
                        "id": 146184,
                        "name": "Shumen",
                        "latitude": "43.28333300",
                        "longitude": "26.93333300"
                    }
                ]
            },
            {
                "id": 4708,
                "name": "Silistra",
                "iso2": "19",
                "latitude": "44.11471010",
                "longitude": "27.26714540",
                "type": "district",
                "cities": [
                    {
                        "id": 9253,
                        "name": "Alfatar",
                        "latitude": "43.94525000",
                        "longitude": "27.28751000"
                    },
                    {
                        "id": 9319,
                        "name": "Dulovo",
                        "latitude": "43.81667000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 9331,
                        "name": "Glavinitsa",
                        "latitude": "43.91667000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 9358,
                        "name": "Kaynardzha",
                        "latitude": "43.99278000",
                        "longitude": "27.50713000"
                    },
                    {
                        "id": 9413,
                        "name": "Obshtina Alfatar",
                        "latitude": "43.90000000",
                        "longitude": "27.33333000"
                    },
                    {
                        "id": 9466,
                        "name": "Obshtina Dulovo",
                        "latitude": "43.81667000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 9479,
                        "name": "Obshtina Glavinitsa",
                        "latitude": "43.95000000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 9500,
                        "name": "Obshtina Kaynardzha",
                        "latitude": "43.95000000",
                        "longitude": "27.53333000"
                    },
                    {
                        "id": 9588,
                        "name": "Obshtina Silistra",
                        "latitude": "44.03333000",
                        "longitude": "27.20000000"
                    },
                    {
                        "id": 9590,
                        "name": "Obshtina Sitovo",
                        "latitude": "44.01667000",
                        "longitude": "27.00000000"
                    },
                    {
                        "id": 9619,
                        "name": "Obshtina Tutrakan",
                        "latitude": "44.00000000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 9692,
                        "name": "Silistra",
                        "latitude": "44.11710000",
                        "longitude": "27.26056000"
                    },
                    {
                        "id": 9695,
                        "name": "Sitovo",
                        "latitude": "44.02730000",
                        "longitude": "27.01982000"
                    },
                    {
                        "id": 9730,
                        "name": "Tutrakan",
                        "latitude": "44.04906000",
                        "longitude": "26.61206000"
                    }
                ]
            },
            {
                "id": 4700,
                "name": "Sliven",
                "iso2": "20",
                "latitude": "42.68167020",
                "longitude": "26.32285690",
                "type": "district",
                "cities": [
                    {
                        "id": 9360,
                        "name": "Kermen",
                        "latitude": "42.50000000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 9371,
                        "name": "Kotel",
                        "latitude": "42.88333000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 9410,
                        "name": "Nova Zagora",
                        "latitude": "42.48333000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 9508,
                        "name": "Obshtina Kotel",
                        "latitude": "42.88333000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 9542,
                        "name": "Obshtina Nova Zagora",
                        "latitude": "42.45000000",
                        "longitude": "26.05000000"
                    },
                    {
                        "id": 9591,
                        "name": "Obshtina Sliven",
                        "latitude": "42.66667000",
                        "longitude": "26.31667000"
                    },
                    {
                        "id": 9620,
                        "name": "Obshtina Tvarditsa",
                        "latitude": "42.73333000",
                        "longitude": "26.00000000"
                    },
                    {
                        "id": 9697,
                        "name": "Sliven",
                        "latitude": "42.68583000",
                        "longitude": "26.32917000"
                    },
                    {
                        "id": 9731,
                        "name": "Tvarditsa",
                        "latitude": "42.70000000",
                        "longitude": "25.90000000"
                    }
                ]
            },
            {
                "id": 4694,
                "name": "Smolyan",
                "iso2": "21",
                "latitude": "41.57741480",
                "longitude": "24.70108710",
                "type": "district",
                "cities": [
                    {
                        "id": 9264,
                        "name": "Banite",
                        "latitude": "41.61667000",
                        "longitude": "25.01667000"
                    },
                    {
                        "id": 9279,
                        "name": "Borino",
                        "latitude": "41.68408000",
                        "longitude": "24.29300000"
                    },
                    {
                        "id": 9298,
                        "name": "Chepelare",
                        "latitude": "41.73333000",
                        "longitude": "24.68333000"
                    },
                    {
                        "id": 9306,
                        "name": "Devin",
                        "latitude": "41.74327000",
                        "longitude": "24.40003000"
                    },
                    {
                        "id": 9315,
                        "name": "Dospat",
                        "latitude": "41.64462000",
                        "longitude": "24.15857000"
                    },
                    {
                        "id": 9339,
                        "name": "Gyovren",
                        "latitude": "41.66326000",
                        "longitude": "24.37557000"
                    },
                    {
                        "id": 9393,
                        "name": "Madan",
                        "latitude": "41.49869000",
                        "longitude": "24.93973000"
                    },
                    {
                        "id": 9405,
                        "name": "Nedelino",
                        "latitude": "41.45602000",
                        "longitude": "25.08008000"
                    },
                    {
                        "id": 9421,
                        "name": "Obshtina Banite",
                        "latitude": "41.70000000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 9433,
                        "name": "Obshtina Borino",
                        "latitude": "41.64834000",
                        "longitude": "24.31694000"
                    },
                    {
                        "id": 9447,
                        "name": "Obshtina Chepelare",
                        "latitude": "41.80000000",
                        "longitude": "24.68333000"
                    },
                    {
                        "id": 9453,
                        "name": "Obshtina Devin",
                        "latitude": "41.74346000",
                        "longitude": "24.40192000"
                    },
                    {
                        "id": 9463,
                        "name": "Obshtina Dospat",
                        "latitude": "41.63228000",
                        "longitude": "24.18765000"
                    },
                    {
                        "id": 9526,
                        "name": "Obshtina Madan",
                        "latitude": "41.53333000",
                        "longitude": "24.96667000"
                    },
                    {
                        "id": 9537,
                        "name": "Obshtina Nedelino",
                        "latitude": "41.46894000",
                        "longitude": "25.09481000"
                    },
                    {
                        "id": 9575,
                        "name": "Obshtina Rudozem",
                        "latitude": "41.45439000",
                        "longitude": "24.83690000"
                    },
                    {
                        "id": 9594,
                        "name": "Obshtina Smolyan",
                        "latitude": "41.57516000",
                        "longitude": "24.71302000"
                    },
                    {
                        "id": 9639,
                        "name": "Obshtina Zlatograd",
                        "latitude": "41.40028000",
                        "longitude": "25.04591000"
                    },
                    {
                        "id": 9673,
                        "name": "Rudozem",
                        "latitude": "41.48751000",
                        "longitude": "24.84945000"
                    },
                    {
                        "id": 9700,
                        "name": "Smolyan",
                        "latitude": "41.57439000",
                        "longitude": "24.71204000"
                    },
                    {
                        "id": 9752,
                        "name": "Zlatograd",
                        "latitude": "41.37950000",
                        "longitude": "25.09605000"
                    }
                ]
            },
            {
                "id": 4719,
                "name": "Sofia",
                "iso2": "23",
                "latitude": "42.67344000",
                "longitude": "23.83349370",
                "type": "district",
                "cities": [
                    {
                        "id": 9254,
                        "name": "Anton",
                        "latitude": "42.75000000",
                        "longitude": "24.28333000"
                    },
                    {
                        "id": 9282,
                        "name": "Botevgrad",
                        "latitude": "42.90000000",
                        "longitude": "23.78333000"
                    },
                    {
                        "id": 9285,
                        "name": "Bozhurishte",
                        "latitude": "42.75000000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 9296,
                        "name": "Chavdar",
                        "latitude": "42.65000000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 9297,
                        "name": "Chelopech",
                        "latitude": "42.70000000",
                        "longitude": "24.08333000"
                    },
                    {
                        "id": 9311,
                        "name": "Dolna Banya",
                        "latitude": "42.30000000",
                        "longitude": "23.76667000"
                    },
                    {
                        "id": 9316,
                        "name": "Dragoman",
                        "latitude": "42.92191000",
                        "longitude": "22.93109000"
                    },
                    {
                        "id": 9326,
                        "name": "Elin Pelin",
                        "latitude": "42.66667000",
                        "longitude": "23.60000000"
                    },
                    {
                        "id": 9327,
                        "name": "Etropole",
                        "latitude": "42.83333000",
                        "longitude": "24.00000000"
                    },
                    {
                        "id": 9332,
                        "name": "Godech",
                        "latitude": "43.01682000",
                        "longitude": "23.04852000"
                    },
                    {
                        "id": 9333,
                        "name": "Gorna Malina",
                        "latitude": "42.68333000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 9346,
                        "name": "Ihtiman",
                        "latitude": "42.43333000",
                        "longitude": "23.81667000"
                    },
                    {
                        "id": 9369,
                        "name": "Koprivshtitsa",
                        "latitude": "42.63333000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 9370,
                        "name": "Kostinbrod",
                        "latitude": "42.81667000",
                        "longitude": "23.21667000"
                    },
                    {
                        "id": 9382,
                        "name": "Lakatnik",
                        "latitude": "43.05000000",
                        "longitude": "23.40000000"
                    },
                    {
                        "id": 9402,
                        "name": "Mirkovo",
                        "latitude": "42.70000000",
                        "longitude": "23.98333000"
                    },
                    {
                        "id": 9414,
                        "name": "Obshtina Anton",
                        "latitude": "42.76667000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 9436,
                        "name": "Obshtina Botevgrad",
                        "latitude": "42.95000000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 9439,
                        "name": "Obshtina Bozhurishte",
                        "latitude": "42.78333000",
                        "longitude": "23.11667000"
                    },
                    {
                        "id": 9445,
                        "name": "Obshtina Chavdar",
                        "latitude": "42.61667000",
                        "longitude": "24.08333000"
                    },
                    {
                        "id": 9446,
                        "name": "Obshtina Chelopech",
                        "latitude": "42.71667000",
                        "longitude": "24.06667000"
                    },
                    {
                        "id": 9459,
                        "name": "Obshtina Dolna Banya",
                        "latitude": "42.30000000",
                        "longitude": "23.76667000"
                    },
                    {
                        "id": 9464,
                        "name": "Obshtina Dragoman",
                        "latitude": "42.93333000",
                        "longitude": "22.93333000"
                    },
                    {
                        "id": 9472,
                        "name": "Obshtina Elin Pelin",
                        "latitude": "42.66667000",
                        "longitude": "23.60000000"
                    },
                    {
                        "id": 9473,
                        "name": "Obshtina Etropole",
                        "latitude": "42.85000000",
                        "longitude": "24.03333000"
                    },
                    {
                        "id": 9480,
                        "name": "Obshtina Gorna Malina",
                        "latitude": "42.71667000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 9505,
                        "name": "Obshtina Koprivshtitsa",
                        "latitude": "42.61667000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 9506,
                        "name": "Obshtina Kostenets",
                        "latitude": "42.30000000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 9507,
                        "name": "Obshtina Kostinbrod",
                        "latitude": "42.88333000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 9533,
                        "name": "Obshtina Mirkovo",
                        "latitude": "42.66667000",
                        "longitude": "23.96667000"
                    },
                    {
                        "id": 9556,
                        "name": "Obshtina Pirdop",
                        "latitude": "42.70000000",
                        "longitude": "24.23333000"
                    },
                    {
                        "id": 9563,
                        "name": "Obshtina Pravets",
                        "latitude": "42.96667000",
                        "longitude": "23.98333000"
                    },
                    {
                        "id": 9580,
                        "name": "Obshtina Samokov",
                        "latitude": "42.33333000",
                        "longitude": "23.55000000"
                    },
                    {
                        "id": 9592,
                        "name": "Obshtina Slivnitsa",
                        "latitude": "42.85000000",
                        "longitude": "22.98333000"
                    },
                    {
                        "id": 9609,
                        "name": "Obshtina Svoge",
                        "latitude": "43.00000000",
                        "longitude": "23.40000000"
                    },
                    {
                        "id": 9638,
                        "name": "Obshtina Zlatitsa",
                        "latitude": "42.70000000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 9654,
                        "name": "Pirdop",
                        "latitude": "42.70000000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 9661,
                        "name": "Pravets",
                        "latitude": "42.88333000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 9679,
                        "name": "Samokov",
                        "latitude": "42.33700000",
                        "longitude": "23.55280000"
                    },
                    {
                        "id": 9698,
                        "name": "Slivnitsa",
                        "latitude": "42.85182000",
                        "longitude": "23.03792000"
                    },
                    {
                        "id": 9718,
                        "name": "Svoge",
                        "latitude": "42.96667000",
                        "longitude": "23.35000000"
                    },
                    {
                        "id": 9750,
                        "name": "Zlatitsa",
                        "latitude": "42.71667000",
                        "longitude": "24.13333000"
                    }
                ]
            },
            {
                "id": 4705,
                "name": "Sofia City",
                "iso2": "22",
                "latitude": "42.75701090",
                "longitude": "23.45046830",
                "type": "district",
                "cities": [
                    {
                        "id": 9291,
                        "name": "Buhovo",
                        "latitude": "42.76667000",
                        "longitude": "23.56667000"
                    },
                    {
                        "id": 9701,
                        "name": "Sofia",
                        "latitude": "42.69751000",
                        "longitude": "23.32415000"
                    },
                    {
                        "id": 9707,
                        "name": "Stolichna Obshtina",
                        "latitude": "42.68647000",
                        "longitude": "23.30561000"
                    }
                ]
            },
            {
                "id": 4707,
                "name": "Stara Zagora",
                "iso2": "24",
                "latitude": "42.42577090",
                "longitude": "25.63448550",
                "type": "district",
                "cities": [
                    {
                        "id": 9258,
                        "name": "Asen",
                        "latitude": "42.65000000",
                        "longitude": "25.20000000"
                    },
                    {
                        "id": 9302,
                        "name": "Chirpan",
                        "latitude": "42.20000000",
                        "longitude": "25.33333000"
                    },
                    {
                        "id": 9340,
                        "name": "Gŭlŭbovo",
                        "latitude": "42.13333000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 9338,
                        "name": "Gurkovo",
                        "latitude": "42.66667000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 9359,
                        "name": "Kazanlak",
                        "latitude": "42.61667000",
                        "longitude": "25.40000000"
                    },
                    {
                        "id": 9395,
                        "name": "Maglizh",
                        "latitude": "42.60000000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 9408,
                        "name": "Nikolaevo",
                        "latitude": "42.63333000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 9441,
                        "name": "Obshtina Bratya Daskalovi",
                        "latitude": "42.30000000",
                        "longitude": "25.21667000"
                    },
                    {
                        "id": 9451,
                        "name": "Obshtina Chirpan",
                        "latitude": "42.23333000",
                        "longitude": "25.38333000"
                    },
                    {
                        "id": 9475,
                        "name": "Obshtina Galabovo",
                        "latitude": "42.15000000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 9485,
                        "name": "Obshtina Gurkovo",
                        "latitude": "42.71667000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 9501,
                        "name": "Obshtina Kazanlŭk",
                        "latitude": "42.61943000",
                        "longitude": "25.39885000"
                    },
                    {
                        "id": 9528,
                        "name": "Obshtina Maglizh",
                        "latitude": "42.63333000",
                        "longitude": "25.61667000"
                    },
                    {
                        "id": 9540,
                        "name": "Obshtina Nikolaevo",
                        "latitude": "42.60000000",
                        "longitude": "25.78333000"
                    },
                    {
                        "id": 9545,
                        "name": "Obshtina Opan",
                        "latitude": "42.21667000",
                        "longitude": "25.70000000"
                    },
                    {
                        "id": 9549,
                        "name": "Obshtina Pavel Banya",
                        "latitude": "42.63333000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 9566,
                        "name": "Obshtina Radnevo",
                        "latitude": "42.30000000",
                        "longitude": "25.93333000"
                    },
                    {
                        "id": 9599,
                        "name": "Obshtina Stara Zagora",
                        "latitude": "42.41667000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 9647,
                        "name": "Pavel Banya",
                        "latitude": "42.60000000",
                        "longitude": "25.20000000"
                    },
                    {
                        "id": 9664,
                        "name": "Radnevo",
                        "latitude": "42.30000000",
                        "longitude": "25.93333000"
                    },
                    {
                        "id": 9691,
                        "name": "Shipka",
                        "latitude": "42.71667000",
                        "longitude": "25.33333000"
                    },
                    {
                        "id": 9706,
                        "name": "Stara Zagora",
                        "latitude": "42.43278000",
                        "longitude": "25.64194000"
                    }
                ]
            },
            {
                "id": 4714,
                "name": "Targovishte",
                "iso2": "25",
                "latitude": "43.24623490",
                "longitude": "26.56912510",
                "type": "district",
                "cities": [
                    {
                        "id": 9255,
                        "name": "Antonovo",
                        "latitude": "43.15000000",
                        "longitude": "26.16667000"
                    },
                    {
                        "id": 9415,
                        "name": "Obshtina Antonovo",
                        "latitude": "43.11667000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 9543,
                        "name": "Obshtina Omurtag",
                        "latitude": "43.08333000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 9544,
                        "name": "Obshtina Opaka",
                        "latitude": "43.46667000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 9561,
                        "name": "Obshtina Popovo",
                        "latitude": "43.35000000",
                        "longitude": "26.23333000"
                    },
                    {
                        "id": 9610,
                        "name": "Obshtina Targovishte",
                        "latitude": "43.25000000",
                        "longitude": "26.56667000"
                    },
                    {
                        "id": 9641,
                        "name": "Omurtag",
                        "latitude": "43.10000000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 9642,
                        "name": "Opaka",
                        "latitude": "43.45000000",
                        "longitude": "26.16667000"
                    },
                    {
                        "id": 9659,
                        "name": "Popovo",
                        "latitude": "43.35000000",
                        "longitude": "26.23333000"
                    },
                    {
                        "id": 9719,
                        "name": "Targovishte",
                        "latitude": "43.25120000",
                        "longitude": "26.57215000"
                    }
                ]
            },
            {
                "id": 4717,
                "name": "Varna",
                "iso2": "03",
                "latitude": "43.20464770",
                "longitude": "27.91054880",
                "type": "district",
                "cities": [
                    {
                        "id": 9252,
                        "name": "Aksakovo",
                        "latitude": "43.25615000",
                        "longitude": "27.82105000"
                    },
                    {
                        "id": 9260,
                        "name": "Asparuhovo",
                        "latitude": "43.18067000",
                        "longitude": "27.88823000"
                    },
                    {
                        "id": 9263,
                        "name": "Balgarevo",
                        "latitude": "43.40296000",
                        "longitude": "28.41189000"
                    },
                    {
                        "id": 9272,
                        "name": "Beloslav",
                        "latitude": "43.18960000",
                        "longitude": "27.70429000"
                    },
                    {
                        "id": 9293,
                        "name": "Byala",
                        "latitude": "42.87426000",
                        "longitude": "27.88865000"
                    },
                    {
                        "id": 9304,
                        "name": "Dalgopol",
                        "latitude": "43.05000000",
                        "longitude": "27.35000000"
                    },
                    {
                        "id": 9307,
                        "name": "Devnya",
                        "latitude": "43.22222000",
                        "longitude": "27.56944000"
                    },
                    {
                        "id": 9313,
                        "name": "Dolni Chiflik",
                        "latitude": "42.99296000",
                        "longitude": "27.71596000"
                    },
                    {
                        "id": 9364,
                        "name": "Kiten",
                        "latitude": "43.08333000",
                        "longitude": "27.31667000"
                    },
                    {
                        "id": 9412,
                        "name": "Obshtina Aksakovo",
                        "latitude": "43.31667000",
                        "longitude": "27.85000000"
                    },
                    {
                        "id": 9418,
                        "name": "Obshtina Avren",
                        "latitude": "43.10000000",
                        "longitude": "27.71667000"
                    },
                    {
                        "id": 9427,
                        "name": "Obshtina Beloslav",
                        "latitude": "43.20000000",
                        "longitude": "27.73333000"
                    },
                    {
                        "id": 9444,
                        "name": "Obshtina Byala",
                        "latitude": "42.88333000",
                        "longitude": "27.81667000"
                    },
                    {
                        "id": 9452,
                        "name": "Obshtina Dalgopol",
                        "latitude": "43.05000000",
                        "longitude": "27.35000000"
                    },
                    {
                        "id": 9454,
                        "name": "Obshtina Devnya",
                        "latitude": "43.22056000",
                        "longitude": "27.60052000"
                    },
                    {
                        "id": 9461,
                        "name": "Obshtina Dolni Chiflik",
                        "latitude": "42.96667000",
                        "longitude": "27.68333000"
                    },
                    {
                        "id": 9565,
                        "name": "Obshtina Provadia",
                        "latitude": "43.18333000",
                        "longitude": "27.40000000"
                    },
                    {
                        "id": 9606,
                        "name": "Obshtina Suvorovo",
                        "latitude": "43.33333000",
                        "longitude": "27.65000000"
                    },
                    {
                        "id": 9623,
                        "name": "Obshtina Valchidol",
                        "latitude": "43.45000000",
                        "longitude": "27.50000000"
                    },
                    {
                        "id": 9624,
                        "name": "Obshtina Varna",
                        "latitude": "43.21667000",
                        "longitude": "27.91667000"
                    },
                    {
                        "id": 9629,
                        "name": "Obshtina Vetrino",
                        "latitude": "43.31667000",
                        "longitude": "27.43333000"
                    },
                    {
                        "id": 9663,
                        "name": "Provadia",
                        "latitude": "43.18333000",
                        "longitude": "27.43333000"
                    },
                    {
                        "id": 9714,
                        "name": "Suvorovo",
                        "latitude": "43.33058000",
                        "longitude": "27.59908000"
                    },
                    {
                        "id": 9734,
                        "name": "Valchidol",
                        "latitude": "43.40000000",
                        "longitude": "27.55000000"
                    },
                    {
                        "id": 9735,
                        "name": "Varna",
                        "latitude": "43.21667000",
                        "longitude": "27.91667000"
                    },
                    {
                        "id": 9740,
                        "name": "Vetrino",
                        "latitude": "43.31667000",
                        "longitude": "27.43333000"
                    },
                    {
                        "id": 9751,
                        "name": "Zlatni Pyasatsi",
                        "latitude": "43.28500000",
                        "longitude": "28.04180000"
                    }
                ]
            },
            {
                "id": 4709,
                "name": "Veliko Tarnovo",
                "iso2": "04",
                "latitude": "43.07565390",
                "longitude": "25.61715000",
                "type": "district",
                "cities": [
                    {
                        "id": 9294,
                        "name": "Byala Cherkva",
                        "latitude": "43.20000000",
                        "longitude": "25.30000000"
                    },
                    {
                        "id": 9305,
                        "name": "Debelets",
                        "latitude": "43.03333000",
                        "longitude": "25.61667000"
                    },
                    {
                        "id": 9324,
                        "name": "Elena",
                        "latitude": "42.93333000",
                        "longitude": "25.88333000"
                    },
                    {
                        "id": 9334,
                        "name": "Gorna Oryahovitsa",
                        "latitude": "43.12778000",
                        "longitude": "25.70167000"
                    },
                    {
                        "id": 9361,
                        "name": "Kilifarevo",
                        "latitude": "42.98333000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 9391,
                        "name": "Lyaskovets",
                        "latitude": "43.11111000",
                        "longitude": "25.72833000"
                    },
                    {
                        "id": 9470,
                        "name": "Obshtina Elena",
                        "latitude": "42.91667000",
                        "longitude": "25.95000000"
                    },
                    {
                        "id": 9481,
                        "name": "Obshtina Gorna Oryahovitsa",
                        "latitude": "43.21667000",
                        "longitude": "25.75000000"
                    },
                    {
                        "id": 9525,
                        "name": "Obshtina Lyaskovets",
                        "latitude": "43.13333000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 9550,
                        "name": "Obshtina Pavlikeni",
                        "latitude": "43.28333000",
                        "longitude": "25.35000000"
                    },
                    {
                        "id": 9559,
                        "name": "Obshtina Polski Trambesh",
                        "latitude": "43.35000000",
                        "longitude": "25.58333000"
                    },
                    {
                        "id": 9601,
                        "name": "Obshtina Strazhitsa",
                        "latitude": "43.26667000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 9604,
                        "name": "Obshtina Suhindol",
                        "latitude": "43.16667000",
                        "longitude": "25.20000000"
                    },
                    {
                        "id": 9608,
                        "name": "Obshtina Svishtov",
                        "latitude": "43.53333000",
                        "longitude": "25.35000000"
                    },
                    {
                        "id": 9626,
                        "name": "Obshtina Veliko Tŭrnovo",
                        "latitude": "43.08241000",
                        "longitude": "25.63202000"
                    },
                    {
                        "id": 9637,
                        "name": "Obshtina Zlataritsa",
                        "latitude": "43.06667000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 9646,
                        "name": "Parvomaytsi",
                        "latitude": "43.15000000",
                        "longitude": "25.65000000"
                    },
                    {
                        "id": 9648,
                        "name": "Pavlikeni",
                        "latitude": "43.24278000",
                        "longitude": "25.32194000"
                    },
                    {
                        "id": 9657,
                        "name": "Polski Trambesh",
                        "latitude": "43.37233000",
                        "longitude": "25.63525000"
                    },
                    {
                        "id": 9709,
                        "name": "Strazhitsa",
                        "latitude": "43.23333000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 9712,
                        "name": "Suhindol",
                        "latitude": "43.19167000",
                        "longitude": "25.18111000"
                    },
                    {
                        "id": 9717,
                        "name": "Svishtov",
                        "latitude": "43.61875000",
                        "longitude": "25.35033000"
                    },
                    {
                        "id": 9737,
                        "name": "Veliko Tŭrnovo",
                        "latitude": "43.08124000",
                        "longitude": "25.62904000"
                    },
                    {
                        "id": 9749,
                        "name": "Zlataritsa",
                        "latitude": "43.05000000",
                        "longitude": "25.90000000"
                    }
                ]
            },
            {
                "id": 4697,
                "name": "Vidin",
                "iso2": "05",
                "latitude": "43.99617390",
                "longitude": "22.86795150",
                "type": "district",
                "cities": [
                    {
                        "id": 9271,
                        "name": "Belogradchik",
                        "latitude": "43.62722000",
                        "longitude": "22.68361000"
                    },
                    {
                        "id": 9284,
                        "name": "Boynitsa",
                        "latitude": "43.95650000",
                        "longitude": "22.53255000"
                    },
                    {
                        "id": 9287,
                        "name": "Bregovo",
                        "latitude": "44.15167000",
                        "longitude": "22.64250000"
                    },
                    {
                        "id": 9303,
                        "name": "Chuprene",
                        "latitude": "43.51806000",
                        "longitude": "22.66611000"
                    },
                    {
                        "id": 9309,
                        "name": "Dimovo",
                        "latitude": "43.74167000",
                        "longitude": "22.72694000"
                    },
                    {
                        "id": 9317,
                        "name": "Drenovets",
                        "latitude": "43.69134000",
                        "longitude": "22.97365000"
                    },
                    {
                        "id": 9320,
                        "name": "Dunavtsi",
                        "latitude": "43.92111000",
                        "longitude": "22.82111000"
                    },
                    {
                        "id": 9336,
                        "name": "Gramada",
                        "latitude": "43.83738000",
                        "longitude": "22.65279000"
                    },
                    {
                        "id": 9380,
                        "name": "Kula",
                        "latitude": "43.88833000",
                        "longitude": "22.52139000"
                    },
                    {
                        "id": 9396,
                        "name": "Makresh",
                        "latitude": "43.76794000",
                        "longitude": "22.66406000"
                    },
                    {
                        "id": 9411,
                        "name": "Novo Selo",
                        "latitude": "44.16214000",
                        "longitude": "22.78376000"
                    },
                    {
                        "id": 9426,
                        "name": "Obshtina Belogradchik",
                        "latitude": "43.65000000",
                        "longitude": "22.60000000"
                    },
                    {
                        "id": 9438,
                        "name": "Obshtina Boynitsa",
                        "latitude": "44.00000000",
                        "longitude": "22.55000000"
                    },
                    {
                        "id": 9456,
                        "name": "Obshtina Dimovo",
                        "latitude": "43.75000000",
                        "longitude": "22.81667000"
                    },
                    {
                        "id": 9483,
                        "name": "Obshtina Gramada",
                        "latitude": "43.83333000",
                        "longitude": "22.65000000"
                    },
                    {
                        "id": 9517,
                        "name": "Obshtina Kula",
                        "latitude": "43.90000000",
                        "longitude": "22.56667000"
                    },
                    {
                        "id": 9577,
                        "name": "Obshtina Ruzhintsi",
                        "latitude": "43.65000000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 9630,
                        "name": "Obshtina Vidin",
                        "latitude": "44.00000000",
                        "longitude": "22.83333000"
                    },
                    {
                        "id": 9676,
                        "name": "Ruzhintsi",
                        "latitude": "43.62179000",
                        "longitude": "22.83286000"
                    },
                    {
                        "id": 9741,
                        "name": "Vidin",
                        "latitude": "43.99159000",
                        "longitude": "22.88236000"
                    }
                ]
            },
            {
                "id": 4711,
                "name": "Vratsa",
                "iso2": "06",
                "latitude": "43.21018060",
                "longitude": "23.55292100",
                "type": "district",
                "cities": [
                    {
                        "id": 9280,
                        "name": "Borovan",
                        "latitude": "43.43333000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 9295,
                        "name": "Byala Slatina",
                        "latitude": "43.46667000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 9344,
                        "name": "Hayredin",
                        "latitude": "43.60193000",
                        "longitude": "23.66135000"
                    },
                    {
                        "id": 9373,
                        "name": "Kozloduy",
                        "latitude": "43.77864000",
                        "longitude": "23.72058000"
                    },
                    {
                        "id": 9376,
                        "name": "Krivodol",
                        "latitude": "43.37444000",
                        "longitude": "23.48444000"
                    },
                    {
                        "id": 9400,
                        "name": "Mezdra",
                        "latitude": "43.15000000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 9403,
                        "name": "Mizia",
                        "latitude": "43.68623000",
                        "longitude": "23.85371000"
                    },
                    {
                        "id": 9434,
                        "name": "Obshtina Borovan",
                        "latitude": "43.43333000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 9488,
                        "name": "Obshtina Hayredin",
                        "latitude": "43.58333000",
                        "longitude": "23.66667000"
                    },
                    {
                        "id": 9510,
                        "name": "Obshtina Kozloduy",
                        "latitude": "43.71667000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 9513,
                        "name": "Obshtina Krivodol",
                        "latitude": "43.38333000",
                        "longitude": "23.48333000"
                    },
                    {
                        "id": 9531,
                        "name": "Obshtina Mezdra",
                        "latitude": "43.13333000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 9534,
                        "name": "Obshtina Mizia",
                        "latitude": "43.63333000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 9546,
                        "name": "Obshtina Oryahovo",
                        "latitude": "43.69038000",
                        "longitude": "23.98643000"
                    },
                    {
                        "id": 9574,
                        "name": "Obshtina Roman",
                        "latitude": "43.15000000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 9631,
                        "name": "Obshtina Vratsa",
                        "latitude": "43.28333000",
                        "longitude": "23.60000000"
                    },
                    {
                        "id": 9643,
                        "name": "Oryahovo",
                        "latitude": "43.73618000",
                        "longitude": "23.96052000"
                    },
                    {
                        "id": 9672,
                        "name": "Roman",
                        "latitude": "43.15000000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 9742,
                        "name": "Vratsa",
                        "latitude": "43.21000000",
                        "longitude": "23.56250000"
                    }
                ]
            },
            {
                "id": 4716,
                "name": "Yambol",
                "iso2": "28",
                "latitude": "42.48414940",
                "longitude": "26.50352960",
                "type": "district",
                "cities": [
                    {
                        "id": 9278,
                        "name": "Bolyarovo",
                        "latitude": "42.14962000",
                        "longitude": "26.81116000"
                    },
                    {
                        "id": 9325,
                        "name": "Elhovo",
                        "latitude": "42.16667000",
                        "longitude": "26.56667000"
                    },
                    {
                        "id": 9432,
                        "name": "Obshtina Bolyarovo",
                        "latitude": "42.15000000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 9471,
                        "name": "Obshtina Elhovo",
                        "latitude": "42.11667000",
                        "longitude": "26.61667000"
                    },
                    {
                        "id": 9600,
                        "name": "Obshtina Straldzha",
                        "latitude": "42.48333000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 9618,
                        "name": "Obshtina Tundzha",
                        "latitude": "42.35000000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 9634,
                        "name": "Obshtina Yambol",
                        "latitude": "42.48333000",
                        "longitude": "26.50000000"
                    },
                    {
                        "id": 9708,
                        "name": "Straldzha",
                        "latitude": "42.60000000",
                        "longitude": "26.68333000"
                    },
                    {
                        "id": 9746,
                        "name": "Yambol",
                        "latitude": "42.48333000",
                        "longitude": "26.50000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 35,
        "name": "Burkina Faso",
        "iso3": "BFA",
        "iso2": "BF",
        "numeric_code": "854",
        "phonecode": "226",
        "capital": "Ouagadougou",
        "currency": "XOF",
        "currency_name": "West African CFA franc",
        "currency_symbol": "CFA",
        "tld": ".bf",
        "native": "Burkina Faso",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Burkinabe",
        "timezones": [
            {
                "zoneName": "Africa\/Ouagadougou",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Burkina Faso",
            "ko": "부르키나 파소",
            "pt-BR": "Burkina Faso",
            "pt": "Burquina Faso",
            "nl": "Burkina Faso",
            "hr": "Burkina Faso",
            "fa": "بورکینافاسو",
            "de": "Burkina Faso",
            "es": "Burkina Faso",
            "fr": "Burkina Faso",
            "ja": "ブルキナファソ",
            "it": "Burkina Faso",
            "zh-CN": "布基纳法索",
            "tr": "Burkina Faso",
            "ru": "Буркина-Фасо",
            "uk": "Буркіна-Фасо",
            "pl": "Burkina Faso"
        },
        "latitude": "13.00000000",
        "longitude": "-2.00000000",
        "emoji": "🇧🇫",
        "emojiU": "U+1F1E7 U+1F1EB",
        "states": [
            {
                "id": 3160,
                "name": "Balé",
                "iso2": "BAL",
                "latitude": "11.78206020",
                "longitude": "-3.01757120",
                "type": "province",
                "cities": []
            },
            {
                "id": 3155,
                "name": "Bam",
                "iso2": "BAM",
                "latitude": "13.44613300",
                "longitude": "-1.59839590",
                "type": "province",
                "cities": []
            },
            {
                "id": 3120,
                "name": "Banwa",
                "iso2": "BAN",
                "latitude": "12.13230530",
                "longitude": "-4.15137640",
                "type": "province",
                "cities": []
            },
            {
                "id": 3152,
                "name": "Bazèga",
                "iso2": "BAZ",
                "latitude": "11.97676920",
                "longitude": "-1.44346900",
                "type": "province",
                "cities": []
            },
            {
                "id": 3138,
                "name": "Boucle du Mouhoun",
                "iso2": "01",
                "latitude": "12.41660000",
                "longitude": "-3.41955270",
                "type": "region",
                "cities": [
                    {
                        "id": 9159,
                        "name": "Barani",
                        "latitude": "13.16910000",
                        "longitude": "-3.88990000"
                    },
                    {
                        "id": 9164,
                        "name": "Boromo",
                        "latitude": "11.74542000",
                        "longitude": "-2.93006000"
                    },
                    {
                        "id": 9172,
                        "name": "Dédougou",
                        "latitude": "12.46338000",
                        "longitude": "-3.46075000"
                    },
                    {
                        "id": 9192,
                        "name": "Nouna",
                        "latitude": "12.72939000",
                        "longitude": "-3.86305000"
                    },
                    {
                        "id": 9203,
                        "name": "Province de la Kossi",
                        "latitude": "12.91667000",
                        "longitude": "-3.83333000"
                    },
                    {
                        "id": 9208,
                        "name": "Province des Balé",
                        "latitude": "11.71667000",
                        "longitude": "-3.05000000"
                    },
                    {
                        "id": 9209,
                        "name": "Province des Banwa",
                        "latitude": "12.16667000",
                        "longitude": "-4.16667000"
                    },
                    {
                        "id": 9221,
                        "name": "Province du Mouhoun",
                        "latitude": "12.25000000",
                        "longitude": "-3.41667000"
                    },
                    {
                        "id": 9223,
                        "name": "Province du Nayala",
                        "latitude": "12.66667000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 9230,
                        "name": "Province du Sourou",
                        "latitude": "13.25000000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 9239,
                        "name": "Salanso",
                        "latitude": "12.17423000",
                        "longitude": "-4.08477000"
                    },
                    {
                        "id": 9244,
                        "name": "Toma",
                        "latitude": "12.75844000",
                        "longitude": "-2.89879000"
                    },
                    {
                        "id": 9245,
                        "name": "Tougan",
                        "latitude": "13.07250000",
                        "longitude": "-3.06940000"
                    }
                ]
            },
            {
                "id": 3121,
                "name": "Bougouriba",
                "iso2": "BGR",
                "latitude": "10.87226460",
                "longitude": "-3.33889170",
                "type": "province",
                "cities": []
            },
            {
                "id": 3131,
                "name": "Boulgou",
                "iso2": "BLG",
                "latitude": "11.43367660",
                "longitude": "-0.37483540",
                "type": "province",
                "cities": []
            },
            {
                "id": 5343,
                "name": "Boulkiemde",
                "iso2": "BLK",
                "latitude": "12.32244190",
                "longitude": "-2.47380520",
                "type": "province",
                "cities": []
            },
            {
                "id": 3153,
                "name": "Cascades",
                "iso2": "02",
                "latitude": "10.32703640",
                "longitude": "-5.25493090",
                "type": "region",
                "cities": [
                    {
                        "id": 9158,
                        "name": "Banfora",
                        "latitude": "10.63333000",
                        "longitude": "-4.76667000"
                    },
                    {
                        "id": 9200,
                        "name": "Province de la Comoé",
                        "latitude": "10.33333000",
                        "longitude": "-4.41667000"
                    },
                    {
                        "id": 9204,
                        "name": "Province de la Léraba",
                        "latitude": "10.66667000",
                        "longitude": "-5.20000000"
                    },
                    {
                        "id": 9241,
                        "name": "Sindou",
                        "latitude": "10.66667000",
                        "longitude": "-5.16667000"
                    }
                ]
            },
            {
                "id": 3136,
                "name": "Centre",
                "iso2": "03",
                "latitude": "12.33937200",
                "longitude": "-1.77969740",
                "type": "region",
                "cities": [
                    {
                        "id": 9181,
                        "name": "Kadiogo Province",
                        "latitude": "12.33333000",
                        "longitude": "-1.50000000"
                    },
                    {
                        "id": 9193,
                        "name": "Ouagadougou",
                        "latitude": "12.36566000",
                        "longitude": "-1.53388000"
                    }
                ]
            },
            {
                "id": 3162,
                "name": "Centre-Est",
                "iso2": "04",
                "latitude": "11.52476740",
                "longitude": "-0.14949880",
                "type": "region",
                "cities": [
                    {
                        "id": 9174,
                        "name": "Garango",
                        "latitude": "11.80000000",
                        "longitude": "-0.55056000"
                    },
                    {
                        "id": 9187,
                        "name": "Koupéla",
                        "latitude": "12.17864000",
                        "longitude": "-0.35103000"
                    },
                    {
                        "id": 9188,
                        "name": "Kouritenga Province",
                        "latitude": "12.20000000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 9195,
                        "name": "Ouargaye",
                        "latitude": "11.50202000",
                        "longitude": "0.05886000"
                    },
                    {
                        "id": 9211,
                        "name": "Province du Boulgou",
                        "latitude": "11.50000000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 9217,
                        "name": "Province du Koulpélogo",
                        "latitude": "11.41667000",
                        "longitude": "0.16667000"
                    },
                    {
                        "id": 9242,
                        "name": "Tenkodogo",
                        "latitude": "11.78000000",
                        "longitude": "-0.36972000"
                    }
                ]
            },
            {
                "id": 3127,
                "name": "Centre-Nord",
                "iso2": "05",
                "latitude": "13.17244640",
                "longitude": "-0.90566230",
                "type": "region",
                "cities": [
                    {
                        "id": 9165,
                        "name": "Boulsa",
                        "latitude": "12.66664000",
                        "longitude": "-0.57469000"
                    },
                    {
                        "id": 9182,
                        "name": "Kaya",
                        "latitude": "13.09167000",
                        "longitude": "-1.08444000"
                    },
                    {
                        "id": 9185,
                        "name": "Kongoussi",
                        "latitude": "13.32583000",
                        "longitude": "-1.53472000"
                    },
                    {
                        "id": 9210,
                        "name": "Province du Bam",
                        "latitude": "13.46667000",
                        "longitude": "-1.58333000"
                    },
                    {
                        "id": 9222,
                        "name": "Province du Namentenga",
                        "latitude": "13.25000000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 9228,
                        "name": "Province du Sanmatenga",
                        "latitude": "13.25000000",
                        "longitude": "-1.08333000"
                    }
                ]
            },
            {
                "id": 3115,
                "name": "Centre-Ouest",
                "iso2": "06",
                "latitude": "11.87984660",
                "longitude": "-2.30244600",
                "type": "region",
                "cities": [
                    {
                        "id": 9178,
                        "name": "Goulouré",
                        "latitude": "12.23484000",
                        "longitude": "-1.93394000"
                    },
                    {
                        "id": 9183,
                        "name": "Kokologo",
                        "latitude": "12.19392000",
                        "longitude": "-1.87687000"
                    },
                    {
                        "id": 9186,
                        "name": "Koudougou",
                        "latitude": "12.25263000",
                        "longitude": "-2.36272000"
                    },
                    {
                        "id": 9189,
                        "name": "Léo",
                        "latitude": "11.10033000",
                        "longitude": "-2.10654000"
                    },
                    {
                        "id": 9198,
                        "name": "Pitmoaga",
                        "latitude": "12.24564000",
                        "longitude": "-1.88148000"
                    },
                    {
                        "id": 9205,
                        "name": "Province de la Sissili",
                        "latitude": "11.33333000",
                        "longitude": "-2.25000000"
                    },
                    {
                        "id": 9212,
                        "name": "Province du Boulkiemdé",
                        "latitude": "12.33333000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 9227,
                        "name": "Province du Sanguié",
                        "latitude": "12.16667000",
                        "longitude": "-2.66667000"
                    },
                    {
                        "id": 9235,
                        "name": "Province du Ziro",
                        "latitude": "11.58333000",
                        "longitude": "-1.91667000"
                    },
                    {
                        "id": 9238,
                        "name": "Réo",
                        "latitude": "12.31963000",
                        "longitude": "-2.47094000"
                    },
                    {
                        "id": 9240,
                        "name": "Sapouy",
                        "latitude": "11.55444000",
                        "longitude": "-1.77361000"
                    }
                ]
            },
            {
                "id": 3149,
                "name": "Centre-Sud",
                "iso2": "07",
                "latitude": "11.52289110",
                "longitude": "-1.05861350",
                "type": "region",
                "cities": [
                    {
                        "id": 9161,
                        "name": "Bazega Province",
                        "latitude": "11.91667000",
                        "longitude": "-1.50000000"
                    },
                    {
                        "id": 9184,
                        "name": "Kombissiri",
                        "latitude": "12.06884000",
                        "longitude": "-1.33644000"
                    },
                    {
                        "id": 9190,
                        "name": "Manga",
                        "latitude": "11.66361000",
                        "longitude": "-1.07306000"
                    },
                    {
                        "id": 9191,
                        "name": "Nahouri Province",
                        "latitude": "11.25000000",
                        "longitude": "-1.25000000"
                    },
                    {
                        "id": 9237,
                        "name": "Pô",
                        "latitude": "11.16972000",
                        "longitude": "-1.14500000"
                    },
                    {
                        "id": 9249,
                        "name": "Zoundweogo Province",
                        "latitude": "11.58333000",
                        "longitude": "-1.00000000"
                    }
                ]
            },
            {
                "id": 3167,
                "name": "Comoé",
                "iso2": "COM",
                "latitude": "10.24952550",
                "longitude": "-5.05937600",
                "type": "province",
                "cities": []
            },
            {
                "id": 3158,
                "name": "Est",
                "iso2": "08",
                "latitude": "12.43655260",
                "longitude": "0.90566230",
                "type": "region",
                "cities": [
                    {
                        "id": 9163,
                        "name": "Bogandé",
                        "latitude": "12.97040000",
                        "longitude": "-0.14953000"
                    },
                    {
                        "id": 9168,
                        "name": "Diapaga",
                        "latitude": "12.07305000",
                        "longitude": "1.78838000"
                    },
                    {
                        "id": 9173,
                        "name": "Fada N'gourma",
                        "latitude": "12.06157000",
                        "longitude": "0.35843000"
                    },
                    {
                        "id": 9175,
                        "name": "Gayéri",
                        "latitude": "12.64824000",
                        "longitude": "0.49314000"
                    },
                    {
                        "id": 9176,
                        "name": "Gnagna Province",
                        "latitude": "12.91880000",
                        "longitude": "0.03920000"
                    },
                    {
                        "id": 9197,
                        "name": "Pama",
                        "latitude": "11.24972000",
                        "longitude": "0.70750000"
                    },
                    {
                        "id": 9201,
                        "name": "Province de la Komandjoari",
                        "latitude": "12.66667000",
                        "longitude": "0.66667000"
                    },
                    {
                        "id": 9202,
                        "name": "Province de la Kompienga",
                        "latitude": "11.41667000",
                        "longitude": "0.91667000"
                    },
                    {
                        "id": 9206,
                        "name": "Province de la Tapoa",
                        "latitude": "12.00000000",
                        "longitude": "1.75000000"
                    },
                    {
                        "id": 9214,
                        "name": "Province du Gourma",
                        "latitude": "12.08333000",
                        "longitude": "0.50000000"
                    }
                ]
            },
            {
                "id": 3148,
                "name": "Ganzourgou",
                "iso2": "GAN",
                "latitude": "12.25239950",
                "longitude": "-1.09675440",
                "type": "province",
                "cities": []
            },
            {
                "id": 3122,
                "name": "Gnagna",
                "iso2": "GNA",
                "latitude": "12.89749920",
                "longitude": "0.07467670",
                "type": "province",
                "cities": []
            },
            {
                "id": 3143,
                "name": "Gourma",
                "iso2": "GOU",
                "latitude": "12.16244730",
                "longitude": "0.67730460",
                "type": "province",
                "cities": []
            },
            {
                "id": 3165,
                "name": "Hauts-Bassins",
                "iso2": "09",
                "latitude": "11.49420030",
                "longitude": "-4.23333550",
                "type": "region",
                "cities": [
                    {
                        "id": 9162,
                        "name": "Bobo-Dioulasso",
                        "latitude": "11.17715000",
                        "longitude": "-4.29790000"
                    },
                    {
                        "id": 9180,
                        "name": "Houndé",
                        "latitude": "11.50000000",
                        "longitude": "-3.51667000"
                    },
                    {
                        "id": 9215,
                        "name": "Province du Houet",
                        "latitude": "11.33333000",
                        "longitude": "-4.25000000"
                    },
                    {
                        "id": 9219,
                        "name": "Province du Kénédougou",
                        "latitude": "11.41667000",
                        "longitude": "-5.00000000"
                    },
                    {
                        "id": 9232,
                        "name": "Province du Tuy",
                        "latitude": "11.41667000",
                        "longitude": "-3.41667000"
                    }
                ]
            },
            {
                "id": 3129,
                "name": "Houet",
                "iso2": "HOU",
                "latitude": "11.13204470",
                "longitude": "-4.23333550",
                "type": "province",
                "cities": []
            },
            {
                "id": 3135,
                "name": "Ioba",
                "iso2": "IOB",
                "latitude": "11.05620340",
                "longitude": "-3.01757120",
                "type": "province",
                "cities": []
            },
            {
                "id": 3168,
                "name": "Kadiogo",
                "iso2": "KAD",
                "latitude": "12.34258970",
                "longitude": "-1.44346900",
                "type": "province",
                "cities": []
            },
            {
                "id": 3112,
                "name": "Kénédougou",
                "iso2": "KEN",
                "latitude": "11.39193950",
                "longitude": "-4.97665400",
                "type": "province",
                "cities": []
            },
            {
                "id": 3132,
                "name": "Komondjari",
                "iso2": "KMD",
                "latitude": "12.71265270",
                "longitude": "0.67730460",
                "type": "province",
                "cities": []
            },
            {
                "id": 3157,
                "name": "Kompienga",
                "iso2": "KMP",
                "latitude": "11.52383620",
                "longitude": "0.75328090",
                "type": "province",
                "cities": []
            },
            {
                "id": 3146,
                "name": "Kossi",
                "iso2": "KOS",
                "latitude": "12.96045800",
                "longitude": "-3.90626880",
                "type": "province",
                "cities": []
            },
            {
                "id": 3133,
                "name": "Koulpélogo",
                "iso2": "KOP",
                "latitude": "11.52476740",
                "longitude": "0.14949880",
                "type": "province",
                "cities": []
            },
            {
                "id": 3161,
                "name": "Kouritenga",
                "iso2": "KOT",
                "latitude": "12.16318130",
                "longitude": "-0.22446620",
                "type": "province",
                "cities": []
            },
            {
                "id": 3147,
                "name": "Kourwéogo",
                "iso2": "KOW",
                "latitude": "12.70774950",
                "longitude": "-1.75388170",
                "type": "province",
                "cities": []
            },
            {
                "id": 3159,
                "name": "Léraba",
                "iso2": "LER",
                "latitude": "10.66487850",
                "longitude": "-5.31025050",
                "type": "province",
                "cities": []
            },
            {
                "id": 3151,
                "name": "Loroum",
                "iso2": "LOR",
                "latitude": "13.81298140",
                "longitude": "-2.06651970",
                "type": "province",
                "cities": []
            },
            {
                "id": 3123,
                "name": "Mouhoun",
                "iso2": "MOU",
                "latitude": "12.14323810",
                "longitude": "-3.33889170",
                "type": "province",
                "cities": []
            },
            {
                "id": 3116,
                "name": "Nahouri",
                "iso2": "NAO",
                "latitude": "11.25022670",
                "longitude": "-1.13530200",
                "type": "province",
                "cities": []
            },
            {
                "id": 3113,
                "name": "Namentenga",
                "iso2": "NAM",
                "latitude": "13.08125840",
                "longitude": "-0.52578230",
                "type": "province",
                "cities": []
            },
            {
                "id": 3142,
                "name": "Nayala",
                "iso2": "NAY",
                "latitude": "12.69645580",
                "longitude": "-3.01757120",
                "type": "province",
                "cities": []
            },
            {
                "id": 3164,
                "name": "Nord",
                "iso2": "10",
                "latitude": "13.71825200",
                "longitude": "-2.30244600",
                "type": "region",
                "cities": [
                    {
                        "id": 9179,
                        "name": "Gourcy",
                        "latitude": "13.20776000",
                        "longitude": "-2.35893000"
                    },
                    {
                        "id": 9194,
                        "name": "Ouahigouya",
                        "latitude": "13.58278000",
                        "longitude": "-2.42158000"
                    },
                    {
                        "id": 9220,
                        "name": "Province du Loroum",
                        "latitude": "13.91667000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 9225,
                        "name": "Province du Passoré",
                        "latitude": "12.91667000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 9234,
                        "name": "Province du Yatenga",
                        "latitude": "13.58333000",
                        "longitude": "-2.41667000"
                    },
                    {
                        "id": 9236,
                        "name": "Province du Zondoma",
                        "latitude": "13.18333000",
                        "longitude": "-2.36667000"
                    },
                    {
                        "id": 9243,
                        "name": "Titao",
                        "latitude": "13.76667000",
                        "longitude": "-2.06667000"
                    },
                    {
                        "id": 9246,
                        "name": "Yako",
                        "latitude": "12.95910000",
                        "longitude": "-2.26075000"
                    }
                ]
            },
            {
                "id": 3156,
                "name": "Noumbiel",
                "iso2": "NOU",
                "latitude": "9.84409460",
                "longitude": "-2.97755580",
                "type": "province",
                "cities": []
            },
            {
                "id": 3141,
                "name": "Oubritenga",
                "iso2": "OUB",
                "latitude": "12.70960870",
                "longitude": "-1.44346900",
                "type": "province",
                "cities": []
            },
            {
                "id": 3144,
                "name": "Oudalan",
                "iso2": "OUD",
                "latitude": "14.47190200",
                "longitude": "-0.45023680",
                "type": "province",
                "cities": []
            },
            {
                "id": 3117,
                "name": "Passoré",
                "iso2": "PAS",
                "latitude": "12.88812210",
                "longitude": "-2.22366670",
                "type": "province",
                "cities": []
            },
            {
                "id": 3125,
                "name": "Plateau-Central",
                "iso2": "11",
                "latitude": "12.36686210",
                "longitude": "-1.89482430",
                "type": "region",
                "cities": [
                    {
                        "id": 9166,
                        "name": "Boussé",
                        "latitude": "12.66121000",
                        "longitude": "-1.89515000"
                    },
                    {
                        "id": 9196,
                        "name": "Oubritenga",
                        "latitude": "12.66667000",
                        "longitude": "-1.33333000"
                    },
                    {
                        "id": 9213,
                        "name": "Province du Ganzourgou",
                        "latitude": "12.26667000",
                        "longitude": "-0.76667000"
                    },
                    {
                        "id": 9218,
                        "name": "Province du Kourwéogo",
                        "latitude": "12.58333000",
                        "longitude": "-1.76667000"
                    },
                    {
                        "id": 9247,
                        "name": "Ziniaré",
                        "latitude": "12.58186000",
                        "longitude": "-1.29710000"
                    },
                    {
                        "id": 9248,
                        "name": "Zorgo",
                        "latitude": "12.24922000",
                        "longitude": "-0.61527000"
                    }
                ]
            },
            {
                "id": 3163,
                "name": "Poni",
                "iso2": "PON",
                "latitude": "10.33259960",
                "longitude": "-3.33889170",
                "type": "province",
                "cities": []
            },
            {
                "id": 3114,
                "name": "Sahel",
                "iso2": "12",
                "latitude": "14.10008650",
                "longitude": "-0.14949880",
                "type": "region",
                "cities": [
                    {
                        "id": 9170,
                        "name": "Djibo",
                        "latitude": "14.09940000",
                        "longitude": "-1.62554000"
                    },
                    {
                        "id": 9171,
                        "name": "Dori",
                        "latitude": "14.03540000",
                        "longitude": "-0.03450000"
                    },
                    {
                        "id": 9177,
                        "name": "Gorom-Gorom",
                        "latitude": "14.44290000",
                        "longitude": "-0.23468000"
                    },
                    {
                        "id": 9207,
                        "name": "Province de l’Oudalan",
                        "latitude": "14.66667000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 9231,
                        "name": "Province du Séno",
                        "latitude": "13.96400000",
                        "longitude": "0.01200000"
                    },
                    {
                        "id": 9229,
                        "name": "Province du Soum",
                        "latitude": "14.33333000",
                        "longitude": "-1.25000000"
                    },
                    {
                        "id": 9233,
                        "name": "Province du Yagha",
                        "latitude": "13.41667000",
                        "longitude": "0.58333000"
                    }
                ]
            },
            {
                "id": 3154,
                "name": "Sanguié",
                "iso2": "SNG",
                "latitude": "12.15018610",
                "longitude": "-2.69838680",
                "type": "province",
                "cities": []
            },
            {
                "id": 3126,
                "name": "Sanmatenga",
                "iso2": "SMT",
                "latitude": "13.35653040",
                "longitude": "-1.05861350",
                "type": "province",
                "cities": []
            },
            {
                "id": 3139,
                "name": "Séno",
                "iso2": "SEN",
                "latitude": "14.00722340",
                "longitude": "-0.07467670",
                "type": "province",
                "cities": []
            },
            {
                "id": 3119,
                "name": "Sissili",
                "iso2": "SIS",
                "latitude": "11.24412190",
                "longitude": "-2.22366670",
                "type": "province",
                "cities": []
            },
            {
                "id": 3166,
                "name": "Soum",
                "iso2": "SOM",
                "latitude": "14.09628410",
                "longitude": "-1.36621600",
                "type": "province",
                "cities": []
            },
            {
                "id": 3137,
                "name": "Sourou",
                "iso2": "SOR",
                "latitude": "13.34180300",
                "longitude": "-2.93757390",
                "type": "province",
                "cities": []
            },
            {
                "id": 3140,
                "name": "Sud-Ouest",
                "iso2": "13",
                "latitude": "10.42314930",
                "longitude": "-3.25836260",
                "type": "region",
                "cities": [
                    {
                        "id": 9160,
                        "name": "Batié",
                        "latitude": "9.88333000",
                        "longitude": "-2.91667000"
                    },
                    {
                        "id": 9167,
                        "name": "Dano",
                        "latitude": "11.14640000",
                        "longitude": "-3.05784000"
                    },
                    {
                        "id": 9169,
                        "name": "Diébougou",
                        "latitude": "10.96209000",
                        "longitude": "-3.24967000"
                    },
                    {
                        "id": 9199,
                        "name": "Province de la Bougouriba",
                        "latitude": "10.83333000",
                        "longitude": "-3.41667000"
                    },
                    {
                        "id": 9216,
                        "name": "Province du Ioba",
                        "latitude": "11.08333000",
                        "longitude": "-3.08333000"
                    },
                    {
                        "id": 9224,
                        "name": "Province du Noumbièl",
                        "latitude": "9.83333000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 9226,
                        "name": "Province du Poni",
                        "latitude": "10.25000000",
                        "longitude": "-3.41667000"
                    }
                ]
            },
            {
                "id": 3128,
                "name": "Tapoa",
                "iso2": "TAP",
                "latitude": "12.24970720",
                "longitude": "1.67606910",
                "type": "province",
                "cities": []
            },
            {
                "id": 3134,
                "name": "Tuy",
                "iso2": "TUI",
                "latitude": "38.88868400",
                "longitude": "-77.00471900",
                "type": "province",
                "cities": []
            },
            {
                "id": 3124,
                "name": "Yagha",
                "iso2": "YAG",
                "latitude": "13.35761570",
                "longitude": "0.75328090",
                "type": "province",
                "cities": []
            },
            {
                "id": 3150,
                "name": "Yatenga",
                "iso2": "YAT",
                "latitude": "13.62493440",
                "longitude": "-2.38136210",
                "type": "province",
                "cities": []
            },
            {
                "id": 3145,
                "name": "Ziro",
                "iso2": "ZIR",
                "latitude": "11.60949950",
                "longitude": "-1.90992380",
                "type": "province",
                "cities": []
            },
            {
                "id": 3130,
                "name": "Zondoma",
                "iso2": "ZON",
                "latitude": "13.11659260",
                "longitude": "-2.42087130",
                "type": "province",
                "cities": []
            },
            {
                "id": 3118,
                "name": "Zoundwéogo",
                "iso2": "ZOU",
                "latitude": "11.61411740",
                "longitude": "-0.98206680",
                "type": "province",
                "cities": []
            }
        ]
    },
    {
        "id": 36,
        "name": "Burundi",
        "iso3": "BDI",
        "iso2": "BI",
        "numeric_code": "108",
        "phonecode": "257",
        "capital": "Bujumbura",
        "currency": "BIF",
        "currency_name": "Burundian franc",
        "currency_symbol": "FBu",
        "tld": ".bi",
        "native": "Burundi",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Burundian",
        "timezones": [
            {
                "zoneName": "Africa\/Bujumbura",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "br": "Burundi",
            "ko": "부룬디",
            "pt-BR": "Burundi",
            "pt": "Burúndi",
            "nl": "Burundi",
            "hr": "Burundi",
            "fa": "بوروندی",
            "de": "Burundi",
            "es": "Burundi",
            "fr": "Burundi",
            "ja": "ブルンジ",
            "it": "Burundi",
            "zh-CN": "布隆迪",
            "tr": "Burundi",
            "ru": "Бурунди",
            "uk": "Бурунді",
            "pl": "Burundi"
        },
        "latitude": "-3.50000000",
        "longitude": "30.00000000",
        "emoji": "🇧🇮",
        "emojiU": "U+1F1E7 U+1F1EE",
        "states": [
            {
                "id": 3196,
                "name": "Bubanza",
                "iso2": "BB",
                "latitude": "-3.15724030",
                "longitude": "29.37149090",
                "type": "province",
                "cities": [
                    {
                        "id": 9762,
                        "name": "Bubanza",
                        "latitude": "-3.08040000",
                        "longitude": "29.39100000"
                    }
                ]
            },
            {
                "id": 3198,
                "name": "Bujumbura Mairie",
                "iso2": "BM",
                "latitude": "-3.38841410",
                "longitude": "29.34826460",
                "type": "province",
                "cities": [
                    {
                        "id": 9763,
                        "name": "Bujumbura",
                        "latitude": "-3.38193000",
                        "longitude": "29.36142000"
                    }
                ]
            },
            {
                "id": 3200,
                "name": "Bujumbura Rural",
                "iso2": "BL",
                "latitude": "-3.50901440",
                "longitude": "29.46435900",
                "type": "province",
                "cities": []
            },
            {
                "id": 3202,
                "name": "Bururi",
                "iso2": "BR",
                "latitude": "-3.90068510",
                "longitude": "29.51077080",
                "type": "province",
                "cities": [
                    {
                        "id": 9764,
                        "name": "Bururi",
                        "latitude": "-3.94877000",
                        "longitude": "29.62438000"
                    }
                ]
            },
            {
                "id": 3201,
                "name": "Cankuzo",
                "iso2": "CA",
                "latitude": "-3.15277880",
                "longitude": "30.61998950",
                "type": "province",
                "cities": [
                    {
                        "id": 9765,
                        "name": "Cankuzo",
                        "latitude": "-3.21860000",
                        "longitude": "30.55280000"
                    }
                ]
            },
            {
                "id": 3190,
                "name": "Cibitoke",
                "iso2": "CI",
                "latitude": "-2.81028970",
                "longitude": "29.18557850",
                "type": "province",
                "cities": [
                    {
                        "id": 9766,
                        "name": "Cibitoke",
                        "latitude": "-2.88690000",
                        "longitude": "29.12480000"
                    }
                ]
            },
            {
                "id": 3197,
                "name": "Gitega",
                "iso2": "GI",
                "latitude": "-3.49290510",
                "longitude": "29.92779470",
                "type": "province",
                "cities": [
                    {
                        "id": 9767,
                        "name": "Gitega",
                        "latitude": "-3.42708000",
                        "longitude": "29.92463000"
                    }
                ]
            },
            {
                "id": 3194,
                "name": "Karuzi",
                "iso2": "KR",
                "latitude": "-3.13403470",
                "longitude": "30.11273500",
                "type": "province",
                "cities": [
                    {
                        "id": 9768,
                        "name": "Karuzi",
                        "latitude": "-3.10139000",
                        "longitude": "30.16278000"
                    }
                ]
            },
            {
                "id": 3192,
                "name": "Kayanza",
                "iso2": "KY",
                "latitude": "-3.00779810",
                "longitude": "29.64991620",
                "type": "province",
                "cities": [
                    {
                        "id": 9769,
                        "name": "Kayanza",
                        "latitude": "-2.92210000",
                        "longitude": "29.62930000"
                    }
                ]
            },
            {
                "id": 3195,
                "name": "Kirundo",
                "iso2": "KI",
                "latitude": "-2.57628820",
                "longitude": "30.11273500",
                "type": "province",
                "cities": [
                    {
                        "id": 9770,
                        "name": "Kirundo",
                        "latitude": "-2.58450000",
                        "longitude": "30.09590000"
                    }
                ]
            },
            {
                "id": 3188,
                "name": "Makamba",
                "iso2": "MA",
                "latitude": "-4.32570620",
                "longitude": "29.69626770",
                "type": "province",
                "cities": [
                    {
                        "id": 9771,
                        "name": "Makamba",
                        "latitude": "-4.13480000",
                        "longitude": "29.80400000"
                    }
                ]
            },
            {
                "id": 3193,
                "name": "Muramvya",
                "iso2": "MU",
                "latitude": "-3.28983980",
                "longitude": "29.64991620",
                "type": "province",
                "cities": [
                    {
                        "id": 9772,
                        "name": "Muramvya",
                        "latitude": "-3.26820000",
                        "longitude": "29.60790000"
                    }
                ]
            },
            {
                "id": 3186,
                "name": "Muyinga",
                "iso2": "MY",
                "latitude": "-2.77935110",
                "longitude": "30.29741990",
                "type": "province",
                "cities": [
                    {
                        "id": 9773,
                        "name": "Muyinga",
                        "latitude": "-2.84510000",
                        "longitude": "30.34140000"
                    }
                ]
            },
            {
                "id": 3187,
                "name": "Mwaro",
                "iso2": "MW",
                "latitude": "-3.50259180",
                "longitude": "29.64991620",
                "type": "province",
                "cities": [
                    {
                        "id": 9774,
                        "name": "Mwaro",
                        "latitude": "-3.51128000",
                        "longitude": "29.70334000"
                    }
                ]
            },
            {
                "id": 3199,
                "name": "Ngozi",
                "iso2": "NG",
                "latitude": "-2.89582430",
                "longitude": "29.88152030",
                "type": "province",
                "cities": [
                    {
                        "id": 9775,
                        "name": "Ngozi",
                        "latitude": "-2.90750000",
                        "longitude": "29.83060000"
                    }
                ]
            },
            {
                "id": 3185,
                "name": "Rumonge",
                "iso2": "RM",
                "latitude": "-3.97540490",
                "longitude": "29.43880140",
                "type": "province",
                "cities": [
                    {
                        "id": 9776,
                        "name": "Rumonge",
                        "latitude": "-3.97360000",
                        "longitude": "29.43860000"
                    }
                ]
            },
            {
                "id": 3189,
                "name": "Rutana",
                "iso2": "RT",
                "latitude": "-3.87915230",
                "longitude": "30.06652360",
                "type": "province",
                "cities": [
                    {
                        "id": 9777,
                        "name": "Rutana",
                        "latitude": "-3.92790000",
                        "longitude": "29.99200000"
                    }
                ]
            },
            {
                "id": 3191,
                "name": "Ruyigi",
                "iso2": "RY",
                "latitude": "-3.44620700",
                "longitude": "30.25127280",
                "type": "province",
                "cities": [
                    {
                        "id": 9778,
                        "name": "Ruyigi",
                        "latitude": "-3.47639000",
                        "longitude": "30.24861000"
                    }
                ]
            }
        ]
    },
    {
        "id": 37,
        "name": "Cambodia",
        "iso3": "KHM",
        "iso2": "KH",
        "numeric_code": "116",
        "phonecode": "855",
        "capital": "Phnom Penh",
        "currency": "KHR",
        "currency_name": "Cambodian riel",
        "currency_symbol": "KHR",
        "tld": ".kh",
        "native": "Kâmpŭchéa",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Cambodian",
        "timezones": [
            {
                "zoneName": "Asia\/Phnom_Penh",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "ICT",
                "tzName": "Indochina Time"
            }
        ],
        "translations": {
            "br": "Kambodja",
            "ko": "캄보디아",
            "pt-BR": "Camboja",
            "pt": "Camboja",
            "nl": "Cambodja",
            "hr": "Kambodža",
            "fa": "کامبوج",
            "de": "Kambodscha",
            "es": "Camboya",
            "fr": "Cambodge",
            "ja": "カンボジア",
            "it": "Cambogia",
            "zh-CN": "柬埔寨",
            "tr": "Kamboçya",
            "ru": "Камбоджа",
            "uk": "Камбоджа",
            "pl": "Kambodża"
        },
        "latitude": "13.00000000",
        "longitude": "105.00000000",
        "emoji": "🇰🇭",
        "emojiU": "U+1F1F0 U+1F1ED",
        "states": [
            {
                "id": 3984,
                "name": "Banteay Meanchey",
                "iso2": "1",
                "latitude": "13.75319140",
                "longitude": "102.98961500",
                "type": "province",
                "cities": [
                    {
                        "id": 64967,
                        "name": "Mongkol Borei",
                        "latitude": "13.45531000",
                        "longitude": "102.99186000"
                    },
                    {
                        "id": 64969,
                        "name": "Paoy Paet",
                        "latitude": "13.65805000",
                        "longitude": "102.56365000"
                    },
                    {
                        "id": 64981,
                        "name": "Sisophon",
                        "latitude": "13.58588000",
                        "longitude": "102.97369000"
                    },
                    {
                        "id": 65009,
                        "name": "Srŏk Malai",
                        "latitude": "13.49902000",
                        "longitude": "102.60164000"
                    },
                    {
                        "id": 65022,
                        "name": "Srŏk Svay Chék",
                        "latitude": "13.81305000",
                        "longitude": "102.95269000"
                    }
                ]
            },
            {
                "id": 3976,
                "name": "Battambang",
                "iso2": "2",
                "latitude": "13.02869710",
                "longitude": "102.98961500",
                "type": "province",
                "cities": [
                    {
                        "id": 64940,
                        "name": "Battambang",
                        "latitude": "13.10271000",
                        "longitude": "103.19822000"
                    },
                    {
                        "id": 65028,
                        "name": "Srŏk Âk Phnŭm",
                        "latitude": "13.23621000",
                        "longitude": "103.45894000"
                    },
                    {
                        "id": 64988,
                        "name": "Srŏk Banăn",
                        "latitude": "12.97067000",
                        "longitude": "103.04742000"
                    },
                    {
                        "id": 64995,
                        "name": "Srŏk Bâvĭl",
                        "latitude": "13.23601000",
                        "longitude": "102.82910000"
                    },
                    {
                        "id": 65017,
                        "name": "Srŏk Rotanak Mondol",
                        "latitude": "12.84048000",
                        "longitude": "102.88700000"
                    }
                ]
            },
            {
                "id": 3991,
                "name": "Kampong Cham",
                "iso2": "3",
                "latitude": "12.09829180",
                "longitude": "105.31311850",
                "type": "province",
                "cities": [
                    {
                        "id": 64941,
                        "name": "Cheung Prey",
                        "latitude": "12.10000000",
                        "longitude": "105.07000000"
                    },
                    {
                        "id": 64944,
                        "name": "Kampong Cham",
                        "latitude": "11.98000000",
                        "longitude": "105.44500000"
                    },
                    {
                        "id": 64990,
                        "name": "Srŏk Bathéay",
                        "latitude": "12.02986000",
                        "longitude": "104.93171000"
                    }
                ]
            },
            {
                "id": 3979,
                "name": "Kampong Chhnang",
                "iso2": "4",
                "latitude": "12.13923520",
                "longitude": "104.56552730",
                "type": "province",
                "cities": [
                    {
                        "id": 64939,
                        "name": "Baribour",
                        "latitude": "12.43000000",
                        "longitude": "104.47000000"
                    },
                    {
                        "id": 64945,
                        "name": "Kampong Chhnang",
                        "latitude": "12.26000000",
                        "longitude": "104.67000000"
                    },
                    {
                        "id": 64974,
                        "name": "Rolea B'ier",
                        "latitude": "12.21000000",
                        "longitude": "104.61000000"
                    },
                    {
                        "id": 64997,
                        "name": "Srŏk Chol Kiri",
                        "latitude": "12.15861000",
                        "longitude": "104.82287000"
                    },
                    {
                        "id": 65019,
                        "name": "Srŏk Sameakki Mean Chey",
                        "latitude": "11.86788000",
                        "longitude": "104.55549000"
                    }
                ]
            },
            {
                "id": 3988,
                "name": "Kampong Speu",
                "iso2": "5",
                "latitude": "11.61551090",
                "longitude": "104.37919120",
                "type": "province",
                "cities": [
                    {
                        "id": 64946,
                        "name": "Kampong Speu",
                        "latitude": "11.45332000",
                        "longitude": "104.52085000"
                    },
                    {
                        "id": 64962,
                        "name": "Krŏng Chbar Mon",
                        "latitude": "11.47091000",
                        "longitude": "104.50655000"
                    },
                    {
                        "id": 64989,
                        "name": "Srŏk Basedth",
                        "latitude": "11.18432000",
                        "longitude": "104.53584000"
                    },
                    {
                        "id": 65008,
                        "name": "Srŏk Kông Pĭsei",
                        "latitude": "11.31648000",
                        "longitude": "104.65992000"
                    },
                    {
                        "id": 65032,
                        "name": "Srŏk Ŏdŏngk",
                        "latitude": "11.66845000",
                        "longitude": "104.61224000"
                    }
                ]
            },
            {
                "id": 5070,
                "name": "Kampong Thom",
                "iso2": "6",
                "latitude": "12.81674850",
                "longitude": "103.84131040",
                "type": "province",
                "cities": []
            },
            {
                "id": 3981,
                "name": "Kampot",
                "iso2": "7",
                "latitude": "10.73253510",
                "longitude": "104.37919120",
                "type": "province",
                "cities": [
                    {
                        "id": 64935,
                        "name": "Angkor Chey",
                        "latitude": "10.76667000",
                        "longitude": "104.65000000"
                    },
                    {
                        "id": 64938,
                        "name": "Banteay Meas",
                        "latitude": "10.61667000",
                        "longitude": "104.53333000"
                    },
                    {
                        "id": 64942,
                        "name": "Chhouk District",
                        "latitude": "10.81667000",
                        "longitude": "104.45000000"
                    },
                    {
                        "id": 64943,
                        "name": "Kampong Bay",
                        "latitude": "10.59554000",
                        "longitude": "104.17136000"
                    },
                    {
                        "id": 64947,
                        "name": "Kampong Tranch",
                        "latitude": "10.55000000",
                        "longitude": "104.46667000"
                    },
                    {
                        "id": 64948,
                        "name": "Kampot",
                        "latitude": "10.61041000",
                        "longitude": "104.18145000"
                    },
                    {
                        "id": 64998,
                        "name": "Srŏk Chŭm Kiri",
                        "latitude": "11.00540000",
                        "longitude": "104.44207000"
                    },
                    {
                        "id": 65001,
                        "name": "Srŏk Dângtóng",
                        "latitude": "10.70733000",
                        "longitude": "104.42229000"
                    },
                    {
                        "id": 64986,
                        "name": "Srok Tuek Chhou",
                        "latitude": "10.74557000",
                        "longitude": "104.11013000"
                    }
                ]
            },
            {
                "id": 3983,
                "name": "Kandal",
                "iso2": "8",
                "latitude": "11.22373830",
                "longitude": "105.12589550",
                "type": "province",
                "cities": [
                    {
                        "id": 64965,
                        "name": "Krŏng Ta Khmau",
                        "latitude": "11.45474000",
                        "longitude": "104.94350000"
                    },
                    {
                        "id": 65003,
                        "name": "Srŏk Khsăch Kândal",
                        "latitude": "11.69224000",
                        "longitude": "105.03732000"
                    },
                    {
                        "id": 65037,
                        "name": "Ta Khmau",
                        "latitude": "11.48333000",
                        "longitude": "104.95000000"
                    }
                ]
            },
            {
                "id": 3978,
                "name": "Kep",
                "iso2": "23",
                "latitude": "10.53608900",
                "longitude": "104.35591580",
                "type": "province",
                "cities": [
                    {
                        "id": 64961,
                        "name": "Krong Kep",
                        "latitude": "10.48291000",
                        "longitude": "104.31672000"
                    },
                    {
                        "id": 65000,
                        "name": "Srŏk Dâmnăk Châng’aeur",
                        "latitude": "10.53394000",
                        "longitude": "104.34855000"
                    }
                ]
            },
            {
                "id": 3982,
                "name": "Koh Kong",
                "iso2": "9",
                "latitude": "11.57628040",
                "longitude": "103.35872880",
                "type": "province",
                "cities": [
                    {
                        "id": 64957,
                        "name": "Koh Kong",
                        "latitude": "11.61531000",
                        "longitude": "102.98380000"
                    },
                    {
                        "id": 64982,
                        "name": "Smach Mean Chey",
                        "latitude": "11.54665000",
                        "longitude": "103.03569000"
                    },
                    {
                        "id": 64984,
                        "name": "Srae Ambel",
                        "latitude": "11.10968000",
                        "longitude": "103.76226000"
                    },
                    {
                        "id": 64991,
                        "name": "Srŏk Batum Sakôr",
                        "latitude": "11.11465000",
                        "longitude": "103.38993000"
                    },
                    {
                        "id": 65011,
                        "name": "Srŏk Môndôl Seima",
                        "latitude": "11.81292000",
                        "longitude": "103.01159000"
                    }
                ]
            },
            {
                "id": 3986,
                "name": "Kratie",
                "iso2": "10",
                "latitude": "12.50436080",
                "longitude": "105.96998780",
                "type": "province",
                "cities": [
                    {
                        "id": 64958,
                        "name": "Kracheh",
                        "latitude": "12.57000000",
                        "longitude": "106.20000000"
                    },
                    {
                        "id": 64960,
                        "name": "Kratié",
                        "latitude": "12.48811000",
                        "longitude": "106.01879000"
                    },
                    {
                        "id": 64983,
                        "name": "Snuol",
                        "latitude": "12.19373000",
                        "longitude": "106.47361000"
                    }
                ]
            },
            {
                "id": 3985,
                "name": "Mondulkiri",
                "iso2": "11",
                "latitude": "12.78794270",
                "longitude": "107.10119310",
                "type": "province",
                "cities": [
                    {
                        "id": 64964,
                        "name": "Krŏng Sênmônoŭrôm",
                        "latitude": "12.50480000",
                        "longitude": "107.15525000"
                    },
                    {
                        "id": 64978,
                        "name": "Sen Monorom",
                        "latitude": "12.45583000",
                        "longitude": "107.18811000"
                    },
                    {
                        "id": 65002,
                        "name": "Srŏk Kaev Seima",
                        "latitude": "12.41722000",
                        "longitude": "106.77025000"
                    },
                    {
                        "id": 65014,
                        "name": "Srŏk Pech Chreada",
                        "latitude": "12.72780000",
                        "longitude": "107.09480000"
                    }
                ]
            },
            {
                "id": 3987,
                "name": "Oddar Meanchey",
                "iso2": "22",
                "latitude": "14.16097380",
                "longitude": "103.82162610",
                "type": "province",
                "cities": [
                    {
                        "id": 64976,
                        "name": "Samraong",
                        "latitude": "14.18175000",
                        "longitude": "103.51761000"
                    },
                    {
                        "id": 64994,
                        "name": "Srŏk Bântéay Âmpĭl",
                        "latitude": "14.18590000",
                        "longitude": "103.25925000"
                    },
                    {
                        "id": 65023,
                        "name": "Srŏk Sâmraông",
                        "latitude": "14.25039000",
                        "longitude": "103.62739000"
                    },
                    {
                        "id": 65026,
                        "name": "Srŏk Trâpeăng Prasat",
                        "latitude": "14.25809000",
                        "longitude": "104.30835000"
                    }
                ]
            },
            {
                "id": 3980,
                "name": "Pailin",
                "iso2": "24",
                "latitude": "12.90929620",
                "longitude": "102.66755750",
                "type": "province",
                "cities": [
                    {
                        "id": 64956,
                        "name": "Khan Sala Krau",
                        "latitude": "12.97984000",
                        "longitude": "102.63957000"
                    },
                    {
                        "id": 64968,
                        "name": "Pailin",
                        "latitude": "12.84895000",
                        "longitude": "102.60928000"
                    }
                ]
            },
            {
                "id": 3994,
                "name": "Phnom Penh",
                "iso2": "12",
                "latitude": "11.55637380",
                "longitude": "104.92820990",
                "type": "autonomous municipality",
                "cities": [
                    {
                        "id": 64949,
                        "name": "Khan 7 Makara",
                        "latitude": "11.56254000",
                        "longitude": "104.91405000"
                    },
                    {
                        "id": 64950,
                        "name": "Khan Châmkar Mon",
                        "latitude": "11.54390000",
                        "longitude": "104.92175000"
                    },
                    {
                        "id": 64952,
                        "name": "Khan Dângkaô",
                        "latitude": "11.52457000",
                        "longitude": "104.83944000"
                    },
                    {
                        "id": 64951,
                        "name": "Khan Duŏn Pénh",
                        "latitude": "11.57561000",
                        "longitude": "104.92025000"
                    },
                    {
                        "id": 64953,
                        "name": "Khan Méan Chey",
                        "latitude": "11.51976000",
                        "longitude": "104.95467000"
                    },
                    {
                        "id": 64954,
                        "name": "Khan Russey Keo",
                        "latitude": "11.61946000",
                        "longitude": "104.90990000"
                    },
                    {
                        "id": 64955,
                        "name": "Khan Saen Sokh",
                        "latitude": "11.61289000",
                        "longitude": "104.86078000"
                    },
                    {
                        "id": 64970,
                        "name": "Phnom Penh",
                        "latitude": "11.56245000",
                        "longitude": "104.91601000"
                    }
                ]
            },
            {
                "id": 3973,
                "name": "Preah Vihear",
                "iso2": "13",
                "latitude": "14.00857970",
                "longitude": "104.84546190",
                "type": "province",
                "cities": [
                    {
                        "id": 64977,
                        "name": "Sangkom Thmei",
                        "latitude": "13.47395000",
                        "longitude": "104.77051000"
                    },
                    {
                        "id": 64999,
                        "name": "Srŏk Ch’êh Sên",
                        "latitude": "13.58215000",
                        "longitude": "105.34533000"
                    },
                    {
                        "id": 64996,
                        "name": "Srŏk Chhêb",
                        "latitude": "13.91077000",
                        "longitude": "105.46180000"
                    },
                    {
                        "id": 65005,
                        "name": "Srŏk Kulén",
                        "latitude": "13.78597000",
                        "longitude": "104.61052000"
                    },
                    {
                        "id": 65018,
                        "name": "Srŏk Rôviĕng",
                        "latitude": "13.35105000",
                        "longitude": "105.09956000"
                    },
                    {
                        "id": 65025,
                        "name": "Srŏk Tbêng Méanchey",
                        "latitude": "13.78622000",
                        "longitude": "105.01586000"
                    },
                    {
                        "id": 65039,
                        "name": "Tbeng Meanchey",
                        "latitude": "13.80731000",
                        "longitude": "104.98046000"
                    }
                ]
            },
            {
                "id": 3974,
                "name": "Prey Veng",
                "iso2": "14",
                "latitude": "11.38024420",
                "longitude": "105.50054830",
                "type": "province",
                "cities": [
                    {
                        "id": 64972,
                        "name": "Prey Veng",
                        "latitude": "11.48682000",
                        "longitude": "105.32533000"
                    },
                    {
                        "id": 65006,
                        "name": "Srŏk Kâmpóng Léav",
                        "latitude": "11.50970000",
                        "longitude": "105.30110000"
                    },
                    {
                        "id": 65010,
                        "name": "Srŏk Mésang",
                        "latitude": "11.35528000",
                        "longitude": "105.57235000"
                    },
                    {
                        "id": 65016,
                        "name": "Srŏk Preăh Sdéch",
                        "latitude": "11.08690000",
                        "longitude": "105.37497000"
                    }
                ]
            },
            {
                "id": 3977,
                "name": "Pursat",
                "iso2": "15",
                "latitude": "12.27209560",
                "longitude": "103.72891670",
                "type": "province",
                "cities": [
                    {
                        "id": 64936,
                        "name": "Bakan",
                        "latitude": "12.78000000",
                        "longitude": "103.79000000"
                    },
                    {
                        "id": 64959,
                        "name": "Krakor",
                        "latitude": "12.48000000",
                        "longitude": "104.19000000"
                    },
                    {
                        "id": 64973,
                        "name": "Pursat",
                        "latitude": "12.53878000",
                        "longitude": "103.91920000"
                    },
                    {
                        "id": 64975,
                        "name": "Sampov Meas",
                        "latitude": "12.47055000",
                        "longitude": "103.91817000"
                    },
                    {
                        "id": 65007,
                        "name": "Srŏk Kândiĕng",
                        "latitude": "12.71245000",
                        "longitude": "104.02592000"
                    },
                    {
                        "id": 65027,
                        "name": "Srŏk Véal Vêng",
                        "latitude": "12.24230000",
                        "longitude": "103.13444000"
                    }
                ]
            },
            {
                "id": 3990,
                "name": "Ratanakiri",
                "iso2": "16",
                "latitude": "13.85766070",
                "longitude": "107.10119310",
                "type": "province",
                "cities": [
                    {
                        "id": 64937,
                        "name": "Banlung",
                        "latitude": "13.73939000",
                        "longitude": "106.98727000"
                    },
                    {
                        "id": 64966,
                        "name": "Lumphat",
                        "latitude": "13.49146000",
                        "longitude": "106.98022000"
                    },
                    {
                        "id": 65029,
                        "name": "Srŏk Ândong Méas",
                        "latitude": "13.93352000",
                        "longitude": "107.31155000"
                    },
                    {
                        "id": 64993,
                        "name": "Srŏk Bâ Kêv",
                        "latitude": "13.70749000",
                        "longitude": "107.19442000"
                    },
                    {
                        "id": 64987,
                        "name": "Srŏk Ban Lŭng",
                        "latitude": "13.68200000",
                        "longitude": "107.03025000"
                    },
                    {
                        "id": 65004,
                        "name": "Srŏk Koun Mom",
                        "latitude": "13.51772000",
                        "longitude": "106.75142000"
                    },
                    {
                        "id": 65012,
                        "name": "Srŏk Ou Chum",
                        "latitude": "13.84069000",
                        "longitude": "107.03469000"
                    },
                    {
                        "id": 65013,
                        "name": "Srŏk Ou Ya Dav",
                        "latitude": "13.54328000",
                        "longitude": "107.44636000"
                    },
                    {
                        "id": 65024,
                        "name": "Srŏk Ta Vêng",
                        "latitude": "14.29192000",
                        "longitude": "107.24031000"
                    }
                ]
            },
            {
                "id": 3992,
                "name": "Siem Reap",
                "iso2": "17",
                "latitude": "13.33026600",
                "longitude": "104.10013260",
                "type": "province",
                "cities": [
                    {
                        "id": 64979,
                        "name": "Siem Reap",
                        "latitude": "13.36179000",
                        "longitude": "103.86056000"
                    },
                    {
                        "id": 65031,
                        "name": "Srŏk Ângkôr Thum",
                        "latitude": "13.57881000",
                        "longitude": "103.85645000"
                    },
                    {
                        "id": 65015,
                        "name": "Srŏk Prasat Bakong",
                        "latitude": "13.21031000",
                        "longitude": "103.97689000"
                    },
                    {
                        "id": 65035,
                        "name": "Svay Leu",
                        "latitude": "13.69168000",
                        "longitude": "104.27446000"
                    },
                    {
                        "id": 65040,
                        "name": "Varin",
                        "latitude": "13.83574000",
                        "longitude": "103.89968000"
                    }
                ]
            },
            {
                "id": 3989,
                "name": "Sihanoukville",
                "iso2": "18",
                "latitude": "10.75818990",
                "longitude": "103.82162610",
                "type": "province",
                "cities": [
                    {
                        "id": 64980,
                        "name": "Sihanoukville",
                        "latitude": "10.60932000",
                        "longitude": "103.52958000"
                    },
                    {
                        "id": 64985,
                        "name": "Srok Stueng Hav",
                        "latitude": "10.85249000",
                        "longitude": "103.74016000"
                    }
                ]
            },
            {
                "id": 3993,
                "name": "Stung Treng",
                "iso2": "19",
                "latitude": "13.57647300",
                "longitude": "105.96998780",
                "type": "province",
                "cities": [
                    {
                        "id": 65020,
                        "name": "Srŏk Srêsén",
                        "latitude": "13.60530000",
                        "longitude": "106.35819000"
                    },
                    {
                        "id": 65033,
                        "name": "Stueng Traeng",
                        "latitude": "13.65000000",
                        "longitude": "106.07000000"
                    },
                    {
                        "id": 65034,
                        "name": "Stung Treng",
                        "latitude": "13.52586000",
                        "longitude": "105.96830000"
                    }
                ]
            },
            {
                "id": 3972,
                "name": "Svay Rieng",
                "iso2": "20",
                "latitude": "11.14272200",
                "longitude": "105.82902980",
                "type": "province",
                "cities": [
                    {
                        "id": 65021,
                        "name": "Srŏk Svay Chrŭm",
                        "latitude": "11.11160000",
                        "longitude": "105.69814000"
                    },
                    {
                        "id": 65036,
                        "name": "Svay Rieng",
                        "latitude": "11.08785000",
                        "longitude": "105.79935000"
                    }
                ]
            },
            {
                "id": 3975,
                "name": "Takeo",
                "iso2": "21",
                "latitude": "10.93215190",
                "longitude": "104.79877100",
                "type": "province",
                "cities": [
                    {
                        "id": 64963,
                        "name": "Krŏng Doun Kaev",
                        "latitude": "10.99459000",
                        "longitude": "104.79550000"
                    },
                    {
                        "id": 64971,
                        "name": "Phumĭ Véal Srê",
                        "latitude": "10.98081000",
                        "longitude": "104.77828000"
                    },
                    {
                        "id": 65030,
                        "name": "Srŏk Ângkôr Borei",
                        "latitude": "10.99291000",
                        "longitude": "104.95177000"
                    },
                    {
                        "id": 64992,
                        "name": "Srŏk Borei Cholsar",
                        "latitude": "10.81414000",
                        "longitude": "104.98994000"
                    },
                    {
                        "id": 65038,
                        "name": "Takeo",
                        "latitude": "10.99081000",
                        "longitude": "104.78498000"
                    }
                ]
            }
        ]
    },
    {
        "id": 38,
        "name": "Cameroon",
        "iso3": "CMR",
        "iso2": "CM",
        "numeric_code": "120",
        "phonecode": "237",
        "capital": "Yaounde",
        "currency": "XAF",
        "currency_name": "Central African CFA franc",
        "currency_symbol": "FCFA",
        "tld": ".cm",
        "native": "Cameroon",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Middle Africa",
        "subregion_id": 2,
        "nationality": "Cameroonian",
        "timezones": [
            {
                "zoneName": "Africa\/Douala",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "br": "Kameroun",
            "ko": "카메룬",
            "pt-BR": "Camarões",
            "pt": "Camarões",
            "nl": "Kameroen",
            "hr": "Kamerun",
            "fa": "کامرون",
            "de": "Kamerun",
            "es": "Camerún",
            "fr": "Cameroun",
            "ja": "カメルーン",
            "it": "Camerun",
            "zh-CN": "喀麦隆",
            "tr": "Kamerun",
            "ru": "Камерун",
            "uk": "Камерун",
            "pl": "Kamerun"
        },
        "latitude": "6.00000000",
        "longitude": "12.00000000",
        "emoji": "🇨🇲",
        "emojiU": "U+1F1E8 U+1F1F2",
        "states": [
            {
                "id": 2663,
                "name": "Adamawa",
                "iso2": "AD",
                "latitude": "7.08049790",
                "longitude": "10.56638820",
                "type": "region",
                "cities": [
                    {
                        "id": 19148,
                        "name": "Bankim",
                        "latitude": "6.08303000",
                        "longitude": "11.49050000"
                    },
                    {
                        "id": 19150,
                        "name": "Banyo",
                        "latitude": "6.75000000",
                        "longitude": "11.81667000"
                    },
                    {
                        "id": 19162,
                        "name": "Bélel",
                        "latitude": "7.05000000",
                        "longitude": "14.43333000"
                    },
                    {
                        "id": 19168,
                        "name": "Djohong",
                        "latitude": "6.83333000",
                        "longitude": "14.70000000"
                    },
                    {
                        "id": 19187,
                        "name": "Kontcha",
                        "latitude": "7.96667000",
                        "longitude": "12.23333000"
                    },
                    {
                        "id": 19203,
                        "name": "Mayo-Banyo",
                        "latitude": "6.58138000",
                        "longitude": "11.73522000"
                    },
                    {
                        "id": 19218,
                        "name": "Meïganga",
                        "latitude": "6.51667000",
                        "longitude": "14.30000000"
                    },
                    {
                        "id": 19236,
                        "name": "Ngaoundéré",
                        "latitude": "7.32765000",
                        "longitude": "13.58472000"
                    },
                    {
                        "id": 19256,
                        "name": "Somié",
                        "latitude": "6.45843000",
                        "longitude": "11.43299000"
                    },
                    {
                        "id": 19258,
                        "name": "Tibati",
                        "latitude": "6.46504000",
                        "longitude": "12.62843000"
                    },
                    {
                        "id": 19259,
                        "name": "Tignère",
                        "latitude": "7.36667000",
                        "longitude": "12.65000000"
                    },
                    {
                        "id": 19262,
                        "name": "Vina",
                        "latitude": "7.16365000",
                        "longitude": "13.72711000"
                    }
                ]
            },
            {
                "id": 2660,
                "name": "Centre",
                "iso2": "CE",
                "latitude": "4.68268980",
                "longitude": "10.41861010",
                "type": "region",
                "cities": [
                    {
                        "id": 19134,
                        "name": "Akono",
                        "latitude": "3.50000000",
                        "longitude": "11.33333000"
                    },
                    {
                        "id": 19135,
                        "name": "Akonolinga",
                        "latitude": "3.76667000",
                        "longitude": "12.25000000"
                    },
                    {
                        "id": 19139,
                        "name": "Bafia",
                        "latitude": "4.75000000",
                        "longitude": "11.23333000"
                    },
                    {
                        "id": 19174,
                        "name": "Eséka",
                        "latitude": "3.65000000",
                        "longitude": "10.76667000"
                    },
                    {
                        "id": 19173,
                        "name": "Essé",
                        "latitude": "4.10000000",
                        "longitude": "11.90000000"
                    },
                    {
                        "id": 19270,
                        "name": "Évodoula",
                        "latitude": "4.08333000",
                        "longitude": "11.20000000"
                    },
                    {
                        "id": 19208,
                        "name": "Mbalmayo",
                        "latitude": "3.51667000",
                        "longitude": "11.50000000"
                    },
                    {
                        "id": 19209,
                        "name": "Mbam-Et-Inoubou",
                        "latitude": "4.73754000",
                        "longitude": "10.96972000"
                    },
                    {
                        "id": 19210,
                        "name": "Mbandjok",
                        "latitude": "4.45000000",
                        "longitude": "11.90000000"
                    },
                    {
                        "id": 19213,
                        "name": "Mbankomo",
                        "latitude": "3.78333000",
                        "longitude": "11.38333000"
                    },
                    {
                        "id": 19216,
                        "name": "Mefou-et-Akono",
                        "latitude": "3.58706000",
                        "longitude": "11.36089000"
                    },
                    {
                        "id": 19219,
                        "name": "Mfoundi",
                        "latitude": "3.86670000",
                        "longitude": "11.51670000"
                    },
                    {
                        "id": 19221,
                        "name": "Minta",
                        "latitude": "4.58333000",
                        "longitude": "12.80000000"
                    },
                    {
                        "id": 19231,
                        "name": "Nanga Eboko",
                        "latitude": "4.68333000",
                        "longitude": "12.36667000"
                    },
                    {
                        "id": 19233,
                        "name": "Ndikiniméki",
                        "latitude": "4.76667000",
                        "longitude": "10.83333000"
                    },
                    {
                        "id": 19237,
                        "name": "Ngomedzap",
                        "latitude": "3.25000000",
                        "longitude": "11.20000000"
                    },
                    {
                        "id": 19238,
                        "name": "Ngoro",
                        "latitude": "4.95000000",
                        "longitude": "11.38333000"
                    },
                    {
                        "id": 19243,
                        "name": "Nkoteng",
                        "latitude": "4.51667000",
                        "longitude": "12.03333000"
                    },
                    {
                        "id": 19245,
                        "name": "Ntui",
                        "latitude": "4.45000000",
                        "longitude": "11.63333000"
                    },
                    {
                        "id": 19246,
                        "name": "Obala",
                        "latitude": "4.16667000",
                        "longitude": "11.53333000"
                    },
                    {
                        "id": 19247,
                        "name": "Okoa",
                        "latitude": "3.98333000",
                        "longitude": "11.60000000"
                    },
                    {
                        "id": 19248,
                        "name": "Okola",
                        "latitude": "4.01667000",
                        "longitude": "11.38333000"
                    },
                    {
                        "id": 19249,
                        "name": "Ombésa",
                        "latitude": "4.60000000",
                        "longitude": "11.25000000"
                    },
                    {
                        "id": 19254,
                        "name": "Saa",
                        "latitude": "4.36667000",
                        "longitude": "11.45000000"
                    },
                    {
                        "id": 19266,
                        "name": "Yaoundé",
                        "latitude": "3.86667000",
                        "longitude": "11.51667000"
                    },
                    {
                        "id": 19268,
                        "name": "Yoko",
                        "latitude": "5.53333000",
                        "longitude": "12.31667000"
                    }
                ]
            },
            {
                "id": 2661,
                "name": "East",
                "iso2": "ES",
                "latitude": "3.88837370",
                "longitude": "11.70249640",
                "type": "region",
                "cities": [
                    {
                        "id": 19132,
                        "name": "Abong Mbang",
                        "latitude": "3.98333000",
                        "longitude": "13.18333000"
                    },
                    {
                        "id": 19152,
                        "name": "Batouri",
                        "latitude": "4.43333000",
                        "longitude": "14.36667000"
                    },
                    {
                        "id": 19161,
                        "name": "Bélabo",
                        "latitude": "4.93333000",
                        "longitude": "13.30000000"
                    },
                    {
                        "id": 19156,
                        "name": "Bertoua",
                        "latitude": "4.57728000",
                        "longitude": "13.68459000"
                    },
                    {
                        "id": 19163,
                        "name": "Bétaré Oya",
                        "latitude": "5.60000000",
                        "longitude": "14.08333000"
                    },
                    {
                        "id": 19166,
                        "name": "Dimako",
                        "latitude": "4.38333000",
                        "longitude": "13.56667000"
                    },
                    {
                        "id": 19170,
                        "name": "Doumé",
                        "latitude": "4.23333000",
                        "longitude": "13.45000000"
                    },
                    {
                        "id": 19182,
                        "name": "Garoua Boulaï",
                        "latitude": "5.88333000",
                        "longitude": "14.55000000"
                    },
                    {
                        "id": 19211,
                        "name": "Mbang",
                        "latitude": "4.58333000",
                        "longitude": "13.33333000"
                    },
                    {
                        "id": 19232,
                        "name": "Ndelele",
                        "latitude": "4.04065000",
                        "longitude": "14.92501000"
                    },
                    {
                        "id": 19267,
                        "name": "Yokadouma",
                        "latitude": "3.51667000",
                        "longitude": "15.05000000"
                    }
                ]
            },
            {
                "id": 2656,
                "name": "Far North",
                "iso2": "EN",
                "latitude": "11.50735430",
                "longitude": "13.23069190",
                "type": "region",
                "cities": [
                    {
                        "id": 19157,
                        "name": "Bogo",
                        "latitude": "10.73360000",
                        "longitude": "14.60928000"
                    },
                    {
                        "id": 19186,
                        "name": "Kaélé",
                        "latitude": "10.10917000",
                        "longitude": "14.45083000"
                    },
                    {
                        "id": 19189,
                        "name": "Kousséri",
                        "latitude": "12.07689000",
                        "longitude": "15.03063000"
                    },
                    {
                        "id": 19190,
                        "name": "Koza",
                        "latitude": "10.86846000",
                        "longitude": "13.88205000"
                    },
                    {
                        "id": 19199,
                        "name": "Makary",
                        "latitude": "12.57535000",
                        "longitude": "14.45483000"
                    },
                    {
                        "id": 19202,
                        "name": "Maroua",
                        "latitude": "10.59095000",
                        "longitude": "14.31593000"
                    },
                    {
                        "id": 19206,
                        "name": "Mayo-Sava",
                        "latitude": "11.10682000",
                        "longitude": "14.20560000"
                    },
                    {
                        "id": 19207,
                        "name": "Mayo-Tsanaga",
                        "latitude": "10.58221000",
                        "longitude": "13.79351000"
                    },
                    {
                        "id": 19220,
                        "name": "Mindif",
                        "latitude": "10.39757000",
                        "longitude": "14.43626000"
                    },
                    {
                        "id": 19223,
                        "name": "Mokolo",
                        "latitude": "10.74244000",
                        "longitude": "13.80227000"
                    },
                    {
                        "id": 19224,
                        "name": "Mora",
                        "latitude": "11.04611000",
                        "longitude": "14.14011000"
                    },
                    {
                        "id": 19265,
                        "name": "Yagoua",
                        "latitude": "10.34107000",
                        "longitude": "15.23288000"
                    }
                ]
            },
            {
                "id": 2662,
                "name": "Littoral",
                "iso2": "LT",
                "latitude": "4.29449680",
                "longitude": "8.88736580",
                "type": "region",
                "cities": [
                    {
                        "id": 19158,
                        "name": "Bonabéri",
                        "latitude": "4.07142000",
                        "longitude": "9.68177000"
                    },
                    {
                        "id": 19164,
                        "name": "Diang",
                        "latitude": "4.25000000",
                        "longitude": "10.01667000"
                    },
                    {
                        "id": 19165,
                        "name": "Dibombari",
                        "latitude": "4.17870000",
                        "longitude": "9.65610000"
                    },
                    {
                        "id": 19167,
                        "name": "Dizangué",
                        "latitude": "3.76667000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 19169,
                        "name": "Douala",
                        "latitude": "4.04827000",
                        "longitude": "9.70428000"
                    },
                    {
                        "id": 19172,
                        "name": "Edéa",
                        "latitude": "3.80000000",
                        "longitude": "10.13333000"
                    },
                    {
                        "id": 19198,
                        "name": "Loum",
                        "latitude": "4.71820000",
                        "longitude": "9.73510000"
                    },
                    {
                        "id": 19201,
                        "name": "Manjo",
                        "latitude": "4.84280000",
                        "longitude": "9.82170000"
                    },
                    {
                        "id": 19212,
                        "name": "Mbanga",
                        "latitude": "4.50160000",
                        "longitude": "9.56710000"
                    },
                    {
                        "id": 19217,
                        "name": "Melong",
                        "latitude": "5.12181000",
                        "longitude": "9.96143000"
                    },
                    {
                        "id": 19225,
                        "name": "Mouanko",
                        "latitude": "3.63972000",
                        "longitude": "9.77694000"
                    },
                    {
                        "id": 19234,
                        "name": "Ndom",
                        "latitude": "4.49780000",
                        "longitude": "9.56280000"
                    },
                    {
                        "id": 19235,
                        "name": "Ngambé",
                        "latitude": "4.23343000",
                        "longitude": "10.61532000"
                    },
                    {
                        "id": 19242,
                        "name": "Nkongsamba",
                        "latitude": "4.95470000",
                        "longitude": "9.94040000"
                    },
                    {
                        "id": 19250,
                        "name": "Penja",
                        "latitude": "4.63911000",
                        "longitude": "9.67987000"
                    },
                    {
                        "id": 19264,
                        "name": "Yabassi",
                        "latitude": "4.45697000",
                        "longitude": "9.96822000"
                    }
                ]
            },
            {
                "id": 2665,
                "name": "North",
                "iso2": "NO",
                "latitude": "8.63353330",
                "longitude": "11.27783520",
                "type": "region",
                "cities": [
                    {
                        "id": 19176,
                        "name": "Faro Department",
                        "latitude": "8.25014000",
                        "longitude": "12.87829000"
                    },
                    {
                        "id": 19181,
                        "name": "Garoua",
                        "latitude": "9.30143000",
                        "longitude": "13.39771000"
                    },
                    {
                        "id": 19183,
                        "name": "Guider",
                        "latitude": "9.93330000",
                        "longitude": "13.94671000"
                    },
                    {
                        "id": 19194,
                        "name": "Lagdo",
                        "latitude": "9.05828000",
                        "longitude": "13.66605000"
                    },
                    {
                        "id": 19204,
                        "name": "Mayo-Louti",
                        "latitude": "9.96577000",
                        "longitude": "13.72738000"
                    },
                    {
                        "id": 19205,
                        "name": "Mayo-Rey",
                        "latitude": "8.12630000",
                        "longitude": "14.61456000"
                    },
                    {
                        "id": 19251,
                        "name": "Pitoa",
                        "latitude": "9.38390000",
                        "longitude": "13.50231000"
                    },
                    {
                        "id": 19252,
                        "name": "Poli",
                        "latitude": "8.47560000",
                        "longitude": "13.24097000"
                    },
                    {
                        "id": 19253,
                        "name": "Rey Bouba",
                        "latitude": "8.67240000",
                        "longitude": "14.17860000"
                    },
                    {
                        "id": 19257,
                        "name": "Tcholliré",
                        "latitude": "8.40220000",
                        "longitude": "14.16980000"
                    }
                ]
            },
            {
                "id": 2657,
                "name": "Northwest",
                "iso2": "NW",
                "latitude": "6.43305980",
                "longitude": "9.74099250",
                "type": "region",
                "cities": [
                    {
                        "id": 19137,
                        "name": "Babanki",
                        "latitude": "6.11667000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 19141,
                        "name": "Bali",
                        "latitude": "5.88737000",
                        "longitude": "10.01176000"
                    },
                    {
                        "id": 19142,
                        "name": "Bamenda",
                        "latitude": "5.95970000",
                        "longitude": "10.14597000"
                    },
                    {
                        "id": 19151,
                        "name": "Batibo",
                        "latitude": "5.83580000",
                        "longitude": "9.85530000"
                    },
                    {
                        "id": 19155,
                        "name": "Belo",
                        "latitude": "6.13333000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 19159,
                        "name": "Boyo",
                        "latitude": "6.36365000",
                        "longitude": "10.35540000"
                    },
                    {
                        "id": 19180,
                        "name": "Fundong",
                        "latitude": "6.25000000",
                        "longitude": "10.26667000"
                    },
                    {
                        "id": 19185,
                        "name": "Jakiri",
                        "latitude": "6.10000000",
                        "longitude": "10.65000000"
                    },
                    {
                        "id": 19193,
                        "name": "Kumbo",
                        "latitude": "6.20000000",
                        "longitude": "10.66667000"
                    },
                    {
                        "id": 19214,
                        "name": "Mbengwi",
                        "latitude": "6.01667000",
                        "longitude": "10.00000000"
                    },
                    {
                        "id": 19222,
                        "name": "Mme-Bafumen",
                        "latitude": "6.33333000",
                        "longitude": "10.23333000"
                    },
                    {
                        "id": 19241,
                        "name": "Njinikom",
                        "latitude": "6.23333000",
                        "longitude": "10.28333000"
                    },
                    {
                        "id": 19263,
                        "name": "Wum",
                        "latitude": "6.38333000",
                        "longitude": "10.06667000"
                    }
                ]
            },
            {
                "id": 2659,
                "name": "South",
                "iso2": "SU",
                "latitude": "2.92314930",
                "longitude": "9.10689990",
                "type": "region",
                "cities": [
                    {
                        "id": 19133,
                        "name": "Akom II",
                        "latitude": "2.78333000",
                        "longitude": "10.56667000"
                    },
                    {
                        "id": 19136,
                        "name": "Ambam",
                        "latitude": "2.38333000",
                        "longitude": "11.28333000"
                    },
                    {
                        "id": 19269,
                        "name": "Ébolowa",
                        "latitude": "2.90000000",
                        "longitude": "11.15000000"
                    },
                    {
                        "id": 19191,
                        "name": "Kribi",
                        "latitude": "2.93725000",
                        "longitude": "9.90765000"
                    },
                    {
                        "id": 19197,
                        "name": "Lolodorf",
                        "latitude": "3.23333000",
                        "longitude": "10.73333000"
                    },
                    {
                        "id": 19229,
                        "name": "Mvangué",
                        "latitude": "2.96667000",
                        "longitude": "11.51667000"
                    },
                    {
                        "id": 19230,
                        "name": "Mvila",
                        "latitude": "2.79796000",
                        "longitude": "11.39434000"
                    },
                    {
                        "id": 19255,
                        "name": "Sangmélima",
                        "latitude": "2.93333000",
                        "longitude": "11.98333000"
                    }
                ]
            },
            {
                "id": 2658,
                "name": "Southwest",
                "iso2": "SW",
                "latitude": "5.22063960",
                "longitude": "7.98347890",
                "type": "region",
                "cities": [
                    {
                        "id": 19144,
                        "name": "Bamusso",
                        "latitude": "4.45910000",
                        "longitude": "8.90270000"
                    },
                    {
                        "id": 19154,
                        "name": "Bekondo",
                        "latitude": "4.68190000",
                        "longitude": "9.32140000"
                    },
                    {
                        "id": 19160,
                        "name": "Buea",
                        "latitude": "4.15342000",
                        "longitude": "9.24231000"
                    },
                    {
                        "id": 19175,
                        "name": "Fako Division",
                        "latitude": "4.16667000",
                        "longitude": "9.16667000"
                    },
                    {
                        "id": 19177,
                        "name": "Fontem",
                        "latitude": "5.46850000",
                        "longitude": "9.88180000"
                    },
                    {
                        "id": 19192,
                        "name": "Kumba",
                        "latitude": "4.63630000",
                        "longitude": "9.44690000"
                    },
                    {
                        "id": 19195,
                        "name": "Lebialem",
                        "latitude": "5.56043000",
                        "longitude": "9.92316000"
                    },
                    {
                        "id": 19196,
                        "name": "Limbe",
                        "latitude": "4.02356000",
                        "longitude": "9.20607000"
                    },
                    {
                        "id": 19200,
                        "name": "Mamfe",
                        "latitude": "5.75132000",
                        "longitude": "9.31370000"
                    },
                    {
                        "id": 19226,
                        "name": "Mundemba",
                        "latitude": "4.94790000",
                        "longitude": "8.87240000"
                    },
                    {
                        "id": 19227,
                        "name": "Mutengene",
                        "latitude": "4.09130000",
                        "longitude": "9.31440000"
                    },
                    {
                        "id": 19228,
                        "name": "Muyuka",
                        "latitude": "4.28980000",
                        "longitude": "9.41030000"
                    },
                    {
                        "id": 19240,
                        "name": "Nguti",
                        "latitude": "5.32990000",
                        "longitude": "9.41850000"
                    },
                    {
                        "id": 19260,
                        "name": "Tiko",
                        "latitude": "4.07500000",
                        "longitude": "9.36005000"
                    }
                ]
            },
            {
                "id": 2664,
                "name": "West",
                "iso2": "OU",
                "latitude": "37.03649890",
                "longitude": "-95.67059870",
                "type": "region",
                "cities": [
                    {
                        "id": 19138,
                        "name": "Bafang",
                        "latitude": "5.15705000",
                        "longitude": "10.17710000"
                    },
                    {
                        "id": 19140,
                        "name": "Bafoussam",
                        "latitude": "5.47775000",
                        "longitude": "10.41759000"
                    },
                    {
                        "id": 19143,
                        "name": "Bamendjou",
                        "latitude": "5.38988000",
                        "longitude": "10.33014000"
                    },
                    {
                        "id": 19145,
                        "name": "Bana",
                        "latitude": "5.14655000",
                        "longitude": "10.27545000"
                    },
                    {
                        "id": 19146,
                        "name": "Bandjoun",
                        "latitude": "5.37568000",
                        "longitude": "10.41326000"
                    },
                    {
                        "id": 19147,
                        "name": "Bangangté",
                        "latitude": "5.14079000",
                        "longitude": "10.52535000"
                    },
                    {
                        "id": 19149,
                        "name": "Bansoa",
                        "latitude": "5.44836000",
                        "longitude": "10.31355000"
                    },
                    {
                        "id": 19153,
                        "name": "Bazou",
                        "latitude": "5.06001000",
                        "longitude": "10.46751000"
                    },
                    {
                        "id": 19171,
                        "name": "Dschang",
                        "latitude": "5.44397000",
                        "longitude": "10.05332000"
                    },
                    {
                        "id": 19178,
                        "name": "Foumban",
                        "latitude": "5.72662000",
                        "longitude": "10.89865000"
                    },
                    {
                        "id": 19179,
                        "name": "Foumbot",
                        "latitude": "5.50803000",
                        "longitude": "10.63250000"
                    },
                    {
                        "id": 19184,
                        "name": "Hauts-Plateaux",
                        "latitude": "5.29632000",
                        "longitude": "10.34314000"
                    },
                    {
                        "id": 19188,
                        "name": "Koung-Khi",
                        "latitude": "5.33848000",
                        "longitude": "10.47453000"
                    },
                    {
                        "id": 19215,
                        "name": "Mbouda",
                        "latitude": "5.62611000",
                        "longitude": "10.25421000"
                    },
                    {
                        "id": 19239,
                        "name": "Ngou",
                        "latitude": "5.19685000",
                        "longitude": "10.38595000"
                    },
                    {
                        "id": 19244,
                        "name": "Noun",
                        "latitude": "5.64123000",
                        "longitude": "10.91840000"
                    },
                    {
                        "id": 19261,
                        "name": "Tonga",
                        "latitude": "4.96667000",
                        "longitude": "10.70000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 39,
        "name": "Canada",
        "iso3": "CAN",
        "iso2": "CA",
        "numeric_code": "124",
        "phonecode": "1",
        "capital": "Ottawa",
        "currency": "CAD",
        "currency_name": "Canadian dollar",
        "currency_symbol": "$",
        "tld": ".ca",
        "native": "Canada",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Northern America",
        "subregion_id": 6,
        "nationality": "Canadian",
        "timezones": [
            {
                "zoneName": "America\/Atikokan",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America)"
            },
            {
                "zoneName": "America\/Blanc-Sablon",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            },
            {
                "zoneName": "America\/Cambridge_Bay",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Creston",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Dawson",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Dawson_Creek",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Edmonton",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Fort_Nelson",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Glace_Bay",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            },
            {
                "zoneName": "America\/Goose_Bay",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            },
            {
                "zoneName": "America\/Halifax",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            },
            {
                "zoneName": "America\/Inuvik",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Iqaluit",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Moncton",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            },
            {
                "zoneName": "America\/Nipigon",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Pangnirtung",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Rainy_River",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Rankin_Inlet",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Regina",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Resolute",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/St_Johns",
                "gmtOffset": -12600,
                "gmtOffsetName": "UTC-03:30",
                "abbreviation": "NST",
                "tzName": "Newfoundland Standard Time"
            },
            {
                "zoneName": "America\/Swift_Current",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Thunder_Bay",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Toronto",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Vancouver",
                "gmtOffset": -28800,
                "gmtOffsetName": "UTC-08:00",
                "abbreviation": "PST",
                "tzName": "Pacific Standard Time (North America"
            },
            {
                "zoneName": "America\/Whitehorse",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Winnipeg",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Yellowknife",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Kanada",
            "ko": "캐나다",
            "pt-BR": "Canadá",
            "pt": "Canadá",
            "nl": "Canada",
            "hr": "Kanada",
            "fa": "کانادا",
            "de": "Kanada",
            "es": "Canadá",
            "fr": "Canada",
            "ja": "カナダ",
            "it": "Canada",
            "zh-CN": "加拿大",
            "tr": "Kanada",
            "ru": "Канада",
            "uk": "Канада",
            "pl": "Kanada"
        },
        "latitude": "60.00000000",
        "longitude": "-95.00000000",
        "emoji": "🇨🇦",
        "emojiU": "U+1F1E8 U+1F1E6",
        "states": [
            {
                "id": 872,
                "name": "Alberta",
                "iso2": "AB",
                "latitude": "53.93327060",
                "longitude": "-116.57650350",
                "type": "province",
                "cities": [
                    {
                        "id": 16151,
                        "name": "Airdrie",
                        "latitude": "51.30011000",
                        "longitude": "-114.03528000"
                    },
                    {
                        "id": 16178,
                        "name": "Athabasca",
                        "latitude": "54.71687000",
                        "longitude": "-113.28537000"
                    },
                    {
                        "id": 16190,
                        "name": "Banff",
                        "latitude": "51.17622000",
                        "longitude": "-115.56982000"
                    },
                    {
                        "id": 16192,
                        "name": "Barrhead",
                        "latitude": "54.13345000",
                        "longitude": "-114.40211000"
                    },
                    {
                        "id": 16196,
                        "name": "Bassano",
                        "latitude": "50.78342000",
                        "longitude": "-112.46854000"
                    },
                    {
                        "id": 16204,
                        "name": "Beaumont",
                        "latitude": "53.35013000",
                        "longitude": "-113.41871000"
                    },
                    {
                        "id": 16207,
                        "name": "Beaverlodge",
                        "latitude": "55.21664000",
                        "longitude": "-119.43605000"
                    },
                    {
                        "id": 16219,
                        "name": "Black Diamond",
                        "latitude": "50.70011000",
                        "longitude": "-114.23530000"
                    },
                    {
                        "id": 16220,
                        "name": "Blackfalds",
                        "latitude": "52.38342000",
                        "longitude": "-113.78530000"
                    },
                    {
                        "id": 16226,
                        "name": "Bon Accord",
                        "latitude": "53.83345000",
                        "longitude": "-113.41872000"
                    },
                    {
                        "id": 16229,
                        "name": "Bonnyville",
                        "latitude": "54.26684000",
                        "longitude": "-110.73505000"
                    },
                    {
                        "id": 16234,
                        "name": "Bow Island",
                        "latitude": "49.86676000",
                        "longitude": "-111.36843000"
                    },
                    {
                        "id": 16245,
                        "name": "Brooks",
                        "latitude": "50.58341000",
                        "longitude": "-111.88509000"
                    },
                    {
                        "id": 16259,
                        "name": "Calgary",
                        "latitude": "51.05011000",
                        "longitude": "-114.08529000"
                    },
                    {
                        "id": 16260,
                        "name": "Calmar",
                        "latitude": "53.26683000",
                        "longitude": "-113.81874000"
                    },
                    {
                        "id": 16265,
                        "name": "Camrose",
                        "latitude": "53.01684000",
                        "longitude": "-112.83525000"
                    },
                    {
                        "id": 16267,
                        "name": "Canmore",
                        "latitude": "51.08335000",
                        "longitude": "-115.35206000"
                    },
                    {
                        "id": 16277,
                        "name": "Cardston",
                        "latitude": "49.19998000",
                        "longitude": "-113.30190000"
                    },
                    {
                        "id": 16284,
                        "name": "Carstairs",
                        "latitude": "51.56681000",
                        "longitude": "-114.10200000"
                    },
                    {
                        "id": 16305,
                        "name": "Chestermere",
                        "latitude": "51.03341000",
                        "longitude": "-113.81867000"
                    },
                    {
                        "id": 16314,
                        "name": "Claresholm",
                        "latitude": "50.03332000",
                        "longitude": "-113.58524000"
                    },
                    {
                        "id": 16316,
                        "name": "Coaldale",
                        "latitude": "49.71670000",
                        "longitude": "-112.61854000"
                    },
                    {
                        "id": 16317,
                        "name": "Coalhurst",
                        "latitude": "49.74640000",
                        "longitude": "-112.93246000"
                    },
                    {
                        "id": 16320,
                        "name": "Cochrane",
                        "latitude": "51.18341000",
                        "longitude": "-114.46871000"
                    },
                    {
                        "id": 16323,
                        "name": "Cold Lake",
                        "latitude": "54.46525000",
                        "longitude": "-110.18154000"
                    },
                    {
                        "id": 16349,
                        "name": "Crossfield",
                        "latitude": "51.43341000",
                        "longitude": "-114.03528000"
                    },
                    {
                        "id": 16371,
                        "name": "Devon",
                        "latitude": "53.36683000",
                        "longitude": "-113.73533000"
                    },
                    {
                        "id": 16372,
                        "name": "Didsbury",
                        "latitude": "51.66681000",
                        "longitude": "-114.13529000"
                    },
                    {
                        "id": 16383,
                        "name": "Drayton Valley",
                        "latitude": "53.21682000",
                        "longitude": "-114.98544000"
                    },
                    {
                        "id": 16396,
                        "name": "Edmonton",
                        "latitude": "53.55014000",
                        "longitude": "-113.46871000"
                    },
                    {
                        "id": 16398,
                        "name": "Edson",
                        "latitude": "53.58345000",
                        "longitude": "-116.43559000"
                    },
                    {
                        "id": 16399,
                        "name": "Elk Point",
                        "latitude": "53.90017000",
                        "longitude": "-110.90170000"
                    },
                    {
                        "id": 16413,
                        "name": "Fairview",
                        "latitude": "56.06675000",
                        "longitude": "-118.38606000"
                    },
                    {
                        "id": 16415,
                        "name": "Falher",
                        "latitude": "55.73339000",
                        "longitude": "-117.20262000"
                    },
                    {
                        "id": 16429,
                        "name": "Fort Macleod",
                        "latitude": "49.71671000",
                        "longitude": "-113.41857000"
                    },
                    {
                        "id": 16430,
                        "name": "Fort McMurray",
                        "latitude": "56.72676000",
                        "longitude": "-111.38103000"
                    },
                    {
                        "id": 16433,
                        "name": "Fort Saskatchewan",
                        "latitude": "53.71684000",
                        "longitude": "-113.21870000"
                    },
                    {
                        "id": 16438,
                        "name": "Fox Creek",
                        "latitude": "54.40007000",
                        "longitude": "-116.80238000"
                    },
                    {
                        "id": 16450,
                        "name": "Gibbons",
                        "latitude": "53.83345000",
                        "longitude": "-113.33531000"
                    },
                    {
                        "id": 16463,
                        "name": "Grand Centre",
                        "latitude": "54.41628000",
                        "longitude": "-110.21304000"
                    },
                    {
                        "id": 16466,
                        "name": "Grande Cache",
                        "latitude": "53.88335000",
                        "longitude": "-119.13585000"
                    },
                    {
                        "id": 16467,
                        "name": "Grande Prairie",
                        "latitude": "55.16667000",
                        "longitude": "-118.80271000"
                    },
                    {
                        "id": 16476,
                        "name": "Grimshaw",
                        "latitude": "56.18339000",
                        "longitude": "-117.60270000"
                    },
                    {
                        "id": 16488,
                        "name": "Hanna",
                        "latitude": "51.63343000",
                        "longitude": "-111.90181000"
                    },
                    {
                        "id": 16502,
                        "name": "Heritage Pointe",
                        "latitude": "50.84213000",
                        "longitude": "-114.00493000"
                    },
                    {
                        "id": 16503,
                        "name": "High Level",
                        "latitude": "58.51688000",
                        "longitude": "-117.13605000"
                    },
                    {
                        "id": 16504,
                        "name": "High Prairie",
                        "latitude": "55.43340000",
                        "longitude": "-116.48580000"
                    },
                    {
                        "id": 16505,
                        "name": "High River",
                        "latitude": "50.58341000",
                        "longitude": "-113.86867000"
                    },
                    {
                        "id": 16506,
                        "name": "Hinton",
                        "latitude": "53.40009000",
                        "longitude": "-117.58567000"
                    },
                    {
                        "id": 16526,
                        "name": "Irricana",
                        "latitude": "51.32372000",
                        "longitude": "-113.60475000"
                    },
                    {
                        "id": 16528,
                        "name": "Jasper Park Lodge",
                        "latitude": "52.88633000",
                        "longitude": "-118.05625000"
                    },
                    {
                        "id": 16543,
                        "name": "Killam",
                        "latitude": "52.78344000",
                        "longitude": "-111.85175000"
                    },
                    {
                        "id": 16575,
                        "name": "Lac La Biche",
                        "latitude": "54.76690000",
                        "longitude": "-111.96861000"
                    },
                    {
                        "id": 16585,
                        "name": "Lacombe",
                        "latitude": "52.46681000",
                        "longitude": "-113.73530000"
                    },
                    {
                        "id": 16592,
                        "name": "Lamont",
                        "latitude": "53.76686000",
                        "longitude": "-112.80195000"
                    },
                    {
                        "id": 16602,
                        "name": "Larkspur",
                        "latitude": "53.47942000",
                        "longitude": "-113.38142000"
                    },
                    {
                        "id": 16603,
                        "name": "Laurel",
                        "latitude": "53.44667000",
                        "longitude": "-113.38197000"
                    },
                    {
                        "id": 16610,
                        "name": "Leduc",
                        "latitude": "53.26682000",
                        "longitude": "-113.55201000"
                    },
                    {
                        "id": 16614,
                        "name": "Lethbridge",
                        "latitude": "49.69999000",
                        "longitude": "-112.81856000"
                    },
                    {
                        "id": 16625,
                        "name": "Lloydminster",
                        "latitude": "53.27237000",
                        "longitude": "-110.02256000"
                    },
                    {
                        "id": 16645,
                        "name": "Magrath",
                        "latitude": "49.41668000",
                        "longitude": "-112.86856000"
                    },
                    {
                        "id": 16653,
                        "name": "Manning",
                        "latitude": "56.91683000",
                        "longitude": "-117.61945000"
                    },
                    {
                        "id": 16654,
                        "name": "Mannville",
                        "latitude": "53.33764000",
                        "longitude": "-111.17750000"
                    },
                    {
                        "id": 16657,
                        "name": "Maple Ridge",
                        "latitude": "53.50172000",
                        "longitude": "-113.36274000"
                    },
                    {
                        "id": 16671,
                        "name": "Mayerthorpe",
                        "latitude": "53.95015000",
                        "longitude": "-115.13547000"
                    },
                    {
                        "id": 16675,
                        "name": "Medicine Hat",
                        "latitude": "50.03928000",
                        "longitude": "-110.67661000"
                    },
                    {
                        "id": 16689,
                        "name": "Mill Woods Town Centre",
                        "latitude": "53.45639000",
                        "longitude": "-113.42751000"
                    },
                    {
                        "id": 16691,
                        "name": "Millet",
                        "latitude": "53.10013000",
                        "longitude": "-113.46870000"
                    },
                    {
                        "id": 16719,
                        "name": "Morinville",
                        "latitude": "53.80014000",
                        "longitude": "-113.65203000"
                    },
                    {
                        "id": 16729,
                        "name": "Nanton",
                        "latitude": "50.35008000",
                        "longitude": "-113.76866000"
                    },
                    {
                        "id": 16774,
                        "name": "Okotoks",
                        "latitude": "50.72885000",
                        "longitude": "-113.98281000"
                    },
                    {
                        "id": 16775,
                        "name": "Olds",
                        "latitude": "51.78341000",
                        "longitude": "-114.10199000"
                    },
                    {
                        "id": 16803,
                        "name": "Peace River",
                        "latitude": "56.23715000",
                        "longitude": "-117.29176000"
                    },
                    {
                        "id": 16810,
                        "name": "Penhold",
                        "latitude": "52.13342000",
                        "longitude": "-113.86870000"
                    },
                    {
                        "id": 16820,
                        "name": "Picture Butte",
                        "latitude": "49.88330000",
                        "longitude": "-112.78516000"
                    },
                    {
                        "id": 16824,
                        "name": "Pincher Creek",
                        "latitude": "49.48328000",
                        "longitude": "-113.95195000"
                    },
                    {
                        "id": 16834,
                        "name": "Ponoka",
                        "latitude": "52.67680000",
                        "longitude": "-113.58147000"
                    },
                    {
                        "id": 16861,
                        "name": "Provost",
                        "latitude": "52.35014000",
                        "longitude": "-110.26828000"
                    },
                    {
                        "id": 16871,
                        "name": "Raymond",
                        "latitude": "49.44998000",
                        "longitude": "-112.65185000"
                    },
                    {
                        "id": 16873,
                        "name": "Red Deer",
                        "latitude": "52.26682000",
                        "longitude": "-113.80200000"
                    },
                    {
                        "id": 16889,
                        "name": "Rideau Park",
                        "latitude": "53.47899000",
                        "longitude": "-113.50470000"
                    },
                    {
                        "id": 16892,
                        "name": "Rimbey",
                        "latitude": "52.63340000",
                        "longitude": "-114.23532000"
                    },
                    {
                        "id": 16901,
                        "name": "Rocky Mountain House",
                        "latitude": "52.36683000",
                        "longitude": "-114.91880000"
                    },
                    {
                        "id": 17029,
                        "name": "Sexsmith",
                        "latitude": "55.34998000",
                        "longitude": "-118.78602000"
                    },
                    {
                        "id": 17040,
                        "name": "Sherwood Park",
                        "latitude": "53.51684000",
                        "longitude": "-113.31870000"
                    },
                    {
                        "id": 17044,
                        "name": "Silver Berry",
                        "latitude": "53.45787000",
                        "longitude": "-113.38170000"
                    },
                    {
                        "id": 17049,
                        "name": "Slave Lake",
                        "latitude": "55.28344000",
                        "longitude": "-114.76896000"
                    },
                    {
                        "id": 17052,
                        "name": "Smoky Lake",
                        "latitude": "54.11687000",
                        "longitude": "-112.46863000"
                    },
                    {
                        "id": 17061,
                        "name": "Spirit River",
                        "latitude": "55.78327000",
                        "longitude": "-118.83607000"
                    },
                    {
                        "id": 17062,
                        "name": "Springbrook",
                        "latitude": "52.17920000",
                        "longitude": "-113.87981000"
                    },
                    {
                        "id": 17065,
                        "name": "Spruce Grove",
                        "latitude": "53.53344000",
                        "longitude": "-113.91874000"
                    },
                    {
                        "id": 17068,
                        "name": "St. Albert",
                        "latitude": "53.63344000",
                        "longitude": "-113.63533000"
                    },
                    {
                        "id": 17078,
                        "name": "Stettler",
                        "latitude": "52.31683000",
                        "longitude": "-112.71861000"
                    },
                    {
                        "id": 17082,
                        "name": "Stony Plain",
                        "latitude": "53.53343000",
                        "longitude": "-114.00205000"
                    },
                    {
                        "id": 17084,
                        "name": "Strathmore",
                        "latitude": "51.05011000",
                        "longitude": "-113.38523000"
                    },
                    {
                        "id": 17088,
                        "name": "Sundre",
                        "latitude": "51.80010000",
                        "longitude": "-114.63532000"
                    },
                    {
                        "id": 17092,
                        "name": "Swan Hills",
                        "latitude": "54.71681000",
                        "longitude": "-115.40226000"
                    },
                    {
                        "id": 17097,
                        "name": "Sylvan Lake",
                        "latitude": "52.31100000",
                        "longitude": "-114.08375000"
                    },
                    {
                        "id": 17098,
                        "name": "Taber",
                        "latitude": "49.78703000",
                        "longitude": "-112.14603000"
                    },
                    {
                        "id": 17099,
                        "name": "Tamarack",
                        "latitude": "53.46441000",
                        "longitude": "-113.36235000"
                    },
                    {
                        "id": 17110,
                        "name": "Three Hills",
                        "latitude": "51.70012000",
                        "longitude": "-113.26863000"
                    },
                    {
                        "id": 17118,
                        "name": "Tofield",
                        "latitude": "53.36684000",
                        "longitude": "-112.66862000"
                    },
                    {
                        "id": 17131,
                        "name": "Two Hills",
                        "latitude": "53.71686000",
                        "longitude": "-111.75181000"
                    },
                    {
                        "id": 17143,
                        "name": "Valleyview",
                        "latitude": "55.06673000",
                        "longitude": "-117.28585000"
                    },
                    {
                        "id": 17151,
                        "name": "Vegreville",
                        "latitude": "53.50015000",
                        "longitude": "-112.05182000"
                    },
                    {
                        "id": 17154,
                        "name": "Vermilion",
                        "latitude": "53.35409000",
                        "longitude": "-110.85849000"
                    },
                    {
                        "id": 17158,
                        "name": "Viking",
                        "latitude": "53.10014000",
                        "longitude": "-111.76844000"
                    },
                    {
                        "id": 17163,
                        "name": "Vulcan",
                        "latitude": "50.40008000",
                        "longitude": "-113.25189000"
                    },
                    {
                        "id": 17166,
                        "name": "Wainwright",
                        "latitude": "52.83482000",
                        "longitude": "-110.85342000"
                    },
                    {
                        "id": 17187,
                        "name": "Wembley",
                        "latitude": "55.14995000",
                        "longitude": "-119.13602000"
                    },
                    {
                        "id": 17194,
                        "name": "Westlake",
                        "latitude": "55.22228000",
                        "longitude": "-118.80415000"
                    },
                    {
                        "id": 17195,
                        "name": "Westlock",
                        "latitude": "54.15016000",
                        "longitude": "-113.86876000"
                    },
                    {
                        "id": 17197,
                        "name": "Wetaskiwin",
                        "latitude": "52.96683000",
                        "longitude": "-113.36869000"
                    },
                    {
                        "id": 17203,
                        "name": "Whitecourt",
                        "latitude": "54.15015000",
                        "longitude": "-115.68548000"
                    },
                    {
                        "id": 17205,
                        "name": "Wild Rose",
                        "latitude": "53.47080000",
                        "longitude": "-113.38119000"
                    }
                ]
            },
            {
                "id": 875,
                "name": "British Columbia",
                "iso2": "BC",
                "latitude": "53.72666830",
                "longitude": "-127.64762050",
                "type": "province",
                "cities": [
                    {
                        "id": 16146,
                        "name": "Abbotsford",
                        "latitude": "49.05798000",
                        "longitude": "-122.25257000"
                    },
                    {
                        "id": 16150,
                        "name": "Agassiz",
                        "latitude": "49.23298000",
                        "longitude": "-121.76926000"
                    },
                    {
                        "id": 16155,
                        "name": "Aldergrove",
                        "latitude": "49.05801000",
                        "longitude": "-122.47087000"
                    },
                    {
                        "id": 16156,
                        "name": "Aldergrove East",
                        "latitude": "49.05593000",
                        "longitude": "-122.42299000"
                    },
                    {
                        "id": 16169,
                        "name": "Anmore",
                        "latitude": "49.31637000",
                        "longitude": "-122.85263000"
                    },
                    {
                        "id": 16172,
                        "name": "Arbutus Ridge",
                        "latitude": "49.24966000",
                        "longitude": "-123.16934000"
                    },
                    {
                        "id": 16173,
                        "name": "Armstrong",
                        "latitude": "50.44979000",
                        "longitude": "-119.20235000"
                    },
                    {
                        "id": 16176,
                        "name": "Ashcroft",
                        "latitude": "50.72372000",
                        "longitude": "-121.28207000"
                    },
                    {
                        "id": 16194,
                        "name": "Barrière",
                        "latitude": "51.18308000",
                        "longitude": "-120.11920000"
                    },
                    {
                        "id": 16235,
                        "name": "Bowen Island",
                        "latitude": "49.38470000",
                        "longitude": "-123.33622000"
                    },
                    {
                        "id": 16253,
                        "name": "Burnaby",
                        "latitude": "49.26636000",
                        "longitude": "-122.95263000"
                    },
                    {
                        "id": 16254,
                        "name": "Burns Lake",
                        "latitude": "54.22972000",
                        "longitude": "-125.76084000"
                    },
                    {
                        "id": 16257,
                        "name": "Cache Creek",
                        "latitude": "50.81011000",
                        "longitude": "-121.32460000"
                    },
                    {
                        "id": 16263,
                        "name": "Campbell River",
                        "latitude": "50.01634000",
                        "longitude": "-125.24459000"
                    },
                    {
                        "id": 16286,
                        "name": "Castlegar",
                        "latitude": "49.32317000",
                        "longitude": "-117.65831000"
                    },
                    {
                        "id": 16288,
                        "name": "Cedar",
                        "latitude": "49.11633000",
                        "longitude": "-123.85270000"
                    },
                    {
                        "id": 16289,
                        "name": "Central Coast Regional District",
                        "latitude": "52.16638000",
                        "longitude": "-127.00323000"
                    },
                    {
                        "id": 16298,
                        "name": "Chase",
                        "latitude": "50.81650000",
                        "longitude": "-119.68571000"
                    },
                    {
                        "id": 16302,
                        "name": "Chemainus",
                        "latitude": "48.91633000",
                        "longitude": "-123.71937000"
                    },
                    {
                        "id": 16306,
                        "name": "Chetwynd",
                        "latitude": "55.69988000",
                        "longitude": "-121.63627000"
                    },
                    {
                        "id": 16308,
                        "name": "Chilliwack",
                        "latitude": "49.16638000",
                        "longitude": "-121.95257000"
                    },
                    {
                        "id": 16326,
                        "name": "Colwood",
                        "latitude": "48.43293000",
                        "longitude": "-123.48591000"
                    },
                    {
                        "id": 16334,
                        "name": "Coombs",
                        "latitude": "49.29963000",
                        "longitude": "-124.41946000"
                    },
                    {
                        "id": 16335,
                        "name": "Coquitlam",
                        "latitude": "49.28460000",
                        "longitude": "-122.78217000"
                    },
                    {
                        "id": 16341,
                        "name": "Courtenay",
                        "latitude": "49.68657000",
                        "longitude": "-124.99360000"
                    },
                    {
                        "id": 16344,
                        "name": "Cowichan Bay",
                        "latitude": "48.73366000",
                        "longitude": "-123.61739000"
                    },
                    {
                        "id": 16346,
                        "name": "Cranbrook",
                        "latitude": "49.49991000",
                        "longitude": "-115.76879000"
                    },
                    {
                        "id": 16347,
                        "name": "Creston",
                        "latitude": "49.09987000",
                        "longitude": "-116.50211000"
                    },
                    {
                        "id": 16350,
                        "name": "Cumberland",
                        "latitude": "49.61634000",
                        "longitude": "-125.03613000"
                    },
                    {
                        "id": 16359,
                        "name": "Dawson Creek",
                        "latitude": "55.75984000",
                        "longitude": "-120.24030000"
                    },
                    {
                        "id": 16366,
                        "name": "Delta",
                        "latitude": "49.14399000",
                        "longitude": "-122.90680000"
                    },
                    {
                        "id": 16367,
                        "name": "Denman Island",
                        "latitude": "49.53294000",
                        "longitude": "-124.81950000"
                    },
                    {
                        "id": 16368,
                        "name": "Denman Island Trust Area",
                        "latitude": "49.55189000",
                        "longitude": "-124.79881000"
                    },
                    {
                        "id": 16386,
                        "name": "Duck Lake",
                        "latitude": "50.00880000",
                        "longitude": "-119.39672000"
                    },
                    {
                        "id": 16387,
                        "name": "Duncan",
                        "latitude": "48.78293000",
                        "longitude": "-123.70266000"
                    },
                    {
                        "id": 16394,
                        "name": "East Wellington",
                        "latitude": "49.17385000",
                        "longitude": "-124.01745000"
                    },
                    {
                        "id": 16400,
                        "name": "Elkford",
                        "latitude": "50.05007000",
                        "longitude": "-114.88540000"
                    },
                    {
                        "id": 16402,
                        "name": "Ellison",
                        "latitude": "49.93307000",
                        "longitude": "-119.36907000"
                    },
                    {
                        "id": 16404,
                        "name": "Enderby",
                        "latitude": "50.54980000",
                        "longitude": "-119.15234000"
                    },
                    {
                        "id": 16414,
                        "name": "Fairwinds",
                        "latitude": "49.27588000",
                        "longitude": "-124.12782000"
                    },
                    {
                        "id": 16421,
                        "name": "Fernie",
                        "latitude": "49.49996000",
                        "longitude": "-115.06871000"
                    },
                    {
                        "id": 16432,
                        "name": "Fort Nelson",
                        "latitude": "58.80533000",
                        "longitude": "-122.70020000"
                    },
                    {
                        "id": 16435,
                        "name": "Fort St. John",
                        "latitude": "56.24988000",
                        "longitude": "-120.85292000"
                    },
                    {
                        "id": 16440,
                        "name": "Fraser Valley Regional District",
                        "latitude": "49.58299000",
                        "longitude": "-121.83587000"
                    },
                    {
                        "id": 16442,
                        "name": "French Creek",
                        "latitude": "49.34123000",
                        "longitude": "-124.35541000"
                    },
                    {
                        "id": 16443,
                        "name": "Fruitvale",
                        "latitude": "49.11654000",
                        "longitude": "-117.55222000"
                    },
                    {
                        "id": 16451,
                        "name": "Gibsons",
                        "latitude": "49.39539000",
                        "longitude": "-123.50555000"
                    },
                    {
                        "id": 16458,
                        "name": "Golden",
                        "latitude": "51.29995000",
                        "longitude": "-116.96890000"
                    },
                    {
                        "id": 16465,
                        "name": "Grand Forks",
                        "latitude": "49.03309000",
                        "longitude": "-118.43560000"
                    },
                    {
                        "id": 16487,
                        "name": "Hanceville",
                        "latitude": "51.91922000",
                        "longitude": "-123.04458000"
                    },
                    {
                        "id": 16507,
                        "name": "Hope",
                        "latitude": "49.38299000",
                        "longitude": "-121.44144000"
                    },
                    {
                        "id": 16508,
                        "name": "Hornby Island",
                        "latitude": "49.53448000",
                        "longitude": "-124.66923000"
                    },
                    {
                        "id": 16510,
                        "name": "Houston",
                        "latitude": "54.39976000",
                        "longitude": "-126.67008000"
                    },
                    {
                        "id": 16523,
                        "name": "Invermere",
                        "latitude": "50.51666000",
                        "longitude": "-116.03538000"
                    },
                    {
                        "id": 16531,
                        "name": "Kamloops",
                        "latitude": "50.66648000",
                        "longitude": "-120.31920000"
                    },
                    {
                        "id": 16536,
                        "name": "Kelowna",
                        "latitude": "49.88307000",
                        "longitude": "-119.48568000"
                    },
                    {
                        "id": 16545,
                        "name": "Kimberley",
                        "latitude": "49.67071000",
                        "longitude": "-115.97760000"
                    },
                    {
                        "id": 16554,
                        "name": "Kitimat",
                        "latitude": "54.05244000",
                        "longitude": "-128.65342000"
                    },
                    {
                        "id": 16586,
                        "name": "Ladner",
                        "latitude": "49.08938000",
                        "longitude": "-123.08241000"
                    },
                    {
                        "id": 16587,
                        "name": "Ladysmith",
                        "latitude": "48.99016000",
                        "longitude": "-123.81699000"
                    },
                    {
                        "id": 16588,
                        "name": "Lake Cowichan",
                        "latitude": "48.82495000",
                        "longitude": "-124.05461000"
                    },
                    {
                        "id": 16595,
                        "name": "Langford",
                        "latitude": "48.44963000",
                        "longitude": "-123.50261000"
                    },
                    {
                        "id": 16597,
                        "name": "Langley",
                        "latitude": "49.10107000",
                        "longitude": "-122.65883000"
                    },
                    {
                        "id": 16616,
                        "name": "Lillooet",
                        "latitude": "50.68560000",
                        "longitude": "-121.94200000"
                    },
                    {
                        "id": 16621,
                        "name": "Lions Bay",
                        "latitude": "49.45218000",
                        "longitude": "-123.23760000"
                    },
                    {
                        "id": 16626,
                        "name": "Logan Lake",
                        "latitude": "50.49976000",
                        "longitude": "-120.80253000"
                    },
                    {
                        "id": 16635,
                        "name": "Lumby",
                        "latitude": "50.24979000",
                        "longitude": "-118.96904000"
                    },
                    {
                        "id": 16641,
                        "name": "Mackenzie",
                        "latitude": "55.33637000",
                        "longitude": "-123.09374000"
                    },
                    {
                        "id": 16656,
                        "name": "Maple Ridge",
                        "latitude": "49.21939000",
                        "longitude": "-122.60193000"
                    },
                    {
                        "id": 16681,
                        "name": "Merritt",
                        "latitude": "50.11225000",
                        "longitude": "-120.79420000"
                    },
                    {
                        "id": 16684,
                        "name": "Metchosin",
                        "latitude": "48.38293000",
                        "longitude": "-123.53591000"
                    },
                    {
                        "id": 16685,
                        "name": "Metro Vancouver Regional District",
                        "latitude": "49.33296000",
                        "longitude": "-123.00264000"
                    },
                    {
                        "id": 16696,
                        "name": "Mission",
                        "latitude": "49.13298000",
                        "longitude": "-122.30258000"
                    },
                    {
                        "id": 16727,
                        "name": "Nakusp",
                        "latitude": "50.24987000",
                        "longitude": "-117.80226000"
                    },
                    {
                        "id": 16728,
                        "name": "Nanaimo",
                        "latitude": "49.16638000",
                        "longitude": "-123.94003000"
                    },
                    {
                        "id": 16735,
                        "name": "Nelson",
                        "latitude": "49.49985000",
                        "longitude": "-117.28553000"
                    },
                    {
                        "id": 16742,
                        "name": "New Westminster",
                        "latitude": "49.20678000",
                        "longitude": "-122.91092000"
                    },
                    {
                        "id": 16757,
                        "name": "North Cowichan",
                        "latitude": "48.84133000",
                        "longitude": "-123.68596000"
                    },
                    {
                        "id": 16758,
                        "name": "North Oyster\/Yellow Point",
                        "latitude": "49.04807000",
                        "longitude": "-123.83395000"
                    },
                    {
                        "id": 16760,
                        "name": "North Saanich",
                        "latitude": "48.66634000",
                        "longitude": "-123.41933000"
                    },
                    {
                        "id": 16761,
                        "name": "North Vancouver",
                        "latitude": "49.31636000",
                        "longitude": "-123.06934000"
                    },
                    {
                        "id": 16769,
                        "name": "Oak Bay",
                        "latitude": "48.44964000",
                        "longitude": "-123.30260000"
                    },
                    {
                        "id": 16772,
                        "name": "Okanagan",
                        "latitude": "50.36386000",
                        "longitude": "-119.34997000"
                    },
                    {
                        "id": 16773,
                        "name": "Okanagan Falls",
                        "latitude": "49.35000000",
                        "longitude": "-119.56667000"
                    },
                    {
                        "id": 16776,
                        "name": "Oliver",
                        "latitude": "49.18306000",
                        "longitude": "-119.55240000"
                    },
                    {
                        "id": 16784,
                        "name": "Osoyoos",
                        "latitude": "49.03306000",
                        "longitude": "-119.45237000"
                    },
                    {
                        "id": 16798,
                        "name": "Parksville",
                        "latitude": "49.31947000",
                        "longitude": "-124.31575000"
                    },
                    {
                        "id": 16804,
                        "name": "Peace River Regional District",
                        "latitude": "56.66650000",
                        "longitude": "-122.75302000"
                    },
                    {
                        "id": 16805,
                        "name": "Peachland",
                        "latitude": "49.76647000",
                        "longitude": "-119.73568000"
                    },
                    {
                        "id": 16808,
                        "name": "Pemberton",
                        "latitude": "50.31641000",
                        "longitude": "-122.80273000"
                    },
                    {
                        "id": 16811,
                        "name": "Penticton",
                        "latitude": "49.48062000",
                        "longitude": "-119.58584000"
                    },
                    {
                        "id": 16826,
                        "name": "Pitt Meadows",
                        "latitude": "49.22119000",
                        "longitude": "-122.68965000"
                    },
                    {
                        "id": 16837,
                        "name": "Port Alberni",
                        "latitude": "49.24133000",
                        "longitude": "-124.80280000"
                    },
                    {
                        "id": 16839,
                        "name": "Port Coquitlam",
                        "latitude": "49.26637000",
                        "longitude": "-122.76932000"
                    },
                    {
                        "id": 16842,
                        "name": "Port McNeill",
                        "latitude": "50.58716000",
                        "longitude": "-127.08053000"
                    },
                    {
                        "id": 16843,
                        "name": "Port Moody",
                        "latitude": "49.28124000",
                        "longitude": "-122.82457000"
                    },
                    {
                        "id": 16851,
                        "name": "Powell River",
                        "latitude": "49.83278000",
                        "longitude": "-124.52368000"
                    },
                    {
                        "id": 16856,
                        "name": "Prince George",
                        "latitude": "53.91660000",
                        "longitude": "-122.75301000"
                    },
                    {
                        "id": 16857,
                        "name": "Prince Rupert",
                        "latitude": "54.31507000",
                        "longitude": "-130.32098000"
                    },
                    {
                        "id": 16858,
                        "name": "Princeton",
                        "latitude": "49.45802000",
                        "longitude": "-120.51076000"
                    },
                    {
                        "id": 16863,
                        "name": "Puntledge",
                        "latitude": "49.66168000",
                        "longitude": "-125.05686000"
                    },
                    {
                        "id": 16865,
                        "name": "Quesnel",
                        "latitude": "52.97842000",
                        "longitude": "-122.49310000"
                    },
                    {
                        "id": 16877,
                        "name": "Regional District of Alberni-Clayoquot",
                        "latitude": "49.24962000",
                        "longitude": "-125.33615000"
                    },
                    {
                        "id": 16878,
                        "name": "Regional District of Central Okanagan",
                        "latitude": "49.99978000",
                        "longitude": "-119.41908000"
                    },
                    {
                        "id": 16882,
                        "name": "Revelstoke",
                        "latitude": "50.99712000",
                        "longitude": "-118.19530000"
                    },
                    {
                        "id": 16885,
                        "name": "Richmond",
                        "latitude": "49.17003000",
                        "longitude": "-123.13683000"
                    },
                    {
                        "id": 16904,
                        "name": "Rossland",
                        "latitude": "49.08313000",
                        "longitude": "-117.80224000"
                    },
                    {
                        "id": 16908,
                        "name": "Royston",
                        "latitude": "49.64703000",
                        "longitude": "-124.94670000"
                    },
                    {
                        "id": 17016,
                        "name": "Salmo",
                        "latitude": "49.19986000",
                        "longitude": "-117.26890000"
                    },
                    {
                        "id": 17017,
                        "name": "Salmon Arm",
                        "latitude": "50.69980000",
                        "longitude": "-119.30237000"
                    },
                    {
                        "id": 17018,
                        "name": "Salt Spring Island",
                        "latitude": "48.81852000",
                        "longitude": "-123.49061000"
                    },
                    {
                        "id": 17019,
                        "name": "Saltair",
                        "latitude": "48.94963000",
                        "longitude": "-123.76939000"
                    },
                    {
                        "id": 17025,
                        "name": "Sechelt",
                        "latitude": "49.47512000",
                        "longitude": "-123.75903000"
                    },
                    {
                        "id": 17043,
                        "name": "Sicamous",
                        "latitude": "50.83312000",
                        "longitude": "-118.98565000"
                    },
                    {
                        "id": 17047,
                        "name": "Six Mile",
                        "latitude": "48.45767000",
                        "longitude": "-123.46088000"
                    },
                    {
                        "id": 17050,
                        "name": "Smithers",
                        "latitude": "54.78036000",
                        "longitude": "-127.17428000"
                    },
                    {
                        "id": 17053,
                        "name": "Sooke",
                        "latitude": "48.37463000",
                        "longitude": "-123.72762000"
                    },
                    {
                        "id": 17058,
                        "name": "South Pender Harbour",
                        "latitude": "49.62202000",
                        "longitude": "-124.02484000"
                    },
                    {
                        "id": 17060,
                        "name": "Sparwood",
                        "latitude": "49.73332000",
                        "longitude": "-114.88532000"
                    },
                    {
                        "id": 17086,
                        "name": "Summerland",
                        "latitude": "49.59977000",
                        "longitude": "-119.66911000"
                    },
                    {
                        "id": 17089,
                        "name": "Surrey",
                        "latitude": "49.10635000",
                        "longitude": "-122.82509000"
                    },
                    {
                        "id": 17102,
                        "name": "Terrace",
                        "latitude": "54.51634000",
                        "longitude": "-128.60345000"
                    },
                    {
                        "id": 17119,
                        "name": "Tofino",
                        "latitude": "49.15314000",
                        "longitude": "-125.90744000"
                    },
                    {
                        "id": 17125,
                        "name": "Trail",
                        "latitude": "49.09983000",
                        "longitude": "-117.70223000"
                    },
                    {
                        "id": 17128,
                        "name": "Tsawwassen",
                        "latitude": "49.01667000",
                        "longitude": "-123.08333000"
                    },
                    {
                        "id": 17129,
                        "name": "Tumbler Ridge",
                        "latitude": "55.13027000",
                        "longitude": "-120.99415000"
                    },
                    {
                        "id": 17133,
                        "name": "Ucluelet",
                        "latitude": "48.94153000",
                        "longitude": "-125.54635000"
                    },
                    {
                        "id": 17145,
                        "name": "Vancouver",
                        "latitude": "49.24966000",
                        "longitude": "-123.11934000"
                    },
                    {
                        "id": 17146,
                        "name": "Vanderhoof",
                        "latitude": "54.01657000",
                        "longitude": "-124.01982000"
                    },
                    {
                        "id": 17155,
                        "name": "Vernon",
                        "latitude": "50.26729000",
                        "longitude": "-119.27337000"
                    },
                    {
                        "id": 17156,
                        "name": "Victoria",
                        "latitude": "48.43590000",
                        "longitude": "-123.35155000"
                    },
                    {
                        "id": 17168,
                        "name": "Walnut Grove",
                        "latitude": "49.16473000",
                        "longitude": "-122.64042000"
                    },
                    {
                        "id": 17183,
                        "name": "Welcome Beach",
                        "latitude": "49.47959000",
                        "longitude": "-123.89239000"
                    },
                    {
                        "id": 17189,
                        "name": "West End",
                        "latitude": "49.28333000",
                        "longitude": "-123.13333000"
                    },
                    {
                        "id": 17190,
                        "name": "West Kelowna",
                        "latitude": "49.86250000",
                        "longitude": "-119.58333000"
                    },
                    {
                        "id": 17193,
                        "name": "West Vancouver",
                        "latitude": "49.36672000",
                        "longitude": "-123.16652000"
                    },
                    {
                        "id": 17200,
                        "name": "Whistler",
                        "latitude": "50.11817000",
                        "longitude": "-122.95396000"
                    },
                    {
                        "id": 17202,
                        "name": "White Rock",
                        "latitude": "49.01636000",
                        "longitude": "-122.80260000"
                    },
                    {
                        "id": 17207,
                        "name": "Williams Lake",
                        "latitude": "52.14153000",
                        "longitude": "-122.14451000"
                    }
                ]
            },
            {
                "id": 867,
                "name": "Manitoba",
                "iso2": "MB",
                "latitude": "53.76086080",
                "longitude": "-98.81387620",
                "type": "province",
                "cities": [
                    {
                        "id": 16160,
                        "name": "Altona",
                        "latitude": "49.10469000",
                        "longitude": "-97.55961000"
                    },
                    {
                        "id": 16206,
                        "name": "Beausejour",
                        "latitude": "50.06220000",
                        "longitude": "-96.51669000"
                    },
                    {
                        "id": 16225,
                        "name": "Boissevain",
                        "latitude": "49.23062000",
                        "longitude": "-100.05586000"
                    },
                    {
                        "id": 16238,
                        "name": "Brandon",
                        "latitude": "49.84692000",
                        "longitude": "-99.95306000"
                    },
                    {
                        "id": 16275,
                        "name": "Carberry",
                        "latitude": "49.86893000",
                        "longitude": "-99.36021000"
                    },
                    {
                        "id": 16283,
                        "name": "Carman",
                        "latitude": "49.49920000",
                        "longitude": "-98.00156000"
                    },
                    {
                        "id": 16348,
                        "name": "Cross Lake 19A",
                        "latitude": "54.65135000",
                        "longitude": "-97.76848000"
                    },
                    {
                        "id": 16356,
                        "name": "Dauphin",
                        "latitude": "51.14941000",
                        "longitude": "-100.05023000"
                    },
                    {
                        "id": 16360,
                        "name": "De Salaberry",
                        "latitude": "49.39999000",
                        "longitude": "-97.00894000"
                    },
                    {
                        "id": 16364,
                        "name": "Deloraine",
                        "latitude": "49.19082000",
                        "longitude": "-100.49477000"
                    },
                    {
                        "id": 16422,
                        "name": "Flin Flon",
                        "latitude": "54.76703000",
                        "longitude": "-101.87433000"
                    },
                    {
                        "id": 16452,
                        "name": "Gimli",
                        "latitude": "50.63362000",
                        "longitude": "-96.99066000"
                    },
                    {
                        "id": 16477,
                        "name": "Grunthal",
                        "latitude": "49.40668000",
                        "longitude": "-96.85873000"
                    },
                    {
                        "id": 16500,
                        "name": "Headingley",
                        "latitude": "49.87530000",
                        "longitude": "-97.40896000"
                    },
                    {
                        "id": 16518,
                        "name": "Ile des Chênes",
                        "latitude": "49.71060000",
                        "longitude": "-96.98893000"
                    },
                    {
                        "id": 16544,
                        "name": "Killarney",
                        "latitude": "49.18332000",
                        "longitude": "-99.66364000"
                    },
                    {
                        "id": 16563,
                        "name": "La Broquerie",
                        "latitude": "49.51688000",
                        "longitude": "-96.50029000"
                    },
                    {
                        "id": 16576,
                        "name": "Lac du Bonnet",
                        "latitude": "50.25360000",
                        "longitude": "-96.06116000"
                    },
                    {
                        "id": 16593,
                        "name": "Landmark",
                        "latitude": "49.67169000",
                        "longitude": "-96.82232000"
                    },
                    {
                        "id": 16629,
                        "name": "Lorette",
                        "latitude": "49.73919000",
                        "longitude": "-96.87232000"
                    },
                    {
                        "id": 16677,
                        "name": "Melita",
                        "latitude": "49.26811000",
                        "longitude": "-100.99669000"
                    },
                    {
                        "id": 16693,
                        "name": "Minnedosa",
                        "latitude": "50.24532000",
                        "longitude": "-99.84364000"
                    },
                    {
                        "id": 16714,
                        "name": "Moose Lake",
                        "latitude": "49.20559000",
                        "longitude": "-95.30629000"
                    },
                    {
                        "id": 16717,
                        "name": "Morden",
                        "latitude": "49.19190000",
                        "longitude": "-98.10136000"
                    },
                    {
                        "id": 16720,
                        "name": "Morris",
                        "latitude": "49.35499000",
                        "longitude": "-97.36567000"
                    },
                    {
                        "id": 16734,
                        "name": "Neepawa",
                        "latitude": "50.22892000",
                        "longitude": "-99.46642000"
                    },
                    {
                        "id": 16749,
                        "name": "Niverville",
                        "latitude": "49.60559000",
                        "longitude": "-97.04234000"
                    },
                    {
                        "id": 16848,
                        "name": "Portage la Prairie",
                        "latitude": "49.97282000",
                        "longitude": "-98.29263000"
                    },
                    {
                        "id": 16894,
                        "name": "Rivers",
                        "latitude": "50.03081000",
                        "longitude": "-100.24029000"
                    },
                    {
                        "id": 16898,
                        "name": "Roblin",
                        "latitude": "51.22999000",
                        "longitude": "-101.35650000"
                    },
                    {
                        "id": 17026,
                        "name": "Selkirk",
                        "latitude": "50.14360000",
                        "longitude": "-96.88452000"
                    },
                    {
                        "id": 17041,
                        "name": "Shilo",
                        "latitude": "49.80509000",
                        "longitude": "-99.63175000"
                    },
                    {
                        "id": 17056,
                        "name": "Souris",
                        "latitude": "49.61720000",
                        "longitude": "-100.26120000"
                    },
                    {
                        "id": 17067,
                        "name": "St. Adolphe",
                        "latitude": "49.67440000",
                        "longitude": "-97.11124000"
                    },
                    {
                        "id": 17075,
                        "name": "Steinbach",
                        "latitude": "49.52579000",
                        "longitude": "-96.68451000"
                    },
                    {
                        "id": 17080,
                        "name": "Stonewall",
                        "latitude": "50.13441000",
                        "longitude": "-97.32676000"
                    },
                    {
                        "id": 17093,
                        "name": "Swan River",
                        "latitude": "52.10580000",
                        "longitude": "-101.26759000"
                    },
                    {
                        "id": 17105,
                        "name": "The Pas",
                        "latitude": "53.82509000",
                        "longitude": "-101.25413000"
                    },
                    {
                        "id": 17108,
                        "name": "Thompson",
                        "latitude": "55.74350000",
                        "longitude": "-97.85579000"
                    },
                    {
                        "id": 17161,
                        "name": "Virden",
                        "latitude": "49.85080000",
                        "longitude": "-100.93262000"
                    },
                    {
                        "id": 17192,
                        "name": "West St. Paul",
                        "latitude": "49.99940000",
                        "longitude": "-97.16284000"
                    },
                    {
                        "id": 17214,
                        "name": "Winkler",
                        "latitude": "49.18170000",
                        "longitude": "-97.94104000"
                    },
                    {
                        "id": 17215,
                        "name": "Winnipeg",
                        "latitude": "49.88440000",
                        "longitude": "-97.14704000"
                    }
                ]
            },
            {
                "id": 868,
                "name": "New Brunswick",
                "iso2": "NB",
                "latitude": "46.56531630",
                "longitude": "-66.46191640",
                "type": "province",
                "cities": [
                    {
                        "id": 16184,
                        "name": "Baie Ste. Anne",
                        "latitude": "47.05231000",
                        "longitude": "-64.95355000"
                    },
                    {
                        "id": 16198,
                        "name": "Bathurst",
                        "latitude": "47.61814000",
                        "longitude": "-65.65112000"
                    },
                    {
                        "id": 16232,
                        "name": "Bouctouche",
                        "latitude": "46.46844000",
                        "longitude": "-64.73905000"
                    },
                    {
                        "id": 16264,
                        "name": "Campbellton",
                        "latitude": "48.00751000",
                        "longitude": "-66.67272000"
                    },
                    {
                        "id": 16373,
                        "name": "Dieppe",
                        "latitude": "46.07844000",
                        "longitude": "-64.68735000"
                    },
                    {
                        "id": 16397,
                        "name": "Edmundston",
                        "latitude": "47.37370000",
                        "longitude": "-68.32512000"
                    },
                    {
                        "id": 16423,
                        "name": "Florenceville-Bristol",
                        "latitude": "46.44353000",
                        "longitude": "-67.61536000"
                    },
                    {
                        "id": 16441,
                        "name": "Fredericton",
                        "latitude": "45.94541000",
                        "longitude": "-66.66558000"
                    },
                    {
                        "id": 16444,
                        "name": "Fundy Bay",
                        "latitude": "44.74100000",
                        "longitude": "-66.76041000"
                    },
                    {
                        "id": 16468,
                        "name": "Grande-Digue",
                        "latitude": "46.30014000",
                        "longitude": "-64.56546000"
                    },
                    {
                        "id": 16471,
                        "name": "Greater Lakeburn",
                        "latitude": "46.07651000",
                        "longitude": "-64.66818000"
                    },
                    {
                        "id": 16486,
                        "name": "Hampton",
                        "latitude": "45.52876000",
                        "longitude": "-65.85354000"
                    },
                    {
                        "id": 16493,
                        "name": "Harrison Brook",
                        "latitude": "47.21304000",
                        "longitude": "-67.92847000"
                    },
                    {
                        "id": 16542,
                        "name": "Keswick Ridge",
                        "latitude": "46.00011000",
                        "longitude": "-66.88218000"
                    },
                    {
                        "id": 16618,
                        "name": "Lincoln",
                        "latitude": "45.90012000",
                        "longitude": "-66.58218000"
                    },
                    {
                        "id": 16638,
                        "name": "Lutes Mountain",
                        "latitude": "46.13544000",
                        "longitude": "-64.90504000"
                    },
                    {
                        "id": 16672,
                        "name": "McEwen",
                        "latitude": "46.14520000",
                        "longitude": "-64.78615000"
                    },
                    {
                        "id": 16695,
                        "name": "Miramichi",
                        "latitude": "47.02895000",
                        "longitude": "-65.50186000"
                    },
                    {
                        "id": 16700,
                        "name": "Moncton",
                        "latitude": "46.09454000",
                        "longitude": "-64.79650000"
                    },
                    {
                        "id": 16726,
                        "name": "Nackawic",
                        "latitude": "45.99666000",
                        "longitude": "-67.24028000"
                    },
                    {
                        "id": 16741,
                        "name": "New Maryland",
                        "latitude": "45.87932000",
                        "longitude": "-66.66828000"
                    },
                    {
                        "id": 16750,
                        "name": "Noonan",
                        "latitude": "45.96682000",
                        "longitude": "-66.53218000"
                    },
                    {
                        "id": 16781,
                        "name": "Oromocto",
                        "latitude": "45.83512000",
                        "longitude": "-66.47917000"
                    },
                    {
                        "id": 16884,
                        "name": "Richibucto",
                        "latitude": "46.68073000",
                        "longitude": "-64.88044000"
                    },
                    {
                        "id": 16910,
                        "name": "Sackville",
                        "latitude": "45.91875000",
                        "longitude": "-64.38455000"
                    },
                    {
                        "id": 16913,
                        "name": "Saint Andrews",
                        "latitude": "45.07370000",
                        "longitude": "-67.05312000"
                    },
                    {
                        "id": 16914,
                        "name": "Saint John",
                        "latitude": "45.27271000",
                        "longitude": "-66.06766000"
                    },
                    {
                        "id": 16921,
                        "name": "Saint-Antoine",
                        "latitude": "46.36294000",
                        "longitude": "-64.74985000"
                    },
                    {
                        "id": 16967,
                        "name": "Saint-Léonard",
                        "latitude": "47.16317000",
                        "longitude": "-67.92460000"
                    },
                    {
                        "id": 17014,
                        "name": "Salisbury",
                        "latitude": "46.03905000",
                        "longitude": "-65.04628000"
                    },
                    {
                        "id": 17034,
                        "name": "Shediac",
                        "latitude": "46.21981000",
                        "longitude": "-64.54107000"
                    },
                    {
                        "id": 17035,
                        "name": "Shediac Bridge-Shediac River",
                        "latitude": "46.26886000",
                        "longitude": "-64.60047000"
                    },
                    {
                        "id": 17042,
                        "name": "Shippagan",
                        "latitude": "47.74424000",
                        "longitude": "-64.70804000"
                    },
                    {
                        "id": 17074,
                        "name": "Starlight Village",
                        "latitude": "45.88308000",
                        "longitude": "-66.76905000"
                    },
                    {
                        "id": 17090,
                        "name": "Sussex",
                        "latitude": "45.72266000",
                        "longitude": "-65.50663000"
                    },
                    {
                        "id": 17124,
                        "name": "Tracadie-Sheila",
                        "latitude": "47.51444000",
                        "longitude": "-64.91806000"
                    },
                    {
                        "id": 17186,
                        "name": "Wells",
                        "latitude": "45.39274000",
                        "longitude": "-65.92313000"
                    }
                ]
            },
            {
                "id": 877,
                "name": "Newfoundland and Labrador",
                "iso2": "NL",
                "latitude": "53.13550910",
                "longitude": "-57.66043640",
                "type": "province",
                "cities": [
                    {
                        "id": 16199,
                        "name": "Bay Roberts",
                        "latitude": "47.59989000",
                        "longitude": "-53.26478000"
                    },
                    {
                        "id": 16200,
                        "name": "Bay St. George South",
                        "latitude": "48.22781000",
                        "longitude": "-58.84162000"
                    },
                    {
                        "id": 16228,
                        "name": "Bonavista",
                        "latitude": "48.64989000",
                        "longitude": "-53.11474000"
                    },
                    {
                        "id": 16230,
                        "name": "Botwood",
                        "latitude": "49.14994000",
                        "longitude": "-55.34819000"
                    },
                    {
                        "id": 16251,
                        "name": "Burgeo",
                        "latitude": "47.61668000",
                        "longitude": "-57.61516000"
                    },
                    {
                        "id": 16276,
                        "name": "Carbonear",
                        "latitude": "47.73319000",
                        "longitude": "-53.21478000"
                    },
                    {
                        "id": 16287,
                        "name": "Catalina",
                        "latitude": "48.51659000",
                        "longitude": "-53.08135000"
                    },
                    {
                        "id": 16294,
                        "name": "Channel-Port aux Basques",
                        "latitude": "47.57286000",
                        "longitude": "-59.13808000"
                    },
                    {
                        "id": 16313,
                        "name": "Clarenville-Shoal Harbour",
                        "latitude": "48.18050000",
                        "longitude": "-53.96982000"
                    },
                    {
                        "id": 16327,
                        "name": "Conception Bay South",
                        "latitude": "47.49989000",
                        "longitude": "-52.99806000"
                    },
                    {
                        "id": 16336,
                        "name": "Corner Brook",
                        "latitude": "48.95001000",
                        "longitude": "-57.95202000"
                    },
                    {
                        "id": 16362,
                        "name": "Deer Lake",
                        "latitude": "49.16671000",
                        "longitude": "-57.43163000"
                    },
                    {
                        "id": 16425,
                        "name": "Fogo Island",
                        "latitude": "49.71649000",
                        "longitude": "-54.16981000"
                    },
                    {
                        "id": 16445,
                        "name": "Gambo",
                        "latitude": "48.78320000",
                        "longitude": "-54.21482000"
                    },
                    {
                        "id": 16460,
                        "name": "Goulds",
                        "latitude": "47.45532000",
                        "longitude": "-52.77552000"
                    },
                    {
                        "id": 16462,
                        "name": "Grand Bank",
                        "latitude": "47.09995000",
                        "longitude": "-55.76504000"
                    },
                    {
                        "id": 16464,
                        "name": "Grand Falls-Windsor",
                        "latitude": "48.93324000",
                        "longitude": "-55.66492000"
                    },
                    {
                        "id": 16491,
                        "name": "Happy Valley-Goose Bay",
                        "latitude": "53.30380000",
                        "longitude": "-60.32576000"
                    },
                    {
                        "id": 16492,
                        "name": "Harbour Breton",
                        "latitude": "47.48325000",
                        "longitude": "-55.79833000"
                    },
                    {
                        "id": 16574,
                        "name": "Labrador City",
                        "latitude": "52.94626000",
                        "longitude": "-66.91137000"
                    },
                    {
                        "id": 16615,
                        "name": "Lewisporte",
                        "latitude": "49.24993000",
                        "longitude": "-55.04816000"
                    },
                    {
                        "id": 16664,
                        "name": "Marystown",
                        "latitude": "47.16663000",
                        "longitude": "-55.14829000"
                    },
                    {
                        "id": 16724,
                        "name": "Mount Pearl",
                        "latitude": "47.51659000",
                        "longitude": "-52.78135000"
                    },
                    {
                        "id": 16802,
                        "name": "Pasadena",
                        "latitude": "49.01671000",
                        "longitude": "-57.59837000"
                    },
                    {
                        "id": 17063,
                        "name": "Springdale",
                        "latitude": "49.49995000",
                        "longitude": "-56.06492000"
                    },
                    {
                        "id": 17069,
                        "name": "St. Anthony",
                        "latitude": "51.37039000",
                        "longitude": "-55.59743000"
                    },
                    {
                        "id": 17072,
                        "name": "St. John's",
                        "latitude": "47.56494000",
                        "longitude": "-52.70931000"
                    },
                    {
                        "id": 17076,
                        "name": "Stephenville",
                        "latitude": "48.55001000",
                        "longitude": "-58.58180000"
                    },
                    {
                        "id": 17077,
                        "name": "Stephenville Crossing",
                        "latitude": "48.50001000",
                        "longitude": "-58.43180000"
                    },
                    {
                        "id": 17120,
                        "name": "Torbay",
                        "latitude": "47.66659000",
                        "longitude": "-52.73135000"
                    },
                    {
                        "id": 17135,
                        "name": "Upper Island Cove",
                        "latitude": "47.64989000",
                        "longitude": "-53.21478000"
                    },
                    {
                        "id": 17164,
                        "name": "Wabana",
                        "latitude": "47.63319000",
                        "longitude": "-52.94806000"
                    }
                ]
            },
            {
                "id": 878,
                "name": "Northwest Territories",
                "iso2": "NT",
                "latitude": "64.82554410",
                "longitude": "-124.84573340",
                "type": "territory",
                "cities": [
                    {
                        "id": 16209,
                        "name": "Behchokǫ̀",
                        "latitude": "62.80250000",
                        "longitude": "-116.04639000"
                    },
                    {
                        "id": 16431,
                        "name": "Fort McPherson",
                        "latitude": "67.43863000",
                        "longitude": "-134.88543000"
                    },
                    {
                        "id": 16434,
                        "name": "Fort Smith",
                        "latitude": "60.00439000",
                        "longitude": "-111.88871000"
                    },
                    {
                        "id": 16498,
                        "name": "Hay River",
                        "latitude": "60.81555000",
                        "longitude": "-115.79993000"
                    },
                    {
                        "id": 16522,
                        "name": "Inuvik",
                        "latitude": "68.34986000",
                        "longitude": "-133.72181000"
                    },
                    {
                        "id": 16753,
                        "name": "Norman Wells",
                        "latitude": "65.28201000",
                        "longitude": "-126.83290000"
                    },
                    {
                        "id": 17221,
                        "name": "Yellowknife",
                        "latitude": "62.45411000",
                        "longitude": "-114.37248000"
                    }
                ]
            },
            {
                "id": 874,
                "name": "Nova Scotia",
                "iso2": "NS",
                "latitude": "44.68198660",
                "longitude": "-63.74431100",
                "type": "province",
                "cities": [
                    {
                        "id": 16161,
                        "name": "Amherst",
                        "latitude": "45.83345000",
                        "longitude": "-64.19874000"
                    },
                    {
                        "id": 16170,
                        "name": "Annapolis County",
                        "latitude": "44.58345000",
                        "longitude": "-65.16551000"
                    },
                    {
                        "id": 16171,
                        "name": "Antigonish",
                        "latitude": "45.61685000",
                        "longitude": "-61.99858000"
                    },
                    {
                        "id": 16216,
                        "name": "Berwick",
                        "latitude": "45.05015000",
                        "longitude": "-64.73208000"
                    },
                    {
                        "id": 16242,
                        "name": "Bridgewater",
                        "latitude": "44.37856000",
                        "longitude": "-64.51882000"
                    },
                    {
                        "id": 16272,
                        "name": "Cape Breton County",
                        "latitude": "46.00014000",
                        "longitude": "-60.31516000"
                    },
                    {
                        "id": 16304,
                        "name": "Chester",
                        "latitude": "44.54225000",
                        "longitude": "-64.23891000"
                    },
                    {
                        "id": 16322,
                        "name": "Colchester",
                        "latitude": "45.33345000",
                        "longitude": "-63.24868000"
                    },
                    {
                        "id": 16324,
                        "name": "Cole Harbour",
                        "latitude": "44.67244000",
                        "longitude": "-63.47506000"
                    },
                    {
                        "id": 16342,
                        "name": "Cow Bay",
                        "latitude": "44.63141000",
                        "longitude": "-63.43218000"
                    },
                    {
                        "id": 16355,
                        "name": "Dartmouth",
                        "latitude": "44.67134000",
                        "longitude": "-63.57719000"
                    },
                    {
                        "id": 16374,
                        "name": "Digby",
                        "latitude": "44.62188000",
                        "longitude": "-65.75860000"
                    },
                    {
                        "id": 16375,
                        "name": "Digby County",
                        "latitude": "44.36685000",
                        "longitude": "-65.69884000"
                    },
                    {
                        "id": 16406,
                        "name": "English Corner",
                        "latitude": "44.73345000",
                        "longitude": "-63.78201000"
                    },
                    {
                        "id": 16407,
                        "name": "Eskasoni 3",
                        "latitude": "45.94522000",
                        "longitude": "-60.61617000"
                    },
                    {
                        "id": 16416,
                        "name": "Fall River",
                        "latitude": "44.81685000",
                        "longitude": "-63.61540000"
                    },
                    {
                        "id": 16454,
                        "name": "Glace Bay",
                        "latitude": "46.19695000",
                        "longitude": "-59.95698000"
                    },
                    {
                        "id": 16475,
                        "name": "Greenwood",
                        "latitude": "44.97413000",
                        "longitude": "-64.93169000"
                    },
                    {
                        "id": 16482,
                        "name": "Halifax",
                        "latitude": "44.64533000",
                        "longitude": "-63.57239000"
                    },
                    {
                        "id": 16490,
                        "name": "Hantsport",
                        "latitude": "45.06685000",
                        "longitude": "-64.16544000"
                    },
                    {
                        "id": 16499,
                        "name": "Hayes Subdivision",
                        "latitude": "45.05519000",
                        "longitude": "-64.58795000"
                    },
                    {
                        "id": 16539,
                        "name": "Kentville",
                        "latitude": "45.07710000",
                        "longitude": "-64.49605000"
                    },
                    {
                        "id": 16589,
                        "name": "Lake Echo",
                        "latitude": "44.73345000",
                        "longitude": "-63.38198000"
                    },
                    {
                        "id": 16600,
                        "name": "Lantz",
                        "latitude": "44.98345000",
                        "longitude": "-63.48199000"
                    },
                    {
                        "id": 16632,
                        "name": "Lower Sackville",
                        "latitude": "44.77599000",
                        "longitude": "-63.67865000"
                    },
                    {
                        "id": 16637,
                        "name": "Lunenburg",
                        "latitude": "44.37847000",
                        "longitude": "-64.31658000"
                    },
                    {
                        "id": 16686,
                        "name": "Middleton",
                        "latitude": "44.94284000",
                        "longitude": "-65.07022000"
                    },
                    {
                        "id": 16739,
                        "name": "New Glasgow",
                        "latitude": "45.58344000",
                        "longitude": "-62.64863000"
                    },
                    {
                        "id": 16791,
                        "name": "Oxford",
                        "latitude": "45.73345000",
                        "longitude": "-63.86542000"
                    },
                    {
                        "id": 16799,
                        "name": "Parrsboro",
                        "latitude": "45.40567000",
                        "longitude": "-64.32585000"
                    },
                    {
                        "id": 16818,
                        "name": "Pictou",
                        "latitude": "45.67875000",
                        "longitude": "-62.70936000"
                    },
                    {
                        "id": 16819,
                        "name": "Pictou County",
                        "latitude": "45.50015000",
                        "longitude": "-62.58193000"
                    },
                    {
                        "id": 16840,
                        "name": "Port Hawkesbury",
                        "latitude": "45.61685000",
                        "longitude": "-61.34853000"
                    },
                    {
                        "id": 16846,
                        "name": "Port Williams",
                        "latitude": "45.10015000",
                        "longitude": "-64.41546000"
                    },
                    {
                        "id": 16859,
                        "name": "Princeville",
                        "latitude": "45.76684000",
                        "longitude": "-61.29853000"
                    },
                    {
                        "id": 17037,
                        "name": "Shelburne",
                        "latitude": "43.76325000",
                        "longitude": "-65.32355000"
                    },
                    {
                        "id": 17064,
                        "name": "Springhill",
                        "latitude": "45.65015000",
                        "longitude": "-64.04873000"
                    },
                    {
                        "id": 17095,
                        "name": "Sydney",
                        "latitude": "46.13510000",
                        "longitude": "-60.18310000"
                    },
                    {
                        "id": 17096,
                        "name": "Sydney Mines",
                        "latitude": "46.23669000",
                        "longitude": "-60.21767000"
                    },
                    {
                        "id": 17127,
                        "name": "Truro",
                        "latitude": "45.36685000",
                        "longitude": "-63.26538000"
                    },
                    {
                        "id": 17211,
                        "name": "Windsor",
                        "latitude": "44.98345000",
                        "longitude": "-64.13204000"
                    },
                    {
                        "id": 17216,
                        "name": "Wolfville",
                        "latitude": "45.08345000",
                        "longitude": "-64.36546000"
                    },
                    {
                        "id": 17220,
                        "name": "Yarmouth",
                        "latitude": "43.83345000",
                        "longitude": "-66.11557000"
                    }
                ]
            },
            {
                "id": 876,
                "name": "Nunavut",
                "iso2": "NU",
                "latitude": "70.29977110",
                "longitude": "-83.10757700",
                "type": "territory",
                "cities": [
                    {
                        "id": 16315,
                        "name": "Clyde River",
                        "latitude": "70.47233000",
                        "longitude": "-68.58987000"
                    },
                    {
                        "id": 16453,
                        "name": "Gjoa Haven",
                        "latitude": "68.62602000",
                        "longitude": "-95.87836000"
                    },
                    {
                        "id": 16524,
                        "name": "Iqaluit",
                        "latitude": "63.74697000",
                        "longitude": "-68.51727000"
                    },
                    {
                        "id": 16555,
                        "name": "Kugluktuk",
                        "latitude": "67.82743000",
                        "longitude": "-115.09649000"
                    },
                    {
                        "id": 16793,
                        "name": "Pangnirtung",
                        "latitude": "66.14642000",
                        "longitude": "-65.69996000"
                    },
                    {
                        "id": 16869,
                        "name": "Rankin Inlet",
                        "latitude": "62.80906000",
                        "longitude": "-92.08534000"
                    }
                ]
            },
            {
                "id": 866,
                "name": "Ontario",
                "iso2": "ON",
                "latitude": "51.25377500",
                "longitude": "-85.32321400",
                "type": "province",
                "cities": [
                    {
                        "id": 16152,
                        "name": "Ajax",
                        "latitude": "43.85012000",
                        "longitude": "-79.03288000"
                    },
                    {
                        "id": 16157,
                        "name": "Algoma",
                        "latitude": "47.88364000",
                        "longitude": "-84.42406000"
                    },
                    {
                        "id": 16158,
                        "name": "Alliston",
                        "latitude": "44.15011000",
                        "longitude": "-79.86635000"
                    },
                    {
                        "id": 16162,
                        "name": "Amherstburg",
                        "latitude": "42.10009000",
                        "longitude": "-83.09985000"
                    },
                    {
                        "id": 16163,
                        "name": "Amigo Beach",
                        "latitude": "44.70011000",
                        "longitude": "-79.39963000"
                    },
                    {
                        "id": 16166,
                        "name": "Ancaster",
                        "latitude": "43.21806000",
                        "longitude": "-79.98716000"
                    },
                    {
                        "id": 16168,
                        "name": "Angus",
                        "latitude": "44.31681000",
                        "longitude": "-79.88295000"
                    },
                    {
                        "id": 16174,
                        "name": "Arnprior",
                        "latitude": "45.43341000",
                        "longitude": "-76.34939000"
                    },
                    {
                        "id": 16179,
                        "name": "Atikokan",
                        "latitude": "48.75667000",
                        "longitude": "-91.62409000"
                    },
                    {
                        "id": 16180,
                        "name": "Attawapiskat",
                        "latitude": "52.92774000",
                        "longitude": "-82.41669000"
                    },
                    {
                        "id": 16181,
                        "name": "Aurora",
                        "latitude": "44.00011000",
                        "longitude": "-79.46632000"
                    },
                    {
                        "id": 16182,
                        "name": "Aylmer",
                        "latitude": "42.76679000",
                        "longitude": "-80.98302000"
                    },
                    {
                        "id": 16183,
                        "name": "Azilda",
                        "latitude": "46.55008000",
                        "longitude": "-81.09975000"
                    },
                    {
                        "id": 16188,
                        "name": "Ballantrae",
                        "latitude": "44.03342000",
                        "longitude": "-79.29960000"
                    },
                    {
                        "id": 16189,
                        "name": "Bancroft",
                        "latitude": "45.05752000",
                        "longitude": "-77.85702000"
                    },
                    {
                        "id": 16193,
                        "name": "Barrie",
                        "latitude": "44.40011000",
                        "longitude": "-79.66634000"
                    },
                    {
                        "id": 16197,
                        "name": "Bath",
                        "latitude": "44.18342000",
                        "longitude": "-76.78273000"
                    },
                    {
                        "id": 16211,
                        "name": "Belleville",
                        "latitude": "44.16682000",
                        "longitude": "-77.38277000"
                    },
                    {
                        "id": 16212,
                        "name": "Bells Corners",
                        "latitude": "45.31588000",
                        "longitude": "-75.83012000"
                    },
                    {
                        "id": 16213,
                        "name": "Belmont",
                        "latitude": "42.88339000",
                        "longitude": "-81.08303000"
                    },
                    {
                        "id": 16218,
                        "name": "Binbrook",
                        "latitude": "43.12135000",
                        "longitude": "-79.81104000"
                    },
                    {
                        "id": 16222,
                        "name": "Bluewater",
                        "latitude": "43.46679000",
                        "longitude": "-81.59977000"
                    },
                    {
                        "id": 16233,
                        "name": "Bourget",
                        "latitude": "45.43340000",
                        "longitude": "-75.14930000"
                    },
                    {
                        "id": 16236,
                        "name": "Bracebridge",
                        "latitude": "45.03341000",
                        "longitude": "-79.31633000"
                    },
                    {
                        "id": 16237,
                        "name": "Brampton",
                        "latitude": "43.68341000",
                        "longitude": "-79.76633000"
                    },
                    {
                        "id": 16239,
                        "name": "Brant",
                        "latitude": "43.13340000",
                        "longitude": "-80.34967000"
                    },
                    {
                        "id": 16240,
                        "name": "Brantford",
                        "latitude": "43.13340000",
                        "longitude": "-80.26636000"
                    },
                    {
                        "id": 16243,
                        "name": "Brockville",
                        "latitude": "44.59132000",
                        "longitude": "-75.68705000"
                    },
                    {
                        "id": 16248,
                        "name": "Brussels",
                        "latitude": "43.73339000",
                        "longitude": "-81.24975000"
                    },
                    {
                        "id": 16250,
                        "name": "Burford",
                        "latitude": "43.10292000",
                        "longitude": "-80.42869000"
                    },
                    {
                        "id": 16252,
                        "name": "Burlington",
                        "latitude": "43.38621000",
                        "longitude": "-79.83713000"
                    },
                    {
                        "id": 16261,
                        "name": "Cambridge",
                        "latitude": "43.36010000",
                        "longitude": "-80.31269000"
                    },
                    {
                        "id": 16262,
                        "name": "Camlachie",
                        "latitude": "43.03596000",
                        "longitude": "-82.16160000"
                    },
                    {
                        "id": 16274,
                        "name": "Capreol",
                        "latitude": "46.70626000",
                        "longitude": "-80.92109000"
                    },
                    {
                        "id": 16280,
                        "name": "Carleton Place",
                        "latitude": "45.13341000",
                        "longitude": "-76.14938000"
                    },
                    {
                        "id": 16285,
                        "name": "Casselman",
                        "latitude": "45.31680000",
                        "longitude": "-75.08260000"
                    },
                    {
                        "id": 16299,
                        "name": "Chatham",
                        "latitude": "42.41224000",
                        "longitude": "-82.18494000"
                    },
                    {
                        "id": 16300,
                        "name": "Chatham-Kent",
                        "latitude": "42.40009000",
                        "longitude": "-82.18310000"
                    },
                    {
                        "id": 16312,
                        "name": "Clarence-Rockland",
                        "latitude": "45.55010000",
                        "longitude": "-75.29101000"
                    },
                    {
                        "id": 16319,
                        "name": "Cobourg",
                        "latitude": "43.95977000",
                        "longitude": "-78.16515000"
                    },
                    {
                        "id": 16321,
                        "name": "Cochrane District",
                        "latitude": "50.00022000",
                        "longitude": "-82.99979000"
                    },
                    {
                        "id": 16325,
                        "name": "Collingwood",
                        "latitude": "44.48340000",
                        "longitude": "-80.21638000"
                    },
                    {
                        "id": 16328,
                        "name": "Concord",
                        "latitude": "43.80011000",
                        "longitude": "-79.48291000"
                    },
                    {
                        "id": 16329,
                        "name": "Constance Bay",
                        "latitude": "45.50011000",
                        "longitude": "-76.08267000"
                    },
                    {
                        "id": 16333,
                        "name": "Cookstown",
                        "latitude": "44.18341000",
                        "longitude": "-79.69964000"
                    },
                    {
                        "id": 16337,
                        "name": "Cornwall",
                        "latitude": "45.01809000",
                        "longitude": "-74.72815000"
                    },
                    {
                        "id": 16339,
                        "name": "Corunna",
                        "latitude": "42.88338000",
                        "longitude": "-82.43313000"
                    },
                    {
                        "id": 16361,
                        "name": "Deep River",
                        "latitude": "46.10012000",
                        "longitude": "-77.49949000"
                    },
                    {
                        "id": 16363,
                        "name": "Delaware",
                        "latitude": "42.91679000",
                        "longitude": "-81.41646000"
                    },
                    {
                        "id": 16369,
                        "name": "Deseronto",
                        "latitude": "44.20012000",
                        "longitude": "-77.04944000"
                    },
                    {
                        "id": 16380,
                        "name": "Dorchester",
                        "latitude": "42.98339000",
                        "longitude": "-81.06643000"
                    },
                    {
                        "id": 16382,
                        "name": "Dowling",
                        "latitude": "46.59111000",
                        "longitude": "-81.33917000"
                    },
                    {
                        "id": 16385,
                        "name": "Dryden",
                        "latitude": "49.78334000",
                        "longitude": "-92.75032000"
                    },
                    {
                        "id": 16389,
                        "name": "Durham",
                        "latitude": "44.20012000",
                        "longitude": "-78.99957000"
                    },
                    {
                        "id": 16390,
                        "name": "Ear Falls",
                        "latitude": "50.63955000",
                        "longitude": "-93.23526000"
                    },
                    {
                        "id": 16393,
                        "name": "East Gwillimbury",
                        "latitude": "44.10087000",
                        "longitude": "-79.43785000"
                    },
                    {
                        "id": 16395,
                        "name": "East York",
                        "latitude": "43.69053000",
                        "longitude": "-79.32794000"
                    },
                    {
                        "id": 16401,
                        "name": "Elliot Lake",
                        "latitude": "46.38336000",
                        "longitude": "-82.63315000"
                    },
                    {
                        "id": 16403,
                        "name": "Elmvale",
                        "latitude": "44.58340000",
                        "longitude": "-79.86636000"
                    },
                    {
                        "id": 16405,
                        "name": "Englehart",
                        "latitude": "47.81686000",
                        "longitude": "-79.86640000"
                    },
                    {
                        "id": 16408,
                        "name": "Espanola",
                        "latitude": "46.25837000",
                        "longitude": "-81.76649000"
                    },
                    {
                        "id": 16409,
                        "name": "Essex",
                        "latitude": "42.17509000",
                        "longitude": "-82.82483000"
                    },
                    {
                        "id": 16412,
                        "name": "Etobicoke",
                        "latitude": "43.65421000",
                        "longitude": "-79.56711000"
                    },
                    {
                        "id": 153520,
                        "name": "Exeter",
                        "latitude": "43.34358630",
                        "longitude": "-81.49726020"
                    },
                    {
                        "id": 16427,
                        "name": "Fort Erie",
                        "latitude": "42.90012000",
                        "longitude": "-78.93286000"
                    },
                    {
                        "id": 16428,
                        "name": "Fort Frances",
                        "latitude": "48.61667000",
                        "longitude": "-93.40030000"
                    },
                    {
                        "id": 16446,
                        "name": "Gananoque",
                        "latitude": "44.33342000",
                        "longitude": "-76.16607000"
                    },
                    {
                        "id": 16455,
                        "name": "Glencoe",
                        "latitude": "42.75009000",
                        "longitude": "-81.71648000"
                    },
                    {
                        "id": 16457,
                        "name": "Goderich",
                        "latitude": "43.74171000",
                        "longitude": "-81.71339000"
                    },
                    {
                        "id": 16459,
                        "name": "Golden",
                        "latitude": "51.05917000",
                        "longitude": "-93.73568000"
                    },
                    {
                        "id": 16470,
                        "name": "Gravenhurst",
                        "latitude": "44.91681000",
                        "longitude": "-79.36633000"
                    },
                    {
                        "id": 16472,
                        "name": "Greater Napanee",
                        "latitude": "44.25012000",
                        "longitude": "-76.94944000"
                    },
                    {
                        "id": 16473,
                        "name": "Greater Sudbury",
                        "latitude": "46.49000000",
                        "longitude": "-80.99001000"
                    },
                    {
                        "id": 16474,
                        "name": "Greenstone",
                        "latitude": "49.73343000",
                        "longitude": "-87.16668000"
                    },
                    {
                        "id": 16478,
                        "name": "Guelph",
                        "latitude": "43.54594000",
                        "longitude": "-80.25599000"
                    },
                    {
                        "id": 16480,
                        "name": "Haldimand County",
                        "latitude": "42.98341000",
                        "longitude": "-79.86633000"
                    },
                    {
                        "id": 16481,
                        "name": "Haliburton Village",
                        "latitude": "45.05154000",
                        "longitude": "-78.52245000"
                    },
                    {
                        "id": 16483,
                        "name": "Halton",
                        "latitude": "43.50011000",
                        "longitude": "-79.88294000"
                    },
                    {
                        "id": 16484,
                        "name": "Hamilton",
                        "latitude": "43.25011000",
                        "longitude": "-79.84963000"
                    },
                    {
                        "id": 16489,
                        "name": "Hanover",
                        "latitude": "44.15009000",
                        "longitude": "-81.03303000"
                    },
                    {
                        "id": 16494,
                        "name": "Harriston",
                        "latitude": "43.90009000",
                        "longitude": "-80.88302000"
                    },
                    {
                        "id": 16497,
                        "name": "Hawkesbury",
                        "latitude": "45.60009000",
                        "longitude": "-74.61595000"
                    },
                    {
                        "id": 16501,
                        "name": "Hearst",
                        "latitude": "49.68351000",
                        "longitude": "-83.66654000"
                    },
                    {
                        "id": 16509,
                        "name": "Hornepayne",
                        "latitude": "49.21451000",
                        "longitude": "-84.77617000"
                    },
                    {
                        "id": 16515,
                        "name": "Huntsville",
                        "latitude": "45.33341000",
                        "longitude": "-79.21632000"
                    },
                    {
                        "id": 16516,
                        "name": "Huron East",
                        "latitude": "43.61679000",
                        "longitude": "-81.29975000"
                    },
                    {
                        "id": 16520,
                        "name": "Ingersoll",
                        "latitude": "43.03339000",
                        "longitude": "-80.88302000"
                    },
                    {
                        "id": 16521,
                        "name": "Innisfil",
                        "latitude": "44.30011000",
                        "longitude": "-79.64964000"
                    },
                    {
                        "id": 16525,
                        "name": "Iroquois Falls",
                        "latitude": "48.76688000",
                        "longitude": "-80.68307000"
                    },
                    {
                        "id": 16527,
                        "name": "Jarvis",
                        "latitude": "42.88341000",
                        "longitude": "-80.09965000"
                    },
                    {
                        "id": 16533,
                        "name": "Kanata",
                        "latitude": "45.30010000",
                        "longitude": "-75.91606000"
                    },
                    {
                        "id": 16534,
                        "name": "Kapuskasing",
                        "latitude": "49.41694000",
                        "longitude": "-82.43308000"
                    },
                    {
                        "id": 16535,
                        "name": "Kawartha Lakes",
                        "latitude": "44.58342000",
                        "longitude": "-78.83288000"
                    },
                    {
                        "id": 16537,
                        "name": "Kenora",
                        "latitude": "49.76741000",
                        "longitude": "-94.48985000"
                    },
                    {
                        "id": 16541,
                        "name": "Keswick",
                        "latitude": "44.25011000",
                        "longitude": "-79.46632000"
                    },
                    {
                        "id": 16546,
                        "name": "Kincardine",
                        "latitude": "44.18339000",
                        "longitude": "-81.63307000"
                    },
                    {
                        "id": 16548,
                        "name": "King",
                        "latitude": "43.96514000",
                        "longitude": "-79.59011000"
                    },
                    {
                        "id": 16550,
                        "name": "Kingston",
                        "latitude": "44.22976000",
                        "longitude": "-76.48098000"
                    },
                    {
                        "id": 16552,
                        "name": "Kirkland Lake",
                        "latitude": "48.14461000",
                        "longitude": "-80.03767000"
                    },
                    {
                        "id": 16553,
                        "name": "Kitchener",
                        "latitude": "43.42537000",
                        "longitude": "-80.51120000"
                    },
                    {
                        "id": 16560,
                        "name": "L'Orignal",
                        "latitude": "45.61980000",
                        "longitude": "-74.69150000"
                    },
                    {
                        "id": 16590,
                        "name": "Lakefield",
                        "latitude": "44.43342000",
                        "longitude": "-78.26623000"
                    },
                    {
                        "id": 16591,
                        "name": "Lambton Shores",
                        "latitude": "43.16678000",
                        "longitude": "-81.93309000"
                    },
                    {
                        "id": 16601,
                        "name": "Lappe",
                        "latitude": "48.56680000",
                        "longitude": "-89.35013000"
                    },
                    {
                        "id": 16607,
                        "name": "Leamington",
                        "latitude": "42.05009000",
                        "longitude": "-82.59981000"
                    },
                    {
                        "id": 16617,
                        "name": "Limoges",
                        "latitude": "45.33340000",
                        "longitude": "-75.24931000"
                    },
                    {
                        "id": 16619,
                        "name": "Lindsay",
                        "latitude": "44.35012000",
                        "longitude": "-78.73286000"
                    },
                    {
                        "id": 16622,
                        "name": "Listowel",
                        "latitude": "43.73340000",
                        "longitude": "-80.94973000"
                    },
                    {
                        "id": 16623,
                        "name": "Little Current",
                        "latitude": "45.97927000",
                        "longitude": "-81.92480000"
                    },
                    {
                        "id": 16624,
                        "name": "Lively",
                        "latitude": "46.43338000",
                        "longitude": "-81.14975000"
                    },
                    {
                        "id": 16627,
                        "name": "London",
                        "latitude": "42.98339000",
                        "longitude": "-81.23304000"
                    },
                    {
                        "id": 16633,
                        "name": "Lucan",
                        "latitude": "43.18339000",
                        "longitude": "-81.39976000"
                    },
                    {
                        "id": 16643,
                        "name": "Madoc",
                        "latitude": "44.50842000",
                        "longitude": "-77.47448000"
                    },
                    {
                        "id": 16650,
                        "name": "Manitoulin District",
                        "latitude": "45.75007000",
                        "longitude": "-82.49985000"
                    },
                    {
                        "id": 16651,
                        "name": "Manitouwadge",
                        "latitude": "49.12152000",
                        "longitude": "-85.84030000"
                    },
                    {
                        "id": 16658,
                        "name": "Marathon",
                        "latitude": "48.75010000",
                        "longitude": "-86.43322000"
                    },
                    {
                        "id": 16661,
                        "name": "Markdale",
                        "latitude": "44.31680000",
                        "longitude": "-80.64971000"
                    },
                    {
                        "id": 16662,
                        "name": "Markham",
                        "latitude": "43.86682000",
                        "longitude": "-79.26630000"
                    },
                    {
                        "id": 16669,
                        "name": "Mattawa",
                        "latitude": "46.31681000",
                        "longitude": "-78.69957000"
                    },
                    {
                        "id": 16674,
                        "name": "Meaford",
                        "latitude": "44.60725000",
                        "longitude": "-80.61081000"
                    },
                    {
                        "id": 16683,
                        "name": "Metcalfe",
                        "latitude": "45.23340000",
                        "longitude": "-75.46603000"
                    },
                    {
                        "id": 16687,
                        "name": "Midland",
                        "latitude": "44.75010000",
                        "longitude": "-79.88296000"
                    },
                    {
                        "id": 16688,
                        "name": "Mildmay",
                        "latitude": "44.05009000",
                        "longitude": "-81.11644000"
                    },
                    {
                        "id": 16690,
                        "name": "Millbrook",
                        "latitude": "44.15012000",
                        "longitude": "-78.44954000"
                    },
                    {
                        "id": 16692,
                        "name": "Milton",
                        "latitude": "43.51681000",
                        "longitude": "-79.88294000"
                    },
                    {
                        "id": 16697,
                        "name": "Mississauga",
                        "latitude": "43.57890000",
                        "longitude": "-79.65830000"
                    },
                    {
                        "id": 16698,
                        "name": "Mississauga Beach",
                        "latitude": "43.26682000",
                        "longitude": "-79.08287000"
                    },
                    {
                        "id": 16712,
                        "name": "Moose Factory",
                        "latitude": "51.26689000",
                        "longitude": "-80.61624000"
                    },
                    {
                        "id": 16716,
                        "name": "Moosonee",
                        "latitude": "51.27931000",
                        "longitude": "-80.63450000"
                    },
                    {
                        "id": 16721,
                        "name": "Morrisburg",
                        "latitude": "44.90010000",
                        "longitude": "-75.18261000"
                    },
                    {
                        "id": 16722,
                        "name": "Mount Albert",
                        "latitude": "44.13341000",
                        "longitude": "-79.31630000"
                    },
                    {
                        "id": 16723,
                        "name": "Mount Brydges",
                        "latitude": "42.90009000",
                        "longitude": "-81.48306000"
                    },
                    {
                        "id": 16730,
                        "name": "Napanee",
                        "latitude": "44.25012000",
                        "longitude": "-76.94944000"
                    },
                    {
                        "id": 16731,
                        "name": "Napanee Downtown",
                        "latitude": "44.24832000",
                        "longitude": "-76.95069000"
                    },
                    {
                        "id": 16733,
                        "name": "Neebing",
                        "latitude": "48.16680000",
                        "longitude": "-89.41683000"
                    },
                    {
                        "id": 16736,
                        "name": "Nepean",
                        "latitude": "45.35215000",
                        "longitude": "-75.73975000"
                    },
                    {
                        "id": 16740,
                        "name": "New Hamburg",
                        "latitude": "43.38339000",
                        "longitude": "-80.69970000"
                    },
                    {
                        "id": 16744,
                        "name": "Newmarket",
                        "latitude": "44.05011000",
                        "longitude": "-79.46631000"
                    },
                    {
                        "id": 16745,
                        "name": "Niagara Falls",
                        "latitude": "43.10012000",
                        "longitude": "-79.06627000"
                    },
                    {
                        "id": 16748,
                        "name": "Nipissing District",
                        "latitude": "46.00010000",
                        "longitude": "-78.99959000"
                    },
                    {
                        "id": 16752,
                        "name": "Norfolk County",
                        "latitude": "42.83340000",
                        "longitude": "-80.38297000"
                    },
                    {
                        "id": 16756,
                        "name": "North Bay",
                        "latitude": "46.31680000",
                        "longitude": "-79.46633000"
                    },
                    {
                        "id": 16759,
                        "name": "North Perth",
                        "latitude": "43.72510000",
                        "longitude": "-80.96723000"
                    },
                    {
                        "id": 16762,
                        "name": "North York",
                        "latitude": "43.76681000",
                        "longitude": "-79.41630000"
                    },
                    {
                        "id": 16763,
                        "name": "Norwood",
                        "latitude": "44.38342000",
                        "longitude": "-77.98281000"
                    },
                    {
                        "id": 16770,
                        "name": "Oakville",
                        "latitude": "43.45011000",
                        "longitude": "-79.68292000"
                    },
                    {
                        "id": 16777,
                        "name": "Omemee",
                        "latitude": "44.29897000",
                        "longitude": "-78.55989000"
                    },
                    {
                        "id": 16778,
                        "name": "Orangeville",
                        "latitude": "43.91680000",
                        "longitude": "-80.09967000"
                    },
                    {
                        "id": 16779,
                        "name": "Orillia",
                        "latitude": "44.60868000",
                        "longitude": "-79.42068000"
                    },
                    {
                        "id": 16782,
                        "name": "Osgoode",
                        "latitude": "45.14887000",
                        "longitude": "-75.59778000"
                    },
                    {
                        "id": 16783,
                        "name": "Oshawa",
                        "latitude": "43.90012000",
                        "longitude": "-78.84957000"
                    },
                    {
                        "id": 16785,
                        "name": "Ottawa",
                        "latitude": "45.41117000",
                        "longitude": "-75.69812000"
                    },
                    {
                        "id": 16789,
                        "name": "Owen Sound",
                        "latitude": "44.56717000",
                        "longitude": "-80.94349000"
                    },
                    {
                        "id": 16792,
                        "name": "Paisley",
                        "latitude": "44.30641000",
                        "longitude": "-81.27265000"
                    },
                    {
                        "id": 16796,
                        "name": "Paris",
                        "latitude": "43.20000000",
                        "longitude": "-80.38333000"
                    },
                    {
                        "id": 16797,
                        "name": "Parkhill",
                        "latitude": "43.15993000",
                        "longitude": "-81.68464000"
                    },
                    {
                        "id": 16800,
                        "name": "Parry Sound",
                        "latitude": "45.34732000",
                        "longitude": "-80.03527000"
                    },
                    {
                        "id": 16801,
                        "name": "Parry Sound District",
                        "latitude": "45.75011000",
                        "longitude": "-79.83297000"
                    },
                    {
                        "id": 16806,
                        "name": "Peel",
                        "latitude": "43.75011000",
                        "longitude": "-79.78293000"
                    },
                    {
                        "id": 16809,
                        "name": "Pembroke",
                        "latitude": "45.81681000",
                        "longitude": "-77.11616000"
                    },
                    {
                        "id": 16812,
                        "name": "Perth",
                        "latitude": "44.90011000",
                        "longitude": "-76.24939000"
                    },
                    {
                        "id": 16813,
                        "name": "Petawawa",
                        "latitude": "45.89452000",
                        "longitude": "-77.28007000"
                    },
                    {
                        "id": 16814,
                        "name": "Peterborough",
                        "latitude": "44.30012000",
                        "longitude": "-78.31623000"
                    },
                    {
                        "id": 16815,
                        "name": "Petrolia",
                        "latitude": "42.86678000",
                        "longitude": "-82.14981000"
                    },
                    {
                        "id": 16816,
                        "name": "Pickering",
                        "latitude": "43.90012000",
                        "longitude": "-79.13289000"
                    },
                    {
                        "id": 16817,
                        "name": "Picton",
                        "latitude": "44.00012000",
                        "longitude": "-77.13275000"
                    },
                    {
                        "id": 16827,
                        "name": "Plantagenet",
                        "latitude": "45.53260000",
                        "longitude": "-74.99369000"
                    },
                    {
                        "id": 16828,
                        "name": "Plattsville",
                        "latitude": "43.30010000",
                        "longitude": "-80.61639000"
                    },
                    {
                        "id": 16838,
                        "name": "Port Colborne",
                        "latitude": "42.90012000",
                        "longitude": "-79.23288000"
                    },
                    {
                        "id": 16841,
                        "name": "Port Hope",
                        "latitude": "44.01682000",
                        "longitude": "-78.39953000"
                    },
                    {
                        "id": 16844,
                        "name": "Port Rowan",
                        "latitude": "42.61680000",
                        "longitude": "-80.46638000"
                    },
                    {
                        "id": 16845,
                        "name": "Port Stanley",
                        "latitude": "42.66679000",
                        "longitude": "-81.21644000"
                    },
                    {
                        "id": 16850,
                        "name": "Powassan",
                        "latitude": "46.03340000",
                        "longitude": "-79.34961000"
                    },
                    {
                        "id": 16853,
                        "name": "Prescott",
                        "latitude": "44.71681000",
                        "longitude": "-75.51604000"
                    },
                    {
                        "id": 16855,
                        "name": "Prince Edward",
                        "latitude": "44.00012000",
                        "longitude": "-77.24946000"
                    },
                    {
                        "id": 16864,
                        "name": "Queenswood Heights",
                        "latitude": "45.47083000",
                        "longitude": "-75.50556000"
                    },
                    {
                        "id": 16866,
                        "name": "Quinte West",
                        "latitude": "44.18342000",
                        "longitude": "-77.56618000"
                    },
                    {
                        "id": 16868,
                        "name": "Rainy River District",
                        "latitude": "48.49981000",
                        "longitude": "-92.50031000"
                    },
                    {
                        "id": 16872,
                        "name": "Rayside-Balfour",
                        "latitude": "46.60873000",
                        "longitude": "-81.20763000"
                    },
                    {
                        "id": 16874,
                        "name": "Red Lake",
                        "latitude": "51.01678000",
                        "longitude": "-93.82736000"
                    },
                    {
                        "id": 16879,
                        "name": "Regional Municipality of Waterloo",
                        "latitude": "43.50010000",
                        "longitude": "-80.49969000"
                    },
                    {
                        "id": 16880,
                        "name": "Renfrew",
                        "latitude": "45.46681000",
                        "longitude": "-76.68272000"
                    },
                    {
                        "id": 16887,
                        "name": "Richmond",
                        "latitude": "45.18340000",
                        "longitude": "-75.83266000"
                    },
                    {
                        "id": 16888,
                        "name": "Richmond Hill",
                        "latitude": "43.87111000",
                        "longitude": "-79.43725000"
                    },
                    {
                        "id": 16890,
                        "name": "Ridgetown",
                        "latitude": "42.43339000",
                        "longitude": "-81.89978000"
                    },
                    {
                        "id": 16900,
                        "name": "Rockwood",
                        "latitude": "43.61899000",
                        "longitude": "-80.14441000"
                    },
                    {
                        "id": 16909,
                        "name": "Russell",
                        "latitude": "45.25010000",
                        "longitude": "-75.36602000"
                    },
                    {
                        "id": 17020,
                        "name": "Sarnia",
                        "latitude": "42.97866000",
                        "longitude": "-82.40407000"
                    },
                    {
                        "id": 17022,
                        "name": "Sault Ste. Marie",
                        "latitude": "46.51677000",
                        "longitude": "-84.33325000"
                    },
                    {
                        "id": 17023,
                        "name": "Scarborough",
                        "latitude": "43.77223000",
                        "longitude": "-79.25666000"
                    },
                    {
                        "id": 17024,
                        "name": "Seaforth",
                        "latitude": "43.55009000",
                        "longitude": "-81.39976000"
                    },
                    {
                        "id": 17036,
                        "name": "Shelburne",
                        "latitude": "44.07870000",
                        "longitude": "-80.20408000"
                    },
                    {
                        "id": 17045,
                        "name": "Simcoe",
                        "latitude": "42.83340000",
                        "longitude": "-80.29967000"
                    },
                    {
                        "id": 17046,
                        "name": "Sioux Lookout",
                        "latitude": "50.06676000",
                        "longitude": "-91.98358000"
                    },
                    {
                        "id": 17048,
                        "name": "Skatepark",
                        "latitude": "44.25122000",
                        "longitude": "-76.94424000"
                    },
                    {
                        "id": 17051,
                        "name": "Smiths Falls",
                        "latitude": "44.90452000",
                        "longitude": "-76.02333000"
                    },
                    {
                        "id": 17057,
                        "name": "South Huron",
                        "latitude": "43.31679000",
                        "longitude": "-81.51647000"
                    },
                    {
                        "id": 17059,
                        "name": "South River",
                        "latitude": "45.83340000",
                        "longitude": "-79.38293000"
                    },
                    {
                        "id": 17070,
                        "name": "St. Catharines",
                        "latitude": "43.17126000",
                        "longitude": "-79.24267000"
                    },
                    {
                        "id": 17071,
                        "name": "St. George",
                        "latitude": "43.24495000",
                        "longitude": "-80.25144000"
                    },
                    {
                        "id": 17073,
                        "name": "St. Thomas",
                        "latitude": "42.77361000",
                        "longitude": "-81.18038000"
                    },
                    {
                        "id": 17079,
                        "name": "Stirling",
                        "latitude": "44.30012000",
                        "longitude": "-77.54948000"
                    },
                    {
                        "id": 17081,
                        "name": "Stoney Point",
                        "latitude": "44.26681000",
                        "longitude": "-79.53292000"
                    },
                    {
                        "id": 17083,
                        "name": "Stratford",
                        "latitude": "43.36679000",
                        "longitude": "-80.94972000"
                    },
                    {
                        "id": 17085,
                        "name": "Sudbury",
                        "latitude": "47.16679000",
                        "longitude": "-81.99980000"
                    },
                    {
                        "id": 17100,
                        "name": "Tavistock",
                        "latitude": "43.31679000",
                        "longitude": "-80.83302000"
                    },
                    {
                        "id": 17101,
                        "name": "Temiskaming Shores",
                        "latitude": "47.49376000",
                        "longitude": "-79.71529000"
                    },
                    {
                        "id": 17106,
                        "name": "Thessalon",
                        "latitude": "46.25006000",
                        "longitude": "-83.56660000"
                    },
                    {
                        "id": 149581,
                        "name": "Thornhill",
                        "latitude": "43.81708480",
                        "longitude": "-79.45011940"
                    },
                    {
                        "id": 17109,
                        "name": "Thorold",
                        "latitude": "43.11682000",
                        "longitude": "-79.19958000"
                    },
                    {
                        "id": 17111,
                        "name": "Thunder Bay",
                        "latitude": "48.38202000",
                        "longitude": "-89.25018000"
                    },
                    {
                        "id": 17112,
                        "name": "Thunder Bay District",
                        "latitude": "49.50011000",
                        "longitude": "-88.50004000"
                    },
                    {
                        "id": 17114,
                        "name": "Timiskaming District",
                        "latitude": "47.75016000",
                        "longitude": "-80.33303000"
                    },
                    {
                        "id": 17115,
                        "name": "Timmins",
                        "latitude": "48.46686000",
                        "longitude": "-81.33312000"
                    },
                    {
                        "id": 17117,
                        "name": "Tobermory",
                        "latitude": "45.25007000",
                        "longitude": "-81.66647000"
                    },
                    {
                        "id": 17121,
                        "name": "Toronto",
                        "latitude": "43.70011000",
                        "longitude": "-79.41630000"
                    },
                    {
                        "id": 17122,
                        "name": "Toronto county",
                        "latitude": "43.69655000",
                        "longitude": "-79.42909000"
                    },
                    {
                        "id": 17123,
                        "name": "Tottenham",
                        "latitude": "44.02437000",
                        "longitude": "-79.80553000"
                    },
                    {
                        "id": 17130,
                        "name": "Tweed",
                        "latitude": "44.47512000",
                        "longitude": "-77.31616000"
                    },
                    {
                        "id": 17136,
                        "name": "Uxbridge",
                        "latitude": "44.10012000",
                        "longitude": "-79.11628000"
                    },
                    {
                        "id": 17142,
                        "name": "Valley East",
                        "latitude": "46.66773000",
                        "longitude": "-81.00028000"
                    },
                    {
                        "id": 17147,
                        "name": "Vanier",
                        "latitude": "45.43990000",
                        "longitude": "-75.66498000"
                    },
                    {
                        "id": 17150,
                        "name": "Vaughan",
                        "latitude": "43.83610000",
                        "longitude": "-79.49827000"
                    },
                    {
                        "id": 17160,
                        "name": "Vineland",
                        "latitude": "43.15012000",
                        "longitude": "-79.39960000"
                    },
                    {
                        "id": 17162,
                        "name": "Virgil",
                        "latitude": "43.21682000",
                        "longitude": "-79.13288000"
                    },
                    {
                        "id": 17169,
                        "name": "Walpole Island",
                        "latitude": "42.61520000",
                        "longitude": "-82.51398000"
                    },
                    {
                        "id": 17172,
                        "name": "Wasaga Beach",
                        "latitude": "44.51680000",
                        "longitude": "-80.01637000"
                    },
                    {
                        "id": 17175,
                        "name": "Waterford",
                        "latitude": "42.93340000",
                        "longitude": "-80.28296000"
                    },
                    {
                        "id": 17176,
                        "name": "Waterloo",
                        "latitude": "43.46680000",
                        "longitude": "-80.51639000"
                    },
                    {
                        "id": 17178,
                        "name": "Watford",
                        "latitude": "42.95008000",
                        "longitude": "-81.88309000"
                    },
                    {
                        "id": 17181,
                        "name": "Wawa",
                        "latitude": "47.98877000",
                        "longitude": "-84.77411000"
                    },
                    {
                        "id": 17184,
                        "name": "Welland",
                        "latitude": "42.98342000",
                        "longitude": "-79.24958000"
                    },
                    {
                        "id": 17185,
                        "name": "Wellesley",
                        "latitude": "43.47691000",
                        "longitude": "-80.76209000"
                    },
                    {
                        "id": 17188,
                        "name": "Wendover",
                        "latitude": "45.57275000",
                        "longitude": "-75.12757000"
                    },
                    {
                        "id": 17191,
                        "name": "West Lorne",
                        "latitude": "42.60009000",
                        "longitude": "-81.59976000"
                    },
                    {
                        "id": 17208,
                        "name": "Willowdale",
                        "latitude": "43.76672000",
                        "longitude": "-79.39909000"
                    },
                    {
                        "id": 17209,
                        "name": "Winchester",
                        "latitude": "45.08340000",
                        "longitude": "-75.34933000"
                    },
                    {
                        "id": 17212,
                        "name": "Windsor",
                        "latitude": "42.30008000",
                        "longitude": "-83.01654000"
                    },
                    {
                        "id": 17213,
                        "name": "Wingham",
                        "latitude": "43.88793000",
                        "longitude": "-81.31145000"
                    },
                    {
                        "id": 17217,
                        "name": "Woodstock",
                        "latitude": "43.13339000",
                        "longitude": "-80.74970000"
                    },
                    {
                        "id": 17222,
                        "name": "York",
                        "latitude": "44.00011000",
                        "longitude": "-79.46632000"
                    }
                ]
            },
            {
                "id": 871,
                "name": "Prince Edward Island",
                "iso2": "PE",
                "latitude": "46.51071200",
                "longitude": "-63.41681360",
                "type": "province",
                "cities": [
                    {
                        "id": 16154,
                        "name": "Alberton",
                        "latitude": "46.81685000",
                        "longitude": "-64.06542000"
                    },
                    {
                        "id": 16210,
                        "name": "Belfast",
                        "latitude": "46.08341000",
                        "longitude": "-62.88197000"
                    },
                    {
                        "id": 16297,
                        "name": "Charlottetown",
                        "latitude": "46.23899000",
                        "longitude": "-63.13414000"
                    },
                    {
                        "id": 16338,
                        "name": "Cornwall",
                        "latitude": "46.22652000",
                        "longitude": "-63.21809000"
                    },
                    {
                        "id": 16417,
                        "name": "Fallingbrook",
                        "latitude": "45.47558000",
                        "longitude": "-75.48401000"
                    },
                    {
                        "id": 16538,
                        "name": "Kensington",
                        "latitude": "46.43343000",
                        "longitude": "-63.64871000"
                    },
                    {
                        "id": 16707,
                        "name": "Montague",
                        "latitude": "46.16681000",
                        "longitude": "-62.64866000"
                    },
                    {
                        "id": 17055,
                        "name": "Souris",
                        "latitude": "46.35010000",
                        "longitude": "-62.24862000"
                    },
                    {
                        "id": 17087,
                        "name": "Summerside",
                        "latitude": "46.39593000",
                        "longitude": "-63.78762000"
                    }
                ]
            },
            {
                "id": 873,
                "name": "Quebec",
                "iso2": "QC",
                "latitude": "52.93991590",
                "longitude": "-73.54913610",
                "type": "province",
                "cities": [
                    {
                        "id": 16147,
                        "name": "Abitibi-Témiscamingue",
                        "latitude": "48.10018000",
                        "longitude": "-77.78280000"
                    },
                    {
                        "id": 16148,
                        "name": "Acton Vale",
                        "latitude": "45.65007000",
                        "longitude": "-72.56582000"
                    },
                    {
                        "id": 16149,
                        "name": "Adstock",
                        "latitude": "46.05007000",
                        "longitude": "-71.08235000"
                    },
                    {
                        "id": 16153,
                        "name": "Albanel",
                        "latitude": "48.88324000",
                        "longitude": "-72.44867000"
                    },
                    {
                        "id": 16159,
                        "name": "Alma",
                        "latitude": "48.55009000",
                        "longitude": "-71.64910000"
                    },
                    {
                        "id": 16164,
                        "name": "Amos",
                        "latitude": "48.56688000",
                        "longitude": "-78.11624000"
                    },
                    {
                        "id": 16165,
                        "name": "Amqui",
                        "latitude": "48.46382000",
                        "longitude": "-67.43134000"
                    },
                    {
                        "id": 16167,
                        "name": "Ange-Gardien",
                        "latitude": "45.35008000",
                        "longitude": "-72.93244000"
                    },
                    {
                        "id": 16175,
                        "name": "Asbestos",
                        "latitude": "45.76678000",
                        "longitude": "-71.93240000"
                    },
                    {
                        "id": 16185,
                        "name": "Baie-Comeau",
                        "latitude": "49.21679000",
                        "longitude": "-68.14894000"
                    },
                    {
                        "id": 16186,
                        "name": "Baie-D'Urfé",
                        "latitude": "45.41397000",
                        "longitude": "-73.91586000"
                    },
                    {
                        "id": 16187,
                        "name": "Baie-Saint-Paul",
                        "latitude": "47.44109000",
                        "longitude": "-70.49858000"
                    },
                    {
                        "id": 16191,
                        "name": "Barraute",
                        "latitude": "48.43349000",
                        "longitude": "-77.63279000"
                    },
                    {
                        "id": 16195,
                        "name": "Bas-Saint-Laurent",
                        "latitude": "48.05030000",
                        "longitude": "-68.02266000"
                    },
                    {
                        "id": 16201,
                        "name": "Beaconsfield",
                        "latitude": "45.43341000",
                        "longitude": "-73.86586000"
                    },
                    {
                        "id": 16202,
                        "name": "Beauceville",
                        "latitude": "46.21785000",
                        "longitude": "-70.77873000"
                    },
                    {
                        "id": 16203,
                        "name": "Beauharnois",
                        "latitude": "45.31341000",
                        "longitude": "-73.87250000"
                    },
                    {
                        "id": 16205,
                        "name": "Beaupré",
                        "latitude": "47.04428000",
                        "longitude": "-70.89529000"
                    },
                    {
                        "id": 16255,
                        "name": "Bécancour",
                        "latitude": "46.34106000",
                        "longitude": "-72.43224000"
                    },
                    {
                        "id": 16208,
                        "name": "Bedford",
                        "latitude": "45.11678000",
                        "longitude": "-72.98244000"
                    },
                    {
                        "id": 16214,
                        "name": "Beloeil",
                        "latitude": "45.56839000",
                        "longitude": "-73.20568000"
                    },
                    {
                        "id": 16215,
                        "name": "Berthierville",
                        "latitude": "46.08336000",
                        "longitude": "-73.18245000"
                    },
                    {
                        "id": 16221,
                        "name": "Blainville",
                        "latitude": "45.66678000",
                        "longitude": "-73.88249000"
                    },
                    {
                        "id": 16223,
                        "name": "Bois-des-Filion",
                        "latitude": "45.66678000",
                        "longitude": "-73.74918000"
                    },
                    {
                        "id": 16224,
                        "name": "Boisbriand",
                        "latitude": "45.61678000",
                        "longitude": "-73.83249000"
                    },
                    {
                        "id": 16227,
                        "name": "Bonaventure",
                        "latitude": "48.04573000",
                        "longitude": "-65.49259000"
                    },
                    {
                        "id": 16231,
                        "name": "Boucherville",
                        "latitude": "45.59104000",
                        "longitude": "-73.43605000"
                    },
                    {
                        "id": 16241,
                        "name": "Breakeyville",
                        "latitude": "46.68037000",
                        "longitude": "-71.22327000"
                    },
                    {
                        "id": 16244,
                        "name": "Bromont",
                        "latitude": "45.31678000",
                        "longitude": "-72.64912000"
                    },
                    {
                        "id": 16246,
                        "name": "Brossard",
                        "latitude": "45.45008000",
                        "longitude": "-73.46583000"
                    },
                    {
                        "id": 16247,
                        "name": "Brownsburg-Chatham",
                        "latitude": "45.68342000",
                        "longitude": "-74.41590000"
                    },
                    {
                        "id": 16249,
                        "name": "Buckingham",
                        "latitude": "45.58563000",
                        "longitude": "-75.42080000"
                    },
                    {
                        "id": 16256,
                        "name": "Cabano",
                        "latitude": "47.68065000",
                        "longitude": "-68.87810000"
                    },
                    {
                        "id": 16258,
                        "name": "Cacouna",
                        "latitude": "47.91657000",
                        "longitude": "-69.50054000"
                    },
                    {
                        "id": 16266,
                        "name": "Candiac",
                        "latitude": "45.38338000",
                        "longitude": "-73.51587000"
                    },
                    {
                        "id": 16269,
                        "name": "Cantley",
                        "latitude": "45.56680000",
                        "longitude": "-75.78265000"
                    },
                    {
                        "id": 16270,
                        "name": "Cap-Chat",
                        "latitude": "49.10009000",
                        "longitude": "-66.68212000"
                    },
                    {
                        "id": 16271,
                        "name": "Cap-Santé",
                        "latitude": "46.67159000",
                        "longitude": "-71.78812000"
                    },
                    {
                        "id": 16273,
                        "name": "Capitale-Nationale",
                        "latitude": "47.37600000",
                        "longitude": "-71.12337000"
                    },
                    {
                        "id": 16278,
                        "name": "Carignan",
                        "latitude": "45.45008000",
                        "longitude": "-73.29916000"
                    },
                    {
                        "id": 16279,
                        "name": "Carleton",
                        "latitude": "48.09838000",
                        "longitude": "-66.10036000"
                    },
                    {
                        "id": 16281,
                        "name": "Carleton-sur-Mer",
                        "latitude": "48.10749000",
                        "longitude": "-66.12800000"
                    },
                    {
                        "id": 16290,
                        "name": "Centre-du-Québec",
                        "latitude": "46.01985000",
                        "longitude": "-71.98242000"
                    },
                    {
                        "id": 16291,
                        "name": "Chambly",
                        "latitude": "45.45008000",
                        "longitude": "-73.28246000"
                    },
                    {
                        "id": 16292,
                        "name": "Chambord",
                        "latitude": "48.43339000",
                        "longitude": "-72.06583000"
                    },
                    {
                        "id": 16293,
                        "name": "Chandler",
                        "latitude": "48.34935000",
                        "longitude": "-64.67926000"
                    },
                    {
                        "id": 16295,
                        "name": "Chapais",
                        "latitude": "49.78344000",
                        "longitude": "-74.84919000"
                    },
                    {
                        "id": 16296,
                        "name": "Charlemagne",
                        "latitude": "45.71678000",
                        "longitude": "-73.48247000"
                    },
                    {
                        "id": 16310,
                        "name": "Château-Richer",
                        "latitude": "46.96031000",
                        "longitude": "-71.03219000"
                    },
                    {
                        "id": 16311,
                        "name": "Châteauguay",
                        "latitude": "45.38338000",
                        "longitude": "-73.74919000"
                    },
                    {
                        "id": 16301,
                        "name": "Chaudière-Appalaches",
                        "latitude": "46.55500000",
                        "longitude": "-70.83080000"
                    },
                    {
                        "id": 16303,
                        "name": "Chertsey",
                        "latitude": "46.07109000",
                        "longitude": "-73.89095000"
                    },
                    {
                        "id": 16307,
                        "name": "Chibougamau",
                        "latitude": "49.91684000",
                        "longitude": "-74.36586000"
                    },
                    {
                        "id": 16309,
                        "name": "Chute-aux-Outardes",
                        "latitude": "49.11679000",
                        "longitude": "-68.39896000"
                    },
                    {
                        "id": 16318,
                        "name": "Coaticook",
                        "latitude": "45.13339000",
                        "longitude": "-71.79907000"
                    },
                    {
                        "id": 16330,
                        "name": "Contrecoeur",
                        "latitude": "45.85008000",
                        "longitude": "-73.23245000"
                    },
                    {
                        "id": 16331,
                        "name": "Cookshire",
                        "latitude": "45.41536000",
                        "longitude": "-71.62962000"
                    },
                    {
                        "id": 16332,
                        "name": "Cookshire-Eaton",
                        "latitude": "45.41675000",
                        "longitude": "-71.63240000"
                    },
                    {
                        "id": 16351,
                        "name": "Côte-Nord",
                        "latitude": "50.86683000",
                        "longitude": "-65.81541000"
                    },
                    {
                        "id": 16352,
                        "name": "Côte-Saint-Luc",
                        "latitude": "45.46536000",
                        "longitude": "-73.66585000"
                    },
                    {
                        "id": 16340,
                        "name": "Coteau-du-Lac",
                        "latitude": "45.30008000",
                        "longitude": "-74.18253000"
                    },
                    {
                        "id": 16343,
                        "name": "Cowansville",
                        "latitude": "45.20008000",
                        "longitude": "-72.74913000"
                    },
                    {
                        "id": 16345,
                        "name": "Crabtree",
                        "latitude": "45.96677000",
                        "longitude": "-73.46586000"
                    },
                    {
                        "id": 16354,
                        "name": "Danville",
                        "latitude": "45.78337000",
                        "longitude": "-72.01580000"
                    },
                    {
                        "id": 16357,
                        "name": "Daveluyville",
                        "latitude": "46.20006000",
                        "longitude": "-72.13239000"
                    },
                    {
                        "id": 16365,
                        "name": "Delson",
                        "latitude": "45.36678000",
                        "longitude": "-73.54917000"
                    },
                    {
                        "id": 16370,
                        "name": "Deux-Montagnes",
                        "latitude": "45.53455000",
                        "longitude": "-73.90168000"
                    },
                    {
                        "id": 16376,
                        "name": "Disraeli",
                        "latitude": "45.90007000",
                        "longitude": "-71.34907000"
                    },
                    {
                        "id": 16377,
                        "name": "Dolbeau-Mistassini",
                        "latitude": "48.87860000",
                        "longitude": "-72.23142000"
                    },
                    {
                        "id": 16378,
                        "name": "Dollard-Des Ormeaux",
                        "latitude": "45.49452000",
                        "longitude": "-73.82419000"
                    },
                    {
                        "id": 16379,
                        "name": "Donnacona",
                        "latitude": "46.68042000",
                        "longitude": "-71.72390000"
                    },
                    {
                        "id": 16381,
                        "name": "Dorval",
                        "latitude": "45.44730000",
                        "longitude": "-73.75335000"
                    },
                    {
                        "id": 16384,
                        "name": "Drummondville",
                        "latitude": "45.88336000",
                        "longitude": "-72.48241000"
                    },
                    {
                        "id": 16388,
                        "name": "Dunham",
                        "latitude": "45.13338000",
                        "longitude": "-72.79913000"
                    },
                    {
                        "id": 16391,
                        "name": "East Angus",
                        "latitude": "45.48338000",
                        "longitude": "-71.66577000"
                    },
                    {
                        "id": 16392,
                        "name": "East Broughton",
                        "latitude": "46.21358000",
                        "longitude": "-71.07674000"
                    },
                    {
                        "id": 16418,
                        "name": "Farnham",
                        "latitude": "45.28338000",
                        "longitude": "-72.98244000"
                    },
                    {
                        "id": 16419,
                        "name": "Ferme-Neuve",
                        "latitude": "46.70011000",
                        "longitude": "-75.44929000"
                    },
                    {
                        "id": 16420,
                        "name": "Fermont",
                        "latitude": "52.78345000",
                        "longitude": "-67.08204000"
                    },
                    {
                        "id": 16426,
                        "name": "Forestville",
                        "latitude": "48.73808000",
                        "longitude": "-69.08478000"
                    },
                    {
                        "id": 16436,
                        "name": "Fort-Coulonge",
                        "latitude": "45.85011000",
                        "longitude": "-76.73272000"
                    },
                    {
                        "id": 16437,
                        "name": "Fossambault-sur-le-Lac",
                        "latitude": "46.87662000",
                        "longitude": "-71.61541000"
                    },
                    {
                        "id": 16439,
                        "name": "Franklin",
                        "latitude": "45.03338000",
                        "longitude": "-73.91591000"
                    },
                    {
                        "id": 16447,
                        "name": "Gaspé",
                        "latitude": "48.83341000",
                        "longitude": "-64.48194000"
                    },
                    {
                        "id": 16448,
                        "name": "Gaspésie-Îles-de-la-Madeleine",
                        "latitude": "48.87555000",
                        "longitude": "-65.40710000"
                    },
                    {
                        "id": 16449,
                        "name": "Gatineau",
                        "latitude": "45.47723000",
                        "longitude": "-75.70164000"
                    },
                    {
                        "id": 16456,
                        "name": "Godefroy",
                        "latitude": "51.75012000",
                        "longitude": "-68.08213000"
                    },
                    {
                        "id": 16461,
                        "name": "Granby",
                        "latitude": "45.40008000",
                        "longitude": "-72.73243000"
                    },
                    {
                        "id": 16485,
                        "name": "Hampstead",
                        "latitude": "45.48064000",
                        "longitude": "-73.66307000"
                    },
                    {
                        "id": 16495,
                        "name": "Hauterive",
                        "latitude": "49.19572000",
                        "longitude": "-68.25813000"
                    },
                    {
                        "id": 16496,
                        "name": "Havre-Saint-Pierre",
                        "latitude": "50.24342000",
                        "longitude": "-63.60264000"
                    },
                    {
                        "id": 16517,
                        "name": "Hérouxville",
                        "latitude": "46.66617000",
                        "longitude": "-72.62512000"
                    },
                    {
                        "id": 16511,
                        "name": "Hudson",
                        "latitude": "45.45008000",
                        "longitude": "-74.14922000"
                    },
                    {
                        "id": 16514,
                        "name": "Huntingdon",
                        "latitude": "45.08339000",
                        "longitude": "-74.16593000"
                    },
                    {
                        "id": 16529,
                        "name": "Joliette",
                        "latitude": "46.01640000",
                        "longitude": "-73.42360000"
                    },
                    {
                        "id": 16530,
                        "name": "Jonquière",
                        "latitude": "48.41648000",
                        "longitude": "-71.24884000"
                    },
                    {
                        "id": 16549,
                        "name": "Kingsey Falls",
                        "latitude": "45.85007000",
                        "longitude": "-72.06580000"
                    },
                    {
                        "id": 16551,
                        "name": "Kirkland",
                        "latitude": "45.45008000",
                        "longitude": "-73.86586000"
                    },
                    {
                        "id": 16556,
                        "name": "L'Ancienne-Lorette",
                        "latitude": "46.79392000",
                        "longitude": "-71.35191000"
                    },
                    {
                        "id": 16557,
                        "name": "L'Ange-Gardien",
                        "latitude": "46.91976000",
                        "longitude": "-71.08253000"
                    },
                    {
                        "id": 16558,
                        "name": "L'Ascension-de-Notre-Seigneur",
                        "latitude": "48.68339000",
                        "longitude": "-71.66580000"
                    },
                    {
                        "id": 16559,
                        "name": "L'Assomption",
                        "latitude": "45.82318000",
                        "longitude": "-73.42940000"
                    },
                    {
                        "id": 16561,
                        "name": "L'Épiphanie",
                        "latitude": "45.85008000",
                        "longitude": "-73.48246000"
                    },
                    {
                        "id": 16562,
                        "name": "L'Île-Perrot",
                        "latitude": "45.38338000",
                        "longitude": "-73.94920000"
                    },
                    {
                        "id": 16564,
                        "name": "La Conception",
                        "latitude": "46.15009000",
                        "longitude": "-74.69925000"
                    },
                    {
                        "id": 16565,
                        "name": "La Haute-Saint-Charles",
                        "latitude": "46.89028000",
                        "longitude": "-71.37222000"
                    },
                    {
                        "id": 16566,
                        "name": "La Malbaie",
                        "latitude": "47.65400000",
                        "longitude": "-70.15268000"
                    },
                    {
                        "id": 16567,
                        "name": "La Minerve",
                        "latitude": "46.25009000",
                        "longitude": "-74.93257000"
                    },
                    {
                        "id": 16568,
                        "name": "La Pocatière",
                        "latitude": "47.36733000",
                        "longitude": "-70.03484000"
                    },
                    {
                        "id": 16569,
                        "name": "La Prairie",
                        "latitude": "45.41678000",
                        "longitude": "-73.49917000"
                    },
                    {
                        "id": 16571,
                        "name": "La Sarre",
                        "latitude": "48.80019000",
                        "longitude": "-79.19964000"
                    },
                    {
                        "id": 16572,
                        "name": "La Tuque",
                        "latitude": "47.43337000",
                        "longitude": "-72.78240000"
                    },
                    {
                        "id": 16573,
                        "name": "Labelle",
                        "latitude": "46.28339000",
                        "longitude": "-74.73255000"
                    },
                    {
                        "id": 16577,
                        "name": "Lac-Alouette",
                        "latitude": "45.81698000",
                        "longitude": "-73.95920000"
                    },
                    {
                        "id": 16578,
                        "name": "Lac-Brome",
                        "latitude": "45.21678000",
                        "longitude": "-72.51581000"
                    },
                    {
                        "id": 16579,
                        "name": "Lac-Connelly",
                        "latitude": "45.89788000",
                        "longitude": "-73.97230000"
                    },
                    {
                        "id": 16580,
                        "name": "Lac-Lapierre",
                        "latitude": "45.89837000",
                        "longitude": "-73.77308000"
                    },
                    {
                        "id": 16581,
                        "name": "Lac-Mégantic",
                        "latitude": "45.58338000",
                        "longitude": "-70.88234000"
                    },
                    {
                        "id": 16582,
                        "name": "Lac-Simon",
                        "latitude": "46.15699000",
                        "longitude": "-74.74129000"
                    },
                    {
                        "id": 16583,
                        "name": "Lachute",
                        "latitude": "45.65008000",
                        "longitude": "-74.33253000"
                    },
                    {
                        "id": 16584,
                        "name": "Lacolle",
                        "latitude": "45.08338000",
                        "longitude": "-73.36585000"
                    },
                    {
                        "id": 16599,
                        "name": "Lanoraie",
                        "latitude": "45.96677000",
                        "longitude": "-73.21585000"
                    },
                    {
                        "id": 16604,
                        "name": "Laval",
                        "latitude": "45.56995000",
                        "longitude": "-73.69200000"
                    },
                    {
                        "id": 16605,
                        "name": "Lavaltrie",
                        "latitude": "45.88338000",
                        "longitude": "-73.28245000"
                    },
                    {
                        "id": 16606,
                        "name": "Le Bic",
                        "latitude": "48.37549000",
                        "longitude": "-68.69415000"
                    },
                    {
                        "id": 17224,
                        "name": "le Plateau",
                        "latitude": "45.43514000",
                        "longitude": "-75.78030000"
                    },
                    {
                        "id": 16608,
                        "name": "Lebel-sur-Quévillon",
                        "latitude": "49.05018000",
                        "longitude": "-76.98273000"
                    },
                    {
                        "id": 16609,
                        "name": "Leblanc",
                        "latitude": "48.26683000",
                        "longitude": "-74.34914000"
                    },
                    {
                        "id": 16612,
                        "name": "Les Cèdres",
                        "latitude": "45.30008000",
                        "longitude": "-74.04922000"
                    },
                    {
                        "id": 16611,
                        "name": "Les Coteaux",
                        "latitude": "45.28338000",
                        "longitude": "-74.23254000"
                    },
                    {
                        "id": 16613,
                        "name": "Les Escoumins",
                        "latitude": "48.35191000",
                        "longitude": "-69.40724000"
                    },
                    {
                        "id": 16639,
                        "name": "Lévis",
                        "latitude": "46.80326000",
                        "longitude": "-71.17793000"
                    },
                    {
                        "id": 16620,
                        "name": "Linière",
                        "latitude": "46.00007000",
                        "longitude": "-70.41572000"
                    },
                    {
                        "id": 16628,
                        "name": "Longueuil",
                        "latitude": "45.53121000",
                        "longitude": "-73.51806000"
                    },
                    {
                        "id": 16630,
                        "name": "Lorraine",
                        "latitude": "45.68338000",
                        "longitude": "-73.78249000"
                    },
                    {
                        "id": 16631,
                        "name": "Louiseville",
                        "latitude": "46.25594000",
                        "longitude": "-72.94145000"
                    },
                    {
                        "id": 16634,
                        "name": "Luceville",
                        "latitude": "48.54498000",
                        "longitude": "-68.39658000"
                    },
                    {
                        "id": 16640,
                        "name": "Macamic",
                        "latitude": "48.75018000",
                        "longitude": "-78.99962000"
                    },
                    {
                        "id": 16644,
                        "name": "Magog",
                        "latitude": "45.26678000",
                        "longitude": "-72.14909000"
                    },
                    {
                        "id": 16646,
                        "name": "Malartic",
                        "latitude": "48.13348000",
                        "longitude": "-78.13283000"
                    },
                    {
                        "id": 16647,
                        "name": "Maliotenam",
                        "latitude": "50.21119000",
                        "longitude": "-66.18164000"
                    },
                    {
                        "id": 16648,
                        "name": "Manawan",
                        "latitude": "47.22029000",
                        "longitude": "-74.38606000"
                    },
                    {
                        "id": 16649,
                        "name": "Mandeville",
                        "latitude": "46.36677000",
                        "longitude": "-73.34915000"
                    },
                    {
                        "id": 16652,
                        "name": "Maniwaki",
                        "latitude": "46.38341000",
                        "longitude": "-75.96605000"
                    },
                    {
                        "id": 16659,
                        "name": "Maria",
                        "latitude": "48.17490000",
                        "longitude": "-65.98595000"
                    },
                    {
                        "id": 16660,
                        "name": "Marieville",
                        "latitude": "45.43338000",
                        "longitude": "-73.16585000"
                    },
                    {
                        "id": 16665,
                        "name": "Mascouche",
                        "latitude": "45.74965000",
                        "longitude": "-73.59956000"
                    },
                    {
                        "id": 16666,
                        "name": "Maskinongé",
                        "latitude": "46.22860000",
                        "longitude": "-73.01917000"
                    },
                    {
                        "id": 16667,
                        "name": "Matagami",
                        "latitude": "49.75018000",
                        "longitude": "-77.63277000"
                    },
                    {
                        "id": 16668,
                        "name": "Matane",
                        "latitude": "48.82857000",
                        "longitude": "-67.52197000"
                    },
                    {
                        "id": 16670,
                        "name": "Mauricie",
                        "latitude": "47.55009000",
                        "longitude": "-73.41583000"
                    },
                    {
                        "id": 16678,
                        "name": "Melocheville",
                        "latitude": "45.31726000",
                        "longitude": "-73.93710000"
                    },
                    {
                        "id": 16680,
                        "name": "Mercier",
                        "latitude": "45.31678000",
                        "longitude": "-73.74919000"
                    },
                    {
                        "id": 16725,
                        "name": "Métabetchouan",
                        "latitude": "48.36679000",
                        "longitude": "-72.01583000"
                    },
                    {
                        "id": 16682,
                        "name": "Metabetchouan-Lac-a-la-Croix",
                        "latitude": "48.41000000",
                        "longitude": "-71.78000000"
                    },
                    {
                        "id": 16694,
                        "name": "Mirabel",
                        "latitude": "45.65008000",
                        "longitude": "-74.08251000"
                    },
                    {
                        "id": 16699,
                        "name": "Mistissini",
                        "latitude": "50.41667000",
                        "longitude": "-73.88333000"
                    },
                    {
                        "id": 16701,
                        "name": "Mont-Joli",
                        "latitude": "48.58388000",
                        "longitude": "-68.19214000"
                    },
                    {
                        "id": 16702,
                        "name": "Mont-Laurier",
                        "latitude": "46.55011000",
                        "longitude": "-75.49930000"
                    },
                    {
                        "id": 16703,
                        "name": "Mont-Royal",
                        "latitude": "45.51675000",
                        "longitude": "-73.64918000"
                    },
                    {
                        "id": 16704,
                        "name": "Mont-Saint-Grégoire",
                        "latitude": "45.33338000",
                        "longitude": "-73.16585000"
                    },
                    {
                        "id": 16705,
                        "name": "Mont-Saint-Hilaire",
                        "latitude": "45.56515000",
                        "longitude": "-73.18680000"
                    },
                    {
                        "id": 16706,
                        "name": "Mont-Tremblant",
                        "latitude": "46.21274000",
                        "longitude": "-74.58438000"
                    },
                    {
                        "id": 16708,
                        "name": "Montmagny",
                        "latitude": "46.98043000",
                        "longitude": "-70.55493000"
                    },
                    {
                        "id": 16709,
                        "name": "Montréal",
                        "latitude": "45.50008000",
                        "longitude": "-73.68248000"
                    },
                    {
                        "id": 16710,
                        "name": "Montréal-Est",
                        "latitude": "45.63202000",
                        "longitude": "-73.50750000"
                    },
                    {
                        "id": 16711,
                        "name": "Montréal-Ouest",
                        "latitude": "45.45286000",
                        "longitude": "-73.64918000"
                    },
                    {
                        "id": 16718,
                        "name": "Morin-Heights",
                        "latitude": "45.90009000",
                        "longitude": "-74.24922000"
                    },
                    {
                        "id": 16732,
                        "name": "Napierville",
                        "latitude": "45.18648000",
                        "longitude": "-73.40468000"
                    },
                    {
                        "id": 16737,
                        "name": "Neuville",
                        "latitude": "46.69823000",
                        "longitude": "-71.58275000"
                    },
                    {
                        "id": 16738,
                        "name": "New Carlisle",
                        "latitude": "48.00956000",
                        "longitude": "-65.33621000"
                    },
                    {
                        "id": 16743,
                        "name": "New-Richmond",
                        "latitude": "48.16059000",
                        "longitude": "-65.85823000"
                    },
                    {
                        "id": 16746,
                        "name": "Nicolet",
                        "latitude": "46.21676000",
                        "longitude": "-72.61582000"
                    },
                    {
                        "id": 16751,
                        "name": "Nord-du-Québec",
                        "latitude": "51.96200000",
                        "longitude": "-74.89610000"
                    },
                    {
                        "id": 16754,
                        "name": "Normandin",
                        "latitude": "48.83328000",
                        "longitude": "-72.53209000"
                    },
                    {
                        "id": 16764,
                        "name": "Notre-Dame-de-Grâce",
                        "latitude": "45.47675000",
                        "longitude": "-73.61432000"
                    },
                    {
                        "id": 16765,
                        "name": "Notre-Dame-de-l'Île-Perrot",
                        "latitude": "45.36678000",
                        "longitude": "-73.93250000"
                    },
                    {
                        "id": 16766,
                        "name": "Notre-Dame-des-Prairies",
                        "latitude": "46.05007000",
                        "longitude": "-73.43245000"
                    },
                    {
                        "id": 16767,
                        "name": "Notre-Dame-du-Lac",
                        "latitude": "46.75012000",
                        "longitude": "-79.04961000"
                    },
                    {
                        "id": 16768,
                        "name": "Notre-Dame-du-Mont-Carmel",
                        "latitude": "46.01680000",
                        "longitude": "-75.08259000"
                    },
                    {
                        "id": 16771,
                        "name": "Oka",
                        "latitude": "45.46489000",
                        "longitude": "-74.08892000"
                    },
                    {
                        "id": 16780,
                        "name": "Ormstown",
                        "latitude": "45.13338000",
                        "longitude": "-73.99922000"
                    },
                    {
                        "id": 16786,
                        "name": "Otterburn Park",
                        "latitude": "45.53338000",
                        "longitude": "-73.21585000"
                    },
                    {
                        "id": 16787,
                        "name": "Outaouais",
                        "latitude": "46.26681000",
                        "longitude": "-76.31606000"
                    },
                    {
                        "id": 16794,
                        "name": "Papineauville",
                        "latitude": "45.61680000",
                        "longitude": "-75.01599000"
                    },
                    {
                        "id": 16795,
                        "name": "Parc-Boutin",
                        "latitude": "45.29209000",
                        "longitude": "-73.26154000"
                    },
                    {
                        "id": 16821,
                        "name": "Piedmont",
                        "latitude": "45.90008000",
                        "longitude": "-74.13251000"
                    },
                    {
                        "id": 16822,
                        "name": "Pierreville",
                        "latitude": "46.07034000",
                        "longitude": "-72.81125000"
                    },
                    {
                        "id": 16825,
                        "name": "Pincourt",
                        "latitude": "45.38338000",
                        "longitude": "-73.98250000"
                    },
                    {
                        "id": 16829,
                        "name": "Plessisville",
                        "latitude": "46.21856000",
                        "longitude": "-71.76201000"
                    },
                    {
                        "id": 16830,
                        "name": "Pohénégamook",
                        "latitude": "47.46315000",
                        "longitude": "-69.22666000"
                    },
                    {
                        "id": 16831,
                        "name": "Pointe-Calumet",
                        "latitude": "45.50008000",
                        "longitude": "-73.96590000"
                    },
                    {
                        "id": 16832,
                        "name": "Pointe-Claire",
                        "latitude": "45.44868000",
                        "longitude": "-73.81669000"
                    },
                    {
                        "id": 16833,
                        "name": "Pointe-du-Lac",
                        "latitude": "48.50009000",
                        "longitude": "-71.78241000"
                    },
                    {
                        "id": 16835,
                        "name": "Pont Rouge",
                        "latitude": "48.88332000",
                        "longitude": "-72.08247000"
                    },
                    {
                        "id": 16836,
                        "name": "Pont-Rouge",
                        "latitude": "46.75468000",
                        "longitude": "-71.69566000"
                    },
                    {
                        "id": 16847,
                        "name": "Port-Cartier",
                        "latitude": "50.03339000",
                        "longitude": "-66.86545000"
                    },
                    {
                        "id": 16849,
                        "name": "Portneuf",
                        "latitude": "46.69058000",
                        "longitude": "-71.89011000"
                    },
                    {
                        "id": 16862,
                        "name": "Prévost",
                        "latitude": "45.86678000",
                        "longitude": "-74.08251000"
                    },
                    {
                        "id": 16860,
                        "name": "Princeville",
                        "latitude": "46.17163000",
                        "longitude": "-71.87462000"
                    },
                    {
                        "id": 16867,
                        "name": "Québec",
                        "latitude": "46.81228000",
                        "longitude": "-71.21454000"
                    },
                    {
                        "id": 16870,
                        "name": "Rawdon",
                        "latitude": "46.05007000",
                        "longitude": "-73.71587000"
                    },
                    {
                        "id": 16881,
                        "name": "Repentigny",
                        "latitude": "45.74222000",
                        "longitude": "-73.45008000"
                    },
                    {
                        "id": 16883,
                        "name": "Richelieu",
                        "latitude": "45.44336000",
                        "longitude": "-73.24602000"
                    },
                    {
                        "id": 16886,
                        "name": "Richmond",
                        "latitude": "45.66677000",
                        "longitude": "-72.14910000"
                    },
                    {
                        "id": 16891,
                        "name": "Rigaud",
                        "latitude": "45.47927000",
                        "longitude": "-74.30238000"
                    },
                    {
                        "id": 16893,
                        "name": "Rimouski",
                        "latitude": "48.44879000",
                        "longitude": "-68.52396000"
                    },
                    {
                        "id": 16896,
                        "name": "Rivière-du-Loup",
                        "latitude": "47.82699000",
                        "longitude": "-69.54243000"
                    },
                    {
                        "id": 16895,
                        "name": "Rivière-Rouge",
                        "latitude": "46.41679000",
                        "longitude": "-74.86596000"
                    },
                    {
                        "id": 16897,
                        "name": "Roberval",
                        "latitude": "48.51680000",
                        "longitude": "-72.23244000"
                    },
                    {
                        "id": 16899,
                        "name": "Rock Forest",
                        "latitude": "45.35699000",
                        "longitude": "-71.99676000"
                    },
                    {
                        "id": 16902,
                        "name": "Rosemère",
                        "latitude": "45.63338000",
                        "longitude": "-73.79919000"
                    },
                    {
                        "id": 16906,
                        "name": "Rougemont",
                        "latitude": "45.43338000",
                        "longitude": "-73.04914000"
                    },
                    {
                        "id": 16907,
                        "name": "Rouyn-Noranda",
                        "latitude": "48.23656000",
                        "longitude": "-79.02311000"
                    },
                    {
                        "id": 16911,
                        "name": "Sacré-Coeur",
                        "latitude": "48.22970000",
                        "longitude": "-69.80061000"
                    },
                    {
                        "id": 16912,
                        "name": "Saguenay",
                        "latitude": "48.41675000",
                        "longitude": "-71.06573000"
                    },
                    {
                        "id": 16915,
                        "name": "Saint-Adolphe-d'Howard",
                        "latitude": "45.96679000",
                        "longitude": "-74.33253000"
                    },
                    {
                        "id": 16916,
                        "name": "Saint-Alexandre",
                        "latitude": "45.50010000",
                        "longitude": "-75.74935000"
                    },
                    {
                        "id": 16917,
                        "name": "Saint-Amable",
                        "latitude": "45.65008000",
                        "longitude": "-73.29916000"
                    },
                    {
                        "id": 16918,
                        "name": "Saint-Ambroise",
                        "latitude": "48.55009000",
                        "longitude": "-71.33238000"
                    },
                    {
                        "id": 16919,
                        "name": "Saint-André-Avellin",
                        "latitude": "45.71680000",
                        "longitude": "-75.06599000"
                    },
                    {
                        "id": 16920,
                        "name": "Saint-Anselme",
                        "latitude": "46.62922000",
                        "longitude": "-70.97340000"
                    },
                    {
                        "id": 16922,
                        "name": "Saint-Antoine-de-Tilly",
                        "latitude": "46.66346000",
                        "longitude": "-71.57335000"
                    },
                    {
                        "id": 16923,
                        "name": "Saint-Augustin",
                        "latitude": "51.22602000",
                        "longitude": "-58.65017000"
                    },
                    {
                        "id": 16924,
                        "name": "Saint-Augustin-de-Desmaures",
                        "latitude": "46.74064000",
                        "longitude": "-71.45131000"
                    },
                    {
                        "id": 16925,
                        "name": "Saint-Barnabé-Sud",
                        "latitude": "45.72977000",
                        "longitude": "-72.92244000"
                    },
                    {
                        "id": 16926,
                        "name": "Saint-Basile-le-Grand",
                        "latitude": "45.53338000",
                        "longitude": "-73.28246000"
                    },
                    {
                        "id": 16927,
                        "name": "Saint-Boniface",
                        "latitude": "46.50011000",
                        "longitude": "-75.98264000"
                    },
                    {
                        "id": 16928,
                        "name": "Saint-Bruno",
                        "latitude": "48.46679000",
                        "longitude": "-71.64910000"
                    },
                    {
                        "id": 16929,
                        "name": "Saint-Bruno-de-Guigues",
                        "latitude": "47.46685000",
                        "longitude": "-79.43296000"
                    },
                    {
                        "id": 16930,
                        "name": "Saint-Bruno-de-Montarville",
                        "latitude": "45.53341000",
                        "longitude": "-73.34916000"
                    },
                    {
                        "id": 16931,
                        "name": "Saint-Canut",
                        "latitude": "45.71502000",
                        "longitude": "-74.08376000"
                    },
                    {
                        "id": 16935,
                        "name": "Saint-Césaire",
                        "latitude": "45.41678000",
                        "longitude": "-72.99914000"
                    },
                    {
                        "id": 16932,
                        "name": "Saint-Charles",
                        "latitude": "45.70288000",
                        "longitude": "-73.55417000"
                    },
                    {
                        "id": 16936,
                        "name": "Saint-Côme-Linière",
                        "latitude": "46.06677000",
                        "longitude": "-70.51573000"
                    },
                    {
                        "id": 16933,
                        "name": "Saint-Constant",
                        "latitude": "45.36678000",
                        "longitude": "-73.56588000"
                    },
                    {
                        "id": 16934,
                        "name": "Saint-Cyrille-de-Wendover",
                        "latitude": "45.93336000",
                        "longitude": "-72.43241000"
                    },
                    {
                        "id": 16937,
                        "name": "Saint-Damase",
                        "latitude": "45.53341000",
                        "longitude": "-72.99914000"
                    },
                    {
                        "id": 16938,
                        "name": "Saint-Denis-sur-Richelieu",
                        "latitude": "45.78338000",
                        "longitude": "-73.14915000"
                    },
                    {
                        "id": 16939,
                        "name": "Saint-Donat-de-Montcalm",
                        "latitude": "46.31868000",
                        "longitude": "-74.22171000"
                    },
                    {
                        "id": 16992,
                        "name": "Saint-Édouard",
                        "latitude": "45.23338000",
                        "longitude": "-73.51588000"
                    },
                    {
                        "id": 16940,
                        "name": "Saint-Elzéar",
                        "latitude": "45.60338000",
                        "longitude": "-73.72698000"
                    },
                    {
                        "id": 16993,
                        "name": "Saint-Éphrem-de-Beauce",
                        "latitude": "46.06677000",
                        "longitude": "-70.94905000"
                    },
                    {
                        "id": 16941,
                        "name": "Saint-Eustache",
                        "latitude": "45.56500000",
                        "longitude": "-73.90554000"
                    },
                    {
                        "id": 16942,
                        "name": "Saint-Félicien",
                        "latitude": "48.65007000",
                        "longitude": "-72.44906000"
                    },
                    {
                        "id": 16943,
                        "name": "Saint-Félix-de-Valois",
                        "latitude": "46.16977000",
                        "longitude": "-73.42525000"
                    },
                    {
                        "id": 16944,
                        "name": "Saint-Gabriel",
                        "latitude": "46.30007000",
                        "longitude": "-73.38245000"
                    },
                    {
                        "id": 16947,
                        "name": "Saint-Gédéon",
                        "latitude": "48.50009000",
                        "longitude": "-71.76581000"
                    },
                    {
                        "id": 16945,
                        "name": "Saint-Georges",
                        "latitude": "46.11353000",
                        "longitude": "-70.66526000"
                    },
                    {
                        "id": 16946,
                        "name": "Saint-Germain-de-Grantham",
                        "latitude": "45.83337000",
                        "longitude": "-72.56582000"
                    },
                    {
                        "id": 16948,
                        "name": "Saint-Henri",
                        "latitude": "46.69314000",
                        "longitude": "-71.06927000"
                    },
                    {
                        "id": 16949,
                        "name": "Saint-Hippolyte",
                        "latitude": "45.93338000",
                        "longitude": "-74.01590000"
                    },
                    {
                        "id": 16950,
                        "name": "Saint-Honoré",
                        "latitude": "48.53338000",
                        "longitude": "-71.08236000"
                    },
                    {
                        "id": 16951,
                        "name": "Saint-Hyacinthe",
                        "latitude": "45.63076000",
                        "longitude": "-72.95699000"
                    },
                    {
                        "id": 16952,
                        "name": "Saint-Isidore",
                        "latitude": "47.43345000",
                        "longitude": "-79.29965000"
                    },
                    {
                        "id": 16953,
                        "name": "Saint-Jacques-le-Mineur",
                        "latitude": "45.28338000",
                        "longitude": "-73.41587000"
                    },
                    {
                        "id": 16954,
                        "name": "Saint-Jean-Baptiste",
                        "latitude": "45.38060000",
                        "longitude": "-74.01210000"
                    },
                    {
                        "id": 16955,
                        "name": "Saint-Jean-sur-Richelieu",
                        "latitude": "45.30713000",
                        "longitude": "-73.26259000"
                    },
                    {
                        "id": 16960,
                        "name": "Saint-Jérôme",
                        "latitude": "45.78036000",
                        "longitude": "-74.00365000"
                    },
                    {
                        "id": 16956,
                        "name": "Saint-Joseph",
                        "latitude": "45.95817000",
                        "longitude": "-73.22025000"
                    },
                    {
                        "id": 16957,
                        "name": "Saint-Joseph-de-Beauce",
                        "latitude": "46.30000000",
                        "longitude": "-70.86667000"
                    },
                    {
                        "id": 16958,
                        "name": "Saint-Joseph-de-Coleraine",
                        "latitude": "45.96677000",
                        "longitude": "-71.36577000"
                    },
                    {
                        "id": 16959,
                        "name": "Saint-Joseph-du-Lac",
                        "latitude": "45.53338000",
                        "longitude": "-73.99920000"
                    },
                    {
                        "id": 16961,
                        "name": "Saint-Lambert-de-Lauzon",
                        "latitude": "46.58624000",
                        "longitude": "-71.20892000"
                    },
                    {
                        "id": 16962,
                        "name": "Saint-Laurent",
                        "latitude": "45.50008000",
                        "longitude": "-73.66585000"
                    },
                    {
                        "id": 16963,
                        "name": "Saint-Lazare",
                        "latitude": "45.40008000",
                        "longitude": "-74.13256000"
                    },
                    {
                        "id": 16966,
                        "name": "Saint-Léonard",
                        "latitude": "45.58773000",
                        "longitude": "-73.59501000"
                    },
                    {
                        "id": 16968,
                        "name": "Saint-Léonard-d'Aston",
                        "latitude": "46.10006000",
                        "longitude": "-72.36580000"
                    },
                    {
                        "id": 16964,
                        "name": "Saint-Liboire",
                        "latitude": "45.65068000",
                        "longitude": "-72.76348000"
                    },
                    {
                        "id": 16965,
                        "name": "Saint-Lin-Laurentides",
                        "latitude": "45.85008000",
                        "longitude": "-73.76588000"
                    },
                    {
                        "id": 16969,
                        "name": "Saint-Marc-des-Carrières",
                        "latitude": "46.68335000",
                        "longitude": "-72.04910000"
                    },
                    {
                        "id": 16970,
                        "name": "Saint-Mathieu",
                        "latitude": "45.31678000",
                        "longitude": "-73.51587000"
                    },
                    {
                        "id": 16971,
                        "name": "Saint-Michel",
                        "latitude": "45.56758000",
                        "longitude": "-73.62168000"
                    },
                    {
                        "id": 16972,
                        "name": "Saint-Michel-des-Saints",
                        "latitude": "46.67702000",
                        "longitude": "-73.91881000"
                    },
                    {
                        "id": 16973,
                        "name": "Saint-Nazaire",
                        "latitude": "48.58944000",
                        "longitude": "-71.55247000"
                    },
                    {
                        "id": 16974,
                        "name": "Saint-Norbert",
                        "latitude": "46.16949000",
                        "longitude": "-73.31494000"
                    },
                    {
                        "id": 16975,
                        "name": "Saint-Pacôme",
                        "latitude": "47.40457000",
                        "longitude": "-69.95025000"
                    },
                    {
                        "id": 16976,
                        "name": "Saint-Pascal",
                        "latitude": "47.51813000",
                        "longitude": "-69.80301000"
                    },
                    {
                        "id": 16977,
                        "name": "Saint-Philippe-de-La Prairie",
                        "latitude": "45.35723000",
                        "longitude": "-73.47706000"
                    },
                    {
                        "id": 16978,
                        "name": "Saint-Pie",
                        "latitude": "45.50277000",
                        "longitude": "-72.90890000"
                    },
                    {
                        "id": 16979,
                        "name": "Saint-Pierre-les-Becquets",
                        "latitude": "46.50005000",
                        "longitude": "-72.19910000"
                    },
                    {
                        "id": 16980,
                        "name": "Saint-Prime",
                        "latitude": "48.58339000",
                        "longitude": "-72.33244000"
                    },
                    {
                        "id": 16981,
                        "name": "Saint-Raphaël",
                        "latitude": "46.25011000",
                        "longitude": "-76.01605000"
                    },
                    {
                        "id": 16982,
                        "name": "Saint-Raymond",
                        "latitude": "45.46698000",
                        "longitude": "-73.60948000"
                    },
                    {
                        "id": 16983,
                        "name": "Saint-Rémi",
                        "latitude": "45.26678000",
                        "longitude": "-73.61588000"
                    },
                    {
                        "id": 16984,
                        "name": "Saint-Rémi-de-Tingwick",
                        "latitude": "45.86677000",
                        "longitude": "-71.81581000"
                    },
                    {
                        "id": 16985,
                        "name": "Saint-Sauveur",
                        "latitude": "45.88686000",
                        "longitude": "-74.17943000"
                    },
                    {
                        "id": 16986,
                        "name": "Saint-Sauveur-des-Monts",
                        "latitude": "45.90008000",
                        "longitude": "-74.16591000"
                    },
                    {
                        "id": 16987,
                        "name": "Saint-Siméon",
                        "latitude": "47.84431000",
                        "longitude": "-69.87837000"
                    },
                    {
                        "id": 16988,
                        "name": "Saint-Thomas",
                        "latitude": "46.01677000",
                        "longitude": "-73.34915000"
                    },
                    {
                        "id": 16989,
                        "name": "Saint-Tite",
                        "latitude": "46.73336000",
                        "longitude": "-72.56581000"
                    },
                    {
                        "id": 16990,
                        "name": "Saint-Victor",
                        "latitude": "45.61118000",
                        "longitude": "-73.51527000"
                    },
                    {
                        "id": 16991,
                        "name": "Saint-Zotique",
                        "latitude": "45.25009000",
                        "longitude": "-74.24924000"
                    },
                    {
                        "id": 16994,
                        "name": "Sainte Catherine de la Jacques Cartier",
                        "latitude": "46.85244000",
                        "longitude": "-71.62056000"
                    },
                    {
                        "id": 16995,
                        "name": "Sainte-Adèle",
                        "latitude": "45.95008000",
                        "longitude": "-74.13251000"
                    },
                    {
                        "id": 16996,
                        "name": "Sainte-Agathe-des-Monts",
                        "latitude": "46.05009000",
                        "longitude": "-74.28252000"
                    },
                    {
                        "id": 16997,
                        "name": "Sainte-Anne-de-Bellevue",
                        "latitude": "45.40618000",
                        "longitude": "-73.94560000"
                    },
                    {
                        "id": 16998,
                        "name": "Sainte-Anne-des-Monts",
                        "latitude": "49.12402000",
                        "longitude": "-66.49243000"
                    },
                    {
                        "id": 16999,
                        "name": "Sainte-Anne-des-Plaines",
                        "latitude": "45.76468000",
                        "longitude": "-73.81156000"
                    },
                    {
                        "id": 17000,
                        "name": "Sainte-Béatrix",
                        "latitude": "46.20007000",
                        "longitude": "-73.61587000"
                    },
                    {
                        "id": 17001,
                        "name": "Sainte-Catherine",
                        "latitude": "45.40008000",
                        "longitude": "-73.58248000"
                    },
                    {
                        "id": 17002,
                        "name": "Sainte-Croix",
                        "latitude": "45.13368000",
                        "longitude": "-72.80083000"
                    },
                    {
                        "id": 17012,
                        "name": "Sainte-Élisabeth",
                        "latitude": "46.09502000",
                        "longitude": "-73.35176000"
                    },
                    {
                        "id": 17003,
                        "name": "Sainte-Julie",
                        "latitude": "45.58338000",
                        "longitude": "-73.33246000"
                    },
                    {
                        "id": 17004,
                        "name": "Sainte-Julienne",
                        "latitude": "45.96677000",
                        "longitude": "-73.71587000"
                    },
                    {
                        "id": 17005,
                        "name": "Sainte-Madeleine",
                        "latitude": "45.60008000",
                        "longitude": "-73.09914000"
                    },
                    {
                        "id": 17006,
                        "name": "Sainte-Marie",
                        "latitude": "46.43401000",
                        "longitude": "-71.01168000"
                    },
                    {
                        "id": 17007,
                        "name": "Sainte-Marthe-sur-le-Lac",
                        "latitude": "45.53338000",
                        "longitude": "-73.93250000"
                    },
                    {
                        "id": 17008,
                        "name": "Sainte-Martine",
                        "latitude": "45.25008000",
                        "longitude": "-73.79919000"
                    },
                    {
                        "id": 17009,
                        "name": "Sainte-Sophie",
                        "latitude": "45.81678000",
                        "longitude": "-73.89919000"
                    },
                    {
                        "id": 17010,
                        "name": "Sainte-Thècle",
                        "latitude": "46.81676000",
                        "longitude": "-72.49911000"
                    },
                    {
                        "id": 17011,
                        "name": "Sainte-Thérèse",
                        "latitude": "45.63922000",
                        "longitude": "-73.82757000"
                    },
                    {
                        "id": 17013,
                        "name": "Salaberry-de-Valleyfield",
                        "latitude": "45.25008000",
                        "longitude": "-74.13253000"
                    },
                    {
                        "id": 17015,
                        "name": "Salluit",
                        "latitude": "62.20411000",
                        "longitude": "-75.64344000"
                    },
                    {
                        "id": 17027,
                        "name": "Senneterre",
                        "latitude": "48.39302000",
                        "longitude": "-77.23951000"
                    },
                    {
                        "id": 17028,
                        "name": "Sept-Îles",
                        "latitude": "50.20011000",
                        "longitude": "-66.38208000"
                    },
                    {
                        "id": 17030,
                        "name": "Shannon",
                        "latitude": "46.88026000",
                        "longitude": "-71.51464000"
                    },
                    {
                        "id": 17032,
                        "name": "Shawinigan",
                        "latitude": "46.56675000",
                        "longitude": "-72.74913000"
                    },
                    {
                        "id": 17033,
                        "name": "Shawville",
                        "latitude": "45.60011000",
                        "longitude": "-76.48270000"
                    },
                    {
                        "id": 17039,
                        "name": "Sherbrooke",
                        "latitude": "45.40008000",
                        "longitude": "-71.89908000"
                    },
                    {
                        "id": 17054,
                        "name": "Sorel-Tracy",
                        "latitude": "46.04178000",
                        "longitude": "-73.11358000"
                    },
                    {
                        "id": 17066,
                        "name": "St-Jean-Port-Joli",
                        "latitude": "47.21418000",
                        "longitude": "-70.26969000"
                    },
                    {
                        "id": 17091,
                        "name": "Sutton",
                        "latitude": "45.10008000",
                        "longitude": "-72.61582000"
                    },
                    {
                        "id": 17132,
                        "name": "Témiscaming",
                        "latitude": "46.72122000",
                        "longitude": "-79.09712000"
                    },
                    {
                        "id": 17103,
                        "name": "Terrasse-des-Pins",
                        "latitude": "45.86449000",
                        "longitude": "-74.06627000"
                    },
                    {
                        "id": 17104,
                        "name": "Terrebonne",
                        "latitude": "45.70004000",
                        "longitude": "-73.64732000"
                    },
                    {
                        "id": 17107,
                        "name": "Thetford-Mines",
                        "latitude": "46.09371000",
                        "longitude": "-71.30539000"
                    },
                    {
                        "id": 17113,
                        "name": "Thurso",
                        "latitude": "45.60010000",
                        "longitude": "-75.24931000"
                    },
                    {
                        "id": 17126,
                        "name": "Trois-Rivières",
                        "latitude": "46.34515000",
                        "longitude": "-72.54770000"
                    },
                    {
                        "id": 17139,
                        "name": "Val-d'Or",
                        "latitude": "48.09740000",
                        "longitude": "-77.79737000"
                    },
                    {
                        "id": 17137,
                        "name": "Val-David",
                        "latitude": "46.03338000",
                        "longitude": "-74.21592000"
                    },
                    {
                        "id": 17140,
                        "name": "Val-des-Monts",
                        "latitude": "45.65010000",
                        "longitude": "-75.66604000"
                    },
                    {
                        "id": 17138,
                        "name": "Val-Morin",
                        "latitude": "46.00008000",
                        "longitude": "-74.18251000"
                    },
                    {
                        "id": 17141,
                        "name": "Valcourt",
                        "latitude": "45.50008000",
                        "longitude": "-72.31581000"
                    },
                    {
                        "id": 17144,
                        "name": "Vallée-Jonction",
                        "latitude": "46.37441000",
                        "longitude": "-70.91881000"
                    },
                    {
                        "id": 17148,
                        "name": "Varennes",
                        "latitude": "45.68338000",
                        "longitude": "-73.43246000"
                    },
                    {
                        "id": 17149,
                        "name": "Vaudreuil-Dorion",
                        "latitude": "45.40008000",
                        "longitude": "-74.03251000"
                    },
                    {
                        "id": 17152,
                        "name": "Venise-en-Québec",
                        "latitude": "45.08338000",
                        "longitude": "-73.13245000"
                    },
                    {
                        "id": 17153,
                        "name": "Verchères",
                        "latitude": "45.78338000",
                        "longitude": "-73.34916000"
                    },
                    {
                        "id": 17157,
                        "name": "Victoriaville",
                        "latitude": "46.05007000",
                        "longitude": "-71.96579000"
                    },
                    {
                        "id": 17159,
                        "name": "Ville-Marie",
                        "latitude": "47.33345000",
                        "longitude": "-79.43297000"
                    },
                    {
                        "id": 17167,
                        "name": "Wakefield",
                        "latitude": "45.66680000",
                        "longitude": "-75.83265000"
                    },
                    {
                        "id": 17171,
                        "name": "Warwick",
                        "latitude": "45.95007000",
                        "longitude": "-71.98240000"
                    },
                    {
                        "id": 17173,
                        "name": "Waskaganish",
                        "latitude": "51.48333000",
                        "longitude": "-78.75000000"
                    },
                    {
                        "id": 17174,
                        "name": "Waswanipi",
                        "latitude": "49.73346000",
                        "longitude": "-76.16604000"
                    },
                    {
                        "id": 17177,
                        "name": "Waterloo",
                        "latitude": "45.35008000",
                        "longitude": "-72.51582000"
                    },
                    {
                        "id": 17182,
                        "name": "Weedon Centre",
                        "latitude": "45.70802000",
                        "longitude": "-71.45986000"
                    },
                    {
                        "id": 17196,
                        "name": "Westmount",
                        "latitude": "45.48341000",
                        "longitude": "-73.59918000"
                    },
                    {
                        "id": 17199,
                        "name": "Weymontachie",
                        "latitude": "47.89940000",
                        "longitude": "-73.77720000"
                    },
                    {
                        "id": 17210,
                        "name": "Windsor",
                        "latitude": "45.56678000",
                        "longitude": "-71.99909000"
                    },
                    {
                        "id": 17219,
                        "name": "Yamachiche",
                        "latitude": "46.26676000",
                        "longitude": "-72.83243000"
                    }
                ]
            },
            {
                "id": 870,
                "name": "Saskatchewan",
                "iso2": "SK",
                "latitude": "52.93991590",
                "longitude": "-106.45086390",
                "type": "province",
                "cities": [
                    {
                        "id": 16177,
                        "name": "Assiniboia",
                        "latitude": "49.63336000",
                        "longitude": "-105.98446000"
                    },
                    {
                        "id": 16217,
                        "name": "Biggar",
                        "latitude": "52.06680000",
                        "longitude": "-108.00135000"
                    },
                    {
                        "id": 16268,
                        "name": "Canora",
                        "latitude": "51.63328000",
                        "longitude": "-102.43425000"
                    },
                    {
                        "id": 16282,
                        "name": "Carlyle",
                        "latitude": "49.63334000",
                        "longitude": "-102.26765000"
                    },
                    {
                        "id": 16353,
                        "name": "Dalmeny",
                        "latitude": "52.33339000",
                        "longitude": "-106.76792000"
                    },
                    {
                        "id": 16410,
                        "name": "Esterhazy",
                        "latitude": "50.65001000",
                        "longitude": "-102.08426000"
                    },
                    {
                        "id": 16411,
                        "name": "Estevan",
                        "latitude": "49.13337000",
                        "longitude": "-102.98422000"
                    },
                    {
                        "id": 16424,
                        "name": "Foam Lake",
                        "latitude": "51.65001000",
                        "longitude": "-103.53431000"
                    },
                    {
                        "id": 16469,
                        "name": "Gravelbourg",
                        "latitude": "49.88336000",
                        "longitude": "-106.55122000"
                    },
                    {
                        "id": 16512,
                        "name": "Hudson Bay",
                        "latitude": "52.85003000",
                        "longitude": "-102.38425000"
                    },
                    {
                        "id": 16513,
                        "name": "Humboldt",
                        "latitude": "52.20005000",
                        "longitude": "-105.12550000"
                    },
                    {
                        "id": 16519,
                        "name": "Indian Head",
                        "latitude": "50.53336000",
                        "longitude": "-103.66775000"
                    },
                    {
                        "id": 16532,
                        "name": "Kamsack",
                        "latitude": "51.56668000",
                        "longitude": "-101.90093000"
                    },
                    {
                        "id": 16540,
                        "name": "Kerrobert",
                        "latitude": "51.91682000",
                        "longitude": "-109.13479000"
                    },
                    {
                        "id": 16547,
                        "name": "Kindersley",
                        "latitude": "51.46681000",
                        "longitude": "-109.16818000"
                    },
                    {
                        "id": 16570,
                        "name": "La Ronge",
                        "latitude": "55.10013000",
                        "longitude": "-105.28422000"
                    },
                    {
                        "id": 16594,
                        "name": "Langenburg",
                        "latitude": "50.84999000",
                        "longitude": "-101.71763000"
                    },
                    {
                        "id": 16596,
                        "name": "Langham",
                        "latitude": "52.36680000",
                        "longitude": "-106.96793000"
                    },
                    {
                        "id": 16598,
                        "name": "Lanigan",
                        "latitude": "51.85006000",
                        "longitude": "-105.03443000"
                    },
                    {
                        "id": 16636,
                        "name": "Lumsden",
                        "latitude": "50.65009000",
                        "longitude": "-104.86783000"
                    },
                    {
                        "id": 16642,
                        "name": "Macklin",
                        "latitude": "52.33344000",
                        "longitude": "-109.93484000"
                    },
                    {
                        "id": 16655,
                        "name": "Maple Creek",
                        "latitude": "49.91678000",
                        "longitude": "-109.48481000"
                    },
                    {
                        "id": 16663,
                        "name": "Martensville",
                        "latitude": "52.28339000",
                        "longitude": "-106.66792000"
                    },
                    {
                        "id": 16673,
                        "name": "Meadow Lake",
                        "latitude": "54.13348000",
                        "longitude": "-108.43471000"
                    },
                    {
                        "id": 16676,
                        "name": "Melfort",
                        "latitude": "52.86673000",
                        "longitude": "-104.61768000"
                    },
                    {
                        "id": 16679,
                        "name": "Melville",
                        "latitude": "50.91671000",
                        "longitude": "-102.80099000"
                    },
                    {
                        "id": 16713,
                        "name": "Moose Jaw",
                        "latitude": "50.40005000",
                        "longitude": "-105.53445000"
                    },
                    {
                        "id": 16715,
                        "name": "Moosomin",
                        "latitude": "50.13332000",
                        "longitude": "-101.66766000"
                    },
                    {
                        "id": 16747,
                        "name": "Nipawin",
                        "latitude": "53.36678000",
                        "longitude": "-104.00092000"
                    },
                    {
                        "id": 16755,
                        "name": "North Battleford",
                        "latitude": "52.77972000",
                        "longitude": "-108.29670000"
                    },
                    {
                        "id": 16788,
                        "name": "Outlook",
                        "latitude": "51.50008000",
                        "longitude": "-107.05128000"
                    },
                    {
                        "id": 16790,
                        "name": "Oxbow",
                        "latitude": "49.23335000",
                        "longitude": "-102.16760000"
                    },
                    {
                        "id": 16807,
                        "name": "Pelican Narrows",
                        "latitude": "55.16685000",
                        "longitude": "-102.93410000"
                    },
                    {
                        "id": 16823,
                        "name": "Pilot Butte",
                        "latitude": "50.46678000",
                        "longitude": "-104.41778000"
                    },
                    {
                        "id": 16852,
                        "name": "Preeceville",
                        "latitude": "51.94998000",
                        "longitude": "-102.66766000"
                    },
                    {
                        "id": 16854,
                        "name": "Prince Albert",
                        "latitude": "53.20008000",
                        "longitude": "-105.76772000"
                    },
                    {
                        "id": 16875,
                        "name": "Regina",
                        "latitude": "50.45008000",
                        "longitude": "-104.61780000"
                    },
                    {
                        "id": 16876,
                        "name": "Regina Beach",
                        "latitude": "50.78338000",
                        "longitude": "-105.00112000"
                    },
                    {
                        "id": 16903,
                        "name": "Rosetown",
                        "latitude": "51.55010000",
                        "longitude": "-108.00136000"
                    },
                    {
                        "id": 16905,
                        "name": "Rosthern",
                        "latitude": "52.66679000",
                        "longitude": "-106.33446000"
                    },
                    {
                        "id": 17021,
                        "name": "Saskatoon",
                        "latitude": "52.13238000",
                        "longitude": "-106.66892000"
                    },
                    {
                        "id": 17031,
                        "name": "Shaunavon",
                        "latitude": "49.65005000",
                        "longitude": "-108.41810000"
                    },
                    {
                        "id": 17038,
                        "name": "Shellbrook",
                        "latitude": "53.21679000",
                        "longitude": "-106.40109000"
                    },
                    {
                        "id": 17094,
                        "name": "Swift Current",
                        "latitude": "50.28337000",
                        "longitude": "-107.80135000"
                    },
                    {
                        "id": 17116,
                        "name": "Tisdale",
                        "latitude": "52.85002000",
                        "longitude": "-104.05096000"
                    },
                    {
                        "id": 17134,
                        "name": "Unity",
                        "latitude": "52.45014000",
                        "longitude": "-109.16816000"
                    },
                    {
                        "id": 17165,
                        "name": "Wadena",
                        "latitude": "51.94999000",
                        "longitude": "-103.80102000"
                    },
                    {
                        "id": 17170,
                        "name": "Warman",
                        "latitude": "52.31679000",
                        "longitude": "-106.56791000"
                    },
                    {
                        "id": 17179,
                        "name": "Watrous",
                        "latitude": "51.66677000",
                        "longitude": "-105.46788000"
                    },
                    {
                        "id": 17198,
                        "name": "Weyburn",
                        "latitude": "49.66675000",
                        "longitude": "-103.85109000"
                    },
                    {
                        "id": 17201,
                        "name": "White City",
                        "latitude": "50.43338000",
                        "longitude": "-104.36778000"
                    },
                    {
                        "id": 17206,
                        "name": "Wilkie",
                        "latitude": "52.41683000",
                        "longitude": "-108.70142000"
                    },
                    {
                        "id": 17218,
                        "name": "Wynyard",
                        "latitude": "51.76674000",
                        "longitude": "-104.18436000"
                    },
                    {
                        "id": 17223,
                        "name": "Yorkton",
                        "latitude": "51.21670000",
                        "longitude": "-102.46766000"
                    }
                ]
            },
            {
                "id": 869,
                "name": "Yukon",
                "iso2": "YT",
                "latitude": "35.50672150",
                "longitude": "-97.76254410",
                "type": "territory",
                "cities": [
                    {
                        "id": 16358,
                        "name": "Dawson City",
                        "latitude": "64.06013000",
                        "longitude": "-139.43328000"
                    },
                    {
                        "id": 16479,
                        "name": "Haines Junction",
                        "latitude": "60.75216000",
                        "longitude": "-137.51082000"
                    },
                    {
                        "id": 17180,
                        "name": "Watson Lake",
                        "latitude": "60.06349000",
                        "longitude": "-128.70893000"
                    },
                    {
                        "id": 17204,
                        "name": "Whitehorse",
                        "latitude": "60.71611000",
                        "longitude": "-135.05375000"
                    }
                ]
            }
        ]
    },
    {
        "id": 40,
        "name": "Cape Verde",
        "iso3": "CPV",
        "iso2": "CV",
        "numeric_code": "132",
        "phonecode": "238",
        "capital": "Praia",
        "currency": "CVE",
        "currency_name": "Cape Verdean escudo",
        "currency_symbol": "$",
        "tld": ".cv",
        "native": "Cabo Verde",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Verdean",
        "timezones": [
            {
                "zoneName": "Atlantic\/Cape_Verde",
                "gmtOffset": -3600,
                "gmtOffsetName": "UTC-01:00",
                "abbreviation": "CVT",
                "tzName": "Cape Verde Time"
            }
        ],
        "translations": {
            "br": "Kab Glas",
            "ko": "카보베르데",
            "pt-BR": "Cabo Verde",
            "pt": "Cabo Verde",
            "nl": "Kaapverdië",
            "hr": "Zelenortska Republika",
            "fa": "کیپ ورد",
            "de": "Kap Verde",
            "es": "Cabo Verde",
            "fr": "Cap Vert",
            "ja": "カーボベルデ",
            "it": "Capo Verde",
            "zh-CN": "佛得角",
            "tr": "Cabo Verde",
            "ru": "Кабо-Верде",
            "uk": "Кабо-Верде",
            "pl": "Republika Zielonego Przylądka"
        },
        "latitude": "16.00000000",
        "longitude": "-24.00000000",
        "emoji": "🇨🇻",
        "emojiU": "U+1F1E8 U+1F1FB",
        "states": [
            {
                "id": 2994,
                "name": "Barlavento Islands",
                "iso2": "B",
                "latitude": "16.82368450",
                "longitude": "-23.99348810",
                "type": "geographical region",
                "cities": []
            },
            {
                "id": 2999,
                "name": "Boa Vista",
                "iso2": "BV",
                "latitude": "38.74346600",
                "longitude": "-120.73042970",
                "type": "municipality",
                "cities": [
                    {
                        "id": 22003,
                        "name": "Sal Rei",
                        "latitude": "16.17611000",
                        "longitude": "-22.91722000"
                    }
                ]
            },
            {
                "id": 2996,
                "name": "Brava",
                "iso2": "BR",
                "latitude": "40.98977780",
                "longitude": "-73.68357150",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21995,
                        "name": "Nova Sintra",
                        "latitude": "14.87139000",
                        "longitude": "-24.69556000"
                    }
                ]
            },
            {
                "id": 2991,
                "name": "Maio",
                "iso2": "MA",
                "latitude": "15.20030980",
                "longitude": "-23.16797930",
                "type": "municipality",
                "cities": [
                    {
                        "id": 22010,
                        "name": "Vila do Maio",
                        "latitude": "15.13823000",
                        "longitude": "-23.21158000"
                    }
                ]
            },
            {
                "id": 2987,
                "name": "Mosteiros",
                "iso2": "MO",
                "latitude": "37.89043480",
                "longitude": "-25.82075560",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21992,
                        "name": "Igreja",
                        "latitude": "15.03389000",
                        "longitude": "-24.32500000"
                    }
                ]
            },
            {
                "id": 2997,
                "name": "Paul",
                "iso2": "PA",
                "latitude": "37.06250000",
                "longitude": "-95.67706800",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21997,
                        "name": "Pombas",
                        "latitude": "17.15026000",
                        "longitude": "-25.02007000"
                    }
                ]
            },
            {
                "id": 2989,
                "name": "Porto Novo",
                "iso2": "PN",
                "latitude": "6.49685740",
                "longitude": "2.62885230",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21999,
                        "name": "Porto Novo",
                        "latitude": "17.01969000",
                        "longitude": "-25.06471000"
                    }
                ]
            },
            {
                "id": 2988,
                "name": "Praia",
                "iso2": "PR",
                "latitude": "14.93305000",
                "longitude": "-23.51332670",
                "type": "municipality",
                "cities": [
                    {
                        "id": 22000,
                        "name": "Praia",
                        "latitude": "14.93152000",
                        "longitude": "-23.51254000"
                    }
                ]
            },
            {
                "id": 2982,
                "name": "Ribeira Brava",
                "iso2": "RB",
                "latitude": "16.60707390",
                "longitude": "-24.20338430",
                "type": "municipality",
                "cities": [
                    {
                        "id": 22001,
                        "name": "Ribeira Brava",
                        "latitude": "16.61583000",
                        "longitude": "-24.29833000"
                    }
                ]
            },
            {
                "id": 3002,
                "name": "Ribeira Grande",
                "iso2": "RG",
                "latitude": "37.82103690",
                "longitude": "-25.51481370",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21998,
                        "name": "Ponta do Sol",
                        "latitude": "17.20171000",
                        "longitude": "-25.09217000"
                    },
                    {
                        "id": 22002,
                        "name": "Ribeira Grande",
                        "latitude": "17.18250000",
                        "longitude": "-25.06500000"
                    }
                ]
            },
            {
                "id": 2984,
                "name": "Ribeira Grande de Santiago",
                "iso2": "RS",
                "latitude": "14.98302980",
                "longitude": "-23.65617250",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21989,
                        "name": "Cidade Velha",
                        "latitude": "14.91531000",
                        "longitude": "-23.60527000"
                    }
                ]
            },
            {
                "id": 2998,
                "name": "Sal",
                "iso2": "SL",
                "latitude": "26.59581220",
                "longitude": "-80.20450830",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21991,
                        "name": "Espargos",
                        "latitude": "16.75524000",
                        "longitude": "-22.94460000"
                    },
                    {
                        "id": 22005,
                        "name": "Santa Maria",
                        "latitude": "16.59796000",
                        "longitude": "-22.90509000"
                    }
                ]
            },
            {
                "id": 2985,
                "name": "Santa Catarina",
                "iso2": "CA",
                "latitude": "-27.24233920",
                "longitude": "-50.21885560",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21987,
                        "name": "Assomada",
                        "latitude": "15.10000000",
                        "longitude": "-23.68333000"
                    }
                ]
            },
            {
                "id": 2995,
                "name": "Santa Catarina do Fogo",
                "iso2": "CF",
                "latitude": "14.93091040",
                "longitude": "-24.32225770",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21990,
                        "name": "Cova Figueira",
                        "latitude": "14.89054000",
                        "longitude": "-24.29343000"
                    }
                ]
            },
            {
                "id": 3004,
                "name": "Santa Cruz",
                "iso2": "CR",
                "latitude": "36.97411710",
                "longitude": "-122.03079630",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21996,
                        "name": "Pedra Badejo",
                        "latitude": "15.13750000",
                        "longitude": "-23.53083000"
                    },
                    {
                        "id": 22004,
                        "name": "Santa Cruz",
                        "latitude": "15.13333000",
                        "longitude": "-23.56667000"
                    }
                ]
            },
            {
                "id": 2986,
                "name": "São Domingos",
                "iso2": "SD",
                "latitude": "15.02861650",
                "longitude": "-23.56392200",
                "type": "municipality",
                "cities": [
                    {
                        "id": 22006,
                        "name": "São Domingos",
                        "latitude": "15.02438000",
                        "longitude": "-23.56250000"
                    }
                ]
            },
            {
                "id": 3000,
                "name": "São Filipe",
                "iso2": "SF",
                "latitude": "14.89516790",
                "longitude": "-24.49456360",
                "type": "municipality",
                "cities": [
                    {
                        "id": 22007,
                        "name": "São Filipe",
                        "latitude": "14.89610000",
                        "longitude": "-24.49556000"
                    }
                ]
            },
            {
                "id": 2993,
                "name": "São Lourenço dos Órgãos",
                "iso2": "SO",
                "latitude": "15.05378410",
                "longitude": "-23.60856120",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21993,
                        "name": "João Teves",
                        "latitude": "15.06694000",
                        "longitude": "-23.58917000"
                    }
                ]
            },
            {
                "id": 2990,
                "name": "São Miguel",
                "iso2": "SM",
                "latitude": "37.78041100",
                "longitude": "-25.49704660",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21988,
                        "name": "Calheta",
                        "latitude": "15.18613000",
                        "longitude": "-23.59228000"
                    }
                ]
            },
            {
                "id": 3001,
                "name": "São Vicente",
                "iso2": "SV",
                "latitude": "-23.96071570",
                "longitude": "-46.39620220",
                "type": "municipality",
                "cities": [
                    {
                        "id": 21994,
                        "name": "Mindelo",
                        "latitude": "16.89014000",
                        "longitude": "-24.98042000"
                    }
                ]
            },
            {
                "id": 2992,
                "name": "Sotavento Islands",
                "iso2": "S",
                "latitude": "15.00000000",
                "longitude": "-24.00000000",
                "type": "geographical region",
                "cities": []
            },
            {
                "id": 2983,
                "name": "Tarrafal",
                "iso2": "TA",
                "latitude": "15.27605780",
                "longitude": "-23.74840770",
                "type": "municipality",
                "cities": [
                    {
                        "id": 22008,
                        "name": "Tarrafal",
                        "latitude": "15.27881000",
                        "longitude": "-23.75192000"
                    }
                ]
            },
            {
                "id": 3003,
                "name": "Tarrafal de São Nicolau",
                "iso2": "TS",
                "latitude": "16.56364980",
                "longitude": "-24.35494200",
                "type": "municipality",
                "cities": [
                    {
                        "id": 22009,
                        "name": "Tarrafal de São Nicolau",
                        "latitude": "16.56622000",
                        "longitude": "-24.35793000"
                    }
                ]
            }
        ]
    },
    {
        "id": 41,
        "name": "Cayman Islands",
        "iso3": "CYM",
        "iso2": "KY",
        "numeric_code": "136",
        "phonecode": "1",
        "capital": "George Town",
        "currency": "KYD",
        "currency_name": "Cayman Islands dollar",
        "currency_symbol": "$",
        "tld": ".ky",
        "native": "Cayman Islands",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Caymanian",
        "timezones": [
            {
                "zoneName": "America\/Cayman",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Inizi Cayman",
            "ko": "케이먼 제도",
            "pt-BR": "Ilhas Cayman",
            "pt": "Ilhas Caimão",
            "nl": "Caymaneilanden",
            "hr": "Kajmanski otoci",
            "fa": "جزایر کیمن",
            "de": "Kaimaninseln",
            "es": "Islas Caimán",
            "fr": "Îles Caïmans",
            "ja": "ケイマン諸島",
            "it": "Isole Cayman",
            "zh-CN": "开曼群岛",
            "tr": "Cayman Adalari",
            "ru": "Каймановы острова",
            "uk": "Кайманові острови",
            "pl": "Kajmany"
        },
        "latitude": "19.50000000",
        "longitude": "-80.50000000",
        "emoji": "🇰🇾",
        "emojiU": "U+1F1F0 U+1F1FE",
        "states": [
            {
                "id": 5252,
                "name": "Cayman Brac",
                "iso2": "NULL",
                "latitude": "19.71999700",
                "longitude": "-79.89072660",
                "type": "NULL",
                "cities": [
                    {
                        "id": 153943,
                        "name": "Cayman Brac",
                        "latitude": "19.71999700",
                        "longitude": "-79.89072660"
                    }
                ]
            },
            {
                "id": 5251,
                "name": "Grand Cayman",
                "iso2": "NULL",
                "latitude": "19.33012710",
                "longitude": "-81.41724510",
                "type": "NULL",
                "cities": [
                    {
                        "id": 153938,
                        "name": "Bodden Town",
                        "latitude": "19.27966930",
                        "longitude": "-81.27779990"
                    },
                    {
                        "id": 153939,
                        "name": "East End",
                        "latitude": "19.29958980",
                        "longitude": "-81.11961380"
                    },
                    {
                        "id": 153940,
                        "name": "George Town",
                        "latitude": "19.29023260",
                        "longitude": "-81.44333720"
                    },
                    {
                        "id": 153941,
                        "name": "North Side",
                        "latitude": "19.33620470",
                        "longitude": "-81.51398130"
                    },
                    {
                        "id": 153942,
                        "name": "West Bay",
                        "latitude": "19.36651530",
                        "longitude": "-81.43170260"
                    }
                ]
            },
            {
                "id": 5253,
                "name": "Little Cayman",
                "iso2": "NULL",
                "latitude": "19.68567390",
                "longitude": "-80.11830190",
                "type": "NULL",
                "cities": [
                    {
                        "id": 153944,
                        "name": "Little Cayman",
                        "latitude": "19.68567390",
                        "longitude": "-80.11830190"
                    }
                ]
            }
        ]
    },
    {
        "id": 42,
        "name": "Central African Republic",
        "iso3": "CAF",
        "iso2": "CF",
        "numeric_code": "140",
        "phonecode": "236",
        "capital": "Bangui",
        "currency": "XAF",
        "currency_name": "Central African CFA franc",
        "currency_symbol": "FCFA",
        "tld": ".cf",
        "native": "Ködörösêse tî Bêafrîka",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Middle Africa",
        "subregion_id": 2,
        "nationality": "Central African",
        "timezones": [
            {
                "zoneName": "Africa\/Bangui",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "br": "Republik Kreizafrikan",
            "ko": "중앙아프리카 공화국",
            "pt-BR": "República Centro-Africana",
            "pt": "República Centro-Africana",
            "nl": "Centraal-Afrikaanse Republiek",
            "hr": "Srednjoafrička Republika",
            "fa": "جمهوری آفریقای مرکزی",
            "de": "Zentralafrikanische Republik",
            "es": "República Centroafricana",
            "fr": "République centrafricaine",
            "ja": "中央アフリカ共和国",
            "it": "Repubblica Centrafricana",
            "zh-CN": "中非",
            "tr": "Orta Afrika Cumhuriyeti",
            "ru": "Центральноафриканская Республика",
            "uk": "Центральноафриканська Республіка",
            "pl": "Republika Środkowoafrykańska"
        },
        "latitude": "7.00000000",
        "longitude": "21.00000000",
        "emoji": "🇨🇫",
        "emojiU": "U+1F1E8 U+1F1EB",
        "states": [
            {
                "id": 1259,
                "name": "Bamingui-Bangoran",
                "iso2": "BB",
                "latitude": "8.27334550",
                "longitude": "20.71224650",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17296,
                        "name": "Bamingui",
                        "latitude": "7.88897000",
                        "longitude": "20.04875000"
                    },
                    {
                        "id": 17329,
                        "name": "Ndélé",
                        "latitude": "8.74287000",
                        "longitude": "20.89108000"
                    }
                ]
            },
            {
                "id": 1262,
                "name": "Bangui",
                "iso2": "BGF",
                "latitude": "4.39467350",
                "longitude": "18.55818990",
                "type": "commune",
                "cities": [
                    {
                        "id": 17298,
                        "name": "Bangui",
                        "latitude": "4.36122000",
                        "longitude": "18.55496000"
                    }
                ]
            },
            {
                "id": 1264,
                "name": "Basse-Kotto",
                "iso2": "BK",
                "latitude": "4.87193190",
                "longitude": "21.28450250",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17294,
                        "name": "Alindao",
                        "latitude": "5.02667000",
                        "longitude": "21.20876000"
                    },
                    {
                        "id": 17323,
                        "name": "Kembé",
                        "latitude": "4.62275000",
                        "longitude": "21.88645000"
                    },
                    {
                        "id": 17327,
                        "name": "Mobaye",
                        "latitude": "4.31902000",
                        "longitude": "21.17861000"
                    }
                ]
            },
            {
                "id": 1258,
                "name": "Haut-Mbomou",
                "iso2": "HM",
                "latitude": "6.25371340",
                "longitude": "25.47335540",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17331,
                        "name": "Obo",
                        "latitude": "5.39586000",
                        "longitude": "26.49211000"
                    },
                    {
                        "id": 17338,
                        "name": "Zemio",
                        "latitude": "5.03144000",
                        "longitude": "25.13614000"
                    }
                ]
            },
            {
                "id": 1268,
                "name": "Haute-Kotto",
                "iso2": "HK",
                "latitude": "7.79643790",
                "longitude": "23.38235450",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17313,
                        "name": "Bria",
                        "latitude": "6.54233000",
                        "longitude": "21.98633000"
                    },
                    {
                        "id": 17332,
                        "name": "Ouadda",
                        "latitude": "8.07771000",
                        "longitude": "22.40075000"
                    }
                ]
            },
            {
                "id": 1263,
                "name": "Kémo",
                "iso2": "KG",
                "latitude": "5.88677940",
                "longitude": "19.37832060",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17337,
                        "name": "Sibut",
                        "latitude": "5.71801000",
                        "longitude": "19.07389000"
                    }
                ]
            },
            {
                "id": 1256,
                "name": "Lobaye",
                "iso2": "LB",
                "latitude": "4.35259810",
                "longitude": "17.47951730",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17307,
                        "name": "Boda",
                        "latitude": "4.31887000",
                        "longitude": "17.46953000"
                    },
                    {
                        "id": 17308,
                        "name": "Boganangone",
                        "latitude": "4.73558000",
                        "longitude": "17.14047000"
                    },
                    {
                        "id": 17325,
                        "name": "Mbaiki",
                        "latitude": "3.97145000",
                        "longitude": "17.93352000"
                    },
                    {
                        "id": 17328,
                        "name": "Mongoumba",
                        "latitude": "3.64153000",
                        "longitude": "18.59364000"
                    }
                ]
            },
            {
                "id": 1257,
                "name": "Mambéré-Kadéï",
                "iso2": "HS",
                "latitude": "4.70556530",
                "longitude": "15.96998780",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17301,
                        "name": "Berberati",
                        "latitude": "4.31211000",
                        "longitude": "15.88948000"
                    },
                    {
                        "id": 17314,
                        "name": "Carnot",
                        "latitude": "4.94273000",
                        "longitude": "15.87735000"
                    },
                    {
                        "id": 17317,
                        "name": "Gamboula",
                        "latitude": "4.11775000",
                        "longitude": "15.13926000"
                    }
                ]
            },
            {
                "id": 1266,
                "name": "Mbomou",
                "iso2": "MB",
                "latitude": "5.55683700",
                "longitude": "23.76328280",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17297,
                        "name": "Bangassou",
                        "latitude": "4.74132000",
                        "longitude": "22.81838000"
                    },
                    {
                        "id": 17316,
                        "name": "Gambo",
                        "latitude": "4.64816000",
                        "longitude": "22.26331000"
                    },
                    {
                        "id": 17334,
                        "name": "Ouango",
                        "latitude": "4.31325000",
                        "longitude": "22.55524000"
                    },
                    {
                        "id": 17336,
                        "name": "Rafai",
                        "latitude": "5.81012000",
                        "longitude": "24.20305000"
                    }
                ]
            },
            {
                "id": 1253,
                "name": "Nana-Grébizi",
                "iso2": "KB",
                "latitude": "7.18486070",
                "longitude": "19.37832060",
                "type": "economic prefecture",
                "cities": [
                    {
                        "id": 17321,
                        "name": "Kaga Bandoro",
                        "latitude": "6.98961000",
                        "longitude": "19.18744000"
                    },
                    {
                        "id": 17322,
                        "name": "Kaga-Bandoro",
                        "latitude": "7.23774000",
                        "longitude": "19.21819000"
                    }
                ]
            },
            {
                "id": 1260,
                "name": "Nana-Mambéré",
                "iso2": "NM",
                "latitude": "5.69321350",
                "longitude": "15.21948080",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17299,
                        "name": "Baoro",
                        "latitude": "5.66667000",
                        "longitude": "15.96667000"
                    },
                    {
                        "id": 17310,
                        "name": "Bouar",
                        "latitude": "5.93404000",
                        "longitude": "15.59599000"
                    }
                ]
            },
            {
                "id": 1255,
                "name": "Ombella-M'Poko",
                "iso2": "MP",
                "latitude": "5.11888250",
                "longitude": "18.42760470",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17303,
                        "name": "Bimbo",
                        "latitude": "4.25671000",
                        "longitude": "18.41583000"
                    },
                    {
                        "id": 17305,
                        "name": "Boali",
                        "latitude": "4.80048000",
                        "longitude": "18.12747000"
                    },
                    {
                        "id": 17315,
                        "name": "Damara",
                        "latitude": "4.96075000",
                        "longitude": "18.70350000"
                    }
                ]
            },
            {
                "id": 1265,
                "name": "Ouaka",
                "iso2": "UK",
                "latitude": "6.31682160",
                "longitude": "20.71224650",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17295,
                        "name": "Bambari",
                        "latitude": "5.76795000",
                        "longitude": "20.67565000"
                    },
                    {
                        "id": 17318,
                        "name": "Grimari",
                        "latitude": "5.73549000",
                        "longitude": "19.91209000"
                    },
                    {
                        "id": 17319,
                        "name": "Ippy",
                        "latitude": "6.26793000",
                        "longitude": "21.22468000"
                    },
                    {
                        "id": 17324,
                        "name": "Kouango",
                        "latitude": "4.99337000",
                        "longitude": "19.96186000"
                    }
                ]
            },
            {
                "id": 1254,
                "name": "Ouham",
                "iso2": "AC",
                "latitude": "7.09091100",
                "longitude": "17.66888700",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17300,
                        "name": "Batangafo",
                        "latitude": "7.30082000",
                        "longitude": "18.28330000"
                    },
                    {
                        "id": 17309,
                        "name": "Bossangoa",
                        "latitude": "6.49263000",
                        "longitude": "17.45518000"
                    },
                    {
                        "id": 17311,
                        "name": "Bouca",
                        "latitude": "6.50734000",
                        "longitude": "18.27670000"
                    },
                    {
                        "id": 17320,
                        "name": "Kabo",
                        "latitude": "7.69937000",
                        "longitude": "18.62903000"
                    }
                ]
            },
            {
                "id": 1267,
                "name": "Ouham-Pendé",
                "iso2": "OP",
                "latitude": "6.48509840",
                "longitude": "16.15809370",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17306,
                        "name": "Bocaranga",
                        "latitude": "6.76546000",
                        "longitude": "15.77873000"
                    },
                    {
                        "id": 17312,
                        "name": "Bozoum",
                        "latitude": "6.31933000",
                        "longitude": "16.37992000"
                    },
                    {
                        "id": 17335,
                        "name": "Paoua",
                        "latitude": "7.24269000",
                        "longitude": "16.44059000"
                    }
                ]
            },
            {
                "id": 1252,
                "name": "Sangha-Mbaéré",
                "iso2": "SE",
                "latitude": "3.43686070",
                "longitude": "16.34637910",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17330,
                        "name": "Nola",
                        "latitude": "3.52494000",
                        "longitude": "16.04583000"
                    }
                ]
            },
            {
                "id": 1261,
                "name": "Vakaga",
                "iso2": "VK",
                "latitude": "9.51132960",
                "longitude": "22.23840170",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 17304,
                        "name": "Birao",
                        "latitude": "10.28488000",
                        "longitude": "22.78818000"
                    },
                    {
                        "id": 17333,
                        "name": "Ouanda-Djallé",
                        "latitude": "9.05877000",
                        "longitude": "22.42741000"
                    }
                ]
            }
        ]
    },
    {
        "id": 43,
        "name": "Chad",
        "iso3": "TCD",
        "iso2": "TD",
        "numeric_code": "148",
        "phonecode": "235",
        "capital": "N'Djamena",
        "currency": "XAF",
        "currency_name": "Central African CFA franc",
        "currency_symbol": "FCFA",
        "tld": ".td",
        "native": "Tchad",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Middle Africa",
        "subregion_id": 2,
        "nationality": "Chadian",
        "timezones": [
            {
                "zoneName": "Africa\/Ndjamena",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "br": "Tchad",
            "ko": "차드",
            "pt-BR": "Chade",
            "pt": "Chade",
            "nl": "Tsjaad",
            "hr": "Čad",
            "fa": "چاد",
            "de": "Tschad",
            "es": "Chad",
            "fr": "Tchad",
            "ja": "チャド",
            "it": "Ciad",
            "zh-CN": "乍得",
            "tr": "Çad",
            "ru": "Чад",
            "uk": "Чад.",
            "pl": "Czad"
        },
        "latitude": "15.00000000",
        "longitude": "19.00000000",
        "emoji": "🇹🇩",
        "emojiU": "U+1F1F9 U+1F1E9",
        "states": [
            {
                "id": 3583,
                "name": "Bahr el Gazel",
                "iso2": "BG",
                "latitude": "14.77022660",
                "longitude": "16.91225100",
                "type": "province",
                "cities": [
                    {
                        "id": 105152,
                        "name": "Moussoro",
                        "latitude": "13.64143000",
                        "longitude": "16.48941000"
                    }
                ]
            },
            {
                "id": 3590,
                "name": "Batha",
                "iso2": "BA",
                "latitude": "13.93717750",
                "longitude": "18.42760470",
                "type": "province",
                "cities": [
                    {
                        "id": 105120,
                        "name": "Ati",
                        "latitude": "13.21540000",
                        "longitude": "18.33530000"
                    },
                    {
                        "id": 105154,
                        "name": "Oum Hadjer",
                        "latitude": "13.29540000",
                        "longitude": "19.69660000"
                    }
                ]
            },
            {
                "id": 3574,
                "name": "Borkou",
                "iso2": "BO",
                "latitude": "17.86888450",
                "longitude": "18.80761950",
                "type": "province",
                "cities": [
                    {
                        "id": 105133,
                        "name": "Faya-Largeau",
                        "latitude": "17.92570000",
                        "longitude": "19.10428000"
                    }
                ]
            },
            {
                "id": 5114,
                "name": "Chari-Baguirmi",
                "iso2": "CB",
                "latitude": "11.46186260",
                "longitude": "15.24463940",
                "type": "province",
                "cities": [
                    {
                        "id": 153256,
                        "name": "Baguirmi Department",
                        "latitude": "11.39833333",
                        "longitude": "16.16750000"
                    },
                    {
                        "id": 153257,
                        "name": "Bousso",
                        "latitude": "10.48250000",
                        "longitude": "16.71611111"
                    },
                    {
                        "id": 153258,
                        "name": "Chari Department",
                        "latitude": "12.05000000",
                        "longitude": "15.30000000"
                    },
                    {
                        "id": 153259,
                        "name": "Dababa",
                        "latitude": "12.38000000",
                        "longitude": "17.06000000"
                    },
                    {
                        "id": 153260,
                        "name": "Gaoui",
                        "latitude": "12.18070000",
                        "longitude": "15.14760000"
                    },
                    {
                        "id": 153261,
                        "name": "Linia",
                        "latitude": "12.05000000",
                        "longitude": "15.30000000"
                    },
                    {
                        "id": 153262,
                        "name": "Mandjafa",
                        "latitude": "11.19861111",
                        "longitude": "15.36111111"
                    },
                    {
                        "id": 153263,
                        "name": "Massenya",
                        "latitude": "11.40277778",
                        "longitude": "16.17000000"
                    }
                ]
            },
            {
                "id": 3575,
                "name": "Ennedi-Est",
                "iso2": "EE",
                "latitude": "16.34204960",
                "longitude": "23.00119890",
                "type": "province",
                "cities": []
            },
            {
                "id": 3584,
                "name": "Ennedi-Ouest",
                "iso2": "EO",
                "latitude": "18.97756300",
                "longitude": "21.85685860",
                "type": "province",
                "cities": [
                    {
                        "id": 105132,
                        "name": "Fada",
                        "latitude": "17.18535000",
                        "longitude": "21.58114000"
                    }
                ]
            },
            {
                "id": 3576,
                "name": "Guéra",
                "iso2": "GR",
                "latitude": "11.12190150",
                "longitude": "18.42760470",
                "type": "province",
                "cities": [
                    {
                        "id": 105124,
                        "name": "Bitkine",
                        "latitude": "11.98010000",
                        "longitude": "18.21380000"
                    },
                    {
                        "id": 105149,
                        "name": "Melfi",
                        "latitude": "11.05980000",
                        "longitude": "17.93550000"
                    },
                    {
                        "id": 105150,
                        "name": "Mongo",
                        "latitude": "12.18441000",
                        "longitude": "18.69303000"
                    }
                ]
            },
            {
                "id": 3573,
                "name": "Hadjer-Lamis",
                "iso2": "HL",
                "latitude": "12.45772730",
                "longitude": "16.72346390",
                "type": "province",
                "cities": [
                    {
                        "id": 105125,
                        "name": "Bokoro",
                        "latitude": "12.37813000",
                        "longitude": "17.05876000"
                    },
                    {
                        "id": 105146,
                        "name": "Massaguet",
                        "latitude": "12.47554000",
                        "longitude": "15.43647000"
                    },
                    {
                        "id": 105147,
                        "name": "Massakory",
                        "latitude": "12.99600000",
                        "longitude": "15.72927000"
                    }
                ]
            },
            {
                "id": 3588,
                "name": "Kanem",
                "iso2": "KA",
                "latitude": "14.87812620",
                "longitude": "15.40680790",
                "type": "province",
                "cities": [
                    {
                        "id": 105145,
                        "name": "Mao",
                        "latitude": "14.12116000",
                        "longitude": "15.31030000"
                    }
                ]
            },
            {
                "id": 3577,
                "name": "Lac",
                "iso2": "LC",
                "latitude": "13.69153770",
                "longitude": "14.10013260",
                "type": "province",
                "cities": [
                    {
                        "id": 105126,
                        "name": "Bol",
                        "latitude": "13.46706000",
                        "longitude": "14.71363000"
                    }
                ]
            },
            {
                "id": 3585,
                "name": "Logone Occidental",
                "iso2": "LO",
                "latitude": "8.75967600",
                "longitude": "15.87600400",
                "type": "province",
                "cities": [
                    {
                        "id": 105122,
                        "name": "Beïnamar",
                        "latitude": "8.66980000",
                        "longitude": "15.38130000"
                    },
                    {
                        "id": 105121,
                        "name": "Benoy",
                        "latitude": "8.98327000",
                        "longitude": "16.31991000"
                    },
                    {
                        "id": 105143,
                        "name": "Lac Wey",
                        "latitude": "8.70502000",
                        "longitude": "15.98303000"
                    },
                    {
                        "id": 105151,
                        "name": "Moundou",
                        "latitude": "8.56667000",
                        "longitude": "16.08333000"
                    }
                ]
            },
            {
                "id": 3591,
                "name": "Logone Oriental",
                "iso2": "LR",
                "latitude": "8.31499490",
                "longitude": "16.34637910",
                "type": "province",
                "cities": [
                    {
                        "id": 105129,
                        "name": "Bébédja",
                        "latitude": "8.67610000",
                        "longitude": "16.56600000"
                    },
                    {
                        "id": 105128,
                        "name": "Béboto",
                        "latitude": "8.26681000",
                        "longitude": "16.93898000"
                    },
                    {
                        "id": 105131,
                        "name": "Doba",
                        "latitude": "8.65000000",
                        "longitude": "16.85000000"
                    }
                ]
            },
            {
                "id": 3589,
                "name": "Mandoul",
                "iso2": "MA",
                "latitude": "8.60309100",
                "longitude": "17.47951730",
                "type": "province",
                "cities": [
                    {
                        "id": 105134,
                        "name": "Goundi",
                        "latitude": "9.36267000",
                        "longitude": "17.36597000"
                    },
                    {
                        "id": 105141,
                        "name": "Koumra",
                        "latitude": "8.91256000",
                        "longitude": "17.55392000"
                    },
                    {
                        "id": 105153,
                        "name": "Moïssala",
                        "latitude": "8.34040000",
                        "longitude": "17.76630000"
                    }
                ]
            },
            {
                "id": 3580,
                "name": "Mayo-Kebbi Est",
                "iso2": "ME",
                "latitude": "9.40460390",
                "longitude": "14.84546190",
                "type": "province",
                "cities": [
                    {
                        "id": 105127,
                        "name": "Bongor",
                        "latitude": "10.28056000",
                        "longitude": "15.37222000"
                    },
                    {
                        "id": 105135,
                        "name": "Gounou Gaya",
                        "latitude": "9.62940000",
                        "longitude": "15.51320000"
                    },
                    {
                        "id": 105138,
                        "name": "Guelendeng",
                        "latitude": "10.91762000",
                        "longitude": "15.55011000"
                    }
                ]
            },
            {
                "id": 3571,
                "name": "Mayo-Kebbi Ouest",
                "iso2": "MO",
                "latitude": "10.41130140",
                "longitude": "15.59433880",
                "type": "province",
                "cities": [
                    {
                        "id": 105148,
                        "name": "Mboursou Léré",
                        "latitude": "9.76390000",
                        "longitude": "14.15390000"
                    },
                    {
                        "id": 105155,
                        "name": "Pala",
                        "latitude": "9.36420000",
                        "longitude": "14.90460000"
                    }
                ]
            },
            {
                "id": 3570,
                "name": "Moyen-Chari",
                "iso2": "MC",
                "latitude": "9.06399980",
                "longitude": "18.42760470",
                "type": "province",
                "cities": [
                    {
                        "id": 105142,
                        "name": "Kyabé",
                        "latitude": "9.45149000",
                        "longitude": "18.94493000"
                    },
                    {
                        "id": 105156,
                        "name": "Sarh",
                        "latitude": "9.14290000",
                        "longitude": "18.39230000"
                    }
                ]
            },
            {
                "id": 3586,
                "name": "N'Djamena",
                "iso2": "ND",
                "latitude": "12.13484570",
                "longitude": "15.05574150",
                "type": "province",
                "cities": [
                    {
                        "id": 153264,
                        "name": "N'Djamena",
                        "latitude": "12.11000000",
                        "longitude": "15.05000000"
                    }
                ]
            },
            {
                "id": 3582,
                "name": "Ouaddaï",
                "iso2": "OD",
                "latitude": "13.74847600",
                "longitude": "20.71224650",
                "type": "province",
                "cities": [
                    {
                        "id": 105116,
                        "name": "Abéché",
                        "latitude": "13.82916000",
                        "longitude": "20.83240000"
                    },
                    {
                        "id": 105117,
                        "name": "Adré",
                        "latitude": "13.46648000",
                        "longitude": "22.19875000"
                    },
                    {
                        "id": 105137,
                        "name": "Goz Béïda",
                        "latitude": "13.94563000",
                        "longitude": "20.54680000"
                    }
                ]
            },
            {
                "id": 3592,
                "name": "Salamat",
                "iso2": "SA",
                "latitude": "10.96916010",
                "longitude": "20.71224650",
                "type": "province",
                "cities": [
                    {
                        "id": 105118,
                        "name": "Am Timan",
                        "latitude": "11.02970000",
                        "longitude": "20.28270000"
                    }
                ]
            },
            {
                "id": 3572,
                "name": "Sila",
                "iso2": "SI",
                "latitude": "12.13074000",
                "longitude": "21.28450250",
                "type": "province",
                "cities": [
                    {
                        "id": 105136,
                        "name": "Goz Beïda",
                        "latitude": "12.22484000",
                        "longitude": "21.41034000"
                    }
                ]
            },
            {
                "id": 3579,
                "name": "Tandjilé",
                "iso2": "TA",
                "latitude": "9.66257290",
                "longitude": "16.72346390",
                "type": "province",
                "cities": [
                    {
                        "id": 105130,
                        "name": "Béré",
                        "latitude": "9.32020000",
                        "longitude": "16.15520000"
                    },
                    {
                        "id": 105140,
                        "name": "Kelo",
                        "latitude": "9.30859000",
                        "longitude": "15.80658000"
                    },
                    {
                        "id": 105144,
                        "name": "Laï",
                        "latitude": "9.39720000",
                        "longitude": "16.30066000"
                    }
                ]
            },
            {
                "id": 3587,
                "name": "Tibesti",
                "iso2": "TI",
                "latitude": "21.36500310",
                "longitude": "16.91225100",
                "type": "province",
                "cities": [
                    {
                        "id": 105119,
                        "name": "Aozou",
                        "latitude": "21.83750000",
                        "longitude": "17.42750000"
                    }
                ]
            },
            {
                "id": 3581,
                "name": "Wadi Fira",
                "iso2": "WF",
                "latitude": "15.08924160",
                "longitude": "21.47528510",
                "type": "province",
                "cities": [
                    {
                        "id": 105123,
                        "name": "Biltine",
                        "latitude": "14.52791000",
                        "longitude": "20.92749000"
                    },
                    {
                        "id": 105139,
                        "name": "Iriba",
                        "latitude": "15.11667000",
                        "longitude": "22.25000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 44,
        "name": "Chile",
        "iso3": "CHL",
        "iso2": "CL",
        "numeric_code": "152",
        "phonecode": "56",
        "capital": "Santiago",
        "currency": "CLP",
        "currency_name": "Chilean peso",
        "currency_symbol": "$",
        "tld": ".cl",
        "native": "Chile",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Chilean",
        "timezones": [
            {
                "zoneName": "America\/Punta_Arenas",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "CLST",
                "tzName": "Chile Summer Time"
            },
            {
                "zoneName": "America\/Santiago",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "CLST",
                "tzName": "Chile Summer Time"
            },
            {
                "zoneName": "Pacific\/Easter",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EASST",
                "tzName": "Easter Island Summer Time"
            }
        ],
        "translations": {
            "br": "Chile",
            "ko": "칠리",
            "pt-BR": "Chile",
            "pt": "Chile",
            "nl": "Chili",
            "hr": "Čile",
            "fa": "شیلی",
            "de": "Chile",
            "es": "Chile",
            "fr": "Chili",
            "ja": "チリ",
            "it": "Cile",
            "zh-CN": "智利",
            "tr": "Şili",
            "ru": "Чили",
            "uk": "Чилі",
            "pl": "Chile"
        },
        "latitude": "-30.00000000",
        "longitude": "-71.00000000",
        "emoji": "🇨🇱",
        "emojiU": "U+1F1E8 U+1F1F1",
        "states": [
            {
                "id": 2828,
                "name": "Aisén del General Carlos Ibañez del Campo",
                "iso2": "AI",
                "latitude": "-46.37834500",
                "longitude": "-72.30076230",
                "type": "region",
                "cities": [
                    {
                        "id": 19082,
                        "name": "Aysén",
                        "latitude": "-45.40303000",
                        "longitude": "-72.69184000"
                    },
                    {
                        "id": 18962,
                        "name": "Chile Chico",
                        "latitude": "-46.53760000",
                        "longitude": "-71.72930000"
                    },
                    {
                        "id": 19084,
                        "name": "Cisnes",
                        "latitude": "-44.72750000",
                        "longitude": "-72.68050000"
                    },
                    {
                        "id": 18966,
                        "name": "Cochrane",
                        "latitude": "-47.25390000",
                        "longitude": "-72.57320000"
                    },
                    {
                        "id": 18976,
                        "name": "Coyhaique",
                        "latitude": "-45.57524000",
                        "longitude": "-72.06619000"
                    },
                    {
                        "id": 148332,
                        "name": "Guaitecas",
                        "latitude": "-43.88333333",
                        "longitude": "-73.73333333"
                    },
                    {
                        "id": 148333,
                        "name": "Lago Verde",
                        "latitude": "-44.24031000",
                        "longitude": "-71.84950000"
                    },
                    {
                        "id": 148334,
                        "name": "O'Higgins",
                        "latitude": "-48.46666667",
                        "longitude": "-72.56666667"
                    },
                    {
                        "id": 148335,
                        "name": "Río Ibáñez",
                        "latitude": "-46.30000000",
                        "longitude": "-71.93333333"
                    },
                    {
                        "id": 148336,
                        "name": "Tortel",
                        "latitude": "-47.83333333",
                        "longitude": "-73.56666667"
                    }
                ]
            },
            {
                "id": 2832,
                "name": "Antofagasta",
                "iso2": "AN",
                "latitude": "-23.83691040",
                "longitude": "-69.28775350",
                "type": "region",
                "cities": [
                    {
                        "id": 18946,
                        "name": "Antofagasta",
                        "latitude": "-23.65236000",
                        "longitude": "-70.39540000"
                    },
                    {
                        "id": 18952,
                        "name": "Calama",
                        "latitude": "-22.45667000",
                        "longitude": "-68.92371000"
                    },
                    {
                        "id": 148326,
                        "name": "María Elena",
                        "latitude": "-22.35000000",
                        "longitude": "-69.66666667"
                    },
                    {
                        "id": 19033,
                        "name": "Mejillones",
                        "latitude": "-23.10000000",
                        "longitude": "-70.45000000"
                    },
                    {
                        "id": 19074,
                        "name": "Ollagüe",
                        "latitude": "-21.22496000",
                        "longitude": "-68.25352000"
                    },
                    {
                        "id": 19107,
                        "name": "San Pedro de Atacama",
                        "latitude": "-22.91110000",
                        "longitude": "-68.20113000"
                    },
                    {
                        "id": 19051,
                        "name": "Sierra Gorda",
                        "latitude": "-22.88333333",
                        "longitude": "-69.31666667"
                    },
                    {
                        "id": 19115,
                        "name": "Taltal",
                        "latitude": "-25.40713000",
                        "longitude": "-70.48554000"
                    },
                    {
                        "id": 19118,
                        "name": "Tocopilla",
                        "latitude": "-22.09198000",
                        "longitude": "-70.19792000"
                    }
                ]
            },
            {
                "id": 2829,
                "name": "Arica y Parinacota",
                "iso2": "AP",
                "latitude": "-18.59404850",
                "longitude": "-69.47845410",
                "type": "region",
                "cities": [
                    {
                        "id": 18948,
                        "name": "Arica",
                        "latitude": "-18.47460000",
                        "longitude": "-70.29792000"
                    },
                    {
                        "id": 19035,
                        "name": "Camarones",
                        "latitude": "-19.01666667",
                        "longitude": "-69.86666667"
                    },
                    {
                        "id": 148327,
                        "name": "General Lagos",
                        "latitude": "-17.56666667",
                        "longitude": "-69.50000000"
                    },
                    {
                        "id": 19067,
                        "name": "Putre",
                        "latitude": "-18.19640000",
                        "longitude": "-69.55920000"
                    }
                ]
            },
            {
                "id": 2823,
                "name": "Atacama",
                "iso2": "AT",
                "latitude": "-27.56605580",
                "longitude": "-70.05031400",
                "type": "region",
                "cities": [
                    {
                        "id": 148330,
                        "name": "Alto del Carmen",
                        "latitude": "-28.93355556",
                        "longitude": "-70.46227778"
                    },
                    {
                        "id": 148328,
                        "name": "Caldera",
                        "latitude": "-27.06666667",
                        "longitude": "-70.81666667"
                    },
                    {
                        "id": 19042,
                        "name": "Chañaral",
                        "latitude": "-26.34790000",
                        "longitude": "-70.62240000"
                    },
                    {
                        "id": 18972,
                        "name": "Copiapó",
                        "latitude": "-27.36650000",
                        "longitude": "-70.33230000"
                    },
                    {
                        "id": 18981,
                        "name": "Diego de Almagro",
                        "latitude": "-26.36667000",
                        "longitude": "-70.05000000"
                    },
                    {
                        "id": 148331,
                        "name": "Freirina",
                        "latitude": "-28.50000000",
                        "longitude": "-71.06666667"
                    },
                    {
                        "id": 19053,
                        "name": "Huasco",
                        "latitude": "-28.45000000",
                        "longitude": "-71.21666667"
                    },
                    {
                        "id": 148329,
                        "name": "Tierra Amarilla",
                        "latitude": "-27.46666667",
                        "longitude": "-70.26666667"
                    },
                    {
                        "id": 19122,
                        "name": "Vallenar",
                        "latitude": "-28.57617000",
                        "longitude": "-70.75938000"
                    }
                ]
            },
            {
                "id": 2827,
                "name": "Biobío",
                "iso2": "BI",
                "latitude": "-37.44644280",
                "longitude": "-72.14161320",
                "type": "region",
                "cities": [
                    {
                        "id": 19036,
                        "name": "Alto Biobío",
                        "latitude": "-38.05000000",
                        "longitude": "-71.31666667"
                    },
                    {
                        "id": 148337,
                        "name": "Antuco",
                        "latitude": "-37.33333333",
                        "longitude": "-71.68333333"
                    },
                    {
                        "id": 18947,
                        "name": "Arauco",
                        "latitude": "-37.24630000",
                        "longitude": "-73.31752000"
                    },
                    {
                        "id": 18951,
                        "name": "Cabrero",
                        "latitude": "-37.03394000",
                        "longitude": "-72.40468000"
                    },
                    {
                        "id": 18958,
                        "name": "Cañete",
                        "latitude": "-37.80128000",
                        "longitude": "-73.39616000"
                    },
                    {
                        "id": 18961,
                        "name": "Chiguayante",
                        "latitude": "-36.92560000",
                        "longitude": "-73.02841000"
                    },
                    {
                        "id": 18970,
                        "name": "Concepción",
                        "latitude": "-36.82699000",
                        "longitude": "-73.04977000"
                    },
                    {
                        "id": 148338,
                        "name": "Contulmo",
                        "latitude": "-38.00000000",
                        "longitude": "-73.23333333"
                    },
                    {
                        "id": 18974,
                        "name": "Coronel",
                        "latitude": "-37.03386000",
                        "longitude": "-73.14019000"
                    },
                    {
                        "id": 18977,
                        "name": "Curanilahue",
                        "latitude": "-37.47793000",
                        "longitude": "-73.34495000"
                    },
                    {
                        "id": 148339,
                        "name": "Florida",
                        "latitude": "-36.81666667",
                        "longitude": "-72.66666667"
                    },
                    {
                        "id": 148340,
                        "name": "Hualpén",
                        "latitude": "-36.78333333",
                        "longitude": "-73.08333333"
                    },
                    {
                        "id": 148341,
                        "name": "Hualqui",
                        "latitude": "-36.97266000",
                        "longitude": "-72.93559000"
                    },
                    {
                        "id": 18996,
                        "name": "Laja",
                        "latitude": "-37.28415000",
                        "longitude": "-72.71105000"
                    },
                    {
                        "id": 19001,
                        "name": "Lebu",
                        "latitude": "-37.60825000",
                        "longitude": "-73.65356000"
                    },
                    {
                        "id": 148342,
                        "name": "Los Álamos",
                        "latitude": "-37.61666667",
                        "longitude": "-73.46666667"
                    },
                    {
                        "id": 19009,
                        "name": "Los Ángeles",
                        "latitude": "-37.46973000",
                        "longitude": "-72.35366000"
                    },
                    {
                        "id": 19010,
                        "name": "Lota",
                        "latitude": "-37.08994000",
                        "longitude": "-73.15770000"
                    },
                    {
                        "id": 19015,
                        "name": "Mulchén",
                        "latitude": "-37.71893000",
                        "longitude": "-72.24099000"
                    },
                    {
                        "id": 19016,
                        "name": "Nacimiento",
                        "latitude": "-37.50253000",
                        "longitude": "-72.67307000"
                    },
                    {
                        "id": 148343,
                        "name": "Negrete",
                        "latitude": "-37.58333333",
                        "longitude": "-72.51666667"
                    },
                    {
                        "id": 19024,
                        "name": "Penco",
                        "latitude": "-36.74075000",
                        "longitude": "-72.99528000"
                    },
                    {
                        "id": 148344,
                        "name": "Quilaco",
                        "latitude": "-37.68436111",
                        "longitude": "-72.00636111"
                    },
                    {
                        "id": 148345,
                        "name": "Quilleco",
                        "latitude": "-37.46666667",
                        "longitude": "-71.96666667"
                    },
                    {
                        "id": 148346,
                        "name": "San Pedro de la Paz",
                        "latitude": "-36.84082000",
                        "longitude": "-73.10311000"
                    },
                    {
                        "id": 148347,
                        "name": "San Rosendo",
                        "latitude": "-37.26666667",
                        "longitude": "-72.71666667"
                    },
                    {
                        "id": 148348,
                        "name": "Santa Bárbara",
                        "latitude": "-37.66666667",
                        "longitude": "-72.01666667"
                    },
                    {
                        "id": 148349,
                        "name": "Santa Juana",
                        "latitude": "-37.16666667",
                        "longitude": "-72.93333333"
                    },
                    {
                        "id": 19114,
                        "name": "Talcahuano",
                        "latitude": "-36.72494000",
                        "longitude": "-73.11684000"
                    },
                    {
                        "id": 148350,
                        "name": "Tirúa",
                        "latitude": "-38.33333333",
                        "longitude": "-73.50000000"
                    },
                    {
                        "id": 19119,
                        "name": "Tomé",
                        "latitude": "-36.61756000",
                        "longitude": "-72.95593000"
                    },
                    {
                        "id": 148351,
                        "name": "Tucapel",
                        "latitude": "-37.28333333",
                        "longitude": "-71.95000000"
                    },
                    {
                        "id": 19131,
                        "name": "Yumbel",
                        "latitude": "-37.09820000",
                        "longitude": "-72.56084000"
                    }
                ]
            },
            {
                "id": 2825,
                "name": "Coquimbo",
                "iso2": "CO",
                "latitude": "-30.54018100",
                "longitude": "-70.81199530",
                "type": "region",
                "cities": [
                    {
                        "id": 148352,
                        "name": "Andacollo",
                        "latitude": "-30.21666667",
                        "longitude": "-71.08333333"
                    },
                    {
                        "id": 148353,
                        "name": "Canela",
                        "latitude": "-31.40000000",
                        "longitude": "-71.45000000"
                    },
                    {
                        "id": 148354,
                        "name": "Combarbalá",
                        "latitude": "-31.16666667",
                        "longitude": "-71.05000000"
                    },
                    {
                        "id": 18973,
                        "name": "Coquimbo",
                        "latitude": "-29.95332000",
                        "longitude": "-71.33947000"
                    },
                    {
                        "id": 18988,
                        "name": "Illapel",
                        "latitude": "-31.63349000",
                        "longitude": "-71.16967000"
                    },
                    {
                        "id": 148355,
                        "name": "La Higuera",
                        "latitude": "-29.50000000",
                        "longitude": "-71.26666667"
                    },
                    {
                        "id": 18994,
                        "name": "La Serena",
                        "latitude": "-29.90453000",
                        "longitude": "-71.24894000"
                    },
                    {
                        "id": 148356,
                        "name": "Los Vilos",
                        "latitude": "-31.90000000",
                        "longitude": "-71.51666667"
                    },
                    {
                        "id": 19014,
                        "name": "Monte Patria",
                        "latitude": "-30.69496000",
                        "longitude": "-70.95770000"
                    },
                    {
                        "id": 19019,
                        "name": "Ovalle",
                        "latitude": "-30.60106000",
                        "longitude": "-71.19901000"
                    },
                    {
                        "id": 148357,
                        "name": "Paihuano",
                        "latitude": "-30.02884000",
                        "longitude": "-70.51708000"
                    },
                    {
                        "id": 148358,
                        "name": "Punitaqui",
                        "latitude": "-30.90000000",
                        "longitude": "-71.26666667"
                    },
                    {
                        "id": 148359,
                        "name": "Río Hurtado",
                        "latitude": "-30.26666667",
                        "longitude": "-70.70000000"
                    },
                    {
                        "id": 19099,
                        "name": "Salamanca",
                        "latitude": "-31.77922000",
                        "longitude": "-70.96389000"
                    },
                    {
                        "id": 19125,
                        "name": "Vicuña",
                        "latitude": "-30.03541000",
                        "longitude": "-70.71274000"
                    }
                ]
            },
            {
                "id": 2826,
                "name": "La Araucanía",
                "iso2": "AR",
                "latitude": "-38.94892100",
                "longitude": "-72.33111300",
                "type": "region",
                "cities": [
                    {
                        "id": 18945,
                        "name": "Angol",
                        "latitude": "-37.79519000",
                        "longitude": "-72.71636000"
                    },
                    {
                        "id": 18954,
                        "name": "Carahue",
                        "latitude": "-38.71122000",
                        "longitude": "-73.16101000"
                    },
                    {
                        "id": 148360,
                        "name": "Cholchol",
                        "latitude": "-38.60000000",
                        "longitude": "-72.85000000"
                    },
                    {
                        "id": 18969,
                        "name": "Collipulli",
                        "latitude": "-37.95453000",
                        "longitude": "-72.43438000"
                    },
                    {
                        "id": 148361,
                        "name": "Cunco",
                        "latitude": "-38.91666667",
                        "longitude": "-72.03333333"
                    },
                    {
                        "id": 148362,
                        "name": "Curacautín",
                        "latitude": "-38.44049210",
                        "longitude": "-71.90539600"
                    },
                    {
                        "id": 148363,
                        "name": "Curarrehue",
                        "latitude": "-39.35000000",
                        "longitude": "-71.58333333"
                    },
                    {
                        "id": 148364,
                        "name": "Ercilla",
                        "latitude": "-38.05000000",
                        "longitude": "-72.38333333"
                    },
                    {
                        "id": 18983,
                        "name": "Freire",
                        "latitude": "-38.95252000",
                        "longitude": "-72.62653000"
                    },
                    {
                        "id": 148365,
                        "name": "Galvarino",
                        "latitude": "-38.40000000",
                        "longitude": "-72.78333333"
                    },
                    {
                        "id": 148366,
                        "name": "Gorbea",
                        "latitude": "-39.10000000",
                        "longitude": "-72.68333333"
                    },
                    {
                        "id": 19000,
                        "name": "Lautaro",
                        "latitude": "-38.53066000",
                        "longitude": "-72.43652000"
                    },
                    {
                        "id": 19006,
                        "name": "Loncoche",
                        "latitude": "-39.36708000",
                        "longitude": "-72.63087000"
                    },
                    {
                        "id": 148367,
                        "name": "Lonquimay",
                        "latitude": "-38.43333333",
                        "longitude": "-71.23333333"
                    },
                    {
                        "id": 148368,
                        "name": "Los Sauces",
                        "latitude": "-37.96666667",
                        "longitude": "-72.83333333"
                    },
                    {
                        "id": 148369,
                        "name": "Lumaco",
                        "latitude": "-38.15000000",
                        "longitude": "-72.91666667"
                    },
                    {
                        "id": 148370,
                        "name": "Melipeuco",
                        "latitude": "-38.85000000",
                        "longitude": "-71.70000000"
                    },
                    {
                        "id": 19017,
                        "name": "Nueva Imperial",
                        "latitude": "-38.74451000",
                        "longitude": "-72.95025000"
                    },
                    {
                        "id": 148371,
                        "name": "Padre Las Casas",
                        "latitude": "-38.76666667",
                        "longitude": "-72.60000000"
                    },
                    {
                        "id": 148372,
                        "name": "Perquenco",
                        "latitude": "-38.41666667",
                        "longitude": "-72.38333333"
                    },
                    {
                        "id": 19027,
                        "name": "Pitrufquén",
                        "latitude": "-38.98635000",
                        "longitude": "-72.63721000"
                    },
                    {
                        "id": 19080,
                        "name": "Pucón",
                        "latitude": "-39.28223000",
                        "longitude": "-71.95427000"
                    },
                    {
                        "id": 148373,
                        "name": "Purén",
                        "latitude": "-38.01666667",
                        "longitude": "-73.08333333"
                    },
                    {
                        "id": 148374,
                        "name": "Renaico",
                        "latitude": "-37.71779000",
                        "longitude": "-72.57570000"
                    },
                    {
                        "id": 148375,
                        "name": "Saavedra",
                        "latitude": "-38.78333333",
                        "longitude": "-73.40000000"
                    },
                    {
                        "id": 19116,
                        "name": "Temuco",
                        "latitude": "-38.73965000",
                        "longitude": "-72.59842000"
                    },
                    {
                        "id": 148376,
                        "name": "Teodoro Schmidt",
                        "latitude": "-38.96666667",
                        "longitude": "-73.05000000"
                    },
                    {
                        "id": 148377,
                        "name": "Toltén",
                        "latitude": "-39.17852000",
                        "longitude": "-73.16448000"
                    },
                    {
                        "id": 19120,
                        "name": "Traiguén",
                        "latitude": "-38.24960000",
                        "longitude": "-72.67027000"
                    },
                    {
                        "id": 19124,
                        "name": "Victoria",
                        "latitude": "-38.23291000",
                        "longitude": "-72.33292000"
                    },
                    {
                        "id": 19126,
                        "name": "Vilcún",
                        "latitude": "-38.66875000",
                        "longitude": "-72.22565000"
                    },
                    {
                        "id": 19129,
                        "name": "Villarrica",
                        "latitude": "-39.28569000",
                        "longitude": "-72.22790000"
                    }
                ]
            },
            {
                "id": 2838,
                "name": "Libertador General Bernardo O'Higgins",
                "iso2": "LI",
                "latitude": "-34.57553740",
                "longitude": "-71.00223110",
                "type": "region",
                "cities": [
                    {
                        "id": 148378,
                        "name": "Chépica",
                        "latitude": "-34.73333333",
                        "longitude": "-71.28333333"
                    },
                    {
                        "id": 18964,
                        "name": "Chimbarongo",
                        "latitude": "-34.71247000",
                        "longitude": "-71.04340000"
                    },
                    {
                        "id": 148379,
                        "name": "Codegua",
                        "latitude": "-34.03333333",
                        "longitude": "-70.66666667"
                    },
                    {
                        "id": 148381,
                        "name": "Coínco",
                        "latitude": "-34.26666667",
                        "longitude": "-70.96666667"
                    },
                    {
                        "id": 148380,
                        "name": "Coltauco",
                        "latitude": "-34.30000000",
                        "longitude": "-71.10000000"
                    },
                    {
                        "id": 148382,
                        "name": "Doñihue",
                        "latitude": "-34.23333333",
                        "longitude": "-70.96666667"
                    },
                    {
                        "id": 18985,
                        "name": "Graneros",
                        "latitude": "-34.06863000",
                        "longitude": "-70.72747000"
                    },
                    {
                        "id": 148383,
                        "name": "La Estrella",
                        "latitude": "-34.20000000",
                        "longitude": "-71.66666667"
                    },
                    {
                        "id": 148384,
                        "name": "Las Cabras",
                        "latitude": "-34.30000000",
                        "longitude": "-71.31666667"
                    },
                    {
                        "id": 148385,
                        "name": "Litueche",
                        "latitude": "-34.11666667",
                        "longitude": "-71.73333333"
                    },
                    {
                        "id": 148386,
                        "name": "Lolol",
                        "latitude": "-34.72861111",
                        "longitude": "-71.64472222"
                    },
                    {
                        "id": 19011,
                        "name": "Machalí",
                        "latitude": "-34.18082000",
                        "longitude": "-70.64933000"
                    },
                    {
                        "id": 148387,
                        "name": "Malloa",
                        "latitude": "-34.45000000",
                        "longitude": "-70.95000000"
                    },
                    {
                        "id": 148388,
                        "name": "Marchigüe",
                        "latitude": "-34.40000000",
                        "longitude": "-71.63333333"
                    },
                    {
                        "id": 148389,
                        "name": "Mostazal",
                        "latitude": "-33.98333333",
                        "longitude": "-70.70000000"
                    },
                    {
                        "id": 148390,
                        "name": "Nancagua",
                        "latitude": "-34.66666667",
                        "longitude": "-71.21666667"
                    },
                    {
                        "id": 148391,
                        "name": "Navidad",
                        "latitude": "-33.93333333",
                        "longitude": "-71.83333333"
                    },
                    {
                        "id": 148392,
                        "name": "Olivar",
                        "latitude": "-34.21164000",
                        "longitude": "-70.82012000"
                    },
                    {
                        "id": 148393,
                        "name": "Palmilla",
                        "latitude": "-34.60000000",
                        "longitude": "-71.36666667"
                    },
                    {
                        "id": 148394,
                        "name": "Paredones",
                        "latitude": "-34.78333333",
                        "longitude": "-71.16666667"
                    },
                    {
                        "id": 148395,
                        "name": "Peralillo",
                        "latitude": "-34.48333333",
                        "longitude": "-71.48333333"
                    },
                    {
                        "id": 148396,
                        "name": "Peumo",
                        "latitude": "-34.40000000",
                        "longitude": "-71.16666667"
                    },
                    {
                        "id": 148397,
                        "name": "Pichidegua",
                        "latitude": "-34.35000000",
                        "longitude": "-71.30000000"
                    },
                    {
                        "id": 148398,
                        "name": "Pichilemu",
                        "latitude": "-34.38333000",
                        "longitude": "-72.00000000"
                    },
                    {
                        "id": 148399,
                        "name": "Placilla",
                        "latitude": "-34.63333333",
                        "longitude": "-71.11666667"
                    },
                    {
                        "id": 148400,
                        "name": "Pumanque",
                        "latitude": "-34.60000000",
                        "longitude": "-71.66666667"
                    },
                    {
                        "id": 148401,
                        "name": "Quinta de Tilcoco",
                        "latitude": "-34.35550000",
                        "longitude": "-70.96527000"
                    },
                    {
                        "id": 19095,
                        "name": "Rancagua",
                        "latitude": "-34.17083000",
                        "longitude": "-70.74444000"
                    },
                    {
                        "id": 19097,
                        "name": "Rengo",
                        "latitude": "-34.40639000",
                        "longitude": "-70.85834000"
                    },
                    {
                        "id": 148402,
                        "name": "Requínoa",
                        "latitude": "-34.28333333",
                        "longitude": "-70.83333333"
                    },
                    {
                        "id": 148403,
                        "name": "San Fernando",
                        "latitude": "-34.74330000",
                        "longitude": "-70.60328000"
                    },
                    {
                        "id": 19109,
                        "name": "San Vicente",
                        "latitude": "-34.43859000",
                        "longitude": "-71.07751000"
                    },
                    {
                        "id": 19110,
                        "name": "Santa Cruz",
                        "latitude": "-34.63881000",
                        "longitude": "-71.36576000"
                    }
                ]
            },
            {
                "id": 2835,
                "name": "Los Lagos",
                "iso2": "LL",
                "latitude": "-41.91977790",
                "longitude": "-72.14161320",
                "type": "region",
                "cities": [
                    {
                        "id": 18944,
                        "name": "Ancud",
                        "latitude": "-41.87070000",
                        "longitude": "-73.81622000"
                    },
                    {
                        "id": 18953,
                        "name": "Calbuco",
                        "latitude": "-41.77338000",
                        "longitude": "-73.13049000"
                    },
                    {
                        "id": 18956,
                        "name": "Castro",
                        "latitude": "-42.47210000",
                        "longitude": "-73.77319000"
                    },
                    {
                        "id": 18959,
                        "name": "Chaitén",
                        "latitude": "-42.91596000",
                        "longitude": "-72.70632000"
                    },
                    {
                        "id": 18965,
                        "name": "Chonchi",
                        "latitude": "-42.62387000",
                        "longitude": "-73.77500000"
                    },
                    {
                        "id": 148477,
                        "name": "Cochamó",
                        "latitude": "-41.50000000",
                        "longitude": "-72.31666667"
                    },
                    {
                        "id": 148478,
                        "name": "Curaco de Vélez",
                        "latitude": "-42.43970000",
                        "longitude": "-73.60290000"
                    },
                    {
                        "id": 18980,
                        "name": "Dalcahue",
                        "latitude": "-42.37845000",
                        "longitude": "-73.65011000"
                    },
                    {
                        "id": 148480,
                        "name": "Fresia",
                        "latitude": "-41.15364000",
                        "longitude": "-73.42102000"
                    },
                    {
                        "id": 148481,
                        "name": "Frutillar",
                        "latitude": "-41.08716000",
                        "longitude": "-73.09563000"
                    },
                    {
                        "id": 18984,
                        "name": "Futaleufú",
                        "latitude": "-43.18492000",
                        "longitude": "-71.86722000"
                    },
                    {
                        "id": 148482,
                        "name": "Hualaihué",
                        "latitude": "-42.01666667",
                        "longitude": "-72.68333333"
                    },
                    {
                        "id": 19058,
                        "name": "Llanquihue",
                        "latitude": "-41.34285000",
                        "longitude": "-72.65800000"
                    },
                    {
                        "id": 148483,
                        "name": "Los Muermos",
                        "latitude": "-41.40000000",
                        "longitude": "-73.48333333"
                    },
                    {
                        "id": 148484,
                        "name": "Maullín",
                        "latitude": "-41.61666667",
                        "longitude": "-73.60000000"
                    },
                    {
                        "id": 19018,
                        "name": "Osorno",
                        "latitude": "-40.57395000",
                        "longitude": "-73.13348000"
                    },
                    {
                        "id": 19021,
                        "name": "Palena",
                        "latitude": "-43.61876000",
                        "longitude": "-71.80434000"
                    },
                    {
                        "id": 19085,
                        "name": "Puerto Montt",
                        "latitude": "-41.46930000",
                        "longitude": "-72.94237000"
                    },
                    {
                        "id": 148485,
                        "name": "Puerto Octay",
                        "latitude": "-40.96666667",
                        "longitude": "-72.90000000"
                    },
                    {
                        "id": 19087,
                        "name": "Puerto Varas",
                        "latitude": "-41.31946000",
                        "longitude": "-72.98538000"
                    },
                    {
                        "id": 148486,
                        "name": "Puqueldón",
                        "latitude": "-42.60001000",
                        "longitude": "-73.67458000"
                    },
                    {
                        "id": 19089,
                        "name": "Purranque",
                        "latitude": "-40.91305000",
                        "longitude": "-73.15913000"
                    },
                    {
                        "id": 148479,
                        "name": "Puyehue",
                        "latitude": "-40.70968010",
                        "longitude": "-72.64190560"
                    },
                    {
                        "id": 148487,
                        "name": "Queilén",
                        "latitude": "-42.85572000",
                        "longitude": "-73.56436000"
                    },
                    {
                        "id": 19091,
                        "name": "Quellón",
                        "latitude": "-43.11819000",
                        "longitude": "-73.61661000"
                    },
                    {
                        "id": 148488,
                        "name": "Quemchi",
                        "latitude": "-42.13333333",
                        "longitude": "-73.51666667"
                    },
                    {
                        "id": 148489,
                        "name": "Quinchao",
                        "latitude": "-42.53333333",
                        "longitude": "-73.41666667"
                    },
                    {
                        "id": 148490,
                        "name": "Río Negro",
                        "latitude": "-40.79615000",
                        "longitude": "-73.21614000"
                    },
                    {
                        "id": 148491,
                        "name": "San Juan de la Costa",
                        "latitude": "-40.51666667",
                        "longitude": "-73.40000000"
                    },
                    {
                        "id": 148492,
                        "name": "San Pablo",
                        "latitude": "-40.40000000",
                        "longitude": "-73.01666667"
                    }
                ]
            },
            {
                "id": 2834,
                "name": "Los Ríos",
                "iso2": "LR",
                "latitude": "-40.23102170",
                "longitude": "-72.33111300",
                "type": "region",
                "cities": [
                    {
                        "id": 18975,
                        "name": "Corral",
                        "latitude": "-39.88730000",
                        "longitude": "-73.43101000"
                    },
                    {
                        "id": 148493,
                        "name": "Futrono",
                        "latitude": "-40.13333333",
                        "longitude": "-72.40000000"
                    },
                    {
                        "id": 18995,
                        "name": "La Unión",
                        "latitude": "-40.29313000",
                        "longitude": "-73.08167000"
                    },
                    {
                        "id": 148494,
                        "name": "Lago Ranco",
                        "latitude": "-40.31666667",
                        "longitude": "-72.50000000"
                    },
                    {
                        "id": 148495,
                        "name": "Lanco",
                        "latitude": "-39.45246000",
                        "longitude": "-72.77117000"
                    },
                    {
                        "id": 148496,
                        "name": "Los Lagos",
                        "latitude": "-39.85000000",
                        "longitude": "-72.83333333"
                    },
                    {
                        "id": 148498,
                        "name": "Máfil",
                        "latitude": "-39.65000000",
                        "longitude": "-72.95000000"
                    },
                    {
                        "id": 148497,
                        "name": "Mariquina",
                        "latitude": "-39.51666667",
                        "longitude": "-72.96666667"
                    },
                    {
                        "id": 148499,
                        "name": "Paillaco",
                        "latitude": "-40.07060000",
                        "longitude": "-72.87270000"
                    },
                    {
                        "id": 19022,
                        "name": "Panguipulli",
                        "latitude": "-39.64355000",
                        "longitude": "-72.33269000"
                    },
                    {
                        "id": 19098,
                        "name": "Río Bueno",
                        "latitude": "-40.33494000",
                        "longitude": "-72.95564000"
                    },
                    {
                        "id": 19121,
                        "name": "Valdivia",
                        "latitude": "-39.81422000",
                        "longitude": "-73.24589000"
                    }
                ]
            },
            {
                "id": 2836,
                "name": "Magallanes y de la Antártica Chilena",
                "iso2": "MA",
                "latitude": "-52.20643160",
                "longitude": "-72.16850010",
                "type": "region",
                "cities": [
                    {
                        "id": 19029,
                        "name": "Antártica",
                        "latitude": "-75.00000000",
                        "longitude": "-71.50000000"
                    },
                    {
                        "id": 148404,
                        "name": "Cabo de Hornos",
                        "latitude": "-54.93333333",
                        "longitude": "-67.61666667"
                    },
                    {
                        "id": 148405,
                        "name": "Laguna Blanca",
                        "latitude": "-52.25000000",
                        "longitude": "-71.91666667"
                    },
                    {
                        "id": 148406,
                        "name": "Natales",
                        "latitude": "-51.73333333",
                        "longitude": "-72.51666667"
                    },
                    {
                        "id": 19028,
                        "name": "Porvenir",
                        "latitude": "-53.30000000",
                        "longitude": "-70.36666667"
                    },
                    {
                        "id": 148407,
                        "name": "Primavera",
                        "latitude": "-52.71666667",
                        "longitude": "-69.25000000"
                    },
                    {
                        "id": 19088,
                        "name": "Punta Arenas",
                        "latitude": "-53.16270000",
                        "longitude": "-70.90810000"
                    },
                    {
                        "id": 148408,
                        "name": "Río Verde",
                        "latitude": "-52.65000000",
                        "longitude": "-71.48333333"
                    },
                    {
                        "id": 148409,
                        "name": "San Gregorio",
                        "latitude": "-52.31666667",
                        "longitude": "-69.68333333"
                    },
                    {
                        "id": 148410,
                        "name": "Timaukel",
                        "latitude": "-53.66666667",
                        "longitude": "-69.90000000"
                    },
                    {
                        "id": 148411,
                        "name": "Torres del Paine",
                        "latitude": "-51.26666667",
                        "longitude": "-72.35000000"
                    }
                ]
            },
            {
                "id": 2833,
                "name": "Maule",
                "iso2": "ML",
                "latitude": "-35.51636030",
                "longitude": "-71.57239530",
                "type": "region",
                "cities": [
                    {
                        "id": 18957,
                        "name": "Cauquenes",
                        "latitude": "-35.96710000",
                        "longitude": "-72.32248000"
                    },
                    {
                        "id": 148435,
                        "name": "Chanco",
                        "latitude": "-35.73333333",
                        "longitude": "-72.53333333"
                    },
                    {
                        "id": 18968,
                        "name": "Colbún",
                        "latitude": "-35.69494000",
                        "longitude": "-71.40568000"
                    },
                    {
                        "id": 18971,
                        "name": "Constitución",
                        "latitude": "-35.33321000",
                        "longitude": "-72.41156000"
                    },
                    {
                        "id": 148436,
                        "name": "Curepto",
                        "latitude": "-35.08333333",
                        "longitude": "-72.01666667"
                    },
                    {
                        "id": 18978,
                        "name": "Curicó",
                        "latitude": "-34.98279000",
                        "longitude": "-71.23943000"
                    },
                    {
                        "id": 148437,
                        "name": "Empedrado",
                        "latitude": "-35.60000000",
                        "longitude": "-72.28333333"
                    },
                    {
                        "id": 148438,
                        "name": "Hualañé",
                        "latitude": "-34.97653333",
                        "longitude": "-71.80478611"
                    },
                    {
                        "id": 148439,
                        "name": "Licantén",
                        "latitude": "-34.98333333",
                        "longitude": "-72.00000000"
                    },
                    {
                        "id": 19003,
                        "name": "Linares",
                        "latitude": "-35.84667000",
                        "longitude": "-71.59308000"
                    },
                    {
                        "id": 19007,
                        "name": "Longaví",
                        "latitude": "-35.96496000",
                        "longitude": "-71.68360000"
                    },
                    {
                        "id": 148440,
                        "name": "Maule",
                        "latitude": "-35.53333333",
                        "longitude": "-71.70000000"
                    },
                    {
                        "id": 19013,
                        "name": "Molina",
                        "latitude": "-35.11428000",
                        "longitude": "-71.28232000"
                    },
                    {
                        "id": 19023,
                        "name": "Parral",
                        "latitude": "-36.14311000",
                        "longitude": "-71.82605000"
                    },
                    {
                        "id": 148441,
                        "name": "Pelarco",
                        "latitude": "-35.38333333",
                        "longitude": "-71.45000000"
                    },
                    {
                        "id": 148442,
                        "name": "Pelluhue",
                        "latitude": "-35.83333333",
                        "longitude": "-72.63333333"
                    },
                    {
                        "id": 148443,
                        "name": "Pencahue",
                        "latitude": "-35.40000000",
                        "longitude": "-71.81666667"
                    },
                    {
                        "id": 19096,
                        "name": "Rauco",
                        "latitude": "-34.92546000",
                        "longitude": "-71.31722000"
                    },
                    {
                        "id": 148444,
                        "name": "Retiro",
                        "latitude": "-36.05000000",
                        "longitude": "-71.76666667"
                    },
                    {
                        "id": 148446,
                        "name": "Río Claro",
                        "latitude": "-35.28333333",
                        "longitude": "-71.26666667"
                    },
                    {
                        "id": 148445,
                        "name": "Romeral",
                        "latitude": "-34.96666667",
                        "longitude": "-71.13333333"
                    },
                    {
                        "id": 148447,
                        "name": "Sagrada Familia",
                        "latitude": "-35.00000000",
                        "longitude": "-71.38333333"
                    },
                    {
                        "id": 19104,
                        "name": "San Clemente",
                        "latitude": "-35.53777000",
                        "longitude": "-71.48700000"
                    },
                    {
                        "id": 19106,
                        "name": "San Javier",
                        "latitude": "-35.59520000",
                        "longitude": "-71.72924000"
                    },
                    {
                        "id": 148448,
                        "name": "San Rafael",
                        "latitude": "-35.31666667",
                        "longitude": "-71.53333333"
                    },
                    {
                        "id": 19113,
                        "name": "Talca",
                        "latitude": "-35.42640000",
                        "longitude": "-71.65542000"
                    },
                    {
                        "id": 19117,
                        "name": "Teno",
                        "latitude": "-34.87055000",
                        "longitude": "-71.16219000"
                    },
                    {
                        "id": 148449,
                        "name": "Vichuquén",
                        "latitude": "-34.88333333",
                        "longitude": "-72.00000000"
                    },
                    {
                        "id": 148450,
                        "name": "Villa Alegre",
                        "latitude": "-35.66666667",
                        "longitude": "-71.75000000"
                    },
                    {
                        "id": 148451,
                        "name": "Yerbas Buenas",
                        "latitude": "-35.75000000",
                        "longitude": "-71.58333333"
                    }
                ]
            },
            {
                "id": 2831,
                "name": "Ñuble",
                "iso2": "NB",
                "latitude": "-36.72257430",
                "longitude": "-71.76224810",
                "type": "region",
                "cities": [
                    {
                        "id": 18950,
                        "name": "Bulnes",
                        "latitude": "-36.74232000",
                        "longitude": "-72.29854000"
                    },
                    {
                        "id": 18963,
                        "name": "Chillán",
                        "latitude": "-36.60664000",
                        "longitude": "-72.10344000"
                    },
                    {
                        "id": 148419,
                        "name": "Chillán Viejo",
                        "latitude": "-36.62290000",
                        "longitude": "-72.13170000"
                    },
                    {
                        "id": 148420,
                        "name": "Cobquecura",
                        "latitude": "-36.13333333",
                        "longitude": "-72.78333333"
                    },
                    {
                        "id": 148421,
                        "name": "Coelemu",
                        "latitude": "-36.48333333",
                        "longitude": "-72.70000000"
                    },
                    {
                        "id": 18967,
                        "name": "Coihueco",
                        "latitude": "-36.62785000",
                        "longitude": "-71.83068000"
                    },
                    {
                        "id": 148422,
                        "name": "El Carmen",
                        "latitude": "-36.90000000",
                        "longitude": "-72.03333333"
                    },
                    {
                        "id": 148423,
                        "name": "Ninhue",
                        "latitude": "-36.40000000",
                        "longitude": "-72.40000000"
                    },
                    {
                        "id": 148424,
                        "name": "Ñiquén",
                        "latitude": "-36.30000000",
                        "longitude": "-71.90000000"
                    },
                    {
                        "id": 148425,
                        "name": "Pemuco",
                        "latitude": "-36.96666667",
                        "longitude": "-72.10000000"
                    },
                    {
                        "id": 148426,
                        "name": "Pinto",
                        "latitude": "-36.70000000",
                        "longitude": "-71.90000000"
                    },
                    {
                        "id": 148427,
                        "name": "Portezuelo",
                        "latitude": "-36.53333333",
                        "longitude": "-72.43333333"
                    },
                    {
                        "id": 148428,
                        "name": "Quillón",
                        "latitude": "-36.73333333",
                        "longitude": "-72.46666667"
                    },
                    {
                        "id": 19094,
                        "name": "Quirihue",
                        "latitude": "-36.27998000",
                        "longitude": "-72.54118000"
                    },
                    {
                        "id": 148429,
                        "name": "Ránquil",
                        "latitude": "-36.65000000",
                        "longitude": "-72.55000000"
                    },
                    {
                        "id": 19103,
                        "name": "San Carlos",
                        "latitude": "-36.42477000",
                        "longitude": "-71.95800000"
                    },
                    {
                        "id": 148430,
                        "name": "San Fabián",
                        "latitude": "-36.55000000",
                        "longitude": "-71.55000000"
                    },
                    {
                        "id": 148431,
                        "name": "San Ignacio",
                        "latitude": "-36.79999910",
                        "longitude": "-72.04207620"
                    },
                    {
                        "id": 148432,
                        "name": "San Nicolás",
                        "latitude": "-36.50000000",
                        "longitude": "-72.21666667"
                    },
                    {
                        "id": 148433,
                        "name": "Treguaco",
                        "latitude": "-36.43333333",
                        "longitude": "-72.66666667"
                    },
                    {
                        "id": 148434,
                        "name": "Yungay",
                        "latitude": "-37.11666667",
                        "longitude": "-72.01666667"
                    }
                ]
            },
            {
                "id": 2824,
                "name": "Región Metropolitana de Santiago",
                "iso2": "RM",
                "latitude": "-33.43755450",
                "longitude": "-70.65048960",
                "type": "region",
                "cities": [
                    {
                        "id": 148500,
                        "name": "Alhué",
                        "latitude": "-34.03333333",
                        "longitude": "-71.10000000"
                    },
                    {
                        "id": 18949,
                        "name": "Buin",
                        "latitude": "-33.73257000",
                        "longitude": "-70.74281000"
                    },
                    {
                        "id": 148501,
                        "name": "Calera de Tango",
                        "latitude": "-33.65000000",
                        "longitude": "-70.81666667"
                    },
                    {
                        "id": 148535,
                        "name": "Cerrillos",
                        "latitude": "-33.50229190",
                        "longitude": "-70.73009420"
                    },
                    {
                        "id": 148540,
                        "name": "Cerro Navia",
                        "latitude": "-33.42516430",
                        "longitude": "-70.78407540"
                    },
                    {
                        "id": 148502,
                        "name": "Colina",
                        "latitude": "-33.20000000",
                        "longitude": "-70.68333333"
                    },
                    {
                        "id": 148503,
                        "name": "Conchalí",
                        "latitude": "-33.35000000",
                        "longitude": "-70.61666667"
                    },
                    {
                        "id": 148536,
                        "name": "Curacaví",
                        "latitude": "-33.46937830",
                        "longitude": "-70.72612030"
                    },
                    {
                        "id": 148504,
                        "name": "El Bosque",
                        "latitude": "-33.56666667",
                        "longitude": "-70.70000000"
                    },
                    {
                        "id": 18982,
                        "name": "El Monte",
                        "latitude": "-33.67969000",
                        "longitude": "-70.98482000"
                    },
                    {
                        "id": 148505,
                        "name": "Estación Central",
                        "latitude": "-33.45194400",
                        "longitude": "-70.67888900"
                    },
                    {
                        "id": 148537,
                        "name": "Huechuraba",
                        "latitude": "-33.36928270",
                        "longitude": "-70.66482650"
                    },
                    {
                        "id": 148506,
                        "name": "Independencia",
                        "latitude": "-33.41666667",
                        "longitude": "-70.63333333"
                    },
                    {
                        "id": 148507,
                        "name": "Isla de Maipo",
                        "latitude": "-33.75000000",
                        "longitude": "-70.90000000"
                    },
                    {
                        "id": 148508,
                        "name": "La Cisterna",
                        "latitude": "-33.55000000",
                        "longitude": "-70.68333000"
                    },
                    {
                        "id": 148510,
                        "name": "La Florida",
                        "latitude": "-33.55000000",
                        "longitude": "-70.56666667"
                    },
                    {
                        "id": 148511,
                        "name": "La Granja",
                        "latitude": "-33.54305556",
                        "longitude": "-70.63194444"
                    },
                    {
                        "id": 18993,
                        "name": "La Pintana",
                        "latitude": "-33.58331000",
                        "longitude": "-70.63419000"
                    },
                    {
                        "id": 148512,
                        "name": "La Reina",
                        "latitude": "-33.45000000",
                        "longitude": "-70.55000000"
                    },
                    {
                        "id": 18997,
                        "name": "Lampa",
                        "latitude": "-33.28630000",
                        "longitude": "-70.87561000"
                    },
                    {
                        "id": 148513,
                        "name": "Las Condes",
                        "latitude": "-33.41666667",
                        "longitude": "-70.58333333"
                    },
                    {
                        "id": 148514,
                        "name": "Lo Barnechea",
                        "latitude": "-33.35000000",
                        "longitude": "-70.51666667"
                    },
                    {
                        "id": 148515,
                        "name": "Lo Espejo",
                        "latitude": "-33.53333333",
                        "longitude": "-70.71666667"
                    },
                    {
                        "id": 19005,
                        "name": "Lo Prado",
                        "latitude": "-33.44430000",
                        "longitude": "-70.72552000"
                    },
                    {
                        "id": 148516,
                        "name": "Macul",
                        "latitude": "-33.50000000",
                        "longitude": "-70.56666667"
                    },
                    {
                        "id": 148517,
                        "name": "Maipú",
                        "latitude": "-33.51666667",
                        "longitude": "-70.76666667"
                    },
                    {
                        "id": 148518,
                        "name": "María Pinto",
                        "latitude": "-33.53333333",
                        "longitude": "-71.13333333"
                    },
                    {
                        "id": 19012,
                        "name": "Melipilla",
                        "latitude": "-33.68909000",
                        "longitude": "-71.21528000"
                    },
                    {
                        "id": 148534,
                        "name": "Ñuñoa",
                        "latitude": "-33.46666667",
                        "longitude": "-70.60000000"
                    },
                    {
                        "id": 148519,
                        "name": "Padre Hurtado",
                        "latitude": "-33.56666667",
                        "longitude": "-70.83333333"
                    },
                    {
                        "id": 19020,
                        "name": "Paine",
                        "latitude": "-33.80796000",
                        "longitude": "-70.74109000"
                    },
                    {
                        "id": 148520,
                        "name": "Pedro Aguirre Cerda",
                        "latitude": "-33.46666667",
                        "longitude": "-70.63333333"
                    },
                    {
                        "id": 19026,
                        "name": "Peñaflor",
                        "latitude": "-33.60627000",
                        "longitude": "-70.87649000"
                    },
                    {
                        "id": 148521,
                        "name": "Peñalolén",
                        "latitude": "-33.48333333",
                        "longitude": "-70.53333333"
                    },
                    {
                        "id": 148522,
                        "name": "Pirque",
                        "latitude": "-33.71865000",
                        "longitude": "-70.50658000"
                    },
                    {
                        "id": 148523,
                        "name": "Providencia",
                        "latitude": "-33.43333333",
                        "longitude": "-70.61666667"
                    },
                    {
                        "id": 148538,
                        "name": "Pudahuel",
                        "latitude": "-33.41883590",
                        "longitude": "-70.91463070"
                    },
                    {
                        "id": 19081,
                        "name": "Puente Alto",
                        "latitude": "-33.61169000",
                        "longitude": "-70.57577000"
                    },
                    {
                        "id": 148524,
                        "name": "Quilicura",
                        "latitude": "-33.36666667",
                        "longitude": "-70.75000000"
                    },
                    {
                        "id": 148525,
                        "name": "Quinta Normal",
                        "latitude": "-33.45000000",
                        "longitude": "-70.70000000"
                    },
                    {
                        "id": 148526,
                        "name": "Recoleta",
                        "latitude": "-33.41666667",
                        "longitude": "-70.65000000"
                    },
                    {
                        "id": 148527,
                        "name": "Renca",
                        "latitude": "-33.40000000",
                        "longitude": "-70.73333333"
                    },
                    {
                        "id": 19102,
                        "name": "San Bernardo",
                        "latitude": "-33.59217000",
                        "longitude": "-70.69960000"
                    },
                    {
                        "id": 148528,
                        "name": "San Joaquín",
                        "latitude": "-33.50000000",
                        "longitude": "-70.61666667"
                    },
                    {
                        "id": 148529,
                        "name": "San José de Maipo",
                        "latitude": "-33.63333333",
                        "longitude": "-70.36666667"
                    },
                    {
                        "id": 148530,
                        "name": "San Miguel",
                        "latitude": "-33.50000000",
                        "longitude": "-70.66666667"
                    },
                    {
                        "id": 148531,
                        "name": "San Pedro",
                        "latitude": "-33.90000000",
                        "longitude": "-71.46666667"
                    },
                    {
                        "id": 148539,
                        "name": "San Ramón",
                        "latitude": "-33.53775950",
                        "longitude": "-70.65176730"
                    },
                    {
                        "id": 19111,
                        "name": "Santiago",
                        "latitude": "-33.45694000",
                        "longitude": "-70.64827000"
                    },
                    {
                        "id": 19112,
                        "name": "Talagante",
                        "latitude": "-33.66386000",
                        "longitude": "-70.92734000"
                    },
                    {
                        "id": 148532,
                        "name": "Tiltil",
                        "latitude": "-33.08333333",
                        "longitude": "-70.93333333"
                    },
                    {
                        "id": 148533,
                        "name": "Vitacura",
                        "latitude": "-33.40000000",
                        "longitude": "-70.60000000"
                    }
                ]
            },
            {
                "id": 2837,
                "name": "Tarapacá",
                "iso2": "TA",
                "latitude": "-20.20287990",
                "longitude": "-69.28775350",
                "type": "region",
                "cities": [
                    {
                        "id": 148412,
                        "name": "Alto Hospicio",
                        "latitude": "-20.25000000",
                        "longitude": "-70.11666667"
                    },
                    {
                        "id": 148413,
                        "name": "Camiña",
                        "latitude": "-19.30000000",
                        "longitude": "-69.41666667"
                    },
                    {
                        "id": 148414,
                        "name": "Colchane",
                        "latitude": "-19.27541100",
                        "longitude": "-68.63964600"
                    },
                    {
                        "id": 148415,
                        "name": "Huara",
                        "latitude": "-19.96666667",
                        "longitude": "-69.76666667"
                    },
                    {
                        "id": 18989,
                        "name": "Iquique",
                        "latitude": "-20.21326000",
                        "longitude": "-70.15027000"
                    },
                    {
                        "id": 148416,
                        "name": "Pica",
                        "latitude": "-20.50000000",
                        "longitude": "-69.33333333"
                    },
                    {
                        "id": 148417,
                        "name": "Pozo Almonte",
                        "latitude": "-20.25970000",
                        "longitude": "-69.78620000"
                    }
                ]
            },
            {
                "id": 2830,
                "name": "Valparaíso",
                "iso2": "VS",
                "latitude": "-33.04723800",
                "longitude": "-71.61268850",
                "type": "region",
                "cities": [
                    {
                        "id": 148452,
                        "name": "Algarrobo",
                        "latitude": "-33.36925600",
                        "longitude": "-71.66813900"
                    },
                    {
                        "id": 148453,
                        "name": "Cabildo",
                        "latitude": "-32.41737000",
                        "longitude": "-70.82435000"
                    },
                    {
                        "id": 148454,
                        "name": "Calle Larga",
                        "latitude": "-32.85000000",
                        "longitude": "-70.63333333"
                    },
                    {
                        "id": 18955,
                        "name": "Cartagena",
                        "latitude": "-33.55384000",
                        "longitude": "-71.60761000"
                    },
                    {
                        "id": 148455,
                        "name": "Casablanca",
                        "latitude": "-33.31666667",
                        "longitude": "-71.41666667"
                    },
                    {
                        "id": 148456,
                        "name": "Catemu",
                        "latitude": "-32.63333333",
                        "longitude": "-71.03333333"
                    },
                    {
                        "id": 148457,
                        "name": "Concón",
                        "latitude": "-32.91666667",
                        "longitude": "-71.51666667"
                    },
                    {
                        "id": 148458,
                        "name": "El Quisco",
                        "latitude": "-33.40000000",
                        "longitude": "-71.70000000"
                    },
                    {
                        "id": 148459,
                        "name": "El Tabo",
                        "latitude": "-33.45000000",
                        "longitude": "-71.66666667"
                    },
                    {
                        "id": 148460,
                        "name": "Hijuelas",
                        "latitude": "-32.80000000",
                        "longitude": "-71.16666667"
                    },
                    {
                        "id": 19055,
                        "name": "Isla de Pascua",
                        "latitude": "-27.11048000",
                        "longitude": "-109.29749000"
                    },
                    {
                        "id": 148461,
                        "name": "Juan Fernández",
                        "latitude": "-30.02564270",
                        "longitude": "-82.05192080"
                    },
                    {
                        "id": 148463,
                        "name": "La Calera",
                        "latitude": "-32.78333333",
                        "longitude": "-71.21666667"
                    },
                    {
                        "id": 148464,
                        "name": "La Cruz",
                        "latitude": "-32.81666667",
                        "longitude": "-71.23333333"
                    },
                    {
                        "id": 18992,
                        "name": "La Ligua",
                        "latitude": "-32.45242000",
                        "longitude": "-71.23106000"
                    },
                    {
                        "id": 19002,
                        "name": "Limache",
                        "latitude": "-33.01667000",
                        "longitude": "-71.26667000"
                    },
                    {
                        "id": 19004,
                        "name": "Llaillay",
                        "latitude": "-32.84043000",
                        "longitude": "-70.95623000"
                    },
                    {
                        "id": 19008,
                        "name": "Los Andes",
                        "latitude": "-32.83369000",
                        "longitude": "-70.59827000"
                    },
                    {
                        "id": 148465,
                        "name": "Nogales",
                        "latitude": "-32.71666667",
                        "longitude": "-71.23333333"
                    },
                    {
                        "id": 148466,
                        "name": "Olmué",
                        "latitude": "-33.00000000",
                        "longitude": "-71.20000000"
                    },
                    {
                        "id": 148467,
                        "name": "Panquehue",
                        "latitude": "-32.80000000",
                        "longitude": "-70.83333333"
                    },
                    {
                        "id": 148468,
                        "name": "Papudo",
                        "latitude": "-32.51666667",
                        "longitude": "-71.45000000"
                    },
                    {
                        "id": 148469,
                        "name": "Petorca",
                        "latitude": "-32.25000000",
                        "longitude": "-70.93333333"
                    },
                    {
                        "id": 148470,
                        "name": "Puchuncaví",
                        "latitude": "-32.72575000",
                        "longitude": "-71.41514000"
                    },
                    {
                        "id": 148471,
                        "name": "Putaendo",
                        "latitude": "-32.63333333",
                        "longitude": "-70.73333333"
                    },
                    {
                        "id": 19092,
                        "name": "Quillota",
                        "latitude": "-32.88341000",
                        "longitude": "-71.24882000"
                    },
                    {
                        "id": 19093,
                        "name": "Quilpué",
                        "latitude": "-33.04752000",
                        "longitude": "-71.44249000"
                    },
                    {
                        "id": 148472,
                        "name": "Quintero",
                        "latitude": "-32.78333333",
                        "longitude": "-71.53333333"
                    },
                    {
                        "id": 148473,
                        "name": "Rinconada",
                        "latitude": "-32.83333333",
                        "longitude": "-70.70000000"
                    },
                    {
                        "id": 19100,
                        "name": "San Antonio",
                        "latitude": "-33.59473000",
                        "longitude": "-71.60746000"
                    },
                    {
                        "id": 148474,
                        "name": "San Esteban",
                        "latitude": "-32.80000000",
                        "longitude": "-70.58333333"
                    },
                    {
                        "id": 19105,
                        "name": "San Felipe",
                        "latitude": "-32.74976000",
                        "longitude": "-70.72584000"
                    },
                    {
                        "id": 148475,
                        "name": "Santa María",
                        "latitude": "-32.75000000",
                        "longitude": "-70.66666667"
                    },
                    {
                        "id": 148462,
                        "name": "Santo Domingo",
                        "latitude": "-33.64719330",
                        "longitude": "-71.63527900"
                    },
                    {
                        "id": 19123,
                        "name": "Valparaíso",
                        "latitude": "-33.03600000",
                        "longitude": "-71.62963000"
                    },
                    {
                        "id": 19127,
                        "name": "Villa Alemana",
                        "latitude": "-33.04222000",
                        "longitude": "-71.37333000"
                    },
                    {
                        "id": 19130,
                        "name": "Viña del Mar",
                        "latitude": "-33.02457000",
                        "longitude": "-71.55183000"
                    },
                    {
                        "id": 148476,
                        "name": "Zapallar",
                        "latitude": "-32.55390000",
                        "longitude": "-71.45770000"
                    }
                ]
            }
        ]
    },
    {
        "id": 45,
        "name": "China",
        "iso3": "CHN",
        "iso2": "CN",
        "numeric_code": "156",
        "phonecode": "86",
        "capital": "Beijing",
        "currency": "CNY",
        "currency_name": "Chinese yuan",
        "currency_symbol": "¥",
        "tld": ".cn",
        "native": "中国",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Eastern Asia",
        "subregion_id": 12,
        "nationality": "Chinese",
        "timezones": [
            {
                "zoneName": "Asia\/Shanghai",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "CST",
                "tzName": "China Standard Time"
            },
            {
                "zoneName": "Asia\/Urumqi",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "XJT",
                "tzName": "China Standard Time"
            }
        ],
        "translations": {
            "br": "Sina",
            "ko": "중국",
            "pt-BR": "China",
            "pt": "China",
            "nl": "China",
            "hr": "Kina",
            "fa": "چین",
            "de": "China",
            "es": "China",
            "fr": "Chine",
            "ja": "中国",
            "it": "Cina",
            "zh-CN": "中国",
            "tr": "Çin",
            "ru": "Китай",
            "uk": "Китай",
            "pl": "Chiny"
        },
        "latitude": "35.00000000",
        "longitude": "105.00000000",
        "emoji": "🇨🇳",
        "emojiU": "U+1F1E8 U+1F1F3",
        "states": [
            {
                "id": 2251,
                "name": "Anhui",
                "iso2": "AH",
                "latitude": "30.60067730",
                "longitude": "117.92490020",
                "type": "province",
                "cities": [
                    {
                        "id": 19284,
                        "name": "Anqing",
                        "latitude": "30.51365000",
                        "longitude": "117.04723000"
                    },
                    {
                        "id": 19285,
                        "name": "Anqing Shi",
                        "latitude": "30.66266000",
                        "longitude": "116.55911000"
                    },
                    {
                        "id": 19338,
                        "name": "Bengbu",
                        "latitude": "32.94083000",
                        "longitude": "117.36083000"
                    },
                    {
                        "id": 19351,
                        "name": "Bozhou",
                        "latitude": "33.87722000",
                        "longitude": "115.77028000"
                    },
                    {
                        "id": 19380,
                        "name": "Chaohu",
                        "latitude": "31.60000000",
                        "longitude": "117.86667000"
                    },
                    {
                        "id": 19401,
                        "name": "Chizhou",
                        "latitude": "30.66134000",
                        "longitude": "117.47783000"
                    },
                    {
                        "id": 19402,
                        "name": "Chizhou Shi",
                        "latitude": "30.30431000",
                        "longitude": "117.41388000"
                    },
                    {
                        "id": 19410,
                        "name": "Chuzhou",
                        "latitude": "32.32194000",
                        "longitude": "118.29778000"
                    },
                    {
                        "id": 19411,
                        "name": "Chuzhou Shi",
                        "latitude": "32.60084000",
                        "longitude": "118.08813000"
                    },
                    {
                        "id": 19435,
                        "name": "Datong",
                        "latitude": "32.62082000",
                        "longitude": "117.06319000"
                    },
                    {
                        "id": 19525,
                        "name": "Fuyang",
                        "latitude": "32.90000000",
                        "longitude": "115.81667000"
                    },
                    {
                        "id": 19527,
                        "name": "Fuyang Shi",
                        "latitude": "32.93718000",
                        "longitude": "115.70778000"
                    },
                    {
                        "id": 19579,
                        "name": "Gushu",
                        "latitude": "31.56055000",
                        "longitude": "118.48147000"
                    },
                    {
                        "id": 19607,
                        "name": "Hefei",
                        "latitude": "31.86389000",
                        "longitude": "117.28083000"
                    },
                    {
                        "id": 19608,
                        "name": "Hefei Shi",
                        "latitude": "31.94665000",
                        "longitude": "117.27805000"
                    },
                    {
                        "id": 19636,
                        "name": "Huaibei",
                        "latitude": "33.97444000",
                        "longitude": "116.79167000"
                    },
                    {
                        "id": 19640,
                        "name": "Huainan",
                        "latitude": "32.62639000",
                        "longitude": "116.99694000"
                    },
                    {
                        "id": 19641,
                        "name": "Huainan Shi",
                        "latitude": "32.73824000",
                        "longitude": "116.78813000"
                    },
                    {
                        "id": 19642,
                        "name": "Huaiyuan Chengguanzhen",
                        "latitude": "32.95893000",
                        "longitude": "117.16566000"
                    },
                    {
                        "id": 19656,
                        "name": "Huangshan",
                        "latitude": "29.71139000",
                        "longitude": "118.31250000"
                    },
                    {
                        "id": 19657,
                        "name": "Huangshan Shi",
                        "latitude": "29.89195000",
                        "longitude": "118.10553000"
                    },
                    {
                        "id": 19685,
                        "name": "Huoqiu Chengguanzhen",
                        "latitude": "32.35473000",
                        "longitude": "116.29390000"
                    },
                    {
                        "id": 19721,
                        "name": "Jieshou",
                        "latitude": "33.26338000",
                        "longitude": "115.36108000"
                    },
                    {
                        "id": 19895,
                        "name": "Lu’an",
                        "latitude": "31.73561000",
                        "longitude": "116.51688000"
                    },
                    {
                        "id": 19880,
                        "name": "Lucheng",
                        "latitude": "31.23357000",
                        "longitude": "117.28057000"
                    },
                    {
                        "id": 19914,
                        "name": "Mengcheng Chengguanzhen",
                        "latitude": "33.26611000",
                        "longitude": "116.56605000"
                    },
                    {
                        "id": 19919,
                        "name": "Mingguang",
                        "latitude": "32.78017000",
                        "longitude": "117.96378000"
                    },
                    {
                        "id": 20144,
                        "name": "Suixi",
                        "latitude": "33.89067000",
                        "longitude": "116.77473000"
                    },
                    {
                        "id": 20149,
                        "name": "Suzhou",
                        "latitude": "33.63611000",
                        "longitude": "116.97889000"
                    },
                    {
                        "id": 20151,
                        "name": "Suzhou Shi",
                        "latitude": "33.86970000",
                        "longitude": "117.20569000"
                    },
                    {
                        "id": 20173,
                        "name": "Tangzhai",
                        "latitude": "34.43278000",
                        "longitude": "116.59111000"
                    },
                    {
                        "id": 20229,
                        "name": "Wucheng",
                        "latitude": "29.60077000",
                        "longitude": "118.17495000"
                    },
                    {
                        "id": 20234,
                        "name": "Wuhu",
                        "latitude": "31.33728000",
                        "longitude": "118.37351000"
                    },
                    {
                        "id": 20236,
                        "name": "Wusong",
                        "latitude": "30.95000000",
                        "longitude": "117.78333000"
                    },
                    {
                        "id": 20241,
                        "name": "Wuyang",
                        "latitude": "31.99250000",
                        "longitude": "116.24722000"
                    },
                    {
                        "id": 20330,
                        "name": "Xuanzhou",
                        "latitude": "30.95250000",
                        "longitude": "118.75528000"
                    },
                    {
                        "id": 20380,
                        "name": "Yingshang Chengguanzhen",
                        "latitude": "32.62945000",
                        "longitude": "116.27013000"
                    }
                ]
            },
            {
                "id": 2257,
                "name": "Beijing",
                "iso2": "BJ",
                "latitude": "39.90419990",
                "longitude": "116.40739630",
                "type": "municipality",
                "cities": [
                    {
                        "id": 19332,
                        "name": "Beijing",
                        "latitude": "39.90750000",
                        "longitude": "116.39723000"
                    },
                    {
                        "id": 19370,
                        "name": "Changping",
                        "latitude": "40.21612000",
                        "longitude": "116.23471000"
                    },
                    {
                        "id": 19439,
                        "name": "Daxing",
                        "latitude": "39.74025000",
                        "longitude": "116.32693000"
                    },
                    {
                        "id": 19499,
                        "name": "Fangshan",
                        "latitude": "39.68699000",
                        "longitude": "115.99658000"
                    },
                    {
                        "id": 19817,
                        "name": "Liangxiang",
                        "latitude": "39.73598000",
                        "longitude": "116.13295000"
                    },
                    {
                        "id": 19916,
                        "name": "Mentougou",
                        "latitude": "39.93819000",
                        "longitude": "116.09307000"
                    },
                    {
                        "id": 20126,
                        "name": "Shunyi",
                        "latitude": "40.12175000",
                        "longitude": "116.64783000"
                    },
                    {
                        "id": 20197,
                        "name": "Tongzhou",
                        "latitude": "39.90395000",
                        "longitude": "116.66183000"
                    }
                ]
            },
            {
                "id": 2271,
                "name": "Chongqing",
                "iso2": "CQ",
                "latitude": "29.43158610",
                "longitude": "106.91225100",
                "type": "municipality",
                "cities": [
                    {
                        "id": 19327,
                        "name": "Beibei",
                        "latitude": "29.82739000",
                        "longitude": "106.43645000"
                    },
                    {
                        "id": 19356,
                        "name": "Caijia",
                        "latitude": "28.90889000",
                        "longitude": "106.34040000"
                    },
                    {
                        "id": 19404,
                        "name": "Chongqing",
                        "latitude": "29.56278000",
                        "longitude": "106.55278000"
                    },
                    {
                        "id": 19479,
                        "name": "Dongxi",
                        "latitude": "28.76139000",
                        "longitude": "106.66111000"
                    },
                    {
                        "id": 19521,
                        "name": "Fuling",
                        "latitude": "29.70600000",
                        "longitude": "107.39575000"
                    },
                    {
                        "id": 19536,
                        "name": "Ganshui",
                        "latitude": "28.74222000",
                        "longitude": "106.71111000"
                    },
                    {
                        "id": 19577,
                        "name": "Guofuchang",
                        "latitude": "28.85000000",
                        "longitude": "106.60139000"
                    },
                    {
                        "id": 19604,
                        "name": "Hechuan",
                        "latitude": "29.99228000",
                        "longitude": "106.26461000"
                    },
                    {
                        "id": 19724,
                        "name": "Jijiang",
                        "latitude": "29.28993000",
                        "longitude": "106.25001000"
                    },
                    {
                        "id": 19815,
                        "name": "Liangping District",
                        "latitude": "30.67409000",
                        "longitude": "107.79380000"
                    },
                    {
                        "id": 19991,
                        "name": "Puhechang",
                        "latitude": "28.95250000",
                        "longitude": "106.83111000"
                    },
                    {
                        "id": 20084,
                        "name": "Shapingba District",
                        "latitude": "29.54166000",
                        "longitude": "106.45547000"
                    },
                    {
                        "id": 20095,
                        "name": "Shijiaochang",
                        "latitude": "28.92444000",
                        "longitude": "106.75611000"
                    },
                    {
                        "id": 20211,
                        "name": "Wanxian",
                        "latitude": "30.81544000",
                        "longitude": "108.37089000"
                    },
                    {
                        "id": 20212,
                        "name": "Wanzhou District",
                        "latitude": "30.70576000",
                        "longitude": "108.40202000"
                    },
                    {
                        "id": 20385,
                        "name": "Yongchuan",
                        "latitude": "29.35376000",
                        "longitude": "105.89392000"
                    },
                    {
                        "id": 20395,
                        "name": "Yudong",
                        "latitude": "29.38500000",
                        "longitude": "106.51944000"
                    },
                    {
                        "id": 20412,
                        "name": "Yuzhong District",
                        "latitude": "29.55208000",
                        "longitude": "106.53814000"
                    }
                ]
            },
            {
                "id": 2248,
                "name": "Fujian",
                "iso2": "FJ",
                "latitude": "26.48368420",
                "longitude": "117.92490020",
                "type": "province",
                "cities": [
                    {
                        "id": 19296,
                        "name": "Badu",
                        "latitude": "26.81028000",
                        "longitude": "119.56417000"
                    },
                    {
                        "id": 19301,
                        "name": "Baiqi",
                        "latitude": "24.88244000",
                        "longitude": "118.70869000"
                    },
                    {
                        "id": 19310,
                        "name": "Baiyun",
                        "latitude": "26.03648000",
                        "longitude": "118.90622000"
                    },
                    {
                        "id": 19334,
                        "name": "Beishancun",
                        "latitude": "26.43732000",
                        "longitude": "119.63372000"
                    },
                    {
                        "id": 19371,
                        "name": "Changqiao",
                        "latitude": "26.82139000",
                        "longitude": "118.84361000"
                    },
                    {
                        "id": 19391,
                        "name": "Chengmen",
                        "latitude": "25.99339000",
                        "longitude": "119.36136000"
                    },
                    {
                        "id": 19400,
                        "name": "Chixi",
                        "latitude": "26.91111000",
                        "longitude": "119.48306000"
                    },
                    {
                        "id": 19405,
                        "name": "Chongru",
                        "latitude": "26.95111000",
                        "longitude": "119.92528000"
                    },
                    {
                        "id": 19414,
                        "name": "Dadeng",
                        "latitude": "24.54386000",
                        "longitude": "118.32753000"
                    },
                    {
                        "id": 19417,
                        "name": "Daixi",
                        "latitude": "26.81250000",
                        "longitude": "119.11417000"
                    },
                    {
                        "id": 19427,
                        "name": "Danyang",
                        "latitude": "26.35102000",
                        "longitude": "119.48030000"
                    },
                    {
                        "id": 19429,
                        "name": "Daqiao",
                        "latitude": "26.61500000",
                        "longitude": "118.90639000"
                    },
                    {
                        "id": 19444,
                        "name": "Dazuo",
                        "latitude": "24.88616000",
                        "longitude": "118.96433000"
                    },
                    {
                        "id": 19457,
                        "name": "Dinghaicun",
                        "latitude": "26.28022000",
                        "longitude": "119.78964000"
                    },
                    {
                        "id": 19459,
                        "name": "Dingtoucun",
                        "latitude": "26.83977000",
                        "longitude": "119.66111000"
                    },
                    {
                        "id": 19462,
                        "name": "Dongchongcun",
                        "latitude": "26.54001000",
                        "longitude": "119.83257000"
                    },
                    {
                        "id": 19464,
                        "name": "Dongdai",
                        "latitude": "26.24366000",
                        "longitude": "119.61566000"
                    },
                    {
                        "id": 19469,
                        "name": "Donghu",
                        "latitude": "26.23453000",
                        "longitude": "119.51430000"
                    },
                    {
                        "id": 19471,
                        "name": "Dongling",
                        "latitude": "24.98271000",
                        "longitude": "118.89790000"
                    },
                    {
                        "id": 19482,
                        "name": "Dongyuan",
                        "latitude": "24.91738000",
                        "longitude": "118.75236000"
                    },
                    {
                        "id": 19502,
                        "name": "Feiluan",
                        "latitude": "26.56250000",
                        "longitude": "119.59750000"
                    },
                    {
                        "id": 19508,
                        "name": "Fengpu",
                        "latitude": "26.68276000",
                        "longitude": "118.76006000"
                    },
                    {
                        "id": 19512,
                        "name": "Fengzhou",
                        "latitude": "24.95762000",
                        "longitude": "118.53365000"
                    },
                    {
                        "id": 19532,
                        "name": "Fu’an",
                        "latitude": "27.06372000",
                        "longitude": "119.65280000"
                    },
                    {
                        "id": 19517,
                        "name": "Fuding",
                        "latitude": "27.32734000",
                        "longitude": "120.21399000"
                    },
                    {
                        "id": 19522,
                        "name": "Fuqing",
                        "latitude": "25.72500000",
                        "longitude": "119.37944000"
                    },
                    {
                        "id": 19531,
                        "name": "Fuzhou",
                        "latitude": "26.06139000",
                        "longitude": "119.30611000"
                    },
                    {
                        "id": 19537,
                        "name": "Gantang",
                        "latitude": "26.92000000",
                        "longitude": "119.63333000"
                    },
                    {
                        "id": 19566,
                        "name": "Guantou",
                        "latitude": "26.13593000",
                        "longitude": "119.56162000"
                    },
                    {
                        "id": 19568,
                        "name": "Gufeng",
                        "latitude": "26.90833000",
                        "longitude": "118.98194000"
                    },
                    {
                        "id": 19618,
                        "name": "Hetang",
                        "latitude": "26.66276000",
                        "longitude": "119.11062000"
                    },
                    {
                        "id": 19628,
                        "name": "Hongtang",
                        "latitude": "26.07056000",
                        "longitude": "119.23083000"
                    },
                    {
                        "id": 19629,
                        "name": "Hongyang",
                        "latitude": "26.52861000",
                        "longitude": "119.46250000"
                    },
                    {
                        "id": 19632,
                        "name": "Houyu",
                        "latitude": "26.05958000",
                        "longitude": "119.53502000"
                    },
                    {
                        "id": 19643,
                        "name": "Huai’an",
                        "latitude": "26.09899000",
                        "longitude": "119.22171000"
                    },
                    {
                        "id": 19659,
                        "name": "Huangtian",
                        "latitude": "26.43851000",
                        "longitude": "118.62398000"
                    },
                    {
                        "id": 19686,
                        "name": "Huotong",
                        "latitude": "26.84972000",
                        "longitude": "119.41806000"
                    },
                    {
                        "id": 19709,
                        "name": "Jian’ou",
                        "latitude": "27.04694000",
                        "longitude": "118.32528000"
                    },
                    {
                        "id": 19697,
                        "name": "Jiangkou",
                        "latitude": "25.48694000",
                        "longitude": "119.19834000"
                    },
                    {
                        "id": 19706,
                        "name": "Jianjiang",
                        "latitude": "26.54972000",
                        "longitude": "119.75500000"
                    },
                    {
                        "id": 19732,
                        "name": "Jingfeng",
                        "latitude": "24.97441000",
                        "longitude": "118.96486000"
                    },
                    {
                        "id": 19744,
                        "name": "Jinjiang",
                        "latitude": "24.81978000",
                        "longitude": "118.57415000"
                    },
                    {
                        "id": 19746,
                        "name": "Jinjing",
                        "latitude": "24.57500000",
                        "longitude": "118.59722000"
                    },
                    {
                        "id": 19755,
                        "name": "Jitoucun",
                        "latitude": "26.47681000",
                        "longitude": "119.60517000"
                    },
                    {
                        "id": 19777,
                        "name": "Kengyuan",
                        "latitude": "26.33964000",
                        "longitude": "119.76476000"
                    },
                    {
                        "id": 19778,
                        "name": "Kerencun",
                        "latitude": "24.58213000",
                        "longitude": "118.66046000"
                    },
                    {
                        "id": 19780,
                        "name": "Kuai’an",
                        "latitude": "26.03417000",
                        "longitude": "119.41639000"
                    },
                    {
                        "id": 19820,
                        "name": "Lianhecun",
                        "latitude": "24.58932000",
                        "longitude": "118.33903000"
                    },
                    {
                        "id": 19862,
                        "name": "Liuwudiancun",
                        "latitude": "24.56923000",
                        "longitude": "118.19064000"
                    },
                    {
                        "id": 19870,
                        "name": "Longmen",
                        "latitude": "24.95972000",
                        "longitude": "118.08889000"
                    },
                    {
                        "id": 19875,
                        "name": "Longyan",
                        "latitude": "25.10722000",
                        "longitude": "117.02250000"
                    },
                    {
                        "id": 19886,
                        "name": "Luoqiao",
                        "latitude": "26.47265000",
                        "longitude": "119.00392000"
                    },
                    {
                        "id": 19890,
                        "name": "Luoyang",
                        "latitude": "24.95938000",
                        "longitude": "118.68300000"
                    },
                    {
                        "id": 19892,
                        "name": "Luxia",
                        "latitude": "26.93000000",
                        "longitude": "118.80722000"
                    },
                    {
                        "id": 19907,
                        "name": "Maping",
                        "latitude": "24.68722000",
                        "longitude": "118.55278000"
                    },
                    {
                        "id": 19911,
                        "name": "Meipu",
                        "latitude": "26.21120000",
                        "longitude": "118.89561000"
                    },
                    {
                        "id": 19924,
                        "name": "Min’an",
                        "latitude": "26.04962000",
                        "longitude": "119.49964000"
                    },
                    {
                        "id": 19947,
                        "name": "Nanping",
                        "latitude": "26.64500000",
                        "longitude": "118.17361000"
                    },
                    {
                        "id": 19955,
                        "name": "Neikeng",
                        "latitude": "24.78544000",
                        "longitude": "118.46037000"
                    },
                    {
                        "id": 19960,
                        "name": "Ningde",
                        "latitude": "26.66167000",
                        "longitude": "119.52278000"
                    },
                    {
                        "id": 19971,
                        "name": "Pandu",
                        "latitude": "26.23639000",
                        "longitude": "119.45026000"
                    },
                    {
                        "id": 19990,
                        "name": "Pucheng",
                        "latitude": "27.92333000",
                        "longitude": "118.53333000"
                    },
                    {
                        "id": 19998,
                        "name": "Putian",
                        "latitude": "25.43944000",
                        "longitude": "119.01028000"
                    },
                    {
                        "id": 20012,
                        "name": "Qibu",
                        "latitude": "26.50750000",
                        "longitude": "119.54500000"
                    },
                    {
                        "id": 20013,
                        "name": "Qidu",
                        "latitude": "26.76528000",
                        "longitude": "119.54722000"
                    },
                    {
                        "id": 20036,
                        "name": "Quanzhou",
                        "latitude": "24.91389000",
                        "longitude": "118.58583000"
                    },
                    {
                        "id": 20043,
                        "name": "Rong’an",
                        "latitude": "26.12472000",
                        "longitude": "119.12139000"
                    },
                    {
                        "id": 20055,
                        "name": "Sanming",
                        "latitude": "26.24861000",
                        "longitude": "117.61861000"
                    },
                    {
                        "id": 20061,
                        "name": "Shajiang",
                        "latitude": "26.78250000",
                        "longitude": "119.96694000"
                    },
                    {
                        "id": 20064,
                        "name": "Shangjie",
                        "latitude": "26.08679000",
                        "longitude": "119.18494000"
                    },
                    {
                        "id": 20078,
                        "name": "Shanxia",
                        "latitude": "24.93802000",
                        "longitude": "118.88170000"
                    },
                    {
                        "id": 20079,
                        "name": "Shanyang",
                        "latitude": "26.67019000",
                        "longitude": "119.20509000"
                    },
                    {
                        "id": 20081,
                        "name": "Shaowu",
                        "latitude": "27.34089000",
                        "longitude": "117.48310000"
                    },
                    {
                        "id": 20098,
                        "name": "Shijing",
                        "latitude": "24.61956000",
                        "longitude": "118.42437000"
                    },
                    {
                        "id": 20102,
                        "name": "Shima",
                        "latitude": "24.44647000",
                        "longitude": "117.81216000"
                    },
                    {
                        "id": 20113,
                        "name": "Shoushan",
                        "latitude": "26.96444000",
                        "longitude": "119.16167000"
                    },
                    {
                        "id": 20118,
                        "name": "Shuangxi",
                        "latitude": "27.02248000",
                        "longitude": "119.04140000"
                    },
                    {
                        "id": 20121,
                        "name": "Shuangzhu",
                        "latitude": "26.63114000",
                        "longitude": "118.64570000"
                    },
                    {
                        "id": 20124,
                        "name": "Shuikou",
                        "latitude": "26.38360000",
                        "longitude": "118.73027000"
                    },
                    {
                        "id": 20169,
                        "name": "Tangkou",
                        "latitude": "26.95417000",
                        "longitude": "119.01278000"
                    },
                    {
                        "id": 20174,
                        "name": "Tantou",
                        "latitude": "26.03033000",
                        "longitude": "119.59739000"
                    },
                    {
                        "id": 20177,
                        "name": "Tatou",
                        "latitude": "24.61732000",
                        "longitude": "118.52672000"
                    },
                    {
                        "id": 20186,
                        "name": "Tingjiang",
                        "latitude": "26.07401000",
                        "longitude": "119.50574000"
                    },
                    {
                        "id": 20202,
                        "name": "Tuzhai",
                        "latitude": "24.98301000",
                        "longitude": "118.83194000"
                    },
                    {
                        "id": 20227,
                        "name": "Wubao",
                        "latitude": "24.59589000",
                        "longitude": "118.55359000"
                    },
                    {
                        "id": 20243,
                        "name": "Wuyishan",
                        "latitude": "27.75995000",
                        "longitude": "118.03066000"
                    },
                    {
                        "id": 20244,
                        "name": "Wuyucun",
                        "latitude": "24.33551000",
                        "longitude": "118.14489000"
                    },
                    {
                        "id": 20248,
                        "name": "Xiabaishi",
                        "latitude": "26.81528000",
                        "longitude": "119.67917000"
                    },
                    {
                        "id": 20249,
                        "name": "Xiahu",
                        "latitude": "26.61056000",
                        "longitude": "119.94833000"
                    },
                    {
                        "id": 20252,
                        "name": "Xiamen",
                        "latitude": "24.47979000",
                        "longitude": "118.08187000"
                    },
                    {
                        "id": 20253,
                        "name": "Xiancun",
                        "latitude": "26.93861000",
                        "longitude": "119.36028000"
                    },
                    {
                        "id": 20259,
                        "name": "Xiangyun",
                        "latitude": "24.97111000",
                        "longitude": "118.16028000"
                    },
                    {
                        "id": 20279,
                        "name": "Xibing",
                        "latitude": "26.98139000",
                        "longitude": "119.72472000"
                    },
                    {
                        "id": 20286,
                        "name": "Xiling",
                        "latitude": "26.81444000",
                        "longitude": "119.04722000"
                    },
                    {
                        "id": 20287,
                        "name": "Ximei",
                        "latitude": "24.98773000",
                        "longitude": "118.38580000"
                    },
                    {
                        "id": 20288,
                        "name": "Xinan",
                        "latitude": "26.72000000",
                        "longitude": "119.85556000"
                    },
                    {
                        "id": 20292,
                        "name": "Xindian",
                        "latitude": "24.61006000",
                        "longitude": "118.24068000"
                    },
                    {
                        "id": 20337,
                        "name": "Yakou",
                        "latitude": "24.67194000",
                        "longitude": "118.63722000"
                    },
                    {
                        "id": 20343,
                        "name": "Yanghou",
                        "latitude": "26.64083000",
                        "longitude": "118.50806000"
                    },
                    {
                        "id": 20348,
                        "name": "Yangzhong",
                        "latitude": "26.70556000",
                        "longitude": "119.37444000"
                    },
                    {
                        "id": 20357,
                        "name": "Yantian",
                        "latitude": "26.85333000",
                        "longitude": "119.85750000"
                    },
                    {
                        "id": 20377,
                        "name": "Yingdu",
                        "latitude": "24.97167000",
                        "longitude": "118.24417000"
                    },
                    {
                        "id": 20379,
                        "name": "Yinglin",
                        "latitude": "24.63222000",
                        "longitude": "118.58056000"
                    },
                    {
                        "id": 20387,
                        "name": "Yongning",
                        "latitude": "24.68000000",
                        "longitude": "118.69000000"
                    },
                    {
                        "id": 20404,
                        "name": "Yushan",
                        "latitude": "26.90863000",
                        "longitude": "118.56713000"
                    },
                    {
                        "id": 20425,
                        "name": "Zhangwan",
                        "latitude": "26.71139000",
                        "longitude": "119.59194000"
                    },
                    {
                        "id": 20428,
                        "name": "Zhangzhou",
                        "latitude": "24.51333000",
                        "longitude": "117.65556000"
                    },
                    {
                        "id": 20440,
                        "name": "Zhenhaicun",
                        "latitude": "24.25894000",
                        "longitude": "118.09186000"
                    },
                    {
                        "id": 20450,
                        "name": "Zhongfang",
                        "latitude": "26.60083000",
                        "longitude": "119.42583000"
                    },
                    {
                        "id": 20472,
                        "name": "Zhuoyang",
                        "latitude": "26.63003000",
                        "longitude": "119.02150000"
                    },
                    {
                        "id": 20473,
                        "name": "Zhuqi",
                        "latitude": "26.14860000",
                        "longitude": "119.10216000"
                    }
                ]
            },
            {
                "id": 2275,
                "name": "Gansu",
                "iso2": "GS",
                "latitude": "35.75183260",
                "longitude": "104.28611160",
                "type": "province",
                "cities": [
                    {
                        "id": 19309,
                        "name": "Baiyin",
                        "latitude": "36.54696000",
                        "longitude": "104.17023000"
                    },
                    {
                        "id": 19330,
                        "name": "Beidao",
                        "latitude": "34.56861000",
                        "longitude": "105.89333000"
                    },
                    {
                        "id": 19460,
                        "name": "Dingxi Shi",
                        "latitude": "35.03710000",
                        "longitude": "104.38623000"
                    },
                    {
                        "id": 19622,
                        "name": "Hezuo",
                        "latitude": "34.98556000",
                        "longitude": "102.90944000"
                    },
                    {
                        "id": 19716,
                        "name": "Jiayuguan",
                        "latitude": "39.81121000",
                        "longitude": "98.28618000"
                    },
                    {
                        "id": 19728,
                        "name": "Jinchang",
                        "latitude": "38.50062000",
                        "longitude": "102.19379000"
                    },
                    {
                        "id": 19758,
                        "name": "Jiuquan",
                        "latitude": "39.74318000",
                        "longitude": "98.51736000"
                    },
                    {
                        "id": 19803,
                        "name": "Lanzhou",
                        "latitude": "36.05701000",
                        "longitude": "103.83987000"
                    },
                    {
                        "id": 19806,
                        "name": "Laojunmiao",
                        "latitude": "39.83333000",
                        "longitude": "97.73333000"
                    },
                    {
                        "id": 19854,
                        "name": "Linxia Chengguanzhen",
                        "latitude": "35.60028000",
                        "longitude": "103.20639000"
                    },
                    {
                        "id": 19855,
                        "name": "Linxia Huizu Zizhizhou",
                        "latitude": "35.66597000",
                        "longitude": "103.24080000"
                    },
                    {
                        "id": 19871,
                        "name": "Longnan Shi",
                        "latitude": "33.53451000",
                        "longitude": "105.34947000"
                    },
                    {
                        "id": 19908,
                        "name": "Mawu",
                        "latitude": "34.42639000",
                        "longitude": "104.91472000"
                    },
                    {
                        "id": 19980,
                        "name": "Pingliang",
                        "latitude": "35.53917000",
                        "longitude": "106.68611000"
                    },
                    {
                        "id": 20015,
                        "name": "Qincheng",
                        "latitude": "34.58028000",
                        "longitude": "105.72722000"
                    },
                    {
                        "id": 20026,
                        "name": "Qingyang Shi",
                        "latitude": "36.23598000",
                        "longitude": "107.58113000"
                    },
                    {
                        "id": 20181,
                        "name": "Tianshui",
                        "latitude": "34.57952000",
                        "longitude": "105.74238000"
                    },
                    {
                        "id": 20237,
                        "name": "Wuwei",
                        "latitude": "37.92672000",
                        "longitude": "102.63202000"
                    },
                    {
                        "id": 20426,
                        "name": "Zhangye",
                        "latitude": "38.93417000",
                        "longitude": "100.45167000"
                    },
                    {
                        "id": 20427,
                        "name": "Zhangye Shi",
                        "latitude": "39.12183000",
                        "longitude": "99.92495000"
                    }
                ]
            },
            {
                "id": 2279,
                "name": "Guangdong",
                "iso2": "GD",
                "latitude": "23.37903330",
                "longitude": "113.76328280",
                "type": "province",
                "cities": [
                    {
                        "id": 19278,
                        "name": "Anbu",
                        "latitude": "23.44895000",
                        "longitude": "116.68092000"
                    },
                    {
                        "id": 19383,
                        "name": "Chaozhou",
                        "latitude": "23.65396000",
                        "longitude": "116.62262000"
                    },
                    {
                        "id": 19389,
                        "name": "Chenghua",
                        "latitude": "23.46132000",
                        "longitude": "116.77007000"
                    },
                    {
                        "id": 19422,
                        "name": "Daliang",
                        "latitude": "22.84067000",
                        "longitude": "113.25030000"
                    },
                    {
                        "id": 19426,
                        "name": "Danshui",
                        "latitude": "22.79840000",
                        "longitude": "114.46716000"
                    },
                    {
                        "id": 19432,
                        "name": "Dasha",
                        "latitude": "23.11037000",
                        "longitude": "113.44180000"
                    },
                    {
                        "id": 19467,
                        "name": "Dongguan",
                        "latitude": "23.01797000",
                        "longitude": "113.74866000"
                    },
                    {
                        "id": 19468,
                        "name": "Donghai",
                        "latitude": "22.94593000",
                        "longitude": "115.64204000"
                    },
                    {
                        "id": 19483,
                        "name": "Ducheng",
                        "latitude": "23.24212000",
                        "longitude": "111.52840000"
                    },
                    {
                        "id": 19490,
                        "name": "Encheng",
                        "latitude": "22.18659000",
                        "longitude": "112.30424000"
                    },
                    {
                        "id": 19514,
                        "name": "Foshan",
                        "latitude": "23.02677000",
                        "longitude": "113.13148000"
                    },
                    {
                        "id": 19515,
                        "name": "Foshan Shi",
                        "latitude": "23.02264000",
                        "longitude": "112.96302000"
                    },
                    {
                        "id": 19546,
                        "name": "Gaoyao",
                        "latitude": "23.02432000",
                        "longitude": "112.44555000"
                    },
                    {
                        "id": 19550,
                        "name": "Gaozhou",
                        "latitude": "21.93924000",
                        "longitude": "110.84607000"
                    },
                    {
                        "id": 19562,
                        "name": "Guangzhou",
                        "latitude": "23.11667000",
                        "longitude": "113.25000000"
                    },
                    {
                        "id": 19563,
                        "name": "Guangzhou Shi",
                        "latitude": "23.37327000",
                        "longitude": "113.51219000"
                    },
                    {
                        "id": 19590,
                        "name": "Haimen",
                        "latitude": "23.19346000",
                        "longitude": "116.61219000"
                    },
                    {
                        "id": 19617,
                        "name": "Hepo",
                        "latitude": "23.43077000",
                        "longitude": "115.82991000"
                    },
                    {
                        "id": 19620,
                        "name": "Heyuan",
                        "latitude": "23.73333000",
                        "longitude": "114.68333000"
                    },
                    {
                        "id": 19637,
                        "name": "Huaicheng",
                        "latitude": "23.91952000",
                        "longitude": "112.17629000"
                    },
                    {
                        "id": 19646,
                        "name": "Huanggang",
                        "latitude": "23.67704000",
                        "longitude": "116.99961000"
                    },
                    {
                        "id": 19669,
                        "name": "Huazhou",
                        "latitude": "21.63333000",
                        "longitude": "110.58333000"
                    },
                    {
                        "id": 19672,
                        "name": "Huicheng",
                        "latitude": "23.03845000",
                        "longitude": "116.28988000"
                    },
                    {
                        "id": 19675,
                        "name": "Huizhou",
                        "latitude": "23.11147000",
                        "longitude": "114.41523000"
                    },
                    {
                        "id": 19699,
                        "name": "Jiangmen",
                        "latitude": "22.58333000",
                        "longitude": "113.08333000"
                    },
                    {
                        "id": 19717,
                        "name": "Jiazi",
                        "latitude": "22.87932000",
                        "longitude": "116.07318000"
                    },
                    {
                        "id": 19720,
                        "name": "Jieshi",
                        "latitude": "22.81027000",
                        "longitude": "115.83058000"
                    },
                    {
                        "id": 19723,
                        "name": "Jieyang",
                        "latitude": "23.54180000",
                        "longitude": "116.36581000"
                    },
                    {
                        "id": 19807,
                        "name": "Lecheng",
                        "latitude": "25.12800000",
                        "longitude": "113.35041000"
                    },
                    {
                        "id": 19821,
                        "name": "Lianjiang",
                        "latitude": "21.64673000",
                        "longitude": "110.28172000"
                    },
                    {
                        "id": 19826,
                        "name": "Lianzhou",
                        "latitude": "24.78186000",
                        "longitude": "112.37120000"
                    },
                    {
                        "id": 19833,
                        "name": "Licheng",
                        "latitude": "23.29549000",
                        "longitude": "113.82465000"
                    },
                    {
                        "id": 19879,
                        "name": "Lubu",
                        "latitude": "23.17233000",
                        "longitude": "112.28298000"
                    },
                    {
                        "id": 19881,
                        "name": "Luocheng",
                        "latitude": "22.76953000",
                        "longitude": "111.56882000"
                    },
                    {
                        "id": 19888,
                        "name": "Luoyang",
                        "latitude": "23.16244000",
                        "longitude": "114.27342000"
                    },
                    {
                        "id": 19898,
                        "name": "Maba",
                        "latitude": "24.68413000",
                        "longitude": "113.59839000"
                    },
                    {
                        "id": 19904,
                        "name": "Maoming",
                        "latitude": "21.65000000",
                        "longitude": "110.90000000"
                    },
                    {
                        "id": 19913,
                        "name": "Meizhou",
                        "latitude": "24.28859000",
                        "longitude": "116.11768000"
                    },
                    {
                        "id": 19939,
                        "name": "Nanfeng",
                        "latitude": "23.72695000",
                        "longitude": "111.79723000"
                    },
                    {
                        "id": 19982,
                        "name": "Pingshan",
                        "latitude": "22.99376000",
                        "longitude": "114.71311000"
                    },
                    {
                        "id": 19996,
                        "name": "Puning",
                        "latitude": "23.31072000",
                        "longitude": "116.16869000"
                    },
                    {
                        "id": 20027,
                        "name": "Qingyuan",
                        "latitude": "23.70000000",
                        "longitude": "113.03333000"
                    },
                    {
                        "id": 20057,
                        "name": "Sanshui",
                        "latitude": "23.15486000",
                        "longitude": "112.89161000"
                    },
                    {
                        "id": 20076,
                        "name": "Shantou",
                        "latitude": "23.36814000",
                        "longitude": "116.71479000"
                    },
                    {
                        "id": 20077,
                        "name": "Shanwei",
                        "latitude": "22.78199000",
                        "longitude": "115.34750000"
                    },
                    {
                        "id": 20080,
                        "name": "Shaoguan",
                        "latitude": "24.80000000",
                        "longitude": "113.58333000"
                    },
                    {
                        "id": 20083,
                        "name": "Shaping",
                        "latitude": "22.77019000",
                        "longitude": "112.95776000"
                    },
                    {
                        "id": 20091,
                        "name": "Shenzhen",
                        "latitude": "22.55653000",
                        "longitude": "113.98590000"
                    },
                    {
                        "id": 20101,
                        "name": "Shilong",
                        "latitude": "23.11444000",
                        "longitude": "113.84722000"
                    },
                    {
                        "id": 20103,
                        "name": "Shiqi",
                        "latitude": "22.51682000",
                        "longitude": "113.38521000"
                    },
                    {
                        "id": 20105,
                        "name": "Shiqiao",
                        "latitude": "22.94640000",
                        "longitude": "113.35769000"
                    },
                    {
                        "id": 20107,
                        "name": "Shiwan",
                        "latitude": "23.00107000",
                        "longitude": "113.07700000"
                    },
                    {
                        "id": 20108,
                        "name": "Shixing",
                        "latitude": "24.94824000",
                        "longitude": "114.06572000"
                    },
                    {
                        "id": 20160,
                        "name": "Taishan",
                        "latitude": "22.25135000",
                        "longitude": "112.77990000"
                    },
                    {
                        "id": 20170,
                        "name": "Tangping",
                        "latitude": "22.03177000",
                        "longitude": "111.93537000"
                    },
                    {
                        "id": 20230,
                        "name": "Wuchuan",
                        "latitude": "21.45713000",
                        "longitude": "110.76591000"
                    },
                    {
                        "id": 20296,
                        "name": "Xingning",
                        "latitude": "24.14830000",
                        "longitude": "115.72272000"
                    },
                    {
                        "id": 20299,
                        "name": "Xinhui",
                        "latitude": "22.45600000",
                        "longitude": "113.04820000"
                    },
                    {
                        "id": 20312,
                        "name": "Xinyi",
                        "latitude": "22.37303000",
                        "longitude": "110.94746000"
                    },
                    {
                        "id": 20319,
                        "name": "Xiongzhou",
                        "latitude": "25.11667000",
                        "longitude": "114.30000000"
                    },
                    {
                        "id": 20333,
                        "name": "Xucheng",
                        "latitude": "20.32917000",
                        "longitude": "110.16712000"
                    },
                    {
                        "id": 20341,
                        "name": "Yangchun",
                        "latitude": "22.16667000",
                        "longitude": "111.78333000"
                    },
                    {
                        "id": 20344,
                        "name": "Yangjiang",
                        "latitude": "21.85563000",
                        "longitude": "111.96272000"
                    },
                    {
                        "id": 20375,
                        "name": "Yingcheng",
                        "latitude": "24.16588000",
                        "longitude": "113.41267000"
                    },
                    {
                        "id": 20401,
                        "name": "Yunfu",
                        "latitude": "22.92833000",
                        "longitude": "112.03954000"
                    },
                    {
                        "id": 20429,
                        "name": "Zhanjiang",
                        "latitude": "21.28145000",
                        "longitude": "110.34271000"
                    },
                    {
                        "id": 20433,
                        "name": "Zhaoqing",
                        "latitude": "23.04893000",
                        "longitude": "112.46091000"
                    },
                    {
                        "id": 20451,
                        "name": "Zhongshan",
                        "latitude": "21.31992000",
                        "longitude": "110.57230000"
                    },
                    {
                        "id": 20452,
                        "name": "Zhongshan Prefecture",
                        "latitude": "22.55358000",
                        "longitude": "113.37550000"
                    },
                    {
                        "id": 20466,
                        "name": "Zhuhai",
                        "latitude": "22.27694000",
                        "longitude": "113.56778000"
                    }
                ]
            },
            {
                "id": 2278,
                "name": "Guangxi Zhuang",
                "iso2": "GX",
                "latitude": "23.72475990",
                "longitude": "108.80761950",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 19295,
                        "name": "Babu",
                        "latitude": "24.41667000",
                        "longitude": "111.51667000"
                    },
                    {
                        "id": 19299,
                        "name": "Baihe",
                        "latitude": "22.13430000",
                        "longitude": "107.23200000"
                    },
                    {
                        "id": 19303,
                        "name": "Baise City",
                        "latitude": "23.89972000",
                        "longitude": "106.61333000"
                    },
                    {
                        "id": 19304,
                        "name": "Baise Shi",
                        "latitude": "23.90000000",
                        "longitude": "106.61667000"
                    },
                    {
                        "id": 19331,
                        "name": "Beihai",
                        "latitude": "21.48333000",
                        "longitude": "109.10000000"
                    },
                    {
                        "id": 19407,
                        "name": "Chongzuo Shi",
                        "latitude": "22.46541000",
                        "longitude": "107.39622000"
                    },
                    {
                        "id": 19441,
                        "name": "Dazhai",
                        "latitude": "25.80980000",
                        "longitude": "110.15000000"
                    },
                    {
                        "id": 19498,
                        "name": "Fangchenggang Shi",
                        "latitude": "21.93580000",
                        "longitude": "107.95932000"
                    },
                    {
                        "id": 19569,
                        "name": "Guigang",
                        "latitude": "23.09639000",
                        "longitude": "109.60917000"
                    },
                    {
                        "id": 19570,
                        "name": "Guilin",
                        "latitude": "25.28194000",
                        "longitude": "110.28639000"
                    },
                    {
                        "id": 19571,
                        "name": "Guilin Shi",
                        "latitude": "25.28333000",
                        "longitude": "110.28333000"
                    },
                    {
                        "id": 19572,
                        "name": "Guiping",
                        "latitude": "23.39336000",
                        "longitude": "110.07437000"
                    },
                    {
                        "id": 19603,
                        "name": "Hechi Shi",
                        "latitude": "24.70000000",
                        "longitude": "108.03000000"
                    },
                    {
                        "id": 19743,
                        "name": "Jinji",
                        "latitude": "23.22806000",
                        "longitude": "110.82611000"
                    },
                    {
                        "id": 19789,
                        "name": "Laibin",
                        "latitude": "23.70000000",
                        "longitude": "109.26667000"
                    },
                    {
                        "id": 19827,
                        "name": "Lianzhou",
                        "latitude": "21.66621000",
                        "longitude": "109.20116000"
                    },
                    {
                        "id": 19840,
                        "name": "Lingcheng",
                        "latitude": "22.70722000",
                        "longitude": "110.34917000"
                    },
                    {
                        "id": 19863,
                        "name": "Liuzhou Shi",
                        "latitude": "24.31667000",
                        "longitude": "109.40000000"
                    },
                    {
                        "id": 19887,
                        "name": "Luorong",
                        "latitude": "24.40583000",
                        "longitude": "109.60861000"
                    },
                    {
                        "id": 19938,
                        "name": "Nandu",
                        "latitude": "22.85250000",
                        "longitude": "110.82333000"
                    },
                    {
                        "id": 19945,
                        "name": "Nanning",
                        "latitude": "22.81667000",
                        "longitude": "108.31667000"
                    },
                    {
                        "id": 19981,
                        "name": "Pingnan",
                        "latitude": "23.54218000",
                        "longitude": "110.38946000"
                    },
                    {
                        "id": 19995,
                        "name": "Pumiao",
                        "latitude": "22.75867000",
                        "longitude": "108.48111000"
                    },
                    {
                        "id": 20031,
                        "name": "Qinzhou",
                        "latitude": "21.97296000",
                        "longitude": "108.62612000"
                    },
                    {
                        "id": 20247,
                        "name": "Wuzhou",
                        "latitude": "23.48333000",
                        "longitude": "111.31667000"
                    },
                    {
                        "id": 20346,
                        "name": "Yangshuo",
                        "latitude": "24.78081000",
                        "longitude": "110.48967000"
                    },
                    {
                        "id": 20361,
                        "name": "Yashan",
                        "latitude": "22.19750000",
                        "longitude": "109.94194000"
                    },
                    {
                        "id": 20398,
                        "name": "Yulin",
                        "latitude": "22.63333000",
                        "longitude": "110.15000000"
                    }
                ]
            },
            {
                "id": 2261,
                "name": "Guizhou",
                "iso2": "GZ",
                "latitude": "26.84296450",
                "longitude": "107.29028390",
                "type": "province",
                "cities": [
                    {
                        "id": 19288,
                        "name": "Anshun",
                        "latitude": "26.25000000",
                        "longitude": "105.93333000"
                    },
                    {
                        "id": 19292,
                        "name": "Aoshi",
                        "latitude": "26.40167000",
                        "longitude": "109.07111000"
                    },
                    {
                        "id": 19297,
                        "name": "Bahuang",
                        "latitude": "27.71806000",
                        "longitude": "109.01889000"
                    },
                    {
                        "id": 19307,
                        "name": "Baishi",
                        "latitude": "26.97361000",
                        "longitude": "109.44333000"
                    },
                    {
                        "id": 19313,
                        "name": "Bangdong",
                        "latitude": "26.97556000",
                        "longitude": "109.18583000"
                    },
                    {
                        "id": 19337,
                        "name": "Benchu",
                        "latitude": "26.77111000",
                        "longitude": "109.29056000"
                    },
                    {
                        "id": 19341,
                        "name": "Bijie",
                        "latitude": "27.30193000",
                        "longitude": "105.28627000"
                    },
                    {
                        "id": 19360,
                        "name": "Chadian",
                        "latitude": "27.58194000",
                        "longitude": "109.13278000"
                    },
                    {
                        "id": 19373,
                        "name": "Changsha",
                        "latitude": "28.68778000",
                        "longitude": "105.98972000"
                    },
                    {
                        "id": 19408,
                        "name": "Chumi",
                        "latitude": "28.23361000",
                        "longitude": "106.83278000"
                    },
                    {
                        "id": 19412,
                        "name": "Dabachang",
                        "latitude": "27.74250000",
                        "longitude": "108.34333000"
                    },
                    {
                        "id": 19431,
                        "name": "Darong",
                        "latitude": "25.78500000",
                        "longitude": "108.86400000"
                    },
                    {
                        "id": 19484,
                        "name": "Dundong",
                        "latitude": "26.01190000",
                        "longitude": "109.14100000"
                    },
                    {
                        "id": 19487,
                        "name": "Duyun",
                        "latitude": "26.26667000",
                        "longitude": "107.51667000"
                    },
                    {
                        "id": 19542,
                        "name": "Gaoniang",
                        "latitude": "26.84250000",
                        "longitude": "109.17889000"
                    },
                    {
                        "id": 19545,
                        "name": "Gaowu",
                        "latitude": "25.56250000",
                        "longitude": "108.90800000"
                    },
                    {
                        "id": 19549,
                        "name": "Gaozeng",
                        "latitude": "25.80167000",
                        "longitude": "108.93750000"
                    },
                    {
                        "id": 19558,
                        "name": "Guandu",
                        "latitude": "28.56833000",
                        "longitude": "106.10255000"
                    },
                    {
                        "id": 19575,
                        "name": "Guiyang",
                        "latitude": "26.58333000",
                        "longitude": "106.71667000"
                    },
                    {
                        "id": 19666,
                        "name": "Huaqiu",
                        "latitude": "28.11665000",
                        "longitude": "106.60225000"
                    },
                    {
                        "id": 19800,
                        "name": "Lantian",
                        "latitude": "27.02500000",
                        "longitude": "109.29472000"
                    },
                    {
                        "id": 19813,
                        "name": "Liangcunchang",
                        "latitude": "28.40667000",
                        "longitude": "106.42444000"
                    },
                    {
                        "id": 19861,
                        "name": "Liupanshui",
                        "latitude": "26.59444000",
                        "longitude": "104.83333000"
                    },
                    {
                        "id": 19869,
                        "name": "Longlisuo",
                        "latitude": "26.41417000",
                        "longitude": "109.10222000"
                    },
                    {
                        "id": 19877,
                        "name": "Loushanguan",
                        "latitude": "28.13680000",
                        "longitude": "106.82200000"
                    },
                    {
                        "id": 19906,
                        "name": "Maoping",
                        "latitude": "26.73694000",
                        "longitude": "109.22111000"
                    },
                    {
                        "id": 19970,
                        "name": "Ouyang",
                        "latitude": "26.41910000",
                        "longitude": "109.21600000"
                    },
                    {
                        "id": 19979,
                        "name": "Pingjiang",
                        "latitude": "25.97056000",
                        "longitude": "108.39528000"
                    },
                    {
                        "id": 20007,
                        "name": "Qiandongnan Miao and Dong Autonomous Prefecture",
                        "latitude": "26.57380000",
                        "longitude": "108.59914000"
                    },
                    {
                        "id": 20009,
                        "name": "Qianxinan Bouyeizu Miaozu Zizhizhou",
                        "latitude": "25.38808000",
                        "longitude": "105.38740000"
                    },
                    {
                        "id": 20014,
                        "name": "Qimeng",
                        "latitude": "26.48472000",
                        "longitude": "108.99944000"
                    },
                    {
                        "id": 20019,
                        "name": "Qinglang",
                        "latitude": "27.12472000",
                        "longitude": "108.73278000"
                    },
                    {
                        "id": 20046,
                        "name": "Runsong",
                        "latitude": "26.87000000",
                        "longitude": "109.09700000"
                    },
                    {
                        "id": 20051,
                        "name": "Sanchahe",
                        "latitude": "28.49528000",
                        "longitude": "106.42833000"
                    },
                    {
                        "id": 20053,
                        "name": "Sangmu",
                        "latitude": "28.21528000",
                        "longitude": "106.26889000"
                    },
                    {
                        "id": 20104,
                        "name": "Shiqian",
                        "latitude": "27.52250000",
                        "longitude": "108.22806000"
                    },
                    {
                        "id": 20134,
                        "name": "Songkan",
                        "latitude": "28.54972000",
                        "longitude": "106.85972000"
                    },
                    {
                        "id": 20185,
                        "name": "Tingdong",
                        "latitude": "25.82444000",
                        "longitude": "108.61250000"
                    },
                    {
                        "id": 20189,
                        "name": "Tonggu",
                        "latitude": "26.57222000",
                        "longitude": "109.30944000"
                    },
                    {
                        "id": 20193,
                        "name": "Tongren",
                        "latitude": "27.71722000",
                        "longitude": "109.18528000"
                    },
                    {
                        "id": 20194,
                        "name": "Tongren Diqu",
                        "latitude": "27.74188000",
                        "longitude": "109.19312000"
                    },
                    {
                        "id": 20216,
                        "name": "Weining",
                        "latitude": "26.85000000",
                        "longitude": "104.23333000"
                    },
                    {
                        "id": 20224,
                        "name": "Wenshui",
                        "latitude": "28.45056000",
                        "longitude": "106.52667000"
                    },
                    {
                        "id": 20250,
                        "name": "Xiajiang",
                        "latitude": "25.75556000",
                        "longitude": "108.69194000"
                    },
                    {
                        "id": 20276,
                        "name": "Xiaoweizhai",
                        "latitude": "26.19028000",
                        "longitude": "107.51250000"
                    },
                    {
                        "id": 20315,
                        "name": "Xinzhan",
                        "latitude": "28.38833000",
                        "longitude": "106.85667000"
                    },
                    {
                        "id": 20321,
                        "name": "Xishan",
                        "latitude": "25.68528000",
                        "longitude": "108.96389000"
                    },
                    {
                        "id": 20334,
                        "name": "Xujiaba",
                        "latitude": "27.88472000",
                        "longitude": "108.11361000"
                    },
                    {
                        "id": 20347,
                        "name": "Yangtou",
                        "latitude": "27.68944000",
                        "longitude": "109.41389000"
                    },
                    {
                        "id": 20390,
                        "name": "Youyupu",
                        "latitude": "27.55170000",
                        "longitude": "109.13500000"
                    },
                    {
                        "id": 20448,
                        "name": "Zhongchao",
                        "latitude": "26.13750000",
                        "longitude": "109.22000000"
                    },
                    {
                        "id": 20468,
                        "name": "Zhujiachang",
                        "latitude": "27.35750000",
                        "longitude": "108.93833000"
                    },
                    {
                        "id": 20483,
                        "name": "Zunyi",
                        "latitude": "27.68667000",
                        "longitude": "106.90722000"
                    }
                ]
            },
            {
                "id": 2273,
                "name": "Hainan",
                "iso2": "HI",
                "latitude": "19.56639470",
                "longitude": "109.94968600",
                "type": "province",
                "cities": [
                    {
                        "id": 19321,
                        "name": "Basuo",
                        "latitude": "19.09390000",
                        "longitude": "108.65456000"
                    },
                    {
                        "id": 19406,
                        "name": "Chongshan",
                        "latitude": "18.78229000",
                        "longitude": "109.50130000"
                    },
                    {
                        "id": 19415,
                        "name": "Dadonghai",
                        "latitude": "18.22056000",
                        "longitude": "109.51028000"
                    },
                    {
                        "id": 19584,
                        "name": "Haikou",
                        "latitude": "20.04583000",
                        "longitude": "110.34167000"
                    },
                    {
                        "id": 19745,
                        "name": "Jinjiang",
                        "latitude": "19.72878000",
                        "longitude": "110.00851000"
                    },
                    {
                        "id": 19837,
                        "name": "Lincheng",
                        "latitude": "19.90778000",
                        "longitude": "109.68583000"
                    },
                    {
                        "id": 19932,
                        "name": "Nada",
                        "latitude": "19.52257000",
                        "longitude": "109.57860000"
                    },
                    {
                        "id": 20032,
                        "name": "Qionghai",
                        "latitude": "19.24250000",
                        "longitude": "110.46417000"
                    },
                    {
                        "id": 20034,
                        "name": "Qiongshan",
                        "latitude": "20.00583000",
                        "longitude": "110.35417000"
                    },
                    {
                        "id": 20056,
                        "name": "Sansha",
                        "latitude": "16.83387000",
                        "longitude": "112.33435000"
                    },
                    {
                        "id": 20058,
                        "name": "Sanya",
                        "latitude": "18.24306000",
                        "longitude": "109.50500000"
                    },
                    {
                        "id": 20209,
                        "name": "Wanning",
                        "latitude": "18.79931000",
                        "longitude": "110.38410000"
                    },
                    {
                        "id": 20217,
                        "name": "Wenchang",
                        "latitude": "19.61570000",
                        "longitude": "110.74894000"
                    },
                    {
                        "id": 20325,
                        "name": "Xiuying",
                        "latitude": "20.00073000",
                        "longitude": "110.29359000"
                    }
                ]
            },
            {
                "id": 2280,
                "name": "Hebei",
                "iso2": "HE",
                "latitude": "37.89565940",
                "longitude": "114.90422080",
                "type": "province",
                "cities": [
                    {
                        "id": 19314,
                        "name": "Baoding",
                        "latitude": "38.85111000",
                        "longitude": "115.49028000"
                    },
                    {
                        "id": 19329,
                        "name": "Beidaihehaibin",
                        "latitude": "39.82222000",
                        "longitude": "119.51806000"
                    },
                    {
                        "id": 19349,
                        "name": "Botou",
                        "latitude": "38.06667000",
                        "longitude": "116.56660000"
                    },
                    {
                        "id": 19357,
                        "name": "Cangzhou",
                        "latitude": "38.31667000",
                        "longitude": "116.86667000"
                    },
                    {
                        "id": 19358,
                        "name": "Cangzhou Shi",
                        "latitude": "38.31000000",
                        "longitude": "116.86000000"
                    },
                    {
                        "id": 19368,
                        "name": "Changli",
                        "latitude": "39.70417000",
                        "longitude": "119.15056000"
                    },
                    {
                        "id": 19385,
                        "name": "Chengde",
                        "latitude": "40.95190000",
                        "longitude": "117.95883000"
                    },
                    {
                        "id": 19386,
                        "name": "Chengde Prefecture",
                        "latitude": "40.97000000",
                        "longitude": "117.93000000"
                    },
                    {
                        "id": 19461,
                        "name": "Dingzhou",
                        "latitude": "38.51306000",
                        "longitude": "114.99556000"
                    },
                    {
                        "id": 19509,
                        "name": "Fengrun",
                        "latitude": "39.83333000",
                        "longitude": "118.11667000"
                    },
                    {
                        "id": 19581,
                        "name": "Guye",
                        "latitude": "39.73054000",
                        "longitude": "118.44085000"
                    },
                    {
                        "id": 19597,
                        "name": "Handan",
                        "latitude": "36.60056000",
                        "longitude": "114.46778000"
                    },
                    {
                        "id": 19605,
                        "name": "Hecun",
                        "latitude": "36.53333000",
                        "longitude": "114.11111000"
                    },
                    {
                        "id": 19614,
                        "name": "Hengshui",
                        "latitude": "37.73222000",
                        "longitude": "115.70111000"
                    },
                    {
                        "id": 19794,
                        "name": "Langfang",
                        "latitude": "39.50972000",
                        "longitude": "116.69472000"
                    },
                    {
                        "id": 19795,
                        "name": "Langfang Shi",
                        "latitude": "39.51667000",
                        "longitude": "116.68333000"
                    },
                    {
                        "id": 19851,
                        "name": "Linshui",
                        "latitude": "36.42472000",
                        "longitude": "114.20472000"
                    },
                    {
                        "id": 19853,
                        "name": "Linxi",
                        "latitude": "39.71183000",
                        "longitude": "118.44954000"
                    },
                    {
                        "id": 19878,
                        "name": "Luancheng",
                        "latitude": "37.87917000",
                        "longitude": "114.65167000"
                    },
                    {
                        "id": 19940,
                        "name": "Nangong",
                        "latitude": "37.35806000",
                        "longitude": "115.37444000"
                    },
                    {
                        "id": 19976,
                        "name": "Pengcheng",
                        "latitude": "36.43111000",
                        "longitude": "114.17000000"
                    },
                    {
                        "id": 20029,
                        "name": "Qinhuangdao",
                        "latitude": "39.93167000",
                        "longitude": "119.58833000"
                    },
                    {
                        "id": 20040,
                        "name": "Renqiu",
                        "latitude": "38.69889000",
                        "longitude": "116.09361000"
                    },
                    {
                        "id": 20060,
                        "name": "Shahecheng",
                        "latitude": "36.93833000",
                        "longitude": "114.50583000"
                    },
                    {
                        "id": 20071,
                        "name": "Shanhaiguan",
                        "latitude": "40.00250000",
                        "longitude": "119.74889000"
                    },
                    {
                        "id": 20096,
                        "name": "Shijiazhuang",
                        "latitude": "38.04139000",
                        "longitude": "114.47861000"
                    },
                    {
                        "id": 20097,
                        "name": "Shijiazhuang Shi",
                        "latitude": "38.04000000",
                        "longitude": "114.47000000"
                    },
                    {
                        "id": 20135,
                        "name": "Songling",
                        "latitude": "40.29303000",
                        "longitude": "118.26908000"
                    },
                    {
                        "id": 20168,
                        "name": "Tangjiazhuang",
                        "latitude": "39.74326000",
                        "longitude": "118.45099000"
                    },
                    {
                        "id": 20171,
                        "name": "Tangshan",
                        "latitude": "39.63333000",
                        "longitude": "118.18333000"
                    },
                    {
                        "id": 20172,
                        "name": "Tangshan Shi",
                        "latitude": "39.63000000",
                        "longitude": "118.18000000"
                    },
                    {
                        "id": 20178,
                        "name": "Tianchang",
                        "latitude": "37.99806000",
                        "longitude": "114.01556000"
                    },
                    {
                        "id": 20297,
                        "name": "Xingtai",
                        "latitude": "37.06306000",
                        "longitude": "114.49417000"
                    },
                    {
                        "id": 20301,
                        "name": "Xinji",
                        "latitude": "37.90278000",
                        "longitude": "115.20361000"
                    },
                    {
                        "id": 20422,
                        "name": "Zhangjiakou",
                        "latitude": "40.81000000",
                        "longitude": "114.87944000"
                    },
                    {
                        "id": 20423,
                        "name": "Zhangjiakou Shi",
                        "latitude": "40.83333000",
                        "longitude": "114.93333000"
                    },
                    {
                        "id": 20424,
                        "name": "Zhangjiakou Shi Xuanhua Qu",
                        "latitude": "40.61028000",
                        "longitude": "115.04472000"
                    },
                    {
                        "id": 20432,
                        "name": "Zhaogezhuang",
                        "latitude": "39.76538000",
                        "longitude": "118.41191000"
                    },
                    {
                        "id": 20482,
                        "name": "Zunhua",
                        "latitude": "40.17917000",
                        "longitude": "117.95861000"
                    }
                ]
            },
            {
                "id": 2265,
                "name": "Heilongjiang",
                "iso2": "HL",
                "latitude": "47.12164720",
                "longitude": "128.73823100",
                "type": "province",
                "cities": [
                    {
                        "id": 19272,
                        "name": "Acheng",
                        "latitude": "45.54545000",
                        "longitude": "126.97703000"
                    },
                    {
                        "id": 19279,
                        "name": "Anda",
                        "latitude": "46.40202000",
                        "longitude": "125.31454000"
                    },
                    {
                        "id": 19302,
                        "name": "Baiquan",
                        "latitude": "47.60605000",
                        "longitude": "126.08481000"
                    },
                    {
                        "id": 19312,
                        "name": "Bamiantong",
                        "latitude": "44.91738000",
                        "longitude": "130.52000000"
                    },
                    {
                        "id": 19316,
                        "name": "Baoqing",
                        "latitude": "46.33167000",
                        "longitude": "132.21111000"
                    },
                    {
                        "id": 19317,
                        "name": "Baoshan",
                        "latitude": "46.55861000",
                        "longitude": "131.42444000"
                    },
                    {
                        "id": 19322,
                        "name": "Bayan",
                        "latitude": "46.07556000",
                        "longitude": "127.39840000"
                    },
                    {
                        "id": 19336,
                        "name": "Bei’an",
                        "latitude": "48.26667000",
                        "longitude": "126.60000000"
                    },
                    {
                        "id": 19344,
                        "name": "Binzhou",
                        "latitude": "45.75281000",
                        "longitude": "127.47986000"
                    },
                    {
                        "id": 19347,
                        "name": "Boli",
                        "latitude": "45.75279000",
                        "longitude": "130.57211000"
                    },
                    {
                        "id": 19361,
                        "name": "Chaihe",
                        "latitude": "44.75980000",
                        "longitude": "129.67826000"
                    },
                    {
                        "id": 19397,
                        "name": "Chengzihe",
                        "latitude": "45.33333000",
                        "longitude": "131.06667000"
                    },
                    {
                        "id": 19430,
                        "name": "Daqing",
                        "latitude": "46.58333000",
                        "longitude": "125.00000000"
                    },
                    {
                        "id": 19473,
                        "name": "Dongning",
                        "latitude": "44.06219000",
                        "longitude": "131.12075000"
                    },
                    {
                        "id": 19480,
                        "name": "Dongxing",
                        "latitude": "45.36088000",
                        "longitude": "130.78679000"
                    },
                    {
                        "id": 19503,
                        "name": "Fendou",
                        "latitude": "46.64142000",
                        "longitude": "124.86283000"
                    },
                    {
                        "id": 19511,
                        "name": "Fengxiang",
                        "latitude": "47.57549000",
                        "longitude": "130.82306000"
                    },
                    {
                        "id": 19518,
                        "name": "Fujin",
                        "latitude": "47.26000000",
                        "longitude": "132.03222000"
                    },
                    {
                        "id": 19520,
                        "name": "Fuli",
                        "latitude": "46.72167000",
                        "longitude": "131.13944000"
                    },
                    {
                        "id": 19528,
                        "name": "Fuyu",
                        "latitude": "47.79756000",
                        "longitude": "124.45731000"
                    },
                    {
                        "id": 19530,
                        "name": "Fuyuan",
                        "latitude": "48.36306000",
                        "longitude": "134.28917000"
                    },
                    {
                        "id": 19535,
                        "name": "Gannan",
                        "latitude": "47.91472000",
                        "longitude": "123.50306000"
                    },
                    {
                        "id": 19588,
                        "name": "Hailin",
                        "latitude": "44.57149000",
                        "longitude": "129.38539000"
                    },
                    {
                        "id": 19589,
                        "name": "Hailun",
                        "latitude": "47.45650000",
                        "longitude": "126.95368000"
                    },
                    {
                        "id": 19601,
                        "name": "Harbin",
                        "latitude": "45.75000000",
                        "longitude": "126.65000000"
                    },
                    {
                        "id": 19609,
                        "name": "Hegang",
                        "latitude": "47.35118000",
                        "longitude": "130.30012000"
                    },
                    {
                        "id": 19610,
                        "name": "Heihe",
                        "latitude": "50.24413000",
                        "longitude": "127.49016000"
                    },
                    {
                        "id": 19624,
                        "name": "Honggang",
                        "latitude": "46.40124000",
                        "longitude": "124.88322000"
                    },
                    {
                        "id": 19645,
                        "name": "Huanan",
                        "latitude": "46.22070000",
                        "longitude": "130.52500000"
                    },
                    {
                        "id": 19676,
                        "name": "Hulan",
                        "latitude": "45.98333000",
                        "longitude": "126.60000000"
                    },
                    {
                        "id": 19677,
                        "name": "Hulan Ergi",
                        "latitude": "47.20417000",
                        "longitude": "123.63333000"
                    },
                    {
                        "id": 19694,
                        "name": "Jiamusi",
                        "latitude": "46.79927000",
                        "longitude": "130.31633000"
                    },
                    {
                        "id": 19718,
                        "name": "Jidong",
                        "latitude": "45.21667000",
                        "longitude": "131.08333000"
                    },
                    {
                        "id": 19760,
                        "name": "Jixi",
                        "latitude": "45.30109000",
                        "longitude": "130.95718000"
                    },
                    {
                        "id": 19797,
                        "name": "Langxiang",
                        "latitude": "46.94985000",
                        "longitude": "128.86849000"
                    },
                    {
                        "id": 19802,
                        "name": "Lanxi",
                        "latitude": "46.25785000",
                        "longitude": "126.28269000"
                    },
                    {
                        "id": 19819,
                        "name": "Lianhe",
                        "latitude": "47.13333000",
                        "longitude": "129.27426000"
                    },
                    {
                        "id": 19841,
                        "name": "Lingdong",
                        "latitude": "46.56694000",
                        "longitude": "131.14528000"
                    },
                    {
                        "id": 19847,
                        "name": "Linkou",
                        "latitude": "45.28606000",
                        "longitude": "130.26151000"
                    },
                    {
                        "id": 19865,
                        "name": "Longfeng",
                        "latitude": "46.53168000",
                        "longitude": "125.10380000"
                    },
                    {
                        "id": 19867,
                        "name": "Longjiang",
                        "latitude": "47.33072000",
                        "longitude": "123.17816000"
                    },
                    {
                        "id": 19921,
                        "name": "Mingshui",
                        "latitude": "47.18150000",
                        "longitude": "125.90027000"
                    },
                    {
                        "id": 19925,
                        "name": "Mishan",
                        "latitude": "45.55000000",
                        "longitude": "131.88333000"
                    },
                    {
                        "id": 19929,
                        "name": "Mudanjiang",
                        "latitude": "44.58333000",
                        "longitude": "129.60000000"
                    },
                    {
                        "id": 19953,
                        "name": "Nehe",
                        "latitude": "48.48333000",
                        "longitude": "124.83333000"
                    },
                    {
                        "id": 19956,
                        "name": "Nenjiang",
                        "latitude": "49.17414000",
                        "longitude": "125.21774000"
                    },
                    {
                        "id": 19958,
                        "name": "Nianzishan",
                        "latitude": "47.51667000",
                        "longitude": "122.88333000"
                    },
                    {
                        "id": 19964,
                        "name": "Ning’an",
                        "latitude": "44.34395000",
                        "longitude": "129.46556000"
                    },
                    {
                        "id": 20017,
                        "name": "Qinggang",
                        "latitude": "46.68469000",
                        "longitude": "126.10595000"
                    },
                    {
                        "id": 20035,
                        "name": "Qiqihar",
                        "latitude": "47.34088000",
                        "longitude": "123.96045000"
                    },
                    {
                        "id": 20070,
                        "name": "Shangzhi",
                        "latitude": "45.21406000",
                        "longitude": "127.97426000"
                    },
                    {
                        "id": 20072,
                        "name": "Shanhecun",
                        "latitude": "45.71131000",
                        "longitude": "128.58029000"
                    },
                    {
                        "id": 20114,
                        "name": "Shuangcheng",
                        "latitude": "45.35000000",
                        "longitude": "126.28333000"
                    },
                    {
                        "id": 20120,
                        "name": "Shuangyashan",
                        "latitude": "46.63611000",
                        "longitude": "131.15389000"
                    },
                    {
                        "id": 20140,
                        "name": "Suifenhe",
                        "latitude": "44.39982000",
                        "longitude": "131.14775000"
                    },
                    {
                        "id": 20141,
                        "name": "Suihua",
                        "latitude": "46.63954000",
                        "longitude": "126.99508000"
                    },
                    {
                        "id": 20142,
                        "name": "Suileng",
                        "latitude": "47.24805000",
                        "longitude": "127.09535000"
                    },
                    {
                        "id": 20154,
                        "name": "Tahe",
                        "latitude": "52.33333000",
                        "longitude": "124.73333000"
                    },
                    {
                        "id": 20156,
                        "name": "Taihecun",
                        "latitude": "45.76347000",
                        "longitude": "130.85048000"
                    },
                    {
                        "id": 20157,
                        "name": "Taikang",
                        "latitude": "46.86135000",
                        "longitude": "124.44200000"
                    },
                    {
                        "id": 20158,
                        "name": "Tailai",
                        "latitude": "46.38909000",
                        "longitude": "123.41371000"
                    },
                    {
                        "id": 20182,
                        "name": "Tieli",
                        "latitude": "46.98043000",
                        "longitude": "128.04497000"
                    },
                    {
                        "id": 20207,
                        "name": "Wangkui",
                        "latitude": "46.83283000",
                        "longitude": "126.47768000"
                    },
                    {
                        "id": 20228,
                        "name": "Wuchang",
                        "latitude": "44.91428000",
                        "longitude": "127.15001000"
                    },
                    {
                        "id": 20304,
                        "name": "Xinqing",
                        "latitude": "48.28701000",
                        "longitude": "129.52337000"
                    },
                    {
                        "id": 20370,
                        "name": "Yichun",
                        "latitude": "47.72143000",
                        "longitude": "128.87529000"
                    },
                    {
                        "id": 20372,
                        "name": "Yilan",
                        "latitude": "46.31618000",
                        "longitude": "129.55455000"
                    },
                    {
                        "id": 20389,
                        "name": "Youhao",
                        "latitude": "47.85306000",
                        "longitude": "128.83565000"
                    },
                    {
                        "id": 20431,
                        "name": "Zhaodong",
                        "latitude": "46.06771000",
                        "longitude": "125.98263000"
                    },
                    {
                        "id": 20436,
                        "name": "Zhaoyuan",
                        "latitude": "45.50000000",
                        "longitude": "125.13333000"
                    },
                    {
                        "id": 20437,
                        "name": "Zhaozhou",
                        "latitude": "45.68333000",
                        "longitude": "125.31667000"
                    }
                ]
            },
            {
                "id": 2259,
                "name": "Henan",
                "iso2": "HA",
                "latitude": "34.29043020",
                "longitude": "113.38235450",
                "type": "province",
                "cities": [
                    {
                        "id": 19290,
                        "name": "Anyang",
                        "latitude": "36.09600000",
                        "longitude": "114.38278000"
                    },
                    {
                        "id": 19291,
                        "name": "Anyang Shi",
                        "latitude": "36.13639000",
                        "longitude": "114.33667000"
                    },
                    {
                        "id": 19342,
                        "name": "Binhe",
                        "latitude": "32.68833000",
                        "longitude": "112.82750000"
                    },
                    {
                        "id": 19388,
                        "name": "Chengguan",
                        "latitude": "35.45861000",
                        "longitude": "113.79778000"
                    },
                    {
                        "id": 19390,
                        "name": "Chengjiao",
                        "latitude": "35.40495000",
                        "longitude": "114.06043000"
                    },
                    {
                        "id": 19428,
                        "name": "Daokou",
                        "latitude": "35.56389000",
                        "longitude": "114.50583000"
                    },
                    {
                        "id": 19456,
                        "name": "Dingcheng",
                        "latitude": "32.12722000",
                        "longitude": "115.03944000"
                    },
                    {
                        "id": 19594,
                        "name": "Hancheng",
                        "latitude": "32.51861000",
                        "longitude": "112.35222000"
                    },
                    {
                        "id": 19602,
                        "name": "Hebi",
                        "latitude": "35.89917000",
                        "longitude": "114.19250000"
                    },
                    {
                        "id": 19638,
                        "name": "Huaidian",
                        "latitude": "33.43333000",
                        "longitude": "115.03333000"
                    },
                    {
                        "id": 19670,
                        "name": "Huazhou",
                        "latitude": "32.68222000",
                        "longitude": "112.08194000"
                    },
                    {
                        "id": 19671,
                        "name": "Huichang",
                        "latitude": "34.90376000",
                        "longitude": "112.78426000"
                    },
                    {
                        "id": 19708,
                        "name": "Jianshe",
                        "latitude": "34.21750000",
                        "longitude": "113.76889000"
                    },
                    {
                        "id": 19712,
                        "name": "Jiaozuo",
                        "latitude": "35.23972000",
                        "longitude": "113.23306000"
                    },
                    {
                        "id": 19754,
                        "name": "Jishui",
                        "latitude": "33.73333000",
                        "longitude": "115.40000000"
                    },
                    {
                        "id": 19761,
                        "name": "Jiyuan",
                        "latitude": "35.09000000",
                        "longitude": "112.58000000"
                    },
                    {
                        "id": 19766,
                        "name": "Kaifeng",
                        "latitude": "34.79860000",
                        "longitude": "114.30742000"
                    },
                    {
                        "id": 19769,
                        "name": "Kaiyuan",
                        "latitude": "36.06813000",
                        "longitude": "113.82209000"
                    },
                    {
                        "id": 19839,
                        "name": "Lingbao Chengguanzhen",
                        "latitude": "34.51972000",
                        "longitude": "110.86444000"
                    },
                    {
                        "id": 19883,
                        "name": "Luohe",
                        "latitude": "33.56394000",
                        "longitude": "114.04272000"
                    },
                    {
                        "id": 19884,
                        "name": "Luohe Shi",
                        "latitude": "33.68806000",
                        "longitude": "113.91306000"
                    },
                    {
                        "id": 19889,
                        "name": "Luoyang",
                        "latitude": "34.68361000",
                        "longitude": "112.45361000"
                    },
                    {
                        "id": 19918,
                        "name": "Minggang",
                        "latitude": "32.45861000",
                        "longitude": "114.04861000"
                    },
                    {
                        "id": 19950,
                        "name": "Nanyang",
                        "latitude": "32.99472000",
                        "longitude": "112.53278000"
                    },
                    {
                        "id": 19977,
                        "name": "Pingdingshan",
                        "latitude": "33.73847000",
                        "longitude": "113.30119000"
                    },
                    {
                        "id": 20000,
                        "name": "Puyang Chengguanzhen",
                        "latitude": "35.70506000",
                        "longitude": "115.01409000"
                    },
                    {
                        "id": 20001,
                        "name": "Puyang Shi",
                        "latitude": "35.81333000",
                        "longitude": "115.15500000"
                    },
                    {
                        "id": 20021,
                        "name": "Qingping",
                        "latitude": "34.53656000",
                        "longitude": "113.37526000"
                    },
                    {
                        "id": 20045,
                        "name": "Runing",
                        "latitude": "33.00111000",
                        "longitude": "114.35417000"
                    },
                    {
                        "id": 20048,
                        "name": "Ruzhou",
                        "latitude": "34.16167000",
                        "longitude": "112.82972000"
                    },
                    {
                        "id": 20066,
                        "name": "Shangqiu",
                        "latitude": "34.45000000",
                        "longitude": "115.65000000"
                    },
                    {
                        "id": 20137,
                        "name": "Songyang",
                        "latitude": "34.45528000",
                        "longitude": "113.02806000"
                    },
                    {
                        "id": 20147,
                        "name": "Suohe",
                        "latitude": "34.78722000",
                        "longitude": "113.35806000"
                    },
                    {
                        "id": 20166,
                        "name": "Tanbei",
                        "latitude": "35.08806000",
                        "longitude": "112.93944000"
                    },
                    {
                        "id": 20205,
                        "name": "Wacheng",
                        "latitude": "33.78333000",
                        "longitude": "114.51667000"
                    },
                    {
                        "id": 20254,
                        "name": "Xiangcheng Chengguanzhen",
                        "latitude": "33.84703000",
                        "longitude": "113.47780000"
                    },
                    {
                        "id": 20289,
                        "name": "Xincheng",
                        "latitude": "33.63333000",
                        "longitude": "115.18333000"
                    },
                    {
                        "id": 20298,
                        "name": "Xinhualu",
                        "latitude": "34.39633000",
                        "longitude": "113.72466000"
                    },
                    {
                        "id": 20308,
                        "name": "Xinxiang",
                        "latitude": "35.19033000",
                        "longitude": "113.80151000"
                    },
                    {
                        "id": 20309,
                        "name": "Xinxiang Shi",
                        "latitude": "35.30861000",
                        "longitude": "114.05111000"
                    },
                    {
                        "id": 20311,
                        "name": "Xinyang",
                        "latitude": "32.12278000",
                        "longitude": "114.06556000"
                    },
                    {
                        "id": 20327,
                        "name": "Xixiang",
                        "latitude": "35.16278000",
                        "longitude": "112.86500000"
                    },
                    {
                        "id": 20331,
                        "name": "Xuchang",
                        "latitude": "34.03189000",
                        "longitude": "113.86299000"
                    },
                    {
                        "id": 20332,
                        "name": "Xuchang Shi",
                        "latitude": "34.14778000",
                        "longitude": "113.71472000"
                    },
                    {
                        "id": 20338,
                        "name": "Yakou",
                        "latitude": "33.29649000",
                        "longitude": "113.52351000"
                    },
                    {
                        "id": 20354,
                        "name": "Yanshi Chengguanzhen",
                        "latitude": "34.71601000",
                        "longitude": "112.79568000"
                    },
                    {
                        "id": 20371,
                        "name": "Yigou",
                        "latitude": "35.81139000",
                        "longitude": "114.31667000"
                    },
                    {
                        "id": 20373,
                        "name": "Yima",
                        "latitude": "34.73806000",
                        "longitude": "111.88389000"
                    },
                    {
                        "id": 20376,
                        "name": "Yingchuan",
                        "latitude": "34.16278000",
                        "longitude": "113.46389000"
                    },
                    {
                        "id": 20403,
                        "name": "Yunyang",
                        "latitude": "33.44743000",
                        "longitude": "112.71422000"
                    },
                    {
                        "id": 20439,
                        "name": "Zhengzhou",
                        "latitude": "34.75778000",
                        "longitude": "113.64861000"
                    },
                    {
                        "id": 20460,
                        "name": "Zhoukou",
                        "latitude": "33.63333000",
                        "longitude": "114.63333000"
                    },
                    {
                        "id": 20470,
                        "name": "Zhumadian",
                        "latitude": "32.97944000",
                        "longitude": "114.02944000"
                    },
                    {
                        "id": 20471,
                        "name": "Zhumadian Shi",
                        "latitude": "32.99417000",
                        "longitude": "114.06167000"
                    },
                    {
                        "id": 20480,
                        "name": "Zijinglu",
                        "latitude": "34.76000000",
                        "longitude": "112.97139000"
                    }
                ]
            },
            {
                "id": 2267,
                "name": "Hong Kong SAR",
                "iso2": "HK",
                "latitude": "22.31930390",
                "longitude": "114.16936110",
                "type": "special administrative region",
                "cities": []
            },
            {
                "id": 2274,
                "name": "Hubei",
                "iso2": "HB",
                "latitude": "30.73781180",
                "longitude": "112.23840170",
                "type": "province",
                "cities": [
                    {
                        "id": 19282,
                        "name": "Anlu",
                        "latitude": "31.25750000",
                        "longitude": "113.67833000"
                    },
                    {
                        "id": 19353,
                        "name": "Buhe",
                        "latitude": "30.28757000",
                        "longitude": "112.22979000"
                    },
                    {
                        "id": 19355,
                        "name": "Caidian",
                        "latitude": "30.58333000",
                        "longitude": "114.03333000"
                    },
                    {
                        "id": 19359,
                        "name": "Caohe",
                        "latitude": "30.22970000",
                        "longitude": "115.43346000"
                    },
                    {
                        "id": 19396,
                        "name": "Chengzhong",
                        "latitude": "30.94454000",
                        "longitude": "113.55284000"
                    },
                    {
                        "id": 19425,
                        "name": "Danjiangkou",
                        "latitude": "32.54278000",
                        "longitude": "111.50861000"
                    },
                    {
                        "id": 19440,
                        "name": "Daye",
                        "latitude": "30.08333000",
                        "longitude": "114.95000000"
                    },
                    {
                        "id": 19486,
                        "name": "Duobao",
                        "latitude": "30.67000000",
                        "longitude": "112.68952000"
                    },
                    {
                        "id": 19491,
                        "name": "Enshi",
                        "latitude": "30.30000000",
                        "longitude": "109.48333000"
                    },
                    {
                        "id": 19492,
                        "name": "Enshi Tujiazu Miaozu Zizhizhou",
                        "latitude": "30.19810000",
                        "longitude": "109.67555000"
                    },
                    {
                        "id": 19495,
                        "name": "Ezhou",
                        "latitude": "30.40000000",
                        "longitude": "114.83333000"
                    },
                    {
                        "id": 19496,
                        "name": "Ezhou Shi",
                        "latitude": "30.48832000",
                        "longitude": "114.77979000"
                    },
                    {
                        "id": 19507,
                        "name": "Fengkou",
                        "latitude": "30.08268000",
                        "longitude": "113.33346000"
                    },
                    {
                        "id": 19560,
                        "name": "Guangshui",
                        "latitude": "31.61990000",
                        "longitude": "113.99780000"
                    },
                    {
                        "id": 19567,
                        "name": "Gucheng Chengguanzhen",
                        "latitude": "32.26604000",
                        "longitude": "111.63476000"
                    },
                    {
                        "id": 19596,
                        "name": "Hanchuan",
                        "latitude": "30.65000000",
                        "longitude": "113.76667000"
                    },
                    {
                        "id": 19647,
                        "name": "Huanggang",
                        "latitude": "30.45143000",
                        "longitude": "114.87035000"
                    },
                    {
                        "id": 19651,
                        "name": "Huangmei",
                        "latitude": "30.19235000",
                        "longitude": "116.02496000"
                    },
                    {
                        "id": 19654,
                        "name": "Huangpi",
                        "latitude": "30.88453000",
                        "longitude": "114.37789000"
                    },
                    {
                        "id": 19658,
                        "name": "Huangshi",
                        "latitude": "30.24706000",
                        "longitude": "115.04814000"
                    },
                    {
                        "id": 19663,
                        "name": "Huangzhou",
                        "latitude": "30.45000000",
                        "longitude": "114.80000000"
                    },
                    {
                        "id": 19735,
                        "name": "Jingling",
                        "latitude": "30.65000000",
                        "longitude": "113.10000000"
                    },
                    {
                        "id": 19736,
                        "name": "Jingmen",
                        "latitude": "31.03361000",
                        "longitude": "112.20472000"
                    },
                    {
                        "id": 19737,
                        "name": "Jingmen Shi",
                        "latitude": "31.11244000",
                        "longitude": "112.64310000"
                    },
                    {
                        "id": 19738,
                        "name": "Jingzhou",
                        "latitude": "30.35028000",
                        "longitude": "112.19028000"
                    },
                    {
                        "id": 19805,
                        "name": "Laohekou",
                        "latitude": "32.38583000",
                        "longitude": "111.66778000"
                    },
                    {
                        "id": 19834,
                        "name": "Lichuan",
                        "latitude": "30.30000000",
                        "longitude": "108.85000000"
                    },
                    {
                        "id": 19900,
                        "name": "Macheng",
                        "latitude": "31.18013000",
                        "longitude": "115.02213000"
                    },
                    {
                        "id": 19951,
                        "name": "Nanzhang Chengguanzhen",
                        "latitude": "31.78394000",
                        "longitude": "111.82752000"
                    },
                    {
                        "id": 19997,
                        "name": "Puqi",
                        "latitude": "29.71667000",
                        "longitude": "113.88333000"
                    },
                    {
                        "id": 20008,
                        "name": "Qianjiang",
                        "latitude": "30.42100000",
                        "longitude": "112.89190000"
                    },
                    {
                        "id": 20022,
                        "name": "Qingquan",
                        "latitude": "30.45113000",
                        "longitude": "115.25593000"
                    },
                    {
                        "id": 20085,
                        "name": "Shashi",
                        "latitude": "30.30722000",
                        "longitude": "112.24472000"
                    },
                    {
                        "id": 20089,
                        "name": "Shennongjia",
                        "latitude": "31.58339000",
                        "longitude": "110.49720000"
                    },
                    {
                        "id": 20109,
                        "name": "Shiyan",
                        "latitude": "32.64750000",
                        "longitude": "110.77806000"
                    },
                    {
                        "id": 20145,
                        "name": "Suizhou",
                        "latitude": "31.71111000",
                        "longitude": "113.36306000"
                    },
                    {
                        "id": 20233,
                        "name": "Wuhan",
                        "latitude": "30.58333000",
                        "longitude": "114.26667000"
                    },
                    {
                        "id": 20240,
                        "name": "Wuxue",
                        "latitude": "29.85058000",
                        "longitude": "115.55250000"
                    },
                    {
                        "id": 20258,
                        "name": "Xiangyang",
                        "latitude": "32.04220000",
                        "longitude": "112.14479000"
                    },
                    {
                        "id": 20261,
                        "name": "Xianning",
                        "latitude": "29.84347000",
                        "longitude": "114.32201000"
                    },
                    {
                        "id": 20262,
                        "name": "Xianning Prefecture",
                        "latitude": "29.66609000",
                        "longitude": "114.26389000"
                    },
                    {
                        "id": 20266,
                        "name": "Xiantao",
                        "latitude": "30.37080000",
                        "longitude": "113.44294000"
                    },
                    {
                        "id": 20269,
                        "name": "Xiaogan",
                        "latitude": "30.92689000",
                        "longitude": "113.92221000"
                    },
                    {
                        "id": 20282,
                        "name": "Xihe",
                        "latitude": "31.68635000",
                        "longitude": "113.46585000"
                    },
                    {
                        "id": 20290,
                        "name": "Xindi",
                        "latitude": "29.81667000",
                        "longitude": "113.46667000"
                    },
                    {
                        "id": 20305,
                        "name": "Xinshi",
                        "latitude": "31.04704000",
                        "longitude": "113.14098000"
                    },
                    {
                        "id": 20317,
                        "name": "Xinzhou",
                        "latitude": "30.86667000",
                        "longitude": "114.80000000"
                    },
                    {
                        "id": 20323,
                        "name": "Xiulin",
                        "latitude": "29.71667000",
                        "longitude": "112.40000000"
                    },
                    {
                        "id": 20366,
                        "name": "Yichang",
                        "latitude": "30.71444000",
                        "longitude": "111.28472000"
                    },
                    {
                        "id": 20367,
                        "name": "Yicheng",
                        "latitude": "31.70472000",
                        "longitude": "112.25611000"
                    },
                    {
                        "id": 20402,
                        "name": "Yunmeng Chengguanzhen",
                        "latitude": "31.06251000",
                        "longitude": "113.76545000"
                    },
                    {
                        "id": 20414,
                        "name": "Zaoyang",
                        "latitude": "32.12722000",
                        "longitude": "112.75417000"
                    },
                    {
                        "id": 20445,
                        "name": "Zhicheng",
                        "latitude": "30.29556000",
                        "longitude": "111.50472000"
                    },
                    {
                        "id": 20446,
                        "name": "Zhijiang",
                        "latitude": "30.42139000",
                        "longitude": "111.75333000"
                    },
                    {
                        "id": 20455,
                        "name": "Zhongxiang",
                        "latitude": "31.16611000",
                        "longitude": "112.58306000"
                    }
                ]
            },
            {
                "id": 2258,
                "name": "Hunan",
                "iso2": "HN",
                "latitude": "27.36830090",
                "longitude": "109.28193470",
                "type": "province",
                "cities": [
                    {
                        "id": 19280,
                        "name": "Anjiang",
                        "latitude": "27.31944000",
                        "longitude": "110.10306000"
                    },
                    {
                        "id": 19283,
                        "name": "Anping",
                        "latitude": "27.86639000",
                        "longitude": "110.11611000"
                    },
                    {
                        "id": 19289,
                        "name": "Anxiang",
                        "latitude": "29.40000000",
                        "longitude": "112.15000000"
                    },
                    {
                        "id": 19305,
                        "name": "Baisha",
                        "latitude": "26.52222000",
                        "longitude": "110.93111000"
                    },
                    {
                        "id": 19345,
                        "name": "Biyong",
                        "latitude": "27.18722000",
                        "longitude": "109.51000000"
                    },
                    {
                        "id": 19346,
                        "name": "Bojia",
                        "latitude": "26.46722000",
                        "longitude": "111.96806000"
                    },
                    {
                        "id": 19350,
                        "name": "Boyang",
                        "latitude": "26.21167000",
                        "longitude": "109.52056000"
                    },
                    {
                        "id": 19352,
                        "name": "Bozhou",
                        "latitude": "27.37889000",
                        "longitude": "109.27778000"
                    },
                    {
                        "id": 19364,
                        "name": "Changde",
                        "latitude": "29.04638000",
                        "longitude": "111.67830000"
                    },
                    {
                        "id": 19374,
                        "name": "Changsha",
                        "latitude": "28.19874000",
                        "longitude": "112.97087000"
                    },
                    {
                        "id": 19375,
                        "name": "Changsha Shi",
                        "latitude": "28.14582000",
                        "longitude": "113.22967000"
                    },
                    {
                        "id": 19384,
                        "name": "Chatian",
                        "latitude": "27.80222000",
                        "longitude": "109.37361000"
                    },
                    {
                        "id": 19398,
                        "name": "Chenzhou",
                        "latitude": "25.80000000",
                        "longitude": "113.03333000"
                    },
                    {
                        "id": 19413,
                        "name": "Dabaozi",
                        "latitude": "26.69556000",
                        "longitude": "109.44778000"
                    },
                    {
                        "id": 19445,
                        "name": "Dehang",
                        "latitude": "28.30710000",
                        "longitude": "109.79668000"
                    },
                    {
                        "id": 19449,
                        "name": "Dengjiapu",
                        "latitude": "26.90444000",
                        "longitude": "110.92000000"
                    },
                    {
                        "id": 19451,
                        "name": "Dengyuantai",
                        "latitude": "26.68806000",
                        "longitude": "110.54222000"
                    },
                    {
                        "id": 19474,
                        "name": "Dongshan Dongzuxiang",
                        "latitude": "26.59500000",
                        "longitude": "109.89667000"
                    },
                    {
                        "id": 19506,
                        "name": "Fenghuang",
                        "latitude": "27.93557000",
                        "longitude": "109.59961000"
                    },
                    {
                        "id": 19534,
                        "name": "Gangdong",
                        "latitude": "27.91694000",
                        "longitude": "110.83417000"
                    },
                    {
                        "id": 19544,
                        "name": "Gaoqiao",
                        "latitude": "26.63361000",
                        "longitude": "110.90000000"
                    },
                    {
                        "id": 19547,
                        "name": "Gaoyi",
                        "latitude": "26.95944000",
                        "longitude": "110.01556000"
                    },
                    {
                        "id": 19565,
                        "name": "Guankou",
                        "latitude": "28.15861000",
                        "longitude": "113.62709000"
                    },
                    {
                        "id": 19613,
                        "name": "Hengbanqiao",
                        "latitude": "27.17167000",
                        "longitude": "110.86528000"
                    },
                    {
                        "id": 19615,
                        "name": "Hengyang",
                        "latitude": "26.88946000",
                        "longitude": "112.61888000"
                    },
                    {
                        "id": 19619,
                        "name": "Hexiangqiao",
                        "latitude": "27.22028000",
                        "longitude": "110.96333000"
                    },
                    {
                        "id": 19626,
                        "name": "Hongjiang",
                        "latitude": "27.11000000",
                        "longitude": "109.99556000"
                    },
                    {
                        "id": 19627,
                        "name": "Hongqiao",
                        "latitude": "26.76837000",
                        "longitude": "112.10814000"
                    },
                    {
                        "id": 19639,
                        "name": "Huaihua",
                        "latitude": "27.56337000",
                        "longitude": "110.00404000"
                    },
                    {
                        "id": 19648,
                        "name": "Huangjinjing",
                        "latitude": "27.58563000",
                        "longitude": "110.89133000"
                    },
                    {
                        "id": 19649,
                        "name": "Huanglong",
                        "latitude": "26.54139000",
                        "longitude": "110.93444000"
                    },
                    {
                        "id": 19650,
                        "name": "Huangmaoyuan",
                        "latitude": "27.40417000",
                        "longitude": "110.47472000"
                    },
                    {
                        "id": 19655,
                        "name": "Huangqiao",
                        "latitude": "27.02194000",
                        "longitude": "110.84056000"
                    },
                    {
                        "id": 19660,
                        "name": "Huangtukuang",
                        "latitude": "26.91528000",
                        "longitude": "110.40778000"
                    },
                    {
                        "id": 19661,
                        "name": "Huangxikou",
                        "latitude": "27.71889000",
                        "longitude": "110.38500000"
                    },
                    {
                        "id": 19665,
                        "name": "Huaqiao",
                        "latitude": "27.70806000",
                        "longitude": "110.14194000"
                    },
                    {
                        "id": 19668,
                        "name": "Huayuan",
                        "latitude": "26.91361000",
                        "longitude": "110.53583000"
                    },
                    {
                        "id": 19684,
                        "name": "Huomachong",
                        "latitude": "27.88333000",
                        "longitude": "110.23000000"
                    },
                    {
                        "id": 19696,
                        "name": "Jiangfang",
                        "latitude": "26.50158000",
                        "longitude": "110.34640000"
                    },
                    {
                        "id": 19698,
                        "name": "Jiangkouxu",
                        "latitude": "27.69417000",
                        "longitude": "109.73583000"
                    },
                    {
                        "id": 19700,
                        "name": "Jiangshi",
                        "latitude": "27.12333000",
                        "longitude": "109.73778000"
                    },
                    {
                        "id": 19739,
                        "name": "Jinhe",
                        "latitude": "27.71694000",
                        "longitude": "109.60472000"
                    },
                    {
                        "id": 19748,
                        "name": "Jinshi",
                        "latitude": "29.60487000",
                        "longitude": "111.87012000"
                    },
                    {
                        "id": 19749,
                        "name": "Jinshiqiao",
                        "latitude": "27.58425000",
                        "longitude": "110.93634000"
                    },
                    {
                        "id": 19799,
                        "name": "Lanli",
                        "latitude": "27.88694000",
                        "longitude": "109.91861000"
                    },
                    {
                        "id": 19808,
                        "name": "Leiyang",
                        "latitude": "26.40238000",
                        "longitude": "112.85908000"
                    },
                    {
                        "id": 19809,
                        "name": "Lengshuijiang",
                        "latitude": "27.68806000",
                        "longitude": "111.42944000"
                    },
                    {
                        "id": 19810,
                        "name": "Lengshuitan",
                        "latitude": "26.41110000",
                        "longitude": "111.59559000"
                    },
                    {
                        "id": 19818,
                        "name": "Liangyaping",
                        "latitude": "27.71833000",
                        "longitude": "110.67083000"
                    },
                    {
                        "id": 19824,
                        "name": "Lianyuan",
                        "latitude": "27.68833000",
                        "longitude": "111.66417000"
                    },
                    {
                        "id": 19846,
                        "name": "Linkou",
                        "latitude": "26.24806000",
                        "longitude": "109.86361000"
                    },
                    {
                        "id": 19859,
                        "name": "Liuduzhai",
                        "latitude": "27.36611000",
                        "longitude": "110.93500000"
                    },
                    {
                        "id": 19864,
                        "name": "Lixiqiao",
                        "latitude": "26.79472000",
                        "longitude": "110.41806000"
                    },
                    {
                        "id": 19873,
                        "name": "Longtan",
                        "latitude": "27.41139000",
                        "longitude": "110.53639000"
                    },
                    {
                        "id": 19874,
                        "name": "Longtou’an",
                        "latitude": "27.67028000",
                        "longitude": "110.33611000"
                    },
                    {
                        "id": 19876,
                        "name": "Loudi",
                        "latitude": "27.73444000",
                        "longitude": "111.99444000"
                    },
                    {
                        "id": 19885,
                        "name": "Luojiu",
                        "latitude": "27.51583000",
                        "longitude": "109.80889000"
                    },
                    {
                        "id": 19893,
                        "name": "Luyang",
                        "latitude": "27.62389000",
                        "longitude": "110.09889000"
                    },
                    {
                        "id": 19909,
                        "name": "Ma’an",
                        "latitude": "26.97750000",
                        "longitude": "110.72111000"
                    },
                    {
                        "id": 19902,
                        "name": "Malin",
                        "latitude": "26.45500000",
                        "longitude": "110.64167000"
                    },
                    {
                        "id": 19905,
                        "name": "Maoping",
                        "latitude": "26.51972000",
                        "longitude": "110.41194000"
                    },
                    {
                        "id": 19944,
                        "name": "Nanmuping",
                        "latitude": "27.31111000",
                        "longitude": "109.67861000"
                    },
                    {
                        "id": 19952,
                        "name": "Nanzhou",
                        "latitude": "29.35955000",
                        "longitude": "112.40243000"
                    },
                    {
                        "id": 19989,
                        "name": "Prefecture of Chenzhou",
                        "latitude": "25.84347000",
                        "longitude": "113.05378000"
                    },
                    {
                        "id": 19993,
                        "name": "Pukou",
                        "latitude": "26.52222000",
                        "longitude": "109.55583000"
                    },
                    {
                        "id": 20002,
                        "name": "Puzi",
                        "latitude": "26.98639000",
                        "longitude": "109.77639000"
                    },
                    {
                        "id": 20006,
                        "name": "Qiancheng",
                        "latitude": "27.18501000",
                        "longitude": "109.76543000"
                    },
                    {
                        "id": 20010,
                        "name": "Qianzhou",
                        "latitude": "28.31925000",
                        "longitude": "109.73346000"
                    },
                    {
                        "id": 20011,
                        "name": "Qiaojiang",
                        "latitude": "27.93722000",
                        "longitude": "110.67639000"
                    },
                    {
                        "id": 20018,
                        "name": "Qingjiangqiao",
                        "latitude": "26.60444000",
                        "longitude": "110.98528000"
                    },
                    {
                        "id": 20024,
                        "name": "Qingxi",
                        "latitude": "26.43114000",
                        "longitude": "110.35489000"
                    },
                    {
                        "id": 20033,
                        "name": "Qionghu",
                        "latitude": "28.84061000",
                        "longitude": "112.37399000"
                    },
                    {
                        "id": 20047,
                        "name": "Ruoshui",
                        "latitude": "27.00194000",
                        "longitude": "109.96667000"
                    },
                    {
                        "id": 20065,
                        "name": "Shangmei",
                        "latitude": "27.74278000",
                        "longitude": "111.29556000"
                    },
                    {
                        "id": 20073,
                        "name": "Shanmen",
                        "latitude": "27.22500000",
                        "longitude": "110.69278000"
                    },
                    {
                        "id": 20094,
                        "name": "Shijiang",
                        "latitude": "27.08194000",
                        "longitude": "110.79333000"
                    },
                    {
                        "id": 20116,
                        "name": "Shuangjiang",
                        "latitude": "26.15467000",
                        "longitude": "109.71380000"
                    },
                    {
                        "id": 20117,
                        "name": "Shuangxi",
                        "latitude": "27.22833000",
                        "longitude": "109.85583000"
                    },
                    {
                        "id": 20122,
                        "name": "Shuiche",
                        "latitude": "27.68694000",
                        "longitude": "110.99972000"
                    },
                    {
                        "id": 20123,
                        "name": "Shuidatian",
                        "latitude": "27.85222000",
                        "longitude": "109.60472000"
                    },
                    {
                        "id": 20128,
                        "name": "Simenqian",
                        "latitude": "27.48722000",
                        "longitude": "110.88611000"
                    },
                    {
                        "id": 20167,
                        "name": "Tangjiafang",
                        "latitude": "26.84000000",
                        "longitude": "110.36472000"
                    },
                    {
                        "id": 20175,
                        "name": "Tanwan",
                        "latitude": "27.96639000",
                        "longitude": "110.15028000"
                    },
                    {
                        "id": 20196,
                        "name": "Tongwan",
                        "latitude": "27.58111000",
                        "longitude": "110.27722000"
                    },
                    {
                        "id": 20199,
                        "name": "Tuokou",
                        "latitude": "27.12472000",
                        "longitude": "109.62472000"
                    },
                    {
                        "id": 20210,
                        "name": "Wantouqiao",
                        "latitude": "26.84111000",
                        "longitude": "110.61944000"
                    },
                    {
                        "id": 20225,
                        "name": "Wenxing",
                        "latitude": "28.68208000",
                        "longitude": "112.87864000"
                    },
                    {
                        "id": 20235,
                        "name": "Wulingyuan",
                        "latitude": "29.34936000",
                        "longitude": "110.54407000"
                    },
                    {
                        "id": 20238,
                        "name": "Wuxi",
                        "latitude": "26.58440000",
                        "longitude": "111.85900000"
                    },
                    {
                        "id": 20242,
                        "name": "Wuyang",
                        "latitude": "26.74278000",
                        "longitude": "110.32833000"
                    },
                    {
                        "id": 20255,
                        "name": "Xiangtan",
                        "latitude": "27.85000000",
                        "longitude": "112.90000000"
                    },
                    {
                        "id": 20256,
                        "name": "Xiangxi Tujiazu Miaozu Zizhizhou",
                        "latitude": "28.70573000",
                        "longitude": "109.73329000"
                    },
                    {
                        "id": 20257,
                        "name": "Xiangxiang",
                        "latitude": "27.73333000",
                        "longitude": "112.53333000"
                    },
                    {
                        "id": 20264,
                        "name": "Xianrenwan",
                        "latitude": "27.75444000",
                        "longitude": "110.32972000"
                    },
                    {
                        "id": 20267,
                        "name": "Xianxi",
                        "latitude": "26.33472000",
                        "longitude": "109.64306000"
                    },
                    {
                        "id": 20270,
                        "name": "Xiaohenglong",
                        "latitude": "27.60500000",
                        "longitude": "110.51694000"
                    },
                    {
                        "id": 20272,
                        "name": "Xiaolongmen",
                        "latitude": "27.80194000",
                        "longitude": "110.16056000"
                    },
                    {
                        "id": 20273,
                        "name": "Xiaoshajiang",
                        "latitude": "27.52139000",
                        "longitude": "110.74806000"
                    },
                    {
                        "id": 20322,
                        "name": "Xishan",
                        "latitude": "27.66667000",
                        "longitude": "113.50000000"
                    },
                    {
                        "id": 20326,
                        "name": "Xixi",
                        "latitude": "27.69375000",
                        "longitude": "110.95333000"
                    },
                    {
                        "id": 20328,
                        "name": "Xiyan",
                        "latitude": "26.61639000",
                        "longitude": "110.47361000"
                    },
                    {
                        "id": 20353,
                        "name": "Yanmen",
                        "latitude": "27.85500000",
                        "longitude": "109.74028000"
                    },
                    {
                        "id": 20360,
                        "name": "Yaoshi",
                        "latitude": "26.29306000",
                        "longitude": "110.78917000"
                    },
                    {
                        "id": 20363,
                        "name": "Yatunpu",
                        "latitude": "26.15500000",
                        "longitude": "109.62667000"
                    },
                    {
                        "id": 20384,
                        "name": "Yiyang",
                        "latitude": "28.58917000",
                        "longitude": "112.32833000"
                    },
                    {
                        "id": 20386,
                        "name": "Yongfeng",
                        "latitude": "27.42829000",
                        "longitude": "112.18338000"
                    },
                    {
                        "id": 20388,
                        "name": "Yongzhou",
                        "latitude": "26.44014000",
                        "longitude": "111.60290000"
                    },
                    {
                        "id": 20396,
                        "name": "Yueyang",
                        "latitude": "29.37455000",
                        "longitude": "113.09481000"
                    },
                    {
                        "id": 20397,
                        "name": "Yueyang Shi",
                        "latitude": "29.32472000",
                        "longitude": "113.30200000"
                    },
                    {
                        "id": 20408,
                        "name": "Yutan",
                        "latitude": "28.25831000",
                        "longitude": "112.56048000"
                    },
                    {
                        "id": 20418,
                        "name": "Zhaishi Miaozu Dongzuxiang",
                        "latitude": "26.50083000",
                        "longitude": "110.04444000"
                    },
                    {
                        "id": 20421,
                        "name": "Zhangjiajie",
                        "latitude": "29.12944000",
                        "longitude": "110.47833000"
                    },
                    {
                        "id": 20449,
                        "name": "Zhongfang",
                        "latitude": "27.41139000",
                        "longitude": "109.93194000"
                    },
                    {
                        "id": 20457,
                        "name": "Zhongzhai",
                        "latitude": "27.19528000",
                        "longitude": "109.26861000"
                    },
                    {
                        "id": 20474,
                        "name": "Zhushi",
                        "latitude": "27.08778000",
                        "longitude": "110.67694000"
                    },
                    {
                        "id": 20475,
                        "name": "Zhuzhou",
                        "latitude": "27.83333000",
                        "longitude": "113.15000000"
                    },
                    {
                        "id": 20476,
                        "name": "Zhuzhou Shi",
                        "latitude": "27.82450000",
                        "longitude": "113.08228000"
                    },
                    {
                        "id": 20477,
                        "name": "Zhuzhoujiang Miaozuxiang",
                        "latitude": "26.67528000",
                        "longitude": "110.07194000"
                    }
                ]
            },
            {
                "id": 2269,
                "name": "Inner Mongolia",
                "iso2": "NM",
                "latitude": "43.37822000",
                "longitude": "115.05948150",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 19318,
                        "name": "Baotou",
                        "latitude": "40.65222000",
                        "longitude": "109.82222000"
                    },
                    {
                        "id": 19323,
                        "name": "Bayan Nur",
                        "latitude": "40.74143000",
                        "longitude": "107.38599000"
                    },
                    {
                        "id": 19324,
                        "name": "Bayannur Shi",
                        "latitude": "41.56958000",
                        "longitude": "107.49485000"
                    },
                    {
                        "id": 19328,
                        "name": "Beichengqu",
                        "latitude": "40.43944000",
                        "longitude": "113.15361000"
                    },
                    {
                        "id": 19399,
                        "name": "Chifeng",
                        "latitude": "42.26833000",
                        "longitude": "118.96361000"
                    },
                    {
                        "id": 19475,
                        "name": "Dongsheng",
                        "latitude": "39.81609000",
                        "longitude": "109.97763000"
                    },
                    {
                        "id": 19497,
                        "name": "E’erguna",
                        "latitude": "50.22362000",
                        "longitude": "120.17092000"
                    },
                    {
                        "id": 19494,
                        "name": "Erenhot",
                        "latitude": "43.64750000",
                        "longitude": "111.97667000"
                    },
                    {
                        "id": 19553,
                        "name": "Genhe",
                        "latitude": "50.78333000",
                        "longitude": "121.51667000"
                    },
                    {
                        "id": 19587,
                        "name": "Hailar",
                        "latitude": "49.20000000",
                        "longitude": "119.70000000"
                    },
                    {
                        "id": 19623,
                        "name": "Hohhot",
                        "latitude": "40.81056000",
                        "longitude": "111.65222000"
                    },
                    {
                        "id": 19680,
                        "name": "Hulunbuir Region",
                        "latitude": "49.70989000",
                        "longitude": "121.72176000"
                    },
                    {
                        "id": 19691,
                        "name": "Jalai Nur",
                        "latitude": "49.45000000",
                        "longitude": "117.70000000"
                    },
                    {
                        "id": 19692,
                        "name": "Jiagedaqi",
                        "latitude": "50.41667000",
                        "longitude": "124.11667000"
                    },
                    {
                        "id": 19742,
                        "name": "Jining",
                        "latitude": "41.02750000",
                        "longitude": "113.10583000"
                    },
                    {
                        "id": 19903,
                        "name": "Manzhouli",
                        "latitude": "49.60000000",
                        "longitude": "117.43333000"
                    },
                    {
                        "id": 19928,
                        "name": "Mositai",
                        "latitude": "45.53538000",
                        "longitude": "119.66698000"
                    },
                    {
                        "id": 19931,
                        "name": "Mujiayingzi",
                        "latitude": "42.11667000",
                        "longitude": "118.78333000"
                    },
                    {
                        "id": 19967,
                        "name": "Ordos",
                        "latitude": "39.60860000",
                        "longitude": "109.78157000"
                    },
                    {
                        "id": 19968,
                        "name": "Ordos Shi",
                        "latitude": "39.46142000",
                        "longitude": "108.80946000"
                    },
                    {
                        "id": 19969,
                        "name": "Oroqen Zizhiqi",
                        "latitude": "50.56667000",
                        "longitude": "123.71667000"
                    },
                    {
                        "id": 19986,
                        "name": "Pingzhuang",
                        "latitude": "42.03722000",
                        "longitude": "119.28889000"
                    },
                    {
                        "id": 20050,
                        "name": "Salaqi",
                        "latitude": "40.54139000",
                        "longitude": "110.51083000"
                    },
                    {
                        "id": 20092,
                        "name": "Shiguai",
                        "latitude": "40.70583000",
                        "longitude": "110.28556000"
                    },
                    {
                        "id": 20192,
                        "name": "Tongliao",
                        "latitude": "43.61250000",
                        "longitude": "122.26528000"
                    },
                    {
                        "id": 20203,
                        "name": "Ulanhot",
                        "latitude": "46.08333000",
                        "longitude": "122.08333000"
                    },
                    {
                        "id": 20220,
                        "name": "Wenquan",
                        "latitude": "47.17560000",
                        "longitude": "119.94809000"
                    },
                    {
                        "id": 20231,
                        "name": "Wuda",
                        "latitude": "39.49944000",
                        "longitude": "106.71167000"
                    },
                    {
                        "id": 20232,
                        "name": "Wuhai",
                        "latitude": "39.68442000",
                        "longitude": "106.81583000"
                    },
                    {
                        "id": 20284,
                        "name": "Xilin Gol Meng",
                        "latitude": "44.85493000",
                        "longitude": "115.72789000"
                    },
                    {
                        "id": 20285,
                        "name": "Xilin Hot",
                        "latitude": "43.96667000",
                        "longitude": "116.03333000"
                    },
                    {
                        "id": 20336,
                        "name": "Yakeshi",
                        "latitude": "49.28333000",
                        "longitude": "120.73333000"
                    },
                    {
                        "id": 20419,
                        "name": "Zhalantun",
                        "latitude": "48.00945000",
                        "longitude": "122.73651000"
                    }
                ]
            },
            {
                "id": 2250,
                "name": "Jiangsu",
                "iso2": "JS",
                "latitude": "33.14017150",
                "longitude": "119.78892480",
                "type": "province",
                "cities": [
                    {
                        "id": 149266,
                        "name": "ChangZhou",
                        "latitude": "31.72322000",
                        "longitude": "119.59794000"
                    },
                    {
                        "id": 19592,
                        "name": "Haizhou",
                        "latitude": "34.57300501",
                        "longitude": "119.16126173"
                    },
                    {
                        "id": 149270,
                        "name": "HuaiAn",
                        "latitude": "33.29433000",
                        "longitude": "118.87350000"
                    },
                    {
                        "id": 19734,
                        "name": "Jingjiang",
                        "latitude": "32.01827432",
                        "longitude": "120.27557629"
                    },
                    {
                        "id": 149269,
                        "name": "LianYunGang",
                        "latitude": "34.84065000",
                        "longitude": "119.17730000"
                    },
                    {
                        "id": 149263,
                        "name": "NanJing",
                        "latitude": "31.32751000",
                        "longitude": "118.89210000"
                    },
                    {
                        "id": 149268,
                        "name": "NanTong",
                        "latitude": "32.00986000",
                        "longitude": "120.85737000"
                    },
                    {
                        "id": 149275,
                        "name": "SuQian",
                        "latitude": "33.96271000",
                        "longitude": "118.24239000"
                    },
                    {
                        "id": 149267,
                        "name": "SuZhou",
                        "latitude": "31.30227000",
                        "longitude": "120.63132000"
                    },
                    {
                        "id": 149274,
                        "name": "TaiZhou",
                        "latitude": "32.31841000",
                        "longitude": "119.88116000"
                    },
                    {
                        "id": 149264,
                        "name": "WuXi",
                        "latitude": "31.52853000",
                        "longitude": "120.28429000"
                    },
                    {
                        "id": 149265,
                        "name": "XuZhou",
                        "latitude": "34.28823000",
                        "longitude": "117.18554000"
                    },
                    {
                        "id": 149271,
                        "name": "YanCheng",
                        "latitude": "33.20107000",
                        "longitude": "120.50102000"
                    },
                    {
                        "id": 149272,
                        "name": "YangZhou",
                        "latitude": "32.39463000",
                        "longitude": "119.43157000"
                    },
                    {
                        "id": 149273,
                        "name": "ZhenJiang",
                        "latitude": "32.13188000",
                        "longitude": "119.43396000"
                    }
                ]
            },
            {
                "id": 2256,
                "name": "Jiangxi",
                "iso2": "JX",
                "latitude": "27.08745640",
                "longitude": "114.90422080",
                "type": "province",
                "cities": [
                    {
                        "id": 19367,
                        "name": "Changleng",
                        "latitude": "28.70000000",
                        "longitude": "115.81667000"
                    },
                    {
                        "id": 19513,
                        "name": "Fenyi",
                        "latitude": "27.81117000",
                        "longitude": "114.66805000"
                    },
                    {
                        "id": 19538,
                        "name": "Ganzhou",
                        "latitude": "25.84664000",
                        "longitude": "114.93260000"
                    },
                    {
                        "id": 19539,
                        "name": "Ganzhou Shi",
                        "latitude": "25.70387000",
                        "longitude": "115.34822000"
                    },
                    {
                        "id": 19574,
                        "name": "Guixi",
                        "latitude": "28.28857000",
                        "longitude": "117.21329000"
                    },
                    {
                        "id": 19762,
                        "name": "Ji’an",
                        "latitude": "27.11716000",
                        "longitude": "114.97927000"
                    },
                    {
                        "id": 19701,
                        "name": "Jianguang",
                        "latitude": "28.19377000",
                        "longitude": "115.78360000"
                    },
                    {
                        "id": 19730,
                        "name": "Jingdezhen",
                        "latitude": "29.29470000",
                        "longitude": "117.20789000"
                    },
                    {
                        "id": 19731,
                        "name": "Jingdezhen Shi",
                        "latitude": "29.31682000",
                        "longitude": "117.24688000"
                    },
                    {
                        "id": 19756,
                        "name": "Jiujiang",
                        "latitude": "29.70475000",
                        "longitude": "116.00206000"
                    },
                    {
                        "id": 19935,
                        "name": "Nanchang",
                        "latitude": "28.68396000",
                        "longitude": "115.85306000"
                    },
                    {
                        "id": 19983,
                        "name": "Pingxiang",
                        "latitude": "27.61672000",
                        "longitude": "113.85353000"
                    },
                    {
                        "id": 19988,
                        "name": "Poyang",
                        "latitude": "28.99242000",
                        "longitude": "116.66754000"
                    },
                    {
                        "id": 20067,
                        "name": "Shangrao",
                        "latitude": "28.45179000",
                        "longitude": "117.94287000"
                    },
                    {
                        "id": 20313,
                        "name": "Xinyu",
                        "latitude": "27.80429000",
                        "longitude": "114.93335000"
                    },
                    {
                        "id": 20369,
                        "name": "Yichun",
                        "latitude": "27.83333000",
                        "longitude": "114.40000000"
                    }
                ]
            },
            {
                "id": 2253,
                "name": "Jilin",
                "iso2": "JL",
                "latitude": "43.83788300",
                "longitude": "126.54957200",
                "type": "province",
                "cities": [
                    {
                        "id": 19298,
                        "name": "Baicheng",
                        "latitude": "45.60746000",
                        "longitude": "122.82076000"
                    },
                    {
                        "id": 19306,
                        "name": "Baishan",
                        "latitude": "41.93853000",
                        "longitude": "126.41965000"
                    },
                    {
                        "id": 19308,
                        "name": "Baishishan",
                        "latitude": "43.58333000",
                        "longitude": "127.56667000"
                    },
                    {
                        "id": 19363,
                        "name": "Changchun",
                        "latitude": "43.88000000",
                        "longitude": "125.32278000"
                    },
                    {
                        "id": 19369,
                        "name": "Changling",
                        "latitude": "44.26532000",
                        "longitude": "124.00045000"
                    },
                    {
                        "id": 19381,
                        "name": "Chaoyang",
                        "latitude": "42.66223000",
                        "longitude": "126.02630000"
                    },
                    {
                        "id": 19418,
                        "name": "Dalai",
                        "latitude": "45.50000000",
                        "longitude": "124.30000000"
                    },
                    {
                        "id": 19434,
                        "name": "Dashitou",
                        "latitude": "43.30667000",
                        "longitude": "128.51139000"
                    },
                    {
                        "id": 19447,
                        "name": "Dehui",
                        "latitude": "44.53333000",
                        "longitude": "125.70000000"
                    },
                    {
                        "id": 19466,
                        "name": "Dongfeng",
                        "latitude": "42.64031000",
                        "longitude": "125.51176000"
                    },
                    {
                        "id": 19485,
                        "name": "Dunhua",
                        "latitude": "43.37250000",
                        "longitude": "128.24250000"
                    },
                    {
                        "id": 19493,
                        "name": "Erdaojiang",
                        "latitude": "41.77639000",
                        "longitude": "126.03194000"
                    },
                    {
                        "id": 19529,
                        "name": "Fuyu",
                        "latitude": "45.18333000",
                        "longitude": "124.81667000"
                    },
                    {
                        "id": 19557,
                        "name": "Gongzhuling",
                        "latitude": "43.50075000",
                        "longitude": "124.81979000"
                    },
                    {
                        "id": 19559,
                        "name": "Guangming",
                        "latitude": "45.33333000",
                        "longitude": "122.78333000"
                    },
                    {
                        "id": 19612,
                        "name": "Helong",
                        "latitude": "42.53974000",
                        "longitude": "128.99722000"
                    },
                    {
                        "id": 19616,
                        "name": "Hepingjie",
                        "latitude": "42.05972000",
                        "longitude": "126.91583000"
                    },
                    {
                        "id": 19634,
                        "name": "Huadian",
                        "latitude": "42.96333000",
                        "longitude": "126.74778000"
                    },
                    {
                        "id": 19653,
                        "name": "Huangnihe",
                        "latitude": "43.55833000",
                        "longitude": "128.02389000"
                    },
                    {
                        "id": 19674,
                        "name": "Huinan",
                        "latitude": "42.62250000",
                        "longitude": "126.26139000"
                    },
                    {
                        "id": 19682,
                        "name": "Hunchun",
                        "latitude": "42.86750000",
                        "longitude": "130.35806000"
                    },
                    {
                        "id": 19763,
                        "name": "Ji’an",
                        "latitude": "41.12349000",
                        "longitude": "126.17631000"
                    },
                    {
                        "id": 19725,
                        "name": "Jilin",
                        "latitude": "43.85083000",
                        "longitude": "126.56028000"
                    },
                    {
                        "id": 19753,
                        "name": "Jishu",
                        "latitude": "44.31667000",
                        "longitude": "126.80000000"
                    },
                    {
                        "id": 19759,
                        "name": "Jiutai",
                        "latitude": "44.15250000",
                        "longitude": "125.83278000"
                    },
                    {
                        "id": 19768,
                        "name": "Kaitong",
                        "latitude": "44.81351000",
                        "longitude": "123.15000000"
                    },
                    {
                        "id": 19830,
                        "name": "Liaoyuan",
                        "latitude": "42.90361000",
                        "longitude": "125.13583000"
                    },
                    {
                        "id": 19845,
                        "name": "Linjiang",
                        "latitude": "41.80694000",
                        "longitude": "126.90778000"
                    },
                    {
                        "id": 19857,
                        "name": "Lishu",
                        "latitude": "43.30472000",
                        "longitude": "124.32778000"
                    },
                    {
                        "id": 19860,
                        "name": "Liuhe",
                        "latitude": "42.24007000",
                        "longitude": "125.71717000"
                    },
                    {
                        "id": 19868,
                        "name": "Longjing",
                        "latitude": "42.77139000",
                        "longitude": "129.42333000"
                    },
                    {
                        "id": 19910,
                        "name": "Meihekou",
                        "latitude": "42.52722000",
                        "longitude": "125.67528000"
                    },
                    {
                        "id": 19922,
                        "name": "Mingyue",
                        "latitude": "43.10694000",
                        "longitude": "128.92167000"
                    },
                    {
                        "id": 19923,
                        "name": "Minzhu",
                        "latitude": "43.72145000",
                        "longitude": "127.33401000"
                    },
                    {
                        "id": 19974,
                        "name": "Panshi",
                        "latitude": "42.94222000",
                        "longitude": "126.05611000"
                    },
                    {
                        "id": 20052,
                        "name": "Sanchazi",
                        "latitude": "42.08167000",
                        "longitude": "126.60028000"
                    },
                    {
                        "id": 20119,
                        "name": "Shuangyang",
                        "latitude": "43.52417000",
                        "longitude": "125.67361000"
                    },
                    {
                        "id": 20125,
                        "name": "Shulan",
                        "latitude": "44.41667000",
                        "longitude": "126.95000000"
                    },
                    {
                        "id": 20129,
                        "name": "Siping",
                        "latitude": "43.16143000",
                        "longitude": "124.37785000"
                    },
                    {
                        "id": 20133,
                        "name": "Songjianghe",
                        "latitude": "42.18590000",
                        "longitude": "127.47895000"
                    },
                    {
                        "id": 20138,
                        "name": "Songyuan",
                        "latitude": "45.12902000",
                        "longitude": "124.82769000"
                    },
                    {
                        "id": 20190,
                        "name": "Tonghua",
                        "latitude": "41.71972000",
                        "longitude": "125.92639000"
                    },
                    {
                        "id": 20191,
                        "name": "Tonghua Shi",
                        "latitude": "42.12389000",
                        "longitude": "125.84833000"
                    },
                    {
                        "id": 20198,
                        "name": "Tumen",
                        "latitude": "42.96611000",
                        "longitude": "129.84250000"
                    },
                    {
                        "id": 20208,
                        "name": "Wangqing",
                        "latitude": "43.32179000",
                        "longitude": "129.76342000"
                    },
                    {
                        "id": 20295,
                        "name": "Xinglongshan",
                        "latitude": "43.95611000",
                        "longitude": "125.46611000"
                    },
                    {
                        "id": 20339,
                        "name": "Yanbian Chaoxianzu Zizhizhou",
                        "latitude": "43.12583000",
                        "longitude": "129.12833000"
                    },
                    {
                        "id": 20350,
                        "name": "Yanji",
                        "latitude": "42.90750000",
                        "longitude": "129.50778000"
                    },
                    {
                        "id": 20358,
                        "name": "Yantongshan",
                        "latitude": "43.29194000",
                        "longitude": "126.00944000"
                    },
                    {
                        "id": 20406,
                        "name": "Yushu",
                        "latitude": "44.80000000",
                        "longitude": "126.53333000"
                    },
                    {
                        "id": 20438,
                        "name": "Zhengjiatun",
                        "latitude": "43.50639000",
                        "longitude": "123.50639000"
                    },
                    {
                        "id": 20442,
                        "name": "Zhenlai",
                        "latitude": "45.84955000",
                        "longitude": "123.29730000"
                    }
                ]
            },
            {
                "id": 2268,
                "name": "Liaoning",
                "iso2": "LN",
                "latitude": "41.94365430",
                "longitude": "122.52903760",
                "type": "province",
                "cities": [
                    {
                        "id": 19287,
                        "name": "Anshan",
                        "latitude": "41.12361000",
                        "longitude": "122.99000000"
                    },
                    {
                        "id": 19333,
                        "name": "Beipiao",
                        "latitude": "41.79194000",
                        "longitude": "120.77917000"
                    },
                    {
                        "id": 19339,
                        "name": "Benxi",
                        "latitude": "41.28861000",
                        "longitude": "123.76500000"
                    },
                    {
                        "id": 19377,
                        "name": "Changtu",
                        "latitude": "42.77884000",
                        "longitude": "124.09545000"
                    },
                    {
                        "id": 19382,
                        "name": "Chaoyang",
                        "latitude": "41.57028000",
                        "longitude": "120.45861000"
                    },
                    {
                        "id": 19421,
                        "name": "Dalian",
                        "latitude": "38.91222000",
                        "longitude": "121.60222000"
                    },
                    {
                        "id": 19423,
                        "name": "Dalianwan",
                        "latitude": "39.02861000",
                        "longitude": "121.69500000"
                    },
                    {
                        "id": 19424,
                        "name": "Dandong",
                        "latitude": "40.12917000",
                        "longitude": "124.39472000"
                    },
                    {
                        "id": 19433,
                        "name": "Dashiqiao",
                        "latitude": "40.63732000",
                        "longitude": "122.50251000"
                    },
                    {
                        "id": 19472,
                        "name": "Dongling",
                        "latitude": "41.81444000",
                        "longitude": "123.57583000"
                    },
                    {
                        "id": 19504,
                        "name": "Fengcheng",
                        "latitude": "40.45361000",
                        "longitude": "124.07167000"
                    },
                    {
                        "id": 19523,
                        "name": "Fushun",
                        "latitude": "41.88669000",
                        "longitude": "123.94363000"
                    },
                    {
                        "id": 19524,
                        "name": "Fuxin",
                        "latitude": "42.01556000",
                        "longitude": "121.65889000"
                    },
                    {
                        "id": 19533,
                        "name": "Gaizhou",
                        "latitude": "40.39417000",
                        "longitude": "122.36861000"
                    },
                    {
                        "id": 19556,
                        "name": "Gongchangling",
                        "latitude": "41.11667000",
                        "longitude": "123.45000000"
                    },
                    {
                        "id": 19583,
                        "name": "Haicheng",
                        "latitude": "40.85158000",
                        "longitude": "122.74754000"
                    },
                    {
                        "id": 19611,
                        "name": "Heishan",
                        "latitude": "41.68917000",
                        "longitude": "122.11278000"
                    },
                    {
                        "id": 19664,
                        "name": "Huanren",
                        "latitude": "41.26472000",
                        "longitude": "125.36667000"
                    },
                    {
                        "id": 19678,
                        "name": "Huludao",
                        "latitude": "40.75243000",
                        "longitude": "120.83552000"
                    },
                    {
                        "id": 19679,
                        "name": "Huludao Shi",
                        "latitude": "40.74528000",
                        "longitude": "120.21972000"
                    },
                    {
                        "id": 19687,
                        "name": "Hushitai",
                        "latitude": "41.94175000",
                        "longitude": "123.50266000"
                    },
                    {
                        "id": 19752,
                        "name": "Jinzhou",
                        "latitude": "41.10778000",
                        "longitude": "121.14167000"
                    },
                    {
                        "id": 19757,
                        "name": "Jiupu",
                        "latitude": "41.06667000",
                        "longitude": "122.95000000"
                    },
                    {
                        "id": 19771,
                        "name": "Kaiyuan",
                        "latitude": "42.53306000",
                        "longitude": "124.04028000"
                    },
                    {
                        "id": 19781,
                        "name": "Kuandian",
                        "latitude": "40.72861000",
                        "longitude": "124.78472000"
                    },
                    {
                        "id": 19796,
                        "name": "Langtoucun",
                        "latitude": "40.04068000",
                        "longitude": "124.33525000"
                    },
                    {
                        "id": 19823,
                        "name": "Lianshan",
                        "latitude": "40.76432000",
                        "longitude": "120.85327000"
                    },
                    {
                        "id": 19829,
                        "name": "Liaoyang",
                        "latitude": "41.27194000",
                        "longitude": "123.17306000"
                    },
                    {
                        "id": 19831,
                        "name": "Liaozhong",
                        "latitude": "41.50611000",
                        "longitude": "122.72417000"
                    },
                    {
                        "id": 19842,
                        "name": "Linghai",
                        "latitude": "41.16528000",
                        "longitude": "121.36667000"
                    },
                    {
                        "id": 19843,
                        "name": "Lingyuan",
                        "latitude": "41.24000000",
                        "longitude": "119.40111000"
                    },
                    {
                        "id": 19897,
                        "name": "Lüshun",
                        "latitude": "38.80000000",
                        "longitude": "121.26667000"
                    },
                    {
                        "id": 19946,
                        "name": "Nanpiao",
                        "latitude": "41.09822000",
                        "longitude": "120.74792000"
                    },
                    {
                        "id": 19948,
                        "name": "Nantai",
                        "latitude": "40.92410000",
                        "longitude": "122.80437000"
                    },
                    {
                        "id": 19972,
                        "name": "Panjin Shi",
                        "latitude": "41.13167000",
                        "longitude": "121.99361000"
                    },
                    {
                        "id": 19973,
                        "name": "Panshan",
                        "latitude": "41.18806000",
                        "longitude": "122.04944000"
                    },
                    {
                        "id": 19994,
                        "name": "Pulandian",
                        "latitude": "39.39528000",
                        "longitude": "121.96694000"
                    },
                    {
                        "id": 20090,
                        "name": "Shenyang",
                        "latitude": "41.79222000",
                        "longitude": "123.43278000"
                    },
                    {
                        "id": 20146,
                        "name": "Sujiatun",
                        "latitude": "41.65917000",
                        "longitude": "123.33917000"
                    },
                    {
                        "id": 20183,
                        "name": "Tieling",
                        "latitude": "42.29306000",
                        "longitude": "123.84139000"
                    },
                    {
                        "id": 20184,
                        "name": "Tieling Shi",
                        "latitude": "42.62583000",
                        "longitude": "124.32361000"
                    },
                    {
                        "id": 20206,
                        "name": "Wafangdian",
                        "latitude": "39.61833000",
                        "longitude": "122.00806000"
                    },
                    {
                        "id": 20275,
                        "name": "Xiaoshi",
                        "latitude": "41.29711000",
                        "longitude": "124.12092000"
                    },
                    {
                        "id": 20281,
                        "name": "Xifeng",
                        "latitude": "42.73722000",
                        "longitude": "124.72222000"
                    },
                    {
                        "id": 20293,
                        "name": "Xingcheng",
                        "latitude": "40.61667000",
                        "longitude": "120.71667000"
                    },
                    {
                        "id": 20302,
                        "name": "Xinmin",
                        "latitude": "41.99083000",
                        "longitude": "122.82528000"
                    },
                    {
                        "id": 20310,
                        "name": "Xinxing",
                        "latitude": "39.86694000",
                        "longitude": "124.12304000"
                    },
                    {
                        "id": 20324,
                        "name": "Xiuyan",
                        "latitude": "40.29278000",
                        "longitude": "123.27444000"
                    },
                    {
                        "id": 20364,
                        "name": "Yebaishou",
                        "latitude": "41.39750000",
                        "longitude": "119.64083000"
                    },
                    {
                        "id": 20378,
                        "name": "Yingkou",
                        "latitude": "40.63897000",
                        "longitude": "122.24762000"
                    },
                    {
                        "id": 20464,
                        "name": "Zhuanghe",
                        "latitude": "39.70083000",
                        "longitude": "122.99111000"
                    }
                ]
            },
            {
                "id": 2266,
                "name": "Macau SAR",
                "iso2": "MO",
                "latitude": "22.19874500",
                "longitude": "113.54387300",
                "type": "special administrative region",
                "cities": []
            },
            {
                "id": 2262,
                "name": "Ningxia Huizu",
                "iso2": "NX",
                "latitude": "37.19873100",
                "longitude": "106.15809370",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 19438,
                        "name": "Dawukou",
                        "latitude": "39.04194000",
                        "longitude": "106.39583000"
                    },
                    {
                        "id": 19476,
                        "name": "Dongta",
                        "latitude": "38.08140000",
                        "longitude": "106.34444000"
                    },
                    {
                        "id": 20106,
                        "name": "Shitanjing",
                        "latitude": "39.23417000",
                        "longitude": "106.34389000"
                    },
                    {
                        "id": 20111,
                        "name": "Shizuishan",
                        "latitude": "39.23333000",
                        "longitude": "106.76944000"
                    },
                    {
                        "id": 20246,
                        "name": "Wuzhong",
                        "latitude": "37.98670000",
                        "longitude": "106.20100000"
                    },
                    {
                        "id": 20374,
                        "name": "Yinchuan",
                        "latitude": "38.46806000",
                        "longitude": "106.27306000"
                    },
                    {
                        "id": 20454,
                        "name": "Zhongwei",
                        "latitude": "37.51129000",
                        "longitude": "105.19067000"
                    }
                ]
            },
            {
                "id": 2270,
                "name": "Qinghai",
                "iso2": "QH",
                "latitude": "35.74479800",
                "longitude": "96.40773580",
                "type": "province",
                "cities": [
                    {
                        "id": 19448,
                        "name": "Delingha",
                        "latitude": "37.37600000",
                        "longitude": "97.37457000"
                    },
                    {
                        "id": 19554,
                        "name": "Golmud",
                        "latitude": "36.40672000",
                        "longitude": "94.90061000"
                    },
                    {
                        "id": 19555,
                        "name": "Golog Tibetan Autonomous Prefecture",
                        "latitude": "34.08595000",
                        "longitude": "99.55181000"
                    },
                    {
                        "id": 19582,
                        "name": "Haibei Tibetan Autonomous Prefecture",
                        "latitude": "37.71919000",
                        "longitude": "100.45656000"
                    },
                    {
                        "id": 19652,
                        "name": "Huangnan Zangzu Zizhizhou",
                        "latitude": "35.06316000",
                        "longitude": "101.65149000"
                    },
                    {
                        "id": 20300,
                        "name": "Xining",
                        "latitude": "36.62554000",
                        "longitude": "101.75739000"
                    },
                    {
                        "id": 20320,
                        "name": "Xireg",
                        "latitude": "36.91866000",
                        "longitude": "98.44463000"
                    },
                    {
                        "id": 20407,
                        "name": "Yushu Zangzu Zizhizhou",
                        "latitude": "34.39802000",
                        "longitude": "94.19021000"
                    }
                ]
            },
            {
                "id": 2272,
                "name": "Shaanxi",
                "iso2": "SN",
                "latitude": "35.39399080",
                "longitude": "109.18800470",
                "type": "province",
                "cities": [
                    {
                        "id": 19281,
                        "name": "Ankang",
                        "latitude": "32.68000000",
                        "longitude": "109.01722000"
                    },
                    {
                        "id": 19315,
                        "name": "Baoji Shi",
                        "latitude": "34.36944000",
                        "longitude": "107.13635000"
                    },
                    {
                        "id": 19578,
                        "name": "Guozhen",
                        "latitude": "34.36591000",
                        "longitude": "107.35904000"
                    },
                    {
                        "id": 19595,
                        "name": "Hancheng",
                        "latitude": "35.46028000",
                        "longitude": "110.42917000"
                    },
                    {
                        "id": 19600,
                        "name": "Hanzhong",
                        "latitude": "33.07507000",
                        "longitude": "107.02214000"
                    },
                    {
                        "id": 19667,
                        "name": "Huayin",
                        "latitude": "34.56528000",
                        "longitude": "110.06639000"
                    },
                    {
                        "id": 19852,
                        "name": "Lintong",
                        "latitude": "34.37803000",
                        "longitude": "109.20892000"
                    },
                    {
                        "id": 20188,
                        "name": "Tongchuanshi",
                        "latitude": "35.07474000",
                        "longitude": "109.08495000"
                    },
                    {
                        "id": 20215,
                        "name": "Weinan",
                        "latitude": "34.50355000",
                        "longitude": "109.50891000"
                    },
                    {
                        "id": 20329,
                        "name": "Xi’an",
                        "latitude": "34.25833000",
                        "longitude": "108.92861000"
                    },
                    {
                        "id": 20268,
                        "name": "Xianyang",
                        "latitude": "34.33778000",
                        "longitude": "108.70261000"
                    },
                    {
                        "id": 20352,
                        "name": "Yanliang",
                        "latitude": "34.65918000",
                        "longitude": "109.22921000"
                    },
                    {
                        "id": 20399,
                        "name": "Yulinshi",
                        "latitude": "38.29181000",
                        "longitude": "109.73753000"
                    },
                    {
                        "id": 20410,
                        "name": "Yuxia",
                        "latitude": "34.06153000",
                        "longitude": "108.62905000"
                    }
                ]
            },
            {
                "id": 2252,
                "name": "Shandong",
                "iso2": "SD",
                "latitude": "37.80060640",
                "longitude": "-122.26999180",
                "type": "province",
                "cities": [
                    {
                        "id": 19286,
                        "name": "Anqiu",
                        "latitude": "36.43417000",
                        "longitude": "119.19250000"
                    },
                    {
                        "id": 19335,
                        "name": "Beizhai",
                        "latitude": "36.21972000",
                        "longitude": "120.52889000"
                    },
                    {
                        "id": 19340,
                        "name": "Bianzhuang",
                        "latitude": "34.84861000",
                        "longitude": "118.04472000"
                    },
                    {
                        "id": 19343,
                        "name": "Binzhou",
                        "latitude": "37.36667000",
                        "longitude": "118.01667000"
                    },
                    {
                        "id": 19348,
                        "name": "Boshan",
                        "latitude": "36.48333000",
                        "longitude": "117.83333000"
                    },
                    {
                        "id": 19372,
                        "name": "Changqing",
                        "latitude": "36.55750000",
                        "longitude": "116.72722000"
                    },
                    {
                        "id": 19392,
                        "name": "Chengqu",
                        "latitude": "36.91060000",
                        "longitude": "121.52504000"
                    },
                    {
                        "id": 19393,
                        "name": "Chengtangcun",
                        "latitude": "35.08357000",
                        "longitude": "117.19071000"
                    },
                    {
                        "id": 19395,
                        "name": "Chengyang",
                        "latitude": "35.57944000",
                        "longitude": "118.83278000"
                    },
                    {
                        "id": 19450,
                        "name": "Dengying",
                        "latitude": "36.13889000",
                        "longitude": "120.57417000"
                    },
                    {
                        "id": 19452,
                        "name": "Dengzhou",
                        "latitude": "37.80822000",
                        "longitude": "120.75908000"
                    },
                    {
                        "id": 19455,
                        "name": "Dezhou",
                        "latitude": "37.45127000",
                        "longitude": "116.31046000"
                    },
                    {
                        "id": 19458,
                        "name": "Dingtao",
                        "latitude": "35.07436000",
                        "longitude": "115.56582000"
                    },
                    {
                        "id": 19463,
                        "name": "Dongcun",
                        "latitude": "36.77667000",
                        "longitude": "121.15972000"
                    },
                    {
                        "id": 19465,
                        "name": "Dongdu",
                        "latitude": "35.85000000",
                        "longitude": "117.70000000"
                    },
                    {
                        "id": 19501,
                        "name": "Feicheng",
                        "latitude": "36.24861000",
                        "longitude": "116.76583000"
                    },
                    {
                        "id": 19541,
                        "name": "Gaomi",
                        "latitude": "36.38333000",
                        "longitude": "119.75278000"
                    },
                    {
                        "id": 19599,
                        "name": "Hanting",
                        "latitude": "36.77083000",
                        "longitude": "119.21083000"
                    },
                    {
                        "id": 19621,
                        "name": "Heze",
                        "latitude": "35.23929000",
                        "longitude": "115.47358000"
                    },
                    {
                        "id": 19693,
                        "name": "Jiamaying",
                        "latitude": "37.20806000",
                        "longitude": "115.95000000"
                    },
                    {
                        "id": 19711,
                        "name": "Jiaozhou",
                        "latitude": "36.28389000",
                        "longitude": "120.00333000"
                    },
                    {
                        "id": 19719,
                        "name": "Jiehu",
                        "latitude": "35.54278000",
                        "longitude": "118.45500000"
                    },
                    {
                        "id": 19726,
                        "name": "Jimo",
                        "latitude": "36.38972000",
                        "longitude": "120.46222000"
                    },
                    {
                        "id": 19727,
                        "name": "Jinan",
                        "latitude": "36.66833000",
                        "longitude": "116.99722000"
                    },
                    {
                        "id": 19741,
                        "name": "Jining",
                        "latitude": "35.40500000",
                        "longitude": "116.58139000"
                    },
                    {
                        "id": 19765,
                        "name": "Juye",
                        "latitude": "35.39472000",
                        "longitude": "116.08833000"
                    },
                    {
                        "id": 19782,
                        "name": "Kuiju",
                        "latitude": "36.85361000",
                        "longitude": "119.39083000"
                    },
                    {
                        "id": 19787,
                        "name": "Kutao",
                        "latitude": "36.14500000",
                        "longitude": "120.48778000"
                    },
                    {
                        "id": 19790,
                        "name": "Laiwu",
                        "latitude": "36.19278000",
                        "longitude": "117.65694000"
                    },
                    {
                        "id": 19791,
                        "name": "Laixi",
                        "latitude": "36.85917000",
                        "longitude": "120.52694000"
                    },
                    {
                        "id": 19792,
                        "name": "Laiyang",
                        "latitude": "36.97583000",
                        "longitude": "120.71361000"
                    },
                    {
                        "id": 19793,
                        "name": "Laizhou",
                        "latitude": "37.18073000",
                        "longitude": "119.94217000"
                    },
                    {
                        "id": 19804,
                        "name": "Laocheng",
                        "latitude": "37.14278000",
                        "longitude": "115.88833000"
                    },
                    {
                        "id": 19828,
                        "name": "Liaocheng",
                        "latitude": "36.45596000",
                        "longitude": "115.97766000"
                    },
                    {
                        "id": 19850,
                        "name": "Linqu",
                        "latitude": "36.51556000",
                        "longitude": "118.53972000"
                    },
                    {
                        "id": 19856,
                        "name": "Linyi",
                        "latitude": "35.06306000",
                        "longitude": "118.34278000"
                    },
                    {
                        "id": 19866,
                        "name": "Longgang",
                        "latitude": "37.65181000",
                        "longitude": "120.33063000"
                    },
                    {
                        "id": 19915,
                        "name": "Mengyin",
                        "latitude": "35.70694000",
                        "longitude": "117.92639000"
                    },
                    {
                        "id": 19920,
                        "name": "Mingshui",
                        "latitude": "36.71667000",
                        "longitude": "117.50000000"
                    },
                    {
                        "id": 19927,
                        "name": "Mizhou",
                        "latitude": "35.99472000",
                        "longitude": "119.39750000"
                    },
                    {
                        "id": 19937,
                        "name": "Nanding",
                        "latitude": "36.74833000",
                        "longitude": "118.05583000"
                    },
                    {
                        "id": 19943,
                        "name": "Nanma",
                        "latitude": "36.18478000",
                        "longitude": "118.15486000"
                    },
                    {
                        "id": 19962,
                        "name": "Ninghai",
                        "latitude": "37.38422000",
                        "longitude": "121.60859000"
                    },
                    {
                        "id": 19963,
                        "name": "Ningyang",
                        "latitude": "35.76417000",
                        "longitude": "116.79139000"
                    },
                    {
                        "id": 19978,
                        "name": "Pingdu",
                        "latitude": "36.78444000",
                        "longitude": "119.94639000"
                    },
                    {
                        "id": 19984,
                        "name": "Pingyi",
                        "latitude": "35.50056000",
                        "longitude": "117.63083000"
                    },
                    {
                        "id": 19985,
                        "name": "Pingyin",
                        "latitude": "36.28306000",
                        "longitude": "116.44528000"
                    },
                    {
                        "id": 20016,
                        "name": "Qingdao",
                        "latitude": "36.06488000",
                        "longitude": "120.38042000"
                    },
                    {
                        "id": 20020,
                        "name": "Qingnian",
                        "latitude": "36.84032000",
                        "longitude": "115.71183000"
                    },
                    {
                        "id": 20023,
                        "name": "Qingshancun",
                        "latitude": "36.15415000",
                        "longitude": "120.68240000"
                    },
                    {
                        "id": 20025,
                        "name": "Qingyang",
                        "latitude": "37.49583000",
                        "longitude": "121.25806000"
                    },
                    {
                        "id": 20028,
                        "name": "Qingzhou",
                        "latitude": "36.69667000",
                        "longitude": "118.47972000"
                    },
                    {
                        "id": 20037,
                        "name": "Qufu",
                        "latitude": "35.59667000",
                        "longitude": "116.99111000"
                    },
                    {
                        "id": 20042,
                        "name": "Rizhao",
                        "latitude": "35.42750000",
                        "longitude": "119.45528000"
                    },
                    {
                        "id": 20062,
                        "name": "Shancheng",
                        "latitude": "34.79528000",
                        "longitude": "116.08167000"
                    },
                    {
                        "id": 20075,
                        "name": "Shanting",
                        "latitude": "35.07528000",
                        "longitude": "117.45778000"
                    },
                    {
                        "id": 20086,
                        "name": "Shazikou",
                        "latitude": "36.11500000",
                        "longitude": "120.53722000"
                    },
                    {
                        "id": 20087,
                        "name": "Shengli",
                        "latitude": "37.46271000",
                        "longitude": "118.49165000"
                    },
                    {
                        "id": 20099,
                        "name": "Shilaorencun",
                        "latitude": "36.09723000",
                        "longitude": "120.48910000"
                    },
                    {
                        "id": 20110,
                        "name": "Shizilu",
                        "latitude": "35.17111000",
                        "longitude": "118.82889000"
                    },
                    {
                        "id": 20112,
                        "name": "Shouguang",
                        "latitude": "36.88000000",
                        "longitude": "118.73750000"
                    },
                    {
                        "id": 20131,
                        "name": "Sishui",
                        "latitude": "35.64889000",
                        "longitude": "117.27583000"
                    },
                    {
                        "id": 20148,
                        "name": "Suozhen",
                        "latitude": "36.95389000",
                        "longitude": "118.10472000"
                    },
                    {
                        "id": 20165,
                        "name": "Tai’an",
                        "latitude": "36.18528000",
                        "longitude": "117.12000000"
                    },
                    {
                        "id": 20176,
                        "name": "Taozhuang",
                        "latitude": "34.85000000",
                        "longitude": "117.33333000"
                    },
                    {
                        "id": 20179,
                        "name": "Tianfu",
                        "latitude": "37.19723000",
                        "longitude": "122.05228000"
                    },
                    {
                        "id": 20213,
                        "name": "Weifang",
                        "latitude": "36.71000000",
                        "longitude": "119.10194000"
                    },
                    {
                        "id": 20214,
                        "name": "Weihai",
                        "latitude": "37.50914000",
                        "longitude": "122.11356000"
                    },
                    {
                        "id": 20223,
                        "name": "Wenshang",
                        "latitude": "35.72750000",
                        "longitude": "116.49611000"
                    },
                    {
                        "id": 20277,
                        "name": "Xiazhen",
                        "latitude": "34.80222000",
                        "longitude": "117.11167000"
                    },
                    {
                        "id": 20278,
                        "name": "Xiazhuang",
                        "latitude": "34.91611000",
                        "longitude": "118.63889000"
                    },
                    {
                        "id": 20283,
                        "name": "Xiliguantun",
                        "latitude": "37.07833000",
                        "longitude": "115.94139000"
                    },
                    {
                        "id": 20291,
                        "name": "Xindian",
                        "latitude": "36.79750000",
                        "longitude": "118.29444000"
                    },
                    {
                        "id": 20306,
                        "name": "Xintai",
                        "latitude": "35.90056000",
                        "longitude": "117.75194000"
                    },
                    {
                        "id": 20342,
                        "name": "Yanggu",
                        "latitude": "36.11056000",
                        "longitude": "115.77528000"
                    },
                    {
                        "id": 20355,
                        "name": "Yanta",
                        "latitude": "36.24111000",
                        "longitude": "115.66722000"
                    },
                    {
                        "id": 20356,
                        "name": "Yantai",
                        "latitude": "37.47649000",
                        "longitude": "121.44081000"
                    },
                    {
                        "id": 20359,
                        "name": "Yanzhou",
                        "latitude": "35.55278000",
                        "longitude": "116.82861000"
                    },
                    {
                        "id": 20362,
                        "name": "Yatou",
                        "latitude": "37.15660000",
                        "longitude": "122.43762000"
                    },
                    {
                        "id": 20381,
                        "name": "Yinzhu",
                        "latitude": "35.87861000",
                        "longitude": "119.97528000"
                    },
                    {
                        "id": 20382,
                        "name": "Yishui",
                        "latitude": "35.78472000",
                        "longitude": "118.62806000"
                    },
                    {
                        "id": 20393,
                        "name": "Yucheng",
                        "latitude": "34.92889000",
                        "longitude": "116.46528000"
                    },
                    {
                        "id": 20415,
                        "name": "Zaozhuang",
                        "latitude": "34.86472000",
                        "longitude": "117.55417000"
                    },
                    {
                        "id": 20435,
                        "name": "Zhaoyuan",
                        "latitude": "37.36497000",
                        "longitude": "120.40997000"
                    },
                    {
                        "id": 20458,
                        "name": "Zhoucheng",
                        "latitude": "35.91222000",
                        "longitude": "116.31167000"
                    },
                    {
                        "id": 20459,
                        "name": "Zhoucun",
                        "latitude": "36.81667000",
                        "longitude": "117.81667000"
                    },
                    {
                        "id": 20463,
                        "name": "Zhu Cheng City",
                        "latitude": "35.99502000",
                        "longitude": "119.40259000"
                    },
                    {
                        "id": 20465,
                        "name": "Zhuangyuan",
                        "latitude": "37.30553000",
                        "longitude": "120.82747000"
                    },
                    {
                        "id": 20478,
                        "name": "Zibo",
                        "latitude": "36.79056000",
                        "longitude": "118.06333000"
                    },
                    {
                        "id": 20481,
                        "name": "Zoucheng",
                        "latitude": "35.40056000",
                        "longitude": "116.96556000"
                    }
                ]
            },
            {
                "id": 2249,
                "name": "Shanghai",
                "iso2": "SH",
                "latitude": "31.23041600",
                "longitude": "121.47370100",
                "type": "municipality",
                "cities": [
                    {
                        "id": 20063,
                        "name": "Shanghai",
                        "latitude": "31.22222000",
                        "longitude": "121.45806000"
                    },
                    {
                        "id": 20132,
                        "name": "Songjiang",
                        "latitude": "31.03595000",
                        "longitude": "121.21460000"
                    },
                    {
                        "id": 20417,
                        "name": "Zhabei",
                        "latitude": "31.25861000",
                        "longitude": "121.45972000"
                    },
                    {
                        "id": 20469,
                        "name": "Zhujiajiao",
                        "latitude": "31.10757000",
                        "longitude": "121.05696000"
                    }
                ]
            },
            {
                "id": 2254,
                "name": "Shanxi",
                "iso2": "SX",
                "latitude": "37.24256490",
                "longitude": "111.85685860",
                "type": "province",
                "cities": [
                    {
                        "id": 19378,
                        "name": "Changzhi",
                        "latitude": "36.18389000",
                        "longitude": "113.10528000"
                    },
                    {
                        "id": 19436,
                        "name": "Datong",
                        "latitude": "40.09361000",
                        "longitude": "113.29139000"
                    },
                    {
                        "id": 19437,
                        "name": "Datong Shi",
                        "latitude": "40.10484000",
                        "longitude": "113.63334000"
                    },
                    {
                        "id": 19580,
                        "name": "Gutao",
                        "latitude": "37.20250000",
                        "longitude": "112.17806000"
                    },
                    {
                        "id": 19722,
                        "name": "Jiexiu",
                        "latitude": "37.02444000",
                        "longitude": "111.91250000"
                    },
                    {
                        "id": 19729,
                        "name": "Jincheng",
                        "latitude": "35.50222000",
                        "longitude": "112.83278000"
                    },
                    {
                        "id": 19751,
                        "name": "Jinzhong Shi",
                        "latitude": "37.43597000",
                        "longitude": "113.08783000"
                    },
                    {
                        "id": 19838,
                        "name": "Linfen",
                        "latitude": "36.08889000",
                        "longitude": "111.51889000"
                    },
                    {
                        "id": 19896,
                        "name": "Lüliang",
                        "latitude": "37.73563000",
                        "longitude": "111.30538000"
                    },
                    {
                        "id": 20127,
                        "name": "Shuozhou",
                        "latitude": "39.31583000",
                        "longitude": "112.42250000"
                    },
                    {
                        "id": 20162,
                        "name": "Taiyuan",
                        "latitude": "37.86944000",
                        "longitude": "112.56028000"
                    },
                    {
                        "id": 20307,
                        "name": "Xintian",
                        "latitude": "35.61358000",
                        "longitude": "111.35660000"
                    },
                    {
                        "id": 20316,
                        "name": "Xinzhi",
                        "latitude": "36.49889000",
                        "longitude": "111.70472000"
                    },
                    {
                        "id": 20318,
                        "name": "Xinzhou",
                        "latitude": "38.40917000",
                        "longitude": "112.73333000"
                    },
                    {
                        "id": 20345,
                        "name": "Yangquan",
                        "latitude": "37.85750000",
                        "longitude": "113.56333000"
                    },
                    {
                        "id": 20391,
                        "name": "Yuanping",
                        "latitude": "38.71528000",
                        "longitude": "112.75750000"
                    },
                    {
                        "id": 20394,
                        "name": "Yuci",
                        "latitude": "37.68028000",
                        "longitude": "112.73194000"
                    },
                    {
                        "id": 20400,
                        "name": "Yuncheng",
                        "latitude": "35.02306000",
                        "longitude": "110.99278000"
                    }
                ]
            },
            {
                "id": 2277,
                "name": "Sichuan",
                "iso2": "SC",
                "latitude": "30.26380320",
                "longitude": "102.80547530",
                "type": "province",
                "cities": [
                    {
                        "id": 19271,
                        "name": "Aba Zangzu Qiangzu Zizhizhou",
                        "latitude": "32.41875000",
                        "longitude": "102.63664000"
                    },
                    {
                        "id": 19320,
                        "name": "Barkam",
                        "latitude": "31.90059000",
                        "longitude": "102.22092000"
                    },
                    {
                        "id": 19326,
                        "name": "Bazhong Shi",
                        "latitude": "32.04025000",
                        "longitude": "107.06230000"
                    },
                    {
                        "id": 19362,
                        "name": "Changchi",
                        "latitude": "32.16377000",
                        "longitude": "106.65814000"
                    },
                    {
                        "id": 19387,
                        "name": "Chengdu",
                        "latitude": "30.66667000",
                        "longitude": "104.06667000"
                    },
                    {
                        "id": 19403,
                        "name": "Chonglong",
                        "latitude": "29.78062000",
                        "longitude": "104.85224000"
                    },
                    {
                        "id": 19416,
                        "name": "Dadukou",
                        "latitude": "26.54790000",
                        "longitude": "101.70539000"
                    },
                    {
                        "id": 19443,
                        "name": "Dazhou",
                        "latitude": "31.21592000",
                        "longitude": "107.50092000"
                    },
                    {
                        "id": 19454,
                        "name": "Deyang",
                        "latitude": "31.13019000",
                        "longitude": "104.38198000"
                    },
                    {
                        "id": 19478,
                        "name": "Dongxi",
                        "latitude": "32.06577000",
                        "longitude": "106.24843000"
                    },
                    {
                        "id": 19500,
                        "name": "Fangting",
                        "latitude": "31.12766000",
                        "longitude": "104.16649000"
                    },
                    {
                        "id": 19516,
                        "name": "Fubao",
                        "latitude": "28.76905000",
                        "longitude": "106.07667000"
                    },
                    {
                        "id": 19543,
                        "name": "Gaoping",
                        "latitude": "30.77576000",
                        "longitude": "106.10294000"
                    },
                    {
                        "id": 19551,
                        "name": "Garzê Zangzu Zizhizhou",
                        "latitude": "31.02407000",
                        "longitude": "100.40553000"
                    },
                    {
                        "id": 19564,
                        "name": "Guang’an",
                        "latitude": "30.47413000",
                        "longitude": "106.63696000"
                    },
                    {
                        "id": 19561,
                        "name": "Guangyuan",
                        "latitude": "32.44201000",
                        "longitude": "105.82300000"
                    },
                    {
                        "id": 19695,
                        "name": "Jiancheng",
                        "latitude": "30.39097000",
                        "longitude": "104.54912000"
                    },
                    {
                        "id": 19704,
                        "name": "Jiangyou",
                        "latitude": "31.76667000",
                        "longitude": "104.71667000"
                    },
                    {
                        "id": 19707,
                        "name": "Jiannan",
                        "latitude": "31.34355000",
                        "longitude": "104.19588000"
                    },
                    {
                        "id": 19772,
                        "name": "Kangding",
                        "latitude": "30.00222000",
                        "longitude": "101.95690000"
                    },
                    {
                        "id": 19798,
                        "name": "Langzhong",
                        "latitude": "31.55037000",
                        "longitude": "105.99381000"
                    },
                    {
                        "id": 19811,
                        "name": "Leshan",
                        "latitude": "29.56227000",
                        "longitude": "103.76386000"
                    },
                    {
                        "id": 19816,
                        "name": "Liangshan Yizu Zizhizhou",
                        "latitude": "27.87644000",
                        "longitude": "102.10180000"
                    },
                    {
                        "id": 19849,
                        "name": "Linqiong",
                        "latitude": "30.41587000",
                        "longitude": "103.46089000"
                    },
                    {
                        "id": 19882,
                        "name": "Luocheng",
                        "latitude": "30.98021000",
                        "longitude": "104.28081000"
                    },
                    {
                        "id": 19894,
                        "name": "Luzhou",
                        "latitude": "28.89030000",
                        "longitude": "105.42575000"
                    },
                    {
                        "id": 19912,
                        "name": "Meishan Shi",
                        "latitude": "30.03000000",
                        "longitude": "104.04000000"
                    },
                    {
                        "id": 19917,
                        "name": "Mianyang",
                        "latitude": "31.46784000",
                        "longitude": "104.68168000"
                    },
                    {
                        "id": 19936,
                        "name": "Nanchong",
                        "latitude": "30.79508000",
                        "longitude": "106.08473000"
                    },
                    {
                        "id": 19942,
                        "name": "Nanlong",
                        "latitude": "31.35333000",
                        "longitude": "106.06309000"
                    },
                    {
                        "id": 19954,
                        "name": "Neijiang",
                        "latitude": "29.58354000",
                        "longitude": "105.06216000"
                    },
                    {
                        "id": 19975,
                        "name": "Panzhihua",
                        "latitude": "26.58509000",
                        "longitude": "101.71276000"
                    },
                    {
                        "id": 19992,
                        "name": "Puji",
                        "latitude": "32.23908000",
                        "longitude": "106.45478000"
                    },
                    {
                        "id": 20115,
                        "name": "Shuanghejiedao",
                        "latitude": "30.37448000",
                        "longitude": "106.77266000"
                    },
                    {
                        "id": 20143,
                        "name": "Suining",
                        "latitude": "30.50802000",
                        "longitude": "105.57332000"
                    },
                    {
                        "id": 20155,
                        "name": "Taihe",
                        "latitude": "30.87123000",
                        "longitude": "105.38454000"
                    },
                    {
                        "id": 20159,
                        "name": "Taiping",
                        "latitude": "28.14083000",
                        "longitude": "106.03771000"
                    },
                    {
                        "id": 20180,
                        "name": "Tianpeng",
                        "latitude": "30.98664000",
                        "longitude": "103.93933000"
                    },
                    {
                        "id": 20187,
                        "name": "Tongchuan",
                        "latitude": "31.09407000",
                        "longitude": "105.08731000"
                    },
                    {
                        "id": 20251,
                        "name": "Xialiang",
                        "latitude": "32.07673000",
                        "longitude": "106.77151000"
                    },
                    {
                        "id": 20265,
                        "name": "Xiantan",
                        "latitude": "28.81859000",
                        "longitude": "106.19270000"
                    },
                    {
                        "id": 20280,
                        "name": "Xichang",
                        "latitude": "27.89642000",
                        "longitude": "102.26341000"
                    },
                    {
                        "id": 20335,
                        "name": "Xunchang",
                        "latitude": "28.45433000",
                        "longitude": "104.71498000"
                    },
                    {
                        "id": 20351,
                        "name": "Yanjiang",
                        "latitude": "30.12108000",
                        "longitude": "104.64811000"
                    },
                    {
                        "id": 20365,
                        "name": "Yibin",
                        "latitude": "28.76667000",
                        "longitude": "104.62383000"
                    },
                    {
                        "id": 20392,
                        "name": "Yucheng",
                        "latitude": "29.98521000",
                        "longitude": "102.99900000"
                    },
                    {
                        "id": 20416,
                        "name": "Zengjia",
                        "latitude": "32.61957000",
                        "longitude": "106.10118000"
                    },
                    {
                        "id": 20447,
                        "name": "Zhongba",
                        "latitude": "31.77819000",
                        "longitude": "104.73932000"
                    },
                    {
                        "id": 20479,
                        "name": "Zigong",
                        "latitude": "29.34162000",
                        "longitude": "104.77689000"
                    }
                ]
            },
            {
                "id": 2255,
                "name": "Taiwan",
                "iso2": "TW",
                "latitude": "23.69781000",
                "longitude": "120.96051500",
                "type": "province",
                "cities": [
                    {
                        "id": 19319,
                        "name": "Baoying",
                        "latitude": "33.22917000",
                        "longitude": "119.30917000"
                    },
                    {
                        "id": 19376,
                        "name": "Changshu City",
                        "latitude": "31.64615000",
                        "longitude": "120.74221000"
                    },
                    {
                        "id": 19379,
                        "name": "Changzhou",
                        "latitude": "31.77359000",
                        "longitude": "119.95401000"
                    },
                    {
                        "id": 19394,
                        "name": "Chengxiang",
                        "latitude": "31.44778000",
                        "longitude": "121.09389000"
                    },
                    {
                        "id": 19442,
                        "name": "Dazhong",
                        "latitude": "33.19973000",
                        "longitude": "120.45780000"
                    },
                    {
                        "id": 19470,
                        "name": "Dongkan",
                        "latitude": "33.99972000",
                        "longitude": "119.83083000"
                    },
                    {
                        "id": 19477,
                        "name": "Dongtai",
                        "latitude": "32.85231000",
                        "longitude": "120.30947000"
                    },
                    {
                        "id": 19510,
                        "name": "Fengxian",
                        "latitude": "34.70388000",
                        "longitude": "116.58717000"
                    },
                    {
                        "id": 19540,
                        "name": "Gaogou",
                        "latitude": "34.01750000",
                        "longitude": "119.18861000"
                    },
                    {
                        "id": 19548,
                        "name": "Gaoyou",
                        "latitude": "32.78933000",
                        "longitude": "119.44182000"
                    },
                    {
                        "id": 19573,
                        "name": "Guiren",
                        "latitude": "33.66972000",
                        "longitude": "118.18889000"
                    },
                    {
                        "id": 19606,
                        "name": "Hede",
                        "latitude": "33.77220000",
                        "longitude": "120.26176000"
                    },
                    {
                        "id": 19635,
                        "name": "Huai'an",
                        "latitude": "33.58861000",
                        "longitude": "119.01917000"
                    },
                    {
                        "id": 19644,
                        "name": "Huai’an Shi",
                        "latitude": "33.31162000",
                        "longitude": "119.04559000"
                    },
                    {
                        "id": 19673,
                        "name": "Huilong",
                        "latitude": "31.81111000",
                        "longitude": "121.65500000"
                    },
                    {
                        "id": 19688,
                        "name": "Hutang",
                        "latitude": "31.53429000",
                        "longitude": "119.49000000"
                    },
                    {
                        "id": 19702,
                        "name": "Jiangyan",
                        "latitude": "32.50611000",
                        "longitude": "120.14278000"
                    },
                    {
                        "id": 19703,
                        "name": "Jiangyin",
                        "latitude": "31.91102000",
                        "longitude": "120.26302000"
                    },
                    {
                        "id": 19747,
                        "name": "Jinsha",
                        "latitude": "32.08982000",
                        "longitude": "121.07355000"
                    },
                    {
                        "id": 19764,
                        "name": "Juegang",
                        "latitude": "32.31737000",
                        "longitude": "121.18552000"
                    },
                    {
                        "id": 19784,
                        "name": "Kunshan",
                        "latitude": "31.37762000",
                        "longitude": "120.95431000"
                    },
                    {
                        "id": 19825,
                        "name": "Lianyungang Shi",
                        "latitude": "34.54844000",
                        "longitude": "119.11228000"
                    },
                    {
                        "id": 19832,
                        "name": "Licheng",
                        "latitude": "31.42813000",
                        "longitude": "119.48353000"
                    },
                    {
                        "id": 19930,
                        "name": "Mudu",
                        "latitude": "31.25597000",
                        "longitude": "120.51857000"
                    },
                    {
                        "id": 19941,
                        "name": "Nanjing",
                        "latitude": "32.06167000",
                        "longitude": "118.77778000"
                    },
                    {
                        "id": 19949,
                        "name": "Nantong",
                        "latitude": "32.03028000",
                        "longitude": "120.87472000"
                    },
                    {
                        "id": 19987,
                        "name": "Pizhou",
                        "latitude": "34.31139000",
                        "longitude": "117.95028000"
                    },
                    {
                        "id": 20030,
                        "name": "Qinnan",
                        "latitude": "33.25306000",
                        "longitude": "119.91333000"
                    },
                    {
                        "id": 20044,
                        "name": "Rucheng",
                        "latitude": "32.38833000",
                        "longitude": "120.55528000"
                    },
                    {
                        "id": 20054,
                        "name": "Sanmao",
                        "latitude": "32.23931000",
                        "longitude": "119.81536000"
                    },
                    {
                        "id": 20136,
                        "name": "Songling",
                        "latitude": "31.19330000",
                        "longitude": "120.71758000"
                    },
                    {
                        "id": 20139,
                        "name": "Suicheng",
                        "latitude": "33.89630000",
                        "longitude": "117.93307000"
                    },
                    {
                        "id": 20150,
                        "name": "Suzhou",
                        "latitude": "31.30408000",
                        "longitude": "120.59538000"
                    },
                    {
                        "id": 20161,
                        "name": "Taixing",
                        "latitude": "32.16667000",
                        "longitude": "120.01361000"
                    },
                    {
                        "id": 20163,
                        "name": "Taizhou",
                        "latitude": "32.49069000",
                        "longitude": "119.90812000"
                    },
                    {
                        "id": 20195,
                        "name": "Tongshan",
                        "latitude": "34.18045000",
                        "longitude": "117.15707000"
                    },
                    {
                        "id": 20239,
                        "name": "Wuxi",
                        "latitude": "31.56887000",
                        "longitude": "120.28857000"
                    },
                    {
                        "id": 20263,
                        "name": "Xiannü",
                        "latitude": "32.42806000",
                        "longitude": "119.56048000"
                    },
                    {
                        "id": 20271,
                        "name": "Xiaolingwei",
                        "latitude": "32.03244000",
                        "longitude": "118.85400000"
                    },
                    {
                        "id": 20294,
                        "name": "Xinghua",
                        "latitude": "32.93917000",
                        "longitude": "119.83417000"
                    },
                    {
                        "id": 20303,
                        "name": "Xinpu",
                        "latitude": "34.59972000",
                        "longitude": "119.15944000"
                    },
                    {
                        "id": 20340,
                        "name": "Yancheng",
                        "latitude": "33.35750000",
                        "longitude": "120.15730000"
                    },
                    {
                        "id": 20349,
                        "name": "Yangzhou",
                        "latitude": "32.39722000",
                        "longitude": "119.43583000"
                    },
                    {
                        "id": 20368,
                        "name": "Yicheng",
                        "latitude": "31.36059000",
                        "longitude": "119.82016000"
                    },
                    {
                        "id": 20405,
                        "name": "Yushan",
                        "latitude": "31.67748000",
                        "longitude": "120.80134000"
                    },
                    {
                        "id": 20420,
                        "name": "Zhangjiagang",
                        "latitude": "31.86500000",
                        "longitude": "120.53889000"
                    },
                    {
                        "id": 20441,
                        "name": "Zhenjiang",
                        "latitude": "32.21086000",
                        "longitude": "119.45508000"
                    },
                    {
                        "id": 20443,
                        "name": "Zhenzhou",
                        "latitude": "32.28034000",
                        "longitude": "119.16999000"
                    },
                    {
                        "id": 20456,
                        "name": "Zhongxing",
                        "latitude": "33.70389000",
                        "longitude": "118.67917000"
                    },
                    {
                        "id": 20462,
                        "name": "Zhouzhuang",
                        "latitude": "31.11788000",
                        "longitude": "120.84427000"
                    }
                ]
            },
            {
                "id": 2276,
                "name": "Tianjin",
                "iso2": "TJ",
                "latitude": "39.12522910",
                "longitude": "117.01534350",
                "type": "municipality",
                "cities": [
                    {
                        "id": 149146,
                        "name": "Badaogu",
                        "latitude": "39.47333333",
                        "longitude": "117.32972222"
                    },
                    {
                        "id": 149147,
                        "name": "Baijian",
                        "latitude": "39.99416667",
                        "longitude": "117.20861111"
                    },
                    {
                        "id": 149148,
                        "name": "Bamencheng",
                        "latitude": "39.57777778",
                        "longitude": "117.60527778"
                    },
                    {
                        "id": 149149,
                        "name": "Bangjun",
                        "latitude": "39.98839000",
                        "longitude": "117.26850000"
                    },
                    {
                        "id": 149150,
                        "name": "Beicang",
                        "latitude": "39.23007000",
                        "longitude": "117.11892000"
                    },
                    {
                        "id": 149151,
                        "name": "Beihuaidian",
                        "latitude": "39.26220000",
                        "longitude": "117.57485000"
                    },
                    {
                        "id": 149152,
                        "name": "Beilizigu",
                        "latitude": "39.49138889",
                        "longitude": "117.46500000"
                    },
                    {
                        "id": 149153,
                        "name": "Biaokou",
                        "latitude": "39.32950000",
                        "longitude": "117.56914000"
                    },
                    {
                        "id": 149154,
                        "name": "Binhai New Area",
                        "latitude": "39.00333333",
                        "longitude": "117.71083333"
                    },
                    {
                        "id": 149155,
                        "name": "Caijiapu",
                        "latitude": "39.17305556",
                        "longitude": "117.81055556"
                    },
                    {
                        "id": 149156,
                        "name": "Caodian",
                        "latitude": "39.61194444",
                        "longitude": "117.47166667"
                    },
                    {
                        "id": 149157,
                        "name": "Chabaihu",
                        "latitude": "39.46555556",
                        "longitude": "117.14833333"
                    },
                    {
                        "id": 149158,
                        "name": "Changtun",
                        "latitude": "39.44333333",
                        "longitude": "117.07055556"
                    },
                    {
                        "id": 149159,
                        "name": "Chengtougu",
                        "latitude": "39.14000000",
                        "longitude": "117.77888889"
                    },
                    {
                        "id": 149160,
                        "name": "Chitu",
                        "latitude": "39.20333333",
                        "longitude": "117.40277778"
                    },
                    {
                        "id": 149161,
                        "name": "Cuijiamatou",
                        "latitude": "39.07472222",
                        "longitude": "117.30055556"
                    },
                    {
                        "id": 149162,
                        "name": "Dadunqiu",
                        "latitude": "39.40611111",
                        "longitude": "117.03305556"
                    },
                    {
                        "id": 149163,
                        "name": "Dakoutun",
                        "latitude": "39.58555556",
                        "longitude": "117.23638889"
                    },
                    {
                        "id": 149164,
                        "name": "Dashentang",
                        "latitude": "39.21722222",
                        "longitude": "117.95250000"
                    },
                    {
                        "id": 149165,
                        "name": "Dawangtai",
                        "latitude": "39.27500000",
                        "longitude": "117.48500000"
                    },
                    {
                        "id": 149166,
                        "name": "Daxinzhuang",
                        "latitude": "39.50361111",
                        "longitude": "117.68611111"
                    },
                    {
                        "id": 149167,
                        "name": "Dazhongzhuang",
                        "latitude": "39.68083333",
                        "longitude": "117.56416667"
                    },
                    {
                        "id": 149168,
                        "name": "Dongditou",
                        "latitude": "39.26638889",
                        "longitude": "117.37277778"
                    },
                    {
                        "id": 149169,
                        "name": "Dongshigu",
                        "latitude": "39.87889000",
                        "longitude": "117.33028000"
                    },
                    {
                        "id": 149170,
                        "name": "Erwangzhuang",
                        "latitude": "39.39166667",
                        "longitude": "117.35388889"
                    },
                    {
                        "id": 149171,
                        "name": "Fanzhuang",
                        "latitude": "39.19361111",
                        "longitude": "117.33500000"
                    },
                    {
                        "id": 149172,
                        "name": "Fengtai (Ninghe)",
                        "latitude": "39.55805556",
                        "longitude": "117.74916667"
                    },
                    {
                        "id": 149173,
                        "name": "Fuzhuang",
                        "latitude": "39.26611111",
                        "longitude": "117.93444444"
                    },
                    {
                        "id": 149174,
                        "name": "Gaojingzhuang",
                        "latitude": "39.41611111",
                        "longitude": "117.63000000"
                    },
                    {
                        "id": 149175,
                        "name": "Hanjiashu",
                        "latitude": "39.18750000",
                        "longitude": "117.07305556"
                    },
                    {
                        "id": 149176,
                        "name": "Hebeitun",
                        "latitude": "39.57472222",
                        "longitude": "117.11333333"
                    },
                    {
                        "id": 149177,
                        "name": "Hexiwu",
                        "latitude": "39.62249000",
                        "longitude": "116.95398000"
                    },
                    {
                        "id": 149178,
                        "name": "Huangcaotuo",
                        "latitude": "39.17944444",
                        "longitude": "117.32166667"
                    },
                    {
                        "id": 149179,
                        "name": "Huantuo",
                        "latitude": "39.22638889",
                        "longitude": "117.32388889"
                    },
                    {
                        "id": 149180,
                        "name": "Huogezhuang",
                        "latitude": "39.74388889",
                        "longitude": "117.36750000"
                    },
                    {
                        "id": 149181,
                        "name": "Jiangwakou",
                        "latitude": "39.52250000",
                        "longitude": "117.70250000"
                    },
                    {
                        "id": 149183,
                        "name": "Lianzhuang",
                        "latitude": "39.41000000",
                        "longitude": "117.75638889"
                    },
                    {
                        "id": 149184,
                        "name": "Lintingkou",
                        "latitude": "39.63027778",
                        "longitude": "117.50027778"
                    },
                    {
                        "id": 149185,
                        "name": "Liujiading",
                        "latitude": "39.96305556",
                        "longitude": "117.19111111"
                    },
                    {
                        "id": 149186,
                        "name": "Liukuaizhuang",
                        "latitude": "39.24777778",
                        "longitude": "117.33944444"
                    },
                    {
                        "id": 149187,
                        "name": "Liuzikou",
                        "latitude": "39.87027778",
                        "longitude": "117.34666667"
                    },
                    {
                        "id": 149188,
                        "name": "Luotuofangzi",
                        "latitude": "39.08361111",
                        "longitude": "117.37694444"
                    },
                    {
                        "id": 149189,
                        "name": "Meichang",
                        "latitude": "39.36611111",
                        "longitude": "117.18055556"
                    },
                    {
                        "id": 149190,
                        "name": "Mengquan",
                        "latitude": "39.82527778",
                        "longitude": "117.47666667"
                    },
                    {
                        "id": 149191,
                        "name": "Panzhuang",
                        "latitude": "39.33943000",
                        "longitude": "117.46820000"
                    },
                    {
                        "id": 149192,
                        "name": "Qingguang",
                        "latitude": "39.19668000",
                        "longitude": "117.05475000"
                    },
                    {
                        "id": 149193,
                        "name": "Sangzi",
                        "latitude": "39.90853000",
                        "longitude": "117.16535000"
                    },
                    {
                        "id": 149194,
                        "name": "Shangcang",
                        "latitude": "39.90518000",
                        "longitude": "117.39553000"
                    },
                    {
                        "id": 149195,
                        "name": "Shimianzhuang",
                        "latitude": "39.41800000",
                        "longitude": "117.15690000"
                    },
                    {
                        "id": 149196,
                        "name": "Shuangjiang",
                        "latitude": "39.04190000",
                        "longitude": "117.31235000"
                    },
                    {
                        "id": 149197,
                        "name": "Sigaozhuang",
                        "latitude": "39.46713000",
                        "longitude": "117.25554000"
                    },
                    {
                        "id": 149198,
                        "name": "Tianjin",
                        "latitude": "39.14666667",
                        "longitude": "117.20555556"
                    },
                    {
                        "id": 149199,
                        "name": "Touying",
                        "latitude": "39.96389000",
                        "longitude": "117.21833000"
                    },
                    {
                        "id": 149200,
                        "name": "Wangqinzhuang",
                        "latitude": "39.22942000",
                        "longitude": "117.08968000"
                    },
                    {
                        "id": 149201,
                        "name": "Weiwangzhuang",
                        "latitude": "39.02500000",
                        "longitude": "117.44083000"
                    },
                    {
                        "id": 149202,
                        "name": "Xiawuqi",
                        "latitude": "39.61551000",
                        "longitude": "117.05523000"
                    },
                    {
                        "id": 149203,
                        "name": "Xiditou",
                        "latitude": "39.25320000",
                        "longitude": "117.34709000"
                    },
                    {
                        "id": 149204,
                        "name": "Xinkaikou",
                        "latitude": "39.67996000",
                        "longitude": "117.18877000"
                    },
                    {
                        "id": 149205,
                        "name": "Xitazhuang",
                        "latitude": "39.93306000",
                        "longitude": "117.21083000"
                    },
                    {
                        "id": 149206,
                        "name": "Yangjinzhuang",
                        "latitude": "39.86645000",
                        "longitude": "117.42592000"
                    },
                    {
                        "id": 149207,
                        "name": "Yangliuqing",
                        "latitude": "39.12740000",
                        "longitude": "117.00885000"
                    },
                    {
                        "id": 149208,
                        "name": "Yinliu",
                        "latitude": "39.98349000",
                        "longitude": "117.39904000"
                    },
                    {
                        "id": 149209,
                        "name": "Yixingfu",
                        "latitude": "39.19917000",
                        "longitude": "117.21139000"
                    },
                    {
                        "id": 149210,
                        "name": "Youguzhuang",
                        "latitude": "39.90802000",
                        "longitude": "117.24576000"
                    },
                    {
                        "id": 149211,
                        "name": "Yuelongzhuang",
                        "latitude": "39.56833000",
                        "longitude": "117.85417000"
                    },
                    {
                        "id": 149212,
                        "name": "Yuguzhuang",
                        "latitude": "39.64290000",
                        "longitude": "117.36470000"
                    },
                    {
                        "id": 149213,
                        "name": "Zaojiacheng",
                        "latitude": "39.28174000",
                        "longitude": "117.42516000"
                    },
                    {
                        "id": 149182,
                        "name": "Zhangjiawo",
                        "latitude": "39.05675000",
                        "longitude": "117.03624000"
                    },
                    {
                        "id": 149214,
                        "name": "Zhaoguli",
                        "latitude": "39.16673000",
                        "longitude": "117.24191000"
                    }
                ]
            },
            {
                "id": 2263,
                "name": "Xinjiang",
                "iso2": "XJ",
                "latitude": "42.52463570",
                "longitude": "87.53958550",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 19273,
                        "name": "Ailan Mubage",
                        "latitude": "43.90845000",
                        "longitude": "81.33299000"
                    },
                    {
                        "id": 19274,
                        "name": "Aksu",
                        "latitude": "41.18418000",
                        "longitude": "80.27921000"
                    },
                    {
                        "id": 19275,
                        "name": "Aksu Diqu",
                        "latitude": "40.55689000",
                        "longitude": "81.84629000"
                    },
                    {
                        "id": 19276,
                        "name": "Altay",
                        "latitude": "47.84864000",
                        "longitude": "88.13361000"
                    },
                    {
                        "id": 19277,
                        "name": "Altay Diqu",
                        "latitude": "47.86667000",
                        "longitude": "88.11667000"
                    },
                    {
                        "id": 19293,
                        "name": "Aral",
                        "latitude": "40.54184000",
                        "longitude": "81.26566000"
                    },
                    {
                        "id": 19294,
                        "name": "Aykol",
                        "latitude": "40.95759000",
                        "longitude": "80.13574000"
                    },
                    {
                        "id": 19300,
                        "name": "Baijiantan",
                        "latitude": "45.69298000",
                        "longitude": "85.13942000"
                    },
                    {
                        "id": 19311,
                        "name": "Baluntaicun",
                        "latitude": "42.66842000",
                        "longitude": "86.32424000"
                    },
                    {
                        "id": 19325,
                        "name": "Bayingolin Mongol Zizhizhou",
                        "latitude": "41.73333000",
                        "longitude": "86.15000000"
                    },
                    {
                        "id": 19365,
                        "name": "Changji",
                        "latitude": "44.00782000",
                        "longitude": "87.30461000"
                    },
                    {
                        "id": 19366,
                        "name": "Changji Huizu Zizhizhou",
                        "latitude": "44.01667000",
                        "longitude": "87.31667000"
                    },
                    {
                        "id": 19519,
                        "name": "Fukang",
                        "latitude": "44.15874000",
                        "longitude": "87.97418000"
                    },
                    {
                        "id": 19593,
                        "name": "Hami",
                        "latitude": "42.83393000",
                        "longitude": "93.50601000"
                    },
                    {
                        "id": 19631,
                        "name": "Hotan",
                        "latitude": "37.10750000",
                        "longitude": "79.93548000"
                    },
                    {
                        "id": 19633,
                        "name": "Hoxtolgay",
                        "latitude": "46.51872000",
                        "longitude": "86.00214000"
                    },
                    {
                        "id": 19683,
                        "name": "Huocheng",
                        "latitude": "44.05305000",
                        "longitude": "80.87173000"
                    },
                    {
                        "id": 19690,
                        "name": "Ili Kazak Zizhizhou",
                        "latitude": "43.31211000",
                        "longitude": "82.27102000"
                    },
                    {
                        "id": 19773,
                        "name": "Karamay",
                        "latitude": "45.58473000",
                        "longitude": "84.88724000"
                    },
                    {
                        "id": 19774,
                        "name": "Karamay Shi",
                        "latitude": "45.49989000",
                        "longitude": "84.91683000"
                    },
                    {
                        "id": 19775,
                        "name": "Kashgar",
                        "latitude": "39.47066000",
                        "longitude": "75.98951000"
                    },
                    {
                        "id": 19776,
                        "name": "Kaxgar Diqu",
                        "latitude": "39.47543000",
                        "longitude": "75.98968000"
                    },
                    {
                        "id": 19779,
                        "name": "Korla",
                        "latitude": "41.76055000",
                        "longitude": "86.15231000"
                    },
                    {
                        "id": 19786,
                        "name": "Kuqa",
                        "latitude": "41.71707000",
                        "longitude": "82.93064000"
                    },
                    {
                        "id": 19788,
                        "name": "Kuytun",
                        "latitude": "44.42707000",
                        "longitude": "84.90069000"
                    },
                    {
                        "id": 20005,
                        "name": "Qapqal",
                        "latitude": "43.80194000",
                        "longitude": "81.08722000"
                    },
                    {
                        "id": 20059,
                        "name": "Shache",
                        "latitude": "38.41667000",
                        "longitude": "77.24056000"
                    },
                    {
                        "id": 20093,
                        "name": "Shihezi",
                        "latitude": "44.30230000",
                        "longitude": "86.03694000"
                    },
                    {
                        "id": 20130,
                        "name": "Sishilichengzi",
                        "latitude": "41.96194000",
                        "longitude": "86.47667000"
                    },
                    {
                        "id": 20152,
                        "name": "Tacheng",
                        "latitude": "46.74535000",
                        "longitude": "82.95847000"
                    },
                    {
                        "id": 20153,
                        "name": "Tacheng Diqu",
                        "latitude": "46.75000000",
                        "longitude": "82.95000000"
                    },
                    {
                        "id": 20200,
                        "name": "Turpan",
                        "latitude": "42.94769000",
                        "longitude": "89.17886000"
                    },
                    {
                        "id": 20201,
                        "name": "Turpan Diqu",
                        "latitude": "42.93333000",
                        "longitude": "89.16667000"
                    },
                    {
                        "id": 20484,
                        "name": "Ürümqi",
                        "latitude": "43.80096000",
                        "longitude": "87.60046000"
                    },
                    {
                        "id": 20204,
                        "name": "Urumqi Shi",
                        "latitude": "43.80000000",
                        "longitude": "87.58333000"
                    },
                    {
                        "id": 20314,
                        "name": "Xinyuan",
                        "latitude": "43.42649000",
                        "longitude": "83.24959000"
                    },
                    {
                        "id": 20413,
                        "name": "Zangguy",
                        "latitude": "37.28333000",
                        "longitude": "78.76667000"
                    }
                ]
            },
            {
                "id": 2264,
                "name": "Xizang",
                "iso2": "XZ",
                "latitude": "30.15336050",
                "longitude": "88.78786780",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 19354,
                        "name": "Burang",
                        "latitude": "30.29559000",
                        "longitude": "81.17511000"
                    },
                    {
                        "id": 19488,
                        "name": "Dêqên",
                        "latitude": "29.96178000",
                        "longitude": "90.71875000"
                    },
                    {
                        "id": 19705,
                        "name": "Jiangzi",
                        "latitude": "28.92026000",
                        "longitude": "89.59956000"
                    },
                    {
                        "id": 19812,
                        "name": "Lhasa",
                        "latitude": "29.65000000",
                        "longitude": "91.10000000"
                    },
                    {
                        "id": 19933,
                        "name": "Nagqu",
                        "latitude": "31.47678000",
                        "longitude": "92.05729000"
                    },
                    {
                        "id": 19934,
                        "name": "Nagqu Diqu",
                        "latitude": "32.66357000",
                        "longitude": "88.93146000"
                    },
                    {
                        "id": 19957,
                        "name": "Ngari Diqu",
                        "latitude": "33.21836000",
                        "longitude": "82.57507000"
                    },
                    {
                        "id": 19966,
                        "name": "Nyingchi Prefecture",
                        "latitude": "29.60092000",
                        "longitude": "94.42406000"
                    },
                    {
                        "id": 20003,
                        "name": "Qamdo",
                        "latitude": "31.13040000",
                        "longitude": "97.17982000"
                    },
                    {
                        "id": 20004,
                        "name": "Qamdo Shi",
                        "latitude": "31.58370000",
                        "longitude": "97.22304000"
                    },
                    {
                        "id": 20041,
                        "name": "Rikaze",
                        "latitude": "29.25000000",
                        "longitude": "88.88333000"
                    },
                    {
                        "id": 20049,
                        "name": "Saga",
                        "latitude": "29.32367000",
                        "longitude": "85.22601000"
                    },
                    {
                        "id": 20074,
                        "name": "Shannan Diqu",
                        "latitude": "28.55630000",
                        "longitude": "92.55684000"
                    }
                ]
            },
            {
                "id": 2260,
                "name": "Yunnan",
                "iso2": "YN",
                "latitude": "24.47528470",
                "longitude": "101.34310580",
                "type": "province",
                "cities": [
                    {
                        "id": 19409,
                        "name": "Chuxiong Yizu Zizhizhou",
                        "latitude": "25.43204000",
                        "longitude": "101.70479000"
                    },
                    {
                        "id": 19419,
                        "name": "Dali",
                        "latitude": "25.58474000",
                        "longitude": "100.21229000"
                    },
                    {
                        "id": 19420,
                        "name": "Dali Baizu Zizhizhou",
                        "latitude": "25.68548000",
                        "longitude": "100.13104000"
                    },
                    {
                        "id": 19446,
                        "name": "Dehong Daizu Jingpozu Zizhizhou",
                        "latitude": "24.66347000",
                        "longitude": "98.03964000"
                    },
                    {
                        "id": 19489,
                        "name": "Dêqên Tibetan Autonomous Prefecture",
                        "latitude": "27.91694000",
                        "longitude": "99.54841000"
                    },
                    {
                        "id": 19552,
                        "name": "Gejiu",
                        "latitude": "23.36085000",
                        "longitude": "103.15372000"
                    },
                    {
                        "id": 19585,
                        "name": "Haikou",
                        "latitude": "24.77985000",
                        "longitude": "102.57548000"
                    },
                    {
                        "id": 19625,
                        "name": "Honghe Hanizu Yizu Zizhizhou",
                        "latitude": "23.51675000",
                        "longitude": "102.97389000"
                    },
                    {
                        "id": 19733,
                        "name": "Jinghong",
                        "latitude": "21.99102000",
                        "longitude": "100.73409000"
                    },
                    {
                        "id": 19767,
                        "name": "Kaihua",
                        "latitude": "23.36950000",
                        "longitude": "104.27721000"
                    },
                    {
                        "id": 19770,
                        "name": "Kaiyuan",
                        "latitude": "23.69767000",
                        "longitude": "103.30372000"
                    },
                    {
                        "id": 19783,
                        "name": "Kunming",
                        "latitude": "25.03889000",
                        "longitude": "102.71833000"
                    },
                    {
                        "id": 19822,
                        "name": "Lianran",
                        "latitude": "24.92271000",
                        "longitude": "102.48496000"
                    },
                    {
                        "id": 19835,
                        "name": "Lijiang",
                        "latitude": "26.86879000",
                        "longitude": "100.22072000"
                    },
                    {
                        "id": 19836,
                        "name": "Lincang Shi",
                        "latitude": "23.94803000",
                        "longitude": "99.55124000"
                    },
                    {
                        "id": 19872,
                        "name": "Longquan",
                        "latitude": "24.67193000",
                        "longitude": "102.16130000"
                    },
                    {
                        "id": 19899,
                        "name": "Mabai",
                        "latitude": "23.01279000",
                        "longitude": "104.45081000"
                    },
                    {
                        "id": 19901,
                        "name": "Majie",
                        "latitude": "25.03190000",
                        "longitude": "102.63800000"
                    },
                    {
                        "id": 19926,
                        "name": "Miyang",
                        "latitude": "24.40417000",
                        "longitude": "103.44278000"
                    },
                    {
                        "id": 19965,
                        "name": "Nujiang Lisuzu Zizhizhou",
                        "latitude": "26.61738000",
                        "longitude": "99.14062000"
                    },
                    {
                        "id": 20038,
                        "name": "Qujing",
                        "latitude": "25.48333000",
                        "longitude": "103.78333000"
                    },
                    {
                        "id": 20068,
                        "name": "Shangri-La",
                        "latitude": "27.82511000",
                        "longitude": "99.70779000"
                    },
                    {
                        "id": 20100,
                        "name": "Shilin",
                        "latitude": "24.81878000",
                        "longitude": "103.33237000"
                    },
                    {
                        "id": 20218,
                        "name": "Wenlan",
                        "latitude": "23.36002000",
                        "longitude": "103.43684000"
                    },
                    {
                        "id": 20221,
                        "name": "Wenshan City",
                        "latitude": "23.36306000",
                        "longitude": "104.25047000"
                    },
                    {
                        "id": 20222,
                        "name": "Wenshan Zhuangzu Miaozu Zizhizhou",
                        "latitude": "23.65130000",
                        "longitude": "104.70830000"
                    },
                    {
                        "id": 20409,
                        "name": "Yuxi",
                        "latitude": "24.35500000",
                        "longitude": "102.54222000"
                    },
                    {
                        "id": 20434,
                        "name": "Zhaotong",
                        "latitude": "27.31667000",
                        "longitude": "103.71667000"
                    },
                    {
                        "id": 20453,
                        "name": "Zhongshu",
                        "latitude": "24.51667000",
                        "longitude": "103.76667000"
                    }
                ]
            },
            {
                "id": 2247,
                "name": "Zhejiang",
                "iso2": "ZJ",
                "latitude": "29.14164320",
                "longitude": "119.78892480",
                "type": "province",
                "cities": [
                    {
                        "id": 19453,
                        "name": "Deqing",
                        "latitude": "30.54485000",
                        "longitude": "119.95990000"
                    },
                    {
                        "id": 19481,
                        "name": "Dongyang",
                        "latitude": "29.26778000",
                        "longitude": "120.22528000"
                    },
                    {
                        "id": 19505,
                        "name": "Fenghua",
                        "latitude": "29.65628000",
                        "longitude": "121.40640000"
                    },
                    {
                        "id": 19526,
                        "name": "Fuyang",
                        "latitude": "30.05333000",
                        "longitude": "119.95194000"
                    },
                    {
                        "id": 19576,
                        "name": "Guli",
                        "latitude": "28.88162000",
                        "longitude": "120.03308000"
                    },
                    {
                        "id": 19591,
                        "name": "Haining",
                        "latitude": "30.53629000",
                        "longitude": "120.68638000"
                    },
                    {
                        "id": 19598,
                        "name": "Hangzhou",
                        "latitude": "30.29365000",
                        "longitude": "120.16142000"
                    },
                    {
                        "id": 19662,
                        "name": "Huangyan",
                        "latitude": "28.65010000",
                        "longitude": "121.26591000"
                    },
                    {
                        "id": 19689,
                        "name": "Huzhou",
                        "latitude": "30.87030000",
                        "longitude": "120.09330000"
                    },
                    {
                        "id": 19710,
                        "name": "Jiaojiang",
                        "latitude": "28.69844000",
                        "longitude": "121.47331000"
                    },
                    {
                        "id": 19713,
                        "name": "Jiashan",
                        "latitude": "30.84918000",
                        "longitude": "120.92583000"
                    },
                    {
                        "id": 19714,
                        "name": "Jiaxing",
                        "latitude": "30.75220000",
                        "longitude": "120.75000000"
                    },
                    {
                        "id": 19715,
                        "name": "Jiaxing Shi",
                        "latitude": "30.77070000",
                        "longitude": "120.75238000"
                    },
                    {
                        "id": 19740,
                        "name": "Jinhua",
                        "latitude": "29.10678000",
                        "longitude": "119.64421000"
                    },
                    {
                        "id": 19750,
                        "name": "Jinxiang",
                        "latitude": "27.43265000",
                        "longitude": "120.60625000"
                    },
                    {
                        "id": 19785,
                        "name": "Kunyang",
                        "latitude": "27.66583000",
                        "longitude": "120.56583000"
                    },
                    {
                        "id": 19801,
                        "name": "Lanxi",
                        "latitude": "29.21588000",
                        "longitude": "119.47156000"
                    },
                    {
                        "id": 19814,
                        "name": "Lianghu",
                        "latitude": "29.99152000",
                        "longitude": "120.89845000"
                    },
                    {
                        "id": 19844,
                        "name": "Linhai",
                        "latitude": "28.85535000",
                        "longitude": "121.14470000"
                    },
                    {
                        "id": 19848,
                        "name": "Linping",
                        "latitude": "30.42250000",
                        "longitude": "120.29722000"
                    },
                    {
                        "id": 19858,
                        "name": "Lishui",
                        "latitude": "28.46042000",
                        "longitude": "119.91029000"
                    },
                    {
                        "id": 19891,
                        "name": "Luqiao",
                        "latitude": "28.58023000",
                        "longitude": "121.37491000"
                    },
                    {
                        "id": 19959,
                        "name": "Ningbo",
                        "latitude": "29.87819000",
                        "longitude": "121.54945000"
                    },
                    {
                        "id": 19961,
                        "name": "Ninghai",
                        "latitude": "29.28917000",
                        "longitude": "121.42472000"
                    },
                    {
                        "id": 19999,
                        "name": "Puyang",
                        "latitude": "29.45679000",
                        "longitude": "119.88872000"
                    },
                    {
                        "id": 20039,
                        "name": "Quzhou",
                        "latitude": "28.95944000",
                        "longitude": "118.86861000"
                    },
                    {
                        "id": 20069,
                        "name": "Shangyu",
                        "latitude": "30.01556000",
                        "longitude": "120.87111000"
                    },
                    {
                        "id": 20082,
                        "name": "Shaoxing",
                        "latitude": "30.00237000",
                        "longitude": "120.57864000"
                    },
                    {
                        "id": 20088,
                        "name": "Shenjiamen",
                        "latitude": "29.95763000",
                        "longitude": "122.29802000"
                    },
                    {
                        "id": 20164,
                        "name": "Taizhou",
                        "latitude": "28.66266000",
                        "longitude": "121.43312000"
                    },
                    {
                        "id": 20219,
                        "name": "Wenling",
                        "latitude": "28.37524000",
                        "longitude": "121.38416000"
                    },
                    {
                        "id": 20226,
                        "name": "Wenzhou",
                        "latitude": "27.99942000",
                        "longitude": "120.66682000"
                    },
                    {
                        "id": 20245,
                        "name": "Wuzhen",
                        "latitude": "30.74536000",
                        "longitude": "120.48510000"
                    },
                    {
                        "id": 20260,
                        "name": "Xianju",
                        "latitude": "28.85470000",
                        "longitude": "120.73168000"
                    },
                    {
                        "id": 20274,
                        "name": "Xiaoshan",
                        "latitude": "30.16746000",
                        "longitude": "120.25883000"
                    },
                    {
                        "id": 20383,
                        "name": "Yiwu",
                        "latitude": "29.31506000",
                        "longitude": "120.07676000"
                    },
                    {
                        "id": 20411,
                        "name": "Yuyao",
                        "latitude": "30.05000000",
                        "longitude": "121.14944000"
                    },
                    {
                        "id": 20430,
                        "name": "Zhaobaoshan",
                        "latitude": "29.96950000",
                        "longitude": "121.68753000"
                    },
                    {
                        "id": 20444,
                        "name": "Zhicheng",
                        "latitude": "31.00751000",
                        "longitude": "119.90851000"
                    },
                    {
                        "id": 20461,
                        "name": "Zhoushan",
                        "latitude": "29.98869000",
                        "longitude": "122.20488000"
                    },
                    {
                        "id": 20467,
                        "name": "Zhuji",
                        "latitude": "29.71877000",
                        "longitude": "120.24233000"
                    }
                ]
            }
        ]
    },
    {
        "id": 46,
        "name": "Christmas Island",
        "iso3": "CXR",
        "iso2": "CX",
        "numeric_code": "162",
        "phonecode": "61",
        "capital": "Flying Fish Cove",
        "currency": "AUD",
        "currency_name": "Australian dollar",
        "currency_symbol": "$",
        "tld": ".cx",
        "native": "Christmas Island",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Australia and New Zealand",
        "subregion_id": 19,
        "nationality": "Christmas Island",
        "timezones": [
            {
                "zoneName": "Indian\/Christmas",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "CXT",
                "tzName": "Christmas Island Time"
            }
        ],
        "translations": {
            "br": "Enez Christmas",
            "ko": "크리스마스 섬",
            "pt-BR": "Ilha Christmas",
            "pt": "Ilha do Natal",
            "nl": "Christmaseiland",
            "hr": "Božićni otok",
            "fa": "جزیره کریسمس",
            "de": "Weihnachtsinsel",
            "es": "Isla de Navidad",
            "fr": "Île Christmas",
            "ja": "クリスマス島",
            "it": "Isola di Natale",
            "zh-CN": "圣诞岛",
            "tr": "Christmas Adasi",
            "ru": "Остров Рождества",
            "uk": "Острів Різдва",
            "pl": "Wyspa Bożego Narodzenia"
        },
        "latitude": "-10.50000000",
        "longitude": "105.66666666",
        "emoji": "🇨🇽",
        "emojiU": "U+1F1E8 U+1F1FD",
        "states": []
    },
    {
        "id": 47,
        "name": "Cocos (Keeling) Islands",
        "iso3": "CCK",
        "iso2": "CC",
        "numeric_code": "166",
        "phonecode": "61",
        "capital": "West Island",
        "currency": "AUD",
        "currency_name": "Australian dollar",
        "currency_symbol": "$",
        "tld": ".cc",
        "native": "Cocos (Keeling) Islands",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Australia and New Zealand",
        "subregion_id": 19,
        "nationality": "Cocos Island",
        "timezones": [
            {
                "zoneName": "Indian\/Cocos",
                "gmtOffset": 23400,
                "gmtOffsetName": "UTC+06:30",
                "abbreviation": "CCT",
                "tzName": "Cocos Islands Time"
            }
        ],
        "translations": {
            "br": "Inizi Cocos",
            "ko": "코코스 제도",
            "pt-BR": "Ilhas Cocos",
            "pt": "Ilhas dos Cocos",
            "nl": "Cocoseilanden",
            "hr": "Kokosovi Otoci",
            "fa": "جزایر کوکوس",
            "de": "Kokosinseln",
            "es": "Islas Cocos o Islas Keeling",
            "fr": "Îles Cocos",
            "ja": "ココス（キーリング）諸島",
            "it": "Isole Cocos e Keeling",
            "zh-CN": "科科斯（基林）群岛",
            "tr": "Cocos Adalari",
            "ru": "Кокосовые (Килинг) острова",
            "uk": "Кокосові (Кілінг) острови",
            "pl": "Wyspy Kokosowe (Keelinga)"
        },
        "latitude": "-12.50000000",
        "longitude": "96.83333333",
        "emoji": "🇨🇨",
        "emojiU": "U+1F1E8 U+1F1E8",
        "states": []
    },
    {
        "id": 48,
        "name": "Colombia",
        "iso3": "COL",
        "iso2": "CO",
        "numeric_code": "170",
        "phonecode": "57",
        "capital": "Bogotá",
        "currency": "COP",
        "currency_name": "Colombian peso",
        "currency_symbol": "$",
        "tld": ".co",
        "native": "Colombia",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Colombian",
        "timezones": [
            {
                "zoneName": "America\/Bogota",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "COT",
                "tzName": "Colombia Time"
            }
        ],
        "translations": {
            "br": "Kolombia",
            "ko": "콜롬비아",
            "pt-BR": "Colômbia",
            "pt": "Colômbia",
            "nl": "Colombia",
            "hr": "Kolumbija",
            "fa": "کلمبیا",
            "de": "Kolumbien",
            "es": "Colombia",
            "fr": "Colombie",
            "ja": "コロンビア",
            "it": "Colombia",
            "zh-CN": "哥伦比亚",
            "tr": "Kolombiya",
            "ru": "Колумбия",
            "uk": "Колумбія",
            "pl": "Kolumbia"
        },
        "latitude": "4.00000000",
        "longitude": "-72.00000000",
        "emoji": "🇨🇴",
        "emojiU": "U+1F1E8 U+1F1F4",
        "states": [
            {
                "id": 2895,
                "name": "Amazonas",
                "iso2": "AMA",
                "latitude": "-1.44291230",
                "longitude": "-71.57239530",
                "type": "department",
                "cities": [
                    {
                        "id": 20807,
                        "name": "El Encanto",
                        "latitude": "-1.56261000",
                        "longitude": "-73.25684000"
                    },
                    {
                        "id": 20977,
                        "name": "La Chorrera",
                        "latitude": "-1.48894000",
                        "longitude": "-72.72935000"
                    },
                    {
                        "id": 20998,
                        "name": "La Pedrera",
                        "latitude": "-1.65596000",
                        "longitude": "-70.22186000"
                    },
                    {
                        "id": 21014,
                        "name": "La Victoria",
                        "latitude": "-0.18311000",
                        "longitude": "-71.03760000"
                    },
                    {
                        "id": 21027,
                        "name": "Leticia",
                        "latitude": "-4.21528000",
                        "longitude": "-69.94056000"
                    },
                    {
                        "id": 21086,
                        "name": "Miriti - Paraná",
                        "latitude": "-0.81858000",
                        "longitude": "-70.78925000"
                    },
                    {
                        "id": 21231,
                        "name": "Puerto Alegría",
                        "latitude": "-0.96886000",
                        "longitude": "-73.74962000"
                    },
                    {
                        "id": 21232,
                        "name": "Puerto Arica",
                        "latitude": "-1.90677000",
                        "longitude": "-71.14653000"
                    },
                    {
                        "id": 21249,
                        "name": "Puerto Nariño",
                        "latitude": "-3.78889000",
                        "longitude": "-70.35584000"
                    },
                    {
                        "id": 21256,
                        "name": "Puerto Santander",
                        "latitude": "-1.09870000",
                        "longitude": "-71.93911000"
                    },
                    {
                        "id": 21512,
                        "name": "Tarapacá",
                        "latitude": "-2.88544000",
                        "longitude": "-69.77692000"
                    }
                ]
            },
            {
                "id": 2890,
                "name": "Antioquia",
                "iso2": "ANT",
                "latitude": "7.19860640",
                "longitude": "-75.34121790",
                "type": "department",
                "cities": [
                    {
                        "id": 20485,
                        "name": "Abejorral",
                        "latitude": "5.78928000",
                        "longitude": "-75.42725000"
                    },
                    {
                        "id": 20487,
                        "name": "Abriaquí",
                        "latitude": "6.63148000",
                        "longitude": "-76.06444000"
                    },
                    {
                        "id": 20504,
                        "name": "Alejandría",
                        "latitude": "6.36667000",
                        "longitude": "-75.08333000"
                    },
                    {
                        "id": 20512,
                        "name": "Amagá",
                        "latitude": "6.04001000",
                        "longitude": "-75.70315000"
                    },
                    {
                        "id": 20513,
                        "name": "Amalfi",
                        "latitude": "6.91016000",
                        "longitude": "-75.07764000"
                    },
                    {
                        "id": 20520,
                        "name": "Andes",
                        "latitude": "5.66974000",
                        "longitude": "-75.89905000"
                    },
                    {
                        "id": 20521,
                        "name": "Angelópolis",
                        "latitude": "6.12228000",
                        "longitude": "-75.71432000"
                    },
                    {
                        "id": 20522,
                        "name": "Angostura",
                        "latitude": "6.87120000",
                        "longitude": "-75.35947000"
                    },
                    {
                        "id": 20747,
                        "name": "Anorí",
                        "latitude": "7.07361111",
                        "longitude": "-75.14694444"
                    },
                    {
                        "id": 20527,
                        "name": "Anza",
                        "latitude": "6.33333000",
                        "longitude": "-75.91667000"
                    },
                    {
                        "id": 20529,
                        "name": "Apartadó",
                        "latitude": "7.88299000",
                        "longitude": "-76.62587000"
                    },
                    {
                        "id": 20541,
                        "name": "Arboletes",
                        "latitude": "8.85051000",
                        "longitude": "-76.42694000"
                    },
                    {
                        "id": 20544,
                        "name": "Argelia",
                        "latitude": "5.73127000",
                        "longitude": "-75.14257000"
                    },
                    {
                        "id": 20551,
                        "name": "Armenia",
                        "latitude": "6.17554000",
                        "longitude": "-75.81230000"
                    },
                    {
                        "id": 20566,
                        "name": "Barbosa",
                        "latitude": "6.43809000",
                        "longitude": "-75.33136000"
                    },
                    {
                        "id": 20579,
                        "name": "Bello",
                        "latitude": "6.36160000",
                        "longitude": "-75.58728000"
                    },
                    {
                        "id": 20580,
                        "name": "Belmira",
                        "latitude": "6.60508000",
                        "longitude": "-75.66619000"
                    },
                    {
                        "id": 20588,
                        "name": "Betania",
                        "latitude": "5.73571000",
                        "longitude": "-75.98964000"
                    },
                    {
                        "id": 20589,
                        "name": "Betulia",
                        "latitude": "6.11284000",
                        "longitude": "-75.98378000"
                    },
                    {
                        "id": 20602,
                        "name": "Briceño",
                        "latitude": "7.05001000",
                        "longitude": "-75.50903000"
                    },
                    {
                        "id": 20613,
                        "name": "Buriticá",
                        "latitude": "6.80549000",
                        "longitude": "-75.92093000"
                    },
                    {
                        "id": 20763,
                        "name": "Cáceres",
                        "latitude": "7.68252000",
                        "longitude": "-75.22481000"
                    },
                    {
                        "id": 20621,
                        "name": "Caicedo",
                        "latitude": "6.42805000",
                        "longitude": "-75.99715000"
                    },
                    {
                        "id": 20631,
                        "name": "Caldas",
                        "latitude": "6.09106000",
                        "longitude": "-75.63569000"
                    },
                    {
                        "id": 20638,
                        "name": "Campamento",
                        "latitude": "7.03910000",
                        "longitude": "-75.28938000"
                    },
                    {
                        "id": 20667,
                        "name": "Cañasgordas",
                        "latitude": "6.80951000",
                        "longitude": "-76.03954000"
                    },
                    {
                        "id": 20649,
                        "name": "Caracolí",
                        "latitude": "6.40920000",
                        "longitude": "-74.75715000"
                    },
                    {
                        "id": 20650,
                        "name": "Caramanta",
                        "latitude": "5.54144000",
                        "longitude": "-75.66961000"
                    },
                    {
                        "id": 20652,
                        "name": "Carepa",
                        "latitude": "7.75849000",
                        "longitude": "-76.65255000"
                    },
                    {
                        "id": 20658,
                        "name": "Carolina",
                        "latitude": "6.74807000",
                        "longitude": "-75.32131000"
                    },
                    {
                        "id": 20666,
                        "name": "Caucasia",
                        "latitude": "7.98654000",
                        "longitude": "-75.19349000"
                    },
                    {
                        "id": 20683,
                        "name": "Chigorodó",
                        "latitude": "7.66638000",
                        "longitude": "-76.68106000"
                    },
                    {
                        "id": 20710,
                        "name": "Cisneros",
                        "latitude": "6.54507000",
                        "longitude": "-75.09415000"
                    },
                    {
                        "id": 20711,
                        "name": "Ciudad Bolívar",
                        "latitude": "5.85389000",
                        "longitude": "-76.02528000"
                    },
                    {
                        "id": 20716,
                        "name": "Cocorná",
                        "latitude": "6.00579000",
                        "longitude": "-75.16984000"
                    },
                    {
                        "id": 20724,
                        "name": "Concepción",
                        "latitude": "6.39408000",
                        "longitude": "-75.25830000"
                    },
                    {
                        "id": 20727,
                        "name": "Concordia",
                        "latitude": "6.04639000",
                        "longitude": "-75.90705000"
                    },
                    {
                        "id": 20735,
                        "name": "Copacabana",
                        "latitude": "6.36230000",
                        "longitude": "-75.49922000"
                    },
                    {
                        "id": 20773,
                        "name": "Dabeiba",
                        "latitude": "7.03367000",
                        "longitude": "-76.34161000"
                    },
                    {
                        "id": 20781,
                        "name": "Donmatías",
                        "latitude": "6.48569000",
                        "longitude": "-75.39496000"
                    },
                    {
                        "id": 20785,
                        "name": "Ebéjico",
                        "latitude": "6.32598000",
                        "longitude": "-75.76835000"
                    },
                    {
                        "id": 20786,
                        "name": "El Bagre",
                        "latitude": "7.60347000",
                        "longitude": "-74.80951000"
                    },
                    {
                        "id": 20656,
                        "name": "El Carmen de Viboral",
                        "latitude": "6.08236000",
                        "longitude": "-75.33509000"
                    },
                    {
                        "id": 21441,
                        "name": "El Santuario",
                        "latitude": "6.13833000",
                        "longitude": "-75.26417000"
                    },
                    {
                        "id": 20838,
                        "name": "Entrerrios",
                        "latitude": "6.58333000",
                        "longitude": "-75.58333000"
                    },
                    {
                        "id": 20840,
                        "name": "Envigado",
                        "latitude": "6.17591000",
                        "longitude": "-75.59174000"
                    },
                    {
                        "id": 20859,
                        "name": "Fredonia",
                        "latitude": "5.89239000",
                        "longitude": "-75.68546000"
                    },
                    {
                        "id": 20861,
                        "name": "Frontino",
                        "latitude": "6.77133000",
                        "longitude": "-76.13324000"
                    },
                    {
                        "id": 20885,
                        "name": "Giraldo",
                        "latitude": "6.66667000",
                        "longitude": "-75.95346000"
                    },
                    {
                        "id": 20888,
                        "name": "Girardota",
                        "latitude": "6.36789000",
                        "longitude": "-75.46231000"
                    },
                    {
                        "id": 20931,
                        "name": "Gómez Plata",
                        "latitude": "6.68178000",
                        "longitude": "-75.21907000"
                    },
                    {
                        "id": 20893,
                        "name": "Granada",
                        "latitude": "6.14353000",
                        "longitude": "-75.18532000"
                    },
                    {
                        "id": 20901,
                        "name": "Guadalupe",
                        "latitude": "6.81449000",
                        "longitude": "-75.24063000"
                    },
                    {
                        "id": 20913,
                        "name": "Guarne",
                        "latitude": "6.28345000",
                        "longitude": "-75.44363000"
                    },
                    {
                        "id": 20915,
                        "name": "Guatapé",
                        "latitude": "6.25548000",
                        "longitude": "-75.16432000"
                    },
                    {
                        "id": 20939,
                        "name": "Heliconia",
                        "latitude": "6.20831000",
                        "longitude": "-75.73565000"
                    },
                    {
                        "id": 20942,
                        "name": "Hispania",
                        "latitude": "5.79925000",
                        "longitude": "-75.90718000"
                    },
                    {
                        "id": 20953,
                        "name": "Itagui",
                        "latitude": "6.17874000",
                        "longitude": "-75.63117000"
                    },
                    {
                        "id": 20955,
                        "name": "Ituango",
                        "latitude": "7.17117000",
                        "longitude": "-75.76404000"
                    },
                    {
                        "id": 20959,
                        "name": "Jardín",
                        "latitude": "5.59038000",
                        "longitude": "-75.81846000"
                    },
                    {
                        "id": 20961,
                        "name": "Jericó",
                        "latitude": "5.79211000",
                        "longitude": "-75.78601000"
                    },
                    {
                        "id": 20974,
                        "name": "La Ceja",
                        "latitude": "6.00000000",
                        "longitude": "-75.43311000"
                    },
                    {
                        "id": 20983,
                        "name": "La Estrella",
                        "latitude": "6.14239000",
                        "longitude": "-75.65257000"
                    },
                    {
                        "id": 21000,
                        "name": "La Pintada",
                        "latitude": "5.74867000",
                        "longitude": "-75.60626000"
                    },
                    {
                        "id": 21009,
                        "name": "La Unión",
                        "latitude": "5.94642000",
                        "longitude": "-75.35917000"
                    },
                    {
                        "id": 21028,
                        "name": "Liborina",
                        "latitude": "6.67790000",
                        "longitude": "-75.81218000"
                    },
                    {
                        "id": 21044,
                        "name": "Maceo",
                        "latitude": "6.55196000",
                        "longitude": "-74.78741000"
                    },
                    {
                        "id": 21066,
                        "name": "Marinilla",
                        "latitude": "6.19609000",
                        "longitude": "-75.30313000"
                    },
                    {
                        "id": 21074,
                        "name": "Medellín",
                        "latitude": "6.25184000",
                        "longitude": "-75.56359000"
                    },
                    {
                        "id": 21097,
                        "name": "Montebello",
                        "latitude": "5.93703000",
                        "longitude": "-75.52741000"
                    },
                    {
                        "id": 21120,
                        "name": "Murindó",
                        "latitude": "6.84698000",
                        "longitude": "-76.71544000"
                    },
                    {
                        "id": 21121,
                        "name": "Mutatá",
                        "latitude": "7.24407000",
                        "longitude": "-76.43564000"
                    },
                    {
                        "id": 21126,
                        "name": "Nariño",
                        "latitude": "5.60893000",
                        "longitude": "-75.17656000"
                    },
                    {
                        "id": 21129,
                        "name": "Nechí",
                        "latitude": "8.09419000",
                        "longitude": "-74.77573000"
                    },
                    {
                        "id": 21130,
                        "name": "Necoclí",
                        "latitude": "8.42627000",
                        "longitude": "-76.78926000"
                    },
                    {
                        "id": 21149,
                        "name": "Olaya",
                        "latitude": "6.62773000",
                        "longitude": "-75.81270000"
                    },
                    {
                        "id": 21197,
                        "name": "Peñol",
                        "latitude": "6.23434000",
                        "longitude": "-75.22573000"
                    },
                    {
                        "id": 21194,
                        "name": "Peque",
                        "latitude": "7.02123000",
                        "longitude": "-75.90926000"
                    },
                    {
                        "id": 21227,
                        "name": "Pueblorrico",
                        "latitude": "5.80000000",
                        "longitude": "-75.85000000"
                    },
                    {
                        "id": 21234,
                        "name": "Puerto Berrío",
                        "latitude": "6.50749000",
                        "longitude": "-74.52271000"
                    },
                    {
                        "id": 21248,
                        "name": "Puerto Nare",
                        "latitude": "6.19167000",
                        "longitude": "-74.58670000"
                    },
                    {
                        "id": 21258,
                        "name": "Puerto Triunfo",
                        "latitude": "5.87259000",
                        "longitude": "-74.64050000"
                    },
                    {
                        "id": 21281,
                        "name": "Remedios",
                        "latitude": "7.02835000",
                        "longitude": "-74.69379000"
                    },
                    {
                        "id": 21286,
                        "name": "Retiro",
                        "latitude": "6.05906000",
                        "longitude": "-75.51488000"
                    },
                    {
                        "id": 21293,
                        "name": "Rionegro",
                        "latitude": "6.16667000",
                        "longitude": "-75.41667000"
                    },
                    {
                        "id": 21311,
                        "name": "Sabanalarga",
                        "latitude": "6.84893000",
                        "longitude": "-75.81711000"
                    },
                    {
                        "id": 21314,
                        "name": "Sabaneta",
                        "latitude": "6.15153000",
                        "longitude": "-75.61657000"
                    },
                    {
                        "id": 21323,
                        "name": "Salgar",
                        "latitude": "5.96711000",
                        "longitude": "-75.98747000"
                    },
                    {
                        "id": 21330,
                        "name": "San Andrés de Cuerquía",
                        "latitude": "6.90333000",
                        "longitude": "-75.68250000"
                    },
                    {
                        "id": 21345,
                        "name": "San Carlos",
                        "latitude": "7.79177000",
                        "longitude": "-74.77316000"
                    },
                    {
                        "id": 21357,
                        "name": "San Francisco",
                        "latitude": "6.11667000",
                        "longitude": "-75.98333000"
                    },
                    {
                        "id": 21362,
                        "name": "San Jerónimo",
                        "latitude": "6.44139000",
                        "longitude": "-75.70783000"
                    },
                    {
                        "id": 21366,
                        "name": "San José de la Montaña",
                        "latitude": "6.82205000",
                        "longitude": "-75.69757000"
                    },
                    {
                        "id": 21376,
                        "name": "San Juan de Urabá",
                        "latitude": "8.75924000",
                        "longitude": "-76.52969000"
                    },
                    {
                        "id": 149253,
                        "name": "San Luis",
                        "latitude": "6.04222222",
                        "longitude": "-74.99333333"
                    },
                    {
                        "id": 21117,
                        "name": "San Pedro de los Milagros",
                        "latitude": "6.45944444",
                        "longitude": "-75.55777888"
                    },
                    {
                        "id": 21399,
                        "name": "San Pedro de Uraba",
                        "latitude": "8.42291000",
                        "longitude": "-76.31747000"
                    },
                    {
                        "id": 21402,
                        "name": "San Rafael",
                        "latitude": "6.31234000",
                        "longitude": "-75.02426000"
                    },
                    {
                        "id": 21403,
                        "name": "San Roque",
                        "latitude": "6.48511000",
                        "longitude": "-75.01960000"
                    },
                    {
                        "id": 21407,
                        "name": "San Vicente Ferrer",
                        "latitude": "6.32237000",
                        "longitude": "-75.33020000"
                    },
                    {
                        "id": 21414,
                        "name": "Santa Bárbara",
                        "latitude": "5.88937000",
                        "longitude": "-75.58255000"
                    },
                    {
                        "id": 21417,
                        "name": "Santa Fe de Antioquia",
                        "latitude": "6.55687000",
                        "longitude": "-75.82806000"
                    },
                    {
                        "id": 21425,
                        "name": "Santa Rosa de Osos",
                        "latitude": "6.64738000",
                        "longitude": "-75.46031000"
                    },
                    {
                        "id": 21439,
                        "name": "Santo Domingo",
                        "latitude": "6.47282000",
                        "longitude": "-75.16547000"
                    },
                    {
                        "id": 21449,
                        "name": "Segovia",
                        "latitude": "7.28132000",
                        "longitude": "-74.64273000"
                    },
                    {
                        "id": 21474,
                        "name": "Sonson",
                        "latitude": "5.75000000",
                        "longitude": "-75.00000000"
                    },
                    {
                        "id": 21476,
                        "name": "Sopetrán",
                        "latitude": "6.52271000",
                        "longitude": "-75.74608000"
                    },
                    {
                        "id": 21562,
                        "name": "Támesis",
                        "latitude": "5.66462000",
                        "longitude": "-75.71339000"
                    },
                    {
                        "id": 21513,
                        "name": "Tarazá",
                        "latitude": "7.58358000",
                        "longitude": "-75.40068000"
                    },
                    {
                        "id": 21514,
                        "name": "Tarso",
                        "latitude": "5.86467000",
                        "longitude": "-75.82192000"
                    },
                    {
                        "id": 21532,
                        "name": "Titiribí",
                        "latitude": "6.06276000",
                        "longitude": "-75.79370000"
                    },
                    {
                        "id": 21537,
                        "name": "Toledo",
                        "latitude": "7.01306000",
                        "longitude": "-75.69528000"
                    },
                    {
                        "id": 21557,
                        "name": "Turbo",
                        "latitude": "8.09263000",
                        "longitude": "-76.72822000"
                    },
                    {
                        "id": 21572,
                        "name": "Uramita",
                        "latitude": "6.89944000",
                        "longitude": "-76.17417000"
                    },
                    {
                        "id": 21574,
                        "name": "Urrao",
                        "latitude": "6.31696000",
                        "longitude": "-76.13420000"
                    },
                    {
                        "id": 21577,
                        "name": "Valdivia",
                        "latitude": "7.29382000",
                        "longitude": "-75.39190000"
                    },
                    {
                        "id": 21584,
                        "name": "Valparaíso",
                        "latitude": "5.61500000",
                        "longitude": "-75.62422000"
                    },
                    {
                        "id": 21585,
                        "name": "Vegachí",
                        "latitude": "6.76141000",
                        "longitude": "-74.79473000"
                    },
                    {
                        "id": 21588,
                        "name": "Venecia",
                        "latitude": "5.95417000",
                        "longitude": "-75.79904000"
                    },
                    {
                        "id": 21595,
                        "name": "Vigía del Fuerte",
                        "latitude": "6.58933000",
                        "longitude": "-76.89599000"
                    },
                    {
                        "id": 21621,
                        "name": "Yalí",
                        "latitude": "6.70257000",
                        "longitude": "-74.79018000"
                    },
                    {
                        "id": 21622,
                        "name": "Yarumal",
                        "latitude": "6.98532000",
                        "longitude": "-75.45402000"
                    },
                    {
                        "id": 21624,
                        "name": "Yolombó",
                        "latitude": "6.66569000",
                        "longitude": "-74.99120000"
                    },
                    {
                        "id": 21625,
                        "name": "Yondó",
                        "latitude": "6.90738000",
                        "longitude": "-74.17686000"
                    },
                    {
                        "id": 21632,
                        "name": "Zaragoza",
                        "latitude": "7.48971000",
                        "longitude": "-74.86919000"
                    }
                ]
            },
            {
                "id": 2881,
                "name": "Arauca",
                "iso2": "ARA",
                "latitude": "6.54730600",
                "longitude": "-71.00223110",
                "type": "department",
                "cities": [
                    {
                        "id": 20536,
                        "name": "Arauca",
                        "latitude": "7.08471000",
                        "longitude": "-70.75908000"
                    },
                    {
                        "id": 20537,
                        "name": "Arauquita",
                        "latitude": "7.02917000",
                        "longitude": "-71.42806000"
                    },
                    {
                        "id": 20746,
                        "name": "Cravo Norte",
                        "latitude": "6.30173000",
                        "longitude": "-70.20415000"
                    },
                    {
                        "id": 20856,
                        "name": "Fortul",
                        "latitude": "6.74611000",
                        "longitude": "-71.85667000"
                    },
                    {
                        "id": 21253,
                        "name": "Puerto Rondón",
                        "latitude": "6.28048000",
                        "longitude": "-71.10000000"
                    },
                    {
                        "id": 21444,
                        "name": "Saravena",
                        "latitude": "6.96319000",
                        "longitude": "-71.88230000"
                    },
                    {
                        "id": 21508,
                        "name": "Tame",
                        "latitude": "6.46065000",
                        "longitude": "-71.73618000"
                    }
                ]
            },
            {
                "id": 2880,
                "name": "Atlántico",
                "iso2": "ATL",
                "latitude": "10.69661590",
                "longitude": "-74.87410450",
                "type": "department",
                "cities": [
                    {
                        "id": 20564,
                        "name": "Baranoa",
                        "latitude": "10.79497000",
                        "longitude": "-74.92073000"
                    },
                    {
                        "id": 20574,
                        "name": "Barranquilla",
                        "latitude": "10.96854000",
                        "longitude": "-74.78132000"
                    },
                    {
                        "id": 20640,
                        "name": "Campo de la Cruz",
                        "latitude": "10.37844000",
                        "longitude": "-74.90258000"
                    },
                    {
                        "id": 20643,
                        "name": "Candelaria",
                        "latitude": "10.47387000",
                        "longitude": "-74.88581000"
                    },
                    {
                        "id": 20876,
                        "name": "Galapa",
                        "latitude": "10.89790000",
                        "longitude": "-74.88700000"
                    },
                    {
                        "id": 20966,
                        "name": "Juan de Acosta",
                        "latitude": "10.82930000",
                        "longitude": "-75.03346000"
                    },
                    {
                        "id": 21038,
                        "name": "Luruaco",
                        "latitude": "10.61712000",
                        "longitude": "-75.15146000"
                    },
                    {
                        "id": 21053,
                        "name": "Malambo",
                        "latitude": "10.85953000",
                        "longitude": "-74.77386000"
                    },
                    {
                        "id": 21055,
                        "name": "Manatí",
                        "latitude": "10.46402000",
                        "longitude": "-74.98220000"
                    },
                    {
                        "id": 21171,
                        "name": "Palmar de Varela",
                        "latitude": "10.74055000",
                        "longitude": "-74.75443000"
                    },
                    {
                        "id": 21208,
                        "name": "Piojó",
                        "latitude": "10.74846000",
                        "longitude": "-75.10776000"
                    },
                    {
                        "id": 21217,
                        "name": "Polonuevo",
                        "latitude": "10.77697000",
                        "longitude": "-74.85344000"
                    },
                    {
                        "id": 21218,
                        "name": "Ponedera",
                        "latitude": "10.64297000",
                        "longitude": "-74.75393000"
                    },
                    {
                        "id": 21238,
                        "name": "Puerto Colombia",
                        "latitude": "11.00854000",
                        "longitude": "-74.90887000"
                    },
                    {
                        "id": 21283,
                        "name": "Repelón",
                        "latitude": "10.50937000",
                        "longitude": "-75.12830000"
                    },
                    {
                        "id": 21309,
                        "name": "Sabanagrande",
                        "latitude": "10.80077000",
                        "longitude": "-74.77051000"
                    },
                    {
                        "id": 21312,
                        "name": "Sabanalarga",
                        "latitude": "10.61636000",
                        "longitude": "-74.95717000"
                    },
                    {
                        "id": 21420,
                        "name": "Santa Lucía",
                        "latitude": "10.32420000",
                        "longitude": "-74.96017000"
                    },
                    {
                        "id": 21440,
                        "name": "Santo Tomás",
                        "latitude": "10.75773000",
                        "longitude": "-74.75451000"
                    },
                    {
                        "id": 21472,
                        "name": "Soledad",
                        "latitude": "10.89986000",
                        "longitude": "-74.78787000"
                    },
                    {
                        "id": 21485,
                        "name": "Suan",
                        "latitude": "10.30214000",
                        "longitude": "-74.91934000"
                    },
                    {
                        "id": 21550,
                        "name": "Tubará",
                        "latitude": "10.87562000",
                        "longitude": "-74.97873000"
                    },
                    {
                        "id": 21576,
                        "name": "Usiacurí",
                        "latitude": "10.74313000",
                        "longitude": "-74.97604000"
                    }
                ]
            },
            {
                "id": 4921,
                "name": "Bogotá D.C.",
                "iso2": "DC",
                "latitude": "4.28204150",
                "longitude": "-74.50270420",
                "type": "capital district",
                "cities": [
                    {
                        "id": 149237,
                        "name": "Bogotá D.C.",
                        "latitude": "4.61263889",
                        "longitude": "-74.07050000"
                    }
                ]
            },
            {
                "id": 2893,
                "name": "Bolívar",
                "iso2": "BOL",
                "latitude": "8.67043820",
                "longitude": "-74.03001220",
                "type": "department",
                "cities": [
                    {
                        "id": 20490,
                        "name": "Achí",
                        "latitude": "8.56950000",
                        "longitude": "-74.55715000"
                    },
                    {
                        "id": 20510,
                        "name": "Altos del Rosario",
                        "latitude": "8.79162000",
                        "longitude": "-74.16556000"
                    },
                    {
                        "id": 20543,
                        "name": "Arenal",
                        "latitude": "8.45928000",
                        "longitude": "-73.94331000"
                    },
                    {
                        "id": 20549,
                        "name": "Arjona",
                        "latitude": "10.17594000",
                        "longitude": "-75.35884000"
                    },
                    {
                        "id": 20554,
                        "name": "Arroyohondo",
                        "latitude": "10.25220000",
                        "longitude": "-75.01980000"
                    },
                    {
                        "id": 20573,
                        "name": "Barranco de Loba",
                        "latitude": "8.94597000",
                        "longitude": "-74.10647000"
                    },
                    {
                        "id": 20628,
                        "name": "Calamar",
                        "latitude": "10.23377000",
                        "longitude": "-74.94240000"
                    },
                    {
                        "id": 20645,
                        "name": "Cantagallo",
                        "latitude": "7.37926000",
                        "longitude": "-73.91550000"
                    },
                    {
                        "id": 20659,
                        "name": "Cartagena de Indias",
                        "latitude": "10.39972000",
                        "longitude": "-75.51444000"
                    },
                    {
                        "id": 20707,
                        "name": "Cicuco",
                        "latitude": "9.27756000",
                        "longitude": "-74.64312000"
                    },
                    {
                        "id": 20715,
                        "name": "Clemencia",
                        "latitude": "10.56645000",
                        "longitude": "-75.32499000"
                    },
                    {
                        "id": 20770,
                        "name": "Córdoba",
                        "latitude": "9.55149000",
                        "longitude": "-74.89800000"
                    },
                    {
                        "id": 20796,
                        "name": "El Carmen de Bolívar",
                        "latitude": "9.71740000",
                        "longitude": "-75.12023000"
                    },
                    {
                        "id": 20810,
                        "name": "El Guamo",
                        "latitude": "10.01753000",
                        "longitude": "-74.93483000"
                    },
                    {
                        "id": 20818,
                        "name": "El Peñón",
                        "latitude": "8.98691000",
                        "longitude": "-73.94697000"
                    },
                    {
                        "id": 20935,
                        "name": "Hatillo de Loba",
                        "latitude": "8.95635000",
                        "longitude": "-74.07819000"
                    },
                    {
                        "id": 21048,
                        "name": "Magangué",
                        "latitude": "9.24202000",
                        "longitude": "-74.75467000"
                    },
                    {
                        "id": 21050,
                        "name": "Mahates",
                        "latitude": "10.23293000",
                        "longitude": "-75.18985000"
                    },
                    {
                        "id": 21065,
                        "name": "Margarita",
                        "latitude": "9.06325000",
                        "longitude": "-74.28134000"
                    },
                    {
                        "id": 21072,
                        "name": "María la Baja",
                        "latitude": "9.99228000",
                        "longitude": "-75.34364000"
                    },
                    {
                        "id": 21093,
                        "name": "Mompós",
                        "latitude": "9.13990000",
                        "longitude": "-74.54513000"
                    },
                    {
                        "id": 21098,
                        "name": "Montecristo",
                        "latitude": "8.29710000",
                        "longitude": "-74.47330000"
                    },
                    {
                        "id": 21104,
                        "name": "Morales",
                        "latitude": "8.27520000",
                        "longitude": "-73.86884000"
                    },
                    {
                        "id": 21138,
                        "name": "Norosí",
                        "latitude": "8.52692000",
                        "longitude": "-74.03736000"
                    },
                    {
                        "id": 21207,
                        "name": "Pinillos",
                        "latitude": "8.91925000",
                        "longitude": "-74.46771000"
                    },
                    {
                        "id": 21280,
                        "name": "Regidor",
                        "latitude": "8.72229000",
                        "longitude": "-73.84891000"
                    },
                    {
                        "id": 21306,
                        "name": "Río Viejo",
                        "latitude": "8.58740000",
                        "longitude": "-73.83901000"
                    },
                    {
                        "id": 21350,
                        "name": "San Cristóbal",
                        "latitude": "9.87809000",
                        "longitude": "-75.25248000"
                    },
                    {
                        "id": 21353,
                        "name": "San Estanislao",
                        "latitude": "10.39833000",
                        "longitude": "-75.15111000"
                    },
                    {
                        "id": 21355,
                        "name": "San Fernando",
                        "latitude": "9.27972000",
                        "longitude": "-74.53389000"
                    },
                    {
                        "id": 21360,
                        "name": "San Jacinto",
                        "latitude": "9.83906000",
                        "longitude": "-75.11043000"
                    },
                    {
                        "id": 21361,
                        "name": "San Jacinto del Cauca",
                        "latitude": "8.23729000",
                        "longitude": "-74.66782000"
                    },
                    {
                        "id": 21372,
                        "name": "San Juan Nepomuceno",
                        "latitude": "9.94976000",
                        "longitude": "-75.07426000"
                    },
                    {
                        "id": 21386,
                        "name": "San Martín de Loba",
                        "latitude": "8.88214000",
                        "longitude": "-74.00353000"
                    },
                    {
                        "id": 21393,
                        "name": "San Pablo",
                        "latitude": "10.05154000",
                        "longitude": "-75.26775000"
                    },
                    {
                        "id": 21416,
                        "name": "Santa Catalina",
                        "latitude": "10.60448000",
                        "longitude": "-75.29555000"
                    },
                    {
                        "id": 21423,
                        "name": "Santa Rosa",
                        "latitude": "10.47312000",
                        "longitude": "-75.36160000"
                    },
                    {
                        "id": 21427,
                        "name": "Santa Rosa del Sur",
                        "latitude": "7.96444000",
                        "longitude": "-74.05444000"
                    },
                    {
                        "id": 21460,
                        "name": "Simití",
                        "latitude": "7.81632000",
                        "longitude": "-73.97922000"
                    },
                    {
                        "id": 21477,
                        "name": "Soplaviento",
                        "latitude": "10.33176000",
                        "longitude": "-75.11853000"
                    },
                    {
                        "id": 21505,
                        "name": "Talaigua Nuevo",
                        "latitude": "9.30347000",
                        "longitude": "-74.56477000"
                    },
                    {
                        "id": 21531,
                        "name": "Tiquisio",
                        "latitude": "8.55666000",
                        "longitude": "-74.26355000"
                    },
                    {
                        "id": 21555,
                        "name": "Turbaco",
                        "latitude": "10.35707000",
                        "longitude": "-75.38044000"
                    },
                    {
                        "id": 21556,
                        "name": "Turbaná",
                        "latitude": "10.27169000",
                        "longitude": "-75.44222000"
                    },
                    {
                        "id": 21609,
                        "name": "Villanueva",
                        "latitude": "10.44759000",
                        "longitude": "-75.26574000"
                    },
                    {
                        "id": 21629,
                        "name": "Zambrano",
                        "latitude": "9.74823000",
                        "longitude": "-74.88487000"
                    }
                ]
            },
            {
                "id": 2903,
                "name": "Boyacá",
                "iso2": "BOY",
                "latitude": "5.45451100",
                "longitude": "-73.36200300",
                "type": "department",
                "cities": [
                    {
                        "id": 20507,
                        "name": "Almeida",
                        "latitude": "4.97083000",
                        "longitude": "-73.37972000"
                    },
                    {
                        "id": 20532,
                        "name": "Aquitania",
                        "latitude": "5.40341000",
                        "longitude": "-72.90192000"
                    },
                    {
                        "id": 20542,
                        "name": "Arcabuco",
                        "latitude": "5.75463000",
                        "longitude": "-73.43669000"
                    },
                    {
                        "id": 20583,
                        "name": "Belén",
                        "latitude": "5.98892000",
                        "longitude": "-72.91254000"
                    },
                    {
                        "id": 20587,
                        "name": "Berbeo",
                        "latitude": "5.22760000",
                        "longitude": "-73.12527000"
                    },
                    {
                        "id": 20591,
                        "name": "Betéitiva",
                        "latitude": "5.91102000",
                        "longitude": "-72.80926000"
                    },
                    {
                        "id": 20593,
                        "name": "Boavita",
                        "latitude": "6.33031000",
                        "longitude": "-72.58505000"
                    },
                    {
                        "id": 20600,
                        "name": "Boyacá",
                        "latitude": "5.45371000",
                        "longitude": "-73.36250000"
                    },
                    {
                        "id": 20601,
                        "name": "Briceño",
                        "latitude": "5.68822000",
                        "longitude": "-73.91784000"
                    },
                    {
                        "id": 20609,
                        "name": "Buenavista",
                        "latitude": "5.50000000",
                        "longitude": "-73.96667000"
                    },
                    {
                        "id": 20614,
                        "name": "Busbanzá",
                        "latitude": "5.83047000",
                        "longitude": "-72.88419000"
                    },
                    {
                        "id": 20632,
                        "name": "Caldas",
                        "latitude": "5.57830000",
                        "longitude": "-73.88066000"
                    },
                    {
                        "id": 20641,
                        "name": "Campohermoso",
                        "latitude": "4.97733000",
                        "longitude": "-73.16714000"
                    },
                    {
                        "id": 20670,
                        "name": "Cerinza",
                        "latitude": "5.93649000",
                        "longitude": "-72.99127000"
                    },
                    {
                        "id": 20687,
                        "name": "Chinavita",
                        "latitude": "5.17915000",
                        "longitude": "-73.37147000"
                    },
                    {
                        "id": 20693,
                        "name": "Chiquinquirá",
                        "latitude": "5.61363000",
                        "longitude": "-73.83848000"
                    },
                    {
                        "id": 20706,
                        "name": "Chíquiza",
                        "latitude": "5.60412000",
                        "longitude": "-73.48518000"
                    },
                    {
                        "id": 20695,
                        "name": "Chiscas",
                        "latitude": "6.55642000",
                        "longitude": "-72.50378000"
                    },
                    {
                        "id": 20696,
                        "name": "Chita",
                        "latitude": "6.07788000",
                        "longitude": "-72.46774000"
                    },
                    {
                        "id": 20698,
                        "name": "Chitaraque",
                        "latitude": "5.96167000",
                        "longitude": "-73.45761000"
                    },
                    {
                        "id": 20699,
                        "name": "Chivatá",
                        "latitude": "5.55823000",
                        "longitude": "-73.28198000"
                    },
                    {
                        "id": 20701,
                        "name": "Chivor",
                        "latitude": "4.88556000",
                        "longitude": "-73.36889000"
                    },
                    {
                        "id": 20714,
                        "name": "Ciénega",
                        "latitude": "5.40867000",
                        "longitude": "-73.29572000"
                    },
                    {
                        "id": 20723,
                        "name": "Combita",
                        "latitude": "5.63333000",
                        "longitude": "-73.31667000"
                    },
                    {
                        "id": 20736,
                        "name": "Coper",
                        "latitude": "5.47681000",
                        "longitude": "-74.04416000"
                    },
                    {
                        "id": 20740,
                        "name": "Corrales",
                        "latitude": "5.82497000",
                        "longitude": "-72.84539000"
                    },
                    {
                        "id": 20743,
                        "name": "Covarachía",
                        "latitude": "6.50563000",
                        "longitude": "-72.73310000"
                    },
                    {
                        "id": 20750,
                        "name": "Cubará",
                        "latitude": "7.00578000",
                        "longitude": "-72.10568000"
                    },
                    {
                        "id": 20751,
                        "name": "Cucaita",
                        "latitude": "5.54373000",
                        "longitude": "-73.45433000"
                    },
                    {
                        "id": 20762,
                        "name": "Cuítiva",
                        "latitude": "5.58007000",
                        "longitude": "-72.96687000"
                    },
                    {
                        "id": 20783,
                        "name": "Duitama",
                        "latitude": "5.82450000",
                        "longitude": "-73.03408000"
                    },
                    {
                        "id": 20802,
                        "name": "El Cocuy",
                        "latitude": "6.32839000",
                        "longitude": "-72.43577000"
                    },
                    {
                        "id": 20808,
                        "name": "El Espino",
                        "latitude": "6.50812000",
                        "longitude": "-72.48036000"
                    },
                    {
                        "id": 20846,
                        "name": "Firavitoba",
                        "latitude": "5.66885000",
                        "longitude": "-72.99289000"
                    },
                    {
                        "id": 20850,
                        "name": "Floresta",
                        "latitude": "5.85903000",
                        "longitude": "-72.92511000"
                    },
                    {
                        "id": 20873,
                        "name": "Gachantivá",
                        "latitude": "5.74417000",
                        "longitude": "-73.54253000"
                    },
                    {
                        "id": 20882,
                        "name": "Gameza",
                        "latitude": "5.80313000",
                        "longitude": "-72.73721000"
                    },
                    {
                        "id": 20883,
                        "name": "Garagoa",
                        "latitude": "5.08236000",
                        "longitude": "-73.36334000"
                    },
                    {
                        "id": 20896,
                        "name": "Guacamayas",
                        "latitude": "6.44599000",
                        "longitude": "-72.51676000"
                    },
                    {
                        "id": 20918,
                        "name": "Guateque",
                        "latitude": "5.00619000",
                        "longitude": "-73.47274000"
                    },
                    {
                        "id": 20924,
                        "name": "Guayatá",
                        "latitude": "4.96417000",
                        "longitude": "-73.48750000"
                    },
                    {
                        "id": 20933,
                        "name": "Güicán",
                        "latitude": "6.46554000",
                        "longitude": "-72.41539000"
                    },
                    {
                        "id": 20956,
                        "name": "Iza",
                        "latitude": "5.61203000",
                        "longitude": "-72.97930000"
                    },
                    {
                        "id": 20960,
                        "name": "Jenesano",
                        "latitude": "5.38541000",
                        "longitude": "-73.36364000"
                    },
                    {
                        "id": 20962,
                        "name": "Jericó",
                        "latitude": "6.14577000",
                        "longitude": "-72.58598000"
                    },
                    {
                        "id": 20973,
                        "name": "La Capilla",
                        "latitude": "5.08076000",
                        "longitude": "-73.48076000"
                    },
                    {
                        "id": 21010,
                        "name": "La Uvita",
                        "latitude": "6.24262000",
                        "longitude": "-72.56448000"
                    },
                    {
                        "id": 21015,
                        "name": "La Victoria",
                        "latitude": "5.52278000",
                        "longitude": "-74.23280000"
                    },
                    {
                        "id": 21018,
                        "name": "Labranzagrande",
                        "latitude": "5.56223000",
                        "longitude": "-72.57499000"
                    },
                    {
                        "id": 21042,
                        "name": "Macanal",
                        "latitude": "4.95050000",
                        "longitude": "-73.32029000"
                    },
                    {
                        "id": 21067,
                        "name": "Maripí",
                        "latitude": "5.55194000",
                        "longitude": "-74.00861000"
                    },
                    {
                        "id": 21084,
                        "name": "Miraflores",
                        "latitude": "5.12216000",
                        "longitude": "-73.21212000"
                    },
                    {
                        "id": 21094,
                        "name": "Mongua",
                        "latitude": "5.75084000",
                        "longitude": "-72.80339000"
                    },
                    {
                        "id": 21095,
                        "name": "Monguí",
                        "latitude": "5.69752000",
                        "longitude": "-72.83359000"
                    },
                    {
                        "id": 21096,
                        "name": "Moniquirá",
                        "latitude": "5.84315000",
                        "longitude": "-73.57775000"
                    },
                    {
                        "id": 21110,
                        "name": "Motavita",
                        "latitude": "5.57655000",
                        "longitude": "-73.36696000"
                    },
                    {
                        "id": 21123,
                        "name": "Muzo",
                        "latitude": "5.53528000",
                        "longitude": "-74.10778000"
                    },
                    {
                        "id": 21135,
                        "name": "Nobsa",
                        "latitude": "5.76978000",
                        "longitude": "-72.94099000"
                    },
                    {
                        "id": 21140,
                        "name": "Nuevo Colón",
                        "latitude": "5.35368000",
                        "longitude": "-73.45660000"
                    },
                    {
                        "id": 21148,
                        "name": "Oicatá",
                        "latitude": "5.59548000",
                        "longitude": "-73.30820000"
                    },
                    {
                        "id": 21156,
                        "name": "Otanche",
                        "latitude": "5.77534000",
                        "longitude": "-74.20315000"
                    },
                    {
                        "id": 21158,
                        "name": "Pachavita",
                        "latitude": "5.13969000",
                        "longitude": "-73.39739000"
                    },
                    {
                        "id": 21268,
                        "name": "Páez",
                        "latitude": "5.10112000",
                        "longitude": "-73.05123000"
                    },
                    {
                        "id": 21166,
                        "name": "Paipa",
                        "latitude": "5.78013000",
                        "longitude": "-73.11708000"
                    },
                    {
                        "id": 21168,
                        "name": "Pajarito",
                        "latitude": "5.34751000",
                        "longitude": "-72.72075000"
                    },
                    {
                        "id": 21180,
                        "name": "Panqueba",
                        "latitude": "6.44533000",
                        "longitude": "-72.46268000"
                    },
                    {
                        "id": 21186,
                        "name": "Pauna",
                        "latitude": "5.65861000",
                        "longitude": "-73.98250000"
                    },
                    {
                        "id": 21187,
                        "name": "Paya",
                        "latitude": "5.62492000",
                        "longitude": "-72.42345000"
                    },
                    {
                        "id": 21190,
                        "name": "Paz de Río",
                        "latitude": "6.00219000",
                        "longitude": "-72.78857000"
                    },
                    {
                        "id": 21196,
                        "name": "Pesca",
                        "latitude": "5.50213000",
                        "longitude": "-73.08794000"
                    },
                    {
                        "id": 21209,
                        "name": "Pisba",
                        "latitude": "5.72396000",
                        "longitude": "-72.48646000"
                    },
                    {
                        "id": 21236,
                        "name": "Puerto Boyacá",
                        "latitude": "5.97214000",
                        "longitude": "-74.46349000"
                    },
                    {
                        "id": 21276,
                        "name": "Quípama",
                        "latitude": "5.51940000",
                        "longitude": "-74.17765000"
                    },
                    {
                        "id": 21278,
                        "name": "Ramiriquí",
                        "latitude": "5.40020000",
                        "longitude": "-73.33544000"
                    },
                    {
                        "id": 21303,
                        "name": "Ráquira",
                        "latitude": "5.53793000",
                        "longitude": "-73.63201000"
                    },
                    {
                        "id": 21300,
                        "name": "Rondón",
                        "latitude": "5.38173000",
                        "longitude": "-73.19683000"
                    },
                    {
                        "id": 21315,
                        "name": "Saboyá",
                        "latitude": "5.69636000",
                        "longitude": "-73.76932000"
                    },
                    {
                        "id": 21502,
                        "name": "Sáchica",
                        "latitude": "5.58453000",
                        "longitude": "-73.54184000"
                    },
                    {
                        "id": 21324,
                        "name": "Samacá",
                        "latitude": "5.49273000",
                        "longitude": "-73.48537000"
                    },
                    {
                        "id": 21352,
                        "name": "San Eduardo",
                        "latitude": "5.22396000",
                        "longitude": "-73.07696000"
                    },
                    {
                        "id": 21368,
                        "name": "San José de Pare",
                        "latitude": "6.01746000",
                        "longitude": "-73.54703000"
                    },
                    {
                        "id": 21380,
                        "name": "San Luis de Gaceno",
                        "latitude": "4.82052000",
                        "longitude": "-73.16851000"
                    },
                    {
                        "id": 21387,
                        "name": "San Mateo",
                        "latitude": "6.37704000",
                        "longitude": "-72.57797000"
                    },
                    {
                        "id": 21390,
                        "name": "San Miguel de Sema",
                        "latitude": "5.51847000",
                        "longitude": "-73.72238000"
                    },
                    {
                        "id": 21394,
                        "name": "San Pablo de Borbur",
                        "latitude": "5.66638000",
                        "longitude": "-74.13723000"
                    },
                    {
                        "id": 21422,
                        "name": "Santa María",
                        "latitude": "4.82282000",
                        "longitude": "-73.25373000"
                    },
                    {
                        "id": 21426,
                        "name": "Santa Rosa de Viterbo",
                        "latitude": "5.87401000",
                        "longitude": "-72.98217000"
                    },
                    {
                        "id": 21430,
                        "name": "Santa Sofía",
                        "latitude": "5.70213000",
                        "longitude": "-73.62976000"
                    },
                    {
                        "id": 21433,
                        "name": "Santana",
                        "latitude": "6.04464000",
                        "longitude": "-73.51107000"
                    },
                    {
                        "id": 21447,
                        "name": "Sativanorte",
                        "latitude": "6.13156000",
                        "longitude": "-72.70895000"
                    },
                    {
                        "id": 21448,
                        "name": "Sativasur",
                        "latitude": "6.08959000",
                        "longitude": "-72.72432000"
                    },
                    {
                        "id": 21452,
                        "name": "Siachoque",
                        "latitude": "5.51238000",
                        "longitude": "-73.24436000"
                    },
                    {
                        "id": 21465,
                        "name": "Soatá",
                        "latitude": "6.29966000",
                        "longitude": "-72.72422000"
                    },
                    {
                        "id": 21466,
                        "name": "Socha",
                        "latitude": "5.92926000",
                        "longitude": "-72.70072000"
                    },
                    {
                        "id": 21469,
                        "name": "Socotá",
                        "latitude": "6.04028000",
                        "longitude": "-72.63509000"
                    },
                    {
                        "id": 21470,
                        "name": "Sogamoso",
                        "latitude": "5.71434000",
                        "longitude": "-72.93391000"
                    },
                    {
                        "id": 21473,
                        "name": "Somondoco",
                        "latitude": "4.98495000",
                        "longitude": "-73.43238000"
                    },
                    {
                        "id": 21479,
                        "name": "Sora",
                        "latitude": "5.56514000",
                        "longitude": "-73.45017000"
                    },
                    {
                        "id": 21480,
                        "name": "Soracá",
                        "latitude": "5.50055000",
                        "longitude": "-73.33299000"
                    },
                    {
                        "id": 21481,
                        "name": "Sotaquirá",
                        "latitude": "5.76483000",
                        "longitude": "-73.24758000"
                    },
                    {
                        "id": 21495,
                        "name": "Susacón",
                        "latitude": "6.22978000",
                        "longitude": "-72.69010000"
                    },
                    {
                        "id": 21496,
                        "name": "Sutamarchán",
                        "latitude": "5.61538000",
                        "longitude": "-73.61701000"
                    },
                    {
                        "id": 21498,
                        "name": "Sutatenza",
                        "latitude": "5.02311000",
                        "longitude": "-73.45230000"
                    },
                    {
                        "id": 21515,
                        "name": "Tasco",
                        "latitude": "5.91044000",
                        "longitude": "-72.78001000"
                    },
                    {
                        "id": 21521,
                        "name": "Tenza",
                        "latitude": "5.07664000",
                        "longitude": "-73.42077000"
                    },
                    {
                        "id": 21523,
                        "name": "Tibaná",
                        "latitude": "5.31728000",
                        "longitude": "-73.39655000"
                    },
                    {
                        "id": 21524,
                        "name": "Tibasosa",
                        "latitude": "5.74722000",
                        "longitude": "-73.01091000"
                    },
                    {
                        "id": 21529,
                        "name": "Tinjacá",
                        "latitude": "5.57916000",
                        "longitude": "-73.64486000"
                    },
                    {
                        "id": 21530,
                        "name": "Tipacoque",
                        "latitude": "6.42031000",
                        "longitude": "-72.69184000"
                    },
                    {
                        "id": 21533,
                        "name": "Toca",
                        "latitude": "5.56393000",
                        "longitude": "-73.18398000"
                    },
                    {
                        "id": 21536,
                        "name": "Togüí",
                        "latitude": "5.93462000",
                        "longitude": "-73.51297000"
                    },
                    {
                        "id": 21563,
                        "name": "Tópaga",
                        "latitude": "5.75979000",
                        "longitude": "-72.82583000"
                    },
                    {
                        "id": 21545,
                        "name": "Tota",
                        "latitude": "5.55833000",
                        "longitude": "-72.98757000"
                    },
                    {
                        "id": 21553,
                        "name": "Tunja",
                        "latitude": "5.53528000",
                        "longitude": "-73.36778000"
                    },
                    {
                        "id": 21554,
                        "name": "Tununguá",
                        "latitude": "5.72967000",
                        "longitude": "-73.94137000"
                    },
                    {
                        "id": 21558,
                        "name": "Turmequé",
                        "latitude": "5.32360000",
                        "longitude": "-73.49067000"
                    },
                    {
                        "id": 21559,
                        "name": "Tuta",
                        "latitude": "5.68966000",
                        "longitude": "-73.22779000"
                    },
                    {
                        "id": 21560,
                        "name": "Tutazá",
                        "latitude": "6.03228000",
                        "longitude": "-72.85639000"
                    },
                    {
                        "id": 21568,
                        "name": "Umbita",
                        "latitude": "5.18411000",
                        "longitude": "-73.48341000"
                    },
                    {
                        "id": 21589,
                        "name": "Ventaquemada",
                        "latitude": "5.35987000",
                        "longitude": "-73.55032000"
                    },
                    {
                        "id": 21598,
                        "name": "Villa de Leyva",
                        "latitude": "5.67061000",
                        "longitude": "-73.51554000"
                    },
                    {
                        "id": 21615,
                        "name": "Viracachá",
                        "latitude": "5.43637000",
                        "longitude": "-73.29606000"
                    },
                    {
                        "id": 21634,
                        "name": "Zetaquira",
                        "latitude": "5.25824000",
                        "longitude": "-73.18275000"
                    }
                ]
            },
            {
                "id": 2887,
                "name": "Caldas",
                "iso2": "CAL",
                "latitude": "5.29826000",
                "longitude": "-75.24790610",
                "type": "department",
                "cities": [
                    {
                        "id": 20494,
                        "name": "Aguadas",
                        "latitude": "5.61161000",
                        "longitude": "-75.45624000"
                    },
                    {
                        "id": 20525,
                        "name": "Anserma",
                        "latitude": "5.20427000",
                        "longitude": "-75.79167000"
                    },
                    {
                        "id": 20534,
                        "name": "Aranzazu",
                        "latitude": "5.25519000",
                        "longitude": "-75.50984000"
                    },
                    {
                        "id": 20576,
                        "name": "Belalcázar",
                        "latitude": "4.99528000",
                        "longitude": "-75.81278000"
                    },
                    {
                        "id": 20688,
                        "name": "Chinchiná",
                        "latitude": "4.97522000",
                        "longitude": "-75.70416000"
                    },
                    {
                        "id": 20844,
                        "name": "Filadelfia",
                        "latitude": "5.29606000",
                        "longitude": "-75.56120000"
                    },
                    {
                        "id": 20981,
                        "name": "La Dorada",
                        "latitude": "5.53333000",
                        "longitude": "-74.70000000"
                    },
                    {
                        "id": 20992,
                        "name": "La Merced",
                        "latitude": "5.38060000",
                        "longitude": "-75.58842000"
                    },
                    {
                        "id": 21059,
                        "name": "Manizales",
                        "latitude": "5.06889000",
                        "longitude": "-75.51738000"
                    },
                    {
                        "id": 21061,
                        "name": "Manzanares",
                        "latitude": "5.23305000",
                        "longitude": "-75.15168000"
                    },
                    {
                        "id": 21068,
                        "name": "Marmato",
                        "latitude": "5.47554000",
                        "longitude": "-75.59710000"
                    },
                    {
                        "id": 21069,
                        "name": "Marquetalia",
                        "latitude": "5.29069000",
                        "longitude": "-75.08028000"
                    },
                    {
                        "id": 21071,
                        "name": "Marulanda",
                        "latitude": "5.28393000",
                        "longitude": "-75.26016000"
                    },
                    {
                        "id": 21131,
                        "name": "Neira",
                        "latitude": "5.17534000",
                        "longitude": "-75.52405000"
                    },
                    {
                        "id": 21137,
                        "name": "Norcasia",
                        "latitude": "5.57535000",
                        "longitude": "-74.88831000"
                    },
                    {
                        "id": 21267,
                        "name": "Pácora",
                        "latitude": "5.50631000",
                        "longitude": "-75.49054000"
                    },
                    {
                        "id": 21169,
                        "name": "Palestina",
                        "latitude": "5.04571000",
                        "longitude": "-75.69552000"
                    },
                    {
                        "id": 21193,
                        "name": "Pensilvania",
                        "latitude": "5.38840000",
                        "longitude": "-75.20420000"
                    },
                    {
                        "id": 21294,
                        "name": "Riosucio",
                        "latitude": "5.42164000",
                        "longitude": "-75.70318000"
                    },
                    {
                        "id": 21296,
                        "name": "Risaralda",
                        "latitude": "5.11237000",
                        "longitude": "-75.75861000"
                    },
                    {
                        "id": 21319,
                        "name": "Salamina",
                        "latitude": "5.37014000",
                        "longitude": "-75.41548000"
                    },
                    {
                        "id": 21326,
                        "name": "Samaná",
                        "latitude": "5.54061000",
                        "longitude": "-74.99346000"
                    },
                    {
                        "id": 21364,
                        "name": "San José",
                        "latitude": "5.08221000",
                        "longitude": "-75.79107000"
                    },
                    {
                        "id": 21492,
                        "name": "Supía",
                        "latitude": "5.45303000",
                        "longitude": "-75.65072000"
                    },
                    {
                        "id": 21594,
                        "name": "Victoria",
                        "latitude": "5.45666000",
                        "longitude": "-74.84061000"
                    },
                    {
                        "id": 21605,
                        "name": "Villamaría",
                        "latitude": "4.95078000",
                        "longitude": "-75.43680000"
                    },
                    {
                        "id": 21617,
                        "name": "Viterbo",
                        "latitude": "5.06242000",
                        "longitude": "-75.87159000"
                    }
                ]
            },
            {
                "id": 2891,
                "name": "Caquetá",
                "iso2": "CAQ",
                "latitude": "0.86989200",
                "longitude": "-73.84190630",
                "type": "department",
                "cities": [
                    {
                        "id": 20499,
                        "name": "Albania",
                        "latitude": "1.26325000",
                        "longitude": "-75.95366000"
                    },
                    {
                        "id": 20584,
                        "name": "Belén de Los Andaquies",
                        "latitude": "1.41667000",
                        "longitude": "-75.91667000"
                    },
                    {
                        "id": 20660,
                        "name": "Cartagena del Chairá",
                        "latitude": "1.33488000",
                        "longitude": "-74.84289000"
                    },
                    {
                        "id": 20759,
                        "name": "Curillo",
                        "latitude": "1.03327000",
                        "longitude": "-75.91907000"
                    },
                    {
                        "id": 20805,
                        "name": "El Doncello",
                        "latitude": "1.67817000",
                        "longitude": "-75.28466000"
                    },
                    {
                        "id": 20814,
                        "name": "El Paujil",
                        "latitude": "1.57085000",
                        "longitude": "-75.31403000"
                    },
                    {
                        "id": 20849,
                        "name": "Florencia",
                        "latitude": "1.71619000",
                        "longitude": "-75.59624000"
                    },
                    {
                        "id": 20994,
                        "name": "La Montañita",
                        "latitude": "1.46389000",
                        "longitude": "-75.30363000"
                    },
                    {
                        "id": 21082,
                        "name": "Milán",
                        "latitude": "1.29034000",
                        "longitude": "-75.50757000"
                    },
                    {
                        "id": 21105,
                        "name": "Morelia",
                        "latitude": "1.48747000",
                        "longitude": "-75.72581000"
                    },
                    {
                        "id": 21251,
                        "name": "Puerto Rico",
                        "latitude": "1.90999000",
                        "longitude": "-75.15931000"
                    },
                    {
                        "id": 21369,
                        "name": "San José del Fragua",
                        "latitude": "1.30780000",
                        "longitude": "-76.16554000"
                    },
                    {
                        "id": 149254,
                        "name": "San Vicente del Caguán",
                        "latitude": "2.11527888",
                        "longitude": "-74.77777777"
                    },
                    {
                        "id": 21471,
                        "name": "Solano",
                        "latitude": "0.22842000",
                        "longitude": "-73.27597000"
                    },
                    {
                        "id": 149255,
                        "name": "Solita",
                        "latitude": "0.87583333",
                        "longitude": "-75.61972222"
                    },
                    {
                        "id": 21583,
                        "name": "Valparaíso",
                        "latitude": "1.19403000",
                        "longitude": "-75.70746000"
                    }
                ]
            },
            {
                "id": 2892,
                "name": "Casanare",
                "iso2": "CAS",
                "latitude": "5.75892690",
                "longitude": "-71.57239530",
                "type": "department",
                "cities": [
                    {
                        "id": 20495,
                        "name": "Aguazul",
                        "latitude": "5.17282000",
                        "longitude": "-72.54706000"
                    },
                    {
                        "id": 20677,
                        "name": "Chameza",
                        "latitude": "5.19237000",
                        "longitude": "-72.88952000"
                    },
                    {
                        "id": 20937,
                        "name": "Hato Corozal",
                        "latitude": "6.15472222",
                        "longitude": "-71.76527888"
                    },
                    {
                        "id": 149243,
                        "name": "La Salina",
                        "latitude": "6.12755555",
                        "longitude": "-72.33416777"
                    },
                    {
                        "id": 21062,
                        "name": "Maní",
                        "latitude": "4.81638000",
                        "longitude": "-72.27946000"
                    },
                    {
                        "id": 21101,
                        "name": "Monterrey",
                        "latitude": "4.82015000",
                        "longitude": "-72.87901000"
                    },
                    {
                        "id": 21141,
                        "name": "Nunchía",
                        "latitude": "5.63589000",
                        "longitude": "-72.19543000"
                    },
                    {
                        "id": 21153,
                        "name": "Orocué",
                        "latitude": "4.79035000",
                        "longitude": "-71.33917000"
                    },
                    {
                        "id": 149244,
                        "name": "Paz de Ariporo",
                        "latitude": "5.88111111",
                        "longitude": "-71.89166777"
                    },
                    {
                        "id": 21220,
                        "name": "Pore",
                        "latitude": "5.72792000",
                        "longitude": "-71.99266000"
                    },
                    {
                        "id": 21279,
                        "name": "Recetor",
                        "latitude": "5.22947000",
                        "longitude": "-72.76099000"
                    },
                    {
                        "id": 21310,
                        "name": "Sabanalarga",
                        "latitude": "4.85430000",
                        "longitude": "-73.04003000"
                    },
                    {
                        "id": 21501,
                        "name": "Sácama",
                        "latitude": "6.09908000",
                        "longitude": "-72.24880000"
                    },
                    {
                        "id": 21381,
                        "name": "San Luis de Palenque",
                        "latitude": "5.42139000",
                        "longitude": "-71.73167000"
                    },
                    {
                        "id": 21561,
                        "name": "Támara",
                        "latitude": "5.82998000",
                        "longitude": "-72.16286000"
                    },
                    {
                        "id": 21516,
                        "name": "Tauramena",
                        "latitude": "5.01789000",
                        "longitude": "-72.74675000"
                    },
                    {
                        "id": 21548,
                        "name": "Trinidad",
                        "latitude": "5.34778000",
                        "longitude": "-71.20194000"
                    },
                    {
                        "id": 21607,
                        "name": "Villanueva",
                        "latitude": "5.28333000",
                        "longitude": "-71.96667000"
                    },
                    {
                        "id": 21626,
                        "name": "Yopal",
                        "latitude": "5.33775000",
                        "longitude": "-72.39586000"
                    }
                ]
            },
            {
                "id": 2884,
                "name": "Cauca",
                "iso2": "CAU",
                "latitude": "2.70498130",
                "longitude": "-76.82596520",
                "type": "department",
                "cities": [
                    {
                        "id": 20506,
                        "name": "Almaguer",
                        "latitude": "1.91472000",
                        "longitude": "-76.85482000"
                    },
                    {
                        "id": 20545,
                        "name": "Argelia",
                        "latitude": "2.31728000",
                        "longitude": "-77.25700000"
                    },
                    {
                        "id": 20562,
                        "name": "Balboa",
                        "latitude": "2.08436000",
                        "longitude": "-77.20781000"
                    },
                    {
                        "id": 20599,
                        "name": "Bolívar",
                        "latitude": "1.84670000",
                        "longitude": "-76.98292000"
                    },
                    {
                        "id": 20610,
                        "name": "Buenos Aires",
                        "latitude": "3.04825000",
                        "longitude": "-76.63066000"
                    },
                    {
                        "id": 20625,
                        "name": "Cajibío",
                        "latitude": "2.62271000",
                        "longitude": "-76.57039000"
                    },
                    {
                        "id": 20633,
                        "name": "Caldono",
                        "latitude": "2.79739000",
                        "longitude": "-76.48316000"
                    },
                    {
                        "id": 20637,
                        "name": "Caloto",
                        "latitude": "3.03586000",
                        "longitude": "-76.40788000"
                    },
                    {
                        "id": 20737,
                        "name": "Corinto",
                        "latitude": "3.13598000",
                        "longitude": "-76.20646000"
                    },
                    {
                        "id": 20831,
                        "name": "El Tambo",
                        "latitude": "2.45199000",
                        "longitude": "-76.81029000"
                    },
                    {
                        "id": 20848,
                        "name": "Florencia",
                        "latitude": "1.68318000",
                        "longitude": "-77.07331000"
                    },
                    {
                        "id": 149241,
                        "name": "Guachené",
                        "latitude": "3.13361111",
                        "longitude": "-76.39255555"
                    },
                    {
                        "id": 20909,
                        "name": "Guapi",
                        "latitude": "2.55210000",
                        "longitude": "-77.87865000"
                    },
                    {
                        "id": 20948,
                        "name": "Inzá",
                        "latitude": "2.55452000",
                        "longitude": "-76.06722000"
                    },
                    {
                        "id": 20957,
                        "name": "Jambaló",
                        "latitude": "2.85065000",
                        "longitude": "-76.32506000"
                    },
                    {
                        "id": 21003,
                        "name": "La Sierra",
                        "latitude": "2.19665000",
                        "longitude": "-76.78590000"
                    },
                    {
                        "id": 21011,
                        "name": "La Vega",
                        "latitude": "2.06201000",
                        "longitude": "-76.76808000"
                    },
                    {
                        "id": 21041,
                        "name": "López de Micay",
                        "latitude": "3.00000000",
                        "longitude": "-77.25000000"
                    },
                    {
                        "id": 21080,
                        "name": "Mercaderes",
                        "latitude": "1.80175000",
                        "longitude": "-77.17032000"
                    },
                    {
                        "id": 21085,
                        "name": "Miranda",
                        "latitude": "3.23773000",
                        "longitude": "-76.22093000"
                    },
                    {
                        "id": 21103,
                        "name": "Morales",
                        "latitude": "2.75446000",
                        "longitude": "-76.62791000"
                    },
                    {
                        "id": 21161,
                        "name": "Padilla",
                        "latitude": "3.22038000",
                        "longitude": "-76.31385000"
                    },
                    {
                        "id": 21163,
                        "name": "Páez",
                        "latitude": "2.64644000",
                        "longitude": "-75.97269000"
                    },
                    {
                        "id": 21185,
                        "name": "Patía",
                        "latitude": "2.14018000",
                        "longitude": "-77.01744000"
                    },
                    {
                        "id": 149245,
                        "name": "Piamonte",
                        "latitude": "1.11583333",
                        "longitude": "-76.32611111"
                    },
                    {
                        "id": 21202,
                        "name": "Piendamo",
                        "latitude": "2.63918000",
                        "longitude": "-76.53055000"
                    },
                    {
                        "id": 21219,
                        "name": "Popayán",
                        "latitude": "2.43823000",
                        "longitude": "-76.61316000"
                    },
                    {
                        "id": 21257,
                        "name": "Puerto Tejada",
                        "latitude": "3.23393000",
                        "longitude": "-76.41935000"
                    },
                    {
                        "id": 21263,
                        "name": "Puracé",
                        "latitude": "2.33851000",
                        "longitude": "-76.38759000"
                    },
                    {
                        "id": 21301,
                        "name": "Rosas",
                        "latitude": "2.26093000",
                        "longitude": "-76.73986000"
                    },
                    {
                        "id": 21404,
                        "name": "San Sebastián",
                        "latitude": "1.91667000",
                        "longitude": "-76.66667000"
                    },
                    {
                        "id": 149250,
                        "name": "Santa Rosa",
                        "latitude": "1.70055666",
                        "longitude": "-76.57277888"
                    },
                    {
                        "id": 21434,
                        "name": "Santander de Quilichao",
                        "latitude": "3.00945000",
                        "longitude": "-76.48494000"
                    },
                    {
                        "id": 21457,
                        "name": "Silvia",
                        "latitude": "2.61557000",
                        "longitude": "-76.38261000"
                    },
                    {
                        "id": 21482,
                        "name": "Sotará",
                        "latitude": "2.25000000",
                        "longitude": "-76.58333000"
                    },
                    {
                        "id": 21499,
                        "name": "Suárez",
                        "latitude": "2.95395000",
                        "longitude": "-76.69644000"
                    },
                    {
                        "id": 21489,
                        "name": "Sucre",
                        "latitude": "2.06182000",
                        "longitude": "-76.91438000"
                    },
                    {
                        "id": 149257,
                        "name": "Timbío",
                        "latitude": "2.35277888",
                        "longitude": "-76.68194444"
                    },
                    {
                        "id": 21528,
                        "name": "Timbiquí",
                        "latitude": "2.77170000",
                        "longitude": "-77.66536000"
                    },
                    {
                        "id": 21542,
                        "name": "Toribio",
                        "latitude": "3.00000000",
                        "longitude": "-76.16667000"
                    },
                    {
                        "id": 21546,
                        "name": "Totoró",
                        "latitude": "2.50518000",
                        "longitude": "-76.39254000"
                    },
                    {
                        "id": 21597,
                        "name": "Villa Rica",
                        "latitude": "2.51420000",
                        "longitude": "-76.84939000"
                    }
                ]
            },
            {
                "id": 2899,
                "name": "Cesar",
                "iso2": "CES",
                "latitude": "9.33729480",
                "longitude": "-73.65362090",
                "type": "department",
                "cities": [
                    {
                        "id": 20492,
                        "name": "Aguachica",
                        "latitude": "8.30844000",
                        "longitude": "-73.61660000"
                    },
                    {
                        "id": 20496,
                        "name": "Agustín Codazzi",
                        "latitude": "10.03672000",
                        "longitude": "-73.23558000"
                    },
                    {
                        "id": 20555,
                        "name": "Astrea",
                        "latitude": "9.49828000",
                        "longitude": "-73.97591000"
                    },
                    {
                        "id": 20575,
                        "name": "Becerril",
                        "latitude": "9.70413000",
                        "longitude": "-73.27930000"
                    },
                    {
                        "id": 149238,
                        "name": "Bosconia",
                        "latitude": "9.97611111",
                        "longitude": "-73.89033333"
                    },
                    {
                        "id": 20685,
                        "name": "Chimichagua",
                        "latitude": "9.25778000",
                        "longitude": "-73.81228000"
                    },
                    {
                        "id": 20694,
                        "name": "Chiriguaná",
                        "latitude": "9.36238000",
                        "longitude": "-73.60313000"
                    },
                    {
                        "id": 20761,
                        "name": "Curumaní",
                        "latitude": "9.19992000",
                        "longitude": "-73.54274000"
                    },
                    {
                        "id": 20804,
                        "name": "El Copey",
                        "latitude": "10.15031000",
                        "longitude": "-73.96140000"
                    },
                    {
                        "id": 20813,
                        "name": "El Paso",
                        "latitude": "9.65724000",
                        "longitude": "-73.74685000"
                    },
                    {
                        "id": 20880,
                        "name": "Gamarra",
                        "latitude": "8.32969000",
                        "longitude": "-73.71773000"
                    },
                    {
                        "id": 20890,
                        "name": "González",
                        "latitude": "8.36735000",
                        "longitude": "-73.40032000"
                    },
                    {
                        "id": 20985,
                        "name": "La Gloria",
                        "latitude": "8.61160000",
                        "longitude": "-73.63045000"
                    },
                    {
                        "id": 20987,
                        "name": "La Jagua de Ibirico",
                        "latitude": "9.56228000",
                        "longitude": "-73.33405000"
                    },
                    {
                        "id": 20997,
                        "name": "La Paz",
                        "latitude": "10.10487000",
                        "longitude": "-73.22056000"
                    },
                    {
                        "id": 21058,
                        "name": "Manaure Balcón del Cesar",
                        "latitude": "10.39278000",
                        "longitude": "-73.03250000"
                    },
                    {
                        "id": 21164,
                        "name": "Pailitas",
                        "latitude": "8.95652000",
                        "longitude": "-73.62548000"
                    },
                    {
                        "id": 21192,
                        "name": "Pelaya",
                        "latitude": "8.68819000",
                        "longitude": "-73.66451000"
                    },
                    {
                        "id": 149247,
                        "name": "Pueblo Bello",
                        "latitude": "10.41638999",
                        "longitude": "-73.58666777"
                    },
                    {
                        "id": 21307,
                        "name": "Río de Oro",
                        "latitude": "8.17879000",
                        "longitude": "-73.51218000"
                    },
                    {
                        "id": 21328,
                        "name": "San Alberto",
                        "latitude": "7.76107000",
                        "longitude": "-73.39220000"
                    },
                    {
                        "id": 21351,
                        "name": "San Diego",
                        "latitude": "10.33623000",
                        "longitude": "-73.18203000"
                    },
                    {
                        "id": 21384,
                        "name": "San Martín",
                        "latitude": "8.00151000",
                        "longitude": "-73.51126000"
                    },
                    {
                        "id": 21507,
                        "name": "Tamalameque",
                        "latitude": "8.86422000",
                        "longitude": "-73.78106000"
                    },
                    {
                        "id": 21582,
                        "name": "Valledupar",
                        "latitude": "10.46314000",
                        "longitude": "-73.25322000"
                    }
                ]
            },
            {
                "id": 2876,
                "name": "Chocó",
                "iso2": "CHO",
                "latitude": "5.25280330",
                "longitude": "-76.82596520",
                "type": "department",
                "cities": [
                    {
                        "id": 20489,
                        "name": "Acandí",
                        "latitude": "8.51158000",
                        "longitude": "-77.27719000"
                    },
                    {
                        "id": 20509,
                        "name": "Alto Baudó",
                        "latitude": "5.51604000",
                        "longitude": "-76.97449000"
                    },
                    {
                        "id": 20557,
                        "name": "Atrato",
                        "latitude": "5.57362000",
                        "longitude": "-76.64063000"
                    },
                    {
                        "id": 20559,
                        "name": "Bagadó",
                        "latitude": "5.41164000",
                        "longitude": "-76.41520000"
                    },
                    {
                        "id": 20560,
                        "name": "Bahía Solano",
                        "latitude": "6.22520000",
                        "longitude": "-77.39147000"
                    },
                    {
                        "id": 20561,
                        "name": "Bajo Baudó",
                        "latitude": "4.95334000",
                        "longitude": "-77.36598000"
                    },
                    {
                        "id": 20596,
                        "name": "Bojayá",
                        "latitude": "6.55645000",
                        "longitude": "-76.88389000"
                    },
                    {
                        "id": 20657,
                        "name": "Carmen del Darien",
                        "latitude": "7.15777888",
                        "longitude": "-76.97083333"
                    },
                    {
                        "id": 20767,
                        "name": "Cértegui",
                        "latitude": "5.37073000",
                        "longitude": "-76.60440000"
                    },
                    {
                        "id": 20728,
                        "name": "Condoto",
                        "latitude": "5.09351000",
                        "longitude": "-76.64973000"
                    },
                    {
                        "id": 20791,
                        "name": "El Cantón de San Pablo",
                        "latitude": "5.33889000",
                        "longitude": "-76.73139000"
                    },
                    {
                        "id": 20795,
                        "name": "El Carmen de Atrato",
                        "latitude": "5.83333000",
                        "longitude": "-76.25000000"
                    },
                    {
                        "id": 20952,
                        "name": "Istmina",
                        "latitude": "5.16054000",
                        "longitude": "-76.68397000"
                    },
                    {
                        "id": 20969,
                        "name": "Juradó",
                        "latitude": "7.10421000",
                        "longitude": "-77.76200000"
                    },
                    {
                        "id": 21418,
                        "name": "Litoral del San Juan",
                        "latitude": "4.25875000",
                        "longitude": "-77.36516000"
                    },
                    {
                        "id": 21030,
                        "name": "Lloró",
                        "latitude": "5.49605000",
                        "longitude": "-76.54945000"
                    },
                    {
                        "id": 21076,
                        "name": "Medio Atrato",
                        "latitude": "5.99500000",
                        "longitude": "-76.78250000"
                    },
                    {
                        "id": 21077,
                        "name": "Medio Baudó",
                        "latitude": "5.05000000",
                        "longitude": "-77.05000000"
                    },
                    {
                        "id": 21078,
                        "name": "Medio San Juan",
                        "latitude": "5.09278000",
                        "longitude": "-76.69528000"
                    },
                    {
                        "id": 21143,
                        "name": "Nóvita",
                        "latitude": "4.95511000",
                        "longitude": "-76.60526000"
                    },
                    {
                        "id": 21142,
                        "name": "Nuquí",
                        "latitude": "5.71250000",
                        "longitude": "-77.27083000"
                    },
                    {
                        "id": 21272,
                        "name": "Quibdó",
                        "latitude": "5.76075000",
                        "longitude": "-76.83701000"
                    },
                    {
                        "id": 21304,
                        "name": "Río Iro",
                        "latitude": "5.18333000",
                        "longitude": "-76.48330000"
                    },
                    {
                        "id": 21305,
                        "name": "Río Quito",
                        "latitude": "5.51667000",
                        "longitude": "-76.75000000"
                    },
                    {
                        "id": 21295,
                        "name": "Riosucio",
                        "latitude": "7.41667000",
                        "longitude": "-77.16667000"
                    },
                    {
                        "id": 21371,
                        "name": "San José del Palmar",
                        "latitude": "4.89616000",
                        "longitude": "-76.23422000"
                    },
                    {
                        "id": 21462,
                        "name": "Sipí",
                        "latitude": "4.65374000",
                        "longitude": "-76.64442000"
                    },
                    {
                        "id": 21504,
                        "name": "Tadó",
                        "latitude": "5.26598000",
                        "longitude": "-76.56487000"
                    },
                    {
                        "id": 21570,
                        "name": "Unguía",
                        "latitude": "8.04364000",
                        "longitude": "-77.09137000"
                    },
                    {
                        "id": 21571,
                        "name": "Unión Panamericana",
                        "latitude": "5.28139000",
                        "longitude": "-76.63000000"
                    }
                ]
            },
            {
                "id": 2898,
                "name": "Córdoba",
                "iso2": "COR",
                "latitude": "8.04929300",
                "longitude": "-75.57405000",
                "type": "department",
                "cities": [
                    {
                        "id": 20558,
                        "name": "Ayapel",
                        "latitude": "8.31372000",
                        "longitude": "-75.13982000"
                    },
                    {
                        "id": 20608,
                        "name": "Buenavista",
                        "latitude": "9.04963000",
                        "longitude": "-76.00280000"
                    },
                    {
                        "id": 20642,
                        "name": "Canalete",
                        "latitude": "8.67611000",
                        "longitude": "-76.20417000"
                    },
                    {
                        "id": 20669,
                        "name": "Cereté",
                        "latitude": "8.88479000",
                        "longitude": "-75.79052000"
                    },
                    {
                        "id": 20686,
                        "name": "Chimá",
                        "latitude": "9.14893000",
                        "longitude": "-75.62841000"
                    },
                    {
                        "id": 20690,
                        "name": "Chinú",
                        "latitude": "9.03869000",
                        "longitude": "-75.34273000"
                    },
                    {
                        "id": 20713,
                        "name": "Ciénaga de Oro",
                        "latitude": "8.83581000",
                        "longitude": "-75.60425000"
                    },
                    {
                        "id": 20742,
                        "name": "Cotorra",
                        "latitude": "9.03886000",
                        "longitude": "-75.78969000"
                    },
                    {
                        "id": 20970,
                        "name": "La Apartada",
                        "latitude": "8.04787000",
                        "longitude": "-75.30097000"
                    },
                    {
                        "id": 21031,
                        "name": "Lorica",
                        "latitude": "9.23648000",
                        "longitude": "-75.81350000"
                    },
                    {
                        "id": 21033,
                        "name": "Los Córdobas",
                        "latitude": "8.89403000",
                        "longitude": "-76.35455000"
                    },
                    {
                        "id": 21092,
                        "name": "Momil",
                        "latitude": "9.23767000",
                        "longitude": "-75.67489000"
                    },
                    {
                        "id": 21112,
                        "name": "Moñitos",
                        "latitude": "9.22615000",
                        "longitude": "-76.13594000"
                    },
                    {
                        "id": 21099,
                        "name": "Montelíbano",
                        "latitude": "7.97917000",
                        "longitude": "-75.42020000"
                    },
                    {
                        "id": 21102,
                        "name": "Montería",
                        "latitude": "8.74798000",
                        "longitude": "-75.88143000"
                    },
                    {
                        "id": 21213,
                        "name": "Planeta Rica",
                        "latitude": "8.41150000",
                        "longitude": "-75.58508000"
                    },
                    {
                        "id": 21225,
                        "name": "Pueblo Nuevo",
                        "latitude": "8.24110000",
                        "longitude": "-74.95815000"
                    },
                    {
                        "id": 21241,
                        "name": "Puerto Escondido",
                        "latitude": "8.99453000",
                        "longitude": "-76.19351000"
                    },
                    {
                        "id": 21245,
                        "name": "Puerto Libertador",
                        "latitude": "7.68181000",
                        "longitude": "-75.78312000"
                    },
                    {
                        "id": 21266,
                        "name": "Purísima",
                        "latitude": "9.23657000",
                        "longitude": "-75.72191000"
                    },
                    {
                        "id": 21316,
                        "name": "Sahagún",
                        "latitude": "8.94617000",
                        "longitude": "-75.44275000"
                    },
                    {
                        "id": 21333,
                        "name": "San Andrés de Sotavento",
                        "latitude": "9.12183000",
                        "longitude": "-75.51627000"
                    },
                    {
                        "id": 21335,
                        "name": "San Antero",
                        "latitude": "9.37410000",
                        "longitude": "-75.75891000"
                    },
                    {
                        "id": 21343,
                        "name": "San Bernardo del Viento",
                        "latitude": "9.35330000",
                        "longitude": "-75.95244000"
                    },
                    {
                        "id": 21346,
                        "name": "San Carlos",
                        "latitude": "8.79577000",
                        "longitude": "-75.69947000"
                    },
                    {
                        "id": 149251,
                        "name": "San José de Uré",
                        "latitude": "7.78722222",
                        "longitude": "-75.53305666"
                    },
                    {
                        "id": 21401,
                        "name": "San Pelayo",
                        "latitude": "8.95833000",
                        "longitude": "-75.83627000"
                    },
                    {
                        "id": 21527,
                        "name": "Tierralta",
                        "latitude": "7.87863000",
                        "longitude": "-76.21307000"
                    },
                    {
                        "id": 149258,
                        "name": "Tuchín",
                        "latitude": "9.18583333",
                        "longitude": "-75.55527888"
                    },
                    {
                        "id": 21578,
                        "name": "Valencia",
                        "latitude": "8.23350000",
                        "longitude": "-76.21428000"
                    }
                ]
            },
            {
                "id": 2875,
                "name": "Cundinamarca",
                "iso2": "CUN",
                "latitude": "5.02600300",
                "longitude": "-74.03001220",
                "type": "department",
                "cities": [
                    {
                        "id": 20491,
                        "name": "Agua de Dios",
                        "latitude": "4.37648000",
                        "longitude": "-74.66995000"
                    },
                    {
                        "id": 20501,
                        "name": "Albán",
                        "latitude": "4.89432000",
                        "longitude": "-74.44388000"
                    },
                    {
                        "id": 20516,
                        "name": "Anapoima",
                        "latitude": "4.55099000",
                        "longitude": "-74.53517000"
                    },
                    {
                        "id": 20523,
                        "name": "Anolaima",
                        "latitude": "4.83362000",
                        "longitude": "-74.49950000"
                    },
                    {
                        "id": 20530,
                        "name": "Apulo",
                        "latitude": "4.51952000",
                        "longitude": "-74.59293000"
                    },
                    {
                        "id": 20538,
                        "name": "Arbeláez",
                        "latitude": "4.21251000",
                        "longitude": "-74.41464000"
                    },
                    {
                        "id": 20581,
                        "name": "Beltrán",
                        "latitude": "4.71947000",
                        "longitude": "-74.75660000"
                    },
                    {
                        "id": 20592,
                        "name": "Bituima",
                        "latitude": "4.87252000",
                        "longitude": "-74.53925000"
                    },
                    {
                        "id": 20595,
                        "name": "Bojacá",
                        "latitude": "4.73176000",
                        "longitude": "-74.34129000"
                    },
                    {
                        "id": 20615,
                        "name": "Cabrera",
                        "latitude": "3.98598000",
                        "longitude": "-74.48283000"
                    },
                    {
                        "id": 20619,
                        "name": "Cachipay",
                        "latitude": "5.26667000",
                        "longitude": "-74.56667000"
                    },
                    {
                        "id": 20626,
                        "name": "Cajicá",
                        "latitude": "4.91857000",
                        "longitude": "-74.02799000"
                    },
                    {
                        "id": 20646,
                        "name": "Caparrapí",
                        "latitude": "5.34644000",
                        "longitude": "-74.49147000"
                    },
                    {
                        "id": 20648,
                        "name": "Caqueza",
                        "latitude": "4.38708000",
                        "longitude": "-73.95722000"
                    },
                    {
                        "id": 20655,
                        "name": "Carmen de Carupa",
                        "latitude": "5.34862000",
                        "longitude": "-73.90168000"
                    },
                    {
                        "id": 20675,
                        "name": "Chaguaní",
                        "latitude": "4.94829000",
                        "longitude": "-74.59392000"
                    },
                    {
                        "id": 20705,
                        "name": "Chía",
                        "latitude": "4.84452000",
                        "longitude": "-74.05848000"
                    },
                    {
                        "id": 20691,
                        "name": "Chipaque",
                        "latitude": "4.44250000",
                        "longitude": "-74.04417000"
                    },
                    {
                        "id": 20702,
                        "name": "Choachí",
                        "latitude": "4.52897000",
                        "longitude": "-73.92273000"
                    },
                    {
                        "id": 20703,
                        "name": "Chocontá",
                        "latitude": "5.14468000",
                        "longitude": "-73.68578000"
                    },
                    {
                        "id": 20718,
                        "name": "Cogua",
                        "latitude": "5.06051000",
                        "longitude": "-73.97925000"
                    },
                    {
                        "id": 20741,
                        "name": "Cota",
                        "latitude": "4.80938000",
                        "longitude": "-74.09800000"
                    },
                    {
                        "id": 20752,
                        "name": "Cucunubá",
                        "latitude": "5.24958000",
                        "longitude": "-73.76610000"
                    },
                    {
                        "id": 20803,
                        "name": "El Colegio",
                        "latitude": "4.56047000",
                        "longitude": "-74.42614000"
                    },
                    {
                        "id": 20817,
                        "name": "El Peñón",
                        "latitude": "5.25264000",
                        "longitude": "-74.29069000"
                    },
                    {
                        "id": 20826,
                        "name": "El Rosal",
                        "latitude": "4.85314000",
                        "longitude": "-74.25996000"
                    },
                    {
                        "id": 20842,
                        "name": "Facatativá",
                        "latitude": "4.81367000",
                        "longitude": "-74.35453000"
                    },
                    {
                        "id": 20854,
                        "name": "Fomeque",
                        "latitude": "4.52806000",
                        "longitude": "-73.78879000"
                    },
                    {
                        "id": 20857,
                        "name": "Fosca",
                        "latitude": "4.33916000",
                        "longitude": "-73.93852000"
                    },
                    {
                        "id": 20866,
                        "name": "Funza",
                        "latitude": "4.71638000",
                        "longitude": "-74.21195000"
                    },
                    {
                        "id": 20869,
                        "name": "Fúquene",
                        "latitude": "5.41988000",
                        "longitude": "-73.76997000"
                    },
                    {
                        "id": 20867,
                        "name": "Fusagasugá",
                        "latitude": "4.33646000",
                        "longitude": "-74.36378000"
                    },
                    {
                        "id": 20870,
                        "name": "Gachala",
                        "latitude": "4.66667000",
                        "longitude": "-73.50000000"
                    },
                    {
                        "id": 20872,
                        "name": "Gachancipá",
                        "latitude": "4.99111000",
                        "longitude": "-73.87154000"
                    },
                    {
                        "id": 20874,
                        "name": "Gachetá",
                        "latitude": "4.87104000",
                        "longitude": "-73.61730000"
                    },
                    {
                        "id": 20879,
                        "name": "Gama",
                        "latitude": "4.76288000",
                        "longitude": "-73.61091000"
                    },
                    {
                        "id": 20886,
                        "name": "Girardot",
                        "latitude": "4.31802000",
                        "longitude": "-74.83504000"
                    },
                    {
                        "id": 20892,
                        "name": "Granada",
                        "latitude": "5.06667000",
                        "longitude": "-74.56667000"
                    },
                    {
                        "id": 20898,
                        "name": "Guachetá",
                        "latitude": "5.38425000",
                        "longitude": "-73.68617000"
                    },
                    {
                        "id": 20903,
                        "name": "Guaduas",
                        "latitude": "5.07430000",
                        "longitude": "-74.59854000"
                    },
                    {
                        "id": 20914,
                        "name": "Guasca",
                        "latitude": "4.86601000",
                        "longitude": "-73.87748000"
                    },
                    {
                        "id": 20916,
                        "name": "Guataquí",
                        "latitude": "4.51573000",
                        "longitude": "-74.78935000"
                    },
                    {
                        "id": 20917,
                        "name": "Guatavita",
                        "latitude": "4.93658000",
                        "longitude": "-73.83314000"
                    },
                    {
                        "id": 20921,
                        "name": "Guayabal de Siquima",
                        "latitude": "4.87881000",
                        "longitude": "-74.48306000"
                    },
                    {
                        "id": 20923,
                        "name": "Guayabetal",
                        "latitude": "4.21472000",
                        "longitude": "-73.81719000"
                    },
                    {
                        "id": 20925,
                        "name": "Gutiérrez",
                        "latitude": "4.18486000",
                        "longitude": "-74.01168000"
                    },
                    {
                        "id": 20963,
                        "name": "Jerusalén",
                        "latitude": "4.56309000",
                        "longitude": "-74.69519000"
                    },
                    {
                        "id": 20968,
                        "name": "Junín",
                        "latitude": "4.70725000",
                        "longitude": "-73.69549000"
                    },
                    {
                        "id": 20972,
                        "name": "La Calera",
                        "latitude": "4.68678000",
                        "longitude": "-73.93590000"
                    },
                    {
                        "id": 20993,
                        "name": "La Mesa",
                        "latitude": "4.65374000",
                        "longitude": "-74.47316000"
                    },
                    {
                        "id": 20995,
                        "name": "La Palma",
                        "latitude": "5.31732000",
                        "longitude": "-74.43003000"
                    },
                    {
                        "id": 20999,
                        "name": "La Peña",
                        "latitude": "5.19847000",
                        "longitude": "-74.39368000"
                    },
                    {
                        "id": 21012,
                        "name": "La Vega",
                        "latitude": "4.97382000",
                        "longitude": "-74.34476000"
                    },
                    {
                        "id": 21026,
                        "name": "Lenguazaque",
                        "latitude": "5.30711000",
                        "longitude": "-73.71152000"
                    },
                    {
                        "id": 21045,
                        "name": "Macheta",
                        "latitude": "5.08333000",
                        "longitude": "-73.61667000"
                    },
                    {
                        "id": 21047,
                        "name": "Madrid",
                        "latitude": "4.75564000",
                        "longitude": "-74.27708000"
                    },
                    {
                        "id": 21060,
                        "name": "Manta",
                        "latitude": "4.95720000",
                        "longitude": "-73.58583000"
                    },
                    {
                        "id": 21075,
                        "name": "Medina",
                        "latitude": "4.51005000",
                        "longitude": "-73.34982000"
                    },
                    {
                        "id": 21109,
                        "name": "Mosquera",
                        "latitude": "4.68935000",
                        "longitude": "-74.23599000"
                    },
                    {
                        "id": 21127,
                        "name": "Nariño",
                        "latitude": "4.39913000",
                        "longitude": "-74.82239000"
                    },
                    {
                        "id": 21132,
                        "name": "Nemocón",
                        "latitude": "5.06767000",
                        "longitude": "-73.87769000"
                    },
                    {
                        "id": 21133,
                        "name": "Nilo",
                        "latitude": "4.30604000",
                        "longitude": "-74.62083000"
                    },
                    {
                        "id": 21134,
                        "name": "Nimaima",
                        "latitude": "5.12614000",
                        "longitude": "-74.38495000"
                    },
                    {
                        "id": 21136,
                        "name": "Nocaima",
                        "latitude": "5.06696000",
                        "longitude": "-74.38439000"
                    },
                    {
                        "id": 21159,
                        "name": "Pacho",
                        "latitude": "5.13055555",
                        "longitude": "-74.15833333"
                    },
                    {
                        "id": 21165,
                        "name": "Paime",
                        "latitude": "5.37054000",
                        "longitude": "-74.15219000"
                    },
                    {
                        "id": 21179,
                        "name": "Pandi",
                        "latitude": "4.18032000",
                        "longitude": "-74.47099000"
                    },
                    {
                        "id": 21182,
                        "name": "Paratebueno",
                        "latitude": "4.37575000",
                        "longitude": "-73.21547000"
                    },
                    {
                        "id": 21183,
                        "name": "Pasca",
                        "latitude": "4.30722000",
                        "longitude": "-74.30056000"
                    },
                    {
                        "id": 21254,
                        "name": "Puerto Salgar",
                        "latitude": "5.61892000",
                        "longitude": "-74.58483000"
                    },
                    {
                        "id": 21261,
                        "name": "Pulí",
                        "latitude": "4.68116000",
                        "longitude": "-74.71406000"
                    },
                    {
                        "id": 21270,
                        "name": "Quebradanegra",
                        "latitude": "5.08262000",
                        "longitude": "-74.52117000"
                    },
                    {
                        "id": 21271,
                        "name": "Quetame",
                        "latitude": "4.33234000",
                        "longitude": "-73.86141000"
                    },
                    {
                        "id": 21275,
                        "name": "Quipile",
                        "latitude": "4.74517000",
                        "longitude": "-74.53378000"
                    },
                    {
                        "id": 21287,
                        "name": "Ricaurte",
                        "latitude": "4.28075000",
                        "longitude": "-74.76469000"
                    },
                    {
                        "id": 21338,
                        "name": "San Antonio del Tequendama",
                        "latitude": "4.61667000",
                        "longitude": "-74.35000000"
                    },
                    {
                        "id": 21342,
                        "name": "San Bernardo",
                        "latitude": "4.12956000",
                        "longitude": "-74.35903000"
                    },
                    {
                        "id": 21348,
                        "name": "San Cayetano",
                        "latitude": "5.31693000",
                        "longitude": "-74.07141000"
                    },
                    {
                        "id": 21358,
                        "name": "San Francisco",
                        "latitude": "4.96335000",
                        "longitude": "-74.26613000"
                    },
                    {
                        "id": 21375,
                        "name": "San Juan de Río Seco",
                        "latitude": "4.83077000",
                        "longitude": "-74.68248000"
                    },
                    {
                        "id": 21446,
                        "name": "Sasaima",
                        "latitude": "4.96705000",
                        "longitude": "-74.43512000"
                    },
                    {
                        "id": 21450,
                        "name": "Sesquilé",
                        "latitude": "5.04463000",
                        "longitude": "-73.79724000"
                    },
                    {
                        "id": 21453,
                        "name": "Sibaté",
                        "latitude": "4.49154000",
                        "longitude": "-74.25957000"
                    },
                    {
                        "id": 21456,
                        "name": "Silvania",
                        "latitude": "4.40367000",
                        "longitude": "-74.38670000"
                    },
                    {
                        "id": 21459,
                        "name": "Simijaca",
                        "latitude": "5.50415000",
                        "longitude": "-73.86944000"
                    },
                    {
                        "id": 21464,
                        "name": "Soacha",
                        "latitude": "4.57937000",
                        "longitude": "-74.21682000"
                    },
                    {
                        "id": 21478,
                        "name": "Sopó",
                        "latitude": "4.90750000",
                        "longitude": "-73.93840000"
                    },
                    {
                        "id": 21486,
                        "name": "Subachoque",
                        "latitude": "4.92614000",
                        "longitude": "-74.17299000"
                    },
                    {
                        "id": 21490,
                        "name": "Suesca",
                        "latitude": "5.10289000",
                        "longitude": "-73.79845000"
                    },
                    {
                        "id": 21491,
                        "name": "Supatá",
                        "latitude": "5.06097000",
                        "longitude": "-74.23721000"
                    },
                    {
                        "id": 21494,
                        "name": "Susa",
                        "latitude": "5.42700000",
                        "longitude": "-73.84786000"
                    },
                    {
                        "id": 21497,
                        "name": "Sutatausa",
                        "latitude": "5.24779000",
                        "longitude": "-73.85238000"
                    },
                    {
                        "id": 21503,
                        "name": "Tabio",
                        "latitude": "4.91726000",
                        "longitude": "-74.09364000"
                    },
                    {
                        "id": 21517,
                        "name": "Tausa",
                        "latitude": "5.19903000",
                        "longitude": "-73.89128000"
                    },
                    {
                        "id": 21518,
                        "name": "Tena",
                        "latitude": "4.66001000",
                        "longitude": "-74.39258000"
                    },
                    {
                        "id": 21520,
                        "name": "Tenjo",
                        "latitude": "4.87270000",
                        "longitude": "-74.14435000"
                    },
                    {
                        "id": 21522,
                        "name": "Tibacuy",
                        "latitude": "4.30606000",
                        "longitude": "-74.51639000"
                    },
                    {
                        "id": 21525,
                        "name": "Tibirita",
                        "latitude": "5.05227000",
                        "longitude": "-73.50459000"
                    },
                    {
                        "id": 21534,
                        "name": "Tocaima",
                        "latitude": "4.46073000",
                        "longitude": "-74.65722000"
                    },
                    {
                        "id": 21535,
                        "name": "Tocancipá",
                        "latitude": "4.96531000",
                        "longitude": "-73.91301000"
                    },
                    {
                        "id": 21541,
                        "name": "Topaipí",
                        "latitude": "5.33457000",
                        "longitude": "-74.30292000"
                    },
                    {
                        "id": 21565,
                        "name": "Ubalá",
                        "latitude": "4.74778000",
                        "longitude": "-72.53694000"
                    },
                    {
                        "id": 21566,
                        "name": "Ubaque",
                        "latitude": "4.48667000",
                        "longitude": "-73.93748000"
                    },
                    {
                        "id": 21569,
                        "name": "Une",
                        "latitude": "4.30691000",
                        "longitude": "-74.07104000"
                    },
                    {
                        "id": 21640,
                        "name": "Útica",
                        "latitude": "5.16977000",
                        "longitude": "-74.50134000"
                    },
                    {
                        "id": 21587,
                        "name": "Venecia",
                        "latitude": "4.08808000",
                        "longitude": "-74.47746000"
                    },
                    {
                        "id": 21590,
                        "name": "Vergara",
                        "latitude": "5.13600000",
                        "longitude": "-74.31539000"
                    },
                    {
                        "id": 21593,
                        "name": "Vianí",
                        "latitude": "4.89579000",
                        "longitude": "-74.55398000"
                    },
                    {
                        "id": 21599,
                        "name": "Villa de San Diego de Ubate",
                        "latitude": "5.31544000",
                        "longitude": "-73.82045000"
                    },
                    {
                        "id": 21603,
                        "name": "Villagómez",
                        "latitude": "5.27372000",
                        "longitude": "-74.19614000"
                    },
                    {
                        "id": 21610,
                        "name": "Villapinzón",
                        "latitude": "5.21617000",
                        "longitude": "-73.59490000"
                    },
                    {
                        "id": 21613,
                        "name": "Villeta",
                        "latitude": "5.00008000",
                        "longitude": "-74.50498000"
                    },
                    {
                        "id": 21614,
                        "name": "Viotá",
                        "latitude": "4.43713000",
                        "longitude": "-74.52157000"
                    },
                    {
                        "id": 21619,
                        "name": "Yacopí",
                        "latitude": "5.45948000",
                        "longitude": "-74.33823000"
                    },
                    {
                        "id": 21635,
                        "name": "Zipacón",
                        "latitude": "4.75881000",
                        "longitude": "-74.38017000"
                    },
                    {
                        "id": 21636,
                        "name": "Zipaquirá",
                        "latitude": "5.02208000",
                        "longitude": "-74.00481000"
                    }
                ]
            },
            {
                "id": 2882,
                "name": "Guainía",
                "iso2": "GUA",
                "latitude": "2.58539300",
                "longitude": "-68.52471490",
                "type": "department",
                "cities": [
                    {
                        "id": 20572,
                        "name": "Barranco Minas",
                        "latitude": "3.09899000",
                        "longitude": "-69.58297000"
                    },
                    {
                        "id": 20618,
                        "name": "Cacahual",
                        "latitude": "3.32533000",
                        "longitude": "-67.62397000"
                    },
                    {
                        "id": 20949,
                        "name": "Inírida",
                        "latitude": "3.86528000",
                        "longitude": "-67.92389000"
                    },
                    {
                        "id": 20986,
                        "name": "La Guadalupe",
                        "latitude": "1.39579000",
                        "longitude": "-67.00150000"
                    },
                    {
                        "id": 21063,
                        "name": "Mapiripana",
                        "latitude": "2.81003000",
                        "longitude": "-70.28568000"
                    },
                    {
                        "id": 21106,
                        "name": "Morichal",
                        "latitude": "2.42980000",
                        "longitude": "-69.83284000"
                    },
                    {
                        "id": 21178,
                        "name": "Pana Pana",
                        "latitude": "1.96249000",
                        "longitude": "-69.12600000"
                    },
                    {
                        "id": 21239,
                        "name": "Puerto Colombia",
                        "latitude": "2.43903000",
                        "longitude": "-68.16419000"
                    },
                    {
                        "id": 21354,
                        "name": "San Felipe",
                        "latitude": "2.14321000",
                        "longitude": "-67.34122000"
                    }
                ]
            },
            {
                "id": 2888,
                "name": "Guaviare",
                "iso2": "GUV",
                "latitude": "2.04392400",
                "longitude": "-72.33111300",
                "type": "department",
                "cities": [
                    {
                        "id": 20627,
                        "name": "Calamar",
                        "latitude": "1.95960000",
                        "longitude": "-72.65315000"
                    },
                    {
                        "id": 20823,
                        "name": "El Retorno",
                        "latitude": "2.33022000",
                        "longitude": "-72.62765000"
                    },
                    {
                        "id": 21083,
                        "name": "Miraflores",
                        "latitude": "1.33667000",
                        "longitude": "-71.95111000"
                    },
                    {
                        "id": 21370,
                        "name": "San José del Guaviare",
                        "latitude": "2.57286000",
                        "longitude": "-72.64591000"
                    }
                ]
            },
            {
                "id": 4871,
                "name": "Huila",
                "iso2": "HUI",
                "latitude": "2.53593490",
                "longitude": "-75.52766990",
                "type": "department",
                "cities": [
                    {
                        "id": 143877,
                        "name": "Acevedo",
                        "latitude": "1.83611111",
                        "longitude": "-75.85500000"
                    },
                    {
                        "id": 143878,
                        "name": "Aipe",
                        "latitude": "3.22194444",
                        "longitude": "-75.23750000"
                    },
                    {
                        "id": 143879,
                        "name": "Algeciras",
                        "latitude": "2.52194444",
                        "longitude": "-75.31444444"
                    },
                    {
                        "id": 143880,
                        "name": "Altamira",
                        "latitude": "2.06333333",
                        "longitude": "-75.78777778"
                    },
                    {
                        "id": 143881,
                        "name": "Baraya",
                        "latitude": "3.15305556",
                        "longitude": "-75.05250000"
                    },
                    {
                        "id": 143882,
                        "name": "Campoalegre",
                        "latitude": "2.68666667",
                        "longitude": "-75.32555556"
                    },
                    {
                        "id": 143883,
                        "name": "Colombia",
                        "latitude": "3.37500000",
                        "longitude": "-74.80194444"
                    },
                    {
                        "id": 143884,
                        "name": "El Agrado",
                        "latitude": "2.25833056",
                        "longitude": "-75.77250000"
                    },
                    {
                        "id": 143885,
                        "name": "Elias",
                        "latitude": "2.01361111",
                        "longitude": "-75.93972222"
                    },
                    {
                        "id": 143886,
                        "name": "Garzón",
                        "latitude": "2.19611111",
                        "longitude": "-75.62916667"
                    },
                    {
                        "id": 143887,
                        "name": "Gigante",
                        "latitude": "2.38666944",
                        "longitude": "-75.54610000"
                    },
                    {
                        "id": 143888,
                        "name": "Guadalupe",
                        "latitude": "2.02500000",
                        "longitude": "-75.75638889"
                    },
                    {
                        "id": 143889,
                        "name": "Hobo",
                        "latitude": "2.58250000",
                        "longitude": "-75.45111111"
                    },
                    {
                        "id": 143890,
                        "name": "Iquira",
                        "latitude": "2.64833333",
                        "longitude": "-75.63638889"
                    },
                    {
                        "id": 143891,
                        "name": "Isnos",
                        "latitude": "1.92888889",
                        "longitude": "-76.21583333"
                    },
                    {
                        "id": 149242,
                        "name": "La Argentina",
                        "latitude": "2.19755555",
                        "longitude": "-75.98888888"
                    },
                    {
                        "id": 143892,
                        "name": "La Plata",
                        "latitude": "2.39000000",
                        "longitude": "-75.89194444"
                    },
                    {
                        "id": 143893,
                        "name": "Nataga",
                        "latitude": "2.54388889",
                        "longitude": "-75.80861111"
                    },
                    {
                        "id": 143894,
                        "name": "Neiva",
                        "latitude": "2.92750000",
                        "longitude": "-75.28750000"
                    },
                    {
                        "id": 143895,
                        "name": "Oporapa",
                        "latitude": "2.02305556",
                        "longitude": "-75.99527778"
                    },
                    {
                        "id": 143896,
                        "name": "Paicol",
                        "latitude": "2.44972222",
                        "longitude": "-75.77388889"
                    },
                    {
                        "id": 143897,
                        "name": "Palermo",
                        "latitude": "2.88833333",
                        "longitude": "-75.43388889"
                    },
                    {
                        "id": 143898,
                        "name": "Palestina",
                        "latitude": "1.72250000",
                        "longitude": "-76.13055556"
                    },
                    {
                        "id": 143899,
                        "name": "Pital",
                        "latitude": "2.26638889",
                        "longitude": "-75.80444444"
                    },
                    {
                        "id": 143900,
                        "name": "Pitalito",
                        "latitude": "1.85388889",
                        "longitude": "-76.05138889"
                    },
                    {
                        "id": 143901,
                        "name": "Rivera",
                        "latitude": "2.77722222",
                        "longitude": "-75.25638889"
                    },
                    {
                        "id": 143902,
                        "name": "Saladoblanco",
                        "latitude": "1.99333333",
                        "longitude": "-76.04527778"
                    },
                    {
                        "id": 143903,
                        "name": "San Agustín",
                        "latitude": "1.87916667",
                        "longitude": "-76.26833333"
                    },
                    {
                        "id": 143904,
                        "name": "Santa María",
                        "latitude": "2.93777778",
                        "longitude": "-75.58694444"
                    },
                    {
                        "id": 143905,
                        "name": "Suaza",
                        "latitude": "1.97500000",
                        "longitude": "-75.79555556"
                    },
                    {
                        "id": 143906,
                        "name": "Tarqui",
                        "latitude": "2.11055556",
                        "longitude": "-75.82305556"
                    },
                    {
                        "id": 143907,
                        "name": "Tello",
                        "latitude": "3.06666667",
                        "longitude": "-75.13861111"
                    },
                    {
                        "id": 143908,
                        "name": "Teruel",
                        "latitude": "2.74055556",
                        "longitude": "-75.56833333"
                    },
                    {
                        "id": 143909,
                        "name": "Tesalia",
                        "latitude": "2.48472222",
                        "longitude": "-75.73000000"
                    },
                    {
                        "id": 143910,
                        "name": "Timana",
                        "latitude": "1.97136000",
                        "longitude": "-75.93123000"
                    },
                    {
                        "id": 143911,
                        "name": "Villavieja",
                        "latitude": "3.21888889",
                        "longitude": "-75.21833333"
                    },
                    {
                        "id": 143912,
                        "name": "Yaguará",
                        "latitude": "2.66361111",
                        "longitude": "-75.51750000"
                    }
                ]
            },
            {
                "id": 2889,
                "name": "La Guajira",
                "iso2": "LAG",
                "latitude": "11.35477430",
                "longitude": "-72.52048270",
                "type": "department",
                "cities": [
                    {
                        "id": 20498,
                        "name": "Albania",
                        "latitude": "11.16099000",
                        "longitude": "-72.59238000"
                    },
                    {
                        "id": 20571,
                        "name": "Barrancas",
                        "latitude": "10.97180000",
                        "longitude": "-72.69115000"
                    },
                    {
                        "id": 20776,
                        "name": "Dibulla",
                        "latitude": "11.27251000",
                        "longitude": "-73.30911000"
                    },
                    {
                        "id": 20777,
                        "name": "Distracción",
                        "latitude": "10.89784000",
                        "longitude": "-72.88666000"
                    },
                    {
                        "id": 20812,
                        "name": "El Molino",
                        "latitude": "10.65296000",
                        "longitude": "-72.92461000"
                    },
                    {
                        "id": 20855,
                        "name": "Fonseca",
                        "latitude": "10.82966000",
                        "longitude": "-72.79778000"
                    },
                    {
                        "id": 20938,
                        "name": "Hatonuevo",
                        "latitude": "11.06940000",
                        "longitude": "-72.76690000"
                    },
                    {
                        "id": 20988,
                        "name": "La Jagua del Pilar",
                        "latitude": "10.51061000",
                        "longitude": "-73.07178000"
                    },
                    {
                        "id": 21051,
                        "name": "Maicao",
                        "latitude": "11.37837000",
                        "longitude": "-72.23950000"
                    },
                    {
                        "id": 21056,
                        "name": "Manaure",
                        "latitude": "11.77505000",
                        "longitude": "-72.44447000"
                    },
                    {
                        "id": 21291,
                        "name": "Riohacha",
                        "latitude": "11.54444000",
                        "longitude": "-72.90722000"
                    },
                    {
                        "id": 21377,
                        "name": "San Juan del Cesar",
                        "latitude": "10.77107000",
                        "longitude": "-73.00314000"
                    },
                    {
                        "id": 21573,
                        "name": "Uribia",
                        "latitude": "12.02638000",
                        "longitude": "-71.74887000"
                    },
                    {
                        "id": 21575,
                        "name": "Urumita",
                        "latitude": "10.55894000",
                        "longitude": "-73.01232000"
                    },
                    {
                        "id": 21608,
                        "name": "Villanueva",
                        "latitude": "10.58333000",
                        "longitude": "-72.96077000"
                    }
                ]
            },
            {
                "id": 2886,
                "name": "Magdalena",
                "iso2": "MAG",
                "latitude": "10.41130140",
                "longitude": "-74.40566120",
                "type": "department",
                "cities": [
                    {
                        "id": 20505,
                        "name": "Algarrobo",
                        "latitude": "10.18553000",
                        "longitude": "-74.06158000"
                    },
                    {
                        "id": 20533,
                        "name": "Aracataca",
                        "latitude": "10.59181000",
                        "longitude": "-74.18983000"
                    },
                    {
                        "id": 20548,
                        "name": "Ariguaní",
                        "latitude": "9.89383000",
                        "longitude": "-74.13583000"
                    },
                    {
                        "id": 20673,
                        "name": "Cerro de San Antonio",
                        "latitude": "10.32585000",
                        "longitude": "-74.86933000"
                    },
                    {
                        "id": 20700,
                        "name": "Chivolo",
                        "latitude": "10.02638888",
                        "longitude": "-74.62138888"
                    },
                    {
                        "id": 20712,
                        "name": "Ciénaga",
                        "latitude": "10.83333000",
                        "longitude": "-74.08333000"
                    },
                    {
                        "id": 20726,
                        "name": "Concordia",
                        "latitude": "9.83545000",
                        "longitude": "-74.45548000"
                    },
                    {
                        "id": 20787,
                        "name": "El Banco",
                        "latitude": "9.00114000",
                        "longitude": "-73.97581000"
                    },
                    {
                        "id": 20820,
                        "name": "El Piñon",
                        "latitude": "10.33333000",
                        "longitude": "-74.66667000"
                    },
                    {
                        "id": 20824,
                        "name": "El Retén",
                        "latitude": "10.61135000",
                        "longitude": "-74.26824000"
                    },
                    {
                        "id": 20864,
                        "name": "Fundación",
                        "latitude": "10.52066000",
                        "longitude": "-74.18504000"
                    },
                    {
                        "id": 20907,
                        "name": "Guamal",
                        "latitude": "9.14334000",
                        "longitude": "-74.22384000"
                    },
                    {
                        "id": 21139,
                        "name": "Nueva Granada",
                        "latitude": "9.80168000",
                        "longitude": "-74.39304000"
                    },
                    {
                        "id": 21191,
                        "name": "Pedraza",
                        "latitude": "10.18739000",
                        "longitude": "-74.91504000"
                    },
                    {
                        "id": 21205,
                        "name": "Pijiño del Carmen",
                        "latitude": "9.32908000",
                        "longitude": "-74.45302000"
                    },
                    {
                        "id": 21210,
                        "name": "Pivijay",
                        "latitude": "10.46167000",
                        "longitude": "-74.61621000"
                    },
                    {
                        "id": 21214,
                        "name": "Plato",
                        "latitude": "9.77267000",
                        "longitude": "-74.74548000"
                    },
                    {
                        "id": 21228,
                        "name": "Puebloviejo",
                        "latitude": "10.84239000",
                        "longitude": "-74.38538000"
                    },
                    {
                        "id": 21282,
                        "name": "Remolino",
                        "latitude": "10.65048000",
                        "longitude": "-74.58442000"
                    },
                    {
                        "id": 21313,
                        "name": "Sabanas de San Angel",
                        "latitude": "10.11072000",
                        "longitude": "-74.26007000"
                    },
                    {
                        "id": 21318,
                        "name": "Salamina",
                        "latitude": "10.49027000",
                        "longitude": "-74.79463000"
                    },
                    {
                        "id": 20606,
                        "name": "San Sebastián de Buenavista",
                        "latitude": "9.23916666",
                        "longitude": "-74.35194444"
                    },
                    {
                        "id": 21409,
                        "name": "San Zenón",
                        "latitude": "9.32686000",
                        "longitude": "-74.32914000"
                    },
                    {
                        "id": 21411,
                        "name": "Santa Ana",
                        "latitude": "9.51484000",
                        "longitude": "-74.34330000"
                    },
                    {
                        "id": 21415,
                        "name": "Santa Bárbara de Pinto",
                        "latitude": "9.52107000",
                        "longitude": "-74.64912000"
                    },
                    {
                        "id": 21421,
                        "name": "Santa Marta",
                        "latitude": "11.24348000",
                        "longitude": "-74.20835000"
                    },
                    {
                        "id": 21463,
                        "name": "Sitionuevo",
                        "latitude": "10.77737000",
                        "longitude": "-74.72049000"
                    },
                    {
                        "id": 21519,
                        "name": "Tenerife",
                        "latitude": "9.93201000",
                        "longitude": "-74.73465000"
                    },
                    {
                        "id": 21631,
                        "name": "Zapayán",
                        "latitude": "10.11846000",
                        "longitude": "-74.69143000"
                    },
                    {
                        "id": 21637,
                        "name": "Zona Bananera",
                        "latitude": "10.76417000",
                        "longitude": "-74.15722000"
                    }
                ]
            },
            {
                "id": 2878,
                "name": "Meta",
                "iso2": "MET",
                "latitude": "39.76732580",
                "longitude": "-104.97535950",
                "type": "department",
                "cities": [
                    {
                        "id": 20488,
                        "name": "Acacías",
                        "latitude": "3.98695000",
                        "longitude": "-73.75797000"
                    },
                    {
                        "id": 20569,
                        "name": "Barranca de Upía",
                        "latitude": "4.56963000",
                        "longitude": "-72.96676000"
                    },
                    {
                        "id": 20617,
                        "name": "Cabuyaro",
                        "latitude": "4.28170000",
                        "longitude": "-72.79399000"
                    },
                    {
                        "id": 20665,
                        "name": "Castilla la Nueva",
                        "latitude": "3.82722000",
                        "longitude": "-73.68831000"
                    },
                    {
                        "id": 20749,
                        "name": "Cubarral",
                        "latitude": "3.79536000",
                        "longitude": "-73.84063000"
                    },
                    {
                        "id": 20754,
                        "name": "Cumaral",
                        "latitude": "4.23814000",
                        "longitude": "-73.34101000"
                    },
                    {
                        "id": 20790,
                        "name": "El Calvario",
                        "latitude": "4.35426000",
                        "longitude": "-73.74431000"
                    },
                    {
                        "id": 20799,
                        "name": "El Castillo",
                        "latitude": "3.56363000",
                        "longitude": "-73.79488000"
                    },
                    {
                        "id": 149240,
                        "name": "El Dorado",
                        "latitude": "3.73916777",
                        "longitude": "-73.83527888"
                    },
                    {
                        "id": 20863,
                        "name": "Fuente de Oro",
                        "latitude": "3.46263000",
                        "longitude": "-73.62162000"
                    },
                    {
                        "id": 20894,
                        "name": "Granada",
                        "latitude": "3.54625000",
                        "longitude": "-73.70687000"
                    },
                    {
                        "id": 20906,
                        "name": "Guamal",
                        "latitude": "3.88043000",
                        "longitude": "-73.76566000"
                    },
                    {
                        "id": 20990,
                        "name": "La Macarena",
                        "latitude": "2.00702000",
                        "longitude": "-74.07320000"
                    },
                    {
                        "id": 21025,
                        "name": "Lejanías",
                        "latitude": "3.52762000",
                        "longitude": "-74.02335000"
                    },
                    {
                        "id": 21064,
                        "name": "Mapiripán",
                        "latitude": "2.89115000",
                        "longitude": "-72.13328000"
                    },
                    {
                        "id": 21081,
                        "name": "Mesetas",
                        "latitude": "3.38463000",
                        "longitude": "-74.04424000"
                    },
                    {
                        "id": 21240,
                        "name": "Puerto Concordia",
                        "latitude": "2.62206000",
                        "longitude": "-72.75724000"
                    },
                    {
                        "id": 21242,
                        "name": "Puerto Gaitán",
                        "latitude": "4.31328000",
                        "longitude": "-72.08157000"
                    },
                    {
                        "id": 21246,
                        "name": "Puerto Lleras",
                        "latitude": "3.21794000",
                        "longitude": "-73.23215000"
                    },
                    {
                        "id": 21247,
                        "name": "Puerto López",
                        "latitude": "4.04426000",
                        "longitude": "-72.65731000"
                    },
                    {
                        "id": 21252,
                        "name": "Puerto Rico",
                        "latitude": "2.93833000",
                        "longitude": "-73.20833000"
                    },
                    {
                        "id": 21284,
                        "name": "Restrepo",
                        "latitude": "4.25833000",
                        "longitude": "-73.56142000"
                    },
                    {
                        "id": 21347,
                        "name": "San Carlos de Guaroa",
                        "latitude": "3.71161000",
                        "longitude": "-73.24344000"
                    },
                    {
                        "id": 21373,
                        "name": "San Juan de Arama",
                        "latitude": "3.29034000",
                        "longitude": "-73.82065000"
                    },
                    {
                        "id": 149252,
                        "name": "San Juanito",
                        "latitude": "4.45861111",
                        "longitude": "-73.67555666"
                    },
                    {
                        "id": 21385,
                        "name": "San Martín",
                        "latitude": "3.50819000",
                        "longitude": "-73.03975000"
                    },
                    {
                        "id": 149259,
                        "name": "Uribe",
                        "latitude": "3.24083333",
                        "longitude": "-74.35361111"
                    },
                    {
                        "id": 21612,
                        "name": "Villavicencio",
                        "latitude": "4.07424000",
                        "longitude": "-73.49150000"
                    },
                    {
                        "id": 21616,
                        "name": "Vistahermosa",
                        "latitude": "3.12428000",
                        "longitude": "-73.75156000"
                    }
                ]
            },
            {
                "id": 2897,
                "name": "Nariño",
                "iso2": "NAR",
                "latitude": "1.28915100",
                "longitude": "-77.35794000",
                "type": "department",
                "cities": [
                    {
                        "id": 20503,
                        "name": "Aldana",
                        "latitude": "0.88283000",
                        "longitude": "-77.70103000"
                    },
                    {
                        "id": 20517,
                        "name": "Ancuya",
                        "latitude": "1.26330000",
                        "longitude": "-77.51376000"
                    },
                    {
                        "id": 20539,
                        "name": "Arboleda",
                        "latitude": "1.49830000",
                        "longitude": "-77.13613000"
                    },
                    {
                        "id": 20565,
                        "name": "Barbacoas",
                        "latitude": "1.67154000",
                        "longitude": "-78.13978000"
                    },
                    {
                        "id": 20582,
                        "name": "Belén",
                        "latitude": "1.59477000",
                        "longitude": "-77.05408000"
                    },
                    {
                        "id": 20611,
                        "name": "Buesaco",
                        "latitude": "1.38364000",
                        "longitude": "-77.15622000"
                    },
                    {
                        "id": 20674,
                        "name": "Chachagüí",
                        "latitude": "1.35943000",
                        "longitude": "-77.28367000"
                    },
                    {
                        "id": 20722,
                        "name": "Colón",
                        "latitude": "1.62850000",
                        "longitude": "-77.02927000"
                    },
                    {
                        "id": 20730,
                        "name": "Consaca",
                        "latitude": "1.20841000",
                        "longitude": "-77.46323000"
                    },
                    {
                        "id": 20732,
                        "name": "Contadero",
                        "latitude": "0.93072000",
                        "longitude": "-77.53333000"
                    },
                    {
                        "id": 20769,
                        "name": "Córdoba",
                        "latitude": "0.85362000",
                        "longitude": "-77.51817000"
                    },
                    {
                        "id": 20748,
                        "name": "Cuaspud",
                        "latitude": "0.87570000",
                        "longitude": "-77.73640000"
                    },
                    {
                        "id": 20756,
                        "name": "Cumbal",
                        "latitude": "0.90875000",
                        "longitude": "-77.79145000"
                    },
                    {
                        "id": 20757,
                        "name": "Cumbitara",
                        "latitude": "1.64786000",
                        "longitude": "-77.57819000"
                    },
                    {
                        "id": 20801,
                        "name": "El Charco",
                        "latitude": "2.47926000",
                        "longitude": "-78.10972000"
                    },
                    {
                        "id": 20816,
                        "name": "El Peñol",
                        "latitude": "1.45365000",
                        "longitude": "-77.44017000"
                    },
                    {
                        "id": 20827,
                        "name": "El Rosario",
                        "latitude": "1.84593000",
                        "longitude": "-77.40620000"
                    },
                    {
                        "id": 20829,
                        "name": "El Tablón de Gómez",
                        "latitude": "1.42717000",
                        "longitude": "-77.09693000"
                    },
                    {
                        "id": 20832,
                        "name": "El Tambo",
                        "latitude": "1.43049000",
                        "longitude": "-77.38326000"
                    },
                    {
                        "id": 20858,
                        "name": "Francisco Pizarro",
                        "latitude": "2.04060000",
                        "longitude": "-78.65877000"
                    },
                    {
                        "id": 20865,
                        "name": "Funes",
                        "latitude": "1.00075000",
                        "longitude": "-77.44918000"
                    },
                    {
                        "id": 20899,
                        "name": "Guachucal",
                        "latitude": "0.96093000",
                        "longitude": "-77.73161000"
                    },
                    {
                        "id": 20904,
                        "name": "Guaitarilla",
                        "latitude": "1.13103000",
                        "longitude": "-77.54815000"
                    },
                    {
                        "id": 20905,
                        "name": "Gualmatán",
                        "latitude": "0.91992000",
                        "longitude": "-77.56738000"
                    },
                    {
                        "id": 20946,
                        "name": "Iles",
                        "latitude": "0.97040000",
                        "longitude": "-77.52146000"
                    },
                    {
                        "id": 20947,
                        "name": "Imués",
                        "latitude": "1.05516000",
                        "longitude": "-77.49669000"
                    },
                    {
                        "id": 20950,
                        "name": "Ipiales",
                        "latitude": "0.82501000",
                        "longitude": "-77.63966000"
                    },
                    {
                        "id": 20978,
                        "name": "La Cruz",
                        "latitude": "1.60221000",
                        "longitude": "-76.97130000"
                    },
                    {
                        "id": 20984,
                        "name": "La Florida",
                        "latitude": "1.35693000",
                        "longitude": "-77.41271000"
                    },
                    {
                        "id": 20989,
                        "name": "La Llanada",
                        "latitude": "1.47310000",
                        "longitude": "-77.58024000"
                    },
                    {
                        "id": 21005,
                        "name": "La Tola",
                        "latitude": "2.39949000",
                        "longitude": "-78.18923000"
                    },
                    {
                        "id": 21008,
                        "name": "La Unión",
                        "latitude": "1.60450000",
                        "longitude": "-77.13152000"
                    },
                    {
                        "id": 21024,
                        "name": "Leiva",
                        "latitude": "1.93497000",
                        "longitude": "-77.30634000"
                    },
                    {
                        "id": 21029,
                        "name": "Linares",
                        "latitude": "1.35078000",
                        "longitude": "-77.52339000"
                    },
                    {
                        "id": 21032,
                        "name": "Los Andes",
                        "latitude": "1.49474000",
                        "longitude": "-77.52136000"
                    },
                    {
                        "id": 21189,
                        "name": "Magüí Payán",
                        "latitude": "1.76645000",
                        "longitude": "-78.18326000"
                    },
                    {
                        "id": 21054,
                        "name": "Mallama",
                        "latitude": "1.14109000",
                        "longitude": "-77.86479000"
                    },
                    {
                        "id": 21108,
                        "name": "Mosquera",
                        "latitude": "2.49139000",
                        "longitude": "-78.44307000"
                    },
                    {
                        "id": 21125,
                        "name": "Nariño",
                        "latitude": "1.28995000",
                        "longitude": "-77.35721000"
                    },
                    {
                        "id": 21150,
                        "name": "Olaya Herrera",
                        "latitude": "1.24803000",
                        "longitude": "-77.49085000"
                    },
                    {
                        "id": 21155,
                        "name": "Ospina",
                        "latitude": "1.02962000",
                        "longitude": "-77.55252000"
                    },
                    {
                        "id": 21184,
                        "name": "Pasto",
                        "latitude": "1.21467000",
                        "longitude": "-77.27865000"
                    },
                    {
                        "id": 21216,
                        "name": "Policarpa",
                        "latitude": "1.62843000",
                        "longitude": "-77.45956000"
                    },
                    {
                        "id": 21221,
                        "name": "Potosí",
                        "latitude": "0.80739000",
                        "longitude": "-77.57216000"
                    },
                    {
                        "id": 149246,
                        "name": "Providencia",
                        "latitude": "1.23888999",
                        "longitude": "-77.59755555"
                    },
                    {
                        "id": 21230,
                        "name": "Puerres",
                        "latitude": "1.19374000",
                        "longitude": "-77.26661000"
                    },
                    {
                        "id": 21262,
                        "name": "Pupiales",
                        "latitude": "0.87136000",
                        "longitude": "-77.64027000"
                    },
                    {
                        "id": 21288,
                        "name": "Ricaurte",
                        "latitude": "1.21474000",
                        "longitude": "-77.99801000"
                    },
                    {
                        "id": 21297,
                        "name": "Roberto Payán",
                        "latitude": "1.91757000",
                        "longitude": "-78.38191000"
                    },
                    {
                        "id": 21325,
                        "name": "Samaniego",
                        "latitude": "1.33849000",
                        "longitude": "-77.59570000"
                    },
                    {
                        "id": 21341,
                        "name": "San Bernardo",
                        "latitude": "1.51525000",
                        "longitude": "-77.04679000"
                    },
                    {
                        "id": 21365,
                        "name": "San José de Albán",
                        "latitude": "1.47388999",
                        "longitude": "-77.08083333"
                    },
                    {
                        "id": 21378,
                        "name": "San Lorenzo",
                        "latitude": "1.55731000",
                        "longitude": "-77.24599000"
                    },
                    {
                        "id": 21392,
                        "name": "San Pablo",
                        "latitude": "1.67250000",
                        "longitude": "-77.01389000"
                    },
                    {
                        "id": 21398,
                        "name": "San Pedro de Cartago",
                        "latitude": "1.55151000",
                        "longitude": "-77.11948000"
                    },
                    {
                        "id": 21410,
                        "name": "Sandoná",
                        "latitude": "1.28626000",
                        "longitude": "-77.46921000"
                    },
                    {
                        "id": 21413,
                        "name": "Santa Bárbara",
                        "latitude": "2.30185000",
                        "longitude": "-77.91487000"
                    },
                    {
                        "id": 21431,
                        "name": "Santacruz",
                        "latitude": "1.52090000",
                        "longitude": "-77.26206000"
                    },
                    {
                        "id": 21443,
                        "name": "Sapuyes",
                        "latitude": "1.03728000",
                        "longitude": "-77.62094000"
                    },
                    {
                        "id": 21509,
                        "name": "Taminango",
                        "latitude": "1.57032000",
                        "longitude": "-77.28043000"
                    },
                    {
                        "id": 21510,
                        "name": "Tangua",
                        "latitude": "1.09189000",
                        "longitude": "-77.38645000"
                    },
                    {
                        "id": 21552,
                        "name": "Tumaco",
                        "latitude": "1.79112000",
                        "longitude": "-78.79275000"
                    },
                    {
                        "id": 21564,
                        "name": "Túquerres",
                        "latitude": "1.08647000",
                        "longitude": "-77.61858000"
                    },
                    {
                        "id": 21620,
                        "name": "Yacuanquer",
                        "latitude": "1.11577000",
                        "longitude": "-77.40169000"
                    }
                ]
            },
            {
                "id": 2877,
                "name": "Norte de Santander",
                "iso2": "NSA",
                "latitude": "7.94628310",
                "longitude": "-72.89880690",
                "type": "department",
                "cities": [
                    {
                        "id": 20486,
                        "name": "Abrego",
                        "latitude": "8.00000000",
                        "longitude": "-73.20000000"
                    },
                    {
                        "id": 20540,
                        "name": "Arboledas",
                        "latitude": "7.63494000",
                        "longitude": "-72.86050000"
                    },
                    {
                        "id": 20594,
                        "name": "Bochalema",
                        "latitude": "7.60217000",
                        "longitude": "-72.68839000"
                    },
                    {
                        "id": 20604,
                        "name": "Bucarasica",
                        "latitude": "8.04096000",
                        "longitude": "-72.86538000"
                    },
                    {
                        "id": 20620,
                        "name": "Cachirá",
                        "latitude": "7.75000000",
                        "longitude": "-73.16667000"
                    },
                    {
                        "id": 20765,
                        "name": "Cácota",
                        "latitude": "7.26787000",
                        "longitude": "-72.64197000"
                    },
                    {
                        "id": 20689,
                        "name": "Chinácota",
                        "latitude": "7.60731000",
                        "longitude": "-72.60108000"
                    },
                    {
                        "id": 20697,
                        "name": "Chitagá",
                        "latitude": "7.13781000",
                        "longitude": "-72.66456000"
                    },
                    {
                        "id": 20734,
                        "name": "Convención",
                        "latitude": "8.82242000",
                        "longitude": "-73.22850000"
                    },
                    {
                        "id": 20772,
                        "name": "Cúcuta",
                        "latitude": "7.89391000",
                        "longitude": "-72.50782000"
                    },
                    {
                        "id": 20753,
                        "name": "Cucutilla",
                        "latitude": "7.53941000",
                        "longitude": "-72.77238000"
                    },
                    {
                        "id": 20784,
                        "name": "Durania",
                        "latitude": "7.71307000",
                        "longitude": "-72.65759000"
                    },
                    {
                        "id": 20793,
                        "name": "El Carmen",
                        "latitude": "8.51064000",
                        "longitude": "-73.44776000"
                    },
                    {
                        "id": 20833,
                        "name": "El Tarra",
                        "latitude": "8.57562000",
                        "longitude": "-73.09489000"
                    },
                    {
                        "id": 20834,
                        "name": "El Zulia",
                        "latitude": "7.93248000",
                        "longitude": "-72.60125000"
                    },
                    {
                        "id": 20891,
                        "name": "Gramalote",
                        "latitude": "7.88752000",
                        "longitude": "-72.79749000"
                    },
                    {
                        "id": 20934,
                        "name": "Hacarí",
                        "latitude": "8.32333000",
                        "longitude": "-73.14889000"
                    },
                    {
                        "id": 20940,
                        "name": "Herrán",
                        "latitude": "7.50611000",
                        "longitude": "-72.48332000"
                    },
                    {
                        "id": 20982,
                        "name": "La Esperanza",
                        "latitude": "8.21043000",
                        "longitude": "-72.46399000"
                    },
                    {
                        "id": 21001,
                        "name": "La Playa",
                        "latitude": "8.25833000",
                        "longitude": "-73.19222000"
                    },
                    {
                        "id": 21017,
                        "name": "Labateca",
                        "latitude": "7.24558000",
                        "longitude": "-72.55286000"
                    },
                    {
                        "id": 21035,
                        "name": "Los Patios",
                        "latitude": "7.83793000",
                        "longitude": "-72.50370000"
                    },
                    {
                        "id": 21037,
                        "name": "Lourdes",
                        "latitude": "7.96774000",
                        "longitude": "-72.84519000"
                    },
                    {
                        "id": 21122,
                        "name": "Mutiscua",
                        "latitude": "7.29810000",
                        "longitude": "-72.79879000"
                    },
                    {
                        "id": 21146,
                        "name": "Ocaña",
                        "latitude": "8.23773000",
                        "longitude": "-73.35604000"
                    },
                    {
                        "id": 21176,
                        "name": "Pamplona",
                        "latitude": "7.37565000",
                        "longitude": "-72.64795000"
                    },
                    {
                        "id": 21177,
                        "name": "Pamplonita",
                        "latitude": "7.45814000",
                        "longitude": "-72.65965000"
                    },
                    {
                        "id": 21255,
                        "name": "Puerto Santander",
                        "latitude": "8.36361000",
                        "longitude": "-72.40630000"
                    },
                    {
                        "id": 21277,
                        "name": "Ragonvalia",
                        "latitude": "7.57749000",
                        "longitude": "-72.47574000"
                    },
                    {
                        "id": 21320,
                        "name": "Salazar",
                        "latitude": "7.78249000",
                        "longitude": "-72.85741000"
                    },
                    {
                        "id": 21344,
                        "name": "San Calixto",
                        "latitude": "8.40210000",
                        "longitude": "-73.20737000"
                    },
                    {
                        "id": 21349,
                        "name": "San Cayetano",
                        "latitude": "7.84771000",
                        "longitude": "-72.61014000"
                    },
                    {
                        "id": 21436,
                        "name": "Santiago",
                        "latitude": "7.86930000",
                        "longitude": "-72.73753000"
                    },
                    {
                        "id": 21445,
                        "name": "Sardinata",
                        "latitude": "8.08289000",
                        "longitude": "-72.80071000"
                    },
                    {
                        "id": 21455,
                        "name": "Silos",
                        "latitude": "7.20524000",
                        "longitude": "-72.75639000"
                    },
                    {
                        "id": 149256,
                        "name": "Teorama",
                        "latitude": "8.43527888",
                        "longitude": "-73.28638999"
                    },
                    {
                        "id": 21526,
                        "name": "Tibú",
                        "latitude": "8.63895000",
                        "longitude": "-72.73583000"
                    },
                    {
                        "id": 21538,
                        "name": "Toledo",
                        "latitude": "7.30984000",
                        "longitude": "-72.48295000"
                    },
                    {
                        "id": 149260,
                        "name": "Villa Caro",
                        "latitude": "7.91472222",
                        "longitude": "-72.97194444"
                    },
                    {
                        "id": 21601,
                        "name": "Villa del Rosario",
                        "latitude": "7.75816000",
                        "longitude": "-72.48182000"
                    }
                ]
            },
            {
                "id": 2896,
                "name": "Putumayo",
                "iso2": "PUT",
                "latitude": "0.43595060",
                "longitude": "-75.52766990",
                "type": "department",
                "cities": [
                    {
                        "id": 20721,
                        "name": "Colón",
                        "latitude": "1.19034000",
                        "longitude": "-76.97369000"
                    },
                    {
                        "id": 21089,
                        "name": "Mocoa",
                        "latitude": "1.15284000",
                        "longitude": "-76.65208000"
                    },
                    {
                        "id": 21152,
                        "name": "Orito",
                        "latitude": "0.66749000",
                        "longitude": "-76.87297000"
                    },
                    {
                        "id": 21233,
                        "name": "Puerto Asís",
                        "latitude": "0.50514000",
                        "longitude": "-76.49571000"
                    },
                    {
                        "id": 149248,
                        "name": "Puerto Caicedo",
                        "latitude": "0.68555555",
                        "longitude": "-76.60444444"
                    },
                    {
                        "id": 21243,
                        "name": "Puerto Guzmán",
                        "latitude": "0.97028000",
                        "longitude": "-76.58583000"
                    },
                    {
                        "id": 21244,
                        "name": "Puerto Leguízamo",
                        "latitude": "-0.19337000",
                        "longitude": "-74.78189000"
                    },
                    {
                        "id": 21356,
                        "name": "San Francisco",
                        "latitude": "1.17644000",
                        "longitude": "-76.87838000"
                    },
                    {
                        "id": 21389,
                        "name": "San Miguel",
                        "latitude": "0.34361111",
                        "longitude": "-76.91083333"
                    },
                    {
                        "id": 21435,
                        "name": "Santiago",
                        "latitude": "1.14844000",
                        "longitude": "-77.00450000"
                    },
                    {
                        "id": 21454,
                        "name": "Sibundoy",
                        "latitude": "1.20296000",
                        "longitude": "-76.92275000"
                    },
                    {
                        "id": 21581,
                        "name": "Valle del Guamuez",
                        "latitude": "0.45250000",
                        "longitude": "-76.91917000"
                    },
                    {
                        "id": 21602,
                        "name": "Villagarzón",
                        "latitude": "0.89663000",
                        "longitude": "-76.72794000"
                    }
                ]
            },
            {
                "id": 2874,
                "name": "Quindío",
                "iso2": "QUI",
                "latitude": "4.46101910",
                "longitude": "-75.66735600",
                "type": "department",
                "cities": [
                    {
                        "id": 20550,
                        "name": "Armenia",
                        "latitude": "4.53307000",
                        "longitude": "-75.70438000"
                    },
                    {
                        "id": 20607,
                        "name": "Buenavista",
                        "latitude": "4.35969000",
                        "longitude": "-75.73888000"
                    },
                    {
                        "id": 20629,
                        "name": "Calarca",
                        "latitude": "4.50000000",
                        "longitude": "-75.63333000"
                    },
                    {
                        "id": 20709,
                        "name": "Circasia",
                        "latitude": "4.59940000",
                        "longitude": "-75.68536000"
                    },
                    {
                        "id": 20771,
                        "name": "Córdoba",
                        "latitude": "4.38055000",
                        "longitude": "-75.66685000"
                    },
                    {
                        "id": 20845,
                        "name": "Filandia",
                        "latitude": "4.67525000",
                        "longitude": "-75.67142000"
                    },
                    {
                        "id": 20930,
                        "name": "Génova",
                        "latitude": "4.22743000",
                        "longitude": "-75.75480000"
                    },
                    {
                        "id": 21004,
                        "name": "La Tebaida",
                        "latitude": "4.43353000",
                        "longitude": "-75.81476000"
                    },
                    {
                        "id": 21100,
                        "name": "Montenegro",
                        "latitude": "4.52676000",
                        "longitude": "-75.82265000"
                    },
                    {
                        "id": 21204,
                        "name": "Pijao",
                        "latitude": "4.33350000",
                        "longitude": "-75.70463000"
                    },
                    {
                        "id": 21273,
                        "name": "Quimbaya",
                        "latitude": "4.59342000",
                        "longitude": "-75.83758000"
                    },
                    {
                        "id": 21322,
                        "name": "Salento",
                        "latitude": "4.63643000",
                        "longitude": "-75.56740000"
                    }
                ]
            },
            {
                "id": 2879,
                "name": "Risaralda",
                "iso2": "RIS",
                "latitude": "5.31584750",
                "longitude": "-75.99276520",
                "type": "department",
                "cities": [
                    {
                        "id": 20531,
                        "name": "Apía",
                        "latitude": "5.10658000",
                        "longitude": "-75.94244000"
                    },
                    {
                        "id": 20563,
                        "name": "Balboa",
                        "latitude": "4.92284000",
                        "longitude": "-75.94030000"
                    },
                    {
                        "id": 20585,
                        "name": "Belén de Umbría",
                        "latitude": "5.20087000",
                        "longitude": "-75.86865000"
                    },
                    {
                        "id": 20782,
                        "name": "Dosquebradas",
                        "latitude": "4.83916000",
                        "longitude": "-75.66727000"
                    },
                    {
                        "id": 20926,
                        "name": "Guática",
                        "latitude": "5.31569000",
                        "longitude": "-75.79826000"
                    },
                    {
                        "id": 20975,
                        "name": "La Celia",
                        "latitude": "5.00332000",
                        "longitude": "-76.00355000"
                    },
                    {
                        "id": 21016,
                        "name": "La Virginia",
                        "latitude": "4.89972000",
                        "longitude": "-75.88250000"
                    },
                    {
                        "id": 21070,
                        "name": "Marsella",
                        "latitude": "4.95238000",
                        "longitude": "-75.75265000"
                    },
                    {
                        "id": 21087,
                        "name": "Mistrató",
                        "latitude": "5.29622000",
                        "longitude": "-75.88390000"
                    },
                    {
                        "id": 21195,
                        "name": "Pereira",
                        "latitude": "4.76896000",
                        "longitude": "-75.72222000"
                    },
                    {
                        "id": 21226,
                        "name": "Pueblo Rico",
                        "latitude": "5.29453000",
                        "longitude": "-76.06702000"
                    },
                    {
                        "id": 21274,
                        "name": "Quinchía",
                        "latitude": "5.33957000",
                        "longitude": "-75.73018000"
                    },
                    {
                        "id": 21424,
                        "name": "Santa Rosa de Cabal",
                        "latitude": "4.86806000",
                        "longitude": "-75.62139000"
                    },
                    {
                        "id": 21442,
                        "name": "Santuario",
                        "latitude": "5.05321000",
                        "longitude": "-75.99060000"
                    }
                ]
            },
            {
                "id": 2900,
                "name": "San Andrés, Providencia y Santa Catalina",
                "iso2": "SAP",
                "latitude": "12.55673240",
                "longitude": "-81.71852530",
                "type": "department",
                "cities": [
                    {
                        "id": 21224,
                        "name": "Providencia",
                        "latitude": "13.38479000",
                        "longitude": "-81.37468000"
                    },
                    {
                        "id": 21331,
                        "name": "San Andrés",
                        "latitude": "12.58317000",
                        "longitude": "-81.70636000"
                    }
                ]
            },
            {
                "id": 2901,
                "name": "Santander",
                "iso2": "SAN",
                "latitude": "6.64370760",
                "longitude": "-73.65362090",
                "type": "department",
                "cities": [
                    {
                        "id": 20493,
                        "name": "Aguada",
                        "latitude": "6.16019000",
                        "longitude": "-73.52747000"
                    },
                    {
                        "id": 20497,
                        "name": "Albania",
                        "latitude": "5.75894000",
                        "longitude": "-73.91376000"
                    },
                    {
                        "id": 20535,
                        "name": "Aratoca",
                        "latitude": "6.69432000",
                        "longitude": "-73.01868000"
                    },
                    {
                        "id": 20567,
                        "name": "Barbosa",
                        "latitude": "5.93168000",
                        "longitude": "-73.61507000"
                    },
                    {
                        "id": 20568,
                        "name": "Barichara",
                        "latitude": "6.63572000",
                        "longitude": "-73.22282000"
                    },
                    {
                        "id": 20570,
                        "name": "Barrancabermeja",
                        "latitude": "7.06528000",
                        "longitude": "-73.85472000"
                    },
                    {
                        "id": 20590,
                        "name": "Betulia",
                        "latitude": "6.90069000",
                        "longitude": "-73.28347000"
                    },
                    {
                        "id": 20597,
                        "name": "Bolívar",
                        "latitude": "5.98930000",
                        "longitude": "-73.77058000"
                    },
                    {
                        "id": 20603,
                        "name": "Bucaramanga",
                        "latitude": "7.12539000",
                        "longitude": "-73.11980000"
                    },
                    {
                        "id": 20616,
                        "name": "Cabrera",
                        "latitude": "6.56443000",
                        "longitude": "-73.26768000"
                    },
                    {
                        "id": 20635,
                        "name": "California",
                        "latitude": "7.34340000",
                        "longitude": "-72.95815000"
                    },
                    {
                        "id": 20647,
                        "name": "Capitanejo",
                        "latitude": "6.52881000",
                        "longitude": "-72.69595000"
                    },
                    {
                        "id": 20651,
                        "name": "Carcasí",
                        "latitude": "6.62711000",
                        "longitude": "-72.62625000"
                    },
                    {
                        "id": 20668,
                        "name": "Cepitá",
                        "latitude": "6.75427000",
                        "longitude": "-72.97440000"
                    },
                    {
                        "id": 20671,
                        "name": "Cerrito",
                        "latitude": "6.84315000",
                        "longitude": "-72.69404000"
                    },
                    {
                        "id": 20679,
                        "name": "Charalá",
                        "latitude": "6.17513000",
                        "longitude": "-73.17587000"
                    },
                    {
                        "id": 20680,
                        "name": "Charta",
                        "latitude": "7.28025000",
                        "longitude": "-72.96782000"
                    },
                    {
                        "id": 20684,
                        "name": "Chima",
                        "latitude": "6.36289000",
                        "longitude": "-73.42534000"
                    },
                    {
                        "id": 20692,
                        "name": "Chipatá",
                        "latitude": "6.06196000",
                        "longitude": "-73.63718000"
                    },
                    {
                        "id": 20708,
                        "name": "Cimitarra",
                        "latitude": "6.31419000",
                        "longitude": "-73.94968000"
                    },
                    {
                        "id": 20725,
                        "name": "Concepción",
                        "latitude": "6.76619000",
                        "longitude": "-72.69400000"
                    },
                    {
                        "id": 20729,
                        "name": "Confines",
                        "latitude": "6.34875000",
                        "longitude": "-73.20990000"
                    },
                    {
                        "id": 20733,
                        "name": "Contratación",
                        "latitude": "6.29005000",
                        "longitude": "-73.47354000"
                    },
                    {
                        "id": 20738,
                        "name": "Coromoro",
                        "latitude": "6.29461000",
                        "longitude": "-73.04022000"
                    },
                    {
                        "id": 20760,
                        "name": "Curití",
                        "latitude": "6.60519000",
                        "longitude": "-73.06809000"
                    },
                    {
                        "id": 20797,
                        "name": "El Carmen de Chucurí",
                        "latitude": "6.69736000",
                        "longitude": "-73.51117000"
                    },
                    {
                        "id": 20809,
                        "name": "El Guacamayo",
                        "latitude": "6.24856000",
                        "longitude": "-73.52957000"
                    },
                    {
                        "id": 20819,
                        "name": "El Peñón",
                        "latitude": "6.09900000",
                        "longitude": "-73.92835000"
                    },
                    {
                        "id": 20822,
                        "name": "El Playón",
                        "latitude": "7.47131000",
                        "longitude": "-73.20310000"
                    },
                    {
                        "id": 20836,
                        "name": "Encino",
                        "latitude": "6.13735000",
                        "longitude": "-73.09847000"
                    },
                    {
                        "id": 20837,
                        "name": "Enciso",
                        "latitude": "6.64651000",
                        "longitude": "-72.70709000"
                    },
                    {
                        "id": 20853,
                        "name": "Florián",
                        "latitude": "5.80487000",
                        "longitude": "-73.97029000"
                    },
                    {
                        "id": 20852,
                        "name": "Floridablanca",
                        "latitude": "7.06315000",
                        "longitude": "-73.08586000"
                    },
                    {
                        "id": 20878,
                        "name": "Galán",
                        "latitude": "6.66271000",
                        "longitude": "-73.34233000"
                    },
                    {
                        "id": 20881,
                        "name": "Gambita",
                        "latitude": "5.90273000",
                        "longitude": "-73.36788000"
                    },
                    {
                        "id": 20889,
                        "name": "Girón",
                        "latitude": "7.06820000",
                        "longitude": "-73.16981000"
                    },
                    {
                        "id": 20895,
                        "name": "Guaca",
                        "latitude": "6.87621000",
                        "longitude": "-72.85594000"
                    },
                    {
                        "id": 20902,
                        "name": "Guadalupe",
                        "latitude": "6.24640000",
                        "longitude": "-73.41833000"
                    },
                    {
                        "id": 20910,
                        "name": "Guapotá",
                        "latitude": "6.30697000",
                        "longitude": "-73.32848000"
                    },
                    {
                        "id": 20919,
                        "name": "Guavatá",
                        "latitude": "5.95502000",
                        "longitude": "-73.70018000"
                    },
                    {
                        "id": 20932,
                        "name": "Güepsa",
                        "latitude": "6.02505000",
                        "longitude": "-73.57313000"
                    },
                    {
                        "id": 20936,
                        "name": "Hato",
                        "latitude": "6.56113000",
                        "longitude": "-73.35895000"
                    },
                    {
                        "id": 20964,
                        "name": "Jesús María",
                        "latitude": "5.87715000",
                        "longitude": "-73.78097000"
                    },
                    {
                        "id": 20965,
                        "name": "Jordán",
                        "latitude": "6.69857000",
                        "longitude": "-73.10966000"
                    },
                    {
                        "id": 20971,
                        "name": "La Belleza",
                        "latitude": "5.86371000",
                        "longitude": "-73.96167000"
                    },
                    {
                        "id": 20996,
                        "name": "La Paz",
                        "latitude": "6.17848000",
                        "longitude": "-73.58948000"
                    },
                    {
                        "id": 21019,
                        "name": "Landázuri",
                        "latitude": "6.21826000",
                        "longitude": "-73.81121000"
                    },
                    {
                        "id": 21021,
                        "name": "Lebrija",
                        "latitude": "7.11317000",
                        "longitude": "-73.21780000"
                    },
                    {
                        "id": 21036,
                        "name": "Los Santos",
                        "latitude": "6.79734000",
                        "longitude": "-73.12490000"
                    },
                    {
                        "id": 21043,
                        "name": "Macaravita",
                        "latitude": "6.50567000",
                        "longitude": "-72.59299000"
                    },
                    {
                        "id": 21124,
                        "name": "Málaga",
                        "latitude": "6.69903000",
                        "longitude": "-72.73233000"
                    },
                    {
                        "id": 21073,
                        "name": "Matanza",
                        "latitude": "7.35605000",
                        "longitude": "-73.05303000"
                    },
                    {
                        "id": 21090,
                        "name": "Mogotes",
                        "latitude": "6.47559000",
                        "longitude": "-72.97046000"
                    },
                    {
                        "id": 21091,
                        "name": "Molagavita",
                        "latitude": "6.67315000",
                        "longitude": "-72.80875000"
                    },
                    {
                        "id": 21145,
                        "name": "Ocamonte",
                        "latitude": "6.34001000",
                        "longitude": "-73.12205000"
                    },
                    {
                        "id": 21147,
                        "name": "Oiba",
                        "latitude": "6.26387000",
                        "longitude": "-73.29876000"
                    },
                    {
                        "id": 21151,
                        "name": "Onzaga",
                        "latitude": "6.34434000",
                        "longitude": "-72.81726000"
                    },
                    {
                        "id": 21170,
                        "name": "Palmar",
                        "latitude": "6.49740000",
                        "longitude": "-73.30740000"
                    },
                    {
                        "id": 21172,
                        "name": "Palmas del Socorro",
                        "latitude": "6.40756000",
                        "longitude": "-73.28824000"
                    },
                    {
                        "id": 21269,
                        "name": "Páramo",
                        "latitude": "6.43750000",
                        "longitude": "-73.18027000"
                    },
                    {
                        "id": 21199,
                        "name": "Piedecuesta",
                        "latitude": "6.97443000",
                        "longitude": "-73.02284000"
                    },
                    {
                        "id": 21206,
                        "name": "Pinchote",
                        "latitude": "6.53226000",
                        "longitude": "-73.17309000"
                    },
                    {
                        "id": 21229,
                        "name": "Puente Nacional",
                        "latitude": "5.87739000",
                        "longitude": "-73.67810000"
                    },
                    {
                        "id": 21250,
                        "name": "Puerto Parra",
                        "latitude": "6.65149000",
                        "longitude": "-74.05734000"
                    },
                    {
                        "id": 21259,
                        "name": "Puerto Wilches",
                        "latitude": "7.34828000",
                        "longitude": "-73.89601000"
                    },
                    {
                        "id": 21292,
                        "name": "Rionegro",
                        "latitude": "7.50000000",
                        "longitude": "-73.33333000"
                    },
                    {
                        "id": 21308,
                        "name": "Sabana de Torres",
                        "latitude": "7.39150000",
                        "longitude": "-73.49574000"
                    },
                    {
                        "id": 21332,
                        "name": "San Andrés",
                        "latitude": "6.81148000",
                        "longitude": "-72.84929000"
                    },
                    {
                        "id": 21339,
                        "name": "San Benito",
                        "latitude": "6.10206000",
                        "longitude": "-73.53753000"
                    },
                    {
                        "id": 21359,
                        "name": "San Gil",
                        "latitude": "6.55952000",
                        "longitude": "-73.13637000"
                    },
                    {
                        "id": 21363,
                        "name": "San Joaquín",
                        "latitude": "6.46554000",
                        "longitude": "-72.84852000"
                    },
                    {
                        "id": 21367,
                        "name": "San José de Miranda",
                        "latitude": "6.63051000",
                        "longitude": "-72.73155000"
                    },
                    {
                        "id": 21388,
                        "name": "San Miguel",
                        "latitude": "6.57583000",
                        "longitude": "-72.64591000"
                    },
                    {
                        "id": 21408,
                        "name": "San Vicente de Chucurí",
                        "latitude": "6.88100000",
                        "longitude": "-73.40977000"
                    },
                    {
                        "id": 21412,
                        "name": "Santa Bárbara",
                        "latitude": "6.99022000",
                        "longitude": "-72.90700000"
                    },
                    {
                        "id": 149249,
                        "name": "Santa Helena Del Opón",
                        "latitude": "6.33916777",
                        "longitude": "-73.61666777"
                    },
                    {
                        "id": 21458,
                        "name": "Simacota",
                        "latitude": "6.44290000",
                        "longitude": "-73.33688000"
                    },
                    {
                        "id": 21468,
                        "name": "Socorro",
                        "latitude": "6.45647000",
                        "longitude": "-73.25502000"
                    },
                    {
                        "id": 21484,
                        "name": "Suaita",
                        "latitude": "6.08221000",
                        "longitude": "-73.37008000"
                    },
                    {
                        "id": 21488,
                        "name": "Sucre",
                        "latitude": "5.96995000",
                        "longitude": "-73.96629000"
                    },
                    {
                        "id": 21493,
                        "name": "Suratá",
                        "latitude": "7.36633000",
                        "longitude": "-72.98361000"
                    },
                    {
                        "id": 21540,
                        "name": "Tona",
                        "latitude": "7.15727000",
                        "longitude": "-72.96559000"
                    },
                    {
                        "id": 21579,
                        "name": "Valle de San José",
                        "latitude": "6.41984000",
                        "longitude": "-73.12946000"
                    },
                    {
                        "id": 21618,
                        "name": "Vélez",
                        "latitude": "6.23274000",
                        "longitude": "-73.72582000"
                    },
                    {
                        "id": 21592,
                        "name": "Vetas",
                        "latitude": "7.30911000",
                        "longitude": "-72.87122000"
                    },
                    {
                        "id": 21606,
                        "name": "Villanueva",
                        "latitude": "6.67169000",
                        "longitude": "-73.17421000"
                    },
                    {
                        "id": 21630,
                        "name": "Zapatoca",
                        "latitude": "6.81532000",
                        "longitude": "-73.26768000"
                    }
                ]
            },
            {
                "id": 2902,
                "name": "Sucre",
                "iso2": "SUC",
                "latitude": "8.81397700",
                "longitude": "-74.72328300",
                "type": "department",
                "cities": [
                    {
                        "id": 149239,
                        "name": "Buenavista",
                        "latitude": "9.31972222",
                        "longitude": "-74.97166777"
                    },
                    {
                        "id": 20623,
                        "name": "Caimito",
                        "latitude": "8.78834000",
                        "longitude": "-75.13583000"
                    },
                    {
                        "id": 20676,
                        "name": "Chalán",
                        "latitude": "9.54765000",
                        "longitude": "-75.31128000"
                    },
                    {
                        "id": 20719,
                        "name": "Coloso",
                        "latitude": "9.51176000",
                        "longitude": "-75.36233000"
                    },
                    {
                        "id": 20739,
                        "name": "Corozal",
                        "latitude": "9.31847000",
                        "longitude": "-75.29330000"
                    },
                    {
                        "id": 20744,
                        "name": "Coveñas",
                        "latitude": "9.40254000",
                        "longitude": "-75.68029000"
                    },
                    {
                        "id": 20825,
                        "name": "El Roble",
                        "latitude": "9.10193000",
                        "longitude": "-75.19508000"
                    },
                    {
                        "id": 20877,
                        "name": "Galeras",
                        "latitude": "9.16095000",
                        "longitude": "-75.04811000"
                    },
                    {
                        "id": 20912,
                        "name": "Guaranda",
                        "latitude": "8.46746000",
                        "longitude": "-74.53617000"
                    },
                    {
                        "id": 21007,
                        "name": "La Unión",
                        "latitude": "8.84965000",
                        "longitude": "-75.27942000"
                    },
                    {
                        "id": 21034,
                        "name": "Los Palmitos",
                        "latitude": "9.37899000",
                        "longitude": "-75.26769000"
                    },
                    {
                        "id": 21052,
                        "name": "Majagual",
                        "latitude": "8.53500000",
                        "longitude": "-74.71499000"
                    },
                    {
                        "id": 21107,
                        "name": "Morroa",
                        "latitude": "9.33348000",
                        "longitude": "-75.30542000"
                    },
                    {
                        "id": 21157,
                        "name": "Ovejas",
                        "latitude": "9.54083000",
                        "longitude": "-75.18333000"
                    },
                    {
                        "id": 21174,
                        "name": "Palmito",
                        "latitude": "9.33667000",
                        "longitude": "-75.56333000"
                    },
                    {
                        "id": 21327,
                        "name": "Sampués",
                        "latitude": "9.18361000",
                        "longitude": "-75.38167000"
                    },
                    {
                        "id": 21340,
                        "name": "San Benito Abad",
                        "latitude": "8.78833000",
                        "longitude": "-74.95666000"
                    },
                    {
                        "id": 21374,
                        "name": "San Juan de Betulia",
                        "latitude": "9.27345000",
                        "longitude": "-75.24103000"
                    },
                    {
                        "id": 21382,
                        "name": "San Luis de Sincé",
                        "latitude": "9.24391000",
                        "longitude": "-75.14675000"
                    },
                    {
                        "id": 21383,
                        "name": "San Marcos",
                        "latitude": "8.58333000",
                        "longitude": "-75.16667000"
                    },
                    {
                        "id": 21391,
                        "name": "San Onofre",
                        "latitude": "9.73586000",
                        "longitude": "-75.52626000"
                    },
                    {
                        "id": 21395,
                        "name": "San Pedro",
                        "latitude": "9.39560000",
                        "longitude": "-75.06476000"
                    },
                    {
                        "id": 21438,
                        "name": "Santiago de Tolú",
                        "latitude": "9.52392000",
                        "longitude": "-75.58139000"
                    },
                    {
                        "id": 21461,
                        "name": "Sincelejo",
                        "latitude": "9.30472000",
                        "longitude": "-75.39778000"
                    },
                    {
                        "id": 21487,
                        "name": "Sucre",
                        "latitude": "8.81136000",
                        "longitude": "-74.72084000"
                    },
                    {
                        "id": 21539,
                        "name": "Tolú Viejo",
                        "latitude": "9.45082000",
                        "longitude": "-75.43864000"
                    }
                ]
            },
            {
                "id": 2883,
                "name": "Tolima",
                "iso2": "TOL",
                "latitude": "4.09251680",
                "longitude": "-75.15453810",
                "type": "department",
                "cities": [
                    {
                        "id": 20508,
                        "name": "Alpujarra",
                        "latitude": "3.39222000",
                        "longitude": "-74.93271000"
                    },
                    {
                        "id": 20511,
                        "name": "Alvarado",
                        "latitude": "4.58826000",
                        "longitude": "-74.97810000"
                    },
                    {
                        "id": 20514,
                        "name": "Ambalema",
                        "latitude": "4.78405000",
                        "longitude": "-74.76268000"
                    },
                    {
                        "id": 20528,
                        "name": "Anzoátegui",
                        "latitude": "4.62232000",
                        "longitude": "-75.18046000"
                    },
                    {
                        "id": 20552,
                        "name": "Armero",
                        "latitude": "5.03055666",
                        "longitude": "-74.88444444"
                    },
                    {
                        "id": 20556,
                        "name": "Ataco",
                        "latitude": "3.59147000",
                        "longitude": "-75.38178000"
                    },
                    {
                        "id": 20624,
                        "name": "Cajamarca",
                        "latitude": "4.41667000",
                        "longitude": "-75.50000000"
                    },
                    {
                        "id": 20654,
                        "name": "Carmen de Apicalá",
                        "latitude": "4.14725000",
                        "longitude": "-74.72014000"
                    },
                    {
                        "id": 20664,
                        "name": "Casabianca",
                        "latitude": "5.07959000",
                        "longitude": "-75.12059000"
                    },
                    {
                        "id": 20678,
                        "name": "Chaparral",
                        "latitude": "3.75000000",
                        "longitude": "-75.58333000"
                    },
                    {
                        "id": 20717,
                        "name": "Coello",
                        "latitude": "4.37330000",
                        "longitude": "-74.88655000"
                    },
                    {
                        "id": 20745,
                        "name": "Coyaima",
                        "latitude": "3.72781000",
                        "longitude": "-75.17397000"
                    },
                    {
                        "id": 20758,
                        "name": "Cunday",
                        "latitude": "4.00284000",
                        "longitude": "-74.69295000"
                    },
                    {
                        "id": 20779,
                        "name": "Dolores",
                        "latitude": "3.60534000",
                        "longitude": "-74.80585000"
                    },
                    {
                        "id": 20841,
                        "name": "Espinal",
                        "latitude": "4.14924000",
                        "longitude": "-74.88429000"
                    },
                    {
                        "id": 20843,
                        "name": "Falan",
                        "latitude": "5.12383000",
                        "longitude": "-74.95181000"
                    },
                    {
                        "id": 20847,
                        "name": "Flandes",
                        "latitude": "4.25000000",
                        "longitude": "-74.83333000"
                    },
                    {
                        "id": 20860,
                        "name": "Fresno",
                        "latitude": "5.15264000",
                        "longitude": "-75.03624000"
                    },
                    {
                        "id": 20908,
                        "name": "Guamo",
                        "latitude": "4.07457000",
                        "longitude": "-74.97689000"
                    },
                    {
                        "id": 20941,
                        "name": "Herveo",
                        "latitude": "5.08004000",
                        "longitude": "-75.17556000"
                    },
                    {
                        "id": 20943,
                        "name": "Honda",
                        "latitude": "5.20856000",
                        "longitude": "-74.73584000"
                    },
                    {
                        "id": 20944,
                        "name": "Ibagué",
                        "latitude": "4.43889000",
                        "longitude": "-75.23222000"
                    },
                    {
                        "id": 20945,
                        "name": "Icononzo",
                        "latitude": "4.17698000",
                        "longitude": "-74.53254000"
                    },
                    {
                        "id": 21039,
                        "name": "Lérida",
                        "latitude": "4.86242000",
                        "longitude": "-74.90977000"
                    },
                    {
                        "id": 21040,
                        "name": "Líbano",
                        "latitude": "4.83560000",
                        "longitude": "-75.10834000"
                    },
                    {
                        "id": 21079,
                        "name": "Melgar",
                        "latitude": "4.20475000",
                        "longitude": "-74.64075000"
                    },
                    {
                        "id": 21119,
                        "name": "Murillo",
                        "latitude": "4.87393000",
                        "longitude": "-75.17151000"
                    },
                    {
                        "id": 21128,
                        "name": "Natagaima",
                        "latitude": "3.55212000",
                        "longitude": "-75.11345000"
                    },
                    {
                        "id": 21154,
                        "name": "Ortega",
                        "latitude": "3.94514000",
                        "longitude": "-75.27245000"
                    },
                    {
                        "id": 21175,
                        "name": "Palocabildo",
                        "latitude": "5.11705000",
                        "longitude": "-75.01732000"
                    },
                    {
                        "id": 21201,
                        "name": "Piedras",
                        "latitude": "4.50000000",
                        "longitude": "-74.91667000"
                    },
                    {
                        "id": 21212,
                        "name": "Planadas",
                        "latitude": "3.10326000",
                        "longitude": "-75.81680000"
                    },
                    {
                        "id": 21223,
                        "name": "Prado",
                        "latitude": "3.73219000",
                        "longitude": "-74.86494000"
                    },
                    {
                        "id": 21264,
                        "name": "Purificación",
                        "latitude": "3.85871000",
                        "longitude": "-74.93129000"
                    },
                    {
                        "id": 21289,
                        "name": "Rioblanco",
                        "latitude": "3.50000000",
                        "longitude": "-75.83333000"
                    },
                    {
                        "id": 21299,
                        "name": "Roncesvalles",
                        "latitude": "4.01080000",
                        "longitude": "-75.60493000"
                    },
                    {
                        "id": 21302,
                        "name": "Rovira",
                        "latitude": "4.21222000",
                        "longitude": "-75.34210000"
                    },
                    {
                        "id": 21321,
                        "name": "Saldaña",
                        "latitude": "3.92923000",
                        "longitude": "-75.01517000"
                    },
                    {
                        "id": 21337,
                        "name": "San Antonio",
                        "latitude": "3.95664000",
                        "longitude": "-75.50000000"
                    },
                    {
                        "id": 21379,
                        "name": "San Luis",
                        "latitude": "4.16667000",
                        "longitude": "-75.08333000"
                    },
                    {
                        "id": 21405,
                        "name": "San Sebastián de Mariquita",
                        "latitude": "5.24269000",
                        "longitude": "-74.90772000"
                    },
                    {
                        "id": 21419,
                        "name": "Santa Isabel",
                        "latitude": "4.72626000",
                        "longitude": "-75.22391000"
                    },
                    {
                        "id": 21500,
                        "name": "Suárez",
                        "latitude": "4.04897000",
                        "longitude": "-74.81821000"
                    },
                    {
                        "id": 21580,
                        "name": "Valle de San Juan",
                        "latitude": "4.19869000",
                        "longitude": "-75.11733000"
                    },
                    {
                        "id": 21586,
                        "name": "Venadillo",
                        "latitude": "4.69177000",
                        "longitude": "-74.93669000"
                    },
                    {
                        "id": 21604,
                        "name": "Villahermosa",
                        "latitude": "4.96503000",
                        "longitude": "-75.15650000"
                    },
                    {
                        "id": 21611,
                        "name": "Villarrica",
                        "latitude": "3.83099000",
                        "longitude": "-74.65258000"
                    }
                ]
            },
            {
                "id": 2904,
                "name": "Valle del Cauca",
                "iso2": "VAC",
                "latitude": "3.80088930",
                "longitude": "-76.64127120",
                "type": "department",
                "cities": [
                    {
                        "id": 20502,
                        "name": "Alcalá",
                        "latitude": "4.67458000",
                        "longitude": "-75.77188000"
                    },
                    {
                        "id": 20519,
                        "name": "Andalucía",
                        "latitude": "4.14035000",
                        "longitude": "-76.14739000"
                    },
                    {
                        "id": 20526,
                        "name": "Ansermanuevo",
                        "latitude": "4.79722000",
                        "longitude": "-75.99500000"
                    },
                    {
                        "id": 20546,
                        "name": "Argelia",
                        "latitude": "4.72904000",
                        "longitude": "-76.11637000"
                    },
                    {
                        "id": 20598,
                        "name": "Bolívar",
                        "latitude": "4.37710000",
                        "longitude": "-76.34870000"
                    },
                    {
                        "id": 20605,
                        "name": "Buenaventura",
                        "latitude": "3.88010000",
                        "longitude": "-77.03116000"
                    },
                    {
                        "id": 20612,
                        "name": "Bugalagrande",
                        "latitude": "4.21207000",
                        "longitude": "-76.15564000"
                    },
                    {
                        "id": 20622,
                        "name": "Caicedonia",
                        "latitude": "4.33240000",
                        "longitude": "-75.82665000"
                    },
                    {
                        "id": 20634,
                        "name": "Cali",
                        "latitude": "3.41033000",
                        "longitude": "-76.58097000"
                    },
                    {
                        "id": 20636,
                        "name": "Calima",
                        "latitude": "3.92511000",
                        "longitude": "-76.62654000"
                    },
                    {
                        "id": 20644,
                        "name": "Candelaria",
                        "latitude": "3.38367000",
                        "longitude": "-76.42466000"
                    },
                    {
                        "id": 20661,
                        "name": "Cartago",
                        "latitude": "4.74639000",
                        "longitude": "-75.91167000"
                    },
                    {
                        "id": 20774,
                        "name": "Dagua",
                        "latitude": "3.65685000",
                        "longitude": "-76.68859000"
                    },
                    {
                        "id": 20835,
                        "name": "El Águila",
                        "latitude": "4.91946000",
                        "longitude": "-76.05680000"
                    },
                    {
                        "id": 20789,
                        "name": "El Cairo",
                        "latitude": "4.74889000",
                        "longitude": "-76.24443000"
                    },
                    {
                        "id": 20800,
                        "name": "El Cerrito",
                        "latitude": "3.64273000",
                        "longitude": "-76.20960000"
                    },
                    {
                        "id": 20806,
                        "name": "El Dovio",
                        "latitude": "4.50790000",
                        "longitude": "-76.23619000"
                    },
                    {
                        "id": 20851,
                        "name": "Florida",
                        "latitude": "3.30940000",
                        "longitude": "-76.18989000"
                    },
                    {
                        "id": 20884,
                        "name": "Ginebra",
                        "latitude": "3.74296000",
                        "longitude": "-76.19412000"
                    },
                    {
                        "id": 20897,
                        "name": "Guacarí",
                        "latitude": "3.76383000",
                        "longitude": "-76.33292000"
                    },
                    {
                        "id": 20900,
                        "name": "Guadalajara de Buga",
                        "latitude": "3.90089000",
                        "longitude": "-76.29783000"
                    },
                    {
                        "id": 20958,
                        "name": "Jamundí",
                        "latitude": "3.26074000",
                        "longitude": "-76.53499000"
                    },
                    {
                        "id": 20979,
                        "name": "La Cumbre",
                        "latitude": "3.72250000",
                        "longitude": "-76.02083000"
                    },
                    {
                        "id": 21006,
                        "name": "La Unión",
                        "latitude": "4.53282000",
                        "longitude": "-76.10318000"
                    },
                    {
                        "id": 21013,
                        "name": "La Victoria",
                        "latitude": "4.52483000",
                        "longitude": "-76.03921000"
                    },
                    {
                        "id": 21144,
                        "name": "Obando",
                        "latitude": "4.59590000",
                        "longitude": "-75.94879000"
                    },
                    {
                        "id": 21173,
                        "name": "Palmira",
                        "latitude": "3.53969000",
                        "longitude": "-76.22607000"
                    },
                    {
                        "id": 21222,
                        "name": "Pradera",
                        "latitude": "3.42793000",
                        "longitude": "-76.17159000"
                    },
                    {
                        "id": 21285,
                        "name": "Restrepo",
                        "latitude": "3.82203000",
                        "longitude": "-76.52242000"
                    },
                    {
                        "id": 21290,
                        "name": "Riofrío",
                        "latitude": "4.15710000",
                        "longitude": "-76.28852000"
                    },
                    {
                        "id": 21298,
                        "name": "Roldanillo",
                        "latitude": "4.41256000",
                        "longitude": "-76.15457000"
                    },
                    {
                        "id": 21397,
                        "name": "San Pedro",
                        "latitude": "3.99936000",
                        "longitude": "-76.26123000"
                    },
                    {
                        "id": 21451,
                        "name": "Sevilla",
                        "latitude": "4.19345000",
                        "longitude": "-75.88829000"
                    },
                    {
                        "id": 21544,
                        "name": "Toro",
                        "latitude": "4.61167000",
                        "longitude": "-76.08139000"
                    },
                    {
                        "id": 21549,
                        "name": "Trujillo",
                        "latitude": "4.23696000",
                        "longitude": "-76.34730000"
                    },
                    {
                        "id": 21551,
                        "name": "Tuluá",
                        "latitude": "4.08466000",
                        "longitude": "-76.19536000"
                    },
                    {
                        "id": 21567,
                        "name": "Ulloa",
                        "latitude": "4.70745000",
                        "longitude": "-75.77781000"
                    },
                    {
                        "id": 21591,
                        "name": "Versalles",
                        "latitude": "4.66335000",
                        "longitude": "-76.24649000"
                    },
                    {
                        "id": 21596,
                        "name": "Vijes",
                        "latitude": "3.73283000",
                        "longitude": "-76.49363000"
                    },
                    {
                        "id": 21627,
                        "name": "Yotoco",
                        "latitude": "3.86048000",
                        "longitude": "-76.38364000"
                    },
                    {
                        "id": 21628,
                        "name": "Yumbo",
                        "latitude": "3.58234000",
                        "longitude": "-76.49146000"
                    },
                    {
                        "id": 21633,
                        "name": "Zarzal",
                        "latitude": "4.39462000",
                        "longitude": "-76.07150000"
                    }
                ]
            },
            {
                "id": 2885,
                "name": "Vaupés",
                "iso2": "VAU",
                "latitude": "0.85535610",
                "longitude": "-70.81199530",
                "type": "department",
                "cities": [
                    {
                        "id": 20663,
                        "name": "Caruru",
                        "latitude": "1.02081000",
                        "longitude": "-71.33788000"
                    },
                    {
                        "id": 21088,
                        "name": "Mitú",
                        "latitude": "1.25778000",
                        "longitude": "-70.23472000"
                    },
                    {
                        "id": 21160,
                        "name": "Pacoa",
                        "latitude": "0.15636000",
                        "longitude": "-70.89274000"
                    },
                    {
                        "id": 21181,
                        "name": "Papunaua",
                        "latitude": "1.68335000",
                        "longitude": "-70.70968000"
                    },
                    {
                        "id": 21511,
                        "name": "Taraira",
                        "latitude": "-0.74835000",
                        "longitude": "-69.89662000"
                    },
                    {
                        "id": 21623,
                        "name": "Yavaraté",
                        "latitude": "0.82828000",
                        "longitude": "-69.62959000"
                    }
                ]
            },
            {
                "id": 2894,
                "name": "Vichada",
                "iso2": "VID",
                "latitude": "4.42344520",
                "longitude": "-69.28775350",
                "type": "department",
                "cities": [
                    {
                        "id": 20755,
                        "name": "Cumaribo",
                        "latitude": "4.44552000",
                        "longitude": "-69.79897000"
                    },
                    {
                        "id": 21002,
                        "name": "La Primavera",
                        "latitude": "5.49056000",
                        "longitude": "-70.40917000"
                    },
                    {
                        "id": 21237,
                        "name": "Puerto Carreño",
                        "latitude": "6.18903000",
                        "longitude": "-67.48588000"
                    },
                    {
                        "id": 21428,
                        "name": "Santa Rosalia",
                        "latitude": "5.13356000",
                        "longitude": "-70.86233000"
                    }
                ]
            }
        ]
    },
    {
        "id": 49,
        "name": "Comoros",
        "iso3": "COM",
        "iso2": "KM",
        "numeric_code": "174",
        "phonecode": "269",
        "capital": "Moroni",
        "currency": "KMF",
        "currency_name": "Comorian franc",
        "currency_symbol": "CF",
        "tld": ".km",
        "native": "Komori",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Comoran, Comorian",
        "timezones": [
            {
                "zoneName": "Indian\/Comoro",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Komorez",
            "ko": "코모로",
            "pt-BR": "Comores",
            "pt": "Comores",
            "nl": "Comoren",
            "hr": "Komori",
            "fa": "کومور",
            "de": "Union der Komoren",
            "es": "Comoras",
            "fr": "Comores",
            "ja": "コモロ",
            "it": "Comore",
            "zh-CN": "科摩罗",
            "tr": "Komorlar",
            "ru": "Коморские острова",
            "uk": "Коморські острови",
            "pl": "Komory"
        },
        "latitude": "-12.16666666",
        "longitude": "44.25000000",
        "emoji": "🇰🇲",
        "emojiU": "U+1F1F0 U+1F1F2",
        "states": [
            {
                "id": 2821,
                "name": "Anjouan",
                "iso2": "A",
                "latitude": "-12.21381450",
                "longitude": "44.43706060",
                "type": "island",
                "cities": [
                    {
                        "id": 65079,
                        "name": "Adda-Douéni",
                        "latitude": "-12.29250000",
                        "longitude": "44.49722000"
                    },
                    {
                        "id": 65080,
                        "name": "Antsahé",
                        "latitude": "-12.35639000",
                        "longitude": "44.52250000"
                    },
                    {
                        "id": 65081,
                        "name": "Assimpao",
                        "latitude": "-12.23306000",
                        "longitude": "44.31972000"
                    },
                    {
                        "id": 65084,
                        "name": "Bambao",
                        "latitude": "-12.20325000",
                        "longitude": "44.51638000"
                    },
                    {
                        "id": 65085,
                        "name": "Bandajou",
                        "latitude": "-12.19167000",
                        "longitude": "44.28694000"
                    },
                    {
                        "id": 65086,
                        "name": "Barakani",
                        "latitude": "-12.13861000",
                        "longitude": "44.43026000"
                    },
                    {
                        "id": 65087,
                        "name": "Bimbini",
                        "latitude": "-12.18833000",
                        "longitude": "44.23556000"
                    },
                    {
                        "id": 65088,
                        "name": "Boungouéni",
                        "latitude": "-12.20556000",
                        "longitude": "44.29944000"
                    },
                    {
                        "id": 65090,
                        "name": "Chandra",
                        "latitude": "-12.19500000",
                        "longitude": "44.46472000"
                    },
                    {
                        "id": 65093,
                        "name": "Chironkamba",
                        "latitude": "-12.19111000",
                        "longitude": "44.35250000"
                    },
                    {
                        "id": 65094,
                        "name": "Chitrouni",
                        "latitude": "-12.18583000",
                        "longitude": "44.33556000"
                    },
                    {
                        "id": 65096,
                        "name": "Daji",
                        "latitude": "-12.32583000",
                        "longitude": "44.48861000"
                    },
                    {
                        "id": 65099,
                        "name": "Domoni",
                        "latitude": "-12.25694000",
                        "longitude": "44.53194000"
                    },
                    {
                        "id": 65102,
                        "name": "Dziani",
                        "latitude": "-12.18333000",
                        "longitude": "44.48333000"
                    },
                    {
                        "id": 65105,
                        "name": "Hajoho",
                        "latitude": "-12.12434000",
                        "longitude": "44.48881000"
                    },
                    {
                        "id": 65107,
                        "name": "Harembo",
                        "latitude": "-12.15108000",
                        "longitude": "44.49828000"
                    },
                    {
                        "id": 65113,
                        "name": "Kangani",
                        "latitude": "-12.32102000",
                        "longitude": "44.47270000"
                    },
                    {
                        "id": 65114,
                        "name": "Kavani",
                        "latitude": "-12.19194000",
                        "longitude": "44.26944000"
                    },
                    {
                        "id": 65115,
                        "name": "Koki",
                        "latitude": "-12.17139000",
                        "longitude": "44.44167000"
                    },
                    {
                        "id": 65116,
                        "name": "Koni-Djodjo",
                        "latitude": "-12.22972000",
                        "longitude": "44.48167000"
                    },
                    {
                        "id": 65117,
                        "name": "Koni-Ngani",
                        "latitude": "-12.21583000",
                        "longitude": "44.48000000"
                    },
                    {
                        "id": 65119,
                        "name": "Kyo",
                        "latitude": "-12.33222000",
                        "longitude": "44.51917000"
                    },
                    {
                        "id": 65120,
                        "name": "Limbi",
                        "latitude": "-12.23944000",
                        "longitude": "44.50528000"
                    },
                    {
                        "id": 65121,
                        "name": "Lingoni",
                        "latitude": "-12.25583000",
                        "longitude": "44.41833000"
                    },
                    {
                        "id": 65123,
                        "name": "Magnassini-Nindri",
                        "latitude": "-12.27806000",
                        "longitude": "44.41583000"
                    },
                    {
                        "id": 65125,
                        "name": "Maraharé",
                        "latitude": "-12.23083000",
                        "longitude": "44.31333000"
                    },
                    {
                        "id": 65128,
                        "name": "Mirontsi",
                        "latitude": "-12.15667000",
                        "longitude": "44.40806000"
                    },
                    {
                        "id": 65131,
                        "name": "Mjamaoué",
                        "latitude": "-12.19361000",
                        "longitude": "44.31000000"
                    },
                    {
                        "id": 65132,
                        "name": "Mjimandra",
                        "latitude": "-12.19167000",
                        "longitude": "44.37028000"
                    },
                    {
                        "id": 65136,
                        "name": "Moutsamoudou",
                        "latitude": "-12.16672000",
                        "longitude": "44.39944000"
                    },
                    {
                        "id": 65137,
                        "name": "Moya",
                        "latitude": "-12.30967000",
                        "longitude": "44.43685000"
                    },
                    {
                        "id": 65138,
                        "name": "Mramani",
                        "latitude": "-12.34639000",
                        "longitude": "44.52861000"
                    },
                    {
                        "id": 65139,
                        "name": "Mrémani",
                        "latitude": "-12.30833000",
                        "longitude": "44.49861000"
                    },
                    {
                        "id": 65147,
                        "name": "Ongoni",
                        "latitude": "-12.17028000",
                        "longitude": "44.50694000"
                    },
                    {
                        "id": 65149,
                        "name": "Ouani",
                        "latitude": "-12.13554000",
                        "longitude": "44.42493000"
                    },
                    {
                        "id": 65154,
                        "name": "Ouzini",
                        "latitude": "-12.26722000",
                        "longitude": "44.47972000"
                    },
                    {
                        "id": 65155,
                        "name": "Pajé",
                        "latitude": "-12.16972000",
                        "longitude": "44.38806000"
                    },
                    {
                        "id": 65156,
                        "name": "Patsi",
                        "latitude": "-12.15556000",
                        "longitude": "44.43722000"
                    },
                    {
                        "id": 65158,
                        "name": "Sima",
                        "latitude": "-12.19556000",
                        "longitude": "44.27667000"
                    },
                    {
                        "id": 65162,
                        "name": "Tsimbeo",
                        "latitude": "-12.20583000",
                        "longitude": "44.46472000"
                    },
                    {
                        "id": 65165,
                        "name": "Vouani",
                        "latitude": "-12.24417000",
                        "longitude": "44.37444000"
                    }
                ]
            },
            {
                "id": 2822,
                "name": "Grande Comore",
                "iso2": "G",
                "latitude": "-11.71673380",
                "longitude": "43.36807880",
                "type": "island",
                "cities": [
                    {
                        "id": 65082,
                        "name": "Bahani",
                        "latitude": "-11.63972000",
                        "longitude": "43.28417000"
                    },
                    {
                        "id": 65083,
                        "name": "Bambadjani",
                        "latitude": "-11.47861000",
                        "longitude": "43.37722000"
                    },
                    {
                        "id": 65089,
                        "name": "Bouni",
                        "latitude": "-11.48694000",
                        "longitude": "43.38833000"
                    },
                    {
                        "id": 65091,
                        "name": "Chezani",
                        "latitude": "-11.43140000",
                        "longitude": "43.39625000"
                    },
                    {
                        "id": 65092,
                        "name": "Chindini",
                        "latitude": "-11.92328000",
                        "longitude": "43.49109000"
                    },
                    {
                        "id": 65095,
                        "name": "Chouani",
                        "latitude": "-11.82330000",
                        "longitude": "43.29429000"
                    },
                    {
                        "id": 65097,
                        "name": "Dembéni",
                        "latitude": "-11.87361000",
                        "longitude": "43.39778000"
                    },
                    {
                        "id": 65100,
                        "name": "Douniani",
                        "latitude": "-11.42111000",
                        "longitude": "43.28889000"
                    },
                    {
                        "id": 65101,
                        "name": "Dzahadjou",
                        "latitude": "-11.85287000",
                        "longitude": "43.34987000"
                    },
                    {
                        "id": 65104,
                        "name": "Foumbouni",
                        "latitude": "-11.86537000",
                        "longitude": "43.49529000"
                    },
                    {
                        "id": 65106,
                        "name": "Hantsindzi",
                        "latitude": "-11.43178000",
                        "longitude": "43.41102000"
                    },
                    {
                        "id": 65109,
                        "name": "Héroumbili",
                        "latitude": "-11.54389000",
                        "longitude": "43.37972000"
                    },
                    {
                        "id": 65110,
                        "name": "Itsandra",
                        "latitude": "-11.67111000",
                        "longitude": "43.25472000"
                    },
                    {
                        "id": 65111,
                        "name": "Itsandzéni",
                        "latitude": "-11.47278000",
                        "longitude": "43.38444000"
                    },
                    {
                        "id": 65112,
                        "name": "Ivouani",
                        "latitude": "-11.39157000",
                        "longitude": "43.39454000"
                    },
                    {
                        "id": 65118,
                        "name": "Koua",
                        "latitude": "-11.42083000",
                        "longitude": "43.27639000"
                    },
                    {
                        "id": 65122,
                        "name": "Madjeouéni",
                        "latitude": "-11.82167000",
                        "longitude": "43.27806000"
                    },
                    {
                        "id": 65124,
                        "name": "Mandza",
                        "latitude": "-11.41806000",
                        "longitude": "43.29528000"
                    },
                    {
                        "id": 65126,
                        "name": "Mavingouni",
                        "latitude": "-11.71639000",
                        "longitude": "43.25250000"
                    },
                    {
                        "id": 65127,
                        "name": "Mbéni",
                        "latitude": "-11.50139000",
                        "longitude": "43.37750000"
                    },
                    {
                        "id": 65129,
                        "name": "Mitsamiouli",
                        "latitude": "-11.38472000",
                        "longitude": "43.28444000"
                    },
                    {
                        "id": 65130,
                        "name": "Mitsoudjé",
                        "latitude": "-11.81209000",
                        "longitude": "43.28043000"
                    },
                    {
                        "id": 65133,
                        "name": "Mnoungou",
                        "latitude": "-11.51778000",
                        "longitude": "43.37389000"
                    },
                    {
                        "id": 65134,
                        "name": "Mohoro",
                        "latitude": "-11.82701000",
                        "longitude": "43.45436000"
                    },
                    {
                        "id": 65135,
                        "name": "Moroni",
                        "latitude": "-11.70216000",
                        "longitude": "43.25506000"
                    },
                    {
                        "id": 65141,
                        "name": "Mtsamdou",
                        "latitude": "-11.60694000",
                        "longitude": "43.38056000"
                    },
                    {
                        "id": 65142,
                        "name": "Mvouni",
                        "latitude": "-11.71611000",
                        "longitude": "43.26472000"
                    },
                    {
                        "id": 65144,
                        "name": "Nioumamilima",
                        "latitude": "-11.85461000",
                        "longitude": "43.44607000"
                    },
                    {
                        "id": 65145,
                        "name": "Ntsaouéni",
                        "latitude": "-11.46583000",
                        "longitude": "43.26278000"
                    },
                    {
                        "id": 65146,
                        "name": "Ntsoudjini",
                        "latitude": "-11.65972000",
                        "longitude": "43.26139000"
                    },
                    {
                        "id": 65150,
                        "name": "Ouellah",
                        "latitude": "-11.39028000",
                        "longitude": "43.33194000"
                    },
                    {
                        "id": 65151,
                        "name": "Ouhozi",
                        "latitude": "-11.40500000",
                        "longitude": "43.28222000"
                    },
                    {
                        "id": 65152,
                        "name": "Ourovéni",
                        "latitude": "-11.91375000",
                        "longitude": "43.49804000"
                    },
                    {
                        "id": 65153,
                        "name": "Oussivo",
                        "latitude": "-11.58500000",
                        "longitude": "43.26722000"
                    },
                    {
                        "id": 65157,
                        "name": "Salimani",
                        "latitude": "-11.81150000",
                        "longitude": "43.26823000"
                    },
                    {
                        "id": 65160,
                        "name": "Séléa",
                        "latitude": "-11.78444000",
                        "longitude": "43.26083000"
                    },
                    {
                        "id": 65159,
                        "name": "Singani",
                        "latitude": "-11.84784000",
                        "longitude": "43.31731000"
                    },
                    {
                        "id": 65161,
                        "name": "Tsidjé",
                        "latitude": "-11.69806000",
                        "longitude": "43.26194000"
                    },
                    {
                        "id": 65163,
                        "name": "Vanadjou",
                        "latitude": "-11.60750000",
                        "longitude": "43.27611000"
                    },
                    {
                        "id": 65164,
                        "name": "Vanambouani",
                        "latitude": "-11.61139000",
                        "longitude": "43.25306000"
                    }
                ]
            },
            {
                "id": 2820,
                "name": "Mohéli",
                "iso2": "M",
                "latitude": "-12.33773760",
                "longitude": "43.73340890",
                "type": "island",
                "cities": [
                    {
                        "id": 65098,
                        "name": "Djoyézi",
                        "latitude": "-12.30587000",
                        "longitude": "43.77425000"
                    },
                    {
                        "id": 65103,
                        "name": "Fomboni",
                        "latitude": "-12.28759000",
                        "longitude": "43.74344000"
                    },
                    {
                        "id": 65108,
                        "name": "Hoani",
                        "latitude": "-12.25083000",
                        "longitude": "43.67472000"
                    },
                    {
                        "id": 65140,
                        "name": "Mtakoudja",
                        "latitude": "-12.26111000",
                        "longitude": "43.70361000"
                    },
                    {
                        "id": 65143,
                        "name": "Nioumachoua",
                        "latitude": "-12.36139000",
                        "longitude": "43.71528000"
                    },
                    {
                        "id": 65148,
                        "name": "Ouanani",
                        "latitude": "-12.33750000",
                        "longitude": "43.79750000"
                    },
                    {
                        "id": 65166,
                        "name": "Ziroudani",
                        "latitude": "-12.33250000",
                        "longitude": "43.77750000"
                    }
                ]
            }
        ]
    },
    {
        "id": 50,
        "name": "Congo",
        "iso3": "COG",
        "iso2": "CG",
        "numeric_code": "178",
        "phonecode": "242",
        "capital": "Brazzaville",
        "currency": "XAF",
        "currency_name": "Congolese Franc",
        "currency_symbol": "CDF",
        "tld": ".cg",
        "native": "République du Congo",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Middle Africa",
        "subregion_id": 2,
        "nationality": "Congolese",
        "timezones": [
            {
                "zoneName": "Africa\/Brazzaville",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "br": "Republik Kongo",
            "ko": "콩고",
            "pt-BR": "Congo",
            "pt": "Congo",
            "nl": "Congo [Republiek]",
            "hr": "Kongo",
            "fa": "کنگو",
            "de": "Kongo",
            "es": "Congo",
            "fr": "Congo",
            "ja": "コンゴ共和国",
            "it": "Congo",
            "zh-CN": "刚果",
            "tr": "Kongo",
            "ru": "Конго",
            "uk": "Конго",
            "pl": "Kongo"
        },
        "latitude": "-1.00000000",
        "longitude": "15.00000000",
        "emoji": "🇨🇬",
        "emojiU": "U+1F1E8 U+1F1EC",
        "states": [
            {
                "id": 2866,
                "name": "Bouenza",
                "iso2": "11",
                "latitude": "-4.11280790",
                "longitude": "13.72891670",
                "type": "department",
                "cities": [
                    {
                        "id": 17345,
                        "name": "Kayes",
                        "latitude": "-4.20493000",
                        "longitude": "13.28608000"
                    },
                    {
                        "id": 17348,
                        "name": "Madingou",
                        "latitude": "-4.15361000",
                        "longitude": "13.55000000"
                    }
                ]
            },
            {
                "id": 2870,
                "name": "Brazzaville",
                "iso2": "BZV",
                "latitude": "-4.26335970",
                "longitude": "15.24288530",
                "type": "department",
                "cities": [
                    {
                        "id": 17339,
                        "name": "Brazzaville",
                        "latitude": "-4.26613000",
                        "longitude": "15.28318000"
                    }
                ]
            },
            {
                "id": 2864,
                "name": "Cuvette",
                "iso2": "8",
                "latitude": "-0.28774460",
                "longitude": "16.15809370",
                "type": "department",
                "cities": [
                    {
                        "id": 17349,
                        "name": "Makoua",
                        "latitude": "0.00694000",
                        "longitude": "15.63333000"
                    },
                    {
                        "id": 17352,
                        "name": "Owando",
                        "latitude": "-0.48193000",
                        "longitude": "15.89988000"
                    }
                ]
            },
            {
                "id": 2869,
                "name": "Cuvette-Ouest",
                "iso2": "15",
                "latitude": "0.14475500",
                "longitude": "14.47233010",
                "type": "department",
                "cities": [
                    {
                        "id": 17342,
                        "name": "Ewo",
                        "latitude": "-0.87250000",
                        "longitude": "14.82056000"
                    }
                ]
            },
            {
                "id": 2867,
                "name": "Kouilou",
                "iso2": "5",
                "latitude": "-4.14284130",
                "longitude": "11.88917210",
                "type": "department",
                "cities": []
            },
            {
                "id": 2868,
                "name": "Lékoumou",
                "iso2": "2",
                "latitude": "-3.17038200",
                "longitude": "13.35872880",
                "type": "department",
                "cities": [
                    {
                        "id": 17354,
                        "name": "Sibiti",
                        "latitude": "-3.68192000",
                        "longitude": "13.34985000"
                    }
                ]
            },
            {
                "id": 2865,
                "name": "Likouala",
                "iso2": "7",
                "latitude": "2.04392400",
                "longitude": "17.66888700",
                "type": "department",
                "cities": [
                    {
                        "id": 17344,
                        "name": "Impfondo",
                        "latitude": "1.61804000",
                        "longitude": "18.05981000"
                    }
                ]
            },
            {
                "id": 2872,
                "name": "Niari",
                "iso2": "9",
                "latitude": "-3.18427000",
                "longitude": "12.25479190",
                "type": "department",
                "cities": [
                    {
                        "id": 17341,
                        "name": "Dolisie",
                        "latitude": "-4.19834000",
                        "longitude": "12.66664000"
                    },
                    {
                        "id": 17350,
                        "name": "Mossendjo",
                        "latitude": "-2.94968000",
                        "longitude": "12.70423000"
                    }
                ]
            },
            {
                "id": 2862,
                "name": "Plateaux",
                "iso2": "14",
                "latitude": "-2.06800880",
                "longitude": "15.40680790",
                "type": "department",
                "cities": [
                    {
                        "id": 17340,
                        "name": "Djambala",
                        "latitude": "-2.54472000",
                        "longitude": "14.75333000"
                    },
                    {
                        "id": 17343,
                        "name": "Gamboma",
                        "latitude": "-1.87639000",
                        "longitude": "15.86444000"
                    }
                ]
            },
            {
                "id": 2863,
                "name": "Pointe-Noire",
                "iso2": "16",
                "latitude": "-4.76916230",
                "longitude": "11.86636200",
                "type": "department",
                "cities": [
                    {
                        "id": 17347,
                        "name": "Loandjili",
                        "latitude": "-4.75611000",
                        "longitude": "11.85778000"
                    },
                    {
                        "id": 17353,
                        "name": "Pointe-Noire",
                        "latitude": "-4.77609000",
                        "longitude": "11.86352000"
                    }
                ]
            },
            {
                "id": 2873,
                "name": "Pool",
                "iso2": "12",
                "latitude": "-3.77626280",
                "longitude": "14.84546190",
                "type": "department",
                "cities": [
                    {
                        "id": 17346,
                        "name": "Kinkala",
                        "latitude": "-4.36139000",
                        "longitude": "14.76444000"
                    }
                ]
            },
            {
                "id": 2871,
                "name": "Sangha",
                "iso2": "13",
                "latitude": "1.46623280",
                "longitude": "15.40680790",
                "type": "department",
                "cities": [
                    {
                        "id": 17351,
                        "name": "Ouésso",
                        "latitude": "1.61361000",
                        "longitude": "16.05167000"
                    },
                    {
                        "id": 17355,
                        "name": "Sémbé",
                        "latitude": "1.64806000",
                        "longitude": "14.58056000"
                    }
                ]
            }
        ]
    },
    {
        "id": 52,
        "name": "Cook Islands",
        "iso3": "COK",
        "iso2": "CK",
        "numeric_code": "184",
        "phonecode": "682",
        "capital": "Avarua",
        "currency": "NZD",
        "currency_name": "New Zealand dollar",
        "currency_symbol": "$",
        "tld": ".ck",
        "native": "Cook Islands",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Polynesia",
        "subregion_id": 22,
        "nationality": "Cook Island",
        "timezones": [
            {
                "zoneName": "Pacific\/Rarotonga",
                "gmtOffset": -36000,
                "gmtOffsetName": "UTC-10:00",
                "abbreviation": "CKT",
                "tzName": "Cook Island Time"
            }
        ],
        "translations": {
            "br": "Inizi Cook",
            "ko": "쿡 제도",
            "pt-BR": "Ilhas Cook",
            "pt": "Ilhas Cook",
            "nl": "Cookeilanden",
            "hr": "Cookovo Otočje",
            "fa": "جزایر کوک",
            "de": "Cookinseln",
            "es": "Islas Cook",
            "fr": "Îles Cook",
            "ja": "クック諸島",
            "it": "Isole Cook",
            "zh-CN": "库克群岛",
            "tr": "Cook Adalari",
            "ru": "Острова Кука",
            "uk": "Острови Кука",
            "pl": "Wyspy Cooka"
        },
        "latitude": "-21.23333333",
        "longitude": "-159.76666666",
        "emoji": "🇨🇰",
        "emojiU": "U+1F1E8 U+1F1F0",
        "states": []
    },
    {
        "id": 53,
        "name": "Costa Rica",
        "iso3": "CRI",
        "iso2": "CR",
        "numeric_code": "188",
        "phonecode": "506",
        "capital": "San Jose",
        "currency": "CRC",
        "currency_name": "Costa Rican colón",
        "currency_symbol": "₡",
        "tld": ".cr",
        "native": "Costa Rica",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Central America",
        "subregion_id": 9,
        "nationality": "Costa Rican",
        "timezones": [
            {
                "zoneName": "America\/Costa_Rica",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Costa Rica",
            "ko": "코스타리카",
            "pt-BR": "Costa Rica",
            "pt": "Costa Rica",
            "nl": "Costa Rica",
            "hr": "Kostarika",
            "fa": "کاستاریکا",
            "de": "Costa Rica",
            "es": "Costa Rica",
            "fr": "Costa Rica",
            "ja": "コスタリカ",
            "it": "Costa Rica",
            "zh-CN": "哥斯达黎加",
            "tr": "Kosta Rika",
            "ru": "Коста-Рика",
            "uk": "Коста-Ріка",
            "pl": "Kostaryka"
        },
        "latitude": "10.00000000",
        "longitude": "-84.00000000",
        "emoji": "🇨🇷",
        "emojiU": "U+1F1E8 U+1F1F7",
        "states": [
            {
                "id": 1215,
                "name": "Alajuela",
                "iso2": "A",
                "latitude": "10.39158300",
                "longitude": "-84.43827210",
                "type": "province",
                "cities": [
                    {
                        "id": 21643,
                        "name": "Alajuela",
                        "latitude": "10.01625000",
                        "longitude": "-84.21163000"
                    },
                    {
                        "id": 21647,
                        "name": "Atenas",
                        "latitude": "9.98333000",
                        "longitude": "-84.38333000"
                    },
                    {
                        "id": 21653,
                        "name": "Bijagua",
                        "latitude": "10.73279000",
                        "longitude": "-85.05676000"
                    },
                    {
                        "id": 21658,
                        "name": "Carrillos",
                        "latitude": "10.02918000",
                        "longitude": "-84.27403000"
                    },
                    {
                        "id": 21672,
                        "name": "Desamparados",
                        "latitude": "9.94727000",
                        "longitude": "-84.50626000"
                    },
                    {
                        "id": 21678,
                        "name": "Esquipulas",
                        "latitude": "10.05676000",
                        "longitude": "-84.42337000"
                    },
                    {
                        "id": 21685,
                        "name": "Grecia",
                        "latitude": "10.06892000",
                        "longitude": "-84.31458000"
                    },
                    {
                        "id": 21687,
                        "name": "Guatuso",
                        "latitude": "10.66667000",
                        "longitude": "-84.83333000"
                    },
                    {
                        "id": 21698,
                        "name": "La Fortuna",
                        "latitude": "10.47089000",
                        "longitude": "-84.64535000"
                    },
                    {
                        "id": 21705,
                        "name": "Los Chiles",
                        "latitude": "10.86667000",
                        "longitude": "-84.66667000"
                    },
                    {
                        "id": 21715,
                        "name": "Naranjo",
                        "latitude": "10.11667000",
                        "longitude": "-84.40000000"
                    },
                    {
                        "id": 21719,
                        "name": "Orotina",
                        "latitude": "9.90000000",
                        "longitude": "-84.56667000"
                    },
                    {
                        "id": 21722,
                        "name": "Palmares",
                        "latitude": "10.03333000",
                        "longitude": "-84.43333000"
                    },
                    {
                        "id": 21729,
                        "name": "Pital",
                        "latitude": "10.45056000",
                        "longitude": "-84.27406000"
                    },
                    {
                        "id": 21733,
                        "name": "Poás",
                        "latitude": "10.08333000",
                        "longitude": "-84.23333000"
                    },
                    {
                        "id": 21732,
                        "name": "Pocosol",
                        "latitude": "10.36667000",
                        "longitude": "-84.61667000"
                    },
                    {
                        "id": 21739,
                        "name": "Quesada",
                        "latitude": "10.32381000",
                        "longitude": "-84.42714000"
                    },
                    {
                        "id": 21741,
                        "name": "Río Segundo",
                        "latitude": "10.24138000",
                        "longitude": "-84.27933000"
                    },
                    {
                        "id": 21742,
                        "name": "Sabanilla",
                        "latitude": "10.07404000",
                        "longitude": "-84.21551000"
                    },
                    {
                        "id": 21747,
                        "name": "San Carlos",
                        "latitude": "10.58333000",
                        "longitude": "-84.41667000"
                    },
                    {
                        "id": 21755,
                        "name": "San José",
                        "latitude": "10.95173000",
                        "longitude": "-85.13610000"
                    },
                    {
                        "id": 21758,
                        "name": "San Juan",
                        "latitude": "10.10248000",
                        "longitude": "-84.31694000"
                    },
                    {
                        "id": 21761,
                        "name": "San Mateo",
                        "latitude": "9.95000000",
                        "longitude": "-84.51667000"
                    },
                    {
                        "id": 21766,
                        "name": "San Rafael",
                        "latitude": "10.06403000",
                        "longitude": "-84.47281000"
                    },
                    {
                        "id": 21770,
                        "name": "San Ramón",
                        "latitude": "10.08718000",
                        "longitude": "-84.47044000"
                    },
                    {
                        "id": 21777,
                        "name": "Santiago",
                        "latitude": "10.02275000",
                        "longitude": "-84.44420000"
                    },
                    {
                        "id": 21795,
                        "name": "Upala",
                        "latitude": "10.85000000",
                        "longitude": "-85.16667000"
                    },
                    {
                        "id": 21796,
                        "name": "Valverde Vega",
                        "latitude": "10.18721000",
                        "longitude": "-84.30290000"
                    },
                    {
                        "id": 21798,
                        "name": "Zarcero",
                        "latitude": "10.20000000",
                        "longitude": "-84.40000000"
                    }
                ]
            },
            {
                "id": 1211,
                "name": "Cartago",
                "iso2": "C",
                "latitude": "9.86223110",
                "longitude": "-83.92141870",
                "type": "province",
                "cities": [
                    {
                        "id": 21645,
                        "name": "Alvarado",
                        "latitude": "9.93333000",
                        "longitude": "-83.80000000"
                    },
                    {
                        "id": 21659,
                        "name": "Cartago",
                        "latitude": "9.86444000",
                        "longitude": "-83.91944000"
                    },
                    {
                        "id": 21665,
                        "name": "Concepción",
                        "latitude": "9.93333000",
                        "longitude": "-84.00000000"
                    },
                    {
                        "id": 21668,
                        "name": "Cot",
                        "latitude": "9.89449000",
                        "longitude": "-83.87302000"
                    },
                    {
                        "id": 21675,
                        "name": "El Guarco",
                        "latitude": "9.75000000",
                        "longitude": "-83.91667000"
                    },
                    {
                        "id": 21694,
                        "name": "Jiménez",
                        "latitude": "9.75000000",
                        "longitude": "-83.68333000"
                    },
                    {
                        "id": 21699,
                        "name": "La Suiza",
                        "latitude": "9.85065000",
                        "longitude": "-83.61690000"
                    },
                    {
                        "id": 21700,
                        "name": "La Unión",
                        "latitude": "9.91667000",
                        "longitude": "-83.98333000"
                    },
                    {
                        "id": 21717,
                        "name": "Oreamuno",
                        "latitude": "10.00000000",
                        "longitude": "-83.83333000"
                    },
                    {
                        "id": 21718,
                        "name": "Orosí",
                        "latitude": "9.79617000",
                        "longitude": "-83.85383000"
                    },
                    {
                        "id": 21721,
                        "name": "Pacayas",
                        "latitude": "9.80709000",
                        "longitude": "-84.04764000"
                    },
                    {
                        "id": 21725,
                        "name": "Paraíso",
                        "latitude": "9.75000000",
                        "longitude": "-83.80000000"
                    },
                    {
                        "id": 21728,
                        "name": "Pejibaye",
                        "latitude": "9.81135000",
                        "longitude": "-83.70336000"
                    },
                    {
                        "id": 21748,
                        "name": "San Diego",
                        "latitude": "9.89898000",
                        "longitude": "-84.00287000"
                    },
                    {
                        "id": 21790,
                        "name": "Tobosi",
                        "latitude": "9.83837000",
                        "longitude": "-83.98391000"
                    },
                    {
                        "id": 21791,
                        "name": "Tres Ríos",
                        "latitude": "9.90644000",
                        "longitude": "-83.98760000"
                    },
                    {
                        "id": 21792,
                        "name": "Tucurrique",
                        "latitude": "9.85336000",
                        "longitude": "-83.72273000"
                    },
                    {
                        "id": 21793,
                        "name": "Turrialba",
                        "latitude": "9.80000000",
                        "longitude": "-83.53333000"
                    }
                ]
            },
            {
                "id": 1209,
                "name": "Guanacaste",
                "iso2": "G",
                "latitude": "10.62673990",
                "longitude": "-85.44367060",
                "type": "province",
                "cities": [
                    {
                        "id": 21641,
                        "name": "Abangares",
                        "latitude": "10.21667000",
                        "longitude": "-85.00000000"
                    },
                    {
                        "id": 21648,
                        "name": "Bagaces",
                        "latitude": "10.50000000",
                        "longitude": "-85.25000000"
                    },
                    {
                        "id": 21651,
                        "name": "Belén",
                        "latitude": "10.40789000",
                        "longitude": "-85.58836000"
                    },
                    {
                        "id": 21660,
                        "name": "Cañas",
                        "latitude": "10.48005000",
                        "longitude": "-85.11349000"
                    },
                    {
                        "id": 21657,
                        "name": "Carrillo",
                        "latitude": "10.41667000",
                        "longitude": "-85.58333000"
                    },
                    {
                        "id": 21680,
                        "name": "Fortuna",
                        "latitude": "10.67384000",
                        "longitude": "-85.19984000"
                    },
                    {
                        "id": 21691,
                        "name": "Hojancha",
                        "latitude": "9.96667000",
                        "longitude": "-85.41667000"
                    },
                    {
                        "id": 21695,
                        "name": "Juntas",
                        "latitude": "10.28089000",
                        "longitude": "-84.95951000"
                    },
                    {
                        "id": 21697,
                        "name": "La Cruz",
                        "latitude": "11.00000000",
                        "longitude": "-85.58333000"
                    },
                    {
                        "id": 21702,
                        "name": "Liberia",
                        "latitude": "10.63504000",
                        "longitude": "-85.43772000"
                    },
                    {
                        "id": 21714,
                        "name": "Nandayure",
                        "latitude": "9.91667000",
                        "longitude": "-85.28333000"
                    },
                    {
                        "id": 21716,
                        "name": "Nicoya",
                        "latitude": "10.08333000",
                        "longitude": "-85.50000000"
                    },
                    {
                        "id": 21784,
                        "name": "Sámara",
                        "latitude": "9.88147000",
                        "longitude": "-85.52809000"
                    },
                    {
                        "id": 21776,
                        "name": "Santa Cruz",
                        "latitude": "10.25000000",
                        "longitude": "-85.66667000"
                    },
                    {
                        "id": 21781,
                        "name": "Sardinal",
                        "latitude": "10.51674000",
                        "longitude": "-85.64748000"
                    },
                    {
                        "id": 21789,
                        "name": "Tilarán",
                        "latitude": "10.45878000",
                        "longitude": "-84.97513000"
                    }
                ]
            },
            {
                "id": 1212,
                "name": "Heredia",
                "iso2": "H",
                "latitude": "10.47352300",
                "longitude": "-84.01674230",
                "type": "province",
                "cities": [
                    {
                        "id": 21799,
                        "name": "Ángeles",
                        "latitude": "9.99591000",
                        "longitude": "-84.05126000"
                    },
                    {
                        "id": 21649,
                        "name": "Barva",
                        "latitude": "10.08333000",
                        "longitude": "-84.10000000"
                    },
                    {
                        "id": 21652,
                        "name": "Belén",
                        "latitude": "9.98333000",
                        "longitude": "-84.16667000"
                    },
                    {
                        "id": 21679,
                        "name": "Flores",
                        "latitude": "10.00000000",
                        "longitude": "-84.15000000"
                    },
                    {
                        "id": 21690,
                        "name": "Heredia",
                        "latitude": "10.00236000",
                        "longitude": "-84.11651000"
                    },
                    {
                        "id": 21696,
                        "name": "La Asunción",
                        "latitude": "9.97961000",
                        "longitude": "-84.17281000"
                    },
                    {
                        "id": 21704,
                        "name": "Llorente",
                        "latitude": "9.99844000",
                        "longitude": "-84.15448000"
                    },
                    {
                        "id": 21708,
                        "name": "Mercedes",
                        "latitude": "10.00695000",
                        "longitude": "-84.13396000"
                    },
                    {
                        "id": 21746,
                        "name": "San Antonio",
                        "latitude": "9.98333000",
                        "longitude": "-84.18333000"
                    },
                    {
                        "id": 21750,
                        "name": "San Francisco",
                        "latitude": "9.99299000",
                        "longitude": "-84.12934000"
                    },
                    {
                        "id": 21753,
                        "name": "San Isidro",
                        "latitude": "10.03333000",
                        "longitude": "-84.03333000"
                    },
                    {
                        "id": 21754,
                        "name": "San Josecito",
                        "latitude": "10.01667000",
                        "longitude": "-84.10000000"
                    },
                    {
                        "id": 21763,
                        "name": "San Pablo",
                        "latitude": "10.00000000",
                        "longitude": "-84.08333000"
                    },
                    {
                        "id": 21767,
                        "name": "San Rafael",
                        "latitude": "10.05000000",
                        "longitude": "-84.06667000"
                    },
                    {
                        "id": 21775,
                        "name": "Santa Bárbara",
                        "latitude": "10.08333000",
                        "longitude": "-84.15000000"
                    },
                    {
                        "id": 21779,
                        "name": "Santo Domingo",
                        "latitude": "10.06389000",
                        "longitude": "-84.15499000"
                    },
                    {
                        "id": 21780,
                        "name": "Sarapiquí",
                        "latitude": "10.50000000",
                        "longitude": "-84.00000000"
                    }
                ]
            },
            {
                "id": 1213,
                "name": "Limón",
                "iso2": "L",
                "latitude": "9.98963980",
                "longitude": "-83.03324170",
                "type": "province",
                "cities": [
                    {
                        "id": 21650,
                        "name": "Batán",
                        "latitude": "10.08354000",
                        "longitude": "-83.33413000"
                    },
                    {
                        "id": 21688,
                        "name": "Guácimo",
                        "latitude": "10.20000000",
                        "longitude": "-83.66667000"
                    },
                    {
                        "id": 21689,
                        "name": "Guápiles",
                        "latitude": "10.21682000",
                        "longitude": "-83.78483000"
                    },
                    {
                        "id": 21703,
                        "name": "Limón",
                        "latitude": "9.99074000",
                        "longitude": "-83.03596000"
                    },
                    {
                        "id": 21706,
                        "name": "Matina",
                        "latitude": "10.00000000",
                        "longitude": "-83.25000000"
                    },
                    {
                        "id": 21730,
                        "name": "Pococí",
                        "latitude": "10.50000000",
                        "longitude": "-83.63333000"
                    },
                    {
                        "id": 21731,
                        "name": "Pocora",
                        "latitude": "10.17185000",
                        "longitude": "-83.60439000"
                    },
                    {
                        "id": 21740,
                        "name": "Roxana",
                        "latitude": "10.26712000",
                        "longitude": "-83.75110000"
                    },
                    {
                        "id": 21782,
                        "name": "Siquirres",
                        "latitude": "10.11667000",
                        "longitude": "-83.50000000"
                    },
                    {
                        "id": 21783,
                        "name": "Sixaola",
                        "latitude": "9.52766000",
                        "longitude": "-82.62185000"
                    },
                    {
                        "id": 21785,
                        "name": "Talamanca",
                        "latitude": "9.50000000",
                        "longitude": "-83.08333000"
                    }
                ]
            },
            {
                "id": 1210,
                "name": "Puntarenas",
                "iso2": "P",
                "latitude": "9.21695310",
                "longitude": "-83.33618800",
                "type": "province",
                "cities": [
                    {
                        "id": 21654,
                        "name": "Buenos Aires",
                        "latitude": "9.11667000",
                        "longitude": "-83.25000000"
                    },
                    {
                        "id": 21656,
                        "name": "Canoas",
                        "latitude": "8.53305000",
                        "longitude": "-82.83844000"
                    },
                    {
                        "id": 21661,
                        "name": "Chacarita",
                        "latitude": "9.98424000",
                        "longitude": "-84.77892000"
                    },
                    {
                        "id": 21662,
                        "name": "Ciudad Cortés",
                        "latitude": "8.95988000",
                        "longitude": "-83.52381000"
                    },
                    {
                        "id": 21666,
                        "name": "Corredor",
                        "latitude": "8.64002000",
                        "longitude": "-82.94600000"
                    },
                    {
                        "id": 21667,
                        "name": "Corredores",
                        "latitude": "8.58333000",
                        "longitude": "-82.91667000"
                    },
                    {
                        "id": 21669,
                        "name": "Coto Brus",
                        "latitude": "8.88333000",
                        "longitude": "-82.96667000"
                    },
                    {
                        "id": 21677,
                        "name": "Esparza",
                        "latitude": "10.00000000",
                        "longitude": "-84.66667000"
                    },
                    {
                        "id": 21681,
                        "name": "Garabito",
                        "latitude": "9.61903000",
                        "longitude": "-84.62013000"
                    },
                    {
                        "id": 21683,
                        "name": "Golfito",
                        "latitude": "8.60000000",
                        "longitude": "-83.12000000"
                    },
                    {
                        "id": 21693,
                        "name": "Jacó",
                        "latitude": "9.61497000",
                        "longitude": "-84.62975000"
                    },
                    {
                        "id": 21709,
                        "name": "Miramar",
                        "latitude": "10.09250000",
                        "longitude": "-84.72978000"
                    },
                    {
                        "id": 21711,
                        "name": "Montes de Oro",
                        "latitude": "10.10000000",
                        "longitude": "-84.75000000"
                    },
                    {
                        "id": 21720,
                        "name": "Osa",
                        "latitude": "8.83333000",
                        "longitude": "-83.50000000"
                    },
                    {
                        "id": 21724,
                        "name": "Paquera",
                        "latitude": "9.82005000",
                        "longitude": "-84.93513000"
                    },
                    {
                        "id": 21726,
                        "name": "Parrita",
                        "latitude": "9.55000000",
                        "longitude": "-84.33333000"
                    },
                    {
                        "id": 21734,
                        "name": "Puntarenas",
                        "latitude": "9.97625000",
                        "longitude": "-84.83836000"
                    },
                    {
                        "id": 21738,
                        "name": "Quepos",
                        "latitude": "9.43187000",
                        "longitude": "-84.16141000"
                    },
                    {
                        "id": 21773,
                        "name": "San Vito",
                        "latitude": "8.82079000",
                        "longitude": "-82.97092000"
                    }
                ]
            },
            {
                "id": 1214,
                "name": "San José",
                "iso2": "SJ",
                "latitude": "9.91297270",
                "longitude": "-84.07682940",
                "type": "province",
                "cities": [
                    {
                        "id": 21642,
                        "name": "Acosta",
                        "latitude": "9.80000000",
                        "longitude": "-84.20000000"
                    },
                    {
                        "id": 21644,
                        "name": "Alajuelita",
                        "latitude": "9.90000000",
                        "longitude": "-84.10000000"
                    },
                    {
                        "id": 21646,
                        "name": "Aserrí",
                        "latitude": "9.86667000",
                        "longitude": "-84.10000000"
                    },
                    {
                        "id": 21655,
                        "name": "Calle Blancos",
                        "latitude": "9.95000000",
                        "longitude": "-84.06667000"
                    },
                    {
                        "id": 21663,
                        "name": "Colima",
                        "latitude": "9.95091000",
                        "longitude": "-84.08503000"
                    },
                    {
                        "id": 21664,
                        "name": "Colón",
                        "latitude": "9.91491000",
                        "longitude": "-84.24170000"
                    },
                    {
                        "id": 21670,
                        "name": "Curridabat",
                        "latitude": "9.91667000",
                        "longitude": "-84.03333000"
                    },
                    {
                        "id": 21671,
                        "name": "Daniel Flores",
                        "latitude": "9.33554000",
                        "longitude": "-83.66940000"
                    },
                    {
                        "id": 21673,
                        "name": "Desamparados",
                        "latitude": "9.90000000",
                        "longitude": "-84.06667000"
                    },
                    {
                        "id": 21674,
                        "name": "Dota",
                        "latitude": "9.65000000",
                        "longitude": "-83.95000000"
                    },
                    {
                        "id": 21676,
                        "name": "Escazú",
                        "latitude": "9.93333000",
                        "longitude": "-84.13333000"
                    },
                    {
                        "id": 21682,
                        "name": "Goicoechea",
                        "latitude": "9.94848000",
                        "longitude": "-84.06365000"
                    },
                    {
                        "id": 21684,
                        "name": "Granadilla",
                        "latitude": "9.93491000",
                        "longitude": "-84.01688000"
                    },
                    {
                        "id": 21686,
                        "name": "Guadalupe",
                        "latitude": "9.94805000",
                        "longitude": "-84.05665000"
                    },
                    {
                        "id": 21692,
                        "name": "Ipís",
                        "latitude": "9.96745000",
                        "longitude": "-84.01326000"
                    },
                    {
                        "id": 21701,
                        "name": "León Cortés",
                        "latitude": "9.68300000",
                        "longitude": "-84.04781000"
                    },
                    {
                        "id": 21707,
                        "name": "Mercedes",
                        "latitude": "9.26270000",
                        "longitude": "-83.58202000"
                    },
                    {
                        "id": 21710,
                        "name": "Montes de Oca",
                        "latitude": "9.93960000",
                        "longitude": "-84.03013000"
                    },
                    {
                        "id": 21712,
                        "name": "Mora",
                        "latitude": "9.91667000",
                        "longitude": "-84.25000000"
                    },
                    {
                        "id": 21713,
                        "name": "Moravia",
                        "latitude": "10.04000000",
                        "longitude": "-84.00000000"
                    },
                    {
                        "id": 21723,
                        "name": "Palmichal",
                        "latitude": "9.83778000",
                        "longitude": "-84.20478000"
                    },
                    {
                        "id": 21727,
                        "name": "Patarrá",
                        "latitude": "9.88071000",
                        "longitude": "-84.03501000"
                    },
                    {
                        "id": 21737,
                        "name": "Pérez Zeledón",
                        "latitude": "9.35473000",
                        "longitude": "-83.63484000"
                    },
                    {
                        "id": 21735,
                        "name": "Puriscal",
                        "latitude": "9.75000000",
                        "longitude": "-84.41667000"
                    },
                    {
                        "id": 21736,
                        "name": "Purral",
                        "latitude": "9.95808000",
                        "longitude": "-84.03050000"
                    },
                    {
                        "id": 21743,
                        "name": "Sabanilla",
                        "latitude": "9.94522000",
                        "longitude": "-84.03927000"
                    },
                    {
                        "id": 21744,
                        "name": "Salitral",
                        "latitude": "9.91163000",
                        "longitude": "-84.17835000"
                    },
                    {
                        "id": 21745,
                        "name": "Salitrillos",
                        "latitude": "9.85259000",
                        "longitude": "-84.09062000"
                    },
                    {
                        "id": 21749,
                        "name": "San Felipe",
                        "latitude": "9.90488000",
                        "longitude": "-84.10551000"
                    },
                    {
                        "id": 21751,
                        "name": "San Ignacio",
                        "latitude": "9.79853000",
                        "longitude": "-84.16173000"
                    },
                    {
                        "id": 21752,
                        "name": "San Isidro",
                        "latitude": "9.36740000",
                        "longitude": "-83.69713000"
                    },
                    {
                        "id": 21756,
                        "name": "San José",
                        "latitude": "9.93333000",
                        "longitude": "-84.08333000"
                    },
                    {
                        "id": 21757,
                        "name": "San Juan",
                        "latitude": "9.95974000",
                        "longitude": "-84.08165000"
                    },
                    {
                        "id": 21759,
                        "name": "San Juan de Dios",
                        "latitude": "9.87730000",
                        "longitude": "-84.08470000"
                    },
                    {
                        "id": 21760,
                        "name": "San Marcos",
                        "latitude": "9.66010000",
                        "longitude": "-84.02026000"
                    },
                    {
                        "id": 21762,
                        "name": "San Miguel",
                        "latitude": "9.87121000",
                        "longitude": "-84.06084000"
                    },
                    {
                        "id": 21764,
                        "name": "San Pedro",
                        "latitude": "9.92829000",
                        "longitude": "-84.05074000"
                    },
                    {
                        "id": 21765,
                        "name": "San Rafael",
                        "latitude": "9.92787000",
                        "longitude": "-84.13722000"
                    },
                    {
                        "id": 21768,
                        "name": "San Rafael Abajo",
                        "latitude": "9.83100000",
                        "longitude": "-84.29008000"
                    },
                    {
                        "id": 21769,
                        "name": "San Rafael Arriba",
                        "latitude": "9.87556000",
                        "longitude": "-84.07661000"
                    },
                    {
                        "id": 21771,
                        "name": "San Vicente",
                        "latitude": "9.96016000",
                        "longitude": "-84.04762000"
                    },
                    {
                        "id": 21772,
                        "name": "San Vicente de Moravia",
                        "latitude": "9.96164000",
                        "longitude": "-84.04880000"
                    },
                    {
                        "id": 21774,
                        "name": "Santa Ana",
                        "latitude": "9.93260000",
                        "longitude": "-84.18255000"
                    },
                    {
                        "id": 21778,
                        "name": "Santiago",
                        "latitude": "9.84636000",
                        "longitude": "-84.31428000"
                    },
                    {
                        "id": 21786,
                        "name": "Tarrazú",
                        "latitude": "9.65965000",
                        "longitude": "-84.02138000"
                    },
                    {
                        "id": 21787,
                        "name": "Tejar",
                        "latitude": "9.74622000",
                        "longitude": "-84.23368000"
                    },
                    {
                        "id": 21788,
                        "name": "Tibás",
                        "latitude": "9.96667000",
                        "longitude": "-84.08333000"
                    },
                    {
                        "id": 21794,
                        "name": "Turrubares",
                        "latitude": "9.75000000",
                        "longitude": "-84.50000000"
                    },
                    {
                        "id": 21797,
                        "name": "Vázquez de Coronado",
                        "latitude": "10.06000000",
                        "longitude": "-84.00000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 54,
        "name": "Cote D'Ivoire (Ivory Coast)",
        "iso3": "CIV",
        "iso2": "CI",
        "numeric_code": "384",
        "phonecode": "225",
        "capital": "Yamoussoukro",
        "currency": "XOF",
        "currency_name": "West African CFA franc",
        "currency_symbol": "CFA",
        "tld": ".ci",
        "native": null,
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Ivorian",
        "timezones": [
            {
                "zoneName": "Africa\/Abidjan",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Aod an Olifant",
            "ko": "코트디부아르",
            "pt-BR": "Costa do Marfim",
            "pt": "Costa do Marfim",
            "nl": "Ivoorkust",
            "hr": "Obala Bjelokosti",
            "fa": "ساحل عاج",
            "de": "Elfenbeinküste",
            "es": "Costa de Marfil",
            "fr": "Côte d'Ivoire",
            "ja": "コートジボワール",
            "it": "Costa D'Avorio",
            "zh-CN": "科特迪瓦",
            "tr": "Kotdivuar",
            "ru": "Кот-д'Ивуар (Берег Слоновой Кости)",
            "uk": "Кот-д'Івуар (Берег Слонової Кістки)",
            "pl": "Cote D'Ivoire (Wybrzeże Kości Słoniowej)"
        },
        "latitude": "8.00000000",
        "longitude": "-5.00000000",
        "emoji": "🇨🇮",
        "emojiU": "U+1F1E8 U+1F1EE",
        "states": [
            {
                "id": 2634,
                "name": "Abidjan",
                "iso2": "AB",
                "latitude": "5.35995170",
                "longitude": "-4.00825630",
                "type": "autonomous district",
                "cities": [
                    {
                        "id": 18860,
                        "name": "Abidjan",
                        "latitude": "5.30966000",
                        "longitude": "-4.01266000"
                    },
                    {
                        "id": 18861,
                        "name": "Abobo",
                        "latitude": "5.41613000",
                        "longitude": "-4.01590000"
                    },
                    {
                        "id": 18870,
                        "name": "Anyama",
                        "latitude": "5.49462000",
                        "longitude": "-4.05183000"
                    },
                    {
                        "id": 18876,
                        "name": "Bingerville",
                        "latitude": "5.35581000",
                        "longitude": "-3.88537000"
                    }
                ]
            },
            {
                "id": 2626,
                "name": "Agnéby",
                "iso2": "16",
                "latitude": "5.32245030",
                "longitude": "-4.34495290",
                "type": "region",
                "cities": []
            },
            {
                "id": 2636,
                "name": "Bafing",
                "iso2": "17",
                "latitude": "8.32520470",
                "longitude": "-7.52472430",
                "type": "region",
                "cities": []
            },
            {
                "id": 2643,
                "name": "Bas-Sassandra",
                "iso2": "BS",
                "latitude": "5.27983560",
                "longitude": "-6.15269850",
                "type": "district",
                "cities": [
                    {
                        "id": 18901,
                        "name": "Gbôklé",
                        "latitude": "4.95712000",
                        "longitude": "-6.09372000"
                    },
                    {
                        "id": 18924,
                        "name": "Nawa",
                        "latitude": "5.80112000",
                        "longitude": "-6.60313000"
                    },
                    {
                        "id": 18928,
                        "name": "San-Pédro",
                        "latitude": "4.76768000",
                        "longitude": "-6.65033000"
                    },
                    {
                        "id": 18929,
                        "name": "Sassandra",
                        "latitude": "4.95384000",
                        "longitude": "-6.08531000"
                    },
                    {
                        "id": 18933,
                        "name": "Tabou",
                        "latitude": "4.42295000",
                        "longitude": "-7.35280000"
                    }
                ]
            },
            {
                "id": 2654,
                "name": "Comoé",
                "iso2": "CM",
                "latitude": "6.22190790",
                "longitude": "-4.60727990",
                "type": "district",
                "cities": [
                    {
                        "id": 18859,
                        "name": "Abengourou",
                        "latitude": "6.72972000",
                        "longitude": "-3.49639000"
                    },
                    {
                        "id": 18862,
                        "name": "Aboisso",
                        "latitude": "5.46779000",
                        "longitude": "-3.20711000"
                    },
                    {
                        "id": 18863,
                        "name": "Adiaké",
                        "latitude": "5.28634000",
                        "longitude": "-3.30403000"
                    },
                    {
                        "id": 18867,
                        "name": "Agnibilékrou",
                        "latitude": "7.13113000",
                        "longitude": "-3.20415000"
                    },
                    {
                        "id": 18872,
                        "name": "Ayamé",
                        "latitude": "5.60520000",
                        "longitude": "-3.15709000"
                    },
                    {
                        "id": 18880,
                        "name": "Bonoua",
                        "latitude": "5.27247000",
                        "longitude": "-3.59625000"
                    },
                    {
                        "id": 18903,
                        "name": "Grand-Bassam",
                        "latitude": "5.21180000",
                        "longitude": "-3.73884000"
                    },
                    {
                        "id": 18913,
                        "name": "Indénié-Djuablin",
                        "latitude": "6.74434000",
                        "longitude": "-3.49400000"
                    },
                    {
                        "id": 18931,
                        "name": "Sud-Comoé",
                        "latitude": "5.49961000",
                        "longitude": "-3.24080000"
                    }
                ]
            },
            {
                "id": 2644,
                "name": "Denguélé",
                "iso2": "DN",
                "latitude": "48.07077630",
                "longitude": "-68.56093410",
                "type": "district",
                "cities": [
                    {
                        "id": 18898,
                        "name": "Folon",
                        "latitude": "9.81241000",
                        "longitude": "-7.51894000"
                    },
                    {
                        "id": 18915,
                        "name": "Kabadougou",
                        "latitude": "9.60571000",
                        "longitude": "-7.43774000"
                    },
                    {
                        "id": 18925,
                        "name": "Odienné",
                        "latitude": "9.50511000",
                        "longitude": "-7.56433000"
                    }
                ]
            },
            {
                "id": 2645,
                "name": "Dix-Huit Montagnes",
                "iso2": "06",
                "latitude": "7.37623730",
                "longitude": "-7.43813550",
                "type": "region",
                "cities": [
                    {
                        "id": 18874,
                        "name": "Bangolo",
                        "latitude": "7.01232000",
                        "longitude": "-7.48639000"
                    },
                    {
                        "id": 18875,
                        "name": "Biankouma",
                        "latitude": "7.73909000",
                        "longitude": "-7.61377000"
                    },
                    {
                        "id": 18889,
                        "name": "Cavally",
                        "latitude": "6.56343000",
                        "longitude": "-7.92526000"
                    },
                    {
                        "id": 18893,
                        "name": "Danané",
                        "latitude": "7.25957000",
                        "longitude": "-8.15498000"
                    },
                    {
                        "id": 18897,
                        "name": "Duekoué",
                        "latitude": "6.74202000",
                        "longitude": "-7.34918000"
                    },
                    {
                        "id": 18908,
                        "name": "Guémon",
                        "latitude": "7.09300000",
                        "longitude": "-7.17785000"
                    },
                    {
                        "id": 18907,
                        "name": "Guiglo",
                        "latitude": "6.54368000",
                        "longitude": "-7.49350000"
                    },
                    {
                        "id": 18919,
                        "name": "Man",
                        "latitude": "7.41251000",
                        "longitude": "-7.55383000"
                    },
                    {
                        "id": 18936,
                        "name": "Tonkpi",
                        "latitude": "7.56785000",
                        "longitude": "-7.60941000"
                    },
                    {
                        "id": 18938,
                        "name": "Toulépleu Gueré",
                        "latitude": "6.57395000",
                        "longitude": "-8.42592000"
                    }
                ]
            },
            {
                "id": 2633,
                "name": "Fromager",
                "iso2": "18",
                "latitude": "45.54502130",
                "longitude": "-73.60462230",
                "type": "region",
                "cities": []
            },
            {
                "id": 2651,
                "name": "Gôh-Djiboua",
                "iso2": "GD",
                "latitude": "5.87113930",
                "longitude": "-5.56172790",
                "type": "district",
                "cities": [
                    {
                        "id": 18896,
                        "name": "Divo",
                        "latitude": "5.83739000",
                        "longitude": "-5.35723000"
                    },
                    {
                        "id": 18899,
                        "name": "Gagnoa",
                        "latitude": "6.13193000",
                        "longitude": "-5.95060000"
                    },
                    {
                        "id": 18909,
                        "name": "Gôh",
                        "latitude": "6.14459000",
                        "longitude": "-5.92644000"
                    },
                    {
                        "id": 18906,
                        "name": "Guibéroua",
                        "latitude": "6.23869000",
                        "longitude": "-6.17147000"
                    },
                    {
                        "id": 18917,
                        "name": "Lakota",
                        "latitude": "5.84752000",
                        "longitude": "-5.68200000"
                    },
                    {
                        "id": 18918,
                        "name": "Lôh-Djiboua",
                        "latitude": "5.82483000",
                        "longitude": "-5.47668000"
                    },
                    {
                        "id": 18926,
                        "name": "Oumé",
                        "latitude": "6.38309000",
                        "longitude": "-5.41759000"
                    }
                ]
            },
            {
                "id": 2638,
                "name": "Haut-Sassandra",
                "iso2": "02",
                "latitude": "6.87578480",
                "longitude": "-6.57833870",
                "type": "region",
                "cities": []
            },
            {
                "id": 2632,
                "name": "Lacs",
                "iso2": "LC",
                "latitude": "48.19801690",
                "longitude": "-80.45644120",
                "type": "district",
                "cities": [
                    {
                        "id": 18871,
                        "name": "Arrah",
                        "latitude": "6.67342000",
                        "longitude": "-3.96938000"
                    },
                    {
                        "id": 18886,
                        "name": "Bélier",
                        "latitude": "7.02582000",
                        "longitude": "-5.06744000"
                    },
                    {
                        "id": 18877,
                        "name": "Bocanda",
                        "latitude": "7.06264000",
                        "longitude": "-4.49948000"
                    },
                    {
                        "id": 18879,
                        "name": "Bongouanou",
                        "latitude": "6.65175000",
                        "longitude": "-4.20406000"
                    },
                    {
                        "id": 18894,
                        "name": "Daoukro",
                        "latitude": "7.05910000",
                        "longitude": "-3.96310000"
                    },
                    {
                        "id": 18895,
                        "name": "Dimbokro",
                        "latitude": "6.64678000",
                        "longitude": "-4.70519000"
                    },
                    {
                        "id": 18912,
                        "name": "Iffou",
                        "latitude": "7.11509000",
                        "longitude": "-3.95027000"
                    },
                    {
                        "id": 18922,
                        "name": "Moronou",
                        "latitude": "6.66830000",
                        "longitude": "-4.13155000"
                    },
                    {
                        "id": 18923,
                        "name": "N'Zi",
                        "latitude": "6.82803000",
                        "longitude": "-4.58130000"
                    },
                    {
                        "id": 18939,
                        "name": "Toumodi",
                        "latitude": "6.55799000",
                        "longitude": "-5.01769000"
                    },
                    {
                        "id": 18942,
                        "name": "Yamoussoukro",
                        "latitude": "6.82055000",
                        "longitude": "-5.27674000"
                    }
                ]
            },
            {
                "id": 2627,
                "name": "Lagunes",
                "iso2": "LG",
                "latitude": "5.88273340",
                "longitude": "-4.23333550",
                "type": "district",
                "cities": [
                    {
                        "id": 18864,
                        "name": "Adzopé",
                        "latitude": "6.10694000",
                        "longitude": "-3.86194000"
                    },
                    {
                        "id": 18865,
                        "name": "Affery",
                        "latitude": "6.32035000",
                        "longitude": "-3.95235000"
                    },
                    {
                        "id": 18866,
                        "name": "Agboville",
                        "latitude": "5.92801000",
                        "longitude": "-4.21319000"
                    },
                    {
                        "id": 18868,
                        "name": "Agnéby-Tiassa",
                        "latitude": "5.79488000",
                        "longitude": "-4.37187000"
                    },
                    {
                        "id": 18869,
                        "name": "Akoupé",
                        "latitude": "6.38423000",
                        "longitude": "-3.88759000"
                    },
                    {
                        "id": 18891,
                        "name": "Dabou",
                        "latitude": "5.32556000",
                        "longitude": "-4.37685000"
                    },
                    {
                        "id": 18904,
                        "name": "Grand-Lahou",
                        "latitude": "5.25068000",
                        "longitude": "-5.00333000"
                    },
                    {
                        "id": 18905,
                        "name": "Grands-Ponts",
                        "latitude": "5.30487000",
                        "longitude": "-4.39247000"
                    },
                    {
                        "id": 18935,
                        "name": "Tiassalé",
                        "latitude": "5.89839000",
                        "longitude": "-4.82293000"
                    }
                ]
            },
            {
                "id": 2631,
                "name": "Marahoué",
                "iso2": "12",
                "latitude": "6.88462070",
                "longitude": "-5.89871390",
                "type": "region",
                "cities": []
            },
            {
                "id": 2629,
                "name": "Montagnes",
                "iso2": "MG",
                "latitude": "6.88716640",
                "longitude": "-9.10706440",
                "type": "district",
                "cities": []
            },
            {
                "id": 2646,
                "name": "Moyen-Cavally",
                "iso2": "19",
                "latitude": "6.52087930",
                "longitude": "-7.61142170",
                "type": "region",
                "cities": []
            },
            {
                "id": 2630,
                "name": "Moyen-Comoé",
                "iso2": "05",
                "latitude": "6.65149170",
                "longitude": "-3.50034540",
                "type": "region",
                "cities": []
            },
            {
                "id": 2655,
                "name": "N'zi-Comoé",
                "iso2": "11",
                "latitude": "7.24567490",
                "longitude": "-4.23333550",
                "type": "region",
                "cities": []
            },
            {
                "id": 2648,
                "name": "Sassandra-Marahoué",
                "iso2": "SM",
                "latitude": "6.88033480",
                "longitude": "-6.23759470",
                "type": "district",
                "cities": [
                    {
                        "id": 18882,
                        "name": "Bouaflé",
                        "latitude": "6.99041000",
                        "longitude": "-5.74420000"
                    },
                    {
                        "id": 18892,
                        "name": "Daloa",
                        "latitude": "6.87735000",
                        "longitude": "-6.45022000"
                    },
                    {
                        "id": 18911,
                        "name": "Haut-Sassandra",
                        "latitude": "6.66961000",
                        "longitude": "-6.50116000"
                    },
                    {
                        "id": 18914,
                        "name": "Issia",
                        "latitude": "6.49224000",
                        "longitude": "-6.58558000"
                    },
                    {
                        "id": 18921,
                        "name": "Marahoué",
                        "latitude": "7.03252000",
                        "longitude": "-5.80215000"
                    },
                    {
                        "id": 18940,
                        "name": "Vavoua",
                        "latitude": "7.38194000",
                        "longitude": "-6.47778000"
                    },
                    {
                        "id": 18943,
                        "name": "Zuénoula",
                        "latitude": "7.43027000",
                        "longitude": "-6.05054000"
                    }
                ]
            },
            {
                "id": 2625,
                "name": "Savanes",
                "iso2": "03",
                "latitude": "9.63735270",
                "longitude": "-6.70071860",
                "type": "region",
                "cities": []
            },
            {
                "id": 2628,
                "name": "Sud-Bandama",
                "iso2": "15",
                "latitude": "5.53570830",
                "longitude": "-5.56172790",
                "type": "region",
                "cities": []
            },
            {
                "id": 2652,
                "name": "Sud-Comoé",
                "iso2": "13",
                "latitude": "5.66697040",
                "longitude": "-3.94723050",
                "type": "region",
                "cities": []
            },
            {
                "id": 2637,
                "name": "Vallée du Bandama",
                "iso2": "VB",
                "latitude": "8.27897800",
                "longitude": "-4.89356270",
                "type": "district",
                "cities": [
                    {
                        "id": 18887,
                        "name": "Béoumi",
                        "latitude": "7.67395000",
                        "longitude": "-5.58085000"
                    },
                    {
                        "id": 18881,
                        "name": "Botro",
                        "latitude": "7.85249000",
                        "longitude": "-5.31063000"
                    },
                    {
                        "id": 18883,
                        "name": "Bouaké",
                        "latitude": "7.69385000",
                        "longitude": "-5.03031000"
                    },
                    {
                        "id": 18890,
                        "name": "Dabakala",
                        "latitude": "8.36321000",
                        "longitude": "-4.42863000"
                    },
                    {
                        "id": 18900,
                        "name": "Gbêkê",
                        "latitude": "7.70271000",
                        "longitude": "-5.28511000"
                    },
                    {
                        "id": 18910,
                        "name": "Hambol",
                        "latitude": "8.30368000",
                        "longitude": "-5.15396000"
                    },
                    {
                        "id": 18916,
                        "name": "Katiola",
                        "latitude": "8.13728000",
                        "longitude": "-5.10095000"
                    },
                    {
                        "id": 18927,
                        "name": "Sakassou",
                        "latitude": "7.45462000",
                        "longitude": "-5.29263000"
                    }
                ]
            },
            {
                "id": 2650,
                "name": "Woroba",
                "iso2": "WR",
                "latitude": "8.24913720",
                "longitude": "-6.92091350",
                "type": "district",
                "cities": [
                    {
                        "id": 18873,
                        "name": "Bafing",
                        "latitude": "8.40611000",
                        "longitude": "-7.58048000"
                    },
                    {
                        "id": 18888,
                        "name": "Béré",
                        "latitude": "8.18952000",
                        "longitude": "-6.17157000"
                    },
                    {
                        "id": 18920,
                        "name": "Mankono",
                        "latitude": "8.05861000",
                        "longitude": "-6.18972000"
                    },
                    {
                        "id": 18932,
                        "name": "Séguéla",
                        "latitude": "7.96111000",
                        "longitude": "-6.67306000"
                    },
                    {
                        "id": 18937,
                        "name": "Touba",
                        "latitude": "8.28333000",
                        "longitude": "-7.68333000"
                    },
                    {
                        "id": 18941,
                        "name": "Worodougou",
                        "latitude": "8.16482000",
                        "longitude": "-6.66595000"
                    }
                ]
            },
            {
                "id": 2649,
                "name": "Worodougou",
                "iso2": "14",
                "latitude": "8.25489620",
                "longitude": "-6.57833870",
                "type": "region",
                "cities": []
            },
            {
                "id": 2653,
                "name": "Yamoussoukro",
                "iso2": "YM",
                "latitude": "6.82762280",
                "longitude": "-5.28934330",
                "type": "autonomous district",
                "cities": []
            },
            {
                "id": 2641,
                "name": "Zanzan",
                "iso2": "ZZ",
                "latitude": "8.82079040",
                "longitude": "-3.41955270",
                "type": "district",
                "cities": [
                    {
                        "id": 18878,
                        "name": "Bondoukou",
                        "latitude": "8.04020000",
                        "longitude": "-2.80003000"
                    },
                    {
                        "id": 18884,
                        "name": "Bouna",
                        "latitude": "9.26927000",
                        "longitude": "-2.99510000"
                    },
                    {
                        "id": 18885,
                        "name": "Bounkani",
                        "latitude": "9.47841000",
                        "longitude": "-3.31238000"
                    },
                    {
                        "id": 18902,
                        "name": "Gontougo",
                        "latitude": "7.87132000",
                        "longitude": "-3.07068000"
                    },
                    {
                        "id": 18930,
                        "name": "Sinfra",
                        "latitude": "6.62103000",
                        "longitude": "-5.91144000"
                    },
                    {
                        "id": 18934,
                        "name": "Tanda",
                        "latitude": "7.80335000",
                        "longitude": "-3.16832000"
                    }
                ]
            }
        ]
    },
    {
        "id": 55,
        "name": "Croatia",
        "iso3": "HRV",
        "iso2": "HR",
        "numeric_code": "191",
        "phonecode": "385",
        "capital": "Zagreb",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".hr",
        "native": "Hrvatska",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Croatian",
        "timezones": [
            {
                "zoneName": "Europe\/Zagreb",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Kroatia",
            "ko": "크로아티아",
            "pt-BR": "Croácia",
            "pt": "Croácia",
            "nl": "Kroatië",
            "hr": "Hrvatska",
            "fa": "کرواسی",
            "de": "Kroatien",
            "es": "Croacia",
            "fr": "Croatie",
            "ja": "クロアチア",
            "it": "Croazia",
            "zh-CN": "克罗地亚",
            "tr": "Hirvatistan",
            "ru": "Хорватия",
            "uk": "Хорватія",
            "pl": "Chorwacja"
        },
        "latitude": "45.16666666",
        "longitude": "15.50000000",
        "emoji": "🇭🇷",
        "emojiU": "U+1F1ED U+1F1F7",
        "states": [
            {
                "id": 734,
                "name": "Bjelovar-Bilogora",
                "iso2": "07",
                "latitude": "45.89879720",
                "longitude": "16.84230930",
                "type": "county",
                "cities": [
                    {
                        "id": 54404,
                        "name": "Bjelovar",
                        "latitude": "45.89861000",
                        "longitude": "16.84889000"
                    },
                    {
                        "id": 54418,
                        "name": "Brezovac",
                        "latitude": "45.86750000",
                        "longitude": "16.84083000"
                    },
                    {
                        "id": 55017,
                        "name": "Čazma",
                        "latitude": "45.74818000",
                        "longitude": "16.61390000"
                    },
                    {
                        "id": 54449,
                        "name": "Daruvar",
                        "latitude": "45.59056000",
                        "longitude": "17.22500000"
                    },
                    {
                        "id": 54453,
                        "name": "Dežanovac",
                        "latitude": "45.57056000",
                        "longitude": "17.08667000"
                    },
                    {
                        "id": 55025,
                        "name": "Đulovac",
                        "latitude": "45.66588000",
                        "longitude": "17.42981000"
                    },
                    {
                        "id": 54489,
                        "name": "Garešnica",
                        "latitude": "45.57444000",
                        "longitude": "16.94139000"
                    },
                    {
                        "id": 54505,
                        "name": "Grad Bjelovar",
                        "latitude": "45.90172000",
                        "longitude": "16.84522000"
                    },
                    {
                        "id": 54571,
                        "name": "Grad Čazma",
                        "latitude": "45.75000000",
                        "longitude": "16.61667000"
                    },
                    {
                        "id": 54508,
                        "name": "Grad Daruvar",
                        "latitude": "45.60000000",
                        "longitude": "17.23333000"
                    },
                    {
                        "id": 54515,
                        "name": "Grad Garešnica",
                        "latitude": "45.56667000",
                        "longitude": "16.93333000"
                    },
                    {
                        "id": 54517,
                        "name": "Grad Grubišno Polje",
                        "latitude": "45.70000000",
                        "longitude": "17.16667000"
                    },
                    {
                        "id": 54588,
                        "name": "Grubišno Polje",
                        "latitude": "45.70214000",
                        "longitude": "17.17268000"
                    },
                    {
                        "id": 54589,
                        "name": "Gudovac",
                        "latitude": "45.88028000",
                        "longitude": "16.78083000"
                    },
                    {
                        "id": 54593,
                        "name": "Hercegovac",
                        "latitude": "45.65861000",
                        "longitude": "17.01361000"
                    },
                    {
                        "id": 54607,
                        "name": "Ivanska",
                        "latitude": "45.77889000",
                        "longitude": "16.81194000"
                    },
                    {
                        "id": 54630,
                        "name": "Kapela",
                        "latitude": "45.98543000",
                        "longitude": "16.85174000"
                    },
                    {
                        "id": 54658,
                        "name": "Končanica",
                        "latitude": "45.63611000",
                        "longitude": "17.16639000"
                    },
                    {
                        "id": 54831,
                        "name": "Predavac",
                        "latitude": "45.93583000",
                        "longitude": "16.78333000"
                    },
                    {
                        "id": 54869,
                        "name": "Rovišće",
                        "latitude": "45.94472000",
                        "longitude": "16.73500000"
                    },
                    {
                        "id": 55028,
                        "name": "Šandrovac",
                        "latitude": "45.90556000",
                        "longitude": "17.02111000"
                    },
                    {
                        "id": 54886,
                        "name": "Severin",
                        "latitude": "45.84152000",
                        "longitude": "16.96950000"
                    },
                    {
                        "id": 54891,
                        "name": "Sirač",
                        "latitude": "45.52333000",
                        "longitude": "17.25500000"
                    },
                    {
                        "id": 54960,
                        "name": "Velika Pisanica",
                        "latitude": "45.80160000",
                        "longitude": "17.06551000"
                    },
                    {
                        "id": 54962,
                        "name": "Veliki Grđevac",
                        "latitude": "45.75028000",
                        "longitude": "17.04750000"
                    },
                    {
                        "id": 55038,
                        "name": "Ždralovi",
                        "latitude": "45.87639000",
                        "longitude": "16.87500000"
                    },
                    {
                        "id": 55013,
                        "name": "Zrinski Topolovac",
                        "latitude": "46.02120000",
                        "longitude": "16.75509000"
                    }
                ]
            },
            {
                "id": 737,
                "name": "Brod-Posavina",
                "iso2": "12",
                "latitude": "45.26379510",
                "longitude": "17.32645620",
                "type": "county",
                "cities": [
                    {
                        "id": 54387,
                        "name": "Batrina",
                        "latitude": "45.18944000",
                        "longitude": "17.66639000"
                    },
                    {
                        "id": 54425,
                        "name": "Brodski Varoš",
                        "latitude": "45.18111000",
                        "longitude": "17.97861000"
                    },
                    {
                        "id": 54434,
                        "name": "Bukovlje",
                        "latitude": "45.18528000",
                        "longitude": "18.07000000"
                    },
                    {
                        "id": 54441,
                        "name": "Cernik",
                        "latitude": "45.28861000",
                        "longitude": "17.38194000"
                    },
                    {
                        "id": 54450,
                        "name": "Davor",
                        "latitude": "45.11528000",
                        "longitude": "17.51639000"
                    },
                    {
                        "id": 54460,
                        "name": "Donji Andrijevci",
                        "latitude": "45.18833000",
                        "longitude": "18.29972000"
                    },
                    {
                        "id": 54490,
                        "name": "Garčin",
                        "latitude": "45.18278000",
                        "longitude": "18.18306000"
                    },
                    {
                        "id": 54498,
                        "name": "Gornji Bogićevci",
                        "latitude": "45.25572000",
                        "longitude": "17.23454000"
                    },
                    {
                        "id": 54534,
                        "name": "Grad Nova Gradiška",
                        "latitude": "45.26667000",
                        "longitude": "17.40000000"
                    },
                    {
                        "id": 54551,
                        "name": "Grad Slavonski Brod",
                        "latitude": "45.16267000",
                        "longitude": "18.03062000"
                    },
                    {
                        "id": 54590,
                        "name": "Gundinci",
                        "latitude": "45.15833000",
                        "longitude": "18.49139000"
                    },
                    {
                        "id": 54661,
                        "name": "Korenica",
                        "latitude": "45.22472000",
                        "longitude": "18.16556000"
                    },
                    {
                        "id": 54672,
                        "name": "Kruševica",
                        "latitude": "45.07750000",
                        "longitude": "18.48278000"
                    },
                    {
                        "id": 54708,
                        "name": "Lužani",
                        "latitude": "45.16806000",
                        "longitude": "17.70694000"
                    },
                    {
                        "id": 54757,
                        "name": "Nova Gradiška",
                        "latitude": "45.25500000",
                        "longitude": "17.38306000"
                    },
                    {
                        "id": 54774,
                        "name": "Okučani",
                        "latitude": "45.26034000",
                        "longitude": "17.19925000"
                    },
                    {
                        "id": 54778,
                        "name": "Oprisavci",
                        "latitude": "45.15111000",
                        "longitude": "18.22972000"
                    },
                    {
                        "id": 54790,
                        "name": "Oriovac",
                        "latitude": "45.16611000",
                        "longitude": "17.76000000"
                    },
                    {
                        "id": 54819,
                        "name": "Podvinje",
                        "latitude": "45.19028000",
                        "longitude": "18.02694000"
                    },
                    {
                        "id": 54862,
                        "name": "Rešetari",
                        "latitude": "45.26232000",
                        "longitude": "17.42346000"
                    },
                    {
                        "id": 54874,
                        "name": "Ruščica",
                        "latitude": "45.14667000",
                        "longitude": "18.07944000"
                    },
                    {
                        "id": 54887,
                        "name": "Sibinj",
                        "latitude": "45.19167000",
                        "longitude": "17.90806000"
                    },
                    {
                        "id": 54889,
                        "name": "Sikirevci",
                        "latitude": "45.10889000",
                        "longitude": "18.46444000"
                    },
                    {
                        "id": 54897,
                        "name": "Slavonski Brod",
                        "latitude": "45.16028000",
                        "longitude": "18.01556000"
                    },
                    {
                        "id": 54899,
                        "name": "Slobodnica",
                        "latitude": "45.16222000",
                        "longitude": "17.93278000"
                    },
                    {
                        "id": 54910,
                        "name": "Stari Perkovci",
                        "latitude": "45.21750000",
                        "longitude": "18.34861000"
                    },
                    {
                        "id": 54957,
                        "name": "Velika Kopanica",
                        "latitude": "45.15611000",
                        "longitude": "18.39306000"
                    },
                    {
                        "id": 54995,
                        "name": "Vrpolje",
                        "latitude": "45.21056000",
                        "longitude": "18.40556000"
                    }
                ]
            },
            {
                "id": 728,
                "name": "Dubrovnik-Neretva",
                "iso2": "19",
                "latitude": "43.07665880",
                "longitude": "17.52684710",
                "type": "county",
                "cities": [
                    {
                        "id": 54437,
                        "name": "Cavtat",
                        "latitude": "42.58111000",
                        "longitude": "18.21806000"
                    },
                    {
                        "id": 55022,
                        "name": "Čibača",
                        "latitude": "42.62889000",
                        "longitude": "18.17111000"
                    },
                    {
                        "id": 54471,
                        "name": "Dubrovačko primorje",
                        "latitude": "42.78988000",
                        "longitude": "17.86240000"
                    },
                    {
                        "id": 54513,
                        "name": "Grad Dubrovnik",
                        "latitude": "42.64861000",
                        "longitude": "18.09397000"
                    },
                    {
                        "id": 54525,
                        "name": "Grad Korčula",
                        "latitude": "42.95693000",
                        "longitude": "17.13181000"
                    },
                    {
                        "id": 54544,
                        "name": "Grad Ploče",
                        "latitude": "43.06667000",
                        "longitude": "17.43333000"
                    },
                    {
                        "id": 54653,
                        "name": "Komin",
                        "latitude": "43.04083000",
                        "longitude": "17.53694000"
                    },
                    {
                        "id": 54656,
                        "name": "Konavle",
                        "latitude": "42.54010000",
                        "longitude": "18.33944000"
                    },
                    {
                        "id": 54662,
                        "name": "Korčula",
                        "latitude": "42.96038000",
                        "longitude": "17.13525000"
                    },
                    {
                        "id": 54684,
                        "name": "Lastovo",
                        "latitude": "42.76757000",
                        "longitude": "16.89708000"
                    },
                    {
                        "id": 54704,
                        "name": "Lumbarda",
                        "latitude": "42.92278000",
                        "longitude": "17.16722000"
                    },
                    {
                        "id": 54728,
                        "name": "Metković",
                        "latitude": "43.05417000",
                        "longitude": "17.64833000"
                    },
                    {
                        "id": 54736,
                        "name": "Mljet",
                        "latitude": "42.74439000",
                        "longitude": "17.53645000"
                    },
                    {
                        "id": 54737,
                        "name": "Mokošica",
                        "latitude": "42.67556000",
                        "longitude": "18.09028000"
                    },
                    {
                        "id": 54785,
                        "name": "Općina Lastovo",
                        "latitude": "42.75000000",
                        "longitude": "16.90000000"
                    },
                    {
                        "id": 54780,
                        "name": "Opuzen",
                        "latitude": "43.01528000",
                        "longitude": "17.56556000"
                    },
                    {
                        "id": 54787,
                        "name": "Orebić",
                        "latitude": "42.98556000",
                        "longitude": "17.17472000"
                    },
                    {
                        "id": 54813,
                        "name": "Podgora",
                        "latitude": "42.84861000",
                        "longitude": "17.83639000"
                    },
                    {
                        "id": 54821,
                        "name": "Pojezerje",
                        "latitude": "43.15741000",
                        "longitude": "17.45152000"
                    },
                    {
                        "id": 54898,
                        "name": "Slivno",
                        "latitude": "42.95864000",
                        "longitude": "17.54431000"
                    },
                    {
                        "id": 54900,
                        "name": "Smokvica",
                        "latitude": "42.93056000",
                        "longitude": "16.89639000"
                    },
                    {
                        "id": 54914,
                        "name": "Ston",
                        "latitude": "42.83861000",
                        "longitude": "17.69639000"
                    },
                    {
                        "id": 54954,
                        "name": "Vela Luka",
                        "latitude": "42.96333000",
                        "longitude": "16.72250000"
                    },
                    {
                        "id": 55007,
                        "name": "Zažablje",
                        "latitude": "43.01113000",
                        "longitude": "17.65683000"
                    },
                    {
                        "id": 55041,
                        "name": "Žrnovo",
                        "latitude": "42.95111000",
                        "longitude": "17.11417000"
                    },
                    {
                        "id": 55042,
                        "name": "Župa dubrovačka",
                        "latitude": "42.62683000",
                        "longitude": "18.19475000"
                    }
                ]
            },
            {
                "id": 743,
                "name": "Istria",
                "iso2": "18",
                "latitude": "45.12864550",
                "longitude": "13.90154200",
                "type": "county",
                "cities": [
                    {
                        "id": 54384,
                        "name": "Bale",
                        "latitude": "45.04056000",
                        "longitude": "13.78361000"
                    },
                    {
                        "id": 54385,
                        "name": "Bale-Valle",
                        "latitude": "45.04089000",
                        "longitude": "13.78565000"
                    },
                    {
                        "id": 54426,
                        "name": "Brtonigla",
                        "latitude": "45.38139000",
                        "longitude": "13.62944000"
                    },
                    {
                        "id": 54427,
                        "name": "Brtonigla-Verteneglio",
                        "latitude": "45.37918000",
                        "longitude": "13.62554000"
                    },
                    {
                        "id": 54432,
                        "name": "Buje",
                        "latitude": "45.41000000",
                        "longitude": "13.66194000"
                    },
                    {
                        "id": 54433,
                        "name": "Buje-Buie",
                        "latitude": "45.40790000",
                        "longitude": "13.65914000"
                    },
                    {
                        "id": 54436,
                        "name": "Buzet",
                        "latitude": "45.40944000",
                        "longitude": "13.96667000"
                    },
                    {
                        "id": 54479,
                        "name": "Fažana",
                        "latitude": "44.92750000",
                        "longitude": "13.80361000"
                    },
                    {
                        "id": 54480,
                        "name": "Fažana-Fasana",
                        "latitude": "44.92822000",
                        "longitude": "13.80548000"
                    },
                    {
                        "id": 54483,
                        "name": "Funtana",
                        "latitude": "45.17472000",
                        "longitude": "13.60500000"
                    },
                    {
                        "id": 54484,
                        "name": "Funtana-Fontane",
                        "latitude": "45.17483000",
                        "longitude": "13.60627000"
                    },
                    {
                        "id": 54487,
                        "name": "Galižana",
                        "latitude": "44.93167000",
                        "longitude": "13.86861000"
                    },
                    {
                        "id": 54506,
                        "name": "Grad Buzet",
                        "latitude": "45.41667000",
                        "longitude": "13.96667000"
                    },
                    {
                        "id": 54530,
                        "name": "Grad Labin",
                        "latitude": "45.08333000",
                        "longitude": "14.13333000"
                    },
                    {
                        "id": 54542,
                        "name": "Grad Pazin",
                        "latitude": "45.23333000",
                        "longitude": "13.93333000"
                    },
                    {
                        "id": 54585,
                        "name": "Grožnjan",
                        "latitude": "45.37889000",
                        "longitude": "13.72389000"
                    },
                    {
                        "id": 54586,
                        "name": "Grožnjan-Grisignana",
                        "latitude": "45.37728000",
                        "longitude": "13.72145000"
                    },
                    {
                        "id": 54629,
                        "name": "Kanfanar",
                        "latitude": "45.12194000",
                        "longitude": "13.83917000"
                    },
                    {
                        "id": 54634,
                        "name": "Karojba",
                        "latitude": "45.30083000",
                        "longitude": "13.82306000"
                    },
                    {
                        "id": 54644,
                        "name": "Kaštelir-Labinci",
                        "latitude": "45.30277000",
                        "longitude": "13.68841000"
                    },
                    {
                        "id": 54681,
                        "name": "Labin",
                        "latitude": "45.09500000",
                        "longitude": "14.11972000"
                    },
                    {
                        "id": 54691,
                        "name": "Ližnjan",
                        "latitude": "44.82833000",
                        "longitude": "13.95694000"
                    },
                    {
                        "id": 54692,
                        "name": "Ližnjan-Lisignano",
                        "latitude": "44.82765000",
                        "longitude": "13.96028000"
                    },
                    {
                        "id": 54706,
                        "name": "Lupoglav",
                        "latitude": "45.35204000",
                        "longitude": "14.10846000"
                    },
                    {
                        "id": 54722,
                        "name": "Marčana",
                        "latitude": "44.95528000",
                        "longitude": "13.95389000"
                    },
                    {
                        "id": 54727,
                        "name": "Medulin",
                        "latitude": "44.82250000",
                        "longitude": "13.93500000"
                    },
                    {
                        "id": 54739,
                        "name": "Motovun",
                        "latitude": "45.33667000",
                        "longitude": "13.82861000"
                    },
                    {
                        "id": 54740,
                        "name": "Motovun-Montona",
                        "latitude": "45.33633000",
                        "longitude": "13.82977000"
                    },
                    {
                        "id": 54761,
                        "name": "Novigrad",
                        "latitude": "45.31500000",
                        "longitude": "13.55806000"
                    },
                    {
                        "id": 54763,
                        "name": "Novigrad-Cittanova",
                        "latitude": "45.31669000",
                        "longitude": "13.56155000"
                    },
                    {
                        "id": 54784,
                        "name": "Općina Lanišće",
                        "latitude": "45.43520000",
                        "longitude": "14.08196000"
                    },
                    {
                        "id": 54779,
                        "name": "Oprtalj-Portole",
                        "latitude": "45.38226000",
                        "longitude": "13.82406000"
                    },
                    {
                        "id": 54800,
                        "name": "Pazin",
                        "latitude": "45.24028000",
                        "longitude": "13.93667000"
                    },
                    {
                        "id": 54826,
                        "name": "Poreč",
                        "latitude": "45.22567000",
                        "longitude": "13.59511000"
                    },
                    {
                        "id": 54827,
                        "name": "Poreč-Parenzo",
                        "latitude": "45.22717000",
                        "longitude": "13.59653000"
                    },
                    {
                        "id": 54844,
                        "name": "Pula",
                        "latitude": "44.86833000",
                        "longitude": "13.84806000"
                    },
                    {
                        "id": 54845,
                        "name": "Pula-Pola",
                        "latitude": "44.86711000",
                        "longitude": "13.84882000"
                    },
                    {
                        "id": 54850,
                        "name": "Rabac",
                        "latitude": "45.07944000",
                        "longitude": "14.15750000"
                    },
                    {
                        "id": 54855,
                        "name": "Raša",
                        "latitude": "45.08028000",
                        "longitude": "14.07889000"
                    },
                    {
                        "id": 54867,
                        "name": "Rovinj",
                        "latitude": "45.08000000",
                        "longitude": "13.64000000"
                    },
                    {
                        "id": 54868,
                        "name": "Rovinj-Rovigno",
                        "latitude": "45.08190000",
                        "longitude": "13.63970000"
                    },
                    {
                        "id": 54925,
                        "name": "Sveta Nedelja",
                        "latitude": "45.14932000",
                        "longitude": "14.09889000"
                    },
                    {
                        "id": 54931,
                        "name": "Sveti Lovreč",
                        "latitude": "45.17770000",
                        "longitude": "13.74317000"
                    },
                    {
                        "id": 54933,
                        "name": "Tar",
                        "latitude": "45.30083000",
                        "longitude": "13.62528000"
                    },
                    {
                        "id": 54934,
                        "name": "Tar-Vabriga-Torre Abrega",
                        "latitude": "45.29946000",
                        "longitude": "13.62489000"
                    },
                    {
                        "id": 54949,
                        "name": "Umag",
                        "latitude": "45.43139000",
                        "longitude": "13.52389000"
                    },
                    {
                        "id": 54950,
                        "name": "Umag-Umago",
                        "latitude": "45.43462000",
                        "longitude": "13.52589000"
                    },
                    {
                        "id": 54951,
                        "name": "Valbandon",
                        "latitude": "44.91879000",
                        "longitude": "13.81344000"
                    },
                    {
                        "id": 54967,
                        "name": "Vinež",
                        "latitude": "45.09806000",
                        "longitude": "14.10694000"
                    },
                    {
                        "id": 54977,
                        "name": "Višnjan-Visignano",
                        "latitude": "45.27614000",
                        "longitude": "13.72128000"
                    },
                    {
                        "id": 54979,
                        "name": "Vižinada-Visinada",
                        "latitude": "45.33126000",
                        "longitude": "13.75943000"
                    },
                    {
                        "id": 54982,
                        "name": "Vodnjan",
                        "latitude": "44.95944000",
                        "longitude": "13.85167000"
                    },
                    {
                        "id": 54983,
                        "name": "Vodnjan-Dignano",
                        "latitude": "44.96187000",
                        "longitude": "13.85041000"
                    },
                    {
                        "id": 54996,
                        "name": "Vrsar",
                        "latitude": "45.14917000",
                        "longitude": "13.60528000"
                    },
                    {
                        "id": 54997,
                        "name": "Vrsar-Orsera",
                        "latitude": "45.15074000",
                        "longitude": "13.60558000"
                    },
                    {
                        "id": 55039,
                        "name": "Žminj",
                        "latitude": "45.14278000",
                        "longitude": "13.90889000"
                    }
                ]
            },
            {
                "id": 5069,
                "name": "Karlovac",
                "iso2": "04",
                "latitude": "45.26133520",
                "longitude": "15.52542016",
                "type": "county",
                "cities": []
            },
            {
                "id": 742,
                "name": "Koprivnica-Križevci",
                "iso2": "06",
                "latitude": "46.15689190",
                "longitude": "16.83908260",
                "type": "county",
                "cities": [
                    {
                        "id": 54469,
                        "name": "Drnje",
                        "latitude": "46.20694000",
                        "longitude": "16.91694000"
                    },
                    {
                        "id": 55024,
                        "name": "Đelekovec",
                        "latitude": "46.24989000",
                        "longitude": "16.87011000"
                    },
                    {
                        "id": 55027,
                        "name": "Đurđevac",
                        "latitude": "46.03972000",
                        "longitude": "17.07168000"
                    },
                    {
                        "id": 54481,
                        "name": "Ferdinandovac",
                        "latitude": "46.05000000",
                        "longitude": "17.20000000"
                    },
                    {
                        "id": 54492,
                        "name": "Gola",
                        "latitude": "46.19583000",
                        "longitude": "17.05806000"
                    },
                    {
                        "id": 54496,
                        "name": "Gornja Rijeka",
                        "latitude": "46.10977000",
                        "longitude": "16.39079000"
                    },
                    {
                        "id": 54524,
                        "name": "Grad Koprivnica",
                        "latitude": "46.16667000",
                        "longitude": "16.83333000"
                    },
                    {
                        "id": 54527,
                        "name": "Grad Križevci",
                        "latitude": "46.03333000",
                        "longitude": "16.56667000"
                    },
                    {
                        "id": 54594,
                        "name": "Hlebine",
                        "latitude": "46.15694000",
                        "longitude": "16.96278000"
                    },
                    {
                        "id": 54626,
                        "name": "Kalinovac",
                        "latitude": "46.02944000",
                        "longitude": "17.11556000"
                    },
                    {
                        "id": 54659,
                        "name": "Koprivnica",
                        "latitude": "46.16278000",
                        "longitude": "16.82750000"
                    },
                    {
                        "id": 54660,
                        "name": "Koprivnički Ivanec",
                        "latitude": "46.19907000",
                        "longitude": "16.81629000"
                    },
                    {
                        "id": 54670,
                        "name": "Križevci",
                        "latitude": "46.02194000",
                        "longitude": "16.54250000"
                    },
                    {
                        "id": 54685,
                        "name": "Legrad",
                        "latitude": "46.29750000",
                        "longitude": "16.85667000"
                    },
                    {
                        "id": 54738,
                        "name": "Molve",
                        "latitude": "46.10917000",
                        "longitude": "17.03167000"
                    },
                    {
                        "id": 54765,
                        "name": "Novo Virje",
                        "latitude": "46.09834000",
                        "longitude": "17.15215000"
                    },
                    {
                        "id": 54803,
                        "name": "Peteranec",
                        "latitude": "46.19222000",
                        "longitude": "16.89167000"
                    },
                    {
                        "id": 54854,
                        "name": "Rasinja",
                        "latitude": "46.18389000",
                        "longitude": "16.70667000"
                    },
                    {
                        "id": 54857,
                        "name": "Reka",
                        "latitude": "46.13028000",
                        "longitude": "16.76694000"
                    },
                    {
                        "id": 54888,
                        "name": "Sigetec",
                        "latitude": "46.18833000",
                        "longitude": "16.93583000"
                    },
                    {
                        "id": 54972,
                        "name": "Virje",
                        "latitude": "46.06722000",
                        "longitude": "16.99000000"
                    }
                ]
            },
            {
                "id": 729,
                "name": "Krapina-Zagorje",
                "iso2": "02",
                "latitude": "46.10133930",
                "longitude": "15.88096930",
                "type": "county",
                "cities": [
                    {
                        "id": 54390,
                        "name": "Bedekovčina",
                        "latitude": "46.04111000",
                        "longitude": "15.99639000"
                    },
                    {
                        "id": 54430,
                        "name": "Budinščina",
                        "latitude": "46.12785000",
                        "longitude": "16.20415000"
                    },
                    {
                        "id": 55026,
                        "name": "Đurmanec",
                        "latitude": "46.19708000",
                        "longitude": "15.83786000"
                    },
                    {
                        "id": 54510,
                        "name": "Grad Donja Stubica",
                        "latitude": "45.97955000",
                        "longitude": "15.97069000"
                    },
                    {
                        "id": 54523,
                        "name": "Grad Klanjec",
                        "latitude": "46.04977000",
                        "longitude": "15.74615000"
                    },
                    {
                        "id": 54526,
                        "name": "Grad Krapina",
                        "latitude": "46.15968000",
                        "longitude": "15.87258000"
                    },
                    {
                        "id": 54566,
                        "name": "Grad Zabok",
                        "latitude": "46.02808000",
                        "longitude": "15.90855000"
                    },
                    {
                        "id": 54568,
                        "name": "Grad Zlatar",
                        "latitude": "46.09198000",
                        "longitude": "16.07695000"
                    },
                    {
                        "id": 54622,
                        "name": "Jesenje",
                        "latitude": "46.20724000",
                        "longitude": "15.88194000"
                    },
                    {
                        "id": 54648,
                        "name": "Klanjec",
                        "latitude": "46.04982000",
                        "longitude": "15.74418000"
                    },
                    {
                        "id": 54657,
                        "name": "Konjščina",
                        "latitude": "46.05435000",
                        "longitude": "16.17763000"
                    },
                    {
                        "id": 54667,
                        "name": "Krapina",
                        "latitude": "46.16083000",
                        "longitude": "15.87889000"
                    },
                    {
                        "id": 54674,
                        "name": "Kumrovec",
                        "latitude": "46.07750000",
                        "longitude": "15.67556000"
                    },
                    {
                        "id": 54725,
                        "name": "Mače",
                        "latitude": "46.09472000",
                        "longitude": "16.03528000"
                    },
                    {
                        "id": 54714,
                        "name": "Marija Bistrica",
                        "latitude": "46.00611000",
                        "longitude": "16.11111000"
                    },
                    {
                        "id": 54731,
                        "name": "Mihovljan",
                        "latitude": "46.13306000",
                        "longitude": "15.97222000"
                    },
                    {
                        "id": 54791,
                        "name": "Oroslavje",
                        "latitude": "45.99672000",
                        "longitude": "15.91507000"
                    },
                    {
                        "id": 54832,
                        "name": "Pregrada",
                        "latitude": "46.16417000",
                        "longitude": "15.75083000"
                    },
                    {
                        "id": 54851,
                        "name": "Radoboj",
                        "latitude": "46.16639000",
                        "longitude": "15.92361000"
                    },
                    {
                        "id": 54918,
                        "name": "Stubičke Toplice",
                        "latitude": "45.97585000",
                        "longitude": "15.93238000"
                    },
                    {
                        "id": 54930,
                        "name": "Sveti Križ Začretje",
                        "latitude": "46.08224000",
                        "longitude": "15.90704000"
                    },
                    {
                        "id": 55001,
                        "name": "Zabok",
                        "latitude": "46.02944000",
                        "longitude": "15.91500000"
                    },
                    {
                        "id": 55010,
                        "name": "Zlatar",
                        "latitude": "46.09417000",
                        "longitude": "16.07083000"
                    },
                    {
                        "id": 55011,
                        "name": "Zlatar Bistrica",
                        "latitude": "46.04788000",
                        "longitude": "16.08527000"
                    }
                ]
            },
            {
                "id": 731,
                "name": "Lika-Senj",
                "iso2": "09",
                "latitude": "44.61922180",
                "longitude": "15.47016080",
                "type": "county",
                "cities": [
                    {
                        "id": 54422,
                        "name": "Brinje",
                        "latitude": "45.00250000",
                        "longitude": "15.13389000"
                    },
                    {
                        "id": 54501,
                        "name": "Gospić",
                        "latitude": "44.54611000",
                        "longitude": "15.37472000"
                    },
                    {
                        "id": 54633,
                        "name": "Karlobag",
                        "latitude": "44.52750000",
                        "longitude": "15.07389000"
                    },
                    {
                        "id": 54690,
                        "name": "Lički Osik",
                        "latitude": "44.60389000",
                        "longitude": "15.42472000"
                    },
                    {
                        "id": 54758,
                        "name": "Novalja",
                        "latitude": "44.55778000",
                        "longitude": "14.88667000"
                    },
                    {
                        "id": 54796,
                        "name": "Otočac",
                        "latitude": "44.86944000",
                        "longitude": "15.23750000"
                    },
                    {
                        "id": 54802,
                        "name": "Perušić",
                        "latitude": "44.64944000",
                        "longitude": "15.38333000"
                    },
                    {
                        "id": 54812,
                        "name": "Plitvička Jezera",
                        "latitude": "44.88053000",
                        "longitude": "15.62123000"
                    },
                    {
                        "id": 54824,
                        "name": "Popovača",
                        "latitude": "44.63917000",
                        "longitude": "15.17917000"
                    },
                    {
                        "id": 54884,
                        "name": "Senj",
                        "latitude": "44.98944000",
                        "longitude": "14.90583000"
                    }
                ]
            },
            {
                "id": 726,
                "name": "Međimurje",
                "iso2": "20",
                "latitude": "46.37666440",
                "longitude": "16.42132980",
                "type": "county",
                "cities": [
                    {
                        "id": 54392,
                        "name": "Belica",
                        "latitude": "46.40417000",
                        "longitude": "16.51833000"
                    },
                    {
                        "id": 55015,
                        "name": "Čakovec",
                        "latitude": "46.38444000",
                        "longitude": "16.43389000"
                    },
                    {
                        "id": 54451,
                        "name": "Dekanovec",
                        "latitude": "46.44861000",
                        "longitude": "16.58472000"
                    },
                    {
                        "id": 54455,
                        "name": "Domašinec",
                        "latitude": "46.43250000",
                        "longitude": "16.60000000"
                    },
                    {
                        "id": 54493,
                        "name": "Goričan",
                        "latitude": "46.38417000",
                        "longitude": "16.68083000"
                    },
                    {
                        "id": 54570,
                        "name": "Grad Čakovec",
                        "latitude": "46.38583000",
                        "longitude": "16.43333000"
                    },
                    {
                        "id": 54595,
                        "name": "Hodošan",
                        "latitude": "46.39528000",
                        "longitude": "16.64389000"
                    },
                    {
                        "id": 54606,
                        "name": "Ivanovec",
                        "latitude": "46.36833000",
                        "longitude": "16.47667000"
                    },
                    {
                        "id": 54663,
                        "name": "Kotoriba",
                        "latitude": "46.35500000",
                        "longitude": "16.81806000"
                    },
                    {
                        "id": 54675,
                        "name": "Kuršanec",
                        "latitude": "46.33028000",
                        "longitude": "16.40167000"
                    },
                    {
                        "id": 54697,
                        "name": "Lopatinec",
                        "latitude": "46.43333000",
                        "longitude": "16.38333000"
                    },
                    {
                        "id": 54726,
                        "name": "Mačkovec",
                        "latitude": "46.42417000",
                        "longitude": "16.43361000"
                    },
                    {
                        "id": 54711,
                        "name": "Mala Subotica",
                        "latitude": "46.37616000",
                        "longitude": "16.52893000"
                    },
                    {
                        "id": 54730,
                        "name": "Mihovljan",
                        "latitude": "46.40861000",
                        "longitude": "16.44806000"
                    },
                    {
                        "id": 54744,
                        "name": "Mursko Središće",
                        "latitude": "46.50944000",
                        "longitude": "16.44111000"
                    },
                    {
                        "id": 54749,
                        "name": "Nedelišće",
                        "latitude": "46.37583000",
                        "longitude": "16.38750000"
                    },
                    {
                        "id": 54764,
                        "name": "Novo Selo Rok",
                        "latitude": "46.42839000",
                        "longitude": "16.46215000"
                    },
                    {
                        "id": 54788,
                        "name": "Orehovica",
                        "latitude": "46.33167000",
                        "longitude": "16.50694000"
                    },
                    {
                        "id": 54801,
                        "name": "Peklenica",
                        "latitude": "46.49528000",
                        "longitude": "16.47611000"
                    },
                    {
                        "id": 54818,
                        "name": "Podturen",
                        "latitude": "46.46472000",
                        "longitude": "16.54306000"
                    },
                    {
                        "id": 54834,
                        "name": "Prelog",
                        "latitude": "46.33500000",
                        "longitude": "16.61556000"
                    },
                    {
                        "id": 54836,
                        "name": "Pribislavec",
                        "latitude": "46.39250000",
                        "longitude": "16.48250000"
                    },
                    {
                        "id": 55029,
                        "name": "Šenkovec",
                        "latitude": "46.40889000",
                        "longitude": "16.42167000"
                    },
                    {
                        "id": 54915,
                        "name": "Strahoninec",
                        "latitude": "46.36889000",
                        "longitude": "16.41500000"
                    },
                    {
                        "id": 54929,
                        "name": "Sveti Juraj na Bregu",
                        "latitude": "46.42853000",
                        "longitude": "16.38525000"
                    },
                    {
                        "id": 54988,
                        "name": "Vratišinec",
                        "latitude": "46.47806000",
                        "longitude": "16.45778000"
                    }
                ]
            },
            {
                "id": 740,
                "name": "Osijek-Baranja",
                "iso2": "14",
                "latitude": "45.55764280",
                "longitude": "18.39421410",
                "type": "county",
                "cities": [
                    {
                        "id": 54381,
                        "name": "Antunovac",
                        "latitude": "45.49083000",
                        "longitude": "18.67500000"
                    },
                    {
                        "id": 54391,
                        "name": "Beli Manastir",
                        "latitude": "45.77000000",
                        "longitude": "18.60361000"
                    },
                    {
                        "id": 54393,
                        "name": "Belišće",
                        "latitude": "45.68028000",
                        "longitude": "18.40583000"
                    },
                    {
                        "id": 54398,
                        "name": "Bijelo Brdo",
                        "latitude": "45.51722000",
                        "longitude": "18.87083000"
                    },
                    {
                        "id": 54399,
                        "name": "Bilje",
                        "latitude": "45.60694000",
                        "longitude": "18.74389000"
                    },
                    {
                        "id": 54402,
                        "name": "Bistrinci",
                        "latitude": "45.69167000",
                        "longitude": "18.39861000"
                    },
                    {
                        "id": 54403,
                        "name": "Bizovac",
                        "latitude": "45.59278000",
                        "longitude": "18.45889000"
                    },
                    {
                        "id": 54421,
                        "name": "Brijest",
                        "latitude": "45.52056000",
                        "longitude": "18.67194000"
                    },
                    {
                        "id": 54431,
                        "name": "Budrovci",
                        "latitude": "45.27111000",
                        "longitude": "18.44861000"
                    },
                    {
                        "id": 55020,
                        "name": "Čeminac",
                        "latitude": "45.68639000",
                        "longitude": "18.66750000"
                    },
                    {
                        "id": 55021,
                        "name": "Čepin",
                        "latitude": "45.52361000",
                        "longitude": "18.56333000"
                    },
                    {
                        "id": 54447,
                        "name": "Dalj",
                        "latitude": "45.48438000",
                        "longitude": "18.98610000"
                    },
                    {
                        "id": 54448,
                        "name": "Darda",
                        "latitude": "45.62806000",
                        "longitude": "18.69972000"
                    },
                    {
                        "id": 54461,
                        "name": "Donji Miholjac",
                        "latitude": "45.76083000",
                        "longitude": "18.16722000"
                    },
                    {
                        "id": 54464,
                        "name": "Draž",
                        "latitude": "45.84222000",
                        "longitude": "18.78861000"
                    },
                    {
                        "id": 55023,
                        "name": "Đakovo",
                        "latitude": "45.30833000",
                        "longitude": "18.41056000"
                    },
                    {
                        "id": 55014,
                        "name": "Đurđenovac",
                        "latitude": "45.54333000",
                        "longitude": "18.04583000"
                    },
                    {
                        "id": 54476,
                        "name": "Erdut",
                        "latitude": "45.52639000",
                        "longitude": "19.06028000"
                    },
                    {
                        "id": 54477,
                        "name": "Ernestinovo",
                        "latitude": "45.45194000",
                        "longitude": "18.65917000"
                    },
                    {
                        "id": 54482,
                        "name": "Feričanci",
                        "latitude": "45.52889000",
                        "longitude": "17.97583000"
                    },
                    {
                        "id": 54494,
                        "name": "Gorjani",
                        "latitude": "45.39889000",
                        "longitude": "18.37222000"
                    },
                    {
                        "id": 54503,
                        "name": "Grad Beli Manastir",
                        "latitude": "45.77219000",
                        "longitude": "18.61084000"
                    },
                    {
                        "id": 54511,
                        "name": "Grad Donji Miholjac",
                        "latitude": "45.75000000",
                        "longitude": "18.16667000"
                    },
                    {
                        "id": 54533,
                        "name": "Grad Našice",
                        "latitude": "45.50000000",
                        "longitude": "18.10000000"
                    },
                    {
                        "id": 54540,
                        "name": "Grad Osijek",
                        "latitude": "45.58333000",
                        "longitude": "18.66667000"
                    },
                    {
                        "id": 54556,
                        "name": "Grad Valpovo",
                        "latitude": "45.66667000",
                        "longitude": "18.41667000"
                    },
                    {
                        "id": 54610,
                        "name": "Jagodnjak",
                        "latitude": "45.69917000",
                        "longitude": "18.57694000"
                    },
                    {
                        "id": 54619,
                        "name": "Jelisavac",
                        "latitude": "45.52889000",
                        "longitude": "18.15611000"
                    },
                    {
                        "id": 54624,
                        "name": "Josipovac",
                        "latitude": "45.58278000",
                        "longitude": "18.58139000"
                    },
                    {
                        "id": 54632,
                        "name": "Karanac",
                        "latitude": "45.76056000",
                        "longitude": "18.68444000"
                    },
                    {
                        "id": 54651,
                        "name": "Kneževi Vinogradi",
                        "latitude": "45.75028000",
                        "longitude": "18.73306000"
                    },
                    {
                        "id": 54664,
                        "name": "Koška",
                        "latitude": "45.54528000",
                        "longitude": "18.28583000"
                    },
                    {
                        "id": 54680,
                        "name": "Kuševac",
                        "latitude": "45.34778000",
                        "longitude": "18.42889000"
                    },
                    {
                        "id": 54682,
                        "name": "Ladimirevci",
                        "latitude": "45.62556000",
                        "longitude": "18.44861000"
                    },
                    {
                        "id": 54683,
                        "name": "Laslovo",
                        "latitude": "45.41500000",
                        "longitude": "18.69611000"
                    },
                    {
                        "id": 54709,
                        "name": "Magadenovac",
                        "latitude": "45.66159000",
                        "longitude": "18.18679000"
                    },
                    {
                        "id": 54715,
                        "name": "Marijanci",
                        "latitude": "45.66645000",
                        "longitude": "18.29284000"
                    },
                    {
                        "id": 54717,
                        "name": "Marjanci",
                        "latitude": "45.66694000",
                        "longitude": "18.29222000"
                    },
                    {
                        "id": 54718,
                        "name": "Markovac Našički",
                        "latitude": "45.49389000",
                        "longitude": "18.12556000"
                    },
                    {
                        "id": 54720,
                        "name": "Martin",
                        "latitude": "45.49222000",
                        "longitude": "18.06667000"
                    },
                    {
                        "id": 54748,
                        "name": "Našice",
                        "latitude": "45.48861000",
                        "longitude": "18.08778000"
                    },
                    {
                        "id": 54792,
                        "name": "Osijek",
                        "latitude": "45.55111000",
                        "longitude": "18.69389000"
                    },
                    {
                        "id": 54804,
                        "name": "Petlovac",
                        "latitude": "45.75833000",
                        "longitude": "18.52806000"
                    },
                    {
                        "id": 54806,
                        "name": "Petrijevci",
                        "latitude": "45.61278000",
                        "longitude": "18.53528000"
                    },
                    {
                        "id": 54810,
                        "name": "Piškorevci",
                        "latitude": "45.25528000",
                        "longitude": "18.40417000"
                    },
                    {
                        "id": 54814,
                        "name": "Podgorač",
                        "latitude": "45.45861000",
                        "longitude": "18.22278000"
                    },
                    {
                        "id": 54816,
                        "name": "Podravska Moslavina",
                        "latitude": "45.78456000",
                        "longitude": "17.98410000"
                    },
                    {
                        "id": 54877,
                        "name": "Sarvaš",
                        "latitude": "45.52722000",
                        "longitude": "18.83750000"
                    },
                    {
                        "id": 54878,
                        "name": "Satnica Đakovačka",
                        "latitude": "45.35367000",
                        "longitude": "18.37729000"
                    },
                    {
                        "id": 54883,
                        "name": "Semeljci",
                        "latitude": "45.36056000",
                        "longitude": "18.54361000"
                    },
                    {
                        "id": 55031,
                        "name": "Široko Polje",
                        "latitude": "45.40528000",
                        "longitude": "18.47250000"
                    },
                    {
                        "id": 55034,
                        "name": "Šodolovci",
                        "latitude": "45.40000000",
                        "longitude": "18.62028000"
                    },
                    {
                        "id": 54916,
                        "name": "Strizivojna",
                        "latitude": "45.22611000",
                        "longitude": "18.42389000"
                    },
                    {
                        "id": 54935,
                        "name": "Tenja",
                        "latitude": "45.49806000",
                        "longitude": "18.74722000"
                    },
                    {
                        "id": 54952,
                        "name": "Valpovo",
                        "latitude": "45.66083000",
                        "longitude": "18.41861000"
                    },
                    {
                        "id": 54963,
                        "name": "Velimirovac",
                        "latitude": "45.52361000",
                        "longitude": "18.10944000"
                    },
                    {
                        "id": 54966,
                        "name": "Viljevo",
                        "latitude": "45.75139000",
                        "longitude": "18.06306000"
                    },
                    {
                        "id": 54975,
                        "name": "Viškovci",
                        "latitude": "45.34500000",
                        "longitude": "18.46222000"
                    },
                    {
                        "id": 54978,
                        "name": "Višnjevac",
                        "latitude": "45.56861000",
                        "longitude": "18.61389000"
                    },
                    {
                        "id": 54980,
                        "name": "Vladislavci",
                        "latitude": "45.45944000",
                        "longitude": "18.57417000"
                    },
                    {
                        "id": 54999,
                        "name": "Vuka",
                        "latitude": "45.43389000",
                        "longitude": "18.50500000"
                    }
                ]
            },
            {
                "id": 724,
                "name": "Požega-Slavonia",
                "iso2": "11",
                "latitude": "45.34178680",
                "longitude": "17.81143590",
                "type": "county",
                "cities": [
                    {
                        "id": 54415,
                        "name": "Brestovac",
                        "latitude": "45.33056000",
                        "longitude": "17.59694000"
                    },
                    {
                        "id": 54541,
                        "name": "Grad Pakrac",
                        "latitude": "45.43333000",
                        "longitude": "17.20000000"
                    },
                    {
                        "id": 54545,
                        "name": "Grad Požega",
                        "latitude": "45.33333000",
                        "longitude": "17.66667000"
                    },
                    {
                        "id": 54612,
                        "name": "Jakšić",
                        "latitude": "45.35765000",
                        "longitude": "17.76502000"
                    },
                    {
                        "id": 54631,
                        "name": "Kaptol",
                        "latitude": "45.43472000",
                        "longitude": "17.72611000"
                    },
                    {
                        "id": 54677,
                        "name": "Kutjevo",
                        "latitude": "45.42611000",
                        "longitude": "17.88250000"
                    },
                    {
                        "id": 54688,
                        "name": "Lipik",
                        "latitude": "45.41139000",
                        "longitude": "17.15222000"
                    },
                    {
                        "id": 54799,
                        "name": "Pakrac",
                        "latitude": "45.43639000",
                        "longitude": "17.18889000"
                    },
                    {
                        "id": 54811,
                        "name": "Pleternica",
                        "latitude": "45.28861000",
                        "longitude": "17.80639000"
                    },
                    {
                        "id": 54830,
                        "name": "Požega",
                        "latitude": "45.34028000",
                        "longitude": "17.68528000"
                    },
                    {
                        "id": 54955,
                        "name": "Velika",
                        "latitude": "45.45444000",
                        "longitude": "17.66139000"
                    },
                    {
                        "id": 54964,
                        "name": "Vidovci",
                        "latitude": "45.33250000",
                        "longitude": "17.71472000"
                    }
                ]
            },
            {
                "id": 735,
                "name": "Primorje-Gorski Kotar",
                "iso2": "08",
                "latitude": "45.31739960",
                "longitude": "14.81674660",
                "type": "county",
                "cities": [
                    {
                        "id": 54383,
                        "name": "Bakar",
                        "latitude": "45.30861000",
                        "longitude": "14.53028000"
                    },
                    {
                        "id": 54386,
                        "name": "Banjol",
                        "latitude": "44.75000000",
                        "longitude": "14.78333000"
                    },
                    {
                        "id": 54388,
                        "name": "Baška",
                        "latitude": "44.97028000",
                        "longitude": "14.75333000"
                    },
                    {
                        "id": 54420,
                        "name": "Bribir",
                        "latitude": "45.16111000",
                        "longitude": "14.76472000"
                    },
                    {
                        "id": 54435,
                        "name": "Buzdohanj",
                        "latitude": "45.34528000",
                        "longitude": "14.48833000"
                    },
                    {
                        "id": 55016,
                        "name": "Čavle",
                        "latitude": "45.35194000",
                        "longitude": "14.48389000"
                    },
                    {
                        "id": 54442,
                        "name": "Cernik",
                        "latitude": "45.34361000",
                        "longitude": "14.50222000"
                    },
                    {
                        "id": 54444,
                        "name": "Cres",
                        "latitude": "44.96111000",
                        "longitude": "14.40840000"
                    },
                    {
                        "id": 54445,
                        "name": "Crikvenica",
                        "latitude": "45.17722000",
                        "longitude": "14.69278000"
                    },
                    {
                        "id": 54452,
                        "name": "Delnice",
                        "latitude": "45.40083000",
                        "longitude": "14.79972000"
                    },
                    {
                        "id": 54465,
                        "name": "Dražice",
                        "latitude": "45.39083000",
                        "longitude": "14.47028000"
                    },
                    {
                        "id": 54466,
                        "name": "Drenova",
                        "latitude": "45.35000000",
                        "longitude": "14.43028000"
                    },
                    {
                        "id": 54485,
                        "name": "Fužine",
                        "latitude": "45.30528000",
                        "longitude": "14.71556000"
                    },
                    {
                        "id": 54569,
                        "name": "Grad Čabar",
                        "latitude": "45.58333000",
                        "longitude": "14.58333000"
                    },
                    {
                        "id": 54507,
                        "name": "Grad Crikvenica",
                        "latitude": "45.16667000",
                        "longitude": "14.70000000"
                    },
                    {
                        "id": 54509,
                        "name": "Grad Delnice",
                        "latitude": "45.39806000",
                        "longitude": "14.80111000"
                    },
                    {
                        "id": 54528,
                        "name": "Grad Krk",
                        "latitude": "45.02829000",
                        "longitude": "14.57233000"
                    },
                    {
                        "id": 54538,
                        "name": "Grad Opatija",
                        "latitude": "45.33333000",
                        "longitude": "14.26667000"
                    },
                    {
                        "id": 54546,
                        "name": "Grad Rijeka",
                        "latitude": "45.32693000",
                        "longitude": "14.43758000"
                    },
                    {
                        "id": 54563,
                        "name": "Grad Vrbovsko",
                        "latitude": "45.37542000",
                        "longitude": "15.07856000"
                    },
                    {
                        "id": 54598,
                        "name": "Hreljin",
                        "latitude": "45.28250000",
                        "longitude": "14.59917000"
                    },
                    {
                        "id": 54609,
                        "name": "Jadranovo",
                        "latitude": "45.23111000",
                        "longitude": "14.61833000"
                    },
                    {
                        "id": 54628,
                        "name": "Kampor",
                        "latitude": "44.77500000",
                        "longitude": "14.71861000"
                    },
                    {
                        "id": 54635,
                        "name": "Kastav",
                        "latitude": "45.37528000",
                        "longitude": "14.34861000"
                    },
                    {
                        "id": 54647,
                        "name": "Klana",
                        "latitude": "45.44694000",
                        "longitude": "14.37694000"
                    },
                    {
                        "id": 54666,
                        "name": "Kraljevica",
                        "latitude": "45.27395000",
                        "longitude": "14.56830000"
                    },
                    {
                        "id": 54668,
                        "name": "Krasica",
                        "latitude": "45.30972000",
                        "longitude": "14.55556000"
                    },
                    {
                        "id": 54671,
                        "name": "Krk",
                        "latitude": "45.02744000",
                        "longitude": "14.57542000"
                    },
                    {
                        "id": 54696,
                        "name": "Lopar",
                        "latitude": "44.83250000",
                        "longitude": "14.73028000"
                    },
                    {
                        "id": 54699,
                        "name": "Lovran",
                        "latitude": "45.29194000",
                        "longitude": "14.27417000"
                    },
                    {
                        "id": 54712,
                        "name": "Mali Lošinj",
                        "latitude": "44.53056000",
                        "longitude": "14.46861000"
                    },
                    {
                        "id": 54713,
                        "name": "Malinska-Dubašnica",
                        "latitude": "45.12277000",
                        "longitude": "14.52873000"
                    },
                    {
                        "id": 54723,
                        "name": "Marčelji",
                        "latitude": "45.39611000",
                        "longitude": "14.38944000"
                    },
                    {
                        "id": 54716,
                        "name": "Marinići",
                        "latitude": "45.36500000",
                        "longitude": "14.39389000"
                    },
                    {
                        "id": 54724,
                        "name": "Matulji",
                        "latitude": "45.36167000",
                        "longitude": "14.32500000"
                    },
                    {
                        "id": 54729,
                        "name": "Mihotići",
                        "latitude": "45.36125000",
                        "longitude": "14.30553000"
                    },
                    {
                        "id": 54743,
                        "name": "Mrkopalj",
                        "latitude": "45.31556000",
                        "longitude": "14.85528000"
                    },
                    {
                        "id": 54755,
                        "name": "Njivice",
                        "latitude": "45.15806000",
                        "longitude": "14.53861000"
                    },
                    {
                        "id": 54759,
                        "name": "Novi Vinodolski",
                        "latitude": "45.12806000",
                        "longitude": "14.78889000"
                    },
                    {
                        "id": 54776,
                        "name": "Omišalj",
                        "latitude": "45.21134000",
                        "longitude": "14.55495000"
                    },
                    {
                        "id": 54777,
                        "name": "Opatija",
                        "latitude": "45.33771000",
                        "longitude": "14.30515000"
                    },
                    {
                        "id": 54815,
                        "name": "Podhum",
                        "latitude": "45.38722000",
                        "longitude": "14.47944000"
                    },
                    {
                        "id": 54846,
                        "name": "Punat",
                        "latitude": "45.01472000",
                        "longitude": "14.62889000"
                    },
                    {
                        "id": 54849,
                        "name": "Rab",
                        "latitude": "44.75769000",
                        "longitude": "14.75906000"
                    },
                    {
                        "id": 54863,
                        "name": "Rijeka",
                        "latitude": "45.32673000",
                        "longitude": "14.44241000"
                    },
                    {
                        "id": 54870,
                        "name": "Rubeši",
                        "latitude": "45.36694000",
                        "longitude": "14.34806000"
                    },
                    {
                        "id": 54882,
                        "name": "Selce",
                        "latitude": "45.15639000",
                        "longitude": "14.72111000"
                    },
                    {
                        "id": 54893,
                        "name": "Skrad",
                        "latitude": "45.42778000",
                        "longitude": "14.91111000"
                    },
                    {
                        "id": 55033,
                        "name": "Škrljevo",
                        "latitude": "45.32053000",
                        "longitude": "14.53268000"
                    },
                    {
                        "id": 54924,
                        "name": "Supetarska Draga",
                        "latitude": "44.79750000",
                        "longitude": "14.72472000"
                    },
                    {
                        "id": 54970,
                        "name": "Vinodolska općina",
                        "latitude": "45.22219000",
                        "longitude": "14.68941000"
                    },
                    {
                        "id": 54976,
                        "name": "Viškovo",
                        "latitude": "45.37572000",
                        "longitude": "14.38400000"
                    },
                    {
                        "id": 54990,
                        "name": "Vrbnik",
                        "latitude": "45.07583000",
                        "longitude": "14.67250000"
                    },
                    {
                        "id": 54992,
                        "name": "Vrbovsko",
                        "latitude": "45.36861000",
                        "longitude": "15.07833000"
                    }
                ]
            },
            {
                "id": 730,
                "name": "Šibenik-Knin",
                "iso2": "15",
                "latitude": "43.92814850",
                "longitude": "16.10376940",
                "type": "county",
                "cities": [
                    {
                        "id": 54424,
                        "name": "Brodarica",
                        "latitude": "43.68000000",
                        "longitude": "15.91972000"
                    },
                    {
                        "id": 54468,
                        "name": "Drniš",
                        "latitude": "43.86250000",
                        "longitude": "16.15556000"
                    },
                    {
                        "id": 54512,
                        "name": "Grad Drniš",
                        "latitude": "43.83333000",
                        "longitude": "16.16667000"
                    },
                    {
                        "id": 54572,
                        "name": "Grad Šibenik",
                        "latitude": "43.73576000",
                        "longitude": "15.89602000"
                    },
                    {
                        "id": 54646,
                        "name": "Kistanje",
                        "latitude": "43.98278000",
                        "longitude": "15.96500000"
                    },
                    {
                        "id": 54652,
                        "name": "Knin",
                        "latitude": "44.04063000",
                        "longitude": "16.19662000"
                    },
                    {
                        "id": 54745,
                        "name": "Murter",
                        "latitude": "43.82043000",
                        "longitude": "15.58988000"
                    },
                    {
                        "id": 54746,
                        "name": "Murter-Kornati",
                        "latitude": "43.80959000",
                        "longitude": "15.60024000"
                    },
                    {
                        "id": 54808,
                        "name": "Pirovac",
                        "latitude": "43.81917000",
                        "longitude": "15.67278000"
                    },
                    {
                        "id": 54839,
                        "name": "Primošten",
                        "latitude": "43.58632000",
                        "longitude": "15.92302000"
                    },
                    {
                        "id": 54843,
                        "name": "Promina",
                        "latitude": "43.95798000",
                        "longitude": "16.09737000"
                    },
                    {
                        "id": 54864,
                        "name": "Rogoznica",
                        "latitude": "43.52472000",
                        "longitude": "15.97000000"
                    },
                    {
                        "id": 54865,
                        "name": "Rogoznica Općina",
                        "latitude": "43.53620000",
                        "longitude": "15.97086000"
                    },
                    {
                        "id": 55030,
                        "name": "Šibenik",
                        "latitude": "43.72722000",
                        "longitude": "15.90583000"
                    },
                    {
                        "id": 54894,
                        "name": "Skradin",
                        "latitude": "43.82028000",
                        "longitude": "15.92361000"
                    },
                    {
                        "id": 54936,
                        "name": "Tisno",
                        "latitude": "43.80417000",
                        "longitude": "15.64333000"
                    },
                    {
                        "id": 54940,
                        "name": "Tribunj",
                        "latitude": "43.75547000",
                        "longitude": "15.74444000"
                    },
                    {
                        "id": 54981,
                        "name": "Vodice",
                        "latitude": "43.76083000",
                        "longitude": "15.78278000"
                    }
                ]
            },
            {
                "id": 733,
                "name": "Sisak-Moslavina",
                "iso2": "03",
                "latitude": "45.38379260",
                "longitude": "16.53809940",
                "type": "county",
                "cities": [
                    {
                        "id": 54429,
                        "name": "Budaševo",
                        "latitude": "45.47472000",
                        "longitude": "16.43667000"
                    },
                    {
                        "id": 54475,
                        "name": "Dvor",
                        "latitude": "45.07306000",
                        "longitude": "16.37083000"
                    },
                    {
                        "id": 54491,
                        "name": "Glina",
                        "latitude": "45.33806000",
                        "longitude": "16.08806000"
                    },
                    {
                        "id": 54516,
                        "name": "Grad Glina",
                        "latitude": "45.33333000",
                        "longitude": "16.10000000"
                    },
                    {
                        "id": 54518,
                        "name": "Grad Hrvatska Kostajnica",
                        "latitude": "45.25000000",
                        "longitude": "16.56667000"
                    },
                    {
                        "id": 54529,
                        "name": "Grad Kutina",
                        "latitude": "45.50000000",
                        "longitude": "16.75000000"
                    },
                    {
                        "id": 54536,
                        "name": "Grad Novska",
                        "latitude": "45.33333000",
                        "longitude": "17.00000000"
                    },
                    {
                        "id": 54543,
                        "name": "Grad Petrinja",
                        "latitude": "45.43333000",
                        "longitude": "16.26667000"
                    },
                    {
                        "id": 54549,
                        "name": "Grad Sisak",
                        "latitude": "45.50000000",
                        "longitude": "16.36667000"
                    },
                    {
                        "id": 54592,
                        "name": "Gvozd",
                        "latitude": "45.35305000",
                        "longitude": "15.86563000"
                    },
                    {
                        "id": 54600,
                        "name": "Hrvatska Kostajnica",
                        "latitude": "45.23167000",
                        "longitude": "16.53917000"
                    },
                    {
                        "id": 54676,
                        "name": "Kutina",
                        "latitude": "45.47500000",
                        "longitude": "16.78194000"
                    },
                    {
                        "id": 54686,
                        "name": "Lekenik",
                        "latitude": "45.58556000",
                        "longitude": "16.21139000"
                    },
                    {
                        "id": 54689,
                        "name": "Lipovljani",
                        "latitude": "45.39667000",
                        "longitude": "16.88972000"
                    },
                    {
                        "id": 54721,
                        "name": "Martinska Ves",
                        "latitude": "45.58670000",
                        "longitude": "16.37465000"
                    },
                    {
                        "id": 54768,
                        "name": "Novska",
                        "latitude": "45.34056000",
                        "longitude": "16.97694000"
                    },
                    {
                        "id": 54782,
                        "name": "Općina Dvor",
                        "latitude": "45.10000000",
                        "longitude": "16.30000000"
                    },
                    {
                        "id": 54783,
                        "name": "Općina Gvozd",
                        "latitude": "45.33333000",
                        "longitude": "15.90000000"
                    },
                    {
                        "id": 54807,
                        "name": "Petrinja",
                        "latitude": "45.43750000",
                        "longitude": "16.29000000"
                    },
                    {
                        "id": 54825,
                        "name": "Popovača",
                        "latitude": "45.56972000",
                        "longitude": "16.62500000"
                    },
                    {
                        "id": 54859,
                        "name": "Repušnica",
                        "latitude": "45.49278000",
                        "longitude": "16.73083000"
                    },
                    {
                        "id": 54892,
                        "name": "Sisak",
                        "latitude": "45.46611000",
                        "longitude": "16.37833000"
                    },
                    {
                        "id": 54922,
                        "name": "Sunja",
                        "latitude": "45.36850000",
                        "longitude": "16.56702000"
                    },
                    {
                        "id": 54984,
                        "name": "Voloder",
                        "latitude": "45.54806000",
                        "longitude": "16.67889000"
                    }
                ]
            },
            {
                "id": 725,
                "name": "Split-Dalmatia",
                "iso2": "17",
                "latitude": "43.52403280",
                "longitude": "16.81783770",
                "type": "county",
                "cities": [
                    {
                        "id": 54389,
                        "name": "Baška Voda",
                        "latitude": "43.35694000",
                        "longitude": "16.95028000"
                    },
                    {
                        "id": 54407,
                        "name": "Bol",
                        "latitude": "43.26194000",
                        "longitude": "16.65500000"
                    },
                    {
                        "id": 54414,
                        "name": "Brela",
                        "latitude": "43.36889000",
                        "longitude": "16.93417000"
                    },
                    {
                        "id": 54423,
                        "name": "Brnaze",
                        "latitude": "43.68000000",
                        "longitude": "16.64972000"
                    },
                    {
                        "id": 54454,
                        "name": "Dicmo",
                        "latitude": "43.63678000",
                        "longitude": "16.58978000"
                    },
                    {
                        "id": 54463,
                        "name": "Donji Vinjani",
                        "latitude": "43.44613000",
                        "longitude": "17.24064000"
                    },
                    {
                        "id": 54474,
                        "name": "Duće",
                        "latitude": "43.44278000",
                        "longitude": "16.66833000"
                    },
                    {
                        "id": 54472,
                        "name": "Dugi Rat Općina",
                        "latitude": "43.44923000",
                        "longitude": "16.64738000"
                    },
                    {
                        "id": 54473,
                        "name": "Dugopolje",
                        "latitude": "43.58056000",
                        "longitude": "16.60278000"
                    },
                    {
                        "id": 54486,
                        "name": "Gala",
                        "latitude": "43.71500000",
                        "longitude": "16.72694000"
                    },
                    {
                        "id": 54502,
                        "name": "Grabovci",
                        "latitude": "43.49278000",
                        "longitude": "17.20111000"
                    },
                    {
                        "id": 54519,
                        "name": "Grad Hvar",
                        "latitude": "43.17263000",
                        "longitude": "16.44550000"
                    },
                    {
                        "id": 54520,
                        "name": "Grad Imotski",
                        "latitude": "43.43333000",
                        "longitude": "17.16667000"
                    },
                    {
                        "id": 54532,
                        "name": "Grad Makarska",
                        "latitude": "43.30000000",
                        "longitude": "17.03333000"
                    },
                    {
                        "id": 54537,
                        "name": "Grad Omiš",
                        "latitude": "43.46667000",
                        "longitude": "16.70000000"
                    },
                    {
                        "id": 54548,
                        "name": "Grad Sinj",
                        "latitude": "43.72285000",
                        "longitude": "16.65819000"
                    },
                    {
                        "id": 54552,
                        "name": "Grad Split",
                        "latitude": "43.50000000",
                        "longitude": "16.50000000"
                    },
                    {
                        "id": 54553,
                        "name": "Grad Supetar",
                        "latitude": "43.38444000",
                        "longitude": "16.55528000"
                    },
                    {
                        "id": 54555,
                        "name": "Grad Trogir",
                        "latitude": "43.52061000",
                        "longitude": "16.25144000"
                    },
                    {
                        "id": 54561,
                        "name": "Grad Vis",
                        "latitude": "43.05315000",
                        "longitude": "16.18698000"
                    },
                    {
                        "id": 54564,
                        "name": "Grad Vrgorac",
                        "latitude": "43.20000000",
                        "longitude": "17.36667000"
                    },
                    {
                        "id": 54574,
                        "name": "Gradac",
                        "latitude": "43.10583000",
                        "longitude": "17.34167000"
                    },
                    {
                        "id": 54584,
                        "name": "Greda",
                        "latitude": "43.61528000",
                        "longitude": "16.69361000"
                    },
                    {
                        "id": 54587,
                        "name": "Grubine",
                        "latitude": "43.42986000",
                        "longitude": "17.16292000"
                    },
                    {
                        "id": 54599,
                        "name": "Hrvace",
                        "latitude": "43.76333000",
                        "longitude": "16.61500000"
                    },
                    {
                        "id": 54601,
                        "name": "Hvar",
                        "latitude": "43.17250000",
                        "longitude": "16.44278000"
                    },
                    {
                        "id": 54603,
                        "name": "Imotski",
                        "latitude": "43.44667000",
                        "longitude": "17.21667000"
                    },
                    {
                        "id": 54620,
                        "name": "Jelsa",
                        "latitude": "43.16139000",
                        "longitude": "16.69306000"
                    },
                    {
                        "id": 54621,
                        "name": "Jesenice",
                        "latitude": "43.46158000",
                        "longitude": "16.60197000"
                    },
                    {
                        "id": 54627,
                        "name": "Kamen",
                        "latitude": "43.51417000",
                        "longitude": "16.51472000"
                    },
                    {
                        "id": 54637,
                        "name": "Kaštel Gomilica",
                        "latitude": "43.55000000",
                        "longitude": "16.40000000"
                    },
                    {
                        "id": 54638,
                        "name": "Kaštel Kambelovac",
                        "latitude": "43.55000000",
                        "longitude": "16.38333000"
                    },
                    {
                        "id": 54639,
                        "name": "Kaštel Lukšić",
                        "latitude": "43.55528000",
                        "longitude": "16.36750000"
                    },
                    {
                        "id": 54640,
                        "name": "Kaštel Novi",
                        "latitude": "43.55000000",
                        "longitude": "16.33333000"
                    },
                    {
                        "id": 54642,
                        "name": "Kaštel Štafilić",
                        "latitude": "43.55000000",
                        "longitude": "16.33333000"
                    },
                    {
                        "id": 54641,
                        "name": "Kaštel Stari",
                        "latitude": "43.55000000",
                        "longitude": "16.35000000"
                    },
                    {
                        "id": 54643,
                        "name": "Kaštela",
                        "latitude": "43.53865000",
                        "longitude": "16.30740000"
                    },
                    {
                        "id": 54650,
                        "name": "Klis",
                        "latitude": "43.55944000",
                        "longitude": "16.51944000"
                    },
                    {
                        "id": 54654,
                        "name": "Komiža",
                        "latitude": "43.04306000",
                        "longitude": "16.09306000"
                    },
                    {
                        "id": 54665,
                        "name": "Košute",
                        "latitude": "43.63083000",
                        "longitude": "16.69500000"
                    },
                    {
                        "id": 54694,
                        "name": "Lokvičići",
                        "latitude": "43.46428000",
                        "longitude": "17.09142000"
                    },
                    {
                        "id": 54700,
                        "name": "Lovreć",
                        "latitude": "43.48761000",
                        "longitude": "16.98632000"
                    },
                    {
                        "id": 54710,
                        "name": "Makarska",
                        "latitude": "43.29694000",
                        "longitude": "17.01778000"
                    },
                    {
                        "id": 54733,
                        "name": "Milna",
                        "latitude": "43.32667000",
                        "longitude": "16.45083000"
                    },
                    {
                        "id": 54742,
                        "name": "Mravince",
                        "latitude": "43.53333000",
                        "longitude": "16.52194000"
                    },
                    {
                        "id": 54747,
                        "name": "Muć",
                        "latitude": "43.69328000",
                        "longitude": "16.47267000"
                    },
                    {
                        "id": 54752,
                        "name": "Nerežišća",
                        "latitude": "43.32959000",
                        "longitude": "16.57743000"
                    },
                    {
                        "id": 54772,
                        "name": "Okrug",
                        "latitude": "43.49638000",
                        "longitude": "16.26732000"
                    },
                    {
                        "id": 54773,
                        "name": "Okrug Gornji",
                        "latitude": "43.49473000",
                        "longitude": "16.26531000"
                    },
                    {
                        "id": 54775,
                        "name": "Omiš",
                        "latitude": "43.44472000",
                        "longitude": "16.68861000"
                    },
                    {
                        "id": 54795,
                        "name": "Otok",
                        "latitude": "43.68661000",
                        "longitude": "16.73488000"
                    },
                    {
                        "id": 54817,
                        "name": "Podstrana",
                        "latitude": "43.48668000",
                        "longitude": "16.55013000"
                    },
                    {
                        "id": 54829,
                        "name": "Postira",
                        "latitude": "43.37551000",
                        "longitude": "16.63091000"
                    },
                    {
                        "id": 54842,
                        "name": "Proložac",
                        "latitude": "43.46690000",
                        "longitude": "17.15507000"
                    },
                    {
                        "id": 54847,
                        "name": "Pučišća",
                        "latitude": "43.34778000",
                        "longitude": "16.73389000"
                    },
                    {
                        "id": 54872,
                        "name": "Runović",
                        "latitude": "43.37667000",
                        "longitude": "17.23667000"
                    },
                    {
                        "id": 54873,
                        "name": "Runovići",
                        "latitude": "43.38704000",
                        "longitude": "17.23892000"
                    },
                    {
                        "id": 54879,
                        "name": "Seget",
                        "latitude": "43.54305000",
                        "longitude": "16.21222000"
                    },
                    {
                        "id": 54880,
                        "name": "Seget Vranjica",
                        "latitude": "43.50999000",
                        "longitude": "16.18704000"
                    },
                    {
                        "id": 54881,
                        "name": "Selca",
                        "latitude": "43.29722000",
                        "longitude": "16.85083000"
                    },
                    {
                        "id": 54890,
                        "name": "Sinj",
                        "latitude": "43.70361000",
                        "longitude": "16.63944000"
                    },
                    {
                        "id": 54896,
                        "name": "Slatine",
                        "latitude": "43.49944000",
                        "longitude": "16.33333000"
                    },
                    {
                        "id": 54901,
                        "name": "Solin",
                        "latitude": "43.54320000",
                        "longitude": "16.49314000"
                    },
                    {
                        "id": 55035,
                        "name": "Šolta",
                        "latitude": "43.38714000",
                        "longitude": "16.28865000"
                    },
                    {
                        "id": 54904,
                        "name": "Split",
                        "latitude": "43.50891000",
                        "longitude": "16.43915000"
                    },
                    {
                        "id": 54906,
                        "name": "Srinjine",
                        "latitude": "43.48333000",
                        "longitude": "16.60000000"
                    },
                    {
                        "id": 54907,
                        "name": "Stari Grad",
                        "latitude": "43.18472000",
                        "longitude": "16.59528000"
                    },
                    {
                        "id": 54913,
                        "name": "Stobreč",
                        "latitude": "43.50250000",
                        "longitude": "16.52222000"
                    },
                    {
                        "id": 54923,
                        "name": "Supetar",
                        "latitude": "43.38417000",
                        "longitude": "16.55083000"
                    },
                    {
                        "id": 54941,
                        "name": "Trilj",
                        "latitude": "43.61833000",
                        "longitude": "16.72417000"
                    },
                    {
                        "id": 54942,
                        "name": "Trogir",
                        "latitude": "43.51250000",
                        "longitude": "16.25167000"
                    },
                    {
                        "id": 54946,
                        "name": "Tučepi",
                        "latitude": "43.27222000",
                        "longitude": "17.05444000"
                    },
                    {
                        "id": 54945,
                        "name": "Turjaci",
                        "latitude": "43.65000000",
                        "longitude": "16.66917000"
                    },
                    {
                        "id": 54961,
                        "name": "Veliki Drvenik",
                        "latitude": "43.45000000",
                        "longitude": "16.15000000"
                    },
                    {
                        "id": 54974,
                        "name": "Vis",
                        "latitude": "43.06194000",
                        "longitude": "16.18306000"
                    },
                    {
                        "id": 54987,
                        "name": "Vranjic",
                        "latitude": "43.53333000",
                        "longitude": "16.46667000"
                    },
                    {
                        "id": 54993,
                        "name": "Vrgorac",
                        "latitude": "43.20583000",
                        "longitude": "17.37111000"
                    },
                    {
                        "id": 54994,
                        "name": "Vrlika",
                        "latitude": "43.91098000",
                        "longitude": "16.39933000"
                    },
                    {
                        "id": 55005,
                        "name": "Zagvozd",
                        "latitude": "43.39750000",
                        "longitude": "17.05694000"
                    },
                    {
                        "id": 55012,
                        "name": "Zmijavci",
                        "latitude": "43.41083000",
                        "longitude": "17.20556000"
                    },
                    {
                        "id": 55040,
                        "name": "Žrnovnica",
                        "latitude": "43.52111000",
                        "longitude": "16.55917000"
                    }
                ]
            },
            {
                "id": 739,
                "name": "Varaždin",
                "iso2": "05",
                "latitude": "46.23174730",
                "longitude": "16.33605590",
                "type": "county",
                "cities": [
                    {
                        "id": 54395,
                        "name": "Beretinec",
                        "latitude": "46.25000000",
                        "longitude": "16.30000000"
                    },
                    {
                        "id": 54416,
                        "name": "Breznica",
                        "latitude": "46.07111000",
                        "longitude": "16.27111000"
                    },
                    {
                        "id": 54417,
                        "name": "Breznički Hum",
                        "latitude": "46.10722000",
                        "longitude": "16.27667000"
                    },
                    {
                        "id": 54443,
                        "name": "Cestica",
                        "latitude": "46.37167000",
                        "longitude": "16.12528000"
                    },
                    {
                        "id": 54459,
                        "name": "Donje Ladanje",
                        "latitude": "46.30000000",
                        "longitude": "16.16667000"
                    },
                    {
                        "id": 54497,
                        "name": "Gornje Vratno",
                        "latitude": "46.35917000",
                        "longitude": "16.15444000"
                    },
                    {
                        "id": 54500,
                        "name": "Gornji Kneginec",
                        "latitude": "46.25051000",
                        "longitude": "16.37555000"
                    },
                    {
                        "id": 54521,
                        "name": "Grad Ivanec",
                        "latitude": "46.23333000",
                        "longitude": "16.13333000"
                    },
                    {
                        "id": 54531,
                        "name": "Grad Ludbreg",
                        "latitude": "46.25000000",
                        "longitude": "16.63333000"
                    },
                    {
                        "id": 54535,
                        "name": "Grad Novi Marof",
                        "latitude": "46.16667000",
                        "longitude": "16.33333000"
                    },
                    {
                        "id": 54557,
                        "name": "Grad Varaždin",
                        "latitude": "46.30354000",
                        "longitude": "16.33444000"
                    },
                    {
                        "id": 54597,
                        "name": "Hrašćica",
                        "latitude": "46.32494000",
                        "longitude": "16.29427000"
                    },
                    {
                        "id": 54604,
                        "name": "Ivanec",
                        "latitude": "46.22306000",
                        "longitude": "16.12000000"
                    },
                    {
                        "id": 54613,
                        "name": "Jalkovec",
                        "latitude": "46.28083000",
                        "longitude": "16.31972000"
                    },
                    {
                        "id": 54614,
                        "name": "Jalžabet",
                        "latitude": "46.26083000",
                        "longitude": "16.47500000"
                    },
                    {
                        "id": 54649,
                        "name": "Klenovnik",
                        "latitude": "46.27028000",
                        "longitude": "16.07000000"
                    },
                    {
                        "id": 54678,
                        "name": "Kućan Marof",
                        "latitude": "46.28944000",
                        "longitude": "16.37222000"
                    },
                    {
                        "id": 54687,
                        "name": "Lepoglava",
                        "latitude": "46.21056000",
                        "longitude": "16.03556000"
                    },
                    {
                        "id": 54693,
                        "name": "Ljubešćica",
                        "latitude": "46.16667000",
                        "longitude": "16.38333000"
                    },
                    {
                        "id": 54701,
                        "name": "Ludbreg",
                        "latitude": "46.25194000",
                        "longitude": "16.61472000"
                    },
                    {
                        "id": 54750,
                        "name": "Nedeljanec",
                        "latitude": "46.28778000",
                        "longitude": "16.28333000"
                    },
                    {
                        "id": 54805,
                        "name": "Petrijanec",
                        "latitude": "46.34917000",
                        "longitude": "16.22500000"
                    },
                    {
                        "id": 54858,
                        "name": "Remetinec",
                        "latitude": "46.18528000",
                        "longitude": "16.32778000"
                    },
                    {
                        "id": 54905,
                        "name": "Sračinec",
                        "latitude": "46.32944000",
                        "longitude": "16.27889000"
                    },
                    {
                        "id": 54932,
                        "name": "Sveti Đurđ",
                        "latitude": "46.28331000",
                        "longitude": "16.60438000"
                    },
                    {
                        "id": 54947,
                        "name": "Tužno",
                        "latitude": "46.25667000",
                        "longitude": "16.23500000"
                    },
                    {
                        "id": 54953,
                        "name": "Varaždin",
                        "latitude": "46.30444000",
                        "longitude": "16.33778000"
                    },
                    {
                        "id": 54965,
                        "name": "Vidovec",
                        "latitude": "46.28333000",
                        "longitude": "16.24111000"
                    },
                    {
                        "id": 54968,
                        "name": "Vinica",
                        "latitude": "46.33611000",
                        "longitude": "16.14944000"
                    }
                ]
            },
            {
                "id": 732,
                "name": "Virovitica-Podravina",
                "iso2": "10",
                "latitude": "45.65579850",
                "longitude": "17.79324720",
                "type": "county",
                "cities": [
                    {
                        "id": 55018,
                        "name": "Čačinci",
                        "latitude": "45.60389000",
                        "longitude": "17.87028000"
                    },
                    {
                        "id": 55019,
                        "name": "Čađavica",
                        "latitude": "45.74417000",
                        "longitude": "17.85472000"
                    },
                    {
                        "id": 54446,
                        "name": "Crnac",
                        "latitude": "45.69611000",
                        "longitude": "17.93722000"
                    },
                    {
                        "id": 54539,
                        "name": "Grad Orahovica",
                        "latitude": "45.53333000",
                        "longitude": "17.90000000"
                    },
                    {
                        "id": 54550,
                        "name": "Grad Slatina",
                        "latitude": "45.70000000",
                        "longitude": "17.70000000"
                    },
                    {
                        "id": 54560,
                        "name": "Grad Virovitica",
                        "latitude": "45.83167000",
                        "longitude": "17.38483000"
                    },
                    {
                        "id": 54576,
                        "name": "Gradina",
                        "latitude": "45.85423000",
                        "longitude": "17.51109000"
                    },
                    {
                        "id": 54732,
                        "name": "Mikleuš",
                        "latitude": "45.61861000",
                        "longitude": "17.80389000"
                    },
                    {
                        "id": 54756,
                        "name": "Nova Bukovica",
                        "latitude": "45.66472000",
                        "longitude": "17.76694000"
                    },
                    {
                        "id": 54786,
                        "name": "Orahovica",
                        "latitude": "45.54000000",
                        "longitude": "17.88472000"
                    },
                    {
                        "id": 54809,
                        "name": "Pitomača",
                        "latitude": "45.95056000",
                        "longitude": "17.22944000"
                    },
                    {
                        "id": 54861,
                        "name": "Rezovac",
                        "latitude": "45.78333000",
                        "longitude": "17.41667000"
                    },
                    {
                        "id": 54895,
                        "name": "Slatina",
                        "latitude": "45.70333000",
                        "longitude": "17.70278000"
                    },
                    {
                        "id": 54903,
                        "name": "Sopje",
                        "latitude": "45.80111000",
                        "longitude": "17.74250000"
                    },
                    {
                        "id": 55036,
                        "name": "Špišić Bukovica",
                        "latitude": "45.85740000",
                        "longitude": "17.30089000"
                    },
                    {
                        "id": 54920,
                        "name": "Suhopolje",
                        "latitude": "45.79972000",
                        "longitude": "17.49917000"
                    },
                    {
                        "id": 54973,
                        "name": "Virovitica",
                        "latitude": "45.83194000",
                        "longitude": "17.38389000"
                    },
                    {
                        "id": 54985,
                        "name": "Voćin",
                        "latitude": "45.61778000",
                        "longitude": "17.54778000"
                    },
                    {
                        "id": 55008,
                        "name": "Zdenci",
                        "latitude": "45.58917000",
                        "longitude": "17.95028000"
                    }
                ]
            },
            {
                "id": 741,
                "name": "Vukovar-Syrmia",
                "iso2": "16",
                "latitude": "45.17735520",
                "longitude": "18.80535270",
                "type": "county",
                "cities": [
                    {
                        "id": 54380,
                        "name": "Andrijaševci",
                        "latitude": "45.22472000",
                        "longitude": "18.73806000"
                    },
                    {
                        "id": 54382,
                        "name": "Babina Greda",
                        "latitude": "45.11722000",
                        "longitude": "18.53694000"
                    },
                    {
                        "id": 54405,
                        "name": "Bobota",
                        "latitude": "45.42111000",
                        "longitude": "18.85389000"
                    },
                    {
                        "id": 54406,
                        "name": "Bogdanovci",
                        "latitude": "45.34083000",
                        "longitude": "18.93083000"
                    },
                    {
                        "id": 54408,
                        "name": "Borovo",
                        "latitude": "45.37639000",
                        "longitude": "18.96694000"
                    },
                    {
                        "id": 54409,
                        "name": "Borovo Selo",
                        "latitude": "45.40528000",
                        "longitude": "18.97583000"
                    },
                    {
                        "id": 54410,
                        "name": "Bošnjaci",
                        "latitude": "45.05028000",
                        "longitude": "18.75556000"
                    },
                    {
                        "id": 54428,
                        "name": "Bršadin",
                        "latitude": "45.36278000",
                        "longitude": "18.91111000"
                    },
                    {
                        "id": 54439,
                        "name": "Cerić",
                        "latitude": "45.31139000",
                        "longitude": "18.85611000"
                    },
                    {
                        "id": 54440,
                        "name": "Cerna",
                        "latitude": "45.18194000",
                        "longitude": "18.68944000"
                    },
                    {
                        "id": 54467,
                        "name": "Drenovci",
                        "latitude": "44.91944000",
                        "longitude": "18.90284000"
                    },
                    {
                        "id": 54559,
                        "name": "Grad Vinkovci",
                        "latitude": "45.28044000",
                        "longitude": "18.80482000"
                    },
                    {
                        "id": 54565,
                        "name": "Grad Vukovar",
                        "latitude": "45.33333000",
                        "longitude": "19.00000000"
                    },
                    {
                        "id": 54573,
                        "name": "Grad Županja",
                        "latitude": "45.07231000",
                        "longitude": "18.69513000"
                    },
                    {
                        "id": 54578,
                        "name": "Gradište",
                        "latitude": "45.14806000",
                        "longitude": "18.70667000"
                    },
                    {
                        "id": 54591,
                        "name": "Gunja",
                        "latitude": "44.88000000",
                        "longitude": "18.85333000"
                    },
                    {
                        "id": 54602,
                        "name": "Ilok",
                        "latitude": "45.22222000",
                        "longitude": "19.37694000"
                    },
                    {
                        "id": 54605,
                        "name": "Ivankovo",
                        "latitude": "45.28861000",
                        "longitude": "18.68389000"
                    },
                    {
                        "id": 54616,
                        "name": "Jarmina",
                        "latitude": "45.31806000",
                        "longitude": "18.72917000"
                    },
                    {
                        "id": 54655,
                        "name": "Komletinci",
                        "latitude": "45.14972000",
                        "longitude": "18.94917000"
                    },
                    {
                        "id": 54698,
                        "name": "Lovas",
                        "latitude": "45.22639000",
                        "longitude": "19.17111000"
                    },
                    {
                        "id": 54719,
                        "name": "Markušica",
                        "latitude": "45.37389000",
                        "longitude": "18.70583000"
                    },
                    {
                        "id": 54734,
                        "name": "Mirkovci",
                        "latitude": "45.26972000",
                        "longitude": "18.85111000"
                    },
                    {
                        "id": 54751,
                        "name": "Negoslavci",
                        "latitude": "45.27944000",
                        "longitude": "18.99667000"
                    },
                    {
                        "id": 54753,
                        "name": "Nijemci",
                        "latitude": "45.14028000",
                        "longitude": "19.03556000"
                    },
                    {
                        "id": 54769,
                        "name": "Nuštar",
                        "latitude": "45.33250000",
                        "longitude": "18.84139000"
                    },
                    {
                        "id": 54794,
                        "name": "Otok",
                        "latitude": "45.14667000",
                        "longitude": "18.88389000"
                    },
                    {
                        "id": 54840,
                        "name": "Privlaka",
                        "latitude": "45.19472000",
                        "longitude": "18.83750000"
                    },
                    {
                        "id": 54860,
                        "name": "Retkovci",
                        "latitude": "45.23333000",
                        "longitude": "18.65306000"
                    },
                    {
                        "id": 54866,
                        "name": "Rokovci",
                        "latitude": "45.23111000",
                        "longitude": "18.74389000"
                    },
                    {
                        "id": 54902,
                        "name": "Soljani",
                        "latitude": "44.95028000",
                        "longitude": "18.97028000"
                    },
                    {
                        "id": 54909,
                        "name": "Stari Jankovci",
                        "latitude": "45.26194000",
                        "longitude": "18.91444000"
                    },
                    {
                        "id": 55037,
                        "name": "Štitar",
                        "latitude": "45.09556000",
                        "longitude": "18.64028000"
                    },
                    {
                        "id": 54938,
                        "name": "Tordinci",
                        "latitude": "45.37028000",
                        "longitude": "18.79500000"
                    },
                    {
                        "id": 54939,
                        "name": "Tovarnik",
                        "latitude": "45.16500000",
                        "longitude": "19.15194000"
                    },
                    {
                        "id": 54943,
                        "name": "Trpinja",
                        "latitude": "45.41917000",
                        "longitude": "18.89917000"
                    },
                    {
                        "id": 54969,
                        "name": "Vinkovci",
                        "latitude": "45.28833000",
                        "longitude": "18.80472000"
                    },
                    {
                        "id": 54986,
                        "name": "Vođinci",
                        "latitude": "45.27556000",
                        "longitude": "18.60972000"
                    },
                    {
                        "id": 54989,
                        "name": "Vrbanja",
                        "latitude": "44.98079000",
                        "longitude": "18.92717000"
                    },
                    {
                        "id": 55000,
                        "name": "Vukovar",
                        "latitude": "45.35161000",
                        "longitude": "19.00225000"
                    },
                    {
                        "id": 55043,
                        "name": "Županja",
                        "latitude": "45.07750000",
                        "longitude": "18.69750000"
                    }
                ]
            },
            {
                "id": 727,
                "name": "Zadar",
                "iso2": "13",
                "latitude": "44.14693900",
                "longitude": "15.61649430",
                "type": "county",
                "cities": [
                    {
                        "id": 54394,
                        "name": "Benkovac",
                        "latitude": "44.03444000",
                        "longitude": "15.61278000"
                    },
                    {
                        "id": 54397,
                        "name": "Bibinje",
                        "latitude": "44.07324000",
                        "longitude": "15.28288000"
                    },
                    {
                        "id": 54400,
                        "name": "Biograd na Moru",
                        "latitude": "43.94333000",
                        "longitude": "15.45194000"
                    },
                    {
                        "id": 54488,
                        "name": "Galovac",
                        "latitude": "44.07139000",
                        "longitude": "15.39333000"
                    },
                    {
                        "id": 54499,
                        "name": "Gornji Karin",
                        "latitude": "44.13598000",
                        "longitude": "15.63423000"
                    },
                    {
                        "id": 54582,
                        "name": "Gračac",
                        "latitude": "44.29916000",
                        "longitude": "15.84752000"
                    },
                    {
                        "id": 54504,
                        "name": "Grad Biograd na Moru",
                        "latitude": "43.93333000",
                        "longitude": "15.43333000"
                    },
                    {
                        "id": 54617,
                        "name": "Jasenice",
                        "latitude": "44.22969000",
                        "longitude": "15.57514000"
                    },
                    {
                        "id": 54625,
                        "name": "Kali",
                        "latitude": "44.06278000",
                        "longitude": "15.20556000"
                    },
                    {
                        "id": 54673,
                        "name": "Kruševo",
                        "latitude": "44.18333000",
                        "longitude": "15.65000000"
                    },
                    {
                        "id": 54754,
                        "name": "Nin",
                        "latitude": "44.24139000",
                        "longitude": "15.17833000"
                    },
                    {
                        "id": 54762,
                        "name": "Novigrad Općina",
                        "latitude": "44.19417000",
                        "longitude": "15.55667000"
                    },
                    {
                        "id": 54770,
                        "name": "Obrovac",
                        "latitude": "44.20056000",
                        "longitude": "15.68222000"
                    },
                    {
                        "id": 54793,
                        "name": "Osljak",
                        "latitude": "44.07667000",
                        "longitude": "15.20722000"
                    },
                    {
                        "id": 54797,
                        "name": "Pag",
                        "latitude": "44.44500000",
                        "longitude": "15.05750000"
                    },
                    {
                        "id": 54798,
                        "name": "Pakoštane",
                        "latitude": "43.91222000",
                        "longitude": "15.50889000"
                    },
                    {
                        "id": 54822,
                        "name": "Polača",
                        "latitude": "44.01833000",
                        "longitude": "15.51750000"
                    },
                    {
                        "id": 54823,
                        "name": "Poličnik",
                        "latitude": "44.17806000",
                        "longitude": "15.37556000"
                    },
                    {
                        "id": 54828,
                        "name": "Posedarje",
                        "latitude": "44.21361000",
                        "longitude": "15.47667000"
                    },
                    {
                        "id": 54833,
                        "name": "Preko",
                        "latitude": "44.08111000",
                        "longitude": "15.18750000"
                    },
                    {
                        "id": 54837,
                        "name": "Pridraga",
                        "latitude": "44.16667000",
                        "longitude": "15.56667000"
                    },
                    {
                        "id": 54841,
                        "name": "Privlaka",
                        "latitude": "44.26667000",
                        "longitude": "15.13333000"
                    },
                    {
                        "id": 54856,
                        "name": "Ražanac",
                        "latitude": "44.28194000",
                        "longitude": "15.34806000"
                    },
                    {
                        "id": 54875,
                        "name": "Sali",
                        "latitude": "43.93972000",
                        "longitude": "15.16333000"
                    },
                    {
                        "id": 55032,
                        "name": "Škabrnja",
                        "latitude": "44.08949000",
                        "longitude": "15.45146000"
                    },
                    {
                        "id": 54908,
                        "name": "Stari Grad",
                        "latitude": "44.43000000",
                        "longitude": "15.06222000"
                    },
                    {
                        "id": 54911,
                        "name": "Starigrad",
                        "latitude": "44.29601000",
                        "longitude": "15.43865000"
                    },
                    {
                        "id": 54921,
                        "name": "Sukošan",
                        "latitude": "44.04696000",
                        "longitude": "15.31391000"
                    },
                    {
                        "id": 54928,
                        "name": "Sveti Filip i Jakov",
                        "latitude": "43.96472000",
                        "longitude": "15.43000000"
                    },
                    {
                        "id": 54937,
                        "name": "Tkon",
                        "latitude": "43.91996000",
                        "longitude": "15.41639000"
                    },
                    {
                        "id": 54944,
                        "name": "Turanj",
                        "latitude": "43.97111000",
                        "longitude": "15.41139000"
                    },
                    {
                        "id": 54948,
                        "name": "Ugljan",
                        "latitude": "44.13083000",
                        "longitude": "15.10306000"
                    },
                    {
                        "id": 54971,
                        "name": "Vir",
                        "latitude": "44.29995000",
                        "longitude": "15.08663000"
                    },
                    {
                        "id": 54998,
                        "name": "Vrsi",
                        "latitude": "44.26472000",
                        "longitude": "15.23250000"
                    },
                    {
                        "id": 55002,
                        "name": "Zadar",
                        "latitude": "44.11972000",
                        "longitude": "15.24222000"
                    }
                ]
            },
            {
                "id": 736,
                "name": "Zagreb",
                "iso2": "01",
                "latitude": "45.87066120",
                "longitude": "16.39549100",
                "type": "county",
                "cities": [
                    {
                        "id": 54396,
                        "name": "Bestovje",
                        "latitude": "45.80833000",
                        "longitude": "15.81667000"
                    },
                    {
                        "id": 54401,
                        "name": "Bistra",
                        "latitude": "45.90657000",
                        "longitude": "15.85087000"
                    },
                    {
                        "id": 54411,
                        "name": "Brckovljani",
                        "latitude": "45.83333000",
                        "longitude": "16.30000000"
                    },
                    {
                        "id": 54412,
                        "name": "Brdovec",
                        "latitude": "45.86666000",
                        "longitude": "15.77102000"
                    },
                    {
                        "id": 54413,
                        "name": "Bregana",
                        "latitude": "45.84013000",
                        "longitude": "15.68792000"
                    },
                    {
                        "id": 54456,
                        "name": "Donja Bistra",
                        "latitude": "45.90778000",
                        "longitude": "15.85444000"
                    },
                    {
                        "id": 54457,
                        "name": "Donja Lomnica",
                        "latitude": "45.71194000",
                        "longitude": "16.02694000"
                    },
                    {
                        "id": 54458,
                        "name": "Donja Zdenčina",
                        "latitude": "45.66667000",
                        "longitude": "15.76667000"
                    },
                    {
                        "id": 54462,
                        "name": "Donji Stupnik",
                        "latitude": "45.73971000",
                        "longitude": "15.85975000"
                    },
                    {
                        "id": 54478,
                        "name": "Farkaševac",
                        "latitude": "45.87899000",
                        "longitude": "16.63467000"
                    },
                    {
                        "id": 54495,
                        "name": "Gornja Bistra",
                        "latitude": "45.91667000",
                        "longitude": "15.90000000"
                    },
                    {
                        "id": 54583,
                        "name": "Gračec",
                        "latitude": "45.83333000",
                        "longitude": "16.31667000"
                    },
                    {
                        "id": 54514,
                        "name": "Grad Dugo Selo",
                        "latitude": "45.80900000",
                        "longitude": "16.24123000"
                    },
                    {
                        "id": 54522,
                        "name": "Grad Jastrebarsko",
                        "latitude": "45.66667000",
                        "longitude": "15.66667000"
                    },
                    {
                        "id": 54547,
                        "name": "Grad Samobor",
                        "latitude": "45.80000000",
                        "longitude": "15.70000000"
                    },
                    {
                        "id": 54554,
                        "name": "Grad Sveti Ivan Zelina",
                        "latitude": "45.96667000",
                        "longitude": "16.25000000"
                    },
                    {
                        "id": 54558,
                        "name": "Grad Velika Gorica",
                        "latitude": "45.70000000",
                        "longitude": "16.08333000"
                    },
                    {
                        "id": 54562,
                        "name": "Grad Vrbovec",
                        "latitude": "45.86667000",
                        "longitude": "16.43333000"
                    },
                    {
                        "id": 54567,
                        "name": "Grad Zaprešić",
                        "latitude": "45.86667000",
                        "longitude": "15.80000000"
                    },
                    {
                        "id": 54575,
                        "name": "Gradec",
                        "latitude": "45.91111000",
                        "longitude": "16.48278000"
                    },
                    {
                        "id": 54577,
                        "name": "Gradići",
                        "latitude": "45.70000000",
                        "longitude": "16.05000000"
                    },
                    {
                        "id": 54608,
                        "name": "Jablanovec",
                        "latitude": "45.87583000",
                        "longitude": "15.85361000"
                    },
                    {
                        "id": 54611,
                        "name": "Jakovlje",
                        "latitude": "45.93611000",
                        "longitude": "15.85559000"
                    },
                    {
                        "id": 54618,
                        "name": "Jastrebarsko",
                        "latitude": "45.66833000",
                        "longitude": "15.64861000"
                    },
                    {
                        "id": 54645,
                        "name": "Kerestinec",
                        "latitude": "45.77010000",
                        "longitude": "15.80864000"
                    },
                    {
                        "id": 54669,
                        "name": "Križ",
                        "latitude": "45.66500000",
                        "longitude": "16.52333000"
                    },
                    {
                        "id": 54679,
                        "name": "Kuče",
                        "latitude": "45.67694000",
                        "longitude": "16.14500000"
                    },
                    {
                        "id": 54695,
                        "name": "Lonjica",
                        "latitude": "45.85500000",
                        "longitude": "16.33000000"
                    },
                    {
                        "id": 54702,
                        "name": "Luka",
                        "latitude": "45.95795000",
                        "longitude": "15.81954000"
                    },
                    {
                        "id": 54703,
                        "name": "Lukavec",
                        "latitude": "45.70444000",
                        "longitude": "15.99000000"
                    },
                    {
                        "id": 54705,
                        "name": "Lupoglav",
                        "latitude": "45.79639000",
                        "longitude": "16.34639000"
                    },
                    {
                        "id": 54735,
                        "name": "Mičevec",
                        "latitude": "45.75000000",
                        "longitude": "16.06667000"
                    },
                    {
                        "id": 54741,
                        "name": "Mraclin",
                        "latitude": "45.66667000",
                        "longitude": "16.09556000"
                    },
                    {
                        "id": 54766,
                        "name": "Novo Čiče",
                        "latitude": "45.70000000",
                        "longitude": "16.11667000"
                    },
                    {
                        "id": 54767,
                        "name": "Novoselec",
                        "latitude": "45.65250000",
                        "longitude": "16.53639000"
                    },
                    {
                        "id": 54781,
                        "name": "Općina Dubrava",
                        "latitude": "45.83759000",
                        "longitude": "16.53683000"
                    },
                    {
                        "id": 54789,
                        "name": "Orešje",
                        "latitude": "45.81618000",
                        "longitude": "15.80246000"
                    },
                    {
                        "id": 54820,
                        "name": "Pojatno",
                        "latitude": "45.90500000",
                        "longitude": "15.80056000"
                    },
                    {
                        "id": 54835,
                        "name": "Preseka",
                        "latitude": "45.97456000",
                        "longitude": "16.38697000"
                    },
                    {
                        "id": 54838,
                        "name": "Prigorje Brdovečko",
                        "latitude": "45.87944000",
                        "longitude": "15.73806000"
                    },
                    {
                        "id": 54848,
                        "name": "Pušća",
                        "latitude": "45.91567000",
                        "longitude": "15.78049000"
                    },
                    {
                        "id": 54852,
                        "name": "Rakitje",
                        "latitude": "45.79389000",
                        "longitude": "15.82222000"
                    },
                    {
                        "id": 54853,
                        "name": "Rakov Potok",
                        "latitude": "45.73806000",
                        "longitude": "15.79722000"
                    },
                    {
                        "id": 54871,
                        "name": "Rude",
                        "latitude": "45.76667000",
                        "longitude": "15.66667000"
                    },
                    {
                        "id": 54876,
                        "name": "Samobor",
                        "latitude": "45.80306000",
                        "longitude": "15.71806000"
                    },
                    {
                        "id": 54919,
                        "name": "Stupnik",
                        "latitude": "45.75314000",
                        "longitude": "15.84078000"
                    },
                    {
                        "id": 54926,
                        "name": "Sveta Nedelja",
                        "latitude": "45.79617000",
                        "longitude": "15.77971000"
                    },
                    {
                        "id": 54927,
                        "name": "Sveta Nedjelja",
                        "latitude": "45.79833000",
                        "longitude": "15.78056000"
                    },
                    {
                        "id": 54956,
                        "name": "Velika Gorica",
                        "latitude": "45.71250000",
                        "longitude": "16.07556000"
                    },
                    {
                        "id": 54958,
                        "name": "Velika Mlaka",
                        "latitude": "45.73639000",
                        "longitude": "16.03111000"
                    },
                    {
                        "id": 54959,
                        "name": "Velika Ostrna",
                        "latitude": "45.78752000",
                        "longitude": "16.28139000"
                    },
                    {
                        "id": 54991,
                        "name": "Vrbovec",
                        "latitude": "45.88333000",
                        "longitude": "16.42167000"
                    },
                    {
                        "id": 55006,
                        "name": "Zaprešić",
                        "latitude": "45.85639000",
                        "longitude": "15.80778000"
                    },
                    {
                        "id": 55009,
                        "name": "Zdenci Brdovečki",
                        "latitude": "45.86667000",
                        "longitude": "15.75000000"
                    }
                ]
            },
            {
                "id": 738,
                "name": "Zagreb",
                "iso2": "21",
                "latitude": "45.81501080",
                "longitude": "15.98191890",
                "type": "city",
                "cities": [
                    {
                        "id": 54419,
                        "name": "Brezovica",
                        "latitude": "45.72919000",
                        "longitude": "15.91069000"
                    },
                    {
                        "id": 54438,
                        "name": "Centar",
                        "latitude": "45.81313000",
                        "longitude": "15.97753000"
                    },
                    {
                        "id": 54470,
                        "name": "Dubrava",
                        "latitude": "45.83361000",
                        "longitude": "16.06361000"
                    },
                    {
                        "id": 54579,
                        "name": "Gradska četvrt Donji grad",
                        "latitude": "45.80834000",
                        "longitude": "15.96949000"
                    },
                    {
                        "id": 54580,
                        "name": "Gradska četvrt Gornji Grad - Medvescak",
                        "latitude": "45.82820000",
                        "longitude": "15.97938000"
                    },
                    {
                        "id": 54581,
                        "name": "Gradska četvrt Podsljeme",
                        "latitude": "45.86097000",
                        "longitude": "15.97996000"
                    },
                    {
                        "id": 54596,
                        "name": "Horvati",
                        "latitude": "45.70000000",
                        "longitude": "15.81667000"
                    },
                    {
                        "id": 54615,
                        "name": "Jankomir",
                        "latitude": "45.79167000",
                        "longitude": "15.90000000"
                    },
                    {
                        "id": 54623,
                        "name": "Ježdovec",
                        "latitude": "45.78333000",
                        "longitude": "15.85000000"
                    },
                    {
                        "id": 54636,
                        "name": "Kašina",
                        "latitude": "45.91134000",
                        "longitude": "16.12436000"
                    },
                    {
                        "id": 54707,
                        "name": "Lučko",
                        "latitude": "45.76111000",
                        "longitude": "15.87028000"
                    },
                    {
                        "id": 54760,
                        "name": "Novi Zagreb",
                        "latitude": "45.78333000",
                        "longitude": "15.98333000"
                    },
                    {
                        "id": 54771,
                        "name": "Odra",
                        "latitude": "45.72979000",
                        "longitude": "15.99240000"
                    },
                    {
                        "id": 54885,
                        "name": "Sesvete",
                        "latitude": "45.83333000",
                        "longitude": "16.13333000"
                    },
                    {
                        "id": 54912,
                        "name": "Stenjevec",
                        "latitude": "45.80846000",
                        "longitude": "15.88245000"
                    },
                    {
                        "id": 54917,
                        "name": "Strmec",
                        "latitude": "45.70843000",
                        "longitude": "15.91674000"
                    },
                    {
                        "id": 55003,
                        "name": "Zadvorsko",
                        "latitude": "45.71978000",
                        "longitude": "15.90880000"
                    },
                    {
                        "id": 55004,
                        "name": "Zagreb",
                        "latitude": "45.81444000",
                        "longitude": "15.97798000"
                    }
                ]
            }
        ]
    },
    {
        "id": 56,
        "name": "Cuba",
        "iso3": "CUB",
        "iso2": "CU",
        "numeric_code": "192",
        "phonecode": "53",
        "capital": "Havana",
        "currency": "CUP",
        "currency_name": "Cuban peso",
        "currency_symbol": "$",
        "tld": ".cu",
        "native": "Cuba",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Cuban",
        "timezones": [
            {
                "zoneName": "America\/Havana",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "CST",
                "tzName": "Cuba Standard Time"
            }
        ],
        "translations": {
            "br": "Kuba",
            "ko": "쿠바",
            "pt-BR": "Cuba",
            "pt": "Cuba",
            "nl": "Cuba",
            "hr": "Kuba",
            "fa": "کوبا",
            "de": "Kuba",
            "es": "Cuba",
            "fr": "Cuba",
            "ja": "キューバ",
            "it": "Cuba",
            "zh-CN": "古巴",
            "tr": "Küba",
            "ru": "Куба",
            "uk": "Куба",
            "pl": "Kuba"
        },
        "latitude": "21.50000000",
        "longitude": "-80.00000000",
        "emoji": "🇨🇺",
        "emojiU": "U+1F1E8 U+1F1FA",
        "states": [
            {
                "id": 283,
                "name": "Artemisa",
                "iso2": "15",
                "latitude": "22.75229030",
                "longitude": "-82.99316070",
                "type": "province",
                "cities": [
                    {
                        "id": 21804,
                        "name": "Alquízar",
                        "latitude": "22.80517000",
                        "longitude": "-82.58392000"
                    },
                    {
                        "id": 21807,
                        "name": "Artemisa",
                        "latitude": "22.81667000",
                        "longitude": "-82.75944000"
                    },
                    {
                        "id": 21808,
                        "name": "Bahía Honda",
                        "latitude": "22.90332000",
                        "longitude": "-83.15994000"
                    },
                    {
                        "id": 21814,
                        "name": "Bauta",
                        "latitude": "22.98226000",
                        "longitude": "-82.54719000"
                    },
                    {
                        "id": 21820,
                        "name": "Cabañas",
                        "latitude": "22.97944000",
                        "longitude": "-82.92214000"
                    },
                    {
                        "id": 21828,
                        "name": "Candelaria",
                        "latitude": "22.74057000",
                        "longitude": "-82.95912000"
                    },
                    {
                        "id": 21858,
                        "name": "Guanajay",
                        "latitude": "22.92639000",
                        "longitude": "-82.68750000"
                    },
                    {
                        "id": 21865,
                        "name": "Güira de Melena",
                        "latitude": "22.79613000",
                        "longitude": "-82.50667000"
                    },
                    {
                        "id": 21895,
                        "name": "Mariel",
                        "latitude": "22.98931000",
                        "longitude": "-82.75376000"
                    },
                    {
                        "id": 21904,
                        "name": "Municipio de Artemisa",
                        "latitude": "22.77383000",
                        "longitude": "-82.80419000"
                    },
                    {
                        "id": 21906,
                        "name": "Municipio de Bauta",
                        "latitude": "22.96957000",
                        "longitude": "-82.49997000"
                    },
                    {
                        "id": 21914,
                        "name": "Municipio de Guanajay",
                        "latitude": "22.89215000",
                        "longitude": "-82.70873000"
                    },
                    {
                        "id": 21923,
                        "name": "Municipio de Mariel",
                        "latitude": "22.96515000",
                        "longitude": "-82.80324000"
                    },
                    {
                        "id": 21931,
                        "name": "Municipio de San Cristóbal",
                        "latitude": "22.71446000",
                        "longitude": "-83.04561000"
                    },
                    {
                        "id": 21959,
                        "name": "San Antonio de los Baños",
                        "latitude": "22.89018000",
                        "longitude": "-82.50099000"
                    },
                    {
                        "id": 21960,
                        "name": "San Cristobal",
                        "latitude": "22.71658000",
                        "longitude": "-83.05647000"
                    },
                    {
                        "id": 21976,
                        "name": "Soroa",
                        "latitude": "22.80000000",
                        "longitude": "-83.01667000"
                    }
                ]
            },
            {
                "id": 286,
                "name": "Camagüey",
                "iso2": "09",
                "latitude": "21.21672470",
                "longitude": "-77.74520810",
                "type": "province",
                "cities": [
                    {
                        "id": 21825,
                        "name": "Camagüey",
                        "latitude": "21.38083000",
                        "longitude": "-77.91694000"
                    },
                    {
                        "id": 21848,
                        "name": "El Caney",
                        "latitude": "21.30000000",
                        "longitude": "-78.48333000"
                    },
                    {
                        "id": 21851,
                        "name": "Esmeralda",
                        "latitude": "21.85139000",
                        "longitude": "-78.11725000"
                    },
                    {
                        "id": 21854,
                        "name": "Florida",
                        "latitude": "21.52536000",
                        "longitude": "-78.22579000"
                    },
                    {
                        "id": 21863,
                        "name": "Guáimaro",
                        "latitude": "21.05222000",
                        "longitude": "-77.34990000"
                    },
                    {
                        "id": 21876,
                        "name": "Jimaguayú",
                        "latitude": "21.24224000",
                        "longitude": "-77.82625000"
                    },
                    {
                        "id": 21899,
                        "name": "Minas",
                        "latitude": "21.48802000",
                        "longitude": "-77.61033000"
                    },
                    {
                        "id": 21913,
                        "name": "Municipio de Florida",
                        "latitude": "21.46582000",
                        "longitude": "-78.34848000"
                    },
                    {
                        "id": 21928,
                        "name": "Municipio de Nuevitas",
                        "latitude": "21.55000000",
                        "longitude": "-77.26667000"
                    },
                    {
                        "id": 21938,
                        "name": "Nuevitas",
                        "latitude": "21.54585000",
                        "longitude": "-77.26504000"
                    },
                    {
                        "id": 21971,
                        "name": "Santa Cruz del Sur",
                        "latitude": "20.71633000",
                        "longitude": "-77.99816000"
                    },
                    {
                        "id": 21975,
                        "name": "Sibanicú",
                        "latitude": "21.23631000",
                        "longitude": "-77.52561000"
                    },
                    {
                        "id": 21982,
                        "name": "Vertientes",
                        "latitude": "21.25817000",
                        "longitude": "-78.14979000"
                    }
                ]
            },
            {
                "id": 282,
                "name": "Ciego de Ávila",
                "iso2": "08",
                "latitude": "21.93295150",
                "longitude": "-78.56608520",
                "type": "province",
                "cities": [
                    {
                        "id": 21811,
                        "name": "Baraguá",
                        "latitude": "21.68216000",
                        "longitude": "-78.62567000"
                    },
                    {
                        "id": 21832,
                        "name": "Chambas",
                        "latitude": "22.19534000",
                        "longitude": "-78.91230000"
                    },
                    {
                        "id": 21833,
                        "name": "Ciego de Ávila",
                        "latitude": "21.84000000",
                        "longitude": "-78.76194000"
                    },
                    {
                        "id": 21836,
                        "name": "Ciro Redondo",
                        "latitude": "22.01921000",
                        "longitude": "-78.70365000"
                    },
                    {
                        "id": 21853,
                        "name": "Florencia",
                        "latitude": "22.14610000",
                        "longitude": "-78.97328000"
                    },
                    {
                        "id": 21902,
                        "name": "Morón",
                        "latitude": "22.10774000",
                        "longitude": "-78.62667000"
                    },
                    {
                        "id": 21909,
                        "name": "Municipio de Ciego de Ávila",
                        "latitude": "21.85000000",
                        "longitude": "-78.76667000"
                    },
                    {
                        "id": 21926,
                        "name": "Municipio de Morón",
                        "latitude": "22.29980000",
                        "longitude": "-78.56875000"
                    },
                    {
                        "id": 21945,
                        "name": "Primero de Enero",
                        "latitude": "21.94501000",
                        "longitude": "-78.43130000"
                    },
                    {
                        "id": 21981,
                        "name": "Venezuela",
                        "latitude": "21.73748000",
                        "longitude": "-78.79336000"
                    }
                ]
            },
            {
                "id": 287,
                "name": "Cienfuegos",
                "iso2": "06",
                "latitude": "22.23797830",
                "longitude": "-80.36586500",
                "type": "province",
                "cities": [
                    {
                        "id": 21800,
                        "name": "Abreus",
                        "latitude": "22.27797000",
                        "longitude": "-80.56931000"
                    },
                    {
                        "id": 21801,
                        "name": "Aguada de Pasajeros",
                        "latitude": "22.38520000",
                        "longitude": "-80.84792000"
                    },
                    {
                        "id": 21834,
                        "name": "Cienfuegos",
                        "latitude": "22.14957000",
                        "longitude": "-80.44662000"
                    },
                    {
                        "id": 21843,
                        "name": "Cruces",
                        "latitude": "22.34203000",
                        "longitude": "-80.27021000"
                    },
                    {
                        "id": 21845,
                        "name": "Cumanayagua",
                        "latitude": "22.15247000",
                        "longitude": "-80.20354000"
                    },
                    {
                        "id": 21883,
                        "name": "Lajas",
                        "latitude": "22.41479000",
                        "longitude": "-80.29310000"
                    },
                    {
                        "id": 21903,
                        "name": "Municipio de Abreus",
                        "latitude": "22.19229000",
                        "longitude": "-80.71465000"
                    },
                    {
                        "id": 21910,
                        "name": "Municipio de Cienfuegos",
                        "latitude": "22.15000000",
                        "longitude": "-80.45000000"
                    },
                    {
                        "id": 21940,
                        "name": "Palmira",
                        "latitude": "22.24126000",
                        "longitude": "-80.39110000"
                    },
                    {
                        "id": 21953,
                        "name": "Rodas",
                        "latitude": "22.34184000",
                        "longitude": "-80.55596000"
                    }
                ]
            },
            {
                "id": 275,
                "name": "Granma",
                "iso2": "12",
                "latitude": "20.38449020",
                "longitude": "-76.64127120",
                "type": "province",
                "cities": [
                    {
                        "id": 21812,
                        "name": "Bartolomé Masó",
                        "latitude": "20.16635000",
                        "longitude": "-76.94291000"
                    },
                    {
                        "id": 21815,
                        "name": "Bayamo",
                        "latitude": "20.37417000",
                        "longitude": "-76.64361000"
                    },
                    {
                        "id": 21827,
                        "name": "Campechuela",
                        "latitude": "20.23329000",
                        "longitude": "-77.27990000"
                    },
                    {
                        "id": 21829,
                        "name": "Cauto Cristo",
                        "latitude": "20.55709000",
                        "longitude": "-76.47270000"
                    },
                    {
                        "id": 21862,
                        "name": "Guisa",
                        "latitude": "20.25494000",
                        "longitude": "-76.53930000"
                    },
                    {
                        "id": 21875,
                        "name": "Jiguaní",
                        "latitude": "20.36785000",
                        "longitude": "-76.42741000"
                    },
                    {
                        "id": 21894,
                        "name": "Manzanillo",
                        "latitude": "20.34173000",
                        "longitude": "-77.12126000"
                    },
                    {
                        "id": 21898,
                        "name": "Media Luna",
                        "latitude": "20.14298000",
                        "longitude": "-77.43532000"
                    },
                    {
                        "id": 21907,
                        "name": "Municipio de Bayamo",
                        "latitude": "20.42511000",
                        "longitude": "-76.68614000"
                    },
                    {
                        "id": 21922,
                        "name": "Municipio de Manzanillo",
                        "latitude": "20.24732000",
                        "longitude": "-77.10273000"
                    },
                    {
                        "id": 21927,
                        "name": "Municipio de Niquero",
                        "latitude": "19.93912000",
                        "longitude": "-77.57085000"
                    },
                    {
                        "id": 21936,
                        "name": "Niquero",
                        "latitude": "20.04698000",
                        "longitude": "-77.58089000"
                    },
                    {
                        "id": 21954,
                        "name": "Río Cauto",
                        "latitude": "20.55971000",
                        "longitude": "-76.91673000"
                    },
                    {
                        "id": 21985,
                        "name": "Yara",
                        "latitude": "20.27465000",
                        "longitude": "-76.95132000"
                    }
                ]
            },
            {
                "id": 285,
                "name": "Guantánamo",
                "iso2": "14",
                "latitude": "20.14559170",
                "longitude": "-74.87410450",
                "type": "province",
                "cities": [
                    {
                        "id": 21810,
                        "name": "Baracoa",
                        "latitude": "20.34711000",
                        "longitude": "-74.49624000"
                    },
                    {
                        "id": 21860,
                        "name": "Guantánamo",
                        "latitude": "20.14444000",
                        "longitude": "-75.20917000"
                    },
                    {
                        "id": 21889,
                        "name": "Maisí",
                        "latitude": "20.24673000",
                        "longitude": "-74.15181000"
                    },
                    {
                        "id": 21916,
                        "name": "Municipio de Guantánamo",
                        "latitude": "20.26723000",
                        "longitude": "-75.15546000"
                    },
                    {
                        "id": 21955,
                        "name": "Río Guayabal de Yateras",
                        "latitude": "20.36667000",
                        "longitude": "-75.01667000"
                    },
                    {
                        "id": 21958,
                        "name": "San Antonio del Sur",
                        "latitude": "20.05564000",
                        "longitude": "-74.80750000"
                    }
                ]
            },
            {
                "id": 272,
                "name": "Havana",
                "iso2": "03",
                "latitude": "23.05406980",
                "longitude": "-82.34518900",
                "type": "province",
                "cities": [
                    {
                        "id": 21803,
                        "name": "Alamar",
                        "latitude": "23.15794000",
                        "longitude": "-82.27837000"
                    },
                    {
                        "id": 21806,
                        "name": "Arroyo Naranjo",
                        "latitude": "23.03677000",
                        "longitude": "-82.36937000"
                    },
                    {
                        "id": 21818,
                        "name": "Boyeros",
                        "latitude": "23.00720000",
                        "longitude": "-82.40170000"
                    },
                    {
                        "id": 21830,
                        "name": "Centro Habana",
                        "latitude": "23.13833000",
                        "longitude": "-82.36417000"
                    },
                    {
                        "id": 21831,
                        "name": "Cerro",
                        "latitude": "23.10861000",
                        "longitude": "-82.37778000"
                    },
                    {
                        "id": 21847,
                        "name": "Diez de Octubre",
                        "latitude": "23.08810000",
                        "longitude": "-82.35970000"
                    },
                    {
                        "id": 21857,
                        "name": "Guanabacoa",
                        "latitude": "23.12360000",
                        "longitude": "-82.30082000"
                    },
                    {
                        "id": 21866,
                        "name": "Habana del Este",
                        "latitude": "23.15917000",
                        "longitude": "-82.33056000"
                    },
                    {
                        "id": 21867,
                        "name": "Havana",
                        "latitude": "23.13302000",
                        "longitude": "-82.38304000"
                    },
                    {
                        "id": 21880,
                        "name": "La Habana Vieja",
                        "latitude": "23.13028000",
                        "longitude": "-82.35306000"
                    },
                    {
                        "id": 21952,
                        "name": "Regla",
                        "latitude": "23.12500000",
                        "longitude": "-82.33194000"
                    },
                    {
                        "id": 21966,
                        "name": "San Miguel del Padrón",
                        "latitude": "23.06639000",
                        "longitude": "-82.29472000"
                    },
                    {
                        "id": 21973,
                        "name": "Santiago de las Vegas",
                        "latitude": "22.97000000",
                        "longitude": "-82.38694000"
                    }
                ]
            },
            {
                "id": 279,
                "name": "Holguín",
                "iso2": "11",
                "latitude": "20.78378930",
                "longitude": "-75.80690820",
                "type": "province",
                "cities": [
                    {
                        "id": 21809,
                        "name": "Banes",
                        "latitude": "20.96116000",
                        "longitude": "-75.72200000"
                    },
                    {
                        "id": 21821,
                        "name": "Cacocum",
                        "latitude": "20.73775000",
                        "longitude": "-76.32574000"
                    },
                    {
                        "id": 21844,
                        "name": "Cueto",
                        "latitude": "20.64855000",
                        "longitude": "-75.92967000"
                    },
                    {
                        "id": 21856,
                        "name": "Gibara",
                        "latitude": "21.10988000",
                        "longitude": "-76.13145000"
                    },
                    {
                        "id": 21868,
                        "name": "Holguín",
                        "latitude": "20.88722000",
                        "longitude": "-76.26306000"
                    },
                    {
                        "id": 21877,
                        "name": "Jobabo",
                        "latitude": "20.96917000",
                        "longitude": "-76.29944000"
                    },
                    {
                        "id": 21901,
                        "name": "Moa",
                        "latitude": "20.65776000",
                        "longitude": "-74.95075000"
                    },
                    {
                        "id": 21905,
                        "name": "Municipio de Banes",
                        "latitude": "20.98008000",
                        "longitude": "-75.74933000"
                    },
                    {
                        "id": 21918,
                        "name": "Municipio de Holguín",
                        "latitude": "20.91192000",
                        "longitude": "-76.27057000"
                    },
                    {
                        "id": 21956,
                        "name": "Sagua de Tánamo",
                        "latitude": "20.58269000",
                        "longitude": "-75.24116000"
                    },
                    {
                        "id": 21962,
                        "name": "San Germán",
                        "latitude": "20.60009000",
                        "longitude": "-76.13364000"
                    }
                ]
            },
            {
                "id": 278,
                "name": "Isla de la Juventud",
                "iso2": "99",
                "latitude": "21.70847370",
                "longitude": "-82.82202320",
                "type": "special municipality",
                "cities": [
                    {
                        "id": 21937,
                        "name": "Nueva Gerona",
                        "latitude": "21.88667000",
                        "longitude": "-82.80556000"
                    }
                ]
            },
            {
                "id": 281,
                "name": "Las Tunas",
                "iso2": "10",
                "latitude": "21.06051620",
                "longitude": "-76.91820970",
                "type": "province",
                "cities": [
                    {
                        "id": 21805,
                        "name": "Amancio",
                        "latitude": "20.81914000",
                        "longitude": "-77.57958000"
                    },
                    {
                        "id": 21837,
                        "name": "Colombia",
                        "latitude": "20.98812000",
                        "longitude": "-77.42598000"
                    },
                    {
                        "id": 21874,
                        "name": "Jesús Menéndez",
                        "latitude": "21.16139000",
                        "longitude": "-76.47919000"
                    },
                    {
                        "id": 21878,
                        "name": "Jobabo",
                        "latitude": "20.90748000",
                        "longitude": "-77.28194000"
                    },
                    {
                        "id": 21884,
                        "name": "Las Tunas",
                        "latitude": "20.96167000",
                        "longitude": "-76.95111000"
                    },
                    {
                        "id": 21890,
                        "name": "Manatí",
                        "latitude": "21.31070000",
                        "longitude": "-76.93403000"
                    },
                    {
                        "id": 21947,
                        "name": "Puerto Padre",
                        "latitude": "21.19517000",
                        "longitude": "-76.60358000"
                    }
                ]
            },
            {
                "id": 284,
                "name": "Matanzas",
                "iso2": "04",
                "latitude": "22.57671230",
                "longitude": "-81.33994140",
                "type": "province",
                "cities": [
                    {
                        "id": 21802,
                        "name": "Alacranes",
                        "latitude": "22.76719000",
                        "longitude": "-81.56803000"
                    },
                    {
                        "id": 21817,
                        "name": "Bolondrón",
                        "latitude": "22.76307000",
                        "longitude": "-81.44780000"
                    },
                    {
                        "id": 21824,
                        "name": "Calimete",
                        "latitude": "22.53420000",
                        "longitude": "-80.91105000"
                    },
                    {
                        "id": 21846,
                        "name": "Cárdenas",
                        "latitude": "23.03661000",
                        "longitude": "-81.20596000"
                    },
                    {
                        "id": 21838,
                        "name": "Colón",
                        "latitude": "22.72064000",
                        "longitude": "-80.90492000"
                    },
                    {
                        "id": 21870,
                        "name": "Jagüey Grande",
                        "latitude": "22.52694000",
                        "longitude": "-81.12861000"
                    },
                    {
                        "id": 21879,
                        "name": "Jovellanos",
                        "latitude": "22.80375000",
                        "longitude": "-81.19127000"
                    },
                    {
                        "id": 21885,
                        "name": "Limonar",
                        "latitude": "22.95035000",
                        "longitude": "-81.41059000"
                    },
                    {
                        "id": 21886,
                        "name": "Los Arabos",
                        "latitude": "22.72969000",
                        "longitude": "-80.72081000"
                    },
                    {
                        "id": 21891,
                        "name": "Manguito",
                        "latitude": "22.58733000",
                        "longitude": "-80.91451000"
                    },
                    {
                        "id": 21896,
                        "name": "Martí",
                        "latitude": "22.94714000",
                        "longitude": "-80.91902000"
                    },
                    {
                        "id": 21897,
                        "name": "Matanzas",
                        "latitude": "23.04111000",
                        "longitude": "-81.57750000"
                    },
                    {
                        "id": 21912,
                        "name": "Municipio de Cárdenas",
                        "latitude": "22.98978000",
                        "longitude": "-81.23520000"
                    },
                    {
                        "id": 21924,
                        "name": "Municipio de Matanzas",
                        "latitude": "23.05000000",
                        "longitude": "-81.58333000"
                    },
                    {
                        "id": 21941,
                        "name": "Pedro Betancourt",
                        "latitude": "22.72709000",
                        "longitude": "-81.28963000"
                    },
                    {
                        "id": 21942,
                        "name": "Perico",
                        "latitude": "22.76987000",
                        "longitude": "-81.01830000"
                    },
                    {
                        "id": 21979,
                        "name": "Unión de Reyes",
                        "latitude": "22.79505000",
                        "longitude": "-81.53617000"
                    },
                    {
                        "id": 21980,
                        "name": "Varadero",
                        "latitude": "23.15678000",
                        "longitude": "-81.24441000"
                    }
                ]
            },
            {
                "id": 276,
                "name": "Mayabeque",
                "iso2": "16",
                "latitude": "22.89265290",
                "longitude": "-81.95348150",
                "type": "province",
                "cities": [
                    {
                        "id": 21813,
                        "name": "Batabanó",
                        "latitude": "22.71794000",
                        "longitude": "-82.28965000"
                    },
                    {
                        "id": 21816,
                        "name": "Bejucal",
                        "latitude": "22.92861000",
                        "longitude": "-82.38861000"
                    },
                    {
                        "id": 21864,
                        "name": "Güines",
                        "latitude": "22.83727000",
                        "longitude": "-82.02641000"
                    },
                    {
                        "id": 21871,
                        "name": "Jamaica",
                        "latitude": "22.97559000",
                        "longitude": "-82.16852000"
                    },
                    {
                        "id": 21872,
                        "name": "Jaruco",
                        "latitude": "23.04419000",
                        "longitude": "-82.00919000"
                    },
                    {
                        "id": 21881,
                        "name": "La Salud",
                        "latitude": "22.87199000",
                        "longitude": "-82.42328000"
                    },
                    {
                        "id": 21888,
                        "name": "Madruga",
                        "latitude": "22.91000000",
                        "longitude": "-81.85639000"
                    },
                    {
                        "id": 21917,
                        "name": "Municipio de Güines",
                        "latitude": "22.78712000",
                        "longitude": "-82.01602000"
                    },
                    {
                        "id": 21925,
                        "name": "Municipio de Melena del Sur",
                        "latitude": "22.78821000",
                        "longitude": "-82.15113000"
                    },
                    {
                        "id": 21949,
                        "name": "Quivicán",
                        "latitude": "22.82313000",
                        "longitude": "-82.35558000"
                    },
                    {
                        "id": 21963,
                        "name": "San José de las Lajas",
                        "latitude": "22.96139000",
                        "longitude": "-82.15111000"
                    },
                    {
                        "id": 21967,
                        "name": "San Nicolás de Bari",
                        "latitude": "22.78444000",
                        "longitude": "-81.91333000"
                    },
                    {
                        "id": 21970,
                        "name": "Santa Cruz del Norte",
                        "latitude": "23.15424000",
                        "longitude": "-81.92556000"
                    }
                ]
            },
            {
                "id": 277,
                "name": "Pinar del Río",
                "iso2": "01",
                "latitude": "22.40762560",
                "longitude": "-83.84730150",
                "type": "province",
                "cities": [
                    {
                        "id": 21840,
                        "name": "Consolación del Sur",
                        "latitude": "22.50419000",
                        "longitude": "-83.51442000"
                    },
                    {
                        "id": 21859,
                        "name": "Guane",
                        "latitude": "22.20179000",
                        "longitude": "-84.08484000"
                    },
                    {
                        "id": 21887,
                        "name": "Los Palacios",
                        "latitude": "22.58882000",
                        "longitude": "-83.24671000"
                    },
                    {
                        "id": 21893,
                        "name": "Mantua",
                        "latitude": "22.29058000",
                        "longitude": "-84.28599000"
                    },
                    {
                        "id": 21900,
                        "name": "Minas de Matahambre",
                        "latitude": "22.58691000",
                        "longitude": "-83.94551000"
                    },
                    {
                        "id": 21911,
                        "name": "Municipio de Consolación del Sur",
                        "latitude": "22.44095000",
                        "longitude": "-83.41985000"
                    },
                    {
                        "id": 21915,
                        "name": "Municipio de Guane",
                        "latitude": "22.24591000",
                        "longitude": "-84.03660000"
                    },
                    {
                        "id": 21920,
                        "name": "Municipio de La Palma",
                        "latitude": "22.75000000",
                        "longitude": "-83.55000000"
                    },
                    {
                        "id": 21921,
                        "name": "Municipio de Los Palacios",
                        "latitude": "22.58333000",
                        "longitude": "-83.25000000"
                    },
                    {
                        "id": 21943,
                        "name": "Pinar del Río",
                        "latitude": "22.41667000",
                        "longitude": "-83.69667000"
                    },
                    {
                        "id": 21946,
                        "name": "Puerto Esperanza",
                        "latitude": "22.77041000",
                        "longitude": "-83.73138000"
                    },
                    {
                        "id": 21961,
                        "name": "San Diego de Los Baños",
                        "latitude": "22.64667000",
                        "longitude": "-83.36972000"
                    },
                    {
                        "id": 21965,
                        "name": "San Luis",
                        "latitude": "22.27898000",
                        "longitude": "-83.75956000"
                    },
                    {
                        "id": 21983,
                        "name": "Viñales",
                        "latitude": "22.61892000",
                        "longitude": "-83.70694000"
                    }
                ]
            },
            {
                "id": 274,
                "name": "Sancti Spíritus",
                "iso2": "07",
                "latitude": "21.99382140",
                "longitude": "-79.47038850",
                "type": "province",
                "cities": [
                    {
                        "id": 21819,
                        "name": "Cabaiguán",
                        "latitude": "22.07874000",
                        "longitude": "-79.49726000"
                    },
                    {
                        "id": 21839,
                        "name": "Condado",
                        "latitude": "21.87670000",
                        "longitude": "-79.84014000"
                    },
                    {
                        "id": 21855,
                        "name": "Fomento",
                        "latitude": "22.10475000",
                        "longitude": "-79.72141000"
                    },
                    {
                        "id": 21861,
                        "name": "Guayos",
                        "latitude": "22.04956000",
                        "longitude": "-79.46106000"
                    },
                    {
                        "id": 21873,
                        "name": "Jatibonico",
                        "latitude": "21.94333000",
                        "longitude": "-79.16906000"
                    },
                    {
                        "id": 21882,
                        "name": "La Sierpe",
                        "latitude": "21.77241000",
                        "longitude": "-79.26832000"
                    },
                    {
                        "id": 21908,
                        "name": "Municipio de Cabaiguán",
                        "latitude": "22.08333000",
                        "longitude": "-79.50000000"
                    },
                    {
                        "id": 21919,
                        "name": "Municipio de Jatibonico",
                        "latitude": "21.93333000",
                        "longitude": "-79.16667000"
                    },
                    {
                        "id": 21932,
                        "name": "Municipio de Sancti Spíritus",
                        "latitude": "21.82176000",
                        "longitude": "-79.51036000"
                    },
                    {
                        "id": 21935,
                        "name": "Municipio de Trinidad",
                        "latitude": "21.83195000",
                        "longitude": "-79.88362000"
                    },
                    {
                        "id": 21968,
                        "name": "Sancti Spíritus",
                        "latitude": "21.92972000",
                        "longitude": "-79.44250000"
                    },
                    {
                        "id": 21977,
                        "name": "Topes de Collantes",
                        "latitude": "21.91524000",
                        "longitude": "-80.01929000"
                    },
                    {
                        "id": 21978,
                        "name": "Trinidad",
                        "latitude": "21.80224000",
                        "longitude": "-79.98467000"
                    },
                    {
                        "id": 21984,
                        "name": "Yaguajay",
                        "latitude": "22.32691000",
                        "longitude": "-79.23567000"
                    },
                    {
                        "id": 21986,
                        "name": "Zaza del Medio",
                        "latitude": "21.99712000",
                        "longitude": "-79.36678000"
                    }
                ]
            },
            {
                "id": 273,
                "name": "Santiago de Cuba",
                "iso2": "13",
                "latitude": "20.23976820",
                "longitude": "-75.99276520",
                "type": "province",
                "cities": [
                    {
                        "id": 21841,
                        "name": "Contramaestre",
                        "latitude": "20.29879000",
                        "longitude": "-76.24511000"
                    },
                    {
                        "id": 21849,
                        "name": "El Cobre",
                        "latitude": "20.04850000",
                        "longitude": "-75.94579000"
                    },
                    {
                        "id": 21929,
                        "name": "Municipio de Palma Soriano",
                        "latitude": "20.20897000",
                        "longitude": "-76.05776000"
                    },
                    {
                        "id": 21934,
                        "name": "Municipio de Santiago de Cuba",
                        "latitude": "20.00617000",
                        "longitude": "-75.70816000"
                    },
                    {
                        "id": 21939,
                        "name": "Palma Soriano",
                        "latitude": "20.21130000",
                        "longitude": "-75.99362000"
                    },
                    {
                        "id": 21964,
                        "name": "San Luis",
                        "latitude": "20.18809000",
                        "longitude": "-75.85031000"
                    },
                    {
                        "id": 21972,
                        "name": "Santiago de Cuba",
                        "latitude": "20.02083000",
                        "longitude": "-75.82667000"
                    }
                ]
            },
            {
                "id": 280,
                "name": "Villa Clara",
                "iso2": "05",
                "latitude": "22.49372040",
                "longitude": "-79.91927020",
                "type": "province",
                "cities": [
                    {
                        "id": 21822,
                        "name": "Caibarién",
                        "latitude": "22.51996000",
                        "longitude": "-79.46599000"
                    },
                    {
                        "id": 21823,
                        "name": "Calabazar de Sagua",
                        "latitude": "22.64515000",
                        "longitude": "-79.89510000"
                    },
                    {
                        "id": 21826,
                        "name": "Camajuaní",
                        "latitude": "22.48333000",
                        "longitude": "-79.75000000"
                    },
                    {
                        "id": 21835,
                        "name": "Cifuentes",
                        "latitude": "22.64930000",
                        "longitude": "-80.04935000"
                    },
                    {
                        "id": 21842,
                        "name": "Corralillo",
                        "latitude": "22.98212000",
                        "longitude": "-80.58556000"
                    },
                    {
                        "id": 21850,
                        "name": "Encrucijada",
                        "latitude": "22.61802000",
                        "longitude": "-79.86603000"
                    },
                    {
                        "id": 21852,
                        "name": "Esperanza",
                        "latitude": "22.44680000",
                        "longitude": "-80.09711000"
                    },
                    {
                        "id": 21869,
                        "name": "Isabela de Sagua",
                        "latitude": "22.93924000",
                        "longitude": "-80.01185000"
                    },
                    {
                        "id": 21892,
                        "name": "Manicaragua",
                        "latitude": "22.15021000",
                        "longitude": "-79.97867000"
                    },
                    {
                        "id": 21930,
                        "name": "Municipio de Placetas",
                        "latitude": "22.22248000",
                        "longitude": "-79.74268000"
                    },
                    {
                        "id": 21933,
                        "name": "Municipio de Santa Clara",
                        "latitude": "22.40000000",
                        "longitude": "-79.96667000"
                    },
                    {
                        "id": 21944,
                        "name": "Placetas",
                        "latitude": "22.31184000",
                        "longitude": "-79.65440000"
                    },
                    {
                        "id": 21948,
                        "name": "Quemado de Güines",
                        "latitude": "22.78816000",
                        "longitude": "-80.25226000"
                    },
                    {
                        "id": 21950,
                        "name": "Rancho Veloz",
                        "latitude": "22.88042000",
                        "longitude": "-80.39098000"
                    },
                    {
                        "id": 21951,
                        "name": "Ranchuelo",
                        "latitude": "22.37266000",
                        "longitude": "-80.15046000"
                    },
                    {
                        "id": 21957,
                        "name": "Sagua la Grande",
                        "latitude": "22.80667000",
                        "longitude": "-80.07556000"
                    },
                    {
                        "id": 21969,
                        "name": "Santa Clara",
                        "latitude": "22.40694000",
                        "longitude": "-79.96472000"
                    },
                    {
                        "id": 21974,
                        "name": "Santo Domingo",
                        "latitude": "22.58677000",
                        "longitude": "-80.24261000"
                    }
                ]
            }
        ]
    },
    {
        "id": 249,
        "name": "Curaçao",
        "iso3": "CUW",
        "iso2": "CW",
        "numeric_code": "531",
        "phonecode": "599",
        "capital": "Willemstad",
        "currency": "ANG",
        "currency_name": "Netherlands Antillean guilder",
        "currency_symbol": "ƒ",
        "tld": ".cw",
        "native": "Curaçao",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Curacaoan",
        "timezones": [
            {
                "zoneName": "America\/Curacao",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Curaçao",
            "ko": "퀴라소",
            "pt-BR": "Curaçao",
            "pt": "Curaçao",
            "nl": "Curaçao",
            "fa": "کوراسائو",
            "de": "Curaçao",
            "fr": "Curaçao",
            "it": "Curaçao",
            "zh-CN": "库拉索",
            "tr": "Curaçao",
            "ru": "Кюрасао",
            "uk": "Кюрасао",
            "pl": "Curaçao"
        },
        "latitude": "12.11666700",
        "longitude": "-68.93333300",
        "emoji": "🇨🇼",
        "emojiU": "U+1F1E8 U+1F1FC",
        "states": []
    },
    {
        "id": 57,
        "name": "Cyprus",
        "iso3": "CYP",
        "iso2": "CY",
        "numeric_code": "196",
        "phonecode": "357",
        "capital": "Nicosia",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".cy",
        "native": "Κύπρος",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Cypriot",
        "timezones": [
            {
                "zoneName": "Asia\/Famagusta",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            },
            {
                "zoneName": "Asia\/Nicosia",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Republik Kiprenez",
            "ko": "키프로스",
            "pt-BR": "Chipre",
            "pt": "Chipre",
            "nl": "Cyprus",
            "hr": "Cipar",
            "fa": "قبرس",
            "de": "Zypern",
            "es": "Chipre",
            "fr": "Chypre",
            "ja": "キプロス",
            "it": "Cipro",
            "zh-CN": "塞浦路斯",
            "tr": "Kuzey Kıbrıs Türk Cumhuriyeti",
            "ru": "Кипр",
            "uk": "Кіпр",
            "pl": "Cypr"
        },
        "latitude": "35.00000000",
        "longitude": "33.00000000",
        "emoji": "🇨🇾",
        "emojiU": "U+1F1E8 U+1F1FE",
        "states": [
            {
                "id": 749,
                "name": "Famagusta (Mağusa)",
                "iso2": "04",
                "latitude": "35.28570230",
                "longitude": "33.84112880",
                "type": "district",
                "cities": [
                    {
                        "id": 22011,
                        "name": "Acherítou",
                        "latitude": "35.10022000",
                        "longitude": "33.86155000"
                    },
                    {
                        "id": 22102,
                        "name": "Áchna",
                        "latitude": "35.05515000",
                        "longitude": "33.78388000"
                    },
                    {
                        "id": 22014,
                        "name": "Ammochostos Municipality",
                        "latitude": "35.11755000",
                        "longitude": "33.94335000"
                    },
                    {
                        "id": 22020,
                        "name": "Avgórou",
                        "latitude": "35.03615000",
                        "longitude": "33.83918000"
                    },
                    {
                        "id": 22021,
                        "name": "Ayia Napa",
                        "latitude": "34.98213000",
                        "longitude": "34.00183000"
                    },
                    {
                        "id": 22023,
                        "name": "Derýneia",
                        "latitude": "35.06484000",
                        "longitude": "33.96083000"
                    },
                    {
                        "id": 22029,
                        "name": "Famagusta",
                        "latitude": "35.12054000",
                        "longitude": "33.93894000"
                    },
                    {
                        "id": 22030,
                        "name": "Frénaros",
                        "latitude": "35.04121000",
                        "longitude": "33.92242000"
                    },
                    {
                        "id": 22052,
                        "name": "Lefkónoiko",
                        "latitude": "35.25980000",
                        "longitude": "33.73189000"
                    },
                    {
                        "id": 22054,
                        "name": "Leonárisso",
                        "latitude": "35.46892000",
                        "longitude": "34.13886000"
                    },
                    {
                        "id": 22056,
                        "name": "Liopétri",
                        "latitude": "35.00885000",
                        "longitude": "33.89256000"
                    },
                    {
                        "id": 22072,
                        "name": "Paralímni",
                        "latitude": "35.03945000",
                        "longitude": "33.98181000"
                    },
                    {
                        "id": 22078,
                        "name": "Protaras",
                        "latitude": "35.01250000",
                        "longitude": "34.05833000"
                    },
                    {
                        "id": 22090,
                        "name": "Rizokárpaso",
                        "latitude": "35.59719000",
                        "longitude": "34.37916000"
                    },
                    {
                        "id": 22095,
                        "name": "Tríkomo",
                        "latitude": "35.28628000",
                        "longitude": "33.89167000"
                    }
                ]
            },
            {
                "id": 744,
                "name": "Kyrenia (Keryneia)",
                "iso2": "06",
                "latitude": "35.29919400",
                "longitude": "33.23632460",
                "type": "district",
                "cities": [
                    {
                        "id": 22045,
                        "name": "Kyrenia",
                        "latitude": "35.33634000",
                        "longitude": "33.31729000"
                    },
                    {
                        "id": 22046,
                        "name": "Kyrenia Municipality",
                        "latitude": "35.33672000",
                        "longitude": "33.31504000"
                    },
                    {
                        "id": 22059,
                        "name": "Lápithos",
                        "latitude": "35.33823000",
                        "longitude": "33.17368000"
                    }
                ]
            },
            {
                "id": 747,
                "name": "Larnaca (Larnaka)",
                "iso2": "03",
                "latitude": "34.85072060",
                "longitude": "33.48319060",
                "type": "district",
                "cities": [
                    {
                        "id": 22015,
                        "name": "Aradíppou",
                        "latitude": "34.95151000",
                        "longitude": "33.59199000"
                    },
                    {
                        "id": 22019,
                        "name": "Athíenou",
                        "latitude": "35.06180000",
                        "longitude": "33.54156000"
                    },
                    {
                        "id": 22024,
                        "name": "Dhromolaxia",
                        "latitude": "34.87551000",
                        "longitude": "33.58684000"
                    },
                    {
                        "id": 22049,
                        "name": "Kíti",
                        "latitude": "34.84696000",
                        "longitude": "33.57344000"
                    },
                    {
                        "id": 22039,
                        "name": "Kofínou",
                        "latitude": "34.82449000",
                        "longitude": "33.39130000"
                    },
                    {
                        "id": 22042,
                        "name": "Kolossi",
                        "latitude": "34.66865000",
                        "longitude": "32.93375000"
                    },
                    {
                        "id": 22050,
                        "name": "Kórnos",
                        "latitude": "34.92396000",
                        "longitude": "33.39764000"
                    },
                    {
                        "id": 22051,
                        "name": "Larnaca",
                        "latitude": "34.92291000",
                        "longitude": "33.62330000"
                    },
                    {
                        "id": 22057,
                        "name": "Livádia",
                        "latitude": "34.95118000",
                        "longitude": "33.62658000"
                    },
                    {
                        "id": 22062,
                        "name": "Meneou",
                        "latitude": "34.86114000",
                        "longitude": "33.59516000"
                    },
                    {
                        "id": 22064,
                        "name": "Mosfilotí",
                        "latitude": "34.95256000",
                        "longitude": "33.42511000"
                    },
                    {
                        "id": 22087,
                        "name": "Pérgamos",
                        "latitude": "35.04167000",
                        "longitude": "33.70833000"
                    },
                    {
                        "id": 22076,
                        "name": "Perivólia",
                        "latitude": "34.83355000",
                        "longitude": "33.58196000"
                    },
                    {
                        "id": 22079,
                        "name": "Psevdás",
                        "latitude": "34.94653000",
                        "longitude": "33.46277000"
                    },
                    {
                        "id": 22089,
                        "name": "Pýla",
                        "latitude": "35.01237000",
                        "longitude": "33.69188000"
                    },
                    {
                        "id": 22093,
                        "name": "Tersefánou",
                        "latitude": "34.85411000",
                        "longitude": "33.54746000"
                    },
                    {
                        "id": 22094,
                        "name": "Troúlloi",
                        "latitude": "35.03203000",
                        "longitude": "33.61501000"
                    },
                    {
                        "id": 22099,
                        "name": "Voróklini",
                        "latitude": "34.98600000",
                        "longitude": "33.65387000"
                    },
                    {
                        "id": 22100,
                        "name": "Xylofágou",
                        "latitude": "34.97743000",
                        "longitude": "33.84894000"
                    },
                    {
                        "id": 22101,
                        "name": "Xylotymbou",
                        "latitude": "35.01720000",
                        "longitude": "33.74245000"
                    }
                ]
            },
            {
                "id": 748,
                "name": "Limassol (Leymasun)",
                "iso2": "02",
                "latitude": "34.70713010",
                "longitude": "33.02261740",
                "type": "district",
                "cities": [
                    {
                        "id": 22103,
                        "name": "Ágios Tomás",
                        "latitude": "34.71158000",
                        "longitude": "32.73129000"
                    },
                    {
                        "id": 22104,
                        "name": "Ágios Týchon",
                        "latitude": "34.72606000",
                        "longitude": "33.13872000"
                    },
                    {
                        "id": 22028,
                        "name": "Erími",
                        "latitude": "34.67766000",
                        "longitude": "32.91815000"
                    },
                    {
                        "id": 22031,
                        "name": "Germasógeia",
                        "latitude": "34.72207000",
                        "longitude": "33.08254000"
                    },
                    {
                        "id": 22044,
                        "name": "Kyperoúnta",
                        "latitude": "34.93815000",
                        "longitude": "32.97551000"
                    },
                    {
                        "id": 22053,
                        "name": "Lemesós",
                        "latitude": "34.69218000",
                        "longitude": "33.02854000"
                    },
                    {
                        "id": 22055,
                        "name": "Limassol",
                        "latitude": "34.68406000",
                        "longitude": "33.03794000"
                    },
                    {
                        "id": 22065,
                        "name": "Mouttagiáka",
                        "latitude": "34.72022000",
                        "longitude": "33.10066000"
                    },
                    {
                        "id": 22082,
                        "name": "Páchna",
                        "latitude": "34.77874000",
                        "longitude": "32.79355000"
                    },
                    {
                        "id": 22084,
                        "name": "Páno Polemídia",
                        "latitude": "34.70559000",
                        "longitude": "32.99269000"
                    },
                    {
                        "id": 22073,
                        "name": "Parekklisha",
                        "latitude": "34.74583000",
                        "longitude": "33.15833000"
                    },
                    {
                        "id": 22074,
                        "name": "Peléndri",
                        "latitude": "34.89597000",
                        "longitude": "32.96817000"
                    },
                    {
                        "id": 22077,
                        "name": "Pissoúri",
                        "latitude": "34.66942000",
                        "longitude": "32.70132000"
                    },
                    {
                        "id": 22081,
                        "name": "Pyrgos",
                        "latitude": "34.74167000",
                        "longitude": "33.18333000"
                    },
                    {
                        "id": 22091,
                        "name": "Sotíra",
                        "latitude": "34.71189000",
                        "longitude": "32.86340000"
                    },
                    {
                        "id": 22092,
                        "name": "Soúni-Zanakiá",
                        "latitude": "34.73570000",
                        "longitude": "32.88437000"
                    },
                    {
                        "id": 22105,
                        "name": "Ýpsonas",
                        "latitude": "34.68797000",
                        "longitude": "32.96191000"
                    }
                ]
            },
            {
                "id": 745,
                "name": "Nicosia (Lefkoşa)",
                "iso2": "01",
                "latitude": "35.18556590",
                "longitude": "33.38227640",
                "type": "district",
                "cities": [
                    {
                        "id": 22012,
                        "name": "Akáki",
                        "latitude": "35.13341000",
                        "longitude": "33.12873000"
                    },
                    {
                        "id": 22013,
                        "name": "Alámpra",
                        "latitude": "34.98898000",
                        "longitude": "33.39887000"
                    },
                    {
                        "id": 22016,
                        "name": "Aredioú",
                        "latitude": "35.04844000",
                        "longitude": "33.19610000"
                    },
                    {
                        "id": 22018,
                        "name": "Astromerítis",
                        "latitude": "35.14096000",
                        "longitude": "33.03793000"
                    },
                    {
                        "id": 22025,
                        "name": "Dáli",
                        "latitude": "35.02294000",
                        "longitude": "33.42195000"
                    },
                    {
                        "id": 22027,
                        "name": "Ergátes",
                        "latitude": "35.05365000",
                        "longitude": "33.24292000"
                    },
                    {
                        "id": 22035,
                        "name": "Géri",
                        "latitude": "35.10560000",
                        "longitude": "33.41977000"
                    },
                    {
                        "id": 22036,
                        "name": "Kakopetriá",
                        "latitude": "34.98768000",
                        "longitude": "32.90468000"
                    },
                    {
                        "id": 22047,
                        "name": "Káto Defterá",
                        "latitude": "35.08489000",
                        "longitude": "33.27558000"
                    },
                    {
                        "id": 22048,
                        "name": "Káto Pýrgos",
                        "latitude": "35.17897000",
                        "longitude": "32.68600000"
                    },
                    {
                        "id": 22038,
                        "name": "Klírou",
                        "latitude": "35.02004000",
                        "longitude": "33.17806000"
                    },
                    {
                        "id": 22040,
                        "name": "Kokkinotrimithiá",
                        "latitude": "35.15303000",
                        "longitude": "33.19966000"
                    },
                    {
                        "id": 22060,
                        "name": "Léfka",
                        "latitude": "35.11199000",
                        "longitude": "32.84997000"
                    },
                    {
                        "id": 22061,
                        "name": "Lýmpia",
                        "latitude": "34.99889000",
                        "longitude": "33.46175000"
                    },
                    {
                        "id": 22058,
                        "name": "Lythrodóntas",
                        "latitude": "34.95105000",
                        "longitude": "33.29777000"
                    },
                    {
                        "id": 22066,
                        "name": "Mámmari",
                        "latitude": "35.17604000",
                        "longitude": "33.20435000"
                    },
                    {
                        "id": 22067,
                        "name": "Méniko",
                        "latitude": "35.10945000",
                        "longitude": "33.14474000"
                    },
                    {
                        "id": 22068,
                        "name": "Mórfou",
                        "latitude": "35.19869000",
                        "longitude": "32.99338000"
                    },
                    {
                        "id": 22069,
                        "name": "Nicosia",
                        "latitude": "35.17531000",
                        "longitude": "33.36420000"
                    },
                    {
                        "id": 22070,
                        "name": "Nicosia Municipality",
                        "latitude": "35.16944000",
                        "longitude": "33.36081000"
                    },
                    {
                        "id": 22083,
                        "name": "Páno Defterá",
                        "latitude": "35.07778000",
                        "longitude": "33.26584000"
                    },
                    {
                        "id": 22086,
                        "name": "Péra",
                        "latitude": "35.03350000",
                        "longitude": "33.25413000"
                    },
                    {
                        "id": 22075,
                        "name": "Peristeróna",
                        "latitude": "35.12928000",
                        "longitude": "33.07858000"
                    },
                    {
                        "id": 22080,
                        "name": "Psimolofou",
                        "latitude": "35.06250000",
                        "longitude": "33.26250000"
                    },
                    {
                        "id": 22097,
                        "name": "Tséri",
                        "latitude": "35.07307000",
                        "longitude": "33.32344000"
                    }
                ]
            },
            {
                "id": 746,
                "name": "Paphos (Pafos)",
                "iso2": "05",
                "latitude": "34.91645940",
                "longitude": "32.49200880",
                "type": "district",
                "cities": [
                    {
                        "id": 22017,
                        "name": "Argáka",
                        "latitude": "35.06646000",
                        "longitude": "32.49446000"
                    },
                    {
                        "id": 22022,
                        "name": "Chlórakas",
                        "latitude": "34.79768000",
                        "longitude": "32.41207000"
                    },
                    {
                        "id": 22026,
                        "name": "Emba",
                        "latitude": "34.80700000",
                        "longitude": "32.42406000"
                    },
                    {
                        "id": 22032,
                        "name": "Geroskipou",
                        "latitude": "34.75498000",
                        "longitude": "32.45155000"
                    },
                    {
                        "id": 22033,
                        "name": "Geroskípou (quarter)",
                        "latitude": "34.76190000",
                        "longitude": "32.45135000"
                    },
                    {
                        "id": 22034,
                        "name": "Geroskípou Municipality",
                        "latitude": "34.75142000",
                        "longitude": "32.45449000"
                    },
                    {
                        "id": 22037,
                        "name": "Kissonerga",
                        "latitude": "34.82279000",
                        "longitude": "32.40131000"
                    },
                    {
                        "id": 22041,
                        "name": "Koloni",
                        "latitude": "34.75228000",
                        "longitude": "32.46487000"
                    },
                    {
                        "id": 22043,
                        "name": "Konia",
                        "latitude": "34.78516000",
                        "longitude": "32.45900000"
                    },
                    {
                        "id": 22063,
                        "name": "Mesógi",
                        "latitude": "34.81577000",
                        "longitude": "32.45542000"
                    },
                    {
                        "id": 22071,
                        "name": "Paphos",
                        "latitude": "34.77679000",
                        "longitude": "32.42451000"
                    },
                    {
                        "id": 22085,
                        "name": "Pégeia",
                        "latitude": "34.88341000",
                        "longitude": "32.38166000"
                    },
                    {
                        "id": 22088,
                        "name": "Pólis",
                        "latitude": "35.03534000",
                        "longitude": "32.42575000"
                    },
                    {
                        "id": 22098,
                        "name": "Tála",
                        "latitude": "34.83745000",
                        "longitude": "32.43272000"
                    },
                    {
                        "id": 22096,
                        "name": "Tsáda",
                        "latitude": "34.83801000",
                        "longitude": "32.47547000"
                    }
                ]
            }
        ]
    },
    {
        "id": 58,
        "name": "Czech Republic",
        "iso3": "CZE",
        "iso2": "CZ",
        "numeric_code": "203",
        "phonecode": "420",
        "capital": "Prague",
        "currency": "CZK",
        "currency_name": "Czech koruna",
        "currency_symbol": "Kč",
        "tld": ".cz",
        "native": "Česká republika",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Czech",
        "timezones": [
            {
                "zoneName": "Europe\/Prague",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Tchekia",
            "ko": "체코",
            "pt-BR": "República Tcheca",
            "pt": "República Checa",
            "nl": "Tsjechië",
            "hr": "Češka",
            "fa": "جمهوری چک",
            "de": "Tschechische Republik",
            "es": "República Checa",
            "fr": "République tchèque",
            "ja": "チェコ",
            "it": "Repubblica Ceca",
            "zh-CN": "捷克",
            "tr": "Çekya",
            "ru": "Чешская Республика",
            "uk": "Чеська Республіка",
            "pl": "Republika Czeska"
        },
        "latitude": "49.75000000",
        "longitude": "15.50000000",
        "emoji": "🇨🇿",
        "emojiU": "U+1F1E8 U+1F1FF",
        "states": [
            {
                "id": 4627,
                "name": "Benešov",
                "iso2": "201",
                "latitude": "49.69008280",
                "longitude": "14.77643990",
                "type": "district",
                "cities": []
            },
            {
                "id": 4620,
                "name": "Beroun",
                "iso2": "202",
                "latitude": "49.95734280",
                "longitude": "13.98407150",
                "type": "district",
                "cities": []
            },
            {
                "id": 4615,
                "name": "Blansko",
                "iso2": "641",
                "latitude": "49.36485020",
                "longitude": "16.64775520",
                "type": "district",
                "cities": []
            },
            {
                "id": 4542,
                "name": "Břeclav",
                "iso2": "644",
                "latitude": "48.75314000",
                "longitude": "16.88251690",
                "type": "district",
                "cities": []
            },
            {
                "id": 4568,
                "name": "Brno-město",
                "iso2": "642",
                "latitude": "49.19506020",
                "longitude": "16.60683710",
                "type": "district",
                "cities": []
            },
            {
                "id": 4545,
                "name": "Brno-venkov",
                "iso2": "643",
                "latitude": "49.12501380",
                "longitude": "16.45588240",
                "type": "district",
                "cities": []
            },
            {
                "id": 4644,
                "name": "Bruntál",
                "iso2": "801",
                "latitude": "49.98817670",
                "longitude": "17.46369410",
                "type": "district",
                "cities": []
            },
            {
                "id": 4633,
                "name": "Česká Lípa",
                "iso2": "511",
                "latitude": "50.67852010",
                "longitude": "14.53969910",
                "type": "district",
                "cities": []
            },
            {
                "id": 4556,
                "name": "České Budějovice",
                "iso2": "311",
                "latitude": "48.97755530",
                "longitude": "14.51507470",
                "type": "district",
                "cities": []
            },
            {
                "id": 4543,
                "name": "Český Krumlov",
                "iso2": "312",
                "latitude": "48.81273540",
                "longitude": "14.31746570",
                "type": "district",
                "cities": []
            },
            {
                "id": 4573,
                "name": "Cheb",
                "iso2": "411",
                "latitude": "50.07953340",
                "longitude": "12.36986360",
                "type": "district",
                "cities": []
            },
            {
                "id": 4553,
                "name": "Chomutov",
                "iso2": "422",
                "latitude": "50.45838720",
                "longitude": "13.30179100",
                "type": "district",
                "cities": []
            },
            {
                "id": 4634,
                "name": "Chrudim",
                "iso2": "531",
                "latitude": "49.88302160",
                "longitude": "15.82908660",
                "type": "district",
                "cities": []
            },
            {
                "id": 4609,
                "name": "Děčín",
                "iso2": "421",
                "latitude": "50.77255630",
                "longitude": "14.21276120",
                "type": "district",
                "cities": []
            },
            {
                "id": 4641,
                "name": "Domažlice",
                "iso2": "321",
                "latitude": "49.43970270",
                "longitude": "12.93114350",
                "type": "district",
                "cities": []
            },
            {
                "id": 4559,
                "name": "Frýdek-Místek",
                "iso2": "802",
                "latitude": "49.68193050",
                "longitude": "18.36732160",
                "type": "district",
                "cities": []
            },
            {
                "id": 4611,
                "name": "Havlíčkův Brod",
                "iso2": "631",
                "latitude": "49.60433640",
                "longitude": "15.57965520",
                "type": "district",
                "cities": []
            },
            {
                "id": 4561,
                "name": "Hodonín",
                "iso2": "645",
                "latitude": "48.85293910",
                "longitude": "17.12600250",
                "type": "district",
                "cities": []
            },
            {
                "id": 4580,
                "name": "Hradec Králové",
                "iso2": "521",
                "latitude": "50.24148050",
                "longitude": "15.67430000",
                "type": "district",
                "cities": []
            },
            {
                "id": 4612,
                "name": "Jablonec nad Nisou",
                "iso2": "512",
                "latitude": "50.72205280",
                "longitude": "15.17031350",
                "type": "district",
                "cities": []
            },
            {
                "id": 4625,
                "name": "Jeseník",
                "iso2": "711",
                "latitude": "50.22462490",
                "longitude": "17.19804710",
                "type": "district",
                "cities": []
            },
            {
                "id": 4640,
                "name": "Jičín",
                "iso2": "522",
                "latitude": "50.43533250",
                "longitude": "15.36104400",
                "type": "district",
                "cities": []
            },
            {
                "id": 4613,
                "name": "Jihlava",
                "iso2": "632",
                "latitude": "49.39837820",
                "longitude": "15.58704150",
                "type": "district",
                "cities": []
            },
            {
                "id": 4639,
                "name": "Jihočeský kraj",
                "iso2": "31",
                "latitude": "48.94577890",
                "longitude": "14.44160550",
                "type": "region",
                "cities": [
                    {
                        "id": 22115,
                        "name": "Bavorov",
                        "latitude": "49.12184000",
                        "longitude": "14.07893000"
                    },
                    {
                        "id": 22118,
                        "name": "Bechyně",
                        "latitude": "49.29523000",
                        "longitude": "14.46810000"
                    },
                    {
                        "id": 22123,
                        "name": "Benešov nad Černou",
                        "latitude": "48.72940000",
                        "longitude": "14.62737000"
                    },
                    {
                        "id": 22125,
                        "name": "Bernartice",
                        "latitude": "49.36889000",
                        "longitude": "14.38101000"
                    },
                    {
                        "id": 22130,
                        "name": "Blatná",
                        "latitude": "49.42489000",
                        "longitude": "13.88176000"
                    },
                    {
                        "id": 22147,
                        "name": "Borek",
                        "latitude": "49.02339000",
                        "longitude": "14.50088000"
                    },
                    {
                        "id": 22150,
                        "name": "Borová Lada",
                        "latitude": "48.98983000",
                        "longitude": "13.65986000"
                    },
                    {
                        "id": 22149,
                        "name": "Borovany",
                        "latitude": "48.89860000",
                        "longitude": "14.64227000"
                    },
                    {
                        "id": 22164,
                        "name": "Brloh",
                        "latitude": "48.92987000",
                        "longitude": "14.21857000"
                    },
                    {
                        "id": 23388,
                        "name": "České Budějovice",
                        "latitude": "48.97447000",
                        "longitude": "14.47434000"
                    },
                    {
                        "id": 23390,
                        "name": "České Velenice",
                        "latitude": "48.76851000",
                        "longitude": "14.96368000"
                    },
                    {
                        "id": 23393,
                        "name": "Český Krumlov",
                        "latitude": "48.81091000",
                        "longitude": "14.31521000"
                    },
                    {
                        "id": 23394,
                        "name": "Český Rudolec",
                        "latitude": "49.06835000",
                        "longitude": "15.32437000"
                    },
                    {
                        "id": 22219,
                        "name": "Chlum u Třeboně",
                        "latitude": "48.96235000",
                        "longitude": "14.92799000"
                    },
                    {
                        "id": 22227,
                        "name": "Chotoviny",
                        "latitude": "49.47803000",
                        "longitude": "14.67695000"
                    },
                    {
                        "id": 22240,
                        "name": "Chvalšiny",
                        "latitude": "48.85401000",
                        "longitude": "14.21114000"
                    },
                    {
                        "id": 22243,
                        "name": "Chýnov",
                        "latitude": "49.40677000",
                        "longitude": "14.81122000"
                    },
                    {
                        "id": 22242,
                        "name": "Chyšky",
                        "latitude": "49.52346000",
                        "longitude": "14.42757000"
                    },
                    {
                        "id": 23396,
                        "name": "Čimelice",
                        "latitude": "49.46557000",
                        "longitude": "14.06922000"
                    },
                    {
                        "id": 23397,
                        "name": "Čkyně",
                        "latitude": "49.11503000",
                        "longitude": "13.82906000"
                    },
                    {
                        "id": 22252,
                        "name": "Dačice",
                        "latitude": "49.08154000",
                        "longitude": "15.43727000"
                    },
                    {
                        "id": 22277,
                        "name": "Dolní Bukovsko",
                        "latitude": "49.17086000",
                        "longitude": "14.58127000"
                    },
                    {
                        "id": 22282,
                        "name": "Dolní Dvořiště",
                        "latitude": "48.65642000",
                        "longitude": "14.45221000"
                    },
                    {
                        "id": 22324,
                        "name": "Dřiteň",
                        "latitude": "49.14280000",
                        "longitude": "14.34596000"
                    },
                    {
                        "id": 22313,
                        "name": "Dubné",
                        "latitude": "48.97619000",
                        "longitude": "14.36038000"
                    },
                    {
                        "id": 22328,
                        "name": "Frymburk",
                        "latitude": "48.66094000",
                        "longitude": "14.16564000"
                    },
                    {
                        "id": 22355,
                        "name": "Hluboká nad Vltavou",
                        "latitude": "49.05225000",
                        "longitude": "14.43427000"
                    },
                    {
                        "id": 22385,
                        "name": "Horní Planá",
                        "latitude": "48.76736000",
                        "longitude": "14.03257000"
                    },
                    {
                        "id": 22390,
                        "name": "Horní Stropnice",
                        "latitude": "48.76124000",
                        "longitude": "14.73502000"
                    },
                    {
                        "id": 22418,
                        "name": "Hrdějovice",
                        "latitude": "49.01893000",
                        "longitude": "14.47857000"
                    },
                    {
                        "id": 22436,
                        "name": "Husinec",
                        "latitude": "49.05496000",
                        "longitude": "13.98697000"
                    },
                    {
                        "id": 22460,
                        "name": "Jarošov nad Nežárkou",
                        "latitude": "49.18989000",
                        "longitude": "15.06734000"
                    },
                    {
                        "id": 22476,
                        "name": "Jindřichův Hradec",
                        "latitude": "49.14404000",
                        "longitude": "15.00301000"
                    },
                    {
                        "id": 22479,
                        "name": "Jistebnice",
                        "latitude": "49.48553000",
                        "longitude": "14.52760000"
                    },
                    {
                        "id": 22582,
                        "name": "Kájov",
                        "latitude": "48.81082000",
                        "longitude": "14.25859000"
                    },
                    {
                        "id": 22494,
                        "name": "Kamenný Újezd",
                        "latitude": "48.89753000",
                        "longitude": "14.44638000"
                    },
                    {
                        "id": 22495,
                        "name": "Kaplice",
                        "latitude": "48.73881000",
                        "longitude": "14.49449000"
                    },
                    {
                        "id": 22496,
                        "name": "Kardašova Řečice",
                        "latitude": "49.18478000",
                        "longitude": "14.85315000"
                    },
                    {
                        "id": 22503,
                        "name": "Katovice",
                        "latitude": "49.27348000",
                        "longitude": "13.83035000"
                    },
                    {
                        "id": 22545,
                        "name": "Kovářov",
                        "latitude": "49.51760000",
                        "longitude": "14.27809000"
                    },
                    {
                        "id": 22583,
                        "name": "Křemže",
                        "latitude": "48.90497000",
                        "longitude": "14.30568000"
                    },
                    {
                        "id": 22575,
                        "name": "Kunžak",
                        "latitude": "49.12119000",
                        "longitude": "15.19028000"
                    },
                    {
                        "id": 22592,
                        "name": "Ledenice",
                        "latitude": "48.93329000",
                        "longitude": "14.61886000"
                    },
                    {
                        "id": 22603,
                        "name": "Lhenice",
                        "latitude": "48.99479000",
                        "longitude": "14.14980000"
                    },
                    {
                        "id": 22627,
                        "name": "Lišov",
                        "latitude": "49.01597000",
                        "longitude": "14.60838000"
                    },
                    {
                        "id": 22626,
                        "name": "Litvínovice",
                        "latitude": "48.96207000",
                        "longitude": "14.45146000"
                    },
                    {
                        "id": 22634,
                        "name": "Lomnice nad Lužnicí",
                        "latitude": "49.08468000",
                        "longitude": "14.71727000"
                    },
                    {
                        "id": 22640,
                        "name": "Loučovice",
                        "latitude": "48.62019000",
                        "longitude": "14.25747000"
                    },
                    {
                        "id": 22670,
                        "name": "Malonty",
                        "latitude": "48.68611000",
                        "longitude": "14.57678000"
                    },
                    {
                        "id": 22674,
                        "name": "Malšice",
                        "latitude": "49.36391000",
                        "longitude": "14.57868000"
                    },
                    {
                        "id": 22689,
                        "name": "Milevsko",
                        "latitude": "49.45089000",
                        "longitude": "14.36000000"
                    },
                    {
                        "id": 22696,
                        "name": "Mirotice",
                        "latitude": "49.42908000",
                        "longitude": "14.03697000"
                    },
                    {
                        "id": 22697,
                        "name": "Mirovice",
                        "latitude": "49.51555000",
                        "longitude": "14.03582000"
                    },
                    {
                        "id": 22702,
                        "name": "Mladá Vožice",
                        "latitude": "49.53313000",
                        "longitude": "14.80857000"
                    },
                    {
                        "id": 22762,
                        "name": "Netolice",
                        "latitude": "49.04930000",
                        "longitude": "14.19700000"
                    },
                    {
                        "id": 22772,
                        "name": "Nová Bystřice",
                        "latitude": "49.01926000",
                        "longitude": "15.10316000"
                    },
                    {
                        "id": 22776,
                        "name": "Nová Včelnice",
                        "latitude": "49.23935000",
                        "longitude": "15.07260000"
                    },
                    {
                        "id": 22777,
                        "name": "Nové Hrady",
                        "latitude": "48.78963000",
                        "longitude": "14.77839000"
                    },
                    {
                        "id": 22877,
                        "name": "Okres České Budějovice",
                        "latitude": "49.00000000",
                        "longitude": "14.50000000"
                    },
                    {
                        "id": 22878,
                        "name": "Okres Český Krumlov",
                        "latitude": "48.75000000",
                        "longitude": "14.33333000"
                    },
                    {
                        "id": 22824,
                        "name": "Okres Jindřichův Hradec",
                        "latitude": "49.08333000",
                        "longitude": "15.16667000"
                    },
                    {
                        "id": 22854,
                        "name": "Okres Písek",
                        "latitude": "49.40000000",
                        "longitude": "14.20000000"
                    },
                    {
                        "id": 22850,
                        "name": "Okres Prachatice",
                        "latitude": "49.00000000",
                        "longitude": "13.86667000"
                    },
                    {
                        "id": 22862,
                        "name": "Okres Strakonice",
                        "latitude": "49.26667000",
                        "longitude": "13.90000000"
                    },
                    {
                        "id": 22867,
                        "name": "Okres Tábor",
                        "latitude": "49.41667000",
                        "longitude": "14.66667000"
                    },
                    {
                        "id": 22893,
                        "name": "Opařany",
                        "latitude": "49.39678000",
                        "longitude": "14.48137000"
                    },
                    {
                        "id": 22993,
                        "name": "Písek",
                        "latitude": "49.30880000",
                        "longitude": "14.14750000"
                    },
                    {
                        "id": 22936,
                        "name": "Planá nad Lužnicí",
                        "latitude": "49.35444000",
                        "longitude": "14.70147000"
                    },
                    {
                        "id": 22968,
                        "name": "Prachatice",
                        "latitude": "49.01292000",
                        "longitude": "13.99752000"
                    },
                    {
                        "id": 22982,
                        "name": "Protivín",
                        "latitude": "49.19949000",
                        "longitude": "14.21717000"
                    },
                    {
                        "id": 23013,
                        "name": "Radomyšl",
                        "latitude": "49.31634000",
                        "longitude": "13.93024000"
                    },
                    {
                        "id": 23049,
                        "name": "Rudolfov",
                        "latitude": "48.99339000",
                        "longitude": "14.54179000"
                    },
                    {
                        "id": 23063,
                        "name": "Sedlice",
                        "latitude": "48.77401000",
                        "longitude": "14.39115000"
                    },
                    {
                        "id": 23069,
                        "name": "Sepekov",
                        "latitude": "49.42865000",
                        "longitude": "14.41815000"
                    },
                    {
                        "id": 23414,
                        "name": "Ševětín",
                        "latitude": "49.10005000",
                        "longitude": "14.57220000"
                    },
                    {
                        "id": 23071,
                        "name": "Sezimovo Ústí",
                        "latitude": "49.38519000",
                        "longitude": "14.68480000"
                    },
                    {
                        "id": 23083,
                        "name": "Slavonice",
                        "latitude": "48.99753000",
                        "longitude": "15.35154000"
                    },
                    {
                        "id": 23092,
                        "name": "Soběslav",
                        "latitude": "49.25993000",
                        "longitude": "14.71861000"
                    },
                    {
                        "id": 23098,
                        "name": "Srubec",
                        "latitude": "48.94806000",
                        "longitude": "14.54131000"
                    },
                    {
                        "id": 23099,
                        "name": "Stachy",
                        "latitude": "49.10179000",
                        "longitude": "13.66659000"
                    },
                    {
                        "id": 23120,
                        "name": "Strakonice",
                        "latitude": "49.26141000",
                        "longitude": "13.90237000"
                    },
                    {
                        "id": 23123,
                        "name": "Strmilov",
                        "latitude": "49.15846000",
                        "longitude": "15.19934000"
                    },
                    {
                        "id": 23124,
                        "name": "Strunkovice nad Blanicí",
                        "latitude": "49.08402000",
                        "longitude": "14.05522000"
                    },
                    {
                        "id": 23133,
                        "name": "Studená",
                        "latitude": "49.18516000",
                        "longitude": "15.28688000"
                    },
                    {
                        "id": 23141,
                        "name": "Suchdol nad Lužnicí",
                        "latitude": "48.89000000",
                        "longitude": "14.87720000"
                    },
                    {
                        "id": 23189,
                        "name": "Tábor",
                        "latitude": "49.41441000",
                        "longitude": "14.65780000"
                    },
                    {
                        "id": 23200,
                        "name": "Třeboň",
                        "latitude": "49.00364000",
                        "longitude": "14.77065000"
                    },
                    {
                        "id": 23173,
                        "name": "Trhové Sviny",
                        "latitude": "48.84231000",
                        "longitude": "14.63924000"
                    },
                    {
                        "id": 23190,
                        "name": "Týn nad Vltavou",
                        "latitude": "49.22340000",
                        "longitude": "14.42057000"
                    },
                    {
                        "id": 23214,
                        "name": "Vacov",
                        "latitude": "49.13686000",
                        "longitude": "13.72911000"
                    },
                    {
                        "id": 23313,
                        "name": "Včelná",
                        "latitude": "48.92373000",
                        "longitude": "14.45383000"
                    },
                    {
                        "id": 23228,
                        "name": "Velešín",
                        "latitude": "48.82949000",
                        "longitude": "14.46252000"
                    },
                    {
                        "id": 23261,
                        "name": "Veselí nad Lužnicí",
                        "latitude": "49.18430000",
                        "longitude": "14.69734000"
                    },
                    {
                        "id": 23315,
                        "name": "Větřní",
                        "latitude": "48.77425000",
                        "longitude": "14.28616000"
                    },
                    {
                        "id": 23271,
                        "name": "Vimperk",
                        "latitude": "49.05857000",
                        "longitude": "13.78286000"
                    },
                    {
                        "id": 23279,
                        "name": "Vlachovo Březí",
                        "latitude": "49.08135000",
                        "longitude": "13.95842000"
                    },
                    {
                        "id": 23286,
                        "name": "Vodňany",
                        "latitude": "49.14789000",
                        "longitude": "14.17513000"
                    },
                    {
                        "id": 23288,
                        "name": "Volary",
                        "latitude": "48.90881000",
                        "longitude": "13.88657000"
                    },
                    {
                        "id": 23289,
                        "name": "Volyně",
                        "latitude": "49.16578000",
                        "longitude": "13.88624000"
                    },
                    {
                        "id": 23309,
                        "name": "Vyšší Brod",
                        "latitude": "48.61598000",
                        "longitude": "14.31183000"
                    },
                    {
                        "id": 23337,
                        "name": "Zdíkov",
                        "latitude": "49.08456000",
                        "longitude": "13.69738000"
                    },
                    {
                        "id": 23341,
                        "name": "Zliv",
                        "latitude": "49.06608000",
                        "longitude": "14.36613000"
                    }
                ]
            },
            {
                "id": 4602,
                "name": "Jihomoravský kraj",
                "iso2": "64",
                "latitude": "48.95445280",
                "longitude": "16.76768990",
                "type": "region",
                "cities": [
                    {
                        "id": 22107,
                        "name": "Adamov",
                        "latitude": "49.30162000",
                        "longitude": "16.65253000"
                    },
                    {
                        "id": 22196,
                        "name": "Bílovice nad Svitavou",
                        "latitude": "49.24708000",
                        "longitude": "16.67247000"
                    },
                    {
                        "id": 22129,
                        "name": "Blansko",
                        "latitude": "49.36304000",
                        "longitude": "16.64446000"
                    },
                    {
                        "id": 22131,
                        "name": "Blažovice",
                        "latitude": "49.16569000",
                        "longitude": "16.78611000"
                    },
                    {
                        "id": 22136,
                        "name": "Blížkovice",
                        "latitude": "48.99976000",
                        "longitude": "15.83482000"
                    },
                    {
                        "id": 22134,
                        "name": "Blučina",
                        "latitude": "49.05497000",
                        "longitude": "16.64450000"
                    },
                    {
                        "id": 22154,
                        "name": "Bořetice",
                        "latitude": "48.91302000",
                        "longitude": "16.85306000"
                    },
                    {
                        "id": 22155,
                        "name": "Bořitov",
                        "latitude": "49.42504000",
                        "longitude": "16.59119000"
                    },
                    {
                        "id": 22152,
                        "name": "Boskovice",
                        "latitude": "49.48751000",
                        "longitude": "16.65997000"
                    },
                    {
                        "id": 22156,
                        "name": "Bošovice",
                        "latitude": "49.05351000",
                        "longitude": "16.83676000"
                    },
                    {
                        "id": 22157,
                        "name": "Božice",
                        "latitude": "48.83687000",
                        "longitude": "16.28875000"
                    },
                    {
                        "id": 22204,
                        "name": "Břeclav",
                        "latitude": "48.75897000",
                        "longitude": "16.88203000"
                    },
                    {
                        "id": 22213,
                        "name": "Březí",
                        "latitude": "48.81928000",
                        "longitude": "16.56748000"
                    },
                    {
                        "id": 22166,
                        "name": "Brno",
                        "latitude": "49.19522000",
                        "longitude": "16.60796000"
                    },
                    {
                        "id": 22180,
                        "name": "Bučovice",
                        "latitude": "49.14896000",
                        "longitude": "17.00191000"
                    },
                    {
                        "id": 22190,
                        "name": "Bzenec",
                        "latitude": "48.97336000",
                        "longitude": "17.26685000"
                    },
                    {
                        "id": 23363,
                        "name": "Čebín",
                        "latitude": "49.31324000",
                        "longitude": "16.47791000"
                    },
                    {
                        "id": 23366,
                        "name": "Čejč",
                        "latitude": "48.94653000",
                        "longitude": "16.96511000"
                    },
                    {
                        "id": 23365,
                        "name": "Čejkovice",
                        "latitude": "48.90592000",
                        "longitude": "16.94230000"
                    },
                    {
                        "id": 23375,
                        "name": "Černá Hora",
                        "latitude": "49.41361000",
                        "longitude": "16.58140000"
                    },
                    {
                        "id": 22249,
                        "name": "Dambořice",
                        "latitude": "49.03828000",
                        "longitude": "16.91757000"
                    },
                    {
                        "id": 22267,
                        "name": "Dobšice",
                        "latitude": "48.84834000",
                        "longitude": "16.08218000"
                    },
                    {
                        "id": 22275,
                        "name": "Dolní Bojanovice",
                        "latitude": "48.85861000",
                        "longitude": "17.02859000"
                    },
                    {
                        "id": 22281,
                        "name": "Dolní Dunajovice",
                        "latitude": "48.85447000",
                        "longitude": "16.59283000"
                    },
                    {
                        "id": 22283,
                        "name": "Dolní Kounice",
                        "latitude": "49.07011000",
                        "longitude": "16.46492000"
                    },
                    {
                        "id": 22285,
                        "name": "Dolní Loućky",
                        "latitude": "49.36099000",
                        "longitude": "16.35871000"
                    },
                    {
                        "id": 22302,
                        "name": "Domanín",
                        "latitude": "49.00167000",
                        "longitude": "17.28476000"
                    },
                    {
                        "id": 22305,
                        "name": "Doubravice nad Svitavou",
                        "latitude": "49.43664000",
                        "longitude": "16.62937000"
                    },
                    {
                        "id": 22310,
                        "name": "Drásov",
                        "latitude": "49.33183000",
                        "longitude": "16.47798000"
                    },
                    {
                        "id": 22308,
                        "name": "Drnholec",
                        "latitude": "48.85746000",
                        "longitude": "16.48586000"
                    },
                    {
                        "id": 22309,
                        "name": "Drnovice",
                        "latitude": "49.27630000",
                        "longitude": "16.95146000"
                    },
                    {
                        "id": 22316,
                        "name": "Dubňany",
                        "latitude": "48.91694000",
                        "longitude": "17.09004000"
                    },
                    {
                        "id": 22350,
                        "name": "Hevlín",
                        "latitude": "48.75209000",
                        "longitude": "16.38131000"
                    },
                    {
                        "id": 22354,
                        "name": "Hlohovec",
                        "latitude": "48.77399000",
                        "longitude": "16.76230000"
                    },
                    {
                        "id": 22364,
                        "name": "Hodonice",
                        "latitude": "48.83680000",
                        "longitude": "16.16337000"
                    },
                    {
                        "id": 22365,
                        "name": "Hodonín",
                        "latitude": "48.84893000",
                        "longitude": "17.13244000"
                    },
                    {
                        "id": 22403,
                        "name": "Hostěradice",
                        "latitude": "48.95006000",
                        "longitude": "16.25931000"
                    },
                    {
                        "id": 22404,
                        "name": "Hovorany",
                        "latitude": "48.95493000",
                        "longitude": "16.99346000"
                    },
                    {
                        "id": 22424,
                        "name": "Hroznová Lhota",
                        "latitude": "48.90784000",
                        "longitude": "17.41697000"
                    },
                    {
                        "id": 22426,
                        "name": "Hrušky",
                        "latitude": "48.79272000",
                        "longitude": "16.97404000"
                    },
                    {
                        "id": 22427,
                        "name": "Hrušovany nad Jevišovkou",
                        "latitude": "48.82991000",
                        "longitude": "16.40271000"
                    },
                    {
                        "id": 22428,
                        "name": "Hrušovany u Brna",
                        "latitude": "49.03863000",
                        "longitude": "16.59429000"
                    },
                    {
                        "id": 22437,
                        "name": "Hustopeče",
                        "latitude": "48.94085000",
                        "longitude": "16.73762000"
                    },
                    {
                        "id": 22444,
                        "name": "Ivančice",
                        "latitude": "49.10144000",
                        "longitude": "16.37752000"
                    },
                    {
                        "id": 22443,
                        "name": "Ivanovice na Hané",
                        "latitude": "49.30542000",
                        "longitude": "17.09343000"
                    },
                    {
                        "id": 22459,
                        "name": "Jaroslavice",
                        "latitude": "48.75657000",
                        "longitude": "16.23351000"
                    },
                    {
                        "id": 22463,
                        "name": "Jedovnice",
                        "latitude": "49.34453000",
                        "longitude": "16.75595000"
                    },
                    {
                        "id": 22469,
                        "name": "Jevišovice",
                        "latitude": "48.98736000",
                        "longitude": "15.98992000"
                    },
                    {
                        "id": 22516,
                        "name": "Klobouky",
                        "latitude": "48.99609000",
                        "longitude": "16.86298000"
                    },
                    {
                        "id": 22520,
                        "name": "Kněždub",
                        "latitude": "48.88666000",
                        "longitude": "17.39546000"
                    },
                    {
                        "id": 22525,
                        "name": "Kobylí",
                        "latitude": "48.93286000",
                        "longitude": "16.89159000"
                    },
                    {
                        "id": 22542,
                        "name": "Kostice",
                        "latitude": "48.74685000",
                        "longitude": "16.97869000"
                    },
                    {
                        "id": 22584,
                        "name": "Křenovice",
                        "latitude": "49.14216000",
                        "longitude": "16.82932000"
                    },
                    {
                        "id": 22585,
                        "name": "Křepice",
                        "latitude": "48.99986000",
                        "longitude": "16.71989000"
                    },
                    {
                        "id": 22562,
                        "name": "Krumvíř",
                        "latitude": "48.98901000",
                        "longitude": "16.91027000"
                    },
                    {
                        "id": 22574,
                        "name": "Kunštát",
                        "latitude": "49.50645000",
                        "longitude": "16.51722000"
                    },
                    {
                        "id": 22577,
                        "name": "Kuřim",
                        "latitude": "49.29852000",
                        "longitude": "16.53144000"
                    },
                    {
                        "id": 22580,
                        "name": "Kyjov",
                        "latitude": "49.01018000",
                        "longitude": "17.12253000"
                    },
                    {
                        "id": 22591,
                        "name": "Lanžhot",
                        "latitude": "48.72443000",
                        "longitude": "16.96695000"
                    },
                    {
                        "id": 22594,
                        "name": "Lednice",
                        "latitude": "48.79992000",
                        "longitude": "16.80339000"
                    },
                    {
                        "id": 22595,
                        "name": "Lelekovice",
                        "latitude": "49.29144000",
                        "longitude": "16.57874000"
                    },
                    {
                        "id": 22598,
                        "name": "Letonice",
                        "latitude": "49.17726000",
                        "longitude": "16.95913000"
                    },
                    {
                        "id": 22599,
                        "name": "Letovice",
                        "latitude": "49.54709000",
                        "longitude": "16.57357000"
                    },
                    {
                        "id": 22618,
                        "name": "Lipov",
                        "latitude": "48.90495000",
                        "longitude": "17.46171000"
                    },
                    {
                        "id": 22619,
                        "name": "Lipovec",
                        "latitude": "49.38394000",
                        "longitude": "16.80583000"
                    },
                    {
                        "id": 22621,
                        "name": "Lipůvka",
                        "latitude": "49.33933000",
                        "longitude": "16.55313000"
                    },
                    {
                        "id": 22632,
                        "name": "Lomnice",
                        "latitude": "49.40462000",
                        "longitude": "16.41359000"
                    },
                    {
                        "id": 22636,
                        "name": "Louka",
                        "latitude": "48.91517000",
                        "longitude": "17.48927000"
                    },
                    {
                        "id": 22657,
                        "name": "Lužice",
                        "latitude": "48.84098000",
                        "longitude": "17.07104000"
                    },
                    {
                        "id": 22659,
                        "name": "Lysice",
                        "latitude": "49.45160000",
                        "longitude": "16.53716000"
                    },
                    {
                        "id": 22737,
                        "name": "Měnín",
                        "latitude": "49.08240000",
                        "longitude": "16.69424000"
                    },
                    {
                        "id": 22742,
                        "name": "Město Brno",
                        "latitude": "49.19954000",
                        "longitude": "16.60755000"
                    },
                    {
                        "id": 22688,
                        "name": "Mikulčice",
                        "latitude": "48.81643000",
                        "longitude": "17.05107000"
                    },
                    {
                        "id": 22685,
                        "name": "Mikulov",
                        "latitude": "48.80556000",
                        "longitude": "16.63780000"
                    },
                    {
                        "id": 22690,
                        "name": "Milotice",
                        "latitude": "48.95528000",
                        "longitude": "17.14241000"
                    },
                    {
                        "id": 22695,
                        "name": "Miroslav",
                        "latitude": "48.94767000",
                        "longitude": "16.31252000"
                    },
                    {
                        "id": 22709,
                        "name": "Modřice",
                        "latitude": "49.11928000",
                        "longitude": "16.60446000"
                    },
                    {
                        "id": 22712,
                        "name": "Mokrá Hora",
                        "latitude": "49.26176000",
                        "longitude": "16.59107000"
                    },
                    {
                        "id": 22715,
                        "name": "Moravany",
                        "latitude": "49.14780000",
                        "longitude": "16.58026000"
                    },
                    {
                        "id": 22717,
                        "name": "Moravská Nová Ves",
                        "latitude": "48.80304000",
                        "longitude": "17.01371000"
                    },
                    {
                        "id": 22721,
                        "name": "Moravský Krumlov",
                        "latitude": "49.04893000",
                        "longitude": "16.31169000"
                    },
                    {
                        "id": 22722,
                        "name": "Moravský Písek",
                        "latitude": "48.99016000",
                        "longitude": "17.33269000"
                    },
                    {
                        "id": 22723,
                        "name": "Moravský Žižkov",
                        "latitude": "48.83285000",
                        "longitude": "16.93140000"
                    },
                    {
                        "id": 22729,
                        "name": "Moutnice",
                        "latitude": "49.04924000",
                        "longitude": "16.73741000"
                    },
                    {
                        "id": 22733,
                        "name": "Mutěnice",
                        "latitude": "48.90413000",
                        "longitude": "17.02917000"
                    },
                    {
                        "id": 22755,
                        "name": "Nedvědice",
                        "latitude": "49.45702000",
                        "longitude": "16.33406000"
                    },
                    {
                        "id": 22761,
                        "name": "Nesovice",
                        "latitude": "49.15111000",
                        "longitude": "17.08095000"
                    },
                    {
                        "id": 22769,
                        "name": "Nosislav",
                        "latitude": "49.01380000",
                        "longitude": "16.65431000"
                    },
                    {
                        "id": 22771,
                        "name": "Novosedly",
                        "latitude": "48.83704000",
                        "longitude": "16.49273000"
                    },
                    {
                        "id": 22808,
                        "name": "Okres Blansko",
                        "latitude": "49.37399000",
                        "longitude": "16.64360000"
                    },
                    {
                        "id": 22811,
                        "name": "Okres Břeclav",
                        "latitude": "48.75958000",
                        "longitude": "16.87260000"
                    },
                    {
                        "id": 22809,
                        "name": "Okres Brno-venkov",
                        "latitude": "49.16667000",
                        "longitude": "16.50000000"
                    },
                    {
                        "id": 22819,
                        "name": "Okres Hodonín",
                        "latitude": "48.86471000",
                        "longitude": "17.13284000"
                    },
                    {
                        "id": 22871,
                        "name": "Okres Vyškov",
                        "latitude": "49.27844000",
                        "longitude": "16.99362000"
                    },
                    {
                        "id": 22873,
                        "name": "Okres Znojmo",
                        "latitude": "48.86200000",
                        "longitude": "16.06270000"
                    },
                    {
                        "id": 22883,
                        "name": "Olbramovice",
                        "latitude": "48.98480000",
                        "longitude": "16.40239000"
                    },
                    {
                        "id": 22885,
                        "name": "Olešnice",
                        "latitude": "49.55755000",
                        "longitude": "16.42169000"
                    },
                    {
                        "id": 22916,
                        "name": "Ořechov",
                        "latitude": "49.11118000",
                        "longitude": "16.52329000"
                    },
                    {
                        "id": 22901,
                        "name": "Oslavany",
                        "latitude": "49.12335000",
                        "longitude": "16.33653000"
                    },
                    {
                        "id": 22903,
                        "name": "Ostopovice",
                        "latitude": "49.16100000",
                        "longitude": "16.54548000"
                    },
                    {
                        "id": 22908,
                        "name": "Ostrov u Macochy",
                        "latitude": "49.38236000",
                        "longitude": "16.76268000"
                    },
                    {
                        "id": 22914,
                        "name": "Otnice",
                        "latitude": "49.08642000",
                        "longitude": "16.81443000"
                    },
                    {
                        "id": 22928,
                        "name": "Petrov",
                        "latitude": "48.88196000",
                        "longitude": "17.27810000"
                    },
                    {
                        "id": 22945,
                        "name": "Podivín",
                        "latitude": "48.82554000",
                        "longitude": "16.84822000"
                    },
                    {
                        "id": 22946,
                        "name": "Podolí",
                        "latitude": "49.19042000",
                        "longitude": "16.72084000"
                    },
                    {
                        "id": 22948,
                        "name": "Pohořelice",
                        "latitude": "48.98119000",
                        "longitude": "16.52445000"
                    },
                    {
                        "id": 22964,
                        "name": "Pozořice",
                        "latitude": "49.20976000",
                        "longitude": "16.79074000"
                    },
                    {
                        "id": 22997,
                        "name": "Předklášteří",
                        "latitude": "49.35253000",
                        "longitude": "16.40241000"
                    },
                    {
                        "id": 22985,
                        "name": "Prušánky",
                        "latitude": "48.82840000",
                        "longitude": "16.98068000"
                    },
                    {
                        "id": 22989,
                        "name": "Pustiměř",
                        "latitude": "49.32251000",
                        "longitude": "17.02792000"
                    },
                    {
                        "id": 23055,
                        "name": "Rájec-Jestřebí",
                        "latitude": "49.41094000",
                        "longitude": "16.63902000"
                    },
                    {
                        "id": 23056,
                        "name": "Ráječko",
                        "latitude": "49.39393000",
                        "longitude": "16.64497000"
                    },
                    {
                        "id": 23017,
                        "name": "Rajhrad",
                        "latitude": "49.09021000",
                        "longitude": "16.60388000"
                    },
                    {
                        "id": 23018,
                        "name": "Rajhradice",
                        "latitude": "49.09203000",
                        "longitude": "16.62933000"
                    },
                    {
                        "id": 23020,
                        "name": "Rakvice",
                        "latitude": "48.85811000",
                        "longitude": "16.81330000"
                    },
                    {
                        "id": 23025,
                        "name": "Ratíškovice",
                        "latitude": "48.92002000",
                        "longitude": "17.16561000"
                    },
                    {
                        "id": 23407,
                        "name": "Říčany",
                        "latitude": "49.21497000",
                        "longitude": "16.39362000"
                    },
                    {
                        "id": 23027,
                        "name": "Rohatec",
                        "latitude": "48.88040000",
                        "longitude": "17.18330000"
                    },
                    {
                        "id": 23035,
                        "name": "Rosice",
                        "latitude": "49.18232000",
                        "longitude": "16.38787000"
                    },
                    {
                        "id": 23039,
                        "name": "Rousínov",
                        "latitude": "49.20128000",
                        "longitude": "16.88215000"
                    },
                    {
                        "id": 23408,
                        "name": "Šakvice",
                        "latitude": "48.89746000",
                        "longitude": "16.71424000"
                    },
                    {
                        "id": 23409,
                        "name": "Šanov",
                        "latitude": "48.80089000",
                        "longitude": "16.37858000"
                    },
                    {
                        "id": 23410,
                        "name": "Šardice",
                        "latitude": "48.96403000",
                        "longitude": "17.02812000"
                    },
                    {
                        "id": 23411,
                        "name": "Šatov",
                        "latitude": "48.79317000",
                        "longitude": "16.00992000"
                    },
                    {
                        "id": 23416,
                        "name": "Šitbořice",
                        "latitude": "49.01433000",
                        "longitude": "16.77975000"
                    },
                    {
                        "id": 23417,
                        "name": "Šlapanice",
                        "latitude": "49.16863000",
                        "longitude": "16.72731000"
                    },
                    {
                        "id": 23082,
                        "name": "Slavkov u Brna",
                        "latitude": "49.15325000",
                        "longitude": "16.87649000"
                    },
                    {
                        "id": 23093,
                        "name": "Sokolnice",
                        "latitude": "49.11392000",
                        "longitude": "16.72156000"
                    },
                    {
                        "id": 23129,
                        "name": "Strážnice",
                        "latitude": "48.90102000",
                        "longitude": "17.31680000"
                    },
                    {
                        "id": 23137,
                        "name": "Střelice",
                        "latitude": "49.15221000",
                        "longitude": "16.50399000"
                    },
                    {
                        "id": 23142,
                        "name": "Suchohrdly",
                        "latitude": "48.86822000",
                        "longitude": "16.09471000"
                    },
                    {
                        "id": 23145,
                        "name": "Sudoměřice",
                        "latitude": "48.86723000",
                        "longitude": "17.25676000"
                    },
                    {
                        "id": 23150,
                        "name": "Svitávka",
                        "latitude": "49.50178000",
                        "longitude": "16.59793000"
                    },
                    {
                        "id": 23157,
                        "name": "Tasovice",
                        "latitude": "48.83610000",
                        "longitude": "16.15558000"
                    },
                    {
                        "id": 23158,
                        "name": "Telnice",
                        "latitude": "49.10187000",
                        "longitude": "16.71774000"
                    },
                    {
                        "id": 23195,
                        "name": "Těšany",
                        "latitude": "49.03956000",
                        "longitude": "16.77003000"
                    },
                    {
                        "id": 23166,
                        "name": "Tišnov",
                        "latitude": "49.34872000",
                        "longitude": "16.42438000"
                    },
                    {
                        "id": 23180,
                        "name": "Troubsko",
                        "latitude": "49.16951000",
                        "longitude": "16.51078000"
                    },
                    {
                        "id": 23187,
                        "name": "Tvarožná",
                        "latitude": "49.19177000",
                        "longitude": "16.77146000"
                    },
                    {
                        "id": 23188,
                        "name": "Tvrdonice",
                        "latitude": "48.76048000",
                        "longitude": "16.99446000"
                    },
                    {
                        "id": 23191,
                        "name": "Týnec",
                        "latitude": "48.77943000",
                        "longitude": "17.01322000"
                    },
                    {
                        "id": 23356,
                        "name": "Únanov",
                        "latitude": "48.90082000",
                        "longitude": "16.06351000"
                    },
                    {
                        "id": 23213,
                        "name": "Vacenovice",
                        "latitude": "48.94510000",
                        "longitude": "17.17404000"
                    },
                    {
                        "id": 23221,
                        "name": "Valtice",
                        "latitude": "48.74069000",
                        "longitude": "16.75499000"
                    },
                    {
                        "id": 23235,
                        "name": "Velká nad Veličkou",
                        "latitude": "48.88257000",
                        "longitude": "17.52060000"
                    },
                    {
                        "id": 23236,
                        "name": "Velké Bílovice",
                        "latitude": "48.84929000",
                        "longitude": "16.89227000"
                    },
                    {
                        "id": 23244,
                        "name": "Velké Němčice",
                        "latitude": "48.99168000",
                        "longitude": "16.67208000"
                    },
                    {
                        "id": 23245,
                        "name": "Velké Opatovice",
                        "latitude": "49.61237000",
                        "longitude": "16.67947000"
                    },
                    {
                        "id": 23246,
                        "name": "Velké Pavlovice",
                        "latitude": "48.90469000",
                        "longitude": "16.81605000"
                    },
                    {
                        "id": 23262,
                        "name": "Veselí nad Moravou",
                        "latitude": "48.95363000",
                        "longitude": "17.37648000"
                    },
                    {
                        "id": 23264,
                        "name": "Veverská Bítýška",
                        "latitude": "49.27591000",
                        "longitude": "16.43686000"
                    },
                    {
                        "id": 23273,
                        "name": "Viničné Šumice",
                        "latitude": "49.21358000",
                        "longitude": "16.82541000"
                    },
                    {
                        "id": 23277,
                        "name": "Višňové",
                        "latitude": "48.98241000",
                        "longitude": "16.15025000"
                    },
                    {
                        "id": 23282,
                        "name": "Vlkoš",
                        "latitude": "48.98960000",
                        "longitude": "17.16356000"
                    },
                    {
                        "id": 23285,
                        "name": "Vnorovy",
                        "latitude": "48.93096000",
                        "longitude": "17.35050000"
                    },
                    {
                        "id": 23287,
                        "name": "Vojkovice",
                        "latitude": "49.05138000",
                        "longitude": "16.60820000"
                    },
                    {
                        "id": 23291,
                        "name": "Vracov",
                        "latitude": "48.97523000",
                        "longitude": "17.21100000"
                    },
                    {
                        "id": 23292,
                        "name": "Vranovice",
                        "latitude": "48.96600000",
                        "longitude": "16.60660000"
                    },
                    {
                        "id": 23295,
                        "name": "Vrbice",
                        "latitude": "48.91508000",
                        "longitude": "16.89779000"
                    },
                    {
                        "id": 23298,
                        "name": "Vrbovec",
                        "latitude": "48.79978000",
                        "longitude": "16.10061000"
                    },
                    {
                        "id": 23308,
                        "name": "Vyškov",
                        "latitude": "49.27747000",
                        "longitude": "16.99897000"
                    },
                    {
                        "id": 23435,
                        "name": "Žabčice",
                        "latitude": "49.01160000",
                        "longitude": "16.60257000"
                    },
                    {
                        "id": 23325,
                        "name": "Zaječí",
                        "latitude": "48.87295000",
                        "longitude": "16.76646000"
                    },
                    {
                        "id": 23326,
                        "name": "Zastávka",
                        "latitude": "49.18800000",
                        "longitude": "16.36310000"
                    },
                    {
                        "id": 23330,
                        "name": "Zbraslav",
                        "latitude": "49.22155000",
                        "longitude": "16.29415000"
                    },
                    {
                        "id": 23332,
                        "name": "Zbýšov",
                        "latitude": "49.15524000",
                        "longitude": "16.34951000"
                    },
                    {
                        "id": 23440,
                        "name": "Ždánice",
                        "latitude": "49.06729000",
                        "longitude": "17.02751000"
                    },
                    {
                        "id": 23446,
                        "name": "Želešice",
                        "latitude": "49.11689000",
                        "longitude": "16.58137000"
                    },
                    {
                        "id": 23448,
                        "name": "Žeravice",
                        "latitude": "49.02288000",
                        "longitude": "17.23726000"
                    },
                    {
                        "id": 23449,
                        "name": "Židlochovice",
                        "latitude": "49.03952000",
                        "longitude": "16.61881000"
                    },
                    {
                        "id": 23344,
                        "name": "Znojmo",
                        "latitude": "48.85550000",
                        "longitude": "16.04880000"
                    }
                ]
            },
            {
                "id": 4624,
                "name": "Jindřichův Hradec",
                "iso2": "313",
                "latitude": "49.14448230",
                "longitude": "15.00613890",
                "type": "district",
                "cities": []
            },
            {
                "id": 4581,
                "name": "Karlovarský kraj",
                "iso2": "41",
                "latitude": "50.17441990",
                "longitude": "12.03823730",
                "type": "region",
                "cities": [
                    {
                        "id": 22106,
                        "name": "Abertamy",
                        "latitude": "50.36874000",
                        "longitude": "12.81826000"
                    },
                    {
                        "id": 22110,
                        "name": "Aš",
                        "latitude": "50.22387000",
                        "longitude": "12.19499000"
                    },
                    {
                        "id": 22137,
                        "name": "Bochov",
                        "latitude": "50.14872000",
                        "longitude": "13.05227000"
                    },
                    {
                        "id": 22209,
                        "name": "Březová",
                        "latitude": "50.14557000",
                        "longitude": "12.64996000"
                    },
                    {
                        "id": 22178,
                        "name": "Bukovany",
                        "latitude": "50.16632000",
                        "longitude": "12.57265000"
                    },
                    {
                        "id": 22217,
                        "name": "Cheb",
                        "latitude": "50.07963000",
                        "longitude": "12.37392000"
                    },
                    {
                        "id": 22224,
                        "name": "Chodov",
                        "latitude": "50.24018000",
                        "longitude": "12.74551000"
                    },
                    {
                        "id": 22248,
                        "name": "Dalovice",
                        "latitude": "50.24779000",
                        "longitude": "12.89581000"
                    },
                    {
                        "id": 22292,
                        "name": "Dolní Rychnov",
                        "latitude": "50.16462000",
                        "longitude": "12.64507000"
                    },
                    {
                        "id": 22299,
                        "name": "Dolní Žandov",
                        "latitude": "50.01794000",
                        "longitude": "12.55101000"
                    },
                    {
                        "id": 22326,
                        "name": "Františkovy Lázně",
                        "latitude": "50.12033000",
                        "longitude": "12.35174000"
                    },
                    {
                        "id": 22337,
                        "name": "Habartov",
                        "latitude": "50.18297000",
                        "longitude": "12.55054000"
                    },
                    {
                        "id": 22346,
                        "name": "Hazlov",
                        "latitude": "50.15634000",
                        "longitude": "12.27238000"
                    },
                    {
                        "id": 22388,
                        "name": "Horní Slavkov",
                        "latitude": "50.13863000",
                        "longitude": "12.80758000"
                    },
                    {
                        "id": 22416,
                        "name": "Hranice",
                        "latitude": "50.30459000",
                        "longitude": "12.17577000"
                    },
                    {
                        "id": 22425,
                        "name": "Hroznětín",
                        "latitude": "50.30940000",
                        "longitude": "12.87180000"
                    },
                    {
                        "id": 22484,
                        "name": "Jáchymov",
                        "latitude": "50.35846000",
                        "longitude": "12.93465000"
                    },
                    {
                        "id": 22498,
                        "name": "Karlovy Vary",
                        "latitude": "50.23271000",
                        "longitude": "12.87117000"
                    },
                    {
                        "id": 22518,
                        "name": "Klášter",
                        "latitude": "49.96762000",
                        "longitude": "12.87623000"
                    },
                    {
                        "id": 22556,
                        "name": "Kraslice",
                        "latitude": "50.32372000",
                        "longitude": "12.51747000"
                    },
                    {
                        "id": 22581,
                        "name": "Kynšperk nad Ohří",
                        "latitude": "50.11893000",
                        "longitude": "12.53027000"
                    },
                    {
                        "id": 22664,
                        "name": "Lázně Kynžvart",
                        "latitude": "50.01058000",
                        "longitude": "12.62474000"
                    },
                    {
                        "id": 22630,
                        "name": "Loket",
                        "latitude": "50.18600000",
                        "longitude": "12.75405000"
                    },
                    {
                        "id": 22633,
                        "name": "Lomnice",
                        "latitude": "50.21174000",
                        "longitude": "12.63267000"
                    },
                    {
                        "id": 22644,
                        "name": "Luby",
                        "latitude": "50.25248000",
                        "longitude": "12.40595000"
                    },
                    {
                        "id": 22676,
                        "name": "Mariánské Lázně",
                        "latitude": "49.96459000",
                        "longitude": "12.70118000"
                    },
                    {
                        "id": 22681,
                        "name": "Merklín",
                        "latitude": "50.32808000",
                        "longitude": "12.86350000"
                    },
                    {
                        "id": 22740,
                        "name": "Město",
                        "latitude": "49.97997000",
                        "longitude": "12.86432000"
                    },
                    {
                        "id": 22757,
                        "name": "Nejdek",
                        "latitude": "50.32242000",
                        "longitude": "12.72936000"
                    },
                    {
                        "id": 22775,
                        "name": "Nová Role",
                        "latitude": "50.27092000",
                        "longitude": "12.78422000"
                    },
                    {
                        "id": 22781,
                        "name": "Nové Sedlo",
                        "latitude": "50.20647000",
                        "longitude": "12.73800000"
                    },
                    {
                        "id": 22812,
                        "name": "Okres Cheb",
                        "latitude": "50.08333000",
                        "longitude": "12.50000000"
                    },
                    {
                        "id": 22826,
                        "name": "Okres Karlovy Vary",
                        "latitude": "50.16667000",
                        "longitude": "13.00000000"
                    },
                    {
                        "id": 22861,
                        "name": "Okres Sokolov",
                        "latitude": "50.21667000",
                        "longitude": "12.63333000"
                    },
                    {
                        "id": 22887,
                        "name": "Oloví",
                        "latitude": "50.25113000",
                        "longitude": "12.55877000"
                    },
                    {
                        "id": 22907,
                        "name": "Ostrov",
                        "latitude": "50.30592000",
                        "longitude": "12.93907000"
                    },
                    {
                        "id": 22940,
                        "name": "Plesná",
                        "latitude": "50.22070000",
                        "longitude": "12.34669000"
                    },
                    {
                        "id": 23036,
                        "name": "Rotava",
                        "latitude": "50.29627000",
                        "longitude": "12.57341000"
                    },
                    {
                        "id": 23058,
                        "name": "Sadov",
                        "latitude": "50.26711000",
                        "longitude": "12.89708000"
                    },
                    {
                        "id": 23073,
                        "name": "Skalná",
                        "latitude": "50.17030000",
                        "longitude": "12.36144000"
                    },
                    {
                        "id": 23094,
                        "name": "Sokolov",
                        "latitude": "50.18130000",
                        "longitude": "12.64010000"
                    },
                    {
                        "id": 23147,
                        "name": "Svatava",
                        "latitude": "50.19223000",
                        "longitude": "12.62524000"
                    },
                    {
                        "id": 23170,
                        "name": "Toužim",
                        "latitude": "50.06049000",
                        "longitude": "12.98506000"
                    },
                    {
                        "id": 23233,
                        "name": "Velká Hleďsebe",
                        "latitude": "49.96151000",
                        "longitude": "12.66763000"
                    },
                    {
                        "id": 23274,
                        "name": "Vintířov",
                        "latitude": "50.23382000",
                        "longitude": "12.71748000"
                    },
                    {
                        "id": 23456,
                        "name": "Žlutice",
                        "latitude": "50.09192000",
                        "longitude": "13.16297000"
                    }
                ]
            },
            {
                "id": 4604,
                "name": "Karlovy Vary",
                "iso2": "412",
                "latitude": "50.21254520",
                "longitude": "12.31223110",
                "type": "district",
                "cities": []
            },
            {
                "id": 4586,
                "name": "Karviná",
                "iso2": "803",
                "latitude": "49.85665240",
                "longitude": "18.54321860",
                "type": "district",
                "cities": []
            },
            {
                "id": 4631,
                "name": "Kladno",
                "iso2": "203",
                "latitude": "50.19402580",
                "longitude": "14.10436570",
                "type": "district",
                "cities": []
            },
            {
                "id": 4591,
                "name": "Klatovy",
                "iso2": "322",
                "latitude": "49.39555490",
                "longitude": "13.29509370",
                "type": "district",
                "cities": []
            },
            {
                "id": 4618,
                "name": "Kolín",
                "iso2": "204",
                "latitude": "49.98832930",
                "longitude": "15.05519770",
                "type": "district",
                "cities": []
            },
            {
                "id": 4575,
                "name": "Kraj Vysočina",
                "iso2": "63",
                "latitude": "49.44900520",
                "longitude": "15.64059340",
                "type": "region",
                "cities": [
                    {
                        "id": 22114,
                        "name": "Batelov",
                        "latitude": "49.31425000",
                        "longitude": "15.39465000"
                    },
                    {
                        "id": 22138,
                        "name": "Bohdalov",
                        "latitude": "49.47921000",
                        "longitude": "15.87582000"
                    },
                    {
                        "id": 22170,
                        "name": "Brtnice",
                        "latitude": "49.30695000",
                        "longitude": "15.67642000"
                    },
                    {
                        "id": 22175,
                        "name": "Budišov",
                        "latitude": "49.27138000",
                        "longitude": "16.00383000"
                    },
                    {
                        "id": 22187,
                        "name": "Bystřice nad Pernštejnem",
                        "latitude": "49.52295000",
                        "longitude": "16.26147000"
                    },
                    {
                        "id": 23371,
                        "name": "Černovice",
                        "latitude": "49.37265000",
                        "longitude": "14.96089000"
                    },
                    {
                        "id": 22228,
                        "name": "Chotěboř",
                        "latitude": "49.72072000",
                        "longitude": "15.67018000"
                    },
                    {
                        "id": 22259,
                        "name": "Dobronín",
                        "latitude": "49.47833000",
                        "longitude": "15.64992000"
                    },
                    {
                        "id": 22279,
                        "name": "Dolní Cerekev",
                        "latitude": "49.34449000",
                        "longitude": "15.45655000"
                    },
                    {
                        "id": 22335,
                        "name": "Golčův Jeníkov",
                        "latitude": "49.81626000",
                        "longitude": "15.47686000"
                    },
                    {
                        "id": 22338,
                        "name": "Habry",
                        "latitude": "49.75603000",
                        "longitude": "15.48486000"
                    },
                    {
                        "id": 22344,
                        "name": "Havlíčkův Brod",
                        "latitude": "49.60690000",
                        "longitude": "15.57937000"
                    },
                    {
                        "id": 22349,
                        "name": "Herálec",
                        "latitude": "49.68891000",
                        "longitude": "15.99431000"
                    },
                    {
                        "id": 22379,
                        "name": "Horní Cerekev",
                        "latitude": "49.32026000",
                        "longitude": "15.32769000"
                    },
                    {
                        "id": 22423,
                        "name": "Hrotovice",
                        "latitude": "49.10770000",
                        "longitude": "16.06067000"
                    },
                    {
                        "id": 22435,
                        "name": "Humpolec",
                        "latitude": "49.54152000",
                        "longitude": "15.35932000"
                    },
                    {
                        "id": 22458,
                        "name": "Jaroměřice nad Rokytnou",
                        "latitude": "49.09408000",
                        "longitude": "15.89331000"
                    },
                    {
                        "id": 22464,
                        "name": "Jemnice",
                        "latitude": "49.01898000",
                        "longitude": "15.56994000"
                    },
                    {
                        "id": 22471,
                        "name": "Jihlava",
                        "latitude": "49.39610000",
                        "longitude": "15.59124000"
                    },
                    {
                        "id": 22473,
                        "name": "Jimramov",
                        "latitude": "49.63719000",
                        "longitude": "16.22632000"
                    },
                    {
                        "id": 22488,
                        "name": "Kamenice",
                        "latitude": "49.36659000",
                        "longitude": "15.78023000"
                    },
                    {
                        "id": 22490,
                        "name": "Kamenice nad Lipou",
                        "latitude": "49.30303000",
                        "longitude": "15.07519000"
                    },
                    {
                        "id": 22521,
                        "name": "Kněžice",
                        "latitude": "49.27078000",
                        "longitude": "15.67216000"
                    },
                    {
                        "id": 22588,
                        "name": "Křižanov",
                        "latitude": "49.38858000",
                        "longitude": "16.10960000"
                    },
                    {
                        "id": 22589,
                        "name": "Křížová",
                        "latitude": "49.68841000",
                        "longitude": "15.85207000"
                    },
                    {
                        "id": 22593,
                        "name": "Ledeč nad Sázavou",
                        "latitude": "49.69517000",
                        "longitude": "15.27772000"
                    },
                    {
                        "id": 22667,
                        "name": "Lípa",
                        "latitude": "49.55418000",
                        "longitude": "15.54465000"
                    },
                    {
                        "id": 22647,
                        "name": "Luka nad Jihlavou",
                        "latitude": "49.37403000",
                        "longitude": "15.70194000"
                    },
                    {
                        "id": 22648,
                        "name": "Lukavec",
                        "latitude": "49.56541000",
                        "longitude": "14.99041000"
                    },
                    {
                        "id": 22746,
                        "name": "Měřín",
                        "latitude": "49.39321000",
                        "longitude": "15.88381000"
                    },
                    {
                        "id": 22711,
                        "name": "Mohelno",
                        "latitude": "49.11412000",
                        "longitude": "16.19022000"
                    },
                    {
                        "id": 22719,
                        "name": "Moravské Budějovice",
                        "latitude": "49.05209000",
                        "longitude": "15.80864000"
                    },
                    {
                        "id": 22795,
                        "name": "Náměšť nad Oslavou",
                        "latitude": "49.20726000",
                        "longitude": "16.15849000"
                    },
                    {
                        "id": 22773,
                        "name": "Nová Cerekev",
                        "latitude": "49.41723000",
                        "longitude": "15.11675000"
                    },
                    {
                        "id": 22778,
                        "name": "Nové Město na Moravě",
                        "latitude": "49.56144000",
                        "longitude": "16.07418000"
                    },
                    {
                        "id": 22783,
                        "name": "Nové Syrovice",
                        "latitude": "49.01763000",
                        "longitude": "15.77345000"
                    },
                    {
                        "id": 22784,
                        "name": "Nové Veselí",
                        "latitude": "49.51976000",
                        "longitude": "15.90853000"
                    },
                    {
                        "id": 22818,
                        "name": "Okres Havlíčkův Brod",
                        "latitude": "49.66667000",
                        "longitude": "15.58333000"
                    },
                    {
                        "id": 22823,
                        "name": "Okres Jihlava",
                        "latitude": "49.33333000",
                        "longitude": "15.58333000"
                    },
                    {
                        "id": 22846,
                        "name": "Okres Pelhřimov",
                        "latitude": "49.41667000",
                        "longitude": "15.16667000"
                    },
                    {
                        "id": 22868,
                        "name": "Okres Třebíč",
                        "latitude": "49.13333000",
                        "longitude": "15.93333000"
                    },
                    {
                        "id": 22880,
                        "name": "Okres Žďár nad Sázavou",
                        "latitude": "49.50000000",
                        "longitude": "16.03333000"
                    },
                    {
                        "id": 22882,
                        "name": "Okříšky",
                        "latitude": "49.24539000",
                        "longitude": "15.76959000"
                    },
                    {
                        "id": 22881,
                        "name": "Okrouhlice",
                        "latitude": "49.62991000",
                        "longitude": "15.49083000"
                    },
                    {
                        "id": 22917,
                        "name": "Pacov",
                        "latitude": "49.47076000",
                        "longitude": "15.00168000"
                    },
                    {
                        "id": 22925,
                        "name": "Pelhřimov",
                        "latitude": "49.43134000",
                        "longitude": "15.22336000"
                    },
                    {
                        "id": 22965,
                        "name": "Počátky",
                        "latitude": "49.26020000",
                        "longitude": "15.24022000"
                    },
                    {
                        "id": 22953,
                        "name": "Polná",
                        "latitude": "49.48700000",
                        "longitude": "15.71881000"
                    },
                    {
                        "id": 23004,
                        "name": "Přibyslav",
                        "latitude": "49.57684000",
                        "longitude": "15.73855000"
                    },
                    {
                        "id": 23037,
                        "name": "Rouchovany",
                        "latitude": "49.07036000",
                        "longitude": "16.10760000"
                    },
                    {
                        "id": 23115,
                        "name": "Stařeč",
                        "latitude": "49.19783000",
                        "longitude": "15.82791000"
                    },
                    {
                        "id": 23421,
                        "name": "Štoky",
                        "latitude": "49.50249000",
                        "longitude": "15.58863000"
                    },
                    {
                        "id": 23153,
                        "name": "Světlá nad Sázavou",
                        "latitude": "49.66801000",
                        "longitude": "15.40393000"
                    },
                    {
                        "id": 23152,
                        "name": "Svratka",
                        "latitude": "49.71066000",
                        "longitude": "16.03214000"
                    },
                    {
                        "id": 23159,
                        "name": "Telč",
                        "latitude": "49.18418000",
                        "longitude": "15.45275000"
                    },
                    {
                        "id": 23201,
                        "name": "Třebíč",
                        "latitude": "49.21492000",
                        "longitude": "15.88166000"
                    },
                    {
                        "id": 23204,
                        "name": "Třešť",
                        "latitude": "49.29092000",
                        "longitude": "15.48211000"
                    },
                    {
                        "id": 23231,
                        "name": "Velká Bíteš",
                        "latitude": "49.28838000",
                        "longitude": "16.22742000"
                    },
                    {
                        "id": 23243,
                        "name": "Velké Meziříčí",
                        "latitude": "49.35522000",
                        "longitude": "16.01224000"
                    },
                    {
                        "id": 23251,
                        "name": "Velký Beranov",
                        "latitude": "49.40504000",
                        "longitude": "15.66700000"
                    },
                    {
                        "id": 23270,
                        "name": "Vilémov",
                        "latitude": "49.81566000",
                        "longitude": "15.53584000"
                    },
                    {
                        "id": 23280,
                        "name": "Vladislav",
                        "latitude": "49.21017000",
                        "longitude": "15.98830000"
                    },
                    {
                        "id": 23459,
                        "name": "Žďár nad Sázavou",
                        "latitude": "49.56263000",
                        "longitude": "15.93924000"
                    },
                    {
                        "id": 23460,
                        "name": "Žďár nad Sázavou Druhy",
                        "latitude": "49.58726000",
                        "longitude": "15.93215000"
                    },
                    {
                        "id": 23442,
                        "name": "Želetava",
                        "latitude": "49.14187000",
                        "longitude": "15.67300000"
                    },
                    {
                        "id": 23447,
                        "name": "Želiv",
                        "latitude": "49.52984000",
                        "longitude": "15.22181000"
                    },
                    {
                        "id": 23451,
                        "name": "Žirovnice",
                        "latitude": "49.25318000",
                        "longitude": "15.18824000"
                    }
                ]
            },
            {
                "id": 4614,
                "name": "Královéhradecký kraj",
                "iso2": "52",
                "latitude": "50.35124840",
                "longitude": "15.79764590",
                "type": "region",
                "cities": [
                    {
                        "id": 22109,
                        "name": "Albrechtice nad Orlicí",
                        "latitude": "50.13979000",
                        "longitude": "16.06437000"
                    },
                    {
                        "id": 22198,
                        "name": "Bílá Třemešná",
                        "latitude": "50.44465000",
                        "longitude": "15.74101000"
                    },
                    {
                        "id": 22148,
                        "name": "Borohrádek",
                        "latitude": "50.09777000",
                        "longitude": "16.09326000"
                    },
                    {
                        "id": 22169,
                        "name": "Broumov",
                        "latitude": "50.58566000",
                        "longitude": "16.33181000"
                    },
                    {
                        "id": 23362,
                        "name": "Častolovice",
                        "latitude": "50.12910000",
                        "longitude": "16.18128000"
                    },
                    {
                        "id": 23370,
                        "name": "Černilov",
                        "latitude": "50.26265000",
                        "longitude": "15.92254000"
                    },
                    {
                        "id": 23374,
                        "name": "Černožice",
                        "latitude": "50.31863000",
                        "longitude": "15.87403000"
                    },
                    {
                        "id": 23381,
                        "name": "Červený Kostelec",
                        "latitude": "50.47626000",
                        "longitude": "16.09289000"
                    },
                    {
                        "id": 23385,
                        "name": "Česká Skalice",
                        "latitude": "50.39467000",
                        "longitude": "16.04276000"
                    },
                    {
                        "id": 23389,
                        "name": "České Meziříčí",
                        "latitude": "50.28680000",
                        "longitude": "16.04428000"
                    },
                    {
                        "id": 22221,
                        "name": "Chlumec nad Cidlinou",
                        "latitude": "50.15440000",
                        "longitude": "15.46026000"
                    },
                    {
                        "id": 22261,
                        "name": "Dobruška",
                        "latitude": "50.29201000",
                        "longitude": "16.16001000"
                    },
                    {
                        "id": 22298,
                        "name": "Dolní Černilov",
                        "latitude": "50.26110000",
                        "longitude": "15.96107000"
                    },
                    {
                        "id": 22306,
                        "name": "Doudleby nad Orlicí",
                        "latitude": "50.10742000",
                        "longitude": "16.26131000"
                    },
                    {
                        "id": 22319,
                        "name": "Dvůr Králové nad Labem",
                        "latitude": "50.43172000",
                        "longitude": "15.81402000"
                    },
                    {
                        "id": 22407,
                        "name": "Hořice",
                        "latitude": "50.36609000",
                        "longitude": "15.63183000"
                    },
                    {
                        "id": 22398,
                        "name": "Hostinné",
                        "latitude": "50.54066000",
                        "longitude": "15.72334000"
                    },
                    {
                        "id": 22412,
                        "name": "Hradec Králové",
                        "latitude": "50.20923000",
                        "longitude": "15.83277000"
                    },
                    {
                        "id": 22422,
                        "name": "Hronov",
                        "latitude": "50.47968000",
                        "longitude": "16.18230000"
                    },
                    {
                        "id": 22456,
                        "name": "Jaroměř",
                        "latitude": "50.35620000",
                        "longitude": "15.92136000"
                    },
                    {
                        "id": 22481,
                        "name": "Jičín",
                        "latitude": "50.43723000",
                        "longitude": "15.35162000"
                    },
                    {
                        "id": 22533,
                        "name": "Kopidlno",
                        "latitude": "50.33085000",
                        "longitude": "15.27029000"
                    },
                    {
                        "id": 22540,
                        "name": "Kostelec nad Orlicí",
                        "latitude": "50.12267000",
                        "longitude": "16.21319000"
                    },
                    {
                        "id": 22579,
                        "name": "Kvasiny",
                        "latitude": "50.21250000",
                        "longitude": "16.26323000"
                    },
                    {
                        "id": 22663,
                        "name": "Lázně Bělohrad",
                        "latitude": "50.42874000",
                        "longitude": "15.58269000"
                    },
                    {
                        "id": 22611,
                        "name": "Libáň",
                        "latitude": "50.37542000",
                        "longitude": "15.21684000"
                    },
                    {
                        "id": 22668,
                        "name": "Machov",
                        "latitude": "50.49927000",
                        "longitude": "16.27690000"
                    },
                    {
                        "id": 22673,
                        "name": "Malé Svatoňovice",
                        "latitude": "50.53395000",
                        "longitude": "16.04978000"
                    },
                    {
                        "id": 22684,
                        "name": "Meziměstí",
                        "latitude": "50.62461000",
                        "longitude": "16.24207000"
                    },
                    {
                        "id": 22703,
                        "name": "Mladé Buky",
                        "latitude": "50.60643000",
                        "longitude": "15.83348000"
                    },
                    {
                        "id": 22726,
                        "name": "Mostek",
                        "latitude": "50.48623000",
                        "longitude": "15.69622000"
                    },
                    {
                        "id": 22792,
                        "name": "Náchod",
                        "latitude": "50.41670000",
                        "longitude": "16.16289000"
                    },
                    {
                        "id": 22752,
                        "name": "Nechanice",
                        "latitude": "50.23737000",
                        "longitude": "15.63276000"
                    },
                    {
                        "id": 22774,
                        "name": "Nová Paka",
                        "latitude": "50.49449000",
                        "longitude": "15.51503000"
                    },
                    {
                        "id": 22779,
                        "name": "Nové Město nad Metují",
                        "latitude": "50.34456000",
                        "longitude": "16.15147000"
                    },
                    {
                        "id": 22786,
                        "name": "Nový Bydžov",
                        "latitude": "50.24150000",
                        "longitude": "15.49082000"
                    },
                    {
                        "id": 22820,
                        "name": "Okres Hradec Králové",
                        "latitude": "50.25000000",
                        "longitude": "15.66667000"
                    },
                    {
                        "id": 22825,
                        "name": "Okres Jičín",
                        "latitude": "50.41667000",
                        "longitude": "15.41667000"
                    },
                    {
                        "id": 22841,
                        "name": "Okres Náchod",
                        "latitude": "50.41667000",
                        "longitude": "16.16667000"
                    },
                    {
                        "id": 22859,
                        "name": "Okres Rychnov nad Kněžnou",
                        "latitude": "50.23333000",
                        "longitude": "16.28333000"
                    },
                    {
                        "id": 22866,
                        "name": "Okres Trutnov",
                        "latitude": "50.58333000",
                        "longitude": "15.83333000"
                    },
                    {
                        "id": 22894,
                        "name": "Opočno",
                        "latitude": "50.26742000",
                        "longitude": "16.11480000"
                    },
                    {
                        "id": 22906,
                        "name": "Ostroměř",
                        "latitude": "50.37246000",
                        "longitude": "15.54949000"
                    },
                    {
                        "id": 22924,
                        "name": "Pecka",
                        "latitude": "50.48034000",
                        "longitude": "15.60822000"
                    },
                    {
                        "id": 22933,
                        "name": "Pilníkov",
                        "latitude": "50.53247000",
                        "longitude": "15.82020000"
                    },
                    {
                        "id": 22951,
                        "name": "Police nad Metují",
                        "latitude": "50.53687000",
                        "longitude": "16.23350000"
                    },
                    {
                        "id": 22998,
                        "name": "Předměřice nad Labem",
                        "latitude": "50.25633000",
                        "longitude": "15.81556000"
                    },
                    {
                        "id": 22983,
                        "name": "Provodov-Šonov",
                        "latitude": "50.38711000",
                        "longitude": "16.10797000"
                    },
                    {
                        "id": 23016,
                        "name": "Radvanice",
                        "latitude": "50.56745000",
                        "longitude": "16.06172000"
                    },
                    {
                        "id": 23031,
                        "name": "Rokytnice v Orlických Horách",
                        "latitude": "50.16473000",
                        "longitude": "16.46567000"
                    },
                    {
                        "id": 23045,
                        "name": "Rtyně v Podkrkonoší",
                        "latitude": "50.50523000",
                        "longitude": "16.07187000"
                    },
                    {
                        "id": 23048,
                        "name": "Rudník",
                        "latitude": "50.59517000",
                        "longitude": "15.73362000"
                    },
                    {
                        "id": 23053,
                        "name": "Rychnov nad Kněžnou",
                        "latitude": "50.16284000",
                        "longitude": "16.27488000"
                    },
                    {
                        "id": 23075,
                        "name": "Skuhrov nad Bělou",
                        "latitude": "50.22946000",
                        "longitude": "16.29230000"
                    },
                    {
                        "id": 23086,
                        "name": "Smidary",
                        "latitude": "50.29146000",
                        "longitude": "15.47725000"
                    },
                    {
                        "id": 23087,
                        "name": "Smiřice",
                        "latitude": "50.29978000",
                        "longitude": "15.86508000"
                    },
                    {
                        "id": 23090,
                        "name": "Sobotka",
                        "latitude": "50.46741000",
                        "longitude": "15.17619000"
                    },
                    {
                        "id": 23095,
                        "name": "Solnice",
                        "latitude": "50.20366000",
                        "longitude": "16.23762000"
                    },
                    {
                        "id": 23419,
                        "name": "Špindlerův Mlýn",
                        "latitude": "50.72615000",
                        "longitude": "15.60944000"
                    },
                    {
                        "id": 23101,
                        "name": "Stará Paka",
                        "latitude": "50.51032000",
                        "longitude": "15.49444000"
                    },
                    {
                        "id": 23109,
                        "name": "Staré Nechanice",
                        "latitude": "50.24298000",
                        "longitude": "15.61787000"
                    },
                    {
                        "id": 23136,
                        "name": "Stěžery",
                        "latitude": "50.21572000",
                        "longitude": "15.74831000"
                    },
                    {
                        "id": 23151,
                        "name": "Svoboda nad Úpou",
                        "latitude": "50.62596000",
                        "longitude": "15.81648000"
                    },
                    {
                        "id": 23161,
                        "name": "Teplice nad Metují",
                        "latitude": "50.59332000",
                        "longitude": "16.17026000"
                    },
                    {
                        "id": 23197,
                        "name": "Třebechovice pod Orebem",
                        "latitude": "50.20097000",
                        "longitude": "15.99223000"
                    },
                    {
                        "id": 23181,
                        "name": "Trutnov",
                        "latitude": "50.56101000",
                        "longitude": "15.91270000"
                    },
                    {
                        "id": 23194,
                        "name": "Týniště nad Orlicí",
                        "latitude": "50.15136000",
                        "longitude": "16.07770000"
                    },
                    {
                        "id": 23357,
                        "name": "Úpice",
                        "latitude": "50.51237000",
                        "longitude": "16.01607000"
                    },
                    {
                        "id": 23219,
                        "name": "Valdice",
                        "latitude": "50.45501000",
                        "longitude": "15.38488000"
                    },
                    {
                        "id": 23222,
                        "name": "Vamberk",
                        "latitude": "50.11756000",
                        "longitude": "16.29067000"
                    },
                    {
                        "id": 23248,
                        "name": "Velké Poříčí",
                        "latitude": "50.46177000",
                        "longitude": "16.18931000"
                    },
                    {
                        "id": 23250,
                        "name": "Velké Svatoňovice",
                        "latitude": "50.53164000",
                        "longitude": "16.02853000"
                    },
                    {
                        "id": 23300,
                        "name": "Vrchlabí",
                        "latitude": "50.62697000",
                        "longitude": "15.60937000"
                    },
                    {
                        "id": 23320,
                        "name": "Všestary",
                        "latitude": "50.25660000",
                        "longitude": "15.75983000"
                    },
                    {
                        "id": 23436,
                        "name": "Žacléř",
                        "latitude": "50.66329000",
                        "longitude": "15.91063000"
                    },
                    {
                        "id": 23323,
                        "name": "Zadní Mostek",
                        "latitude": "50.49670000",
                        "longitude": "15.69804000"
                    },
                    {
                        "id": 23443,
                        "name": "Železnice",
                        "latitude": "50.47274000",
                        "longitude": "15.38459000"
                    }
                ]
            },
            {
                "id": 4593,
                "name": "Kroměříž",
                "iso2": "721",
                "latitude": "49.29165820",
                "longitude": "17.39938000",
                "type": "district",
                "cities": []
            },
            {
                "id": 4923,
                "name": "Kutná Hora",
                "iso2": "205",
                "latitude": "49.94920890",
                "longitude": "15.24704400",
                "type": "district",
                "cities": []
            },
            {
                "id": 4590,
                "name": "Liberec",
                "iso2": "513",
                "latitude": "50.75641010",
                "longitude": "14.99650410",
                "type": "district",
                "cities": []
            },
            {
                "id": 4601,
                "name": "Liberecký kraj",
                "iso2": "51",
                "latitude": "50.65942400",
                "longitude": "14.76324240",
                "type": "region",
                "cities": [
                    {
                        "id": 22120,
                        "name": "Benecko",
                        "latitude": "50.66633000",
                        "longitude": "15.54816000"
                    },
                    {
                        "id": 22165,
                        "name": "Brniště",
                        "latitude": "50.72919000",
                        "longitude": "14.70338000"
                    },
                    {
                        "id": 23384,
                        "name": "Česká Lípa",
                        "latitude": "50.68551000",
                        "longitude": "14.53764000"
                    },
                    {
                        "id": 23392,
                        "name": "Český Dub",
                        "latitude": "50.66054000",
                        "longitude": "14.99617000"
                    },
                    {
                        "id": 22232,
                        "name": "Chrastava",
                        "latitude": "50.81693000",
                        "longitude": "14.96884000"
                    },
                    {
                        "id": 22245,
                        "name": "Cvikov",
                        "latitude": "50.77668000",
                        "longitude": "14.63298000"
                    },
                    {
                        "id": 22254,
                        "name": "Desná",
                        "latitude": "50.75987000",
                        "longitude": "15.30284000"
                    },
                    {
                        "id": 22269,
                        "name": "Doksy",
                        "latitude": "50.56471000",
                        "longitude": "14.65553000"
                    },
                    {
                        "id": 22314,
                        "name": "Dubá",
                        "latitude": "50.54034000",
                        "longitude": "14.54023000"
                    },
                    {
                        "id": 22332,
                        "name": "Frýdlant",
                        "latitude": "50.92139000",
                        "longitude": "15.07974000"
                    },
                    {
                        "id": 22342,
                        "name": "Harrachov",
                        "latitude": "50.77209000",
                        "longitude": "15.43141000"
                    },
                    {
                        "id": 22348,
                        "name": "Hejnice",
                        "latitude": "50.87720000",
                        "longitude": "15.18168000"
                    },
                    {
                        "id": 22362,
                        "name": "Hodkovice nad Mohelkou",
                        "latitude": "50.66586000",
                        "longitude": "15.08985000"
                    },
                    {
                        "id": 22377,
                        "name": "Horní Branná",
                        "latitude": "50.60826000",
                        "longitude": "15.57146000"
                    },
                    {
                        "id": 22431,
                        "name": "Hrádek nad Nisou",
                        "latitude": "50.85279000",
                        "longitude": "14.84455000"
                    },
                    {
                        "id": 22445,
                        "name": "Jablonec nad Jizerou",
                        "latitude": "50.70347000",
                        "longitude": "15.42959000"
                    },
                    {
                        "id": 22446,
                        "name": "Jablonec nad Nisou",
                        "latitude": "50.72431000",
                        "longitude": "15.17108000"
                    },
                    {
                        "id": 22448,
                        "name": "Jablonné v Podještědí",
                        "latitude": "50.76528000",
                        "longitude": "14.76052000"
                    },
                    {
                        "id": 22453,
                        "name": "Janov nad Nisou",
                        "latitude": "50.77204000",
                        "longitude": "15.16913000"
                    },
                    {
                        "id": 22472,
                        "name": "Jilemnice",
                        "latitude": "50.60890000",
                        "longitude": "15.50653000"
                    },
                    {
                        "id": 22483,
                        "name": "Josefův Důl",
                        "latitude": "50.78191000",
                        "longitude": "15.23146000"
                    },
                    {
                        "id": 22491,
                        "name": "Kamenický Šenov",
                        "latitude": "50.77359000",
                        "longitude": "14.47287000"
                    },
                    {
                        "id": 22549,
                        "name": "Kořenov",
                        "latitude": "50.75926000",
                        "longitude": "15.36532000"
                    },
                    {
                        "id": 22551,
                        "name": "Košťálov",
                        "latitude": "50.57165000",
                        "longitude": "15.40403000"
                    },
                    {
                        "id": 22604,
                        "name": "Liberec",
                        "latitude": "50.76711000",
                        "longitude": "15.05619000"
                    },
                    {
                        "id": 22635,
                        "name": "Lomnice nad Popelkou",
                        "latitude": "50.53062000",
                        "longitude": "15.37341000"
                    },
                    {
                        "id": 22652,
                        "name": "Lučany nad Nisou",
                        "latitude": "50.74136000",
                        "longitude": "15.22046000"
                    },
                    {
                        "id": 22671,
                        "name": "Malá Skála",
                        "latitude": "50.64631000",
                        "longitude": "15.19543000"
                    },
                    {
                        "id": 22694,
                        "name": "Mimoň",
                        "latitude": "50.65869000",
                        "longitude": "14.72474000"
                    },
                    {
                        "id": 22706,
                        "name": "Mníšek",
                        "latitude": "50.83163000",
                        "longitude": "15.05630000"
                    },
                    {
                        "id": 22780,
                        "name": "Nové Město pod Smrkem",
                        "latitude": "50.92491000",
                        "longitude": "15.22943000"
                    },
                    {
                        "id": 22785,
                        "name": "Nový Bor",
                        "latitude": "50.75761000",
                        "longitude": "14.55555000"
                    },
                    {
                        "id": 22805,
                        "name": "Ohrazenice",
                        "latitude": "50.59765000",
                        "longitude": "15.12596000"
                    },
                    {
                        "id": 22876,
                        "name": "Okres Česká Lípa",
                        "latitude": "50.66667000",
                        "longitude": "14.66667000"
                    },
                    {
                        "id": 22821,
                        "name": "Okres Jablonec nad Nisou",
                        "latitude": "50.75000000",
                        "longitude": "15.25000000"
                    },
                    {
                        "id": 22833,
                        "name": "Okres Liberec",
                        "latitude": "50.83333000",
                        "longitude": "15.08333000"
                    },
                    {
                        "id": 22860,
                        "name": "Okres Semily",
                        "latitude": "50.61667000",
                        "longitude": "15.41667000"
                    },
                    {
                        "id": 22899,
                        "name": "Osečná",
                        "latitude": "50.69489000",
                        "longitude": "14.92138000"
                    },
                    {
                        "id": 22996,
                        "name": "Pěnčín",
                        "latitude": "50.68769000",
                        "longitude": "15.23593000"
                    },
                    {
                        "id": 22938,
                        "name": "Plavy",
                        "latitude": "50.70324000",
                        "longitude": "15.31736000"
                    },
                    {
                        "id": 22955,
                        "name": "Poniklá",
                        "latitude": "50.66152000",
                        "longitude": "15.46329000"
                    },
                    {
                        "id": 23010,
                        "name": "Příšovice",
                        "latitude": "50.57813000",
                        "longitude": "15.08390000"
                    },
                    {
                        "id": 23022,
                        "name": "Raspenava",
                        "latitude": "50.90415000",
                        "longitude": "15.11465000"
                    },
                    {
                        "id": 23030,
                        "name": "Rokytnice nad Jizerou",
                        "latitude": "50.72561000",
                        "longitude": "15.43357000"
                    },
                    {
                        "id": 23040,
                        "name": "Rovensko pod Troskami",
                        "latitude": "50.53532000",
                        "longitude": "15.25941000"
                    },
                    {
                        "id": 23067,
                        "name": "Semily",
                        "latitude": "50.60191000",
                        "longitude": "15.33552000"
                    },
                    {
                        "id": 23089,
                        "name": "Smržovka",
                        "latitude": "50.73820000",
                        "longitude": "15.24639000"
                    },
                    {
                        "id": 23127,
                        "name": "Stráž nad Nisou",
                        "latitude": "50.79099000",
                        "longitude": "15.02683000"
                    },
                    {
                        "id": 23128,
                        "name": "Stráž pod Ralskem",
                        "latitude": "50.70280000",
                        "longitude": "14.80102000"
                    },
                    {
                        "id": 23132,
                        "name": "Studenec",
                        "latitude": "50.55344000",
                        "longitude": "15.54936000"
                    },
                    {
                        "id": 23156,
                        "name": "Tanvald",
                        "latitude": "50.73735000",
                        "longitude": "15.30585000"
                    },
                    {
                        "id": 23186,
                        "name": "Turnov",
                        "latitude": "50.58356000",
                        "longitude": "15.15186000"
                    },
                    {
                        "id": 23220,
                        "name": "Valdice",
                        "latitude": "50.58350000",
                        "longitude": "15.41248000"
                    },
                    {
                        "id": 23238,
                        "name": "Velké Hamry",
                        "latitude": "50.71373000",
                        "longitude": "15.31539000"
                    },
                    {
                        "id": 23276,
                        "name": "Višňova",
                        "latitude": "50.96663000",
                        "longitude": "15.02495000"
                    },
                    {
                        "id": 23306,
                        "name": "Vysoké nad Jizerou",
                        "latitude": "50.68559000",
                        "longitude": "15.40152000"
                    },
                    {
                        "id": 23350,
                        "name": "Zákupy",
                        "latitude": "50.68475000",
                        "longitude": "14.64522000"
                    },
                    {
                        "id": 23438,
                        "name": "Žandov",
                        "latitude": "50.71394000",
                        "longitude": "14.39623000"
                    },
                    {
                        "id": 23445,
                        "name": "Železný Brod",
                        "latitude": "50.64274000",
                        "longitude": "15.25408000"
                    }
                ]
            },
            {
                "id": 4605,
                "name": "Litoměřice",
                "iso2": "423",
                "latitude": "50.53841970",
                "longitude": "14.13054580",
                "type": "district",
                "cities": []
            },
            {
                "id": 4617,
                "name": "Louny",
                "iso2": "424",
                "latitude": "50.35398120",
                "longitude": "13.80335510",
                "type": "district",
                "cities": []
            },
            {
                "id": 4638,
                "name": "Mělník",
                "iso2": "206",
                "latitude": "50.31044150",
                "longitude": "14.51792230",
                "type": "district",
                "cities": []
            },
            {
                "id": 4643,
                "name": "Mladá Boleslav",
                "iso2": "207",
                "latitude": "50.42523170",
                "longitude": "14.93624770",
                "type": "district",
                "cities": []
            },
            {
                "id": 4600,
                "name": "Moravskoslezský kraj",
                "iso2": "80",
                "latitude": "49.73053270",
                "longitude": "18.23326370",
                "type": "region",
                "cities": [
                    {
                        "id": 22108,
                        "name": "Albrechtice",
                        "latitude": "49.78645000",
                        "longitude": "18.52444000"
                    },
                    {
                        "id": 22113,
                        "name": "Bartošovice",
                        "latitude": "49.66884000",
                        "longitude": "18.05461000"
                    },
                    {
                        "id": 22116,
                        "name": "Baška",
                        "latitude": "49.64584000",
                        "longitude": "18.37233000"
                    },
                    {
                        "id": 22194,
                        "name": "Bílovec",
                        "latitude": "49.75639000",
                        "longitude": "18.01581000"
                    },
                    {
                        "id": 22139,
                        "name": "Bohumín",
                        "latitude": "49.90411000",
                        "longitude": "18.35755000"
                    },
                    {
                        "id": 22140,
                        "name": "Bohuslavice",
                        "latitude": "49.94232000",
                        "longitude": "18.12866000"
                    },
                    {
                        "id": 22145,
                        "name": "Bolatice",
                        "latitude": "49.95172000",
                        "longitude": "18.08358000"
                    },
                    {
                        "id": 22161,
                        "name": "Brantice",
                        "latitude": "50.06351000",
                        "longitude": "17.62911000"
                    },
                    {
                        "id": 22210,
                        "name": "Březová",
                        "latitude": "49.79158000",
                        "longitude": "17.86556000"
                    },
                    {
                        "id": 22214,
                        "name": "Břidličná",
                        "latitude": "49.91167000",
                        "longitude": "17.37107000"
                    },
                    {
                        "id": 22171,
                        "name": "Brumovice",
                        "latitude": "50.01530000",
                        "longitude": "17.74958000"
                    },
                    {
                        "id": 22172,
                        "name": "Bruntál",
                        "latitude": "49.98844000",
                        "longitude": "17.46470000"
                    },
                    {
                        "id": 22173,
                        "name": "Brušperk",
                        "latitude": "49.70010000",
                        "longitude": "18.22210000"
                    },
                    {
                        "id": 22176,
                        "name": "Budišov nad Budišovkou",
                        "latitude": "49.79511000",
                        "longitude": "17.62969000"
                    },
                    {
                        "id": 22179,
                        "name": "Bukovec",
                        "latitude": "49.55114000",
                        "longitude": "18.82683000"
                    },
                    {
                        "id": 22186,
                        "name": "Bystřice",
                        "latitude": "49.63657000",
                        "longitude": "18.72038000"
                    },
                    {
                        "id": 23367,
                        "name": "Čeladná",
                        "latitude": "49.54873000",
                        "longitude": "18.33759000"
                    },
                    {
                        "id": 23395,
                        "name": "Český Těšín",
                        "latitude": "49.74613000",
                        "longitude": "18.62613000"
                    },
                    {
                        "id": 22218,
                        "name": "Chlebičov",
                        "latitude": "49.95942000",
                        "longitude": "17.96748000"
                    },
                    {
                        "id": 22229,
                        "name": "Chotěbuz",
                        "latitude": "49.76849000",
                        "longitude": "18.56912000"
                    },
                    {
                        "id": 22237,
                        "name": "Chuchelná",
                        "latitude": "49.98664000",
                        "longitude": "18.11656000"
                    },
                    {
                        "id": 22250,
                        "name": "Darkovice",
                        "latitude": "49.93592000",
                        "longitude": "18.22213000"
                    },
                    {
                        "id": 22321,
                        "name": "Dětmarovice",
                        "latitude": "49.89412000",
                        "longitude": "18.46079000"
                    },
                    {
                        "id": 22262,
                        "name": "Dobrá",
                        "latitude": "49.67383000",
                        "longitude": "18.41393000"
                    },
                    {
                        "id": 22257,
                        "name": "Dobratice",
                        "latitude": "49.66039000",
                        "longitude": "18.49226000"
                    },
                    {
                        "id": 22271,
                        "name": "Dolní Benešov",
                        "latitude": "49.92101000",
                        "longitude": "18.10835000"
                    },
                    {
                        "id": 22284,
                        "name": "Dolní Lhota",
                        "latitude": "49.84236000",
                        "longitude": "18.09241000"
                    },
                    {
                        "id": 22286,
                        "name": "Dolní Lutyně",
                        "latitude": "49.89876000",
                        "longitude": "18.42815000"
                    },
                    {
                        "id": 22300,
                        "name": "Dolní Životice",
                        "latitude": "49.89732000",
                        "longitude": "17.77969000"
                    },
                    {
                        "id": 22304,
                        "name": "Doubrava",
                        "latitude": "49.85873000",
                        "longitude": "18.48018000"
                    },
                    {
                        "id": 22318,
                        "name": "Dvorce",
                        "latitude": "49.83332000",
                        "longitude": "17.54762000"
                    },
                    {
                        "id": 22327,
                        "name": "Frenštát pod Radhoštěm",
                        "latitude": "49.54835000",
                        "longitude": "18.21078000"
                    },
                    {
                        "id": 22329,
                        "name": "Fryčovice",
                        "latitude": "49.66677000",
                        "longitude": "18.22321000"
                    },
                    {
                        "id": 22331,
                        "name": "Frýdek-Místek",
                        "latitude": "49.68333000",
                        "longitude": "18.35000000"
                    },
                    {
                        "id": 22333,
                        "name": "Frýdlant nad Ostravicí",
                        "latitude": "49.59280000",
                        "longitude": "18.35967000"
                    },
                    {
                        "id": 22334,
                        "name": "Fulnek",
                        "latitude": "49.71238000",
                        "longitude": "17.90319000"
                    },
                    {
                        "id": 22440,
                        "name": "Háj ve Slezsku",
                        "latitude": "49.89856000",
                        "longitude": "18.09540000"
                    },
                    {
                        "id": 22347,
                        "name": "Hať",
                        "latitude": "49.94644000",
                        "longitude": "18.23931000"
                    },
                    {
                        "id": 22345,
                        "name": "Havířov",
                        "latitude": "49.77984000",
                        "longitude": "18.43688000"
                    },
                    {
                        "id": 22358,
                        "name": "Hlučín",
                        "latitude": "49.89795000",
                        "longitude": "18.19196000"
                    },
                    {
                        "id": 22361,
                        "name": "Hněvošice",
                        "latitude": "50.00299000",
                        "longitude": "18.00829000"
                    },
                    {
                        "id": 22359,
                        "name": "Hnojník",
                        "latitude": "49.68250000",
                        "longitude": "18.54143000"
                    },
                    {
                        "id": 22366,
                        "name": "Hodslavice",
                        "latitude": "49.53856000",
                        "longitude": "18.02367000"
                    },
                    {
                        "id": 22367,
                        "name": "Holasovice",
                        "latitude": "49.99843000",
                        "longitude": "17.80847000"
                    },
                    {
                        "id": 22374,
                        "name": "Horní Benešov",
                        "latitude": "49.96682000",
                        "longitude": "17.60262000"
                    },
                    {
                        "id": 22376,
                        "name": "Horní Bludovice",
                        "latitude": "49.74965000",
                        "longitude": "18.43677000"
                    },
                    {
                        "id": 22384,
                        "name": "Horní Město",
                        "latitude": "49.90845000",
                        "longitude": "17.21112000"
                    },
                    {
                        "id": 22391,
                        "name": "Horní Suchá",
                        "latitude": "49.79780000",
                        "longitude": "18.48189000"
                    },
                    {
                        "id": 22392,
                        "name": "Horní Těrlicko",
                        "latitude": "49.75177000",
                        "longitude": "18.48290000"
                    },
                    {
                        "id": 22411,
                        "name": "Hrabyně",
                        "latitude": "49.88249000",
                        "longitude": "18.05483000"
                    },
                    {
                        "id": 22413,
                        "name": "Hradec nad Moravici",
                        "latitude": "49.87042000",
                        "longitude": "17.87843000"
                    },
                    {
                        "id": 22429,
                        "name": "Hrádek",
                        "latitude": "49.61661000",
                        "longitude": "18.73720000"
                    },
                    {
                        "id": 22433,
                        "name": "Hukvaldy",
                        "latitude": "49.62381000",
                        "longitude": "18.22189000"
                    },
                    {
                        "id": 22449,
                        "name": "Jablunkov",
                        "latitude": "49.57672000",
                        "longitude": "18.76458000"
                    },
                    {
                        "id": 22451,
                        "name": "Jakartovice",
                        "latitude": "49.91510000",
                        "longitude": "17.68400000"
                    },
                    {
                        "id": 22454,
                        "name": "Janovice",
                        "latitude": "49.62141000",
                        "longitude": "18.40602000"
                    },
                    {
                        "id": 22468,
                        "name": "Jeseník nad Odrou",
                        "latitude": "49.61194000",
                        "longitude": "17.90526000"
                    },
                    {
                        "id": 22475,
                        "name": "Jindřichov",
                        "latitude": "50.25184000",
                        "longitude": "17.51903000"
                    },
                    {
                        "id": 22480,
                        "name": "Jistebník",
                        "latitude": "49.75400000",
                        "longitude": "18.13063000"
                    },
                    {
                        "id": 22497,
                        "name": "Karlovice",
                        "latitude": "50.10564000",
                        "longitude": "17.44563000"
                    },
                    {
                        "id": 22501,
                        "name": "Karviná",
                        "latitude": "49.85400000",
                        "longitude": "18.54169000"
                    },
                    {
                        "id": 22515,
                        "name": "Klimkovice",
                        "latitude": "49.78809000",
                        "longitude": "18.12585000"
                    },
                    {
                        "id": 22524,
                        "name": "Kobeřice",
                        "latitude": "49.98548000",
                        "longitude": "18.05212000"
                    },
                    {
                        "id": 22530,
                        "name": "Komorní Lhotka",
                        "latitude": "49.65811000",
                        "longitude": "18.52777000"
                    },
                    {
                        "id": 22534,
                        "name": "Kopřivnice",
                        "latitude": "49.59947000",
                        "longitude": "18.14480000"
                    },
                    {
                        "id": 22547,
                        "name": "Kozlovice",
                        "latitude": "49.59040000",
                        "longitude": "18.25656000"
                    },
                    {
                        "id": 22548,
                        "name": "Kozmice",
                        "latitude": "49.91280000",
                        "longitude": "18.15584000"
                    },
                    {
                        "id": 22557,
                        "name": "Kravaře",
                        "latitude": "49.93203000",
                        "longitude": "18.00472000"
                    },
                    {
                        "id": 22558,
                        "name": "Krmelín",
                        "latitude": "49.72914000",
                        "longitude": "18.23541000"
                    },
                    {
                        "id": 22559,
                        "name": "Krnov",
                        "latitude": "50.08967000",
                        "longitude": "17.70385000"
                    },
                    {
                        "id": 22572,
                        "name": "Kunčice pod Ondřejníkem",
                        "latitude": "49.55070000",
                        "longitude": "18.26113000"
                    },
                    {
                        "id": 22571,
                        "name": "Kunín",
                        "latitude": "49.63377000",
                        "longitude": "17.98965000"
                    },
                    {
                        "id": 22614,
                        "name": "Lichnov",
                        "latitude": "50.00786000",
                        "longitude": "17.62640000"
                    },
                    {
                        "id": 22615,
                        "name": "Lichnov (o. Nový Jičín)",
                        "latitude": "49.56423000",
                        "longitude": "18.16898000"
                    },
                    {
                        "id": 22653,
                        "name": "Lučina",
                        "latitude": "49.72082000",
                        "longitude": "18.44776000"
                    },
                    {
                        "id": 22645,
                        "name": "Ludgeřovice",
                        "latitude": "49.89042000",
                        "longitude": "18.24008000"
                    },
                    {
                        "id": 22677,
                        "name": "Markvartovice",
                        "latitude": "49.90595000",
                        "longitude": "18.23602000"
                    },
                    {
                        "id": 22741,
                        "name": "Město Albrechtice",
                        "latitude": "50.16294000",
                        "longitude": "17.57481000"
                    },
                    {
                        "id": 22682,
                        "name": "Metylovice",
                        "latitude": "49.60666000",
                        "longitude": "18.33911000"
                    },
                    {
                        "id": 22692,
                        "name": "Milíkov",
                        "latitude": "49.58565000",
                        "longitude": "18.71943000"
                    },
                    {
                        "id": 22713,
                        "name": "Mokré Lazce",
                        "latitude": "49.90462000",
                        "longitude": "18.02954000"
                    },
                    {
                        "id": 22724,
                        "name": "Morávka",
                        "latitude": "49.59607000",
                        "longitude": "18.52471000"
                    },
                    {
                        "id": 22730,
                        "name": "Mořkov",
                        "latitude": "49.53684000",
                        "longitude": "18.05968000"
                    },
                    {
                        "id": 22728,
                        "name": "Mosty u Jablunkova",
                        "latitude": "49.52737000",
                        "longitude": "18.75417000"
                    },
                    {
                        "id": 22796,
                        "name": "Návsí u Jablunkova",
                        "latitude": "49.58720000",
                        "longitude": "18.75907000"
                    },
                    {
                        "id": 22788,
                        "name": "Nový Jičín",
                        "latitude": "49.59438000",
                        "longitude": "18.01028000"
                    },
                    {
                        "id": 22797,
                        "name": "Nýdek",
                        "latitude": "49.65609000",
                        "longitude": "18.75687000"
                    },
                    {
                        "id": 22804,
                        "name": "Odry",
                        "latitude": "49.66255000",
                        "longitude": "17.83084000"
                    },
                    {
                        "id": 22810,
                        "name": "Okres Bruntál",
                        "latitude": "50.00000000",
                        "longitude": "17.41667000"
                    },
                    {
                        "id": 22817,
                        "name": "Okres Frýdek-Místek",
                        "latitude": "49.58333000",
                        "longitude": "18.50000000"
                    },
                    {
                        "id": 22827,
                        "name": "Okres Karviná",
                        "latitude": "49.83333000",
                        "longitude": "18.50000000"
                    },
                    {
                        "id": 22839,
                        "name": "Okres Nový Jičín",
                        "latitude": "49.66667000",
                        "longitude": "18.00000000"
                    },
                    {
                        "id": 22843,
                        "name": "Okres Opava",
                        "latitude": "49.83333000",
                        "longitude": "17.91667000"
                    },
                    {
                        "id": 22844,
                        "name": "Okres Ostrava-město",
                        "latitude": "49.83333000",
                        "longitude": "18.25000000"
                    },
                    {
                        "id": 22884,
                        "name": "Oldřišov",
                        "latitude": "49.99130000",
                        "longitude": "17.96074000"
                    },
                    {
                        "id": 22892,
                        "name": "Opava",
                        "latitude": "49.93866000",
                        "longitude": "17.90257000"
                    },
                    {
                        "id": 22895,
                        "name": "Orlová",
                        "latitude": "49.84527000",
                        "longitude": "18.43011000"
                    },
                    {
                        "id": 22902,
                        "name": "Osoblaha",
                        "latitude": "50.27517000",
                        "longitude": "17.71523000"
                    },
                    {
                        "id": 22904,
                        "name": "Ostrava",
                        "latitude": "49.83465000",
                        "longitude": "18.28204000"
                    },
                    {
                        "id": 22905,
                        "name": "Ostravice",
                        "latitude": "49.53510000",
                        "longitude": "18.39164000"
                    },
                    {
                        "id": 22913,
                        "name": "Otice",
                        "latitude": "49.91684000",
                        "longitude": "17.86982000"
                    },
                    {
                        "id": 22918,
                        "name": "Palkovice",
                        "latitude": "49.63467000",
                        "longitude": "18.31508000"
                    },
                    {
                        "id": 22921,
                        "name": "Paskov",
                        "latitude": "49.73179000",
                        "longitude": "18.29037000"
                    },
                    {
                        "id": 22930,
                        "name": "Petrovice u Karviné",
                        "latitude": "49.89587000",
                        "longitude": "18.54779000"
                    },
                    {
                        "id": 22931,
                        "name": "Petřvald",
                        "latitude": "49.83100000",
                        "longitude": "18.38940000"
                    },
                    {
                        "id": 22992,
                        "name": "Písek",
                        "latitude": "49.55924000",
                        "longitude": "18.80231000"
                    },
                    {
                        "id": 22995,
                        "name": "Píšť",
                        "latitude": "49.97857000",
                        "longitude": "18.19349000"
                    },
                    {
                        "id": 22975,
                        "name": "Pražmo",
                        "latitude": "49.60876000",
                        "longitude": "18.48617000"
                    },
                    {
                        "id": 23007,
                        "name": "Příbor",
                        "latitude": "49.64094000",
                        "longitude": "18.14499000"
                    },
                    {
                        "id": 22990,
                        "name": "Pustá Polom",
                        "latitude": "49.84917000",
                        "longitude": "17.99790000"
                    },
                    {
                        "id": 23026,
                        "name": "Raškovice",
                        "latitude": "49.61975000",
                        "longitude": "18.47286000"
                    },
                    {
                        "id": 23401,
                        "name": "Řepiště",
                        "latitude": "49.73338000",
                        "longitude": "18.31707000"
                    },
                    {
                        "id": 23033,
                        "name": "Ropice",
                        "latitude": "49.70536000",
                        "longitude": "18.61345000"
                    },
                    {
                        "id": 23052,
                        "name": "Rybí",
                        "latitude": "49.60073000",
                        "longitude": "18.07592000"
                    },
                    {
                        "id": 23054,
                        "name": "Rychvald",
                        "latitude": "49.86625000",
                        "longitude": "18.37626000"
                    },
                    {
                        "id": 23057,
                        "name": "Rýmařov",
                        "latitude": "49.93183000",
                        "longitude": "17.27177000"
                    },
                    {
                        "id": 23064,
                        "name": "Sedliště",
                        "latitude": "49.71836000",
                        "longitude": "18.36869000"
                    },
                    {
                        "id": 23065,
                        "name": "Sedlnice",
                        "latitude": "49.65770000",
                        "longitude": "18.08690000"
                    },
                    {
                        "id": 23412,
                        "name": "Šenov",
                        "latitude": "49.79315000",
                        "longitude": "18.37607000"
                    },
                    {
                        "id": 23415,
                        "name": "Šilheřovice",
                        "latitude": "49.92602000",
                        "longitude": "18.27017000"
                    },
                    {
                        "id": 23081,
                        "name": "Slavkov",
                        "latitude": "49.92180000",
                        "longitude": "17.83641000"
                    },
                    {
                        "id": 23102,
                        "name": "Stará Ves nad Ondřejnicí",
                        "latitude": "49.72775000",
                        "longitude": "18.18850000"
                    },
                    {
                        "id": 23105,
                        "name": "Staré Město",
                        "latitude": "49.66992000",
                        "longitude": "18.36349000"
                    },
                    {
                        "id": 23116,
                        "name": "Staříč",
                        "latitude": "49.68594000",
                        "longitude": "18.27281000"
                    },
                    {
                        "id": 23110,
                        "name": "Starý Bohumín",
                        "latitude": "49.91690000",
                        "longitude": "18.33619000"
                    },
                    {
                        "id": 23111,
                        "name": "Starý Jičín",
                        "latitude": "49.57686000",
                        "longitude": "17.96169000"
                    },
                    {
                        "id": 23135,
                        "name": "Stěbořice",
                        "latitude": "49.93708000",
                        "longitude": "17.80547000"
                    },
                    {
                        "id": 23428,
                        "name": "Štěpánkovice",
                        "latitude": "49.95738000",
                        "longitude": "18.03741000"
                    },
                    {
                        "id": 23423,
                        "name": "Štítina",
                        "latitude": "49.91487000",
                        "longitude": "18.01245000"
                    },
                    {
                        "id": 23119,
                        "name": "Stonava",
                        "latitude": "49.81691000",
                        "longitude": "18.52518000"
                    },
                    {
                        "id": 23422,
                        "name": "Štramberk",
                        "latitude": "49.59181000",
                        "longitude": "18.11741000"
                    },
                    {
                        "id": 23134,
                        "name": "Studénka",
                        "latitude": "49.72342000",
                        "longitude": "18.07853000"
                    },
                    {
                        "id": 23148,
                        "name": "Sviadnov",
                        "latitude": "49.68926000",
                        "longitude": "18.32762000"
                    },
                    {
                        "id": 23164,
                        "name": "Tichá",
                        "latitude": "49.56999000",
                        "longitude": "18.22148000"
                    },
                    {
                        "id": 23205,
                        "name": "Třinec",
                        "latitude": "49.67763000",
                        "longitude": "18.67078000"
                    },
                    {
                        "id": 23177,
                        "name": "Trojanovice",
                        "latitude": "49.52039000",
                        "longitude": "18.23800000"
                    },
                    {
                        "id": 23310,
                        "name": "Václavovice",
                        "latitude": "49.75531000",
                        "longitude": "18.37220000"
                    },
                    {
                        "id": 23234,
                        "name": "Velká Polom",
                        "latitude": "49.86359000",
                        "longitude": "18.09331000"
                    },
                    {
                        "id": 23239,
                        "name": "Velké Heraltice",
                        "latitude": "49.97493000",
                        "longitude": "17.72879000"
                    },
                    {
                        "id": 23240,
                        "name": "Velké Hoštice",
                        "latitude": "49.93609000",
                        "longitude": "17.97380000"
                    },
                    {
                        "id": 23259,
                        "name": "Vendryně",
                        "latitude": "49.66662000",
                        "longitude": "18.71307000"
                    },
                    {
                        "id": 23265,
                        "name": "Veřovice",
                        "latitude": "49.53916000",
                        "longitude": "18.11425000"
                    },
                    {
                        "id": 23312,
                        "name": "Vítkov",
                        "latitude": "49.77445000",
                        "longitude": "17.74941000"
                    },
                    {
                        "id": 23283,
                        "name": "Vlčnov",
                        "latitude": "49.57866000",
                        "longitude": "17.95458000"
                    },
                    {
                        "id": 23294,
                        "name": "Vratimov",
                        "latitude": "49.76995000",
                        "longitude": "18.31015000"
                    },
                    {
                        "id": 23296,
                        "name": "Vrbice",
                        "latitude": "49.88333000",
                        "longitude": "18.31667000"
                    },
                    {
                        "id": 23297,
                        "name": "Vrbno pod Pradědem",
                        "latitude": "50.12095000",
                        "longitude": "17.38316000"
                    },
                    {
                        "id": 23316,
                        "name": "Vřesina",
                        "latitude": "49.82418000",
                        "longitude": "18.12569000"
                    },
                    {
                        "id": 23352,
                        "name": "Zátor",
                        "latitude": "50.03413000",
                        "longitude": "17.59296000"
                    }
                ]
            },
            {
                "id": 4629,
                "name": "Most",
                "iso2": "425",
                "latitude": "37.15540830",
                "longitude": "-94.29488840",
                "type": "district",
                "cities": []
            },
            {
                "id": 4550,
                "name": "Náchod",
                "iso2": "523",
                "latitude": "50.41457220",
                "longitude": "16.16563470",
                "type": "district",
                "cities": []
            },
            {
                "id": 4548,
                "name": "Nový Jičín",
                "iso2": "804",
                "latitude": "49.59432510",
                "longitude": "18.01353560",
                "type": "district",
                "cities": []
            },
            {
                "id": 4582,
                "name": "Nymburk",
                "iso2": "208",
                "latitude": "50.18558160",
                "longitude": "15.04366040",
                "type": "district",
                "cities": []
            },
            {
                "id": 4574,
                "name": "Olomouc",
                "iso2": "712",
                "latitude": "49.59377800",
                "longitude": "17.25087870",
                "type": "district",
                "cities": []
            },
            {
                "id": 4589,
                "name": "Olomoucký kraj",
                "iso2": "71",
                "latitude": "49.65865490",
                "longitude": "17.08114060",
                "type": "region",
                "cities": [
                    {
                        "id": 22119,
                        "name": "Bedihošť",
                        "latitude": "49.44826000",
                        "longitude": "17.16643000"
                    },
                    {
                        "id": 22200,
                        "name": "Bělotín",
                        "latitude": "49.59120000",
                        "longitude": "17.80654000"
                    },
                    {
                        "id": 22197,
                        "name": "Bílá Lhota",
                        "latitude": "49.70953000",
                        "longitude": "16.97507000"
                    },
                    {
                        "id": 22133,
                        "name": "Bludov",
                        "latitude": "49.94080000",
                        "longitude": "16.92849000"
                    },
                    {
                        "id": 22142,
                        "name": "Bohuňovice",
                        "latitude": "49.66301000",
                        "longitude": "17.28693000"
                    },
                    {
                        "id": 22153,
                        "name": "Bouzov",
                        "latitude": "49.70426000",
                        "longitude": "16.89288000"
                    },
                    {
                        "id": 22168,
                        "name": "Brodek u Přerova",
                        "latitude": "49.48419000",
                        "longitude": "17.33825000"
                    },
                    {
                        "id": 23368,
                        "name": "Čelechovice na Hané",
                        "latitude": "49.51626000",
                        "longitude": "17.09379000"
                    },
                    {
                        "id": 23378,
                        "name": "Červenka",
                        "latitude": "49.72068000",
                        "longitude": "17.07773000"
                    },
                    {
                        "id": 23387,
                        "name": "Česká Ves",
                        "latitude": "50.25736000",
                        "longitude": "17.22805000"
                    },
                    {
                        "id": 22270,
                        "name": "Dolany",
                        "latitude": "49.64987000",
                        "longitude": "17.32240000"
                    },
                    {
                        "id": 22274,
                        "name": "Dolní Bohdíkov",
                        "latitude": "50.00996000",
                        "longitude": "16.90433000"
                    },
                    {
                        "id": 22294,
                        "name": "Dolní Studénky",
                        "latitude": "49.93506000",
                        "longitude": "16.97107000"
                    },
                    {
                        "id": 22295,
                        "name": "Dolní Újezd",
                        "latitude": "49.54597000",
                        "longitude": "17.53547000"
                    },
                    {
                        "id": 22301,
                        "name": "Doloplazy",
                        "latitude": "49.56876000",
                        "longitude": "17.41393000"
                    },
                    {
                        "id": 22307,
                        "name": "Drahanovice",
                        "latitude": "49.57856000",
                        "longitude": "17.07701000"
                    },
                    {
                        "id": 22323,
                        "name": "Dřevohostice",
                        "latitude": "49.42594000",
                        "longitude": "17.59204000"
                    },
                    {
                        "id": 22311,
                        "name": "Dub nad Moravou",
                        "latitude": "49.48249000",
                        "longitude": "17.27723000"
                    },
                    {
                        "id": 22312,
                        "name": "Dubicko",
                        "latitude": "49.82806000",
                        "longitude": "16.96266000"
                    },
                    {
                        "id": 22336,
                        "name": "Grygov",
                        "latitude": "49.53841000",
                        "longitude": "17.30887000"
                    },
                    {
                        "id": 22341,
                        "name": "Hanušovice",
                        "latitude": "50.08049000",
                        "longitude": "16.93641000"
                    },
                    {
                        "id": 22356,
                        "name": "Hlubočky",
                        "latitude": "49.61783000",
                        "longitude": "17.39436000"
                    },
                    {
                        "id": 22360,
                        "name": "Hněvotín",
                        "latitude": "49.57205000",
                        "longitude": "17.17954000"
                    },
                    {
                        "id": 22373,
                        "name": "Horka nad Moravou",
                        "latitude": "49.64009000",
                        "longitude": "17.21070000"
                    },
                    {
                        "id": 22383,
                        "name": "Horní Moštěnice",
                        "latitude": "49.41213000",
                        "longitude": "17.45879000"
                    },
                    {
                        "id": 22394,
                        "name": "Horní Štěpánov",
                        "latitude": "49.54901000",
                        "longitude": "16.79078000"
                    },
                    {
                        "id": 22417,
                        "name": "Hranice",
                        "latitude": "49.54796000",
                        "longitude": "17.73469000"
                    },
                    {
                        "id": 22438,
                        "name": "Hustopeče Nad Bečvou",
                        "latitude": "49.53053000",
                        "longitude": "17.86994000"
                    },
                    {
                        "id": 22461,
                        "name": "Javorník",
                        "latitude": "50.39077000",
                        "longitude": "17.00272000"
                    },
                    {
                        "id": 22467,
                        "name": "Jeseník",
                        "latitude": "50.22937000",
                        "longitude": "17.20464000"
                    },
                    {
                        "id": 22526,
                        "name": "Kojetín",
                        "latitude": "49.35179000",
                        "longitude": "17.30207000"
                    },
                    {
                        "id": 22527,
                        "name": "Kokory",
                        "latitude": "49.49482000",
                        "longitude": "17.37544000"
                    },
                    {
                        "id": 22532,
                        "name": "Konice",
                        "latitude": "49.59030000",
                        "longitude": "16.88911000"
                    },
                    {
                        "id": 22538,
                        "name": "Kostelec na Hané",
                        "latitude": "49.51398000",
                        "longitude": "17.05824000"
                    },
                    {
                        "id": 22553,
                        "name": "Kralice na Hané",
                        "latitude": "49.46296000",
                        "longitude": "17.18048000"
                    },
                    {
                        "id": 22602,
                        "name": "Leština",
                        "latitude": "49.86879000",
                        "longitude": "16.92748000"
                    },
                    {
                        "id": 22617,
                        "name": "Lipník nad Bečvou",
                        "latitude": "49.52721000",
                        "longitude": "17.58594000"
                    },
                    {
                        "id": 22624,
                        "name": "Litovel",
                        "latitude": "49.70121000",
                        "longitude": "17.07615000"
                    },
                    {
                        "id": 22642,
                        "name": "Loštice",
                        "latitude": "49.74470000",
                        "longitude": "16.92892000"
                    },
                    {
                        "id": 22639,
                        "name": "Loučná nad Desnou",
                        "latitude": "50.07433000",
                        "longitude": "17.09052000"
                    },
                    {
                        "id": 22651,
                        "name": "Lutín",
                        "latitude": "49.55845000",
                        "longitude": "17.13572000"
                    },
                    {
                        "id": 22669,
                        "name": "Majetín",
                        "latitude": "49.49808000",
                        "longitude": "17.33314000"
                    },
                    {
                        "id": 22679,
                        "name": "Medlov",
                        "latitude": "49.78754000",
                        "longitude": "17.06261000"
                    },
                    {
                        "id": 22743,
                        "name": "Město Libavá",
                        "latitude": "49.72162000",
                        "longitude": "17.52013000"
                    },
                    {
                        "id": 22686,
                        "name": "Mikulovice",
                        "latitude": "50.29854000",
                        "longitude": "17.32155000"
                    },
                    {
                        "id": 22710,
                        "name": "Mohelnice",
                        "latitude": "49.77698000",
                        "longitude": "16.91946000"
                    },
                    {
                        "id": 22716,
                        "name": "Moravičany",
                        "latitude": "49.75694000",
                        "longitude": "16.96042000"
                    },
                    {
                        "id": 22720,
                        "name": "Moravský Beroun",
                        "latitude": "49.79374000",
                        "longitude": "17.44212000"
                    },
                    {
                        "id": 22727,
                        "name": "Mostkovice",
                        "latitude": "49.47215000",
                        "longitude": "17.05212000"
                    },
                    {
                        "id": 22793,
                        "name": "Náklo",
                        "latitude": "49.65462000",
                        "longitude": "17.12969000"
                    },
                    {
                        "id": 22794,
                        "name": "Náměšť na Hané",
                        "latitude": "49.60213000",
                        "longitude": "17.06539000"
                    },
                    {
                        "id": 22800,
                        "name": "Němčice nad Hanou",
                        "latitude": "49.34181000",
                        "longitude": "17.20596000"
                    },
                    {
                        "id": 22765,
                        "name": "Nezamyslice",
                        "latitude": "49.32543000",
                        "longitude": "17.17326000"
                    },
                    {
                        "id": 22790,
                        "name": "Nový Malín",
                        "latitude": "49.94262000",
                        "longitude": "17.03191000"
                    },
                    {
                        "id": 22822,
                        "name": "Okres Jeseník",
                        "latitude": "50.25000000",
                        "longitude": "17.16667000"
                    },
                    {
                        "id": 22842,
                        "name": "Okres Olomouc",
                        "latitude": "49.66667000",
                        "longitude": "17.25000000"
                    },
                    {
                        "id": 22855,
                        "name": "Okres Přerov",
                        "latitude": "49.50000000",
                        "longitude": "17.55000000"
                    },
                    {
                        "id": 22853,
                        "name": "Okres Prostějov",
                        "latitude": "49.50000000",
                        "longitude": "17.03333000"
                    },
                    {
                        "id": 22879,
                        "name": "Okres Šumperk",
                        "latitude": "50.00000000",
                        "longitude": "17.00000000"
                    },
                    {
                        "id": 22886,
                        "name": "Olomouc",
                        "latitude": "49.59552000",
                        "longitude": "17.25175000"
                    },
                    {
                        "id": 22888,
                        "name": "Olšany",
                        "latitude": "49.96509000",
                        "longitude": "16.85894000"
                    },
                    {
                        "id": 22898,
                        "name": "Osek nad Bečvou",
                        "latitude": "49.51121000",
                        "longitude": "17.52829000"
                    },
                    {
                        "id": 22900,
                        "name": "Oskava",
                        "latitude": "49.89523000",
                        "longitude": "17.13214000"
                    },
                    {
                        "id": 22912,
                        "name": "Otaslavice",
                        "latitude": "49.38833000",
                        "longitude": "17.07108000"
                    },
                    {
                        "id": 22920,
                        "name": "Paseka",
                        "latitude": "49.79644000",
                        "longitude": "17.22276000"
                    },
                    {
                        "id": 22994,
                        "name": "Písečná",
                        "latitude": "50.27303000",
                        "longitude": "17.25373000"
                    },
                    {
                        "id": 22941,
                        "name": "Plumlov",
                        "latitude": "49.46614000",
                        "longitude": "17.01502000"
                    },
                    {
                        "id": 22960,
                        "name": "Postřelmov",
                        "latitude": "49.90756000",
                        "longitude": "16.91226000"
                    },
                    {
                        "id": 22961,
                        "name": "Potštát",
                        "latitude": "49.63693000",
                        "longitude": "17.65174000"
                    },
                    {
                        "id": 23006,
                        "name": "Přáslavice",
                        "latitude": "49.58568000",
                        "longitude": "17.38209000"
                    },
                    {
                        "id": 23000,
                        "name": "Přemyslovice",
                        "latitude": "49.55637000",
                        "longitude": "16.95581000"
                    },
                    {
                        "id": 23001,
                        "name": "Přerov",
                        "latitude": "49.45511000",
                        "longitude": "17.45090000"
                    },
                    {
                        "id": 23009,
                        "name": "Příkazy",
                        "latitude": "49.64360000",
                        "longitude": "17.14337000"
                    },
                    {
                        "id": 22979,
                        "name": "Prostějov",
                        "latitude": "49.47188000",
                        "longitude": "17.11184000"
                    },
                    {
                        "id": 22981,
                        "name": "Protivanov",
                        "latitude": "49.48351000",
                        "longitude": "16.83594000"
                    },
                    {
                        "id": 22988,
                        "name": "Ptení",
                        "latitude": "49.51163000",
                        "longitude": "16.96110000"
                    },
                    {
                        "id": 23015,
                        "name": "Radslavice",
                        "latitude": "49.47817000",
                        "longitude": "17.51656000"
                    },
                    {
                        "id": 23021,
                        "name": "Rapotín",
                        "latitude": "50.01094000",
                        "longitude": "17.03121000"
                    },
                    {
                        "id": 23029,
                        "name": "Rokytnice",
                        "latitude": "49.46592000",
                        "longitude": "17.39120000"
                    },
                    {
                        "id": 23046,
                        "name": "Ruda nad Moravou",
                        "latitude": "49.98100000",
                        "longitude": "16.87782000"
                    },
                    {
                        "id": 23060,
                        "name": "Samotíšky",
                        "latitude": "49.63042000",
                        "longitude": "17.32807000"
                    },
                    {
                        "id": 23068,
                        "name": "Senice na Hané",
                        "latitude": "49.62401000",
                        "longitude": "17.08578000"
                    },
                    {
                        "id": 23074,
                        "name": "Skrbeň",
                        "latitude": "49.64115000",
                        "longitude": "17.17650000"
                    },
                    {
                        "id": 23078,
                        "name": "Slatinice",
                        "latitude": "49.56155000",
                        "longitude": "17.09992000"
                    },
                    {
                        "id": 23088,
                        "name": "Smržice",
                        "latitude": "49.50569000",
                        "longitude": "17.10698000"
                    },
                    {
                        "id": 23091,
                        "name": "Sobotín",
                        "latitude": "50.01039000",
                        "longitude": "17.09129000"
                    },
                    {
                        "id": 23108,
                        "name": "Staré Město",
                        "latitude": "50.16174000",
                        "longitude": "16.94734000"
                    },
                    {
                        "id": 23429,
                        "name": "Štěpánov",
                        "latitude": "49.68404000",
                        "longitude": "17.22041000"
                    },
                    {
                        "id": 23420,
                        "name": "Šternberk",
                        "latitude": "49.73044000",
                        "longitude": "17.29889000"
                    },
                    {
                        "id": 23425,
                        "name": "Štíty",
                        "latitude": "49.96122000",
                        "longitude": "16.76576000"
                    },
                    {
                        "id": 23130,
                        "name": "Strážná",
                        "latitude": "49.83104000",
                        "longitude": "17.13275000"
                    },
                    {
                        "id": 23144,
                        "name": "Sudkov",
                        "latitude": "49.91903000",
                        "longitude": "16.94516000"
                    },
                    {
                        "id": 23432,
                        "name": "Šumperk",
                        "latitude": "49.96528000",
                        "longitude": "16.97061000"
                    },
                    {
                        "id": 23196,
                        "name": "Těšetice",
                        "latitude": "49.59317000",
                        "longitude": "17.12607000"
                    },
                    {
                        "id": 23171,
                        "name": "Tovačov",
                        "latitude": "49.43083000",
                        "longitude": "17.28795000"
                    },
                    {
                        "id": 23178,
                        "name": "Troubelice",
                        "latitude": "49.81731000",
                        "longitude": "17.08100000"
                    },
                    {
                        "id": 23179,
                        "name": "Troubky",
                        "latitude": "49.43215000",
                        "longitude": "17.34914000"
                    },
                    {
                        "id": 23182,
                        "name": "Tršice",
                        "latitude": "49.54237000",
                        "longitude": "17.42483000"
                    },
                    {
                        "id": 23355,
                        "name": "Újezd",
                        "latitude": "49.76397000",
                        "longitude": "17.18040000"
                    },
                    {
                        "id": 23211,
                        "name": "Uničov",
                        "latitude": "49.77092000",
                        "longitude": "17.12144000"
                    },
                    {
                        "id": 23212,
                        "name": "Určice",
                        "latitude": "49.43045000",
                        "longitude": "17.07291000"
                    },
                    {
                        "id": 23358,
                        "name": "Úsov",
                        "latitude": "49.79831000",
                        "longitude": "17.01055000"
                    },
                    {
                        "id": 23311,
                        "name": "Vápenná",
                        "latitude": "50.28338000",
                        "longitude": "17.09762000"
                    },
                    {
                        "id": 23230,
                        "name": "Velká Bystřice",
                        "latitude": "49.59480000",
                        "longitude": "17.36544000"
                    },
                    {
                        "id": 23242,
                        "name": "Velké Losiny",
                        "latitude": "50.03197000",
                        "longitude": "17.04058000"
                    },
                    {
                        "id": 23253,
                        "name": "Velký Týnec",
                        "latitude": "49.54994000",
                        "longitude": "17.33359000"
                    },
                    {
                        "id": 23254,
                        "name": "Velký Újezd",
                        "latitude": "49.57858000",
                        "longitude": "17.48347000"
                    },
                    {
                        "id": 23314,
                        "name": "Věrovany",
                        "latitude": "49.46109000",
                        "longitude": "17.28795000"
                    },
                    {
                        "id": 23266,
                        "name": "Vidnava",
                        "latitude": "50.37234000",
                        "longitude": "17.18626000"
                    },
                    {
                        "id": 23268,
                        "name": "Vikýřovice",
                        "latitude": "49.97792000",
                        "longitude": "17.01234000"
                    },
                    {
                        "id": 23299,
                        "name": "Vrbátky",
                        "latitude": "49.50805000",
                        "longitude": "17.19994000"
                    },
                    {
                        "id": 23348,
                        "name": "Zábřeh",
                        "latitude": "49.88260000",
                        "longitude": "16.87223000"
                    },
                    {
                        "id": 23339,
                        "name": "Zlaté Hory",
                        "latitude": "50.26380000",
                        "longitude": "17.39602000"
                    },
                    {
                        "id": 23457,
                        "name": "Žulová",
                        "latitude": "50.30933000",
                        "longitude": "17.09871000"
                    }
                ]
            },
            {
                "id": 4623,
                "name": "Opava",
                "iso2": "805",
                "latitude": "49.90837570",
                "longitude": "17.91633800",
                "type": "district",
                "cities": []
            },
            {
                "id": 4584,
                "name": "Ostrava-město",
                "iso2": "806",
                "latitude": "49.82092260",
                "longitude": "18.26252430",
                "type": "district",
                "cities": []
            },
            {
                "id": 4547,
                "name": "Pardubice",
                "iso2": "532",
                "latitude": "50.05559600",
                "longitude": "15.09305880",
                "type": "district",
                "cities": []
            },
            {
                "id": 4588,
                "name": "Pardubický kraj",
                "iso2": "53",
                "latitude": "49.88422200",
                "longitude": "14.79894120",
                "type": "region",
                "cities": [
                    {
                        "id": 22159,
                        "name": "Brandýs nad Orlicí",
                        "latitude": "50.00194000",
                        "longitude": "16.28528000"
                    },
                    {
                        "id": 22212,
                        "name": "Březová nad Svitavou",
                        "latitude": "49.64418000",
                        "longitude": "16.51799000"
                    },
                    {
                        "id": 22167,
                        "name": "Brněnec",
                        "latitude": "49.62735000",
                        "longitude": "16.52202000"
                    },
                    {
                        "id": 22199,
                        "name": "Býšť",
                        "latitude": "50.13243000",
                        "longitude": "15.91116000"
                    },
                    {
                        "id": 22182,
                        "name": "Bystré",
                        "latitude": "49.62846000",
                        "longitude": "16.34679000"
                    },
                    {
                        "id": 22184,
                        "name": "Bystřec",
                        "latitude": "50.01168000",
                        "longitude": "16.61900000"
                    },
                    {
                        "id": 23379,
                        "name": "Červená Voda",
                        "latitude": "50.04029000",
                        "longitude": "16.74268000"
                    },
                    {
                        "id": 23386,
                        "name": "Česká Třebová",
                        "latitude": "49.90436000",
                        "longitude": "16.44413000"
                    },
                    {
                        "id": 22223,
                        "name": "Choceň",
                        "latitude": "50.00161000",
                        "longitude": "16.22303000"
                    },
                    {
                        "id": 22231,
                        "name": "Chrast",
                        "latitude": "49.90205000",
                        "longitude": "15.93396000"
                    },
                    {
                        "id": 22234,
                        "name": "Chroustovice",
                        "latitude": "49.95553000",
                        "longitude": "15.99143000"
                    },
                    {
                        "id": 22235,
                        "name": "Chrudim",
                        "latitude": "49.95109000",
                        "longitude": "15.79558000"
                    },
                    {
                        "id": 22238,
                        "name": "Chvaletice",
                        "latitude": "50.03443000",
                        "longitude": "15.41846000"
                    },
                    {
                        "id": 22253,
                        "name": "Dašice",
                        "latitude": "50.02844000",
                        "longitude": "15.91244000"
                    },
                    {
                        "id": 22256,
                        "name": "Dlouhá Třebová",
                        "latitude": "49.94040000",
                        "longitude": "16.42329000"
                    },
                    {
                        "id": 22297,
                        "name": "Dolní Čermná",
                        "latitude": "49.97954000",
                        "longitude": "16.56475000"
                    },
                    {
                        "id": 22280,
                        "name": "Dolní Dobrouč",
                        "latitude": "49.99273000",
                        "longitude": "16.49766000"
                    },
                    {
                        "id": 22291,
                        "name": "Dolní Roveň",
                        "latitude": "50.02927000",
                        "longitude": "15.96774000"
                    },
                    {
                        "id": 22293,
                        "name": "Dolní Sloupnice",
                        "latitude": "49.92721000",
                        "longitude": "16.29401000"
                    },
                    {
                        "id": 22296,
                        "name": "Dolní Újezd",
                        "latitude": "49.82562000",
                        "longitude": "16.25461000"
                    },
                    {
                        "id": 22352,
                        "name": "Heřmanův Městec",
                        "latitude": "49.94707000",
                        "longitude": "15.66492000"
                    },
                    {
                        "id": 22353,
                        "name": "Hlinsko",
                        "latitude": "49.76213000",
                        "longitude": "15.90756000"
                    },
                    {
                        "id": 22369,
                        "name": "Holice",
                        "latitude": "50.06601000",
                        "longitude": "15.98590000"
                    },
                    {
                        "id": 22393,
                        "name": "Horní Čermná",
                        "latitude": "49.97053000",
                        "longitude": "16.60772000"
                    },
                    {
                        "id": 22380,
                        "name": "Horní Jelení",
                        "latitude": "50.04901000",
                        "longitude": "16.08396000"
                    },
                    {
                        "id": 22389,
                        "name": "Horní Sloupnice",
                        "latitude": "49.92138000",
                        "longitude": "16.33948000"
                    },
                    {
                        "id": 22414,
                        "name": "Hradec nad Svitavou",
                        "latitude": "49.71143000",
                        "longitude": "16.48058000"
                    },
                    {
                        "id": 22420,
                        "name": "Hrochův Týnec",
                        "latitude": "49.95946000",
                        "longitude": "15.91054000"
                    },
                    {
                        "id": 22447,
                        "name": "Jablonné nad Orlicí",
                        "latitude": "50.02964000",
                        "longitude": "16.60059000"
                    },
                    {
                        "id": 22457,
                        "name": "Jaroměřice",
                        "latitude": "49.62556000",
                        "longitude": "16.75185000"
                    },
                    {
                        "id": 22462,
                        "name": "Jedlová",
                        "latitude": "49.66100000",
                        "longitude": "16.30608000"
                    },
                    {
                        "id": 22470,
                        "name": "Jevíčko",
                        "latitude": "49.63220000",
                        "longitude": "16.71125000"
                    },
                    {
                        "id": 22565,
                        "name": "Králíky",
                        "latitude": "50.08384000",
                        "longitude": "16.76054000"
                    },
                    {
                        "id": 22561,
                        "name": "Krouna",
                        "latitude": "49.77240000",
                        "longitude": "16.02674000"
                    },
                    {
                        "id": 22573,
                        "name": "Kunčina",
                        "latitude": "49.79455000",
                        "longitude": "16.62763000"
                    },
                    {
                        "id": 22570,
                        "name": "Kunvald",
                        "latitude": "50.12927000",
                        "longitude": "16.49996000"
                    },
                    {
                        "id": 22590,
                        "name": "Lanškroun",
                        "latitude": "49.91217000",
                        "longitude": "16.61190000"
                    },
                    {
                        "id": 22662,
                        "name": "Lázně Bohdaneč",
                        "latitude": "50.07560000",
                        "longitude": "15.67978000"
                    },
                    {
                        "id": 22597,
                        "name": "Letohrad",
                        "latitude": "50.03580000",
                        "longitude": "16.49879000"
                    },
                    {
                        "id": 22622,
                        "name": "Litomyšl",
                        "latitude": "49.86809000",
                        "longitude": "16.31298000"
                    },
                    {
                        "id": 22649,
                        "name": "Lukavice",
                        "latitude": "50.06029000",
                        "longitude": "16.48207000"
                    },
                    {
                        "id": 22655,
                        "name": "Luže",
                        "latitude": "49.89341000",
                        "longitude": "16.02850000"
                    },
                    {
                        "id": 22739,
                        "name": "Městečko Trnávka",
                        "latitude": "49.70926000",
                        "longitude": "16.72744000"
                    },
                    {
                        "id": 22700,
                        "name": "Miřetice",
                        "latitude": "49.84126000",
                        "longitude": "15.88472000"
                    },
                    {
                        "id": 22714,
                        "name": "Moravany",
                        "latitude": "50.00095000",
                        "longitude": "15.94071000"
                    },
                    {
                        "id": 22718,
                        "name": "Moravská Třebová",
                        "latitude": "49.75793000",
                        "longitude": "16.66426000"
                    },
                    {
                        "id": 22750,
                        "name": "Nasavrky",
                        "latitude": "49.84450000",
                        "longitude": "15.80461000"
                    },
                    {
                        "id": 22814,
                        "name": "Okres Chrudim",
                        "latitude": "49.83333000",
                        "longitude": "15.83333000"
                    },
                    {
                        "id": 22845,
                        "name": "Okres Pardubice",
                        "latitude": "50.08333000",
                        "longitude": "15.75000000"
                    },
                    {
                        "id": 22863,
                        "name": "Okres Svitavy",
                        "latitude": "49.73333000",
                        "longitude": "16.50000000"
                    },
                    {
                        "id": 22875,
                        "name": "Okres Ústí nad Orlicí",
                        "latitude": "50.00000000",
                        "longitude": "16.53333000"
                    },
                    {
                        "id": 22890,
                        "name": "Opatov",
                        "latitude": "49.82500000",
                        "longitude": "16.50458000"
                    },
                    {
                        "id": 22891,
                        "name": "Opatovice nad Labem",
                        "latitude": "50.14541000",
                        "longitude": "15.79045000"
                    },
                    {
                        "id": 22911,
                        "name": "Osík",
                        "latitude": "49.84355000",
                        "longitude": "16.28467000"
                    },
                    {
                        "id": 22919,
                        "name": "Pardubice",
                        "latitude": "50.04075000",
                        "longitude": "15.77659000"
                    },
                    {
                        "id": 22952,
                        "name": "Polička",
                        "latitude": "49.71465000",
                        "longitude": "16.26543000"
                    },
                    {
                        "id": 22954,
                        "name": "Pomezí",
                        "latitude": "49.71026000",
                        "longitude": "16.31729000"
                    },
                    {
                        "id": 22969,
                        "name": "Prachovice",
                        "latitude": "49.89379000",
                        "longitude": "15.62872000"
                    },
                    {
                        "id": 22999,
                        "name": "Přelouč",
                        "latitude": "50.03985000",
                        "longitude": "15.56031000"
                    },
                    {
                        "id": 22978,
                        "name": "Proseč",
                        "latitude": "49.80590000",
                        "longitude": "16.11621000"
                    },
                    {
                        "id": 23011,
                        "name": "Radiměř",
                        "latitude": "49.69850000",
                        "longitude": "16.44070000"
                    },
                    {
                        "id": 23404,
                        "name": "Řečany nad Labem",
                        "latitude": "50.03589000",
                        "longitude": "15.47735000"
                    },
                    {
                        "id": 23032,
                        "name": "Ronov nad Doubravou",
                        "latitude": "49.88825000",
                        "longitude": "15.53144000"
                    },
                    {
                        "id": 23034,
                        "name": "Rosice",
                        "latitude": "49.92226000",
                        "longitude": "15.95127000"
                    },
                    {
                        "id": 23051,
                        "name": "Rybitví",
                        "latitude": "50.06015000",
                        "longitude": "15.70472000"
                    },
                    {
                        "id": 23072,
                        "name": "Seč",
                        "latitude": "49.84694000",
                        "longitude": "15.65643000"
                    },
                    {
                        "id": 23070,
                        "name": "Sezemice",
                        "latitude": "50.06651000",
                        "longitude": "15.85270000"
                    },
                    {
                        "id": 23076,
                        "name": "Skuteč",
                        "latitude": "49.84347000",
                        "longitude": "15.99655000"
                    },
                    {
                        "id": 23079,
                        "name": "Slatiňany",
                        "latitude": "49.92110000",
                        "longitude": "15.81377000"
                    },
                    {
                        "id": 23103,
                        "name": "Staré Hradiště",
                        "latitude": "50.06540000",
                        "longitude": "15.77885000"
                    },
                    {
                        "id": 23149,
                        "name": "Svitavy",
                        "latitude": "49.75594000",
                        "longitude": "16.46829000"
                    },
                    {
                        "id": 23202,
                        "name": "Třemošnice",
                        "latitude": "49.86912000",
                        "longitude": "15.58002000"
                    },
                    {
                        "id": 23359,
                        "name": "Ústí nad Orlicí",
                        "latitude": "49.97387000",
                        "longitude": "16.39361000"
                    },
                    {
                        "id": 23305,
                        "name": "Vysoké Mýto",
                        "latitude": "49.95320000",
                        "longitude": "16.16169000"
                    },
                    {
                        "id": 23437,
                        "name": "Žamberk",
                        "latitude": "50.08601000",
                        "longitude": "16.46738000"
                    }
                ]
            },
            {
                "id": 4645,
                "name": "Pelhřimov",
                "iso2": "633",
                "latitude": "49.43062070",
                "longitude": "15.22298300",
                "type": "district",
                "cities": []
            },
            {
                "id": 4560,
                "name": "Písek",
                "iso2": "314",
                "latitude": "49.34199380",
                "longitude": "14.24697600",
                "type": "district",
                "cities": []
            },
            {
                "id": 4608,
                "name": "Plzeň-jih",
                "iso2": "324",
                "latitude": "49.59048850",
                "longitude": "13.57158610",
                "type": "district",
                "cities": [
                    {
                        "id": 22201,
                        "name": "Bělá nad Radbuzou",
                        "latitude": "49.59115000",
                        "longitude": "12.71761000"
                    },
                    {
                        "id": 22127,
                        "name": "Bezdružice",
                        "latitude": "49.90724000",
                        "longitude": "12.97110000"
                    },
                    {
                        "id": 22135,
                        "name": "Blížejov",
                        "latitude": "49.50000000",
                        "longitude": "12.98926000"
                    },
                    {
                        "id": 22132,
                        "name": "Blovice",
                        "latitude": "49.58220000",
                        "longitude": "13.54009000"
                    },
                    {
                        "id": 22146,
                        "name": "Bor",
                        "latitude": "49.71159000",
                        "longitude": "12.77516000"
                    },
                    {
                        "id": 22203,
                        "name": "Břasy",
                        "latitude": "49.83700000",
                        "longitude": "13.57833000"
                    },
                    {
                        "id": 23373,
                        "name": "Černošín",
                        "latitude": "49.81613000",
                        "longitude": "12.88381000"
                    },
                    {
                        "id": 22222,
                        "name": "Chlumčany",
                        "latitude": "49.63256000",
                        "longitude": "13.31323000"
                    },
                    {
                        "id": 22225,
                        "name": "Chodová Planá",
                        "latitude": "49.89321000",
                        "longitude": "12.73014000"
                    },
                    {
                        "id": 22230,
                        "name": "Chotěšov",
                        "latitude": "49.65408000",
                        "longitude": "13.20271000"
                    },
                    {
                        "id": 22236,
                        "name": "Chrást",
                        "latitude": "49.79320000",
                        "longitude": "13.49358000"
                    },
                    {
                        "id": 22263,
                        "name": "Dobřany",
                        "latitude": "49.65482000",
                        "longitude": "13.29307000"
                    },
                    {
                        "id": 22265,
                        "name": "Dobřív",
                        "latitude": "49.71566000",
                        "longitude": "13.68681000"
                    },
                    {
                        "id": 22303,
                        "name": "Domažlice",
                        "latitude": "49.44049000",
                        "longitude": "12.92976000"
                    },
                    {
                        "id": 22320,
                        "name": "Dýšina",
                        "latitude": "49.77735000",
                        "longitude": "13.49150000"
                    },
                    {
                        "id": 22343,
                        "name": "Hartmanice",
                        "latitude": "49.16948000",
                        "longitude": "13.45455000"
                    },
                    {
                        "id": 22351,
                        "name": "Heřmanova Huť",
                        "latitude": "49.70679000",
                        "longitude": "13.10069000"
                    },
                    {
                        "id": 22370,
                        "name": "Holoubkov",
                        "latitude": "49.77598000",
                        "longitude": "13.69246000"
                    },
                    {
                        "id": 22371,
                        "name": "Holýšov",
                        "latitude": "49.59361000",
                        "longitude": "13.10129000"
                    },
                    {
                        "id": 22372,
                        "name": "Horažďovice",
                        "latitude": "49.32069000",
                        "longitude": "13.70100000"
                    },
                    {
                        "id": 22378,
                        "name": "Horní Bříza",
                        "latitude": "49.84012000",
                        "longitude": "13.35558000"
                    },
                    {
                        "id": 22396,
                        "name": "Horšovský Týn",
                        "latitude": "49.52965000",
                        "longitude": "12.94405000"
                    },
                    {
                        "id": 22402,
                        "name": "Hostouň",
                        "latitude": "49.55971000",
                        "longitude": "12.77147000"
                    },
                    {
                        "id": 22430,
                        "name": "Hrádek",
                        "latitude": "49.71316000",
                        "longitude": "13.65296000"
                    },
                    {
                        "id": 22421,
                        "name": "Hromnice",
                        "latitude": "49.84907000",
                        "longitude": "13.44146000"
                    },
                    {
                        "id": 22455,
                        "name": "Janovice nad Úhlavou",
                        "latitude": "49.34515000",
                        "longitude": "13.21813000"
                    },
                    {
                        "id": 22502,
                        "name": "Kasejovice",
                        "latitude": "49.46270000",
                        "longitude": "13.74060000"
                    },
                    {
                        "id": 22506,
                        "name": "Kašperské Hory",
                        "latitude": "49.14289000",
                        "longitude": "13.55616000"
                    },
                    {
                        "id": 22504,
                        "name": "Kaznějov",
                        "latitude": "49.89313000",
                        "longitude": "13.38295000"
                    },
                    {
                        "id": 22508,
                        "name": "Kdyně",
                        "latitude": "49.39077000",
                        "longitude": "13.03968000"
                    },
                    {
                        "id": 22511,
                        "name": "Kladruby",
                        "latitude": "49.71498000",
                        "longitude": "12.98232000"
                    },
                    {
                        "id": 22512,
                        "name": "Klatovy",
                        "latitude": "49.39552000",
                        "longitude": "13.29505000"
                    },
                    {
                        "id": 22514,
                        "name": "Klenčí pod Čerchovem",
                        "latitude": "49.43484000",
                        "longitude": "12.81473000"
                    },
                    {
                        "id": 22528,
                        "name": "Kolinec",
                        "latitude": "49.29895000",
                        "longitude": "13.43900000"
                    },
                    {
                        "id": 22543,
                        "name": "Kout na Šumavě",
                        "latitude": "49.40255000",
                        "longitude": "13.00208000"
                    },
                    {
                        "id": 22552,
                        "name": "Kožlany",
                        "latitude": "49.99389000",
                        "longitude": "13.54107000"
                    },
                    {
                        "id": 22554,
                        "name": "Kralovice",
                        "latitude": "49.98192000",
                        "longitude": "13.48747000"
                    },
                    {
                        "id": 22666,
                        "name": "Líně",
                        "latitude": "49.69472000",
                        "longitude": "13.25693000"
                    },
                    {
                        "id": 22675,
                        "name": "Manětín",
                        "latitude": "49.99177000",
                        "longitude": "13.23319000"
                    },
                    {
                        "id": 22745,
                        "name": "Měčín",
                        "latitude": "49.48009000",
                        "longitude": "13.40289000"
                    },
                    {
                        "id": 22678,
                        "name": "Meclov",
                        "latitude": "49.50556000",
                        "longitude": "12.88082000"
                    },
                    {
                        "id": 22680,
                        "name": "Merklín",
                        "latitude": "49.56043000",
                        "longitude": "13.19790000"
                    },
                    {
                        "id": 22744,
                        "name": "Město Touškov",
                        "latitude": "49.77587000",
                        "longitude": "13.25108000"
                    },
                    {
                        "id": 22698,
                        "name": "Mirošov",
                        "latitude": "49.68782000",
                        "longitude": "13.65807000"
                    },
                    {
                        "id": 22731,
                        "name": "Mrákov",
                        "latitude": "49.40314000",
                        "longitude": "12.95120000"
                    },
                    {
                        "id": 22734,
                        "name": "Mýto",
                        "latitude": "49.78904000",
                        "longitude": "13.73461000"
                    },
                    {
                        "id": 22759,
                        "name": "Nepomuk",
                        "latitude": "49.48616000",
                        "longitude": "13.58225000"
                    },
                    {
                        "id": 22766,
                        "name": "Nezvěstice",
                        "latitude": "49.64043000",
                        "longitude": "13.51962000"
                    },
                    {
                        "id": 22799,
                        "name": "Nýřany",
                        "latitude": "49.71145000",
                        "longitude": "13.21185000"
                    },
                    {
                        "id": 22798,
                        "name": "Nýrsko",
                        "latitude": "49.29387000",
                        "longitude": "13.14353000"
                    },
                    {
                        "id": 22815,
                        "name": "Okres Domažlice",
                        "latitude": "49.50000000",
                        "longitude": "12.91667000"
                    },
                    {
                        "id": 22829,
                        "name": "Okres Klatovy",
                        "latitude": "49.25000000",
                        "longitude": "13.41667000"
                    },
                    {
                        "id": 22847,
                        "name": "Okres Plzeň-jih",
                        "latitude": "49.58333000",
                        "longitude": "13.50000000"
                    },
                    {
                        "id": 22848,
                        "name": "Okres Plzeň-město",
                        "latitude": "49.75000000",
                        "longitude": "13.36667000"
                    },
                    {
                        "id": 22849,
                        "name": "Okres Plzeň-sever",
                        "latitude": "49.91667000",
                        "longitude": "13.25000000"
                    },
                    {
                        "id": 22858,
                        "name": "Okres Rokycany",
                        "latitude": "49.78333000",
                        "longitude": "13.66667000"
                    },
                    {
                        "id": 22864,
                        "name": "Okres Tachov",
                        "latitude": "49.76667000",
                        "longitude": "12.75000000"
                    },
                    {
                        "id": 22896,
                        "name": "Osek",
                        "latitude": "49.77594000",
                        "longitude": "13.59060000"
                    },
                    {
                        "id": 22934,
                        "name": "Pilsen",
                        "latitude": "49.74747000",
                        "longitude": "13.37759000"
                    },
                    {
                        "id": 22935,
                        "name": "Planá",
                        "latitude": "49.86816000",
                        "longitude": "12.74378000"
                    },
                    {
                        "id": 22942,
                        "name": "Plánice",
                        "latitude": "49.38993000",
                        "longitude": "13.47106000"
                    },
                    {
                        "id": 22937,
                        "name": "Plasy",
                        "latitude": "49.93449000",
                        "longitude": "13.39035000"
                    },
                    {
                        "id": 22943,
                        "name": "Poběžovice",
                        "latitude": "49.51029000",
                        "longitude": "12.80261000"
                    },
                    {
                        "id": 22959,
                        "name": "Postřekov",
                        "latitude": "49.45827000",
                        "longitude": "12.80678000"
                    },
                    {
                        "id": 23003,
                        "name": "Přeštice",
                        "latitude": "49.57298000",
                        "longitude": "13.33350000"
                    },
                    {
                        "id": 23005,
                        "name": "Přimda",
                        "latitude": "49.67488000",
                        "longitude": "12.67366000"
                    },
                    {
                        "id": 23012,
                        "name": "Radnice",
                        "latitude": "49.85677000",
                        "longitude": "13.60570000"
                    },
                    {
                        "id": 23028,
                        "name": "Rokycany",
                        "latitude": "49.74270000",
                        "longitude": "13.59459000"
                    },
                    {
                        "id": 23097,
                        "name": "Spálené Poříčí",
                        "latitude": "49.61371000",
                        "longitude": "13.60556000"
                    },
                    {
                        "id": 23434,
                        "name": "Šťáhlavy",
                        "latitude": "49.67555000",
                        "longitude": "13.50394000"
                    },
                    {
                        "id": 23114,
                        "name": "Staňkov",
                        "latitude": "49.55348000",
                        "longitude": "13.06976000"
                    },
                    {
                        "id": 23113,
                        "name": "Starý Plzenec",
                        "latitude": "49.69768000",
                        "longitude": "13.47350000"
                    },
                    {
                        "id": 23427,
                        "name": "Štěnovice",
                        "latitude": "49.67051000",
                        "longitude": "13.39963000"
                    },
                    {
                        "id": 23118,
                        "name": "Stod",
                        "latitude": "49.63909000",
                        "longitude": "13.16474000"
                    },
                    {
                        "id": 23122,
                        "name": "Strašice",
                        "latitude": "49.73552000",
                        "longitude": "13.75755000"
                    },
                    {
                        "id": 23126,
                        "name": "Stráž",
                        "latitude": "49.66878000",
                        "longitude": "12.77546000"
                    },
                    {
                        "id": 23131,
                        "name": "Strážov",
                        "latitude": "49.30326000",
                        "longitude": "13.24623000"
                    },
                    {
                        "id": 23138,
                        "name": "Stříbro",
                        "latitude": "49.75565000",
                        "longitude": "12.99700000"
                    },
                    {
                        "id": 23146,
                        "name": "Sušice",
                        "latitude": "49.23106000",
                        "longitude": "13.52018000"
                    },
                    {
                        "id": 23433,
                        "name": "Švihov",
                        "latitude": "49.48136000",
                        "longitude": "13.28417000"
                    },
                    {
                        "id": 23155,
                        "name": "Tachov",
                        "latitude": "49.79528000",
                        "longitude": "12.63365000"
                    },
                    {
                        "id": 23168,
                        "name": "Tlučná",
                        "latitude": "49.72425000",
                        "longitude": "13.23534000"
                    },
                    {
                        "id": 23203,
                        "name": "Třemošná",
                        "latitude": "49.81584000",
                        "longitude": "13.39499000"
                    },
                    {
                        "id": 23224,
                        "name": "Vejprnice",
                        "latitude": "49.72988000",
                        "longitude": "13.27628000"
                    },
                    {
                        "id": 23319,
                        "name": "Všeruby",
                        "latitude": "49.84167000",
                        "longitude": "13.22943000"
                    },
                    {
                        "id": 23328,
                        "name": "Zbiroh",
                        "latitude": "49.86024000",
                        "longitude": "13.77262000"
                    },
                    {
                        "id": 23333,
                        "name": "Zbůch",
                        "latitude": "49.67840000",
                        "longitude": "13.22564000"
                    },
                    {
                        "id": 23444,
                        "name": "Železná Ruda",
                        "latitude": "49.13743000",
                        "longitude": "13.23520000"
                    },
                    {
                        "id": 23450,
                        "name": "Žihle",
                        "latitude": "50.04491000",
                        "longitude": "13.37502000"
                    }
                ]
            },
            {
                "id": 4544,
                "name": "Plzeň-město",
                "iso2": "323",
                "latitude": "49.73843140",
                "longitude": "13.37363710",
                "type": "district",
                "cities": []
            },
            {
                "id": 4564,
                "name": "Plzeň-sever",
                "iso2": "325",
                "latitude": "49.87748930",
                "longitude": "13.25374280",
                "type": "district",
                "cities": []
            },
            {
                "id": 4607,
                "name": "Plzeňský kraj",
                "iso2": "32",
                "latitude": "49.41348120",
                "longitude": "13.31572460",
                "type": "region",
                "cities": []
            },
            {
                "id": 4578,
                "name": "Prachatice",
                "iso2": "315",
                "latitude": "49.01091000",
                "longitude": "14.00000050",
                "type": "district",
                "cities": []
            },
            {
                "id": 4606,
                "name": "Praha-východ",
                "iso2": "209",
                "latitude": "49.93893070",
                "longitude": "14.79244720",
                "type": "district",
                "cities": []
            },
            {
                "id": 4619,
                "name": "Praha-západ",
                "iso2": "20A",
                "latitude": "49.89352350",
                "longitude": "14.32937790",
                "type": "district",
                "cities": []
            },
            {
                "id": 4598,
                "name": "Praha, Hlavní město",
                "iso2": "10",
                "latitude": "50.07553810",
                "longitude": "14.43780050",
                "type": "capital city",
                "cities": [
                    {
                        "id": 22162,
                        "name": "Braník",
                        "latitude": "50.03498000",
                        "longitude": "14.41518000"
                    },
                    {
                        "id": 23376,
                        "name": "Černý Most",
                        "latitude": "50.10475000",
                        "longitude": "14.57974000"
                    },
                    {
                        "id": 22290,
                        "name": "Dolní Počernice",
                        "latitude": "50.08760000",
                        "longitude": "14.57199000"
                    },
                    {
                        "id": 22363,
                        "name": "Hodkovičky",
                        "latitude": "50.02346000",
                        "longitude": "14.41415000"
                    },
                    {
                        "id": 22387,
                        "name": "Horní Počernice",
                        "latitude": "50.11210000",
                        "longitude": "14.61036000"
                    },
                    {
                        "id": 22397,
                        "name": "Hostavice",
                        "latitude": "50.09283000",
                        "longitude": "14.55822000"
                    },
                    {
                        "id": 22499,
                        "name": "Karlín",
                        "latitude": "50.09272000",
                        "longitude": "14.44711000"
                    },
                    {
                        "id": 22507,
                        "name": "Kbely",
                        "latitude": "50.13333000",
                        "longitude": "14.55000000"
                    },
                    {
                        "id": 22600,
                        "name": "Letňany",
                        "latitude": "50.13333000",
                        "longitude": "14.51667000"
                    },
                    {
                        "id": 22605,
                        "name": "Libeň",
                        "latitude": "50.10819000",
                        "longitude": "14.47457000"
                    },
                    {
                        "id": 22672,
                        "name": "Malá Strana",
                        "latitude": "50.08774000",
                        "longitude": "14.40449000"
                    },
                    {
                        "id": 22708,
                        "name": "Modřany",
                        "latitude": "50.01116000",
                        "longitude": "14.40960000"
                    },
                    {
                        "id": 22970,
                        "name": "Prague",
                        "latitude": "50.08804000",
                        "longitude": "14.42076000"
                    },
                    {
                        "id": 22971,
                        "name": "Praha 1",
                        "latitude": "50.08802000",
                        "longitude": "14.42166000"
                    },
                    {
                        "id": 22972,
                        "name": "Praha 16",
                        "latitude": "49.98357000",
                        "longitude": "14.36110000"
                    },
                    {
                        "id": 22973,
                        "name": "Praha 20",
                        "latitude": "50.11568000",
                        "longitude": "14.61122000"
                    },
                    {
                        "id": 22974,
                        "name": "Praha 21",
                        "latitude": "50.07521000",
                        "longitude": "14.66898000"
                    },
                    {
                        "id": 22977,
                        "name": "Prosek",
                        "latitude": "50.11525000",
                        "longitude": "14.50685000"
                    },
                    {
                        "id": 23061,
                        "name": "Satalice",
                        "latitude": "50.12484000",
                        "longitude": "14.57191000"
                    },
                    {
                        "id": 23106,
                        "name": "Staré Město",
                        "latitude": "50.08700000",
                        "longitude": "14.42024000"
                    },
                    {
                        "id": 23139,
                        "name": "Střížkov",
                        "latitude": "50.12674000",
                        "longitude": "14.49363000"
                    },
                    {
                        "id": 23304,
                        "name": "Vysehrad",
                        "latitude": "50.06509000",
                        "longitude": "14.41711000"
                    },
                    {
                        "id": 23307,
                        "name": "Vysočany",
                        "latitude": "50.10938000",
                        "longitude": "14.51667000"
                    }
                ]
            },
            {
                "id": 4626,
                "name": "Přerov",
                "iso2": "714",
                "latitude": "49.46713560",
                "longitude": "17.50773320",
                "type": "district",
                "cities": []
            },
            {
                "id": 4546,
                "name": "Příbram",
                "iso2": "20B",
                "latitude": "49.69479590",
                "longitude": "14.08238100",
                "type": "district",
                "cities": []
            },
            {
                "id": 4551,
                "name": "Prostějov",
                "iso2": "713",
                "latitude": "49.44184010",
                "longitude": "17.12779040",
                "type": "district",
                "cities": []
            },
            {
                "id": 4558,
                "name": "Rakovník",
                "iso2": "20C",
                "latitude": "50.10612300",
                "longitude": "13.73966230",
                "type": "district",
                "cities": []
            },
            {
                "id": 4583,
                "name": "Rokycany",
                "iso2": "326",
                "latitude": "49.82628270",
                "longitude": "13.68749430",
                "type": "district",
                "cities": []
            },
            {
                "id": 4636,
                "name": "Rychnov nad Kněžnou",
                "iso2": "524",
                "latitude": "50.16596510",
                "longitude": "16.27768420",
                "type": "district",
                "cities": []
            },
            {
                "id": 4596,
                "name": "Semily",
                "iso2": "514",
                "latitude": "50.60515760",
                "longitude": "15.32814090",
                "type": "district",
                "cities": []
            },
            {
                "id": 4595,
                "name": "Sokolov",
                "iso2": "413",
                "latitude": "50.20134340",
                "longitude": "12.60546360",
                "type": "district",
                "cities": []
            },
            {
                "id": 4628,
                "name": "Strakonice",
                "iso2": "316",
                "latitude": "49.26040430",
                "longitude": "13.91030850",
                "type": "district",
                "cities": []
            },
            {
                "id": 4554,
                "name": "Středočeský kraj",
                "iso2": "20",
                "latitude": "49.87822230",
                "longitude": "14.93629550",
                "type": "region",
                "cities": [
                    {
                        "id": 22112,
                        "name": "Bakov nad Jizerou",
                        "latitude": "50.48230000",
                        "longitude": "14.94149000"
                    },
                    {
                        "id": 22202,
                        "name": "Bělá pod Bezdězem",
                        "latitude": "50.50121000",
                        "longitude": "14.80418000"
                    },
                    {
                        "id": 22124,
                        "name": "Benátky nad Jizerou",
                        "latitude": "50.29085000",
                        "longitude": "14.82343000"
                    },
                    {
                        "id": 22121,
                        "name": "Benešov",
                        "latitude": "49.78162000",
                        "longitude": "14.68697000"
                    },
                    {
                        "id": 22126,
                        "name": "Beroun",
                        "latitude": "49.96382000",
                        "longitude": "14.07200000"
                    },
                    {
                        "id": 22141,
                        "name": "Bohutín",
                        "latitude": "49.65551000",
                        "longitude": "13.94389000"
                    },
                    {
                        "id": 22158,
                        "name": "Brandýs nad Labem-Stará Boleslav",
                        "latitude": "50.18709000",
                        "longitude": "14.66326000"
                    },
                    {
                        "id": 22160,
                        "name": "Brandýsek",
                        "latitude": "50.18923000",
                        "longitude": "14.16199000"
                    },
                    {
                        "id": 22206,
                        "name": "Březnice",
                        "latitude": "49.55763000",
                        "longitude": "13.95063000"
                    },
                    {
                        "id": 22181,
                        "name": "Buštěhrad",
                        "latitude": "50.15594000",
                        "longitude": "14.18897000"
                    },
                    {
                        "id": 22189,
                        "name": "Byšice",
                        "latitude": "50.31044000",
                        "longitude": "14.61136000"
                    },
                    {
                        "id": 22185,
                        "name": "Bystřice",
                        "latitude": "49.73213000",
                        "longitude": "14.66740000"
                    },
                    {
                        "id": 23398,
                        "name": "Čáslav",
                        "latitude": "49.91099000",
                        "longitude": "15.38972000"
                    },
                    {
                        "id": 23364,
                        "name": "Čechtice",
                        "latitude": "49.62403000",
                        "longitude": "15.04824000"
                    },
                    {
                        "id": 23369,
                        "name": "Čelákovice",
                        "latitude": "50.16038000",
                        "longitude": "14.75005000"
                    },
                    {
                        "id": 23382,
                        "name": "Čerčany",
                        "latitude": "49.85293000",
                        "longitude": "14.70299000"
                    },
                    {
                        "id": 22215,
                        "name": "Cerhenice",
                        "latitude": "50.07127000",
                        "longitude": "15.07203000"
                    },
                    {
                        "id": 23372,
                        "name": "Černošice",
                        "latitude": "49.96008000",
                        "longitude": "14.31979000"
                    },
                    {
                        "id": 23380,
                        "name": "Červené Pečky",
                        "latitude": "49.97822000",
                        "longitude": "15.20856000"
                    },
                    {
                        "id": 23391,
                        "name": "Český Brod",
                        "latitude": "50.07420000",
                        "longitude": "14.86081000"
                    },
                    {
                        "id": 22241,
                        "name": "Chyňava",
                        "latitude": "50.02736000",
                        "longitude": "14.07398000"
                    },
                    {
                        "id": 22246,
                        "name": "Církvice",
                        "latitude": "49.94560000",
                        "longitude": "15.33505000"
                    },
                    {
                        "id": 22247,
                        "name": "Cítov",
                        "latitude": "50.37225000",
                        "longitude": "14.39813000"
                    },
                    {
                        "id": 22251,
                        "name": "Davle",
                        "latitude": "49.89218000",
                        "longitude": "14.40037000"
                    },
                    {
                        "id": 22255,
                        "name": "Divišov",
                        "latitude": "49.78849000",
                        "longitude": "14.87579000"
                    },
                    {
                        "id": 22264,
                        "name": "Dobřichovice",
                        "latitude": "49.92749000",
                        "longitude": "14.27469000"
                    },
                    {
                        "id": 22266,
                        "name": "Dobříš",
                        "latitude": "49.78113000",
                        "longitude": "14.16717000"
                    },
                    {
                        "id": 22260,
                        "name": "Dobrovice",
                        "latitude": "50.36933000",
                        "longitude": "14.96233000"
                    },
                    {
                        "id": 22268,
                        "name": "Doksy",
                        "latitude": "50.11900000",
                        "longitude": "14.04782000"
                    },
                    {
                        "id": 22273,
                        "name": "Dolní Beřkovice",
                        "latitude": "50.39313000",
                        "longitude": "14.45024000"
                    },
                    {
                        "id": 22276,
                        "name": "Dolní Bousov",
                        "latitude": "50.43825000",
                        "longitude": "15.12812000"
                    },
                    {
                        "id": 22278,
                        "name": "Dolní Břežany",
                        "latitude": "49.96321000",
                        "longitude": "14.45850000"
                    },
                    {
                        "id": 22386,
                        "name": "Horní Počaply",
                        "latitude": "50.42440000",
                        "longitude": "14.38993000"
                    },
                    {
                        "id": 22395,
                        "name": "Horoměřice",
                        "latitude": "50.13173000",
                        "longitude": "14.33879000"
                    },
                    {
                        "id": 22408,
                        "name": "Hořovice",
                        "latitude": "49.83597000",
                        "longitude": "13.90268000"
                    },
                    {
                        "id": 22399,
                        "name": "Hostivice",
                        "latitude": "50.08158000",
                        "longitude": "14.25856000"
                    },
                    {
                        "id": 22401,
                        "name": "Hostomice",
                        "latitude": "49.82526000",
                        "longitude": "14.04560000"
                    },
                    {
                        "id": 22405,
                        "name": "Hovorčovice",
                        "latitude": "50.17866000",
                        "longitude": "14.51789000"
                    },
                    {
                        "id": 22415,
                        "name": "Hradištko",
                        "latitude": "49.86828000",
                        "longitude": "14.40935000"
                    },
                    {
                        "id": 22442,
                        "name": "Hřebeč",
                        "latitude": "50.13595000",
                        "longitude": "14.16446000"
                    },
                    {
                        "id": 22432,
                        "name": "Hudlice",
                        "latitude": "49.96096000",
                        "longitude": "13.97063000"
                    },
                    {
                        "id": 22441,
                        "name": "Hýskov",
                        "latitude": "49.99072000",
                        "longitude": "14.05055000"
                    },
                    {
                        "id": 22465,
                        "name": "Jeneč",
                        "latitude": "50.08730000",
                        "longitude": "14.21482000"
                    },
                    {
                        "id": 22466,
                        "name": "Jesenice",
                        "latitude": "49.96814000",
                        "longitude": "14.51350000"
                    },
                    {
                        "id": 22486,
                        "name": "Jílové u Prahy",
                        "latitude": "49.89545000",
                        "longitude": "14.49333000"
                    },
                    {
                        "id": 22474,
                        "name": "Jince",
                        "latitude": "49.78624000",
                        "longitude": "13.97867000"
                    },
                    {
                        "id": 22478,
                        "name": "Jirny",
                        "latitude": "50.11578000",
                        "longitude": "14.69923000"
                    },
                    {
                        "id": 22505,
                        "name": "Kačice",
                        "latitude": "50.16261000",
                        "longitude": "13.98815000"
                    },
                    {
                        "id": 22489,
                        "name": "Kamenice",
                        "latitude": "49.90151000",
                        "longitude": "14.58242000"
                    },
                    {
                        "id": 22492,
                        "name": "Kamenné Žehrovice",
                        "latitude": "50.12697000",
                        "longitude": "14.01809000"
                    },
                    {
                        "id": 22493,
                        "name": "Kamenný Přívoz",
                        "latitude": "49.86299000",
                        "longitude": "14.50339000"
                    },
                    {
                        "id": 22510,
                        "name": "Kladno",
                        "latitude": "50.14734000",
                        "longitude": "14.10285000"
                    },
                    {
                        "id": 22513,
                        "name": "Klecany",
                        "latitude": "50.17599000",
                        "longitude": "14.41148000"
                    },
                    {
                        "id": 22517,
                        "name": "Klobuky",
                        "latitude": "50.29401000",
                        "longitude": "13.98748000"
                    },
                    {
                        "id": 22522,
                        "name": "Kněžmost",
                        "latitude": "50.48917000",
                        "longitude": "15.03829000"
                    },
                    {
                        "id": 22529,
                        "name": "Kolín",
                        "latitude": "50.02806000",
                        "longitude": "15.19980000"
                    },
                    {
                        "id": 22531,
                        "name": "Komárov",
                        "latitude": "49.80650000",
                        "longitude": "13.85636000"
                    },
                    {
                        "id": 22536,
                        "name": "Kosmonosy",
                        "latitude": "50.43850000",
                        "longitude": "14.93000000"
                    },
                    {
                        "id": 22537,
                        "name": "Kosova Hora",
                        "latitude": "49.65414000",
                        "longitude": "14.47173000"
                    },
                    {
                        "id": 22541,
                        "name": "Kostelec nad Černými Lesy",
                        "latitude": "49.99403000",
                        "longitude": "14.85922000"
                    },
                    {
                        "id": 22539,
                        "name": "Kostelec nad Labem",
                        "latitude": "50.22653000",
                        "longitude": "14.58552000"
                    },
                    {
                        "id": 22544,
                        "name": "Kouřim",
                        "latitude": "50.00306000",
                        "longitude": "14.97703000"
                    },
                    {
                        "id": 22555,
                        "name": "Kralupy nad Vltavou",
                        "latitude": "50.24107000",
                        "longitude": "14.31149000"
                    },
                    {
                        "id": 22566,
                        "name": "Králův Dvůr",
                        "latitude": "49.94981000",
                        "longitude": "14.03445000"
                    },
                    {
                        "id": 22567,
                        "name": "Krásná Hora nad Vltavou",
                        "latitude": "49.60461000",
                        "longitude": "14.27742000"
                    },
                    {
                        "id": 22587,
                        "name": "Křinec",
                        "latitude": "50.26449000",
                        "longitude": "15.13782000"
                    },
                    {
                        "id": 22576,
                        "name": "Kutná Hora",
                        "latitude": "49.94839000",
                        "longitude": "15.26816000"
                    },
                    {
                        "id": 22661,
                        "name": "Lány",
                        "latitude": "50.12471000",
                        "longitude": "13.95041000"
                    },
                    {
                        "id": 22612,
                        "name": "Libčice nad Vltavou",
                        "latitude": "50.19778000",
                        "longitude": "14.36385000"
                    },
                    {
                        "id": 22665,
                        "name": "Líbeznice",
                        "latitude": "50.19198000",
                        "longitude": "14.49357000"
                    },
                    {
                        "id": 22606,
                        "name": "Libice nad Cidlinou",
                        "latitude": "50.12677000",
                        "longitude": "15.17820000"
                    },
                    {
                        "id": 22607,
                        "name": "Libiš",
                        "latitude": "50.27417000",
                        "longitude": "14.50240000"
                    },
                    {
                        "id": 22610,
                        "name": "Libušín",
                        "latitude": "50.16819000",
                        "longitude": "14.05458000"
                    },
                    {
                        "id": 22628,
                        "name": "Lochovice",
                        "latitude": "49.85318000",
                        "longitude": "13.98126000"
                    },
                    {
                        "id": 22629,
                        "name": "Loděnice",
                        "latitude": "49.99486000",
                        "longitude": "14.15785000"
                    },
                    {
                        "id": 22638,
                        "name": "Loučeň",
                        "latitude": "50.28537000",
                        "longitude": "15.02049000"
                    },
                    {
                        "id": 22654,
                        "name": "Luštěnice",
                        "latitude": "50.32296000",
                        "longitude": "14.93667000"
                    },
                    {
                        "id": 22656,
                        "name": "Lužec nad Vltavou",
                        "latitude": "50.32138000",
                        "longitude": "14.40022000"
                    },
                    {
                        "id": 22658,
                        "name": "Lužná",
                        "latitude": "50.12377000",
                        "longitude": "13.77004000"
                    },
                    {
                        "id": 22660,
                        "name": "Lysá nad Labem",
                        "latitude": "50.20143000",
                        "longitude": "14.83281000"
                    },
                    {
                        "id": 22736,
                        "name": "Mělník",
                        "latitude": "50.35050000",
                        "longitude": "14.47411000"
                    },
                    {
                        "id": 22747,
                        "name": "Měšice",
                        "latitude": "50.19799000",
                        "longitude": "14.51992000"
                    },
                    {
                        "id": 22738,
                        "name": "Městec Králové",
                        "latitude": "50.20718000",
                        "longitude": "15.29758000"
                    },
                    {
                        "id": 22693,
                        "name": "Milín",
                        "latitude": "49.63192000",
                        "longitude": "14.04600000"
                    },
                    {
                        "id": 22691,
                        "name": "Milovice",
                        "latitude": "50.22596000",
                        "longitude": "14.88863000"
                    },
                    {
                        "id": 22701,
                        "name": "Mladá Boleslav",
                        "latitude": "50.41135000",
                        "longitude": "14.90318000"
                    },
                    {
                        "id": 22704,
                        "name": "Mnichovice",
                        "latitude": "49.93601000",
                        "longitude": "14.70907000"
                    },
                    {
                        "id": 22705,
                        "name": "Mnichovo Hradiště",
                        "latitude": "50.52720000",
                        "longitude": "14.97134000"
                    },
                    {
                        "id": 22707,
                        "name": "Mníšek pod Brdy",
                        "latitude": "49.86650000",
                        "longitude": "14.26176000"
                    },
                    {
                        "id": 22748,
                        "name": "Mšeno",
                        "latitude": "50.43809000",
                        "longitude": "14.63250000"
                    },
                    {
                        "id": 22732,
                        "name": "Mukařov",
                        "latitude": "49.99115000",
                        "longitude": "14.74155000"
                    },
                    {
                        "id": 22751,
                        "name": "Načeradec",
                        "latitude": "49.61018000",
                        "longitude": "14.90633000"
                    },
                    {
                        "id": 22756,
                        "name": "Nehvizdy",
                        "latitude": "50.13056000",
                        "longitude": "14.72993000"
                    },
                    {
                        "id": 22758,
                        "name": "Nelahozeves",
                        "latitude": "50.26148000",
                        "longitude": "14.29881000"
                    },
                    {
                        "id": 22760,
                        "name": "Neratovice",
                        "latitude": "50.25926000",
                        "longitude": "14.51759000"
                    },
                    {
                        "id": 22763,
                        "name": "Netvořice",
                        "latitude": "49.81569000",
                        "longitude": "14.51827000"
                    },
                    {
                        "id": 22764,
                        "name": "Neveklov",
                        "latitude": "49.75373000",
                        "longitude": "14.53291000"
                    },
                    {
                        "id": 22768,
                        "name": "Nižbor",
                        "latitude": "49.99995000",
                        "longitude": "14.00237000"
                    },
                    {
                        "id": 22782,
                        "name": "Nové Strašecí",
                        "latitude": "50.15272000",
                        "longitude": "13.90043000"
                    },
                    {
                        "id": 22789,
                        "name": "Nový Knín",
                        "latitude": "49.78800000",
                        "longitude": "14.29355000"
                    },
                    {
                        "id": 22791,
                        "name": "Nymburk",
                        "latitude": "50.18605000",
                        "longitude": "15.04167000"
                    },
                    {
                        "id": 22801,
                        "name": "Obecnice",
                        "latitude": "49.71615000",
                        "longitude": "13.94731000"
                    },
                    {
                        "id": 22803,
                        "name": "Odolena Voda",
                        "latitude": "50.23341000",
                        "longitude": "14.41078000"
                    },
                    {
                        "id": 22806,
                        "name": "Okres Benešov",
                        "latitude": "49.66667000",
                        "longitude": "14.75000000"
                    },
                    {
                        "id": 22807,
                        "name": "Okres Beroun",
                        "latitude": "49.83333000",
                        "longitude": "14.08333000"
                    },
                    {
                        "id": 22828,
                        "name": "Okres Kladno",
                        "latitude": "50.16667000",
                        "longitude": "14.16667000"
                    },
                    {
                        "id": 22830,
                        "name": "Okres Kolín",
                        "latitude": "50.00000000",
                        "longitude": "15.00000000"
                    },
                    {
                        "id": 22832,
                        "name": "Okres Kutná Hora",
                        "latitude": "49.83333000",
                        "longitude": "15.25000000"
                    },
                    {
                        "id": 22838,
                        "name": "Okres Mělník",
                        "latitude": "50.33333000",
                        "longitude": "14.50000000"
                    },
                    {
                        "id": 22836,
                        "name": "Okres Mladá Boleslav",
                        "latitude": "50.41667000",
                        "longitude": "14.91667000"
                    },
                    {
                        "id": 22840,
                        "name": "Okres Nymburk",
                        "latitude": "50.16667000",
                        "longitude": "15.16667000"
                    },
                    {
                        "id": 22851,
                        "name": "Okres Praha-východ",
                        "latitude": "50.11768000",
                        "longitude": "14.70836000"
                    },
                    {
                        "id": 22852,
                        "name": "Okres Praha-západ",
                        "latitude": "49.83333000",
                        "longitude": "14.33333000"
                    },
                    {
                        "id": 22856,
                        "name": "Okres Příbram",
                        "latitude": "49.66667000",
                        "longitude": "14.16667000"
                    },
                    {
                        "id": 22857,
                        "name": "Okres Rakovník",
                        "latitude": "50.10000000",
                        "longitude": "13.70000000"
                    },
                    {
                        "id": 22889,
                        "name": "Ondřejov",
                        "latitude": "49.90461000",
                        "longitude": "14.78420000"
                    },
                    {
                        "id": 22922,
                        "name": "Pavlíkov",
                        "latitude": "50.05599000",
                        "longitude": "13.73636000"
                    },
                    {
                        "id": 22923,
                        "name": "Pchery",
                        "latitude": "50.19378000",
                        "longitude": "14.11782000"
                    },
                    {
                        "id": 22932,
                        "name": "Pečky",
                        "latitude": "50.09043000",
                        "longitude": "15.03017000"
                    },
                    {
                        "id": 22929,
                        "name": "Petrovice",
                        "latitude": "49.55426000",
                        "longitude": "14.33737000"
                    },
                    {
                        "id": 22939,
                        "name": "Plaňany",
                        "latitude": "50.05010000",
                        "longitude": "15.02944000"
                    },
                    {
                        "id": 22947,
                        "name": "Poděbrady",
                        "latitude": "50.14242000",
                        "longitude": "15.11881000"
                    },
                    {
                        "id": 22966,
                        "name": "Poříčany",
                        "latitude": "50.10806000",
                        "longitude": "14.91818000"
                    },
                    {
                        "id": 22967,
                        "name": "Poříčí nad Sázavou",
                        "latitude": "49.83895000",
                        "longitude": "14.67446000"
                    },
                    {
                        "id": 22958,
                        "name": "Postupice",
                        "latitude": "49.72798000",
                        "longitude": "14.77722000"
                    },
                    {
                        "id": 23002,
                        "name": "Přerov nad Labem",
                        "latitude": "50.16027000",
                        "longitude": "14.82502000"
                    },
                    {
                        "id": 23008,
                        "name": "Příbram",
                        "latitude": "49.68988000",
                        "longitude": "14.01043000"
                    },
                    {
                        "id": 22986,
                        "name": "Průhonice",
                        "latitude": "49.99962000",
                        "longitude": "14.55017000"
                    },
                    {
                        "id": 22987,
                        "name": "Psáry",
                        "latitude": "49.93622000",
                        "longitude": "14.51276000"
                    },
                    {
                        "id": 22991,
                        "name": "Pyšely",
                        "latitude": "49.87678000",
                        "longitude": "14.67713000"
                    },
                    {
                        "id": 23019,
                        "name": "Rakovník",
                        "latitude": "50.10370000",
                        "longitude": "13.73340000"
                    },
                    {
                        "id": 23402,
                        "name": "Řevnice",
                        "latitude": "49.91395000",
                        "longitude": "14.23589000"
                    },
                    {
                        "id": 23403,
                        "name": "Řevničov",
                        "latitude": "50.18489000",
                        "longitude": "13.80823000"
                    },
                    {
                        "id": 23405,
                        "name": "Řež",
                        "latitude": "50.17734000",
                        "longitude": "14.35733000"
                    },
                    {
                        "id": 23406,
                        "name": "Říčany",
                        "latitude": "49.99168000",
                        "longitude": "14.65427000"
                    },
                    {
                        "id": 23044,
                        "name": "Rožďalovice",
                        "latitude": "50.30476000",
                        "longitude": "15.16962000"
                    },
                    {
                        "id": 23042,
                        "name": "Rožmitál pod Třemšínem",
                        "latitude": "49.60196000",
                        "longitude": "13.86430000"
                    },
                    {
                        "id": 23041,
                        "name": "Roztoky",
                        "latitude": "50.15841000",
                        "longitude": "14.39760000"
                    },
                    {
                        "id": 23047,
                        "name": "Rudná",
                        "latitude": "50.03502000",
                        "longitude": "14.23435000"
                    },
                    {
                        "id": 23059,
                        "name": "Sadská",
                        "latitude": "50.13596000",
                        "longitude": "14.98633000"
                    },
                    {
                        "id": 23154,
                        "name": "Sázava",
                        "latitude": "49.87164000",
                        "longitude": "14.89674000"
                    },
                    {
                        "id": 23066,
                        "name": "Sedlčany",
                        "latitude": "49.66057000",
                        "longitude": "14.42664000"
                    },
                    {
                        "id": 23062,
                        "name": "Sedlec",
                        "latitude": "49.96391000",
                        "longitude": "15.28846000"
                    },
                    {
                        "id": 23413,
                        "name": "Šestajovice",
                        "latitude": "50.10845000",
                        "longitude": "14.68013000"
                    },
                    {
                        "id": 23077,
                        "name": "Slaný",
                        "latitude": "50.23046000",
                        "longitude": "14.08693000"
                    },
                    {
                        "id": 23085,
                        "name": "Smečno",
                        "latitude": "50.18844000",
                        "longitude": "14.04037000"
                    },
                    {
                        "id": 23100,
                        "name": "Stará Huť",
                        "latitude": "49.78225000",
                        "longitude": "14.19735000"
                    },
                    {
                        "id": 23112,
                        "name": "Starý Kolín",
                        "latitude": "50.00977000",
                        "longitude": "15.29388000"
                    },
                    {
                        "id": 23426,
                        "name": "Štěchovice",
                        "latitude": "49.85109000",
                        "longitude": "14.40543000"
                    },
                    {
                        "id": 23117,
                        "name": "Stochov",
                        "latitude": "50.14631000",
                        "longitude": "13.96345000"
                    },
                    {
                        "id": 23121,
                        "name": "Strančice",
                        "latitude": "49.94811000",
                        "longitude": "14.67745000"
                    },
                    {
                        "id": 23140,
                        "name": "Suchdol",
                        "latitude": "49.95247000",
                        "longitude": "15.16651000"
                    },
                    {
                        "id": 23165,
                        "name": "Tišice",
                        "latitude": "50.26980000",
                        "longitude": "14.55411000"
                    },
                    {
                        "id": 23199,
                        "name": "Třebotov",
                        "latitude": "49.97244000",
                        "longitude": "14.29127000"
                    },
                    {
                        "id": 23174,
                        "name": "Trhový Štěpánov",
                        "latitude": "49.71147000",
                        "longitude": "15.01356000"
                    },
                    {
                        "id": 23183,
                        "name": "Tuchlovice",
                        "latitude": "50.13803000",
                        "longitude": "13.99115000"
                    },
                    {
                        "id": 23184,
                        "name": "Tuchoměřice",
                        "latitude": "50.13543000",
                        "longitude": "14.28218000"
                    },
                    {
                        "id": 23192,
                        "name": "Týnec nad Labem",
                        "latitude": "50.04202000",
                        "longitude": "15.35836000"
                    },
                    {
                        "id": 23193,
                        "name": "Týnec nad Sázavou",
                        "latitude": "49.83348000",
                        "longitude": "14.58983000"
                    },
                    {
                        "id": 23209,
                        "name": "Uhlířské Janovice",
                        "latitude": "49.88019000",
                        "longitude": "15.06481000"
                    },
                    {
                        "id": 23210,
                        "name": "Unhošť",
                        "latitude": "50.08535000",
                        "longitude": "14.13007000"
                    },
                    {
                        "id": 23360,
                        "name": "Úvaly",
                        "latitude": "50.07394000",
                        "longitude": "14.73080000"
                    },
                    {
                        "id": 23229,
                        "name": "Velim",
                        "latitude": "50.05965000",
                        "longitude": "15.10711000"
                    },
                    {
                        "id": 23232,
                        "name": "Velká Dobrá",
                        "latitude": "50.10964000",
                        "longitude": "14.06980000"
                    },
                    {
                        "id": 23247,
                        "name": "Velké Popovice",
                        "latitude": "49.92252000",
                        "longitude": "14.63934000"
                    },
                    {
                        "id": 23249,
                        "name": "Velké Přílepy",
                        "latitude": "50.16050000",
                        "longitude": "14.31447000"
                    },
                    {
                        "id": 23252,
                        "name": "Velký Osek",
                        "latitude": "50.09867000",
                        "longitude": "15.18629000"
                    },
                    {
                        "id": 23256,
                        "name": "Veltruby",
                        "latitude": "50.07059000",
                        "longitude": "15.18454000"
                    },
                    {
                        "id": 23257,
                        "name": "Veltrusy",
                        "latitude": "50.27046000",
                        "longitude": "14.32857000"
                    },
                    {
                        "id": 23258,
                        "name": "Velvary",
                        "latitude": "50.28152000",
                        "longitude": "14.23616000"
                    },
                    {
                        "id": 23263,
                        "name": "Vestec",
                        "latitude": "49.98050000",
                        "longitude": "14.50487000"
                    },
                    {
                        "id": 23272,
                        "name": "Vinařice",
                        "latitude": "50.17585000",
                        "longitude": "14.09106000"
                    },
                    {
                        "id": 23281,
                        "name": "Vlašim",
                        "latitude": "49.70632000",
                        "longitude": "14.89881000"
                    },
                    {
                        "id": 23290,
                        "name": "Votice",
                        "latitude": "49.64013000",
                        "longitude": "14.63809000"
                    },
                    {
                        "id": 23293,
                        "name": "Vrané nad Vltavou",
                        "latitude": "49.93585000",
                        "longitude": "14.37706000"
                    },
                    {
                        "id": 23301,
                        "name": "Vrdy",
                        "latitude": "49.92153000",
                        "longitude": "15.47243000"
                    },
                    {
                        "id": 23318,
                        "name": "Všenory",
                        "latitude": "49.92883000",
                        "longitude": "14.30392000"
                    },
                    {
                        "id": 23321,
                        "name": "Všetaty",
                        "latitude": "50.28187000",
                        "longitude": "14.59297000"
                    },
                    {
                        "id": 23324,
                        "name": "Zaječov",
                        "latitude": "49.77435000",
                        "longitude": "13.84072000"
                    },
                    {
                        "id": 23351,
                        "name": "Zásmuky",
                        "latitude": "49.95470000",
                        "longitude": "15.03058000"
                    },
                    {
                        "id": 23331,
                        "name": "Zbraslavice",
                        "latitude": "49.81179000",
                        "longitude": "15.18319000"
                    },
                    {
                        "id": 23458,
                        "name": "Žďár",
                        "latitude": "50.54366000",
                        "longitude": "15.08034000"
                    },
                    {
                        "id": 23334,
                        "name": "Zdiby",
                        "latitude": "50.16799000",
                        "longitude": "14.45118000"
                    },
                    {
                        "id": 23335,
                        "name": "Zdice",
                        "latitude": "49.91207000",
                        "longitude": "13.97747000"
                    },
                    {
                        "id": 23441,
                        "name": "Žebrák",
                        "latitude": "49.87574000",
                        "longitude": "13.89735000"
                    },
                    {
                        "id": 23338,
                        "name": "Zeleneč",
                        "latitude": "50.13362000",
                        "longitude": "14.66070000"
                    },
                    {
                        "id": 23453,
                        "name": "Žiželice",
                        "latitude": "50.13192000",
                        "longitude": "15.39320000"
                    },
                    {
                        "id": 23454,
                        "name": "Žleby",
                        "latitude": "49.88958000",
                        "longitude": "15.48853000"
                    },
                    {
                        "id": 23342,
                        "name": "Zlonice",
                        "latitude": "50.28750000",
                        "longitude": "14.09214000"
                    },
                    {
                        "id": 23345,
                        "name": "Zruč nad Sázavou",
                        "latitude": "49.74010000",
                        "longitude": "15.10606000"
                    },
                    {
                        "id": 23347,
                        "name": "Zvole",
                        "latitude": "49.93466000",
                        "longitude": "14.41769000"
                    }
                ]
            },
            {
                "id": 4642,
                "name": "Šumperk",
                "iso2": "715",
                "latitude": "49.97784070",
                "longitude": "16.97177540",
                "type": "district",
                "cities": []
            },
            {
                "id": 4571,
                "name": "Svitavy",
                "iso2": "533",
                "latitude": "49.75516290",
                "longitude": "16.46918610",
                "type": "district",
                "cities": []
            },
            {
                "id": 4565,
                "name": "Tábor",
                "iso2": "317",
                "latitude": "49.36462930",
                "longitude": "14.71912930",
                "type": "district",
                "cities": []
            },
            {
                "id": 4646,
                "name": "Tachov",
                "iso2": "327",
                "latitude": "49.79878030",
                "longitude": "12.63619210",
                "type": "district",
                "cities": []
            },
            {
                "id": 4621,
                "name": "Teplice",
                "iso2": "426",
                "latitude": "50.65846050",
                "longitude": "13.75132270",
                "type": "district",
                "cities": []
            },
            {
                "id": 4597,
                "name": "Třebíč",
                "iso2": "634",
                "latitude": "49.21478690",
                "longitude": "15.87955160",
                "type": "district",
                "cities": []
            },
            {
                "id": 4579,
                "name": "Trutnov",
                "iso2": "525",
                "latitude": "50.56538380",
                "longitude": "15.90909230",
                "type": "district",
                "cities": []
            },
            {
                "id": 4592,
                "name": "Uherské Hradiště",
                "iso2": "722",
                "latitude": "49.05979690",
                "longitude": "17.49585010",
                "type": "district",
                "cities": []
            },
            {
                "id": 4576,
                "name": "Ústecký kraj",
                "iso2": "42",
                "latitude": "50.56071240",
                "longitude": "12.48038650",
                "type": "region",
                "cities": [
                    {
                        "id": 22117,
                        "name": "Bechlín",
                        "latitude": "50.41615000",
                        "longitude": "14.34092000"
                    },
                    {
                        "id": 22128,
                        "name": "Bečov",
                        "latitude": "50.44972000",
                        "longitude": "13.71784000"
                    },
                    {
                        "id": 22122,
                        "name": "Benešov nad Ploučnicí",
                        "latitude": "50.74159000",
                        "longitude": "14.31239000"
                    },
                    {
                        "id": 22192,
                        "name": "Bílina",
                        "latitude": "50.54854000",
                        "longitude": "13.77535000"
                    },
                    {
                        "id": 22193,
                        "name": "Bílina Kyselka",
                        "latitude": "50.55000000",
                        "longitude": "13.76667000"
                    },
                    {
                        "id": 22143,
                        "name": "Bohušovice nad Ohří",
                        "latitude": "50.49316000",
                        "longitude": "14.15048000"
                    },
                    {
                        "id": 22163,
                        "name": "Braňany",
                        "latitude": "50.54295000",
                        "longitude": "13.70017000"
                    },
                    {
                        "id": 22207,
                        "name": "Březno",
                        "latitude": "50.40185000",
                        "longitude": "13.42118000"
                    },
                    {
                        "id": 22177,
                        "name": "Budyně nad Ohří",
                        "latitude": "50.40427000",
                        "longitude": "14.12591000"
                    },
                    {
                        "id": 22183,
                        "name": "Bystřany",
                        "latitude": "50.62867000",
                        "longitude": "13.86419000"
                    },
                    {
                        "id": 23377,
                        "name": "Černčice",
                        "latitude": "50.36138000",
                        "longitude": "13.84521000"
                    },
                    {
                        "id": 23383,
                        "name": "Česká Kamenice",
                        "latitude": "50.79780000",
                        "longitude": "14.41767000"
                    },
                    {
                        "id": 22216,
                        "name": "Chabařovice",
                        "latitude": "50.67318000",
                        "longitude": "13.94184000"
                    },
                    {
                        "id": 22220,
                        "name": "Chlumec",
                        "latitude": "50.69972000",
                        "longitude": "13.93964000"
                    },
                    {
                        "id": 22226,
                        "name": "Chomutov",
                        "latitude": "50.46048000",
                        "longitude": "13.41779000"
                    },
                    {
                        "id": 22244,
                        "name": "Chřibská",
                        "latitude": "50.86079000",
                        "longitude": "14.48444000"
                    },
                    {
                        "id": 23399,
                        "name": "Čížkovice",
                        "latitude": "50.48418000",
                        "longitude": "14.02839000"
                    },
                    {
                        "id": 22322,
                        "name": "Děčín",
                        "latitude": "50.78215000",
                        "longitude": "14.21478000"
                    },
                    {
                        "id": 22258,
                        "name": "Dobroměřice",
                        "latitude": "50.37009000",
                        "longitude": "13.79473000"
                    },
                    {
                        "id": 22288,
                        "name": "Dolní Podluží",
                        "latitude": "50.87988000",
                        "longitude": "14.59503000"
                    },
                    {
                        "id": 22289,
                        "name": "Dolní Poustevna",
                        "latitude": "50.98251000",
                        "longitude": "14.28684000"
                    },
                    {
                        "id": 22315,
                        "name": "Dubí",
                        "latitude": "50.68558000",
                        "longitude": "13.78561000"
                    },
                    {
                        "id": 22317,
                        "name": "Duchcov",
                        "latitude": "50.60376000",
                        "longitude": "13.74621000"
                    },
                    {
                        "id": 22381,
                        "name": "Horní Jiřetín",
                        "latitude": "50.57309000",
                        "longitude": "13.54717000"
                    },
                    {
                        "id": 22409,
                        "name": "Hošťka",
                        "latitude": "50.48859000",
                        "longitude": "14.33500000"
                    },
                    {
                        "id": 22400,
                        "name": "Hostomice",
                        "latitude": "50.58770000",
                        "longitude": "13.80803000"
                    },
                    {
                        "id": 22419,
                        "name": "Hrob",
                        "latitude": "50.65919000",
                        "longitude": "13.72676000"
                    },
                    {
                        "id": 22485,
                        "name": "Jílové",
                        "latitude": "50.76082000",
                        "longitude": "14.10383000"
                    },
                    {
                        "id": 22482,
                        "name": "Jiříkov",
                        "latitude": "50.99514000",
                        "longitude": "14.56910000"
                    },
                    {
                        "id": 22477,
                        "name": "Jirkov",
                        "latitude": "50.49979000",
                        "longitude": "13.44769000"
                    },
                    {
                        "id": 22487,
                        "name": "Kadaň",
                        "latitude": "50.38333000",
                        "longitude": "13.26667000"
                    },
                    {
                        "id": 22519,
                        "name": "Klášterec nad Ohří",
                        "latitude": "50.38860000",
                        "longitude": "13.18342000"
                    },
                    {
                        "id": 22550,
                        "name": "Košťany",
                        "latitude": "50.65507000",
                        "longitude": "13.75554000"
                    },
                    {
                        "id": 22546,
                        "name": "Kovářská",
                        "latitude": "50.43821000",
                        "longitude": "13.05388000"
                    },
                    {
                        "id": 22568,
                        "name": "Krásná Lípa",
                        "latitude": "50.48378000",
                        "longitude": "13.35750000"
                    },
                    {
                        "id": 22586,
                        "name": "Křešice",
                        "latitude": "50.52259000",
                        "longitude": "14.21450000"
                    },
                    {
                        "id": 22563,
                        "name": "Krupka",
                        "latitude": "50.68449000",
                        "longitude": "13.85815000"
                    },
                    {
                        "id": 22564,
                        "name": "Kryry",
                        "latitude": "50.17437000",
                        "longitude": "13.42660000"
                    },
                    {
                        "id": 22596,
                        "name": "Lenešice",
                        "latitude": "50.37516000",
                        "longitude": "13.76590000"
                    },
                    {
                        "id": 22613,
                        "name": "Liběšice",
                        "latitude": "50.56886000",
                        "longitude": "14.28906000"
                    },
                    {
                        "id": 22608,
                        "name": "Libochovice",
                        "latitude": "50.40626000",
                        "longitude": "14.04439000"
                    },
                    {
                        "id": 22609,
                        "name": "Libouchec",
                        "latitude": "50.75854000",
                        "longitude": "14.04071000"
                    },
                    {
                        "id": 22623,
                        "name": "Litoměřice",
                        "latitude": "50.53348000",
                        "longitude": "14.13180000"
                    },
                    {
                        "id": 22625,
                        "name": "Litvínov",
                        "latitude": "50.60420000",
                        "longitude": "13.61812000"
                    },
                    {
                        "id": 22631,
                        "name": "Lom u Mostu",
                        "latitude": "50.59328000",
                        "longitude": "13.65729000"
                    },
                    {
                        "id": 22637,
                        "name": "Louny",
                        "latitude": "50.35699000",
                        "longitude": "13.79667000"
                    },
                    {
                        "id": 22641,
                        "name": "Lovosice",
                        "latitude": "50.51504000",
                        "longitude": "14.05103000"
                    },
                    {
                        "id": 22643,
                        "name": "Lubenec",
                        "latitude": "50.13207000",
                        "longitude": "13.31319000"
                    },
                    {
                        "id": 22735,
                        "name": "Měcholupy",
                        "latitude": "50.26666000",
                        "longitude": "13.53737000"
                    },
                    {
                        "id": 22683,
                        "name": "Meziboři",
                        "latitude": "50.62115000",
                        "longitude": "13.59870000"
                    },
                    {
                        "id": 22687,
                        "name": "Mikulášovice",
                        "latitude": "50.96507000",
                        "longitude": "14.36368000"
                    },
                    {
                        "id": 22725,
                        "name": "Most",
                        "latitude": "50.50301000",
                        "longitude": "13.63617000"
                    },
                    {
                        "id": 22770,
                        "name": "Novosedlice",
                        "latitude": "50.65633000",
                        "longitude": "13.82304000"
                    },
                    {
                        "id": 22802,
                        "name": "Obrnice",
                        "latitude": "50.50498000",
                        "longitude": "13.69540000"
                    },
                    {
                        "id": 22813,
                        "name": "Okres Chomutov",
                        "latitude": "50.41667000",
                        "longitude": "13.33333000"
                    },
                    {
                        "id": 22816,
                        "name": "Okres Děčín",
                        "latitude": "50.82905000",
                        "longitude": "14.34325000"
                    },
                    {
                        "id": 22834,
                        "name": "Okres Litoměřice",
                        "latitude": "50.50000000",
                        "longitude": "14.16667000"
                    },
                    {
                        "id": 22835,
                        "name": "Okres Louny",
                        "latitude": "50.33333000",
                        "longitude": "13.66667000"
                    },
                    {
                        "id": 22837,
                        "name": "Okres Most",
                        "latitude": "50.55000000",
                        "longitude": "13.63333000"
                    },
                    {
                        "id": 22865,
                        "name": "Okres Teplice",
                        "latitude": "50.63333000",
                        "longitude": "13.83333000"
                    },
                    {
                        "id": 22874,
                        "name": "Okres Ústí nad Labem",
                        "latitude": "50.66667000",
                        "longitude": "14.05000000"
                    },
                    {
                        "id": 22897,
                        "name": "Osek",
                        "latitude": "50.62115000",
                        "longitude": "13.69274000"
                    },
                    {
                        "id": 22927,
                        "name": "Perštejn",
                        "latitude": "50.38166000",
                        "longitude": "13.11020000"
                    },
                    {
                        "id": 22926,
                        "name": "Peruc",
                        "latitude": "50.34250000",
                        "longitude": "13.95986000"
                    },
                    {
                        "id": 22944,
                        "name": "Podbořany",
                        "latitude": "50.22937000",
                        "longitude": "13.41192000"
                    },
                    {
                        "id": 22949,
                        "name": "Polepy",
                        "latitude": "50.50563000",
                        "longitude": "14.26447000"
                    },
                    {
                        "id": 22957,
                        "name": "Postoloprty",
                        "latitude": "50.35979000",
                        "longitude": "13.70291000"
                    },
                    {
                        "id": 22962,
                        "name": "Povrly",
                        "latitude": "50.67276000",
                        "longitude": "14.16033000"
                    },
                    {
                        "id": 22976,
                        "name": "Proboštov",
                        "latitude": "50.66773000",
                        "longitude": "13.83601000"
                    },
                    {
                        "id": 23014,
                        "name": "Radonice",
                        "latitude": "50.29803000",
                        "longitude": "13.28464000"
                    },
                    {
                        "id": 23400,
                        "name": "Řehlovice",
                        "latitude": "50.60712000",
                        "longitude": "13.95412000"
                    },
                    {
                        "id": 23038,
                        "name": "Roudnice nad Labem",
                        "latitude": "50.42528000",
                        "longitude": "14.26175000"
                    },
                    {
                        "id": 23050,
                        "name": "Rumburk",
                        "latitude": "50.95151000",
                        "longitude": "14.55699000"
                    },
                    {
                        "id": 23418,
                        "name": "Šluknov",
                        "latitude": "51.00369000",
                        "longitude": "14.45258000"
                    },
                    {
                        "id": 23104,
                        "name": "Staré Křečany",
                        "latitude": "50.95044000",
                        "longitude": "14.49617000"
                    },
                    {
                        "id": 23430,
                        "name": "Štětí",
                        "latitude": "50.45298000",
                        "longitude": "14.37421000"
                    },
                    {
                        "id": 23160,
                        "name": "Teplice",
                        "latitude": "50.64040000",
                        "longitude": "13.82451000"
                    },
                    {
                        "id": 23162,
                        "name": "Terezín",
                        "latitude": "50.51100000",
                        "longitude": "14.15055000"
                    },
                    {
                        "id": 23198,
                        "name": "Třebenice",
                        "latitude": "50.47632000",
                        "longitude": "13.99005000"
                    },
                    {
                        "id": 23175,
                        "name": "Trmice",
                        "latitude": "50.64286000",
                        "longitude": "13.99449000"
                    },
                    {
                        "id": 23353,
                        "name": "Údlice",
                        "latitude": "50.44060000",
                        "longitude": "13.45738000"
                    },
                    {
                        "id": 23361,
                        "name": "Úštěk",
                        "latitude": "50.58474000",
                        "longitude": "14.34332000"
                    },
                    {
                        "id": 23223,
                        "name": "Varnsdorf",
                        "latitude": "50.91154000",
                        "longitude": "14.61824000"
                    },
                    {
                        "id": 23225,
                        "name": "Vejprty",
                        "latitude": "50.49232000",
                        "longitude": "13.03212000"
                    },
                    {
                        "id": 23227,
                        "name": "Velemín",
                        "latitude": "50.53898000",
                        "longitude": "13.97675000"
                    },
                    {
                        "id": 23237,
                        "name": "Velké Březno",
                        "latitude": "50.66270000",
                        "longitude": "14.14174000"
                    },
                    {
                        "id": 23255,
                        "name": "Velký Šenov",
                        "latitude": "50.99078000",
                        "longitude": "14.37428000"
                    },
                    {
                        "id": 23260,
                        "name": "Verneřice",
                        "latitude": "50.66114000",
                        "longitude": "14.30114000"
                    },
                    {
                        "id": 23269,
                        "name": "Vilémov",
                        "latitude": "50.99054000",
                        "longitude": "14.33531000"
                    },
                    {
                        "id": 23302,
                        "name": "Vroutek",
                        "latitude": "50.17999000",
                        "longitude": "13.37986000"
                    },
                    {
                        "id": 23322,
                        "name": "Zabrušany",
                        "latitude": "50.60495000",
                        "longitude": "13.78748000"
                    },
                    {
                        "id": 23439,
                        "name": "Žatec",
                        "latitude": "50.32717000",
                        "longitude": "13.54577000"
                    },
                    {
                        "id": 23452,
                        "name": "Žitenice",
                        "latitude": "50.55528000",
                        "longitude": "14.15665000"
                    }
                ]
            },
            {
                "id": 4599,
                "name": "Ústí nad Labem",
                "iso2": "427",
                "latitude": "50.69571320",
                "longitude": "13.73122450",
                "type": "district",
                "cities": []
            },
            {
                "id": 4647,
                "name": "Ústí nad Orlicí",
                "iso2": "534",
                "latitude": "49.97218010",
                "longitude": "16.39966170",
                "type": "district",
                "cities": []
            },
            {
                "id": 4572,
                "name": "Vsetín",
                "iso2": "723",
                "latitude": "49.37932500",
                "longitude": "18.06181620",
                "type": "district",
                "cities": []
            },
            {
                "id": 4622,
                "name": "Vyškov",
                "iso2": "646",
                "latitude": "49.21274450",
                "longitude": "16.98559270",
                "type": "district",
                "cities": []
            },
            {
                "id": 4648,
                "name": "Žďár nad Sázavou",
                "iso2": "635",
                "latitude": "49.56430120",
                "longitude": "15.93910300",
                "type": "district",
                "cities": []
            },
            {
                "id": 4563,
                "name": "Zlín",
                "iso2": "724",
                "latitude": "49.16960520",
                "longitude": "17.80252200",
                "type": "district",
                "cities": [
                    {
                        "id": 22111,
                        "name": "Babice",
                        "latitude": "49.12167000",
                        "longitude": "17.48075000"
                    },
                    {
                        "id": 22191,
                        "name": "Bánov",
                        "latitude": "48.98801000",
                        "longitude": "17.71752000"
                    },
                    {
                        "id": 22195,
                        "name": "Bílovice",
                        "latitude": "49.09965000",
                        "longitude": "17.54961000"
                    },
                    {
                        "id": 22144,
                        "name": "Bojkovice",
                        "latitude": "49.03864000",
                        "longitude": "17.81487000"
                    },
                    {
                        "id": 22151,
                        "name": "Boršice",
                        "latitude": "49.06254000",
                        "longitude": "17.35084000"
                    },
                    {
                        "id": 22205,
                        "name": "Březnice",
                        "latitude": "49.18643000",
                        "longitude": "17.66277000"
                    },
                    {
                        "id": 22208,
                        "name": "Březolupy",
                        "latitude": "49.12138000",
                        "longitude": "17.58034000"
                    },
                    {
                        "id": 22211,
                        "name": "Březová",
                        "latitude": "48.92543000",
                        "longitude": "17.73986000"
                    },
                    {
                        "id": 22174,
                        "name": "Buchlovice",
                        "latitude": "49.08627000",
                        "longitude": "17.33852000"
                    },
                    {
                        "id": 22188,
                        "name": "Bystřice pod Hostýnem",
                        "latitude": "49.39924000",
                        "longitude": "17.67401000"
                    },
                    {
                        "id": 22233,
                        "name": "Chropyně",
                        "latitude": "49.35644000",
                        "longitude": "17.36451000"
                    },
                    {
                        "id": 22239,
                        "name": "Chvalčov",
                        "latitude": "49.38918000",
                        "longitude": "17.71149000"
                    },
                    {
                        "id": 22272,
                        "name": "Dolní Bečva",
                        "latitude": "49.45498000",
                        "longitude": "18.19419000"
                    },
                    {
                        "id": 22287,
                        "name": "Dolní Němčí",
                        "latitude": "48.96837000",
                        "longitude": "17.58585000"
                    },
                    {
                        "id": 22325,
                        "name": "Francova Lhota",
                        "latitude": "49.20174000",
                        "longitude": "18.11175000"
                    },
                    {
                        "id": 22330,
                        "name": "Fryšták",
                        "latitude": "49.28520000",
                        "longitude": "17.68346000"
                    },
                    {
                        "id": 22339,
                        "name": "Halenkov",
                        "latitude": "49.31740000",
                        "longitude": "18.14749000"
                    },
                    {
                        "id": 22340,
                        "name": "Halenkovice",
                        "latitude": "49.17102000",
                        "longitude": "17.47156000"
                    },
                    {
                        "id": 22357,
                        "name": "Hluk",
                        "latitude": "48.98805000",
                        "longitude": "17.52744000"
                    },
                    {
                        "id": 22368,
                        "name": "Holešov",
                        "latitude": "49.33331000",
                        "longitude": "17.57832000"
                    },
                    {
                        "id": 22375,
                        "name": "Horní Bečva",
                        "latitude": "49.43216000",
                        "longitude": "18.28859000"
                    },
                    {
                        "id": 22382,
                        "name": "Horní Lideč",
                        "latitude": "49.18121000",
                        "longitude": "18.06099000"
                    },
                    {
                        "id": 22410,
                        "name": "Hošťálková",
                        "latitude": "49.35467000",
                        "longitude": "17.86944000"
                    },
                    {
                        "id": 22406,
                        "name": "Hovězí",
                        "latitude": "49.30365000",
                        "longitude": "18.06062000"
                    },
                    {
                        "id": 22434,
                        "name": "Hulín",
                        "latitude": "49.31689000",
                        "longitude": "17.46374000"
                    },
                    {
                        "id": 22439,
                        "name": "Hvozdná",
                        "latitude": "49.24848000",
                        "longitude": "17.75163000"
                    },
                    {
                        "id": 22450,
                        "name": "Jablůnka",
                        "latitude": "49.38355000",
                        "longitude": "17.95021000"
                    },
                    {
                        "id": 22452,
                        "name": "Jalubí",
                        "latitude": "49.11626000",
                        "longitude": "17.42788000"
                    },
                    {
                        "id": 22500,
                        "name": "Karolinka",
                        "latitude": "49.35128000",
                        "longitude": "18.24006000"
                    },
                    {
                        "id": 22509,
                        "name": "Kelč",
                        "latitude": "49.47844000",
                        "longitude": "17.81533000"
                    },
                    {
                        "id": 22523,
                        "name": "Kněžpole",
                        "latitude": "49.09855000",
                        "longitude": "17.51671000"
                    },
                    {
                        "id": 22535,
                        "name": "Koryčany",
                        "latitude": "49.10639000",
                        "longitude": "17.16433000"
                    },
                    {
                        "id": 22560,
                        "name": "Kroměříž",
                        "latitude": "49.29785000",
                        "longitude": "17.39312000"
                    },
                    {
                        "id": 22569,
                        "name": "Kunovice",
                        "latitude": "49.04499000",
                        "longitude": "17.47011000"
                    },
                    {
                        "id": 22578,
                        "name": "Kvasice",
                        "latitude": "49.24223000",
                        "longitude": "17.46974000"
                    },
                    {
                        "id": 22601,
                        "name": "Lešná",
                        "latitude": "49.52055000",
                        "longitude": "17.93004000"
                    },
                    {
                        "id": 22616,
                        "name": "Lidečko",
                        "latitude": "49.20303000",
                        "longitude": "18.05130000"
                    },
                    {
                        "id": 22620,
                        "name": "Liptál",
                        "latitude": "49.29051000",
                        "longitude": "17.92177000"
                    },
                    {
                        "id": 22646,
                        "name": "Luhačovice",
                        "latitude": "49.09982000",
                        "longitude": "17.75747000"
                    },
                    {
                        "id": 22650,
                        "name": "Lukov",
                        "latitude": "49.29027000",
                        "longitude": "17.72959000"
                    },
                    {
                        "id": 22699,
                        "name": "Mistřice",
                        "latitude": "49.08668000",
                        "longitude": "17.53597000"
                    },
                    {
                        "id": 22749,
                        "name": "Napajedla",
                        "latitude": "49.17156000",
                        "longitude": "17.51194000"
                    },
                    {
                        "id": 22753,
                        "name": "Nedakonice",
                        "latitude": "49.03159000",
                        "longitude": "17.38141000"
                    },
                    {
                        "id": 22754,
                        "name": "Nedašov",
                        "latitude": "49.10778000",
                        "longitude": "18.07036000"
                    },
                    {
                        "id": 22767,
                        "name": "Nivnice",
                        "latitude": "48.97465000",
                        "longitude": "17.64757000"
                    },
                    {
                        "id": 22787,
                        "name": "Nový Hrozenkov",
                        "latitude": "49.33697000",
                        "longitude": "18.19793000"
                    },
                    {
                        "id": 22831,
                        "name": "Okres Kroměříž",
                        "latitude": "49.33333000",
                        "longitude": "17.50000000"
                    },
                    {
                        "id": 22869,
                        "name": "Okres Uherské Hradiště",
                        "latitude": "49.01667000",
                        "longitude": "17.55000000"
                    },
                    {
                        "id": 22870,
                        "name": "Okres Vsetín",
                        "latitude": "49.36667000",
                        "longitude": "18.08333000"
                    },
                    {
                        "id": 22872,
                        "name": "Okres Zlín",
                        "latitude": "49.21667000",
                        "longitude": "17.78333000"
                    },
                    {
                        "id": 22909,
                        "name": "Ostrožská Lhota",
                        "latitude": "48.97559000",
                        "longitude": "17.46751000"
                    },
                    {
                        "id": 22910,
                        "name": "Ostrožská Nová Ves",
                        "latitude": "49.00434000",
                        "longitude": "17.43632000"
                    },
                    {
                        "id": 22915,
                        "name": "Otrokovice",
                        "latitude": "49.20934000",
                        "longitude": "17.53944000"
                    },
                    {
                        "id": 22950,
                        "name": "Polešovice",
                        "latitude": "49.03390000",
                        "longitude": "17.34064000"
                    },
                    {
                        "id": 22956,
                        "name": "Popovice",
                        "latitude": "49.05255000",
                        "longitude": "17.52712000"
                    },
                    {
                        "id": 22963,
                        "name": "Pozlovice",
                        "latitude": "49.12921000",
                        "longitude": "17.76925000"
                    },
                    {
                        "id": 22980,
                        "name": "Prostřední Bečva",
                        "latitude": "49.43609000",
                        "longitude": "18.25200000"
                    },
                    {
                        "id": 22984,
                        "name": "Prusinovice",
                        "latitude": "49.37898000",
                        "longitude": "17.58710000"
                    },
                    {
                        "id": 23023,
                        "name": "Rataje",
                        "latitude": "49.27130000",
                        "longitude": "17.33555000"
                    },
                    {
                        "id": 23024,
                        "name": "Ratiboř",
                        "latitude": "49.36769000",
                        "longitude": "17.91499000"
                    },
                    {
                        "id": 23043,
                        "name": "Rožnov pod Radhoštěm",
                        "latitude": "49.45853000",
                        "longitude": "18.14302000"
                    },
                    {
                        "id": 23080,
                        "name": "Slavičín",
                        "latitude": "49.08799000",
                        "longitude": "17.87349000"
                    },
                    {
                        "id": 23084,
                        "name": "Slušovice",
                        "latitude": "49.24782000",
                        "longitude": "17.80150000"
                    },
                    {
                        "id": 23096,
                        "name": "Spytihněv",
                        "latitude": "49.14115000",
                        "longitude": "17.49808000"
                    },
                    {
                        "id": 23107,
                        "name": "Staré Město",
                        "latitude": "49.07515000",
                        "longitude": "17.43338000"
                    },
                    {
                        "id": 23424,
                        "name": "Štítná nad Vláří",
                        "latitude": "49.06881000",
                        "longitude": "17.98274000"
                    },
                    {
                        "id": 23125,
                        "name": "Strání",
                        "latitude": "48.90216000",
                        "longitude": "17.70671000"
                    },
                    {
                        "id": 23143,
                        "name": "Suchá Loz",
                        "latitude": "48.97001000",
                        "longitude": "17.71379000"
                    },
                    {
                        "id": 23431,
                        "name": "Šumice",
                        "latitude": "49.02858000",
                        "longitude": "17.72205000"
                    },
                    {
                        "id": 23163,
                        "name": "Tečovice",
                        "latitude": "49.22107000",
                        "longitude": "17.58733000"
                    },
                    {
                        "id": 23167,
                        "name": "Tlumačov",
                        "latitude": "49.25351000",
                        "longitude": "17.49559000"
                    },
                    {
                        "id": 23169,
                        "name": "Topolná",
                        "latitude": "49.12187000",
                        "longitude": "17.54434000"
                    },
                    {
                        "id": 23172,
                        "name": "Traplice",
                        "latitude": "49.13088000",
                        "longitude": "17.43622000"
                    },
                    {
                        "id": 23176,
                        "name": "Trnava",
                        "latitude": "49.29603000",
                        "longitude": "17.84191000"
                    },
                    {
                        "id": 23185,
                        "name": "Tupesy",
                        "latitude": "49.08427000",
                        "longitude": "17.36983000"
                    },
                    {
                        "id": 23206,
                        "name": "Uherské Hradiště",
                        "latitude": "49.06975000",
                        "longitude": "17.45969000"
                    },
                    {
                        "id": 23207,
                        "name": "Uherský Brod",
                        "latitude": "49.02513000",
                        "longitude": "17.64715000"
                    },
                    {
                        "id": 23208,
                        "name": "Uherský Ostroh",
                        "latitude": "48.98556000",
                        "longitude": "17.38984000"
                    },
                    {
                        "id": 23354,
                        "name": "Újezd",
                        "latitude": "49.16809000",
                        "longitude": "17.90610000"
                    },
                    {
                        "id": 23215,
                        "name": "Valašská Bystřice",
                        "latitude": "49.41507000",
                        "longitude": "18.10977000"
                    },
                    {
                        "id": 23216,
                        "name": "Valašská Polanka",
                        "latitude": "49.26215000",
                        "longitude": "17.99667000"
                    },
                    {
                        "id": 23217,
                        "name": "Valašské Klobouky",
                        "latitude": "49.14064000",
                        "longitude": "18.00760000"
                    },
                    {
                        "id": 23218,
                        "name": "Valašské Meziříčí",
                        "latitude": "49.47181000",
                        "longitude": "17.97113000"
                    },
                    {
                        "id": 23226,
                        "name": "Velehrad",
                        "latitude": "49.10543000",
                        "longitude": "17.39426000"
                    },
                    {
                        "id": 23241,
                        "name": "Velké Karlovice",
                        "latitude": "49.36064000",
                        "longitude": "18.28355000"
                    },
                    {
                        "id": 23267,
                        "name": "Vidče",
                        "latitude": "49.44151000",
                        "longitude": "18.09473000"
                    },
                    {
                        "id": 23275,
                        "name": "Vizovice",
                        "latitude": "49.22287000",
                        "longitude": "17.85455000"
                    },
                    {
                        "id": 23278,
                        "name": "Vlachovice",
                        "latitude": "49.12377000",
                        "longitude": "17.94001000"
                    },
                    {
                        "id": 23284,
                        "name": "Vlčnov",
                        "latitude": "49.00990000",
                        "longitude": "17.58183000"
                    },
                    {
                        "id": 23317,
                        "name": "Všemina",
                        "latitude": "49.28100000",
                        "longitude": "17.87682000"
                    },
                    {
                        "id": 23303,
                        "name": "Vsetín",
                        "latitude": "49.33871000",
                        "longitude": "17.99619000"
                    },
                    {
                        "id": 23349,
                        "name": "Záhorovice",
                        "latitude": "49.02266000",
                        "longitude": "17.77922000"
                    },
                    {
                        "id": 23327,
                        "name": "Zašová",
                        "latitude": "49.47410000",
                        "longitude": "18.04436000"
                    },
                    {
                        "id": 23329,
                        "name": "Zborovice",
                        "latitude": "49.24889000",
                        "longitude": "17.28464000"
                    },
                    {
                        "id": 23336,
                        "name": "Zdounky",
                        "latitude": "49.22771000",
                        "longitude": "17.31899000"
                    },
                    {
                        "id": 23340,
                        "name": "Zlechov",
                        "latitude": "49.07396000",
                        "longitude": "17.37938000"
                    },
                    {
                        "id": 23343,
                        "name": "Zlín",
                        "latitude": "49.22645000",
                        "longitude": "17.67065000"
                    },
                    {
                        "id": 23455,
                        "name": "Žlutava",
                        "latitude": "49.19976000",
                        "longitude": "17.49037000"
                    },
                    {
                        "id": 23346,
                        "name": "Zubří",
                        "latitude": "49.46603000",
                        "longitude": "18.09249000"
                    }
                ]
            },
            {
                "id": 4552,
                "name": "Zlínský kraj",
                "iso2": "72",
                "latitude": "49.21622960",
                "longitude": "17.77203530",
                "type": "region",
                "cities": []
            },
            {
                "id": 4630,
                "name": "Znojmo",
                "iso2": "647",
                "latitude": "48.92723270",
                "longitude": "16.10378080",
                "type": "district",
                "cities": []
            }
        ]
    },
    {
        "id": 51,
        "name": "Democratic Republic of the Congo",
        "iso3": "COD",
        "iso2": "CD",
        "numeric_code": "180",
        "phonecode": "243",
        "capital": "Kinshasa",
        "currency": "CDF",
        "currency_name": "Congolese Franc",
        "currency_symbol": "FC",
        "tld": ".cd",
        "native": "République démocratique du Congo",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Middle Africa",
        "subregion_id": 2,
        "nationality": "Congolese",
        "timezones": [
            {
                "zoneName": "Africa\/Kinshasa",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            },
            {
                "zoneName": "Africa\/Lubumbashi",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "br": "Kongo (RD)",
            "ko": "콩고 민주 공화국",
            "pt-BR": "RD Congo",
            "pt": "RD Congo",
            "nl": "Congo [DRC]",
            "hr": "Kongo, Demokratska Republika",
            "fa": "جمهوری کنگو",
            "de": "Kongo (Dem. Rep.)",
            "es": "Congo (Rep. Dem.)",
            "fr": "Congo (Rép. dém.)",
            "ja": "コンゴ民主共和国",
            "it": "Congo (Rep. Dem.)",
            "zh-CN": "刚果（金）",
            "tr": "Kongo Demokratik Cumhuriyeti",
            "ru": "Демократическая Республика Конго",
            "uk": "Демократична Республіка Конго",
            "pl": "Demokratyczna Republika Konga"
        },
        "latitude": "0.00000000",
        "longitude": "25.00000000",
        "emoji": "🇨🇩",
        "emojiU": "U+1F1E8 U+1F1E9",
        "states": [
            {
                "id": 2753,
                "name": "Bas-Uélé",
                "iso2": "BU",
                "latitude": "3.99010090",
                "longitude": "24.90422080",
                "type": "province",
                "cities": [
                    {
                        "id": 17225,
                        "name": "Aketi",
                        "latitude": "2.73877000",
                        "longitude": "23.78326000"
                    },
                    {
                        "id": 17232,
                        "name": "Bondo",
                        "latitude": "3.81461000",
                        "longitude": "23.68665000"
                    },
                    {
                        "id": 17241,
                        "name": "Buta",
                        "latitude": "2.78582000",
                        "longitude": "24.72997000"
                    }
                ]
            },
            {
                "id": 2744,
                "name": "Équateur",
                "iso2": "EQ",
                "latitude": "-1.83123900",
                "longitude": "-78.18340600",
                "type": "province",
                "cities": [
                    {
                        "id": 17245,
                        "name": "Gemena",
                        "latitude": "3.25651000",
                        "longitude": "19.77234000"
                    },
                    {
                        "id": 17269,
                        "name": "Lisala",
                        "latitude": "2.15127000",
                        "longitude": "21.51672000"
                    },
                    {
                        "id": 17274,
                        "name": "Lukolela",
                        "latitude": "-1.06046000",
                        "longitude": "17.18210000"
                    },
                    {
                        "id": 17279,
                        "name": "Mbandaka",
                        "latitude": "0.04865000",
                        "longitude": "18.26034000"
                    }
                ]
            },
            {
                "id": 2750,
                "name": "Haut-Katanga",
                "iso2": "HK",
                "latitude": "-10.41020750",
                "longitude": "27.54958460",
                "type": "province",
                "cities": [
                    {
                        "id": 17268,
                        "name": "Likasi",
                        "latitude": "-10.98303000",
                        "longitude": "26.73840000"
                    },
                    {
                        "id": 17272,
                        "name": "Lubumbashi",
                        "latitude": "-11.66089000",
                        "longitude": "27.47938000"
                    }
                ]
            },
            {
                "id": 2758,
                "name": "Haut-Lomami",
                "iso2": "HL",
                "latitude": "-7.70527520",
                "longitude": "24.90422080",
                "type": "province",
                "cities": [
                    {
                        "id": 17235,
                        "name": "Bukama",
                        "latitude": "-9.20443000",
                        "longitude": "25.85475000"
                    },
                    {
                        "id": 17256,
                        "name": "Kamina",
                        "latitude": "-8.73508000",
                        "longitude": "24.99798000"
                    }
                ]
            },
            {
                "id": 2734,
                "name": "Haut-Uélé",
                "iso2": "HU",
                "latitude": "3.58451540",
                "longitude": "28.29943500",
                "type": "province",
                "cities": [
                    {
                        "id": 17250,
                        "name": "Isiro",
                        "latitude": "2.77391000",
                        "longitude": "27.61603000"
                    },
                    {
                        "id": 17291,
                        "name": "Wamba",
                        "latitude": "2.14838000",
                        "longitude": "27.99466000"
                    },
                    {
                        "id": 17292,
                        "name": "Watsa",
                        "latitude": "3.03716000",
                        "longitude": "29.53551000"
                    }
                ]
            },
            {
                "id": 2751,
                "name": "Ituri",
                "iso2": "IT",
                "latitude": "1.59576820",
                "longitude": "29.41793240",
                "type": "province",
                "cities": [
                    {
                        "id": 17239,
                        "name": "Bunia",
                        "latitude": "1.55941000",
                        "longitude": "30.25224000"
                    }
                ]
            },
            {
                "id": 2757,
                "name": "Kasaï",
                "iso2": "KS",
                "latitude": "-5.04719790",
                "longitude": "20.71224650",
                "type": "province",
                "cities": [
                    {
                        "id": 17248,
                        "name": "Ilebo",
                        "latitude": "-4.33111000",
                        "longitude": "20.58638000"
                    },
                    {
                        "id": 17273,
                        "name": "Luebo",
                        "latitude": "-5.35218000",
                        "longitude": "21.42192000"
                    },
                    {
                        "id": 17284,
                        "name": "Mweka",
                        "latitude": "-4.85187000",
                        "longitude": "21.55950000"
                    },
                    {
                        "id": 17289,
                        "name": "Tshikapa",
                        "latitude": "-6.41621000",
                        "longitude": "20.79995000"
                    }
                ]
            },
            {
                "id": 2742,
                "name": "Kasaï Central",
                "iso2": "KC",
                "latitude": "-8.44045910",
                "longitude": "20.41659340",
                "type": "province",
                "cities": []
            },
            {
                "id": 2735,
                "name": "Kasaï Oriental",
                "iso2": "KE",
                "latitude": "-6.03362300",
                "longitude": "23.57285010",
                "type": "province",
                "cities": [
                    {
                        "id": 17243,
                        "name": "Gandajika",
                        "latitude": "-6.74504000",
                        "longitude": "23.95328000"
                    },
                    {
                        "id": 17253,
                        "name": "Kabinda",
                        "latitude": "-6.13791000",
                        "longitude": "24.48179000"
                    },
                    {
                        "id": 17281,
                        "name": "Mbuji-Mayi",
                        "latitude": "-6.13603000",
                        "longitude": "23.58979000"
                    }
                ]
            },
            {
                "id": 2741,
                "name": "Kinshasa",
                "iso2": "KN",
                "latitude": "-4.44193110",
                "longitude": "15.26629310",
                "type": "city",
                "cities": [
                    {
                        "id": 17263,
                        "name": "Kinshasa",
                        "latitude": "-4.32758000",
                        "longitude": "15.31357000"
                    }
                ]
            },
            {
                "id": 2746,
                "name": "Kongo Central",
                "iso2": "BC",
                "latitude": "-5.23656850",
                "longitude": "13.91439900",
                "type": "province",
                "cities": [
                    {
                        "id": 17231,
                        "name": "Boma",
                        "latitude": "-5.85098000",
                        "longitude": "13.05364000"
                    },
                    {
                        "id": 17258,
                        "name": "Kasangulu",
                        "latitude": "-4.58330000",
                        "longitude": "15.16554000"
                    },
                    {
                        "id": 17278,
                        "name": "Matadi",
                        "latitude": "-5.83861000",
                        "longitude": "13.46306000"
                    },
                    {
                        "id": 17280,
                        "name": "Mbanza-Ngungu",
                        "latitude": "-5.25837000",
                        "longitude": "14.85838000"
                    },
                    {
                        "id": 17282,
                        "name": "Moanda",
                        "latitude": "-5.92753000",
                        "longitude": "12.37148000"
                    },
                    {
                        "id": 17288,
                        "name": "Tshela",
                        "latitude": "-4.99707000",
                        "longitude": "12.94840000"
                    }
                ]
            },
            {
                "id": 2740,
                "name": "Kwango",
                "iso2": "KG",
                "latitude": "-6.43374090",
                "longitude": "17.66888700",
                "type": "province",
                "cities": [
                    {
                        "id": 17260,
                        "name": "Kasongo-Lunda",
                        "latitude": "-6.47833000",
                        "longitude": "16.81735000"
                    }
                ]
            },
            {
                "id": 2759,
                "name": "Kwilu",
                "iso2": "KL",
                "latitude": "-5.11888250",
                "longitude": "18.42760470",
                "type": "province",
                "cities": [
                    {
                        "id": 17226,
                        "name": "Bandundu",
                        "latitude": "-3.31687000",
                        "longitude": "17.38063000"
                    },
                    {
                        "id": 17237,
                        "name": "Bulungu",
                        "latitude": "-4.54437000",
                        "longitude": "18.60364000"
                    },
                    {
                        "id": 17261,
                        "name": "Kikwit",
                        "latitude": "-5.04098000",
                        "longitude": "18.81619000"
                    },
                    {
                        "id": 17276,
                        "name": "Mangai",
                        "latitude": "-4.02328000",
                        "longitude": "19.53385000"
                    }
                ]
            },
            {
                "id": 2747,
                "name": "Lomami",
                "iso2": "LO",
                "latitude": "-6.14539310",
                "longitude": "24.52426400",
                "type": "province",
                "cities": [
                    {
                        "id": 17271,
                        "name": "Lubao",
                        "latitude": "-5.38771000",
                        "longitude": "25.74885000"
                    },
                    {
                        "id": 17285,
                        "name": "Mwene-Ditu",
                        "latitude": "-7.00906000",
                        "longitude": "23.45278000"
                    }
                ]
            },
            {
                "id": 4953,
                "name": "Lualaba",
                "iso2": "LU",
                "latitude": "-10.48086980",
                "longitude": "25.62978160",
                "type": "province",
                "cities": [
                    {
                        "id": 153949,
                        "name": "Kasaji",
                        "latitude": "-10.38342000",
                        "longitude": "23.44987000"
                    },
                    {
                        "id": 153948,
                        "name": "Kolwezi",
                        "latitude": "-10.71666700",
                        "longitude": "25.46666700"
                    }
                ]
            },
            {
                "id": 2755,
                "name": "Mai-Ndombe",
                "iso2": "MN",
                "latitude": "-2.63574340",
                "longitude": "18.42760470",
                "type": "province",
                "cities": [
                    {
                        "id": 17230,
                        "name": "Bolobo",
                        "latitude": "-2.15800000",
                        "longitude": "16.23249000"
                    },
                    {
                        "id": 17249,
                        "name": "Inongo",
                        "latitude": "-1.92750000",
                        "longitude": "18.28810000"
                    },
                    {
                        "id": 17283,
                        "name": "Mushie",
                        "latitude": "-3.01728000",
                        "longitude": "16.92238000"
                    },
                    {
                        "id": 17286,
                        "name": "Nioki",
                        "latitude": "-2.72037000",
                        "longitude": "17.69001000"
                    }
                ]
            },
            {
                "id": 2745,
                "name": "Maniema",
                "iso2": "MA",
                "latitude": "-3.07309290",
                "longitude": "26.04138890",
                "type": "province",
                "cities": [
                    {
                        "id": 17257,
                        "name": "Kampene",
                        "latitude": "-3.59678000",
                        "longitude": "26.66715000"
                    },
                    {
                        "id": 17259,
                        "name": "Kasongo",
                        "latitude": "-4.42741000",
                        "longitude": "26.66656000"
                    },
                    {
                        "id": 17262,
                        "name": "Kindu",
                        "latitude": "-2.94373000",
                        "longitude": "25.92237000"
                    }
                ]
            },
            {
                "id": 2752,
                "name": "Mongala",
                "iso2": "MO",
                "latitude": "1.99623240",
                "longitude": "21.47528510",
                "type": "province",
                "cities": [
                    {
                        "id": 17238,
                        "name": "Bumba",
                        "latitude": "2.18771000",
                        "longitude": "22.46827000"
                    }
                ]
            },
            {
                "id": 2749,
                "name": "Nord-Kivu",
                "iso2": "NK",
                "latitude": "-0.79177290",
                "longitude": "29.04599270",
                "type": "province",
                "cities": [
                    {
                        "id": 17228,
                        "name": "Beni",
                        "latitude": "0.49113000",
                        "longitude": "29.47306000"
                    },
                    {
                        "id": 17242,
                        "name": "Butembo",
                        "latitude": "0.14164000",
                        "longitude": "29.29117000"
                    },
                    {
                        "id": 17246,
                        "name": "Goma",
                        "latitude": "-1.67409000",
                        "longitude": "29.22845000"
                    },
                    {
                        "id": 17287,
                        "name": "Sake",
                        "latitude": "-1.57386000",
                        "longitude": "29.04339000"
                    }
                ]
            },
            {
                "id": 2739,
                "name": "Nord-Ubangi",
                "iso2": "NU",
                "latitude": "3.78787260",
                "longitude": "21.47528510",
                "type": "province",
                "cities": [
                    {
                        "id": 17234,
                        "name": "Bosobolo",
                        "latitude": "4.18980000",
                        "longitude": "19.88330000"
                    },
                    {
                        "id": 17240,
                        "name": "Businga",
                        "latitude": "3.33863000",
                        "longitude": "20.88577000"
                    },
                    {
                        "id": 17244,
                        "name": "Gbadolite",
                        "latitude": "4.27900000",
                        "longitude": "21.00284000"
                    }
                ]
            },
            {
                "id": 2743,
                "name": "Sankuru",
                "iso2": "SA",
                "latitude": "-2.84374530",
                "longitude": "23.38235450",
                "type": "province",
                "cities": [
                    {
                        "id": 17270,
                        "name": "Lodja",
                        "latitude": "-3.52105000",
                        "longitude": "23.60050000"
                    },
                    {
                        "id": 17275,
                        "name": "Lusambo",
                        "latitude": "-4.97503000",
                        "longitude": "23.44391000"
                    }
                ]
            },
            {
                "id": 2738,
                "name": "Sud-Kivu",
                "iso2": "SK",
                "latitude": "-3.01165800",
                "longitude": "28.29943500",
                "type": "province",
                "cities": [
                    {
                        "id": 17236,
                        "name": "Bukavu",
                        "latitude": "-2.49077000",
                        "longitude": "28.84281000"
                    },
                    {
                        "id": 17252,
                        "name": "Kabare",
                        "latitude": "-2.49682000",
                        "longitude": "28.79081000"
                    },
                    {
                        "id": 17290,
                        "name": "Uvira",
                        "latitude": "-3.39534000",
                        "longitude": "29.13779000"
                    }
                ]
            },
            {
                "id": 2748,
                "name": "Sud-Ubangi",
                "iso2": "SU",
                "latitude": "3.22999420",
                "longitude": "19.18800470",
                "type": "province",
                "cities": [
                    {
                        "id": 17233,
                        "name": "Bongandanga",
                        "latitude": "1.50695000",
                        "longitude": "21.07260000"
                    },
                    {
                        "id": 17267,
                        "name": "Libenge",
                        "latitude": "3.65332000",
                        "longitude": "18.63566000"
                    }
                ]
            },
            {
                "id": 2733,
                "name": "Tanganyika",
                "iso2": "TA",
                "latitude": "-6.27401180",
                "longitude": "27.92490020",
                "type": "province",
                "cities": [
                    {
                        "id": 17251,
                        "name": "Kabalo",
                        "latitude": "-6.05255000",
                        "longitude": "26.91430000"
                    },
                    {
                        "id": 17254,
                        "name": "Kalemie",
                        "latitude": "-5.94749000",
                        "longitude": "29.19471000"
                    },
                    {
                        "id": 17266,
                        "name": "Kongolo",
                        "latitude": "-5.38532000",
                        "longitude": "27.00029000"
                    }
                ]
            },
            {
                "id": 2756,
                "name": "Tshopo",
                "iso2": "TO",
                "latitude": "0.54554620",
                "longitude": "24.90422080",
                "type": "province",
                "cities": [
                    {
                        "id": 17227,
                        "name": "Basoko",
                        "latitude": "1.23909000",
                        "longitude": "23.61598000"
                    },
                    {
                        "id": 17265,
                        "name": "Kisangani",
                        "latitude": "0.51528000",
                        "longitude": "25.19099000"
                    },
                    {
                        "id": 17293,
                        "name": "Yangambi",
                        "latitude": "0.76755000",
                        "longitude": "24.43973000"
                    }
                ]
            },
            {
                "id": 2732,
                "name": "Tshuapa",
                "iso2": "TU",
                "latitude": "-0.99030230",
                "longitude": "23.02888440",
                "type": "province",
                "cities": [
                    {
                        "id": 17229,
                        "name": "Boende",
                        "latitude": "-0.28163000",
                        "longitude": "20.88053000"
                    }
                ]
            }
        ]
    },
    {
        "id": 59,
        "name": "Denmark",
        "iso3": "DNK",
        "iso2": "DK",
        "numeric_code": "208",
        "phonecode": "45",
        "capital": "Copenhagen",
        "currency": "DKK",
        "currency_name": "Danish krone",
        "currency_symbol": "Kr.",
        "tld": ".dk",
        "native": "Danmark",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Danish",
        "timezones": [
            {
                "zoneName": "Europe\/Copenhagen",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Danmark",
            "ko": "덴마크",
            "pt-BR": "Dinamarca",
            "pt": "Dinamarca",
            "nl": "Denemarken",
            "hr": "Danska",
            "fa": "دانمارک",
            "de": "Dänemark",
            "es": "Dinamarca",
            "fr": "Danemark",
            "ja": "デンマーク",
            "it": "Danimarca",
            "zh-CN": "丹麦",
            "tr": "Danimarka",
            "ru": "Дания",
            "uk": "Данія",
            "pl": "Dania"
        },
        "latitude": "56.00000000",
        "longitude": "10.00000000",
        "emoji": "🇩🇰",
        "emojiU": "U+1F1E9 U+1F1F0",
        "states": [
            {
                "id": 1531,
                "name": "Central Denmark",
                "iso2": "82",
                "latitude": "56.30213900",
                "longitude": "9.30277700",
                "type": "region",
                "cities": [
                    {
                        "id": 30993,
                        "name": "Aarhus",
                        "latitude": "56.15674000",
                        "longitude": "10.21076000"
                    },
                    {
                        "id": 30994,
                        "name": "Aarhus Kommune",
                        "latitude": "56.16317000",
                        "longitude": "10.16897000"
                    },
                    {
                        "id": 30580,
                        "name": "Allingåbro",
                        "latitude": "56.46432000",
                        "longitude": "10.31957000"
                    },
                    {
                        "id": 30585,
                        "name": "Assentoft",
                        "latitude": "56.44210000",
                        "longitude": "10.15170000"
                    },
                    {
                        "id": 30587,
                        "name": "Auning",
                        "latitude": "56.43079000",
                        "longitude": "10.37818000"
                    },
                    {
                        "id": 30588,
                        "name": "Avlum",
                        "latitude": "56.26539000",
                        "longitude": "8.79256000"
                    },
                    {
                        "id": 30591,
                        "name": "Beder",
                        "latitude": "56.06025000",
                        "longitude": "10.21179000"
                    },
                    {
                        "id": 30596,
                        "name": "Bjerringbro",
                        "latitude": "56.37797000",
                        "longitude": "9.66065000"
                    },
                    {
                        "id": 30600,
                        "name": "Bording Kirkeby",
                        "latitude": "56.16871000",
                        "longitude": "9.24384000"
                    },
                    {
                        "id": 30604,
                        "name": "Brande",
                        "latitude": "55.94316000",
                        "longitude": "9.12798000"
                    },
                    {
                        "id": 30609,
                        "name": "Brædstrup",
                        "latitude": "55.97153000",
                        "longitude": "9.61129000"
                    },
                    {
                        "id": 30626,
                        "name": "Ebeltoft",
                        "latitude": "56.19442000",
                        "longitude": "10.68210000"
                    },
                    {
                        "id": 30639,
                        "name": "Favrskov Kommune",
                        "latitude": "56.31667000",
                        "longitude": "9.94000000"
                    },
                    {
                        "id": 30647,
                        "name": "Framlev",
                        "latitude": "56.15664000",
                        "longitude": "10.01318000"
                    },
                    {
                        "id": 30663,
                        "name": "Galten",
                        "latitude": "56.15902000",
                        "longitude": "9.91691000"
                    },
                    {
                        "id": 30669,
                        "name": "Gjellerup",
                        "latitude": "56.14616000",
                        "longitude": "9.05467000"
                    },
                    {
                        "id": 30675,
                        "name": "Grenaa",
                        "latitude": "56.41578000",
                        "longitude": "10.87825000"
                    },
                    {
                        "id": 30688,
                        "name": "Hadsten",
                        "latitude": "56.32819000",
                        "longitude": "10.04931000"
                    },
                    {
                        "id": 30692,
                        "name": "Hammel",
                        "latitude": "56.25762000",
                        "longitude": "9.86316000"
                    },
                    {
                        "id": 30693,
                        "name": "Hammerum",
                        "latitude": "56.13361000",
                        "longitude": "9.06121000"
                    },
                    {
                        "id": 30695,
                        "name": "Harboøre",
                        "latitude": "56.61752000",
                        "longitude": "8.18069000"
                    },
                    {
                        "id": 30698,
                        "name": "Hedensted",
                        "latitude": "55.77043000",
                        "longitude": "9.70110000"
                    },
                    {
                        "id": 30699,
                        "name": "Hedensted Kommune",
                        "latitude": "55.79680000",
                        "longitude": "9.74400000"
                    },
                    {
                        "id": 30705,
                        "name": "Herning",
                        "latitude": "56.13615000",
                        "longitude": "8.97662000"
                    },
                    {
                        "id": 30706,
                        "name": "Herning Kommune",
                        "latitude": "56.14997000",
                        "longitude": "8.89712000"
                    },
                    {
                        "id": 30709,
                        "name": "Hinnerup",
                        "latitude": "56.26608000",
                        "longitude": "10.06299000"
                    },
                    {
                        "id": 30712,
                        "name": "Hjortshøj",
                        "latitude": "56.24811000",
                        "longitude": "10.26533000"
                    },
                    {
                        "id": 30719,
                        "name": "Holstebro",
                        "latitude": "56.36009000",
                        "longitude": "8.61607000"
                    },
                    {
                        "id": 30720,
                        "name": "Holstebro Kommune",
                        "latitude": "56.35916000",
                        "longitude": "8.59631000"
                    },
                    {
                        "id": 30723,
                        "name": "Hornslet",
                        "latitude": "56.31550000",
                        "longitude": "10.32041000"
                    },
                    {
                        "id": 30724,
                        "name": "Hornsyld",
                        "latitude": "55.75621000",
                        "longitude": "9.85643000"
                    },
                    {
                        "id": 30725,
                        "name": "Horsens",
                        "latitude": "55.86066000",
                        "longitude": "9.85034000"
                    },
                    {
                        "id": 30726,
                        "name": "Horsens Kommune",
                        "latitude": "55.92740000",
                        "longitude": "9.77377000"
                    },
                    {
                        "id": 30738,
                        "name": "Hørning",
                        "latitude": "56.08701000",
                        "longitude": "10.03716000"
                    },
                    {
                        "id": 30730,
                        "name": "Hvide Sande",
                        "latitude": "55.99866000",
                        "longitude": "8.12605000"
                    },
                    {
                        "id": 30743,
                        "name": "Ikast",
                        "latitude": "56.13883000",
                        "longitude": "9.15768000"
                    },
                    {
                        "id": 30744,
                        "name": "Ikast-Brande Kommune",
                        "latitude": "55.98333000",
                        "longitude": "9.21667000"
                    },
                    {
                        "id": 30749,
                        "name": "Juelsminde",
                        "latitude": "55.70876000",
                        "longitude": "10.01668000"
                    },
                    {
                        "id": 30755,
                        "name": "Karup",
                        "latitude": "56.30673000",
                        "longitude": "9.16835000"
                    },
                    {
                        "id": 30758,
                        "name": "Kibæk",
                        "latitude": "56.03170000",
                        "longitude": "8.85697000"
                    },
                    {
                        "id": 30760,
                        "name": "Kjellerup",
                        "latitude": "56.28581000",
                        "longitude": "9.43528000"
                    },
                    {
                        "id": 30765,
                        "name": "Kolt",
                        "latitude": "56.10845000",
                        "longitude": "10.06986000"
                    },
                    {
                        "id": 30775,
                        "name": "Langå",
                        "latitude": "56.39026000",
                        "longitude": "9.89486000"
                    },
                    {
                        "id": 30778,
                        "name": "Lemvig",
                        "latitude": "56.54856000",
                        "longitude": "8.31019000"
                    },
                    {
                        "id": 30779,
                        "name": "Lemvig Kommune",
                        "latitude": "56.49136000",
                        "longitude": "8.29927000"
                    },
                    {
                        "id": 30781,
                        "name": "Lind",
                        "latitude": "56.10600000",
                        "longitude": "8.97915000"
                    },
                    {
                        "id": 30790,
                        "name": "Løgten",
                        "latitude": "56.27459000",
                        "longitude": "10.31181000"
                    },
                    {
                        "id": 30787,
                        "name": "Lystrup",
                        "latitude": "56.23750000",
                        "longitude": "10.23778000"
                    },
                    {
                        "id": 30794,
                        "name": "Malling",
                        "latitude": "56.03632000",
                        "longitude": "10.19632000"
                    },
                    {
                        "id": 30804,
                        "name": "Mårslet",
                        "latitude": "56.06690000",
                        "longitude": "10.16112000"
                    },
                    {
                        "id": 30813,
                        "name": "Norddjurs Kommune",
                        "latitude": "56.44124000",
                        "longitude": "10.76660000"
                    },
                    {
                        "id": 30827,
                        "name": "Odder",
                        "latitude": "55.97313000",
                        "longitude": "10.15300000"
                    },
                    {
                        "id": 30828,
                        "name": "Odder Kommune",
                        "latitude": "55.92967000",
                        "longitude": "10.15304000"
                    },
                    {
                        "id": 30838,
                        "name": "Randers",
                        "latitude": "56.46070000",
                        "longitude": "10.03639000"
                    },
                    {
                        "id": 30839,
                        "name": "Randers Kommune",
                        "latitude": "56.51561000",
                        "longitude": "10.06901000"
                    },
                    {
                        "id": 30843,
                        "name": "Ringkøbing",
                        "latitude": "56.09006000",
                        "longitude": "8.24402000"
                    },
                    {
                        "id": 30844,
                        "name": "Ringkøbing-Skjern Kommune",
                        "latitude": "56.01000000",
                        "longitude": "8.39667000"
                    },
                    {
                        "id": 30860,
                        "name": "Rønde",
                        "latitude": "56.30145000",
                        "longitude": "10.47505000"
                    },
                    {
                        "id": 30851,
                        "name": "Ry",
                        "latitude": "56.09038000",
                        "longitude": "9.76505000"
                    },
                    {
                        "id": 30852,
                        "name": "Ryomgård",
                        "latitude": "56.38430000",
                        "longitude": "10.50295000"
                    },
                    {
                        "id": 30863,
                        "name": "Sabro",
                        "latitude": "56.21333000",
                        "longitude": "10.03441000"
                    },
                    {
                        "id": 30865,
                        "name": "Samsø Kommune",
                        "latitude": "55.85245000",
                        "longitude": "10.60045000"
                    },
                    {
                        "id": 30867,
                        "name": "Silkeborg",
                        "latitude": "56.16970000",
                        "longitude": "9.54508000"
                    },
                    {
                        "id": 30868,
                        "name": "Silkeborg Kommune",
                        "latitude": "56.17495000",
                        "longitude": "9.54666000"
                    },
                    {
                        "id": 30872,
                        "name": "Skanderborg",
                        "latitude": "56.03434000",
                        "longitude": "9.93177000"
                    },
                    {
                        "id": 30873,
                        "name": "Skanderborg Kommune",
                        "latitude": "56.07956000",
                        "longitude": "9.89868000"
                    },
                    {
                        "id": 30875,
                        "name": "Skive",
                        "latitude": "56.56699000",
                        "longitude": "9.02707000"
                    },
                    {
                        "id": 30876,
                        "name": "Skive Kommune",
                        "latitude": "56.64478000",
                        "longitude": "8.97660000"
                    },
                    {
                        "id": 30877,
                        "name": "Skjern",
                        "latitude": "55.95000000",
                        "longitude": "8.50000000"
                    },
                    {
                        "id": 30878,
                        "name": "Skovby",
                        "latitude": "56.15672000",
                        "longitude": "9.94523000"
                    },
                    {
                        "id": 30886,
                        "name": "Snejbjerg",
                        "latitude": "56.13291000",
                        "longitude": "8.90353000"
                    },
                    {
                        "id": 30888,
                        "name": "Solbjerg",
                        "latitude": "56.04271000",
                        "longitude": "10.08631000"
                    },
                    {
                        "id": 30925,
                        "name": "Søften",
                        "latitude": "56.23801000",
                        "longitude": "10.08510000"
                    },
                    {
                        "id": 30894,
                        "name": "Spentrup",
                        "latitude": "56.53703000",
                        "longitude": "10.03792000"
                    },
                    {
                        "id": 30897,
                        "name": "Stavtrup",
                        "latitude": "56.13124000",
                        "longitude": "10.11987000"
                    },
                    {
                        "id": 30903,
                        "name": "Stilling",
                        "latitude": "56.06224000",
                        "longitude": "9.98822000"
                    },
                    {
                        "id": 30904,
                        "name": "Stoholm",
                        "latitude": "56.48454000",
                        "longitude": "9.14617000"
                    },
                    {
                        "id": 30909,
                        "name": "Struer",
                        "latitude": "56.49205000",
                        "longitude": "8.59397000"
                    },
                    {
                        "id": 30910,
                        "name": "Struer Kommune",
                        "latitude": "56.46667000",
                        "longitude": "8.58333000"
                    },
                    {
                        "id": 30915,
                        "name": "Sunds",
                        "latitude": "56.20743000",
                        "longitude": "9.01386000"
                    },
                    {
                        "id": 30917,
                        "name": "Svejbæk",
                        "latitude": "56.13255000",
                        "longitude": "9.63289000"
                    },
                    {
                        "id": 30923,
                        "name": "Syddjurs Kommune",
                        "latitude": "56.31250000",
                        "longitude": "10.52083000"
                    },
                    {
                        "id": 30931,
                        "name": "Tarm",
                        "latitude": "55.90861000",
                        "longitude": "8.53041000"
                    },
                    {
                        "id": 30936,
                        "name": "Thyborøn",
                        "latitude": "56.69846000",
                        "longitude": "8.21238000"
                    },
                    {
                        "id": 30952,
                        "name": "Tørring",
                        "latitude": "55.85000000",
                        "longitude": "9.48333000"
                    },
                    {
                        "id": 30942,
                        "name": "Tranbjerg",
                        "latitude": "56.09519000",
                        "longitude": "10.13605000"
                    },
                    {
                        "id": 30943,
                        "name": "Trige",
                        "latitude": "56.25291000",
                        "longitude": "10.14840000"
                    },
                    {
                        "id": 30953,
                        "name": "Ulfborg",
                        "latitude": "56.26725000",
                        "longitude": "8.32167000"
                    },
                    {
                        "id": 30955,
                        "name": "Ulstrup",
                        "latitude": "56.38994000",
                        "longitude": "9.79354000"
                    },
                    {
                        "id": 30972,
                        "name": "Viborg",
                        "latitude": "56.45319000",
                        "longitude": "9.40201000"
                    },
                    {
                        "id": 30973,
                        "name": "Viborg Kommune",
                        "latitude": "56.45000000",
                        "longitude": "9.36667000"
                    },
                    {
                        "id": 30975,
                        "name": "Videbæk",
                        "latitude": "56.08760000",
                        "longitude": "8.62852000"
                    },
                    {
                        "id": 30976,
                        "name": "Vildbjerg",
                        "latitude": "56.20000000",
                        "longitude": "8.76667000"
                    },
                    {
                        "id": 30978,
                        "name": "Vinderup",
                        "latitude": "56.48176000",
                        "longitude": "8.77991000"
                    },
                    {
                        "id": 30981,
                        "name": "Virklund",
                        "latitude": "56.13218000",
                        "longitude": "9.55582000"
                    }
                ]
            },
            {
                "id": 1530,
                "name": "Denmark",
                "iso2": "84",
                "latitude": "55.67518120",
                "longitude": "12.54932610",
                "type": "region",
                "cities": [
                    {
                        "id": 30990,
                        "name": "Åkirkeby",
                        "latitude": "55.07080000",
                        "longitude": "14.91978000"
                    },
                    {
                        "id": 30577,
                        "name": "Albertslund",
                        "latitude": "55.65691000",
                        "longitude": "12.36381000"
                    },
                    {
                        "id": 30578,
                        "name": "Albertslund Kommune",
                        "latitude": "55.68022000",
                        "longitude": "12.34797000"
                    },
                    {
                        "id": 30579,
                        "name": "Allerød Kommune",
                        "latitude": "55.85856000",
                        "longitude": "12.32558000"
                    },
                    {
                        "id": 30589,
                        "name": "Ballerup",
                        "latitude": "55.73165000",
                        "longitude": "12.36328000"
                    },
                    {
                        "id": 30590,
                        "name": "Ballerup Kommune",
                        "latitude": "55.73248000",
                        "longitude": "12.35793000"
                    },
                    {
                        "id": 30595,
                        "name": "Birkerød",
                        "latitude": "55.84759000",
                        "longitude": "12.42791000"
                    },
                    {
                        "id": 30598,
                        "name": "Blovstrød",
                        "latitude": "55.87038000",
                        "longitude": "12.38640000"
                    },
                    {
                        "id": 30601,
                        "name": "Bornholm Kommune",
                        "latitude": "55.12386000",
                        "longitude": "14.91115000"
                    },
                    {
                        "id": 30610,
                        "name": "Brøndby Kommune",
                        "latitude": "55.64290000",
                        "longitude": "12.41101000"
                    },
                    {
                        "id": 30616,
                        "name": "Charlottenlund",
                        "latitude": "55.75238000",
                        "longitude": "12.57450000"
                    },
                    {
                        "id": 30618,
                        "name": "Christianshavn",
                        "latitude": "55.67383000",
                        "longitude": "12.59541000"
                    },
                    {
                        "id": 30619,
                        "name": "Christiansø",
                        "latitude": "55.31982000",
                        "longitude": "15.18783000"
                    },
                    {
                        "id": 30620,
                        "name": "Copenhagen",
                        "latitude": "55.67594000",
                        "longitude": "12.56553000"
                    },
                    {
                        "id": 30622,
                        "name": "Dragør",
                        "latitude": "55.59280000",
                        "longitude": "12.67221000"
                    },
                    {
                        "id": 30623,
                        "name": "Dragør Kommune",
                        "latitude": "55.58233000",
                        "longitude": "12.62756000"
                    },
                    {
                        "id": 30627,
                        "name": "Egedal Kommune",
                        "latitude": "55.75556000",
                        "longitude": "12.22778000"
                    },
                    {
                        "id": 30633,
                        "name": "Espergærde",
                        "latitude": "55.99464000",
                        "longitude": "12.54733000"
                    },
                    {
                        "id": 30638,
                        "name": "Farum",
                        "latitude": "55.80858000",
                        "longitude": "12.36066000"
                    },
                    {
                        "id": 30645,
                        "name": "Fløng",
                        "latitude": "55.66212000",
                        "longitude": "12.18698000"
                    },
                    {
                        "id": 30648,
                        "name": "Fredensborg",
                        "latitude": "55.97558000",
                        "longitude": "12.40314000"
                    },
                    {
                        "id": 30649,
                        "name": "Fredensborg Kommune",
                        "latitude": "55.95000000",
                        "longitude": "12.45000000"
                    },
                    {
                        "id": 30652,
                        "name": "Frederiksberg",
                        "latitude": "55.67938000",
                        "longitude": "12.53463000"
                    },
                    {
                        "id": 30654,
                        "name": "Frederiksberg Kommune",
                        "latitude": "55.67856000",
                        "longitude": "12.52216000"
                    },
                    {
                        "id": 30657,
                        "name": "Frederikssund",
                        "latitude": "55.83956000",
                        "longitude": "12.06896000"
                    },
                    {
                        "id": 30658,
                        "name": "Frederikssund Kommune",
                        "latitude": "55.80957000",
                        "longitude": "12.04038000"
                    },
                    {
                        "id": 30659,
                        "name": "Frederiksværk",
                        "latitude": "55.97073000",
                        "longitude": "12.02250000"
                    },
                    {
                        "id": 30662,
                        "name": "Furesø Kommune",
                        "latitude": "55.78333000",
                        "longitude": "12.34167000"
                    },
                    {
                        "id": 30664,
                        "name": "Ganløse",
                        "latitude": "55.79124000",
                        "longitude": "12.26421000"
                    },
                    {
                        "id": 30665,
                        "name": "Gentofte Kommune",
                        "latitude": "55.75000000",
                        "longitude": "12.55000000"
                    },
                    {
                        "id": 30666,
                        "name": "Gilleleje",
                        "latitude": "56.12196000",
                        "longitude": "12.31056000"
                    },
                    {
                        "id": 30670,
                        "name": "Gladsaxe Municipality",
                        "latitude": "55.76667000",
                        "longitude": "12.43333000"
                    },
                    {
                        "id": 30672,
                        "name": "Glostrup",
                        "latitude": "55.66660000",
                        "longitude": "12.40377000"
                    },
                    {
                        "id": 30673,
                        "name": "Glostrup Kommune",
                        "latitude": "55.68188000",
                        "longitude": "12.41018000"
                    },
                    {
                        "id": 30681,
                        "name": "Græsted",
                        "latitude": "56.06558000",
                        "longitude": "12.28512000"
                    },
                    {
                        "id": 30678,
                        "name": "Gribskov Kommune",
                        "latitude": "56.05833000",
                        "longitude": "12.24167000"
                    },
                    {
                        "id": 30691,
                        "name": "Halsnæs Kommune",
                        "latitude": "55.96765000",
                        "longitude": "11.94214000"
                    },
                    {
                        "id": 153629,
                        "name": "Hedehusene",
                        "latitude": "55.67594000",
                        "longitude": "12.56553000"
                    },
                    {
                        "id": 30700,
                        "name": "Hellebæk",
                        "latitude": "56.06823000",
                        "longitude": "12.55782000"
                    },
                    {
                        "id": 30701,
                        "name": "Helsinge",
                        "latitude": "56.02283000",
                        "longitude": "12.19752000"
                    },
                    {
                        "id": 30702,
                        "name": "Helsingør",
                        "latitude": "56.03606000",
                        "longitude": "12.61360000"
                    },
                    {
                        "id": 30703,
                        "name": "Helsingør Kommune",
                        "latitude": "56.05000000",
                        "longitude": "12.50000000"
                    },
                    {
                        "id": 30704,
                        "name": "Herlev Kommune",
                        "latitude": "55.73317000",
                        "longitude": "12.43106000"
                    },
                    {
                        "id": 30707,
                        "name": "Hillerød",
                        "latitude": "55.92791000",
                        "longitude": "12.30081000"
                    },
                    {
                        "id": 30708,
                        "name": "Hillerød Kommune",
                        "latitude": "55.92319000",
                        "longitude": "12.23794000"
                    },
                    {
                        "id": 30722,
                        "name": "Hornbæk",
                        "latitude": "56.09027000",
                        "longitude": "12.45693000"
                    },
                    {
                        "id": 30736,
                        "name": "Høje-Taastrup Kommune",
                        "latitude": "55.65643000",
                        "longitude": "12.24854000"
                    },
                    {
                        "id": 30739,
                        "name": "Hørsholm",
                        "latitude": "55.88098000",
                        "longitude": "12.50111000"
                    },
                    {
                        "id": 30740,
                        "name": "Hørsholm Kommune",
                        "latitude": "55.88759000",
                        "longitude": "12.48566000"
                    },
                    {
                        "id": 30727,
                        "name": "Humlebæk",
                        "latitude": "55.96180000",
                        "longitude": "12.53410000"
                    },
                    {
                        "id": 30728,
                        "name": "Hundested",
                        "latitude": "55.96397000",
                        "longitude": "11.85044000"
                    },
                    {
                        "id": 30731,
                        "name": "Hvidovre",
                        "latitude": "55.65719000",
                        "longitude": "12.47364000"
                    },
                    {
                        "id": 30732,
                        "name": "Hvidovre Kommune",
                        "latitude": "55.63166000",
                        "longitude": "12.46615000"
                    },
                    {
                        "id": 30745,
                        "name": "Ishøj",
                        "latitude": "55.61543000",
                        "longitude": "12.35182000"
                    },
                    {
                        "id": 30746,
                        "name": "Ishøj Kommune",
                        "latitude": "55.62299000",
                        "longitude": "12.30567000"
                    },
                    {
                        "id": 30752,
                        "name": "Jægerspris",
                        "latitude": "55.85248000",
                        "longitude": "11.98565000"
                    },
                    {
                        "id": 30762,
                        "name": "Kokkedal",
                        "latitude": "55.91179000",
                        "longitude": "12.49952000"
                    },
                    {
                        "id": 30766,
                        "name": "Kongens Lyngby",
                        "latitude": "55.77044000",
                        "longitude": "12.50378000"
                    },
                    {
                        "id": 30770,
                        "name": "København",
                        "latitude": "55.67110000",
                        "longitude": "12.56529000"
                    },
                    {
                        "id": 30780,
                        "name": "Lillerød",
                        "latitude": "55.87496000",
                        "longitude": "12.34579000"
                    },
                    {
                        "id": 30782,
                        "name": "Liseleje",
                        "latitude": "56.01295000",
                        "longitude": "11.96544000"
                    },
                    {
                        "id": 30785,
                        "name": "Lyngby-Tårbæk Kommune",
                        "latitude": "55.78456000",
                        "longitude": "12.50508000"
                    },
                    {
                        "id": 30786,
                        "name": "Lynge",
                        "latitude": "55.83941000",
                        "longitude": "12.27725000"
                    },
                    {
                        "id": 30803,
                        "name": "Måløv",
                        "latitude": "55.75528000",
                        "longitude": "12.32327000"
                    },
                    {
                        "id": 30808,
                        "name": "Nexø",
                        "latitude": "55.06067000",
                        "longitude": "15.13058000"
                    },
                    {
                        "id": 30810,
                        "name": "Nivå",
                        "latitude": "55.93405000",
                        "longitude": "12.50485000"
                    },
                    {
                        "id": 30823,
                        "name": "Nødebo",
                        "latitude": "55.97877000",
                        "longitude": "12.34685000"
                    },
                    {
                        "id": 31000,
                        "name": "Ølstykke",
                        "latitude": "55.79567000",
                        "longitude": "12.15509000"
                    },
                    {
                        "id": 30857,
                        "name": "Rødovre",
                        "latitude": "55.68062000",
                        "longitude": "12.45373000"
                    },
                    {
                        "id": 30858,
                        "name": "Rødovre Kommune",
                        "latitude": "55.68852000",
                        "longitude": "12.44834000"
                    },
                    {
                        "id": 30861,
                        "name": "Rønne",
                        "latitude": "55.10091000",
                        "longitude": "14.70664000"
                    },
                    {
                        "id": 30849,
                        "name": "Rudersdal Kommune",
                        "latitude": "55.82500000",
                        "longitude": "12.49167000"
                    },
                    {
                        "id": 30880,
                        "name": "Skævinge",
                        "latitude": "55.90785000",
                        "longitude": "12.15036000"
                    },
                    {
                        "id": 30874,
                        "name": "Skibby",
                        "latitude": "55.75122000",
                        "longitude": "11.96083000"
                    },
                    {
                        "id": 30884,
                        "name": "Slangerup",
                        "latitude": "55.85000000",
                        "longitude": "12.18333000"
                    },
                    {
                        "id": 30885,
                        "name": "Smørumnedre",
                        "latitude": "55.74232000",
                        "longitude": "12.30276000"
                    },
                    {
                        "id": 30896,
                        "name": "Stavnsholt",
                        "latitude": "55.81479000",
                        "longitude": "12.40545000"
                    },
                    {
                        "id": 30900,
                        "name": "Stenløse",
                        "latitude": "55.76828000",
                        "longitude": "12.19723000"
                    },
                    {
                        "id": 30930,
                        "name": "Taastrup",
                        "latitude": "55.65006000",
                        "longitude": "12.30160000"
                    },
                    {
                        "id": 30946,
                        "name": "Tårnby",
                        "latitude": "55.63030000",
                        "longitude": "12.60035000"
                    },
                    {
                        "id": 30947,
                        "name": "Tårnby Kommune",
                        "latitude": "55.60391000",
                        "longitude": "12.59599000"
                    },
                    {
                        "id": 30944,
                        "name": "Trørød",
                        "latitude": "55.83946000",
                        "longitude": "12.54432000"
                    },
                    {
                        "id": 30958,
                        "name": "Vallensbæk Kommune",
                        "latitude": "55.63128000",
                        "longitude": "12.37369000"
                    },
                    {
                        "id": 30957,
                        "name": "Vallensbæk Strand",
                        "latitude": "55.62199000",
                        "longitude": "12.38511000"
                    },
                    {
                        "id": 30960,
                        "name": "Vanløse",
                        "latitude": "55.68361000",
                        "longitude": "12.48713000"
                    },
                    {
                        "id": 30988,
                        "name": "Værløse",
                        "latitude": "55.78251000",
                        "longitude": "12.36856000"
                    },
                    {
                        "id": 30967,
                        "name": "Veksø",
                        "latitude": "55.75473000",
                        "longitude": "12.23837000"
                    }
                ]
            },
            {
                "id": 1532,
                "name": "North Denmark",
                "iso2": "81",
                "latitude": "56.83074160",
                "longitude": "9.49305270",
                "type": "region",
                "cities": [
                    {
                        "id": 30575,
                        "name": "Aalborg",
                        "latitude": "57.04800000",
                        "longitude": "9.91870000"
                    },
                    {
                        "id": 30576,
                        "name": "Aars",
                        "latitude": "56.80399000",
                        "longitude": "9.51441000"
                    },
                    {
                        "id": 30989,
                        "name": "Åbybro",
                        "latitude": "57.16249000",
                        "longitude": "9.72996000"
                    },
                    {
                        "id": 30991,
                        "name": "Ålborg Kommune",
                        "latitude": "57.00000000",
                        "longitude": "9.95000000"
                    },
                    {
                        "id": 30992,
                        "name": "Ålestrup",
                        "latitude": "56.69470000",
                        "longitude": "9.49336000"
                    },
                    {
                        "id": 30581,
                        "name": "Arden",
                        "latitude": "56.76899000",
                        "longitude": "9.86184000"
                    },
                    {
                        "id": 30608,
                        "name": "Brovst",
                        "latitude": "57.09750000",
                        "longitude": "9.52264000"
                    },
                    {
                        "id": 30611,
                        "name": "Brønderslev",
                        "latitude": "57.27021000",
                        "longitude": "9.94102000"
                    },
                    {
                        "id": 30612,
                        "name": "Brønderslev Kommune",
                        "latitude": "57.23506000",
                        "longitude": "10.10061000"
                    },
                    {
                        "id": 30624,
                        "name": "Dronninglund",
                        "latitude": "57.16035000",
                        "longitude": "10.29287000"
                    },
                    {
                        "id": 30637,
                        "name": "Farsø",
                        "latitude": "56.77276000",
                        "longitude": "9.33925000"
                    },
                    {
                        "id": 30644,
                        "name": "Fjerritslev",
                        "latitude": "57.08822000",
                        "longitude": "9.26622000"
                    },
                    {
                        "id": 30655,
                        "name": "Frederikshavn",
                        "latitude": "57.44073000",
                        "longitude": "10.53661000"
                    },
                    {
                        "id": 30656,
                        "name": "Frederikshavn Kommune",
                        "latitude": "57.43347000",
                        "longitude": "10.42507000"
                    },
                    {
                        "id": 30660,
                        "name": "Frejlev",
                        "latitude": "57.00623000",
                        "longitude": "9.81711000"
                    },
                    {
                        "id": 30667,
                        "name": "Gistrup",
                        "latitude": "56.99430000",
                        "longitude": "9.99085000"
                    },
                    {
                        "id": 30689,
                        "name": "Hadsund",
                        "latitude": "56.71482000",
                        "longitude": "10.11682000"
                    },
                    {
                        "id": 30690,
                        "name": "Hals",
                        "latitude": "56.99609000",
                        "longitude": "10.30807000"
                    },
                    {
                        "id": 30694,
                        "name": "Hanstholm",
                        "latitude": "57.11667000",
                        "longitude": "8.61667000"
                    },
                    {
                        "id": 30710,
                        "name": "Hirtshals",
                        "latitude": "57.58812000",
                        "longitude": "9.95922000"
                    },
                    {
                        "id": 30711,
                        "name": "Hjallerup",
                        "latitude": "57.16466000",
                        "longitude": "10.14571000"
                    },
                    {
                        "id": 30713,
                        "name": "Hjørring",
                        "latitude": "57.46417000",
                        "longitude": "9.98229000"
                    },
                    {
                        "id": 30714,
                        "name": "Hjørring Kommune",
                        "latitude": "57.45682000",
                        "longitude": "10.05859000"
                    },
                    {
                        "id": 30715,
                        "name": "Hobro",
                        "latitude": "56.64306000",
                        "longitude": "9.79029000"
                    },
                    {
                        "id": 30729,
                        "name": "Hurup",
                        "latitude": "56.74944000",
                        "longitude": "8.41953000"
                    },
                    {
                        "id": 30747,
                        "name": "Jammerbugt Kommune",
                        "latitude": "57.14583000",
                        "longitude": "9.56250000"
                    },
                    {
                        "id": 30769,
                        "name": "Kås",
                        "latitude": "57.19774000",
                        "longitude": "9.67173000"
                    },
                    {
                        "id": 30761,
                        "name": "Klarup",
                        "latitude": "57.01194000",
                        "longitude": "10.05617000"
                    },
                    {
                        "id": 30788,
                        "name": "Læso Kommune",
                        "latitude": "57.26774000",
                        "longitude": "11.02265000"
                    },
                    {
                        "id": 30789,
                        "name": "Løgstør",
                        "latitude": "56.96245000",
                        "longitude": "9.25830000"
                    },
                    {
                        "id": 30793,
                        "name": "Løkken",
                        "latitude": "57.37047000",
                        "longitude": "9.71466000"
                    },
                    {
                        "id": 30795,
                        "name": "Mariager",
                        "latitude": "56.64985000",
                        "longitude": "9.97515000"
                    },
                    {
                        "id": 30796,
                        "name": "Mariagerfjord Kommune",
                        "latitude": "56.69722000",
                        "longitude": "9.84722000"
                    },
                    {
                        "id": 30801,
                        "name": "Morsø Kommune",
                        "latitude": "56.79622000",
                        "longitude": "8.73272000"
                    },
                    {
                        "id": 30809,
                        "name": "Nibe",
                        "latitude": "56.98150000",
                        "longitude": "9.63917000"
                    },
                    {
                        "id": 30826,
                        "name": "Nørresundby",
                        "latitude": "57.05877000",
                        "longitude": "9.92284000"
                    },
                    {
                        "id": 30818,
                        "name": "Nykøbing Mors",
                        "latitude": "56.79334000",
                        "longitude": "8.85282000"
                    },
                    {
                        "id": 30836,
                        "name": "Pandrup",
                        "latitude": "57.22147000",
                        "longitude": "9.67569000"
                    },
                    {
                        "id": 30840,
                        "name": "Rebild Kommune",
                        "latitude": "56.80556000",
                        "longitude": "9.77778000"
                    },
                    {
                        "id": 30924,
                        "name": "Sæby",
                        "latitude": "57.33188000",
                        "longitude": "10.52251000"
                    },
                    {
                        "id": 30869,
                        "name": "Sindal",
                        "latitude": "57.47117000",
                        "longitude": "10.20312000"
                    },
                    {
                        "id": 30871,
                        "name": "Skagen",
                        "latitude": "57.72093000",
                        "longitude": "10.58394000"
                    },
                    {
                        "id": 30881,
                        "name": "Skørping",
                        "latitude": "56.83626000",
                        "longitude": "9.89255000"
                    },
                    {
                        "id": 30906,
                        "name": "Storvorde",
                        "latitude": "57.00392000",
                        "longitude": "10.10125000"
                    },
                    {
                        "id": 30913,
                        "name": "Støvring",
                        "latitude": "56.88536000",
                        "longitude": "9.83839000"
                    },
                    {
                        "id": 30907,
                        "name": "Strandby",
                        "latitude": "57.49150000",
                        "longitude": "10.49609000"
                    },
                    {
                        "id": 30920,
                        "name": "Svenstrup",
                        "latitude": "56.97230000",
                        "longitude": "9.84806000"
                    },
                    {
                        "id": 30948,
                        "name": "Tårs",
                        "latitude": "57.38333000",
                        "longitude": "10.11667000"
                    },
                    {
                        "id": 30933,
                        "name": "Thisted",
                        "latitude": "56.95523000",
                        "longitude": "8.69491000"
                    },
                    {
                        "id": 30934,
                        "name": "Thisted Kommune",
                        "latitude": "57.00397000",
                        "longitude": "8.61834000"
                    },
                    {
                        "id": 30956,
                        "name": "Vadum",
                        "latitude": "57.11790000",
                        "longitude": "9.85700000"
                    },
                    {
                        "id": 30968,
                        "name": "Vestbjerg",
                        "latitude": "57.13166000",
                        "longitude": "9.95942000"
                    },
                    {
                        "id": 30969,
                        "name": "Vester Hassing",
                        "latitude": "57.06767000",
                        "longitude": "10.12558000"
                    },
                    {
                        "id": 30971,
                        "name": "Vesthimmerland Kommune",
                        "latitude": "56.80000000",
                        "longitude": "9.37083000"
                    },
                    {
                        "id": 30983,
                        "name": "Vodskov",
                        "latitude": "57.10854000",
                        "longitude": "10.02215000"
                    },
                    {
                        "id": 30987,
                        "name": "Vrå",
                        "latitude": "57.35370000",
                        "longitude": "9.94176000"
                    }
                ]
            },
            {
                "id": 1529,
                "name": "Southern Denmark",
                "iso2": "83",
                "latitude": "55.33077140",
                "longitude": "9.09249030",
                "type": "region",
                "cities": [
                    {
                        "id": 30573,
                        "name": "Aabenraa",
                        "latitude": "55.04434000",
                        "longitude": "9.41741000"
                    },
                    {
                        "id": 30574,
                        "name": "Aabenraa Kommune",
                        "latitude": "54.98980000",
                        "longitude": "9.31282000"
                    },
                    {
                        "id": 30995,
                        "name": "Årslev",
                        "latitude": "55.30353000",
                        "longitude": "10.46428000"
                    },
                    {
                        "id": 30996,
                        "name": "Årup",
                        "latitude": "55.37315000",
                        "longitude": "10.04131000"
                    },
                    {
                        "id": 30583,
                        "name": "Assens",
                        "latitude": "55.27023000",
                        "longitude": "9.90081000"
                    },
                    {
                        "id": 30584,
                        "name": "Assens Kommune",
                        "latitude": "55.29958000",
                        "longitude": "10.07952000"
                    },
                    {
                        "id": 30586,
                        "name": "Augustenborg",
                        "latitude": "54.95201000",
                        "longitude": "9.87216000"
                    },
                    {
                        "id": 30997,
                        "name": "Ærø Kommune",
                        "latitude": "54.85833000",
                        "longitude": "10.43333000"
                    },
                    {
                        "id": 30998,
                        "name": "Ærøskøbing",
                        "latitude": "54.88803000",
                        "longitude": "10.41117000"
                    },
                    {
                        "id": 30592,
                        "name": "Bellinge",
                        "latitude": "55.33535000",
                        "longitude": "10.32045000"
                    },
                    {
                        "id": 30593,
                        "name": "Billund",
                        "latitude": "55.73349000",
                        "longitude": "9.10785000"
                    },
                    {
                        "id": 30594,
                        "name": "Billund Kommune",
                        "latitude": "55.73079000",
                        "longitude": "8.96844000"
                    },
                    {
                        "id": 30599,
                        "name": "Bogense",
                        "latitude": "55.56691000",
                        "longitude": "10.08863000"
                    },
                    {
                        "id": 30615,
                        "name": "Børkop",
                        "latitude": "55.64195000",
                        "longitude": "9.64958000"
                    },
                    {
                        "id": 30603,
                        "name": "Bramming",
                        "latitude": "55.46946000",
                        "longitude": "8.70007000"
                    },
                    {
                        "id": 30605,
                        "name": "Brejning",
                        "latitude": "55.66594000",
                        "longitude": "9.67217000"
                    },
                    {
                        "id": 30606,
                        "name": "Brenderup",
                        "latitude": "55.48407000",
                        "longitude": "9.97908000"
                    },
                    {
                        "id": 30607,
                        "name": "Broager",
                        "latitude": "54.88940000",
                        "longitude": "9.67465000"
                    },
                    {
                        "id": 30613,
                        "name": "Brørup",
                        "latitude": "55.48194000",
                        "longitude": "9.01756000"
                    },
                    {
                        "id": 30614,
                        "name": "Bullerup",
                        "latitude": "55.42686000",
                        "longitude": "10.47137000"
                    },
                    {
                        "id": 30617,
                        "name": "Christiansfeld",
                        "latitude": "55.35817000",
                        "longitude": "9.48701000"
                    },
                    {
                        "id": 30625,
                        "name": "Dybbøl",
                        "latitude": "54.91079000",
                        "longitude": "9.73601000"
                    },
                    {
                        "id": 30628,
                        "name": "Egtved",
                        "latitude": "55.61613000",
                        "longitude": "9.30763000"
                    },
                    {
                        "id": 30629,
                        "name": "Ejby",
                        "latitude": "55.43010000",
                        "longitude": "9.92973000"
                    },
                    {
                        "id": 30631,
                        "name": "Esbjerg",
                        "latitude": "55.47028000",
                        "longitude": "8.45187000"
                    },
                    {
                        "id": 30632,
                        "name": "Esbjerg Kommune",
                        "latitude": "55.46893000",
                        "longitude": "8.46222000"
                    },
                    {
                        "id": 30634,
                        "name": "Faaborg",
                        "latitude": "55.09510000",
                        "longitude": "10.24226000"
                    },
                    {
                        "id": 30635,
                        "name": "Faaborg-Midtfyn Kommune",
                        "latitude": "55.22667000",
                        "longitude": "10.40667000"
                    },
                    {
                        "id": 30636,
                        "name": "Fanø Kommune",
                        "latitude": "55.41667000",
                        "longitude": "8.41667000"
                    },
                    {
                        "id": 30650,
                        "name": "Fredericia",
                        "latitude": "55.56568000",
                        "longitude": "9.75257000"
                    },
                    {
                        "id": 30651,
                        "name": "Fredericia Kommune",
                        "latitude": "55.57271000",
                        "longitude": "9.69489000"
                    },
                    {
                        "id": 30668,
                        "name": "Give",
                        "latitude": "55.84523000",
                        "longitude": "9.23769000"
                    },
                    {
                        "id": 30671,
                        "name": "Glamsbjerg",
                        "latitude": "55.27237000",
                        "longitude": "10.10483000"
                    },
                    {
                        "id": 30674,
                        "name": "Gram",
                        "latitude": "55.28948000",
                        "longitude": "9.04913000"
                    },
                    {
                        "id": 30680,
                        "name": "Gråsten",
                        "latitude": "54.91918000",
                        "longitude": "9.59523000"
                    },
                    {
                        "id": 30679,
                        "name": "Grindsted",
                        "latitude": "55.75726000",
                        "longitude": "8.92750000"
                    },
                    {
                        "id": 30682,
                        "name": "Guderup",
                        "latitude": "54.98978000",
                        "longitude": "9.87174000"
                    },
                    {
                        "id": 30686,
                        "name": "Haderslev",
                        "latitude": "55.24943000",
                        "longitude": "9.48771000"
                    },
                    {
                        "id": 30687,
                        "name": "Haderslev Kommune",
                        "latitude": "55.24441000",
                        "longitude": "9.32261000"
                    },
                    {
                        "id": 30733,
                        "name": "Hårby",
                        "latitude": "55.22357000",
                        "longitude": "10.12268000"
                    },
                    {
                        "id": 30721,
                        "name": "Holsted",
                        "latitude": "55.51086000",
                        "longitude": "8.91872000"
                    },
                    {
                        "id": 30735,
                        "name": "Højby",
                        "latitude": "55.33177000",
                        "longitude": "10.43725000"
                    },
                    {
                        "id": 30741,
                        "name": "Høruphav",
                        "latitude": "54.91017000",
                        "longitude": "9.89872000"
                    },
                    {
                        "id": 30748,
                        "name": "Jelling",
                        "latitude": "55.75588000",
                        "longitude": "9.42580000"
                    },
                    {
                        "id": 30756,
                        "name": "Kerteminde",
                        "latitude": "55.44903000",
                        "longitude": "10.65769000"
                    },
                    {
                        "id": 30757,
                        "name": "Kerteminde Kommune",
                        "latitude": "55.45498000",
                        "longitude": "10.62220000"
                    },
                    {
                        "id": 30763,
                        "name": "Kolding",
                        "latitude": "55.49040000",
                        "longitude": "9.47216000"
                    },
                    {
                        "id": 30764,
                        "name": "Kolding Kommune",
                        "latitude": "55.45006000",
                        "longitude": "9.45807000"
                    },
                    {
                        "id": 30768,
                        "name": "Kruså",
                        "latitude": "54.85097000",
                        "longitude": "9.40129000"
                    },
                    {
                        "id": 30773,
                        "name": "Langeland Kommune",
                        "latitude": "54.90000000",
                        "longitude": "10.77222000"
                    },
                    {
                        "id": 30774,
                        "name": "Langeskov",
                        "latitude": "55.35655000",
                        "longitude": "10.58447000"
                    },
                    {
                        "id": 30791,
                        "name": "Løgumkloster",
                        "latitude": "55.05941000",
                        "longitude": "8.95508000"
                    },
                    {
                        "id": 30792,
                        "name": "Løjt Kirkeby",
                        "latitude": "55.08959000",
                        "longitude": "9.46084000"
                    },
                    {
                        "id": 30784,
                        "name": "Lunderskov",
                        "latitude": "55.48375000",
                        "longitude": "9.29917000"
                    },
                    {
                        "id": 30798,
                        "name": "Marstal",
                        "latitude": "54.85621000",
                        "longitude": "10.51726000"
                    },
                    {
                        "id": 30799,
                        "name": "Middelfart",
                        "latitude": "55.50591000",
                        "longitude": "9.73054000"
                    },
                    {
                        "id": 30800,
                        "name": "Middelfart Kommune",
                        "latitude": "55.45782000",
                        "longitude": "9.88100000"
                    },
                    {
                        "id": 30802,
                        "name": "Munkebo",
                        "latitude": "55.45553000",
                        "longitude": "10.55433000"
                    },
                    {
                        "id": 30806,
                        "name": "Neder Holluf",
                        "latitude": "55.36451000",
                        "longitude": "10.44824000"
                    },
                    {
                        "id": 30811,
                        "name": "Nordborg",
                        "latitude": "55.05732000",
                        "longitude": "9.74080000"
                    },
                    {
                        "id": 30812,
                        "name": "Nordby",
                        "latitude": "55.44603000",
                        "longitude": "8.39786000"
                    },
                    {
                        "id": 30814,
                        "name": "Nordfyns Kommune",
                        "latitude": "55.52222000",
                        "longitude": "10.22222000"
                    },
                    {
                        "id": 30825,
                        "name": "Nørre Åby",
                        "latitude": "55.46107000",
                        "longitude": "9.87940000"
                    },
                    {
                        "id": 30815,
                        "name": "Nyborg",
                        "latitude": "55.31274000",
                        "longitude": "10.78964000"
                    },
                    {
                        "id": 30816,
                        "name": "Nyborg Kommune",
                        "latitude": "55.29473000",
                        "longitude": "10.70310000"
                    },
                    {
                        "id": 30829,
                        "name": "Odense",
                        "latitude": "55.39594000",
                        "longitude": "10.38831000"
                    },
                    {
                        "id": 30830,
                        "name": "Odense Kommune",
                        "latitude": "55.39570000",
                        "longitude": "10.37761000"
                    },
                    {
                        "id": 30832,
                        "name": "Oksbøl",
                        "latitude": "55.62680000",
                        "longitude": "8.28757000"
                    },
                    {
                        "id": 30834,
                        "name": "Otterup",
                        "latitude": "55.51527000",
                        "longitude": "10.39756000"
                    },
                    {
                        "id": 30999,
                        "name": "Ølgod",
                        "latitude": "55.80682000",
                        "longitude": "8.62859000"
                    },
                    {
                        "id": 30835,
                        "name": "Padborg",
                        "latitude": "54.82657000",
                        "longitude": "9.36247000"
                    },
                    {
                        "id": 30841,
                        "name": "Ribe",
                        "latitude": "55.33051000",
                        "longitude": "8.76966000"
                    },
                    {
                        "id": 30842,
                        "name": "Ringe",
                        "latitude": "55.23828000",
                        "longitude": "10.47860000"
                    },
                    {
                        "id": 30855,
                        "name": "Rødding",
                        "latitude": "55.36569000",
                        "longitude": "9.06316000"
                    },
                    {
                        "id": 30856,
                        "name": "Rødekro",
                        "latitude": "55.07076000",
                        "longitude": "9.33531000"
                    },
                    {
                        "id": 30850,
                        "name": "Rudkøbing",
                        "latitude": "54.93639000",
                        "longitude": "10.71019000"
                    },
                    {
                        "id": 30866,
                        "name": "Seden",
                        "latitude": "55.42648000",
                        "longitude": "10.44265000"
                    },
                    {
                        "id": 30870,
                        "name": "Skaerbaek",
                        "latitude": "55.15735000",
                        "longitude": "8.76901000"
                    },
                    {
                        "id": 30887,
                        "name": "Snoghøj",
                        "latitude": "55.52253000",
                        "longitude": "9.72125000"
                    },
                    {
                        "id": 30926,
                        "name": "Sønder Bjert",
                        "latitude": "55.45272000",
                        "longitude": "9.56741000"
                    },
                    {
                        "id": 30927,
                        "name": "Sønderborg",
                        "latitude": "54.90896000",
                        "longitude": "9.78917000"
                    },
                    {
                        "id": 30928,
                        "name": "Sønderborg Kommune",
                        "latitude": "54.91667000",
                        "longitude": "9.80000000"
                    },
                    {
                        "id": 30929,
                        "name": "Søndersø",
                        "latitude": "55.48526000",
                        "longitude": "10.25540000"
                    },
                    {
                        "id": 30895,
                        "name": "Starup",
                        "latitude": "55.24097000",
                        "longitude": "9.53503000"
                    },
                    {
                        "id": 30902,
                        "name": "Stige",
                        "latitude": "55.43941000",
                        "longitude": "10.40940000"
                    },
                    {
                        "id": 30908,
                        "name": "Strib",
                        "latitude": "55.54021000",
                        "longitude": "9.76748000"
                    },
                    {
                        "id": 30918,
                        "name": "Svendborg",
                        "latitude": "55.05982000",
                        "longitude": "10.60677000"
                    },
                    {
                        "id": 30919,
                        "name": "Svendborg Kommune",
                        "latitude": "55.08410000",
                        "longitude": "10.61391000"
                    },
                    {
                        "id": 30932,
                        "name": "Taulov",
                        "latitude": "55.54582000",
                        "longitude": "9.61553000"
                    },
                    {
                        "id": 30935,
                        "name": "Thurø By",
                        "latitude": "55.04740000",
                        "longitude": "10.66385000"
                    },
                    {
                        "id": 30937,
                        "name": "Tinglev",
                        "latitude": "54.93788000",
                        "longitude": "9.25547000"
                    },
                    {
                        "id": 30938,
                        "name": "Tjæreborg",
                        "latitude": "55.46457000",
                        "longitude": "8.57968000"
                    },
                    {
                        "id": 30939,
                        "name": "Toftlund",
                        "latitude": "55.18858000",
                        "longitude": "9.06925000"
                    },
                    {
                        "id": 30940,
                        "name": "Tommerup",
                        "latitude": "55.31952000",
                        "longitude": "10.20659000"
                    },
                    {
                        "id": 30941,
                        "name": "Tommerup Stationsby",
                        "latitude": "55.34535000",
                        "longitude": "10.17594000"
                    },
                    {
                        "id": 30950,
                        "name": "Tønder",
                        "latitude": "54.93306000",
                        "longitude": "8.86674000"
                    },
                    {
                        "id": 30951,
                        "name": "Tønder Kommune",
                        "latitude": "55.07304000",
                        "longitude": "8.87214000"
                    },
                    {
                        "id": 30954,
                        "name": "Ullerslev",
                        "latitude": "55.36172000",
                        "longitude": "10.65190000"
                    },
                    {
                        "id": 30959,
                        "name": "Vamdrup",
                        "latitude": "55.42764000",
                        "longitude": "9.28435000"
                    },
                    {
                        "id": 30961,
                        "name": "Varde",
                        "latitude": "55.62112000",
                        "longitude": "8.48069000"
                    },
                    {
                        "id": 30962,
                        "name": "Varde Kommune",
                        "latitude": "55.61667000",
                        "longitude": "8.50000000"
                    },
                    {
                        "id": 30963,
                        "name": "Vejen",
                        "latitude": "55.48117000",
                        "longitude": "9.13795000"
                    },
                    {
                        "id": 30964,
                        "name": "Vejen Kommune",
                        "latitude": "55.46312000",
                        "longitude": "9.05004000"
                    },
                    {
                        "id": 30965,
                        "name": "Vejle",
                        "latitude": "55.70927000",
                        "longitude": "9.53570000"
                    },
                    {
                        "id": 30966,
                        "name": "Vejle Kommune",
                        "latitude": "55.74874000",
                        "longitude": "9.40421000"
                    },
                    {
                        "id": 30970,
                        "name": "Vester-Skerninge",
                        "latitude": "55.07322000",
                        "longitude": "10.45536000"
                    },
                    {
                        "id": 30977,
                        "name": "Vindeby",
                        "latitude": "55.04489000",
                        "longitude": "10.61309000"
                    },
                    {
                        "id": 30982,
                        "name": "Vissenbjerg",
                        "latitude": "55.38482000",
                        "longitude": "10.13784000"
                    },
                    {
                        "id": 30984,
                        "name": "Vojens",
                        "latitude": "55.24639000",
                        "longitude": "9.30603000"
                    }
                ]
            },
            {
                "id": 1528,
                "name": "Zealand",
                "iso2": "85",
                "latitude": "55.46325180",
                "longitude": "11.72149790",
                "type": "region",
                "cities": [
                    {
                        "id": 30582,
                        "name": "Asnæs",
                        "latitude": "55.81229000",
                        "longitude": "11.50129000"
                    },
                    {
                        "id": 30597,
                        "name": "Bjæverskov",
                        "latitude": "55.45756000",
                        "longitude": "12.03651000"
                    },
                    {
                        "id": 30602,
                        "name": "Borup",
                        "latitude": "55.49472000",
                        "longitude": "11.97584000"
                    },
                    {
                        "id": 30621,
                        "name": "Dianalund",
                        "latitude": "55.53133000",
                        "longitude": "11.49250000"
                    },
                    {
                        "id": 30630,
                        "name": "Ejby",
                        "latitude": "55.48580000",
                        "longitude": "12.08171000"
                    },
                    {
                        "id": 30640,
                        "name": "Faxe",
                        "latitude": "55.25561000",
                        "longitude": "12.11926000"
                    },
                    {
                        "id": 30641,
                        "name": "Faxe Kommune",
                        "latitude": "55.29444000",
                        "longitude": "12.06111000"
                    },
                    {
                        "id": 30642,
                        "name": "Faxe Ladeplads",
                        "latitude": "55.21981000",
                        "longitude": "12.17013000"
                    },
                    {
                        "id": 30643,
                        "name": "Fensmark",
                        "latitude": "55.27919000",
                        "longitude": "11.80382000"
                    },
                    {
                        "id": 30646,
                        "name": "Forlev",
                        "latitude": "55.37445000",
                        "longitude": "11.25966000"
                    },
                    {
                        "id": 30653,
                        "name": "Frederiksberg",
                        "latitude": "55.41618000",
                        "longitude": "11.56934000"
                    },
                    {
                        "id": 30661,
                        "name": "Fuglebjerg",
                        "latitude": "55.30604000",
                        "longitude": "11.54766000"
                    },
                    {
                        "id": 30685,
                        "name": "Gørlev",
                        "latitude": "55.53926000",
                        "longitude": "11.22708000"
                    },
                    {
                        "id": 30676,
                        "name": "Greve",
                        "latitude": "55.58333000",
                        "longitude": "12.30000000"
                    },
                    {
                        "id": 30677,
                        "name": "Greve Kommune",
                        "latitude": "55.58770000",
                        "longitude": "12.25060000"
                    },
                    {
                        "id": 30683,
                        "name": "Guldborgsund Kommune",
                        "latitude": "54.76944000",
                        "longitude": "11.83611000"
                    },
                    {
                        "id": 30684,
                        "name": "Gundsømagle",
                        "latitude": "55.73565000",
                        "longitude": "12.15158000"
                    },
                    {
                        "id": 30734,
                        "name": "Hårlev",
                        "latitude": "55.34936000",
                        "longitude": "12.23382000"
                    },
                    {
                        "id": 30696,
                        "name": "Haslev",
                        "latitude": "55.32346000",
                        "longitude": "11.96389000"
                    },
                    {
                        "id": 30697,
                        "name": "Havdrup",
                        "latitude": "55.54481000",
                        "longitude": "12.12392000"
                    },
                    {
                        "id": 30716,
                        "name": "Holbæk",
                        "latitude": "55.71750000",
                        "longitude": "11.71279000"
                    },
                    {
                        "id": 30717,
                        "name": "Holbæk Kommune",
                        "latitude": "55.65919000",
                        "longitude": "11.62049000"
                    },
                    {
                        "id": 30718,
                        "name": "Holeby",
                        "latitude": "54.71148000",
                        "longitude": "11.46416000"
                    },
                    {
                        "id": 30737,
                        "name": "Høng",
                        "latitude": "55.50736000",
                        "longitude": "11.28873000"
                    },
                    {
                        "id": 30742,
                        "name": "Hørve",
                        "latitude": "55.75292000",
                        "longitude": "11.45298000"
                    },
                    {
                        "id": 30750,
                        "name": "Jyderup",
                        "latitude": "55.66399000",
                        "longitude": "11.42029000"
                    },
                    {
                        "id": 30751,
                        "name": "Jyllinge",
                        "latitude": "55.75295000",
                        "longitude": "12.10315000"
                    },
                    {
                        "id": 30753,
                        "name": "Kalundborg",
                        "latitude": "55.67954000",
                        "longitude": "11.08864000"
                    },
                    {
                        "id": 30754,
                        "name": "Kalundborg Kommune",
                        "latitude": "55.63545000",
                        "longitude": "11.19993000"
                    },
                    {
                        "id": 30759,
                        "name": "Kirke Hvalsø",
                        "latitude": "55.59170000",
                        "longitude": "11.86253000"
                    },
                    {
                        "id": 30767,
                        "name": "Korsør",
                        "latitude": "55.32993000",
                        "longitude": "11.13857000"
                    },
                    {
                        "id": 30771,
                        "name": "Køge",
                        "latitude": "55.45802000",
                        "longitude": "12.18214000"
                    },
                    {
                        "id": 30772,
                        "name": "Køge Kommune",
                        "latitude": "55.45668000",
                        "longitude": "12.07332000"
                    },
                    {
                        "id": 30776,
                        "name": "Lejre",
                        "latitude": "55.60461000",
                        "longitude": "11.97477000"
                    },
                    {
                        "id": 30777,
                        "name": "Lejre Kommune",
                        "latitude": "55.63375000",
                        "longitude": "11.92234000"
                    },
                    {
                        "id": 30783,
                        "name": "Lolland Kommune",
                        "latitude": "54.80238000",
                        "longitude": "11.29524000"
                    },
                    {
                        "id": 30797,
                        "name": "Maribo",
                        "latitude": "54.77662000",
                        "longitude": "11.50017000"
                    },
                    {
                        "id": 30805,
                        "name": "Nakskov",
                        "latitude": "54.83038000",
                        "longitude": "11.13567000"
                    },
                    {
                        "id": 30821,
                        "name": "Næstved",
                        "latitude": "55.22992000",
                        "longitude": "11.76092000"
                    },
                    {
                        "id": 30822,
                        "name": "Næstved Kommune",
                        "latitude": "55.25855000",
                        "longitude": "11.74615000"
                    },
                    {
                        "id": 30807,
                        "name": "Neder Vindinge",
                        "latitude": "55.03211000",
                        "longitude": "11.88356000"
                    },
                    {
                        "id": 30824,
                        "name": "Nørre Alslev",
                        "latitude": "54.89784000",
                        "longitude": "11.88414000"
                    },
                    {
                        "id": 30817,
                        "name": "Nykøbing Falster",
                        "latitude": "54.76906000",
                        "longitude": "11.87425000"
                    },
                    {
                        "id": 30819,
                        "name": "Nykøbing Sjælland",
                        "latitude": "55.92491000",
                        "longitude": "11.67109000"
                    },
                    {
                        "id": 30820,
                        "name": "Nyråd",
                        "latitude": "55.00511000",
                        "longitude": "11.96060000"
                    },
                    {
                        "id": 30831,
                        "name": "Odsherred Kommune",
                        "latitude": "55.88333000",
                        "longitude": "11.59444000"
                    },
                    {
                        "id": 30833,
                        "name": "Osted",
                        "latitude": "55.56228000",
                        "longitude": "11.95786000"
                    },
                    {
                        "id": 31001,
                        "name": "Ørslev",
                        "latitude": "55.04356000",
                        "longitude": "11.96792000"
                    },
                    {
                        "id": 30837,
                        "name": "Præstø",
                        "latitude": "55.12374000",
                        "longitude": "12.04477000"
                    },
                    {
                        "id": 30845,
                        "name": "Ringsted",
                        "latitude": "55.44260000",
                        "longitude": "11.79011000"
                    },
                    {
                        "id": 30846,
                        "name": "Ringsted Kommune",
                        "latitude": "55.44721000",
                        "longitude": "11.81720000"
                    },
                    {
                        "id": 30847,
                        "name": "Roskilde",
                        "latitude": "55.64152000",
                        "longitude": "12.08035000"
                    },
                    {
                        "id": 30848,
                        "name": "Roskilde Kommune",
                        "latitude": "55.65000000",
                        "longitude": "12.10000000"
                    },
                    {
                        "id": 30853,
                        "name": "Rødby",
                        "latitude": "54.69495000",
                        "longitude": "11.38885000"
                    },
                    {
                        "id": 30854,
                        "name": "Rødbyhavn",
                        "latitude": "54.65944000",
                        "longitude": "11.35504000"
                    },
                    {
                        "id": 30859,
                        "name": "Rødvig",
                        "latitude": "55.25540000",
                        "longitude": "12.37936000"
                    },
                    {
                        "id": 30862,
                        "name": "Rønnede",
                        "latitude": "55.25710000",
                        "longitude": "12.02125000"
                    },
                    {
                        "id": 30864,
                        "name": "Sakskøbing",
                        "latitude": "54.79970000",
                        "longitude": "11.62599000"
                    },
                    {
                        "id": 30879,
                        "name": "Skælskør",
                        "latitude": "55.25058000",
                        "longitude": "11.29352000"
                    },
                    {
                        "id": 30882,
                        "name": "Slagelse",
                        "latitude": "55.40276000",
                        "longitude": "11.35459000"
                    },
                    {
                        "id": 30883,
                        "name": "Slagelse Kommune",
                        "latitude": "55.34546000",
                        "longitude": "11.33390000"
                    },
                    {
                        "id": 30889,
                        "name": "Solrød",
                        "latitude": "55.53628000",
                        "longitude": "12.18270000"
                    },
                    {
                        "id": 30890,
                        "name": "Solrød Kommune",
                        "latitude": "55.53553000",
                        "longitude": "12.17337000"
                    },
                    {
                        "id": 30891,
                        "name": "Solrød Strand",
                        "latitude": "55.53285000",
                        "longitude": "12.22227000"
                    },
                    {
                        "id": 30892,
                        "name": "Sorø",
                        "latitude": "55.43184000",
                        "longitude": "11.55547000"
                    },
                    {
                        "id": 30893,
                        "name": "Sorø Kommune",
                        "latitude": "55.48268000",
                        "longitude": "11.55693000"
                    },
                    {
                        "id": 30898,
                        "name": "Stege",
                        "latitude": "54.98704000",
                        "longitude": "12.28461000"
                    },
                    {
                        "id": 30899,
                        "name": "Stenlille",
                        "latitude": "55.53888000",
                        "longitude": "11.59120000"
                    },
                    {
                        "id": 30901,
                        "name": "Stevns Kommune",
                        "latitude": "55.33373000",
                        "longitude": "12.30692000"
                    },
                    {
                        "id": 30905,
                        "name": "Store Heddinge",
                        "latitude": "55.30965000",
                        "longitude": "12.38885000"
                    },
                    {
                        "id": 30911,
                        "name": "Strøby Egede",
                        "latitude": "55.41382000",
                        "longitude": "12.24502000"
                    },
                    {
                        "id": 30912,
                        "name": "Stubbekøbing",
                        "latitude": "54.88875000",
                        "longitude": "12.04102000"
                    },
                    {
                        "id": 30914,
                        "name": "Sundby",
                        "latitude": "54.76711000",
                        "longitude": "11.84979000"
                    },
                    {
                        "id": 30916,
                        "name": "Svebølle",
                        "latitude": "55.65183000",
                        "longitude": "11.28658000"
                    },
                    {
                        "id": 30921,
                        "name": "Svinninge",
                        "latitude": "55.72111000",
                        "longitude": "11.46547000"
                    },
                    {
                        "id": 30922,
                        "name": "Svogerslev",
                        "latitude": "55.63423000",
                        "longitude": "12.01465000"
                    },
                    {
                        "id": 30949,
                        "name": "Tølløse",
                        "latitude": "55.61250000",
                        "longitude": "11.77034000"
                    },
                    {
                        "id": 30945,
                        "name": "Tune",
                        "latitude": "55.59287000",
                        "longitude": "12.16968000"
                    },
                    {
                        "id": 30974,
                        "name": "Viby",
                        "latitude": "55.54872000",
                        "longitude": "12.02391000"
                    },
                    {
                        "id": 30979,
                        "name": "Vindinge",
                        "latitude": "55.62298000",
                        "longitude": "12.13870000"
                    },
                    {
                        "id": 30980,
                        "name": "Vipperød",
                        "latitude": "55.66768000",
                        "longitude": "11.73967000"
                    },
                    {
                        "id": 30985,
                        "name": "Vordingborg",
                        "latitude": "55.00801000",
                        "longitude": "11.91057000"
                    },
                    {
                        "id": 30986,
                        "name": "Vordingborg Kommune",
                        "latitude": "55.01383000",
                        "longitude": "12.10008000"
                    }
                ]
            }
        ]
    },
    {
        "id": 60,
        "name": "Djibouti",
        "iso3": "DJI",
        "iso2": "DJ",
        "numeric_code": "262",
        "phonecode": "253",
        "capital": "Djibouti",
        "currency": "DJF",
        "currency_name": "Djiboutian franc",
        "currency_symbol": "Fdj",
        "tld": ".dj",
        "native": "Djibouti",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Djiboutian",
        "timezones": [
            {
                "zoneName": "Africa\/Djibouti",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Djibouti",
            "ko": "지부티",
            "pt-BR": "Djibuti",
            "pt": "Djibuti",
            "nl": "Djibouti",
            "hr": "Džibuti",
            "fa": "جیبوتی",
            "de": "Dschibuti",
            "es": "Yibuti",
            "fr": "Djibouti",
            "ja": "ジブチ",
            "it": "Gibuti",
            "zh-CN": "吉布提",
            "tr": "Cibuti",
            "ru": "Джибути",
            "uk": "Джибуті",
            "pl": "Dżibuti"
        },
        "latitude": "11.50000000",
        "longitude": "43.00000000",
        "emoji": "🇩🇯",
        "emojiU": "U+1F1E9 U+1F1EF",
        "states": [
            {
                "id": 2933,
                "name": "Ali Sabieh",
                "iso2": "AS",
                "latitude": "11.19289730",
                "longitude": "42.94169800",
                "type": "region",
                "cities": [
                    {
                        "id": 30561,
                        "name": "'Ali Sabieh",
                        "latitude": "11.15583000",
                        "longitude": "42.71250000"
                    },
                    {
                        "id": 30567,
                        "name": "Goubétto",
                        "latitude": "11.42389000",
                        "longitude": "43.00028000"
                    },
                    {
                        "id": 30569,
                        "name": "Holhol",
                        "latitude": "11.31028000",
                        "longitude": "42.92944000"
                    }
                ]
            },
            {
                "id": 2932,
                "name": "Arta",
                "iso2": "AR",
                "latitude": "11.52555280",
                "longitude": "42.84794740",
                "type": "region",
                "cities": [
                    {
                        "id": 30563,
                        "name": "Arta",
                        "latitude": "11.52639000",
                        "longitude": "42.85194000"
                    }
                ]
            },
            {
                "id": 2930,
                "name": "Dikhil",
                "iso2": "DI",
                "latitude": "11.10543360",
                "longitude": "42.37047440",
                "type": "region",
                "cities": [
                    {
                        "id": 30564,
                        "name": "Dikhil",
                        "latitude": "11.10454000",
                        "longitude": "42.36971000"
                    },
                    {
                        "id": 30568,
                        "name": "Gâlâfi",
                        "latitude": "11.71583000",
                        "longitude": "41.83611000"
                    }
                ]
            },
            {
                "id": 2929,
                "name": "Djibouti",
                "iso2": "DJ",
                "latitude": "11.82513800",
                "longitude": "42.59027500",
                "type": "city",
                "cities": [
                    {
                        "id": 30565,
                        "name": "Djibouti",
                        "latitude": "11.58901000",
                        "longitude": "43.14503000"
                    },
                    {
                        "id": 30570,
                        "name": "Loyada",
                        "latitude": "11.46111000",
                        "longitude": "43.25278000"
                    }
                ]
            },
            {
                "id": 2928,
                "name": "Obock",
                "iso2": "OB",
                "latitude": "12.38956910",
                "longitude": "43.01948970",
                "type": "region",
                "cities": [
                    {
                        "id": 30562,
                        "name": "Alaïli Ḏaḏḏa‘",
                        "latitude": "12.42167000",
                        "longitude": "42.89556000"
                    },
                    {
                        "id": 30571,
                        "name": "Obock",
                        "latitude": "11.96693000",
                        "longitude": "43.28835000"
                    }
                ]
            },
            {
                "id": 2931,
                "name": "Tadjourah",
                "iso2": "TA",
                "latitude": "11.93388850",
                "longitude": "42.39383750",
                "type": "region",
                "cities": [
                    {
                        "id": 30566,
                        "name": "Dorra",
                        "latitude": "12.15028000",
                        "longitude": "42.47624000"
                    },
                    {
                        "id": 30572,
                        "name": "Tadjourah",
                        "latitude": "11.78778000",
                        "longitude": "42.88222000"
                    }
                ]
            }
        ]
    },
    {
        "id": 61,
        "name": "Dominica",
        "iso3": "DMA",
        "iso2": "DM",
        "numeric_code": "212",
        "phonecode": "1",
        "capital": "Roseau",
        "currency": "XCD",
        "currency_name": "Eastern Caribbean dollar",
        "currency_symbol": "$",
        "tld": ".dm",
        "native": "Dominica",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Dominican",
        "timezones": [
            {
                "zoneName": "America\/Dominica",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Dominika",
            "ko": "도미니카 연방",
            "pt-BR": "Dominica",
            "pt": "Dominica",
            "nl": "Dominica",
            "hr": "Dominika",
            "fa": "دومینیکا",
            "de": "Dominica",
            "es": "Dominica",
            "fr": "Dominique",
            "ja": "ドミニカ国",
            "it": "Dominica",
            "zh-CN": "多米尼加",
            "tr": "Dominika",
            "ru": "Доминика",
            "uk": "Домініка",
            "pl": "Dominika"
        },
        "latitude": "15.41666666",
        "longitude": "-61.33333333",
        "emoji": "🇩🇲",
        "emojiU": "U+1F1E9 U+1F1F2",
        "states": [
            {
                "id": 4082,
                "name": "Saint Andrew",
                "iso2": "02",
                "latitude": "15.54681520",
                "longitude": "-61.43994240",
                "type": "parish",
                "cities": [
                    {
                        "id": 31003,
                        "name": "Calibishie",
                        "latitude": "15.59297000",
                        "longitude": "-61.34901000"
                    },
                    {
                        "id": 31008,
                        "name": "Marigot",
                        "latitude": "15.53886000",
                        "longitude": "-61.28375000"
                    },
                    {
                        "id": 31017,
                        "name": "Wesley",
                        "latitude": "15.56667000",
                        "longitude": "-61.31667000"
                    },
                    {
                        "id": 31018,
                        "name": "Woodford Hill",
                        "latitude": "15.58093000",
                        "longitude": "-61.33149000"
                    }
                ]
            },
            {
                "id": 4078,
                "name": "Saint David",
                "iso2": "03",
                "latitude": "15.42418230",
                "longitude": "-61.36762040",
                "type": "parish",
                "cities": [
                    {
                        "id": 31004,
                        "name": "Castle Bruce",
                        "latitude": "15.44397000",
                        "longitude": "-61.25723000"
                    },
                    {
                        "id": 31012,
                        "name": "Rosalie",
                        "latitude": "15.36667000",
                        "longitude": "-61.26667000"
                    }
                ]
            },
            {
                "id": 4079,
                "name": "Saint George",
                "iso2": "04",
                "latitude": "15.30925320",
                "longitude": "-61.38706140",
                "type": "parish",
                "cities": [
                    {
                        "id": 31013,
                        "name": "Roseau",
                        "latitude": "15.30174000",
                        "longitude": "-61.38808000"
                    }
                ]
            },
            {
                "id": 4076,
                "name": "Saint John",
                "iso2": "05",
                "latitude": "15.57574670",
                "longitude": "-61.48178530",
                "type": "parish",
                "cities": [
                    {
                        "id": 31011,
                        "name": "Portsmouth",
                        "latitude": "15.58333000",
                        "longitude": "-61.46667000"
                    }
                ]
            },
            {
                "id": 4085,
                "name": "Saint Joseph",
                "iso2": "06",
                "latitude": "15.44758940",
                "longitude": "-61.46733630",
                "type": "parish",
                "cities": [
                    {
                        "id": 31014,
                        "name": "Saint Joseph",
                        "latitude": "15.40000000",
                        "longitude": "-61.43333000"
                    },
                    {
                        "id": 31015,
                        "name": "Salisbury",
                        "latitude": "15.43689000",
                        "longitude": "-61.43637000"
                    }
                ]
            },
            {
                "id": 4083,
                "name": "Saint Luke",
                "iso2": "07",
                "latitude": "15.25502710",
                "longitude": "-61.38176360",
                "type": "parish",
                "cities": [
                    {
                        "id": 31009,
                        "name": "Pointe Michel",
                        "latitude": "15.25976000",
                        "longitude": "-61.37452000"
                    }
                ]
            },
            {
                "id": 4077,
                "name": "Saint Mark",
                "iso2": "08",
                "latitude": "15.23086360",
                "longitude": "-61.37248360",
                "type": "parish",
                "cities": [
                    {
                        "id": 31016,
                        "name": "Soufrière",
                        "latitude": "15.23374000",
                        "longitude": "-61.35881000"
                    }
                ]
            },
            {
                "id": 4080,
                "name": "Saint Patrick",
                "iso2": "09",
                "latitude": "15.28147970",
                "longitude": "-61.33486030",
                "type": "parish",
                "cities": [
                    {
                        "id": 31002,
                        "name": "Berekua",
                        "latitude": "15.23333000",
                        "longitude": "-61.31667000"
                    },
                    {
                        "id": 31006,
                        "name": "La Plaine",
                        "latitude": "15.32768000",
                        "longitude": "-61.24753000"
                    }
                ]
            },
            {
                "id": 4084,
                "name": "Saint Paul",
                "iso2": "10",
                "latitude": "15.36719130",
                "longitude": "-61.41210820",
                "type": "parish",
                "cities": [
                    {
                        "id": 31007,
                        "name": "Mahaut",
                        "latitude": "15.36357000",
                        "longitude": "-61.39701000"
                    },
                    {
                        "id": 31010,
                        "name": "Pont Cassé",
                        "latitude": "15.36667000",
                        "longitude": "-61.35000000"
                    }
                ]
            },
            {
                "id": 4081,
                "name": "Saint Peter",
                "iso2": "11",
                "latitude": "15.50215020",
                "longitude": "-61.48021570",
                "type": "parish",
                "cities": [
                    {
                        "id": 31005,
                        "name": "Colihaut",
                        "latitude": "15.48478000",
                        "longitude": "-61.46215000"
                    }
                ]
            }
        ]
    },
    {
        "id": 62,
        "name": "Dominican Republic",
        "iso3": "DOM",
        "iso2": "DO",
        "numeric_code": "214",
        "phonecode": "1",
        "capital": "Santo Domingo",
        "currency": "DOP",
        "currency_name": "Dominican peso",
        "currency_symbol": "$",
        "tld": ".do",
        "native": "República Dominicana",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Dominican",
        "timezones": [
            {
                "zoneName": "America\/Santo_Domingo",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Republik Dominikan",
            "ko": "도미니카 공화국",
            "pt-BR": "República Dominicana",
            "pt": "República Dominicana",
            "nl": "Dominicaanse Republiek",
            "hr": "Dominikanska Republika",
            "fa": "جمهوری دومینیکن",
            "de": "Dominikanische Republik",
            "es": "República Dominicana",
            "fr": "République dominicaine",
            "ja": "ドミニカ共和国",
            "it": "Repubblica Dominicana",
            "zh-CN": "多明尼加共和国",
            "tr": "Dominik Cumhuriyeti",
            "ru": "Доминиканская Республика",
            "uk": "Домініканська Республіка",
            "pl": "Republika Dominikańska"
        },
        "latitude": "19.00000000",
        "longitude": "-70.66666666",
        "emoji": "🇩🇴",
        "emojiU": "U+1F1E9 U+1F1F4",
        "states": [
            {
                "id": 4114,
                "name": "Azua",
                "iso2": "02",
                "latitude": "18.45527090",
                "longitude": "-70.73809280",
                "type": "province",
                "cities": [
                    {
                        "id": 31024,
                        "name": "Azua",
                        "latitude": "18.45319000",
                        "longitude": "-70.73490000"
                    },
                    {
                        "id": 31060,
                        "name": "El Guayabal",
                        "latitude": "18.74960000",
                        "longitude": "-70.83690000"
                    },
                    {
                        "id": 31070,
                        "name": "Estebanía",
                        "latitude": "18.45770000",
                        "longitude": "-70.64350000"
                    },
                    {
                        "id": 31111,
                        "name": "Las Charcas",
                        "latitude": "18.45026000",
                        "longitude": "-70.61724000"
                    },
                    {
                        "id": 31142,
                        "name": "Padre Las Casas",
                        "latitude": "18.75000000",
                        "longitude": "-70.88333000"
                    },
                    {
                        "id": 31144,
                        "name": "Palmar de Ocoa",
                        "latitude": "18.29656000",
                        "longitude": "-70.58635000"
                    },
                    {
                        "id": 31153,
                        "name": "Peralta",
                        "latitude": "18.58164000",
                        "longitude": "-70.77029000"
                    },
                    {
                        "id": 31160,
                        "name": "Pueblo Viejo",
                        "latitude": "18.40000000",
                        "longitude": "-70.76765000"
                    },
                    {
                        "id": 31174,
                        "name": "Sabana Yegua",
                        "latitude": "18.71667000",
                        "longitude": "-71.01667000"
                    },
                    {
                        "id": 31207,
                        "name": "Tábara Arriba",
                        "latitude": "18.56999000",
                        "longitude": "-70.87978000"
                    },
                    {
                        "id": 31222,
                        "name": "Villarpando",
                        "latitude": "18.65860000",
                        "longitude": "-71.03916000"
                    },
                    {
                        "id": 31225,
                        "name": "Yayas de Viajama",
                        "latitude": "18.60710000",
                        "longitude": "-70.92753000"
                    }
                ]
            },
            {
                "id": 4105,
                "name": "Baoruco",
                "iso2": "03",
                "latitude": "18.48798980",
                "longitude": "-71.41822490",
                "type": "province",
                "cities": [
                    {
                        "id": 31061,
                        "name": "El Palmar",
                        "latitude": "18.41139000",
                        "longitude": "-71.24558000"
                    },
                    {
                        "id": 31074,
                        "name": "Galván",
                        "latitude": "18.50228000",
                        "longitude": "-71.34271000"
                    },
                    {
                        "id": 31109,
                        "name": "La Uvilla",
                        "latitude": "18.36186000",
                        "longitude": "-71.21046000"
                    },
                    {
                        "id": 31122,
                        "name": "Los Ríos",
                        "latitude": "18.52131000",
                        "longitude": "-71.59106000"
                    },
                    {
                        "id": 31138,
                        "name": "Neiba",
                        "latitude": "18.48137000",
                        "longitude": "-71.41965000"
                    },
                    {
                        "id": 31203,
                        "name": "Tamayo",
                        "latitude": "18.50000000",
                        "longitude": "-71.16667000"
                    },
                    {
                        "id": 31218,
                        "name": "Villa Jaragua",
                        "latitude": "18.49077000",
                        "longitude": "-71.48377000"
                    }
                ]
            },
            {
                "id": 4090,
                "name": "Barahona",
                "iso2": "04",
                "latitude": "18.21390660",
                "longitude": "-71.10437590",
                "type": "province",
                "cities": [
                    {
                        "id": 31036,
                        "name": "Cabral",
                        "latitude": "18.19991000",
                        "longitude": "-71.24660000"
                    },
                    {
                        "id": 31038,
                        "name": "Cachón",
                        "latitude": "18.24833000",
                        "longitude": "-71.18912000"
                    },
                    {
                        "id": 31041,
                        "name": "Canoa",
                        "latitude": "18.35499000",
                        "longitude": "-71.15851000"
                    },
                    {
                        "id": 31062,
                        "name": "El Peñón",
                        "latitude": "18.29643000",
                        "longitude": "-71.18410000"
                    },
                    {
                        "id": 31066,
                        "name": "Enriquillo",
                        "latitude": "17.91667000",
                        "longitude": "-71.25000000"
                    },
                    {
                        "id": 31073,
                        "name": "Fundación",
                        "latitude": "18.28668000",
                        "longitude": "-71.18147000"
                    },
                    {
                        "id": 31090,
                        "name": "Jaquimeyes",
                        "latitude": "18.31173000",
                        "longitude": "-71.16145000"
                    },
                    {
                        "id": 31104,
                        "name": "La Ciénaga",
                        "latitude": "18.06858000",
                        "longitude": "-71.10651000"
                    },
                    {
                        "id": 31115,
                        "name": "Las Salinas",
                        "latitude": "18.27485000",
                        "longitude": "-71.31596000"
                    },
                    {
                        "id": 31145,
                        "name": "Paraíso",
                        "latitude": "18.02652000",
                        "longitude": "-71.20889000"
                    },
                    {
                        "id": 31154,
                        "name": "Pescadería",
                        "latitude": "18.26766000",
                        "longitude": "-71.16612000"
                    },
                    {
                        "id": 31158,
                        "name": "Polo",
                        "latitude": "18.07873000",
                        "longitude": "-71.28723000"
                    },
                    {
                        "id": 31194,
                        "name": "Santa Cruz de Barahona",
                        "latitude": "18.20854000",
                        "longitude": "-71.10077000"
                    },
                    {
                        "id": 31210,
                        "name": "Vicente Noble",
                        "latitude": "18.38443000",
                        "longitude": "-71.18009000"
                    }
                ]
            },
            {
                "id": 4107,
                "name": "Dajabón",
                "iso2": "05",
                "latitude": "19.54992410",
                "longitude": "-71.70865140",
                "type": "province",
                "cities": [
                    {
                        "id": 31053,
                        "name": "Dajabón",
                        "latitude": "19.54878000",
                        "longitude": "-71.70829000"
                    },
                    {
                        "id": 31063,
                        "name": "El Pino",
                        "latitude": "19.43537000",
                        "longitude": "-71.47540000"
                    },
                    {
                        "id": 31118,
                        "name": "Loma de Cabrera",
                        "latitude": "19.41667000",
                        "longitude": "-71.58333000"
                    },
                    {
                        "id": 31146,
                        "name": "Partido",
                        "latitude": "19.48403000",
                        "longitude": "-71.54730000"
                    },
                    {
                        "id": 31165,
                        "name": "Restauración",
                        "latitude": "19.31532000",
                        "longitude": "-71.69239000"
                    }
                ]
            },
            {
                "id": 4095,
                "name": "Distrito Nacional",
                "iso2": "01",
                "latitude": "18.48605750",
                "longitude": "-69.93121170",
                "type": "district",
                "cities": [
                    {
                        "id": 31029,
                        "name": "Bella Vista",
                        "latitude": "18.45539000",
                        "longitude": "-69.94540000"
                    },
                    {
                        "id": 31047,
                        "name": "Ciudad Nueva",
                        "latitude": "18.46707000",
                        "longitude": "-69.89339000"
                    },
                    {
                        "id": 31051,
                        "name": "Cristo Rey",
                        "latitude": "18.50000000",
                        "longitude": "-69.93333000"
                    },
                    {
                        "id": 31067,
                        "name": "Ensanche Luperón",
                        "latitude": "18.50000000",
                        "longitude": "-69.90000000"
                    },
                    {
                        "id": 31101,
                        "name": "La Agustina",
                        "latitude": "18.50000000",
                        "longitude": "-69.93333000"
                    },
                    {
                        "id": 31107,
                        "name": "La Julia",
                        "latitude": "18.46667000",
                        "longitude": "-69.93333000"
                    },
                    {
                        "id": 31182,
                        "name": "San Carlos",
                        "latitude": "18.48333000",
                        "longitude": "-69.90000000"
                    },
                    {
                        "id": 31197,
                        "name": "Santo Domingo",
                        "latitude": "18.47186000",
                        "longitude": "-69.89232000"
                    },
                    {
                        "id": 31213,
                        "name": "Villa Consuelo",
                        "latitude": "18.48333000",
                        "longitude": "-69.90000000"
                    },
                    {
                        "id": 31215,
                        "name": "Villa Francisca",
                        "latitude": "18.48278000",
                        "longitude": "-69.88914000"
                    }
                ]
            },
            {
                "id": 4113,
                "name": "Duarte",
                "iso2": "06",
                "latitude": "19.20908230",
                "longitude": "-70.02700040",
                "type": "province",
                "cities": [
                    {
                        "id": 31019,
                        "name": "Agua Santa del Yuna",
                        "latitude": "19.15072000",
                        "longitude": "-69.80069000"
                    },
                    {
                        "id": 31022,
                        "name": "Arenoso",
                        "latitude": "19.18732000",
                        "longitude": "-69.85917000"
                    },
                    {
                        "id": 31043,
                        "name": "Castillo",
                        "latitude": "19.25000000",
                        "longitude": "-70.00000000"
                    },
                    {
                        "id": 31086,
                        "name": "Hostos",
                        "latitude": "19.18043000",
                        "longitude": "-70.02046000"
                    },
                    {
                        "id": 31112,
                        "name": "Las Guáranas",
                        "latitude": "19.19310000",
                        "longitude": "-70.20835000"
                    },
                    {
                        "id": 31156,
                        "name": "Pimentel",
                        "latitude": "19.21667000",
                        "longitude": "-70.16667000"
                    },
                    {
                        "id": 31185,
                        "name": "San Francisco de Macorís",
                        "latitude": "19.30099000",
                        "longitude": "-70.25259000"
                    },
                    {
                        "id": 31219,
                        "name": "Villa Riva",
                        "latitude": "19.15051000",
                        "longitude": "-69.88370000"
                    }
                ]
            },
            {
                "id": 4086,
                "name": "El Seibo",
                "iso2": "08",
                "latitude": "18.76584960",
                "longitude": "-69.04066800",
                "type": "province",
                "cities": [
                    {
                        "id": 31131,
                        "name": "Miches",
                        "latitude": "18.98364000",
                        "longitude": "-69.04760000"
                    },
                    {
                        "id": 31151,
                        "name": "Pedro Sánchez",
                        "latitude": "18.86375000",
                        "longitude": "-69.10868000"
                    },
                    {
                        "id": 31195,
                        "name": "Santa Cruz de El Seibo",
                        "latitude": "18.76559000",
                        "longitude": "-69.03886000"
                    }
                ]
            },
            {
                "id": 4102,
                "name": "Espaillat",
                "iso2": "09",
                "latitude": "19.62776580",
                "longitude": "-70.27867750",
                "type": "province",
                "cities": [
                    {
                        "id": 31044,
                        "name": "Cayetano Germosén",
                        "latitude": "19.34285000",
                        "longitude": "-70.47573000"
                    },
                    {
                        "id": 31075,
                        "name": "Gaspar Hernández",
                        "latitude": "19.62748000",
                        "longitude": "-70.27772000"
                    },
                    {
                        "id": 31089,
                        "name": "Jamao al Norte",
                        "latitude": "19.63552000",
                        "longitude": "-70.44664000"
                    },
                    {
                        "id": 31095,
                        "name": "Joba Arriba",
                        "latitude": "19.56667000",
                        "longitude": "-70.26667000"
                    },
                    {
                        "id": 31097,
                        "name": "Juan López Abajo",
                        "latitude": "19.43333000",
                        "longitude": "-70.50000000"
                    },
                    {
                        "id": 31132,
                        "name": "Moca",
                        "latitude": "19.50000000",
                        "longitude": "-70.50000000"
                    },
                    {
                        "id": 31193,
                        "name": "San Víctor Arriba",
                        "latitude": "19.47741000",
                        "longitude": "-70.53585000"
                    },
                    {
                        "id": 31209,
                        "name": "Veragua Arriba",
                        "latitude": "19.58333000",
                        "longitude": "-70.33333000"
                    }
                ]
            },
            {
                "id": 4106,
                "name": "Hato Mayor",
                "iso2": "30",
                "latitude": "18.76357990",
                "longitude": "-69.25576370",
                "type": "province",
                "cities": [
                    {
                        "id": 31065,
                        "name": "El Valle",
                        "latitude": "18.93333000",
                        "longitude": "-69.38333000"
                    },
                    {
                        "id": 31080,
                        "name": "Guayabo Dulce",
                        "latitude": "18.65000000",
                        "longitude": "-69.28333000"
                    },
                    {
                        "id": 31084,
                        "name": "Hato Mayor del Rey",
                        "latitude": "18.76278000",
                        "longitude": "-69.25681000"
                    },
                    {
                        "id": 31175,
                        "name": "Sabana de la Mar",
                        "latitude": "19.03333000",
                        "longitude": "-69.41667000"
                    }
                ]
            },
            {
                "id": 4089,
                "name": "Hermanas Mirabal",
                "iso2": "19",
                "latitude": "19.37475590",
                "longitude": "-70.35132350",
                "type": "province",
                "cities": [
                    {
                        "id": 31178,
                        "name": "Salcedo",
                        "latitude": "19.41667000",
                        "longitude": "-70.38333000"
                    },
                    {
                        "id": 31179,
                        "name": "Salsipuedes",
                        "latitude": "19.40552000",
                        "longitude": "-70.37985000"
                    },
                    {
                        "id": 31205,
                        "name": "Tenares",
                        "latitude": "19.37439000",
                        "longitude": "-70.35087000"
                    },
                    {
                        "id": 31220,
                        "name": "Villa Tapia",
                        "latitude": "19.30084000",
                        "longitude": "-70.42199000"
                    }
                ]
            },
            {
                "id": 4097,
                "name": "Independencia",
                "iso2": "10",
                "latitude": "32.63357480",
                "longitude": "-115.42892940",
                "type": "province",
                "cities": [
                    {
                        "id": 31052,
                        "name": "Cristóbal",
                        "latitude": "18.29405000",
                        "longitude": "-71.29298000"
                    },
                    {
                        "id": 31055,
                        "name": "Duvergé",
                        "latitude": "18.31634000",
                        "longitude": "-71.59451000"
                    },
                    {
                        "id": 31079,
                        "name": "Guayabal",
                        "latitude": "18.59810000",
                        "longitude": "-71.64184000"
                    },
                    {
                        "id": 31094,
                        "name": "Jimaní",
                        "latitude": "18.49169000",
                        "longitude": "-71.85022000"
                    },
                    {
                        "id": 31105,
                        "name": "La Descubierta",
                        "latitude": "18.57053000",
                        "longitude": "-71.72967000"
                    },
                    {
                        "id": 31130,
                        "name": "Mella",
                        "latitude": "18.35871000",
                        "longitude": "-71.41716000"
                    },
                    {
                        "id": 31159,
                        "name": "Postrer Río",
                        "latitude": "18.54374000",
                        "longitude": "-71.63561000"
                    }
                ]
            },
            {
                "id": 4109,
                "name": "La Altagracia",
                "iso2": "11",
                "latitude": "18.58502360",
                "longitude": "-68.62010720",
                "type": "province",
                "cities": [
                    {
                        "id": 31032,
                        "name": "Boca de Yuma",
                        "latitude": "18.37825000",
                        "longitude": "-68.60900000"
                    },
                    {
                        "id": 31085,
                        "name": "Higüey",
                        "latitude": "18.70000000",
                        "longitude": "-68.66667000"
                    },
                    {
                        "id": 31140,
                        "name": "Otra Banda",
                        "latitude": "18.65017000",
                        "longitude": "-68.66281000"
                    },
                    {
                        "id": 31162,
                        "name": "Punta Cana",
                        "latitude": "18.58182000",
                        "longitude": "-68.40431000"
                    },
                    {
                        "id": 31180,
                        "name": "Salvaleón de Higüey",
                        "latitude": "18.61501000",
                        "longitude": "-68.70798000"
                    },
                    {
                        "id": 31192,
                        "name": "San Rafael del Yuma",
                        "latitude": "18.42993000",
                        "longitude": "-68.67390000"
                    }
                ]
            },
            {
                "id": 4087,
                "name": "La Romana",
                "iso2": "12",
                "latitude": "18.43102710",
                "longitude": "-68.98373730",
                "type": "province",
                "cities": [
                    {
                        "id": 31081,
                        "name": "Guaymate",
                        "latitude": "18.58793000",
                        "longitude": "-68.97867000"
                    },
                    {
                        "id": 31108,
                        "name": "La Romana",
                        "latitude": "18.42733000",
                        "longitude": "-68.97285000"
                    }
                ]
            },
            {
                "id": 4116,
                "name": "La Vega",
                "iso2": "13",
                "latitude": "19.22115540",
                "longitude": "-70.52887530",
                "type": "province",
                "cities": [
                    {
                        "id": 31048,
                        "name": "Concepción de La Vega",
                        "latitude": "19.22207000",
                        "longitude": "-70.52956000"
                    },
                    {
                        "id": 31049,
                        "name": "Constanza",
                        "latitude": "18.90919000",
                        "longitude": "-70.74499000"
                    },
                    {
                        "id": 31091,
                        "name": "Jarabacoa",
                        "latitude": "19.11683000",
                        "longitude": "-70.63595000"
                    },
                    {
                        "id": 31093,
                        "name": "Jima Abajo",
                        "latitude": "19.13292000",
                        "longitude": "-70.37607000"
                    },
                    {
                        "id": 31166,
                        "name": "Rincón",
                        "latitude": "19.11938000",
                        "longitude": "-70.40632000"
                    },
                    {
                        "id": 31169,
                        "name": "Río Verde Arriba",
                        "latitude": "19.31583000",
                        "longitude": "-70.56643000"
                    },
                    {
                        "id": 31206,
                        "name": "Tireo Arriba",
                        "latitude": "18.93537000",
                        "longitude": "-70.68850000"
                    }
                ]
            },
            {
                "id": 4094,
                "name": "María Trinidad Sánchez",
                "iso2": "14",
                "latitude": "19.37345970",
                "longitude": "-69.85144390",
                "type": "province",
                "cities": [
                    {
                        "id": 31023,
                        "name": "Arroyo Salado",
                        "latitude": "19.50000000",
                        "longitude": "-69.90000000"
                    },
                    {
                        "id": 31037,
                        "name": "Cabrera",
                        "latitude": "19.64260000",
                        "longitude": "-69.90489000"
                    },
                    {
                        "id": 31059,
                        "name": "El Factor",
                        "latitude": "19.31834000",
                        "longitude": "-69.88827000"
                    },
                    {
                        "id": 31106,
                        "name": "La Entrada",
                        "latitude": "19.55367000",
                        "longitude": "-69.90762000"
                    },
                    {
                        "id": 31137,
                        "name": "Nagua",
                        "latitude": "19.38320000",
                        "longitude": "-69.84740000"
                    },
                    {
                        "id": 31168,
                        "name": "Río San Juan",
                        "latitude": "19.55022000",
                        "longitude": "-70.07703000"
                    }
                ]
            },
            {
                "id": 4099,
                "name": "Monseñor Nouel",
                "iso2": "28",
                "latitude": "18.92152340",
                "longitude": "-70.38368150",
                "type": "province",
                "cities": [
                    {
                        "id": 31034,
                        "name": "Bonao",
                        "latitude": "18.91667000",
                        "longitude": "-70.46667000"
                    },
                    {
                        "id": 31096,
                        "name": "Juan Adrián",
                        "latitude": "18.76365000",
                        "longitude": "-70.33732000"
                    },
                    {
                        "id": 31124,
                        "name": "Maimón",
                        "latitude": "18.88333000",
                        "longitude": "-70.30000000"
                    },
                    {
                        "id": 31155,
                        "name": "Piedra Blanca",
                        "latitude": "18.84431000",
                        "longitude": "-70.31688000"
                    },
                    {
                        "id": 31176,
                        "name": "Sabana del Puerto",
                        "latitude": "19.06667000",
                        "longitude": "-70.41667000"
                    }
                ]
            },
            {
                "id": 4115,
                "name": "Monte Cristi",
                "iso2": "15",
                "latitude": "19.73968990",
                "longitude": "-71.44339840",
                "type": "province",
                "cities": [
                    {
                        "id": 31040,
                        "name": "Cana Chapetón",
                        "latitude": "19.60703000",
                        "longitude": "-71.25734000"
                    },
                    {
                        "id": 31042,
                        "name": "Castañuelas",
                        "latitude": "19.71387000",
                        "longitude": "-71.49876000"
                    },
                    {
                        "id": 31082,
                        "name": "Guayubín",
                        "latitude": "19.61667000",
                        "longitude": "-71.33333000"
                    },
                    {
                        "id": 31083,
                        "name": "Hatillo Palma",
                        "latitude": "19.66256000",
                        "longitude": "-71.19406000"
                    },
                    {
                        "id": 31114,
                        "name": "Las Matas de Santa Cruz",
                        "latitude": "19.67119000",
                        "longitude": "-71.50471000"
                    },
                    {
                        "id": 31134,
                        "name": "Monte Cristi",
                        "latitude": "19.83333000",
                        "longitude": "-71.61667000"
                    },
                    {
                        "id": 31152,
                        "name": "Pepillo Salcedo",
                        "latitude": "19.66667000",
                        "longitude": "-71.66667000"
                    },
                    {
                        "id": 31184,
                        "name": "San Fernando de Monte Cristi",
                        "latitude": "19.84826000",
                        "longitude": "-71.64597000"
                    },
                    {
                        "id": 31214,
                        "name": "Villa Elisa",
                        "latitude": "19.68560000",
                        "longitude": "-71.27007000"
                    },
                    {
                        "id": 31221,
                        "name": "Villa Vásquez",
                        "latitude": "19.80791000",
                        "longitude": "-71.44000000"
                    }
                ]
            },
            {
                "id": 4111,
                "name": "Monte Plata",
                "iso2": "29",
                "latitude": "18.80808780",
                "longitude": "-69.78691460",
                "type": "province",
                "cities": [
                    {
                        "id": 31028,
                        "name": "Bayaguana",
                        "latitude": "18.78333000",
                        "longitude": "-69.60000000"
                    },
                    {
                        "id": 31054,
                        "name": "Don Juan",
                        "latitude": "18.82774000",
                        "longitude": "-69.94629000"
                    },
                    {
                        "id": 31068,
                        "name": "Esperalvillo",
                        "latitude": "18.81509000",
                        "longitude": "-70.03557000"
                    },
                    {
                        "id": 31076,
                        "name": "Gonzalo",
                        "latitude": "18.95147000",
                        "longitude": "-69.75114000"
                    },
                    {
                        "id": 31119,
                        "name": "Los Botados",
                        "latitude": "18.73226000",
                        "longitude": "-69.99536000"
                    },
                    {
                        "id": 31126,
                        "name": "Majagual",
                        "latitude": "19.04134000",
                        "longitude": "-69.83616000"
                    },
                    {
                        "id": 31136,
                        "name": "Monte Plata",
                        "latitude": "18.80700000",
                        "longitude": "-69.78399000"
                    },
                    {
                        "id": 31171,
                        "name": "Sabana Grande de Boyá",
                        "latitude": "18.94498000",
                        "longitude": "-69.79331000"
                    },
                    {
                        "id": 31224,
                        "name": "Yamasá",
                        "latitude": "18.77315000",
                        "longitude": "-70.02583000"
                    }
                ]
            },
            {
                "id": 4101,
                "name": "Pedernales",
                "iso2": "16",
                "latitude": "17.85376260",
                "longitude": "-71.33032090",
                "type": "province",
                "cities": [
                    {
                        "id": 31099,
                        "name": "Juancho",
                        "latitude": "17.85782000",
                        "longitude": "-71.29311000"
                    },
                    {
                        "id": 31141,
                        "name": "Oviedo",
                        "latitude": "17.80136000",
                        "longitude": "-71.40100000"
                    },
                    {
                        "id": 31148,
                        "name": "Pedernales",
                        "latitude": "18.08333000",
                        "longitude": "-71.60000000"
                    }
                ]
            },
            {
                "id": 4096,
                "name": "Peravia",
                "iso2": "17",
                "latitude": "18.27865940",
                "longitude": "-70.33358870",
                "type": "province",
                "cities": [
                    {
                        "id": 31027,
                        "name": "Baní",
                        "latitude": "18.27964000",
                        "longitude": "-70.33185000"
                    },
                    {
                        "id": 31128,
                        "name": "Matanzas",
                        "latitude": "18.24297000",
                        "longitude": "-70.41768000"
                    },
                    {
                        "id": 31139,
                        "name": "Nizao",
                        "latitude": "18.24697000",
                        "longitude": "-70.21053000"
                    },
                    {
                        "id": 31147,
                        "name": "Paya",
                        "latitude": "18.26196000",
                        "longitude": "-70.29560000"
                    },
                    {
                        "id": 31157,
                        "name": "Pizarrete",
                        "latitude": "18.29935000",
                        "longitude": "-70.22648000"
                    },
                    {
                        "id": 31170,
                        "name": "Sabana Buey",
                        "latitude": "18.27351000",
                        "longitude": "-70.52352000"
                    }
                ]
            },
            {
                "id": 4092,
                "name": "Puerto Plata",
                "iso2": "18",
                "latitude": "19.75432250",
                "longitude": "-70.83328470",
                "type": "province",
                "cities": [
                    {
                        "id": 31020,
                        "name": "Altamira",
                        "latitude": "19.70000000",
                        "longitude": "-70.83333000"
                    },
                    {
                        "id": 31035,
                        "name": "Cabarete",
                        "latitude": "19.74982000",
                        "longitude": "-70.40829000"
                    },
                    {
                        "id": 31071,
                        "name": "Estero Hondo",
                        "latitude": "19.82712000",
                        "longitude": "-71.17411000"
                    },
                    {
                        "id": 31077,
                        "name": "Guananico",
                        "latitude": "19.72693000",
                        "longitude": "-70.92294000"
                    },
                    {
                        "id": 31087,
                        "name": "Imbert",
                        "latitude": "19.75371000",
                        "longitude": "-70.82906000"
                    },
                    {
                        "id": 31120,
                        "name": "Los Hidalgos",
                        "latitude": "19.73333000",
                        "longitude": "-71.03333000"
                    },
                    {
                        "id": 31123,
                        "name": "Luperón",
                        "latitude": "19.89131000",
                        "longitude": "-70.96204000"
                    },
                    {
                        "id": 31135,
                        "name": "Monte Llano",
                        "latitude": "19.73460000",
                        "longitude": "-70.59915000"
                    },
                    {
                        "id": 31161,
                        "name": "Puerto Plata",
                        "latitude": "19.75119000",
                        "longitude": "-70.70251000"
                    },
                    {
                        "id": 31167,
                        "name": "Río Grande",
                        "latitude": "19.66667000",
                        "longitude": "-70.76667000"
                    },
                    {
                        "id": 31201,
                        "name": "Sosúa",
                        "latitude": "19.75220000",
                        "longitude": "-70.51995000"
                    },
                    {
                        "id": 31217,
                        "name": "Villa Isabela",
                        "latitude": "19.81564000",
                        "longitude": "-71.06056000"
                    }
                ]
            },
            {
                "id": 4103,
                "name": "Samaná",
                "iso2": "20",
                "latitude": "19.20583710",
                "longitude": "-69.33629490",
                "type": "province",
                "cities": [
                    {
                        "id": 31116,
                        "name": "Las Terrenas",
                        "latitude": "19.31102000",
                        "longitude": "-69.54280000"
                    },
                    {
                        "id": 31181,
                        "name": "Samaná",
                        "latitude": "19.20561000",
                        "longitude": "-69.33685000"
                    },
                    {
                        "id": 31202,
                        "name": "Sánchez",
                        "latitude": "19.22810000",
                        "longitude": "-69.61370000"
                    }
                ]
            },
            {
                "id": 4091,
                "name": "San Cristóbal",
                "iso2": "21",
                "latitude": "18.41804140",
                "longitude": "-70.10658490",
                "type": "province",
                "cities": [
                    {
                        "id": 31026,
                        "name": "Bajos de Haina",
                        "latitude": "18.41667000",
                        "longitude": "-70.03333000"
                    },
                    {
                        "id": 31039,
                        "name": "Cambita Garabitos",
                        "latitude": "18.50000000",
                        "longitude": "-70.23333000"
                    },
                    {
                        "id": 31056,
                        "name": "El Cacao",
                        "latitude": "18.52719000",
                        "longitude": "-70.29585000"
                    },
                    {
                        "id": 31057,
                        "name": "El Carril",
                        "latitude": "18.44905000",
                        "longitude": "-70.02785000"
                    },
                    {
                        "id": 31172,
                        "name": "Sabana Grande de Palenque",
                        "latitude": "18.26256000",
                        "longitude": "-70.14821000"
                    },
                    {
                        "id": 31183,
                        "name": "San Cristóbal",
                        "latitude": "18.41667000",
                        "longitude": "-70.13333000"
                    },
                    {
                        "id": 31186,
                        "name": "San Gregorio de Nigua",
                        "latitude": "18.38333000",
                        "longitude": "-70.08333000"
                    },
                    {
                        "id": 31211,
                        "name": "Villa Altagracia",
                        "latitude": "18.63333000",
                        "longitude": "-70.25000000"
                    },
                    {
                        "id": 31223,
                        "name": "Yaguate",
                        "latitude": "18.33333000",
                        "longitude": "-70.18333000"
                    }
                ]
            },
            {
                "id": 4112,
                "name": "San José de Ocoa",
                "iso2": "31",
                "latitude": "18.54385800",
                "longitude": "-70.50418160",
                "type": "province",
                "cities": [
                    {
                        "id": 31189,
                        "name": "San José de Ocoa",
                        "latitude": "18.54661000",
                        "longitude": "-70.50631000"
                    }
                ]
            },
            {
                "id": 4098,
                "name": "San Juan",
                "iso2": "22",
                "latitude": "-31.52871270",
                "longitude": "-68.53604030",
                "type": "province",
                "cities": [
                    {
                        "id": 31033,
                        "name": "Bohechío",
                        "latitude": "18.77515000",
                        "longitude": "-70.98889000"
                    },
                    {
                        "id": 31045,
                        "name": "Cercado Abajo",
                        "latitude": "18.72681000",
                        "longitude": "-71.51742000"
                    },
                    {
                        "id": 31058,
                        "name": "El Cercado",
                        "latitude": "18.70000000",
                        "longitude": "-71.46667000"
                    },
                    {
                        "id": 31098,
                        "name": "Juan de Herrera",
                        "latitude": "18.87402000",
                        "longitude": "-71.23830000"
                    },
                    {
                        "id": 31113,
                        "name": "Las Matas de Farfán",
                        "latitude": "18.91667000",
                        "longitude": "-71.50000000"
                    },
                    {
                        "id": 31129,
                        "name": "Matayaya",
                        "latitude": "18.89036000",
                        "longitude": "-71.59459000"
                    },
                    {
                        "id": 31149,
                        "name": "Pedro Corto",
                        "latitude": "18.84856000",
                        "longitude": "-71.41041000"
                    },
                    {
                        "id": 31190,
                        "name": "San Juan de la Maguana",
                        "latitude": "18.80588000",
                        "longitude": "-71.22991000"
                    },
                    {
                        "id": 31208,
                        "name": "Vallejuelo",
                        "latitude": "18.65354000",
                        "longitude": "-71.33431000"
                    }
                ]
            },
            {
                "id": 4110,
                "name": "San Pedro de Macorís",
                "iso2": "23",
                "latitude": "18.46266000",
                "longitude": "-69.30512340",
                "type": "province",
                "cities": [
                    {
                        "id": 31064,
                        "name": "El Puerto",
                        "latitude": "18.78333000",
                        "longitude": "-69.46667000"
                    },
                    {
                        "id": 31121,
                        "name": "Los Llanos",
                        "latitude": "18.62035000",
                        "longitude": "-69.49581000"
                    },
                    {
                        "id": 31163,
                        "name": "Quisqueya",
                        "latitude": "18.55542000",
                        "longitude": "-69.40814000"
                    },
                    {
                        "id": 31164,
                        "name": "Ramón Santana",
                        "latitude": "18.54224000",
                        "longitude": "-69.17979000"
                    },
                    {
                        "id": 31191,
                        "name": "San Pedro de Macorís",
                        "latitude": "18.45390000",
                        "longitude": "-69.30864000"
                    }
                ]
            },
            {
                "id": 4088,
                "name": "Sánchez Ramírez",
                "iso2": "24",
                "latitude": "19.05270600",
                "longitude": "-70.14922640",
                "type": "province",
                "cities": [
                    {
                        "id": 31046,
                        "name": "Cevicos",
                        "latitude": "19.00449000",
                        "longitude": "-69.97896000"
                    },
                    {
                        "id": 31050,
                        "name": "Cotuí",
                        "latitude": "19.05272000",
                        "longitude": "-70.14939000"
                    },
                    {
                        "id": 31072,
                        "name": "Fantino",
                        "latitude": "19.11667000",
                        "longitude": "-70.30000000"
                    }
                ]
            },
            {
                "id": 4108,
                "name": "Santiago",
                "iso2": "25",
                "latitude": "-33.45000000",
                "longitude": "-70.66670000",
                "type": "province",
                "cities": [
                    {
                        "id": 31025,
                        "name": "Baitoa",
                        "latitude": "19.32512000",
                        "longitude": "-70.70357000"
                    },
                    {
                        "id": 31030,
                        "name": "Bisonó",
                        "latitude": "19.58333000",
                        "longitude": "-70.86667000"
                    },
                    {
                        "id": 31100,
                        "name": "Juncalito Abajo",
                        "latitude": "19.21990000",
                        "longitude": "-70.81905000"
                    },
                    {
                        "id": 31102,
                        "name": "La Canela",
                        "latitude": "19.47341000",
                        "longitude": "-70.81629000"
                    },
                    {
                        "id": 31117,
                        "name": "Licey al Medio",
                        "latitude": "19.45000000",
                        "longitude": "-70.60000000"
                    },
                    {
                        "id": 31143,
                        "name": "Palmar Arriba",
                        "latitude": "19.53957000",
                        "longitude": "-70.73826000"
                    },
                    {
                        "id": 31150,
                        "name": "Pedro García",
                        "latitude": "19.59202000",
                        "longitude": "-70.65256000"
                    },
                    {
                        "id": 31173,
                        "name": "Sabana Iglesia",
                        "latitude": "19.32114000",
                        "longitude": "-70.75992000"
                    },
                    {
                        "id": 31188,
                        "name": "San José de Las Matas",
                        "latitude": "19.33915000",
                        "longitude": "-70.93819000"
                    },
                    {
                        "id": 31196,
                        "name": "Santiago de los Caballeros",
                        "latitude": "19.45170000",
                        "longitude": "-70.69703000"
                    },
                    {
                        "id": 31200,
                        "name": "Santo Tomás de Jánico",
                        "latitude": "19.23528000",
                        "longitude": "-70.79515000"
                    },
                    {
                        "id": 31204,
                        "name": "Tamboril",
                        "latitude": "19.48538000",
                        "longitude": "-70.61104000"
                    },
                    {
                        "id": 31212,
                        "name": "Villa Bisonó",
                        "latitude": "19.56378000",
                        "longitude": "-70.87582000"
                    },
                    {
                        "id": 31216,
                        "name": "Villa González",
                        "latitude": "19.54057000",
                        "longitude": "-70.78853000"
                    }
                ]
            },
            {
                "id": 4100,
                "name": "Santiago Rodríguez",
                "iso2": "26",
                "latitude": "19.47131810",
                "longitude": "-71.33958010",
                "type": "province",
                "cities": [
                    {
                        "id": 31133,
                        "name": "Monción",
                        "latitude": "19.46667000",
                        "longitude": "-71.16667000"
                    },
                    {
                        "id": 31177,
                        "name": "Sabaneta",
                        "latitude": "19.47793000",
                        "longitude": "-71.34125000"
                    },
                    {
                        "id": 31187,
                        "name": "San Ignacio de Sabaneta",
                        "latitude": "19.38333000",
                        "longitude": "-71.35000000"
                    }
                ]
            },
            {
                "id": 4093,
                "name": "Santo Domingo",
                "iso2": "32",
                "latitude": "18.51042530",
                "longitude": "-69.84040540",
                "type": "province",
                "cities": [
                    {
                        "id": 31031,
                        "name": "Boca Chica",
                        "latitude": "18.45000000",
                        "longitude": "-69.60000000"
                    },
                    {
                        "id": 31198,
                        "name": "Santo Domingo Este",
                        "latitude": "18.48847000",
                        "longitude": "-69.85707000"
                    },
                    {
                        "id": 31199,
                        "name": "Santo Domingo Oeste",
                        "latitude": "18.50000000",
                        "longitude": "-70.00000000"
                    }
                ]
            },
            {
                "id": 4104,
                "name": "Valverde",
                "iso2": "27",
                "latitude": "19.58812210",
                "longitude": "-70.98033100",
                "type": "province",
                "cities": [
                    {
                        "id": 31021,
                        "name": "Amina",
                        "latitude": "19.54813000",
                        "longitude": "-70.99599000"
                    },
                    {
                        "id": 31069,
                        "name": "Esperanza",
                        "latitude": "19.62379000",
                        "longitude": "-70.97141000"
                    },
                    {
                        "id": 31078,
                        "name": "Guatapanal",
                        "latitude": "19.50705000",
                        "longitude": "-70.91713000"
                    },
                    {
                        "id": 31088,
                        "name": "Jaibón",
                        "latitude": "19.61169000",
                        "longitude": "-71.14847000"
                    },
                    {
                        "id": 31092,
                        "name": "Jicomé",
                        "latitude": "19.64955000",
                        "longitude": "-70.94927000"
                    },
                    {
                        "id": 31103,
                        "name": "La Caya",
                        "latitude": "19.69981000",
                        "longitude": "-71.12084000"
                    },
                    {
                        "id": 31110,
                        "name": "Laguna Salada",
                        "latitude": "19.70000000",
                        "longitude": "-71.13333000"
                    },
                    {
                        "id": 31125,
                        "name": "Maizal",
                        "latitude": "19.63655000",
                        "longitude": "-71.02734000"
                    },
                    {
                        "id": 31127,
                        "name": "Mao",
                        "latitude": "19.55186000",
                        "longitude": "-71.07813000"
                    }
                ]
            }
        ]
    },
    {
        "id": 64,
        "name": "Ecuador",
        "iso3": "ECU",
        "iso2": "EC",
        "numeric_code": "218",
        "phonecode": "593",
        "capital": "Quito",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".ec",
        "native": "Ecuador",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Ecuadorian",
        "timezones": [
            {
                "zoneName": "America\/Guayaquil",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "ECT",
                "tzName": "Ecuador Time"
            },
            {
                "zoneName": "Pacific\/Galapagos",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "GALT",
                "tzName": "Galápagos Time"
            }
        ],
        "translations": {
            "br": "Ecuador",
            "ko": "에콰도르",
            "pt-BR": "Equador",
            "pt": "Equador",
            "nl": "Ecuador",
            "hr": "Ekvador",
            "fa": "اکوادور",
            "de": "Ecuador",
            "es": "Ecuador",
            "fr": "Équateur",
            "ja": "エクアドル",
            "it": "Ecuador",
            "zh-CN": "厄瓜多尔",
            "tr": "Ekvator",
            "ru": "Эквадор",
            "uk": "Еквадор",
            "pl": "Ekwador"
        },
        "latitude": "-2.00000000",
        "longitude": "-77.50000000",
        "emoji": "🇪🇨",
        "emojiU": "U+1F1EA U+1F1E8",
        "states": [
            {
                "id": 2923,
                "name": "Azuay",
                "iso2": "A",
                "latitude": "-2.89430680",
                "longitude": "-78.99683440",
                "type": "province",
                "cities": [
                    {
                        "id": 31493,
                        "name": "Cantón San Fernando",
                        "latitude": "-3.13349000",
                        "longitude": "-79.26893000"
                    },
                    {
                        "id": 31501,
                        "name": "Cuenca",
                        "latitude": "-2.90055000",
                        "longitude": "-79.00453000"
                    },
                    {
                        "id": 31507,
                        "name": "Gualaceo",
                        "latitude": "-2.89264000",
                        "longitude": "-78.77814000"
                    },
                    {
                        "id": 31519,
                        "name": "La Unión",
                        "latitude": "-2.85000000",
                        "longitude": "-78.78333000"
                    },
                    {
                        "id": 31521,
                        "name": "Llacao",
                        "latitude": "-2.86667000",
                        "longitude": "-78.88333000"
                    },
                    {
                        "id": 31535,
                        "name": "Nulti",
                        "latitude": "-2.91667000",
                        "longitude": "-78.85000000"
                    }
                ]
            },
            {
                "id": 2920,
                "name": "Bolívar",
                "iso2": "B",
                "latitude": "-1.70958280",
                "longitude": "-79.04504290",
                "type": "province",
                "cities": [
                    {
                        "id": 31510,
                        "name": "Guaranda",
                        "latitude": "-1.59263000",
                        "longitude": "-79.00098000"
                    },
                    {
                        "id": 31569,
                        "name": "San Miguel",
                        "latitude": "-1.70884000",
                        "longitude": "-79.04311000"
                    }
                ]
            },
            {
                "id": 2917,
                "name": "Cañar",
                "iso2": "F",
                "latitude": "-2.55893150",
                "longitude": "-78.93881910",
                "type": "province",
                "cities": [
                    {
                        "id": 31484,
                        "name": "Azogues",
                        "latitude": "-2.73969000",
                        "longitude": "-78.84860000"
                    },
                    {
                        "id": 31496,
                        "name": "Cañar",
                        "latitude": "-2.56062000",
                        "longitude": "-78.93940000"
                    },
                    {
                        "id": 31518,
                        "name": "La Troncal",
                        "latitude": "-2.42355000",
                        "longitude": "-79.33977000"
                    }
                ]
            },
            {
                "id": 2915,
                "name": "Carchi",
                "iso2": "C",
                "latitude": "0.50269120",
                "longitude": "-77.90425210",
                "type": "province",
                "cities": [
                    {
                        "id": 31503,
                        "name": "El Ángel",
                        "latitude": "0.62279000",
                        "longitude": "-77.94003000"
                    },
                    {
                        "id": 31567,
                        "name": "San Gabriel",
                        "latitude": "0.59318000",
                        "longitude": "-77.83078000"
                    },
                    {
                        "id": 31583,
                        "name": "Tulcán",
                        "latitude": "0.81187000",
                        "longitude": "-77.71727000"
                    }
                ]
            },
            {
                "id": 2925,
                "name": "Chimborazo",
                "iso2": "H",
                "latitude": "-1.66479950",
                "longitude": "-78.65432550",
                "type": "province",
                "cities": [
                    {
                        "id": 31479,
                        "name": "Alausí",
                        "latitude": "-2.20329000",
                        "longitude": "-78.84714000"
                    },
                    {
                        "id": 31509,
                        "name": "Guano",
                        "latitude": "-1.60789000",
                        "longitude": "-78.63105000"
                    },
                    {
                        "id": 31562,
                        "name": "Riobamba",
                        "latitude": "-1.67098000",
                        "longitude": "-78.64712000"
                    }
                ]
            },
            {
                "id": 2921,
                "name": "Cotopaxi",
                "iso2": "X",
                "latitude": "-0.83842060",
                "longitude": "-78.66626780",
                "type": "province",
                "cities": [
                    {
                        "id": 31517,
                        "name": "La Maná",
                        "latitude": "-0.94094000",
                        "longitude": "-79.22506000"
                    },
                    {
                        "id": 31520,
                        "name": "Latacunga",
                        "latitude": "-0.93521000",
                        "longitude": "-78.61554000"
                    },
                    {
                        "id": 31556,
                        "name": "Pujilí",
                        "latitude": "-0.95759000",
                        "longitude": "-78.69636000"
                    },
                    {
                        "id": 31570,
                        "name": "San Miguel de Salcedo",
                        "latitude": "-1.04547000",
                        "longitude": "-78.59063000"
                    },
                    {
                        "id": 31578,
                        "name": "Saquisilí",
                        "latitude": "-0.83990000",
                        "longitude": "-78.66700000"
                    }
                ]
            },
            {
                "id": 2924,
                "name": "El Oro",
                "iso2": "O",
                "latitude": "-3.25924130",
                "longitude": "-79.95835410",
                "type": "province",
                "cities": [
                    {
                        "id": 31512,
                        "name": "Huaquillas",
                        "latitude": "-3.47523000",
                        "longitude": "-80.23084000"
                    },
                    {
                        "id": 31526,
                        "name": "Machala",
                        "latitude": "-3.25861000",
                        "longitude": "-79.96053000"
                    },
                    {
                        "id": 31542,
                        "name": "Pasaje",
                        "latitude": "-3.32561000",
                        "longitude": "-79.80697000"
                    },
                    {
                        "id": 31547,
                        "name": "Piñas",
                        "latitude": "-3.68107000",
                        "longitude": "-79.68083000"
                    },
                    {
                        "id": 31549,
                        "name": "Portovelo",
                        "latitude": "-3.72145000",
                        "longitude": "-79.62187000"
                    },
                    {
                        "id": 31553,
                        "name": "Puerto Bolívar",
                        "latitude": "-3.26649000",
                        "longitude": "-79.99749000"
                    },
                    {
                        "id": 31576,
                        "name": "Santa Rosa",
                        "latitude": "-3.44882000",
                        "longitude": "-79.95952000"
                    },
                    {
                        "id": 31592,
                        "name": "Zaruma",
                        "latitude": "-3.69132000",
                        "longitude": "-79.61174000"
                    }
                ]
            },
            {
                "id": 2922,
                "name": "Esmeraldas",
                "iso2": "E",
                "latitude": "0.96817890",
                "longitude": "-79.65172020",
                "type": "province",
                "cities": [
                    {
                        "id": 31505,
                        "name": "Esmeraldas",
                        "latitude": "0.95920000",
                        "longitude": "-79.65397000"
                    },
                    {
                        "id": 31531,
                        "name": "Muisne",
                        "latitude": "0.61129000",
                        "longitude": "-80.01863000"
                    },
                    {
                        "id": 31541,
                        "name": "Pampanal de Bolívar",
                        "latitude": "1.35251000",
                        "longitude": "-78.89360000"
                    },
                    {
                        "id": 31561,
                        "name": "Rio Verde",
                        "latitude": "1.06235000",
                        "longitude": "-79.39939000"
                    },
                    {
                        "id": 31564,
                        "name": "Rosa Zarate",
                        "latitude": "0.32779000",
                        "longitude": "-79.47407000"
                    },
                    {
                        "id": 31568,
                        "name": "San Lorenzo de Esmeraldas",
                        "latitude": "1.28626000",
                        "longitude": "-78.83514000"
                    },
                    {
                        "id": 31585,
                        "name": "Valdez",
                        "latitude": "1.24917000",
                        "longitude": "-78.98306000"
                    }
                ]
            },
            {
                "id": 2905,
                "name": "Galápagos",
                "iso2": "W",
                "latitude": "-0.95376910",
                "longitude": "-90.96560190",
                "type": "province",
                "cities": [
                    {
                        "id": 31551,
                        "name": "Puerto Ayora",
                        "latitude": "-0.74018000",
                        "longitude": "-90.31380000"
                    },
                    {
                        "id": 31552,
                        "name": "Puerto Baquerizo Moreno",
                        "latitude": "-0.90172000",
                        "longitude": "-89.61021000"
                    },
                    {
                        "id": 31555,
                        "name": "Puerto Villamil",
                        "latitude": "-0.95542000",
                        "longitude": "-90.96654000"
                    }
                ]
            },
            {
                "id": 2914,
                "name": "Guayas",
                "iso2": "G",
                "latitude": "-1.95748390",
                "longitude": "-79.91927020",
                "type": "province",
                "cities": [
                    {
                        "id": 31480,
                        "name": "Alfredo Baquerizo Moreno",
                        "latitude": "-1.91667000",
                        "longitude": "-79.51667000"
                    },
                    {
                        "id": 31488,
                        "name": "Baláo",
                        "latitude": "-2.91100000",
                        "longitude": "-79.81441000"
                    },
                    {
                        "id": 31487,
                        "name": "Balzar",
                        "latitude": "-1.36501000",
                        "longitude": "-79.90494000"
                    },
                    {
                        "id": 31498,
                        "name": "Colimes",
                        "latitude": "-1.54553000",
                        "longitude": "-80.01165000"
                    },
                    {
                        "id": 31499,
                        "name": "Coronel Marcelino Maridueña",
                        "latitude": "-2.20924000",
                        "longitude": "-79.43248000"
                    },
                    {
                        "id": 31502,
                        "name": "El Triunfo",
                        "latitude": "-1.93333000",
                        "longitude": "-79.96667000"
                    },
                    {
                        "id": 31504,
                        "name": "Eloy Alfaro",
                        "latitude": "-2.17579000",
                        "longitude": "-79.85519000"
                    },
                    {
                        "id": 31511,
                        "name": "Guayaquil",
                        "latitude": "-2.19616000",
                        "longitude": "-79.88621000"
                    },
                    {
                        "id": 31522,
                        "name": "Lomas de Sargentillo",
                        "latitude": "-1.88333000",
                        "longitude": "-80.08333000"
                    },
                    {
                        "id": 31528,
                        "name": "Milagro",
                        "latitude": "-2.13404000",
                        "longitude": "-79.59415000"
                    },
                    {
                        "id": 31532,
                        "name": "Naranjal",
                        "latitude": "-2.67364000",
                        "longitude": "-79.61830000"
                    },
                    {
                        "id": 31533,
                        "name": "Naranjito",
                        "latitude": "-2.16671000",
                        "longitude": "-79.46540000"
                    },
                    {
                        "id": 31539,
                        "name": "Palestina",
                        "latitude": "-1.93709000",
                        "longitude": "-79.71396000"
                    },
                    {
                        "id": 31544,
                        "name": "Pedro Carbo",
                        "latitude": "-1.81563000",
                        "longitude": "-80.23309000"
                    },
                    {
                        "id": 31548,
                        "name": "Playas",
                        "latitude": "-2.63199000",
                        "longitude": "-80.38808000"
                    },
                    {
                        "id": 31566,
                        "name": "Samborondón",
                        "latitude": "-1.96276000",
                        "longitude": "-79.72402000"
                    },
                    {
                        "id": 31575,
                        "name": "Santa Lucía",
                        "latitude": "-2.18333000",
                        "longitude": "-80.00000000"
                    },
                    {
                        "id": 31586,
                        "name": "Velasco Ibarra",
                        "latitude": "-1.04376000",
                        "longitude": "-79.63837000"
                    },
                    {
                        "id": 31589,
                        "name": "Yaguachi Nuevo",
                        "latitude": "-2.09680000",
                        "longitude": "-79.69485000"
                    }
                ]
            },
            {
                "id": 2911,
                "name": "Imbabura",
                "iso2": "I",
                "latitude": "0.34997680",
                "longitude": "-78.12601290",
                "type": "province",
                "cities": [
                    {
                        "id": 31483,
                        "name": "Atuntaqui",
                        "latitude": "0.33247000",
                        "longitude": "-78.21371000"
                    },
                    {
                        "id": 31500,
                        "name": "Cotacachi",
                        "latitude": "0.30107000",
                        "longitude": "-78.26428000"
                    },
                    {
                        "id": 31513,
                        "name": "Ibarra",
                        "latitude": "0.35171000",
                        "longitude": "-78.12233000"
                    },
                    {
                        "id": 31536,
                        "name": "Otavalo",
                        "latitude": "0.23457000",
                        "longitude": "-78.26248000"
                    },
                    {
                        "id": 31546,
                        "name": "Pimampiro",
                        "latitude": "0.39116000",
                        "longitude": "-77.94068000"
                    }
                ]
            },
            {
                "id": 5068,
                "name": "Loja",
                "iso2": "L",
                "latitude": "-3.99313000",
                "longitude": "-79.20422000",
                "type": "province",
                "cities": [
                    {
                        "id": 149262,
                        "name": "Loja",
                        "latitude": "-3.99313000",
                        "longitude": "-79.20422000"
                    }
                ]
            },
            {
                "id": 2910,
                "name": "Los Ríos",
                "iso2": "R",
                "latitude": "-1.02306070",
                "longitude": "-79.46088970",
                "type": "province",
                "cities": [
                    {
                        "id": 31485,
                        "name": "Babahoyo",
                        "latitude": "-1.80217000",
                        "longitude": "-79.53443000"
                    },
                    {
                        "id": 31494,
                        "name": "Catarama",
                        "latitude": "-1.57504000",
                        "longitude": "-79.45998000"
                    },
                    {
                        "id": 31529,
                        "name": "Montalvo",
                        "latitude": "-1.79008000",
                        "longitude": "-79.28759000"
                    },
                    {
                        "id": 31538,
                        "name": "Palenque",
                        "latitude": "-1.43795000",
                        "longitude": "-79.75647000"
                    },
                    {
                        "id": 31559,
                        "name": "Quevedo",
                        "latitude": "-1.02863000",
                        "longitude": "-79.46352000"
                    },
                    {
                        "id": 31587,
                        "name": "Ventanas",
                        "latitude": "-1.44158000",
                        "longitude": "-79.45943000"
                    },
                    {
                        "id": 31588,
                        "name": "Vinces",
                        "latitude": "-1.55611000",
                        "longitude": "-79.75191000"
                    }
                ]
            },
            {
                "id": 2913,
                "name": "Manabí",
                "iso2": "M",
                "latitude": "-1.05434340",
                "longitude": "-80.45264400",
                "type": "province",
                "cities": [
                    {
                        "id": 31486,
                        "name": "Bahía de Caráquez",
                        "latitude": "-0.59792000",
                        "longitude": "-80.42367000"
                    },
                    {
                        "id": 31491,
                        "name": "Calceta",
                        "latitude": "-0.84582000",
                        "longitude": "-80.16389000"
                    },
                    {
                        "id": 31492,
                        "name": "Cantón Portoviejo",
                        "latitude": "-1.05000000",
                        "longitude": "-80.45000000"
                    },
                    {
                        "id": 31497,
                        "name": "Chone",
                        "latitude": "-0.69819000",
                        "longitude": "-80.09361000"
                    },
                    {
                        "id": 31514,
                        "name": "Jipijapa",
                        "latitude": "-1.34872000",
                        "longitude": "-80.57875000"
                    },
                    {
                        "id": 31515,
                        "name": "Junín",
                        "latitude": "-0.92777000",
                        "longitude": "-80.20583000"
                    },
                    {
                        "id": 31527,
                        "name": "Manta",
                        "latitude": "-0.96212000",
                        "longitude": "-80.71271000"
                    },
                    {
                        "id": 31530,
                        "name": "Montecristi",
                        "latitude": "-1.04576000",
                        "longitude": "-80.65889000"
                    },
                    {
                        "id": 31537,
                        "name": "Paján",
                        "latitude": "-1.55238000",
                        "longitude": "-80.42958000"
                    },
                    {
                        "id": 31543,
                        "name": "Pedernales",
                        "latitude": "0.07167000",
                        "longitude": "-80.05250000"
                    },
                    {
                        "id": 31550,
                        "name": "Portoviejo",
                        "latitude": "-1.05458000",
                        "longitude": "-80.45445000"
                    },
                    {
                        "id": 31563,
                        "name": "Rocafuerte",
                        "latitude": "-0.92360000",
                        "longitude": "-80.44946000"
                    },
                    {
                        "id": 31571,
                        "name": "San Vicente",
                        "latitude": "-0.60435000",
                        "longitude": "-80.40267000"
                    },
                    {
                        "id": 31573,
                        "name": "Santa Ana",
                        "latitude": "-1.20726000",
                        "longitude": "-80.37132000"
                    },
                    {
                        "id": 31579,
                        "name": "Sucre",
                        "latitude": "-1.27974000",
                        "longitude": "-80.41885000"
                    },
                    {
                        "id": 31582,
                        "name": "Tosagua",
                        "latitude": "-0.78679000",
                        "longitude": "-80.23473000"
                    }
                ]
            },
            {
                "id": 2918,
                "name": "Morona-Santiago",
                "iso2": "S",
                "latitude": "-2.30510620",
                "longitude": "-78.11468660",
                "type": "province",
                "cities": [
                    {
                        "id": 31508,
                        "name": "Gualaquiza",
                        "latitude": "-3.40359000",
                        "longitude": "-78.58166000"
                    },
                    {
                        "id": 31524,
                        "name": "Macas",
                        "latitude": "-2.30868000",
                        "longitude": "-78.11135000"
                    },
                    {
                        "id": 31540,
                        "name": "Palora",
                        "latitude": "-1.70131000",
                        "longitude": "-77.96516000"
                    },
                    {
                        "id": 31580,
                        "name": "Sucúa",
                        "latitude": "-2.45866000",
                        "longitude": "-78.17171000"
                    }
                ]
            },
            {
                "id": 2916,
                "name": "Napo",
                "iso2": "N",
                "latitude": "-0.99559640",
                "longitude": "-77.81296840",
                "type": "province",
                "cities": [
                    {
                        "id": 31482,
                        "name": "Archidona",
                        "latitude": "-0.90950000",
                        "longitude": "-77.80772000"
                    },
                    {
                        "id": 31581,
                        "name": "Tena",
                        "latitude": "-0.99380000",
                        "longitude": "-77.81286000"
                    }
                ]
            },
            {
                "id": 2926,
                "name": "Orellana",
                "iso2": "D",
                "latitude": "-0.45451630",
                "longitude": "-76.99502860",
                "type": "province",
                "cities": [
                    {
                        "id": 31490,
                        "name": "Boca Suno",
                        "latitude": "-0.69832000",
                        "longitude": "-77.14083000"
                    },
                    {
                        "id": 31506,
                        "name": "Francisco de Orellana Canton",
                        "latitude": "-0.46667000",
                        "longitude": "-76.96667000"
                    },
                    {
                        "id": 31523,
                        "name": "Loreto Canton",
                        "latitude": "-0.69487000",
                        "longitude": "-77.30255000"
                    },
                    {
                        "id": 31554,
                        "name": "Puerto Francisco de Orellana",
                        "latitude": "-0.46645000",
                        "longitude": "-76.98719000"
                    }
                ]
            },
            {
                "id": 2907,
                "name": "Pastaza",
                "iso2": "Y",
                "latitude": "-1.48822650",
                "longitude": "-78.00310570",
                "type": "province",
                "cities": [
                    {
                        "id": 31557,
                        "name": "Puyo",
                        "latitude": "-1.48369000",
                        "longitude": "-78.00257000"
                    }
                ]
            },
            {
                "id": 2927,
                "name": "Pichincha",
                "iso2": "P",
                "latitude": "-0.14648470",
                "longitude": "-78.47519450",
                "type": "province",
                "cities": [
                    {
                        "id": 31495,
                        "name": "Cayambe",
                        "latitude": "0.04084000",
                        "longitude": "-78.14524000"
                    },
                    {
                        "id": 31525,
                        "name": "Machachi",
                        "latitude": "-0.51011000",
                        "longitude": "-78.56712000"
                    },
                    {
                        "id": 31560,
                        "name": "Quito",
                        "latitude": "-0.22985000",
                        "longitude": "-78.52495000"
                    },
                    {
                        "id": 31572,
                        "name": "Sangolquí",
                        "latitude": "-0.33405000",
                        "longitude": "-78.45217000"
                    }
                ]
            },
            {
                "id": 2912,
                "name": "Santa Elena",
                "iso2": "SE",
                "latitude": "-2.22671050",
                "longitude": "-80.85949900",
                "type": "province",
                "cities": [
                    {
                        "id": 31516,
                        "name": "La Libertad",
                        "latitude": "-2.23300000",
                        "longitude": "-80.91039000"
                    },
                    {
                        "id": 31565,
                        "name": "Salinas",
                        "latitude": "-2.21452000",
                        "longitude": "-80.95151000"
                    },
                    {
                        "id": 31574,
                        "name": "Santa Elena",
                        "latitude": "-2.22622000",
                        "longitude": "-80.85873000"
                    }
                ]
            },
            {
                "id": 2919,
                "name": "Santo Domingo de los Tsáchilas",
                "iso2": "SD",
                "latitude": "-0.25218820",
                "longitude": "-79.18793830",
                "type": "province",
                "cities": [
                    {
                        "id": 31577,
                        "name": "Santo Domingo de los Colorados",
                        "latitude": "-0.25305000",
                        "longitude": "-79.17536000"
                    }
                ]
            },
            {
                "id": 2906,
                "name": "Sucumbíos",
                "iso2": "U",
                "latitude": "0.08892310",
                "longitude": "-76.88975570",
                "type": "province",
                "cities": [
                    {
                        "id": 31534,
                        "name": "Nueva Loja",
                        "latitude": "0.08600000",
                        "longitude": "-76.89528000"
                    }
                ]
            },
            {
                "id": 2908,
                "name": "Tungurahua",
                "iso2": "T",
                "latitude": "-1.26352840",
                "longitude": "-78.56608520",
                "type": "province",
                "cities": [
                    {
                        "id": 31481,
                        "name": "Ambato",
                        "latitude": "-1.24908000",
                        "longitude": "-78.61675000"
                    },
                    {
                        "id": 31489,
                        "name": "Baños",
                        "latitude": "-1.39699000",
                        "longitude": "-78.42289000"
                    },
                    {
                        "id": 31545,
                        "name": "Pelileo",
                        "latitude": "-1.32990000",
                        "longitude": "-78.54341000"
                    },
                    {
                        "id": 31558,
                        "name": "Píllaro",
                        "latitude": "-1.17414000",
                        "longitude": "-78.54676000"
                    }
                ]
            },
            {
                "id": 2909,
                "name": "Zamora Chinchipe",
                "iso2": "Z",
                "latitude": "-4.06558920",
                "longitude": "-78.95035250",
                "type": "province",
                "cities": [
                    {
                        "id": 31590,
                        "name": "Yantzaza",
                        "latitude": "-3.83261000",
                        "longitude": "-78.76076000"
                    },
                    {
                        "id": 31591,
                        "name": "Zamora",
                        "latitude": "-4.06685000",
                        "longitude": "-78.95488000"
                    }
                ]
            }
        ]
    },
    {
        "id": 65,
        "name": "Egypt",
        "iso3": "EGY",
        "iso2": "EG",
        "numeric_code": "818",
        "phonecode": "20",
        "capital": "Cairo",
        "currency": "EGP",
        "currency_name": "Egyptian pound",
        "currency_symbol": "ج.م",
        "tld": ".eg",
        "native": "مصر‎",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Northern Africa",
        "subregion_id": 1,
        "nationality": "Egyptian",
        "timezones": [
            {
                "zoneName": "Africa\/Cairo",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Egipt",
            "ko": "이집트",
            "pt-BR": "Egito",
            "pt": "Egipto",
            "nl": "Egypte",
            "hr": "Egipat",
            "fa": "مصر",
            "de": "Ägypten",
            "es": "Egipto",
            "fr": "Égypte",
            "ja": "エジプト",
            "it": "Egitto",
            "zh-CN": "埃及",
            "tr": "Mısır",
            "ru": "Египет",
            "uk": "Єгипет",
            "pl": "Egipt"
        },
        "latitude": "27.00000000",
        "longitude": "30.00000000",
        "emoji": "🇪🇬",
        "emojiU": "U+1F1EA U+1F1EC",
        "states": [
            {
                "id": 3235,
                "name": "Alexandria",
                "iso2": "ALX",
                "latitude": "30.87605680",
                "longitude": "29.74260400",
                "type": "governorate",
                "cities": [
                    {
                        "id": 149594,
                        "name": "Abu Qir",
                        "latitude": "31.31666667",
                        "longitude": "30.06666667"
                    },
                    {
                        "id": 149595,
                        "name": "Agami",
                        "latitude": "31.09590000",
                        "longitude": "29.76040000"
                    },
                    {
                        "id": 31787,
                        "name": "Alexandria",
                        "latitude": "31.20176000",
                        "longitude": "29.91582000"
                    },
                    {
                        "id": 149596,
                        "name": "Ar-Raml",
                        "latitude": "31.24821000",
                        "longitude": "29.97368000"
                    },
                    {
                        "id": 149597,
                        "name": "Borg El Arab",
                        "latitude": "30.91666667",
                        "longitude": "29.53333333"
                    },
                    {
                        "id": 149598,
                        "name": "Montaza",
                        "latitude": "31.28270000",
                        "longitude": "30.02190000"
                    },
                    {
                        "id": 149599,
                        "name": "New Borg El Arab",
                        "latitude": "30.88525000",
                        "longitude": "29.57721000"
                    },
                    {
                        "id": 149600,
                        "name": "Sidi Bishr",
                        "latitude": "31.25210000",
                        "longitude": "29.99450000"
                    }
                ]
            },
            {
                "id": 3225,
                "name": "Aswan",
                "iso2": "ASN",
                "latitude": "23.69664980",
                "longitude": "32.71813750",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31756,
                        "name": "Abu Simbel",
                        "latitude": "22.34570000",
                        "longitude": "31.61624000"
                    },
                    {
                        "id": 31791,
                        "name": "Aswan",
                        "latitude": "24.09082000",
                        "longitude": "32.89942000"
                    },
                    {
                        "id": 31819,
                        "name": "Idfū",
                        "latitude": "24.97916000",
                        "longitude": "32.87722000"
                    },
                    {
                        "id": 31829,
                        "name": "Kawm Umbū",
                        "latitude": "24.47669000",
                        "longitude": "32.94626000"
                    }
                ]
            },
            {
                "id": 3236,
                "name": "Asyut",
                "iso2": "AST",
                "latitude": "27.21338310",
                "longitude": "31.44561790",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31755,
                        "name": "Abnūb",
                        "latitude": "27.26960000",
                        "longitude": "31.15105000"
                    },
                    {
                        "id": 31758,
                        "name": "Abū Tīj",
                        "latitude": "27.04411000",
                        "longitude": "31.31897000"
                    },
                    {
                        "id": 31764,
                        "name": "Al Badārī",
                        "latitude": "26.99257000",
                        "longitude": "31.41554000"
                    },
                    {
                        "id": 31781,
                        "name": "Al Qūşīyah",
                        "latitude": "27.44020000",
                        "longitude": "30.81841000"
                    },
                    {
                        "id": 31792,
                        "name": "Asyūţ",
                        "latitude": "27.18096000",
                        "longitude": "31.18368000"
                    },
                    {
                        "id": 31807,
                        "name": "Dayrūţ",
                        "latitude": "27.55602000",
                        "longitude": "30.80764000"
                    },
                    {
                        "id": 31836,
                        "name": "Manfalūţ",
                        "latitude": "27.31040000",
                        "longitude": "30.97004000"
                    }
                ]
            },
            {
                "id": 3241,
                "name": "Beheira",
                "iso2": "BH",
                "latitude": "30.84809860",
                "longitude": "30.34355060",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31759,
                        "name": "Abū al Maţāmīr",
                        "latitude": "30.91018000",
                        "longitude": "30.17438000"
                    },
                    {
                        "id": 31760,
                        "name": "Ad Dilinjāt",
                        "latitude": "30.82796000",
                        "longitude": "30.53552000"
                    },
                    {
                        "id": 31804,
                        "name": "Damanhūr",
                        "latitude": "31.03408000",
                        "longitude": "30.46823000"
                    },
                    {
                        "id": 31879,
                        "name": "Ḩawsh ‘Īsá",
                        "latitude": "30.91280000",
                        "longitude": "30.29019000"
                    },
                    {
                        "id": 31820,
                        "name": "Idkū",
                        "latitude": "31.30730000",
                        "longitude": "30.29810000"
                    },
                    {
                        "id": 31826,
                        "name": "Kafr ad Dawwār",
                        "latitude": "31.13379000",
                        "longitude": "30.12969000"
                    },
                    {
                        "id": 31830,
                        "name": "Kawm Ḩamādah",
                        "latitude": "30.76128000",
                        "longitude": "30.69972000"
                    },
                    {
                        "id": 31857,
                        "name": "Rosetta",
                        "latitude": "31.39951000",
                        "longitude": "30.41718000"
                    }
                ]
            },
            {
                "id": 3230,
                "name": "Beni Suef",
                "iso2": "BNS",
                "latitude": "28.89388370",
                "longitude": "31.44561790",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31768,
                        "name": "Al Fashn",
                        "latitude": "28.82431000",
                        "longitude": "30.89948000"
                    },
                    {
                        "id": 31798,
                        "name": "Banī Suwayf",
                        "latitude": "29.07441000",
                        "longitude": "31.09785000"
                    },
                    {
                        "id": 31801,
                        "name": "Būsh",
                        "latitude": "29.14816000",
                        "longitude": "31.12733000"
                    },
                    {
                        "id": 31869,
                        "name": "Sumusţā as Sulţānī",
                        "latitude": "28.91667000",
                        "longitude": "30.85000000"
                    }
                ]
            },
            {
                "id": 3223,
                "name": "Cairo",
                "iso2": "C",
                "latitude": "29.95375640",
                "longitude": "31.53700030",
                "type": "governorate",
                "cities": [
                    {
                        "id": 149582,
                        "name": "Badr",
                        "latitude": "30.13600000",
                        "longitude": "31.71500000"
                    },
                    {
                        "id": 149583,
                        "name": "Bulaq",
                        "latitude": "30.05300000",
                        "longitude": "31.23000000"
                    },
                    {
                        "id": 31802,
                        "name": "Cairo",
                        "latitude": "30.06263000",
                        "longitude": "31.24967000"
                    },
                    {
                        "id": 149584,
                        "name": "El Mataria",
                        "latitude": "30.12950000",
                        "longitude": "31.28890000"
                    },
                    {
                        "id": 149585,
                        "name": "Fustat",
                        "latitude": "30.00000000",
                        "longitude": "31.23333333"
                    },
                    {
                        "id": 149586,
                        "name": "Hadayek El Kobba",
                        "latitude": "30.09670000",
                        "longitude": "31.31030000"
                    },
                    {
                        "id": 149587,
                        "name": "Heliopolis",
                        "latitude": "30.13333333",
                        "longitude": "31.30000000"
                    },
                    {
                        "id": 149588,
                        "name": "Helwan",
                        "latitude": "29.84194444",
                        "longitude": "31.33416667"
                    },
                    {
                        "id": 149589,
                        "name": "Maadi",
                        "latitude": "29.96670000",
                        "longitude": "31.25000000"
                    },
                    {
                        "id": 149590,
                        "name": "Musturud",
                        "latitude": "30.13881944",
                        "longitude": "31.29241111"
                    },
                    {
                        "id": 149591,
                        "name": "New Administrative Capital of Egypt",
                        "latitude": "30.02750000",
                        "longitude": "31.76500000"
                    },
                    {
                        "id": 149592,
                        "name": "Shubra",
                        "latitude": "30.07250000",
                        "longitude": "31.24080000"
                    },
                    {
                        "id": 149593,
                        "name": "Tura",
                        "latitude": "29.93927900",
                        "longitude": "31.29000700"
                    }
                ]
            },
            {
                "id": 3245,
                "name": "Dakahlia",
                "iso2": "DK",
                "latitude": "31.16560440",
                "longitude": "31.49131820",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31880,
                        "name": "‘Izbat al Burj",
                        "latitude": "31.50840000",
                        "longitude": "31.84106000"
                    },
                    {
                        "id": 31762,
                        "name": "Ajā",
                        "latitude": "30.94162000",
                        "longitude": "31.29039000"
                    },
                    {
                        "id": 31770,
                        "name": "Al Jammālīyah",
                        "latitude": "31.18065000",
                        "longitude": "31.86497000"
                    },
                    {
                        "id": 31775,
                        "name": "Al Manşūrah",
                        "latitude": "31.03637000",
                        "longitude": "31.38069000"
                    },
                    {
                        "id": 31774,
                        "name": "Al Manzalah",
                        "latitude": "31.15823000",
                        "longitude": "31.93600000"
                    },
                    {
                        "id": 31776,
                        "name": "Al Maţarīyah",
                        "latitude": "31.18287000",
                        "longitude": "32.03108000"
                    },
                    {
                        "id": 31800,
                        "name": "Bilqās",
                        "latitude": "31.21452000",
                        "longitude": "31.35798000"
                    },
                    {
                        "id": 31808,
                        "name": "Dikirnis",
                        "latitude": "31.08898000",
                        "longitude": "31.59478000"
                    },
                    {
                        "id": 31844,
                        "name": "Minyat an Naşr",
                        "latitude": "31.12624000",
                        "longitude": "31.64313000"
                    },
                    {
                        "id": 31865,
                        "name": "Shirbīn",
                        "latitude": "31.19688000",
                        "longitude": "31.52430000"
                    },
                    {
                        "id": 31876,
                        "name": "Ţalkhā",
                        "latitude": "31.05390000",
                        "longitude": "31.37787000"
                    }
                ]
            },
            {
                "id": 3224,
                "name": "Damietta",
                "iso2": "DT",
                "latitude": "31.36257990",
                "longitude": "31.67393710",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31794,
                        "name": "Az Zarqā",
                        "latitude": "31.20864000",
                        "longitude": "31.63528000"
                    },
                    {
                        "id": 31805,
                        "name": "Damietta",
                        "latitude": "31.41648000",
                        "longitude": "31.81332000"
                    },
                    {
                        "id": 31815,
                        "name": "Fāraskūr",
                        "latitude": "31.32977000",
                        "longitude": "31.71507000"
                    }
                ]
            },
            {
                "id": 3238,
                "name": "Faiyum",
                "iso2": "FYM",
                "latitude": "29.30840210",
                "longitude": "30.84284970",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31769,
                        "name": "Al Fayyūm",
                        "latitude": "29.30995000",
                        "longitude": "30.84180000"
                    },
                    {
                        "id": 31782,
                        "name": "Al Wāsiţah",
                        "latitude": "29.33778000",
                        "longitude": "31.20556000"
                    },
                    {
                        "id": 31818,
                        "name": "Ibshawāy",
                        "latitude": "29.35896000",
                        "longitude": "30.68061000"
                    },
                    {
                        "id": 31823,
                        "name": "Iţsā",
                        "latitude": "29.23760000",
                        "longitude": "30.78944000"
                    },
                    {
                        "id": 31877,
                        "name": "Ţāmiyah",
                        "latitude": "29.47639000",
                        "longitude": "30.96119000"
                    }
                ]
            },
            {
                "id": 3234,
                "name": "Gharbia",
                "iso2": "GH",
                "latitude": "30.87535560",
                "longitude": "31.03351000",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31777,
                        "name": "Al Maḩallah al Kubrá",
                        "latitude": "30.97063000",
                        "longitude": "31.16690000"
                    },
                    {
                        "id": 31799,
                        "name": "Basyūn",
                        "latitude": "30.93976000",
                        "longitude": "30.81338000"
                    },
                    {
                        "id": 31828,
                        "name": "Kafr az Zayyāt",
                        "latitude": "30.82480000",
                        "longitude": "30.81805000"
                    },
                    {
                        "id": 31855,
                        "name": "Quţūr",
                        "latitude": "30.97225000",
                        "longitude": "30.95614000"
                    },
                    {
                        "id": 31860,
                        "name": "Samannūd",
                        "latitude": "30.96160000",
                        "longitude": "31.24069000"
                    },
                    {
                        "id": 31872,
                        "name": "Tanda",
                        "latitude": "30.78847000",
                        "longitude": "31.00192000"
                    },
                    {
                        "id": 31874,
                        "name": "Zefta",
                        "latitude": "30.71420000",
                        "longitude": "31.24425000"
                    }
                ]
            },
            {
                "id": 3239,
                "name": "Giza",
                "iso2": "GZ",
                "latitude": "28.76662160",
                "longitude": "29.23207840",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31786,
                        "name": "Al ‘Ayyāţ",
                        "latitude": "29.61972000",
                        "longitude": "31.25750000"
                    },
                    {
                        "id": 31766,
                        "name": "Al Bawīţī",
                        "latitude": "28.34919000",
                        "longitude": "28.86591000"
                    },
                    {
                        "id": 31783,
                        "name": "Al Ḩawāmidīyah",
                        "latitude": "29.90000000",
                        "longitude": "31.25000000"
                    },
                    {
                        "id": 31795,
                        "name": "Aş Şaff",
                        "latitude": "29.56472000",
                        "longitude": "31.28111000"
                    },
                    {
                        "id": 31793,
                        "name": "Awsīm",
                        "latitude": "30.12303000",
                        "longitude": "31.13571000"
                    },
                    {
                        "id": 31816,
                        "name": "Giza",
                        "latitude": "30.00808000",
                        "longitude": "31.21093000"
                    },
                    {
                        "id": 31833,
                        "name": "Madīnat Sittah Uktūbar",
                        "latitude": "29.81667000",
                        "longitude": "31.05000000"
                    }
                ]
            },
            {
                "id": 3244,
                "name": "Ismailia",
                "iso2": "IS",
                "latitude": "30.58309340",
                "longitude": "32.26538870",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31821,
                        "name": "Ismailia",
                        "latitude": "30.60427000",
                        "longitude": "32.27225000"
                    }
                ]
            },
            {
                "id": 3222,
                "name": "Kafr El-Sheikh",
                "iso2": "KFS",
                "latitude": "31.30854440",
                "longitude": "30.80394740",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31784,
                        "name": "Al Ḩāmūl",
                        "latitude": "31.31146000",
                        "longitude": "31.14766000"
                    },
                    {
                        "id": 31810,
                        "name": "Disūq",
                        "latitude": "31.13259000",
                        "longitude": "30.64784000"
                    },
                    {
                        "id": 31814,
                        "name": "Fuwwah",
                        "latitude": "31.20365000",
                        "longitude": "30.54908000"
                    },
                    {
                        "id": 31827,
                        "name": "Kafr ash Shaykh",
                        "latitude": "31.11174000",
                        "longitude": "30.93991000"
                    },
                    {
                        "id": 31837,
                        "name": "Markaz Disūq",
                        "latitude": "31.14590000",
                        "longitude": "30.71609000"
                    },
                    {
                        "id": 31845,
                        "name": "Munshāt ‘Alī Āghā",
                        "latitude": "31.15791000",
                        "longitude": "30.70177000"
                    },
                    {
                        "id": 31870,
                        "name": "Sīdī Sālim",
                        "latitude": "31.27133000",
                        "longitude": "30.78617000"
                    }
                ]
            },
            {
                "id": 3242,
                "name": "Luxor",
                "iso2": "LX",
                "latitude": "25.39444440",
                "longitude": "32.49200880",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31832,
                        "name": "Luxor",
                        "latitude": "25.69893000",
                        "longitude": "32.64210000"
                    },
                    {
                        "id": 31840,
                        "name": "Markaz al Uqşur",
                        "latitude": "25.62986000",
                        "longitude": "32.59017000"
                    }
                ]
            },
            {
                "id": 3231,
                "name": "Matrouh",
                "iso2": "MT",
                "latitude": "29.56963500",
                "longitude": "26.41938900",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31785,
                        "name": "Al ‘Alamayn",
                        "latitude": "30.83007000",
                        "longitude": "28.95502000"
                    },
                    {
                        "id": 31843,
                        "name": "Mersa Matruh",
                        "latitude": "31.35290000",
                        "longitude": "27.23725000"
                    },
                    {
                        "id": 31866,
                        "name": "Siwa Oasis",
                        "latitude": "29.20320000",
                        "longitude": "25.51965000"
                    }
                ]
            },
            {
                "id": 3243,
                "name": "Minya",
                "iso2": "MN",
                "latitude": "28.28472900",
                "longitude": "30.52790960",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31757,
                        "name": "Abū Qurqāş",
                        "latitude": "27.93120000",
                        "longitude": "30.83841000"
                    },
                    {
                        "id": 31778,
                        "name": "Al Minyā",
                        "latitude": "28.10988000",
                        "longitude": "30.75030000"
                    },
                    {
                        "id": 31797,
                        "name": "Banī Mazār",
                        "latitude": "28.50360000",
                        "longitude": "30.80040000"
                    },
                    {
                        "id": 31806,
                        "name": "Dayr Mawās",
                        "latitude": "27.64176000",
                        "longitude": "30.84662000"
                    },
                    {
                        "id": 31835,
                        "name": "Mallawī",
                        "latitude": "27.73140000",
                        "longitude": "30.84165000"
                    },
                    {
                        "id": 31842,
                        "name": "Maţāy",
                        "latitude": "28.41899000",
                        "longitude": "30.77924000"
                    },
                    {
                        "id": 31861,
                        "name": "Samālūţ",
                        "latitude": "28.31214000",
                        "longitude": "30.71007000"
                    }
                ]
            },
            {
                "id": 3228,
                "name": "Monufia",
                "iso2": "MNF",
                "latitude": "30.59724550",
                "longitude": "30.98763210",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31767,
                        "name": "Al Bājūr",
                        "latitude": "30.43046000",
                        "longitude": "31.03679000"
                    },
                    {
                        "id": 31789,
                        "name": "Ash Shuhadā’",
                        "latitude": "30.59683000",
                        "longitude": "30.89931000"
                    },
                    {
                        "id": 31790,
                        "name": "Ashmūn",
                        "latitude": "30.29735000",
                        "longitude": "30.97641000"
                    },
                    {
                        "id": 31846,
                        "name": "Munūf",
                        "latitude": "30.46597000",
                        "longitude": "30.93199000"
                    },
                    {
                        "id": 31854,
                        "name": "Quwaysinā",
                        "latitude": "30.56482000",
                        "longitude": "31.15777000"
                    },
                    {
                        "id": 31863,
                        "name": "Shibīn al Kawm",
                        "latitude": "30.55258000",
                        "longitude": "31.00904000"
                    },
                    {
                        "id": 31871,
                        "name": "Talā",
                        "latitude": "30.67980000",
                        "longitude": "30.94364000"
                    }
                ]
            },
            {
                "id": 3246,
                "name": "New Valley",
                "iso2": "WAD",
                "latitude": "24.54556380",
                "longitude": "27.17353160",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31772,
                        "name": "Al Khārijah",
                        "latitude": "25.45141000",
                        "longitude": "30.54635000"
                    },
                    {
                        "id": 31852,
                        "name": "Qaşr al Farāfirah",
                        "latitude": "27.05680000",
                        "longitude": "27.96979000"
                    }
                ]
            },
            {
                "id": 3227,
                "name": "North Sinai",
                "iso2": "SIN",
                "latitude": "30.28236500",
                "longitude": "33.61757700",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31788,
                        "name": "Arish",
                        "latitude": "31.13159000",
                        "longitude": "33.79844000"
                    }
                ]
            },
            {
                "id": 3229,
                "name": "Port Said",
                "iso2": "PTS",
                "latitude": "31.07586060",
                "longitude": "32.26538870",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31850,
                        "name": "Port Said",
                        "latitude": "31.25654000",
                        "longitude": "32.28411000"
                    }
                ]
            },
            {
                "id": 3232,
                "name": "Qalyubia",
                "iso2": "KB",
                "latitude": "30.32923680",
                "longitude": "31.21684660",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31771,
                        "name": "Al Khānkah",
                        "latitude": "30.21035000",
                        "longitude": "31.36812000"
                    },
                    {
                        "id": 31779,
                        "name": "Al Qanāţir al Khayrīyah",
                        "latitude": "30.19327000",
                        "longitude": "31.13703000"
                    },
                    {
                        "id": 31796,
                        "name": "Banhā",
                        "latitude": "30.45977000",
                        "longitude": "31.18420000"
                    },
                    {
                        "id": 31851,
                        "name": "Qalyūb",
                        "latitude": "30.17922000",
                        "longitude": "31.20560000"
                    },
                    {
                        "id": 31864,
                        "name": "Shibīn al Qanāṭir",
                        "latitude": "30.31269000",
                        "longitude": "31.32018000"
                    },
                    {
                        "id": 31873,
                        "name": "Toukh",
                        "latitude": "30.35487000",
                        "longitude": "31.20105000"
                    }
                ]
            },
            {
                "id": 3247,
                "name": "Qena",
                "iso2": "KN",
                "latitude": "26.23460330",
                "longitude": "32.98883190",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31809,
                        "name": "Dishnā",
                        "latitude": "26.12467000",
                        "longitude": "32.47598000"
                    },
                    {
                        "id": 31813,
                        "name": "Farshūţ",
                        "latitude": "26.05494000",
                        "longitude": "32.16329000"
                    },
                    {
                        "id": 31822,
                        "name": "Isnā",
                        "latitude": "25.29336000",
                        "longitude": "32.55402000"
                    },
                    {
                        "id": 31831,
                        "name": "Kousa",
                        "latitude": "25.91407000",
                        "longitude": "32.76362000"
                    },
                    {
                        "id": 31847,
                        "name": "Naja' Ḥammādī",
                        "latitude": "26.04949000",
                        "longitude": "32.24142000"
                    },
                    {
                        "id": 31853,
                        "name": "Qinā",
                        "latitude": "26.16418000",
                        "longitude": "32.72671000"
                    }
                ]
            },
            {
                "id": 3240,
                "name": "Red Sea",
                "iso2": "BA",
                "latitude": "24.68263160",
                "longitude": "34.15319470",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31780,
                        "name": "Al Quşayr",
                        "latitude": "26.10426000",
                        "longitude": "34.27793000"
                    },
                    {
                        "id": 31811,
                        "name": "El Gouna",
                        "latitude": "27.39417000",
                        "longitude": "33.67825000"
                    },
                    {
                        "id": 31817,
                        "name": "Hurghada",
                        "latitude": "27.25738000",
                        "longitude": "33.81291000"
                    },
                    {
                        "id": 31834,
                        "name": "Makadi Bay",
                        "latitude": "26.99123000",
                        "longitude": "33.89952000"
                    },
                    {
                        "id": 31841,
                        "name": "Marsa Alam",
                        "latitude": "25.06305000",
                        "longitude": "34.89005000"
                    },
                    {
                        "id": 31856,
                        "name": "Ras Gharib",
                        "latitude": "28.35831000",
                        "longitude": "33.07829000"
                    },
                    {
                        "id": 31858,
                        "name": "Safaga",
                        "latitude": "26.74906000",
                        "longitude": "33.93891000"
                    }
                ]
            },
            {
                "id": 5067,
                "name": "Sharqia",
                "iso2": "SHR",
                "latitude": "30.67305450",
                "longitude": "31.15932470",
                "type": "governorate",
                "cities": [
                    {
                        "id": 149220,
                        "name": "10th of Ramadan",
                        "latitude": "30.29939390",
                        "longitude": "31.61417890"
                    },
                    {
                        "id": 149228,
                        "name": "Al Qurein",
                        "latitude": "26.29300660",
                        "longitude": "31.84950350"
                    },
                    {
                        "id": 149223,
                        "name": "Awlad Saqr",
                        "latitude": "30.93096230",
                        "longitude": "31.69132380"
                    },
                    {
                        "id": 149224,
                        "name": "Bilbeis",
                        "latitude": "30.41676920",
                        "longitude": "31.55430480"
                    },
                    {
                        "id": 149225,
                        "name": "Diyarb Negm",
                        "latitude": "30.74800820",
                        "longitude": "31.38893080"
                    },
                    {
                        "id": 149226,
                        "name": "El Husseiniya",
                        "latitude": "31.13933960",
                        "longitude": "32.14949670"
                    },
                    {
                        "id": 149229,
                        "name": "Faqous",
                        "latitude": "30.72291740",
                        "longitude": "31.76136580"
                    },
                    {
                        "id": 149230,
                        "name": "Hihya",
                        "latitude": "30.65516210",
                        "longitude": "31.50671570"
                    },
                    {
                        "id": 149231,
                        "name": "Kafr Saqr",
                        "latitude": "30.77955140",
                        "longitude": "31.61774120"
                    },
                    {
                        "id": 149221,
                        "name": "Markaz Abū Ḩammād",
                        "latitude": "30.53604430",
                        "longitude": "31.65970230"
                    },
                    {
                        "id": 149232,
                        "name": "Mashtoul El Souk",
                        "latitude": "30.35570110",
                        "longitude": "31.36278530"
                    },
                    {
                        "id": 149233,
                        "name": "Minya El Qamh",
                        "latitude": "30.50037450",
                        "longitude": "31.23766850"
                    },
                    {
                        "id": 149234,
                        "name": "New Salhia",
                        "latitude": "30.62868790",
                        "longitude": "31.92099060"
                    },
                    {
                        "id": 149235,
                        "name": "Zagazig",
                        "latitude": "30.58456230",
                        "longitude": "31.34747790"
                    }
                ]
            },
            {
                "id": 3226,
                "name": "Sohag",
                "iso2": "SHG",
                "latitude": "26.69383400",
                "longitude": "32.17460500",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31763,
                        "name": "Akhmīm",
                        "latitude": "26.56217000",
                        "longitude": "31.74503000"
                    },
                    {
                        "id": 31765,
                        "name": "Al Balyanā",
                        "latitude": "26.23568000",
                        "longitude": "32.00347000"
                    },
                    {
                        "id": 31773,
                        "name": "Al Manshāh",
                        "latitude": "26.47686000",
                        "longitude": "31.80350000"
                    },
                    {
                        "id": 31824,
                        "name": "Jirjā",
                        "latitude": "26.33826000",
                        "longitude": "31.89161000"
                    },
                    {
                        "id": 31825,
                        "name": "Juhaynah",
                        "latitude": "26.67319000",
                        "longitude": "31.49760000"
                    },
                    {
                        "id": 31838,
                        "name": "Markaz Jirjā",
                        "latitude": "26.30683000",
                        "longitude": "31.84574000"
                    },
                    {
                        "id": 31839,
                        "name": "Markaz Sūhāj",
                        "latitude": "26.53948000",
                        "longitude": "31.67524000"
                    },
                    {
                        "id": 31867,
                        "name": "Sohag",
                        "latitude": "26.55695000",
                        "longitude": "31.69478000"
                    },
                    {
                        "id": 31875,
                        "name": "Ţahţā",
                        "latitude": "26.76930000",
                        "longitude": "31.50214000"
                    }
                ]
            },
            {
                "id": 3237,
                "name": "South Sinai",
                "iso2": "JS",
                "latitude": "29.31018280",
                "longitude": "34.15319470",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31803,
                        "name": "Dahab",
                        "latitude": "28.48208000",
                        "longitude": "34.49505000"
                    },
                    {
                        "id": 31812,
                        "name": "El-Tor",
                        "latitude": "28.24168000",
                        "longitude": "33.62220000"
                    },
                    {
                        "id": 31849,
                        "name": "Nuwaybi‘a",
                        "latitude": "29.04681000",
                        "longitude": "34.66340000"
                    },
                    {
                        "id": 31859,
                        "name": "Saint Catherine",
                        "latitude": "28.56191000",
                        "longitude": "33.94934000"
                    },
                    {
                        "id": 31862,
                        "name": "Sharm el-Sheikh",
                        "latitude": "27.91582000",
                        "longitude": "34.32995000"
                    }
                ]
            },
            {
                "id": 3233,
                "name": "Suez",
                "iso2": "SUZ",
                "latitude": "29.36822550",
                "longitude": "32.17460500",
                "type": "governorate",
                "cities": [
                    {
                        "id": 31761,
                        "name": "Ain Sukhna",
                        "latitude": "29.60018000",
                        "longitude": "32.31671000"
                    },
                    {
                        "id": 31868,
                        "name": "Suez",
                        "latitude": "29.97371000",
                        "longitude": "32.52627000"
                    }
                ]
            }
        ]
    },
    {
        "id": 66,
        "name": "El Salvador",
        "iso3": "SLV",
        "iso2": "SV",
        "numeric_code": "222",
        "phonecode": "503",
        "capital": "San Salvador",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".sv",
        "native": "El Salvador",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Central America",
        "subregion_id": 9,
        "nationality": "Salvadoran",
        "timezones": [
            {
                "zoneName": "America\/El_Salvador",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            }
        ],
        "translations": {
            "br": "El Salvador",
            "ko": "엘살바도르",
            "pt-BR": "El Salvador",
            "pt": "El Salvador",
            "nl": "El Salvador",
            "hr": "Salvador",
            "fa": "السالوادور",
            "de": "El Salvador",
            "es": "El Salvador",
            "fr": "Salvador",
            "ja": "エルサルバドル",
            "it": "El Salvador",
            "zh-CN": "萨尔瓦多",
            "tr": "El Salvador",
            "ru": "Сальвадор",
            "uk": "Сальвадор",
            "pl": "Salwador"
        },
        "latitude": "13.83333333",
        "longitude": "-88.91666666",
        "emoji": "🇸🇻",
        "emojiU": "U+1F1F8 U+1F1FB",
        "states": [
            {
                "id": 4139,
                "name": "Ahuachapán",
                "iso2": "AH",
                "latitude": "13.82161480",
                "longitude": "-89.92532330",
                "type": "department",
                "cities": [
                    {
                        "id": 104842,
                        "name": "Ahuachapán",
                        "latitude": "13.92139000",
                        "longitude": "-89.84500000"
                    },
                    {
                        "id": 104848,
                        "name": "Atiquizaya",
                        "latitude": "13.97694000",
                        "longitude": "-89.75250000"
                    },
                    {
                        "id": 104863,
                        "name": "Concepción de Ataco",
                        "latitude": "13.87028000",
                        "longitude": "-89.84861000"
                    },
                    {
                        "id": 104873,
                        "name": "Guaymango",
                        "latitude": "13.75028000",
                        "longitude": "-89.84222000"
                    },
                    {
                        "id": 104883,
                        "name": "Jujutla",
                        "latitude": "13.78694000",
                        "longitude": "-89.85722000"
                    },
                    {
                        "id": 104906,
                        "name": "San Francisco Menéndez",
                        "latitude": "13.84306000",
                        "longitude": "-90.01583000"
                    },
                    {
                        "id": 104931,
                        "name": "Tacuba",
                        "latitude": "13.90111000",
                        "longitude": "-89.92972000"
                    }
                ]
            },
            {
                "id": 4132,
                "name": "Cabañas",
                "iso2": "CA",
                "latitude": "13.86482880",
                "longitude": "-88.74939980",
                "type": "department",
                "cities": [
                    {
                        "id": 104924,
                        "name": "Sensuntepeque",
                        "latitude": "13.86667000",
                        "longitude": "-88.63333000"
                    },
                    {
                        "id": 104937,
                        "name": "Victoria",
                        "latitude": "13.95000000",
                        "longitude": "-88.63333000"
                    }
                ]
            },
            {
                "id": 4131,
                "name": "Chalatenango",
                "iso2": "CH",
                "latitude": "14.19166480",
                "longitude": "-89.17059980",
                "type": "department",
                "cities": [
                    {
                        "id": 104853,
                        "name": "Chalatenango",
                        "latitude": "14.03333000",
                        "longitude": "-88.93333000"
                    },
                    {
                        "id": 104891,
                        "name": "Nueva Concepción",
                        "latitude": "14.13333000",
                        "longitude": "-89.30000000"
                    }
                ]
            },
            {
                "id": 4137,
                "name": "Cuscatlán",
                "iso2": "CU",
                "latitude": "13.86619570",
                "longitude": "-89.05615320",
                "type": "department",
                "cities": [
                    {
                        "id": 104861,
                        "name": "Cojutepeque",
                        "latitude": "13.71667000",
                        "longitude": "-88.93333000"
                    },
                    {
                        "id": 104909,
                        "name": "San Martín",
                        "latitude": "13.78333000",
                        "longitude": "-88.91667000"
                    },
                    {
                        "id": 104930,
                        "name": "Suchitoto",
                        "latitude": "13.93806000",
                        "longitude": "-89.02778000"
                    },
                    {
                        "id": 104932,
                        "name": "Tecoluca",
                        "latitude": "13.78917000",
                        "longitude": "-89.00528000"
                    },
                    {
                        "id": 104933,
                        "name": "Tenancingo",
                        "latitude": "13.83333000",
                        "longitude": "-88.98333000"
                    }
                ]
            },
            {
                "id": 4134,
                "name": "La Libertad",
                "iso2": "LI",
                "latitude": "13.68176610",
                "longitude": "-89.36062980",
                "type": "department",
                "cities": [
                    {
                        "id": 104844,
                        "name": "Antiguo Cuscatlán",
                        "latitude": "13.66492000",
                        "longitude": "-89.25319000"
                    },
                    {
                        "id": 104858,
                        "name": "Ciudad Arce",
                        "latitude": "13.84028000",
                        "longitude": "-89.44722000"
                    },
                    {
                        "id": 104884,
                        "name": "La Libertad",
                        "latitude": "13.48833000",
                        "longitude": "-89.32222000"
                    },
                    {
                        "id": 104894,
                        "name": "Nuevo Cuscatlán",
                        "latitude": "13.64861000",
                        "longitude": "-89.26528000"
                    },
                    {
                        "id": 104900,
                        "name": "Quezaltepeque",
                        "latitude": "13.83124000",
                        "longitude": "-89.27221000"
                    },
                    {
                        "id": 104907,
                        "name": "San Juan Opico",
                        "latitude": "13.87611000",
                        "longitude": "-89.35972000"
                    },
                    {
                        "id": 104911,
                        "name": "San Pablo Tacachico",
                        "latitude": "13.97556000",
                        "longitude": "-89.34000000"
                    },
                    {
                        "id": 104920,
                        "name": "Santa Tecla",
                        "latitude": "13.67694000",
                        "longitude": "-89.27972000"
                    },
                    {
                        "id": 104939,
                        "name": "Zaragoza",
                        "latitude": "13.58944000",
                        "longitude": "-89.28889000"
                    }
                ]
            },
            {
                "id": 4136,
                "name": "La Paz",
                "iso2": "PA",
                "latitude": "13.46621480",
                "longitude": "-89.13699720",
                "type": "department",
                "cities": [
                    {
                        "id": 104870,
                        "name": "El Rosario",
                        "latitude": "13.49778000",
                        "longitude": "-89.02972000"
                    },
                    {
                        "id": 104895,
                        "name": "Olocuilta",
                        "latitude": "13.56972000",
                        "longitude": "-89.11722000"
                    },
                    {
                        "id": 104912,
                        "name": "San Pedro Masahuat",
                        "latitude": "13.54361000",
                        "longitude": "-89.03861000"
                    },
                    {
                        "id": 104921,
                        "name": "Santiago Nonualco",
                        "latitude": "13.51667000",
                        "longitude": "-88.95000000"
                    },
                    {
                        "id": 104938,
                        "name": "Zacatecoluca",
                        "latitude": "13.50000000",
                        "longitude": "-88.86667000"
                    }
                ]
            },
            {
                "id": 4138,
                "name": "La Unión ",
                "iso2": "UN",
                "latitude": "13.48864430",
                "longitude": "-87.89424510",
                "type": "department",
                "cities": [
                    {
                        "id": 104843,
                        "name": "Anamorós",
                        "latitude": "13.74056000",
                        "longitude": "-87.87361000"
                    },
                    {
                        "id": 104864,
                        "name": "Conchagua",
                        "latitude": "13.30778000",
                        "longitude": "-87.86472000"
                    },
                    {
                        "id": 104876,
                        "name": "Intipucá",
                        "latitude": "13.19694000",
                        "longitude": "-88.05444000"
                    },
                    {
                        "id": 104885,
                        "name": "La Unión",
                        "latitude": "13.33694000",
                        "longitude": "-87.84389000"
                    },
                    {
                        "id": 104892,
                        "name": "Nueva Esparta",
                        "latitude": "13.78361000",
                        "longitude": "-87.83861000"
                    },
                    {
                        "id": 104898,
                        "name": "Pasaquina",
                        "latitude": "13.58444000",
                        "longitude": "-87.84111000"
                    },
                    {
                        "id": 104903,
                        "name": "San Alejo",
                        "latitude": "13.43139000",
                        "longitude": "-87.96306000"
                    },
                    {
                        "id": 104919,
                        "name": "Santa Rosa de Lima",
                        "latitude": "13.62472000",
                        "longitude": "-87.89361000"
                    }
                ]
            },
            {
                "id": 4130,
                "name": "Morazán",
                "iso2": "MO",
                "latitude": "13.76820000",
                "longitude": "-88.12913870",
                "type": "department",
                "cities": [
                    {
                        "id": 104851,
                        "name": "Cacaopera",
                        "latitude": "13.76667000",
                        "longitude": "-88.08333000"
                    },
                    {
                        "id": 104865,
                        "name": "Corinto",
                        "latitude": "13.81083000",
                        "longitude": "-87.97139000"
                    },
                    {
                        "id": 104872,
                        "name": "Guatajiagua",
                        "latitude": "13.66667000",
                        "longitude": "-88.20000000"
                    },
                    {
                        "id": 104879,
                        "name": "Jocoro",
                        "latitude": "13.61667000",
                        "longitude": "-88.01667000"
                    },
                    {
                        "id": 104905,
                        "name": "San Francisco",
                        "latitude": "13.70000000",
                        "longitude": "-88.10000000"
                    },
                    {
                        "id": 104926,
                        "name": "Sociedad",
                        "latitude": "13.70000000",
                        "longitude": "-88.01667000"
                    }
                ]
            },
            {
                "id": 4135,
                "name": "San Miguel",
                "iso2": "SM",
                "latitude": "13.44510410",
                "longitude": "-88.24611830",
                "type": "department",
                "cities": [
                    {
                        "id": 104855,
                        "name": "Chapeltique",
                        "latitude": "13.63333000",
                        "longitude": "-88.26667000"
                    },
                    {
                        "id": 104856,
                        "name": "Chinameca",
                        "latitude": "13.50000000",
                        "longitude": "-88.35000000"
                    },
                    {
                        "id": 104857,
                        "name": "Chirilagua",
                        "latitude": "13.22028000",
                        "longitude": "-88.13861000"
                    },
                    {
                        "id": 104859,
                        "name": "Ciudad Barrios",
                        "latitude": "13.76667000",
                        "longitude": "-88.26667000"
                    },
                    {
                        "id": 104871,
                        "name": "El Tránsito",
                        "latitude": "13.35000000",
                        "longitude": "-88.35000000"
                    },
                    {
                        "id": 104886,
                        "name": "Lolotique",
                        "latitude": "13.55000000",
                        "longitude": "-88.35000000"
                    },
                    {
                        "id": 104889,
                        "name": "Moncagua",
                        "latitude": "13.53333000",
                        "longitude": "-88.25000000"
                    },
                    {
                        "id": 104893,
                        "name": "Nueva Guadalupe",
                        "latitude": "13.53333000",
                        "longitude": "-88.35000000"
                    },
                    {
                        "id": 104910,
                        "name": "San Miguel",
                        "latitude": "13.48333000",
                        "longitude": "-88.18333000"
                    },
                    {
                        "id": 104913,
                        "name": "San Rafael Oriente",
                        "latitude": "13.38333000",
                        "longitude": "-88.35000000"
                    },
                    {
                        "id": 104925,
                        "name": "Sesori",
                        "latitude": "13.71667000",
                        "longitude": "-88.36667000"
                    }
                ]
            },
            {
                "id": 4133,
                "name": "San Salvador",
                "iso2": "SS",
                "latitude": "13.77399970",
                "longitude": "-89.20867730",
                "type": "department",
                "cities": [
                    {
                        "id": 104841,
                        "name": "Aguilares",
                        "latitude": "13.95722000",
                        "longitude": "-89.18972000"
                    },
                    {
                        "id": 104846,
                        "name": "Apopa",
                        "latitude": "13.80722000",
                        "longitude": "-89.17917000"
                    },
                    {
                        "id": 104849,
                        "name": "Ayutuxtepeque",
                        "latitude": "13.74556000",
                        "longitude": "-89.20639000"
                    },
                    {
                        "id": 104866,
                        "name": "Cuscatancingo",
                        "latitude": "13.73611000",
                        "longitude": "-89.18139000"
                    },
                    {
                        "id": 104867,
                        "name": "Delgado",
                        "latitude": "13.72417000",
                        "longitude": "-89.17028000"
                    },
                    {
                        "id": 104869,
                        "name": "El Paisnal",
                        "latitude": "13.97361000",
                        "longitude": "-89.21861000"
                    },
                    {
                        "id": 104874,
                        "name": "Guazapa",
                        "latitude": "13.87694000",
                        "longitude": "-89.17306000"
                    },
                    {
                        "id": 104875,
                        "name": "Ilopango",
                        "latitude": "13.70167000",
                        "longitude": "-89.10944000"
                    },
                    {
                        "id": 104887,
                        "name": "Mejicanos",
                        "latitude": "13.74028000",
                        "longitude": "-89.21306000"
                    },
                    {
                        "id": 104897,
                        "name": "Panchimalco",
                        "latitude": "13.61278000",
                        "longitude": "-89.18000000"
                    },
                    {
                        "id": 104901,
                        "name": "Rosario de Mora",
                        "latitude": "13.57528000",
                        "longitude": "-89.20889000"
                    },
                    {
                        "id": 104908,
                        "name": "San Marcos",
                        "latitude": "13.65889000",
                        "longitude": "-89.18306000"
                    },
                    {
                        "id": 104914,
                        "name": "San Salvador",
                        "latitude": "13.68935000",
                        "longitude": "-89.18718000"
                    },
                    {
                        "id": 104923,
                        "name": "Santo Tomás",
                        "latitude": "13.64083000",
                        "longitude": "-89.13333000"
                    },
                    {
                        "id": 104929,
                        "name": "Soyapango",
                        "latitude": "13.71024000",
                        "longitude": "-89.13989000"
                    },
                    {
                        "id": 104935,
                        "name": "Tonacatepeque",
                        "latitude": "13.78111000",
                        "longitude": "-89.11861000"
                    }
                ]
            },
            {
                "id": 4127,
                "name": "San Vicente",
                "iso2": "SV",
                "latitude": "13.58685610",
                "longitude": "-88.74939980",
                "type": "department",
                "cities": [
                    {
                        "id": 104845,
                        "name": "Apastepeque",
                        "latitude": "13.66667000",
                        "longitude": "-88.78333000"
                    },
                    {
                        "id": 104915,
                        "name": "San Sebastián",
                        "latitude": "13.73333000",
                        "longitude": "-88.83333000"
                    },
                    {
                        "id": 104916,
                        "name": "San Vicente",
                        "latitude": "13.63333000",
                        "longitude": "-88.80000000"
                    }
                ]
            },
            {
                "id": 4128,
                "name": "Santa Ana",
                "iso2": "SA",
                "latitude": "14.14611210",
                "longitude": "-89.51200840",
                "type": "department",
                "cities": [
                    {
                        "id": 104852,
                        "name": "Candelaria de La Frontera",
                        "latitude": "14.11667000",
                        "longitude": "-89.65000000"
                    },
                    {
                        "id": 104854,
                        "name": "Chalchuapa",
                        "latitude": "13.98667000",
                        "longitude": "-89.68111000"
                    },
                    {
                        "id": 104860,
                        "name": "Coatepeque",
                        "latitude": "13.92861000",
                        "longitude": "-89.50417000"
                    },
                    {
                        "id": 104868,
                        "name": "El Congo",
                        "latitude": "13.90889000",
                        "longitude": "-89.49583000"
                    },
                    {
                        "id": 104888,
                        "name": "Metapán",
                        "latitude": "14.33333000",
                        "longitude": "-89.45000000"
                    },
                    {
                        "id": 104917,
                        "name": "Santa Ana",
                        "latitude": "13.99417000",
                        "longitude": "-89.55972000"
                    },
                    {
                        "id": 104934,
                        "name": "Texistepeque",
                        "latitude": "14.13333000",
                        "longitude": "-89.50000000"
                    }
                ]
            },
            {
                "id": 4140,
                "name": "Sonsonate",
                "iso2": "SO",
                "latitude": "13.68235800",
                "longitude": "-89.66281110",
                "type": "department",
                "cities": [
                    {
                        "id": 104840,
                        "name": "Acajutla",
                        "latitude": "13.59278000",
                        "longitude": "-89.82750000"
                    },
                    {
                        "id": 104847,
                        "name": "Armenia",
                        "latitude": "13.74361000",
                        "longitude": "-89.49889000"
                    },
                    {
                        "id": 104877,
                        "name": "Izalco",
                        "latitude": "13.74472000",
                        "longitude": "-89.67306000"
                    },
                    {
                        "id": 104880,
                        "name": "Juayúa",
                        "latitude": "13.84139000",
                        "longitude": "-89.74556000"
                    },
                    {
                        "id": 104890,
                        "name": "Nahuizalco",
                        "latitude": "13.77750000",
                        "longitude": "-89.73667000"
                    },
                    {
                        "id": 104904,
                        "name": "San Antonio del Monte",
                        "latitude": "13.71639000",
                        "longitude": "-89.73833000"
                    },
                    {
                        "id": 104927,
                        "name": "Sonsonate",
                        "latitude": "13.71889000",
                        "longitude": "-89.72417000"
                    },
                    {
                        "id": 104928,
                        "name": "Sonzacate",
                        "latitude": "13.73417000",
                        "longitude": "-89.71472000"
                    }
                ]
            },
            {
                "id": 4129,
                "name": "Usulután",
                "iso2": "US",
                "latitude": "13.44706340",
                "longitude": "-88.55653100",
                "type": "department",
                "cities": [
                    {
                        "id": 104850,
                        "name": "Berlín",
                        "latitude": "13.50000000",
                        "longitude": "-88.53333000"
                    },
                    {
                        "id": 104862,
                        "name": "Concepción Batres",
                        "latitude": "13.35000000",
                        "longitude": "-88.36667000"
                    },
                    {
                        "id": 104878,
                        "name": "Jiquilisco",
                        "latitude": "13.31667000",
                        "longitude": "-88.58333000"
                    },
                    {
                        "id": 104881,
                        "name": "Jucuapa",
                        "latitude": "13.51667000",
                        "longitude": "-88.38333000"
                    },
                    {
                        "id": 104882,
                        "name": "Jucuarán",
                        "latitude": "13.25389000",
                        "longitude": "-88.24778000"
                    },
                    {
                        "id": 104896,
                        "name": "Ozatlán",
                        "latitude": "13.38333000",
                        "longitude": "-88.50000000"
                    },
                    {
                        "id": 104899,
                        "name": "Puerto El Triunfo",
                        "latitude": "13.28333000",
                        "longitude": "-88.55000000"
                    },
                    {
                        "id": 104902,
                        "name": "San Agustín",
                        "latitude": "13.43333000",
                        "longitude": "-88.60000000"
                    },
                    {
                        "id": 104918,
                        "name": "Santa Elena",
                        "latitude": "13.38333000",
                        "longitude": "-88.41667000"
                    },
                    {
                        "id": 104922,
                        "name": "Santiago de María",
                        "latitude": "13.48333000",
                        "longitude": "-88.46667000"
                    },
                    {
                        "id": 104936,
                        "name": "Usulután",
                        "latitude": "13.35000000",
                        "longitude": "-88.45000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 67,
        "name": "Equatorial Guinea",
        "iso3": "GNQ",
        "iso2": "GQ",
        "numeric_code": "226",
        "phonecode": "240",
        "capital": "Malabo",
        "currency": "XAF",
        "currency_name": "Central African CFA franc",
        "currency_symbol": "FCFA",
        "tld": ".gq",
        "native": "Guinea Ecuatorial",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Middle Africa",
        "subregion_id": 2,
        "nationality": "Equatorial Guinean, Equatoguinean",
        "timezones": [
            {
                "zoneName": "Africa\/Malabo",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "br": "Ginea ar C'heheder",
            "ko": "적도 기니",
            "pt-BR": "Guiné Equatorial",
            "pt": "Guiné Equatorial",
            "nl": "Equatoriaal-Guinea",
            "hr": "Ekvatorijalna Gvineja",
            "fa": "گینه استوایی",
            "de": "Äquatorial-Guinea",
            "es": "Guinea Ecuatorial",
            "fr": "Guinée-Équatoriale",
            "ja": "赤道ギニア",
            "it": "Guinea Equatoriale",
            "zh-CN": "赤道几内亚",
            "tr": "Ekvator Ginesi",
            "ru": "Экваториальная Гвинея",
            "uk": "Екваторіальна Гвінея",
            "pl": "Gwinea Równikowa"
        },
        "latitude": "2.00000000",
        "longitude": "10.00000000",
        "emoji": "🇬🇶",
        "emojiU": "U+1F1EC U+1F1F6",
        "states": [
            {
                "id": 3444,
                "name": "Annobón",
                "iso2": "AN",
                "latitude": "-1.42687820",
                "longitude": "5.63528010",
                "type": "province",
                "cities": [
                    {
                        "id": 52397,
                        "name": "San Antonio de Palé",
                        "latitude": "-1.40680000",
                        "longitude": "5.63178000"
                    }
                ]
            },
            {
                "id": 3446,
                "name": "Bioko Norte",
                "iso2": "BN",
                "latitude": "3.65950720",
                "longitude": "8.79218360",
                "type": "province",
                "cities": [
                    {
                        "id": 52387,
                        "name": "Malabo",
                        "latitude": "3.75578000",
                        "longitude": "8.78166000"
                    },
                    {
                        "id": 52395,
                        "name": "Rebola",
                        "latitude": "3.71667000",
                        "longitude": "8.83333000"
                    },
                    {
                        "id": 52398,
                        "name": "Santiago de Baney",
                        "latitude": "3.69920000",
                        "longitude": "8.90840000"
                    }
                ]
            },
            {
                "id": 3443,
                "name": "Bioko Sur",
                "iso2": "BS",
                "latitude": "3.42097850",
                "longitude": "8.61606740",
                "type": "province",
                "cities": [
                    {
                        "id": 52385,
                        "name": "Luba",
                        "latitude": "3.45683000",
                        "longitude": "8.55465000"
                    }
                ]
            },
            {
                "id": 3445,
                "name": "Centro Sur",
                "iso2": "CS",
                "latitude": "1.34360840",
                "longitude": "10.43965600",
                "type": "province",
                "cities": [
                    {
                        "id": 52376,
                        "name": "Acurenam",
                        "latitude": "1.03225000",
                        "longitude": "10.64882000"
                    },
                    {
                        "id": 52380,
                        "name": "Bicurga",
                        "latitude": "1.58113000",
                        "longitude": "10.46716000"
                    },
                    {
                        "id": 52384,
                        "name": "Evinayong",
                        "latitude": "1.43677000",
                        "longitude": "10.55124000"
                    }
                ]
            },
            {
                "id": 3442,
                "name": "Insular",
                "iso2": "I",
                "latitude": "37.09024000",
                "longitude": "-95.71289100",
                "type": "region",
                "cities": []
            },
            {
                "id": 3439,
                "name": "Kié-Ntem",
                "iso2": "KN",
                "latitude": "2.02809300",
                "longitude": "11.07117580",
                "type": "province",
                "cities": [
                    {
                        "id": 52383,
                        "name": "Ebebiyin",
                        "latitude": "2.15106000",
                        "longitude": "11.33528000"
                    },
                    {
                        "id": 52390,
                        "name": "Mikomeseng",
                        "latitude": "2.13609000",
                        "longitude": "10.61322000"
                    },
                    {
                        "id": 52392,
                        "name": "Ncue",
                        "latitude": "2.01643000",
                        "longitude": "10.47066000"
                    },
                    {
                        "id": 52393,
                        "name": "Nsang",
                        "latitude": "2.02475000",
                        "longitude": "10.94599000"
                    }
                ]
            },
            {
                "id": 3441,
                "name": "Litoral",
                "iso2": "LI",
                "latitude": "1.57502440",
                "longitude": "9.81249350",
                "type": "province",
                "cities": [
                    {
                        "id": 52379,
                        "name": "Bata",
                        "latitude": "1.86391000",
                        "longitude": "9.76582000"
                    },
                    {
                        "id": 52381,
                        "name": "Bitica",
                        "latitude": "1.42610000",
                        "longitude": "9.62316000"
                    },
                    {
                        "id": 52382,
                        "name": "Cogo",
                        "latitude": "1.08425000",
                        "longitude": "9.69300000"
                    },
                    {
                        "id": 52386,
                        "name": "Machinda",
                        "latitude": "1.88262000",
                        "longitude": "9.95133000"
                    },
                    {
                        "id": 52388,
                        "name": "Mbini",
                        "latitude": "1.58267000",
                        "longitude": "9.61478000"
                    },
                    {
                        "id": 52396,
                        "name": "Río Campo",
                        "latitude": "2.33812000",
                        "longitude": "9.82212000"
                    }
                ]
            },
            {
                "id": 3438,
                "name": "Río Muni",
                "iso2": "C",
                "latitude": "1.46106060",
                "longitude": "9.67868940",
                "type": "region",
                "cities": []
            },
            {
                "id": 3440,
                "name": "Wele-Nzas",
                "iso2": "WN",
                "latitude": "1.41661620",
                "longitude": "11.07117580",
                "type": "province",
                "cities": [
                    {
                        "id": 52375,
                        "name": "Aconibe",
                        "latitude": "1.29683000",
                        "longitude": "10.93691000"
                    },
                    {
                        "id": 52378,
                        "name": "Añisoc",
                        "latitude": "1.86580000",
                        "longitude": "10.76892000"
                    },
                    {
                        "id": 52377,
                        "name": "Ayene",
                        "latitude": "1.85592000",
                        "longitude": "10.68994000"
                    },
                    {
                        "id": 52389,
                        "name": "Mengomeyén",
                        "latitude": "1.69439000",
                        "longitude": "11.03422000"
                    },
                    {
                        "id": 52391,
                        "name": "Mongomo",
                        "latitude": "1.62742000",
                        "longitude": "11.31346000"
                    },
                    {
                        "id": 52394,
                        "name": "Nsok",
                        "latitude": "1.12985000",
                        "longitude": "11.26603000"
                    }
                ]
            }
        ]
    },
    {
        "id": 68,
        "name": "Eritrea",
        "iso3": "ERI",
        "iso2": "ER",
        "numeric_code": "232",
        "phonecode": "291",
        "capital": "Asmara",
        "currency": "ERN",
        "currency_name": "Eritrean nakfa",
        "currency_symbol": "Nfk",
        "tld": ".er",
        "native": "ኤርትራ",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Eritrean",
        "timezones": [
            {
                "zoneName": "Africa\/Asmara",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Eritrea",
            "ko": "에리트레아",
            "pt-BR": "Eritreia",
            "pt": "Eritreia",
            "nl": "Eritrea",
            "hr": "Eritreja",
            "fa": "اریتره",
            "de": "Eritrea",
            "es": "Eritrea",
            "fr": "Érythrée",
            "ja": "エリトリア",
            "it": "Eritrea",
            "zh-CN": "厄立特里亚",
            "tr": "Eritre",
            "ru": "Эритрея",
            "uk": "Еритрея",
            "pl": "Erytrea"
        },
        "latitude": "15.00000000",
        "longitude": "39.00000000",
        "emoji": "🇪🇷",
        "emojiU": "U+1F1EA U+1F1F7",
        "states": [
            {
                "id": 3425,
                "name": "Anseba",
                "iso2": "AN",
                "latitude": "16.47455310",
                "longitude": "37.80876930",
                "type": "region",
                "cities": [
                    {
                        "id": 31888,
                        "name": "Keren",
                        "latitude": "15.77792000",
                        "longitude": "38.45107000"
                    }
                ]
            },
            {
                "id": 3427,
                "name": "Debub",
                "iso2": "DU",
                "latitude": "14.94786920",
                "longitude": "39.15436770",
                "type": "region",
                "cities": [
                    {
                        "id": 31881,
                        "name": "Adi Keyh",
                        "latitude": "14.84444000",
                        "longitude": "39.37722000"
                    },
                    {
                        "id": 31886,
                        "name": "Dek’emhāre",
                        "latitude": "15.07000000",
                        "longitude": "39.04750000"
                    },
                    {
                        "id": 31890,
                        "name": "Mendefera",
                        "latitude": "14.88722000",
                        "longitude": "38.81528000"
                    }
                ]
            },
            {
                "id": 3428,
                "name": "Gash-Barka",
                "iso2": "GB",
                "latitude": "15.40688250",
                "longitude": "37.63866220",
                "type": "region",
                "cities": [
                    {
                        "id": 31882,
                        "name": "Ak’ordat",
                        "latitude": "15.54798000",
                        "longitude": "37.88291000"
                    },
                    {
                        "id": 31885,
                        "name": "Barentu",
                        "latitude": "15.10582000",
                        "longitude": "37.59067000"
                    },
                    {
                        "id": 31891,
                        "name": "Teseney",
                        "latitude": "15.11000000",
                        "longitude": "36.65750000"
                    }
                ]
            },
            {
                "id": 3426,
                "name": "Maekel",
                "iso2": "MA",
                "latitude": "15.35514090",
                "longitude": "38.86236830",
                "type": "region",
                "cities": [
                    {
                        "id": 31883,
                        "name": "Asmara",
                        "latitude": "15.33805000",
                        "longitude": "38.93184000"
                    }
                ]
            },
            {
                "id": 3424,
                "name": "Northern Red Sea",
                "iso2": "SK",
                "latitude": "16.25839970",
                "longitude": "38.82054540",
                "type": "region",
                "cities": [
                    {
                        "id": 31889,
                        "name": "Massawa",
                        "latitude": "15.60811000",
                        "longitude": "39.47455000"
                    }
                ]
            },
            {
                "id": 3429,
                "name": "Southern Red Sea",
                "iso2": "DK",
                "latitude": "13.51371030",
                "longitude": "41.76064720",
                "type": "region",
                "cities": [
                    {
                        "id": 31884,
                        "name": "Assab",
                        "latitude": "13.00917000",
                        "longitude": "42.73944000"
                    },
                    {
                        "id": 31887,
                        "name": "Edd",
                        "latitude": "13.93088000",
                        "longitude": "41.69380000"
                    }
                ]
            }
        ]
    },
    {
        "id": 69,
        "name": "Estonia",
        "iso3": "EST",
        "iso2": "EE",
        "numeric_code": "233",
        "phonecode": "372",
        "capital": "Tallinn",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".ee",
        "native": "Eesti",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Estonian",
        "timezones": [
            {
                "zoneName": "Europe\/Tallinn",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Estonia",
            "ko": "에스토니아",
            "pt-BR": "Estônia",
            "pt": "Estónia",
            "nl": "Estland",
            "hr": "Estonija",
            "fa": "استونی",
            "de": "Estland",
            "es": "Estonia",
            "fr": "Estonie",
            "ja": "エストニア",
            "it": "Estonia",
            "zh-CN": "爱沙尼亚",
            "tr": "Estonya",
            "ru": "Эстония",
            "uk": "Естонія",
            "pl": "Estonia"
        },
        "latitude": "59.00000000",
        "longitude": "26.00000000",
        "emoji": "🇪🇪",
        "emojiU": "U+1F1EA U+1F1EA",
        "states": [
            {
                "id": 3567,
                "name": "Harju",
                "iso2": "37",
                "latitude": "59.33342390",
                "longitude": "25.24669740",
                "type": "county",
                "cities": [
                    {
                        "id": 31595,
                        "name": "Anija vald",
                        "latitude": "59.27644000",
                        "longitude": "25.48168000"
                    },
                    {
                        "id": 31598,
                        "name": "Aruküla",
                        "latitude": "59.36686000",
                        "longitude": "25.07618000"
                    },
                    {
                        "id": 31602,
                        "name": "Haabneeme",
                        "latitude": "59.51358000",
                        "longitude": "24.82225000"
                    },
                    {
                        "id": 31607,
                        "name": "Harku",
                        "latitude": "59.38641000",
                        "longitude": "24.57176000"
                    },
                    {
                        "id": 31608,
                        "name": "Harku vald",
                        "latitude": "59.39157000",
                        "longitude": "24.46206000"
                    },
                    {
                        "id": 31613,
                        "name": "Jõelähtme vald",
                        "latitude": "59.43996000",
                        "longitude": "25.13535000"
                    },
                    {
                        "id": 31618,
                        "name": "Jüri",
                        "latitude": "59.35417000",
                        "longitude": "24.89417000"
                    },
                    {
                        "id": 31626,
                        "name": "Kehra",
                        "latitude": "59.33611000",
                        "longitude": "25.32111000"
                    },
                    {
                        "id": 31629,
                        "name": "Keila",
                        "latitude": "59.30361000",
                        "longitude": "24.41306000"
                    },
                    {
                        "id": 31631,
                        "name": "Kiili",
                        "latitude": "59.30775000",
                        "longitude": "24.83776000"
                    },
                    {
                        "id": 31632,
                        "name": "Kiili vald",
                        "latitude": "59.29672000",
                        "longitude": "24.85292000"
                    },
                    {
                        "id": 31640,
                        "name": "Kose",
                        "latitude": "59.46001000",
                        "longitude": "24.87824000"
                    },
                    {
                        "id": 31644,
                        "name": "Kuusalu",
                        "latitude": "59.44389000",
                        "longitude": "25.44139000"
                    },
                    {
                        "id": 31647,
                        "name": "Laagri",
                        "latitude": "59.35083000",
                        "longitude": "24.61418000"
                    },
                    {
                        "id": 31651,
                        "name": "Loksa",
                        "latitude": "59.57639000",
                        "longitude": "25.72139000"
                    },
                    {
                        "id": 31652,
                        "name": "Loksa linn",
                        "latitude": "59.57844000",
                        "longitude": "25.71667000"
                    },
                    {
                        "id": 31653,
                        "name": "Loo",
                        "latitude": "59.43123000",
                        "longitude": "24.94949000"
                    },
                    {
                        "id": 31658,
                        "name": "Maardu",
                        "latitude": "59.46529000",
                        "longitude": "24.98215000"
                    },
                    {
                        "id": 31659,
                        "name": "Maardu linn",
                        "latitude": "59.46385000",
                        "longitude": "24.97350000"
                    },
                    {
                        "id": 31676,
                        "name": "Paldiski",
                        "latitude": "59.35667000",
                        "longitude": "24.05306000"
                    },
                    {
                        "id": 31678,
                        "name": "Pringi",
                        "latitude": "59.53459000",
                        "longitude": "24.79726000"
                    },
                    {
                        "id": 31688,
                        "name": "Raasiku",
                        "latitude": "59.36639000",
                        "longitude": "25.18306000"
                    },
                    {
                        "id": 31689,
                        "name": "Rae vald",
                        "latitude": "59.33202000",
                        "longitude": "24.93932000"
                    },
                    {
                        "id": 31695,
                        "name": "Riisipere",
                        "latitude": "59.11417000",
                        "longitude": "24.31056000"
                    },
                    {
                        "id": 31698,
                        "name": "Rummu",
                        "latitude": "59.53528000",
                        "longitude": "24.79972000"
                    },
                    {
                        "id": 31704,
                        "name": "Saku",
                        "latitude": "59.30354000",
                        "longitude": "24.66382000"
                    },
                    {
                        "id": 31705,
                        "name": "Saku vald",
                        "latitude": "59.28069000",
                        "longitude": "24.71649000"
                    },
                    {
                        "id": 31706,
                        "name": "Saue",
                        "latitude": "59.32258000",
                        "longitude": "24.54967000"
                    },
                    {
                        "id": 31707,
                        "name": "Saue vald",
                        "latitude": "59.29255000",
                        "longitude": "24.52503000"
                    },
                    {
                        "id": 31714,
                        "name": "Tabasalu",
                        "latitude": "59.42607000",
                        "longitude": "24.55330000"
                    },
                    {
                        "id": 31716,
                        "name": "Tallinn",
                        "latitude": "59.43696000",
                        "longitude": "24.75353000"
                    },
                    {
                        "id": 31727,
                        "name": "Turba",
                        "latitude": "59.08306000",
                        "longitude": "24.22500000"
                    },
                    {
                        "id": 31734,
                        "name": "Vaida",
                        "latitude": "59.28546000",
                        "longitude": "24.97897000"
                    },
                    {
                        "id": 31737,
                        "name": "Viimsi",
                        "latitude": "59.50502000",
                        "longitude": "24.84807000"
                    },
                    {
                        "id": 31738,
                        "name": "Viimsi vald",
                        "latitude": "59.50204000",
                        "longitude": "24.84833000"
                    }
                ]
            },
            {
                "id": 3555,
                "name": "Hiiu",
                "iso2": "39",
                "latitude": "58.92395530",
                "longitude": "22.59194680",
                "type": "county",
                "cities": [
                    {
                        "id": 31645,
                        "name": "Kärdla",
                        "latitude": "58.99778000",
                        "longitude": "22.74917000"
                    }
                ]
            },
            {
                "id": 3569,
                "name": "Ida-Viru",
                "iso2": "44",
                "latitude": "59.25926630",
                "longitude": "27.41365350",
                "type": "county",
                "cities": [
                    {
                        "id": 31610,
                        "name": "Iisaku",
                        "latitude": "59.10139000",
                        "longitude": "27.30806000"
                    },
                    {
                        "id": 31616,
                        "name": "Jõhvi",
                        "latitude": "59.35917000",
                        "longitude": "27.42111000"
                    },
                    {
                        "id": 31617,
                        "name": "Jõhvi vald",
                        "latitude": "59.35653000",
                        "longitude": "27.39304000"
                    },
                    {
                        "id": 31634,
                        "name": "Kiviõli",
                        "latitude": "59.35306000",
                        "longitude": "26.97111000"
                    },
                    {
                        "id": 31638,
                        "name": "Kohtla-Järve",
                        "latitude": "59.39861000",
                        "longitude": "27.27306000"
                    },
                    {
                        "id": 31639,
                        "name": "Kohtla-Nõmme",
                        "latitude": "59.35167000",
                        "longitude": "27.17500000"
                    },
                    {
                        "id": 31657,
                        "name": "Lüganuse vald",
                        "latitude": "59.39262000",
                        "longitude": "27.07641000"
                    },
                    {
                        "id": 31665,
                        "name": "Narva",
                        "latitude": "59.37722000",
                        "longitude": "28.19028000"
                    },
                    {
                        "id": 31666,
                        "name": "Narva-Jõesuu",
                        "latitude": "59.45889000",
                        "longitude": "28.04083000"
                    },
                    {
                        "id": 31667,
                        "name": "Narva-Jõesuu linn",
                        "latitude": "59.44127000",
                        "longitude": "28.02142000"
                    },
                    {
                        "id": 31687,
                        "name": "Püssi",
                        "latitude": "59.36000000",
                        "longitude": "27.04972000"
                    },
                    {
                        "id": 31709,
                        "name": "Sillamäe",
                        "latitude": "59.39697000",
                        "longitude": "27.76331000"
                    },
                    {
                        "id": 31724,
                        "name": "Toila",
                        "latitude": "59.42127000",
                        "longitude": "27.50807000"
                    },
                    {
                        "id": 31745,
                        "name": "Voka",
                        "latitude": "59.40776000",
                        "longitude": "27.58263000"
                    }
                ]
            },
            {
                "id": 3566,
                "name": "Järva",
                "iso2": "51",
                "latitude": "58.88667130",
                "longitude": "25.50006240",
                "type": "county",
                "cities": [
                    {
                        "id": 31611,
                        "name": "Järva-Jaani",
                        "latitude": "59.03861000",
                        "longitude": "25.88639000"
                    },
                    {
                        "id": 31635,
                        "name": "Koeru",
                        "latitude": "58.96306000",
                        "longitude": "26.03083000"
                    },
                    {
                        "id": 31672,
                        "name": "Paide",
                        "latitude": "58.88556000",
                        "longitude": "25.55722000"
                    },
                    {
                        "id": 31673,
                        "name": "Paide linn",
                        "latitude": "58.88504000",
                        "longitude": "25.56021000"
                    },
                    {
                        "id": 31712,
                        "name": "Särevere",
                        "latitude": "58.79000000",
                        "longitude": "25.42806000"
                    },
                    {
                        "id": 31729,
                        "name": "Türi",
                        "latitude": "58.80861000",
                        "longitude": "25.43250000"
                    },
                    {
                        "id": 31730,
                        "name": "Türi vald",
                        "latitude": "58.74143000",
                        "longitude": "25.46443000"
                    }
                ]
            },
            {
                "id": 3565,
                "name": "Jõgeva",
                "iso2": "49",
                "latitude": "58.75061430",
                "longitude": "26.36048780",
                "type": "county",
                "cities": [
                    {
                        "id": 31614,
                        "name": "Jõgeva",
                        "latitude": "58.74667000",
                        "longitude": "26.39389000"
                    },
                    {
                        "id": 31615,
                        "name": "Jõgeva vald",
                        "latitude": "58.78732000",
                        "longitude": "26.38122000"
                    },
                    {
                        "id": 31661,
                        "name": "Mustvee",
                        "latitude": "58.84861000",
                        "longitude": "26.93972000"
                    },
                    {
                        "id": 31683,
                        "name": "Põltsamaa",
                        "latitude": "58.65250000",
                        "longitude": "25.97056000"
                    },
                    {
                        "id": 31684,
                        "name": "Põltsamaa vald",
                        "latitude": "58.64067000",
                        "longitude": "26.00957000"
                    }
                ]
            },
            {
                "id": 3568,
                "name": "Lääne",
                "iso2": "57",
                "latitude": "58.97227420",
                "longitude": "23.87408340",
                "type": "county",
                "cities": [
                    {
                        "id": 31603,
                        "name": "Haapsalu",
                        "latitude": "58.94306000",
                        "longitude": "23.54139000"
                    },
                    {
                        "id": 31604,
                        "name": "Haapsalu linn",
                        "latitude": "58.93580000",
                        "longitude": "23.53005000"
                    },
                    {
                        "id": 31609,
                        "name": "Hullo",
                        "latitude": "58.99004000",
                        "longitude": "23.24441000"
                    },
                    {
                        "id": 31656,
                        "name": "Lääne-Nigula vald",
                        "latitude": "58.96045000",
                        "longitude": "23.74489000"
                    },
                    {
                        "id": 31715,
                        "name": "Taebla",
                        "latitude": "58.95389000",
                        "longitude": "23.75222000"
                    },
                    {
                        "id": 31731,
                        "name": "Uuemõisa",
                        "latitude": "58.93944000",
                        "longitude": "23.58944000"
                    },
                    {
                        "id": 31746,
                        "name": "Vormsi vald",
                        "latitude": "58.99986000",
                        "longitude": "23.23408000"
                    }
                ]
            },
            {
                "id": 3564,
                "name": "Lääne-Viru",
                "iso2": "59",
                "latitude": "59.30188160",
                "longitude": "26.32803120",
                "type": "county",
                "cities": [
                    {
                        "id": 31599,
                        "name": "Aseri",
                        "latitude": "59.45056000",
                        "longitude": "26.86750000"
                    },
                    {
                        "id": 31605,
                        "name": "Haljala",
                        "latitude": "59.43361000",
                        "longitude": "26.26139000"
                    },
                    {
                        "id": 31606,
                        "name": "Haljala vald",
                        "latitude": "59.45427000",
                        "longitude": "26.22015000"
                    },
                    {
                        "id": 31619,
                        "name": "Kadrina",
                        "latitude": "59.33472000",
                        "longitude": "26.14500000"
                    },
                    {
                        "id": 31620,
                        "name": "Kadrina vald",
                        "latitude": "59.37463000",
                        "longitude": "26.04150000"
                    },
                    {
                        "id": 31641,
                        "name": "Kunda",
                        "latitude": "59.49861000",
                        "longitude": "26.52611000"
                    },
                    {
                        "id": 31675,
                        "name": "Pajusti",
                        "latitude": "59.27444000",
                        "longitude": "26.42333000"
                    },
                    {
                        "id": 31690,
                        "name": "Rakke",
                        "latitude": "58.98167000",
                        "longitude": "26.25444000"
                    },
                    {
                        "id": 31691,
                        "name": "Rakvere",
                        "latitude": "59.34639000",
                        "longitude": "26.35583000"
                    },
                    {
                        "id": 31692,
                        "name": "Rakvere vald",
                        "latitude": "59.32457000",
                        "longitude": "26.29757000"
                    },
                    {
                        "id": 31713,
                        "name": "Sõmeru",
                        "latitude": "59.36111000",
                        "longitude": "26.43750000"
                    },
                    {
                        "id": 31717,
                        "name": "Tamsalu",
                        "latitude": "59.15861000",
                        "longitude": "26.11528000"
                    },
                    {
                        "id": 31718,
                        "name": "Tapa",
                        "latitude": "59.26056000",
                        "longitude": "25.95861000"
                    },
                    {
                        "id": 31719,
                        "name": "Tapa vald",
                        "latitude": "59.23821000",
                        "longitude": "25.84572000"
                    },
                    {
                        "id": 31733,
                        "name": "Vaiatu",
                        "latitude": "59.35556000",
                        "longitude": "25.99528000"
                    },
                    {
                        "id": 31747,
                        "name": "Väike-Maarja",
                        "latitude": "59.12639000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 31748,
                        "name": "Väike-Maarja vald",
                        "latitude": "59.06556000",
                        "longitude": "26.31417000"
                    },
                    {
                        "id": 31742,
                        "name": "Vinni",
                        "latitude": "59.29583000",
                        "longitude": "26.43222000"
                    },
                    {
                        "id": 31743,
                        "name": "Vinni vald",
                        "latitude": "59.23744000",
                        "longitude": "26.62261000"
                    },
                    {
                        "id": 31744,
                        "name": "Viru-Nigula vald",
                        "latitude": "59.46387000",
                        "longitude": "26.58585000"
                    }
                ]
            },
            {
                "id": 3562,
                "name": "Pärnu",
                "iso2": "67",
                "latitude": "58.52619520",
                "longitude": "24.40201590",
                "type": "county",
                "cities": [
                    {
                        "id": 31600,
                        "name": "Audru",
                        "latitude": "58.40861000",
                        "longitude": "24.37389000"
                    },
                    {
                        "id": 31630,
                        "name": "Kihnu vald",
                        "latitude": "58.13000000",
                        "longitude": "23.99002000"
                    },
                    {
                        "id": 31633,
                        "name": "Kilingi-Nõmme",
                        "latitude": "58.15028000",
                        "longitude": "24.96417000"
                    },
                    {
                        "id": 31648,
                        "name": "Lihula",
                        "latitude": "58.68139000",
                        "longitude": "23.84528000"
                    },
                    {
                        "id": 31650,
                        "name": "Linaküla",
                        "latitude": "58.13722000",
                        "longitude": "23.97444000"
                    },
                    {
                        "id": 31674,
                        "name": "Paikuse",
                        "latitude": "58.37917000",
                        "longitude": "24.63444000"
                    },
                    {
                        "id": 31680,
                        "name": "Pärnu",
                        "latitude": "58.38588000",
                        "longitude": "24.49711000"
                    },
                    {
                        "id": 31681,
                        "name": "Pärnu linn",
                        "latitude": "58.37901000",
                        "longitude": "24.52784000"
                    },
                    {
                        "id": 31682,
                        "name": "Pärnu-Jaagupi",
                        "latitude": "58.61052000",
                        "longitude": "24.50689000"
                    },
                    {
                        "id": 31703,
                        "name": "Saarde vald",
                        "latitude": "58.13802000",
                        "longitude": "24.95564000"
                    },
                    {
                        "id": 31708,
                        "name": "Sauga",
                        "latitude": "58.42720000",
                        "longitude": "24.49496000"
                    },
                    {
                        "id": 31710,
                        "name": "Sindi",
                        "latitude": "58.40056000",
                        "longitude": "24.66750000"
                    },
                    {
                        "id": 31725,
                        "name": "Tootsi",
                        "latitude": "58.57806000",
                        "longitude": "24.79250000"
                    },
                    {
                        "id": 31726,
                        "name": "Tori vald",
                        "latitude": "58.48663000",
                        "longitude": "24.88961000"
                    },
                    {
                        "id": 31732,
                        "name": "Uulu",
                        "latitude": "58.28361000",
                        "longitude": "24.58722000"
                    },
                    {
                        "id": 31749,
                        "name": "Vändra",
                        "latitude": "58.64806000",
                        "longitude": "25.03611000"
                    }
                ]
            },
            {
                "id": 3563,
                "name": "Põlva",
                "iso2": "65",
                "latitude": "58.11606220",
                "longitude": "27.20663940",
                "type": "county",
                "cities": [
                    {
                        "id": 31623,
                        "name": "Kanepi",
                        "latitude": "57.98306000",
                        "longitude": "26.75639000"
                    },
                    {
                        "id": 31624,
                        "name": "Kanepi vald",
                        "latitude": "57.98058000",
                        "longitude": "26.76151000"
                    },
                    {
                        "id": 31685,
                        "name": "Põlva",
                        "latitude": "58.06028000",
                        "longitude": "27.06944000"
                    },
                    {
                        "id": 31686,
                        "name": "Põlva vald",
                        "latitude": "58.08368000",
                        "longitude": "26.98242000"
                    },
                    {
                        "id": 31699,
                        "name": "Räpina",
                        "latitude": "58.09806000",
                        "longitude": "27.46361000"
                    },
                    {
                        "id": 31700,
                        "name": "Räpina vald",
                        "latitude": "58.10777000",
                        "longitude": "27.38580000"
                    }
                ]
            },
            {
                "id": 3559,
                "name": "Rapla",
                "iso2": "70",
                "latitude": "58.84926250",
                "longitude": "24.73465690",
                "type": "county",
                "cities": [
                    {
                        "id": 31612,
                        "name": "Järvakandi",
                        "latitude": "58.77889000",
                        "longitude": "24.82583000"
                    },
                    {
                        "id": 31627,
                        "name": "Kehtna",
                        "latitude": "58.93028000",
                        "longitude": "24.87806000"
                    },
                    {
                        "id": 31628,
                        "name": "Kehtna vald",
                        "latitude": "58.84274000",
                        "longitude": "24.89002000"
                    },
                    {
                        "id": 31636,
                        "name": "Kohila",
                        "latitude": "59.16806000",
                        "longitude": "24.75750000"
                    },
                    {
                        "id": 31637,
                        "name": "Kohila vald",
                        "latitude": "59.15283000",
                        "longitude": "24.73337000"
                    },
                    {
                        "id": 31662,
                        "name": "Märjamaa",
                        "latitude": "58.90389000",
                        "longitude": "24.43056000"
                    },
                    {
                        "id": 31663,
                        "name": "Märjamaa vald",
                        "latitude": "58.90262000",
                        "longitude": "24.39423000"
                    },
                    {
                        "id": 31693,
                        "name": "Rapla",
                        "latitude": "59.00722000",
                        "longitude": "24.79278000"
                    },
                    {
                        "id": 31694,
                        "name": "Rapla vald",
                        "latitude": "59.03309000",
                        "longitude": "24.71793000"
                    }
                ]
            },
            {
                "id": 3561,
                "name": "Saare",
                "iso2": "74",
                "latitude": "58.48497210",
                "longitude": "22.61364080",
                "type": "county",
                "cities": [
                    {
                        "id": 31643,
                        "name": "Kuressaare",
                        "latitude": "58.24806000",
                        "longitude": "22.50389000"
                    },
                    {
                        "id": 31649,
                        "name": "Liiva",
                        "latitude": "58.60194000",
                        "longitude": "23.24694000"
                    },
                    {
                        "id": 31660,
                        "name": "Muhu vald",
                        "latitude": "58.58486000",
                        "longitude": "23.25609000"
                    },
                    {
                        "id": 31670,
                        "name": "Orissaare",
                        "latitude": "58.55917000",
                        "longitude": "23.08262000"
                    },
                    {
                        "id": 31696,
                        "name": "Ruhnu",
                        "latitude": "57.80028000",
                        "longitude": "23.24833000"
                    },
                    {
                        "id": 31697,
                        "name": "Ruhnu vald",
                        "latitude": "57.80309000",
                        "longitude": "23.24250000"
                    },
                    {
                        "id": 31723,
                        "name": "Tehumardi",
                        "latitude": "58.18027000",
                        "longitude": "22.24646000"
                    }
                ]
            },
            {
                "id": 3557,
                "name": "Tartu",
                "iso2": "78",
                "latitude": "58.40571280",
                "longitude": "26.80157600",
                "type": "county",
                "cities": [
                    {
                        "id": 31594,
                        "name": "Alatskivi",
                        "latitude": "58.59806000",
                        "longitude": "27.13361000"
                    },
                    {
                        "id": 31601,
                        "name": "Elva",
                        "latitude": "58.22250000",
                        "longitude": "26.42111000"
                    },
                    {
                        "id": 31621,
                        "name": "Kallaste",
                        "latitude": "58.66312000",
                        "longitude": "27.16164000"
                    },
                    {
                        "id": 31622,
                        "name": "Kambja vald",
                        "latitude": "58.20255000",
                        "longitude": "26.68996000"
                    },
                    {
                        "id": 31646,
                        "name": "Kõrveküla",
                        "latitude": "58.42417000",
                        "longitude": "26.78222000"
                    },
                    {
                        "id": 31642,
                        "name": "Kurepalu",
                        "latitude": "58.31861000",
                        "longitude": "26.84083000"
                    },
                    {
                        "id": 31654,
                        "name": "Luunja",
                        "latitude": "58.35583000",
                        "longitude": "26.88083000"
                    },
                    {
                        "id": 31655,
                        "name": "Luunja vald",
                        "latitude": "58.39178000",
                        "longitude": "26.95574000"
                    },
                    {
                        "id": 31668,
                        "name": "Nõo",
                        "latitude": "58.27556000",
                        "longitude": "26.53750000"
                    },
                    {
                        "id": 31669,
                        "name": "Nõo vald",
                        "latitude": "58.24199000",
                        "longitude": "26.52499000"
                    },
                    {
                        "id": 31677,
                        "name": "Peipsiääre vald",
                        "latitude": "58.51559000",
                        "longitude": "27.18444000"
                    },
                    {
                        "id": 31679,
                        "name": "Puhja",
                        "latitude": "58.34194000",
                        "longitude": "26.31472000"
                    },
                    {
                        "id": 31720,
                        "name": "Tartu",
                        "latitude": "58.38062000",
                        "longitude": "26.72509000"
                    },
                    {
                        "id": 31721,
                        "name": "Tartu linn",
                        "latitude": "58.37498000",
                        "longitude": "26.73256000"
                    },
                    {
                        "id": 31722,
                        "name": "Tartu vald",
                        "latitude": "58.47800000",
                        "longitude": "26.74956000"
                    },
                    {
                        "id": 31754,
                        "name": "Ülenurme",
                        "latitude": "58.31620000",
                        "longitude": "26.72517000"
                    }
                ]
            },
            {
                "id": 3558,
                "name": "Valga",
                "iso2": "82",
                "latitude": "57.91034410",
                "longitude": "26.16018190",
                "type": "county",
                "cities": [
                    {
                        "id": 31671,
                        "name": "Otepää vald",
                        "latitude": "58.02177000",
                        "longitude": "26.45306000"
                    },
                    {
                        "id": 31728,
                        "name": "Tõrva",
                        "latitude": "58.00278000",
                        "longitude": "25.93500000"
                    },
                    {
                        "id": 31735,
                        "name": "Valga",
                        "latitude": "57.77781000",
                        "longitude": "26.04730000"
                    }
                ]
            },
            {
                "id": 3556,
                "name": "Viljandi",
                "iso2": "84",
                "latitude": "58.28217460",
                "longitude": "25.57522330",
                "type": "county",
                "cities": [
                    {
                        "id": 31593,
                        "name": "Abja-Paluoja",
                        "latitude": "58.12528000",
                        "longitude": "25.34972000"
                    },
                    {
                        "id": 31625,
                        "name": "Karksi-Nuia",
                        "latitude": "58.10333000",
                        "longitude": "25.56278000"
                    },
                    {
                        "id": 31664,
                        "name": "Mõisaküla",
                        "latitude": "58.09222000",
                        "longitude": "25.18639000"
                    },
                    {
                        "id": 31711,
                        "name": "Suure-Jaani",
                        "latitude": "58.53611000",
                        "longitude": "25.47056000"
                    },
                    {
                        "id": 31739,
                        "name": "Viiratsi",
                        "latitude": "58.36000000",
                        "longitude": "25.63722000"
                    },
                    {
                        "id": 31740,
                        "name": "Viljandi",
                        "latitude": "58.36389000",
                        "longitude": "25.59000000"
                    },
                    {
                        "id": 31741,
                        "name": "Viljandi vald",
                        "latitude": "58.36392000",
                        "longitude": "25.49103000"
                    },
                    {
                        "id": 31751,
                        "name": "Võhma",
                        "latitude": "58.62833000",
                        "longitude": "25.54833000"
                    }
                ]
            },
            {
                "id": 3560,
                "name": "Võru",
                "iso2": "86",
                "latitude": "57.73773720",
                "longitude": "27.13989380",
                "type": "county",
                "cities": [
                    {
                        "id": 31596,
                        "name": "Antsla",
                        "latitude": "57.82556000",
                        "longitude": "26.54056000"
                    },
                    {
                        "id": 31597,
                        "name": "Antsla vald",
                        "latitude": "57.77738000",
                        "longitude": "26.59520000"
                    },
                    {
                        "id": 31701,
                        "name": "Rõuge",
                        "latitude": "57.72778000",
                        "longitude": "26.90972000"
                    },
                    {
                        "id": 31702,
                        "name": "Rõuge vald",
                        "latitude": "57.72780000",
                        "longitude": "26.88033000"
                    },
                    {
                        "id": 31736,
                        "name": "Vana-Antsla",
                        "latitude": "57.86611000",
                        "longitude": "26.53222000"
                    },
                    {
                        "id": 31750,
                        "name": "Värska",
                        "latitude": "57.95806000",
                        "longitude": "27.63806000"
                    },
                    {
                        "id": 31752,
                        "name": "Võru",
                        "latitude": "57.83389000",
                        "longitude": "27.01944000"
                    },
                    {
                        "id": 31753,
                        "name": "Võru vald",
                        "latitude": "57.86618000",
                        "longitude": "26.97418000"
                    }
                ]
            }
        ]
    },
    {
        "id": 212,
        "name": "Eswatini",
        "iso3": "SWZ",
        "iso2": "SZ",
        "numeric_code": "748",
        "phonecode": "268",
        "capital": "Mbabane",
        "currency": "SZL",
        "currency_name": "Lilangeni",
        "currency_symbol": "E",
        "tld": ".sz",
        "native": "Swaziland",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Southern Africa",
        "subregion_id": 5,
        "nationality": "Swazi",
        "timezones": [
            {
                "zoneName": "Africa\/Mbabane",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "SAST",
                "tzName": "South African Standard Time"
            }
        ],
        "translations": {
            "br": "Eswatini",
            "ko": "에스와티니",
            "pt-BR": "Suazilândia",
            "pt": "Suazilândia",
            "nl": "Swaziland",
            "hr": "Svazi",
            "fa": "سوازیلند",
            "de": "Swasiland",
            "es": "Suazilandia",
            "fr": "Swaziland",
            "ja": "スワジランド",
            "it": "Swaziland",
            "zh-CN": "斯威士兰",
            "tr": "Esvatini",
            "ru": "Эсватини",
            "uk": "Есватіні",
            "pl": "Eswatini"
        },
        "latitude": "-26.50000000",
        "longitude": "31.50000000",
        "emoji": "🇸🇿",
        "emojiU": "U+1F1F8 U+1F1FF",
        "states": [
            {
                "id": 969,
                "name": "Hhohho",
                "iso2": "HH",
                "latitude": "-26.13656620",
                "longitude": "31.35416310",
                "type": "region",
                "cities": [
                    {
                        "id": 105084,
                        "name": "Bulembu",
                        "latitude": "-25.96667000",
                        "longitude": "31.13333000"
                    },
                    {
                        "id": 105087,
                        "name": "Hhukwini",
                        "latitude": "-26.31972000",
                        "longitude": "31.22222000"
                    },
                    {
                        "id": 105093,
                        "name": "Lobamba",
                        "latitude": "-26.46667000",
                        "longitude": "31.20000000"
                    },
                    {
                        "id": 105099,
                        "name": "Mbabane",
                        "latitude": "-26.31667000",
                        "longitude": "31.13333000"
                    },
                    {
                        "id": 105105,
                        "name": "Nkhaba",
                        "latitude": "-26.15728000",
                        "longitude": "31.16391000"
                    },
                    {
                        "id": 105109,
                        "name": "Piggs Peak",
                        "latitude": "-25.96082000",
                        "longitude": "31.24666000"
                    }
                ]
            },
            {
                "id": 970,
                "name": "Lubombo",
                "iso2": "LU",
                "latitude": "-26.78517730",
                "longitude": "31.81070790",
                "type": "region",
                "cities": [
                    {
                        "id": 105083,
                        "name": "Big Bend",
                        "latitude": "-26.81667000",
                        "longitude": "31.93333000"
                    },
                    {
                        "id": 105085,
                        "name": "Dvokodvweni Inkhundla",
                        "latitude": "-26.45398000",
                        "longitude": "31.76456000"
                    },
                    {
                        "id": 105094,
                        "name": "Lomashasha",
                        "latitude": "-26.06644000",
                        "longitude": "32.00768000"
                    },
                    {
                        "id": 105101,
                        "name": "Mhlume",
                        "latitude": "-26.03333000",
                        "longitude": "31.85000000"
                    },
                    {
                        "id": 105107,
                        "name": "Nsoko",
                        "latitude": "-27.03333000",
                        "longitude": "31.95000000"
                    },
                    {
                        "id": 105112,
                        "name": "Siteki",
                        "latitude": "-26.45250000",
                        "longitude": "31.94722000"
                    },
                    {
                        "id": 105113,
                        "name": "Tshaneni",
                        "latitude": "-25.98333000",
                        "longitude": "31.71667000"
                    },
                    {
                        "id": 105114,
                        "name": "Vuvulane",
                        "latitude": "-26.07427000",
                        "longitude": "31.87672000"
                    }
                ]
            },
            {
                "id": 968,
                "name": "Manzini",
                "iso2": "MA",
                "latitude": "-26.50819990",
                "longitude": "31.37131640",
                "type": "region",
                "cities": [
                    {
                        "id": 105082,
                        "name": "Bhunya",
                        "latitude": "-26.55000000",
                        "longitude": "31.01667000"
                    },
                    {
                        "id": 105086,
                        "name": "Ekukhanyeni",
                        "latitude": "-26.38750000",
                        "longitude": "31.52806000"
                    },
                    {
                        "id": 105091,
                        "name": "Kwaluseni",
                        "latitude": "-26.48333000",
                        "longitude": "31.33333000"
                    },
                    {
                        "id": 105095,
                        "name": "Malkerns",
                        "latitude": "-26.56667000",
                        "longitude": "31.18333000"
                    },
                    {
                        "id": 105096,
                        "name": "Manzini",
                        "latitude": "-26.49884000",
                        "longitude": "31.38004000"
                    },
                    {
                        "id": 105097,
                        "name": "Manzini South",
                        "latitude": "-26.48333000",
                        "longitude": "31.36667000"
                    },
                    {
                        "id": 105100,
                        "name": "Mhlambanyatsi",
                        "latitude": "-26.45000000",
                        "longitude": "31.01667000"
                    },
                    {
                        "id": 105103,
                        "name": "Ngwempisi",
                        "latitude": "-26.69990000",
                        "longitude": "31.28876000"
                    },
                    {
                        "id": 105108,
                        "name": "Ntondozi",
                        "latitude": "-26.63500000",
                        "longitude": "31.22556000"
                    },
                    {
                        "id": 105110,
                        "name": "Sidvokodvo",
                        "latitude": "-26.62820000",
                        "longitude": "31.42021000"
                    }
                ]
            },
            {
                "id": 971,
                "name": "Shiselweni",
                "iso2": "SH",
                "latitude": "-26.98275770",
                "longitude": "31.35416310",
                "type": "region",
                "cities": [
                    {
                        "id": 105088,
                        "name": "Hlatikulu",
                        "latitude": "-26.97917000",
                        "longitude": "31.32444000"
                    },
                    {
                        "id": 105089,
                        "name": "Hluti",
                        "latitude": "-27.21667000",
                        "longitude": "31.61667000"
                    },
                    {
                        "id": 105090,
                        "name": "Kubuta",
                        "latitude": "-26.88333000",
                        "longitude": "31.48333000"
                    },
                    {
                        "id": 105092,
                        "name": "Lavumisa",
                        "latitude": "-27.31005000",
                        "longitude": "31.89198000"
                    },
                    {
                        "id": 105098,
                        "name": "Matsanjeni",
                        "latitude": "-27.21585000",
                        "longitude": "31.72309000"
                    },
                    {
                        "id": 105102,
                        "name": "Ngudzeni",
                        "latitude": "-27.03583000",
                        "longitude": "31.55111000"
                    },
                    {
                        "id": 105104,
                        "name": "Nhlangano",
                        "latitude": "-27.11222000",
                        "longitude": "31.19833000"
                    },
                    {
                        "id": 105106,
                        "name": "Nkwene",
                        "latitude": "-26.89778000",
                        "longitude": "31.24972000"
                    },
                    {
                        "id": 105111,
                        "name": "Sigwe Inkhundla",
                        "latitude": "-27.05821000",
                        "longitude": "31.64543000"
                    },
                    {
                        "id": 105115,
                        "name": "Zombodze Ikhundla",
                        "latitude": "-27.22746000",
                        "longitude": "31.33799000"
                    }
                ]
            }
        ]
    },
    {
        "id": 70,
        "name": "Ethiopia",
        "iso3": "ETH",
        "iso2": "ET",
        "numeric_code": "231",
        "phonecode": "251",
        "capital": "Addis Ababa",
        "currency": "ETB",
        "currency_name": "Ethiopian birr",
        "currency_symbol": "Nkf",
        "tld": ".et",
        "native": "ኢትዮጵያ",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Ethiopian",
        "timezones": [
            {
                "zoneName": "Africa\/Addis_Ababa",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Etiopia",
            "ko": "에티오피아",
            "pt-BR": "Etiópia",
            "pt": "Etiópia",
            "nl": "Ethiopië",
            "hr": "Etiopija",
            "fa": "اتیوپی",
            "de": "Äthiopien",
            "es": "Etiopía",
            "fr": "Éthiopie",
            "ja": "エチオピア",
            "it": "Etiopia",
            "zh-CN": "埃塞俄比亚",
            "tr": "Etiyopya",
            "ru": "Эфиопия",
            "uk": "Ефіопія",
            "pl": "Etiopia"
        },
        "latitude": "8.00000000",
        "longitude": "38.00000000",
        "emoji": "🇪🇹",
        "emojiU": "U+1F1EA U+1F1F9",
        "states": [
            {
                "id": 11,
                "name": "Addis Ababa",
                "iso2": "AA",
                "latitude": "8.98060340",
                "longitude": "38.75776050",
                "type": "administration",
                "cities": [
                    {
                        "id": 38587,
                        "name": "Addis Ababa",
                        "latitude": "9.02497000",
                        "longitude": "38.74689000"
                    }
                ]
            },
            {
                "id": 6,
                "name": "Afar",
                "iso2": "AF",
                "latitude": "11.75593880",
                "longitude": "40.95868800",
                "type": "region",
                "cities": [
                    {
                        "id": 38589,
                        "name": "Administrative Zone 2",
                        "latitude": "13.68513000",
                        "longitude": "40.05615000"
                    },
                    {
                        "id": 38590,
                        "name": "Administrative Zone 3",
                        "latitude": "10.00902000",
                        "longitude": "40.47394000"
                    },
                    {
                        "id": 38595,
                        "name": "Asaita",
                        "latitude": "11.56838000",
                        "longitude": "41.43869000"
                    },
                    {
                        "id": 38729,
                        "name": "Āwash",
                        "latitude": "8.98333000",
                        "longitude": "40.16667000"
                    },
                    {
                        "id": 38624,
                        "name": "Dubti",
                        "latitude": "11.73292000",
                        "longitude": "41.08200000"
                    },
                    {
                        "id": 38637,
                        "name": "Gewanē",
                        "latitude": "10.16658000",
                        "longitude": "40.64689000"
                    },
                    {
                        "id": 38691,
                        "name": "Semera",
                        "latitude": "11.79342000",
                        "longitude": "41.00578000"
                    }
                ]
            },
            {
                "id": 3,
                "name": "Amhara",
                "iso2": "AM",
                "latitude": "11.34942470",
                "longitude": "37.97845850",
                "type": "region",
                "cities": [
                    {
                        "id": 38585,
                        "name": "Abomsa",
                        "latitude": "9.98333000",
                        "longitude": "39.98333000"
                    },
                    {
                        "id": 38586,
                        "name": "Addiet Canna",
                        "latitude": "11.26667000",
                        "longitude": "37.48333000"
                    },
                    {
                        "id": 38722,
                        "name": "Ādīs Zemen",
                        "latitude": "12.11667000",
                        "longitude": "37.78333000"
                    },
                    {
                        "id": 38598,
                        "name": "Bahir Dar",
                        "latitude": "11.59364000",
                        "longitude": "37.39077000"
                    },
                    {
                        "id": 38600,
                        "name": "Batī",
                        "latitude": "11.19152000",
                        "longitude": "40.01675000"
                    },
                    {
                        "id": 38604,
                        "name": "Bichena",
                        "latitude": "10.45000000",
                        "longitude": "38.20000000"
                    },
                    {
                        "id": 38608,
                        "name": "Burē",
                        "latitude": "10.70000000",
                        "longitude": "37.06667000"
                    },
                    {
                        "id": 38610,
                        "name": "Dabat",
                        "latitude": "12.98417000",
                        "longitude": "37.76500000"
                    },
                    {
                        "id": 38611,
                        "name": "Debark’",
                        "latitude": "13.15611000",
                        "longitude": "37.89806000"
                    },
                    {
                        "id": 38612,
                        "name": "Debre Birhan",
                        "latitude": "9.67954000",
                        "longitude": "39.53262000"
                    },
                    {
                        "id": 38613,
                        "name": "Debre Mark’os",
                        "latitude": "10.35000000",
                        "longitude": "37.73333000"
                    },
                    {
                        "id": 38614,
                        "name": "Debre Sīna",
                        "latitude": "9.84752000",
                        "longitude": "39.76027000"
                    },
                    {
                        "id": 38615,
                        "name": "Debre Tabor",
                        "latitude": "11.85000000",
                        "longitude": "38.01667000"
                    },
                    {
                        "id": 38616,
                        "name": "Debre Werk’",
                        "latitude": "10.66667000",
                        "longitude": "38.16667000"
                    },
                    {
                        "id": 38619,
                        "name": "Dejen",
                        "latitude": "10.16667000",
                        "longitude": "38.13333000"
                    },
                    {
                        "id": 38621,
                        "name": "Desē",
                        "latitude": "11.13333000",
                        "longitude": "39.63333000"
                    },
                    {
                        "id": 38631,
                        "name": "Finote Selam",
                        "latitude": "10.70000000",
                        "longitude": "37.26667000"
                    },
                    {
                        "id": 38642,
                        "name": "Gondar",
                        "latitude": "12.60000000",
                        "longitude": "37.46667000"
                    },
                    {
                        "id": 38664,
                        "name": "Kemisē",
                        "latitude": "10.71668000",
                        "longitude": "39.86997000"
                    },
                    {
                        "id": 38667,
                        "name": "Kombolcha",
                        "latitude": "11.08155000",
                        "longitude": "39.74339000"
                    },
                    {
                        "id": 38671,
                        "name": "Lalībela",
                        "latitude": "12.03219000",
                        "longitude": "39.04756000"
                    },
                    {
                        "id": 38686,
                        "name": "North Shewa Zone",
                        "latitude": "9.76900000",
                        "longitude": "39.66800000"
                    },
                    {
                        "id": 38688,
                        "name": "North Wollo Zone",
                        "latitude": "11.92000000",
                        "longitude": "39.10000000"
                    },
                    {
                        "id": 38689,
                        "name": "Robīt",
                        "latitude": "12.01667000",
                        "longitude": "39.63333000"
                    },
                    {
                        "id": 38701,
                        "name": "South Gondar Zone",
                        "latitude": "11.83850000",
                        "longitude": "38.09954000"
                    },
                    {
                        "id": 38702,
                        "name": "South Wollo Zone",
                        "latitude": "11.00000000",
                        "longitude": "39.25000000"
                    },
                    {
                        "id": 38708,
                        "name": "Wag Hemra Zone",
                        "latitude": "12.76500000",
                        "longitude": "38.84300000"
                    },
                    {
                        "id": 38712,
                        "name": "Were Īlu",
                        "latitude": "10.58964000",
                        "longitude": "39.43767000"
                    },
                    {
                        "id": 38713,
                        "name": "Werota",
                        "latitude": "11.91667000",
                        "longitude": "37.70000000"
                    }
                ]
            },
            {
                "id": 9,
                "name": "Benishangul-Gumuz",
                "iso2": "BE",
                "latitude": "10.78028890",
                "longitude": "35.56578620",
                "type": "region",
                "cities": [
                    {
                        "id": 38596,
                        "name": "Asosa",
                        "latitude": "10.00000000",
                        "longitude": "34.50000000"
                    },
                    {
                        "id": 38679,
                        "name": "Metekel",
                        "latitude": "10.42673000",
                        "longitude": "35.71975000"
                    }
                ]
            },
            {
                "id": 8,
                "name": "Dire Dawa",
                "iso2": "DD",
                "latitude": "9.60087470",
                "longitude": "41.85014200",
                "type": "administration",
                "cities": [
                    {
                        "id": 38622,
                        "name": "Dire Dawa",
                        "latitude": "9.59306000",
                        "longitude": "41.86611000"
                    }
                ]
            },
            {
                "id": 10,
                "name": "Gambela",
                "iso2": "GA",
                "latitude": "7.92196870",
                "longitude": "34.15319470",
                "type": "region",
                "cities": [
                    {
                        "id": 38588,
                        "name": "Administrative Zone 1",
                        "latitude": "8.14699000",
                        "longitude": "33.97335000"
                    },
                    {
                        "id": 38632,
                        "name": "Gambēla",
                        "latitude": "8.25000000",
                        "longitude": "34.58333000"
                    }
                ]
            },
            {
                "id": 7,
                "name": "Harari",
                "iso2": "HA",
                "latitude": "9.31486600",
                "longitude": "42.19677160",
                "type": "region",
                "cities": [
                    {
                        "id": 38650,
                        "name": "Harar",
                        "latitude": "9.31387000",
                        "longitude": "42.11815000"
                    }
                ]
            },
            {
                "id": 5,
                "name": "Oromia",
                "iso2": "OR",
                "latitude": "7.54603770",
                "longitude": "40.63468510",
                "type": "region",
                "cities": [
                    {
                        "id": 38723,
                        "name": "Ādīs ‘Alem",
                        "latitude": "9.03333000",
                        "longitude": "38.40000000"
                    },
                    {
                        "id": 38724,
                        "name": "Āgaro",
                        "latitude": "7.85000000",
                        "longitude": "36.65000000"
                    },
                    {
                        "id": 38594,
                        "name": "Arsi Zone",
                        "latitude": "7.50000000",
                        "longitude": "39.50000000"
                    },
                    {
                        "id": 38726,
                        "name": "Āsasa",
                        "latitude": "7.10000000",
                        "longitude": "39.20000000"
                    },
                    {
                        "id": 38727,
                        "name": "Āsbe Teferī",
                        "latitude": "9.08569000",
                        "longitude": "40.86708000"
                    },
                    {
                        "id": 38601,
                        "name": "Bedelē",
                        "latitude": "8.45600000",
                        "longitude": "36.35302000"
                    },
                    {
                        "id": 38602,
                        "name": "Bedēsa",
                        "latitude": "8.90000000",
                        "longitude": "40.78333000"
                    },
                    {
                        "id": 38605,
                        "name": "Bishoftu",
                        "latitude": "8.75225000",
                        "longitude": "38.97846000"
                    },
                    {
                        "id": 38617,
                        "name": "Deder",
                        "latitude": "9.31168000",
                        "longitude": "41.44301000"
                    },
                    {
                        "id": 38620,
                        "name": "Dembī Dolo",
                        "latitude": "8.53333000",
                        "longitude": "34.80000000"
                    },
                    {
                        "id": 38623,
                        "name": "Dodola",
                        "latitude": "6.98333000",
                        "longitude": "39.18333000"
                    },
                    {
                        "id": 38626,
                        "name": "East Harerghe Zone",
                        "latitude": "8.70114000",
                        "longitude": "42.00241000"
                    },
                    {
                        "id": 38627,
                        "name": "East Shewa Zone",
                        "latitude": "8.21353000",
                        "longitude": "38.84809000"
                    },
                    {
                        "id": 38628,
                        "name": "East Wellega Zone",
                        "latitude": "9.51928000",
                        "longitude": "36.75762000"
                    },
                    {
                        "id": 38630,
                        "name": "Fichē",
                        "latitude": "9.80000000",
                        "longitude": "38.73333000"
                    },
                    {
                        "id": 38633,
                        "name": "Gebre Guracha",
                        "latitude": "9.80000000",
                        "longitude": "38.40000000"
                    },
                    {
                        "id": 38646,
                        "name": "Gēdo",
                        "latitude": "9.01667000",
                        "longitude": "37.45000000"
                    },
                    {
                        "id": 38635,
                        "name": "Gelemso",
                        "latitude": "8.81667000",
                        "longitude": "40.51667000"
                    },
                    {
                        "id": 38636,
                        "name": "Genet",
                        "latitude": "9.06667000",
                        "longitude": "38.50000000"
                    },
                    {
                        "id": 38638,
                        "name": "Gimbi",
                        "latitude": "9.17031000",
                        "longitude": "35.83491000"
                    },
                    {
                        "id": 38639,
                        "name": "Ginir",
                        "latitude": "7.13952000",
                        "longitude": "40.71083000"
                    },
                    {
                        "id": 38640,
                        "name": "Goba",
                        "latitude": "7.01667000",
                        "longitude": "39.98333000"
                    },
                    {
                        "id": 38643,
                        "name": "Gorē",
                        "latitude": "8.15000000",
                        "longitude": "35.53333000"
                    },
                    {
                        "id": 38644,
                        "name": "Guji Zone",
                        "latitude": "5.58800000",
                        "longitude": "39.06700000"
                    },
                    {
                        "id": 38654,
                        "name": "Hāgere Hiywet",
                        "latitude": "8.98333000",
                        "longitude": "37.85000000"
                    },
                    {
                        "id": 38649,
                        "name": "Hagere Maryam",
                        "latitude": "5.63418000",
                        "longitude": "38.23603000"
                    },
                    {
                        "id": 38656,
                        "name": "Hīrna",
                        "latitude": "9.21667000",
                        "longitude": "41.10000000"
                    },
                    {
                        "id": 38653,
                        "name": "Huruta",
                        "latitude": "8.15000000",
                        "longitude": "39.35000000"
                    },
                    {
                        "id": 38657,
                        "name": "Illubabor Zone",
                        "latitude": "8.27526000",
                        "longitude": "35.75596000"
                    },
                    {
                        "id": 38660,
                        "name": "Jimma",
                        "latitude": "7.67344000",
                        "longitude": "36.83441000"
                    },
                    {
                        "id": 38661,
                        "name": "Jimma Zone",
                        "latitude": "7.66667000",
                        "longitude": "37.00000000"
                    },
                    {
                        "id": 38665,
                        "name": "Kibre Mengist",
                        "latitude": "5.88333000",
                        "longitude": "38.98333000"
                    },
                    {
                        "id": 38666,
                        "name": "Kofelē",
                        "latitude": "7.06667000",
                        "longitude": "38.78333000"
                    },
                    {
                        "id": 38682,
                        "name": "Mēga",
                        "latitude": "4.05000000",
                        "longitude": "38.30000000"
                    },
                    {
                        "id": 38677,
                        "name": "Mendī",
                        "latitude": "9.80000000",
                        "longitude": "35.10000000"
                    },
                    {
                        "id": 38678,
                        "name": "Metahāra",
                        "latitude": "8.90000000",
                        "longitude": "39.91667000"
                    },
                    {
                        "id": 38680,
                        "name": "Metu",
                        "latitude": "8.30000000",
                        "longitude": "35.58333000"
                    },
                    {
                        "id": 38681,
                        "name": "Mojo",
                        "latitude": "8.58679000",
                        "longitude": "39.12111000"
                    },
                    {
                        "id": 38684,
                        "name": "Nazrēt",
                        "latitude": "8.55000000",
                        "longitude": "39.26667000"
                    },
                    {
                        "id": 38685,
                        "name": "Nejo",
                        "latitude": "9.50000000",
                        "longitude": "35.50000000"
                    },
                    {
                        "id": 38687,
                        "name": "North Shewa Zone",
                        "latitude": "9.66915000",
                        "longitude": "38.81240000"
                    },
                    {
                        "id": 38690,
                        "name": "Sebeta",
                        "latitude": "8.91667000",
                        "longitude": "38.61667000"
                    },
                    {
                        "id": 38692,
                        "name": "Sendafa",
                        "latitude": "9.15203000",
                        "longitude": "39.02335000"
                    },
                    {
                        "id": 38693,
                        "name": "Shakiso",
                        "latitude": "5.76494000",
                        "longitude": "38.91006000"
                    },
                    {
                        "id": 38694,
                        "name": "Shambu",
                        "latitude": "9.56667000",
                        "longitude": "37.10000000"
                    },
                    {
                        "id": 38695,
                        "name": "Shashemenē",
                        "latitude": "7.20000000",
                        "longitude": "38.60000000"
                    },
                    {
                        "id": 38699,
                        "name": "Sirre",
                        "latitude": "8.31667000",
                        "longitude": "39.48333000"
                    },
                    {
                        "id": 38706,
                        "name": "Tulu Bolo",
                        "latitude": "8.66667000",
                        "longitude": "38.21667000"
                    },
                    {
                        "id": 38709,
                        "name": "Waliso",
                        "latitude": "8.53417000",
                        "longitude": "37.96515000"
                    },
                    {
                        "id": 38711,
                        "name": "Wenjī",
                        "latitude": "8.45000000",
                        "longitude": "39.28333000"
                    },
                    {
                        "id": 38714,
                        "name": "West Harerghe Zone",
                        "latitude": "8.67245000",
                        "longitude": "40.84885000"
                    },
                    {
                        "id": 38715,
                        "name": "West Wellega Zone",
                        "latitude": "9.17283000",
                        "longitude": "35.05279000"
                    },
                    {
                        "id": 38717,
                        "name": "Yabēlo",
                        "latitude": "4.88333000",
                        "longitude": "38.08333000"
                    },
                    {
                        "id": 38720,
                        "name": "Ziway",
                        "latitude": "7.93333000",
                        "longitude": "38.71667000"
                    }
                ]
            },
            {
                "id": 2,
                "name": "Somali",
                "iso2": "SO",
                "latitude": "6.66122930",
                "longitude": "43.79084530",
                "type": "region",
                "cities": [
                    {
                        "id": 38591,
                        "name": "Afder Zone",
                        "latitude": "5.25000000",
                        "longitude": "43.00000000"
                    },
                    {
                        "id": 38618,
                        "name": "Degehabur Zone",
                        "latitude": "8.25000000",
                        "longitude": "43.75000000"
                    },
                    {
                        "id": 38641,
                        "name": "Gode Zone",
                        "latitude": "6.00000000",
                        "longitude": "43.75000000"
                    },
                    {
                        "id": 38659,
                        "name": "Jijiga",
                        "latitude": "9.35000000",
                        "longitude": "42.80000000"
                    },
                    {
                        "id": 38673,
                        "name": "Liben zone",
                        "latitude": "4.75000000",
                        "longitude": "40.50000000"
                    },
                    {
                        "id": 38697,
                        "name": "Shinile Zone",
                        "latitude": "10.17097000",
                        "longitude": "41.83748000"
                    }
                ]
            },
            {
                "id": 1,
                "name": "Southern Nations, Nationalities, and Peoples'",
                "iso2": "SN",
                "latitude": "6.51569110",
                "longitude": "36.95410700",
                "type": "region",
                "cities": [
                    {
                        "id": 38592,
                        "name": "Alaba Special Wereda",
                        "latitude": "7.45347000",
                        "longitude": "38.21189000"
                    },
                    {
                        "id": 38593,
                        "name": "Arba Minch",
                        "latitude": "6.03333000",
                        "longitude": "37.55000000"
                    },
                    {
                        "id": 38725,
                        "name": "Āreka",
                        "latitude": "7.06667000",
                        "longitude": "37.70000000"
                    },
                    {
                        "id": 38599,
                        "name": "Bako",
                        "latitude": "5.78333000",
                        "longitude": "36.56667000"
                    },
                    {
                        "id": 38603,
                        "name": "Bench Maji Zone",
                        "latitude": "6.45994000",
                        "longitude": "35.30549000"
                    },
                    {
                        "id": 38606,
                        "name": "Bodītī",
                        "latitude": "6.96667000",
                        "longitude": "37.86667000"
                    },
                    {
                        "id": 38607,
                        "name": "Bonga",
                        "latitude": "7.28333000",
                        "longitude": "36.23333000"
                    },
                    {
                        "id": 38609,
                        "name": "Butajīra",
                        "latitude": "8.11667000",
                        "longitude": "38.36667000"
                    },
                    {
                        "id": 38625,
                        "name": "Dīla",
                        "latitude": "6.41667000",
                        "longitude": "38.31667000"
                    },
                    {
                        "id": 38629,
                        "name": "Felege Neway",
                        "latitude": "6.30000000",
                        "longitude": "36.88333000"
                    },
                    {
                        "id": 38634,
                        "name": "Gedeo Zone",
                        "latitude": "6.12727000",
                        "longitude": "38.27716000"
                    },
                    {
                        "id": 38647,
                        "name": "Gīdolē",
                        "latitude": "5.65000000",
                        "longitude": "37.36667000"
                    },
                    {
                        "id": 38645,
                        "name": "Guraghe Zone",
                        "latitude": "8.25000000",
                        "longitude": "38.00000000"
                    },
                    {
                        "id": 38648,
                        "name": "Hadiya Zone",
                        "latitude": "7.50000000",
                        "longitude": "37.75000000"
                    },
                    {
                        "id": 38655,
                        "name": "Hāgere Selam",
                        "latitude": "6.48333000",
                        "longitude": "38.51667000"
                    },
                    {
                        "id": 38651,
                        "name": "Hawassa",
                        "latitude": "7.06205000",
                        "longitude": "38.47635000"
                    },
                    {
                        "id": 38652,
                        "name": "Hosa’ina",
                        "latitude": "7.54978000",
                        "longitude": "37.85374000"
                    },
                    {
                        "id": 38662,
                        "name": "Jinka",
                        "latitude": "5.65000000",
                        "longitude": "36.65000000"
                    },
                    {
                        "id": 38670,
                        "name": "K’olīto",
                        "latitude": "7.31667000",
                        "longitude": "38.08333000"
                    },
                    {
                        "id": 38663,
                        "name": "Kembata Alaba Tembaro Zone",
                        "latitude": "7.27039000",
                        "longitude": "37.77887000"
                    },
                    {
                        "id": 38668,
                        "name": "Konso",
                        "latitude": "5.25000000",
                        "longitude": "37.48333000"
                    },
                    {
                        "id": 38672,
                        "name": "Leku",
                        "latitude": "6.87309000",
                        "longitude": "38.44425000"
                    },
                    {
                        "id": 38674,
                        "name": "Lobuni",
                        "latitude": "4.83333000",
                        "longitude": "36.10000000"
                    },
                    {
                        "id": 38683,
                        "name": "Mīzan Teferī",
                        "latitude": "6.99865000",
                        "longitude": "35.58879000"
                    },
                    {
                        "id": 38696,
                        "name": "Sheka Zone",
                        "latitude": "7.56166000",
                        "longitude": "35.40174000"
                    },
                    {
                        "id": 38698,
                        "name": "Sidama Zone",
                        "latitude": "6.71800000",
                        "longitude": "38.44800000"
                    },
                    {
                        "id": 38700,
                        "name": "Sodo",
                        "latitude": "6.86000000",
                        "longitude": "37.76159000"
                    },
                    {
                        "id": 38705,
                        "name": "Tippi",
                        "latitude": "7.20000000",
                        "longitude": "35.45000000"
                    },
                    {
                        "id": 38707,
                        "name": "Turmi",
                        "latitude": "4.96667000",
                        "longitude": "36.48333000"
                    },
                    {
                        "id": 38710,
                        "name": "Wendo",
                        "latitude": "6.60000000",
                        "longitude": "38.41667000"
                    },
                    {
                        "id": 38716,
                        "name": "Wolayita Zone",
                        "latitude": "6.84312000",
                        "longitude": "37.70051000"
                    },
                    {
                        "id": 38718,
                        "name": "Yem",
                        "latitude": "7.83333000",
                        "longitude": "37.50000000"
                    },
                    {
                        "id": 38719,
                        "name": "Yirga ‘Alem",
                        "latitude": "6.75000000",
                        "longitude": "38.41667000"
                    }
                ]
            },
            {
                "id": 4,
                "name": "Tigray",
                "iso2": "TI",
                "latitude": "14.03233360",
                "longitude": "38.31657250",
                "type": "region",
                "cities": [
                    {
                        "id": 38721,
                        "name": "Ādīgrat",
                        "latitude": "14.27700000",
                        "longitude": "39.46200000"
                    },
                    {
                        "id": 38597,
                        "name": "Axum",
                        "latitude": "14.12109000",
                        "longitude": "38.72337000"
                    },
                    {
                        "id": 38658,
                        "name": "Inda Silasē",
                        "latitude": "14.10307000",
                        "longitude": "38.28289000"
                    },
                    {
                        "id": 38669,
                        "name": "Korem",
                        "latitude": "12.50583000",
                        "longitude": "39.52278000"
                    },
                    {
                        "id": 38675,
                        "name": "Maych’ew",
                        "latitude": "12.78750000",
                        "longitude": "39.54222000"
                    },
                    {
                        "id": 38676,
                        "name": "Mek'ele",
                        "latitude": "13.49667000",
                        "longitude": "39.47528000"
                    },
                    {
                        "id": 38703,
                        "name": "Southeastern Tigray Zone",
                        "latitude": "13.24797000",
                        "longitude": "39.53156000"
                    },
                    {
                        "id": 38704,
                        "name": "Southern Tigray Zone",
                        "latitude": "12.96033000",
                        "longitude": "39.52831000"
                    }
                ]
            }
        ]
    },
    {
        "id": 71,
        "name": "Falkland Islands",
        "iso3": "FLK",
        "iso2": "FK",
        "numeric_code": "238",
        "phonecode": "500",
        "capital": "Stanley",
        "currency": "FKP",
        "currency_name": "Falkland Islands pound",
        "currency_symbol": "£",
        "tld": ".fk",
        "native": "Falkland Islands",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Falkland Island",
        "timezones": [
            {
                "zoneName": "Atlantic\/Stanley",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "FKST",
                "tzName": "Falkland Islands Summer Time"
            }
        ],
        "translations": {
            "br": "Inizi Maloù",
            "ko": "포클랜드 제도",
            "pt-BR": "Ilhas Malvinas",
            "pt": "Ilhas Falkland",
            "nl": "Falklandeilanden [Islas Malvinas]",
            "hr": "Falklandski Otoci",
            "fa": "جزایر فالکلند",
            "de": "Falklandinseln",
            "es": "Islas Malvinas",
            "fr": "Îles Malouines",
            "ja": "フォークランド（マルビナス）諸島",
            "it": "Isole Falkland o Isole Malvine",
            "zh-CN": "福克兰群岛",
            "tr": "Falkland Adalari",
            "ru": "Фолклендские острова",
            "uk": "Фолклендські острови",
            "pl": "Falklandy"
        },
        "latitude": "-51.75000000",
        "longitude": "-59.00000000",
        "emoji": "🇫🇰",
        "emojiU": "U+1F1EB U+1F1F0",
        "states": []
    },
    {
        "id": 72,
        "name": "Faroe Islands",
        "iso3": "FRO",
        "iso2": "FO",
        "numeric_code": "234",
        "phonecode": "298",
        "capital": "Torshavn",
        "currency": "DKK",
        "currency_name": "Danish krone",
        "currency_symbol": "Kr.",
        "tld": ".fo",
        "native": "Føroyar",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Faroese",
        "timezones": [
            {
                "zoneName": "Atlantic\/Faroe",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "WET",
                "tzName": "Western European Time"
            }
        ],
        "translations": {
            "br": "Faero",
            "ko": "페로 제도",
            "pt-BR": "Ilhas Faroé",
            "pt": "Ilhas Faroé",
            "nl": "Faeröer",
            "hr": "Farski Otoci",
            "fa": "جزایر فارو",
            "de": "Färöer-Inseln",
            "es": "Islas Faroe",
            "fr": "Îles Féroé",
            "ja": "フェロー諸島",
            "it": "Isole Far Oer",
            "zh-CN": "法罗群岛",
            "tr": "Faroe Adalari",
            "ru": "Фарерские острова",
            "uk": "Фарерські острови",
            "pl": "Wyspy Owcze"
        },
        "latitude": "62.00000000",
        "longitude": "-7.00000000",
        "emoji": "🇫🇴",
        "emojiU": "U+1F1EB U+1F1F4",
        "states": [
            {
                "id": 5229,
                "name": "Eysturoy",
                "iso2": "EY",
                "latitude": "62.19787370",
                "longitude": "-7.18239060",
                "type": "region",
                "cities": [
                    {
                        "id": 153758,
                        "name": "Eiði",
                        "latitude": "62.27890000",
                        "longitude": "-7.01230000"
                    },
                    {
                        "id": 153748,
                        "name": "Eystur",
                        "latitude": "62.15670000",
                        "longitude": "-6.82330000"
                    },
                    {
                        "id": 153752,
                        "name": "Fuglafjørður",
                        "latitude": "62.21010000",
                        "longitude": "-6.81230000"
                    },
                    {
                        "id": 153754,
                        "name": "Nes",
                        "latitude": "62.09870000",
                        "longitude": "-6.76540000"
                    },
                    {
                        "id": 153747,
                        "name": "Runavík",
                        "latitude": "62.13230000",
                        "longitude": "-6.78900000"
                    },
                    {
                        "id": 153757,
                        "name": "Sjóvar",
                        "latitude": "62.12340000",
                        "longitude": "-6.87650000"
                    }
                ]
            },
            {
                "id": 5230,
                "name": "Northern Isles",
                "iso2": "NO",
                "latitude": "62.28056890",
                "longitude": "6.70170610",
                "type": "region",
                "cities": [
                    {
                        "id": 153773,
                        "name": "Fugloy",
                        "latitude": "62.45670000",
                        "longitude": "-6.72340000"
                    },
                    {
                        "id": 153763,
                        "name": "Hvannasund",
                        "latitude": "62.34560000",
                        "longitude": "-6.78900000"
                    },
                    {
                        "id": 153746,
                        "name": "Klaksvík",
                        "latitude": "62.22100000",
                        "longitude": "-6.58000000"
                    },
                    {
                        "id": 153767,
                        "name": "Kunoy",
                        "latitude": "62.34560000",
                        "longitude": "-6.89010000"
                    },
                    {
                        "id": 153765,
                        "name": "Viðareiði",
                        "latitude": "62.45670000",
                        "longitude": "-6.72340000"
                    }
                ]
            },
            {
                "id": 5231,
                "name": "Sandoy",
                "iso2": "SA",
                "latitude": "61.83651690",
                "longitude": "-6.96301660",
                "type": "region",
                "cities": [
                    {
                        "id": 153769,
                        "name": "Húsavík",
                        "latitude": "61.90120000",
                        "longitude": "-6.84560000"
                    },
                    {
                        "id": 153761,
                        "name": "Sandur",
                        "latitude": "61.90120000",
                        "longitude": "-6.84560000"
                    },
                    {
                        "id": 153768,
                        "name": "Skálavík",
                        "latitude": "61.98760000",
                        "longitude": "-6.76540000"
                    },
                    {
                        "id": 153762,
                        "name": "Skopun",
                        "latitude": "62.01230000",
                        "longitude": "-6.98760000"
                    },
                    {
                        "id": 153772,
                        "name": "Skúvoy",
                        "latitude": "61.98760000",
                        "longitude": "-6.76540000"
                    }
                ]
            },
            {
                "id": 5232,
                "name": "Streymoy",
                "iso2": "ST",
                "latitude": "62.12338200",
                "longitude": "-7.32641080",
                "type": "region",
                "cities": [
                    {
                        "id": 153760,
                        "name": "Kvívík",
                        "latitude": "62.14560000",
                        "longitude": "-7.20980000"
                    },
                    {
                        "id": 153750,
                        "name": "Sunda",
                        "latitude": "62.13450000",
                        "longitude": "-7.09870000"
                    },
                    {
                        "id": 153745,
                        "name": "Tórshavn",
                        "latitude": "62.00000000",
                        "longitude": "-7.00000000"
                    },
                    {
                        "id": 153755,
                        "name": "Vestmanna",
                        "latitude": "62.15670000",
                        "longitude": "-7.23450000"
                    }
                ]
            },
            {
                "id": 5233,
                "name": "Suðuroy",
                "iso2": "SU",
                "latitude": "61.52118160",
                "longitude": "-7.00190140",
                "type": "region",
                "cities": [
                    {
                        "id": 153771,
                        "name": "Fámjin",
                        "latitude": "61.45670000",
                        "longitude": "-6.89010000"
                    },
                    {
                        "id": 153770,
                        "name": "Hov",
                        "latitude": "61.45670000",
                        "longitude": "-6.89010000"
                    },
                    {
                        "id": 153759,
                        "name": "Hvalba",
                        "latitude": "61.59870000",
                        "longitude": "-6.98760000"
                    },
                    {
                        "id": 153766,
                        "name": "Porkeri",
                        "latitude": "61.54320000",
                        "longitude": "-6.98760000"
                    },
                    {
                        "id": 153764,
                        "name": "Sumba",
                        "latitude": "61.45670000",
                        "longitude": "-6.89010000"
                    },
                    {
                        "id": 153751,
                        "name": "Tvøroyri",
                        "latitude": "61.56230000",
                        "longitude": "-6.77800000"
                    },
                    {
                        "id": 153753,
                        "name": "Vágur",
                        "latitude": "61.47890000",
                        "longitude": "-6.81010000"
                    }
                ]
            },
            {
                "id": 5234,
                "name": "Vágar",
                "iso2": "VA",
                "latitude": "62.08998350",
                "longitude": "-7.42768370",
                "type": "region",
                "cities": [
                    {
                        "id": 153756,
                        "name": "Sørvágur",
                        "latitude": "62.06540000",
                        "longitude": "-7.37870000"
                    },
                    {
                        "id": 153749,
                        "name": "Vágar",
                        "latitude": "62.06670000",
                        "longitude": "-7.10000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 73,
        "name": "Fiji Islands",
        "iso3": "FJI",
        "iso2": "FJ",
        "numeric_code": "242",
        "phonecode": "679",
        "capital": "Suva",
        "currency": "FJD",
        "currency_name": "Fijian dollar",
        "currency_symbol": "FJ$",
        "tld": ".fj",
        "native": "Fiji",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Melanesia",
        "subregion_id": 20,
        "nationality": "Fijian",
        "timezones": [
            {
                "zoneName": "Pacific\/Fiji",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "FJT",
                "tzName": "Fiji Time"
            }
        ],
        "translations": {
            "br": "Fidji",
            "ko": "피지",
            "pt-BR": "Fiji",
            "pt": "Fiji",
            "nl": "Fiji",
            "hr": "Fiđi",
            "fa": "فیجی",
            "de": "Fidschi",
            "es": "Fiyi",
            "fr": "Fidji",
            "ja": "フィジー",
            "it": "Figi",
            "zh-CN": "斐济",
            "tr": "Fiji",
            "ru": "Острова Фиджи",
            "uk": "Острови Фіджі",
            "pl": "Wyspy Fidżi"
        },
        "latitude": "-18.00000000",
        "longitude": "175.00000000",
        "emoji": "🇫🇯",
        "emojiU": "U+1F1EB U+1F1EF",
        "states": [
            {
                "id": 1917,
                "name": "Ba",
                "iso2": "01",
                "latitude": "36.06138930",
                "longitude": "-95.80058720",
                "type": "province",
                "cities": []
            },
            {
                "id": 1930,
                "name": "Bua",
                "iso2": "02",
                "latitude": "43.09645840",
                "longitude": "-89.50088000",
                "type": "province",
                "cities": []
            },
            {
                "id": 1924,
                "name": "Cakaudrove",
                "iso2": "03",
                "latitude": "-16.58141050",
                "longitude": "179.51200840",
                "type": "province",
                "cities": []
            },
            {
                "id": 1929,
                "name": "Central",
                "iso2": "C",
                "latitude": "34.04400660",
                "longitude": "-118.24727380",
                "type": "division",
                "cities": [
                    {
                        "id": 39145,
                        "name": "Naitasiri Province",
                        "latitude": "-17.83333000",
                        "longitude": "178.25000000"
                    },
                    {
                        "id": 39146,
                        "name": "Namosi Province",
                        "latitude": "-18.05000000",
                        "longitude": "178.13333000"
                    },
                    {
                        "id": 39149,
                        "name": "Rewa Province",
                        "latitude": "-18.08333000",
                        "longitude": "178.33333000"
                    },
                    {
                        "id": 39150,
                        "name": "Serua Province",
                        "latitude": "-18.16667000",
                        "longitude": "178.00000000"
                    },
                    {
                        "id": 39151,
                        "name": "Suva",
                        "latitude": "-18.14161000",
                        "longitude": "178.44149000"
                    },
                    {
                        "id": 39152,
                        "name": "Tailevu Province",
                        "latitude": "-17.83333000",
                        "longitude": "178.50000000"
                    }
                ]
            },
            {
                "id": 1932,
                "name": "Eastern",
                "iso2": "E",
                "latitude": "32.80943050",
                "longitude": "-117.12899370",
                "type": "division",
                "cities": [
                    {
                        "id": 39137,
                        "name": "Kadavu Province",
                        "latitude": "-18.99331000",
                        "longitude": "178.22021000"
                    },
                    {
                        "id": 39139,
                        "name": "Lau Province",
                        "latitude": "-18.20488000",
                        "longitude": "-178.79251000"
                    },
                    {
                        "id": 39141,
                        "name": "Levuka",
                        "latitude": "-18.06667000",
                        "longitude": "179.31667000"
                    },
                    {
                        "id": 39142,
                        "name": "Lomaiviti Province",
                        "latitude": "-17.66667000",
                        "longitude": "178.80000000"
                    }
                ]
            },
            {
                "id": 1934,
                "name": "Kadavu",
                "iso2": "04",
                "latitude": "-19.01271220",
                "longitude": "178.18766760",
                "type": "province",
                "cities": []
            },
            {
                "id": 1933,
                "name": "Lau",
                "iso2": "05",
                "latitude": "31.66870150",
                "longitude": "-106.39557630",
                "type": "province",
                "cities": []
            },
            {
                "id": 1916,
                "name": "Lomaiviti",
                "iso2": "06",
                "latitude": "-17.70900000",
                "longitude": "179.09100000",
                "type": "province",
                "cities": []
            },
            {
                "id": 1922,
                "name": "Macuata",
                "iso2": "07",
                "latitude": "-16.48649220",
                "longitude": "179.28472510",
                "type": "province",
                "cities": []
            },
            {
                "id": 1919,
                "name": "Nadroga-Navosa",
                "iso2": "08",
                "latitude": "-17.98652780",
                "longitude": "177.65811300",
                "type": "province",
                "cities": []
            },
            {
                "id": 1927,
                "name": "Naitasiri",
                "iso2": "09",
                "latitude": "-17.89757540",
                "longitude": "178.20715980",
                "type": "province",
                "cities": []
            },
            {
                "id": 1928,
                "name": "Namosi",
                "iso2": "10",
                "latitude": "-18.08641760",
                "longitude": "178.12913870",
                "type": "province",
                "cities": []
            },
            {
                "id": 1921,
                "name": "Northern",
                "iso2": "N",
                "latitude": "32.87687660",
                "longitude": "-117.21563450",
                "type": "division",
                "cities": [
                    {
                        "id": 39135,
                        "name": "Bua Province",
                        "latitude": "-16.83333000",
                        "longitude": "178.75000000"
                    },
                    {
                        "id": 39136,
                        "name": "Cakaudrove Province",
                        "latitude": "-16.66667000",
                        "longitude": "179.41667000"
                    },
                    {
                        "id": 39138,
                        "name": "Labasa",
                        "latitude": "-16.43320000",
                        "longitude": "179.36451000"
                    },
                    {
                        "id": 39143,
                        "name": "Macuata Province",
                        "latitude": "-16.50000000",
                        "longitude": "179.25000000"
                    }
                ]
            },
            {
                "id": 1926,
                "name": "Ra",
                "iso2": "11",
                "latitude": "37.10031530",
                "longitude": "-95.67442460",
                "type": "province",
                "cities": []
            },
            {
                "id": 1920,
                "name": "Rewa",
                "iso2": "12",
                "latitude": "34.79235170",
                "longitude": "-82.36092640",
                "type": "province",
                "cities": []
            },
            {
                "id": 1931,
                "name": "Rotuma",
                "iso2": "R",
                "latitude": "-12.50250690",
                "longitude": "177.07241640",
                "type": "dependency",
                "cities": []
            },
            {
                "id": 1925,
                "name": "Serua",
                "iso2": "13",
                "latitude": "-18.18047490",
                "longitude": "178.05097900",
                "type": "province",
                "cities": []
            },
            {
                "id": 1918,
                "name": "Tailevu",
                "iso2": "14",
                "latitude": "-17.82691110",
                "longitude": "178.29324800",
                "type": "province",
                "cities": []
            },
            {
                "id": 1923,
                "name": "Western",
                "iso2": "W",
                "latitude": "42.96621980",
                "longitude": "-78.70211340",
                "type": "division",
                "cities": [
                    {
                        "id": 39133,
                        "name": "Ba",
                        "latitude": "-17.53430000",
                        "longitude": "177.67407000"
                    },
                    {
                        "id": 39134,
                        "name": "Ba Province",
                        "latitude": "-17.66667000",
                        "longitude": "177.66667000"
                    },
                    {
                        "id": 39140,
                        "name": "Lautoka",
                        "latitude": "-17.61686000",
                        "longitude": "177.45049000"
                    },
                    {
                        "id": 39144,
                        "name": "Nadi",
                        "latitude": "-17.80309000",
                        "longitude": "177.41617000"
                    },
                    {
                        "id": 39147,
                        "name": "Nandronga and Navosa Province",
                        "latitude": "-18.00000000",
                        "longitude": "177.66667000"
                    },
                    {
                        "id": 39148,
                        "name": "Ra Province",
                        "latitude": "-17.50000000",
                        "longitude": "178.16667000"
                    }
                ]
            }
        ]
    },
    {
        "id": 74,
        "name": "Finland",
        "iso3": "FIN",
        "iso2": "FI",
        "numeric_code": "246",
        "phonecode": "358",
        "capital": "Helsinki",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".fi",
        "native": "Suomi",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Finnish",
        "timezones": [
            {
                "zoneName": "Europe\/Helsinki",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Finland",
            "ko": "핀란드",
            "pt-BR": "Finlândia",
            "pt": "Finlândia",
            "nl": "Finland",
            "hr": "Finska",
            "fa": "فنلاند",
            "de": "Finnland",
            "es": "Finlandia",
            "fr": "Finlande",
            "ja": "フィンランド",
            "it": "Finlandia",
            "zh-CN": "芬兰",
            "tr": "Finlandiya",
            "ru": "Финляндия",
            "uk": "Фінляндія",
            "pl": "Finlandia"
        },
        "latitude": "64.00000000",
        "longitude": "26.00000000",
        "emoji": "🇫🇮",
        "emojiU": "U+1F1EB U+1F1EE",
        "states": [
            {
                "id": 1509,
                "name": "Åland Islands",
                "iso2": "01",
                "latitude": "60.17852470",
                "longitude": "19.91561050",
                "type": "region",
                "cities": [
                    {
                        "id": 153539,
                        "name": "Brändö",
                        "latitude": "60.40750000",
                        "longitude": "21.07860000"
                    },
                    {
                        "id": 153536,
                        "name": "Eckerö",
                        "latitude": "60.22080000",
                        "longitude": "19.55890000"
                    },
                    {
                        "id": 153531,
                        "name": "Finström",
                        "latitude": "60.23420000",
                        "longitude": "20.11390000"
                    },
                    {
                        "id": 153537,
                        "name": "Föglö",
                        "latitude": "60.09890000",
                        "longitude": "20.37280000"
                    },
                    {
                        "id": 153538,
                        "name": "Geta",
                        "latitude": "60.41830000",
                        "longitude": "19.71670000"
                    },
                    {
                        "id": 153535,
                        "name": "Hammarland",
                        "latitude": "60.24470000",
                        "longitude": "19.68920000"
                    },
                    {
                        "id": 153530,
                        "name": "Jomala",
                        "latitude": "60.11810000",
                        "longitude": "19.89890000"
                    },
                    {
                        "id": 153540,
                        "name": "Kumlinge",
                        "latitude": "60.39920000",
                        "longitude": "20.76920000"
                    },
                    {
                        "id": 153532,
                        "name": "Lemland",
                        "latitude": "60.09250000",
                        "longitude": "20.15440000"
                    },
                    {
                        "id": 153529,
                        "name": "Mariehamn",
                        "latitude": "60.10260000",
                        "longitude": "19.93480000"
                    },
                    {
                        "id": 153533,
                        "name": "Saltvik",
                        "latitude": "60.35750000",
                        "longitude": "20.15470000"
                    },
                    {
                        "id": 153534,
                        "name": "Sund",
                        "latitude": "60.23610000",
                        "longitude": "20.21560000"
                    }
                ]
            },
            {
                "id": 1511,
                "name": "Central Finland",
                "iso2": "08",
                "latitude": "62.56667430",
                "longitude": "25.55494450",
                "type": "region",
                "cities": [
                    {
                        "id": 39132,
                        "name": "Äänekoski",
                        "latitude": "62.60000000",
                        "longitude": "25.73333000"
                    },
                    {
                        "id": 38760,
                        "name": "Hankasalmi",
                        "latitude": "62.38333000",
                        "longitude": "26.43333000"
                    },
                    {
                        "id": 38809,
                        "name": "Jämsä",
                        "latitude": "61.86420000",
                        "longitude": "25.19002000"
                    },
                    {
                        "id": 38810,
                        "name": "Jämsänkoski",
                        "latitude": "61.91900000",
                        "longitude": "25.17011000"
                    },
                    {
                        "id": 38801,
                        "name": "Joutsa",
                        "latitude": "61.73333000",
                        "longitude": "26.11667000"
                    },
                    {
                        "id": 38807,
                        "name": "Jyväskylä",
                        "latitude": "62.24147000",
                        "longitude": "25.72088000"
                    },
                    {
                        "id": 38823,
                        "name": "Kannonkoski",
                        "latitude": "62.96667000",
                        "longitude": "25.25000000"
                    },
                    {
                        "id": 38831,
                        "name": "Karstula",
                        "latitude": "62.86667000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 38849,
                        "name": "Keuruu",
                        "latitude": "62.26667000",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 38855,
                        "name": "Kinnula",
                        "latitude": "63.38333000",
                        "longitude": "24.95000000"
                    },
                    {
                        "id": 38862,
                        "name": "Kivijärvi",
                        "latitude": "63.11984000",
                        "longitude": "25.07835000"
                    },
                    {
                        "id": 38866,
                        "name": "Konnevesi",
                        "latitude": "62.61667000",
                        "longitude": "26.31667000"
                    },
                    {
                        "id": 38868,
                        "name": "Korpilahti",
                        "latitude": "62.01667000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 38878,
                        "name": "Kuhmoinen",
                        "latitude": "61.56667000",
                        "longitude": "25.18333000"
                    },
                    {
                        "id": 38887,
                        "name": "Kyyjärvi",
                        "latitude": "63.03333000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 38903,
                        "name": "Laukaa",
                        "latitude": "62.41407000",
                        "longitude": "25.95194000"
                    },
                    {
                        "id": 38907,
                        "name": "Leivonmäki",
                        "latitude": "61.91198000",
                        "longitude": "26.12796000"
                    },
                    {
                        "id": 38921,
                        "name": "Luhanka",
                        "latitude": "61.79682000",
                        "longitude": "25.70457000"
                    },
                    {
                        "id": 38939,
                        "name": "Multia",
                        "latitude": "62.41667000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 38942,
                        "name": "Muurame",
                        "latitude": "62.13333000",
                        "longitude": "25.66667000"
                    },
                    {
                        "id": 38982,
                        "name": "Petäjävesi",
                        "latitude": "62.25000000",
                        "longitude": "25.20000000"
                    },
                    {
                        "id": 38985,
                        "name": "Pihtipudas",
                        "latitude": "63.38333000",
                        "longitude": "25.56667000"
                    },
                    {
                        "id": 39008,
                        "name": "Pylkönmäki",
                        "latitude": "62.66667000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 39035,
                        "name": "Saarijärvi",
                        "latitude": "62.70486000",
                        "longitude": "25.25396000"
                    },
                    {
                        "id": 39066,
                        "name": "Säynätsalo",
                        "latitude": "62.14025000",
                        "longitude": "25.76948000"
                    },
                    {
                        "id": 39058,
                        "name": "Sumiainen",
                        "latitude": "62.65736000",
                        "longitude": "26.04642000"
                    },
                    {
                        "id": 39059,
                        "name": "Suolahti",
                        "latitude": "62.56421000",
                        "longitude": "25.85363000"
                    },
                    {
                        "id": 39079,
                        "name": "Toivakka",
                        "latitude": "62.10000000",
                        "longitude": "26.08333000"
                    },
                    {
                        "id": 39092,
                        "name": "Uurainen",
                        "latitude": "62.50000000",
                        "longitude": "25.45000000"
                    },
                    {
                        "id": 39110,
                        "name": "Viitasaari",
                        "latitude": "63.06667000",
                        "longitude": "25.86667000"
                    }
                ]
            },
            {
                "id": 1494,
                "name": "Central Ostrobothnia",
                "iso2": "07",
                "latitude": "63.56217350",
                "longitude": "24.00136310",
                "type": "region",
                "cities": [
                    {
                        "id": 38758,
                        "name": "Halsua",
                        "latitude": "63.46667000",
                        "longitude": "24.16667000"
                    },
                    {
                        "id": 38888,
                        "name": "Kälviä",
                        "latitude": "63.86067000",
                        "longitude": "23.45289000"
                    },
                    {
                        "id": 38824,
                        "name": "Kannus",
                        "latitude": "63.90000000",
                        "longitude": "23.90000000"
                    },
                    {
                        "id": 38838,
                        "name": "Kaustinen",
                        "latitude": "63.54878000",
                        "longitude": "23.68845000"
                    },
                    {
                        "id": 38864,
                        "name": "Kokkola",
                        "latitude": "63.85414000",
                        "longitude": "23.58562000"
                    },
                    {
                        "id": 38911,
                        "name": "Lestijärvi",
                        "latitude": "63.53333000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 38918,
                        "name": "Lohtaja",
                        "latitude": "64.02472000",
                        "longitude": "23.50482000"
                    },
                    {
                        "id": 38977,
                        "name": "Perho",
                        "latitude": "63.21667000",
                        "longitude": "24.41667000"
                    },
                    {
                        "id": 39078,
                        "name": "Toholampi",
                        "latitude": "63.76667000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 39088,
                        "name": "Ullava",
                        "latitude": "63.60000000",
                        "longitude": "24.08333000"
                    },
                    {
                        "id": 39106,
                        "name": "Veteli",
                        "latitude": "63.47839000",
                        "longitude": "23.78285000"
                    }
                ]
            },
            {
                "id": 1507,
                "name": "Finland Proper",
                "iso2": "19",
                "latitude": "60.36279140",
                "longitude": "22.44393690",
                "type": "region",
                "cities": [
                    {
                        "id": 38732,
                        "name": "Alastaro",
                        "latitude": "60.95000000",
                        "longitude": "22.85000000"
                    },
                    {
                        "id": 38738,
                        "name": "Askainen",
                        "latitude": "60.56667000",
                        "longitude": "21.86667000"
                    },
                    {
                        "id": 38740,
                        "name": "Aura",
                        "latitude": "60.64710000",
                        "longitude": "22.58755000"
                    },
                    {
                        "id": 38742,
                        "name": "Dragsfjärd",
                        "latitude": "60.06667000",
                        "longitude": "22.48333000"
                    },
                    {
                        "id": 38757,
                        "name": "Halikko",
                        "latitude": "60.40000000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 38775,
                        "name": "Houtskär",
                        "latitude": "60.22284000",
                        "longitude": "21.37218000"
                    },
                    {
                        "id": 38790,
                        "name": "Iniö",
                        "latitude": "60.40000000",
                        "longitude": "21.40000000"
                    },
                    {
                        "id": 38814,
                        "name": "Kaarina",
                        "latitude": "60.40724000",
                        "longitude": "22.36904000"
                    },
                    {
                        "id": 38827,
                        "name": "Karinainen",
                        "latitude": "60.66667000",
                        "longitude": "22.76667000"
                    },
                    {
                        "id": 38851,
                        "name": "Kiikala",
                        "latitude": "60.46667000",
                        "longitude": "23.56667000"
                    },
                    {
                        "id": 38854,
                        "name": "Kimito",
                        "latitude": "60.16047000",
                        "longitude": "22.72900000"
                    },
                    {
                        "id": 38857,
                        "name": "Kisko",
                        "latitude": "60.23333000",
                        "longitude": "23.48333000"
                    },
                    {
                        "id": 38884,
                        "name": "Kustavi",
                        "latitude": "60.54529000",
                        "longitude": "21.35880000"
                    },
                    {
                        "id": 38886,
                        "name": "Kuusjoki",
                        "latitude": "60.51667000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 38894,
                        "name": "Laitila",
                        "latitude": "60.87575000",
                        "longitude": "21.69765000"
                    },
                    {
                        "id": 38909,
                        "name": "Lemu",
                        "latitude": "60.56667000",
                        "longitude": "21.96667000"
                    },
                    {
                        "id": 38913,
                        "name": "Lieto",
                        "latitude": "60.51032000",
                        "longitude": "22.46176000"
                    },
                    {
                        "id": 38928,
                        "name": "Marttila",
                        "latitude": "60.58333000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 38929,
                        "name": "Masku",
                        "latitude": "60.57082000",
                        "longitude": "22.09883000"
                    },
                    {
                        "id": 38930,
                        "name": "Mellilä",
                        "latitude": "60.76667000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 38934,
                        "name": "Merimasku",
                        "latitude": "60.48333000",
                        "longitude": "21.86667000"
                    },
                    {
                        "id": 38936,
                        "name": "Mietoinen",
                        "latitude": "60.63333000",
                        "longitude": "21.93333000"
                    },
                    {
                        "id": 38943,
                        "name": "Muurla",
                        "latitude": "60.35000000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 38944,
                        "name": "Mynämäki",
                        "latitude": "60.67915000",
                        "longitude": "21.99274000"
                    },
                    {
                        "id": 38948,
                        "name": "Naantali",
                        "latitude": "60.46744000",
                        "longitude": "22.02428000"
                    },
                    {
                        "id": 38949,
                        "name": "Nagu",
                        "latitude": "60.19375000",
                        "longitude": "21.90972000"
                    },
                    {
                        "id": 38955,
                        "name": "Nousiainen",
                        "latitude": "60.60416000",
                        "longitude": "22.07926000"
                    },
                    {
                        "id": 38963,
                        "name": "Oripää",
                        "latitude": "60.85000000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 38970,
                        "name": "Paimio",
                        "latitude": "60.45671000",
                        "longitude": "22.68694000"
                    },
                    {
                        "id": 38972,
                        "name": "Pargas",
                        "latitude": "60.30672000",
                        "longitude": "22.30097000"
                    },
                    {
                        "id": 38978,
                        "name": "Perniö",
                        "latitude": "60.20000000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 38980,
                        "name": "Pertteli",
                        "latitude": "60.43333000",
                        "longitude": "23.26667000"
                    },
                    {
                        "id": 38986,
                        "name": "Piikkiö",
                        "latitude": "60.42481000",
                        "longitude": "22.51601000"
                    },
                    {
                        "id": 39009,
                        "name": "Pöytyä",
                        "latitude": "60.76667000",
                        "longitude": "22.66667000"
                    },
                    {
                        "id": 39006,
                        "name": "Pyhäranta",
                        "latitude": "60.95000000",
                        "longitude": "21.45000000"
                    },
                    {
                        "id": 39012,
                        "name": "Raisio",
                        "latitude": "60.48592000",
                        "longitude": "22.16895000"
                    },
                    {
                        "id": 39030,
                        "name": "Rusko",
                        "latitude": "60.53333000",
                        "longitude": "22.21667000"
                    },
                    {
                        "id": 39032,
                        "name": "Rymättylä",
                        "latitude": "60.37658000",
                        "longitude": "21.94184000"
                    },
                    {
                        "id": 39037,
                        "name": "Salo",
                        "latitude": "60.38333000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 39065,
                        "name": "Särkisalo",
                        "latitude": "60.11389000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 39039,
                        "name": "Sauvo",
                        "latitude": "60.34306000",
                        "longitude": "22.69642000"
                    },
                    {
                        "id": 39054,
                        "name": "Somero",
                        "latitude": "60.61667000",
                        "longitude": "23.53333000"
                    },
                    {
                        "id": 39060,
                        "name": "Suomusjärvi",
                        "latitude": "60.35000000",
                        "longitude": "23.65000000"
                    },
                    {
                        "id": 39069,
                        "name": "Taivassalo",
                        "latitude": "60.56085000",
                        "longitude": "21.61639000"
                    },
                    {
                        "id": 39071,
                        "name": "Tarvasjoki",
                        "latitude": "60.58333000",
                        "longitude": "22.73333000"
                    },
                    {
                        "id": 39081,
                        "name": "Turku",
                        "latitude": "60.45148000",
                        "longitude": "22.26869000"
                    },
                    {
                        "id": 39093,
                        "name": "Uusikaupunki",
                        "latitude": "60.80043000",
                        "longitude": "21.40841000"
                    },
                    {
                        "id": 39096,
                        "name": "Vahto",
                        "latitude": "60.60000000",
                        "longitude": "22.30000000"
                    },
                    {
                        "id": 39119,
                        "name": "Väståboland",
                        "latitude": "60.29972000",
                        "longitude": "22.30040000"
                    },
                    {
                        "id": 39118,
                        "name": "Västanfjärd",
                        "latitude": "60.05000000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 39102,
                        "name": "Vehmaa",
                        "latitude": "60.68333000",
                        "longitude": "21.66667000"
                    },
                    {
                        "id": 39104,
                        "name": "Velkua",
                        "latitude": "60.46667000",
                        "longitude": "21.66667000"
                    },
                    {
                        "id": 39128,
                        "name": "Yläne",
                        "latitude": "60.88333000",
                        "longitude": "22.41667000"
                    }
                ]
            },
            {
                "id": 1496,
                "name": "Kainuu",
                "iso2": "05",
                "latitude": "64.37365640",
                "longitude": "28.74374750",
                "type": "region",
                "cities": [
                    {
                        "id": 38778,
                        "name": "Hyrynsalmi",
                        "latitude": "64.66667000",
                        "longitude": "28.53333000"
                    },
                    {
                        "id": 38816,
                        "name": "Kajaani",
                        "latitude": "64.22728000",
                        "longitude": "27.72846000"
                    },
                    {
                        "id": 38877,
                        "name": "Kuhmo",
                        "latitude": "64.13333000",
                        "longitude": "29.51667000"
                    },
                    {
                        "id": 38971,
                        "name": "Paltamo",
                        "latitude": "64.41667000",
                        "longitude": "27.83333000"
                    },
                    {
                        "id": 38999,
                        "name": "Puolanka",
                        "latitude": "64.86667000",
                        "longitude": "27.66667000"
                    },
                    {
                        "id": 39025,
                        "name": "Ristijärvi",
                        "latitude": "64.50000000",
                        "longitude": "28.21667000"
                    },
                    {
                        "id": 39056,
                        "name": "Sotkamo",
                        "latitude": "64.13333000",
                        "longitude": "28.41667000"
                    },
                    {
                        "id": 39061,
                        "name": "Suomussalmi",
                        "latitude": "64.88685000",
                        "longitude": "28.90778000"
                    },
                    {
                        "id": 39094,
                        "name": "Vaala",
                        "latitude": "64.56667000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 39114,
                        "name": "Vuokatti",
                        "latitude": "64.14466000",
                        "longitude": "28.28196000"
                    },
                    {
                        "id": 39115,
                        "name": "Vuolijoki",
                        "latitude": "64.18538000",
                        "longitude": "26.99547000"
                    }
                ]
            },
            {
                "id": 1512,
                "name": "Kymenlaakso",
                "iso2": "09",
                "latitude": "60.78051200",
                "longitude": "26.88293360",
                "type": "region",
                "cities": [
                    {
                        "id": 38735,
                        "name": "Anjala",
                        "latitude": "60.68333000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 38744,
                        "name": "Elimäki",
                        "latitude": "60.71667000",
                        "longitude": "26.46667000"
                    },
                    {
                        "id": 38759,
                        "name": "Hamina",
                        "latitude": "60.56974000",
                        "longitude": "27.19794000"
                    },
                    {
                        "id": 38784,
                        "name": "Iitti",
                        "latitude": "60.89488000",
                        "longitude": "26.33869000"
                    },
                    {
                        "id": 38794,
                        "name": "Jaala",
                        "latitude": "61.05251000",
                        "longitude": "26.48117000"
                    },
                    {
                        "id": 38825,
                        "name": "Karhula",
                        "latitude": "60.52156000",
                        "longitude": "26.93125000"
                    },
                    {
                        "id": 38872,
                        "name": "Kotka",
                        "latitude": "60.46640000",
                        "longitude": "26.94582000"
                    },
                    {
                        "id": 38874,
                        "name": "Kouvola",
                        "latitude": "60.86667000",
                        "longitude": "26.70000000"
                    },
                    {
                        "id": 38935,
                        "name": "Miehikkälä",
                        "latitude": "60.66667000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 39001,
                        "name": "Pyhtää",
                        "latitude": "60.49349000",
                        "longitude": "26.54346000"
                    },
                    {
                        "id": 39112,
                        "name": "Virojoki",
                        "latitude": "60.57940000",
                        "longitude": "27.70354000"
                    }
                ]
            },
            {
                "id": 1500,
                "name": "Lapland",
                "iso2": "10",
                "latitude": "67.92223040",
                "longitude": "26.50464380",
                "type": "region",
                "cities": [
                    {
                        "id": 38747,
                        "name": "Enontekiö",
                        "latitude": "68.38573000",
                        "longitude": "23.63215000"
                    },
                    {
                        "id": 38788,
                        "name": "Inari",
                        "latitude": "68.90596000",
                        "longitude": "27.02881000"
                    },
                    {
                        "id": 38793,
                        "name": "Ivalo",
                        "latitude": "68.65986000",
                        "longitude": "27.53891000"
                    },
                    {
                        "id": 38841,
                        "name": "Kemi",
                        "latitude": "65.73641000",
                        "longitude": "24.56371000"
                    },
                    {
                        "id": 38842,
                        "name": "Kemijärvi",
                        "latitude": "66.71309000",
                        "longitude": "27.43056000"
                    },
                    {
                        "id": 38843,
                        "name": "Keminmaa",
                        "latitude": "65.80158000",
                        "longitude": "24.54483000"
                    },
                    {
                        "id": 38859,
                        "name": "Kittilä",
                        "latitude": "67.66474000",
                        "longitude": "24.89356000"
                    },
                    {
                        "id": 38865,
                        "name": "Kolari",
                        "latitude": "67.33047000",
                        "longitude": "23.77785000"
                    },
                    {
                        "id": 38941,
                        "name": "Muonio",
                        "latitude": "67.95000000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 38975,
                        "name": "Pelkosenniemi",
                        "latitude": "67.11083000",
                        "longitude": "27.51056000"
                    },
                    {
                        "id": 38976,
                        "name": "Pello",
                        "latitude": "66.77364000",
                        "longitude": "23.96255000"
                    },
                    {
                        "id": 38994,
                        "name": "Posio",
                        "latitude": "66.10856000",
                        "longitude": "28.17186000"
                    },
                    {
                        "id": 39004,
                        "name": "Pyhäjärvi",
                        "latitude": "67.07010000",
                        "longitude": "27.21763000"
                    },
                    {
                        "id": 39015,
                        "name": "Ranua",
                        "latitude": "65.91667000",
                        "longitude": "26.53333000"
                    },
                    {
                        "id": 39027,
                        "name": "Rovaniemi",
                        "latitude": "66.50000000",
                        "longitude": "25.71667000"
                    },
                    {
                        "id": 39036,
                        "name": "Salla",
                        "latitude": "66.83333000",
                        "longitude": "28.66667000"
                    },
                    {
                        "id": 39043,
                        "name": "Savukoski",
                        "latitude": "67.29250000",
                        "longitude": "28.15806000"
                    },
                    {
                        "id": 39050,
                        "name": "Simo",
                        "latitude": "65.66667000",
                        "longitude": "25.05000000"
                    },
                    {
                        "id": 39052,
                        "name": "Sodankylä",
                        "latitude": "67.41667000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 39075,
                        "name": "Tervola",
                        "latitude": "66.08333000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 39080,
                        "name": "Tornio",
                        "latitude": "65.84811000",
                        "longitude": "24.14662000"
                    },
                    {
                        "id": 39091,
                        "name": "Utsjoki",
                        "latitude": "69.90864000",
                        "longitude": "27.02843000"
                    },
                    {
                        "id": 39125,
                        "name": "Ylitornio",
                        "latitude": "66.30893000",
                        "longitude": "23.67734000"
                    }
                ]
            },
            {
                "id": 1504,
                "name": "North Karelia",
                "iso2": "13",
                "latitude": "62.80620780",
                "longitude": "30.15538870",
                "type": "region",
                "cities": [
                    {
                        "id": 38745,
                        "name": "Eno",
                        "latitude": "62.80511000",
                        "longitude": "30.15422000"
                    },
                    {
                        "id": 38786,
                        "name": "Ilomantsi",
                        "latitude": "62.67162000",
                        "longitude": "30.93276000"
                    },
                    {
                        "id": 38798,
                        "name": "Joensuu",
                        "latitude": "62.60118000",
                        "longitude": "29.76316000"
                    },
                    {
                        "id": 38805,
                        "name": "Juuka",
                        "latitude": "63.23333000",
                        "longitude": "29.25000000"
                    },
                    {
                        "id": 38848,
                        "name": "Kesälahti",
                        "latitude": "61.89752000",
                        "longitude": "29.83494000"
                    },
                    {
                        "id": 38850,
                        "name": "Kiihtelysvaara",
                        "latitude": "62.49525000",
                        "longitude": "30.25081000"
                    },
                    {
                        "id": 38858,
                        "name": "Kitee",
                        "latitude": "62.10000000",
                        "longitude": "30.15000000"
                    },
                    {
                        "id": 38867,
                        "name": "Kontiolahti",
                        "latitude": "62.76023000",
                        "longitude": "29.84711000"
                    },
                    {
                        "id": 38912,
                        "name": "Lieksa",
                        "latitude": "63.31667000",
                        "longitude": "30.01667000"
                    },
                    {
                        "id": 38916,
                        "name": "Liperi",
                        "latitude": "62.53333000",
                        "longitude": "29.36667000"
                    },
                    {
                        "id": 38957,
                        "name": "Nurmes",
                        "latitude": "63.54205000",
                        "longitude": "29.13965000"
                    },
                    {
                        "id": 38968,
                        "name": "Outokumpu",
                        "latitude": "62.72685000",
                        "longitude": "29.01592000"
                    },
                    {
                        "id": 38989,
                        "name": "Polvijärvi",
                        "latitude": "62.85000000",
                        "longitude": "29.36667000"
                    },
                    {
                        "id": 39007,
                        "name": "Pyhäselkä",
                        "latitude": "62.43333000",
                        "longitude": "29.96667000"
                    },
                    {
                        "id": 39033,
                        "name": "Rääkkylä",
                        "latitude": "62.31667000",
                        "longitude": "29.61667000"
                    },
                    {
                        "id": 39077,
                        "name": "Tohmajärvi",
                        "latitude": "62.18333000",
                        "longitude": "30.38333000"
                    },
                    {
                        "id": 39083,
                        "name": "Tuupovaara",
                        "latitude": "62.48372000",
                        "longitude": "30.62731000"
                    },
                    {
                        "id": 39097,
                        "name": "Valtimo",
                        "latitude": "63.66667000",
                        "longitude": "28.80000000"
                    }
                ]
            },
            {
                "id": 1505,
                "name": "Northern Ostrobothnia",
                "iso2": "14",
                "latitude": "65.27949300",
                "longitude": "26.28904170",
                "type": "region",
                "cities": [
                    {
                        "id": 38733,
                        "name": "Alavieska",
                        "latitude": "64.16667000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 38754,
                        "name": "Haapajärvi",
                        "latitude": "63.75000000",
                        "longitude": "25.33333000"
                    },
                    {
                        "id": 38755,
                        "name": "Haapavesi",
                        "latitude": "64.13333000",
                        "longitude": "25.36667000"
                    },
                    {
                        "id": 38756,
                        "name": "Hailuoto",
                        "latitude": "65.00900000",
                        "longitude": "24.71385000"
                    },
                    {
                        "id": 38765,
                        "name": "Haukipudas",
                        "latitude": "65.17654000",
                        "longitude": "25.35233000"
                    },
                    {
                        "id": 38772,
                        "name": "Himanka",
                        "latitude": "64.06218000",
                        "longitude": "23.65447000"
                    },
                    {
                        "id": 38782,
                        "name": "Ii",
                        "latitude": "65.31735000",
                        "longitude": "25.37310000"
                    },
                    {
                        "id": 38817,
                        "name": "Kalajoki",
                        "latitude": "64.25000000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 38890,
                        "name": "Kärsämäki",
                        "latitude": "63.96667000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 38844,
                        "name": "Kempele",
                        "latitude": "64.91314000",
                        "longitude": "25.50339000"
                    },
                    {
                        "id": 38847,
                        "name": "Kestilä",
                        "latitude": "64.35002000",
                        "longitude": "26.27921000"
                    },
                    {
                        "id": 38852,
                        "name": "Kiiminki",
                        "latitude": "65.13139000",
                        "longitude": "25.79744000"
                    },
                    {
                        "id": 38879,
                        "name": "Kuivaniemi",
                        "latitude": "65.57847000",
                        "longitude": "25.18814000"
                    },
                    {
                        "id": 38885,
                        "name": "Kuusamo",
                        "latitude": "65.96667000",
                        "longitude": "29.18333000"
                    },
                    {
                        "id": 38915,
                        "name": "Liminka",
                        "latitude": "64.80985000",
                        "longitude": "25.41545000"
                    },
                    {
                        "id": 38922,
                        "name": "Lumijoki",
                        "latitude": "64.83744000",
                        "longitude": "25.18607000"
                    },
                    {
                        "id": 38932,
                        "name": "Merijärvi",
                        "latitude": "64.30000000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 38938,
                        "name": "Muhos",
                        "latitude": "64.80798000",
                        "longitude": "25.99314000"
                    },
                    {
                        "id": 38953,
                        "name": "Nivala",
                        "latitude": "63.91667000",
                        "longitude": "24.96667000"
                    },
                    {
                        "id": 38965,
                        "name": "Oulainen",
                        "latitude": "64.26667000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 38966,
                        "name": "Oulu",
                        "latitude": "65.01236000",
                        "longitude": "25.46816000"
                    },
                    {
                        "id": 38967,
                        "name": "Oulunsalo",
                        "latitude": "64.93456000",
                        "longitude": "25.41121000"
                    },
                    {
                        "id": 38987,
                        "name": "Piippola",
                        "latitude": "64.16667000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 38995,
                        "name": "Pudasjärvi",
                        "latitude": "65.38333000",
                        "longitude": "26.91667000"
                    },
                    {
                        "id": 38997,
                        "name": "Pulkkila",
                        "latitude": "64.26667000",
                        "longitude": "25.86667000"
                    },
                    {
                        "id": 39003,
                        "name": "Pyhäjärvi",
                        "latitude": "63.66667000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 39002,
                        "name": "Pyhäjoki",
                        "latitude": "64.46667000",
                        "longitude": "24.23333000"
                    },
                    {
                        "id": 39005,
                        "name": "Pyhäntä",
                        "latitude": "64.10000000",
                        "longitude": "26.31667000"
                    },
                    {
                        "id": 39010,
                        "name": "Raahe",
                        "latitude": "64.68333000",
                        "longitude": "24.48333000"
                    },
                    {
                        "id": 39014,
                        "name": "Rantsila",
                        "latitude": "64.50613000",
                        "longitude": "25.66449000"
                    },
                    {
                        "id": 39020,
                        "name": "Reisjärvi",
                        "latitude": "63.61667000",
                        "longitude": "24.90000000"
                    },
                    {
                        "id": 39031,
                        "name": "Ruukki",
                        "latitude": "64.66667000",
                        "longitude": "25.10000000"
                    },
                    {
                        "id": 39046,
                        "name": "Sievi",
                        "latitude": "63.90000000",
                        "longitude": "24.50000000"
                    },
                    {
                        "id": 39048,
                        "name": "Siikajoki",
                        "latitude": "64.81455000",
                        "longitude": "24.75924000"
                    },
                    {
                        "id": 39068,
                        "name": "Taivalkoski",
                        "latitude": "65.56667000",
                        "longitude": "28.25000000"
                    },
                    {
                        "id": 39086,
                        "name": "Tyrnävä",
                        "latitude": "64.76469000",
                        "longitude": "25.65230000"
                    },
                    {
                        "id": 39090,
                        "name": "Utajärvi",
                        "latitude": "64.75000000",
                        "longitude": "26.38333000"
                    },
                    {
                        "id": 39108,
                        "name": "Vihanti",
                        "latitude": "64.48472000",
                        "longitude": "24.99157000"
                    },
                    {
                        "id": 39121,
                        "name": "Yli-Ii",
                        "latitude": "65.37181000",
                        "longitude": "25.84580000"
                    },
                    {
                        "id": 39123,
                        "name": "Ylikiiminki",
                        "latitude": "65.08333000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 39126,
                        "name": "Ylivieska",
                        "latitude": "64.08333000",
                        "longitude": "24.55000000"
                    }
                ]
            },
            {
                "id": 1503,
                "name": "Northern Savonia",
                "iso2": "15",
                "latitude": "63.08448000",
                "longitude": "27.02535040",
                "type": "region",
                "cities": []
            },
            {
                "id": 1508,
                "name": "Ostrobothnia",
                "iso2": "12",
                "latitude": "63.11817570",
                "longitude": "21.90610620",
                "type": "region",
                "cities": [
                    {
                        "id": 38771,
                        "name": "Hietalahti",
                        "latitude": "63.08480000",
                        "longitude": "21.61716000"
                    },
                    {
                        "id": 38792,
                        "name": "Isokyrö",
                        "latitude": "63.01172000",
                        "longitude": "22.33332000"
                    },
                    {
                        "id": 38795,
                        "name": "Jakobstad",
                        "latitude": "63.67486000",
                        "longitude": "22.70256000"
                    },
                    {
                        "id": 38834,
                        "name": "Kaskinen",
                        "latitude": "62.38444000",
                        "longitude": "21.22331000"
                    },
                    {
                        "id": 38869,
                        "name": "Korsholm",
                        "latitude": "63.11418000",
                        "longitude": "21.68216000"
                    },
                    {
                        "id": 38870,
                        "name": "Korsnäs",
                        "latitude": "62.78333000",
                        "longitude": "21.20000000"
                    },
                    {
                        "id": 38875,
                        "name": "Kristinestad",
                        "latitude": "62.27429000",
                        "longitude": "21.37596000"
                    },
                    {
                        "id": 38876,
                        "name": "Kronoby",
                        "latitude": "63.72859000",
                        "longitude": "23.03387000"
                    },
                    {
                        "id": 38893,
                        "name": "Laihia",
                        "latitude": "62.97609000",
                        "longitude": "22.01143000"
                    },
                    {
                        "id": 38902,
                        "name": "Larsmo",
                        "latitude": "63.75388000",
                        "longitude": "22.74728000"
                    },
                    {
                        "id": 38927,
                        "name": "Malax",
                        "latitude": "62.94225000",
                        "longitude": "21.57311000"
                    },
                    {
                        "id": 38960,
                        "name": "Nykarleby",
                        "latitude": "63.52277000",
                        "longitude": "22.53073000"
                    },
                    {
                        "id": 38961,
                        "name": "Oravais",
                        "latitude": "63.30135000",
                        "longitude": "22.37821000"
                    },
                    {
                        "id": 38974,
                        "name": "Pedersöre",
                        "latitude": "63.65000000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 39022,
                        "name": "Replot",
                        "latitude": "63.22882000",
                        "longitude": "21.41691000"
                    },
                    {
                        "id": 39026,
                        "name": "Ristinummi",
                        "latitude": "63.09192000",
                        "longitude": "21.72297000"
                    },
                    {
                        "id": 39072,
                        "name": "Teeriniemi",
                        "latitude": "63.09705000",
                        "longitude": "21.69590000"
                    },
                    {
                        "id": 39095,
                        "name": "Vaasa",
                        "latitude": "63.09600000",
                        "longitude": "21.61577000"
                    },
                    {
                        "id": 39117,
                        "name": "Vähäkyrö",
                        "latitude": "63.05635000",
                        "longitude": "22.10584000"
                    },
                    {
                        "id": 39120,
                        "name": "Vörå",
                        "latitude": "63.13607000",
                        "longitude": "22.25223000"
                    }
                ]
            },
            {
                "id": 1502,
                "name": "Päijänne Tavastia",
                "iso2": "16",
                "latitude": "61.32300410",
                "longitude": "25.73224960",
                "type": "region",
                "cities": [
                    {
                        "id": 38736,
                        "name": "Artjärvi",
                        "latitude": "60.74544000",
                        "longitude": "26.07084000"
                    },
                    {
                        "id": 38737,
                        "name": "Asikkala",
                        "latitude": "61.21667000",
                        "longitude": "25.50000000"
                    },
                    {
                        "id": 38741,
                        "name": "Auttoinen",
                        "latitude": "61.29901000",
                        "longitude": "25.08887000"
                    },
                    {
                        "id": 38780,
                        "name": "Hämeenkoski",
                        "latitude": "61.02222000",
                        "longitude": "25.15417000"
                    },
                    {
                        "id": 38763,
                        "name": "Hartola",
                        "latitude": "61.58333000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 38768,
                        "name": "Heinola",
                        "latitude": "61.20564000",
                        "longitude": "26.03811000"
                    },
                    {
                        "id": 38774,
                        "name": "Hollola",
                        "latitude": "61.05000000",
                        "longitude": "25.43333000"
                    },
                    {
                        "id": 38892,
                        "name": "Lahti",
                        "latitude": "60.98267000",
                        "longitude": "25.66151000"
                    },
                    {
                        "id": 38951,
                        "name": "Nastola",
                        "latitude": "60.95000000",
                        "longitude": "25.93333000"
                    },
                    {
                        "id": 38962,
                        "name": "Orimattila",
                        "latitude": "60.80487000",
                        "longitude": "25.72964000"
                    },
                    {
                        "id": 38969,
                        "name": "Padasjoki",
                        "latitude": "61.35000000",
                        "longitude": "25.28333000"
                    },
                    {
                        "id": 39063,
                        "name": "Sysmä",
                        "latitude": "61.50000000",
                        "longitude": "25.68333000"
                    }
                ]
            },
            {
                "id": 1506,
                "name": "Pirkanmaa",
                "iso2": "11",
                "latitude": "61.69869180",
                "longitude": "23.78955980",
                "type": "region",
                "cities": [
                    {
                        "id": 153349,
                        "name": "Äetsä",
                        "latitude": "61.28333000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 153290,
                        "name": "Aimala",
                        "latitude": "61.33000000",
                        "longitude": "23.69000000"
                    },
                    {
                        "id": 153291,
                        "name": "Aitoo",
                        "latitude": "61.33897400",
                        "longitude": "24.49431900"
                    },
                    {
                        "id": 153292,
                        "name": "Akaa",
                        "latitude": "61.16666667",
                        "longitude": "23.86805556"
                    },
                    {
                        "id": 153293,
                        "name": "Amuri",
                        "latitude": "61.50000000",
                        "longitude": "23.74500000"
                    },
                    {
                        "id": 153294,
                        "name": "Haihara",
                        "latitude": "61.47630000",
                        "longitude": "23.87711000"
                    },
                    {
                        "id": 153295,
                        "name": "Hallila",
                        "latitude": "61.46250000",
                        "longitude": "23.82916667"
                    },
                    {
                        "id": 153297,
                        "name": "Hämeenkyrö",
                        "latitude": "61.63333333",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 153296,
                        "name": "Hervanta",
                        "latitude": "61.44810000",
                        "longitude": "23.85210000"
                    },
                    {
                        "id": 153298,
                        "name": "Ikaalinen",
                        "latitude": "61.76944444",
                        "longitude": "23.06805556"
                    },
                    {
                        "id": 153299,
                        "name": "Juupajoki",
                        "latitude": "61.79666667",
                        "longitude": "24.37000000"
                    },
                    {
                        "id": 153300,
                        "name": "Kangasala",
                        "latitude": "61.46388900",
                        "longitude": "24.06500000"
                    },
                    {
                        "id": 153301,
                        "name": "Kihniö",
                        "latitude": "62.20833333",
                        "longitude": "23.17916667"
                    },
                    {
                        "id": 153302,
                        "name": "Kiikka",
                        "latitude": "61.32077778",
                        "longitude": "22.77538889"
                    },
                    {
                        "id": 153303,
                        "name": "Kiikoinen",
                        "latitude": "61.45000000",
                        "longitude": "22.57500000"
                    },
                    {
                        "id": 153304,
                        "name": "Kolho",
                        "latitude": "62.13333333",
                        "longitude": "24.51666667"
                    },
                    {
                        "id": 153305,
                        "name": "Kuhmalahti",
                        "latitude": "61.50500000",
                        "longitude": "24.56666667"
                    },
                    {
                        "id": 153306,
                        "name": "Kuru",
                        "latitude": "61.87558000",
                        "longitude": "23.71948000"
                    },
                    {
                        "id": 153307,
                        "name": "Kylmäkoski",
                        "latitude": "61.15000000",
                        "longitude": "23.69166667"
                    },
                    {
                        "id": 153312,
                        "name": "Längelmäki",
                        "latitude": "61.68890000",
                        "longitude": "24.69194000"
                    },
                    {
                        "id": 153308,
                        "name": "Lempäälä",
                        "latitude": "61.31388889",
                        "longitude": "23.75277778"
                    },
                    {
                        "id": 153309,
                        "name": "Lentävänniemi",
                        "latitude": "61.52801000",
                        "longitude": "23.70575000"
                    },
                    {
                        "id": 153310,
                        "name": "Lielahti",
                        "latitude": "61.51666667",
                        "longitude": "23.66666667"
                    },
                    {
                        "id": 153311,
                        "name": "Luopioinen",
                        "latitude": "61.36293000",
                        "longitude": "24.66781000"
                    },
                    {
                        "id": 153315,
                        "name": "Mänttä",
                        "latitude": "62.03014000",
                        "longitude": "24.62791000"
                    },
                    {
                        "id": 153313,
                        "name": "Messukylä",
                        "latitude": "61.48527778",
                        "longitude": "23.84472222"
                    },
                    {
                        "id": 153314,
                        "name": "Mouhijärvi",
                        "latitude": "61.50000000",
                        "longitude": "23.01667000"
                    },
                    {
                        "id": 153316,
                        "name": "Naistenmatka",
                        "latitude": "61.46518000",
                        "longitude": "23.65253000"
                    },
                    {
                        "id": 153317,
                        "name": "Nekala",
                        "latitude": "61.48333333",
                        "longitude": "23.79055556"
                    },
                    {
                        "id": 153318,
                        "name": "Nokia",
                        "latitude": "61.47666667",
                        "longitude": "23.50527778"
                    },
                    {
                        "id": 153319,
                        "name": "Nurmi",
                        "latitude": "61.53779000",
                        "longitude": "23.94178000"
                    },
                    {
                        "id": 153320,
                        "name": "Nuutajärvi",
                        "latitude": "61.04000000",
                        "longitude": "23.43000000"
                    },
                    {
                        "id": 153321,
                        "name": "Orivesi",
                        "latitude": "61.67777778",
                        "longitude": "24.35694444"
                    },
                    {
                        "id": 153322,
                        "name": "Osara",
                        "latitude": "61.70866000",
                        "longitude": "23.15871000"
                    },
                    {
                        "id": 153328,
                        "name": "Pälkäne",
                        "latitude": "61.35403000",
                        "longitude": "24.51912000"
                    },
                    {
                        "id": 153323,
                        "name": "Parkano",
                        "latitude": "62.00972222",
                        "longitude": "23.02500000"
                    },
                    {
                        "id": 153324,
                        "name": "Pirkkala",
                        "latitude": "61.46666667",
                        "longitude": "23.65000000"
                    },
                    {
                        "id": 153325,
                        "name": "Pispala",
                        "latitude": "61.50611111",
                        "longitude": "23.70250000"
                    },
                    {
                        "id": 153326,
                        "name": "Pohjaslahti",
                        "latitude": "62.15631000",
                        "longitude": "24.13190000"
                    },
                    {
                        "id": 153327,
                        "name": "Punkalaidun",
                        "latitude": "61.11166667",
                        "longitude": "23.10500000"
                    },
                    {
                        "id": 153329,
                        "name": "Ruovesi",
                        "latitude": "61.98333300",
                        "longitude": "24.08333300"
                    },
                    {
                        "id": 153334,
                        "name": "Sääksmäki",
                        "latitude": "61.20000000",
                        "longitude": "24.06666667"
                    },
                    {
                        "id": 153330,
                        "name": "Sahalahti",
                        "latitude": "61.46666667",
                        "longitude": "24.31666667"
                    },
                    {
                        "id": 153331,
                        "name": "Sastamala",
                        "latitude": "61.34166667",
                        "longitude": "22.90833333"
                    },
                    {
                        "id": 153332,
                        "name": "Suodenniemi",
                        "latitude": "61.55810000",
                        "longitude": "22.78526000"
                    },
                    {
                        "id": 153333,
                        "name": "Suoniemi",
                        "latitude": "61.44111111",
                        "longitude": "23.21500000"
                    },
                    {
                        "id": 153335,
                        "name": "Tampere",
                        "latitude": "61.49805556",
                        "longitude": "23.76000000"
                    },
                    {
                        "id": 153336,
                        "name": "Teisko",
                        "latitude": "61.67336111",
                        "longitude": "23.84766944"
                    },
                    {
                        "id": 153337,
                        "name": "Toijala",
                        "latitude": "61.16780000",
                        "longitude": "23.83819000"
                    },
                    {
                        "id": 153338,
                        "name": "Tottijärvi",
                        "latitude": "61.39777778",
                        "longitude": "23.34277778"
                    },
                    {
                        "id": 153339,
                        "name": "Urjala",
                        "latitude": "61.08333333",
                        "longitude": "23.55000000"
                    },
                    {
                        "id": 153340,
                        "name": "Valkeakoski",
                        "latitude": "61.26666667",
                        "longitude": "24.03055556"
                    },
                    {
                        "id": 153341,
                        "name": "Vammala",
                        "latitude": "61.34027778",
                        "longitude": "22.90972222"
                    },
                    {
                        "id": 153342,
                        "name": "Vesilahti",
                        "latitude": "61.31666700",
                        "longitude": "23.61666700"
                    },
                    {
                        "id": 153343,
                        "name": "Viiala",
                        "latitude": "61.21023000",
                        "longitude": "23.76738000"
                    },
                    {
                        "id": 153344,
                        "name": "Viljakkala",
                        "latitude": "61.70601000",
                        "longitude": "23.26688000"
                    },
                    {
                        "id": 153345,
                        "name": "Vilppula",
                        "latitude": "62.02121000",
                        "longitude": "24.50483000"
                    },
                    {
                        "id": 153346,
                        "name": "Virrat",
                        "latitude": "62.24027778",
                        "longitude": "23.77083333"
                    },
                    {
                        "id": 153347,
                        "name": "Vuores",
                        "latitude": "61.43100000",
                        "longitude": "23.81184000"
                    },
                    {
                        "id": 153348,
                        "name": "Ylöjärvi",
                        "latitude": "61.55000000",
                        "longitude": "23.58333333"
                    }
                ]
            },
            {
                "id": 1501,
                "name": "Satakunta",
                "iso2": "17",
                "latitude": "61.59327580",
                "longitude": "22.14830810",
                "type": "region",
                "cities": [
                    {
                        "id": 38749,
                        "name": "Eura",
                        "latitude": "61.13333000",
                        "longitude": "22.13333000"
                    },
                    {
                        "id": 38750,
                        "name": "Eurajoki",
                        "latitude": "61.20000000",
                        "longitude": "21.73333000"
                    },
                    {
                        "id": 38762,
                        "name": "Harjavalta",
                        "latitude": "61.31667000",
                        "longitude": "22.13333000"
                    },
                    {
                        "id": 38776,
                        "name": "Huittinen",
                        "latitude": "61.18333000",
                        "longitude": "22.70000000"
                    },
                    {
                        "id": 38808,
                        "name": "Jämijärvi",
                        "latitude": "61.81667000",
                        "longitude": "22.70000000"
                    },
                    {
                        "id": 38822,
                        "name": "Kankaanpää",
                        "latitude": "61.80000000",
                        "longitude": "22.41667000"
                    },
                    {
                        "id": 38833,
                        "name": "Karvia",
                        "latitude": "62.13333000",
                        "longitude": "22.56667000"
                    },
                    {
                        "id": 38860,
                        "name": "Kiukainen",
                        "latitude": "61.21667000",
                        "longitude": "22.08333000"
                    },
                    {
                        "id": 38863,
                        "name": "Kokemäki",
                        "latitude": "61.25647000",
                        "longitude": "22.35643000"
                    },
                    {
                        "id": 38891,
                        "name": "Köyliö",
                        "latitude": "61.11910000",
                        "longitude": "22.30976000"
                    },
                    {
                        "id": 38880,
                        "name": "Kullaa",
                        "latitude": "61.46998000",
                        "longitude": "22.16145000"
                    },
                    {
                        "id": 38925,
                        "name": "Längelmäki",
                        "latitude": "61.65000000",
                        "longitude": "22.10000000"
                    },
                    {
                        "id": 38900,
                        "name": "Lappi",
                        "latitude": "61.10000000",
                        "longitude": "21.83333000"
                    },
                    {
                        "id": 38905,
                        "name": "Lavia",
                        "latitude": "61.60000000",
                        "longitude": "22.60000000"
                    },
                    {
                        "id": 38924,
                        "name": "Luvia",
                        "latitude": "61.36375000",
                        "longitude": "21.62556000"
                    },
                    {
                        "id": 38933,
                        "name": "Merikarvia",
                        "latitude": "61.85839000",
                        "longitude": "21.50035000"
                    },
                    {
                        "id": 38950,
                        "name": "Nakkila",
                        "latitude": "61.36667000",
                        "longitude": "22.00000000"
                    },
                    {
                        "id": 38954,
                        "name": "Noormarkku",
                        "latitude": "61.59274000",
                        "longitude": "21.86846000"
                    },
                    {
                        "id": 38990,
                        "name": "Pomarkku",
                        "latitude": "61.69348000",
                        "longitude": "22.00862000"
                    },
                    {
                        "id": 38991,
                        "name": "Pori",
                        "latitude": "61.48333000",
                        "longitude": "21.78333000"
                    },
                    {
                        "id": 39016,
                        "name": "Rauma",
                        "latitude": "61.12724000",
                        "longitude": "21.51127000"
                    },
                    {
                        "id": 39064,
                        "name": "Säkylä",
                        "latitude": "61.03333000",
                        "longitude": "22.33333000"
                    },
                    {
                        "id": 39047,
                        "name": "Siikainen",
                        "latitude": "61.87703000",
                        "longitude": "21.81945000"
                    },
                    {
                        "id": 39089,
                        "name": "Ulvila",
                        "latitude": "61.42844000",
                        "longitude": "21.87103000"
                    },
                    {
                        "id": 39098,
                        "name": "Vampula",
                        "latitude": "61.01667000",
                        "longitude": "22.70000000"
                    }
                ]
            },
            {
                "id": 1497,
                "name": "South Karelia",
                "iso2": "02",
                "latitude": "61.11819490",
                "longitude": "28.10243720",
                "type": "region",
                "cities": [
                    {
                        "id": 38787,
                        "name": "Imatra",
                        "latitude": "61.17185000",
                        "longitude": "28.75242000"
                    },
                    {
                        "id": 38802,
                        "name": "Joutseno",
                        "latitude": "61.11796000",
                        "longitude": "28.50763000"
                    },
                    {
                        "id": 38899,
                        "name": "Lappeenranta",
                        "latitude": "61.05871000",
                        "longitude": "28.18871000"
                    },
                    {
                        "id": 38908,
                        "name": "Lemi",
                        "latitude": "61.06244000",
                        "longitude": "27.80571000"
                    },
                    {
                        "id": 38923,
                        "name": "Luumäki",
                        "latitude": "60.92618000",
                        "longitude": "27.58135000"
                    },
                    {
                        "id": 38956,
                        "name": "Nuijamaa",
                        "latitude": "60.96011000",
                        "longitude": "28.55104000"
                    },
                    {
                        "id": 38973,
                        "name": "Parikkala",
                        "latitude": "61.55000000",
                        "longitude": "29.50000000"
                    },
                    {
                        "id": 39019,
                        "name": "Rautjärvi",
                        "latitude": "61.43333000",
                        "longitude": "29.35000000"
                    },
                    {
                        "id": 39028,
                        "name": "Ruokolahti",
                        "latitude": "61.28333000",
                        "longitude": "28.83333000"
                    },
                    {
                        "id": 39034,
                        "name": "Saari",
                        "latitude": "61.65000000",
                        "longitude": "29.75000000"
                    },
                    {
                        "id": 39040,
                        "name": "Savitaipale",
                        "latitude": "61.20000000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 39067,
                        "name": "Taipalsaari",
                        "latitude": "61.15000000",
                        "longitude": "28.05000000"
                    },
                    {
                        "id": 39127,
                        "name": "Ylämaa",
                        "latitude": "60.80000000",
                        "longitude": "28.00000000"
                    }
                ]
            },
            {
                "id": 1498,
                "name": "Southern Ostrobothnia",
                "iso2": "03",
                "latitude": "62.94330990",
                "longitude": "23.52852670",
                "type": "region",
                "cities": [
                    {
                        "id": 39130,
                        "name": "Ähtäri",
                        "latitude": "62.55403000",
                        "longitude": "24.06186000"
                    },
                    {
                        "id": 38730,
                        "name": "Alahärmä",
                        "latitude": "63.23333000",
                        "longitude": "22.85000000"
                    },
                    {
                        "id": 38731,
                        "name": "Alajärvi",
                        "latitude": "63.00000000",
                        "longitude": "23.81667000"
                    },
                    {
                        "id": 38734,
                        "name": "Alavus",
                        "latitude": "62.58333000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 38751,
                        "name": "Evijärvi",
                        "latitude": "63.36667000",
                        "longitude": "23.48333000"
                    },
                    {
                        "id": 38785,
                        "name": "Ilmajoki",
                        "latitude": "62.73333000",
                        "longitude": "22.56667000"
                    },
                    {
                        "id": 38791,
                        "name": "Isojoki",
                        "latitude": "62.11319000",
                        "longitude": "21.95884000"
                    },
                    {
                        "id": 38796,
                        "name": "Jalasjärvi",
                        "latitude": "62.50000000",
                        "longitude": "22.75000000"
                    },
                    {
                        "id": 38804,
                        "name": "Jurva",
                        "latitude": "62.68333000",
                        "longitude": "21.98333000"
                    },
                    {
                        "id": 38826,
                        "name": "Karijoki",
                        "latitude": "62.30851000",
                        "longitude": "21.70856000"
                    },
                    {
                        "id": 38835,
                        "name": "Kauhajoki",
                        "latitude": "62.43333000",
                        "longitude": "22.18333000"
                    },
                    {
                        "id": 38836,
                        "name": "Kauhava",
                        "latitude": "63.10299000",
                        "longitude": "23.07129000"
                    },
                    {
                        "id": 38871,
                        "name": "Kortesjärvi",
                        "latitude": "63.30000000",
                        "longitude": "23.16667000"
                    },
                    {
                        "id": 38882,
                        "name": "Kuortane",
                        "latitude": "62.80000000",
                        "longitude": "23.50000000"
                    },
                    {
                        "id": 38883,
                        "name": "Kurikka",
                        "latitude": "62.61667000",
                        "longitude": "22.41667000"
                    },
                    {
                        "id": 38898,
                        "name": "Lappajärvi",
                        "latitude": "63.20000000",
                        "longitude": "23.63333000"
                    },
                    {
                        "id": 38901,
                        "name": "Lapua",
                        "latitude": "62.96927000",
                        "longitude": "23.00880000"
                    },
                    {
                        "id": 38906,
                        "name": "Lehtimäki",
                        "latitude": "62.78333000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 38959,
                        "name": "Nurmo",
                        "latitude": "62.82870000",
                        "longitude": "22.90990000"
                    },
                    {
                        "id": 39044,
                        "name": "Seinäjoki",
                        "latitude": "62.79446000",
                        "longitude": "22.82822000"
                    },
                    {
                        "id": 39053,
                        "name": "Soini",
                        "latitude": "62.86667000",
                        "longitude": "24.21667000"
                    },
                    {
                        "id": 39076,
                        "name": "Teuva",
                        "latitude": "62.48190000",
                        "longitude": "21.74156000"
                    },
                    {
                        "id": 39087,
                        "name": "Töysä",
                        "latitude": "62.62803000",
                        "longitude": "23.81828000"
                    },
                    {
                        "id": 39111,
                        "name": "Vimpeli",
                        "latitude": "63.16187000",
                        "longitude": "23.81922000"
                    },
                    {
                        "id": 39122,
                        "name": "Ylihärmä",
                        "latitude": "63.15000000",
                        "longitude": "22.78333000"
                    },
                    {
                        "id": 39124,
                        "name": "Ylistaro",
                        "latitude": "62.93958000",
                        "longitude": "22.51306000"
                    }
                ]
            },
            {
                "id": 1495,
                "name": "Southern Savonia",
                "iso2": "04",
                "latitude": "61.69451480",
                "longitude": "27.80050150",
                "type": "region",
                "cities": [
                    {
                        "id": 38746,
                        "name": "Enonkoski",
                        "latitude": "62.08333000",
                        "longitude": "28.93333000"
                    },
                    {
                        "id": 38766,
                        "name": "Haukivuori",
                        "latitude": "62.01753000",
                        "longitude": "27.21906000"
                    },
                    {
                        "id": 38769,
                        "name": "Heinävesi",
                        "latitude": "62.43333000",
                        "longitude": "28.60000000"
                    },
                    {
                        "id": 38773,
                        "name": "Hirvensalmi",
                        "latitude": "61.63333000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 38811,
                        "name": "Jäppilä",
                        "latitude": "62.37899000",
                        "longitude": "27.43372000"
                    },
                    {
                        "id": 38800,
                        "name": "Joroinen",
                        "latitude": "62.17823000",
                        "longitude": "27.83165000"
                    },
                    {
                        "id": 38806,
                        "name": "Juva",
                        "latitude": "61.90000000",
                        "longitude": "27.85000000"
                    },
                    {
                        "id": 38821,
                        "name": "Kangasniemi",
                        "latitude": "61.99357000",
                        "longitude": "26.64785000"
                    },
                    {
                        "id": 38846,
                        "name": "Kerimäki",
                        "latitude": "61.91069000",
                        "longitude": "29.28228000"
                    },
                    {
                        "id": 38947,
                        "name": "Mäntyharju",
                        "latitude": "61.41667000",
                        "longitude": "26.88333000"
                    },
                    {
                        "id": 38937,
                        "name": "Mikkeli",
                        "latitude": "61.68857000",
                        "longitude": "27.27227000"
                    },
                    {
                        "id": 38981,
                        "name": "Pertunmaa",
                        "latitude": "61.50000000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 38983,
                        "name": "Pieksämäki",
                        "latitude": "62.30000000",
                        "longitude": "27.13333000"
                    },
                    {
                        "id": 38998,
                        "name": "Punkaharju",
                        "latitude": "61.75883000",
                        "longitude": "29.38843000"
                    },
                    {
                        "id": 39000,
                        "name": "Puumala",
                        "latitude": "61.52728000",
                        "longitude": "28.17495000"
                    },
                    {
                        "id": 39013,
                        "name": "Rantasalmi",
                        "latitude": "62.06667000",
                        "longitude": "28.30000000"
                    },
                    {
                        "id": 39024,
                        "name": "Ristiina",
                        "latitude": "61.50579000",
                        "longitude": "27.24643000"
                    },
                    {
                        "id": 39041,
                        "name": "Savonlinna",
                        "latitude": "61.86990000",
                        "longitude": "28.87999000"
                    },
                    {
                        "id": 39042,
                        "name": "Savonranta",
                        "latitude": "62.18333000",
                        "longitude": "29.20000000"
                    },
                    {
                        "id": 39057,
                        "name": "Sulkava",
                        "latitude": "61.78691000",
                        "longitude": "28.37299000"
                    },
                    {
                        "id": 39113,
                        "name": "Virtasalmi",
                        "latitude": "62.12695000",
                        "longitude": "27.46276000"
                    }
                ]
            },
            {
                "id": 1493,
                "name": "Tavastia Proper",
                "iso2": "06",
                "latitude": "60.90701500",
                "longitude": "24.30054980",
                "type": "region",
                "cities": [
                    {
                        "id": 38752,
                        "name": "Forssa",
                        "latitude": "60.81462000",
                        "longitude": "23.62146000"
                    },
                    {
                        "id": 38781,
                        "name": "Hämeenlinna",
                        "latitude": "60.99596000",
                        "longitude": "24.46434000"
                    },
                    {
                        "id": 38764,
                        "name": "Hauho",
                        "latitude": "61.17255000",
                        "longitude": "24.56303000"
                    },
                    {
                        "id": 38767,
                        "name": "Hausjärvi",
                        "latitude": "60.78333000",
                        "longitude": "24.93333000"
                    },
                    {
                        "id": 38777,
                        "name": "Humppila",
                        "latitude": "60.93333000",
                        "longitude": "23.36667000"
                    },
                    {
                        "id": 38797,
                        "name": "Janakkala",
                        "latitude": "60.90000000",
                        "longitude": "24.60000000"
                    },
                    {
                        "id": 38799,
                        "name": "Jokioinen",
                        "latitude": "60.80162000",
                        "longitude": "23.48004000"
                    },
                    {
                        "id": 38819,
                        "name": "Kalvola",
                        "latitude": "61.10081000",
                        "longitude": "24.12177000"
                    },
                    {
                        "id": 38895,
                        "name": "Lammi",
                        "latitude": "61.08333000",
                        "longitude": "25.01667000"
                    },
                    {
                        "id": 38919,
                        "name": "Loppi",
                        "latitude": "60.71667000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 39021,
                        "name": "Renko",
                        "latitude": "60.89563000",
                        "longitude": "24.28785000"
                    },
                    {
                        "id": 39023,
                        "name": "Riihimäki",
                        "latitude": "60.73769000",
                        "longitude": "24.77726000"
                    },
                    {
                        "id": 39070,
                        "name": "Tammela",
                        "latitude": "60.81035000",
                        "longitude": "23.76823000"
                    },
                    {
                        "id": 39073,
                        "name": "Tervakoski",
                        "latitude": "60.81412000",
                        "longitude": "24.62594000"
                    },
                    {
                        "id": 39082,
                        "name": "Tuulos",
                        "latitude": "61.15000000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 39129,
                        "name": "Ypäjä",
                        "latitude": "60.80000000",
                        "longitude": "23.28333000"
                    }
                ]
            },
            {
                "id": 1510,
                "name": "Uusimaa",
                "iso2": "18",
                "latitude": "60.21872000",
                "longitude": "25.27162100",
                "type": "region",
                "cities": [
                    {
                        "id": 38739,
                        "name": "Askola",
                        "latitude": "60.53333000",
                        "longitude": "25.60000000"
                    },
                    {
                        "id": 38743,
                        "name": "Ekenäs",
                        "latitude": "59.97359000",
                        "longitude": "23.43389000"
                    },
                    {
                        "id": 38748,
                        "name": "Espoo",
                        "latitude": "60.20520000",
                        "longitude": "24.65220000"
                    },
                    {
                        "id": 38753,
                        "name": "Gumböle",
                        "latitude": "60.21948000",
                        "longitude": "24.61684000"
                    },
                    {
                        "id": 38761,
                        "name": "Hanko",
                        "latitude": "59.83333000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 38770,
                        "name": "Helsinki",
                        "latitude": "60.16952000",
                        "longitude": "24.93545000"
                    },
                    {
                        "id": 38779,
                        "name": "Hyvinge",
                        "latitude": "60.63333000",
                        "longitude": "24.86667000"
                    },
                    {
                        "id": 38789,
                        "name": "Ingå",
                        "latitude": "60.04587000",
                        "longitude": "24.00459000"
                    },
                    {
                        "id": 38812,
                        "name": "Järvenpää",
                        "latitude": "60.47369000",
                        "longitude": "25.08992000"
                    },
                    {
                        "id": 38813,
                        "name": "Kaarela",
                        "latitude": "60.25174000",
                        "longitude": "24.88111000"
                    },
                    {
                        "id": 38818,
                        "name": "Kallio",
                        "latitude": "60.18427000",
                        "longitude": "24.95034000"
                    },
                    {
                        "id": 38828,
                        "name": "Karis",
                        "latitude": "60.07178000",
                        "longitude": "23.66163000"
                    },
                    {
                        "id": 38829,
                        "name": "Karjalohja",
                        "latitude": "60.24015000",
                        "longitude": "23.71789000"
                    },
                    {
                        "id": 38830,
                        "name": "Karkkila",
                        "latitude": "60.53418000",
                        "longitude": "24.20977000"
                    },
                    {
                        "id": 38889,
                        "name": "Kärkölä",
                        "latitude": "60.61292000",
                        "longitude": "23.94196000"
                    },
                    {
                        "id": 38837,
                        "name": "Kauniainen",
                        "latitude": "60.21209000",
                        "longitude": "24.72756000"
                    },
                    {
                        "id": 38840,
                        "name": "Kellokoski",
                        "latitude": "60.53271000",
                        "longitude": "25.10917000"
                    },
                    {
                        "id": 38845,
                        "name": "Kerava",
                        "latitude": "60.40338000",
                        "longitude": "25.10500000"
                    },
                    {
                        "id": 38853,
                        "name": "Kilo",
                        "latitude": "60.21746000",
                        "longitude": "24.78151000"
                    },
                    {
                        "id": 38856,
                        "name": "Kirkkonummi",
                        "latitude": "60.12381000",
                        "longitude": "24.43853000"
                    },
                    {
                        "id": 38873,
                        "name": "Koukkuniemi",
                        "latitude": "60.15261000",
                        "longitude": "24.76467000"
                    },
                    {
                        "id": 38896,
                        "name": "Lapinjärvi",
                        "latitude": "60.62443000",
                        "longitude": "26.19720000"
                    },
                    {
                        "id": 38904,
                        "name": "Lauttasaari",
                        "latitude": "60.15896000",
                        "longitude": "24.86797000"
                    },
                    {
                        "id": 38914,
                        "name": "Liljendal",
                        "latitude": "60.57346000",
                        "longitude": "26.05257000"
                    },
                    {
                        "id": 38917,
                        "name": "Lohja",
                        "latitude": "60.24859000",
                        "longitude": "24.06534000"
                    },
                    {
                        "id": 38920,
                        "name": "Lovisa",
                        "latitude": "60.45659000",
                        "longitude": "26.22505000"
                    },
                    {
                        "id": 38946,
                        "name": "Mäntsälä",
                        "latitude": "60.63333000",
                        "longitude": "25.31667000"
                    },
                    {
                        "id": 38931,
                        "name": "Mellunkylä",
                        "latitude": "60.23355000",
                        "longitude": "25.09947000"
                    },
                    {
                        "id": 38940,
                        "name": "Munkkiniemi",
                        "latitude": "60.19861000",
                        "longitude": "24.87772000"
                    },
                    {
                        "id": 38945,
                        "name": "Myrskylä",
                        "latitude": "60.66965000",
                        "longitude": "25.84750000"
                    },
                    {
                        "id": 38958,
                        "name": "Nurmijärvi",
                        "latitude": "60.46407000",
                        "longitude": "24.80730000"
                    },
                    {
                        "id": 38964,
                        "name": "Otaniemi",
                        "latitude": "60.18395000",
                        "longitude": "24.82786000"
                    },
                    {
                        "id": 38979,
                        "name": "Pernå",
                        "latitude": "60.44869000",
                        "longitude": "26.03187000"
                    },
                    {
                        "id": 38988,
                        "name": "Pohja",
                        "latitude": "60.09626000",
                        "longitude": "23.52757000"
                    },
                    {
                        "id": 38992,
                        "name": "Pornainen",
                        "latitude": "60.47581000",
                        "longitude": "25.37490000"
                    },
                    {
                        "id": 38993,
                        "name": "Porvoo",
                        "latitude": "60.39233000",
                        "longitude": "25.66507000"
                    },
                    {
                        "id": 38996,
                        "name": "Pukkila",
                        "latitude": "60.65000000",
                        "longitude": "25.56667000"
                    },
                    {
                        "id": 39011,
                        "name": "Raaseporin",
                        "latitude": "60.00273000",
                        "longitude": "23.55499000"
                    },
                    {
                        "id": 39029,
                        "name": "Ruotsinpyhtää",
                        "latitude": "60.52680000",
                        "longitude": "26.46203000"
                    },
                    {
                        "id": 39038,
                        "name": "Sammatti",
                        "latitude": "60.31991000",
                        "longitude": "23.82085000"
                    },
                    {
                        "id": 39045,
                        "name": "Sibbo",
                        "latitude": "60.37752000",
                        "longitude": "25.26906000"
                    },
                    {
                        "id": 39051,
                        "name": "Siuntio",
                        "latitude": "60.13862000",
                        "longitude": "24.22715000"
                    },
                    {
                        "id": 39085,
                        "name": "Tuusula",
                        "latitude": "60.40368000",
                        "longitude": "25.02638000"
                    },
                    {
                        "id": 39099,
                        "name": "Vantaa",
                        "latitude": "60.29414000",
                        "longitude": "25.04099000"
                    },
                    {
                        "id": 39109,
                        "name": "Vihti",
                        "latitude": "60.41699000",
                        "longitude": "24.31965000"
                    },
                    {
                        "id": 39116,
                        "name": "Vuosaari",
                        "latitude": "60.20963000",
                        "longitude": "25.14195000"
                    }
                ]
            }
        ]
    },
    {
        "id": 75,
        "name": "France",
        "iso3": "FRA",
        "iso2": "FR",
        "numeric_code": "250",
        "phonecode": "33",
        "capital": "Paris",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".fr",
        "native": "France",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Western Europe",
        "subregion_id": 17,
        "nationality": "French",
        "timezones": [
            {
                "zoneName": "Europe\/Paris",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Frañs",
            "ko": "프랑스",
            "pt-BR": "França",
            "pt": "França",
            "nl": "Frankrijk",
            "hr": "Francuska",
            "fa": "فرانسه",
            "de": "Frankreich",
            "es": "Francia",
            "fr": "France",
            "ja": "フランス",
            "it": "Francia",
            "zh-CN": "法国",
            "tr": "Fransa",
            "ru": "Франция",
            "uk": "Франція",
            "pl": "Francja"
        },
        "latitude": "46.00000000",
        "longitude": "2.00000000",
        "emoji": "🇫🇷",
        "emojiU": "U+1F1EB U+1F1F7",
        "states": [
            {
                "id": 4967,
                "name": "Ain",
                "iso2": "01",
                "latitude": "46.06508600",
                "longitude": "4.88861500",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4968,
                "name": "Aisne",
                "iso2": "02",
                "latitude": "49.45289210",
                "longitude": "3.04651110",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4969,
                "name": "Allier",
                "iso2": "03",
                "latitude": "46.36708630",
                "longitude": "2.58082770",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4970,
                "name": "Alpes-de-Haute-Provence",
                "iso2": "04",
                "latitude": "44.16377520",
                "longitude": "5.67247800",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4972,
                "name": "Alpes-Maritimes",
                "iso2": "06",
                "latitude": "43.92041700",
                "longitude": "6.61678220",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4811,
                "name": "Alsace",
                "iso2": "6AE",
                "latitude": "48.31817950",
                "longitude": "7.44162410",
                "type": "European collectivity",
                "cities": []
            },
            {
                "id": 4973,
                "name": "Ardèche",
                "iso2": "07",
                "latitude": "44.81486950",
                "longitude": "3.81334830",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4974,
                "name": "Ardennes",
                "iso2": "08",
                "latitude": "49.69759510",
                "longitude": "4.14895760",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4975,
                "name": "Ariège",
                "iso2": "09",
                "latitude": "42.94347830",
                "longitude": "0.94048640",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4976,
                "name": "Aube",
                "iso2": "10",
                "latitude": "48.31975470",
                "longitude": "3.56371040",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4977,
                "name": "Aude",
                "iso2": "11",
                "latitude": "43.05411400",
                "longitude": "1.90384760",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4798,
                "name": "Auvergne-Rhône-Alpes",
                "iso2": "ARA",
                "latitude": "45.44714310",
                "longitude": "4.38525070",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39243,
                        "name": "Abondance",
                        "latitude": "46.27874000",
                        "longitude": "6.72105000"
                    },
                    {
                        "id": 39246,
                        "name": "Abrest",
                        "latitude": "46.09859000",
                        "longitude": "3.44461000"
                    },
                    {
                        "id": 39273,
                        "name": "Aigueblanche",
                        "latitude": "45.50455000",
                        "longitude": "6.50184000"
                    },
                    {
                        "id": 39275,
                        "name": "Aigueperse",
                        "latitude": "46.02255000",
                        "longitude": "3.20228000"
                    },
                    {
                        "id": 39285,
                        "name": "Aime",
                        "latitude": "45.55559000",
                        "longitude": "6.65042000"
                    },
                    {
                        "id": 39286,
                        "name": "Ainay-le-Château",
                        "latitude": "46.71125000",
                        "longitude": "2.69238000"
                    },
                    {
                        "id": 39291,
                        "name": "Aiton",
                        "latitude": "45.56123000",
                        "longitude": "6.25955000"
                    },
                    {
                        "id": 39295,
                        "name": "Aix-les-Bains",
                        "latitude": "45.69173000",
                        "longitude": "5.90863000"
                    },
                    {
                        "id": 39301,
                        "name": "Alba-la-Romaine",
                        "latitude": "44.55537000",
                        "longitude": "4.59846000"
                    },
                    {
                        "id": 39302,
                        "name": "Albens",
                        "latitude": "45.78786000",
                        "longitude": "5.94528000"
                    },
                    {
                        "id": 39304,
                        "name": "Albertville",
                        "latitude": "45.67452000",
                        "longitude": "6.39061000"
                    },
                    {
                        "id": 39307,
                        "name": "Albigny-sur-Saône",
                        "latitude": "45.86667000",
                        "longitude": "4.83333000"
                    },
                    {
                        "id": 39309,
                        "name": "Alby-sur-Chéran",
                        "latitude": "45.81667000",
                        "longitude": "6.01667000"
                    },
                    {
                        "id": 39315,
                        "name": "Alissas",
                        "latitude": "44.71253000",
                        "longitude": "4.62936000"
                    },
                    {
                        "id": 39316,
                        "name": "Alixan",
                        "latitude": "44.97426000",
                        "longitude": "5.02850000"
                    },
                    {
                        "id": 39319,
                        "name": "Allan",
                        "latitude": "44.49713000",
                        "longitude": "4.79068000"
                    },
                    {
                        "id": 39320,
                        "name": "Allanche",
                        "latitude": "45.22907000",
                        "longitude": "2.93449000"
                    },
                    {
                        "id": 39333,
                        "name": "Allègre",
                        "latitude": "45.19959000",
                        "longitude": "3.71174000"
                    },
                    {
                        "id": 39325,
                        "name": "Allevard",
                        "latitude": "45.39449000",
                        "longitude": "6.07519000"
                    },
                    {
                        "id": 39326,
                        "name": "Allex",
                        "latitude": "44.76765000",
                        "longitude": "4.89837000"
                    },
                    {
                        "id": 39328,
                        "name": "Allières-et-Risset",
                        "latitude": "45.09934000",
                        "longitude": "5.67924000"
                    },
                    {
                        "id": 39327,
                        "name": "Allinges",
                        "latitude": "46.33547000",
                        "longitude": "6.46350000"
                    },
                    {
                        "id": 39331,
                        "name": "Allonzier-la-Caille",
                        "latitude": "46.00117000",
                        "longitude": "6.11865000"
                    },
                    {
                        "id": 39344,
                        "name": "Amancy",
                        "latitude": "46.07294000",
                        "longitude": "6.32890000"
                    },
                    {
                        "id": 39360,
                        "name": "Ambérieu-en-Bugey",
                        "latitude": "45.95932000",
                        "longitude": "5.35160000"
                    },
                    {
                        "id": 39361,
                        "name": "Ambérieux-en-Dombes",
                        "latitude": "45.99894000",
                        "longitude": "4.90126000"
                    },
                    {
                        "id": 39349,
                        "name": "Ambert",
                        "latitude": "45.54944000",
                        "longitude": "3.74164000"
                    },
                    {
                        "id": 39350,
                        "name": "Ambierle",
                        "latitude": "46.10558000",
                        "longitude": "3.89323000"
                    },
                    {
                        "id": 39358,
                        "name": "Ambronay",
                        "latitude": "46.00467000",
                        "longitude": "5.36273000"
                    },
                    {
                        "id": 39369,
                        "name": "Amplepuis",
                        "latitude": "45.97260000",
                        "longitude": "4.33030000"
                    },
                    {
                        "id": 39370,
                        "name": "Ampuis",
                        "latitude": "45.48925000",
                        "longitude": "4.81001000"
                    },
                    {
                        "id": 39375,
                        "name": "Ancône",
                        "latitude": "44.58107000",
                        "longitude": "4.72711000"
                    },
                    {
                        "id": 39376,
                        "name": "Andance",
                        "latitude": "45.24059000",
                        "longitude": "4.79916000"
                    },
                    {
                        "id": 39377,
                        "name": "Andancette",
                        "latitude": "45.24858000",
                        "longitude": "4.80860000"
                    },
                    {
                        "id": 39391,
                        "name": "Andrézieux-Bouthéon",
                        "latitude": "45.52625000",
                        "longitude": "4.26021000"
                    },
                    {
                        "id": 39414,
                        "name": "Annecy",
                        "latitude": "45.90878000",
                        "longitude": "6.12565000"
                    },
                    {
                        "id": 39415,
                        "name": "Annecy-le-Vieux",
                        "latitude": "45.91971000",
                        "longitude": "6.14393000"
                    },
                    {
                        "id": 39416,
                        "name": "Annemasse",
                        "latitude": "46.19439000",
                        "longitude": "6.23775000"
                    },
                    {
                        "id": 39420,
                        "name": "Anneyron",
                        "latitude": "45.27220000",
                        "longitude": "4.88626000"
                    },
                    {
                        "id": 39423,
                        "name": "Annonay",
                        "latitude": "45.23992000",
                        "longitude": "4.67070000"
                    },
                    {
                        "id": 39428,
                        "name": "Anse",
                        "latitude": "45.93553000",
                        "longitude": "4.71933000"
                    },
                    {
                        "id": 39431,
                        "name": "Anthy-sur-Léman",
                        "latitude": "46.35534000",
                        "longitude": "6.42735000"
                    },
                    {
                        "id": 39440,
                        "name": "Aoste",
                        "latitude": "45.59423000",
                        "longitude": "5.60712000"
                    },
                    {
                        "id": 39441,
                        "name": "Aouste-sur-Sye",
                        "latitude": "44.71813000",
                        "longitude": "5.05422000"
                    },
                    {
                        "id": 39444,
                        "name": "Apprieu",
                        "latitude": "45.39591000",
                        "longitude": "5.49993000"
                    },
                    {
                        "id": 39537,
                        "name": "Arâches-la-Frasse",
                        "latitude": "46.04297000",
                        "longitude": "6.63145000"
                    },
                    {
                        "id": 39448,
                        "name": "Arbent",
                        "latitude": "46.29221000",
                        "longitude": "5.67890000"
                    },
                    {
                        "id": 39460,
                        "name": "Archamps",
                        "latitude": "46.13195000",
                        "longitude": "6.12551000"
                    },
                    {
                        "id": 39471,
                        "name": "Arenthon",
                        "latitude": "46.10697000",
                        "longitude": "6.33316000"
                    },
                    {
                        "id": 39487,
                        "name": "Arlanc",
                        "latitude": "45.41389000",
                        "longitude": "3.72528000"
                    },
                    {
                        "id": 39496,
                        "name": "Armoy",
                        "latitude": "46.35079000",
                        "longitude": "6.51703000"
                    },
                    {
                        "id": 39500,
                        "name": "Arnas",
                        "latitude": "46.02361000",
                        "longitude": "4.70830000"
                    },
                    {
                        "id": 39507,
                        "name": "Arpajon-sur-Cère",
                        "latitude": "44.90391000",
                        "longitude": "2.45664000"
                    },
                    {
                        "id": 39514,
                        "name": "Ars-sur-Formans",
                        "latitude": "45.99491000",
                        "longitude": "4.81986000"
                    },
                    {
                        "id": 39519,
                        "name": "Artas",
                        "latitude": "45.53717000",
                        "longitude": "5.16352000"
                    },
                    {
                        "id": 39520,
                        "name": "Artemare",
                        "latitude": "45.87441000",
                        "longitude": "5.69366000"
                    },
                    {
                        "id": 39522,
                        "name": "Arthaz-Pont-Notre-Dame",
                        "latitude": "46.15941000",
                        "longitude": "6.26598000"
                    },
                    {
                        "id": 39563,
                        "name": "Attignat",
                        "latitude": "46.28562000",
                        "longitude": "5.16164000"
                    },
                    {
                        "id": 39569,
                        "name": "Aubenas",
                        "latitude": "44.61975000",
                        "longitude": "4.39033000"
                    },
                    {
                        "id": 39572,
                        "name": "Auberives-sur-Varèze",
                        "latitude": "45.42080000",
                        "longitude": "4.81914000"
                    },
                    {
                        "id": 39585,
                        "name": "Aubière",
                        "latitude": "45.75082000",
                        "longitude": "3.11078000"
                    },
                    {
                        "id": 39607,
                        "name": "Aulnat",
                        "latitude": "45.79929000",
                        "longitude": "3.16743000"
                    },
                    {
                        "id": 39624,
                        "name": "Aurec-sur-Loire",
                        "latitude": "45.36908000",
                        "longitude": "4.20161000"
                    },
                    {
                        "id": 39630,
                        "name": "Aurillac",
                        "latitude": "44.92539000",
                        "longitude": "2.43983000"
                    },
                    {
                        "id": 39637,
                        "name": "Autrans",
                        "latitude": "45.17605000",
                        "longitude": "5.54271000"
                    },
                    {
                        "id": 39650,
                        "name": "Auzat-la-Combelle",
                        "latitude": "45.45224000",
                        "longitude": "3.31825000"
                    },
                    {
                        "id": 39659,
                        "name": "Aveize",
                        "latitude": "45.68243000",
                        "longitude": "4.47786000"
                    },
                    {
                        "id": 39660,
                        "name": "Aveizieux",
                        "latitude": "45.56500000",
                        "longitude": "4.37071000"
                    },
                    {
                        "id": 39663,
                        "name": "Avermes",
                        "latitude": "46.58774000",
                        "longitude": "3.30720000"
                    },
                    {
                        "id": 39685,
                        "name": "Aydat",
                        "latitude": "45.66022000",
                        "longitude": "2.97316000"
                    },
                    {
                        "id": 39690,
                        "name": "Ayse",
                        "latitude": "46.08135000",
                        "longitude": "6.44550000"
                    },
                    {
                        "id": 40409,
                        "name": "Bâgé-la-Ville",
                        "latitude": "46.31567000",
                        "longitude": "4.94086000"
                    },
                    {
                        "id": 39734,
                        "name": "Bains",
                        "latitude": "45.00956000",
                        "longitude": "3.77503000"
                    },
                    {
                        "id": 39744,
                        "name": "Balan",
                        "latitude": "45.83416000",
                        "longitude": "5.09930000"
                    },
                    {
                        "id": 39748,
                        "name": "Balbigny",
                        "latitude": "45.81913000",
                        "longitude": "4.19030000"
                    },
                    {
                        "id": 39751,
                        "name": "Ballaison",
                        "latitude": "46.29842000",
                        "longitude": "6.32765000"
                    },
                    {
                        "id": 39773,
                        "name": "Barberaz",
                        "latitude": "45.56179000",
                        "longitude": "5.94306000"
                    },
                    {
                        "id": 39776,
                        "name": "Barby",
                        "latitude": "45.56810000",
                        "longitude": "5.97966000"
                    },
                    {
                        "id": 39791,
                        "name": "Barraux",
                        "latitude": "45.43176000",
                        "longitude": "5.97964000"
                    },
                    {
                        "id": 39796,
                        "name": "Bas-en-Basset",
                        "latitude": "45.30599000",
                        "longitude": "4.10912000"
                    },
                    {
                        "id": 39800,
                        "name": "Bassens",
                        "latitude": "45.57555000",
                        "longitude": "5.93900000"
                    },
                    {
                        "id": 39840,
                        "name": "Beauchastel",
                        "latitude": "44.82587000",
                        "longitude": "4.80305000"
                    },
                    {
                        "id": 39843,
                        "name": "Beaucroissant",
                        "latitude": "45.34276000",
                        "longitude": "5.47102000"
                    },
                    {
                        "id": 39846,
                        "name": "Beaufort",
                        "latitude": "45.71915000",
                        "longitude": "6.57331000"
                    },
                    {
                        "id": 39849,
                        "name": "Beaujeu",
                        "latitude": "46.15428000",
                        "longitude": "4.58826000"
                    },
                    {
                        "id": 39856,
                        "name": "Beaulon",
                        "latitude": "46.60156000",
                        "longitude": "3.67314000"
                    },
                    {
                        "id": 39859,
                        "name": "Beaumont",
                        "latitude": "45.75165000",
                        "longitude": "3.08294000"
                    },
                    {
                        "id": 39870,
                        "name": "Beaumont-lès-Valence",
                        "latitude": "44.86203000",
                        "longitude": "4.94309000"
                    },
                    {
                        "id": 39862,
                        "name": "Beaumont-Monteux",
                        "latitude": "45.01980000",
                        "longitude": "4.91883000"
                    },
                    {
                        "id": 39882,
                        "name": "Beaurepaire",
                        "latitude": "45.33658000",
                        "longitude": "5.04878000"
                    },
                    {
                        "id": 39885,
                        "name": "Beausemblant",
                        "latitude": "45.21706000",
                        "longitude": "4.83241000"
                    },
                    {
                        "id": 39891,
                        "name": "Beauvallon",
                        "latitude": "44.85593000",
                        "longitude": "4.90756000"
                    },
                    {
                        "id": 39892,
                        "name": "Beauvoir-de-Marc",
                        "latitude": "45.52009000",
                        "longitude": "5.07906000"
                    },
                    {
                        "id": 39897,
                        "name": "Beauzac",
                        "latitude": "45.25913000",
                        "longitude": "4.09874000"
                    },
                    {
                        "id": 40421,
                        "name": "Béligneux",
                        "latitude": "45.86775000",
                        "longitude": "5.12747000"
                    },
                    {
                        "id": 39911,
                        "name": "Belle-Plagne",
                        "latitude": "45.50932000",
                        "longitude": "6.70685000"
                    },
                    {
                        "id": 39914,
                        "name": "Bellegarde-en-Forez",
                        "latitude": "45.64469000",
                        "longitude": "4.29721000"
                    },
                    {
                        "id": 39915,
                        "name": "Bellegarde-sur-Valserine",
                        "latitude": "46.10787000",
                        "longitude": "5.82421000"
                    },
                    {
                        "id": 39916,
                        "name": "Bellenaves",
                        "latitude": "46.20045000",
                        "longitude": "3.07995000"
                    },
                    {
                        "id": 39919,
                        "name": "Bellerive-sur-Allier",
                        "latitude": "46.11652000",
                        "longitude": "3.40406000"
                    },
                    {
                        "id": 39921,
                        "name": "Bellevaux",
                        "latitude": "46.25875000",
                        "longitude": "6.53351000"
                    },
                    {
                        "id": 39922,
                        "name": "Belleville",
                        "latitude": "46.10867000",
                        "longitude": "4.74920000"
                    },
                    {
                        "id": 39927,
                        "name": "Belley",
                        "latitude": "45.75917000",
                        "longitude": "5.68813000"
                    },
                    {
                        "id": 39928,
                        "name": "Bellignat",
                        "latitude": "46.24237000",
                        "longitude": "5.62843000"
                    },
                    {
                        "id": 39932,
                        "name": "Belmont-de-la-Loire",
                        "latitude": "46.16596000",
                        "longitude": "4.34737000"
                    },
                    {
                        "id": 39955,
                        "name": "Bernin",
                        "latitude": "45.26772000",
                        "longitude": "5.86457000"
                    },
                    {
                        "id": 39975,
                        "name": "Bessay-sur-Allier",
                        "latitude": "46.44199000",
                        "longitude": "3.36257000"
                    },
                    {
                        "id": 39976,
                        "name": "Besse-et-Saint-Anastaise",
                        "latitude": "45.51667000",
                        "longitude": "2.93333000"
                    },
                    {
                        "id": 39978,
                        "name": "Bessenay",
                        "latitude": "45.77661000",
                        "longitude": "4.55441000"
                    },
                    {
                        "id": 40000,
                        "name": "Beynost",
                        "latitude": "45.83569000",
                        "longitude": "4.99910000"
                    },
                    {
                        "id": 40020,
                        "name": "Bilieu",
                        "latitude": "45.44809000",
                        "longitude": "5.54268000"
                    },
                    {
                        "id": 40021,
                        "name": "Billom",
                        "latitude": "45.72267000",
                        "longitude": "3.33869000"
                    },
                    {
                        "id": 40028,
                        "name": "Biol",
                        "latitude": "45.49140000",
                        "longitude": "5.38550000"
                    },
                    {
                        "id": 40036,
                        "name": "Biviers",
                        "latitude": "45.23333000",
                        "longitude": "5.80000000"
                    },
                    {
                        "id": 40042,
                        "name": "Blacé",
                        "latitude": "46.03152000",
                        "longitude": "4.64448000"
                    },
                    {
                        "id": 40056,
                        "name": "Blanzat",
                        "latitude": "45.82975000",
                        "longitude": "3.07794000"
                    },
                    {
                        "id": 40061,
                        "name": "Blavozy",
                        "latitude": "45.05720000",
                        "longitude": "3.97993000"
                    },
                    {
                        "id": 40245,
                        "name": "Boëge",
                        "latitude": "46.20711000",
                        "longitude": "6.40428000"
                    },
                    {
                        "id": 40246,
                        "name": "Boën-sur-Lignon",
                        "latitude": "45.75114000",
                        "longitude": "4.00725000"
                    },
                    {
                        "id": 40117,
                        "name": "Bonne",
                        "latitude": "46.17207000",
                        "longitude": "6.32443000"
                    },
                    {
                        "id": 40118,
                        "name": "Bonnefamille",
                        "latitude": "45.59956000",
                        "longitude": "5.12489000"
                    },
                    {
                        "id": 40126,
                        "name": "Bonneville",
                        "latitude": "46.08020000",
                        "longitude": "6.40726000"
                    },
                    {
                        "id": 40131,
                        "name": "Bons-en-Chablais",
                        "latitude": "46.26486000",
                        "longitude": "6.37129000"
                    },
                    {
                        "id": 40132,
                        "name": "Bonson",
                        "latitude": "45.52291000",
                        "longitude": "4.21270000"
                    },
                    {
                        "id": 40168,
                        "name": "Boulieu-lès-Annonay",
                        "latitude": "45.27065000",
                        "longitude": "4.66645000"
                    },
                    {
                        "id": 40179,
                        "name": "Bourbon-l’Archambault",
                        "latitude": "46.58324000",
                        "longitude": "3.05652000"
                    },
                    {
                        "id": 40187,
                        "name": "Bourg-Argental",
                        "latitude": "45.29899000",
                        "longitude": "4.56830000"
                    },
                    {
                        "id": 40191,
                        "name": "Bourg-de-Péage",
                        "latitude": "45.03151000",
                        "longitude": "5.04993000"
                    },
                    {
                        "id": 40192,
                        "name": "Bourg-de-Thizy",
                        "latitude": "46.03371000",
                        "longitude": "4.29904000"
                    },
                    {
                        "id": 40194,
                        "name": "Bourg-en-Bresse",
                        "latitude": "46.20574000",
                        "longitude": "5.22580000"
                    },
                    {
                        "id": 40196,
                        "name": "Bourg-lès-Valence",
                        "latitude": "44.94703000",
                        "longitude": "4.89463000"
                    },
                    {
                        "id": 40189,
                        "name": "Bourg-Saint-Andéol",
                        "latitude": "44.37338000",
                        "longitude": "4.64413000"
                    },
                    {
                        "id": 40190,
                        "name": "Bourg-Saint-Maurice",
                        "latitude": "45.61463000",
                        "longitude": "6.76845000"
                    },
                    {
                        "id": 40204,
                        "name": "Bourgoin-Jallieu",
                        "latitude": "45.58611000",
                        "longitude": "5.27361000"
                    },
                    {
                        "id": 40210,
                        "name": "Bournoncle-Saint-Pierre",
                        "latitude": "45.34351000",
                        "longitude": "3.31830000"
                    },
                    {
                        "id": 40226,
                        "name": "Bouvesse-Quirieu",
                        "latitude": "45.79310000",
                        "longitude": "5.41496000"
                    },
                    {
                        "id": 40242,
                        "name": "Bozel",
                        "latitude": "45.44288000",
                        "longitude": "6.64896000"
                    },
                    {
                        "id": 40262,
                        "name": "Brassac-les-Mines",
                        "latitude": "45.41407000",
                        "longitude": "3.32900000"
                    },
                    {
                        "id": 40363,
                        "name": "Brézins",
                        "latitude": "45.35213000",
                        "longitude": "5.30539000"
                    },
                    {
                        "id": 40330,
                        "name": "Brié-et-Angonnes",
                        "latitude": "45.12418000",
                        "longitude": "5.78374000"
                    },
                    {
                        "id": 40309,
                        "name": "Briennon",
                        "latitude": "46.15127000",
                        "longitude": "4.07690000"
                    },
                    {
                        "id": 40312,
                        "name": "Brignais",
                        "latitude": "45.67383000",
                        "longitude": "4.75418000"
                    },
                    {
                        "id": 40316,
                        "name": "Brindas",
                        "latitude": "45.72111000",
                        "longitude": "4.69349000"
                    },
                    {
                        "id": 40321,
                        "name": "Brioude",
                        "latitude": "45.29419000",
                        "longitude": "3.38423000"
                    },
                    {
                        "id": 40325,
                        "name": "Brison-Saint-Innocent",
                        "latitude": "45.72440000",
                        "longitude": "5.88895000"
                    },
                    {
                        "id": 40328,
                        "name": "Brives-Charensac",
                        "latitude": "45.04780000",
                        "longitude": "3.92878000"
                    },
                    {
                        "id": 40332,
                        "name": "Bron",
                        "latitude": "45.73865000",
                        "longitude": "4.91303000"
                    },
                    {
                        "id": 40337,
                        "name": "Broût-Vernet",
                        "latitude": "46.18756000",
                        "longitude": "3.27324000"
                    },
                    {
                        "id": 40341,
                        "name": "Brugheas",
                        "latitude": "46.07676000",
                        "longitude": "3.36780000"
                    },
                    {
                        "id": 40375,
                        "name": "Buellas",
                        "latitude": "46.21110000",
                        "longitude": "5.13220000"
                    },
                    {
                        "id": 40379,
                        "name": "Buis-les-Baronnies",
                        "latitude": "44.27647000",
                        "longitude": "5.27187000"
                    },
                    {
                        "id": 40383,
                        "name": "Bully",
                        "latitude": "45.85113000",
                        "longitude": "4.58328000"
                    },
                    {
                        "id": 40400,
                        "name": "Bussières",
                        "latitude": "45.83570000",
                        "longitude": "4.27123000"
                    },
                    {
                        "id": 40404,
                        "name": "Buxières-les-Mines",
                        "latitude": "46.46807000",
                        "longitude": "2.95994000"
                    },
                    {
                        "id": 40465,
                        "name": "Cailloux-sur-Fontaines",
                        "latitude": "45.85259000",
                        "longitude": "4.87473000"
                    },
                    {
                        "id": 40477,
                        "name": "Caluire-et-Cuire",
                        "latitude": "45.79462000",
                        "longitude": "4.84640000"
                    },
                    {
                        "id": 40516,
                        "name": "Cantal",
                        "latitude": "45.13985000",
                        "longitude": "2.64947000"
                    },
                    {
                        "id": 41389,
                        "name": "Cébazat",
                        "latitude": "45.83140000",
                        "longitude": "3.09992000"
                    },
                    {
                        "id": 40634,
                        "name": "Celles-sur-Durolle",
                        "latitude": "45.85829000",
                        "longitude": "3.63540000"
                    },
                    {
                        "id": 40636,
                        "name": "Cellieu",
                        "latitude": "45.51866000",
                        "longitude": "4.54332000"
                    },
                    {
                        "id": 41397,
                        "name": "Cérilly",
                        "latitude": "46.61791000",
                        "longitude": "2.82080000"
                    },
                    {
                        "id": 40655,
                        "name": "Certines",
                        "latitude": "46.13244000",
                        "longitude": "5.26525000"
                    },
                    {
                        "id": 40659,
                        "name": "Cessieu",
                        "latitude": "45.56371000",
                        "longitude": "5.37607000"
                    },
                    {
                        "id": 40662,
                        "name": "Cessy",
                        "latitude": "46.32032000",
                        "longitude": "6.07477000"
                    },
                    {
                        "id": 40665,
                        "name": "Ceyrat",
                        "latitude": "45.73265000",
                        "longitude": "3.06323000"
                    },
                    {
                        "id": 40667,
                        "name": "Ceyzériat",
                        "latitude": "46.18126000",
                        "longitude": "5.31977000"
                    },
                    {
                        "id": 40669,
                        "name": "Chabeuil",
                        "latitude": "44.89843000",
                        "longitude": "5.01438000"
                    },
                    {
                        "id": 40931,
                        "name": "Châbons",
                        "latitude": "45.44282000",
                        "longitude": "5.42542000"
                    },
                    {
                        "id": 40671,
                        "name": "Chabreloche",
                        "latitude": "45.87900000",
                        "longitude": "3.69664000"
                    },
                    {
                        "id": 40674,
                        "name": "Chadrac",
                        "latitude": "45.06181000",
                        "longitude": "3.90261000"
                    },
                    {
                        "id": 40686,
                        "name": "Chalamont",
                        "latitude": "45.99734000",
                        "longitude": "5.16865000"
                    },
                    {
                        "id": 40688,
                        "name": "Chaleins",
                        "latitude": "46.03165000",
                        "longitude": "4.80789000"
                    },
                    {
                        "id": 40694,
                        "name": "Challes-les-Eaux",
                        "latitude": "45.54685000",
                        "longitude": "5.98098000"
                    },
                    {
                        "id": 40695,
                        "name": "Challex",
                        "latitude": "46.18458000",
                        "longitude": "5.97639000"
                    },
                    {
                        "id": 40700,
                        "name": "Chamagnieu",
                        "latitude": "45.68249000",
                        "longitude": "5.16947000"
                    },
                    {
                        "id": 40701,
                        "name": "Chamalières",
                        "latitude": "45.77364000",
                        "longitude": "3.06703000"
                    },
                    {
                        "id": 40713,
                        "name": "Chambéry",
                        "latitude": "45.56628000",
                        "longitude": "5.92079000"
                    },
                    {
                        "id": 40714,
                        "name": "Chambœuf",
                        "latitude": "45.58333000",
                        "longitude": "4.31667000"
                    },
                    {
                        "id": 40717,
                        "name": "Chamonix-Mont-Blanc",
                        "latitude": "45.92375000",
                        "longitude": "6.86933000"
                    },
                    {
                        "id": 40718,
                        "name": "Champ-sur-Drac",
                        "latitude": "45.06940000",
                        "longitude": "5.73151000"
                    },
                    {
                        "id": 40719,
                        "name": "Champagnac",
                        "latitude": "45.35660000",
                        "longitude": "2.39942000"
                    },
                    {
                        "id": 40721,
                        "name": "Champagne-au-Mont-d’Or",
                        "latitude": "45.79475000",
                        "longitude": "4.79079000"
                    },
                    {
                        "id": 40725,
                        "name": "Champagnier",
                        "latitude": "45.11155000",
                        "longitude": "5.72716000"
                    },
                    {
                        "id": 40732,
                        "name": "Champdieu",
                        "latitude": "45.64533000",
                        "longitude": "4.04705000"
                    },
                    {
                        "id": 40733,
                        "name": "Champeix",
                        "latitude": "45.58863000",
                        "longitude": "3.12878000"
                    },
                    {
                        "id": 40738,
                        "name": "Champier",
                        "latitude": "45.45540000",
                        "longitude": "5.29237000"
                    },
                    {
                        "id": 40749,
                        "name": "Champs-sur-Tarentaine-Marchal",
                        "latitude": "45.40000000",
                        "longitude": "2.56667000"
                    },
                    {
                        "id": 40756,
                        "name": "Chanas",
                        "latitude": "45.31881000",
                        "longitude": "4.81849000"
                    },
                    {
                        "id": 40760,
                        "name": "Chandon",
                        "latitude": "46.14925000",
                        "longitude": "4.21393000"
                    },
                    {
                        "id": 40765,
                        "name": "Chanonat",
                        "latitude": "45.69299000",
                        "longitude": "3.09351000"
                    },
                    {
                        "id": 40766,
                        "name": "Chanos-Curson",
                        "latitude": "45.06057000",
                        "longitude": "4.92381000"
                    },
                    {
                        "id": 40769,
                        "name": "Chantelle",
                        "latitude": "46.23806000",
                        "longitude": "3.15318000"
                    },
                    {
                        "id": 40781,
                        "name": "Chapareillan",
                        "latitude": "45.46513000",
                        "longitude": "5.99171000"
                    },
                    {
                        "id": 40782,
                        "name": "Chapdes-Beaufort",
                        "latitude": "45.89277000",
                        "longitude": "2.86362000"
                    },
                    {
                        "id": 40784,
                        "name": "Chaponnay",
                        "latitude": "45.62762000",
                        "longitude": "4.93615000"
                    },
                    {
                        "id": 40785,
                        "name": "Chaponost",
                        "latitude": "45.71020000",
                        "longitude": "4.74221000"
                    },
                    {
                        "id": 40786,
                        "name": "Chappes",
                        "latitude": "45.86848000",
                        "longitude": "3.22068000"
                    },
                    {
                        "id": 40788,
                        "name": "Charantonnay",
                        "latitude": "45.53705000",
                        "longitude": "5.11005000"
                    },
                    {
                        "id": 40789,
                        "name": "Charavines",
                        "latitude": "45.42891000",
                        "longitude": "5.51492000"
                    },
                    {
                        "id": 40790,
                        "name": "Charbonnières-les-Bains",
                        "latitude": "45.78053000",
                        "longitude": "4.74637000"
                    },
                    {
                        "id": 40791,
                        "name": "Charbonnières-les-Varennes",
                        "latitude": "45.90786000",
                        "longitude": "2.99976000"
                    },
                    {
                        "id": 40793,
                        "name": "Charentay",
                        "latitude": "46.08897000",
                        "longitude": "4.67921000"
                    },
                    {
                        "id": 40803,
                        "name": "Charlieu",
                        "latitude": "46.16202000",
                        "longitude": "4.17228000"
                    },
                    {
                        "id": 40804,
                        "name": "Charly",
                        "latitude": "45.64887000",
                        "longitude": "4.79461000"
                    },
                    {
                        "id": 40808,
                        "name": "Charmes-sur-Rhône",
                        "latitude": "44.86367000",
                        "longitude": "4.83533000"
                    },
                    {
                        "id": 40809,
                        "name": "Charnay",
                        "latitude": "45.89058000",
                        "longitude": "4.66821000"
                    },
                    {
                        "id": 40813,
                        "name": "Charnècles",
                        "latitude": "45.34398000",
                        "longitude": "5.52799000"
                    },
                    {
                        "id": 40822,
                        "name": "Charvieu-Chavagneux",
                        "latitude": "45.75000000",
                        "longitude": "5.15000000"
                    },
                    {
                        "id": 40824,
                        "name": "Chassagny",
                        "latitude": "45.60670000",
                        "longitude": "4.73214000"
                    },
                    {
                        "id": 40825,
                        "name": "Chasse-sur-Rhône",
                        "latitude": "45.57850000",
                        "longitude": "4.80985000"
                    },
                    {
                        "id": 40826,
                        "name": "Chasselay",
                        "latitude": "45.87440000",
                        "longitude": "4.77237000"
                    },
                    {
                        "id": 40829,
                        "name": "Chassieu",
                        "latitude": "45.74584000",
                        "longitude": "4.97088000"
                    },
                    {
                        "id": 40938,
                        "name": "Château-Gaillard",
                        "latitude": "45.97239000",
                        "longitude": "5.30436000"
                    },
                    {
                        "id": 40955,
                        "name": "Châteaugay",
                        "latitude": "45.85117000",
                        "longitude": "3.08482000"
                    },
                    {
                        "id": 40959,
                        "name": "Châteauneuf",
                        "latitude": "45.52457000",
                        "longitude": "4.64044000"
                    },
                    {
                        "id": 40962,
                        "name": "Châteauneuf-de-Galaure",
                        "latitude": "45.22977000",
                        "longitude": "4.95777000"
                    },
                    {
                        "id": 40965,
                        "name": "Châteauneuf-du-Rhône",
                        "latitude": "44.48906000",
                        "longitude": "4.71706000"
                    },
                    {
                        "id": 40973,
                        "name": "Châteauneuf-sur-Isère",
                        "latitude": "45.01667000",
                        "longitude": "4.93333000"
                    },
                    {
                        "id": 40980,
                        "name": "Châtel",
                        "latitude": "46.26495000",
                        "longitude": "6.84030000"
                    },
                    {
                        "id": 40981,
                        "name": "Châtel-Guyon",
                        "latitude": "45.92258000",
                        "longitude": "3.06423000"
                    },
                    {
                        "id": 40991,
                        "name": "Châtillon",
                        "latitude": "45.80091000",
                        "longitude": "5.84352000"
                    },
                    {
                        "id": 40995,
                        "name": "Châtillon-en-Michaille",
                        "latitude": "46.14320000",
                        "longitude": "5.79950000"
                    },
                    {
                        "id": 40997,
                        "name": "Châtillon-la-Palud",
                        "latitude": "45.97171000",
                        "longitude": "5.25290000"
                    },
                    {
                        "id": 40999,
                        "name": "Châtillon-sur-Chalaronne",
                        "latitude": "46.11834000",
                        "longitude": "4.95656000"
                    },
                    {
                        "id": 41001,
                        "name": "Châtillon-sur-Cluses",
                        "latitude": "46.08765000",
                        "longitude": "6.58041000"
                    },
                    {
                        "id": 41007,
                        "name": "Châtonnay",
                        "latitude": "45.48734000",
                        "longitude": "5.21168000"
                    },
                    {
                        "id": 40832,
                        "name": "Chatte",
                        "latitude": "45.14248000",
                        "longitude": "5.28224000"
                    },
                    {
                        "id": 40833,
                        "name": "Chatuzange-le-Goubet",
                        "latitude": "45.00359000",
                        "longitude": "5.09079000"
                    },
                    {
                        "id": 40836,
                        "name": "Chaudes-Aigues",
                        "latitude": "44.85455000",
                        "longitude": "3.00406000"
                    },
                    {
                        "id": 40851,
                        "name": "Chauriat",
                        "latitude": "45.75127000",
                        "longitude": "3.27895000"
                    },
                    {
                        "id": 40857,
                        "name": "Chavanay",
                        "latitude": "45.41647000",
                        "longitude": "4.72602000"
                    },
                    {
                        "id": 40858,
                        "name": "Chavanod",
                        "latitude": "45.89005000",
                        "longitude": "6.03928000"
                    },
                    {
                        "id": 40859,
                        "name": "Chavanoz",
                        "latitude": "45.76846000",
                        "longitude": "5.18808000"
                    },
                    {
                        "id": 40865,
                        "name": "Chazelles-sur-Lyon",
                        "latitude": "45.63779000",
                        "longitude": "4.38890000"
                    },
                    {
                        "id": 40866,
                        "name": "Chazey-sur-Ain",
                        "latitude": "45.89300000",
                        "longitude": "5.25352000"
                    },
                    {
                        "id": 40876,
                        "name": "Chens-sur-Léman",
                        "latitude": "46.32459000",
                        "longitude": "6.27075000"
                    },
                    {
                        "id": 40888,
                        "name": "Chessy",
                        "latitude": "45.88716000",
                        "longitude": "4.62339000"
                    },
                    {
                        "id": 40903,
                        "name": "Chevry",
                        "latitude": "46.28136000",
                        "longitude": "6.03873000"
                    },
                    {
                        "id": 40908,
                        "name": "Chilly",
                        "latitude": "45.99185000",
                        "longitude": "5.95477000"
                    },
                    {
                        "id": 40910,
                        "name": "Chimilin",
                        "latitude": "45.57490000",
                        "longitude": "5.59569000"
                    },
                    {
                        "id": 40911,
                        "name": "Chindrieux",
                        "latitude": "45.81948000",
                        "longitude": "5.85024000"
                    },
                    {
                        "id": 40914,
                        "name": "Chirens",
                        "latitude": "45.41024000",
                        "longitude": "5.55634000"
                    },
                    {
                        "id": 40920,
                        "name": "Choisy",
                        "latitude": "45.99359000",
                        "longitude": "6.05866000"
                    },
                    {
                        "id": 40925,
                        "name": "Chomérac",
                        "latitude": "44.70752000",
                        "longitude": "4.66164000"
                    },
                    {
                        "id": 40930,
                        "name": "Chuzelles",
                        "latitude": "45.58481000",
                        "longitude": "4.87703000"
                    },
                    {
                        "id": 41030,
                        "name": "Civens",
                        "latitude": "45.77964000",
                        "longitude": "4.25170000"
                    },
                    {
                        "id": 41033,
                        "name": "Civrieux",
                        "latitude": "45.92086000",
                        "longitude": "4.88249000"
                    },
                    {
                        "id": 41038,
                        "name": "Claix",
                        "latitude": "45.11994000",
                        "longitude": "5.67292000"
                    },
                    {
                        "id": 41073,
                        "name": "Clérieux",
                        "latitude": "45.07591000",
                        "longitude": "4.95983000"
                    },
                    {
                        "id": 41049,
                        "name": "Clermont-Ferrand",
                        "latitude": "45.77969000",
                        "longitude": "3.08682000"
                    },
                    {
                        "id": 41059,
                        "name": "Clonas-sur-Varèze",
                        "latitude": "45.41382000",
                        "longitude": "4.79077000"
                    },
                    {
                        "id": 41064,
                        "name": "Cluses",
                        "latitude": "46.06251000",
                        "longitude": "6.57497000"
                    },
                    {
                        "id": 41081,
                        "name": "Cognin",
                        "latitude": "45.55952000",
                        "longitude": "5.89113000"
                    },
                    {
                        "id": 41082,
                        "name": "Cogny",
                        "latitude": "45.98747000",
                        "longitude": "4.62475000"
                    },
                    {
                        "id": 41086,
                        "name": "Coise",
                        "latitude": "45.52822000",
                        "longitude": "6.14389000"
                    },
                    {
                        "id": 41088,
                        "name": "Coligny",
                        "latitude": "46.38252000",
                        "longitude": "5.34554000"
                    },
                    {
                        "id": 41093,
                        "name": "Collonges",
                        "latitude": "46.13819000",
                        "longitude": "5.90506000"
                    },
                    {
                        "id": 41094,
                        "name": "Collonges-sous-Salève",
                        "latitude": "46.14160000",
                        "longitude": "6.15372000"
                    },
                    {
                        "id": 41098,
                        "name": "Colombe",
                        "latitude": "45.40024000",
                        "longitude": "5.45441000"
                    },
                    {
                        "id": 41109,
                        "name": "Combloux",
                        "latitude": "45.89790000",
                        "longitude": "6.64420000"
                    },
                    {
                        "id": 41113,
                        "name": "Combronde",
                        "latitude": "45.98099000",
                        "longitude": "3.08807000"
                    },
                    {
                        "id": 41117,
                        "name": "Commelle",
                        "latitude": "46.00086000",
                        "longitude": "4.05794000"
                    },
                    {
                        "id": 41118,
                        "name": "Commentry",
                        "latitude": "46.28876000",
                        "longitude": "2.74163000"
                    },
                    {
                        "id": 41122,
                        "name": "Communay",
                        "latitude": "45.60442000",
                        "longitude": "4.83488000"
                    },
                    {
                        "id": 41130,
                        "name": "Condat",
                        "latitude": "45.34093000",
                        "longitude": "2.75791000"
                    },
                    {
                        "id": 41134,
                        "name": "Condrieu",
                        "latitude": "45.46300000",
                        "longitude": "4.76765000"
                    },
                    {
                        "id": 41154,
                        "name": "Contamine-sur-Arve",
                        "latitude": "46.14223000",
                        "longitude": "6.33215000"
                    },
                    {
                        "id": 41162,
                        "name": "Corbas",
                        "latitude": "45.66798000",
                        "longitude": "4.90198000"
                    },
                    {
                        "id": 41166,
                        "name": "Corbelin",
                        "latitude": "45.60733000",
                        "longitude": "5.54261000"
                    },
                    {
                        "id": 41175,
                        "name": "Cordon",
                        "latitude": "45.92099000",
                        "longitude": "6.60536000"
                    },
                    {
                        "id": 41176,
                        "name": "Corenc",
                        "latitude": "45.21889000",
                        "longitude": "5.76497000"
                    },
                    {
                        "id": 41186,
                        "name": "Cornas",
                        "latitude": "44.96382000",
                        "longitude": "4.84839000"
                    },
                    {
                        "id": 41192,
                        "name": "Cornier",
                        "latitude": "46.09304000",
                        "longitude": "6.29895000"
                    },
                    {
                        "id": 41213,
                        "name": "Coublevie",
                        "latitude": "45.35856000",
                        "longitude": "5.61146000"
                    },
                    {
                        "id": 41214,
                        "name": "Coubon",
                        "latitude": "44.99731000",
                        "longitude": "3.91783000"
                    },
                    {
                        "id": 41247,
                        "name": "Courchevel",
                        "latitude": "45.41538000",
                        "longitude": "6.63643000"
                    },
                    {
                        "id": 41255,
                        "name": "Cournon-d’Auvergne",
                        "latitude": "45.74123000",
                        "longitude": "3.19643000"
                    },
                    {
                        "id": 41259,
                        "name": "Courpière",
                        "latitude": "45.75689000",
                        "longitude": "3.54216000"
                    },
                    {
                        "id": 41262,
                        "name": "Cours-la-Ville",
                        "latitude": "46.10000000",
                        "longitude": "4.31667000"
                    },
                    {
                        "id": 41273,
                        "name": "Courzieu",
                        "latitude": "45.74270000",
                        "longitude": "4.57084000"
                    },
                    {
                        "id": 41282,
                        "name": "Coutouvre",
                        "latitude": "46.07303000",
                        "longitude": "4.20535000"
                    },
                    {
                        "id": 41285,
                        "name": "Coux",
                        "latitude": "44.73484000",
                        "longitude": "4.62057000"
                    },
                    {
                        "id": 41287,
                        "name": "Couzon-au-Mont-d’Or",
                        "latitude": "45.84436000",
                        "longitude": "4.82883000"
                    },
                    {
                        "id": 41295,
                        "name": "Cran-Gevrier",
                        "latitude": "45.90000000",
                        "longitude": "6.10000000"
                    },
                    {
                        "id": 41297,
                        "name": "Cranves-Sales",
                        "latitude": "46.18799000",
                        "longitude": "6.29903000"
                    },
                    {
                        "id": 41299,
                        "name": "Craponne",
                        "latitude": "45.74526000",
                        "longitude": "4.72322000"
                    },
                    {
                        "id": 41300,
                        "name": "Craponne-sur-Arzon",
                        "latitude": "45.33092000",
                        "longitude": "3.84817000"
                    },
                    {
                        "id": 41347,
                        "name": "Crémieu",
                        "latitude": "45.72557000",
                        "longitude": "5.24911000"
                    },
                    {
                        "id": 41309,
                        "name": "Crest",
                        "latitude": "44.72639000",
                        "longitude": "5.01517000"
                    },
                    {
                        "id": 41313,
                        "name": "Creuzier-le-Vieux",
                        "latitude": "46.16253000",
                        "longitude": "3.43311000"
                    },
                    {
                        "id": 41315,
                        "name": "Creys-Mépieu",
                        "latitude": "45.73333000",
                        "longitude": "5.48333000"
                    },
                    {
                        "id": 41326,
                        "name": "Crolles",
                        "latitude": "45.27724000",
                        "longitude": "5.87837000"
                    },
                    {
                        "id": 41330,
                        "name": "Crottet",
                        "latitude": "46.27602000",
                        "longitude": "4.89388000"
                    },
                    {
                        "id": 41335,
                        "name": "Cruas",
                        "latitude": "44.65706000",
                        "longitude": "4.76293000"
                    },
                    {
                        "id": 41336,
                        "name": "Cruet",
                        "latitude": "45.52890000",
                        "longitude": "6.09220000"
                    },
                    {
                        "id": 41337,
                        "name": "Cruseilles",
                        "latitude": "46.02980000",
                        "longitude": "6.10831000"
                    },
                    {
                        "id": 41355,
                        "name": "Cublize",
                        "latitude": "46.01810000",
                        "longitude": "4.37738000"
                    },
                    {
                        "id": 41370,
                        "name": "Cuisiat",
                        "latitude": "46.30021000",
                        "longitude": "5.38809000"
                    },
                    {
                        "id": 41371,
                        "name": "Culhat",
                        "latitude": "45.86259000",
                        "longitude": "3.33676000"
                    },
                    {
                        "id": 41372,
                        "name": "Culoz",
                        "latitude": "45.84886000",
                        "longitude": "5.78537000"
                    },
                    {
                        "id": 41374,
                        "name": "Cunlhat",
                        "latitude": "45.63198000",
                        "longitude": "3.55927000"
                    },
                    {
                        "id": 41377,
                        "name": "Curtin",
                        "latitude": "45.64353000",
                        "longitude": "5.48982000"
                    },
                    {
                        "id": 41380,
                        "name": "Cussac-sur-Loire",
                        "latitude": "44.98807000",
                        "longitude": "3.88416000"
                    },
                    {
                        "id": 41381,
                        "name": "Cusset",
                        "latitude": "46.13452000",
                        "longitude": "3.45639000"
                    },
                    {
                        "id": 41383,
                        "name": "Cusy",
                        "latitude": "45.76603000",
                        "longitude": "6.02825000"
                    },
                    {
                        "id": 41387,
                        "name": "Cuzieu",
                        "latitude": "45.60764000",
                        "longitude": "4.25761000"
                    },
                    {
                        "id": 41404,
                        "name": "Dagneux",
                        "latitude": "45.85140000",
                        "longitude": "5.07780000"
                    },
                    {
                        "id": 41407,
                        "name": "Dallet",
                        "latitude": "45.77047000",
                        "longitude": "3.23875000"
                    },
                    {
                        "id": 41432,
                        "name": "Dardilly",
                        "latitude": "45.80558000",
                        "longitude": "4.75319000"
                    },
                    {
                        "id": 41442,
                        "name": "Davézieux",
                        "latitude": "45.25520000",
                        "longitude": "4.70744000"
                    },
                    {
                        "id": 41600,
                        "name": "Décines-Charpieu",
                        "latitude": "45.76873000",
                        "longitude": "4.95883000"
                    },
                    {
                        "id": 41452,
                        "name": "Denicé",
                        "latitude": "46.00158000",
                        "longitude": "4.64555000"
                    },
                    {
                        "id": 41608,
                        "name": "Département de l'Ain",
                        "latitude": "46.16667000",
                        "longitude": "5.33333000"
                    },
                    {
                        "id": 41610,
                        "name": "Département de l'Allier",
                        "latitude": "46.50000000",
                        "longitude": "3.00000000"
                    },
                    {
                        "id": 41611,
                        "name": "Département de l'Ardèche",
                        "latitude": "44.66667000",
                        "longitude": "4.33333000"
                    },
                    {
                        "id": 41620,
                        "name": "Département de l'Isère",
                        "latitude": "45.16667000",
                        "longitude": "5.83333000"
                    },
                    {
                        "id": 41627,
                        "name": "Département de la Drôme",
                        "latitude": "44.69971000",
                        "longitude": "5.16521000"
                    },
                    {
                        "id": 41630,
                        "name": "Département de la Loire",
                        "latitude": "45.47169000",
                        "longitude": "4.43298000"
                    },
                    {
                        "id": 41643,
                        "name": "Département du Puy-de-Dôme",
                        "latitude": "45.70549000",
                        "longitude": "3.14600000"
                    },
                    {
                        "id": 41644,
                        "name": "Département du Rhône",
                        "latitude": "45.89126000",
                        "longitude": "4.53039000"
                    },
                    {
                        "id": 41648,
                        "name": "Désaignes",
                        "latitude": "44.99466000",
                        "longitude": "4.51695000"
                    },
                    {
                        "id": 41649,
                        "name": "Désertines",
                        "latitude": "46.35456000",
                        "longitude": "2.61924000"
                    },
                    {
                        "id": 41466,
                        "name": "Die",
                        "latitude": "44.75360000",
                        "longitude": "5.37033000"
                    },
                    {
                        "id": 41499,
                        "name": "Diémoz",
                        "latitude": "45.59099000",
                        "longitude": "5.08884000"
                    },
                    {
                        "id": 41473,
                        "name": "Dieulefit",
                        "latitude": "44.52563000",
                        "longitude": "5.06180000"
                    },
                    {
                        "id": 41485,
                        "name": "Dingy-Saint-Clair",
                        "latitude": "45.90664000",
                        "longitude": "6.22554000"
                    },
                    {
                        "id": 41489,
                        "name": "Diou",
                        "latitude": "46.53432000",
                        "longitude": "3.74453000"
                    },
                    {
                        "id": 41497,
                        "name": "Divonne-les-Bains",
                        "latitude": "46.35710000",
                        "longitude": "6.13494000"
                    },
                    {
                        "id": 41506,
                        "name": "Dolomieu",
                        "latitude": "45.60540000",
                        "longitude": "5.48571000"
                    },
                    {
                        "id": 41511,
                        "name": "Domancy",
                        "latitude": "45.91205000",
                        "longitude": "6.65271000"
                    },
                    {
                        "id": 41512,
                        "name": "Domarin",
                        "latitude": "45.58662000",
                        "longitude": "5.24599000"
                    },
                    {
                        "id": 41526,
                        "name": "Domène",
                        "latitude": "45.20289000",
                        "longitude": "5.83335000"
                    },
                    {
                        "id": 41527,
                        "name": "Domérat",
                        "latitude": "46.36036000",
                        "longitude": "2.53455000"
                    },
                    {
                        "id": 41515,
                        "name": "Domessin",
                        "latitude": "45.54739000",
                        "longitude": "5.70495000"
                    },
                    {
                        "id": 41522,
                        "name": "Dompierre-sur-Besbre",
                        "latitude": "46.52214000",
                        "longitude": "3.68106000"
                    },
                    {
                        "id": 41524,
                        "name": "Dompierre-sur-Veyle",
                        "latitude": "46.07108000",
                        "longitude": "5.20232000"
                    },
                    {
                        "id": 41537,
                        "name": "Donzère",
                        "latitude": "44.44246000",
                        "longitude": "4.71134000"
                    },
                    {
                        "id": 41543,
                        "name": "Dortan",
                        "latitude": "46.31973000",
                        "longitude": "5.66028000"
                    },
                    {
                        "id": 41557,
                        "name": "Doussard",
                        "latitude": "45.77512000",
                        "longitude": "6.22553000"
                    },
                    {
                        "id": 41558,
                        "name": "Douvaine",
                        "latitude": "46.30544000",
                        "longitude": "6.30375000"
                    },
                    {
                        "id": 41563,
                        "name": "Doyet",
                        "latitude": "46.33558000",
                        "longitude": "2.79718000"
                    },
                    {
                        "id": 41580,
                        "name": "Drumettaz",
                        "latitude": "45.66136000",
                        "longitude": "5.92191000"
                    },
                    {
                        "id": 41591,
                        "name": "Dunières",
                        "latitude": "45.21558000",
                        "longitude": "4.34471000"
                    },
                    {
                        "id": 41597,
                        "name": "Durtol",
                        "latitude": "45.79621000",
                        "longitude": "3.05156000"
                    },
                    {
                        "id": 48036,
                        "name": "Ébreuil",
                        "latitude": "46.11548000",
                        "longitude": "3.08677000"
                    },
                    {
                        "id": 48038,
                        "name": "Échalas",
                        "latitude": "45.55203000",
                        "longitude": "4.71544000"
                    },
                    {
                        "id": 48039,
                        "name": "Échenevex",
                        "latitude": "46.30923000",
                        "longitude": "6.03963000"
                    },
                    {
                        "id": 48042,
                        "name": "Échirolles",
                        "latitude": "45.14603000",
                        "longitude": "5.71441000"
                    },
                    {
                        "id": 48056,
                        "name": "Écully",
                        "latitude": "45.77437000",
                        "longitude": "4.77758000"
                    },
                    {
                        "id": 41675,
                        "name": "Ennezat",
                        "latitude": "45.89772000",
                        "longitude": "3.22348000"
                    },
                    {
                        "id": 41682,
                        "name": "Entre-Deux-Guiers",
                        "latitude": "45.43061000",
                        "longitude": "5.75209000"
                    },
                    {
                        "id": 41684,
                        "name": "Enval",
                        "latitude": "45.89921000",
                        "longitude": "3.04981000"
                    },
                    {
                        "id": 48069,
                        "name": "Épagny",
                        "latitude": "45.93584000",
                        "longitude": "6.08302000"
                    },
                    {
                        "id": 48082,
                        "name": "Épinouze",
                        "latitude": "45.31003000",
                        "longitude": "4.92936000"
                    },
                    {
                        "id": 41713,
                        "name": "Escoutoux",
                        "latitude": "45.81942000",
                        "longitude": "3.56336000"
                    },
                    {
                        "id": 41717,
                        "name": "Espaly-Saint-Marcel",
                        "latitude": "45.04790000",
                        "longitude": "3.86557000"
                    },
                    {
                        "id": 41735,
                        "name": "Estivareilles",
                        "latitude": "46.42526000",
                        "longitude": "2.61872000"
                    },
                    {
                        "id": 41736,
                        "name": "Estrablin",
                        "latitude": "45.51546000",
                        "longitude": "4.96173000"
                    },
                    {
                        "id": 41740,
                        "name": "Etaux",
                        "latitude": "46.06835000",
                        "longitude": "6.29533000"
                    },
                    {
                        "id": 48106,
                        "name": "Étoile-sur-Rhône",
                        "latitude": "44.83883000",
                        "longitude": "4.89050000"
                    },
                    {
                        "id": 48109,
                        "name": "Étrembières",
                        "latitude": "46.17923000",
                        "longitude": "6.22725000"
                    },
                    {
                        "id": 41744,
                        "name": "Eurre",
                        "latitude": "44.75825000",
                        "longitude": "4.98843000"
                    },
                    {
                        "id": 48118,
                        "name": "Évian-les-Bains",
                        "latitude": "46.40111000",
                        "longitude": "6.58793000"
                    },
                    {
                        "id": 48120,
                        "name": "Évires",
                        "latitude": "46.03783000",
                        "longitude": "6.22453000"
                    },
                    {
                        "id": 41751,
                        "name": "Eybens",
                        "latitude": "45.14771000",
                        "longitude": "5.75014000"
                    },
                    {
                        "id": 41759,
                        "name": "Eyzin-Pinet",
                        "latitude": "45.47377000",
                        "longitude": "4.99845000"
                    },
                    {
                        "id": 41772,
                        "name": "Fareins",
                        "latitude": "46.01913000",
                        "longitude": "4.76136000"
                    },
                    {
                        "id": 41775,
                        "name": "Farnay",
                        "latitude": "45.49622000",
                        "longitude": "4.58311000"
                    },
                    {
                        "id": 41782,
                        "name": "Faverges",
                        "latitude": "45.75116000",
                        "longitude": "6.29151000"
                    },
                    {
                        "id": 41783,
                        "name": "Faverges-de-la-Tour",
                        "latitude": "45.59068000",
                        "longitude": "5.52136000"
                    },
                    {
                        "id": 41793,
                        "name": "Feigères",
                        "latitude": "46.11228000",
                        "longitude": "6.07937000"
                    },
                    {
                        "id": 41794,
                        "name": "Feillens",
                        "latitude": "46.33426000",
                        "longitude": "4.89146000"
                    },
                    {
                        "id": 42002,
                        "name": "Félines",
                        "latitude": "45.31668000",
                        "longitude": "4.72836000"
                    },
                    {
                        "id": 41801,
                        "name": "Ferney-Voltaire",
                        "latitude": "46.25858000",
                        "longitude": "6.11063000"
                    },
                    {
                        "id": 42008,
                        "name": "Féternes",
                        "latitude": "46.35582000",
                        "longitude": "6.54829000"
                    },
                    {
                        "id": 41814,
                        "name": "Feurs",
                        "latitude": "45.73337000",
                        "longitude": "4.22755000"
                    },
                    {
                        "id": 41816,
                        "name": "Feyzin",
                        "latitude": "45.67287000",
                        "longitude": "4.85894000"
                    },
                    {
                        "id": 41820,
                        "name": "Fillinges",
                        "latitude": "46.15944000",
                        "longitude": "6.34237000"
                    },
                    {
                        "id": 41824,
                        "name": "Firminy",
                        "latitude": "45.38956000",
                        "longitude": "4.28860000"
                    },
                    {
                        "id": 41826,
                        "name": "Fitilieu",
                        "latitude": "45.54744000",
                        "longitude": "5.56194000"
                    },
                    {
                        "id": 41830,
                        "name": "Flaviac",
                        "latitude": "44.74777000",
                        "longitude": "4.67434000"
                    },
                    {
                        "id": 41842,
                        "name": "Fleurie",
                        "latitude": "46.19219000",
                        "longitude": "4.69747000"
                    },
                    {
                        "id": 41843,
                        "name": "Fleurieu-sur-Saône",
                        "latitude": "45.86095000",
                        "longitude": "4.84633000"
                    },
                    {
                        "id": 41866,
                        "name": "Foissiat",
                        "latitude": "46.37150000",
                        "longitude": "5.17525000"
                    },
                    {
                        "id": 41876,
                        "name": "Fontaine",
                        "latitude": "45.19275000",
                        "longitude": "5.68821000"
                    },
                    {
                        "id": 41889,
                        "name": "Fontaines-Saint-Martin",
                        "latitude": "45.84420000",
                        "longitude": "4.85305000"
                    },
                    {
                        "id": 41890,
                        "name": "Fontaines-sur-Saône",
                        "latitude": "45.83572000",
                        "longitude": "4.84490000"
                    },
                    {
                        "id": 41891,
                        "name": "Fontanil-Cornillon",
                        "latitude": "45.25280000",
                        "longitude": "5.66308000"
                    },
                    {
                        "id": 41892,
                        "name": "Fontannes",
                        "latitude": "45.30149000",
                        "longitude": "3.76366000"
                    },
                    {
                        "id": 41944,
                        "name": "Fraisses",
                        "latitude": "45.38838000",
                        "longitude": "4.26373000"
                    },
                    {
                        "id": 41946,
                        "name": "Francheleins",
                        "latitude": "46.07440000",
                        "longitude": "4.80920000"
                    },
                    {
                        "id": 41947,
                        "name": "Francheville",
                        "latitude": "45.73637000",
                        "longitude": "4.76358000"
                    },
                    {
                        "id": 41950,
                        "name": "Frangy",
                        "latitude": "46.02000000",
                        "longitude": "5.93220000"
                    },
                    {
                        "id": 41952,
                        "name": "Frans",
                        "latitude": "45.99291000",
                        "longitude": "4.77820000"
                    },
                    {
                        "id": 41967,
                        "name": "Froges",
                        "latitude": "45.27377000",
                        "longitude": "5.92098000"
                    },
                    {
                        "id": 41974,
                        "name": "Frontenex",
                        "latitude": "45.63335000",
                        "longitude": "6.31168000"
                    },
                    {
                        "id": 41977,
                        "name": "Frontonas",
                        "latitude": "45.64487000",
                        "longitude": "5.19701000"
                    },
                    {
                        "id": 42016,
                        "name": "Gaillard",
                        "latitude": "46.18530000",
                        "longitude": "6.20693000"
                    },
                    {
                        "id": 42030,
                        "name": "Gannat",
                        "latitude": "46.09987000",
                        "longitude": "3.19842000"
                    },
                    {
                        "id": 42059,
                        "name": "Gelles",
                        "latitude": "45.76947000",
                        "longitude": "2.76309000"
                    },
                    {
                        "id": 42061,
                        "name": "Genas",
                        "latitude": "45.73131000",
                        "longitude": "5.00211000"
                    },
                    {
                        "id": 42062,
                        "name": "Genay",
                        "latitude": "45.89681000",
                        "longitude": "4.84091000"
                    },
                    {
                        "id": 42297,
                        "name": "Génissieux",
                        "latitude": "45.08413000",
                        "longitude": "5.08133000"
                    },
                    {
                        "id": 42077,
                        "name": "Gerzat",
                        "latitude": "45.82581000",
                        "longitude": "3.14473000"
                    },
                    {
                        "id": 42083,
                        "name": "Gex",
                        "latitude": "46.33323000",
                        "longitude": "6.05766000"
                    },
                    {
                        "id": 42111,
                        "name": "Gières",
                        "latitude": "45.17997000",
                        "longitude": "5.78935000"
                    },
                    {
                        "id": 42095,
                        "name": "Gillonnay",
                        "latitude": "45.39251000",
                        "longitude": "5.29413000"
                    },
                    {
                        "id": 42096,
                        "name": "Gilly-sur-Isère",
                        "latitude": "45.65917000",
                        "longitude": "6.35096000"
                    },
                    {
                        "id": 42108,
                        "name": "Givors",
                        "latitude": "45.59063000",
                        "longitude": "4.76878000"
                    },
                    {
                        "id": 42113,
                        "name": "Gleizé",
                        "latitude": "45.98916000",
                        "longitude": "4.69708000"
                    },
                    {
                        "id": 42123,
                        "name": "Goncelin",
                        "latitude": "45.34428000",
                        "longitude": "5.97896000"
                    },
                    {
                        "id": 42179,
                        "name": "Grandris",
                        "latitude": "46.03780000",
                        "longitude": "4.47526000"
                    },
                    {
                        "id": 42182,
                        "name": "Grane",
                        "latitude": "44.73255000",
                        "longitude": "4.92203000"
                    },
                    {
                        "id": 42197,
                        "name": "Grenay",
                        "latitude": "45.66347000",
                        "longitude": "5.08031000"
                    },
                    {
                        "id": 42200,
                        "name": "Grenoble",
                        "latitude": "45.17869000",
                        "longitude": "5.71479000"
                    },
                    {
                        "id": 42235,
                        "name": "Grésy-sur-Aix",
                        "latitude": "45.72311000",
                        "longitude": "5.92522000"
                    },
                    {
                        "id": 42236,
                        "name": "Grésy-sur-Isère",
                        "latitude": "45.59898000",
                        "longitude": "6.25358000"
                    },
                    {
                        "id": 42237,
                        "name": "Grézieu-la-Varenne",
                        "latitude": "45.74736000",
                        "longitude": "4.69037000"
                    },
                    {
                        "id": 42217,
                        "name": "Grièges",
                        "latitude": "46.25619000",
                        "longitude": "4.84856000"
                    },
                    {
                        "id": 42208,
                        "name": "Grignan",
                        "latitude": "44.41967000",
                        "longitude": "4.90785000"
                    },
                    {
                        "id": 42210,
                        "name": "Grignon",
                        "latitude": "45.65122000",
                        "longitude": "6.37795000"
                    },
                    {
                        "id": 42211,
                        "name": "Grigny",
                        "latitude": "45.60843000",
                        "longitude": "4.78976000"
                    },
                    {
                        "id": 42219,
                        "name": "Groissiat",
                        "latitude": "46.22213000",
                        "longitude": "5.60775000"
                    },
                    {
                        "id": 42220,
                        "name": "Groisy",
                        "latitude": "46.01008000",
                        "longitude": "6.16983000"
                    },
                    {
                        "id": 42229,
                        "name": "Gruffy",
                        "latitude": "45.78897000",
                        "longitude": "6.05648000"
                    },
                    {
                        "id": 42286,
                        "name": "Guéreins",
                        "latitude": "46.10346000",
                        "longitude": "4.77275000"
                    },
                    {
                        "id": 42259,
                        "name": "Guilherand-Granges",
                        "latitude": "44.93278000",
                        "longitude": "4.87372000"
                    },
                    {
                        "id": 42343,
                        "name": "Haute-Loire",
                        "latitude": "45.11001000",
                        "longitude": "3.83940000"
                    },
                    {
                        "id": 42345,
                        "name": "Haute-Rivoire",
                        "latitude": "45.71559000",
                        "longitude": "4.39633000"
                    },
                    {
                        "id": 42346,
                        "name": "Haute-Savoie",
                        "latitude": "46.06143000",
                        "longitude": "6.45374000"
                    },
                    {
                        "id": 42349,
                        "name": "Hauterive",
                        "latitude": "46.08834000",
                        "longitude": "3.44626000"
                    },
                    {
                        "id": 42350,
                        "name": "Hauterives",
                        "latitude": "45.25565000",
                        "longitude": "5.01904000"
                    },
                    {
                        "id": 42352,
                        "name": "Hauteville-Lompnes",
                        "latitude": "45.97794000",
                        "longitude": "5.60114000"
                    },
                    {
                        "id": 42372,
                        "name": "Herbeys",
                        "latitude": "45.14012000",
                        "longitude": "5.79289000"
                    },
                    {
                        "id": 42393,
                        "name": "Heyrieux",
                        "latitude": "45.63186000",
                        "longitude": "5.06284000"
                    },
                    {
                        "id": 42405,
                        "name": "Hières-sur-Amby",
                        "latitude": "45.79654000",
                        "longitude": "5.29333000"
                    },
                    {
                        "id": 42436,
                        "name": "Huez",
                        "latitude": "45.08240000",
                        "longitude": "6.05878000"
                    },
                    {
                        "id": 42443,
                        "name": "Huriel",
                        "latitude": "46.37299000",
                        "longitude": "2.47679000"
                    },
                    {
                        "id": 42493,
                        "name": "Irigny",
                        "latitude": "45.67313000",
                        "longitude": "4.82243000"
                    },
                    {
                        "id": 42505,
                        "name": "Issoire",
                        "latitude": "45.54422000",
                        "longitude": "3.24901000"
                    },
                    {
                        "id": 42519,
                        "name": "Izeaux",
                        "latitude": "45.33473000",
                        "longitude": "5.42486000"
                    },
                    {
                        "id": 42520,
                        "name": "Izernore",
                        "latitude": "46.21352000",
                        "longitude": "5.55200000"
                    },
                    {
                        "id": 42522,
                        "name": "Jacob-Bellecombette",
                        "latitude": "45.55763000",
                        "longitude": "5.91484000"
                    },
                    {
                        "id": 42525,
                        "name": "Janneyrias",
                        "latitude": "45.75221000",
                        "longitude": "5.11277000"
                    },
                    {
                        "id": 42531,
                        "name": "Jardin",
                        "latitude": "45.49638000",
                        "longitude": "4.90847000"
                    },
                    {
                        "id": 42535,
                        "name": "Jarrie",
                        "latitude": "45.11732000",
                        "longitude": "5.75957000"
                    },
                    {
                        "id": 42538,
                        "name": "Jassans-Riottier",
                        "latitude": "45.98134000",
                        "longitude": "4.76140000"
                    },
                    {
                        "id": 42539,
                        "name": "Jasseron",
                        "latitude": "46.21316000",
                        "longitude": "5.32579000"
                    },
                    {
                        "id": 42540,
                        "name": "Jaujac",
                        "latitude": "44.63695000",
                        "longitude": "4.25638000"
                    },
                    {
                        "id": 42551,
                        "name": "Job",
                        "latitude": "45.61607000",
                        "longitude": "3.74542000"
                    },
                    {
                        "id": 42555,
                        "name": "Jonage",
                        "latitude": "45.79638000",
                        "longitude": "5.04664000"
                    },
                    {
                        "id": 42561,
                        "name": "Jons",
                        "latitude": "45.80823000",
                        "longitude": "5.08070000"
                    },
                    {
                        "id": 42563,
                        "name": "Jonzieux",
                        "latitude": "45.31355000",
                        "longitude": "4.36158000"
                    },
                    {
                        "id": 42580,
                        "name": "Joyeuse",
                        "latitude": "44.47951000",
                        "longitude": "4.23778000"
                    },
                    {
                        "id": 42588,
                        "name": "Jujurieux",
                        "latitude": "46.04122000",
                        "longitude": "5.40855000"
                    },
                    {
                        "id": 42595,
                        "name": "Jussac",
                        "latitude": "44.98764000",
                        "longitude": "2.42308000"
                    },
                    {
                        "id": 43709,
                        "name": "L’Étrat",
                        "latitude": "45.48610000",
                        "longitude": "4.37586000"
                    },
                    {
                        "id": 43705,
                        "name": "L’Isle-d’Abeau",
                        "latitude": "45.61960000",
                        "longitude": "5.22466000"
                    },
                    {
                        "id": 42631,
                        "name": "La Balme-de-Sillingy",
                        "latitude": "45.96890000",
                        "longitude": "6.04187000"
                    },
                    {
                        "id": 42658,
                        "name": "La Bâthie",
                        "latitude": "45.62829000",
                        "longitude": "6.44900000"
                    },
                    {
                        "id": 42659,
                        "name": "La Bâtie-Montgascon",
                        "latitude": "45.57745000",
                        "longitude": "5.52873000"
                    },
                    {
                        "id": 42661,
                        "name": "La Bégude-de-Mazenc",
                        "latitude": "44.54298000",
                        "longitude": "4.93403000"
                    },
                    {
                        "id": 42642,
                        "name": "La Biolle",
                        "latitude": "45.75846000",
                        "longitude": "5.92866000"
                    },
                    {
                        "id": 42645,
                        "name": "La Boisse",
                        "latitude": "45.84278000",
                        "longitude": "5.03639000"
                    },
                    {
                        "id": 42650,
                        "name": "La Bourboule",
                        "latitude": "45.58829000",
                        "longitude": "2.73920000"
                    },
                    {
                        "id": 42654,
                        "name": "La Bridoire",
                        "latitude": "45.52504000",
                        "longitude": "5.74073000"
                    },
                    {
                        "id": 42657,
                        "name": "La Buisse",
                        "latitude": "45.34644000",
                        "longitude": "5.61435000"
                    },
                    {
                        "id": 42676,
                        "name": "La Chambre",
                        "latitude": "45.35862000",
                        "longitude": "6.29978000"
                    },
                    {
                        "id": 42692,
                        "name": "La Chapelle-de-la-Tour",
                        "latitude": "45.58484000",
                        "longitude": "5.46360000"
                    },
                    {
                        "id": 42710,
                        "name": "La Clusaz",
                        "latitude": "45.90675000",
                        "longitude": "6.43445000"
                    },
                    {
                        "id": 42726,
                        "name": "La Côte-Saint-André",
                        "latitude": "45.39447000",
                        "longitude": "5.25908000"
                    },
                    {
                        "id": 42754,
                        "name": "La Fouillouse",
                        "latitude": "45.50462000",
                        "longitude": "4.31524000"
                    },
                    {
                        "id": 42762,
                        "name": "La Garde-Adhémar",
                        "latitude": "44.39699000",
                        "longitude": "4.75759000"
                    },
                    {
                        "id": 42771,
                        "name": "La Grand-Croix",
                        "latitude": "45.50383000",
                        "longitude": "4.55915000"
                    },
                    {
                        "id": 42808,
                        "name": "La Monnerie-le-Montel",
                        "latitude": "45.87106000",
                        "longitude": "3.60110000"
                    },
                    {
                        "id": 42817,
                        "name": "La Motte-d’Aveillans",
                        "latitude": "44.96015000",
                        "longitude": "5.74409000"
                    },
                    {
                        "id": 42815,
                        "name": "La Motte-Saint-Martin",
                        "latitude": "44.95131000",
                        "longitude": "5.71814000"
                    },
                    {
                        "id": 42816,
                        "name": "La Motte-Servolex",
                        "latitude": "45.59702000",
                        "longitude": "5.86724000"
                    },
                    {
                        "id": 42818,
                        "name": "La Mulatière",
                        "latitude": "45.72818000",
                        "longitude": "4.81213000"
                    },
                    {
                        "id": 42819,
                        "name": "La Mure",
                        "latitude": "44.90145000",
                        "longitude": "5.78874000"
                    },
                    {
                        "id": 42820,
                        "name": "La Murette",
                        "latitude": "45.37891000",
                        "longitude": "5.54200000"
                    },
                    {
                        "id": 42825,
                        "name": "La Pacaudière",
                        "latitude": "46.17879000",
                        "longitude": "3.86252000"
                    },
                    {
                        "id": 42841,
                        "name": "La Ravoire",
                        "latitude": "45.56266000",
                        "longitude": "5.95826000"
                    },
                    {
                        "id": 42845,
                        "name": "La Ricamarie",
                        "latitude": "45.40536000",
                        "longitude": "4.36944000"
                    },
                    {
                        "id": 42850,
                        "name": "La Roche-Blanche",
                        "latitude": "45.70062000",
                        "longitude": "3.12629000"
                    },
                    {
                        "id": 42856,
                        "name": "La Roche-de-Glun",
                        "latitude": "45.01336000",
                        "longitude": "4.84488000"
                    },
                    {
                        "id": 42858,
                        "name": "La Roche-sur-Foron",
                        "latitude": "46.07111000",
                        "longitude": "6.30450000"
                    },
                    {
                        "id": 42862,
                        "name": "La Rochette",
                        "latitude": "45.45758000",
                        "longitude": "6.11356000"
                    },
                    {
                        "id": 42881,
                        "name": "La Séauve-sur-Semène",
                        "latitude": "45.29554000",
                        "longitude": "4.25023000"
                    },
                    {
                        "id": 42883,
                        "name": "La Talaudière",
                        "latitude": "45.47603000",
                        "longitude": "4.42607000"
                    },
                    {
                        "id": 42885,
                        "name": "La Terrasse",
                        "latitude": "45.32052000",
                        "longitude": "5.92761000"
                    },
                    {
                        "id": 42889,
                        "name": "La Tour",
                        "latitude": "46.13312000",
                        "longitude": "6.43109000"
                    },
                    {
                        "id": 42890,
                        "name": "La Tour-de-Salvagny",
                        "latitude": "45.81374000",
                        "longitude": "4.71670000"
                    },
                    {
                        "id": 42892,
                        "name": "La Tour-du-Pin",
                        "latitude": "45.56600000",
                        "longitude": "5.44487000"
                    },
                    {
                        "id": 42893,
                        "name": "La Tour-en-Jarez",
                        "latitude": "45.48347000",
                        "longitude": "4.39064000"
                    },
                    {
                        "id": 42900,
                        "name": "La Tronche",
                        "latitude": "45.20507000",
                        "longitude": "5.74629000"
                    },
                    {
                        "id": 42908,
                        "name": "La Verpillière",
                        "latitude": "45.63417000",
                        "longitude": "5.14560000"
                    },
                    {
                        "id": 42918,
                        "name": "La Voulte-sur-Rhône",
                        "latitude": "44.79958000",
                        "longitude": "4.77925000"
                    },
                    {
                        "id": 42940,
                        "name": "Labégude",
                        "latitude": "44.64496000",
                        "longitude": "4.36939000"
                    },
                    {
                        "id": 42933,
                        "name": "Lablachère",
                        "latitude": "44.46355000",
                        "longitude": "4.21439000"
                    },
                    {
                        "id": 42946,
                        "name": "Lachapelle-sous-Aubenas",
                        "latitude": "44.56421000",
                        "longitude": "4.36393000"
                    },
                    {
                        "id": 42957,
                        "name": "Lagnieu",
                        "latitude": "45.90237000",
                        "longitude": "5.34399000"
                    },
                    {
                        "id": 42972,
                        "name": "Laiz",
                        "latitude": "46.25054000",
                        "longitude": "4.88955000"
                    },
                    {
                        "id": 42974,
                        "name": "Lalevade-d’Ardèche",
                        "latitude": "44.64780000",
                        "longitude": "4.32303000"
                    },
                    {
                        "id": 42984,
                        "name": "Lamastre",
                        "latitude": "44.98672000",
                        "longitude": "4.57975000"
                    },
                    {
                        "id": 42996,
                        "name": "Lamure-sur-Azergues",
                        "latitude": "46.06255000",
                        "longitude": "4.49195000"
                    },
                    {
                        "id": 42998,
                        "name": "Lancrans",
                        "latitude": "46.12729000",
                        "longitude": "5.83277000"
                    },
                    {
                        "id": 43021,
                        "name": "Langeac",
                        "latitude": "45.10028000",
                        "longitude": "3.49420000"
                    },
                    {
                        "id": 43039,
                        "name": "Lanobre",
                        "latitude": "45.43889000",
                        "longitude": "2.53443000"
                    },
                    {
                        "id": 43045,
                        "name": "Lans-en-Vercors",
                        "latitude": "45.12852000",
                        "longitude": "5.58599000"
                    },
                    {
                        "id": 43051,
                        "name": "Lantriac",
                        "latitude": "45.00050000",
                        "longitude": "4.00444000"
                    },
                    {
                        "id": 43058,
                        "name": "Lapalisse",
                        "latitude": "46.24835000",
                        "longitude": "3.63605000"
                    },
                    {
                        "id": 43063,
                        "name": "Lapte",
                        "latitude": "45.18593000",
                        "longitude": "4.21699000"
                    },
                    {
                        "id": 43066,
                        "name": "Larajasse",
                        "latitude": "45.61399000",
                        "longitude": "4.50113000"
                    },
                    {
                        "id": 43070,
                        "name": "Larequille",
                        "latitude": "46.25189000",
                        "longitude": "2.70163000"
                    },
                    {
                        "id": 43071,
                        "name": "Largentière",
                        "latitude": "44.54272000",
                        "longitude": "4.29342000"
                    },
                    {
                        "id": 43078,
                        "name": "Laroquebrou",
                        "latitude": "44.96855000",
                        "longitude": "2.19158000"
                    },
                    {
                        "id": 43080,
                        "name": "Larringes",
                        "latitude": "46.36919000",
                        "longitude": "6.57125000"
                    },
                    {
                        "id": 43100,
                        "name": "Laussonne",
                        "latitude": "44.96990000",
                        "longitude": "4.05204000"
                    },
                    {
                        "id": 43112,
                        "name": "Lavault-Sainte-Anne",
                        "latitude": "46.30999000",
                        "longitude": "2.60027000"
                    },
                    {
                        "id": 43117,
                        "name": "Lavilledieu",
                        "latitude": "44.57545000",
                        "longitude": "4.45314000"
                    },
                    {
                        "id": 43133,
                        "name": "Le Bois-d'Oingt",
                        "latitude": "45.91718000",
                        "longitude": "4.58259000"
                    },
                    {
                        "id": 43137,
                        "name": "Le Bourg-d’Oisans",
                        "latitude": "45.05483000",
                        "longitude": "6.03366000"
                    },
                    {
                        "id": 43139,
                        "name": "Le Bourget-du-Lac",
                        "latitude": "45.65362000",
                        "longitude": "5.85490000"
                    },
                    {
                        "id": 43145,
                        "name": "Le Breuil-sur-Couze",
                        "latitude": "45.46860000",
                        "longitude": "3.26310000"
                    },
                    {
                        "id": 43159,
                        "name": "Le Cendre",
                        "latitude": "45.72240000",
                        "longitude": "3.18711000"
                    },
                    {
                        "id": 43160,
                        "name": "Le Chambon-Feugerolles",
                        "latitude": "45.39145000",
                        "longitude": "4.32149000"
                    },
                    {
                        "id": 43161,
                        "name": "Le Chambon-sur-Lignon",
                        "latitude": "45.06097000",
                        "longitude": "4.30241000"
                    },
                    {
                        "id": 43163,
                        "name": "Le Champ-près-Froges",
                        "latitude": "45.28045000",
                        "longitude": "5.93977000"
                    },
                    {
                        "id": 43166,
                        "name": "Le Cheylard",
                        "latitude": "44.90623000",
                        "longitude": "4.42406000"
                    },
                    {
                        "id": 43167,
                        "name": "Le Cheylas",
                        "latitude": "45.37064000",
                        "longitude": "5.99277000"
                    },
                    {
                        "id": 43171,
                        "name": "Le Coteau",
                        "latitude": "46.01919000",
                        "longitude": "4.09230000"
                    },
                    {
                        "id": 43174,
                        "name": "Le Crest",
                        "latitude": "45.68666000",
                        "longitude": "3.12735000"
                    },
                    {
                        "id": 43179,
                        "name": "Le Donjon",
                        "latitude": "46.35058000",
                        "longitude": "3.79269000"
                    },
                    {
                        "id": 43194,
                        "name": "Le Grand-Bornand",
                        "latitude": "45.94211000",
                        "longitude": "6.43077000"
                    },
                    {
                        "id": 43196,
                        "name": "Le Grand-Lemps",
                        "latitude": "45.39646000",
                        "longitude": "5.42010000"
                    },
                    {
                        "id": 43202,
                        "name": "Le Gua",
                        "latitude": "45.01667000",
                        "longitude": "5.61667000"
                    },
                    {
                        "id": 43224,
                        "name": "Le Mayet-de-Montagne",
                        "latitude": "46.07091000",
                        "longitude": "3.66665000"
                    },
                    {
                        "id": 43235,
                        "name": "Le Monastier-sur-Gazeille",
                        "latitude": "44.93333000",
                        "longitude": "4.00000000"
                    },
                    {
                        "id": 43288,
                        "name": "Le Péage-de-Roussillon",
                        "latitude": "45.37380000",
                        "longitude": "4.79727000"
                    },
                    {
                        "id": 43252,
                        "name": "Le Perréon",
                        "latitude": "46.06316000",
                        "longitude": "4.60045000"
                    },
                    {
                        "id": 43258,
                        "name": "Le Pin",
                        "latitude": "45.45582000",
                        "longitude": "5.50497000"
                    },
                    {
                        "id": 43273,
                        "name": "Le Pont-de-Beauvoisin",
                        "latitude": "45.53694000",
                        "longitude": "5.67333000"
                    },
                    {
                        "id": 43274,
                        "name": "Le Pont-de-Claix",
                        "latitude": "45.12321000",
                        "longitude": "5.69782000"
                    },
                    {
                        "id": 43282,
                        "name": "Le Pouzin",
                        "latitude": "44.75173000",
                        "longitude": "4.74798000"
                    },
                    {
                        "id": 43287,
                        "name": "Le Puy-en-Velay",
                        "latitude": "45.04366000",
                        "longitude": "3.88523000"
                    },
                    {
                        "id": 43299,
                        "name": "Le Sappey-en-Chartreuse",
                        "latitude": "45.26235000",
                        "longitude": "5.77476000"
                    },
                    {
                        "id": 43307,
                        "name": "Le Teil",
                        "latitude": "44.54531000",
                        "longitude": "4.68223000"
                    },
                    {
                        "id": 43322,
                        "name": "Le Touvet",
                        "latitude": "45.35909000",
                        "longitude": "5.95283000"
                    },
                    {
                        "id": 43331,
                        "name": "Le Versoud",
                        "latitude": "45.21988000",
                        "longitude": "5.86502000"
                    },
                    {
                        "id": 43348,
                        "name": "Lempdes-sur-Allagnon",
                        "latitude": "45.38333000",
                        "longitude": "3.28333000"
                    },
                    {
                        "id": 43351,
                        "name": "Lent",
                        "latitude": "46.12027000",
                        "longitude": "5.19352000"
                    },
                    {
                        "id": 43352,
                        "name": "Lentigny",
                        "latitude": "45.99391000",
                        "longitude": "3.97918000"
                    },
                    {
                        "id": 43353,
                        "name": "Lentilly",
                        "latitude": "45.81873000",
                        "longitude": "4.66304000"
                    },
                    {
                        "id": 43355,
                        "name": "Les Abrets",
                        "latitude": "45.54466000",
                        "longitude": "5.58021000"
                    },
                    {
                        "id": 43359,
                        "name": "Les Allues",
                        "latitude": "45.43255000",
                        "longitude": "6.55558000"
                    },
                    {
                        "id": 43361,
                        "name": "Les Ancizes",
                        "latitude": "45.92524000",
                        "longitude": "2.81265000"
                    },
                    {
                        "id": 43369,
                        "name": "Les Avenières",
                        "latitude": "45.63632000",
                        "longitude": "5.56144000"
                    },
                    {
                        "id": 43377,
                        "name": "Les Chères",
                        "latitude": "45.88960000",
                        "longitude": "4.74261000"
                    },
                    {
                        "id": 43380,
                        "name": "Les Contamines-Montjoie",
                        "latitude": "45.82164000",
                        "longitude": "6.72865000"
                    },
                    {
                        "id": 43382,
                        "name": "Les Côtes-d'Arey",
                        "latitude": "45.45640000",
                        "longitude": "4.86660000"
                    },
                    {
                        "id": 43383,
                        "name": "Les Deux Alpes",
                        "latitude": "45.01160000",
                        "longitude": "6.12548000"
                    },
                    {
                        "id": 43434,
                        "name": "Les Échelles",
                        "latitude": "45.44058000",
                        "longitude": "5.74866000"
                    },
                    {
                        "id": 43390,
                        "name": "Les Gets",
                        "latitude": "46.15522000",
                        "longitude": "6.66492000"
                    },
                    {
                        "id": 43396,
                        "name": "Les Houches",
                        "latitude": "45.89267000",
                        "longitude": "6.80637000"
                    },
                    {
                        "id": 43405,
                        "name": "Les Marches",
                        "latitude": "45.50042000",
                        "longitude": "6.00381000"
                    },
                    {
                        "id": 43406,
                        "name": "Les Martres-d'Artière",
                        "latitude": "45.83333000",
                        "longitude": "3.26667000"
                    },
                    {
                        "id": 43424,
                        "name": "Les Roches-de-Condrieu",
                        "latitude": "45.45281000",
                        "longitude": "4.76718000"
                    },
                    {
                        "id": 43433,
                        "name": "Les Vans",
                        "latitude": "44.40522000",
                        "longitude": "4.13198000"
                    },
                    {
                        "id": 43458,
                        "name": "Leyment",
                        "latitude": "45.92390000",
                        "longitude": "5.29241000"
                    },
                    {
                        "id": 43700,
                        "name": "Lézigneux",
                        "latitude": "45.56589000",
                        "longitude": "4.06542000"
                    },
                    {
                        "id": 43461,
                        "name": "Lezoux",
                        "latitude": "45.82689000",
                        "longitude": "3.37924000"
                    },
                    {
                        "id": 43467,
                        "name": "Liergues",
                        "latitude": "45.97138000",
                        "longitude": "4.66231000"
                    },
                    {
                        "id": 43488,
                        "name": "Limas",
                        "latitude": "45.97558000",
                        "longitude": "4.70550000"
                    },
                    {
                        "id": 43494,
                        "name": "Limonest",
                        "latitude": "45.83702000",
                        "longitude": "4.77188000"
                    },
                    {
                        "id": 43511,
                        "name": "Lissieu",
                        "latitude": "45.86487000",
                        "longitude": "4.74221000"
                    },
                    {
                        "id": 43517,
                        "name": "Livet-et-Gavet",
                        "latitude": "45.10782000",
                        "longitude": "5.93333000"
                    },
                    {
                        "id": 43519,
                        "name": "Livron-sur-Drôme",
                        "latitude": "44.77689000",
                        "longitude": "4.84180000"
                    },
                    {
                        "id": 43541,
                        "name": "Loire-sur-Rhône",
                        "latitude": "45.55000000",
                        "longitude": "4.80000000"
                    },
                    {
                        "id": 43544,
                        "name": "Loisin",
                        "latitude": "46.29227000",
                        "longitude": "6.31010000"
                    },
                    {
                        "id": 43584,
                        "name": "Lorette",
                        "latitude": "45.51105000",
                        "longitude": "4.58242000"
                    },
                    {
                        "id": 43589,
                        "name": "Loriol-sur-Drôme",
                        "latitude": "44.74703000",
                        "longitude": "4.81719000"
                    },
                    {
                        "id": 43622,
                        "name": "Lovagny",
                        "latitude": "45.90377000",
                        "longitude": "6.03281000"
                    },
                    {
                        "id": 43624,
                        "name": "Loyettes",
                        "latitude": "45.77663000",
                        "longitude": "5.20687000"
                    },
                    {
                        "id": 43625,
                        "name": "Lozanne",
                        "latitude": "45.85733000",
                        "longitude": "4.68070000"
                    },
                    {
                        "id": 43633,
                        "name": "Lucenay",
                        "latitude": "45.91274000",
                        "longitude": "4.70287000"
                    },
                    {
                        "id": 43636,
                        "name": "Lucinges",
                        "latitude": "46.19181000",
                        "longitude": "6.31511000"
                    },
                    {
                        "id": 43643,
                        "name": "Lugrin",
                        "latitude": "46.40208000",
                        "longitude": "6.65283000"
                    },
                    {
                        "id": 43646,
                        "name": "Lumbin",
                        "latitude": "45.30954000",
                        "longitude": "5.91505000"
                    },
                    {
                        "id": 43658,
                        "name": "Lurcy-Lévis",
                        "latitude": "46.72981000",
                        "longitude": "2.93829000"
                    },
                    {
                        "id": 43662,
                        "name": "Lusigny",
                        "latitude": "46.58776000",
                        "longitude": "3.49142000"
                    },
                    {
                        "id": 43673,
                        "name": "Luzinay",
                        "latitude": "45.58996000",
                        "longitude": "4.95891000"
                    },
                    {
                        "id": 43677,
                        "name": "Lyaud",
                        "latitude": "46.33972000",
                        "longitude": "6.52595000"
                    },
                    {
                        "id": 43678,
                        "name": "Lyon",
                        "latitude": "45.74846000",
                        "longitude": "4.84671000"
                    },
                    {
                        "id": 43710,
                        "name": "Mably",
                        "latitude": "46.06484000",
                        "longitude": "4.06014000"
                    },
                    {
                        "id": 43715,
                        "name": "Maclas",
                        "latitude": "45.36289000",
                        "longitude": "4.68200000"
                    },
                    {
                        "id": 44452,
                        "name": "Mâcot-la-Plagne",
                        "latitude": "45.55000000",
                        "longitude": "6.66667000"
                    },
                    {
                        "id": 43720,
                        "name": "Magland",
                        "latitude": "46.02064000",
                        "longitude": "6.62089000"
                    },
                    {
                        "id": 43750,
                        "name": "Malataverne",
                        "latitude": "44.48525000",
                        "longitude": "4.75326000"
                    },
                    {
                        "id": 43761,
                        "name": "Malintrat",
                        "latitude": "45.81509000",
                        "longitude": "3.18603000"
                    },
                    {
                        "id": 43762,
                        "name": "Malissard",
                        "latitude": "44.89969000",
                        "longitude": "4.95384000"
                    },
                    {
                        "id": 43787,
                        "name": "Manzat",
                        "latitude": "45.96160000",
                        "longitude": "2.94140000"
                    },
                    {
                        "id": 43788,
                        "name": "Manziat",
                        "latitude": "46.36125000",
                        "longitude": "4.90580000"
                    },
                    {
                        "id": 43795,
                        "name": "Marboz",
                        "latitude": "46.34290000",
                        "longitude": "5.25722000"
                    },
                    {
                        "id": 43797,
                        "name": "Marcellaz-Albanais",
                        "latitude": "45.87546000",
                        "longitude": "5.99880000"
                    },
                    {
                        "id": 43806,
                        "name": "Marcilly-le-Châtel",
                        "latitude": "45.69590000",
                        "longitude": "4.03082000"
                    },
                    {
                        "id": 43822,
                        "name": "Marennes",
                        "latitude": "45.62089000",
                        "longitude": "4.91236000"
                    },
                    {
                        "id": 43833,
                        "name": "Margencel",
                        "latitude": "46.34140000",
                        "longitude": "6.41416000"
                    },
                    {
                        "id": 43839,
                        "name": "Marignier",
                        "latitude": "46.09014000",
                        "longitude": "6.50004000"
                    },
                    {
                        "id": 43845,
                        "name": "Marin",
                        "latitude": "46.37941000",
                        "longitude": "6.52559000"
                    },
                    {
                        "id": 43847,
                        "name": "Maringues",
                        "latitude": "45.92164000",
                        "longitude": "3.33029000"
                    },
                    {
                        "id": 43852,
                        "name": "Marlhes",
                        "latitude": "45.28307000",
                        "longitude": "4.39616000"
                    },
                    {
                        "id": 43862,
                        "name": "Marnaz",
                        "latitude": "46.06356000",
                        "longitude": "6.52653000"
                    },
                    {
                        "id": 43877,
                        "name": "Marsac-en-Livradois",
                        "latitude": "45.47886000",
                        "longitude": "3.72783000"
                    },
                    {
                        "id": 43880,
                        "name": "Marsanne",
                        "latitude": "44.64204000",
                        "longitude": "4.87529000"
                    },
                    {
                        "id": 43881,
                        "name": "Marsat",
                        "latitude": "45.87645000",
                        "longitude": "3.08173000"
                    },
                    {
                        "id": 43910,
                        "name": "Marthod",
                        "latitude": "45.72714000",
                        "longitude": "6.40299000"
                    },
                    {
                        "id": 43912,
                        "name": "Martignat",
                        "latitude": "46.20972000",
                        "longitude": "5.61049000"
                    },
                    {
                        "id": 43933,
                        "name": "Massiac",
                        "latitude": "45.25146000",
                        "longitude": "3.19735000"
                    },
                    {
                        "id": 43934,
                        "name": "Massieux",
                        "latitude": "45.90984000",
                        "longitude": "4.83265000"
                    },
                    {
                        "id": 43935,
                        "name": "Massongy",
                        "latitude": "46.31807000",
                        "longitude": "6.33148000"
                    },
                    {
                        "id": 43944,
                        "name": "Maubec",
                        "latitude": "45.56739000",
                        "longitude": "5.26371000"
                    },
                    {
                        "id": 43956,
                        "name": "Mauriac",
                        "latitude": "45.21899000",
                        "longitude": "2.33353000"
                    },
                    {
                        "id": 43958,
                        "name": "Maurs",
                        "latitude": "44.71065000",
                        "longitude": "2.19797000"
                    },
                    {
                        "id": 43960,
                        "name": "Mauves",
                        "latitude": "45.03833000",
                        "longitude": "4.82934000"
                    },
                    {
                        "id": 43966,
                        "name": "Maxilly-sur-Léman",
                        "latitude": "46.39828000",
                        "longitude": "6.63113000"
                    },
                    {
                        "id": 43974,
                        "name": "Mazet-Saint-Voy",
                        "latitude": "45.04696000",
                        "longitude": "4.24414000"
                    },
                    {
                        "id": 44454,
                        "name": "Méaudre",
                        "latitude": "45.13020000",
                        "longitude": "5.52853000"
                    },
                    {
                        "id": 43984,
                        "name": "Megève",
                        "latitude": "45.85687000",
                        "longitude": "6.61775000"
                    },
                    {
                        "id": 43989,
                        "name": "Meillonnas",
                        "latitude": "46.24367000",
                        "longitude": "5.35019000"
                    },
                    {
                        "id": 44467,
                        "name": "Ménétrol",
                        "latitude": "45.87155000",
                        "longitude": "3.12422000"
                    },
                    {
                        "id": 44004,
                        "name": "Mens",
                        "latitude": "44.81557000",
                        "longitude": "5.75146000"
                    },
                    {
                        "id": 44006,
                        "name": "Menthon-Saint-Bernard",
                        "latitude": "45.85995000",
                        "longitude": "6.19552000"
                    },
                    {
                        "id": 44011,
                        "name": "Mercurol-Veaunes",
                        "latitude": "45.07437000",
                        "longitude": "4.89279000"
                    },
                    {
                        "id": 44012,
                        "name": "Mercury",
                        "latitude": "45.67452000",
                        "longitude": "6.33688000"
                    },
                    {
                        "id": 44470,
                        "name": "Méribel",
                        "latitude": "45.41497000",
                        "longitude": "6.56500000"
                    },
                    {
                        "id": 44477,
                        "name": "Méry",
                        "latitude": "45.64139000",
                        "longitude": "5.93550000"
                    },
                    {
                        "id": 44035,
                        "name": "Messeix",
                        "latitude": "45.61702000",
                        "longitude": "2.54157000"
                    },
                    {
                        "id": 44036,
                        "name": "Messery",
                        "latitude": "46.35036000",
                        "longitude": "6.29099000"
                    },
                    {
                        "id": 44038,
                        "name": "Messimy",
                        "latitude": "45.69816000",
                        "longitude": "4.67429000"
                    },
                    {
                        "id": 44040,
                        "name": "Metz",
                        "latitude": "45.93343000",
                        "longitude": "6.10973000"
                    },
                    {
                        "id": 44053,
                        "name": "Meximieux",
                        "latitude": "45.90823000",
                        "longitude": "5.19920000"
                    },
                    {
                        "id": 44056,
                        "name": "Meylan",
                        "latitude": "45.20978000",
                        "longitude": "5.77762000"
                    },
                    {
                        "id": 44063,
                        "name": "Meysse",
                        "latitude": "44.61028000",
                        "longitude": "4.72306000"
                    },
                    {
                        "id": 44064,
                        "name": "Meythet",
                        "latitude": "45.91836000",
                        "longitude": "6.09422000"
                    },
                    {
                        "id": 44065,
                        "name": "Meyzieu",
                        "latitude": "45.76637000",
                        "longitude": "5.00277000"
                    },
                    {
                        "id": 44066,
                        "name": "Mezel",
                        "latitude": "45.75508000",
                        "longitude": "3.24225000"
                    },
                    {
                        "id": 44492,
                        "name": "Mézériat",
                        "latitude": "46.23701000",
                        "longitude": "5.04615000"
                    },
                    {
                        "id": 44067,
                        "name": "Mieussy",
                        "latitude": "46.13369000",
                        "longitude": "6.52416000"
                    },
                    {
                        "id": 44075,
                        "name": "Millery",
                        "latitude": "45.63232000",
                        "longitude": "4.78207000"
                    },
                    {
                        "id": 44083,
                        "name": "Mionnay",
                        "latitude": "45.89824000",
                        "longitude": "4.92808000"
                    },
                    {
                        "id": 44084,
                        "name": "Mions",
                        "latitude": "45.66302000",
                        "longitude": "4.95292000"
                    },
                    {
                        "id": 44086,
                        "name": "Mirabel-aux-Baronnies",
                        "latitude": "44.31002000",
                        "longitude": "5.09962000"
                    },
                    {
                        "id": 44095,
                        "name": "Mirefleurs",
                        "latitude": "45.69319000",
                        "longitude": "3.22370000"
                    },
                    {
                        "id": 44100,
                        "name": "Miribel",
                        "latitude": "45.82580000",
                        "longitude": "4.95440000"
                    },
                    {
                        "id": 44101,
                        "name": "Miribel-les-Échelles",
                        "latitude": "45.43155000",
                        "longitude": "5.70810000"
                    },
                    {
                        "id": 44105,
                        "name": "Misérieux",
                        "latitude": "45.97433000",
                        "longitude": "4.81340000"
                    },
                    {
                        "id": 44109,
                        "name": "Modane",
                        "latitude": "45.20032000",
                        "longitude": "6.66871000"
                    },
                    {
                        "id": 44111,
                        "name": "Moidieu",
                        "latitude": "45.51680000",
                        "longitude": "5.00749000"
                    },
                    {
                        "id": 44113,
                        "name": "Moirans",
                        "latitude": "45.33140000",
                        "longitude": "5.55432000"
                    },
                    {
                        "id": 44122,
                        "name": "Molinet",
                        "latitude": "46.46576000",
                        "longitude": "3.93589000"
                    },
                    {
                        "id": 44143,
                        "name": "Monistrol-sur-Loire",
                        "latitude": "45.29263000",
                        "longitude": "4.17233000"
                    },
                    {
                        "id": 44145,
                        "name": "Monnetier-Mornex",
                        "latitude": "46.16030000",
                        "longitude": "6.20667000"
                    },
                    {
                        "id": 44160,
                        "name": "Mont-de-Lans",
                        "latitude": "45.03626000",
                        "longitude": "6.13141000"
                    },
                    {
                        "id": 44155,
                        "name": "Mont-Dore",
                        "latitude": "45.57641000",
                        "longitude": "2.80889000"
                    },
                    {
                        "id": 44159,
                        "name": "Mont-Saxonnex",
                        "latitude": "46.05080000",
                        "longitude": "6.47429000"
                    },
                    {
                        "id": 44166,
                        "name": "Montagnat",
                        "latitude": "46.16761000",
                        "longitude": "5.28791000"
                    },
                    {
                        "id": 44168,
                        "name": "Montagny",
                        "latitude": "45.62801000",
                        "longitude": "4.74778000"
                    },
                    {
                        "id": 44171,
                        "name": "Montaigut",
                        "latitude": "45.61499000",
                        "longitude": "3.44896000"
                    },
                    {
                        "id": 44173,
                        "name": "Montalieu",
                        "latitude": "45.81245000",
                        "longitude": "5.40221000"
                    },
                    {
                        "id": 44175,
                        "name": "Montanay",
                        "latitude": "45.87908000",
                        "longitude": "4.86308000"
                    },
                    {
                        "id": 44199,
                        "name": "Montbonnot-Saint-Martin",
                        "latitude": "45.22537000",
                        "longitude": "5.80170000"
                    },
                    {
                        "id": 44200,
                        "name": "Montboucher-sur-Jabron",
                        "latitude": "44.55050000",
                        "longitude": "4.80200000"
                    },
                    {
                        "id": 44201,
                        "name": "Montbrison",
                        "latitude": "45.60752000",
                        "longitude": "4.06525000"
                    },
                    {
                        "id": 44334,
                        "name": "Montéléger",
                        "latitude": "44.85296000",
                        "longitude": "4.93598000"
                    },
                    {
                        "id": 44332,
                        "name": "Montélier",
                        "latitude": "44.93441000",
                        "longitude": "5.03126000"
                    },
                    {
                        "id": 44333,
                        "name": "Montélimar",
                        "latitude": "44.55468000",
                        "longitude": "4.75469000"
                    },
                    {
                        "id": 44233,
                        "name": "Montfaucon-en-Velay",
                        "latitude": "45.18561000",
                        "longitude": "4.31376000"
                    },
                    {
                        "id": 44237,
                        "name": "Montferrat",
                        "latitude": "45.48481000",
                        "longitude": "5.59020000"
                    },
                    {
                        "id": 44277,
                        "name": "Montluçon",
                        "latitude": "46.34015000",
                        "longitude": "2.60254000"
                    },
                    {
                        "id": 44276,
                        "name": "Montluel",
                        "latitude": "45.85190000",
                        "longitude": "5.05780000"
                    },
                    {
                        "id": 44281,
                        "name": "Montmarault",
                        "latitude": "46.31738000",
                        "longitude": "2.95472000"
                    },
                    {
                        "id": 44291,
                        "name": "Montmélian",
                        "latitude": "45.50509000",
                        "longitude": "6.05634000"
                    },
                    {
                        "id": 44283,
                        "name": "Montmerle-sur-Saône",
                        "latitude": "46.08333000",
                        "longitude": "4.76667000"
                    },
                    {
                        "id": 44284,
                        "name": "Montmeyran",
                        "latitude": "44.83389000",
                        "longitude": "4.97181000"
                    },
                    {
                        "id": 44295,
                        "name": "Montoison",
                        "latitude": "44.79608000",
                        "longitude": "4.94118000"
                    },
                    {
                        "id": 44325,
                        "name": "Montréal-la-Cluse",
                        "latitude": "46.18333000",
                        "longitude": "5.58333000"
                    },
                    {
                        "id": 44316,
                        "name": "Montrevel-en-Bresse",
                        "latitude": "46.33527000",
                        "longitude": "5.12269000"
                    },
                    {
                        "id": 44320,
                        "name": "Montrond-les-Bains",
                        "latitude": "45.64374000",
                        "longitude": "4.23752000"
                    },
                    {
                        "id": 44321,
                        "name": "Montrottier",
                        "latitude": "45.79010000",
                        "longitude": "4.46660000"
                    },
                    {
                        "id": 44329,
                        "name": "Montségur-sur-Lauzon",
                        "latitude": "44.36098000",
                        "longitude": "4.85468000"
                    },
                    {
                        "id": 44340,
                        "name": "Morancé",
                        "latitude": "45.89815000",
                        "longitude": "4.70051000"
                    },
                    {
                        "id": 44348,
                        "name": "Morestel",
                        "latitude": "45.67900000",
                        "longitude": "5.46479000"
                    },
                    {
                        "id": 44361,
                        "name": "Mornant",
                        "latitude": "45.61885000",
                        "longitude": "4.67231000"
                    },
                    {
                        "id": 44377,
                        "name": "Morzine",
                        "latitude": "46.18149000",
                        "longitude": "6.70664000"
                    },
                    {
                        "id": 44394,
                        "name": "Moulins",
                        "latitude": "46.56459000",
                        "longitude": "3.33243000"
                    },
                    {
                        "id": 44405,
                        "name": "Mours-Saint-Eusèbe",
                        "latitude": "45.06513000",
                        "longitude": "5.05776000"
                    },
                    {
                        "id": 44428,
                        "name": "Moûtiers",
                        "latitude": "45.48459000",
                        "longitude": "6.53146000"
                    },
                    {
                        "id": 44415,
                        "name": "Mouxy",
                        "latitude": "45.68399000",
                        "longitude": "5.93538000"
                    },
                    {
                        "id": 44421,
                        "name": "Moye",
                        "latitude": "45.87566000",
                        "longitude": "5.91289000"
                    },
                    {
                        "id": 44425,
                        "name": "Mozac",
                        "latitude": "45.89393000",
                        "longitude": "3.09512000"
                    },
                    {
                        "id": 44439,
                        "name": "Murat",
                        "latitude": "45.11011000",
                        "longitude": "2.86859000"
                    },
                    {
                        "id": 44512,
                        "name": "Nantua",
                        "latitude": "46.15343000",
                        "longitude": "5.60601000"
                    },
                    {
                        "id": 44519,
                        "name": "Naucelles",
                        "latitude": "44.95898000",
                        "longitude": "2.41884000"
                    },
                    {
                        "id": 44695,
                        "name": "Néris-les-Bains",
                        "latitude": "46.28688000",
                        "longitude": "2.65869000"
                    },
                    {
                        "id": 44549,
                        "name": "Neuilly-le-Réal",
                        "latitude": "46.46413000",
                        "longitude": "3.43197000"
                    },
                    {
                        "id": 44555,
                        "name": "Neulise",
                        "latitude": "45.89811000",
                        "longitude": "4.18134000"
                    },
                    {
                        "id": 44558,
                        "name": "Neussargues",
                        "latitude": "45.12826000",
                        "longitude": "2.97627000"
                    },
                    {
                        "id": 44559,
                        "name": "Neuvecelle",
                        "latitude": "46.39502000",
                        "longitude": "6.61257000"
                    },
                    {
                        "id": 44581,
                        "name": "Neuvéglise",
                        "latitude": "44.92809000",
                        "longitude": "2.98328000"
                    },
                    {
                        "id": 44568,
                        "name": "Neuville-les-Dames",
                        "latitude": "46.16230000",
                        "longitude": "5.00667000"
                    },
                    {
                        "id": 44569,
                        "name": "Neuville-sur-Ain",
                        "latitude": "46.07144000",
                        "longitude": "5.37491000"
                    },
                    {
                        "id": 44573,
                        "name": "Neuville-sur-Saône",
                        "latitude": "45.87615000",
                        "longitude": "4.84099000"
                    },
                    {
                        "id": 44574,
                        "name": "Neuvy",
                        "latitude": "46.56191000",
                        "longitude": "3.29038000"
                    },
                    {
                        "id": 44586,
                        "name": "Neydens",
                        "latitude": "46.12162000",
                        "longitude": "6.10436000"
                    },
                    {
                        "id": 44605,
                        "name": "Niévroz",
                        "latitude": "45.82576000",
                        "longitude": "5.06108000"
                    },
                    {
                        "id": 44604,
                        "name": "Nivolas-Vermelle",
                        "latitude": "45.55885000",
                        "longitude": "5.30578000"
                    },
                    {
                        "id": 44620,
                        "name": "Nohanent",
                        "latitude": "45.80815000",
                        "longitude": "3.05507000"
                    },
                    {
                        "id": 44625,
                        "name": "Noirétable",
                        "latitude": "45.81671000",
                        "longitude": "3.76247000"
                    },
                    {
                        "id": 44653,
                        "name": "Notre-Dame-de-Mésage",
                        "latitude": "45.06241000",
                        "longitude": "5.75880000"
                    },
                    {
                        "id": 44665,
                        "name": "Novalaise",
                        "latitude": "45.59480000",
                        "longitude": "5.77767000"
                    },
                    {
                        "id": 44674,
                        "name": "Noyarey",
                        "latitude": "45.24421000",
                        "longitude": "5.63366000"
                    },
                    {
                        "id": 44690,
                        "name": "Nyons",
                        "latitude": "44.36082000",
                        "longitude": "5.14052000"
                    },
                    {
                        "id": 44756,
                        "name": "Orcet",
                        "latitude": "45.70355000",
                        "longitude": "3.16884000"
                    },
                    {
                        "id": 44760,
                        "name": "Orcines",
                        "latitude": "45.78246000",
                        "longitude": "3.01234000"
                    },
                    {
                        "id": 44775,
                        "name": "Orléat",
                        "latitude": "45.86059000",
                        "longitude": "3.42083000"
                    },
                    {
                        "id": 44772,
                        "name": "Orliénas",
                        "latitude": "45.65886000",
                        "longitude": "4.71832000"
                    },
                    {
                        "id": 44781,
                        "name": "Ornex",
                        "latitude": "46.27270000",
                        "longitude": "6.09982000"
                    },
                    {
                        "id": 44801,
                        "name": "Ouches",
                        "latitude": "46.01582000",
                        "longitude": "3.98828000"
                    },
                    {
                        "id": 44807,
                        "name": "Oullins",
                        "latitude": "45.71404000",
                        "longitude": "4.80755000"
                    },
                    {
                        "id": 44819,
                        "name": "Oyonnax",
                        "latitude": "46.25917000",
                        "longitude": "5.65727000"
                    },
                    {
                        "id": 44820,
                        "name": "Oytier-Saint-Oblas",
                        "latitude": "45.55757000",
                        "longitude": "5.03083000"
                    },
                    {
                        "id": 44842,
                        "name": "Panissières",
                        "latitude": "45.79185000",
                        "longitude": "4.34163000"
                    },
                    {
                        "id": 44863,
                        "name": "Paslières",
                        "latitude": "45.92889000",
                        "longitude": "3.49736000"
                    },
                    {
                        "id": 44865,
                        "name": "Passy",
                        "latitude": "45.92341000",
                        "longitude": "6.69562000"
                    },
                    {
                        "id": 44870,
                        "name": "Paulhaguet",
                        "latitude": "45.20795000",
                        "longitude": "3.51331000"
                    },
                    {
                        "id": 44878,
                        "name": "Peaugres",
                        "latitude": "45.28651000",
                        "longitude": "4.72845000"
                    },
                    {
                        "id": 44884,
                        "name": "Peillonnex",
                        "latitude": "46.12861000",
                        "longitude": "6.37715000"
                    },
                    {
                        "id": 45347,
                        "name": "Pélussin",
                        "latitude": "45.41951000",
                        "longitude": "4.68365000"
                    },
                    {
                        "id": 45354,
                        "name": "Pérignat-lès-Sarliève",
                        "latitude": "45.73657000",
                        "longitude": "3.13960000"
                    },
                    {
                        "id": 45355,
                        "name": "Pérignat-sur-Allier",
                        "latitude": "45.72843000",
                        "longitude": "3.23184000"
                    },
                    {
                        "id": 45356,
                        "name": "Périgneux",
                        "latitude": "45.44077000",
                        "longitude": "4.15569000"
                    },
                    {
                        "id": 45361,
                        "name": "Péron",
                        "latitude": "46.19053000",
                        "longitude": "5.92524000"
                    },
                    {
                        "id": 45362,
                        "name": "Péronnas",
                        "latitude": "46.18338000",
                        "longitude": "5.21052000"
                    },
                    {
                        "id": 45364,
                        "name": "Pérouges",
                        "latitude": "45.90440000",
                        "longitude": "5.17695000"
                    },
                    {
                        "id": 44901,
                        "name": "Perreux",
                        "latitude": "46.04004000",
                        "longitude": "4.12663000"
                    },
                    {
                        "id": 44903,
                        "name": "Perrignier",
                        "latitude": "46.30558000",
                        "longitude": "6.43928000"
                    },
                    {
                        "id": 44908,
                        "name": "Pers-Jussy",
                        "latitude": "46.10594000",
                        "longitude": "6.26955000"
                    },
                    {
                        "id": 44912,
                        "name": "Peschadoires",
                        "latitude": "45.82622000",
                        "longitude": "3.49255000"
                    },
                    {
                        "id": 44933,
                        "name": "Peyrins",
                        "latitude": "45.09331000",
                        "longitude": "5.04513000"
                    },
                    {
                        "id": 44950,
                        "name": "Pierre-Bénite",
                        "latitude": "45.70359000",
                        "longitude": "4.82424000"
                    },
                    {
                        "id": 44951,
                        "name": "Pierre-Châtel",
                        "latitude": "44.95735000",
                        "longitude": "5.77454000"
                    },
                    {
                        "id": 44958,
                        "name": "Pierrefort",
                        "latitude": "44.92175000",
                        "longitude": "2.83811000"
                    },
                    {
                        "id": 44959,
                        "name": "Pierrelatte",
                        "latitude": "44.37549000",
                        "longitude": "4.70314000"
                    },
                    {
                        "id": 44975,
                        "name": "Pionsat",
                        "latitude": "46.10963000",
                        "longitude": "2.69319000"
                    },
                    {
                        "id": 45004,
                        "name": "Plauzat",
                        "latitude": "45.62157000",
                        "longitude": "3.14896000"
                    },
                    {
                        "id": 45005,
                        "name": "Pleaux",
                        "latitude": "45.13479000",
                        "longitude": "2.22652000"
                    },
                    {
                        "id": 45135,
                        "name": "Poisat",
                        "latitude": "45.15852000",
                        "longitude": "5.76051000"
                    },
                    {
                        "id": 45137,
                        "name": "Poisy",
                        "latitude": "45.92142000",
                        "longitude": "6.06356000"
                    },
                    {
                        "id": 45141,
                        "name": "Polignac",
                        "latitude": "45.07090000",
                        "longitude": "3.86031000"
                    },
                    {
                        "id": 45144,
                        "name": "Polliat",
                        "latitude": "46.24849000",
                        "longitude": "5.12658000"
                    },
                    {
                        "id": 45145,
                        "name": "Pollionnay",
                        "latitude": "45.76459000",
                        "longitude": "4.66112000"
                    },
                    {
                        "id": 45146,
                        "name": "Polminhac",
                        "latitude": "44.95177000",
                        "longitude": "2.57751000"
                    },
                    {
                        "id": 45152,
                        "name": "Pommiers",
                        "latitude": "45.95540000",
                        "longitude": "4.69251000"
                    },
                    {
                        "id": 45161,
                        "name": "Poncin",
                        "latitude": "46.08531000",
                        "longitude": "5.41120000"
                    },
                    {
                        "id": 45187,
                        "name": "Pont-d’Ain",
                        "latitude": "46.05583000",
                        "longitude": "5.33974000"
                    },
                    {
                        "id": 45178,
                        "name": "Pont-de-Chéruy",
                        "latitude": "45.75344000",
                        "longitude": "5.17245000"
                    },
                    {
                        "id": 45183,
                        "name": "Pont-de-Vaux",
                        "latitude": "46.43326000",
                        "longitude": "4.94473000"
                    },
                    {
                        "id": 45184,
                        "name": "Pont-de-Veyle",
                        "latitude": "46.26166000",
                        "longitude": "4.88612000"
                    },
                    {
                        "id": 45186,
                        "name": "Pont-du-Château",
                        "latitude": "45.79830000",
                        "longitude": "3.24839000"
                    },
                    {
                        "id": 45188,
                        "name": "Pont-en-Royans",
                        "latitude": "45.06250000",
                        "longitude": "5.34094000"
                    },
                    {
                        "id": 45195,
                        "name": "Pont-Évêque",
                        "latitude": "45.53217000",
                        "longitude": "4.90922000"
                    },
                    {
                        "id": 45175,
                        "name": "Pont-Salomon",
                        "latitude": "45.33777000",
                        "longitude": "4.24781000"
                    },
                    {
                        "id": 45204,
                        "name": "Pontcharra",
                        "latitude": "45.43588000",
                        "longitude": "6.01782000"
                    },
                    {
                        "id": 45205,
                        "name": "Pontcharra-sur-Turdine",
                        "latitude": "45.87413000",
                        "longitude": "4.48989000"
                    },
                    {
                        "id": 45221,
                        "name": "Porcieu",
                        "latitude": "45.83416000",
                        "longitude": "5.40168000"
                    },
                    {
                        "id": 45240,
                        "name": "Portes-lès-Valence",
                        "latitude": "44.87585000",
                        "longitude": "4.87415000"
                    },
                    {
                        "id": 45255,
                        "name": "Pouilly-lès-Feurs",
                        "latitude": "45.79760000",
                        "longitude": "4.23289000"
                    },
                    {
                        "id": 45254,
                        "name": "Pouilly-les-Nonains",
                        "latitude": "46.04508000",
                        "longitude": "3.98247000"
                    },
                    {
                        "id": 45256,
                        "name": "Pouilly-sous-Charlieu",
                        "latitude": "46.14551000",
                        "longitude": "4.11287000"
                    },
                    {
                        "id": 45275,
                        "name": "Pragoulin",
                        "latitude": "46.05425000",
                        "longitude": "3.39346000"
                    },
                    {
                        "id": 45280,
                        "name": "Praz-sur-Arly",
                        "latitude": "45.83731000",
                        "longitude": "6.57259000"
                    },
                    {
                        "id": 45305,
                        "name": "Précieux",
                        "latitude": "45.58702000",
                        "longitude": "4.15152000"
                    },
                    {
                        "id": 45311,
                        "name": "Prémilhat",
                        "latitude": "46.31341000",
                        "longitude": "2.53559000"
                    },
                    {
                        "id": 45285,
                        "name": "Priay",
                        "latitude": "46.00183000",
                        "longitude": "5.28684000"
                    },
                    {
                        "id": 45287,
                        "name": "Pringy",
                        "latitude": "45.94622000",
                        "longitude": "6.12608000"
                    },
                    {
                        "id": 45291,
                        "name": "Privas",
                        "latitude": "44.73500000",
                        "longitude": "4.59918000"
                    },
                    {
                        "id": 45313,
                        "name": "Publier",
                        "latitude": "46.38773000",
                        "longitude": "6.54356000"
                    },
                    {
                        "id": 45331,
                        "name": "Pusignan",
                        "latitude": "45.75558000",
                        "longitude": "5.06722000"
                    },
                    {
                        "id": 45335,
                        "name": "Puy-Guillaume",
                        "latitude": "45.96036000",
                        "longitude": "3.47405000"
                    },
                    {
                        "id": 45394,
                        "name": "Quincié-en-Beaujolais",
                        "latitude": "46.11898000",
                        "longitude": "4.61635000"
                    },
                    {
                        "id": 45393,
                        "name": "Quincieux",
                        "latitude": "45.91374000",
                        "longitude": "4.77698000"
                    },
                    {
                        "id": 45399,
                        "name": "Quinssaines",
                        "latitude": "46.32721000",
                        "longitude": "2.51040000"
                    },
                    {
                        "id": 45400,
                        "name": "Quintenas",
                        "latitude": "45.18892000",
                        "longitude": "4.68743000"
                    },
                    {
                        "id": 45427,
                        "name": "Randan",
                        "latitude": "46.01767000",
                        "longitude": "3.35478000"
                    },
                    {
                        "id": 45687,
                        "name": "Régny",
                        "latitude": "45.99087000",
                        "longitude": "4.21655000"
                    },
                    {
                        "id": 45448,
                        "name": "Reignier-Ésery",
                        "latitude": "46.13333000",
                        "longitude": "6.26667000"
                    },
                    {
                        "id": 45456,
                        "name": "Renage",
                        "latitude": "45.33346000",
                        "longitude": "5.48881000"
                    },
                    {
                        "id": 45457,
                        "name": "Renaison",
                        "latitude": "46.04955000",
                        "longitude": "3.92440000"
                    },
                    {
                        "id": 45462,
                        "name": "Replonges",
                        "latitude": "46.30098000",
                        "longitude": "4.88317000"
                    },
                    {
                        "id": 45470,
                        "name": "Retournac",
                        "latitude": "45.20390000",
                        "longitude": "4.03330000"
                    },
                    {
                        "id": 45474,
                        "name": "Revel",
                        "latitude": "45.18618000",
                        "longitude": "5.87208000"
                    },
                    {
                        "id": 45476,
                        "name": "Reventin-Vaugris",
                        "latitude": "45.46638000",
                        "longitude": "4.84244000"
                    },
                    {
                        "id": 45481,
                        "name": "Reyrieux",
                        "latitude": "45.93577000",
                        "longitude": "4.81453000"
                    },
                    {
                        "id": 45512,
                        "name": "Rillieux-la-Pape",
                        "latitude": "45.81667000",
                        "longitude": "4.90000000"
                    },
                    {
                        "id": 45516,
                        "name": "Riom",
                        "latitude": "45.89362000",
                        "longitude": "3.11264000"
                    },
                    {
                        "id": 45517,
                        "name": "Riom-ès-Montagnes",
                        "latitude": "45.28206000",
                        "longitude": "2.65973000"
                    },
                    {
                        "id": 45520,
                        "name": "Riorges",
                        "latitude": "46.04378000",
                        "longitude": "4.04255000"
                    },
                    {
                        "id": 45521,
                        "name": "Riotord",
                        "latitude": "45.23159000",
                        "longitude": "4.40208000"
                    },
                    {
                        "id": 45526,
                        "name": "Rive-de-Gier",
                        "latitude": "45.52755000",
                        "longitude": "4.61589000"
                    },
                    {
                        "id": 45529,
                        "name": "Rives",
                        "latitude": "45.35326000",
                        "longitude": "5.50084000"
                    },
                    {
                        "id": 45535,
                        "name": "Roanne",
                        "latitude": "46.03624000",
                        "longitude": "4.06802000"
                    },
                    {
                        "id": 45539,
                        "name": "Roche",
                        "latitude": "45.58723000",
                        "longitude": "5.16223000"
                    },
                    {
                        "id": 45540,
                        "name": "Roche-la-Molière",
                        "latitude": "45.43088000",
                        "longitude": "4.32820000"
                    },
                    {
                        "id": 45547,
                        "name": "Rochegude",
                        "latitude": "44.24414000",
                        "longitude": "4.82719000"
                    },
                    {
                        "id": 45548,
                        "name": "Rochemaure",
                        "latitude": "44.58747000",
                        "longitude": "4.70391000"
                    },
                    {
                        "id": 45551,
                        "name": "Rochetaillée-sur-Saône",
                        "latitude": "45.85000000",
                        "longitude": "4.85000000"
                    },
                    {
                        "id": 45563,
                        "name": "Roiffieux",
                        "latitude": "45.22655000",
                        "longitude": "4.65441000"
                    },
                    {
                        "id": 45569,
                        "name": "Romagnat",
                        "latitude": "45.72955000",
                        "longitude": "3.10061000"
                    },
                    {
                        "id": 45570,
                        "name": "Romagnieu",
                        "latitude": "45.57061000",
                        "longitude": "5.64096000"
                    },
                    {
                        "id": 45574,
                        "name": "Romans-sur-Isère",
                        "latitude": "45.04960000",
                        "longitude": "5.06602000"
                    },
                    {
                        "id": 45602,
                        "name": "Rosières",
                        "latitude": "45.13287000",
                        "longitude": "3.98826000"
                    },
                    {
                        "id": 45639,
                        "name": "Roussillon",
                        "latitude": "45.37388000",
                        "longitude": "4.81496000"
                    },
                    {
                        "id": 45646,
                        "name": "Royat",
                        "latitude": "45.76497000",
                        "longitude": "3.05013000"
                    },
                    {
                        "id": 45647,
                        "name": "Roybon",
                        "latitude": "45.25851000",
                        "longitude": "5.24502000"
                    },
                    {
                        "id": 45653,
                        "name": "Rozier-en-Donzy",
                        "latitude": "45.80069000",
                        "longitude": "4.27736000"
                    },
                    {
                        "id": 45672,
                        "name": "Rumilly",
                        "latitude": "45.86116000",
                        "longitude": "5.94513000"
                    },
                    {
                        "id": 45676,
                        "name": "Ruoms",
                        "latitude": "44.45294000",
                        "longitude": "4.34202000"
                    },
                    {
                        "id": 45681,
                        "name": "Ruy",
                        "latitude": "45.58640000",
                        "longitude": "5.32143000"
                    },
                    {
                        "id": 45702,
                        "name": "Sablons",
                        "latitude": "45.32104000",
                        "longitude": "4.77449000"
                    },
                    {
                        "id": 45716,
                        "name": "Sail-sous-Couzan",
                        "latitude": "45.73482000",
                        "longitude": "3.96898000"
                    },
                    {
                        "id": 45721,
                        "name": "Sain-Bel",
                        "latitude": "45.81017000",
                        "longitude": "4.59797000"
                    },
                    {
                        "id": 45731,
                        "name": "Saint-Agrève",
                        "latitude": "45.01003000",
                        "longitude": "4.39612000"
                    },
                    {
                        "id": 45737,
                        "name": "Saint-Alban-de-Roche",
                        "latitude": "45.59490000",
                        "longitude": "5.22630000"
                    },
                    {
                        "id": 45736,
                        "name": "Saint-Alban-Leysse",
                        "latitude": "45.58333000",
                        "longitude": "5.95000000"
                    },
                    {
                        "id": 45748,
                        "name": "Saint-Amant-Tallende",
                        "latitude": "45.66900000",
                        "longitude": "3.10788000"
                    },
                    {
                        "id": 45769,
                        "name": "Saint-Andéol-le-Château",
                        "latitude": "45.58597000",
                        "longitude": "4.69504000"
                    },
                    {
                        "id": 45757,
                        "name": "Saint-André-de-Corcy",
                        "latitude": "45.92590000",
                        "longitude": "4.95166000"
                    },
                    {
                        "id": 45763,
                        "name": "Saint-André-le-Gaz",
                        "latitude": "45.54546000",
                        "longitude": "5.52886000"
                    },
                    {
                        "id": 45764,
                        "name": "Saint-André-le-Puy",
                        "latitude": "45.64763000",
                        "longitude": "4.25887000"
                    },
                    {
                        "id": 45768,
                        "name": "Saint-André-sur-Vieux-Jonc",
                        "latitude": "46.15855000",
                        "longitude": "5.14776000"
                    },
                    {
                        "id": 45773,
                        "name": "Saint-Antoine-l'Abbaye",
                        "latitude": "45.16667000",
                        "longitude": "5.21667000"
                    },
                    {
                        "id": 45796,
                        "name": "Saint-Aupre",
                        "latitude": "45.40296000",
                        "longitude": "5.66682000"
                    },
                    {
                        "id": 45801,
                        "name": "Saint-Baldoph",
                        "latitude": "45.53120000",
                        "longitude": "5.95217000"
                    },
                    {
                        "id": 45804,
                        "name": "Saint-Barthélemy-de-Vals",
                        "latitude": "45.16938000",
                        "longitude": "4.87160000"
                    },
                    {
                        "id": 45808,
                        "name": "Saint-Beauzire",
                        "latitude": "45.84964000",
                        "longitude": "3.17947000"
                    },
                    {
                        "id": 45835,
                        "name": "Saint-Béron",
                        "latitude": "45.50308000",
                        "longitude": "5.72790000"
                    },
                    {
                        "id": 45815,
                        "name": "Saint-Bon-Tarentaise",
                        "latitude": "45.43373000",
                        "longitude": "6.63686000"
                    },
                    {
                        "id": 45816,
                        "name": "Saint-Bonnet-de-Mure",
                        "latitude": "45.69042000",
                        "longitude": "5.02912000"
                    },
                    {
                        "id": 45818,
                        "name": "Saint-Bonnet-le-Château",
                        "latitude": "45.42402000",
                        "longitude": "4.06706000"
                    },
                    {
                        "id": 45819,
                        "name": "Saint-Bonnet-les-Oules",
                        "latitude": "45.54946000",
                        "longitude": "4.32522000"
                    },
                    {
                        "id": 45820,
                        "name": "Saint-Bonnet-près-Riom",
                        "latitude": "45.92972000",
                        "longitude": "3.11310000"
                    },
                    {
                        "id": 45841,
                        "name": "Saint-Cassien",
                        "latitude": "45.35710000",
                        "longitude": "5.54793000"
                    },
                    {
                        "id": 45843,
                        "name": "Saint-Cergues",
                        "latitude": "46.23005000",
                        "longitude": "6.31924000"
                    },
                    {
                        "id": 45844,
                        "name": "Saint-Cernin",
                        "latitude": "45.05850000",
                        "longitude": "2.42081000"
                    },
                    {
                        "id": 45847,
                        "name": "Saint-Chamond",
                        "latitude": "45.47590000",
                        "longitude": "4.51294000"
                    },
                    {
                        "id": 45850,
                        "name": "Saint-Chef",
                        "latitude": "45.63585000",
                        "longitude": "5.36465000"
                    },
                    {
                        "id": 45852,
                        "name": "Saint-Christo-en-Jarez",
                        "latitude": "45.54508000",
                        "longitude": "4.48826000"
                    },
                    {
                        "id": 45863,
                        "name": "Saint-Clair-de-la-Tour",
                        "latitude": "45.57345000",
                        "longitude": "5.47741000"
                    },
                    {
                        "id": 45864,
                        "name": "Saint-Clair-du-Rhône",
                        "latitude": "45.44186000",
                        "longitude": "4.77123000"
                    },
                    {
                        "id": 45879,
                        "name": "Saint-Cyprien",
                        "latitude": "45.53450000",
                        "longitude": "4.23428000"
                    },
                    {
                        "id": 45882,
                        "name": "Saint-Cyr",
                        "latitude": "45.25183000",
                        "longitude": "4.73045000"
                    },
                    {
                        "id": 45891,
                        "name": "Saint-Cyr-sur-le-Rhône",
                        "latitude": "45.51585000",
                        "longitude": "4.85250000"
                    },
                    {
                        "id": 45888,
                        "name": "Saint-Cyr-sur-Menthon",
                        "latitude": "46.27502000",
                        "longitude": "4.97246000"
                    },
                    {
                        "id": 45895,
                        "name": "Saint-Denis-de-Cabanne",
                        "latitude": "46.17249000",
                        "longitude": "4.21447000"
                    },
                    {
                        "id": 45899,
                        "name": "Saint-Denis-en-Bugey",
                        "latitude": "45.94963000",
                        "longitude": "5.32773000"
                    },
                    {
                        "id": 45903,
                        "name": "Saint-Denis-lès-Bourg",
                        "latitude": "46.20217000",
                        "longitude": "5.18924000"
                    },
                    {
                        "id": 45907,
                        "name": "Saint-Didier-de-Formans",
                        "latitude": "45.95969000",
                        "longitude": "4.78406000"
                    },
                    {
                        "id": 45908,
                        "name": "Saint-Didier-de-la-Tour",
                        "latitude": "45.55755000",
                        "longitude": "5.48026000"
                    },
                    {
                        "id": 45909,
                        "name": "Saint-Didier-en-Velay",
                        "latitude": "45.30265000",
                        "longitude": "4.27514000"
                    },
                    {
                        "id": 45910,
                        "name": "Saint-Didier-sous-Riverie",
                        "latitude": "45.59627000",
                        "longitude": "4.60650000"
                    },
                    {
                        "id": 45911,
                        "name": "Saint-Didier-sur-Chalaronne",
                        "latitude": "46.17714000",
                        "longitude": "4.81626000"
                    },
                    {
                        "id": 46635,
                        "name": "Saint-Égrève",
                        "latitude": "45.23313000",
                        "longitude": "5.68154000"
                    },
                    {
                        "id": 46638,
                        "name": "Saint-Éloy-les-Mines",
                        "latitude": "46.16051000",
                        "longitude": "2.83379000"
                    },
                    {
                        "id": 46641,
                        "name": "Saint-Étienne",
                        "latitude": "45.43389000",
                        "longitude": "4.39000000"
                    },
                    {
                        "id": 46645,
                        "name": "Saint-Étienne-de-Crossey",
                        "latitude": "45.38027000",
                        "longitude": "5.64365000"
                    },
                    {
                        "id": 45925,
                        "name": "Saint-Etienne-de-Cuines",
                        "latitude": "45.35000000",
                        "longitude": "6.28333000"
                    },
                    {
                        "id": 46646,
                        "name": "Saint-Étienne-de-Fontbellon",
                        "latitude": "44.60077000",
                        "longitude": "4.38635000"
                    },
                    {
                        "id": 46649,
                        "name": "Saint-Étienne-de-Saint-Geoirs",
                        "latitude": "45.33909000",
                        "longitude": "5.34650000"
                    },
                    {
                        "id": 46651,
                        "name": "Saint-Étienne-des-Oullières",
                        "latitude": "46.06731000",
                        "longitude": "4.64945000"
                    },
                    {
                        "id": 46653,
                        "name": "Saint-Étienne-du-Bois",
                        "latitude": "46.28990000",
                        "longitude": "5.29471000"
                    },
                    {
                        "id": 46658,
                        "name": "Saint-Étienne-sur-Chalaronne",
                        "latitude": "46.14778000",
                        "longitude": "4.87129000"
                    },
                    {
                        "id": 45945,
                        "name": "Saint-Félicien",
                        "latitude": "45.08600000",
                        "longitude": "4.62738000"
                    },
                    {
                        "id": 45947,
                        "name": "Saint-Félix",
                        "latitude": "45.80269000",
                        "longitude": "5.97714000"
                    },
                    {
                        "id": 45938,
                        "name": "Saint-Flour",
                        "latitude": "45.03374000",
                        "longitude": "3.09297000"
                    },
                    {
                        "id": 45940,
                        "name": "Saint-Fons",
                        "latitude": "45.70875000",
                        "longitude": "4.85325000"
                    },
                    {
                        "id": 45941,
                        "name": "Saint-Forgeux",
                        "latitude": "45.85895000",
                        "longitude": "4.47480000"
                    },
                    {
                        "id": 45943,
                        "name": "Saint-François",
                        "latitude": "46.41537000",
                        "longitude": "3.90542000"
                    },
                    {
                        "id": 45949,
                        "name": "Saint-Galmier",
                        "latitude": "45.59787000",
                        "longitude": "4.31086000"
                    },
                    {
                        "id": 45969,
                        "name": "Saint-Genès-Champanelle",
                        "latitude": "45.72037000",
                        "longitude": "3.01883000"
                    },
                    {
                        "id": 45955,
                        "name": "Saint-Genest-Lerpt",
                        "latitude": "45.44347000",
                        "longitude": "4.33968000"
                    },
                    {
                        "id": 45956,
                        "name": "Saint-Genest-Malifaux",
                        "latitude": "45.34064000",
                        "longitude": "4.41652000"
                    },
                    {
                        "id": 45959,
                        "name": "Saint-Genis-Laval",
                        "latitude": "45.69542000",
                        "longitude": "4.79316000"
                    },
                    {
                        "id": 45962,
                        "name": "Saint-Genis-les-Ollières",
                        "latitude": "45.75710000",
                        "longitude": "4.72625000"
                    },
                    {
                        "id": 45960,
                        "name": "Saint-Genis-Pouilly",
                        "latitude": "46.24356000",
                        "longitude": "6.02119000"
                    },
                    {
                        "id": 45963,
                        "name": "Saint-Genix-sur-Guiers",
                        "latitude": "45.59864000",
                        "longitude": "5.63559000"
                    },
                    {
                        "id": 45970,
                        "name": "Saint-Geoire-en-Valdaine",
                        "latitude": "45.45668000",
                        "longitude": "5.63515000"
                    },
                    {
                        "id": 45973,
                        "name": "Saint-Georges-de-Commiers",
                        "latitude": "45.04546000",
                        "longitude": "5.70628000"
                    },
                    {
                        "id": 45976,
                        "name": "Saint-Georges-de-Mons",
                        "latitude": "45.93941000",
                        "longitude": "2.83866000"
                    },
                    {
                        "id": 45980,
                        "name": "Saint-Georges-de-Reneins",
                        "latitude": "46.06185000",
                        "longitude": "4.72169000"
                    },
                    {
                        "id": 45972,
                        "name": "Saint-Georges-Haute-Ville",
                        "latitude": "45.55701000",
                        "longitude": "4.09801000"
                    },
                    {
                        "id": 45985,
                        "name": "Saint-Georges-les-Bains",
                        "latitude": "44.86100000",
                        "longitude": "4.80924000"
                    },
                    {
                        "id": 45987,
                        "name": "Saint-Georges-sur-Allier",
                        "latitude": "45.71015000",
                        "longitude": "3.24261000"
                    },
                    {
                        "id": 46045,
                        "name": "Saint-Gérand-le-Puy",
                        "latitude": "46.25790000",
                        "longitude": "3.51210000"
                    },
                    {
                        "id": 46006,
                        "name": "Saint-Germain-des-Fossés",
                        "latitude": "46.20682000",
                        "longitude": "3.43374000"
                    },
                    {
                        "id": 45995,
                        "name": "Saint-Germain-Laprade",
                        "latitude": "45.03862000",
                        "longitude": "3.97004000"
                    },
                    {
                        "id": 45997,
                        "name": "Saint-Germain-Laval",
                        "latitude": "45.83249000",
                        "longitude": "4.01444000"
                    },
                    {
                        "id": 45998,
                        "name": "Saint-Germain-Lembron",
                        "latitude": "45.45793000",
                        "longitude": "3.23973000"
                    },
                    {
                        "id": 45999,
                        "name": "Saint-Germain-Lespinasse",
                        "latitude": "46.10342000",
                        "longitude": "3.96503000"
                    },
                    {
                        "id": 46000,
                        "name": "Saint-Germain-Nuelles",
                        "latitude": "45.85242000",
                        "longitude": "4.61182000"
                    },
                    {
                        "id": 46026,
                        "name": "Saint-Gervais-d’Auvergne",
                        "latitude": "46.02916000",
                        "longitude": "2.81901000"
                    },
                    {
                        "id": 46029,
                        "name": "Saint-Gervais-les-Bains",
                        "latitude": "45.89126000",
                        "longitude": "6.71678000"
                    },
                    {
                        "id": 46072,
                        "name": "Saint-Héand",
                        "latitude": "45.52740000",
                        "longitude": "4.37077000"
                    },
                    {
                        "id": 46050,
                        "name": "Saint-Hilaire",
                        "latitude": "45.30000000",
                        "longitude": "5.88333000"
                    },
                    {
                        "id": 46061,
                        "name": "Saint-Hilaire-de-la-Côte",
                        "latitude": "45.39162000",
                        "longitude": "5.31590000"
                    },
                    {
                        "id": 46064,
                        "name": "Saint-Hilaire-du-Rosier",
                        "latitude": "45.09942000",
                        "longitude": "5.24946000"
                    },
                    {
                        "id": 46074,
                        "name": "Saint-Ismier",
                        "latitude": "45.25227000",
                        "longitude": "5.83073000"
                    },
                    {
                        "id": 46083,
                        "name": "Saint-Jean-Bonnefonds",
                        "latitude": "45.45609000",
                        "longitude": "4.44223000"
                    },
                    {
                        "id": 46112,
                        "name": "Saint-Jean-d’Aulps",
                        "latitude": "46.23438000",
                        "longitude": "6.65327000"
                    },
                    {
                        "id": 46088,
                        "name": "Saint-Jean-de-Bournay",
                        "latitude": "45.50093000",
                        "longitude": "5.13818000"
                    },
                    {
                        "id": 46091,
                        "name": "Saint-Jean-de-Gonville",
                        "latitude": "46.21298000",
                        "longitude": "5.95047000"
                    },
                    {
                        "id": 46095,
                        "name": "Saint-Jean-de-Maurienne",
                        "latitude": "45.27534000",
                        "longitude": "6.35293000"
                    },
                    {
                        "id": 46096,
                        "name": "Saint-Jean-de-Moirans",
                        "latitude": "45.34506000",
                        "longitude": "5.58536000"
                    },
                    {
                        "id": 46098,
                        "name": "Saint-Jean-de-Muzols",
                        "latitude": "45.08179000",
                        "longitude": "4.81396000"
                    },
                    {
                        "id": 46099,
                        "name": "Saint-Jean-de-Niost",
                        "latitude": "45.83333000",
                        "longitude": "5.21667000"
                    },
                    {
                        "id": 46101,
                        "name": "Saint-Jean-de-Sixt",
                        "latitude": "45.92312000",
                        "longitude": "6.41180000"
                    },
                    {
                        "id": 46102,
                        "name": "Saint-Jean-de-Soudain",
                        "latitude": "45.56770000",
                        "longitude": "5.42880000"
                    },
                    {
                        "id": 46114,
                        "name": "Saint-Jean-en-Royans",
                        "latitude": "45.01968000",
                        "longitude": "5.29223000"
                    },
                    {
                        "id": 46117,
                        "name": "Saint-Jean-le-Vieux",
                        "latitude": "46.03005000",
                        "longitude": "5.38798000"
                    },
                    {
                        "id": 46121,
                        "name": "Saint-Jean-sur-Veyle",
                        "latitude": "46.25902000",
                        "longitude": "4.91712000"
                    },
                    {
                        "id": 46123,
                        "name": "Saint-Jeoire",
                        "latitude": "46.13733000",
                        "longitude": "6.46172000"
                    },
                    {
                        "id": 46125,
                        "name": "Saint-Jorioz",
                        "latitude": "45.83074000",
                        "longitude": "6.15792000"
                    },
                    {
                        "id": 46127,
                        "name": "Saint-Joseph",
                        "latitude": "45.55757000",
                        "longitude": "4.62076000"
                    },
                    {
                        "id": 46129,
                        "name": "Saint-Joseph-de-Rivière",
                        "latitude": "45.37572000",
                        "longitude": "5.69643000"
                    },
                    {
                        "id": 46137,
                        "name": "Saint-Julien-Chapteuil",
                        "latitude": "45.03486000",
                        "longitude": "4.06110000"
                    },
                    {
                        "id": 46144,
                        "name": "Saint-Julien-en-Genevois",
                        "latitude": "46.14434000",
                        "longitude": "6.08256000"
                    },
                    {
                        "id": 46145,
                        "name": "Saint-Julien-en-Saint-Alban",
                        "latitude": "44.75417000",
                        "longitude": "4.69678000"
                    },
                    {
                        "id": 46138,
                        "name": "Saint-Julien-Molin-Molette",
                        "latitude": "45.32148000",
                        "longitude": "4.61692000"
                    },
                    {
                        "id": 46154,
                        "name": "Saint-Just-Chaleyssin",
                        "latitude": "45.59421000",
                        "longitude": "4.99852000"
                    },
                    {
                        "id": 46159,
                        "name": "Saint-Just-d'Ardèche",
                        "latitude": "44.30000000",
                        "longitude": "4.61667000"
                    },
                    {
                        "id": 46160,
                        "name": "Saint-Just-de-Claix",
                        "latitude": "45.07562000",
                        "longitude": "5.28309000"
                    },
                    {
                        "id": 46162,
                        "name": "Saint-Just-en-Chevalet",
                        "latitude": "45.91477000",
                        "longitude": "3.84234000"
                    },
                    {
                        "id": 46163,
                        "name": "Saint-Just-la-Pendue",
                        "latitude": "45.89423000",
                        "longitude": "4.24129000"
                    },
                    {
                        "id": 46156,
                        "name": "Saint-Just-Malmont",
                        "latitude": "45.33932000",
                        "longitude": "4.31275000"
                    },
                    {
                        "id": 46157,
                        "name": "Saint-Just-Saint-Rambert",
                        "latitude": "45.49973000",
                        "longitude": "4.24141000"
                    },
                    {
                        "id": 46171,
                        "name": "Saint-Lattier",
                        "latitude": "45.08815000",
                        "longitude": "5.20352000"
                    },
                    {
                        "id": 46176,
                        "name": "Saint-Laurent-de-Chamousset",
                        "latitude": "45.73827000",
                        "longitude": "4.46415000"
                    },
                    {
                        "id": 46177,
                        "name": "Saint-Laurent-de-Mure",
                        "latitude": "45.68563000",
                        "longitude": "5.04484000"
                    },
                    {
                        "id": 46183,
                        "name": "Saint-Laurent-du-Pape",
                        "latitude": "44.82328000",
                        "longitude": "4.76679000"
                    },
                    {
                        "id": 46184,
                        "name": "Saint-Laurent-du-Pont",
                        "latitude": "45.39240000",
                        "longitude": "5.73312000"
                    },
                    {
                        "id": 46187,
                        "name": "Saint-Laurent-en-Royans",
                        "latitude": "45.02653000",
                        "longitude": "5.32669000"
                    },
                    {
                        "id": 46189,
                        "name": "Saint-Laurent-sur-Saône",
                        "latitude": "46.30532000",
                        "longitude": "4.84119000"
                    },
                    {
                        "id": 46219,
                        "name": "Saint-Léger-sur-Roanne",
                        "latitude": "46.04174000",
                        "longitude": "3.99644000"
                    },
                    {
                        "id": 46233,
                        "name": "Saint-Mamet-la-Salvetat",
                        "latitude": "44.85813000",
                        "longitude": "2.30688000"
                    },
                    {
                        "id": 46245,
                        "name": "Saint-Marcel-d'Ardèche",
                        "latitude": "44.32726000",
                        "longitude": "4.61769000"
                    },
                    {
                        "id": 46246,
                        "name": "Saint-Marcel-lès-Annonay",
                        "latitude": "45.28613000",
                        "longitude": "4.62616000"
                    },
                    {
                        "id": 46247,
                        "name": "Saint-Marcel-lès-Sauzet",
                        "latitude": "44.59752000",
                        "longitude": "4.80541000"
                    },
                    {
                        "id": 46248,
                        "name": "Saint-Marcel-lès-Valence",
                        "latitude": "44.97132000",
                        "longitude": "4.95316000"
                    },
                    {
                        "id": 46250,
                        "name": "Saint-Marcellin",
                        "latitude": "45.14914000",
                        "longitude": "5.31673000"
                    },
                    {
                        "id": 46251,
                        "name": "Saint-Marcellin-en-Forez",
                        "latitude": "45.49676000",
                        "longitude": "4.17233000"
                    },
                    {
                        "id": 46260,
                        "name": "Saint-Martin-Bellevue",
                        "latitude": "45.96262000",
                        "longitude": "6.15763000"
                    },
                    {
                        "id": 46295,
                        "name": "Saint-Martin-d’Hères",
                        "latitude": "45.17870000",
                        "longitude": "5.76281000"
                    },
                    {
                        "id": 46268,
                        "name": "Saint-Martin-de-Belleville",
                        "latitude": "45.38175000",
                        "longitude": "6.50519000"
                    },
                    {
                        "id": 46279,
                        "name": "Saint-Martin-de-Valamas",
                        "latitude": "44.93718000",
                        "longitude": "4.36865000"
                    },
                    {
                        "id": 46287,
                        "name": "Saint-Martin-du-Frêne",
                        "latitude": "46.13591000",
                        "longitude": "5.55049000"
                    },
                    {
                        "id": 46289,
                        "name": "Saint-Martin-du-Mont",
                        "latitude": "46.09800000",
                        "longitude": "5.31706000"
                    },
                    {
                        "id": 46298,
                        "name": "Saint-Martin-en-Haut",
                        "latitude": "45.65984000",
                        "longitude": "4.56180000"
                    },
                    {
                        "id": 46299,
                        "name": "Saint-Martin-la-Plaine",
                        "latitude": "45.54635000",
                        "longitude": "4.59749000"
                    },
                    {
                        "id": 46301,
                        "name": "Saint-Martin-le-Vinoux",
                        "latitude": "45.20297000",
                        "longitude": "5.71630000"
                    },
                    {
                        "id": 46313,
                        "name": "Saint-Maurice-de-Beynost",
                        "latitude": "45.83440000",
                        "longitude": "4.97750000"
                    },
                    {
                        "id": 46314,
                        "name": "Saint-Maurice-de-Gourdans",
                        "latitude": "45.82248000",
                        "longitude": "5.19450000"
                    },
                    {
                        "id": 46315,
                        "name": "Saint-Maurice-de-Lignon",
                        "latitude": "45.22430000",
                        "longitude": "4.13880000"
                    },
                    {
                        "id": 46316,
                        "name": "Saint-Maurice-en-Gourgois",
                        "latitude": "45.40127000",
                        "longitude": "4.18253000"
                    },
                    {
                        "id": 46319,
                        "name": "Saint-Maurice-sur-Dargoire",
                        "latitude": "45.58224000",
                        "longitude": "4.63120000"
                    },
                    {
                        "id": 46337,
                        "name": "Saint-Michel-de-Maurienne",
                        "latitude": "45.22011000",
                        "longitude": "6.46868000"
                    },
                    {
                        "id": 46361,
                        "name": "Saint-Nazaire-les-Eymes",
                        "latitude": "45.24921000",
                        "longitude": "5.85254000"
                    },
                    {
                        "id": 46370,
                        "name": "Saint-Nizier-sous-Charlieu",
                        "latitude": "46.15290000",
                        "longitude": "4.12399000"
                    },
                    {
                        "id": 46384,
                        "name": "Saint-Ours",
                        "latitude": "45.85024000",
                        "longitude": "2.89163000"
                    },
                    {
                        "id": 46388,
                        "name": "Saint-Pal-de-Mons",
                        "latitude": "45.24634000",
                        "longitude": "4.27416000"
                    },
                    {
                        "id": 46402,
                        "name": "Saint-Paul",
                        "latitude": "45.39840000",
                        "longitude": "4.22617000"
                    },
                    {
                        "id": 46408,
                        "name": "Saint-Paul-de-Varax",
                        "latitude": "46.09692000",
                        "longitude": "5.12959000"
                    },
                    {
                        "id": 46409,
                        "name": "Saint-Paul-de-Varces",
                        "latitude": "45.07175000",
                        "longitude": "5.64247000"
                    },
                    {
                        "id": 46411,
                        "name": "Saint-Paul-des-Landes",
                        "latitude": "44.94356000",
                        "longitude": "2.31439000"
                    },
                    {
                        "id": 46412,
                        "name": "Saint-Paul-en-Chablais",
                        "latitude": "46.37958000",
                        "longitude": "6.62483000"
                    },
                    {
                        "id": 46414,
                        "name": "Saint-Paul-en-Jarez",
                        "latitude": "45.48512000",
                        "longitude": "4.57113000"
                    },
                    {
                        "id": 46417,
                        "name": "Saint-Paul-lès-Romans",
                        "latitude": "45.06725000",
                        "longitude": "5.13213000"
                    },
                    {
                        "id": 46405,
                        "name": "Saint-Paul-Trois-Châteaux",
                        "latitude": "44.34594000",
                        "longitude": "4.76356000"
                    },
                    {
                        "id": 46419,
                        "name": "Saint-Paulien",
                        "latitude": "45.13629000",
                        "longitude": "3.81290000"
                    },
                    {
                        "id": 46482,
                        "name": "Saint-Péray",
                        "latitude": "44.94866000",
                        "longitude": "4.84510000"
                    },
                    {
                        "id": 46431,
                        "name": "Saint-Pierre-de-Bœuf",
                        "latitude": "45.36667000",
                        "longitude": "4.75000000"
                    },
                    {
                        "id": 46432,
                        "name": "Saint-Pierre-de-Chandieu",
                        "latitude": "45.64625000",
                        "longitude": "5.01481000"
                    },
                    {
                        "id": 46448,
                        "name": "Saint-Pierre-la-Palud",
                        "latitude": "45.79092000",
                        "longitude": "4.61177000"
                    },
                    {
                        "id": 46462,
                        "name": "Saint-Pourçain-sur-Sioule",
                        "latitude": "46.30748000",
                        "longitude": "3.28931000"
                    },
                    {
                        "id": 46464,
                        "name": "Saint-Priest",
                        "latitude": "45.69651000",
                        "longitude": "4.94385000"
                    },
                    {
                        "id": 46466,
                        "name": "Saint-Priest-en-Jarez",
                        "latitude": "45.47390000",
                        "longitude": "4.37678000"
                    },
                    {
                        "id": 46468,
                        "name": "Saint-Privat",
                        "latitude": "44.62859000",
                        "longitude": "4.41489000"
                    },
                    {
                        "id": 46486,
                        "name": "Saint-Quentin-Fallavier",
                        "latitude": "45.64335000",
                        "longitude": "5.11266000"
                    },
                    {
                        "id": 46491,
                        "name": "Saint-Quentin-sur-Isère",
                        "latitude": "45.27843000",
                        "longitude": "5.54463000"
                    },
                    {
                        "id": 46493,
                        "name": "Saint-Rambert-en-Bugey",
                        "latitude": "45.94734000",
                        "longitude": "5.43630000"
                    },
                    {
                        "id": 46510,
                        "name": "Saint-Rémy-de-Maurienne",
                        "latitude": "45.40000000",
                        "longitude": "6.26667000"
                    },
                    {
                        "id": 46513,
                        "name": "Saint-Rémy-en-Rollat",
                        "latitude": "46.18330000",
                        "longitude": "3.39106000"
                    },
                    {
                        "id": 46516,
                        "name": "Saint-Rémy-sur-Durolle",
                        "latitude": "45.88815000",
                        "longitude": "3.59257000"
                    },
                    {
                        "id": 46496,
                        "name": "Saint-Restitut",
                        "latitude": "44.32446000",
                        "longitude": "4.79282000"
                    },
                    {
                        "id": 46501,
                        "name": "Saint-Romain-de-Jalionas",
                        "latitude": "45.75677000",
                        "longitude": "5.21741000"
                    },
                    {
                        "id": 46502,
                        "name": "Saint-Romain-de-Popey",
                        "latitude": "45.84725000",
                        "longitude": "4.53118000"
                    },
                    {
                        "id": 46503,
                        "name": "Saint-Romain-en-Gal",
                        "latitude": "45.53255000",
                        "longitude": "4.86190000"
                    },
                    {
                        "id": 46504,
                        "name": "Saint-Romain-la-Motte",
                        "latitude": "46.08150000",
                        "longitude": "3.99076000"
                    },
                    {
                        "id": 46505,
                        "name": "Saint-Romain-le-Puy",
                        "latitude": "45.55837000",
                        "longitude": "4.12296000"
                    },
                    {
                        "id": 46507,
                        "name": "Saint-Romans",
                        "latitude": "45.11278000",
                        "longitude": "5.32239000"
                    },
                    {
                        "id": 46521,
                        "name": "Saint-Saturnin",
                        "latitude": "45.65956000",
                        "longitude": "3.09232000"
                    },
                    {
                        "id": 46527,
                        "name": "Saint-Sauves-d'Auvergne",
                        "latitude": "45.60000000",
                        "longitude": "2.68333000"
                    },
                    {
                        "id": 46529,
                        "name": "Saint-Sauveur",
                        "latitude": "45.15335000",
                        "longitude": "5.35280000"
                    },
                    {
                        "id": 46534,
                        "name": "Saint-Sauveur-de-Montagut",
                        "latitude": "44.82142000",
                        "longitude": "4.57993000"
                    },
                    {
                        "id": 46537,
                        "name": "Saint-Sauveur-en-Rue",
                        "latitude": "45.26981000",
                        "longitude": "4.49512000"
                    },
                    {
                        "id": 46540,
                        "name": "Saint-Savin",
                        "latitude": "45.62776000",
                        "longitude": "5.30856000"
                    },
                    {
                        "id": 46548,
                        "name": "Saint-Sernin",
                        "latitude": "44.57147000",
                        "longitude": "4.39186000"
                    },
                    {
                        "id": 46554,
                        "name": "Saint-Siméon-de-Bressieux",
                        "latitude": "45.33850000",
                        "longitude": "5.26591000"
                    },
                    {
                        "id": 46553,
                        "name": "Saint-Simon",
                        "latitude": "44.96320000",
                        "longitude": "2.48994000"
                    },
                    {
                        "id": 46555,
                        "name": "Saint-Sorlin-en-Bugey",
                        "latitude": "45.88576000",
                        "longitude": "5.36688000"
                    },
                    {
                        "id": 46556,
                        "name": "Saint-Sorlin-en-Valloire",
                        "latitude": "45.28774000",
                        "longitude": "4.94903000"
                    },
                    {
                        "id": 46575,
                        "name": "Saint-Symphorien-de-Lay",
                        "latitude": "45.94772000",
                        "longitude": "4.21318000"
                    },
                    {
                        "id": 46576,
                        "name": "Saint-Symphorien-sur-Coise",
                        "latitude": "45.63220000",
                        "longitude": "4.45709000"
                    },
                    {
                        "id": 46585,
                        "name": "Saint-Trivier-de-Courtes",
                        "latitude": "46.45980000",
                        "longitude": "5.07762000"
                    },
                    {
                        "id": 46586,
                        "name": "Saint-Trivier-sur-Moignans",
                        "latitude": "46.07233000",
                        "longitude": "4.89721000"
                    },
                    {
                        "id": 46594,
                        "name": "Saint-Uze",
                        "latitude": "45.18409000",
                        "longitude": "4.86000000"
                    },
                    {
                        "id": 46599,
                        "name": "Saint-Vallier",
                        "latitude": "45.17154000",
                        "longitude": "4.81758000"
                    },
                    {
                        "id": 46624,
                        "name": "Saint-Vérand",
                        "latitude": "45.17344000",
                        "longitude": "5.33261000"
                    },
                    {
                        "id": 46607,
                        "name": "Saint-Victor",
                        "latitude": "46.39506000",
                        "longitude": "2.60819000"
                    },
                    {
                        "id": 46608,
                        "name": "Saint-Victor-de-Cessieu",
                        "latitude": "45.54113000",
                        "longitude": "5.39098000"
                    },
                    {
                        "id": 46613,
                        "name": "Saint-Vincent-de-Mercuze",
                        "latitude": "45.37215000",
                        "longitude": "5.95424000"
                    },
                    {
                        "id": 46629,
                        "name": "Saint-Yorre",
                        "latitude": "46.06598000",
                        "longitude": "3.46430000"
                    },
                    {
                        "id": 46669,
                        "name": "Sainte-Colombe",
                        "latitude": "45.52531000",
                        "longitude": "4.86664000"
                    },
                    {
                        "id": 46671,
                        "name": "Sainte-Consorce",
                        "latitude": "45.77585000",
                        "longitude": "4.69033000"
                    },
                    {
                        "id": 46677,
                        "name": "Sainte-Euphémie",
                        "latitude": "45.97101000",
                        "longitude": "4.79853000"
                    },
                    {
                        "id": 46680,
                        "name": "Sainte-Florine",
                        "latitude": "45.40519000",
                        "longitude": "3.31732000"
                    },
                    {
                        "id": 46686,
                        "name": "Sainte-Foy-l’Argentière",
                        "latitude": "45.70823000",
                        "longitude": "4.47025000"
                    },
                    {
                        "id": 46685,
                        "name": "Sainte-Foy-lès-Lyon",
                        "latitude": "45.73375000",
                        "longitude": "4.80259000"
                    },
                    {
                        "id": 46699,
                        "name": "Sainte-Hélène-sur-Isère",
                        "latitude": "45.61434000",
                        "longitude": "6.32052000"
                    },
                    {
                        "id": 46726,
                        "name": "Sainte-Sigolène",
                        "latitude": "45.24329000",
                        "longitude": "4.23343000"
                    },
                    {
                        "id": 46740,
                        "name": "Salagnon",
                        "latitude": "45.66863000",
                        "longitude": "5.36325000"
                    },
                    {
                        "id": 46741,
                        "name": "Salaise-sur-Sanne",
                        "latitude": "45.35126000",
                        "longitude": "4.81070000"
                    },
                    {
                        "id": 46746,
                        "name": "Sales",
                        "latitude": "45.87441000",
                        "longitude": "5.95996000"
                    },
                    {
                        "id": 46756,
                        "name": "Salins-les-Thermes",
                        "latitude": "45.47169000",
                        "longitude": "6.53051000"
                    },
                    {
                        "id": 46757,
                        "name": "Sallanches",
                        "latitude": "45.94423000",
                        "longitude": "6.63162000"
                    },
                    {
                        "id": 46776,
                        "name": "Samoëns",
                        "latitude": "46.08282000",
                        "longitude": "6.72647000"
                    },
                    {
                        "id": 46791,
                        "name": "Sansac-de-Marmiesse",
                        "latitude": "44.88376000",
                        "longitude": "2.34768000"
                    },
                    {
                        "id": 46810,
                        "name": "Sarras",
                        "latitude": "45.18679000",
                        "longitude": "4.80004000"
                    },
                    {
                        "id": 46825,
                        "name": "Sassenage",
                        "latitude": "45.21266000",
                        "longitude": "5.66290000"
                    },
                    {
                        "id": 46827,
                        "name": "Sathonay-Camp",
                        "latitude": "45.82462000",
                        "longitude": "4.87453000"
                    },
                    {
                        "id": 46828,
                        "name": "Sathonay-Village",
                        "latitude": "45.83337000",
                        "longitude": "4.87821000"
                    },
                    {
                        "id": 46829,
                        "name": "Satillieu",
                        "latitude": "45.15041000",
                        "longitude": "4.61410000"
                    },
                    {
                        "id": 46830,
                        "name": "Satolas-et-Bonce",
                        "latitude": "45.69368000",
                        "longitude": "5.13032000"
                    },
                    {
                        "id": 46836,
                        "name": "Saugues",
                        "latitude": "44.96008000",
                        "longitude": "3.54737000"
                    },
                    {
                        "id": 46838,
                        "name": "Saulce-sur-Rhône",
                        "latitude": "44.70430000",
                        "longitude": "4.80061000"
                    },
                    {
                        "id": 46845,
                        "name": "Sault-Brénaz",
                        "latitude": "45.86132000",
                        "longitude": "5.39954000"
                    },
                    {
                        "id": 46860,
                        "name": "Sauverny",
                        "latitude": "46.31514000",
                        "longitude": "6.11827000"
                    },
                    {
                        "id": 46867,
                        "name": "Sauxillanges",
                        "latitude": "45.55109000",
                        "longitude": "3.37147000"
                    },
                    {
                        "id": 46868,
                        "name": "Sauzet",
                        "latitude": "44.60397000",
                        "longitude": "4.82091000"
                    },
                    {
                        "id": 46870,
                        "name": "Savasse",
                        "latitude": "44.60428000",
                        "longitude": "4.77653000"
                    },
                    {
                        "id": 46875,
                        "name": "Savigneux",
                        "latitude": "45.61670000",
                        "longitude": "4.08330000"
                    },
                    {
                        "id": 46876,
                        "name": "Savigny",
                        "latitude": "45.81595000",
                        "longitude": "4.57410000"
                    },
                    {
                        "id": 46886,
                        "name": "Savoie",
                        "latitude": "45.46805000",
                        "longitude": "6.48547000"
                    },
                    {
                        "id": 46889,
                        "name": "Sayat",
                        "latitude": "45.82640000",
                        "longitude": "3.05250000"
                    },
                    {
                        "id": 46905,
                        "name": "Sciez",
                        "latitude": "46.33251000",
                        "longitude": "6.38413000"
                    },
                    {
                        "id": 46906,
                        "name": "Scionzier",
                        "latitude": "46.06010000",
                        "longitude": "6.55271000"
                    },
                    {
                        "id": 47134,
                        "name": "Séez",
                        "latitude": "45.62368000",
                        "longitude": "6.80149000"
                    },
                    {
                        "id": 47135,
                        "name": "Ségny",
                        "latitude": "46.29571000",
                        "longitude": "6.07257000"
                    },
                    {
                        "id": 46950,
                        "name": "Septème",
                        "latitude": "45.55294000",
                        "longitude": "5.00596000"
                    },
                    {
                        "id": 47147,
                        "name": "Sérézin-du-Rhône",
                        "latitude": "45.62871000",
                        "longitude": "4.82400000"
                    },
                    {
                        "id": 46955,
                        "name": "Sergy",
                        "latitude": "46.25069000",
                        "longitude": "6.00183000"
                    },
                    {
                        "id": 46959,
                        "name": "Sermérieu",
                        "latitude": "45.66995000",
                        "longitude": "5.41110000"
                    },
                    {
                        "id": 46961,
                        "name": "Serpaize",
                        "latitude": "45.55824000",
                        "longitude": "4.91764000"
                    },
                    {
                        "id": 46969,
                        "name": "Serrières",
                        "latitude": "45.31799000",
                        "longitude": "4.76327000"
                    },
                    {
                        "id": 46970,
                        "name": "Serrières-de-Briord",
                        "latitude": "45.80706000",
                        "longitude": "5.44795000"
                    },
                    {
                        "id": 46971,
                        "name": "Servas",
                        "latitude": "46.13317000",
                        "longitude": "5.16510000"
                    },
                    {
                        "id": 46981,
                        "name": "Sevrier",
                        "latitude": "45.86442000",
                        "longitude": "6.13990000"
                    },
                    {
                        "id": 46983,
                        "name": "Seynod",
                        "latitude": "45.88549000",
                        "longitude": "6.08831000"
                    },
                    {
                        "id": 46985,
                        "name": "Seyssinet-Pariset",
                        "latitude": "45.17675000",
                        "longitude": "5.69387000"
                    },
                    {
                        "id": 46986,
                        "name": "Seyssins",
                        "latitude": "45.16224000",
                        "longitude": "5.68673000"
                    },
                    {
                        "id": 46987,
                        "name": "Seyssuel",
                        "latitude": "45.55826000",
                        "longitude": "4.84313000"
                    },
                    {
                        "id": 46995,
                        "name": "Sillans",
                        "latitude": "45.34261000",
                        "longitude": "5.38864000"
                    },
                    {
                        "id": 46997,
                        "name": "Sillingy",
                        "latitude": "45.94781000",
                        "longitude": "6.04415000"
                    },
                    {
                        "id": 47001,
                        "name": "Simandres",
                        "latitude": "45.61955000",
                        "longitude": "4.87314000"
                    },
                    {
                        "id": 47022,
                        "name": "Solaize",
                        "latitude": "45.63970000",
                        "longitude": "4.84038000"
                    },
                    {
                        "id": 47029,
                        "name": "Solignac-sur-Loire",
                        "latitude": "44.96833000",
                        "longitude": "3.88635000"
                    },
                    {
                        "id": 47039,
                        "name": "Sonnay",
                        "latitude": "45.35809000",
                        "longitude": "4.90479000"
                    },
                    {
                        "id": 47040,
                        "name": "Sonnaz",
                        "latitude": "45.61765000",
                        "longitude": "5.91505000"
                    },
                    {
                        "id": 47043,
                        "name": "Sorbiers",
                        "latitude": "45.49111000",
                        "longitude": "4.44163000"
                    },
                    {
                        "id": 47060,
                        "name": "Soucieu-en-Jarrest",
                        "latitude": "45.67771000",
                        "longitude": "4.70379000"
                    },
                    {
                        "id": 47082,
                        "name": "Sourcieux-les-Mines",
                        "latitude": "45.80606000",
                        "longitude": "4.62254000"
                    },
                    {
                        "id": 47089,
                        "name": "Souvigny",
                        "latitude": "46.53480000",
                        "longitude": "3.19205000"
                    },
                    {
                        "id": 47091,
                        "name": "Soyons",
                        "latitude": "44.88914000",
                        "longitude": "4.85026000"
                    },
                    {
                        "id": 47124,
                        "name": "Sury-le-Comtal",
                        "latitude": "45.53735000",
                        "longitude": "4.18573000"
                    },
                    {
                        "id": 47127,
                        "name": "Suze-la-Rousse",
                        "latitude": "44.28761000",
                        "longitude": "4.84161000"
                    },
                    {
                        "id": 47157,
                        "name": "Tain-l’Hermitage",
                        "latitude": "45.06672000",
                        "longitude": "4.85590000"
                    },
                    {
                        "id": 47165,
                        "name": "Tallende",
                        "latitude": "45.67040000",
                        "longitude": "3.12460000"
                    },
                    {
                        "id": 47166,
                        "name": "Talloires",
                        "latitude": "45.84098000",
                        "longitude": "6.21374000"
                    },
                    {
                        "id": 47168,
                        "name": "Taluyers",
                        "latitude": "45.63973000",
                        "longitude": "4.72203000"
                    },
                    {
                        "id": 47170,
                        "name": "Taninges",
                        "latitude": "46.10883000",
                        "longitude": "6.59231000"
                    },
                    {
                        "id": 47175,
                        "name": "Tarare",
                        "latitude": "45.89614000",
                        "longitude": "4.43300000"
                    },
                    {
                        "id": 47183,
                        "name": "Tassin-la-Demi-Lune",
                        "latitude": "45.75499000",
                        "longitude": "4.78812000"
                    },
                    {
                        "id": 47185,
                        "name": "Taulignan",
                        "latitude": "44.44419000",
                        "longitude": "4.97057000"
                    },
                    {
                        "id": 47199,
                        "name": "Tenay",
                        "latitude": "45.91884000",
                        "longitude": "5.50797000"
                    },
                    {
                        "id": 47200,
                        "name": "Tence",
                        "latitude": "45.11423000",
                        "longitude": "4.29097000"
                    },
                    {
                        "id": 47201,
                        "name": "Tencin",
                        "latitude": "45.31105000",
                        "longitude": "5.95752000"
                    },
                    {
                        "id": 47208,
                        "name": "Ternay",
                        "latitude": "45.60234000",
                        "longitude": "4.81064000"
                    },
                    {
                        "id": 47222,
                        "name": "Theizé",
                        "latitude": "45.93963000",
                        "longitude": "4.61634000"
                    },
                    {
                        "id": 47224,
                        "name": "Theys",
                        "latitude": "45.30132000",
                        "longitude": "5.99848000"
                    },
                    {
                        "id": 47228,
                        "name": "Thiers",
                        "latitude": "45.85654000",
                        "longitude": "3.54758000"
                    },
                    {
                        "id": 47233,
                        "name": "Thil",
                        "latitude": "45.81368000",
                        "longitude": "5.02323000"
                    },
                    {
                        "id": 47242,
                        "name": "Thizy-les-Bourgs",
                        "latitude": "46.02995000",
                        "longitude": "4.31299000"
                    },
                    {
                        "id": 47243,
                        "name": "Thoiry",
                        "latitude": "46.23762000",
                        "longitude": "5.98111000"
                    },
                    {
                        "id": 47245,
                        "name": "Thoissey",
                        "latitude": "46.17222000",
                        "longitude": "4.80251000"
                    },
                    {
                        "id": 47275,
                        "name": "Thônes",
                        "latitude": "45.88123000",
                        "longitude": "6.32572000"
                    },
                    {
                        "id": 47247,
                        "name": "Thonon-les-Bains",
                        "latitude": "46.37049000",
                        "longitude": "6.47985000"
                    },
                    {
                        "id": 47248,
                        "name": "Thorens-Glières",
                        "latitude": "45.99510000",
                        "longitude": "6.24557000"
                    },
                    {
                        "id": 47257,
                        "name": "Thuellin",
                        "latitude": "45.63964000",
                        "longitude": "5.50840000"
                    },
                    {
                        "id": 47258,
                        "name": "Thueyts",
                        "latitude": "44.67628000",
                        "longitude": "4.22146000"
                    },
                    {
                        "id": 47262,
                        "name": "Thurins",
                        "latitude": "45.68179000",
                        "longitude": "4.64079000"
                    },
                    {
                        "id": 47265,
                        "name": "Thyez",
                        "latitude": "46.08249000",
                        "longitude": "6.53777000"
                    },
                    {
                        "id": 47279,
                        "name": "Tignes",
                        "latitude": "45.49604000",
                        "longitude": "6.92463000"
                    },
                    {
                        "id": 47280,
                        "name": "Tignieu",
                        "latitude": "45.75164000",
                        "longitude": "5.18911000"
                    },
                    {
                        "id": 47306,
                        "name": "Tossiat",
                        "latitude": "46.13965000",
                        "longitude": "5.31158000"
                    },
                    {
                        "id": 47310,
                        "name": "Toulaud",
                        "latitude": "44.89773000",
                        "longitude": "4.81639000"
                    },
                    {
                        "id": 47313,
                        "name": "Toulon-sur-Allier",
                        "latitude": "46.51845000",
                        "longitude": "3.35989000"
                    },
                    {
                        "id": 47328,
                        "name": "Tournon-sur-Rhône",
                        "latitude": "45.06667000",
                        "longitude": "4.83333000"
                    },
                    {
                        "id": 47340,
                        "name": "Toussieu",
                        "latitude": "45.65443000",
                        "longitude": "4.98495000"
                    },
                    {
                        "id": 47346,
                        "name": "Tramoyes",
                        "latitude": "45.87599000",
                        "longitude": "4.96502000"
                    },
                    {
                        "id": 47353,
                        "name": "Treffort-Cuisiat",
                        "latitude": "46.26667000",
                        "longitude": "5.36667000"
                    },
                    {
                        "id": 47359,
                        "name": "Trept",
                        "latitude": "45.68742000",
                        "longitude": "5.31843000"
                    },
                    {
                        "id": 47363,
                        "name": "Tresserve",
                        "latitude": "45.67610000",
                        "longitude": "5.89906000"
                    },
                    {
                        "id": 47406,
                        "name": "Trévol",
                        "latitude": "46.62924000",
                        "longitude": "3.30599000"
                    },
                    {
                        "id": 47408,
                        "name": "Trévoux",
                        "latitude": "45.94281000",
                        "longitude": "4.77143000"
                    },
                    {
                        "id": 47412,
                        "name": "Tulette",
                        "latitude": "44.28656000",
                        "longitude": "4.93122000"
                    },
                    {
                        "id": 47414,
                        "name": "Tullins",
                        "latitude": "45.30239000",
                        "longitude": "5.49077000"
                    },
                    {
                        "id": 47424,
                        "name": "Ugine",
                        "latitude": "45.75571000",
                        "longitude": "6.41503000"
                    },
                    {
                        "id": 47427,
                        "name": "Unieux",
                        "latitude": "45.40395000",
                        "longitude": "4.27094000"
                    },
                    {
                        "id": 47429,
                        "name": "Upie",
                        "latitude": "44.80250000",
                        "longitude": "4.97673000"
                    },
                    {
                        "id": 47441,
                        "name": "Usson-en-Forez",
                        "latitude": "45.39174000",
                        "longitude": "3.94142000"
                    },
                    {
                        "id": 47461,
                        "name": "Val Thorens",
                        "latitude": "45.29777000",
                        "longitude": "6.58377000"
                    },
                    {
                        "id": 47465,
                        "name": "Val-d’Isère",
                        "latitude": "45.45142000",
                        "longitude": "6.97455000"
                    },
                    {
                        "id": 47471,
                        "name": "Valence",
                        "latitude": "44.92560000",
                        "longitude": "4.90956000"
                    },
                    {
                        "id": 47475,
                        "name": "Valencin",
                        "latitude": "45.61109000",
                        "longitude": "5.02935000"
                    },
                    {
                        "id": 47486,
                        "name": "Valleiry",
                        "latitude": "46.11106000",
                        "longitude": "5.97037000"
                    },
                    {
                        "id": 47491,
                        "name": "Vallières",
                        "latitude": "45.90043000",
                        "longitude": "5.93863000"
                    },
                    {
                        "id": 47492,
                        "name": "Valloire",
                        "latitude": "45.16542000",
                        "longitude": "6.42998000"
                    },
                    {
                        "id": 47494,
                        "name": "Vallon-en-Sully",
                        "latitude": "46.53629000",
                        "longitude": "2.60804000"
                    },
                    {
                        "id": 47493,
                        "name": "Vallon-Pont-d’Arc",
                        "latitude": "44.40685000",
                        "longitude": "4.39374000"
                    },
                    {
                        "id": 47501,
                        "name": "Vals-les-Bains",
                        "latitude": "44.66561000",
                        "longitude": "4.36615000"
                    },
                    {
                        "id": 47502,
                        "name": "Vals-près-le-Puy",
                        "latitude": "45.03155000",
                        "longitude": "3.87787000"
                    },
                    {
                        "id": 47514,
                        "name": "Varennes-sur-Allier",
                        "latitude": "46.31318000",
                        "longitude": "3.40147000"
                    },
                    {
                        "id": 47533,
                        "name": "Vaugneray",
                        "latitude": "45.73791000",
                        "longitude": "4.65645000"
                    },
                    {
                        "id": 47537,
                        "name": "Vaulnaveys-le-Bas",
                        "latitude": "45.10020000",
                        "longitude": "5.82532000"
                    },
                    {
                        "id": 47538,
                        "name": "Vaulnaveys-le-Haut",
                        "latitude": "45.12524000",
                        "longitude": "5.81723000"
                    },
                    {
                        "id": 47541,
                        "name": "Vaulx-en-Velin",
                        "latitude": "45.78693000",
                        "longitude": "4.92510000"
                    },
                    {
                        "id": 47539,
                        "name": "Vaulx-Milieu",
                        "latitude": "45.61329000",
                        "longitude": "5.18371000"
                    },
                    {
                        "id": 47545,
                        "name": "Vaux-en-Bugey",
                        "latitude": "45.92671000",
                        "longitude": "5.35141000"
                    },
                    {
                        "id": 47552,
                        "name": "Veauche",
                        "latitude": "45.56326000",
                        "longitude": "4.29192000"
                    },
                    {
                        "id": 47556,
                        "name": "Veigy",
                        "latitude": "46.26787000",
                        "longitude": "6.26304000"
                    },
                    {
                        "id": 47567,
                        "name": "Vendat",
                        "latitude": "46.16387000",
                        "longitude": "3.35366000"
                    },
                    {
                        "id": 47926,
                        "name": "Vénissieux",
                        "latitude": "45.69706000",
                        "longitude": "4.88593000"
                    },
                    {
                        "id": 47599,
                        "name": "Vergongheon",
                        "latitude": "45.37107000",
                        "longitude": "3.31981000"
                    },
                    {
                        "id": 47608,
                        "name": "Vernaison",
                        "latitude": "45.64781000",
                        "longitude": "4.81140000"
                    },
                    {
                        "id": 47617,
                        "name": "Vernioz",
                        "latitude": "45.42672000",
                        "longitude": "4.88267000"
                    },
                    {
                        "id": 47620,
                        "name": "Vernosc-lès-Annonay",
                        "latitude": "45.21596000",
                        "longitude": "4.71310000"
                    },
                    {
                        "id": 47625,
                        "name": "Vernoux-en-Vivarais",
                        "latitude": "44.89577000",
                        "longitude": "4.64524000"
                    },
                    {
                        "id": 47634,
                        "name": "Versonnex",
                        "latitude": "45.92914000",
                        "longitude": "5.92586000"
                    },
                    {
                        "id": 47639,
                        "name": "Vertaizon",
                        "latitude": "45.76983000",
                        "longitude": "3.28650000"
                    },
                    {
                        "id": 47649,
                        "name": "Vesseaux",
                        "latitude": "44.65152000",
                        "longitude": "4.44025000"
                    },
                    {
                        "id": 47931,
                        "name": "Vétraz-Monthoux",
                        "latitude": "46.17430000",
                        "longitude": "6.25852000"
                    },
                    {
                        "id": 47651,
                        "name": "Veurey-Voroize",
                        "latitude": "45.27268000",
                        "longitude": "5.61372000"
                    },
                    {
                        "id": 47654,
                        "name": "Veyras",
                        "latitude": "44.73518000",
                        "longitude": "4.56254000"
                    },
                    {
                        "id": 47655,
                        "name": "Veyre-Monton",
                        "latitude": "45.66866000",
                        "longitude": "3.17144000"
                    },
                    {
                        "id": 47656,
                        "name": "Veyrier-du-Lac",
                        "latitude": "45.88234000",
                        "longitude": "6.17709000"
                    },
                    {
                        "id": 47666,
                        "name": "Vic-le-Comte",
                        "latitude": "45.64296000",
                        "longitude": "3.24607000"
                    },
                    {
                        "id": 47668,
                        "name": "Vic-sur-Cère",
                        "latitude": "44.98011000",
                        "longitude": "2.62505000"
                    },
                    {
                        "id": 47670,
                        "name": "Vichy",
                        "latitude": "46.12709000",
                        "longitude": "3.42577000"
                    },
                    {
                        "id": 47675,
                        "name": "Vieille-Brioude",
                        "latitude": "45.26470000",
                        "longitude": "3.40479000"
                    },
                    {
                        "id": 47682,
                        "name": "Vienne",
                        "latitude": "45.52569000",
                        "longitude": "4.87484000"
                    },
                    {
                        "id": 47692,
                        "name": "Vif",
                        "latitude": "45.05654000",
                        "longitude": "5.67204000"
                    },
                    {
                        "id": 47710,
                        "name": "Villard-Bonnot",
                        "latitude": "45.23460000",
                        "longitude": "5.88323000"
                    },
                    {
                        "id": 47711,
                        "name": "Villard-de-Lans",
                        "latitude": "45.07156000",
                        "longitude": "5.55637000"
                    },
                    {
                        "id": 47712,
                        "name": "Villargondran",
                        "latitude": "45.26427000",
                        "longitude": "6.37668000"
                    },
                    {
                        "id": 47713,
                        "name": "Villars",
                        "latitude": "45.46785000",
                        "longitude": "4.35539000"
                    },
                    {
                        "id": 47714,
                        "name": "Villars-les-Dombes",
                        "latitude": "46.00208000",
                        "longitude": "5.03248000"
                    },
                    {
                        "id": 47716,
                        "name": "Villaz",
                        "latitude": "45.95127000",
                        "longitude": "6.19447000"
                    },
                    {
                        "id": 47718,
                        "name": "Ville-la-Grand",
                        "latitude": "46.20300000",
                        "longitude": "6.25010000"
                    },
                    {
                        "id": 47719,
                        "name": "Ville-sous-Anjou",
                        "latitude": "45.37274000",
                        "longitude": "4.85081000"
                    },
                    {
                        "id": 47724,
                        "name": "Villebois",
                        "latitude": "45.84822000",
                        "longitude": "5.43310000"
                    },
                    {
                        "id": 47726,
                        "name": "Villebret",
                        "latitude": "46.26683000",
                        "longitude": "2.63862000"
                    },
                    {
                        "id": 47734,
                        "name": "Villefontaine",
                        "latitude": "45.61278000",
                        "longitude": "5.15058000"
                    },
                    {
                        "id": 47738,
                        "name": "Villefranche-d’Allier",
                        "latitude": "46.39652000",
                        "longitude": "2.85717000"
                    },
                    {
                        "id": 47741,
                        "name": "Villefranche-sur-Saône",
                        "latitude": "45.98967000",
                        "longitude": "4.71961000"
                    },
                    {
                        "id": 47751,
                        "name": "Villemoirieu",
                        "latitude": "45.71884000",
                        "longitude": "5.22586000"
                    },
                    {
                        "id": 47759,
                        "name": "Villeneuve",
                        "latitude": "46.02096000",
                        "longitude": "4.83591000"
                    },
                    {
                        "id": 47767,
                        "name": "Villeneuve-de-Berg",
                        "latitude": "44.55699000",
                        "longitude": "4.50215000"
                    },
                    {
                        "id": 47793,
                        "name": "Villerest",
                        "latitude": "45.99539000",
                        "longitude": "4.03463000"
                    },
                    {
                        "id": 47794,
                        "name": "Villereversure",
                        "latitude": "46.18521000",
                        "longitude": "5.38262000"
                    },
                    {
                        "id": 47817,
                        "name": "Villette-de-Vienne",
                        "latitude": "45.59049000",
                        "longitude": "4.91528000"
                    },
                    {
                        "id": 47818,
                        "name": "Villeurbanne",
                        "latitude": "45.76601000",
                        "longitude": "4.87950000"
                    },
                    {
                        "id": 47822,
                        "name": "Villevocance",
                        "latitude": "45.22481000",
                        "longitude": "4.58827000"
                    },
                    {
                        "id": 47836,
                        "name": "Villié-Morgon",
                        "latitude": "46.16227000",
                        "longitude": "4.68069000"
                    },
                    {
                        "id": 47838,
                        "name": "Vimines",
                        "latitude": "45.54640000",
                        "longitude": "5.86523000"
                    },
                    {
                        "id": 47843,
                        "name": "Vinay",
                        "latitude": "45.20832000",
                        "longitude": "5.40646000"
                    },
                    {
                        "id": 47850,
                        "name": "Vinsobres",
                        "latitude": "44.33328000",
                        "longitude": "5.06204000"
                    },
                    {
                        "id": 47853,
                        "name": "Violay",
                        "latitude": "45.85335000",
                        "longitude": "4.35951000"
                    },
                    {
                        "id": 47861,
                        "name": "Viriat",
                        "latitude": "46.25484000",
                        "longitude": "5.21567000"
                    },
                    {
                        "id": 47862,
                        "name": "Virieu",
                        "latitude": "45.48404000",
                        "longitude": "5.47586000"
                    },
                    {
                        "id": 47863,
                        "name": "Virieu-le-Grand",
                        "latitude": "45.84766000",
                        "longitude": "5.65146000"
                    },
                    {
                        "id": 47864,
                        "name": "Viriville",
                        "latitude": "45.31579000",
                        "longitude": "5.20376000"
                    },
                    {
                        "id": 47866,
                        "name": "Viry",
                        "latitude": "46.11291000",
                        "longitude": "6.03808000"
                    },
                    {
                        "id": 47879,
                        "name": "Viuz-en-Sallaz",
                        "latitude": "46.14673000",
                        "longitude": "6.40781000"
                    },
                    {
                        "id": 47880,
                        "name": "Viuz-la-Chiésaz",
                        "latitude": "45.81203000",
                        "longitude": "6.06645000"
                    },
                    {
                        "id": 47882,
                        "name": "Viviers",
                        "latitude": "44.48280000",
                        "longitude": "4.68895000"
                    },
                    {
                        "id": 47883,
                        "name": "Viviers-du-Lac",
                        "latitude": "45.65000000",
                        "longitude": "5.90000000"
                    },
                    {
                        "id": 47889,
                        "name": "Vizille",
                        "latitude": "45.07819000",
                        "longitude": "5.77074000"
                    },
                    {
                        "id": 47890,
                        "name": "Voglans",
                        "latitude": "45.61868000",
                        "longitude": "5.88798000"
                    },
                    {
                        "id": 47892,
                        "name": "Voiron",
                        "latitude": "45.36471000",
                        "longitude": "5.58560000"
                    },
                    {
                        "id": 47899,
                        "name": "Volvic",
                        "latitude": "45.87196000",
                        "longitude": "3.03832000"
                    },
                    {
                        "id": 47901,
                        "name": "Vonnas",
                        "latitude": "46.21727000",
                        "longitude": "4.99246000"
                    },
                    {
                        "id": 47902,
                        "name": "Voreppe",
                        "latitude": "45.29484000",
                        "longitude": "5.63192000"
                    },
                    {
                        "id": 47903,
                        "name": "Vorey",
                        "latitude": "45.18638000",
                        "longitude": "3.90991000"
                    },
                    {
                        "id": 47905,
                        "name": "Vougy",
                        "latitude": "46.10435000",
                        "longitude": "4.11771000"
                    },
                    {
                        "id": 47912,
                        "name": "Vourey",
                        "latitude": "45.32180000",
                        "longitude": "5.51931000"
                    },
                    {
                        "id": 47913,
                        "name": "Vourles",
                        "latitude": "45.65878000",
                        "longitude": "4.77325000"
                    },
                    {
                        "id": 48002,
                        "name": "Ydes",
                        "latitude": "45.34722000",
                        "longitude": "2.43727000"
                    },
                    {
                        "id": 48003,
                        "name": "Yenne",
                        "latitude": "45.70420000",
                        "longitude": "5.75795000"
                    },
                    {
                        "id": 48009,
                        "name": "Youx",
                        "latitude": "46.14467000",
                        "longitude": "2.79903000"
                    },
                    {
                        "id": 48011,
                        "name": "Yssingeaux",
                        "latitude": "45.14282000",
                        "longitude": "4.12372000"
                    },
                    {
                        "id": 48012,
                        "name": "Ytrac",
                        "latitude": "44.91200000",
                        "longitude": "2.36248000"
                    },
                    {
                        "id": 48021,
                        "name": "Yzeure",
                        "latitude": "46.56596000",
                        "longitude": "3.35446000"
                    }
                ]
            },
            {
                "id": 4978,
                "name": "Aveyron",
                "iso2": "12",
                "latitude": "44.31563620",
                "longitude": "2.08523790",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5035,
                "name": "Bas-Rhin",
                "iso2": "67",
                "latitude": "48.59864440",
                "longitude": "7.02666760",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4979,
                "name": "Bouches-du-Rhône",
                "iso2": "13",
                "latitude": "43.54038650",
                "longitude": "4.46138290",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4825,
                "name": "Bourgogne-Franche-Comté",
                "iso2": "BFC",
                "latitude": "47.28051270",
                "longitude": "4.99943720",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39267,
                        "name": "Ahuy",
                        "latitude": "47.36944000",
                        "longitude": "5.02089000"
                    },
                    {
                        "id": 39280,
                        "name": "Aillant-sur-Tholon",
                        "latitude": "47.87426000",
                        "longitude": "3.35049000"
                    },
                    {
                        "id": 39281,
                        "name": "Aillevillers-et-Lyaumont",
                        "latitude": "47.92033000",
                        "longitude": "6.33775000"
                    },
                    {
                        "id": 39290,
                        "name": "Aiserey",
                        "latitude": "47.17229000",
                        "longitude": "5.16260000"
                    },
                    {
                        "id": 39373,
                        "name": "Ancy-le-Franc",
                        "latitude": "47.77586000",
                        "longitude": "4.16361000"
                    },
                    {
                        "id": 39379,
                        "name": "Andelnans",
                        "latitude": "47.60267000",
                        "longitude": "6.86621000"
                    },
                    {
                        "id": 39443,
                        "name": "Appoigny",
                        "latitude": "47.87467000",
                        "longitude": "3.52524000"
                    },
                    {
                        "id": 39449,
                        "name": "Arbois",
                        "latitude": "46.90311000",
                        "longitude": "5.77454000"
                    },
                    {
                        "id": 39452,
                        "name": "Arbouans",
                        "latitude": "47.49944000",
                        "longitude": "6.79505000"
                    },
                    {
                        "id": 39454,
                        "name": "Arc-et-Senans",
                        "latitude": "47.03127000",
                        "longitude": "5.77027000"
                    },
                    {
                        "id": 39455,
                        "name": "Arc-lès-Gray",
                        "latitude": "47.45701000",
                        "longitude": "5.58547000"
                    },
                    {
                        "id": 39456,
                        "name": "Arc-sur-Tille",
                        "latitude": "47.34349000",
                        "longitude": "5.18666000"
                    },
                    {
                        "id": 39459,
                        "name": "Arcey",
                        "latitude": "47.52258000",
                        "longitude": "6.66222000"
                    },
                    {
                        "id": 39486,
                        "name": "Arinthod",
                        "latitude": "46.39339000",
                        "longitude": "5.56616000"
                    },
                    {
                        "id": 39501,
                        "name": "Arnay-le-Duc",
                        "latitude": "47.13202000",
                        "longitude": "4.48595000"
                    },
                    {
                        "id": 39598,
                        "name": "Audincourt",
                        "latitude": "47.48327000",
                        "longitude": "6.85341000"
                    },
                    {
                        "id": 39606,
                        "name": "Augy",
                        "latitude": "47.76640000",
                        "longitude": "3.61051000"
                    },
                    {
                        "id": 39639,
                        "name": "Autun",
                        "latitude": "46.95104000",
                        "longitude": "4.29869000"
                    },
                    {
                        "id": 39644,
                        "name": "Auxerre",
                        "latitude": "47.79960000",
                        "longitude": "3.57033000"
                    },
                    {
                        "id": 39646,
                        "name": "Auxon-Dessous",
                        "latitude": "47.30000000",
                        "longitude": "5.95000000"
                    },
                    {
                        "id": 39647,
                        "name": "Auxonne",
                        "latitude": "47.19255000",
                        "longitude": "5.38726000"
                    },
                    {
                        "id": 39648,
                        "name": "Auxy",
                        "latitude": "46.94940000",
                        "longitude": "4.40440000"
                    },
                    {
                        "id": 39656,
                        "name": "Avallon",
                        "latitude": "47.49002000",
                        "longitude": "3.90832000"
                    },
                    {
                        "id": 39657,
                        "name": "Avanne-Aveney",
                        "latitude": "47.20000000",
                        "longitude": "5.96667000"
                    },
                    {
                        "id": 39793,
                        "name": "Bart",
                        "latitude": "47.48861000",
                        "longitude": "6.77090000"
                    },
                    {
                        "id": 39814,
                        "name": "Baume-les-Dames",
                        "latitude": "47.35295000",
                        "longitude": "6.36117000"
                    },
                    {
                        "id": 39817,
                        "name": "Bavans",
                        "latitude": "47.48528000",
                        "longitude": "6.73324000"
                    },
                    {
                        "id": 39820,
                        "name": "Bavilliers",
                        "latitude": "47.62235000",
                        "longitude": "6.83543000"
                    },
                    {
                        "id": 39841,
                        "name": "Beaucourt",
                        "latitude": "47.48878000",
                        "longitude": "6.92214000"
                    },
                    {
                        "id": 39874,
                        "name": "Beaune",
                        "latitude": "47.02413000",
                        "longitude": "4.83887000"
                    },
                    {
                        "id": 39904,
                        "name": "Belfort",
                        "latitude": "47.64218000",
                        "longitude": "6.85385000"
                    },
                    {
                        "id": 39917,
                        "name": "Belleneuve",
                        "latitude": "47.36224000",
                        "longitude": "5.26393000"
                    },
                    {
                        "id": 39971,
                        "name": "Besançon",
                        "latitude": "47.24878000",
                        "longitude": "6.01815000"
                    },
                    {
                        "id": 39984,
                        "name": "Bethoncourt",
                        "latitude": "47.53512000",
                        "longitude": "6.80504000"
                    },
                    {
                        "id": 39989,
                        "name": "Beure",
                        "latitude": "47.20690000",
                        "longitude": "6.00548000"
                    },
                    {
                        "id": 40052,
                        "name": "Blamont",
                        "latitude": "47.38513000",
                        "longitude": "6.84800000"
                    },
                    {
                        "id": 40057,
                        "name": "Blanzy",
                        "latitude": "46.70012000",
                        "longitude": "4.38833000"
                    },
                    {
                        "id": 40072,
                        "name": "Bléneau",
                        "latitude": "47.70000000",
                        "longitude": "2.95000000"
                    },
                    {
                        "id": 40065,
                        "name": "Bletterans",
                        "latitude": "46.74673000",
                        "longitude": "5.45444000"
                    },
                    {
                        "id": 40067,
                        "name": "Bligny-lès-Beaune",
                        "latitude": "46.98631000",
                        "longitude": "4.82620000"
                    },
                    {
                        "id": 40088,
                        "name": "Bois-d’Amont",
                        "latitude": "46.53280000",
                        "longitude": "6.13750000"
                    },
                    {
                        "id": 40178,
                        "name": "Bourbon-Lancy",
                        "latitude": "46.62214000",
                        "longitude": "3.76953000"
                    },
                    {
                        "id": 40211,
                        "name": "Bourogne",
                        "latitude": "47.56307000",
                        "longitude": "6.91654000"
                    },
                    {
                        "id": 40219,
                        "name": "Boussières",
                        "latitude": "47.15866000",
                        "longitude": "5.90314000"
                    },
                    {
                        "id": 40254,
                        "name": "Branges",
                        "latitude": "46.64441000",
                        "longitude": "5.18465000"
                    },
                    {
                        "id": 40270,
                        "name": "Brazey-en-Plaine",
                        "latitude": "47.13784000",
                        "longitude": "5.21538000"
                    },
                    {
                        "id": 40310,
                        "name": "Brienon-sur-Armançon",
                        "latitude": "47.99009000",
                        "longitude": "3.61628000"
                    },
                    {
                        "id": 40405,
                        "name": "Buxy",
                        "latitude": "46.71369000",
                        "longitude": "4.70427000"
                    },
                    {
                        "id": 40642,
                        "name": "Cercy-la-Tour",
                        "latitude": "46.86203000",
                        "longitude": "3.64652000"
                    },
                    {
                        "id": 41400,
                        "name": "Cézy",
                        "latitude": "47.99265000",
                        "longitude": "3.34067000"
                    },
                    {
                        "id": 40670,
                        "name": "Chablis",
                        "latitude": "47.81386000",
                        "longitude": "3.79835000"
                    },
                    {
                        "id": 40675,
                        "name": "Chagny",
                        "latitude": "46.90953000",
                        "longitude": "4.75190000"
                    },
                    {
                        "id": 40696,
                        "name": "Challuy",
                        "latitude": "46.94971000",
                        "longitude": "3.14807000"
                    },
                    {
                        "id": 40698,
                        "name": "Chalon-sur-Saône",
                        "latitude": "46.78112000",
                        "longitude": "4.85372000"
                    },
                    {
                        "id": 40934,
                        "name": "Châlonvillars",
                        "latitude": "47.64055000",
                        "longitude": "6.78407000"
                    },
                    {
                        "id": 40724,
                        "name": "Champagney",
                        "latitude": "47.70504000",
                        "longitude": "6.68173000"
                    },
                    {
                        "id": 40726,
                        "name": "Champagnole",
                        "latitude": "46.74452000",
                        "longitude": "5.91354000"
                    },
                    {
                        "id": 40736,
                        "name": "Champforgeuil",
                        "latitude": "46.81857000",
                        "longitude": "4.83357000"
                    },
                    {
                        "id": 40739,
                        "name": "Champignelles",
                        "latitude": "47.78009000",
                        "longitude": "3.07457000"
                    },
                    {
                        "id": 40741,
                        "name": "Champigny",
                        "latitude": "48.31667000",
                        "longitude": "3.13333000"
                    },
                    {
                        "id": 40745,
                        "name": "Champlitte",
                        "latitude": "47.61667000",
                        "longitude": "5.51667000"
                    },
                    {
                        "id": 40746,
                        "name": "Champlitte-la-Ville",
                        "latitude": "47.61333000",
                        "longitude": "5.53191000"
                    },
                    {
                        "id": 40750,
                        "name": "Champs-sur-Yonne",
                        "latitude": "47.73333000",
                        "longitude": "3.60000000"
                    },
                    {
                        "id": 40754,
                        "name": "Champvans",
                        "latitude": "47.10466000",
                        "longitude": "5.43760000"
                    },
                    {
                        "id": 40773,
                        "name": "Chantenay-Saint-Imbert",
                        "latitude": "46.73333000",
                        "longitude": "3.18333000"
                    },
                    {
                        "id": 40792,
                        "name": "Charbuy",
                        "latitude": "47.82282000",
                        "longitude": "3.46617000"
                    },
                    {
                        "id": 40810,
                        "name": "Charnay-lès-Mâcon",
                        "latitude": "46.30751000",
                        "longitude": "4.78479000"
                    },
                    {
                        "id": 40811,
                        "name": "Charny",
                        "latitude": "47.88661000",
                        "longitude": "3.09583000"
                    },
                    {
                        "id": 40814,
                        "name": "Charolles",
                        "latitude": "46.43451000",
                        "longitude": "4.27527000"
                    },
                    {
                        "id": 40815,
                        "name": "Charquemont",
                        "latitude": "47.21417000",
                        "longitude": "6.81980000"
                    },
                    {
                        "id": 40937,
                        "name": "Château-Chinon(Ville)",
                        "latitude": "47.06667000",
                        "longitude": "3.93333000"
                    },
                    {
                        "id": 40989,
                        "name": "Châtenois-les-Forges",
                        "latitude": "47.55875000",
                        "longitude": "6.84871000"
                    },
                    {
                        "id": 40990,
                        "name": "Châtenoy-le-Royal",
                        "latitude": "46.79797000",
                        "longitude": "4.81190000"
                    },
                    {
                        "id": 40994,
                        "name": "Châtillon-en-Bazois",
                        "latitude": "47.05464000",
                        "longitude": "3.65893000"
                    },
                    {
                        "id": 40998,
                        "name": "Châtillon-le-Duc",
                        "latitude": "47.30486000",
                        "longitude": "6.00792000"
                    },
                    {
                        "id": 41005,
                        "name": "Châtillon-sur-Seine",
                        "latitude": "47.85851000",
                        "longitude": "4.57375000"
                    },
                    {
                        "id": 40839,
                        "name": "Chauffailles",
                        "latitude": "46.20726000",
                        "longitude": "4.33932000"
                    },
                    {
                        "id": 40840,
                        "name": "Chaulgnes",
                        "latitude": "47.12889000",
                        "longitude": "3.10348000"
                    },
                    {
                        "id": 40852,
                        "name": "Chaussin",
                        "latitude": "46.96612000",
                        "longitude": "5.40791000"
                    },
                    {
                        "id": 40870,
                        "name": "Chemaudin",
                        "latitude": "47.22392000",
                        "longitude": "5.89419000"
                    },
                    {
                        "id": 40878,
                        "name": "Chenôve",
                        "latitude": "47.29323000",
                        "longitude": "5.00457000"
                    },
                    {
                        "id": 40877,
                        "name": "Cheny",
                        "latitude": "47.95166000",
                        "longitude": "3.53340000"
                    },
                    {
                        "id": 41016,
                        "name": "Chéroy",
                        "latitude": "48.20076000",
                        "longitude": "3.00011000"
                    },
                    {
                        "id": 40896,
                        "name": "Chevigny-Saint-Sauveur",
                        "latitude": "47.29908000",
                        "longitude": "5.13367000"
                    },
                    {
                        "id": 41009,
                        "name": "Chèvremont",
                        "latitude": "47.62912000",
                        "longitude": "6.92056000"
                    },
                    {
                        "id": 40919,
                        "name": "Choisey",
                        "latitude": "47.06389000",
                        "longitude": "5.45911000"
                    },
                    {
                        "id": 41027,
                        "name": "Ciry-le-Noble",
                        "latitude": "46.60607000",
                        "longitude": "4.29869000"
                    },
                    {
                        "id": 41037,
                        "name": "Clairvaux-les-Lacs",
                        "latitude": "46.57473000",
                        "longitude": "5.74825000"
                    },
                    {
                        "id": 41040,
                        "name": "Clamecy",
                        "latitude": "47.46017000",
                        "longitude": "3.51940000"
                    },
                    {
                        "id": 41051,
                        "name": "Clerval",
                        "latitude": "47.39167000",
                        "longitude": "6.49925000"
                    },
                    {
                        "id": 41063,
                        "name": "Cluny",
                        "latitude": "46.43318000",
                        "longitude": "4.65845000"
                    },
                    {
                        "id": 41102,
                        "name": "Colombier-Fontaine",
                        "latitude": "47.45224000",
                        "longitude": "6.69010000"
                    },
                    {
                        "id": 41167,
                        "name": "Corbenay",
                        "latitude": "47.89275000",
                        "longitude": "6.33047000"
                    },
                    {
                        "id": 41169,
                        "name": "Corbigny",
                        "latitude": "47.25678000",
                        "longitude": "3.68285000"
                    },
                    {
                        "id": 41199,
                        "name": "Corpeau",
                        "latitude": "46.92917000",
                        "longitude": "4.75226000"
                    },
                    {
                        "id": 41208,
                        "name": "Cosne-Cours-sur-Loire",
                        "latitude": "47.41101000",
                        "longitude": "2.92528000"
                    },
                    {
                        "id": 41216,
                        "name": "Couches",
                        "latitude": "46.86667000",
                        "longitude": "4.56667000"
                    },
                    {
                        "id": 41217,
                        "name": "Couchey",
                        "latitude": "47.25991000",
                        "longitude": "4.98257000"
                    },
                    {
                        "id": 41229,
                        "name": "Coulanges-lès-Nevers",
                        "latitude": "47.00509000",
                        "longitude": "3.18756000"
                    },
                    {
                        "id": 41244,
                        "name": "Courcelles-lès-Montbéliard",
                        "latitude": "47.50113000",
                        "longitude": "6.78461000"
                    },
                    {
                        "id": 41253,
                        "name": "Courlon-sur-Yonne",
                        "latitude": "48.33927000",
                        "longitude": "3.16660000"
                    },
                    {
                        "id": 41275,
                        "name": "Cousance",
                        "latitude": "46.53324000",
                        "longitude": "5.39214000"
                    },
                    {
                        "id": 41280,
                        "name": "Couternon",
                        "latitude": "47.33333000",
                        "longitude": "5.15000000"
                    },
                    {
                        "id": 41301,
                        "name": "Cravanche",
                        "latitude": "47.65346000",
                        "longitude": "6.83197000"
                    },
                    {
                        "id": 41353,
                        "name": "Crêches-sur-Saône",
                        "latitude": "46.24475000",
                        "longitude": "4.78678000"
                    },
                    {
                        "id": 41321,
                        "name": "Crissey",
                        "latitude": "46.81652000",
                        "longitude": "4.88185000"
                    },
                    {
                        "id": 41368,
                        "name": "Cuiseaux",
                        "latitude": "46.49473000",
                        "longitude": "5.38931000"
                    },
                    {
                        "id": 41369,
                        "name": "Cuisery",
                        "latitude": "46.55696000",
                        "longitude": "4.99797000"
                    },
                    {
                        "id": 41376,
                        "name": "Curgy",
                        "latitude": "46.98714000",
                        "longitude": "4.38452000"
                    },
                    {
                        "id": 41406,
                        "name": "Daix",
                        "latitude": "47.35081000",
                        "longitude": "5.00052000"
                    },
                    {
                        "id": 41417,
                        "name": "Damparis",
                        "latitude": "47.07556000",
                        "longitude": "5.41398000"
                    },
                    {
                        "id": 41418,
                        "name": "Dampierre",
                        "latitude": "47.15498000",
                        "longitude": "5.74167000"
                    },
                    {
                        "id": 41421,
                        "name": "Dampierre-les-Bois",
                        "latitude": "47.50639000",
                        "longitude": "6.91279000"
                    },
                    {
                        "id": 41422,
                        "name": "Dampierre-sur-Salon",
                        "latitude": "47.55719000",
                        "longitude": "5.67970000"
                    },
                    {
                        "id": 41424,
                        "name": "Damprichard",
                        "latitude": "47.24413000",
                        "longitude": "6.88121000"
                    },
                    {
                        "id": 41427,
                        "name": "Danjoutin",
                        "latitude": "47.61822000",
                        "longitude": "6.86204000"
                    },
                    {
                        "id": 41429,
                        "name": "Dannemarie-sur-Crête",
                        "latitude": "47.20488000",
                        "longitude": "5.87018000"
                    },
                    {
                        "id": 41438,
                        "name": "Dasle",
                        "latitude": "47.47843000",
                        "longitude": "6.89728000"
                    },
                    {
                        "id": 41447,
                        "name": "Decize",
                        "latitude": "46.82852000",
                        "longitude": "3.46192000"
                    },
                    {
                        "id": 41448,
                        "name": "Delle",
                        "latitude": "47.50797000",
                        "longitude": "6.99975000"
                    },
                    {
                        "id": 41449,
                        "name": "Demigny",
                        "latitude": "46.93048000",
                        "longitude": "4.83381000"
                    },
                    {
                        "id": 41623,
                        "name": "Département de l'Yonne",
                        "latitude": "47.91667000",
                        "longitude": "3.75000000"
                    },
                    {
                        "id": 41626,
                        "name": "Département de la Côte-d'Or",
                        "latitude": "47.50000000",
                        "longitude": "4.83333000"
                    },
                    {
                        "id": 41629,
                        "name": "Département de la Haute-Saône",
                        "latitude": "47.67625000",
                        "longitude": "6.10066000"
                    },
                    {
                        "id": 41632,
                        "name": "Département de la Nièvre",
                        "latitude": "47.11695000",
                        "longitude": "3.49192000"
                    },
                    {
                        "id": 41607,
                        "name": "Département de Saône-et-Loire",
                        "latitude": "46.63646000",
                        "longitude": "4.58819000"
                    },
                    {
                        "id": 41460,
                        "name": "Devecey",
                        "latitude": "47.32169000",
                        "longitude": "6.01900000"
                    },
                    {
                        "id": 41476,
                        "name": "Diges",
                        "latitude": "47.72862000",
                        "longitude": "3.39786000"
                    },
                    {
                        "id": 41479,
                        "name": "Digoin",
                        "latitude": "46.48124000",
                        "longitude": "3.97946000"
                    },
                    {
                        "id": 41481,
                        "name": "Dijon",
                        "latitude": "47.31667000",
                        "longitude": "5.01667000"
                    },
                    {
                        "id": 41504,
                        "name": "Dole",
                        "latitude": "47.09225000",
                        "longitude": "5.48966000"
                    },
                    {
                        "id": 41536,
                        "name": "Donzy",
                        "latitude": "47.37066000",
                        "longitude": "3.12548000"
                    },
                    {
                        "id": 41542,
                        "name": "Dornes",
                        "latitude": "46.71600000",
                        "longitude": "3.35343000"
                    },
                    {
                        "id": 41547,
                        "name": "Doubs",
                        "latitude": "47.19967000",
                        "longitude": "6.43487000"
                    },
                    {
                        "id": 41565,
                        "name": "Dracy-le-Fort",
                        "latitude": "46.79750000",
                        "longitude": "4.76215000"
                    },
                    {
                        "id": 48040,
                        "name": "Échenoz-la-Méline",
                        "latitude": "47.60086000",
                        "longitude": "6.13544000"
                    },
                    {
                        "id": 48044,
                        "name": "École-Valentin",
                        "latitude": "47.26667000",
                        "longitude": "5.98333000"
                    },
                    {
                        "id": 48055,
                        "name": "Écuisses",
                        "latitude": "46.75631000",
                        "longitude": "4.53845000"
                    },
                    {
                        "id": 48060,
                        "name": "Égriselles-le-Bocage",
                        "latitude": "48.12103000",
                        "longitude": "3.18233000"
                    },
                    {
                        "id": 48075,
                        "name": "Épervans",
                        "latitude": "46.75247000",
                        "longitude": "4.89930000"
                    },
                    {
                        "id": 48077,
                        "name": "Épinac",
                        "latitude": "46.98333000",
                        "longitude": "4.51667000"
                    },
                    {
                        "id": 41725,
                        "name": "Essert",
                        "latitude": "47.63342000",
                        "longitude": "6.81702000"
                    },
                    {
                        "id": 48094,
                        "name": "Étalans",
                        "latitude": "47.15125000",
                        "longitude": "6.27315000"
                    },
                    {
                        "id": 48097,
                        "name": "Étang-sur-Arroux",
                        "latitude": "46.86560000",
                        "longitude": "4.18988000"
                    },
                    {
                        "id": 48115,
                        "name": "Étupes",
                        "latitude": "47.50525000",
                        "longitude": "6.87075000"
                    },
                    {
                        "id": 41749,
                        "name": "Exincourt",
                        "latitude": "47.49465000",
                        "longitude": "6.83169000"
                    },
                    {
                        "id": 41784,
                        "name": "Faverney",
                        "latitude": "47.76713000",
                        "longitude": "6.10428000"
                    },
                    {
                        "id": 42003,
                        "name": "Fénay",
                        "latitude": "47.23185000",
                        "longitude": "5.06211000"
                    },
                    {
                        "id": 41807,
                        "name": "Fesches-le-Châtel",
                        "latitude": "47.52415000",
                        "longitude": "6.90535000"
                    },
                    {
                        "id": 41841,
                        "name": "Fleurey-sur-Ouche",
                        "latitude": "47.31182000",
                        "longitude": "4.85911000"
                    },
                    {
                        "id": 41848,
                        "name": "Fleury-la-Vallée",
                        "latitude": "47.86672000",
                        "longitude": "3.44908000"
                    },
                    {
                        "id": 41857,
                        "name": "Flogny-la-Chapelle",
                        "latitude": "47.95000000",
                        "longitude": "3.86667000"
                    },
                    {
                        "id": 41884,
                        "name": "Fontaine-lès-Dijon",
                        "latitude": "47.34238000",
                        "longitude": "5.02007000"
                    },
                    {
                        "id": 41885,
                        "name": "Fontaine-lès-Luxeuil",
                        "latitude": "47.85592000",
                        "longitude": "6.33482000"
                    },
                    {
                        "id": 41888,
                        "name": "Fontaines",
                        "latitude": "46.84905000",
                        "longitude": "4.77036000"
                    },
                    {
                        "id": 41922,
                        "name": "Foucherans",
                        "latitude": "47.08094000",
                        "longitude": "5.45503000"
                    },
                    {
                        "id": 41925,
                        "name": "Fougerolles",
                        "latitude": "47.88542000",
                        "longitude": "6.40454000"
                    },
                    {
                        "id": 41934,
                        "name": "Fourchambault",
                        "latitude": "47.01667000",
                        "longitude": "3.08333000"
                    },
                    {
                        "id": 41942,
                        "name": "Frahier-et-Chatebier",
                        "latitude": "47.66667000",
                        "longitude": "6.75000000"
                    },
                    {
                        "id": 41943,
                        "name": "Fraisans",
                        "latitude": "47.14857000",
                        "longitude": "5.76051000"
                    },
                    {
                        "id": 41951,
                        "name": "Franois",
                        "latitude": "47.23055000",
                        "longitude": "5.92869000"
                    },
                    {
                        "id": 41953,
                        "name": "Frasne",
                        "latitude": "46.85641000",
                        "longitude": "6.15940000"
                    },
                    {
                        "id": 41968,
                        "name": "Froideconche",
                        "latitude": "47.82121000",
                        "longitude": "6.41523000"
                    },
                    {
                        "id": 41979,
                        "name": "Frotey-lès-Vesoul",
                        "latitude": "47.62078000",
                        "longitude": "6.18831000"
                    },
                    {
                        "id": 42035,
                        "name": "Garchizy",
                        "latitude": "47.04786000",
                        "longitude": "3.09625000"
                    },
                    {
                        "id": 42295,
                        "name": "Génelard",
                        "latitude": "46.58119000",
                        "longitude": "4.23619000"
                    },
                    {
                        "id": 42066,
                        "name": "Genlis",
                        "latitude": "47.24203000",
                        "longitude": "5.22415000"
                    },
                    {
                        "id": 42074,
                        "name": "Gergy",
                        "latitude": "46.87557000",
                        "longitude": "4.94527000"
                    },
                    {
                        "id": 42082,
                        "name": "Gevrey-Chambertin",
                        "latitude": "47.22614000",
                        "longitude": "4.96806000"
                    },
                    {
                        "id": 42094,
                        "name": "Gilley",
                        "latitude": "47.04740000",
                        "longitude": "6.48257000"
                    },
                    {
                        "id": 42101,
                        "name": "Giromagny",
                        "latitude": "47.74272000",
                        "longitude": "6.82733000"
                    },
                    {
                        "id": 42110,
                        "name": "Givry",
                        "latitude": "46.78202000",
                        "longitude": "4.74262000"
                    },
                    {
                        "id": 42171,
                        "name": "Grand-Charmont",
                        "latitude": "47.52674000",
                        "longitude": "6.82604000"
                    },
                    {
                        "id": 42177,
                        "name": "Grandfontaine",
                        "latitude": "47.19763000",
                        "longitude": "5.90079000"
                    },
                    {
                        "id": 42180,
                        "name": "Grandvillars",
                        "latitude": "47.53929000",
                        "longitude": "6.97100000"
                    },
                    {
                        "id": 42192,
                        "name": "Gray",
                        "latitude": "47.44575000",
                        "longitude": "5.59215000"
                    },
                    {
                        "id": 42193,
                        "name": "Gray-la-Ville",
                        "latitude": "47.43932000",
                        "longitude": "5.57252000"
                    },
                    {
                        "id": 42222,
                        "name": "Gron",
                        "latitude": "48.15967000",
                        "longitude": "3.26345000"
                    },
                    {
                        "id": 42288,
                        "name": "Guérigny",
                        "latitude": "47.08703000",
                        "longitude": "3.20182000"
                    },
                    {
                        "id": 42248,
                        "name": "Gueugnon",
                        "latitude": "46.60357000",
                        "longitude": "4.06286000"
                    },
                    {
                        "id": 42275,
                        "name": "Gurgy",
                        "latitude": "47.86712000",
                        "longitude": "3.56341000"
                    },
                    {
                        "id": 42292,
                        "name": "Gy",
                        "latitude": "47.40588000",
                        "longitude": "5.81226000"
                    },
                    {
                        "id": 42353,
                        "name": "Hauteville-lès-Dijon",
                        "latitude": "47.36602000",
                        "longitude": "4.99375000"
                    },
                    {
                        "id": 42457,
                        "name": "Héricourt",
                        "latitude": "47.57305000",
                        "longitude": "6.76139000"
                    },
                    {
                        "id": 42459,
                        "name": "Hérimoncourt",
                        "latitude": "47.44284000",
                        "longitude": "6.88242000"
                    },
                    {
                        "id": 42463,
                        "name": "Héry",
                        "latitude": "47.90146000",
                        "longitude": "3.62868000"
                    },
                    {
                        "id": 42444,
                        "name": "Hurigny",
                        "latitude": "46.34722000",
                        "longitude": "4.79676000"
                    },
                    {
                        "id": 42484,
                        "name": "Imphy",
                        "latitude": "46.93619000",
                        "longitude": "3.26037000"
                    },
                    {
                        "id": 42497,
                        "name": "Is-sur-Tille",
                        "latitude": "47.52670000",
                        "longitude": "5.10649000"
                    },
                    {
                        "id": 42552,
                        "name": "Joigny",
                        "latitude": "47.98288000",
                        "longitude": "3.40096000"
                    },
                    {
                        "id": 42556,
                        "name": "Joncherey",
                        "latitude": "47.52895000",
                        "longitude": "7.00323000"
                    },
                    {
                        "id": 42569,
                        "name": "Jougne",
                        "latitude": "46.76291000",
                        "longitude": "6.38838000"
                    },
                    {
                        "id": 42571,
                        "name": "Joux-la-Ville",
                        "latitude": "47.62241000",
                        "longitude": "3.86217000"
                    },
                    {
                        "id": 42593,
                        "name": "Jura",
                        "latitude": "46.73431000",
                        "longitude": "5.72349000"
                    },
                    {
                        "id": 42596,
                        "name": "Jussey",
                        "latitude": "47.82536000",
                        "longitude": "5.90193000"
                    },
                    {
                        "id": 42691,
                        "name": "La Chapelle-de-Guinchay",
                        "latitude": "46.20841000",
                        "longitude": "4.76245000"
                    },
                    {
                        "id": 42702,
                        "name": "La Charité-sur-Loire",
                        "latitude": "47.18333000",
                        "longitude": "3.01667000"
                    },
                    {
                        "id": 42709,
                        "name": "La Clayette",
                        "latitude": "46.29002000",
                        "longitude": "4.30422000"
                    },
                    {
                        "id": 42711,
                        "name": "La Cluse-et-Mijoux",
                        "latitude": "46.88333000",
                        "longitude": "6.38333000"
                    },
                    {
                        "id": 42796,
                        "name": "La Machine",
                        "latitude": "46.89226000",
                        "longitude": "3.46426000"
                    },
                    {
                        "id": 42814,
                        "name": "La Motte-Saint-Jean",
                        "latitude": "46.49594000",
                        "longitude": "3.96396000"
                    },
                    {
                        "id": 42855,
                        "name": "La Roche-Vineuse",
                        "latitude": "46.34524000",
                        "longitude": "4.72023000"
                    },
                    {
                        "id": 42951,
                        "name": "Ladoix-Serrigny",
                        "latitude": "47.06667000",
                        "longitude": "4.88333000"
                    },
                    {
                        "id": 42982,
                        "name": "Lamarche-sur-Saône",
                        "latitude": "47.26946000",
                        "longitude": "5.38589000"
                    },
                    {
                        "id": 43074,
                        "name": "Laroche-Saint-Cydroine",
                        "latitude": "47.96801000",
                        "longitude": "3.48467000"
                    },
                    {
                        "id": 43110,
                        "name": "Lavans-lès-Saint-Claude",
                        "latitude": "46.38484000",
                        "longitude": "5.78172000"
                    },
                    {
                        "id": 43144,
                        "name": "Le Breuil",
                        "latitude": "46.80654000",
                        "longitude": "4.46953000"
                    },
                    {
                        "id": 43175,
                        "name": "Le Creusot",
                        "latitude": "46.80714000",
                        "longitude": "4.41632000"
                    },
                    {
                        "id": 43298,
                        "name": "Le Russey",
                        "latitude": "47.16055000",
                        "longitude": "6.72912000"
                    },
                    {
                        "id": 43354,
                        "name": "Lepuix",
                        "latitude": "47.76050000",
                        "longitude": "6.81434000"
                    },
                    {
                        "id": 43387,
                        "name": "Les Fins",
                        "latitude": "47.07764000",
                        "longitude": "6.63002000"
                    },
                    {
                        "id": 43389,
                        "name": "Les Fourgs",
                        "latitude": "46.83455000",
                        "longitude": "6.39953000"
                    },
                    {
                        "id": 43426,
                        "name": "Les Rousses",
                        "latitude": "46.48412000",
                        "longitude": "6.06330000"
                    },
                    {
                        "id": 43452,
                        "name": "Levier",
                        "latitude": "46.95302000",
                        "longitude": "6.12059000"
                    },
                    {
                        "id": 43479,
                        "name": "Ligny-le-Châtel",
                        "latitude": "47.90022000",
                        "longitude": "3.75760000"
                    },
                    {
                        "id": 43553,
                        "name": "Longchamp",
                        "latitude": "47.25973000",
                        "longitude": "5.28694000"
                    },
                    {
                        "id": 43554,
                        "name": "Longchaumois",
                        "latitude": "46.46228000",
                        "longitude": "5.93052000"
                    },
                    {
                        "id": 43555,
                        "name": "Longecourt-en-Plaine",
                        "latitude": "47.19783000",
                        "longitude": "5.14956000"
                    },
                    {
                        "id": 43574,
                        "name": "Longvic",
                        "latitude": "47.28754000",
                        "longitude": "5.06341000"
                    },
                    {
                        "id": 43577,
                        "name": "Lons-le-Saunier",
                        "latitude": "46.67535000",
                        "longitude": "5.55575000"
                    },
                    {
                        "id": 43591,
                        "name": "Lormes",
                        "latitude": "47.28964000",
                        "longitude": "3.81714000"
                    },
                    {
                        "id": 43596,
                        "name": "Losne",
                        "latitude": "47.09850000",
                        "longitude": "5.26216000"
                    },
                    {
                        "id": 43603,
                        "name": "Louhans",
                        "latitude": "46.62637000",
                        "longitude": "5.22468000"
                    },
                    {
                        "id": 43634,
                        "name": "Lucenay-lès-Aix",
                        "latitude": "46.70274000",
                        "longitude": "3.48308000"
                    },
                    {
                        "id": 43659,
                        "name": "Lure",
                        "latitude": "47.68294000",
                        "longitude": "6.49658000"
                    },
                    {
                        "id": 43668,
                        "name": "Luxeuil-les-Bains",
                        "latitude": "47.81710000",
                        "longitude": "6.36500000"
                    },
                    {
                        "id": 43674,
                        "name": "Luzy",
                        "latitude": "46.79011000",
                        "longitude": "3.97036000"
                    },
                    {
                        "id": 44451,
                        "name": "Mâcon",
                        "latitude": "46.31407000",
                        "longitude": "4.82823000"
                    },
                    {
                        "id": 43724,
                        "name": "Magny-Cours",
                        "latitude": "46.88333000",
                        "longitude": "3.15000000"
                    },
                    {
                        "id": 43725,
                        "name": "Magny-Vernois",
                        "latitude": "47.66997000",
                        "longitude": "6.47545000"
                    },
                    {
                        "id": 43982,
                        "name": "Maîche",
                        "latitude": "47.25160000",
                        "longitude": "6.80309000"
                    },
                    {
                        "id": 43735,
                        "name": "Maillot",
                        "latitude": "48.17557000",
                        "longitude": "3.30784000"
                    },
                    {
                        "id": 43753,
                        "name": "Malay-le-Grand",
                        "latitude": "48.17589000",
                        "longitude": "3.34189000"
                    },
                    {
                        "id": 43770,
                        "name": "Mamirolle",
                        "latitude": "47.19857000",
                        "longitude": "6.15924000"
                    },
                    {
                        "id": 43774,
                        "name": "Mandeure",
                        "latitude": "47.44921000",
                        "longitude": "6.80762000"
                    },
                    {
                        "id": 43802,
                        "name": "Marcigny",
                        "latitude": "46.27627000",
                        "longitude": "4.03957000"
                    },
                    {
                        "id": 43808,
                        "name": "Marcilly-sur-Tille",
                        "latitude": "47.51700000",
                        "longitude": "5.12979000"
                    },
                    {
                        "id": 43857,
                        "name": "Marmagne",
                        "latitude": "46.83666000",
                        "longitude": "4.35892000"
                    },
                    {
                        "id": 43861,
                        "name": "Marnay",
                        "latitude": "47.29088000",
                        "longitude": "5.77277000"
                    },
                    {
                        "id": 43879,
                        "name": "Marsannay-la-Côte",
                        "latitude": "47.27095000",
                        "longitude": "4.98895000"
                    },
                    {
                        "id": 43925,
                        "name": "Marzy",
                        "latitude": "46.98125000",
                        "longitude": "3.09352000"
                    },
                    {
                        "id": 43938,
                        "name": "Mathay",
                        "latitude": "47.43905000",
                        "longitude": "6.78487000"
                    },
                    {
                        "id": 43941,
                        "name": "Matour",
                        "latitude": "46.30654000",
                        "longitude": "4.48178000"
                    },
                    {
                        "id": 44461,
                        "name": "Mélisey",
                        "latitude": "47.75229000",
                        "longitude": "6.58014000"
                    },
                    {
                        "id": 43996,
                        "name": "Mellecey",
                        "latitude": "46.81084000",
                        "longitude": "4.72822000"
                    },
                    {
                        "id": 44010,
                        "name": "Mercurey",
                        "latitude": "46.84035000",
                        "longitude": "4.71743000"
                    },
                    {
                        "id": 44021,
                        "name": "Mervans",
                        "latitude": "46.79923000",
                        "longitude": "5.18430000"
                    },
                    {
                        "id": 44037,
                        "name": "Messigny-et-Vantoux",
                        "latitude": "47.40666000",
                        "longitude": "5.01715000"
                    },
                    {
                        "id": 44050,
                        "name": "Meursault",
                        "latitude": "46.97822000",
                        "longitude": "4.76952000"
                    },
                    {
                        "id": 44487,
                        "name": "Méziré",
                        "latitude": "47.53336000",
                        "longitude": "6.92072000"
                    },
                    {
                        "id": 44068,
                        "name": "Migennes",
                        "latitude": "47.96548000",
                        "longitude": "3.51787000"
                    },
                    {
                        "id": 44093,
                        "name": "Mirebeau-sur-Bèze",
                        "latitude": "47.39828000",
                        "longitude": "5.32093000"
                    },
                    {
                        "id": 44103,
                        "name": "Miserey-Salines",
                        "latitude": "47.28638000",
                        "longitude": "5.97387000"
                    },
                    {
                        "id": 44114,
                        "name": "Moirans-en-Montagne",
                        "latitude": "46.43381000",
                        "longitude": "5.72643000"
                    },
                    {
                        "id": 44336,
                        "name": "Monéteau",
                        "latitude": "47.84923000",
                        "longitude": "3.58178000"
                    },
                    {
                        "id": 44163,
                        "name": "Mont-sous-Vaudrey",
                        "latitude": "46.97874000",
                        "longitude": "5.60295000"
                    },
                    {
                        "id": 44190,
                        "name": "Montbard",
                        "latitude": "47.62294000",
                        "longitude": "4.33700000"
                    },
                    {
                        "id": 44204,
                        "name": "Montbéliard",
                        "latitude": "47.50957000",
                        "longitude": "6.79823000"
                    },
                    {
                        "id": 44206,
                        "name": "Montceau-les-Mines",
                        "latitude": "46.66667000",
                        "longitude": "4.36667000"
                    },
                    {
                        "id": 44207,
                        "name": "Montcenis",
                        "latitude": "46.78785000",
                        "longitude": "4.38738000"
                    },
                    {
                        "id": 44208,
                        "name": "Montchanin",
                        "latitude": "46.74964000",
                        "longitude": "4.47070000"
                    },
                    {
                        "id": 44220,
                        "name": "Montenois",
                        "latitude": "47.49222000",
                        "longitude": "6.66561000"
                    },
                    {
                        "id": 44230,
                        "name": "Montfaucon",
                        "latitude": "47.23562000",
                        "longitude": "6.08162000"
                    },
                    {
                        "id": 44236,
                        "name": "Montferrand-le-Château",
                        "latitude": "47.17536000",
                        "longitude": "5.91534000"
                    },
                    {
                        "id": 44270,
                        "name": "Montlebon",
                        "latitude": "47.03778000",
                        "longitude": "6.61111000"
                    },
                    {
                        "id": 44289,
                        "name": "Montmorot",
                        "latitude": "46.67541000",
                        "longitude": "5.52283000"
                    },
                    {
                        "id": 44302,
                        "name": "Montpont-en-Bresse",
                        "latitude": "46.55630000",
                        "longitude": "5.16459000"
                    },
                    {
                        "id": 44314,
                        "name": "Montreux-Château",
                        "latitude": "47.61003000",
                        "longitude": "6.99923000"
                    },
                    {
                        "id": 44344,
                        "name": "Morbier",
                        "latitude": "46.53693000",
                        "longitude": "6.01532000"
                    },
                    {
                        "id": 44351,
                        "name": "Morez",
                        "latitude": "46.52540000",
                        "longitude": "6.02589000"
                    },
                    {
                        "id": 44364,
                        "name": "Morre",
                        "latitude": "47.22595000",
                        "longitude": "6.07512000"
                    },
                    {
                        "id": 44374,
                        "name": "Morteau",
                        "latitude": "47.05784000",
                        "longitude": "6.60716000"
                    },
                    {
                        "id": 44376,
                        "name": "Morvillars",
                        "latitude": "47.54854000",
                        "longitude": "6.93450000"
                    },
                    {
                        "id": 44383,
                        "name": "Mouchard",
                        "latitude": "46.97259000",
                        "longitude": "5.79626000"
                    },
                    {
                        "id": 44395,
                        "name": "Moulins-Engilbert",
                        "latitude": "46.98821000",
                        "longitude": "3.81084000"
                    },
                    {
                        "id": 44500,
                        "name": "Nancray",
                        "latitude": "47.24536000",
                        "longitude": "6.18283000"
                    },
                    {
                        "id": 44523,
                        "name": "Navenne",
                        "latitude": "47.60873000",
                        "longitude": "6.16176000"
                    },
                    {
                        "id": 44550,
                        "name": "Neuilly-lès-Dijon",
                        "latitude": "47.27943000",
                        "longitude": "5.10645000"
                    },
                    {
                        "id": 44577,
                        "name": "Neuvy-Sautour",
                        "latitude": "48.04190000",
                        "longitude": "3.79472000"
                    },
                    {
                        "id": 44580,
                        "name": "Neuvy-sur-Loire",
                        "latitude": "47.52323000",
                        "longitude": "2.88333000"
                    },
                    {
                        "id": 44583,
                        "name": "Nevers",
                        "latitude": "46.98956000",
                        "longitude": "3.15900000"
                    },
                    {
                        "id": 44622,
                        "name": "Noidans-lès-Vesoul",
                        "latitude": "47.61299000",
                        "longitude": "6.12571000"
                    },
                    {
                        "id": 44633,
                        "name": "Nolay",
                        "latitude": "46.95202000",
                        "longitude": "4.63405000"
                    },
                    {
                        "id": 44637,
                        "name": "Nommay",
                        "latitude": "47.53780000",
                        "longitude": "6.84219000"
                    },
                    {
                        "id": 44667,
                        "name": "Novillars",
                        "latitude": "47.28465000",
                        "longitude": "6.12878000"
                    },
                    {
                        "id": 44688,
                        "name": "Nuits-Saint-Georges",
                        "latitude": "47.13683000",
                        "longitude": "4.94900000"
                    },
                    {
                        "id": 44718,
                        "name": "Offemont",
                        "latitude": "47.66278000",
                        "longitude": "6.87764000"
                    },
                    {
                        "id": 44757,
                        "name": "Orchamps",
                        "latitude": "47.14751000",
                        "longitude": "5.65873000"
                    },
                    {
                        "id": 44758,
                        "name": "Orchamps-Vennes",
                        "latitude": "47.13042000",
                        "longitude": "6.52468000"
                    },
                    {
                        "id": 44761,
                        "name": "Orgelet",
                        "latitude": "46.52096000",
                        "longitude": "5.61049000"
                    },
                    {
                        "id": 44780,
                        "name": "Ornans",
                        "latitude": "47.10749000",
                        "longitude": "6.14306000"
                    },
                    {
                        "id": 44804,
                        "name": "Ouges",
                        "latitude": "47.26164000",
                        "longitude": "5.07395000"
                    },
                    {
                        "id": 44808,
                        "name": "Ouroux-sur-Saône",
                        "latitude": "46.72147000",
                        "longitude": "4.95262000"
                    },
                    {
                        "id": 44837,
                        "name": "Palinges",
                        "latitude": "46.55357000",
                        "longitude": "4.21964000"
                    },
                    {
                        "id": 44848,
                        "name": "Paray-le-Monial",
                        "latitude": "46.45457000",
                        "longitude": "4.11584000"
                    },
                    {
                        "id": 44858,
                        "name": "Paron",
                        "latitude": "48.17888000",
                        "longitude": "3.25075000"
                    },
                    {
                        "id": 44888,
                        "name": "Pelousey",
                        "latitude": "47.27538000",
                        "longitude": "5.92263000"
                    },
                    {
                        "id": 44900,
                        "name": "Perrecy-les-Forges",
                        "latitude": "46.61453000",
                        "longitude": "4.21380000"
                    },
                    {
                        "id": 44904,
                        "name": "Perrigny",
                        "latitude": "46.66744000",
                        "longitude": "5.58456000"
                    },
                    {
                        "id": 44905,
                        "name": "Perrigny-lès-Dijon",
                        "latitude": "47.26648000",
                        "longitude": "5.00628000"
                    },
                    {
                        "id": 44913,
                        "name": "Pesmes",
                        "latitude": "47.28008000",
                        "longitude": "5.56698000"
                    },
                    {
                        "id": 44917,
                        "name": "Petit-Noir",
                        "latitude": "46.93333000",
                        "longitude": "5.33333000"
                    },
                    {
                        "id": 44952,
                        "name": "Pierre-de-Bresse",
                        "latitude": "46.88333000",
                        "longitude": "5.25000000"
                    },
                    {
                        "id": 44957,
                        "name": "Pierrefontaine-les-Varans",
                        "latitude": "47.21601000",
                        "longitude": "6.54030000"
                    },
                    {
                        "id": 44977,
                        "name": "Pirey",
                        "latitude": "47.26136000",
                        "longitude": "5.96466000"
                    },
                    {
                        "id": 44998,
                        "name": "Plancher-Bas",
                        "latitude": "47.71977000",
                        "longitude": "6.73041000"
                    },
                    {
                        "id": 44999,
                        "name": "Plancher-les-Mines",
                        "latitude": "47.76150000",
                        "longitude": "6.74308000"
                    },
                    {
                        "id": 45037,
                        "name": "Plombières-lès-Dijon",
                        "latitude": "47.33333000",
                        "longitude": "4.96667000"
                    },
                    {
                        "id": 45142,
                        "name": "Poligny",
                        "latitude": "46.83712000",
                        "longitude": "5.70505000"
                    },
                    {
                        "id": 45181,
                        "name": "Pont-de-Roide",
                        "latitude": "47.38738000",
                        "longitude": "6.76840000"
                    },
                    {
                        "id": 45193,
                        "name": "Pont-sur-Yonne",
                        "latitude": "48.28297000",
                        "longitude": "3.20198000"
                    },
                    {
                        "id": 45200,
                        "name": "Pontailler-sur-Saône",
                        "latitude": "47.30455000",
                        "longitude": "5.41479000"
                    },
                    {
                        "id": 45201,
                        "name": "Pontarlier",
                        "latitude": "46.90347000",
                        "longitude": "6.35542000"
                    },
                    {
                        "id": 45237,
                        "name": "Port-sur-Saône",
                        "latitude": "47.68774000",
                        "longitude": "6.05011000"
                    },
                    {
                        "id": 45250,
                        "name": "Pougues-les-Eaux",
                        "latitude": "47.07518000",
                        "longitude": "3.10150000"
                    },
                    {
                        "id": 45251,
                        "name": "Pouilley-les-Vignes",
                        "latitude": "47.25770000",
                        "longitude": "5.93581000"
                    },
                    {
                        "id": 45253,
                        "name": "Pouilly-en-Auxois",
                        "latitude": "47.26238000",
                        "longitude": "4.55583000"
                    },
                    {
                        "id": 45257,
                        "name": "Pouilly-sur-Loire",
                        "latitude": "47.28377000",
                        "longitude": "2.95442000"
                    },
                    {
                        "id": 45265,
                        "name": "Pourrain",
                        "latitude": "47.75615000",
                        "longitude": "3.41193000"
                    },
                    {
                        "id": 45309,
                        "name": "Prémery",
                        "latitude": "47.16952000",
                        "longitude": "3.32743000"
                    },
                    {
                        "id": 45290,
                        "name": "Prissé",
                        "latitude": "46.32130000",
                        "longitude": "4.74469000"
                    },
                    {
                        "id": 45330,
                        "name": "Pusey",
                        "latitude": "47.65243000",
                        "longitude": "6.12615000"
                    },
                    {
                        "id": 45380,
                        "name": "Quetigny",
                        "latitude": "47.31667000",
                        "longitude": "5.11667000"
                    },
                    {
                        "id": 45392,
                        "name": "Quincey",
                        "latitude": "47.61165000",
                        "longitude": "6.18556000"
                    },
                    {
                        "id": 45397,
                        "name": "Quingey",
                        "latitude": "47.10250000",
                        "longitude": "5.88312000"
                    },
                    {
                        "id": 45435,
                        "name": "Ravières",
                        "latitude": "47.73475000",
                        "longitude": "4.22777000"
                    },
                    {
                        "id": 45522,
                        "name": "Rioz",
                        "latitude": "47.42521000",
                        "longitude": "6.06598000"
                    },
                    {
                        "id": 45541,
                        "name": "Roche-lez-Beaupré",
                        "latitude": "47.28333000",
                        "longitude": "6.11667000"
                    },
                    {
                        "id": 45576,
                        "name": "Romanèche-Thorins",
                        "latitude": "46.18402000",
                        "longitude": "4.74242000"
                    },
                    {
                        "id": 45578,
                        "name": "Romenay",
                        "latitude": "46.50208000",
                        "longitude": "5.06904000"
                    },
                    {
                        "id": 45583,
                        "name": "Ronchamp",
                        "latitude": "47.70063000",
                        "longitude": "6.63591000"
                    },
                    {
                        "id": 45622,
                        "name": "Rougemont",
                        "latitude": "47.48211000",
                        "longitude": "6.35574000"
                    },
                    {
                        "id": 45623,
                        "name": "Rougemont-le-Château",
                        "latitude": "47.73532000",
                        "longitude": "6.96690000"
                    },
                    {
                        "id": 45631,
                        "name": "Roulans",
                        "latitude": "47.31553000",
                        "longitude": "6.22901000"
                    },
                    {
                        "id": 45649,
                        "name": "Roye",
                        "latitude": "47.66995000",
                        "longitude": "6.54139000"
                    },
                    {
                        "id": 45664,
                        "name": "Ruffey-lès-Echirey",
                        "latitude": "47.36667000",
                        "longitude": "5.08333000"
                    },
                    {
                        "id": 45669,
                        "name": "Rully",
                        "latitude": "46.87499000",
                        "longitude": "4.74322000"
                    },
                    {
                        "id": 45712,
                        "name": "Sagy",
                        "latitude": "46.60129000",
                        "longitude": "5.31045000"
                    },
                    {
                        "id": 45743,
                        "name": "Saint-Amand-en-Puisaye",
                        "latitude": "47.52913000",
                        "longitude": "3.07400000"
                    },
                    {
                        "id": 45752,
                        "name": "Saint-Amour",
                        "latitude": "46.43638000",
                        "longitude": "5.34416000"
                    },
                    {
                        "id": 45774,
                        "name": "Saint-Apollinaire",
                        "latitude": "47.33333000",
                        "longitude": "5.08333000"
                    },
                    {
                        "id": 45780,
                        "name": "Saint-Aubin",
                        "latitude": "47.03336000",
                        "longitude": "5.32666000"
                    },
                    {
                        "id": 45809,
                        "name": "Saint-Benin-d’Azy",
                        "latitude": "46.99914000",
                        "longitude": "3.39267000"
                    },
                    {
                        "id": 45813,
                        "name": "Saint-Berain-sous-Sanvignes",
                        "latitude": "46.70678000",
                        "longitude": "4.29405000"
                    },
                    {
                        "id": 45831,
                        "name": "Saint-Bris-le-Vineux",
                        "latitude": "47.74396000",
                        "longitude": "3.64922000"
                    },
                    {
                        "id": 45866,
                        "name": "Saint-Claude",
                        "latitude": "46.38679000",
                        "longitude": "5.86473000"
                    },
                    {
                        "id": 45870,
                        "name": "Saint-Clément",
                        "latitude": "48.21724000",
                        "longitude": "3.29609000"
                    },
                    {
                        "id": 46636,
                        "name": "Saint-Éloi",
                        "latitude": "46.97342000",
                        "longitude": "3.22228000"
                    },
                    {
                        "id": 45928,
                        "name": "Saint-Eusèbe",
                        "latitude": "46.71346000",
                        "longitude": "4.46203000"
                    },
                    {
                        "id": 45929,
                        "name": "Saint-Fargeau",
                        "latitude": "47.64133000",
                        "longitude": "3.07066000"
                    },
                    {
                        "id": 45937,
                        "name": "Saint-Florentin",
                        "latitude": "48.00057000",
                        "longitude": "3.72489000"
                    },
                    {
                        "id": 45957,
                        "name": "Saint-Gengoux-le-National",
                        "latitude": "46.61476000",
                        "longitude": "4.66261000"
                    },
                    {
                        "id": 45988,
                        "name": "Saint-Georges-sur-Baulche",
                        "latitude": "47.80039000",
                        "longitude": "3.53144000"
                    },
                    {
                        "id": 45993,
                        "name": "Saint-Germain",
                        "latitude": "47.72496000",
                        "longitude": "6.53117000"
                    },
                    {
                        "id": 46009,
                        "name": "Saint-Germain-du-Bois",
                        "latitude": "46.75287000",
                        "longitude": "5.24530000"
                    },
                    {
                        "id": 46011,
                        "name": "Saint-Germain-du-Plain",
                        "latitude": "46.69938000",
                        "longitude": "4.98510000"
                    },
                    {
                        "id": 46069,
                        "name": "Saint-Hippolyte",
                        "latitude": "47.31880000",
                        "longitude": "6.81617000"
                    },
                    {
                        "id": 46093,
                        "name": "Saint-Jean-de-Losne",
                        "latitude": "47.10247000",
                        "longitude": "5.26556000"
                    },
                    {
                        "id": 46134,
                        "name": "Saint-Julien",
                        "latitude": "47.40029000",
                        "longitude": "5.14163000"
                    },
                    {
                        "id": 46142,
                        "name": "Saint-Julien-du-Sault",
                        "latitude": "48.03188000",
                        "longitude": "3.29556000"
                    },
                    {
                        "id": 46186,
                        "name": "Saint-Laurent-en-Grandvaux",
                        "latitude": "46.58333000",
                        "longitude": "5.95000000"
                    },
                    {
                        "id": 46212,
                        "name": "Saint-Léger-des-Vignes",
                        "latitude": "46.84063000",
                        "longitude": "3.45488000"
                    },
                    {
                        "id": 46218,
                        "name": "Saint-Léger-sur-Dheune",
                        "latitude": "46.84548000",
                        "longitude": "4.63607000"
                    },
                    {
                        "id": 46192,
                        "name": "Saint-Leu",
                        "latitude": "46.73060000",
                        "longitude": "4.50083000"
                    },
                    {
                        "id": 46201,
                        "name": "Saint-Loup-sur-Semouse",
                        "latitude": "47.88345000",
                        "longitude": "6.27530000"
                    },
                    {
                        "id": 46206,
                        "name": "Saint-Lupicin",
                        "latitude": "46.40034000",
                        "longitude": "5.79220000"
                    },
                    {
                        "id": 46243,
                        "name": "Saint-Marcel",
                        "latitude": "46.77371000",
                        "longitude": "4.89205000"
                    },
                    {
                        "id": 46259,
                        "name": "Saint-Martin-Belle-Roche",
                        "latitude": "46.38312000",
                        "longitude": "4.85539000"
                    },
                    {
                        "id": 46291,
                        "name": "Saint-Martin-du-Tertre",
                        "latitude": "48.21659000",
                        "longitude": "3.26151000"
                    },
                    {
                        "id": 46296,
                        "name": "Saint-Martin-en-Bresse",
                        "latitude": "46.81725000",
                        "longitude": "5.06027000"
                    },
                    {
                        "id": 46396,
                        "name": "Saint-Parize-le-Châtel",
                        "latitude": "46.85447000",
                        "longitude": "3.18267000"
                    },
                    {
                        "id": 46449,
                        "name": "Saint-Pierre-le-Moûtier",
                        "latitude": "46.79277000",
                        "longitude": "3.11657000"
                    },
                    {
                        "id": 46508,
                        "name": "Saint-Rémy",
                        "latitude": "46.76334000",
                        "longitude": "4.83928000"
                    },
                    {
                        "id": 46530,
                        "name": "Saint-Sauveur",
                        "latitude": "47.80530000",
                        "longitude": "6.38583000"
                    },
                    {
                        "id": 46549,
                        "name": "Saint-Sernin-du-Bois",
                        "latitude": "46.84074000",
                        "longitude": "4.43271000"
                    },
                    {
                        "id": 46592,
                        "name": "Saint-Usage",
                        "latitude": "47.11009000",
                        "longitude": "5.26044000"
                    },
                    {
                        "id": 46593,
                        "name": "Saint-Usuge",
                        "latitude": "46.67900000",
                        "longitude": "5.25089000"
                    },
                    {
                        "id": 46601,
                        "name": "Saint-Valérien",
                        "latitude": "48.17805000",
                        "longitude": "3.09523000"
                    },
                    {
                        "id": 46598,
                        "name": "Saint-Vallier",
                        "latitude": "46.64107000",
                        "longitude": "4.37107000"
                    },
                    {
                        "id": 46619,
                        "name": "Saint-Vit",
                        "latitude": "47.18333000",
                        "longitude": "5.81667000"
                    },
                    {
                        "id": 46628,
                        "name": "Saint-Yan",
                        "latitude": "46.41147000",
                        "longitude": "4.03876000"
                    },
                    {
                        "id": 46730,
                        "name": "Sainte-Suzanne",
                        "latitude": "47.50017000",
                        "longitude": "6.76775000"
                    },
                    {
                        "id": 46742,
                        "name": "Salbert",
                        "latitude": "47.66959000",
                        "longitude": "6.81269000"
                    },
                    {
                        "id": 46755,
                        "name": "Salins-les-Bains",
                        "latitude": "46.94663000",
                        "longitude": "5.87763000"
                    },
                    {
                        "id": 46784,
                        "name": "Sancé",
                        "latitude": "46.33926000",
                        "longitude": "4.83049000"
                    },
                    {
                        "id": 46782,
                        "name": "Sancey-le-Grand",
                        "latitude": "47.29489000",
                        "longitude": "6.58287000"
                    },
                    {
                        "id": 46800,
                        "name": "Sanvignes-les-Mines",
                        "latitude": "46.66444000",
                        "longitude": "4.29188000"
                    },
                    {
                        "id": 46893,
                        "name": "Saône",
                        "latitude": "47.22311000",
                        "longitude": "6.11682000"
                    },
                    {
                        "id": 46826,
                        "name": "Sassenay",
                        "latitude": "46.83074000",
                        "longitude": "4.92523000"
                    },
                    {
                        "id": 46841,
                        "name": "Saulieu",
                        "latitude": "47.28023000",
                        "longitude": "4.22857000"
                    },
                    {
                        "id": 46866,
                        "name": "Sauvigny-les-Bois",
                        "latitude": "46.96676000",
                        "longitude": "3.27190000"
                    },
                    {
                        "id": 46881,
                        "name": "Savigny-lès-Beaune",
                        "latitude": "47.06357000",
                        "longitude": "4.81821000"
                    },
                    {
                        "id": 46896,
                        "name": "Scey-sur-Saône-et-Saint-Albin",
                        "latitude": "47.66398000",
                        "longitude": "5.97451000"
                    },
                    {
                        "id": 46918,
                        "name": "Seignelay",
                        "latitude": "47.90542000",
                        "longitude": "3.60136000"
                    },
                    {
                        "id": 46932,
                        "name": "Seloncourt",
                        "latitude": "47.45989000",
                        "longitude": "6.85535000"
                    },
                    {
                        "id": 46933,
                        "name": "Selongey",
                        "latitude": "47.58846000",
                        "longitude": "5.18483000"
                    },
                    {
                        "id": 46938,
                        "name": "Semur-en-Auxois",
                        "latitude": "47.48333000",
                        "longitude": "4.33333000"
                    },
                    {
                        "id": 46941,
                        "name": "Sennecey-le-Grand",
                        "latitude": "46.64137000",
                        "longitude": "4.86707000"
                    },
                    {
                        "id": 46942,
                        "name": "Sennecey-lès-Dijon",
                        "latitude": "47.28984000",
                        "longitude": "5.10485000"
                    },
                    {
                        "id": 46945,
                        "name": "Sens",
                        "latitude": "48.19738000",
                        "longitude": "3.28328000"
                    },
                    {
                        "id": 46954,
                        "name": "Sergines",
                        "latitude": "48.34203000",
                        "longitude": "3.26213000"
                    },
                    {
                        "id": 46958,
                        "name": "Sermoise-sur-Loire",
                        "latitude": "46.95000000",
                        "longitude": "3.18333000"
                    },
                    {
                        "id": 46965,
                        "name": "Serre-les-Sapins",
                        "latitude": "47.25000000",
                        "longitude": "5.93333000"
                    },
                    {
                        "id": 46978,
                        "name": "Seurre",
                        "latitude": "46.99923000",
                        "longitude": "5.15138000"
                    },
                    {
                        "id": 46980,
                        "name": "Sevrey",
                        "latitude": "46.73825000",
                        "longitude": "4.84030000"
                    },
                    {
                        "id": 47000,
                        "name": "Simandre",
                        "latitude": "46.62364000",
                        "longitude": "4.98777000"
                    },
                    {
                        "id": 47014,
                        "name": "Sochaux",
                        "latitude": "47.50808000",
                        "longitude": "6.82748000"
                    },
                    {
                        "id": 47049,
                        "name": "Sornay",
                        "latitude": "46.63023000",
                        "longitude": "5.17999000"
                    },
                    {
                        "id": 47061,
                        "name": "Soucy",
                        "latitude": "48.24956000",
                        "longitude": "3.32385000"
                    },
                    {
                        "id": 47156,
                        "name": "Taillecourt",
                        "latitude": "47.49521000",
                        "longitude": "6.85442000"
                    },
                    {
                        "id": 47161,
                        "name": "Talant",
                        "latitude": "47.33693000",
                        "longitude": "5.00888000"
                    },
                    {
                        "id": 47171,
                        "name": "Tanlay",
                        "latitude": "47.84488000",
                        "longitude": "4.08504000"
                    },
                    {
                        "id": 47190,
                        "name": "Tavaux",
                        "latitude": "47.03376000",
                        "longitude": "5.40500000"
                    },
                    {
                        "id": 47210,
                        "name": "Territoire de Belfort",
                        "latitude": "47.63578000",
                        "longitude": "6.88843000"
                    },
                    {
                        "id": 47238,
                        "name": "Thise",
                        "latitude": "47.28486000",
                        "longitude": "6.08127000"
                    },
                    {
                        "id": 47250,
                        "name": "Thorigny-sur-Oreuse",
                        "latitude": "48.29297000",
                        "longitude": "3.40128000"
                    },
                    {
                        "id": 47297,
                        "name": "Tonnerre",
                        "latitude": "47.85628000",
                        "longitude": "3.97369000"
                    },
                    {
                        "id": 47300,
                        "name": "Torcy",
                        "latitude": "46.76857000",
                        "longitude": "4.45333000"
                    },
                    {
                        "id": 47307,
                        "name": "Toucy",
                        "latitude": "47.73602000",
                        "longitude": "3.29502000"
                    },
                    {
                        "id": 47314,
                        "name": "Toulon-sur-Arroux",
                        "latitude": "46.69345000",
                        "longitude": "4.13869000"
                    },
                    {
                        "id": 47329,
                        "name": "Tournus",
                        "latitude": "46.56758000",
                        "longitude": "4.90574000"
                    },
                    {
                        "id": 47436,
                        "name": "Urzy",
                        "latitude": "47.04877000",
                        "longitude": "3.20295000"
                    },
                    {
                        "id": 47460,
                        "name": "Vaivre-et-Montoille",
                        "latitude": "47.63021000",
                        "longitude": "6.10362000"
                    },
                    {
                        "id": 47468,
                        "name": "Valdahon",
                        "latitude": "47.15000000",
                        "longitude": "6.35000000"
                    },
                    {
                        "id": 47469,
                        "name": "Valdoie",
                        "latitude": "47.67041000",
                        "longitude": "6.84203000"
                    },
                    {
                        "id": 47477,
                        "name": "Valentigney",
                        "latitude": "47.46388000",
                        "longitude": "6.83168000"
                    },
                    {
                        "id": 47482,
                        "name": "Valfin-lès-Saint-Claude",
                        "latitude": "46.43758000",
                        "longitude": "5.85513000"
                    },
                    {
                        "id": 47513,
                        "name": "Varennes-le-Grand",
                        "latitude": "46.71868000",
                        "longitude": "4.86872000"
                    },
                    {
                        "id": 47511,
                        "name": "Varennes-Saint-Sauveur",
                        "latitude": "46.48226000",
                        "longitude": "5.24349000"
                    },
                    {
                        "id": 47512,
                        "name": "Varennes-Vauzelles",
                        "latitude": "47.01678000",
                        "longitude": "3.14037000"
                    },
                    {
                        "id": 47519,
                        "name": "Varois-et-Chaignot",
                        "latitude": "47.35059000",
                        "longitude": "5.12838000"
                    },
                    {
                        "id": 47523,
                        "name": "Varzy",
                        "latitude": "47.35810000",
                        "longitude": "3.38619000"
                    },
                    {
                        "id": 47559,
                        "name": "Velars-sur-Ouche",
                        "latitude": "47.31960000",
                        "longitude": "4.90594000"
                    },
                    {
                        "id": 47563,
                        "name": "Venarey-les-Laumes",
                        "latitude": "47.54202000",
                        "longitude": "4.46022000"
                    },
                    {
                        "id": 47586,
                        "name": "Venoy",
                        "latitude": "47.80518000",
                        "longitude": "3.63695000"
                    },
                    {
                        "id": 47592,
                        "name": "Vercel-Villedieu-le-Camp",
                        "latitude": "47.18318000",
                        "longitude": "6.40082000"
                    },
                    {
                        "id": 47595,
                        "name": "Verdun-sur-le-Doubs",
                        "latitude": "46.89692000",
                        "longitude": "5.02127000"
                    },
                    {
                        "id": 47598,
                        "name": "Vergigny",
                        "latitude": "47.97059000",
                        "longitude": "3.71861000"
                    },
                    {
                        "id": 47605,
                        "name": "Vermenton",
                        "latitude": "47.66459000",
                        "longitude": "3.73501000"
                    },
                    {
                        "id": 47930,
                        "name": "Véron",
                        "latitude": "48.12853000",
                        "longitude": "3.30773000"
                    },
                    {
                        "id": 47648,
                        "name": "Vesoul",
                        "latitude": "47.62604000",
                        "longitude": "6.14251000"
                    },
                    {
                        "id": 47689,
                        "name": "Vieux-Charmont",
                        "latitude": "47.52190000",
                        "longitude": "6.83738000"
                    },
                    {
                        "id": 47723,
                        "name": "Villeblevin",
                        "latitude": "48.32446000",
                        "longitude": "3.08038000"
                    },
                    {
                        "id": 47774,
                        "name": "Villeneuve-la-Guyard",
                        "latitude": "48.34093000",
                        "longitude": "3.06176000"
                    },
                    {
                        "id": 47785,
                        "name": "Villeneuve-sur-Yonne",
                        "latitude": "48.08247000",
                        "longitude": "3.29688000"
                    },
                    {
                        "id": 47805,
                        "name": "Villers-le-Lac",
                        "latitude": "47.06319000",
                        "longitude": "6.66699000"
                    },
                    {
                        "id": 47811,
                        "name": "Villersexel",
                        "latitude": "47.55070000",
                        "longitude": "6.43273000"
                    },
                    {
                        "id": 47848,
                        "name": "Vinneuf",
                        "latitude": "48.34795000",
                        "longitude": "3.14013000"
                    },
                    {
                        "id": 47860,
                        "name": "Virey-le-Grand",
                        "latitude": "46.83333000",
                        "longitude": "4.86667000"
                    },
                    {
                        "id": 47877,
                        "name": "Vitteaux",
                        "latitude": "47.39732000",
                        "longitude": "4.54190000"
                    },
                    {
                        "id": 47907,
                        "name": "Voujeaucourt",
                        "latitude": "47.47513000",
                        "longitude": "6.77431000"
                    }
                ]
            },
            {
                "id": 4807,
                "name": "Bretagne",
                "iso2": "BRE",
                "latitude": "48.20204710",
                "longitude": "-2.93264350",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39254,
                        "name": "Acigné",
                        "latitude": "48.13333000",
                        "longitude": "-1.53704000"
                    },
                    {
                        "id": 39318,
                        "name": "Allaire",
                        "latitude": "47.63752000",
                        "longitude": "-2.16324000"
                    },
                    {
                        "id": 39345,
                        "name": "Amanlis",
                        "latitude": "48.00752000",
                        "longitude": "-1.47677000"
                    },
                    {
                        "id": 39356,
                        "name": "Ambon",
                        "latitude": "47.55367000",
                        "longitude": "-2.55512000"
                    },
                    {
                        "id": 39436,
                        "name": "Antrain",
                        "latitude": "48.46031000",
                        "longitude": "-1.48354000"
                    },
                    {
                        "id": 39485,
                        "name": "Argentré-du-Plessis",
                        "latitude": "48.05697000",
                        "longitude": "-1.14601000"
                    },
                    {
                        "id": 39510,
                        "name": "Arradon",
                        "latitude": "47.62709000",
                        "longitude": "-2.82150000"
                    },
                    {
                        "id": 39534,
                        "name": "Arzano",
                        "latitude": "47.90136000",
                        "longitude": "-3.44032000"
                    },
                    {
                        "id": 39536,
                        "name": "Arzon",
                        "latitude": "47.54852000",
                        "longitude": "-2.88989000"
                    },
                    {
                        "id": 39597,
                        "name": "Audierne",
                        "latitude": "48.01640000",
                        "longitude": "-4.53838000"
                    },
                    {
                        "id": 39604,
                        "name": "Augan",
                        "latitude": "47.91943000",
                        "longitude": "-2.27905000"
                    },
                    {
                        "id": 39623,
                        "name": "Auray",
                        "latitude": "47.67025000",
                        "longitude": "-2.99183000"
                    },
                    {
                        "id": 39703,
                        "name": "Baden",
                        "latitude": "47.61734000",
                        "longitude": "-2.91987000"
                    },
                    {
                        "id": 39716,
                        "name": "Baguer-Morvan",
                        "latitude": "48.52531000",
                        "longitude": "-1.77332000"
                    },
                    {
                        "id": 39717,
                        "name": "Baguer-Pican",
                        "latitude": "48.55253000",
                        "longitude": "-1.69837000"
                    },
                    {
                        "id": 39732,
                        "name": "Bain-de-Bretagne",
                        "latitude": "47.84418000",
                        "longitude": "-1.68486000"
                    },
                    {
                        "id": 39736,
                        "name": "Bains-sur-Oust",
                        "latitude": "47.70362000",
                        "longitude": "-2.07047000"
                    },
                    {
                        "id": 39738,
                        "name": "Bais",
                        "latitude": "48.00959000",
                        "longitude": "-1.28983000"
                    },
                    {
                        "id": 39747,
                        "name": "Balazé",
                        "latitude": "48.16797000",
                        "longitude": "-1.19157000"
                    },
                    {
                        "id": 39760,
                        "name": "Bannalec",
                        "latitude": "47.93229000",
                        "longitude": "-3.69759000"
                    },
                    {
                        "id": 39808,
                        "name": "Baud",
                        "latitude": "47.87474000",
                        "longitude": "-3.01760000"
                    },
                    {
                        "id": 39813,
                        "name": "Baulon",
                        "latitude": "47.98590000",
                        "longitude": "-1.93114000"
                    },
                    {
                        "id": 39834,
                        "name": "Bazouges-la-Pérouse",
                        "latitude": "48.42606000",
                        "longitude": "-1.57431000"
                    },
                    {
                        "id": 39844,
                        "name": "Beaucé",
                        "latitude": "48.33890000",
                        "longitude": "-1.15804000"
                    },
                    {
                        "id": 40415,
                        "name": "Bédée",
                        "latitude": "48.17953000",
                        "longitude": "-1.94477000"
                    },
                    {
                        "id": 40417,
                        "name": "Béganne",
                        "latitude": "47.59670000",
                        "longitude": "-2.24162000"
                    },
                    {
                        "id": 40418,
                        "name": "Bégard",
                        "latitude": "48.62754000",
                        "longitude": "-3.30067000"
                    },
                    {
                        "id": 39900,
                        "name": "Beignon",
                        "latitude": "47.97200000",
                        "longitude": "-2.16933000"
                    },
                    {
                        "id": 39910,
                        "name": "Belle-Isle-en-Terre",
                        "latitude": "48.54478000",
                        "longitude": "-3.39500000"
                    },
                    {
                        "id": 39937,
                        "name": "Belz",
                        "latitude": "47.67506000",
                        "longitude": "-3.16800000"
                    },
                    {
                        "id": 40425,
                        "name": "Bénodet",
                        "latitude": "47.87531000",
                        "longitude": "-4.10580000"
                    },
                    {
                        "id": 39958,
                        "name": "Berné",
                        "latitude": "47.99470000",
                        "longitude": "-3.39421000"
                    },
                    {
                        "id": 39961,
                        "name": "Berric",
                        "latitude": "47.63326000",
                        "longitude": "-2.52250000"
                    },
                    {
                        "id": 39962,
                        "name": "Berrien",
                        "latitude": "48.40278000",
                        "longitude": "-3.75266000"
                    },
                    {
                        "id": 39987,
                        "name": "Betton",
                        "latitude": "48.18048000",
                        "longitude": "-1.63829000"
                    },
                    {
                        "id": 39994,
                        "name": "Beuzec-Cap-Sizun",
                        "latitude": "48.07567000",
                        "longitude": "-4.51200000"
                    },
                    {
                        "id": 40016,
                        "name": "Bignan",
                        "latitude": "47.87935000",
                        "longitude": "-2.77153000"
                    },
                    {
                        "id": 40026,
                        "name": "Binic",
                        "latitude": "48.60074000",
                        "longitude": "-2.82602000"
                    },
                    {
                        "id": 40078,
                        "name": "Bodilis",
                        "latitude": "48.52978000",
                        "longitude": "-4.11567000"
                    },
                    {
                        "id": 40082,
                        "name": "Bohars",
                        "latitude": "48.42983000",
                        "longitude": "-4.51292000"
                    },
                    {
                        "id": 40092,
                        "name": "Boisgervilly",
                        "latitude": "48.16692000",
                        "longitude": "-2.06426000"
                    },
                    {
                        "id": 40120,
                        "name": "Bonnemain",
                        "latitude": "48.46652000",
                        "longitude": "-1.76774000"
                    },
                    {
                        "id": 40182,
                        "name": "Bourbriac",
                        "latitude": "48.47384000",
                        "longitude": "-3.18758000"
                    },
                    {
                        "id": 40188,
                        "name": "Bourg-Blanc",
                        "latitude": "48.49867000",
                        "longitude": "-4.50406000"
                    },
                    {
                        "id": 40193,
                        "name": "Bourg-des-Comptes",
                        "latitude": "47.92934000",
                        "longitude": "-1.74534000"
                    },
                    {
                        "id": 40198,
                        "name": "Bourgbarré",
                        "latitude": "47.99515000",
                        "longitude": "-1.61419000"
                    },
                    {
                        "id": 40253,
                        "name": "Brandérion",
                        "latitude": "47.79412000",
                        "longitude": "-3.19474000"
                    },
                    {
                        "id": 40260,
                        "name": "Brasparts",
                        "latitude": "48.30167000",
                        "longitude": "-3.95516000"
                    },
                    {
                        "id": 40354,
                        "name": "Bréal-sous-Montfort",
                        "latitude": "48.04876000",
                        "longitude": "-1.86438000"
                    },
                    {
                        "id": 40357,
                        "name": "Brécé",
                        "latitude": "48.10839000",
                        "longitude": "-1.48086000"
                    },
                    {
                        "id": 40272,
                        "name": "Brech",
                        "latitude": "47.72134000",
                        "longitude": "-2.99862000"
                    },
                    {
                        "id": 40359,
                        "name": "Bréhand",
                        "latitude": "48.40333000",
                        "longitude": "-2.57412000"
                    },
                    {
                        "id": 40279,
                        "name": "Brest",
                        "latitude": "48.39029000",
                        "longitude": "-4.48628000"
                    },
                    {
                        "id": 40280,
                        "name": "Breteil",
                        "latitude": "48.14534000",
                        "longitude": "-1.89886000"
                    },
                    {
                        "id": 40307,
                        "name": "Briec",
                        "latitude": "48.10167000",
                        "longitude": "-3.99833000"
                    },
                    {
                        "id": 40333,
                        "name": "Broons",
                        "latitude": "48.31748000",
                        "longitude": "-2.25952000"
                    },
                    {
                        "id": 40352,
                        "name": "Bruz",
                        "latitude": "48.02420000",
                        "longitude": "-1.74591000"
                    },
                    {
                        "id": 40367,
                        "name": "Bubry",
                        "latitude": "47.96336000",
                        "longitude": "-3.17108000"
                    },
                    {
                        "id": 40452,
                        "name": "Caden",
                        "latitude": "47.63124000",
                        "longitude": "-2.28704000"
                    },
                    {
                        "id": 40471,
                        "name": "Callac",
                        "latitude": "48.40292000",
                        "longitude": "-3.42800000"
                    },
                    {
                        "id": 40482,
                        "name": "Camaret-sur-Mer",
                        "latitude": "48.27497000",
                        "longitude": "-4.59615000"
                    },
                    {
                        "id": 40495,
                        "name": "Camors",
                        "latitude": "47.84739000",
                        "longitude": "-2.99981000"
                    },
                    {
                        "id": 40503,
                        "name": "Campénéac",
                        "latitude": "47.95733000",
                        "longitude": "-2.29277000"
                    },
                    {
                        "id": 40504,
                        "name": "Cancale",
                        "latitude": "48.67601000",
                        "longitude": "-1.85231000"
                    },
                    {
                        "id": 40535,
                        "name": "Carantec",
                        "latitude": "48.66811000",
                        "longitude": "-3.91545000"
                    },
                    {
                        "id": 40542,
                        "name": "Carentoir",
                        "latitude": "47.81667000",
                        "longitude": "-2.13333000"
                    },
                    {
                        "id": 40544,
                        "name": "Carhaix-Plouguer",
                        "latitude": "48.27594000",
                        "longitude": "-3.57326000"
                    },
                    {
                        "id": 40550,
                        "name": "Carnac",
                        "latitude": "47.58351000",
                        "longitude": "-3.07884000"
                    },
                    {
                        "id": 40553,
                        "name": "Caro",
                        "latitude": "47.86429000",
                        "longitude": "-2.31924000"
                    },
                    {
                        "id": 40573,
                        "name": "Cast",
                        "latitude": "48.15712000",
                        "longitude": "-4.13889000"
                    },
                    {
                        "id": 40601,
                        "name": "Caudan",
                        "latitude": "47.80877000",
                        "longitude": "-3.34250000"
                    },
                    {
                        "id": 40606,
                        "name": "Caulnes",
                        "latitude": "48.28804000",
                        "longitude": "-2.15518000"
                    },
                    {
                        "id": 40619,
                        "name": "Cavan",
                        "latitude": "48.67242000",
                        "longitude": "-3.34606000"
                    },
                    {
                        "id": 40661,
                        "name": "Cesson-Sévigné",
                        "latitude": "48.12120000",
                        "longitude": "-1.60300000"
                    },
                    {
                        "id": 40770,
                        "name": "Chanteloup",
                        "latitude": "47.96574000",
                        "longitude": "-1.61517000"
                    },
                    {
                        "id": 40774,
                        "name": "Chantepie",
                        "latitude": "48.08885000",
                        "longitude": "-1.61524000"
                    },
                    {
                        "id": 40820,
                        "name": "Chartres-de-Bretagne",
                        "latitude": "48.03924000",
                        "longitude": "-1.70533000"
                    },
                    {
                        "id": 40823,
                        "name": "Chasné-sur-Illet",
                        "latitude": "48.24247000",
                        "longitude": "-1.56138000"
                    },
                    {
                        "id": 40951,
                        "name": "Châteaubourg",
                        "latitude": "48.11119000",
                        "longitude": "-1.40019000"
                    },
                    {
                        "id": 40956,
                        "name": "Châteaugiron",
                        "latitude": "48.04629000",
                        "longitude": "-1.50438000"
                    },
                    {
                        "id": 40957,
                        "name": "Châteaulin",
                        "latitude": "48.19677000",
                        "longitude": "-4.09008000"
                    },
                    {
                        "id": 40966,
                        "name": "Châteauneuf-d’Ille-et-Vilaine",
                        "latitude": "48.56083000",
                        "longitude": "-1.92838000"
                    },
                    {
                        "id": 40963,
                        "name": "Châteauneuf-du-Faou",
                        "latitude": "48.18755000",
                        "longitude": "-3.81789000"
                    },
                    {
                        "id": 40996,
                        "name": "Châtillon-en-Vendelais",
                        "latitude": "48.22409000",
                        "longitude": "-1.17695000"
                    },
                    {
                        "id": 41004,
                        "name": "Châtillon-sur-Seiche",
                        "latitude": "48.03448000",
                        "longitude": "-1.67114000"
                    },
                    {
                        "id": 40855,
                        "name": "Chavagne",
                        "latitude": "48.05438000",
                        "longitude": "-1.78571000"
                    },
                    {
                        "id": 40884,
                        "name": "Cherrueix",
                        "latitude": "48.60629000",
                        "longitude": "-1.70405000"
                    },
                    {
                        "id": 40891,
                        "name": "Chevaigné",
                        "latitude": "48.21153000",
                        "longitude": "-1.62933000"
                    },
                    {
                        "id": 41024,
                        "name": "Cintré",
                        "latitude": "48.10504000",
                        "longitude": "-1.87162000"
                    },
                    {
                        "id": 41067,
                        "name": "Cléden-Poher",
                        "latitude": "48.23644000",
                        "longitude": "-3.66911000"
                    },
                    {
                        "id": 41068,
                        "name": "Cléder",
                        "latitude": "48.66300000",
                        "longitude": "-4.10200000"
                    },
                    {
                        "id": 41069,
                        "name": "Cléguer",
                        "latitude": "47.85407000",
                        "longitude": "-3.38219000"
                    },
                    {
                        "id": 41070,
                        "name": "Cléguérec",
                        "latitude": "48.12577000",
                        "longitude": "-3.07162000"
                    },
                    {
                        "id": 41057,
                        "name": "Clohars-Carnoët",
                        "latitude": "47.79606000",
                        "longitude": "-3.58502000"
                    },
                    {
                        "id": 41058,
                        "name": "Clohars-Fouesnant",
                        "latitude": "47.89657000",
                        "longitude": "-4.06396000"
                    },
                    {
                        "id": 41291,
                        "name": "Coësmes",
                        "latitude": "47.88325000",
                        "longitude": "-1.44074000"
                    },
                    {
                        "id": 41292,
                        "name": "Coëtmieux",
                        "latitude": "48.49117000",
                        "longitude": "-2.60067000"
                    },
                    {
                        "id": 41107,
                        "name": "Colpo",
                        "latitude": "47.81778000",
                        "longitude": "-2.81002000"
                    },
                    {
                        "id": 41110,
                        "name": "Combourg",
                        "latitude": "48.41267000",
                        "longitude": "-1.74424000"
                    },
                    {
                        "id": 41112,
                        "name": "Combrit",
                        "latitude": "47.88734000",
                        "longitude": "-4.15817000"
                    },
                    {
                        "id": 41127,
                        "name": "Concarneau",
                        "latitude": "47.87502000",
                        "longitude": "-3.92245000"
                    },
                    {
                        "id": 41160,
                        "name": "Coray",
                        "latitude": "48.05934000",
                        "longitude": "-3.83056000"
                    },
                    {
                        "id": 41177,
                        "name": "Corlay",
                        "latitude": "48.31725000",
                        "longitude": "-3.05733000"
                    },
                    {
                        "id": 41200,
                        "name": "Corps-Nuds",
                        "latitude": "47.97915000",
                        "longitude": "-1.58409000"
                    },
                    {
                        "id": 41204,
                        "name": "Corseul",
                        "latitude": "48.48180000",
                        "longitude": "-2.16947000"
                    },
                    {
                        "id": 41294,
                        "name": "Crach",
                        "latitude": "47.61700000",
                        "longitude": "-3.00170000"
                    },
                    {
                        "id": 41343,
                        "name": "Crédin",
                        "latitude": "48.03462000",
                        "longitude": "-2.76630000"
                    },
                    {
                        "id": 41346,
                        "name": "Créhen",
                        "latitude": "48.54546000",
                        "longitude": "-2.21307000"
                    },
                    {
                        "id": 41314,
                        "name": "Crevin",
                        "latitude": "47.93333000",
                        "longitude": "-1.66667000"
                    },
                    {
                        "id": 41334,
                        "name": "Crozon",
                        "latitude": "48.24643000",
                        "longitude": "-4.48993000"
                    },
                    {
                        "id": 41412,
                        "name": "Damgan",
                        "latitude": "47.51799000",
                        "longitude": "-2.57698000"
                    },
                    {
                        "id": 41431,
                        "name": "Daoulas",
                        "latitude": "48.36089000",
                        "longitude": "-4.25977000"
                    },
                    {
                        "id": 41604,
                        "name": "Département d'Ille-et-Vilaine",
                        "latitude": "48.16667000",
                        "longitude": "-1.50000000"
                    },
                    {
                        "id": 41635,
                        "name": "Département des Côtes-d’Armor",
                        "latitude": "48.34295000",
                        "longitude": "-2.78216000"
                    },
                    {
                        "id": 41640,
                        "name": "Département du Finistère",
                        "latitude": "48.25224000",
                        "longitude": "-3.99263000"
                    },
                    {
                        "id": 41482,
                        "name": "Dinan",
                        "latitude": "48.45551000",
                        "longitude": "-2.05019000"
                    },
                    {
                        "id": 41483,
                        "name": "Dinard",
                        "latitude": "48.63143000",
                        "longitude": "-2.06144000"
                    },
                    {
                        "id": 41488,
                        "name": "Dinéault",
                        "latitude": "48.21922000",
                        "longitude": "-4.16411000"
                    },
                    {
                        "id": 41486,
                        "name": "Dingé",
                        "latitude": "48.35702000",
                        "longitude": "-1.71489000"
                    },
                    {
                        "id": 41491,
                        "name": "Dirinon",
                        "latitude": "48.39775000",
                        "longitude": "-4.27017000"
                    },
                    {
                        "id": 41503,
                        "name": "Dol-de-Bretagne",
                        "latitude": "48.54765000",
                        "longitude": "-1.75018000"
                    },
                    {
                        "id": 41509,
                        "name": "Domagné",
                        "latitude": "48.07081000",
                        "longitude": "-1.39291000"
                    },
                    {
                        "id": 41510,
                        "name": "Domalain",
                        "latitude": "47.99617000",
                        "longitude": "-1.24250000"
                    },
                    {
                        "id": 41546,
                        "name": "Douarnenez",
                        "latitude": "48.09542000",
                        "longitude": "-4.32904000"
                    },
                    {
                        "id": 41659,
                        "name": "Edern",
                        "latitude": "48.10000000",
                        "longitude": "-3.98333000"
                    },
                    {
                        "id": 41663,
                        "name": "Elliant",
                        "latitude": "47.99417000",
                        "longitude": "-3.88966000"
                    },
                    {
                        "id": 41665,
                        "name": "Elven",
                        "latitude": "47.73230000",
                        "longitude": "-2.58956000"
                    },
                    {
                        "id": 41687,
                        "name": "Epiniac",
                        "latitude": "48.50000000",
                        "longitude": "-1.70000000"
                    },
                    {
                        "id": 41690,
                        "name": "Erbrée",
                        "latitude": "48.09745000",
                        "longitude": "-1.12479000"
                    },
                    {
                        "id": 41692,
                        "name": "Ercé-en-Lamée",
                        "latitude": "47.83048000",
                        "longitude": "-1.55867000"
                    },
                    {
                        "id": 41693,
                        "name": "Ercé-près-Liffré",
                        "latitude": "48.25454000",
                        "longitude": "-1.51560000"
                    },
                    {
                        "id": 41694,
                        "name": "Erdeven",
                        "latitude": "47.64210000",
                        "longitude": "-3.15706000"
                    },
                    {
                        "id": 41695,
                        "name": "Ergué-Gabéric",
                        "latitude": "47.99562000",
                        "longitude": "-4.02223000"
                    },
                    {
                        "id": 41700,
                        "name": "Erquy",
                        "latitude": "48.63186000",
                        "longitude": "-2.46280000"
                    },
                    {
                        "id": 41722,
                        "name": "Esquibien",
                        "latitude": "48.02506000",
                        "longitude": "-4.56139000"
                    },
                    {
                        "id": 48090,
                        "name": "Étables-sur-Mer",
                        "latitude": "48.63333000",
                        "longitude": "-2.83333000"
                    },
                    {
                        "id": 48101,
                        "name": "Étel",
                        "latitude": "47.65614000",
                        "longitude": "-3.20018000"
                    },
                    {
                        "id": 48108,
                        "name": "Étrelles",
                        "latitude": "48.06031000",
                        "longitude": "-1.19402000"
                    },
                    {
                        "id": 48121,
                        "name": "Évran",
                        "latitude": "48.37987000",
                        "longitude": "-1.98076000"
                    },
                    {
                        "id": 42004,
                        "name": "Férel",
                        "latitude": "47.48203000",
                        "longitude": "-2.34227000"
                    },
                    {
                        "id": 41923,
                        "name": "Fouesnant",
                        "latitude": "47.89187000",
                        "longitude": "-4.01484000"
                    },
                    {
                        "id": 41927,
                        "name": "Fougères",
                        "latitude": "48.35185000",
                        "longitude": "-1.19989000"
                    },
                    {
                        "id": 41928,
                        "name": "Fouillard",
                        "latitude": "48.15820000",
                        "longitude": "-1.57915000"
                    },
                    {
                        "id": 41983,
                        "name": "Fréhel",
                        "latitude": "48.63333000",
                        "longitude": "-2.36667000"
                    },
                    {
                        "id": 42057,
                        "name": "Gaël",
                        "latitude": "48.13209000",
                        "longitude": "-2.22267000"
                    },
                    {
                        "id": 42079,
                        "name": "Gestel",
                        "latitude": "47.80361000",
                        "longitude": "-3.44245000"
                    },
                    {
                        "id": 42301,
                        "name": "Gévezé",
                        "latitude": "48.21933000",
                        "longitude": "-1.78952000"
                    },
                    {
                        "id": 42114,
                        "name": "Glomel",
                        "latitude": "48.22300000",
                        "longitude": "-3.39696000"
                    },
                    {
                        "id": 42141,
                        "name": "Gosné",
                        "latitude": "48.24674000",
                        "longitude": "-1.46558000"
                    },
                    {
                        "id": 42143,
                        "name": "Gouarec",
                        "latitude": "48.22725000",
                        "longitude": "-3.17994000"
                    },
                    {
                        "id": 42145,
                        "name": "Goudelin",
                        "latitude": "48.60375000",
                        "longitude": "-3.01842000"
                    },
                    {
                        "id": 42146,
                        "name": "Gouesnach",
                        "latitude": "47.91040000",
                        "longitude": "-4.11450000"
                    },
                    {
                        "id": 42147,
                        "name": "Gouesnou",
                        "latitude": "48.45267000",
                        "longitude": "-4.46456000"
                    },
                    {
                        "id": 42161,
                        "name": "Gouézec",
                        "latitude": "48.16911000",
                        "longitude": "-3.97277000"
                    },
                    {
                        "id": 42151,
                        "name": "Gourin",
                        "latitude": "48.13866000",
                        "longitude": "-3.60755000"
                    },
                    {
                        "id": 42162,
                        "name": "Goven",
                        "latitude": "48.00638000",
                        "longitude": "-1.84629000"
                    },
                    {
                        "id": 42232,
                        "name": "Grâces",
                        "latitude": "48.55651000",
                        "longitude": "-3.18533000"
                    },
                    {
                        "id": 42170,
                        "name": "Grand-Champ",
                        "latitude": "47.75804000",
                        "longitude": "-2.84635000"
                    },
                    {
                        "id": 42174,
                        "name": "Grand-Fougeray",
                        "latitude": "47.72390000",
                        "longitude": "-1.73210000"
                    },
                    {
                        "id": 42221,
                        "name": "Groix",
                        "latitude": "47.63887000",
                        "longitude": "-3.45430000"
                    },
                    {
                        "id": 42278,
                        "name": "Guégon",
                        "latitude": "47.93707000",
                        "longitude": "-2.56450000"
                    },
                    {
                        "id": 42281,
                        "name": "Guémené-sur-Scorff",
                        "latitude": "48.06667000",
                        "longitude": "-3.20000000"
                    },
                    {
                        "id": 42240,
                        "name": "Guengat",
                        "latitude": "48.04193000",
                        "longitude": "-4.20470000"
                    },
                    {
                        "id": 42283,
                        "name": "Guénin",
                        "latitude": "47.90757000",
                        "longitude": "-2.97941000"
                    },
                    {
                        "id": 42242,
                        "name": "Guer",
                        "latitude": "47.90619000",
                        "longitude": "-2.12314000"
                    },
                    {
                        "id": 42243,
                        "name": "Guerlesquin",
                        "latitude": "48.51758000",
                        "longitude": "-3.58583000"
                    },
                    {
                        "id": 42245,
                        "name": "Guern",
                        "latitude": "48.02964000",
                        "longitude": "-3.09145000"
                    },
                    {
                        "id": 42252,
                        "name": "Guichen",
                        "latitude": "47.96762000",
                        "longitude": "-1.79534000"
                    },
                    {
                        "id": 42253,
                        "name": "Guiclan",
                        "latitude": "48.54967000",
                        "longitude": "-3.96211000"
                    },
                    {
                        "id": 42254,
                        "name": "Guidel-Plage",
                        "latitude": "47.76768000",
                        "longitude": "-3.52180000"
                    },
                    {
                        "id": 42255,
                        "name": "Guignen",
                        "latitude": "47.92009000",
                        "longitude": "-1.86161000"
                    },
                    {
                        "id": 42258,
                        "name": "Guilers",
                        "latitude": "48.42545000",
                        "longitude": "-4.55801000"
                    },
                    {
                        "id": 42260,
                        "name": "Guillac",
                        "latitude": "47.91096000",
                        "longitude": "-2.46571000"
                    },
                    {
                        "id": 42262,
                        "name": "Guilliers",
                        "latitude": "48.04286000",
                        "longitude": "-2.40562000"
                    },
                    {
                        "id": 42263,
                        "name": "Guilvinec",
                        "latitude": "47.79861000",
                        "longitude": "-4.28111000"
                    },
                    {
                        "id": 42264,
                        "name": "Guingamp",
                        "latitude": "48.56251000",
                        "longitude": "-3.15096000"
                    },
                    {
                        "id": 42265,
                        "name": "Guipavas",
                        "latitude": "48.43522000",
                        "longitude": "-4.39722000"
                    },
                    {
                        "id": 42266,
                        "name": "Guipel",
                        "latitude": "48.29937000",
                        "longitude": "-1.71866000"
                    },
                    {
                        "id": 42267,
                        "name": "Guipry",
                        "latitude": "47.82637000",
                        "longitude": "-1.84218000"
                    },
                    {
                        "id": 42269,
                        "name": "Guiscriff",
                        "latitude": "48.04944000",
                        "longitude": "-3.64356000"
                    },
                    {
                        "id": 42271,
                        "name": "Guissény",
                        "latitude": "48.63292000",
                        "longitude": "-4.40884000"
                    },
                    {
                        "id": 42324,
                        "name": "Hanvec",
                        "latitude": "48.32692000",
                        "longitude": "-4.15951000"
                    },
                    {
                        "id": 42449,
                        "name": "Hédé-Bazouges",
                        "latitude": "48.30000000",
                        "longitude": "-1.80000000"
                    },
                    {
                        "id": 42452,
                        "name": "Hénanbihen",
                        "latitude": "48.56072000",
                        "longitude": "-2.37602000"
                    },
                    {
                        "id": 42368,
                        "name": "Hennebont",
                        "latitude": "47.80512000",
                        "longitude": "-3.27337000"
                    },
                    {
                        "id": 42454,
                        "name": "Hénon",
                        "latitude": "48.38433000",
                        "longitude": "-2.68334000"
                    },
                    {
                        "id": 42370,
                        "name": "Henvic",
                        "latitude": "48.63256000",
                        "longitude": "-3.92623000"
                    },
                    {
                        "id": 42395,
                        "name": "Hillion",
                        "latitude": "48.51429000",
                        "longitude": "-2.66634000"
                    },
                    {
                        "id": 42400,
                        "name": "Hirel",
                        "latitude": "48.60502000",
                        "longitude": "-1.80224000"
                    },
                    {
                        "id": 42466,
                        "name": "Hôpital-Camfrout",
                        "latitude": "48.32789000",
                        "longitude": "-4.24155000"
                    },
                    {
                        "id": 42435,
                        "name": "Huelgoat",
                        "latitude": "48.36111000",
                        "longitude": "-3.74578000"
                    },
                    {
                        "id": 42471,
                        "name": "Iffendic",
                        "latitude": "48.12981000",
                        "longitude": "-2.03486000"
                    },
                    {
                        "id": 42490,
                        "name": "Inguiniel",
                        "latitude": "47.97658000",
                        "longitude": "-3.28072000"
                    },
                    {
                        "id": 42495,
                        "name": "Irodouër",
                        "latitude": "48.24932000",
                        "longitude": "-1.94959000"
                    },
                    {
                        "id": 42496,
                        "name": "Irvillac",
                        "latitude": "48.37011000",
                        "longitude": "-4.21223000"
                    },
                    {
                        "id": 42529,
                        "name": "Janzé",
                        "latitude": "47.95915000",
                        "longitude": "-1.49829000"
                    },
                    {
                        "id": 42544,
                        "name": "Javené",
                        "latitude": "48.31933000",
                        "longitude": "-1.21630000"
                    },
                    {
                        "id": 42564,
                        "name": "Josselin",
                        "latitude": "47.95720000",
                        "longitude": "-2.54713000"
                    },
                    {
                        "id": 42581,
                        "name": "Jugon-les-Lacs",
                        "latitude": "48.41667000",
                        "longitude": "-2.33333000"
                    },
                    {
                        "id": 42608,
                        "name": "Kerlouan",
                        "latitude": "48.64500000",
                        "longitude": "-4.36556000"
                    },
                    {
                        "id": 42609,
                        "name": "Kernilis",
                        "latitude": "48.57075000",
                        "longitude": "-4.41800000"
                    },
                    {
                        "id": 42610,
                        "name": "Kersaint-Plabennec",
                        "latitude": "48.47166000",
                        "longitude": "-4.37233000"
                    },
                    {
                        "id": 42612,
                        "name": "Kervignac",
                        "latitude": "47.76289000",
                        "longitude": "-3.23778000"
                    },
                    {
                        "id": 42652,
                        "name": "La Bouëxière",
                        "latitude": "48.18333000",
                        "longitude": "-1.43333000"
                    },
                    {
                        "id": 42651,
                        "name": "La Boussac",
                        "latitude": "48.51260000",
                        "longitude": "-1.66088000"
                    },
                    {
                        "id": 42693,
                        "name": "La Chapelle-des-Fougeretz",
                        "latitude": "48.17705000",
                        "longitude": "-1.73143000"
                    },
                    {
                        "id": 42681,
                        "name": "La Chapelle-Janson",
                        "latitude": "48.34775000",
                        "longitude": "-1.10209000"
                    },
                    {
                        "id": 42690,
                        "name": "La Chapelle-Thouarault",
                        "latitude": "48.12486000",
                        "longitude": "-1.86619000"
                    },
                    {
                        "id": 42731,
                        "name": "La Dominelais",
                        "latitude": "47.76229000",
                        "longitude": "-1.68819000"
                    },
                    {
                        "id": 42750,
                        "name": "La Forest-Landerneau",
                        "latitude": "48.42589000",
                        "longitude": "-4.31578000"
                    },
                    {
                        "id": 42751,
                        "name": "La Forêt-Fouesnant",
                        "latitude": "47.91010000",
                        "longitude": "-3.97858000"
                    },
                    {
                        "id": 42757,
                        "name": "La Fresnais",
                        "latitude": "48.59478000",
                        "longitude": "-1.84186000"
                    },
                    {
                        "id": 42760,
                        "name": "La Gacilly",
                        "latitude": "47.76562000",
                        "longitude": "-2.13220000"
                    },
                    {
                        "id": 42770,
                        "name": "La Gouesnière",
                        "latitude": "48.60467000",
                        "longitude": "-1.89400000"
                    },
                    {
                        "id": 42775,
                        "name": "La Guerche-de-Bretagne",
                        "latitude": "47.94112000",
                        "longitude": "-1.22869000"
                    },
                    {
                        "id": 42821,
                        "name": "La Méaugon",
                        "latitude": "48.49933000",
                        "longitude": "-2.83850000"
                    },
                    {
                        "id": 42823,
                        "name": "La Mézière",
                        "latitude": "48.21829000",
                        "longitude": "-1.75514000"
                    },
                    {
                        "id": 42812,
                        "name": "La Motte",
                        "latitude": "48.23381000",
                        "longitude": "-2.73271000"
                    },
                    {
                        "id": 42846,
                        "name": "La Richardais",
                        "latitude": "48.60641000",
                        "longitude": "-2.03639000"
                    },
                    {
                        "id": 42852,
                        "name": "La Roche-Derrien",
                        "latitude": "48.74627000",
                        "longitude": "-3.26142000"
                    },
                    {
                        "id": 42853,
                        "name": "La Roche-Maurice",
                        "latitude": "48.47455000",
                        "longitude": "-4.20211000"
                    },
                    {
                        "id": 42899,
                        "name": "La Trinité-sur-Mer",
                        "latitude": "47.58680000",
                        "longitude": "-3.02994000"
                    },
                    {
                        "id": 42919,
                        "name": "La Vraie-Croix",
                        "latitude": "47.68954000",
                        "longitude": "-2.54274000"
                    },
                    {
                        "id": 42970,
                        "name": "Laillé",
                        "latitude": "47.97848000",
                        "longitude": "-1.71676000"
                    },
                    {
                        "id": 42985,
                        "name": "Lamballe",
                        "latitude": "48.46762000",
                        "longitude": "-2.51436000"
                    },
                    {
                        "id": 42993,
                        "name": "Lampaul-Guimiliau",
                        "latitude": "48.49156000",
                        "longitude": "-4.04144000"
                    },
                    {
                        "id": 42994,
                        "name": "Lampaul-Plouarzel",
                        "latitude": "48.44727000",
                        "longitude": "-4.76045000"
                    },
                    {
                        "id": 42997,
                        "name": "Lancieux",
                        "latitude": "48.60767000",
                        "longitude": "-2.15030000"
                    },
                    {
                        "id": 43000,
                        "name": "Landaul",
                        "latitude": "47.74785000",
                        "longitude": "-3.07694000"
                    },
                    {
                        "id": 43015,
                        "name": "Landéan",
                        "latitude": "48.41253000",
                        "longitude": "-1.15245000"
                    },
                    {
                        "id": 43016,
                        "name": "Landéda",
                        "latitude": "48.58733000",
                        "longitude": "-4.57100000"
                    },
                    {
                        "id": 43017,
                        "name": "Landéhen",
                        "latitude": "48.43022000",
                        "longitude": "-2.53999000"
                    },
                    {
                        "id": 43001,
                        "name": "Landeleau",
                        "latitude": "48.22734000",
                        "longitude": "-3.72850000"
                    },
                    {
                        "id": 43003,
                        "name": "Landerneau",
                        "latitude": "48.45252000",
                        "longitude": "-4.25252000"
                    },
                    {
                        "id": 43018,
                        "name": "Landévant",
                        "latitude": "47.76499000",
                        "longitude": "-3.12221000"
                    },
                    {
                        "id": 43007,
                        "name": "Landivisiau",
                        "latitude": "48.50784000",
                        "longitude": "-4.06833000"
                    },
                    {
                        "id": 43011,
                        "name": "Landrévarzec",
                        "latitude": "48.09177000",
                        "longitude": "-4.06044000"
                    },
                    {
                        "id": 43013,
                        "name": "Landudec",
                        "latitude": "47.99983000",
                        "longitude": "-4.33641000"
                    },
                    {
                        "id": 43014,
                        "name": "Landunvez",
                        "latitude": "48.53466000",
                        "longitude": "-4.72545000"
                    },
                    {
                        "id": 43019,
                        "name": "Lanester",
                        "latitude": "47.76132000",
                        "longitude": "-3.33965000"
                    },
                    {
                        "id": 43024,
                        "name": "Langoat",
                        "latitude": "48.75061000",
                        "longitude": "-3.28121000"
                    },
                    {
                        "id": 43027,
                        "name": "Langon",
                        "latitude": "47.72057000",
                        "longitude": "-1.85010000"
                    },
                    {
                        "id": 43029,
                        "name": "Langonnet",
                        "latitude": "48.10511000",
                        "longitude": "-3.49356000"
                    },
                    {
                        "id": 43032,
                        "name": "Langueux",
                        "latitude": "48.49500000",
                        "longitude": "-2.71850000"
                    },
                    {
                        "id": 43033,
                        "name": "Languidic",
                        "latitude": "47.83266000",
                        "longitude": "-3.15821000"
                    },
                    {
                        "id": 43034,
                        "name": "Lanmeur",
                        "latitude": "48.64733000",
                        "longitude": "-3.71645000"
                    },
                    {
                        "id": 43036,
                        "name": "Lannilis",
                        "latitude": "48.57091000",
                        "longitude": "-4.52233000"
                    },
                    {
                        "id": 43037,
                        "name": "Lannion",
                        "latitude": "48.73255000",
                        "longitude": "-3.45542000"
                    },
                    {
                        "id": 43041,
                        "name": "Lanouée",
                        "latitude": "48.00225000",
                        "longitude": "-2.58157000"
                    },
                    {
                        "id": 43043,
                        "name": "Lanrivoaré",
                        "latitude": "48.47310000",
                        "longitude": "-4.63870000"
                    },
                    {
                        "id": 43044,
                        "name": "Lanrodec",
                        "latitude": "48.51622000",
                        "longitude": "-3.03122000"
                    },
                    {
                        "id": 43048,
                        "name": "Lantic",
                        "latitude": "48.60641000",
                        "longitude": "-2.88200000"
                    },
                    {
                        "id": 43052,
                        "name": "Lanvallay",
                        "latitude": "48.45543000",
                        "longitude": "-2.02803000"
                    },
                    {
                        "id": 43054,
                        "name": "Lanvénégen",
                        "latitude": "47.99811000",
                        "longitude": "-3.54134000"
                    },
                    {
                        "id": 43055,
                        "name": "Lanvéoc",
                        "latitude": "48.28799000",
                        "longitude": "-4.46277000"
                    },
                    {
                        "id": 43053,
                        "name": "Lanvollon",
                        "latitude": "48.63117000",
                        "longitude": "-2.98641000"
                    },
                    {
                        "id": 43072,
                        "name": "Larmor-Baden",
                        "latitude": "47.58341000",
                        "longitude": "-2.89440000"
                    },
                    {
                        "id": 43073,
                        "name": "Larmor-Plage",
                        "latitude": "47.70646000",
                        "longitude": "-3.38339000"
                    },
                    {
                        "id": 43088,
                        "name": "Lassy",
                        "latitude": "47.97829000",
                        "longitude": "-1.87190000"
                    },
                    {
                        "id": 43134,
                        "name": "Le Bono",
                        "latitude": "47.64129000",
                        "longitude": "-2.94902000"
                    },
                    {
                        "id": 43170,
                        "name": "Le Conquet",
                        "latitude": "48.36053000",
                        "longitude": "-4.77086000"
                    },
                    {
                        "id": 43182,
                        "name": "Le Drennec",
                        "latitude": "48.53475000",
                        "longitude": "-4.37008000"
                    },
                    {
                        "id": 43183,
                        "name": "Le Faou",
                        "latitude": "48.29456000",
                        "longitude": "-4.17927000"
                    },
                    {
                        "id": 43184,
                        "name": "Le Faouët",
                        "latitude": "48.03299000",
                        "longitude": "-3.49048000"
                    },
                    {
                        "id": 43192,
                        "name": "Le Fœil",
                        "latitude": "48.43333000",
                        "longitude": "-2.91667000"
                    },
                    {
                        "id": 43189,
                        "name": "Le Folgoët",
                        "latitude": "48.56359000",
                        "longitude": "-4.33641000"
                    },
                    {
                        "id": 43233,
                        "name": "Le Minihic-sur-Rance",
                        "latitude": "48.57835000",
                        "longitude": "-2.00876000"
                    },
                    {
                        "id": 43243,
                        "name": "Le Palais",
                        "latitude": "47.34590000",
                        "longitude": "-3.15488000"
                    },
                    {
                        "id": 43253,
                        "name": "Le Pertre",
                        "latitude": "48.03373000",
                        "longitude": "-1.03735000"
                    },
                    {
                        "id": 43293,
                        "name": "Le Relecq-Kerhuon",
                        "latitude": "48.40691000",
                        "longitude": "-4.39359000"
                    },
                    {
                        "id": 43295,
                        "name": "Le Rheu",
                        "latitude": "48.10228000",
                        "longitude": "-1.79733000"
                    },
                    {
                        "id": 43302,
                        "name": "Le Sourn",
                        "latitude": "48.04262000",
                        "longitude": "-2.98790000"
                    },
                    {
                        "id": 43311,
                        "name": "Le Theil-de-Bretagne",
                        "latitude": "47.91950000",
                        "longitude": "-1.42975000"
                    },
                    {
                        "id": 43325,
                        "name": "Le Trévoux",
                        "latitude": "47.89478000",
                        "longitude": "-3.64080000"
                    },
                    {
                        "id": 43333,
                        "name": "Le Vieux-Marché",
                        "latitude": "48.60000000",
                        "longitude": "-3.45000000"
                    },
                    {
                        "id": 43336,
                        "name": "Le Vivier-sur-Mer",
                        "latitude": "48.60169000",
                        "longitude": "-1.77303000"
                    },
                    {
                        "id": 43682,
                        "name": "Lécousse",
                        "latitude": "48.36458000",
                        "longitude": "-1.21289000"
                    },
                    {
                        "id": 43686,
                        "name": "Léhon",
                        "latitude": "48.44432000",
                        "longitude": "-2.04578000"
                    },
                    {
                        "id": 43375,
                        "name": "Les Champs-Géraux",
                        "latitude": "48.41647000",
                        "longitude": "-1.97087000"
                    },
                    {
                        "id": 43437,
                        "name": "Lesneven",
                        "latitude": "48.57233000",
                        "longitude": "-4.32133000"
                    },
                    {
                        "id": 43696,
                        "name": "Lézardrieux",
                        "latitude": "48.78510000",
                        "longitude": "-3.10588000"
                    },
                    {
                        "id": 43474,
                        "name": "Liffré",
                        "latitude": "48.21324000",
                        "longitude": "-1.50838000"
                    },
                    {
                        "id": 43491,
                        "name": "Limerzel",
                        "latitude": "47.63619000",
                        "longitude": "-2.35448000"
                    },
                    {
                        "id": 43522,
                        "name": "Livré-sur-Changeon",
                        "latitude": "48.21937000",
                        "longitude": "-1.34438000"
                    },
                    {
                        "id": 43528,
                        "name": "Locmariaquer",
                        "latitude": "47.56915000",
                        "longitude": "-2.94468000"
                    },
                    {
                        "id": 43529,
                        "name": "Locminé",
                        "latitude": "47.88619000",
                        "longitude": "-2.83536000"
                    },
                    {
                        "id": 43530,
                        "name": "Locmiquélic",
                        "latitude": "47.72499000",
                        "longitude": "-3.34153000"
                    },
                    {
                        "id": 43531,
                        "name": "Locoal-Mendon",
                        "latitude": "47.70520000",
                        "longitude": "-3.10796000"
                    },
                    {
                        "id": 43534,
                        "name": "Locquémeau",
                        "latitude": "48.72474000",
                        "longitude": "-3.56275000"
                    },
                    {
                        "id": 43533,
                        "name": "Locquirec",
                        "latitude": "48.69243000",
                        "longitude": "-3.64554000"
                    },
                    {
                        "id": 43535,
                        "name": "Loctudy",
                        "latitude": "47.83333000",
                        "longitude": "-4.16667000"
                    },
                    {
                        "id": 43539,
                        "name": "Logonna-Daoulas",
                        "latitude": "48.32308000",
                        "longitude": "-4.29675000"
                    },
                    {
                        "id": 43583,
                        "name": "Lopérec",
                        "latitude": "48.27734000",
                        "longitude": "-4.04756000"
                    },
                    {
                        "id": 43582,
                        "name": "Loperhet",
                        "latitude": "48.37725000",
                        "longitude": "-4.30608000"
                    },
                    {
                        "id": 43587,
                        "name": "Lorient",
                        "latitude": "47.74589000",
                        "longitude": "-3.36643000"
                    },
                    {
                        "id": 43598,
                        "name": "Louannec",
                        "latitude": "48.79423000",
                        "longitude": "-3.41200000"
                    },
                    {
                        "id": 43599,
                        "name": "Louargat",
                        "latitude": "48.56576000",
                        "longitude": "-3.33750000"
                    },
                    {
                        "id": 43602,
                        "name": "Loudéac",
                        "latitude": "48.17826000",
                        "longitude": "-2.75433000"
                    },
                    {
                        "id": 43616,
                        "name": "Louvigné-de-Bais",
                        "latitude": "48.04898000",
                        "longitude": "-1.33091000"
                    },
                    {
                        "id": 43617,
                        "name": "Louvigné-du-Désert",
                        "latitude": "48.48047000",
                        "longitude": "-1.12537000"
                    },
                    {
                        "id": 43623,
                        "name": "Loyat",
                        "latitude": "47.98933000",
                        "longitude": "-2.38344000"
                    },
                    {
                        "id": 43645,
                        "name": "Luitré",
                        "latitude": "48.28247000",
                        "longitude": "-1.11866000"
                    },
                    {
                        "id": 43981,
                        "name": "Maël-Carhaix",
                        "latitude": "48.28444000",
                        "longitude": "-3.42322000"
                    },
                    {
                        "id": 43749,
                        "name": "Malansac",
                        "latitude": "47.67724000",
                        "longitude": "-2.29543000"
                    },
                    {
                        "id": 43757,
                        "name": "Malestroit",
                        "latitude": "47.80934000",
                        "longitude": "-2.38457000"
                    },
                    {
                        "id": 43758,
                        "name": "Malguénac",
                        "latitude": "48.08008000",
                        "longitude": "-3.05248000"
                    },
                    {
                        "id": 43914,
                        "name": "Martigné-Ferchaud",
                        "latitude": "47.82934000",
                        "longitude": "-1.31911000"
                    },
                    {
                        "id": 43924,
                        "name": "Marzan",
                        "latitude": "47.54069000",
                        "longitude": "-2.32466000"
                    },
                    {
                        "id": 43940,
                        "name": "Matignon",
                        "latitude": "48.59627000",
                        "longitude": "-2.29125000"
                    },
                    {
                        "id": 43951,
                        "name": "Maure-de-Bretagne",
                        "latitude": "47.89239000",
                        "longitude": "-1.99104000"
                    },
                    {
                        "id": 43957,
                        "name": "Mauron",
                        "latitude": "48.08257000",
                        "longitude": "-2.28477000"
                    },
                    {
                        "id": 43965,
                        "name": "Maxent",
                        "latitude": "47.98333000",
                        "longitude": "-2.03333000"
                    },
                    {
                        "id": 44459,
                        "name": "Médréac",
                        "latitude": "48.26703000",
                        "longitude": "-2.06618000"
                    },
                    {
                        "id": 43988,
                        "name": "Meillac",
                        "latitude": "48.41174000",
                        "longitude": "-1.81378000"
                    },
                    {
                        "id": 43992,
                        "name": "Melesse",
                        "latitude": "48.21771000",
                        "longitude": "-1.69496000"
                    },
                    {
                        "id": 43993,
                        "name": "Melgven",
                        "latitude": "47.90626000",
                        "longitude": "-3.83518000"
                    },
                    {
                        "id": 43994,
                        "name": "Mellac",
                        "latitude": "47.90345000",
                        "longitude": "-3.57675000"
                    },
                    {
                        "id": 43997,
                        "name": "Melrand",
                        "latitude": "47.98002000",
                        "longitude": "-3.10941000"
                    },
                    {
                        "id": 44466,
                        "name": "Ménéac",
                        "latitude": "48.13972000",
                        "longitude": "-2.46134000"
                    },
                    {
                        "id": 44015,
                        "name": "Merdrignac",
                        "latitude": "48.19372000",
                        "longitude": "-2.41533000"
                    },
                    {
                        "id": 44016,
                        "name": "Merlevenez",
                        "latitude": "47.73563000",
                        "longitude": "-3.23047000"
                    },
                    {
                        "id": 44028,
                        "name": "Meslan",
                        "latitude": "47.99502000",
                        "longitude": "-3.43285000"
                    },
                    {
                        "id": 44032,
                        "name": "Messac",
                        "latitude": "47.82399000",
                        "longitude": "-1.81085000"
                    },
                    {
                        "id": 44044,
                        "name": "Meucon",
                        "latitude": "47.71648000",
                        "longitude": "-2.76170000"
                    },
                    {
                        "id": 44072,
                        "name": "Milizac",
                        "latitude": "48.46667000",
                        "longitude": "-4.56667000"
                    },
                    {
                        "id": 44081,
                        "name": "Miniac-Morvan",
                        "latitude": "48.51477000",
                        "longitude": "-1.89955000"
                    },
                    {
                        "id": 44082,
                        "name": "Minihy-Tréguier",
                        "latitude": "48.77746000",
                        "longitude": "-3.22883000"
                    },
                    {
                        "id": 44427,
                        "name": "Moëlan-sur-Mer",
                        "latitude": "47.81418000",
                        "longitude": "-3.62892000"
                    },
                    {
                        "id": 44121,
                        "name": "Molac",
                        "latitude": "47.73011000",
                        "longitude": "-2.43484000"
                    },
                    {
                        "id": 44184,
                        "name": "Montauban-de-Bretagne",
                        "latitude": "48.19933000",
                        "longitude": "-2.04476000"
                    },
                    {
                        "id": 44221,
                        "name": "Monterblanc",
                        "latitude": "47.74211000",
                        "longitude": "-2.67950000"
                    },
                    {
                        "id": 44223,
                        "name": "Monterfil",
                        "latitude": "48.06733000",
                        "longitude": "-1.97905000"
                    },
                    {
                        "id": 44242,
                        "name": "Montfort-sur-Meu",
                        "latitude": "48.13542000",
                        "longitude": "-1.95201000"
                    },
                    {
                        "id": 44245,
                        "name": "Montgermont",
                        "latitude": "48.15592000",
                        "longitude": "-1.71464000"
                    },
                    {
                        "id": 44311,
                        "name": "Montreuil-le-Gast",
                        "latitude": "48.24647000",
                        "longitude": "-1.72498000"
                    },
                    {
                        "id": 44312,
                        "name": "Montreuil-sous-Pérouse",
                        "latitude": "48.15176000",
                        "longitude": "-1.23946000"
                    },
                    {
                        "id": 44313,
                        "name": "Montreuil-sur-Ille",
                        "latitude": "48.30788000",
                        "longitude": "-1.66880000"
                    },
                    {
                        "id": 44345,
                        "name": "Morbihan",
                        "latitude": "47.84765000",
                        "longitude": "-2.77760000"
                    },
                    {
                        "id": 44347,
                        "name": "Mordelles",
                        "latitude": "48.07571000",
                        "longitude": "-1.84286000"
                    },
                    {
                        "id": 44378,
                        "name": "Moréac",
                        "latitude": "47.91967000",
                        "longitude": "-2.81934000"
                    },
                    {
                        "id": 44357,
                        "name": "Morlaix",
                        "latitude": "48.57742000",
                        "longitude": "-3.82788000"
                    },
                    {
                        "id": 44410,
                        "name": "Moustoir-Ac",
                        "latitude": "47.85461000",
                        "longitude": "-2.83481000"
                    },
                    {
                        "id": 44493,
                        "name": "Mûr-de-Bretagne",
                        "latitude": "48.20000000",
                        "longitude": "-2.98333000"
                    },
                    {
                        "id": 44450,
                        "name": "Muzillac",
                        "latitude": "47.55451000",
                        "longitude": "-2.48041000"
                    },
                    {
                        "id": 44498,
                        "name": "Naizin",
                        "latitude": "47.98993000",
                        "longitude": "-2.83287000"
                    },
                    {
                        "id": 44556,
                        "name": "Neulliac",
                        "latitude": "48.12836000",
                        "longitude": "-2.98289000"
                    },
                    {
                        "id": 44697,
                        "name": "Névez",
                        "latitude": "47.81924000",
                        "longitude": "-3.79225000"
                    },
                    {
                        "id": 44603,
                        "name": "Nivillac",
                        "latitude": "47.53371000",
                        "longitude": "-2.28298000"
                    },
                    {
                        "id": 44647,
                        "name": "Nostang",
                        "latitude": "47.74870000",
                        "longitude": "-3.18639000"
                    },
                    {
                        "id": 44662,
                        "name": "Nouvoitou",
                        "latitude": "48.04105000",
                        "longitude": "-1.54714000"
                    },
                    {
                        "id": 44669,
                        "name": "Noyal-Muzillac",
                        "latitude": "47.59169000",
                        "longitude": "-2.45557000"
                    },
                    {
                        "id": 44670,
                        "name": "Noyal-Pontivy",
                        "latitude": "48.06667000",
                        "longitude": "-2.88333000"
                    },
                    {
                        "id": 44671,
                        "name": "Noyal-sur-Vilaine",
                        "latitude": "48.11219000",
                        "longitude": "-1.52333000"
                    },
                    {
                        "id": 44766,
                        "name": "Orgères",
                        "latitude": "47.99886000",
                        "longitude": "-1.66781000"
                    },
                    {
                        "id": 44791,
                        "name": "Ossé",
                        "latitude": "48.05542000",
                        "longitude": "-1.45029000"
                    },
                    {
                        "id": 44823,
                        "name": "Pabu",
                        "latitude": "48.58608000",
                        "longitude": "-3.13608000"
                    },
                    {
                        "id": 44825,
                        "name": "Pacé",
                        "latitude": "48.14848000",
                        "longitude": "-1.77327000"
                    },
                    {
                        "id": 44829,
                        "name": "Paimpol",
                        "latitude": "48.77841000",
                        "longitude": "-3.04375000"
                    },
                    {
                        "id": 44830,
                        "name": "Paimpont",
                        "latitude": "48.01809000",
                        "longitude": "-2.17105000"
                    },
                    {
                        "id": 44841,
                        "name": "Pancé",
                        "latitude": "47.88181000",
                        "longitude": "-1.65953000"
                    },
                    {
                        "id": 44854,
                        "name": "Parigné",
                        "latitude": "48.42727000",
                        "longitude": "-1.19210000"
                    },
                    {
                        "id": 45342,
                        "name": "Péaule",
                        "latitude": "47.57972000",
                        "longitude": "-2.35601000"
                    },
                    {
                        "id": 45344,
                        "name": "Pédernec",
                        "latitude": "48.59682000",
                        "longitude": "-3.26948000"
                    },
                    {
                        "id": 44881,
                        "name": "Peillac",
                        "latitude": "47.71391000",
                        "longitude": "-2.21971000"
                    },
                    {
                        "id": 44890,
                        "name": "Pencran",
                        "latitude": "48.43333000",
                        "longitude": "-4.23333000"
                    },
                    {
                        "id": 45348,
                        "name": "Pénestin",
                        "latitude": "47.48226000",
                        "longitude": "-2.47275000"
                    },
                    {
                        "id": 44894,
                        "name": "Penvénan",
                        "latitude": "48.81182000",
                        "longitude": "-3.29550000"
                    },
                    {
                        "id": 44906,
                        "name": "Perros-Guirec",
                        "latitude": "48.81454000",
                        "longitude": "-3.43963000"
                    },
                    {
                        "id": 44976,
                        "name": "Pipriac",
                        "latitude": "47.80953000",
                        "longitude": "-1.94638000"
                    },
                    {
                        "id": 44980,
                        "name": "Piré-sur-Seiche",
                        "latitude": "48.00958000",
                        "longitude": "-1.42909000"
                    },
                    {
                        "id": 44987,
                        "name": "Plabennec",
                        "latitude": "48.50244000",
                        "longitude": "-4.42656000"
                    },
                    {
                        "id": 44990,
                        "name": "Plaine-Haute",
                        "latitude": "48.44442000",
                        "longitude": "-2.85416000"
                    },
                    {
                        "id": 44992,
                        "name": "Plaintel",
                        "latitude": "48.40733000",
                        "longitude": "-2.81733000"
                    },
                    {
                        "id": 45000,
                        "name": "Plancoët",
                        "latitude": "48.52199000",
                        "longitude": "-2.23540000"
                    },
                    {
                        "id": 45001,
                        "name": "Planguenoual",
                        "latitude": "48.53300000",
                        "longitude": "-2.57642000"
                    },
                    {
                        "id": 45003,
                        "name": "Plaudren",
                        "latitude": "47.77868000",
                        "longitude": "-2.69331000"
                    },
                    {
                        "id": 45116,
                        "name": "Pléchâtel",
                        "latitude": "47.89496000",
                        "longitude": "-1.74876000"
                    },
                    {
                        "id": 45118,
                        "name": "Plédéliac",
                        "latitude": "48.45000000",
                        "longitude": "-2.38333000"
                    },
                    {
                        "id": 45117,
                        "name": "Plédran",
                        "latitude": "48.44600000",
                        "longitude": "-2.74667000"
                    },
                    {
                        "id": 45119,
                        "name": "Pléguien",
                        "latitude": "48.63525000",
                        "longitude": "-2.94001000"
                    },
                    {
                        "id": 45120,
                        "name": "Pléhédel",
                        "latitude": "48.69645000",
                        "longitude": "-3.00833000"
                    },
                    {
                        "id": 45006,
                        "name": "Pleine-Fougères",
                        "latitude": "48.53308000",
                        "longitude": "-1.56534000"
                    },
                    {
                        "id": 45121,
                        "name": "Plélan-le-Grand",
                        "latitude": "48.00124000",
                        "longitude": "-2.09914000"
                    },
                    {
                        "id": 45122,
                        "name": "Plélan-le-Petit",
                        "latitude": "48.43157000",
                        "longitude": "-2.21740000"
                    },
                    {
                        "id": 45123,
                        "name": "Plélo",
                        "latitude": "48.55534000",
                        "longitude": "-2.94634000"
                    },
                    {
                        "id": 45124,
                        "name": "Plémet",
                        "latitude": "48.17601000",
                        "longitude": "-2.59325000"
                    },
                    {
                        "id": 45125,
                        "name": "Plémy",
                        "latitude": "48.33644000",
                        "longitude": "-2.68244000"
                    },
                    {
                        "id": 45127,
                        "name": "Plénée-Jugon",
                        "latitude": "48.36462000",
                        "longitude": "-2.40036000"
                    },
                    {
                        "id": 45126,
                        "name": "Pléneuf-Val-André",
                        "latitude": "48.59300000",
                        "longitude": "-2.54675000"
                    },
                    {
                        "id": 45007,
                        "name": "Plerguer",
                        "latitude": "48.52676000",
                        "longitude": "-1.84769000"
                    },
                    {
                        "id": 45128,
                        "name": "Plérin",
                        "latitude": "48.54249000",
                        "longitude": "-2.77983000"
                    },
                    {
                        "id": 45008,
                        "name": "Plescop",
                        "latitude": "47.69726000",
                        "longitude": "-2.80560000"
                    },
                    {
                        "id": 45009,
                        "name": "Pleslin-Trigavou",
                        "latitude": "48.53333000",
                        "longitude": "-2.06667000"
                    },
                    {
                        "id": 45010,
                        "name": "Plessala",
                        "latitude": "48.27642000",
                        "longitude": "-2.61876000"
                    },
                    {
                        "id": 45012,
                        "name": "Plestan",
                        "latitude": "48.42266000",
                        "longitude": "-2.44777000"
                    },
                    {
                        "id": 45013,
                        "name": "Plestin-les-Grèves",
                        "latitude": "48.65844000",
                        "longitude": "-3.63056000"
                    },
                    {
                        "id": 45014,
                        "name": "Pleubian",
                        "latitude": "48.84267000",
                        "longitude": "-3.13900000"
                    },
                    {
                        "id": 45015,
                        "name": "Pleucadeuc",
                        "latitude": "47.75876000",
                        "longitude": "-2.37362000"
                    },
                    {
                        "id": 45016,
                        "name": "Pleudaniel",
                        "latitude": "48.76644000",
                        "longitude": "-3.14033000"
                    },
                    {
                        "id": 45017,
                        "name": "Pleudihen-sur-Rance",
                        "latitude": "48.51667000",
                        "longitude": "-1.96667000"
                    },
                    {
                        "id": 45018,
                        "name": "Pleugriffet",
                        "latitude": "47.98594000",
                        "longitude": "-2.68454000"
                    },
                    {
                        "id": 45019,
                        "name": "Pleugueneuc",
                        "latitude": "48.39735000",
                        "longitude": "-1.90301000"
                    },
                    {
                        "id": 45021,
                        "name": "Pleumeleuc",
                        "latitude": "48.18438000",
                        "longitude": "-1.91962000"
                    },
                    {
                        "id": 45022,
                        "name": "Pleumeur-Bodou",
                        "latitude": "48.76667000",
                        "longitude": "-3.51667000"
                    },
                    {
                        "id": 45023,
                        "name": "Pleumeur-Gautier",
                        "latitude": "48.80044000",
                        "longitude": "-3.15578000"
                    },
                    {
                        "id": 45024,
                        "name": "Pleurtuit",
                        "latitude": "48.57858000",
                        "longitude": "-2.05805000"
                    },
                    {
                        "id": 45025,
                        "name": "Pleuven",
                        "latitude": "47.90000000",
                        "longitude": "-4.03333000"
                    },
                    {
                        "id": 45026,
                        "name": "Pleyben",
                        "latitude": "48.23333000",
                        "longitude": "-3.96667000"
                    },
                    {
                        "id": 45027,
                        "name": "Pleyber-Christ",
                        "latitude": "48.50000000",
                        "longitude": "-3.86667000"
                    },
                    {
                        "id": 45028,
                        "name": "Plobannalec-Lesconil",
                        "latitude": "47.81667000",
                        "longitude": "-4.21667000"
                    },
                    {
                        "id": 45030,
                        "name": "Ploemel",
                        "latitude": "47.65153000",
                        "longitude": "-3.07030000"
                    },
                    {
                        "id": 45031,
                        "name": "Ploemeur",
                        "latitude": "47.73333000",
                        "longitude": "-3.43333000"
                    },
                    {
                        "id": 45100,
                        "name": "Ploërdut",
                        "latitude": "48.08742000",
                        "longitude": "-3.28550000"
                    },
                    {
                        "id": 45032,
                        "name": "Ploeren",
                        "latitude": "47.65713000",
                        "longitude": "-2.86397000"
                    },
                    {
                        "id": 45101,
                        "name": "Ploërmel",
                        "latitude": "47.93172000",
                        "longitude": "-2.39781000"
                    },
                    {
                        "id": 45129,
                        "name": "Plœuc-sur-Lié",
                        "latitude": "48.35000000",
                        "longitude": "-2.75000000"
                    },
                    {
                        "id": 45102,
                        "name": "Ploëzal",
                        "latitude": "48.71534000",
                        "longitude": "-3.20333000"
                    },
                    {
                        "id": 45033,
                        "name": "Plogastel-Saint-Germain",
                        "latitude": "47.98333000",
                        "longitude": "-4.26667000"
                    },
                    {
                        "id": 45034,
                        "name": "Plogoff",
                        "latitude": "48.03700000",
                        "longitude": "-4.66606000"
                    },
                    {
                        "id": 45035,
                        "name": "Plogonnec",
                        "latitude": "48.08333000",
                        "longitude": "-4.18333000"
                    },
                    {
                        "id": 45038,
                        "name": "Plomelin",
                        "latitude": "47.93333000",
                        "longitude": "-4.15000000"
                    },
                    {
                        "id": 45039,
                        "name": "Plomeur",
                        "latitude": "47.83333000",
                        "longitude": "-4.28333000"
                    },
                    {
                        "id": 45040,
                        "name": "Plomodiern",
                        "latitude": "48.18333000",
                        "longitude": "-4.23333000"
                    },
                    {
                        "id": 45041,
                        "name": "Plonéis",
                        "latitude": "48.01667000",
                        "longitude": "-4.21667000"
                    },
                    {
                        "id": 45042,
                        "name": "Plonéour-Lanvern",
                        "latitude": "47.90000000",
                        "longitude": "-4.28333000"
                    },
                    {
                        "id": 45044,
                        "name": "Plonévez-du-Faou",
                        "latitude": "48.25000000",
                        "longitude": "-3.83333000"
                    },
                    {
                        "id": 45043,
                        "name": "Plonévez-Porzay",
                        "latitude": "48.10000000",
                        "longitude": "-4.21667000"
                    },
                    {
                        "id": 45045,
                        "name": "Plouagat",
                        "latitude": "48.53611000",
                        "longitude": "-2.99956000"
                    },
                    {
                        "id": 45046,
                        "name": "Plouaret",
                        "latitude": "48.61667000",
                        "longitude": "-3.46667000"
                    },
                    {
                        "id": 45047,
                        "name": "Plouarzel",
                        "latitude": "48.43333000",
                        "longitude": "-4.73333000"
                    },
                    {
                        "id": 45048,
                        "name": "Plouasne",
                        "latitude": "48.30081000",
                        "longitude": "-2.00698000"
                    },
                    {
                        "id": 45049,
                        "name": "Plouay",
                        "latitude": "47.91444000",
                        "longitude": "-3.33384000"
                    },
                    {
                        "id": 45050,
                        "name": "Ploubalay",
                        "latitude": "48.58109000",
                        "longitude": "-2.14069000"
                    },
                    {
                        "id": 45051,
                        "name": "Ploubazlanec",
                        "latitude": "48.80000000",
                        "longitude": "-3.03333000"
                    },
                    {
                        "id": 45052,
                        "name": "Ploubezre",
                        "latitude": "48.70000000",
                        "longitude": "-3.45000000"
                    },
                    {
                        "id": 45053,
                        "name": "Ploudalmézeau",
                        "latitude": "48.53333000",
                        "longitude": "-4.65000000"
                    },
                    {
                        "id": 45054,
                        "name": "Ploudaniel",
                        "latitude": "48.53333000",
                        "longitude": "-4.31667000"
                    },
                    {
                        "id": 45097,
                        "name": "Plouëc-du-Trieux",
                        "latitude": "48.68333000",
                        "longitude": "-3.20000000"
                    },
                    {
                        "id": 45094,
                        "name": "Plouédern",
                        "latitude": "48.48333000",
                        "longitude": "-4.25000000"
                    },
                    {
                        "id": 45095,
                        "name": "Plouénan",
                        "latitude": "48.63333000",
                        "longitude": "-4.00000000"
                    },
                    {
                        "id": 45098,
                        "name": "Plouër-sur-Rance",
                        "latitude": "48.52669000",
                        "longitude": "-2.00298000"
                    },
                    {
                        "id": 45055,
                        "name": "Plouescat",
                        "latitude": "48.66667000",
                        "longitude": "-4.16667000"
                    },
                    {
                        "id": 45096,
                        "name": "Plouézec",
                        "latitude": "48.75122000",
                        "longitude": "-2.98467000"
                    },
                    {
                        "id": 45056,
                        "name": "Plouezoc'h",
                        "latitude": "48.63333000",
                        "longitude": "-3.81667000"
                    },
                    {
                        "id": 45057,
                        "name": "Ploufragan",
                        "latitude": "48.49141000",
                        "longitude": "-2.79458000"
                    },
                    {
                        "id": 45058,
                        "name": "Plougasnou",
                        "latitude": "48.70000000",
                        "longitude": "-3.80000000"
                    },
                    {
                        "id": 45059,
                        "name": "Plougastel-Daoulas",
                        "latitude": "48.36667000",
                        "longitude": "-4.36667000"
                    },
                    {
                        "id": 45060,
                        "name": "Plougonvelin",
                        "latitude": "48.34059000",
                        "longitude": "-4.71846000"
                    },
                    {
                        "id": 45061,
                        "name": "Plougonven",
                        "latitude": "48.51667000",
                        "longitude": "-3.71667000"
                    },
                    {
                        "id": 45062,
                        "name": "Plougoulm",
                        "latitude": "48.66667000",
                        "longitude": "-4.05000000"
                    },
                    {
                        "id": 45063,
                        "name": "Plougoumelen",
                        "latitude": "47.65070000",
                        "longitude": "-2.91716000"
                    },
                    {
                        "id": 45064,
                        "name": "Plougourvest",
                        "latitude": "48.55000000",
                        "longitude": "-4.08333000"
                    },
                    {
                        "id": 45065,
                        "name": "Plougrescant",
                        "latitude": "48.84026000",
                        "longitude": "-3.22886000"
                    },
                    {
                        "id": 45066,
                        "name": "Plouguenast",
                        "latitude": "48.28208000",
                        "longitude": "-2.70443000"
                    },
                    {
                        "id": 45067,
                        "name": "Plouguerneau",
                        "latitude": "48.60000000",
                        "longitude": "-4.50000000"
                    },
                    {
                        "id": 45068,
                        "name": "Plouguernével",
                        "latitude": "48.23940000",
                        "longitude": "-3.25071000"
                    },
                    {
                        "id": 45069,
                        "name": "Plouguiel",
                        "latitude": "48.79742000",
                        "longitude": "-3.23883000"
                    },
                    {
                        "id": 45070,
                        "name": "Plouguin",
                        "latitude": "48.53333000",
                        "longitude": "-4.60000000"
                    },
                    {
                        "id": 45071,
                        "name": "Plouha",
                        "latitude": "48.67650000",
                        "longitude": "-2.92842000"
                    },
                    {
                        "id": 45072,
                        "name": "Plouharnel",
                        "latitude": "47.59804000",
                        "longitude": "-3.11274000"
                    },
                    {
                        "id": 45073,
                        "name": "Plouhinec",
                        "latitude": "48.01667000",
                        "longitude": "-4.48333000"
                    },
                    {
                        "id": 45074,
                        "name": "Plouider",
                        "latitude": "48.61667000",
                        "longitude": "-4.30000000"
                    },
                    {
                        "id": 45075,
                        "name": "Plouigneau",
                        "latitude": "48.56667000",
                        "longitude": "-3.70000000"
                    },
                    {
                        "id": 45076,
                        "name": "Plouisy",
                        "latitude": "48.57817000",
                        "longitude": "-3.18434000"
                    },
                    {
                        "id": 45077,
                        "name": "Ploumagoar",
                        "latitude": "48.54509000",
                        "longitude": "-3.13233000"
                    },
                    {
                        "id": 45078,
                        "name": "Ploumilliau",
                        "latitude": "48.68333000",
                        "longitude": "-3.51667000"
                    },
                    {
                        "id": 45079,
                        "name": "Ploumoguer",
                        "latitude": "48.40000000",
                        "longitude": "-4.71667000"
                    },
                    {
                        "id": 45080,
                        "name": "Plounéour-Ménez",
                        "latitude": "48.45000000",
                        "longitude": "-3.88333000"
                    },
                    {
                        "id": 45081,
                        "name": "Plounéour-Trez",
                        "latitude": "48.65000000",
                        "longitude": "-4.31667000"
                    },
                    {
                        "id": 45082,
                        "name": "Plounéventer",
                        "latitude": "48.51667000",
                        "longitude": "-4.21667000"
                    },
                    {
                        "id": 45083,
                        "name": "Plounévez-Lochrist",
                        "latitude": "48.61667000",
                        "longitude": "-4.21667000"
                    },
                    {
                        "id": 45084,
                        "name": "Plounévez-Moëdec",
                        "latitude": "48.56667000",
                        "longitude": "-3.45000000"
                    },
                    {
                        "id": 45085,
                        "name": "Plounévez-Quintin",
                        "latitude": "48.28333000",
                        "longitude": "-3.23333000"
                    },
                    {
                        "id": 45086,
                        "name": "Plounévézel",
                        "latitude": "48.30000000",
                        "longitude": "-3.60000000"
                    },
                    {
                        "id": 45087,
                        "name": "Plouray",
                        "latitude": "48.14580000",
                        "longitude": "-3.38671000"
                    },
                    {
                        "id": 45088,
                        "name": "Plourin-lès-Morlaix",
                        "latitude": "48.53333000",
                        "longitude": "-3.78333000"
                    },
                    {
                        "id": 45089,
                        "name": "Plourivo",
                        "latitude": "48.74550000",
                        "longitude": "-3.07075000"
                    },
                    {
                        "id": 45090,
                        "name": "Plouvien",
                        "latitude": "48.53333000",
                        "longitude": "-4.45000000"
                    },
                    {
                        "id": 45091,
                        "name": "Plouvorn",
                        "latitude": "48.58333000",
                        "longitude": "-4.03333000"
                    },
                    {
                        "id": 45092,
                        "name": "Plouzané",
                        "latitude": "48.38333000",
                        "longitude": "-4.61667000"
                    },
                    {
                        "id": 45093,
                        "name": "Plouzévédé",
                        "latitude": "48.60000000",
                        "longitude": "-4.11667000"
                    },
                    {
                        "id": 45099,
                        "name": "Plozévet",
                        "latitude": "47.98333000",
                        "longitude": "-4.41667000"
                    },
                    {
                        "id": 45103,
                        "name": "Pluduno",
                        "latitude": "48.53110000",
                        "longitude": "-2.26848000"
                    },
                    {
                        "id": 45104,
                        "name": "Pluguffan",
                        "latitude": "47.98333000",
                        "longitude": "-4.18333000"
                    },
                    {
                        "id": 45105,
                        "name": "Pluherlin",
                        "latitude": "47.69632000",
                        "longitude": "-2.36349000"
                    },
                    {
                        "id": 45106,
                        "name": "Plumaugat",
                        "latitude": "48.25479000",
                        "longitude": "-2.23843000"
                    },
                    {
                        "id": 45107,
                        "name": "Plumelec",
                        "latitude": "47.83754000",
                        "longitude": "-2.63987000"
                    },
                    {
                        "id": 45111,
                        "name": "Pluméliau",
                        "latitude": "47.95769000",
                        "longitude": "-2.97494000"
                    },
                    {
                        "id": 45108,
                        "name": "Plumelin",
                        "latitude": "47.86036000",
                        "longitude": "-2.88754000"
                    },
                    {
                        "id": 45109,
                        "name": "Plumergat",
                        "latitude": "47.74134000",
                        "longitude": "-2.91501000"
                    },
                    {
                        "id": 45110,
                        "name": "Plumieux",
                        "latitude": "48.10303000",
                        "longitude": "-2.58382000"
                    },
                    {
                        "id": 45112,
                        "name": "Pluneret",
                        "latitude": "47.67525000",
                        "longitude": "-2.95782000"
                    },
                    {
                        "id": 45113,
                        "name": "Plurien",
                        "latitude": "48.62559000",
                        "longitude": "-2.40423000"
                    },
                    {
                        "id": 45114,
                        "name": "Pluvigner",
                        "latitude": "47.77627000",
                        "longitude": "-3.01013000"
                    },
                    {
                        "id": 45115,
                        "name": "Pluzunet",
                        "latitude": "48.64076000",
                        "longitude": "-3.37113000"
                    },
                    {
                        "id": 45130,
                        "name": "Pocé-les-Bois",
                        "latitude": "48.11626000",
                        "longitude": "-1.25168000"
                    },
                    {
                        "id": 45148,
                        "name": "Pommeret",
                        "latitude": "48.46378000",
                        "longitude": "-2.62689000"
                    },
                    {
                        "id": 45149,
                        "name": "Pommerit-Jaudy",
                        "latitude": "48.73058000",
                        "longitude": "-3.24208000"
                    },
                    {
                        "id": 45150,
                        "name": "Pommerit-le-Vicomte",
                        "latitude": "48.61989000",
                        "longitude": "-3.09000000"
                    },
                    {
                        "id": 45165,
                        "name": "Pont-Aven",
                        "latitude": "47.85000000",
                        "longitude": "-3.75000000"
                    },
                    {
                        "id": 45166,
                        "name": "Pont-Croix",
                        "latitude": "48.04088000",
                        "longitude": "-4.48714000"
                    },
                    {
                        "id": 45189,
                        "name": "Pont-l’Abbé",
                        "latitude": "47.86667000",
                        "longitude": "-4.21667000"
                    },
                    {
                        "id": 45176,
                        "name": "Pont-Scorff",
                        "latitude": "47.83343000",
                        "longitude": "-3.40251000"
                    },
                    {
                        "id": 45211,
                        "name": "Pontivy",
                        "latitude": "48.06862000",
                        "longitude": "-2.96280000"
                    },
                    {
                        "id": 45217,
                        "name": "Pontrieux",
                        "latitude": "48.70111000",
                        "longitude": "-3.15967000"
                    },
                    {
                        "id": 45222,
                        "name": "Pordic",
                        "latitude": "48.57051000",
                        "longitude": "-2.81783000"
                    },
                    {
                        "id": 45225,
                        "name": "Porspoder",
                        "latitude": "48.50000000",
                        "longitude": "-4.76667000"
                    },
                    {
                        "id": 45228,
                        "name": "Port-Louis",
                        "latitude": "47.70704000",
                        "longitude": "-3.35484000"
                    },
                    {
                        "id": 45259,
                        "name": "Pouldergat",
                        "latitude": "48.05000000",
                        "longitude": "-4.33333000"
                    },
                    {
                        "id": 45260,
                        "name": "Pouldreuzic",
                        "latitude": "47.95000000",
                        "longitude": "-4.36667000"
                    },
                    {
                        "id": 45262,
                        "name": "Poullan-sur-Mer",
                        "latitude": "48.08333000",
                        "longitude": "-4.41667000"
                    },
                    {
                        "id": 45263,
                        "name": "Poullaouen",
                        "latitude": "48.33333000",
                        "longitude": "-3.65000000"
                    },
                    {
                        "id": 45277,
                        "name": "Prat",
                        "latitude": "48.67677000",
                        "longitude": "-3.29707000"
                    },
                    {
                        "id": 45293,
                        "name": "Priziac",
                        "latitude": "48.06667000",
                        "longitude": "-3.41667000"
                    },
                    {
                        "id": 45406,
                        "name": "Québriac",
                        "latitude": "48.34444000",
                        "longitude": "-1.82723000"
                    },
                    {
                        "id": 45407,
                        "name": "Quédillac",
                        "latitude": "48.24904000",
                        "longitude": "-2.14241000"
                    },
                    {
                        "id": 45408,
                        "name": "Quéménéven",
                        "latitude": "48.11667000",
                        "longitude": "-4.11667000"
                    },
                    {
                        "id": 45373,
                        "name": "Quemper-Guézennec",
                        "latitude": "48.70378000",
                        "longitude": "-3.10522000"
                    },
                    {
                        "id": 45376,
                        "name": "Querrien",
                        "latitude": "47.96667000",
                        "longitude": "-3.53333000"
                    },
                    {
                        "id": 45378,
                        "name": "Quessoy",
                        "latitude": "48.42208000",
                        "longitude": "-2.66089000"
                    },
                    {
                        "id": 45379,
                        "name": "Questembert",
                        "latitude": "47.66296000",
                        "longitude": "-2.45220000"
                    },
                    {
                        "id": 45409,
                        "name": "Quéven",
                        "latitude": "47.78333000",
                        "longitude": "-3.41667000"
                    },
                    {
                        "id": 45410,
                        "name": "Quévert",
                        "latitude": "48.46402000",
                        "longitude": "-2.08745000"
                    },
                    {
                        "id": 45384,
                        "name": "Quiberon",
                        "latitude": "47.48412000",
                        "longitude": "-3.11963000"
                    },
                    {
                        "id": 45389,
                        "name": "Quimper",
                        "latitude": "48.00000000",
                        "longitude": "-4.10000000"
                    },
                    {
                        "id": 45390,
                        "name": "Quimperlé",
                        "latitude": "47.86667000",
                        "longitude": "-3.55000000"
                    },
                    {
                        "id": 45401,
                        "name": "Quintin",
                        "latitude": "48.40342000",
                        "longitude": "-2.91050000"
                    },
                    {
                        "id": 45403,
                        "name": "Quistinic",
                        "latitude": "47.90410000",
                        "longitude": "-3.13400000"
                    },
                    {
                        "id": 45429,
                        "name": "Rannée",
                        "latitude": "47.92383000",
                        "longitude": "-1.24124000"
                    },
                    {
                        "id": 45685,
                        "name": "Rédené",
                        "latitude": "47.85000000",
                        "longitude": "-3.46667000"
                    },
                    {
                        "id": 45443,
                        "name": "Redon",
                        "latitude": "47.65141000",
                        "longitude": "-2.08481000"
                    },
                    {
                        "id": 45688,
                        "name": "Réguiny",
                        "latitude": "47.97649000",
                        "longitude": "-2.74478000"
                    },
                    {
                        "id": 45460,
                        "name": "Rennes",
                        "latitude": "48.11198000",
                        "longitude": "-1.67429000"
                    },
                    {
                        "id": 45468,
                        "name": "Retiers",
                        "latitude": "47.91392000",
                        "longitude": "-1.37967000"
                    },
                    {
                        "id": 45488,
                        "name": "Riantec",
                        "latitude": "47.71093000",
                        "longitude": "-3.31629000"
                    },
                    {
                        "id": 45499,
                        "name": "Riec-sur-Belon",
                        "latitude": "47.83333000",
                        "longitude": "-3.70000000"
                    },
                    {
                        "id": 45504,
                        "name": "Rieux",
                        "latitude": "47.59781000",
                        "longitude": "-2.10828000"
                    },
                    {
                        "id": 45561,
                        "name": "Rohan",
                        "latitude": "48.06833000",
                        "longitude": "-2.75120000"
                    },
                    {
                        "id": 45572,
                        "name": "Romagné",
                        "latitude": "48.34019000",
                        "longitude": "-1.27751000"
                    },
                    {
                        "id": 45581,
                        "name": "Romillé",
                        "latitude": "48.21619000",
                        "longitude": "-1.89229000"
                    },
                    {
                        "id": 45598,
                        "name": "Roscanvel",
                        "latitude": "48.31520000",
                        "longitude": "-4.54937000"
                    },
                    {
                        "id": 45599,
                        "name": "Roscoff",
                        "latitude": "48.72381000",
                        "longitude": "-3.98709000"
                    },
                    {
                        "id": 45608,
                        "name": "Rospez",
                        "latitude": "48.72940000",
                        "longitude": "-3.38364000"
                    },
                    {
                        "id": 45609,
                        "name": "Rosporden",
                        "latitude": "47.96667000",
                        "longitude": "-3.83333000"
                    },
                    {
                        "id": 45611,
                        "name": "Rostrenen",
                        "latitude": "48.23696000",
                        "longitude": "-3.31442000"
                    },
                    {
                        "id": 45650,
                        "name": "Roz-Landrieux",
                        "latitude": "48.54337000",
                        "longitude": "-1.81586000"
                    },
                    {
                        "id": 45651,
                        "name": "Roz-sur-Couesnon",
                        "latitude": "48.58867000",
                        "longitude": "-1.59213000"
                    },
                    {
                        "id": 45665,
                        "name": "Ruffiac",
                        "latitude": "47.81866000",
                        "longitude": "-2.28238000"
                    },
                    {
                        "id": 45728,
                        "name": "Saint-Agathon",
                        "latitude": "48.55867000",
                        "longitude": "-3.10525000"
                    },
                    {
                        "id": 45734,
                        "name": "Saint-Alban",
                        "latitude": "48.55630000",
                        "longitude": "-2.54013000"
                    },
                    {
                        "id": 45775,
                        "name": "Saint-Armel",
                        "latitude": "48.01305000",
                        "longitude": "-1.59152000"
                    },
                    {
                        "id": 45786,
                        "name": "Saint-Aubin-du-Cormier",
                        "latitude": "48.25843000",
                        "longitude": "-1.40252000"
                    },
                    {
                        "id": 45799,
                        "name": "Saint-Avé",
                        "latitude": "47.69085000",
                        "longitude": "-2.74648000"
                    },
                    {
                        "id": 45802,
                        "name": "Saint-Barnabé",
                        "latitude": "48.13712000",
                        "longitude": "-2.70483000"
                    },
                    {
                        "id": 45822,
                        "name": "Saint-Brandan",
                        "latitude": "48.39008000",
                        "longitude": "-2.86875000"
                    },
                    {
                        "id": 45824,
                        "name": "Saint-Briac-sur-Mer",
                        "latitude": "48.62189000",
                        "longitude": "-2.13435000"
                    },
                    {
                        "id": 45827,
                        "name": "Saint-Brice-en-Coglès",
                        "latitude": "48.41157000",
                        "longitude": "-1.37019000"
                    },
                    {
                        "id": 45830,
                        "name": "Saint-Brieuc",
                        "latitude": "48.51513000",
                        "longitude": "-2.76838000"
                    },
                    {
                        "id": 45833,
                        "name": "Saint-Broladre",
                        "latitude": "48.58677000",
                        "longitude": "-1.65769000"
                    },
                    {
                        "id": 45839,
                        "name": "Saint-Caradec",
                        "latitude": "48.19429000",
                        "longitude": "-2.84386000"
                    },
                    {
                        "id": 45840,
                        "name": "Saint-Carreuc",
                        "latitude": "48.39889000",
                        "longitude": "-2.73056000"
                    },
                    {
                        "id": 45842,
                        "name": "Saint-Cast-le-Guildo",
                        "latitude": "48.63028000",
                        "longitude": "-2.25777000"
                    },
                    {
                        "id": 45876,
                        "name": "Saint-Coulomb",
                        "latitude": "48.67465000",
                        "longitude": "-1.91092000"
                    },
                    {
                        "id": 45906,
                        "name": "Saint-Didier",
                        "latitude": "48.09506000",
                        "longitude": "-1.37276000"
                    },
                    {
                        "id": 45914,
                        "name": "Saint-Dolay",
                        "latitude": "47.54476000",
                        "longitude": "-2.15466000"
                    },
                    {
                        "id": 45915,
                        "name": "Saint-Domineuc",
                        "latitude": "48.37191000",
                        "longitude": "-1.87544000"
                    },
                    {
                        "id": 45916,
                        "name": "Saint-Donan",
                        "latitude": "48.46958000",
                        "longitude": "-2.88442000"
                    },
                    {
                        "id": 45921,
                        "name": "Saint-Erblon",
                        "latitude": "48.01895000",
                        "longitude": "-1.65162000"
                    },
                    {
                        "id": 46656,
                        "name": "Saint-Étienne-en-Coglès",
                        "latitude": "48.40172000",
                        "longitude": "-1.32812000"
                    },
                    {
                        "id": 46659,
                        "name": "Saint-Évarzec",
                        "latitude": "47.93333000",
                        "longitude": "-4.01667000"
                    },
                    {
                        "id": 45979,
                        "name": "Saint-Georges-de-Reintembault",
                        "latitude": "48.50744000",
                        "longitude": "-1.24328000"
                    },
                    {
                        "id": 46014,
                        "name": "Saint-Germain-en-Coglès",
                        "latitude": "48.40531000",
                        "longitude": "-1.26369000"
                    },
                    {
                        "id": 46032,
                        "name": "Saint-Gildas-de-Rhuys",
                        "latitude": "47.50060000",
                        "longitude": "-2.83825000"
                    },
                    {
                        "id": 46035,
                        "name": "Saint-Gilles",
                        "latitude": "48.15381000",
                        "longitude": "-1.82477000"
                    },
                    {
                        "id": 46040,
                        "name": "Saint-Gonnery",
                        "latitude": "48.12465000",
                        "longitude": "-2.81848000"
                    },
                    {
                        "id": 46042,
                        "name": "Saint-Grégoire",
                        "latitude": "48.15085000",
                        "longitude": "-1.68706000"
                    },
                    {
                        "id": 46073,
                        "name": "Saint-Hélen",
                        "latitude": "48.47002000",
                        "longitude": "-1.95894000"
                    },
                    {
                        "id": 46075,
                        "name": "Saint-Jacques-de-la-Lande",
                        "latitude": "48.06514000",
                        "longitude": "-1.72086000"
                    },
                    {
                        "id": 46077,
                        "name": "Saint-Jacut-les-Pins",
                        "latitude": "47.68581000",
                        "longitude": "-2.21514000"
                    },
                    {
                        "id": 46084,
                        "name": "Saint-Jean-Brévelay",
                        "latitude": "47.84497000",
                        "longitude": "-2.72231000"
                    },
                    {
                        "id": 46115,
                        "name": "Saint-Jean-la-Poterie",
                        "latitude": "47.63581000",
                        "longitude": "-2.12420000"
                    },
                    {
                        "id": 46119,
                        "name": "Saint-Jean-sur-Couesnon",
                        "latitude": "48.29013000",
                        "longitude": "-1.36835000"
                    },
                    {
                        "id": 46131,
                        "name": "Saint-Jouan-des-Guérets",
                        "latitude": "48.59932000",
                        "longitude": "-1.97372000"
                    },
                    {
                        "id": 46135,
                        "name": "Saint-Julien",
                        "latitude": "48.45142000",
                        "longitude": "-2.81250000"
                    },
                    {
                        "id": 46152,
                        "name": "Saint-Just",
                        "latitude": "47.76581000",
                        "longitude": "-1.96096000"
                    },
                    {
                        "id": 46205,
                        "name": "Saint-Lunaire",
                        "latitude": "48.63811000",
                        "longitude": "-2.11392000"
                    },
                    {
                        "id": 46229,
                        "name": "Saint-Malo",
                        "latitude": "48.64720000",
                        "longitude": "-2.00883000"
                    },
                    {
                        "id": 46240,
                        "name": "Saint-Marc-le-Blanc",
                        "latitude": "48.36498000",
                        "longitude": "-1.40938000"
                    },
                    {
                        "id": 46284,
                        "name": "Saint-Martin-des-Champs",
                        "latitude": "48.58333000",
                        "longitude": "-3.83333000"
                    },
                    {
                        "id": 46304,
                        "name": "Saint-Martin-sur-Oust",
                        "latitude": "47.74600000",
                        "longitude": "-2.25343000"
                    },
                    {
                        "id": 46351,
                        "name": "Saint-Médard-sur-Ille",
                        "latitude": "48.27202000",
                        "longitude": "-1.65968000"
                    },
                    {
                        "id": 46352,
                        "name": "Saint-Méen-le-Grand",
                        "latitude": "48.18971000",
                        "longitude": "-2.19486000"
                    },
                    {
                        "id": 46353,
                        "name": "Saint-Méloir-des-Ondes",
                        "latitude": "48.63790000",
                        "longitude": "-1.90448000"
                    },
                    {
                        "id": 46368,
                        "name": "Saint-Nicolas-du-Pélem",
                        "latitude": "48.31222000",
                        "longitude": "-3.16465000"
                    },
                    {
                        "id": 46371,
                        "name": "Saint-Nolff",
                        "latitude": "47.70365000",
                        "longitude": "-2.65209000"
                    },
                    {
                        "id": 46380,
                        "name": "Saint-Ouen-des-Alleux",
                        "latitude": "48.32805000",
                        "longitude": "-1.42590000"
                    },
                    {
                        "id": 46386,
                        "name": "Saint-Pabu",
                        "latitude": "48.56667000",
                        "longitude": "-4.60000000"
                    },
                    {
                        "id": 46477,
                        "name": "Saint-Père",
                        "latitude": "48.58727000",
                        "longitude": "-1.92413000"
                    },
                    {
                        "id": 46422,
                        "name": "Saint-Perreux",
                        "latitude": "47.66952000",
                        "longitude": "-2.10809000"
                    },
                    {
                        "id": 46426,
                        "name": "Saint-Philibert",
                        "latitude": "47.58821000",
                        "longitude": "-2.99978000"
                    },
                    {
                        "id": 46433,
                        "name": "Saint-Pierre-de-Plesguen",
                        "latitude": "48.44638000",
                        "longitude": "-1.91278000"
                    },
                    {
                        "id": 46430,
                        "name": "Saint-Pierre-Quiberon",
                        "latitude": "47.52061000",
                        "longitude": "-3.13084000"
                    },
                    {
                        "id": 46455,
                        "name": "Saint-Pol-de-Léon",
                        "latitude": "48.68333000",
                        "longitude": "-3.98333000"
                    },
                    {
                        "id": 46483,
                        "name": "Saint-Quay-Perros",
                        "latitude": "48.78333000",
                        "longitude": "-3.45000000"
                    },
                    {
                        "id": 46484,
                        "name": "Saint-Quay-Portrieux",
                        "latitude": "48.64992000",
                        "longitude": "-2.83059000"
                    },
                    {
                        "id": 46495,
                        "name": "Saint-Renan",
                        "latitude": "48.43333000",
                        "longitude": "-4.61667000"
                    },
                    {
                        "id": 46517,
                        "name": "Saint-Samson-sur-Rance",
                        "latitude": "48.49252000",
                        "longitude": "-2.02865000"
                    },
                    {
                        "id": 46535,
                        "name": "Saint-Sauveur-des-Landes",
                        "latitude": "48.34278000",
                        "longitude": "-1.31248000"
                    },
                    {
                        "id": 46547,
                        "name": "Saint-Senoux",
                        "latitude": "47.90552000",
                        "longitude": "-1.78819000"
                    },
                    {
                        "id": 46565,
                        "name": "Saint-Sulpice-la-Forêt",
                        "latitude": "48.21667000",
                        "longitude": "-1.57972000"
                    },
                    {
                        "id": 46584,
                        "name": "Saint-Thégonnec",
                        "latitude": "48.51667000",
                        "longitude": "-3.95000000"
                    },
                    {
                        "id": 46581,
                        "name": "Saint-Thonan",
                        "latitude": "48.48333000",
                        "longitude": "-4.33333000"
                    },
                    {
                        "id": 46582,
                        "name": "Saint-Thurial",
                        "latitude": "48.02924000",
                        "longitude": "-1.93181000"
                    },
                    {
                        "id": 46583,
                        "name": "Saint-Thuriau",
                        "latitude": "48.01667000",
                        "longitude": "-2.95000000"
                    },
                    {
                        "id": 46591,
                        "name": "Saint-Urbain",
                        "latitude": "48.40000000",
                        "longitude": "-4.23333000"
                    },
                    {
                        "id": 46618,
                        "name": "Saint-Vincent-sur-Oust",
                        "latitude": "47.70010000",
                        "longitude": "-2.14657000"
                    },
                    {
                        "id": 46632,
                        "name": "Saint-Yvi",
                        "latitude": "47.96667000",
                        "longitude": "-3.93333000"
                    },
                    {
                        "id": 46664,
                        "name": "Sainte-Anne-d'Auray",
                        "latitude": "47.70000000",
                        "longitude": "-2.95000000"
                    },
                    {
                        "id": 46698,
                        "name": "Sainte-Hélène",
                        "latitude": "47.71976000",
                        "longitude": "-3.20359000"
                    },
                    {
                        "id": 46707,
                        "name": "Sainte-Marie",
                        "latitude": "47.69429000",
                        "longitude": "-2.00190000"
                    },
                    {
                        "id": 46797,
                        "name": "Santec",
                        "latitude": "48.70000000",
                        "longitude": "-4.03333000"
                    },
                    {
                        "id": 46824,
                        "name": "Sarzeau",
                        "latitude": "47.52772000",
                        "longitude": "-2.76933000"
                    },
                    {
                        "id": 46894,
                        "name": "Scaër",
                        "latitude": "48.03333000",
                        "longitude": "-3.70000000"
                    },
                    {
                        "id": 47140,
                        "name": "Séné",
                        "latitude": "47.61900000",
                        "longitude": "-2.73700000"
                    },
                    {
                        "id": 46946,
                        "name": "Sens-de-Bretagne",
                        "latitude": "48.33245000",
                        "longitude": "-1.53535000"
                    },
                    {
                        "id": 47142,
                        "name": "Sérent",
                        "latitude": "47.82333000",
                        "longitude": "-2.50571000"
                    },
                    {
                        "id": 46974,
                        "name": "Servon-sur-Vilaine",
                        "latitude": "48.12114000",
                        "longitude": "-1.45971000"
                    },
                    {
                        "id": 47148,
                        "name": "Sévignac",
                        "latitude": "48.33297000",
                        "longitude": "-2.33915000"
                    },
                    {
                        "id": 46988,
                        "name": "Sibiril",
                        "latitude": "48.66667000",
                        "longitude": "-4.06667000"
                    },
                    {
                        "id": 47011,
                        "name": "Sixt-sur-Aff",
                        "latitude": "47.77648000",
                        "longitude": "-2.07867000"
                    },
                    {
                        "id": 47012,
                        "name": "Sizun",
                        "latitude": "48.40000000",
                        "longitude": "-4.08333000"
                    },
                    {
                        "id": 47096,
                        "name": "Spézet",
                        "latitude": "48.20000000",
                        "longitude": "-3.71667000"
                    },
                    {
                        "id": 47115,
                        "name": "Sulniac",
                        "latitude": "47.67375000",
                        "longitude": "-2.57136000"
                    },
                    {
                        "id": 47125,
                        "name": "Surzur",
                        "latitude": "47.57850000",
                        "longitude": "-2.62892000"
                    },
                    {
                        "id": 47154,
                        "name": "Taden",
                        "latitude": "48.47530000",
                        "longitude": "-2.01946000"
                    },
                    {
                        "id": 47163,
                        "name": "Talensac",
                        "latitude": "48.10847000",
                        "longitude": "-1.92829000"
                    },
                    {
                        "id": 47186,
                        "name": "Taulé",
                        "latitude": "48.60000000",
                        "longitude": "-3.90000000"
                    },
                    {
                        "id": 47187,
                        "name": "Taupont",
                        "latitude": "47.95961000",
                        "longitude": "-2.43933000"
                    },
                    {
                        "id": 47195,
                        "name": "Telgruc-sur-Mer",
                        "latitude": "48.23333000",
                        "longitude": "-4.35000000"
                    },
                    {
                        "id": 47221,
                        "name": "Theix",
                        "latitude": "47.62916000",
                        "longitude": "-2.65186000"
                    },
                    {
                        "id": 47290,
                        "name": "Tinténiac",
                        "latitude": "48.32860000",
                        "longitude": "-1.83630000"
                    },
                    {
                        "id": 47298,
                        "name": "Tonquédec",
                        "latitude": "48.66886000",
                        "longitude": "-3.39712000"
                    },
                    {
                        "id": 47301,
                        "name": "Torcé",
                        "latitude": "48.06120000",
                        "longitude": "-1.26708000"
                    },
                    {
                        "id": 47390,
                        "name": "Trébeurden",
                        "latitude": "48.76667000",
                        "longitude": "-3.56667000"
                    },
                    {
                        "id": 47391,
                        "name": "Trédarzec",
                        "latitude": "48.78583000",
                        "longitude": "-3.20100000"
                    },
                    {
                        "id": 47392,
                        "name": "Trédrez-Locquémeau",
                        "latitude": "48.70000000",
                        "longitude": "-3.56667000"
                    },
                    {
                        "id": 47351,
                        "name": "Treffiagat",
                        "latitude": "47.81667000",
                        "longitude": "-4.26667000"
                    },
                    {
                        "id": 47352,
                        "name": "Treffléan",
                        "latitude": "47.68163000",
                        "longitude": "-2.61287000"
                    },
                    {
                        "id": 47393,
                        "name": "Trégastel",
                        "latitude": "48.81667000",
                        "longitude": "-3.50000000"
                    },
                    {
                        "id": 47394,
                        "name": "Tréguier",
                        "latitude": "48.78333000",
                        "longitude": "-3.23333000"
                    },
                    {
                        "id": 47395,
                        "name": "Trégunc",
                        "latitude": "47.85000000",
                        "longitude": "-3.85000000"
                    },
                    {
                        "id": 47400,
                        "name": "Trélévern",
                        "latitude": "48.81071000",
                        "longitude": "-3.37141000"
                    },
                    {
                        "id": 47398,
                        "name": "Trélivan",
                        "latitude": "48.43198000",
                        "longitude": "-2.11748000"
                    },
                    {
                        "id": 47357,
                        "name": "Tremblay",
                        "latitude": "48.42216000",
                        "longitude": "-1.47555000"
                    },
                    {
                        "id": 47404,
                        "name": "Tréméven",
                        "latitude": "47.90000000",
                        "longitude": "-3.53333000"
                    },
                    {
                        "id": 47403,
                        "name": "Trémuson",
                        "latitude": "48.52325000",
                        "longitude": "-2.84833000"
                    },
                    {
                        "id": 47360,
                        "name": "Tresbœuf",
                        "latitude": "47.88333000",
                        "longitude": "-1.55000000"
                    },
                    {
                        "id": 47409,
                        "name": "Trévé",
                        "latitude": "48.21147000",
                        "longitude": "-2.79317000"
                    },
                    {
                        "id": 47407,
                        "name": "Trévou-Tréguignec",
                        "latitude": "48.81869000",
                        "longitude": "-3.34132000"
                    },
                    {
                        "id": 47504,
                        "name": "Vannes",
                        "latitude": "47.65790000",
                        "longitude": "-2.75574000"
                    },
                    {
                        "id": 47607,
                        "name": "Vern-sur-Seiche",
                        "latitude": "48.04514000",
                        "longitude": "-1.60057000"
                    },
                    {
                        "id": 47657,
                        "name": "Vezin-le-Coquet",
                        "latitude": "48.11857000",
                        "longitude": "-1.75466000"
                    },
                    {
                        "id": 47698,
                        "name": "Vignoc",
                        "latitude": "48.24842000",
                        "longitude": "-1.78169000"
                    },
                    {
                        "id": 47876,
                        "name": "Vitré",
                        "latitude": "48.11776000",
                        "longitude": "-1.20577000"
                    },
                    {
                        "id": 48006,
                        "name": "Yffiniac",
                        "latitude": "48.48428000",
                        "longitude": "-2.67647000"
                    },
                    {
                        "id": 48017,
                        "name": "Yvignac-la-Tour",
                        "latitude": "48.35000000",
                        "longitude": "-2.18333000"
                    }
                ]
            },
            {
                "id": 4981,
                "name": "Calvados",
                "iso2": "14",
                "latitude": "49.09035140",
                "longitude": "-0.91706480",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4982,
                "name": "Cantal",
                "iso2": "15",
                "latitude": "45.04921770",
                "longitude": "2.15672720",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4818,
                "name": "Centre-Val de Loire",
                "iso2": "CVL",
                "latitude": "47.75156860",
                "longitude": "1.67506310",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39237,
                        "name": "Abilly",
                        "latitude": "46.93333000",
                        "longitude": "0.73333000"
                    },
                    {
                        "id": 39244,
                        "name": "Abondant",
                        "latitude": "48.78590000",
                        "longitude": "1.44006000"
                    },
                    {
                        "id": 39279,
                        "name": "Aigurande",
                        "latitude": "46.43397000",
                        "longitude": "1.83026000"
                    },
                    {
                        "id": 39351,
                        "name": "Ambillou",
                        "latitude": "47.45100000",
                        "longitude": "0.44730000"
                    },
                    {
                        "id": 39355,
                        "name": "Amboise",
                        "latitude": "47.41249000",
                        "longitude": "0.98266000"
                    },
                    {
                        "id": 39365,
                        "name": "Amilly",
                        "latitude": "47.97281000",
                        "longitude": "2.77186000"
                    },
                    {
                        "id": 39394,
                        "name": "Anet",
                        "latitude": "48.85642000",
                        "longitude": "1.43981000"
                    },
                    {
                        "id": 39467,
                        "name": "Ardentes",
                        "latitude": "46.74191000",
                        "longitude": "1.83428000"
                    },
                    {
                        "id": 39478,
                        "name": "Argent-sur-Sauldre",
                        "latitude": "47.55847000",
                        "longitude": "2.44410000"
                    },
                    {
                        "id": 39483,
                        "name": "Argenton-sur-Creuse",
                        "latitude": "46.58997000",
                        "longitude": "1.51981000"
                    },
                    {
                        "id": 39492,
                        "name": "Armenonville-les-Gâtineaux",
                        "latitude": "48.54365000",
                        "longitude": "1.64750000"
                    },
                    {
                        "id": 39512,
                        "name": "Arrou",
                        "latitude": "48.09768000",
                        "longitude": "1.12851000"
                    },
                    {
                        "id": 39518,
                        "name": "Artannes-sur-Indre",
                        "latitude": "47.27451000",
                        "longitude": "0.60036000"
                    },
                    {
                        "id": 39521,
                        "name": "Artenay",
                        "latitude": "48.08246000",
                        "longitude": "1.88098000"
                    },
                    {
                        "id": 39524,
                        "name": "Arthon",
                        "latitude": "46.69361000",
                        "longitude": "1.69857000"
                    },
                    {
                        "id": 39541,
                        "name": "Aschères-le-Marché",
                        "latitude": "48.11008000",
                        "longitude": "2.00725000"
                    },
                    {
                        "id": 39559,
                        "name": "Athée-sur-Cher",
                        "latitude": "47.32023000",
                        "longitude": "0.91659000"
                    },
                    {
                        "id": 39582,
                        "name": "Aubigny-sur-Nère",
                        "latitude": "47.48819000",
                        "longitude": "2.43895000"
                    },
                    {
                        "id": 39618,
                        "name": "Aunay-sous-Auneau",
                        "latitude": "48.44140000",
                        "longitude": "1.81094000"
                    },
                    {
                        "id": 39620,
                        "name": "Auneau",
                        "latitude": "48.46361000",
                        "longitude": "1.77263000"
                    },
                    {
                        "id": 39636,
                        "name": "Authon-du-Perche",
                        "latitude": "48.19615000",
                        "longitude": "0.89189000"
                    },
                    {
                        "id": 39638,
                        "name": "Autry-le-Châtel",
                        "latitude": "47.59886000",
                        "longitude": "2.60200000"
                    },
                    {
                        "id": 39654,
                        "name": "Auzouer-en-Touraine",
                        "latitude": "47.54230000",
                        "longitude": "0.92067000"
                    },
                    {
                        "id": 39675,
                        "name": "Avoine",
                        "latitude": "47.20533000",
                        "longitude": "0.18253000"
                    },
                    {
                        "id": 39677,
                        "name": "Avord",
                        "latitude": "47.03514000",
                        "longitude": "2.65295000"
                    },
                    {
                        "id": 39693,
                        "name": "Azay-le-Ferron",
                        "latitude": "46.85097000",
                        "longitude": "1.07084000"
                    },
                    {
                        "id": 39694,
                        "name": "Azay-le-Rideau",
                        "latitude": "47.26405000",
                        "longitude": "0.47132000"
                    },
                    {
                        "id": 39695,
                        "name": "Azay-sur-Cher",
                        "latitude": "47.34966000",
                        "longitude": "0.84562000"
                    },
                    {
                        "id": 39698,
                        "name": "Azé",
                        "latitude": "47.85141000",
                        "longitude": "0.99829000"
                    },
                    {
                        "id": 39723,
                        "name": "Bailleau-l’Évêque",
                        "latitude": "48.48960000",
                        "longitude": "1.39665000"
                    },
                    {
                        "id": 39722,
                        "name": "Bailleau-le-Pin",
                        "latitude": "48.36698000",
                        "longitude": "1.32948000"
                    },
                    {
                        "id": 39752,
                        "name": "Ballan-Miré",
                        "latitude": "47.34057000",
                        "longitude": "0.61466000"
                    },
                    {
                        "id": 39786,
                        "name": "Barjouville",
                        "latitude": "48.41002000",
                        "longitude": "1.47639000"
                    },
                    {
                        "id": 39809,
                        "name": "Baugy",
                        "latitude": "47.08181000",
                        "longitude": "2.72848000"
                    },
                    {
                        "id": 39811,
                        "name": "Baule",
                        "latitude": "47.81084000",
                        "longitude": "1.67259000"
                    },
                    {
                        "id": 39832,
                        "name": "Bazoches-les-Gallerandes",
                        "latitude": "48.16540000",
                        "longitude": "2.04319000"
                    },
                    {
                        "id": 39848,
                        "name": "Beaugency",
                        "latitude": "47.78019000",
                        "longitude": "1.62705000"
                    },
                    {
                        "id": 39851,
                        "name": "Beaulieu-lès-Loches",
                        "latitude": "47.12526000",
                        "longitude": "1.01585000"
                    },
                    {
                        "id": 39867,
                        "name": "Beaumont-en-Véron",
                        "latitude": "47.19397000",
                        "longitude": "0.18436000"
                    },
                    {
                        "id": 39868,
                        "name": "Beaumont-la-Ronce",
                        "latitude": "47.56948000",
                        "longitude": "0.67017000"
                    },
                    {
                        "id": 39875,
                        "name": "Beaune-la-Rolande",
                        "latitude": "48.07124000",
                        "longitude": "2.43140000"
                    },
                    {
                        "id": 40422,
                        "name": "Bélâbre",
                        "latitude": "46.55121000",
                        "longitude": "1.15791000"
                    },
                    {
                        "id": 39912,
                        "name": "Bellegarde",
                        "latitude": "47.98333000",
                        "longitude": "2.43333000"
                    },
                    {
                        "id": 39924,
                        "name": "Belleville-sur-Loire",
                        "latitude": "47.50000000",
                        "longitude": "2.85000000"
                    },
                    {
                        "id": 40435,
                        "name": "Béville-le-Comte",
                        "latitude": "48.43558000",
                        "longitude": "1.71305000"
                    },
                    {
                        "id": 40053,
                        "name": "Blancafort",
                        "latitude": "47.53219000",
                        "longitude": "2.52981000"
                    },
                    {
                        "id": 40076,
                        "name": "Bléré",
                        "latitude": "47.32738000",
                        "longitude": "0.99186000"
                    },
                    {
                        "id": 40069,
                        "name": "Blois",
                        "latitude": "47.59432000",
                        "longitude": "1.32912000"
                    },
                    {
                        "id": 40083,
                        "name": "Boigny-sur-Bionne",
                        "latitude": "47.93333000",
                        "longitude": "2.01667000"
                    },
                    {
                        "id": 40091,
                        "name": "Boiscommun",
                        "latitude": "48.03576000",
                        "longitude": "2.38333000"
                    },
                    {
                        "id": 40124,
                        "name": "Bonneval",
                        "latitude": "48.18312000",
                        "longitude": "1.38524000"
                    },
                    {
                        "id": 40129,
                        "name": "Bonny-sur-Loire",
                        "latitude": "47.56172000",
                        "longitude": "2.83933000"
                    },
                    {
                        "id": 40170,
                        "name": "Boulleret",
                        "latitude": "47.42419000",
                        "longitude": "2.87343000"
                    },
                    {
                        "id": 40199,
                        "name": "Bourges",
                        "latitude": "47.08333000",
                        "longitude": "2.40000000"
                    },
                    {
                        "id": 40206,
                        "name": "Bourgueil",
                        "latitude": "47.28333000",
                        "longitude": "0.16612000"
                    },
                    {
                        "id": 40237,
                        "name": "Bouzy-la-Forêt",
                        "latitude": "47.85120000",
                        "longitude": "2.37773000"
                    },
                    {
                        "id": 40241,
                        "name": "Boynes",
                        "latitude": "48.11822000",
                        "longitude": "2.36006000"
                    },
                    {
                        "id": 40247,
                        "name": "Bracieux",
                        "latitude": "47.54895000",
                        "longitude": "1.54120000"
                    },
                    {
                        "id": 40267,
                        "name": "Bray-en-Val",
                        "latitude": "47.82856000",
                        "longitude": "2.36644000"
                    },
                    {
                        "id": 40299,
                        "name": "Brezolles",
                        "latitude": "48.69033000",
                        "longitude": "1.07404000"
                    },
                    {
                        "id": 40301,
                        "name": "Briare",
                        "latitude": "47.63343000",
                        "longitude": "2.74380000"
                    },
                    {
                        "id": 40304,
                        "name": "Bricy",
                        "latitude": "47.99847000",
                        "longitude": "1.77937000"
                    },
                    {
                        "id": 40317,
                        "name": "Brinon-sur-Sauldre",
                        "latitude": "47.56600000",
                        "longitude": "2.25647000"
                    },
                    {
                        "id": 40334,
                        "name": "Brou",
                        "latitude": "48.21719000",
                        "longitude": "1.16539000"
                    },
                    {
                        "id": 40438,
                        "name": "Bû",
                        "latitude": "48.79705000",
                        "longitude": "1.49702000"
                    },
                    {
                        "id": 40406,
                        "name": "Buzançais",
                        "latitude": "46.88877000",
                        "longitude": "1.41950000"
                    },
                    {
                        "id": 40508,
                        "name": "Candé-sur-Beuvron",
                        "latitude": "47.49499000",
                        "longitude": "1.25937000"
                    },
                    {
                        "id": 40511,
                        "name": "Cangey",
                        "latitude": "47.46718000",
                        "longitude": "1.06051000"
                    },
                    {
                        "id": 40635,
                        "name": "Cellettes",
                        "latitude": "47.52758000",
                        "longitude": "1.38102000"
                    },
                    {
                        "id": 40640,
                        "name": "Cepoy",
                        "latitude": "48.04795000",
                        "longitude": "2.73782000"
                    },
                    {
                        "id": 40643,
                        "name": "Cerdon",
                        "latitude": "47.63571000",
                        "longitude": "2.36277000"
                    },
                    {
                        "id": 40644,
                        "name": "Cerelles",
                        "latitude": "47.50168000",
                        "longitude": "0.68333000"
                    },
                    {
                        "id": 40672,
                        "name": "Chabris",
                        "latitude": "47.25343000",
                        "longitude": "1.65181000"
                    },
                    {
                        "id": 40676,
                        "name": "Chaillac",
                        "latitude": "46.43382000",
                        "longitude": "1.29889000"
                    },
                    {
                        "id": 40678,
                        "name": "Chailles",
                        "latitude": "47.54160000",
                        "longitude": "1.31220000"
                    },
                    {
                        "id": 40683,
                        "name": "Chaingy",
                        "latitude": "47.88326000",
                        "longitude": "1.77059000"
                    },
                    {
                        "id": 40932,
                        "name": "Châlette-sur-Loing",
                        "latitude": "48.01337000",
                        "longitude": "2.73587000"
                    },
                    {
                        "id": 40710,
                        "name": "Chambourg-sur-Indre",
                        "latitude": "47.18159000",
                        "longitude": "0.96863000"
                    },
                    {
                        "id": 40711,
                        "name": "Chambray-lès-Tours",
                        "latitude": "47.33537000",
                        "longitude": "0.70286000"
                    },
                    {
                        "id": 40737,
                        "name": "Champhol",
                        "latitude": "48.46813000",
                        "longitude": "1.50281000"
                    },
                    {
                        "id": 40757,
                        "name": "Chanceaux-sur-Choisille",
                        "latitude": "47.47145000",
                        "longitude": "0.70539000"
                    },
                    {
                        "id": 40762,
                        "name": "Changy-les-Bois",
                        "latitude": "47.85793000",
                        "longitude": "2.68543000"
                    },
                    {
                        "id": 40767,
                        "name": "Chanteau",
                        "latitude": "47.96651000",
                        "longitude": "1.97129000"
                    },
                    {
                        "id": 40778,
                        "name": "Chantôme",
                        "latitude": "46.41067000",
                        "longitude": "1.55590000"
                    },
                    {
                        "id": 40796,
                        "name": "Charentilly",
                        "latitude": "47.46981000",
                        "longitude": "0.60903000"
                    },
                    {
                        "id": 40797,
                        "name": "Charenton-du-Cher",
                        "latitude": "46.73007000",
                        "longitude": "2.64438000"
                    },
                    {
                        "id": 40799,
                        "name": "Chargé",
                        "latitude": "47.43270000",
                        "longitude": "1.03037000"
                    },
                    {
                        "id": 40936,
                        "name": "Chârost",
                        "latitude": "46.99390000",
                        "longitude": "2.11639000"
                    },
                    {
                        "id": 40819,
                        "name": "Chartres",
                        "latitude": "48.44685000",
                        "longitude": "1.48925000"
                    },
                    {
                        "id": 40949,
                        "name": "Château-la-Vallière",
                        "latitude": "47.54665000",
                        "longitude": "0.32458000"
                    },
                    {
                        "id": 40943,
                        "name": "Château-Renard",
                        "latitude": "47.93333000",
                        "longitude": "2.93333000"
                    },
                    {
                        "id": 40944,
                        "name": "Château-Renault",
                        "latitude": "47.59188000",
                        "longitude": "0.91143000"
                    },
                    {
                        "id": 40953,
                        "name": "Châteaudun",
                        "latitude": "48.07086000",
                        "longitude": "1.33783000"
                    },
                    {
                        "id": 40958,
                        "name": "Châteaumeillant",
                        "latitude": "46.56219000",
                        "longitude": "2.19515000"
                    },
                    {
                        "id": 40967,
                        "name": "Châteauneuf-en-Thymerais",
                        "latitude": "48.58112000",
                        "longitude": "1.24085000"
                    },
                    {
                        "id": 40972,
                        "name": "Châteauneuf-sur-Cher",
                        "latitude": "46.85778000",
                        "longitude": "2.31710000"
                    },
                    {
                        "id": 40974,
                        "name": "Châteauneuf-sur-Loire",
                        "latitude": "47.86575000",
                        "longitude": "2.21903000"
                    },
                    {
                        "id": 40978,
                        "name": "Châteauroux",
                        "latitude": "46.81248000",
                        "longitude": "1.69362000"
                    },
                    {
                        "id": 40993,
                        "name": "Châtillon-Coligny",
                        "latitude": "47.82266000",
                        "longitude": "2.84563000"
                    },
                    {
                        "id": 41000,
                        "name": "Châtillon-sur-Cher",
                        "latitude": "47.27571000",
                        "longitude": "1.49424000"
                    },
                    {
                        "id": 41002,
                        "name": "Châtillon-sur-Indre",
                        "latitude": "46.98735000",
                        "longitude": "1.17218000"
                    },
                    {
                        "id": 41008,
                        "name": "Châtres-sur-Cher",
                        "latitude": "47.26505000",
                        "longitude": "1.90591000"
                    },
                    {
                        "id": 40837,
                        "name": "Chaudon",
                        "latitude": "48.66276000",
                        "longitude": "1.49670000"
                    },
                    {
                        "id": 40845,
                        "name": "Chaumont-sur-Loire",
                        "latitude": "47.48108000",
                        "longitude": "1.18929000"
                    },
                    {
                        "id": 40846,
                        "name": "Chaumont-sur-Tharonne",
                        "latitude": "47.61039000",
                        "longitude": "1.90514000"
                    },
                    {
                        "id": 41010,
                        "name": "Chécy",
                        "latitude": "47.89402000",
                        "longitude": "2.02304000"
                    },
                    {
                        "id": 40868,
                        "name": "Cheillé",
                        "latitude": "47.26114000",
                        "longitude": "0.40553000"
                    },
                    {
                        "id": 40880,
                        "name": "Cher",
                        "latitude": "47.11304000",
                        "longitude": "2.50983000"
                    },
                    {
                        "id": 40882,
                        "name": "Cherisy",
                        "latitude": "48.75000000",
                        "longitude": "1.43333000"
                    },
                    {
                        "id": 40895,
                        "name": "Cheverny",
                        "latitude": "47.50079000",
                        "longitude": "1.45951000"
                    },
                    {
                        "id": 40898,
                        "name": "Chevillon-sur-Huillard",
                        "latitude": "47.96197000",
                        "longitude": "2.62601000"
                    },
                    {
                        "id": 40899,
                        "name": "Chevilly",
                        "latitude": "48.02973000",
                        "longitude": "1.87402000"
                    },
                    {
                        "id": 40907,
                        "name": "Chilleurs-aux-Bois",
                        "latitude": "48.07220000",
                        "longitude": "2.13540000"
                    },
                    {
                        "id": 40912,
                        "name": "Chinon",
                        "latitude": "47.16701000",
                        "longitude": "0.24284000"
                    },
                    {
                        "id": 40916,
                        "name": "Chissay-en-Touraine",
                        "latitude": "47.33747000",
                        "longitude": "1.13362000"
                    },
                    {
                        "id": 40917,
                        "name": "Chitenay",
                        "latitude": "47.49753000",
                        "longitude": "1.37139000"
                    },
                    {
                        "id": 40928,
                        "name": "Chouzé-sur-Loire",
                        "latitude": "47.23673000",
                        "longitude": "0.12364000"
                    },
                    {
                        "id": 40927,
                        "name": "Chouzy-sur-Cisse",
                        "latitude": "47.52576000",
                        "longitude": "1.24661000"
                    },
                    {
                        "id": 41021,
                        "name": "Cinq-Mars-la-Pile",
                        "latitude": "47.34638000",
                        "longitude": "0.45873000"
                    },
                    {
                        "id": 41032,
                        "name": "Civray-de-Touraine",
                        "latitude": "47.33253000",
                        "longitude": "1.04952000"
                    },
                    {
                        "id": 41075,
                        "name": "Cléré-les-Pins",
                        "latitude": "47.42550000",
                        "longitude": "0.38963000"
                    },
                    {
                        "id": 41074,
                        "name": "Cléry-Saint-André",
                        "latitude": "47.82218000",
                        "longitude": "1.75091000"
                    },
                    {
                        "id": 41055,
                        "name": "Clion",
                        "latitude": "46.94085000",
                        "longitude": "1.23214000"
                    },
                    {
                        "id": 41061,
                        "name": "Cloyes-sur-le-Loir",
                        "latitude": "47.99726000",
                        "longitude": "1.23711000"
                    },
                    {
                        "id": 41062,
                        "name": "Cluis",
                        "latitude": "46.54486000",
                        "longitude": "1.74933000"
                    },
                    {
                        "id": 41156,
                        "name": "Contres",
                        "latitude": "47.41754000",
                        "longitude": "1.42849000"
                    },
                    {
                        "id": 41165,
                        "name": "Corbeilles",
                        "latitude": "48.07201000",
                        "longitude": "2.55030000"
                    },
                    {
                        "id": 41182,
                        "name": "Cormeray",
                        "latitude": "47.49195000",
                        "longitude": "1.40610000"
                    },
                    {
                        "id": 41183,
                        "name": "Cormery",
                        "latitude": "47.26812000",
                        "longitude": "0.83583000"
                    },
                    {
                        "id": 41201,
                        "name": "Corquilleroy",
                        "latitude": "48.04212000",
                        "longitude": "2.70382000"
                    },
                    {
                        "id": 41231,
                        "name": "Coullons",
                        "latitude": "47.62105000",
                        "longitude": "2.49258000"
                    },
                    {
                        "id": 41234,
                        "name": "Coulombs",
                        "latitude": "48.65253000",
                        "longitude": "1.54646000"
                    },
                    {
                        "id": 41240,
                        "name": "Cour-Cheverny",
                        "latitude": "47.51033000",
                        "longitude": "1.45583000"
                    },
                    {
                        "id": 41263,
                        "name": "Cours-les-Barres",
                        "latitude": "47.02513000",
                        "longitude": "3.03167000"
                    },
                    {
                        "id": 41268,
                        "name": "Courtenay",
                        "latitude": "48.03901000",
                        "longitude": "3.05851000"
                    },
                    {
                        "id": 41272,
                        "name": "Courville-sur-Eure",
                        "latitude": "48.44899000",
                        "longitude": "1.24085000"
                    },
                    {
                        "id": 41361,
                        "name": "Cuffy",
                        "latitude": "46.96275000",
                        "longitude": "3.05238000"
                    },
                    {
                        "id": 41403,
                        "name": "Dadonville",
                        "latitude": "48.15776000",
                        "longitude": "2.27150000"
                    },
                    {
                        "id": 41414,
                        "name": "Dammarie",
                        "latitude": "48.34314000",
                        "longitude": "1.49444000"
                    },
                    {
                        "id": 41419,
                        "name": "Dampierre-en-Burly",
                        "latitude": "47.76143000",
                        "longitude": "2.51962000"
                    },
                    {
                        "id": 41437,
                        "name": "Darvoy",
                        "latitude": "47.85839000",
                        "longitude": "2.10033000"
                    },
                    {
                        "id": 41602,
                        "name": "Déols",
                        "latitude": "46.82934000",
                        "longitude": "1.70428000"
                    },
                    {
                        "id": 41603,
                        "name": "Département d'Eure-et-Loir",
                        "latitude": "48.50000000",
                        "longitude": "1.50000000"
                    },
                    {
                        "id": 41605,
                        "name": "Département d'Indre-et-Loire",
                        "latitude": "47.25000000",
                        "longitude": "0.75000000"
                    },
                    {
                        "id": 41619,
                        "name": "Département de l'Indre",
                        "latitude": "46.83333000",
                        "longitude": "1.66667000"
                    },
                    {
                        "id": 41641,
                        "name": "Département du Loir-et-Cher",
                        "latitude": "47.50000000",
                        "longitude": "1.50000000"
                    },
                    {
                        "id": 41455,
                        "name": "Descartes",
                        "latitude": "46.96667000",
                        "longitude": "0.70000000"
                    },
                    {
                        "id": 41464,
                        "name": "Dhuizon",
                        "latitude": "47.58723000",
                        "longitude": "1.65809000"
                    },
                    {
                        "id": 41533,
                        "name": "Donnery",
                        "latitude": "47.91486000",
                        "longitude": "2.10299000"
                    },
                    {
                        "id": 41538,
                        "name": "Dordives",
                        "latitude": "48.14253000",
                        "longitude": "2.76775000"
                    },
                    {
                        "id": 41548,
                        "name": "Douchy",
                        "latitude": "47.94282000",
                        "longitude": "3.05392000"
                    },
                    {
                        "id": 41574,
                        "name": "Dreux",
                        "latitude": "48.73649000",
                        "longitude": "1.36566000"
                    },
                    {
                        "id": 41577,
                        "name": "Droué",
                        "latitude": "48.04023000",
                        "longitude": "1.07534000"
                    },
                    {
                        "id": 41576,
                        "name": "Droue-sur-Drouette",
                        "latitude": "48.60053000",
                        "longitude": "1.70113000"
                    },
                    {
                        "id": 41582,
                        "name": "Dry",
                        "latitude": "47.79612000",
                        "longitude": "1.71330000"
                    },
                    {
                        "id": 41590,
                        "name": "Dun-sur-Auron",
                        "latitude": "46.88490000",
                        "longitude": "2.57345000"
                    },
                    {
                        "id": 48053,
                        "name": "Écueillé",
                        "latitude": "47.08462000",
                        "longitude": "1.34668000"
                    },
                    {
                        "id": 48062,
                        "name": "Éguzon-Chantôme",
                        "latitude": "46.45000000",
                        "longitude": "1.58333000"
                    },
                    {
                        "id": 48074,
                        "name": "Épernon",
                        "latitude": "48.61031000",
                        "longitude": "1.67218000"
                    },
                    {
                        "id": 48076,
                        "name": "Épieds-en-Beauce",
                        "latitude": "47.95066000",
                        "longitude": "1.61732000"
                    },
                    {
                        "id": 41739,
                        "name": "Esvres",
                        "latitude": "47.28537000",
                        "longitude": "0.78588000"
                    },
                    {
                        "id": 41785,
                        "name": "Faverolles-sur-Cher",
                        "latitude": "47.31732000",
                        "longitude": "1.19045000"
                    },
                    {
                        "id": 41787,
                        "name": "Fay-aux-Loges",
                        "latitude": "47.92724000",
                        "longitude": "2.14012000"
                    },
                    {
                        "id": 42006,
                        "name": "Férolles",
                        "latitude": "47.83475000",
                        "longitude": "2.11113000"
                    },
                    {
                        "id": 41849,
                        "name": "Fleury-les-Aubrais",
                        "latitude": "47.93328000",
                        "longitude": "1.91811000"
                    },
                    {
                        "id": 41941,
                        "name": "Foëcy",
                        "latitude": "47.17618000",
                        "longitude": "2.16257000"
                    },
                    {
                        "id": 41873,
                        "name": "Fondettes",
                        "latitude": "47.40350000",
                        "longitude": "0.59686000"
                    },
                    {
                        "id": 41879,
                        "name": "Fontaine-la-Guyon",
                        "latitude": "48.47270000",
                        "longitude": "1.31417000"
                    },
                    {
                        "id": 41903,
                        "name": "Fontenay-sur-Loing",
                        "latitude": "48.10365000",
                        "longitude": "2.77542000"
                    },
                    {
                        "id": 41995,
                        "name": "Fussy",
                        "latitude": "47.14372000",
                        "longitude": "2.42953000"
                    },
                    {
                        "id": 42021,
                        "name": "Gallardon",
                        "latitude": "48.52622000",
                        "longitude": "1.69307000"
                    },
                    {
                        "id": 42046,
                        "name": "Garnay",
                        "latitude": "48.70489000",
                        "longitude": "1.33706000"
                    },
                    {
                        "id": 42051,
                        "name": "Gasville-Oisème",
                        "latitude": "48.46973000",
                        "longitude": "1.53843000"
                    },
                    {
                        "id": 42065,
                        "name": "Genillé",
                        "latitude": "47.18333000",
                        "longitude": "1.10000000"
                    },
                    {
                        "id": 42087,
                        "name": "Gidy",
                        "latitude": "47.98539000",
                        "longitude": "1.83816000"
                    },
                    {
                        "id": 42088,
                        "name": "Gien",
                        "latitude": "47.69332000",
                        "longitude": "2.63094000"
                    },
                    {
                        "id": 42112,
                        "name": "Gièvres",
                        "latitude": "47.27847000",
                        "longitude": "1.66943000"
                    },
                    {
                        "id": 42194,
                        "name": "Graçay",
                        "latitude": "47.14371000",
                        "longitude": "1.84733000"
                    },
                    {
                        "id": 42322,
                        "name": "Hanches",
                        "latitude": "48.60115000",
                        "longitude": "1.65137000"
                    },
                    {
                        "id": 42369,
                        "name": "Henrichemont",
                        "latitude": "47.30333000",
                        "longitude": "2.52458000"
                    },
                    {
                        "id": 42371,
                        "name": "Herbault",
                        "latitude": "47.60501000",
                        "longitude": "1.13934000"
                    },
                    {
                        "id": 42384,
                        "name": "Herry",
                        "latitude": "47.21667000",
                        "longitude": "2.95385000"
                    },
                    {
                        "id": 42437,
                        "name": "Huismes",
                        "latitude": "47.23319000",
                        "longitude": "0.25116000"
                    },
                    {
                        "id": 42438,
                        "name": "Huisseau-sur-Cosson",
                        "latitude": "47.59335000",
                        "longitude": "1.45333000"
                    },
                    {
                        "id": 42439,
                        "name": "Huisseau-sur-Mauves",
                        "latitude": "47.89319000",
                        "longitude": "1.70274000"
                    },
                    {
                        "id": 42489,
                        "name": "Ingré",
                        "latitude": "47.91995000",
                        "longitude": "1.82778000"
                    },
                    {
                        "id": 42507,
                        "name": "Issoudun",
                        "latitude": "46.94848000",
                        "longitude": "1.99362000"
                    },
                    {
                        "id": 42527,
                        "name": "Janville",
                        "latitude": "48.20284000",
                        "longitude": "1.88020000"
                    },
                    {
                        "id": 42532,
                        "name": "Jargeau",
                        "latitude": "47.86316000",
                        "longitude": "2.12648000"
                    },
                    {
                        "id": 42579,
                        "name": "Joué-lès-Tours",
                        "latitude": "47.35223000",
                        "longitude": "0.66905000"
                    },
                    {
                        "id": 42568,
                        "name": "Jouet-sur-l'Aubois",
                        "latitude": "47.04562000",
                        "longitude": "2.98725000"
                    },
                    {
                        "id": 42572,
                        "name": "Jouy",
                        "latitude": "48.51005000",
                        "longitude": "1.54501000"
                    },
                    {
                        "id": 42577,
                        "name": "Jouy-le-Potier",
                        "latitude": "47.74553000",
                        "longitude": "1.81115000"
                    },
                    {
                        "id": 42628,
                        "name": "L'Île-Bouchard",
                        "latitude": "47.11667000",
                        "longitude": "0.41667000"
                    },
                    {
                        "id": 42638,
                        "name": "La Bazoche-Gouet",
                        "latitude": "48.13985000",
                        "longitude": "0.98163000"
                    },
                    {
                        "id": 42671,
                        "name": "La Celle-Saint-Avant",
                        "latitude": "47.02200000",
                        "longitude": "0.60488000"
                    },
                    {
                        "id": 42696,
                        "name": "La Chapelle-du-Noyer",
                        "latitude": "48.03191000",
                        "longitude": "1.30953000"
                    },
                    {
                        "id": 42688,
                        "name": "La Chapelle-Saint-Mesmin",
                        "latitude": "47.88648000",
                        "longitude": "1.83450000"
                    },
                    {
                        "id": 42689,
                        "name": "La Chapelle-Saint-Ursin",
                        "latitude": "47.06248000",
                        "longitude": "2.32447000"
                    },
                    {
                        "id": 42701,
                        "name": "La Chapelle-sur-Loire",
                        "latitude": "47.25063000",
                        "longitude": "0.21887000"
                    },
                    {
                        "id": 42707,
                        "name": "La Châtre",
                        "latitude": "46.58228000",
                        "longitude": "1.98734000"
                    },
                    {
                        "id": 42704,
                        "name": "La Chaussée-Saint-Victor",
                        "latitude": "47.61621000",
                        "longitude": "1.36765000"
                    },
                    {
                        "id": 42724,
                        "name": "La Croix-en-Touraine",
                        "latitude": "47.34031000",
                        "longitude": "0.99024000"
                    },
                    {
                        "id": 42739,
                        "name": "La Ferté-Imbault",
                        "latitude": "47.38467000",
                        "longitude": "1.95344000"
                    },
                    {
                        "id": 42742,
                        "name": "La Ferté-Saint-Aubin",
                        "latitude": "47.71695000",
                        "longitude": "1.93904000"
                    },
                    {
                        "id": 42795,
                        "name": "La Loupe",
                        "latitude": "48.47320000",
                        "longitude": "1.01585000"
                    },
                    {
                        "id": 42804,
                        "name": "La Membrolle-sur-Choisille",
                        "latitude": "47.43719000",
                        "longitude": "0.63163000"
                    },
                    {
                        "id": 42847,
                        "name": "La Riche",
                        "latitude": "47.38996000",
                        "longitude": "0.67072000"
                    },
                    {
                        "id": 42912,
                        "name": "La Ville-aux-Clercs",
                        "latitude": "47.91835000",
                        "longitude": "1.08521000"
                    },
                    {
                        "id": 42913,
                        "name": "La Ville-aux-Dames",
                        "latitude": "47.39551000",
                        "longitude": "0.76837000"
                    },
                    {
                        "id": 42952,
                        "name": "Ladon",
                        "latitude": "48.00259000",
                        "longitude": "2.53724000"
                    },
                    {
                        "id": 42969,
                        "name": "Lailly-en-Val",
                        "latitude": "47.76962000",
                        "longitude": "1.68657000"
                    },
                    {
                        "id": 42992,
                        "name": "Lamotte-Beuvron",
                        "latitude": "47.60200000",
                        "longitude": "2.02837000"
                    },
                    {
                        "id": 43022,
                        "name": "Langeais",
                        "latitude": "47.32587000",
                        "longitude": "0.40136000"
                    },
                    {
                        "id": 43083,
                        "name": "Larçay",
                        "latitude": "47.36649000",
                        "longitude": "0.78145000"
                    },
                    {
                        "id": 43130,
                        "name": "Le Blanc",
                        "latitude": "46.63371000",
                        "longitude": "1.06272000"
                    },
                    {
                        "id": 43168,
                        "name": "Le Châtelet",
                        "latitude": "46.64247000",
                        "longitude": "2.28229000"
                    },
                    {
                        "id": 43172,
                        "name": "Le Coudray",
                        "latitude": "48.42115000",
                        "longitude": "1.50057000"
                    },
                    {
                        "id": 43198,
                        "name": "Le Grand-Pressigny",
                        "latitude": "46.92017000",
                        "longitude": "0.80380000"
                    },
                    {
                        "id": 43289,
                        "name": "Le Pêchereau",
                        "latitude": "46.57677000",
                        "longitude": "1.54743000"
                    },
                    {
                        "id": 43271,
                        "name": "Le Poinçonnet",
                        "latitude": "46.76410000",
                        "longitude": "1.71790000"
                    },
                    {
                        "id": 43691,
                        "name": "Léré",
                        "latitude": "47.46867000",
                        "longitude": "2.86981000"
                    },
                    {
                        "id": 43358,
                        "name": "Les Aix-d’Angillon",
                        "latitude": "47.19652000",
                        "longitude": "2.56506000"
                    },
                    {
                        "id": 43410,
                        "name": "Les Montils",
                        "latitude": "47.49499000",
                        "longitude": "1.29775000"
                    },
                    {
                        "id": 43680,
                        "name": "Lèves",
                        "latitude": "48.47065000",
                        "longitude": "1.48194000"
                    },
                    {
                        "id": 43451,
                        "name": "Levet",
                        "latitude": "46.92605000",
                        "longitude": "2.40732000"
                    },
                    {
                        "id": 43453,
                        "name": "Levroux",
                        "latitude": "46.97860000",
                        "longitude": "1.61243000"
                    },
                    {
                        "id": 43476,
                        "name": "Lignières",
                        "latitude": "46.75152000",
                        "longitude": "2.17381000"
                    },
                    {
                        "id": 43480,
                        "name": "Ligny-le-Ribault",
                        "latitude": "47.68419000",
                        "longitude": "1.78153000"
                    },
                    {
                        "id": 43482,
                        "name": "Ligré",
                        "latitude": "47.11185000",
                        "longitude": "0.27562000"
                    },
                    {
                        "id": 43483,
                        "name": "Ligueil",
                        "latitude": "47.04210000",
                        "longitude": "0.81893000"
                    },
                    {
                        "id": 43527,
                        "name": "Loches",
                        "latitude": "47.12858000",
                        "longitude": "0.99522000"
                    },
                    {
                        "id": 43542,
                        "name": "Loiret",
                        "latitude": "47.93598000",
                        "longitude": "2.30173000"
                    },
                    {
                        "id": 43595,
                        "name": "Lorris",
                        "latitude": "47.88950000",
                        "longitude": "2.51478000"
                    },
                    {
                        "id": 43610,
                        "name": "Loury",
                        "latitude": "47.99944000",
                        "longitude": "2.08474000"
                    },
                    {
                        "id": 43627,
                        "name": "Luant",
                        "latitude": "46.73300000",
                        "longitude": "1.55793000"
                    },
                    {
                        "id": 43675,
                        "name": "Luçay-le-Mâle",
                        "latitude": "47.12996000",
                        "longitude": "1.44173000"
                    },
                    {
                        "id": 43638,
                        "name": "Lucé",
                        "latitude": "48.43689000",
                        "longitude": "1.46359000"
                    },
                    {
                        "id": 43644,
                        "name": "Luisant",
                        "latitude": "48.42950000",
                        "longitude": "1.47383000"
                    },
                    {
                        "id": 43651,
                        "name": "Lunay",
                        "latitude": "47.80864000",
                        "longitude": "0.91499000"
                    },
                    {
                        "id": 43655,
                        "name": "Lunery",
                        "latitude": "46.93569000",
                        "longitude": "2.26895000"
                    },
                    {
                        "id": 43657,
                        "name": "Luray",
                        "latitude": "48.72035000",
                        "longitude": "1.39889000"
                    },
                    {
                        "id": 43669,
                        "name": "Luynes",
                        "latitude": "47.38441000",
                        "longitude": "0.55470000"
                    },
                    {
                        "id": 43739,
                        "name": "Maintenon",
                        "latitude": "48.58704000",
                        "longitude": "1.57847000"
                    },
                    {
                        "id": 43740,
                        "name": "Mainvilliers",
                        "latitude": "48.45003000",
                        "longitude": "1.45607000"
                    },
                    {
                        "id": 43756,
                        "name": "Malesherbes",
                        "latitude": "48.29566000",
                        "longitude": "2.40935000"
                    },
                    {
                        "id": 43786,
                        "name": "Manthelan",
                        "latitude": "47.13632000",
                        "longitude": "0.79319000"
                    },
                    {
                        "id": 43794,
                        "name": "Marboué",
                        "latitude": "48.11377000",
                        "longitude": "1.33210000"
                    },
                    {
                        "id": 43805,
                        "name": "Marcilly-en-Villette",
                        "latitude": "47.76505000",
                        "longitude": "2.02266000"
                    },
                    {
                        "id": 43818,
                        "name": "Mardié",
                        "latitude": "47.88617000",
                        "longitude": "2.05745000"
                    },
                    {
                        "id": 43819,
                        "name": "Mareau-aux-Prés",
                        "latitude": "47.86667000",
                        "longitude": "1.78333000"
                    },
                    {
                        "id": 43829,
                        "name": "Mareuil-sur-Cher",
                        "latitude": "47.29314000",
                        "longitude": "1.32897000"
                    },
                    {
                        "id": 43836,
                        "name": "Margon",
                        "latitude": "48.33568000",
                        "longitude": "0.83454000"
                    },
                    {
                        "id": 43843,
                        "name": "Marigny-les-Usages",
                        "latitude": "47.95799000",
                        "longitude": "2.01462000"
                    },
                    {
                        "id": 43858,
                        "name": "Marmagne",
                        "latitude": "47.10000000",
                        "longitude": "2.28333000"
                    },
                    {
                        "id": 43920,
                        "name": "Martizay",
                        "latitude": "46.80767000",
                        "longitude": "1.04324000"
                    },
                    {
                        "id": 43931,
                        "name": "Massay",
                        "latitude": "47.15324000",
                        "longitude": "1.99334000"
                    },
                    {
                        "id": 43976,
                        "name": "Mazières-de-Touraine",
                        "latitude": "47.38326000",
                        "longitude": "0.42548000"
                    },
                    {
                        "id": 43985,
                        "name": "Mehun-sur-Yèvre",
                        "latitude": "47.13782000",
                        "longitude": "2.21105000"
                    },
                    {
                        "id": 44464,
                        "name": "Ménestreau-en-Villette",
                        "latitude": "47.69962000",
                        "longitude": "2.02333000"
                    },
                    {
                        "id": 44000,
                        "name": "Menetou-Salon",
                        "latitude": "47.23172000",
                        "longitude": "2.48715000"
                    },
                    {
                        "id": 44009,
                        "name": "Mer",
                        "latitude": "47.70555000",
                        "longitude": "1.50621000"
                    },
                    {
                        "id": 44469,
                        "name": "Méreau",
                        "latitude": "47.16295000",
                        "longitude": "2.05086000"
                    },
                    {
                        "id": 44039,
                        "name": "Mettray",
                        "latitude": "47.45251000",
                        "longitude": "0.64939000"
                    },
                    {
                        "id": 44047,
                        "name": "Meung-sur-Loire",
                        "latitude": "47.83124000",
                        "longitude": "1.69582000"
                    },
                    {
                        "id": 44488,
                        "name": "Mézières-en-Brenne",
                        "latitude": "46.81979000",
                        "longitude": "1.21123000"
                    },
                    {
                        "id": 44489,
                        "name": "Mézières-en-Drouais",
                        "latitude": "48.72413000",
                        "longitude": "1.42440000"
                    },
                    {
                        "id": 44138,
                        "name": "Mondoubleau",
                        "latitude": "47.98061000",
                        "longitude": "0.89782000"
                    },
                    {
                        "id": 44144,
                        "name": "Monnaie",
                        "latitude": "47.50162000",
                        "longitude": "0.78872000"
                    },
                    {
                        "id": 44162,
                        "name": "Mont-près-Chambord",
                        "latitude": "47.56235000",
                        "longitude": "1.45712000"
                    },
                    {
                        "id": 44179,
                        "name": "Montargis",
                        "latitude": "47.99696000",
                        "longitude": "2.73261000"
                    },
                    {
                        "id": 44193,
                        "name": "Montbazon",
                        "latitude": "47.28348000",
                        "longitude": "0.69988000"
                    },
                    {
                        "id": 44211,
                        "name": "Montcresson",
                        "latitude": "47.90561000",
                        "longitude": "2.80796000"
                    },
                    {
                        "id": 44248,
                        "name": "Montgivray",
                        "latitude": "46.60324000",
                        "longitude": "1.98162000"
                    },
                    {
                        "id": 44254,
                        "name": "Montierchaume",
                        "latitude": "46.86362000",
                        "longitude": "1.77181000"
                    },
                    {
                        "id": 44274,
                        "name": "Montlivault",
                        "latitude": "47.63987000",
                        "longitude": "1.44487000"
                    },
                    {
                        "id": 44275,
                        "name": "Montlouis-sur-Loire",
                        "latitude": "47.38845000",
                        "longitude": "0.83208000"
                    },
                    {
                        "id": 44293,
                        "name": "Montoire-sur-le-Loir",
                        "latitude": "47.75316000",
                        "longitude": "0.86525000"
                    },
                    {
                        "id": 44317,
                        "name": "Montrichard",
                        "latitude": "47.34310000",
                        "longitude": "1.18653000"
                    },
                    {
                        "id": 44327,
                        "name": "Monts",
                        "latitude": "47.27723000",
                        "longitude": "0.62473000"
                    },
                    {
                        "id": 44339,
                        "name": "Morancez",
                        "latitude": "48.40051000",
                        "longitude": "1.49388000"
                    },
                    {
                        "id": 44379,
                        "name": "Morée",
                        "latitude": "47.90397000",
                        "longitude": "1.23421000"
                    },
                    {
                        "id": 44431,
                        "name": "Muides-sur-Loire",
                        "latitude": "47.66958000",
                        "longitude": "1.52694000"
                    },
                    {
                        "id": 44438,
                        "name": "Mur-de-Sologne",
                        "latitude": "47.41239000",
                        "longitude": "1.60832000"
                    },
                    {
                        "id": 44515,
                        "name": "Nargis",
                        "latitude": "48.11106000",
                        "longitude": "2.75597000"
                    },
                    {
                        "id": 44522,
                        "name": "Naveil",
                        "latitude": "47.79576000",
                        "longitude": "1.03222000"
                    },
                    {
                        "id": 44526,
                        "name": "Nazelles-Négron",
                        "latitude": "47.43333000",
                        "longitude": "0.95000000"
                    },
                    {
                        "id": 44696,
                        "name": "Nérondes",
                        "latitude": "46.99758000",
                        "longitude": "2.81834000"
                    },
                    {
                        "id": 44554,
                        "name": "Neuillé-Pont-Pierre",
                        "latitude": "47.54840000",
                        "longitude": "0.54962000"
                    },
                    {
                        "id": 44557,
                        "name": "Neung-sur-Beuvron",
                        "latitude": "47.53486000",
                        "longitude": "1.80514000"
                    },
                    {
                        "id": 44565,
                        "name": "Neuville-aux-Bois",
                        "latitude": "48.06813000",
                        "longitude": "2.05372000"
                    },
                    {
                        "id": 44578,
                        "name": "Neuvy-le-Roi",
                        "latitude": "47.60386000",
                        "longitude": "0.59472000"
                    },
                    {
                        "id": 44575,
                        "name": "Neuvy-Pailloux",
                        "latitude": "46.88486000",
                        "longitude": "1.86152000"
                    },
                    {
                        "id": 44576,
                        "name": "Neuvy-Saint-Sépulchre",
                        "latitude": "46.59781000",
                        "longitude": "1.80601000"
                    },
                    {
                        "id": 44579,
                        "name": "Neuvy-sur-Barangeon",
                        "latitude": "47.31495000",
                        "longitude": "2.25343000"
                    },
                    {
                        "id": 44584,
                        "name": "Nevoy",
                        "latitude": "47.71591000",
                        "longitude": "2.57791000"
                    },
                    {
                        "id": 44599,
                        "name": "Niherne",
                        "latitude": "46.82768000",
                        "longitude": "1.56384000"
                    },
                    {
                        "id": 44611,
                        "name": "Nogent-le-Phaye",
                        "latitude": "48.44528000",
                        "longitude": "1.57777000"
                    },
                    {
                        "id": 44612,
                        "name": "Nogent-le-Roi",
                        "latitude": "48.64785000",
                        "longitude": "1.52933000"
                    },
                    {
                        "id": 44613,
                        "name": "Nogent-le-Rotrou",
                        "latitude": "48.32157000",
                        "longitude": "0.82177000"
                    },
                    {
                        "id": 44618,
                        "name": "Nogent-sur-Vernisson",
                        "latitude": "47.84603000",
                        "longitude": "2.74267000"
                    },
                    {
                        "id": 44632,
                        "name": "Noizay",
                        "latitude": "47.42188000",
                        "longitude": "0.89201000"
                    },
                    {
                        "id": 44658,
                        "name": "Nouan-le-Fuzelier",
                        "latitude": "47.53600000",
                        "longitude": "2.03647000"
                    },
                    {
                        "id": 44663,
                        "name": "Nouzilly",
                        "latitude": "47.54499000",
                        "longitude": "0.74623000"
                    },
                    {
                        "id": 44679,
                        "name": "Noyers-sur-Cher",
                        "latitude": "47.27701000",
                        "longitude": "1.40320000"
                    },
                    {
                        "id": 44733,
                        "name": "Olivet",
                        "latitude": "47.86219000",
                        "longitude": "1.89910000"
                    },
                    {
                        "id": 44746,
                        "name": "Onzain",
                        "latitude": "47.49956000",
                        "longitude": "1.17701000"
                    },
                    {
                        "id": 44767,
                        "name": "Orgères-en-Beauce",
                        "latitude": "48.14636000",
                        "longitude": "1.68380000"
                    },
                    {
                        "id": 44774,
                        "name": "Orléans",
                        "latitude": "47.90289000",
                        "longitude": "1.90389000"
                    },
                    {
                        "id": 44776,
                        "name": "Ormes",
                        "latitude": "47.94152000",
                        "longitude": "1.81823000"
                    },
                    {
                        "id": 44787,
                        "name": "Orval",
                        "latitude": "46.72581000",
                        "longitude": "2.47144000"
                    },
                    {
                        "id": 44802,
                        "name": "Oucques",
                        "latitude": "47.82252000",
                        "longitude": "1.29383000"
                    },
                    {
                        "id": 44806,
                        "name": "Oulins",
                        "latitude": "48.86451000",
                        "longitude": "1.47038000"
                    },
                    {
                        "id": 44812,
                        "name": "Outarville",
                        "latitude": "48.21393000",
                        "longitude": "2.02198000"
                    },
                    {
                        "id": 44815,
                        "name": "Ouzouer-le-Marché",
                        "latitude": "47.91055000",
                        "longitude": "1.52607000"
                    },
                    {
                        "id": 44816,
                        "name": "Ouzouer-sur-Loire",
                        "latitude": "47.76638000",
                        "longitude": "2.48038000"
                    },
                    {
                        "id": 44817,
                        "name": "Ouzouer-sur-Trézée",
                        "latitude": "47.67266000",
                        "longitude": "2.80800000"
                    },
                    {
                        "id": 44844,
                        "name": "Pannes",
                        "latitude": "48.01937000",
                        "longitude": "2.66755000"
                    },
                    {
                        "id": 44860,
                        "name": "Parçay-Meslay",
                        "latitude": "47.44195000",
                        "longitude": "0.74847000"
                    },
                    {
                        "id": 44866,
                        "name": "Patay",
                        "latitude": "48.04833000",
                        "longitude": "1.69500000"
                    },
                    {
                        "id": 44907,
                        "name": "Perrusson",
                        "latitude": "47.09873000",
                        "longitude": "1.01438000"
                    },
                    {
                        "id": 44962,
                        "name": "Pierres",
                        "latitude": "48.59209000",
                        "longitude": "1.56444000"
                    },
                    {
                        "id": 44984,
                        "name": "Pithiviers",
                        "latitude": "48.17185000",
                        "longitude": "2.25185000"
                    },
                    {
                        "id": 44985,
                        "name": "Pithiviers-le-Vieil",
                        "latitude": "48.16313000",
                        "longitude": "2.20922000"
                    },
                    {
                        "id": 44989,
                        "name": "Plaimpied-Givaudins",
                        "latitude": "46.99800000",
                        "longitude": "2.45428000"
                    },
                    {
                        "id": 45131,
                        "name": "Pocé-sur-Cisse",
                        "latitude": "47.44330000",
                        "longitude": "0.99142000"
                    },
                    {
                        "id": 45134,
                        "name": "Poilly-lez-Gien",
                        "latitude": "47.67724000",
                        "longitude": "2.59743000"
                    },
                    {
                        "id": 45212,
                        "name": "Pontlevoy",
                        "latitude": "47.39002000",
                        "longitude": "1.25465000"
                    },
                    {
                        "id": 45261,
                        "name": "Pouligny-Saint-Pierre",
                        "latitude": "46.68095000",
                        "longitude": "1.03877000"
                    },
                    {
                        "id": 45284,
                        "name": "Preuilly-sur-Claise",
                        "latitude": "46.85424000",
                        "longitude": "0.92954000"
                    },
                    {
                        "id": 45301,
                        "name": "Pruniers-en-Sologne",
                        "latitude": "47.31667000",
                        "longitude": "1.66667000"
                    },
                    {
                        "id": 45320,
                        "name": "Puiseaux",
                        "latitude": "48.09234000",
                        "longitude": "2.05967000"
                    },
                    {
                        "id": 45385,
                        "name": "Quiers-sur-Bézonde",
                        "latitude": "47.99615000",
                        "longitude": "2.44141000"
                    },
                    {
                        "id": 45440,
                        "name": "Rebréchien",
                        "latitude": "47.98727000",
                        "longitude": "2.04432000"
                    },
                    {
                        "id": 45447,
                        "name": "Reignac-sur-Indre",
                        "latitude": "47.22662000",
                        "longitude": "0.91587000"
                    },
                    {
                        "id": 45465,
                        "name": "Restigné",
                        "latitude": "47.28224000",
                        "longitude": "0.22788000"
                    },
                    {
                        "id": 45472,
                        "name": "Reugny",
                        "latitude": "47.48208000",
                        "longitude": "0.88468000"
                    },
                    {
                        "id": 45473,
                        "name": "Reuilly",
                        "latitude": "47.08476000",
                        "longitude": "2.04305000"
                    },
                    {
                        "id": 45487,
                        "name": "Rians",
                        "latitude": "47.17875000",
                        "longitude": "2.61359000"
                    },
                    {
                        "id": 45496,
                        "name": "Richelieu",
                        "latitude": "47.01389000",
                        "longitude": "0.32406000"
                    },
                    {
                        "id": 45543,
                        "name": "Rochecorbon",
                        "latitude": "47.41658000",
                        "longitude": "0.75521000"
                    },
                    {
                        "id": 45582,
                        "name": "Romorantin-Lanthenay",
                        "latitude": "47.36667000",
                        "longitude": "1.75000000"
                    },
                    {
                        "id": 45644,
                        "name": "Rouziers-de-Touraine",
                        "latitude": "47.51720000",
                        "longitude": "0.64848000"
                    },
                    {
                        "id": 45706,
                        "name": "Saché",
                        "latitude": "47.24707000",
                        "longitude": "0.54455000"
                    },
                    {
                        "id": 45732,
                        "name": "Saint-Aignan",
                        "latitude": "47.26892000",
                        "longitude": "1.37614000"
                    },
                    {
                        "id": 45741,
                        "name": "Saint-Amand-Longpré",
                        "latitude": "47.68333000",
                        "longitude": "1.01667000"
                    },
                    {
                        "id": 45742,
                        "name": "Saint-Amand-Montrond",
                        "latitude": "46.72284000",
                        "longitude": "2.50494000"
                    },
                    {
                        "id": 45772,
                        "name": "Saint-Antoine-du-Rocher",
                        "latitude": "47.49677000",
                        "longitude": "0.62997000"
                    },
                    {
                        "id": 45783,
                        "name": "Saint-Aubin-des-Bois",
                        "latitude": "48.46549000",
                        "longitude": "1.35784000"
                    },
                    {
                        "id": 45797,
                        "name": "Saint-Avertin",
                        "latitude": "47.36357000",
                        "longitude": "0.73993000"
                    },
                    {
                        "id": 45800,
                        "name": "Saint-Ay",
                        "latitude": "47.85890000",
                        "longitude": "1.75137000"
                    },
                    {
                        "id": 45812,
                        "name": "Saint-Benoît-sur-Loire",
                        "latitude": "47.80561000",
                        "longitude": "2.31274000"
                    },
                    {
                        "id": 45821,
                        "name": "Saint-Branchs",
                        "latitude": "47.22655000",
                        "longitude": "0.77306000"
                    },
                    {
                        "id": 45832,
                        "name": "Saint-Brisson-sur-Loire",
                        "latitude": "47.64686000",
                        "longitude": "2.68229000"
                    },
                    {
                        "id": 45859,
                        "name": "Saint-Christophe-sur-le-Nais",
                        "latitude": "47.61720000",
                        "longitude": "0.47801000"
                    },
                    {
                        "id": 45867,
                        "name": "Saint-Claude-de-Diray",
                        "latitude": "47.61651000",
                        "longitude": "1.41798000"
                    },
                    {
                        "id": 45884,
                        "name": "Saint-Cyr-en-Val",
                        "latitude": "47.83182000",
                        "longitude": "1.96672000"
                    },
                    {
                        "id": 45887,
                        "name": "Saint-Cyr-sur-Loire",
                        "latitude": "47.40000000",
                        "longitude": "0.66667000"
                    },
                    {
                        "id": 45900,
                        "name": "Saint-Denis-en-Val",
                        "latitude": "47.87321000",
                        "longitude": "1.96601000"
                    },
                    {
                        "id": 45902,
                        "name": "Saint-Denis-les-Ponts",
                        "latitude": "48.06692000",
                        "longitude": "1.29764000"
                    },
                    {
                        "id": 45917,
                        "name": "Saint-Doulchard",
                        "latitude": "47.10371000",
                        "longitude": "2.35200000"
                    },
                    {
                        "id": 45919,
                        "name": "Saint-Dyé-sur-Loire",
                        "latitude": "47.65595000",
                        "longitude": "1.48847000"
                    },
                    {
                        "id": 46637,
                        "name": "Saint-Éloy-de-Gy",
                        "latitude": "47.15552000",
                        "longitude": "2.34267000"
                    },
                    {
                        "id": 46640,
                        "name": "Saint-Épain",
                        "latitude": "47.14482000",
                        "longitude": "0.53668000"
                    },
                    {
                        "id": 46644,
                        "name": "Saint-Étienne-de-Chigny",
                        "latitude": "47.38333000",
                        "longitude": "0.53333000"
                    },
                    {
                        "id": 45936,
                        "name": "Saint-Florent-sur-Cher",
                        "latitude": "46.99552000",
                        "longitude": "2.25076000"
                    },
                    {
                        "id": 45952,
                        "name": "Saint-Gaultier",
                        "latitude": "46.63518000",
                        "longitude": "1.41289000"
                    },
                    {
                        "id": 45989,
                        "name": "Saint-Georges-sur-Cher",
                        "latitude": "47.32996000",
                        "longitude": "1.13261000"
                    },
                    {
                        "id": 45990,
                        "name": "Saint-Georges-sur-Eure",
                        "latitude": "48.41869000",
                        "longitude": "1.35460000"
                    },
                    {
                        "id": 46008,
                        "name": "Saint-Germain-des-Prés",
                        "latitude": "47.95384000",
                        "longitude": "2.84846000"
                    },
                    {
                        "id": 46013,
                        "name": "Saint-Germain-du-Puy",
                        "latitude": "47.10000000",
                        "longitude": "2.48333000"
                    },
                    {
                        "id": 46028,
                        "name": "Saint-Gervais-la-Forêt",
                        "latitude": "47.56705000",
                        "longitude": "1.35493000"
                    },
                    {
                        "id": 46053,
                        "name": "Saint-Hilaire-Saint-Mesmin",
                        "latitude": "47.86614000",
                        "longitude": "1.83351000"
                    },
                    {
                        "id": 46089,
                        "name": "Saint-Jean-de-Braye",
                        "latitude": "47.91303000",
                        "longitude": "1.97705000"
                    },
                    {
                        "id": 46105,
                        "name": "Saint-Jean-de-la-Ruelle",
                        "latitude": "47.91127000",
                        "longitude": "1.86483000"
                    },
                    {
                        "id": 46116,
                        "name": "Saint-Jean-le-Blanc",
                        "latitude": "47.89327000",
                        "longitude": "1.91540000"
                    },
                    {
                        "id": 46174,
                        "name": "Saint-Laurent-Nouan",
                        "latitude": "47.71667000",
                        "longitude": "1.60000000"
                    },
                    {
                        "id": 46202,
                        "name": "Saint-Lubin-des-Joncherets",
                        "latitude": "48.76667000",
                        "longitude": "1.21667000"
                    },
                    {
                        "id": 46244,
                        "name": "Saint-Marcel",
                        "latitude": "46.60193000",
                        "longitude": "1.51324000"
                    },
                    {
                        "id": 46294,
                        "name": "Saint-Martin-d’Auxigny",
                        "latitude": "47.20371000",
                        "longitude": "2.41553000"
                    },
                    {
                        "id": 46275,
                        "name": "Saint-Martin-de-Nigelles",
                        "latitude": "48.61234000",
                        "longitude": "1.60920000"
                    },
                    {
                        "id": 46300,
                        "name": "Saint-Martin-le-Beau",
                        "latitude": "47.35566000",
                        "longitude": "0.90953000"
                    },
                    {
                        "id": 46303,
                        "name": "Saint-Martin-sur-Ocre",
                        "latitude": "47.65942000",
                        "longitude": "2.65810000"
                    },
                    {
                        "id": 46309,
                        "name": "Saint-Maur",
                        "latitude": "46.80657000",
                        "longitude": "1.63904000"
                    },
                    {
                        "id": 46320,
                        "name": "Saint-Maurice-sur-Fessard",
                        "latitude": "47.99231000",
                        "longitude": "2.62157000"
                    },
                    {
                        "id": 46363,
                        "name": "Saint-Nicolas-de-Bourgueil",
                        "latitude": "47.28493000",
                        "longitude": "0.12727000"
                    },
                    {
                        "id": 46377,
                        "name": "Saint-Ouen",
                        "latitude": "47.81404000",
                        "longitude": "1.08067000"
                    },
                    {
                        "id": 46399,
                        "name": "Saint-Paterne-Racan",
                        "latitude": "47.60213000",
                        "longitude": "0.48478000"
                    },
                    {
                        "id": 46479,
                        "name": "Saint-Père-sur-Loire",
                        "latitude": "47.76667000",
                        "longitude": "2.36667000"
                    },
                    {
                        "id": 46427,
                        "name": "Saint-Piat",
                        "latitude": "48.54668000",
                        "longitude": "1.58363000"
                    },
                    {
                        "id": 46435,
                        "name": "Saint-Pierre-des-Corps",
                        "latitude": "47.38623000",
                        "longitude": "0.74849000"
                    },
                    {
                        "id": 46463,
                        "name": "Saint-Prest",
                        "latitude": "48.49107000",
                        "longitude": "1.53034000"
                    },
                    {
                        "id": 46475,
                        "name": "Saint-Pryvé-Saint-Mesmin",
                        "latitude": "47.88177000",
                        "longitude": "1.86950000"
                    },
                    {
                        "id": 46515,
                        "name": "Saint-Rémy-sur-Avre",
                        "latitude": "48.76143000",
                        "longitude": "1.24532000"
                    },
                    {
                        "id": 46506,
                        "name": "Saint-Romain-sur-Cher",
                        "latitude": "47.31877000",
                        "longitude": "1.39956000"
                    },
                    {
                        "id": 46518,
                        "name": "Saint-Satur",
                        "latitude": "47.33914000",
                        "longitude": "2.83734000"
                    },
                    {
                        "id": 46562,
                        "name": "Saint-Sulpice-de-Pommeray",
                        "latitude": "47.60000000",
                        "longitude": "1.26667000"
                    },
                    {
                        "id": 46622,
                        "name": "Saint-Viâtre",
                        "latitude": "47.52438000",
                        "longitude": "1.93276000"
                    },
                    {
                        "id": 46692,
                        "name": "Sainte-Geneviève-des-Bois",
                        "latitude": "47.81777000",
                        "longitude": "2.81652000"
                    },
                    {
                        "id": 46702,
                        "name": "Sainte-Lizaigne",
                        "latitude": "47.00695000",
                        "longitude": "2.02266000"
                    },
                    {
                        "id": 46717,
                        "name": "Sainte-Maure-de-Touraine",
                        "latitude": "47.11130000",
                        "longitude": "0.62236000"
                    },
                    {
                        "id": 46727,
                        "name": "Sainte-Solange",
                        "latitude": "47.13628000",
                        "longitude": "2.55019000"
                    },
                    {
                        "id": 46743,
                        "name": "Salbris",
                        "latitude": "47.42420000",
                        "longitude": "2.05124000"
                    },
                    {
                        "id": 46781,
                        "name": "Sancerre",
                        "latitude": "47.32889000",
                        "longitude": "2.83447000"
                    },
                    {
                        "id": 46783,
                        "name": "Sancoins",
                        "latitude": "46.83314000",
                        "longitude": "2.92238000"
                    },
                    {
                        "id": 46786,
                        "name": "Sandillon",
                        "latitude": "47.84510000",
                        "longitude": "2.03155000"
                    },
                    {
                        "id": 46801,
                        "name": "Saran",
                        "latitude": "47.95013000",
                        "longitude": "1.87601000"
                    },
                    {
                        "id": 46806,
                        "name": "Sargé-sur-Braye",
                        "latitude": "47.92352000",
                        "longitude": "0.85340000"
                    },
                    {
                        "id": 46855,
                        "name": "Saussay",
                        "latitude": "48.85571000",
                        "longitude": "1.40889000"
                    },
                    {
                        "id": 46885,
                        "name": "Savigné-sur-Lathan",
                        "latitude": "47.44483000",
                        "longitude": "0.32093000"
                    },
                    {
                        "id": 46878,
                        "name": "Savigny-en-Sancerre",
                        "latitude": "47.44142000",
                        "longitude": "2.80953000"
                    },
                    {
                        "id": 46879,
                        "name": "Savigny-en-Véron",
                        "latitude": "47.20071000",
                        "longitude": "0.14457000"
                    },
                    {
                        "id": 46882,
                        "name": "Savigny-sur-Braye",
                        "latitude": "47.87923000",
                        "longitude": "0.80981000"
                    },
                    {
                        "id": 46887,
                        "name": "Savonnières",
                        "latitude": "47.34769000",
                        "longitude": "0.54961000"
                    },
                    {
                        "id": 46920,
                        "name": "Seigy",
                        "latitude": "47.25688000",
                        "longitude": "1.39964000"
                    },
                    {
                        "id": 46930,
                        "name": "Selles-Saint-Denis",
                        "latitude": "47.38695000",
                        "longitude": "1.92295000"
                    },
                    {
                        "id": 46931,
                        "name": "Selles-sur-Cher",
                        "latitude": "47.27904000",
                        "longitude": "1.55387000"
                    },
                    {
                        "id": 46936,
                        "name": "Semblançay",
                        "latitude": "47.50000000",
                        "longitude": "0.58333000"
                    },
                    {
                        "id": 46937,
                        "name": "Semoy",
                        "latitude": "47.93333000",
                        "longitude": "1.95000000"
                    },
                    {
                        "id": 46943,
                        "name": "Senonches",
                        "latitude": "48.55999000",
                        "longitude": "1.03069000"
                    },
                    {
                        "id": 46956,
                        "name": "Sermaises",
                        "latitude": "48.29650000",
                        "longitude": "2.20546000"
                    },
                    {
                        "id": 47017,
                        "name": "Soings-en-Sologne",
                        "latitude": "47.41289000",
                        "longitude": "1.52452000"
                    },
                    {
                        "id": 47041,
                        "name": "Sonzay",
                        "latitude": "47.52687000",
                        "longitude": "0.46203000"
                    },
                    {
                        "id": 47044,
                        "name": "Sorel-Moussel",
                        "latitude": "48.83391000",
                        "longitude": "1.36699000"
                    },
                    {
                        "id": 47047,
                        "name": "Sorigny",
                        "latitude": "47.24329000",
                        "longitude": "0.69520000"
                    },
                    {
                        "id": 47064,
                        "name": "Souesmes",
                        "latitude": "47.45638000",
                        "longitude": "2.17495000"
                    },
                    {
                        "id": 47085,
                        "name": "Sours",
                        "latitude": "48.41043000",
                        "longitude": "1.59889000"
                    },
                    {
                        "id": 47128,
                        "name": "Suèvres",
                        "latitude": "47.66655000",
                        "longitude": "1.46153000"
                    },
                    {
                        "id": 47114,
                        "name": "Sully-sur-Loire",
                        "latitude": "47.76372000",
                        "longitude": "2.37238000"
                    },
                    {
                        "id": 47189,
                        "name": "Tauxigny",
                        "latitude": "47.21337000",
                        "longitude": "0.83479000"
                    },
                    {
                        "id": 47193,
                        "name": "Tavers",
                        "latitude": "47.75921000",
                        "longitude": "1.61267000"
                    },
                    {
                        "id": 47220,
                        "name": "Theillay",
                        "latitude": "47.31429000",
                        "longitude": "2.04028000"
                    },
                    {
                        "id": 47272,
                        "name": "Thésée",
                        "latitude": "47.32345000",
                        "longitude": "1.30882000"
                    },
                    {
                        "id": 47235,
                        "name": "Thilouze",
                        "latitude": "47.22415000",
                        "longitude": "0.57963000"
                    },
                    {
                        "id": 47237,
                        "name": "Thiron Gardais",
                        "latitude": "48.31667000",
                        "longitude": "0.98333000"
                    },
                    {
                        "id": 47281,
                        "name": "Tigy",
                        "latitude": "47.79365000",
                        "longitude": "2.19767000"
                    },
                    {
                        "id": 47327,
                        "name": "Tournon-Saint-Martin",
                        "latitude": "46.73423000",
                        "longitude": "0.95514000"
                    },
                    {
                        "id": 47333,
                        "name": "Tours",
                        "latitude": "47.39484000",
                        "longitude": "0.70398000"
                    },
                    {
                        "id": 47339,
                        "name": "Toury",
                        "latitude": "48.19397000",
                        "longitude": "1.93484000"
                    },
                    {
                        "id": 47350,
                        "name": "Traînou",
                        "latitude": "47.97353000",
                        "longitude": "2.10399000"
                    },
                    {
                        "id": 47405,
                        "name": "Tréon",
                        "latitude": "48.67709000",
                        "longitude": "1.32668000"
                    },
                    {
                        "id": 47374,
                        "name": "Triguères",
                        "latitude": "47.93975000",
                        "longitude": "2.98570000"
                    },
                    {
                        "id": 47384,
                        "name": "Trouy",
                        "latitude": "47.01153000",
                        "longitude": "2.36018000"
                    },
                    {
                        "id": 47388,
                        "name": "Truyes",
                        "latitude": "47.27299000",
                        "longitude": "0.85179000"
                    },
                    {
                        "id": 47428,
                        "name": "Unverre",
                        "latitude": "48.19829000",
                        "longitude": "1.09207000"
                    },
                    {
                        "id": 47479,
                        "name": "Valençay",
                        "latitude": "47.16207000",
                        "longitude": "1.56852000"
                    },
                    {
                        "id": 47525,
                        "name": "Vasselay",
                        "latitude": "47.15686000",
                        "longitude": "2.38963000"
                    },
                    {
                        "id": 47527,
                        "name": "Vatan",
                        "latitude": "47.07447000",
                        "longitude": "1.81010000"
                    },
                    {
                        "id": 47555,
                        "name": "Veigné",
                        "latitude": "47.28556000",
                        "longitude": "0.74079000"
                    },
                    {
                        "id": 47579,
                        "name": "Vendœuvres",
                        "latitude": "46.80000000",
                        "longitude": "1.35000000"
                    },
                    {
                        "id": 47578,
                        "name": "Vendôme",
                        "latitude": "47.79292000",
                        "longitude": "1.06556000"
                    },
                    {
                        "id": 47585,
                        "name": "Vennecy",
                        "latitude": "47.95465000",
                        "longitude": "2.05459000"
                    },
                    {
                        "id": 47928,
                        "name": "Véretz",
                        "latitude": "47.35706000",
                        "longitude": "0.80575000"
                    },
                    {
                        "id": 47622,
                        "name": "Vernou-sur-Brenne",
                        "latitude": "47.41936000",
                        "longitude": "0.84757000"
                    },
                    {
                        "id": 47624,
                        "name": "Vernouillet",
                        "latitude": "48.72090000",
                        "longitude": "1.36951000"
                    },
                    {
                        "id": 47636,
                        "name": "Vert-en-Drouais",
                        "latitude": "48.76029000",
                        "longitude": "1.29460000"
                    },
                    {
                        "id": 47684,
                        "name": "Vienne-en-Val",
                        "latitude": "47.80036000",
                        "longitude": "2.13460000"
                    },
                    {
                        "id": 47685,
                        "name": "Vierzon",
                        "latitude": "47.22186000",
                        "longitude": "2.06840000"
                    },
                    {
                        "id": 47700,
                        "name": "Vignoux-sur-Barangeon",
                        "latitude": "47.20068000",
                        "longitude": "2.17258000"
                    },
                    {
                        "id": 47708,
                        "name": "Villandry",
                        "latitude": "47.34019000",
                        "longitude": "0.51050000"
                    },
                    {
                        "id": 47721,
                        "name": "Villebarou",
                        "latitude": "47.62344000",
                        "longitude": "1.32252000"
                    },
                    {
                        "id": 47731,
                        "name": "Villedieu-sur-Indre",
                        "latitude": "46.84598000",
                        "longitude": "1.53975000"
                    },
                    {
                        "id": 47732,
                        "name": "Villedômer",
                        "latitude": "47.54651000",
                        "longitude": "0.88775000"
                    },
                    {
                        "id": 47739,
                        "name": "Villefranche-sur-Cher",
                        "latitude": "47.30000000",
                        "longitude": "1.76667000"
                    },
                    {
                        "id": 47749,
                        "name": "Villemandeur",
                        "latitude": "47.98701000",
                        "longitude": "2.71802000"
                    },
                    {
                        "id": 47750,
                        "name": "Villemeux-sur-Eure",
                        "latitude": "48.67259000",
                        "longitude": "1.46470000"
                    },
                    {
                        "id": 47831,
                        "name": "Villiers-le-Morhier",
                        "latitude": "48.62018000",
                        "longitude": "1.56349000"
                    },
                    {
                        "id": 47832,
                        "name": "Villiers-sur-Loir",
                        "latitude": "47.80507000",
                        "longitude": "0.99774000"
                    },
                    {
                        "id": 47839,
                        "name": "Vimory",
                        "latitude": "47.94786000",
                        "longitude": "2.68701000"
                    },
                    {
                        "id": 47846,
                        "name": "Vineuil",
                        "latitude": "47.58380000",
                        "longitude": "1.37601000"
                    },
                    {
                        "id": 47871,
                        "name": "Vitry-aux-Loges",
                        "latitude": "47.93333000",
                        "longitude": "2.26667000"
                    },
                    {
                        "id": 47915,
                        "name": "Vouvray",
                        "latitude": "47.41087000",
                        "longitude": "0.79892000"
                    },
                    {
                        "id": 47917,
                        "name": "Vouzon",
                        "latitude": "47.64515000",
                        "longitude": "2.05609000"
                    },
                    {
                        "id": 47918,
                        "name": "Voves",
                        "latitude": "48.27138000",
                        "longitude": "1.62583000"
                    },
                    {
                        "id": 48023,
                        "name": "Yèvres",
                        "latitude": "48.21078000",
                        "longitude": "1.18717000"
                    },
                    {
                        "id": 48022,
                        "name": "Yzeures-sur-Creuse",
                        "latitude": "46.78609000",
                        "longitude": "0.87166000"
                    }
                ]
            },
            {
                "id": 4983,
                "name": "Charente",
                "iso2": "16",
                "latitude": "45.66584790",
                "longitude": "-0.31845770",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4984,
                "name": "Charente-Maritime",
                "iso2": "17",
                "latitude": "45.72968280",
                "longitude": "-1.33881160",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4985,
                "name": "Cher",
                "iso2": "18",
                "latitude": "47.02436280",
                "longitude": "1.86627320",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5064,
                "name": "Clipperton",
                "iso2": "CP",
                "latitude": "10.28335410",
                "longitude": "-109.22542150",
                "type": "dependency",
                "cities": []
            },
            {
                "id": 4986,
                "name": "Corrèze",
                "iso2": "19",
                "latitude": "45.34237070",
                "longitude": "1.31717330",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4806,
                "name": "Corse",
                "iso2": "20R",
                "latitude": "42.03960420",
                "longitude": "9.01289260",
                "type": "metropolitan collectivity with special status",
                "cities": [
                    {
                        "id": 39256,
                        "name": "Afa",
                        "latitude": "41.98396000",
                        "longitude": "8.79833000"
                    },
                    {
                        "id": 39298,
                        "name": "Ajaccio",
                        "latitude": "41.91886000",
                        "longitude": "8.73812000"
                    },
                    {
                        "id": 39300,
                        "name": "Alata",
                        "latitude": "41.97636000",
                        "longitude": "8.74208000"
                    },
                    {
                        "id": 39308,
                        "name": "Albitreccia",
                        "latitude": "41.86301000",
                        "longitude": "8.94262000"
                    },
                    {
                        "id": 39343,
                        "name": "Aléria",
                        "latitude": "42.10431000",
                        "longitude": "9.51265000"
                    },
                    {
                        "id": 39442,
                        "name": "Appietto",
                        "latitude": "42.01426000",
                        "longitude": "8.76855000"
                    },
                    {
                        "id": 39804,
                        "name": "Bastia",
                        "latitude": "42.70278000",
                        "longitude": "9.45000000"
                    },
                    {
                        "id": 40018,
                        "name": "Biguglia",
                        "latitude": "42.62692000",
                        "longitude": "9.42018000"
                    },
                    {
                        "id": 40114,
                        "name": "Bonifacio",
                        "latitude": "41.38740000",
                        "longitude": "9.15941000"
                    },
                    {
                        "id": 40140,
                        "name": "Borgo",
                        "latitude": "42.55488000",
                        "longitude": "9.42636000"
                    },
                    {
                        "id": 40252,
                        "name": "Brando",
                        "latitude": "42.76667000",
                        "longitude": "9.45000000"
                    },
                    {
                        "id": 40470,
                        "name": "Calenzana",
                        "latitude": "42.50855000",
                        "longitude": "8.85538000"
                    },
                    {
                        "id": 40479,
                        "name": "Calvi",
                        "latitude": "42.56604000",
                        "longitude": "8.75713000"
                    },
                    {
                        "id": 40543,
                        "name": "Cargèse",
                        "latitude": "42.13629000",
                        "longitude": "8.59586000"
                    },
                    {
                        "id": 40611,
                        "name": "Cauro",
                        "latitude": "41.91756000",
                        "longitude": "8.91480000"
                    },
                    {
                        "id": 40657,
                        "name": "Cervione",
                        "latitude": "42.32835000",
                        "longitude": "9.49343000"
                    },
                    {
                        "id": 41205,
                        "name": "Corte",
                        "latitude": "42.30956000",
                        "longitude": "9.14917000"
                    },
                    {
                        "id": 41384,
                        "name": "Cuttoli-Corticchiato",
                        "latitude": "41.98333000",
                        "longitude": "8.91667000"
                    },
                    {
                        "id": 41818,
                        "name": "Figari",
                        "latitude": "41.48792000",
                        "longitude": "9.13013000"
                    },
                    {
                        "id": 41994,
                        "name": "Furiani",
                        "latitude": "42.65847000",
                        "longitude": "9.41446000"
                    },
                    {
                        "id": 42084,
                        "name": "Ghisonaccia",
                        "latitude": "42.01582000",
                        "longitude": "9.40507000"
                    },
                    {
                        "id": 42227,
                        "name": "Grosseto-Prugna",
                        "latitude": "41.87097000",
                        "longitude": "8.96403000"
                    },
                    {
                        "id": 42629,
                        "name": "L'Île-Rousse",
                        "latitude": "42.63371000",
                        "longitude": "8.93764000"
                    },
                    {
                        "id": 43502,
                        "name": "Linguizzetta",
                        "latitude": "42.26384000",
                        "longitude": "9.47297000"
                    },
                    {
                        "id": 43631,
                        "name": "Lucciana",
                        "latitude": "42.54609000",
                        "longitude": "9.41865000"
                    },
                    {
                        "id": 43650,
                        "name": "Lumio",
                        "latitude": "42.57894000",
                        "longitude": "8.83373000"
                    },
                    {
                        "id": 44252,
                        "name": "Monticello",
                        "latitude": "42.61705000",
                        "longitude": "8.95477000"
                    },
                    {
                        "id": 44363,
                        "name": "Morosaglia",
                        "latitude": "42.43511000",
                        "longitude": "9.30009000"
                    },
                    {
                        "id": 44732,
                        "name": "Oletta",
                        "latitude": "42.62991000",
                        "longitude": "9.35431000"
                    },
                    {
                        "id": 44736,
                        "name": "Olmeto",
                        "latitude": "41.71724000",
                        "longitude": "8.91783000"
                    },
                    {
                        "id": 44893,
                        "name": "Penta-di-Casinca",
                        "latitude": "42.46579000",
                        "longitude": "9.45884000"
                    },
                    {
                        "id": 44896,
                        "name": "Peri",
                        "latitude": "42.00345000",
                        "longitude": "8.92066000"
                    },
                    {
                        "id": 44966,
                        "name": "Pietranera",
                        "latitude": "42.72338000",
                        "longitude": "9.45621000"
                    },
                    {
                        "id": 44967,
                        "name": "Pietrosella",
                        "latitude": "41.83576000",
                        "longitude": "8.84573000"
                    },
                    {
                        "id": 45245,
                        "name": "Porto-Vecchio",
                        "latitude": "41.59101000",
                        "longitude": "9.27947000"
                    },
                    {
                        "id": 45294,
                        "name": "Propriano",
                        "latitude": "41.67590000",
                        "longitude": "8.90412000"
                    },
                    {
                        "id": 45300,
                        "name": "Prunelli-di-Fiumorbo",
                        "latitude": "42.01047000",
                        "longitude": "9.32473000"
                    },
                    {
                        "id": 45932,
                        "name": "Saint-Florent",
                        "latitude": "42.68150000",
                        "longitude": "9.30396000"
                    },
                    {
                        "id": 46778,
                        "name": "San-Martino-di-Lota",
                        "latitude": "42.73163000",
                        "longitude": "9.43966000"
                    },
                    {
                        "id": 46779,
                        "name": "San-Nicolao",
                        "latitude": "42.36993000",
                        "longitude": "9.51443000"
                    },
                    {
                        "id": 46795,
                        "name": "Santa-Lucia-di-Moriani",
                        "latitude": "42.38212000",
                        "longitude": "9.52242000"
                    },
                    {
                        "id": 46796,
                        "name": "Santa-Maria-di-Lota",
                        "latitude": "42.74783000",
                        "longitude": "9.43202000"
                    },
                    {
                        "id": 46807,
                        "name": "Sari-Solenzara",
                        "latitude": "41.83519000",
                        "longitude": "9.37470000"
                    },
                    {
                        "id": 46817,
                        "name": "Sarrola",
                        "latitude": "42.02828000",
                        "longitude": "8.84241000"
                    },
                    {
                        "id": 46823,
                        "name": "Sartène",
                        "latitude": "41.61667000",
                        "longitude": "8.98333000"
                    },
                    {
                        "id": 47007,
                        "name": "Sisco",
                        "latitude": "42.80000000",
                        "longitude": "9.43333000"
                    },
                    {
                        "id": 47588,
                        "name": "Ventiseri",
                        "latitude": "41.94356000",
                        "longitude": "9.33342000"
                    },
                    {
                        "id": 47647,
                        "name": "Vescovato",
                        "latitude": "42.49293000",
                        "longitude": "9.43934000"
                    },
                    {
                        "id": 48028,
                        "name": "Zonza",
                        "latitude": "41.74934000",
                        "longitude": "9.17082000"
                    }
                ]
            },
            {
                "id": 4996,
                "name": "Corse-du-Sud",
                "iso2": "2A",
                "latitude": "41.85720550",
                "longitude": "8.41091830",
                "type": "metropolitan department",
                "cities": [
                    {
                        "id": 155104,
                        "name": "Altagène",
                        "latitude": "41.70979980",
                        "longitude": "9.03244740"
                    },
                    {
                        "id": 155105,
                        "name": "Ambiegna",
                        "latitude": "42.08997100",
                        "longitude": "8.68572790"
                    },
                    {
                        "id": 155106,
                        "name": "Arbellara",
                        "latitude": "41.67053860",
                        "longitude": "8.95143510"
                    },
                    {
                        "id": 155107,
                        "name": "Arbori",
                        "latitude": "42.12313760",
                        "longitude": "8.71342620"
                    },
                    {
                        "id": 155108,
                        "name": "Argiusta-Moriccio",
                        "latitude": "41.81382430",
                        "longitude": "8.99131010"
                    },
                    {
                        "id": 155109,
                        "name": "Arro",
                        "latitude": "42.09798010",
                        "longitude": "8.75989740"
                    },
                    {
                        "id": 155110,
                        "name": "Aullène",
                        "latitude": "41.81112980",
                        "longitude": "9.01049070"
                    },
                    {
                        "id": 155111,
                        "name": "Azilone-Ampaza",
                        "latitude": "41.87187550",
                        "longitude": "8.97319630"
                    },
                    {
                        "id": 155112,
                        "name": "Azzana",
                        "latitude": "42.11721370",
                        "longitude": "8.89190240"
                    },
                    {
                        "id": 155113,
                        "name": "Balogna",
                        "latitude": "42.18551330",
                        "longitude": "8.66814750"
                    },
                    {
                        "id": 155114,
                        "name": "Bastelica",
                        "latitude": "41.97827930",
                        "longitude": "8.89046980"
                    },
                    {
                        "id": 155115,
                        "name": "Bastelicaccia",
                        "latitude": "41.93275190",
                        "longitude": "8.75474200"
                    },
                    {
                        "id": 155116,
                        "name": "Belvédère-Campomoro",
                        "latitude": "41.61786410",
                        "longitude": "8.73961960"
                    },
                    {
                        "id": 155117,
                        "name": "Bilia",
                        "latitude": "41.62228620",
                        "longitude": "8.86361220"
                    },
                    {
                        "id": 155118,
                        "name": "Bocognano",
                        "latitude": "42.08725430",
                        "longitude": "8.89984080"
                    },
                    {
                        "id": 155119,
                        "name": "Calcatoggio",
                        "latitude": "42.03062800",
                        "longitude": "8.56586910"
                    },
                    {
                        "id": 155120,
                        "name": "Cannelle",
                        "latitude": "42.04763110",
                        "longitude": "8.77278640"
                    },
                    {
                        "id": 155121,
                        "name": "Carbini",
                        "latitude": "41.67797340",
                        "longitude": "9.07766470"
                    },
                    {
                        "id": 155122,
                        "name": "Carbuccia",
                        "latitude": "42.03444050",
                        "longitude": "8.84777130"
                    },
                    {
                        "id": 155123,
                        "name": "Cardo-Torgia",
                        "latitude": "41.85339560",
                        "longitude": "8.93231920"
                    },
                    {
                        "id": 155124,
                        "name": "Cargiaca",
                        "latitude": "41.73027600",
                        "longitude": "8.99726850"
                    },
                    {
                        "id": 155125,
                        "name": "Casaglione",
                        "latitude": "42.07010930",
                        "longitude": "8.67561920"
                    },
                    {
                        "id": 155126,
                        "name": "Casalabriva",
                        "latitude": "41.75839120",
                        "longitude": "8.83503960"
                    },
                    {
                        "id": 155127,
                        "name": "Ciamannacce",
                        "latitude": "41.96956260",
                        "longitude": "9.04943790"
                    },
                    {
                        "id": 155128,
                        "name": "Coggia",
                        "latitude": "42.10969630",
                        "longitude": "8.65699370"
                    },
                    {
                        "id": 155129,
                        "name": "Cognocoli-Monticchi",
                        "latitude": "41.80533000",
                        "longitude": "8.78603500"
                    },
                    {
                        "id": 155130,
                        "name": "Conca",
                        "latitude": "41.75493440",
                        "longitude": "9.15518920"
                    },
                    {
                        "id": 155131,
                        "name": "Corrano",
                        "latitude": "41.88294090",
                        "longitude": "9.03204830"
                    },
                    {
                        "id": 155132,
                        "name": "Coti-Chiavari",
                        "latitude": "41.76753510",
                        "longitude": "8.57629580"
                    },
                    {
                        "id": 155133,
                        "name": "Cozzano",
                        "latitude": "41.93212380",
                        "longitude": "9.10243500"
                    },
                    {
                        "id": 155134,
                        "name": "Cristinacce",
                        "latitude": "42.24591620",
                        "longitude": "8.77513950"
                    },
                    {
                        "id": 155135,
                        "name": "Eccica-Suarella",
                        "latitude": "41.92055190",
                        "longitude": "8.81319530"
                    },
                    {
                        "id": 155136,
                        "name": "Évisa",
                        "latitude": "42.28469150",
                        "longitude": "8.66170890"
                    },
                    {
                        "id": 155137,
                        "name": "Foce",
                        "latitude": "41.62405620",
                        "longitude": "8.95304970"
                    },
                    {
                        "id": 155138,
                        "name": "Forciolo",
                        "latitude": "41.84636790",
                        "longitude": "8.97427010"
                    },
                    {
                        "id": 155139,
                        "name": "Fozzano",
                        "latitude": "41.70147190",
                        "longitude": "8.90848330"
                    },
                    {
                        "id": 155140,
                        "name": "Frasseto",
                        "latitude": "41.91991920",
                        "longitude": "8.99497150"
                    },
                    {
                        "id": 155141,
                        "name": "Giuncheto",
                        "latitude": "41.58632120",
                        "longitude": "8.91700060"
                    },
                    {
                        "id": 155142,
                        "name": "Granace",
                        "latitude": "41.64000060",
                        "longitude": "8.97112880"
                    },
                    {
                        "id": 155143,
                        "name": "Grossa",
                        "latitude": "41.60507370",
                        "longitude": "8.77524570"
                    },
                    {
                        "id": 155144,
                        "name": "Guagno",
                        "latitude": "42.17729320",
                        "longitude": "8.81646350"
                    },
                    {
                        "id": 155145,
                        "name": "Guargualé",
                        "latitude": "41.82511790",
                        "longitude": "8.88582590"
                    },
                    {
                        "id": 155146,
                        "name": "Guitera-les-Bains",
                        "latitude": "41.92678350",
                        "longitude": "9.03851880"
                    },
                    {
                        "id": 155147,
                        "name": "Lecci",
                        "latitude": "41.65827700",
                        "longitude": "9.21834790"
                    },
                    {
                        "id": 155148,
                        "name": "Letia",
                        "latitude": "42.21674990",
                        "longitude": "8.71109770"
                    },
                    {
                        "id": 155149,
                        "name": "Levie",
                        "latitude": "41.66132060",
                        "longitude": "8.94347470"
                    },
                    {
                        "id": 155150,
                        "name": "Lopigna",
                        "latitude": "42.08887400",
                        "longitude": "8.77072880"
                    },
                    {
                        "id": 155151,
                        "name": "Loreto-di-Tallano",
                        "latitude": "41.69599080",
                        "longitude": "8.98955210"
                    },
                    {
                        "id": 155152,
                        "name": "Marignana",
                        "latitude": "42.20910440",
                        "longitude": "8.55450840"
                    },
                    {
                        "id": 155153,
                        "name": "Mela",
                        "latitude": "41.68271320",
                        "longitude": "9.07114460"
                    },
                    {
                        "id": 155154,
                        "name": "Moca-Croce",
                        "latitude": "41.77770220",
                        "longitude": "8.92262750"
                    },
                    {
                        "id": 155155,
                        "name": "Monacia-d'Aullène",
                        "latitude": "41.52339080",
                        "longitude": "8.84344610"
                    },
                    {
                        "id": 155156,
                        "name": "Murzo",
                        "latitude": "42.15567260",
                        "longitude": "8.76666600"
                    },
                    {
                        "id": 155157,
                        "name": "Ocana",
                        "latitude": "41.95479460",
                        "longitude": "8.82095560"
                    },
                    {
                        "id": 155158,
                        "name": "Olivese",
                        "latitude": "41.83663330",
                        "longitude": "8.98826630"
                    },
                    {
                        "id": 155159,
                        "name": "Olmiccia",
                        "latitude": "41.67014450",
                        "longitude": "8.94867300"
                    },
                    {
                        "id": 155160,
                        "name": "Orto",
                        "latitude": "42.19844630",
                        "longitude": "8.88015900"
                    },
                    {
                        "id": 155161,
                        "name": "Osani",
                        "latitude": "42.34054810",
                        "longitude": "8.44433550"
                    },
                    {
                        "id": 155162,
                        "name": "Ota",
                        "latitude": "42.25380700",
                        "longitude": "8.65379700"
                    },
                    {
                        "id": 155163,
                        "name": "Palneca",
                        "latitude": "41.99059270",
                        "longitude": "9.10442300"
                    },
                    {
                        "id": 155164,
                        "name": "Partinello",
                        "latitude": "42.31514250",
                        "longitude": "8.60972210"
                    },
                    {
                        "id": 155165,
                        "name": "Pastricciola",
                        "latitude": "42.14458360",
                        "longitude": "8.85004000"
                    },
                    {
                        "id": 155166,
                        "name": "Petreto-Bicchisano",
                        "latitude": "41.76580760",
                        "longitude": "8.88051210"
                    },
                    {
                        "id": 155167,
                        "name": "Piana",
                        "latitude": "42.22348930",
                        "longitude": "8.45594130"
                    },
                    {
                        "id": 155168,
                        "name": "Pianottoli-Caldarello",
                        "latitude": "41.52095720",
                        "longitude": "8.96324230"
                    },
                    {
                        "id": 155169,
                        "name": "Pila-Canale",
                        "latitude": "41.79176200",
                        "longitude": "8.81261900"
                    },
                    {
                        "id": 155170,
                        "name": "Poggiolo",
                        "latitude": "42.16168570",
                        "longitude": "8.85729650"
                    },
                    {
                        "id": 155171,
                        "name": "Quasquara",
                        "latitude": "41.91209200",
                        "longitude": "8.96589210"
                    },
                    {
                        "id": 155172,
                        "name": "Quenza",
                        "latitude": "41.79490800",
                        "longitude": "9.05083610"
                    },
                    {
                        "id": 155173,
                        "name": "Renno",
                        "latitude": "42.20534630",
                        "longitude": "8.77953290"
                    },
                    {
                        "id": 155174,
                        "name": "Rezza",
                        "latitude": "42.12551330",
                        "longitude": "8.91451210"
                    },
                    {
                        "id": 155175,
                        "name": "Rosazia",
                        "latitude": "42.12356710",
                        "longitude": "8.77574290"
                    },
                    {
                        "id": 155176,
                        "name": "Sainte-Lucie-de-Tallano",
                        "latitude": "41.67306690",
                        "longitude": "8.97894540"
                    },
                    {
                        "id": 155177,
                        "name": "Salice",
                        "latitude": "42.10720980",
                        "longitude": "8.81793860"
                    },
                    {
                        "id": 155178,
                        "name": "Sampolo",
                        "latitude": "41.94881470",
                        "longitude": "9.10113750"
                    },
                    {
                        "id": 155179,
                        "name": "San-Gavino-di-Carbini",
                        "latitude": "41.68609470",
                        "longitude": "9.06496120"
                    },
                    {
                        "id": 155182,
                        "name": "Sant'Andréa-d'Orcino",
                        "latitude": "42.04525520",
                        "longitude": "8.70199430"
                    },
                    {
                        "id": 155180,
                        "name": "Santa-Maria-Figaniella",
                        "latitude": "41.72890300",
                        "longitude": "8.96815770"
                    },
                    {
                        "id": 155181,
                        "name": "Santa-Maria-Siché",
                        "latitude": "41.88386590",
                        "longitude": "8.94073540"
                    },
                    {
                        "id": 155183,
                        "name": "Sari-d'Orcino",
                        "latitude": "42.06410360",
                        "longitude": "8.75449250"
                    },
                    {
                        "id": 155184,
                        "name": "Sarrola-Carcopino",
                        "latitude": "41.99819430",
                        "longitude": "8.74521320"
                    },
                    {
                        "id": 155185,
                        "name": "Serra-di-Ferro",
                        "latitude": "41.74441690",
                        "longitude": "8.73185340"
                    },
                    {
                        "id": 155186,
                        "name": "Serra-di-Scopamène",
                        "latitude": "41.78278420",
                        "longitude": "9.03631850"
                    },
                    {
                        "id": 155187,
                        "name": "Serriera",
                        "latitude": "42.30848100",
                        "longitude": "8.64718220"
                    },
                    {
                        "id": 155188,
                        "name": "Soccia",
                        "latitude": "42.20663760",
                        "longitude": "8.84852820"
                    },
                    {
                        "id": 155189,
                        "name": "Sollacaro",
                        "latitude": "41.74211740",
                        "longitude": "8.79357890"
                    },
                    {
                        "id": 155190,
                        "name": "Sorbollano",
                        "latitude": "41.75214510",
                        "longitude": "9.07076950"
                    },
                    {
                        "id": 155191,
                        "name": "Sotta",
                        "latitude": "41.55589090",
                        "longitude": "9.01187780"
                    },
                    {
                        "id": 155192,
                        "name": "Tasso",
                        "latitude": "41.94768210",
                        "longitude": "9.04918930"
                    },
                    {
                        "id": 155193,
                        "name": "Tavaco",
                        "latitude": "42.03272730",
                        "longitude": "8.84606610"
                    },
                    {
                        "id": 155194,
                        "name": "Tavera",
                        "latitude": "42.07299640",
                        "longitude": "8.86480670"
                    },
                    {
                        "id": 155195,
                        "name": "Tolla",
                        "latitude": "41.96787260",
                        "longitude": "8.88503090"
                    },
                    {
                        "id": 155196,
                        "name": "Ucciani",
                        "latitude": "42.05153310",
                        "longitude": "8.90293770"
                    },
                    {
                        "id": 155197,
                        "name": "Urbalacone",
                        "latitude": "41.82347630",
                        "longitude": "8.90763450"
                    },
                    {
                        "id": 155198,
                        "name": "Valle-di-Mezzana",
                        "latitude": "42.02532520",
                        "longitude": "8.77545390"
                    },
                    {
                        "id": 155199,
                        "name": "Vero",
                        "latitude": "42.05769310",
                        "longitude": "8.83737700"
                    },
                    {
                        "id": 155200,
                        "name": "Vico",
                        "latitude": "42.14633020",
                        "longitude": "8.57127000"
                    },
                    {
                        "id": 155201,
                        "name": "Viggianello",
                        "latitude": "41.67158340",
                        "longitude": "8.90493080"
                    },
                    {
                        "id": 155202,
                        "name": "Villanova",
                        "latitude": "41.96415850",
                        "longitude": "8.57898450"
                    },
                    {
                        "id": 155203,
                        "name": "Zérubia",
                        "latitude": "41.74596790",
                        "longitude": "8.97213510"
                    },
                    {
                        "id": 155204,
                        "name": "Zévaco",
                        "latitude": "41.88906400",
                        "longitude": "9.00460850"
                    },
                    {
                        "id": 155205,
                        "name": "Zicavo",
                        "latitude": "41.88412060",
                        "longitude": "9.00447510"
                    },
                    {
                        "id": 155206,
                        "name": "Zigliara",
                        "latitude": "41.83614310",
                        "longitude": "8.94211810"
                    },
                    {
                        "id": 155207,
                        "name": "Zoza",
                        "latitude": "41.72266780",
                        "longitude": "9.02871580"
                    }
                ]
            },
            {
                "id": 4987,
                "name": "Côte-d'Or",
                "iso2": "21",
                "latitude": "47.46513020",
                "longitude": "4.23154950",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4988,
                "name": "Côtes-d'Armor",
                "iso2": "22",
                "latitude": "48.46633360",
                "longitude": "-3.34789610",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4989,
                "name": "Creuse",
                "iso2": "23",
                "latitude": "46.05903940",
                "longitude": "1.43150500",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5047,
                "name": "Deux-Sèvres",
                "iso2": "79",
                "latitude": "46.53868170",
                "longitude": "-0.90199480",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4990,
                "name": "Dordogne",
                "iso2": "24",
                "latitude": "45.14234160",
                "longitude": "0.14274080",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4991,
                "name": "Doubs",
                "iso2": "25",
                "latitude": "46.93217740",
                "longitude": "6.34762140",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4992,
                "name": "Drôme",
                "iso2": "26",
                "latitude": "44.72933570",
                "longitude": "4.67821580",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5059,
                "name": "Essonne",
                "iso2": "91",
                "latitude": "48.53046150",
                "longitude": "1.96990560",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4993,
                "name": "Eure",
                "iso2": "27",
                "latitude": "49.07540350",
                "longitude": "0.48937320",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4994,
                "name": "Eure-et-Loir",
                "iso2": "28",
                "latitude": "48.44697840",
                "longitude": "0.81470250",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4995,
                "name": "Finistère",
                "iso2": "29",
                "latitude": "48.22696100",
                "longitude": "-4.82437330",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4822,
                "name": "French Guiana",
                "iso2": "973",
                "latitude": "3.93388900",
                "longitude": "-53.12578200",
                "type": "overseas region",
                "cities": []
            },
            {
                "id": 4824,
                "name": "French Polynesia",
                "iso2": "PF",
                "latitude": "-17.67974200",
                "longitude": "-149.40684300",
                "type": "overseas collectivity",
                "cities": []
            },
            {
                "id": 5065,
                "name": "French Southern and Antarctic Lands",
                "iso2": "TF",
                "latitude": "-47.54466040",
                "longitude": "51.28375420",
                "type": "overseas territory",
                "cities": []
            },
            {
                "id": 4998,
                "name": "Gard",
                "iso2": "30",
                "latitude": "43.95952760",
                "longitude": "3.49356810",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5000,
                "name": "Gers",
                "iso2": "32",
                "latitude": "43.69505340",
                "longitude": "-0.09997280",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5001,
                "name": "Gironde",
                "iso2": "33",
                "latitude": "44.89584690",
                "longitude": "-1.59405320",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4820,
                "name": "Grand-Est",
                "iso2": "GES",
                "latitude": "48.69980300",
                "longitude": "6.18780740",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39245,
                        "name": "Abreschviller",
                        "latitude": "48.63698000",
                        "longitude": "7.09607000"
                    },
                    {
                        "id": 39249,
                        "name": "Achenheim",
                        "latitude": "48.58070000",
                        "longitude": "7.62803000"
                    },
                    {
                        "id": 39269,
                        "name": "Aiglemont",
                        "latitude": "49.78031000",
                        "longitude": "4.76483000"
                    },
                    {
                        "id": 39293,
                        "name": "Aix-en-Othe",
                        "latitude": "48.22391000",
                        "longitude": "3.73425000"
                    },
                    {
                        "id": 39312,
                        "name": "Algolsheim",
                        "latitude": "48.00629000",
                        "longitude": "7.55945000"
                    },
                    {
                        "id": 39313,
                        "name": "Algrange",
                        "latitude": "49.36276000",
                        "longitude": "6.05094000"
                    },
                    {
                        "id": 39336,
                        "name": "Alsting",
                        "latitude": "49.18175000",
                        "longitude": "6.99255000"
                    },
                    {
                        "id": 39338,
                        "name": "Altkirch",
                        "latitude": "47.62417000",
                        "longitude": "7.23954000"
                    },
                    {
                        "id": 39339,
                        "name": "Altorf",
                        "latitude": "48.52166000",
                        "longitude": "7.52787000"
                    },
                    {
                        "id": 39346,
                        "name": "Amanvillers",
                        "latitude": "49.16784000",
                        "longitude": "6.04367000"
                    },
                    {
                        "id": 39366,
                        "name": "Ammerschwihr",
                        "latitude": "48.12548000",
                        "longitude": "7.28282000"
                    },
                    {
                        "id": 39367,
                        "name": "Amnéville",
                        "latitude": "49.25671000",
                        "longitude": "6.13414000"
                    },
                    {
                        "id": 39372,
                        "name": "Ancerville",
                        "latitude": "48.63574000",
                        "longitude": "5.02091000"
                    },
                    {
                        "id": 39374,
                        "name": "Ancy-sur-Moselle",
                        "latitude": "49.05689000",
                        "longitude": "6.05775000"
                    },
                    {
                        "id": 39384,
                        "name": "Andlau",
                        "latitude": "48.38607000",
                        "longitude": "7.41697000"
                    },
                    {
                        "id": 39385,
                        "name": "Andolsheim",
                        "latitude": "48.06179000",
                        "longitude": "7.41637000"
                    },
                    {
                        "id": 39400,
                        "name": "Angevillers",
                        "latitude": "49.38815000",
                        "longitude": "6.04430000"
                    },
                    {
                        "id": 39426,
                        "name": "Anould",
                        "latitude": "48.18526000",
                        "longitude": "6.94597000"
                    },
                    {
                        "id": 39461,
                        "name": "Arches",
                        "latitude": "48.11856000",
                        "longitude": "6.52806000"
                    },
                    {
                        "id": 39462,
                        "name": "Archettes",
                        "latitude": "48.12320000",
                        "longitude": "6.53723000"
                    },
                    {
                        "id": 39464,
                        "name": "Arcis-sur-Aube",
                        "latitude": "48.53387000",
                        "longitude": "4.14085000"
                    },
                    {
                        "id": 39466,
                        "name": "Ardennes",
                        "latitude": "49.63202000",
                        "longitude": "4.65369000"
                    },
                    {
                        "id": 39473,
                        "name": "Argancy",
                        "latitude": "49.19543000",
                        "longitude": "6.20157000"
                    },
                    {
                        "id": 39515,
                        "name": "Ars-sur-Moselle",
                        "latitude": "49.07791000",
                        "longitude": "6.07420000"
                    },
                    {
                        "id": 39517,
                        "name": "Art-sur-Meurthe",
                        "latitude": "48.65750000",
                        "longitude": "6.26708000"
                    },
                    {
                        "id": 39545,
                        "name": "Aspach",
                        "latitude": "47.64234000",
                        "longitude": "7.23353000"
                    },
                    {
                        "id": 39546,
                        "name": "Aspach-le-Bas",
                        "latitude": "47.76135000",
                        "longitude": "7.15104000"
                    },
                    {
                        "id": 39547,
                        "name": "Aspach-le-Haut",
                        "latitude": "47.77653000",
                        "longitude": "7.13145000"
                    },
                    {
                        "id": 39564,
                        "name": "Attigny",
                        "latitude": "49.47846000",
                        "longitude": "4.57803000"
                    },
                    {
                        "id": 39587,
                        "name": "Auboué",
                        "latitude": "49.21198000",
                        "longitude": "5.97663000"
                    },
                    {
                        "id": 39600,
                        "name": "Audun-le-Roman",
                        "latitude": "49.36977000",
                        "longitude": "5.89545000"
                    },
                    {
                        "id": 39601,
                        "name": "Audun-le-Tiche",
                        "latitude": "49.47217000",
                        "longitude": "5.95550000"
                    },
                    {
                        "id": 39605,
                        "name": "Augny",
                        "latitude": "49.06110000",
                        "longitude": "6.11820000"
                    },
                    {
                        "id": 39616,
                        "name": "Aumetz",
                        "latitude": "49.41787000",
                        "longitude": "5.94418000"
                    },
                    {
                        "id": 39674,
                        "name": "Avize",
                        "latitude": "48.97352000",
                        "longitude": "4.01438000"
                    },
                    {
                        "id": 39683,
                        "name": "Ay",
                        "latitude": "49.05457000",
                        "longitude": "4.00343000"
                    },
                    {
                        "id": 39684,
                        "name": "Ay-sur-Moselle",
                        "latitude": "49.24326000",
                        "longitude": "6.20627000"
                    },
                    {
                        "id": 39686,
                        "name": "Aydoilles",
                        "latitude": "48.21026000",
                        "longitude": "6.57389000"
                    },
                    {
                        "id": 39699,
                        "name": "Baccarat",
                        "latitude": "48.44984000",
                        "longitude": "6.73946000"
                    },
                    {
                        "id": 39704,
                        "name": "Badonviller",
                        "latitude": "48.50116000",
                        "longitude": "6.89218000"
                    },
                    {
                        "id": 39735,
                        "name": "Bains-les-Bains",
                        "latitude": "48.00113000",
                        "longitude": "6.26492000"
                    },
                    {
                        "id": 39737,
                        "name": "Bainville-sur-Madon",
                        "latitude": "48.58725000",
                        "longitude": "6.09580000"
                    },
                    {
                        "id": 39743,
                        "name": "Balan",
                        "latitude": "49.68881000",
                        "longitude": "4.96478000"
                    },
                    {
                        "id": 39749,
                        "name": "Baldersheim",
                        "latitude": "47.80136000",
                        "longitude": "7.38078000"
                    },
                    {
                        "id": 39758,
                        "name": "Ban-de-Laveline",
                        "latitude": "48.24498000",
                        "longitude": "7.06593000"
                    },
                    {
                        "id": 39761,
                        "name": "Bantzenheim",
                        "latitude": "47.82452000",
                        "longitude": "7.51445000"
                    },
                    {
                        "id": 39765,
                        "name": "Bar-le-Duc",
                        "latitude": "48.77275000",
                        "longitude": "5.16108000"
                    },
                    {
                        "id": 39766,
                        "name": "Bar-sur-Aube",
                        "latitude": "48.23315000",
                        "longitude": "4.70640000"
                    },
                    {
                        "id": 39767,
                        "name": "Bar-sur-Seine",
                        "latitude": "48.11295000",
                        "longitude": "4.37656000"
                    },
                    {
                        "id": 39790,
                        "name": "Barr",
                        "latitude": "48.40755000",
                        "longitude": "7.44873000"
                    },
                    {
                        "id": 39794,
                        "name": "Bartenheim",
                        "latitude": "47.63364000",
                        "longitude": "7.47951000"
                    },
                    {
                        "id": 39795,
                        "name": "Bas-Rhin",
                        "latitude": "48.65693000",
                        "longitude": "7.56346000"
                    },
                    {
                        "id": 39799,
                        "name": "Basse-Ham",
                        "latitude": "49.38626000",
                        "longitude": "6.24180000"
                    },
                    {
                        "id": 39805,
                        "name": "Batilly",
                        "latitude": "49.17372000",
                        "longitude": "5.96869000"
                    },
                    {
                        "id": 39806,
                        "name": "Battenheim",
                        "latitude": "47.81999000",
                        "longitude": "7.38170000"
                    },
                    {
                        "id": 39821,
                        "name": "Bayard-sur-Marne",
                        "latitude": "48.55410000",
                        "longitude": "5.07680000"
                    },
                    {
                        "id": 39823,
                        "name": "Bayon",
                        "latitude": "48.47425000",
                        "longitude": "6.31631000"
                    },
                    {
                        "id": 39826,
                        "name": "Bazancourt",
                        "latitude": "49.36562000",
                        "longitude": "4.17051000"
                    },
                    {
                        "id": 39828,
                        "name": "Bazeilles",
                        "latitude": "49.67650000",
                        "longitude": "4.97752000"
                    },
                    {
                        "id": 39899,
                        "name": "Behren-lès-Forbach",
                        "latitude": "49.16949000",
                        "longitude": "6.93933000"
                    },
                    {
                        "id": 39923,
                        "name": "Belleville",
                        "latitude": "48.81817000",
                        "longitude": "6.10294000"
                    },
                    {
                        "id": 39925,
                        "name": "Belleville-sur-Meuse",
                        "latitude": "49.17863000",
                        "longitude": "5.37190000"
                    },
                    {
                        "id": 39939,
                        "name": "Benfeld",
                        "latitude": "48.37062000",
                        "longitude": "7.59370000"
                    },
                    {
                        "id": 40424,
                        "name": "Béning-lès-Saint-Avold",
                        "latitude": "49.13504000",
                        "longitude": "6.83902000"
                    },
                    {
                        "id": 39941,
                        "name": "Bennwihr",
                        "latitude": "48.14456000",
                        "longitude": "7.32445000"
                    },
                    {
                        "id": 39946,
                        "name": "Bergheim",
                        "latitude": "48.20540000",
                        "longitude": "7.36299000"
                    },
                    {
                        "id": 39947,
                        "name": "Bergholtz",
                        "latitude": "47.91670000",
                        "longitude": "7.24651000"
                    },
                    {
                        "id": 39950,
                        "name": "Bernardswiller",
                        "latitude": "48.45035000",
                        "longitude": "7.46238000"
                    },
                    {
                        "id": 39963,
                        "name": "Berrwiller",
                        "latitude": "47.84984000",
                        "longitude": "7.21922000"
                    },
                    {
                        "id": 39965,
                        "name": "Berstett",
                        "latitude": "48.67900000",
                        "longitude": "7.65721000"
                    },
                    {
                        "id": 39969,
                        "name": "Bertrange",
                        "latitude": "49.31368000",
                        "longitude": "6.19208000"
                    },
                    {
                        "id": 40431,
                        "name": "Bétheny",
                        "latitude": "49.28498000",
                        "longitude": "4.05495000"
                    },
                    {
                        "id": 39985,
                        "name": "Betschdorf",
                        "latitude": "48.89825000",
                        "longitude": "7.90196000"
                    },
                    {
                        "id": 39986,
                        "name": "Bettancourt-la-Ferrée",
                        "latitude": "48.64898000",
                        "longitude": "4.96971000"
                    },
                    {
                        "id": 40001,
                        "name": "Bezannes",
                        "latitude": "49.22339000",
                        "longitude": "3.98892000"
                    },
                    {
                        "id": 40011,
                        "name": "Bienville",
                        "latitude": "48.57582000",
                        "longitude": "5.04579000"
                    },
                    {
                        "id": 40013,
                        "name": "Biesheim",
                        "latitude": "48.04118000",
                        "longitude": "7.54474000"
                    },
                    {
                        "id": 40014,
                        "name": "Biesles",
                        "latitude": "48.08597000",
                        "longitude": "5.29409000"
                    },
                    {
                        "id": 40027,
                        "name": "Bining",
                        "latitude": "49.03729000",
                        "longitude": "7.25273000"
                    },
                    {
                        "id": 40031,
                        "name": "Bischheim",
                        "latitude": "48.61612000",
                        "longitude": "7.75343000"
                    },
                    {
                        "id": 40032,
                        "name": "Bischoffsheim",
                        "latitude": "48.48703000",
                        "longitude": "7.48967000"
                    },
                    {
                        "id": 40033,
                        "name": "Bischwiller",
                        "latitude": "48.76826000",
                        "longitude": "7.85406000"
                    },
                    {
                        "id": 40034,
                        "name": "Bitche",
                        "latitude": "49.05232000",
                        "longitude": "7.42992000"
                    },
                    {
                        "id": 40035,
                        "name": "Bitschwiller-lès-Thann",
                        "latitude": "47.82969000",
                        "longitude": "7.07911000"
                    },
                    {
                        "id": 40043,
                        "name": "Blaesheim",
                        "latitude": "48.50648000",
                        "longitude": "7.60923000"
                    },
                    {
                        "id": 40045,
                        "name": "Blagny",
                        "latitude": "49.62167000",
                        "longitude": "5.19194000"
                    },
                    {
                        "id": 40073,
                        "name": "Blénod-lès-Pont-à-Mousson",
                        "latitude": "48.88487000",
                        "longitude": "6.04844000"
                    },
                    {
                        "id": 40074,
                        "name": "Blénod-lès-Toul",
                        "latitude": "48.59882000",
                        "longitude": "5.83685000"
                    },
                    {
                        "id": 40066,
                        "name": "Bliesbruck",
                        "latitude": "49.11543000",
                        "longitude": "7.18112000"
                    },
                    {
                        "id": 40068,
                        "name": "Blodelsheim",
                        "latitude": "47.88538000",
                        "longitude": "7.53635000"
                    },
                    {
                        "id": 40071,
                        "name": "Blotzheim",
                        "latitude": "47.60260000",
                        "longitude": "7.49654000"
                    },
                    {
                        "id": 40439,
                        "name": "Bœrsch",
                        "latitude": "48.47656000",
                        "longitude": "7.43998000"
                    },
                    {
                        "id": 40104,
                        "name": "Bollwiller",
                        "latitude": "47.85832000",
                        "longitude": "7.26179000"
                    },
                    {
                        "id": 40106,
                        "name": "Bologne",
                        "latitude": "48.20005000",
                        "longitude": "5.14209000"
                    },
                    {
                        "id": 40133,
                        "name": "Boofzheim",
                        "latitude": "48.33186000",
                        "longitude": "7.68071000"
                    },
                    {
                        "id": 40158,
                        "name": "Bouilly",
                        "latitude": "48.19674000",
                        "longitude": "4.00011000"
                    },
                    {
                        "id": 40162,
                        "name": "Boulange",
                        "latitude": "49.38229000",
                        "longitude": "5.95000000"
                    },
                    {
                        "id": 40163,
                        "name": "Boulay-Moselle",
                        "latitude": "49.18333000",
                        "longitude": "6.50000000"
                    },
                    {
                        "id": 40169,
                        "name": "Bouligny",
                        "latitude": "49.29189000",
                        "longitude": "5.74248000"
                    },
                    {
                        "id": 40176,
                        "name": "Boult-sur-Suippe",
                        "latitude": "49.37149000",
                        "longitude": "4.14632000"
                    },
                    {
                        "id": 40180,
                        "name": "Bourbonne-les-Bains",
                        "latitude": "47.95305000",
                        "longitude": "5.74801000"
                    },
                    {
                        "id": 40203,
                        "name": "Bourgogne",
                        "latitude": "49.34962000",
                        "longitude": "4.07111000"
                    },
                    {
                        "id": 40218,
                        "name": "Bousse",
                        "latitude": "49.27786000",
                        "longitude": "6.19672000"
                    },
                    {
                        "id": 40231,
                        "name": "Bouxières-aux-Chênes",
                        "latitude": "48.77215000",
                        "longitude": "6.26152000"
                    },
                    {
                        "id": 40232,
                        "name": "Bouxières-aux-Dames",
                        "latitude": "48.75441000",
                        "longitude": "6.16294000"
                    },
                    {
                        "id": 40233,
                        "name": "Bouxwiller",
                        "latitude": "48.82495000",
                        "longitude": "7.48117000"
                    },
                    {
                        "id": 40236,
                        "name": "Bouzonville",
                        "latitude": "49.29188000",
                        "longitude": "6.53386000"
                    },
                    {
                        "id": 40298,
                        "name": "Breuschwickersheim",
                        "latitude": "48.58007000",
                        "longitude": "7.60159000"
                    },
                    {
                        "id": 40362,
                        "name": "Bréviandes",
                        "latitude": "48.25693000",
                        "longitude": "4.09531000"
                    },
                    {
                        "id": 40308,
                        "name": "Brienne-le-Château",
                        "latitude": "48.39319000",
                        "longitude": "4.52637000"
                    },
                    {
                        "id": 40311,
                        "name": "Briey",
                        "latitude": "49.24920000",
                        "longitude": "5.93975000"
                    },
                    {
                        "id": 40345,
                        "name": "Brumath",
                        "latitude": "48.73398000",
                        "longitude": "7.71095000"
                    },
                    {
                        "id": 40347,
                        "name": "Brunstatt",
                        "latitude": "47.72131000",
                        "longitude": "7.32009000"
                    },
                    {
                        "id": 40348,
                        "name": "Bruyères",
                        "latitude": "48.20709000",
                        "longitude": "6.71845000"
                    },
                    {
                        "id": 40371,
                        "name": "Buchères",
                        "latitude": "48.23508000",
                        "longitude": "4.11310000"
                    },
                    {
                        "id": 40377,
                        "name": "Buhl",
                        "latitude": "47.92806000",
                        "longitude": "7.18719000"
                    },
                    {
                        "id": 40380,
                        "name": "Bulgnéville",
                        "latitude": "48.20694000",
                        "longitude": "5.83430000"
                    },
                    {
                        "id": 40389,
                        "name": "Burnhaupt-le-Bas",
                        "latitude": "47.71764000",
                        "longitude": "7.16148000"
                    },
                    {
                        "id": 40390,
                        "name": "Burnhaupt-le-Haut",
                        "latitude": "47.73162000",
                        "longitude": "7.14437000"
                    },
                    {
                        "id": 40396,
                        "name": "Bussang",
                        "latitude": "47.88449000",
                        "longitude": "6.85272000"
                    },
                    {
                        "id": 40545,
                        "name": "Carignan",
                        "latitude": "49.63159000",
                        "longitude": "5.16796000"
                    },
                    {
                        "id": 40548,
                        "name": "Carling",
                        "latitude": "49.16635000",
                        "longitude": "6.71563000"
                    },
                    {
                        "id": 40565,
                        "name": "Carspach",
                        "latitude": "47.61608000",
                        "longitude": "7.21018000"
                    },
                    {
                        "id": 40599,
                        "name": "Cattenom",
                        "latitude": "49.40627000",
                        "longitude": "6.24297000"
                    },
                    {
                        "id": 40650,
                        "name": "Cernay",
                        "latitude": "47.80970000",
                        "longitude": "7.17699000"
                    },
                    {
                        "id": 40652,
                        "name": "Cernay-lès-Reims",
                        "latitude": "49.26375000",
                        "longitude": "4.10216000"
                    },
                    {
                        "id": 40687,
                        "name": "Chalampé",
                        "latitude": "47.82019000",
                        "longitude": "7.54113000"
                    },
                    {
                        "id": 40690,
                        "name": "Chaligny",
                        "latitude": "48.62422000",
                        "longitude": "6.08262000"
                    },
                    {
                        "id": 40691,
                        "name": "Chalindrey",
                        "latitude": "47.80308000",
                        "longitude": "5.42797000"
                    },
                    {
                        "id": 40933,
                        "name": "Châlons-en-Champagne",
                        "latitude": "48.95393000",
                        "longitude": "4.36724000"
                    },
                    {
                        "id": 40704,
                        "name": "Chamarandes-Choignes",
                        "latitude": "48.08333000",
                        "longitude": "5.15000000"
                    },
                    {
                        "id": 40734,
                        "name": "Champenoux",
                        "latitude": "48.74257000",
                        "longitude": "6.34830000"
                    },
                    {
                        "id": 40740,
                        "name": "Champigneulles",
                        "latitude": "48.73404000",
                        "longitude": "6.16181000"
                    },
                    {
                        "id": 40759,
                        "name": "Chancenay",
                        "latitude": "48.67001000",
                        "longitude": "4.98715000"
                    },
                    {
                        "id": 40768,
                        "name": "Chanteheux",
                        "latitude": "48.59722000",
                        "longitude": "6.52783000"
                    },
                    {
                        "id": 40777,
                        "name": "Chantraine",
                        "latitude": "48.17157000",
                        "longitude": "6.43538000"
                    },
                    {
                        "id": 40780,
                        "name": "Chaource",
                        "latitude": "48.05915000",
                        "longitude": "4.13738000"
                    },
                    {
                        "id": 40802,
                        "name": "Charleville-Mézières",
                        "latitude": "49.76850000",
                        "longitude": "4.72487000"
                    },
                    {
                        "id": 40806,
                        "name": "Charmes",
                        "latitude": "48.37220000",
                        "longitude": "6.29117000"
                    },
                    {
                        "id": 40942,
                        "name": "Château-Porcien",
                        "latitude": "49.52740000",
                        "longitude": "4.24533000"
                    },
                    {
                        "id": 40945,
                        "name": "Château-Salins",
                        "latitude": "48.81885000",
                        "longitude": "6.51455000"
                    },
                    {
                        "id": 40979,
                        "name": "Châteauvillain",
                        "latitude": "48.03655000",
                        "longitude": "4.91823000"
                    },
                    {
                        "id": 40982,
                        "name": "Châtel-Saint-Germain",
                        "latitude": "49.12255000",
                        "longitude": "6.08006000"
                    },
                    {
                        "id": 40983,
                        "name": "Châtel-sur-Moselle",
                        "latitude": "48.31430000",
                        "longitude": "6.39403000"
                    },
                    {
                        "id": 40988,
                        "name": "Châtenois",
                        "latitude": "48.27201000",
                        "longitude": "7.40109000"
                    },
                    {
                        "id": 41003,
                        "name": "Châtillon-sur-Marne",
                        "latitude": "49.10048000",
                        "longitude": "3.76023000"
                    },
                    {
                        "id": 40843,
                        "name": "Chaumont",
                        "latitude": "48.11121000",
                        "longitude": "5.14134000"
                    },
                    {
                        "id": 40860,
                        "name": "Chavelot",
                        "latitude": "48.23459000",
                        "longitude": "6.43809000"
                    },
                    {
                        "id": 40862,
                        "name": "Chavigny",
                        "latitude": "48.62899000",
                        "longitude": "6.12317000"
                    },
                    {
                        "id": 40873,
                        "name": "Cheniménil",
                        "latitude": "48.13880000",
                        "longitude": "6.60346000"
                    },
                    {
                        "id": 40897,
                        "name": "Chevillon",
                        "latitude": "48.52869000",
                        "longitude": "5.13086000"
                    },
                    {
                        "id": 41026,
                        "name": "Cirey-sur-Vezouze",
                        "latitude": "48.58093000",
                        "longitude": "6.94573000"
                    },
                    {
                        "id": 41050,
                        "name": "Clermont-en-Argonne",
                        "latitude": "49.10711000",
                        "longitude": "5.07002000"
                    },
                    {
                        "id": 41060,
                        "name": "Clouange",
                        "latitude": "49.26240000",
                        "longitude": "6.09723000"
                    },
                    {
                        "id": 41077,
                        "name": "Cocheren",
                        "latitude": "49.14384000",
                        "longitude": "6.85649000"
                    },
                    {
                        "id": 41096,
                        "name": "Colmar",
                        "latitude": "48.08078000",
                        "longitude": "7.35584000"
                    },
                    {
                        "id": 41101,
                        "name": "Colombey-les-Belles",
                        "latitude": "48.52920000",
                        "longitude": "5.89451000"
                    },
                    {
                        "id": 41121,
                        "name": "Commercy",
                        "latitude": "48.76128000",
                        "longitude": "5.59067000"
                    },
                    {
                        "id": 41123,
                        "name": "Compertrix",
                        "latitude": "48.94179000",
                        "longitude": "4.34631000"
                    },
                    {
                        "id": 41143,
                        "name": "Conflans-en-Jarnisy",
                        "latitude": "49.16725000",
                        "longitude": "5.85515000"
                    },
                    {
                        "id": 41149,
                        "name": "Connantre",
                        "latitude": "48.72657000",
                        "longitude": "3.92403000"
                    },
                    {
                        "id": 41157,
                        "name": "Contrexéville",
                        "latitude": "48.18424000",
                        "longitude": "5.89572000"
                    },
                    {
                        "id": 41171,
                        "name": "Corcieux",
                        "latitude": "48.17236000",
                        "longitude": "6.88148000"
                    },
                    {
                        "id": 41184,
                        "name": "Cormicy",
                        "latitude": "49.37071000",
                        "longitude": "3.89595000"
                    },
                    {
                        "id": 41185,
                        "name": "Cormontreuil",
                        "latitude": "49.21667000",
                        "longitude": "4.05000000"
                    },
                    {
                        "id": 41195,
                        "name": "Cornimont",
                        "latitude": "47.95998000",
                        "longitude": "6.83038000"
                    },
                    {
                        "id": 41196,
                        "name": "Corny-sur-Moselle",
                        "latitude": "49.03557000",
                        "longitude": "6.06084000"
                    },
                    {
                        "id": 41209,
                        "name": "Cosnes",
                        "latitude": "49.51964000",
                        "longitude": "5.71210000"
                    },
                    {
                        "id": 41242,
                        "name": "Courcelles-Chaussy",
                        "latitude": "49.10940000",
                        "longitude": "6.40153000"
                    },
                    {
                        "id": 41250,
                        "name": "Courcy",
                        "latitude": "49.32361000",
                        "longitude": "4.00257000"
                    },
                    {
                        "id": 41270,
                        "name": "Courtisols",
                        "latitude": "48.98670000",
                        "longitude": "4.51700000"
                    },
                    {
                        "id": 41345,
                        "name": "Créhange",
                        "latitude": "49.05897000",
                        "longitude": "6.58178000"
                    },
                    {
                        "id": 41305,
                        "name": "Creney-près-Troyes",
                        "latitude": "48.33333000",
                        "longitude": "4.13333000"
                    },
                    {
                        "id": 41312,
                        "name": "Creutzwald",
                        "latitude": "49.20531000",
                        "longitude": "6.69668000"
                    },
                    {
                        "id": 41338,
                        "name": "Crusnes",
                        "latitude": "49.43406000",
                        "longitude": "5.91557000"
                    },
                    {
                        "id": 41382,
                        "name": "Custines",
                        "latitude": "48.79127000",
                        "longitude": "6.14461000"
                    },
                    {
                        "id": 41401,
                        "name": "Dabo",
                        "latitude": "48.65373000",
                        "longitude": "7.23611000"
                    },
                    {
                        "id": 41402,
                        "name": "Dachstein",
                        "latitude": "48.56127000",
                        "longitude": "7.53233000"
                    },
                    {
                        "id": 41409,
                        "name": "Dambach-la-Ville",
                        "latitude": "48.32379000",
                        "longitude": "7.42547000"
                    },
                    {
                        "id": 41410,
                        "name": "Damelevières",
                        "latitude": "48.55930000",
                        "longitude": "6.38453000"
                    },
                    {
                        "id": 41411,
                        "name": "Damery",
                        "latitude": "49.07238000",
                        "longitude": "3.88036000"
                    },
                    {
                        "id": 41428,
                        "name": "Dannemarie",
                        "latitude": "47.63034000",
                        "longitude": "7.11903000"
                    },
                    {
                        "id": 41434,
                        "name": "Darney",
                        "latitude": "48.08660000",
                        "longitude": "6.04917000"
                    },
                    {
                        "id": 41435,
                        "name": "Darnieulles",
                        "latitude": "48.19950000",
                        "longitude": "6.34929000"
                    },
                    {
                        "id": 41439,
                        "name": "Dauendorf",
                        "latitude": "48.82987000",
                        "longitude": "7.65532000"
                    },
                    {
                        "id": 41613,
                        "name": "Département de l'Aube",
                        "latitude": "48.25000000",
                        "longitude": "4.08333000"
                    },
                    {
                        "id": 41456,
                        "name": "Dessenheim",
                        "latitude": "47.97767000",
                        "longitude": "7.48891000"
                    },
                    {
                        "id": 41458,
                        "name": "Dettwiller",
                        "latitude": "48.75415000",
                        "longitude": "7.46633000"
                    },
                    {
                        "id": 41461,
                        "name": "Deville",
                        "latitude": "49.87893000",
                        "longitude": "4.70610000"
                    },
                    {
                        "id": 41462,
                        "name": "Deyvillers",
                        "latitude": "48.20013000",
                        "longitude": "6.51533000"
                    },
                    {
                        "id": 41465,
                        "name": "Didenheim",
                        "latitude": "47.71866000",
                        "longitude": "7.30157000"
                    },
                    {
                        "id": 41467,
                        "name": "Diebling",
                        "latitude": "49.10966000",
                        "longitude": "6.93974000"
                    },
                    {
                        "id": 41468,
                        "name": "Diemeringen",
                        "latitude": "48.94013000",
                        "longitude": "7.18839000"
                    },
                    {
                        "id": 41470,
                        "name": "Diesen",
                        "latitude": "49.17818000",
                        "longitude": "6.67798000"
                    },
                    {
                        "id": 41471,
                        "name": "Dietwiller",
                        "latitude": "47.69278000",
                        "longitude": "7.40300000"
                    },
                    {
                        "id": 41472,
                        "name": "Dieue-sur-Meuse",
                        "latitude": "49.07200000",
                        "longitude": "5.42248000"
                    },
                    {
                        "id": 41474,
                        "name": "Dieulouard",
                        "latitude": "48.84137000",
                        "longitude": "6.06782000"
                    },
                    {
                        "id": 41475,
                        "name": "Dieuze",
                        "latitude": "48.81263000",
                        "longitude": "6.71780000"
                    },
                    {
                        "id": 41484,
                        "name": "Dingsheim",
                        "latitude": "48.63053000",
                        "longitude": "7.66932000"
                    },
                    {
                        "id": 41487,
                        "name": "Dinsheim-sur-Bruche",
                        "latitude": "48.54258000",
                        "longitude": "7.42727000"
                    },
                    {
                        "id": 41493,
                        "name": "Distroff",
                        "latitude": "49.33295000",
                        "longitude": "6.26662000"
                    },
                    {
                        "id": 41498,
                        "name": "Dizy",
                        "latitude": "49.06667000",
                        "longitude": "3.96667000"
                    },
                    {
                        "id": 41500,
                        "name": "Docelles",
                        "latitude": "48.14475000",
                        "longitude": "6.61289000"
                    },
                    {
                        "id": 41501,
                        "name": "Dogneville",
                        "latitude": "48.22251000",
                        "longitude": "6.45944000"
                    },
                    {
                        "id": 41508,
                        "name": "Dom-le-Mesnil",
                        "latitude": "49.69012000",
                        "longitude": "4.80363000"
                    },
                    {
                        "id": 41514,
                        "name": "Dombasle-sur-Meurthe",
                        "latitude": "48.61861000",
                        "longitude": "6.35538000"
                    },
                    {
                        "id": 41517,
                        "name": "Domgermain",
                        "latitude": "48.64276000",
                        "longitude": "5.82957000"
                    },
                    {
                        "id": 41518,
                        "name": "Dommartin-lès-Remiremont",
                        "latitude": "47.99902000",
                        "longitude": "6.64048000"
                    },
                    {
                        "id": 41519,
                        "name": "Dommartin-lès-Toul",
                        "latitude": "48.66949000",
                        "longitude": "5.91005000"
                    },
                    {
                        "id": 41529,
                        "name": "Donchery",
                        "latitude": "49.69584000",
                        "longitude": "4.87417000"
                    },
                    {
                        "id": 41530,
                        "name": "Doncourt-lès-Conflans",
                        "latitude": "49.14250000",
                        "longitude": "5.93368000"
                    },
                    {
                        "id": 41540,
                        "name": "Dorlisheim",
                        "latitude": "48.52485000",
                        "longitude": "7.48624000"
                    },
                    {
                        "id": 41541,
                        "name": "Dormans",
                        "latitude": "49.07392000",
                        "longitude": "3.63819000"
                    },
                    {
                        "id": 41544,
                        "name": "Dossenheim-sur-Zinsel",
                        "latitude": "48.80590000",
                        "longitude": "7.40273000"
                    },
                    {
                        "id": 41552,
                        "name": "Doulaincourt-Saucourt",
                        "latitude": "48.31667000",
                        "longitude": "5.20000000"
                    },
                    {
                        "id": 41561,
                        "name": "Douzy",
                        "latitude": "49.67080000",
                        "longitude": "5.04156000"
                    },
                    {
                        "id": 41579,
                        "name": "Drulingen",
                        "latitude": "48.86804000",
                        "longitude": "7.18956000"
                    },
                    {
                        "id": 41581,
                        "name": "Drusenheim",
                        "latitude": "48.76207000",
                        "longitude": "7.95326000"
                    },
                    {
                        "id": 41587,
                        "name": "Dugny-sur-Meuse",
                        "latitude": "49.10953000",
                        "longitude": "5.38550000"
                    },
                    {
                        "id": 41593,
                        "name": "Duppigheim",
                        "latitude": "48.52866000",
                        "longitude": "7.59421000"
                    },
                    {
                        "id": 41595,
                        "name": "Durrenbach",
                        "latitude": "48.89681000",
                        "longitude": "7.76769000"
                    },
                    {
                        "id": 41599,
                        "name": "Duttlenheim",
                        "latitude": "48.52553000",
                        "longitude": "7.56572000"
                    },
                    {
                        "id": 41654,
                        "name": "Ebersheim",
                        "latitude": "48.30438000",
                        "longitude": "7.49903000"
                    },
                    {
                        "id": 41655,
                        "name": "Eckbolsheim",
                        "latitude": "48.58075000",
                        "longitude": "7.68768000"
                    },
                    {
                        "id": 41656,
                        "name": "Eckwersheim",
                        "latitude": "48.68167000",
                        "longitude": "7.69687000"
                    },
                    {
                        "id": 48052,
                        "name": "Écrouves",
                        "latitude": "48.67986000",
                        "longitude": "5.84267000"
                    },
                    {
                        "id": 41660,
                        "name": "Eguisheim",
                        "latitude": "48.04280000",
                        "longitude": "7.30617000"
                    },
                    {
                        "id": 41661,
                        "name": "Einville-au-Jard",
                        "latitude": "48.65569000",
                        "longitude": "6.48447000"
                    },
                    {
                        "id": 48065,
                        "name": "Éloyes",
                        "latitude": "48.09793000",
                        "longitude": "6.60653000"
                    },
                    {
                        "id": 41668,
                        "name": "Enchenberg",
                        "latitude": "49.01354000",
                        "longitude": "7.33868000"
                    },
                    {
                        "id": 41671,
                        "name": "Ennery",
                        "latitude": "49.22619000",
                        "longitude": "6.21778000"
                    },
                    {
                        "id": 41676,
                        "name": "Ensisheim",
                        "latitude": "47.86584000",
                        "longitude": "7.35052000"
                    },
                    {
                        "id": 41680,
                        "name": "Entrange",
                        "latitude": "49.41300000",
                        "longitude": "6.10501000"
                    },
                    {
                        "id": 41683,
                        "name": "Entzheim",
                        "latitude": "48.53424000",
                        "longitude": "7.63772000"
                    },
                    {
                        "id": 48073,
                        "name": "Épernay",
                        "latitude": "49.04000000",
                        "longitude": "3.95922000"
                    },
                    {
                        "id": 41686,
                        "name": "Epfig",
                        "latitude": "48.35933000",
                        "longitude": "7.46427000"
                    },
                    {
                        "id": 48078,
                        "name": "Épinal",
                        "latitude": "48.18324000",
                        "longitude": "6.45304000"
                    },
                    {
                        "id": 41697,
                        "name": "Ernolsheim-Bruche",
                        "latitude": "48.56531000",
                        "longitude": "7.56503000"
                    },
                    {
                        "id": 41702,
                        "name": "Erstein",
                        "latitude": "48.42373000",
                        "longitude": "7.66262000"
                    },
                    {
                        "id": 41703,
                        "name": "Ervy-le-Châtel",
                        "latitude": "48.04116000",
                        "longitude": "3.90988000"
                    },
                    {
                        "id": 41709,
                        "name": "Eschau",
                        "latitude": "48.48897000",
                        "longitude": "7.71644000"
                    },
                    {
                        "id": 41710,
                        "name": "Eschbach",
                        "latitude": "48.87465000",
                        "longitude": "7.73609000"
                    },
                    {
                        "id": 41711,
                        "name": "Eschentzwiller",
                        "latitude": "47.71270000",
                        "longitude": "7.39773000"
                    },
                    {
                        "id": 41726,
                        "name": "Essey-lès-Nancy",
                        "latitude": "48.70500000",
                        "longitude": "6.22691000"
                    },
                    {
                        "id": 41731,
                        "name": "Esternay",
                        "latitude": "48.73232000",
                        "longitude": "3.56159000"
                    },
                    {
                        "id": 41734,
                        "name": "Estissac",
                        "latitude": "48.26920000",
                        "longitude": "3.80515000"
                    },
                    {
                        "id": 48092,
                        "name": "Étain",
                        "latitude": "49.21259000",
                        "longitude": "5.64022000"
                    },
                    {
                        "id": 48104,
                        "name": "Étival-Clairefontaine",
                        "latitude": "48.36519000",
                        "longitude": "6.86118000"
                    },
                    {
                        "id": 41741,
                        "name": "Etzling",
                        "latitude": "49.17943000",
                        "longitude": "6.95864000"
                    },
                    {
                        "id": 41743,
                        "name": "Eulmont",
                        "latitude": "48.75026000",
                        "longitude": "6.22731000"
                    },
                    {
                        "id": 41745,
                        "name": "Eurville-Bienville",
                        "latitude": "48.58333000",
                        "longitude": "5.03333000"
                    },
                    {
                        "id": 41746,
                        "name": "Euville",
                        "latitude": "48.75030000",
                        "longitude": "5.62603000"
                    },
                    {
                        "id": 41763,
                        "name": "Fagnières",
                        "latitude": "48.96385000",
                        "longitude": "4.31692000"
                    },
                    {
                        "id": 41764,
                        "name": "Fains-Véel",
                        "latitude": "48.78333000",
                        "longitude": "5.13333000"
                    },
                    {
                        "id": 41766,
                        "name": "Falck",
                        "latitude": "49.22695000",
                        "longitude": "6.63373000"
                    },
                    {
                        "id": 41770,
                        "name": "Fameck",
                        "latitude": "49.29895000",
                        "longitude": "6.10915000"
                    },
                    {
                        "id": 41777,
                        "name": "Farébersviller",
                        "latitude": "49.11898000",
                        "longitude": "6.86914000"
                    },
                    {
                        "id": 41776,
                        "name": "Farschviller",
                        "latitude": "49.09406000",
                        "longitude": "6.89517000"
                    },
                    {
                        "id": 41778,
                        "name": "Faulquemont",
                        "latitude": "49.04910000",
                        "longitude": "6.59732000"
                    },
                    {
                        "id": 41779,
                        "name": "Faulx",
                        "latitude": "48.79266000",
                        "longitude": "6.19554000"
                    },
                    {
                        "id": 41790,
                        "name": "Fayl-Billot",
                        "latitude": "47.78199000",
                        "longitude": "5.59917000"
                    },
                    {
                        "id": 41791,
                        "name": "Fegersheim",
                        "latitude": "48.49016000",
                        "longitude": "7.68107000"
                    },
                    {
                        "id": 41795,
                        "name": "Fellering",
                        "latitude": "47.89659000",
                        "longitude": "6.98552000"
                    },
                    {
                        "id": 41997,
                        "name": "Fère-Champenoise",
                        "latitude": "48.75431000",
                        "longitude": "3.99069000"
                    },
                    {
                        "id": 41804,
                        "name": "Ferrette",
                        "latitude": "47.49436000",
                        "longitude": "7.31372000"
                    },
                    {
                        "id": 41808,
                        "name": "Fessenheim",
                        "latitude": "47.91565000",
                        "longitude": "7.53499000"
                    },
                    {
                        "id": 41825,
                        "name": "Fismes",
                        "latitude": "49.30773000",
                        "longitude": "3.68607000"
                    },
                    {
                        "id": 41831,
                        "name": "Flavigny-sur-Moselle",
                        "latitude": "48.56567000",
                        "longitude": "6.18878000"
                    },
                    {
                        "id": 41834,
                        "name": "Flaxlanden",
                        "latitude": "47.69547000",
                        "longitude": "7.31484000"
                    },
                    {
                        "id": 41846,
                        "name": "Fleury",
                        "latitude": "49.04181000",
                        "longitude": "6.19329000"
                    },
                    {
                        "id": 41865,
                        "name": "Fléville-devant-Nancy",
                        "latitude": "48.62495000",
                        "longitude": "6.20325000"
                    },
                    {
                        "id": 41856,
                        "name": "Flize",
                        "latitude": "49.69875000",
                        "longitude": "4.77171000"
                    },
                    {
                        "id": 41858,
                        "name": "Floing",
                        "latitude": "49.72216000",
                        "longitude": "4.92947000"
                    },
                    {
                        "id": 41861,
                        "name": "Florange",
                        "latitude": "49.32373000",
                        "longitude": "6.12120000"
                    },
                    {
                        "id": 41869,
                        "name": "Folkling",
                        "latitude": "49.14756000",
                        "longitude": "6.89482000"
                    },
                    {
                        "id": 41871,
                        "name": "Folschviller",
                        "latitude": "49.07732000",
                        "longitude": "6.68358000"
                    },
                    {
                        "id": 41906,
                        "name": "Fontoy",
                        "latitude": "49.35597000",
                        "longitude": "5.99250000"
                    },
                    {
                        "id": 41908,
                        "name": "Forbach",
                        "latitude": "49.18848000",
                        "longitude": "6.89255000"
                    },
                    {
                        "id": 41918,
                        "name": "Fortschwihr",
                        "latitude": "48.08825000",
                        "longitude": "7.45050000"
                    },
                    {
                        "id": 41924,
                        "name": "Foug",
                        "latitude": "48.68385000",
                        "longitude": "5.78735000"
                    },
                    {
                        "id": 41945,
                        "name": "Fraize",
                        "latitude": "48.18660000",
                        "longitude": "6.99787000"
                    },
                    {
                        "id": 41986,
                        "name": "Fréland",
                        "latitude": "48.17215000",
                        "longitude": "7.19167000"
                    },
                    {
                        "id": 41961,
                        "name": "Fresse-sur-Moselle",
                        "latitude": "47.87589000",
                        "longitude": "6.78589000"
                    },
                    {
                        "id": 41964,
                        "name": "Freyming-Merlebach",
                        "latitude": "49.15000000",
                        "longitude": "6.78333000"
                    },
                    {
                        "id": 41965,
                        "name": "Frignicourt",
                        "latitude": "48.69966000",
                        "longitude": "4.59153000"
                    },
                    {
                        "id": 41970,
                        "name": "Fromelennes",
                        "latitude": "50.12333000",
                        "longitude": "4.85952000"
                    },
                    {
                        "id": 41971,
                        "name": "Froncles",
                        "latitude": "48.29756000",
                        "longitude": "5.14586000"
                    },
                    {
                        "id": 41980,
                        "name": "Frouard",
                        "latitude": "48.75994000",
                        "longitude": "6.13036000"
                    },
                    {
                        "id": 41991,
                        "name": "Fumay",
                        "latitude": "49.99132000",
                        "longitude": "4.70771000"
                    },
                    {
                        "id": 41993,
                        "name": "Furdenheim",
                        "latitude": "48.61129000",
                        "longitude": "7.56100000"
                    },
                    {
                        "id": 42026,
                        "name": "Gambsheim",
                        "latitude": "48.69209000",
                        "longitude": "7.88286000"
                    },
                    {
                        "id": 42028,
                        "name": "Gandrange",
                        "latitude": "49.27133000",
                        "longitude": "6.12536000"
                    },
                    {
                        "id": 42058,
                        "name": "Geispolsheim",
                        "latitude": "48.51603000",
                        "longitude": "7.64825000"
                    },
                    {
                        "id": 42299,
                        "name": "Gérardmer",
                        "latitude": "48.07346000",
                        "longitude": "6.87787000"
                    },
                    {
                        "id": 42072,
                        "name": "Gerbéviller",
                        "latitude": "48.49618000",
                        "longitude": "6.51075000"
                    },
                    {
                        "id": 42076,
                        "name": "Gerstheim",
                        "latitude": "48.38215000",
                        "longitude": "7.70395000"
                    },
                    {
                        "id": 42078,
                        "name": "Gespunsart",
                        "latitude": "49.82143000",
                        "longitude": "4.82926000"
                    },
                    {
                        "id": 42081,
                        "name": "Geudertheim",
                        "latitude": "48.72415000",
                        "longitude": "7.75188000"
                    },
                    {
                        "id": 42100,
                        "name": "Giraumont",
                        "latitude": "49.17076000",
                        "longitude": "5.91448000"
                    },
                    {
                        "id": 42107,
                        "name": "Givet",
                        "latitude": "50.13796000",
                        "longitude": "4.82545000"
                    },
                    {
                        "id": 42302,
                        "name": "Gœrsdorf",
                        "latitude": "48.95000000",
                        "longitude": "7.76667000"
                    },
                    {
                        "id": 42117,
                        "name": "Goetzenbruck",
                        "latitude": "48.97778000",
                        "longitude": "7.37960000"
                    },
                    {
                        "id": 42119,
                        "name": "Golbey",
                        "latitude": "48.19764000",
                        "longitude": "6.43966000"
                    },
                    {
                        "id": 42126,
                        "name": "Gondrecourt-le-Château",
                        "latitude": "48.51366000",
                        "longitude": "5.51058000"
                    },
                    {
                        "id": 42127,
                        "name": "Gondreville",
                        "latitude": "48.69373000",
                        "longitude": "5.96467000"
                    },
                    {
                        "id": 42135,
                        "name": "Gorcy",
                        "latitude": "49.53487000",
                        "longitude": "5.68487000"
                    },
                    {
                        "id": 42139,
                        "name": "Gorze",
                        "latitude": "49.05236000",
                        "longitude": "6.00072000"
                    },
                    {
                        "id": 42183,
                        "name": "Granges-sur-Vologne",
                        "latitude": "48.14517000",
                        "longitude": "6.79095000"
                    },
                    {
                        "id": 42199,
                        "name": "Grendelbruch",
                        "latitude": "48.49272000",
                        "longitude": "7.32239000"
                    },
                    {
                        "id": 42201,
                        "name": "Gresswiller",
                        "latitude": "48.53542000",
                        "longitude": "7.43251000"
                    },
                    {
                        "id": 42205,
                        "name": "Gries",
                        "latitude": "48.75370000",
                        "longitude": "7.81403000"
                    },
                    {
                        "id": 42206,
                        "name": "Griesheim-près-Molsheim",
                        "latitude": "48.50296000",
                        "longitude": "7.53027000"
                    },
                    {
                        "id": 42207,
                        "name": "Griesheim-sur-Souffel",
                        "latitude": "48.63591000",
                        "longitude": "7.66923000"
                    },
                    {
                        "id": 42223,
                        "name": "Gros-Réderching",
                        "latitude": "49.06835000",
                        "longitude": "7.21914000"
                    },
                    {
                        "id": 42224,
                        "name": "Grosbliederstroff",
                        "latitude": "49.15808000",
                        "longitude": "7.02413000"
                    },
                    {
                        "id": 42239,
                        "name": "Guebwiller",
                        "latitude": "47.91667000",
                        "longitude": "7.20000000"
                    },
                    {
                        "id": 42279,
                        "name": "Guémar",
                        "latitude": "48.18869000",
                        "longitude": "7.39706000"
                    },
                    {
                        "id": 42282,
                        "name": "Guénange",
                        "latitude": "49.29945000",
                        "longitude": "6.20535000"
                    },
                    {
                        "id": 42249,
                        "name": "Gueux",
                        "latitude": "49.25048000",
                        "longitude": "3.91024000"
                    },
                    {
                        "id": 42250,
                        "name": "Guewenheim",
                        "latitude": "47.75283000",
                        "longitude": "7.09253000"
                    },
                    {
                        "id": 42273,
                        "name": "Gumbrechtshoffen",
                        "latitude": "48.90580000",
                        "longitude": "7.62915000"
                    },
                    {
                        "id": 42274,
                        "name": "Gundershoffen",
                        "latitude": "48.90648000",
                        "longitude": "7.66096000"
                    },
                    {
                        "id": 42305,
                        "name": "Habsheim",
                        "latitude": "47.72975000",
                        "longitude": "7.41801000"
                    },
                    {
                        "id": 42306,
                        "name": "Hadol",
                        "latitude": "48.08983000",
                        "longitude": "6.47662000"
                    },
                    {
                        "id": 42307,
                        "name": "Hagenthal-le-Bas",
                        "latitude": "47.52497000",
                        "longitude": "7.47783000"
                    },
                    {
                        "id": 42309,
                        "name": "Hagondange",
                        "latitude": "49.24879000",
                        "longitude": "6.16374000"
                    },
                    {
                        "id": 42310,
                        "name": "Haguenau",
                        "latitude": "48.81557000",
                        "longitude": "7.79051000"
                    },
                    {
                        "id": 42318,
                        "name": "Ham-sous-Varsberg",
                        "latitude": "49.18014000",
                        "longitude": "6.64702000"
                    },
                    {
                        "id": 42319,
                        "name": "Hambach",
                        "latitude": "49.05942000",
                        "longitude": "7.03530000"
                    },
                    {
                        "id": 42323,
                        "name": "Hangenbieten",
                        "latitude": "48.55985000",
                        "longitude": "7.61464000"
                    },
                    {
                        "id": 42329,
                        "name": "Hargarten-aux-Mines",
                        "latitude": "49.22436000",
                        "longitude": "6.61459000"
                    },
                    {
                        "id": 42335,
                        "name": "Hatten",
                        "latitude": "48.90123000",
                        "longitude": "7.97968000"
                    },
                    {
                        "id": 42337,
                        "name": "Haucourt",
                        "latitude": "49.48982000",
                        "longitude": "5.80361000"
                    },
                    {
                        "id": 42340,
                        "name": "Haut-Rhin",
                        "latitude": "47.87603000",
                        "longitude": "7.27190000"
                    },
                    {
                        "id": 42344,
                        "name": "Haute-Marne",
                        "latitude": "48.12019000",
                        "longitude": "5.24038000"
                    },
                    {
                        "id": 42360,
                        "name": "Hayange",
                        "latitude": "49.32881000",
                        "longitude": "6.06278000"
                    },
                    {
                        "id": 42361,
                        "name": "Haybes",
                        "latitude": "50.00458000",
                        "longitude": "4.70496000"
                    },
                    {
                        "id": 42450,
                        "name": "Hégenheim",
                        "latitude": "47.56299000",
                        "longitude": "7.52401000"
                    },
                    {
                        "id": 42363,
                        "name": "Heillecourt",
                        "latitude": "48.65049000",
                        "longitude": "6.19512000"
                    },
                    {
                        "id": 42364,
                        "name": "Heimsbrunn",
                        "latitude": "47.72669000",
                        "longitude": "7.22699000"
                    },
                    {
                        "id": 42374,
                        "name": "Herbitzheim",
                        "latitude": "49.01541000",
                        "longitude": "7.08188000"
                    },
                    {
                        "id": 42381,
                        "name": "Hermonville",
                        "latitude": "49.33655000",
                        "longitude": "3.91011000"
                    },
                    {
                        "id": 42382,
                        "name": "Herrlisheim",
                        "latitude": "48.73049000",
                        "longitude": "7.90535000"
                    },
                    {
                        "id": 42383,
                        "name": "Herrlisheim-près-Colmar",
                        "latitude": "48.01835000",
                        "longitude": "7.32668000"
                    },
                    {
                        "id": 42385,
                        "name": "Herserange",
                        "latitude": "49.52047000",
                        "longitude": "5.78994000"
                    },
                    {
                        "id": 42465,
                        "name": "Hésingue",
                        "latitude": "47.57818000",
                        "longitude": "7.51911000"
                    },
                    {
                        "id": 42389,
                        "name": "Hettange-Grande",
                        "latitude": "49.40650000",
                        "longitude": "6.15233000"
                    },
                    {
                        "id": 42396,
                        "name": "Hilsenheim",
                        "latitude": "48.28761000",
                        "longitude": "7.56348000"
                    },
                    {
                        "id": 42397,
                        "name": "Hindisheim",
                        "latitude": "48.46837000",
                        "longitude": "7.63859000"
                    },
                    {
                        "id": 42401,
                        "name": "Hirsingue",
                        "latitude": "47.58768000",
                        "longitude": "7.25299000"
                    },
                    {
                        "id": 42403,
                        "name": "Hirtzbach",
                        "latitude": "47.59839000",
                        "longitude": "7.22222000"
                    },
                    {
                        "id": 42404,
                        "name": "Hirtzfelden",
                        "latitude": "47.91131000",
                        "longitude": "7.44610000"
                    },
                    {
                        "id": 42406,
                        "name": "Hochfelden",
                        "latitude": "48.75738000",
                        "longitude": "7.56769000"
                    },
                    {
                        "id": 42407,
                        "name": "Hochstatt",
                        "latitude": "47.70389000",
                        "longitude": "7.27650000"
                    },
                    {
                        "id": 42467,
                        "name": "Hœnheim",
                        "latitude": "48.62224000",
                        "longitude": "7.75549000"
                    },
                    {
                        "id": 42468,
                        "name": "Hœrdt",
                        "latitude": "48.70000000",
                        "longitude": "7.78333000"
                    },
                    {
                        "id": 42409,
                        "name": "Holtzheim",
                        "latitude": "48.55820000",
                        "longitude": "7.64434000"
                    },
                    {
                        "id": 42410,
                        "name": "Holtzwihr",
                        "latitude": "48.11288000",
                        "longitude": "7.42080000"
                    },
                    {
                        "id": 42411,
                        "name": "Holving",
                        "latitude": "49.01162000",
                        "longitude": "6.96556000"
                    },
                    {
                        "id": 42414,
                        "name": "Hombourg-Haut",
                        "latitude": "49.12819000",
                        "longitude": "6.77066000"
                    },
                    {
                        "id": 42415,
                        "name": "Homécourt",
                        "latitude": "49.22071000",
                        "longitude": "5.99242000"
                    },
                    {
                        "id": 42418,
                        "name": "Horbourg-Wihr",
                        "latitude": "48.08106000",
                        "longitude": "7.39380000"
                    },
                    {
                        "id": 42425,
                        "name": "Houdemont",
                        "latitude": "48.64407000",
                        "longitude": "6.17579000"
                    },
                    {
                        "id": 42433,
                        "name": "Houssen",
                        "latitude": "48.12579000",
                        "longitude": "7.37735000"
                    },
                    {
                        "id": 42441,
                        "name": "Hundling",
                        "latitude": "49.10860000",
                        "longitude": "6.97989000"
                    },
                    {
                        "id": 42442,
                        "name": "Huningue",
                        "latitude": "47.60477000",
                        "longitude": "7.57782000"
                    },
                    {
                        "id": 42445,
                        "name": "Husseren-Wesserling",
                        "latitude": "47.88351000",
                        "longitude": "6.98994000"
                    },
                    {
                        "id": 42446,
                        "name": "Hussigny-Godbrange",
                        "latitude": "49.49437000",
                        "longitude": "5.86677000"
                    },
                    {
                        "id": 42447,
                        "name": "Huttenheim",
                        "latitude": "48.35864000",
                        "longitude": "7.57833000"
                    },
                    {
                        "id": 42473,
                        "name": "Igney",
                        "latitude": "48.27358000",
                        "longitude": "6.39664000"
                    },
                    {
                        "id": 42477,
                        "name": "Illange",
                        "latitude": "49.32617000",
                        "longitude": "6.17953000"
                    },
                    {
                        "id": 42480,
                        "name": "Illfurth",
                        "latitude": "47.67410000",
                        "longitude": "7.26607000"
                    },
                    {
                        "id": 42482,
                        "name": "Illkirch-Graffenstaden",
                        "latitude": "48.52894000",
                        "longitude": "7.71523000"
                    },
                    {
                        "id": 42483,
                        "name": "Illzach",
                        "latitude": "47.77420000",
                        "longitude": "7.35175000"
                    },
                    {
                        "id": 42487,
                        "name": "Ingersheim",
                        "latitude": "48.09803000",
                        "longitude": "7.30308000"
                    },
                    {
                        "id": 42491,
                        "name": "Ingwiller",
                        "latitude": "48.87284000",
                        "longitude": "7.47980000"
                    },
                    {
                        "id": 42492,
                        "name": "Innenheim",
                        "latitude": "48.49659000",
                        "longitude": "7.57439000"
                    },
                    {
                        "id": 42494,
                        "name": "Irmstett",
                        "latitude": "48.58801000",
                        "longitude": "7.47837000"
                    },
                    {
                        "id": 42504,
                        "name": "Issenheim",
                        "latitude": "47.90357000",
                        "longitude": "7.25235000"
                    },
                    {
                        "id": 42513,
                        "name": "Ittenheim",
                        "latitude": "48.60508000",
                        "longitude": "7.59372000"
                    },
                    {
                        "id": 42534,
                        "name": "Jarny",
                        "latitude": "49.15873000",
                        "longitude": "5.87640000"
                    },
                    {
                        "id": 42536,
                        "name": "Jarville-la-Malgrange",
                        "latitude": "48.66697000",
                        "longitude": "6.20269000"
                    },
                    {
                        "id": 42546,
                        "name": "Jeanménil",
                        "latitude": "48.33560000",
                        "longitude": "6.68769000"
                    },
                    {
                        "id": 42547,
                        "name": "Jebsheim",
                        "latitude": "48.12375000",
                        "longitude": "7.47578000"
                    },
                    {
                        "id": 42603,
                        "name": "Jœuf",
                        "latitude": "49.23333000",
                        "longitude": "6.01667000"
                    },
                    {
                        "id": 42553,
                        "name": "Joinville",
                        "latitude": "48.44363000",
                        "longitude": "5.14144000"
                    },
                    {
                        "id": 42557,
                        "name": "Jonchery-sur-Vesle",
                        "latitude": "49.28952000",
                        "longitude": "3.81345000"
                    },
                    {
                        "id": 42567,
                        "name": "Joudreville",
                        "latitude": "49.29145000",
                        "longitude": "5.77903000"
                    },
                    {
                        "id": 42573,
                        "name": "Jouy-aux-Arches",
                        "latitude": "49.06148000",
                        "longitude": "6.07925000"
                    },
                    {
                        "id": 42604,
                        "name": "Kaltenhouse",
                        "latitude": "48.79110000",
                        "longitude": "7.83217000"
                    },
                    {
                        "id": 42605,
                        "name": "Kaysersberg",
                        "latitude": "48.13803000",
                        "longitude": "7.26385000"
                    },
                    {
                        "id": 42623,
                        "name": "Kédange-sur-Canner",
                        "latitude": "49.30887000",
                        "longitude": "6.33805000"
                    },
                    {
                        "id": 42606,
                        "name": "Kembs",
                        "latitude": "47.68948000",
                        "longitude": "7.50323000"
                    },
                    {
                        "id": 42607,
                        "name": "Kerbach",
                        "latitude": "49.16682000",
                        "longitude": "6.96549000"
                    },
                    {
                        "id": 42611,
                        "name": "Kertzfeld",
                        "latitude": "48.37990000",
                        "longitude": "7.56816000"
                    },
                    {
                        "id": 42613,
                        "name": "Keskastel",
                        "latitude": "48.97132000",
                        "longitude": "7.04412000"
                    },
                    {
                        "id": 42615,
                        "name": "Kilstett",
                        "latitude": "48.67600000",
                        "longitude": "7.85471000"
                    },
                    {
                        "id": 42616,
                        "name": "Kingersheim",
                        "latitude": "47.79100000",
                        "longitude": "7.32647000"
                    },
                    {
                        "id": 42617,
                        "name": "Kintzheim",
                        "latitude": "48.25480000",
                        "longitude": "7.39491000"
                    },
                    {
                        "id": 42618,
                        "name": "Knutange",
                        "latitude": "49.33895000",
                        "longitude": "6.03898000"
                    },
                    {
                        "id": 42624,
                        "name": "Kœnigsmacker",
                        "latitude": "49.40000000",
                        "longitude": "6.28333000"
                    },
                    {
                        "id": 42619,
                        "name": "Krautergersheim",
                        "latitude": "48.47634000",
                        "longitude": "7.56718000"
                    },
                    {
                        "id": 42620,
                        "name": "Kruth",
                        "latitude": "47.93101000",
                        "longitude": "6.96467000"
                    },
                    {
                        "id": 42621,
                        "name": "Kunheim",
                        "latitude": "48.07657000",
                        "longitude": "7.53489000"
                    },
                    {
                        "id": 42622,
                        "name": "Kuntzig",
                        "latitude": "49.34731000",
                        "longitude": "6.23710000"
                    },
                    {
                        "id": 42653,
                        "name": "La Bresse",
                        "latitude": "47.99974000",
                        "longitude": "6.86499000"
                    },
                    {
                        "id": 42655,
                        "name": "La Broque",
                        "latitude": "48.47298000",
                        "longitude": "7.21639000"
                    },
                    {
                        "id": 42687,
                        "name": "La Chapelle-Saint-Luc",
                        "latitude": "48.31734000",
                        "longitude": "4.03988000"
                    },
                    {
                        "id": 42756,
                        "name": "La Francheville",
                        "latitude": "49.72923000",
                        "longitude": "4.71273000"
                    },
                    {
                        "id": 42849,
                        "name": "La Rivière-de-Corps",
                        "latitude": "48.28840000",
                        "longitude": "4.01947000"
                    },
                    {
                        "id": 42920,
                        "name": "La Wantzenau",
                        "latitude": "48.65786000",
                        "longitude": "7.83068000"
                    },
                    {
                        "id": 42921,
                        "name": "Labaroche",
                        "latitude": "48.11076000",
                        "longitude": "7.19244000"
                    },
                    {
                        "id": 42938,
                        "name": "Labry",
                        "latitude": "49.17289000",
                        "longitude": "5.88087000"
                    },
                    {
                        "id": 42981,
                        "name": "Lamarche",
                        "latitude": "48.06967000",
                        "longitude": "5.78141000"
                    },
                    {
                        "id": 42995,
                        "name": "Lampertheim",
                        "latitude": "48.65149000",
                        "longitude": "7.69876000"
                    },
                    {
                        "id": 43010,
                        "name": "Landres",
                        "latitude": "49.32044000",
                        "longitude": "5.80060000"
                    },
                    {
                        "id": 43012,
                        "name": "Landser",
                        "latitude": "47.68501000",
                        "longitude": "7.38998000"
                    },
                    {
                        "id": 43020,
                        "name": "Laneuveville-devant-Nancy",
                        "latitude": "48.65659000",
                        "longitude": "6.22658000"
                    },
                    {
                        "id": 43030,
                        "name": "Langres",
                        "latitude": "47.86263000",
                        "longitude": "5.33308000"
                    },
                    {
                        "id": 43062,
                        "name": "Lapoutroie",
                        "latitude": "48.15398000",
                        "longitude": "7.16714000"
                    },
                    {
                        "id": 43101,
                        "name": "Lautenbach",
                        "latitude": "47.94055000",
                        "longitude": "7.15768000"
                    },
                    {
                        "id": 43102,
                        "name": "Lautenbachzell",
                        "latitude": "47.94124000",
                        "longitude": "7.14643000"
                    },
                    {
                        "id": 43103,
                        "name": "Lauterbourg",
                        "latitude": "48.97515000",
                        "longitude": "8.17846000"
                    },
                    {
                        "id": 43121,
                        "name": "Laxou",
                        "latitude": "48.68372000",
                        "longitude": "6.14929000"
                    },
                    {
                        "id": 43122,
                        "name": "Lay-Saint-Christophe",
                        "latitude": "48.74926000",
                        "longitude": "6.19735000"
                    },
                    {
                        "id": 43124,
                        "name": "Le Ban Saint-Martin",
                        "latitude": "49.12250000",
                        "longitude": "6.15111000"
                    },
                    {
                        "id": 43240,
                        "name": "Le Ménil",
                        "latitude": "47.90477000",
                        "longitude": "6.78209000"
                    },
                    {
                        "id": 43231,
                        "name": "Le Mesnil-sur-Oger",
                        "latitude": "48.94708000",
                        "longitude": "4.02263000"
                    },
                    {
                        "id": 43303,
                        "name": "Le Syndicat",
                        "latitude": "48.01733000",
                        "longitude": "6.68436000"
                    },
                    {
                        "id": 43313,
                        "name": "Le Thillot",
                        "latitude": "47.87941000",
                        "longitude": "6.76279000"
                    },
                    {
                        "id": 43315,
                        "name": "Le Tholy",
                        "latitude": "48.08229000",
                        "longitude": "6.74351000"
                    },
                    {
                        "id": 43345,
                        "name": "Lembach",
                        "latitude": "49.00362000",
                        "longitude": "7.78986000"
                    },
                    {
                        "id": 43346,
                        "name": "Lemberg",
                        "latitude": "49.00199000",
                        "longitude": "7.37889000"
                    },
                    {
                        "id": 43689,
                        "name": "Lérouville",
                        "latitude": "48.79261000",
                        "longitude": "5.54063000"
                    },
                    {
                        "id": 43388,
                        "name": "Les Forges",
                        "latitude": "48.17747000",
                        "longitude": "6.38846000"
                    },
                    {
                        "id": 43394,
                        "name": "Les Hautes-Rivières",
                        "latitude": "49.88595000",
                        "longitude": "4.84186000"
                    },
                    {
                        "id": 43415,
                        "name": "Les Noës-près-Troyes",
                        "latitude": "48.30358000",
                        "longitude": "4.04552000"
                    },
                    {
                        "id": 43423,
                        "name": "Les Riceys",
                        "latitude": "47.99390000",
                        "longitude": "4.36986000"
                    },
                    {
                        "id": 43455,
                        "name": "Lexy",
                        "latitude": "49.49996000",
                        "longitude": "5.72985000"
                    },
                    {
                        "id": 43457,
                        "name": "Leymen",
                        "latitude": "47.49632000",
                        "longitude": "7.48517000"
                    },
                    {
                        "id": 43524,
                        "name": "Lièpvre",
                        "latitude": "48.27166000",
                        "longitude": "7.28229000"
                    },
                    {
                        "id": 43473,
                        "name": "Liffol-le-Grand",
                        "latitude": "48.31771000",
                        "longitude": "5.58125000"
                    },
                    {
                        "id": 43477,
                        "name": "Ligny-en-Barrois",
                        "latitude": "48.68861000",
                        "longitude": "5.32543000"
                    },
                    {
                        "id": 43501,
                        "name": "Lingolsheim",
                        "latitude": "48.55752000",
                        "longitude": "7.68253000"
                    },
                    {
                        "id": 43506,
                        "name": "Lipsheim",
                        "latitude": "48.49164000",
                        "longitude": "7.66751000"
                    },
                    {
                        "id": 43515,
                        "name": "Liverdun",
                        "latitude": "48.74973000",
                        "longitude": "6.06372000"
                    },
                    {
                        "id": 43546,
                        "name": "Loivre",
                        "latitude": "49.34619000",
                        "longitude": "3.97978000"
                    },
                    {
                        "id": 43556,
                        "name": "Longeville-en-Barrois",
                        "latitude": "48.74242000",
                        "longitude": "5.20905000"
                    },
                    {
                        "id": 43557,
                        "name": "Longeville-lès-Metz",
                        "latitude": "49.11403000",
                        "longitude": "6.13612000"
                    },
                    {
                        "id": 43558,
                        "name": "Longeville-lès-Saint-Avold",
                        "latitude": "49.11689000",
                        "longitude": "6.64327000"
                    },
                    {
                        "id": 43562,
                        "name": "Longlaville",
                        "latitude": "49.53443000",
                        "longitude": "5.80048000"
                    },
                    {
                        "id": 43573,
                        "name": "Longuyon",
                        "latitude": "49.44181000",
                        "longitude": "5.60508000"
                    },
                    {
                        "id": 43575,
                        "name": "Longwy",
                        "latitude": "49.52170000",
                        "longitude": "5.76192000"
                    },
                    {
                        "id": 43593,
                        "name": "Lorquin",
                        "latitude": "48.67102000",
                        "longitude": "6.99915000"
                    },
                    {
                        "id": 43641,
                        "name": "Ludres",
                        "latitude": "48.62032000",
                        "longitude": "6.16747000"
                    },
                    {
                        "id": 43648,
                        "name": "Lumes",
                        "latitude": "49.73461000",
                        "longitude": "4.78616000"
                    },
                    {
                        "id": 43656,
                        "name": "Lunéville",
                        "latitude": "48.59273000",
                        "longitude": "6.49383000"
                    },
                    {
                        "id": 43663,
                        "name": "Lusigny-sur-Barse",
                        "latitude": "48.25451000",
                        "longitude": "4.26891000"
                    },
                    {
                        "id": 43666,
                        "name": "Lutterbach",
                        "latitude": "47.75976000",
                        "longitude": "7.28032000"
                    },
                    {
                        "id": 43667,
                        "name": "Lutzelhouse",
                        "latitude": "48.52114000",
                        "longitude": "7.28700000"
                    },
                    {
                        "id": 43713,
                        "name": "Macheren",
                        "latitude": "49.10019000",
                        "longitude": "6.77763000"
                    },
                    {
                        "id": 43718,
                        "name": "Magenta",
                        "latitude": "49.04899000",
                        "longitude": "3.96882000"
                    },
                    {
                        "id": 43731,
                        "name": "Maidières",
                        "latitude": "48.89961000",
                        "longitude": "6.04005000"
                    },
                    {
                        "id": 43736,
                        "name": "Mailly-le-Camp",
                        "latitude": "48.66526000",
                        "longitude": "4.21303000"
                    },
                    {
                        "id": 43746,
                        "name": "Maizières-la-Grande-Paroisse",
                        "latitude": "48.51012000",
                        "longitude": "3.78573000"
                    },
                    {
                        "id": 43747,
                        "name": "Maizières-lès-Metz",
                        "latitude": "49.21335000",
                        "longitude": "6.15956000"
                    },
                    {
                        "id": 43767,
                        "name": "Malzéville",
                        "latitude": "48.71235000",
                        "longitude": "6.18468000"
                    },
                    {
                        "id": 43772,
                        "name": "Mancieulles",
                        "latitude": "49.28231000",
                        "longitude": "5.89612000"
                    },
                    {
                        "id": 43779,
                        "name": "Manom",
                        "latitude": "49.37092000",
                        "longitude": "6.18345000"
                    },
                    {
                        "id": 43790,
                        "name": "Marange-Silvange",
                        "latitude": "49.20822000",
                        "longitude": "6.10426000"
                    },
                    {
                        "id": 43793,
                        "name": "Marbache",
                        "latitude": "48.79867000",
                        "longitude": "6.10600000"
                    },
                    {
                        "id": 43810,
                        "name": "Marckolsheim",
                        "latitude": "48.16471000",
                        "longitude": "7.54400000"
                    },
                    {
                        "id": 43817,
                        "name": "Mardeuil",
                        "latitude": "49.05393000",
                        "longitude": "3.93000000"
                    },
                    {
                        "id": 43826,
                        "name": "Mareuil-le-Port",
                        "latitude": "49.08179000",
                        "longitude": "3.76011000"
                    },
                    {
                        "id": 43828,
                        "name": "Mareuil-sur-Ay",
                        "latitude": "49.04581000",
                        "longitude": "4.03587000"
                    },
                    {
                        "id": 43842,
                        "name": "Marigny-le-Châtel",
                        "latitude": "48.40291000",
                        "longitude": "3.73588000"
                    },
                    {
                        "id": 43849,
                        "name": "Marlenheim",
                        "latitude": "48.62134000",
                        "longitude": "7.49096000"
                    },
                    {
                        "id": 43854,
                        "name": "Marly",
                        "latitude": "49.06382000",
                        "longitude": "6.15427000"
                    },
                    {
                        "id": 43860,
                        "name": "Marmoutier",
                        "latitude": "48.69005000",
                        "longitude": "7.38195000"
                    },
                    {
                        "id": 43863,
                        "name": "Marne",
                        "latitude": "48.99116000",
                        "longitude": "4.25966000"
                    },
                    {
                        "id": 43928,
                        "name": "Masevaux",
                        "latitude": "47.77671000",
                        "longitude": "6.99683000"
                    },
                    {
                        "id": 43942,
                        "name": "Matzenheim",
                        "latitude": "48.39450000",
                        "longitude": "7.62185000"
                    },
                    {
                        "id": 43967,
                        "name": "Maxéville",
                        "latitude": "48.71324000",
                        "longitude": "6.16658000"
                    },
                    {
                        "id": 44456,
                        "name": "Mécleuves",
                        "latitude": "49.04429000",
                        "longitude": "6.27051000"
                    },
                    {
                        "id": 43990,
                        "name": "Meistratzheim",
                        "latitude": "48.44853000",
                        "longitude": "7.54350000"
                    },
                    {
                        "id": 44014,
                        "name": "Mercy-le-Bas",
                        "latitude": "49.38935000",
                        "longitude": "5.75599000"
                    },
                    {
                        "id": 44481,
                        "name": "Méréville",
                        "latitude": "48.59113000",
                        "longitude": "6.15106000"
                    },
                    {
                        "id": 44019,
                        "name": "Merten",
                        "latitude": "49.24903000",
                        "longitude": "6.66465000"
                    },
                    {
                        "id": 44020,
                        "name": "Mertzwiller",
                        "latitude": "48.86558000",
                        "longitude": "7.68136000"
                    },
                    {
                        "id": 44026,
                        "name": "Merxheim",
                        "latitude": "47.91128000",
                        "longitude": "7.29492000"
                    },
                    {
                        "id": 44479,
                        "name": "Méry-sur-Seine",
                        "latitude": "48.50937000",
                        "longitude": "3.89129000"
                    },
                    {
                        "id": 44034,
                        "name": "Messein",
                        "latitude": "48.61180000",
                        "longitude": "6.13959000"
                    },
                    {
                        "id": 44041,
                        "name": "Metz",
                        "latitude": "49.11911000",
                        "longitude": "6.17269000"
                    },
                    {
                        "id": 44042,
                        "name": "Metzeral",
                        "latitude": "48.01217000",
                        "longitude": "7.07091000"
                    },
                    {
                        "id": 44043,
                        "name": "Metzervisse",
                        "latitude": "49.31476000",
                        "longitude": "6.28277000"
                    },
                    {
                        "id": 44051,
                        "name": "Meurthe-et-Moselle",
                        "latitude": "48.65082000",
                        "longitude": "6.15660000"
                    },
                    {
                        "id": 44052,
                        "name": "Meuse",
                        "latitude": "48.97176000",
                        "longitude": "5.36371000"
                    },
                    {
                        "id": 44054,
                        "name": "Mexy",
                        "latitude": "49.50072000",
                        "longitude": "5.78078000"
                    },
                    {
                        "id": 44055,
                        "name": "Meyenheim",
                        "latitude": "47.91364000",
                        "longitude": "7.35560000"
                    },
                    {
                        "id": 44094,
                        "name": "Mirecourt",
                        "latitude": "48.30089000",
                        "longitude": "6.13282000"
                    },
                    {
                        "id": 44107,
                        "name": "Mittelhausbergen",
                        "latitude": "48.61436000",
                        "longitude": "7.69009000"
                    },
                    {
                        "id": 44126,
                        "name": "Molsheim",
                        "latitude": "48.54042000",
                        "longitude": "7.49199000"
                    },
                    {
                        "id": 44127,
                        "name": "Mommenheim",
                        "latitude": "48.75782000",
                        "longitude": "7.64494000"
                    },
                    {
                        "id": 44135,
                        "name": "Mondelange",
                        "latitude": "49.26145000",
                        "longitude": "6.16503000"
                    },
                    {
                        "id": 44151,
                        "name": "Monswiller",
                        "latitude": "48.75511000",
                        "longitude": "7.37732000"
                    },
                    {
                        "id": 44157,
                        "name": "Mont-Saint-Martin",
                        "latitude": "49.54363000",
                        "longitude": "5.78337000"
                    },
                    {
                        "id": 44188,
                        "name": "Montauville",
                        "latitude": "48.90111000",
                        "longitude": "6.02359000"
                    },
                    {
                        "id": 44203,
                        "name": "Montbronn",
                        "latitude": "48.99243000",
                        "longitude": "7.31075000"
                    },
                    {
                        "id": 44213,
                        "name": "Montcy-Notre-Dame",
                        "latitude": "49.77507000",
                        "longitude": "4.74245000"
                    },
                    {
                        "id": 44250,
                        "name": "Monthermé",
                        "latitude": "49.88465000",
                        "longitude": "4.73013000"
                    },
                    {
                        "id": 44253,
                        "name": "Montier-en-Der",
                        "latitude": "48.47823000",
                        "longitude": "4.77073000"
                    },
                    {
                        "id": 44262,
                        "name": "Montigny-lès-Metz",
                        "latitude": "49.09560000",
                        "longitude": "6.15271000"
                    },
                    {
                        "id": 44290,
                        "name": "Montmédy",
                        "latitude": "49.52096000",
                        "longitude": "5.36835000"
                    },
                    {
                        "id": 44285,
                        "name": "Montmirail",
                        "latitude": "48.87214000",
                        "longitude": "3.53797000"
                    },
                    {
                        "id": 44294,
                        "name": "Montois-la-Montagne",
                        "latitude": "49.21680000",
                        "longitude": "6.02137000"
                    },
                    {
                        "id": 44337,
                        "name": "Moosch",
                        "latitude": "47.86035000",
                        "longitude": "7.04870000"
                    },
                    {
                        "id": 44352,
                        "name": "Morhange",
                        "latitude": "48.92359000",
                        "longitude": "6.64163000"
                    },
                    {
                        "id": 44366,
                        "name": "Morsbach",
                        "latitude": "49.16806000",
                        "longitude": "6.87190000"
                    },
                    {
                        "id": 44367,
                        "name": "Morschwiller-le-Bas",
                        "latitude": "47.73615000",
                        "longitude": "7.26954000"
                    },
                    {
                        "id": 44380,
                        "name": "Moselle",
                        "latitude": "49.04177000",
                        "longitude": "6.58355000"
                    },
                    {
                        "id": 44396,
                        "name": "Moulins-lès-Metz",
                        "latitude": "49.10434000",
                        "longitude": "6.10832000"
                    },
                    {
                        "id": 44402,
                        "name": "Mourmelon-le-Grand",
                        "latitude": "49.13256000",
                        "longitude": "4.36420000"
                    },
                    {
                        "id": 44412,
                        "name": "Moutiers",
                        "latitude": "49.23302000",
                        "longitude": "5.96553000"
                    },
                    {
                        "id": 44419,
                        "name": "Mouzon",
                        "latitude": "49.60706000",
                        "longitude": "5.07569000"
                    },
                    {
                        "id": 44422,
                        "name": "Moyenmoutier",
                        "latitude": "48.37730000",
                        "longitude": "6.90047000"
                    },
                    {
                        "id": 44423,
                        "name": "Moyeuvre-Grande",
                        "latitude": "49.25294000",
                        "longitude": "6.04467000"
                    },
                    {
                        "id": 44432,
                        "name": "Muizon",
                        "latitude": "49.27499000",
                        "longitude": "3.89083000"
                    },
                    {
                        "id": 44433,
                        "name": "Mulhouse",
                        "latitude": "47.75205000",
                        "longitude": "7.32866000"
                    },
                    {
                        "id": 44435,
                        "name": "Munchhouse",
                        "latitude": "47.86930000",
                        "longitude": "7.45233000"
                    },
                    {
                        "id": 44436,
                        "name": "Mundolsheim",
                        "latitude": "48.64215000",
                        "longitude": "7.71378000"
                    },
                    {
                        "id": 44437,
                        "name": "Munster",
                        "latitude": "48.04048000",
                        "longitude": "7.13933000"
                    },
                    {
                        "id": 44446,
                        "name": "Mussig",
                        "latitude": "48.22993000",
                        "longitude": "7.51963000"
                    },
                    {
                        "id": 44447,
                        "name": "Mussy-sur-Seine",
                        "latitude": "47.97791000",
                        "longitude": "4.49743000"
                    },
                    {
                        "id": 44448,
                        "name": "Muttersholtz",
                        "latitude": "48.26761000",
                        "longitude": "7.53567000"
                    },
                    {
                        "id": 44449,
                        "name": "Mutzig",
                        "latitude": "48.53974000",
                        "longitude": "7.45594000"
                    },
                    {
                        "id": 44501,
                        "name": "Nancy",
                        "latitude": "48.68439000",
                        "longitude": "6.18496000"
                    },
                    {
                        "id": 44538,
                        "name": "Neuf-Brisach",
                        "latitude": "48.01783000",
                        "longitude": "7.52795000"
                    },
                    {
                        "id": 44540,
                        "name": "Neufchâteau",
                        "latitude": "48.35557000",
                        "longitude": "5.69602000"
                    },
                    {
                        "id": 44539,
                        "name": "Neufchef",
                        "latitude": "49.31678000",
                        "longitude": "6.02416000"
                    },
                    {
                        "id": 44543,
                        "name": "Neufgrange",
                        "latitude": "49.07679000",
                        "longitude": "7.06526000"
                    },
                    {
                        "id": 44544,
                        "name": "Neufmanil",
                        "latitude": "49.81096000",
                        "longitude": "4.79673000"
                    },
                    {
                        "id": 44560,
                        "name": "Neuves-Maisons",
                        "latitude": "48.61811000",
                        "longitude": "6.10544000"
                    },
                    {
                        "id": 44582,
                        "name": "Neuwiller-lès-Saverne",
                        "latitude": "48.82506000",
                        "longitude": "7.40513000"
                    },
                    {
                        "id": 44588,
                        "name": "Niderviller",
                        "latitude": "48.71294000",
                        "longitude": "7.10627000"
                    },
                    {
                        "id": 44589,
                        "name": "Niederbronn-les-Bains",
                        "latitude": "48.95165000",
                        "longitude": "7.64271000"
                    },
                    {
                        "id": 44590,
                        "name": "Niederhaslach",
                        "latitude": "48.54264000",
                        "longitude": "7.34282000"
                    },
                    {
                        "id": 44591,
                        "name": "Niederhausbergen",
                        "latitude": "48.62400000",
                        "longitude": "7.70210000"
                    },
                    {
                        "id": 44592,
                        "name": "Niedernai",
                        "latitude": "48.45101000",
                        "longitude": "7.51635000"
                    },
                    {
                        "id": 44593,
                        "name": "Niederschaeffolsheim",
                        "latitude": "48.77241000",
                        "longitude": "7.73862000"
                    },
                    {
                        "id": 44600,
                        "name": "Nilvange",
                        "latitude": "49.34224000",
                        "longitude": "6.04964000"
                    },
                    {
                        "id": 44610,
                        "name": "Nogent-le-Bas",
                        "latitude": "48.01974000",
                        "longitude": "5.33323000"
                    },
                    {
                        "id": 44617,
                        "name": "Nogent-sur-Seine",
                        "latitude": "48.49372000",
                        "longitude": "3.50262000"
                    },
                    {
                        "id": 44635,
                        "name": "Nomeny",
                        "latitude": "48.88977000",
                        "longitude": "6.22635000"
                    },
                    {
                        "id": 44636,
                        "name": "Nomexy",
                        "latitude": "48.30741000",
                        "longitude": "6.38572000"
                    },
                    {
                        "id": 44641,
                        "name": "Nordhouse",
                        "latitude": "48.44833000",
                        "longitude": "7.67326000"
                    },
                    {
                        "id": 44644,
                        "name": "Norroy-lès-Pont-à-Mousson",
                        "latitude": "48.93495000",
                        "longitude": "6.03078000"
                    },
                    {
                        "id": 44661,
                        "name": "Nouvion-sur-Meuse",
                        "latitude": "49.69949000",
                        "longitude": "4.79562000"
                    },
                    {
                        "id": 44664,
                        "name": "Nouzonville",
                        "latitude": "49.81369000",
                        "longitude": "4.74736000"
                    },
                    {
                        "id": 44668,
                        "name": "Novéant-sur-Moselle",
                        "latitude": "49.02366000",
                        "longitude": "6.04795000"
                    },
                    {
                        "id": 44702,
                        "name": "Obenheim",
                        "latitude": "48.35975000",
                        "longitude": "7.69200000"
                    },
                    {
                        "id": 44703,
                        "name": "Oberbronn",
                        "latitude": "48.94020000",
                        "longitude": "7.60700000"
                    },
                    {
                        "id": 44704,
                        "name": "Oberhaslach",
                        "latitude": "48.55039000",
                        "longitude": "7.33213000"
                    },
                    {
                        "id": 44705,
                        "name": "Oberhausbergen",
                        "latitude": "48.60607000",
                        "longitude": "7.68846000"
                    },
                    {
                        "id": 44706,
                        "name": "Oberhergheim",
                        "latitude": "47.96668000",
                        "longitude": "7.39516000"
                    },
                    {
                        "id": 44707,
                        "name": "Oberhoffen-sur-Moder",
                        "latitude": "48.78366000",
                        "longitude": "7.86347000"
                    },
                    {
                        "id": 44708,
                        "name": "Obermodern-Zutzendorf",
                        "latitude": "48.85000000",
                        "longitude": "7.53333000"
                    },
                    {
                        "id": 44709,
                        "name": "Obernai",
                        "latitude": "48.46313000",
                        "longitude": "7.48100000"
                    },
                    {
                        "id": 44710,
                        "name": "Oberschaeffolsheim",
                        "latitude": "48.58643000",
                        "longitude": "7.65018000"
                    },
                    {
                        "id": 44714,
                        "name": "Oderen",
                        "latitude": "47.91036000",
                        "longitude": "6.97463000"
                    },
                    {
                        "id": 44716,
                        "name": "Oermingen",
                        "latitude": "49.00043000",
                        "longitude": "7.12900000"
                    },
                    {
                        "id": 48128,
                        "name": "Œting",
                        "latitude": "49.17291000",
                        "longitude": "6.91472000"
                    },
                    {
                        "id": 44719,
                        "name": "Offenheim",
                        "latitude": "48.63208000",
                        "longitude": "7.61668000"
                    },
                    {
                        "id": 44723,
                        "name": "Ohlungen",
                        "latitude": "48.81352000",
                        "longitude": "7.70225000"
                    },
                    {
                        "id": 44755,
                        "name": "Orbey",
                        "latitude": "48.12651000",
                        "longitude": "7.16455000"
                    },
                    {
                        "id": 44793,
                        "name": "Ostheim",
                        "latitude": "48.15995000",
                        "longitude": "7.36976000"
                    },
                    {
                        "id": 44795,
                        "name": "Ostwald",
                        "latitude": "48.54369000",
                        "longitude": "7.71099000"
                    },
                    {
                        "id": 44797,
                        "name": "Ottange",
                        "latitude": "49.44307000",
                        "longitude": "6.01988000"
                    },
                    {
                        "id": 44798,
                        "name": "Otterswiller",
                        "latitude": "48.72568000",
                        "longitude": "7.37878000"
                    },
                    {
                        "id": 44799,
                        "name": "Ottmarsheim",
                        "latitude": "47.78802000",
                        "longitude": "7.50777000"
                    },
                    {
                        "id": 44800,
                        "name": "Ottrott",
                        "latitude": "48.45642000",
                        "longitude": "7.42556000"
                    },
                    {
                        "id": 44826,
                        "name": "Pagny-sur-Moselle",
                        "latitude": "48.98365000",
                        "longitude": "6.02069000"
                    },
                    {
                        "id": 44852,
                        "name": "Pargny-sur-Saulx",
                        "latitude": "48.76866000",
                        "longitude": "4.83758000"
                    },
                    {
                        "id": 44875,
                        "name": "Payns",
                        "latitude": "48.38255000",
                        "longitude": "3.97755000"
                    },
                    {
                        "id": 44889,
                        "name": "Peltre",
                        "latitude": "49.07480000",
                        "longitude": "6.22721000"
                    },
                    {
                        "id": 44918,
                        "name": "Petit-Réderching",
                        "latitude": "49.05494000",
                        "longitude": "7.30640000"
                    },
                    {
                        "id": 44920,
                        "name": "Petite-Rosselle",
                        "latitude": "49.21177000",
                        "longitude": "6.85607000"
                    },
                    {
                        "id": 44937,
                        "name": "Pfaffenheim",
                        "latitude": "47.98567000",
                        "longitude": "7.28928000"
                    },
                    {
                        "id": 44938,
                        "name": "Pfaffenhoffen",
                        "latitude": "48.84220000",
                        "longitude": "7.60714000"
                    },
                    {
                        "id": 44939,
                        "name": "Pfastatt",
                        "latitude": "47.76915000",
                        "longitude": "7.30295000"
                    },
                    {
                        "id": 44940,
                        "name": "Pfetterhouse",
                        "latitude": "47.50128000",
                        "longitude": "7.16598000"
                    },
                    {
                        "id": 44941,
                        "name": "Pfulgriesheim",
                        "latitude": "48.64403000",
                        "longitude": "7.67086000"
                    },
                    {
                        "id": 44943,
                        "name": "Phalsbourg",
                        "latitude": "48.76771000",
                        "longitude": "7.25820000"
                    },
                    {
                        "id": 44948,
                        "name": "Piennes",
                        "latitude": "49.30964000",
                        "longitude": "5.78009000"
                    },
                    {
                        "id": 44961,
                        "name": "Pierrepont",
                        "latitude": "49.41646000",
                        "longitude": "5.70908000"
                    },
                    {
                        "id": 44964,
                        "name": "Pierrevillers",
                        "latitude": "49.22468000",
                        "longitude": "6.10337000"
                    },
                    {
                        "id": 44965,
                        "name": "Pierry",
                        "latitude": "49.02024000",
                        "longitude": "3.94071000"
                    },
                    {
                        "id": 44971,
                        "name": "Piney",
                        "latitude": "48.36366000",
                        "longitude": "4.33325000"
                    },
                    {
                        "id": 44991,
                        "name": "Plainfaing",
                        "latitude": "48.17284000",
                        "longitude": "7.01539000"
                    },
                    {
                        "id": 45002,
                        "name": "Plappeville",
                        "latitude": "49.13019000",
                        "longitude": "6.12471000"
                    },
                    {
                        "id": 45029,
                        "name": "Plobsheim",
                        "latitude": "48.46979000",
                        "longitude": "7.72442000"
                    },
                    {
                        "id": 45036,
                        "name": "Plombières-les-Bains",
                        "latitude": "47.96337000",
                        "longitude": "6.45758000"
                    },
                    {
                        "id": 45155,
                        "name": "Pompey",
                        "latitude": "48.76876000",
                        "longitude": "6.12639000"
                    },
                    {
                        "id": 45197,
                        "name": "Pont-à-Mousson",
                        "latitude": "48.90702000",
                        "longitude": "6.05635000"
                    },
                    {
                        "id": 45172,
                        "name": "Pont-Saint-Vincent",
                        "latitude": "48.60519000",
                        "longitude": "6.09850000"
                    },
                    {
                        "id": 45173,
                        "name": "Pont-Sainte-Marie",
                        "latitude": "48.31848000",
                        "longitude": "4.09447000"
                    },
                    {
                        "id": 45209,
                        "name": "Pontfaverger-Moronvilliers",
                        "latitude": "49.29702000",
                        "longitude": "4.31657000"
                    },
                    {
                        "id": 45219,
                        "name": "Porcelette",
                        "latitude": "49.15657000",
                        "longitude": "6.65513000"
                    },
                    {
                        "id": 45226,
                        "name": "Port à Binson",
                        "latitude": "49.08202000",
                        "longitude": "3.75989000"
                    },
                    {
                        "id": 45243,
                        "name": "Portieux",
                        "latitude": "48.34466000",
                        "longitude": "6.34465000"
                    },
                    {
                        "id": 45267,
                        "name": "Pouru-Saint-Remy",
                        "latitude": "49.68333000",
                        "longitude": "5.08333000"
                    },
                    {
                        "id": 45269,
                        "name": "Pouxeux",
                        "latitude": "48.10621000",
                        "longitude": "6.57299000"
                    },
                    {
                        "id": 45292,
                        "name": "Prix-lès-Mézières",
                        "latitude": "49.75549000",
                        "longitude": "4.69113000"
                    },
                    {
                        "id": 45327,
                        "name": "Pulligny",
                        "latitude": "48.53893000",
                        "longitude": "6.14426000"
                    },
                    {
                        "id": 45328,
                        "name": "Pulnoy",
                        "latitude": "48.70343000",
                        "longitude": "6.25765000"
                    },
                    {
                        "id": 45329,
                        "name": "Pulversheim",
                        "latitude": "47.83753000",
                        "longitude": "7.30119000"
                    },
                    {
                        "id": 45416,
                        "name": "Raedersheim",
                        "latitude": "47.88895000",
                        "longitude": "7.28222000"
                    },
                    {
                        "id": 45422,
                        "name": "Rambervillers",
                        "latitude": "48.34240000",
                        "longitude": "6.63580000"
                    },
                    {
                        "id": 45424,
                        "name": "Ramonchamp",
                        "latitude": "47.89429000",
                        "longitude": "6.74171000"
                    },
                    {
                        "id": 45432,
                        "name": "Raon-aux-Bois",
                        "latitude": "48.05686000",
                        "longitude": "6.52098000"
                    },
                    {
                        "id": 45686,
                        "name": "Réding",
                        "latitude": "48.75177000",
                        "longitude": "7.10747000"
                    },
                    {
                        "id": 45689,
                        "name": "Réguisheim",
                        "latitude": "47.89563000",
                        "longitude": "7.35288000"
                    },
                    {
                        "id": 45691,
                        "name": "Réhon",
                        "latitude": "49.49878000",
                        "longitude": "5.75497000"
                    },
                    {
                        "id": 45444,
                        "name": "Reichshoffen",
                        "latitude": "48.93287000",
                        "longitude": "7.66561000"
                    },
                    {
                        "id": 45445,
                        "name": "Reichstett",
                        "latitude": "48.64856000",
                        "longitude": "7.75455000"
                    },
                    {
                        "id": 45450,
                        "name": "Reims",
                        "latitude": "49.26526000",
                        "longitude": "4.02853000"
                    },
                    {
                        "id": 45451,
                        "name": "Reiningue",
                        "latitude": "47.75215000",
                        "longitude": "7.23327000"
                    },
                    {
                        "id": 45693,
                        "name": "Rémelfing",
                        "latitude": "49.08947000",
                        "longitude": "7.08820000"
                    },
                    {
                        "id": 45694,
                        "name": "Rémilly",
                        "latitude": "49.01359000",
                        "longitude": "6.39219000"
                    },
                    {
                        "id": 45452,
                        "name": "Remiremont",
                        "latitude": "48.01754000",
                        "longitude": "6.58820000"
                    },
                    {
                        "id": 45461,
                        "name": "Renwez",
                        "latitude": "49.83839000",
                        "longitude": "4.60334000"
                    },
                    {
                        "id": 45467,
                        "name": "Rethel",
                        "latitude": "49.50979000",
                        "longitude": "4.36740000"
                    },
                    {
                        "id": 45469,
                        "name": "Retonfey",
                        "latitude": "49.13648000",
                        "longitude": "6.30634000"
                    },
                    {
                        "id": 45477,
                        "name": "Revigny-sur-Ornain",
                        "latitude": "48.83016000",
                        "longitude": "4.98558000"
                    },
                    {
                        "id": 45478,
                        "name": "Revin",
                        "latitude": "49.94039000",
                        "longitude": "4.63503000"
                    },
                    {
                        "id": 45483,
                        "name": "Rhinau",
                        "latitude": "48.32017000",
                        "longitude": "7.70527000"
                    },
                    {
                        "id": 45490,
                        "name": "Ribeauvillé",
                        "latitude": "48.19510000",
                        "longitude": "7.31938000"
                    },
                    {
                        "id": 45493,
                        "name": "Richardménil",
                        "latitude": "48.59334000",
                        "longitude": "6.16917000"
                    },
                    {
                        "id": 45497,
                        "name": "Richemont",
                        "latitude": "49.27723000",
                        "longitude": "6.16372000"
                    },
                    {
                        "id": 45498,
                        "name": "Richwiller",
                        "latitude": "47.77995000",
                        "longitude": "7.28067000"
                    },
                    {
                        "id": 45500,
                        "name": "Riedisheim",
                        "latitude": "47.74847000",
                        "longitude": "7.36716000"
                    },
                    {
                        "id": 45513,
                        "name": "Rilly-la-Montagne",
                        "latitude": "49.16553000",
                        "longitude": "4.04568000"
                    },
                    {
                        "id": 45514,
                        "name": "Rimogne",
                        "latitude": "49.84075000",
                        "longitude": "4.53941000"
                    },
                    {
                        "id": 45523,
                        "name": "Riquewihr",
                        "latitude": "48.16672000",
                        "longitude": "7.29707000"
                    },
                    {
                        "id": 45534,
                        "name": "Rixheim",
                        "latitude": "47.74970000",
                        "longitude": "7.40203000"
                    },
                    {
                        "id": 45553,
                        "name": "Rocroi",
                        "latitude": "49.92610000",
                        "longitude": "4.52220000"
                    },
                    {
                        "id": 45556,
                        "name": "Roeschwoog",
                        "latitude": "48.82676000",
                        "longitude": "8.03684000"
                    },
                    {
                        "id": 45562,
                        "name": "Rohrbach-lès-Bitche",
                        "latitude": "49.04424000",
                        "longitude": "7.26759000"
                    },
                    {
                        "id": 45567,
                        "name": "Rolampont",
                        "latitude": "47.94951000",
                        "longitude": "5.28560000"
                    },
                    {
                        "id": 45575,
                        "name": "Romanswiller",
                        "latitude": "48.64556000",
                        "longitude": "7.40762000"
                    },
                    {
                        "id": 45577,
                        "name": "Rombas",
                        "latitude": "49.24946000",
                        "longitude": "6.09398000"
                    },
                    {
                        "id": 45580,
                        "name": "Romilly-sur-Seine",
                        "latitude": "48.51085000",
                        "longitude": "3.72634000"
                    },
                    {
                        "id": 45600,
                        "name": "Rosenau",
                        "latitude": "47.63688000",
                        "longitude": "7.53598000"
                    },
                    {
                        "id": 45601,
                        "name": "Rosheim",
                        "latitude": "48.49710000",
                        "longitude": "7.47105000"
                    },
                    {
                        "id": 45603,
                        "name": "Rosières-aux-Salines",
                        "latitude": "48.59301000",
                        "longitude": "6.33199000"
                    },
                    {
                        "id": 45605,
                        "name": "Rosières-près-Troyes",
                        "latitude": "48.26182000",
                        "longitude": "4.07396000"
                    },
                    {
                        "id": 45610,
                        "name": "Rosselange",
                        "latitude": "49.25780000",
                        "longitude": "6.06890000"
                    },
                    {
                        "id": 45613,
                        "name": "Rothau",
                        "latitude": "48.45687000",
                        "longitude": "7.20772000"
                    },
                    {
                        "id": 45619,
                        "name": "Rouffach",
                        "latitude": "47.95786000",
                        "longitude": "7.30016000"
                    },
                    {
                        "id": 45626,
                        "name": "Rouhling",
                        "latitude": "49.13888000",
                        "longitude": "7.00446000"
                    },
                    {
                        "id": 45655,
                        "name": "Rozérieulles",
                        "latitude": "49.10668000",
                        "longitude": "6.08198000"
                    },
                    {
                        "id": 45661,
                        "name": "Ruelisheim",
                        "latitude": "47.82405000",
                        "longitude": "7.35744000"
                    },
                    {
                        "id": 45671,
                        "name": "Rumersheim-le-Haut",
                        "latitude": "47.85124000",
                        "longitude": "7.52079000"
                    },
                    {
                        "id": 45677,
                        "name": "Rupt-sur-Moselle",
                        "latitude": "47.92271000",
                        "longitude": "6.66291000"
                    },
                    {
                        "id": 45678,
                        "name": "Rurange-lès-Thionville",
                        "latitude": "49.27599000",
                        "longitude": "6.23184000"
                    },
                    {
                        "id": 45679,
                        "name": "Russ",
                        "latitude": "48.49600000",
                        "longitude": "7.25911000"
                    },
                    {
                        "id": 45680,
                        "name": "Russange",
                        "latitude": "49.48283000",
                        "longitude": "5.95204000"
                    },
                    {
                        "id": 45750,
                        "name": "Saint-Amarin",
                        "latitude": "47.87494000",
                        "longitude": "7.02940000"
                    },
                    {
                        "id": 45753,
                        "name": "Saint-Amé",
                        "latitude": "48.02388000",
                        "longitude": "6.66416000"
                    },
                    {
                        "id": 45765,
                        "name": "Saint-André-les-Vergers",
                        "latitude": "48.28527000",
                        "longitude": "4.05210000"
                    },
                    {
                        "id": 45798,
                        "name": "Saint-Avold",
                        "latitude": "49.10465000",
                        "longitude": "6.70402000"
                    },
                    {
                        "id": 45826,
                        "name": "Saint-Brice-Courcelles",
                        "latitude": "49.26667000",
                        "longitude": "3.98333000"
                    },
                    {
                        "id": 45913,
                        "name": "Saint-Dié-des-Vosges",
                        "latitude": "48.28333000",
                        "longitude": "6.95000000"
                    },
                    {
                        "id": 45912,
                        "name": "Saint-Dizier",
                        "latitude": "48.63773000",
                        "longitude": "4.94892000"
                    },
                    {
                        "id": 46657,
                        "name": "Saint-Étienne-lès-Remiremont",
                        "latitude": "48.02287000",
                        "longitude": "6.60868000"
                    },
                    {
                        "id": 45994,
                        "name": "Saint-Germain",
                        "latitude": "48.25736000",
                        "longitude": "4.03264000"
                    },
                    {
                        "id": 46068,
                        "name": "Saint-Hippolyte",
                        "latitude": "48.23156000",
                        "longitude": "7.37121000"
                    },
                    {
                        "id": 46148,
                        "name": "Saint-Julien-lès-Metz",
                        "latitude": "49.13288000",
                        "longitude": "6.20240000"
                    },
                    {
                        "id": 46147,
                        "name": "Saint-Julien-les-Villas",
                        "latitude": "48.27127000",
                        "longitude": "4.09901000"
                    },
                    {
                        "id": 46158,
                        "name": "Saint-Just-Sauvage",
                        "latitude": "48.55478000",
                        "longitude": "3.78449000"
                    },
                    {
                        "id": 46172,
                        "name": "Saint-Laurent",
                        "latitude": "49.76449000",
                        "longitude": "4.77193000"
                    },
                    {
                        "id": 46223,
                        "name": "Saint-Léonard",
                        "latitude": "48.21638000",
                        "longitude": "6.94355000"
                    },
                    {
                        "id": 46196,
                        "name": "Saint-Louis",
                        "latitude": "47.59206000",
                        "longitude": "7.55923000"
                    },
                    {
                        "id": 46209,
                        "name": "Saint-Lyé",
                        "latitude": "48.36502000",
                        "longitude": "3.99900000"
                    },
                    {
                        "id": 46321,
                        "name": "Saint-Maurice-sur-Moselle",
                        "latitude": "47.85889000",
                        "longitude": "6.82477000"
                    },
                    {
                        "id": 46323,
                        "name": "Saint-Max",
                        "latitude": "48.70426000",
                        "longitude": "6.20686000"
                    },
                    {
                        "id": 46328,
                        "name": "Saint-Memmie",
                        "latitude": "48.95247000",
                        "longitude": "4.38409000"
                    },
                    {
                        "id": 46330,
                        "name": "Saint-Menges",
                        "latitude": "49.73873000",
                        "longitude": "4.92628000"
                    },
                    {
                        "id": 46340,
                        "name": "Saint-Michel-sur-Meurthe",
                        "latitude": "48.32219000",
                        "longitude": "6.89024000"
                    },
                    {
                        "id": 46342,
                        "name": "Saint-Mihiel",
                        "latitude": "48.88746000",
                        "longitude": "5.55099000"
                    },
                    {
                        "id": 46356,
                        "name": "Saint-Nabord",
                        "latitude": "48.05171000",
                        "longitude": "6.58248000"
                    },
                    {
                        "id": 46364,
                        "name": "Saint-Nicolas-de-Port",
                        "latitude": "48.62857000",
                        "longitude": "6.29668000"
                    },
                    {
                        "id": 46397,
                        "name": "Saint-Parres-aux-Tertres",
                        "latitude": "48.29780000",
                        "longitude": "4.11752000"
                    },
                    {
                        "id": 46461,
                        "name": "Saint-Pouange",
                        "latitude": "48.22656000",
                        "longitude": "4.03979000"
                    },
                    {
                        "id": 46471,
                        "name": "Saint-Privat-la-Montagne",
                        "latitude": "49.18768000",
                        "longitude": "6.03874000"
                    },
                    {
                        "id": 46672,
                        "name": "Sainte-Croix-aux-Mines",
                        "latitude": "48.26249000",
                        "longitude": "7.22739000"
                    },
                    {
                        "id": 46673,
                        "name": "Sainte-Croix-en-Plaine",
                        "latitude": "48.00876000",
                        "longitude": "7.38556000"
                    },
                    {
                        "id": 46704,
                        "name": "Sainte-Marguerite",
                        "latitude": "48.26735000",
                        "longitude": "6.98439000"
                    },
                    {
                        "id": 46710,
                        "name": "Sainte-Marie-aux-Chênes",
                        "latitude": "49.19262000",
                        "longitude": "6.00150000"
                    },
                    {
                        "id": 46711,
                        "name": "Sainte-Marie-aux-Mines",
                        "latitude": "48.24649000",
                        "longitude": "7.18385000"
                    },
                    {
                        "id": 46716,
                        "name": "Sainte-Maure",
                        "latitude": "48.34729000",
                        "longitude": "4.05962000"
                    },
                    {
                        "id": 46719,
                        "name": "Sainte-Menehould",
                        "latitude": "49.09008000",
                        "longitude": "4.89733000"
                    },
                    {
                        "id": 46725,
                        "name": "Sainte-Savine",
                        "latitude": "48.29637000",
                        "longitude": "4.04642000"
                    },
                    {
                        "id": 46739,
                        "name": "Saizerais",
                        "latitude": "48.79250000",
                        "longitude": "6.04470000"
                    },
                    {
                        "id": 46785,
                        "name": "Sand",
                        "latitude": "48.38319000",
                        "longitude": "7.61233000"
                    },
                    {
                        "id": 46809,
                        "name": "Sarralbe",
                        "latitude": "48.99858000",
                        "longitude": "7.03074000"
                    },
                    {
                        "id": 46811,
                        "name": "Sarre-Union",
                        "latitude": "48.93818000",
                        "longitude": "7.09373000"
                    },
                    {
                        "id": 46812,
                        "name": "Sarrebourg",
                        "latitude": "48.73558000",
                        "longitude": "7.05720000"
                    },
                    {
                        "id": 46813,
                        "name": "Sarreguemines",
                        "latitude": "49.10995000",
                        "longitude": "7.06747000"
                    },
                    {
                        "id": 46814,
                        "name": "Sarreinsming",
                        "latitude": "49.09121000",
                        "longitude": "7.11053000"
                    },
                    {
                        "id": 46815,
                        "name": "Sarrewerden",
                        "latitude": "48.92261000",
                        "longitude": "7.08412000"
                    },
                    {
                        "id": 46818,
                        "name": "Sarry",
                        "latitude": "48.91852000",
                        "longitude": "4.40621000"
                    },
                    {
                        "id": 46839,
                        "name": "Saulcy-sur-Meurthe",
                        "latitude": "48.23758000",
                        "longitude": "6.96443000"
                    },
                    {
                        "id": 46842,
                        "name": "Saulnes",
                        "latitude": "49.53189000",
                        "longitude": "5.82130000"
                    },
                    {
                        "id": 46843,
                        "name": "Saulny",
                        "latitude": "49.15770000",
                        "longitude": "6.10929000"
                    },
                    {
                        "id": 46846,
                        "name": "Sault-lès-Rethel",
                        "latitude": "49.49980000",
                        "longitude": "4.36227000"
                    },
                    {
                        "id": 46849,
                        "name": "Saulxures-lès-Nancy",
                        "latitude": "48.68872000",
                        "longitude": "6.24353000"
                    },
                    {
                        "id": 46850,
                        "name": "Saulxures-sur-Moselotte",
                        "latitude": "47.94894000",
                        "longitude": "6.77040000"
                    },
                    {
                        "id": 46853,
                        "name": "Sausheim",
                        "latitude": "47.78711000",
                        "longitude": "7.37267000"
                    },
                    {
                        "id": 46874,
                        "name": "Saverne",
                        "latitude": "48.74164000",
                        "longitude": "7.36221000"
                    },
                    {
                        "id": 46897,
                        "name": "Scherwiller",
                        "latitude": "48.28713000",
                        "longitude": "7.42135000"
                    },
                    {
                        "id": 46898,
                        "name": "Schiltigheim",
                        "latitude": "48.60749000",
                        "longitude": "7.74931000"
                    },
                    {
                        "id": 46899,
                        "name": "Schirmeck",
                        "latitude": "48.48313000",
                        "longitude": "7.22004000"
                    },
                    {
                        "id": 46900,
                        "name": "Schirrhein",
                        "latitude": "48.80161000",
                        "longitude": "7.90588000"
                    },
                    {
                        "id": 46901,
                        "name": "Schnersheim",
                        "latitude": "48.65741000",
                        "longitude": "7.56701000"
                    },
                    {
                        "id": 46904,
                        "name": "Schœneck",
                        "latitude": "49.21667000",
                        "longitude": "6.91667000"
                    },
                    {
                        "id": 46902,
                        "name": "Schweighouse-sur-Moder",
                        "latitude": "48.82009000",
                        "longitude": "7.72810000"
                    },
                    {
                        "id": 46903,
                        "name": "Schwindratzheim",
                        "latitude": "48.75582000",
                        "longitude": "7.59898000"
                    },
                    {
                        "id": 46908,
                        "name": "Scy-Chazelles",
                        "latitude": "49.11340000",
                        "longitude": "6.11470000"
                    },
                    {
                        "id": 46913,
                        "name": "Sedan",
                        "latitude": "49.70187000",
                        "longitude": "4.94028000"
                    },
                    {
                        "id": 46916,
                        "name": "Seichamps",
                        "latitude": "48.71492000",
                        "longitude": "6.26139000"
                    },
                    {
                        "id": 46928,
                        "name": "Seingbouse",
                        "latitude": "49.11341000",
                        "longitude": "6.83186000"
                    },
                    {
                        "id": 47136,
                        "name": "Sélestat",
                        "latitude": "48.26195000",
                        "longitude": "7.44890000"
                    },
                    {
                        "id": 46934,
                        "name": "Seltz",
                        "latitude": "48.89520000",
                        "longitude": "8.10757000"
                    },
                    {
                        "id": 46944,
                        "name": "Senones",
                        "latitude": "48.39475000",
                        "longitude": "6.97818000"
                    },
                    {
                        "id": 46947,
                        "name": "Sentheim",
                        "latitude": "47.75560000",
                        "longitude": "7.05305000"
                    },
                    {
                        "id": 46975,
                        "name": "Serémange-Erzange",
                        "latitude": "49.32062000",
                        "longitude": "6.09092000"
                    },
                    {
                        "id": 46957,
                        "name": "Sermaize-les-Bains",
                        "latitude": "48.78507000",
                        "longitude": "4.91169000"
                    },
                    {
                        "id": 46976,
                        "name": "Sessenheim",
                        "latitude": "48.79652000",
                        "longitude": "7.98719000"
                    },
                    {
                        "id": 47151,
                        "name": "Sézanne",
                        "latitude": "48.72047000",
                        "longitude": "3.72339000"
                    },
                    {
                        "id": 46989,
                        "name": "Sierck-les-Bains",
                        "latitude": "49.43942000",
                        "longitude": "6.35816000"
                    },
                    {
                        "id": 46990,
                        "name": "Sierentz",
                        "latitude": "47.65834000",
                        "longitude": "7.45387000"
                    },
                    {
                        "id": 46993,
                        "name": "Signy-le-Petit",
                        "latitude": "49.90277000",
                        "longitude": "4.27990000"
                    },
                    {
                        "id": 46994,
                        "name": "Sigolsheim",
                        "latitude": "48.13493000",
                        "longitude": "7.29980000"
                    },
                    {
                        "id": 46996,
                        "name": "Sillery",
                        "latitude": "49.19822000",
                        "longitude": "4.13244000"
                    },
                    {
                        "id": 47026,
                        "name": "Solgne",
                        "latitude": "48.96543000",
                        "longitude": "6.29429000"
                    },
                    {
                        "id": 47059,
                        "name": "Soucht",
                        "latitude": "48.95902000",
                        "longitude": "7.33434000"
                    },
                    {
                        "id": 47065,
                        "name": "Souffelweyersheim",
                        "latitude": "48.63540000",
                        "longitude": "7.74141000"
                    },
                    {
                        "id": 47066,
                        "name": "Soufflenheim",
                        "latitude": "48.83026000",
                        "longitude": "7.96268000"
                    },
                    {
                        "id": 47074,
                        "name": "Soultz-Haut-Rhin",
                        "latitude": "47.88849000",
                        "longitude": "7.22860000"
                    },
                    {
                        "id": 47075,
                        "name": "Soultz-sous-Forêts",
                        "latitude": "48.93693000",
                        "longitude": "7.88110000"
                    },
                    {
                        "id": 47076,
                        "name": "Soultzeren",
                        "latitude": "48.06394000",
                        "longitude": "7.10233000"
                    },
                    {
                        "id": 47077,
                        "name": "Soultzmatt",
                        "latitude": "47.96188000",
                        "longitude": "7.23759000"
                    },
                    {
                        "id": 47093,
                        "name": "Spicheren",
                        "latitude": "49.19252000",
                        "longitude": "6.96611000"
                    },
                    {
                        "id": 47097,
                        "name": "Staffelfelden",
                        "latitude": "47.82647000",
                        "longitude": "7.25235000"
                    },
                    {
                        "id": 47103,
                        "name": "Steinbach",
                        "latitude": "47.82140000",
                        "longitude": "7.15279000"
                    },
                    {
                        "id": 47104,
                        "name": "Steinbourg",
                        "latitude": "48.77028000",
                        "longitude": "7.41354000"
                    },
                    {
                        "id": 47105,
                        "name": "Stenay",
                        "latitude": "49.49489000",
                        "longitude": "5.18606000"
                    },
                    {
                        "id": 47106,
                        "name": "Still",
                        "latitude": "48.54982000",
                        "longitude": "7.40444000"
                    },
                    {
                        "id": 47107,
                        "name": "Stiring-Wendel",
                        "latitude": "49.20198000",
                        "longitude": "6.93170000"
                    },
                    {
                        "id": 47108,
                        "name": "Stosswihr",
                        "latitude": "48.05389000",
                        "longitude": "7.09964000"
                    },
                    {
                        "id": 47109,
                        "name": "Stotzheim",
                        "latitude": "48.37868000",
                        "longitude": "7.49235000"
                    },
                    {
                        "id": 47110,
                        "name": "Strasbourg",
                        "latitude": "48.58392000",
                        "longitude": "7.74553000"
                    },
                    {
                        "id": 47113,
                        "name": "Suippes",
                        "latitude": "49.12886000",
                        "longitude": "4.53446000"
                    },
                    {
                        "id": 47117,
                        "name": "Sundhoffen",
                        "latitude": "48.04263000",
                        "longitude": "7.41320000"
                    },
                    {
                        "id": 47118,
                        "name": "Sundhouse",
                        "latitude": "48.25110000",
                        "longitude": "7.60427000"
                    },
                    {
                        "id": 47119,
                        "name": "Surbourg",
                        "latitude": "48.91009000",
                        "longitude": "7.84716000"
                    },
                    {
                        "id": 47158,
                        "name": "Taintrux",
                        "latitude": "48.24944000",
                        "longitude": "6.89963000"
                    },
                    {
                        "id": 47159,
                        "name": "Taissy",
                        "latitude": "49.21509000",
                        "longitude": "4.09406000"
                    },
                    {
                        "id": 47160,
                        "name": "Talange",
                        "latitude": "49.23577000",
                        "longitude": "6.17167000"
                    },
                    {
                        "id": 47204,
                        "name": "Tenteling",
                        "latitude": "49.12544000",
                        "longitude": "6.93751000"
                    },
                    {
                        "id": 47211,
                        "name": "Terville",
                        "latitude": "49.34668000",
                        "longitude": "6.13346000"
                    },
                    {
                        "id": 47214,
                        "name": "Teting-sur-Nied",
                        "latitude": "49.05704000",
                        "longitude": "6.66294000"
                    },
                    {
                        "id": 47217,
                        "name": "Thann",
                        "latitude": "47.80789000",
                        "longitude": "7.10301000"
                    },
                    {
                        "id": 47219,
                        "name": "Thaon-les-Vosges",
                        "latitude": "48.25000000",
                        "longitude": "6.41667000"
                    },
                    {
                        "id": 47266,
                        "name": "Théding",
                        "latitude": "49.12847000",
                        "longitude": "6.89220000"
                    },
                    {
                        "id": 47231,
                        "name": "Thierville-sur-Meuse",
                        "latitude": "49.17050000",
                        "longitude": "5.35266000"
                    },
                    {
                        "id": 47232,
                        "name": "Thil",
                        "latitude": "49.47300000",
                        "longitude": "5.90821000"
                    },
                    {
                        "id": 47234,
                        "name": "Thilay",
                        "latitude": "49.87345000",
                        "longitude": "4.80772000"
                    },
                    {
                        "id": 47236,
                        "name": "Thionville",
                        "latitude": "49.35994000",
                        "longitude": "6.16044000"
                    },
                    {
                        "id": 47289,
                        "name": "Tinqueux",
                        "latitude": "49.25000000",
                        "longitude": "3.98333000"
                    },
                    {
                        "id": 47293,
                        "name": "Tomblaine",
                        "latitude": "48.68378000",
                        "longitude": "6.21620000"
                    },
                    {
                        "id": 47309,
                        "name": "Toul",
                        "latitude": "48.68075000",
                        "longitude": "5.89115000"
                    },
                    {
                        "id": 47326,
                        "name": "Tournes",
                        "latitude": "49.79700000",
                        "longitude": "4.63856000"
                    },
                    {
                        "id": 47334,
                        "name": "Tours-sur-Marne",
                        "latitude": "49.04873000",
                        "longitude": "4.12060000"
                    },
                    {
                        "id": 47402,
                        "name": "Trémery",
                        "latitude": "49.24610000",
                        "longitude": "6.22369000"
                    },
                    {
                        "id": 47362,
                        "name": "Tressange",
                        "latitude": "49.40271000",
                        "longitude": "5.98084000"
                    },
                    {
                        "id": 47372,
                        "name": "Trieux",
                        "latitude": "49.32462000",
                        "longitude": "5.93049000"
                    },
                    {
                        "id": 47380,
                        "name": "Tronville-en-Barrois",
                        "latitude": "48.71977000",
                        "longitude": "5.27808000"
                    },
                    {
                        "id": 47385,
                        "name": "Troyes",
                        "latitude": "48.30073000",
                        "longitude": "4.08524000"
                    },
                    {
                        "id": 47386,
                        "name": "Truchtersheim",
                        "latitude": "48.66313000",
                        "longitude": "7.60752000"
                    },
                    {
                        "id": 47410,
                        "name": "Tucquegnieux",
                        "latitude": "49.31010000",
                        "longitude": "5.89448000"
                    },
                    {
                        "id": 47415,
                        "name": "Turckheim",
                        "latitude": "48.08748000",
                        "longitude": "7.27707000"
                    },
                    {
                        "id": 47419,
                        "name": "Uberach",
                        "latitude": "48.84990000",
                        "longitude": "7.62934000"
                    },
                    {
                        "id": 47422,
                        "name": "Uckange",
                        "latitude": "49.30304000",
                        "longitude": "6.14920000"
                    },
                    {
                        "id": 47423,
                        "name": "Uffholtz",
                        "latitude": "47.82082000",
                        "longitude": "7.17785000"
                    },
                    {
                        "id": 47426,
                        "name": "Ungersheim",
                        "latitude": "47.87848000",
                        "longitude": "7.30797000"
                    },
                    {
                        "id": 47431,
                        "name": "Uriménil",
                        "latitude": "48.10079000",
                        "longitude": "6.40046000"
                    },
                    {
                        "id": 47432,
                        "name": "Urmatt",
                        "latitude": "48.52752000",
                        "longitude": "7.32565000"
                    },
                    {
                        "id": 47443,
                        "name": "Uxegney",
                        "latitude": "48.19652000",
                        "longitude": "6.36971000"
                    },
                    {
                        "id": 47446,
                        "name": "Uzemain",
                        "latitude": "48.08572000",
                        "longitude": "6.34443000"
                    },
                    {
                        "id": 47450,
                        "name": "Vacon",
                        "latitude": "48.66865000",
                        "longitude": "5.60024000"
                    },
                    {
                        "id": 47453,
                        "name": "Vagney",
                        "latitude": "48.00629000",
                        "longitude": "6.71740000"
                    },
                    {
                        "id": 47463,
                        "name": "Val-de-Meuse",
                        "latitude": "48.00000000",
                        "longitude": "5.50000000"
                    },
                    {
                        "id": 47481,
                        "name": "Valff",
                        "latitude": "48.42140000",
                        "longitude": "7.52058000"
                    },
                    {
                        "id": 47488,
                        "name": "Valleroy",
                        "latitude": "49.20944000",
                        "longitude": "5.93703000"
                    },
                    {
                        "id": 47496,
                        "name": "Valmont",
                        "latitude": "49.08430000",
                        "longitude": "6.69781000"
                    },
                    {
                        "id": 47503,
                        "name": "Vandœuvre-lès-Nancy",
                        "latitude": "48.65000000",
                        "longitude": "6.18333000"
                    },
                    {
                        "id": 47508,
                        "name": "Varangéville",
                        "latitude": "48.63675000",
                        "longitude": "6.31875000"
                    },
                    {
                        "id": 47529,
                        "name": "Vaucouleurs",
                        "latitude": "48.60313000",
                        "longitude": "5.66659000"
                    },
                    {
                        "id": 47553,
                        "name": "Vecoux",
                        "latitude": "47.97797000",
                        "longitude": "6.63651000"
                    },
                    {
                        "id": 47557,
                        "name": "Velaine-en-Haye",
                        "latitude": "48.69990000",
                        "longitude": "6.02754000"
                    },
                    {
                        "id": 47558,
                        "name": "Velaines",
                        "latitude": "48.69880000",
                        "longitude": "5.30483000"
                    },
                    {
                        "id": 47570,
                        "name": "Vendenheim",
                        "latitude": "48.66948000",
                        "longitude": "7.70983000"
                    },
                    {
                        "id": 47572,
                        "name": "Vendeuvre-sur-Barse",
                        "latitude": "48.23786000",
                        "longitude": "4.46905000"
                    },
                    {
                        "id": 47593,
                        "name": "Verdun",
                        "latitude": "49.15964000",
                        "longitude": "5.38290000"
                    },
                    {
                        "id": 47626,
                        "name": "Verny",
                        "latitude": "49.00677000",
                        "longitude": "6.20350000"
                    },
                    {
                        "id": 47629,
                        "name": "Verrières",
                        "latitude": "48.23334000",
                        "longitude": "4.14893000"
                    },
                    {
                        "id": 47643,
                        "name": "Vertus",
                        "latitude": "48.90609000",
                        "longitude": "4.00216000"
                    },
                    {
                        "id": 47645,
                        "name": "Verzenay",
                        "latitude": "49.15918000",
                        "longitude": "4.14543000"
                    },
                    {
                        "id": 47646,
                        "name": "Verzy",
                        "latitude": "49.14576000",
                        "longitude": "4.16409000"
                    },
                    {
                        "id": 47932,
                        "name": "Vézelise",
                        "latitude": "48.48748000",
                        "longitude": "6.08825000"
                    },
                    {
                        "id": 47669,
                        "name": "Vic-sur-Seille",
                        "latitude": "48.78195000",
                        "longitude": "6.53079000"
                    },
                    {
                        "id": 47691,
                        "name": "Vieux-Thann",
                        "latitude": "47.80400000",
                        "longitude": "7.12067000"
                    },
                    {
                        "id": 47695,
                        "name": "Vigneulles-lès-Hattonchâtel",
                        "latitude": "48.98152000",
                        "longitude": "5.70464000"
                    },
                    {
                        "id": 47699,
                        "name": "Vignot",
                        "latitude": "48.77418000",
                        "longitude": "5.60904000"
                    },
                    {
                        "id": 47702,
                        "name": "Vigy",
                        "latitude": "49.20443000",
                        "longitude": "6.29906000"
                    },
                    {
                        "id": 47706,
                        "name": "Village-Neuf",
                        "latitude": "47.60682000",
                        "longitude": "7.56964000"
                    },
                    {
                        "id": 47837,
                        "name": "Villé",
                        "latitude": "48.34270000",
                        "longitude": "7.30260000"
                    },
                    {
                        "id": 47720,
                        "name": "Ville-sous-la-Ferté",
                        "latitude": "48.12060000",
                        "longitude": "4.78957000"
                    },
                    {
                        "id": 47757,
                        "name": "Villenauxe-la-Grande",
                        "latitude": "48.58333000",
                        "longitude": "3.55000000"
                    },
                    {
                        "id": 47804,
                        "name": "Villers-la-Montagne",
                        "latitude": "49.47175000",
                        "longitude": "5.82522000"
                    },
                    {
                        "id": 47806,
                        "name": "Villers-lès-Nancy",
                        "latitude": "48.67333000",
                        "longitude": "6.15283000"
                    },
                    {
                        "id": 47802,
                        "name": "Villers-Semeuse",
                        "latitude": "49.74201000",
                        "longitude": "4.74697000"
                    },
                    {
                        "id": 47812,
                        "name": "Villerupt",
                        "latitude": "49.46715000",
                        "longitude": "5.93202000"
                    },
                    {
                        "id": 47824,
                        "name": "Villey-Saint-Étienne",
                        "latitude": "48.73254000",
                        "longitude": "5.97851000"
                    },
                    {
                        "id": 47827,
                        "name": "Villiers-en-Lieu",
                        "latitude": "48.66785000",
                        "longitude": "4.89755000"
                    },
                    {
                        "id": 47845,
                        "name": "Vincey",
                        "latitude": "48.33749000",
                        "longitude": "6.33134000"
                    },
                    {
                        "id": 47858,
                        "name": "Vireux-Molhain",
                        "latitude": "50.07874000",
                        "longitude": "4.72426000"
                    },
                    {
                        "id": 47859,
                        "name": "Vireux-Wallerand",
                        "latitude": "50.08196000",
                        "longitude": "4.73017000"
                    },
                    {
                        "id": 47873,
                        "name": "Vitry-le-François",
                        "latitude": "48.72472000",
                        "longitude": "4.58439000"
                    },
                    {
                        "id": 47874,
                        "name": "Vitry-sur-Orne",
                        "latitude": "49.26595000",
                        "longitude": "6.11074000"
                    },
                    {
                        "id": 47878,
                        "name": "Vittel",
                        "latitude": "48.20085000",
                        "longitude": "5.94843000"
                    },
                    {
                        "id": 47881,
                        "name": "Vivier-au-Court",
                        "latitude": "49.73326000",
                        "longitude": "4.82939000"
                    },
                    {
                        "id": 47891,
                        "name": "Void-Vacon",
                        "latitude": "48.68333000",
                        "longitude": "5.61667000"
                    },
                    {
                        "id": 47895,
                        "name": "Volgelsheim",
                        "latitude": "48.01462000",
                        "longitude": "7.55456000"
                    },
                    {
                        "id": 47896,
                        "name": "Volmerange-les-Mines",
                        "latitude": "49.44326000",
                        "longitude": "6.08062000"
                    },
                    {
                        "id": 47898,
                        "name": "Volstroff",
                        "latitude": "49.31135000",
                        "longitude": "6.25976000"
                    },
                    {
                        "id": 47904,
                        "name": "Vosges",
                        "latitude": "48.19161000",
                        "longitude": "6.40533000"
                    },
                    {
                        "id": 47916,
                        "name": "Vouziers",
                        "latitude": "49.39791000",
                        "longitude": "4.70120000"
                    },
                    {
                        "id": 47920,
                        "name": "Vrigne-aux-Bois",
                        "latitude": "49.73716000",
                        "longitude": "4.85567000"
                    },
                    {
                        "id": 47937,
                        "name": "Walbourg",
                        "latitude": "48.88628000",
                        "longitude": "7.78828000"
                    },
                    {
                        "id": 47938,
                        "name": "Waldighofen",
                        "latitude": "47.55045000",
                        "longitude": "7.31512000"
                    },
                    {
                        "id": 47941,
                        "name": "Walscheid",
                        "latitude": "48.65308000",
                        "longitude": "7.14998000"
                    },
                    {
                        "id": 47944,
                        "name": "Wangenbourg-Engenthal",
                        "latitude": "48.62805000",
                        "longitude": "7.30471000"
                    },
                    {
                        "id": 47945,
                        "name": "Warcq",
                        "latitude": "49.77517000",
                        "longitude": "4.68175000"
                    },
                    {
                        "id": 47950,
                        "name": "Warmeriville",
                        "latitude": "49.35227000",
                        "longitude": "4.21882000"
                    },
                    {
                        "id": 47952,
                        "name": "Wasselonne",
                        "latitude": "48.63779000",
                        "longitude": "7.44506000"
                    },
                    {
                        "id": 47954,
                        "name": "Wassy",
                        "latitude": "48.49811000",
                        "longitude": "4.94775000"
                    },
                    {
                        "id": 47958,
                        "name": "Wattwiller",
                        "latitude": "47.83649000",
                        "longitude": "7.17785000"
                    },
                    {
                        "id": 47963,
                        "name": "Weitbruch",
                        "latitude": "48.75455000",
                        "longitude": "7.77935000"
                    },
                    {
                        "id": 47965,
                        "name": "Westhoffen",
                        "latitude": "48.60352000",
                        "longitude": "7.44289000"
                    },
                    {
                        "id": 47966,
                        "name": "Wettolsheim",
                        "latitude": "48.05755000",
                        "longitude": "7.29844000"
                    },
                    {
                        "id": 47967,
                        "name": "Weyersheim",
                        "latitude": "48.71622000",
                        "longitude": "7.80127000"
                    },
                    {
                        "id": 47968,
                        "name": "Widensolen",
                        "latitude": "48.06377000",
                        "longitude": "7.48015000"
                    },
                    {
                        "id": 47969,
                        "name": "Wiesviller",
                        "latitude": "49.08095000",
                        "longitude": "7.16415000"
                    },
                    {
                        "id": 47971,
                        "name": "Wihr-au-Val",
                        "latitude": "48.05196000",
                        "longitude": "7.20493000"
                    },
                    {
                        "id": 47973,
                        "name": "Willerwald",
                        "latitude": "49.02481000",
                        "longitude": "7.03726000"
                    },
                    {
                        "id": 47976,
                        "name": "Wimmenau",
                        "latitude": "48.91217000",
                        "longitude": "7.42189000"
                    },
                    {
                        "id": 47977,
                        "name": "Wingen-sur-Moder",
                        "latitude": "48.91900000",
                        "longitude": "7.37955000"
                    },
                    {
                        "id": 47978,
                        "name": "Wingersheim",
                        "latitude": "48.72149000",
                        "longitude": "7.63464000"
                    },
                    {
                        "id": 47981,
                        "name": "Wintzenheim",
                        "latitude": "48.07269000",
                        "longitude": "7.29072000"
                    },
                    {
                        "id": 47982,
                        "name": "Wisches",
                        "latitude": "48.50881000",
                        "longitude": "7.26814000"
                    },
                    {
                        "id": 47984,
                        "name": "Wissembourg",
                        "latitude": "49.03708000",
                        "longitude": "7.94548000"
                    },
                    {
                        "id": 47986,
                        "name": "Witry-lès-Reims",
                        "latitude": "49.29162000",
                        "longitude": "4.11921000"
                    },
                    {
                        "id": 47987,
                        "name": "Wittelsheim",
                        "latitude": "47.80947000",
                        "longitude": "7.24154000"
                    },
                    {
                        "id": 47988,
                        "name": "Wittenheim",
                        "latitude": "47.81090000",
                        "longitude": "7.32756000"
                    },
                    {
                        "id": 47989,
                        "name": "Wittisheim",
                        "latitude": "48.26451000",
                        "longitude": "7.58683000"
                    },
                    {
                        "id": 47991,
                        "name": "Woerth",
                        "latitude": "48.93953000",
                        "longitude": "7.74279000"
                    },
                    {
                        "id": 47993,
                        "name": "Woippy",
                        "latitude": "49.15111000",
                        "longitude": "6.15132000"
                    },
                    {
                        "id": 47994,
                        "name": "Wolfgantzen",
                        "latitude": "48.02805000",
                        "longitude": "7.50040000"
                    },
                    {
                        "id": 47995,
                        "name": "Wolfisheim",
                        "latitude": "48.58723000",
                        "longitude": "7.66708000"
                    },
                    {
                        "id": 47997,
                        "name": "Woustviller",
                        "latitude": "49.07636000",
                        "longitude": "7.00487000"
                    },
                    {
                        "id": 47998,
                        "name": "Xertigny",
                        "latitude": "48.04394000",
                        "longitude": "6.40836000"
                    },
                    {
                        "id": 47999,
                        "name": "Xonrupt-Longemer",
                        "latitude": "48.08223000",
                        "longitude": "6.92944000"
                    },
                    {
                        "id": 48013,
                        "name": "Yutz",
                        "latitude": "49.35571000",
                        "longitude": "6.19260000"
                    },
                    {
                        "id": 48026,
                        "name": "Zillisheim",
                        "latitude": "47.69604000",
                        "longitude": "7.29736000"
                    },
                    {
                        "id": 48027,
                        "name": "Zimmersheim",
                        "latitude": "47.72079000",
                        "longitude": "7.38847000"
                    }
                ]
            },
            {
                "id": 4829,
                "name": "Guadeloupe",
                "iso2": "971",
                "latitude": "16.26500000",
                "longitude": "-61.55100000",
                "type": "overseas region",
                "cities": []
            },
            {
                "id": 5036,
                "name": "Haut-Rhin",
                "iso2": "68",
                "latitude": "47.86537740",
                "longitude": "6.67113810",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4997,
                "name": "Haute-Corse",
                "iso2": "2B",
                "latitude": "42.42958660",
                "longitude": "8.50625610",
                "type": "metropolitan department",
                "cities": [
                    {
                        "id": 155208,
                        "name": "Aghione",
                        "latitude": "42.09351770",
                        "longitude": "9.32400680"
                    },
                    {
                        "id": 155209,
                        "name": "Aiti",
                        "latitude": "42.40272900",
                        "longitude": "9.14601550"
                    },
                    {
                        "id": 155210,
                        "name": "Alando",
                        "latitude": "42.30835090",
                        "longitude": "9.24872760"
                    },
                    {
                        "id": 155211,
                        "name": "Albertacce",
                        "latitude": "42.31464300",
                        "longitude": "8.76294030"
                    },
                    {
                        "id": 155212,
                        "name": "Algajola",
                        "latitude": "42.60515890",
                        "longitude": "8.83813090"
                    },
                    {
                        "id": 155213,
                        "name": "Altiani",
                        "latitude": "42.21990470",
                        "longitude": "9.19419550"
                    },
                    {
                        "id": 155214,
                        "name": "Alzi",
                        "latitude": "42.31340260",
                        "longitude": "9.27630150"
                    },
                    {
                        "id": 155215,
                        "name": "Ampriani",
                        "latitude": "42.25370180",
                        "longitude": "9.33597420"
                    },
                    {
                        "id": 155216,
                        "name": "Antisanti",
                        "latitude": "42.15714410",
                        "longitude": "9.22131850"
                    },
                    {
                        "id": 155217,
                        "name": "Aregno",
                        "latitude": "42.59433650",
                        "longitude": "8.83525890"
                    },
                    {
                        "id": 155218,
                        "name": "Asco",
                        "latitude": "42.43874150",
                        "longitude": "8.82755850"
                    },
                    {
                        "id": 155219,
                        "name": "Avapessa",
                        "latitude": "42.55929760",
                        "longitude": "8.85503480"
                    },
                    {
                        "id": 155220,
                        "name": "Barbaggio",
                        "latitude": "42.68274440",
                        "longitude": "9.28120320"
                    },
                    {
                        "id": 155221,
                        "name": "Barrettali",
                        "latitude": "42.87329630",
                        "longitude": "9.27871910"
                    },
                    {
                        "id": 155222,
                        "name": "Belgodère",
                        "latitude": "42.60850590",
                        "longitude": "8.97837920"
                    },
                    {
                        "id": 155223,
                        "name": "Bigorno",
                        "latitude": "42.52747480",
                        "longitude": "9.26319330"
                    },
                    {
                        "id": 155224,
                        "name": "Bisinchi",
                        "latitude": "42.48162300",
                        "longitude": "9.27249410"
                    },
                    {
                        "id": 155225,
                        "name": "Bustanico",
                        "latitude": "42.32613300",
                        "longitude": "9.22882260"
                    },
                    {
                        "id": 155226,
                        "name": "Cagnano",
                        "latitude": "42.87260240",
                        "longitude": "9.36069020"
                    },
                    {
                        "id": 155227,
                        "name": "Calacuccia",
                        "latitude": "42.32427320",
                        "longitude": "8.95205590"
                    },
                    {
                        "id": 155228,
                        "name": "Cambia",
                        "latitude": "42.36709230",
                        "longitude": "9.26178460"
                    },
                    {
                        "id": 155229,
                        "name": "Campana",
                        "latitude": "42.38924560",
                        "longitude": "9.30055610"
                    },
                    {
                        "id": 155230,
                        "name": "Campi",
                        "latitude": "42.26803680",
                        "longitude": "9.38279330"
                    },
                    {
                        "id": 155231,
                        "name": "Campile",
                        "latitude": "42.49475810",
                        "longitude": "9.31631090"
                    },
                    {
                        "id": 155232,
                        "name": "Campitello",
                        "latitude": "42.52728370",
                        "longitude": "9.28666230"
                    },
                    {
                        "id": 155233,
                        "name": "Canale-di-Verde",
                        "latitude": "42.26344410",
                        "longitude": "9.41727130"
                    },
                    {
                        "id": 155234,
                        "name": "Canari",
                        "latitude": "42.83942170",
                        "longitude": "9.26809890"
                    },
                    {
                        "id": 155235,
                        "name": "Canavaggia",
                        "latitude": "42.49884440",
                        "longitude": "9.15170910"
                    },
                    {
                        "id": 155236,
                        "name": "Carcheto-Brustico",
                        "latitude": "42.35541930",
                        "longitude": "9.31805640"
                    },
                    {
                        "id": 155237,
                        "name": "Carpineto",
                        "latitude": "42.35616290",
                        "longitude": "9.35874080"
                    },
                    {
                        "id": 155238,
                        "name": "Carticasi",
                        "latitude": "42.34859640",
                        "longitude": "9.22282780"
                    },
                    {
                        "id": 155239,
                        "name": "Casabianca",
                        "latitude": "42.44678300",
                        "longitude": "9.33355320"
                    },
                    {
                        "id": 155240,
                        "name": "Casalta",
                        "latitude": "42.43677930",
                        "longitude": "9.38461370"
                    },
                    {
                        "id": 155241,
                        "name": "Casamaccioli",
                        "latitude": "42.28329300",
                        "longitude": "8.90035650"
                    },
                    {
                        "id": 155242,
                        "name": "Casanova",
                        "latitude": "42.25900900",
                        "longitude": "9.06782600"
                    },
                    {
                        "id": 155243,
                        "name": "Casevecchie",
                        "latitude": "42.13681050",
                        "longitude": "9.32656850"
                    },
                    {
                        "id": 155244,
                        "name": "Castellare-di-Casinca",
                        "latitude": "42.47190030",
                        "longitude": "9.41793230"
                    },
                    {
                        "id": 155245,
                        "name": "Castellare-di-Mercurio",
                        "latitude": "42.31219940",
                        "longitude": "9.20272570"
                    },
                    {
                        "id": 155246,
                        "name": "Castello-di-Rostino",
                        "latitude": "42.47326880",
                        "longitude": "9.21427900"
                    },
                    {
                        "id": 155247,
                        "name": "Castifao",
                        "latitude": "42.53093630",
                        "longitude": "9.05146520"
                    },
                    {
                        "id": 155248,
                        "name": "Castiglione",
                        "latitude": "42.40846610",
                        "longitude": "9.03051600"
                    },
                    {
                        "id": 155249,
                        "name": "Castineta",
                        "latitude": "42.42547080",
                        "longitude": "9.19083910"
                    },
                    {
                        "id": 155250,
                        "name": "Castirla",
                        "latitude": "42.36667180",
                        "longitude": "9.04219410"
                    },
                    {
                        "id": 155251,
                        "name": "Cateri",
                        "latitude": "42.56790080",
                        "longitude": "8.85583990"
                    },
                    {
                        "id": 155257,
                        "name": "Centuri",
                        "latitude": "42.97162300",
                        "longitude": "9.32725270"
                    },
                    {
                        "id": 155256,
                        "name": "Cervione",
                        "latitude": "42.31843150",
                        "longitude": "9.42916470"
                    },
                    {
                        "id": 155255,
                        "name": "Chiatra",
                        "latitude": "42.28548990",
                        "longitude": "9.40428420"
                    },
                    {
                        "id": 155258,
                        "name": "Chisa",
                        "latitude": "41.91303560",
                        "longitude": "9.09777580"
                    },
                    {
                        "id": 155259,
                        "name": "Corbara",
                        "latitude": "42.61971710",
                        "longitude": "8.81704390"
                    },
                    {
                        "id": 155260,
                        "name": "Corscia",
                        "latitude": "42.36254030",
                        "longitude": "8.88046260"
                    },
                    {
                        "id": 155261,
                        "name": "Corte",
                        "latitude": "42.27318810",
                        "longitude": "8.73949770"
                    },
                    {
                        "id": 155262,
                        "name": "Costa",
                        "latitude": "42.57641070",
                        "longitude": "8.97795830"
                    },
                    {
                        "id": 155263,
                        "name": "Croce",
                        "latitude": "42.40804700",
                        "longitude": "9.27544860"
                    },
                    {
                        "id": 155264,
                        "name": "Crocicchia",
                        "latitude": "42.47366210",
                        "longitude": "9.31159590"
                    },
                    {
                        "id": 155265,
                        "name": "Erbajolo",
                        "latitude": "42.25197400",
                        "longitude": "9.18182080"
                    },
                    {
                        "id": 155266,
                        "name": "Érone",
                        "latitude": "42.37549360",
                        "longitude": "9.22532680"
                    },
                    {
                        "id": 155267,
                        "name": "Ersa",
                        "latitude": "42.99133440",
                        "longitude": "9.29667870"
                    },
                    {
                        "id": 155268,
                        "name": "Farinole",
                        "latitude": "42.73058370",
                        "longitude": "9.28062940"
                    },
                    {
                        "id": 155269,
                        "name": "Favalello",
                        "latitude": "42.28853640",
                        "longitude": "9.16971490"
                    },
                    {
                        "id": 155270,
                        "name": "Felce",
                        "latitude": "42.34671380",
                        "longitude": "9.38667840"
                    },
                    {
                        "id": 155271,
                        "name": "Feliceto",
                        "latitude": "42.55150150",
                        "longitude": "8.90037400"
                    },
                    {
                        "id": 155272,
                        "name": "Ficaja",
                        "latitude": "42.42051980",
                        "longitude": "9.33661440"
                    },
                    {
                        "id": 155273,
                        "name": "Focicchia",
                        "latitude": "42.24716110",
                        "longitude": "9.20338290"
                    },
                    {
                        "id": 155274,
                        "name": "Furiani",
                        "latitude": "42.65475480",
                        "longitude": "9.33909820"
                    },
                    {
                        "id": 155275,
                        "name": "Galéria",
                        "latitude": "42.40437800",
                        "longitude": "8.37705840"
                    },
                    {
                        "id": 155276,
                        "name": "Gavignano",
                        "latitude": "42.42403320",
                        "longitude": "9.09917780"
                    },
                    {
                        "id": 155277,
                        "name": "Ghisonaccia",
                        "latitude": "42.04523600",
                        "longitude": "9.25475280"
                    },
                    {
                        "id": 155278,
                        "name": "Ghisoni",
                        "latitude": "42.09385260",
                        "longitude": "9.07207530"
                    },
                    {
                        "id": 155279,
                        "name": "Giocatojo",
                        "latitude": "42.44422280",
                        "longitude": "9.30278420"
                    },
                    {
                        "id": 155280,
                        "name": "Giuncaggio",
                        "latitude": "42.18273190",
                        "longitude": "9.23349260"
                    },
                    {
                        "id": 155281,
                        "name": "Isolaccio-di-Fiumorbo",
                        "latitude": "42.01677680",
                        "longitude": "9.10498040"
                    },
                    {
                        "id": 155282,
                        "name": "L'Île-Rousse",
                        "latitude": "42.63436740",
                        "longitude": "8.91584510"
                    },
                    {
                        "id": 155364,
                        "name": "La Porta",
                        "latitude": "42.42707930",
                        "longitude": "9.27794660"
                    },
                    {
                        "id": 155283,
                        "name": "Lama",
                        "latitude": "42.58301070",
                        "longitude": "9.08681670"
                    },
                    {
                        "id": 155284,
                        "name": "Lano",
                        "latitude": "42.37526990",
                        "longitude": "9.14755630"
                    },
                    {
                        "id": 155285,
                        "name": "Lavatoggio",
                        "latitude": "42.57535150",
                        "longitude": "8.82128990"
                    },
                    {
                        "id": 155286,
                        "name": "Lento",
                        "latitude": "42.52583960",
                        "longitude": "9.18195210"
                    },
                    {
                        "id": 155287,
                        "name": "Linguizzetta",
                        "latitude": "42.21428550",
                        "longitude": "9.33701210"
                    },
                    {
                        "id": 155288,
                        "name": "Loreto-di-Casinca",
                        "latitude": "42.47666180",
                        "longitude": "9.38572760"
                    },
                    {
                        "id": 155289,
                        "name": "Lozzi",
                        "latitude": "42.36239000",
                        "longitude": "8.89511900"
                    },
                    {
                        "id": 155290,
                        "name": "Lucciana",
                        "latitude": "42.53920450",
                        "longitude": "9.30055920"
                    },
                    {
                        "id": 155291,
                        "name": "Lugo-di-Nazza",
                        "latitude": "42.07214540",
                        "longitude": "9.24031860"
                    },
                    {
                        "id": 155292,
                        "name": "Lumio",
                        "latitude": "42.57998400",
                        "longitude": "8.74394560"
                    },
                    {
                        "id": 155293,
                        "name": "Luri",
                        "latitude": "42.89113080",
                        "longitude": "9.25479360"
                    },
                    {
                        "id": 155294,
                        "name": "Manso",
                        "latitude": "42.36851160",
                        "longitude": "8.64952570"
                    },
                    {
                        "id": 155295,
                        "name": "Matra",
                        "latitude": "42.28230160",
                        "longitude": "9.34546690"
                    },
                    {
                        "id": 155296,
                        "name": "Mausoléo",
                        "latitude": "42.49801620",
                        "longitude": "8.88576620"
                    },
                    {
                        "id": 155297,
                        "name": "Mazzola",
                        "latitude": "42.30597120",
                        "longitude": "9.28397050"
                    },
                    {
                        "id": 155298,
                        "name": "Meria",
                        "latitude": "42.91785300",
                        "longitude": "9.34970690"
                    },
                    {
                        "id": 155299,
                        "name": "Moïta",
                        "latitude": "42.28018330",
                        "longitude": "9.37249240"
                    },
                    {
                        "id": 155300,
                        "name": "Moltifao",
                        "latitude": "42.46883990",
                        "longitude": "8.96029060"
                    },
                    {
                        "id": 155301,
                        "name": "Monacia-d'Orezza",
                        "latitude": "42.38175330",
                        "longitude": "9.36589010"
                    },
                    {
                        "id": 155302,
                        "name": "Moncale",
                        "latitude": "42.50235230",
                        "longitude": "8.78007650"
                    },
                    {
                        "id": 155303,
                        "name": "Monte",
                        "latitude": "42.48744490",
                        "longitude": "9.32976280"
                    },
                    {
                        "id": 155304,
                        "name": "Montegrosso",
                        "latitude": "42.54450490",
                        "longitude": "8.77192600"
                    },
                    {
                        "id": 155305,
                        "name": "Monticello",
                        "latitude": "42.62127520",
                        "longitude": "8.92020970"
                    },
                    {
                        "id": 155306,
                        "name": "Morosaglia",
                        "latitude": "42.44984750",
                        "longitude": "9.08692080"
                    },
                    {
                        "id": 155307,
                        "name": "Morsiglia",
                        "latitude": "42.93626590",
                        "longitude": "9.29198950"
                    },
                    {
                        "id": 155308,
                        "name": "Muracciole",
                        "latitude": "42.17008830",
                        "longitude": "9.15273600"
                    },
                    {
                        "id": 155309,
                        "name": "Murato",
                        "latitude": "42.57201860",
                        "longitude": "9.24793820"
                    },
                    {
                        "id": 155310,
                        "name": "Muro",
                        "latitude": "42.54543420",
                        "longitude": "8.87384440"
                    },
                    {
                        "id": 155311,
                        "name": "Nessa",
                        "latitude": "42.55172680",
                        "longitude": "8.91651700"
                    },
                    {
                        "id": 155312,
                        "name": "Nocario",
                        "latitude": "42.39289080",
                        "longitude": "9.30544400"
                    },
                    {
                        "id": 155313,
                        "name": "Noceta",
                        "latitude": "42.19658120",
                        "longitude": "9.12781610"
                    },
                    {
                        "id": 155314,
                        "name": "Nonza",
                        "latitude": "42.78403550",
                        "longitude": "9.31824930"
                    },
                    {
                        "id": 155315,
                        "name": "Novale",
                        "latitude": "42.30335060",
                        "longitude": "9.36986170"
                    },
                    {
                        "id": 155316,
                        "name": "Novella",
                        "latitude": "42.60346870",
                        "longitude": "9.02053810"
                    },
                    {
                        "id": 155317,
                        "name": "Occhiatana",
                        "latitude": "42.59677140",
                        "longitude": "8.92657830"
                    },
                    {
                        "id": 155318,
                        "name": "Ogliastro",
                        "latitude": "42.82154010",
                        "longitude": "9.27432680"
                    },
                    {
                        "id": 155319,
                        "name": "Olcani",
                        "latitude": "42.80736380",
                        "longitude": "9.30390500"
                    },
                    {
                        "id": 155320,
                        "name": "Oletta",
                        "latitude": "42.64493460",
                        "longitude": "9.18078760"
                    },
                    {
                        "id": 155321,
                        "name": "Olmeta-di-Capocorso",
                        "latitude": "42.76424570",
                        "longitude": "9.29679550"
                    },
                    {
                        "id": 155322,
                        "name": "Olmeta-di-Tuda",
                        "latitude": "42.60942560",
                        "longitude": "9.19674580"
                    },
                    {
                        "id": 155323,
                        "name": "Olmi-Cappella",
                        "latitude": "42.51739670",
                        "longitude": "8.84126130"
                    },
                    {
                        "id": 155324,
                        "name": "Olmo",
                        "latitude": "42.50180800",
                        "longitude": "9.33164650"
                    },
                    {
                        "id": 155325,
                        "name": "Omessa",
                        "latitude": "42.38695340",
                        "longitude": "9.11234410"
                    },
                    {
                        "id": 155326,
                        "name": "Ortale",
                        "latitude": "42.31047550",
                        "longitude": "9.39542370"
                    },
                    {
                        "id": 155327,
                        "name": "Ortiporio",
                        "latitude": "42.45674850",
                        "longitude": "9.30463210"
                    },
                    {
                        "id": 155328,
                        "name": "Palasca",
                        "latitude": "42.63583990",
                        "longitude": "8.97872150"
                    },
                    {
                        "id": 155329,
                        "name": "Pancheraccia",
                        "latitude": "42.18906260",
                        "longitude": "9.32708290"
                    },
                    {
                        "id": 155330,
                        "name": "Parata",
                        "latitude": "42.36575830",
                        "longitude": "9.37624570"
                    },
                    {
                        "id": 155331,
                        "name": "Patrimonio",
                        "latitude": "42.70921810",
                        "longitude": "9.28246780"
                    },
                    {
                        "id": 155332,
                        "name": "Penta-Acquatella",
                        "latitude": "42.46514100",
                        "longitude": "9.35238220"
                    },
                    {
                        "id": 155333,
                        "name": "Penta-di-Casinca",
                        "latitude": "42.45646380",
                        "longitude": "9.40656030"
                    },
                    {
                        "id": 155334,
                        "name": "Perelli",
                        "latitude": "42.31447960",
                        "longitude": "9.34652120"
                    },
                    {
                        "id": 155335,
                        "name": "Pero-Casevecchie",
                        "latitude": "42.41675550",
                        "longitude": "9.42299870"
                    },
                    {
                        "id": 155336,
                        "name": "Pianello",
                        "latitude": "42.30038470",
                        "longitude": "9.31656400"
                    },
                    {
                        "id": 155337,
                        "name": "Piano",
                        "latitude": "42.44069670",
                        "longitude": "9.37581580"
                    },
                    {
                        "id": 155338,
                        "name": "Piazzali",
                        "latitude": "42.31959010",
                        "longitude": "9.38398320"
                    },
                    {
                        "id": 155339,
                        "name": "Piazzole",
                        "latitude": "42.39455590",
                        "longitude": "9.36466130"
                    },
                    {
                        "id": 155344,
                        "name": "Pie-d'Orezza",
                        "latitude": "42.37557790",
                        "longitude": "9.29929770"
                    },
                    {
                        "id": 155340,
                        "name": "Piedicorte-di-Gaggio",
                        "latitude": "42.21743570",
                        "longitude": "9.24011670"
                    },
                    {
                        "id": 155341,
                        "name": "Piedicroce",
                        "latitude": "42.38467410",
                        "longitude": "9.32590180"
                    },
                    {
                        "id": 155342,
                        "name": "Piedigriggio",
                        "latitude": "42.44558770",
                        "longitude": "9.09760880"
                    },
                    {
                        "id": 155343,
                        "name": "Piedipartino",
                        "latitude": "42.35693930",
                        "longitude": "9.30720690"
                    },
                    {
                        "id": 155346,
                        "name": "Pietra-di-Verde",
                        "latitude": "42.28982950",
                        "longitude": "9.40317730"
                    },
                    {
                        "id": 155345,
                        "name": "Pietracorbara",
                        "latitude": "42.84586770",
                        "longitude": "9.35388720"
                    },
                    {
                        "id": 155347,
                        "name": "Pietralba",
                        "latitude": "42.54266910",
                        "longitude": "9.09552570"
                    },
                    {
                        "id": 155348,
                        "name": "Pietraserena",
                        "latitude": "42.23455610",
                        "longitude": "9.31884200"
                    },
                    {
                        "id": 155349,
                        "name": "Pietricaggio",
                        "latitude": "42.32829820",
                        "longitude": "9.33692280"
                    },
                    {
                        "id": 155350,
                        "name": "Pietroso",
                        "latitude": "42.12609180",
                        "longitude": "9.15465880"
                    },
                    {
                        "id": 155351,
                        "name": "Piève",
                        "latitude": "42.60253180",
                        "longitude": "9.18228790"
                    },
                    {
                        "id": 155352,
                        "name": "Pigna",
                        "latitude": "42.60027710",
                        "longitude": "8.85893110"
                    },
                    {
                        "id": 155353,
                        "name": "Pino",
                        "latitude": "42.90632700",
                        "longitude": "9.31061970"
                    },
                    {
                        "id": 155354,
                        "name": "Piobetta",
                        "latitude": "42.34089490",
                        "longitude": "9.32816220"
                    },
                    {
                        "id": 155355,
                        "name": "Pioggiola",
                        "latitude": "42.52505410",
                        "longitude": "8.88739080"
                    },
                    {
                        "id": 155358,
                        "name": "Poggio-d'Oletta",
                        "latitude": "42.65576540",
                        "longitude": "9.27433470"
                    },
                    {
                        "id": 155356,
                        "name": "Poggio-di-Nazza",
                        "latitude": "42.05380930",
                        "longitude": "9.13536900"
                    },
                    {
                        "id": 155357,
                        "name": "Poggio-di-Venaco",
                        "latitude": "42.26901250",
                        "longitude": "9.12257750"
                    },
                    {
                        "id": 155359,
                        "name": "Poggio-Marinaccio",
                        "latitude": "42.43737620",
                        "longitude": "9.30816810"
                    },
                    {
                        "id": 155360,
                        "name": "Poggio-Mezzana",
                        "latitude": "42.40091390",
                        "longitude": "9.47094860"
                    },
                    {
                        "id": 155361,
                        "name": "Polveroso",
                        "latitude": "42.40106200",
                        "longitude": "9.32140830"
                    },
                    {
                        "id": 155362,
                        "name": "Popolasca",
                        "latitude": "42.43790560",
                        "longitude": "9.05060170"
                    },
                    {
                        "id": 155363,
                        "name": "Porri",
                        "latitude": "42.44861540",
                        "longitude": "9.40336090"
                    },
                    {
                        "id": 155365,
                        "name": "Prato-di-Giovellina",
                        "latitude": "42.41795990",
                        "longitude": "9.09282700"
                    },
                    {
                        "id": 155366,
                        "name": "Prunelli-di-Casacconi",
                        "latitude": "42.50939370",
                        "longitude": "9.36319610"
                    },
                    {
                        "id": 155367,
                        "name": "Prunelli-di-Fiumorbo",
                        "latitude": "42.00682260",
                        "longitude": "9.21039500"
                    },
                    {
                        "id": 155368,
                        "name": "Pruno",
                        "latitude": "42.42675360",
                        "longitude": "9.40616260"
                    },
                    {
                        "id": 155369,
                        "name": "Quercitello",
                        "latitude": "42.42791970",
                        "longitude": "9.30999360"
                    },
                    {
                        "id": 155370,
                        "name": "Rapaggio",
                        "latitude": "42.37684300",
                        "longitude": "9.36416640"
                    },
                    {
                        "id": 155371,
                        "name": "Rapale",
                        "latitude": "42.62041180",
                        "longitude": "9.20940740"
                    },
                    {
                        "id": 155372,
                        "name": "Riventosa",
                        "latitude": "42.24836810",
                        "longitude": "9.12387760"
                    },
                    {
                        "id": 155373,
                        "name": "Rogliano",
                        "latitude": "42.97393030",
                        "longitude": "9.35006110"
                    },
                    {
                        "id": 155374,
                        "name": "Rospigliani",
                        "latitude": "42.19215440",
                        "longitude": "9.19762290"
                    },
                    {
                        "id": 155375,
                        "name": "Rusio",
                        "latitude": "42.35006170",
                        "longitude": "9.21612070"
                    },
                    {
                        "id": 155376,
                        "name": "Rutali",
                        "latitude": "42.58083040",
                        "longitude": "9.30070230"
                    },
                    {
                        "id": 155377,
                        "name": "Saint-Florent",
                        "latitude": "42.69192000",
                        "longitude": "9.11964050"
                    },
                    {
                        "id": 155378,
                        "name": "Saliceto",
                        "latitude": "42.41247900",
                        "longitude": "9.09750990"
                    },
                    {
                        "id": 155379,
                        "name": "San-Damiano",
                        "latitude": "42.40404270",
                        "longitude": "9.33552850"
                    },
                    {
                        "id": 155380,
                        "name": "San-Gavino-d'Ampugnani",
                        "latitude": "42.41734350",
                        "longitude": "9.40599960"
                    },
                    {
                        "id": 155381,
                        "name": "San-Gavino-di-Fiumorbo",
                        "latitude": "41.96572750",
                        "longitude": "9.17425300"
                    },
                    {
                        "id": 155382,
                        "name": "San-Gavino-di-Tenda",
                        "latitude": "42.65010820",
                        "longitude": "8.85072150"
                    },
                    {
                        "id": 155383,
                        "name": "San-Giovanni-di-Moriani",
                        "latitude": "42.37134090",
                        "longitude": "9.37845470"
                    },
                    {
                        "id": 155384,
                        "name": "San-Giuliano",
                        "latitude": "42.28440900",
                        "longitude": "9.43895000"
                    },
                    {
                        "id": 155385,
                        "name": "San-Lorenzo",
                        "latitude": "42.39070270",
                        "longitude": "9.20935070"
                    },
                    {
                        "id": 155386,
                        "name": "San-Martino-di-Lota",
                        "latitude": "42.73061110",
                        "longitude": "9.34669340"
                    },
                    {
                        "id": 155387,
                        "name": "San-Nicolao",
                        "latitude": "42.36868140",
                        "longitude": "9.42463370"
                    },
                    {
                        "id": 155392,
                        "name": "Sant'Andréa-di-Bozio",
                        "latitude": "42.27513120",
                        "longitude": "9.19755740"
                    },
                    {
                        "id": 155393,
                        "name": "Sant'Andréa-di-Cotone",
                        "latitude": "42.31877670",
                        "longitude": "9.43558380"
                    },
                    {
                        "id": 155394,
                        "name": "Sant'Antonino",
                        "latitude": "42.58615920",
                        "longitude": "8.86831470"
                    },
                    {
                        "id": 155388,
                        "name": "Santa-Lucia-di-Mercurio",
                        "latitude": "42.31855700",
                        "longitude": "9.13943620"
                    },
                    {
                        "id": 155389,
                        "name": "Santa-Lucia-di-Moriani",
                        "latitude": "42.38411940",
                        "longitude": "9.46780110"
                    },
                    {
                        "id": 155390,
                        "name": "Santa-Maria-di-Lota",
                        "latitude": "42.75437830",
                        "longitude": "9.34581990"
                    },
                    {
                        "id": 155391,
                        "name": "Santa-Maria-Poggio",
                        "latitude": "42.34988660",
                        "longitude": "9.42674460"
                    },
                    {
                        "id": 155395,
                        "name": "Santa-Reparata-di-Balagna",
                        "latitude": "42.60384370",
                        "longitude": "8.89198700"
                    },
                    {
                        "id": 155396,
                        "name": "Santa-Reparata-di-Moriani",
                        "latitude": "42.35160020",
                        "longitude": "9.41405460"
                    },
                    {
                        "id": 155397,
                        "name": "Santo-Pietro-di-Tenda",
                        "latitude": "42.66779820",
                        "longitude": "9.03472830"
                    },
                    {
                        "id": 155398,
                        "name": "Santo-Pietro-di-Venaco",
                        "latitude": "42.24726390",
                        "longitude": "9.09402350"
                    },
                    {
                        "id": 155399,
                        "name": "Scata",
                        "latitude": "42.42257890",
                        "longitude": "9.38361600"
                    },
                    {
                        "id": 155400,
                        "name": "Scolca",
                        "latitude": "42.53892740",
                        "longitude": "9.32630690"
                    },
                    {
                        "id": 155401,
                        "name": "Sermano",
                        "latitude": "42.31560260",
                        "longitude": "9.22247850"
                    },
                    {
                        "id": 155402,
                        "name": "Serra-di-Fiumorbo",
                        "latitude": "41.96688950",
                        "longitude": "9.17044500"
                    },
                    {
                        "id": 155403,
                        "name": "Silvareccio",
                        "latitude": "42.45144250",
                        "longitude": "9.37544210"
                    },
                    {
                        "id": 155404,
                        "name": "Sisco",
                        "latitude": "42.81534120",
                        "longitude": "9.35649720"
                    },
                    {
                        "id": 155405,
                        "name": "Solaro",
                        "latitude": "41.87906980",
                        "longitude": "9.15326840"
                    },
                    {
                        "id": 155406,
                        "name": "Sorbo-Ocagnano",
                        "latitude": "42.48123970",
                        "longitude": "9.40054300"
                    },
                    {
                        "id": 155407,
                        "name": "Sorio",
                        "latitude": "42.57817260",
                        "longitude": "9.16252460"
                    },
                    {
                        "id": 155408,
                        "name": "Soveria",
                        "latitude": "42.34738910",
                        "longitude": "9.06011510"
                    },
                    {
                        "id": 155409,
                        "name": "Speloncato",
                        "latitude": "42.57573620",
                        "longitude": "8.93193350"
                    },
                    {
                        "id": 155410,
                        "name": "Stazzona",
                        "latitude": "42.38005990",
                        "longitude": "9.35394890"
                    },
                    {
                        "id": 155411,
                        "name": "Taglio-Isolaccio",
                        "latitude": "42.43374360",
                        "longitude": "9.41824090"
                    },
                    {
                        "id": 155412,
                        "name": "Talasani",
                        "latitude": "42.41639040",
                        "longitude": "9.42522150"
                    },
                    {
                        "id": 155413,
                        "name": "Tallone",
                        "latitude": "42.18985750",
                        "longitude": "9.30496420"
                    },
                    {
                        "id": 155414,
                        "name": "Tarrano",
                        "latitude": "42.34378850",
                        "longitude": "9.38001030"
                    },
                    {
                        "id": 155415,
                        "name": "Tomino",
                        "latitude": "42.94593020",
                        "longitude": "9.40354050"
                    },
                    {
                        "id": 155416,
                        "name": "Tox",
                        "latitude": "42.24546010",
                        "longitude": "9.36122460"
                    },
                    {
                        "id": 155417,
                        "name": "Tralonca",
                        "latitude": "42.33903850",
                        "longitude": "9.11323550"
                    },
                    {
                        "id": 155418,
                        "name": "Urtaca",
                        "latitude": "42.62562970",
                        "longitude": "8.98834530"
                    },
                    {
                        "id": 155420,
                        "name": "Valle-d'Alesani",
                        "latitude": "42.32690820",
                        "longitude": "9.34958470"
                    },
                    {
                        "id": 155423,
                        "name": "Valle-d'Orezza",
                        "latitude": "42.36362950",
                        "longitude": "9.36470200"
                    },
                    {
                        "id": 155421,
                        "name": "Valle-di-Campoloro",
                        "latitude": "42.33345160",
                        "longitude": "9.42874890"
                    },
                    {
                        "id": 155422,
                        "name": "Valle-di-Rostino",
                        "latitude": "42.45999690",
                        "longitude": "9.17693140"
                    },
                    {
                        "id": 155419,
                        "name": "Vallecalle",
                        "latitude": "42.60030380",
                        "longitude": "9.29621450"
                    },
                    {
                        "id": 155424,
                        "name": "Vallica",
                        "latitude": "42.51664890",
                        "longitude": "9.01709280"
                    },
                    {
                        "id": 155425,
                        "name": "Velone-Orneto",
                        "latitude": "42.38738090",
                        "longitude": "9.37230550"
                    },
                    {
                        "id": 155426,
                        "name": "Venaco",
                        "latitude": "42.21278320",
                        "longitude": "8.98102310"
                    },
                    {
                        "id": 155427,
                        "name": "Ventiseri",
                        "latitude": "41.93841610",
                        "longitude": "9.19053750"
                    },
                    {
                        "id": 155428,
                        "name": "Venzolasca",
                        "latitude": "42.49964240",
                        "longitude": "9.32367080"
                    },
                    {
                        "id": 155429,
                        "name": "Verdèse",
                        "latitude": "42.39345950",
                        "longitude": "9.33257210"
                    },
                    {
                        "id": 155430,
                        "name": "Vescovato",
                        "latitude": "42.51213260",
                        "longitude": "9.31076860"
                    },
                    {
                        "id": 155431,
                        "name": "Vezzani",
                        "latitude": "42.15001220",
                        "longitude": "9.12875190"
                    },
                    {
                        "id": 155432,
                        "name": "Vignale",
                        "latitude": "42.53893880",
                        "longitude": "9.31730980"
                    },
                    {
                        "id": 155433,
                        "name": "Ville-di-Paraso",
                        "latitude": "42.58451030",
                        "longitude": "8.95047850"
                    },
                    {
                        "id": 155434,
                        "name": "Ville-di-Pietrabugno",
                        "latitude": "42.71649610",
                        "longitude": "9.34390820"
                    },
                    {
                        "id": 155435,
                        "name": "Vivario",
                        "latitude": "42.14282250",
                        "longitude": "8.94907210"
                    },
                    {
                        "id": 155436,
                        "name": "Volpajola",
                        "latitude": "42.52447600",
                        "longitude": "9.28587710"
                    },
                    {
                        "id": 155437,
                        "name": "Zalana",
                        "latitude": "42.25298640",
                        "longitude": "9.30129380"
                    },
                    {
                        "id": 155438,
                        "name": "Zilia",
                        "latitude": "42.51808290",
                        "longitude": "8.81650790"
                    },
                    {
                        "id": 155439,
                        "name": "Zuani",
                        "latitude": "42.26507850",
                        "longitude": "9.30076490"
                    }
                ]
            },
            {
                "id": 4999,
                "name": "Haute-Garonne",
                "iso2": "31",
                "latitude": "43.30505550",
                "longitude": "0.68455150",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5011,
                "name": "Haute-Loire",
                "iso2": "43",
                "latitude": "45.08538060",
                "longitude": "3.22607070",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5020,
                "name": "Haute-Marne",
                "iso2": "52",
                "latitude": "48.13248210",
                "longitude": "4.69834990",
                "type": "metropolitan department",
                "cities": [
                    {
                        "id": 155592,
                        "name": "Ageville",
                        "latitude": "48.11003830",
                        "longitude": "5.17310240"
                    },
                    {
                        "id": 155593,
                        "name": "Aigremont",
                        "latitude": "48.90266770",
                        "longitude": "1.99205600"
                    },
                    {
                        "id": 155594,
                        "name": "Aillianville",
                        "latitude": "48.33429430",
                        "longitude": "5.43849100"
                    },
                    {
                        "id": 155595,
                        "name": "Aingoulaincourt",
                        "latitude": "48.45649370",
                        "longitude": "5.25730900"
                    },
                    {
                        "id": 155596,
                        "name": "Aizanville",
                        "latitude": "48.11129400",
                        "longitude": "4.87474160"
                    },
                    {
                        "id": 155597,
                        "name": "Allichamps",
                        "latitude": "48.56395740",
                        "longitude": "4.86851950"
                    },
                    {
                        "id": 155598,
                        "name": "Ambonville",
                        "latitude": "48.31526490",
                        "longitude": "4.97257640"
                    },
                    {
                        "id": 155599,
                        "name": "Andelot-Blancheville",
                        "latitude": "48.23644260",
                        "longitude": "5.19846690"
                    },
                    {
                        "id": 155600,
                        "name": "Andilly-en-Bassigny",
                        "latitude": "47.92767610",
                        "longitude": "5.50215770"
                    },
                    {
                        "id": 155601,
                        "name": "Annéville-la-Prairie",
                        "latitude": "48.19953310",
                        "longitude": "5.06688300"
                    },
                    {
                        "id": 155602,
                        "name": "Annonville",
                        "latitude": "48.38644880",
                        "longitude": "5.25003680"
                    },
                    {
                        "id": 155603,
                        "name": "Anrosey",
                        "latitude": "47.84682990",
                        "longitude": "5.63671220"
                    },
                    {
                        "id": 155604,
                        "name": "Aprey",
                        "latitude": "47.77385090",
                        "longitude": "5.15533100"
                    },
                    {
                        "id": 155605,
                        "name": "Arbigny-sous-Varennes",
                        "latitude": "47.86151230",
                        "longitude": "5.57368630"
                    },
                    {
                        "id": 155606,
                        "name": "Arbot",
                        "latitude": "47.84677600",
                        "longitude": "4.97535050"
                    },
                    {
                        "id": 155607,
                        "name": "Arc-en-Barrois",
                        "latitude": "47.94842170",
                        "longitude": "4.93535810"
                    },
                    {
                        "id": 155608,
                        "name": "Arnancourt",
                        "latitude": "48.35044190",
                        "longitude": "4.87836560"
                    },
                    {
                        "id": 155609,
                        "name": "Attancourt",
                        "latitude": "48.53654140",
                        "longitude": "4.92125760"
                    },
                    {
                        "id": 155610,
                        "name": "Aubepierre-sur-Aube",
                        "latitude": "47.91445660",
                        "longitude": "4.87267560"
                    },
                    {
                        "id": 155611,
                        "name": "Auberive",
                        "latitude": "47.78425200",
                        "longitude": "5.01220860"
                    },
                    {
                        "id": 155612,
                        "name": "Audeloncourt",
                        "latitude": "48.11815830",
                        "longitude": "5.49095690"
                    },
                    {
                        "id": 155613,
                        "name": "Aujeurres",
                        "latitude": "47.73910330",
                        "longitude": "5.15077390"
                    },
                    {
                        "id": 155614,
                        "name": "Aulnoy-sur-Aube",
                        "latitude": "47.83190590",
                        "longitude": "5.01148910"
                    },
                    {
                        "id": 155615,
                        "name": "Autigny-le-Grand",
                        "latitude": "48.47256660",
                        "longitude": "5.12977220"
                    },
                    {
                        "id": 155616,
                        "name": "Autigny-le-Petit",
                        "latitude": "48.48112360",
                        "longitude": "5.13049570"
                    },
                    {
                        "id": 155617,
                        "name": "Autreville-sur-la-Renne",
                        "latitude": "48.12694010",
                        "longitude": "4.93468920"
                    },
                    {
                        "id": 155618,
                        "name": "Avrecourt",
                        "latitude": "47.96548350",
                        "longitude": "5.51320070"
                    },
                    {
                        "id": 155619,
                        "name": "Bailly-aux-Forges",
                        "latitude": "48.45530510",
                        "longitude": "4.86522790"
                    },
                    {
                        "id": 155620,
                        "name": "Baissey",
                        "latitude": "47.74925220",
                        "longitude": "5.23160860"
                    },
                    {
                        "id": 155621,
                        "name": "Bannes",
                        "latitude": "47.90300420",
                        "longitude": "5.34928270"
                    },
                    {
                        "id": 155622,
                        "name": "Bassoncourt",
                        "latitude": "48.07583980",
                        "longitude": "5.53541300"
                    },
                    {
                        "id": 155623,
                        "name": "Baudrecourt",
                        "latitude": "48.39385650",
                        "longitude": "4.94971690"
                    },
                    {
                        "id": 155624,
                        "name": "Bay-sur-Aube",
                        "latitude": "47.82532160",
                        "longitude": "5.01752460"
                    },
                    {
                        "id": 155626,
                        "name": "Beauchemin",
                        "latitude": "47.91712610",
                        "longitude": "5.22845130"
                    },
                    {
                        "id": 155627,
                        "name": "Belmont",
                        "latitude": "47.72043020",
                        "longitude": "5.53289520"
                    },
                    {
                        "id": 155629,
                        "name": "Beurville",
                        "latitude": "48.31754850",
                        "longitude": "4.82026430"
                    },
                    {
                        "id": 155631,
                        "name": "Bize",
                        "latitude": "47.84023480",
                        "longitude": "5.62608600"
                    },
                    {
                        "id": 155632,
                        "name": "Blaisy",
                        "latitude": "48.17298570",
                        "longitude": "4.98940130"
                    },
                    {
                        "id": 155633,
                        "name": "Blecourt",
                        "latitude": "48.38107250",
                        "longitude": "5.05751790"
                    },
                    {
                        "id": 155634,
                        "name": "Blessonville",
                        "latitude": "48.05694950",
                        "longitude": "4.99102850"
                    },
                    {
                        "id": 155635,
                        "name": "Blumeray",
                        "latitude": "48.35548390",
                        "longitude": "4.82383150"
                    },
                    {
                        "id": 155636,
                        "name": "Bologne",
                        "latitude": "48.20354150",
                        "longitude": "5.09719810"
                    },
                    {
                        "id": 155637,
                        "name": "Bonnecourt",
                        "latitude": "47.95739540",
                        "longitude": "5.44091600"
                    },
                    {
                        "id": 155639,
                        "name": "Bourdons-sur-Rognon",
                        "latitude": "48.17170170",
                        "longitude": "5.30208680"
                    },
                    {
                        "id": 155640,
                        "name": "Bourg",
                        "latitude": "47.79262450",
                        "longitude": "5.29332670"
                    },
                    {
                        "id": 155641,
                        "name": "Bourg-Sainte-Marie",
                        "latitude": "48.18197720",
                        "longitude": "5.53052000"
                    },
                    {
                        "id": 155642,
                        "name": "Bourmont-entre-Meuse-et-Mouzon",
                        "latitude": "48.22243740",
                        "longitude": "5.52972790"
                    },
                    {
                        "id": 155643,
                        "name": "Bouzancourt",
                        "latitude": "48.32097000",
                        "longitude": "4.90280800"
                    },
                    {
                        "id": 155644,
                        "name": "Brachay",
                        "latitude": "48.38085670",
                        "longitude": "5.01955230"
                    },
                    {
                        "id": 155645,
                        "name": "Brainville-sur-Meuse",
                        "latitude": "48.17535640",
                        "longitude": "5.57198980"
                    },
                    {
                        "id": 155646,
                        "name": "Braux-le-Châtel",
                        "latitude": "48.10436560",
                        "longitude": "4.91530550"
                    },
                    {
                        "id": 155647,
                        "name": "Brennes",
                        "latitude": "47.79788150",
                        "longitude": "5.25663480"
                    },
                    {
                        "id": 155648,
                        "name": "Brethenay",
                        "latitude": "48.15851630",
                        "longitude": "5.05767330"
                    },
                    {
                        "id": 155649,
                        "name": "Breuvannes-en-Bassigny",
                        "latitude": "48.08609690",
                        "longitude": "5.45314980"
                    },
                    {
                        "id": 155650,
                        "name": "Briaucourt",
                        "latitude": "48.21316360",
                        "longitude": "5.11644400"
                    },
                    {
                        "id": 155651,
                        "name": "Bricon",
                        "latitude": "48.08496060",
                        "longitude": "4.89998930"
                    },
                    {
                        "id": 155652,
                        "name": "Brousseval",
                        "latitude": "48.49136290",
                        "longitude": "4.89438720"
                    },
                    {
                        "id": 155653,
                        "name": "Bugnières",
                        "latitude": "47.96416330",
                        "longitude": "5.00776330"
                    },
                    {
                        "id": 155654,
                        "name": "Busson",
                        "latitude": "48.33266540",
                        "longitude": "5.26170320"
                    },
                    {
                        "id": 155655,
                        "name": "Buxières-lès-Clefmont",
                        "latitude": "48.09178680",
                        "longitude": "5.41935070"
                    },
                    {
                        "id": 155656,
                        "name": "Buxières-lès-Villiers",
                        "latitude": "48.10202600",
                        "longitude": "4.98611350"
                    },
                    {
                        "id": 155657,
                        "name": "Ceffonds",
                        "latitude": "48.44066380",
                        "longitude": "4.66533470"
                    },
                    {
                        "id": 155658,
                        "name": "Celles-en-Bassigny",
                        "latitude": "47.91340760",
                        "longitude": "5.51327500"
                    },
                    {
                        "id": 155659,
                        "name": "Celsoy",
                        "latitude": "47.86313860",
                        "longitude": "5.41182330"
                    },
                    {
                        "id": 155660,
                        "name": "Cerisières",
                        "latitude": "48.30729880",
                        "longitude": "4.99872940"
                    },
                    {
                        "id": 155661,
                        "name": "Chalancey",
                        "latitude": "47.67730900",
                        "longitude": "5.09393640"
                    },
                    {
                        "id": 155663,
                        "name": "Chalvraines",
                        "latitude": "48.23096890",
                        "longitude": "5.42477410"
                    },
                    {
                        "id": 155665,
                        "name": "Chambroncourt",
                        "latitude": "48.35030240",
                        "longitude": "5.31643530"
                    },
                    {
                        "id": 155666,
                        "name": "Chamouilley",
                        "latitude": "48.61222530",
                        "longitude": "5.01052170"
                    },
                    {
                        "id": 155667,
                        "name": "Champigneulles-en-Bassigny",
                        "latitude": "48.12626680",
                        "longitude": "5.54881560"
                    },
                    {
                        "id": 155668,
                        "name": "Champigny-lès-Langres",
                        "latitude": "47.89504230",
                        "longitude": "5.30624340"
                    },
                    {
                        "id": 155669,
                        "name": "Champigny-sous-Varennes",
                        "latitude": "47.87101090",
                        "longitude": "5.58682790"
                    },
                    {
                        "id": 155670,
                        "name": "Champsevraine",
                        "latitude": "47.77173090",
                        "longitude": "5.44622930"
                    },
                    {
                        "id": 155672,
                        "name": "Changey",
                        "latitude": "47.92492750",
                        "longitude": "5.34400040"
                    },
                    {
                        "id": 155673,
                        "name": "Chanoy",
                        "latitude": "47.91949160",
                        "longitude": "5.24465840"
                    },
                    {
                        "id": 155674,
                        "name": "Chantraines",
                        "latitude": "48.21872710",
                        "longitude": "5.16303190"
                    },
                    {
                        "id": 155675,
                        "name": "Charmes",
                        "latitude": "47.92190360",
                        "longitude": "5.31165990"
                    },
                    {
                        "id": 155676,
                        "name": "Charmes-en-l'Angle",
                        "latitude": "48.35757160",
                        "longitude": "4.95762110"
                    },
                    {
                        "id": 155677,
                        "name": "Charmes-la-Grande",
                        "latitude": "48.37936440",
                        "longitude": "4.91447860"
                    },
                    {
                        "id": 155678,
                        "name": "Chassigny",
                        "latitude": "47.71648730",
                        "longitude": "5.30081530"
                    },
                    {
                        "id": 155680,
                        "name": "Chatenay-Mâcheron",
                        "latitude": "47.85558150",
                        "longitude": "5.36702060"
                    },
                    {
                        "id": 155681,
                        "name": "Chatenay-Vaudin",
                        "latitude": "47.85027070",
                        "longitude": "5.42774510"
                    },
                    {
                        "id": 155682,
                        "name": "Chatonrupt-Sommermont",
                        "latitude": "48.47276510",
                        "longitude": "5.05684940"
                    },
                    {
                        "id": 155683,
                        "name": "Chaudenay",
                        "latitude": "47.82101410",
                        "longitude": "5.48649640"
                    },
                    {
                        "id": 155684,
                        "name": "Chauffourt",
                        "latitude": "47.97093640",
                        "longitude": "5.41595430"
                    },
                    {
                        "id": 155686,
                        "name": "Chaumont-la-Ville",
                        "latitude": "48.14359480",
                        "longitude": "5.59744110"
                    },
                    {
                        "id": 155688,
                        "name": "Chézeaux",
                        "latitude": "47.87619500",
                        "longitude": "5.63682650"
                    },
                    {
                        "id": 155689,
                        "name": "Choilley-Dardenay",
                        "latitude": "47.66135320",
                        "longitude": "5.32586410"
                    },
                    {
                        "id": 155690,
                        "name": "Choiseul",
                        "latitude": "48.05307990",
                        "longitude": "5.53234320"
                    },
                    {
                        "id": 155691,
                        "name": "Cirey-lès-Mareilles",
                        "latitude": "48.19562700",
                        "longitude": "5.25802700"
                    },
                    {
                        "id": 155692,
                        "name": "Cirey-sur-Blaise",
                        "latitude": "48.33405640",
                        "longitude": "4.88668160"
                    },
                    {
                        "id": 155693,
                        "name": "Cirfontaines-en-Azois",
                        "latitude": "48.10642120",
                        "longitude": "4.82462800"
                    },
                    {
                        "id": 155694,
                        "name": "Cirfontaines-en-Ornois",
                        "latitude": "48.45153230",
                        "longitude": "5.35759750"
                    },
                    {
                        "id": 155695,
                        "name": "Clefmont",
                        "latitude": "48.11212670",
                        "longitude": "5.46557900"
                    },
                    {
                        "id": 155696,
                        "name": "Clinchamp",
                        "latitude": "48.19391770",
                        "longitude": "5.40928020"
                    },
                    {
                        "id": 155697,
                        "name": "Cohons",
                        "latitude": "47.78898870",
                        "longitude": "5.34431200"
                    },
                    {
                        "id": 155698,
                        "name": "Coiffy-le-Bas",
                        "latitude": "47.90668480",
                        "longitude": "5.62482490"
                    },
                    {
                        "id": 155699,
                        "name": "Coiffy-le-Haut",
                        "latitude": "47.90178030",
                        "longitude": "5.64793180"
                    },
                    {
                        "id": 155700,
                        "name": "Colmier-le-Bas",
                        "latitude": "47.77232870",
                        "longitude": "4.92056180"
                    },
                    {
                        "id": 155701,
                        "name": "Colmier-le-Haut",
                        "latitude": "47.78962640",
                        "longitude": "4.93877080"
                    },
                    {
                        "id": 155702,
                        "name": "Colombey-les-Deux-Églises",
                        "latitude": "48.24179510",
                        "longitude": "4.84142220"
                    },
                    {
                        "id": 155703,
                        "name": "Condes",
                        "latitude": "48.14191220",
                        "longitude": "5.12104360"
                    },
                    {
                        "id": 155704,
                        "name": "Consigny",
                        "latitude": "48.16698300",
                        "longitude": "5.39310760"
                    },
                    {
                        "id": 155705,
                        "name": "Coublanc",
                        "latitude": "47.70526190",
                        "longitude": "5.39955600"
                    },
                    {
                        "id": 155706,
                        "name": "Coupray",
                        "latitude": "47.97741680",
                        "longitude": "4.92257120"
                    },
                    {
                        "id": 155707,
                        "name": "Cour-l'Évêque",
                        "latitude": "47.97500900",
                        "longitude": "4.93867850"
                    },
                    {
                        "id": 155708,
                        "name": "Courcelles-en-Montagne",
                        "latitude": "47.84555620",
                        "longitude": "5.16853750"
                    },
                    {
                        "id": 155709,
                        "name": "Courcelles-sur-Blaise",
                        "latitude": "48.41190880",
                        "longitude": "4.92156100"
                    },
                    {
                        "id": 155710,
                        "name": "Culmont",
                        "latitude": "47.82735130",
                        "longitude": "5.42334280"
                    },
                    {
                        "id": 155711,
                        "name": "Curel",
                        "latitude": "48.49913400",
                        "longitude": "5.12525580"
                    },
                    {
                        "id": 155712,
                        "name": "Curmont",
                        "latitude": "48.25485950",
                        "longitude": "4.93168510"
                    },
                    {
                        "id": 155713,
                        "name": "Cusey",
                        "latitude": "47.62218810",
                        "longitude": "5.31457190"
                    },
                    {
                        "id": 155714,
                        "name": "Cuves",
                        "latitude": "48.09516660",
                        "longitude": "5.41048170"
                    },
                    {
                        "id": 155715,
                        "name": "Daillancourt",
                        "latitude": "48.29727430",
                        "longitude": "4.89335880"
                    },
                    {
                        "id": 155716,
                        "name": "Daillecourt",
                        "latitude": "48.07091800",
                        "longitude": "5.48541460"
                    },
                    {
                        "id": 155717,
                        "name": "Dammartin-sur-Meuse",
                        "latitude": "47.98014540",
                        "longitude": "5.54011160"
                    },
                    {
                        "id": 155718,
                        "name": "Dampierre",
                        "latitude": "47.96097820",
                        "longitude": "5.35983870"
                    },
                    {
                        "id": 155719,
                        "name": "Damrémont",
                        "latitude": "47.94753010",
                        "longitude": "5.62063790"
                    },
                    {
                        "id": 155720,
                        "name": "Dancevoir",
                        "latitude": "47.92997570",
                        "longitude": "4.83475000"
                    },
                    {
                        "id": 155721,
                        "name": "Darmannes",
                        "latitude": "48.16602830",
                        "longitude": "5.18359650"
                    },
                    {
                        "id": 155722,
                        "name": "Dinteville",
                        "latitude": "48.03717850",
                        "longitude": "4.75949350"
                    },
                    {
                        "id": 155723,
                        "name": "Domblain",
                        "latitude": "48.46556250",
                        "longitude": "4.98032150"
                    },
                    {
                        "id": 155724,
                        "name": "Dommarien",
                        "latitude": "47.69226170",
                        "longitude": "5.31668620"
                    },
                    {
                        "id": 155725,
                        "name": "Dommartin-le-Franc",
                        "latitude": "48.42542100",
                        "longitude": "4.90614030"
                    },
                    {
                        "id": 155726,
                        "name": "Dommartin-le-Saint-Père",
                        "latitude": "48.40935390",
                        "longitude": "4.87367550"
                    },
                    {
                        "id": 155727,
                        "name": "Domremy-Landéville",
                        "latitude": "48.35793190",
                        "longitude": "5.21644750"
                    },
                    {
                        "id": 155728,
                        "name": "Doncourt-sur-Meuse",
                        "latitude": "48.14015870",
                        "longitude": "5.56146110"
                    },
                    {
                        "id": 155729,
                        "name": "Donjeux",
                        "latitude": "48.35077150",
                        "longitude": "5.12228600"
                    },
                    {
                        "id": 155731,
                        "name": "Doulevant-le-Château",
                        "latitude": "48.37258030",
                        "longitude": "4.87465300"
                    },
                    {
                        "id": 155732,
                        "name": "Doulevant-le-Petit",
                        "latitude": "48.44960830",
                        "longitude": "4.90880550"
                    },
                    {
                        "id": 155733,
                        "name": "Échenay",
                        "latitude": "48.46415180",
                        "longitude": "5.29418650"
                    },
                    {
                        "id": 155734,
                        "name": "Éclaron-Braucourt Sainte-Livière",
                        "latitude": "48.56976940",
                        "longitude": "4.75146290"
                    },
                    {
                        "id": 155735,
                        "name": "Ecot-la-Combe",
                        "latitude": "48.20667070",
                        "longitude": "5.35545180"
                    },
                    {
                        "id": 155736,
                        "name": "Effincourt",
                        "latitude": "48.49253830",
                        "longitude": "5.22333410"
                    },
                    {
                        "id": 155737,
                        "name": "Enfonvelle",
                        "latitude": "47.92284820",
                        "longitude": "5.84364660"
                    },
                    {
                        "id": 155738,
                        "name": "Épizon",
                        "latitude": "48.36227480",
                        "longitude": "5.28765960"
                    },
                    {
                        "id": 155739,
                        "name": "Esnouveaux",
                        "latitude": "48.13316490",
                        "longitude": "5.30037330"
                    },
                    {
                        "id": 155740,
                        "name": "Euffigneix",
                        "latitude": "48.12704880",
                        "longitude": "5.02268520"
                    },
                    {
                        "id": 155742,
                        "name": "Farincourt",
                        "latitude": "47.69747240",
                        "longitude": "5.66052420"
                    },
                    {
                        "id": 155743,
                        "name": "Faverolles",
                        "latitude": "47.95586620",
                        "longitude": "5.18139380"
                    },
                    {
                        "id": 155745,
                        "name": "Fays",
                        "latitude": "48.47715660",
                        "longitude": "5.01702410"
                    },
                    {
                        "id": 155746,
                        "name": "Ferrière-et-Lafolie",
                        "latitude": "48.39795850",
                        "longitude": "5.02872880"
                    },
                    {
                        "id": 155747,
                        "name": "Flagey",
                        "latitude": "47.78531030",
                        "longitude": "5.22333310"
                    },
                    {
                        "id": 155748,
                        "name": "Flammerécourt",
                        "latitude": "48.36310990",
                        "longitude": "4.99504130"
                    },
                    {
                        "id": 155749,
                        "name": "Fontaines-sur-Marne",
                        "latitude": "48.55606530",
                        "longitude": "5.09800750"
                    },
                    {
                        "id": 155750,
                        "name": "Forcey",
                        "latitude": "48.15106090",
                        "longitude": "5.34878360"
                    },
                    {
                        "id": 155751,
                        "name": "Foulain",
                        "latitude": "48.02341440",
                        "longitude": "5.08059780"
                    },
                    {
                        "id": 155752,
                        "name": "Frampas",
                        "latitude": "48.52019730",
                        "longitude": "4.79234870"
                    },
                    {
                        "id": 155753,
                        "name": "Frécourt",
                        "latitude": "47.94824400",
                        "longitude": "5.43396940"
                    },
                    {
                        "id": 155754,
                        "name": "Fresnes-sur-Apance",
                        "latitude": "47.94256810",
                        "longitude": "5.79363180"
                    },
                    {
                        "id": 155756,
                        "name": "Fronville",
                        "latitude": "48.40046960",
                        "longitude": "5.08972870"
                    },
                    {
                        "id": 155757,
                        "name": "Genevrières",
                        "latitude": "47.72341160",
                        "longitude": "5.56109540"
                    },
                    {
                        "id": 155758,
                        "name": "Germaines",
                        "latitude": "47.79906490",
                        "longitude": "5.00901320"
                    },
                    {
                        "id": 155759,
                        "name": "Germainvilliers",
                        "latitude": "48.11538840",
                        "longitude": "5.59607490"
                    },
                    {
                        "id": 155760,
                        "name": "Germay",
                        "latitude": "48.40740010",
                        "longitude": "5.33129750"
                    },
                    {
                        "id": 155761,
                        "name": "Germisay",
                        "latitude": "48.39092360",
                        "longitude": "5.32527420"
                    },
                    {
                        "id": 155762,
                        "name": "Giey-sur-Aujon",
                        "latitude": "47.90527530",
                        "longitude": "5.01745440"
                    },
                    {
                        "id": 155763,
                        "name": "Gillancourt",
                        "latitude": "48.15335260",
                        "longitude": "4.95441460"
                    },
                    {
                        "id": 155764,
                        "name": "Gillaumé",
                        "latitude": "48.46854310",
                        "longitude": "5.32664310"
                    },
                    {
                        "id": 155765,
                        "name": "Gilley",
                        "latitude": "47.69170150",
                        "longitude": "5.61223970"
                    },
                    {
                        "id": 155766,
                        "name": "Graffigny-Chemin",
                        "latitude": "48.16830590",
                        "longitude": "5.60728900"
                    },
                    {
                        "id": 155767,
                        "name": "Grandchamp",
                        "latitude": "47.72231290",
                        "longitude": "5.42566200"
                    },
                    {
                        "id": 155768,
                        "name": "Grenant",
                        "latitude": "47.70722560",
                        "longitude": "5.45146330"
                    },
                    {
                        "id": 155769,
                        "name": "Gudmont-Villiers",
                        "latitude": "48.33621300",
                        "longitude": "5.07926390"
                    },
                    {
                        "id": 155770,
                        "name": "Guindrecourt-aux-Ormes",
                        "latitude": "48.45297720",
                        "longitude": "5.01940090"
                    },
                    {
                        "id": 155771,
                        "name": "Guindrecourt-sur-Blaise",
                        "latitude": "48.29844230",
                        "longitude": "4.95858090"
                    },
                    {
                        "id": 155772,
                        "name": "Guyonvelle",
                        "latitude": "47.85944450",
                        "longitude": "5.68424970"
                    },
                    {
                        "id": 155773,
                        "name": "Hâcourt",
                        "latitude": "48.16058690",
                        "longitude": "5.55908140"
                    },
                    {
                        "id": 155774,
                        "name": "Hallignicourt",
                        "latitude": "48.64738110",
                        "longitude": "4.83143460"
                    },
                    {
                        "id": 155775,
                        "name": "Harréville-les-Chanteurs",
                        "latitude": "48.26707700",
                        "longitude": "5.57667880"
                    },
                    {
                        "id": 155776,
                        "name": "Haute-Amance",
                        "latitude": "47.84922990",
                        "longitude": "5.44636080"
                    },
                    {
                        "id": 155777,
                        "name": "Heuilley-le-Grand",
                        "latitude": "47.75642110",
                        "longitude": "5.35520380"
                    },
                    {
                        "id": 155778,
                        "name": "Huilliécourt",
                        "latitude": "48.15936370",
                        "longitude": "5.49064550"
                    },
                    {
                        "id": 155779,
                        "name": "Humbécourt",
                        "latitude": "48.57997770",
                        "longitude": "4.88058760"
                    },
                    {
                        "id": 155780,
                        "name": "Humberville",
                        "latitude": "48.29451110",
                        "longitude": "5.35975040"
                    },
                    {
                        "id": 155781,
                        "name": "Humes-Jorquenay",
                        "latitude": "47.90270770",
                        "longitude": "5.26091140"
                    },
                    {
                        "id": 155782,
                        "name": "Illoud",
                        "latitude": "48.21660190",
                        "longitude": "5.50966650"
                    },
                    {
                        "id": 155783,
                        "name": "Is-en-Bassigny",
                        "latitude": "48.03599300",
                        "longitude": "5.40391500"
                    },
                    {
                        "id": 155784,
                        "name": "Isômes",
                        "latitude": "47.63553020",
                        "longitude": "5.28259770"
                    },
                    {
                        "id": 155786,
                        "name": "Jonchery",
                        "latitude": "48.14954500",
                        "longitude": "5.03102390"
                    },
                    {
                        "id": 155787,
                        "name": "Juzennecourt",
                        "latitude": "48.20193170",
                        "longitude": "4.93709400"
                    },
                    {
                        "id": 155788,
                        "name": "La Genevroye",
                        "latitude": "48.27634460",
                        "longitude": "5.04524190"
                    },
                    {
                        "id": 155807,
                        "name": "La Porte du Der",
                        "latitude": "48.47727400",
                        "longitude": "4.72506070"
                    },
                    {
                        "id": 155789,
                        "name": "Lachapelle-en-Blaisy",
                        "latitude": "48.20699960",
                        "longitude": "4.92140070"
                    },
                    {
                        "id": 155790,
                        "name": "Lafauche",
                        "latitude": "48.30393090",
                        "longitude": "5.47017390"
                    },
                    {
                        "id": 155791,
                        "name": "Laferté-sur-Amance",
                        "latitude": "47.83411950",
                        "longitude": "5.67509670"
                    },
                    {
                        "id": 155792,
                        "name": "Laferté-sur-Aube",
                        "latitude": "48.09601060",
                        "longitude": "4.69694760"
                    },
                    {
                        "id": 155793,
                        "name": "Lamancine",
                        "latitude": "48.21118010",
                        "longitude": "5.09502950"
                    },
                    {
                        "id": 155794,
                        "name": "Laneuvelle",
                        "latitude": "47.93542250",
                        "longitude": "5.62778440"
                    },
                    {
                        "id": 155795,
                        "name": "Laneuville-à-Rémy",
                        "latitude": "48.47308750",
                        "longitude": "4.86052000"
                    },
                    {
                        "id": 155796,
                        "name": "Laneuville-au-Pont",
                        "latitude": "48.62694140",
                        "longitude": "4.84664660"
                    },
                    {
                        "id": 155798,
                        "name": "Lanques-sur-Rognon",
                        "latitude": "48.08303240",
                        "longitude": "5.32255170"
                    },
                    {
                        "id": 155799,
                        "name": "Lanty-sur-Aube",
                        "latitude": "48.02518980",
                        "longitude": "4.70654310"
                    },
                    {
                        "id": 155800,
                        "name": "Larivière-Arnoncourt",
                        "latitude": "48.02104840",
                        "longitude": "5.68728930"
                    },
                    {
                        "id": 155801,
                        "name": "Latrecey-Ormoy-sur-Aube",
                        "latitude": "47.99042260",
                        "longitude": "4.76772670"
                    },
                    {
                        "id": 155802,
                        "name": "Lavernoy",
                        "latitude": "47.91545060",
                        "longitude": "5.55590600"
                    },
                    {
                        "id": 155803,
                        "name": "Laville-aux-Bois",
                        "latitude": "48.09019120",
                        "longitude": "5.19527530"
                    },
                    {
                        "id": 155804,
                        "name": "Lavilleneuve",
                        "latitude": "48.03787050",
                        "longitude": "5.49782730"
                    },
                    {
                        "id": 155805,
                        "name": "Lavilleneuve-au-Roi",
                        "latitude": "48.16186770",
                        "longitude": "4.89325960"
                    },
                    {
                        "id": 155806,
                        "name": "Le Châtelet-sur-Meuse",
                        "latitude": "47.97140070",
                        "longitude": "5.60843310"
                    },
                    {
                        "id": 155808,
                        "name": "Le Montsaugeonnais",
                        "latitude": "47.66421090",
                        "longitude": "5.24629220"
                    },
                    {
                        "id": 155809,
                        "name": "Le Pailly",
                        "latitude": "47.78735040",
                        "longitude": "5.39442630"
                    },
                    {
                        "id": 155810,
                        "name": "Le Val-d'Esnoms",
                        "latitude": "47.68612880",
                        "longitude": "5.17887510"
                    },
                    {
                        "id": 155811,
                        "name": "Lecey",
                        "latitude": "47.86069910",
                        "longitude": "5.39436730"
                    },
                    {
                        "id": 155812,
                        "name": "Leffonds",
                        "latitude": "47.97910970",
                        "longitude": "5.10514730"
                    },
                    {
                        "id": 155813,
                        "name": "Les Loges",
                        "latitude": "47.77091890",
                        "longitude": "5.43999360"
                    },
                    {
                        "id": 155814,
                        "name": "Leschères-sur-le-Blaiseron",
                        "latitude": "48.33227190",
                        "longitude": "4.98729420"
                    },
                    {
                        "id": 155815,
                        "name": "Leuchey",
                        "latitude": "47.72882880",
                        "longitude": "5.19522020"
                    },
                    {
                        "id": 155816,
                        "name": "Leurville",
                        "latitude": "48.33739830",
                        "longitude": "5.34456230"
                    },
                    {
                        "id": 155817,
                        "name": "Levécourt",
                        "latitude": "48.13468800",
                        "longitude": "5.53822550"
                    },
                    {
                        "id": 155818,
                        "name": "Lezéville",
                        "latitude": "48.42612920",
                        "longitude": "5.31536230"
                    },
                    {
                        "id": 155819,
                        "name": "Liffol-le-Petit",
                        "latitude": "48.28954560",
                        "longitude": "5.50319300"
                    },
                    {
                        "id": 155820,
                        "name": "Longchamp",
                        "latitude": "48.12751100",
                        "longitude": "5.41954620"
                    },
                    {
                        "id": 155821,
                        "name": "Longeau-Percey",
                        "latitude": "47.76162950",
                        "longitude": "5.30188170"
                    },
                    {
                        "id": 155822,
                        "name": "Louvemont",
                        "latitude": "48.54505530",
                        "longitude": "4.85255050"
                    },
                    {
                        "id": 155823,
                        "name": "Louvières",
                        "latitude": "48.02738590",
                        "longitude": "5.26121600"
                    },
                    {
                        "id": 155824,
                        "name": "Luzy-sur-Marne",
                        "latitude": "48.05608050",
                        "longitude": "5.15926420"
                    },
                    {
                        "id": 155825,
                        "name": "Maâtz",
                        "latitude": "47.71307280",
                        "longitude": "5.39316550"
                    },
                    {
                        "id": 155826,
                        "name": "Magneux",
                        "latitude": "48.50905220",
                        "longitude": "4.98600760"
                    },
                    {
                        "id": 155827,
                        "name": "Maisoncelles",
                        "latitude": "48.13434230",
                        "longitude": "5.51604440"
                    },
                    {
                        "id": 155828,
                        "name": "Maizières",
                        "latitude": "48.49179160",
                        "longitude": "5.04303620"
                    },
                    {
                        "id": 155829,
                        "name": "Maizières-sur-Amance",
                        "latitude": "47.83451390",
                        "longitude": "5.58840420"
                    },
                    {
                        "id": 155830,
                        "name": "Malaincourt-sur-Meuse",
                        "latitude": "48.15524750",
                        "longitude": "5.58557770"
                    },
                    {
                        "id": 155831,
                        "name": "Mandres-la-Côte",
                        "latitude": "48.06916010",
                        "longitude": "5.31170080"
                    },
                    {
                        "id": 155832,
                        "name": "Manois",
                        "latitude": "48.26171510",
                        "longitude": "5.32880090"
                    },
                    {
                        "id": 155833,
                        "name": "Marac",
                        "latitude": "47.93285650",
                        "longitude": "5.12392710"
                    },
                    {
                        "id": 155834,
                        "name": "Maranville",
                        "latitude": "48.13911090",
                        "longitude": "4.82156550"
                    },
                    {
                        "id": 155835,
                        "name": "Marbéville",
                        "latitude": "48.26382630",
                        "longitude": "4.98364480"
                    },
                    {
                        "id": 155836,
                        "name": "Marcilly-en-Bassigny",
                        "latitude": "47.88770960",
                        "longitude": "5.50749090"
                    },
                    {
                        "id": 155837,
                        "name": "Mardor",
                        "latitude": "47.88452460",
                        "longitude": "5.18860900"
                    },
                    {
                        "id": 155838,
                        "name": "Mareilles",
                        "latitude": "48.16622450",
                        "longitude": "5.21569020"
                    },
                    {
                        "id": 155839,
                        "name": "Marnay-sur-Marne",
                        "latitude": "48.01085340",
                        "longitude": "5.19018170"
                    },
                    {
                        "id": 155840,
                        "name": "Mathons",
                        "latitude": "48.41611710",
                        "longitude": "5.00074970"
                    },
                    {
                        "id": 155842,
                        "name": "Mennouveaux",
                        "latitude": "48.10067320",
                        "longitude": "5.39342730"
                    },
                    {
                        "id": 155843,
                        "name": "Merrey",
                        "latitude": "48.05268360",
                        "longitude": "5.57406620"
                    },
                    {
                        "id": 155844,
                        "name": "Mertrud",
                        "latitude": "48.42574330",
                        "longitude": "4.84438430"
                    },
                    {
                        "id": 155845,
                        "name": "Meures",
                        "latitude": "48.19294160",
                        "longitude": "5.03876540"
                    },
                    {
                        "id": 155846,
                        "name": "Millières",
                        "latitude": "48.14111140",
                        "longitude": "5.38895610"
                    },
                    {
                        "id": 155847,
                        "name": "Mirbel",
                        "latitude": "48.28465710",
                        "longitude": "4.99748980"
                    },
                    {
                        "id": 155848,
                        "name": "Moëslains",
                        "latitude": "48.61732390",
                        "longitude": "4.86389160"
                    },
                    {
                        "id": 155849,
                        "name": "Montcharvot",
                        "latitude": "47.89949990",
                        "longitude": "5.70872600"
                    },
                    {
                        "id": 155850,
                        "name": "Montheries",
                        "latitude": "48.17784520",
                        "longitude": "4.86100620"
                    },
                    {
                        "id": 155851,
                        "name": "Montot-sur-Rognon",
                        "latitude": "48.28254330",
                        "longitude": "5.27595230"
                    },
                    {
                        "id": 155852,
                        "name": "Montreuil-sur-Blaise",
                        "latitude": "48.47619540",
                        "longitude": "4.94593680"
                    },
                    {
                        "id": 155853,
                        "name": "Montreuil-sur-Thonnance",
                        "latitude": "48.46004720",
                        "longitude": "5.21313130"
                    },
                    {
                        "id": 155854,
                        "name": "Morancourt",
                        "latitude": "48.42661810",
                        "longitude": "4.96726870"
                    },
                    {
                        "id": 155855,
                        "name": "Morionvilliers",
                        "latitude": "48.37619480",
                        "longitude": "5.36990080"
                    },
                    {
                        "id": 155856,
                        "name": "Mouilleron",
                        "latitude": "47.69491120",
                        "longitude": "5.09199610"
                    },
                    {
                        "id": 155857,
                        "name": "Mussey-sur-Marne",
                        "latitude": "48.37996200",
                        "longitude": "5.08777310"
                    },
                    {
                        "id": 155858,
                        "name": "Narcy",
                        "latitude": "48.58022390",
                        "longitude": "5.06088760"
                    },
                    {
                        "id": 155859,
                        "name": "Neuilly-l'Évêque",
                        "latitude": "47.91818080",
                        "longitude": "5.39804820"
                    },
                    {
                        "id": 155860,
                        "name": "Neuilly-sur-Suize",
                        "latitude": "48.04022460",
                        "longitude": "5.08709010"
                    },
                    {
                        "id": 155861,
                        "name": "Neuvelle-lès-Voisey",
                        "latitude": "47.86595320",
                        "longitude": "5.76340180"
                    },
                    {
                        "id": 155862,
                        "name": "Ninville",
                        "latitude": "48.07034300",
                        "longitude": "5.41897960"
                    },
                    {
                        "id": 155863,
                        "name": "Nogent",
                        "latitude": "48.04190920",
                        "longitude": "5.28097660"
                    },
                    {
                        "id": 155864,
                        "name": "Noidant-Chatenoy",
                        "latitude": "47.79096260",
                        "longitude": "5.35658960"
                    },
                    {
                        "id": 155865,
                        "name": "Noidant-le-Rocheux",
                        "latitude": "47.82214980",
                        "longitude": "5.21828750"
                    },
                    {
                        "id": 155866,
                        "name": "Nomécourt",
                        "latitude": "48.43514120",
                        "longitude": "5.05450660"
                    },
                    {
                        "id": 155867,
                        "name": "Noncourt-sur-le-Rongeant",
                        "latitude": "48.42041590",
                        "longitude": "5.21100170"
                    },
                    {
                        "id": 155868,
                        "name": "Noyers",
                        "latitude": "48.06256930",
                        "longitude": "5.43980670"
                    },
                    {
                        "id": 155869,
                        "name": "Nully",
                        "latitude": "48.36994340",
                        "longitude": "4.77283570"
                    },
                    {
                        "id": 155870,
                        "name": "Occey",
                        "latitude": "47.60228840",
                        "longitude": "5.23091360"
                    },
                    {
                        "id": 155871,
                        "name": "Orbigny-au-Mont",
                        "latitude": "47.88624820",
                        "longitude": "5.41828830"
                    },
                    {
                        "id": 155872,
                        "name": "Orbigny-au-Val",
                        "latitude": "47.88273660",
                        "longitude": "5.39997210"
                    },
                    {
                        "id": 155873,
                        "name": "Orcevaux",
                        "latitude": "47.77568660",
                        "longitude": "5.24770100"
                    },
                    {
                        "id": 155874,
                        "name": "Orges",
                        "latitude": "48.08135560",
                        "longitude": "4.90011710"
                    },
                    {
                        "id": 155875,
                        "name": "Ormancey",
                        "latitude": "47.90808570",
                        "longitude": "5.14187900"
                    },
                    {
                        "id": 155876,
                        "name": "Ormoy-lès-Sexfontaines",
                        "latitude": "48.22566050",
                        "longitude": "5.03544590"
                    },
                    {
                        "id": 155877,
                        "name": "Orquevaux",
                        "latitude": "48.30883890",
                        "longitude": "5.37439010"
                    },
                    {
                        "id": 155878,
                        "name": "Osne-le-Val",
                        "latitude": "48.49932980",
                        "longitude": "5.16007990"
                    },
                    {
                        "id": 155879,
                        "name": "Oudincourt",
                        "latitude": "48.22629300",
                        "longitude": "5.06522200"
                    },
                    {
                        "id": 155880,
                        "name": "Outremécourt",
                        "latitude": "48.21716750",
                        "longitude": "5.67382010"
                    },
                    {
                        "id": 155881,
                        "name": "Ozières",
                        "latitude": "48.17100680",
                        "longitude": "5.42996970"
                    },
                    {
                        "id": 155882,
                        "name": "Palaiseul",
                        "latitude": "47.76623900",
                        "longitude": "5.39620530"
                    },
                    {
                        "id": 155883,
                        "name": "Pansey",
                        "latitude": "48.47999850",
                        "longitude": "5.25871390"
                    },
                    {
                        "id": 155884,
                        "name": "Parnoy-en-Bassigny",
                        "latitude": "48.02629320",
                        "longitude": "5.61953680"
                    },
                    {
                        "id": 155885,
                        "name": "Paroy-sur-Saulx",
                        "latitude": "48.51735880",
                        "longitude": "5.21423680"
                    },
                    {
                        "id": 155886,
                        "name": "Peigney",
                        "latitude": "47.87845800",
                        "longitude": "5.33174740"
                    },
                    {
                        "id": 155887,
                        "name": "Perrancey-les-Vieux-Moulins",
                        "latitude": "47.85690190",
                        "longitude": "5.23224090"
                    },
                    {
                        "id": 155888,
                        "name": "Perrogney-les-Fontaines",
                        "latitude": "47.80298680",
                        "longitude": "5.17994490"
                    },
                    {
                        "id": 155889,
                        "name": "Perrusse",
                        "latitude": "48.09542620",
                        "longitude": "5.45322600"
                    },
                    {
                        "id": 155890,
                        "name": "Perthes",
                        "latitude": "48.66496600",
                        "longitude": "4.77372900"
                    },
                    {
                        "id": 155891,
                        "name": "Pierremont-sur-Amance",
                        "latitude": "47.80493160",
                        "longitude": "5.61770510"
                    },
                    {
                        "id": 155892,
                        "name": "Pisseloup",
                        "latitude": "47.83368620",
                        "longitude": "5.71974430"
                    },
                    {
                        "id": 155893,
                        "name": "Planrupt",
                        "latitude": "48.51142910",
                        "longitude": "4.76825930"
                    },
                    {
                        "id": 155894,
                        "name": "Plesnoy",
                        "latitude": "47.89149120",
                        "longitude": "5.47252670"
                    },
                    {
                        "id": 155895,
                        "name": "Poinsenot",
                        "latitude": "47.71563430",
                        "longitude": "4.98878050"
                    },
                    {
                        "id": 155896,
                        "name": "Poinson-lès-Fayl",
                        "latitude": "47.74786340",
                        "longitude": "5.58397570"
                    },
                    {
                        "id": 155897,
                        "name": "Poinson-lès-Grancey",
                        "latitude": "47.71029800",
                        "longitude": "4.93758360"
                    },
                    {
                        "id": 155898,
                        "name": "Poinson-lès-Nogent",
                        "latitude": "47.99058610",
                        "longitude": "5.36029190"
                    },
                    {
                        "id": 155899,
                        "name": "Poiseul",
                        "latitude": "47.92266710",
                        "longitude": "5.46997760"
                    },
                    {
                        "id": 155900,
                        "name": "Poissons",
                        "latitude": "48.42206940",
                        "longitude": "5.17333320"
                    },
                    {
                        "id": 155901,
                        "name": "Pont-la-Ville",
                        "latitude": "48.08058580",
                        "longitude": "4.82778500"
                    },
                    {
                        "id": 155902,
                        "name": "Poulangy",
                        "latitude": "48.04549150",
                        "longitude": "5.21471120"
                    },
                    {
                        "id": 155903,
                        "name": "Praslay",
                        "latitude": "47.73812500",
                        "longitude": "5.08879800"
                    },
                    {
                        "id": 155904,
                        "name": "Pressigny",
                        "latitude": "47.74651310",
                        "longitude": "5.58646370"
                    },
                    {
                        "id": 155905,
                        "name": "Prez-sous-Lafauche",
                        "latitude": "48.27823300",
                        "longitude": "5.34331400"
                    },
                    {
                        "id": 155906,
                        "name": "Rachecourt-sur-Marne",
                        "latitude": "48.52103480",
                        "longitude": "5.05339480"
                    },
                    {
                        "id": 155907,
                        "name": "Rachecourt-Suzémont",
                        "latitude": "48.45595560",
                        "longitude": "4.88990020"
                    },
                    {
                        "id": 155908,
                        "name": "Rançonnières",
                        "latitude": "47.94135110",
                        "longitude": "5.47810020"
                    },
                    {
                        "id": 155909,
                        "name": "Rangecourt",
                        "latitude": "48.04264520",
                        "longitude": "5.40383200"
                    },
                    {
                        "id": 155910,
                        "name": "Rennepont",
                        "latitude": "48.16526320",
                        "longitude": "4.78042830"
                    },
                    {
                        "id": 155911,
                        "name": "Reynel",
                        "latitude": "48.29584990",
                        "longitude": "5.25914400"
                    },
                    {
                        "id": 155912,
                        "name": "Riaucourt",
                        "latitude": "48.17349130",
                        "longitude": "5.08483730"
                    },
                    {
                        "id": 155913,
                        "name": "Richebourg",
                        "latitude": "48.01291970",
                        "longitude": "4.97413170"
                    },
                    {
                        "id": 155914,
                        "name": "Rimaucourt",
                        "latitude": "48.24571280",
                        "longitude": "5.26579570"
                    },
                    {
                        "id": 155915,
                        "name": "Rives-Dervoises",
                        "latitude": "48.47008130",
                        "longitude": "4.54173260"
                    },
                    {
                        "id": 155916,
                        "name": "Rivière-les-Fosses",
                        "latitude": "47.64528080",
                        "longitude": "5.14208490"
                    },
                    {
                        "id": 155917,
                        "name": "Rivières-le-Bois",
                        "latitude": "47.74121690",
                        "longitude": "5.37227870"
                    },
                    {
                        "id": 155918,
                        "name": "Rizaucourt-Buchey",
                        "latitude": "48.27264630",
                        "longitude": "4.82755890"
                    },
                    {
                        "id": 155919,
                        "name": "Rochefort-sur-la-Côte",
                        "latitude": "48.22774660",
                        "longitude": "5.17031000"
                    },
                    {
                        "id": 155920,
                        "name": "Roches-Bettaincourt",
                        "latitude": "48.29497860",
                        "longitude": "5.09804100"
                    },
                    {
                        "id": 155921,
                        "name": "Roches-sur-Marne",
                        "latitude": "48.60128900",
                        "longitude": "4.92473260"
                    },
                    {
                        "id": 155922,
                        "name": "Rochetaillée",
                        "latitude": "47.84350730",
                        "longitude": "5.03630890"
                    },
                    {
                        "id": 155924,
                        "name": "Romain-sur-Meuse",
                        "latitude": "48.18704310",
                        "longitude": "5.43497840"
                    },
                    {
                        "id": 155925,
                        "name": "Rouécourt",
                        "latitude": "48.32969990",
                        "longitude": "5.03470510"
                    },
                    {
                        "id": 155926,
                        "name": "Rouelles",
                        "latitude": "47.80404790",
                        "longitude": "5.00686720"
                    },
                    {
                        "id": 155927,
                        "name": "Rougeux",
                        "latitude": "47.80985060",
                        "longitude": "5.48943790"
                    },
                    {
                        "id": 155928,
                        "name": "Rouvres-sur-Aube",
                        "latitude": "47.85625420",
                        "longitude": "4.90917460"
                    },
                    {
                        "id": 155929,
                        "name": "Rouvroy-sur-Marne",
                        "latitude": "48.35930110",
                        "longitude": "5.03258810"
                    },
                    {
                        "id": 155930,
                        "name": "Rupt",
                        "latitude": "48.42201290",
                        "longitude": "5.08968240"
                    },
                    {
                        "id": 155931,
                        "name": "Sailly",
                        "latitude": "48.43460450",
                        "longitude": "5.18392070"
                    },
                    {
                        "id": 155932,
                        "name": "Saint-Blin",
                        "latitude": "48.25132460",
                        "longitude": "5.33490740"
                    },
                    {
                        "id": 155933,
                        "name": "Saint-Broingt-le-Bois",
                        "latitude": "47.72907030",
                        "longitude": "5.37721400"
                    },
                    {
                        "id": 155934,
                        "name": "Saint-Broingt-les-Fosses",
                        "latitude": "47.71348800",
                        "longitude": "5.18741880"
                    },
                    {
                        "id": 155935,
                        "name": "Saint-Ciergues",
                        "latitude": "47.88210520",
                        "longitude": "5.17675340"
                    },
                    {
                        "id": 155937,
                        "name": "Saint-Loup-sur-Aujon",
                        "latitude": "47.88103150",
                        "longitude": "5.04677660"
                    },
                    {
                        "id": 155938,
                        "name": "Saint-Martin-lès-Langres",
                        "latitude": "47.89667100",
                        "longitude": "5.24056120"
                    },
                    {
                        "id": 155939,
                        "name": "Saint-Maurice",
                        "latitude": "47.85428070",
                        "longitude": "5.39679970"
                    },
                    {
                        "id": 155940,
                        "name": "Saint-Thiébault",
                        "latitude": "48.20130260",
                        "longitude": "5.57213120"
                    },
                    {
                        "id": 155941,
                        "name": "Saint-Urbain-Maconcourt",
                        "latitude": "48.39746090",
                        "longitude": "5.16342030"
                    },
                    {
                        "id": 155942,
                        "name": "Saint-Vallier-sur-Marne",
                        "latitude": "47.83364900",
                        "longitude": "5.38366650"
                    },
                    {
                        "id": 155943,
                        "name": "Saints-Geosmes",
                        "latitude": "47.82407550",
                        "longitude": "5.26286650"
                    },
                    {
                        "id": 155944,
                        "name": "Sarcey",
                        "latitude": "48.05754870",
                        "longitude": "5.27547170"
                    },
                    {
                        "id": 155945,
                        "name": "Sarrey",
                        "latitude": "48.00147630",
                        "longitude": "5.38484610"
                    },
                    {
                        "id": 155946,
                        "name": "Saudron",
                        "latitude": "48.49521910",
                        "longitude": "5.30211280"
                    },
                    {
                        "id": 155947,
                        "name": "Saulles",
                        "latitude": "47.70269920",
                        "longitude": "5.49479430"
                    },
                    {
                        "id": 155948,
                        "name": "Saulxures",
                        "latitude": "47.95526360",
                        "longitude": "5.55739830"
                    },
                    {
                        "id": 155949,
                        "name": "Savigny",
                        "latitude": "47.71818410",
                        "longitude": "5.62419620"
                    },
                    {
                        "id": 155950,
                        "name": "Semilly",
                        "latitude": "48.24459400",
                        "longitude": "5.43191300"
                    },
                    {
                        "id": 155951,
                        "name": "Semoutiers-Montsaon",
                        "latitude": "48.06061810",
                        "longitude": "5.00527010"
                    },
                    {
                        "id": 155952,
                        "name": "Serqueux",
                        "latitude": "48.00058880",
                        "longitude": "5.70494920"
                    },
                    {
                        "id": 155953,
                        "name": "Sexfontaines",
                        "latitude": "48.20861510",
                        "longitude": "4.98752520"
                    },
                    {
                        "id": 155954,
                        "name": "Signéville",
                        "latitude": "48.26716930",
                        "longitude": "5.24589790"
                    },
                    {
                        "id": 155955,
                        "name": "Silvarouvres",
                        "latitude": "48.06079300",
                        "longitude": "4.74683420"
                    },
                    {
                        "id": 155956,
                        "name": "Sommancourt",
                        "latitude": "48.50343420",
                        "longitude": "5.02013850"
                    },
                    {
                        "id": 155957,
                        "name": "Sommerécourt",
                        "latitude": "48.22388180",
                        "longitude": "5.63072840"
                    },
                    {
                        "id": 155958,
                        "name": "Sommevoire",
                        "latitude": "48.41083390",
                        "longitude": "4.78633990"
                    },
                    {
                        "id": 155959,
                        "name": "Soncourt-sur-Marne",
                        "latitude": "48.24871860",
                        "longitude": "5.04369710"
                    },
                    {
                        "id": 155960,
                        "name": "Soulaucourt-sur-Mouzon",
                        "latitude": "48.19417950",
                        "longitude": "5.65538450"
                    },
                    {
                        "id": 155961,
                        "name": "Soyers",
                        "latitude": "47.86610300",
                        "longitude": "5.67665260"
                    },
                    {
                        "id": 155962,
                        "name": "Suzannecourt",
                        "latitude": "48.43972340",
                        "longitude": "5.16459240"
                    },
                    {
                        "id": 155963,
                        "name": "Ternat",
                        "latitude": "47.91493000",
                        "longitude": "5.10697840"
                    },
                    {
                        "id": 155964,
                        "name": "Thilleux",
                        "latitude": "48.43397010",
                        "longitude": "4.74635320"
                    },
                    {
                        "id": 155965,
                        "name": "Thivet",
                        "latitude": "47.98564580",
                        "longitude": "5.25449150"
                    },
                    {
                        "id": 155966,
                        "name": "Thol-lès-Millières",
                        "latitude": "48.14733420",
                        "longitude": "5.45470260"
                    },
                    {
                        "id": 155967,
                        "name": "Thonnance-lès-Joinville",
                        "latitude": "48.46323300",
                        "longitude": "5.14344030"
                    },
                    {
                        "id": 155968,
                        "name": "Thonnance-les-Moulins",
                        "latitude": "48.42399040",
                        "longitude": "5.27728420"
                    },
                    {
                        "id": 155969,
                        "name": "Torcenay",
                        "latitude": "47.81390190",
                        "longitude": "5.44814510"
                    },
                    {
                        "id": 155970,
                        "name": "Tornay",
                        "latitude": "47.69092670",
                        "longitude": "5.57446190"
                    },
                    {
                        "id": 155971,
                        "name": "Treix",
                        "latitude": "48.14188840",
                        "longitude": "5.17482140"
                    },
                    {
                        "id": 155972,
                        "name": "Trémilly",
                        "latitude": "48.38320700",
                        "longitude": "4.73529780"
                    },
                    {
                        "id": 155973,
                        "name": "Troisfontaines-la-Ville",
                        "latitude": "48.54729600",
                        "longitude": "4.92826190"
                    },
                    {
                        "id": 155974,
                        "name": "Vaillant",
                        "latitude": "47.71714370",
                        "longitude": "5.13847950"
                    },
                    {
                        "id": 155976,
                        "name": "Valcourt",
                        "latitude": "48.61145330",
                        "longitude": "4.89102590"
                    },
                    {
                        "id": 155977,
                        "name": "Valleret",
                        "latitude": "48.48859990",
                        "longitude": "4.98741820"
                    },
                    {
                        "id": 155978,
                        "name": "Valleroy",
                        "latitude": "47.69724640",
                        "longitude": "5.63716420"
                    },
                    {
                        "id": 155979,
                        "name": "Vals-des-Tilles",
                        "latitude": "47.69045420",
                        "longitude": "5.04554390"
                    },
                    {
                        "id": 155980,
                        "name": "Varennes-sur-Amance",
                        "latitude": "47.89502760",
                        "longitude": "5.57035760"
                    },
                    {
                        "id": 155981,
                        "name": "Vaudrecourt",
                        "latitude": "48.20776050",
                        "longitude": "5.62640900"
                    },
                    {
                        "id": 155982,
                        "name": "Vaudrémont",
                        "latitude": "48.13263140",
                        "longitude": "4.89214880"
                    },
                    {
                        "id": 155983,
                        "name": "Vaux-sur-Blaise",
                        "latitude": "48.46939050",
                        "longitude": "4.92184930"
                    },
                    {
                        "id": 155984,
                        "name": "Vaux-sur-Saint-Urbain",
                        "latitude": "48.37091770",
                        "longitude": "5.18580800"
                    },
                    {
                        "id": 155985,
                        "name": "Vauxbons",
                        "latitude": "47.88279570",
                        "longitude": "5.10023080"
                    },
                    {
                        "id": 155986,
                        "name": "Vecqueville",
                        "latitude": "48.46221150",
                        "longitude": "5.11963550"
                    },
                    {
                        "id": 155987,
                        "name": "Velles",
                        "latitude": "47.83479550",
                        "longitude": "5.70376260"
                    },
                    {
                        "id": 155988,
                        "name": "Verbiesles",
                        "latitude": "48.07588620",
                        "longitude": "5.15359360"
                    },
                    {
                        "id": 155989,
                        "name": "Verseilles-le-Bas",
                        "latitude": "47.76239030",
                        "longitude": "5.27401660"
                    },
                    {
                        "id": 155990,
                        "name": "Verseilles-le-Haut",
                        "latitude": "47.76948850",
                        "longitude": "5.27154330"
                    },
                    {
                        "id": 155991,
                        "name": "Vesaignes-sous-Lafauche",
                        "latitude": "48.28455870",
                        "longitude": "5.40490290"
                    },
                    {
                        "id": 155992,
                        "name": "Vesaignes-sur-Marne",
                        "latitude": "47.99737090",
                        "longitude": "5.24620470"
                    },
                    {
                        "id": 155993,
                        "name": "Vesvres-sous-Chalancey",
                        "latitude": "47.69688350",
                        "longitude": "5.14739040"
                    },
                    {
                        "id": 155994,
                        "name": "Vicq",
                        "latitude": "47.92698400",
                        "longitude": "5.56721220"
                    },
                    {
                        "id": 155995,
                        "name": "Viéville",
                        "latitude": "48.23948100",
                        "longitude": "5.12726260"
                    },
                    {
                        "id": 155996,
                        "name": "Vignes-la-Côte",
                        "latitude": "48.27354120",
                        "longitude": "5.28830910"
                    },
                    {
                        "id": 155997,
                        "name": "Vignory",
                        "latitude": "48.27150790",
                        "longitude": "5.04814910"
                    },
                    {
                        "id": 155998,
                        "name": "Villars-en-Azois",
                        "latitude": "48.07059670",
                        "longitude": "4.66956980"
                    },
                    {
                        "id": 155999,
                        "name": "Villars-Santenoge",
                        "latitude": "47.74507410",
                        "longitude": "4.96042310"
                    },
                    {
                        "id": 156000,
                        "name": "Ville-en-Blaisois",
                        "latitude": "48.44287440",
                        "longitude": "4.90760270"
                    },
                    {
                        "id": 156001,
                        "name": "Villegusien-le-Lac",
                        "latitude": "47.74347330",
                        "longitude": "5.23703940"
                    },
                    {
                        "id": 156003,
                        "name": "Villiers-le-Sec",
                        "latitude": "48.10088220",
                        "longitude": "5.04868120"
                    },
                    {
                        "id": 156004,
                        "name": "Villiers-lès-Aprey",
                        "latitude": "47.75636890",
                        "longitude": "5.19942070"
                    },
                    {
                        "id": 156005,
                        "name": "Villiers-sur-Suize",
                        "latitude": "47.97984800",
                        "longitude": "5.15035880"
                    },
                    {
                        "id": 156006,
                        "name": "Violot",
                        "latitude": "47.75844870",
                        "longitude": "5.42669600"
                    },
                    {
                        "id": 156007,
                        "name": "Vitry-en-Montagne",
                        "latitude": "47.82110980",
                        "longitude": "5.05066180"
                    },
                    {
                        "id": 156008,
                        "name": "Vitry-lès-Nogent",
                        "latitude": "47.98704190",
                        "longitude": "5.32216350"
                    },
                    {
                        "id": 156009,
                        "name": "Vivey",
                        "latitude": "47.73769510",
                        "longitude": "5.04015670"
                    },
                    {
                        "id": 156010,
                        "name": "Voillecomte",
                        "latitude": "48.50408460",
                        "longitude": "4.82070500"
                    },
                    {
                        "id": 156011,
                        "name": "Voisey",
                        "latitude": "47.87910480",
                        "longitude": "5.73145280"
                    },
                    {
                        "id": 156012,
                        "name": "Voisines",
                        "latitude": "47.85666890",
                        "longitude": "5.13551680"
                    },
                    {
                        "id": 156013,
                        "name": "Voncourt",
                        "latitude": "47.71717710",
                        "longitude": "5.65392650"
                    },
                    {
                        "id": 156014,
                        "name": "Vouécourt",
                        "latitude": "48.26424440",
                        "longitude": "5.12639200"
                    },
                    {
                        "id": 156015,
                        "name": "Vraincourt",
                        "latitude": "48.23150090",
                        "longitude": "5.10004090"
                    },
                    {
                        "id": 156016,
                        "name": "Vroncourt-la-Côte",
                        "latitude": "48.14619270",
                        "longitude": "5.49240830"
                    }
                ]
            },
            {
                "id": 5039,
                "name": "Haute-Saône",
                "iso2": "70",
                "latitude": "47.63789960",
                "longitude": "5.53550550",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5043,
                "name": "Haute-Savoie",
                "iso2": "74",
                "latitude": "46.04452770",
                "longitude": "5.86413800",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5055,
                "name": "Haute-Vienne",
                "iso2": "87",
                "latitude": "45.91868780",
                "longitude": "0.70972060",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4971,
                "name": "Hautes-Alpes",
                "iso2": "05",
                "latitude": "44.65626820",
                "longitude": "5.68732110",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5033,
                "name": "Hautes-Pyrénées",
                "iso2": "65",
                "latitude": "43.14294620",
                "longitude": "-0.40097360",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4828,
                "name": "Hauts-de-France",
                "iso2": "HDF",
                "latitude": "50.48011530",
                "longitude": "2.79372650",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39235,
                        "name": "Abbeville",
                        "latitude": "50.10521000",
                        "longitude": "1.83547000"
                    },
                    {
                        "id": 39238,
                        "name": "Ablain-Saint-Nazaire",
                        "latitude": "50.39320000",
                        "longitude": "2.70880000"
                    },
                    {
                        "id": 39247,
                        "name": "Abscon",
                        "latitude": "50.33333000",
                        "longitude": "3.30000000"
                    },
                    {
                        "id": 39250,
                        "name": "Achicourt",
                        "latitude": "50.27429000",
                        "longitude": "2.75779000"
                    },
                    {
                        "id": 39251,
                        "name": "Achiet-le-Grand",
                        "latitude": "50.13067000",
                        "longitude": "2.78119000"
                    },
                    {
                        "id": 39260,
                        "name": "Agnetz",
                        "latitude": "49.38118000",
                        "longitude": "2.38621000"
                    },
                    {
                        "id": 39261,
                        "name": "Agny",
                        "latitude": "50.25914000",
                        "longitude": "2.76002000"
                    },
                    {
                        "id": 39282,
                        "name": "Ailly-sur-Noye",
                        "latitude": "49.75707000",
                        "longitude": "2.36367000"
                    },
                    {
                        "id": 39283,
                        "name": "Ailly-sur-Somme",
                        "latitude": "49.92886000",
                        "longitude": "2.19615000"
                    },
                    {
                        "id": 39287,
                        "name": "Airaines",
                        "latitude": "49.96826000",
                        "longitude": "1.94266000"
                    },
                    {
                        "id": 39288,
                        "name": "Aire-sur-la-Lys",
                        "latitude": "50.63871000",
                        "longitude": "2.39876000"
                    },
                    {
                        "id": 39292,
                        "name": "Aix-Noulette",
                        "latitude": "50.42568000",
                        "longitude": "2.70554000"
                    },
                    {
                        "id": 39303,
                        "name": "Albert",
                        "latitude": "50.00091000",
                        "longitude": "2.65096000"
                    },
                    {
                        "id": 39324,
                        "name": "Allennes-les-Marais",
                        "latitude": "50.53754000",
                        "longitude": "2.95361000"
                    },
                    {
                        "id": 39329,
                        "name": "Allonne",
                        "latitude": "49.40863000",
                        "longitude": "2.11427000"
                    },
                    {
                        "id": 39332,
                        "name": "Allouagne",
                        "latitude": "50.53167000",
                        "longitude": "2.51194000"
                    },
                    {
                        "id": 39352,
                        "name": "Amblainville",
                        "latitude": "49.20443000",
                        "longitude": "2.12242000"
                    },
                    {
                        "id": 39353,
                        "name": "Ambleny",
                        "latitude": "49.38079000",
                        "longitude": "3.18447000"
                    },
                    {
                        "id": 39354,
                        "name": "Ambleteuse",
                        "latitude": "50.80729000",
                        "longitude": "1.60388000"
                    },
                    {
                        "id": 39364,
                        "name": "Amiens",
                        "latitude": "49.90000000",
                        "longitude": "2.30000000"
                    },
                    {
                        "id": 39381,
                        "name": "Andeville",
                        "latitude": "49.26078000",
                        "longitude": "2.16427000"
                    },
                    {
                        "id": 39387,
                        "name": "Andres",
                        "latitude": "50.86556000",
                        "longitude": "1.92094000"
                    },
                    {
                        "id": 39401,
                        "name": "Angicourt",
                        "latitude": "49.31175000",
                        "longitude": "2.50419000"
                    },
                    {
                        "id": 39406,
                        "name": "Angres",
                        "latitude": "50.40572000",
                        "longitude": "2.76054000"
                    },
                    {
                        "id": 39408,
                        "name": "Angy",
                        "latitude": "49.32975000",
                        "longitude": "2.32854000"
                    },
                    {
                        "id": 39409,
                        "name": "Anhiers",
                        "latitude": "50.40737000",
                        "longitude": "3.15512000"
                    },
                    {
                        "id": 39411,
                        "name": "Aniche",
                        "latitude": "50.32995000",
                        "longitude": "3.25346000"
                    },
                    {
                        "id": 39412,
                        "name": "Anizy-le-Château",
                        "latitude": "49.50678000",
                        "longitude": "3.45119000"
                    },
                    {
                        "id": 39413,
                        "name": "Annay",
                        "latitude": "50.46303000",
                        "longitude": "2.88122000"
                    },
                    {
                        "id": 39417,
                        "name": "Annequin",
                        "latitude": "50.50525000",
                        "longitude": "2.72019000"
                    },
                    {
                        "id": 39421,
                        "name": "Annezin",
                        "latitude": "50.53192000",
                        "longitude": "2.61785000"
                    },
                    {
                        "id": 39422,
                        "name": "Annoeullin",
                        "latitude": "50.52925000",
                        "longitude": "2.93180000"
                    },
                    {
                        "id": 39425,
                        "name": "Anor",
                        "latitude": "49.98999000",
                        "longitude": "4.10049000"
                    },
                    {
                        "id": 39427,
                        "name": "Ansauvillers",
                        "latitude": "49.56523000",
                        "longitude": "2.38742000"
                    },
                    {
                        "id": 39430,
                        "name": "Anstaing",
                        "latitude": "50.60473000",
                        "longitude": "3.19079000"
                    },
                    {
                        "id": 39438,
                        "name": "Anzin",
                        "latitude": "50.37201000",
                        "longitude": "3.50387000"
                    },
                    {
                        "id": 39439,
                        "name": "Anzin-Saint-Aubin",
                        "latitude": "50.31313000",
                        "longitude": "2.74732000"
                    },
                    {
                        "id": 39469,
                        "name": "Ardres",
                        "latitude": "50.85786000",
                        "longitude": "1.98168000"
                    },
                    {
                        "id": 39490,
                        "name": "Arleux",
                        "latitude": "50.28037000",
                        "longitude": "3.10448000"
                    },
                    {
                        "id": 39491,
                        "name": "Armbouts-Cappel",
                        "latitude": "50.97682000",
                        "longitude": "2.35352000"
                    },
                    {
                        "id": 39493,
                        "name": "Armentières",
                        "latitude": "50.68568000",
                        "longitude": "2.88214000"
                    },
                    {
                        "id": 39504,
                        "name": "Arnèke",
                        "latitude": "50.83219000",
                        "longitude": "2.40943000"
                    },
                    {
                        "id": 39508,
                        "name": "Arques",
                        "latitude": "50.73375000",
                        "longitude": "2.30237000"
                    },
                    {
                        "id": 39511,
                        "name": "Arras",
                        "latitude": "50.29301000",
                        "longitude": "2.78186000"
                    },
                    {
                        "id": 39530,
                        "name": "Artres",
                        "latitude": "50.29482000",
                        "longitude": "3.54013000"
                    },
                    {
                        "id": 39556,
                        "name": "Athies-sous-Laon",
                        "latitude": "49.57369000",
                        "longitude": "3.68417000"
                    },
                    {
                        "id": 39561,
                        "name": "Attiches",
                        "latitude": "50.52220000",
                        "longitude": "3.06222000"
                    },
                    {
                        "id": 39562,
                        "name": "Attichy",
                        "latitude": "49.41121000",
                        "longitude": "3.04949000"
                    },
                    {
                        "id": 39570,
                        "name": "Auberchicourt",
                        "latitude": "50.33333000",
                        "longitude": "3.23333000"
                    },
                    {
                        "id": 39573,
                        "name": "Aubers",
                        "latitude": "50.59543000",
                        "longitude": "2.82666000"
                    },
                    {
                        "id": 39580,
                        "name": "Aubigny-au-Bac",
                        "latitude": "50.26370000",
                        "longitude": "3.16448000"
                    },
                    {
                        "id": 39581,
                        "name": "Aubigny-en-Artois",
                        "latitude": "50.35000000",
                        "longitude": "2.58333000"
                    },
                    {
                        "id": 39588,
                        "name": "Aubry-du-Hainaut",
                        "latitude": "50.36667000",
                        "longitude": "3.46667000"
                    },
                    {
                        "id": 39590,
                        "name": "Auby",
                        "latitude": "50.41457000",
                        "longitude": "3.05396000"
                    },
                    {
                        "id": 39593,
                        "name": "Auchel",
                        "latitude": "50.50345000",
                        "longitude": "2.47346000"
                    },
                    {
                        "id": 39595,
                        "name": "Auchy-lès-Hesdin",
                        "latitude": "50.40114000",
                        "longitude": "2.10145000"
                    },
                    {
                        "id": 39594,
                        "name": "Auchy-les-Mines",
                        "latitude": "50.51349000",
                        "longitude": "2.78283000"
                    },
                    {
                        "id": 39599,
                        "name": "Audruicq",
                        "latitude": "50.87795000",
                        "longitude": "2.07975000"
                    },
                    {
                        "id": 39611,
                        "name": "Aulnois-sous-Laon",
                        "latitude": "49.61429000",
                        "longitude": "3.60547000"
                    },
                    {
                        "id": 39612,
                        "name": "Aulnoy-lez-Valenciennes",
                        "latitude": "50.33333000",
                        "longitude": "3.53333000"
                    },
                    {
                        "id": 39613,
                        "name": "Aulnoye-Aymeries",
                        "latitude": "50.20141000",
                        "longitude": "3.83844000"
                    },
                    {
                        "id": 39614,
                        "name": "Ault",
                        "latitude": "50.10404000",
                        "longitude": "1.45000000"
                    },
                    {
                        "id": 39621,
                        "name": "Auneuil",
                        "latitude": "49.37026000",
                        "longitude": "1.99712000"
                    },
                    {
                        "id": 39645,
                        "name": "Auxi-le-Château",
                        "latitude": "50.23101000",
                        "longitude": "2.11593000"
                    },
                    {
                        "id": 39661,
                        "name": "Avelin",
                        "latitude": "50.53968000",
                        "longitude": "3.08222000"
                    },
                    {
                        "id": 39664,
                        "name": "Avesnelles",
                        "latitude": "50.11782000",
                        "longitude": "3.94674000"
                    },
                    {
                        "id": 39665,
                        "name": "Avesnes-le-Comte",
                        "latitude": "50.27767000",
                        "longitude": "2.52957000"
                    },
                    {
                        "id": 39666,
                        "name": "Avesnes-le-Sec",
                        "latitude": "50.25100000",
                        "longitude": "3.37768000"
                    },
                    {
                        "id": 39667,
                        "name": "Avesnes-les-Aubert",
                        "latitude": "50.20000000",
                        "longitude": "3.38333000"
                    },
                    {
                        "id": 39671,
                        "name": "Avilly-Saint-Léonard",
                        "latitude": "49.19449000",
                        "longitude": "2.54148000"
                    },
                    {
                        "id": 39672,
                        "name": "Avion",
                        "latitude": "50.41038000",
                        "longitude": "2.83053000"
                    },
                    {
                        "id": 39679,
                        "name": "Avrechy",
                        "latitude": "49.44796000",
                        "longitude": "2.42710000"
                    },
                    {
                        "id": 39700,
                        "name": "Bachant",
                        "latitude": "50.21540000",
                        "longitude": "3.86835000"
                    },
                    {
                        "id": 39701,
                        "name": "Bachy",
                        "latitude": "50.55079000",
                        "longitude": "3.25976000"
                    },
                    {
                        "id": 39725,
                        "name": "Bailleul",
                        "latitude": "50.73592000",
                        "longitude": "2.73594000"
                    },
                    {
                        "id": 39726,
                        "name": "Bailleul-Sir-Berthoult",
                        "latitude": "50.33752000",
                        "longitude": "2.85129000"
                    },
                    {
                        "id": 39727,
                        "name": "Bailleul-sur-Thérain",
                        "latitude": "49.38526000",
                        "longitude": "2.22279000"
                    },
                    {
                        "id": 39728,
                        "name": "Bailleval",
                        "latitude": "49.34605000",
                        "longitude": "2.45695000"
                    },
                    {
                        "id": 39733,
                        "name": "Baincthun",
                        "latitude": "50.70994000",
                        "longitude": "1.68075000"
                    },
                    {
                        "id": 39740,
                        "name": "Baisieux",
                        "latitude": "50.60841000",
                        "longitude": "3.25251000"
                    },
                    {
                        "id": 39742,
                        "name": "Balagny-sur-Thérain",
                        "latitude": "49.29605000",
                        "longitude": "2.33645000"
                    },
                    {
                        "id": 39764,
                        "name": "Bapaume",
                        "latitude": "50.10379000",
                        "longitude": "2.84966000"
                    },
                    {
                        "id": 39787,
                        "name": "Barlin",
                        "latitude": "50.45238000",
                        "longitude": "2.61955000"
                    },
                    {
                        "id": 39816,
                        "name": "Bauvin",
                        "latitude": "50.51714000",
                        "longitude": "2.89404000"
                    },
                    {
                        "id": 39818,
                        "name": "Bavay",
                        "latitude": "50.29828000",
                        "longitude": "3.79372000"
                    },
                    {
                        "id": 39837,
                        "name": "Beaucamps-le-Vieux",
                        "latitude": "49.84642000",
                        "longitude": "1.78272000"
                    },
                    {
                        "id": 39839,
                        "name": "Beauchamps",
                        "latitude": "50.01202000",
                        "longitude": "1.51764000"
                    },
                    {
                        "id": 39858,
                        "name": "Beaumetz-lès-Loges",
                        "latitude": "50.23897000",
                        "longitude": "2.65818000"
                    },
                    {
                        "id": 39879,
                        "name": "Beauquesne",
                        "latitude": "50.08526000",
                        "longitude": "2.39276000"
                    },
                    {
                        "id": 39880,
                        "name": "Beaurains",
                        "latitude": "50.26599000",
                        "longitude": "2.79467000"
                    },
                    {
                        "id": 39881,
                        "name": "Beaurainville",
                        "latitude": "50.42432000",
                        "longitude": "1.89938000"
                    },
                    {
                        "id": 39884,
                        "name": "Beaurevoir",
                        "latitude": "49.99714000",
                        "longitude": "3.30855000"
                    },
                    {
                        "id": 39888,
                        "name": "Beautor",
                        "latitude": "49.65214000",
                        "longitude": "3.34475000"
                    },
                    {
                        "id": 39889,
                        "name": "Beauvais",
                        "latitude": "49.43333000",
                        "longitude": "2.08333000"
                    },
                    {
                        "id": 39890,
                        "name": "Beauval",
                        "latitude": "50.10789000",
                        "longitude": "2.33269000"
                    },
                    {
                        "id": 39895,
                        "name": "Beauvois-en-Cambrésis",
                        "latitude": "50.13735000",
                        "longitude": "3.37870000"
                    },
                    {
                        "id": 39908,
                        "name": "Bellaing",
                        "latitude": "50.36811000",
                        "longitude": "3.42515000"
                    },
                    {
                        "id": 39920,
                        "name": "Belleu",
                        "latitude": "49.35917000",
                        "longitude": "3.33556000"
                    },
                    {
                        "id": 39943,
                        "name": "Berck",
                        "latitude": "50.40000000",
                        "longitude": "1.60000000"
                    },
                    {
                        "id": 39944,
                        "name": "Berck-Plage",
                        "latitude": "50.40704000",
                        "longitude": "1.56446000"
                    },
                    {
                        "id": 39948,
                        "name": "Bergues",
                        "latitude": "50.96882000",
                        "longitude": "2.43242000"
                    },
                    {
                        "id": 39949,
                        "name": "Berlaimont",
                        "latitude": "50.20155000",
                        "longitude": "3.81343000"
                    },
                    {
                        "id": 39951,
                        "name": "Bernaville",
                        "latitude": "50.13232000",
                        "longitude": "2.16300000"
                    },
                    {
                        "id": 39966,
                        "name": "Bersée",
                        "latitude": "50.47978000",
                        "longitude": "3.14765000"
                    },
                    {
                        "id": 39967,
                        "name": "Berteaucourt-les-Dames",
                        "latitude": "50.04697000",
                        "longitude": "2.15750000"
                    },
                    {
                        "id": 39968,
                        "name": "Berthecourt",
                        "latitude": "49.35097000",
                        "longitude": "2.22471000"
                    },
                    {
                        "id": 39970,
                        "name": "Bertry",
                        "latitude": "50.08718000",
                        "longitude": "3.44298000"
                    },
                    {
                        "id": 40430,
                        "name": "Béthencourt-sur-Mer",
                        "latitude": "50.07756000",
                        "longitude": "1.50348000"
                    },
                    {
                        "id": 40432,
                        "name": "Béthisy-Saint-Martin",
                        "latitude": "49.29480000",
                        "longitude": "2.81743000"
                    },
                    {
                        "id": 40433,
                        "name": "Béthisy-Saint-Pierre",
                        "latitude": "49.30482000",
                        "longitude": "2.79636000"
                    },
                    {
                        "id": 40434,
                        "name": "Béthune",
                        "latitude": "50.52965000",
                        "longitude": "2.64003000"
                    },
                    {
                        "id": 39988,
                        "name": "Betz",
                        "latitude": "49.15558000",
                        "longitude": "2.95584000"
                    },
                    {
                        "id": 39992,
                        "name": "Beuvrages",
                        "latitude": "50.38414000",
                        "longitude": "3.49420000"
                    },
                    {
                        "id": 39993,
                        "name": "Beuvry",
                        "latitude": "50.51674000",
                        "longitude": "2.68541000"
                    },
                    {
                        "id": 40004,
                        "name": "Biache-Saint-Vaast",
                        "latitude": "50.30869000",
                        "longitude": "2.94777000"
                    },
                    {
                        "id": 40012,
                        "name": "Bierne",
                        "latitude": "50.96232000",
                        "longitude": "2.40963000"
                    },
                    {
                        "id": 40022,
                        "name": "Billy-Berclau",
                        "latitude": "50.51783000",
                        "longitude": "2.86613000"
                    },
                    {
                        "id": 40023,
                        "name": "Billy-Montigny",
                        "latitude": "50.41711000",
                        "longitude": "2.90286000"
                    },
                    {
                        "id": 40024,
                        "name": "Billy-sur-Aisne",
                        "latitude": "49.35632000",
                        "longitude": "3.38357000"
                    },
                    {
                        "id": 40047,
                        "name": "Blaincourt-lès-Précy",
                        "latitude": "49.23333000",
                        "longitude": "2.35000000"
                    },
                    {
                        "id": 40058,
                        "name": "Blaringhem",
                        "latitude": "50.69110000",
                        "longitude": "2.40321000"
                    },
                    {
                        "id": 40064,
                        "name": "Blendecques",
                        "latitude": "50.71843000",
                        "longitude": "2.28601000"
                    },
                    {
                        "id": 40075,
                        "name": "Blérancourt",
                        "latitude": "49.51667000",
                        "longitude": "3.15000000"
                    },
                    {
                        "id": 40080,
                        "name": "Boeschepe",
                        "latitude": "50.80000000",
                        "longitude": "2.70000000"
                    },
                    {
                        "id": 40081,
                        "name": "Bohain-en-Vermandois",
                        "latitude": "49.98730000",
                        "longitude": "3.45300000"
                    },
                    {
                        "id": 40085,
                        "name": "Bois-Grenier",
                        "latitude": "50.64985000",
                        "longitude": "2.87409000"
                    },
                    {
                        "id": 40103,
                        "name": "Bollezeele",
                        "latitude": "50.86687000",
                        "longitude": "2.34751000"
                    },
                    {
                        "id": 40112,
                        "name": "Bondues",
                        "latitude": "50.70196000",
                        "longitude": "3.09497000"
                    },
                    {
                        "id": 40135,
                        "name": "Boran-sur-Oise",
                        "latitude": "49.16715000",
                        "longitude": "2.35803000"
                    },
                    {
                        "id": 40142,
                        "name": "Bornel",
                        "latitude": "49.19820000",
                        "longitude": "2.20912000"
                    },
                    {
                        "id": 40151,
                        "name": "Bouchain",
                        "latitude": "50.28519000",
                        "longitude": "3.31491000"
                    },
                    {
                        "id": 40238,
                        "name": "Boué",
                        "latitude": "50.01141000",
                        "longitude": "3.69608000"
                    },
                    {
                        "id": 40174,
                        "name": "Boulogne-sur-Mer",
                        "latitude": "50.72571000",
                        "longitude": "1.61392000"
                    },
                    {
                        "id": 40181,
                        "name": "Bourbourg",
                        "latitude": "50.94783000",
                        "longitude": "2.19576000"
                    },
                    {
                        "id": 40200,
                        "name": "Bourghelles",
                        "latitude": "50.56501000",
                        "longitude": "3.24447000"
                    },
                    {
                        "id": 40208,
                        "name": "Bourlon",
                        "latitude": "50.17692000",
                        "longitude": "3.11425000"
                    },
                    {
                        "id": 40214,
                        "name": "Bousbecque",
                        "latitude": "50.77123000",
                        "longitude": "3.08459000"
                    },
                    {
                        "id": 40215,
                        "name": "Bousies",
                        "latitude": "50.15097000",
                        "longitude": "3.61752000"
                    },
                    {
                        "id": 40220,
                        "name": "Boussois",
                        "latitude": "50.28907000",
                        "longitude": "4.04117000"
                    },
                    {
                        "id": 40225,
                        "name": "Bouttencourt",
                        "latitude": "49.93725000",
                        "longitude": "1.63431000"
                    },
                    {
                        "id": 40227,
                        "name": "Bouvignies",
                        "latitude": "50.43627000",
                        "longitude": "3.24361000"
                    },
                    {
                        "id": 40228,
                        "name": "Bouvigny-Boyeffles",
                        "latitude": "50.42146000",
                        "longitude": "2.67209000"
                    },
                    {
                        "id": 40239,
                        "name": "Boves",
                        "latitude": "49.84645000",
                        "longitude": "2.39605000"
                    },
                    {
                        "id": 40249,
                        "name": "Braine",
                        "latitude": "49.34261000",
                        "longitude": "3.53262000"
                    },
                    {
                        "id": 40259,
                        "name": "Brasles",
                        "latitude": "49.04810000",
                        "longitude": "3.43000000"
                    },
                    {
                        "id": 40266,
                        "name": "Bray-Dunes",
                        "latitude": "51.07786000",
                        "longitude": "2.51673000"
                    },
                    {
                        "id": 40269,
                        "name": "Bray-sur-Somme",
                        "latitude": "49.94085000",
                        "longitude": "2.71847000"
                    },
                    {
                        "id": 40271,
                        "name": "Brebières",
                        "latitude": "50.33333000",
                        "longitude": "3.01667000"
                    },
                    {
                        "id": 40365,
                        "name": "Brêmes",
                        "latitude": "50.85483000",
                        "longitude": "1.97687000"
                    },
                    {
                        "id": 40274,
                        "name": "Brenouille",
                        "latitude": "49.30551000",
                        "longitude": "2.54437000"
                    },
                    {
                        "id": 40276,
                        "name": "Bresles",
                        "latitude": "49.41044000",
                        "longitude": "2.25024000"
                    },
                    {
                        "id": 40283,
                        "name": "Breteuil",
                        "latitude": "49.63357000",
                        "longitude": "2.29509000"
                    },
                    {
                        "id": 40293,
                        "name": "Breuil-le-Sec",
                        "latitude": "49.37135000",
                        "longitude": "2.45084000"
                    },
                    {
                        "id": 40294,
                        "name": "Breuil-le-Vert",
                        "latitude": "49.36176000",
                        "longitude": "2.43633000"
                    },
                    {
                        "id": 40336,
                        "name": "Brouckerque",
                        "latitude": "50.95476000",
                        "longitude": "2.29378000"
                    },
                    {
                        "id": 40338,
                        "name": "Bruay-la-Buissière",
                        "latitude": "50.48333000",
                        "longitude": "2.55000000"
                    },
                    {
                        "id": 40339,
                        "name": "Bruay-sur-l’Escaut",
                        "latitude": "50.39918000",
                        "longitude": "3.54379000"
                    },
                    {
                        "id": 40344,
                        "name": "Bruille-lez-Marchiennes",
                        "latitude": "50.36068000",
                        "longitude": "3.24424000"
                    },
                    {
                        "id": 40343,
                        "name": "Bruille-Saint-Amand",
                        "latitude": "50.46605000",
                        "longitude": "3.50013000"
                    },
                    {
                        "id": 40349,
                        "name": "Bruyères-et-Montbérault",
                        "latitude": "49.52535000",
                        "longitude": "3.66369000"
                    },
                    {
                        "id": 40372,
                        "name": "Bucquoy",
                        "latitude": "50.13973000",
                        "longitude": "2.71036000"
                    },
                    {
                        "id": 40373,
                        "name": "Bucy-le-Long",
                        "latitude": "49.39072000",
                        "longitude": "3.39582000"
                    },
                    {
                        "id": 40378,
                        "name": "Buironfosse",
                        "latitude": "49.96659000",
                        "longitude": "3.83587000"
                    },
                    {
                        "id": 40384,
                        "name": "Bully-les-Mines",
                        "latitude": "50.44380000",
                        "longitude": "2.72703000"
                    },
                    {
                        "id": 40385,
                        "name": "Burbure",
                        "latitude": "50.53663000",
                        "longitude": "2.46897000"
                    },
                    {
                        "id": 40392,
                        "name": "Bury",
                        "latitude": "49.31307000",
                        "longitude": "2.34401000"
                    },
                    {
                        "id": 40393,
                        "name": "Busigny",
                        "latitude": "50.03424000",
                        "longitude": "3.46713000"
                    },
                    {
                        "id": 40394,
                        "name": "Busnes",
                        "latitude": "50.58781000",
                        "longitude": "2.51827000"
                    },
                    {
                        "id": 40630,
                        "name": "Caëstre",
                        "latitude": "50.75838000",
                        "longitude": "2.60274000"
                    },
                    {
                        "id": 40460,
                        "name": "Cagny",
                        "latitude": "49.86217000",
                        "longitude": "2.34266000"
                    },
                    {
                        "id": 40469,
                        "name": "Calais",
                        "latitude": "50.95194000",
                        "longitude": "1.85635000"
                    },
                    {
                        "id": 40475,
                        "name": "Calonne-Ricouart",
                        "latitude": "50.48504000",
                        "longitude": "2.47335000"
                    },
                    {
                        "id": 40476,
                        "name": "Calonne-sur-la-Lys",
                        "latitude": "50.62292000",
                        "longitude": "2.61664000"
                    },
                    {
                        "id": 40486,
                        "name": "Camblain-Châtelain",
                        "latitude": "50.48355000",
                        "longitude": "2.45521000"
                    },
                    {
                        "id": 40489,
                        "name": "Cambrai",
                        "latitude": "50.17596000",
                        "longitude": "3.23472000"
                    },
                    {
                        "id": 40491,
                        "name": "Cambronne-lès-Clermont",
                        "latitude": "49.33022000",
                        "longitude": "2.39928000"
                    },
                    {
                        "id": 40492,
                        "name": "Cambronne-lès-Ribécourt",
                        "latitude": "49.50711000",
                        "longitude": "2.89797000"
                    },
                    {
                        "id": 40493,
                        "name": "Camiers",
                        "latitude": "50.57153000",
                        "longitude": "1.61325000"
                    },
                    {
                        "id": 40494,
                        "name": "Camon",
                        "latitude": "49.88764000",
                        "longitude": "2.34486000"
                    },
                    {
                        "id": 40496,
                        "name": "Campagne-lès-Hesdin",
                        "latitude": "50.39724000",
                        "longitude": "1.87494000"
                    },
                    {
                        "id": 40499,
                        "name": "Camphin-en-Carembault",
                        "latitude": "50.51196000",
                        "longitude": "2.98710000"
                    },
                    {
                        "id": 40500,
                        "name": "Camphin-en-Pévèle",
                        "latitude": "50.59561000",
                        "longitude": "3.26082000"
                    },
                    {
                        "id": 40521,
                        "name": "Cantin",
                        "latitude": "50.30885000",
                        "longitude": "3.12765000"
                    },
                    {
                        "id": 40529,
                        "name": "Capinghem",
                        "latitude": "50.64551000",
                        "longitude": "2.96193000"
                    },
                    {
                        "id": 40530,
                        "name": "Cappelle-en-Pévèle",
                        "latitude": "50.51011000",
                        "longitude": "3.17133000"
                    },
                    {
                        "id": 40531,
                        "name": "Cappelle-la-Grande",
                        "latitude": "50.99979000",
                        "longitude": "2.35848000"
                    },
                    {
                        "id": 40547,
                        "name": "Carlepont",
                        "latitude": "49.51438000",
                        "longitude": "3.02327000"
                    },
                    {
                        "id": 40566,
                        "name": "Cartignies",
                        "latitude": "50.09290000",
                        "longitude": "3.84473000"
                    },
                    {
                        "id": 40567,
                        "name": "Carvin",
                        "latitude": "50.49235000",
                        "longitude": "2.95815000"
                    },
                    {
                        "id": 40569,
                        "name": "Cassel",
                        "latitude": "50.80109000",
                        "longitude": "2.48527000"
                    },
                    {
                        "id": 40598,
                        "name": "Catenoy",
                        "latitude": "49.36824000",
                        "longitude": "2.51054000"
                    },
                    {
                        "id": 40600,
                        "name": "Cauchy-à-la-Tour",
                        "latitude": "50.50394000",
                        "longitude": "2.44606000"
                    },
                    {
                        "id": 40604,
                        "name": "Caudry",
                        "latitude": "50.12490000",
                        "longitude": "3.41186000"
                    },
                    {
                        "id": 40605,
                        "name": "Cauffry",
                        "latitude": "49.31978000",
                        "longitude": "2.44581000"
                    },
                    {
                        "id": 40614,
                        "name": "Cauvigny",
                        "latitude": "49.30180000",
                        "longitude": "2.24844000"
                    },
                    {
                        "id": 40622,
                        "name": "Cayeux-sur-Mer",
                        "latitude": "50.18200000",
                        "longitude": "1.49400000"
                    },
                    {
                        "id": 40702,
                        "name": "Chamant",
                        "latitude": "49.21990000",
                        "longitude": "2.61176000"
                    },
                    {
                        "id": 40706,
                        "name": "Chambly",
                        "latitude": "49.16667000",
                        "longitude": "2.25000000"
                    },
                    {
                        "id": 40775,
                        "name": "Chantilly",
                        "latitude": "49.19461000",
                        "longitude": "2.47124000"
                    },
                    {
                        "id": 40805,
                        "name": "Charly-sur-Marne",
                        "latitude": "48.97749000",
                        "longitude": "3.28464000"
                    },
                    {
                        "id": 40807,
                        "name": "Charmes",
                        "latitude": "49.65345000",
                        "longitude": "3.37857000"
                    },
                    {
                        "id": 40946,
                        "name": "Château-Thierry",
                        "latitude": "49.04636000",
                        "longitude": "3.40304000"
                    },
                    {
                        "id": 40841,
                        "name": "Chaulnes",
                        "latitude": "49.81699000",
                        "longitude": "2.80064000"
                    },
                    {
                        "id": 40844,
                        "name": "Chaumont-en-Vexin",
                        "latitude": "49.26595000",
                        "longitude": "1.88597000"
                    },
                    {
                        "id": 40849,
                        "name": "Chauny",
                        "latitude": "49.61514000",
                        "longitude": "3.21857000"
                    },
                    {
                        "id": 41012,
                        "name": "Chépy",
                        "latitude": "50.06361000",
                        "longitude": "1.64694000"
                    },
                    {
                        "id": 41015,
                        "name": "Chéreng",
                        "latitude": "50.61059000",
                        "longitude": "3.20666000"
                    },
                    {
                        "id": 40902,
                        "name": "Chevrières",
                        "latitude": "49.34645000",
                        "longitude": "2.68219000"
                    },
                    {
                        "id": 41017,
                        "name": "Chézy-sur-Marne",
                        "latitude": "48.98881000",
                        "longitude": "3.36786000"
                    },
                    {
                        "id": 40906,
                        "name": "Chierry",
                        "latitude": "49.03940000",
                        "longitude": "3.42976000"
                    },
                    {
                        "id": 40915,
                        "name": "Chiry-Ourscamp",
                        "latitude": "49.54378000",
                        "longitude": "2.94721000"
                    },
                    {
                        "id": 40918,
                        "name": "Chocques",
                        "latitude": "50.54084000",
                        "longitude": "2.57193000"
                    },
                    {
                        "id": 40921,
                        "name": "Choisy-au-Bac",
                        "latitude": "49.43777000",
                        "longitude": "2.87739000"
                    },
                    {
                        "id": 41022,
                        "name": "Cinqueux",
                        "latitude": "49.31739000",
                        "longitude": "2.52997000"
                    },
                    {
                        "id": 41025,
                        "name": "Cires-lès-Mello",
                        "latitude": "49.27242000",
                        "longitude": "2.35840000"
                    },
                    {
                        "id": 41036,
                        "name": "Clairoix",
                        "latitude": "49.44264000",
                        "longitude": "2.84628000"
                    },
                    {
                        "id": 41044,
                        "name": "Clary",
                        "latitude": "50.07789000",
                        "longitude": "3.39943000"
                    },
                    {
                        "id": 41047,
                        "name": "Clermont",
                        "latitude": "49.37897000",
                        "longitude": "2.41258000"
                    },
                    {
                        "id": 41085,
                        "name": "Coincy",
                        "latitude": "49.16036000",
                        "longitude": "3.42202000"
                    },
                    {
                        "id": 41089,
                        "name": "Colleret",
                        "latitude": "50.25693000",
                        "longitude": "4.08083000"
                    },
                    {
                        "id": 41116,
                        "name": "Comines",
                        "latitude": "50.76150000",
                        "longitude": "3.01063000"
                    },
                    {
                        "id": 41124,
                        "name": "Compiègne",
                        "latitude": "49.41794000",
                        "longitude": "2.82606000"
                    },
                    {
                        "id": 41141,
                        "name": "Condé-sur-l’Escaut",
                        "latitude": "50.45436000",
                        "longitude": "3.58884000"
                    },
                    {
                        "id": 41132,
                        "name": "Condette",
                        "latitude": "50.65817000",
                        "longitude": "1.63386000"
                    },
                    {
                        "id": 41158,
                        "name": "Conty",
                        "latitude": "49.74100000",
                        "longitude": "2.15120000"
                    },
                    {
                        "id": 41159,
                        "name": "Coquelles",
                        "latitude": "50.93461000",
                        "longitude": "1.79880000"
                    },
                    {
                        "id": 41163,
                        "name": "Corbehem",
                        "latitude": "50.33141000",
                        "longitude": "3.04995000"
                    },
                    {
                        "id": 41168,
                        "name": "Corbie",
                        "latitude": "49.90672000",
                        "longitude": "2.50682000"
                    },
                    {
                        "id": 41218,
                        "name": "Coucy-le-Château-Auffrique",
                        "latitude": "49.52083000",
                        "longitude": "3.32381000"
                    },
                    {
                        "id": 41219,
                        "name": "Coudekerque-Branche",
                        "latitude": "51.02288000",
                        "longitude": "2.39359000"
                    },
                    {
                        "id": 41220,
                        "name": "Coudekerque-Village",
                        "latitude": "51.00000000",
                        "longitude": "2.41667000"
                    },
                    {
                        "id": 41222,
                        "name": "Coudun",
                        "latitude": "49.46146000",
                        "longitude": "2.81248000"
                    },
                    {
                        "id": 41232,
                        "name": "Coulogne",
                        "latitude": "50.92463000",
                        "longitude": "1.88137000"
                    },
                    {
                        "id": 41243,
                        "name": "Courcelles-lès-Lens",
                        "latitude": "50.41667000",
                        "longitude": "3.01667000"
                    },
                    {
                        "id": 41246,
                        "name": "Courchelettes",
                        "latitude": "50.34043000",
                        "longitude": "3.05938000"
                    },
                    {
                        "id": 41254,
                        "name": "Courmelles",
                        "latitude": "49.34595000",
                        "longitude": "3.31215000"
                    },
                    {
                        "id": 41260,
                        "name": "Courrières",
                        "latitude": "50.45701000",
                        "longitude": "2.94725000"
                    },
                    {
                        "id": 41276,
                        "name": "Cousolre",
                        "latitude": "50.24607000",
                        "longitude": "4.14941000"
                    },
                    {
                        "id": 41281,
                        "name": "Coutiches",
                        "latitude": "50.45520000",
                        "longitude": "3.20384000"
                    },
                    {
                        "id": 41284,
                        "name": "Couvron-et-Aumencourt",
                        "latitude": "49.64476000",
                        "longitude": "3.51857000"
                    },
                    {
                        "id": 41289,
                        "name": "Coye-la-Forêt",
                        "latitude": "49.14233000",
                        "longitude": "2.47038000"
                    },
                    {
                        "id": 41341,
                        "name": "Crécy-en-Ponthieu",
                        "latitude": "50.25193000",
                        "longitude": "1.88085000"
                    },
                    {
                        "id": 41342,
                        "name": "Crécy-sur-Serre",
                        "latitude": "49.69594000",
                        "longitude": "3.62453000"
                    },
                    {
                        "id": 41302,
                        "name": "Creil",
                        "latitude": "49.25672000",
                        "longitude": "2.48477000"
                    },
                    {
                        "id": 41349,
                        "name": "Crépy",
                        "latitude": "49.60000000",
                        "longitude": "3.51667000"
                    },
                    {
                        "id": 41350,
                        "name": "Crépy-en-Valois",
                        "latitude": "49.23359000",
                        "longitude": "2.88807000"
                    },
                    {
                        "id": 41306,
                        "name": "Crespin",
                        "latitude": "50.42110000",
                        "longitude": "3.66137000"
                    },
                    {
                        "id": 41339,
                        "name": "Crèvecœur-le-Grand",
                        "latitude": "49.60000000",
                        "longitude": "2.08333000"
                    },
                    {
                        "id": 41352,
                        "name": "Crézancy",
                        "latitude": "49.04833000",
                        "longitude": "3.51047000"
                    },
                    {
                        "id": 41320,
                        "name": "Crisolles",
                        "latitude": "49.62250000",
                        "longitude": "3.01451000"
                    },
                    {
                        "id": 41322,
                        "name": "Croisilles",
                        "latitude": "50.19978000",
                        "longitude": "2.87935000"
                    },
                    {
                        "id": 41325,
                        "name": "Croix",
                        "latitude": "50.67846000",
                        "longitude": "3.14930000"
                    },
                    {
                        "id": 41331,
                        "name": "Crouy",
                        "latitude": "49.40274000",
                        "longitude": "3.35834000"
                    },
                    {
                        "id": 41332,
                        "name": "Crouy-en-Thelle",
                        "latitude": "49.21487000",
                        "longitude": "2.32146000"
                    },
                    {
                        "id": 41357,
                        "name": "Cucq",
                        "latitude": "50.47733000",
                        "longitude": "1.62018000"
                    },
                    {
                        "id": 41360,
                        "name": "Cuffies",
                        "latitude": "49.40358000",
                        "longitude": "3.32119000"
                    },
                    {
                        "id": 41365,
                        "name": "Cuinchy",
                        "latitude": "50.51750000",
                        "longitude": "2.74880000"
                    },
                    {
                        "id": 41366,
                        "name": "Cuincy",
                        "latitude": "50.37933000",
                        "longitude": "3.05301000"
                    },
                    {
                        "id": 41367,
                        "name": "Cuise-la-Motte",
                        "latitude": "49.38642000",
                        "longitude": "3.00588000"
                    },
                    {
                        "id": 41375,
                        "name": "Curgies",
                        "latitude": "50.32975000",
                        "longitude": "3.60299000"
                    },
                    {
                        "id": 41388,
                        "name": "Cysoing",
                        "latitude": "50.56939000",
                        "longitude": "3.21627000"
                    },
                    {
                        "id": 41405,
                        "name": "Dainville",
                        "latitude": "50.28097000",
                        "longitude": "2.72603000"
                    },
                    {
                        "id": 41430,
                        "name": "Dannes",
                        "latitude": "50.58799000",
                        "longitude": "1.61381000"
                    },
                    {
                        "id": 41433,
                        "name": "Dargnies",
                        "latitude": "50.04144000",
                        "longitude": "1.52526000"
                    },
                    {
                        "id": 41446,
                        "name": "Dechy",
                        "latitude": "50.35000000",
                        "longitude": "3.11667000"
                    },
                    {
                        "id": 41450,
                        "name": "Denain",
                        "latitude": "50.32930000",
                        "longitude": "3.39430000"
                    },
                    {
                        "id": 41609,
                        "name": "Département de l'Aisne",
                        "latitude": "49.50000000",
                        "longitude": "3.50000000"
                    },
                    {
                        "id": 41621,
                        "name": "Département de l'Oise",
                        "latitude": "49.50000000",
                        "longitude": "2.50000000"
                    },
                    {
                        "id": 41457,
                        "name": "Desvres",
                        "latitude": "50.66884000",
                        "longitude": "1.83478000"
                    },
                    {
                        "id": 41463,
                        "name": "Deûlémont",
                        "latitude": "50.73333000",
                        "longitude": "2.95000000"
                    },
                    {
                        "id": 41496,
                        "name": "Divion",
                        "latitude": "50.47169000",
                        "longitude": "2.50546000"
                    },
                    {
                        "id": 41502,
                        "name": "Doingt",
                        "latitude": "49.92113000",
                        "longitude": "2.96766000"
                    },
                    {
                        "id": 41513,
                        "name": "Domart-en-Ponthieu",
                        "latitude": "50.07437000",
                        "longitude": "2.12596000"
                    },
                    {
                        "id": 41528,
                        "name": "Don",
                        "latitude": "50.54912000",
                        "longitude": "2.91817000"
                    },
                    {
                        "id": 41545,
                        "name": "Douai",
                        "latitude": "50.37069000",
                        "longitude": "3.07922000"
                    },
                    {
                        "id": 41549,
                        "name": "Douchy-les-Mines",
                        "latitude": "50.30080000",
                        "longitude": "3.39270000"
                    },
                    {
                        "id": 41553,
                        "name": "Doullens",
                        "latitude": "50.15724000",
                        "longitude": "2.34019000"
                    },
                    {
                        "id": 41555,
                        "name": "Dourges",
                        "latitude": "50.43636000",
                        "longitude": "2.98589000"
                    },
                    {
                        "id": 41560,
                        "name": "Douvrin",
                        "latitude": "50.50916000",
                        "longitude": "2.83053000"
                    },
                    {
                        "id": 41572,
                        "name": "Dreslincourt",
                        "latitude": "49.52809000",
                        "longitude": "2.92699000"
                    },
                    {
                        "id": 41573,
                        "name": "Dreuil-lès-Amiens",
                        "latitude": "49.91483000",
                        "longitude": "2.22893000"
                    },
                    {
                        "id": 41575,
                        "name": "Drocourt",
                        "latitude": "50.39002000",
                        "longitude": "2.92425000"
                    },
                    {
                        "id": 41588,
                        "name": "Duisans",
                        "latitude": "50.30633000",
                        "longitude": "2.68653000"
                    },
                    {
                        "id": 41592,
                        "name": "Dunkerque",
                        "latitude": "51.03297000",
                        "longitude": "2.37700000"
                    },
                    {
                        "id": 41598,
                        "name": "Dury",
                        "latitude": "49.84731000",
                        "longitude": "2.27070000"
                    },
                    {
                        "id": 48037,
                        "name": "Écaillon",
                        "latitude": "50.35034000",
                        "longitude": "3.21664000"
                    },
                    {
                        "id": 48049,
                        "name": "Écourt-Saint-Quentin",
                        "latitude": "50.25226000",
                        "longitude": "3.07331000"
                    },
                    {
                        "id": 41657,
                        "name": "Ecques",
                        "latitude": "50.66998000",
                        "longitude": "2.28633000"
                    },
                    {
                        "id": 48064,
                        "name": "Éleu-dit-Leauwette",
                        "latitude": "50.42147000",
                        "longitude": "2.81079000"
                    },
                    {
                        "id": 48067,
                        "name": "Émerchicourt",
                        "latitude": "50.30786000",
                        "longitude": "3.24537000"
                    },
                    {
                        "id": 41667,
                        "name": "Emmerin",
                        "latitude": "50.59475000",
                        "longitude": "3.00124000"
                    },
                    {
                        "id": 41670,
                        "name": "Englefontaine",
                        "latitude": "50.19091000",
                        "longitude": "3.64401000"
                    },
                    {
                        "id": 41673,
                        "name": "Ennetières-en-Weppes",
                        "latitude": "50.63530000",
                        "longitude": "2.94012000"
                    },
                    {
                        "id": 41674,
                        "name": "Ennevelin",
                        "latitude": "50.54121000",
                        "longitude": "3.12972000"
                    },
                    {
                        "id": 48071,
                        "name": "Épehy",
                        "latitude": "50.00000000",
                        "longitude": "3.13333000"
                    },
                    {
                        "id": 48072,
                        "name": "Éperlecques",
                        "latitude": "50.80566000",
                        "longitude": "2.15207000"
                    },
                    {
                        "id": 41688,
                        "name": "Eppeville",
                        "latitude": "49.74069000",
                        "longitude": "3.05114000"
                    },
                    {
                        "id": 48088,
                        "name": "Équihen-Plage",
                        "latitude": "50.67557000",
                        "longitude": "1.57225000"
                    },
                    {
                        "id": 41691,
                        "name": "Ercuis",
                        "latitude": "49.23465000",
                        "longitude": "2.30407000"
                    },
                    {
                        "id": 41699,
                        "name": "Erquinghem-Lys",
                        "latitude": "50.67601000",
                        "longitude": "2.84505000"
                    },
                    {
                        "id": 41701,
                        "name": "Erre",
                        "latitude": "50.36252000",
                        "longitude": "3.31561000"
                    },
                    {
                        "id": 41706,
                        "name": "Escaudain",
                        "latitude": "50.33315000",
                        "longitude": "3.34430000"
                    },
                    {
                        "id": 41707,
                        "name": "Escaudœuvres",
                        "latitude": "50.20000000",
                        "longitude": "3.26667000"
                    },
                    {
                        "id": 41708,
                        "name": "Escautpont",
                        "latitude": "50.41875000",
                        "longitude": "3.55341000"
                    },
                    {
                        "id": 41712,
                        "name": "Esches",
                        "latitude": "49.22086000",
                        "longitude": "2.16595000"
                    },
                    {
                        "id": 41723,
                        "name": "Esquéhéries",
                        "latitude": "49.98391000",
                        "longitude": "3.74743000"
                    },
                    {
                        "id": 41720,
                        "name": "Esquelbecq",
                        "latitude": "50.88694000",
                        "longitude": "2.43215000"
                    },
                    {
                        "id": 41721,
                        "name": "Esquerdes",
                        "latitude": "50.70414000",
                        "longitude": "2.18851000"
                    },
                    {
                        "id": 41724,
                        "name": "Essars",
                        "latitude": "50.54868000",
                        "longitude": "2.66620000"
                    },
                    {
                        "id": 41727,
                        "name": "Essigny-le-Grand",
                        "latitude": "49.77865000",
                        "longitude": "3.27774000"
                    },
                    {
                        "id": 41728,
                        "name": "Essômes-sur-Marne",
                        "latitude": "49.02881000",
                        "longitude": "3.37571000"
                    },
                    {
                        "id": 41730,
                        "name": "Estaires",
                        "latitude": "50.64574000",
                        "longitude": "2.72782000"
                    },
                    {
                        "id": 41732,
                        "name": "Estevelles",
                        "latitude": "50.47653000",
                        "longitude": "2.90928000"
                    },
                    {
                        "id": 41737,
                        "name": "Estrées",
                        "latitude": "50.30079000",
                        "longitude": "3.06980000"
                    },
                    {
                        "id": 41738,
                        "name": "Estrées-Saint-Denis",
                        "latitude": "49.42602000",
                        "longitude": "2.64293000"
                    },
                    {
                        "id": 48096,
                        "name": "Étampes-sur-Marne",
                        "latitude": "49.03464000",
                        "longitude": "3.41893000"
                    },
                    {
                        "id": 48098,
                        "name": "Étaples",
                        "latitude": "50.52194000",
                        "longitude": "1.63319000"
                    },
                    {
                        "id": 48107,
                        "name": "Étreillers",
                        "latitude": "49.83059000",
                        "longitude": "3.16029000"
                    },
                    {
                        "id": 48111,
                        "name": "Étreux",
                        "latitude": "49.98333000",
                        "longitude": "3.65000000"
                    },
                    {
                        "id": 48119,
                        "name": "Évin-Malmaison",
                        "latitude": "50.43923000",
                        "longitude": "3.03139000"
                    },
                    {
                        "id": 41762,
                        "name": "Faches-Thumesnil",
                        "latitude": "50.58333000",
                        "longitude": "3.06667000"
                    },
                    {
                        "id": 41769,
                        "name": "Famars",
                        "latitude": "50.31743000",
                        "longitude": "3.51945000"
                    },
                    {
                        "id": 41771,
                        "name": "Fampoux",
                        "latitude": "50.30173000",
                        "longitude": "2.87310000"
                    },
                    {
                        "id": 41780,
                        "name": "Faumont",
                        "latitude": "50.46017000",
                        "longitude": "3.13713000"
                    },
                    {
                        "id": 42000,
                        "name": "Féchain",
                        "latitude": "50.26638000",
                        "longitude": "3.21024000"
                    },
                    {
                        "id": 41792,
                        "name": "Feignies",
                        "latitude": "50.29806000",
                        "longitude": "3.91534000"
                    },
                    {
                        "id": 41797,
                        "name": "Fenain",
                        "latitude": "50.36667000",
                        "longitude": "3.30000000"
                    },
                    {
                        "id": 41998,
                        "name": "Fère-en-Tardenois",
                        "latitude": "49.20000000",
                        "longitude": "3.51667000"
                    },
                    {
                        "id": 42005,
                        "name": "Férin",
                        "latitude": "50.32732000",
                        "longitude": "3.07415000"
                    },
                    {
                        "id": 41802,
                        "name": "Ferques",
                        "latitude": "50.83002000",
                        "longitude": "1.75994000"
                    },
                    {
                        "id": 41805,
                        "name": "Ferrière-la-Grande",
                        "latitude": "50.25521000",
                        "longitude": "3.99288000"
                    },
                    {
                        "id": 41809,
                        "name": "Festubert",
                        "latitude": "50.54250000",
                        "longitude": "2.73593000"
                    },
                    {
                        "id": 41811,
                        "name": "Feuchy",
                        "latitude": "50.29439000",
                        "longitude": "2.84335000"
                    },
                    {
                        "id": 41812,
                        "name": "Feuquières",
                        "latitude": "49.64677000",
                        "longitude": "1.84784000"
                    },
                    {
                        "id": 41813,
                        "name": "Feuquières-en-Vimeu",
                        "latitude": "50.05982000",
                        "longitude": "1.60465000"
                    },
                    {
                        "id": 41827,
                        "name": "Fitz-James",
                        "latitude": "49.39113000",
                        "longitude": "2.43070000"
                    },
                    {
                        "id": 41833,
                        "name": "Flavy-le-Martel",
                        "latitude": "49.71299000",
                        "longitude": "3.19150000"
                    },
                    {
                        "id": 41837,
                        "name": "Flers-en-Escrebieux",
                        "latitude": "50.39790000",
                        "longitude": "3.06038000"
                    },
                    {
                        "id": 41838,
                        "name": "Flesselles",
                        "latitude": "50.00202000",
                        "longitude": "2.26119000"
                    },
                    {
                        "id": 41840,
                        "name": "Fleurbaix",
                        "latitude": "50.65061000",
                        "longitude": "2.83305000"
                    },
                    {
                        "id": 41844,
                        "name": "Fleurines",
                        "latitude": "49.25901000",
                        "longitude": "2.58385000"
                    },
                    {
                        "id": 41853,
                        "name": "Flines-lès-Mortagne",
                        "latitude": "50.50281000",
                        "longitude": "3.46495000"
                    },
                    {
                        "id": 41852,
                        "name": "Flines-lez-Raches",
                        "latitude": "50.41667000",
                        "longitude": "3.18333000"
                    },
                    {
                        "id": 41855,
                        "name": "Flixecourt",
                        "latitude": "50.01465000",
                        "longitude": "2.08095000"
                    },
                    {
                        "id": 41868,
                        "name": "Folembray",
                        "latitude": "49.54334000",
                        "longitude": "3.29119000"
                    },
                    {
                        "id": 41878,
                        "name": "Fontaine-au-Pire",
                        "latitude": "50.13250000",
                        "longitude": "3.37667000"
                    },
                    {
                        "id": 41877,
                        "name": "Fontaine-Notre-Dame",
                        "latitude": "50.16681000",
                        "longitude": "3.15812000"
                    },
                    {
                        "id": 41911,
                        "name": "Forest-sur-Marque",
                        "latitude": "50.63341000",
                        "longitude": "3.18939000"
                    },
                    {
                        "id": 41914,
                        "name": "Formerie",
                        "latitude": "49.64928000",
                        "longitude": "1.73106000"
                    },
                    {
                        "id": 41916,
                        "name": "Fort-Mahon-Plage",
                        "latitude": "50.33955000",
                        "longitude": "1.55984000"
                    },
                    {
                        "id": 41917,
                        "name": "Fort-Mardyck",
                        "latitude": "51.02899000",
                        "longitude": "2.30724000"
                    },
                    {
                        "id": 41930,
                        "name": "Fouquereuil",
                        "latitude": "50.51885000",
                        "longitude": "2.60024000"
                    },
                    {
                        "id": 41931,
                        "name": "Fouquières-lès-Béthune",
                        "latitude": "50.51534000",
                        "longitude": "2.60999000"
                    },
                    {
                        "id": 41932,
                        "name": "Fouquières-lès-Lens",
                        "latitude": "50.42842000",
                        "longitude": "2.91321000"
                    },
                    {
                        "id": 41935,
                        "name": "Fourmies",
                        "latitude": "50.01532000",
                        "longitude": "4.04784000"
                    },
                    {
                        "id": 41936,
                        "name": "Fournes-en-Weppes",
                        "latitude": "50.58497000",
                        "longitude": "2.88793000"
                    },
                    {
                        "id": 41955,
                        "name": "Frelinghien",
                        "latitude": "50.71667000",
                        "longitude": "2.93333000"
                    },
                    {
                        "id": 41959,
                        "name": "Fresnes-sur-Escaut",
                        "latitude": "50.43382000",
                        "longitude": "3.57752000"
                    },
                    {
                        "id": 41960,
                        "name": "Fresnoy-le-Grand",
                        "latitude": "49.94757000",
                        "longitude": "3.41841000"
                    },
                    {
                        "id": 41962,
                        "name": "Fressenneville",
                        "latitude": "50.06838000",
                        "longitude": "1.57816000"
                    },
                    {
                        "id": 41988,
                        "name": "Fréthun",
                        "latitude": "50.91729000",
                        "longitude": "1.82505000"
                    },
                    {
                        "id": 41963,
                        "name": "Fretin",
                        "latitude": "50.55745000",
                        "longitude": "3.13668000"
                    },
                    {
                        "id": 41989,
                        "name": "Frévent",
                        "latitude": "50.27608000",
                        "longitude": "2.28725000"
                    },
                    {
                        "id": 41966,
                        "name": "Friville-Escarbotin",
                        "latitude": "50.08602000",
                        "longitude": "1.54560000"
                    },
                    {
                        "id": 41982,
                        "name": "Fruges",
                        "latitude": "50.51501000",
                        "longitude": "2.13292000"
                    },
                    {
                        "id": 42024,
                        "name": "Gamaches",
                        "latitude": "49.98615000",
                        "longitude": "1.55624000"
                    },
                    {
                        "id": 42053,
                        "name": "Gauchy",
                        "latitude": "49.82765000",
                        "longitude": "3.27371000"
                    },
                    {
                        "id": 42063,
                        "name": "Genech",
                        "latitude": "50.53122000",
                        "longitude": "3.21651000"
                    },
                    {
                        "id": 42085,
                        "name": "Ghyvelde",
                        "latitude": "51.05275000",
                        "longitude": "2.52642000"
                    },
                    {
                        "id": 42106,
                        "name": "Givenchy-en-Gohelle",
                        "latitude": "50.39080000",
                        "longitude": "2.77320000"
                    },
                    {
                        "id": 42116,
                        "name": "Godewaersvelde",
                        "latitude": "50.79399000",
                        "longitude": "2.64456000"
                    },
                    {
                        "id": 42303,
                        "name": "Gœulzin",
                        "latitude": "50.31667000",
                        "longitude": "3.10000000"
                    },
                    {
                        "id": 42118,
                        "name": "Goincourt",
                        "latitude": "49.42614000",
                        "longitude": "2.03621000"
                    },
                    {
                        "id": 42122,
                        "name": "Gommegnies",
                        "latitude": "50.27155000",
                        "longitude": "3.70625000"
                    },
                    {
                        "id": 42125,
                        "name": "Gondecourt",
                        "latitude": "50.54469000",
                        "longitude": "2.98378000"
                    },
                    {
                        "id": 42131,
                        "name": "Gonnehem",
                        "latitude": "50.56061000",
                        "longitude": "2.57277000"
                    },
                    {
                        "id": 42140,
                        "name": "Gosnay",
                        "latitude": "50.50622000",
                        "longitude": "2.58904000"
                    },
                    {
                        "id": 42156,
                        "name": "Gouvieux",
                        "latitude": "49.18705000",
                        "longitude": "2.41439000"
                    },
                    {
                        "id": 42158,
                        "name": "Gouy-sous-Bellonne",
                        "latitude": "50.31139000",
                        "longitude": "3.05657000"
                    },
                    {
                        "id": 42159,
                        "name": "Gouzeaucourt",
                        "latitude": "50.05606000",
                        "longitude": "3.12351000"
                    },
                    {
                        "id": 42173,
                        "name": "Grand-Fort-Philippe",
                        "latitude": "50.99961000",
                        "longitude": "2.10784000"
                    },
                    {
                        "id": 42176,
                        "name": "Grande-Synthe",
                        "latitude": "51.01540000",
                        "longitude": "2.29975000"
                    },
                    {
                        "id": 42178,
                        "name": "Grandfresnoy",
                        "latitude": "49.37218000",
                        "longitude": "2.65216000"
                    },
                    {
                        "id": 42181,
                        "name": "Grandvilliers",
                        "latitude": "49.66547000",
                        "longitude": "1.94088000"
                    },
                    {
                        "id": 42189,
                        "name": "Gravelines",
                        "latitude": "50.98651000",
                        "longitude": "2.12807000"
                    },
                    {
                        "id": 42198,
                        "name": "Grenay",
                        "latitude": "50.44962000",
                        "longitude": "2.75168000"
                    },
                    {
                        "id": 42218,
                        "name": "Groffliers",
                        "latitude": "50.38444000",
                        "longitude": "1.61474000"
                    },
                    {
                        "id": 42231,
                        "name": "Gruson",
                        "latitude": "50.59583000",
                        "longitude": "3.20777000"
                    },
                    {
                        "id": 42238,
                        "name": "Guarbecque",
                        "latitude": "50.61162000",
                        "longitude": "2.48895000"
                    },
                    {
                        "id": 42247,
                        "name": "Guesnain",
                        "latitude": "50.35000000",
                        "longitude": "3.15000000"
                    },
                    {
                        "id": 42257,
                        "name": "Guignicourt",
                        "latitude": "49.43714000",
                        "longitude": "3.96755000"
                    },
                    {
                        "id": 42290,
                        "name": "Guînes",
                        "latitude": "50.86708000",
                        "longitude": "1.87025000"
                    },
                    {
                        "id": 42268,
                        "name": "Guiscard",
                        "latitude": "49.65660000",
                        "longitude": "3.05127000"
                    },
                    {
                        "id": 42270,
                        "name": "Guise",
                        "latitude": "49.90055000",
                        "longitude": "3.62801000"
                    },
                    {
                        "id": 42311,
                        "name": "Haillicourt",
                        "latitude": "50.47519000",
                        "longitude": "2.57458000"
                    },
                    {
                        "id": 42312,
                        "name": "Haisnes",
                        "latitude": "50.50776000",
                        "longitude": "2.79416000"
                    },
                    {
                        "id": 42313,
                        "name": "Hallencourt",
                        "latitude": "49.99201000",
                        "longitude": "1.87649000"
                    },
                    {
                        "id": 42314,
                        "name": "Hallennes-lez-Haubourdin",
                        "latitude": "50.61667000",
                        "longitude": "2.96667000"
                    },
                    {
                        "id": 42315,
                        "name": "Hallines",
                        "latitude": "50.71087000",
                        "longitude": "2.22629000"
                    },
                    {
                        "id": 42316,
                        "name": "Halluin",
                        "latitude": "50.78628000",
                        "longitude": "3.12611000"
                    },
                    {
                        "id": 42317,
                        "name": "Ham",
                        "latitude": "49.74721000",
                        "longitude": "3.07301000"
                    },
                    {
                        "id": 42321,
                        "name": "Hames-Boucres",
                        "latitude": "50.88178000",
                        "longitude": "1.84338000"
                    },
                    {
                        "id": 42325,
                        "name": "Harbonnières",
                        "latitude": "49.84958000",
                        "longitude": "2.66812000"
                    },
                    {
                        "id": 42326,
                        "name": "Hardinghen",
                        "latitude": "50.80414000",
                        "longitude": "1.82122000"
                    },
                    {
                        "id": 42330,
                        "name": "Harly",
                        "latitude": "49.83766000",
                        "longitude": "3.31001000"
                    },
                    {
                        "id": 42331,
                        "name": "Harnes",
                        "latitude": "50.44643000",
                        "longitude": "2.90481000"
                    },
                    {
                        "id": 42332,
                        "name": "Hasnon",
                        "latitude": "50.42472000",
                        "longitude": "3.38657000"
                    },
                    {
                        "id": 42334,
                        "name": "Haspres",
                        "latitude": "50.25829000",
                        "longitude": "3.41695000"
                    },
                    {
                        "id": 42336,
                        "name": "Haubourdin",
                        "latitude": "50.60826000",
                        "longitude": "2.99143000"
                    },
                    {
                        "id": 42338,
                        "name": "Haulchin",
                        "latitude": "50.31720000",
                        "longitude": "3.43599000"
                    },
                    {
                        "id": 42339,
                        "name": "Haussy",
                        "latitude": "50.21830000",
                        "longitude": "3.47683000"
                    },
                    {
                        "id": 42354,
                        "name": "Hautmont",
                        "latitude": "50.25077000",
                        "longitude": "3.92143000"
                    },
                    {
                        "id": 42358,
                        "name": "Haveluy",
                        "latitude": "50.35289000",
                        "longitude": "3.40389000"
                    },
                    {
                        "id": 42359,
                        "name": "Haverskerque",
                        "latitude": "50.64089000",
                        "longitude": "2.54162000"
                    },
                    {
                        "id": 42362,
                        "name": "Hazebrouck",
                        "latitude": "50.72374000",
                        "longitude": "2.53729000"
                    },
                    {
                        "id": 42451,
                        "name": "Hélesmes",
                        "latitude": "50.37036000",
                        "longitude": "3.35918000"
                    },
                    {
                        "id": 42365,
                        "name": "Helfaut",
                        "latitude": "50.69783000",
                        "longitude": "2.24234000"
                    },
                    {
                        "id": 42366,
                        "name": "Hem",
                        "latitude": "50.65256000",
                        "longitude": "3.18681000"
                    },
                    {
                        "id": 42453,
                        "name": "Hénin-Beaumont",
                        "latitude": "50.41359000",
                        "longitude": "2.96485000"
                    },
                    {
                        "id": 42376,
                        "name": "Hergnies",
                        "latitude": "50.47287000",
                        "longitude": "3.52612000"
                    },
                    {
                        "id": 42460,
                        "name": "Hérin",
                        "latitude": "50.35557000",
                        "longitude": "3.45309000"
                    },
                    {
                        "id": 42377,
                        "name": "Herlies",
                        "latitude": "50.57753000",
                        "longitude": "2.85285000"
                    },
                    {
                        "id": 42379,
                        "name": "Hermes",
                        "latitude": "49.36032000",
                        "longitude": "2.24461000"
                    },
                    {
                        "id": 42380,
                        "name": "Hermies",
                        "latitude": "50.11126000",
                        "longitude": "3.04202000"
                    },
                    {
                        "id": 42386,
                        "name": "Hersin-Coupigny",
                        "latitude": "50.44796000",
                        "longitude": "2.64940000"
                    },
                    {
                        "id": 42387,
                        "name": "Herzeele",
                        "latitude": "50.88584000",
                        "longitude": "2.53510000"
                    },
                    {
                        "id": 42388,
                        "name": "Hesdin",
                        "latitude": "50.37349000",
                        "longitude": "2.03820000"
                    },
                    {
                        "id": 42392,
                        "name": "Heuringhem",
                        "latitude": "50.69638000",
                        "longitude": "2.28333000"
                    },
                    {
                        "id": 42398,
                        "name": "Hinges",
                        "latitude": "50.56674000",
                        "longitude": "2.62160000"
                    },
                    {
                        "id": 42402,
                        "name": "Hirson",
                        "latitude": "49.92262000",
                        "longitude": "4.08259000"
                    },
                    {
                        "id": 42408,
                        "name": "Holnon",
                        "latitude": "49.86086000",
                        "longitude": "3.21509000"
                    },
                    {
                        "id": 42412,
                        "name": "Hombleux",
                        "latitude": "49.73942000",
                        "longitude": "2.98574000"
                    },
                    {
                        "id": 42413,
                        "name": "Homblières",
                        "latitude": "49.85031000",
                        "longitude": "3.36456000"
                    },
                    {
                        "id": 42416,
                        "name": "Hondschoote",
                        "latitude": "50.97800000",
                        "longitude": "2.58372000"
                    },
                    {
                        "id": 42419,
                        "name": "Hordain",
                        "latitude": "50.26306000",
                        "longitude": "3.31358000"
                    },
                    {
                        "id": 42421,
                        "name": "Hornaing",
                        "latitude": "50.36835000",
                        "longitude": "3.33707000"
                    },
                    {
                        "id": 42422,
                        "name": "Hornoy-le-Bourg",
                        "latitude": "49.85000000",
                        "longitude": "1.90000000"
                    },
                    {
                        "id": 42423,
                        "name": "Houdain",
                        "latitude": "50.45040000",
                        "longitude": "2.53777000"
                    },
                    {
                        "id": 42429,
                        "name": "Houplin-Ancoisne",
                        "latitude": "50.56284000",
                        "longitude": "3.00251000"
                    },
                    {
                        "id": 42430,
                        "name": "Houplines",
                        "latitude": "50.69499000",
                        "longitude": "2.91518000"
                    },
                    {
                        "id": 42434,
                        "name": "Hoymille",
                        "latitude": "50.97187000",
                        "longitude": "2.44738000"
                    },
                    {
                        "id": 42440,
                        "name": "Hulluch",
                        "latitude": "50.48961000",
                        "longitude": "2.81232000"
                    },
                    {
                        "id": 42481,
                        "name": "Illies",
                        "latitude": "50.56144000",
                        "longitude": "2.83011000"
                    },
                    {
                        "id": 42498,
                        "name": "Isbergues",
                        "latitude": "50.62328000",
                        "longitude": "2.45902000"
                    },
                    {
                        "id": 42503,
                        "name": "Isques",
                        "latitude": "50.67391000",
                        "longitude": "1.65445000"
                    },
                    {
                        "id": 42511,
                        "name": "Itancourt",
                        "latitude": "49.80664000",
                        "longitude": "3.34427000"
                    },
                    {
                        "id": 42518,
                        "name": "Iwuy",
                        "latitude": "50.23300000",
                        "longitude": "3.32058000"
                    },
                    {
                        "id": 42543,
                        "name": "Jaux",
                        "latitude": "49.39120000",
                        "longitude": "2.77809000"
                    },
                    {
                        "id": 42549,
                        "name": "Jenlain",
                        "latitude": "50.31164000",
                        "longitude": "3.62872000"
                    },
                    {
                        "id": 42550,
                        "name": "Jeumont",
                        "latitude": "50.29658000",
                        "longitude": "4.10108000"
                    },
                    {
                        "id": 42597,
                        "name": "Jussy",
                        "latitude": "49.71984000",
                        "longitude": "3.23270000"
                    },
                    {
                        "id": 42614,
                        "name": "Killem",
                        "latitude": "50.95779000",
                        "longitude": "2.56068000"
                    },
                    {
                        "id": 42635,
                        "name": "La Bassée",
                        "latitude": "50.53424000",
                        "longitude": "2.80620000"
                    },
                    {
                        "id": 42667,
                        "name": "La Capelle",
                        "latitude": "49.96667000",
                        "longitude": "3.91667000"
                    },
                    {
                        "id": 42668,
                        "name": "La Capelle-lès-Boulogne",
                        "latitude": "50.73302000",
                        "longitude": "1.70147000"
                    },
                    {
                        "id": 42697,
                        "name": "La Chapelle-en-Serval",
                        "latitude": "49.12842000",
                        "longitude": "2.53405000"
                    },
                    {
                        "id": 42719,
                        "name": "La Couture",
                        "latitude": "50.58212000",
                        "longitude": "2.70710000"
                    },
                    {
                        "id": 42759,
                        "name": "La Fère",
                        "latitude": "49.66286000",
                        "longitude": "3.36631000"
                    },
                    {
                        "id": 42741,
                        "name": "La Ferté-Milon",
                        "latitude": "49.17453000",
                        "longitude": "3.12885000"
                    },
                    {
                        "id": 42745,
                        "name": "La Flamengrie",
                        "latitude": "50.00175000",
                        "longitude": "3.92081000"
                    },
                    {
                        "id": 42769,
                        "name": "La Gorgue",
                        "latitude": "50.63790000",
                        "longitude": "2.71502000"
                    },
                    {
                        "id": 42793,
                        "name": "La Longueville",
                        "latitude": "50.28939000",
                        "longitude": "3.85672000"
                    },
                    {
                        "id": 42797,
                        "name": "La Madeleine",
                        "latitude": "50.64603000",
                        "longitude": "3.07585000"
                    },
                    {
                        "id": 42877,
                        "name": "La Sentinelle",
                        "latitude": "50.35115000",
                        "longitude": "3.48425000"
                    },
                    {
                        "id": 42932,
                        "name": "Labeuvrière",
                        "latitude": "50.51915000",
                        "longitude": "2.56268000"
                    },
                    {
                        "id": 42934,
                        "name": "Laboissière-en-Thelle",
                        "latitude": "49.29329000",
                        "longitude": "2.16150000"
                    },
                    {
                        "id": 42936,
                        "name": "Labourse",
                        "latitude": "50.49883000",
                        "longitude": "2.68121000"
                    },
                    {
                        "id": 42945,
                        "name": "Lachapelle-aux-Pots",
                        "latitude": "49.44905000",
                        "longitude": "1.90228000"
                    },
                    {
                        "id": 42948,
                        "name": "Lacroix-Saint-Ouen",
                        "latitude": "49.35685000",
                        "longitude": "2.78803000"
                    },
                    {
                        "id": 42958,
                        "name": "Lagny-le-Sec",
                        "latitude": "49.08744000",
                        "longitude": "2.74502000"
                    },
                    {
                        "id": 42967,
                        "name": "Laigneville",
                        "latitude": "49.29149000",
                        "longitude": "2.44581000"
                    },
                    {
                        "id": 42976,
                        "name": "Lallaing",
                        "latitude": "50.39012000",
                        "longitude": "3.16949000"
                    },
                    {
                        "id": 42986,
                        "name": "Lambersart",
                        "latitude": "50.65000000",
                        "longitude": "3.03333000"
                    },
                    {
                        "id": 42988,
                        "name": "Lambres-lez-Douai",
                        "latitude": "50.35000000",
                        "longitude": "3.06667000"
                    },
                    {
                        "id": 42990,
                        "name": "Lamorlaye",
                        "latitude": "49.16246000",
                        "longitude": "2.44687000"
                    },
                    {
                        "id": 42999,
                        "name": "Landas",
                        "latitude": "50.47269000",
                        "longitude": "3.30367000"
                    },
                    {
                        "id": 43009,
                        "name": "Landrecies",
                        "latitude": "50.12499000",
                        "longitude": "3.69171000"
                    },
                    {
                        "id": 43038,
                        "name": "Lannoy",
                        "latitude": "50.66674000",
                        "longitude": "3.21012000"
                    },
                    {
                        "id": 43057,
                        "name": "Laon",
                        "latitude": "49.56310000",
                        "longitude": "3.62714000"
                    },
                    {
                        "id": 43064,
                        "name": "Lapugnoy",
                        "latitude": "50.51635000",
                        "longitude": "2.53460000"
                    },
                    {
                        "id": 43087,
                        "name": "Lassigny",
                        "latitude": "49.58828000",
                        "longitude": "2.84289000"
                    },
                    {
                        "id": 43105,
                        "name": "Lauwin-Planque",
                        "latitude": "50.39024000",
                        "longitude": "3.04510000"
                    },
                    {
                        "id": 43115,
                        "name": "Laventie",
                        "latitude": "50.62818000",
                        "longitude": "2.77076000"
                    },
                    {
                        "id": 43177,
                        "name": "Le Crotoy",
                        "latitude": "50.21600000",
                        "longitude": "1.62500000"
                    },
                    {
                        "id": 43181,
                        "name": "Le Doulieu",
                        "latitude": "50.68194000",
                        "longitude": "2.71741000"
                    },
                    {
                        "id": 43228,
                        "name": "Le Mesnil-en-Thelle",
                        "latitude": "49.17830000",
                        "longitude": "2.28573000"
                    },
                    {
                        "id": 43232,
                        "name": "Le Meux",
                        "latitude": "49.36718000",
                        "longitude": "2.74374000"
                    },
                    {
                        "id": 43242,
                        "name": "Le Nouvion-en-Thiérache",
                        "latitude": "50.01625000",
                        "longitude": "3.78509000"
                    },
                    {
                        "id": 43263,
                        "name": "Le Plessis-Belleville",
                        "latitude": "49.09501000",
                        "longitude": "2.75614000"
                    },
                    {
                        "id": 43265,
                        "name": "Le Plessis-Brion",
                        "latitude": "49.46419000",
                        "longitude": "2.89096000"
                    },
                    {
                        "id": 43278,
                        "name": "Le Portel",
                        "latitude": "50.70559000",
                        "longitude": "1.57574000"
                    },
                    {
                        "id": 43290,
                        "name": "Le Quesnoy",
                        "latitude": "50.24797000",
                        "longitude": "3.63656000"
                    },
                    {
                        "id": 43321,
                        "name": "Le Touquet-Paris-Plage",
                        "latitude": "50.52432000",
                        "longitude": "1.58571000"
                    },
                    {
                        "id": 43338,
                        "name": "Lecelles",
                        "latitude": "50.46779000",
                        "longitude": "3.40096000"
                    },
                    {
                        "id": 43681,
                        "name": "Lécluse",
                        "latitude": "50.27671000",
                        "longitude": "3.04045000"
                    },
                    {
                        "id": 43341,
                        "name": "Leers",
                        "latitude": "50.68217000",
                        "longitude": "3.24429000"
                    },
                    {
                        "id": 43342,
                        "name": "Leffrinckoucke",
                        "latitude": "51.03457000",
                        "longitude": "2.46452000"
                    },
                    {
                        "id": 43343,
                        "name": "Leforest",
                        "latitude": "50.43866000",
                        "longitude": "3.06480000"
                    },
                    {
                        "id": 43350,
                        "name": "Lens",
                        "latitude": "50.43302000",
                        "longitude": "2.82791000"
                    },
                    {
                        "id": 43357,
                        "name": "Les Ageux",
                        "latitude": "49.31667000",
                        "longitude": "2.60000000"
                    },
                    {
                        "id": 43367,
                        "name": "Les Attaques",
                        "latitude": "50.90962000",
                        "longitude": "1.92961000"
                    },
                    {
                        "id": 43441,
                        "name": "Lesquin",
                        "latitude": "50.58232000",
                        "longitude": "3.11900000"
                    },
                    {
                        "id": 43444,
                        "name": "Lestrem",
                        "latitude": "50.61987000",
                        "longitude": "2.68646000"
                    },
                    {
                        "id": 43448,
                        "name": "Leval",
                        "latitude": "50.18106000",
                        "longitude": "3.83093000"
                    },
                    {
                        "id": 43454,
                        "name": "Lewarde",
                        "latitude": "50.34173000",
                        "longitude": "3.16782000"
                    },
                    {
                        "id": 43460,
                        "name": "Lezennes",
                        "latitude": "50.61553000",
                        "longitude": "3.11354000"
                    },
                    {
                        "id": 43463,
                        "name": "Liancourt",
                        "latitude": "49.33034000",
                        "longitude": "2.46595000"
                    },
                    {
                        "id": 43464,
                        "name": "Libercourt",
                        "latitude": "50.48322000",
                        "longitude": "3.01584000"
                    },
                    {
                        "id": 43466,
                        "name": "Licques",
                        "latitude": "50.78416000",
                        "longitude": "1.93844000"
                    },
                    {
                        "id": 43468,
                        "name": "Liesse-Notre-Dame",
                        "latitude": "49.61667000",
                        "longitude": "3.80000000"
                    },
                    {
                        "id": 43469,
                        "name": "Lieu-Saint-Amand",
                        "latitude": "50.27318000",
                        "longitude": "3.34624000"
                    },
                    {
                        "id": 43525,
                        "name": "Liévin",
                        "latitude": "50.41980000",
                        "longitude": "2.78068000"
                    },
                    {
                        "id": 43478,
                        "name": "Ligny-en-Cambrésis",
                        "latitude": "50.10123000",
                        "longitude": "3.37841000"
                    },
                    {
                        "id": 43485,
                        "name": "Lille",
                        "latitude": "50.63297000",
                        "longitude": "3.05858000"
                    },
                    {
                        "id": 43487,
                        "name": "Lillers",
                        "latitude": "50.56345000",
                        "longitude": "2.48042000"
                    },
                    {
                        "id": 43503,
                        "name": "Linselles",
                        "latitude": "50.73708000",
                        "longitude": "3.07878000"
                    },
                    {
                        "id": 43532,
                        "name": "Locon",
                        "latitude": "50.57029000",
                        "longitude": "2.66629000"
                    },
                    {
                        "id": 43545,
                        "name": "Loison-sous-Lens",
                        "latitude": "50.43796000",
                        "longitude": "2.85322000"
                    },
                    {
                        "id": 43549,
                        "name": "Lomme",
                        "latitude": "50.64358000",
                        "longitude": "2.98715000"
                    },
                    {
                        "id": 43550,
                        "name": "Lompret",
                        "latitude": "50.66931000",
                        "longitude": "2.98968000"
                    },
                    {
                        "id": 43560,
                        "name": "Longfossé",
                        "latitude": "50.65217000",
                        "longitude": "1.80693000"
                    },
                    {
                        "id": 43567,
                        "name": "Longpré-les-Corps-Saints",
                        "latitude": "50.01239000",
                        "longitude": "1.99287000"
                    },
                    {
                        "id": 43568,
                        "name": "Longueau",
                        "latitude": "49.87226000",
                        "longitude": "2.35880000"
                    },
                    {
                        "id": 43569,
                        "name": "Longueil-Annel",
                        "latitude": "49.46908000",
                        "longitude": "2.86464000"
                    },
                    {
                        "id": 43570,
                        "name": "Longueil-Sainte-Marie",
                        "latitude": "49.35723000",
                        "longitude": "2.71844000"
                    },
                    {
                        "id": 43571,
                        "name": "Longuenesse",
                        "latitude": "50.73395000",
                        "longitude": "2.23520000"
                    },
                    {
                        "id": 43578,
                        "name": "Looberghe",
                        "latitude": "50.91694000",
                        "longitude": "2.27439000"
                    },
                    {
                        "id": 43579,
                        "name": "Loon-Plage",
                        "latitude": "50.99647000",
                        "longitude": "2.21770000"
                    },
                    {
                        "id": 43580,
                        "name": "Loos",
                        "latitude": "50.60982000",
                        "longitude": "3.01874000"
                    },
                    {
                        "id": 43581,
                        "name": "Loos-en-Gohelle",
                        "latitude": "50.45786000",
                        "longitude": "2.79215000"
                    },
                    {
                        "id": 43585,
                        "name": "Lorgies",
                        "latitude": "50.56880000",
                        "longitude": "2.79034000"
                    },
                    {
                        "id": 43590,
                        "name": "Lormaison",
                        "latitude": "49.25647000",
                        "longitude": "2.10575000"
                    },
                    {
                        "id": 43607,
                        "name": "Lourches",
                        "latitude": "50.31354000",
                        "longitude": "3.35258000"
                    },
                    {
                        "id": 43619,
                        "name": "Louvroil",
                        "latitude": "50.26427000",
                        "longitude": "3.96272000"
                    },
                    {
                        "id": 43626,
                        "name": "Lozinghem",
                        "latitude": "50.51554000",
                        "longitude": "2.50209000"
                    },
                    {
                        "id": 43647,
                        "name": "Lumbres",
                        "latitude": "50.70693000",
                        "longitude": "2.12081000"
                    },
                    {
                        "id": 43679,
                        "name": "Lys-lez-Lannoy",
                        "latitude": "50.66667000",
                        "longitude": "3.21667000"
                    },
                    {
                        "id": 43732,
                        "name": "Maignelay-Montigny",
                        "latitude": "49.55000000",
                        "longitude": "2.51667000"
                    },
                    {
                        "id": 43738,
                        "name": "Maing",
                        "latitude": "50.30791000",
                        "longitude": "3.48447000"
                    },
                    {
                        "id": 43742,
                        "name": "Maisnil-lès-Ruitz",
                        "latitude": "50.45342000",
                        "longitude": "2.58992000"
                    },
                    {
                        "id": 43769,
                        "name": "Mametz",
                        "latitude": "50.63485000",
                        "longitude": "2.32478000"
                    },
                    {
                        "id": 43800,
                        "name": "Marchiennes",
                        "latitude": "50.40000000",
                        "longitude": "3.28333000"
                    },
                    {
                        "id": 43809,
                        "name": "Marck",
                        "latitude": "50.94897000",
                        "longitude": "1.94328000"
                    },
                    {
                        "id": 43811,
                        "name": "Marcoing",
                        "latitude": "50.12110000",
                        "longitude": "3.17321000"
                    },
                    {
                        "id": 43812,
                        "name": "Marconne",
                        "latitude": "50.37143000",
                        "longitude": "2.04669000"
                    },
                    {
                        "id": 43813,
                        "name": "Marconnelle",
                        "latitude": "50.37588000",
                        "longitude": "2.01108000"
                    },
                    {
                        "id": 43816,
                        "name": "Marcq-en-Barœul",
                        "latitude": "50.66667000",
                        "longitude": "3.08333000"
                    },
                    {
                        "id": 43824,
                        "name": "Maretz",
                        "latitude": "50.04530000",
                        "longitude": "3.41808000"
                    },
                    {
                        "id": 43831,
                        "name": "Mareuil-sur-Ourcq",
                        "latitude": "49.13752000",
                        "longitude": "3.07822000"
                    },
                    {
                        "id": 43835,
                        "name": "Margny-lès-Compiègne",
                        "latitude": "49.42559000",
                        "longitude": "2.81806000"
                    },
                    {
                        "id": 43848,
                        "name": "Marle",
                        "latitude": "49.74006000",
                        "longitude": "3.77060000"
                    },
                    {
                        "id": 43851,
                        "name": "Marles-les-Mines",
                        "latitude": "50.50478000",
                        "longitude": "2.50882000"
                    },
                    {
                        "id": 43853,
                        "name": "Marly",
                        "latitude": "50.34556000",
                        "longitude": "3.54959000"
                    },
                    {
                        "id": 43927,
                        "name": "Marœuil",
                        "latitude": "50.32519000",
                        "longitude": "2.70504000"
                    },
                    {
                        "id": 43865,
                        "name": "Maroilles",
                        "latitude": "50.13508000",
                        "longitude": "3.76132000"
                    },
                    {
                        "id": 43870,
                        "name": "Marpent",
                        "latitude": "50.29252000",
                        "longitude": "4.07936000"
                    },
                    {
                        "id": 43872,
                        "name": "Marquette-en-Ostrevant",
                        "latitude": "50.28333000",
                        "longitude": "3.26667000"
                    },
                    {
                        "id": 43873,
                        "name": "Marquette-lez-Lille",
                        "latitude": "50.67628000",
                        "longitude": "3.06613000"
                    },
                    {
                        "id": 43874,
                        "name": "Marquillies",
                        "latitude": "50.55577000",
                        "longitude": "2.87067000"
                    },
                    {
                        "id": 43875,
                        "name": "Marquion",
                        "latitude": "50.21126000",
                        "longitude": "3.08719000"
                    },
                    {
                        "id": 43876,
                        "name": "Marquise",
                        "latitude": "50.81294000",
                        "longitude": "1.70786000"
                    },
                    {
                        "id": 43929,
                        "name": "Masnières",
                        "latitude": "50.11489000",
                        "longitude": "3.20889000"
                    },
                    {
                        "id": 43930,
                        "name": "Masny",
                        "latitude": "50.34797000",
                        "longitude": "3.20165000"
                    },
                    {
                        "id": 43945,
                        "name": "Maubeuge",
                        "latitude": "50.27875000",
                        "longitude": "3.97267000"
                    },
                    {
                        "id": 43975,
                        "name": "Mazingarbe",
                        "latitude": "50.47109000",
                        "longitude": "2.71544000"
                    },
                    {
                        "id": 44455,
                        "name": "Méaulte",
                        "latitude": "49.98167000",
                        "longitude": "2.66121000"
                    },
                    {
                        "id": 44471,
                        "name": "Méricourt",
                        "latitude": "50.40116000",
                        "longitude": "2.86246000"
                    },
                    {
                        "id": 44474,
                        "name": "Mérignies",
                        "latitude": "50.50609000",
                        "longitude": "3.11043000"
                    },
                    {
                        "id": 44017,
                        "name": "Merlimont",
                        "latitude": "50.45590000",
                        "longitude": "1.61315000"
                    },
                    {
                        "id": 44018,
                        "name": "Mers-les-Bains",
                        "latitude": "50.06538000",
                        "longitude": "1.38810000"
                    },
                    {
                        "id": 44476,
                        "name": "Méru",
                        "latitude": "49.23333000",
                        "longitude": "2.13333000"
                    },
                    {
                        "id": 44023,
                        "name": "Merville",
                        "latitude": "50.64329000",
                        "longitude": "2.64125000"
                    },
                    {
                        "id": 44484,
                        "name": "Méteren",
                        "latitude": "50.73333000",
                        "longitude": "2.70000000"
                    },
                    {
                        "id": 44048,
                        "name": "Meurchin",
                        "latitude": "50.49831000",
                        "longitude": "2.89318000"
                    },
                    {
                        "id": 44077,
                        "name": "Milly-sur-Thérain",
                        "latitude": "49.50240000",
                        "longitude": "1.99605000"
                    },
                    {
                        "id": 44110,
                        "name": "Mogneville",
                        "latitude": "49.31535000",
                        "longitude": "2.47170000"
                    },
                    {
                        "id": 44117,
                        "name": "Moislains",
                        "latitude": "49.98820000",
                        "longitude": "2.96404000"
                    },
                    {
                        "id": 44129,
                        "name": "Monchecourt",
                        "latitude": "50.30413000",
                        "longitude": "3.21029000"
                    },
                    {
                        "id": 44130,
                        "name": "Monchy-Saint-Éloi",
                        "latitude": "49.29042000",
                        "longitude": "2.46739000"
                    },
                    {
                        "id": 44148,
                        "name": "Mons-en-Barœul",
                        "latitude": "50.63333000",
                        "longitude": "3.11667000"
                    },
                    {
                        "id": 44149,
                        "name": "Mons-en-Pévèle",
                        "latitude": "50.47926000",
                        "longitude": "3.09767000"
                    },
                    {
                        "id": 44154,
                        "name": "Mont-Bernanchon",
                        "latitude": "50.58333000",
                        "longitude": "2.58333000"
                    },
                    {
                        "id": 44158,
                        "name": "Mont-Saint-Éloi",
                        "latitude": "50.35105000",
                        "longitude": "2.69249000"
                    },
                    {
                        "id": 44182,
                        "name": "Montataire",
                        "latitude": "49.25900000",
                        "longitude": "2.43777000"
                    },
                    {
                        "id": 44209,
                        "name": "Montcornet",
                        "latitude": "49.69526000",
                        "longitude": "4.01667000"
                    },
                    {
                        "id": 44214,
                        "name": "Montdidier",
                        "latitude": "49.64800000",
                        "longitude": "2.56991000"
                    },
                    {
                        "id": 44225,
                        "name": "Montescourt-Lizerolles",
                        "latitude": "49.73828000",
                        "longitude": "3.25736000"
                    },
                    {
                        "id": 44258,
                        "name": "Montigny-en-Gohelle",
                        "latitude": "50.42540000",
                        "longitude": "2.93902000"
                    },
                    {
                        "id": 44259,
                        "name": "Montigny-en-Ostrevent",
                        "latitude": "50.36667000",
                        "longitude": "3.18333000"
                    },
                    {
                        "id": 44278,
                        "name": "Montmacq",
                        "latitude": "49.48181000",
                        "longitude": "2.90257000"
                    },
                    {
                        "id": 44308,
                        "name": "Montreuil",
                        "latitude": "50.46374000",
                        "longitude": "1.76348000"
                    },
                    {
                        "id": 44310,
                        "name": "Montreuil-aux-Lions",
                        "latitude": "49.02124000",
                        "longitude": "3.19543000"
                    },
                    {
                        "id": 44343,
                        "name": "Morbecque",
                        "latitude": "50.69365000",
                        "longitude": "2.51787000"
                    },
                    {
                        "id": 44350,
                        "name": "Moreuil",
                        "latitude": "49.77457000",
                        "longitude": "2.48273000"
                    },
                    {
                        "id": 44353,
                        "name": "Morienval",
                        "latitude": "49.29770000",
                        "longitude": "2.92078000"
                    },
                    {
                        "id": 44369,
                        "name": "Mortagne-du-Nord",
                        "latitude": "50.50352000",
                        "longitude": "3.45352000"
                    },
                    {
                        "id": 44384,
                        "name": "Mouchin",
                        "latitude": "50.51639000",
                        "longitude": "3.29627000"
                    },
                    {
                        "id": 44414,
                        "name": "Mouvaux",
                        "latitude": "50.69944000",
                        "longitude": "3.13429000"
                    },
                    {
                        "id": 44416,
                        "name": "Mouy",
                        "latitude": "49.31535000",
                        "longitude": "2.31954000"
                    },
                    {
                        "id": 44509,
                        "name": "Nanteuil-le-Haudouin",
                        "latitude": "49.14082000",
                        "longitude": "2.81142000"
                    },
                    {
                        "id": 44513,
                        "name": "Naours",
                        "latitude": "50.03682000",
                        "longitude": "2.27691000"
                    },
                    {
                        "id": 44532,
                        "name": "Nesle",
                        "latitude": "49.75888000",
                        "longitude": "2.91133000"
                    },
                    {
                        "id": 44533,
                        "name": "Nesles",
                        "latitude": "50.62588000",
                        "longitude": "1.65641000"
                    },
                    {
                        "id": 44534,
                        "name": "Nesles-la-Montagne",
                        "latitude": "49.01964000",
                        "longitude": "3.42607000"
                    },
                    {
                        "id": 44537,
                        "name": "Neuf-Berquin",
                        "latitude": "50.66065000",
                        "longitude": "2.67213000"
                    },
                    {
                        "id": 44541,
                        "name": "Neufchâtel-Hardelot",
                        "latitude": "50.62018000",
                        "longitude": "1.64223000"
                    },
                    {
                        "id": 44548,
                        "name": "Neuilly-en-Thelle",
                        "latitude": "49.22445000",
                        "longitude": "2.28525000"
                    },
                    {
                        "id": 44547,
                        "name": "Neuilly-Saint-Front",
                        "latitude": "49.17012000",
                        "longitude": "3.26393000"
                    },
                    {
                        "id": 44551,
                        "name": "Neuilly-sous-Clermont",
                        "latitude": "49.34437000",
                        "longitude": "2.41030000"
                    },
                    {
                        "id": 44567,
                        "name": "Neuville-en-Ferrain",
                        "latitude": "50.74839000",
                        "longitude": "3.15676000"
                    },
                    {
                        "id": 44563,
                        "name": "Neuville-Saint-Rémy",
                        "latitude": "50.18618000",
                        "longitude": "3.22404000"
                    },
                    {
                        "id": 44564,
                        "name": "Neuville-Saint-Vaast",
                        "latitude": "50.35756000",
                        "longitude": "2.76261000"
                    },
                    {
                        "id": 44570,
                        "name": "Neuville-sur-Escaut",
                        "latitude": "50.30000000",
                        "longitude": "3.35000000"
                    },
                    {
                        "id": 44594,
                        "name": "Nieppe",
                        "latitude": "50.70425000",
                        "longitude": "2.83506000"
                    },
                    {
                        "id": 44607,
                        "name": "Noailles",
                        "latitude": "49.32866000",
                        "longitude": "2.20024000"
                    },
                    {
                        "id": 44701,
                        "name": "Nœux-les-Mines",
                        "latitude": "50.48333000",
                        "longitude": "2.66667000"
                    },
                    {
                        "id": 44614,
                        "name": "Nogent-l’Artaud",
                        "latitude": "48.96560000",
                        "longitude": "3.32178000"
                    },
                    {
                        "id": 44616,
                        "name": "Nogent-sur-Oise",
                        "latitude": "49.27158000",
                        "longitude": "2.47074000"
                    },
                    {
                        "id": 44619,
                        "name": "Nogentel",
                        "latitude": "49.01750000",
                        "longitude": "3.40250000"
                    },
                    {
                        "id": 44634,
                        "name": "Nomain",
                        "latitude": "50.49857000",
                        "longitude": "3.24991000"
                    },
                    {
                        "id": 44640,
                        "name": "Nord",
                        "latitude": "50.33333000",
                        "longitude": "3.36197000"
                    },
                    {
                        "id": 44643,
                        "name": "Norrent-Fontes",
                        "latitude": "50.58333000",
                        "longitude": "2.40000000"
                    },
                    {
                        "id": 44646,
                        "name": "Nortkerque",
                        "latitude": "50.87519000",
                        "longitude": "2.02464000"
                    },
                    {
                        "id": 44660,
                        "name": "Nouvion",
                        "latitude": "50.20000000",
                        "longitude": "1.78333000"
                    },
                    {
                        "id": 44675,
                        "name": "Noyelles-Godault",
                        "latitude": "50.41753000",
                        "longitude": "2.99306000"
                    },
                    {
                        "id": 44676,
                        "name": "Noyelles-lès-Vermelles",
                        "latitude": "50.49001000",
                        "longitude": "2.72628000"
                    },
                    {
                        "id": 44677,
                        "name": "Noyelles-sous-Lens",
                        "latitude": "50.43084000",
                        "longitude": "2.87221000"
                    },
                    {
                        "id": 44680,
                        "name": "Noyon",
                        "latitude": "49.58333000",
                        "longitude": "3.00000000"
                    },
                    {
                        "id": 44722,
                        "name": "Ognes",
                        "latitude": "49.61244000",
                        "longitude": "3.19340000"
                    },
                    {
                        "id": 44724,
                        "name": "Oignies",
                        "latitude": "50.46331000",
                        "longitude": "2.99376000"
                    },
                    {
                        "id": 44726,
                        "name": "Oisemont",
                        "latitude": "49.95587000",
                        "longitude": "1.76703000"
                    },
                    {
                        "id": 44730,
                        "name": "Oisy-le-Verger",
                        "latitude": "50.25047000",
                        "longitude": "3.12330000"
                    },
                    {
                        "id": 44740,
                        "name": "Omissy",
                        "latitude": "49.87760000",
                        "longitude": "3.31235000"
                    },
                    {
                        "id": 44744,
                        "name": "Onnaing",
                        "latitude": "50.38584000",
                        "longitude": "3.59963000"
                    },
                    {
                        "id": 44745,
                        "name": "Ons-en-Bray",
                        "latitude": "49.41631000",
                        "longitude": "1.92302000"
                    },
                    {
                        "id": 44759,
                        "name": "Orchies",
                        "latitude": "50.46667000",
                        "longitude": "3.23333000"
                    },
                    {
                        "id": 44769,
                        "name": "Origny-en-Thiérache",
                        "latitude": "49.89327000",
                        "longitude": "4.01644000"
                    },
                    {
                        "id": 44768,
                        "name": "Origny-Sainte-Benoite",
                        "latitude": "49.83333000",
                        "longitude": "3.50000000"
                    },
                    {
                        "id": 44782,
                        "name": "Orry-la-Ville",
                        "latitude": "49.13345000",
                        "longitude": "2.51139000"
                    },
                    {
                        "id": 44794,
                        "name": "Ostricourt",
                        "latitude": "50.45145000",
                        "longitude": "3.03417000"
                    },
                    {
                        "id": 44813,
                        "name": "Outreau",
                        "latitude": "50.70535000",
                        "longitude": "1.58970000"
                    },
                    {
                        "id": 44818,
                        "name": "Oye-Plage",
                        "latitude": "50.97713000",
                        "longitude": "2.04276000"
                    },
                    {
                        "id": 44862,
                        "name": "Pas-de-Calais",
                        "latitude": "50.48280000",
                        "longitude": "2.28664000"
                    },
                    {
                        "id": 44864,
                        "name": "Pasly",
                        "latitude": "49.40167000",
                        "longitude": "3.29631000"
                    },
                    {
                        "id": 44880,
                        "name": "Pecquencourt",
                        "latitude": "50.37850000",
                        "longitude": "3.21277000"
                    },
                    {
                        "id": 44891,
                        "name": "Pendé",
                        "latitude": "50.16055000",
                        "longitude": "1.58541000"
                    },
                    {
                        "id": 45350,
                        "name": "Pérenchies",
                        "latitude": "50.67013000",
                        "longitude": "2.97024000"
                    },
                    {
                        "id": 44897,
                        "name": "Pernes",
                        "latitude": "50.48437000",
                        "longitude": "2.41253000"
                    },
                    {
                        "id": 45363,
                        "name": "Péronne",
                        "latitude": "49.93218000",
                        "longitude": "2.93630000"
                    },
                    {
                        "id": 45365,
                        "name": "Péroy-les-Gombries",
                        "latitude": "49.16248000",
                        "longitude": "2.84556000"
                    },
                    {
                        "id": 44919,
                        "name": "Petite-Forêt",
                        "latitude": "50.36667000",
                        "longitude": "3.48333000"
                    },
                    {
                        "id": 44942,
                        "name": "Phalempin",
                        "latitude": "50.51691000",
                        "longitude": "3.01584000"
                    },
                    {
                        "id": 44947,
                        "name": "Picquigny",
                        "latitude": "49.94413000",
                        "longitude": "2.14376000"
                    },
                    {
                        "id": 44956,
                        "name": "Pierrefonds",
                        "latitude": "49.34878000",
                        "longitude": "2.97790000"
                    },
                    {
                        "id": 44972,
                        "name": "Pinon",
                        "latitude": "49.48916000",
                        "longitude": "3.44703000"
                    },
                    {
                        "id": 44988,
                        "name": "Plailly",
                        "latitude": "49.10288000",
                        "longitude": "2.58549000"
                    },
                    {
                        "id": 45139,
                        "name": "Poix-de-Picardie",
                        "latitude": "49.78333000",
                        "longitude": "1.98333000"
                    },
                    {
                        "id": 45140,
                        "name": "Poix-du-Nord",
                        "latitude": "50.18927000",
                        "longitude": "3.60956000"
                    },
                    {
                        "id": 45160,
                        "name": "Ponchon",
                        "latitude": "49.34652000",
                        "longitude": "2.19677000"
                    },
                    {
                        "id": 45196,
                        "name": "Pont-à-Marcq",
                        "latitude": "50.52213000",
                        "longitude": "3.11441000"
                    },
                    {
                        "id": 45198,
                        "name": "Pont-à-Vendin",
                        "latitude": "50.47358000",
                        "longitude": "2.88884000"
                    },
                    {
                        "id": 45180,
                        "name": "Pont-de-Metz",
                        "latitude": "49.87820000",
                        "longitude": "2.24266000"
                    },
                    {
                        "id": 45168,
                        "name": "Pont-Remy",
                        "latitude": "50.05000000",
                        "longitude": "1.91667000"
                    },
                    {
                        "id": 45174,
                        "name": "Pont-Sainte-Maxence",
                        "latitude": "49.30168000",
                        "longitude": "2.60467000"
                    },
                    {
                        "id": 45192,
                        "name": "Pont-sur-Sambre",
                        "latitude": "50.22195000",
                        "longitude": "3.84693000"
                    },
                    {
                        "id": 45216,
                        "name": "Pontpoint",
                        "latitude": "49.30000000",
                        "longitude": "2.65000000"
                    },
                    {
                        "id": 45258,
                        "name": "Poulainville",
                        "latitude": "49.94745000",
                        "longitude": "2.31373000"
                    },
                    {
                        "id": 45307,
                        "name": "Précy-sur-Oise",
                        "latitude": "49.20779000",
                        "longitude": "2.37266000"
                    },
                    {
                        "id": 45310,
                        "name": "Prémesques",
                        "latitude": "50.65572000",
                        "longitude": "2.95162000"
                    },
                    {
                        "id": 45312,
                        "name": "Préseau",
                        "latitude": "50.31122000",
                        "longitude": "3.57434000"
                    },
                    {
                        "id": 45295,
                        "name": "Prouvy",
                        "latitude": "50.31793000",
                        "longitude": "3.45096000"
                    },
                    {
                        "id": 45296,
                        "name": "Proville",
                        "latitude": "50.16137000",
                        "longitude": "3.20629000"
                    },
                    {
                        "id": 45297,
                        "name": "Provin",
                        "latitude": "50.51430000",
                        "longitude": "2.90794000"
                    },
                    {
                        "id": 45371,
                        "name": "Quaëdypre",
                        "latitude": "50.93527000",
                        "longitude": "2.45445000"
                    },
                    {
                        "id": 45370,
                        "name": "Quarouble",
                        "latitude": "50.38634000",
                        "longitude": "3.62306000"
                    },
                    {
                        "id": 45374,
                        "name": "Quend",
                        "latitude": "50.31584000",
                        "longitude": "1.63609000"
                    },
                    {
                        "id": 45377,
                        "name": "Quesnoy-sur-Deûle",
                        "latitude": "50.71359000",
                        "longitude": "2.99996000"
                    },
                    {
                        "id": 45383,
                        "name": "Quevauvillers",
                        "latitude": "49.82376000",
                        "longitude": "2.08431000"
                    },
                    {
                        "id": 45404,
                        "name": "Quiévrechain",
                        "latitude": "50.39172000",
                        "longitude": "3.66815000"
                    },
                    {
                        "id": 45405,
                        "name": "Quiévy",
                        "latitude": "50.16804000",
                        "longitude": "3.42834000"
                    },
                    {
                        "id": 45682,
                        "name": "Râches",
                        "latitude": "50.41706000",
                        "longitude": "3.13635000"
                    },
                    {
                        "id": 45413,
                        "name": "Racquinghem",
                        "latitude": "50.69245000",
                        "longitude": "2.35736000"
                    },
                    {
                        "id": 45414,
                        "name": "Radinghem-en-Weppes",
                        "latitude": "50.61884000",
                        "longitude": "2.90924000"
                    },
                    {
                        "id": 45418,
                        "name": "Raillencourt-Sainte-Olle",
                        "latitude": "50.18333000",
                        "longitude": "3.16667000"
                    },
                    {
                        "id": 45419,
                        "name": "Raimbeaucourt",
                        "latitude": "50.43466000",
                        "longitude": "3.09333000"
                    },
                    {
                        "id": 45420,
                        "name": "Raismes",
                        "latitude": "50.38333000",
                        "longitude": "3.48333000"
                    },
                    {
                        "id": 45426,
                        "name": "Ranchicourt",
                        "latitude": "50.43559000",
                        "longitude": "2.55690000"
                    },
                    {
                        "id": 45428,
                        "name": "Rang-du-Fliers",
                        "latitude": "50.41708000",
                        "longitude": "1.64431000"
                    },
                    {
                        "id": 45430,
                        "name": "Rantigny",
                        "latitude": "49.32758000",
                        "longitude": "2.44244000"
                    },
                    {
                        "id": 45434,
                        "name": "Ravenel",
                        "latitude": "49.51523000",
                        "longitude": "2.50192000"
                    },
                    {
                        "id": 45441,
                        "name": "Recquignies",
                        "latitude": "50.28396000",
                        "longitude": "4.03722000"
                    },
                    {
                        "id": 45455,
                        "name": "Remy",
                        "latitude": "49.43333000",
                        "longitude": "2.71667000"
                    },
                    {
                        "id": 45459,
                        "name": "Renescure",
                        "latitude": "50.72754000",
                        "longitude": "2.36801000"
                    },
                    {
                        "id": 45464,
                        "name": "Ressons-sur-Matz",
                        "latitude": "49.53858000",
                        "longitude": "2.74416000"
                    },
                    {
                        "id": 45471,
                        "name": "Rety",
                        "latitude": "50.80000000",
                        "longitude": "1.76667000"
                    },
                    {
                        "id": 45479,
                        "name": "Rexpoëde",
                        "latitude": "50.93926000",
                        "longitude": "2.53914000"
                    },
                    {
                        "id": 45491,
                        "name": "Ribemont",
                        "latitude": "49.79540000",
                        "longitude": "3.45893000"
                    },
                    {
                        "id": 45494,
                        "name": "Richebourg",
                        "latitude": "50.58333000",
                        "longitude": "2.73333000"
                    },
                    {
                        "id": 45495,
                        "name": "Richebourg-l'Avoué",
                        "latitude": "50.56999000",
                        "longitude": "2.74884000"
                    },
                    {
                        "id": 45501,
                        "name": "Rieulay",
                        "latitude": "50.37856000",
                        "longitude": "3.25284000"
                    },
                    {
                        "id": 45505,
                        "name": "Rieux",
                        "latitude": "49.30000000",
                        "longitude": "2.51667000"
                    },
                    {
                        "id": 45508,
                        "name": "Rieux-en-Cambrésis",
                        "latitude": "50.20069000",
                        "longitude": "3.35232000"
                    },
                    {
                        "id": 45515,
                        "name": "Rinxent",
                        "latitude": "50.80714000",
                        "longitude": "1.72899000"
                    },
                    {
                        "id": 45528,
                        "name": "Rivery",
                        "latitude": "49.90328000",
                        "longitude": "2.32235000"
                    },
                    {
                        "id": 45531,
                        "name": "Rivière",
                        "latitude": "50.23316000",
                        "longitude": "2.69200000"
                    },
                    {
                        "id": 45536,
                        "name": "Robecq",
                        "latitude": "50.59608000",
                        "longitude": "2.56262000"
                    },
                    {
                        "id": 45697,
                        "name": "Rœulx",
                        "latitude": "50.30000000",
                        "longitude": "3.33333000"
                    },
                    {
                        "id": 45698,
                        "name": "Rœux",
                        "latitude": "50.29526000",
                        "longitude": "2.90073000"
                    },
                    {
                        "id": 45564,
                        "name": "Roisel",
                        "latitude": "49.94768000",
                        "longitude": "3.09973000"
                    },
                    {
                        "id": 45585,
                        "name": "Ronchin",
                        "latitude": "50.59883000",
                        "longitude": "3.09056000"
                    },
                    {
                        "id": 45586,
                        "name": "Roncq",
                        "latitude": "50.75330000",
                        "longitude": "3.12131000"
                    },
                    {
                        "id": 45587,
                        "name": "Roost-Warendin",
                        "latitude": "50.41920000",
                        "longitude": "3.10374000"
                    },
                    {
                        "id": 45595,
                        "name": "Roquetoire",
                        "latitude": "50.67029000",
                        "longitude": "2.34307000"
                    },
                    {
                        "id": 45604,
                        "name": "Rosières-en-Santerre",
                        "latitude": "49.81433000",
                        "longitude": "2.70095000"
                    },
                    {
                        "id": 45612,
                        "name": "Rosult",
                        "latitude": "50.45888000",
                        "longitude": "3.35902000"
                    },
                    {
                        "id": 45616,
                        "name": "Roubaix",
                        "latitude": "50.69421000",
                        "longitude": "3.17456000"
                    },
                    {
                        "id": 45635,
                        "name": "Rousies",
                        "latitude": "50.27346000",
                        "longitude": "4.00382000"
                    },
                    {
                        "id": 45642,
                        "name": "Rouvroy",
                        "latitude": "50.39247000",
                        "longitude": "2.90396000"
                    },
                    {
                        "id": 45648,
                        "name": "Roye",
                        "latitude": "49.70038000",
                        "longitude": "2.78959000"
                    },
                    {
                        "id": 45654,
                        "name": "Rozoy-sur-Serre",
                        "latitude": "49.70956000",
                        "longitude": "4.12902000"
                    },
                    {
                        "id": 45659,
                        "name": "Rue",
                        "latitude": "50.27150000",
                        "longitude": "1.67163000"
                    },
                    {
                        "id": 45668,
                        "name": "Ruitz",
                        "latitude": "50.46643000",
                        "longitude": "2.58876000"
                    },
                    {
                        "id": 45670,
                        "name": "Rumegies",
                        "latitude": "50.48877000",
                        "longitude": "3.35131000"
                    },
                    {
                        "id": 45673,
                        "name": "Rumilly-en-Cambrésis",
                        "latitude": "50.12691000",
                        "longitude": "3.21874000"
                    },
                    {
                        "id": 45674,
                        "name": "Ruminghem",
                        "latitude": "50.85922000",
                        "longitude": "2.15838000"
                    },
                    {
                        "id": 45709,
                        "name": "Sacy-le-Grand",
                        "latitude": "49.35479000",
                        "longitude": "2.54461000"
                    },
                    {
                        "id": 45717,
                        "name": "Sailly-Flibeaucourt",
                        "latitude": "50.18419000",
                        "longitude": "1.77180000"
                    },
                    {
                        "id": 45718,
                        "name": "Sailly-Labourse",
                        "latitude": "50.50120000",
                        "longitude": "2.69708000"
                    },
                    {
                        "id": 45719,
                        "name": "Sailly-lez-Lannoy",
                        "latitude": "50.65000000",
                        "longitude": "3.21667000"
                    },
                    {
                        "id": 45720,
                        "name": "Sailly-sur-la-Lys",
                        "latitude": "50.65820000",
                        "longitude": "2.76872000"
                    },
                    {
                        "id": 45722,
                        "name": "Sainghin-en-Mélantois",
                        "latitude": "50.58836000",
                        "longitude": "3.16619000"
                    },
                    {
                        "id": 45723,
                        "name": "Sainghin-en-Weppes",
                        "latitude": "50.56407000",
                        "longitude": "2.89804000"
                    },
                    {
                        "id": 45724,
                        "name": "Sains-du-Nord",
                        "latitude": "50.09377000",
                        "longitude": "4.00898000"
                    },
                    {
                        "id": 45725,
                        "name": "Sains-en-Amiénois",
                        "latitude": "49.81716000",
                        "longitude": "2.31862000"
                    },
                    {
                        "id": 45726,
                        "name": "Sains-en-Gohelle",
                        "latitude": "50.44512000",
                        "longitude": "2.68301000"
                    },
                    {
                        "id": 45744,
                        "name": "Saint-Amand-les-Eaux",
                        "latitude": "50.44718000",
                        "longitude": "3.43076000"
                    },
                    {
                        "id": 45766,
                        "name": "Saint-André-lez-Lille",
                        "latitude": "50.66667000",
                        "longitude": "3.05000000"
                    },
                    {
                        "id": 45779,
                        "name": "Saint-Aubert",
                        "latitude": "50.20805000",
                        "longitude": "3.41727000"
                    },
                    {
                        "id": 45787,
                        "name": "Saint-Aubin-en-Bray",
                        "latitude": "49.42051000",
                        "longitude": "1.87782000"
                    },
                    {
                        "id": 45878,
                        "name": "Saint-Crépin-Ibouvillers",
                        "latitude": "49.26283000",
                        "longitude": "2.07793000"
                    },
                    {
                        "id": 45922,
                        "name": "Saint-Erme-Outre-et-Ramecourt",
                        "latitude": "49.51464000",
                        "longitude": "3.84060000"
                    },
                    {
                        "id": 46642,
                        "name": "Saint-Étienne-au-Mont",
                        "latitude": "50.67794000",
                        "longitude": "1.63084000"
                    },
                    {
                        "id": 45939,
                        "name": "Saint-Folquin",
                        "latitude": "50.94473000",
                        "longitude": "2.12433000"
                    },
                    {
                        "id": 46023,
                        "name": "Saint-Germer-de-Fly",
                        "latitude": "49.44281000",
                        "longitude": "1.77986000"
                    },
                    {
                        "id": 46039,
                        "name": "Saint-Gobain",
                        "latitude": "49.59572000",
                        "longitude": "3.37750000"
                    },
                    {
                        "id": 46066,
                        "name": "Saint-Hilaire-lez-Cambrai",
                        "latitude": "50.18419000",
                        "longitude": "3.41327000"
                    },
                    {
                        "id": 46079,
                        "name": "Saint-Jans-Cappel",
                        "latitude": "50.76387000",
                        "longitude": "2.72227000"
                    },
                    {
                        "id": 46130,
                        "name": "Saint-Josse",
                        "latitude": "50.46801000",
                        "longitude": "1.66180000"
                    },
                    {
                        "id": 46161,
                        "name": "Saint-Just-en-Chaussée",
                        "latitude": "49.50503000",
                        "longitude": "2.43285000"
                    },
                    {
                        "id": 46173,
                        "name": "Saint-Laurent-Blangy",
                        "latitude": "50.29446000",
                        "longitude": "2.80698000"
                    },
                    {
                        "id": 46216,
                        "name": "Saint-Léger-lès-Domart",
                        "latitude": "50.05208000",
                        "longitude": "2.14067000"
                    },
                    {
                        "id": 46221,
                        "name": "Saint-Léonard",
                        "latitude": "50.69058000",
                        "longitude": "1.62536000"
                    },
                    {
                        "id": 46267,
                        "name": "Saint-Martin-au-Laërt",
                        "latitude": "50.75179000",
                        "longitude": "2.24051000"
                    },
                    {
                        "id": 46261,
                        "name": "Saint-Martin-Boulogne",
                        "latitude": "50.72691000",
                        "longitude": "1.61864000"
                    },
                    {
                        "id": 46264,
                        "name": "Saint-Martin-Longueau",
                        "latitude": "49.34281000",
                        "longitude": "2.60276000"
                    },
                    {
                        "id": 46324,
                        "name": "Saint-Maximin",
                        "latitude": "49.22182000",
                        "longitude": "2.45359000"
                    },
                    {
                        "id": 46334,
                        "name": "Saint-Michel",
                        "latitude": "49.91952000",
                        "longitude": "4.13278000"
                    },
                    {
                        "id": 46362,
                        "name": "Saint-Nicolas",
                        "latitude": "50.30413000",
                        "longitude": "2.77939000"
                    },
                    {
                        "id": 46373,
                        "name": "Saint-Omer",
                        "latitude": "50.74834000",
                        "longitude": "2.26091000"
                    },
                    {
                        "id": 46374,
                        "name": "Saint-Omer-en-Chaussée",
                        "latitude": "49.53142000",
                        "longitude": "2.00335000"
                    },
                    {
                        "id": 46378,
                        "name": "Saint-Ouen",
                        "latitude": "50.03819000",
                        "longitude": "2.12088000"
                    },
                    {
                        "id": 46401,
                        "name": "Saint-Paul",
                        "latitude": "49.42962000",
                        "longitude": "2.00755000"
                    },
                    {
                        "id": 46456,
                        "name": "Saint-Pol-sur-Mer",
                        "latitude": "51.03116000",
                        "longitude": "2.33983000"
                    },
                    {
                        "id": 46457,
                        "name": "Saint-Pol-sur-Ternoise",
                        "latitude": "50.38113000",
                        "longitude": "2.33407000"
                    },
                    {
                        "id": 46476,
                        "name": "Saint-Python",
                        "latitude": "50.19001000",
                        "longitude": "3.48027000"
                    },
                    {
                        "id": 46485,
                        "name": "Saint-Quentin",
                        "latitude": "49.84889000",
                        "longitude": "3.28757000"
                    },
                    {
                        "id": 46497,
                        "name": "Saint-Riquier",
                        "latitude": "50.13235000",
                        "longitude": "1.94755000"
                    },
                    {
                        "id": 46525,
                        "name": "Saint-Saulve",
                        "latitude": "50.37141000",
                        "longitude": "3.55612000"
                    },
                    {
                        "id": 46528,
                        "name": "Saint-Sauveur",
                        "latitude": "49.31857000",
                        "longitude": "2.78321000"
                    },
                    {
                        "id": 46557,
                        "name": "Saint-Souplet",
                        "latitude": "50.05639000",
                        "longitude": "3.53179000"
                    },
                    {
                        "id": 46559,
                        "name": "Saint-Sulpice",
                        "latitude": "49.35049000",
                        "longitude": "2.12314000"
                    },
                    {
                        "id": 46572,
                        "name": "Saint-Sylvestre-Cappel",
                        "latitude": "50.77625000",
                        "longitude": "2.55622000"
                    },
                    {
                        "id": 46597,
                        "name": "Saint-Valery-sur-Somme",
                        "latitude": "50.18333000",
                        "longitude": "1.63333000"
                    },
                    {
                        "id": 46604,
                        "name": "Saint-Venant",
                        "latitude": "50.61955000",
                        "longitude": "2.53946000"
                    },
                    {
                        "id": 46667,
                        "name": "Sainte-Catherine",
                        "latitude": "50.30757000",
                        "longitude": "2.76404000"
                    },
                    {
                        "id": 46691,
                        "name": "Sainte-Geneviève",
                        "latitude": "49.28920000",
                        "longitude": "2.19904000"
                    },
                    {
                        "id": 46708,
                        "name": "Sainte-Marie-Kerque",
                        "latitude": "50.89917000",
                        "longitude": "2.13664000"
                    },
                    {
                        "id": 46747,
                        "name": "Saleux",
                        "latitude": "49.85630000",
                        "longitude": "2.23698000"
                    },
                    {
                        "id": 46758,
                        "name": "Sallaumines",
                        "latitude": "50.41749000",
                        "longitude": "2.86174000"
                    },
                    {
                        "id": 46765,
                        "name": "Salomé",
                        "latitude": "50.53352000",
                        "longitude": "2.84709000"
                    },
                    {
                        "id": 46767,
                        "name": "Salouël",
                        "latitude": "49.86988000",
                        "longitude": "2.24340000"
                    },
                    {
                        "id": 46777,
                        "name": "Saméon",
                        "latitude": "50.47135000",
                        "longitude": "3.33544000"
                    },
                    {
                        "id": 46772,
                        "name": "Samer",
                        "latitude": "50.63840000",
                        "longitude": "1.74628000"
                    },
                    {
                        "id": 46787,
                        "name": "Sangatte",
                        "latitude": "50.94564000",
                        "longitude": "1.75321000"
                    },
                    {
                        "id": 46799,
                        "name": "Santes",
                        "latitude": "50.59316000",
                        "longitude": "2.96289000"
                    },
                    {
                        "id": 46819,
                        "name": "Sars-Poteries",
                        "latitude": "50.16928000",
                        "longitude": "4.02676000"
                    },
                    {
                        "id": 46847,
                        "name": "Saultain",
                        "latitude": "50.33676000",
                        "longitude": "3.57723000"
                    },
                    {
                        "id": 46851,
                        "name": "Saulzoir",
                        "latitude": "50.24057000",
                        "longitude": "3.44430000"
                    },
                    {
                        "id": 46888,
                        "name": "Savy-Berlette",
                        "latitude": "50.35249000",
                        "longitude": "2.56456000"
                    },
                    {
                        "id": 46909,
                        "name": "Seboncourt",
                        "latitude": "49.95273000",
                        "longitude": "3.47586000"
                    },
                    {
                        "id": 46910,
                        "name": "Sebourg",
                        "latitude": "50.34249000",
                        "longitude": "3.64352000"
                    },
                    {
                        "id": 46911,
                        "name": "Seclin",
                        "latitude": "50.54873000",
                        "longitude": "3.02731000"
                    },
                    {
                        "id": 46935,
                        "name": "Selvigny",
                        "latitude": "50.07971000",
                        "longitude": "3.34899000"
                    },
                    {
                        "id": 46940,
                        "name": "Senlis",
                        "latitude": "49.20724000",
                        "longitude": "2.58661000"
                    },
                    {
                        "id": 46952,
                        "name": "Sequedin",
                        "latitude": "50.62575000",
                        "longitude": "2.98276000"
                    },
                    {
                        "id": 47143,
                        "name": "Sérifontaine",
                        "latitude": "49.35440000",
                        "longitude": "1.76873000"
                    },
                    {
                        "id": 46962,
                        "name": "Serques",
                        "latitude": "50.79338000",
                        "longitude": "2.20134000"
                    },
                    {
                        "id": 46998,
                        "name": "Silly-le-Long",
                        "latitude": "49.10749000",
                        "longitude": "2.79226000"
                    },
                    {
                        "id": 47003,
                        "name": "Sin-le-Noble",
                        "latitude": "50.36159000",
                        "longitude": "3.13113000"
                    },
                    {
                        "id": 47004,
                        "name": "Sinceny",
                        "latitude": "49.59619000",
                        "longitude": "3.24679000"
                    },
                    {
                        "id": 47008,
                        "name": "Sissonne",
                        "latitude": "49.57107000",
                        "longitude": "3.89369000"
                    },
                    {
                        "id": 47015,
                        "name": "Socx",
                        "latitude": "50.93571000",
                        "longitude": "2.42422000"
                    },
                    {
                        "id": 47018,
                        "name": "Soissons",
                        "latitude": "49.38167000",
                        "longitude": "3.32361000"
                    },
                    {
                        "id": 47024,
                        "name": "Solesmes",
                        "latitude": "50.18468000",
                        "longitude": "3.49799000"
                    },
                    {
                        "id": 47033,
                        "name": "Solre-le-Château",
                        "latitude": "50.17432000",
                        "longitude": "4.08898000"
                    },
                    {
                        "id": 47034,
                        "name": "Somain",
                        "latitude": "50.35961000",
                        "longitude": "3.28108000"
                    },
                    {
                        "id": 47035,
                        "name": "Somme",
                        "latitude": "49.93141000",
                        "longitude": "2.27639000"
                    },
                    {
                        "id": 47038,
                        "name": "Songeons",
                        "latitude": "49.54916000",
                        "longitude": "1.85361000"
                    },
                    {
                        "id": 47058,
                        "name": "Souchez",
                        "latitude": "50.39291000",
                        "longitude": "2.73984000"
                    },
                    {
                        "id": 47094,
                        "name": "Spycker",
                        "latitude": "50.96915000",
                        "longitude": "2.32184000"
                    },
                    {
                        "id": 47099,
                        "name": "Steenbecque",
                        "latitude": "50.67421000",
                        "longitude": "2.48442000"
                    },
                    {
                        "id": 47100,
                        "name": "Steene",
                        "latitude": "50.95228000",
                        "longitude": "2.36813000"
                    },
                    {
                        "id": 47101,
                        "name": "Steenvoorde",
                        "latitude": "50.81046000",
                        "longitude": "2.58244000"
                    },
                    {
                        "id": 47102,
                        "name": "Steenwerck",
                        "latitude": "50.70199000",
                        "longitude": "2.77829000"
                    },
                    {
                        "id": 47167,
                        "name": "Talmas",
                        "latitude": "50.03049000",
                        "longitude": "2.32554000"
                    },
                    {
                        "id": 47184,
                        "name": "Tatinghem",
                        "latitude": "50.74317000",
                        "longitude": "2.20724000"
                    },
                    {
                        "id": 47197,
                        "name": "Templemars",
                        "latitude": "50.57387000",
                        "longitude": "3.05437000"
                    },
                    {
                        "id": 47198,
                        "name": "Templeuve-en-Pévèle",
                        "latitude": "50.52336000",
                        "longitude": "3.17809000"
                    },
                    {
                        "id": 47207,
                        "name": "Tergnier",
                        "latitude": "49.65607000",
                        "longitude": "3.30107000"
                    },
                    {
                        "id": 47417,
                        "name": "Téteghem",
                        "latitude": "51.01859000",
                        "longitude": "2.44454000"
                    },
                    {
                        "id": 47267,
                        "name": "Thélus",
                        "latitude": "50.35441000",
                        "longitude": "2.80146000"
                    },
                    {
                        "id": 47271,
                        "name": "Thérouanne",
                        "latitude": "50.63695000",
                        "longitude": "2.25838000"
                    },
                    {
                        "id": 47226,
                        "name": "Thiant",
                        "latitude": "50.30480000",
                        "longitude": "3.44796000"
                    },
                    {
                        "id": 47230,
                        "name": "Thiers-sur-Thève",
                        "latitude": "49.15252000",
                        "longitude": "2.57051000"
                    },
                    {
                        "id": 47239,
                        "name": "Thiverny",
                        "latitude": "49.25180000",
                        "longitude": "2.43609000"
                    },
                    {
                        "id": 47256,
                        "name": "Thourotte",
                        "latitude": "49.47591000",
                        "longitude": "2.88210000"
                    },
                    {
                        "id": 47260,
                        "name": "Thumeries",
                        "latitude": "50.47662000",
                        "longitude": "3.05500000"
                    },
                    {
                        "id": 47261,
                        "name": "Thun-Saint-Amand",
                        "latitude": "50.47276000",
                        "longitude": "3.45115000"
                    },
                    {
                        "id": 47286,
                        "name": "Tillé",
                        "latitude": "49.46415000",
                        "longitude": "2.11038000"
                    },
                    {
                        "id": 47284,
                        "name": "Tilloy-lès-Mofflaines",
                        "latitude": "50.27519000",
                        "longitude": "2.81456000"
                    },
                    {
                        "id": 47287,
                        "name": "Tilques",
                        "latitude": "50.77712000",
                        "longitude": "2.19948000"
                    },
                    {
                        "id": 47308,
                        "name": "Toufflers",
                        "latitude": "50.66039000",
                        "longitude": "3.23358000"
                    },
                    {
                        "id": 47320,
                        "name": "Tourcoing",
                        "latitude": "50.72391000",
                        "longitude": "3.16117000"
                    },
                    {
                        "id": 47325,
                        "name": "Tournehem-sur-la-Hem",
                        "latitude": "50.80000000",
                        "longitude": "2.05000000"
                    },
                    {
                        "id": 47345,
                        "name": "Tracy-le-Mont",
                        "latitude": "49.47225000",
                        "longitude": "3.00939000"
                    },
                    {
                        "id": 47399,
                        "name": "Trélon",
                        "latitude": "50.05805000",
                        "longitude": "4.10200000"
                    },
                    {
                        "id": 47365,
                        "name": "Tressin",
                        "latitude": "50.61750000",
                        "longitude": "3.19354000"
                    },
                    {
                        "id": 47368,
                        "name": "Tricot",
                        "latitude": "49.56080000",
                        "longitude": "2.58789000"
                    },
                    {
                        "id": 47369,
                        "name": "Trie-Château",
                        "latitude": "49.28540000",
                        "longitude": "1.82129000"
                    },
                    {
                        "id": 47376,
                        "name": "Trith-Saint-Léger",
                        "latitude": "50.31667000",
                        "longitude": "3.48333000"
                    },
                    {
                        "id": 47379,
                        "name": "Troissereux",
                        "latitude": "49.47998000",
                        "longitude": "2.04485000"
                    },
                    {
                        "id": 47381,
                        "name": "Trosly-Breuil",
                        "latitude": "49.40000000",
                        "longitude": "2.96667000"
                    },
                    {
                        "id": 47425,
                        "name": "Ully-Saint-Georges",
                        "latitude": "49.27914000",
                        "longitude": "2.28094000"
                    },
                    {
                        "id": 47444,
                        "name": "Uxem",
                        "latitude": "51.02170000",
                        "longitude": "2.48376000"
                    },
                    {
                        "id": 47456,
                        "name": "Vailly-sur-Aisne",
                        "latitude": "49.40834000",
                        "longitude": "3.51631000"
                    },
                    {
                        "id": 47474,
                        "name": "Valenciennes",
                        "latitude": "50.35909000",
                        "longitude": "3.52506000"
                    },
                    {
                        "id": 47540,
                        "name": "Vaulx-Vraucourt",
                        "latitude": "50.14910000",
                        "longitude": "2.90830000"
                    },
                    {
                        "id": 47542,
                        "name": "Vaumoise",
                        "latitude": "49.23525000",
                        "longitude": "2.98077000"
                    },
                    {
                        "id": 47569,
                        "name": "Vendegies-sur-Écaillon",
                        "latitude": "50.26224000",
                        "longitude": "3.51256000"
                    },
                    {
                        "id": 47573,
                        "name": "Vendeville",
                        "latitude": "50.57693000",
                        "longitude": "3.07870000"
                    },
                    {
                        "id": 47574,
                        "name": "Vendin-le-Vieil",
                        "latitude": "50.47385000",
                        "longitude": "2.86674000"
                    },
                    {
                        "id": 47575,
                        "name": "Vendin-lès-Béthune",
                        "latitude": "50.54012000",
                        "longitude": "2.60043000"
                    },
                    {
                        "id": 47582,
                        "name": "Venette",
                        "latitude": "49.41705000",
                        "longitude": "2.80317000"
                    },
                    {
                        "id": 47584,
                        "name": "Venizel",
                        "latitude": "49.36583000",
                        "longitude": "3.39321000"
                    },
                    {
                        "id": 47589,
                        "name": "Ver-sur-Launette",
                        "latitude": "49.10495000",
                        "longitude": "2.68409000"
                    },
                    {
                        "id": 47591,
                        "name": "Verberie",
                        "latitude": "49.31115000",
                        "longitude": "2.73210000"
                    },
                    {
                        "id": 47602,
                        "name": "Verlinghem",
                        "latitude": "50.68291000",
                        "longitude": "2.99907000"
                    },
                    {
                        "id": 47603,
                        "name": "Vermand",
                        "latitude": "49.87550000",
                        "longitude": "3.14959000"
                    },
                    {
                        "id": 47604,
                        "name": "Vermelles",
                        "latitude": "50.48949000",
                        "longitude": "2.74739000"
                    },
                    {
                        "id": 47612,
                        "name": "Verneuil-en-Halatte",
                        "latitude": "49.27914000",
                        "longitude": "2.52410000"
                    },
                    {
                        "id": 47628,
                        "name": "Verquin",
                        "latitude": "50.50240000",
                        "longitude": "2.63888000"
                    },
                    {
                        "id": 47641,
                        "name": "Verton",
                        "latitude": "50.40234000",
                        "longitude": "1.64766000"
                    },
                    {
                        "id": 47644,
                        "name": "Vervins",
                        "latitude": "49.83510000",
                        "longitude": "3.90925000"
                    },
                    {
                        "id": 47667,
                        "name": "Vic-sur-Aisne",
                        "latitude": "49.40609000",
                        "longitude": "3.11223000"
                    },
                    {
                        "id": 47671,
                        "name": "Vicq",
                        "latitude": "50.40738000",
                        "longitude": "3.60348000"
                    },
                    {
                        "id": 47677,
                        "name": "Vieille-Église",
                        "latitude": "50.92823000",
                        "longitude": "2.07671000"
                    },
                    {
                        "id": 47686,
                        "name": "Viesly",
                        "latitude": "50.15345000",
                        "longitude": "3.46236000"
                    },
                    {
                        "id": 47687,
                        "name": "Vieux-Berquin",
                        "latitude": "50.69489000",
                        "longitude": "2.64444000"
                    },
                    {
                        "id": 47690,
                        "name": "Vieux-Condé",
                        "latitude": "50.45944000",
                        "longitude": "3.56738000"
                    },
                    {
                        "id": 47694,
                        "name": "Vignacourt",
                        "latitude": "50.01236000",
                        "longitude": "2.19743000"
                    },
                    {
                        "id": 47766,
                        "name": "Villeneuve-d'Ascq",
                        "latitude": "50.61669000",
                        "longitude": "3.16664000"
                    },
                    {
                        "id": 47778,
                        "name": "Villeneuve-les-Sablons",
                        "latitude": "49.23753000",
                        "longitude": "2.07782000"
                    },
                    {
                        "id": 47764,
                        "name": "Villeneuve-Saint-Germain",
                        "latitude": "49.37976000",
                        "longitude": "3.35952000"
                    },
                    {
                        "id": 47795,
                        "name": "Villers-Bocage",
                        "latitude": "49.99810000",
                        "longitude": "2.31683000"
                    },
                    {
                        "id": 47797,
                        "name": "Villers-Bretonneux",
                        "latitude": "49.86844000",
                        "longitude": "2.51688000"
                    },
                    {
                        "id": 47798,
                        "name": "Villers-Cotterêts",
                        "latitude": "49.25311000",
                        "longitude": "3.09003000"
                    },
                    {
                        "id": 47803,
                        "name": "Villers-en-Cauchies",
                        "latitude": "50.22574000",
                        "longitude": "3.40362000"
                    },
                    {
                        "id": 47799,
                        "name": "Villers-Outréaux",
                        "latitude": "50.03590000",
                        "longitude": "3.29947000"
                    },
                    {
                        "id": 47800,
                        "name": "Villers-Pol",
                        "latitude": "50.28460000",
                        "longitude": "3.61449000"
                    },
                    {
                        "id": 47801,
                        "name": "Villers-Saint-Paul",
                        "latitude": "49.28885000",
                        "longitude": "2.48968000"
                    },
                    {
                        "id": 47807,
                        "name": "Villers-sous-Saint-Leu",
                        "latitude": "49.21235000",
                        "longitude": "2.39485000"
                    },
                    {
                        "id": 47808,
                        "name": "Villers-sur-Coudun",
                        "latitude": "49.48308000",
                        "longitude": "2.80457000"
                    },
                    {
                        "id": 47841,
                        "name": "Vimy",
                        "latitude": "50.37243000",
                        "longitude": "2.81034000"
                    },
                    {
                        "id": 47847,
                        "name": "Vineuil-Saint-Firmin",
                        "latitude": "49.20024000",
                        "longitude": "2.49567000"
                    },
                    {
                        "id": 47852,
                        "name": "Violaines",
                        "latitude": "50.54160000",
                        "longitude": "2.78860000"
                    },
                    {
                        "id": 47868,
                        "name": "Viry-Noureuil",
                        "latitude": "49.63214000",
                        "longitude": "3.24322000"
                    },
                    {
                        "id": 47872,
                        "name": "Vitry-en-Artois",
                        "latitude": "50.32660000",
                        "longitude": "2.97999000"
                    },
                    {
                        "id": 47919,
                        "name": "Vred",
                        "latitude": "50.39455000",
                        "longitude": "3.23029000"
                    },
                    {
                        "id": 47935,
                        "name": "Wahagnies",
                        "latitude": "50.48665000",
                        "longitude": "3.03448000"
                    },
                    {
                        "id": 47936,
                        "name": "Wailly",
                        "latitude": "50.52287000",
                        "longitude": "2.06792000"
                    },
                    {
                        "id": 47939,
                        "name": "Walincourt-Selvigny",
                        "latitude": "50.06667000",
                        "longitude": "3.33333000"
                    },
                    {
                        "id": 47940,
                        "name": "Wallers",
                        "latitude": "50.37432000",
                        "longitude": "3.39188000"
                    },
                    {
                        "id": 47942,
                        "name": "Wambrechies",
                        "latitude": "50.68276000",
                        "longitude": "3.04784000"
                    },
                    {
                        "id": 47943,
                        "name": "Wandignies-Hamage",
                        "latitude": "50.39609000",
                        "longitude": "3.31450000"
                    },
                    {
                        "id": 47946,
                        "name": "Wardrecques",
                        "latitude": "50.71108000",
                        "longitude": "2.34483000"
                    },
                    {
                        "id": 47947,
                        "name": "Wargnies-le-Grand",
                        "latitude": "50.30751000",
                        "longitude": "3.66038000"
                    },
                    {
                        "id": 47948,
                        "name": "Warhem",
                        "latitude": "50.97592000",
                        "longitude": "2.49303000"
                    },
                    {
                        "id": 47949,
                        "name": "Warluis",
                        "latitude": "49.38874000",
                        "longitude": "2.14220000"
                    },
                    {
                        "id": 47951,
                        "name": "Wasquehal",
                        "latitude": "50.67043000",
                        "longitude": "3.13382000"
                    },
                    {
                        "id": 47953,
                        "name": "Wassigny",
                        "latitude": "50.01334000",
                        "longitude": "3.59988000"
                    },
                    {
                        "id": 47955,
                        "name": "Watten",
                        "latitude": "50.83685000",
                        "longitude": "2.21346000"
                    },
                    {
                        "id": 47956,
                        "name": "Wattignies",
                        "latitude": "50.58639000",
                        "longitude": "3.04394000"
                    },
                    {
                        "id": 47957,
                        "name": "Wattrelos",
                        "latitude": "50.70118000",
                        "longitude": "3.21812000"
                    },
                    {
                        "id": 47959,
                        "name": "Wavignies",
                        "latitude": "49.54748000",
                        "longitude": "2.36032000"
                    },
                    {
                        "id": 47960,
                        "name": "Wavrechain-sous-Denain",
                        "latitude": "50.33224000",
                        "longitude": "3.41252000"
                    },
                    {
                        "id": 47961,
                        "name": "Wavrin",
                        "latitude": "50.57386000",
                        "longitude": "2.93630000"
                    },
                    {
                        "id": 47962,
                        "name": "Waziers",
                        "latitude": "50.38717000",
                        "longitude": "3.11490000"
                    },
                    {
                        "id": 47964,
                        "name": "Wervicq-Sud",
                        "latitude": "50.77450000",
                        "longitude": "3.04207000"
                    },
                    {
                        "id": 47970,
                        "name": "Wignehies",
                        "latitude": "50.01550000",
                        "longitude": "4.00913000"
                    },
                    {
                        "id": 47972,
                        "name": "Willems",
                        "latitude": "50.63206000",
                        "longitude": "3.23840000"
                    },
                    {
                        "id": 47974,
                        "name": "Wimereux",
                        "latitude": "50.76963000",
                        "longitude": "1.61139000"
                    },
                    {
                        "id": 47975,
                        "name": "Wimille",
                        "latitude": "50.76418000",
                        "longitude": "1.63137000"
                    },
                    {
                        "id": 47979,
                        "name": "Wingles",
                        "latitude": "50.49382000",
                        "longitude": "2.85500000"
                    },
                    {
                        "id": 47980,
                        "name": "Winnezeele",
                        "latitude": "50.84100000",
                        "longitude": "2.55118000"
                    },
                    {
                        "id": 47983,
                        "name": "Wissant",
                        "latitude": "50.88530000",
                        "longitude": "1.66263000"
                    },
                    {
                        "id": 47990,
                        "name": "Wizernes",
                        "latitude": "50.71170000",
                        "longitude": "2.24316000"
                    },
                    {
                        "id": 47992,
                        "name": "Woincourt",
                        "latitude": "50.06630000",
                        "longitude": "1.53676000"
                    },
                    {
                        "id": 47996,
                        "name": "Wormhout",
                        "latitude": "50.88129000",
                        "longitude": "2.46901000"
                    },
                    {
                        "id": 48025,
                        "name": "Zegerscappel",
                        "latitude": "50.88333000",
                        "longitude": "2.40000000"
                    },
                    {
                        "id": 48029,
                        "name": "Zutkerque",
                        "latitude": "50.85303000",
                        "longitude": "2.06818000"
                    },
                    {
                        "id": 48030,
                        "name": "Zuydcoote",
                        "latitude": "51.06096000",
                        "longitude": "2.49338000"
                    }
                ]
            },
            {
                "id": 5060,
                "name": "Hauts-de-Seine",
                "iso2": "92",
                "latitude": "48.84030080",
                "longitude": "2.10125590",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5002,
                "name": "Hérault",
                "iso2": "34",
                "latitude": "43.59111200",
                "longitude": "2.80661080",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4796,
                "name": "Île-de-France",
                "iso2": "IDF",
                "latitude": "48.84991980",
                "longitude": "2.63704110",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39239,
                        "name": "Ableiges",
                        "latitude": "49.08932000",
                        "longitude": "1.98154000"
                    },
                    {
                        "id": 39240,
                        "name": "Ablis",
                        "latitude": "48.51720000",
                        "longitude": "1.83624000"
                    },
                    {
                        "id": 39242,
                        "name": "Ablon-sur-Seine",
                        "latitude": "48.72732000",
                        "longitude": "2.42686000"
                    },
                    {
                        "id": 39252,
                        "name": "Achères",
                        "latitude": "48.96115000",
                        "longitude": "2.06882000"
                    },
                    {
                        "id": 39253,
                        "name": "Achères-la-Forêt",
                        "latitude": "48.35458000",
                        "longitude": "2.57035000"
                    },
                    {
                        "id": 39311,
                        "name": "Alfortville",
                        "latitude": "48.80575000",
                        "longitude": "2.42040000"
                    },
                    {
                        "id": 39383,
                        "name": "Andilly",
                        "latitude": "49.00935000",
                        "longitude": "2.30240000"
                    },
                    {
                        "id": 39390,
                        "name": "Andrésy",
                        "latitude": "48.98235000",
                        "longitude": "2.05687000"
                    },
                    {
                        "id": 39397,
                        "name": "Angerville",
                        "latitude": "48.31354000",
                        "longitude": "1.99935000"
                    },
                    {
                        "id": 39399,
                        "name": "Angervilliers",
                        "latitude": "48.59263000",
                        "longitude": "2.06541000"
                    },
                    {
                        "id": 39419,
                        "name": "Annet-sur-Marne",
                        "latitude": "48.92669000",
                        "longitude": "2.71959000"
                    },
                    {
                        "id": 39435,
                        "name": "Antony",
                        "latitude": "48.75329000",
                        "longitude": "2.29668000"
                    },
                    {
                        "id": 39451,
                        "name": "Arbonne-la-Forêt",
                        "latitude": "48.41405000",
                        "longitude": "2.56677000"
                    },
                    {
                        "id": 39465,
                        "name": "Arcueil",
                        "latitude": "48.79993000",
                        "longitude": "2.33256000"
                    },
                    {
                        "id": 39481,
                        "name": "Argenteuil",
                        "latitude": "48.94788000",
                        "longitude": "2.24744000"
                    },
                    {
                        "id": 39494,
                        "name": "Armentières-en-Brie",
                        "latitude": "48.97775000",
                        "longitude": "3.02073000"
                    },
                    {
                        "id": 39503,
                        "name": "Arnouville",
                        "latitude": "48.98333000",
                        "longitude": "2.41667000"
                    },
                    {
                        "id": 39506,
                        "name": "Arpajon",
                        "latitude": "48.58875000",
                        "longitude": "2.24672000"
                    },
                    {
                        "id": 39543,
                        "name": "Asnières-sur-Oise",
                        "latitude": "49.13369000",
                        "longitude": "2.35551000"
                    },
                    {
                        "id": 39544,
                        "name": "Asnières-sur-Seine",
                        "latitude": "48.91667000",
                        "longitude": "2.28333000"
                    },
                    {
                        "id": 39557,
                        "name": "Athis-Mons",
                        "latitude": "48.70522000",
                        "longitude": "2.39147000"
                    },
                    {
                        "id": 39560,
                        "name": "Attainville",
                        "latitude": "49.05779000",
                        "longitude": "2.34497000"
                    },
                    {
                        "id": 39571,
                        "name": "Aubergenville",
                        "latitude": "48.95996000",
                        "longitude": "1.85467000"
                    },
                    {
                        "id": 39574,
                        "name": "Aubervilliers",
                        "latitude": "48.91667000",
                        "longitude": "2.38333000"
                    },
                    {
                        "id": 39602,
                        "name": "Auffargis",
                        "latitude": "48.70049000",
                        "longitude": "1.88696000"
                    },
                    {
                        "id": 39609,
                        "name": "Aulnay-sous-Bois",
                        "latitude": "48.93814000",
                        "longitude": "2.49402000"
                    },
                    {
                        "id": 39610,
                        "name": "Aulnay-sur-Mauldre",
                        "latitude": "48.92950000",
                        "longitude": "1.84113000"
                    },
                    {
                        "id": 39640,
                        "name": "Auvers-Saint-Georges",
                        "latitude": "48.49276000",
                        "longitude": "2.22045000"
                    },
                    {
                        "id": 39642,
                        "name": "Auvers-sur-Oise",
                        "latitude": "49.07158000",
                        "longitude": "2.16978000"
                    },
                    {
                        "id": 39676,
                        "name": "Avon",
                        "latitude": "48.40219000",
                        "longitude": "2.72022000"
                    },
                    {
                        "id": 39708,
                        "name": "Bagneaux-sur-Loing",
                        "latitude": "48.23310000",
                        "longitude": "2.70675000"
                    },
                    {
                        "id": 39709,
                        "name": "Bagneux",
                        "latitude": "48.79565000",
                        "longitude": "2.30796000"
                    },
                    {
                        "id": 39711,
                        "name": "Bagnolet",
                        "latitude": "48.86667000",
                        "longitude": "2.41667000"
                    },
                    {
                        "id": 39724,
                        "name": "Baillet-en-France",
                        "latitude": "49.06187000",
                        "longitude": "2.29880000"
                    },
                    {
                        "id": 39729,
                        "name": "Bailly",
                        "latitude": "48.84168000",
                        "longitude": "2.07673000"
                    },
                    {
                        "id": 39730,
                        "name": "Bailly-Carrois",
                        "latitude": "48.58029000",
                        "longitude": "2.99047000"
                    },
                    {
                        "id": 39731,
                        "name": "Bailly-Romainvilliers",
                        "latitude": "48.84729000",
                        "longitude": "2.82352000"
                    },
                    {
                        "id": 39750,
                        "name": "Ballainvilliers",
                        "latitude": "48.67481000",
                        "longitude": "2.30057000"
                    },
                    {
                        "id": 39753,
                        "name": "Ballancourt-sur-Essonne",
                        "latitude": "48.52525000",
                        "longitude": "2.38604000"
                    },
                    {
                        "id": 39775,
                        "name": "Barbizon",
                        "latitude": "48.44346000",
                        "longitude": "2.60313000"
                    },
                    {
                        "id": 39812,
                        "name": "Baulne",
                        "latitude": "48.49303000",
                        "longitude": "2.36230000"
                    },
                    {
                        "id": 39825,
                        "name": "Bazainville",
                        "latitude": "48.80435000",
                        "longitude": "1.66732000"
                    },
                    {
                        "id": 39829,
                        "name": "Bazemont",
                        "latitude": "48.92726000",
                        "longitude": "1.86651000"
                    },
                    {
                        "id": 39838,
                        "name": "Beauchamp",
                        "latitude": "49.01667000",
                        "longitude": "2.20000000"
                    },
                    {
                        "id": 39865,
                        "name": "Beaumont-du-Gâtinais",
                        "latitude": "48.13860000",
                        "longitude": "2.47913000"
                    },
                    {
                        "id": 39872,
                        "name": "Beaumont-sur-Oise",
                        "latitude": "49.14232000",
                        "longitude": "2.28705000"
                    },
                    {
                        "id": 39930,
                        "name": "Belloy-en-France",
                        "latitude": "49.08837000",
                        "longitude": "2.37159000"
                    },
                    {
                        "id": 39940,
                        "name": "Bennecourt",
                        "latitude": "49.04148000",
                        "longitude": "1.55469000"
                    },
                    {
                        "id": 39953,
                        "name": "Bernes-sur-Oise",
                        "latitude": "49.16128000",
                        "longitude": "2.30000000"
                    },
                    {
                        "id": 39974,
                        "name": "Bessancourt",
                        "latitude": "49.03765000",
                        "longitude": "2.20936000"
                    },
                    {
                        "id": 39999,
                        "name": "Beynes",
                        "latitude": "48.85626000",
                        "longitude": "1.87261000"
                    },
                    {
                        "id": 40002,
                        "name": "Bezons",
                        "latitude": "48.92426000",
                        "longitude": "2.21280000"
                    },
                    {
                        "id": 40040,
                        "name": "Bièvres",
                        "latitude": "48.75772000",
                        "longitude": "2.21881000"
                    },
                    {
                        "id": 40077,
                        "name": "Bobigny",
                        "latitude": "48.90982000",
                        "longitude": "2.45012000"
                    },
                    {
                        "id": 40084,
                        "name": "Bois-Colombes",
                        "latitude": "48.91936000",
                        "longitude": "2.27485000"
                    },
                    {
                        "id": 40089,
                        "name": "Bois-d’Arcy",
                        "latitude": "48.79966000",
                        "longitude": "2.02325000"
                    },
                    {
                        "id": 40090,
                        "name": "Bois-le-Roi",
                        "latitude": "48.47348000",
                        "longitude": "2.70464000"
                    },
                    {
                        "id": 40097,
                        "name": "Boissise-le-Roi",
                        "latitude": "48.52479000",
                        "longitude": "2.56971000"
                    },
                    {
                        "id": 40099,
                        "name": "Boissy-le-Châtel",
                        "latitude": "48.82073000",
                        "longitude": "3.13651000"
                    },
                    {
                        "id": 40100,
                        "name": "Boissy-le-Cutté",
                        "latitude": "48.47020000",
                        "longitude": "2.28326000"
                    },
                    {
                        "id": 40098,
                        "name": "Boissy-Saint-Léger",
                        "latitude": "48.75149000",
                        "longitude": "2.51163000"
                    },
                    {
                        "id": 40101,
                        "name": "Boissy-sous-Saint-Yon",
                        "latitude": "48.55379000",
                        "longitude": "2.21212000"
                    },
                    {
                        "id": 40111,
                        "name": "Bondoufle",
                        "latitude": "48.61294000",
                        "longitude": "2.37775000"
                    },
                    {
                        "id": 40113,
                        "name": "Bondy",
                        "latitude": "48.90180000",
                        "longitude": "2.48931000"
                    },
                    {
                        "id": 40119,
                        "name": "Bonnelles",
                        "latitude": "48.61816000",
                        "longitude": "2.02922000"
                    },
                    {
                        "id": 40123,
                        "name": "Bonneuil-sur-Marne",
                        "latitude": "48.76950000",
                        "longitude": "2.47930000"
                    },
                    {
                        "id": 40128,
                        "name": "Bonnières-sur-Seine",
                        "latitude": "49.03525000",
                        "longitude": "1.57830000"
                    },
                    {
                        "id": 40147,
                        "name": "Bouafle",
                        "latitude": "48.96463000",
                        "longitude": "1.90120000"
                    },
                    {
                        "id": 40153,
                        "name": "Bouffémont",
                        "latitude": "49.04377000",
                        "longitude": "2.29796000"
                    },
                    {
                        "id": 40155,
                        "name": "Bougival",
                        "latitude": "48.86223000",
                        "longitude": "2.14148000"
                    },
                    {
                        "id": 40166,
                        "name": "Bouleurs",
                        "latitude": "48.88181000",
                        "longitude": "2.90728000"
                    },
                    {
                        "id": 40172,
                        "name": "Boulogne-Billancourt",
                        "latitude": "48.83545000",
                        "longitude": "2.24128000"
                    },
                    {
                        "id": 40177,
                        "name": "Bouray-sur-Juine",
                        "latitude": "48.51981000",
                        "longitude": "2.30001000"
                    },
                    {
                        "id": 40195,
                        "name": "Bourg-la-Reine",
                        "latitude": "48.77888000",
                        "longitude": "2.31781000"
                    },
                    {
                        "id": 40212,
                        "name": "Bourron-Marlotte",
                        "latitude": "48.34051000",
                        "longitude": "2.70041000"
                    },
                    {
                        "id": 40221,
                        "name": "Boussy-Saint-Antoine",
                        "latitude": "48.69101000",
                        "longitude": "2.53060000"
                    },
                    {
                        "id": 40224,
                        "name": "Boutigny-sur-Essonne",
                        "latitude": "48.43333000",
                        "longitude": "2.38333000"
                    },
                    {
                        "id": 40268,
                        "name": "Bray-sur-Seine",
                        "latitude": "48.41371000",
                        "longitude": "3.23852000"
                    },
                    {
                        "id": 40360,
                        "name": "Brétigny-sur-Orge",
                        "latitude": "48.61135000",
                        "longitude": "2.30593000"
                    },
                    {
                        "id": 40296,
                        "name": "Breuillet",
                        "latitude": "48.57064000",
                        "longitude": "2.17424000"
                    },
                    {
                        "id": 40361,
                        "name": "Bréval",
                        "latitude": "48.94545000",
                        "longitude": "1.53309000"
                    },
                    {
                        "id": 40306,
                        "name": "Brie-Comte-Robert",
                        "latitude": "48.69247000",
                        "longitude": "2.61090000"
                    },
                    {
                        "id": 40315,
                        "name": "Briis-sous-Forges",
                        "latitude": "48.62399000",
                        "longitude": "2.12112000"
                    },
                    {
                        "id": 40335,
                        "name": "Brou-sur-Chantereine",
                        "latitude": "48.88333000",
                        "longitude": "2.63333000"
                    },
                    {
                        "id": 40346,
                        "name": "Brunoy",
                        "latitude": "48.69420000",
                        "longitude": "2.49223000"
                    },
                    {
                        "id": 40350,
                        "name": "Bruyères-le-Châtel",
                        "latitude": "48.58868000",
                        "longitude": "2.18991000"
                    },
                    {
                        "id": 40351,
                        "name": "Bruyères-sur-Oise",
                        "latitude": "49.15756000",
                        "longitude": "2.32577000"
                    },
                    {
                        "id": 40353,
                        "name": "Bry-sur-Marne",
                        "latitude": "48.83811000",
                        "longitude": "2.52488000"
                    },
                    {
                        "id": 40368,
                        "name": "Buc",
                        "latitude": "48.77627000",
                        "longitude": "2.12577000"
                    },
                    {
                        "id": 40369,
                        "name": "Buchelay",
                        "latitude": "48.97926000",
                        "longitude": "1.67026000"
                    },
                    {
                        "id": 40381,
                        "name": "Bullion",
                        "latitude": "48.62285000",
                        "longitude": "1.99024000"
                    },
                    {
                        "id": 40386,
                        "name": "Bures-sur-Yvette",
                        "latitude": "48.69981000",
                        "longitude": "2.17064000"
                    },
                    {
                        "id": 40401,
                        "name": "Bussy-Saint-Georges",
                        "latitude": "48.84099000",
                        "longitude": "2.70165000"
                    },
                    {
                        "id": 40402,
                        "name": "Butry-sur-Oise",
                        "latitude": "49.08837000",
                        "longitude": "2.19916000"
                    },
                    {
                        "id": 40449,
                        "name": "Cachan",
                        "latitude": "48.79632000",
                        "longitude": "2.33661000"
                    },
                    {
                        "id": 40513,
                        "name": "Cannes-Écluse",
                        "latitude": "48.36303000",
                        "longitude": "2.98748000"
                    },
                    {
                        "id": 40559,
                        "name": "Carrières-sous-Poissy",
                        "latitude": "48.94952000",
                        "longitude": "2.04068000"
                    },
                    {
                        "id": 40560,
                        "name": "Carrières-sur-Seine",
                        "latitude": "48.90687000",
                        "longitude": "2.17920000"
                    },
                    {
                        "id": 41390,
                        "name": "Cély",
                        "latitude": "48.45959000",
                        "longitude": "2.53245000"
                    },
                    {
                        "id": 40646,
                        "name": "Cergy",
                        "latitude": "49.03645000",
                        "longitude": "2.07613000"
                    },
                    {
                        "id": 40647,
                        "name": "Cergy-Pontoise",
                        "latitude": "49.03894000",
                        "longitude": "2.07805000"
                    },
                    {
                        "id": 40651,
                        "name": "Cernay-la-Ville",
                        "latitude": "48.67324000",
                        "longitude": "1.97422000"
                    },
                    {
                        "id": 40653,
                        "name": "Cerny",
                        "latitude": "48.47796000",
                        "longitude": "2.32815000"
                    },
                    {
                        "id": 40660,
                        "name": "Cesson",
                        "latitude": "48.56204000",
                        "longitude": "2.60816000"
                    },
                    {
                        "id": 40680,
                        "name": "Chailly-en-Bière",
                        "latitude": "48.46701000",
                        "longitude": "2.60785000"
                    },
                    {
                        "id": 40681,
                        "name": "Chailly-en-Brie",
                        "latitude": "48.79006000",
                        "longitude": "3.12453000"
                    },
                    {
                        "id": 40689,
                        "name": "Chalifert",
                        "latitude": "48.88993000",
                        "longitude": "2.77339000"
                    },
                    {
                        "id": 40697,
                        "name": "Chalo-Saint-Mars",
                        "latitude": "48.42328000",
                        "longitude": "2.06491000"
                    },
                    {
                        "id": 40703,
                        "name": "Chamarande",
                        "latitude": "48.51715000",
                        "longitude": "2.21710000"
                    },
                    {
                        "id": 40709,
                        "name": "Chambourcy",
                        "latitude": "48.90655000",
                        "longitude": "2.04100000"
                    },
                    {
                        "id": 40716,
                        "name": "Chamigny",
                        "latitude": "48.97242000",
                        "longitude": "3.15165000"
                    },
                    {
                        "id": 40722,
                        "name": "Champagne-sur-Oise",
                        "latitude": "49.14052000",
                        "longitude": "2.24233000"
                    },
                    {
                        "id": 40723,
                        "name": "Champagne-sur-Seine",
                        "latitude": "48.39794000",
                        "longitude": "2.79785000"
                    },
                    {
                        "id": 40730,
                        "name": "Champcueil",
                        "latitude": "48.51594000",
                        "longitude": "2.44674000"
                    },
                    {
                        "id": 40742,
                        "name": "Champigny-sur-Marne",
                        "latitude": "48.81642000",
                        "longitude": "2.49366000"
                    },
                    {
                        "id": 40744,
                        "name": "Champlan",
                        "latitude": "48.70823000",
                        "longitude": "2.27975000"
                    },
                    {
                        "id": 40748,
                        "name": "Champs-sur-Marne",
                        "latitude": "48.85000000",
                        "longitude": "2.60000000"
                    },
                    {
                        "id": 40761,
                        "name": "Changis-sur-Marne",
                        "latitude": "48.95816000",
                        "longitude": "3.02191000"
                    },
                    {
                        "id": 40771,
                        "name": "Chanteloup-en-Brie",
                        "latitude": "48.85478000",
                        "longitude": "2.73929000"
                    },
                    {
                        "id": 40772,
                        "name": "Chanteloup-les-Vignes",
                        "latitude": "48.97614000",
                        "longitude": "2.03261000"
                    },
                    {
                        "id": 40783,
                        "name": "Chapet",
                        "latitude": "48.96667000",
                        "longitude": "1.93333000"
                    },
                    {
                        "id": 40798,
                        "name": "Charenton-le-Pont",
                        "latitude": "48.82209000",
                        "longitude": "2.41217000"
                    },
                    {
                        "id": 40812,
                        "name": "Charny",
                        "latitude": "48.97098000",
                        "longitude": "2.76121000"
                    },
                    {
                        "id": 40818,
                        "name": "Chars",
                        "latitude": "49.16032000",
                        "longitude": "1.93669000"
                    },
                    {
                        "id": 40821,
                        "name": "Chartrettes",
                        "latitude": "48.48808000",
                        "longitude": "2.70083000"
                    },
                    {
                        "id": 40941,
                        "name": "Château-Landon",
                        "latitude": "48.14721000",
                        "longitude": "2.69754000"
                    },
                    {
                        "id": 40954,
                        "name": "Châteaufort",
                        "latitude": "48.73584000",
                        "longitude": "2.09054000"
                    },
                    {
                        "id": 40986,
                        "name": "Châtenay-Malabry",
                        "latitude": "48.76507000",
                        "longitude": "2.26655000"
                    },
                    {
                        "id": 40987,
                        "name": "Châtenay-sur-Seine",
                        "latitude": "48.41839000",
                        "longitude": "3.09474000"
                    },
                    {
                        "id": 40992,
                        "name": "Châtillon",
                        "latitude": "48.80240000",
                        "longitude": "2.29346000"
                    },
                    {
                        "id": 40831,
                        "name": "Chatou",
                        "latitude": "48.88980000",
                        "longitude": "2.15863000"
                    },
                    {
                        "id": 40835,
                        "name": "Chauconin-Neufmontiers",
                        "latitude": "48.96667000",
                        "longitude": "2.85000000"
                    },
                    {
                        "id": 40842,
                        "name": "Chaumes-en-Brie",
                        "latitude": "48.66853000",
                        "longitude": "2.84015000"
                    },
                    {
                        "id": 40847,
                        "name": "Chaumontel",
                        "latitude": "49.12470000",
                        "longitude": "2.43237000"
                    },
                    {
                        "id": 40861,
                        "name": "Chavenay",
                        "latitude": "48.85437000",
                        "longitude": "1.99163000"
                    },
                    {
                        "id": 40863,
                        "name": "Chaville",
                        "latitude": "48.80565000",
                        "longitude": "2.18864000"
                    },
                    {
                        "id": 40869,
                        "name": "Chelles",
                        "latitude": "48.88109000",
                        "longitude": "2.59295000"
                    },
                    {
                        "id": 40874,
                        "name": "Chennevières-sur-Marne",
                        "latitude": "48.79702000",
                        "longitude": "2.54046000"
                    },
                    {
                        "id": 40875,
                        "name": "Chenoise",
                        "latitude": "48.61462000",
                        "longitude": "3.19459000"
                    },
                    {
                        "id": 40879,
                        "name": "Cheptainville",
                        "latitude": "48.55090000",
                        "longitude": "2.27665000"
                    },
                    {
                        "id": 40889,
                        "name": "Chessy",
                        "latitude": "48.88333000",
                        "longitude": "2.76667000"
                    },
                    {
                        "id": 40894,
                        "name": "Chevannes",
                        "latitude": "48.53259000",
                        "longitude": "2.44388000"
                    },
                    {
                        "id": 40900,
                        "name": "Chevilly-Larue",
                        "latitude": "48.76476000",
                        "longitude": "2.35030000"
                    },
                    {
                        "id": 40901,
                        "name": "Chevreuse",
                        "latitude": "48.70662000",
                        "longitude": "2.03329000"
                    },
                    {
                        "id": 40904,
                        "name": "Chevry-Cossigny",
                        "latitude": "48.72465000",
                        "longitude": "2.66106000"
                    },
                    {
                        "id": 40909,
                        "name": "Chilly-Mazarin",
                        "latitude": "48.71489000",
                        "longitude": "2.31638000"
                    },
                    {
                        "id": 40922,
                        "name": "Choisy-en-Brie",
                        "latitude": "48.75867000",
                        "longitude": "3.21705000"
                    },
                    {
                        "id": 40923,
                        "name": "Choisy-le-Roi",
                        "latitude": "48.76846000",
                        "longitude": "2.41874000"
                    },
                    {
                        "id": 41039,
                        "name": "Clamart",
                        "latitude": "48.80299000",
                        "longitude": "2.26692000"
                    },
                    {
                        "id": 41046,
                        "name": "Claye-Souilly",
                        "latitude": "48.94492000",
                        "longitude": "2.68566000"
                    },
                    {
                        "id": 41052,
                        "name": "Clichy",
                        "latitude": "48.90018000",
                        "longitude": "2.30952000"
                    },
                    {
                        "id": 41053,
                        "name": "Clichy-sous-Bois",
                        "latitude": "48.91020000",
                        "longitude": "2.55323000"
                    },
                    {
                        "id": 41084,
                        "name": "Coignières",
                        "latitude": "48.75010000",
                        "longitude": "1.92082000"
                    },
                    {
                        "id": 41095,
                        "name": "Collégien",
                        "latitude": "48.83571000",
                        "longitude": "2.67365000"
                    },
                    {
                        "id": 41100,
                        "name": "Colombes",
                        "latitude": "48.91882000",
                        "longitude": "2.25404000"
                    },
                    {
                        "id": 41115,
                        "name": "Combs-la-Ville",
                        "latitude": "48.66497000",
                        "longitude": "2.56957000"
                    },
                    {
                        "id": 41129,
                        "name": "Conches-sur-Gondoire",
                        "latitude": "48.85624000",
                        "longitude": "2.71783000"
                    },
                    {
                        "id": 41135,
                        "name": "Condé-Sainte-Libiaire",
                        "latitude": "48.89695000",
                        "longitude": "2.83904000"
                    },
                    {
                        "id": 41139,
                        "name": "Condé-sur-Vesgre",
                        "latitude": "48.74199000",
                        "longitude": "1.66069000"
                    },
                    {
                        "id": 41142,
                        "name": "Conflans-Sainte-Honorine",
                        "latitude": "49.00158000",
                        "longitude": "2.09694000"
                    },
                    {
                        "id": 41145,
                        "name": "Congis-sur-Thérouanne",
                        "latitude": "49.00000000",
                        "longitude": "2.98333000"
                    },
                    {
                        "id": 41164,
                        "name": "Corbeil-Essonnes",
                        "latitude": "48.60603000",
                        "longitude": "2.48757000"
                    },
                    {
                        "id": 41170,
                        "name": "Corbreuse",
                        "latitude": "48.50065000",
                        "longitude": "1.95913000"
                    },
                    {
                        "id": 41180,
                        "name": "Cormeilles-en-Parisis",
                        "latitude": "48.97111000",
                        "longitude": "2.20491000"
                    },
                    {
                        "id": 41212,
                        "name": "Coubert",
                        "latitude": "48.67186000",
                        "longitude": "2.69733000"
                    },
                    {
                        "id": 41215,
                        "name": "Coubron",
                        "latitude": "48.91667000",
                        "longitude": "2.58333000"
                    },
                    {
                        "id": 41226,
                        "name": "Couilly-Pont-aux-Dames",
                        "latitude": "48.88473000",
                        "longitude": "2.85677000"
                    },
                    {
                        "id": 41235,
                        "name": "Coulommiers",
                        "latitude": "48.81451000",
                        "longitude": "3.08498000"
                    },
                    {
                        "id": 41239,
                        "name": "Coupvray",
                        "latitude": "48.89289000",
                        "longitude": "2.79670000"
                    },
                    {
                        "id": 41241,
                        "name": "Courbevoie",
                        "latitude": "48.89672000",
                        "longitude": "2.25666000"
                    },
                    {
                        "id": 41249,
                        "name": "Courcouronnes",
                        "latitude": "48.61429000",
                        "longitude": "2.40762000"
                    },
                    {
                        "id": 41251,
                        "name": "Courdimanche",
                        "latitude": "49.03513000",
                        "longitude": "2.00096000"
                    },
                    {
                        "id": 41258,
                        "name": "Courpalay",
                        "latitude": "48.64947000",
                        "longitude": "2.96116000"
                    },
                    {
                        "id": 41271,
                        "name": "Courtry",
                        "latitude": "48.91906000",
                        "longitude": "2.60431000"
                    },
                    {
                        "id": 41344,
                        "name": "Crégy-lès-Meaux",
                        "latitude": "48.97648000",
                        "longitude": "2.87483000"
                    },
                    {
                        "id": 41307,
                        "name": "Crespières",
                        "latitude": "48.88317000",
                        "longitude": "1.92151000"
                    },
                    {
                        "id": 41351,
                        "name": "Créteil",
                        "latitude": "48.79266000",
                        "longitude": "2.46569000"
                    },
                    {
                        "id": 41323,
                        "name": "Croissy-Beaubourg",
                        "latitude": "48.82830000",
                        "longitude": "2.66964000"
                    },
                    {
                        "id": 41324,
                        "name": "Croissy-sur-Seine",
                        "latitude": "48.87925000",
                        "longitude": "2.13836000"
                    },
                    {
                        "id": 41327,
                        "name": "Crosne",
                        "latitude": "48.71921000",
                        "longitude": "2.45728000"
                    },
                    {
                        "id": 41333,
                        "name": "Crouy-sur-Ourcq",
                        "latitude": "49.08980000",
                        "longitude": "3.07530000"
                    },
                    {
                        "id": 41415,
                        "name": "Dammarie-les-Lys",
                        "latitude": "48.51667000",
                        "longitude": "2.65000000"
                    },
                    {
                        "id": 41416,
                        "name": "Dammartin-en-Goële",
                        "latitude": "49.05423000",
                        "longitude": "2.67777000"
                    },
                    {
                        "id": 41420,
                        "name": "Dampierre-en-Yvelines",
                        "latitude": "48.70000000",
                        "longitude": "1.98333000"
                    },
                    {
                        "id": 41423,
                        "name": "Dampmart",
                        "latitude": "48.88854000",
                        "longitude": "2.74095000"
                    },
                    {
                        "id": 41616,
                        "name": "Département de l'Essonne",
                        "latitude": "48.50000000",
                        "longitude": "2.25000000"
                    },
                    {
                        "id": 41646,
                        "name": "Département du Val-d’Oise",
                        "latitude": "49.07891000",
                        "longitude": "2.17673000"
                    },
                    {
                        "id": 41459,
                        "name": "Deuil-la-Barre",
                        "latitude": "48.97674000",
                        "longitude": "2.32722000"
                    },
                    {
                        "id": 41521,
                        "name": "Domont",
                        "latitude": "49.02782000",
                        "longitude": "2.32638000"
                    },
                    {
                        "id": 41532,
                        "name": "Donnemarie-Dontilly",
                        "latitude": "48.47719000",
                        "longitude": "3.13162000"
                    },
                    {
                        "id": 41551,
                        "name": "Doue",
                        "latitude": "48.86641000",
                        "longitude": "3.16269000"
                    },
                    {
                        "id": 41554,
                        "name": "Dourdan",
                        "latitude": "48.52772000",
                        "longitude": "2.01113000"
                    },
                    {
                        "id": 41568,
                        "name": "Drancy",
                        "latitude": "48.92578000",
                        "longitude": "2.44533000"
                    },
                    {
                        "id": 41570,
                        "name": "Draveil",
                        "latitude": "48.68466000",
                        "longitude": "2.41418000"
                    },
                    {
                        "id": 41586,
                        "name": "Dugny",
                        "latitude": "48.95371000",
                        "longitude": "2.41734000"
                    },
                    {
                        "id": 41651,
                        "name": "Eaubonne",
                        "latitude": "48.99712000",
                        "longitude": "2.28249000"
                    },
                    {
                        "id": 48047,
                        "name": "Écouen",
                        "latitude": "49.02062000",
                        "longitude": "2.38309000"
                    },
                    {
                        "id": 41658,
                        "name": "Ecquevilly",
                        "latitude": "48.95192000",
                        "longitude": "1.92338000"
                    },
                    {
                        "id": 48054,
                        "name": "Écuelles",
                        "latitude": "48.35636000",
                        "longitude": "2.82335000"
                    },
                    {
                        "id": 48058,
                        "name": "Égly",
                        "latitude": "48.57828000",
                        "longitude": "2.22417000"
                    },
                    {
                        "id": 48059,
                        "name": "Égreville",
                        "latitude": "48.17606000",
                        "longitude": "2.87278000"
                    },
                    {
                        "id": 48063,
                        "name": "Élancourt",
                        "latitude": "48.78421000",
                        "longitude": "1.95520000"
                    },
                    {
                        "id": 48066,
                        "name": "Émerainville",
                        "latitude": "48.81276000",
                        "longitude": "2.62139000"
                    },
                    {
                        "id": 41669,
                        "name": "Enghien-les-Bains",
                        "latitude": "48.96667000",
                        "longitude": "2.31667000"
                    },
                    {
                        "id": 41672,
                        "name": "Ennery",
                        "latitude": "49.07505000",
                        "longitude": "2.10599000"
                    },
                    {
                        "id": 48079,
                        "name": "Épinay-sous-Sénart",
                        "latitude": "48.68970000",
                        "longitude": "2.51186000"
                    },
                    {
                        "id": 48080,
                        "name": "Épinay-sur-Orge",
                        "latitude": "48.67338000",
                        "longitude": "2.31074000"
                    },
                    {
                        "id": 48081,
                        "name": "Épinay-sur-Seine",
                        "latitude": "48.95350000",
                        "longitude": "2.31514000"
                    },
                    {
                        "id": 48085,
                        "name": "Épône",
                        "latitude": "48.95476000",
                        "longitude": "1.82233000"
                    },
                    {
                        "id": 48089,
                        "name": "Éragny",
                        "latitude": "49.01667000",
                        "longitude": "2.10000000"
                    },
                    {
                        "id": 41696,
                        "name": "Ermont",
                        "latitude": "48.99004000",
                        "longitude": "2.25804000"
                    },
                    {
                        "id": 41704,
                        "name": "Esbly",
                        "latitude": "48.90520000",
                        "longitude": "2.81235000"
                    },
                    {
                        "id": 48095,
                        "name": "Étampes",
                        "latitude": "48.43507000",
                        "longitude": "2.16233000"
                    },
                    {
                        "id": 48103,
                        "name": "Étiolles",
                        "latitude": "48.63248000",
                        "longitude": "2.48226000"
                    },
                    {
                        "id": 48113,
                        "name": "Étréchy",
                        "latitude": "48.49465000",
                        "longitude": "2.19489000"
                    },
                    {
                        "id": 48125,
                        "name": "Évry",
                        "latitude": "48.63280000",
                        "longitude": "2.44049000"
                    },
                    {
                        "id": 48126,
                        "name": "Ézanville",
                        "latitude": "49.02794000",
                        "longitude": "2.36787000"
                    },
                    {
                        "id": 41773,
                        "name": "Faremoutiers",
                        "latitude": "48.79962000",
                        "longitude": "2.99607000"
                    },
                    {
                        "id": 41786,
                        "name": "Favières",
                        "latitude": "48.76324000",
                        "longitude": "2.77470000"
                    },
                    {
                        "id": 42007,
                        "name": "Férolles-Attilly",
                        "latitude": "48.73184000",
                        "longitude": "2.63088000"
                    },
                    {
                        "id": 41806,
                        "name": "Ferrières-en-Brie",
                        "latitude": "48.82352000",
                        "longitude": "2.70664000"
                    },
                    {
                        "id": 41810,
                        "name": "Feucherolles",
                        "latitude": "48.87002000",
                        "longitude": "1.97402000"
                    },
                    {
                        "id": 41847,
                        "name": "Fleury-Mérogis",
                        "latitude": "48.63730000",
                        "longitude": "2.36378000"
                    },
                    {
                        "id": 41854,
                        "name": "Flins-sur-Seine",
                        "latitude": "48.96523000",
                        "longitude": "1.87314000"
                    },
                    {
                        "id": 41870,
                        "name": "Follainville-Dennemont",
                        "latitude": "49.02194000",
                        "longitude": "1.71331000"
                    },
                    {
                        "id": 41887,
                        "name": "Fontainebleau",
                        "latitude": "48.40908000",
                        "longitude": "2.70177000"
                    },
                    {
                        "id": 41896,
                        "name": "Fontenay-aux-Roses",
                        "latitude": "48.79325000",
                        "longitude": "2.29275000"
                    },
                    {
                        "id": 41897,
                        "name": "Fontenay-en-Parisis",
                        "latitude": "49.05371000",
                        "longitude": "2.45156000"
                    },
                    {
                        "id": 41899,
                        "name": "Fontenay-le-Fleury",
                        "latitude": "48.81253000",
                        "longitude": "2.04863000"
                    },
                    {
                        "id": 41901,
                        "name": "Fontenay-lès-Briis",
                        "latitude": "48.61962000",
                        "longitude": "2.15276000"
                    },
                    {
                        "id": 41902,
                        "name": "Fontenay-sous-Bois",
                        "latitude": "48.85442000",
                        "longitude": "2.48268000"
                    },
                    {
                        "id": 41895,
                        "name": "Fontenay-Trésigny",
                        "latitude": "48.70647000",
                        "longitude": "2.87047000"
                    },
                    {
                        "id": 41912,
                        "name": "Forges-les-Bains",
                        "latitude": "48.62942000",
                        "longitude": "2.10264000"
                    },
                    {
                        "id": 41920,
                        "name": "Fosses",
                        "latitude": "49.09808000",
                        "longitude": "2.50957000"
                    },
                    {
                        "id": 41939,
                        "name": "Fourqueux",
                        "latitude": "48.88693000",
                        "longitude": "2.06367000"
                    },
                    {
                        "id": 41949,
                        "name": "Franconville",
                        "latitude": "48.98333000",
                        "longitude": "2.23333000"
                    },
                    {
                        "id": 41956,
                        "name": "Freneuse",
                        "latitude": "49.04832000",
                        "longitude": "1.60168000"
                    },
                    {
                        "id": 41987,
                        "name": "Frépillon",
                        "latitude": "49.05216000",
                        "longitude": "2.20528000"
                    },
                    {
                        "id": 41958,
                        "name": "Fresnes",
                        "latitude": "48.75568000",
                        "longitude": "2.32241000"
                    },
                    {
                        "id": 41990,
                        "name": "Fublaines",
                        "latitude": "48.93816000",
                        "longitude": "2.93655000"
                    },
                    {
                        "id": 42012,
                        "name": "Gagny",
                        "latitude": "48.88333000",
                        "longitude": "2.53333000"
                    },
                    {
                        "id": 42023,
                        "name": "Galluis",
                        "latitude": "48.79657000",
                        "longitude": "1.79414000"
                    },
                    {
                        "id": 42025,
                        "name": "Gambais",
                        "latitude": "48.77351000",
                        "longitude": "1.67196000"
                    },
                    {
                        "id": 42032,
                        "name": "Garancières",
                        "latitude": "48.82271000",
                        "longitude": "1.75512000"
                    },
                    {
                        "id": 42034,
                        "name": "Garches",
                        "latitude": "48.84226000",
                        "longitude": "2.18232000"
                    },
                    {
                        "id": 42042,
                        "name": "Gargenville",
                        "latitude": "48.98802000",
                        "longitude": "1.81176000"
                    },
                    {
                        "id": 42043,
                        "name": "Garges-lès-Gonesse",
                        "latitude": "48.96791000",
                        "longitude": "2.39781000"
                    },
                    {
                        "id": 42056,
                        "name": "Gazeran",
                        "latitude": "48.63264000",
                        "longitude": "1.77149000"
                    },
                    {
                        "id": 42068,
                        "name": "Gennevilliers",
                        "latitude": "48.93333000",
                        "longitude": "2.30000000"
                    },
                    {
                        "id": 42070,
                        "name": "Gentilly",
                        "latitude": "48.81294000",
                        "longitude": "2.34170000"
                    },
                    {
                        "id": 42089,
                        "name": "Gif-sur-Yvette",
                        "latitude": "48.68333000",
                        "longitude": "2.13333000"
                    },
                    {
                        "id": 42120,
                        "name": "Gometz-la-Ville",
                        "latitude": "48.67219000",
                        "longitude": "2.12868000"
                    },
                    {
                        "id": 42121,
                        "name": "Gometz-le-Châtel",
                        "latitude": "48.67837000",
                        "longitude": "2.13792000"
                    },
                    {
                        "id": 42129,
                        "name": "Gonesse",
                        "latitude": "48.98693000",
                        "longitude": "2.44892000"
                    },
                    {
                        "id": 42142,
                        "name": "Gouaix",
                        "latitude": "48.48539000",
                        "longitude": "3.29336000"
                    },
                    {
                        "id": 42153,
                        "name": "Gournay-sur-Marne",
                        "latitude": "48.86223000",
                        "longitude": "2.58452000"
                    },
                    {
                        "id": 42154,
                        "name": "Goussainville",
                        "latitude": "49.01367000",
                        "longitude": "2.46595000"
                    },
                    {
                        "id": 42155,
                        "name": "Gouvernes",
                        "latitude": "48.86007000",
                        "longitude": "2.69074000"
                    },
                    {
                        "id": 42202,
                        "name": "Gretz-Armainvilliers",
                        "latitude": "48.74120000",
                        "longitude": "2.73105000"
                    },
                    {
                        "id": 42204,
                        "name": "Grez-sur-Loing",
                        "latitude": "48.31754000",
                        "longitude": "2.68848000"
                    },
                    {
                        "id": 42212,
                        "name": "Grigny",
                        "latitude": "48.65412000",
                        "longitude": "2.39343000"
                    },
                    {
                        "id": 42216,
                        "name": "Grisy-Suisnes",
                        "latitude": "48.68538000",
                        "longitude": "2.66781000"
                    },
                    {
                        "id": 42226,
                        "name": "Groslay",
                        "latitude": "48.98561000",
                        "longitude": "2.34736000"
                    },
                    {
                        "id": 42285,
                        "name": "Guérard",
                        "latitude": "48.82086000",
                        "longitude": "2.95969000"
                    },
                    {
                        "id": 42244,
                        "name": "Guermantes",
                        "latitude": "48.85303000",
                        "longitude": "2.70495000"
                    },
                    {
                        "id": 42246,
                        "name": "Guerville",
                        "latitude": "48.94388000",
                        "longitude": "1.73429000"
                    },
                    {
                        "id": 42256,
                        "name": "Guignes",
                        "latitude": "48.63333000",
                        "longitude": "2.80000000"
                    },
                    {
                        "id": 42276,
                        "name": "Guyancourt",
                        "latitude": "48.77334000",
                        "longitude": "2.07393000"
                    },
                    {
                        "id": 42327,
                        "name": "Hardricourt",
                        "latitude": "49.00779000",
                        "longitude": "1.89389000"
                    },
                    {
                        "id": 42356,
                        "name": "Hauts-de-Seine",
                        "latitude": "48.85000000",
                        "longitude": "2.19293000"
                    },
                    {
                        "id": 42375,
                        "name": "Herblay",
                        "latitude": "48.98994000",
                        "longitude": "2.16990000"
                    },
                    {
                        "id": 42458,
                        "name": "Héricy",
                        "latitude": "48.44848000",
                        "longitude": "2.76445000"
                    },
                    {
                        "id": 42424,
                        "name": "Houdan",
                        "latitude": "48.79044000",
                        "longitude": "1.60007000"
                    },
                    {
                        "id": 42426,
                        "name": "Houilles",
                        "latitude": "48.92161000",
                        "longitude": "2.19263000"
                    },
                    {
                        "id": 42474,
                        "name": "Igny",
                        "latitude": "48.74437000",
                        "longitude": "2.22428000"
                    },
                    {
                        "id": 42506,
                        "name": "Issou",
                        "latitude": "48.98994000",
                        "longitude": "1.79292000"
                    },
                    {
                        "id": 42508,
                        "name": "Issy-les-Moulineaux",
                        "latitude": "48.82104000",
                        "longitude": "2.27718000"
                    },
                    {
                        "id": 42514,
                        "name": "Itteville",
                        "latitude": "48.51536000",
                        "longitude": "2.34377000"
                    },
                    {
                        "id": 42517,
                        "name": "Ivry-sur-Seine",
                        "latitude": "48.81568000",
                        "longitude": "2.38487000"
                    },
                    {
                        "id": 42528,
                        "name": "Janville-sur-Juine",
                        "latitude": "48.51352000",
                        "longitude": "2.27064000"
                    },
                    {
                        "id": 42554,
                        "name": "Joinville-le-Pont",
                        "latitude": "48.82538000",
                        "longitude": "2.47458000"
                    },
                    {
                        "id": 42565,
                        "name": "Jouarre",
                        "latitude": "48.92661000",
                        "longitude": "3.13168000"
                    },
                    {
                        "id": 42566,
                        "name": "Jouars-Pontchartrain",
                        "latitude": "48.78888000",
                        "longitude": "1.89898000"
                    },
                    {
                        "id": 42574,
                        "name": "Jouy-en-Josas",
                        "latitude": "48.75909000",
                        "longitude": "2.16966000"
                    },
                    {
                        "id": 42575,
                        "name": "Jouy-le-Châtel",
                        "latitude": "48.66651000",
                        "longitude": "3.13036000"
                    },
                    {
                        "id": 42576,
                        "name": "Jouy-le-Moutier",
                        "latitude": "49.01068000",
                        "longitude": "2.04028000"
                    },
                    {
                        "id": 42578,
                        "name": "Jouy-sur-Morin",
                        "latitude": "48.79500000",
                        "longitude": "3.27238000"
                    },
                    {
                        "id": 42587,
                        "name": "Juilly",
                        "latitude": "49.01375000",
                        "longitude": "2.70563000"
                    },
                    {
                        "id": 42601,
                        "name": "Juvisy-sur-Orge",
                        "latitude": "48.68333000",
                        "longitude": "2.38333000"
                    },
                    {
                        "id": 42602,
                        "name": "Juziers",
                        "latitude": "48.99137000",
                        "longitude": "1.84760000"
                    },
                    {
                        "id": 42626,
                        "name": "L'Haÿ-les-Roses",
                        "latitude": "48.78333000",
                        "longitude": "2.33333000"
                    },
                    {
                        "id": 43708,
                        "name": "L’Étang-la-Ville",
                        "latitude": "48.86954000",
                        "longitude": "2.05732000"
                    },
                    {
                        "id": 43703,
                        "name": "L’Isle-Adam",
                        "latitude": "49.10744000",
                        "longitude": "2.22818000"
                    },
                    {
                        "id": 42672,
                        "name": "La Celle-Saint-Cloud",
                        "latitude": "48.85029000",
                        "longitude": "2.14523000"
                    },
                    {
                        "id": 42673,
                        "name": "La Celle-sur-Morin",
                        "latitude": "48.81146000",
                        "longitude": "2.96921000"
                    },
                    {
                        "id": 42679,
                        "name": "La Chapelle-Gauthier",
                        "latitude": "48.54947000",
                        "longitude": "2.89776000"
                    },
                    {
                        "id": 42698,
                        "name": "La Chapelle-la-Reine",
                        "latitude": "48.31813000",
                        "longitude": "2.57152000"
                    },
                    {
                        "id": 42699,
                        "name": "La Chapelle-sur-Crécy",
                        "latitude": "48.85879000",
                        "longitude": "2.92597000"
                    },
                    {
                        "id": 42716,
                        "name": "La Courneuve",
                        "latitude": "48.92805000",
                        "longitude": "2.39627000"
                    },
                    {
                        "id": 42728,
                        "name": "La Defense",
                        "latitude": "48.89198000",
                        "longitude": "2.23881000"
                    },
                    {
                        "id": 42736,
                        "name": "La Ferté-Alais",
                        "latitude": "48.48306000",
                        "longitude": "2.34802000"
                    },
                    {
                        "id": 42738,
                        "name": "La Ferté-Gaucher",
                        "latitude": "48.78310000",
                        "longitude": "3.30678000"
                    },
                    {
                        "id": 42743,
                        "name": "La Ferté-sous-Jouarre",
                        "latitude": "48.95140000",
                        "longitude": "3.12724000"
                    },
                    {
                        "id": 42758,
                        "name": "La Frette-sur-Seine",
                        "latitude": "48.98057000",
                        "longitude": "2.17866000"
                    },
                    {
                        "id": 42764,
                        "name": "La Garenne-Colombes",
                        "latitude": "48.90472000",
                        "longitude": "2.24690000"
                    },
                    {
                        "id": 42773,
                        "name": "La Grande-Paroisse",
                        "latitude": "48.38682000",
                        "longitude": "2.90157000"
                    },
                    {
                        "id": 42783,
                        "name": "La Houssaye-en-Brie",
                        "latitude": "48.75381000",
                        "longitude": "2.86552000"
                    },
                    {
                        "id": 42824,
                        "name": "La Norville",
                        "latitude": "48.58243000",
                        "longitude": "2.26180000"
                    },
                    {
                        "id": 42839,
                        "name": "La Queue-en-Brie",
                        "latitude": "48.78520000",
                        "longitude": "2.58112000"
                    },
                    {
                        "id": 42840,
                        "name": "La Queue-les-Yvelines",
                        "latitude": "48.80000000",
                        "longitude": "1.76667000"
                    },
                    {
                        "id": 42863,
                        "name": "La Rochette",
                        "latitude": "48.50882000",
                        "longitude": "2.66357000"
                    },
                    {
                        "id": 42910,
                        "name": "La Verrière",
                        "latitude": "48.75200000",
                        "longitude": "1.94649000"
                    },
                    {
                        "id": 42914,
                        "name": "La Ville-du-Bois",
                        "latitude": "48.65521000",
                        "longitude": "2.26833000"
                    },
                    {
                        "id": 42959,
                        "name": "Lagny-sur-Marne",
                        "latitude": "48.86667000",
                        "longitude": "2.71667000"
                    },
                    {
                        "id": 43069,
                        "name": "Lardy",
                        "latitude": "48.51847000",
                        "longitude": "2.27360000"
                    },
                    {
                        "id": 43131,
                        "name": "Le Blanc-Mesnil",
                        "latitude": "48.93872000",
                        "longitude": "2.46138000"
                    },
                    {
                        "id": 43138,
                        "name": "Le Bourget",
                        "latitude": "48.93405000",
                        "longitude": "2.43584000"
                    },
                    {
                        "id": 43169,
                        "name": "Le Châtelet-en-Brie",
                        "latitude": "48.50695000",
                        "longitude": "2.79163000"
                    },
                    {
                        "id": 43165,
                        "name": "Le Chesnay",
                        "latitude": "48.82220000",
                        "longitude": "2.12213000"
                    },
                    {
                        "id": 43173,
                        "name": "Le Coudray-Montceaux",
                        "latitude": "48.56376000",
                        "longitude": "2.50013000"
                    },
                    {
                        "id": 43208,
                        "name": "Le Kremlin-Bicêtre",
                        "latitude": "48.81471000",
                        "longitude": "2.36073000"
                    },
                    {
                        "id": 43239,
                        "name": "Le Mée-sur-Seine",
                        "latitude": "48.53157000",
                        "longitude": "2.62829000"
                    },
                    {
                        "id": 43230,
                        "name": "Le Mesnil-le-Roi",
                        "latitude": "48.93825000",
                        "longitude": "2.12554000"
                    },
                    {
                        "id": 43227,
                        "name": "Le Mesnil-Saint-Denis",
                        "latitude": "48.74485000",
                        "longitude": "1.95594000"
                    },
                    {
                        "id": 43247,
                        "name": "Le Pecq",
                        "latitude": "48.89317000",
                        "longitude": "2.10371000"
                    },
                    {
                        "id": 43249,
                        "name": "Le Perray-en-Yvelines",
                        "latitude": "48.69441000",
                        "longitude": "1.85643000"
                    },
                    {
                        "id": 43250,
                        "name": "Le Perreux-sur-Marne",
                        "latitude": "48.85000000",
                        "longitude": "2.50000000"
                    },
                    {
                        "id": 43257,
                        "name": "Le Pin",
                        "latitude": "48.91523000",
                        "longitude": "2.62841000"
                    },
                    {
                        "id": 43264,
                        "name": "Le Plessis-Bouchard",
                        "latitude": "49.00000000",
                        "longitude": "2.23333000"
                    },
                    {
                        "id": 43268,
                        "name": "Le Plessis-Pâté",
                        "latitude": "48.61078000",
                        "longitude": "2.32318000"
                    },
                    {
                        "id": 43269,
                        "name": "Le Plessis-Robinson",
                        "latitude": "48.78889000",
                        "longitude": "2.27078000"
                    },
                    {
                        "id": 43270,
                        "name": "Le Plessis-Trévise",
                        "latitude": "48.81074000",
                        "longitude": "2.57363000"
                    },
                    {
                        "id": 43277,
                        "name": "Le Port-Marly",
                        "latitude": "48.89016000",
                        "longitude": "2.11139000"
                    },
                    {
                        "id": 43284,
                        "name": "Le Pré-Saint-Gervais",
                        "latitude": "48.88549000",
                        "longitude": "2.40422000"
                    },
                    {
                        "id": 43291,
                        "name": "Le Raincy",
                        "latitude": "48.89916000",
                        "longitude": "2.52298000"
                    },
                    {
                        "id": 43312,
                        "name": "Le Thillay",
                        "latitude": "49.00659000",
                        "longitude": "2.47218000"
                    },
                    {
                        "id": 43327,
                        "name": "Le Val-Saint-Germain",
                        "latitude": "48.56601000",
                        "longitude": "2.06471000"
                    },
                    {
                        "id": 43337,
                        "name": "Le Vésinet",
                        "latitude": "48.89281000",
                        "longitude": "2.13308000"
                    },
                    {
                        "id": 43360,
                        "name": "Les Alluets-le-Roi",
                        "latitude": "48.91379000",
                        "longitude": "1.91810000"
                    },
                    {
                        "id": 43378,
                        "name": "Les Clayes-sous-Bois",
                        "latitude": "48.82206000",
                        "longitude": "1.98677000"
                    },
                    {
                        "id": 43386,
                        "name": "Les Essarts-le-Roi",
                        "latitude": "48.71673000",
                        "longitude": "1.90089000"
                    },
                    {
                        "id": 43398,
                        "name": "Les Lilas",
                        "latitude": "48.87992000",
                        "longitude": "2.42057000"
                    },
                    {
                        "id": 43401,
                        "name": "Les Loges-en-Josas",
                        "latitude": "48.76377000",
                        "longitude": "2.14002000"
                    },
                    {
                        "id": 43409,
                        "name": "Les Molières",
                        "latitude": "48.67306000",
                        "longitude": "2.06959000"
                    },
                    {
                        "id": 43412,
                        "name": "Les Mureaux",
                        "latitude": "48.99173000",
                        "longitude": "1.90972000"
                    },
                    {
                        "id": 43418,
                        "name": "Les Pavillons-sous-Bois",
                        "latitude": "48.90683000",
                        "longitude": "2.50648000"
                    },
                    {
                        "id": 43432,
                        "name": "Les Ulis",
                        "latitude": "48.68167000",
                        "longitude": "2.16944000"
                    },
                    {
                        "id": 43692,
                        "name": "Lésigny",
                        "latitude": "48.74374000",
                        "longitude": "2.61518000"
                    },
                    {
                        "id": 43446,
                        "name": "Leudeville",
                        "latitude": "48.56591000",
                        "longitude": "2.32676000"
                    },
                    {
                        "id": 43447,
                        "name": "Leuville-sur-Orge",
                        "latitude": "48.61730000",
                        "longitude": "2.26685000"
                    },
                    {
                        "id": 43449,
                        "name": "Levallois-Perret",
                        "latitude": "48.89389000",
                        "longitude": "2.28864000"
                    },
                    {
                        "id": 43694,
                        "name": "Lévis-Saint-Nom",
                        "latitude": "48.71667000",
                        "longitude": "1.95000000"
                    },
                    {
                        "id": 43472,
                        "name": "Lieusaint",
                        "latitude": "48.63476000",
                        "longitude": "2.54806000"
                    },
                    {
                        "id": 43489,
                        "name": "Limay",
                        "latitude": "48.99553000",
                        "longitude": "1.74081000"
                    },
                    {
                        "id": 43490,
                        "name": "Limeil-Brévannes",
                        "latitude": "48.74480000",
                        "longitude": "2.48705000"
                    },
                    {
                        "id": 43492,
                        "name": "Limetz-Villez",
                        "latitude": "49.06667000",
                        "longitude": "1.55000000"
                    },
                    {
                        "id": 43495,
                        "name": "Limours",
                        "latitude": "48.64625000",
                        "longitude": "2.07688000"
                    },
                    {
                        "id": 43500,
                        "name": "Linas",
                        "latitude": "48.63041000",
                        "longitude": "2.26266000"
                    },
                    {
                        "id": 43510,
                        "name": "Lisses",
                        "latitude": "48.60222000",
                        "longitude": "2.42245000"
                    },
                    {
                        "id": 43516,
                        "name": "Liverdy-en-Brie",
                        "latitude": "48.69987000",
                        "longitude": "2.77606000"
                    },
                    {
                        "id": 43520,
                        "name": "Livry-Gargan",
                        "latitude": "48.91930000",
                        "longitude": "2.54305000"
                    },
                    {
                        "id": 43521,
                        "name": "Livry-sur-Seine",
                        "latitude": "48.51771000",
                        "longitude": "2.67879000"
                    },
                    {
                        "id": 43523,
                        "name": "Lizy-sur-Ourcq",
                        "latitude": "49.02454000",
                        "longitude": "3.02178000"
                    },
                    {
                        "id": 43538,
                        "name": "Lognes",
                        "latitude": "48.83541000",
                        "longitude": "2.62998000"
                    },
                    {
                        "id": 43561,
                        "name": "Longjumeau",
                        "latitude": "48.69503000",
                        "longitude": "2.30735000"
                    },
                    {
                        "id": 43563,
                        "name": "Longnes",
                        "latitude": "48.92002000",
                        "longitude": "1.58705000"
                    },
                    {
                        "id": 43565,
                        "name": "Longperrier",
                        "latitude": "49.04844000",
                        "longitude": "2.66571000"
                    },
                    {
                        "id": 43566,
                        "name": "Longpont-sur-Orge",
                        "latitude": "48.64171000",
                        "longitude": "2.29278000"
                    },
                    {
                        "id": 43572,
                        "name": "Longueville",
                        "latitude": "48.51503000",
                        "longitude": "3.24677000"
                    },
                    {
                        "id": 43594,
                        "name": "Lorrez-le-Bocage-Préaux",
                        "latitude": "48.23333000",
                        "longitude": "2.90000000"
                    },
                    {
                        "id": 43611,
                        "name": "Louveciennes",
                        "latitude": "48.86115000",
                        "longitude": "2.11463000"
                    },
                    {
                        "id": 43618,
                        "name": "Louvres",
                        "latitude": "49.04460000",
                        "longitude": "2.50479000"
                    },
                    {
                        "id": 43649,
                        "name": "Lumigny-Nesles-Ormeaux",
                        "latitude": "48.73333000",
                        "longitude": "2.95000000"
                    },
                    {
                        "id": 43671,
                        "name": "Luzarches",
                        "latitude": "49.11319000",
                        "longitude": "2.42230000"
                    },
                    {
                        "id": 43716,
                        "name": "Maffliers",
                        "latitude": "49.07758000",
                        "longitude": "2.30768000"
                    },
                    {
                        "id": 43723,
                        "name": "Magnanville",
                        "latitude": "48.96798000",
                        "longitude": "1.67842000"
                    },
                    {
                        "id": 43726,
                        "name": "Magny-en-Vexin",
                        "latitude": "49.15515000",
                        "longitude": "1.78669000"
                    },
                    {
                        "id": 43728,
                        "name": "Magny-le-Hongre",
                        "latitude": "48.86325000",
                        "longitude": "2.81546000"
                    },
                    {
                        "id": 43729,
                        "name": "Magny-les-Hameaux",
                        "latitude": "48.74345000",
                        "longitude": "2.06154000"
                    },
                    {
                        "id": 43737,
                        "name": "Maincy",
                        "latitude": "48.54977000",
                        "longitude": "2.70017000"
                    },
                    {
                        "id": 43743,
                        "name": "Maisons-Alfort",
                        "latitude": "48.81171000",
                        "longitude": "2.43945000"
                    },
                    {
                        "id": 43744,
                        "name": "Maisons-Laffitte",
                        "latitude": "48.95264000",
                        "longitude": "2.14521000"
                    },
                    {
                        "id": 43745,
                        "name": "Maisse",
                        "latitude": "48.39525000",
                        "longitude": "2.37902000"
                    },
                    {
                        "id": 43748,
                        "name": "Malakoff",
                        "latitude": "48.81999000",
                        "longitude": "2.29998000"
                    },
                    {
                        "id": 43775,
                        "name": "Mandres-les-Roses",
                        "latitude": "48.70198000",
                        "longitude": "2.54662000"
                    },
                    {
                        "id": 43784,
                        "name": "Mantes-la-Jolie",
                        "latitude": "48.99048000",
                        "longitude": "1.71670000"
                    },
                    {
                        "id": 43785,
                        "name": "Mantes-la-Ville",
                        "latitude": "48.97374000",
                        "longitude": "1.70253000"
                    },
                    {
                        "id": 43815,
                        "name": "Marcoussis",
                        "latitude": "48.64026000",
                        "longitude": "2.23858000"
                    },
                    {
                        "id": 43820,
                        "name": "Mareil-Marly",
                        "latitude": "48.88213000",
                        "longitude": "2.07351000"
                    },
                    {
                        "id": 43821,
                        "name": "Mareil-sur-Mauldre",
                        "latitude": "48.89521000",
                        "longitude": "1.86870000"
                    },
                    {
                        "id": 43827,
                        "name": "Mareuil-lès-Meaux",
                        "latitude": "48.92648000",
                        "longitude": "2.86134000"
                    },
                    {
                        "id": 43834,
                        "name": "Margency",
                        "latitude": "49.00000000",
                        "longitude": "2.30000000"
                    },
                    {
                        "id": 43846,
                        "name": "Marines",
                        "latitude": "49.14485000",
                        "longitude": "1.98226000"
                    },
                    {
                        "id": 43850,
                        "name": "Marles-en-Brie",
                        "latitude": "48.72783000",
                        "longitude": "2.88003000"
                    },
                    {
                        "id": 43855,
                        "name": "Marly-la-Ville",
                        "latitude": "49.08201000",
                        "longitude": "2.50347000"
                    },
                    {
                        "id": 43856,
                        "name": "Marly-le-Roi",
                        "latitude": "48.86667000",
                        "longitude": "2.08333000"
                    },
                    {
                        "id": 43864,
                        "name": "Marnes-la-Coquette",
                        "latitude": "48.82732000",
                        "longitude": "2.17151000"
                    },
                    {
                        "id": 43866,
                        "name": "Marolles-en-Hurepoix",
                        "latitude": "48.56232000",
                        "longitude": "2.29885000"
                    },
                    {
                        "id": 43868,
                        "name": "Marolles-sur-Seine",
                        "latitude": "48.38662000",
                        "longitude": "3.03562000"
                    },
                    {
                        "id": 43923,
                        "name": "Mary-sur-Marne",
                        "latitude": "49.01591000",
                        "longitude": "3.02788000"
                    },
                    {
                        "id": 43936,
                        "name": "Massy",
                        "latitude": "48.72692000",
                        "longitude": "2.28301000"
                    },
                    {
                        "id": 43948,
                        "name": "Maule",
                        "latitude": "48.91056000",
                        "longitude": "1.85264000"
                    },
                    {
                        "id": 43952,
                        "name": "Maurecourt",
                        "latitude": "48.99614000",
                        "longitude": "2.06155000"
                    },
                    {
                        "id": 43955,
                        "name": "Maurepas",
                        "latitude": "48.76486000",
                        "longitude": "1.92923000"
                    },
                    {
                        "id": 43983,
                        "name": "Meaux",
                        "latitude": "48.96014000",
                        "longitude": "2.87885000"
                    },
                    {
                        "id": 44457,
                        "name": "Médan",
                        "latitude": "48.95539000",
                        "longitude": "1.99494000"
                    },
                    {
                        "id": 43998,
                        "name": "Melun",
                        "latitude": "48.54570000",
                        "longitude": "2.65356000"
                    },
                    {
                        "id": 44001,
                        "name": "Mennecy",
                        "latitude": "48.56903000",
                        "longitude": "2.44384000"
                    },
                    {
                        "id": 44008,
                        "name": "Menucourt",
                        "latitude": "49.02841000",
                        "longitude": "1.98046000"
                    },
                    {
                        "id": 44480,
                        "name": "Méré",
                        "latitude": "48.78445000",
                        "longitude": "1.81247000"
                    },
                    {
                        "id": 44482,
                        "name": "Méréville",
                        "latitude": "48.31476000",
                        "longitude": "2.08609000"
                    },
                    {
                        "id": 44472,
                        "name": "Mériel",
                        "latitude": "49.07614000",
                        "longitude": "2.21054000"
                    },
                    {
                        "id": 44478,
                        "name": "Méry-sur-Oise",
                        "latitude": "49.05876000",
                        "longitude": "2.19113000"
                    },
                    {
                        "id": 44045,
                        "name": "Meudon",
                        "latitude": "48.81381000",
                        "longitude": "2.23500000"
                    },
                    {
                        "id": 44046,
                        "name": "Meulan-en-Yvelines",
                        "latitude": "49.00768000",
                        "longitude": "1.90602000"
                    },
                    {
                        "id": 44490,
                        "name": "Mézières-sur-Seine",
                        "latitude": "48.96128000",
                        "longitude": "1.79245000"
                    },
                    {
                        "id": 44491,
                        "name": "Mézy-sur-Seine",
                        "latitude": "49.00000000",
                        "longitude": "1.88333000"
                    },
                    {
                        "id": 44076,
                        "name": "Milly-la-Forêt",
                        "latitude": "48.40400000",
                        "longitude": "2.47015000"
                    },
                    {
                        "id": 44106,
                        "name": "Mitry-Mory",
                        "latitude": "48.98333000",
                        "longitude": "2.61667000"
                    },
                    {
                        "id": 44112,
                        "name": "Moigny-sur-École",
                        "latitude": "48.43262000",
                        "longitude": "2.45802000"
                    },
                    {
                        "id": 44116,
                        "name": "Moisenay",
                        "latitude": "48.56266000",
                        "longitude": "2.73527000"
                    },
                    {
                        "id": 44119,
                        "name": "Moisselles",
                        "latitude": "49.05000000",
                        "longitude": "2.33597000"
                    },
                    {
                        "id": 44120,
                        "name": "Moissy-Cramayel",
                        "latitude": "48.62605000",
                        "longitude": "2.60125000"
                    },
                    {
                        "id": 44210,
                        "name": "Montcourt-Fromonville",
                        "latitude": "48.30672000",
                        "longitude": "2.70460000"
                    },
                    {
                        "id": 44222,
                        "name": "Montereau-Fault-Yonne",
                        "latitude": "48.38333000",
                        "longitude": "2.95000000"
                    },
                    {
                        "id": 44228,
                        "name": "Montesson",
                        "latitude": "48.90924000",
                        "longitude": "2.13754000"
                    },
                    {
                        "id": 44335,
                        "name": "Montévrain",
                        "latitude": "48.87415000",
                        "longitude": "2.75114000"
                    },
                    {
                        "id": 44235,
                        "name": "Montfermeil",
                        "latitude": "48.89820000",
                        "longitude": "2.57913000"
                    },
                    {
                        "id": 44246,
                        "name": "Montgeron",
                        "latitude": "48.70543000",
                        "longitude": "2.45039000"
                    },
                    {
                        "id": 44251,
                        "name": "Monthyon",
                        "latitude": "49.00753000",
                        "longitude": "2.82610000"
                    },
                    {
                        "id": 44260,
                        "name": "Montigny-le-Bretonneux",
                        "latitude": "48.76636000",
                        "longitude": "2.03405000"
                    },
                    {
                        "id": 44257,
                        "name": "Montigny-Lencoup",
                        "latitude": "48.45162000",
                        "longitude": "3.06503000"
                    },
                    {
                        "id": 44261,
                        "name": "Montigny-lès-Cormeilles",
                        "latitude": "48.98201000",
                        "longitude": "2.20035000"
                    },
                    {
                        "id": 44263,
                        "name": "Montigny-sur-Loing",
                        "latitude": "48.33575000",
                        "longitude": "2.74423000"
                    },
                    {
                        "id": 44271,
                        "name": "Montlhéry",
                        "latitude": "48.64004000",
                        "longitude": "2.27465000"
                    },
                    {
                        "id": 44273,
                        "name": "Montlignon",
                        "latitude": "49.00636000",
                        "longitude": "2.28705000"
                    },
                    {
                        "id": 44279,
                        "name": "Montmagny",
                        "latitude": "48.97338000",
                        "longitude": "2.34688000"
                    },
                    {
                        "id": 44287,
                        "name": "Montmorency",
                        "latitude": "48.98826000",
                        "longitude": "2.34340000"
                    },
                    {
                        "id": 44307,
                        "name": "Montreuil",
                        "latitude": "48.86415000",
                        "longitude": "2.44322000"
                    },
                    {
                        "id": 44322,
                        "name": "Montrouge",
                        "latitude": "48.81620000",
                        "longitude": "2.31393000"
                    },
                    {
                        "id": 44323,
                        "name": "Montry",
                        "latitude": "48.88409000",
                        "longitude": "2.82915000"
                    },
                    {
                        "id": 44328,
                        "name": "Montsoult",
                        "latitude": "49.06942000",
                        "longitude": "2.31966000"
                    },
                    {
                        "id": 44338,
                        "name": "Morainvilliers",
                        "latitude": "48.92902000",
                        "longitude": "1.93621000"
                    },
                    {
                        "id": 44341,
                        "name": "Morangis",
                        "latitude": "48.70383000",
                        "longitude": "2.33908000"
                    },
                    {
                        "id": 44349,
                        "name": "Moret-sur-Loing",
                        "latitude": "48.37239000",
                        "longitude": "2.81713000"
                    },
                    {
                        "id": 44354,
                        "name": "Morigny-Champigny",
                        "latitude": "48.44685000",
                        "longitude": "2.18351000"
                    },
                    {
                        "id": 44358,
                        "name": "Mormant",
                        "latitude": "48.60901000",
                        "longitude": "2.89025000"
                    },
                    {
                        "id": 44365,
                        "name": "Morsang-sur-Orge",
                        "latitude": "48.66181000",
                        "longitude": "2.35338000"
                    },
                    {
                        "id": 44373,
                        "name": "Mortcerf",
                        "latitude": "48.78879000",
                        "longitude": "2.91692000"
                    },
                    {
                        "id": 44403,
                        "name": "Mouroux",
                        "latitude": "48.82263000",
                        "longitude": "3.03879000"
                    },
                    {
                        "id": 44404,
                        "name": "Mours",
                        "latitude": "49.13077000",
                        "longitude": "2.26761000"
                    },
                    {
                        "id": 44408,
                        "name": "Moussy-le-Neuf",
                        "latitude": "49.06427000",
                        "longitude": "2.60252000"
                    },
                    {
                        "id": 44409,
                        "name": "Moussy-le-Vieux",
                        "latitude": "49.04712000",
                        "longitude": "2.62493000"
                    },
                    {
                        "id": 44502,
                        "name": "Nandy",
                        "latitude": "48.58301000",
                        "longitude": "2.56292000"
                    },
                    {
                        "id": 44503,
                        "name": "Nangis",
                        "latitude": "48.55535000",
                        "longitude": "3.01306000"
                    },
                    {
                        "id": 44505,
                        "name": "Nanterre",
                        "latitude": "48.89198000",
                        "longitude": "2.20675000"
                    },
                    {
                        "id": 44510,
                        "name": "Nanteuil-lès-Meaux",
                        "latitude": "48.92940000",
                        "longitude": "2.89594000"
                    },
                    {
                        "id": 44528,
                        "name": "Neauphle-le-Château",
                        "latitude": "48.81418000",
                        "longitude": "1.90567000"
                    },
                    {
                        "id": 44529,
                        "name": "Nemours",
                        "latitude": "48.27511000",
                        "longitude": "2.69078000"
                    },
                    {
                        "id": 44535,
                        "name": "Nesles-la-Vallée",
                        "latitude": "49.13202000",
                        "longitude": "2.17099000"
                    },
                    {
                        "id": 44545,
                        "name": "Neufmoutiers-en-Brie",
                        "latitude": "48.76882000",
                        "longitude": "2.83156000"
                    },
                    {
                        "id": 44546,
                        "name": "Neuilly-Plaisance",
                        "latitude": "48.86342000",
                        "longitude": "2.50600000"
                    },
                    {
                        "id": 44552,
                        "name": "Neuilly-sur-Marne",
                        "latitude": "48.85373000",
                        "longitude": "2.54903000"
                    },
                    {
                        "id": 44553,
                        "name": "Neuilly-sur-Seine",
                        "latitude": "48.88460000",
                        "longitude": "2.26965000"
                    },
                    {
                        "id": 44571,
                        "name": "Neuville-sur-Oise",
                        "latitude": "49.01667000",
                        "longitude": "2.06667000"
                    },
                    {
                        "id": 44615,
                        "name": "Nogent-sur-Marne",
                        "latitude": "48.83669000",
                        "longitude": "2.48255000"
                    },
                    {
                        "id": 44626,
                        "name": "Noiseau",
                        "latitude": "48.77589000",
                        "longitude": "2.54892000"
                    },
                    {
                        "id": 44627,
                        "name": "Noisiel",
                        "latitude": "48.84868000",
                        "longitude": "2.62435000"
                    },
                    {
                        "id": 44628,
                        "name": "Noisy-le-Grand",
                        "latitude": "48.84979000",
                        "longitude": "2.56266000"
                    },
                    {
                        "id": 44629,
                        "name": "Noisy-le-Roi",
                        "latitude": "48.84445000",
                        "longitude": "2.06345000"
                    },
                    {
                        "id": 44630,
                        "name": "Noisy-le-Sec",
                        "latitude": "48.89148000",
                        "longitude": "2.46451000"
                    },
                    {
                        "id": 44631,
                        "name": "Noisy-sur-École",
                        "latitude": "48.36701000",
                        "longitude": "2.50804000"
                    },
                    {
                        "id": 44681,
                        "name": "Nozay",
                        "latitude": "48.65921000",
                        "longitude": "2.24151000"
                    },
                    {
                        "id": 44725,
                        "name": "Oinville-sur-Montcient",
                        "latitude": "49.02722000",
                        "longitude": "1.84928000"
                    },
                    {
                        "id": 44729,
                        "name": "Oissery",
                        "latitude": "49.07047000",
                        "longitude": "2.81819000"
                    },
                    {
                        "id": 44734,
                        "name": "Ollainville",
                        "latitude": "48.59081000",
                        "longitude": "2.21936000"
                    },
                    {
                        "id": 44762,
                        "name": "Orgerus",
                        "latitude": "48.83851000",
                        "longitude": "1.70132000"
                    },
                    {
                        "id": 44763,
                        "name": "Orgeval",
                        "latitude": "48.92162000",
                        "longitude": "1.97790000"
                    },
                    {
                        "id": 44773,
                        "name": "Orly",
                        "latitude": "48.74792000",
                        "longitude": "2.39253000"
                    },
                    {
                        "id": 44777,
                        "name": "Ormesson-sur-Marne",
                        "latitude": "48.78630000",
                        "longitude": "2.54471000"
                    },
                    {
                        "id": 44778,
                        "name": "Ormoy",
                        "latitude": "48.57489000",
                        "longitude": "2.45206000"
                    },
                    {
                        "id": 44784,
                        "name": "Orsay",
                        "latitude": "48.69572000",
                        "longitude": "2.18727000"
                    },
                    {
                        "id": 44789,
                        "name": "Osny",
                        "latitude": "49.07010000",
                        "longitude": "2.06277000"
                    },
                    {
                        "id": 44796,
                        "name": "Othis",
                        "latitude": "49.07387000",
                        "longitude": "2.67502000"
                    },
                    {
                        "id": 44821,
                        "name": "Ozoir-la-Ferrière",
                        "latitude": "48.76699000",
                        "longitude": "2.66871000"
                    },
                    {
                        "id": 44822,
                        "name": "Ozouer-le-Voulgis",
                        "latitude": "48.66012000",
                        "longitude": "2.77409000"
                    },
                    {
                        "id": 44832,
                        "name": "Palaiseau",
                        "latitude": "48.71828000",
                        "longitude": "2.24980000"
                    },
                    {
                        "id": 44845,
                        "name": "Pantin",
                        "latitude": "48.89437000",
                        "longitude": "2.40935000"
                    },
                    {
                        "id": 44847,
                        "name": "Paray-Vieille-Poste",
                        "latitude": "48.71402000",
                        "longitude": "2.36283000"
                    },
                    {
                        "id": 44856,
                        "name": "Paris",
                        "latitude": "48.85340000",
                        "longitude": "2.34860000"
                    },
                    {
                        "id": 44857,
                        "name": "Parmain",
                        "latitude": "49.11247000",
                        "longitude": "2.21487000"
                    },
                    {
                        "id": 45358,
                        "name": "Périgny",
                        "latitude": "48.69656000",
                        "longitude": "2.55537000"
                    },
                    {
                        "id": 44909,
                        "name": "Persan",
                        "latitude": "49.15335000",
                        "longitude": "2.27218000"
                    },
                    {
                        "id": 44910,
                        "name": "Perthes",
                        "latitude": "48.47821000",
                        "longitude": "2.55509000"
                    },
                    {
                        "id": 44955,
                        "name": "Pierrefitte-sur-Seine",
                        "latitude": "48.96691000",
                        "longitude": "2.36104000"
                    },
                    {
                        "id": 44960,
                        "name": "Pierrelaye",
                        "latitude": "49.02110000",
                        "longitude": "2.15481000"
                    },
                    {
                        "id": 44995,
                        "name": "Plaisir",
                        "latitude": "48.82319000",
                        "longitude": "1.95410000"
                    },
                    {
                        "id": 45136,
                        "name": "Poissy",
                        "latitude": "48.92902000",
                        "longitude": "2.04952000"
                    },
                    {
                        "id": 45151,
                        "name": "Pommeuse",
                        "latitude": "48.81667000",
                        "longitude": "3.01667000"
                    },
                    {
                        "id": 45158,
                        "name": "Pomponne",
                        "latitude": "48.88130000",
                        "longitude": "2.68232000"
                    },
                    {
                        "id": 45202,
                        "name": "Pontault-Combault",
                        "latitude": "48.79813000",
                        "longitude": "2.60676000"
                    },
                    {
                        "id": 45203,
                        "name": "Pontcarré",
                        "latitude": "48.79772000",
                        "longitude": "2.70508000"
                    },
                    {
                        "id": 45210,
                        "name": "Ponthierry",
                        "latitude": "48.53366000",
                        "longitude": "2.54419000"
                    },
                    {
                        "id": 45213,
                        "name": "Pontoise",
                        "latitude": "49.05000000",
                        "longitude": "2.10000000"
                    },
                    {
                        "id": 45220,
                        "name": "Porcheville",
                        "latitude": "48.97254000",
                        "longitude": "1.77973000"
                    },
                    {
                        "id": 45283,
                        "name": "Presles-en-Brie",
                        "latitude": "48.71527000",
                        "longitude": "2.74112000"
                    },
                    {
                        "id": 45288,
                        "name": "Pringy",
                        "latitude": "48.51815000",
                        "longitude": "2.56333000"
                    },
                    {
                        "id": 45298,
                        "name": "Provins",
                        "latitude": "48.55897000",
                        "longitude": "3.29939000"
                    },
                    {
                        "id": 45321,
                        "name": "Puiseux-en-France",
                        "latitude": "49.05552000",
                        "longitude": "2.50035000"
                    },
                    {
                        "id": 45332,
                        "name": "Pussay",
                        "latitude": "48.34908000",
                        "longitude": "1.99182000"
                    },
                    {
                        "id": 45334,
                        "name": "Puteaux",
                        "latitude": "48.88341000",
                        "longitude": "2.23894000"
                    },
                    {
                        "id": 45396,
                        "name": "Quincy-sous-Sénart",
                        "latitude": "48.67294000",
                        "longitude": "2.53419000"
                    },
                    {
                        "id": 45395,
                        "name": "Quincy-Voisins",
                        "latitude": "48.90114000",
                        "longitude": "2.87559000"
                    },
                    {
                        "id": 45423,
                        "name": "Rambouillet",
                        "latitude": "48.64374000",
                        "longitude": "1.82992000"
                    },
                    {
                        "id": 45439,
                        "name": "Rebais",
                        "latitude": "48.84721000",
                        "longitude": "3.23232000"
                    },
                    {
                        "id": 45524,
                        "name": "Ris-Orangis",
                        "latitude": "48.65110000",
                        "longitude": "2.41406000"
                    },
                    {
                        "id": 45552,
                        "name": "Rocquencourt",
                        "latitude": "48.83783000",
                        "longitude": "2.10228000"
                    },
                    {
                        "id": 45565,
                        "name": "Roissy-en-Brie",
                        "latitude": "48.79159000",
                        "longitude": "2.64747000"
                    },
                    {
                        "id": 45566,
                        "name": "Roissy-en-France",
                        "latitude": "49.00443000",
                        "longitude": "2.51703000"
                    },
                    {
                        "id": 45573,
                        "name": "Romainville",
                        "latitude": "48.88540000",
                        "longitude": "2.43482000"
                    },
                    {
                        "id": 45606,
                        "name": "Rosny-sous-Bois",
                        "latitude": "48.87017000",
                        "longitude": "2.49910000"
                    },
                    {
                        "id": 45607,
                        "name": "Rosny-sur-Seine",
                        "latitude": "48.99808000",
                        "longitude": "1.63130000"
                    },
                    {
                        "id": 45652,
                        "name": "Rozay-en-Brie",
                        "latitude": "48.68333000",
                        "longitude": "2.95816000"
                    },
                    {
                        "id": 45658,
                        "name": "Rubelles",
                        "latitude": "48.55327000",
                        "longitude": "2.67593000"
                    },
                    {
                        "id": 45660,
                        "name": "Rueil-Malmaison",
                        "latitude": "48.87650000",
                        "longitude": "2.18967000"
                    },
                    {
                        "id": 45675,
                        "name": "Rungis",
                        "latitude": "48.74607000",
                        "longitude": "2.35275000"
                    },
                    {
                        "id": 46891,
                        "name": "Saâcy-sur-Marne",
                        "latitude": "48.96210000",
                        "longitude": "3.21083000"
                    },
                    {
                        "id": 45707,
                        "name": "Saclas",
                        "latitude": "48.35845000",
                        "longitude": "2.12349000"
                    },
                    {
                        "id": 45708,
                        "name": "Saclay",
                        "latitude": "48.73260000",
                        "longitude": "2.16923000"
                    },
                    {
                        "id": 45713,
                        "name": "Sagy",
                        "latitude": "49.04988000",
                        "longitude": "1.95216000"
                    },
                    {
                        "id": 45777,
                        "name": "Saint-Arnoult-en-Yvelines",
                        "latitude": "48.57111000",
                        "longitude": "1.93950000"
                    },
                    {
                        "id": 45793,
                        "name": "Saint-Augustin",
                        "latitude": "48.78333000",
                        "longitude": "3.03016000"
                    },
                    {
                        "id": 45828,
                        "name": "Saint-Brice-sous-Forêt",
                        "latitude": "49.00132000",
                        "longitude": "2.35361000"
                    },
                    {
                        "id": 45860,
                        "name": "Saint-Chéron",
                        "latitude": "48.55433000",
                        "longitude": "2.12403000"
                    },
                    {
                        "id": 45868,
                        "name": "Saint-Cloud",
                        "latitude": "48.84598000",
                        "longitude": "2.20289000"
                    },
                    {
                        "id": 45885,
                        "name": "Saint-Cyr-l’École",
                        "latitude": "48.79865000",
                        "longitude": "2.06814000"
                    },
                    {
                        "id": 45886,
                        "name": "Saint-Cyr-sous-Dourdan",
                        "latitude": "48.56667000",
                        "longitude": "2.03333000"
                    },
                    {
                        "id": 45890,
                        "name": "Saint-Cyr-sur-Morin",
                        "latitude": "48.90664000",
                        "longitude": "3.18016000"
                    },
                    {
                        "id": 45894,
                        "name": "Saint-Denis",
                        "latitude": "48.93564000",
                        "longitude": "2.35387000"
                    },
                    {
                        "id": 45930,
                        "name": "Saint-Fargeau-Ponthierry",
                        "latitude": "48.55713000",
                        "longitude": "2.52840000"
                    },
                    {
                        "id": 46005,
                        "name": "Saint-Germain-de-la-Grange",
                        "latitude": "48.83436000",
                        "longitude": "1.89884000"
                    },
                    {
                        "id": 46015,
                        "name": "Saint-Germain-en-Laye",
                        "latitude": "48.89643000",
                        "longitude": "2.09040000"
                    },
                    {
                        "id": 45996,
                        "name": "Saint-Germain-Laval",
                        "latitude": "48.39968000",
                        "longitude": "2.99781000"
                    },
                    {
                        "id": 46018,
                        "name": "Saint-Germain-lès-Arpajon",
                        "latitude": "48.59733000",
                        "longitude": "2.26481000"
                    },
                    {
                        "id": 46019,
                        "name": "Saint-Germain-lès-Corbeil",
                        "latitude": "48.62211000",
                        "longitude": "2.48775000"
                    },
                    {
                        "id": 46022,
                        "name": "Saint-Germain-sur-Morin",
                        "latitude": "48.88257000",
                        "longitude": "2.85127000"
                    },
                    {
                        "id": 46041,
                        "name": "Saint-Gratien",
                        "latitude": "48.97350000",
                        "longitude": "2.28729000"
                    },
                    {
                        "id": 46118,
                        "name": "Saint-Jean-les-Deux-Jumeaux",
                        "latitude": "48.95140000",
                        "longitude": "3.01959000"
                    },
                    {
                        "id": 46214,
                        "name": "Saint-Léger-en-Yvelines",
                        "latitude": "48.72173000",
                        "longitude": "1.76638000"
                    },
                    {
                        "id": 46193,
                        "name": "Saint-Leu-la-Forêt",
                        "latitude": "49.01667000",
                        "longitude": "2.25000000"
                    },
                    {
                        "id": 46234,
                        "name": "Saint-Mammès",
                        "latitude": "48.38458000",
                        "longitude": "2.81578000"
                    },
                    {
                        "id": 46236,
                        "name": "Saint-Mandé",
                        "latitude": "48.83864000",
                        "longitude": "2.41579000"
                    },
                    {
                        "id": 46252,
                        "name": "Saint-Mard",
                        "latitude": "49.03701000",
                        "longitude": "2.69645000"
                    },
                    {
                        "id": 46290,
                        "name": "Saint-Martin-du-Tertre",
                        "latitude": "49.10743000",
                        "longitude": "2.34533000"
                    },
                    {
                        "id": 46310,
                        "name": "Saint-Maur-des-Fossés",
                        "latitude": "48.79395000",
                        "longitude": "2.49323000"
                    },
                    {
                        "id": 46311,
                        "name": "Saint-Maurice",
                        "latitude": "48.82182000",
                        "longitude": "2.42716000"
                    },
                    {
                        "id": 46312,
                        "name": "Saint-Maurice-Montcouronne",
                        "latitude": "48.58288000",
                        "longitude": "2.12504000"
                    },
                    {
                        "id": 46341,
                        "name": "Saint-Michel-sur-Orge",
                        "latitude": "48.63479000",
                        "longitude": "2.30831000"
                    },
                    {
                        "id": 46372,
                        "name": "Saint-Nom-la-Bretêche",
                        "latitude": "48.85942000",
                        "longitude": "2.02233000"
                    },
                    {
                        "id": 46376,
                        "name": "Saint-Ouen",
                        "latitude": "48.90654000",
                        "longitude": "2.33339000"
                    },
                    {
                        "id": 46383,
                        "name": "Saint-Ouen-l’Aumône",
                        "latitude": "49.04353000",
                        "longitude": "2.12134000"
                    },
                    {
                        "id": 46400,
                        "name": "Saint-Pathus",
                        "latitude": "49.07136000",
                        "longitude": "2.79886000"
                    },
                    {
                        "id": 46441,
                        "name": "Saint-Pierre-du-Perray",
                        "latitude": "48.61064000",
                        "longitude": "2.49429000"
                    },
                    {
                        "id": 46451,
                        "name": "Saint-Pierre-lès-Nemours",
                        "latitude": "48.26733000",
                        "longitude": "2.67966000"
                    },
                    {
                        "id": 46472,
                        "name": "Saint-Prix",
                        "latitude": "49.01667000",
                        "longitude": "2.26667000"
                    },
                    {
                        "id": 46489,
                        "name": "Saint-Quentin-en-Yvelines",
                        "latitude": "48.77186000",
                        "longitude": "2.01891000"
                    },
                    {
                        "id": 46514,
                        "name": "Saint-Rémy-lès-Chevreuse",
                        "latitude": "48.70708000",
                        "longitude": "2.07692000"
                    },
                    {
                        "id": 46539,
                        "name": "Saint-Sauveur-sur-École",
                        "latitude": "48.49750000",
                        "longitude": "2.54711000"
                    },
                    {
                        "id": 46558,
                        "name": "Saint-Soupplets",
                        "latitude": "49.03866000",
                        "longitude": "2.80723000"
                    },
                    {
                        "id": 46579,
                        "name": "Saint-Thibault-des-Vignes",
                        "latitude": "48.87111000",
                        "longitude": "2.68041000"
                    },
                    {
                        "id": 46623,
                        "name": "Saint-Vrain",
                        "latitude": "48.54302000",
                        "longitude": "2.33331000"
                    },
                    {
                        "id": 46626,
                        "name": "Saint-Witz",
                        "latitude": "49.09100000",
                        "longitude": "2.57122000"
                    },
                    {
                        "id": 46668,
                        "name": "Sainte-Colombe",
                        "latitude": "48.53047000",
                        "longitude": "3.25517000"
                    },
                    {
                        "id": 46693,
                        "name": "Sainte-Geneviève-des-Bois",
                        "latitude": "48.64682000",
                        "longitude": "2.31965000"
                    },
                    {
                        "id": 46736,
                        "name": "Saintry-sur-Seine",
                        "latitude": "48.59640000",
                        "longitude": "2.49515000"
                    },
                    {
                        "id": 46737,
                        "name": "Saints",
                        "latitude": "48.76066000",
                        "longitude": "3.04645000"
                    },
                    {
                        "id": 46754,
                        "name": "Salins",
                        "latitude": "48.42156000",
                        "longitude": "3.02130000"
                    },
                    {
                        "id": 46773,
                        "name": "Sammeron",
                        "latitude": "48.94721000",
                        "longitude": "3.08333000"
                    },
                    {
                        "id": 46774,
                        "name": "Samois-sur-Seine",
                        "latitude": "48.45251000",
                        "longitude": "2.75040000"
                    },
                    {
                        "id": 46775,
                        "name": "Samoreau",
                        "latitude": "48.42946000",
                        "longitude": "2.75587000"
                    },
                    {
                        "id": 46790,
                        "name": "Sannois",
                        "latitude": "48.96667000",
                        "longitude": "2.25000000"
                    },
                    {
                        "id": 46798,
                        "name": "Santeny",
                        "latitude": "48.72730000",
                        "longitude": "2.57346000"
                    },
                    {
                        "id": 46803,
                        "name": "Sarcelles",
                        "latitude": "48.99739000",
                        "longitude": "2.37821000"
                    },
                    {
                        "id": 46822,
                        "name": "Sartrouville",
                        "latitude": "48.94820000",
                        "longitude": "2.19169000"
                    },
                    {
                        "id": 46848,
                        "name": "Saulx-les-Chartreux",
                        "latitude": "48.69062000",
                        "longitude": "2.26727000"
                    },
                    {
                        "id": 46880,
                        "name": "Savigny-le-Temple",
                        "latitude": "48.57409000",
                        "longitude": "2.58287000"
                    },
                    {
                        "id": 46883,
                        "name": "Savigny-sur-Orge",
                        "latitude": "48.67677000",
                        "longitude": "2.34835000"
                    },
                    {
                        "id": 46895,
                        "name": "Sceaux",
                        "latitude": "48.77644000",
                        "longitude": "2.29026000"
                    },
                    {
                        "id": 46927,
                        "name": "Seine-et-Marne",
                        "latitude": "48.64599000",
                        "longitude": "2.95905000"
                    },
                    {
                        "id": 46925,
                        "name": "Seine-Port",
                        "latitude": "48.55743000",
                        "longitude": "2.55316000"
                    },
                    {
                        "id": 46926,
                        "name": "Seine-Saint-Denis",
                        "latitude": "48.91421000",
                        "longitude": "2.47604000"
                    },
                    {
                        "id": 46948,
                        "name": "Septeuil",
                        "latitude": "48.89245000",
                        "longitude": "1.68357000"
                    },
                    {
                        "id": 46953,
                        "name": "Seraincourt",
                        "latitude": "49.03573000",
                        "longitude": "1.86703000"
                    },
                    {
                        "id": 46968,
                        "name": "Serris",
                        "latitude": "48.84528000",
                        "longitude": "2.78611000"
                    },
                    {
                        "id": 46973,
                        "name": "Servon",
                        "latitude": "48.71662000",
                        "longitude": "2.58737000"
                    },
                    {
                        "id": 46977,
                        "name": "Seugy",
                        "latitude": "49.12182000",
                        "longitude": "2.39377000"
                    },
                    {
                        "id": 46979,
                        "name": "Sevran",
                        "latitude": "48.94472000",
                        "longitude": "2.52746000"
                    },
                    {
                        "id": 47130,
                        "name": "Sèvres",
                        "latitude": "48.82292000",
                        "longitude": "2.21757000"
                    },
                    {
                        "id": 47016,
                        "name": "Soignolles-en-Brie",
                        "latitude": "48.65350000",
                        "longitude": "2.69968000"
                    },
                    {
                        "id": 47019,
                        "name": "Soisy-sous-Montmorency",
                        "latitude": "48.98813000",
                        "longitude": "2.30156000"
                    },
                    {
                        "id": 47021,
                        "name": "Soisy-sur-École",
                        "latitude": "48.47637000",
                        "longitude": "2.49301000"
                    },
                    {
                        "id": 47020,
                        "name": "Soisy-sur-Seine",
                        "latitude": "48.64875000",
                        "longitude": "2.45223000"
                    },
                    {
                        "id": 47023,
                        "name": "Solers",
                        "latitude": "48.65919000",
                        "longitude": "2.71617000"
                    },
                    {
                        "id": 47037,
                        "name": "Sonchamp",
                        "latitude": "48.57590000",
                        "longitude": "1.87753000"
                    },
                    {
                        "id": 47079,
                        "name": "Souppes-sur-Loing",
                        "latitude": "48.18297000",
                        "longitude": "2.73521000"
                    },
                    {
                        "id": 47084,
                        "name": "Sourdun",
                        "latitude": "48.53688000",
                        "longitude": "3.35200000"
                    },
                    {
                        "id": 47098,
                        "name": "Stains",
                        "latitude": "48.95000000",
                        "longitude": "2.38333000"
                    },
                    {
                        "id": 47111,
                        "name": "Sucy-en-Brie",
                        "latitude": "48.76872000",
                        "longitude": "2.53474000"
                    },
                    {
                        "id": 47120,
                        "name": "Suresnes",
                        "latitude": "48.87143000",
                        "longitude": "2.22929000"
                    },
                    {
                        "id": 47123,
                        "name": "Survilliers",
                        "latitude": "49.09712000",
                        "longitude": "2.54449000"
                    },
                    {
                        "id": 47153,
                        "name": "Tacoignières",
                        "latitude": "48.83619000",
                        "longitude": "1.67501000"
                    },
                    {
                        "id": 47192,
                        "name": "Taverny",
                        "latitude": "49.02542000",
                        "longitude": "2.21691000"
                    },
                    {
                        "id": 47225,
                        "name": "Thiais",
                        "latitude": "48.76496000",
                        "longitude": "2.39610000"
                    },
                    {
                        "id": 47240,
                        "name": "Thiverval-Grignon",
                        "latitude": "48.84964000",
                        "longitude": "1.91729000"
                    },
                    {
                        "id": 47244,
                        "name": "Thoiry",
                        "latitude": "48.86715000",
                        "longitude": "1.79760000"
                    },
                    {
                        "id": 47246,
                        "name": "Thomery",
                        "latitude": "48.40723000",
                        "longitude": "2.78852000"
                    },
                    {
                        "id": 47249,
                        "name": "Thorigny-sur-Marne",
                        "latitude": "48.88689000",
                        "longitude": "2.71806000"
                    },
                    {
                        "id": 47278,
                        "name": "Tigery",
                        "latitude": "48.64257000",
                        "longitude": "2.50779000"
                    },
                    {
                        "id": 47299,
                        "name": "Torcy",
                        "latitude": "48.85064000",
                        "longitude": "2.65078000"
                    },
                    {
                        "id": 47318,
                        "name": "Touquin",
                        "latitude": "48.73498000",
                        "longitude": "3.01222000"
                    },
                    {
                        "id": 47322,
                        "name": "Tournan-en-Brie",
                        "latitude": "48.74146000",
                        "longitude": "2.77200000"
                    },
                    {
                        "id": 47349,
                        "name": "Trappes",
                        "latitude": "48.77413000",
                        "longitude": "2.01781000"
                    },
                    {
                        "id": 47358,
                        "name": "Tremblay-en-France",
                        "latitude": "48.94956000",
                        "longitude": "2.56840000"
                    },
                    {
                        "id": 47371,
                        "name": "Triel-sur-Seine",
                        "latitude": "48.97818000",
                        "longitude": "2.00743000"
                    },
                    {
                        "id": 47375,
                        "name": "Trilport",
                        "latitude": "48.95685000",
                        "longitude": "2.95076000"
                    },
                    {
                        "id": 47437,
                        "name": "Us",
                        "latitude": "49.10000000",
                        "longitude": "1.96667000"
                    },
                    {
                        "id": 47457,
                        "name": "Vaires-sur-Marne",
                        "latitude": "48.87649000",
                        "longitude": "2.63982000"
                    },
                    {
                        "id": 47462,
                        "name": "Val-de-Marne",
                        "latitude": "48.78149000",
                        "longitude": "2.49331000"
                    },
                    {
                        "id": 47478,
                        "name": "Valenton",
                        "latitude": "48.74527000",
                        "longitude": "2.46467000"
                    },
                    {
                        "id": 47495,
                        "name": "Valmondois",
                        "latitude": "49.09730000",
                        "longitude": "2.18996000"
                    },
                    {
                        "id": 47505,
                        "name": "Vanves",
                        "latitude": "48.82345000",
                        "longitude": "2.29025000"
                    },
                    {
                        "id": 47510,
                        "name": "Varennes-Jarcy",
                        "latitude": "48.67914000",
                        "longitude": "2.56152000"
                    },
                    {
                        "id": 47516,
                        "name": "Varennes-sur-Seine",
                        "latitude": "48.37304000",
                        "longitude": "2.92571000"
                    },
                    {
                        "id": 47521,
                        "name": "Varreddes",
                        "latitude": "49.00305000",
                        "longitude": "2.92788000"
                    },
                    {
                        "id": 47530,
                        "name": "Vaucresson",
                        "latitude": "48.84078000",
                        "longitude": "2.15652000"
                    },
                    {
                        "id": 47534,
                        "name": "Vaugrigneuse",
                        "latitude": "48.60263000",
                        "longitude": "2.12218000"
                    },
                    {
                        "id": 47535,
                        "name": "Vauhallan",
                        "latitude": "48.73354000",
                        "longitude": "2.20277000"
                    },
                    {
                        "id": 47536,
                        "name": "Vaujours",
                        "latitude": "48.93022000",
                        "longitude": "2.57110000"
                    },
                    {
                        "id": 47543,
                        "name": "Vauréal",
                        "latitude": "49.03333000",
                        "longitude": "2.03333000"
                    },
                    {
                        "id": 47546,
                        "name": "Vaux-le-Pénil",
                        "latitude": "48.52803000",
                        "longitude": "2.69165000"
                    },
                    {
                        "id": 47548,
                        "name": "Vaux-sur-Seine",
                        "latitude": "49.01271000",
                        "longitude": "1.96942000"
                    },
                    {
                        "id": 47924,
                        "name": "Vélizy-Villacoublay",
                        "latitude": "48.78198000",
                        "longitude": "2.19395000"
                    },
                    {
                        "id": 47925,
                        "name": "Vémars",
                        "latitude": "49.06942000",
                        "longitude": "2.56643000"
                    },
                    {
                        "id": 47583,
                        "name": "Veneux-les-Sablons",
                        "latitude": "48.37872000",
                        "longitude": "2.79499000"
                    },
                    {
                        "id": 47614,
                        "name": "Verneuil-sur-Seine",
                        "latitude": "48.97388000",
                        "longitude": "1.96480000"
                    },
                    {
                        "id": 47621,
                        "name": "Vernou-la-Celle-sur-Seine",
                        "latitude": "48.38789000",
                        "longitude": "2.84718000"
                    },
                    {
                        "id": 47623,
                        "name": "Vernouillet",
                        "latitude": "48.97146000",
                        "longitude": "1.98082000"
                    },
                    {
                        "id": 47630,
                        "name": "Verrières-le-Buisson",
                        "latitude": "48.74565000",
                        "longitude": "2.26796000"
                    },
                    {
                        "id": 47632,
                        "name": "Versailles",
                        "latitude": "48.80359000",
                        "longitude": "2.13424000"
                    },
                    {
                        "id": 47637,
                        "name": "Vert-le-Grand",
                        "latitude": "48.57172000",
                        "longitude": "2.35777000"
                    },
                    {
                        "id": 47638,
                        "name": "Vert-le-Petit",
                        "latitude": "48.55163000",
                        "longitude": "2.36526000"
                    },
                    {
                        "id": 47635,
                        "name": "Vert-Saint-Denis",
                        "latitude": "48.56818000",
                        "longitude": "2.62007000"
                    },
                    {
                        "id": 47660,
                        "name": "Viarmes",
                        "latitude": "49.13082000",
                        "longitude": "2.37074000"
                    },
                    {
                        "id": 47697,
                        "name": "Vigneux-sur-Seine",
                        "latitude": "48.70291000",
                        "longitude": "2.41357000"
                    },
                    {
                        "id": 47701,
                        "name": "Vigny",
                        "latitude": "49.07902000",
                        "longitude": "1.92806000"
                    },
                    {
                        "id": 47705,
                        "name": "Villabé",
                        "latitude": "48.58949000",
                        "longitude": "2.45096000"
                    },
                    {
                        "id": 47717,
                        "name": "Ville-d’Avray",
                        "latitude": "48.82358000",
                        "longitude": "2.19311000"
                    },
                    {
                        "id": 47725,
                        "name": "Villebon-sur-Yvette",
                        "latitude": "48.70594000",
                        "longitude": "2.24019000"
                    },
                    {
                        "id": 47727,
                        "name": "Villecresnes",
                        "latitude": "48.72002000",
                        "longitude": "2.53940000"
                    },
                    {
                        "id": 47745,
                        "name": "Villejuif",
                        "latitude": "48.79390000",
                        "longitude": "2.35992000"
                    },
                    {
                        "id": 47746,
                        "name": "Villejust",
                        "latitude": "48.68304000",
                        "longitude": "2.23610000"
                    },
                    {
                        "id": 47752,
                        "name": "Villemoisson-sur-Orge",
                        "latitude": "48.66632000",
                        "longitude": "2.33657000"
                    },
                    {
                        "id": 47754,
                        "name": "Villemomble",
                        "latitude": "48.88333000",
                        "longitude": "2.50000000"
                    },
                    {
                        "id": 47773,
                        "name": "Villeneuve-la-Garenne",
                        "latitude": "48.93935000",
                        "longitude": "2.31478000"
                    },
                    {
                        "id": 47776,
                        "name": "Villeneuve-le-Comte",
                        "latitude": "48.81413000",
                        "longitude": "2.82953000"
                    },
                    {
                        "id": 47777,
                        "name": "Villeneuve-le-Roi",
                        "latitude": "48.73684000",
                        "longitude": "2.40081000"
                    },
                    {
                        "id": 47763,
                        "name": "Villeneuve-Saint-Georges",
                        "latitude": "48.73219000",
                        "longitude": "2.44925000"
                    },
                    {
                        "id": 47783,
                        "name": "Villeneuve-sur-Bellot",
                        "latitude": "48.86203000",
                        "longitude": "3.34143000"
                    },
                    {
                        "id": 47786,
                        "name": "Villennes-sur-Seine",
                        "latitude": "48.94137000",
                        "longitude": "1.99137000"
                    },
                    {
                        "id": 47788,
                        "name": "Villenoy",
                        "latitude": "48.94112000",
                        "longitude": "2.86020000"
                    },
                    {
                        "id": 47789,
                        "name": "Villeparisis",
                        "latitude": "48.94208000",
                        "longitude": "2.61463000"
                    },
                    {
                        "id": 47790,
                        "name": "Villepinte",
                        "latitude": "48.96203000",
                        "longitude": "2.53253000"
                    },
                    {
                        "id": 47792,
                        "name": "Villepreux",
                        "latitude": "48.82815000",
                        "longitude": "1.99760000"
                    },
                    {
                        "id": 47815,
                        "name": "Villetaneuse",
                        "latitude": "48.95833000",
                        "longitude": "2.34167000"
                    },
                    {
                        "id": 47819,
                        "name": "Villevaudé",
                        "latitude": "48.91751000",
                        "longitude": "2.65228000"
                    },
                    {
                        "id": 47830,
                        "name": "Villiers-le-Bâcle",
                        "latitude": "48.72819000",
                        "longitude": "2.11925000"
                    },
                    {
                        "id": 47829,
                        "name": "Villiers-le-Bel",
                        "latitude": "49.00875000",
                        "longitude": "2.39819000"
                    },
                    {
                        "id": 47825,
                        "name": "Villiers-Saint-Fréderic",
                        "latitude": "48.81667000",
                        "longitude": "1.88333000"
                    },
                    {
                        "id": 47826,
                        "name": "Villiers-Saint-Georges",
                        "latitude": "48.64998000",
                        "longitude": "3.40754000"
                    },
                    {
                        "id": 47833,
                        "name": "Villiers-sur-Marne",
                        "latitude": "48.83100000",
                        "longitude": "2.54844000"
                    },
                    {
                        "id": 47834,
                        "name": "Villiers-sur-Morin",
                        "latitude": "48.86099000",
                        "longitude": "2.87773000"
                    },
                    {
                        "id": 47835,
                        "name": "Villiers-sur-Orge",
                        "latitude": "48.65953000",
                        "longitude": "2.30002000"
                    },
                    {
                        "id": 47844,
                        "name": "Vincennes",
                        "latitude": "48.84860000",
                        "longitude": "2.43769000"
                    },
                    {
                        "id": 47865,
                        "name": "Viroflay",
                        "latitude": "48.80078000",
                        "longitude": "2.16181000"
                    },
                    {
                        "id": 47867,
                        "name": "Viry-Châtillon",
                        "latitude": "48.67211000",
                        "longitude": "2.39318000"
                    },
                    {
                        "id": 47875,
                        "name": "Vitry-sur-Seine",
                        "latitude": "48.78716000",
                        "longitude": "2.40332000"
                    },
                    {
                        "id": 47893,
                        "name": "Voisenon",
                        "latitude": "48.57170000",
                        "longitude": "2.66480000"
                    },
                    {
                        "id": 47894,
                        "name": "Voisins-le-Bretonneux",
                        "latitude": "48.75793000",
                        "longitude": "2.05137000"
                    },
                    {
                        "id": 47908,
                        "name": "Voulangis",
                        "latitude": "48.85252000",
                        "longitude": "2.89558000"
                    },
                    {
                        "id": 47909,
                        "name": "Voulx",
                        "latitude": "48.28204000",
                        "longitude": "2.96747000"
                    },
                    {
                        "id": 47922,
                        "name": "Vulaines-sur-Seine",
                        "latitude": "48.43186000",
                        "longitude": "2.76476000"
                    },
                    {
                        "id": 47985,
                        "name": "Wissous",
                        "latitude": "48.73352000",
                        "longitude": "2.32338000"
                    },
                    {
                        "id": 48004,
                        "name": "Yerres",
                        "latitude": "48.71785000",
                        "longitude": "2.49338000"
                    },
                    {
                        "id": 48014,
                        "name": "Yvelines",
                        "latitude": "48.80546000",
                        "longitude": "1.85696000"
                    }
                ]
            },
            {
                "id": 5003,
                "name": "Ille-et-Vilaine",
                "iso2": "35",
                "latitude": "48.17624840",
                "longitude": "-2.21304010",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5004,
                "name": "Indre",
                "iso2": "36",
                "latitude": "46.81175500",
                "longitude": "0.97555230",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5005,
                "name": "Indre-et-Loire",
                "iso2": "37",
                "latitude": "47.22285820",
                "longitude": "0.14896190",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5006,
                "name": "Isère",
                "iso2": "38",
                "latitude": "45.28922710",
                "longitude": "4.99023550",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5007,
                "name": "Jura",
                "iso2": "39",
                "latitude": "46.78287410",
                "longitude": "5.16918440",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4823,
                "name": "La Réunion",
                "iso2": "974",
                "latitude": "-21.11514100",
                "longitude": "55.53638400",
                "type": "overseas region",
                "cities": []
            },
            {
                "id": 5008,
                "name": "Landes",
                "iso2": "40",
                "latitude": "44.00950800",
                "longitude": "-1.25385790",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5009,
                "name": "Loir-et-Cher",
                "iso2": "41",
                "latitude": "47.65937600",
                "longitude": "0.85376310",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5010,
                "name": "Loire",
                "iso2": "42",
                "latitude": "46.35228120",
                "longitude": "-1.17563390",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5012,
                "name": "Loire-Atlantique",
                "iso2": "44",
                "latitude": "47.34757210",
                "longitude": "-2.34663120",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5013,
                "name": "Loiret",
                "iso2": "45",
                "latitude": "47.91354310",
                "longitude": "1.76009900",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5014,
                "name": "Lot",
                "iso2": "46",
                "latitude": "44.62460700",
                "longitude": "1.03576310",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5015,
                "name": "Lot-et-Garonne",
                "iso2": "47",
                "latitude": "44.36873140",
                "longitude": "-0.09161690",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5016,
                "name": "Lozère",
                "iso2": "48",
                "latitude": "44.54227790",
                "longitude": "2.92934590",
                "type": "metropolitan department",
                "cities": [
                    {
                        "id": 155440,
                        "name": "Albaret-le-Comtal",
                        "latitude": "44.86408830",
                        "longitude": "3.06236370"
                    },
                    {
                        "id": 155441,
                        "name": "Albaret-Sainte-Marie",
                        "latitude": "44.88040430",
                        "longitude": "3.17131470"
                    },
                    {
                        "id": 155442,
                        "name": "Allenc",
                        "latitude": "44.54993740",
                        "longitude": "3.59555250"
                    },
                    {
                        "id": 155443,
                        "name": "Altier",
                        "latitude": "44.45694160",
                        "longitude": "3.77366380"
                    },
                    {
                        "id": 155444,
                        "name": "Antrenas",
                        "latitude": "44.58932640",
                        "longitude": "3.17214900"
                    },
                    {
                        "id": 155445,
                        "name": "Arzenc-d'Apcher",
                        "latitude": "44.84478810",
                        "longitude": "3.07183030"
                    },
                    {
                        "id": 155446,
                        "name": "Arzenc-de-Randon",
                        "latitude": "44.65971620",
                        "longitude": "3.44349940"
                    },
                    {
                        "id": 155447,
                        "name": "Auroux",
                        "latitude": "44.76093530",
                        "longitude": "3.63866950"
                    },
                    {
                        "id": 155448,
                        "name": "Badaroux",
                        "latitude": "44.54758080",
                        "longitude": "3.47885450"
                    },
                    {
                        "id": 155449,
                        "name": "Balsièges",
                        "latitude": "44.47696610",
                        "longitude": "3.36132620"
                    },
                    {
                        "id": 155450,
                        "name": "Banassac-Canilhac",
                        "latitude": "44.42957910",
                        "longitude": "3.08708260"
                    },
                    {
                        "id": 155451,
                        "name": "Barjac",
                        "latitude": "44.52303760",
                        "longitude": "3.32146630"
                    },
                    {
                        "id": 155452,
                        "name": "Barre-des-Cévennes",
                        "latitude": "44.25503740",
                        "longitude": "3.59237140"
                    },
                    {
                        "id": 155453,
                        "name": "Bassurels",
                        "latitude": "44.16265610",
                        "longitude": "3.51911250"
                    },
                    {
                        "id": 155454,
                        "name": "Bédouès-Cocurès",
                        "latitude": "44.34785370",
                        "longitude": "3.47706160"
                    },
                    {
                        "id": 155455,
                        "name": "Bel-Air-Val-d'Ance",
                        "latitude": "44.84238100",
                        "longitude": "3.54569750"
                    },
                    {
                        "id": 155456,
                        "name": "Blavignac",
                        "latitude": "44.86835450",
                        "longitude": "3.20534000"
                    },
                    {
                        "id": 155457,
                        "name": "Bourgs sur Colagne",
                        "latitude": "44.53217870",
                        "longitude": "3.06719720"
                    },
                    {
                        "id": 155458,
                        "name": "Brenoux",
                        "latitude": "44.48720230",
                        "longitude": "3.49204910"
                    },
                    {
                        "id": 155459,
                        "name": "Brion",
                        "latitude": "44.74580540",
                        "longitude": "2.99567790"
                    },
                    {
                        "id": 155460,
                        "name": "Cans-et-Cévennes",
                        "latitude": "44.28325390",
                        "longitude": "3.47983330"
                    },
                    {
                        "id": 155461,
                        "name": "Cassagnas",
                        "latitude": "44.28024940",
                        "longitude": "3.64687800"
                    },
                    {
                        "id": 155462,
                        "name": "Chadenet",
                        "latitude": "44.50809190",
                        "longitude": "3.60035590"
                    },
                    {
                        "id": 155464,
                        "name": "Chastanier",
                        "latitude": "44.72462090",
                        "longitude": "3.66855030"
                    },
                    {
                        "id": 155465,
                        "name": "Chastel-Nouvel",
                        "latitude": "44.56694800",
                        "longitude": "3.40816790"
                    },
                    {
                        "id": 155466,
                        "name": "Châteauneuf-de-Randon",
                        "latitude": "44.64787830",
                        "longitude": "3.60551010"
                    },
                    {
                        "id": 155467,
                        "name": "Chauchailles",
                        "latitude": "44.79674540",
                        "longitude": "2.99305420"
                    },
                    {
                        "id": 155468,
                        "name": "Chaudeyrac",
                        "latitude": "44.64399550",
                        "longitude": "3.66880310"
                    },
                    {
                        "id": 155469,
                        "name": "Chaulhac",
                        "latitude": "44.91954690",
                        "longitude": "3.22560030"
                    },
                    {
                        "id": 155470,
                        "name": "Cheylard-l'Évêque",
                        "latitude": "44.63892020",
                        "longitude": "3.72733760"
                    },
                    {
                        "id": 155471,
                        "name": "Cubières",
                        "latitude": "44.47178550",
                        "longitude": "3.70829630"
                    },
                    {
                        "id": 155472,
                        "name": "Cubiérettes",
                        "latitude": "44.44483990",
                        "longitude": "3.74597540"
                    },
                    {
                        "id": 155473,
                        "name": "Cultures",
                        "latitude": "44.48989070",
                        "longitude": "3.34107920"
                    },
                    {
                        "id": 155474,
                        "name": "Esclanèdes",
                        "latitude": "44.48423720",
                        "longitude": "3.28838770"
                    },
                    {
                        "id": 155475,
                        "name": "Florac Trois Rivières",
                        "latitude": "44.31878550",
                        "longitude": "3.46234640"
                    },
                    {
                        "id": 155476,
                        "name": "Fontans",
                        "latitude": "44.74335630",
                        "longitude": "3.29726160"
                    },
                    {
                        "id": 155477,
                        "name": "Fournels",
                        "latitude": "44.80990320",
                        "longitude": "3.04719330"
                    },
                    {
                        "id": 155478,
                        "name": "Fraissinet-de-Fourques",
                        "latitude": "44.20696720",
                        "longitude": "3.45396630"
                    },
                    {
                        "id": 155479,
                        "name": "Gabriac",
                        "latitude": "44.46354050",
                        "longitude": "2.72391180"
                    },
                    {
                        "id": 155480,
                        "name": "Gabrias",
                        "latitude": "44.55215590",
                        "longitude": "3.30255100"
                    },
                    {
                        "id": 155481,
                        "name": "Gatuzières",
                        "latitude": "44.18764770",
                        "longitude": "3.34346610"
                    },
                    {
                        "id": 155482,
                        "name": "Gorges du Tarn Causses",
                        "latitude": "44.36301740",
                        "longitude": "3.12843700"
                    },
                    {
                        "id": 155483,
                        "name": "Grandrieu",
                        "latitude": "44.77465750",
                        "longitude": "3.47552260"
                    },
                    {
                        "id": 155484,
                        "name": "Grandvals",
                        "latitude": "44.73323540",
                        "longitude": "2.97292810"
                    },
                    {
                        "id": 155485,
                        "name": "Grèzes",
                        "latitude": "44.91229830",
                        "longitude": "3.38544460"
                    },
                    {
                        "id": 155486,
                        "name": "Hures-la-Parade",
                        "latitude": "44.24776400",
                        "longitude": "3.22063520"
                    },
                    {
                        "id": 155487,
                        "name": "Ispagnac",
                        "latitude": "44.40076280",
                        "longitude": "3.36704030"
                    },
                    {
                        "id": 155488,
                        "name": "Julianges",
                        "latitude": "44.93673250",
                        "longitude": "3.23892630"
                    },
                    {
                        "id": 155489,
                        "name": "La Bastide-Puylaurent",
                        "latitude": "44.56618960",
                        "longitude": "3.80592540"
                    },
                    {
                        "id": 155491,
                        "name": "La Fage-Montivernoux",
                        "latitude": "44.75038190",
                        "longitude": "3.06617300"
                    },
                    {
                        "id": 155492,
                        "name": "La Fage-Saint-Julien",
                        "latitude": "44.80075160",
                        "longitude": "3.12953010"
                    },
                    {
                        "id": 155493,
                        "name": "La Malène",
                        "latitude": "44.30726880",
                        "longitude": "3.23418980"
                    },
                    {
                        "id": 155519,
                        "name": "La Tieule",
                        "latitude": "44.38273020",
                        "longitude": "3.08688240"
                    },
                    {
                        "id": 155494,
                        "name": "Lachamp-Ribennes",
                        "latitude": "44.62737900",
                        "longitude": "3.22045050"
                    },
                    {
                        "id": 155495,
                        "name": "Lajo",
                        "latitude": "44.82626630",
                        "longitude": "3.35445860"
                    },
                    {
                        "id": 155497,
                        "name": "Lanuéjols",
                        "latitude": "44.12390610",
                        "longitude": "3.21189290"
                    },
                    {
                        "id": 155498,
                        "name": "Laubert",
                        "latitude": "44.59557020",
                        "longitude": "3.56117430"
                    },
                    {
                        "id": 155499,
                        "name": "Laval-du-Tarn",
                        "latitude": "44.37615770",
                        "longitude": "3.26887730"
                    },
                    {
                        "id": 155500,
                        "name": "Le Born",
                        "latitude": "44.58739290",
                        "longitude": "3.47465410"
                    },
                    {
                        "id": 155501,
                        "name": "Le Buisson",
                        "latitude": "44.63006490",
                        "longitude": "3.13760330"
                    },
                    {
                        "id": 155502,
                        "name": "Le Collet-de-Dèze",
                        "latitude": "44.25843160",
                        "longitude": "3.83866250"
                    },
                    {
                        "id": 155503,
                        "name": "Le Malzieu-Forain",
                        "latitude": "44.87146660",
                        "longitude": "3.30717150"
                    },
                    {
                        "id": 155520,
                        "name": "Le Pompidou",
                        "latitude": "44.20687610",
                        "longitude": "3.58134290"
                    },
                    {
                        "id": 155521,
                        "name": "Le Rozier",
                        "latitude": "44.19715100",
                        "longitude": "3.17619310"
                    },
                    {
                        "id": 155505,
                        "name": "Les Bessons",
                        "latitude": "44.77464960",
                        "longitude": "3.15372610"
                    },
                    {
                        "id": 155506,
                        "name": "Les Bondons",
                        "latitude": "44.39920280",
                        "longitude": "3.55412150"
                    },
                    {
                        "id": 155507,
                        "name": "Les Hermaux",
                        "latitude": "44.51822140",
                        "longitude": "3.09007870"
                    },
                    {
                        "id": 155508,
                        "name": "Les Laubies",
                        "latitude": "44.70009600",
                        "longitude": "3.36382720"
                    },
                    {
                        "id": 155522,
                        "name": "Les Monts-Verts",
                        "latitude": "44.84816450",
                        "longitude": "3.13608200"
                    },
                    {
                        "id": 155523,
                        "name": "Les Salces",
                        "latitude": "44.55668080",
                        "longitude": "2.96715200"
                    },
                    {
                        "id": 155524,
                        "name": "Les Salelles",
                        "latitude": "44.48397540",
                        "longitude": "3.19413340"
                    },
                    {
                        "id": 155509,
                        "name": "Luc",
                        "latitude": "44.64202020",
                        "longitude": "3.78397990"
                    },
                    {
                        "id": 155510,
                        "name": "Marchastel",
                        "latitude": "44.64209100",
                        "longitude": "3.02542050"
                    },
                    {
                        "id": 155512,
                        "name": "Mas-Saint-Chély",
                        "latitude": "44.31428220",
                        "longitude": "3.24531640"
                    },
                    {
                        "id": 155513,
                        "name": "Massegros Causses Gorges",
                        "latitude": "44.30788700",
                        "longitude": "3.04101180"
                    },
                    {
                        "id": 155516,
                        "name": "Moissac-Vallée-Française",
                        "latitude": "44.15864780",
                        "longitude": "3.70981410"
                    },
                    {
                        "id": 155517,
                        "name": "Molezon",
                        "latitude": "44.21509650",
                        "longitude": "3.60879980"
                    },
                    {
                        "id": 155525,
                        "name": "Mont Lozère et Goulet",
                        "latitude": "44.50942940",
                        "longitude": "3.42059060"
                    },
                    {
                        "id": 155526,
                        "name": "Montbel",
                        "latitude": "44.59911360",
                        "longitude": "3.55374580"
                    },
                    {
                        "id": 155528,
                        "name": "Monts-de-Randon",
                        "latitude": "44.65296610",
                        "longitude": "3.31177050"
                    },
                    {
                        "id": 155529,
                        "name": "Nasbinals",
                        "latitude": "44.64591450",
                        "longitude": "2.88171410"
                    },
                    {
                        "id": 155530,
                        "name": "Naussac-Fontanes",
                        "latitude": "44.76372420",
                        "longitude": "3.71633440"
                    },
                    {
                        "id": 155531,
                        "name": "Noalhac",
                        "latitude": "44.80076880",
                        "longitude": "3.04219410"
                    },
                    {
                        "id": 155532,
                        "name": "Palhers",
                        "latitude": "44.51596940",
                        "longitude": "3.26800390"
                    },
                    {
                        "id": 155533,
                        "name": "Paulhac-en-Margeride",
                        "latitude": "44.94667560",
                        "longitude": "3.30312000"
                    },
                    {
                        "id": 155534,
                        "name": "Pelouse",
                        "latitude": "44.57701030",
                        "longitude": "3.52723650"
                    },
                    {
                        "id": 155535,
                        "name": "Peyre en Aubrac",
                        "latitude": "44.69220010",
                        "longitude": "3.10850550"
                    },
                    {
                        "id": 155536,
                        "name": "Pied-de-Borne",
                        "latitude": "44.48384780",
                        "longitude": "3.88625210"
                    },
                    {
                        "id": 155537,
                        "name": "Pierrefiche",
                        "latitude": "44.68284990",
                        "longitude": "3.65209720"
                    },
                    {
                        "id": 155538,
                        "name": "Pont-de-Montvert-Sud-Mont-Lozère",
                        "latitude": "44.36789890",
                        "longitude": "3.44873450"
                    },
                    {
                        "id": 155539,
                        "name": "Pourcharesses",
                        "latitude": "44.44124690",
                        "longitude": "3.80881470"
                    },
                    {
                        "id": 155540,
                        "name": "Prévenchères",
                        "latitude": "44.51424500",
                        "longitude": "3.74741750"
                    },
                    {
                        "id": 155541,
                        "name": "Prinsuéjols-Malbouzon",
                        "latitude": "44.67858350",
                        "longitude": "2.99201520"
                    },
                    {
                        "id": 155542,
                        "name": "Prunières",
                        "latitude": "44.81860990",
                        "longitude": "3.28823790"
                    },
                    {
                        "id": 155543,
                        "name": "Recoules-d'Aubrac",
                        "latitude": "44.68583470",
                        "longitude": "2.87196780"
                    },
                    {
                        "id": 155544,
                        "name": "Recoules-de-Fumas",
                        "latitude": "44.63265310",
                        "longitude": "3.28882170"
                    },
                    {
                        "id": 155545,
                        "name": "Rimeize",
                        "latitude": "44.76257200",
                        "longitude": "3.23712500"
                    },
                    {
                        "id": 155546,
                        "name": "Rocles",
                        "latitude": "44.57087090",
                        "longitude": "4.12631730"
                    },
                    {
                        "id": 155547,
                        "name": "Rousses",
                        "latitude": "44.19413200",
                        "longitude": "3.48743470"
                    },
                    {
                        "id": 155549,
                        "name": "Saint-André-Capcèze",
                        "latitude": "44.41672230",
                        "longitude": "3.90345800"
                    },
                    {
                        "id": 155550,
                        "name": "Saint-André-de-Lancize",
                        "latitude": "44.27387440",
                        "longitude": "3.71686560"
                    },
                    {
                        "id": 155551,
                        "name": "Saint-Bauzile",
                        "latitude": "44.47013630",
                        "longitude": "3.41468500"
                    },
                    {
                        "id": 155552,
                        "name": "Saint-Bonnet-de-Chirac",
                        "latitude": "44.50208840",
                        "longitude": "3.19230680"
                    },
                    {
                        "id": 155553,
                        "name": "Saint-Bonnet-Laval",
                        "latitude": "44.81039080",
                        "longitude": "3.54515400"
                    },
                    {
                        "id": 155554,
                        "name": "Saint-Chély-d'Apcher",
                        "latitude": "44.81436180",
                        "longitude": "3.19610440"
                    },
                    {
                        "id": 155555,
                        "name": "Saint-Denis-en-Margeride",
                        "latitude": "44.73761140",
                        "longitude": "3.30719730"
                    },
                    {
                        "id": 155556,
                        "name": "Saint-Étienne-du-Valdonnez",
                        "latitude": "44.44475260",
                        "longitude": "3.41660100"
                    },
                    {
                        "id": 155557,
                        "name": "Saint-Étienne-Vallée-Française",
                        "latitude": "44.17352280",
                        "longitude": "3.68473080"
                    },
                    {
                        "id": 155558,
                        "name": "Saint-Flour-de-Mercoire",
                        "latitude": "44.68234050",
                        "longitude": "3.79020970"
                    },
                    {
                        "id": 155559,
                        "name": "Saint-Frézal-d'Albuges",
                        "latitude": "44.57849670",
                        "longitude": "3.68309500"
                    },
                    {
                        "id": 155560,
                        "name": "Saint-Gal",
                        "latitude": "44.66778650",
                        "longitude": "3.33398210"
                    },
                    {
                        "id": 155561,
                        "name": "Saint-Germain-de-Calberte",
                        "latitude": "44.22617030",
                        "longitude": "3.65720480"
                    },
                    {
                        "id": 155562,
                        "name": "Saint-Germain-du-Teil",
                        "latitude": "44.48409990",
                        "longitude": "3.09280920"
                    },
                    {
                        "id": 155563,
                        "name": "Saint-Hilaire-de-Lavit",
                        "latitude": "44.25207830",
                        "longitude": "3.81401230"
                    },
                    {
                        "id": 155564,
                        "name": "Saint-Jean-la-Fouillouse",
                        "latitude": "44.70523380",
                        "longitude": "3.61016210"
                    },
                    {
                        "id": 155565,
                        "name": "Saint-Juéry",
                        "latitude": "43.93532530",
                        "longitude": "2.14660510"
                    },
                    {
                        "id": 155566,
                        "name": "Saint-Julien-des-Points",
                        "latitude": "44.25946230",
                        "longitude": "3.92002430"
                    },
                    {
                        "id": 155567,
                        "name": "Saint-Laurent-de-Muret",
                        "latitude": "44.60011620",
                        "longitude": "3.17524240"
                    },
                    {
                        "id": 155568,
                        "name": "Saint-Laurent-de-Veyrès",
                        "latitude": "44.76621220",
                        "longitude": "3.08198030"
                    },
                    {
                        "id": 155569,
                        "name": "Saint-Léger-de-Peyre",
                        "latitude": "44.60480410",
                        "longitude": "3.22370540"
                    },
                    {
                        "id": 155570,
                        "name": "Saint-Léger-du-Malzieu",
                        "latitude": "44.89768500",
                        "longitude": "3.23202580"
                    },
                    {
                        "id": 155571,
                        "name": "Saint-Martin-de-Boubaux",
                        "latitude": "44.19272020",
                        "longitude": "3.84456680"
                    },
                    {
                        "id": 155572,
                        "name": "Saint-Martin-de-Lansuscle",
                        "latitude": "44.21893950",
                        "longitude": "3.66705490"
                    },
                    {
                        "id": 155573,
                        "name": "Saint-Michel-de-Dèze",
                        "latitude": "44.24700130",
                        "longitude": "3.79872580"
                    },
                    {
                        "id": 155574,
                        "name": "Saint-Paul-le-Froid",
                        "latitude": "44.79320180",
                        "longitude": "3.45821820"
                    },
                    {
                        "id": 155575,
                        "name": "Saint-Pierre-de-Nogaret",
                        "latitude": "44.48953010",
                        "longitude": "3.04339900"
                    },
                    {
                        "id": 155576,
                        "name": "Saint-Pierre-des-Tripiers",
                        "latitude": "44.22415590",
                        "longitude": "3.11045630"
                    },
                    {
                        "id": 155577,
                        "name": "Saint-Pierre-le-Vieux",
                        "latitude": "44.84380490",
                        "longitude": "3.26688980"
                    },
                    {
                        "id": 155578,
                        "name": "Saint-Privat-de-Vallongue",
                        "latitude": "44.28850720",
                        "longitude": "3.75182180"
                    },
                    {
                        "id": 155579,
                        "name": "Saint-Privat-du-Fau",
                        "latitude": "44.91700160",
                        "longitude": "3.27750610"
                    },
                    {
                        "id": 155580,
                        "name": "Saint-Saturnin",
                        "latitude": "44.40588570",
                        "longitude": "3.15374590"
                    },
                    {
                        "id": 155581,
                        "name": "Saint-Sauveur-de-Ginestoux",
                        "latitude": "44.71033430",
                        "longitude": "3.52497510"
                    },
                    {
                        "id": 155582,
                        "name": "Sainte-Croix-Vallée-Française",
                        "latitude": "44.18672320",
                        "longitude": "3.66298360"
                    },
                    {
                        "id": 155583,
                        "name": "Sainte-Eulalie",
                        "latitude": "44.78306400",
                        "longitude": "3.40900710"
                    },
                    {
                        "id": 155584,
                        "name": "Sainte-Hélène",
                        "latitude": "44.51915320",
                        "longitude": "3.56117250"
                    },
                    {
                        "id": 155585,
                        "name": "Serverette",
                        "latitude": "44.70075330",
                        "longitude": "3.30951210"
                    },
                    {
                        "id": 155586,
                        "name": "Termes",
                        "latitude": "44.82182220",
                        "longitude": "3.08602160"
                    },
                    {
                        "id": 155587,
                        "name": "Trélans",
                        "latitude": "44.52462660",
                        "longitude": "3.01873960"
                    },
                    {
                        "id": 155588,
                        "name": "Vebron",
                        "latitude": "44.25120990",
                        "longitude": "3.38466000"
                    },
                    {
                        "id": 155589,
                        "name": "Ventalon-en-Cévennes",
                        "latitude": "44.29743370",
                        "longitude": "3.79415850"
                    },
                    {
                        "id": 155590,
                        "name": "Vialas",
                        "latitude": "44.34648860",
                        "longitude": "3.72856860"
                    },
                    {
                        "id": 155591,
                        "name": "Villefort",
                        "latitude": "44.44290390",
                        "longitude": "3.88818020"
                    }
                ]
            },
            {
                "id": 5017,
                "name": "Maine-et-Loire",
                "iso2": "49",
                "latitude": "47.38900340",
                "longitude": "-1.12025270",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5018,
                "name": "Manche",
                "iso2": "50",
                "latitude": "49.08817340",
                "longitude": "-2.46272090",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5019,
                "name": "Marne",
                "iso2": "51",
                "latitude": "48.96107450",
                "longitude": "3.65737670",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4827,
                "name": "Martinique",
                "iso2": "972",
                "latitude": "14.64152800",
                "longitude": "-61.02417400",
                "type": "overseas region",
                "cities": []
            },
            {
                "id": 5021,
                "name": "Mayenne",
                "iso2": "53",
                "latitude": "48.30668420",
                "longitude": "-0.64901820",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4797,
                "name": "Mayotte",
                "iso2": "976",
                "latitude": "-12.82750000",
                "longitude": "45.16624400",
                "type": "overseas region",
                "cities": []
            },
            {
                "id": 5038,
                "name": "Métropole de Lyon",
                "iso2": "69M",
                "latitude": "45.74826290",
                "longitude": "4.59584040",
                "type": "metropolitan collectivity with special status",
                "cities": []
            },
            {
                "id": 5022,
                "name": "Meurthe-et-Moselle",
                "iso2": "54",
                "latitude": "48.95566150",
                "longitude": "5.71423500",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5023,
                "name": "Meuse",
                "iso2": "55",
                "latitude": "49.01246200",
                "longitude": "4.81087340",
                "type": "metropolitan department",
                "cities": [
                    {
                        "id": 156516,
                        "name": "Abainville",
                        "latitude": "48.53100980",
                        "longitude": "5.48230790"
                    },
                    {
                        "id": 156517,
                        "name": "Aincreville",
                        "latitude": "49.36873540",
                        "longitude": "5.09406930"
                    },
                    {
                        "id": 156518,
                        "name": "Amanty",
                        "latitude": "48.51595410",
                        "longitude": "5.56034560"
                    },
                    {
                        "id": 156519,
                        "name": "Ambly-sur-Meuse",
                        "latitude": "49.02195200",
                        "longitude": "5.43145940"
                    },
                    {
                        "id": 156520,
                        "name": "Amel-sur-l'Étang",
                        "latitude": "49.25692170",
                        "longitude": "5.60368590"
                    },
                    {
                        "id": 156521,
                        "name": "Ancemont",
                        "latitude": "49.06315250",
                        "longitude": "5.33983060"
                    },
                    {
                        "id": 156523,
                        "name": "Andernay",
                        "latitude": "48.78265100",
                        "longitude": "4.93179330"
                    },
                    {
                        "id": 156524,
                        "name": "Apremont-la-Forêt",
                        "latitude": "48.84666850",
                        "longitude": "5.53810130"
                    },
                    {
                        "id": 156525,
                        "name": "Arrancy-sur-Crusnes",
                        "latitude": "49.41265820",
                        "longitude": "5.60859030"
                    },
                    {
                        "id": 156526,
                        "name": "Aubréville",
                        "latitude": "49.15977260",
                        "longitude": "5.01532490"
                    },
                    {
                        "id": 156527,
                        "name": "Aulnois-en-Perthois",
                        "latitude": "48.63622250",
                        "longitude": "5.10201810"
                    },
                    {
                        "id": 156528,
                        "name": "Autrécourt-sur-Aire",
                        "latitude": "49.02722290",
                        "longitude": "5.10256540"
                    },
                    {
                        "id": 156529,
                        "name": "Autréville-Saint-Lambert",
                        "latitude": "49.56444980",
                        "longitude": "5.11449740"
                    },
                    {
                        "id": 156530,
                        "name": "Avillers-Sainte-Croix",
                        "latitude": "49.03371100",
                        "longitude": "5.68130890"
                    },
                    {
                        "id": 156531,
                        "name": "Avioth",
                        "latitude": "49.56734390",
                        "longitude": "5.36901670"
                    },
                    {
                        "id": 156532,
                        "name": "Avocourt",
                        "latitude": "49.20457090",
                        "longitude": "5.09943710"
                    },
                    {
                        "id": 156533,
                        "name": "Azannes-et-Soumazannes",
                        "latitude": "49.28802350",
                        "longitude": "5.42713150"
                    },
                    {
                        "id": 156534,
                        "name": "Baâlon",
                        "latitude": "49.48503050",
                        "longitude": "5.22105230"
                    },
                    {
                        "id": 156535,
                        "name": "Badonvilliers-Gérauvilliers",
                        "latitude": "48.54338000",
                        "longitude": "5.53683120"
                    },
                    {
                        "id": 156536,
                        "name": "Bannoncourt",
                        "latitude": "48.95506220",
                        "longitude": "5.43923310"
                    },
                    {
                        "id": 156537,
                        "name": "Bantheville",
                        "latitude": "49.35219980",
                        "longitude": "5.03047660"
                    },
                    {
                        "id": 156539,
                        "name": "Baudonvilliers",
                        "latitude": "48.68944380",
                        "longitude": "4.98494400"
                    },
                    {
                        "id": 156540,
                        "name": "Baudrémont",
                        "latitude": "48.83632990",
                        "longitude": "5.37398420"
                    },
                    {
                        "id": 156541,
                        "name": "Baulny",
                        "latitude": "49.26608760",
                        "longitude": "5.00457180"
                    },
                    {
                        "id": 156542,
                        "name": "Bazeilles-sur-Othain",
                        "latitude": "49.50065480",
                        "longitude": "5.40665560"
                    },
                    {
                        "id": 156543,
                        "name": "Bazincourt-sur-Saulx",
                        "latitude": "48.68737020",
                        "longitude": "5.09979600"
                    },
                    {
                        "id": 156544,
                        "name": "Beauclair",
                        "latitude": "49.44816660",
                        "longitude": "5.10405100"
                    },
                    {
                        "id": 156545,
                        "name": "Beaufort-en-Argonne",
                        "latitude": "49.48004650",
                        "longitude": "5.08994040"
                    },
                    {
                        "id": 156546,
                        "name": "Beaulieu-en-Argonne",
                        "latitude": "49.04495330",
                        "longitude": "4.95134220"
                    },
                    {
                        "id": 156547,
                        "name": "Beaumont-en-Verdunois",
                        "latitude": "49.26503880",
                        "longitude": "5.38276650"
                    },
                    {
                        "id": 156548,
                        "name": "Beausite",
                        "latitude": "48.96575030",
                        "longitude": "5.17705850"
                    },
                    {
                        "id": 156549,
                        "name": "Behonne",
                        "latitude": "48.79775790",
                        "longitude": "5.14955660"
                    },
                    {
                        "id": 156550,
                        "name": "Belleray",
                        "latitude": "49.12816470",
                        "longitude": "5.33195000"
                    },
                    {
                        "id": 156552,
                        "name": "Belrain",
                        "latitude": "48.86166180",
                        "longitude": "5.28584050"
                    },
                    {
                        "id": 156553,
                        "name": "Belrupt-en-Verdunois",
                        "latitude": "49.14968100",
                        "longitude": "5.40670410"
                    },
                    {
                        "id": 156554,
                        "name": "Beney-en-Woëvre",
                        "latitude": "48.96326650",
                        "longitude": "5.76147070"
                    },
                    {
                        "id": 156555,
                        "name": "Béthelainville",
                        "latitude": "49.16937570",
                        "longitude": "5.18317160"
                    },
                    {
                        "id": 156556,
                        "name": "Béthincourt",
                        "latitude": "49.24773570",
                        "longitude": "5.17879730"
                    },
                    {
                        "id": 156557,
                        "name": "Beurey-sur-Saulx",
                        "latitude": "48.75928430",
                        "longitude": "4.98768960"
                    },
                    {
                        "id": 156558,
                        "name": "Bezonvaux",
                        "latitude": "49.22943350",
                        "longitude": "5.43391160"
                    },
                    {
                        "id": 156559,
                        "name": "Biencourt-sur-Orge",
                        "latitude": "48.56973070",
                        "longitude": "5.30373790"
                    },
                    {
                        "id": 156560,
                        "name": "Billy-sous-Mangiennes",
                        "latitude": "49.32213940",
                        "longitude": "5.52382890"
                    },
                    {
                        "id": 156561,
                        "name": "Bislée",
                        "latitude": "48.87218620",
                        "longitude": "5.48834500"
                    },
                    {
                        "id": 156562,
                        "name": "Blanzée",
                        "latitude": "49.16092680",
                        "longitude": "5.51290460"
                    },
                    {
                        "id": 156563,
                        "name": "Boinville-en-Woëvre",
                        "latitude": "49.18807600",
                        "longitude": "5.65839910"
                    },
                    {
                        "id": 156564,
                        "name": "Boncourt-sur-Meuse",
                        "latitude": "48.81156610",
                        "longitude": "5.54251880"
                    },
                    {
                        "id": 156565,
                        "name": "Bonnet",
                        "latitude": "48.52428290",
                        "longitude": "5.38061550"
                    },
                    {
                        "id": 156566,
                        "name": "Bonzée",
                        "latitude": "49.08936250",
                        "longitude": "5.52794380"
                    },
                    {
                        "id": 156567,
                        "name": "Bouconville-sur-Madt",
                        "latitude": "48.84400040",
                        "longitude": "5.68321140"
                    },
                    {
                        "id": 156569,
                        "name": "Bouquemont",
                        "latitude": "48.98252930",
                        "longitude": "5.38611640"
                    },
                    {
                        "id": 156570,
                        "name": "Boureuilles",
                        "latitude": "49.19876160",
                        "longitude": "4.93943150"
                    },
                    {
                        "id": 156571,
                        "name": "Bovée-sur-Barboure",
                        "latitude": "48.63655590",
                        "longitude": "5.47106230"
                    },
                    {
                        "id": 156572,
                        "name": "Boviolles",
                        "latitude": "48.64329430",
                        "longitude": "5.39484800"
                    },
                    {
                        "id": 156573,
                        "name": "Brabant-en-Argonne",
                        "latitude": "49.11984150",
                        "longitude": "5.10926080"
                    },
                    {
                        "id": 156574,
                        "name": "Brabant-le-Roi",
                        "latitude": "48.85758340",
                        "longitude": "4.93707330"
                    },
                    {
                        "id": 156575,
                        "name": "Brabant-sur-Meuse",
                        "latitude": "49.28018550",
                        "longitude": "5.30167730"
                    },
                    {
                        "id": 156576,
                        "name": "Brandeville",
                        "latitude": "49.39148270",
                        "longitude": "5.26739040"
                    },
                    {
                        "id": 156577,
                        "name": "Braquis",
                        "latitude": "49.15631520",
                        "longitude": "5.60512950"
                    },
                    {
                        "id": 156578,
                        "name": "Bras-sur-Meuse",
                        "latitude": "49.20744030",
                        "longitude": "5.36994010"
                    },
                    {
                        "id": 156579,
                        "name": "Brauvilliers",
                        "latitude": "48.57677050",
                        "longitude": "5.13436530"
                    },
                    {
                        "id": 156580,
                        "name": "Bréhéville",
                        "latitude": "49.38276840",
                        "longitude": "5.28926900"
                    },
                    {
                        "id": 156581,
                        "name": "Breux",
                        "latitude": "49.59296770",
                        "longitude": "5.35490690"
                    },
                    {
                        "id": 156582,
                        "name": "Brieulles-sur-Meuse",
                        "latitude": "49.32830230",
                        "longitude": "5.13096880"
                    },
                    {
                        "id": 156583,
                        "name": "Brillon-en-Barrois",
                        "latitude": "48.71708160",
                        "longitude": "5.06660850"
                    },
                    {
                        "id": 156584,
                        "name": "Brixey-aux-Chanoines",
                        "latitude": "48.47541490",
                        "longitude": "5.69548150"
                    },
                    {
                        "id": 156585,
                        "name": "Brizeaux",
                        "latitude": "49.00537420",
                        "longitude": "5.03490360"
                    },
                    {
                        "id": 156586,
                        "name": "Brocourt-en-Argonne",
                        "latitude": "49.11169840",
                        "longitude": "5.15081550"
                    },
                    {
                        "id": 156587,
                        "name": "Brouennes",
                        "latitude": "49.52228260",
                        "longitude": "5.23014080"
                    },
                    {
                        "id": 156588,
                        "name": "Broussey-en-Blois",
                        "latitude": "48.63423170",
                        "longitude": "5.51211270"
                    },
                    {
                        "id": 156589,
                        "name": "Broussey-Raulecourt",
                        "latitude": "48.81420930",
                        "longitude": "5.67384860"
                    },
                    {
                        "id": 156590,
                        "name": "Bure",
                        "latitude": "48.50617190",
                        "longitude": "5.30068860"
                    },
                    {
                        "id": 156591,
                        "name": "Burey-en-Vaux",
                        "latitude": "48.55584050",
                        "longitude": "5.60489550"
                    },
                    {
                        "id": 156592,
                        "name": "Burey-la-Côte",
                        "latitude": "48.50108450",
                        "longitude": "5.66313430"
                    },
                    {
                        "id": 156593,
                        "name": "Buxières-sous-les-Côtes",
                        "latitude": "48.90551910",
                        "longitude": "5.64024070"
                    },
                    {
                        "id": 156594,
                        "name": "Buzy-Darmont",
                        "latitude": "49.17104480",
                        "longitude": "5.67398990"
                    },
                    {
                        "id": 156595,
                        "name": "Cesse",
                        "latitude": "49.50861990",
                        "longitude": "5.11759360"
                    },
                    {
                        "id": 156596,
                        "name": "Chaillon",
                        "latitude": "48.94960800",
                        "longitude": "5.61048030"
                    },
                    {
                        "id": 156597,
                        "name": "Chalaines",
                        "latitude": "48.59631660",
                        "longitude": "5.67679300"
                    },
                    {
                        "id": 156598,
                        "name": "Champneuville",
                        "latitude": "49.23773020",
                        "longitude": "5.29069960"
                    },
                    {
                        "id": 156599,
                        "name": "Champougny",
                        "latitude": "48.54366520",
                        "longitude": "5.68076440"
                    },
                    {
                        "id": 156600,
                        "name": "Chanteraine",
                        "latitude": "48.67540010",
                        "longitude": "5.34771790"
                    },
                    {
                        "id": 156601,
                        "name": "Chardogne",
                        "latitude": "48.82633270",
                        "longitude": "5.08644240"
                    },
                    {
                        "id": 156602,
                        "name": "Charny-sur-Meuse",
                        "latitude": "49.20240380",
                        "longitude": "5.32159870"
                    },
                    {
                        "id": 156603,
                        "name": "Charpentry",
                        "latitude": "49.25820080",
                        "longitude": "5.02068500"
                    },
                    {
                        "id": 156604,
                        "name": "Chassey-Beaupré",
                        "latitude": "48.44462180",
                        "longitude": "5.39618320"
                    },
                    {
                        "id": 156605,
                        "name": "Châtillon-sous-les-Côtes",
                        "latitude": "49.13929530",
                        "longitude": "5.47165910"
                    },
                    {
                        "id": 156606,
                        "name": "Chattancourt",
                        "latitude": "49.21543200",
                        "longitude": "5.22409810"
                    },
                    {
                        "id": 156607,
                        "name": "Chaumont-devant-Damvillers",
                        "latitude": "49.31078030",
                        "longitude": "5.41337090"
                    },
                    {
                        "id": 156608,
                        "name": "Chaumont-sur-Aire",
                        "latitude": "48.92317480",
                        "longitude": "5.22943310"
                    },
                    {
                        "id": 156609,
                        "name": "Chauvency-le-Château",
                        "latitude": "49.52816520",
                        "longitude": "5.26469820"
                    },
                    {
                        "id": 156610,
                        "name": "Chauvency-Saint-Hubert",
                        "latitude": "49.53857260",
                        "longitude": "5.27781260"
                    },
                    {
                        "id": 156611,
                        "name": "Chauvoncourt",
                        "latitude": "48.89397020",
                        "longitude": "5.45227170"
                    },
                    {
                        "id": 156612,
                        "name": "Cheppy",
                        "latitude": "49.22691970",
                        "longitude": "5.03692550"
                    },
                    {
                        "id": 156613,
                        "name": "Chonville-Malaumont",
                        "latitude": "48.75918510",
                        "longitude": "5.44537090"
                    },
                    {
                        "id": 156614,
                        "name": "Cierges-sous-Montfaucon",
                        "latitude": "49.30086390",
                        "longitude": "5.04903330"
                    },
                    {
                        "id": 156616,
                        "name": "Cléry-le-Grand",
                        "latitude": "49.36199880",
                        "longitude": "5.12141630"
                    },
                    {
                        "id": 156617,
                        "name": "Cléry-le-Petit",
                        "latitude": "49.36466670",
                        "longitude": "5.14508480"
                    },
                    {
                        "id": 156618,
                        "name": "Combles-en-Barrois",
                        "latitude": "48.74269090",
                        "longitude": "5.09174410"
                    },
                    {
                        "id": 156619,
                        "name": "Combres-sous-les-Côtes",
                        "latitude": "49.06337160",
                        "longitude": "5.59950120"
                    },
                    {
                        "id": 156621,
                        "name": "Consenvoye",
                        "latitude": "49.29606920",
                        "longitude": "5.27234190"
                    },
                    {
                        "id": 156622,
                        "name": "Contrisson",
                        "latitude": "48.80288550",
                        "longitude": "4.91588870"
                    },
                    {
                        "id": 156623,
                        "name": "Courcelles-en-Barrois",
                        "latitude": "48.82518430",
                        "longitude": "5.38643030"
                    },
                    {
                        "id": 156624,
                        "name": "Courcelles-sur-Aire",
                        "latitude": "48.94070550",
                        "longitude": "5.19180790"
                    },
                    {
                        "id": 156625,
                        "name": "Courouvre",
                        "latitude": "48.94540440",
                        "longitude": "5.33629130"
                    },
                    {
                        "id": 156626,
                        "name": "Cousances-les-Forges",
                        "latitude": "48.61826840",
                        "longitude": "5.04726340"
                    },
                    {
                        "id": 156627,
                        "name": "Cousances-lès-Triconville",
                        "latitude": "48.77029360",
                        "longitude": "5.36191510"
                    },
                    {
                        "id": 156628,
                        "name": "Couvertpuis",
                        "latitude": "48.58014930",
                        "longitude": "5.28529890"
                    },
                    {
                        "id": 156629,
                        "name": "Couvonges",
                        "latitude": "48.77718840",
                        "longitude": "5.01707740"
                    },
                    {
                        "id": 156630,
                        "name": "Cuisy",
                        "latitude": "49.26836240",
                        "longitude": "5.16782620"
                    },
                    {
                        "id": 156631,
                        "name": "Culey",
                        "latitude": "48.76706400",
                        "longitude": "5.23013760"
                    },
                    {
                        "id": 156632,
                        "name": "Cumières-le-Mort-Homme",
                        "latitude": "49.23403960",
                        "longitude": "5.22347290"
                    },
                    {
                        "id": 156633,
                        "name": "Cunel",
                        "latitude": "49.33130970",
                        "longitude": "5.09780700"
                    },
                    {
                        "id": 156634,
                        "name": "Dagonville",
                        "latitude": "48.79035680",
                        "longitude": "5.34194090"
                    },
                    {
                        "id": 156635,
                        "name": "Dainville-Bertheléville",
                        "latitude": "48.45076010",
                        "longitude": "5.47221330"
                    },
                    {
                        "id": 156636,
                        "name": "Damloup",
                        "latitude": "49.19852150",
                        "longitude": "5.45380840"
                    },
                    {
                        "id": 156637,
                        "name": "Dammarie-sur-Saulx",
                        "latitude": "48.59881920",
                        "longitude": "5.15605990"
                    },
                    {
                        "id": 156638,
                        "name": "Damvillers",
                        "latitude": "49.34312080",
                        "longitude": "5.37353910"
                    },
                    {
                        "id": 156639,
                        "name": "Dannevoux",
                        "latitude": "49.30878460",
                        "longitude": "5.18085810"
                    },
                    {
                        "id": 156640,
                        "name": "Delouze-Rosières",
                        "latitude": "48.56803930",
                        "longitude": "5.49407230"
                    },
                    {
                        "id": 156641,
                        "name": "Delut",
                        "latitude": "49.41059840",
                        "longitude": "5.37942990"
                    },
                    {
                        "id": 156642,
                        "name": "Demange-Baudignécourt",
                        "latitude": "48.58652540",
                        "longitude": "5.42366080"
                    },
                    {
                        "id": 156643,
                        "name": "Dieppe-sous-Douaumont",
                        "latitude": "49.22170900",
                        "longitude": "5.47881840"
                    },
                    {
                        "id": 156645,
                        "name": "Dombasle-en-Argonne",
                        "latitude": "49.14537170",
                        "longitude": "5.17647300"
                    },
                    {
                        "id": 156646,
                        "name": "Dombras",
                        "latitude": "49.37883560",
                        "longitude": "5.41036750"
                    },
                    {
                        "id": 156647,
                        "name": "Dommartin-la-Montagne",
                        "latitude": "49.02573240",
                        "longitude": "5.57926490"
                    },
                    {
                        "id": 156648,
                        "name": "Dommary-Baroncourt",
                        "latitude": "49.28028740",
                        "longitude": "5.67728050"
                    },
                    {
                        "id": 156649,
                        "name": "Dompcevrin",
                        "latitude": "48.93055070",
                        "longitude": "5.42454910"
                    },
                    {
                        "id": 156650,
                        "name": "Dompierre-aux-Bois",
                        "latitude": "48.99911790",
                        "longitude": "5.57509550"
                    },
                    {
                        "id": 156651,
                        "name": "Domremy-la-Canne",
                        "latitude": "49.29728350",
                        "longitude": "5.68417590"
                    },
                    {
                        "id": 156652,
                        "name": "Doncourt-aux-Templiers",
                        "latitude": "49.06006010",
                        "longitude": "5.69990800"
                    },
                    {
                        "id": 156653,
                        "name": "Douaumont-Vaux",
                        "latitude": "49.21405440",
                        "longitude": "5.41049540"
                    },
                    {
                        "id": 156654,
                        "name": "Doulcon",
                        "latitude": "49.38563860",
                        "longitude": "5.13535030"
                    },
                    {
                        "id": 156655,
                        "name": "Dugny-sur-Meuse",
                        "latitude": "49.09857610",
                        "longitude": "5.32499720"
                    },
                    {
                        "id": 156656,
                        "name": "Dun-sur-Meuse",
                        "latitude": "49.38387500",
                        "longitude": "5.17572900"
                    },
                    {
                        "id": 156657,
                        "name": "Duzey",
                        "latitude": "49.35967880",
                        "longitude": "5.59701880"
                    },
                    {
                        "id": 156658,
                        "name": "Écouviez",
                        "latitude": "49.53369880",
                        "longitude": "5.43264160"
                    },
                    {
                        "id": 156659,
                        "name": "Écurey-en-Verdunois",
                        "latitude": "49.35516280",
                        "longitude": "5.30155390"
                    },
                    {
                        "id": 156660,
                        "name": "Eix",
                        "latitude": "49.18118600",
                        "longitude": "5.43284740"
                    },
                    {
                        "id": 156661,
                        "name": "Épiez-sur-Meuse",
                        "latitude": "48.54271260",
                        "longitude": "5.60663510"
                    },
                    {
                        "id": 156662,
                        "name": "Épinonville",
                        "latitude": "49.27244850",
                        "longitude": "5.04228590"
                    },
                    {
                        "id": 156663,
                        "name": "Érize-la-Brûlée",
                        "latitude": "48.84655530",
                        "longitude": "5.23343380"
                    },
                    {
                        "id": 156664,
                        "name": "Érize-la-Petite",
                        "latitude": "48.91314970",
                        "longitude": "5.20041290"
                    },
                    {
                        "id": 156665,
                        "name": "Érize-Saint-Dizier",
                        "latitude": "48.81039430",
                        "longitude": "5.26027330"
                    },
                    {
                        "id": 156666,
                        "name": "Erneville-aux-Bois",
                        "latitude": "48.74248130",
                        "longitude": "5.32570030"
                    },
                    {
                        "id": 156667,
                        "name": "Esnes-en-Argonne",
                        "latitude": "49.20980860",
                        "longitude": "5.16265640"
                    },
                    {
                        "id": 156669,
                        "name": "Éton",
                        "latitude": "49.26444120",
                        "longitude": "5.64690050"
                    },
                    {
                        "id": 156670,
                        "name": "Étraye",
                        "latitude": "49.32635870",
                        "longitude": "5.33667130"
                    },
                    {
                        "id": 156672,
                        "name": "Èvres",
                        "latitude": "48.98242380",
                        "longitude": "5.08814040"
                    },
                    {
                        "id": 156674,
                        "name": "Flassigny",
                        "latitude": "49.47493530",
                        "longitude": "5.42203110"
                    },
                    {
                        "id": 156675,
                        "name": "Fleury-devant-Douaumont",
                        "latitude": "49.19480710",
                        "longitude": "5.40129030"
                    },
                    {
                        "id": 156676,
                        "name": "Foameix-Ornel",
                        "latitude": "49.23577310",
                        "longitude": "5.56870100"
                    },
                    {
                        "id": 156677,
                        "name": "Fontaines-Saint-Clair",
                        "latitude": "49.36622470",
                        "longitude": "5.22594770"
                    },
                    {
                        "id": 156678,
                        "name": "Forges-sur-Meuse",
                        "latitude": "49.26011730",
                        "longitude": "5.23676210"
                    },
                    {
                        "id": 156679,
                        "name": "Foucaucourt-sur-Thabas",
                        "latitude": "49.00684770",
                        "longitude": "5.05826020"
                    },
                    {
                        "id": 156680,
                        "name": "Fouchères-aux-Bois",
                        "latitude": "48.63089260",
                        "longitude": "5.22906400"
                    },
                    {
                        "id": 156681,
                        "name": "Frémeréville-sous-les-Côtes",
                        "latitude": "48.80427430",
                        "longitude": "5.63531920"
                    },
                    {
                        "id": 156682,
                        "name": "Fresnes-au-Mont",
                        "latitude": "48.89838960",
                        "longitude": "5.40186990"
                    },
                    {
                        "id": 156683,
                        "name": "Fresnes-en-Woëvre",
                        "latitude": "49.10141030",
                        "longitude": "5.61431420"
                    },
                    {
                        "id": 156684,
                        "name": "Froidos",
                        "latitude": "49.06095920",
                        "longitude": "5.07956950"
                    },
                    {
                        "id": 156685,
                        "name": "Fromeréville-les-Vallons",
                        "latitude": "49.16579740",
                        "longitude": "5.25175220"
                    },
                    {
                        "id": 156686,
                        "name": "Fromezey",
                        "latitude": "49.20921930",
                        "longitude": "5.56209080"
                    },
                    {
                        "id": 156687,
                        "name": "Futeau",
                        "latitude": "49.07606670",
                        "longitude": "4.98997100"
                    },
                    {
                        "id": 156688,
                        "name": "Génicourt-sur-Meuse",
                        "latitude": "49.04435540",
                        "longitude": "5.42202400"
                    },
                    {
                        "id": 156689,
                        "name": "Gercourt-et-Drillancourt",
                        "latitude": "49.28175700",
                        "longitude": "5.19607620"
                    },
                    {
                        "id": 156690,
                        "name": "Géry",
                        "latitude": "48.78662760",
                        "longitude": "5.28271640"
                    },
                    {
                        "id": 156691,
                        "name": "Gesnes-en-Argonne",
                        "latitude": "49.30610080",
                        "longitude": "5.01526970"
                    },
                    {
                        "id": 156692,
                        "name": "Geville",
                        "latitude": "48.78319060",
                        "longitude": "5.62937410"
                    },
                    {
                        "id": 156693,
                        "name": "Gimécourt",
                        "latitude": "48.84750360",
                        "longitude": "5.33693110"
                    },
                    {
                        "id": 156694,
                        "name": "Gincrey",
                        "latitude": "49.26158630",
                        "longitude": "5.52290520"
                    },
                    {
                        "id": 156695,
                        "name": "Girauvoisin",
                        "latitude": "48.80566180",
                        "longitude": "5.61518780"
                    },
                    {
                        "id": 156696,
                        "name": "Givrauval",
                        "latitude": "48.65654630",
                        "longitude": "5.27917760"
                    },
                    {
                        "id": 156698,
                        "name": "Gouraincourt",
                        "latitude": "49.29887280",
                        "longitude": "5.64604260"
                    },
                    {
                        "id": 156699,
                        "name": "Goussaincourt",
                        "latitude": "48.48259330",
                        "longitude": "5.65118080"
                    },
                    {
                        "id": 156700,
                        "name": "Gremilly",
                        "latitude": "49.28286700",
                        "longitude": "5.47156470"
                    },
                    {
                        "id": 156701,
                        "name": "Grimaucourt-en-Woëvre",
                        "latitude": "49.16400020",
                        "longitude": "5.54610850"
                    },
                    {
                        "id": 156702,
                        "name": "Grimaucourt-près-Sampigny",
                        "latitude": "48.78025070",
                        "longitude": "5.42828180"
                    },
                    {
                        "id": 156703,
                        "name": "Guerpont",
                        "latitude": "48.71948670",
                        "longitude": "5.23646480"
                    },
                    {
                        "id": 156704,
                        "name": "Gussainville",
                        "latitude": "49.16678060",
                        "longitude": "5.64030070"
                    },
                    {
                        "id": 156705,
                        "name": "Haironville",
                        "latitude": "48.68611870",
                        "longitude": "5.07057680"
                    },
                    {
                        "id": 156706,
                        "name": "Halles-sous-les-Côtes",
                        "latitude": "49.44653080",
                        "longitude": "5.10668190"
                    },
                    {
                        "id": 156707,
                        "name": "Han-lès-Juvigny",
                        "latitude": "49.48162460",
                        "longitude": "5.30914860"
                    },
                    {
                        "id": 156708,
                        "name": "Han-sur-Meuse",
                        "latitude": "48.85392610",
                        "longitude": "5.51471810"
                    },
                    {
                        "id": 156709,
                        "name": "Hannonville-sous-les-Côtes",
                        "latitude": "49.03228060",
                        "longitude": "5.61124840"
                    },
                    {
                        "id": 156710,
                        "name": "Harville",
                        "latitude": "49.09448080",
                        "longitude": "5.70667950"
                    },
                    {
                        "id": 156711,
                        "name": "Haudainville",
                        "latitude": "49.12455040",
                        "longitude": "5.38986590"
                    },
                    {
                        "id": 156712,
                        "name": "Haudiomont",
                        "latitude": "49.11303330",
                        "longitude": "5.49673180"
                    },
                    {
                        "id": 156713,
                        "name": "Haumont-près-Samogneux",
                        "latitude": "49.27880470",
                        "longitude": "5.33166540"
                    },
                    {
                        "id": 156714,
                        "name": "Heippes",
                        "latitude": "48.99926790",
                        "longitude": "5.25614560"
                    },
                    {
                        "id": 156715,
                        "name": "Hennemont",
                        "latitude": "49.14302440",
                        "longitude": "5.63103730"
                    },
                    {
                        "id": 156716,
                        "name": "Herbeuville",
                        "latitude": "49.04767900",
                        "longitude": "5.61981550"
                    },
                    {
                        "id": 156717,
                        "name": "Herméville-en-Woëvre",
                        "latitude": "49.17674840",
                        "longitude": "5.56306380"
                    },
                    {
                        "id": 156718,
                        "name": "Heudicourt-sous-les-Côtes",
                        "latitude": "48.93683270",
                        "longitude": "5.65332710"
                    },
                    {
                        "id": 156719,
                        "name": "Hévilliers",
                        "latitude": "48.60235530",
                        "longitude": "5.28392300"
                    },
                    {
                        "id": 156720,
                        "name": "Horville-en-Ornois",
                        "latitude": "48.48566250",
                        "longitude": "5.44821910"
                    },
                    {
                        "id": 156721,
                        "name": "Houdelaincourt",
                        "latitude": "48.54996910",
                        "longitude": "5.41082810"
                    },
                    {
                        "id": 156722,
                        "name": "Inor",
                        "latitude": "49.55268560",
                        "longitude": "5.14423740"
                    },
                    {
                        "id": 156723,
                        "name": "Ippécourt",
                        "latitude": "49.03898800",
                        "longitude": "5.19091120"
                    },
                    {
                        "id": 156724,
                        "name": "Iré-le-Sec",
                        "latitude": "49.47432720",
                        "longitude": "5.37490210"
                    },
                    {
                        "id": 156725,
                        "name": "Jametz",
                        "latitude": "49.42495130",
                        "longitude": "5.35090450"
                    },
                    {
                        "id": 156726,
                        "name": "Jonville-en-Woëvre",
                        "latitude": "49.06458360",
                        "longitude": "5.73544610"
                    },
                    {
                        "id": 156727,
                        "name": "Jouy-en-Argonne",
                        "latitude": "49.13768450",
                        "longitude": "5.20114130"
                    },
                    {
                        "id": 156728,
                        "name": "Julvécourt",
                        "latitude": "49.05963720",
                        "longitude": "5.16737320"
                    },
                    {
                        "id": 156729,
                        "name": "Juvigny-en-Perthois",
                        "latitude": "48.59771700",
                        "longitude": "5.14595740"
                    },
                    {
                        "id": 156730,
                        "name": "Juvigny-sur-Loison",
                        "latitude": "49.46169380",
                        "longitude": "5.29455350"
                    },
                    {
                        "id": 156731,
                        "name": "Kœur-la-Grande",
                        "latitude": "48.86481860",
                        "longitude": "5.42116640"
                    },
                    {
                        "id": 156732,
                        "name": "Kœur-la-Petite",
                        "latitude": "48.85336650",
                        "longitude": "5.41985460"
                    },
                    {
                        "id": 156733,
                        "name": "L'Isle-en-Rigault",
                        "latitude": "48.71034120",
                        "longitude": "4.98890440"
                    },
                    {
                        "id": 156734,
                        "name": "Labeuville",
                        "latitude": "49.08808290",
                        "longitude": "5.73148930"
                    },
                    {
                        "id": 156735,
                        "name": "Lachalade",
                        "latitude": "49.17805000",
                        "longitude": "4.94442650"
                    },
                    {
                        "id": 156736,
                        "name": "Lachaussée",
                        "latitude": "49.03218530",
                        "longitude": "5.75716150"
                    },
                    {
                        "id": 156737,
                        "name": "Lacroix-sur-Meuse",
                        "latitude": "48.98457220",
                        "longitude": "5.48871750"
                    },
                    {
                        "id": 156738,
                        "name": "Lahaymeix",
                        "latitude": "48.93384780",
                        "longitude": "5.37734030"
                    },
                    {
                        "id": 156739,
                        "name": "Lahayville",
                        "latitude": "48.89466810",
                        "longitude": "5.74852350"
                    },
                    {
                        "id": 156740,
                        "name": "Laheycourt",
                        "latitude": "48.90099470",
                        "longitude": "4.99404560"
                    },
                    {
                        "id": 156741,
                        "name": "Laimont",
                        "latitude": "48.84216070",
                        "longitude": "5.00037490"
                    },
                    {
                        "id": 156742,
                        "name": "Lamorville",
                        "latitude": "48.96243500",
                        "longitude": "5.51747290"
                    },
                    {
                        "id": 156743,
                        "name": "Lamouilly",
                        "latitude": "49.54799770",
                        "longitude": "5.22391800"
                    },
                    {
                        "id": 156744,
                        "name": "Landrecourt-Lempire",
                        "latitude": "49.09544020",
                        "longitude": "5.29041840"
                    },
                    {
                        "id": 156745,
                        "name": "Laneuville-au-Rupt",
                        "latitude": "48.70712280",
                        "longitude": "5.53474740"
                    },
                    {
                        "id": 156746,
                        "name": "Laneuville-sur-Meuse",
                        "latitude": "49.49595450",
                        "longitude": "5.07622270"
                    },
                    {
                        "id": 156747,
                        "name": "Lanhères",
                        "latitude": "49.21001140",
                        "longitude": "5.69107820"
                    },
                    {
                        "id": 156748,
                        "name": "Latour-en-Woëvre",
                        "latitude": "49.09196160",
                        "longitude": "5.78100630"
                    },
                    {
                        "id": 156749,
                        "name": "Lavallée",
                        "latitude": "48.80668120",
                        "longitude": "5.29407120"
                    },
                    {
                        "id": 156750,
                        "name": "Lavincourt",
                        "latitude": "48.65676000",
                        "longitude": "5.12446310"
                    },
                    {
                        "id": 156751,
                        "name": "Lavoye",
                        "latitude": "49.04927300",
                        "longitude": "5.09529430"
                    },
                    {
                        "id": 156752,
                        "name": "Le Bouchon-sur-Saulx",
                        "latitude": "48.61058000",
                        "longitude": "5.20360510"
                    },
                    {
                        "id": 156753,
                        "name": "Le Claon",
                        "latitude": "49.14518460",
                        "longitude": "4.97181320"
                    },
                    {
                        "id": 156764,
                        "name": "Le Neufour",
                        "latitude": "49.12899740",
                        "longitude": "4.97358390"
                    },
                    {
                        "id": 156754,
                        "name": "Lemmes",
                        "latitude": "49.06958470",
                        "longitude": "5.27160930"
                    },
                    {
                        "id": 156756,
                        "name": "Les Éparges",
                        "latitude": "49.06483370",
                        "longitude": "5.56482080"
                    },
                    {
                        "id": 156757,
                        "name": "Les Hauts-de-Chée",
                        "latitude": "48.87241210",
                        "longitude": "5.08857110"
                    },
                    {
                        "id": 156758,
                        "name": "Les Islettes",
                        "latitude": "49.10976760",
                        "longitude": "4.98837530"
                    },
                    {
                        "id": 156765,
                        "name": "Les Monthairons",
                        "latitude": "49.04510600",
                        "longitude": "5.34484380"
                    },
                    {
                        "id": 156766,
                        "name": "Les Paroches",
                        "latitude": "48.91054240",
                        "longitude": "5.44069240"
                    },
                    {
                        "id": 156767,
                        "name": "Les Roises",
                        "latitude": "48.44983690",
                        "longitude": "5.59265890"
                    },
                    {
                        "id": 156768,
                        "name": "Les Souhesmes-Rampont",
                        "latitude": "49.08737720",
                        "longitude": "5.20642280"
                    },
                    {
                        "id": 156769,
                        "name": "Les Trois-Domaines",
                        "latitude": "48.96837770",
                        "longitude": "5.25085440"
                    },
                    {
                        "id": 156759,
                        "name": "Levoncourt",
                        "latitude": "48.82728170",
                        "longitude": "5.31061830"
                    },
                    {
                        "id": 156760,
                        "name": "Lignières-sur-Aire",
                        "latitude": "48.81250750",
                        "longitude": "5.34924760"
                    },
                    {
                        "id": 156762,
                        "name": "Liny-devant-Dun",
                        "latitude": "49.35314080",
                        "longitude": "5.17028470"
                    },
                    {
                        "id": 156763,
                        "name": "Lion-devant-Dun",
                        "latitude": "49.41638290",
                        "longitude": "5.21439040"
                    },
                    {
                        "id": 156770,
                        "name": "Lisle-en-Barrois",
                        "latitude": "48.92092060",
                        "longitude": "4.99907020"
                    },
                    {
                        "id": 156771,
                        "name": "Lissey",
                        "latitude": "49.38126050",
                        "longitude": "5.31856950"
                    },
                    {
                        "id": 156772,
                        "name": "Loisey",
                        "latitude": "48.77090380",
                        "longitude": "5.25876420"
                    },
                    {
                        "id": 156773,
                        "name": "Loison",
                        "latitude": "49.30455620",
                        "longitude": "5.54947980"
                    },
                    {
                        "id": 156774,
                        "name": "Longchamps-sur-Aire",
                        "latitude": "48.91302260",
                        "longitude": "5.26826000"
                    },
                    {
                        "id": 156775,
                        "name": "Longeaux",
                        "latitude": "48.64047460",
                        "longitude": "5.30677090"
                    },
                    {
                        "id": 156777,
                        "name": "Loupmont",
                        "latitude": "48.86629450",
                        "longitude": "5.63696570"
                    },
                    {
                        "id": 156778,
                        "name": "Louppy-le-Château",
                        "latitude": "48.86677960",
                        "longitude": "5.03235960"
                    },
                    {
                        "id": 156779,
                        "name": "Louppy-sur-Loison",
                        "latitude": "49.43927580",
                        "longitude": "5.29751160"
                    },
                    {
                        "id": 156780,
                        "name": "Louvemont-Côte-du-Poivre",
                        "latitude": "49.23725740",
                        "longitude": "5.37891040"
                    },
                    {
                        "id": 156781,
                        "name": "Luzy-Saint-Martin",
                        "latitude": "49.52924190",
                        "longitude": "5.12112750"
                    },
                    {
                        "id": 156782,
                        "name": "Maizeray",
                        "latitude": "49.10370880",
                        "longitude": "5.68021760"
                    },
                    {
                        "id": 156783,
                        "name": "Maizey",
                        "latitude": "48.92395630",
                        "longitude": "5.50049520"
                    },
                    {
                        "id": 156784,
                        "name": "Malancourt",
                        "latitude": "49.23751010",
                        "longitude": "5.13534470"
                    },
                    {
                        "id": 156785,
                        "name": "Mandres-en-Barrois",
                        "latitude": "48.50282240",
                        "longitude": "5.35750910"
                    },
                    {
                        "id": 156786,
                        "name": "Mangiennes",
                        "latitude": "49.34534300",
                        "longitude": "5.49659930"
                    },
                    {
                        "id": 156787,
                        "name": "Manheulles",
                        "latitude": "49.12287230",
                        "longitude": "5.55430970"
                    },
                    {
                        "id": 156788,
                        "name": "Marchéville-en-Woëvre",
                        "latitude": "49.08947350",
                        "longitude": "5.65831990"
                    },
                    {
                        "id": 156789,
                        "name": "Marre",
                        "latitude": "49.20284350",
                        "longitude": "5.25620120"
                    },
                    {
                        "id": 156790,
                        "name": "Marson-sur-Barboure",
                        "latitude": "48.63354360",
                        "longitude": "5.42387600"
                    },
                    {
                        "id": 156791,
                        "name": "Martincourt-sur-Meuse",
                        "latitude": "49.53480160",
                        "longitude": "5.15811550"
                    },
                    {
                        "id": 156792,
                        "name": "Marville",
                        "latitude": "49.44232400",
                        "longitude": "5.39772750"
                    },
                    {
                        "id": 156793,
                        "name": "Maucourt-sur-Orne",
                        "latitude": "49.25303790",
                        "longitude": "5.47233340"
                    },
                    {
                        "id": 156794,
                        "name": "Maulan",
                        "latitude": "48.66570050",
                        "longitude": "5.23911690"
                    },
                    {
                        "id": 156795,
                        "name": "Mauvages",
                        "latitude": "48.59319760",
                        "longitude": "5.50996030"
                    },
                    {
                        "id": 156796,
                        "name": "Maxey-sur-Vaise",
                        "latitude": "48.53212620",
                        "longitude": "5.61641680"
                    },
                    {
                        "id": 156797,
                        "name": "Mécrin",
                        "latitude": "48.82882580",
                        "longitude": "5.52594770"
                    },
                    {
                        "id": 156798,
                        "name": "Méligny-le-Grand",
                        "latitude": "48.67459780",
                        "longitude": "5.45287580"
                    },
                    {
                        "id": 156799,
                        "name": "Méligny-le-Petit",
                        "latitude": "48.65740500",
                        "longitude": "5.44816310"
                    },
                    {
                        "id": 156800,
                        "name": "Menaucourt",
                        "latitude": "48.65449780",
                        "longitude": "5.34115580"
                    },
                    {
                        "id": 156801,
                        "name": "Ménil-aux-Bois",
                        "latitude": "48.80366090",
                        "longitude": "5.42070360"
                    },
                    {
                        "id": 156802,
                        "name": "Ménil-la-Horgne",
                        "latitude": "48.70352050",
                        "longitude": "5.49840410"
                    },
                    {
                        "id": 156803,
                        "name": "Ménil-sur-Saulx",
                        "latitude": "48.61796640",
                        "longitude": "5.16525110"
                    },
                    {
                        "id": 156804,
                        "name": "Merles-sur-Loison",
                        "latitude": "49.36581570",
                        "longitude": "5.43022050"
                    },
                    {
                        "id": 156805,
                        "name": "Milly-sur-Bradon",
                        "latitude": "49.39910620",
                        "longitude": "5.17617910"
                    },
                    {
                        "id": 156806,
                        "name": "Mogeville",
                        "latitude": "49.24592900",
                        "longitude": "5.51960560"
                    },
                    {
                        "id": 156807,
                        "name": "Mognéville",
                        "latitude": "48.77494590",
                        "longitude": "4.94684710"
                    },
                    {
                        "id": 156808,
                        "name": "Moirey-Flabas-Crépion",
                        "latitude": "49.30128550",
                        "longitude": "5.34345680"
                    },
                    {
                        "id": 156809,
                        "name": "Mont-devant-Sassey",
                        "latitude": "49.41472350",
                        "longitude": "5.12242480"
                    },
                    {
                        "id": 156810,
                        "name": "Montblainville",
                        "latitude": "49.24044610",
                        "longitude": "4.94896330"
                    },
                    {
                        "id": 156811,
                        "name": "Montbras",
                        "latitude": "48.51541550",
                        "longitude": "5.67415730"
                    },
                    {
                        "id": 156812,
                        "name": "Montfaucon-d'Argonne",
                        "latitude": "49.25511670",
                        "longitude": "5.09399230"
                    },
                    {
                        "id": 156813,
                        "name": "Montiers-sur-Saulx",
                        "latitude": "48.54129060",
                        "longitude": "5.17808750"
                    },
                    {
                        "id": 156814,
                        "name": "Montigny-devant-Sassey",
                        "latitude": "49.42721330",
                        "longitude": "5.11367380"
                    },
                    {
                        "id": 156815,
                        "name": "Montigny-lès-Vaucouleurs",
                        "latitude": "48.57842130",
                        "longitude": "5.58350230"
                    },
                    {
                        "id": 156817,
                        "name": "Montplonne",
                        "latitude": "48.69825150",
                        "longitude": "5.12465920"
                    },
                    {
                        "id": 156818,
                        "name": "Montsec",
                        "latitude": "48.89018870",
                        "longitude": "5.70477830"
                    },
                    {
                        "id": 156819,
                        "name": "Montzéville",
                        "latitude": "49.18811860",
                        "longitude": "5.17103330"
                    },
                    {
                        "id": 156820,
                        "name": "Moranville",
                        "latitude": "49.17791340",
                        "longitude": "5.52085510"
                    },
                    {
                        "id": 156821,
                        "name": "Morgemoulin",
                        "latitude": "49.23037680",
                        "longitude": "5.52805680"
                    },
                    {
                        "id": 156822,
                        "name": "Morley",
                        "latitude": "48.57427170",
                        "longitude": "5.14208990"
                    },
                    {
                        "id": 156823,
                        "name": "Mouilly",
                        "latitude": "49.05658510",
                        "longitude": "5.49533380"
                    },
                    {
                        "id": 156824,
                        "name": "Moulainville",
                        "latitude": "49.15871350",
                        "longitude": "5.43794770"
                    },
                    {
                        "id": 156825,
                        "name": "Moulins-Saint-Hubert",
                        "latitude": "49.57729150",
                        "longitude": "5.10827700"
                    },
                    {
                        "id": 156826,
                        "name": "Moulotte",
                        "latitude": "49.10091420",
                        "longitude": "5.72986820"
                    },
                    {
                        "id": 156827,
                        "name": "Mouzay",
                        "latitude": "49.45307520",
                        "longitude": "5.20224690"
                    },
                    {
                        "id": 156828,
                        "name": "Murvaux",
                        "latitude": "49.39733450",
                        "longitude": "5.23565530"
                    },
                    {
                        "id": 156829,
                        "name": "Muzeray",
                        "latitude": "49.33849650",
                        "longitude": "5.58153110"
                    },
                    {
                        "id": 156830,
                        "name": "Naives-en-Blois",
                        "latitude": "48.66652170",
                        "longitude": "5.50951110"
                    },
                    {
                        "id": 156831,
                        "name": "Naives-Rosières",
                        "latitude": "48.80310300",
                        "longitude": "5.18959950"
                    },
                    {
                        "id": 156832,
                        "name": "Naix-aux-Forges",
                        "latitude": "48.63121150",
                        "longitude": "5.34977740"
                    },
                    {
                        "id": 156833,
                        "name": "Nançois-le-Grand",
                        "latitude": "48.71288460",
                        "longitude": "5.37208600"
                    },
                    {
                        "id": 156834,
                        "name": "Nançois-sur-Ornain",
                        "latitude": "48.72201370",
                        "longitude": "5.29725970"
                    },
                    {
                        "id": 156835,
                        "name": "Nant-le-Grand",
                        "latitude": "48.68087330",
                        "longitude": "5.19105120"
                    },
                    {
                        "id": 156836,
                        "name": "Nant-le-Petit",
                        "latitude": "48.65135630",
                        "longitude": "5.20701390"
                    },
                    {
                        "id": 156837,
                        "name": "Nantillois",
                        "latitude": "49.30256190",
                        "longitude": "5.11210260"
                    },
                    {
                        "id": 156838,
                        "name": "Nantois",
                        "latitude": "48.62775160",
                        "longitude": "5.32116460"
                    },
                    {
                        "id": 156839,
                        "name": "Nepvant",
                        "latitude": "49.53639180",
                        "longitude": "5.20240100"
                    },
                    {
                        "id": 156840,
                        "name": "Nettancourt",
                        "latitude": "48.87401090",
                        "longitude": "4.89467490"
                    },
                    {
                        "id": 156841,
                        "name": "Neuville-en-Verdunois",
                        "latitude": "48.94890690",
                        "longitude": "5.26469190"
                    },
                    {
                        "id": 156842,
                        "name": "Neuville-lès-Vaucouleurs",
                        "latitude": "48.57722510",
                        "longitude": "5.63663620"
                    },
                    {
                        "id": 156843,
                        "name": "Neuville-sur-Ornain",
                        "latitude": "48.82352660",
                        "longitude": "5.00837360"
                    },
                    {
                        "id": 156844,
                        "name": "Neuvilly-en-Argonne",
                        "latitude": "49.16129370",
                        "longitude": "4.95021200"
                    },
                    {
                        "id": 156845,
                        "name": "Nicey-sur-Aire",
                        "latitude": "48.89577810",
                        "longitude": "5.30867370"
                    },
                    {
                        "id": 156846,
                        "name": "Nixéville-Blercourt",
                        "latitude": "49.11151800",
                        "longitude": "5.17292930"
                    },
                    {
                        "id": 156847,
                        "name": "Nonsard-Lamarche",
                        "latitude": "48.93664820",
                        "longitude": "5.72052730"
                    },
                    {
                        "id": 156848,
                        "name": "Nouillonpont",
                        "latitude": "49.35709260",
                        "longitude": "5.62448760"
                    },
                    {
                        "id": 156849,
                        "name": "Noyers-Auzécourt",
                        "latitude": "48.88520160",
                        "longitude": "4.94208700"
                    },
                    {
                        "id": 156850,
                        "name": "Nubécourt",
                        "latitude": "49.00615460",
                        "longitude": "5.13427310"
                    },
                    {
                        "id": 156851,
                        "name": "Olizy-sur-Chiers",
                        "latitude": "49.55730540",
                        "longitude": "5.18622590"
                    },
                    {
                        "id": 156852,
                        "name": "Ornes",
                        "latitude": "49.25764690",
                        "longitude": "5.44034480"
                    },
                    {
                        "id": 156853,
                        "name": "Osches",
                        "latitude": "49.04531270",
                        "longitude": "5.22975570"
                    },
                    {
                        "id": 156854,
                        "name": "Ourches-sur-Meuse",
                        "latitude": "48.66715320",
                        "longitude": "5.67230760"
                    },
                    {
                        "id": 156855,
                        "name": "Pagny-la-Blanche-Côte",
                        "latitude": "48.53759320",
                        "longitude": "5.69872950"
                    },
                    {
                        "id": 156856,
                        "name": "Pagny-sur-Meuse",
                        "latitude": "48.69041270",
                        "longitude": "5.69074200"
                    },
                    {
                        "id": 156857,
                        "name": "Pareid",
                        "latitude": "49.12737300",
                        "longitude": "5.68667760"
                    },
                    {
                        "id": 156858,
                        "name": "Parfondrupt",
                        "latitude": "49.14905020",
                        "longitude": "5.70298920"
                    },
                    {
                        "id": 156859,
                        "name": "Peuvillers",
                        "latitude": "49.36784770",
                        "longitude": "5.38234520"
                    },
                    {
                        "id": 156860,
                        "name": "Pierrefitte-sur-Aire",
                        "latitude": "48.90505420",
                        "longitude": "5.30423020"
                    },
                    {
                        "id": 156861,
                        "name": "Pillon",
                        "latitude": "49.37121790",
                        "longitude": "5.54355010"
                    },
                    {
                        "id": 156862,
                        "name": "Pintheville",
                        "latitude": "49.11617870",
                        "longitude": "5.64788820"
                    },
                    {
                        "id": 156863,
                        "name": "Pont-sur-Meuse",
                        "latitude": "48.81097850",
                        "longitude": "5.53249380"
                    },
                    {
                        "id": 156864,
                        "name": "Pouilly-sur-Meuse",
                        "latitude": "49.53871480",
                        "longitude": "5.08140300"
                    },
                    {
                        "id": 156865,
                        "name": "Pretz-en-Argonne",
                        "latitude": "48.95851050",
                        "longitude": "5.12465780"
                    },
                    {
                        "id": 156866,
                        "name": "Quincy-Landzécourt",
                        "latitude": "49.48921610",
                        "longitude": "5.25340950"
                    },
                    {
                        "id": 156867,
                        "name": "Raival",
                        "latitude": "48.88469720",
                        "longitude": "5.20796430"
                    },
                    {
                        "id": 156868,
                        "name": "Rambluzin-et-Benoite-Vaux",
                        "latitude": "48.98645580",
                        "longitude": "5.29668640"
                    },
                    {
                        "id": 156869,
                        "name": "Rambucourt",
                        "latitude": "48.83053820",
                        "longitude": "5.71199610"
                    },
                    {
                        "id": 156870,
                        "name": "Rancourt-sur-Ornain",
                        "latitude": "48.81906730",
                        "longitude": "4.89557360"
                    },
                    {
                        "id": 156871,
                        "name": "Ranzières",
                        "latitude": "49.02437660",
                        "longitude": "5.46121670"
                    },
                    {
                        "id": 156872,
                        "name": "Rarécourt",
                        "latitude": "49.07635530",
                        "longitude": "5.04722430"
                    },
                    {
                        "id": 156873,
                        "name": "Récicourt",
                        "latitude": "49.15422010",
                        "longitude": "5.12024930"
                    },
                    {
                        "id": 156874,
                        "name": "Récourt-le-Creux",
                        "latitude": "48.99777820",
                        "longitude": "5.33598140"
                    },
                    {
                        "id": 156875,
                        "name": "Reffroy",
                        "latitude": "48.62655930",
                        "longitude": "5.44900300"
                    },
                    {
                        "id": 156876,
                        "name": "Regnéville-sur-Meuse",
                        "latitude": "49.25414010",
                        "longitude": "5.29522690"
                    },
                    {
                        "id": 156877,
                        "name": "Rembercourt-Sommaisne",
                        "latitude": "48.92070550",
                        "longitude": "5.13996830"
                    },
                    {
                        "id": 156878,
                        "name": "Remennecourt",
                        "latitude": "48.79904120",
                        "longitude": "4.89349600"
                    },
                    {
                        "id": 156879,
                        "name": "Remoiville",
                        "latitude": "49.43692670",
                        "longitude": "5.34035810"
                    },
                    {
                        "id": 156880,
                        "name": "Resson",
                        "latitude": "48.77247840",
                        "longitude": "5.20976770"
                    },
                    {
                        "id": 156882,
                        "name": "Réville-aux-Bois",
                        "latitude": "49.33783130",
                        "longitude": "5.30238870"
                    },
                    {
                        "id": 156883,
                        "name": "Riaville",
                        "latitude": "49.09599830",
                        "longitude": "5.64647140"
                    },
                    {
                        "id": 156884,
                        "name": "Ribeaucourt",
                        "latitude": "48.54223820",
                        "longitude": "5.31379210"
                    },
                    {
                        "id": 156885,
                        "name": "Richecourt",
                        "latitude": "48.89443880",
                        "longitude": "5.73382990"
                    },
                    {
                        "id": 156886,
                        "name": "Rigny-la-Salle",
                        "latitude": "48.62536020",
                        "longitude": "5.67972210"
                    },
                    {
                        "id": 156887,
                        "name": "Rigny-Saint-Martin",
                        "latitude": "48.61012660",
                        "longitude": "5.71068250"
                    },
                    {
                        "id": 156888,
                        "name": "Robert-Espagne",
                        "latitude": "48.72926730",
                        "longitude": "5.00469050"
                    },
                    {
                        "id": 156889,
                        "name": "Romagne-sous-les-Côtes",
                        "latitude": "49.33024820",
                        "longitude": "5.42692970"
                    },
                    {
                        "id": 156890,
                        "name": "Romagne-sous-Montfaucon",
                        "latitude": "49.32753510",
                        "longitude": "5.02688150"
                    },
                    {
                        "id": 156891,
                        "name": "Ronvaux",
                        "latitude": "49.13147700",
                        "longitude": "5.53890910"
                    },
                    {
                        "id": 156892,
                        "name": "Rouvres-en-Woëvre",
                        "latitude": "49.22317950",
                        "longitude": "5.65989010"
                    },
                    {
                        "id": 156893,
                        "name": "Rouvrois-sur-Meuse",
                        "latitude": "48.94953350",
                        "longitude": "5.50452050"
                    },
                    {
                        "id": 156894,
                        "name": "Rouvrois-sur-Othain",
                        "latitude": "49.38826730",
                        "longitude": "5.59062350"
                    },
                    {
                        "id": 156895,
                        "name": "Rumont",
                        "latitude": "48.82804310",
                        "longitude": "5.23684370"
                    },
                    {
                        "id": 156896,
                        "name": "Rupt-aux-Nonains",
                        "latitude": "48.66985200",
                        "longitude": "5.04768020"
                    },
                    {
                        "id": 156897,
                        "name": "Rupt-devant-Saint-Mihiel",
                        "latitude": "48.88719940",
                        "longitude": "5.37745280"
                    },
                    {
                        "id": 156898,
                        "name": "Rupt-en-Woëvre",
                        "latitude": "49.06483860",
                        "longitude": "5.45603290"
                    },
                    {
                        "id": 156899,
                        "name": "Rupt-sur-Othain",
                        "latitude": "49.41577620",
                        "longitude": "5.45701310"
                    },
                    {
                        "id": 156900,
                        "name": "Saint-Amand-sur-Ornain",
                        "latitude": "48.62629850",
                        "longitude": "5.37210890"
                    },
                    {
                        "id": 156901,
                        "name": "Saint-André-en-Barrois",
                        "latitude": "49.00962810",
                        "longitude": "5.21148770"
                    },
                    {
                        "id": 156902,
                        "name": "Saint-Aubin-sur-Aire",
                        "latitude": "48.71708070",
                        "longitude": "5.40858000"
                    },
                    {
                        "id": 156903,
                        "name": "Saint-Germain-sur-Meuse",
                        "latitude": "48.64731210",
                        "longitude": "5.67559510"
                    },
                    {
                        "id": 156904,
                        "name": "Saint-Hilaire-en-Woëvre",
                        "latitude": "49.07497060",
                        "longitude": "5.66090670"
                    },
                    {
                        "id": 156905,
                        "name": "Saint-Jean-lès-Buzy",
                        "latitude": "49.17033190",
                        "longitude": "5.69951830"
                    },
                    {
                        "id": 156906,
                        "name": "Saint-Joire",
                        "latitude": "48.58216990",
                        "longitude": "5.36788680"
                    },
                    {
                        "id": 156907,
                        "name": "Saint-Julien-sous-les-Côtes",
                        "latitude": "48.82122480",
                        "longitude": "5.59984120"
                    },
                    {
                        "id": 156908,
                        "name": "Saint-Laurent-sur-Othain",
                        "latitude": "49.39746030",
                        "longitude": "5.48741910"
                    },
                    {
                        "id": 156909,
                        "name": "Saint-Maurice-sous-les-Côtes",
                        "latitude": "49.01146950",
                        "longitude": "5.62798720"
                    },
                    {
                        "id": 156911,
                        "name": "Saint-Pierrevillers",
                        "latitude": "49.37359680",
                        "longitude": "5.66446430"
                    },
                    {
                        "id": 156912,
                        "name": "Saint-Remy-la-Calonne",
                        "latitude": "49.03864990",
                        "longitude": "5.54651210"
                    },
                    {
                        "id": 156913,
                        "name": "Salmagne",
                        "latitude": "48.75870970",
                        "longitude": "5.29010790"
                    },
                    {
                        "id": 156914,
                        "name": "Samogneux",
                        "latitude": "49.25799740",
                        "longitude": "5.33084700"
                    },
                    {
                        "id": 156915,
                        "name": "Sampigny",
                        "latitude": "48.81977510",
                        "longitude": "5.44562810"
                    },
                    {
                        "id": 156916,
                        "name": "Sassey-sur-Meuse",
                        "latitude": "49.41315880",
                        "longitude": "5.15928660"
                    },
                    {
                        "id": 156917,
                        "name": "Saudrupt",
                        "latitude": "48.69400790",
                        "longitude": "5.03425360"
                    },
                    {
                        "id": 156918,
                        "name": "Saulmory-Villefranche",
                        "latitude": "49.43839510",
                        "longitude": "5.15062870"
                    },
                    {
                        "id": 156919,
                        "name": "Saulvaux",
                        "latitude": "48.69222340",
                        "longitude": "5.42141070"
                    },
                    {
                        "id": 156920,
                        "name": "Saulx-lès-Champlon",
                        "latitude": "49.07387510",
                        "longitude": "5.61599190"
                    },
                    {
                        "id": 156921,
                        "name": "Sauvigny",
                        "latitude": "48.50056650",
                        "longitude": "5.69091880"
                    },
                    {
                        "id": 156922,
                        "name": "Sauvoy",
                        "latitude": "48.63834230",
                        "longitude": "5.56398380"
                    },
                    {
                        "id": 156923,
                        "name": "Savonnières-devant-Bar",
                        "latitude": "48.74908020",
                        "longitude": "5.15519670"
                    },
                    {
                        "id": 156924,
                        "name": "Savonnières-en-Perthois",
                        "latitude": "48.60230750",
                        "longitude": "5.10156550"
                    },
                    {
                        "id": 156925,
                        "name": "Seigneulles",
                        "latitude": "48.85215160",
                        "longitude": "5.21186850"
                    },
                    {
                        "id": 156926,
                        "name": "Senon",
                        "latitude": "49.28049620",
                        "longitude": "5.57871770"
                    },
                    {
                        "id": 156927,
                        "name": "Senoncourt-lès-Maujouy",
                        "latitude": "49.05854980",
                        "longitude": "5.30461760"
                    },
                    {
                        "id": 156928,
                        "name": "Septsarges",
                        "latitude": "49.28747270",
                        "longitude": "5.15683380"
                    },
                    {
                        "id": 156929,
                        "name": "Sepvigny",
                        "latitude": "48.56421780",
                        "longitude": "5.67317790"
                    },
                    {
                        "id": 156930,
                        "name": "Seuil-d'Argonne",
                        "latitude": "48.97126640",
                        "longitude": "5.01142150"
                    },
                    {
                        "id": 156931,
                        "name": "Seuzey",
                        "latitude": "48.98997940",
                        "longitude": "5.54064890"
                    },
                    {
                        "id": 156932,
                        "name": "Silmont",
                        "latitude": "48.73581360",
                        "longitude": "5.22563760"
                    },
                    {
                        "id": 156933,
                        "name": "Sivry-la-Perche",
                        "latitude": "49.13796090",
                        "longitude": "5.21402720"
                    },
                    {
                        "id": 156934,
                        "name": "Sivry-sur-Meuse",
                        "latitude": "49.33016260",
                        "longitude": "5.24453690"
                    },
                    {
                        "id": 156935,
                        "name": "Sommedieue",
                        "latitude": "49.09839160",
                        "longitude": "5.43692250"
                    },
                    {
                        "id": 156936,
                        "name": "Sommeilles",
                        "latitude": "48.91528400",
                        "longitude": "4.92458270"
                    },
                    {
                        "id": 156937,
                        "name": "Sommelonne",
                        "latitude": "48.67625150",
                        "longitude": "4.99788410"
                    },
                    {
                        "id": 156938,
                        "name": "Sorbey",
                        "latitude": "49.40193500",
                        "longitude": "5.54455780"
                    },
                    {
                        "id": 156939,
                        "name": "Sorcy-Saint-Martin",
                        "latitude": "48.71969650",
                        "longitude": "5.57643010"
                    },
                    {
                        "id": 156940,
                        "name": "Souilly",
                        "latitude": "49.03229210",
                        "longitude": "5.21380960"
                    },
                    {
                        "id": 156941,
                        "name": "Spincourt",
                        "latitude": "49.33591620",
                        "longitude": "5.65123710"
                    },
                    {
                        "id": 156942,
                        "name": "Stainville",
                        "latitude": "48.64188120",
                        "longitude": "5.13767670"
                    },
                    {
                        "id": 156944,
                        "name": "Taillancourt",
                        "latitude": "48.51253120",
                        "longitude": "5.62147700"
                    },
                    {
                        "id": 156945,
                        "name": "Tannois",
                        "latitude": "48.71914340",
                        "longitude": "5.17825040"
                    },
                    {
                        "id": 156947,
                        "name": "Thillombois",
                        "latitude": "48.95355960",
                        "longitude": "5.34224800"
                    },
                    {
                        "id": 156948,
                        "name": "Thillot",
                        "latitude": "49.02463390",
                        "longitude": "5.64632350"
                    },
                    {
                        "id": 156949,
                        "name": "Thonne-la-Long",
                        "latitude": "49.57172150",
                        "longitude": "5.40693240"
                    },
                    {
                        "id": 156950,
                        "name": "Thonne-le-Thil",
                        "latitude": "49.57310550",
                        "longitude": "5.31744810"
                    },
                    {
                        "id": 156951,
                        "name": "Thonne-les-Près",
                        "latitude": "49.53314540",
                        "longitude": "5.32115530"
                    },
                    {
                        "id": 156952,
                        "name": "Thonnelle",
                        "latitude": "49.55442690",
                        "longitude": "5.33509810"
                    },
                    {
                        "id": 156953,
                        "name": "Tilly-sur-Meuse",
                        "latitude": "48.99509140",
                        "longitude": "5.36912070"
                    },
                    {
                        "id": 156954,
                        "name": "Trémont-sur-Saulx",
                        "latitude": "48.74350610",
                        "longitude": "5.04877160"
                    },
                    {
                        "id": 156955,
                        "name": "Trésauvaux",
                        "latitude": "49.07989510",
                        "longitude": "5.59086390"
                    },
                    {
                        "id": 156956,
                        "name": "Tréveray",
                        "latitude": "48.60433360",
                        "longitude": "5.35161720"
                    },
                    {
                        "id": 156958,
                        "name": "Troussey",
                        "latitude": "48.70103200",
                        "longitude": "5.65526920"
                    },
                    {
                        "id": 156959,
                        "name": "Troyon",
                        "latitude": "48.99895560",
                        "longitude": "5.45151320"
                    },
                    {
                        "id": 156960,
                        "name": "Ugny-sur-Meuse",
                        "latitude": "48.63719020",
                        "longitude": "5.66760250"
                    },
                    {
                        "id": 156961,
                        "name": "Vacherauville",
                        "latitude": "49.23183630",
                        "longitude": "5.30611930"
                    },
                    {
                        "id": 156962,
                        "name": "Vadelaincourt",
                        "latitude": "49.07118340",
                        "longitude": "5.23714340"
                    },
                    {
                        "id": 156963,
                        "name": "Vadonville",
                        "latitude": "48.80012910",
                        "longitude": "5.49326200"
                    },
                    {
                        "id": 156964,
                        "name": "Val-d'Ornain",
                        "latitude": "48.81310330",
                        "longitude": "5.04734920"
                    },
                    {
                        "id": 156965,
                        "name": "Valbois",
                        "latitude": "48.92968860",
                        "longitude": "5.57549060"
                    },
                    {
                        "id": 156966,
                        "name": "Varennes-en-Argonne",
                        "latitude": "49.22985940",
                        "longitude": "4.97185240"
                    },
                    {
                        "id": 156967,
                        "name": "Varnéville",
                        "latitude": "48.87679930",
                        "longitude": "5.63878100"
                    },
                    {
                        "id": 156968,
                        "name": "Vassincourt",
                        "latitude": "48.80102650",
                        "longitude": "5.00539440"
                    },
                    {
                        "id": 156969,
                        "name": "Vaubecourt",
                        "latitude": "48.94458410",
                        "longitude": "5.06501010"
                    },
                    {
                        "id": 156971,
                        "name": "Vaudeville-le-Haut",
                        "latitude": "48.44647070",
                        "longitude": "5.55274550"
                    },
                    {
                        "id": 156972,
                        "name": "Vaudoncourt",
                        "latitude": "49.31738010",
                        "longitude": "5.62378680"
                    },
                    {
                        "id": 156973,
                        "name": "Vauquois",
                        "latitude": "49.19873210",
                        "longitude": "5.04193780"
                    },
                    {
                        "id": 156974,
                        "name": "Vaux-lès-Palameix",
                        "latitude": "49.02345330",
                        "longitude": "5.50929970"
                    },
                    {
                        "id": 156975,
                        "name": "Vavincourt",
                        "latitude": "48.82454790",
                        "longitude": "5.15470230"
                    },
                    {
                        "id": 156977,
                        "name": "Velosnes",
                        "latitude": "49.50077970",
                        "longitude": "5.43529340"
                    },
                    {
                        "id": 156979,
                        "name": "Verneuil-Grand",
                        "latitude": "49.53500790",
                        "longitude": "5.40188700"
                    },
                    {
                        "id": 156980,
                        "name": "Verneuil-Petit",
                        "latitude": "49.54457420",
                        "longitude": "5.39835050"
                    },
                    {
                        "id": 156981,
                        "name": "Véry",
                        "latitude": "49.23552930",
                        "longitude": "5.04745090"
                    },
                    {
                        "id": 156982,
                        "name": "Vigneul-sous-Montmédy",
                        "latitude": "49.50890470",
                        "longitude": "5.31032850"
                    },
                    {
                        "id": 156985,
                        "name": "Ville-devant-Belrain",
                        "latitude": "48.87728020",
                        "longitude": "5.31806890"
                    },
                    {
                        "id": 156986,
                        "name": "Ville-devant-Chaumont",
                        "latitude": "49.29057040",
                        "longitude": "5.40927120"
                    },
                    {
                        "id": 156987,
                        "name": "Ville-en-Woëvre",
                        "latitude": "49.13992700",
                        "longitude": "5.56951470"
                    },
                    {
                        "id": 156988,
                        "name": "Ville-sur-Cousances",
                        "latitude": "49.07958800",
                        "longitude": "5.13834460"
                    },
                    {
                        "id": 156989,
                        "name": "Ville-sur-Saulx",
                        "latitude": "48.71747880",
                        "longitude": "5.04943550"
                    },
                    {
                        "id": 156990,
                        "name": "Villécloye",
                        "latitude": "49.50816900",
                        "longitude": "5.38434800"
                    },
                    {
                        "id": 156991,
                        "name": "Villeroy-sur-Méholle",
                        "latitude": "48.61415890",
                        "longitude": "5.54640360"
                    },
                    {
                        "id": 156992,
                        "name": "Villers-aux-Vents",
                        "latitude": "48.85974880",
                        "longitude": "5.00241390"
                    },
                    {
                        "id": 156993,
                        "name": "Villers-devant-Dun",
                        "latitude": "49.39841480",
                        "longitude": "5.08591900"
                    },
                    {
                        "id": 156994,
                        "name": "Villers-le-Sec",
                        "latitude": "48.62596370",
                        "longitude": "5.27943900"
                    },
                    {
                        "id": 156995,
                        "name": "Villers-lès-Mangiennes",
                        "latitude": "49.35593880",
                        "longitude": "5.46105480"
                    },
                    {
                        "id": 156996,
                        "name": "Villers-sous-Pareid",
                        "latitude": "49.12703940",
                        "longitude": "5.72493230"
                    },
                    {
                        "id": 156997,
                        "name": "Villers-sur-Meuse",
                        "latitude": "49.02346420",
                        "longitude": "5.37791110"
                    },
                    {
                        "id": 156998,
                        "name": "Villotte-devant-Louppy",
                        "latitude": "48.88992340",
                        "longitude": "5.03631540"
                    },
                    {
                        "id": 156999,
                        "name": "Villotte-sur-Aire",
                        "latitude": "48.85543480",
                        "longitude": "5.31931630"
                    },
                    {
                        "id": 157000,
                        "name": "Vilosnes-Haraumont",
                        "latitude": "49.33887480",
                        "longitude": "5.21008330"
                    },
                    {
                        "id": 157001,
                        "name": "Vittarville",
                        "latitude": "49.38485200",
                        "longitude": "5.37147030"
                    },
                    {
                        "id": 157003,
                        "name": "Vouthon-Bas",
                        "latitude": "48.48879200",
                        "longitude": "5.59584880"
                    },
                    {
                        "id": 157004,
                        "name": "Vouthon-Haut",
                        "latitude": "48.47960360",
                        "longitude": "5.56394000"
                    },
                    {
                        "id": 157005,
                        "name": "Waly",
                        "latitude": "49.02341850",
                        "longitude": "5.07494570"
                    },
                    {
                        "id": 157006,
                        "name": "Warcq",
                        "latitude": "49.19000130",
                        "longitude": "5.62324000"
                    },
                    {
                        "id": 157007,
                        "name": "Watronville",
                        "latitude": "49.13687260",
                        "longitude": "5.50012770"
                    },
                    {
                        "id": 157008,
                        "name": "Wavrille",
                        "latitude": "49.31891460",
                        "longitude": "5.35388940"
                    },
                    {
                        "id": 157009,
                        "name": "Willeroncourt",
                        "latitude": "48.71574440",
                        "longitude": "5.33659220"
                    },
                    {
                        "id": 157010,
                        "name": "Wiseppe",
                        "latitude": "49.46046290",
                        "longitude": "5.14342590"
                    },
                    {
                        "id": 157011,
                        "name": "Woël",
                        "latitude": "49.03890730",
                        "longitude": "5.70460080"
                    },
                    {
                        "id": 157012,
                        "name": "Woimbey",
                        "latitude": "48.96632360",
                        "longitude": "5.40909270"
                    },
                    {
                        "id": 157013,
                        "name": "Xivray-et-Marvoisin",
                        "latitude": "48.86728710",
                        "longitude": "5.68687780"
                    }
                ]
            },
            {
                "id": 5024,
                "name": "Morbihan",
                "iso2": "56",
                "latitude": "47.74395180",
                "longitude": "-3.44555240",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5025,
                "name": "Moselle",
                "iso2": "57",
                "latitude": "49.02045660",
                "longitude": "6.20553220",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5026,
                "name": "Nièvre",
                "iso2": "58",
                "latitude": "47.11921640",
                "longitude": "2.97797130",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5027,
                "name": "Nord",
                "iso2": "59",
                "latitude": "50.52854770",
                "longitude": "2.60007760",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4804,
                "name": "Normandie",
                "iso2": "NOR",
                "latitude": "48.87987040",
                "longitude": "0.17125290",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39241,
                        "name": "Ablon",
                        "latitude": "49.39214000",
                        "longitude": "0.29584000"
                    },
                    {
                        "id": 39255,
                        "name": "Acquigny",
                        "latitude": "49.17350000",
                        "longitude": "1.17650000"
                    },
                    {
                        "id": 39259,
                        "name": "Agneaux",
                        "latitude": "49.11905000",
                        "longitude": "-1.10610000"
                    },
                    {
                        "id": 39262,
                        "name": "Agon-Coutainville",
                        "latitude": "49.04167000",
                        "longitude": "-1.57500000"
                    },
                    {
                        "id": 39310,
                        "name": "Alençon",
                        "latitude": "48.43476000",
                        "longitude": "0.09311000"
                    },
                    {
                        "id": 39317,
                        "name": "Alizay",
                        "latitude": "49.32158000",
                        "longitude": "1.17854000"
                    },
                    {
                        "id": 39362,
                        "name": "Amfreville",
                        "latitude": "49.25000000",
                        "longitude": "-0.23333000"
                    },
                    {
                        "id": 39363,
                        "name": "Amfreville-la-Mi-Voie",
                        "latitude": "49.40755000",
                        "longitude": "1.13871000"
                    },
                    {
                        "id": 39393,
                        "name": "Andé",
                        "latitude": "49.23163000",
                        "longitude": "1.24088000"
                    },
                    {
                        "id": 39398,
                        "name": "Angerville-l’Orcher",
                        "latitude": "49.58833000",
                        "longitude": "0.28191000"
                    },
                    {
                        "id": 39477,
                        "name": "Argences",
                        "latitude": "49.12635000",
                        "longitude": "-0.16644000"
                    },
                    {
                        "id": 39479,
                        "name": "Argentan",
                        "latitude": "48.74441000",
                        "longitude": "-0.02023000"
                    },
                    {
                        "id": 39502,
                        "name": "Arnières-sur-Iton",
                        "latitude": "48.99678000",
                        "longitude": "1.10384000"
                    },
                    {
                        "id": 39509,
                        "name": "Arques-la-Bataille",
                        "latitude": "49.88122000",
                        "longitude": "1.12875000"
                    },
                    {
                        "id": 39558,
                        "name": "Athis-de-l'Orne",
                        "latitude": "48.81667000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 39568,
                        "name": "Aube-sur-Rîle",
                        "latitude": "48.73920000",
                        "longitude": "0.55161000"
                    },
                    {
                        "id": 39575,
                        "name": "Aubevoye",
                        "latitude": "49.17097000",
                        "longitude": "1.33537000"
                    },
                    {
                        "id": 39603,
                        "name": "Auffay",
                        "latitude": "49.71881000",
                        "longitude": "1.09911000"
                    },
                    {
                        "id": 39615,
                        "name": "Aumale",
                        "latitude": "49.76985000",
                        "longitude": "1.75587000"
                    },
                    {
                        "id": 39619,
                        "name": "Aunay-sur-Odon",
                        "latitude": "49.02012000",
                        "longitude": "-0.63238000"
                    },
                    {
                        "id": 39635,
                        "name": "Authie",
                        "latitude": "49.20615000",
                        "longitude": "-0.43191000"
                    },
                    {
                        "id": 39651,
                        "name": "Auzebosc",
                        "latitude": "49.59565000",
                        "longitude": "0.72850000"
                    },
                    {
                        "id": 39673,
                        "name": "Aviron",
                        "latitude": "49.05000000",
                        "longitude": "1.11667000"
                    },
                    {
                        "id": 39678,
                        "name": "Avranches",
                        "latitude": "48.68436000",
                        "longitude": "-1.35686000"
                    },
                    {
                        "id": 39702,
                        "name": "Bacqueville-en-Caux",
                        "latitude": "49.78761000",
                        "longitude": "0.99927000"
                    },
                    {
                        "id": 39710,
                        "name": "Bagnoles-de-l'Orne",
                        "latitude": "48.55720000",
                        "longitude": "-0.41383000"
                    },
                    {
                        "id": 39781,
                        "name": "Barentin",
                        "latitude": "49.54533000",
                        "longitude": "0.95515000"
                    },
                    {
                        "id": 39782,
                        "name": "Barenton",
                        "latitude": "48.60027000",
                        "longitude": "-0.83258000"
                    },
                    {
                        "id": 39788,
                        "name": "Barneville-Carteret",
                        "latitude": "49.38333000",
                        "longitude": "-1.75000000"
                    },
                    {
                        "id": 39789,
                        "name": "Barneville-Plage",
                        "latitude": "49.36786000",
                        "longitude": "-1.76512000"
                    },
                    {
                        "id": 39819,
                        "name": "Bavent",
                        "latitude": "49.22996000",
                        "longitude": "-0.18675000"
                    },
                    {
                        "id": 39822,
                        "name": "Bayeux",
                        "latitude": "49.27732000",
                        "longitude": "-0.70390000"
                    },
                    {
                        "id": 39861,
                        "name": "Beaumont-Hague",
                        "latitude": "49.66387000",
                        "longitude": "-1.83822000"
                    },
                    {
                        "id": 39869,
                        "name": "Beaumont-le-Roger",
                        "latitude": "49.07839000",
                        "longitude": "0.78081000"
                    },
                    {
                        "id": 39902,
                        "name": "Belbeuf",
                        "latitude": "49.38766000",
                        "longitude": "1.14245000"
                    },
                    {
                        "id": 39931,
                        "name": "Bellême",
                        "latitude": "48.37329000",
                        "longitude": "0.57005000"
                    },
                    {
                        "id": 39918,
                        "name": "Bellengreville",
                        "latitude": "49.12425000",
                        "longitude": "-0.20961000"
                    },
                    {
                        "id": 40426,
                        "name": "Bénouville",
                        "latitude": "49.24151000",
                        "longitude": "-0.28246000"
                    },
                    {
                        "id": 39952,
                        "name": "Bernay",
                        "latitude": "49.08888000",
                        "longitude": "0.59858000"
                    },
                    {
                        "id": 39954,
                        "name": "Berneval-le-Grand",
                        "latitude": "49.95328000",
                        "longitude": "1.18755000"
                    },
                    {
                        "id": 39957,
                        "name": "Bernières-sur-Mer",
                        "latitude": "49.33057000",
                        "longitude": "-0.42299000"
                    },
                    {
                        "id": 39990,
                        "name": "Beuville",
                        "latitude": "49.24364000",
                        "longitude": "-0.32585000"
                    },
                    {
                        "id": 39991,
                        "name": "Beuvillers",
                        "latitude": "49.12961000",
                        "longitude": "0.25492000"
                    },
                    {
                        "id": 39995,
                        "name": "Beuzeville",
                        "latitude": "49.34483000",
                        "longitude": "0.34254000"
                    },
                    {
                        "id": 39996,
                        "name": "Beuzeville-la-Grenier",
                        "latitude": "49.59157000",
                        "longitude": "0.42684000"
                    },
                    {
                        "id": 40437,
                        "name": "Bézu-Saint-Éloi",
                        "latitude": "49.29524000",
                        "longitude": "1.70404000"
                    },
                    {
                        "id": 40041,
                        "name": "Biéville-Beuville",
                        "latitude": "49.24293000",
                        "longitude": "-0.32762000"
                    },
                    {
                        "id": 40019,
                        "name": "Bihorel",
                        "latitude": "49.45468000",
                        "longitude": "1.12230000"
                    },
                    {
                        "id": 40048,
                        "name": "Blainville-Crevon",
                        "latitude": "49.50395000",
                        "longitude": "1.29952000"
                    },
                    {
                        "id": 40049,
                        "name": "Blainville-sur-Mer",
                        "latitude": "49.06599000",
                        "longitude": "-1.58340000"
                    },
                    {
                        "id": 40050,
                        "name": "Blainville-sur-Orne",
                        "latitude": "49.22913000",
                        "longitude": "-0.30061000"
                    },
                    {
                        "id": 40054,
                        "name": "Blangy-sur-Bresle",
                        "latitude": "49.93211000",
                        "longitude": "1.62514000"
                    },
                    {
                        "id": 40070,
                        "name": "Blonville-sur-Mer",
                        "latitude": "49.33709000",
                        "longitude": "0.02709000"
                    },
                    {
                        "id": 40086,
                        "name": "Bois-Guillaume",
                        "latitude": "49.46020000",
                        "longitude": "1.12219000"
                    },
                    {
                        "id": 40102,
                        "name": "Bolbec",
                        "latitude": "49.57321000",
                        "longitude": "0.47339000"
                    },
                    {
                        "id": 40134,
                        "name": "Boos",
                        "latitude": "49.38849000",
                        "longitude": "1.20348000"
                    },
                    {
                        "id": 40144,
                        "name": "Bosc-le-Hard",
                        "latitude": "49.62734000",
                        "longitude": "1.17483000"
                    },
                    {
                        "id": 40186,
                        "name": "Bourg-Achard",
                        "latitude": "49.35322000",
                        "longitude": "0.81623000"
                    },
                    {
                        "id": 40205,
                        "name": "Bourgtheroulde-Infreville",
                        "latitude": "49.30000000",
                        "longitude": "0.88333000"
                    },
                    {
                        "id": 40207,
                        "name": "Bourguébus",
                        "latitude": "49.12187000",
                        "longitude": "-0.29786000"
                    },
                    {
                        "id": 40213,
                        "name": "Bourth",
                        "latitude": "48.76846000",
                        "longitude": "0.80911000"
                    },
                    {
                        "id": 40229,
                        "name": "Bouville",
                        "latitude": "49.56193000",
                        "longitude": "0.89514000"
                    },
                    {
                        "id": 40355,
                        "name": "Bréauté",
                        "latitude": "49.62805000",
                        "longitude": "0.40005000"
                    },
                    {
                        "id": 40356,
                        "name": "Brécey",
                        "latitude": "48.72413000",
                        "longitude": "-1.16647000"
                    },
                    {
                        "id": 40358,
                        "name": "Bréhal",
                        "latitude": "48.89915000",
                        "longitude": "-1.51225000"
                    },
                    {
                        "id": 40282,
                        "name": "Breteuil",
                        "latitude": "48.83333000",
                        "longitude": "0.91667000"
                    },
                    {
                        "id": 40285,
                        "name": "Bretoncelles",
                        "latitude": "48.43122000",
                        "longitude": "0.88775000"
                    },
                    {
                        "id": 40287,
                        "name": "Bretteville",
                        "latitude": "49.65440000",
                        "longitude": "-1.52884000"
                    },
                    {
                        "id": 40288,
                        "name": "Bretteville-du-Grand-Caux",
                        "latitude": "49.66667000",
                        "longitude": "0.40000000"
                    },
                    {
                        "id": 40289,
                        "name": "Bretteville-l’Orgueilleuse",
                        "latitude": "49.21189000",
                        "longitude": "-0.51428000"
                    },
                    {
                        "id": 40290,
                        "name": "Bretteville-sur-Laize",
                        "latitude": "49.04466000",
                        "longitude": "-0.32639000"
                    },
                    {
                        "id": 40291,
                        "name": "Bretteville-sur-Odon",
                        "latitude": "49.16627000",
                        "longitude": "-0.41662000"
                    },
                    {
                        "id": 40297,
                        "name": "Breuilpont",
                        "latitude": "48.96398000",
                        "longitude": "1.42919000"
                    },
                    {
                        "id": 40303,
                        "name": "Bricquebec",
                        "latitude": "49.47008000",
                        "longitude": "-1.63254000"
                    },
                    {
                        "id": 40320,
                        "name": "Brionne",
                        "latitude": "49.19553000",
                        "longitude": "0.71510000"
                    },
                    {
                        "id": 40323,
                        "name": "Briouze",
                        "latitude": "48.69848000",
                        "longitude": "-0.36806000"
                    },
                    {
                        "id": 40329,
                        "name": "Brix",
                        "latitude": "49.54512000",
                        "longitude": "-1.58012000"
                    },
                    {
                        "id": 40331,
                        "name": "Broglie",
                        "latitude": "49.00911000",
                        "longitude": "0.52915000"
                    },
                    {
                        "id": 40370,
                        "name": "Buchy",
                        "latitude": "49.58513000",
                        "longitude": "1.35852000"
                    },
                    {
                        "id": 40374,
                        "name": "Bueil",
                        "latitude": "48.93189000",
                        "longitude": "1.44257000"
                    },
                    {
                        "id": 40382,
                        "name": "Bully",
                        "latitude": "49.10155000",
                        "longitude": "-0.40825000"
                    },
                    {
                        "id": 40445,
                        "name": "Cabourg",
                        "latitude": "49.29110000",
                        "longitude": "-0.11330000"
                    },
                    {
                        "id": 40457,
                        "name": "Caen",
                        "latitude": "49.18585000",
                        "longitude": "-0.35912000"
                    },
                    {
                        "id": 40461,
                        "name": "Cagny",
                        "latitude": "49.14580000",
                        "longitude": "-0.25630000"
                    },
                    {
                        "id": 40462,
                        "name": "Cahagnes",
                        "latitude": "49.06631000",
                        "longitude": "-0.76869000"
                    },
                    {
                        "id": 40466,
                        "name": "Cairon",
                        "latitude": "49.24017000",
                        "longitude": "-0.45046000"
                    },
                    {
                        "id": 40478,
                        "name": "Calvados",
                        "latitude": "49.09011000",
                        "longitude": "-0.30608000"
                    },
                    {
                        "id": 40485,
                        "name": "Cambes-en-Plaine",
                        "latitude": "49.23161000",
                        "longitude": "-0.38540000"
                    },
                    {
                        "id": 40490,
                        "name": "Cambremer",
                        "latitude": "49.15192000",
                        "longitude": "0.04760000"
                    },
                    {
                        "id": 40515,
                        "name": "Canon",
                        "latitude": "49.07380000",
                        "longitude": "-0.09219000"
                    },
                    {
                        "id": 40518,
                        "name": "Canteleu",
                        "latitude": "49.44065000",
                        "longitude": "1.02459000"
                    },
                    {
                        "id": 40522,
                        "name": "Cany-Barville",
                        "latitude": "49.78885000",
                        "longitude": "0.63704000"
                    },
                    {
                        "id": 40541,
                        "name": "Carentan",
                        "latitude": "49.30312000",
                        "longitude": "-1.24806000"
                    },
                    {
                        "id": 40556,
                        "name": "Carpiquet",
                        "latitude": "49.18522000",
                        "longitude": "-0.44623000"
                    },
                    {
                        "id": 40602,
                        "name": "Caudebec-en-Caux",
                        "latitude": "49.52577000",
                        "longitude": "0.72561000"
                    },
                    {
                        "id": 40603,
                        "name": "Caudebec-lès-Elbeuf",
                        "latitude": "49.28082000",
                        "longitude": "1.02195000"
                    },
                    {
                        "id": 40607,
                        "name": "Caumont",
                        "latitude": "49.36642000",
                        "longitude": "0.89591000"
                    },
                    {
                        "id": 40608,
                        "name": "Caumont-l'Éventé",
                        "latitude": "49.09017000",
                        "longitude": "-0.80501000"
                    },
                    {
                        "id": 40615,
                        "name": "Cauville-sur-Mer",
                        "latitude": "49.60000000",
                        "longitude": "0.13333000"
                    },
                    {
                        "id": 40631,
                        "name": "Ceaucé",
                        "latitude": "48.49436000",
                        "longitude": "-0.62526000"
                    },
                    {
                        "id": 41395,
                        "name": "Cérences",
                        "latitude": "48.91667000",
                        "longitude": "-1.43470000"
                    },
                    {
                        "id": 40648,
                        "name": "Cerisy-la-Salle",
                        "latitude": "49.02622000",
                        "longitude": "-1.28283000"
                    },
                    {
                        "id": 40664,
                        "name": "Ceton",
                        "latitude": "48.22631000",
                        "longitude": "0.74968000"
                    },
                    {
                        "id": 40751,
                        "name": "Champsecret",
                        "latitude": "48.60925000",
                        "longitude": "-0.55058000"
                    },
                    {
                        "id": 40779,
                        "name": "Chanu",
                        "latitude": "48.72914000",
                        "longitude": "-0.67603000"
                    },
                    {
                        "id": 40801,
                        "name": "Charleval",
                        "latitude": "49.37290000",
                        "longitude": "1.38369000"
                    },
                    {
                        "id": 40881,
                        "name": "Cherbourg-Octeville",
                        "latitude": "49.63984000",
                        "longitude": "-1.61636000"
                    },
                    {
                        "id": 40890,
                        "name": "Cheux",
                        "latitude": "49.16611000",
                        "longitude": "-0.52544000"
                    },
                    {
                        "id": 41045,
                        "name": "Claville",
                        "latitude": "49.04844000",
                        "longitude": "1.01954000"
                    },
                    {
                        "id": 41066,
                        "name": "Clécy",
                        "latitude": "48.91718000",
                        "longitude": "-0.48041000"
                    },
                    {
                        "id": 41071,
                        "name": "Cléon",
                        "latitude": "49.31235000",
                        "longitude": "1.02950000"
                    },
                    {
                        "id": 41065,
                        "name": "Clères",
                        "latitude": "49.60000000",
                        "longitude": "1.11667000"
                    },
                    {
                        "id": 41054,
                        "name": "Clinchamps-sur-Orne",
                        "latitude": "49.07857000",
                        "longitude": "-0.40156000"
                    },
                    {
                        "id": 41090,
                        "name": "Colleville-Montgomery",
                        "latitude": "49.27528000",
                        "longitude": "-0.30052000"
                    },
                    {
                        "id": 41099,
                        "name": "Colombelles",
                        "latitude": "49.20490000",
                        "longitude": "-0.29571000"
                    },
                    {
                        "id": 41128,
                        "name": "Conches-en-Ouche",
                        "latitude": "48.95768000",
                        "longitude": "0.94052000"
                    },
                    {
                        "id": 41136,
                        "name": "Condé-sur-Huisne",
                        "latitude": "48.38103000",
                        "longitude": "0.85093000"
                    },
                    {
                        "id": 41137,
                        "name": "Condé-sur-Noireau",
                        "latitude": "48.84881000",
                        "longitude": "-0.55214000"
                    },
                    {
                        "id": 41138,
                        "name": "Condé-sur-Sarthe",
                        "latitude": "48.43197000",
                        "longitude": "0.03398000"
                    },
                    {
                        "id": 41140,
                        "name": "Condé-sur-Vire",
                        "latitude": "49.05000000",
                        "longitude": "-1.03333000"
                    },
                    {
                        "id": 41179,
                        "name": "Cormeilles",
                        "latitude": "49.24803000",
                        "longitude": "0.37654000"
                    },
                    {
                        "id": 41181,
                        "name": "Cormelles-le-Royal",
                        "latitude": "49.15398000",
                        "longitude": "-0.33062000"
                    },
                    {
                        "id": 41191,
                        "name": "Corneville-sur-Risle",
                        "latitude": "49.34128000",
                        "longitude": "0.58628000"
                    },
                    {
                        "id": 41245,
                        "name": "Courcelles-sur-Seine",
                        "latitude": "49.18285000",
                        "longitude": "1.36008000"
                    },
                    {
                        "id": 41266,
                        "name": "Courseulles-sur-Mer",
                        "latitude": "49.33027000",
                        "longitude": "-0.45612000"
                    },
                    {
                        "id": 41267,
                        "name": "Courteilles",
                        "latitude": "48.77495000",
                        "longitude": "-0.19942000"
                    },
                    {
                        "id": 41278,
                        "name": "Coutances",
                        "latitude": "49.04541000",
                        "longitude": "-1.44518000"
                    },
                    {
                        "id": 41279,
                        "name": "Couterne",
                        "latitude": "48.51318000",
                        "longitude": "-0.41538000"
                    },
                    {
                        "id": 41340,
                        "name": "Créances",
                        "latitude": "49.19873000",
                        "longitude": "-1.56938000"
                    },
                    {
                        "id": 41308,
                        "name": "Cresserons",
                        "latitude": "49.28701000",
                        "longitude": "-0.35569000"
                    },
                    {
                        "id": 41310,
                        "name": "Creully",
                        "latitude": "49.28478000",
                        "longitude": "-0.53976000"
                    },
                    {
                        "id": 41317,
                        "name": "Criel-sur-Mer",
                        "latitude": "50.01508000",
                        "longitude": "1.31459000"
                    },
                    {
                        "id": 41318,
                        "name": "Criquebeuf-sur-Seine",
                        "latitude": "49.30563000",
                        "longitude": "1.09964000"
                    },
                    {
                        "id": 41319,
                        "name": "Criquetot-l’Esneval",
                        "latitude": "49.64555000",
                        "longitude": "0.26571000"
                    },
                    {
                        "id": 41329,
                        "name": "Croth",
                        "latitude": "48.84557000",
                        "longitude": "1.37861000"
                    },
                    {
                        "id": 41385,
                        "name": "Cuverville",
                        "latitude": "49.18998000",
                        "longitude": "-0.26474000"
                    },
                    {
                        "id": 41413,
                        "name": "Damigny",
                        "latitude": "48.45000000",
                        "longitude": "0.06667000"
                    },
                    {
                        "id": 41425,
                        "name": "Damville",
                        "latitude": "48.86930000",
                        "longitude": "1.07458000"
                    },
                    {
                        "id": 41436,
                        "name": "Darnétal",
                        "latitude": "49.44533000",
                        "longitude": "1.15144000"
                    },
                    {
                        "id": 41444,
                        "name": "Deauville",
                        "latitude": "49.35700000",
                        "longitude": "0.06995000"
                    },
                    {
                        "id": 41601,
                        "name": "Démouville",
                        "latitude": "49.18001000",
                        "longitude": "-0.26947000"
                    },
                    {
                        "id": 41617,
                        "name": "Département de l'Eure",
                        "latitude": "49.16667000",
                        "longitude": "1.00000000"
                    },
                    {
                        "id": 41622,
                        "name": "Département de l'Orne",
                        "latitude": "48.66667000",
                        "longitude": "0.08333000"
                    },
                    {
                        "id": 41650,
                        "name": "Déville-lès-Rouen",
                        "latitude": "49.46942000",
                        "longitude": "1.05214000"
                    },
                    {
                        "id": 41469,
                        "name": "Dieppe",
                        "latitude": "49.92160000",
                        "longitude": "1.07772000"
                    },
                    {
                        "id": 41480,
                        "name": "Digosville",
                        "latitude": "49.63104000",
                        "longitude": "-1.52627000"
                    },
                    {
                        "id": 41495,
                        "name": "Dives-sur-Mer",
                        "latitude": "49.28176000",
                        "longitude": "-0.10125000"
                    },
                    {
                        "id": 41516,
                        "name": "Domfront",
                        "latitude": "48.59208000",
                        "longitude": "-0.64588000"
                    },
                    {
                        "id": 41534,
                        "name": "Donville-les-Bains",
                        "latitude": "48.84608000",
                        "longitude": "-1.58315000"
                    },
                    {
                        "id": 41550,
                        "name": "Doudeville",
                        "latitude": "49.72268000",
                        "longitude": "0.78479000"
                    },
                    {
                        "id": 41559,
                        "name": "Douvres-la-Délivrande",
                        "latitude": "49.29472000",
                        "longitude": "-0.38039000"
                    },
                    {
                        "id": 41564,
                        "name": "Dozulé",
                        "latitude": "49.23132000",
                        "longitude": "-0.04454000"
                    },
                    {
                        "id": 41584,
                        "name": "Ducey",
                        "latitude": "48.61843000",
                        "longitude": "-1.29052000"
                    },
                    {
                        "id": 41585,
                        "name": "Duclair",
                        "latitude": "49.48385000",
                        "longitude": "0.87617000"
                    },
                    {
                        "id": 48046,
                        "name": "Écouché",
                        "latitude": "48.71751000",
                        "longitude": "-0.12409000"
                    },
                    {
                        "id": 48051,
                        "name": "Écrainville",
                        "latitude": "49.64943000",
                        "longitude": "0.32488000"
                    },
                    {
                        "id": 41662,
                        "name": "Elbeuf",
                        "latitude": "49.28669000",
                        "longitude": "1.00288000"
                    },
                    {
                        "id": 41685,
                        "name": "Envermeu",
                        "latitude": "49.89560000",
                        "longitude": "1.26493000"
                    },
                    {
                        "id": 48070,
                        "name": "Épaignes",
                        "latitude": "49.27945000",
                        "longitude": "0.43980000"
                    },
                    {
                        "id": 48083,
                        "name": "Épouville",
                        "latitude": "49.56349000",
                        "longitude": "0.22373000"
                    },
                    {
                        "id": 48084,
                        "name": "Épron",
                        "latitude": "49.22174000",
                        "longitude": "-0.37085000"
                    },
                    {
                        "id": 48086,
                        "name": "Équemauville",
                        "latitude": "49.39406000",
                        "longitude": "0.20760000"
                    },
                    {
                        "id": 48087,
                        "name": "Équeurdreville-Hainneville",
                        "latitude": "49.64868000",
                        "longitude": "-1.65306000"
                    },
                    {
                        "id": 41714,
                        "name": "Eslettes",
                        "latitude": "49.54820000",
                        "longitude": "1.05515000"
                    },
                    {
                        "id": 48093,
                        "name": "Étainhus",
                        "latitude": "49.56648000",
                        "longitude": "0.31285000"
                    },
                    {
                        "id": 48102,
                        "name": "Éterville",
                        "latitude": "49.14423000",
                        "longitude": "-0.42512000"
                    },
                    {
                        "id": 48114,
                        "name": "Étrépagny",
                        "latitude": "49.30623000",
                        "longitude": "1.61139000"
                    },
                    {
                        "id": 48110,
                        "name": "Étretat",
                        "latitude": "49.70669000",
                        "longitude": "0.20523000"
                    },
                    {
                        "id": 41742,
                        "name": "Eu",
                        "latitude": "50.04606000",
                        "longitude": "1.42079000"
                    },
                    {
                        "id": 48122,
                        "name": "Évrecy",
                        "latitude": "49.09904000",
                        "longitude": "-0.50421000"
                    },
                    {
                        "id": 48123,
                        "name": "Évreux",
                        "latitude": "49.02414000",
                        "longitude": "1.15082000"
                    },
                    {
                        "id": 48127,
                        "name": "Ézy-sur-Eure",
                        "latitude": "48.86667000",
                        "longitude": "1.41667000"
                    },
                    {
                        "id": 41765,
                        "name": "Falaise",
                        "latitude": "48.89217000",
                        "longitude": "-0.19527000"
                    },
                    {
                        "id": 41781,
                        "name": "Fauville-en-Caux",
                        "latitude": "49.65257000",
                        "longitude": "0.59197000"
                    },
                    {
                        "id": 41999,
                        "name": "Fécamp",
                        "latitude": "49.75787000",
                        "longitude": "0.37457000"
                    },
                    {
                        "id": 41800,
                        "name": "Fermanville",
                        "latitude": "49.68673000",
                        "longitude": "-1.46284000"
                    },
                    {
                        "id": 41828,
                        "name": "Flamanville",
                        "latitude": "49.53274000",
                        "longitude": "-1.86560000"
                    },
                    {
                        "id": 41836,
                        "name": "Flers",
                        "latitude": "48.73722000",
                        "longitude": "-0.57466000"
                    },
                    {
                        "id": 41850,
                        "name": "Fleury-sur-Andelle",
                        "latitude": "49.36176000",
                        "longitude": "1.35599000"
                    },
                    {
                        "id": 41851,
                        "name": "Fleury-sur-Orne",
                        "latitude": "49.14851000",
                        "longitude": "-0.37508000"
                    },
                    {
                        "id": 41886,
                        "name": "Fontaine-Étoupefour",
                        "latitude": "49.14600000",
                        "longitude": "-0.45522000"
                    },
                    {
                        "id": 41880,
                        "name": "Fontaine-la-Mallet",
                        "latitude": "49.53600000",
                        "longitude": "0.14625000"
                    },
                    {
                        "id": 41881,
                        "name": "Fontaine-le-Bourg",
                        "latitude": "49.56451000",
                        "longitude": "1.16391000"
                    },
                    {
                        "id": 41883,
                        "name": "Fontaine-le-Dun",
                        "latitude": "49.81182000",
                        "longitude": "0.85095000"
                    },
                    {
                        "id": 41894,
                        "name": "Fontenay",
                        "latitude": "49.55993000",
                        "longitude": "0.18391000"
                    },
                    {
                        "id": 41900,
                        "name": "Fontenay-le-Marmion",
                        "latitude": "49.09346000",
                        "longitude": "-0.35294000"
                    },
                    {
                        "id": 41913,
                        "name": "Forges-les-Eaux",
                        "latitude": "49.61391000",
                        "longitude": "1.54449000"
                    },
                    {
                        "id": 41921,
                        "name": "Foucarmont",
                        "latitude": "49.84682000",
                        "longitude": "1.56899000"
                    },
                    {
                        "id": 41948,
                        "name": "Francheville",
                        "latitude": "48.78647000",
                        "longitude": "0.84962000"
                    },
                    {
                        "id": 42010,
                        "name": "Gacé",
                        "latitude": "48.79344000",
                        "longitude": "0.29624000"
                    },
                    {
                        "id": 42017,
                        "name": "Gaillefontaine",
                        "latitude": "49.65371000",
                        "longitude": "1.61547000"
                    },
                    {
                        "id": 42018,
                        "name": "Gaillon",
                        "latitude": "49.16104000",
                        "longitude": "1.34016000"
                    },
                    {
                        "id": 42019,
                        "name": "Gainneville",
                        "latitude": "49.51845000",
                        "longitude": "0.26164000"
                    },
                    {
                        "id": 42040,
                        "name": "Garennes-sur-Eure",
                        "latitude": "48.91116000",
                        "longitude": "1.43836000"
                    },
                    {
                        "id": 42049,
                        "name": "Gasny",
                        "latitude": "49.09184000",
                        "longitude": "1.60336000"
                    },
                    {
                        "id": 42055,
                        "name": "Gavray",
                        "latitude": "48.91108000",
                        "longitude": "-1.35059000"
                    },
                    {
                        "id": 42086,
                        "name": "Giberville",
                        "latitude": "49.18158000",
                        "longitude": "-0.28386000"
                    },
                    {
                        "id": 42105,
                        "name": "Gisors",
                        "latitude": "49.28178000",
                        "longitude": "1.78010000"
                    },
                    {
                        "id": 42115,
                        "name": "Goderville",
                        "latitude": "49.64566000",
                        "longitude": "0.36593000"
                    },
                    {
                        "id": 42132,
                        "name": "Gonneville-la-Mallet",
                        "latitude": "49.63950000",
                        "longitude": "0.22245000"
                    },
                    {
                        "id": 42152,
                        "name": "Gournay-en-Bray",
                        "latitude": "49.48285000",
                        "longitude": "1.72471000"
                    },
                    {
                        "id": 42157,
                        "name": "Gouville-sur-Mer",
                        "latitude": "49.09611000",
                        "longitude": "-1.57908000"
                    },
                    {
                        "id": 42166,
                        "name": "Grainville-la-Teinturière",
                        "latitude": "49.74773000",
                        "longitude": "0.64048000"
                    },
                    {
                        "id": 42167,
                        "name": "Grainville-sur-Odon",
                        "latitude": "49.13936000",
                        "longitude": "-0.53046000"
                    },
                    {
                        "id": 42172,
                        "name": "Grand-Couronne",
                        "latitude": "49.35563000",
                        "longitude": "1.00647000"
                    },
                    {
                        "id": 42175,
                        "name": "Grandcamp-Maisy",
                        "latitude": "49.38333000",
                        "longitude": "-1.03333000"
                    },
                    {
                        "id": 42185,
                        "name": "Granville",
                        "latitude": "48.83792000",
                        "longitude": "-1.59714000"
                    },
                    {
                        "id": 42191,
                        "name": "Gravigny",
                        "latitude": "49.05310000",
                        "longitude": "1.16962000"
                    },
                    {
                        "id": 42228,
                        "name": "Gruchet-le-Valasse",
                        "latitude": "49.55466000",
                        "longitude": "0.48684000"
                    },
                    {
                        "id": 42251,
                        "name": "Guichainville",
                        "latitude": "49.00139000",
                        "longitude": "1.19305000"
                    },
                    {
                        "id": 42320,
                        "name": "Hambye",
                        "latitude": "48.94798000",
                        "longitude": "-1.26417000"
                    },
                    {
                        "id": 42328,
                        "name": "Harfleur",
                        "latitude": "49.50660000",
                        "longitude": "0.19827000"
                    },
                    {
                        "id": 42355,
                        "name": "Hautot-sur-Mer",
                        "latitude": "49.89789000",
                        "longitude": "1.02884000"
                    },
                    {
                        "id": 42357,
                        "name": "Hauville",
                        "latitude": "49.39645000",
                        "longitude": "0.77232000"
                    },
                    {
                        "id": 42455,
                        "name": "Hénouville",
                        "latitude": "49.47890000",
                        "longitude": "0.96367000"
                    },
                    {
                        "id": 42378,
                        "name": "Hermanville-sur-Mer",
                        "latitude": "49.28464000",
                        "longitude": "-0.31544000"
                    },
                    {
                        "id": 42461,
                        "name": "Hérouville-Saint-Clair",
                        "latitude": "49.21088000",
                        "longitude": "-0.30653000"
                    },
                    {
                        "id": 42462,
                        "name": "Hérouvillette",
                        "latitude": "49.22130000",
                        "longitude": "-0.24348000"
                    },
                    {
                        "id": 42390,
                        "name": "Heudreville-sur-Eure",
                        "latitude": "49.14089000",
                        "longitude": "1.18813000"
                    },
                    {
                        "id": 42417,
                        "name": "Honfleur",
                        "latitude": "49.41985000",
                        "longitude": "0.23294000"
                    },
                    {
                        "id": 42427,
                        "name": "Houlbec-Cocherel",
                        "latitude": "49.07350000",
                        "longitude": "1.36563000"
                    },
                    {
                        "id": 42428,
                        "name": "Houlgate",
                        "latitude": "49.29900000",
                        "longitude": "-0.08153000"
                    },
                    {
                        "id": 42431,
                        "name": "Houppeville",
                        "latitude": "49.51259000",
                        "longitude": "1.07962000"
                    },
                    {
                        "id": 42472,
                        "name": "Ifs",
                        "latitude": "49.14000000",
                        "longitude": "-0.34899000"
                    },
                    {
                        "id": 42476,
                        "name": "Igoville",
                        "latitude": "49.31990000",
                        "longitude": "1.14832000"
                    },
                    {
                        "id": 42485,
                        "name": "Incheville",
                        "latitude": "50.01239000",
                        "longitude": "1.49438000"
                    },
                    {
                        "id": 42499,
                        "name": "Isigny-le-Buat",
                        "latitude": "48.61705000",
                        "longitude": "-1.16993000"
                    },
                    {
                        "id": 42500,
                        "name": "Isigny-sur-Mer",
                        "latitude": "49.31604000",
                        "longitude": "-1.10384000"
                    },
                    {
                        "id": 42502,
                        "name": "Isneauville",
                        "latitude": "49.49832000",
                        "longitude": "1.15431000"
                    },
                    {
                        "id": 42516,
                        "name": "Ivry-la-Bataille",
                        "latitude": "48.88333000",
                        "longitude": "1.45948000"
                    },
                    {
                        "id": 42589,
                        "name": "Jullouville",
                        "latitude": "48.77576000",
                        "longitude": "-1.56366000"
                    },
                    {
                        "id": 42592,
                        "name": "Jumièges",
                        "latitude": "49.43324000",
                        "longitude": "0.81918000"
                    },
                    {
                        "id": 42599,
                        "name": "Juvigny-sous-Andaine",
                        "latitude": "48.55194000",
                        "longitude": "-0.50878000"
                    },
                    {
                        "id": 42648,
                        "name": "La Bonneville-sur-Iton",
                        "latitude": "49.00000000",
                        "longitude": "1.03333000"
                    },
                    {
                        "id": 42674,
                        "name": "La Cerlangue",
                        "latitude": "49.50592000",
                        "longitude": "0.41332000"
                    },
                    {
                        "id": 42683,
                        "name": "La Chapelle-Réanville",
                        "latitude": "49.09752000",
                        "longitude": "1.38209000"
                    },
                    {
                        "id": 42720,
                        "name": "La Couture-Boussey",
                        "latitude": "48.89581000",
                        "longitude": "1.40491000"
                    },
                    {
                        "id": 42735,
                        "name": "La Ferrière-aux-Étangs",
                        "latitude": "48.66227000",
                        "longitude": "-0.51955000"
                    },
                    {
                        "id": 42740,
                        "name": "La Ferté-Macé",
                        "latitude": "48.58999000",
                        "longitude": "-0.35800000"
                    },
                    {
                        "id": 42744,
                        "name": "La Feuillie",
                        "latitude": "49.46415000",
                        "longitude": "1.51463000"
                    },
                    {
                        "id": 42768,
                        "name": "La Glacerie",
                        "latitude": "49.60517000",
                        "longitude": "-1.58185000"
                    },
                    {
                        "id": 42782,
                        "name": "La Haye-du-Puits",
                        "latitude": "49.28973000",
                        "longitude": "-1.54324000"
                    },
                    {
                        "id": 42780,
                        "name": "La Haye-Malherbe",
                        "latitude": "49.22553000",
                        "longitude": "1.06774000"
                    },
                    {
                        "id": 42781,
                        "name": "La Haye-Pesnel",
                        "latitude": "48.79561000",
                        "longitude": "-1.39655000"
                    },
                    {
                        "id": 42789,
                        "name": "La Lande-Patry",
                        "latitude": "48.76202000",
                        "longitude": "-0.59876000"
                    },
                    {
                        "id": 42798,
                        "name": "La Madeleine-de-Nonancourt",
                        "latitude": "48.77298000",
                        "longitude": "1.20253000"
                    },
                    {
                        "id": 42799,
                        "name": "La Mailleraye-sur-Seine",
                        "latitude": "49.48308000",
                        "longitude": "0.77030000"
                    },
                    {
                        "id": 42800,
                        "name": "La Meauffe",
                        "latitude": "49.17643000",
                        "longitude": "-1.11119000"
                    },
                    {
                        "id": 42844,
                        "name": "La Remuée",
                        "latitude": "49.52773000",
                        "longitude": "0.40283000"
                    },
                    {
                        "id": 42848,
                        "name": "La Rivière-Saint-Sauveur",
                        "latitude": "49.40821000",
                        "longitude": "0.27030000"
                    },
                    {
                        "id": 42874,
                        "name": "La Saussaye",
                        "latitude": "49.25936000",
                        "longitude": "0.98094000"
                    },
                    {
                        "id": 42876,
                        "name": "La Selle-la-Forge",
                        "latitude": "48.73295000",
                        "longitude": "-0.54103000"
                    },
                    {
                        "id": 42907,
                        "name": "La Vaupalière",
                        "latitude": "49.48789000",
                        "longitude": "0.99630000"
                    },
                    {
                        "id": 42911,
                        "name": "La Vespière",
                        "latitude": "49.01975000",
                        "longitude": "0.41250000"
                    },
                    {
                        "id": 43031,
                        "name": "Langrune-sur-Mer",
                        "latitude": "49.32346000",
                        "longitude": "-0.37346000"
                    },
                    {
                        "id": 43042,
                        "name": "Lanquetot",
                        "latitude": "49.58527000",
                        "longitude": "0.52637000"
                    },
                    {
                        "id": 43135,
                        "name": "Le Bosc-Roger-en-Roumois",
                        "latitude": "49.28333000",
                        "longitude": "0.93333000"
                    },
                    {
                        "id": 43199,
                        "name": "Le Grand-Quevilly",
                        "latitude": "49.40076000",
                        "longitude": "1.04582000"
                    },
                    {
                        "id": 43205,
                        "name": "Le Havre",
                        "latitude": "49.49380000",
                        "longitude": "0.10767000"
                    },
                    {
                        "id": 43207,
                        "name": "Le Houlme",
                        "latitude": "49.50972000",
                        "longitude": "1.03537000"
                    },
                    {
                        "id": 43220,
                        "name": "Le Manoir",
                        "latitude": "49.31355000",
                        "longitude": "1.20455000"
                    },
                    {
                        "id": 43226,
                        "name": "Le Mesnil-Esnard",
                        "latitude": "49.41319000",
                        "longitude": "1.14521000"
                    },
                    {
                        "id": 43234,
                        "name": "Le Molay-Littry",
                        "latitude": "49.24265000",
                        "longitude": "-0.87238000"
                    },
                    {
                        "id": 43241,
                        "name": "Le Neubourg",
                        "latitude": "49.15048000",
                        "longitude": "0.91020000"
                    },
                    {
                        "id": 43254,
                        "name": "Le Petit-Quevilly",
                        "latitude": "49.41338000",
                        "longitude": "1.06155000"
                    },
                    {
                        "id": 43308,
                        "name": "Le Teilleul",
                        "latitude": "48.53758000",
                        "longitude": "-0.87304000"
                    },
                    {
                        "id": 43310,
                        "name": "Le Theil-Bocage",
                        "latitude": "48.88333000",
                        "longitude": "-0.71667000"
                    },
                    {
                        "id": 43319,
                        "name": "Le Thuit-Signol",
                        "latitude": "49.26487000",
                        "longitude": "0.93910000"
                    },
                    {
                        "id": 43323,
                        "name": "Le Trait",
                        "latitude": "49.46895000",
                        "longitude": "0.81634000"
                    },
                    {
                        "id": 43324,
                        "name": "Le Tréport",
                        "latitude": "50.05979000",
                        "longitude": "1.37583000"
                    },
                    {
                        "id": 43328,
                        "name": "Le Val-Saint-Père",
                        "latitude": "48.66177000",
                        "longitude": "-1.37653000"
                    },
                    {
                        "id": 43329,
                        "name": "Le Vaudreuil",
                        "latitude": "49.25407000",
                        "longitude": "1.20960000"
                    },
                    {
                        "id": 43690,
                        "name": "Léry",
                        "latitude": "49.28585000",
                        "longitude": "1.20768000"
                    },
                    {
                        "id": 43362,
                        "name": "Les Andelys",
                        "latitude": "49.24557000",
                        "longitude": "1.41168000"
                    },
                    {
                        "id": 43368,
                        "name": "Les Authieux-sur-le-Port-Saint-Ouen",
                        "latitude": "49.34100000",
                        "longitude": "1.13465000"
                    },
                    {
                        "id": 43392,
                        "name": "Les Grandes-Ventes",
                        "latitude": "49.78544000",
                        "longitude": "1.22921000"
                    },
                    {
                        "id": 43399,
                        "name": "Les Loges",
                        "latitude": "49.69860000",
                        "longitude": "0.28403000"
                    },
                    {
                        "id": 43400,
                        "name": "Les Loges-Marchis",
                        "latitude": "48.54132000",
                        "longitude": "-1.08754000"
                    },
                    {
                        "id": 43421,
                        "name": "Les Pieux",
                        "latitude": "49.51286000",
                        "longitude": "-1.80714000"
                    },
                    {
                        "id": 43442,
                        "name": "Lessay",
                        "latitude": "49.21703000",
                        "longitude": "-1.53089000"
                    },
                    {
                        "id": 43471,
                        "name": "Lieurey",
                        "latitude": "49.23019000",
                        "longitude": "0.49879000"
                    },
                    {
                        "id": 43486,
                        "name": "Lillebonne",
                        "latitude": "49.52030000",
                        "longitude": "0.53617000"
                    },
                    {
                        "id": 43497,
                        "name": "Limésy",
                        "latitude": "49.61271000",
                        "longitude": "0.92483000"
                    },
                    {
                        "id": 43505,
                        "name": "Lion-sur-Mer",
                        "latitude": "49.30018000",
                        "longitude": "-0.32157000"
                    },
                    {
                        "id": 43508,
                        "name": "Lisieux",
                        "latitude": "49.14660000",
                        "longitude": "0.22925000"
                    },
                    {
                        "id": 43514,
                        "name": "Livarot",
                        "latitude": "49.00500000",
                        "longitude": "0.15020000"
                    },
                    {
                        "id": 43551,
                        "name": "Londinières",
                        "latitude": "49.83187000",
                        "longitude": "1.40232000"
                    },
                    {
                        "id": 43564,
                        "name": "Longny-au-Perche",
                        "latitude": "48.52984000",
                        "longitude": "0.75239000"
                    },
                    {
                        "id": 43614,
                        "name": "Louviers",
                        "latitude": "49.21667000",
                        "longitude": "1.16667000"
                    },
                    {
                        "id": 43615,
                        "name": "Louvigny",
                        "latitude": "49.15715000",
                        "longitude": "-0.39376000"
                    },
                    {
                        "id": 43630,
                        "name": "Luc-sur-Mer",
                        "latitude": "49.31452000",
                        "longitude": "-0.35499000"
                    },
                    {
                        "id": 43654,
                        "name": "Luneray",
                        "latitude": "49.82795000",
                        "longitude": "0.91581000"
                    },
                    {
                        "id": 43727,
                        "name": "Magny-le-Désert",
                        "latitude": "48.57015000",
                        "longitude": "-0.32732000"
                    },
                    {
                        "id": 43752,
                        "name": "Malaunay",
                        "latitude": "49.52710000",
                        "longitude": "1.04292000"
                    },
                    {
                        "id": 43771,
                        "name": "Manche",
                        "latitude": "49.03822000",
                        "longitude": "-1.31865000"
                    },
                    {
                        "id": 43789,
                        "name": "Manéglise",
                        "latitude": "49.56578000",
                        "longitude": "0.25572000"
                    },
                    {
                        "id": 43778,
                        "name": "Manneville-sur-Risle",
                        "latitude": "49.35173000",
                        "longitude": "0.54526000"
                    },
                    {
                        "id": 43798,
                        "name": "Marcey-les-Grèves",
                        "latitude": "48.69673000",
                        "longitude": "-1.39156000"
                    },
                    {
                        "id": 43807,
                        "name": "Marcilly-sur-Eure",
                        "latitude": "48.82568000",
                        "longitude": "1.34741000"
                    },
                    {
                        "id": 43840,
                        "name": "Marigny",
                        "latitude": "49.09952000",
                        "longitude": "-1.24179000"
                    },
                    {
                        "id": 43869,
                        "name": "Maromme",
                        "latitude": "49.47925000",
                        "longitude": "1.02375000"
                    },
                    {
                        "id": 43918,
                        "name": "Martin-Église",
                        "latitude": "49.90174000",
                        "longitude": "1.14120000"
                    },
                    {
                        "id": 43919,
                        "name": "Martinvast",
                        "latitude": "49.59608000",
                        "longitude": "-1.66434000"
                    },
                    {
                        "id": 43939,
                        "name": "Mathieu",
                        "latitude": "49.25448000",
                        "longitude": "-0.37188000"
                    },
                    {
                        "id": 43968,
                        "name": "May-sur-Orne",
                        "latitude": "49.10107000",
                        "longitude": "-0.37471000"
                    },
                    {
                        "id": 44465,
                        "name": "Ménilles",
                        "latitude": "49.03333000",
                        "longitude": "1.36667000"
                    },
                    {
                        "id": 44002,
                        "name": "Menneval",
                        "latitude": "49.10000000",
                        "longitude": "0.61667000"
                    },
                    {
                        "id": 44025,
                        "name": "Merville-Franceville-Plage",
                        "latitude": "49.27218000",
                        "longitude": "-0.19616000"
                    },
                    {
                        "id": 44030,
                        "name": "Mesnières-en-Bray",
                        "latitude": "49.76172000",
                        "longitude": "1.38187000"
                    },
                    {
                        "id": 44033,
                        "name": "Messei",
                        "latitude": "48.71157000",
                        "longitude": "-0.53739000"
                    },
                    {
                        "id": 44136,
                        "name": "Mondeville",
                        "latitude": "49.17497000",
                        "longitude": "-0.32238000"
                    },
                    {
                        "id": 44156,
                        "name": "Mont-Saint-Aignan",
                        "latitude": "49.46307000",
                        "longitude": "1.09364000"
                    },
                    {
                        "id": 44185,
                        "name": "Montaure",
                        "latitude": "49.23417000",
                        "longitude": "1.08837000"
                    },
                    {
                        "id": 44215,
                        "name": "Montebourg",
                        "latitude": "49.48774000",
                        "longitude": "-1.38036000"
                    },
                    {
                        "id": 44256,
                        "name": "Montigny",
                        "latitude": "49.45960000",
                        "longitude": "1.00168000"
                    },
                    {
                        "id": 44265,
                        "name": "Montivilliers",
                        "latitude": "49.54518000",
                        "longitude": "0.18769000"
                    },
                    {
                        "id": 44280,
                        "name": "Montmain",
                        "latitude": "49.40996000",
                        "longitude": "1.23742000"
                    },
                    {
                        "id": 44282,
                        "name": "Montmartin-sur-Mer",
                        "latitude": "48.98861000",
                        "longitude": "-1.52530000"
                    },
                    {
                        "id": 44368,
                        "name": "Mortagne-au-Perche",
                        "latitude": "48.52018000",
                        "longitude": "0.54734000"
                    },
                    {
                        "id": 44372,
                        "name": "Mortain",
                        "latitude": "48.64782000",
                        "longitude": "-0.94055000"
                    },
                    {
                        "id": 44375,
                        "name": "Mortrée",
                        "latitude": "48.63899000",
                        "longitude": "0.07909000"
                    },
                    {
                        "id": 44385,
                        "name": "Mouen",
                        "latitude": "49.14696000",
                        "longitude": "-0.48366000"
                    },
                    {
                        "id": 44398,
                        "name": "Moult",
                        "latitude": "49.11494000",
                        "longitude": "-0.16472000"
                    },
                    {
                        "id": 44420,
                        "name": "Moyaux",
                        "latitude": "49.19511000",
                        "longitude": "0.35603000"
                    },
                    {
                        "id": 44517,
                        "name": "Nassandres",
                        "latitude": "49.12632000",
                        "longitude": "0.73597000"
                    },
                    {
                        "id": 44527,
                        "name": "Neaufles-Saint-Martin",
                        "latitude": "49.27650000",
                        "longitude": "1.72794000"
                    },
                    {
                        "id": 44542,
                        "name": "Neufchâtel-en-Bray",
                        "latitude": "49.73315000",
                        "longitude": "1.43956000"
                    },
                    {
                        "id": 44699,
                        "name": "Néville",
                        "latitude": "49.82472000",
                        "longitude": "0.70862000"
                    },
                    {
                        "id": 44623,
                        "name": "Nointot",
                        "latitude": "49.59822000",
                        "longitude": "0.47674000"
                    },
                    {
                        "id": 44638,
                        "name": "Nonancourt",
                        "latitude": "48.77086000",
                        "longitude": "1.19799000"
                    },
                    {
                        "id": 44642,
                        "name": "Normanville",
                        "latitude": "49.07868000",
                        "longitude": "1.15915000"
                    },
                    {
                        "id": 44650,
                        "name": "Notre-Dame-de-Bondeville",
                        "latitude": "49.48333000",
                        "longitude": "1.05000000"
                    },
                    {
                        "id": 44651,
                        "name": "Notre-Dame-de-Gravenchon",
                        "latitude": "49.48940000",
                        "longitude": "0.57188000"
                    },
                    {
                        "id": 44712,
                        "name": "Octeville",
                        "latitude": "49.62612000",
                        "longitude": "-1.64349000"
                    },
                    {
                        "id": 44713,
                        "name": "Octeville-sur-Mer",
                        "latitude": "49.55496000",
                        "longitude": "0.11660000"
                    },
                    {
                        "id": 44720,
                        "name": "Offranville",
                        "latitude": "49.87208000",
                        "longitude": "1.04817000"
                    },
                    {
                        "id": 44728,
                        "name": "Oissel",
                        "latitude": "49.33309000",
                        "longitude": "1.09413000"
                    },
                    {
                        "id": 44754,
                        "name": "Orbec",
                        "latitude": "49.01667000",
                        "longitude": "0.41667000"
                    },
                    {
                        "id": 44770,
                        "name": "Orival",
                        "latitude": "49.72429000",
                        "longitude": "1.20512000"
                    },
                    {
                        "id": 44805,
                        "name": "Ouistreham",
                        "latitude": "49.27566000",
                        "longitude": "-0.25910000"
                    },
                    {
                        "id": 44810,
                        "name": "Ourville-en-Caux",
                        "latitude": "49.72854000",
                        "longitude": "0.60460000"
                    },
                    {
                        "id": 44824,
                        "name": "Pacy-sur-Eure",
                        "latitude": "49.01667000",
                        "longitude": "1.38333000"
                    },
                    {
                        "id": 44853,
                        "name": "Parigny",
                        "latitude": "48.59450000",
                        "longitude": "-1.07925000"
                    },
                    {
                        "id": 44874,
                        "name": "Pavilly",
                        "latitude": "49.56703000",
                        "longitude": "0.95445000"
                    },
                    {
                        "id": 44895,
                        "name": "Percy",
                        "latitude": "48.91714000",
                        "longitude": "-1.18916000"
                    },
                    {
                        "id": 45352,
                        "name": "Périers",
                        "latitude": "49.18667000",
                        "longitude": "-1.40762000"
                    },
                    {
                        "id": 44902,
                        "name": "Perriers-sur-Andelle",
                        "latitude": "49.41487000",
                        "longitude": "1.37098000"
                    },
                    {
                        "id": 44915,
                        "name": "Petit-Couronne",
                        "latitude": "49.38333000",
                        "longitude": "1.01667000"
                    },
                    {
                        "id": 44921,
                        "name": "Petiville",
                        "latitude": "49.46078000",
                        "longitude": "0.58740000"
                    },
                    {
                        "id": 44946,
                        "name": "Picauville",
                        "latitude": "49.37810000",
                        "longitude": "-1.40048000"
                    },
                    {
                        "id": 44979,
                        "name": "Pirou",
                        "latitude": "49.18089000",
                        "longitude": "-1.57384000"
                    },
                    {
                        "id": 44983,
                        "name": "Pissy-Pôville",
                        "latitude": "49.52986000",
                        "longitude": "0.99281000"
                    },
                    {
                        "id": 45368,
                        "name": "Pîtres",
                        "latitude": "49.31667000",
                        "longitude": "1.23333000"
                    },
                    {
                        "id": 45164,
                        "name": "Pont-Audemer",
                        "latitude": "49.35000000",
                        "longitude": "0.51667000"
                    },
                    {
                        "id": 45177,
                        "name": "Pont-d'Ouilly",
                        "latitude": "48.87590000",
                        "longitude": "-0.40221000"
                    },
                    {
                        "id": 45194,
                        "name": "Pont-Écrepin",
                        "latitude": "48.76425000",
                        "longitude": "-0.24455000"
                    },
                    {
                        "id": 45167,
                        "name": "Pont-Hébert",
                        "latitude": "49.16714000",
                        "longitude": "-1.13428000"
                    },
                    {
                        "id": 45191,
                        "name": "Pont-l’Évêque",
                        "latitude": "49.28912000",
                        "longitude": "0.19161000"
                    },
                    {
                        "id": 45171,
                        "name": "Pont-Saint-Pierre",
                        "latitude": "49.33561000",
                        "longitude": "1.27601000"
                    },
                    {
                        "id": 45215,
                        "name": "Pontorson",
                        "latitude": "48.55316000",
                        "longitude": "-1.50754000"
                    },
                    {
                        "id": 45235,
                        "name": "Port-en-Bessin-Huppain",
                        "latitude": "49.34460000",
                        "longitude": "-0.75557000"
                    },
                    {
                        "id": 45238,
                        "name": "Portbail",
                        "latitude": "49.33571000",
                        "longitude": "-1.69560000"
                    },
                    {
                        "id": 45247,
                        "name": "Poses",
                        "latitude": "49.30539000",
                        "longitude": "1.24353000"
                    },
                    {
                        "id": 45248,
                        "name": "Potigny",
                        "latitude": "48.96925000",
                        "longitude": "-0.24166000"
                    },
                    {
                        "id": 45303,
                        "name": "Préaux",
                        "latitude": "49.49136000",
                        "longitude": "1.21583000"
                    },
                    {
                        "id": 45333,
                        "name": "Putanges-Pont-Écrepin",
                        "latitude": "48.76667000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 45375,
                        "name": "Querqueville",
                        "latitude": "49.66251000",
                        "longitude": "-1.69119000"
                    },
                    {
                        "id": 45381,
                        "name": "Quettehou",
                        "latitude": "49.59308000",
                        "longitude": "-1.30352000"
                    },
                    {
                        "id": 45382,
                        "name": "Quettreville-sur-Sienne",
                        "latitude": "48.96802000",
                        "longitude": "-1.46782000"
                    },
                    {
                        "id": 45387,
                        "name": "Quillebeuf-sur-Seine",
                        "latitude": "49.46934000",
                        "longitude": "0.52793000"
                    },
                    {
                        "id": 45391,
                        "name": "Quincampoix",
                        "latitude": "49.52710000",
                        "longitude": "1.18849000"
                    },
                    {
                        "id": 45415,
                        "name": "Radon",
                        "latitude": "48.50246000",
                        "longitude": "0.10278000"
                    },
                    {
                        "id": 45417,
                        "name": "Rai",
                        "latitude": "48.75000000",
                        "longitude": "0.58333000"
                    },
                    {
                        "id": 45431,
                        "name": "Ranville",
                        "latitude": "49.23071000",
                        "longitude": "-0.25560000"
                    },
                    {
                        "id": 45692,
                        "name": "Rémalard",
                        "latitude": "48.42867000",
                        "longitude": "0.77185000"
                    },
                    {
                        "id": 45696,
                        "name": "Réville",
                        "latitude": "49.61906000",
                        "longitude": "-1.25868000"
                    },
                    {
                        "id": 45557,
                        "name": "Rogerville",
                        "latitude": "49.50296000",
                        "longitude": "0.26516000"
                    },
                    {
                        "id": 45568,
                        "name": "Rolleville",
                        "latitude": "49.58232000",
                        "longitude": "0.21177000"
                    },
                    {
                        "id": 45571,
                        "name": "Romagny",
                        "latitude": "48.63931000",
                        "longitude": "-0.96605000"
                    },
                    {
                        "id": 45579,
                        "name": "Romilly-sur-Andelle",
                        "latitude": "49.33190000",
                        "longitude": "1.26127000"
                    },
                    {
                        "id": 45584,
                        "name": "Roncherolles-sur-le-Vivier",
                        "latitude": "49.46667000",
                        "longitude": "1.18333000"
                    },
                    {
                        "id": 45614,
                        "name": "Rots",
                        "latitude": "49.21235000",
                        "longitude": "-0.47319000"
                    },
                    {
                        "id": 45617,
                        "name": "Rouen",
                        "latitude": "49.44313000",
                        "longitude": "1.09932000"
                    },
                    {
                        "id": 45633,
                        "name": "Roumare",
                        "latitude": "49.51008000",
                        "longitude": "0.97422000"
                    },
                    {
                        "id": 45641,
                        "name": "Routot",
                        "latitude": "49.37800000",
                        "longitude": "0.73346000"
                    },
                    {
                        "id": 45643,
                        "name": "Rouxmesnil-Bouteilles",
                        "latitude": "49.90633000",
                        "longitude": "1.07976000"
                    },
                    {
                        "id": 45666,
                        "name": "Rugles",
                        "latitude": "48.82212000",
                        "longitude": "0.70979000"
                    },
                    {
                        "id": 45714,
                        "name": "Sahurs",
                        "latitude": "49.35863000",
                        "longitude": "0.94256000"
                    },
                    {
                        "id": 45740,
                        "name": "Saint-Amand",
                        "latitude": "49.04338000",
                        "longitude": "-0.96491000"
                    },
                    {
                        "id": 45767,
                        "name": "Saint-André-sur-Orne",
                        "latitude": "49.11741000",
                        "longitude": "-0.38227000"
                    },
                    {
                        "id": 45776,
                        "name": "Saint-Arnoult",
                        "latitude": "49.52676000",
                        "longitude": "0.67117000"
                    },
                    {
                        "id": 45789,
                        "name": "Saint-Aubin-lès-Elbeuf",
                        "latitude": "49.30360000",
                        "longitude": "1.01056000"
                    },
                    {
                        "id": 45781,
                        "name": "Saint-Aubin-Routot",
                        "latitude": "49.52341000",
                        "longitude": "0.32602000"
                    },
                    {
                        "id": 45790,
                        "name": "Saint-Aubin-sur-Gaillon",
                        "latitude": "49.14701000",
                        "longitude": "1.32914000"
                    },
                    {
                        "id": 45791,
                        "name": "Saint-Aubin-sur-Mer",
                        "latitude": "49.32787000",
                        "longitude": "-0.38696000"
                    },
                    {
                        "id": 45792,
                        "name": "Saint-Aubin-sur-Scie",
                        "latitude": "49.87162000",
                        "longitude": "1.06823000"
                    },
                    {
                        "id": 45874,
                        "name": "Saint-Contest",
                        "latitude": "49.21401000",
                        "longitude": "-0.40221000"
                    },
                    {
                        "id": 45904,
                        "name": "Saint-Denis-sur-Sarthon",
                        "latitude": "48.45320000",
                        "longitude": "-0.04720000"
                    },
                    {
                        "id": 45920,
                        "name": "Saint-Désir",
                        "latitude": "49.14056000",
                        "longitude": "0.21398000"
                    },
                    {
                        "id": 46655,
                        "name": "Saint-Étienne-du-Rouvray",
                        "latitude": "49.37794000",
                        "longitude": "1.10467000"
                    },
                    {
                        "id": 45927,
                        "name": "Saint-Eustache-la-Forêt",
                        "latitude": "49.55137000",
                        "longitude": "0.45599000"
                    },
                    {
                        "id": 45950,
                        "name": "Saint-Gatien-des-Bois",
                        "latitude": "49.35000000",
                        "longitude": "0.18333000"
                    },
                    {
                        "id": 45982,
                        "name": "Saint-Georges-des-Groseillers",
                        "latitude": "48.76993000",
                        "longitude": "-0.56768000"
                    },
                    {
                        "id": 46010,
                        "name": "Saint-Germain-du-Corbéis",
                        "latitude": "48.42215000",
                        "longitude": "0.06193000"
                    },
                    {
                        "id": 46016,
                        "name": "Saint-Germain-la-Blanche-Herbe",
                        "latitude": "49.18327000",
                        "longitude": "-0.40426000"
                    },
                    {
                        "id": 46020,
                        "name": "Saint-Germain-sur-Avre",
                        "latitude": "48.76466000",
                        "longitude": "1.26776000"
                    },
                    {
                        "id": 46001,
                        "name": "Saint-Germain-Village",
                        "latitude": "49.34908000",
                        "longitude": "0.50331000"
                    },
                    {
                        "id": 46063,
                        "name": "Saint-Hilaire-du-Harcouët",
                        "latitude": "48.57700000",
                        "longitude": "-1.09004000"
                    },
                    {
                        "id": 46052,
                        "name": "Saint-Hilaire-Petitville",
                        "latitude": "49.30250000",
                        "longitude": "-1.21995000"
                    },
                    {
                        "id": 46076,
                        "name": "Saint-Jacques-sur-Darnétal",
                        "latitude": "49.43980000",
                        "longitude": "1.20359000"
                    },
                    {
                        "id": 46078,
                        "name": "Saint-James",
                        "latitude": "48.52180000",
                        "longitude": "-1.32629000"
                    },
                    {
                        "id": 46106,
                        "name": "Saint-Jean-des-Baisants",
                        "latitude": "49.09371000",
                        "longitude": "-0.97289000"
                    },
                    {
                        "id": 46107,
                        "name": "Saint-Jean-des-Champs",
                        "latitude": "48.82800000",
                        "longitude": "-1.46487000"
                    },
                    {
                        "id": 46109,
                        "name": "Saint-Jean-du-Cardonnay",
                        "latitude": "49.50455000",
                        "longitude": "1.01140000"
                    },
                    {
                        "id": 46132,
                        "name": "Saint-Jouin-Bruneval",
                        "latitude": "49.64275000",
                        "longitude": "0.16400000"
                    },
                    {
                        "id": 46153,
                        "name": "Saint-Just",
                        "latitude": "49.10852000",
                        "longitude": "1.44101000"
                    },
                    {
                        "id": 46175,
                        "name": "Saint-Laurent-de-Brévedent",
                        "latitude": "49.52564000",
                        "longitude": "0.25458000"
                    },
                    {
                        "id": 46213,
                        "name": "Saint-Léger-du-Bourg-Denis",
                        "latitude": "49.43345000",
                        "longitude": "1.15803000"
                    },
                    {
                        "id": 46222,
                        "name": "Saint-Léonard",
                        "latitude": "49.74252000",
                        "longitude": "0.35907000"
                    },
                    {
                        "id": 46225,
                        "name": "Saint-Lô",
                        "latitude": "49.11624000",
                        "longitude": "-1.09031000"
                    },
                    {
                        "id": 46237,
                        "name": "Saint-Manvieu",
                        "latitude": "49.18067000",
                        "longitude": "-0.50211000"
                    },
                    {
                        "id": 46238,
                        "name": "Saint-Manvieu-Norrey",
                        "latitude": "49.18139000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 46241,
                        "name": "Saint-Marcel",
                        "latitude": "49.10000000",
                        "longitude": "1.45000000"
                    },
                    {
                        "id": 46269,
                        "name": "Saint-Martin-de-Boscherville",
                        "latitude": "49.44377000",
                        "longitude": "0.96271000"
                    },
                    {
                        "id": 46271,
                        "name": "Saint-Martin-de-Fontenay",
                        "latitude": "49.11523000",
                        "longitude": "-0.37391000"
                    },
                    {
                        "id": 46273,
                        "name": "Saint-Martin-de-Landelles",
                        "latitude": "48.54530000",
                        "longitude": "-1.17240000"
                    },
                    {
                        "id": 46282,
                        "name": "Saint-Martin-des-Besaces",
                        "latitude": "49.01091000",
                        "longitude": "-0.84500000"
                    },
                    {
                        "id": 46283,
                        "name": "Saint-Martin-des-Champs",
                        "latitude": "48.66841000",
                        "longitude": "-1.33393000"
                    },
                    {
                        "id": 46288,
                        "name": "Saint-Martin-du-Manoir",
                        "latitude": "49.53213000",
                        "longitude": "0.23759000"
                    },
                    {
                        "id": 46293,
                        "name": "Saint-Martin-du-Vivier",
                        "latitude": "49.46667000",
                        "longitude": "1.16667000"
                    },
                    {
                        "id": 46297,
                        "name": "Saint-Martin-en-Campagne",
                        "latitude": "49.95648000",
                        "longitude": "1.22233000"
                    },
                    {
                        "id": 46265,
                        "name": "Saint-Martin-Osmonville",
                        "latitude": "49.63873000",
                        "longitude": "1.29952000"
                    },
                    {
                        "id": 46369,
                        "name": "Saint-Nicolas-d’Aliermont",
                        "latitude": "49.87857000",
                        "longitude": "1.22486000"
                    },
                    {
                        "id": 46367,
                        "name": "Saint-Nicolas-de-la-Taille",
                        "latitude": "49.51085000",
                        "longitude": "0.47405000"
                    },
                    {
                        "id": 46379,
                        "name": "Saint-Ouen-de-Thouberville",
                        "latitude": "49.35726000",
                        "longitude": "0.88848000"
                    },
                    {
                        "id": 46381,
                        "name": "Saint-Ouen-du-Tilleul",
                        "latitude": "49.29723000",
                        "longitude": "0.94760000"
                    },
                    {
                        "id": 46420,
                        "name": "Saint-Paër",
                        "latitude": "49.51452000",
                        "longitude": "0.87935000"
                    },
                    {
                        "id": 46387,
                        "name": "Saint-Pair-sur-Mer",
                        "latitude": "48.81455000",
                        "longitude": "-1.56761000"
                    },
                    {
                        "id": 46434,
                        "name": "Saint-Pierre-de-Varengeville",
                        "latitude": "49.50240000",
                        "longitude": "0.93118000"
                    },
                    {
                        "id": 46436,
                        "name": "Saint-Pierre-des-Fleurs",
                        "latitude": "49.25000000",
                        "longitude": "0.96667000"
                    },
                    {
                        "id": 46442,
                        "name": "Saint-Pierre-du-Regard",
                        "latitude": "48.84286000",
                        "longitude": "-0.54631000"
                    },
                    {
                        "id": 46443,
                        "name": "Saint-Pierre-du-Vauvray",
                        "latitude": "49.23208000",
                        "longitude": "1.22125000"
                    },
                    {
                        "id": 46453,
                        "name": "Saint-Pierre-Église",
                        "latitude": "49.66848000",
                        "longitude": "-1.40358000"
                    },
                    {
                        "id": 46446,
                        "name": "Saint-Pierre-en-Val",
                        "latitude": "50.02168000",
                        "longitude": "1.44707000"
                    },
                    {
                        "id": 46450,
                        "name": "Saint-Pierre-lès-Elbeuf",
                        "latitude": "49.27901000",
                        "longitude": "1.04305000"
                    },
                    {
                        "id": 46452,
                        "name": "Saint-Pierre-sur-Dives",
                        "latitude": "49.01667000",
                        "longitude": "-0.03333000"
                    },
                    {
                        "id": 46454,
                        "name": "Saint-Planchers",
                        "latitude": "48.82269000",
                        "longitude": "-1.52598000"
                    },
                    {
                        "id": 46492,
                        "name": "Saint-Quentin-sur-le-Homme",
                        "latitude": "48.64751000",
                        "longitude": "-1.31806000"
                    },
                    {
                        "id": 46509,
                        "name": "Saint-Rémy",
                        "latitude": "48.94007000",
                        "longitude": "-0.50344000"
                    },
                    {
                        "id": 46500,
                        "name": "Saint-Romain-de-Colbosc",
                        "latitude": "49.53093000",
                        "longitude": "0.35719000"
                    },
                    {
                        "id": 46544,
                        "name": "Saint-Saëns",
                        "latitude": "49.67302000",
                        "longitude": "1.28525000"
                    },
                    {
                        "id": 46538,
                        "name": "Saint-Sauveur-le-Vicomte",
                        "latitude": "49.38547000",
                        "longitude": "-1.53310000"
                    },
                    {
                        "id": 46533,
                        "name": "Saint-Sauveur-Lendelin",
                        "latitude": "49.12988000",
                        "longitude": "-1.41405000"
                    },
                    {
                        "id": 46577,
                        "name": "Saint-Sébastien-de-Morsent",
                        "latitude": "49.01096000",
                        "longitude": "1.08730000"
                    },
                    {
                        "id": 46546,
                        "name": "Saint-Senier-sous-Avranches",
                        "latitude": "48.68399000",
                        "longitude": "-1.33126000"
                    },
                    {
                        "id": 46552,
                        "name": "Saint-Sever-Calvados",
                        "latitude": "48.84035000",
                        "longitude": "-1.04773000"
                    },
                    {
                        "id": 46570,
                        "name": "Saint-Sulpice-sur-Risle",
                        "latitude": "48.78063000",
                        "longitude": "0.65739000"
                    },
                    {
                        "id": 46571,
                        "name": "Saint-Sylvain",
                        "latitude": "49.05624000",
                        "longitude": "-0.21758000"
                    },
                    {
                        "id": 46595,
                        "name": "Saint-Vaast-la-Hougue",
                        "latitude": "49.58843000",
                        "longitude": "-1.26931000"
                    },
                    {
                        "id": 46596,
                        "name": "Saint-Valery-en-Caux",
                        "latitude": "49.86667000",
                        "longitude": "0.73333000"
                    },
                    {
                        "id": 46612,
                        "name": "Saint-Vigor-le-Grand",
                        "latitude": "49.28242000",
                        "longitude": "-0.68579000"
                    },
                    {
                        "id": 46625,
                        "name": "Saint-Wandrille-Rançon",
                        "latitude": "49.52658000",
                        "longitude": "0.76497000"
                    },
                    {
                        "id": 46660,
                        "name": "Sainte-Adresse",
                        "latitude": "49.50890000",
                        "longitude": "0.08446000"
                    },
                    {
                        "id": 46688,
                        "name": "Sainte-Gauburge-Sainte-Colombe",
                        "latitude": "48.71722000",
                        "longitude": "0.43126000"
                    },
                    {
                        "id": 46696,
                        "name": "Sainte-Honorine-du-Fay",
                        "latitude": "49.07775000",
                        "longitude": "-0.49295000"
                    },
                    {
                        "id": 46706,
                        "name": "Sainte-Marguerite-sur-Duclair",
                        "latitude": "49.50852000",
                        "longitude": "0.84362000"
                    },
                    {
                        "id": 46714,
                        "name": "Sainte-Marie-des-Champs",
                        "latitude": "49.62120000",
                        "longitude": "0.77904000"
                    },
                    {
                        "id": 46720,
                        "name": "Sainte-Mère-Église",
                        "latitude": "49.41000000",
                        "longitude": "-1.31726000"
                    },
                    {
                        "id": 46789,
                        "name": "Sannerville",
                        "latitude": "49.18018000",
                        "longitude": "-0.22434000"
                    },
                    {
                        "id": 46821,
                        "name": "Sartilly",
                        "latitude": "48.75239000",
                        "longitude": "-1.45678000"
                    },
                    {
                        "id": 47133,
                        "name": "Sées",
                        "latitude": "48.60403000",
                        "longitude": "0.17244000"
                    },
                    {
                        "id": 46924,
                        "name": "Seine-Maritime",
                        "latitude": "49.67278000",
                        "longitude": "1.12519000"
                    },
                    {
                        "id": 46963,
                        "name": "Serqueux",
                        "latitude": "49.63202000",
                        "longitude": "1.54005000"
                    },
                    {
                        "id": 46964,
                        "name": "Serquigny",
                        "latitude": "49.10943000",
                        "longitude": "0.71016000"
                    },
                    {
                        "id": 47027,
                        "name": "Soliers",
                        "latitude": "49.13440000",
                        "longitude": "-0.29613000"
                    },
                    {
                        "id": 47053,
                        "name": "Sottevast",
                        "latitude": "49.52374000",
                        "longitude": "-1.59169000"
                    },
                    {
                        "id": 47054,
                        "name": "Sotteville-lès-Rouen",
                        "latitude": "49.40972000",
                        "longitude": "1.09005000"
                    },
                    {
                        "id": 47083,
                        "name": "Sourdeval",
                        "latitude": "48.72312000",
                        "longitude": "-0.92223000"
                    },
                    {
                        "id": 47122,
                        "name": "Surtainville",
                        "latitude": "49.45977000",
                        "longitude": "-1.81298000"
                    },
                    {
                        "id": 47169,
                        "name": "Tancarville",
                        "latitude": "49.48550000",
                        "longitude": "0.45765000"
                    },
                    {
                        "id": 47213,
                        "name": "Tessé-la-Madeleine",
                        "latitude": "48.54963000",
                        "longitude": "-0.42521000"
                    },
                    {
                        "id": 47212,
                        "name": "Tessy-sur-Vire",
                        "latitude": "48.97381000",
                        "longitude": "-1.06087000"
                    },
                    {
                        "id": 47218,
                        "name": "Thaon",
                        "latitude": "49.25796000",
                        "longitude": "-0.45605000"
                    },
                    {
                        "id": 47227,
                        "name": "Thiberville",
                        "latitude": "49.13768000",
                        "longitude": "0.45502000"
                    },
                    {
                        "id": 47263,
                        "name": "Thury-Harcourt",
                        "latitude": "48.98434000",
                        "longitude": "-0.47519000"
                    },
                    {
                        "id": 47283,
                        "name": "Tillières-sur-Avre",
                        "latitude": "48.75585000",
                        "longitude": "1.05388000"
                    },
                    {
                        "id": 47285,
                        "name": "Tilly-sur-Seulles",
                        "latitude": "49.17598000",
                        "longitude": "-0.62605000"
                    },
                    {
                        "id": 47288,
                        "name": "Tinchebray",
                        "latitude": "48.76437000",
                        "longitude": "-0.73333000"
                    },
                    {
                        "id": 47292,
                        "name": "Tollevast",
                        "latitude": "49.57437000",
                        "longitude": "-1.62746000"
                    },
                    {
                        "id": 47303,
                        "name": "Torigni-sur-Vire",
                        "latitude": "49.03702000",
                        "longitude": "-0.98214000"
                    },
                    {
                        "id": 47418,
                        "name": "Tôtes",
                        "latitude": "49.68091000",
                        "longitude": "1.04649000"
                    },
                    {
                        "id": 47317,
                        "name": "Touques",
                        "latitude": "49.34443000",
                        "longitude": "0.10218000"
                    },
                    {
                        "id": 47321,
                        "name": "Tourlaville",
                        "latitude": "49.63829000",
                        "longitude": "-1.56639000"
                    },
                    {
                        "id": 47330,
                        "name": "Tourouvre",
                        "latitude": "48.58951000",
                        "longitude": "0.65253000"
                    },
                    {
                        "id": 47336,
                        "name": "Tourville-la-Rivière",
                        "latitude": "49.32782000",
                        "longitude": "1.10551000"
                    },
                    {
                        "id": 47337,
                        "name": "Tourville-sur-Arques",
                        "latitude": "49.85926000",
                        "longitude": "1.10238000"
                    },
                    {
                        "id": 47338,
                        "name": "Tourville-sur-Odon",
                        "latitude": "49.14154000",
                        "longitude": "-0.50128000"
                    },
                    {
                        "id": 47341,
                        "name": "Toutainville",
                        "latitude": "49.36474000",
                        "longitude": "0.46538000"
                    },
                    {
                        "id": 47378,
                        "name": "Troarn",
                        "latitude": "49.17835000",
                        "longitude": "-0.18169000"
                    },
                    {
                        "id": 47383,
                        "name": "Trouville-sur-Mer",
                        "latitude": "49.36570000",
                        "longitude": "0.08041000"
                    },
                    {
                        "id": 47387,
                        "name": "Trun",
                        "latitude": "48.84268000",
                        "longitude": "0.03268000"
                    },
                    {
                        "id": 47416,
                        "name": "Turretot",
                        "latitude": "49.60923000",
                        "longitude": "0.23422000"
                    },
                    {
                        "id": 47435,
                        "name": "Urville-Nacqueville",
                        "latitude": "49.67444000",
                        "longitude": "-1.73664000"
                    },
                    {
                        "id": 47464,
                        "name": "Val-de-Reuil",
                        "latitude": "49.27385000",
                        "longitude": "1.21021000"
                    },
                    {
                        "id": 47483,
                        "name": "Valframbert",
                        "latitude": "48.46465000",
                        "longitude": "0.10828000"
                    },
                    {
                        "id": 47490,
                        "name": "Valliquerville",
                        "latitude": "49.61385000",
                        "longitude": "0.68703000"
                    },
                    {
                        "id": 47497,
                        "name": "Valognes",
                        "latitude": "49.50881000",
                        "longitude": "-1.47047000"
                    },
                    {
                        "id": 47509,
                        "name": "Varengeville-sur-Mer",
                        "latitude": "49.90475000",
                        "longitude": "0.99479000"
                    },
                    {
                        "id": 47526,
                        "name": "Vassy",
                        "latitude": "48.85381000",
                        "longitude": "-0.67485000"
                    },
                    {
                        "id": 47532,
                        "name": "Vaudry",
                        "latitude": "48.84130000",
                        "longitude": "-0.85309000"
                    },
                    {
                        "id": 47590,
                        "name": "Ver-sur-Mer",
                        "latitude": "49.32987000",
                        "longitude": "-0.53118000"
                    },
                    {
                        "id": 47613,
                        "name": "Verneuil-sur-Avre",
                        "latitude": "48.73949000",
                        "longitude": "0.92731000"
                    },
                    {
                        "id": 47619,
                        "name": "Vernon",
                        "latitude": "49.09292000",
                        "longitude": "1.46332000"
                    },
                    {
                        "id": 47633,
                        "name": "Verson",
                        "latitude": "49.15432000",
                        "longitude": "-0.45628000"
                    },
                    {
                        "id": 47730,
                        "name": "Villedieu-les-Poêles",
                        "latitude": "48.83333000",
                        "longitude": "-1.21667000"
                    },
                    {
                        "id": 47796,
                        "name": "Villers-Bocage",
                        "latitude": "49.07960000",
                        "longitude": "-0.65412000"
                    },
                    {
                        "id": 47810,
                        "name": "Villers-Écalles",
                        "latitude": "49.54136000",
                        "longitude": "0.91942000"
                    },
                    {
                        "id": 47809,
                        "name": "Villers-sur-Mer",
                        "latitude": "49.32264000",
                        "longitude": "0.00027000"
                    },
                    {
                        "id": 47840,
                        "name": "Vimoutiers",
                        "latitude": "48.92772000",
                        "longitude": "0.19835000"
                    },
                    {
                        "id": 47857,
                        "name": "Vire",
                        "latitude": "48.83849000",
                        "longitude": "-0.88929000"
                    },
                    {
                        "id": 48000,
                        "name": "Yainville",
                        "latitude": "49.45371000",
                        "longitude": "0.82920000"
                    },
                    {
                        "id": 48024,
                        "name": "Yébleron",
                        "latitude": "49.63333000",
                        "longitude": "0.53746000"
                    },
                    {
                        "id": 48005,
                        "name": "Yerville",
                        "latitude": "49.66720000",
                        "longitude": "0.89594000"
                    },
                    {
                        "id": 48008,
                        "name": "Ymare",
                        "latitude": "49.35060000",
                        "longitude": "1.17938000"
                    },
                    {
                        "id": 48010,
                        "name": "Yport",
                        "latitude": "49.73716000",
                        "longitude": "0.31537000"
                    },
                    {
                        "id": 48016,
                        "name": "Yvetot",
                        "latitude": "49.61744000",
                        "longitude": "0.75814000"
                    }
                ]
            },
            {
                "id": 4795,
                "name": "Nouvelle-Aquitaine",
                "iso2": "NAQ",
                "latitude": "45.70871820",
                "longitude": "0.62689100",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39248,
                        "name": "Abzac",
                        "latitude": "45.01667000",
                        "longitude": "-0.13333000"
                    },
                    {
                        "id": 39258,
                        "name": "Agen",
                        "latitude": "44.19991000",
                        "longitude": "0.62664000"
                    },
                    {
                        "id": 39263,
                        "name": "Agonac",
                        "latitude": "45.29248000",
                        "longitude": "0.75025000"
                    },
                    {
                        "id": 39264,
                        "name": "Ahetze",
                        "latitude": "43.40432000",
                        "longitude": "-1.57191000"
                    },
                    {
                        "id": 39266,
                        "name": "Ahun",
                        "latitude": "46.08594000",
                        "longitude": "2.04479000"
                    },
                    {
                        "id": 39268,
                        "name": "Aiffres",
                        "latitude": "46.29449000",
                        "longitude": "-0.42101000"
                    },
                    {
                        "id": 39271,
                        "name": "Aigre",
                        "latitude": "45.89377000",
                        "longitude": "0.00963000"
                    },
                    {
                        "id": 39278,
                        "name": "Aiguillon",
                        "latitude": "44.29893000",
                        "longitude": "0.34020000"
                    },
                    {
                        "id": 39289,
                        "name": "Airvault",
                        "latitude": "46.82533000",
                        "longitude": "-0.13634000"
                    },
                    {
                        "id": 39296,
                        "name": "Aixe-sur-Vienne",
                        "latitude": "45.79862000",
                        "longitude": "1.13884000"
                    },
                    {
                        "id": 39299,
                        "name": "Ajain",
                        "latitude": "46.20635000",
                        "longitude": "1.99850000"
                    },
                    {
                        "id": 39321,
                        "name": "Allassac",
                        "latitude": "45.25840000",
                        "longitude": "1.47550000"
                    },
                    {
                        "id": 39347,
                        "name": "Ambarès-et-Lagrave",
                        "latitude": "44.91667000",
                        "longitude": "-0.48333000"
                    },
                    {
                        "id": 39348,
                        "name": "Ambazac",
                        "latitude": "45.95983000",
                        "longitude": "1.40063000"
                    },
                    {
                        "id": 39359,
                        "name": "Ambès",
                        "latitude": "45.01127000",
                        "longitude": "-0.53219000"
                    },
                    {
                        "id": 39368,
                        "name": "Amou",
                        "latitude": "43.59257000",
                        "longitude": "-0.74676000"
                    },
                    {
                        "id": 39380,
                        "name": "Andernos-les-Bains",
                        "latitude": "44.74572000",
                        "longitude": "-1.10355000"
                    },
                    {
                        "id": 39382,
                        "name": "Andilly",
                        "latitude": "46.25425000",
                        "longitude": "-1.02672000"
                    },
                    {
                        "id": 39403,
                        "name": "Anglet",
                        "latitude": "43.47664000",
                        "longitude": "-1.51346000"
                    },
                    {
                        "id": 39405,
                        "name": "Angoulême",
                        "latitude": "45.65000000",
                        "longitude": "0.15000000"
                    },
                    {
                        "id": 39404,
                        "name": "Angoulins",
                        "latitude": "46.10526000",
                        "longitude": "-1.10713000"
                    },
                    {
                        "id": 39407,
                        "name": "Angresse",
                        "latitude": "43.65809000",
                        "longitude": "-1.37191000"
                    },
                    {
                        "id": 39418,
                        "name": "Annesse-et-Beaulieu",
                        "latitude": "45.16416000",
                        "longitude": "0.57193000"
                    },
                    {
                        "id": 39434,
                        "name": "Antonne-et-Trigonant",
                        "latitude": "45.21271000",
                        "longitude": "0.83006000"
                    },
                    {
                        "id": 39437,
                        "name": "Antran",
                        "latitude": "46.85350000",
                        "longitude": "0.54317000"
                    },
                    {
                        "id": 39450,
                        "name": "Arbonne",
                        "latitude": "43.43248000",
                        "longitude": "-1.55118000"
                    },
                    {
                        "id": 39453,
                        "name": "Arbus",
                        "latitude": "43.33333000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 39457,
                        "name": "Arcachon",
                        "latitude": "44.65854000",
                        "longitude": "-1.16879000"
                    },
                    {
                        "id": 39458,
                        "name": "Arcangues",
                        "latitude": "43.43124000",
                        "longitude": "-1.52237000"
                    },
                    {
                        "id": 39463,
                        "name": "Archigny",
                        "latitude": "46.67411000",
                        "longitude": "0.65372000"
                    },
                    {
                        "id": 39468,
                        "name": "Ardin",
                        "latitude": "46.47512000",
                        "longitude": "-0.55416000"
                    },
                    {
                        "id": 39539,
                        "name": "Arès",
                        "latitude": "44.76667000",
                        "longitude": "-1.13333000"
                    },
                    {
                        "id": 39472,
                        "name": "Arette",
                        "latitude": "43.10000000",
                        "longitude": "-0.71667000"
                    },
                    {
                        "id": 39480,
                        "name": "Argentat",
                        "latitude": "45.09325000",
                        "longitude": "1.93778000"
                    },
                    {
                        "id": 39482,
                        "name": "Argenton-les-Vallées",
                        "latitude": "46.98333000",
                        "longitude": "-0.45000000"
                    },
                    {
                        "id": 39498,
                        "name": "Arnac-la-Poste",
                        "latitude": "46.26597000",
                        "longitude": "1.37375000"
                    },
                    {
                        "id": 39497,
                        "name": "Arnac-Pompadour",
                        "latitude": "45.40975000",
                        "longitude": "1.36993000"
                    },
                    {
                        "id": 39513,
                        "name": "Ars-en-Ré",
                        "latitude": "46.20555000",
                        "longitude": "-1.52720000"
                    },
                    {
                        "id": 39516,
                        "name": "Arsac",
                        "latitude": "44.99688000",
                        "longitude": "-0.68976000"
                    },
                    {
                        "id": 39523,
                        "name": "Arthez-de-Béarn",
                        "latitude": "43.46667000",
                        "longitude": "-0.60000000"
                    },
                    {
                        "id": 39527,
                        "name": "Artiguelouve",
                        "latitude": "43.31667000",
                        "longitude": "-0.46667000"
                    },
                    {
                        "id": 39528,
                        "name": "Artigues-près-Bordeaux",
                        "latitude": "44.85000000",
                        "longitude": "-0.51667000"
                    },
                    {
                        "id": 39529,
                        "name": "Artix",
                        "latitude": "43.39667000",
                        "longitude": "-0.57256000"
                    },
                    {
                        "id": 39531,
                        "name": "Arudy",
                        "latitude": "43.10640000",
                        "longitude": "-0.43333000"
                    },
                    {
                        "id": 39532,
                        "name": "Arvert",
                        "latitude": "45.74486000",
                        "longitude": "-1.12573000"
                    },
                    {
                        "id": 39533,
                        "name": "Arveyres",
                        "latitude": "44.88333000",
                        "longitude": "-0.28333000"
                    },
                    {
                        "id": 39540,
                        "name": "Ascain",
                        "latitude": "43.34521000",
                        "longitude": "-1.62073000"
                    },
                    {
                        "id": 39542,
                        "name": "Asnières-sur-Nouère",
                        "latitude": "45.71667000",
                        "longitude": "0.05000000"
                    },
                    {
                        "id": 39552,
                        "name": "Assat",
                        "latitude": "43.25000000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 39553,
                        "name": "Asson",
                        "latitude": "43.15000000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 39555,
                        "name": "Astaffort",
                        "latitude": "44.06426000",
                        "longitude": "0.65141000"
                    },
                    {
                        "id": 39565,
                        "name": "Atur",
                        "latitude": "45.14086000",
                        "longitude": "0.74701000"
                    },
                    {
                        "id": 39576,
                        "name": "Aubie-et-Espessas",
                        "latitude": "45.01869000",
                        "longitude": "-0.40297000"
                    },
                    {
                        "id": 39589,
                        "name": "Aubusson",
                        "latitude": "45.95606000",
                        "longitude": "2.16760000"
                    },
                    {
                        "id": 39596,
                        "name": "Audenge",
                        "latitude": "44.68686000",
                        "longitude": "-1.01345000"
                    },
                    {
                        "id": 39608,
                        "name": "Aulnay",
                        "latitude": "46.02082000",
                        "longitude": "-0.34778000"
                    },
                    {
                        "id": 39649,
                        "name": "Auzances",
                        "latitude": "46.02849000",
                        "longitude": "2.50042000"
                    },
                    {
                        "id": 39655,
                        "name": "Availles-Limouzine",
                        "latitude": "46.12104000",
                        "longitude": "0.65558000"
                    },
                    {
                        "id": 39658,
                        "name": "Avanton",
                        "latitude": "46.66369000",
                        "longitude": "0.30862000"
                    },
                    {
                        "id": 39662,
                        "name": "Avensan",
                        "latitude": "45.03444000",
                        "longitude": "-0.75568000"
                    },
                    {
                        "id": 39687,
                        "name": "Ayguemorte-les-Graves",
                        "latitude": "44.70988000",
                        "longitude": "-0.48060000"
                    },
                    {
                        "id": 39689,
                        "name": "Ayron",
                        "latitude": "46.66026000",
                        "longitude": "0.07545000"
                    },
                    {
                        "id": 39691,
                        "name": "Aytré",
                        "latitude": "46.13570000",
                        "longitude": "-1.11452000"
                    },
                    {
                        "id": 39692,
                        "name": "Azay-le-Brûlé",
                        "latitude": "46.40011000",
                        "longitude": "-0.24914000"
                    },
                    {
                        "id": 39719,
                        "name": "Baignes-Sainte-Radegonde",
                        "latitude": "45.38333000",
                        "longitude": "-0.23333000"
                    },
                    {
                        "id": 39757,
                        "name": "Balzac",
                        "latitude": "45.70000000",
                        "longitude": "0.11667000"
                    },
                    {
                        "id": 39769,
                        "name": "Barbaste",
                        "latitude": "44.16905000",
                        "longitude": "0.28659000"
                    },
                    {
                        "id": 39774,
                        "name": "Barbezieux-Saint-Hilaire",
                        "latitude": "45.47265000",
                        "longitude": "-0.15218000"
                    },
                    {
                        "id": 39780,
                        "name": "Bardos",
                        "latitude": "43.47392000",
                        "longitude": "-1.20347000"
                    },
                    {
                        "id": 39792,
                        "name": "Barsac",
                        "latitude": "44.60745000",
                        "longitude": "-0.31527000"
                    },
                    {
                        "id": 39801,
                        "name": "Bassens",
                        "latitude": "44.90226000",
                        "longitude": "-0.51631000"
                    },
                    {
                        "id": 39802,
                        "name": "Bassillac",
                        "latitude": "45.19305000",
                        "longitude": "0.81528000"
                    },
                    {
                        "id": 39803,
                        "name": "Bassussarry",
                        "latitude": "43.44272000",
                        "longitude": "-1.51647000"
                    },
                    {
                        "id": 39824,
                        "name": "Bayonne",
                        "latitude": "43.49257000",
                        "longitude": "-1.47624000"
                    },
                    {
                        "id": 39827,
                        "name": "Bazas",
                        "latitude": "44.43202000",
                        "longitude": "-0.21327000"
                    },
                    {
                        "id": 39853,
                        "name": "Beaulieu-sur-Dordogne",
                        "latitude": "44.97832000",
                        "longitude": "1.83834000"
                    },
                    {
                        "id": 39860,
                        "name": "Beaumont",
                        "latitude": "46.73773000",
                        "longitude": "0.42961000"
                    },
                    {
                        "id": 39866,
                        "name": "Beaumont-du-Périgord",
                        "latitude": "44.76662000",
                        "longitude": "0.76916000"
                    },
                    {
                        "id": 39877,
                        "name": "Beaupuy",
                        "latitude": "44.53549000",
                        "longitude": "0.14900000"
                    },
                    {
                        "id": 39887,
                        "name": "Beautiran",
                        "latitude": "44.70393000",
                        "longitude": "-0.45202000"
                    },
                    {
                        "id": 39894,
                        "name": "Beauvoir-sur-Niort",
                        "latitude": "46.18017000",
                        "longitude": "-0.47178000"
                    },
                    {
                        "id": 40416,
                        "name": "Bégaar",
                        "latitude": "43.82363000",
                        "longitude": "-0.84904000"
                    },
                    {
                        "id": 40410,
                        "name": "Bègles",
                        "latitude": "44.80845000",
                        "longitude": "-0.54809000"
                    },
                    {
                        "id": 39906,
                        "name": "Belin-Béliet",
                        "latitude": "44.50000000",
                        "longitude": "-0.78333000"
                    },
                    {
                        "id": 39907,
                        "name": "Bellac",
                        "latitude": "46.12209000",
                        "longitude": "1.04931000"
                    },
                    {
                        "id": 39936,
                        "name": "Belvès",
                        "latitude": "44.77632000",
                        "longitude": "1.00588000"
                    },
                    {
                        "id": 40427,
                        "name": "Bénéjacq",
                        "latitude": "43.20000000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 40423,
                        "name": "Bénesse-Maremne",
                        "latitude": "43.63678000",
                        "longitude": "-1.35773000"
                    },
                    {
                        "id": 39942,
                        "name": "Benquet",
                        "latitude": "43.82992000",
                        "longitude": "-0.50102000"
                    },
                    {
                        "id": 39945,
                        "name": "Bergerac",
                        "latitude": "44.85118000",
                        "longitude": "0.48200000"
                    },
                    {
                        "id": 39964,
                        "name": "Berson",
                        "latitude": "45.10679000",
                        "longitude": "-0.58774000"
                    },
                    {
                        "id": 40429,
                        "name": "Béruges",
                        "latitude": "46.56738000",
                        "longitude": "0.20741000"
                    },
                    {
                        "id": 39979,
                        "name": "Bessines",
                        "latitude": "46.30207000",
                        "longitude": "-0.51294000"
                    },
                    {
                        "id": 39980,
                        "name": "Bessines-sur-Gartempe",
                        "latitude": "46.10799000",
                        "longitude": "1.36865000"
                    },
                    {
                        "id": 39997,
                        "name": "Beychac-et-Caillau",
                        "latitude": "44.87781000",
                        "longitude": "-0.40219000"
                    },
                    {
                        "id": 39998,
                        "name": "Beynat",
                        "latitude": "45.12444000",
                        "longitude": "1.72323000"
                    },
                    {
                        "id": 40005,
                        "name": "Biard",
                        "latitude": "46.57889000",
                        "longitude": "0.30812000"
                    },
                    {
                        "id": 40006,
                        "name": "Biarritz",
                        "latitude": "43.48012000",
                        "longitude": "-1.55558000"
                    },
                    {
                        "id": 40008,
                        "name": "Bias",
                        "latitude": "44.41655000",
                        "longitude": "0.66977000"
                    },
                    {
                        "id": 40009,
                        "name": "Bidache",
                        "latitude": "43.48299000",
                        "longitude": "-1.14121000"
                    },
                    {
                        "id": 40010,
                        "name": "Bidart",
                        "latitude": "43.43760000",
                        "longitude": "-1.59127000"
                    },
                    {
                        "id": 40015,
                        "name": "Biganos",
                        "latitude": "44.64504000",
                        "longitude": "-0.97367000"
                    },
                    {
                        "id": 40017,
                        "name": "Bignoux",
                        "latitude": "46.60008000",
                        "longitude": "0.46932000"
                    },
                    {
                        "id": 40025,
                        "name": "Billère",
                        "latitude": "43.30000000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 40030,
                        "name": "Biscarrosse",
                        "latitude": "44.39454000",
                        "longitude": "-1.16721000"
                    },
                    {
                        "id": 40038,
                        "name": "Bizanos",
                        "latitude": "43.28333000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 40055,
                        "name": "Blanquefort",
                        "latitude": "44.91248000",
                        "longitude": "-0.63663000"
                    },
                    {
                        "id": 40062,
                        "name": "Blaye",
                        "latitude": "45.12782000",
                        "longitude": "-0.66230000"
                    },
                    {
                        "id": 40244,
                        "name": "Boé",
                        "latitude": "44.16007000",
                        "longitude": "0.62905000"
                    },
                    {
                        "id": 40079,
                        "name": "Boeil-Bezing",
                        "latitude": "43.21667000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 40093,
                        "name": "Boismé",
                        "latitude": "46.77393000",
                        "longitude": "-0.43476000"
                    },
                    {
                        "id": 40096,
                        "name": "Boisseuil",
                        "latitude": "45.76977000",
                        "longitude": "1.33333000"
                    },
                    {
                        "id": 40108,
                        "name": "Bon-Encontre",
                        "latitude": "44.18518000",
                        "longitude": "0.66759000"
                    },
                    {
                        "id": 40115,
                        "name": "Bonnac-la-Côte",
                        "latitude": "45.94212000",
                        "longitude": "1.28417000"
                    },
                    {
                        "id": 40116,
                        "name": "Bonnat",
                        "latitude": "46.33333000",
                        "longitude": "1.90000000"
                    },
                    {
                        "id": 40121,
                        "name": "Bonnes",
                        "latitude": "46.60386000",
                        "longitude": "0.59791000"
                    },
                    {
                        "id": 40122,
                        "name": "Bonneuil-Matours",
                        "latitude": "46.68155000",
                        "longitude": "0.57063000"
                    },
                    {
                        "id": 40136,
                        "name": "Bordeaux",
                        "latitude": "44.84044000",
                        "longitude": "-0.58050000"
                    },
                    {
                        "id": 40137,
                        "name": "Bordes",
                        "latitude": "43.23333000",
                        "longitude": "-0.28333000"
                    },
                    {
                        "id": 40138,
                        "name": "Bords",
                        "latitude": "45.89722000",
                        "longitude": "-0.79528000"
                    },
                    {
                        "id": 40143,
                        "name": "Bort-les-Orgues",
                        "latitude": "45.39980000",
                        "longitude": "2.49579000"
                    },
                    {
                        "id": 40145,
                        "name": "Bosdarros",
                        "latitude": "43.21667000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 40146,
                        "name": "Bosmie-l'Aiguille",
                        "latitude": "45.75000000",
                        "longitude": "1.20000000"
                    },
                    {
                        "id": 40150,
                        "name": "Boucau",
                        "latitude": "43.52770000",
                        "longitude": "-1.46556000"
                    },
                    {
                        "id": 40159,
                        "name": "Bouillé-Loretz",
                        "latitude": "47.07911000",
                        "longitude": "-0.27178000"
                    },
                    {
                        "id": 40164,
                        "name": "Boulazac",
                        "latitude": "45.11667000",
                        "longitude": "0.75000000"
                    },
                    {
                        "id": 40167,
                        "name": "Bouliac",
                        "latitude": "44.81724000",
                        "longitude": "-0.50248000"
                    },
                    {
                        "id": 40183,
                        "name": "Bourcefranc-le-Chapus",
                        "latitude": "45.85000000",
                        "longitude": "-1.15000000"
                    },
                    {
                        "id": 40184,
                        "name": "Bourg",
                        "latitude": "45.04062000",
                        "longitude": "-0.55893000"
                    },
                    {
                        "id": 40197,
                        "name": "Bourganeuf",
                        "latitude": "45.95268000",
                        "longitude": "1.75520000"
                    },
                    {
                        "id": 40201,
                        "name": "Bourgneuf",
                        "latitude": "46.16766000",
                        "longitude": "-1.02141000"
                    },
                    {
                        "id": 40216,
                        "name": "Boussac",
                        "latitude": "46.34941000",
                        "longitude": "2.21474000"
                    },
                    {
                        "id": 40223,
                        "name": "Boutiers-Saint-Trojan",
                        "latitude": "45.71667000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 40240,
                        "name": "Boyard-Ville",
                        "latitude": "45.96717000",
                        "longitude": "-1.24289000"
                    },
                    {
                        "id": 40255,
                        "name": "Branne",
                        "latitude": "44.83333000",
                        "longitude": "-0.18333000"
                    },
                    {
                        "id": 40257,
                        "name": "Brantôme",
                        "latitude": "45.36091000",
                        "longitude": "0.65398000"
                    },
                    {
                        "id": 40263,
                        "name": "Braud-et-Saint-Louis",
                        "latitude": "45.24703000",
                        "longitude": "-0.62438000"
                    },
                    {
                        "id": 40265,
                        "name": "Brax",
                        "latitude": "44.20277000",
                        "longitude": "0.55163000"
                    },
                    {
                        "id": 40278,
                        "name": "Bressuire",
                        "latitude": "46.84012000",
                        "longitude": "-0.48851000"
                    },
                    {
                        "id": 40292,
                        "name": "Breuil-Magné",
                        "latitude": "45.98478000",
                        "longitude": "-0.96000000"
                    },
                    {
                        "id": 40295,
                        "name": "Breuillet",
                        "latitude": "45.69143000",
                        "longitude": "-1.05175000"
                    },
                    {
                        "id": 40305,
                        "name": "Brie",
                        "latitude": "45.73804000",
                        "longitude": "0.24107000"
                    },
                    {
                        "id": 40314,
                        "name": "Brigueuil",
                        "latitude": "45.95337000",
                        "longitude": "0.86065000"
                    },
                    {
                        "id": 40322,
                        "name": "Brioux-sur-Boutonne",
                        "latitude": "46.14171000",
                        "longitude": "-0.22182000"
                    },
                    {
                        "id": 40324,
                        "name": "Briscous",
                        "latitude": "43.45958000",
                        "longitude": "-1.33353000"
                    },
                    {
                        "id": 40327,
                        "name": "Brive-la-Gaillarde",
                        "latitude": "45.15890000",
                        "longitude": "1.53326000"
                    },
                    {
                        "id": 40340,
                        "name": "Bruges",
                        "latitude": "44.87981000",
                        "longitude": "-0.61219000"
                    },
                    {
                        "id": 40376,
                        "name": "Bugeat",
                        "latitude": "45.59809000",
                        "longitude": "1.92727000"
                    },
                    {
                        "id": 40387,
                        "name": "Burie",
                        "latitude": "45.77273000",
                        "longitude": "-0.42289000"
                    },
                    {
                        "id": 40391,
                        "name": "Buros",
                        "latitude": "43.35000000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 40395,
                        "name": "Bussac-sur-Charente",
                        "latitude": "45.78333000",
                        "longitude": "-0.63333000"
                    },
                    {
                        "id": 40397,
                        "name": "Bussière-Dunoise",
                        "latitude": "46.25898000",
                        "longitude": "1.76216000"
                    },
                    {
                        "id": 40398,
                        "name": "Bussière-Galant",
                        "latitude": "45.62702000",
                        "longitude": "1.03640000"
                    },
                    {
                        "id": 40399,
                        "name": "Bussière-Poitevine",
                        "latitude": "46.23543000",
                        "longitude": "0.90530000"
                    },
                    {
                        "id": 40403,
                        "name": "Buxerolles",
                        "latitude": "46.61667000",
                        "longitude": "0.48333000"
                    },
                    {
                        "id": 40407,
                        "name": "Buzet-sur-Baïse",
                        "latitude": "44.25811000",
                        "longitude": "0.29809000"
                    },
                    {
                        "id": 40440,
                        "name": "Cabanac-et-Villagrains",
                        "latitude": "44.60000000",
                        "longitude": "-0.55000000"
                    },
                    {
                        "id": 40442,
                        "name": "Cabariot",
                        "latitude": "45.92645000",
                        "longitude": "-0.85741000"
                    },
                    {
                        "id": 40451,
                        "name": "Cadaujac",
                        "latitude": "44.75437000",
                        "longitude": "-0.53128000"
                    },
                    {
                        "id": 40455,
                        "name": "Cadillac",
                        "latitude": "44.63631000",
                        "longitude": "-0.31702000"
                    },
                    {
                        "id": 40484,
                        "name": "Cambes",
                        "latitude": "44.73179000",
                        "longitude": "-0.46261000"
                    },
                    {
                        "id": 40487,
                        "name": "Camblanes-et-Meynac",
                        "latitude": "44.76551000",
                        "longitude": "-0.48653000"
                    },
                    {
                        "id": 40488,
                        "name": "Cambo-les-Bains",
                        "latitude": "43.35851000",
                        "longitude": "-1.40105000"
                    },
                    {
                        "id": 40505,
                        "name": "Cancon",
                        "latitude": "44.53543000",
                        "longitude": "0.62520000"
                    },
                    {
                        "id": 40523,
                        "name": "Canéjan",
                        "latitude": "44.76667000",
                        "longitude": "-0.63333000"
                    },
                    {
                        "id": 40519,
                        "name": "Cantenac",
                        "latitude": "45.02816000",
                        "longitude": "-0.65312000"
                    },
                    {
                        "id": 40525,
                        "name": "Capbreton",
                        "latitude": "43.64216000",
                        "longitude": "-1.42816000"
                    },
                    {
                        "id": 40532,
                        "name": "Captieux",
                        "latitude": "44.29240000",
                        "longitude": "-0.26196000"
                    },
                    {
                        "id": 40536,
                        "name": "Carbon-Blanc",
                        "latitude": "44.89642000",
                        "longitude": "-0.50107000"
                    },
                    {
                        "id": 40538,
                        "name": "Carcans",
                        "latitude": "45.07869000",
                        "longitude": "-1.04429000"
                    },
                    {
                        "id": 40546,
                        "name": "Carignan-de-Bordeaux",
                        "latitude": "44.80000000",
                        "longitude": "-0.48333000"
                    },
                    {
                        "id": 40563,
                        "name": "Cars",
                        "latitude": "45.12917000",
                        "longitude": "-0.61952000"
                    },
                    {
                        "id": 40564,
                        "name": "Carsac-Aillac",
                        "latitude": "44.83333000",
                        "longitude": "1.25000000"
                    },
                    {
                        "id": 40570,
                        "name": "Casseneuil",
                        "latitude": "44.44310000",
                        "longitude": "0.62095000"
                    },
                    {
                        "id": 40576,
                        "name": "Castelculier",
                        "latitude": "44.17486000",
                        "longitude": "0.69142000"
                    },
                    {
                        "id": 40578,
                        "name": "Casteljaloux",
                        "latitude": "44.31762000",
                        "longitude": "0.08605000"
                    },
                    {
                        "id": 40581,
                        "name": "Castelmoron-sur-Lot",
                        "latitude": "44.39810000",
                        "longitude": "0.49572000"
                    },
                    {
                        "id": 40586,
                        "name": "Castelnau-de-Médoc",
                        "latitude": "45.02934000",
                        "longitude": "-0.79828000"
                    },
                    {
                        "id": 40590,
                        "name": "Castets",
                        "latitude": "43.88233000",
                        "longitude": "-1.14572000"
                    },
                    {
                        "id": 40591,
                        "name": "Castets-en-Dorthe",
                        "latitude": "44.56146000",
                        "longitude": "-0.15226000"
                    },
                    {
                        "id": 40593,
                        "name": "Castillon-la-Bataille",
                        "latitude": "44.85000000",
                        "longitude": "-0.03333000"
                    },
                    {
                        "id": 40594,
                        "name": "Castillonnès",
                        "latitude": "44.65215000",
                        "longitude": "0.59222000"
                    },
                    {
                        "id": 40596,
                        "name": "Castres-Gironde",
                        "latitude": "44.69464000",
                        "longitude": "-0.44679000"
                    },
                    {
                        "id": 40621,
                        "name": "Cavignac",
                        "latitude": "45.10083000",
                        "longitude": "-0.38976000"
                    },
                    {
                        "id": 40629,
                        "name": "Cazères-sur-l’Adour",
                        "latitude": "43.76154000",
                        "longitude": "-0.31546000"
                    },
                    {
                        "id": 40632,
                        "name": "Celle-Lévescault",
                        "latitude": "46.42406000",
                        "longitude": "0.18810000"
                    },
                    {
                        "id": 40633,
                        "name": "Celles-sur-Belle",
                        "latitude": "46.26223000",
                        "longitude": "-0.21274000"
                    },
                    {
                        "id": 41391,
                        "name": "Cénac",
                        "latitude": "44.78003000",
                        "longitude": "-0.45999000"
                    },
                    {
                        "id": 41392,
                        "name": "Cénac-et-Saint-Julien",
                        "latitude": "44.79968000",
                        "longitude": "1.20535000"
                    },
                    {
                        "id": 40638,
                        "name": "Cenon",
                        "latitude": "44.85590000",
                        "longitude": "-0.51839000"
                    },
                    {
                        "id": 40639,
                        "name": "Cenon-sur-Vienne",
                        "latitude": "46.77426000",
                        "longitude": "0.53698000"
                    },
                    {
                        "id": 40641,
                        "name": "Cercoux",
                        "latitude": "45.13333000",
                        "longitude": "-0.20000000"
                    },
                    {
                        "id": 40649,
                        "name": "Cerizay",
                        "latitude": "46.82154000",
                        "longitude": "-0.66726000"
                    },
                    {
                        "id": 41398,
                        "name": "Cérons",
                        "latitude": "44.63572000",
                        "longitude": "-0.33351000"
                    },
                    {
                        "id": 40663,
                        "name": "Cestas",
                        "latitude": "44.74345000",
                        "longitude": "-0.67905000"
                    },
                    {
                        "id": 41399,
                        "name": "Cézac",
                        "latitude": "45.09019000",
                        "longitude": "-0.41963000"
                    },
                    {
                        "id": 40668,
                        "name": "Chabanais",
                        "latitude": "45.87339000",
                        "longitude": "0.71763000"
                    },
                    {
                        "id": 40679,
                        "name": "Chaillevette",
                        "latitude": "45.73030000",
                        "longitude": "-1.05810000"
                    },
                    {
                        "id": 40685,
                        "name": "Chalais",
                        "latitude": "45.27338000",
                        "longitude": "0.03880000"
                    },
                    {
                        "id": 40935,
                        "name": "Châlus",
                        "latitude": "45.65440000",
                        "longitude": "0.98011000"
                    },
                    {
                        "id": 40705,
                        "name": "Chamberet",
                        "latitude": "45.58345000",
                        "longitude": "1.71980000"
                    },
                    {
                        "id": 40707,
                        "name": "Chambon-sur-Voueize",
                        "latitude": "46.18938000",
                        "longitude": "2.42568000"
                    },
                    {
                        "id": 40708,
                        "name": "Chamboulive",
                        "latitude": "45.43215000",
                        "longitude": "1.70441000"
                    },
                    {
                        "id": 40715,
                        "name": "Chameyrat",
                        "latitude": "45.23407000",
                        "longitude": "1.69811000"
                    },
                    {
                        "id": 40720,
                        "name": "Champagne-Mouton",
                        "latitude": "45.99078000",
                        "longitude": "0.41051000"
                    },
                    {
                        "id": 40729,
                        "name": "Champcevinel",
                        "latitude": "45.21630000",
                        "longitude": "0.72796000"
                    },
                    {
                        "id": 40731,
                        "name": "Champdeniers-Saint-Denis",
                        "latitude": "46.48333000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 40747,
                        "name": "Champniers",
                        "latitude": "45.71451000",
                        "longitude": "0.20436000"
                    },
                    {
                        "id": 40758,
                        "name": "Chancelade",
                        "latitude": "45.20049000",
                        "longitude": "0.67261000"
                    },
                    {
                        "id": 40764,
                        "name": "Chaniers",
                        "latitude": "45.71858000",
                        "longitude": "-0.55779000"
                    },
                    {
                        "id": 40787,
                        "name": "Chaptelat",
                        "latitude": "45.90962000",
                        "longitude": "1.26018000"
                    },
                    {
                        "id": 40794,
                        "name": "Charente",
                        "latitude": "45.70598000",
                        "longitude": "0.18162000"
                    },
                    {
                        "id": 40795,
                        "name": "Charente-Maritime",
                        "latitude": "45.75556000",
                        "longitude": "-0.71314000"
                    },
                    {
                        "id": 40816,
                        "name": "Charron",
                        "latitude": "46.29433000",
                        "longitude": "-1.10572000"
                    },
                    {
                        "id": 40817,
                        "name": "Charroux",
                        "latitude": "46.14410000",
                        "longitude": "0.40354000"
                    },
                    {
                        "id": 40827,
                        "name": "Chasseneuil-du-Poitou",
                        "latitude": "46.65112000",
                        "longitude": "0.37329000"
                    },
                    {
                        "id": 40828,
                        "name": "Chasseneuil-sur-Bonnieure",
                        "latitude": "45.81667000",
                        "longitude": "0.45000000"
                    },
                    {
                        "id": 40830,
                        "name": "Chassors",
                        "latitude": "45.70000000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 40950,
                        "name": "Châteaubernard",
                        "latitude": "45.66667000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 40968,
                        "name": "Châteauneuf-la-Forêt",
                        "latitude": "45.71436000",
                        "longitude": "1.60610000"
                    },
                    {
                        "id": 40971,
                        "name": "Châteauneuf-sur-Charente",
                        "latitude": "45.60000000",
                        "longitude": "-0.05000000"
                    },
                    {
                        "id": 40976,
                        "name": "Châteauponsac",
                        "latitude": "46.13536000",
                        "longitude": "1.27623000"
                    },
                    {
                        "id": 40984,
                        "name": "Châtelaillon-Plage",
                        "latitude": "46.07190000",
                        "longitude": "-1.08926000"
                    },
                    {
                        "id": 40985,
                        "name": "Châtellerault",
                        "latitude": "46.81712000",
                        "longitude": "0.54536000"
                    },
                    {
                        "id": 41006,
                        "name": "Châtillon-sur-Thouet",
                        "latitude": "46.66176000",
                        "longitude": "-0.23489000"
                    },
                    {
                        "id": 40848,
                        "name": "Chaunay",
                        "latitude": "46.20759000",
                        "longitude": "0.16084000"
                    },
                    {
                        "id": 40850,
                        "name": "Chauray",
                        "latitude": "46.35997000",
                        "longitude": "-0.37859000"
                    },
                    {
                        "id": 40853,
                        "name": "Chauvigny",
                        "latitude": "46.56747000",
                        "longitude": "0.64928000"
                    },
                    {
                        "id": 40864,
                        "name": "Chazelles",
                        "latitude": "45.64713000",
                        "longitude": "0.36748000"
                    },
                    {
                        "id": 40867,
                        "name": "Chef-Boutonne",
                        "latitude": "46.10859000",
                        "longitude": "-0.07083000"
                    },
                    {
                        "id": 41013,
                        "name": "Chérac",
                        "latitude": "45.70456000",
                        "longitude": "-0.43859000"
                    },
                    {
                        "id": 41014,
                        "name": "Chéraute",
                        "latitude": "43.23096000",
                        "longitude": "-0.86831000"
                    },
                    {
                        "id": 40883,
                        "name": "Chermignac",
                        "latitude": "45.68578000",
                        "longitude": "-0.67349000"
                    },
                    {
                        "id": 40886,
                        "name": "Cherves-Richemont",
                        "latitude": "45.74345000",
                        "longitude": "-0.35096000"
                    },
                    {
                        "id": 40887,
                        "name": "Cherveux",
                        "latitude": "46.41543000",
                        "longitude": "-0.35706000"
                    },
                    {
                        "id": 40893,
                        "name": "Chevanceaux",
                        "latitude": "45.30000000",
                        "longitude": "-0.23333000"
                    },
                    {
                        "id": 40905,
                        "name": "Chiché",
                        "latitude": "46.79643000",
                        "longitude": "-0.35560000"
                    },
                    {
                        "id": 41019,
                        "name": "Ciboure",
                        "latitude": "43.38287000",
                        "longitude": "-1.67600000"
                    },
                    {
                        "id": 41028,
                        "name": "Ciré-d’Aunis",
                        "latitude": "46.05544000",
                        "longitude": "-0.93056000"
                    },
                    {
                        "id": 41029,
                        "name": "Cissé",
                        "latitude": "46.64583000",
                        "longitude": "0.22870000"
                    },
                    {
                        "id": 41031,
                        "name": "Civray",
                        "latitude": "46.14710000",
                        "longitude": "0.29509000"
                    },
                    {
                        "id": 41035,
                        "name": "Clairac",
                        "latitude": "44.36011000",
                        "longitude": "0.37893000"
                    },
                    {
                        "id": 41072,
                        "name": "Clérac",
                        "latitude": "45.18333000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 41076,
                        "name": "Coarraze",
                        "latitude": "43.16667000",
                        "longitude": "-0.23333000"
                    },
                    {
                        "id": 41079,
                        "name": "Cognac",
                        "latitude": "45.69583000",
                        "longitude": "-0.32916000"
                    },
                    {
                        "id": 41080,
                        "name": "Cognac-la-Forêt",
                        "latitude": "45.83333000",
                        "longitude": "1.00000000"
                    },
                    {
                        "id": 41087,
                        "name": "Colayrac-Saint-Cirq",
                        "latitude": "44.22095000",
                        "longitude": "0.55061000"
                    },
                    {
                        "id": 41104,
                        "name": "Colombiers",
                        "latitude": "46.77158000",
                        "longitude": "0.42388000"
                    },
                    {
                        "id": 41111,
                        "name": "Combrand",
                        "latitude": "46.86405000",
                        "longitude": "-0.68869000"
                    },
                    {
                        "id": 41125,
                        "name": "Compreignac",
                        "latitude": "45.99162000",
                        "longitude": "1.27561000"
                    },
                    {
                        "id": 41131,
                        "name": "Condat-sur-Vienne",
                        "latitude": "45.78648000",
                        "longitude": "1.28454000"
                    },
                    {
                        "id": 41144,
                        "name": "Confolens",
                        "latitude": "46.01363000",
                        "longitude": "0.67231000"
                    },
                    {
                        "id": 41178,
                        "name": "Corme-Royal",
                        "latitude": "45.74395000",
                        "longitude": "-0.81471000"
                    },
                    {
                        "id": 41193,
                        "name": "Cornil",
                        "latitude": "45.21062000",
                        "longitude": "1.69173000"
                    },
                    {
                        "id": 41202,
                        "name": "Corrèze",
                        "latitude": "45.37244000",
                        "longitude": "1.87513000"
                    },
                    {
                        "id": 41207,
                        "name": "Cosnac",
                        "latitude": "45.13423000",
                        "longitude": "1.58544000"
                    },
                    {
                        "id": 41225,
                        "name": "Couhé",
                        "latitude": "46.29911000",
                        "longitude": "0.18174000"
                    },
                    {
                        "id": 41233,
                        "name": "Coulombiers",
                        "latitude": "46.48324000",
                        "longitude": "0.18494000"
                    },
                    {
                        "id": 41236,
                        "name": "Coulon",
                        "latitude": "46.32328000",
                        "longitude": "-0.58561000"
                    },
                    {
                        "id": 41237,
                        "name": "Coulonges-sur-l’Autize",
                        "latitude": "46.48333000",
                        "longitude": "-0.59845000"
                    },
                    {
                        "id": 41238,
                        "name": "Coulounieix-Chamiers",
                        "latitude": "45.15289000",
                        "longitude": "0.68852000"
                    },
                    {
                        "id": 41274,
                        "name": "Courçon",
                        "latitude": "46.24389000",
                        "longitude": "-0.81300000"
                    },
                    {
                        "id": 41252,
                        "name": "Courlay",
                        "latitude": "46.77941000",
                        "longitude": "-0.56607000"
                    },
                    {
                        "id": 41261,
                        "name": "Cours-de-Pile",
                        "latitude": "44.83608000",
                        "longitude": "0.54656000"
                    },
                    {
                        "id": 41264,
                        "name": "Coursac",
                        "latitude": "45.12881000",
                        "longitude": "0.63919000"
                    },
                    {
                        "id": 41277,
                        "name": "Coussac-Bonneval",
                        "latitude": "45.51199000",
                        "longitude": "1.32261000"
                    },
                    {
                        "id": 41283,
                        "name": "Coutras",
                        "latitude": "45.03333000",
                        "longitude": "-0.13333000"
                    },
                    {
                        "id": 41286,
                        "name": "Couzeix",
                        "latitude": "45.87047000",
                        "longitude": "1.23828000"
                    },
                    {
                        "id": 41290,
                        "name": "Cozes",
                        "latitude": "45.58375000",
                        "longitude": "-0.83178000"
                    },
                    {
                        "id": 41348,
                        "name": "Créon",
                        "latitude": "44.77457000",
                        "longitude": "-0.34800000"
                    },
                    {
                        "id": 41311,
                        "name": "Creuse",
                        "latitude": "46.07523000",
                        "longitude": "2.05476000"
                    },
                    {
                        "id": 41316,
                        "name": "Creysse",
                        "latitude": "44.85474000",
                        "longitude": "0.56583000"
                    },
                    {
                        "id": 41354,
                        "name": "Cublac",
                        "latitude": "45.14488000",
                        "longitude": "1.30609000"
                    },
                    {
                        "id": 41356,
                        "name": "Cubzac-les-Ponts",
                        "latitude": "44.97119000",
                        "longitude": "-0.44976000"
                    },
                    {
                        "id": 41378,
                        "name": "Cussac",
                        "latitude": "45.70666000",
                        "longitude": "0.85124000"
                    },
                    {
                        "id": 41379,
                        "name": "Cussac-Fort-Médoc",
                        "latitude": "45.11667000",
                        "longitude": "-0.73333000"
                    },
                    {
                        "id": 41408,
                        "name": "Damazan",
                        "latitude": "44.29068000",
                        "longitude": "0.27694000"
                    },
                    {
                        "id": 41426,
                        "name": "Dangé-Saint-Romain",
                        "latitude": "46.93333000",
                        "longitude": "0.60000000"
                    },
                    {
                        "id": 41443,
                        "name": "Dax",
                        "latitude": "43.71032000",
                        "longitude": "-1.05366000"
                    },
                    {
                        "id": 41451,
                        "name": "Denguin",
                        "latitude": "43.36667000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 41624,
                        "name": "Département de la Corrèze",
                        "latitude": "45.34754000",
                        "longitude": "1.87319000"
                    },
                    {
                        "id": 41636,
                        "name": "Département des Deux-Sèvres",
                        "latitude": "46.53918000",
                        "longitude": "-0.30838000"
                    },
                    {
                        "id": 41638,
                        "name": "Département des Pyrénées-Atlantiques",
                        "latitude": "43.23587000",
                        "longitude": "-0.81642000"
                    },
                    {
                        "id": 41642,
                        "name": "Département du Lot-et-Garonne",
                        "latitude": "44.33333000",
                        "longitude": "0.50000000"
                    },
                    {
                        "id": 41477,
                        "name": "Dignac",
                        "latitude": "45.55000000",
                        "longitude": "0.28333000"
                    },
                    {
                        "id": 41490,
                        "name": "Dirac",
                        "latitude": "45.60000000",
                        "longitude": "0.25000000"
                    },
                    {
                        "id": 41492,
                        "name": "Dissay",
                        "latitude": "46.70007000",
                        "longitude": "0.43311000"
                    },
                    {
                        "id": 41507,
                        "name": "Dolus-d'Oléron",
                        "latitude": "45.91667000",
                        "longitude": "-1.26667000"
                    },
                    {
                        "id": 41520,
                        "name": "Domme",
                        "latitude": "44.80218000",
                        "longitude": "1.21459000"
                    },
                    {
                        "id": 41523,
                        "name": "Dompierre-sur-Mer",
                        "latitude": "46.18817000",
                        "longitude": "-1.06351000"
                    },
                    {
                        "id": 41535,
                        "name": "Donzenac",
                        "latitude": "45.22731000",
                        "longitude": "1.52400000"
                    },
                    {
                        "id": 41539,
                        "name": "Dordogne",
                        "latitude": "45.12735000",
                        "longitude": "0.73504000"
                    },
                    {
                        "id": 41589,
                        "name": "Dun-le-Palestel",
                        "latitude": "46.30000000",
                        "longitude": "1.66667000"
                    },
                    {
                        "id": 41594,
                        "name": "Duras",
                        "latitude": "44.67618000",
                        "longitude": "0.18247000"
                    },
                    {
                        "id": 48041,
                        "name": "Échillais",
                        "latitude": "45.90072000",
                        "longitude": "-0.95211000"
                    },
                    {
                        "id": 48043,
                        "name": "Échiré",
                        "latitude": "46.38748000",
                        "longitude": "-0.41511000"
                    },
                    {
                        "id": 48050,
                        "name": "Écoyeux",
                        "latitude": "45.82231000",
                        "longitude": "-0.50539000"
                    },
                    {
                        "id": 48057,
                        "name": "Égletons",
                        "latitude": "45.40637000",
                        "longitude": "2.04518000"
                    },
                    {
                        "id": 41715,
                        "name": "Esnandes",
                        "latitude": "46.25033000",
                        "longitude": "-1.11566000"
                    },
                    {
                        "id": 41718,
                        "name": "Espelette",
                        "latitude": "43.34015000",
                        "longitude": "-1.44737000"
                    },
                    {
                        "id": 41733,
                        "name": "Estillac",
                        "latitude": "44.15766000",
                        "longitude": "0.56383000"
                    },
                    {
                        "id": 48091,
                        "name": "Étagnac",
                        "latitude": "45.89506000",
                        "longitude": "0.77897000"
                    },
                    {
                        "id": 48099,
                        "name": "Étaules",
                        "latitude": "45.73407000",
                        "longitude": "-1.09918000"
                    },
                    {
                        "id": 48100,
                        "name": "Étauliers",
                        "latitude": "45.22582000",
                        "longitude": "-0.57243000"
                    },
                    {
                        "id": 48116,
                        "name": "Évaux-les-Bains",
                        "latitude": "46.17346000",
                        "longitude": "2.48463000"
                    },
                    {
                        "id": 41747,
                        "name": "Excideuil",
                        "latitude": "45.33635000",
                        "longitude": "1.04754000"
                    },
                    {
                        "id": 41748,
                        "name": "Exideuil",
                        "latitude": "45.88639000",
                        "longitude": "0.67318000"
                    },
                    {
                        "id": 41750,
                        "name": "Exireuil",
                        "latitude": "46.43382000",
                        "longitude": "-0.19251000"
                    },
                    {
                        "id": 41754,
                        "name": "Eymet",
                        "latitude": "44.66812000",
                        "longitude": "0.39961000"
                    },
                    {
                        "id": 41755,
                        "name": "Eymoutiers",
                        "latitude": "45.73790000",
                        "longitude": "1.74189000"
                    },
                    {
                        "id": 41757,
                        "name": "Eysines",
                        "latitude": "44.88352000",
                        "longitude": "-0.64686000"
                    },
                    {
                        "id": 41758,
                        "name": "Eyvigues-et-Eybènes",
                        "latitude": "44.93333000",
                        "longitude": "1.35000000"
                    },
                    {
                        "id": 41774,
                        "name": "Fargues-Saint-Hilaire",
                        "latitude": "44.82304000",
                        "longitude": "-0.44676000"
                    },
                    {
                        "id": 41796,
                        "name": "Felletin",
                        "latitude": "45.88333000",
                        "longitude": "2.17431000"
                    },
                    {
                        "id": 41815,
                        "name": "Feytiat",
                        "latitude": "45.80905000",
                        "longitude": "1.33033000"
                    },
                    {
                        "id": 41864,
                        "name": "Fléac",
                        "latitude": "45.66667000",
                        "longitude": "0.10000000"
                    },
                    {
                        "id": 41859,
                        "name": "Floirac",
                        "latitude": "44.83238000",
                        "longitude": "-0.51411000"
                    },
                    {
                        "id": 41882,
                        "name": "Fontaine-le-Comte",
                        "latitude": "46.53217000",
                        "longitude": "0.26176000"
                    },
                    {
                        "id": 41893,
                        "name": "Fontcouverte",
                        "latitude": "45.76708000",
                        "longitude": "-0.58682000"
                    },
                    {
                        "id": 41915,
                        "name": "Fors",
                        "latitude": "46.23570000",
                        "longitude": "-0.40904000"
                    },
                    {
                        "id": 41929,
                        "name": "Foulayronnes",
                        "latitude": "44.24029000",
                        "longitude": "0.64516000"
                    },
                    {
                        "id": 41933,
                        "name": "Fouras",
                        "latitude": "45.98736000",
                        "longitude": "-1.09275000"
                    },
                    {
                        "id": 41938,
                        "name": "Fourques-sur-Garonne",
                        "latitude": "44.44798000",
                        "longitude": "0.15703000"
                    },
                    {
                        "id": 41972,
                        "name": "Fronsac",
                        "latitude": "44.91667000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 41973,
                        "name": "Frontenay-Rohan-Rohan",
                        "latitude": "46.25276000",
                        "longitude": "-0.53833000"
                    },
                    {
                        "id": 41992,
                        "name": "Fumel",
                        "latitude": "44.49862000",
                        "longitude": "0.96506000"
                    },
                    {
                        "id": 42009,
                        "name": "Gabarret",
                        "latitude": "43.98779000",
                        "longitude": "0.00978000"
                    },
                    {
                        "id": 42015,
                        "name": "Gaillan-en-Médoc",
                        "latitude": "45.32133000",
                        "longitude": "-0.95794000"
                    },
                    {
                        "id": 42020,
                        "name": "Galgon",
                        "latitude": "44.98333000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 42027,
                        "name": "Gan",
                        "latitude": "43.23333000",
                        "longitude": "-0.38333000"
                    },
                    {
                        "id": 42033,
                        "name": "Garat",
                        "latitude": "45.63333000",
                        "longitude": "0.26667000"
                    },
                    {
                        "id": 42038,
                        "name": "Gardonne",
                        "latitude": "44.83333000",
                        "longitude": "0.35000000"
                    },
                    {
                        "id": 42045,
                        "name": "Garlin",
                        "latitude": "43.55927000",
                        "longitude": "-0.27321000"
                    },
                    {
                        "id": 42054,
                        "name": "Gauriaguet",
                        "latitude": "45.03904000",
                        "longitude": "-0.39191000"
                    },
                    {
                        "id": 42060,
                        "name": "Gelos",
                        "latitude": "43.28333000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 42294,
                        "name": "Gémozac",
                        "latitude": "45.56896000",
                        "longitude": "-0.67574000"
                    },
                    {
                        "id": 42296,
                        "name": "Génissac",
                        "latitude": "44.85000000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 42069,
                        "name": "Gensac-la-Pallue",
                        "latitude": "45.65000000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 42071,
                        "name": "Ger",
                        "latitude": "43.25000000",
                        "longitude": "-0.05000000"
                    },
                    {
                        "id": 42102,
                        "name": "Gironde",
                        "latitude": "44.69306000",
                        "longitude": "-0.41400000"
                    },
                    {
                        "id": 42103,
                        "name": "Gironde-sur-Dropt",
                        "latitude": "44.58333000",
                        "longitude": "-0.08333000"
                    },
                    {
                        "id": 42124,
                        "name": "Gond-Pontouvre",
                        "latitude": "45.68333000",
                        "longitude": "0.16667000"
                    },
                    {
                        "id": 42133,
                        "name": "Gontaud-de-Nogaret",
                        "latitude": "44.45000000",
                        "longitude": "0.30000000"
                    },
                    {
                        "id": 42160,
                        "name": "Gouzon",
                        "latitude": "46.19286000",
                        "longitude": "2.23876000"
                    },
                    {
                        "id": 42164,
                        "name": "Gradignan",
                        "latitude": "44.77262000",
                        "longitude": "-0.61393000"
                    },
                    {
                        "id": 42196,
                        "name": "Grenade-sur-l’Adour",
                        "latitude": "43.77753000",
                        "longitude": "-0.42961000"
                    },
                    {
                        "id": 42209,
                        "name": "Grignols",
                        "latitude": "44.38842000",
                        "longitude": "-0.04287000"
                    },
                    {
                        "id": 42287,
                        "name": "Guéret",
                        "latitude": "46.17234000",
                        "longitude": "1.87456000"
                    },
                    {
                        "id": 42289,
                        "name": "Guéthary",
                        "latitude": "43.42285000",
                        "longitude": "-1.61073000"
                    },
                    {
                        "id": 42291,
                        "name": "Guîtres",
                        "latitude": "45.03333000",
                        "longitude": "-0.18333000"
                    },
                    {
                        "id": 42272,
                        "name": "Gujan-Mestras",
                        "latitude": "44.63333000",
                        "longitude": "-1.06667000"
                    },
                    {
                        "id": 42304,
                        "name": "Habas",
                        "latitude": "43.57180000",
                        "longitude": "-0.92976000"
                    },
                    {
                        "id": 42308,
                        "name": "Hagetmau",
                        "latitude": "43.65893000",
                        "longitude": "-0.59172000"
                    },
                    {
                        "id": 42333,
                        "name": "Hasparren",
                        "latitude": "43.38377000",
                        "longitude": "-1.30499000"
                    },
                    {
                        "id": 42347,
                        "name": "Haute-Vienne",
                        "latitude": "45.88341000",
                        "longitude": "1.21781000"
                    },
                    {
                        "id": 42348,
                        "name": "Hautefort",
                        "latitude": "45.25953000",
                        "longitude": "1.14879000"
                    },
                    {
                        "id": 42367,
                        "name": "Hendaye",
                        "latitude": "43.37172000",
                        "longitude": "-1.77382000"
                    },
                    {
                        "id": 42391,
                        "name": "Heugas",
                        "latitude": "43.64334000",
                        "longitude": "-1.08143000"
                    },
                    {
                        "id": 42394,
                        "name": "Hiersac",
                        "latitude": "45.66667000",
                        "longitude": "0.00000000"
                    },
                    {
                        "id": 42399,
                        "name": "Hinx",
                        "latitude": "43.70190000",
                        "longitude": "-0.92591000"
                    },
                    {
                        "id": 42432,
                        "name": "Hourtin",
                        "latitude": "45.18570000",
                        "longitude": "-1.05719000"
                    },
                    {
                        "id": 42470,
                        "name": "Idron",
                        "latitude": "43.28333000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 42475,
                        "name": "Igon",
                        "latitude": "43.16667000",
                        "longitude": "-0.23333000"
                    },
                    {
                        "id": 42478,
                        "name": "Illats",
                        "latitude": "44.59714000",
                        "longitude": "-0.37238000"
                    },
                    {
                        "id": 42501,
                        "name": "Isle",
                        "latitude": "45.80272000",
                        "longitude": "1.21213000"
                    },
                    {
                        "id": 42512,
                        "name": "Iteuil",
                        "latitude": "46.48808000",
                        "longitude": "0.31212000"
                    },
                    {
                        "id": 42515,
                        "name": "Itxassou",
                        "latitude": "43.32893000",
                        "longitude": "-1.40617000"
                    },
                    {
                        "id": 42521,
                        "name": "Izon",
                        "latitude": "44.92416000",
                        "longitude": "-0.36322000"
                    },
                    {
                        "id": 42533,
                        "name": "Jarnac",
                        "latitude": "45.68160000",
                        "longitude": "-0.17329000"
                    },
                    {
                        "id": 42541,
                        "name": "Jaunay-Clan",
                        "latitude": "46.68453000",
                        "longitude": "0.37128000"
                    },
                    {
                        "id": 42562,
                        "name": "Jonzac",
                        "latitude": "45.44668000",
                        "longitude": "-0.43370000"
                    },
                    {
                        "id": 42585,
                        "name": "Juillac",
                        "latitude": "45.31808000",
                        "longitude": "1.32257000"
                    },
                    {
                        "id": 42591,
                        "name": "Jumilhac-le-Grand",
                        "latitude": "45.49432000",
                        "longitude": "1.06339000"
                    },
                    {
                        "id": 42594,
                        "name": "Jurançon",
                        "latitude": "43.28830000",
                        "longitude": "-0.38694000"
                    },
                    {
                        "id": 42686,
                        "name": "La Chapelle-Saint-Laurent",
                        "latitude": "46.74643000",
                        "longitude": "-0.47643000"
                    },
                    {
                        "id": 42714,
                        "name": "La Coquille",
                        "latitude": "45.54201000",
                        "longitude": "0.97675000"
                    },
                    {
                        "id": 42715,
                        "name": "La Couarde-sur-Mer",
                        "latitude": "46.19411000",
                        "longitude": "-1.42522000"
                    },
                    {
                        "id": 42717,
                        "name": "La Couronne",
                        "latitude": "45.61128000",
                        "longitude": "0.09948000"
                    },
                    {
                        "id": 42718,
                        "name": "La Courtine",
                        "latitude": "45.70000000",
                        "longitude": "2.26667000"
                    },
                    {
                        "id": 42725,
                        "name": "La Crèche",
                        "latitude": "46.36667000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 42747,
                        "name": "La Flotte",
                        "latitude": "46.18771000",
                        "longitude": "-1.32815000"
                    },
                    {
                        "id": 42749,
                        "name": "La Force",
                        "latitude": "44.86902000",
                        "longitude": "0.37541000"
                    },
                    {
                        "id": 42752,
                        "name": "La Forêt-sur-Sèvre",
                        "latitude": "46.76905000",
                        "longitude": "-0.64964000"
                    },
                    {
                        "id": 42784,
                        "name": "La Jarne",
                        "latitude": "46.12773000",
                        "longitude": "-1.07259000"
                    },
                    {
                        "id": 42785,
                        "name": "La Jarrie",
                        "latitude": "46.12879000",
                        "longitude": "-1.00896000"
                    },
                    {
                        "id": 42790,
                        "name": "La Lande-de-Fronsac",
                        "latitude": "44.98036000",
                        "longitude": "-0.38048000"
                    },
                    {
                        "id": 42811,
                        "name": "La Mothe-Saint-Héray",
                        "latitude": "46.35934000",
                        "longitude": "-0.11236000"
                    },
                    {
                        "id": 42830,
                        "name": "La Peyratte",
                        "latitude": "46.67453000",
                        "longitude": "-0.14912000"
                    },
                    {
                        "id": 42869,
                        "name": "La Réole",
                        "latitude": "44.58201000",
                        "longitude": "-0.03691000"
                    },
                    {
                        "id": 42851,
                        "name": "La Roche-Chalais",
                        "latitude": "45.15000000",
                        "longitude": "0.01667000"
                    },
                    {
                        "id": 42854,
                        "name": "La Roche-Posay",
                        "latitude": "46.78654000",
                        "longitude": "0.81354000"
                    },
                    {
                        "id": 42860,
                        "name": "La Rochefoucauld",
                        "latitude": "45.74048000",
                        "longitude": "0.38564000"
                    },
                    {
                        "id": 42861,
                        "name": "La Rochelle",
                        "latitude": "46.16667000",
                        "longitude": "-1.15000000"
                    },
                    {
                        "id": 42875,
                        "name": "La Sauve",
                        "latitude": "44.76667000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 42879,
                        "name": "La Souterraine",
                        "latitude": "46.23714000",
                        "longitude": "1.48701000"
                    },
                    {
                        "id": 42887,
                        "name": "La Teste-de-Buch",
                        "latitude": "44.62875000",
                        "longitude": "-1.14059000"
                    },
                    {
                        "id": 42897,
                        "name": "La Tremblade",
                        "latitude": "45.76806000",
                        "longitude": "-1.14265000"
                    },
                    {
                        "id": 42915,
                        "name": "La Villedieu-du-Clain",
                        "latitude": "46.45559000",
                        "longitude": "0.36917000"
                    },
                    {
                        "id": 42930,
                        "name": "Labatut",
                        "latitude": "43.55000000",
                        "longitude": "-0.98333000"
                    },
                    {
                        "id": 42931,
                        "name": "Labenne",
                        "latitude": "43.59464000",
                        "longitude": "-1.42559000"
                    },
                    {
                        "id": 42935,
                        "name": "Labouheyre",
                        "latitude": "44.21297000",
                        "longitude": "-0.92062000"
                    },
                    {
                        "id": 42941,
                        "name": "Lacanau",
                        "latitude": "44.97779000",
                        "longitude": "-1.07621000"
                    },
                    {
                        "id": 42950,
                        "name": "Ladignac-le-Long",
                        "latitude": "45.58256000",
                        "longitude": "1.11359000"
                    },
                    {
                        "id": 42960,
                        "name": "Lagor",
                        "latitude": "43.38333000",
                        "longitude": "-0.65000000"
                    },
                    {
                        "id": 42961,
                        "name": "Lagorce",
                        "latitude": "45.06667000",
                        "longitude": "-0.13333000"
                    },
                    {
                        "id": 42962,
                        "name": "Lagord",
                        "latitude": "46.18822000",
                        "longitude": "-1.15355000"
                    },
                    {
                        "id": 42964,
                        "name": "Laguenne",
                        "latitude": "45.24218000",
                        "longitude": "1.78135000"
                    },
                    {
                        "id": 42966,
                        "name": "Lahonce",
                        "latitude": "43.48248000",
                        "longitude": "-1.39101000"
                    },
                    {
                        "id": 42975,
                        "name": "Lalinde",
                        "latitude": "44.83621000",
                        "longitude": "0.73075000"
                    },
                    {
                        "id": 42983,
                        "name": "Lamarque",
                        "latitude": "45.09536000",
                        "longitude": "-0.71892000"
                    },
                    {
                        "id": 42989,
                        "name": "Lamonzie-Saint-Martin",
                        "latitude": "44.84713000",
                        "longitude": "0.39102000"
                    },
                    {
                        "id": 42991,
                        "name": "Lamothe-Montravel",
                        "latitude": "44.85000000",
                        "longitude": "0.03333000"
                    },
                    {
                        "id": 43005,
                        "name": "Landes",
                        "latitude": "43.97543000",
                        "longitude": "-0.74241000"
                    },
                    {
                        "id": 43006,
                        "name": "Landiras",
                        "latitude": "44.56702000",
                        "longitude": "-0.41536000"
                    },
                    {
                        "id": 43026,
                        "name": "Langoiran",
                        "latitude": "44.70869000",
                        "longitude": "-0.39368000"
                    },
                    {
                        "id": 43028,
                        "name": "Langon",
                        "latitude": "44.55310000",
                        "longitude": "-0.24951000"
                    },
                    {
                        "id": 43040,
                        "name": "Lanouaille",
                        "latitude": "45.39517000",
                        "longitude": "1.13968000"
                    },
                    {
                        "id": 43049,
                        "name": "Lanton",
                        "latitude": "44.70478000",
                        "longitude": "-1.03562000"
                    },
                    {
                        "id": 43061,
                        "name": "Laplume",
                        "latitude": "44.11292000",
                        "longitude": "0.52975000"
                    },
                    {
                        "id": 43068,
                        "name": "Larche",
                        "latitude": "45.12048000",
                        "longitude": "1.41566000"
                    },
                    {
                        "id": 43076,
                        "name": "Laroque-Timbaut",
                        "latitude": "44.28238000",
                        "longitude": "0.76274000"
                    },
                    {
                        "id": 43079,
                        "name": "Larressore",
                        "latitude": "43.36792000",
                        "longitude": "-1.43976000"
                    },
                    {
                        "id": 43081,
                        "name": "Laruns",
                        "latitude": "42.98826000",
                        "longitude": "-0.42658000"
                    },
                    {
                        "id": 43082,
                        "name": "Laruscade",
                        "latitude": "45.11667000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 43086,
                        "name": "Lasseube",
                        "latitude": "43.23333000",
                        "longitude": "-0.48333000"
                    },
                    {
                        "id": 43089,
                        "name": "Lathus-Saint-Rémy",
                        "latitude": "46.33333000",
                        "longitude": "0.96667000"
                    },
                    {
                        "id": 43090,
                        "name": "Latillé",
                        "latitude": "46.61818000",
                        "longitude": "0.07630000"
                    },
                    {
                        "id": 43092,
                        "name": "Latresne",
                        "latitude": "44.78601000",
                        "longitude": "-0.48994000"
                    },
                    {
                        "id": 43111,
                        "name": "Lavardac",
                        "latitude": "44.17785000",
                        "longitude": "0.29825000"
                    },
                    {
                        "id": 43119,
                        "name": "Lavoux",
                        "latitude": "46.59566000",
                        "longitude": "0.53012000"
                    },
                    {
                        "id": 43123,
                        "name": "Layrac",
                        "latitude": "44.13449000",
                        "longitude": "0.66176000"
                    },
                    {
                        "id": 43127,
                        "name": "Le Barp",
                        "latitude": "44.60833000",
                        "longitude": "-0.76948000"
                    },
                    {
                        "id": 43132,
                        "name": "Le Bois-Plage-en-Ré",
                        "latitude": "46.18659000",
                        "longitude": "-1.39267000"
                    },
                    {
                        "id": 43141,
                        "name": "Le Bouscat",
                        "latitude": "44.86600000",
                        "longitude": "-0.59411000"
                    },
                    {
                        "id": 43148,
                        "name": "Le Bugue",
                        "latitude": "44.91847000",
                        "longitude": "0.92714000"
                    },
                    {
                        "id": 43149,
                        "name": "Le Buisson-de-Cadouin",
                        "latitude": "44.85000000",
                        "longitude": "0.91667000"
                    },
                    {
                        "id": 43180,
                        "name": "Le Dorat",
                        "latitude": "46.21514000",
                        "longitude": "1.08153000"
                    },
                    {
                        "id": 43188,
                        "name": "Le Fleix",
                        "latitude": "44.86667000",
                        "longitude": "0.25000000"
                    },
                    {
                        "id": 43195,
                        "name": "Le Grand-Bourg",
                        "latitude": "46.16018000",
                        "longitude": "1.64465000"
                    },
                    {
                        "id": 43201,
                        "name": "Le Gua",
                        "latitude": "45.72614000",
                        "longitude": "-0.94468000"
                    },
                    {
                        "id": 43204,
                        "name": "Le Haillan",
                        "latitude": "44.87225000",
                        "longitude": "-0.67965000"
                    },
                    {
                        "id": 43211,
                        "name": "Le Lardin-Saint-Lazare",
                        "latitude": "45.13333000",
                        "longitude": "1.21667000"
                    },
                    {
                        "id": 43222,
                        "name": "Le Mas-d’Agenais",
                        "latitude": "44.41033000",
                        "longitude": "0.21869000"
                    },
                    {
                        "id": 43244,
                        "name": "Le Palais-sur-Vienne",
                        "latitude": "45.86380000",
                        "longitude": "1.32207000"
                    },
                    {
                        "id": 43246,
                        "name": "Le Passage",
                        "latitude": "44.20143000",
                        "longitude": "0.60275000"
                    },
                    {
                        "id": 43256,
                        "name": "Le Pian-Médoc",
                        "latitude": "44.95537000",
                        "longitude": "-0.66227000"
                    },
                    {
                        "id": 43259,
                        "name": "Le Pin",
                        "latitude": "46.86179000",
                        "longitude": "-0.65440000"
                    },
                    {
                        "id": 43261,
                        "name": "Le Pizou",
                        "latitude": "45.01667000",
                        "longitude": "0.06667000"
                    },
                    {
                        "id": 43276,
                        "name": "Le Porge",
                        "latitude": "44.87277000",
                        "longitude": "-1.08889000"
                    },
                    {
                        "id": 43304,
                        "name": "Le Taillan-Médoc",
                        "latitude": "44.90521000",
                        "longitude": "-0.67060000"
                    },
                    {
                        "id": 43305,
                        "name": "Le Tallud",
                        "latitude": "46.62911000",
                        "longitude": "-0.29979000"
                    },
                    {
                        "id": 43306,
                        "name": "Le Teich",
                        "latitude": "44.63177000",
                        "longitude": "-1.02155000"
                    },
                    {
                        "id": 43318,
                        "name": "Le Thou",
                        "latitude": "46.08333000",
                        "longitude": "-0.91667000"
                    },
                    {
                        "id": 43330,
                        "name": "Le Verdon-sur-Mer",
                        "latitude": "45.54490000",
                        "longitude": "-1.06225000"
                    },
                    {
                        "id": 43335,
                        "name": "Le Vigen",
                        "latitude": "45.75149000",
                        "longitude": "1.28865000"
                    },
                    {
                        "id": 43340,
                        "name": "Ledeuix",
                        "latitude": "43.21667000",
                        "longitude": "-0.61667000"
                    },
                    {
                        "id": 43347,
                        "name": "Lembras",
                        "latitude": "44.88431000",
                        "longitude": "0.52657000"
                    },
                    {
                        "id": 43349,
                        "name": "Lencloître",
                        "latitude": "46.81622000",
                        "longitude": "0.32827000"
                    },
                    {
                        "id": 43687,
                        "name": "Léognan",
                        "latitude": "44.73548000",
                        "longitude": "-0.59738000"
                    },
                    {
                        "id": 43688,
                        "name": "Léon",
                        "latitude": "43.87676000",
                        "longitude": "-1.30057000"
                    },
                    {
                        "id": 43366,
                        "name": "Les Artigues-de-Lussac",
                        "latitude": "44.96667000",
                        "longitude": "-0.15000000"
                    },
                    {
                        "id": 43435,
                        "name": "Les Églisottes-et-Chalaures",
                        "latitude": "45.09811000",
                        "longitude": "-0.03893000"
                    },
                    {
                        "id": 43391,
                        "name": "Les Gonds",
                        "latitude": "45.71437000",
                        "longitude": "-0.61408000"
                    },
                    {
                        "id": 43408,
                        "name": "Les Mathes",
                        "latitude": "45.71390000",
                        "longitude": "-1.15497000"
                    },
                    {
                        "id": 43417,
                        "name": "Les Ormes",
                        "latitude": "46.97478000",
                        "longitude": "0.60484000"
                    },
                    {
                        "id": 43419,
                        "name": "Les Peintures",
                        "latitude": "45.06667000",
                        "longitude": "-0.10000000"
                    },
                    {
                        "id": 43436,
                        "name": "Lescar",
                        "latitude": "43.33333000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 43438,
                        "name": "Lesparre-Médoc",
                        "latitude": "45.30719000",
                        "longitude": "-0.93764000"
                    },
                    {
                        "id": 43443,
                        "name": "Lestelle-Bétharram",
                        "latitude": "43.13333000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 43459,
                        "name": "Lezay",
                        "latitude": "46.26437000",
                        "longitude": "-0.00925000"
                    },
                    {
                        "id": 43465,
                        "name": "Libourne",
                        "latitude": "44.91530000",
                        "longitude": "-0.24394000"
                    },
                    {
                        "id": 43484,
                        "name": "Ligugé",
                        "latitude": "46.52035000",
                        "longitude": "0.32617000"
                    },
                    {
                        "id": 43493,
                        "name": "Limoges",
                        "latitude": "45.83153000",
                        "longitude": "1.25781000"
                    },
                    {
                        "id": 43498,
                        "name": "Linards",
                        "latitude": "45.70083000",
                        "longitude": "1.53259000"
                    },
                    {
                        "id": 43499,
                        "name": "Linars",
                        "latitude": "45.65000000",
                        "longitude": "0.08333000"
                    },
                    {
                        "id": 43504,
                        "name": "Linxe",
                        "latitude": "43.91984000",
                        "longitude": "-1.24619000"
                    },
                    {
                        "id": 43512,
                        "name": "Listrac-Médoc",
                        "latitude": "45.07410000",
                        "longitude": "-0.79132000"
                    },
                    {
                        "id": 43513,
                        "name": "Lit-et-Mixe",
                        "latitude": "44.03308000",
                        "longitude": "-1.25330000"
                    },
                    {
                        "id": 43576,
                        "name": "Lons",
                        "latitude": "43.31667000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 43592,
                        "name": "Lormont",
                        "latitude": "44.87495000",
                        "longitude": "-0.51782000"
                    },
                    {
                        "id": 43600,
                        "name": "Loubert",
                        "latitude": "45.91422000",
                        "longitude": "0.58617000"
                    },
                    {
                        "id": 43601,
                        "name": "Loudun",
                        "latitude": "47.00788000",
                        "longitude": "0.08296000"
                    },
                    {
                        "id": 43604,
                        "name": "Loupiac",
                        "latitude": "44.61667000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 43613,
                        "name": "Louvie-Juzon",
                        "latitude": "43.08646000",
                        "longitude": "-0.41928000"
                    },
                    {
                        "id": 43620,
                        "name": "Louzy",
                        "latitude": "47.01201000",
                        "longitude": "-0.18537000"
                    },
                    {
                        "id": 43628,
                        "name": "Lubersac",
                        "latitude": "45.44474000",
                        "longitude": "1.40457000"
                    },
                    {
                        "id": 43637,
                        "name": "Lucq-de-Béarn",
                        "latitude": "43.30000000",
                        "longitude": "-0.66667000"
                    },
                    {
                        "id": 43640,
                        "name": "Ludon-Médoc",
                        "latitude": "44.98118000",
                        "longitude": "-0.60254000"
                    },
                    {
                        "id": 43642,
                        "name": "Lugon-et-l'Île-du-Carnay",
                        "latitude": "44.95556000",
                        "longitude": "-0.33611000"
                    },
                    {
                        "id": 43661,
                        "name": "Lusignan",
                        "latitude": "46.43598000",
                        "longitude": "0.12620000"
                    },
                    {
                        "id": 43664,
                        "name": "Lussac",
                        "latitude": "44.95000000",
                        "longitude": "-0.10000000"
                    },
                    {
                        "id": 43665,
                        "name": "Lussac-les-Châteaux",
                        "latitude": "46.40327000",
                        "longitude": "0.72524000"
                    },
                    {
                        "id": 43711,
                        "name": "Macau",
                        "latitude": "45.00679000",
                        "longitude": "-0.61821000"
                    },
                    {
                        "id": 43719,
                        "name": "Magescq",
                        "latitude": "43.78205000",
                        "longitude": "-1.21652000"
                    },
                    {
                        "id": 43721,
                        "name": "Magnac-Laval",
                        "latitude": "46.21514000",
                        "longitude": "1.16724000"
                    },
                    {
                        "id": 43722,
                        "name": "Magnac-sur-Touvre",
                        "latitude": "45.66667000",
                        "longitude": "0.23333000"
                    },
                    {
                        "id": 43730,
                        "name": "Magné",
                        "latitude": "46.31548000",
                        "longitude": "-0.54575000"
                    },
                    {
                        "id": 43755,
                        "name": "Malemort-sur-Corrèze",
                        "latitude": "45.17075000",
                        "longitude": "1.56393000"
                    },
                    {
                        "id": 43781,
                        "name": "Mansac",
                        "latitude": "45.16839000",
                        "longitude": "1.38342000"
                    },
                    {
                        "id": 43783,
                        "name": "Mansle",
                        "latitude": "45.87526000",
                        "longitude": "0.17914000"
                    },
                    {
                        "id": 43791,
                        "name": "Marans",
                        "latitude": "46.30811000",
                        "longitude": "-0.99450000"
                    },
                    {
                        "id": 43796,
                        "name": "Marcamps",
                        "latitude": "45.04045000",
                        "longitude": "-0.49275000"
                    },
                    {
                        "id": 43799,
                        "name": "Marcheprime",
                        "latitude": "44.69146000",
                        "longitude": "-0.85496000"
                    },
                    {
                        "id": 43803,
                        "name": "Marcillac",
                        "latitude": "45.26870000",
                        "longitude": "-0.52379000"
                    },
                    {
                        "id": 43823,
                        "name": "Marennes",
                        "latitude": "45.82280000",
                        "longitude": "-1.10546000"
                    },
                    {
                        "id": 43825,
                        "name": "Mareuil",
                        "latitude": "45.45000000",
                        "longitude": "0.45000000"
                    },
                    {
                        "id": 43832,
                        "name": "Margaux",
                        "latitude": "45.04012000",
                        "longitude": "-0.67892000"
                    },
                    {
                        "id": 43841,
                        "name": "Marigny-Brizay",
                        "latitude": "46.74622000",
                        "longitude": "0.37626000"
                    },
                    {
                        "id": 43859,
                        "name": "Marmande",
                        "latitude": "44.50012000",
                        "longitude": "0.16526000"
                    },
                    {
                        "id": 43907,
                        "name": "Marsilly",
                        "latitude": "46.23027000",
                        "longitude": "-1.13840000"
                    },
                    {
                        "id": 43911,
                        "name": "Martignas-sur-Jalle",
                        "latitude": "44.84528000",
                        "longitude": "-0.78060000"
                    },
                    {
                        "id": 43917,
                        "name": "Martillac",
                        "latitude": "44.71100000",
                        "longitude": "-0.53747000"
                    },
                    {
                        "id": 43937,
                        "name": "Matha",
                        "latitude": "45.86823000",
                        "longitude": "-0.31849000"
                    },
                    {
                        "id": 43949,
                        "name": "Mauléon-Licharre",
                        "latitude": "43.22684000",
                        "longitude": "-0.88038000"
                    },
                    {
                        "id": 43964,
                        "name": "Mauzé-sur-le-Mignon",
                        "latitude": "46.19516000",
                        "longitude": "-0.67032000"
                    },
                    {
                        "id": 43963,
                        "name": "Mauzé-Thouarsais",
                        "latitude": "46.97611000",
                        "longitude": "-0.27846000"
                    },
                    {
                        "id": 43979,
                        "name": "Mazères-Lezons",
                        "latitude": "43.26667000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 44458,
                        "name": "Médis",
                        "latitude": "45.64337000",
                        "longitude": "-0.96298000"
                    },
                    {
                        "id": 44460,
                        "name": "Mées",
                        "latitude": "43.70452000",
                        "longitude": "-1.10952000"
                    },
                    {
                        "id": 43986,
                        "name": "Meilhan",
                        "latitude": "43.86436000",
                        "longitude": "-0.70587000"
                    },
                    {
                        "id": 43987,
                        "name": "Meilhan-sur-Garonne",
                        "latitude": "44.52131000",
                        "longitude": "0.03472000"
                    },
                    {
                        "id": 43995,
                        "name": "Melle",
                        "latitude": "46.22285000",
                        "longitude": "-0.14216000"
                    },
                    {
                        "id": 44463,
                        "name": "Ménesplet",
                        "latitude": "45.01667000",
                        "longitude": "0.11667000"
                    },
                    {
                        "id": 44005,
                        "name": "Mensignac",
                        "latitude": "45.22505000",
                        "longitude": "0.56214000"
                    },
                    {
                        "id": 44473,
                        "name": "Mérignac",
                        "latitude": "44.83248000",
                        "longitude": "-0.63381000"
                    },
                    {
                        "id": 44027,
                        "name": "Meschers-sur-Gironde",
                        "latitude": "45.56037000",
                        "longitude": "-0.95470000"
                    },
                    {
                        "id": 44049,
                        "name": "Meursac",
                        "latitude": "45.64890000",
                        "longitude": "-0.80801000"
                    },
                    {
                        "id": 44057,
                        "name": "Meymac",
                        "latitude": "45.53583000",
                        "longitude": "2.14699000"
                    },
                    {
                        "id": 44062,
                        "name": "Meyssac",
                        "latitude": "45.05547000",
                        "longitude": "1.67412000"
                    },
                    {
                        "id": 44486,
                        "name": "Mézin",
                        "latitude": "44.05668000",
                        "longitude": "0.25874000"
                    },
                    {
                        "id": 44069,
                        "name": "Mignaloux-Beauvoir",
                        "latitude": "46.54157000",
                        "longitude": "0.41538000"
                    },
                    {
                        "id": 44070,
                        "name": "Migné-Auxances",
                        "latitude": "46.62745000",
                        "longitude": "0.31458000"
                    },
                    {
                        "id": 44078,
                        "name": "Mimbaste",
                        "latitude": "43.64887000",
                        "longitude": "-0.97383000"
                    },
                    {
                        "id": 44080,
                        "name": "Mimizan",
                        "latitude": "44.20057000",
                        "longitude": "-1.22886000"
                    },
                    {
                        "id": 44085,
                        "name": "Mios",
                        "latitude": "44.60489000",
                        "longitude": "-0.93329000"
                    },
                    {
                        "id": 44088,
                        "name": "Mirambeau",
                        "latitude": "45.37310000",
                        "longitude": "-0.57067000"
                    },
                    {
                        "id": 44089,
                        "name": "Miramont-de-Guyenne",
                        "latitude": "44.60157000",
                        "longitude": "0.36247000"
                    },
                    {
                        "id": 44092,
                        "name": "Mirebeau",
                        "latitude": "46.78743000",
                        "longitude": "0.18341000"
                    },
                    {
                        "id": 44097,
                        "name": "Mirepeix",
                        "latitude": "43.18333000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 44128,
                        "name": "Monbazillac",
                        "latitude": "44.79374000",
                        "longitude": "0.49256000"
                    },
                    {
                        "id": 44132,
                        "name": "Moncontour",
                        "latitude": "46.88086000",
                        "longitude": "-0.01996000"
                    },
                    {
                        "id": 44133,
                        "name": "Moncoutant",
                        "latitude": "46.72547000",
                        "longitude": "-0.58797000"
                    },
                    {
                        "id": 44140,
                        "name": "Monein",
                        "latitude": "43.33333000",
                        "longitude": "-0.58333000"
                    },
                    {
                        "id": 44142,
                        "name": "Monflanquin",
                        "latitude": "44.52966000",
                        "longitude": "0.76772000"
                    },
                    {
                        "id": 44152,
                        "name": "Monségur",
                        "latitude": "44.65040000",
                        "longitude": "0.08047000"
                    },
                    {
                        "id": 44150,
                        "name": "Monsempron-Libos",
                        "latitude": "44.49004000",
                        "longitude": "0.94090000"
                    },
                    {
                        "id": 44153,
                        "name": "Mont",
                        "latitude": "43.43333000",
                        "longitude": "-0.65000000"
                    },
                    {
                        "id": 44161,
                        "name": "Mont-de-Marsan",
                        "latitude": "43.89022000",
                        "longitude": "-0.49713000"
                    },
                    {
                        "id": 44167,
                        "name": "Montagne",
                        "latitude": "44.93333000",
                        "longitude": "-0.13333000"
                    },
                    {
                        "id": 44174,
                        "name": "Montamisé",
                        "latitude": "46.62181000",
                        "longitude": "0.42442000"
                    },
                    {
                        "id": 44177,
                        "name": "Montardon",
                        "latitude": "43.36667000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 44187,
                        "name": "Montaut",
                        "latitude": "43.13333000",
                        "longitude": "-0.20000000"
                    },
                    {
                        "id": 44189,
                        "name": "Montayral",
                        "latitude": "44.47513000",
                        "longitude": "0.98769000"
                    },
                    {
                        "id": 44202,
                        "name": "Montbron",
                        "latitude": "45.66667000",
                        "longitude": "0.50000000"
                    },
                    {
                        "id": 44205,
                        "name": "Montcaret",
                        "latitude": "44.85000000",
                        "longitude": "0.06667000"
                    },
                    {
                        "id": 44219,
                        "name": "Montendre",
                        "latitude": "45.28469000",
                        "longitude": "-0.40627000"
                    },
                    {
                        "id": 44240,
                        "name": "Montfort-en-Chalosse",
                        "latitude": "43.71124000",
                        "longitude": "-0.83947000"
                    },
                    {
                        "id": 44249,
                        "name": "Montguyon",
                        "latitude": "45.21667000",
                        "longitude": "-0.18333000"
                    },
                    {
                        "id": 44255,
                        "name": "Montignac",
                        "latitude": "45.06429000",
                        "longitude": "1.16196000"
                    },
                    {
                        "id": 44272,
                        "name": "Montlieu-la-Garde",
                        "latitude": "45.25000000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 44286,
                        "name": "Montmoreau-Saint-Cybard",
                        "latitude": "45.40000000",
                        "longitude": "0.13333000"
                    },
                    {
                        "id": 44288,
                        "name": "Montmorillon",
                        "latitude": "46.42614000",
                        "longitude": "0.87070000"
                    },
                    {
                        "id": 44301,
                        "name": "Montpon-Ménestérol",
                        "latitude": "45.00000000",
                        "longitude": "0.16667000"
                    },
                    {
                        "id": 44306,
                        "name": "Montrem",
                        "latitude": "45.13417000",
                        "longitude": "0.59029000"
                    },
                    {
                        "id": 44331,
                        "name": "Montussan",
                        "latitude": "44.88057000",
                        "longitude": "-0.42181000"
                    },
                    {
                        "id": 44346,
                        "name": "Morcenx",
                        "latitude": "44.03536000",
                        "longitude": "-0.91375000"
                    },
                    {
                        "id": 44356,
                        "name": "Morlaas",
                        "latitude": "43.35000000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 44360,
                        "name": "Mornac",
                        "latitude": "45.68333000",
                        "longitude": "0.26667000"
                    },
                    {
                        "id": 44370,
                        "name": "Mortagne-sur-Gironde",
                        "latitude": "45.48139000",
                        "longitude": "-0.78702000"
                    },
                    {
                        "id": 44387,
                        "name": "Mougon",
                        "latitude": "46.29561000",
                        "longitude": "-0.28659000"
                    },
                    {
                        "id": 44388,
                        "name": "Mouguerre",
                        "latitude": "43.46795000",
                        "longitude": "-1.41824000"
                    },
                    {
                        "id": 44392,
                        "name": "Mouleydier",
                        "latitude": "44.85572000",
                        "longitude": "0.59759000"
                    },
                    {
                        "id": 44393,
                        "name": "Mouliets-et-Villemartin",
                        "latitude": "44.83333000",
                        "longitude": "-0.01667000"
                    },
                    {
                        "id": 44397,
                        "name": "Moulis-en-Médoc",
                        "latitude": "45.05938000",
                        "longitude": "-0.77033000"
                    },
                    {
                        "id": 44399,
                        "name": "Mourenx",
                        "latitude": "43.38333000",
                        "longitude": "-0.60000000"
                    },
                    {
                        "id": 44411,
                        "name": "Mouthiers-sur-Boëme",
                        "latitude": "45.55000000",
                        "longitude": "0.11667000"
                    },
                    {
                        "id": 44430,
                        "name": "Mugron",
                        "latitude": "43.74952000",
                        "longitude": "-0.75179000"
                    },
                    {
                        "id": 44441,
                        "name": "Muron",
                        "latitude": "46.03444000",
                        "longitude": "-0.82867000"
                    },
                    {
                        "id": 44445,
                        "name": "Mussidan",
                        "latitude": "45.03542000",
                        "longitude": "0.36290000"
                    },
                    {
                        "id": 44497,
                        "name": "Naintré",
                        "latitude": "46.76354000",
                        "longitude": "0.48683000"
                    },
                    {
                        "id": 44507,
                        "name": "Nanteuil",
                        "latitude": "46.41172000",
                        "longitude": "-0.17461000"
                    },
                    {
                        "id": 44508,
                        "name": "Nanteuil-en-Vallée",
                        "latitude": "46.00089000",
                        "longitude": "0.32206000"
                    },
                    {
                        "id": 44511,
                        "name": "Nantiat",
                        "latitude": "46.00910000",
                        "longitude": "1.17308000"
                    },
                    {
                        "id": 44516,
                        "name": "Narrosse",
                        "latitude": "43.70381000",
                        "longitude": "-1.00742000"
                    },
                    {
                        "id": 44520,
                        "name": "Navailles-Angos",
                        "latitude": "43.41667000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 44521,
                        "name": "Navarrenx",
                        "latitude": "43.32135000",
                        "longitude": "-0.75927000"
                    },
                    {
                        "id": 44524,
                        "name": "Naves",
                        "latitude": "45.31395000",
                        "longitude": "1.76708000"
                    },
                    {
                        "id": 44525,
                        "name": "Nay",
                        "latitude": "43.18333000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 44694,
                        "name": "Nérac",
                        "latitude": "44.13613000",
                        "longitude": "0.33934000"
                    },
                    {
                        "id": 44530,
                        "name": "Nercillac",
                        "latitude": "45.71667000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 44531,
                        "name": "Nersac",
                        "latitude": "45.63333000",
                        "longitude": "0.05000000"
                    },
                    {
                        "id": 44561,
                        "name": "Neuvic",
                        "latitude": "45.10033000",
                        "longitude": "0.46901000"
                    },
                    {
                        "id": 44562,
                        "name": "Neuvic-Entier",
                        "latitude": "45.72206000",
                        "longitude": "1.61303000"
                    },
                    {
                        "id": 44566,
                        "name": "Neuville-de-Poitou",
                        "latitude": "46.68333000",
                        "longitude": "0.25000000"
                    },
                    {
                        "id": 44585,
                        "name": "Nexon",
                        "latitude": "45.67962000",
                        "longitude": "1.18555000"
                    },
                    {
                        "id": 44595,
                        "name": "Nieul",
                        "latitude": "45.92668000",
                        "longitude": "1.17494000"
                    },
                    {
                        "id": 44597,
                        "name": "Nieul-lès-Saintes",
                        "latitude": "45.76021000",
                        "longitude": "-0.73137000"
                    },
                    {
                        "id": 44598,
                        "name": "Nieul-sur-Mer",
                        "latitude": "46.20583000",
                        "longitude": "-1.16449000"
                    },
                    {
                        "id": 44601,
                        "name": "Niort",
                        "latitude": "46.32313000",
                        "longitude": "-0.45877000"
                    },
                    {
                        "id": 44606,
                        "name": "Noaillan",
                        "latitude": "44.48057000",
                        "longitude": "-0.36640000"
                    },
                    {
                        "id": 44639,
                        "name": "Nontron",
                        "latitude": "45.52950000",
                        "longitude": "0.66179000"
                    },
                    {
                        "id": 44655,
                        "name": "Notre-Dame-de-Sanilhac",
                        "latitude": "45.12121000",
                        "longitude": "0.71157000"
                    },
                    {
                        "id": 44657,
                        "name": "Nouaillé-Maupertuis",
                        "latitude": "46.51113000",
                        "longitude": "0.41667000"
                    },
                    {
                        "id": 44659,
                        "name": "Nousty",
                        "latitude": "43.26667000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 44685,
                        "name": "Nueil-les-Aubiers",
                        "latitude": "46.93333000",
                        "longitude": "-0.58333000"
                    },
                    {
                        "id": 44711,
                        "name": "Objat",
                        "latitude": "45.26302000",
                        "longitude": "1.40826000"
                    },
                    {
                        "id": 44717,
                        "name": "Oeyreluy",
                        "latitude": "43.66876000",
                        "longitude": "-1.08276000"
                    },
                    {
                        "id": 44721,
                        "name": "Ogeu-les-Bains",
                        "latitude": "43.15000000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 44739,
                        "name": "Oloron-Sainte-Marie",
                        "latitude": "43.19441000",
                        "longitude": "-0.61069000"
                    },
                    {
                        "id": 44742,
                        "name": "Ondres",
                        "latitude": "43.56461000",
                        "longitude": "-1.44449000"
                    },
                    {
                        "id": 44743,
                        "name": "Onesse-Laharie",
                        "latitude": "44.06146000",
                        "longitude": "-1.06984000"
                    },
                    {
                        "id": 44750,
                        "name": "Oradour-sur-Glane",
                        "latitude": "45.93405000",
                        "longitude": "1.03170000"
                    },
                    {
                        "id": 44751,
                        "name": "Oradour-sur-Vayres",
                        "latitude": "45.73286000",
                        "longitude": "0.86457000"
                    },
                    {
                        "id": 44786,
                        "name": "Orthez",
                        "latitude": "43.48839000",
                        "longitude": "-0.77244000"
                    },
                    {
                        "id": 44811,
                        "name": "Ousse",
                        "latitude": "43.28333000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 44827,
                        "name": "Paillet",
                        "latitude": "44.68512000",
                        "longitude": "-0.36500000"
                    },
                    {
                        "id": 44839,
                        "name": "Pamproux",
                        "latitude": "46.39578000",
                        "longitude": "-0.05327000"
                    },
                    {
                        "id": 44840,
                        "name": "Panazol",
                        "latitude": "45.83465000",
                        "longitude": "1.32759000"
                    },
                    {
                        "id": 44850,
                        "name": "Parempuyre",
                        "latitude": "44.95038000",
                        "longitude": "-0.60453000"
                    },
                    {
                        "id": 44851,
                        "name": "Parentis-en-Born",
                        "latitude": "44.35274000",
                        "longitude": "-1.07095000"
                    },
                    {
                        "id": 44859,
                        "name": "Parthenay",
                        "latitude": "46.64872000",
                        "longitude": "-0.24682000"
                    },
                    {
                        "id": 44867,
                        "name": "Pau",
                        "latitude": "43.30000000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 44868,
                        "name": "Pauillac",
                        "latitude": "45.19644000",
                        "longitude": "-0.74873000"
                    },
                    {
                        "id": 44877,
                        "name": "Payzac",
                        "latitude": "45.40000000",
                        "longitude": "1.21667000"
                    },
                    {
                        "id": 44886,
                        "name": "Pellegrue",
                        "latitude": "44.74355000",
                        "longitude": "0.07595000"
                    },
                    {
                        "id": 45353,
                        "name": "Pérignac",
                        "latitude": "45.62306000",
                        "longitude": "-0.46488000"
                    },
                    {
                        "id": 45357,
                        "name": "Périgny",
                        "latitude": "46.15519000",
                        "longitude": "-1.09822000"
                    },
                    {
                        "id": 45359,
                        "name": "Périgueux",
                        "latitude": "45.18333000",
                        "longitude": "0.71667000"
                    },
                    {
                        "id": 44914,
                        "name": "Pessac",
                        "latitude": "44.81011000",
                        "longitude": "-0.64129000"
                    },
                    {
                        "id": 44922,
                        "name": "Peujard",
                        "latitude": "45.03619000",
                        "longitude": "-0.44096000"
                    },
                    {
                        "id": 44926,
                        "name": "Peyrat-de-Bellac",
                        "latitude": "46.14087000",
                        "longitude": "1.03661000"
                    },
                    {
                        "id": 44927,
                        "name": "Peyrat-le-Château",
                        "latitude": "45.81578000",
                        "longitude": "1.77233000"
                    },
                    {
                        "id": 44928,
                        "name": "Peyrehorade",
                        "latitude": "43.54886000",
                        "longitude": "-1.11574000"
                    },
                    {
                        "id": 44932,
                        "name": "Peyrilhac",
                        "latitude": "45.95043000",
                        "longitude": "1.13503000"
                    },
                    {
                        "id": 44986,
                        "name": "Piégut-Pluviers",
                        "latitude": "45.62297000",
                        "longitude": "0.69013000"
                    },
                    {
                        "id": 44949,
                        "name": "Pierre-Buffière",
                        "latitude": "45.69193000",
                        "longitude": "1.36193000"
                    },
                    {
                        "id": 44981,
                        "name": "Pissos",
                        "latitude": "44.30833000",
                        "longitude": "-0.77963000"
                    },
                    {
                        "id": 45020,
                        "name": "Pleumartin",
                        "latitude": "46.73786000",
                        "longitude": "0.76900000"
                    },
                    {
                        "id": 45132,
                        "name": "Podensac",
                        "latitude": "44.65038000",
                        "longitude": "-0.35508000"
                    },
                    {
                        "id": 45133,
                        "name": "Poey-de-Lescar",
                        "latitude": "43.35000000",
                        "longitude": "-0.46667000"
                    },
                    {
                        "id": 45138,
                        "name": "Poitiers",
                        "latitude": "46.58333000",
                        "longitude": "0.33333000"
                    },
                    {
                        "id": 45147,
                        "name": "Pomarez",
                        "latitude": "43.62971000",
                        "longitude": "-0.82934000"
                    },
                    {
                        "id": 45153,
                        "name": "Pompaire",
                        "latitude": "46.60727000",
                        "longitude": "-0.23237000"
                    },
                    {
                        "id": 45156,
                        "name": "Pompignac",
                        "latitude": "44.85114000",
                        "longitude": "-0.43705000"
                    },
                    {
                        "id": 45162,
                        "name": "Pons",
                        "latitude": "45.57988000",
                        "longitude": "-0.54783000"
                    },
                    {
                        "id": 45185,
                        "name": "Pont-du-Casse",
                        "latitude": "44.22867000",
                        "longitude": "0.67924000"
                    },
                    {
                        "id": 45190,
                        "name": "Pont-l’Abbé-d’Arnoult",
                        "latitude": "45.82875000",
                        "longitude": "-0.87499000"
                    },
                    {
                        "id": 45199,
                        "name": "Pontacq",
                        "latitude": "43.18333000",
                        "longitude": "-0.11667000"
                    },
                    {
                        "id": 45208,
                        "name": "Pontenx-les-Forges",
                        "latitude": "44.24134000",
                        "longitude": "-1.12095000"
                    },
                    {
                        "id": 45214,
                        "name": "Pontonx-sur-l'Adour",
                        "latitude": "43.78783000",
                        "longitude": "-0.92508000"
                    },
                    {
                        "id": 45234,
                        "name": "Port-des-Barques",
                        "latitude": "45.94763000",
                        "longitude": "-1.07795000"
                    },
                    {
                        "id": 45231,
                        "name": "Port-Sainte-Foy-et-Ponchapt",
                        "latitude": "44.83333000",
                        "longitude": "0.20000000"
                    },
                    {
                        "id": 45232,
                        "name": "Port-Sainte-Marie",
                        "latitude": "44.25158000",
                        "longitude": "0.39134000"
                    },
                    {
                        "id": 45242,
                        "name": "Portets",
                        "latitude": "44.69679000",
                        "longitude": "-0.42452000"
                    },
                    {
                        "id": 45252,
                        "name": "Pouillon",
                        "latitude": "43.60480000",
                        "longitude": "-0.99947000"
                    },
                    {
                        "id": 45276,
                        "name": "Prahecq",
                        "latitude": "46.25897000",
                        "longitude": "-0.34425000"
                    },
                    {
                        "id": 45304,
                        "name": "Préchac",
                        "latitude": "44.39883000",
                        "longitude": "-0.35387000"
                    },
                    {
                        "id": 45281,
                        "name": "Preignac",
                        "latitude": "44.58438000",
                        "longitude": "-0.29423000"
                    },
                    {
                        "id": 45286,
                        "name": "Prigonrieux",
                        "latitude": "44.85451000",
                        "longitude": "0.40275000"
                    },
                    {
                        "id": 45317,
                        "name": "Pugnac",
                        "latitude": "45.08190000",
                        "longitude": "-0.49618000"
                    },
                    {
                        "id": 45319,
                        "name": "Puilboreau",
                        "latitude": "46.18620000",
                        "longitude": "-1.11797000"
                    },
                    {
                        "id": 45326,
                        "name": "Pujols",
                        "latitude": "44.39424000",
                        "longitude": "0.68810000"
                    },
                    {
                        "id": 45340,
                        "name": "Puymoyen",
                        "latitude": "45.61667000",
                        "longitude": "0.18333000"
                    },
                    {
                        "id": 45341,
                        "name": "Puyoô",
                        "latitude": "43.52502000",
                        "longitude": "-0.91283000"
                    },
                    {
                        "id": 45398,
                        "name": "Quinsac",
                        "latitude": "44.75535000",
                        "longitude": "-0.48697000"
                    },
                    {
                        "id": 45433,
                        "name": "Rauzan",
                        "latitude": "44.77838000",
                        "longitude": "-0.12465000"
                    },
                    {
                        "id": 45436,
                        "name": "Razac-sur-l’Isle",
                        "latitude": "45.16332000",
                        "longitude": "0.60085000"
                    },
                    {
                        "id": 45437,
                        "name": "Razès",
                        "latitude": "46.03219000",
                        "longitude": "1.33676000"
                    },
                    {
                        "id": 45446,
                        "name": "Reignac",
                        "latitude": "45.23393000",
                        "longitude": "-0.50627000"
                    },
                    {
                        "id": 45492,
                        "name": "Ribérac",
                        "latitude": "45.25000000",
                        "longitude": "0.33333000"
                    },
                    {
                        "id": 45511,
                        "name": "Rilhac-Rancon",
                        "latitude": "45.90000000",
                        "longitude": "1.31667000"
                    },
                    {
                        "id": 45518,
                        "name": "Rion-des-Landes",
                        "latitude": "43.93449000",
                        "longitude": "-0.92388000"
                    },
                    {
                        "id": 45519,
                        "name": "Rions",
                        "latitude": "44.66378000",
                        "longitude": "-0.35113000"
                    },
                    {
                        "id": 45527,
                        "name": "Rivedoux-Plage",
                        "latitude": "46.15854000",
                        "longitude": "-1.27093000"
                    },
                    {
                        "id": 45532,
                        "name": "Rivière-Saas-et-Gourby",
                        "latitude": "43.67990000",
                        "longitude": "-1.14986000"
                    },
                    {
                        "id": 45533,
                        "name": "Rivières",
                        "latitude": "45.75295000",
                        "longitude": "0.36128000"
                    },
                    {
                        "id": 45542,
                        "name": "Rochechouart",
                        "latitude": "45.82290000",
                        "longitude": "0.82080000"
                    },
                    {
                        "id": 45544,
                        "name": "Rochefort",
                        "latitude": "45.94204000",
                        "longitude": "-0.96696000"
                    },
                    {
                        "id": 45549,
                        "name": "Roches-Prémarie-Andillé",
                        "latitude": "46.48251000",
                        "longitude": "0.37106000"
                    },
                    {
                        "id": 45592,
                        "name": "Roquefort",
                        "latitude": "44.03500000",
                        "longitude": "-0.32323000"
                    },
                    {
                        "id": 45621,
                        "name": "Rouffignac-Saint-Cernin-de-Reilhac",
                        "latitude": "45.05000000",
                        "longitude": "0.96667000"
                    },
                    {
                        "id": 45627,
                        "name": "Rouillac",
                        "latitude": "45.77582000",
                        "longitude": "-0.06380000"
                    },
                    {
                        "id": 45629,
                        "name": "Rouillé",
                        "latitude": "46.42024000",
                        "longitude": "0.04073000"
                    },
                    {
                        "id": 45632,
                        "name": "Roullet-Saint-Estèphe",
                        "latitude": "45.58333000",
                        "longitude": "0.05000000"
                    },
                    {
                        "id": 45634,
                        "name": "Roumazières-Loubert",
                        "latitude": "45.88690000",
                        "longitude": "0.58125000"
                    },
                    {
                        "id": 45645,
                        "name": "Royan",
                        "latitude": "45.62846000",
                        "longitude": "-1.02810000"
                    },
                    {
                        "id": 45662,
                        "name": "Ruelle-sur-Touvre",
                        "latitude": "45.68333000",
                        "longitude": "0.23333000"
                    },
                    {
                        "id": 45663,
                        "name": "Ruffec",
                        "latitude": "46.02877000",
                        "longitude": "0.19821000"
                    },
                    {
                        "id": 45700,
                        "name": "Sablonceaux",
                        "latitude": "45.70963000",
                        "longitude": "-0.88806000"
                    },
                    {
                        "id": 45701,
                        "name": "Sablons",
                        "latitude": "45.03333000",
                        "longitude": "-0.18333000"
                    },
                    {
                        "id": 45705,
                        "name": "Sabres",
                        "latitude": "44.14896000",
                        "longitude": "-0.74123000"
                    },
                    {
                        "id": 45710,
                        "name": "Sadirac",
                        "latitude": "44.78179000",
                        "longitude": "-0.41334000"
                    },
                    {
                        "id": 45729,
                        "name": "Saint-Agnant",
                        "latitude": "45.87354000",
                        "longitude": "-0.96119000"
                    },
                    {
                        "id": 45730,
                        "name": "Saint-Agnant-de-Versillat",
                        "latitude": "46.27800000",
                        "longitude": "1.50962000"
                    },
                    {
                        "id": 45733,
                        "name": "Saint-Aigulin",
                        "latitude": "45.15735000",
                        "longitude": "-0.00863000"
                    },
                    {
                        "id": 45745,
                        "name": "Saint-Amand-sur-Sèvre",
                        "latitude": "46.86905000",
                        "longitude": "-0.79441000"
                    },
                    {
                        "id": 45749,
                        "name": "Saint-Amant-de-Boixe",
                        "latitude": "45.79790000",
                        "longitude": "0.13524000"
                    },
                    {
                        "id": 45759,
                        "name": "Saint-André-de-Seignanx",
                        "latitude": "43.55800000",
                        "longitude": "-1.35183000"
                    },
                    {
                        "id": 45771,
                        "name": "Saint-Antoine-de-Breuilh",
                        "latitude": "44.83333000",
                        "longitude": "0.16667000"
                    },
                    {
                        "id": 45778,
                        "name": "Saint-Astier",
                        "latitude": "45.14582000",
                        "longitude": "0.52898000"
                    },
                    {
                        "id": 45782,
                        "name": "Saint-Aubin-de-Médoc",
                        "latitude": "44.91180000",
                        "longitude": "-0.72460000"
                    },
                    {
                        "id": 45788,
                        "name": "Saint-Aubin-le-Cloud",
                        "latitude": "46.65308000",
                        "longitude": "-0.35258000"
                    },
                    {
                        "id": 45794,
                        "name": "Saint-Aulaye",
                        "latitude": "45.20000000",
                        "longitude": "0.13333000"
                    },
                    {
                        "id": 45810,
                        "name": "Saint-Benoît",
                        "latitude": "46.55315000",
                        "longitude": "0.34190000"
                    },
                    {
                        "id": 45825,
                        "name": "Saint-Brice",
                        "latitude": "45.68333000",
                        "longitude": "-0.28333000"
                    },
                    {
                        "id": 45829,
                        "name": "Saint-Brice-sur-Vienne",
                        "latitude": "45.87852000",
                        "longitude": "0.95594000"
                    },
                    {
                        "id": 45838,
                        "name": "Saint-Caprais-de-Bordeaux",
                        "latitude": "44.74786000",
                        "longitude": "-0.43192000"
                    },
                    {
                        "id": 45855,
                        "name": "Saint-Christoly-de-Blaye",
                        "latitude": "45.13179000",
                        "longitude": "-0.50760000"
                    },
                    {
                        "id": 45861,
                        "name": "Saint-Ciers-d’Abzac",
                        "latitude": "45.03333000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 45862,
                        "name": "Saint-Ciers-sur-Gironde",
                        "latitude": "45.28855000",
                        "longitude": "-0.60794000"
                    },
                    {
                        "id": 45865,
                        "name": "Saint-Claud",
                        "latitude": "45.89526000",
                        "longitude": "0.46454000"
                    },
                    {
                        "id": 45869,
                        "name": "Saint-Clément",
                        "latitude": "45.34150000",
                        "longitude": "1.68507000"
                    },
                    {
                        "id": 45880,
                        "name": "Saint-Cyprien",
                        "latitude": "44.86924000",
                        "longitude": "1.04156000"
                    },
                    {
                        "id": 45898,
                        "name": "Saint-Denis-d’Oléron",
                        "latitude": "46.03496000",
                        "longitude": "-1.37867000"
                    },
                    {
                        "id": 45897,
                        "name": "Saint-Denis-de-Pile",
                        "latitude": "45.00000000",
                        "longitude": "-0.20000000"
                    },
                    {
                        "id": 46639,
                        "name": "Saint-Émilion",
                        "latitude": "44.88333000",
                        "longitude": "-0.15000000"
                    },
                    {
                        "id": 45923,
                        "name": "Saint-Estèphe",
                        "latitude": "45.26252000",
                        "longitude": "-0.77237000"
                    },
                    {
                        "id": 46643,
                        "name": "Saint-Étienne-de-Baïgorry",
                        "latitude": "43.17533000",
                        "longitude": "-1.34670000"
                    },
                    {
                        "id": 45953,
                        "name": "Saint-Gelais",
                        "latitude": "46.38234000",
                        "longitude": "-0.39084000"
                    },
                    {
                        "id": 45954,
                        "name": "Saint-Gence",
                        "latitude": "45.92198000",
                        "longitude": "1.13726000"
                    },
                    {
                        "id": 45961,
                        "name": "Saint-Genis-de-Saintonge",
                        "latitude": "45.48107000",
                        "longitude": "-0.56848000"
                    },
                    {
                        "id": 45974,
                        "name": "Saint-Georges-de-Didonne",
                        "latitude": "45.60342000",
                        "longitude": "-1.00487000"
                    },
                    {
                        "id": 45981,
                        "name": "Saint-Georges-des-Coteaux",
                        "latitude": "45.76667000",
                        "longitude": "-0.71667000"
                    },
                    {
                        "id": 45984,
                        "name": "Saint-Georges-du-Bois",
                        "latitude": "46.14074000",
                        "longitude": "-0.73393000"
                    },
                    {
                        "id": 45986,
                        "name": "Saint-Georges-lès-Baillargeaux",
                        "latitude": "46.67017000",
                        "longitude": "0.40209000"
                    },
                    {
                        "id": 45992,
                        "name": "Saint-Geours-de-Maremne",
                        "latitude": "43.68936000",
                        "longitude": "-1.22937000"
                    },
                    {
                        "id": 46002,
                        "name": "Saint-Germain-de-Lusignan",
                        "latitude": "45.45011000",
                        "longitude": "-0.46147000"
                    },
                    {
                        "id": 46003,
                        "name": "Saint-Germain-de-Marencennes",
                        "latitude": "46.07733000",
                        "longitude": "-0.79133000"
                    },
                    {
                        "id": 46012,
                        "name": "Saint-Germain-du-Puch",
                        "latitude": "44.85000000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 46017,
                        "name": "Saint-Germain-les-Belles",
                        "latitude": "45.61356000",
                        "longitude": "1.49490000"
                    },
                    {
                        "id": 46024,
                        "name": "Saint-Gervais",
                        "latitude": "45.01583000",
                        "longitude": "-0.45238000"
                    },
                    {
                        "id": 46030,
                        "name": "Saint-Gervais-les-Trois-Clochers",
                        "latitude": "46.90067000",
                        "longitude": "0.40766000"
                    },
                    {
                        "id": 46051,
                        "name": "Saint-Hilaire",
                        "latitude": "44.53333000",
                        "longitude": "0.71667000"
                    },
                    {
                        "id": 46060,
                        "name": "Saint-Hilaire-de-Villefranche",
                        "latitude": "45.85091000",
                        "longitude": "-0.52993000"
                    },
                    {
                        "id": 46065,
                        "name": "Saint-Hilaire-la-Palud",
                        "latitude": "46.26676000",
                        "longitude": "-0.71380000"
                    },
                    {
                        "id": 46070,
                        "name": "Saint-Hippolyte",
                        "latitude": "45.91884000",
                        "longitude": "-0.89183000"
                    },
                    {
                        "id": 46113,
                        "name": "Saint-Jean-d’Illac",
                        "latitude": "44.80869000",
                        "longitude": "-0.78565000"
                    },
                    {
                        "id": 46092,
                        "name": "Saint-Jean-de-Liversay",
                        "latitude": "46.26894000",
                        "longitude": "-0.87385000"
                    },
                    {
                        "id": 46094,
                        "name": "Saint-Jean-de-Luz",
                        "latitude": "43.38871000",
                        "longitude": "-1.66267000"
                    },
                    {
                        "id": 46100,
                        "name": "Saint-Jean-de-Sauves",
                        "latitude": "46.84130000",
                        "longitude": "0.09272000"
                    },
                    {
                        "id": 46103,
                        "name": "Saint-Jean-de-Thouars",
                        "latitude": "46.96486000",
                        "longitude": "-0.21114000"
                    },
                    {
                        "id": 46086,
                        "name": "Saint-Jean-Pied-de-Port",
                        "latitude": "43.16363000",
                        "longitude": "-1.23738000"
                    },
                    {
                        "id": 46133,
                        "name": "Saint-Jouvent",
                        "latitude": "45.95680000",
                        "longitude": "1.20500000"
                    },
                    {
                        "id": 46143,
                        "name": "Saint-Julien-en-Born",
                        "latitude": "44.06311000",
                        "longitude": "-1.22445000"
                    },
                    {
                        "id": 46149,
                        "name": "Saint-Junien",
                        "latitude": "45.88867000",
                        "longitude": "0.90143000"
                    },
                    {
                        "id": 46164,
                        "name": "Saint-Just-le-Martel",
                        "latitude": "45.86351000",
                        "longitude": "1.38829000"
                    },
                    {
                        "id": 46155,
                        "name": "Saint-Just-Luzac",
                        "latitude": "45.80000000",
                        "longitude": "-1.03333000"
                    },
                    {
                        "id": 46179,
                        "name": "Saint-Laurent-de-la-Prée",
                        "latitude": "45.98259000",
                        "longitude": "-1.03625000"
                    },
                    {
                        "id": 46188,
                        "name": "Saint-Laurent-sur-Gorre",
                        "latitude": "45.77052000",
                        "longitude": "0.95859000"
                    },
                    {
                        "id": 46210,
                        "name": "Saint-Léger-de-Montbrun",
                        "latitude": "47.00000000",
                        "longitude": "-0.13333000"
                    },
                    {
                        "id": 46220,
                        "name": "Saint-Léon-sur-l’Isle",
                        "latitude": "45.11491000",
                        "longitude": "0.50444000"
                    },
                    {
                        "id": 46224,
                        "name": "Saint-Léonard-de-Noblat",
                        "latitude": "45.83566000",
                        "longitude": "1.49174000"
                    },
                    {
                        "id": 46195,
                        "name": "Saint-Loubès",
                        "latitude": "44.91536000",
                        "longitude": "-0.42703000"
                    },
                    {
                        "id": 46198,
                        "name": "Saint-Louis-de-Montferrand",
                        "latitude": "44.95000000",
                        "longitude": "-0.53543000"
                    },
                    {
                        "id": 46226,
                        "name": "Saint-Macaire",
                        "latitude": "44.56527000",
                        "longitude": "-0.22431000"
                    },
                    {
                        "id": 46228,
                        "name": "Saint-Maixant",
                        "latitude": "44.57868000",
                        "longitude": "-0.25920000"
                    },
                    {
                        "id": 46253,
                        "name": "Saint-Mariens",
                        "latitude": "45.11631000",
                        "longitude": "-0.40084000"
                    },
                    {
                        "id": 46272,
                        "name": "Saint-Martin-de-Hinx",
                        "latitude": "43.58238000",
                        "longitude": "-1.26809000"
                    },
                    {
                        "id": 46277,
                        "name": "Saint-Martin-de-Ré",
                        "latitude": "46.20311000",
                        "longitude": "-1.36726000"
                    },
                    {
                        "id": 46278,
                        "name": "Saint-Martin-de-Seignanx",
                        "latitude": "43.54283000",
                        "longitude": "-1.38946000"
                    },
                    {
                        "id": 46262,
                        "name": "Saint-Martin-Lacaussade",
                        "latitude": "45.14631000",
                        "longitude": "-0.64310000"
                    },
                    {
                        "id": 46305,
                        "name": "Saint-Mathieu",
                        "latitude": "45.70674000",
                        "longitude": "0.75908000"
                    },
                    {
                        "id": 46317,
                        "name": "Saint-Maurice-la-Clouère",
                        "latitude": "46.37804000",
                        "longitude": "0.41253000"
                    },
                    {
                        "id": 46318,
                        "name": "Saint-Maurice-la-Souterraine",
                        "latitude": "46.21388000",
                        "longitude": "1.43130000"
                    },
                    {
                        "id": 46326,
                        "name": "Saint-Maxire",
                        "latitude": "46.39911000",
                        "longitude": "-0.47988000"
                    },
                    {
                        "id": 46349,
                        "name": "Saint-Médard-d’Eyrans",
                        "latitude": "44.71667000",
                        "longitude": "-0.51667000"
                    },
                    {
                        "id": 46347,
                        "name": "Saint-Médard-de-Guizières",
                        "latitude": "45.01667000",
                        "longitude": "-0.05000000"
                    },
                    {
                        "id": 46348,
                        "name": "Saint-Médard-de-Mussidan",
                        "latitude": "45.03333000",
                        "longitude": "0.35000000"
                    },
                    {
                        "id": 46350,
                        "name": "Saint-Médard-en-Jalles",
                        "latitude": "44.89692000",
                        "longitude": "-0.72136000"
                    },
                    {
                        "id": 46355,
                        "name": "Saint-Même-les-Carrières",
                        "latitude": "45.65000000",
                        "longitude": "-0.15000000"
                    },
                    {
                        "id": 46332,
                        "name": "Saint-Mexant",
                        "latitude": "45.28514000",
                        "longitude": "1.65799000"
                    },
                    {
                        "id": 46333,
                        "name": "Saint-Michel",
                        "latitude": "45.65000000",
                        "longitude": "0.10000000"
                    },
                    {
                        "id": 46346,
                        "name": "Saint-Morillon",
                        "latitude": "44.65060000",
                        "longitude": "-0.50322000"
                    },
                    {
                        "id": 46389,
                        "name": "Saint-Palais",
                        "latitude": "43.32867000",
                        "longitude": "-1.03333000"
                    },
                    {
                        "id": 46390,
                        "name": "Saint-Palais-sur-Mer",
                        "latitude": "45.64255000",
                        "longitude": "-1.08810000"
                    },
                    {
                        "id": 46391,
                        "name": "Saint-Pantaléon-de-Larche",
                        "latitude": "45.14122000",
                        "longitude": "1.44652000"
                    },
                    {
                        "id": 46392,
                        "name": "Saint-Pardoux",
                        "latitude": "46.57155000",
                        "longitude": "-0.30542000"
                    },
                    {
                        "id": 46393,
                        "name": "Saint-Pardoux-Isaac",
                        "latitude": "44.61190000",
                        "longitude": "0.37345000"
                    },
                    {
                        "id": 46394,
                        "name": "Saint-Pardoux-la-Rivière",
                        "latitude": "45.49388000",
                        "longitude": "0.74651000"
                    },
                    {
                        "id": 46403,
                        "name": "Saint-Paul",
                        "latitude": "45.75114000",
                        "longitude": "1.43238000"
                    },
                    {
                        "id": 46416,
                        "name": "Saint-Paul-lès-Dax",
                        "latitude": "43.72715000",
                        "longitude": "-1.05162000"
                    },
                    {
                        "id": 46481,
                        "name": "Saint-Pée-sur-Nivelle",
                        "latitude": "43.35564000",
                        "longitude": "-1.55013000"
                    },
                    {
                        "id": 46421,
                        "name": "Saint-Perdon",
                        "latitude": "43.86560000",
                        "longitude": "-0.59069000"
                    },
                    {
                        "id": 46444,
                        "name": "Saint-Pierre-d’Aurillac",
                        "latitude": "44.57168000",
                        "longitude": "-0.18922000"
                    },
                    {
                        "id": 46445,
                        "name": "Saint-Pierre-d’Oléron",
                        "latitude": "45.94430000",
                        "longitude": "-1.30630000"
                    },
                    {
                        "id": 46438,
                        "name": "Saint-Pierre-des-Échaubrognes",
                        "latitude": "46.98988000",
                        "longitude": "-0.74441000"
                    },
                    {
                        "id": 46440,
                        "name": "Saint-Pierre-du-Mont",
                        "latitude": "43.88453000",
                        "longitude": "-0.52185000"
                    },
                    {
                        "id": 46459,
                        "name": "Saint-Porchaire",
                        "latitude": "45.82075000",
                        "longitude": "-0.78235000"
                    },
                    {
                        "id": 46467,
                        "name": "Saint-Priest-sous-Aixe",
                        "latitude": "45.81667000",
                        "longitude": "1.10000000"
                    },
                    {
                        "id": 46465,
                        "name": "Saint-Priest-Taurion",
                        "latitude": "45.88686000",
                        "longitude": "1.40016000"
                    },
                    {
                        "id": 46469,
                        "name": "Saint-Privat",
                        "latitude": "45.13831000",
                        "longitude": "2.09902000"
                    },
                    {
                        "id": 46473,
                        "name": "Saint-Projet-Saint-Constant",
                        "latitude": "45.72802000",
                        "longitude": "0.33851000"
                    },
                    {
                        "id": 46487,
                        "name": "Saint-Quentin-de-Baron",
                        "latitude": "44.81802000",
                        "longitude": "-0.28636000"
                    },
                    {
                        "id": 46498,
                        "name": "Saint-Rogatien",
                        "latitude": "46.15000000",
                        "longitude": "-1.06963000"
                    },
                    {
                        "id": 46499,
                        "name": "Saint-Romain-de-Benet",
                        "latitude": "45.69150000",
                        "longitude": "-0.84765000"
                    },
                    {
                        "id": 46519,
                        "name": "Saint-Saturnin",
                        "latitude": "45.66667000",
                        "longitude": "0.05000000"
                    },
                    {
                        "id": 46526,
                        "name": "Saint-Sauvant",
                        "latitude": "46.35965000",
                        "longitude": "0.05634000"
                    },
                    {
                        "id": 46532,
                        "name": "Saint-Sauveur",
                        "latitude": "45.20272000",
                        "longitude": "-0.83433000"
                    },
                    {
                        "id": 46536,
                        "name": "Saint-Sauveur-d’Aunis",
                        "latitude": "46.21716000",
                        "longitude": "-0.88580000"
                    },
                    {
                        "id": 46541,
                        "name": "Saint-Savin",
                        "latitude": "45.15000000",
                        "longitude": "-0.45000000"
                    },
                    {
                        "id": 46542,
                        "name": "Saint-Savinien",
                        "latitude": "45.87711000",
                        "longitude": "-0.67919000"
                    },
                    {
                        "id": 46545,
                        "name": "Saint-Selve",
                        "latitude": "44.67095000",
                        "longitude": "-0.47887000"
                    },
                    {
                        "id": 46550,
                        "name": "Saint-Seurin-sur-l’Isle",
                        "latitude": "45.01667000",
                        "longitude": "0.00000000"
                    },
                    {
                        "id": 46551,
                        "name": "Saint-Sever",
                        "latitude": "43.75727000",
                        "longitude": "-0.57357000"
                    },
                    {
                        "id": 46560,
                        "name": "Saint-Sulpice-de-Cognac",
                        "latitude": "45.75978000",
                        "longitude": "-0.38093000"
                    },
                    {
                        "id": 46561,
                        "name": "Saint-Sulpice-de-Faleyrens",
                        "latitude": "44.86667000",
                        "longitude": "-0.18333000"
                    },
                    {
                        "id": 46563,
                        "name": "Saint-Sulpice-de-Royan",
                        "latitude": "45.67035000",
                        "longitude": "-1.01252000"
                    },
                    {
                        "id": 46564,
                        "name": "Saint-Sulpice-et-Cameyrac",
                        "latitude": "44.91131000",
                        "longitude": "-0.39048000"
                    },
                    {
                        "id": 46567,
                        "name": "Saint-Sulpice-le-Guérétois",
                        "latitude": "46.20097000",
                        "longitude": "1.82826000"
                    },
                    {
                        "id": 46568,
                        "name": "Saint-Sulpice-les-Feuilles",
                        "latitude": "46.31868000",
                        "longitude": "1.36792000"
                    },
                    {
                        "id": 46573,
                        "name": "Saint-Sylvestre-sur-Lot",
                        "latitude": "44.39667000",
                        "longitude": "0.80441000"
                    },
                    {
                        "id": 46574,
                        "name": "Saint-Symphorien",
                        "latitude": "46.26442000",
                        "longitude": "-0.49220000"
                    },
                    {
                        "id": 46587,
                        "name": "Saint-Trojan-les-Bains",
                        "latitude": "45.84134000",
                        "longitude": "-1.20728000"
                    },
                    {
                        "id": 46602,
                        "name": "Saint-Varent",
                        "latitude": "46.88934000",
                        "longitude": "-0.23210000"
                    },
                    {
                        "id": 46603,
                        "name": "Saint-Vaury",
                        "latitude": "46.20417000",
                        "longitude": "1.75654000"
                    },
                    {
                        "id": 46605,
                        "name": "Saint-Viance",
                        "latitude": "45.21760000",
                        "longitude": "1.45263000"
                    },
                    {
                        "id": 46611,
                        "name": "Saint-Victurnien",
                        "latitude": "45.87855000",
                        "longitude": "1.01376000"
                    },
                    {
                        "id": 46614,
                        "name": "Saint-Vincent-de-Paul",
                        "latitude": "43.74431000",
                        "longitude": "-1.00662000"
                    },
                    {
                        "id": 46615,
                        "name": "Saint-Vincent-de-Tyrosse",
                        "latitude": "43.66031000",
                        "longitude": "-1.30799000"
                    },
                    {
                        "id": 46620,
                        "name": "Saint-Vite",
                        "latitude": "44.47133000",
                        "longitude": "0.93876000"
                    },
                    {
                        "id": 46621,
                        "name": "Saint-Vivien-de-Médoc",
                        "latitude": "45.42695000",
                        "longitude": "-1.03377000"
                    },
                    {
                        "id": 46627,
                        "name": "Saint-Xandre",
                        "latitude": "46.20444000",
                        "longitude": "-1.10267000"
                    },
                    {
                        "id": 46630,
                        "name": "Saint-Yrieix-la-Perche",
                        "latitude": "45.51604000",
                        "longitude": "1.20569000"
                    },
                    {
                        "id": 46631,
                        "name": "Saint-Yrieix-sur-Charente",
                        "latitude": "45.68333000",
                        "longitude": "0.11667000"
                    },
                    {
                        "id": 46633,
                        "name": "Saint-Yzan-de-Soudiac",
                        "latitude": "45.14118000",
                        "longitude": "-0.41078000"
                    },
                    {
                        "id": 46666,
                        "name": "Sainte-Bazeille",
                        "latitude": "44.53073000",
                        "longitude": "0.09740000"
                    },
                    {
                        "id": 46670,
                        "name": "Sainte-Colombe-en-Bruilhois",
                        "latitude": "44.17822000",
                        "longitude": "0.51572000"
                    },
                    {
                        "id": 46676,
                        "name": "Sainte-Eulalie",
                        "latitude": "44.90667000",
                        "longitude": "-0.47417000"
                    },
                    {
                        "id": 46687,
                        "name": "Sainte-Féréole",
                        "latitude": "45.22932000",
                        "longitude": "1.58248000"
                    },
                    {
                        "id": 46678,
                        "name": "Sainte-Feyre",
                        "latitude": "46.13900000",
                        "longitude": "1.91517000"
                    },
                    {
                        "id": 46681,
                        "name": "Sainte-Fortunade",
                        "latitude": "45.20691000",
                        "longitude": "1.77117000"
                    },
                    {
                        "id": 46684,
                        "name": "Sainte-Foy-la-Grande",
                        "latitude": "44.83333000",
                        "longitude": "0.21667000"
                    },
                    {
                        "id": 46697,
                        "name": "Sainte-Hélène",
                        "latitude": "44.96667000",
                        "longitude": "-0.88333000"
                    },
                    {
                        "id": 46701,
                        "name": "Sainte-Livrade-sur-Lot",
                        "latitude": "44.39929000",
                        "longitude": "0.59120000"
                    },
                    {
                        "id": 46712,
                        "name": "Sainte-Marie-de-Gosse",
                        "latitude": "43.55000000",
                        "longitude": "-0.23333000"
                    },
                    {
                        "id": 46713,
                        "name": "Sainte-Marie-de-Ré",
                        "latitude": "46.15237000",
                        "longitude": "-1.31281000"
                    },
                    {
                        "id": 46723,
                        "name": "Sainte-Radegonde",
                        "latitude": "46.98333000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 46728,
                        "name": "Sainte-Soulle",
                        "latitude": "46.18847000",
                        "longitude": "-1.01607000"
                    },
                    {
                        "id": 46731,
                        "name": "Sainte-Terre",
                        "latitude": "44.83333000",
                        "longitude": "-0.11667000"
                    },
                    {
                        "id": 46733,
                        "name": "Sainte-Verge",
                        "latitude": "47.00818000",
                        "longitude": "-0.21033000"
                    },
                    {
                        "id": 46734,
                        "name": "Saintes",
                        "latitude": "45.74544000",
                        "longitude": "-0.63450000"
                    },
                    {
                        "id": 46738,
                        "name": "Saivres",
                        "latitude": "46.43262000",
                        "longitude": "-0.23677000"
                    },
                    {
                        "id": 46748,
                        "name": "Salies-de-Béarn",
                        "latitude": "43.47422000",
                        "longitude": "-0.92448000"
                    },
                    {
                        "id": 46750,
                        "name": "Salignac",
                        "latitude": "45.01607000",
                        "longitude": "-0.37964000"
                    },
                    {
                        "id": 46751,
                        "name": "Salignac-Eyvigues",
                        "latitude": "44.97464000",
                        "longitude": "1.32428000"
                    },
                    {
                        "id": 46759,
                        "name": "Sallebœuf",
                        "latitude": "44.83333000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 46761,
                        "name": "Salles",
                        "latitude": "44.55000000",
                        "longitude": "-0.86073000"
                    },
                    {
                        "id": 46764,
                        "name": "Salles-sur-Mer",
                        "latitude": "46.10543000",
                        "longitude": "-1.05741000"
                    },
                    {
                        "id": 46770,
                        "name": "Samadet",
                        "latitude": "43.63761000",
                        "longitude": "-0.48785000"
                    },
                    {
                        "id": 46788,
                        "name": "Sanguinet",
                        "latitude": "44.48320000",
                        "longitude": "-1.07457000"
                    },
                    {
                        "id": 46802,
                        "name": "Sarbazan",
                        "latitude": "44.02029000",
                        "longitude": "-0.31294000"
                    },
                    {
                        "id": 46804,
                        "name": "Sare",
                        "latitude": "43.31260000",
                        "longitude": "-1.58012000"
                    },
                    {
                        "id": 46808,
                        "name": "Sarlat-la-Canéda",
                        "latitude": "44.88902000",
                        "longitude": "1.21656000"
                    },
                    {
                        "id": 46832,
                        "name": "Saubion",
                        "latitude": "43.67140000",
                        "longitude": "-1.34821000"
                    },
                    {
                        "id": 46833,
                        "name": "Saubrigues",
                        "latitude": "43.60989000",
                        "longitude": "-1.31381000"
                    },
                    {
                        "id": 46834,
                        "name": "Saucats",
                        "latitude": "44.65405000",
                        "longitude": "-0.59643000"
                    },
                    {
                        "id": 46835,
                        "name": "Saugnac-et-Cambran",
                        "latitude": "43.67098000",
                        "longitude": "-0.99495000"
                    },
                    {
                        "id": 46837,
                        "name": "Saujon",
                        "latitude": "45.67309000",
                        "longitude": "-0.92620000"
                    },
                    {
                        "id": 46840,
                        "name": "Saulgé",
                        "latitude": "46.37758000",
                        "longitude": "0.87577000"
                    },
                    {
                        "id": 46858,
                        "name": "Sauvagnon",
                        "latitude": "43.40000000",
                        "longitude": "-0.38333000"
                    },
                    {
                        "id": 46862,
                        "name": "Sauveterre-de-Béarn",
                        "latitude": "43.40000000",
                        "longitude": "-0.93333000"
                    },
                    {
                        "id": 46863,
                        "name": "Sauveterre-de-Guyenne",
                        "latitude": "44.69300000",
                        "longitude": "-0.08549000"
                    },
                    {
                        "id": 46865,
                        "name": "Sauviat-sur-Vige",
                        "latitude": "45.90720000",
                        "longitude": "1.60827000"
                    },
                    {
                        "id": 46869,
                        "name": "Sauzé-Vaussais",
                        "latitude": "46.13369000",
                        "longitude": "0.10673000"
                    },
                    {
                        "id": 46884,
                        "name": "Savigné",
                        "latitude": "46.15950000",
                        "longitude": "0.31937000"
                    },
                    {
                        "id": 46877,
                        "name": "Savigny-Lévescault",
                        "latitude": "46.53502000",
                        "longitude": "0.47719000"
                    },
                    {
                        "id": 46907,
                        "name": "Scorbé-Clairvaux",
                        "latitude": "46.81061000",
                        "longitude": "0.41369000"
                    },
                    {
                        "id": 46912,
                        "name": "Secondigny",
                        "latitude": "46.61024000",
                        "longitude": "-0.41679000"
                    },
                    {
                        "id": 46914,
                        "name": "Segonzac",
                        "latitude": "45.61667000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 46919,
                        "name": "Seignosse",
                        "latitude": "43.68774000",
                        "longitude": "-1.37000000"
                    },
                    {
                        "id": 46922,
                        "name": "Seilhac",
                        "latitude": "45.36709000",
                        "longitude": "1.71350000"
                    },
                    {
                        "id": 46939,
                        "name": "Semussac",
                        "latitude": "45.60000000",
                        "longitude": "-0.91667000"
                    },
                    {
                        "id": 47141,
                        "name": "Séreilhac",
                        "latitude": "45.76843000",
                        "longitude": "1.08052000"
                    },
                    {
                        "id": 46967,
                        "name": "Serres-Castet",
                        "latitude": "43.38333000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 47131,
                        "name": "Sèvres-Anxaumont",
                        "latitude": "46.57036000",
                        "longitude": "0.46603000"
                    },
                    {
                        "id": 47006,
                        "name": "Sireuil",
                        "latitude": "45.61667000",
                        "longitude": "0.01667000"
                    },
                    {
                        "id": 47013,
                        "name": "Smarves",
                        "latitude": "46.51078000",
                        "longitude": "0.34980000"
                    },
                    {
                        "id": 47028,
                        "name": "Solignac",
                        "latitude": "45.75528000",
                        "longitude": "1.27563000"
                    },
                    {
                        "id": 47042,
                        "name": "Soorts-Hossegor",
                        "latitude": "43.66490000",
                        "longitude": "-1.39717000"
                    },
                    {
                        "id": 47045,
                        "name": "Sorges",
                        "latitude": "45.30563000",
                        "longitude": "0.87328000"
                    },
                    {
                        "id": 47056,
                        "name": "Soubise",
                        "latitude": "45.92395000",
                        "longitude": "-1.00938000"
                    },
                    {
                        "id": 47068,
                        "name": "Soulac-sur-Mer",
                        "latitude": "45.51068000",
                        "longitude": "-1.12524000"
                    },
                    {
                        "id": 47078,
                        "name": "Soumoulou",
                        "latitude": "43.26667000",
                        "longitude": "-0.18333000"
                    },
                    {
                        "id": 47080,
                        "name": "Souprosse",
                        "latitude": "43.78869000",
                        "longitude": "-0.71035000"
                    },
                    {
                        "id": 47081,
                        "name": "Souraïde",
                        "latitude": "43.34154000",
                        "longitude": "-1.47559000"
                    },
                    {
                        "id": 47086,
                        "name": "Sourzac",
                        "latitude": "45.04978000",
                        "longitude": "0.39598000"
                    },
                    {
                        "id": 47087,
                        "name": "Soussans",
                        "latitude": "45.05619000",
                        "longitude": "-0.69916000"
                    },
                    {
                        "id": 47088,
                        "name": "Soustons",
                        "latitude": "43.75328000",
                        "longitude": "-1.32780000"
                    },
                    {
                        "id": 47090,
                        "name": "Soyaux",
                        "latitude": "45.65000000",
                        "longitude": "0.20000000"
                    },
                    {
                        "id": 47121,
                        "name": "Surgères",
                        "latitude": "46.10820000",
                        "longitude": "-0.75148000"
                    },
                    {
                        "id": 47152,
                        "name": "Tabanac",
                        "latitude": "44.72059000",
                        "longitude": "-0.40513000"
                    },
                    {
                        "id": 47162,
                        "name": "Talence",
                        "latitude": "44.80477000",
                        "longitude": "-0.59543000"
                    },
                    {
                        "id": 47173,
                        "name": "Taponnat-Fleurignac",
                        "latitude": "45.77868000",
                        "longitude": "0.40932000"
                    },
                    {
                        "id": 47179,
                        "name": "Targon",
                        "latitude": "44.73495000",
                        "longitude": "-0.26351000"
                    },
                    {
                        "id": 47181,
                        "name": "Tarnos",
                        "latitude": "43.54170000",
                        "longitude": "-1.46281000"
                    },
                    {
                        "id": 47182,
                        "name": "Tartas",
                        "latitude": "43.83248000",
                        "longitude": "-0.80895000"
                    },
                    {
                        "id": 47188,
                        "name": "Tauriac",
                        "latitude": "45.04915000",
                        "longitude": "-0.50048000"
                    },
                    {
                        "id": 47206,
                        "name": "Tercé",
                        "latitude": "46.51667000",
                        "longitude": "0.56386000"
                    },
                    {
                        "id": 47205,
                        "name": "Tercis-les-Bains",
                        "latitude": "43.67048000",
                        "longitude": "-1.10738000"
                    },
                    {
                        "id": 47209,
                        "name": "Terrasson-Lavilledieu",
                        "latitude": "45.13011000",
                        "longitude": "1.30136000"
                    },
                    {
                        "id": 47216,
                        "name": "Thairé",
                        "latitude": "46.07341000",
                        "longitude": "-1.00230000"
                    },
                    {
                        "id": 47268,
                        "name": "Thénac",
                        "latitude": "45.66705000",
                        "longitude": "-0.65345000"
                    },
                    {
                        "id": 47269,
                        "name": "Thénezay",
                        "latitude": "46.71879000",
                        "longitude": "-0.02883000"
                    },
                    {
                        "id": 47223,
                        "name": "Thenon",
                        "latitude": "45.13897000",
                        "longitude": "1.07211000"
                    },
                    {
                        "id": 47241,
                        "name": "Thiviers",
                        "latitude": "45.41542000",
                        "longitude": "0.91963000"
                    },
                    {
                        "id": 47251,
                        "name": "Thorigné",
                        "latitude": "46.29149000",
                        "longitude": "-0.25122000"
                    },
                    {
                        "id": 47254,
                        "name": "Thouars",
                        "latitude": "46.97602000",
                        "longitude": "-0.21507000"
                    },
                    {
                        "id": 47264,
                        "name": "Thuré",
                        "latitude": "46.83221000",
                        "longitude": "0.45797000"
                    },
                    {
                        "id": 47291,
                        "name": "Tocane-Saint-Apre",
                        "latitude": "45.25404000",
                        "longitude": "0.49682000"
                    },
                    {
                        "id": 47294,
                        "name": "Tonnay-Boutonne",
                        "latitude": "45.96815000",
                        "longitude": "-0.70847000"
                    },
                    {
                        "id": 47295,
                        "name": "Tonnay-Charente",
                        "latitude": "45.94900000",
                        "longitude": "-0.89350000"
                    },
                    {
                        "id": 47296,
                        "name": "Tonneins",
                        "latitude": "44.39206000",
                        "longitude": "0.31241000"
                    },
                    {
                        "id": 47305,
                        "name": "Tosse",
                        "latitude": "43.68916000",
                        "longitude": "-1.33262000"
                    },
                    {
                        "id": 47311,
                        "name": "Toulenne",
                        "latitude": "44.55665000",
                        "longitude": "-0.26328000"
                    },
                    {
                        "id": 47344,
                        "name": "Touvre",
                        "latitude": "45.66667000",
                        "longitude": "0.25000000"
                    },
                    {
                        "id": 47354,
                        "name": "Treignac",
                        "latitude": "45.53696000",
                        "longitude": "1.79520000"
                    },
                    {
                        "id": 47397,
                        "name": "Trélissac",
                        "latitude": "45.19766000",
                        "longitude": "0.78615000"
                    },
                    {
                        "id": 47364,
                        "name": "Tresses",
                        "latitude": "44.84781000",
                        "longitude": "-0.46296000"
                    },
                    {
                        "id": 47377,
                        "name": "Trizay",
                        "latitude": "45.88276000",
                        "longitude": "-0.89697000"
                    },
                    {
                        "id": 47413,
                        "name": "Tulle",
                        "latitude": "45.26582000",
                        "longitude": "1.77233000"
                    },
                    {
                        "id": 47430,
                        "name": "Urcuit",
                        "latitude": "43.48594000",
                        "longitude": "-1.33668000"
                    },
                    {
                        "id": 47433,
                        "name": "Urrugne",
                        "latitude": "43.36361000",
                        "longitude": "-1.69921000"
                    },
                    {
                        "id": 47434,
                        "name": "Urt",
                        "latitude": "43.49009000",
                        "longitude": "-1.29744000"
                    },
                    {
                        "id": 47438,
                        "name": "Ussac",
                        "latitude": "45.19389000",
                        "longitude": "1.51337000"
                    },
                    {
                        "id": 47439,
                        "name": "Ussel",
                        "latitude": "45.54804000",
                        "longitude": "2.30917000"
                    },
                    {
                        "id": 47440,
                        "name": "Usson-du-Poitou",
                        "latitude": "46.27782000",
                        "longitude": "0.52816000"
                    },
                    {
                        "id": 47442,
                        "name": "Ustaritz",
                        "latitude": "43.39650000",
                        "longitude": "-1.45603000"
                    },
                    {
                        "id": 47445,
                        "name": "Uzein",
                        "latitude": "43.40000000",
                        "longitude": "-0.43333000"
                    },
                    {
                        "id": 47447,
                        "name": "Uzerche",
                        "latitude": "45.42462000",
                        "longitude": "1.56341000"
                    },
                    {
                        "id": 47517,
                        "name": "Varetz",
                        "latitude": "45.19392000",
                        "longitude": "1.45063000"
                    },
                    {
                        "id": 47522,
                        "name": "Vars",
                        "latitude": "45.76256000",
                        "longitude": "0.12478000"
                    },
                    {
                        "id": 47524,
                        "name": "Vasles",
                        "latitude": "46.57618000",
                        "longitude": "-0.02638000"
                    },
                    {
                        "id": 47547,
                        "name": "Vaux-sur-Mer",
                        "latitude": "45.64606000",
                        "longitude": "-1.05841000"
                    },
                    {
                        "id": 47551,
                        "name": "Vayres",
                        "latitude": "44.90000000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 47923,
                        "name": "Vélines",
                        "latitude": "44.85000000",
                        "longitude": "0.11667000"
                    },
                    {
                        "id": 47568,
                        "name": "Vendays-Montalivet",
                        "latitude": "45.35492000",
                        "longitude": "-1.06088000"
                    },
                    {
                        "id": 47571,
                        "name": "Vendeuvre-du-Poitou",
                        "latitude": "46.73579000",
                        "longitude": "0.30996000"
                    },
                    {
                        "id": 47600,
                        "name": "Vergt",
                        "latitude": "45.02695000",
                        "longitude": "0.71820000"
                    },
                    {
                        "id": 47929,
                        "name": "Vérines",
                        "latitude": "46.19372000",
                        "longitude": "-0.96683000"
                    },
                    {
                        "id": 47615,
                        "name": "Verneuil-sur-Vienne",
                        "latitude": "45.85524000",
                        "longitude": "1.10133000"
                    },
                    {
                        "id": 47640,
                        "name": "Vertheuil",
                        "latitude": "45.25000000",
                        "longitude": "-0.83333000"
                    },
                    {
                        "id": 47653,
                        "name": "Veyrac",
                        "latitude": "45.89521000",
                        "longitude": "1.10500000"
                    },
                    {
                        "id": 47659,
                        "name": "Vianne",
                        "latitude": "44.19658000",
                        "longitude": "0.32104000"
                    },
                    {
                        "id": 47672,
                        "name": "Vicq-sur-Breuilh",
                        "latitude": "45.64661000",
                        "longitude": "1.38179000"
                    },
                    {
                        "id": 47679,
                        "name": "Vielle-Saint-Girons",
                        "latitude": "43.95000000",
                        "longitude": "-1.30000000"
                    },
                    {
                        "id": 47681,
                        "name": "Viennay",
                        "latitude": "46.68711000",
                        "longitude": "-0.24641000"
                    },
                    {
                        "id": 47683,
                        "name": "Vienne",
                        "latitude": "46.53528000",
                        "longitude": "0.45201000"
                    },
                    {
                        "id": 47688,
                        "name": "Vieux-Boucau-les-Bains",
                        "latitude": "43.78947000",
                        "longitude": "-1.39957000"
                    },
                    {
                        "id": 47693,
                        "name": "Vigeois",
                        "latitude": "45.37934000",
                        "longitude": "1.51731000"
                    },
                    {
                        "id": 47733,
                        "name": "Villefagnan",
                        "latitude": "46.01140000",
                        "longitude": "0.07936000"
                    },
                    {
                        "id": 47742,
                        "name": "Villefranque",
                        "latitude": "43.43631000",
                        "longitude": "-1.45324000"
                    },
                    {
                        "id": 47744,
                        "name": "Villegouge",
                        "latitude": "44.96667000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 47758,
                        "name": "Villenave-d’Ornon",
                        "latitude": "44.77327000",
                        "longitude": "-0.54420000"
                    },
                    {
                        "id": 47768,
                        "name": "Villeneuve-de-Marsan",
                        "latitude": "43.88906000",
                        "longitude": "-0.30926000"
                    },
                    {
                        "id": 47784,
                        "name": "Villeneuve-sur-Lot",
                        "latitude": "44.40854000",
                        "longitude": "0.70415000"
                    },
                    {
                        "id": 47813,
                        "name": "Villeréal",
                        "latitude": "44.63631000",
                        "longitude": "0.74326000"
                    },
                    {
                        "id": 47828,
                        "name": "Villiers-en-Plaine",
                        "latitude": "46.40895000",
                        "longitude": "-0.53756000"
                    },
                    {
                        "id": 47856,
                        "name": "Virazeil",
                        "latitude": "44.50705000",
                        "longitude": "0.22177000"
                    },
                    {
                        "id": 47886,
                        "name": "Vivonne",
                        "latitude": "46.42953000",
                        "longitude": "0.26443000"
                    },
                    {
                        "id": 47934,
                        "name": "Vœuil-et-Giget",
                        "latitude": "45.58333000",
                        "longitude": "0.15000000"
                    },
                    {
                        "id": 47906,
                        "name": "Vouillé",
                        "latitude": "46.64011000",
                        "longitude": "0.16778000"
                    },
                    {
                        "id": 47910,
                        "name": "Vouneuil-sous-Biard",
                        "latitude": "46.57387000",
                        "longitude": "0.26988000"
                    },
                    {
                        "id": 47911,
                        "name": "Vouneuil-sur-Vienne",
                        "latitude": "46.71793000",
                        "longitude": "0.53936000"
                    },
                    {
                        "id": 47914,
                        "name": "Voutezac",
                        "latitude": "45.29214000",
                        "longitude": "1.43721000"
                    },
                    {
                        "id": 48001,
                        "name": "Ychoux",
                        "latitude": "44.32869000",
                        "longitude": "-0.95179000"
                    },
                    {
                        "id": 48007,
                        "name": "Ygos-Saint-Saturnin",
                        "latitude": "43.97651000",
                        "longitude": "-0.73780000"
                    },
                    {
                        "id": 48015,
                        "name": "Yves",
                        "latitude": "46.01922000",
                        "longitude": "-1.04833000"
                    },
                    {
                        "id": 48018,
                        "name": "Yvrac",
                        "latitude": "44.87786000",
                        "longitude": "-0.45870000"
                    }
                ]
            },
            {
                "id": 4799,
                "name": "Occitanie",
                "iso2": "OCC",
                "latitude": "43.89272320",
                "longitude": "3.28276250",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39236,
                        "name": "Abeilhan",
                        "latitude": "43.44925000",
                        "longitude": "3.29529000"
                    },
                    {
                        "id": 39257,
                        "name": "Agde",
                        "latitude": "43.31083000",
                        "longitude": "3.47583000"
                    },
                    {
                        "id": 39274,
                        "name": "Aiguefonde",
                        "latitude": "43.49394000",
                        "longitude": "2.31686000"
                    },
                    {
                        "id": 39276,
                        "name": "Aigues-Mortes",
                        "latitude": "43.56683000",
                        "longitude": "4.19068000"
                    },
                    {
                        "id": 39277,
                        "name": "Aigues-Vives",
                        "latitude": "43.73790000",
                        "longitude": "4.18066000"
                    },
                    {
                        "id": 39284,
                        "name": "Aimargues",
                        "latitude": "43.68448000",
                        "longitude": "4.20999000"
                    },
                    {
                        "id": 39305,
                        "name": "Albi",
                        "latitude": "43.92980000",
                        "longitude": "2.14800000"
                    },
                    {
                        "id": 39306,
                        "name": "Albias",
                        "latitude": "44.09049000",
                        "longitude": "1.44821000"
                    },
                    {
                        "id": 39342,
                        "name": "Alénya",
                        "latitude": "42.63875000",
                        "longitude": "2.98148000"
                    },
                    {
                        "id": 39341,
                        "name": "Alès",
                        "latitude": "44.12489000",
                        "longitude": "4.08082000"
                    },
                    {
                        "id": 39314,
                        "name": "Alignan-du-Vent",
                        "latitude": "43.46945000",
                        "longitude": "3.34165000"
                    },
                    {
                        "id": 39340,
                        "name": "Alzonne",
                        "latitude": "43.25338000",
                        "longitude": "2.17808000"
                    },
                    {
                        "id": 39388,
                        "name": "Andrest",
                        "latitude": "43.31998000",
                        "longitude": "0.06405000"
                    },
                    {
                        "id": 39392,
                        "name": "Anduze",
                        "latitude": "44.05409000",
                        "longitude": "3.98545000"
                    },
                    {
                        "id": 39410,
                        "name": "Aniane",
                        "latitude": "43.68448000",
                        "longitude": "3.58747000"
                    },
                    {
                        "id": 39447,
                        "name": "Aramon",
                        "latitude": "43.89174000",
                        "longitude": "4.68096000"
                    },
                    {
                        "id": 39474,
                        "name": "Argelers",
                        "latitude": "42.54714000",
                        "longitude": "3.02253000"
                    },
                    {
                        "id": 39476,
                        "name": "Argelès-Gazost",
                        "latitude": "43.00258000",
                        "longitude": "-0.09855000"
                    },
                    {
                        "id": 39475,
                        "name": "Argeliers",
                        "latitude": "43.31217000",
                        "longitude": "2.91046000"
                    },
                    {
                        "id": 39488,
                        "name": "Arles",
                        "latitude": "42.45654000",
                        "longitude": "2.63457000"
                    },
                    {
                        "id": 39495,
                        "name": "Armissan",
                        "latitude": "43.18778000",
                        "longitude": "3.09660000"
                    },
                    {
                        "id": 39526,
                        "name": "Arthès",
                        "latitude": "43.95745000",
                        "longitude": "2.21130000"
                    },
                    {
                        "id": 39535,
                        "name": "Arzens",
                        "latitude": "43.19838000",
                        "longitude": "2.20954000"
                    },
                    {
                        "id": 39548,
                        "name": "Aspet",
                        "latitude": "43.01457000",
                        "longitude": "0.80294000"
                    },
                    {
                        "id": 39549,
                        "name": "Aspiran",
                        "latitude": "43.56586000",
                        "longitude": "3.45031000"
                    },
                    {
                        "id": 39551,
                        "name": "Assas",
                        "latitude": "43.70278000",
                        "longitude": "3.90000000"
                    },
                    {
                        "id": 39567,
                        "name": "Aubais",
                        "latitude": "43.75402000",
                        "longitude": "4.14567000"
                    },
                    {
                        "id": 39577,
                        "name": "Aubiet",
                        "latitude": "43.64631000",
                        "longitude": "0.78441000"
                    },
                    {
                        "id": 39584,
                        "name": "Aubin",
                        "latitude": "44.52809000",
                        "longitude": "2.24439000"
                    },
                    {
                        "id": 39586,
                        "name": "Aubord",
                        "latitude": "43.75827000",
                        "longitude": "4.31105000"
                    },
                    {
                        "id": 39591,
                        "name": "Aucamville",
                        "latitude": "43.67020000",
                        "longitude": "1.42808000"
                    },
                    {
                        "id": 39592,
                        "name": "Auch",
                        "latitude": "43.64540000",
                        "longitude": "0.58793000"
                    },
                    {
                        "id": 39617,
                        "name": "Aumont-Aubrac",
                        "latitude": "44.72205000",
                        "longitude": "3.28466000"
                    },
                    {
                        "id": 39625,
                        "name": "Aureilhan",
                        "latitude": "43.24337000",
                        "longitude": "0.09581000"
                    },
                    {
                        "id": 39627,
                        "name": "Auriac-sur-Vendinelle",
                        "latitude": "43.52416000",
                        "longitude": "1.82640000"
                    },
                    {
                        "id": 39629,
                        "name": "Aurignac",
                        "latitude": "43.21695000",
                        "longitude": "0.88176000"
                    },
                    {
                        "id": 39632,
                        "name": "Aussillon",
                        "latitude": "43.50293000",
                        "longitude": "2.36791000"
                    },
                    {
                        "id": 39633,
                        "name": "Aussonne",
                        "latitude": "43.68162000",
                        "longitude": "1.31886000"
                    },
                    {
                        "id": 39634,
                        "name": "Auterive",
                        "latitude": "43.35103000",
                        "longitude": "1.47797000"
                    },
                    {
                        "id": 39643,
                        "name": "Auvillar",
                        "latitude": "44.06863000",
                        "longitude": "0.90192000"
                    },
                    {
                        "id": 39652,
                        "name": "Auzeville-Tolosane",
                        "latitude": "43.52777000",
                        "longitude": "1.48240000"
                    },
                    {
                        "id": 39653,
                        "name": "Auzielle",
                        "latitude": "43.54165000",
                        "longitude": "1.56574000"
                    },
                    {
                        "id": 39681,
                        "name": "Avèze",
                        "latitude": "43.97116000",
                        "longitude": "3.60097000"
                    },
                    {
                        "id": 39670,
                        "name": "Avignonet-Lauragais",
                        "latitude": "43.36667000",
                        "longitude": "1.80000000"
                    },
                    {
                        "id": 39682,
                        "name": "Ax-les-Thermes",
                        "latitude": "42.71968000",
                        "longitude": "1.83845000"
                    },
                    {
                        "id": 39688,
                        "name": "Ayguesvives",
                        "latitude": "43.43636000",
                        "longitude": "1.59505000"
                    },
                    {
                        "id": 39696,
                        "name": "Azille",
                        "latitude": "43.27691000",
                        "longitude": "2.65981000"
                    },
                    {
                        "id": 39705,
                        "name": "Bagard",
                        "latitude": "44.07126000",
                        "longitude": "4.05225000"
                    },
                    {
                        "id": 39706,
                        "name": "Bages",
                        "latitude": "42.60588000",
                        "longitude": "2.89350000"
                    },
                    {
                        "id": 39707,
                        "name": "Bagnac-sur-Célé",
                        "latitude": "44.66667000",
                        "longitude": "2.16667000"
                    },
                    {
                        "id": 39714,
                        "name": "Bagnères-de-Bigorre",
                        "latitude": "43.06416000",
                        "longitude": "0.14970000"
                    },
                    {
                        "id": 39715,
                        "name": "Bagnères-de-Luchon",
                        "latitude": "42.79079000",
                        "longitude": "0.59315000"
                    },
                    {
                        "id": 39713,
                        "name": "Bagnols-sur-Cèze",
                        "latitude": "44.15990000",
                        "longitude": "4.61776000"
                    },
                    {
                        "id": 39718,
                        "name": "Baho",
                        "latitude": "42.70000000",
                        "longitude": "2.82204000"
                    },
                    {
                        "id": 39720,
                        "name": "Baillargues",
                        "latitude": "43.66267000",
                        "longitude": "4.01681000"
                    },
                    {
                        "id": 39741,
                        "name": "Baixas",
                        "latitude": "42.74969000",
                        "longitude": "2.81002000"
                    },
                    {
                        "id": 39745,
                        "name": "Balaruc-le-Vieux",
                        "latitude": "43.46140000",
                        "longitude": "3.68530000"
                    },
                    {
                        "id": 39746,
                        "name": "Balaruc-les-Bains",
                        "latitude": "43.44170000",
                        "longitude": "3.67780000"
                    },
                    {
                        "id": 39756,
                        "name": "Balma",
                        "latitude": "43.61111000",
                        "longitude": "1.49944000"
                    },
                    {
                        "id": 39762,
                        "name": "Banyuls de la Marenda",
                        "latitude": "42.48375000",
                        "longitude": "3.12897000"
                    },
                    {
                        "id": 39763,
                        "name": "Banyuls-dels-Aspres",
                        "latitude": "42.56567000",
                        "longitude": "2.86667000"
                    },
                    {
                        "id": 39768,
                        "name": "Baraqueville",
                        "latitude": "44.27655000",
                        "longitude": "2.43184000"
                    },
                    {
                        "id": 39770,
                        "name": "Barbazan-Debat",
                        "latitude": "43.19580000",
                        "longitude": "0.12060000"
                    },
                    {
                        "id": 39778,
                        "name": "Barcelonne-du-Gers",
                        "latitude": "43.70360000",
                        "longitude": "-0.23619000"
                    },
                    {
                        "id": 39784,
                        "name": "Barjac",
                        "latitude": "44.30743000",
                        "longitude": "4.35146000"
                    },
                    {
                        "id": 39797,
                        "name": "Bassan",
                        "latitude": "43.41060000",
                        "longitude": "3.25396000"
                    },
                    {
                        "id": 39830,
                        "name": "Bazet",
                        "latitude": "43.29145000",
                        "longitude": "0.06728000"
                    },
                    {
                        "id": 39831,
                        "name": "Baziège",
                        "latitude": "43.45454000",
                        "longitude": "1.61399000"
                    },
                    {
                        "id": 39836,
                        "name": "Beaucaire",
                        "latitude": "43.80806000",
                        "longitude": "4.64417000"
                    },
                    {
                        "id": 39850,
                        "name": "Beaulieu",
                        "latitude": "43.72861000",
                        "longitude": "4.02194000"
                    },
                    {
                        "id": 39863,
                        "name": "Beaumont-de-Lomagne",
                        "latitude": "43.88285000",
                        "longitude": "0.98762000"
                    },
                    {
                        "id": 39871,
                        "name": "Beaumont-sur-Lèze",
                        "latitude": "43.38095000",
                        "longitude": "1.35826000"
                    },
                    {
                        "id": 39878,
                        "name": "Beaupuy",
                        "latitude": "43.64713000",
                        "longitude": "1.55517000"
                    },
                    {
                        "id": 39896,
                        "name": "Beauvoisin",
                        "latitude": "43.71835000",
                        "longitude": "4.32339000"
                    },
                    {
                        "id": 39898,
                        "name": "Beauzelle",
                        "latitude": "43.66713000",
                        "longitude": "1.37518000"
                    },
                    {
                        "id": 40412,
                        "name": "Bédarieux",
                        "latitude": "43.61553000",
                        "longitude": "3.15714000"
                    },
                    {
                        "id": 39901,
                        "name": "Belberaud",
                        "latitude": "43.50557000",
                        "longitude": "1.56725000"
                    },
                    {
                        "id": 40420,
                        "name": "Bélesta",
                        "latitude": "42.90228000",
                        "longitude": "1.93325000"
                    },
                    {
                        "id": 39913,
                        "name": "Bellegarde",
                        "latitude": "43.75329000",
                        "longitude": "4.51654000"
                    },
                    {
                        "id": 39933,
                        "name": "Belmont-sur-Rance",
                        "latitude": "43.81981000",
                        "longitude": "2.75524000"
                    },
                    {
                        "id": 39934,
                        "name": "Belpech",
                        "latitude": "43.19957000",
                        "longitude": "1.75157000"
                    },
                    {
                        "id": 40428,
                        "name": "Bérat",
                        "latitude": "43.37857000",
                        "longitude": "1.17572000"
                    },
                    {
                        "id": 39956,
                        "name": "Bernis",
                        "latitude": "43.76913000",
                        "longitude": "4.28713000"
                    },
                    {
                        "id": 39973,
                        "name": "Bessan",
                        "latitude": "43.36196000",
                        "longitude": "3.42288000"
                    },
                    {
                        "id": 39982,
                        "name": "Bessèges",
                        "latitude": "44.29230000",
                        "longitude": "4.09661000"
                    },
                    {
                        "id": 39981,
                        "name": "Bessières",
                        "latitude": "43.79861000",
                        "longitude": "1.60624000"
                    },
                    {
                        "id": 40436,
                        "name": "Béziers",
                        "latitude": "43.34122000",
                        "longitude": "3.21402000"
                    },
                    {
                        "id": 40003,
                        "name": "Bezouce",
                        "latitude": "43.88229000",
                        "longitude": "4.49072000"
                    },
                    {
                        "id": 40007,
                        "name": "Biars-sur-Cère",
                        "latitude": "44.92629000",
                        "longitude": "1.85403000"
                    },
                    {
                        "id": 40037,
                        "name": "Bizanet",
                        "latitude": "43.16419000",
                        "longitude": "2.87034000"
                    },
                    {
                        "id": 40039,
                        "name": "Bize-Minervois",
                        "latitude": "43.31656000",
                        "longitude": "2.87134000"
                    },
                    {
                        "id": 40044,
                        "name": "Blagnac",
                        "latitude": "43.63276000",
                        "longitude": "1.39399000"
                    },
                    {
                        "id": 40060,
                        "name": "Blauzac",
                        "latitude": "43.96151000",
                        "longitude": "4.36930000"
                    },
                    {
                        "id": 40063,
                        "name": "Blaye-les-Mines",
                        "latitude": "44.03073000",
                        "longitude": "2.13166000"
                    },
                    {
                        "id": 40094,
                        "name": "Boisseron",
                        "latitude": "43.75795000",
                        "longitude": "4.07970000"
                    },
                    {
                        "id": 40095,
                        "name": "Boisset-et-Gaujac",
                        "latitude": "44.04749000",
                        "longitude": "4.00861000"
                    },
                    {
                        "id": 40107,
                        "name": "Bompas",
                        "latitude": "42.73333000",
                        "longitude": "2.93333000"
                    },
                    {
                        "id": 40157,
                        "name": "Bouillargues",
                        "latitude": "43.79733000",
                        "longitude": "4.42853000"
                    },
                    {
                        "id": 40161,
                        "name": "Boujan-sur-Libron",
                        "latitude": "43.36996000",
                        "longitude": "3.24759000"
                    },
                    {
                        "id": 40171,
                        "name": "Bouloc",
                        "latitude": "43.78163000",
                        "longitude": "1.40522000"
                    },
                    {
                        "id": 40173,
                        "name": "Boulogne-sur-Gesse",
                        "latitude": "43.30000000",
                        "longitude": "0.65000000"
                    },
                    {
                        "id": 40222,
                        "name": "Bout-du-Pont-de-Larn",
                        "latitude": "43.49738000",
                        "longitude": "2.41642000"
                    },
                    {
                        "id": 40234,
                        "name": "Bouzigues",
                        "latitude": "43.44810000",
                        "longitude": "3.65781000"
                    },
                    {
                        "id": 40243,
                        "name": "Bozouls",
                        "latitude": "44.47050000",
                        "longitude": "2.72432000"
                    },
                    {
                        "id": 40251,
                        "name": "Bram",
                        "latitude": "43.24376000",
                        "longitude": "2.11341000"
                    },
                    {
                        "id": 40256,
                        "name": "Branoux-les-Taillades",
                        "latitude": "44.21941000",
                        "longitude": "3.99647000"
                    },
                    {
                        "id": 40261,
                        "name": "Brassac",
                        "latitude": "43.62959000",
                        "longitude": "2.49763000"
                    },
                    {
                        "id": 40264,
                        "name": "Brax",
                        "latitude": "43.61793000",
                        "longitude": "1.23957000"
                    },
                    {
                        "id": 40275,
                        "name": "Brens",
                        "latitude": "43.88725000",
                        "longitude": "1.90716000"
                    },
                    {
                        "id": 40277,
                        "name": "Bressols",
                        "latitude": "43.96796000",
                        "longitude": "1.33839000"
                    },
                    {
                        "id": 40281,
                        "name": "Bretenoux",
                        "latitude": "44.91468000",
                        "longitude": "1.84007000"
                    },
                    {
                        "id": 40302,
                        "name": "Briatexte",
                        "latitude": "43.75237000",
                        "longitude": "1.90879000"
                    },
                    {
                        "id": 40342,
                        "name": "Bruguières",
                        "latitude": "43.72720000",
                        "longitude": "1.40762000"
                    },
                    {
                        "id": 40388,
                        "name": "Burlats",
                        "latitude": "43.63633000",
                        "longitude": "2.31879000"
                    },
                    {
                        "id": 40408,
                        "name": "Buzet-sur-Tarn",
                        "latitude": "43.77977000",
                        "longitude": "1.63301000"
                    },
                    {
                        "id": 40444,
                        "name": "Cabestany",
                        "latitude": "42.68132000",
                        "longitude": "2.94122000"
                    },
                    {
                        "id": 40447,
                        "name": "Cabrières",
                        "latitude": "43.90389000",
                        "longitude": "4.47094000"
                    },
                    {
                        "id": 40450,
                        "name": "Cadalen",
                        "latitude": "43.84933000",
                        "longitude": "1.98089000"
                    },
                    {
                        "id": 40458,
                        "name": "Cagnac-les-Mines",
                        "latitude": "43.98445000",
                        "longitude": "2.14227000"
                    },
                    {
                        "id": 40463,
                        "name": "Cahors",
                        "latitude": "44.44910000",
                        "longitude": "1.43663000"
                    },
                    {
                        "id": 40464,
                        "name": "Cahuzac-sur-Vère",
                        "latitude": "43.98268000",
                        "longitude": "1.91052000"
                    },
                    {
                        "id": 40467,
                        "name": "Caissargues",
                        "latitude": "43.79509000",
                        "longitude": "4.37955000"
                    },
                    {
                        "id": 40468,
                        "name": "Cajarc",
                        "latitude": "44.48546000",
                        "longitude": "1.84261000"
                    },
                    {
                        "id": 40474,
                        "name": "Calmont",
                        "latitude": "43.28718000",
                        "longitude": "1.63031000"
                    },
                    {
                        "id": 40480,
                        "name": "Calvisson",
                        "latitude": "43.78696000",
                        "longitude": "4.19626000"
                    },
                    {
                        "id": 40483,
                        "name": "Camarès",
                        "latitude": "43.82208000",
                        "longitude": "2.88005000"
                    },
                    {
                        "id": 40497,
                        "name": "Campan",
                        "latitude": "43.01587000",
                        "longitude": "0.17846000"
                    },
                    {
                        "id": 40502,
                        "name": "Campsas",
                        "latitude": "43.89591000",
                        "longitude": "1.32677000"
                    },
                    {
                        "id": 40506,
                        "name": "Candillargues",
                        "latitude": "43.62052000",
                        "longitude": "4.06924000"
                    },
                    {
                        "id": 40509,
                        "name": "Canet",
                        "latitude": "43.22744000",
                        "longitude": "2.84800000"
                    },
                    {
                        "id": 40510,
                        "name": "Canet-en-Roussillon",
                        "latitude": "42.70000000",
                        "longitude": "3.01667000"
                    },
                    {
                        "id": 40514,
                        "name": "Canohès",
                        "latitude": "42.65461000",
                        "longitude": "2.83633000"
                    },
                    {
                        "id": 40526,
                        "name": "Capdenac-Gare",
                        "latitude": "44.57567000",
                        "longitude": "2.08079000"
                    },
                    {
                        "id": 40527,
                        "name": "Capendu",
                        "latitude": "43.18596000",
                        "longitude": "2.55677000"
                    },
                    {
                        "id": 40528,
                        "name": "Capestang",
                        "latitude": "43.32791000",
                        "longitude": "3.04447000"
                    },
                    {
                        "id": 40533,
                        "name": "Capvern",
                        "latitude": "43.10357000",
                        "longitude": "0.31604000"
                    },
                    {
                        "id": 40534,
                        "name": "Caraman",
                        "latitude": "43.53271000",
                        "longitude": "1.76002000"
                    },
                    {
                        "id": 40537,
                        "name": "Carbonne",
                        "latitude": "43.29857000",
                        "longitude": "1.22520000"
                    },
                    {
                        "id": 40539,
                        "name": "Carcassonne",
                        "latitude": "43.21351000",
                        "longitude": "2.35162000"
                    },
                    {
                        "id": 40549,
                        "name": "Carmaux",
                        "latitude": "44.05099000",
                        "longitude": "2.15795000"
                    },
                    {
                        "id": 40568,
                        "name": "Cassagnes-Bégonhès",
                        "latitude": "44.16893000",
                        "longitude": "2.53084000"
                    },
                    {
                        "id": 40575,
                        "name": "Castanet-Tolosan",
                        "latitude": "43.51591000",
                        "longitude": "1.49864000"
                    },
                    {
                        "id": 40577,
                        "name": "Castelginest",
                        "latitude": "43.69382000",
                        "longitude": "1.43440000"
                    },
                    {
                        "id": 40580,
                        "name": "Castelmaurou",
                        "latitude": "43.67778000",
                        "longitude": "1.53222000"
                    },
                    {
                        "id": 40583,
                        "name": "Castelnau-d'Estrétefonds",
                        "latitude": "43.78367000",
                        "longitude": "1.35904000"
                    },
                    {
                        "id": 40584,
                        "name": "Castelnau-de-Guers",
                        "latitude": "43.43398000",
                        "longitude": "3.43708000"
                    },
                    {
                        "id": 40585,
                        "name": "Castelnau-de-Lévis",
                        "latitude": "43.93975000",
                        "longitude": "2.08491000"
                    },
                    {
                        "id": 40587,
                        "name": "Castelnau-le-Lez",
                        "latitude": "43.63333000",
                        "longitude": "3.90000000"
                    },
                    {
                        "id": 40582,
                        "name": "Castelnau-Montratier",
                        "latitude": "44.26667000",
                        "longitude": "1.36667000"
                    },
                    {
                        "id": 40588,
                        "name": "Castelnaudary",
                        "latitude": "43.31829000",
                        "longitude": "1.95449000"
                    },
                    {
                        "id": 40589,
                        "name": "Castelsarrasin",
                        "latitude": "44.04022000",
                        "longitude": "1.10702000"
                    },
                    {
                        "id": 40592,
                        "name": "Castillon-du-Gard",
                        "latitude": "43.96457000",
                        "longitude": "4.55337000"
                    },
                    {
                        "id": 40595,
                        "name": "Castres",
                        "latitude": "43.60589000",
                        "longitude": "2.23992000"
                    },
                    {
                        "id": 40597,
                        "name": "Castries",
                        "latitude": "43.67972000",
                        "longitude": "3.98222000"
                    },
                    {
                        "id": 40610,
                        "name": "Caunes-Minervois",
                        "latitude": "43.32555000",
                        "longitude": "2.52541000"
                    },
                    {
                        "id": 40612,
                        "name": "Caussade",
                        "latitude": "44.16080000",
                        "longitude": "1.53913000"
                    },
                    {
                        "id": 40613,
                        "name": "Cauterets",
                        "latitude": "42.88333000",
                        "longitude": "-0.11667000"
                    },
                    {
                        "id": 40616,
                        "name": "Caux",
                        "latitude": "43.50621000",
                        "longitude": "3.36709000"
                    },
                    {
                        "id": 40620,
                        "name": "Caveirac",
                        "latitude": "43.82437000",
                        "longitude": "4.26664000"
                    },
                    {
                        "id": 40623,
                        "name": "Caylus",
                        "latitude": "44.23607000",
                        "longitude": "1.77168000"
                    },
                    {
                        "id": 40624,
                        "name": "Cazaubon",
                        "latitude": "43.93431000",
                        "longitude": "-0.06814000"
                    },
                    {
                        "id": 40628,
                        "name": "Cazères",
                        "latitude": "43.20710000",
                        "longitude": "1.08633000"
                    },
                    {
                        "id": 40625,
                        "name": "Cazes-Mondenard",
                        "latitude": "44.22689000",
                        "longitude": "1.20299000"
                    },
                    {
                        "id": 40626,
                        "name": "Cazilhac",
                        "latitude": "43.18205000",
                        "longitude": "2.36085000"
                    },
                    {
                        "id": 40627,
                        "name": "Cazouls-lès-Béziers",
                        "latitude": "43.39218000",
                        "longitude": "3.10100000"
                    },
                    {
                        "id": 40637,
                        "name": "Cendras",
                        "latitude": "44.15000000",
                        "longitude": "4.06667000"
                    },
                    {
                        "id": 41393,
                        "name": "Cépet",
                        "latitude": "43.74885000",
                        "longitude": "1.43168000"
                    },
                    {
                        "id": 40645,
                        "name": "Ceret",
                        "latitude": "42.48533000",
                        "longitude": "2.74804000"
                    },
                    {
                        "id": 40654,
                        "name": "Cers",
                        "latitude": "43.32352000",
                        "longitude": "3.30450000"
                    },
                    {
                        "id": 40656,
                        "name": "Cervera de la Marenda",
                        "latitude": "42.44094000",
                        "longitude": "3.16518000"
                    },
                    {
                        "id": 40658,
                        "name": "Cessenon-sur-Orb",
                        "latitude": "43.45011000",
                        "longitude": "3.05154000"
                    },
                    {
                        "id": 40684,
                        "name": "Chalabre",
                        "latitude": "42.98248000",
                        "longitude": "2.00538000"
                    },
                    {
                        "id": 40755,
                        "name": "Chanac",
                        "latitude": "44.46614000",
                        "longitude": "3.34327000"
                    },
                    {
                        "id": 40913,
                        "name": "Chirac",
                        "latitude": "44.52289000",
                        "longitude": "3.26652000"
                    },
                    {
                        "id": 41023,
                        "name": "Cintegabelle",
                        "latitude": "43.31316000",
                        "longitude": "1.53333000"
                    },
                    {
                        "id": 41034,
                        "name": "Claira",
                        "latitude": "42.76036000",
                        "longitude": "2.95572000"
                    },
                    {
                        "id": 41041,
                        "name": "Clapiers",
                        "latitude": "43.65833000",
                        "longitude": "3.88917000"
                    },
                    {
                        "id": 41042,
                        "name": "Clarensac",
                        "latitude": "43.82536000",
                        "longitude": "4.22047000"
                    },
                    {
                        "id": 41043,
                        "name": "Claret",
                        "latitude": "43.86244000",
                        "longitude": "3.90522000"
                    },
                    {
                        "id": 41078,
                        "name": "Codognan",
                        "latitude": "43.73033000",
                        "longitude": "4.22120000"
                    },
                    {
                        "id": 41091,
                        "name": "Collioure",
                        "latitude": "42.52462000",
                        "longitude": "3.08235000"
                    },
                    {
                        "id": 41103,
                        "name": "Colombiers",
                        "latitude": "43.31424000",
                        "longitude": "3.13947000"
                    },
                    {
                        "id": 41105,
                        "name": "Colombiès",
                        "latitude": "44.34414000",
                        "longitude": "2.33772000"
                    },
                    {
                        "id": 41106,
                        "name": "Colomiers",
                        "latitude": "43.61058000",
                        "longitude": "1.33467000"
                    },
                    {
                        "id": 41108,
                        "name": "Combaillaux",
                        "latitude": "43.67191000",
                        "longitude": "3.76767000"
                    },
                    {
                        "id": 41126,
                        "name": "Comps",
                        "latitude": "43.85304000",
                        "longitude": "4.60567000"
                    },
                    {
                        "id": 41133,
                        "name": "Condom",
                        "latitude": "43.95816000",
                        "longitude": "0.37199000"
                    },
                    {
                        "id": 41147,
                        "name": "Congénies",
                        "latitude": "43.76667000",
                        "longitude": "4.16667000"
                    },
                    {
                        "id": 41150,
                        "name": "Connaux",
                        "latitude": "44.08919000",
                        "longitude": "4.59387000"
                    },
                    {
                        "id": 41153,
                        "name": "Conques-sur-Orbiel",
                        "latitude": "43.26667000",
                        "longitude": "2.41667000"
                    },
                    {
                        "id": 41161,
                        "name": "Corbarieu",
                        "latitude": "43.94415000",
                        "longitude": "1.36881000"
                    },
                    {
                        "id": 41174,
                        "name": "Cordes-sur-Ciel",
                        "latitude": "44.06667000",
                        "longitude": "1.95000000"
                    },
                    {
                        "id": 41187,
                        "name": "Cornebarrieu",
                        "latitude": "43.64895000",
                        "longitude": "1.32407000"
                    },
                    {
                        "id": 41188,
                        "name": "Corneilhan",
                        "latitude": "43.39957000",
                        "longitude": "3.19147000"
                    },
                    {
                        "id": 41189,
                        "name": "Corneilla-del-Vercol",
                        "latitude": "42.62390000",
                        "longitude": "2.95216000"
                    },
                    {
                        "id": 41190,
                        "name": "Corneilla-la-Rivière",
                        "latitude": "42.69675000",
                        "longitude": "2.72962000"
                    },
                    {
                        "id": 41224,
                        "name": "Coufouleux",
                        "latitude": "43.81713000",
                        "longitude": "1.73078000"
                    },
                    {
                        "id": 41227,
                        "name": "Couiza",
                        "latitude": "42.94198000",
                        "longitude": "2.25453000"
                    },
                    {
                        "id": 41256,
                        "name": "Cournonsec",
                        "latitude": "43.54944000",
                        "longitude": "3.70556000"
                    },
                    {
                        "id": 41257,
                        "name": "Cournonterral",
                        "latitude": "43.55889000",
                        "longitude": "3.72000000"
                    },
                    {
                        "id": 41265,
                        "name": "Coursan",
                        "latitude": "43.23370000",
                        "longitude": "3.05712000"
                    },
                    {
                        "id": 41296,
                        "name": "Cransac",
                        "latitude": "44.52411000",
                        "longitude": "2.28370000"
                    },
                    {
                        "id": 41303,
                        "name": "Creissan",
                        "latitude": "43.37524000",
                        "longitude": "3.01196000"
                    },
                    {
                        "id": 41304,
                        "name": "Creissels",
                        "latitude": "44.08588000",
                        "longitude": "3.06071000"
                    },
                    {
                        "id": 41364,
                        "name": "Cugnaux",
                        "latitude": "43.53635000",
                        "longitude": "1.34428000"
                    },
                    {
                        "id": 41373,
                        "name": "Cunac",
                        "latitude": "43.93010000",
                        "longitude": "2.21878000"
                    },
                    {
                        "id": 41386,
                        "name": "Cuxac-Cabardès",
                        "latitude": "43.37087000",
                        "longitude": "2.28369000"
                    },
                    {
                        "id": 41441,
                        "name": "Daux",
                        "latitude": "43.69506000",
                        "longitude": "1.26892000"
                    },
                    {
                        "id": 41445,
                        "name": "Decazeville",
                        "latitude": "44.56045000",
                        "longitude": "2.25091000"
                    },
                    {
                        "id": 41612,
                        "name": "Département de l'Ariège",
                        "latitude": "43.00000000",
                        "longitude": "1.50000000"
                    },
                    {
                        "id": 41614,
                        "name": "Département de l'Aude",
                        "latitude": "43.08333000",
                        "longitude": "2.50000000"
                    },
                    {
                        "id": 41615,
                        "name": "Département de l'Aveyron",
                        "latitude": "44.25000000",
                        "longitude": "2.50000000"
                    },
                    {
                        "id": 41618,
                        "name": "Département de l'Hérault",
                        "latitude": "43.66667000",
                        "longitude": "3.50000000"
                    },
                    {
                        "id": 41631,
                        "name": "Département de la Lozère",
                        "latitude": "44.50000000",
                        "longitude": "3.50000000"
                    },
                    {
                        "id": 41637,
                        "name": "Département des Hautes-Pyrénées",
                        "latitude": "43.03686000",
                        "longitude": "0.18632000"
                    },
                    {
                        "id": 41639,
                        "name": "Département des Pyrénées-Orientales",
                        "latitude": "42.60075000",
                        "longitude": "2.58889000"
                    },
                    {
                        "id": 41645,
                        "name": "Département du Tarn-et-Garonne",
                        "latitude": "44.00000000",
                        "longitude": "1.16667000"
                    },
                    {
                        "id": 41556,
                        "name": "Dourgne",
                        "latitude": "43.48381000",
                        "longitude": "2.13989000"
                    },
                    {
                        "id": 41583,
                        "name": "Drémil-Lafage",
                        "latitude": "43.59624000",
                        "longitude": "1.60117000"
                    },
                    {
                        "id": 41578,
                        "name": "Druelle",
                        "latitude": "44.36006000",
                        "longitude": "2.50505000"
                    },
                    {
                        "id": 41652,
                        "name": "Eaunes",
                        "latitude": "43.42079000",
                        "longitude": "1.35397000"
                    },
                    {
                        "id": 41653,
                        "name": "Eauze",
                        "latitude": "43.86055000",
                        "longitude": "0.10199000"
                    },
                    {
                        "id": 48031,
                        "name": "el Voló",
                        "latitude": "42.52424000",
                        "longitude": "2.83336000"
                    },
                    {
                        "id": 41664,
                        "name": "Elne",
                        "latitude": "42.60031000",
                        "longitude": "2.97146000"
                    },
                    {
                        "id": 48032,
                        "name": "els Banys d'Arles",
                        "latitude": "42.47289000",
                        "longitude": "2.66916000"
                    },
                    {
                        "id": 41681,
                        "name": "Entraygues-sur-Truyère",
                        "latitude": "44.64606000",
                        "longitude": "2.56745000"
                    },
                    {
                        "id": 41705,
                        "name": "Escalquens",
                        "latitude": "43.51744000",
                        "longitude": "1.55893000"
                    },
                    {
                        "id": 41716,
                        "name": "Espalion",
                        "latitude": "44.52237000",
                        "longitude": "2.76265000"
                    },
                    {
                        "id": 41719,
                        "name": "Espéraza",
                        "latitude": "42.93225000",
                        "longitude": "2.22006000"
                    },
                    {
                        "id": 41729,
                        "name": "Estagel",
                        "latitude": "42.77314000",
                        "longitude": "2.69665000"
                    },
                    {
                        "id": 41761,
                        "name": "Fabrègues",
                        "latitude": "43.55057000",
                        "longitude": "3.77637000"
                    },
                    {
                        "id": 41760,
                        "name": "Fabrezan",
                        "latitude": "43.13581000",
                        "longitude": "2.69814000"
                    },
                    {
                        "id": 41799,
                        "name": "Fenouillet",
                        "latitude": "43.68041000",
                        "longitude": "1.39200000"
                    },
                    {
                        "id": 41803,
                        "name": "Ferrals-les-Corbières",
                        "latitude": "43.15000000",
                        "longitude": "2.73333000"
                    },
                    {
                        "id": 41819,
                        "name": "Figeac",
                        "latitude": "44.60880000",
                        "longitude": "2.03187000"
                    },
                    {
                        "id": 41822,
                        "name": "Finhan",
                        "latitude": "43.91335000",
                        "longitude": "1.22120000"
                    },
                    {
                        "id": 41823,
                        "name": "Firmi",
                        "latitude": "44.54106000",
                        "longitude": "2.30764000"
                    },
                    {
                        "id": 41832,
                        "name": "Flavin",
                        "latitude": "44.28890000",
                        "longitude": "2.60513000"
                    },
                    {
                        "id": 41839,
                        "name": "Fleurance",
                        "latitude": "43.84824000",
                        "longitude": "0.66302000"
                    },
                    {
                        "id": 41845,
                        "name": "Fleury",
                        "latitude": "43.23095000",
                        "longitude": "3.13745000"
                    },
                    {
                        "id": 41860,
                        "name": "Florac",
                        "latitude": "44.32632000",
                        "longitude": "3.59301000"
                    },
                    {
                        "id": 41862,
                        "name": "Florensac",
                        "latitude": "43.38301000",
                        "longitude": "3.46638000"
                    },
                    {
                        "id": 41863,
                        "name": "Flourens",
                        "latitude": "43.59273000",
                        "longitude": "1.56259000"
                    },
                    {
                        "id": 41867,
                        "name": "Foix",
                        "latitude": "42.96046000",
                        "longitude": "1.60787000"
                    },
                    {
                        "id": 41872,
                        "name": "Fonbeauzard",
                        "latitude": "43.67830000",
                        "longitude": "1.43440000"
                    },
                    {
                        "id": 41874,
                        "name": "Fonsorbes",
                        "latitude": "43.53524000",
                        "longitude": "1.22937000"
                    },
                    {
                        "id": 41875,
                        "name": "Font-Romeu-Odeillo-Via",
                        "latitude": "42.50552000",
                        "longitude": "2.04011000"
                    },
                    {
                        "id": 41904,
                        "name": "Fontenilles",
                        "latitude": "43.55286000",
                        "longitude": "1.19096000"
                    },
                    {
                        "id": 41937,
                        "name": "Fourques",
                        "latitude": "43.69450000",
                        "longitude": "4.60932000"
                    },
                    {
                        "id": 41984,
                        "name": "Fréjairolles",
                        "latitude": "43.88094000",
                        "longitude": "2.23151000"
                    },
                    {
                        "id": 41975,
                        "name": "Frontignan",
                        "latitude": "43.44848000",
                        "longitude": "3.75400000"
                    },
                    {
                        "id": 41976,
                        "name": "Fronton",
                        "latitude": "43.83931000",
                        "longitude": "1.38931000"
                    },
                    {
                        "id": 41981,
                        "name": "Frouzins",
                        "latitude": "43.51482000",
                        "longitude": "1.32523000"
                    },
                    {
                        "id": 42011,
                        "name": "Gagnac-sur-Garonne",
                        "latitude": "43.69990000",
                        "longitude": "1.37535000"
                    },
                    {
                        "id": 42013,
                        "name": "Gaillac",
                        "latitude": "43.90160000",
                        "longitude": "1.89686000"
                    },
                    {
                        "id": 42014,
                        "name": "Gaillac-Toulza",
                        "latitude": "43.25536000",
                        "longitude": "1.47141000"
                    },
                    {
                        "id": 42022,
                        "name": "Gallargues-le-Montueux",
                        "latitude": "43.71667000",
                        "longitude": "4.16667000"
                    },
                    {
                        "id": 42029,
                        "name": "Ganges",
                        "latitude": "43.93380000",
                        "longitude": "3.70784000"
                    },
                    {
                        "id": 42036,
                        "name": "Gard",
                        "latitude": "44.01790000",
                        "longitude": "4.28751000"
                    },
                    {
                        "id": 42039,
                        "name": "Gardouch",
                        "latitude": "43.39096000",
                        "longitude": "1.68313000"
                    },
                    {
                        "id": 42044,
                        "name": "Garidech",
                        "latitude": "43.71076000",
                        "longitude": "1.56036000"
                    },
                    {
                        "id": 42047,
                        "name": "Garons",
                        "latitude": "43.76861000",
                        "longitude": "4.42753000"
                    },
                    {
                        "id": 42298,
                        "name": "Générac",
                        "latitude": "43.72830000",
                        "longitude": "4.35000000"
                    },
                    {
                        "id": 42073,
                        "name": "Gerde",
                        "latitude": "43.05567000",
                        "longitude": "0.16688000"
                    },
                    {
                        "id": 42075,
                        "name": "Gers",
                        "latitude": "43.71731000",
                        "longitude": "0.45422000"
                    },
                    {
                        "id": 42090,
                        "name": "Gigean",
                        "latitude": "43.50028000",
                        "longitude": "3.71167000"
                    },
                    {
                        "id": 42091,
                        "name": "Gignac",
                        "latitude": "43.65200000",
                        "longitude": "3.55090000"
                    },
                    {
                        "id": 42097,
                        "name": "Gimont",
                        "latitude": "43.62627000",
                        "longitude": "0.87655000"
                    },
                    {
                        "id": 42099,
                        "name": "Ginestas",
                        "latitude": "43.26645000",
                        "longitude": "2.87038000"
                    },
                    {
                        "id": 42104,
                        "name": "Giroussens",
                        "latitude": "43.76199000",
                        "longitude": "1.77608000"
                    },
                    {
                        "id": 42128,
                        "name": "Gondrin",
                        "latitude": "43.88466000",
                        "longitude": "0.23737000"
                    },
                    {
                        "id": 42144,
                        "name": "Goudargues",
                        "latitude": "44.21376000",
                        "longitude": "4.46652000"
                    },
                    {
                        "id": 42149,
                        "name": "Gourdan-Polignan",
                        "latitude": "43.07092000",
                        "longitude": "0.57482000"
                    },
                    {
                        "id": 42150,
                        "name": "Gourdon",
                        "latitude": "44.73742000",
                        "longitude": "1.38297000"
                    },
                    {
                        "id": 42163,
                        "name": "Grabels",
                        "latitude": "43.64797000",
                        "longitude": "3.79865000"
                    },
                    {
                        "id": 42165,
                        "name": "Gragnague",
                        "latitude": "43.68091000",
                        "longitude": "1.58461000"
                    },
                    {
                        "id": 42168,
                        "name": "Gramat",
                        "latitude": "44.78075000",
                        "longitude": "1.71957000"
                    },
                    {
                        "id": 42187,
                        "name": "Gratentour",
                        "latitude": "43.72360000",
                        "longitude": "1.43234000"
                    },
                    {
                        "id": 42188,
                        "name": "Graulhet",
                        "latitude": "43.76688000",
                        "longitude": "1.98938000"
                    },
                    {
                        "id": 42195,
                        "name": "Grenade",
                        "latitude": "43.76667000",
                        "longitude": "1.28333000"
                    },
                    {
                        "id": 42215,
                        "name": "Grisolles",
                        "latitude": "43.82920000",
                        "longitude": "1.29673000"
                    },
                    {
                        "id": 42230,
                        "name": "Gruissan",
                        "latitude": "43.10759000",
                        "longitude": "3.08651000"
                    },
                    {
                        "id": 42341,
                        "name": "Haute-Garonne",
                        "latitude": "43.38724000",
                        "longitude": "1.22191000"
                    },
                    {
                        "id": 42464,
                        "name": "Hérépian",
                        "latitude": "43.59300000",
                        "longitude": "3.11595000"
                    },
                    {
                        "id": 42420,
                        "name": "Horgues",
                        "latitude": "43.18865000",
                        "longitude": "0.08733000"
                    },
                    {
                        "id": 42469,
                        "name": "Ibos",
                        "latitude": "43.23333000",
                        "longitude": "0.00000000"
                    },
                    {
                        "id": 42479,
                        "name": "Ille-sur-Têt",
                        "latitude": "42.67069000",
                        "longitude": "2.62162000"
                    },
                    {
                        "id": 42523,
                        "name": "Jacou",
                        "latitude": "43.66139000",
                        "longitude": "3.91222000"
                    },
                    {
                        "id": 42548,
                        "name": "Jegun",
                        "latitude": "43.76667000",
                        "longitude": "0.46667000"
                    },
                    {
                        "id": 42560,
                        "name": "Jonquières-Saint-Vincent",
                        "latitude": "43.82809000",
                        "longitude": "4.56327000"
                    },
                    {
                        "id": 42586,
                        "name": "Juillan",
                        "latitude": "43.19937000",
                        "longitude": "0.02570000"
                    },
                    {
                        "id": 42598,
                        "name": "Juvignac",
                        "latitude": "43.61389000",
                        "longitude": "3.81056000"
                    },
                    {
                        "id": 42627,
                        "name": "L'Union",
                        "latitude": "43.66042000",
                        "longitude": "1.48264000"
                    },
                    {
                        "id": 43706,
                        "name": "L’Isle-en-Dodon",
                        "latitude": "43.38428000",
                        "longitude": "0.83513000"
                    },
                    {
                        "id": 43704,
                        "name": "L’Isle-Jourdain",
                        "latitude": "43.61218000",
                        "longitude": "1.08219000"
                    },
                    {
                        "id": 42634,
                        "name": "La Barthe-de-Neste",
                        "latitude": "43.08123000",
                        "longitude": "0.38438000"
                    },
                    {
                        "id": 42664,
                        "name": "La Calmette",
                        "latitude": "43.92283000",
                        "longitude": "4.26617000"
                    },
                    {
                        "id": 42665,
                        "name": "La Canourgue",
                        "latitude": "44.43133000",
                        "longitude": "3.21584000"
                    },
                    {
                        "id": 42669,
                        "name": "La Cavalerie",
                        "latitude": "44.00961000",
                        "longitude": "3.15840000"
                    },
                    {
                        "id": 42753,
                        "name": "La Fouillade",
                        "latitude": "44.23072000",
                        "longitude": "2.03989000"
                    },
                    {
                        "id": 42772,
                        "name": "La Grande-Motte",
                        "latitude": "43.56667000",
                        "longitude": "4.08333000"
                    },
                    {
                        "id": 48033,
                        "name": "la Guingueta d'Ix",
                        "latitude": "42.43416000",
                        "longitude": "1.94391000"
                    },
                    {
                        "id": 42794,
                        "name": "La Loubière",
                        "latitude": "44.37143000",
                        "longitude": "2.66825000"
                    },
                    {
                        "id": 42827,
                        "name": "La Palme",
                        "latitude": "42.97518000",
                        "longitude": "2.99243000"
                    },
                    {
                        "id": 48034,
                        "name": "la Roca d'Albera",
                        "latitude": "42.52130000",
                        "longitude": "2.93374000"
                    },
                    {
                        "id": 42871,
                        "name": "La Salvetat-Peyralès",
                        "latitude": "44.21940000",
                        "longitude": "2.20297000"
                    },
                    {
                        "id": 42872,
                        "name": "La Salvetat-Saint-Gilles",
                        "latitude": "43.57622000",
                        "longitude": "1.27192000"
                    },
                    {
                        "id": 42873,
                        "name": "La Salvetat-sur-Agout",
                        "latitude": "43.60000000",
                        "longitude": "2.71667000"
                    },
                    {
                        "id": 42891,
                        "name": "La Tour-du-Crieu",
                        "latitude": "43.10471000",
                        "longitude": "1.65275000"
                    },
                    {
                        "id": 42894,
                        "name": "La Tour-sur-Orb",
                        "latitude": "43.65186000",
                        "longitude": "3.15071000"
                    },
                    {
                        "id": 42922,
                        "name": "Labarthe-Rivière",
                        "latitude": "43.08100000",
                        "longitude": "0.67134000"
                    },
                    {
                        "id": 42923,
                        "name": "Labarthe-sur-Lèze",
                        "latitude": "43.45206000",
                        "longitude": "1.39968000"
                    },
                    {
                        "id": 42924,
                        "name": "Labastide-Beauvoir",
                        "latitude": "43.48148000",
                        "longitude": "1.66543000"
                    },
                    {
                        "id": 42925,
                        "name": "Labastide-Rouairoux",
                        "latitude": "43.47566000",
                        "longitude": "2.63929000"
                    },
                    {
                        "id": 42926,
                        "name": "Labastide-Saint-Georges",
                        "latitude": "43.69962000",
                        "longitude": "1.84585000"
                    },
                    {
                        "id": 42927,
                        "name": "Labastide-Saint-Pierre",
                        "latitude": "43.91769000",
                        "longitude": "1.36628000"
                    },
                    {
                        "id": 42928,
                        "name": "Labastide-Saint-Sernin",
                        "latitude": "43.73743000",
                        "longitude": "1.46985000"
                    },
                    {
                        "id": 42929,
                        "name": "Labastidette",
                        "latitude": "43.45952000",
                        "longitude": "1.24525000"
                    },
                    {
                        "id": 42939,
                        "name": "Labège",
                        "latitude": "43.53039000",
                        "longitude": "1.53596000"
                    },
                    {
                        "id": 42937,
                        "name": "Labruguière",
                        "latitude": "43.53858000",
                        "longitude": "2.26392000"
                    },
                    {
                        "id": 42942,
                        "name": "Lacapelle-Marival",
                        "latitude": "44.72773000",
                        "longitude": "1.92465000"
                    },
                    {
                        "id": 42943,
                        "name": "Lacasse",
                        "latitude": "43.39873000",
                        "longitude": "1.26951000"
                    },
                    {
                        "id": 42944,
                        "name": "Lacaune",
                        "latitude": "43.70660000",
                        "longitude": "2.69293000"
                    },
                    {
                        "id": 42947,
                        "name": "Lacroix-Falgarde",
                        "latitude": "43.49968000",
                        "longitude": "1.40985000"
                    },
                    {
                        "id": 42949,
                        "name": "Lacrouzette",
                        "latitude": "43.66030000",
                        "longitude": "2.34838000"
                    },
                    {
                        "id": 42953,
                        "name": "Lafrançaise",
                        "latitude": "44.12791000",
                        "longitude": "1.24141000"
                    },
                    {
                        "id": 42954,
                        "name": "Lagardelle-sur-Lèze",
                        "latitude": "43.41143000",
                        "longitude": "1.38920000"
                    },
                    {
                        "id": 42955,
                        "name": "Lagarrigue",
                        "latitude": "43.57765000",
                        "longitude": "2.27784000"
                    },
                    {
                        "id": 42963,
                        "name": "Lagrave",
                        "latitude": "43.89734000",
                        "longitude": "1.99268000"
                    },
                    {
                        "id": 42965,
                        "name": "Laguiole",
                        "latitude": "44.68465000",
                        "longitude": "2.84666000"
                    },
                    {
                        "id": 42971,
                        "name": "Laissac",
                        "latitude": "44.38085000",
                        "longitude": "2.82154000"
                    },
                    {
                        "id": 42973,
                        "name": "Lalbenque",
                        "latitude": "44.33929000",
                        "longitude": "1.54501000"
                    },
                    {
                        "id": 42977,
                        "name": "Laloubère",
                        "latitude": "43.20430000",
                        "longitude": "0.07296000"
                    },
                    {
                        "id": 42978,
                        "name": "Lamagistère",
                        "latitude": "44.12488000",
                        "longitude": "0.82486000"
                    },
                    {
                        "id": 42979,
                        "name": "Lamalou-les-Bains",
                        "latitude": "43.59786000",
                        "longitude": "3.08052000"
                    },
                    {
                        "id": 43023,
                        "name": "Langlade",
                        "latitude": "43.80284000",
                        "longitude": "4.25232000"
                    },
                    {
                        "id": 43025,
                        "name": "Langogne",
                        "latitude": "44.72726000",
                        "longitude": "3.85539000"
                    },
                    {
                        "id": 43035,
                        "name": "Lannemezan",
                        "latitude": "43.12517000",
                        "longitude": "0.38401000"
                    },
                    {
                        "id": 43046,
                        "name": "Lansargues",
                        "latitude": "43.65157000",
                        "longitude": "4.07495000"
                    },
                    {
                        "id": 43047,
                        "name": "Lanta",
                        "latitude": "43.56667000",
                        "longitude": "1.66667000"
                    },
                    {
                        "id": 43060,
                        "name": "Lapeyrouse-Fossat",
                        "latitude": "43.69973000",
                        "longitude": "1.51049000"
                    },
                    {
                        "id": 43075,
                        "name": "Laroque",
                        "latitude": "43.92320000",
                        "longitude": "3.72397000"
                    },
                    {
                        "id": 43077,
                        "name": "Laroque-d’Olmes",
                        "latitude": "42.96785000",
                        "longitude": "1.86677000"
                    },
                    {
                        "id": 43084,
                        "name": "Lasalle",
                        "latitude": "44.04530000",
                        "longitude": "3.85477000"
                    },
                    {
                        "id": 43091,
                        "name": "Latour-Bas-Elne",
                        "latitude": "42.60646000",
                        "longitude": "3.00201000"
                    },
                    {
                        "id": 43093,
                        "name": "Lattes",
                        "latitude": "43.56752000",
                        "longitude": "3.90460000"
                    },
                    {
                        "id": 43094,
                        "name": "Laudun-l'Ardoise",
                        "latitude": "44.10000000",
                        "longitude": "4.66667000"
                    },
                    {
                        "id": 43095,
                        "name": "Launac",
                        "latitude": "43.74357000",
                        "longitude": "1.18172000"
                    },
                    {
                        "id": 43096,
                        "name": "Launaguet",
                        "latitude": "43.67818000",
                        "longitude": "1.45603000"
                    },
                    {
                        "id": 43097,
                        "name": "Laure-Minervois",
                        "latitude": "43.27106000",
                        "longitude": "2.52031000"
                    },
                    {
                        "id": 43098,
                        "name": "Laurens",
                        "latitude": "43.52238000",
                        "longitude": "3.19714000"
                    },
                    {
                        "id": 43104,
                        "name": "Lautrec",
                        "latitude": "43.70591000",
                        "longitude": "2.13925000"
                    },
                    {
                        "id": 43106,
                        "name": "Lauzerte",
                        "latitude": "44.25535000",
                        "longitude": "1.13817000"
                    },
                    {
                        "id": 43108,
                        "name": "Laval-Pradel",
                        "latitude": "44.20665000",
                        "longitude": "4.06591000"
                    },
                    {
                        "id": 43109,
                        "name": "Lavalette",
                        "latitude": "43.18428000",
                        "longitude": "2.26825000"
                    },
                    {
                        "id": 43113,
                        "name": "Lavaur",
                        "latitude": "43.69847000",
                        "longitude": "1.81858000"
                    },
                    {
                        "id": 43114,
                        "name": "Lavelanet",
                        "latitude": "42.93127000",
                        "longitude": "1.84656000"
                    },
                    {
                        "id": 43116,
                        "name": "Lavernose-Lacasse",
                        "latitude": "43.39700000",
                        "longitude": "1.26205000"
                    },
                    {
                        "id": 43120,
                        "name": "Lavérune",
                        "latitude": "43.58639000",
                        "longitude": "3.80611000"
                    },
                    {
                        "id": 43118,
                        "name": "Lavit",
                        "latitude": "43.95674000",
                        "longitude": "0.92010000"
                    },
                    {
                        "id": 43126,
                        "name": "Le Barcarès",
                        "latitude": "42.78773000",
                        "longitude": "3.03656000"
                    },
                    {
                        "id": 43142,
                        "name": "Le Bousquet-d’Orb",
                        "latitude": "43.69242000",
                        "longitude": "3.16746000"
                    },
                    {
                        "id": 43151,
                        "name": "Le Cailar",
                        "latitude": "43.67923000",
                        "longitude": "4.23576000"
                    },
                    {
                        "id": 43156,
                        "name": "Le Cap d'Agde",
                        "latitude": "43.27796000",
                        "longitude": "3.51357000"
                    },
                    {
                        "id": 43178,
                        "name": "Le Crès",
                        "latitude": "43.64807000",
                        "longitude": "3.93976000"
                    },
                    {
                        "id": 43185,
                        "name": "Le Fauga",
                        "latitude": "43.39619000",
                        "longitude": "1.29571000"
                    },
                    {
                        "id": 43190,
                        "name": "Le Fousseret",
                        "latitude": "43.28205000",
                        "longitude": "1.06624000"
                    },
                    {
                        "id": 43193,
                        "name": "Le Garric",
                        "latitude": "44.00932000",
                        "longitude": "2.16431000"
                    },
                    {
                        "id": 43200,
                        "name": "Le Grau-du-Roi",
                        "latitude": "43.53881000",
                        "longitude": "4.13559000"
                    },
                    {
                        "id": 43206,
                        "name": "Le Houga",
                        "latitude": "43.77464000",
                        "longitude": "-0.17833000"
                    },
                    {
                        "id": 43219,
                        "name": "Le Malzieu-Ville",
                        "latitude": "44.85699000",
                        "longitude": "3.33302000"
                    },
                    {
                        "id": 43236,
                        "name": "Le Monastère",
                        "latitude": "44.34165000",
                        "longitude": "2.57956000"
                    },
                    {
                        "id": 43279,
                        "name": "Le Pouget",
                        "latitude": "43.59195000",
                        "longitude": "3.52423000"
                    },
                    {
                        "id": 43280,
                        "name": "Le Poujol-sur-Orb",
                        "latitude": "43.57919000",
                        "longitude": "3.06156000"
                    },
                    {
                        "id": 43300,
                        "name": "Le Sequestre",
                        "latitude": "43.91076000",
                        "longitude": "2.11804000"
                    },
                    {
                        "id": 43301,
                        "name": "Le Soler",
                        "latitude": "42.68101000",
                        "longitude": "2.79335000"
                    },
                    {
                        "id": 43334,
                        "name": "Le Vigan",
                        "latitude": "44.74075000",
                        "longitude": "1.43963000"
                    },
                    {
                        "id": 43339,
                        "name": "Lectoure",
                        "latitude": "43.93464000",
                        "longitude": "0.62107000"
                    },
                    {
                        "id": 43683,
                        "name": "Lédenon",
                        "latitude": "43.91349000",
                        "longitude": "4.51444000"
                    },
                    {
                        "id": 43684,
                        "name": "Lédignan",
                        "latitude": "43.98690000",
                        "longitude": "4.10644000"
                    },
                    {
                        "id": 43685,
                        "name": "Léguevin",
                        "latitude": "43.60028000",
                        "longitude": "1.23236000"
                    },
                    {
                        "id": 43363,
                        "name": "Les Angles",
                        "latitude": "43.95806000",
                        "longitude": "4.76342000"
                    },
                    {
                        "id": 43403,
                        "name": "Les Mages",
                        "latitude": "44.22862000",
                        "longitude": "4.16946000"
                    },
                    {
                        "id": 43407,
                        "name": "Les Matelles",
                        "latitude": "43.72905000",
                        "longitude": "3.81360000"
                    },
                    {
                        "id": 43428,
                        "name": "Les Salles-du-Gardon",
                        "latitude": "44.20790000",
                        "longitude": "4.03689000"
                    },
                    {
                        "id": 43439,
                        "name": "Lespignan",
                        "latitude": "43.27366000",
                        "longitude": "3.17224000"
                    },
                    {
                        "id": 43440,
                        "name": "Lespinasse",
                        "latitude": "43.71206000",
                        "longitude": "1.38462000"
                    },
                    {
                        "id": 43445,
                        "name": "Leucate",
                        "latitude": "42.91056000",
                        "longitude": "3.02944000"
                    },
                    {
                        "id": 43693,
                        "name": "Lévignac",
                        "latitude": "43.66667000",
                        "longitude": "1.20000000"
                    },
                    {
                        "id": 43456,
                        "name": "Leyme",
                        "latitude": "44.78622000",
                        "longitude": "1.89897000"
                    },
                    {
                        "id": 43695,
                        "name": "Lézan",
                        "latitude": "44.01667000",
                        "longitude": "4.05000000"
                    },
                    {
                        "id": 43697,
                        "name": "Lézat-sur-Lèze",
                        "latitude": "43.27734000",
                        "longitude": "1.34686000"
                    },
                    {
                        "id": 43698,
                        "name": "Lézignan-Corbières",
                        "latitude": "43.19765000",
                        "longitude": "2.76142000"
                    },
                    {
                        "id": 43699,
                        "name": "Lézignan-la-Cèbe",
                        "latitude": "43.49368000",
                        "longitude": "3.43708000"
                    },
                    {
                        "id": 43462,
                        "name": "Lherm",
                        "latitude": "43.43127000",
                        "longitude": "1.22239000"
                    },
                    {
                        "id": 43470,
                        "name": "Lieuran-lès-Béziers",
                        "latitude": "43.41860000",
                        "longitude": "3.23719000"
                    },
                    {
                        "id": 43475,
                        "name": "Lignan-sur-Orb",
                        "latitude": "43.38462000",
                        "longitude": "3.16891000"
                    },
                    {
                        "id": 43496,
                        "name": "Limoux",
                        "latitude": "43.05487000",
                        "longitude": "2.22173000"
                    },
                    {
                        "id": 43509,
                        "name": "Lisle-sur-Tarn",
                        "latitude": "43.85249000",
                        "longitude": "1.81099000"
                    },
                    {
                        "id": 43518,
                        "name": "Livinhac-le-Haut",
                        "latitude": "44.59212000",
                        "longitude": "2.23117000"
                    },
                    {
                        "id": 43526,
                        "name": "Llupia",
                        "latitude": "42.62074000",
                        "longitude": "2.76924000"
                    },
                    {
                        "id": 43537,
                        "name": "Lodève",
                        "latitude": "43.73166000",
                        "longitude": "3.31941000"
                    },
                    {
                        "id": 43547,
                        "name": "Lombez",
                        "latitude": "43.47501000",
                        "longitude": "0.91119000"
                    },
                    {
                        "id": 43552,
                        "name": "Longages",
                        "latitude": "43.35398000",
                        "longitude": "1.23905000"
                    },
                    {
                        "id": 43597,
                        "name": "Lot",
                        "latitude": "44.62703000",
                        "longitude": "1.63461000"
                    },
                    {
                        "id": 43605,
                        "name": "Loupian",
                        "latitude": "43.44886000",
                        "longitude": "3.61381000"
                    },
                    {
                        "id": 43608,
                        "name": "Lourdes",
                        "latitude": "43.10000000",
                        "longitude": "-0.05000000"
                    },
                    {
                        "id": 43629,
                        "name": "Luc-la-Primaube",
                        "latitude": "44.31439000",
                        "longitude": "2.53552000"
                    },
                    {
                        "id": 43652,
                        "name": "Lunel",
                        "latitude": "43.67778000",
                        "longitude": "4.13611000"
                    },
                    {
                        "id": 43653,
                        "name": "Lunel-Viel",
                        "latitude": "43.67890000",
                        "longitude": "4.09250000"
                    },
                    {
                        "id": 43670,
                        "name": "Luz-Saint-Sauveur",
                        "latitude": "42.87191000",
                        "longitude": "-0.00323000"
                    },
                    {
                        "id": 43672,
                        "name": "Luzech",
                        "latitude": "44.47818000",
                        "longitude": "1.28704000"
                    },
                    {
                        "id": 43717,
                        "name": "Magalas",
                        "latitude": "43.47095000",
                        "longitude": "3.22338000"
                    },
                    {
                        "id": 43776,
                        "name": "Manduel",
                        "latitude": "43.81855000",
                        "longitude": "4.47247000"
                    },
                    {
                        "id": 43792,
                        "name": "Maraussan",
                        "latitude": "43.36895000",
                        "longitude": "3.15643000"
                    },
                    {
                        "id": 43801,
                        "name": "Marciac",
                        "latitude": "43.52321000",
                        "longitude": "0.16091000"
                    },
                    {
                        "id": 43804,
                        "name": "Marcillac-Vallon",
                        "latitude": "44.47464000",
                        "longitude": "2.46454000"
                    },
                    {
                        "id": 43814,
                        "name": "Marcorignan",
                        "latitude": "43.22634000",
                        "longitude": "2.92281000"
                    },
                    {
                        "id": 43837,
                        "name": "Marguerittes",
                        "latitude": "43.85960000",
                        "longitude": "4.44517000"
                    },
                    {
                        "id": 43871,
                        "name": "Marquefave",
                        "latitude": "43.31766000",
                        "longitude": "1.24661000"
                    },
                    {
                        "id": 43882,
                        "name": "Marseillan",
                        "latitude": "43.35618000",
                        "longitude": "3.52795000"
                    },
                    {
                        "id": 43906,
                        "name": "Marsillargues",
                        "latitude": "43.66424000",
                        "longitude": "4.17448000"
                    },
                    {
                        "id": 43908,
                        "name": "Marssac-sur-Tarn",
                        "latitude": "43.91768000",
                        "longitude": "2.02921000"
                    },
                    {
                        "id": 43909,
                        "name": "Martel",
                        "latitude": "44.93667000",
                        "longitude": "1.60851000"
                    },
                    {
                        "id": 43921,
                        "name": "Martres-Tolosane",
                        "latitude": "43.19929000",
                        "longitude": "1.01056000"
                    },
                    {
                        "id": 43922,
                        "name": "Marvejols",
                        "latitude": "44.55378000",
                        "longitude": "3.29137000"
                    },
                    {
                        "id": 43932,
                        "name": "Masseube",
                        "latitude": "43.42984000",
                        "longitude": "0.57810000"
                    },
                    {
                        "id": 43946,
                        "name": "Maubourguet",
                        "latitude": "43.46824000",
                        "longitude": "0.03578000"
                    },
                    {
                        "id": 43947,
                        "name": "Mauguio",
                        "latitude": "43.61810000",
                        "longitude": "4.00739000"
                    },
                    {
                        "id": 43953,
                        "name": "Maureilhan",
                        "latitude": "43.35000000",
                        "longitude": "3.11667000"
                    },
                    {
                        "id": 43954,
                        "name": "Maureillas-las-Illas",
                        "latitude": "42.49014000",
                        "longitude": "2.80752000"
                    },
                    {
                        "id": 43962,
                        "name": "Mauvezin",
                        "latitude": "43.73048000",
                        "longitude": "0.87810000"
                    },
                    {
                        "id": 43971,
                        "name": "Mazamet",
                        "latitude": "43.49001000",
                        "longitude": "2.37304000"
                    },
                    {
                        "id": 43978,
                        "name": "Mazères",
                        "latitude": "43.25055000",
                        "longitude": "1.67728000"
                    },
                    {
                        "id": 43999,
                        "name": "Mende",
                        "latitude": "44.51849000",
                        "longitude": "3.50372000"
                    },
                    {
                        "id": 44013,
                        "name": "Mercus-Garrabet",
                        "latitude": "42.87790000",
                        "longitude": "1.62900000"
                    },
                    {
                        "id": 44024,
                        "name": "Merville",
                        "latitude": "43.72354000",
                        "longitude": "1.29656000"
                    },
                    {
                        "id": 44058,
                        "name": "Meynes",
                        "latitude": "43.87974000",
                        "longitude": "4.55958000"
                    },
                    {
                        "id": 44061,
                        "name": "Meyrueis",
                        "latitude": "44.17737000",
                        "longitude": "3.43083000"
                    },
                    {
                        "id": 44453,
                        "name": "Mèze",
                        "latitude": "43.42504000",
                        "longitude": "3.60590000"
                    },
                    {
                        "id": 44108,
                        "name": "Miélan",
                        "latitude": "43.43054000",
                        "longitude": "0.30794000"
                    },
                    {
                        "id": 44071,
                        "name": "Milhaud",
                        "latitude": "43.78977000",
                        "longitude": "4.31035000"
                    },
                    {
                        "id": 44073,
                        "name": "Millas",
                        "latitude": "42.69203000",
                        "longitude": "2.69508000"
                    },
                    {
                        "id": 44074,
                        "name": "Millau",
                        "latitude": "44.09774000",
                        "longitude": "3.07777000"
                    },
                    {
                        "id": 44090,
                        "name": "Mirande",
                        "latitude": "43.51481000",
                        "longitude": "0.40410000"
                    },
                    {
                        "id": 44091,
                        "name": "Mirandol-Bourgnounac",
                        "latitude": "44.14273000",
                        "longitude": "2.16857000"
                    },
                    {
                        "id": 44096,
                        "name": "Miremont",
                        "latitude": "43.36995000",
                        "longitude": "1.41724000"
                    },
                    {
                        "id": 44098,
                        "name": "Mirepoix",
                        "latitude": "43.08773000",
                        "longitude": "1.87350000"
                    },
                    {
                        "id": 44099,
                        "name": "Mireval",
                        "latitude": "43.50860000",
                        "longitude": "3.80170000"
                    },
                    {
                        "id": 44118,
                        "name": "Moissac",
                        "latitude": "44.10236000",
                        "longitude": "1.09450000"
                    },
                    {
                        "id": 44123,
                        "name": "Molières",
                        "latitude": "44.19305000",
                        "longitude": "1.36318000"
                    },
                    {
                        "id": 44124,
                        "name": "Molières-sur-Cèze",
                        "latitude": "44.25989000",
                        "longitude": "4.15836000"
                    },
                    {
                        "id": 44131,
                        "name": "Monclar-de-Quercy",
                        "latitude": "43.96554000",
                        "longitude": "1.58587000"
                    },
                    {
                        "id": 44137,
                        "name": "Mondonville",
                        "latitude": "43.67296000",
                        "longitude": "1.28592000"
                    },
                    {
                        "id": 44141,
                        "name": "Monestiés",
                        "latitude": "44.06667000",
                        "longitude": "2.10000000"
                    },
                    {
                        "id": 44147,
                        "name": "Mons",
                        "latitude": "43.61240000",
                        "longitude": "1.57207000"
                    },
                    {
                        "id": 44164,
                        "name": "Montady",
                        "latitude": "43.33590000",
                        "longitude": "3.12780000"
                    },
                    {
                        "id": 44165,
                        "name": "Montagnac",
                        "latitude": "43.48087000",
                        "longitude": "3.48312000"
                    },
                    {
                        "id": 44170,
                        "name": "Montaigu-de-Quercy",
                        "latitude": "44.33964000",
                        "longitude": "1.01690000"
                    },
                    {
                        "id": 44172,
                        "name": "Montaigut-sur-Save",
                        "latitude": "43.68947000",
                        "longitude": "1.23133000"
                    },
                    {
                        "id": 44176,
                        "name": "Montans",
                        "latitude": "43.86700000",
                        "longitude": "1.88568000"
                    },
                    {
                        "id": 44178,
                        "name": "Montaren-et-Saint-Médiers",
                        "latitude": "44.02869000",
                        "longitude": "4.38030000"
                    },
                    {
                        "id": 44180,
                        "name": "Montarnaud",
                        "latitude": "43.64743000",
                        "longitude": "3.69690000"
                    },
                    {
                        "id": 44181,
                        "name": "Montastruc-la-Conseillère",
                        "latitude": "43.71982000",
                        "longitude": "1.59019000"
                    },
                    {
                        "id": 44183,
                        "name": "Montauban",
                        "latitude": "44.01819000",
                        "longitude": "1.36432000"
                    },
                    {
                        "id": 44191,
                        "name": "Montbazens",
                        "latitude": "44.47807000",
                        "longitude": "2.22980000"
                    },
                    {
                        "id": 44192,
                        "name": "Montbazin",
                        "latitude": "43.51667000",
                        "longitude": "3.69667000"
                    },
                    {
                        "id": 44194,
                        "name": "Montberon",
                        "latitude": "43.71586000",
                        "longitude": "1.47968000"
                    },
                    {
                        "id": 44196,
                        "name": "Montbeton",
                        "latitude": "44.01667000",
                        "longitude": "1.30000000"
                    },
                    {
                        "id": 44198,
                        "name": "Montblanc",
                        "latitude": "43.39486000",
                        "longitude": "3.36752000"
                    },
                    {
                        "id": 44212,
                        "name": "Montcuq",
                        "latitude": "44.33838000",
                        "longitude": "1.20850000"
                    },
                    {
                        "id": 44216,
                        "name": "Montech",
                        "latitude": "43.95816000",
                        "longitude": "1.23204000"
                    },
                    {
                        "id": 44217,
                        "name": "Monteils",
                        "latitude": "44.16862000",
                        "longitude": "1.57608000"
                    },
                    {
                        "id": 44224,
                        "name": "Montescot",
                        "latitude": "42.60692000",
                        "longitude": "2.93318000"
                    },
                    {
                        "id": 44226,
                        "name": "Montesquieu-Volvestre",
                        "latitude": "43.20725000",
                        "longitude": "1.22862000"
                    },
                    {
                        "id": 44227,
                        "name": "Montesquiu d'Albera",
                        "latitude": "42.51798000",
                        "longitude": "2.88243000"
                    },
                    {
                        "id": 44231,
                        "name": "Montfaucon",
                        "latitude": "44.07245000",
                        "longitude": "4.75504000"
                    },
                    {
                        "id": 44239,
                        "name": "Montferrier-sur-Lez",
                        "latitude": "43.66742000",
                        "longitude": "3.85439000"
                    },
                    {
                        "id": 44243,
                        "name": "Montfrin",
                        "latitude": "43.87596000",
                        "longitude": "4.59959000"
                    },
                    {
                        "id": 44244,
                        "name": "Montgaillard",
                        "latitude": "42.93333000",
                        "longitude": "1.63333000"
                    },
                    {
                        "id": 44247,
                        "name": "Montgiscard",
                        "latitude": "43.46072000",
                        "longitude": "1.56739000"
                    },
                    {
                        "id": 44267,
                        "name": "Montjoie-en-Couserans",
                        "latitude": "43.00250000",
                        "longitude": "1.16000000"
                    },
                    {
                        "id": 44268,
                        "name": "Montjoire",
                        "latitude": "43.76899000",
                        "longitude": "1.53362000"
                    },
                    {
                        "id": 44269,
                        "name": "Montlaur",
                        "latitude": "43.48935000",
                        "longitude": "1.56807000"
                    },
                    {
                        "id": 44298,
                        "name": "Montpellier",
                        "latitude": "43.61092000",
                        "longitude": "3.87723000"
                    },
                    {
                        "id": 44299,
                        "name": "Montpeyroux",
                        "latitude": "43.69590000",
                        "longitude": "3.50542000"
                    },
                    {
                        "id": 44300,
                        "name": "Montpezat-de-Quercy",
                        "latitude": "44.23876000",
                        "longitude": "1.47682000"
                    },
                    {
                        "id": 44303,
                        "name": "Montrabé",
                        "latitude": "43.64477000",
                        "longitude": "1.52384000"
                    },
                    {
                        "id": 44324,
                        "name": "Montréal",
                        "latitude": "43.19980000",
                        "longitude": "2.14122000"
                    },
                    {
                        "id": 44305,
                        "name": "Montredon-Labessonnié",
                        "latitude": "43.71723000",
                        "longitude": "2.32454000"
                    },
                    {
                        "id": 44326,
                        "name": "Montréjeau",
                        "latitude": "43.08555000",
                        "longitude": "0.56470000"
                    },
                    {
                        "id": 44318,
                        "name": "Montricoux",
                        "latitude": "44.07589000",
                        "longitude": "1.61946000"
                    },
                    {
                        "id": 44319,
                        "name": "Montrodat",
                        "latitude": "44.55038000",
                        "longitude": "3.32929000"
                    },
                    {
                        "id": 44406,
                        "name": "Moussac",
                        "latitude": "43.98119000",
                        "longitude": "4.22647000"
                    },
                    {
                        "id": 44407,
                        "name": "Moussan",
                        "latitude": "43.23091000",
                        "longitude": "2.95000000"
                    },
                    {
                        "id": 44424,
                        "name": "Moyrazès",
                        "latitude": "44.34204000",
                        "longitude": "2.43933000"
                    },
                    {
                        "id": 44429,
                        "name": "Mudaison",
                        "latitude": "43.63333000",
                        "longitude": "4.03333000"
                    },
                    {
                        "id": 44440,
                        "name": "Muret",
                        "latitude": "43.46027000",
                        "longitude": "1.32571000"
                    },
                    {
                        "id": 44442,
                        "name": "Murviel-lès-Béziers",
                        "latitude": "43.43333000",
                        "longitude": "3.13333000"
                    },
                    {
                        "id": 44443,
                        "name": "Murviel-lès-Montpellier",
                        "latitude": "43.60528000",
                        "longitude": "3.73750000"
                    },
                    {
                        "id": 44444,
                        "name": "Mus",
                        "latitude": "43.73919000",
                        "longitude": "4.20257000"
                    },
                    {
                        "id": 44495,
                        "name": "Nages-et-Solorgues",
                        "latitude": "43.79010000",
                        "longitude": "4.23027000"
                    },
                    {
                        "id": 44496,
                        "name": "Nailloux",
                        "latitude": "43.35718000",
                        "longitude": "1.62302000"
                    },
                    {
                        "id": 44514,
                        "name": "Narbonne",
                        "latitude": "43.18396000",
                        "longitude": "3.00141000"
                    },
                    {
                        "id": 44518,
                        "name": "Naucelle",
                        "latitude": "44.19810000",
                        "longitude": "2.34310000"
                    },
                    {
                        "id": 44692,
                        "name": "Nébian",
                        "latitude": "43.60657000",
                        "longitude": "3.43133000"
                    },
                    {
                        "id": 44691,
                        "name": "Nègrepelisse",
                        "latitude": "44.07436000",
                        "longitude": "1.51978000"
                    },
                    {
                        "id": 44698,
                        "name": "Névian",
                        "latitude": "43.21238000",
                        "longitude": "2.90286000"
                    },
                    {
                        "id": 44700,
                        "name": "Nîmes",
                        "latitude": "43.83378000",
                        "longitude": "4.35962000"
                    },
                    {
                        "id": 44602,
                        "name": "Nissan-lez-Enserune",
                        "latitude": "43.28961000",
                        "longitude": "3.12705000"
                    },
                    {
                        "id": 44683,
                        "name": "Noé",
                        "latitude": "43.35814000",
                        "longitude": "1.27709000"
                    },
                    {
                        "id": 44609,
                        "name": "Nogaro",
                        "latitude": "43.75856000",
                        "longitude": "-0.03293000"
                    },
                    {
                        "id": 44621,
                        "name": "Nohic",
                        "latitude": "43.88970000",
                        "longitude": "1.43741000"
                    },
                    {
                        "id": 44715,
                        "name": "Odos",
                        "latitude": "43.19622000",
                        "longitude": "0.05693000"
                    },
                    {
                        "id": 44731,
                        "name": "Olemps",
                        "latitude": "44.34638000",
                        "longitude": "2.55140000"
                    },
                    {
                        "id": 44738,
                        "name": "Olonzac",
                        "latitude": "43.28294000",
                        "longitude": "2.73098000"
                    },
                    {
                        "id": 44741,
                        "name": "Ondes",
                        "latitude": "43.78250000",
                        "longitude": "1.30823000"
                    },
                    {
                        "id": 44765,
                        "name": "Orgueil",
                        "latitude": "43.90618000",
                        "longitude": "1.41071000"
                    },
                    {
                        "id": 44771,
                        "name": "Orleix",
                        "latitude": "43.27932000",
                        "longitude": "0.12033000"
                    },
                    {
                        "id": 44779,
                        "name": "Ornaisons",
                        "latitude": "43.18040000",
                        "longitude": "2.83689000"
                    },
                    {
                        "id": 44783,
                        "name": "Orsan",
                        "latitude": "44.13106000",
                        "longitude": "4.66520000"
                    },
                    {
                        "id": 44785,
                        "name": "Ortaffa",
                        "latitude": "42.57977000",
                        "longitude": "2.92653000"
                    },
                    {
                        "id": 44792,
                        "name": "Osséja",
                        "latitude": "42.41383000",
                        "longitude": "1.98192000"
                    },
                    {
                        "id": 44790,
                        "name": "Ossun",
                        "latitude": "43.18333000",
                        "longitude": "-0.03333000"
                    },
                    {
                        "id": 44809,
                        "name": "Oursbelille",
                        "latitude": "43.28508000",
                        "longitude": "0.03473000"
                    },
                    {
                        "id": 44814,
                        "name": "Ouveillan",
                        "latitude": "43.28915000",
                        "longitude": "2.97124000"
                    },
                    {
                        "id": 44833,
                        "name": "Palaja",
                        "latitude": "43.17363000",
                        "longitude": "2.38462000"
                    },
                    {
                        "id": 44835,
                        "name": "Palau-del-Vidre",
                        "latitude": "42.57162000",
                        "longitude": "2.96033000"
                    },
                    {
                        "id": 44836,
                        "name": "Palavas-les-Flots",
                        "latitude": "43.52805000",
                        "longitude": "3.92705000"
                    },
                    {
                        "id": 44838,
                        "name": "Pamiers",
                        "latitude": "43.11650000",
                        "longitude": "1.61079000"
                    },
                    {
                        "id": 44869,
                        "name": "Paulhac",
                        "latitude": "43.75639000",
                        "longitude": "1.55667000"
                    },
                    {
                        "id": 44871,
                        "name": "Paulhan",
                        "latitude": "43.53944000",
                        "longitude": "3.45760000"
                    },
                    {
                        "id": 44873,
                        "name": "Pavie",
                        "latitude": "43.60969000",
                        "longitude": "0.59143000"
                    },
                    {
                        "id": 44876,
                        "name": "Payrin-Augmontel",
                        "latitude": "43.54450000",
                        "longitude": "2.35406000"
                    },
                    {
                        "id": 45343,
                        "name": "Péchabou",
                        "latitude": "43.50241000",
                        "longitude": "1.50934000"
                    },
                    {
                        "id": 44879,
                        "name": "Pechbonnieu",
                        "latitude": "43.70242000",
                        "longitude": "1.46538000"
                    },
                    {
                        "id": 44892,
                        "name": "Pennautier",
                        "latitude": "43.24513000",
                        "longitude": "2.31892000"
                    },
                    {
                        "id": 45349,
                        "name": "Pépieux",
                        "latitude": "43.29735000",
                        "longitude": "2.67952000"
                    },
                    {
                        "id": 45360,
                        "name": "Pérols",
                        "latitude": "43.56313000",
                        "longitude": "3.95203000"
                    },
                    {
                        "id": 44899,
                        "name": "Perpignan",
                        "latitude": "42.69764000",
                        "longitude": "2.89541000"
                    },
                    {
                        "id": 44929,
                        "name": "Peyrestortes",
                        "latitude": "42.75480000",
                        "longitude": "2.85232000"
                    },
                    {
                        "id": 44931,
                        "name": "Peyriac-de-Mer",
                        "latitude": "43.08720000",
                        "longitude": "2.95831000"
                    },
                    {
                        "id": 44930,
                        "name": "Peyriac-Minervois",
                        "latitude": "43.29068000",
                        "longitude": "2.56613000"
                    },
                    {
                        "id": 45366,
                        "name": "Pézenas",
                        "latitude": "43.45953000",
                        "longitude": "3.42384000"
                    },
                    {
                        "id": 44936,
                        "name": "Pezens",
                        "latitude": "43.25446000",
                        "longitude": "2.26868000"
                    },
                    {
                        "id": 45367,
                        "name": "Pézilla-la-Rivière",
                        "latitude": "42.69536000",
                        "longitude": "2.77115000"
                    },
                    {
                        "id": 44944,
                        "name": "Pia",
                        "latitude": "42.74490000",
                        "longitude": "2.91930000"
                    },
                    {
                        "id": 44945,
                        "name": "Pibrac",
                        "latitude": "43.62042000",
                        "longitude": "1.28540000"
                    },
                    {
                        "id": 44954,
                        "name": "Pierrefitte-Nestalas",
                        "latitude": "42.96667000",
                        "longitude": "-0.06667000"
                    },
                    {
                        "id": 44968,
                        "name": "Pignan",
                        "latitude": "43.58365000",
                        "longitude": "3.75981000"
                    },
                    {
                        "id": 44970,
                        "name": "Pinet",
                        "latitude": "43.40556000",
                        "longitude": "3.51000000"
                    },
                    {
                        "id": 44973,
                        "name": "Pinsaguel",
                        "latitude": "43.51040000",
                        "longitude": "1.38831000"
                    },
                    {
                        "id": 44993,
                        "name": "Plaisance",
                        "latitude": "43.60436000",
                        "longitude": "0.04615000"
                    },
                    {
                        "id": 44994,
                        "name": "Plaisance-du-Touch",
                        "latitude": "43.56566000",
                        "longitude": "1.29749000"
                    },
                    {
                        "id": 45143,
                        "name": "Pollestres",
                        "latitude": "42.64200000",
                        "longitude": "2.87116000"
                    },
                    {
                        "id": 45159,
                        "name": "Pomérols",
                        "latitude": "43.39139000",
                        "longitude": "3.49944000"
                    },
                    {
                        "id": 45154,
                        "name": "Pompertuzat",
                        "latitude": "43.49277000",
                        "longitude": "1.51531000"
                    },
                    {
                        "id": 45157,
                        "name": "Pompignan",
                        "latitude": "43.81768000",
                        "longitude": "1.31209000"
                    },
                    {
                        "id": 45179,
                        "name": "Pont-de-Larn",
                        "latitude": "43.50412000",
                        "longitude": "2.40786000"
                    },
                    {
                        "id": 45182,
                        "name": "Pont-de-Salars",
                        "latitude": "44.28080000",
                        "longitude": "2.72783000"
                    },
                    {
                        "id": 45169,
                        "name": "Pont-Saint-Esprit",
                        "latitude": "44.25494000",
                        "longitude": "4.64736000"
                    },
                    {
                        "id": 45207,
                        "name": "Ponteilla",
                        "latitude": "42.62594000",
                        "longitude": "2.81335000"
                    },
                    {
                        "id": 45236,
                        "name": "Port-la-Nouvelle",
                        "latitude": "43.01991000",
                        "longitude": "3.04366000"
                    },
                    {
                        "id": 45239,
                        "name": "Portel-des-Corbières",
                        "latitude": "43.05000000",
                        "longitude": "2.91667000"
                    },
                    {
                        "id": 45241,
                        "name": "Portet-sur-Garonne",
                        "latitude": "43.52333000",
                        "longitude": "1.40651000"
                    },
                    {
                        "id": 45244,
                        "name": "Portiragnes",
                        "latitude": "43.30460000",
                        "longitude": "3.33365000"
                    },
                    {
                        "id": 45246,
                        "name": "Portvendres",
                        "latitude": "42.51792000",
                        "longitude": "3.10553000"
                    },
                    {
                        "id": 45264,
                        "name": "Poulx",
                        "latitude": "43.90798000",
                        "longitude": "4.41629000"
                    },
                    {
                        "id": 45268,
                        "name": "Poussan",
                        "latitude": "43.48944000",
                        "longitude": "3.67083000"
                    },
                    {
                        "id": 45270,
                        "name": "Pouzac",
                        "latitude": "43.08606000",
                        "longitude": "0.13522000"
                    },
                    {
                        "id": 45272,
                        "name": "Prades",
                        "latitude": "42.61715000",
                        "longitude": "2.42208000"
                    },
                    {
                        "id": 45273,
                        "name": "Prades-le-Lez",
                        "latitude": "43.69754000",
                        "longitude": "3.86463000"
                    },
                    {
                        "id": 45274,
                        "name": "Pradines",
                        "latitude": "44.48341000",
                        "longitude": "1.40105000"
                    },
                    {
                        "id": 45278,
                        "name": "Prats de Molló",
                        "latitude": "42.40404000",
                        "longitude": "2.47928000"
                    },
                    {
                        "id": 45279,
                        "name": "Prayssac",
                        "latitude": "44.50440000",
                        "longitude": "1.18862000"
                    },
                    {
                        "id": 45282,
                        "name": "Preignan",
                        "latitude": "43.71177000",
                        "longitude": "0.62608000"
                    },
                    {
                        "id": 45318,
                        "name": "Puicheric",
                        "latitude": "43.22380000",
                        "longitude": "2.62455000"
                    },
                    {
                        "id": 45322,
                        "name": "Puissalicon",
                        "latitude": "43.45828000",
                        "longitude": "3.23690000"
                    },
                    {
                        "id": 45323,
                        "name": "Puisserguier",
                        "latitude": "43.36767000",
                        "longitude": "3.04047000"
                    },
                    {
                        "id": 45324,
                        "name": "Pujaudran",
                        "latitude": "43.58954000",
                        "longitude": "1.14977000"
                    },
                    {
                        "id": 45325,
                        "name": "Pujaut",
                        "latitude": "44.00404000",
                        "longitude": "4.77575000"
                    },
                    {
                        "id": 45336,
                        "name": "Puy-l’Évêque",
                        "latitude": "44.50483000",
                        "longitude": "1.14015000"
                    },
                    {
                        "id": 45337,
                        "name": "Puygouzon",
                        "latitude": "43.90000000",
                        "longitude": "2.16667000"
                    },
                    {
                        "id": 45338,
                        "name": "Puylaurens",
                        "latitude": "43.57202000",
                        "longitude": "2.01227000"
                    },
                    {
                        "id": 45369,
                        "name": "Quarante",
                        "latitude": "43.34711000",
                        "longitude": "2.96228000"
                    },
                    {
                        "id": 45386,
                        "name": "Quillan",
                        "latitude": "42.87579000",
                        "longitude": "2.18176000"
                    },
                    {
                        "id": 45402,
                        "name": "Quissac",
                        "latitude": "43.91341000",
                        "longitude": "3.99920000"
                    },
                    {
                        "id": 45411,
                        "name": "Rabastens",
                        "latitude": "43.82512000",
                        "longitude": "1.72382000"
                    },
                    {
                        "id": 45412,
                        "name": "Rabastens-de-Bigorre",
                        "latitude": "43.38769000",
                        "longitude": "0.15122000"
                    },
                    {
                        "id": 45425,
                        "name": "Ramonville-Saint-Agne",
                        "latitude": "43.54618000",
                        "longitude": "1.47491000"
                    },
                    {
                        "id": 45683,
                        "name": "Réalmont",
                        "latitude": "43.77754000",
                        "longitude": "2.18885000"
                    },
                    {
                        "id": 45684,
                        "name": "Réalville",
                        "latitude": "44.11452000",
                        "longitude": "1.47998000"
                    },
                    {
                        "id": 45442,
                        "name": "Redessan",
                        "latitude": "43.83117000",
                        "longitude": "4.49771000"
                    },
                    {
                        "id": 45454,
                        "name": "Remoulins",
                        "latitude": "43.93949000",
                        "longitude": "4.56799000"
                    },
                    {
                        "id": 45695,
                        "name": "Réquista",
                        "latitude": "44.03325000",
                        "longitude": "2.53554000"
                    },
                    {
                        "id": 45466,
                        "name": "Restinclières",
                        "latitude": "43.72252000",
                        "longitude": "4.03476000"
                    },
                    {
                        "id": 45475,
                        "name": "Revel",
                        "latitude": "43.45812000",
                        "longitude": "2.00469000"
                    },
                    {
                        "id": 45480,
                        "name": "Reynès",
                        "latitude": "42.47702000",
                        "longitude": "2.70680000"
                    },
                    {
                        "id": 45484,
                        "name": "Ria-Sirach",
                        "latitude": "42.61667000",
                        "longitude": "2.40000000"
                    },
                    {
                        "id": 45489,
                        "name": "Ribaute-les-Tavernes",
                        "latitude": "44.03724000",
                        "longitude": "4.08046000"
                    },
                    {
                        "id": 45502,
                        "name": "Rieumes",
                        "latitude": "43.41143000",
                        "longitude": "1.11702000"
                    },
                    {
                        "id": 45503,
                        "name": "Rieupeyroux",
                        "latitude": "44.30799000",
                        "longitude": "2.23819000"
                    },
                    {
                        "id": 45506,
                        "name": "Rieux-Minervois",
                        "latitude": "43.28194000",
                        "longitude": "2.58687000"
                    },
                    {
                        "id": 45507,
                        "name": "Rieux-Volvestre",
                        "latitude": "43.25000000",
                        "longitude": "1.20000000"
                    },
                    {
                        "id": 45510,
                        "name": "Rignac",
                        "latitude": "44.40853000",
                        "longitude": "2.29001000"
                    },
                    {
                        "id": 45525,
                        "name": "Riscle",
                        "latitude": "43.65633000",
                        "longitude": "-0.08607000"
                    },
                    {
                        "id": 45530,
                        "name": "Rivesaltes",
                        "latitude": "42.76945000",
                        "longitude": "2.87239000"
                    },
                    {
                        "id": 45545,
                        "name": "Rochefort-du-Gard",
                        "latitude": "43.97652000",
                        "longitude": "4.69023000"
                    },
                    {
                        "id": 45554,
                        "name": "Rodez",
                        "latitude": "44.35258000",
                        "longitude": "2.57338000"
                    },
                    {
                        "id": 45555,
                        "name": "Rodilhan",
                        "latitude": "43.82725000",
                        "longitude": "4.43088000"
                    },
                    {
                        "id": 45591,
                        "name": "Roquecourbe",
                        "latitude": "43.66442000",
                        "longitude": "2.29264000"
                    },
                    {
                        "id": 45594,
                        "name": "Roquemaure",
                        "latitude": "44.04944000",
                        "longitude": "4.77740000"
                    },
                    {
                        "id": 45596,
                        "name": "Roquettes",
                        "latitude": "43.49733000",
                        "longitude": "1.36848000"
                    },
                    {
                        "id": 45620,
                        "name": "Rouffiac-Tolosan",
                        "latitude": "43.66576000",
                        "longitude": "1.52521000"
                    },
                    {
                        "id": 45630,
                        "name": "Roujan",
                        "latitude": "43.50489000",
                        "longitude": "3.31071000"
                    },
                    {
                        "id": 45640,
                        "name": "Rousson",
                        "latitude": "44.19136000",
                        "longitude": "4.14786000"
                    },
                    {
                        "id": 45704,
                        "name": "Sabran",
                        "latitude": "44.15040000",
                        "longitude": "4.54820000"
                    },
                    {
                        "id": 45727,
                        "name": "Saint-Affrique",
                        "latitude": "43.95575000",
                        "longitude": "2.88915000"
                    },
                    {
                        "id": 45735,
                        "name": "Saint-Alban",
                        "latitude": "43.69270000",
                        "longitude": "1.41020000"
                    },
                    {
                        "id": 45738,
                        "name": "Saint-Alban-sur-Limagnole",
                        "latitude": "44.78100000",
                        "longitude": "3.38793000"
                    },
                    {
                        "id": 45739,
                        "name": "Saint-Alexandre",
                        "latitude": "44.22741000",
                        "longitude": "4.62081000"
                    },
                    {
                        "id": 45746,
                        "name": "Saint-Amans-Soult",
                        "latitude": "43.47697000",
                        "longitude": "2.49076000"
                    },
                    {
                        "id": 45747,
                        "name": "Saint-Amans-Valtoret",
                        "latitude": "43.48071000",
                        "longitude": "2.49095000"
                    },
                    {
                        "id": 45751,
                        "name": "Saint-Ambroix",
                        "latitude": "44.25893000",
                        "longitude": "4.19833000"
                    },
                    {
                        "id": 45758,
                        "name": "Saint-André-de-Sangonis",
                        "latitude": "43.64753000",
                        "longitude": "3.50209000"
                    },
                    {
                        "id": 45795,
                        "name": "Saint-Aunès",
                        "latitude": "43.64083000",
                        "longitude": "3.96583000"
                    },
                    {
                        "id": 45807,
                        "name": "Saint-Bauzille-de-Putois",
                        "latitude": "43.89454000",
                        "longitude": "3.73580000"
                    },
                    {
                        "id": 45811,
                        "name": "Saint-Benoît-de-Carmaux",
                        "latitude": "44.05037000",
                        "longitude": "2.12911000"
                    },
                    {
                        "id": 45834,
                        "name": "Saint-Brès",
                        "latitude": "43.66742000",
                        "longitude": "4.03105000"
                    },
                    {
                        "id": 45892,
                        "name": "Saint-Céré",
                        "latitude": "44.85726000",
                        "longitude": "1.89415000"
                    },
                    {
                        "id": 45848,
                        "name": "Saint-Chaptes",
                        "latitude": "43.97172000",
                        "longitude": "4.27812000"
                    },
                    {
                        "id": 45851,
                        "name": "Saint-Chinian",
                        "latitude": "43.42238000",
                        "longitude": "2.94643000"
                    },
                    {
                        "id": 45853,
                        "name": "Saint-Christol",
                        "latitude": "43.72805000",
                        "longitude": "4.07991000"
                    },
                    {
                        "id": 45854,
                        "name": "Saint-Christol-lès-Alès",
                        "latitude": "44.08256000",
                        "longitude": "4.07506000"
                    },
                    {
                        "id": 45856,
                        "name": "Saint-Christophe-Vallon",
                        "latitude": "44.47072000",
                        "longitude": "2.41184000"
                    },
                    {
                        "id": 45871,
                        "name": "Saint-Clément-de-Rivière",
                        "latitude": "43.68333000",
                        "longitude": "3.83333000"
                    },
                    {
                        "id": 45881,
                        "name": "Saint-Cyprien-Plage",
                        "latitude": "42.63229000",
                        "longitude": "3.03333000"
                    },
                    {
                        "id": 45918,
                        "name": "Saint-Drézéry",
                        "latitude": "43.72991000",
                        "longitude": "3.97620000"
                    },
                    {
                        "id": 45924,
                        "name": "Saint-Estève",
                        "latitude": "42.71175000",
                        "longitude": "2.84490000"
                    },
                    {
                        "id": 45926,
                        "name": "Saint-Etienne-de-Tulmont",
                        "latitude": "44.05000000",
                        "longitude": "1.46667000"
                    },
                    {
                        "id": 45946,
                        "name": "Saint-Féliu-d’Avall",
                        "latitude": "42.68117000",
                        "longitude": "2.73813000"
                    },
                    {
                        "id": 45948,
                        "name": "Saint-Félix-Lauragais",
                        "latitude": "43.44863000",
                        "longitude": "1.88814000"
                    },
                    {
                        "id": 45935,
                        "name": "Saint-Florent-sur-Auzonnet",
                        "latitude": "44.24032000",
                        "longitude": "4.11252000"
                    },
                    {
                        "id": 45951,
                        "name": "Saint-Gaudens",
                        "latitude": "43.10809000",
                        "longitude": "0.72345000"
                    },
                    {
                        "id": 46043,
                        "name": "Saint-Gély-du-Fesc",
                        "latitude": "43.69272000",
                        "longitude": "3.80492000"
                    },
                    {
                        "id": 45964,
                        "name": "Saint-Geniès-Bellevue",
                        "latitude": "43.68409000",
                        "longitude": "1.48693000"
                    },
                    {
                        "id": 45965,
                        "name": "Saint-Geniès-de-Comolas",
                        "latitude": "44.06617000",
                        "longitude": "4.72157000"
                    },
                    {
                        "id": 45966,
                        "name": "Saint-Geniès-de-Fontedit",
                        "latitude": "43.46667000",
                        "longitude": "3.18333000"
                    },
                    {
                        "id": 45967,
                        "name": "Saint-Geniès-de-Malgoirès",
                        "latitude": "43.95000000",
                        "longitude": "4.21667000"
                    },
                    {
                        "id": 45968,
                        "name": "Saint-Geniès-des-Mourgues",
                        "latitude": "43.69780000",
                        "longitude": "4.03610000"
                    },
                    {
                        "id": 45958,
                        "name": "Saint-Geniez-d’Olt",
                        "latitude": "44.46561000",
                        "longitude": "2.97261000"
                    },
                    {
                        "id": 46044,
                        "name": "Saint-Génis-des-Fontaines",
                        "latitude": "42.54325000",
                        "longitude": "2.92060000"
                    },
                    {
                        "id": 45975,
                        "name": "Saint-Georges-de-Luzençon",
                        "latitude": "44.06471000",
                        "longitude": "2.98597000"
                    },
                    {
                        "id": 46031,
                        "name": "Saint-Gervasy",
                        "latitude": "43.87687000",
                        "longitude": "4.46588000"
                    },
                    {
                        "id": 46034,
                        "name": "Saint-Gilles",
                        "latitude": "43.67656000",
                        "longitude": "4.43024000"
                    },
                    {
                        "id": 46038,
                        "name": "Saint-Girons",
                        "latitude": "42.98491000",
                        "longitude": "1.14587000"
                    },
                    {
                        "id": 46054,
                        "name": "Saint-Hilaire-de-Brethmas",
                        "latitude": "44.08003000",
                        "longitude": "4.12478000"
                    },
                    {
                        "id": 46067,
                        "name": "Saint-Hippolyte",
                        "latitude": "42.78550000",
                        "longitude": "2.96620000"
                    },
                    {
                        "id": 46071,
                        "name": "Saint-Hippolyte-du-Fort",
                        "latitude": "43.96362000",
                        "longitude": "3.85572000"
                    },
                    {
                        "id": 46081,
                        "name": "Saint-Jean",
                        "latitude": "43.66420000",
                        "longitude": "1.49941000"
                    },
                    {
                        "id": 46090,
                        "name": "Saint-Jean-de-Fos",
                        "latitude": "43.70100000",
                        "longitude": "3.55171000"
                    },
                    {
                        "id": 46104,
                        "name": "Saint-Jean-de-Védas",
                        "latitude": "43.57759000",
                        "longitude": "3.82603000"
                    },
                    {
                        "id": 46110,
                        "name": "Saint-Jean-du-Falga",
                        "latitude": "43.08647000",
                        "longitude": "1.62780000"
                    },
                    {
                        "id": 46111,
                        "name": "Saint-Jean-du-Gard",
                        "latitude": "44.10523000",
                        "longitude": "3.88566000"
                    },
                    {
                        "id": 46126,
                        "name": "Saint-Jory",
                        "latitude": "43.74146000",
                        "longitude": "1.37089000"
                    },
                    {
                        "id": 46165,
                        "name": "Saint-Juéry",
                        "latitude": "43.95000000",
                        "longitude": "2.21667000"
                    },
                    {
                        "id": 46140,
                        "name": "Saint-Julien-de-Peyrolas",
                        "latitude": "44.28837000",
                        "longitude": "4.56507000"
                    },
                    {
                        "id": 46146,
                        "name": "Saint-Julien-les-Rosiers",
                        "latitude": "44.17445000",
                        "longitude": "4.10803000"
                    },
                    {
                        "id": 46151,
                        "name": "Saint-Just",
                        "latitude": "43.65806000",
                        "longitude": "4.11472000"
                    },
                    {
                        "id": 46170,
                        "name": "Saint-Lary-Soulan",
                        "latitude": "42.81713000",
                        "longitude": "0.32238000"
                    },
                    {
                        "id": 46180,
                        "name": "Saint-Laurent-de-la-Salanque",
                        "latitude": "42.77270000",
                        "longitude": "2.98998000"
                    },
                    {
                        "id": 46181,
                        "name": "Saint-Laurent-des-Arbres",
                        "latitude": "44.05493000",
                        "longitude": "4.70026000"
                    },
                    {
                        "id": 46194,
                        "name": "Saint-Lizier",
                        "latitude": "43.00183000",
                        "longitude": "1.13686000"
                    },
                    {
                        "id": 46200,
                        "name": "Saint-Loup-Cammas",
                        "latitude": "43.69767000",
                        "longitude": "1.48127000"
                    },
                    {
                        "id": 46208,
                        "name": "Saint-Lys",
                        "latitude": "43.51127000",
                        "longitude": "1.17557000"
                    },
                    {
                        "id": 46232,
                        "name": "Saint-Mamert-du-Gard",
                        "latitude": "43.88835000",
                        "longitude": "4.18725000"
                    },
                    {
                        "id": 46249,
                        "name": "Saint-Marcel-sur-Aude",
                        "latitude": "43.25000000",
                        "longitude": "2.93333000"
                    },
                    {
                        "id": 46274,
                        "name": "Saint-Martin-de-Londres",
                        "latitude": "43.79040000",
                        "longitude": "3.73066000"
                    },
                    {
                        "id": 46280,
                        "name": "Saint-Martin-de-Valgalgues",
                        "latitude": "44.16315000",
                        "longitude": "4.08364000"
                    },
                    {
                        "id": 46263,
                        "name": "Saint-Martin-Lalande",
                        "latitude": "43.29928000",
                        "longitude": "2.02004000"
                    },
                    {
                        "id": 46306,
                        "name": "Saint-Mathieu-de-Tréviers",
                        "latitude": "43.76795000",
                        "longitude": "3.85814000"
                    },
                    {
                        "id": 46357,
                        "name": "Saint-Nauphary",
                        "latitude": "43.96712000",
                        "longitude": "1.42549000"
                    },
                    {
                        "id": 46359,
                        "name": "Saint-Nazaire",
                        "latitude": "42.66790000",
                        "longitude": "2.99168000"
                    },
                    {
                        "id": 46360,
                        "name": "Saint-Nazaire-d’Aude",
                        "latitude": "43.24518000",
                        "longitude": "2.89443000"
                    },
                    {
                        "id": 46366,
                        "name": "Saint-Nicolas-de-la-Grave",
                        "latitude": "44.06417000",
                        "longitude": "1.02280000"
                    },
                    {
                        "id": 46375,
                        "name": "Saint-Orens-de-Gameville",
                        "latitude": "43.55402000",
                        "longitude": "1.53411000"
                    },
                    {
                        "id": 46395,
                        "name": "Saint-Pargoire",
                        "latitude": "43.52766000",
                        "longitude": "3.51870000"
                    },
                    {
                        "id": 46404,
                        "name": "Saint-Paul-Cap-de-Joux",
                        "latitude": "43.64791000",
                        "longitude": "1.97559000"
                    },
                    {
                        "id": 46406,
                        "name": "Saint-Paul-de-Fenouillet",
                        "latitude": "42.80938000",
                        "longitude": "2.50374000"
                    },
                    {
                        "id": 46407,
                        "name": "Saint-Paul-de-Jarrat",
                        "latitude": "42.91404000",
                        "longitude": "1.65437000"
                    },
                    {
                        "id": 46418,
                        "name": "Saint-Paulet-de-Caisson",
                        "latitude": "44.26055000",
                        "longitude": "4.59785000"
                    },
                    {
                        "id": 46480,
                        "name": "Saint-Pé-de-Bigorre",
                        "latitude": "43.10369000",
                        "longitude": "-0.15943000"
                    },
                    {
                        "id": 46458,
                        "name": "Saint-Pons-de-Thomières",
                        "latitude": "43.48333000",
                        "longitude": "2.76667000"
                    },
                    {
                        "id": 46460,
                        "name": "Saint-Porquier",
                        "latitude": "44.00344000",
                        "longitude": "1.17932000"
                    },
                    {
                        "id": 46470,
                        "name": "Saint-Privat-des-Vieux",
                        "latitude": "44.14415000",
                        "longitude": "4.12988000"
                    },
                    {
                        "id": 46490,
                        "name": "Saint-Quentin-la-Poterie",
                        "latitude": "44.04392000",
                        "longitude": "4.44432000"
                    },
                    {
                        "id": 46531,
                        "name": "Saint-Sauveur",
                        "latitude": "43.74830000",
                        "longitude": "1.40085000"
                    },
                    {
                        "id": 46566,
                        "name": "Saint-Sulpice-la-Pointe",
                        "latitude": "43.77500000",
                        "longitude": "1.68511000"
                    },
                    {
                        "id": 46569,
                        "name": "Saint-Sulpice-sur-Lèze",
                        "latitude": "43.33076000",
                        "longitude": "1.32091000"
                    },
                    {
                        "id": 46580,
                        "name": "Saint-Thibéry",
                        "latitude": "43.39657000",
                        "longitude": "3.41774000"
                    },
                    {
                        "id": 46609,
                        "name": "Saint-Victor-la-Coste",
                        "latitude": "44.06295000",
                        "longitude": "4.64238000"
                    },
                    {
                        "id": 46683,
                        "name": "Sainte-Foy-de-Peyrolières",
                        "latitude": "43.49262000",
                        "longitude": "1.14477000"
                    },
                    {
                        "id": 46694,
                        "name": "Sainte-Geneviève-sur-Argence",
                        "latitude": "44.80222000",
                        "longitude": "2.75954000"
                    },
                    {
                        "id": 46709,
                        "name": "Sainte-Marie-Plage",
                        "latitude": "42.72498000",
                        "longitude": "3.03751000"
                    },
                    {
                        "id": 46722,
                        "name": "Sainte-Radegonde",
                        "latitude": "44.33743000",
                        "longitude": "2.62672000"
                    },
                    {
                        "id": 46892,
                        "name": "Saïx",
                        "latitude": "43.58333000",
                        "longitude": "2.18333000"
                    },
                    {
                        "id": 46744,
                        "name": "Saleilles",
                        "latitude": "42.65418000",
                        "longitude": "2.95309000"
                    },
                    {
                        "id": 46749,
                        "name": "Salies-du-Salat",
                        "latitude": "43.10074000",
                        "longitude": "0.95866000"
                    },
                    {
                        "id": 46753,
                        "name": "Salindres",
                        "latitude": "44.17174000",
                        "longitude": "4.16020000"
                    },
                    {
                        "id": 46762,
                        "name": "Salles-Curan",
                        "latitude": "44.18220000",
                        "longitude": "2.78821000"
                    },
                    {
                        "id": 46763,
                        "name": "Salles-la-Source",
                        "latitude": "44.43505000",
                        "longitude": "2.51283000"
                    },
                    {
                        "id": 46768,
                        "name": "Salses-le-Château",
                        "latitude": "42.83333000",
                        "longitude": "2.91667000"
                    },
                    {
                        "id": 46769,
                        "name": "Salviac",
                        "latitude": "44.68080000",
                        "longitude": "1.26506000"
                    },
                    {
                        "id": 46771,
                        "name": "Samatan",
                        "latitude": "43.49286000",
                        "longitude": "0.92976000"
                    },
                    {
                        "id": 46792,
                        "name": "Sant Andreu de Sureda",
                        "latitude": "42.55201000",
                        "longitude": "2.97129000"
                    },
                    {
                        "id": 46793,
                        "name": "Sant Joan de Pladecorts",
                        "latitude": "42.51069000",
                        "longitude": "2.79091000"
                    },
                    {
                        "id": 46794,
                        "name": "Sant Llorenç de Cerdans",
                        "latitude": "42.38473000",
                        "longitude": "2.61320000"
                    },
                    {
                        "id": 46831,
                        "name": "Saubens",
                        "latitude": "43.47984000",
                        "longitude": "1.35189000"
                    },
                    {
                        "id": 46854,
                        "name": "Saussan",
                        "latitude": "43.57220000",
                        "longitude": "3.77500000"
                    },
                    {
                        "id": 46859,
                        "name": "Sauve",
                        "latitude": "43.94150000",
                        "longitude": "3.94903000"
                    },
                    {
                        "id": 46861,
                        "name": "Sauveterre",
                        "latitude": "44.02282000",
                        "longitude": "4.79347000"
                    },
                    {
                        "id": 46864,
                        "name": "Sauvian",
                        "latitude": "43.29293000",
                        "longitude": "3.26024000"
                    },
                    {
                        "id": 46873,
                        "name": "Saverdun",
                        "latitude": "43.23526000",
                        "longitude": "1.57398000"
                    },
                    {
                        "id": 46890,
                        "name": "Saze",
                        "latitude": "43.94340000",
                        "longitude": "4.68096000"
                    },
                    {
                        "id": 47132,
                        "name": "Sébazac-Concourès",
                        "latitude": "44.40484000",
                        "longitude": "2.60324000"
                    },
                    {
                        "id": 46921,
                        "name": "Seilh",
                        "latitude": "43.69469000",
                        "longitude": "1.35509000"
                    },
                    {
                        "id": 46929,
                        "name": "Seissan",
                        "latitude": "43.49215000",
                        "longitude": "0.59250000"
                    },
                    {
                        "id": 47137,
                        "name": "Sémalens",
                        "latitude": "43.59225000",
                        "longitude": "2.11208000"
                    },
                    {
                        "id": 47138,
                        "name": "Séméac",
                        "latitude": "43.22915000",
                        "longitude": "0.10602000"
                    },
                    {
                        "id": 46949,
                        "name": "Septfonds",
                        "latitude": "44.17813000",
                        "longitude": "1.61806000"
                    },
                    {
                        "id": 47144,
                        "name": "Sérignan",
                        "latitude": "43.27873000",
                        "longitude": "3.27712000"
                    },
                    {
                        "id": 46960,
                        "name": "Sernhac",
                        "latitude": "43.91116000",
                        "longitude": "4.55039000"
                    },
                    {
                        "id": 46972,
                        "name": "Servian",
                        "latitude": "43.42716000",
                        "longitude": "3.30032000"
                    },
                    {
                        "id": 47129,
                        "name": "Sète",
                        "latitude": "43.40280000",
                        "longitude": "3.69278000"
                    },
                    {
                        "id": 47150,
                        "name": "Sévérac-le-Château",
                        "latitude": "44.32429000",
                        "longitude": "3.05929000"
                    },
                    {
                        "id": 46984,
                        "name": "Seysses",
                        "latitude": "43.49801000",
                        "longitude": "1.31081000"
                    },
                    {
                        "id": 46991,
                        "name": "Sigean",
                        "latitude": "43.02777000",
                        "longitude": "2.97916000"
                    },
                    {
                        "id": 47036,
                        "name": "Sommières",
                        "latitude": "43.78534000",
                        "longitude": "4.08973000"
                    },
                    {
                        "id": 47050,
                        "name": "Sorède",
                        "latitude": "42.53069000",
                        "longitude": "2.95708000"
                    },
                    {
                        "id": 47051,
                        "name": "Sorèze",
                        "latitude": "43.45241000",
                        "longitude": "2.06799000"
                    },
                    {
                        "id": 47055,
                        "name": "Soual",
                        "latitude": "43.55530000",
                        "longitude": "2.11679000"
                    },
                    {
                        "id": 47063,
                        "name": "Soues",
                        "latitude": "43.20736000",
                        "longitude": "0.09874000"
                    },
                    {
                        "id": 47067,
                        "name": "Souillac",
                        "latitude": "44.89720000",
                        "longitude": "1.47224000"
                    },
                    {
                        "id": 47116,
                        "name": "Sumène",
                        "latitude": "43.98057000",
                        "longitude": "3.71575000"
                    },
                    {
                        "id": 47126,
                        "name": "Sussargues",
                        "latitude": "43.71250000",
                        "longitude": "4.00310000"
                    },
                    {
                        "id": 47177,
                        "name": "Tarascon-sur-Ariège",
                        "latitude": "42.84545000",
                        "longitude": "1.60332000"
                    },
                    {
                        "id": 47178,
                        "name": "Tarbes",
                        "latitude": "43.23333000",
                        "longitude": "0.08333000"
                    },
                    {
                        "id": 47180,
                        "name": "Tarn",
                        "latitude": "43.78170000",
                        "longitude": "2.16317000"
                    },
                    {
                        "id": 47191,
                        "name": "Tavel",
                        "latitude": "44.01270000",
                        "longitude": "4.69835000"
                    },
                    {
                        "id": 47215,
                        "name": "Teyran",
                        "latitude": "43.68528000",
                        "longitude": "3.92889000"
                    },
                    {
                        "id": 47273,
                        "name": "Théza",
                        "latitude": "42.63797000",
                        "longitude": "2.95108000"
                    },
                    {
                        "id": 47274,
                        "name": "Thézan-lès-Béziers",
                        "latitude": "43.41667000",
                        "longitude": "3.16667000"
                    },
                    {
                        "id": 47259,
                        "name": "Thuir",
                        "latitude": "42.63290000",
                        "longitude": "2.75471000"
                    },
                    {
                        "id": 47304,
                        "name": "Torreilles",
                        "latitude": "42.75433000",
                        "longitude": "2.99292000"
                    },
                    {
                        "id": 47315,
                        "name": "Toulouges",
                        "latitude": "42.66961000",
                        "longitude": "2.83008000"
                    },
                    {
                        "id": 47316,
                        "name": "Toulouse",
                        "latitude": "43.60426000",
                        "longitude": "1.44367000"
                    },
                    {
                        "id": 47319,
                        "name": "Tourbes",
                        "latitude": "43.44615000",
                        "longitude": "3.37852000"
                    },
                    {
                        "id": 47323,
                        "name": "Tournay",
                        "latitude": "43.18438000",
                        "longitude": "0.24454000"
                    },
                    {
                        "id": 47324,
                        "name": "Tournefeuille",
                        "latitude": "43.58872000",
                        "longitude": "1.31922000"
                    },
                    {
                        "id": 47389,
                        "name": "Trèbes",
                        "latitude": "43.21064000",
                        "longitude": "2.44165000"
                    },
                    {
                        "id": 47361,
                        "name": "Tresques",
                        "latitude": "44.10689000",
                        "longitude": "4.58739000"
                    },
                    {
                        "id": 47370,
                        "name": "Trie-sur-Baïse",
                        "latitude": "43.33333000",
                        "longitude": "0.36667000"
                    },
                    {
                        "id": 47382,
                        "name": "Trouillas",
                        "latitude": "42.61089000",
                        "longitude": "2.80821000"
                    },
                    {
                        "id": 47420,
                        "name": "Uchaud",
                        "latitude": "43.75857000",
                        "longitude": "4.26843000"
                    },
                    {
                        "id": 47448,
                        "name": "Uzès",
                        "latitude": "44.01362000",
                        "longitude": "4.41529000"
                    },
                    {
                        "id": 47452,
                        "name": "Vacquiers",
                        "latitude": "43.77667000",
                        "longitude": "1.48127000"
                    },
                    {
                        "id": 47455,
                        "name": "Vailhauquès",
                        "latitude": "43.67159000",
                        "longitude": "3.72042000"
                    },
                    {
                        "id": 47466,
                        "name": "Valady",
                        "latitude": "44.45633000",
                        "longitude": "2.42746000"
                    },
                    {
                        "id": 47470,
                        "name": "Valence",
                        "latitude": "44.10823000",
                        "longitude": "0.89101000"
                    },
                    {
                        "id": 47472,
                        "name": "Valence-d’Albigeois",
                        "latitude": "44.01928000",
                        "longitude": "2.40534000"
                    },
                    {
                        "id": 47473,
                        "name": "Valence-sur-Baïse",
                        "latitude": "43.88270000",
                        "longitude": "0.38111000"
                    },
                    {
                        "id": 47480,
                        "name": "Valergues",
                        "latitude": "43.66824000",
                        "longitude": "4.06124000"
                    },
                    {
                        "id": 47484,
                        "name": "Vallabrègues",
                        "latitude": "43.85307000",
                        "longitude": "4.62662000"
                    },
                    {
                        "id": 47487,
                        "name": "Valleraugue",
                        "latitude": "44.08130000",
                        "longitude": "3.64154000"
                    },
                    {
                        "id": 47498,
                        "name": "Valras-Plage",
                        "latitude": "43.24808000",
                        "longitude": "3.29032000"
                    },
                    {
                        "id": 47499,
                        "name": "Valros",
                        "latitude": "43.41956000",
                        "longitude": "3.36506000"
                    },
                    {
                        "id": 47518,
                        "name": "Varilhes",
                        "latitude": "43.04514000",
                        "longitude": "1.62805000"
                    },
                    {
                        "id": 47544,
                        "name": "Vauvert",
                        "latitude": "43.69529000",
                        "longitude": "4.27705000"
                    },
                    {
                        "id": 47550,
                        "name": "Vayrac",
                        "latitude": "44.95337000",
                        "longitude": "1.70358000"
                    },
                    {
                        "id": 47566,
                        "name": "Vendargues",
                        "latitude": "43.65833000",
                        "longitude": "3.97000000"
                    },
                    {
                        "id": 47577,
                        "name": "Vendres",
                        "latitude": "43.26977000",
                        "longitude": "3.22341000"
                    },
                    {
                        "id": 47927,
                        "name": "Vénéjan",
                        "latitude": "44.19729000",
                        "longitude": "4.65422000"
                    },
                    {
                        "id": 47581,
                        "name": "Venerque",
                        "latitude": "43.43457000",
                        "longitude": "1.44588000"
                    },
                    {
                        "id": 47594,
                        "name": "Verdun-sur-Garonne",
                        "latitude": "43.85446000",
                        "longitude": "1.23425000"
                    },
                    {
                        "id": 47597,
                        "name": "Verfeil",
                        "latitude": "43.65781000",
                        "longitude": "1.66340000"
                    },
                    {
                        "id": 47601,
                        "name": "Vergèze",
                        "latitude": "43.74404000",
                        "longitude": "4.22109000"
                    },
                    {
                        "id": 47610,
                        "name": "Vernet",
                        "latitude": "43.43333000",
                        "longitude": "1.41667000"
                    },
                    {
                        "id": 47611,
                        "name": "Vernet-les-Bains",
                        "latitude": "42.54834000",
                        "longitude": "2.38717000"
                    },
                    {
                        "id": 47616,
                        "name": "Verniolle",
                        "latitude": "43.08162000",
                        "longitude": "1.64904000"
                    },
                    {
                        "id": 47631,
                        "name": "Vers-Pont-du-Gard",
                        "latitude": "43.96667000",
                        "longitude": "4.53333000"
                    },
                    {
                        "id": 47650,
                        "name": "Vestric-et-Candiac",
                        "latitude": "43.74061000",
                        "longitude": "4.25914000"
                    },
                    {
                        "id": 47933,
                        "name": "Vézénobres",
                        "latitude": "44.05130000",
                        "longitude": "4.13775000"
                    },
                    {
                        "id": 47661,
                        "name": "Vias",
                        "latitude": "43.31156000",
                        "longitude": "3.41774000"
                    },
                    {
                        "id": 47664,
                        "name": "Vic-en-Bigorre",
                        "latitude": "43.38682000",
                        "longitude": "0.05471000"
                    },
                    {
                        "id": 47663,
                        "name": "Vic-Fezensac",
                        "latitude": "43.77183000",
                        "longitude": "0.31368000"
                    },
                    {
                        "id": 47665,
                        "name": "Vic-la-Gardiole",
                        "latitude": "43.49080000",
                        "longitude": "3.79750000"
                    },
                    {
                        "id": 47676,
                        "name": "Vieille-Toulouse",
                        "latitude": "43.52366000",
                        "longitude": "1.44230000"
                    },
                    {
                        "id": 47680,
                        "name": "Vielmur-sur-Agout",
                        "latitude": "43.61667000",
                        "longitude": "2.10000000"
                    },
                    {
                        "id": 47704,
                        "name": "Vilallonga dels Monts",
                        "latitude": "42.52557000",
                        "longitude": "2.90434000"
                    },
                    {
                        "id": 47715,
                        "name": "Villaudric",
                        "latitude": "43.83044000",
                        "longitude": "1.43166000"
                    },
                    {
                        "id": 47735,
                        "name": "Villefranche-d'Albigeois",
                        "latitude": "43.89635000",
                        "longitude": "2.33022000"
                    },
                    {
                        "id": 47736,
                        "name": "Villefranche-de-Lauragais",
                        "latitude": "43.40000000",
                        "longitude": "1.71694000"
                    },
                    {
                        "id": 47737,
                        "name": "Villefranche-de-Rouergue",
                        "latitude": "44.35166000",
                        "longitude": "2.03702000"
                    },
                    {
                        "id": 47743,
                        "name": "Villegailhenc",
                        "latitude": "43.26867000",
                        "longitude": "2.35469000"
                    },
                    {
                        "id": 47748,
                        "name": "Villelongue-de-la-Salanque",
                        "latitude": "42.72637000",
                        "longitude": "2.98240000"
                    },
                    {
                        "id": 47753,
                        "name": "Villemolaque",
                        "latitude": "42.58815000",
                        "longitude": "2.83890000"
                    },
                    {
                        "id": 47755,
                        "name": "Villemoustaussou",
                        "latitude": "43.25186000",
                        "longitude": "2.36552000"
                    },
                    {
                        "id": 47756,
                        "name": "Villemur-sur-Tarn",
                        "latitude": "43.86708000",
                        "longitude": "1.50281000"
                    },
                    {
                        "id": 47761,
                        "name": "Villeneuve",
                        "latitude": "44.43333000",
                        "longitude": "2.03333000"
                    },
                    {
                        "id": 47771,
                        "name": "Villeneuve-d’Olmes",
                        "latitude": "42.90610000",
                        "longitude": "1.81937000"
                    },
                    {
                        "id": 47770,
                        "name": "Villeneuve-de-la-Raho",
                        "latitude": "42.63596000",
                        "longitude": "2.91651000"
                    },
                    {
                        "id": 47769,
                        "name": "Villeneuve-de-Rivière",
                        "latitude": "43.12829000",
                        "longitude": "0.66351000"
                    },
                    {
                        "id": 47772,
                        "name": "Villeneuve-la-Comptal",
                        "latitude": "43.28833000",
                        "longitude": "1.91773000"
                    },
                    {
                        "id": 47775,
                        "name": "Villeneuve-la-Rivière",
                        "latitude": "42.69366000",
                        "longitude": "2.80294000"
                    },
                    {
                        "id": 47779,
                        "name": "Villeneuve-lès-Avignon",
                        "latitude": "43.96840000",
                        "longitude": "4.79630000"
                    },
                    {
                        "id": 47781,
                        "name": "Villeneuve-lès-Béziers",
                        "latitude": "43.31517000",
                        "longitude": "3.28059000"
                    },
                    {
                        "id": 47780,
                        "name": "Villeneuve-lès-Bouloc",
                        "latitude": "43.76769000",
                        "longitude": "1.42278000"
                    },
                    {
                        "id": 47782,
                        "name": "Villeneuve-lès-Maguelone",
                        "latitude": "43.53333000",
                        "longitude": "3.86667000"
                    },
                    {
                        "id": 47765,
                        "name": "Villeneuve-Tolosane",
                        "latitude": "43.52316000",
                        "longitude": "1.34102000"
                    },
                    {
                        "id": 47787,
                        "name": "Villenouvelle",
                        "latitude": "43.43581000",
                        "longitude": "1.66279000"
                    },
                    {
                        "id": 47791,
                        "name": "Villepinte",
                        "latitude": "43.28213000",
                        "longitude": "2.08760000"
                    },
                    {
                        "id": 47816,
                        "name": "Villetelle",
                        "latitude": "43.73105000",
                        "longitude": "4.13658000"
                    },
                    {
                        "id": 47820,
                        "name": "Villeveyrac",
                        "latitude": "43.50095000",
                        "longitude": "3.60723000"
                    },
                    {
                        "id": 47821,
                        "name": "Villevieille",
                        "latitude": "43.78795000",
                        "longitude": "4.09756000"
                    },
                    {
                        "id": 47842,
                        "name": "Vinassan",
                        "latitude": "43.20443000",
                        "longitude": "3.07463000"
                    },
                    {
                        "id": 47851,
                        "name": "Vinça",
                        "latitude": "42.64486000",
                        "longitude": "2.52830000"
                    },
                    {
                        "id": 47884,
                        "name": "Viviers-lès-Montagnes",
                        "latitude": "43.55474000",
                        "longitude": "2.17672000"
                    },
                    {
                        "id": 47885,
                        "name": "Viviez",
                        "latitude": "44.55678000",
                        "longitude": "2.21649000"
                    }
                ]
            },
            {
                "id": 5028,
                "name": "Oise",
                "iso2": "60",
                "latitude": "49.41173350",
                "longitude": "1.86688250",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5029,
                "name": "Orne",
                "iso2": "61",
                "latitude": "48.57576440",
                "longitude": "-0.50242950",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4816,
                "name": "Paris",
                "iso2": "75C",
                "latitude": "48.85661400",
                "longitude": "2.35222190",
                "type": "metropolitan collectivity with special status",
                "cities": []
            },
            {
                "id": 5030,
                "name": "Pas-de-Calais",
                "iso2": "62",
                "latitude": "50.51446990",
                "longitude": "1.81149800",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4802,
                "name": "Pays-de-la-Loire",
                "iso2": "PDL",
                "latitude": "47.76328360",
                "longitude": "-0.32996870",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39234,
                        "name": "Abbaretz",
                        "latitude": "47.55314000",
                        "longitude": "-1.53200000"
                    },
                    {
                        "id": 39265,
                        "name": "Ahuillé",
                        "latitude": "48.02086000",
                        "longitude": "-0.86906000"
                    },
                    {
                        "id": 39270,
                        "name": "Aigné",
                        "latitude": "48.06471000",
                        "longitude": "0.11908000"
                    },
                    {
                        "id": 39272,
                        "name": "Aigrefeuille-sur-Maine",
                        "latitude": "47.07888000",
                        "longitude": "-1.40254000"
                    },
                    {
                        "id": 39297,
                        "name": "Aizenay",
                        "latitude": "46.74004000",
                        "longitude": "-1.60834000"
                    },
                    {
                        "id": 39330,
                        "name": "Allonnes",
                        "latitude": "47.29338000",
                        "longitude": "0.02458000"
                    },
                    {
                        "id": 39357,
                        "name": "Ambrières-les-Vallées",
                        "latitude": "48.40000000",
                        "longitude": "-0.63333000"
                    },
                    {
                        "id": 39371,
                        "name": "Ancenis",
                        "latitude": "47.36667000",
                        "longitude": "-1.16667000"
                    },
                    {
                        "id": 39378,
                        "name": "Andard",
                        "latitude": "47.45659000",
                        "longitude": "-0.39752000"
                    },
                    {
                        "id": 39386,
                        "name": "Andouillé",
                        "latitude": "48.17685000",
                        "longitude": "-0.78364000"
                    },
                    {
                        "id": 39389,
                        "name": "Andrezé",
                        "latitude": "47.17155000",
                        "longitude": "-0.95239000"
                    },
                    {
                        "id": 39395,
                        "name": "Anetz",
                        "latitude": "47.38059000",
                        "longitude": "-1.10583000"
                    },
                    {
                        "id": 39396,
                        "name": "Angers",
                        "latitude": "47.47381000",
                        "longitude": "-0.54774000"
                    },
                    {
                        "id": 39402,
                        "name": "Angles",
                        "latitude": "46.40839000",
                        "longitude": "-1.40389000"
                    },
                    {
                        "id": 39433,
                        "name": "Antigny",
                        "latitude": "46.62095000",
                        "longitude": "-0.76988000"
                    },
                    {
                        "id": 39445,
                        "name": "Apremont",
                        "latitude": "46.74850000",
                        "longitude": "-1.74075000"
                    },
                    {
                        "id": 39538,
                        "name": "Arçonnay",
                        "latitude": "48.39678000",
                        "longitude": "0.08620000"
                    },
                    {
                        "id": 39484,
                        "name": "Argentré",
                        "latitude": "48.08362000",
                        "longitude": "-0.64150000"
                    },
                    {
                        "id": 39499,
                        "name": "Arnage",
                        "latitude": "47.92616000",
                        "longitude": "0.18782000"
                    },
                    {
                        "id": 39505,
                        "name": "Aron",
                        "latitude": "48.29800000",
                        "longitude": "-0.55980000"
                    },
                    {
                        "id": 39525,
                        "name": "Arthon-en-Retz",
                        "latitude": "47.11586000",
                        "longitude": "-1.94260000"
                    },
                    {
                        "id": 39554,
                        "name": "Assérac",
                        "latitude": "47.42881000",
                        "longitude": "-2.38916000"
                    },
                    {
                        "id": 39583,
                        "name": "Aubigné-Racan",
                        "latitude": "47.69091000",
                        "longitude": "0.26870000"
                    },
                    {
                        "id": 39579,
                        "name": "Aubigny",
                        "latitude": "46.59653000",
                        "longitude": "-1.45364000"
                    },
                    {
                        "id": 39641,
                        "name": "Auvers-le-Hamon",
                        "latitude": "47.90246000",
                        "longitude": "-0.35170000"
                    },
                    {
                        "id": 39668,
                        "name": "Avessac",
                        "latitude": "47.65324000",
                        "longitude": "-1.98961000"
                    },
                    {
                        "id": 39680,
                        "name": "Avrillé",
                        "latitude": "47.50000000",
                        "longitude": "-0.58333000"
                    },
                    {
                        "id": 39697,
                        "name": "Azé",
                        "latitude": "47.82220000",
                        "longitude": "-0.68333000"
                    },
                    {
                        "id": 39739,
                        "name": "Bais",
                        "latitude": "48.25280000",
                        "longitude": "-0.36493000"
                    },
                    {
                        "id": 39754,
                        "name": "Ballon",
                        "latitude": "48.17317000",
                        "longitude": "0.23814000"
                    },
                    {
                        "id": 39755,
                        "name": "Ballots",
                        "latitude": "47.89617000",
                        "longitude": "-1.04759000"
                    },
                    {
                        "id": 39777,
                        "name": "Barbâtre",
                        "latitude": "46.94116000",
                        "longitude": "-2.17752000"
                    },
                    {
                        "id": 39771,
                        "name": "Barbechat",
                        "latitude": "47.27750000",
                        "longitude": "-1.28524000"
                    },
                    {
                        "id": 39798,
                        "name": "Basse-Goulaine",
                        "latitude": "47.21167000",
                        "longitude": "-1.46748000"
                    },
                    {
                        "id": 39807,
                        "name": "Batz-sur-Mer",
                        "latitude": "47.27750000",
                        "longitude": "-2.48027000"
                    },
                    {
                        "id": 39810,
                        "name": "Baugé-en-Anjou",
                        "latitude": "47.54447000",
                        "longitude": "-0.10653000"
                    },
                    {
                        "id": 39815,
                        "name": "Bauné",
                        "latitude": "47.49954000",
                        "longitude": "-0.31906000"
                    },
                    {
                        "id": 39833,
                        "name": "Bazoges-en-Pareds",
                        "latitude": "46.65702000",
                        "longitude": "-0.91654000"
                    },
                    {
                        "id": 39835,
                        "name": "Bazouges-sur-le-Loir",
                        "latitude": "47.68928000",
                        "longitude": "-0.16883000"
                    },
                    {
                        "id": 39842,
                        "name": "Beaucouzé",
                        "latitude": "47.47444000",
                        "longitude": "-0.63016000"
                    },
                    {
                        "id": 39845,
                        "name": "Beaufay",
                        "latitude": "48.14664000",
                        "longitude": "0.36224000"
                    },
                    {
                        "id": 39847,
                        "name": "Beaufort-en-Vallée",
                        "latitude": "47.43965000",
                        "longitude": "-0.21890000"
                    },
                    {
                        "id": 39852,
                        "name": "Beaulieu-sous-la-Roche",
                        "latitude": "46.67647000",
                        "longitude": "-1.61129000"
                    },
                    {
                        "id": 39854,
                        "name": "Beaulieu-sur-Layon",
                        "latitude": "47.31095000",
                        "longitude": "-0.58988000"
                    },
                    {
                        "id": 39873,
                        "name": "Beaumont-sur-Sarthe",
                        "latitude": "48.22772000",
                        "longitude": "0.13186000"
                    },
                    {
                        "id": 39876,
                        "name": "Beaupréau",
                        "latitude": "47.20464000",
                        "longitude": "-0.98703000"
                    },
                    {
                        "id": 39883,
                        "name": "Beaurepaire",
                        "latitude": "46.90977000",
                        "longitude": "-1.08928000"
                    },
                    {
                        "id": 39893,
                        "name": "Beauvoir-sur-Mer",
                        "latitude": "46.91274000",
                        "longitude": "-2.04156000"
                    },
                    {
                        "id": 40411,
                        "name": "Bécon-les-Granits",
                        "latitude": "47.50134000",
                        "longitude": "-0.80000000"
                    },
                    {
                        "id": 40419,
                        "name": "Bégrolles-en-Mauges",
                        "latitude": "47.14048000",
                        "longitude": "-0.94000000"
                    },
                    {
                        "id": 39926,
                        "name": "Belleville-sur-Vie",
                        "latitude": "46.78369000",
                        "longitude": "-1.42905000"
                    },
                    {
                        "id": 39929,
                        "name": "Belligné",
                        "latitude": "47.46774000",
                        "longitude": "-1.02780000"
                    },
                    {
                        "id": 39938,
                        "name": "Benet",
                        "latitude": "46.36972000",
                        "longitude": "-0.59333000"
                    },
                    {
                        "id": 39972,
                        "name": "Besné",
                        "latitude": "47.40000000",
                        "longitude": "-2.08976000"
                    },
                    {
                        "id": 39983,
                        "name": "Bessé-sur-Braye",
                        "latitude": "47.83333000",
                        "longitude": "0.75000000"
                    },
                    {
                        "id": 40046,
                        "name": "Blain",
                        "latitude": "47.47655000",
                        "longitude": "-1.76285000"
                    },
                    {
                        "id": 40051,
                        "name": "Blaison-Gohier",
                        "latitude": "47.39951000",
                        "longitude": "-0.37723000"
                    },
                    {
                        "id": 40087,
                        "name": "Bois-de-Cené",
                        "latitude": "46.93689000",
                        "longitude": "-1.88656000"
                    },
                    {
                        "id": 40110,
                        "name": "Bonchamp-lès-Laval",
                        "latitude": "48.07357000",
                        "longitude": "-0.70000000"
                    },
                    {
                        "id": 40130,
                        "name": "Bonnétable",
                        "latitude": "48.17908000",
                        "longitude": "0.42570000"
                    },
                    {
                        "id": 40148,
                        "name": "Bouaye",
                        "latitude": "47.14263000",
                        "longitude": "-1.69306000"
                    },
                    {
                        "id": 40152,
                        "name": "Bouchemaine",
                        "latitude": "47.42234000",
                        "longitude": "-0.60888000"
                    },
                    {
                        "id": 40154,
                        "name": "Boufféré",
                        "latitude": "46.96179000",
                        "longitude": "-1.33965000"
                    },
                    {
                        "id": 40156,
                        "name": "Bouguenais",
                        "latitude": "47.17762000",
                        "longitude": "-1.62143000"
                    },
                    {
                        "id": 40160,
                        "name": "Bouin",
                        "latitude": "46.97314000",
                        "longitude": "-1.99830000"
                    },
                    {
                        "id": 40175,
                        "name": "Bouloire",
                        "latitude": "47.97385000",
                        "longitude": "0.55009000"
                    },
                    {
                        "id": 40185,
                        "name": "Bourg de Joué-sur-Erdre",
                        "latitude": "47.49596000",
                        "longitude": "-1.42047000"
                    },
                    {
                        "id": 40202,
                        "name": "Bourgneuf-en-Retz",
                        "latitude": "47.04122000",
                        "longitude": "-1.95019000"
                    },
                    {
                        "id": 40209,
                        "name": "Bournezeau",
                        "latitude": "46.63714000",
                        "longitude": "-1.17107000"
                    },
                    {
                        "id": 40217,
                        "name": "Boussay",
                        "latitude": "47.04476000",
                        "longitude": "-1.18476000"
                    },
                    {
                        "id": 40230,
                        "name": "Bouvron",
                        "latitude": "47.41726000",
                        "longitude": "-1.84679000"
                    },
                    {
                        "id": 40235,
                        "name": "Bouzillé",
                        "latitude": "47.33750000",
                        "longitude": "-1.11143000"
                    },
                    {
                        "id": 40248,
                        "name": "Brain-sur-Allonnes",
                        "latitude": "47.30325000",
                        "longitude": "0.06514000"
                    },
                    {
                        "id": 40250,
                        "name": "Brains",
                        "latitude": "47.16850000",
                        "longitude": "-1.72290000"
                    },
                    {
                        "id": 40284,
                        "name": "Bretignolles-sur-Mer",
                        "latitude": "46.63333000",
                        "longitude": "-1.86667000"
                    },
                    {
                        "id": 40286,
                        "name": "Brette-les-Pins",
                        "latitude": "47.91062000",
                        "longitude": "0.33649000"
                    },
                    {
                        "id": 40364,
                        "name": "Brézé",
                        "latitude": "47.17357000",
                        "longitude": "-0.06059000"
                    },
                    {
                        "id": 40318,
                        "name": "Briollay",
                        "latitude": "47.56478000",
                        "longitude": "-0.50681000"
                    },
                    {
                        "id": 40319,
                        "name": "Brion",
                        "latitude": "47.44121000",
                        "longitude": "-0.15616000"
                    },
                    {
                        "id": 40326,
                        "name": "Brissac-Quincé",
                        "latitude": "47.35575000",
                        "longitude": "-0.44924000"
                    },
                    {
                        "id": 40366,
                        "name": "Brûlon",
                        "latitude": "47.96667000",
                        "longitude": "-0.23333000"
                    },
                    {
                        "id": 40498,
                        "name": "Campbon",
                        "latitude": "47.41310000",
                        "longitude": "-1.96857000"
                    },
                    {
                        "id": 40507,
                        "name": "Candé",
                        "latitude": "47.56158000",
                        "longitude": "-1.03619000"
                    },
                    {
                        "id": 40520,
                        "name": "Cantenay-Épinard",
                        "latitude": "47.53503000",
                        "longitude": "-0.56899000"
                    },
                    {
                        "id": 40557,
                        "name": "Carquefou",
                        "latitude": "47.29821000",
                        "longitude": "-1.49024000"
                    },
                    {
                        "id": 40572,
                        "name": "Casson",
                        "latitude": "47.38761000",
                        "longitude": "-1.55654000"
                    },
                    {
                        "id": 41394,
                        "name": "Cérans-Foulletourte",
                        "latitude": "47.82651000",
                        "longitude": "0.07724000"
                    },
                    {
                        "id": 40673,
                        "name": "Chacé",
                        "latitude": "47.21435000",
                        "longitude": "-0.07179000"
                    },
                    {
                        "id": 40677,
                        "name": "Chailland",
                        "latitude": "48.22516000",
                        "longitude": "-0.87387000"
                    },
                    {
                        "id": 40682,
                        "name": "Chaillé-les-Marais",
                        "latitude": "46.39628000",
                        "longitude": "-1.02369000"
                    },
                    {
                        "id": 40692,
                        "name": "Challans",
                        "latitude": "46.84363000",
                        "longitude": "-1.87491000"
                    },
                    {
                        "id": 40693,
                        "name": "Challes",
                        "latitude": "47.93033000",
                        "longitude": "0.41511000"
                    },
                    {
                        "id": 40699,
                        "name": "Chalonnes-sur-Loire",
                        "latitude": "47.35160000",
                        "longitude": "-0.76310000"
                    },
                    {
                        "id": 40712,
                        "name": "Chambretaud",
                        "latitude": "46.92166000",
                        "longitude": "-0.96405000"
                    },
                    {
                        "id": 40727,
                        "name": "Champagné",
                        "latitude": "48.02185000",
                        "longitude": "0.33096000"
                    },
                    {
                        "id": 40728,
                        "name": "Champagné-les-Marais",
                        "latitude": "46.38081000",
                        "longitude": "-1.12112000"
                    },
                    {
                        "id": 40735,
                        "name": "Champfleur",
                        "latitude": "48.38668000",
                        "longitude": "0.12942000"
                    },
                    {
                        "id": 40743,
                        "name": "Champigné",
                        "latitude": "47.66332000",
                        "longitude": "-0.57160000"
                    },
                    {
                        "id": 40753,
                        "name": "Champtocé-sur-Loire",
                        "latitude": "47.41239000",
                        "longitude": "-0.86452000"
                    },
                    {
                        "id": 40752,
                        "name": "Champtoceaux",
                        "latitude": "47.33476000",
                        "longitude": "-1.26131000"
                    },
                    {
                        "id": 40763,
                        "name": "Changé",
                        "latitude": "48.09918000",
                        "longitude": "-0.79292000"
                    },
                    {
                        "id": 40776,
                        "name": "Chantonnay",
                        "latitude": "46.68702000",
                        "longitude": "-1.05024000"
                    },
                    {
                        "id": 40948,
                        "name": "Château-d’Olonne",
                        "latitude": "46.50382000",
                        "longitude": "-1.74097000"
                    },
                    {
                        "id": 40947,
                        "name": "Château-du-Loir",
                        "latitude": "47.69492000",
                        "longitude": "0.41851000"
                    },
                    {
                        "id": 40939,
                        "name": "Château-Gontier",
                        "latitude": "47.82872000",
                        "longitude": "-0.70265000"
                    },
                    {
                        "id": 40940,
                        "name": "Château-Guibert",
                        "latitude": "46.58110000",
                        "longitude": "-1.23656000"
                    },
                    {
                        "id": 40952,
                        "name": "Châteaubriant",
                        "latitude": "47.71712000",
                        "longitude": "-1.37624000"
                    },
                    {
                        "id": 40975,
                        "name": "Châteauneuf-sur-Sarthe",
                        "latitude": "47.68145000",
                        "longitude": "-0.48652000"
                    },
                    {
                        "id": 40834,
                        "name": "Chauché",
                        "latitude": "46.82963000",
                        "longitude": "-1.27178000"
                    },
                    {
                        "id": 40838,
                        "name": "Chaudron-en-Mauges",
                        "latitude": "47.28809000",
                        "longitude": "-0.98547000"
                    },
                    {
                        "id": 40854,
                        "name": "Chauvé",
                        "latitude": "47.15174000",
                        "longitude": "-1.98489000"
                    },
                    {
                        "id": 40856,
                        "name": "Chavagnes-en-Paillers",
                        "latitude": "46.89167000",
                        "longitude": "-1.25214000"
                    },
                    {
                        "id": 40871,
                        "name": "Chemazé",
                        "latitude": "47.78690000",
                        "longitude": "-0.77523000"
                    },
                    {
                        "id": 41011,
                        "name": "Chéméré",
                        "latitude": "47.11667000",
                        "longitude": "-1.91667000"
                    },
                    {
                        "id": 40872,
                        "name": "Chemillé-Melay",
                        "latitude": "47.21476000",
                        "longitude": "-0.72488000"
                    },
                    {
                        "id": 41018,
                        "name": "Chênehutte-Trèves-Cunault",
                        "latitude": "47.31084000",
                        "longitude": "-0.16042000"
                    },
                    {
                        "id": 40885,
                        "name": "Cherré",
                        "latitude": "48.17290000",
                        "longitude": "0.65781000"
                    },
                    {
                        "id": 40924,
                        "name": "Cholet",
                        "latitude": "47.05905000",
                        "longitude": "-0.87953000"
                    },
                    {
                        "id": 41048,
                        "name": "Clermont-Créans",
                        "latitude": "47.71831000",
                        "longitude": "-0.01459000"
                    },
                    {
                        "id": 41056,
                        "name": "Clisson",
                        "latitude": "47.08714000",
                        "longitude": "-1.28286000"
                    },
                    {
                        "id": 41293,
                        "name": "Coëx",
                        "latitude": "46.69808000",
                        "longitude": "-1.75956000"
                    },
                    {
                        "id": 41114,
                        "name": "Combrée",
                        "latitude": "47.70446000",
                        "longitude": "-1.03003000"
                    },
                    {
                        "id": 41119,
                        "name": "Commequiers",
                        "latitude": "46.76049000",
                        "longitude": "-1.83901000"
                    },
                    {
                        "id": 41120,
                        "name": "Commer",
                        "latitude": "48.23333000",
                        "longitude": "-0.61667000"
                    },
                    {
                        "id": 41146,
                        "name": "Congrier",
                        "latitude": "47.80989000",
                        "longitude": "-1.11700000"
                    },
                    {
                        "id": 41148,
                        "name": "Conlie",
                        "latitude": "48.12334000",
                        "longitude": "-0.01739000"
                    },
                    {
                        "id": 41151,
                        "name": "Connerré",
                        "latitude": "48.05698000",
                        "longitude": "0.49344000"
                    },
                    {
                        "id": 41152,
                        "name": "Conquereuil",
                        "latitude": "47.62524000",
                        "longitude": "-1.75105000"
                    },
                    {
                        "id": 41172,
                        "name": "Corcoué-sur-Logne",
                        "latitude": "46.96667000",
                        "longitude": "-1.58333000"
                    },
                    {
                        "id": 41173,
                        "name": "Cordemais",
                        "latitude": "47.29107000",
                        "longitude": "-1.87869000"
                    },
                    {
                        "id": 41197,
                        "name": "Corné",
                        "latitude": "47.47091000",
                        "longitude": "-0.34992000"
                    },
                    {
                        "id": 41198,
                        "name": "Coron",
                        "latitude": "47.12726000",
                        "longitude": "-0.64512000"
                    },
                    {
                        "id": 41203,
                        "name": "Corsept",
                        "latitude": "47.27703000",
                        "longitude": "-2.05904000"
                    },
                    {
                        "id": 41206,
                        "name": "Corzé",
                        "latitude": "47.55956000",
                        "longitude": "-0.39062000"
                    },
                    {
                        "id": 41210,
                        "name": "Cossé-le-Vivien",
                        "latitude": "47.94599000",
                        "longitude": "-0.91185000"
                    },
                    {
                        "id": 41288,
                        "name": "Couëron",
                        "latitude": "47.21508000",
                        "longitude": "-1.72171000"
                    },
                    {
                        "id": 41223,
                        "name": "Couffé",
                        "latitude": "47.39120000",
                        "longitude": "-1.29321000"
                    },
                    {
                        "id": 41228,
                        "name": "Coulaines",
                        "latitude": "48.02409000",
                        "longitude": "0.20411000"
                    },
                    {
                        "id": 41230,
                        "name": "Coulans-sur-Gée",
                        "latitude": "48.02070000",
                        "longitude": "0.00974000"
                    },
                    {
                        "id": 41248,
                        "name": "Courcité",
                        "latitude": "48.30633000",
                        "longitude": "-0.24961000"
                    },
                    {
                        "id": 41298,
                        "name": "Craon",
                        "latitude": "47.84687000",
                        "longitude": "-0.94929000"
                    },
                    {
                        "id": 41328,
                        "name": "Crossac",
                        "latitude": "47.41119000",
                        "longitude": "-2.16952000"
                    },
                    {
                        "id": 41362,
                        "name": "Cugand",
                        "latitude": "47.06318000",
                        "longitude": "-1.25270000"
                    },
                    {
                        "id": 41440,
                        "name": "Daumeray",
                        "latitude": "47.70070000",
                        "longitude": "-0.36119000"
                    },
                    {
                        "id": 41453,
                        "name": "Denée",
                        "latitude": "47.37885000",
                        "longitude": "-0.60816000"
                    },
                    {
                        "id": 41633,
                        "name": "Département de la Vendée",
                        "latitude": "46.64169000",
                        "longitude": "-1.30407000"
                    },
                    {
                        "id": 41606,
                        "name": "Département de Maine-et-Loire",
                        "latitude": "47.50000000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 41454,
                        "name": "Derval",
                        "latitude": "47.66724000",
                        "longitude": "-1.66990000"
                    },
                    {
                        "id": 41494,
                        "name": "Distré",
                        "latitude": "47.22281000",
                        "longitude": "-0.11071000"
                    },
                    {
                        "id": 41505,
                        "name": "Dollon",
                        "latitude": "48.03879000",
                        "longitude": "0.58686000"
                    },
                    {
                        "id": 41525,
                        "name": "Dompierre-sur-Yon",
                        "latitude": "46.73857000",
                        "longitude": "-1.38463000"
                    },
                    {
                        "id": 41531,
                        "name": "Donges",
                        "latitude": "47.31824000",
                        "longitude": "-2.07538000"
                    },
                    {
                        "id": 41562,
                        "name": "Doué-la-Fontaine",
                        "latitude": "47.19372000",
                        "longitude": "-0.27492000"
                    },
                    {
                        "id": 41567,
                        "name": "Drain",
                        "latitude": "47.33655000",
                        "longitude": "-1.20773000"
                    },
                    {
                        "id": 41571,
                        "name": "Drefféac",
                        "latitude": "47.47464000",
                        "longitude": "-2.05774000"
                    },
                    {
                        "id": 41596,
                        "name": "Durtal",
                        "latitude": "47.67247000",
                        "longitude": "-0.23393000"
                    },
                    {
                        "id": 48045,
                        "name": "Écommoy",
                        "latitude": "47.82565000",
                        "longitude": "0.27422000"
                    },
                    {
                        "id": 48048,
                        "name": "Écouflant",
                        "latitude": "47.53101000",
                        "longitude": "-0.52780000"
                    },
                    {
                        "id": 41679,
                        "name": "Entrammes",
                        "latitude": "47.99759000",
                        "longitude": "-0.71399000"
                    },
                    {
                        "id": 41689,
                        "name": "Erbray",
                        "latitude": "47.65492000",
                        "longitude": "-1.31783000"
                    },
                    {
                        "id": 41698,
                        "name": "Ernée",
                        "latitude": "48.29764000",
                        "longitude": "-0.93143000"
                    },
                    {
                        "id": 48105,
                        "name": "Étival-lès-le-Mans",
                        "latitude": "47.95000000",
                        "longitude": "0.08333000"
                    },
                    {
                        "id": 48112,
                        "name": "Étriché",
                        "latitude": "47.65087000",
                        "longitude": "-0.44377000"
                    },
                    {
                        "id": 48124,
                        "name": "Évron",
                        "latitude": "48.15642000",
                        "longitude": "-0.39970000"
                    },
                    {
                        "id": 41768,
                        "name": "Falleron",
                        "latitude": "46.88160000",
                        "longitude": "-1.70208000"
                    },
                    {
                        "id": 41788,
                        "name": "Fay-de-Bretagne",
                        "latitude": "47.41453000",
                        "longitude": "-1.79155000"
                    },
                    {
                        "id": 42001,
                        "name": "Fégréac",
                        "latitude": "47.58476000",
                        "longitude": "-2.04410000"
                    },
                    {
                        "id": 41798,
                        "name": "Feneu",
                        "latitude": "47.57211000",
                        "longitude": "-0.59422000"
                    },
                    {
                        "id": 41821,
                        "name": "Fillé",
                        "latitude": "47.90011000",
                        "longitude": "0.12543000"
                    },
                    {
                        "id": 41898,
                        "name": "Fontenay-le-Comte",
                        "latitude": "46.46720000",
                        "longitude": "-0.80645000"
                    },
                    {
                        "id": 41905,
                        "name": "Fontevraud-l'Abbaye",
                        "latitude": "47.18333000",
                        "longitude": "0.05000000"
                    },
                    {
                        "id": 41926,
                        "name": "Fougerolles-du-Plessis",
                        "latitude": "48.47424000",
                        "longitude": "-0.97255000"
                    },
                    {
                        "id": 41940,
                        "name": "Foussais-Payré",
                        "latitude": "46.53333000",
                        "longitude": "-0.68333000"
                    },
                    {
                        "id": 41954,
                        "name": "Freigné",
                        "latitude": "47.54858000",
                        "longitude": "-1.12274000"
                    },
                    {
                        "id": 41957,
                        "name": "Fresnay-sur-Sarthe",
                        "latitude": "48.28199000",
                        "longitude": "0.02288000"
                    },
                    {
                        "id": 41969,
                        "name": "Froidfond",
                        "latitude": "46.86898000",
                        "longitude": "-1.75740000"
                    },
                    {
                        "id": 41978,
                        "name": "Frossay",
                        "latitude": "47.24451000",
                        "longitude": "-1.93557000"
                    },
                    {
                        "id": 42064,
                        "name": "Geneston",
                        "latitude": "47.05639000",
                        "longitude": "-1.51139000"
                    },
                    {
                        "id": 42067,
                        "name": "Gennes",
                        "latitude": "47.34010000",
                        "longitude": "-0.23149000"
                    },
                    {
                        "id": 42080,
                        "name": "Gesté",
                        "latitude": "47.18179000",
                        "longitude": "-1.10917000"
                    },
                    {
                        "id": 42300,
                        "name": "Gétigné",
                        "latitude": "47.07650000",
                        "longitude": "-1.24810000"
                    },
                    {
                        "id": 42109,
                        "name": "Givrand",
                        "latitude": "46.67083000",
                        "longitude": "-1.88612000"
                    },
                    {
                        "id": 42137,
                        "name": "Gorges",
                        "latitude": "47.09917000",
                        "longitude": "-1.30024000"
                    },
                    {
                        "id": 42138,
                        "name": "Gorron",
                        "latitude": "48.41095000",
                        "longitude": "-0.81267000"
                    },
                    {
                        "id": 42203,
                        "name": "Grez-Neuville",
                        "latitude": "47.60288000",
                        "longitude": "-0.68193000"
                    },
                    {
                        "id": 42225,
                        "name": "Grosbreuil",
                        "latitude": "46.53946000",
                        "longitude": "-1.61655000"
                    },
                    {
                        "id": 42277,
                        "name": "Guécélard",
                        "latitude": "47.87751000",
                        "longitude": "0.12930000"
                    },
                    {
                        "id": 42280,
                        "name": "Guémené-Penfao",
                        "latitude": "47.63333000",
                        "longitude": "-1.83333000"
                    },
                    {
                        "id": 42241,
                        "name": "Guenrouet",
                        "latitude": "47.51881000",
                        "longitude": "-1.95381000"
                    },
                    {
                        "id": 42284,
                        "name": "Guérande",
                        "latitude": "47.32911000",
                        "longitude": "-2.42829000"
                    },
                    {
                        "id": 42342,
                        "name": "Haute-Goulaine",
                        "latitude": "47.19905000",
                        "longitude": "-1.42941000"
                    },
                    {
                        "id": 42373,
                        "name": "Herbignac",
                        "latitude": "47.44822000",
                        "longitude": "-2.31810000"
                    },
                    {
                        "id": 42456,
                        "name": "Héric",
                        "latitude": "47.41417000",
                        "longitude": "-1.65309000"
                    },
                    {
                        "id": 42486,
                        "name": "Indre",
                        "latitude": "47.20000000",
                        "longitude": "-1.66667000"
                    },
                    {
                        "id": 42488,
                        "name": "Ingrandes",
                        "latitude": "47.40500000",
                        "longitude": "-0.92336000"
                    },
                    {
                        "id": 42509,
                        "name": "Issé",
                        "latitude": "47.62419000",
                        "longitude": "-1.45152000"
                    },
                    {
                        "id": 42524,
                        "name": "Jallais",
                        "latitude": "47.19691000",
                        "longitude": "-0.86738000"
                    },
                    {
                        "id": 42526,
                        "name": "Jans",
                        "latitude": "47.62029000",
                        "longitude": "-1.61438000"
                    },
                    {
                        "id": 42530,
                        "name": "Jard-sur-Mer",
                        "latitude": "46.41451000",
                        "longitude": "-1.57639000"
                    },
                    {
                        "id": 42537,
                        "name": "Jarzé",
                        "latitude": "47.55563000",
                        "longitude": "-0.23183000"
                    },
                    {
                        "id": 42545,
                        "name": "Javron-les-Chapelles",
                        "latitude": "48.41797000",
                        "longitude": "-0.33742000"
                    },
                    {
                        "id": 42582,
                        "name": "Juigné",
                        "latitude": "47.71878000",
                        "longitude": "-0.39405000"
                    },
                    {
                        "id": 42583,
                        "name": "Juigné-sur-Loire",
                        "latitude": "47.40741000",
                        "longitude": "-0.47682000"
                    },
                    {
                        "id": 42584,
                        "name": "Juigné-sur-Sarthe",
                        "latitude": "47.86499000",
                        "longitude": "-0.28624000"
                    },
                    {
                        "id": 42590,
                        "name": "Jumelles",
                        "latitude": "47.43511000",
                        "longitude": "-0.10370000"
                    },
                    {
                        "id": 42600,
                        "name": "Juvigné",
                        "latitude": "48.22891000",
                        "longitude": "-1.03408000"
                    },
                    {
                        "id": 42630,
                        "name": "La Baconnière",
                        "latitude": "48.18012000",
                        "longitude": "-0.89202000"
                    },
                    {
                        "id": 42633,
                        "name": "La Barre-de-Monts",
                        "latitude": "46.88059000",
                        "longitude": "-2.12168000"
                    },
                    {
                        "id": 42637,
                        "name": "La Baule-Escoublac",
                        "latitude": "47.29221000",
                        "longitude": "-2.36395000"
                    },
                    {
                        "id": 42639,
                        "name": "La Bazoge",
                        "latitude": "48.09689000",
                        "longitude": "0.15534000"
                    },
                    {
                        "id": 42640,
                        "name": "La Bernardière",
                        "latitude": "47.04952000",
                        "longitude": "-1.26587000"
                    },
                    {
                        "id": 42641,
                        "name": "La Bernerie-en-Retz",
                        "latitude": "47.08040000",
                        "longitude": "-2.03642000"
                    },
                    {
                        "id": 42644,
                        "name": "La Bohalle",
                        "latitude": "47.42095000",
                        "longitude": "-0.39723000"
                    },
                    {
                        "id": 42646,
                        "name": "La Boissière-de-Montaigu",
                        "latitude": "46.95012000",
                        "longitude": "-1.19047000"
                    },
                    {
                        "id": 42647,
                        "name": "La Boissière-des-Landes",
                        "latitude": "46.56398000",
                        "longitude": "-1.46172000"
                    },
                    {
                        "id": 42656,
                        "name": "La Bruffière",
                        "latitude": "47.01492000",
                        "longitude": "-1.19730000"
                    },
                    {
                        "id": 42675,
                        "name": "La Chaize-le-Vicomte",
                        "latitude": "46.67166000",
                        "longitude": "-1.29084000"
                    },
                    {
                        "id": 42677,
                        "name": "La Chapelle-Achard",
                        "latitude": "46.58862000",
                        "longitude": "-1.64757000"
                    },
                    {
                        "id": 42678,
                        "name": "La Chapelle-Basse-Mer",
                        "latitude": "47.27086000",
                        "longitude": "-1.33913000"
                    },
                    {
                        "id": 42694,
                        "name": "La Chapelle-des-Marais",
                        "latitude": "47.44845000",
                        "longitude": "-2.23834000"
                    },
                    {
                        "id": 42695,
                        "name": "La Chapelle-du-Genêt",
                        "latitude": "47.18203000",
                        "longitude": "-1.01857000"
                    },
                    {
                        "id": 42680,
                        "name": "La Chapelle-Heulin",
                        "latitude": "47.17667000",
                        "longitude": "-1.34000000"
                    },
                    {
                        "id": 42682,
                        "name": "La Chapelle-Launay",
                        "latitude": "47.37226000",
                        "longitude": "-1.97071000"
                    },
                    {
                        "id": 42684,
                        "name": "La Chapelle-Saint-Aubin",
                        "latitude": "48.03595000",
                        "longitude": "0.15624000"
                    },
                    {
                        "id": 42685,
                        "name": "La Chapelle-Saint-Florent",
                        "latitude": "47.33393000",
                        "longitude": "-1.05631000"
                    },
                    {
                        "id": 42700,
                        "name": "La Chapelle-sur-Erdre",
                        "latitude": "47.29583000",
                        "longitude": "-1.55309000"
                    },
                    {
                        "id": 42703,
                        "name": "La Chartre-sur-le-Loir",
                        "latitude": "47.73117000",
                        "longitude": "0.56852000"
                    },
                    {
                        "id": 42706,
                        "name": "La Châtaigneraie",
                        "latitude": "46.64786000",
                        "longitude": "-0.73916000"
                    },
                    {
                        "id": 42705,
                        "name": "La Chevrolière",
                        "latitude": "47.09124000",
                        "longitude": "-1.60973000"
                    },
                    {
                        "id": 42727,
                        "name": "La Daguenière",
                        "latitude": "47.41934000",
                        "longitude": "-0.43128000"
                    },
                    {
                        "id": 42734,
                        "name": "La Ferrière",
                        "latitude": "46.71453000",
                        "longitude": "-1.31417000"
                    },
                    {
                        "id": 42737,
                        "name": "La Ferté-Bernard",
                        "latitude": "48.18633000",
                        "longitude": "0.65357000"
                    },
                    {
                        "id": 42748,
                        "name": "La Flèche",
                        "latitude": "47.69815000",
                        "longitude": "-0.07553000"
                    },
                    {
                        "id": 42746,
                        "name": "La Flocellière",
                        "latitude": "46.83202000",
                        "longitude": "-0.86215000"
                    },
                    {
                        "id": 42765,
                        "name": "La Garnache",
                        "latitude": "46.89176000",
                        "longitude": "-1.83163000"
                    },
                    {
                        "id": 42766,
                        "name": "La Gaubretière",
                        "latitude": "46.94143000",
                        "longitude": "-1.06215000"
                    },
                    {
                        "id": 42778,
                        "name": "La Génétouze",
                        "latitude": "46.73333000",
                        "longitude": "-1.51667000"
                    },
                    {
                        "id": 42774,
                        "name": "La Grigonnais",
                        "latitude": "47.52724000",
                        "longitude": "-1.66781000"
                    },
                    {
                        "id": 42777,
                        "name": "La Guérinière",
                        "latitude": "46.96667000",
                        "longitude": "-2.23333000"
                    },
                    {
                        "id": 42776,
                        "name": "La Guyonnière",
                        "latitude": "46.96476000",
                        "longitude": "-1.25059000"
                    },
                    {
                        "id": 42779,
                        "name": "La Haie-Fouassière",
                        "latitude": "47.15492000",
                        "longitude": "-1.39794000"
                    },
                    {
                        "id": 42787,
                        "name": "La Jubaudière",
                        "latitude": "47.17202000",
                        "longitude": "-0.89215000"
                    },
                    {
                        "id": 42788,
                        "name": "La Jumellière",
                        "latitude": "47.27976000",
                        "longitude": "-0.72952000"
                    },
                    {
                        "id": 42791,
                        "name": "La Limouzinière",
                        "latitude": "46.99274000",
                        "longitude": "-1.59722000"
                    },
                    {
                        "id": 42801,
                        "name": "La Meignanne",
                        "latitude": "47.51700000",
                        "longitude": "-0.66861000"
                    },
                    {
                        "id": 42802,
                        "name": "La Meilleraie-Tillay",
                        "latitude": "46.74059000",
                        "longitude": "-0.84500000"
                    },
                    {
                        "id": 42803,
                        "name": "La Meilleraye-de-Bretagne",
                        "latitude": "47.55941000",
                        "longitude": "-1.40200000"
                    },
                    {
                        "id": 42805,
                        "name": "La Membrolle-sur-Longuenée",
                        "latitude": "47.55991000",
                        "longitude": "-0.67236000"
                    },
                    {
                        "id": 42822,
                        "name": "La Ménitré",
                        "latitude": "47.40000000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 42806,
                        "name": "La Milesse",
                        "latitude": "48.06314000",
                        "longitude": "0.13428000"
                    },
                    {
                        "id": 42809,
                        "name": "La Montagne",
                        "latitude": "47.18651000",
                        "longitude": "-1.68272000"
                    },
                    {
                        "id": 42810,
                        "name": "La Mothe-Achard",
                        "latitude": "46.61586000",
                        "longitude": "-1.65938000"
                    },
                    {
                        "id": 42831,
                        "name": "La Plaine-sur-Mer",
                        "latitude": "47.13619000",
                        "longitude": "-2.19182000"
                    },
                    {
                        "id": 42832,
                        "name": "La Planche",
                        "latitude": "47.01619000",
                        "longitude": "-1.43159000"
                    },
                    {
                        "id": 42835,
                        "name": "La Pommeraie-sur-Sèvre",
                        "latitude": "46.83535000",
                        "longitude": "-0.77785000"
                    },
                    {
                        "id": 42836,
                        "name": "La Pommeraye",
                        "latitude": "47.35562000",
                        "longitude": "-0.85892000"
                    },
                    {
                        "id": 42837,
                        "name": "La Possonnière",
                        "latitude": "47.37485000",
                        "longitude": "-0.68539000"
                    },
                    {
                        "id": 42838,
                        "name": "La Pouëze",
                        "latitude": "47.55357000",
                        "longitude": "-0.80928000"
                    },
                    {
                        "id": 42842,
                        "name": "La Regrippière",
                        "latitude": "47.18167000",
                        "longitude": "-1.17620000"
                    },
                    {
                        "id": 42843,
                        "name": "La Remaudière",
                        "latitude": "47.23762000",
                        "longitude": "-1.24358000"
                    },
                    {
                        "id": 42859,
                        "name": "La Roche-sur-Yon",
                        "latitude": "46.66667000",
                        "longitude": "-1.43333000"
                    },
                    {
                        "id": 42864,
                        "name": "La Romagne",
                        "latitude": "47.06119000",
                        "longitude": "-1.02000000"
                    },
                    {
                        "id": 42870,
                        "name": "La Salle-et-Chapelle-Aubry",
                        "latitude": "47.25013000",
                        "longitude": "-0.97512000"
                    },
                    {
                        "id": 42882,
                        "name": "La Séguinière",
                        "latitude": "47.06357000",
                        "longitude": "-0.93857000"
                    },
                    {
                        "id": 42880,
                        "name": "La Suze-sur-Sarthe",
                        "latitude": "47.88753000",
                        "longitude": "0.02519000"
                    },
                    {
                        "id": 42884,
                        "name": "La Tardière",
                        "latitude": "46.66096000",
                        "longitude": "-0.73143000"
                    },
                    {
                        "id": 42886,
                        "name": "La Tessoualle",
                        "latitude": "47.00476000",
                        "longitude": "-0.85119000"
                    },
                    {
                        "id": 42895,
                        "name": "La Tourlandry",
                        "latitude": "47.14375000",
                        "longitude": "-0.69688000"
                    },
                    {
                        "id": 42896,
                        "name": "La Tranche-sur-Mer",
                        "latitude": "46.34300000",
                        "longitude": "-1.43700000"
                    },
                    {
                        "id": 42901,
                        "name": "La Turballe",
                        "latitude": "47.34686000",
                        "longitude": "-2.50734000"
                    },
                    {
                        "id": 42906,
                        "name": "La Varenne",
                        "latitude": "47.31107000",
                        "longitude": "-1.31976000"
                    },
                    {
                        "id": 42909,
                        "name": "La Verrie",
                        "latitude": "46.96131000",
                        "longitude": "-0.99596000"
                    },
                    {
                        "id": 42968,
                        "name": "Laigné-en-Belin",
                        "latitude": "47.87706000",
                        "longitude": "0.22795000"
                    },
                    {
                        "id": 43002,
                        "name": "Landemont",
                        "latitude": "47.26536000",
                        "longitude": "-1.23989000"
                    },
                    {
                        "id": 43004,
                        "name": "Landeronde",
                        "latitude": "46.65722000",
                        "longitude": "-1.56953000"
                    },
                    {
                        "id": 43008,
                        "name": "Landivy",
                        "latitude": "48.47868000",
                        "longitude": "-1.03320000"
                    },
                    {
                        "id": 43067,
                        "name": "Larchamp",
                        "latitude": "48.36131000",
                        "longitude": "-0.99900000"
                    },
                    {
                        "id": 43085,
                        "name": "Lassay-les-Châteaux",
                        "latitude": "48.43835000",
                        "longitude": "-0.49758000"
                    },
                    {
                        "id": 43107,
                        "name": "Laval",
                        "latitude": "48.07320000",
                        "longitude": "-0.76340000"
                    },
                    {
                        "id": 43129,
                        "name": "Le Bignon",
                        "latitude": "47.09722000",
                        "longitude": "-1.49167000"
                    },
                    {
                        "id": 43136,
                        "name": "Le Boupère",
                        "latitude": "46.79595000",
                        "longitude": "-0.92654000"
                    },
                    {
                        "id": 43140,
                        "name": "Le Bourgneuf-la-Forêt",
                        "latitude": "48.16325000",
                        "longitude": "-0.96963000"
                    },
                    {
                        "id": 43143,
                        "name": "Le Breil-sur-Mérize",
                        "latitude": "48.00755000",
                        "longitude": "0.47808000"
                    },
                    {
                        "id": 43158,
                        "name": "Le Cellier",
                        "latitude": "47.31988000",
                        "longitude": "-1.34584000"
                    },
                    {
                        "id": 43162,
                        "name": "Le Champ-Saint-Père",
                        "latitude": "46.50773000",
                        "longitude": "-1.34726000"
                    },
                    {
                        "id": 43176,
                        "name": "Le Croisic",
                        "latitude": "47.29189000",
                        "longitude": "-2.51380000"
                    },
                    {
                        "id": 43186,
                        "name": "Le Fenouiller",
                        "latitude": "46.71901000",
                        "longitude": "-1.90175000"
                    },
                    {
                        "id": 43187,
                        "name": "Le Fief-Sauvin",
                        "latitude": "47.22143000",
                        "longitude": "-1.04214000"
                    },
                    {
                        "id": 43191,
                        "name": "Le Fuilet",
                        "latitude": "47.28345000",
                        "longitude": "-1.11310000"
                    },
                    {
                        "id": 43203,
                        "name": "Le Gâvre",
                        "latitude": "47.52131000",
                        "longitude": "-1.74905000"
                    },
                    {
                        "id": 43197,
                        "name": "Le Grand-Lucé",
                        "latitude": "47.86618000",
                        "longitude": "0.46919000"
                    },
                    {
                        "id": 43209,
                        "name": "Le Landreau",
                        "latitude": "47.20512000",
                        "longitude": "-1.30452000"
                    },
                    {
                        "id": 43210,
                        "name": "Le Langon",
                        "latitude": "46.43850000",
                        "longitude": "-0.94767000"
                    },
                    {
                        "id": 43213,
                        "name": "Le Longeron",
                        "latitude": "47.01845000",
                        "longitude": "-1.05763000"
                    },
                    {
                        "id": 43214,
                        "name": "Le Loroux-Bottereau",
                        "latitude": "47.23763000",
                        "longitude": "-1.34952000"
                    },
                    {
                        "id": 43215,
                        "name": "Le Louroux-Béconnais",
                        "latitude": "47.52211000",
                        "longitude": "-0.88663000"
                    },
                    {
                        "id": 43216,
                        "name": "Le Luart",
                        "latitude": "48.07053000",
                        "longitude": "0.58564000"
                    },
                    {
                        "id": 43218,
                        "name": "Le Lude",
                        "latitude": "47.64648000",
                        "longitude": "0.15664000"
                    },
                    {
                        "id": 43221,
                        "name": "Le Mans",
                        "latitude": "48.00039000",
                        "longitude": "0.20471000"
                    },
                    {
                        "id": 43223,
                        "name": "Le May-sur-Èvre",
                        "latitude": "47.13714000",
                        "longitude": "-0.89227000"
                    },
                    {
                        "id": 43229,
                        "name": "Le Mesnil-en-Vallée",
                        "latitude": "47.36551000",
                        "longitude": "-0.93485000"
                    },
                    {
                        "id": 43245,
                        "name": "Le Pallet",
                        "latitude": "47.13809000",
                        "longitude": "-1.33476000"
                    },
                    {
                        "id": 43248,
                        "name": "Le Pellerin",
                        "latitude": "47.19915000",
                        "longitude": "-1.75514000"
                    },
                    {
                        "id": 43251,
                        "name": "Le Perrier",
                        "latitude": "46.81932000",
                        "longitude": "-1.99306000"
                    },
                    {
                        "id": 43260,
                        "name": "Le Pin-en-Mauges",
                        "latitude": "47.25357000",
                        "longitude": "-0.89917000"
                    },
                    {
                        "id": 43266,
                        "name": "Le Plessis-Grammoire",
                        "latitude": "47.49884000",
                        "longitude": "-0.43021000"
                    },
                    {
                        "id": 43267,
                        "name": "Le Plessis-Macé",
                        "latitude": "47.54304000",
                        "longitude": "-0.67436000"
                    },
                    {
                        "id": 43272,
                        "name": "Le Poiré-sur-Vie",
                        "latitude": "46.76921000",
                        "longitude": "-1.50938000"
                    },
                    {
                        "id": 43281,
                        "name": "Le Pouliguen",
                        "latitude": "47.26973000",
                        "longitude": "-2.42780000"
                    },
                    {
                        "id": 43285,
                        "name": "Le Puy-Notre-Dame",
                        "latitude": "47.12551000",
                        "longitude": "-0.23572000"
                    },
                    {
                        "id": 43309,
                        "name": "Le Temple-de-Bretagne",
                        "latitude": "47.32737000",
                        "longitude": "-1.78904000"
                    },
                    {
                        "id": 43332,
                        "name": "Le Vieil-Baugé",
                        "latitude": "47.53193000",
                        "longitude": "-0.11888000"
                    },
                    {
                        "id": 43344,
                        "name": "Legé",
                        "latitude": "46.88484000",
                        "longitude": "-1.60127000"
                    },
                    {
                        "id": 43372,
                        "name": "Les Brouzils",
                        "latitude": "46.88571000",
                        "longitude": "-1.32095000"
                    },
                    {
                        "id": 43379,
                        "name": "Les Clouzeaux",
                        "latitude": "46.62881000",
                        "longitude": "-1.50947000"
                    },
                    {
                        "id": 43384,
                        "name": "Les Epesses",
                        "latitude": "46.88333000",
                        "longitude": "-0.90000000"
                    },
                    {
                        "id": 43385,
                        "name": "Les Essarts",
                        "latitude": "46.77440000",
                        "longitude": "-1.22834000"
                    },
                    {
                        "id": 43395,
                        "name": "Les Herbiers",
                        "latitude": "46.86667000",
                        "longitude": "-1.01667000"
                    },
                    {
                        "id": 43397,
                        "name": "Les Landes-Genusson",
                        "latitude": "46.96667000",
                        "longitude": "-1.11667000"
                    },
                    {
                        "id": 43402,
                        "name": "Les Lucs-sur-Boulogne",
                        "latitude": "46.84478000",
                        "longitude": "-1.49445000"
                    },
                    {
                        "id": 43404,
                        "name": "Les Magnils-Reigniers",
                        "latitude": "46.48333000",
                        "longitude": "-1.21667000"
                    },
                    {
                        "id": 43411,
                        "name": "Les Moutiers-en-Retz",
                        "latitude": "47.06375000",
                        "longitude": "-1.99900000"
                    },
                    {
                        "id": 43422,
                        "name": "Les Ponts-de-Cé",
                        "latitude": "47.42315000",
                        "longitude": "-0.52477000"
                    },
                    {
                        "id": 43425,
                        "name": "Les Rosiers-sur-Loire",
                        "latitude": "47.35000000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 43427,
                        "name": "Les Sables-d’Olonne",
                        "latitude": "46.49645000",
                        "longitude": "-1.78472000"
                    },
                    {
                        "id": 43429,
                        "name": "Les Sorinières",
                        "latitude": "47.14831000",
                        "longitude": "-1.52932000"
                    },
                    {
                        "id": 43430,
                        "name": "Les Touches",
                        "latitude": "47.44249000",
                        "longitude": "-1.43097000"
                    },
                    {
                        "id": 43481,
                        "name": "Ligné",
                        "latitude": "47.41096000",
                        "longitude": "-1.37726000"
                    },
                    {
                        "id": 43507,
                        "name": "Liré",
                        "latitude": "47.34322000",
                        "longitude": "-1.16536000"
                    },
                    {
                        "id": 43540,
                        "name": "Loire-Atlantique",
                        "latitude": "47.32863000",
                        "longitude": "-1.65764000"
                    },
                    {
                        "id": 43543,
                        "name": "Loiron",
                        "latitude": "48.06667000",
                        "longitude": "-0.93333000"
                    },
                    {
                        "id": 43548,
                        "name": "Lombron",
                        "latitude": "48.07879000",
                        "longitude": "0.41869000"
                    },
                    {
                        "id": 43559,
                        "name": "Longeville-sur-Mer",
                        "latitude": "46.41667000",
                        "longitude": "-1.50000000"
                    },
                    {
                        "id": 43621,
                        "name": "Loué",
                        "latitude": "47.99575000",
                        "longitude": "-0.15450000"
                    },
                    {
                        "id": 43606,
                        "name": "Louplande",
                        "latitude": "47.95000000",
                        "longitude": "-0.05000000"
                    },
                    {
                        "id": 43612,
                        "name": "Louverné",
                        "latitude": "48.12178000",
                        "longitude": "-0.71721000"
                    },
                    {
                        "id": 43632,
                        "name": "Luceau",
                        "latitude": "47.71167000",
                        "longitude": "0.39734000"
                    },
                    {
                        "id": 43635,
                        "name": "Luché-Pringé",
                        "latitude": "47.70326000",
                        "longitude": "0.07549000"
                    },
                    {
                        "id": 43676,
                        "name": "Luçon",
                        "latitude": "46.45773000",
                        "longitude": "-1.16512000"
                    },
                    {
                        "id": 43660,
                        "name": "Lusanger",
                        "latitude": "47.68153000",
                        "longitude": "-1.58857000"
                    },
                    {
                        "id": 43714,
                        "name": "Maché",
                        "latitude": "46.75405000",
                        "longitude": "-1.68692000"
                    },
                    {
                        "id": 43712,
                        "name": "Machecoul",
                        "latitude": "46.99358000",
                        "longitude": "-1.82352000"
                    },
                    {
                        "id": 43734,
                        "name": "Maillezais",
                        "latitude": "46.37267000",
                        "longitude": "-0.73963000"
                    },
                    {
                        "id": 43741,
                        "name": "Maisdon-sur-Sèvre",
                        "latitude": "47.09714000",
                        "longitude": "-1.38000000"
                    },
                    {
                        "id": 43759,
                        "name": "Malicorne-sur-Sarthe",
                        "latitude": "47.81317000",
                        "longitude": "-0.08152000"
                    },
                    {
                        "id": 43766,
                        "name": "Malville",
                        "latitude": "47.35905000",
                        "longitude": "-1.86227000"
                    },
                    {
                        "id": 43768,
                        "name": "Mamers",
                        "latitude": "48.34961000",
                        "longitude": "0.36937000"
                    },
                    {
                        "id": 43782,
                        "name": "Mansigné",
                        "latitude": "47.74833000",
                        "longitude": "0.13311000"
                    },
                    {
                        "id": 43926,
                        "name": "Marçon",
                        "latitude": "47.71059000",
                        "longitude": "0.51101000"
                    },
                    {
                        "id": 43830,
                        "name": "Mareuil-sur-Lay-Dissais",
                        "latitude": "46.53333000",
                        "longitude": "-1.23333000"
                    },
                    {
                        "id": 43844,
                        "name": "Marigné-Laillé",
                        "latitude": "47.81765000",
                        "longitude": "0.34050000"
                    },
                    {
                        "id": 43867,
                        "name": "Marolles-les-Braults",
                        "latitude": "48.25271000",
                        "longitude": "0.31631000"
                    },
                    {
                        "id": 43878,
                        "name": "Marsac-sur-Don",
                        "latitude": "47.59648000",
                        "longitude": "-1.67952000"
                    },
                    {
                        "id": 43913,
                        "name": "Martigné-Briand",
                        "latitude": "47.23358000",
                        "longitude": "-0.42933000"
                    },
                    {
                        "id": 43915,
                        "name": "Martigné-sur-Mayenne",
                        "latitude": "48.20000000",
                        "longitude": "-0.66667000"
                    },
                    {
                        "id": 43950,
                        "name": "Maulévrier",
                        "latitude": "47.00929000",
                        "longitude": "-0.74239000"
                    },
                    {
                        "id": 43961,
                        "name": "Mauves-sur-Loire",
                        "latitude": "47.29738000",
                        "longitude": "-1.38763000"
                    },
                    {
                        "id": 43969,
                        "name": "Mayenne",
                        "latitude": "48.13494000",
                        "longitude": "-0.66667000"
                    },
                    {
                        "id": 43970,
                        "name": "Mayet",
                        "latitude": "47.75968000",
                        "longitude": "0.27468000"
                    },
                    {
                        "id": 43980,
                        "name": "Mazé",
                        "latitude": "47.45632000",
                        "longitude": "-0.27106000"
                    },
                    {
                        "id": 43977,
                        "name": "Mazières-en-Mauges",
                        "latitude": "47.04536000",
                        "longitude": "-0.81702000"
                    },
                    {
                        "id": 43991,
                        "name": "Melay",
                        "latitude": "47.18333000",
                        "longitude": "-0.69429000"
                    },
                    {
                        "id": 44022,
                        "name": "Mervent",
                        "latitude": "46.52239000",
                        "longitude": "-0.75654000"
                    },
                    {
                        "id": 44483,
                        "name": "Mésanger",
                        "latitude": "47.43131000",
                        "longitude": "-1.22798000"
                    },
                    {
                        "id": 44029,
                        "name": "Meslay-du-Maine",
                        "latitude": "47.95116000",
                        "longitude": "-0.55428000"
                    },
                    {
                        "id": 44031,
                        "name": "Mesquer",
                        "latitude": "47.39919000",
                        "longitude": "-2.45986000"
                    },
                    {
                        "id": 44485,
                        "name": "Mézeray",
                        "latitude": "47.82682000",
                        "longitude": "-0.01770000"
                    },
                    {
                        "id": 44102,
                        "name": "Miré",
                        "latitude": "47.75759000",
                        "longitude": "-0.49157000"
                    },
                    {
                        "id": 44104,
                        "name": "Missillac",
                        "latitude": "47.48155000",
                        "longitude": "-2.16000000"
                    },
                    {
                        "id": 44115,
                        "name": "Moisdon-la-Rivière",
                        "latitude": "47.62175000",
                        "longitude": "-1.37258000"
                    },
                    {
                        "id": 44134,
                        "name": "Moncé-en-Belin",
                        "latitude": "47.89442000",
                        "longitude": "0.19809000"
                    },
                    {
                        "id": 44146,
                        "name": "Monnières",
                        "latitude": "47.13301000",
                        "longitude": "-1.35317000"
                    },
                    {
                        "id": 44169,
                        "name": "Montaigu",
                        "latitude": "46.97667000",
                        "longitude": "-1.30846000"
                    },
                    {
                        "id": 44195,
                        "name": "Montbert",
                        "latitude": "47.05613000",
                        "longitude": "-1.48890000"
                    },
                    {
                        "id": 44197,
                        "name": "Montbizot",
                        "latitude": "48.14995000",
                        "longitude": "0.18384000"
                    },
                    {
                        "id": 44218,
                        "name": "Montenay",
                        "latitude": "48.28787000",
                        "longitude": "-0.89373000"
                    },
                    {
                        "id": 44232,
                        "name": "Montfaucon-Montigné",
                        "latitude": "47.10000000",
                        "longitude": "-1.11667000"
                    },
                    {
                        "id": 44241,
                        "name": "Montfort-le-Gesnois",
                        "latitude": "48.05000000",
                        "longitude": "0.41667000"
                    },
                    {
                        "id": 44264,
                        "name": "Montigné-le-Brillant",
                        "latitude": "48.00872000",
                        "longitude": "-0.81488000"
                    },
                    {
                        "id": 44266,
                        "name": "Montjean-sur-Loire",
                        "latitude": "47.38842000",
                        "longitude": "-0.85873000"
                    },
                    {
                        "id": 44292,
                        "name": "Montoir-de-Bretagne",
                        "latitude": "47.33012000",
                        "longitude": "-2.15107000"
                    },
                    {
                        "id": 44297,
                        "name": "Montournais",
                        "latitude": "46.74191000",
                        "longitude": "-0.76464000"
                    },
                    {
                        "id": 44309,
                        "name": "Montreuil-Bellay",
                        "latitude": "47.13106000",
                        "longitude": "-0.15209000"
                    },
                    {
                        "id": 44315,
                        "name": "Montrevault",
                        "latitude": "47.25965000",
                        "longitude": "-1.04679000"
                    },
                    {
                        "id": 44330,
                        "name": "Montsûrs",
                        "latitude": "48.13604000",
                        "longitude": "-0.55413000"
                    },
                    {
                        "id": 44342,
                        "name": "Morannes",
                        "latitude": "47.74364000",
                        "longitude": "-0.41604000"
                    },
                    {
                        "id": 44371,
                        "name": "Mortagne-sur-Sèvre",
                        "latitude": "46.99203000",
                        "longitude": "-0.94738000"
                    },
                    {
                        "id": 44382,
                        "name": "Mouchamps",
                        "latitude": "46.78131000",
                        "longitude": "-1.06179000"
                    },
                    {
                        "id": 44389,
                        "name": "Mouilleron-en-Pareds",
                        "latitude": "46.67630000",
                        "longitude": "-0.84940000"
                    },
                    {
                        "id": 44390,
                        "name": "Mouilleron-le-Captif",
                        "latitude": "46.71898000",
                        "longitude": "-1.45463000"
                    },
                    {
                        "id": 44391,
                        "name": "Moulay",
                        "latitude": "48.27245000",
                        "longitude": "-0.62734000"
                    },
                    {
                        "id": 44413,
                        "name": "Moutiers-les-Mauxfaits",
                        "latitude": "46.48333000",
                        "longitude": "-1.41667000"
                    },
                    {
                        "id": 44417,
                        "name": "Mouzeil",
                        "latitude": "47.44738000",
                        "longitude": "-1.34786000"
                    },
                    {
                        "id": 44418,
                        "name": "Mouzillon",
                        "latitude": "47.14096000",
                        "longitude": "-1.28191000"
                    },
                    {
                        "id": 44426,
                        "name": "Mozé-sur-Louet",
                        "latitude": "47.35856000",
                        "longitude": "-0.55295000"
                    },
                    {
                        "id": 44434,
                        "name": "Mulsanne",
                        "latitude": "47.91172000",
                        "longitude": "0.24938000"
                    },
                    {
                        "id": 44494,
                        "name": "Mûrs-Erigné",
                        "latitude": "47.40000000",
                        "longitude": "-0.55000000"
                    },
                    {
                        "id": 44499,
                        "name": "Nalliers",
                        "latitude": "46.47071000",
                        "longitude": "-1.02774000"
                    },
                    {
                        "id": 44506,
                        "name": "Nantes",
                        "latitude": "47.21725000",
                        "longitude": "-1.55336000"
                    },
                    {
                        "id": 44536,
                        "name": "Nesmy",
                        "latitude": "46.59078000",
                        "longitude": "-1.40074000"
                    },
                    {
                        "id": 44572,
                        "name": "Neuville-sur-Sarthe",
                        "latitude": "48.07615000",
                        "longitude": "0.19264000"
                    },
                    {
                        "id": 44596,
                        "name": "Nieul-le-Dolent",
                        "latitude": "46.57379000",
                        "longitude": "-1.50808000"
                    },
                    {
                        "id": 44624,
                        "name": "Noirmoutier-en-l’Île",
                        "latitude": "46.99733000",
                        "longitude": "-2.27374000"
                    },
                    {
                        "id": 44645,
                        "name": "Nort-sur-Erdre",
                        "latitude": "47.43881000",
                        "longitude": "-1.49833000"
                    },
                    {
                        "id": 44652,
                        "name": "Notre-Dame-de-Monts",
                        "latitude": "46.83100000",
                        "longitude": "-2.13100000"
                    },
                    {
                        "id": 44654,
                        "name": "Notre-Dame-de-Riez",
                        "latitude": "46.74445000",
                        "longitude": "-1.90857000"
                    },
                    {
                        "id": 44656,
                        "name": "Notre-Dame-des-Landes",
                        "latitude": "47.38048000",
                        "longitude": "-1.70904000"
                    },
                    {
                        "id": 44672,
                        "name": "Noyant",
                        "latitude": "47.51048000",
                        "longitude": "0.11771000"
                    },
                    {
                        "id": 44673,
                        "name": "Noyant-la-Gravoyère",
                        "latitude": "47.70348000",
                        "longitude": "-0.95730000"
                    },
                    {
                        "id": 44678,
                        "name": "Noyen-sur-Sarthe",
                        "latitude": "47.87187000",
                        "longitude": "-0.09916000"
                    },
                    {
                        "id": 44682,
                        "name": "Nozay",
                        "latitude": "47.56495000",
                        "longitude": "-1.62629000"
                    },
                    {
                        "id": 44684,
                        "name": "Nuaillé",
                        "latitude": "47.09524000",
                        "longitude": "-0.79477000"
                    },
                    {
                        "id": 44686,
                        "name": "Nueil-sur-Layon",
                        "latitude": "47.11811000",
                        "longitude": "-0.36573000"
                    },
                    {
                        "id": 44687,
                        "name": "Nuillé-sur-Vicoin",
                        "latitude": "47.98556000",
                        "longitude": "-0.78351000"
                    },
                    {
                        "id": 44689,
                        "name": "Nyoiseau",
                        "latitude": "47.71667000",
                        "longitude": "-0.91667000"
                    },
                    {
                        "id": 44727,
                        "name": "Oisseau",
                        "latitude": "48.35559000",
                        "longitude": "-0.67148000"
                    },
                    {
                        "id": 44737,
                        "name": "Olonne-sur-Mer",
                        "latitude": "46.53524000",
                        "longitude": "-1.77293000"
                    },
                    {
                        "id": 44788,
                        "name": "Orvault",
                        "latitude": "47.27095000",
                        "longitude": "-1.62190000"
                    },
                    {
                        "id": 44803,
                        "name": "Oudon",
                        "latitude": "47.34774000",
                        "longitude": "-1.28500000"
                    },
                    {
                        "id": 44828,
                        "name": "Paimboeuf",
                        "latitude": "47.28654000",
                        "longitude": "-2.03048000"
                    },
                    {
                        "id": 44843,
                        "name": "Pannecé",
                        "latitude": "47.48583000",
                        "longitude": "-1.23940000"
                    },
                    {
                        "id": 44861,
                        "name": "Parçay-les-Pins",
                        "latitude": "47.43668000",
                        "longitude": "0.16312000"
                    },
                    {
                        "id": 44849,
                        "name": "Parcé-sur-Sarthe",
                        "latitude": "47.84356000",
                        "longitude": "-0.20104000"
                    },
                    {
                        "id": 44855,
                        "name": "Parigné-le-Pôlin",
                        "latitude": "47.84987000",
                        "longitude": "0.10705000"
                    },
                    {
                        "id": 44872,
                        "name": "Paulx",
                        "latitude": "46.96181000",
                        "longitude": "-1.75520000"
                    },
                    {
                        "id": 44887,
                        "name": "Pellouailles-les-Vignes",
                        "latitude": "47.52172000",
                        "longitude": "-0.43954000"
                    },
                    {
                        "id": 44916,
                        "name": "Petit-Mars",
                        "latitude": "47.39512000",
                        "longitude": "-1.45262000"
                    },
                    {
                        "id": 44978,
                        "name": "Piriac-sur-Mer",
                        "latitude": "47.37938000",
                        "longitude": "-2.54616000"
                    },
                    {
                        "id": 44982,
                        "name": "Pissotte",
                        "latitude": "46.49725000",
                        "longitude": "-0.80666000"
                    },
                    {
                        "id": 45011,
                        "name": "Plessé",
                        "latitude": "47.54180000",
                        "longitude": "-1.88609000"
                    },
                    {
                        "id": 45170,
                        "name": "Pont-Saint-Martin",
                        "latitude": "47.12338000",
                        "longitude": "-1.58455000"
                    },
                    {
                        "id": 45206,
                        "name": "Pontchâteau",
                        "latitude": "47.43797000",
                        "longitude": "-2.09011000"
                    },
                    {
                        "id": 45218,
                        "name": "Pontvallain",
                        "latitude": "47.75169000",
                        "longitude": "0.19145000"
                    },
                    {
                        "id": 45223,
                        "name": "Pornic",
                        "latitude": "47.11205000",
                        "longitude": "-2.08888000"
                    },
                    {
                        "id": 45224,
                        "name": "Pornichet",
                        "latitude": "47.26682000",
                        "longitude": "-2.33794000"
                    },
                    {
                        "id": 45227,
                        "name": "Port-Brillet",
                        "latitude": "48.11315000",
                        "longitude": "-0.97080000"
                    },
                    {
                        "id": 45230,
                        "name": "Port-Saint-Père",
                        "latitude": "47.13294000",
                        "longitude": "-1.74850000"
                    },
                    {
                        "id": 45249,
                        "name": "Pouancé",
                        "latitude": "47.74167000",
                        "longitude": "-1.17366000"
                    },
                    {
                        "id": 45271,
                        "name": "Pouzauges",
                        "latitude": "46.77941000",
                        "longitude": "-0.83619000"
                    },
                    {
                        "id": 45302,
                        "name": "Pré-en-Pail",
                        "latitude": "48.45993000",
                        "longitude": "-0.19814000"
                    },
                    {
                        "id": 45306,
                        "name": "Précigné",
                        "latitude": "47.76692000",
                        "longitude": "-0.32491000"
                    },
                    {
                        "id": 45308,
                        "name": "Préfailles",
                        "latitude": "47.12839000",
                        "longitude": "-2.21693000"
                    },
                    {
                        "id": 45289,
                        "name": "Prinquiau",
                        "latitude": "47.36215000",
                        "longitude": "-2.00952000"
                    },
                    {
                        "id": 45299,
                        "name": "Pruillé-le-Chétif",
                        "latitude": "47.99383000",
                        "longitude": "0.10677000"
                    },
                    {
                        "id": 45372,
                        "name": "Quelaines-Saint-Gault",
                        "latitude": "47.93333000",
                        "longitude": "-0.80000000"
                    },
                    {
                        "id": 45388,
                        "name": "Quilly",
                        "latitude": "47.46131000",
                        "longitude": "-1.95274000"
                    },
                    {
                        "id": 45453,
                        "name": "Remouillé",
                        "latitude": "47.05587000",
                        "longitude": "-1.37682000"
                    },
                    {
                        "id": 45458,
                        "name": "Renazé",
                        "latitude": "47.79340000",
                        "longitude": "-1.05437000"
                    },
                    {
                        "id": 45463,
                        "name": "Requeil",
                        "latitude": "47.78371000",
                        "longitude": "0.16105000"
                    },
                    {
                        "id": 45482,
                        "name": "Rezé",
                        "latitude": "47.18144000",
                        "longitude": "-1.54965000"
                    },
                    {
                        "id": 45485,
                        "name": "Riaillé",
                        "latitude": "47.51797000",
                        "longitude": "-1.29404000"
                    },
                    {
                        "id": 45546,
                        "name": "Rochefort-sur-Loire",
                        "latitude": "47.35705000",
                        "longitude": "-0.65696000"
                    },
                    {
                        "id": 45550,
                        "name": "Rocheservière",
                        "latitude": "46.93765000",
                        "longitude": "-1.51143000"
                    },
                    {
                        "id": 45656,
                        "name": "Roézé-sur-Sarthe",
                        "latitude": "47.89546000",
                        "longitude": "0.06723000"
                    },
                    {
                        "id": 45615,
                        "name": "Rouans",
                        "latitude": "47.18321000",
                        "longitude": "-1.85929000"
                    },
                    {
                        "id": 45625,
                        "name": "Rougé",
                        "latitude": "47.78367000",
                        "longitude": "-1.44763000"
                    },
                    {
                        "id": 45628,
                        "name": "Rouillon",
                        "latitude": "48.00629000",
                        "longitude": "0.13527000"
                    },
                    {
                        "id": 45636,
                        "name": "Roussay",
                        "latitude": "47.09011000",
                        "longitude": "-1.06417000"
                    },
                    {
                        "id": 45657,
                        "name": "Ruaudin",
                        "latitude": "47.94509000",
                        "longitude": "0.26760000"
                    },
                    {
                        "id": 45667,
                        "name": "Ruillé-sur-Loir",
                        "latitude": "47.75075000",
                        "longitude": "0.62058000"
                    },
                    {
                        "id": 45703,
                        "name": "Sablé-sur-Sarthe",
                        "latitude": "47.83765000",
                        "longitude": "-0.33294000"
                    },
                    {
                        "id": 45711,
                        "name": "Saffré",
                        "latitude": "47.50143000",
                        "longitude": "-1.57856000"
                    },
                    {
                        "id": 45760,
                        "name": "Saint-André-de-la-Marche",
                        "latitude": "47.09952000",
                        "longitude": "-0.99441000"
                    },
                    {
                        "id": 45762,
                        "name": "Saint-André-des-Eaux",
                        "latitude": "47.31461000",
                        "longitude": "-2.31105000"
                    },
                    {
                        "id": 45756,
                        "name": "Saint-André-Treize-Voies",
                        "latitude": "46.93369000",
                        "longitude": "-1.41274000"
                    },
                    {
                        "id": 45784,
                        "name": "Saint-Aubin-des-Châteaux",
                        "latitude": "47.72047000",
                        "longitude": "-1.48876000"
                    },
                    {
                        "id": 45785,
                        "name": "Saint-Aubin-des-Ormeaux",
                        "latitude": "46.99238000",
                        "longitude": "-1.04274000"
                    },
                    {
                        "id": 45806,
                        "name": "Saint-Baudelle",
                        "latitude": "48.28081000",
                        "longitude": "-0.63728000"
                    },
                    {
                        "id": 45814,
                        "name": "Saint-Berthevin",
                        "latitude": "48.06667000",
                        "longitude": "-0.83333000"
                    },
                    {
                        "id": 45823,
                        "name": "Saint-Brevin-les-Pins",
                        "latitude": "47.25000000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 45836,
                        "name": "Saint-Calais",
                        "latitude": "47.92211000",
                        "longitude": "0.74587000"
                    },
                    {
                        "id": 45857,
                        "name": "Saint-Christophe-du-Bois",
                        "latitude": "47.03012000",
                        "longitude": "-0.94441000"
                    },
                    {
                        "id": 45858,
                        "name": "Saint-Christophe-du-Ligneron",
                        "latitude": "46.82478000",
                        "longitude": "-1.76586000"
                    },
                    {
                        "id": 45872,
                        "name": "Saint-Clément-de-la-Place",
                        "latitude": "47.52744000",
                        "longitude": "-0.74545000"
                    },
                    {
                        "id": 45873,
                        "name": "Saint-Clément-des-Levées",
                        "latitude": "47.33333000",
                        "longitude": "-0.18222000"
                    },
                    {
                        "id": 45875,
                        "name": "Saint-Cosme-en-Vairais",
                        "latitude": "48.26667000",
                        "longitude": "0.46667000"
                    },
                    {
                        "id": 45877,
                        "name": "Saint-Crespin-sur-Moine",
                        "latitude": "47.09968000",
                        "longitude": "-1.18651000"
                    },
                    {
                        "id": 45883,
                        "name": "Saint-Cyr-en-Bourg",
                        "latitude": "47.19520000",
                        "longitude": "-0.06085000"
                    },
                    {
                        "id": 45896,
                        "name": "Saint-Denis-de-Gastines",
                        "latitude": "48.34210000",
                        "longitude": "-0.85869000"
                    },
                    {
                        "id": 45901,
                        "name": "Saint-Denis-la-Chevasse",
                        "latitude": "46.82273000",
                        "longitude": "-1.35749000"
                    },
                    {
                        "id": 46647,
                        "name": "Saint-Étienne-de-Mer-Morte",
                        "latitude": "46.92848000",
                        "longitude": "-1.74272000"
                    },
                    {
                        "id": 46648,
                        "name": "Saint-Étienne-de-Montluc",
                        "latitude": "47.27690000",
                        "longitude": "-1.78072000"
                    },
                    {
                        "id": 46652,
                        "name": "Saint-Étienne-du-Bois",
                        "latitude": "46.83041000",
                        "longitude": "-1.59714000"
                    },
                    {
                        "id": 45931,
                        "name": "Saint-Fiacre-sur-Maine",
                        "latitude": "47.14255000",
                        "longitude": "-1.41714000"
                    },
                    {
                        "id": 45933,
                        "name": "Saint-Florent-des-Bois",
                        "latitude": "46.59377000",
                        "longitude": "-1.31580000"
                    },
                    {
                        "id": 45934,
                        "name": "Saint-Florent-le-Vieil",
                        "latitude": "47.36069000",
                        "longitude": "-1.01515000"
                    },
                    {
                        "id": 45942,
                        "name": "Saint-Fort",
                        "latitude": "47.79928000",
                        "longitude": "-0.72095000"
                    },
                    {
                        "id": 45944,
                        "name": "Saint-Fulgent",
                        "latitude": "46.85226000",
                        "longitude": "-1.17798000"
                    },
                    {
                        "id": 45971,
                        "name": "Saint-Georges-Buttavent",
                        "latitude": "48.31018000",
                        "longitude": "-0.69372000"
                    },
                    {
                        "id": 45977,
                        "name": "Saint-Georges-de-Montaigu",
                        "latitude": "46.94655000",
                        "longitude": "-1.29262000"
                    },
                    {
                        "id": 45978,
                        "name": "Saint-Georges-de-Pointindoux",
                        "latitude": "46.64462000",
                        "longitude": "-1.62204000"
                    },
                    {
                        "id": 45983,
                        "name": "Saint-Georges-du-Bois",
                        "latitude": "47.97242000",
                        "longitude": "0.10113000"
                    },
                    {
                        "id": 45991,
                        "name": "Saint-Georges-sur-Loire",
                        "latitude": "47.40792000",
                        "longitude": "-0.76194000"
                    },
                    {
                        "id": 46046,
                        "name": "Saint-Géréon",
                        "latitude": "47.36774000",
                        "longitude": "-1.20262000"
                    },
                    {
                        "id": 46004,
                        "name": "Saint-Germain-de-Prinçay",
                        "latitude": "46.72107000",
                        "longitude": "-1.02153000"
                    },
                    {
                        "id": 46007,
                        "name": "Saint-Germain-des-Prés",
                        "latitude": "47.40998000",
                        "longitude": "-0.83342000"
                    },
                    {
                        "id": 46021,
                        "name": "Saint-Germain-sur-Moine",
                        "latitude": "47.11746000",
                        "longitude": "-1.12223000"
                    },
                    {
                        "id": 46025,
                        "name": "Saint-Gervais",
                        "latitude": "46.90174000",
                        "longitude": "-2.00210000"
                    },
                    {
                        "id": 46027,
                        "name": "Saint-Gervais-en-Belin",
                        "latitude": "47.87720000",
                        "longitude": "0.21770000"
                    },
                    {
                        "id": 46033,
                        "name": "Saint-Gildas-des-Bois",
                        "latitude": "47.51622000",
                        "longitude": "-2.03659000"
                    },
                    {
                        "id": 46036,
                        "name": "Saint-Gilles-Croix-de-Vie",
                        "latitude": "46.69761000",
                        "longitude": "-1.94561000"
                    },
                    {
                        "id": 46048,
                        "name": "Saint-Herblain",
                        "latitude": "47.21765000",
                        "longitude": "-1.64841000"
                    },
                    {
                        "id": 46049,
                        "name": "Saint-Herblon",
                        "latitude": "47.40786000",
                        "longitude": "-1.09738000"
                    },
                    {
                        "id": 46055,
                        "name": "Saint-Hilaire-de-Chaléons",
                        "latitude": "47.10196000",
                        "longitude": "-1.86690000"
                    },
                    {
                        "id": 46056,
                        "name": "Saint-Hilaire-de-Clisson",
                        "latitude": "47.06222000",
                        "longitude": "-1.30778000"
                    },
                    {
                        "id": 46057,
                        "name": "Saint-Hilaire-de-Loulay",
                        "latitude": "47.00190000",
                        "longitude": "-1.33079000"
                    },
                    {
                        "id": 46058,
                        "name": "Saint-Hilaire-de-Riez",
                        "latitude": "46.71308000",
                        "longitude": "-1.92583000"
                    },
                    {
                        "id": 46059,
                        "name": "Saint-Hilaire-de-Talmont",
                        "latitude": "46.47002000",
                        "longitude": "-1.60359000"
                    },
                    {
                        "id": 46062,
                        "name": "Saint-Hilaire-des-Loges",
                        "latitude": "46.47190000",
                        "longitude": "-0.66393000"
                    },
                    {
                        "id": 46080,
                        "name": "Saint-Jean",
                        "latitude": "47.24553000",
                        "longitude": "-0.38413000"
                    },
                    {
                        "id": 46087,
                        "name": "Saint-Jean-de-Boiseau",
                        "latitude": "47.19315000",
                        "longitude": "-1.72340000"
                    },
                    {
                        "id": 46097,
                        "name": "Saint-Jean-de-Monts",
                        "latitude": "46.79088000",
                        "longitude": "-2.08219000"
                    },
                    {
                        "id": 46108,
                        "name": "Saint-Jean-des-Mauvrets",
                        "latitude": "47.39857000",
                        "longitude": "-0.44929000"
                    },
                    {
                        "id": 46120,
                        "name": "Saint-Jean-sur-Mayenne",
                        "latitude": "48.13522000",
                        "longitude": "-0.75613000"
                    },
                    {
                        "id": 46124,
                        "name": "Saint-Joachim",
                        "latitude": "47.38349000",
                        "longitude": "-2.19239000"
                    },
                    {
                        "id": 46139,
                        "name": "Saint-Julien-de-Concelles",
                        "latitude": "47.25285000",
                        "longitude": "-1.38428000"
                    },
                    {
                        "id": 46141,
                        "name": "Saint-Julien-des-Landes",
                        "latitude": "46.63940000",
                        "longitude": "-1.71381000"
                    },
                    {
                        "id": 46168,
                        "name": "Saint-Lambert-du-Lattay",
                        "latitude": "47.30250000",
                        "longitude": "-0.63321000"
                    },
                    {
                        "id": 46169,
                        "name": "Saint-Lambert-la-Potherie",
                        "latitude": "47.48289000",
                        "longitude": "-0.67789000"
                    },
                    {
                        "id": 46178,
                        "name": "Saint-Laurent-de-la-Plaine",
                        "latitude": "47.31738000",
                        "longitude": "-0.80333000"
                    },
                    {
                        "id": 46182,
                        "name": "Saint-Laurent-des-Autels",
                        "latitude": "47.28524000",
                        "longitude": "-1.18881000"
                    },
                    {
                        "id": 46190,
                        "name": "Saint-Laurent-sur-Sèvre",
                        "latitude": "46.95809000",
                        "longitude": "-0.89392000"
                    },
                    {
                        "id": 46211,
                        "name": "Saint-Léger-des-Bois",
                        "latitude": "47.46238000",
                        "longitude": "-0.70953000"
                    },
                    {
                        "id": 46215,
                        "name": "Saint-Léger-les-Vignes",
                        "latitude": "47.13587000",
                        "longitude": "-1.73060000"
                    },
                    {
                        "id": 46217,
                        "name": "Saint-Léger-sous-Cholet",
                        "latitude": "47.09405000",
                        "longitude": "-0.91024000"
                    },
                    {
                        "id": 46203,
                        "name": "Saint-Lumine-de-Clisson",
                        "latitude": "47.08413000",
                        "longitude": "-1.33524000"
                    },
                    {
                        "id": 46204,
                        "name": "Saint-Lumine-de-Coutais",
                        "latitude": "47.05399000",
                        "longitude": "-1.72777000"
                    },
                    {
                        "id": 46207,
                        "name": "Saint-Lyphard",
                        "latitude": "47.39822000",
                        "longitude": "-2.30642000"
                    },
                    {
                        "id": 46227,
                        "name": "Saint-Macaire-en-Mauges",
                        "latitude": "47.12357000",
                        "longitude": "-0.99120000"
                    },
                    {
                        "id": 46230,
                        "name": "Saint-Malo-de-Guersac",
                        "latitude": "47.35345000",
                        "longitude": "-2.17773000"
                    },
                    {
                        "id": 46231,
                        "name": "Saint-Malô-du-Bois",
                        "latitude": "46.93333000",
                        "longitude": "-0.90000000"
                    },
                    {
                        "id": 46256,
                        "name": "Saint-Mars-d’Outillé",
                        "latitude": "47.87034000",
                        "longitude": "0.33221000"
                    },
                    {
                        "id": 46254,
                        "name": "Saint-Mars-de-Coutais",
                        "latitude": "47.11153000",
                        "longitude": "-1.73437000"
                    },
                    {
                        "id": 46255,
                        "name": "Saint-Mars-du-Désert",
                        "latitude": "47.36560000",
                        "longitude": "-1.40678000"
                    },
                    {
                        "id": 46257,
                        "name": "Saint-Mars-la-Brière",
                        "latitude": "48.03046000",
                        "longitude": "0.37319000"
                    },
                    {
                        "id": 46258,
                        "name": "Saint-Mars-la-Jaille",
                        "latitude": "47.52566000",
                        "longitude": "-1.18483000"
                    },
                    {
                        "id": 46281,
                        "name": "Saint-Martin-de-la-Place",
                        "latitude": "47.31747000",
                        "longitude": "-0.14849000"
                    },
                    {
                        "id": 46285,
                        "name": "Saint-Martin-des-Noyers",
                        "latitude": "46.72226000",
                        "longitude": "-1.17727000"
                    },
                    {
                        "id": 46286,
                        "name": "Saint-Martin-du-Fouilloux",
                        "latitude": "47.43360000",
                        "longitude": "-0.70357000"
                    },
                    {
                        "id": 46302,
                        "name": "Saint-Martin-sous-Mouzeuil",
                        "latitude": "46.45905000",
                        "longitude": "-0.98893000"
                    },
                    {
                        "id": 46307,
                        "name": "Saint-Mathurin",
                        "latitude": "46.56493000",
                        "longitude": "-1.71389000"
                    },
                    {
                        "id": 46308,
                        "name": "Saint-Mathurin-sur-Loire",
                        "latitude": "47.41667000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 46327,
                        "name": "Saint-Melaine-sur-Aubance",
                        "latitude": "47.36667000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 46354,
                        "name": "Saint-Même-le-Tenu",
                        "latitude": "47.02005000",
                        "longitude": "-1.79459000"
                    },
                    {
                        "id": 46331,
                        "name": "Saint-Mesmin",
                        "latitude": "46.79369000",
                        "longitude": "-0.73262000"
                    },
                    {
                        "id": 46335,
                        "name": "Saint-Michel-Chef-Chef",
                        "latitude": "47.18072000",
                        "longitude": "-2.14869000"
                    },
                    {
                        "id": 46338,
                        "name": "Saint-Michel-le-Cloucq",
                        "latitude": "46.48500000",
                        "longitude": "-0.75262000"
                    },
                    {
                        "id": 46336,
                        "name": "Saint-Michel-Mont-Mercure",
                        "latitude": "46.82941000",
                        "longitude": "-0.88298000"
                    },
                    {
                        "id": 46345,
                        "name": "Saint-Molf",
                        "latitude": "47.39167000",
                        "longitude": "-2.42357000"
                    },
                    {
                        "id": 46358,
                        "name": "Saint-Nazaire",
                        "latitude": "47.27956000",
                        "longitude": "-2.20993000"
                    },
                    {
                        "id": 46365,
                        "name": "Saint-Nicolas-de-Redon",
                        "latitude": "47.64343000",
                        "longitude": "-2.06305000"
                    },
                    {
                        "id": 46385,
                        "name": "Saint-Ouën-des-Toits",
                        "latitude": "48.13333000",
                        "longitude": "-0.90000000"
                    },
                    {
                        "id": 46382,
                        "name": "Saint-Ouen-en-Belin",
                        "latitude": "47.83302000",
                        "longitude": "0.20924000"
                    },
                    {
                        "id": 46398,
                        "name": "Saint-Paterne",
                        "latitude": "48.41614000",
                        "longitude": "0.11271000"
                    },
                    {
                        "id": 46415,
                        "name": "Saint-Paul-en-Pareds",
                        "latitude": "46.82214000",
                        "longitude": "-0.98977000"
                    },
                    {
                        "id": 46478,
                        "name": "Saint-Père-en-Retz",
                        "latitude": "47.20559000",
                        "longitude": "-2.04095000"
                    },
                    {
                        "id": 46423,
                        "name": "Saint-Philbert-de-Bouaine",
                        "latitude": "46.98568000",
                        "longitude": "-1.52022000"
                    },
                    {
                        "id": 46424,
                        "name": "Saint-Philbert-de-Grand-Lieu",
                        "latitude": "47.03580000",
                        "longitude": "-1.64120000"
                    },
                    {
                        "id": 46425,
                        "name": "Saint-Philbert-du-Peuple",
                        "latitude": "47.39314000",
                        "longitude": "-0.04360000"
                    },
                    {
                        "id": 46437,
                        "name": "Saint-Pierre-des-Nids",
                        "latitude": "48.39826000",
                        "longitude": "-0.09984000"
                    },
                    {
                        "id": 46439,
                        "name": "Saint-Pierre-du-Chemin",
                        "latitude": "46.69523000",
                        "longitude": "-0.70095000"
                    },
                    {
                        "id": 46447,
                        "name": "Saint-Pierre-la-Cour",
                        "latitude": "48.11258000",
                        "longitude": "-1.02496000"
                    },
                    {
                        "id": 46429,
                        "name": "Saint-Pierre-Montlimart",
                        "latitude": "47.26976000",
                        "longitude": "-1.02738000"
                    },
                    {
                        "id": 46474,
                        "name": "Saint-Prouant",
                        "latitude": "46.75822000",
                        "longitude": "-0.95703000"
                    },
                    {
                        "id": 46488,
                        "name": "Saint-Quentin-en-Mauges",
                        "latitude": "47.29130000",
                        "longitude": "-0.91191000"
                    },
                    {
                        "id": 46512,
                        "name": "Saint-Rémy-en-Mauges",
                        "latitude": "47.27202000",
                        "longitude": "-1.07499000"
                    },
                    {
                        "id": 46520,
                        "name": "Saint-Saturnin",
                        "latitude": "48.05795000",
                        "longitude": "0.15218000"
                    },
                    {
                        "id": 46524,
                        "name": "Saint-Saturnin-sur-Loire",
                        "latitude": "47.39438000",
                        "longitude": "-0.43565000"
                    },
                    {
                        "id": 46578,
                        "name": "Saint-Sébastien-sur-Loire",
                        "latitude": "47.20768000",
                        "longitude": "-1.50332000"
                    },
                    {
                        "id": 46590,
                        "name": "Saint-Urbain",
                        "latitude": "46.87557000",
                        "longitude": "-2.00961000"
                    },
                    {
                        "id": 46606,
                        "name": "Saint-Viaud",
                        "latitude": "47.25619000",
                        "longitude": "-2.01833000"
                    },
                    {
                        "id": 46616,
                        "name": "Saint-Vincent-des-Landes",
                        "latitude": "47.65695000",
                        "longitude": "-1.49572000"
                    },
                    {
                        "id": 46617,
                        "name": "Saint-Vincent-sur-Graon",
                        "latitude": "46.51690000",
                        "longitude": "-1.38881000"
                    },
                    {
                        "id": 46665,
                        "name": "Sainte-Anne-sur-Brivet",
                        "latitude": "47.46071000",
                        "longitude": "-2.00415000"
                    },
                    {
                        "id": 46674,
                        "name": "Sainte-Cécile",
                        "latitude": "46.74286000",
                        "longitude": "-1.11429000"
                    },
                    {
                        "id": 46679,
                        "name": "Sainte-Flaive-des-Loups",
                        "latitude": "46.61303000",
                        "longitude": "-1.58082000"
                    },
                    {
                        "id": 46682,
                        "name": "Sainte-Foy",
                        "latitude": "46.54488000",
                        "longitude": "-1.67265000"
                    },
                    {
                        "id": 46689,
                        "name": "Sainte-Gemme-la-Plaine",
                        "latitude": "46.48286000",
                        "longitude": "-1.11321000"
                    },
                    {
                        "id": 46690,
                        "name": "Sainte-Gemmes-sur-Loire",
                        "latitude": "47.42290000",
                        "longitude": "-0.55684000"
                    },
                    {
                        "id": 46695,
                        "name": "Sainte-Hermine",
                        "latitude": "46.55619000",
                        "longitude": "-1.05476000"
                    },
                    {
                        "id": 46700,
                        "name": "Sainte-Jamme-sur-Sarthe",
                        "latitude": "48.14264000",
                        "longitude": "0.16743000"
                    },
                    {
                        "id": 46703,
                        "name": "Sainte-Luce-sur-Loire",
                        "latitude": "47.25381000",
                        "longitude": "-1.48430000"
                    },
                    {
                        "id": 46721,
                        "name": "Sainte-Pazanne",
                        "latitude": "47.10301000",
                        "longitude": "-1.80950000"
                    },
                    {
                        "id": 46724,
                        "name": "Sainte-Reine-de-Bretagne",
                        "latitude": "47.44131000",
                        "longitude": "-2.19238000"
                    },
                    {
                        "id": 46729,
                        "name": "Sainte-Suzanne",
                        "latitude": "48.09818000",
                        "longitude": "-0.35439000"
                    },
                    {
                        "id": 46752,
                        "name": "Saligny",
                        "latitude": "46.80833000",
                        "longitude": "-1.42726000"
                    },
                    {
                        "id": 46760,
                        "name": "Sallertaine",
                        "latitude": "46.86017000",
                        "longitude": "-1.95522000"
                    },
                    {
                        "id": 46805,
                        "name": "Sargé-lès-le-Mans",
                        "latitude": "48.03333000",
                        "longitude": "0.23333000"
                    },
                    {
                        "id": 46820,
                        "name": "Sarthe",
                        "latitude": "48.00493000",
                        "longitude": "0.26516000"
                    },
                    {
                        "id": 46852,
                        "name": "Saumur",
                        "latitude": "47.25908000",
                        "longitude": "-0.07796000"
                    },
                    {
                        "id": 46857,
                        "name": "Sautron",
                        "latitude": "47.26274000",
                        "longitude": "-1.67107000"
                    },
                    {
                        "id": 46871,
                        "name": "Savenay",
                        "latitude": "47.36072000",
                        "longitude": "-1.94215000"
                    },
                    {
                        "id": 46872,
                        "name": "Savennières",
                        "latitude": "47.38225000",
                        "longitude": "-0.65708000"
                    },
                    {
                        "id": 46915,
                        "name": "Segré",
                        "latitude": "47.68646000",
                        "longitude": "-0.87237000"
                    },
                    {
                        "id": 46917,
                        "name": "Seiches-sur-le-Loir",
                        "latitude": "47.57351000",
                        "longitude": "-0.35628000"
                    },
                    {
                        "id": 47146,
                        "name": "Sérigné",
                        "latitude": "46.50107000",
                        "longitude": "-0.84453000"
                    },
                    {
                        "id": 47149,
                        "name": "Sévérac",
                        "latitude": "47.55008000",
                        "longitude": "-2.07496000"
                    },
                    {
                        "id": 46999,
                        "name": "Sillé-le-Guillaume",
                        "latitude": "48.18266000",
                        "longitude": "-0.12642000"
                    },
                    {
                        "id": 47005,
                        "name": "Sion-les-Mines",
                        "latitude": "47.73476000",
                        "longitude": "-1.59190000"
                    },
                    {
                        "id": 47025,
                        "name": "Solesmes",
                        "latitude": "47.85009000",
                        "longitude": "-0.29806000"
                    },
                    {
                        "id": 47057,
                        "name": "Soucelles",
                        "latitude": "47.56848000",
                        "longitude": "-0.41819000"
                    },
                    {
                        "id": 47062,
                        "name": "Soudan",
                        "latitude": "47.73777000",
                        "longitude": "-1.30566000"
                    },
                    {
                        "id": 47069,
                        "name": "Soulaines-sur-Aubance",
                        "latitude": "47.36381000",
                        "longitude": "-0.52265000"
                    },
                    {
                        "id": 47070,
                        "name": "Soulaire-et-Bourg",
                        "latitude": "47.57896000",
                        "longitude": "-0.55232000"
                    },
                    {
                        "id": 47071,
                        "name": "Soulgé-sur-Ouette",
                        "latitude": "48.06667000",
                        "longitude": "-0.56667000"
                    },
                    {
                        "id": 47072,
                        "name": "Souligné-sous-Ballon",
                        "latitude": "48.13758000",
                        "longitude": "0.23572000"
                    },
                    {
                        "id": 47073,
                        "name": "Soullans",
                        "latitude": "46.79624000",
                        "longitude": "-1.90106000"
                    },
                    {
                        "id": 47092,
                        "name": "Spay",
                        "latitude": "47.92384000",
                        "longitude": "0.15258000"
                    },
                    {
                        "id": 47112,
                        "name": "Sucé-sur-Erdre",
                        "latitude": "47.33333000",
                        "longitude": "-1.53333000"
                    },
                    {
                        "id": 47194,
                        "name": "Teillé",
                        "latitude": "47.46170000",
                        "longitude": "-1.27810000"
                    },
                    {
                        "id": 47196,
                        "name": "Teloché",
                        "latitude": "47.88819000",
                        "longitude": "0.27086000"
                    },
                    {
                        "id": 47203,
                        "name": "Tennie",
                        "latitude": "48.10769000",
                        "longitude": "-0.07626000"
                    },
                    {
                        "id": 47252,
                        "name": "Thorigné-sur-Dué",
                        "latitude": "48.03920000",
                        "longitude": "0.53554000"
                    },
                    {
                        "id": 47253,
                        "name": "Thouarcé",
                        "latitude": "47.26734000",
                        "longitude": "-0.50186000"
                    },
                    {
                        "id": 47255,
                        "name": "Thouaré-sur-Loire",
                        "latitude": "47.26893000",
                        "longitude": "-1.43834000"
                    },
                    {
                        "id": 47276,
                        "name": "Tiercé",
                        "latitude": "47.61587000",
                        "longitude": "-0.46609000"
                    },
                    {
                        "id": 47277,
                        "name": "Tiffauges",
                        "latitude": "47.01080000",
                        "longitude": "-1.10999000"
                    },
                    {
                        "id": 47282,
                        "name": "Tillières",
                        "latitude": "47.14397000",
                        "longitude": "-1.16334000"
                    },
                    {
                        "id": 47302,
                        "name": "Torfou",
                        "latitude": "47.03682000",
                        "longitude": "-1.11635000"
                    },
                    {
                        "id": 47342,
                        "name": "Toutlemonde",
                        "latitude": "47.05488000",
                        "longitude": "-0.76548000"
                    },
                    {
                        "id": 47343,
                        "name": "Touvois",
                        "latitude": "46.90208000",
                        "longitude": "-1.68333000"
                    },
                    {
                        "id": 47347,
                        "name": "Trangé",
                        "latitude": "48.02706000",
                        "longitude": "0.11054000"
                    },
                    {
                        "id": 47355,
                        "name": "Treillières",
                        "latitude": "47.33060000",
                        "longitude": "-1.61918000"
                    },
                    {
                        "id": 47356,
                        "name": "Treize-Septiers",
                        "latitude": "46.98524000",
                        "longitude": "-1.22921000"
                    },
                    {
                        "id": 47396,
                        "name": "Trélazé",
                        "latitude": "47.44565000",
                        "longitude": "-0.46540000"
                    },
                    {
                        "id": 47401,
                        "name": "Trémentines",
                        "latitude": "47.12357000",
                        "longitude": "-0.78500000"
                    },
                    {
                        "id": 47367,
                        "name": "Triaize",
                        "latitude": "46.39265000",
                        "longitude": "-1.19785000"
                    },
                    {
                        "id": 47373,
                        "name": "Trignac",
                        "latitude": "47.31809000",
                        "longitude": "-2.18895000"
                    },
                    {
                        "id": 47411,
                        "name": "Tuffé",
                        "latitude": "48.11319000",
                        "longitude": "0.51551000"
                    },
                    {
                        "id": 47449,
                        "name": "Vaas",
                        "latitude": "47.66890000",
                        "longitude": "0.31677000"
                    },
                    {
                        "id": 47454,
                        "name": "Vaiges",
                        "latitude": "48.04025000",
                        "longitude": "-0.47513000"
                    },
                    {
                        "id": 47458,
                        "name": "Vairé",
                        "latitude": "46.60104000",
                        "longitude": "-1.75538000"
                    },
                    {
                        "id": 47489,
                        "name": "Vallet",
                        "latitude": "47.16227000",
                        "longitude": "-1.26607000"
                    },
                    {
                        "id": 47507,
                        "name": "Varades",
                        "latitude": "47.38458000",
                        "longitude": "-1.02842000"
                    },
                    {
                        "id": 47515,
                        "name": "Varennes-sur-Loire",
                        "latitude": "47.23767000",
                        "longitude": "0.05350000"
                    },
                    {
                        "id": 47520,
                        "name": "Varrains",
                        "latitude": "47.22305000",
                        "longitude": "-0.06033000"
                    },
                    {
                        "id": 47528,
                        "name": "Vauchrétien",
                        "latitude": "47.33234000",
                        "longitude": "-0.47678000"
                    },
                    {
                        "id": 47531,
                        "name": "Vaudelnay",
                        "latitude": "47.13813000",
                        "longitude": "-0.20677000"
                    },
                    {
                        "id": 47549,
                        "name": "Vay",
                        "latitude": "47.55466000",
                        "longitude": "-1.70095000"
                    },
                    {
                        "id": 47562,
                        "name": "Venansault",
                        "latitude": "46.68516000",
                        "longitude": "-1.51415000"
                    },
                    {
                        "id": 47576,
                        "name": "Vendrennes",
                        "latitude": "46.82523000",
                        "longitude": "-1.12357000"
                    },
                    {
                        "id": 47606,
                        "name": "Vern-d’Anjou",
                        "latitude": "47.60119000",
                        "longitude": "-0.83357000"
                    },
                    {
                        "id": 47609,
                        "name": "Vernantes",
                        "latitude": "47.39320000",
                        "longitude": "0.05304000"
                    },
                    {
                        "id": 47618,
                        "name": "Vernoil-le-Fourrier",
                        "latitude": "47.38333000",
                        "longitude": "0.08333000"
                    },
                    {
                        "id": 47642,
                        "name": "Vertou",
                        "latitude": "47.16869000",
                        "longitude": "-1.46929000"
                    },
                    {
                        "id": 47658,
                        "name": "Vezins",
                        "latitude": "47.12015000",
                        "longitude": "-0.70971000"
                    },
                    {
                        "id": 47662,
                        "name": "Vibraye",
                        "latitude": "48.05607000",
                        "longitude": "0.74171000"
                    },
                    {
                        "id": 47678,
                        "name": "Vieillevigne",
                        "latitude": "46.97214000",
                        "longitude": "-1.43405000"
                    },
                    {
                        "id": 47696,
                        "name": "Vigneux-de-Bretagne",
                        "latitude": "47.32547000",
                        "longitude": "-1.73678000"
                    },
                    {
                        "id": 47703,
                        "name": "Vihiers",
                        "latitude": "47.14631000",
                        "longitude": "-0.53238000"
                    },
                    {
                        "id": 47707,
                        "name": "Villaines-la-Juhel",
                        "latitude": "48.34416000",
                        "longitude": "-0.27734000"
                    },
                    {
                        "id": 47722,
                        "name": "Villebernier",
                        "latitude": "47.25374000",
                        "longitude": "-0.03229000"
                    },
                    {
                        "id": 47729,
                        "name": "Villedieu-la-Blouère",
                        "latitude": "47.14738000",
                        "longitude": "-1.06286000"
                    },
                    {
                        "id": 47823,
                        "name": "Villevêque",
                        "latitude": "47.56095000",
                        "longitude": "-0.42383000"
                    },
                    {
                        "id": 47855,
                        "name": "Vion",
                        "latitude": "47.81923000",
                        "longitude": "-0.23916000"
                    },
                    {
                        "id": 47887,
                        "name": "Vivy",
                        "latitude": "47.32648000",
                        "longitude": "-0.05531000"
                    },
                    {
                        "id": 47888,
                        "name": "Vix",
                        "latitude": "46.36456000",
                        "longitude": "-0.86072000"
                    },
                    {
                        "id": 47921,
                        "name": "Vue",
                        "latitude": "47.19953000",
                        "longitude": "-1.87750000"
                    },
                    {
                        "id": 48019,
                        "name": "Yvré-le-Pôlin",
                        "latitude": "47.82235000",
                        "longitude": "0.15581000"
                    },
                    {
                        "id": 48020,
                        "name": "Yzernay",
                        "latitude": "47.02229000",
                        "longitude": "-0.70295000"
                    }
                ]
            },
            {
                "id": 4812,
                "name": "Provence-Alpes-Côte-d’Azur",
                "iso2": "PAC",
                "latitude": "43.93516910",
                "longitude": "6.06791940",
                "type": "metropolitan region",
                "cities": [
                    {
                        "id": 39294,
                        "name": "Aix-en-Provence",
                        "latitude": "43.52830000",
                        "longitude": "5.44973000"
                    },
                    {
                        "id": 39322,
                        "name": "Allauch",
                        "latitude": "43.33573000",
                        "longitude": "5.48201000"
                    },
                    {
                        "id": 39323,
                        "name": "Alleins",
                        "latitude": "43.70387000",
                        "longitude": "5.16203000"
                    },
                    {
                        "id": 39335,
                        "name": "Alpes-de-Haute-Provence",
                        "latitude": "44.09829000",
                        "longitude": "6.26537000"
                    },
                    {
                        "id": 39334,
                        "name": "Alpes-Maritimes",
                        "latitude": "43.91307000",
                        "longitude": "7.20436000"
                    },
                    {
                        "id": 39337,
                        "name": "Althen-des-Paluds",
                        "latitude": "44.00405000",
                        "longitude": "4.95861000"
                    },
                    {
                        "id": 39424,
                        "name": "Annot",
                        "latitude": "43.96528000",
                        "longitude": "6.66879000"
                    },
                    {
                        "id": 39429,
                        "name": "Ansouis",
                        "latitude": "43.73771000",
                        "longitude": "5.46356000"
                    },
                    {
                        "id": 39432,
                        "name": "Antibes",
                        "latitude": "43.58579000",
                        "longitude": "7.10831000"
                    },
                    {
                        "id": 39446,
                        "name": "Apt",
                        "latitude": "43.87638000",
                        "longitude": "5.39635000"
                    },
                    {
                        "id": 39470,
                        "name": "Arenc",
                        "latitude": "43.31583000",
                        "longitude": "5.36698000"
                    },
                    {
                        "id": 39489,
                        "name": "Arles",
                        "latitude": "43.67681000",
                        "longitude": "4.63031000"
                    },
                    {
                        "id": 39550,
                        "name": "Aspremont",
                        "latitude": "43.78342000",
                        "longitude": "7.24406000"
                    },
                    {
                        "id": 39566,
                        "name": "Aubagne",
                        "latitude": "43.29276000",
                        "longitude": "5.57067000"
                    },
                    {
                        "id": 39578,
                        "name": "Aubignan",
                        "latitude": "44.09971000",
                        "longitude": "5.02526000"
                    },
                    {
                        "id": 39622,
                        "name": "Aups",
                        "latitude": "43.62841000",
                        "longitude": "6.22477000"
                    },
                    {
                        "id": 39626,
                        "name": "Aureille",
                        "latitude": "43.70821000",
                        "longitude": "4.94728000"
                    },
                    {
                        "id": 39628,
                        "name": "Auribeau-sur-Siagne",
                        "latitude": "43.60063000",
                        "longitude": "6.90992000"
                    },
                    {
                        "id": 39631,
                        "name": "Auriol",
                        "latitude": "43.37161000",
                        "longitude": "5.63410000"
                    },
                    {
                        "id": 39669,
                        "name": "Avignon",
                        "latitude": "43.94834000",
                        "longitude": "4.80892000"
                    },
                    {
                        "id": 39712,
                        "name": "Bagnols-en-Forêt",
                        "latitude": "43.53752000",
                        "longitude": "6.69814000"
                    },
                    {
                        "id": 39721,
                        "name": "Baille",
                        "latitude": "43.28770000",
                        "longitude": "5.39804000"
                    },
                    {
                        "id": 39759,
                        "name": "Bandol",
                        "latitude": "43.14247000",
                        "longitude": "5.74718000"
                    },
                    {
                        "id": 39772,
                        "name": "Barbentane",
                        "latitude": "43.89939000",
                        "longitude": "4.74756000"
                    },
                    {
                        "id": 39779,
                        "name": "Barcelonnette",
                        "latitude": "44.38691000",
                        "longitude": "6.65179000"
                    },
                    {
                        "id": 39783,
                        "name": "Bargemon",
                        "latitude": "43.61899000",
                        "longitude": "6.54957000"
                    },
                    {
                        "id": 39785,
                        "name": "Barjols",
                        "latitude": "43.55805000",
                        "longitude": "6.00752000"
                    },
                    {
                        "id": 39855,
                        "name": "Beaulieu-sur-Mer",
                        "latitude": "43.70692000",
                        "longitude": "7.33135000"
                    },
                    {
                        "id": 39857,
                        "name": "Beaumes-de-Venise",
                        "latitude": "44.12227000",
                        "longitude": "5.03065000"
                    },
                    {
                        "id": 39864,
                        "name": "Beaumont-de-Pertuis",
                        "latitude": "43.73737000",
                        "longitude": "5.68959000"
                    },
                    {
                        "id": 39886,
                        "name": "Beausoleil",
                        "latitude": "43.74311000",
                        "longitude": "7.42250000"
                    },
                    {
                        "id": 40413,
                        "name": "Bédarrides",
                        "latitude": "44.04022000",
                        "longitude": "4.89819000"
                    },
                    {
                        "id": 40414,
                        "name": "Bédoin",
                        "latitude": "44.12432000",
                        "longitude": "5.18040000"
                    },
                    {
                        "id": 39903,
                        "name": "Belcodène",
                        "latitude": "43.42612000",
                        "longitude": "5.58878000"
                    },
                    {
                        "id": 39905,
                        "name": "Belgentier",
                        "latitude": "43.24535000",
                        "longitude": "5.99933000"
                    },
                    {
                        "id": 39909,
                        "name": "Belle de Mai",
                        "latitude": "43.31184000",
                        "longitude": "5.38541000"
                    },
                    {
                        "id": 39935,
                        "name": "Belsunce",
                        "latitude": "43.29834000",
                        "longitude": "5.37660000"
                    },
                    {
                        "id": 39959,
                        "name": "Berre-l'Étang",
                        "latitude": "43.47809000",
                        "longitude": "5.17044000"
                    },
                    {
                        "id": 39960,
                        "name": "Berre-les-Alpes",
                        "latitude": "43.83052000",
                        "longitude": "7.32877000"
                    },
                    {
                        "id": 39977,
                        "name": "Besse-sur-Issole",
                        "latitude": "43.34892000",
                        "longitude": "6.17656000"
                    },
                    {
                        "id": 40029,
                        "name": "Biot",
                        "latitude": "43.62852000",
                        "longitude": "7.09530000"
                    },
                    {
                        "id": 40059,
                        "name": "Blausasc",
                        "latitude": "43.80572000",
                        "longitude": "7.36477000"
                    },
                    {
                        "id": 40105,
                        "name": "Bollène",
                        "latitude": "44.28124000",
                        "longitude": "4.74891000"
                    },
                    {
                        "id": 40109,
                        "name": "Bon-Secours",
                        "latitude": "43.31923000",
                        "longitude": "5.38426000"
                    },
                    {
                        "id": 40125,
                        "name": "Bonneveine",
                        "latitude": "43.25000000",
                        "longitude": "5.38333000"
                    },
                    {
                        "id": 40127,
                        "name": "Bonnieux",
                        "latitude": "43.82396000",
                        "longitude": "5.30759000"
                    },
                    {
                        "id": 40139,
                        "name": "Borel",
                        "latitude": "43.36486000",
                        "longitude": "5.36681000"
                    },
                    {
                        "id": 40141,
                        "name": "Bormes-les-Mimosas",
                        "latitude": "43.15169000",
                        "longitude": "6.34220000"
                    },
                    {
                        "id": 40149,
                        "name": "Bouc-Bel-Air",
                        "latitude": "43.45217000",
                        "longitude": "5.41300000"
                    },
                    {
                        "id": 40165,
                        "name": "Boulbon",
                        "latitude": "43.86232000",
                        "longitude": "4.69391000"
                    },
                    {
                        "id": 40258,
                        "name": "Bras",
                        "latitude": "43.47163000",
                        "longitude": "5.95486000"
                    },
                    {
                        "id": 40273,
                        "name": "Breil-sur-Roya",
                        "latitude": "43.93755000",
                        "longitude": "7.51472000"
                    },
                    {
                        "id": 40300,
                        "name": "Briançon",
                        "latitude": "44.89978000",
                        "longitude": "6.64201000"
                    },
                    {
                        "id": 40313,
                        "name": "Brignoles",
                        "latitude": "43.40580000",
                        "longitude": "6.06172000"
                    },
                    {
                        "id": 40441,
                        "name": "Cabannes",
                        "latitude": "43.86015000",
                        "longitude": "4.95192000"
                    },
                    {
                        "id": 40443,
                        "name": "Cabasse",
                        "latitude": "43.42646000",
                        "longitude": "6.21917000"
                    },
                    {
                        "id": 40448,
                        "name": "Cabriès",
                        "latitude": "43.44127000",
                        "longitude": "5.37884000"
                    },
                    {
                        "id": 40446,
                        "name": "Cabris",
                        "latitude": "43.65617000",
                        "longitude": "6.87358000"
                    },
                    {
                        "id": 40453,
                        "name": "Cadenet",
                        "latitude": "43.73500000",
                        "longitude": "5.37339000"
                    },
                    {
                        "id": 40454,
                        "name": "Caderousse",
                        "latitude": "44.10327000",
                        "longitude": "4.75672000"
                    },
                    {
                        "id": 40456,
                        "name": "Cadolive",
                        "latitude": "43.39694000",
                        "longitude": "5.54526000"
                    },
                    {
                        "id": 40459,
                        "name": "Cagnes-sur-Mer",
                        "latitude": "43.66352000",
                        "longitude": "7.14790000"
                    },
                    {
                        "id": 40472,
                        "name": "Callas",
                        "latitude": "43.59284000",
                        "longitude": "6.53840000"
                    },
                    {
                        "id": 40473,
                        "name": "Callian",
                        "latitude": "43.62210000",
                        "longitude": "6.75269000"
                    },
                    {
                        "id": 40481,
                        "name": "Camaret-sur-Aigues",
                        "latitude": "44.16375000",
                        "longitude": "4.87310000"
                    },
                    {
                        "id": 40501,
                        "name": "Camps-la-Source",
                        "latitude": "43.38626000",
                        "longitude": "6.09607000"
                    },
                    {
                        "id": 40512,
                        "name": "Cannes",
                        "latitude": "43.55135000",
                        "longitude": "7.01275000"
                    },
                    {
                        "id": 40517,
                        "name": "Cantaron",
                        "latitude": "43.76203000",
                        "longitude": "7.31756000"
                    },
                    {
                        "id": 40524,
                        "name": "Cap-d’Ail",
                        "latitude": "43.72126000",
                        "longitude": "7.40556000"
                    },
                    {
                        "id": 40540,
                        "name": "Carcès",
                        "latitude": "43.47585000",
                        "longitude": "6.18257000"
                    },
                    {
                        "id": 40551,
                        "name": "Carnoules",
                        "latitude": "43.30187000",
                        "longitude": "6.18733000"
                    },
                    {
                        "id": 40552,
                        "name": "Carnoux-en-Provence",
                        "latitude": "43.25639000",
                        "longitude": "5.56444000"
                    },
                    {
                        "id": 40554,
                        "name": "Caromb",
                        "latitude": "44.11106000",
                        "longitude": "5.10738000"
                    },
                    {
                        "id": 40555,
                        "name": "Carpentras",
                        "latitude": "44.05507000",
                        "longitude": "5.04813000"
                    },
                    {
                        "id": 40558,
                        "name": "Carqueiranne",
                        "latitude": "43.09495000",
                        "longitude": "6.07349000"
                    },
                    {
                        "id": 40561,
                        "name": "Carros",
                        "latitude": "43.79246000",
                        "longitude": "7.18745000"
                    },
                    {
                        "id": 40562,
                        "name": "Carry-le-Rouet",
                        "latitude": "43.33139000",
                        "longitude": "5.15237000"
                    },
                    {
                        "id": 40571,
                        "name": "Cassis",
                        "latitude": "43.21571000",
                        "longitude": "5.53855000"
                    },
                    {
                        "id": 40574,
                        "name": "Castagniers",
                        "latitude": "43.79134000",
                        "longitude": "7.23162000"
                    },
                    {
                        "id": 40579,
                        "name": "Castellane",
                        "latitude": "43.84707000",
                        "longitude": "6.51283000"
                    },
                    {
                        "id": 40609,
                        "name": "Caumont-sur-Durance",
                        "latitude": "43.89356000",
                        "longitude": "4.94745000"
                    },
                    {
                        "id": 40617,
                        "name": "Cavaillon",
                        "latitude": "43.83125000",
                        "longitude": "5.03586000"
                    },
                    {
                        "id": 40618,
                        "name": "Cavalaire-sur-Mer",
                        "latitude": "43.17261000",
                        "longitude": "6.52959000"
                    },
                    {
                        "id": 41396,
                        "name": "Céreste",
                        "latitude": "43.85580000",
                        "longitude": "5.58685000"
                    },
                    {
                        "id": 40666,
                        "name": "Ceyreste",
                        "latitude": "43.21352000",
                        "longitude": "5.62946000"
                    },
                    {
                        "id": 40800,
                        "name": "Charleval",
                        "latitude": "43.71864000",
                        "longitude": "5.24546000"
                    },
                    {
                        "id": 40961,
                        "name": "Châteauneuf-de-Gadagne",
                        "latitude": "43.92683000",
                        "longitude": "4.94453000"
                    },
                    {
                        "id": 40964,
                        "name": "Châteauneuf-du-Pape",
                        "latitude": "44.05638000",
                        "longitude": "4.83244000"
                    },
                    {
                        "id": 40960,
                        "name": "Châteauneuf-Grasse",
                        "latitude": "43.66667000",
                        "longitude": "6.98333000"
                    },
                    {
                        "id": 40969,
                        "name": "Châteauneuf-le-Rouge",
                        "latitude": "43.48936000",
                        "longitude": "5.56921000"
                    },
                    {
                        "id": 40970,
                        "name": "Châteauneuf-les-Martigues",
                        "latitude": "43.38383000",
                        "longitude": "5.16403000"
                    },
                    {
                        "id": 40977,
                        "name": "Châteaurenard",
                        "latitude": "43.88169000",
                        "longitude": "4.85493000"
                    },
                    {
                        "id": 40892,
                        "name": "Cheval-Blanc",
                        "latitude": "43.80189000",
                        "longitude": "5.06229000"
                    },
                    {
                        "id": 40926,
                        "name": "Chorges",
                        "latitude": "44.54879000",
                        "longitude": "6.27727000"
                    },
                    {
                        "id": 40929,
                        "name": "Chutes-Lavie",
                        "latitude": "43.31017000",
                        "longitude": "5.39464000"
                    },
                    {
                        "id": 41020,
                        "name": "Cinq Avenues",
                        "latitude": "43.30375000",
                        "longitude": "5.39761000"
                    },
                    {
                        "id": 41083,
                        "name": "Cogolin",
                        "latitude": "43.25294000",
                        "longitude": "6.52981000"
                    },
                    {
                        "id": 41092,
                        "name": "Collobrières",
                        "latitude": "43.23718000",
                        "longitude": "6.30901000"
                    },
                    {
                        "id": 41097,
                        "name": "Colomars",
                        "latitude": "43.76320000",
                        "longitude": "7.22191000"
                    },
                    {
                        "id": 41155,
                        "name": "Contes",
                        "latitude": "43.81278000",
                        "longitude": "7.31444000"
                    },
                    {
                        "id": 41194,
                        "name": "Cornillon-Confoux",
                        "latitude": "43.56267000",
                        "longitude": "5.07162000"
                    },
                    {
                        "id": 41211,
                        "name": "Cotignac",
                        "latitude": "43.52876000",
                        "longitude": "6.14955000"
                    },
                    {
                        "id": 41221,
                        "name": "Coudoux",
                        "latitude": "43.55800000",
                        "longitude": "5.24889000"
                    },
                    {
                        "id": 41269,
                        "name": "Courthézon",
                        "latitude": "44.08760000",
                        "longitude": "4.88407000"
                    },
                    {
                        "id": 41358,
                        "name": "Cucuron",
                        "latitude": "43.77298000",
                        "longitude": "5.43858000"
                    },
                    {
                        "id": 41359,
                        "name": "Cuers",
                        "latitude": "43.23754000",
                        "longitude": "6.07178000"
                    },
                    {
                        "id": 41363,
                        "name": "Cuges-les-Pins",
                        "latitude": "43.27607000",
                        "longitude": "5.69955000"
                    },
                    {
                        "id": 41634,
                        "name": "Département des Bouches-du-Rhône",
                        "latitude": "43.52366000",
                        "longitude": "5.42450000"
                    },
                    {
                        "id": 41647,
                        "name": "Département du Vaucluse",
                        "latitude": "44.00000000",
                        "longitude": "5.16667000"
                    },
                    {
                        "id": 41478,
                        "name": "Digne-les-Bains",
                        "latitude": "44.09252000",
                        "longitude": "6.23199000"
                    },
                    {
                        "id": 41566,
                        "name": "Draguignan",
                        "latitude": "43.53692000",
                        "longitude": "6.46458000"
                    },
                    {
                        "id": 41569,
                        "name": "Drap",
                        "latitude": "43.75508000",
                        "longitude": "7.32152000"
                    },
                    {
                        "id": 48061,
                        "name": "Éguilles",
                        "latitude": "43.56867000",
                        "longitude": "5.35575000"
                    },
                    {
                        "id": 41666,
                        "name": "Embrun",
                        "latitude": "44.56387000",
                        "longitude": "6.49526000"
                    },
                    {
                        "id": 41677,
                        "name": "Ensuès-la-Redonne",
                        "latitude": "43.35464000",
                        "longitude": "5.20357000"
                    },
                    {
                        "id": 41678,
                        "name": "Entraigues-sur-la-Sorgue",
                        "latitude": "44.00320000",
                        "longitude": "4.92657000"
                    },
                    {
                        "id": 48068,
                        "name": "Éoures",
                        "latitude": "43.30045000",
                        "longitude": "5.52193000"
                    },
                    {
                        "id": 48117,
                        "name": "Évenos",
                        "latitude": "43.16365000",
                        "longitude": "5.84628000"
                    },
                    {
                        "id": 41752,
                        "name": "Eygalières",
                        "latitude": "43.76099000",
                        "longitude": "4.94968000"
                    },
                    {
                        "id": 41753,
                        "name": "Eyguières",
                        "latitude": "43.69481000",
                        "longitude": "5.03131000"
                    },
                    {
                        "id": 41756,
                        "name": "Eyragues",
                        "latitude": "43.84103000",
                        "longitude": "4.84231000"
                    },
                    {
                        "id": 48035,
                        "name": "Èze",
                        "latitude": "43.72799000",
                        "longitude": "7.36194000"
                    },
                    {
                        "id": 41767,
                        "name": "Falicon",
                        "latitude": "43.74861000",
                        "longitude": "7.27856000"
                    },
                    {
                        "id": 41789,
                        "name": "Fayence",
                        "latitude": "43.62570000",
                        "longitude": "6.69531000"
                    },
                    {
                        "id": 41817,
                        "name": "Figanières",
                        "latitude": "43.56882000",
                        "longitude": "6.49722000"
                    },
                    {
                        "id": 41829,
                        "name": "Flassans-sur-Issole",
                        "latitude": "43.36856000",
                        "longitude": "6.22154000"
                    },
                    {
                        "id": 41835,
                        "name": "Flayosc",
                        "latitude": "43.53396000",
                        "longitude": "6.39660000"
                    },
                    {
                        "id": 41907,
                        "name": "Fontvieille",
                        "latitude": "43.72806000",
                        "longitude": "4.70953000"
                    },
                    {
                        "id": 41909,
                        "name": "Forcalqueiret",
                        "latitude": "43.33618000",
                        "longitude": "6.08346000"
                    },
                    {
                        "id": 41910,
                        "name": "Forcalquier",
                        "latitude": "43.95927000",
                        "longitude": "5.77945000"
                    },
                    {
                        "id": 41919,
                        "name": "Fos-sur-Mer",
                        "latitude": "43.43774000",
                        "longitude": "4.94457000"
                    },
                    {
                        "id": 41985,
                        "name": "Fréjus",
                        "latitude": "43.43325000",
                        "longitude": "6.73555000"
                    },
                    {
                        "id": 41996,
                        "name": "Fuveau",
                        "latitude": "43.45578000",
                        "longitude": "5.56149000"
                    },
                    {
                        "id": 42031,
                        "name": "Gap",
                        "latitude": "44.55858000",
                        "longitude": "6.07868000"
                    },
                    {
                        "id": 42037,
                        "name": "Gardanne",
                        "latitude": "43.45491000",
                        "longitude": "5.46913000"
                    },
                    {
                        "id": 42048,
                        "name": "Garéoult",
                        "latitude": "43.32833000",
                        "longitude": "6.04616000"
                    },
                    {
                        "id": 42041,
                        "name": "Gargas",
                        "latitude": "43.90196000",
                        "longitude": "5.35814000"
                    },
                    {
                        "id": 42050,
                        "name": "Gassin",
                        "latitude": "43.22882000",
                        "longitude": "6.58549000"
                    },
                    {
                        "id": 42052,
                        "name": "Gattières",
                        "latitude": "43.75951000",
                        "longitude": "7.17574000"
                    },
                    {
                        "id": 42293,
                        "name": "Gémenos",
                        "latitude": "43.29751000",
                        "longitude": "5.62843000"
                    },
                    {
                        "id": 42092,
                        "name": "Gignac-la-Nerthe",
                        "latitude": "43.39287000",
                        "longitude": "5.23586000"
                    },
                    {
                        "id": 42093,
                        "name": "Gilette",
                        "latitude": "43.84976000",
                        "longitude": "7.16346000"
                    },
                    {
                        "id": 42098,
                        "name": "Ginasservis",
                        "latitude": "43.67088000",
                        "longitude": "5.84911000"
                    },
                    {
                        "id": 42130,
                        "name": "Gonfaron",
                        "latitude": "43.32036000",
                        "longitude": "6.28929000"
                    },
                    {
                        "id": 42134,
                        "name": "Gorbio",
                        "latitude": "43.78678000",
                        "longitude": "7.44375000"
                    },
                    {
                        "id": 42136,
                        "name": "Gordes",
                        "latitude": "43.91290000",
                        "longitude": "5.19892000"
                    },
                    {
                        "id": 42148,
                        "name": "Goult",
                        "latitude": "43.86297000",
                        "longitude": "5.24390000"
                    },
                    {
                        "id": 42169,
                        "name": "Grambois",
                        "latitude": "43.76233000",
                        "longitude": "5.58860000"
                    },
                    {
                        "id": 42184,
                        "name": "Grans",
                        "latitude": "43.60862000",
                        "longitude": "5.06290000"
                    },
                    {
                        "id": 42186,
                        "name": "Grasse",
                        "latitude": "43.65783000",
                        "longitude": "6.92537000"
                    },
                    {
                        "id": 42190,
                        "name": "Graveson",
                        "latitude": "43.85051000",
                        "longitude": "4.77361000"
                    },
                    {
                        "id": 42233,
                        "name": "Gréasque",
                        "latitude": "43.43310000",
                        "longitude": "5.54449000"
                    },
                    {
                        "id": 42234,
                        "name": "Gréoux-les-Bains",
                        "latitude": "43.75844000",
                        "longitude": "5.88351000"
                    },
                    {
                        "id": 42213,
                        "name": "Grillon",
                        "latitude": "44.39508000",
                        "longitude": "4.92954000"
                    },
                    {
                        "id": 42214,
                        "name": "Grimaud",
                        "latitude": "43.27329000",
                        "longitude": "6.52171000"
                    },
                    {
                        "id": 42261,
                        "name": "Guillestre",
                        "latitude": "44.65950000",
                        "longitude": "6.64948000"
                    },
                    {
                        "id": 42351,
                        "name": "Hautes-Alpes",
                        "latitude": "44.68055000",
                        "longitude": "6.28969000"
                    },
                    {
                        "id": 42448,
                        "name": "Hyères",
                        "latitude": "43.12038000",
                        "longitude": "6.12857000"
                    },
                    {
                        "id": 42510,
                        "name": "Istres",
                        "latitude": "43.51345000",
                        "longitude": "4.98747000"
                    },
                    {
                        "id": 42542,
                        "name": "Jausiers",
                        "latitude": "44.41705000",
                        "longitude": "6.72947000"
                    },
                    {
                        "id": 42558,
                        "name": "Jonquerettes",
                        "latitude": "43.94655000",
                        "longitude": "4.93286000"
                    },
                    {
                        "id": 42559,
                        "name": "Jonquières",
                        "latitude": "44.11603000",
                        "longitude": "4.89989000"
                    },
                    {
                        "id": 42570,
                        "name": "Jouques",
                        "latitude": "43.63710000",
                        "longitude": "5.63672000"
                    },
                    {
                        "id": 42625,
                        "name": "L'Estaque",
                        "latitude": "43.36385000",
                        "longitude": "5.30854000"
                    },
                    {
                        "id": 43701,
                        "name": "L’Escale",
                        "latitude": "44.08162000",
                        "longitude": "6.02379000"
                    },
                    {
                        "id": 43702,
                        "name": "L’Escarène",
                        "latitude": "43.83492000",
                        "longitude": "7.35542000"
                    },
                    {
                        "id": 43707,
                        "name": "L’Isle-sur-la-Sorgue",
                        "latitude": "43.91971000",
                        "longitude": "5.05141000"
                    },
                    {
                        "id": 42632,
                        "name": "La Barasse",
                        "latitude": "43.28433000",
                        "longitude": "5.48664000"
                    },
                    {
                        "id": 42636,
                        "name": "La Bastide-des-Jourdans",
                        "latitude": "43.78531000",
                        "longitude": "5.63446000"
                    },
                    {
                        "id": 42660,
                        "name": "La Bâtie-Neuve",
                        "latitude": "44.56680000",
                        "longitude": "6.19587000"
                    },
                    {
                        "id": 42643,
                        "name": "La Blancarde",
                        "latitude": "43.30047000",
                        "longitude": "5.40563000"
                    },
                    {
                        "id": 42649,
                        "name": "La Bouilladisse",
                        "latitude": "43.39619000",
                        "longitude": "5.59307000"
                    },
                    {
                        "id": 42662,
                        "name": "La Cabucelle",
                        "latitude": "43.33189000",
                        "longitude": "5.36111000"
                    },
                    {
                        "id": 42663,
                        "name": "La Calade",
                        "latitude": "43.33895000",
                        "longitude": "5.35111000"
                    },
                    {
                        "id": 42666,
                        "name": "La Capelette",
                        "latitude": "43.28086000",
                        "longitude": "5.40600000"
                    },
                    {
                        "id": 42670,
                        "name": "La Celle",
                        "latitude": "43.39523000",
                        "longitude": "6.03750000"
                    },
                    {
                        "id": 42708,
                        "name": "La Ciotat",
                        "latitude": "43.17476000",
                        "longitude": "5.60449000"
                    },
                    {
                        "id": 42712,
                        "name": "La Colle-sur-Loup",
                        "latitude": "43.68648000",
                        "longitude": "7.10376000"
                    },
                    {
                        "id": 42713,
                        "name": "La Conception",
                        "latitude": "43.29174000",
                        "longitude": "5.39391000"
                    },
                    {
                        "id": 42721,
                        "name": "La Crau",
                        "latitude": "43.14962000",
                        "longitude": "6.07399000"
                    },
                    {
                        "id": 42722,
                        "name": "La Croix-Rouge",
                        "latitude": "43.33329000",
                        "longitude": "5.45403000"
                    },
                    {
                        "id": 42723,
                        "name": "La Croix-Valmer",
                        "latitude": "43.20755000",
                        "longitude": "6.56796000"
                    },
                    {
                        "id": 42729,
                        "name": "La Delorme",
                        "latitude": "43.34405000",
                        "longitude": "5.37251000"
                    },
                    {
                        "id": 42730,
                        "name": "La Destrousse",
                        "latitude": "43.37505000",
                        "longitude": "5.60560000"
                    },
                    {
                        "id": 42732,
                        "name": "La Fare-les-Oliviers",
                        "latitude": "43.55104000",
                        "longitude": "5.19430000"
                    },
                    {
                        "id": 42733,
                        "name": "La Farlède",
                        "latitude": "43.16866000",
                        "longitude": "6.04323000"
                    },
                    {
                        "id": 42755,
                        "name": "La Fourragère",
                        "latitude": "43.30382000",
                        "longitude": "5.43138000"
                    },
                    {
                        "id": 42761,
                        "name": "La Garde",
                        "latitude": "43.12468000",
                        "longitude": "6.01033000"
                    },
                    {
                        "id": 42763,
                        "name": "La Garde-Freinet",
                        "latitude": "43.31710000",
                        "longitude": "6.46946000"
                    },
                    {
                        "id": 42767,
                        "name": "La Gaude",
                        "latitude": "43.72209000",
                        "longitude": "7.15296000"
                    },
                    {
                        "id": 42786,
                        "name": "La Joliette",
                        "latitude": "43.30485000",
                        "longitude": "5.36654000"
                    },
                    {
                        "id": 42792,
                        "name": "La Londe-les-Maures",
                        "latitude": "43.13839000",
                        "longitude": "6.23362000"
                    },
                    {
                        "id": 42807,
                        "name": "La Millère",
                        "latitude": "43.28128000",
                        "longitude": "5.49804000"
                    },
                    {
                        "id": 42813,
                        "name": "La Motte",
                        "latitude": "43.49403000",
                        "longitude": "6.53519000"
                    },
                    {
                        "id": 42826,
                        "name": "La Page",
                        "latitude": "43.26627000",
                        "longitude": "5.37377000"
                    },
                    {
                        "id": 42828,
                        "name": "La Panouse",
                        "latitude": "43.25576000",
                        "longitude": "5.42963000"
                    },
                    {
                        "id": 42829,
                        "name": "La Penne-sur-Huveaune",
                        "latitude": "43.28208000",
                        "longitude": "5.51642000"
                    },
                    {
                        "id": 42833,
                        "name": "La Pointe Rouge",
                        "latitude": "43.23853000",
                        "longitude": "5.37679000"
                    },
                    {
                        "id": 42834,
                        "name": "La Pomme",
                        "latitude": "43.28987000",
                        "longitude": "5.44153000"
                    },
                    {
                        "id": 42857,
                        "name": "La Roche-des-Arnauds",
                        "latitude": "44.56188000",
                        "longitude": "5.95541000"
                    },
                    {
                        "id": 42865,
                        "name": "La Roque-d’Anthéron",
                        "latitude": "43.71544000",
                        "longitude": "5.30973000"
                    },
                    {
                        "id": 42866,
                        "name": "La Roquebrussanne",
                        "latitude": "43.34030000",
                        "longitude": "5.97603000"
                    },
                    {
                        "id": 42867,
                        "name": "La Roquette-sur-Siagne",
                        "latitude": "43.59873000",
                        "longitude": "6.95671000"
                    },
                    {
                        "id": 42868,
                        "name": "La Rose",
                        "latitude": "43.32889000",
                        "longitude": "5.42859000"
                    },
                    {
                        "id": 42878,
                        "name": "La Seyne-sur-Mer",
                        "latitude": "43.10322000",
                        "longitude": "5.87816000"
                    },
                    {
                        "id": 42888,
                        "name": "La Timone",
                        "latitude": "43.28847000",
                        "longitude": "5.41447000"
                    },
                    {
                        "id": 42898,
                        "name": "La Trinité",
                        "latitude": "43.74050000",
                        "longitude": "7.31400000"
                    },
                    {
                        "id": 42902,
                        "name": "La Turbie",
                        "latitude": "43.74540000",
                        "longitude": "7.40046000"
                    },
                    {
                        "id": 42903,
                        "name": "La Valbarelle",
                        "latitude": "43.28494000",
                        "longitude": "5.45387000"
                    },
                    {
                        "id": 42904,
                        "name": "La Valentine",
                        "latitude": "43.29757000",
                        "longitude": "5.48432000"
                    },
                    {
                        "id": 42905,
                        "name": "La Valette-du-Var",
                        "latitude": "43.13763000",
                        "longitude": "5.98317000"
                    },
                    {
                        "id": 42916,
                        "name": "La Villette",
                        "latitude": "43.31181000",
                        "longitude": "5.37391000"
                    },
                    {
                        "id": 42917,
                        "name": "La Viste",
                        "latitude": "43.35936000",
                        "longitude": "5.35649000"
                    },
                    {
                        "id": 42956,
                        "name": "Lagnes",
                        "latitude": "43.89348000",
                        "longitude": "5.11454000"
                    },
                    {
                        "id": 42980,
                        "name": "Lamanon",
                        "latitude": "43.69979000",
                        "longitude": "5.08871000"
                    },
                    {
                        "id": 42987,
                        "name": "Lambesc",
                        "latitude": "43.65382000",
                        "longitude": "5.26211000"
                    },
                    {
                        "id": 43056,
                        "name": "Lançon-Provence",
                        "latitude": "43.59266000",
                        "longitude": "5.12789000"
                    },
                    {
                        "id": 43050,
                        "name": "Lantosque",
                        "latitude": "43.97446000",
                        "longitude": "7.31174000"
                    },
                    {
                        "id": 43059,
                        "name": "Lapalud",
                        "latitude": "44.30780000",
                        "longitude": "4.68946000"
                    },
                    {
                        "id": 43065,
                        "name": "Laragne-Montéglin",
                        "latitude": "44.31667000",
                        "longitude": "5.81667000"
                    },
                    {
                        "id": 43099,
                        "name": "Lauris",
                        "latitude": "43.74716000",
                        "longitude": "5.31346000"
                    },
                    {
                        "id": 43125,
                        "name": "Le Bar-sur-Loup",
                        "latitude": "43.70000000",
                        "longitude": "6.98333000"
                    },
                    {
                        "id": 43128,
                        "name": "Le Beausset",
                        "latitude": "43.19822000",
                        "longitude": "5.80267000"
                    },
                    {
                        "id": 43146,
                        "name": "Le Broc",
                        "latitude": "43.80878000",
                        "longitude": "7.16882000"
                    },
                    {
                        "id": 43147,
                        "name": "Le Brusquet",
                        "latitude": "44.16126000",
                        "longitude": "6.30925000"
                    },
                    {
                        "id": 43150,
                        "name": "Le Cabot",
                        "latitude": "43.25884000",
                        "longitude": "5.41729000"
                    },
                    {
                        "id": 43152,
                        "name": "Le Camas",
                        "latitude": "43.29469000",
                        "longitude": "5.39415000"
                    },
                    {
                        "id": 43153,
                        "name": "Le Canet",
                        "latitude": "43.32611000",
                        "longitude": "5.37230000"
                    },
                    {
                        "id": 43154,
                        "name": "Le Cannet",
                        "latitude": "43.57662000",
                        "longitude": "7.01912000"
                    },
                    {
                        "id": 43155,
                        "name": "Le Cannet-des-Maures",
                        "latitude": "43.39236000",
                        "longitude": "6.33966000"
                    },
                    {
                        "id": 43157,
                        "name": "Le Castellet",
                        "latitude": "43.20291000",
                        "longitude": "5.77657000"
                    },
                    {
                        "id": 43164,
                        "name": "Le Chapitre",
                        "latitude": "43.30053000",
                        "longitude": "5.38433000"
                    },
                    {
                        "id": 43212,
                        "name": "Le Lavandou",
                        "latitude": "43.13700000",
                        "longitude": "6.36600000"
                    },
                    {
                        "id": 43217,
                        "name": "Le Luc",
                        "latitude": "43.39453000",
                        "longitude": "6.31253000"
                    },
                    {
                        "id": 43225,
                        "name": "Le Merlan",
                        "latitude": "43.33875000",
                        "longitude": "5.40773000"
                    },
                    {
                        "id": 43237,
                        "name": "Le Monêtier-les-Bains",
                        "latitude": "44.97604000",
                        "longitude": "6.50898000"
                    },
                    {
                        "id": 43238,
                        "name": "Le Muy",
                        "latitude": "43.47280000",
                        "longitude": "6.56637000"
                    },
                    {
                        "id": 43255,
                        "name": "Le Pharo",
                        "latitude": "43.29140000",
                        "longitude": "5.35829000"
                    },
                    {
                        "id": 43262,
                        "name": "Le Plan-de-la-Tour",
                        "latitude": "43.33333000",
                        "longitude": "6.55000000"
                    },
                    {
                        "id": 43275,
                        "name": "Le Pontet",
                        "latitude": "43.96119000",
                        "longitude": "4.86008000"
                    },
                    {
                        "id": 43283,
                        "name": "Le Pradet",
                        "latitude": "43.10545000",
                        "longitude": "6.02350000"
                    },
                    {
                        "id": 43286,
                        "name": "Le Puy-Sainte-Réparade",
                        "latitude": "43.66393000",
                        "longitude": "5.43493000"
                    },
                    {
                        "id": 43292,
                        "name": "Le Redon",
                        "latitude": "43.24604000",
                        "longitude": "5.42889000"
                    },
                    {
                        "id": 43294,
                        "name": "Le Revest-les-Eaux",
                        "latitude": "43.17612000",
                        "longitude": "5.92667000"
                    },
                    {
                        "id": 43296,
                        "name": "Le Rouret",
                        "latitude": "43.67873000",
                        "longitude": "7.01521000"
                    },
                    {
                        "id": 43297,
                        "name": "Le Rove",
                        "latitude": "43.36987000",
                        "longitude": "5.25112000"
                    },
                    {
                        "id": 43314,
                        "name": "Le Tholonet",
                        "latitude": "43.52176000",
                        "longitude": "5.51115000"
                    },
                    {
                        "id": 43316,
                        "name": "Le Thor",
                        "latitude": "43.92943000",
                        "longitude": "4.99543000"
                    },
                    {
                        "id": 43317,
                        "name": "Le Thoronet",
                        "latitude": "43.45174000",
                        "longitude": "6.30391000"
                    },
                    {
                        "id": 43320,
                        "name": "Le Tignet",
                        "latitude": "43.63979000",
                        "longitude": "6.84625000"
                    },
                    {
                        "id": 43326,
                        "name": "Le Val",
                        "latitude": "43.43928000",
                        "longitude": "6.07335000"
                    },
                    {
                        "id": 43356,
                        "name": "Les Accates",
                        "latitude": "43.29989000",
                        "longitude": "5.49726000"
                    },
                    {
                        "id": 43364,
                        "name": "Les Arcs",
                        "latitude": "43.46328000",
                        "longitude": "6.47876000"
                    },
                    {
                        "id": 43365,
                        "name": "Les Arnavaux",
                        "latitude": "43.33506000",
                        "longitude": "5.37969000"
                    },
                    {
                        "id": 43370,
                        "name": "Les Aygalades",
                        "latitude": "43.35711000",
                        "longitude": "5.37116000"
                    },
                    {
                        "id": 43371,
                        "name": "Les Baumettes",
                        "latitude": "43.22641000",
                        "longitude": "5.41642000"
                    },
                    {
                        "id": 43373,
                        "name": "Les Caillols",
                        "latitude": "43.30221000",
                        "longitude": "5.44811000"
                    },
                    {
                        "id": 43374,
                        "name": "Les Camoins",
                        "latitude": "43.30607000",
                        "longitude": "5.51745000"
                    },
                    {
                        "id": 43376,
                        "name": "Les Chartreux",
                        "latitude": "43.31112000",
                        "longitude": "5.40480000"
                    },
                    {
                        "id": 43381,
                        "name": "Les Crottes",
                        "latitude": "43.32302000",
                        "longitude": "5.36809000"
                    },
                    {
                        "id": 43393,
                        "name": "Les Grands Carmes",
                        "latitude": "43.30038000",
                        "longitude": "5.37275000"
                    },
                    {
                        "id": 43413,
                        "name": "Les Médecins",
                        "latitude": "43.35417000",
                        "longitude": "5.45483000"
                    },
                    {
                        "id": 43414,
                        "name": "Les Mées",
                        "latitude": "44.02961000",
                        "longitude": "5.97635000"
                    },
                    {
                        "id": 43416,
                        "name": "Les Olives",
                        "latitude": "43.32393000",
                        "longitude": "5.45840000"
                    },
                    {
                        "id": 43420,
                        "name": "Les Pennes-Mirabeau",
                        "latitude": "43.41012000",
                        "longitude": "5.30838000"
                    },
                    {
                        "id": 43431,
                        "name": "Les Trois-Lucs",
                        "latitude": "43.31371000",
                        "longitude": "5.46248000"
                    },
                    {
                        "id": 43450,
                        "name": "Levens",
                        "latitude": "43.85948000",
                        "longitude": "7.22583000"
                    },
                    {
                        "id": 43536,
                        "name": "Lodi",
                        "latitude": "43.28663000",
                        "longitude": "5.38882000"
                    },
                    {
                        "id": 43586,
                        "name": "Lorgues",
                        "latitude": "43.49325000",
                        "longitude": "6.36150000"
                    },
                    {
                        "id": 43588,
                        "name": "Loriol-du-Comtat",
                        "latitude": "44.07653000",
                        "longitude": "5.00065000"
                    },
                    {
                        "id": 43609,
                        "name": "Lourmarin",
                        "latitude": "43.76385000",
                        "longitude": "5.36264000"
                    },
                    {
                        "id": 43639,
                        "name": "Lucéram",
                        "latitude": "43.88293000",
                        "longitude": "7.35988000"
                    },
                    {
                        "id": 43733,
                        "name": "Maillane",
                        "latitude": "43.83289000",
                        "longitude": "4.78209000"
                    },
                    {
                        "id": 43751,
                        "name": "Malaucène",
                        "latitude": "44.17393000",
                        "longitude": "5.13213000"
                    },
                    {
                        "id": 43754,
                        "name": "Malemort-du-Comtat",
                        "latitude": "44.02096000",
                        "longitude": "5.15961000"
                    },
                    {
                        "id": 43760,
                        "name": "Malijai",
                        "latitude": "44.04600000",
                        "longitude": "6.03041000"
                    },
                    {
                        "id": 43763,
                        "name": "Mallemoisson",
                        "latitude": "44.04687000",
                        "longitude": "6.12557000"
                    },
                    {
                        "id": 43764,
                        "name": "Mallemort",
                        "latitude": "43.73172000",
                        "longitude": "5.17945000"
                    },
                    {
                        "id": 43765,
                        "name": "Malpassé",
                        "latitude": "43.32170000",
                        "longitude": "5.41551000"
                    },
                    {
                        "id": 43773,
                        "name": "Mandelieu-la-Napoule",
                        "latitude": "43.54577000",
                        "longitude": "6.93734000"
                    },
                    {
                        "id": 43777,
                        "name": "Mane",
                        "latitude": "43.93795000",
                        "longitude": "5.76718000"
                    },
                    {
                        "id": 43780,
                        "name": "Manosque",
                        "latitude": "43.82883000",
                        "longitude": "5.78688000"
                    },
                    {
                        "id": 43838,
                        "name": "Marignane",
                        "latitude": "43.41727000",
                        "longitude": "5.21462000"
                    },
                    {
                        "id": 43883,
                        "name": "Marseille",
                        "latitude": "43.29695000",
                        "longitude": "5.38107000"
                    },
                    {
                        "id": 43884,
                        "name": "Marseille 01",
                        "latitude": "43.29814000",
                        "longitude": "5.38407000"
                    },
                    {
                        "id": 43885,
                        "name": "Marseille 02",
                        "latitude": "43.29664000",
                        "longitude": "5.37034000"
                    },
                    {
                        "id": 43886,
                        "name": "Marseille 03",
                        "latitude": "43.30257000",
                        "longitude": "5.37583000"
                    },
                    {
                        "id": 43887,
                        "name": "Marseille 04",
                        "latitude": "43.30213000",
                        "longitude": "5.40141000"
                    },
                    {
                        "id": 43888,
                        "name": "Marseille 05",
                        "latitude": "43.29551000",
                        "longitude": "5.40055000"
                    },
                    {
                        "id": 43889,
                        "name": "Marseille 06",
                        "latitude": "43.28764000",
                        "longitude": "5.37918000"
                    },
                    {
                        "id": 43890,
                        "name": "Marseille 07",
                        "latitude": "43.28289000",
                        "longitude": "5.36021000"
                    },
                    {
                        "id": 43891,
                        "name": "Marseille 08",
                        "latitude": "43.27083000",
                        "longitude": "5.38210000"
                    },
                    {
                        "id": 43892,
                        "name": "Marseille 09",
                        "latitude": "43.25433000",
                        "longitude": "5.40570000"
                    },
                    {
                        "id": 43893,
                        "name": "Marseille 10",
                        "latitude": "43.27889000",
                        "longitude": "5.41523000"
                    },
                    {
                        "id": 43894,
                        "name": "Marseille 11",
                        "latitude": "43.29070000",
                        "longitude": "5.43840000"
                    },
                    {
                        "id": 43895,
                        "name": "Marseille 12",
                        "latitude": "43.29614000",
                        "longitude": "5.43617000"
                    },
                    {
                        "id": 43896,
                        "name": "Marseille 13",
                        "latitude": "43.31856000",
                        "longitude": "5.40836000"
                    },
                    {
                        "id": 43897,
                        "name": "Marseille 14",
                        "latitude": "43.34447000",
                        "longitude": "5.38004000"
                    },
                    {
                        "id": 43898,
                        "name": "Marseille 15",
                        "latitude": "43.37224000",
                        "longitude": "5.35386000"
                    },
                    {
                        "id": 43899,
                        "name": "Marseille 16",
                        "latitude": "43.35982000",
                        "longitude": "5.33421000"
                    },
                    {
                        "id": 43900,
                        "name": "Marseille Bompard",
                        "latitude": "43.28120000",
                        "longitude": "5.36081000"
                    },
                    {
                        "id": 43901,
                        "name": "Marseille Endoume",
                        "latitude": "43.28320000",
                        "longitude": "5.35159000"
                    },
                    {
                        "id": 43902,
                        "name": "Marseille Prefecture",
                        "latitude": "43.29092000",
                        "longitude": "5.37901000"
                    },
                    {
                        "id": 43903,
                        "name": "Marseille Roucas-Blanc",
                        "latitude": "43.27652000",
                        "longitude": "5.36519000"
                    },
                    {
                        "id": 43904,
                        "name": "Marseille Saint-Victor",
                        "latitude": "43.28955000",
                        "longitude": "5.36845000"
                    },
                    {
                        "id": 43905,
                        "name": "Marseille Vauban",
                        "latitude": "43.28408000",
                        "longitude": "5.37540000"
                    },
                    {
                        "id": 43916,
                        "name": "Martigues",
                        "latitude": "43.40735000",
                        "longitude": "5.05526000"
                    },
                    {
                        "id": 43943,
                        "name": "Maubec",
                        "latitude": "43.84379000",
                        "longitude": "5.13919000"
                    },
                    {
                        "id": 43959,
                        "name": "Maussane-les-Alpilles",
                        "latitude": "43.72236000",
                        "longitude": "4.80497000"
                    },
                    {
                        "id": 43972,
                        "name": "Mazan",
                        "latitude": "44.05696000",
                        "longitude": "5.12680000"
                    },
                    {
                        "id": 43973,
                        "name": "Mazargues",
                        "latitude": "43.24622000",
                        "longitude": "5.39788000"
                    },
                    {
                        "id": 44462,
                        "name": "Ménerbes",
                        "latitude": "43.83242000",
                        "longitude": "5.20597000"
                    },
                    {
                        "id": 44003,
                        "name": "Menpenti",
                        "latitude": "43.28198000",
                        "longitude": "5.39607000"
                    },
                    {
                        "id": 44007,
                        "name": "Menton",
                        "latitude": "43.77649000",
                        "longitude": "7.50435000"
                    },
                    {
                        "id": 44468,
                        "name": "Méounes-lès-Montrieux",
                        "latitude": "43.28102000",
                        "longitude": "5.96986000"
                    },
                    {
                        "id": 44475,
                        "name": "Mérindol",
                        "latitude": "43.75516000",
                        "longitude": "5.20357000"
                    },
                    {
                        "id": 44059,
                        "name": "Meyrargues",
                        "latitude": "43.63677000",
                        "longitude": "5.52679000"
                    },
                    {
                        "id": 44060,
                        "name": "Meyreuil",
                        "latitude": "43.48780000",
                        "longitude": "5.49574000"
                    },
                    {
                        "id": 44079,
                        "name": "Mimet",
                        "latitude": "43.41427000",
                        "longitude": "5.50579000"
                    },
                    {
                        "id": 44087,
                        "name": "Miramas",
                        "latitude": "43.58508000",
                        "longitude": "5.00268000"
                    },
                    {
                        "id": 44125,
                        "name": "Mollégès",
                        "latitude": "43.80703000",
                        "longitude": "4.94934000"
                    },
                    {
                        "id": 44139,
                        "name": "Mondragon",
                        "latitude": "44.23831000",
                        "longitude": "4.71286000"
                    },
                    {
                        "id": 44186,
                        "name": "Montauroux",
                        "latitude": "43.61823000",
                        "longitude": "6.76528000"
                    },
                    {
                        "id": 44229,
                        "name": "Monteux",
                        "latitude": "44.03618000",
                        "longitude": "4.99630000"
                    },
                    {
                        "id": 44234,
                        "name": "Montfavet",
                        "latitude": "43.93335000",
                        "longitude": "4.87342000"
                    },
                    {
                        "id": 44238,
                        "name": "Montferrat",
                        "latitude": "43.61196000",
                        "longitude": "6.48093000"
                    },
                    {
                        "id": 44296,
                        "name": "Montolivet",
                        "latitude": "43.31715000",
                        "longitude": "5.42350000"
                    },
                    {
                        "id": 44304,
                        "name": "Montredon",
                        "latitude": "43.24016000",
                        "longitude": "5.36629000"
                    },
                    {
                        "id": 44355,
                        "name": "Morières-lès-Avignon",
                        "latitude": "43.94030000",
                        "longitude": "4.90110000"
                    },
                    {
                        "id": 44359,
                        "name": "Mormoiron",
                        "latitude": "44.06810000",
                        "longitude": "5.18312000"
                    },
                    {
                        "id": 44362,
                        "name": "Mornas",
                        "latitude": "44.20242000",
                        "longitude": "4.72763000"
                    },
                    {
                        "id": 44381,
                        "name": "Mouans-Sartoux",
                        "latitude": "43.62101000",
                        "longitude": "6.97139000"
                    },
                    {
                        "id": 44386,
                        "name": "Mougins",
                        "latitude": "43.60068000",
                        "longitude": "6.99523000"
                    },
                    {
                        "id": 44400,
                        "name": "Mouret",
                        "latitude": "43.36126000",
                        "longitude": "5.43006000"
                    },
                    {
                        "id": 44401,
                        "name": "Mouriès",
                        "latitude": "43.68997000",
                        "longitude": "4.87089000"
                    },
                    {
                        "id": 44504,
                        "name": "Nans-les-Pins",
                        "latitude": "43.37066000",
                        "longitude": "5.78189000"
                    },
                    {
                        "id": 44693,
                        "name": "Néoules",
                        "latitude": "43.30844000",
                        "longitude": "6.00798000"
                    },
                    {
                        "id": 44587,
                        "name": "Nice",
                        "latitude": "43.70313000",
                        "longitude": "7.26608000"
                    },
                    {
                        "id": 44608,
                        "name": "Noailles",
                        "latitude": "43.29604000",
                        "longitude": "5.37959000"
                    },
                    {
                        "id": 44649,
                        "name": "Notre-Dame du Mont",
                        "latitude": "43.29293000",
                        "longitude": "5.38203000"
                    },
                    {
                        "id": 44648,
                        "name": "Notre-Dame Limite",
                        "latitude": "43.38165000",
                        "longitude": "5.36269000"
                    },
                    {
                        "id": 44666,
                        "name": "Noves",
                        "latitude": "43.87736000",
                        "longitude": "4.90248000"
                    },
                    {
                        "id": 44735,
                        "name": "Ollioules",
                        "latitude": "43.13990000",
                        "longitude": "5.84766000"
                    },
                    {
                        "id": 44749,
                        "name": "Opéra",
                        "latitude": "43.29401000",
                        "longitude": "5.37610000"
                    },
                    {
                        "id": 44747,
                        "name": "Opio",
                        "latitude": "43.66862000",
                        "longitude": "6.98212000"
                    },
                    {
                        "id": 44748,
                        "name": "Oppède le Vieux",
                        "latitude": "43.82844000",
                        "longitude": "5.16132000"
                    },
                    {
                        "id": 44752,
                        "name": "Oraison",
                        "latitude": "43.91726000",
                        "longitude": "5.91836000"
                    },
                    {
                        "id": 44753,
                        "name": "Orange",
                        "latitude": "44.13806000",
                        "longitude": "4.81025000"
                    },
                    {
                        "id": 44764,
                        "name": "Orgon",
                        "latitude": "43.79108000",
                        "longitude": "5.03869000"
                    },
                    {
                        "id": 44831,
                        "name": "Palais de Justice",
                        "latitude": "43.28657000",
                        "longitude": "5.37603000"
                    },
                    {
                        "id": 44834,
                        "name": "Palama",
                        "latitude": "43.36566000",
                        "longitude": "5.44427000"
                    },
                    {
                        "id": 44846,
                        "name": "Paradou",
                        "latitude": "43.71699000",
                        "longitude": "4.78604000"
                    },
                    {
                        "id": 45345,
                        "name": "Pégomas",
                        "latitude": "43.59662000",
                        "longitude": "6.93211000"
                    },
                    {
                        "id": 44882,
                        "name": "Peille",
                        "latitude": "43.80296000",
                        "longitude": "7.40191000"
                    },
                    {
                        "id": 44883,
                        "name": "Peillon",
                        "latitude": "43.77861000",
                        "longitude": "7.38278000"
                    },
                    {
                        "id": 44885,
                        "name": "Peipin",
                        "latitude": "44.13778000",
                        "longitude": "5.95722000"
                    },
                    {
                        "id": 45346,
                        "name": "Pélissanne",
                        "latitude": "43.63260000",
                        "longitude": "5.15220000"
                    },
                    {
                        "id": 45351,
                        "name": "Périer",
                        "latitude": "43.27755000",
                        "longitude": "5.37925000"
                    },
                    {
                        "id": 44898,
                        "name": "Pernes-les-Fontaines",
                        "latitude": "43.99802000",
                        "longitude": "5.05906000"
                    },
                    {
                        "id": 44911,
                        "name": "Pertuis",
                        "latitude": "43.69415000",
                        "longitude": "5.50291000"
                    },
                    {
                        "id": 44923,
                        "name": "Peymeinade",
                        "latitude": "43.64244000",
                        "longitude": "6.87583000"
                    },
                    {
                        "id": 44924,
                        "name": "Peynier",
                        "latitude": "43.44837000",
                        "longitude": "5.64139000"
                    },
                    {
                        "id": 44925,
                        "name": "Peypin",
                        "latitude": "43.38503000",
                        "longitude": "5.57788000"
                    },
                    {
                        "id": 44934,
                        "name": "Peyrolles-en-Provence",
                        "latitude": "43.64545000",
                        "longitude": "5.58492000"
                    },
                    {
                        "id": 44935,
                        "name": "Peyruis",
                        "latitude": "44.02880000",
                        "longitude": "5.94032000"
                    },
                    {
                        "id": 44953,
                        "name": "Pierrefeu-du-Var",
                        "latitude": "43.22411000",
                        "longitude": "6.14536000"
                    },
                    {
                        "id": 44963,
                        "name": "Pierrevert",
                        "latitude": "43.81137000",
                        "longitude": "5.74958000"
                    },
                    {
                        "id": 44969,
                        "name": "Pignans",
                        "latitude": "43.30071000",
                        "longitude": "6.22650000"
                    },
                    {
                        "id": 44974,
                        "name": "Piolenc",
                        "latitude": "44.17765000",
                        "longitude": "4.76157000"
                    },
                    {
                        "id": 44996,
                        "name": "Plan-d'Aups-Sainte-Baume",
                        "latitude": "43.33333000",
                        "longitude": "5.71667000"
                    },
                    {
                        "id": 44997,
                        "name": "Plan-de-Cuques",
                        "latitude": "43.34753000",
                        "longitude": "5.46398000"
                    },
                    {
                        "id": 45163,
                        "name": "Pont de Vivaux",
                        "latitude": "43.27604000",
                        "longitude": "5.41586000"
                    },
                    {
                        "id": 45233,
                        "name": "Port-de-Bouc",
                        "latitude": "43.40657000",
                        "longitude": "4.98090000"
                    },
                    {
                        "id": 45229,
                        "name": "Port-Saint-Louis-du-Rhône",
                        "latitude": "43.38734000",
                        "longitude": "4.82609000"
                    },
                    {
                        "id": 45266,
                        "name": "Pourrières",
                        "latitude": "43.50611000",
                        "longitude": "5.73452000"
                    },
                    {
                        "id": 45316,
                        "name": "Puget-sur-Argens",
                        "latitude": "43.45576000",
                        "longitude": "6.68519000"
                    },
                    {
                        "id": 45314,
                        "name": "Puget-Théniers",
                        "latitude": "43.95598000",
                        "longitude": "6.89378000"
                    },
                    {
                        "id": 45315,
                        "name": "Puget-Ville",
                        "latitude": "43.28958000",
                        "longitude": "6.13612000"
                    },
                    {
                        "id": 45339,
                        "name": "Puyloubier",
                        "latitude": "43.52522000",
                        "longitude": "5.67650000"
                    },
                    {
                        "id": 45421,
                        "name": "Ramatuelle",
                        "latitude": "43.21599000",
                        "longitude": "6.61156000"
                    },
                    {
                        "id": 45690,
                        "name": "Régusse",
                        "latitude": "43.65540000",
                        "longitude": "6.13186000"
                    },
                    {
                        "id": 45449,
                        "name": "Reillanne",
                        "latitude": "43.87899000",
                        "longitude": "5.65919000"
                    },
                    {
                        "id": 45486,
                        "name": "Rians",
                        "latitude": "43.60691000",
                        "longitude": "5.75696000"
                    },
                    {
                        "id": 45509,
                        "name": "Riez",
                        "latitude": "43.81810000",
                        "longitude": "6.09268000"
                    },
                    {
                        "id": 45537,
                        "name": "Robion",
                        "latitude": "43.84697000",
                        "longitude": "5.11017000"
                    },
                    {
                        "id": 45538,
                        "name": "Rocbaron",
                        "latitude": "43.30904000",
                        "longitude": "6.07941000"
                    },
                    {
                        "id": 45558,
                        "name": "Rognac",
                        "latitude": "43.48761000",
                        "longitude": "5.23387000"
                    },
                    {
                        "id": 45559,
                        "name": "Rognes",
                        "latitude": "43.66378000",
                        "longitude": "5.34733000"
                    },
                    {
                        "id": 45560,
                        "name": "Rognonas",
                        "latitude": "43.89993000",
                        "longitude": "4.80369000"
                    },
                    {
                        "id": 45588,
                        "name": "Roquebillière",
                        "latitude": "44.01203000",
                        "longitude": "7.30727000"
                    },
                    {
                        "id": 45589,
                        "name": "Roquebrune-Cap-Martin",
                        "latitude": "43.76408000",
                        "longitude": "7.48207000"
                    },
                    {
                        "id": 45590,
                        "name": "Roquebrune-sur-Argens",
                        "latitude": "43.44313000",
                        "longitude": "6.63772000"
                    },
                    {
                        "id": 45593,
                        "name": "Roquefort-la-Bédoule",
                        "latitude": "43.24883000",
                        "longitude": "5.59015000"
                    },
                    {
                        "id": 45597,
                        "name": "Roquevaire",
                        "latitude": "43.35021000",
                        "longitude": "5.60414000"
                    },
                    {
                        "id": 45618,
                        "name": "Rouet",
                        "latitude": "43.27808000",
                        "longitude": "5.39158000"
                    },
                    {
                        "id": 45624,
                        "name": "Rougiers",
                        "latitude": "43.39233000",
                        "longitude": "5.85112000"
                    },
                    {
                        "id": 45637,
                        "name": "Rousset",
                        "latitude": "43.48307000",
                        "longitude": "5.61959000"
                    },
                    {
                        "id": 45638,
                        "name": "Roussillon",
                        "latitude": "43.90239000",
                        "longitude": "5.29274000"
                    },
                    {
                        "id": 45699,
                        "name": "Sablet",
                        "latitude": "44.19265000",
                        "longitude": "5.00566000"
                    },
                    {
                        "id": 45715,
                        "name": "Saignon",
                        "latitude": "43.86308000",
                        "longitude": "5.42838000"
                    },
                    {
                        "id": 45754,
                        "name": "Saint-Andiol",
                        "latitude": "43.83484000",
                        "longitude": "4.94453000"
                    },
                    {
                        "id": 45755,
                        "name": "Saint-André",
                        "latitude": "43.35630000",
                        "longitude": "5.34335000"
                    },
                    {
                        "id": 45761,
                        "name": "Saint-André-de-la-Roche",
                        "latitude": "43.73333000",
                        "longitude": "7.28333000"
                    },
                    {
                        "id": 45770,
                        "name": "Saint-Antoine",
                        "latitude": "43.37087000",
                        "longitude": "5.35888000"
                    },
                    {
                        "id": 45803,
                        "name": "Saint-Barnabé",
                        "latitude": "43.30000000",
                        "longitude": "5.41667000"
                    },
                    {
                        "id": 45805,
                        "name": "Saint-Barthélémy",
                        "latitude": "43.33105000",
                        "longitude": "5.40241000"
                    },
                    {
                        "id": 45817,
                        "name": "Saint-Bonnet-en-Champsaur",
                        "latitude": "44.68333000",
                        "longitude": "6.08333000"
                    },
                    {
                        "id": 45837,
                        "name": "Saint-Cannat",
                        "latitude": "43.62132000",
                        "longitude": "5.29810000"
                    },
                    {
                        "id": 45893,
                        "name": "Saint-Cézaire-sur-Siagne",
                        "latitude": "43.65015000",
                        "longitude": "6.79219000"
                    },
                    {
                        "id": 45845,
                        "name": "Saint-Chaffrey",
                        "latitude": "44.92555000",
                        "longitude": "6.60768000"
                    },
                    {
                        "id": 45846,
                        "name": "Saint-Chamas",
                        "latitude": "43.55048000",
                        "longitude": "5.03501000"
                    },
                    {
                        "id": 45849,
                        "name": "Saint-Charles",
                        "latitude": "43.30199000",
                        "longitude": "5.38405000"
                    },
                    {
                        "id": 45889,
                        "name": "Saint-Cyr-sur-Mer",
                        "latitude": "43.18048000",
                        "longitude": "5.70120000"
                    },
                    {
                        "id": 45905,
                        "name": "Saint-Didier",
                        "latitude": "44.00424000",
                        "longitude": "5.11053000"
                    },
                    {
                        "id": 46650,
                        "name": "Saint-Étienne-de-Tinée",
                        "latitude": "44.25643000",
                        "longitude": "6.92499000"
                    },
                    {
                        "id": 46654,
                        "name": "Saint-Étienne-du-Grès",
                        "latitude": "43.78045000",
                        "longitude": "4.72534000"
                    },
                    {
                        "id": 46037,
                        "name": "Saint-Giniez",
                        "latitude": "43.26946000",
                        "longitude": "5.38566000"
                    },
                    {
                        "id": 46047,
                        "name": "Saint-Henri",
                        "latitude": "43.36151000",
                        "longitude": "5.33069000"
                    },
                    {
                        "id": 46082,
                        "name": "Saint-Jean du Désert",
                        "latitude": "43.29331000",
                        "longitude": "5.42134000"
                    },
                    {
                        "id": 46085,
                        "name": "Saint-Jean-Cap-Ferrat",
                        "latitude": "43.68843000",
                        "longitude": "7.33361000"
                    },
                    {
                        "id": 46122,
                        "name": "Saint-Jeannet",
                        "latitude": "43.74718000",
                        "longitude": "7.14299000"
                    },
                    {
                        "id": 46166,
                        "name": "Saint-Jérôme",
                        "latitude": "43.33404000",
                        "longitude": "5.41733000"
                    },
                    {
                        "id": 46128,
                        "name": "Saint-Joseph",
                        "latitude": "43.34617000",
                        "longitude": "5.37976000"
                    },
                    {
                        "id": 46136,
                        "name": "Saint-Julien",
                        "latitude": "43.31334000",
                        "longitude": "5.44935000"
                    },
                    {
                        "id": 46150,
                        "name": "Saint-Just",
                        "latitude": "43.31700000",
                        "longitude": "5.40587000"
                    },
                    {
                        "id": 46167,
                        "name": "Saint-Lambert",
                        "latitude": "43.28606000",
                        "longitude": "5.36000000"
                    },
                    {
                        "id": 46185,
                        "name": "Saint-Laurent-du-Var",
                        "latitude": "43.67323000",
                        "longitude": "7.19000000"
                    },
                    {
                        "id": 46191,
                        "name": "Saint-Lazare",
                        "latitude": "43.30545000",
                        "longitude": "5.37443000"
                    },
                    {
                        "id": 46197,
                        "name": "Saint-Louis",
                        "latitude": "43.34809000",
                        "longitude": "5.35463000"
                    },
                    {
                        "id": 46199,
                        "name": "Saint-Loup",
                        "latitude": "43.27766000",
                        "longitude": "5.43133000"
                    },
                    {
                        "id": 46235,
                        "name": "Saint-Mandrier-sur-Mer",
                        "latitude": "43.07800000",
                        "longitude": "5.92900000"
                    },
                    {
                        "id": 46239,
                        "name": "Saint-Marc-Jaumegarde",
                        "latitude": "43.54718000",
                        "longitude": "5.52280000"
                    },
                    {
                        "id": 46242,
                        "name": "Saint-Marcel",
                        "latitude": "43.28745000",
                        "longitude": "5.46604000"
                    },
                    {
                        "id": 46270,
                        "name": "Saint-Martin-de-Crau",
                        "latitude": "43.63955000",
                        "longitude": "4.81270000"
                    },
                    {
                        "id": 46276,
                        "name": "Saint-Martin-de-Queyrières",
                        "latitude": "44.82319000",
                        "longitude": "6.57901000"
                    },
                    {
                        "id": 46292,
                        "name": "Saint-Martin-du-Var",
                        "latitude": "43.81846000",
                        "longitude": "7.19062000"
                    },
                    {
                        "id": 46266,
                        "name": "Saint-Martin-Vésubie",
                        "latitude": "44.06892000",
                        "longitude": "7.25583000"
                    },
                    {
                        "id": 46322,
                        "name": "Saint-Mauront",
                        "latitude": "43.31552000",
                        "longitude": "5.37538000"
                    },
                    {
                        "id": 46325,
                        "name": "Saint-Maximin-la-Sainte-Baume",
                        "latitude": "43.44813000",
                        "longitude": "5.86081000"
                    },
                    {
                        "id": 46329,
                        "name": "Saint-Menet",
                        "latitude": "43.28997000",
                        "longitude": "5.50427000"
                    },
                    {
                        "id": 46339,
                        "name": "Saint-Michel-l’Observatoire",
                        "latitude": "43.90977000",
                        "longitude": "5.71584000"
                    },
                    {
                        "id": 46343,
                        "name": "Saint-Mitre",
                        "latitude": "43.34640000",
                        "longitude": "5.42274000"
                    },
                    {
                        "id": 46344,
                        "name": "Saint-Mitre-les-Remparts",
                        "latitude": "43.45503000",
                        "longitude": "5.01429000"
                    },
                    {
                        "id": 46410,
                        "name": "Saint-Paul-de-Vence",
                        "latitude": "43.70000000",
                        "longitude": "7.11667000"
                    },
                    {
                        "id": 46413,
                        "name": "Saint-Paul-en-Forêt",
                        "latitude": "43.56709000",
                        "longitude": "6.69206000"
                    },
                    {
                        "id": 46428,
                        "name": "Saint-Pierre",
                        "latitude": "43.29282000",
                        "longitude": "5.40682000"
                    },
                    {
                        "id": 46494,
                        "name": "Saint-Raphaël",
                        "latitude": "43.42332000",
                        "longitude": "6.77350000"
                    },
                    {
                        "id": 46511,
                        "name": "Saint-Rémy-de-Provence",
                        "latitude": "43.78848000",
                        "longitude": "4.83167000"
                    },
                    {
                        "id": 46522,
                        "name": "Saint-Saturnin-lès-Apt",
                        "latitude": "43.93333000",
                        "longitude": "5.38333000"
                    },
                    {
                        "id": 46523,
                        "name": "Saint-Saturnin-lès-Avignon",
                        "latitude": "43.95501000",
                        "longitude": "4.92548000"
                    },
                    {
                        "id": 46543,
                        "name": "Saint-Savournin",
                        "latitude": "43.40848000",
                        "longitude": "5.52690000"
                    },
                    {
                        "id": 46588,
                        "name": "Saint-Tronc",
                        "latitude": "43.27093000",
                        "longitude": "5.42285000"
                    },
                    {
                        "id": 46589,
                        "name": "Saint-Tropez",
                        "latitude": "43.26764000",
                        "longitude": "6.64049000"
                    },
                    {
                        "id": 46600,
                        "name": "Saint-Vallier-de-Thiey",
                        "latitude": "43.69841000",
                        "longitude": "6.84779000"
                    },
                    {
                        "id": 46610,
                        "name": "Saint-Victoret",
                        "latitude": "43.41957000",
                        "longitude": "5.23396000"
                    },
                    {
                        "id": 46634,
                        "name": "Saint-Zacharie",
                        "latitude": "43.38521000",
                        "longitude": "5.70808000"
                    },
                    {
                        "id": 46661,
                        "name": "Sainte-Agnès",
                        "latitude": "43.80054000",
                        "longitude": "7.46150000"
                    },
                    {
                        "id": 46662,
                        "name": "Sainte-Anastasie-sur-Issole",
                        "latitude": "43.34266000",
                        "longitude": "6.12493000"
                    },
                    {
                        "id": 46663,
                        "name": "Sainte-Anne",
                        "latitude": "43.25720000",
                        "longitude": "5.39377000"
                    },
                    {
                        "id": 46675,
                        "name": "Sainte-Cécile-les-Vignes",
                        "latitude": "44.24542000",
                        "longitude": "4.88613000"
                    },
                    {
                        "id": 46705,
                        "name": "Sainte-Marguerite",
                        "latitude": "43.26196000",
                        "longitude": "5.40125000"
                    },
                    {
                        "id": 46715,
                        "name": "Sainte-Marthe",
                        "latitude": "43.33449000",
                        "longitude": "5.39112000"
                    },
                    {
                        "id": 46718,
                        "name": "Sainte-Maxime",
                        "latitude": "43.30907000",
                        "longitude": "6.63849000"
                    },
                    {
                        "id": 46732,
                        "name": "Sainte-Tulle",
                        "latitude": "43.78619000",
                        "longitude": "5.76513000"
                    },
                    {
                        "id": 46735,
                        "name": "Saintes-Maries-de-la-Mer",
                        "latitude": "43.45214000",
                        "longitude": "4.42913000"
                    },
                    {
                        "id": 46745,
                        "name": "Salernes",
                        "latitude": "43.56350000",
                        "longitude": "6.23386000"
                    },
                    {
                        "id": 46766,
                        "name": "Salon-de-Provence",
                        "latitude": "43.64229000",
                        "longitude": "5.09478000"
                    },
                    {
                        "id": 46780,
                        "name": "Sanary-sur-Mer",
                        "latitude": "43.11985000",
                        "longitude": "5.80155000"
                    },
                    {
                        "id": 46816,
                        "name": "Sarrians",
                        "latitude": "44.08312000",
                        "longitude": "4.97111000"
                    },
                    {
                        "id": 46844,
                        "name": "Sault",
                        "latitude": "44.08968000",
                        "longitude": "5.40836000"
                    },
                    {
                        "id": 46856,
                        "name": "Sausset-les-Pins",
                        "latitude": "43.33136000",
                        "longitude": "5.10431000"
                    },
                    {
                        "id": 46923,
                        "name": "Seillans",
                        "latitude": "43.63623000",
                        "longitude": "6.64332000"
                    },
                    {
                        "id": 47139,
                        "name": "Sénas",
                        "latitude": "43.74375000",
                        "longitude": "5.07800000"
                    },
                    {
                        "id": 46951,
                        "name": "Septèmes-les-Vallons",
                        "latitude": "43.39834000",
                        "longitude": "5.36596000"
                    },
                    {
                        "id": 47145,
                        "name": "Sérignan-du-Comtat",
                        "latitude": "44.18915000",
                        "longitude": "4.84379000"
                    },
                    {
                        "id": 46966,
                        "name": "Serres",
                        "latitude": "44.42753000",
                        "longitude": "5.71458000"
                    },
                    {
                        "id": 46982,
                        "name": "Seyne-les-Alpes",
                        "latitude": "44.35042000",
                        "longitude": "6.35634000"
                    },
                    {
                        "id": 46992,
                        "name": "Signes",
                        "latitude": "43.29080000",
                        "longitude": "5.86284000"
                    },
                    {
                        "id": 47002,
                        "name": "Simiane-Collongue",
                        "latitude": "43.43067000",
                        "longitude": "5.43454000"
                    },
                    {
                        "id": 47009,
                        "name": "Sisteron",
                        "latitude": "44.19002000",
                        "longitude": "5.94643000"
                    },
                    {
                        "id": 47010,
                        "name": "Six-Fours-les-Plages",
                        "latitude": "43.09174000",
                        "longitude": "5.82465000"
                    },
                    {
                        "id": 47030,
                        "name": "Solliès-Pont",
                        "latitude": "43.19009000",
                        "longitude": "6.04115000"
                    },
                    {
                        "id": 47031,
                        "name": "Solliès-Toucas",
                        "latitude": "43.20579000",
                        "longitude": "6.02485000"
                    },
                    {
                        "id": 47032,
                        "name": "Solliès-Ville",
                        "latitude": "43.18256000",
                        "longitude": "6.03849000"
                    },
                    {
                        "id": 47046,
                        "name": "Sorgues",
                        "latitude": "44.01023000",
                        "longitude": "4.87381000"
                    },
                    {
                        "id": 47048,
                        "name": "Sormiou",
                        "latitude": "43.20959000",
                        "longitude": "5.41872000"
                    },
                    {
                        "id": 47052,
                        "name": "Sospel",
                        "latitude": "43.87792000",
                        "longitude": "7.44788000"
                    },
                    {
                        "id": 47095,
                        "name": "Spéracèdes",
                        "latitude": "43.64850000",
                        "longitude": "6.85889000"
                    },
                    {
                        "id": 47155,
                        "name": "Taillades",
                        "latitude": "43.83762000",
                        "longitude": "5.08951000"
                    },
                    {
                        "id": 47164,
                        "name": "Tallard",
                        "latitude": "44.46200000",
                        "longitude": "6.05205000"
                    },
                    {
                        "id": 47172,
                        "name": "Tanneron",
                        "latitude": "43.59057000",
                        "longitude": "6.87541000"
                    },
                    {
                        "id": 47174,
                        "name": "Taradeau",
                        "latitude": "43.45444000",
                        "longitude": "6.42729000"
                    },
                    {
                        "id": 47176,
                        "name": "Tarascon",
                        "latitude": "43.80583000",
                        "longitude": "4.66028000"
                    },
                    {
                        "id": 47202,
                        "name": "Tende",
                        "latitude": "44.08752000",
                        "longitude": "7.59366000"
                    },
                    {
                        "id": 47270,
                        "name": "Théoule-sur-Mer",
                        "latitude": "43.50780000",
                        "longitude": "6.94080000"
                    },
                    {
                        "id": 47229,
                        "name": "Thiers",
                        "latitude": "43.29748000",
                        "longitude": "5.38198000"
                    },
                    {
                        "id": 47312,
                        "name": "Toulon",
                        "latitude": "43.12442000",
                        "longitude": "5.92836000"
                    },
                    {
                        "id": 47331,
                        "name": "Tourrette-Levens",
                        "latitude": "43.78640000",
                        "longitude": "7.27598000"
                    },
                    {
                        "id": 47332,
                        "name": "Tourrettes-sur-Loup",
                        "latitude": "43.71569000",
                        "longitude": "7.05892000"
                    },
                    {
                        "id": 47335,
                        "name": "Tourves",
                        "latitude": "43.40803000",
                        "longitude": "5.92392000"
                    },
                    {
                        "id": 47348,
                        "name": "Trans-en-Provence",
                        "latitude": "43.50326000",
                        "longitude": "6.48641000"
                    },
                    {
                        "id": 47366,
                        "name": "Trets",
                        "latitude": "43.44818000",
                        "longitude": "5.68328000"
                    },
                    {
                        "id": 47421,
                        "name": "Uchaux",
                        "latitude": "44.21667000",
                        "longitude": "4.80000000"
                    },
                    {
                        "id": 47451,
                        "name": "Vacqueyras",
                        "latitude": "44.13835000",
                        "longitude": "4.98332000"
                    },
                    {
                        "id": 47459,
                        "name": "Vaison-la-Romaine",
                        "latitude": "44.23896000",
                        "longitude": "5.07461000"
                    },
                    {
                        "id": 47467,
                        "name": "Valbonne",
                        "latitude": "43.63292000",
                        "longitude": "6.99911000"
                    },
                    {
                        "id": 47476,
                        "name": "Valensole",
                        "latitude": "43.83766000",
                        "longitude": "5.98392000"
                    },
                    {
                        "id": 47485,
                        "name": "Vallauris",
                        "latitude": "43.57803000",
                        "longitude": "7.05451000"
                    },
                    {
                        "id": 47500,
                        "name": "Valréas",
                        "latitude": "44.38490000",
                        "longitude": "4.99125000"
                    },
                    {
                        "id": 47506,
                        "name": "Var",
                        "latitude": "43.45860000",
                        "longitude": "6.29145000"
                    },
                    {
                        "id": 47554,
                        "name": "Vedène",
                        "latitude": "43.97744000",
                        "longitude": "4.90428000"
                    },
                    {
                        "id": 47560,
                        "name": "Velaux",
                        "latitude": "43.52839000",
                        "longitude": "5.25661000"
                    },
                    {
                        "id": 47561,
                        "name": "Velleron",
                        "latitude": "43.95742000",
                        "longitude": "5.02936000"
                    },
                    {
                        "id": 47564,
                        "name": "Venasque",
                        "latitude": "43.99595000",
                        "longitude": "5.14666000"
                    },
                    {
                        "id": 47565,
                        "name": "Vence",
                        "latitude": "43.72254000",
                        "longitude": "7.11183000"
                    },
                    {
                        "id": 47580,
                        "name": "Venelles",
                        "latitude": "43.59859000",
                        "longitude": "5.47977000"
                    },
                    {
                        "id": 47587,
                        "name": "Ventabren",
                        "latitude": "43.53847000",
                        "longitude": "5.29541000"
                    },
                    {
                        "id": 47596,
                        "name": "Verduron",
                        "latitude": "43.37063000",
                        "longitude": "5.34513000"
                    },
                    {
                        "id": 47627,
                        "name": "Vernègues",
                        "latitude": "43.68575000",
                        "longitude": "5.17156000"
                    },
                    {
                        "id": 47652,
                        "name": "Veynes",
                        "latitude": "44.53406000",
                        "longitude": "5.82321000"
                    },
                    {
                        "id": 47673,
                        "name": "Vidauban",
                        "latitude": "43.42721000",
                        "longitude": "6.43185000"
                    },
                    {
                        "id": 47674,
                        "name": "Vieille Chapelle",
                        "latitude": "43.24963000",
                        "longitude": "5.38048000"
                    },
                    {
                        "id": 47709,
                        "name": "Villar-Saint-Pancrace",
                        "latitude": "44.87318000",
                        "longitude": "6.62669000"
                    },
                    {
                        "id": 47728,
                        "name": "Villecroze",
                        "latitude": "43.58223000",
                        "longitude": "6.27587000"
                    },
                    {
                        "id": 47740,
                        "name": "Villefranche-sur-Mer",
                        "latitude": "43.70392000",
                        "longitude": "7.31088000"
                    },
                    {
                        "id": 47747,
                        "name": "Villelaure",
                        "latitude": "43.71075000",
                        "longitude": "5.43422000"
                    },
                    {
                        "id": 47760,
                        "name": "Villeneuve",
                        "latitude": "44.94488000",
                        "longitude": "6.56545000"
                    },
                    {
                        "id": 47762,
                        "name": "Villeneuve-Loubet",
                        "latitude": "43.65790000",
                        "longitude": "7.12233000"
                    },
                    {
                        "id": 47814,
                        "name": "Villes-sur-Auzon",
                        "latitude": "44.05669000",
                        "longitude": "5.23430000"
                    },
                    {
                        "id": 47849,
                        "name": "Vinon-sur-Verdon",
                        "latitude": "43.72484000",
                        "longitude": "5.81168000"
                    },
                    {
                        "id": 47854,
                        "name": "Violès",
                        "latitude": "44.16176000",
                        "longitude": "4.95483000"
                    },
                    {
                        "id": 47869,
                        "name": "Visan",
                        "latitude": "44.31468000",
                        "longitude": "4.95033000"
                    },
                    {
                        "id": 47870,
                        "name": "Vitrolles",
                        "latitude": "43.46000000",
                        "longitude": "5.24861000"
                    },
                    {
                        "id": 47897,
                        "name": "Volonne",
                        "latitude": "44.11039000",
                        "longitude": "6.01424000"
                    },
                    {
                        "id": 47900,
                        "name": "Volx",
                        "latitude": "43.87787000",
                        "longitude": "5.84148000"
                    }
                ]
            },
            {
                "id": 5031,
                "name": "Puy-de-Dôme",
                "iso2": "63",
                "latitude": "45.77141850",
                "longitude": "2.62626760",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5032,
                "name": "Pyrénées-Atlantiques",
                "iso2": "64",
                "latitude": "43.18681700",
                "longitude": "-1.44170710",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5034,
                "name": "Pyrénées-Orientales",
                "iso2": "66",
                "latitude": "42.62541790",
                "longitude": "1.88929580",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5037,
                "name": "Rhône",
                "iso2": "69",
                "latitude": "44.93433000",
                "longitude": "4.24093290",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4821,
                "name": "Saint Pierre and Miquelon",
                "iso2": "PM",
                "latitude": "46.88520000",
                "longitude": "-56.31590000",
                "type": "overseas collectivity",
                "cities": []
            },
            {
                "id": 4794,
                "name": "Saint-Barthélemy",
                "iso2": "BL",
                "latitude": "17.90051340",
                "longitude": "-62.82058710",
                "type": "overseas collectivity",
                "cities": []
            },
            {
                "id": 4809,
                "name": "Saint-Martin",
                "iso2": "MF",
                "latitude": "18.07082980",
                "longitude": "-63.05008090",
                "type": "overseas collectivity",
                "cities": []
            },
            {
                "id": 5040,
                "name": "Saône-et-Loire",
                "iso2": "71",
                "latitude": "46.65548830",
                "longitude": "3.98350500",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5041,
                "name": "Sarthe",
                "iso2": "72",
                "latitude": "48.02627330",
                "longitude": "-0.32613170",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5042,
                "name": "Savoie",
                "iso2": "73",
                "latitude": "45.49469900",
                "longitude": "5.84329840",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5045,
                "name": "Seine-et-Marne",
                "iso2": "77",
                "latitude": "48.61853940",
                "longitude": "2.41525610",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5044,
                "name": "Seine-Maritime",
                "iso2": "76",
                "latitude": "49.66096810",
                "longitude": "0.36775610",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5061,
                "name": "Seine-Saint-Denis",
                "iso2": "93",
                "latitude": "48.90993180",
                "longitude": "2.30573790",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5048,
                "name": "Somme",
                "iso2": "80",
                "latitude": "49.96859220",
                "longitude": "1.73106960",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5049,
                "name": "Tarn",
                "iso2": "81",
                "latitude": "43.79149770",
                "longitude": "1.67588930",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5050,
                "name": "Tarn-et-Garonne",
                "iso2": "82",
                "latitude": "44.08089500",
                "longitude": "1.08916570",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5058,
                "name": "Territoire de Belfort",
                "iso2": "90",
                "latitude": "47.62930720",
                "longitude": "6.66962000",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5063,
                "name": "Val-d'Oise",
                "iso2": "95",
                "latitude": "49.07518180",
                "longitude": "1.82169140",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5062,
                "name": "Val-de-Marne",
                "iso2": "94",
                "latitude": "48.77470040",
                "longitude": "2.32210390",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5051,
                "name": "Var",
                "iso2": "83",
                "latitude": "43.39507300",
                "longitude": "5.73424170",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5052,
                "name": "Vaucluse",
                "iso2": "84",
                "latitude": "44.04475000",
                "longitude": "4.64277180",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5053,
                "name": "Vendée",
                "iso2": "85",
                "latitude": "46.67541030",
                "longitude": "-2.02983920",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5054,
                "name": "Vienne",
                "iso2": "86",
                "latitude": "45.52213140",
                "longitude": "4.84531360",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5056,
                "name": "Vosges",
                "iso2": "88",
                "latitude": "48.16301730",
                "longitude": "5.73556000",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 4810,
                "name": "Wallis and Futuna",
                "iso2": "WF",
                "latitude": "-14.29380000",
                "longitude": "-178.11650000",
                "type": "overseas collectivity",
                "cities": []
            },
            {
                "id": 5057,
                "name": "Yonne",
                "iso2": "89",
                "latitude": "47.85476140",
                "longitude": "3.03394040",
                "type": "metropolitan department",
                "cities": []
            },
            {
                "id": 5046,
                "name": "Yvelines",
                "iso2": "78",
                "latitude": "48.76153010",
                "longitude": "1.27729490",
                "type": "metropolitan department",
                "cities": []
            }
        ]
    },
    {
        "id": 76,
        "name": "French Guiana",
        "iso3": "GUF",
        "iso2": "GF",
        "numeric_code": "254",
        "phonecode": "594",
        "capital": "Cayenne",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".gf",
        "native": "Guyane française",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "French Guianese",
        "timezones": [
            {
                "zoneName": "America\/Cayenne",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "GFT",
                "tzName": "French Guiana Time"
            }
        ],
        "translations": {
            "br": "Gwiana",
            "ko": "프랑스령 기아나",
            "pt-BR": "Guiana Francesa",
            "pt": "Guiana Francesa",
            "nl": "Frans-Guyana",
            "hr": "Francuska Gvajana",
            "fa": "گویان فرانسه",
            "de": "Französisch Guyana",
            "es": "Guayana Francesa",
            "fr": "Guayane",
            "ja": "フランス領ギアナ",
            "it": "Guyana francese",
            "zh-CN": "法属圭亚那",
            "tr": "Fransiz Guyanasi",
            "ru": "Французская Гвиана",
            "uk": "Французька Гвіана",
            "pl": "Gujana Francuska"
        },
        "latitude": "4.00000000",
        "longitude": "-53.00000000",
        "emoji": "🇬🇫",
        "emojiU": "U+1F1EC U+1F1EB",
        "states": []
    },
    {
        "id": 77,
        "name": "French Polynesia",
        "iso3": "PYF",
        "iso2": "PF",
        "numeric_code": "258",
        "phonecode": "689",
        "capital": "Papeete",
        "currency": "XPF",
        "currency_name": "CFP franc",
        "currency_symbol": "₣",
        "tld": ".pf",
        "native": "Polynésie française",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Polynesia",
        "subregion_id": 22,
        "nationality": "French Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Gambier",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "GAMT",
                "tzName": "Gambier Islands Time"
            },
            {
                "zoneName": "Pacific\/Marquesas",
                "gmtOffset": -34200,
                "gmtOffsetName": "UTC-09:30",
                "abbreviation": "MART",
                "tzName": "Marquesas Islands Time"
            },
            {
                "zoneName": "Pacific\/Tahiti",
                "gmtOffset": -36000,
                "gmtOffsetName": "UTC-10:00",
                "abbreviation": "TAHT",
                "tzName": "Tahiti Time"
            }
        ],
        "translations": {
            "br": "Polinezia C'hall",
            "ko": "프랑스령 폴리네시아",
            "pt-BR": "Polinésia Francesa",
            "pt": "Polinésia Francesa",
            "nl": "Frans-Polynesië",
            "hr": "Francuska Polinezija",
            "fa": "پلی‌نزی فرانسه",
            "de": "Französisch-Polynesien",
            "es": "Polinesia Francesa",
            "fr": "Polynésie française",
            "ja": "フランス領ポリネシア",
            "it": "Polinesia Francese",
            "zh-CN": "法属波利尼西亚",
            "tr": "Fransiz Polinezyasi",
            "ru": "Французская Полинезия",
            "uk": "Французька Полінезія",
            "pl": "Polinezja Francuska"
        },
        "latitude": "-15.00000000",
        "longitude": "-140.00000000",
        "emoji": "🇵🇫",
        "emojiU": "U+1F1F5 U+1F1EB",
        "states": [
            {
                "id": 5369,
                "name": "Austral Islands",
                "iso2": "01",
                "latitude": "-24.62108770",
                "longitude": "-154.79155860",
                "type": "division",
                "cities": [
                    {
                        "id": 154867,
                        "name": "Raivavae",
                        "latitude": "-23.86946330",
                        "longitude": "-147.73244720"
                    },
                    {
                        "id": 154868,
                        "name": "Rapa",
                        "latitude": "-27.60822390",
                        "longitude": "-144.38427770"
                    },
                    {
                        "id": 154869,
                        "name": "Rimatara",
                        "latitude": "-22.64382540",
                        "longitude": "-152.83120520"
                    },
                    {
                        "id": 154870,
                        "name": "Rurutu",
                        "latitude": "-22.46958690",
                        "longitude": "-151.39113710"
                    },
                    {
                        "id": 154871,
                        "name": "Tubuai",
                        "latitude": "-23.36850430",
                        "longitude": "-149.54496480"
                    }
                ]
            },
            {
                "id": 5370,
                "name": "Leeward Islands",
                "iso2": "02",
                "latitude": "-16.33144420",
                "longitude": "-155.45770620",
                "type": "division",
                "cities": [
                    {
                        "id": 154872,
                        "name": "Bora-Bora",
                        "latitude": "-16.39169250",
                        "longitude": "-151.93003350"
                    },
                    {
                        "id": 154873,
                        "name": "Huahine",
                        "latitude": "-16.75212330",
                        "longitude": "-151.07889500"
                    },
                    {
                        "id": 154874,
                        "name": "Maupiti",
                        "latitude": "-16.31438490",
                        "longitude": "-154.79908630"
                    },
                    {
                        "id": 154875,
                        "name": "Tahaa",
                        "latitude": "-16.61957120",
                        "longitude": "-151.57215390"
                    },
                    {
                        "id": 154876,
                        "name": "Taputapuatea",
                        "latitude": "-16.82062470",
                        "longitude": "-151.47741330"
                    },
                    {
                        "id": 154877,
                        "name": "Tumaraa",
                        "latitude": "-16.82985330",
                        "longitude": "-151.53381840"
                    },
                    {
                        "id": 154878,
                        "name": "Uturoa",
                        "latitude": "-16.73858290",
                        "longitude": "-151.49549020"
                    }
                ]
            },
            {
                "id": 5371,
                "name": "Marquesas Islands",
                "iso2": "03",
                "latitude": "-9.17852990",
                "longitude": "-140.97670260",
                "type": "division",
                "cities": [
                    {
                        "id": 154879,
                        "name": "Fatu-Hiva",
                        "latitude": "-10.48604740",
                        "longitude": "-138.69188860"
                    },
                    {
                        "id": 154880,
                        "name": "Hiva-Oa",
                        "latitude": "-9.72631690",
                        "longitude": "-139.30998880"
                    },
                    {
                        "id": 154881,
                        "name": "Nuku-Hiva",
                        "latitude": "-8.41030010",
                        "longitude": "-141.02327110"
                    },
                    {
                        "id": 154882,
                        "name": "Tahuata",
                        "latitude": "-9.95732410",
                        "longitude": "-139.16563470"
                    },
                    {
                        "id": 154883,
                        "name": "Ua-Huka",
                        "latitude": "-8.90967990",
                        "longitude": "-139.63171970"
                    },
                    {
                        "id": 154884,
                        "name": "Ua-Pou",
                        "latitude": "-9.40892440",
                        "longitude": "-140.15553770"
                    }
                ]
            },
            {
                "id": 5372,
                "name": "Tuamotu-Gambier",
                "iso2": "04",
                "latitude": "-18.32071570",
                "longitude": "-152.44871660",
                "type": "division",
                "cities": [
                    {
                        "id": 154885,
                        "name": "Anaa",
                        "latitude": "-17.41194390",
                        "longitude": "-145.66284990"
                    },
                    {
                        "id": 154886,
                        "name": "Arutua",
                        "latitude": "-15.31203340",
                        "longitude": "-146.91262850"
                    },
                    {
                        "id": 154887,
                        "name": "Fakarava",
                        "latitude": "-16.29845160",
                        "longitude": "-145.92218890"
                    },
                    {
                        "id": 154888,
                        "name": "Fangatau",
                        "latitude": "-15.82097880",
                        "longitude": "-140.90810600"
                    },
                    {
                        "id": 154889,
                        "name": "Gambier",
                        "latitude": "-23.10088440",
                        "longitude": "-135.07922550"
                    },
                    {
                        "id": 154890,
                        "name": "Hao",
                        "latitude": "-18.74532930",
                        "longitude": "-145.33383850"
                    },
                    {
                        "id": 154891,
                        "name": "Hikueru",
                        "latitude": "-17.58767480",
                        "longitude": "-142.69120590"
                    },
                    {
                        "id": 154892,
                        "name": "Makemo",
                        "latitude": "-16.59334420",
                        "longitude": "-144.01756280"
                    },
                    {
                        "id": 154893,
                        "name": "Manihi",
                        "latitude": "-14.39757810",
                        "longitude": "-146.12217070"
                    },
                    {
                        "id": 154894,
                        "name": "Napuka",
                        "latitude": "-14.17342310",
                        "longitude": "-141.30676690"
                    },
                    {
                        "id": 154895,
                        "name": "Nukutavake",
                        "latitude": "-18.97808660",
                        "longitude": "-139.29284520"
                    },
                    {
                        "id": 154896,
                        "name": "Puka-Puka",
                        "latitude": "-14.81902510",
                        "longitude": "-138.86100870"
                    },
                    {
                        "id": 154897,
                        "name": "Rangiroa",
                        "latitude": "-15.12282920",
                        "longitude": "-147.91140150"
                    },
                    {
                        "id": 154898,
                        "name": "Reao",
                        "latitude": "-18.51946500",
                        "longitude": "-136.46088500"
                    },
                    {
                        "id": 154899,
                        "name": "Takaroa",
                        "latitude": "-14.67263940",
                        "longitude": "-145.22680410"
                    },
                    {
                        "id": 154900,
                        "name": "Tatakoto",
                        "latitude": "-17.34173160",
                        "longitude": "-138.47584630"
                    },
                    {
                        "id": 154901,
                        "name": "Tureia",
                        "latitude": "-20.82803180",
                        "longitude": "-138.58163900"
                    }
                ]
            },
            {
                "id": 5373,
                "name": "Windward Islands",
                "iso2": "05",
                "latitude": "-17.42539670",
                "longitude": "-150.67802270",
                "type": "division",
                "cities": [
                    {
                        "id": 154902,
                        "name": "Arue",
                        "latitude": "-17.27738940",
                        "longitude": "-149.87199430"
                    },
                    {
                        "id": 154903,
                        "name": "Faaa",
                        "latitude": "-17.58391940",
                        "longitude": "-149.64609260"
                    },
                    {
                        "id": 154904,
                        "name": "Hitiaa O Te Ra",
                        "latitude": "-17.59142580",
                        "longitude": "-149.47324810"
                    },
                    {
                        "id": 154905,
                        "name": "Mahina",
                        "latitude": "-17.55747420",
                        "longitude": "-149.51647820"
                    },
                    {
                        "id": 154906,
                        "name": "Moorea-Maiao",
                        "latitude": "-17.57566530",
                        "longitude": "-150.86188770"
                    },
                    {
                        "id": 154907,
                        "name": "Paea",
                        "latitude": "-17.69616980",
                        "longitude": "-149.58969660"
                    },
                    {
                        "id": 154908,
                        "name": "Papara",
                        "latitude": "-17.71187630",
                        "longitude": "-149.59042950"
                    },
                    {
                        "id": 154909,
                        "name": "Papeete",
                        "latitude": "-17.55713870",
                        "longitude": "-149.59660090"
                    },
                    {
                        "id": 154910,
                        "name": "Pirae",
                        "latitude": "-17.56986380",
                        "longitude": "-149.56352800"
                    },
                    {
                        "id": 154911,
                        "name": "Punaauia",
                        "latitude": "-17.61796960",
                        "longitude": "-149.63102240"
                    },
                    {
                        "id": 154912,
                        "name": "Taiarapu-Est",
                        "latitude": "-17.75551280",
                        "longitude": "-149.39533960"
                    },
                    {
                        "id": 154913,
                        "name": "Taiarapu-Ouest",
                        "latitude": "-17.81004520",
                        "longitude": "-149.32700520"
                    },
                    {
                        "id": 154914,
                        "name": "Teva I Uta",
                        "latitude": "-17.72250080",
                        "longitude": "-149.48196150"
                    }
                ]
            }
        ]
    },
    {
        "id": 78,
        "name": "French Southern Territories",
        "iso3": "ATF",
        "iso2": "TF",
        "numeric_code": "260",
        "phonecode": "262",
        "capital": "Port-aux-Francais",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".tf",
        "native": "Territoire des Terres australes et antarctiques fr",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Southern Africa",
        "subregion_id": 5,
        "nationality": "French Southern Territories",
        "timezones": [
            {
                "zoneName": "Indian\/Kerguelen",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "TFT",
                "tzName": "French Southern and Antarctic Time"
            }
        ],
        "translations": {
            "br": "Douaroù Aostral hag Antarktikel Frañs",
            "ko": "프랑스령 남방 및 남극",
            "pt-BR": "Terras Austrais e Antárticas Francesas",
            "pt": "Terras Austrais e Antárticas Francesas",
            "nl": "Franse Gebieden in de zuidelijke Indische Oceaan",
            "hr": "Francuski južni i antarktički teritoriji",
            "fa": "سرزمین‌های جنوبی و جنوبگانی فرانسه",
            "de": "Französische Süd- und Antarktisgebiete",
            "es": "Tierras Australes y Antárticas Francesas",
            "fr": "Terres australes et antarctiques françaises",
            "ja": "フランス領南方・南極地域",
            "it": "Territori Francesi del Sud",
            "zh-CN": "法属南部领地",
            "tr": "Fransiz Güney Topraklari",
            "ru": "Французские южные территории",
            "uk": "Французькі південні території",
            "pl": "Francuskie terytoria południowe"
        },
        "latitude": "-49.25000000",
        "longitude": "69.16700000",
        "emoji": "🇹🇫",
        "emojiU": "U+1F1F9 U+1F1EB",
        "states": []
    },
    {
        "id": 79,
        "name": "Gabon",
        "iso3": "GAB",
        "iso2": "GA",
        "numeric_code": "266",
        "phonecode": "241",
        "capital": "Libreville",
        "currency": "XAF",
        "currency_name": "Central African CFA franc",
        "currency_symbol": "FCFA",
        "tld": ".ga",
        "native": "Gabon",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Middle Africa",
        "subregion_id": 2,
        "nationality": "Gabonese",
        "timezones": [
            {
                "zoneName": "Africa\/Libreville",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "br": "Gabon",
            "ko": "가봉",
            "pt-BR": "Gabão",
            "pt": "Gabão",
            "nl": "Gabon",
            "hr": "Gabon",
            "fa": "گابن",
            "de": "Gabun",
            "es": "Gabón",
            "fr": "Gabon",
            "ja": "ガボン",
            "it": "Gabon",
            "zh-CN": "加蓬",
            "tr": "Gabon",
            "ru": "Габон",
            "uk": "Габон",
            "pl": "Gabon"
        },
        "latitude": "-1.00000000",
        "longitude": "11.75000000",
        "emoji": "🇬🇦",
        "emojiU": "U+1F1EC U+1F1E6",
        "states": [
            {
                "id": 2727,
                "name": "Estuaire",
                "iso2": "1",
                "latitude": "0.44328640",
                "longitude": "10.08072980",
                "type": "province",
                "cities": [
                    {
                        "id": 48131,
                        "name": "Cocobeach",
                        "latitude": "1.00019000",
                        "longitude": "9.58229000"
                    },
                    {
                        "id": 48138,
                        "name": "Libreville",
                        "latitude": "0.39241000",
                        "longitude": "9.45356000"
                    },
                    {
                        "id": 48150,
                        "name": "Ntoum",
                        "latitude": "0.39051000",
                        "longitude": "9.76096000"
                    }
                ]
            },
            {
                "id": 2726,
                "name": "Haut-Ogooué",
                "iso2": "2",
                "latitude": "-1.47625440",
                "longitude": "13.91439900",
                "type": "province",
                "cities": [
                    {
                        "id": 48133,
                        "name": "Franceville",
                        "latitude": "-1.63333000",
                        "longitude": "13.58357000"
                    },
                    {
                        "id": 48139,
                        "name": "Lékoni",
                        "latitude": "-1.58431000",
                        "longitude": "14.25905000"
                    },
                    {
                        "id": 48145,
                        "name": "Moanda",
                        "latitude": "-1.56652000",
                        "longitude": "13.19870000"
                    },
                    {
                        "id": 48147,
                        "name": "Mounana",
                        "latitude": "-1.40850000",
                        "longitude": "13.15857000"
                    },
                    {
                        "id": 48151,
                        "name": "Okondja",
                        "latitude": "-0.65487000",
                        "longitude": "13.67533000"
                    }
                ]
            },
            {
                "id": 2730,
                "name": "Moyen-Ogooué",
                "iso2": "3",
                "latitude": "-0.44278400",
                "longitude": "10.43965600",
                "type": "province",
                "cities": [
                    {
                        "id": 48136,
                        "name": "Lambaréné",
                        "latitude": "-0.70010000",
                        "longitude": "10.24055000"
                    },
                    {
                        "id": 48149,
                        "name": "Ndjolé",
                        "latitude": "-0.17827000",
                        "longitude": "10.76488000"
                    }
                ]
            },
            {
                "id": 2731,
                "name": "Ngounié",
                "iso2": "4",
                "latitude": "-1.49303030",
                "longitude": "10.98070030",
                "type": "province",
                "cities": [
                    {
                        "id": 48132,
                        "name": "Fougamou",
                        "latitude": "-1.21544000",
                        "longitude": "10.58378000"
                    },
                    {
                        "id": 48142,
                        "name": "Mbigou",
                        "latitude": "-1.90046000",
                        "longitude": "11.90600000"
                    },
                    {
                        "id": 48143,
                        "name": "Mimongo",
                        "latitude": "-1.61952000",
                        "longitude": "11.60675000"
                    },
                    {
                        "id": 48146,
                        "name": "Mouila",
                        "latitude": "-1.86846000",
                        "longitude": "11.05594000"
                    },
                    {
                        "id": 48148,
                        "name": "Ndendé",
                        "latitude": "-2.40077000",
                        "longitude": "11.35813000"
                    }
                ]
            },
            {
                "id": 2725,
                "name": "Nyanga",
                "iso2": "5",
                "latitude": "-2.88210330",
                "longitude": "11.16173560",
                "type": "province",
                "cities": [
                    {
                        "id": 48141,
                        "name": "Mayumba",
                        "latitude": "-3.43198000",
                        "longitude": "10.65540000"
                    },
                    {
                        "id": 48155,
                        "name": "Tchibanga",
                        "latitude": "-2.93323000",
                        "longitude": "10.98178000"
                    }
                ]
            },
            {
                "id": 2724,
                "name": "Ogooué-Ivindo",
                "iso2": "6",
                "latitude": "0.88183110",
                "longitude": "13.17403480",
                "type": "province",
                "cities": [
                    {
                        "id": 48130,
                        "name": "Booué",
                        "latitude": "-0.09207000",
                        "longitude": "11.93846000"
                    },
                    {
                        "id": 48140,
                        "name": "Makokou",
                        "latitude": "0.57381000",
                        "longitude": "12.86419000"
                    },
                    {
                        "id": 48156,
                        "name": "Zadie",
                        "latitude": "0.92582000",
                        "longitude": "13.90813000"
                    }
                ]
            },
            {
                "id": 2729,
                "name": "Ogooué-Lolo",
                "iso2": "7",
                "latitude": "-0.88440930",
                "longitude": "12.43805810",
                "type": "province",
                "cities": [
                    {
                        "id": 48135,
                        "name": "Koulamoutou",
                        "latitude": "-1.13667000",
                        "longitude": "12.46399000"
                    },
                    {
                        "id": 48137,
                        "name": "Lastoursville",
                        "latitude": "-0.81742000",
                        "longitude": "12.70818000"
                    }
                ]
            },
            {
                "id": 2728,
                "name": "Ogooué-Maritime",
                "iso2": "8",
                "latitude": "-1.34659750",
                "longitude": "9.72326730",
                "type": "province",
                "cities": [
                    {
                        "id": 48134,
                        "name": "Gamba",
                        "latitude": "-2.65000000",
                        "longitude": "10.00000000"
                    },
                    {
                        "id": 48152,
                        "name": "Omboué",
                        "latitude": "-1.57464000",
                        "longitude": "9.26184000"
                    },
                    {
                        "id": 48154,
                        "name": "Port-Gentil",
                        "latitude": "-0.71933000",
                        "longitude": "8.78151000"
                    }
                ]
            },
            {
                "id": 2723,
                "name": "Woleu-Ntem",
                "iso2": "9",
                "latitude": "2.29898270",
                "longitude": "11.44669140",
                "type": "province",
                "cities": [
                    {
                        "id": 48129,
                        "name": "Bitam",
                        "latitude": "2.07597000",
                        "longitude": "11.50065000"
                    },
                    {
                        "id": 48144,
                        "name": "Mitzic",
                        "latitude": "0.78205000",
                        "longitude": "11.54904000"
                    },
                    {
                        "id": 48153,
                        "name": "Oyem",
                        "latitude": "1.59950000",
                        "longitude": "11.57933000"
                    }
                ]
            }
        ]
    },
    {
        "id": 81,
        "name": "Georgia",
        "iso3": "GEO",
        "iso2": "GE",
        "numeric_code": "268",
        "phonecode": "995",
        "capital": "Tbilisi",
        "currency": "GEL",
        "currency_name": "Georgian lari",
        "currency_symbol": "ლ",
        "tld": ".ge",
        "native": "საქართველო",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Georgian",
        "timezones": [
            {
                "zoneName": "Asia\/Tbilisi",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "GET",
                "tzName": "Georgia Standard Time"
            }
        ],
        "translations": {
            "br": "Jorjia",
            "ko": "조지아",
            "pt-BR": "Geórgia",
            "pt": "Geórgia",
            "nl": "Georgië",
            "hr": "Gruzija",
            "fa": "گرجستان",
            "de": "Georgien",
            "es": "Georgia",
            "fr": "Géorgie",
            "ja": "グルジア",
            "it": "Georgia",
            "zh-CN": "格鲁吉亚",
            "tr": "Gürcistan",
            "ru": "Джорджия",
            "uk": "Грузія",
            "pl": "Gruzja"
        },
        "latitude": "42.00000000",
        "longitude": "43.50000000",
        "emoji": "🇬🇪",
        "emojiU": "U+1F1EC U+1F1EA",
        "states": [
            {
                "id": 901,
                "name": "Abkhazia",
                "iso2": "AB",
                "latitude": "43.00155440",
                "longitude": "41.02340700",
                "type": "autonomous republic",
                "cities": [
                    {
                        "id": 52054,
                        "name": "Bich’vinta",
                        "latitude": "43.16197000",
                        "longitude": "40.34102000"
                    },
                    {
                        "id": 52063,
                        "name": "Dranda",
                        "latitude": "42.87167000",
                        "longitude": "41.15333000"
                    },
                    {
                        "id": 52065,
                        "name": "Gagra",
                        "latitude": "43.27858000",
                        "longitude": "40.27124000"
                    },
                    {
                        "id": 52066,
                        "name": "Gali",
                        "latitude": "42.62655000",
                        "longitude": "41.73808000"
                    },
                    {
                        "id": 52067,
                        "name": "Gantiadi",
                        "latitude": "43.38111000",
                        "longitude": "40.07944000"
                    },
                    {
                        "id": 52073,
                        "name": "Gudauta",
                        "latitude": "43.10547000",
                        "longitude": "40.62067000"
                    },
                    {
                        "id": 52078,
                        "name": "Kelasuri",
                        "latitude": "42.97877000",
                        "longitude": "41.07067000"
                    },
                    {
                        "id": 52105,
                        "name": "Och’amch’ire",
                        "latitude": "42.71232000",
                        "longitude": "41.46863000"
                    },
                    {
                        "id": 52111,
                        "name": "P’rimorsk’oe",
                        "latitude": "43.09236000",
                        "longitude": "40.69650000"
                    },
                    {
                        "id": 52122,
                        "name": "Sokhumi",
                        "latitude": "43.00697000",
                        "longitude": "40.98930000"
                    },
                    {
                        "id": 52123,
                        "name": "Stantsiya Novyy Afon",
                        "latitude": "43.08056000",
                        "longitude": "40.83833000"
                    },
                    {
                        "id": 52130,
                        "name": "Tqvarch'eli",
                        "latitude": "42.84035000",
                        "longitude": "41.68007000"
                    }
                ]
            },
            {
                "id": 900,
                "name": "Adjara",
                "iso2": "AJ",
                "latitude": "41.60056260",
                "longitude": "42.06883830",
                "type": "autonomous republic",
                "cities": [
                    {
                        "id": 52040,
                        "name": "Akhaldaba",
                        "latitude": "41.65395000",
                        "longitude": "42.15163000"
                    },
                    {
                        "id": 52053,
                        "name": "Batumi",
                        "latitude": "41.64228000",
                        "longitude": "41.63392000"
                    },
                    {
                        "id": 52058,
                        "name": "Chakvi",
                        "latitude": "41.72528000",
                        "longitude": "41.73278000"
                    },
                    {
                        "id": 52061,
                        "name": "Dioknisi",
                        "latitude": "41.62933000",
                        "longitude": "42.39171000"
                    },
                    {
                        "id": 52081,
                        "name": "Khelvachauri",
                        "latitude": "41.58556000",
                        "longitude": "41.66889000"
                    },
                    {
                        "id": 52084,
                        "name": "Khulo",
                        "latitude": "41.64353000",
                        "longitude": "42.30397000"
                    },
                    {
                        "id": 52085,
                        "name": "Kobuleti",
                        "latitude": "41.82143000",
                        "longitude": "41.77921000"
                    },
                    {
                        "id": 52093,
                        "name": "Makhinjauri",
                        "latitude": "41.67385000",
                        "longitude": "41.69401000"
                    },
                    {
                        "id": 52104,
                        "name": "Ochkhamuri",
                        "latitude": "41.85975000",
                        "longitude": "41.85309000"
                    },
                    {
                        "id": 52119,
                        "name": "Shuakhevi",
                        "latitude": "41.63000000",
                        "longitude": "42.19083000"
                    },
                    {
                        "id": 52134,
                        "name": "Tsikhisdziri",
                        "latitude": "41.76659000",
                        "longitude": "41.75517000"
                    }
                ]
            },
            {
                "id": 907,
                "name": "Guria",
                "iso2": "GU",
                "latitude": "41.94427360",
                "longitude": "42.04580910",
                "type": "region",
                "cities": [
                    {
                        "id": 52091,
                        "name": "Lanchkhuti",
                        "latitude": "42.09027000",
                        "longitude": "42.03239000"
                    },
                    {
                        "id": 52102,
                        "name": "Naruja",
                        "latitude": "41.90694000",
                        "longitude": "41.95417000"
                    },
                    {
                        "id": 52108,
                        "name": "Ozurgeti",
                        "latitude": "41.92442000",
                        "longitude": "42.00682000"
                    },
                    {
                        "id": 52141,
                        "name": "Urek’i",
                        "latitude": "41.99556000",
                        "longitude": "41.77861000"
                    }
                ]
            },
            {
                "id": 905,
                "name": "Imereti",
                "iso2": "IM",
                "latitude": "42.23010800",
                "longitude": "42.90086640",
                "type": "region",
                "cities": [
                    {
                        "id": 52051,
                        "name": "Baghdatis Munitsip’alit’et’i",
                        "latitude": "42.00000000",
                        "longitude": "42.90000000"
                    },
                    {
                        "id": 52059,
                        "name": "Chiat’ura",
                        "latitude": "42.29806000",
                        "longitude": "43.29889000"
                    },
                    {
                        "id": 52088,
                        "name": "K’alak’i Chiat’ura",
                        "latitude": "42.28333000",
                        "longitude": "43.25000000"
                    },
                    {
                        "id": 52089,
                        "name": "K’ulashi",
                        "latitude": "42.20405000",
                        "longitude": "42.34289000"
                    },
                    {
                        "id": 52079,
                        "name": "Kharagauli",
                        "latitude": "42.02137000",
                        "longitude": "43.19773000"
                    },
                    {
                        "id": 52083,
                        "name": "Khoni",
                        "latitude": "42.32260000",
                        "longitude": "42.42061000"
                    },
                    {
                        "id": 52086,
                        "name": "Kutaisi",
                        "latitude": "42.26791000",
                        "longitude": "42.69459000"
                    },
                    {
                        "id": 52114,
                        "name": "Sach’khere",
                        "latitude": "42.34528000",
                        "longitude": "43.41944000"
                    },
                    {
                        "id": 52116,
                        "name": "Samtredia",
                        "latitude": "42.15370000",
                        "longitude": "42.33517000"
                    },
                    {
                        "id": 52118,
                        "name": "Shorapani",
                        "latitude": "42.08980000",
                        "longitude": "43.08662000"
                    },
                    {
                        "id": 52129,
                        "name": "Tqibuli",
                        "latitude": "42.35121000",
                        "longitude": "42.99874000"
                    },
                    {
                        "id": 52137,
                        "name": "Tsqaltubo",
                        "latitude": "42.34129000",
                        "longitude": "42.59760000"
                    },
                    {
                        "id": 52143,
                        "name": "Vani",
                        "latitude": "42.08320000",
                        "longitude": "42.52163000"
                    },
                    {
                        "id": 52144,
                        "name": "Zestap’oni",
                        "latitude": "42.11000000",
                        "longitude": "43.05250000"
                    }
                ]
            },
            {
                "id": 910,
                "name": "Kakheti",
                "iso2": "KA",
                "latitude": "41.64816020",
                "longitude": "45.69055540",
                "type": "region",
                "cities": [
                    {
                        "id": 52045,
                        "name": "Akhmet’a",
                        "latitude": "42.03111000",
                        "longitude": "45.20750000"
                    },
                    {
                        "id": 52046,
                        "name": "Akhmet’is Munitsip’alit’et’i",
                        "latitude": "42.25000000",
                        "longitude": "45.33333000"
                    },
                    {
                        "id": 52074,
                        "name": "Gurjaani",
                        "latitude": "41.74292000",
                        "longitude": "45.80111000"
                    },
                    {
                        "id": 52090,
                        "name": "Lagodekhi",
                        "latitude": "41.82681000",
                        "longitude": "46.27667000"
                    },
                    {
                        "id": 52112,
                        "name": "Qvareli",
                        "latitude": "41.95493000",
                        "longitude": "45.81716000"
                    },
                    {
                        "id": 52115,
                        "name": "Sagarejo",
                        "latitude": "41.73397000",
                        "longitude": "45.33149000"
                    },
                    {
                        "id": 52120,
                        "name": "Sighnaghi",
                        "latitude": "41.62046000",
                        "longitude": "45.92198000"
                    },
                    {
                        "id": 52121,
                        "name": "Sighnaghis Munitsip’alit’et’i",
                        "latitude": "41.56667000",
                        "longitude": "45.85000000"
                    },
                    {
                        "id": 52127,
                        "name": "Telavi",
                        "latitude": "41.91978000",
                        "longitude": "45.47315000"
                    },
                    {
                        "id": 52135,
                        "name": "Tsinandali",
                        "latitude": "41.89315000",
                        "longitude": "45.57129000"
                    },
                    {
                        "id": 52136,
                        "name": "Tsnori",
                        "latitude": "41.62088000",
                        "longitude": "45.96943000"
                    }
                ]
            },
            {
                "id": 904,
                "name": "Kvemo Kartli",
                "iso2": "KK",
                "latitude": "41.47918330",
                "longitude": "44.65604510",
                "type": "region",
                "cities": [
                    {
                        "id": 52055,
                        "name": "Bolnisi",
                        "latitude": "41.44794000",
                        "longitude": "44.53838000"
                    },
                    {
                        "id": 52056,
                        "name": "Bolnisis Munitsip’alit’et’i",
                        "latitude": "41.36667000",
                        "longitude": "44.51667000"
                    },
                    {
                        "id": 52060,
                        "name": "Didi Lilo",
                        "latitude": "41.73611000",
                        "longitude": "44.96472000"
                    },
                    {
                        "id": 52062,
                        "name": "Dmanisis Munitsip’alit’et’i",
                        "latitude": "41.35000000",
                        "longitude": "44.13333000"
                    },
                    {
                        "id": 52068,
                        "name": "Gardabani",
                        "latitude": "41.46054000",
                        "longitude": "45.09283000"
                    },
                    {
                        "id": 52069,
                        "name": "Gardabnis Munitsip’alit’et’i",
                        "latitude": "41.61667000",
                        "longitude": "45.00000000"
                    },
                    {
                        "id": 52094,
                        "name": "Manglisi",
                        "latitude": "41.69698000",
                        "longitude": "44.38448000"
                    },
                    {
                        "id": 52095,
                        "name": "Marneuli",
                        "latitude": "41.47588000",
                        "longitude": "44.80895000"
                    },
                    {
                        "id": 52096,
                        "name": "Marneulis Munitsip’alit’et’i",
                        "latitude": "41.38333000",
                        "longitude": "44.85000000"
                    },
                    {
                        "id": 52101,
                        "name": "Naghvarevi",
                        "latitude": "41.35272000",
                        "longitude": "44.76178000"
                    },
                    {
                        "id": 52113,
                        "name": "Rust’avi",
                        "latitude": "41.54949000",
                        "longitude": "44.99323000"
                    },
                    {
                        "id": 52140,
                        "name": "T’et’ri Tsqaro",
                        "latitude": "41.54448000",
                        "longitude": "44.46153000"
                    },
                    {
                        "id": 52128,
                        "name": "Tetrits’q’alos Munitsip’alit’et’i",
                        "latitude": "41.60000000",
                        "longitude": "44.50000000"
                    },
                    {
                        "id": 52138,
                        "name": "Ts’alk’is Munitsip’alit’et’i",
                        "latitude": "41.63333000",
                        "longitude": "43.96667000"
                    },
                    {
                        "id": 52133,
                        "name": "Tsalka",
                        "latitude": "41.59460000",
                        "longitude": "44.08909000"
                    }
                ]
            },
            {
                "id": 902,
                "name": "Mtskheta-Mtianeti",
                "iso2": "MM",
                "latitude": "42.16821850",
                "longitude": "44.65060580",
                "type": "region",
                "cities": [
                    {
                        "id": 52041,
                        "name": "Akhalgori",
                        "latitude": "42.12597000",
                        "longitude": "44.48333000"
                    },
                    {
                        "id": 52064,
                        "name": "Dzegvi",
                        "latitude": "41.84569000",
                        "longitude": "44.60097000"
                    },
                    {
                        "id": 52072,
                        "name": "Gudauri",
                        "latitude": "42.47797000",
                        "longitude": "44.47616000"
                    },
                    {
                        "id": 52075,
                        "name": "Java",
                        "latitude": "42.39972000",
                        "longitude": "43.93667000"
                    },
                    {
                        "id": 52100,
                        "name": "Mtskheta",
                        "latitude": "41.84514000",
                        "longitude": "44.71875000"
                    },
                    {
                        "id": 52109,
                        "name": "P’asanauri",
                        "latitude": "42.35060000",
                        "longitude": "44.68912000"
                    },
                    {
                        "id": 52124,
                        "name": "Step’antsminda",
                        "latitude": "42.65667000",
                        "longitude": "44.64333000"
                    },
                    {
                        "id": 52145,
                        "name": "Zhinvali",
                        "latitude": "42.13181000",
                        "longitude": "44.77264000"
                    }
                ]
            },
            {
                "id": 909,
                "name": "Racha-Lechkhumi and Kvemo Svaneti",
                "iso2": "RL",
                "latitude": "42.67188730",
                "longitude": "43.05628360",
                "type": "region",
                "cities": [
                    {
                        "id": 52047,
                        "name": "Ambrolauri",
                        "latitude": "42.52111000",
                        "longitude": "43.16222000"
                    },
                    {
                        "id": 52048,
                        "name": "Ambrolauris Munitsip’alit’et’i",
                        "latitude": "42.56667000",
                        "longitude": "43.10000000"
                    },
                    {
                        "id": 52092,
                        "name": "Lent’ekhi",
                        "latitude": "42.78893000",
                        "longitude": "42.72226000"
                    },
                    {
                        "id": 52106,
                        "name": "Oni",
                        "latitude": "42.57944000",
                        "longitude": "43.44250000"
                    }
                ]
            },
            {
                "id": 908,
                "name": "Samegrelo-Zemo Svaneti",
                "iso2": "SZ",
                "latitude": "42.73522470",
                "longitude": "42.16893620",
                "type": "region",
                "cities": [
                    {
                        "id": 52035,
                        "name": "Abasha",
                        "latitude": "42.20000000",
                        "longitude": "42.20000000"
                    },
                    {
                        "id": 52076,
                        "name": "Jvari",
                        "latitude": "42.71693000",
                        "longitude": "42.05200000"
                    },
                    {
                        "id": 52082,
                        "name": "Khobi",
                        "latitude": "42.31558000",
                        "longitude": "41.89871000"
                    },
                    {
                        "id": 52087,
                        "name": "Kveda Chkhorots’q’u",
                        "latitude": "42.48103000",
                        "longitude": "42.09661000"
                    },
                    {
                        "id": 52097,
                        "name": "Mart’vili",
                        "latitude": "42.41436000",
                        "longitude": "42.37924000"
                    },
                    {
                        "id": 52098,
                        "name": "Mest’ia",
                        "latitude": "43.04581000",
                        "longitude": "42.72780000"
                    },
                    {
                        "id": 52099,
                        "name": "Mest’iis Munitsip’alit’et’i",
                        "latitude": "43.05000000",
                        "longitude": "42.55000000"
                    },
                    {
                        "id": 52107,
                        "name": "Orsant’ia",
                        "latitude": "42.46777000",
                        "longitude": "41.67377000"
                    },
                    {
                        "id": 52110,
                        "name": "P’ot’i",
                        "latitude": "42.14616000",
                        "longitude": "41.67197000"
                    },
                    {
                        "id": 52117,
                        "name": "Senak’i",
                        "latitude": "42.27042000",
                        "longitude": "42.06750000"
                    },
                    {
                        "id": 52132,
                        "name": "Tsalenjikha",
                        "latitude": "42.60444000",
                        "longitude": "42.06825000"
                    },
                    {
                        "id": 52146,
                        "name": "Zugdidi",
                        "latitude": "42.50880000",
                        "longitude": "41.87088000"
                    }
                ]
            },
            {
                "id": 906,
                "name": "Samtskhe-Javakheti",
                "iso2": "SJ",
                "latitude": "41.54792960",
                "longitude": "43.27764000",
                "type": "region",
                "cities": [
                    {
                        "id": 52036,
                        "name": "Adigeni",
                        "latitude": "41.68191000",
                        "longitude": "42.69867000"
                    },
                    {
                        "id": 52037,
                        "name": "Adigeni Municipality",
                        "latitude": "41.71667000",
                        "longitude": "42.73333000"
                    },
                    {
                        "id": 52039,
                        "name": "Akhaldaba",
                        "latitude": "41.92945000",
                        "longitude": "43.48762000"
                    },
                    {
                        "id": 52042,
                        "name": "Akhalk’alak’i",
                        "latitude": "41.40514000",
                        "longitude": "43.48629000"
                    },
                    {
                        "id": 52043,
                        "name": "Akhaltsikhe",
                        "latitude": "41.63901000",
                        "longitude": "42.98262000"
                    },
                    {
                        "id": 52044,
                        "name": "Akhaltsikhis Munitsip’alit’et’i",
                        "latitude": "41.63333000",
                        "longitude": "43.00000000"
                    },
                    {
                        "id": 52050,
                        "name": "Asp’indzis Munitsip’alit’et’i",
                        "latitude": "41.50000000",
                        "longitude": "43.25000000"
                    },
                    {
                        "id": 52049,
                        "name": "Aspindza",
                        "latitude": "41.57389000",
                        "longitude": "43.24826000"
                    },
                    {
                        "id": 52052,
                        "name": "Bakuriani",
                        "latitude": "41.74972000",
                        "longitude": "43.53250000"
                    },
                    {
                        "id": 52057,
                        "name": "Borjomi",
                        "latitude": "41.85272000",
                        "longitude": "43.41284000"
                    },
                    {
                        "id": 52103,
                        "name": "Ninotsminda",
                        "latitude": "41.26458000",
                        "longitude": "43.59161000"
                    },
                    {
                        "id": 52131,
                        "name": "Tsaghveri",
                        "latitude": "41.80365000",
                        "longitude": "43.48194000"
                    },
                    {
                        "id": 52142,
                        "name": "Vale",
                        "latitude": "41.61558000",
                        "longitude": "42.87224000"
                    }
                ]
            },
            {
                "id": 903,
                "name": "Shida Kartli",
                "iso2": "SK",
                "latitude": "42.07569440",
                "longitude": "43.95404620",
                "type": "region",
                "cities": [
                    {
                        "id": 52038,
                        "name": "Agara",
                        "latitude": "42.03761000",
                        "longitude": "43.82382000"
                    },
                    {
                        "id": 52070,
                        "name": "Gori",
                        "latitude": "41.98422000",
                        "longitude": "44.11578000"
                    },
                    {
                        "id": 52071,
                        "name": "Goris Munitsip’alit’et’i",
                        "latitude": "42.06667000",
                        "longitude": "44.11667000"
                    },
                    {
                        "id": 52077,
                        "name": "Kaspi",
                        "latitude": "41.92520000",
                        "longitude": "44.42568000"
                    },
                    {
                        "id": 52080,
                        "name": "Khashuri",
                        "latitude": "41.99414000",
                        "longitude": "43.59994000"
                    },
                    {
                        "id": 52125,
                        "name": "Surami",
                        "latitude": "42.02431000",
                        "longitude": "43.55556000"
                    },
                    {
                        "id": 52139,
                        "name": "Ts’khinvali",
                        "latitude": "42.22764000",
                        "longitude": "43.96861000"
                    }
                ]
            },
            {
                "id": 899,
                "name": "Tbilisi",
                "iso2": "TB",
                "latitude": "41.71513770",
                "longitude": "44.82709600",
                "type": "city",
                "cities": [
                    {
                        "id": 52126,
                        "name": "Tbilisi",
                        "latitude": "41.69411000",
                        "longitude": "44.83368000"
                    }
                ]
            }
        ]
    },
    {
        "id": 82,
        "name": "Germany",
        "iso3": "DEU",
        "iso2": "DE",
        "numeric_code": "276",
        "phonecode": "49",
        "capital": "Berlin",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".de",
        "native": "Deutschland",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Western Europe",
        "subregion_id": 17,
        "nationality": "German",
        "timezones": [
            {
                "zoneName": "Europe\/Berlin",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            },
            {
                "zoneName": "Europe\/Busingen",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Alamagn",
            "ko": "독일",
            "pt-BR": "Alemanha",
            "pt": "Alemanha",
            "nl": "Duitsland",
            "hr": "Njemačka",
            "fa": "آلمان",
            "de": "Deutschland",
            "es": "Alemania",
            "fr": "Allemagne",
            "ja": "ドイツ",
            "it": "Germania",
            "zh-CN": "德国",
            "tr": "Almanya",
            "ru": "Германия",
            "uk": "Німеччина",
            "pl": "Niemcy"
        },
        "latitude": "51.00000000",
        "longitude": "9.00000000",
        "emoji": "🇩🇪",
        "emojiU": "U+1F1E9 U+1F1EA",
        "states": [
            {
                "id": 3006,
                "name": "Baden-Württemberg",
                "iso2": "BW",
                "latitude": "48.66160370",
                "longitude": "9.35013360",
                "type": "land",
                "cities": [
                    {
                        "id": 23461,
                        "name": "Aach",
                        "latitude": "47.84240000",
                        "longitude": "8.85384000"
                    },
                    {
                        "id": 23464,
                        "name": "Aalen",
                        "latitude": "48.83777000",
                        "longitude": "10.09330000"
                    },
                    {
                        "id": 23469,
                        "name": "Abstatt",
                        "latitude": "49.06820000",
                        "longitude": "9.29070000"
                    },
                    {
                        "id": 23471,
                        "name": "Abtsgmünd",
                        "latitude": "48.89503000",
                        "longitude": "10.00172000"
                    },
                    {
                        "id": 23472,
                        "name": "Achern",
                        "latitude": "48.63115000",
                        "longitude": "8.07607000"
                    },
                    {
                        "id": 23475,
                        "name": "Achstetten",
                        "latitude": "48.25886000",
                        "longitude": "9.89748000"
                    },
                    {
                        "id": 23477,
                        "name": "Adelberg",
                        "latitude": "48.76227000",
                        "longitude": "9.59991000"
                    },
                    {
                        "id": 23480,
                        "name": "Adelmannsfelden",
                        "latitude": "48.95476000",
                        "longitude": "10.00466000"
                    },
                    {
                        "id": 23482,
                        "name": "Adelsheim",
                        "latitude": "49.40150000",
                        "longitude": "9.39250000"
                    },
                    {
                        "id": 23495,
                        "name": "Affalterbach",
                        "latitude": "48.92267000",
                        "longitude": "9.32362000"
                    },
                    {
                        "id": 23498,
                        "name": "Aglasterhausen",
                        "latitude": "49.35694000",
                        "longitude": "8.98694000"
                    },
                    {
                        "id": 23517,
                        "name": "Aichelberg",
                        "latitude": "48.63557000",
                        "longitude": "9.56373000"
                    },
                    {
                        "id": 23519,
                        "name": "Aichhalden",
                        "latitude": "48.26719000",
                        "longitude": "8.40233000"
                    },
                    {
                        "id": 23520,
                        "name": "Aichstetten",
                        "latitude": "47.89295000",
                        "longitude": "10.07837000"
                    },
                    {
                        "id": 23523,
                        "name": "Aidlingen",
                        "latitude": "48.67849000",
                        "longitude": "8.89524000"
                    },
                    {
                        "id": 23528,
                        "name": "Aitrach",
                        "latitude": "47.93333000",
                        "longitude": "10.08333000"
                    },
                    {
                        "id": 23532,
                        "name": "Albbruck",
                        "latitude": "47.59077000",
                        "longitude": "8.12954000"
                    },
                    {
                        "id": 23534,
                        "name": "Albershausen",
                        "latitude": "48.69136000",
                        "longitude": "9.56493000"
                    },
                    {
                        "id": 23541,
                        "name": "Albstadt",
                        "latitude": "48.21644000",
                        "longitude": "9.02596000"
                    },
                    {
                        "id": 23544,
                        "name": "Aldingen",
                        "latitude": "48.10000000",
                        "longitude": "8.70000000"
                    },
                    {
                        "id": 23548,
                        "name": "Alfdorf",
                        "latitude": "48.84385000",
                        "longitude": "9.71857000"
                    },
                    {
                        "id": 23557,
                        "name": "Allensbach",
                        "latitude": "47.71536000",
                        "longitude": "9.07145000"
                    },
                    {
                        "id": 23561,
                        "name": "Allmendingen",
                        "latitude": "48.33052000",
                        "longitude": "9.72419000"
                    },
                    {
                        "id": 23562,
                        "name": "Allmersbach im Tal",
                        "latitude": "48.90659000",
                        "longitude": "9.46815000"
                    },
                    {
                        "id": 23566,
                        "name": "Alpirsbach",
                        "latitude": "48.34507000",
                        "longitude": "8.40197000"
                    },
                    {
                        "id": 23582,
                        "name": "Altbach",
                        "latitude": "48.72268000",
                        "longitude": "9.38078000"
                    },
                    {
                        "id": 23584,
                        "name": "Altdorf",
                        "latitude": "48.63112000",
                        "longitude": "8.99626000"
                    },
                    {
                        "id": 23612,
                        "name": "Altenriet",
                        "latitude": "48.59140000",
                        "longitude": "9.22186000"
                    },
                    {
                        "id": 23615,
                        "name": "Altensteig",
                        "latitude": "48.58649000",
                        "longitude": "8.60395000"
                    },
                    {
                        "id": 23619,
                        "name": "Altes Lager",
                        "latitude": "48.41755000",
                        "longitude": "9.53606000"
                    },
                    {
                        "id": 23623,
                        "name": "Althengstett",
                        "latitude": "48.72325000",
                        "longitude": "8.79434000"
                    },
                    {
                        "id": 23624,
                        "name": "Althütte",
                        "latitude": "48.91565000",
                        "longitude": "9.56984000"
                    },
                    {
                        "id": 23628,
                        "name": "Altlußheim",
                        "latitude": "49.30167000",
                        "longitude": "8.49917000"
                    },
                    {
                        "id": 23634,
                        "name": "Altshausen",
                        "latitude": "47.93333000",
                        "longitude": "9.53333000"
                    },
                    {
                        "id": 23650,
                        "name": "Amstetten",
                        "latitude": "48.57876000",
                        "longitude": "9.87388000"
                    },
                    {
                        "id": 23651,
                        "name": "Amtzell",
                        "latitude": "47.70000000",
                        "longitude": "9.75000000"
                    },
                    {
                        "id": 23710,
                        "name": "Aspach",
                        "latitude": "48.96667000",
                        "longitude": "9.40000000"
                    },
                    {
                        "id": 23711,
                        "name": "Asperg",
                        "latitude": "48.90525000",
                        "longitude": "9.13502000"
                    },
                    {
                        "id": 23712,
                        "name": "Assamstadt",
                        "latitude": "49.42806000",
                        "longitude": "9.68611000"
                    },
                    {
                        "id": 23713,
                        "name": "Asselfingen",
                        "latitude": "48.52959000",
                        "longitude": "10.19166000"
                    },
                    {
                        "id": 23717,
                        "name": "Attenweiler",
                        "latitude": "48.13333000",
                        "longitude": "9.70000000"
                    },
                    {
                        "id": 23720,
                        "name": "Au",
                        "latitude": "47.95000000",
                        "longitude": "7.83333000"
                    },
                    {
                        "id": 23721,
                        "name": "Au am Rhein",
                        "latitude": "48.95000000",
                        "longitude": "8.23333000"
                    },
                    {
                        "id": 23730,
                        "name": "Auggen",
                        "latitude": "47.78333000",
                        "longitude": "7.60000000"
                    },
                    {
                        "id": 23738,
                        "name": "Aulendorf",
                        "latitude": "47.95083000",
                        "longitude": "9.63745000"
                    },
                    {
                        "id": 23758,
                        "name": "Backnang",
                        "latitude": "48.94743000",
                        "longitude": "9.43718000"
                    },
                    {
                        "id": 23763,
                        "name": "Bad Bellingen",
                        "latitude": "47.73147000",
                        "longitude": "7.55756000"
                    },
                    {
                        "id": 23779,
                        "name": "Bad Buchau",
                        "latitude": "48.06231000",
                        "longitude": "9.61244000"
                    },
                    {
                        "id": 23781,
                        "name": "Bad Ditzenbach",
                        "latitude": "48.58830000",
                        "longitude": "9.70393000"
                    },
                    {
                        "id": 23787,
                        "name": "Bad Dürrheim",
                        "latitude": "48.02093000",
                        "longitude": "8.53056000"
                    },
                    {
                        "id": 23805,
                        "name": "Bad Herrenalb",
                        "latitude": "48.79787000",
                        "longitude": "8.43617000"
                    },
                    {
                        "id": 23830,
                        "name": "Bad Liebenzell",
                        "latitude": "48.77427000",
                        "longitude": "8.72971000"
                    },
                    {
                        "id": 23835,
                        "name": "Bad Mergentheim",
                        "latitude": "49.49250000",
                        "longitude": "9.77361000"
                    },
                    {
                        "id": 23847,
                        "name": "Bad Peterstal-Griesbach",
                        "latitude": "48.43333000",
                        "longitude": "8.21667000"
                    },
                    {
                        "id": 23849,
                        "name": "Bad Rappenau",
                        "latitude": "49.23848000",
                        "longitude": "9.10180000"
                    },
                    {
                        "id": 23851,
                        "name": "Bad Rippoldsau-Schapbach",
                        "latitude": "48.42883000",
                        "longitude": "8.32584000"
                    },
                    {
                        "id": 23874,
                        "name": "Bad Säckingen",
                        "latitude": "47.55371000",
                        "longitude": "7.94612000"
                    },
                    {
                        "id": 23863,
                        "name": "Bad Schussenried",
                        "latitude": "48.00468000",
                        "longitude": "9.65741000"
                    },
                    {
                        "id": 23876,
                        "name": "Bad Teinach-Zavelstein",
                        "latitude": "48.69051000",
                        "longitude": "8.69285000"
                    },
                    {
                        "id": 23891,
                        "name": "Bad Überkingen",
                        "latitude": "48.59991000",
                        "longitude": "9.79586000"
                    },
                    {
                        "id": 23879,
                        "name": "Bad Urach",
                        "latitude": "48.49107000",
                        "longitude": "9.40009000"
                    },
                    {
                        "id": 23881,
                        "name": "Bad Waldsee",
                        "latitude": "47.92027000",
                        "longitude": "9.75490000"
                    },
                    {
                        "id": 23883,
                        "name": "Bad Wildbad",
                        "latitude": "48.75071000",
                        "longitude": "8.55040000"
                    },
                    {
                        "id": 23886,
                        "name": "Bad Wimpfen",
                        "latitude": "49.22971000",
                        "longitude": "9.15648000"
                    },
                    {
                        "id": 23888,
                        "name": "Bad Wurzach",
                        "latitude": "47.90799000",
                        "longitude": "9.89686000"
                    },
                    {
                        "id": 23895,
                        "name": "Baden-Baden",
                        "latitude": "48.76060000",
                        "longitude": "8.23975000"
                    },
                    {
                        "id": 23897,
                        "name": "Badenweiler",
                        "latitude": "47.80223000",
                        "longitude": "7.67236000"
                    },
                    {
                        "id": 23899,
                        "name": "Bahlingen",
                        "latitude": "48.12064000",
                        "longitude": "7.73982000"
                    },
                    {
                        "id": 23902,
                        "name": "Baienfurt",
                        "latitude": "47.82857000",
                        "longitude": "9.65157000"
                    },
                    {
                        "id": 23904,
                        "name": "Baiersbronn",
                        "latitude": "48.50318000",
                        "longitude": "8.37699000"
                    },
                    {
                        "id": 23906,
                        "name": "Baindt",
                        "latitude": "47.85000000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 23910,
                        "name": "Balingen",
                        "latitude": "48.27525000",
                        "longitude": "8.85464000"
                    },
                    {
                        "id": 23913,
                        "name": "Baltmannsweiler",
                        "latitude": "48.74215000",
                        "longitude": "9.44940000"
                    },
                    {
                        "id": 23915,
                        "name": "Balzfeld",
                        "latitude": "49.26892000",
                        "longitude": "8.78919000"
                    },
                    {
                        "id": 23919,
                        "name": "Bammental",
                        "latitude": "49.35611000",
                        "longitude": "8.77944000"
                    },
                    {
                        "id": 23945,
                        "name": "Bartholomä",
                        "latitude": "48.75350000",
                        "longitude": "9.98752000"
                    },
                    {
                        "id": 23995,
                        "name": "Beilstein",
                        "latitude": "49.04140000",
                        "longitude": "9.31370000"
                    },
                    {
                        "id": 23996,
                        "name": "Beimerstetten",
                        "latitude": "48.48333000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 24006,
                        "name": "Bempflingen",
                        "latitude": "48.57178000",
                        "longitude": "9.26834000"
                    },
                    {
                        "id": 24014,
                        "name": "Benningen am Neckar",
                        "latitude": "48.94672000",
                        "longitude": "9.24212000"
                    },
                    {
                        "id": 24030,
                        "name": "Bergatreute",
                        "latitude": "47.85000000",
                        "longitude": "9.75000000"
                    },
                    {
                        "id": 24038,
                        "name": "Berghaupten",
                        "latitude": "48.40602000",
                        "longitude": "7.98672000"
                    },
                    {
                        "id": 24040,
                        "name": "Berghülen",
                        "latitude": "48.46399000",
                        "longitude": "9.76110000"
                    },
                    {
                        "id": 24052,
                        "name": "Berkheim",
                        "latitude": "48.04263000",
                        "longitude": "10.08227000"
                    },
                    {
                        "id": 24058,
                        "name": "Bermatingen",
                        "latitude": "47.73333000",
                        "longitude": "9.35000000"
                    },
                    {
                        "id": 24059,
                        "name": "Bernau",
                        "latitude": "47.80018000",
                        "longitude": "8.03830000"
                    },
                    {
                        "id": 24072,
                        "name": "Bernstadt",
                        "latitude": "48.49957000",
                        "longitude": "10.02575000"
                    },
                    {
                        "id": 24078,
                        "name": "Besigheim",
                        "latitude": "48.99797000",
                        "longitude": "9.14268000"
                    },
                    {
                        "id": 24088,
                        "name": "Beuren",
                        "latitude": "48.56927000",
                        "longitude": "9.40406000"
                    },
                    {
                        "id": 24095,
                        "name": "Biberach",
                        "latitude": "48.61008000",
                        "longitude": "8.27704000"
                    },
                    {
                        "id": 24096,
                        "name": "Biberach an der Riß",
                        "latitude": "48.09345000",
                        "longitude": "9.79053000"
                    },
                    {
                        "id": 24114,
                        "name": "Bietigheim",
                        "latitude": "48.90919000",
                        "longitude": "8.25202000"
                    },
                    {
                        "id": 24115,
                        "name": "Bietigheim-Bissingen",
                        "latitude": "48.94407000",
                        "longitude": "9.11755000"
                    },
                    {
                        "id": 24118,
                        "name": "Billigheim",
                        "latitude": "49.34861000",
                        "longitude": "9.25389000"
                    },
                    {
                        "id": 24121,
                        "name": "Binau",
                        "latitude": "49.36833000",
                        "longitude": "9.05806000"
                    },
                    {
                        "id": 24123,
                        "name": "Bingen",
                        "latitude": "48.11127000",
                        "longitude": "9.27238000"
                    },
                    {
                        "id": 24128,
                        "name": "Binzen",
                        "latitude": "47.63333000",
                        "longitude": "7.61667000"
                    },
                    {
                        "id": 24130,
                        "name": "Birenbach",
                        "latitude": "48.74732000",
                        "longitude": "9.66115000"
                    },
                    {
                        "id": 24134,
                        "name": "Birkenfeld",
                        "latitude": "48.86667000",
                        "longitude": "8.63333000"
                    },
                    {
                        "id": 24152,
                        "name": "Bischweier",
                        "latitude": "48.83766000",
                        "longitude": "8.28412000"
                    },
                    {
                        "id": 24153,
                        "name": "Bisingen",
                        "latitude": "48.31012000",
                        "longitude": "8.91738000"
                    },
                    {
                        "id": 24158,
                        "name": "Bissingen an der Teck",
                        "latitude": "48.59915000",
                        "longitude": "9.49146000"
                    },
                    {
                        "id": 24161,
                        "name": "Bitz",
                        "latitude": "48.24400000",
                        "longitude": "9.09144000"
                    },
                    {
                        "id": 24173,
                        "name": "Blaubeuren",
                        "latitude": "48.41215000",
                        "longitude": "9.78427000"
                    },
                    {
                        "id": 24174,
                        "name": "Blaufelden",
                        "latitude": "49.29778000",
                        "longitude": "9.97389000"
                    },
                    {
                        "id": 24187,
                        "name": "Blumberg",
                        "latitude": "47.84058000",
                        "longitude": "8.53329000"
                    },
                    {
                        "id": 24462,
                        "name": "Böbingen an der Rems",
                        "latitude": "48.81955000",
                        "longitude": "9.92130000"
                    },
                    {
                        "id": 24463,
                        "name": "Böblingen",
                        "latitude": "48.68212000",
                        "longitude": "9.01171000"
                    },
                    {
                        "id": 24203,
                        "name": "Bodelshausen",
                        "latitude": "48.38886000",
                        "longitude": "8.97703000"
                    },
                    {
                        "id": 24210,
                        "name": "Bodman-Ludwigshafen",
                        "latitude": "47.81817000",
                        "longitude": "9.05540000"
                    },
                    {
                        "id": 24211,
                        "name": "Bodnegg",
                        "latitude": "47.71014000",
                        "longitude": "9.68841000"
                    },
                    {
                        "id": 24467,
                        "name": "Böhmenkirch",
                        "latitude": "48.68333000",
                        "longitude": "9.93333000"
                    },
                    {
                        "id": 24222,
                        "name": "Bolheim",
                        "latitude": "48.63141000",
                        "longitude": "10.14995000"
                    },
                    {
                        "id": 24223,
                        "name": "Boll",
                        "latitude": "48.64357000",
                        "longitude": "9.61295000"
                    },
                    {
                        "id": 24226,
                        "name": "Bollschweil",
                        "latitude": "47.92143000",
                        "longitude": "7.78986000"
                    },
                    {
                        "id": 24229,
                        "name": "Bondorf",
                        "latitude": "48.52064000",
                        "longitude": "8.83704000"
                    },
                    {
                        "id": 24232,
                        "name": "Bonndorf",
                        "latitude": "47.81863000",
                        "longitude": "8.34139000"
                    },
                    {
                        "id": 24470,
                        "name": "Bönnigheim",
                        "latitude": "49.04018000",
                        "longitude": "9.09386000"
                    },
                    {
                        "id": 24236,
                        "name": "Bopfingen",
                        "latitude": "48.85847000",
                        "longitude": "10.35417000"
                    },
                    {
                        "id": 24476,
                        "name": "Börtlingen",
                        "latitude": "48.75376000",
                        "longitude": "9.63181000"
                    },
                    {
                        "id": 24481,
                        "name": "Bösingen",
                        "latitude": "48.23333000",
                        "longitude": "8.55000000"
                    },
                    {
                        "id": 24483,
                        "name": "Böttingen",
                        "latitude": "48.10000000",
                        "longitude": "8.80000000"
                    },
                    {
                        "id": 24484,
                        "name": "Bötzingen",
                        "latitude": "48.07642000",
                        "longitude": "7.72485000"
                    },
                    {
                        "id": 24268,
                        "name": "Boxberg",
                        "latitude": "49.47965000",
                        "longitude": "9.64006000"
                    },
                    {
                        "id": 24271,
                        "name": "Brackenheim",
                        "latitude": "49.07787000",
                        "longitude": "9.06601000"
                    },
                    {
                        "id": 24364,
                        "name": "Bräunlingen",
                        "latitude": "47.92957000",
                        "longitude": "8.44806000"
                    },
                    {
                        "id": 24289,
                        "name": "Braunsbach",
                        "latitude": "49.19917000",
                        "longitude": "9.79056000"
                    },
                    {
                        "id": 24302,
                        "name": "Breisach am Rhein",
                        "latitude": "48.03279000",
                        "longitude": "7.58294000"
                    },
                    {
                        "id": 24314,
                        "name": "Breitnau",
                        "latitude": "47.93333000",
                        "longitude": "8.08333000"
                    },
                    {
                        "id": 24325,
                        "name": "Bretten",
                        "latitude": "49.03685000",
                        "longitude": "8.70745000"
                    },
                    {
                        "id": 24327,
                        "name": "Bretzfeld",
                        "latitude": "49.17944000",
                        "longitude": "9.43833000"
                    },
                    {
                        "id": 24351,
                        "name": "Bruchsal",
                        "latitude": "49.12426000",
                        "longitude": "8.59804000"
                    },
                    {
                        "id": 24371,
                        "name": "Brühl",
                        "latitude": "49.39722000",
                        "longitude": "8.53361000"
                    },
                    {
                        "id": 24377,
                        "name": "Bubsheim",
                        "latitude": "48.11667000",
                        "longitude": "8.83333000"
                    },
                    {
                        "id": 24380,
                        "name": "Buch am Ahorn",
                        "latitude": "49.53909000",
                        "longitude": "9.55560000"
                    },
                    {
                        "id": 24386,
                        "name": "Buchen in Odenwald",
                        "latitude": "49.52416000",
                        "longitude": "9.32293000"
                    },
                    {
                        "id": 24387,
                        "name": "Buchenbach",
                        "latitude": "47.96138000",
                        "longitude": "8.00909000"
                    },
                    {
                        "id": 24400,
                        "name": "Buggingen",
                        "latitude": "47.84750000",
                        "longitude": "7.63799000"
                    },
                    {
                        "id": 24495,
                        "name": "Bühl",
                        "latitude": "48.69676000",
                        "longitude": "8.13523000"
                    },
                    {
                        "id": 24496,
                        "name": "Bühlertal",
                        "latitude": "48.68569000",
                        "longitude": "8.18876000"
                    },
                    {
                        "id": 24497,
                        "name": "Bühlertann",
                        "latitude": "49.04167000",
                        "longitude": "9.90861000"
                    },
                    {
                        "id": 24498,
                        "name": "Bühlerzell",
                        "latitude": "49.00333000",
                        "longitude": "9.92056000"
                    },
                    {
                        "id": 24429,
                        "name": "Burgrieden",
                        "latitude": "48.23333000",
                        "longitude": "9.93333000"
                    },
                    {
                        "id": 24434,
                        "name": "Burgstetten",
                        "latitude": "48.92805000",
                        "longitude": "9.37239000"
                    },
                    {
                        "id": 24443,
                        "name": "Burladingen",
                        "latitude": "48.29111000",
                        "longitude": "9.11286000"
                    },
                    {
                        "id": 24505,
                        "name": "Büsingen",
                        "latitude": "47.69638000",
                        "longitude": "8.68759000"
                    },
                    {
                        "id": 24519,
                        "name": "Calw",
                        "latitude": "48.71419000",
                        "longitude": "8.74031000"
                    },
                    {
                        "id": 24540,
                        "name": "Cleebronn",
                        "latitude": "49.04500000",
                        "longitude": "9.03694000"
                    },
                    {
                        "id": 24557,
                        "name": "Crailsheim",
                        "latitude": "49.13444000",
                        "longitude": "10.07193000"
                    },
                    {
                        "id": 24559,
                        "name": "Creglingen",
                        "latitude": "49.46937000",
                        "longitude": "10.03119000"
                    },
                    {
                        "id": 24585,
                        "name": "Daisendorf",
                        "latitude": "47.71265000",
                        "longitude": "9.26783000"
                    },
                    {
                        "id": 24604,
                        "name": "Dauchingen",
                        "latitude": "48.08993000",
                        "longitude": "8.55011000"
                    },
                    {
                        "id": 24607,
                        "name": "Deckenpfronn",
                        "latitude": "48.65128000",
                        "longitude": "8.82417000"
                    },
                    {
                        "id": 24611,
                        "name": "Deggingen",
                        "latitude": "48.59710000",
                        "longitude": "9.71891000"
                    },
                    {
                        "id": 24614,
                        "name": "Deilingen",
                        "latitude": "48.17410000",
                        "longitude": "8.78533000"
                    },
                    {
                        "id": 24620,
                        "name": "Deißlingen",
                        "latitude": "48.11230000",
                        "longitude": "8.60736000"
                    },
                    {
                        "id": 24619,
                        "name": "Deizisau",
                        "latitude": "48.71220000",
                        "longitude": "9.38610000"
                    },
                    {
                        "id": 24630,
                        "name": "Denkendorf",
                        "latitude": "48.69555000",
                        "longitude": "9.31675000"
                    },
                    {
                        "id": 24631,
                        "name": "Denkingen",
                        "latitude": "48.11110000",
                        "longitude": "8.73820000"
                    },
                    {
                        "id": 24635,
                        "name": "Denzlingen",
                        "latitude": "48.06667000",
                        "longitude": "7.88333000"
                    },
                    {
                        "id": 24649,
                        "name": "Dettenhausen",
                        "latitude": "48.60758000",
                        "longitude": "9.10041000"
                    },
                    {
                        "id": 24650,
                        "name": "Dettighofen",
                        "latitude": "47.62333000",
                        "longitude": "8.48512000"
                    },
                    {
                        "id": 24651,
                        "name": "Dettingen",
                        "latitude": "48.26246000",
                        "longitude": "9.72161000"
                    },
                    {
                        "id": 24652,
                        "name": "Dettingen an der Erms",
                        "latitude": "48.53077000",
                        "longitude": "9.34458000"
                    },
                    {
                        "id": 24653,
                        "name": "Dettingen unter Teck",
                        "latitude": "48.61667000",
                        "longitude": "9.45000000"
                    },
                    {
                        "id": 24668,
                        "name": "Dielheim",
                        "latitude": "49.28417000",
                        "longitude": "8.73806000"
                    },
                    {
                        "id": 24677,
                        "name": "Dietenheim",
                        "latitude": "48.21072000",
                        "longitude": "10.07163000"
                    },
                    {
                        "id": 24683,
                        "name": "Dietingen",
                        "latitude": "48.20480000",
                        "longitude": "8.64864000"
                    },
                    {
                        "id": 24704,
                        "name": "Dischingen",
                        "latitude": "48.70000000",
                        "longitude": "10.36667000"
                    },
                    {
                        "id": 24710,
                        "name": "Ditzingen",
                        "latitude": "48.82672000",
                        "longitude": "9.06703000"
                    },
                    {
                        "id": 24712,
                        "name": "Dobel",
                        "latitude": "48.80000000",
                        "longitude": "8.50000000"
                    },
                    {
                        "id": 24717,
                        "name": "Dogern",
                        "latitude": "47.60952000",
                        "longitude": "8.16713000"
                    },
                    {
                        "id": 24729,
                        "name": "Donaueschingen",
                        "latitude": "47.95514000",
                        "longitude": "8.49707000"
                    },
                    {
                        "id": 24733,
                        "name": "Donzdorf",
                        "latitude": "48.68544000",
                        "longitude": "9.81053000"
                    },
                    {
                        "id": 24739,
                        "name": "Dormettingen",
                        "latitude": "48.23688000",
                        "longitude": "8.77327000"
                    },
                    {
                        "id": 24742,
                        "name": "Dornhan",
                        "latitude": "48.35008000",
                        "longitude": "8.50901000"
                    },
                    {
                        "id": 24743,
                        "name": "Dornstadt",
                        "latitude": "48.46697000",
                        "longitude": "9.94434000"
                    },
                    {
                        "id": 24744,
                        "name": "Dornstetten",
                        "latitude": "48.47198000",
                        "longitude": "8.49817000"
                    },
                    {
                        "id": 24803,
                        "name": "Dörzbach",
                        "latitude": "49.38355000",
                        "longitude": "9.70732000"
                    },
                    {
                        "id": 24749,
                        "name": "Dossenheim",
                        "latitude": "49.45028000",
                        "longitude": "8.67472000"
                    },
                    {
                        "id": 24750,
                        "name": "Dotternhausen",
                        "latitude": "48.22848000",
                        "longitude": "8.79228000"
                    },
                    {
                        "id": 24782,
                        "name": "Dunningen",
                        "latitude": "48.21242000",
                        "longitude": "8.50619000"
                    },
                    {
                        "id": 24785,
                        "name": "Durbach",
                        "latitude": "48.49352000",
                        "longitude": "8.01736000"
                    },
                    {
                        "id": 24809,
                        "name": "Dürbheim",
                        "latitude": "48.05623000",
                        "longitude": "8.79344000"
                    },
                    {
                        "id": 24786,
                        "name": "Durlangen",
                        "latitude": "48.85632000",
                        "longitude": "9.79654000"
                    },
                    {
                        "id": 24811,
                        "name": "Dürmentingen",
                        "latitude": "48.11667000",
                        "longitude": "9.53333000"
                    },
                    {
                        "id": 24787,
                        "name": "Durmersheim",
                        "latitude": "48.93333000",
                        "longitude": "8.26667000"
                    },
                    {
                        "id": 24812,
                        "name": "Dürnau",
                        "latitude": "48.64079000",
                        "longitude": "9.63544000"
                    },
                    {
                        "id": 24789,
                        "name": "Dußlingen",
                        "latitude": "48.45357000",
                        "longitude": "9.05552000"
                    },
                    {
                        "id": 24824,
                        "name": "Ebenweiler",
                        "latitude": "47.90000000",
                        "longitude": "9.51667000"
                    },
                    {
                        "id": 24825,
                        "name": "Eberbach",
                        "latitude": "49.46680000",
                        "longitude": "8.99016000"
                    },
                    {
                        "id": 24826,
                        "name": "Eberdingen",
                        "latitude": "48.87942000",
                        "longitude": "8.96502000"
                    },
                    {
                        "id": 24828,
                        "name": "Eberhardzell",
                        "latitude": "48.00000000",
                        "longitude": "9.81667000"
                    },
                    {
                        "id": 24833,
                        "name": "Ebersbach an der Fils",
                        "latitude": "48.71600000",
                        "longitude": "9.52360000"
                    },
                    {
                        "id": 24834,
                        "name": "Ebersbach-Musbach",
                        "latitude": "47.96667000",
                        "longitude": "9.58333000"
                    },
                    {
                        "id": 24838,
                        "name": "Eberstadt",
                        "latitude": "49.18028000",
                        "longitude": "9.32111000"
                    },
                    {
                        "id": 24841,
                        "name": "Ebhausen",
                        "latitude": "48.58333000",
                        "longitude": "8.68333000"
                    },
                    {
                        "id": 24843,
                        "name": "Ebringen",
                        "latitude": "47.95780000",
                        "longitude": "7.77652000"
                    },
                    {
                        "id": 24861,
                        "name": "Edingen-Neckarhausen",
                        "latitude": "49.45722000",
                        "longitude": "8.60639000"
                    },
                    {
                        "id": 24864,
                        "name": "Efringen-Kirchen",
                        "latitude": "47.65000000",
                        "longitude": "7.56667000"
                    },
                    {
                        "id": 24867,
                        "name": "Egenhausen",
                        "latitude": "48.56667000",
                        "longitude": "8.61667000"
                    },
                    {
                        "id": 24873,
                        "name": "Eggenstein-Leopoldshafen",
                        "latitude": "49.09006000",
                        "longitude": "8.39879000"
                    },
                    {
                        "id": 24878,
                        "name": "Eggingen",
                        "latitude": "47.70000000",
                        "longitude": "8.40000000"
                    },
                    {
                        "id": 24888,
                        "name": "Ehingen",
                        "latitude": "48.28259000",
                        "longitude": "9.72749000"
                    },
                    {
                        "id": 24891,
                        "name": "Ehningen",
                        "latitude": "48.65882000",
                        "longitude": "8.94124000"
                    },
                    {
                        "id": 24905,
                        "name": "Eichstetten",
                        "latitude": "48.09427000",
                        "longitude": "7.74244000"
                    },
                    {
                        "id": 24911,
                        "name": "Eigeltingen",
                        "latitude": "47.85802000",
                        "longitude": "8.89784000"
                    },
                    {
                        "id": 24916,
                        "name": "Eimeldingen",
                        "latitude": "47.63333000",
                        "longitude": "7.60000000"
                    },
                    {
                        "id": 24925,
                        "name": "Eisenbach",
                        "latitude": "47.96117000",
                        "longitude": "8.26802000"
                    },
                    {
                        "id": 24931,
                        "name": "Eisingen",
                        "latitude": "48.95000000",
                        "longitude": "8.66667000"
                    },
                    {
                        "id": 24934,
                        "name": "Eislingen",
                        "latitude": "48.69515000",
                        "longitude": "9.70676000"
                    },
                    {
                        "id": 24947,
                        "name": "Ellenberg",
                        "latitude": "49.01667000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 24953,
                        "name": "Ellhofen",
                        "latitude": "49.14667000",
                        "longitude": "9.32194000"
                    },
                    {
                        "id": 24956,
                        "name": "Ellwangen",
                        "latitude": "48.96164000",
                        "longitude": "10.13173000"
                    },
                    {
                        "id": 24979,
                        "name": "Elzach",
                        "latitude": "48.17247000",
                        "longitude": "8.06992000"
                    },
                    {
                        "id": 24988,
                        "name": "Emmendingen",
                        "latitude": "48.12096000",
                        "longitude": "7.85359000"
                    },
                    {
                        "id": 24991,
                        "name": "Emmingen-Liptingen",
                        "latitude": "47.93333000",
                        "longitude": "8.88333000"
                    },
                    {
                        "id": 24992,
                        "name": "Empfingen",
                        "latitude": "48.39258000",
                        "longitude": "8.71036000"
                    },
                    {
                        "id": 24999,
                        "name": "Endingen",
                        "latitude": "48.14221000",
                        "longitude": "7.70049000"
                    },
                    {
                        "id": 25002,
                        "name": "Engelsbrand",
                        "latitude": "48.83333000",
                        "longitude": "8.65000000"
                    },
                    {
                        "id": 25005,
                        "name": "Engen",
                        "latitude": "47.85534000",
                        "longitude": "8.77342000"
                    },
                    {
                        "id": 25007,
                        "name": "Eningen unter Achalm",
                        "latitude": "48.48686000",
                        "longitude": "9.25946000"
                    },
                    {
                        "id": 25011,
                        "name": "Ennetach",
                        "latitude": "48.05238000",
                        "longitude": "9.32010000"
                    },
                    {
                        "id": 25015,
                        "name": "Enzklösterle",
                        "latitude": "48.66638000",
                        "longitude": "8.47083000"
                    },
                    {
                        "id": 25016,
                        "name": "Epfenbach",
                        "latitude": "49.33917000",
                        "longitude": "8.90778000"
                    },
                    {
                        "id": 25017,
                        "name": "Epfendorf",
                        "latitude": "48.25000000",
                        "longitude": "8.60000000"
                    },
                    {
                        "id": 25019,
                        "name": "Eppelheim",
                        "latitude": "49.40190000",
                        "longitude": "8.63644000"
                    },
                    {
                        "id": 25024,
                        "name": "Eppingen",
                        "latitude": "49.13645000",
                        "longitude": "8.91229000"
                    },
                    {
                        "id": 25028,
                        "name": "Erbach",
                        "latitude": "48.32841000",
                        "longitude": "9.88752000"
                    },
                    {
                        "id": 25033,
                        "name": "Erdmannhausen",
                        "latitude": "48.94256000",
                        "longitude": "9.29615000"
                    },
                    {
                        "id": 25044,
                        "name": "Eriskirch",
                        "latitude": "47.62479000",
                        "longitude": "9.54197000"
                    },
                    {
                        "id": 25046,
                        "name": "Erkenbrechtsweiler",
                        "latitude": "48.55656000",
                        "longitude": "9.43211000"
                    },
                    {
                        "id": 25057,
                        "name": "Erlenbach",
                        "latitude": "49.17250000",
                        "longitude": "9.26833000"
                    },
                    {
                        "id": 25059,
                        "name": "Erlenmoos",
                        "latitude": "48.06530000",
                        "longitude": "9.97567000"
                    },
                    {
                        "id": 25061,
                        "name": "Erligheim",
                        "latitude": "49.02250000",
                        "longitude": "9.09722000"
                    },
                    {
                        "id": 25066,
                        "name": "Erolzheim",
                        "latitude": "48.09001000",
                        "longitude": "10.07300000"
                    },
                    {
                        "id": 25069,
                        "name": "Ersingen",
                        "latitude": "48.29260000",
                        "longitude": "9.85510000"
                    },
                    {
                        "id": 25070,
                        "name": "Ertingen",
                        "latitude": "48.10000000",
                        "longitude": "9.46667000"
                    },
                    {
                        "id": 25074,
                        "name": "Eschach",
                        "latitude": "48.88832000",
                        "longitude": "9.86999000"
                    },
                    {
                        "id": 25079,
                        "name": "Eschelbronn",
                        "latitude": "49.31944000",
                        "longitude": "8.86528000"
                    },
                    {
                        "id": 25080,
                        "name": "Eschenbach",
                        "latitude": "48.65264000",
                        "longitude": "9.67037000"
                    },
                    {
                        "id": 25099,
                        "name": "Essingen",
                        "latitude": "48.80859000",
                        "longitude": "10.02773000"
                    },
                    {
                        "id": 25101,
                        "name": "Esslingen",
                        "latitude": "48.73961000",
                        "longitude": "9.30473000"
                    },
                    {
                        "id": 25106,
                        "name": "Ettenheim",
                        "latitude": "48.25696000",
                        "longitude": "7.81247000"
                    },
                    {
                        "id": 25107,
                        "name": "Ettlingen",
                        "latitude": "48.94094000",
                        "longitude": "8.40763000"
                    },
                    {
                        "id": 25118,
                        "name": "Eutingen an der Enz",
                        "latitude": "48.91246000",
                        "longitude": "8.74898000"
                    },
                    {
                        "id": 25127,
                        "name": "Fahrenbach",
                        "latitude": "49.43139000",
                        "longitude": "9.15056000"
                    },
                    {
                        "id": 25153,
                        "name": "Feldberg",
                        "latitude": "47.77435000",
                        "longitude": "7.64142000"
                    },
                    {
                        "id": 25159,
                        "name": "Fellbach",
                        "latitude": "48.80912000",
                        "longitude": "9.27697000"
                    },
                    {
                        "id": 25168,
                        "name": "Fichtenberg",
                        "latitude": "48.98601000",
                        "longitude": "9.71199000"
                    },
                    {
                        "id": 25170,
                        "name": "Filderstadt",
                        "latitude": "48.65698000",
                        "longitude": "9.22049000"
                    },
                    {
                        "id": 25181,
                        "name": "Fischerbach",
                        "latitude": "48.28687000",
                        "longitude": "8.10959000"
                    },
                    {
                        "id": 25188,
                        "name": "Flein",
                        "latitude": "49.10306000",
                        "longitude": "9.21083000"
                    },
                    {
                        "id": 25203,
                        "name": "Forbach",
                        "latitude": "48.68333000",
                        "longitude": "8.35000000"
                    },
                    {
                        "id": 25205,
                        "name": "Forchheim",
                        "latitude": "48.16667000",
                        "longitude": "7.70000000"
                    },
                    {
                        "id": 25206,
                        "name": "Forchtenberg",
                        "latitude": "49.28867000",
                        "longitude": "9.56026000"
                    },
                    {
                        "id": 25208,
                        "name": "Forst",
                        "latitude": "49.15861000",
                        "longitude": "8.58083000"
                    },
                    {
                        "id": 25239,
                        "name": "Freiberg am Neckar",
                        "latitude": "48.93196000",
                        "longitude": "9.20240000"
                    },
                    {
                        "id": 25240,
                        "name": "Freiburg",
                        "latitude": "47.99590000",
                        "longitude": "7.85222000"
                    },
                    {
                        "id": 25242,
                        "name": "Freiburg Region",
                        "latitude": "48.16667000",
                        "longitude": "8.33333000"
                    },
                    {
                        "id": 25258,
                        "name": "Freudenberg",
                        "latitude": "49.75349000",
                        "longitude": "9.32748000"
                    },
                    {
                        "id": 25260,
                        "name": "Freudenstadt",
                        "latitude": "48.46695000",
                        "longitude": "8.41371000"
                    },
                    {
                        "id": 25261,
                        "name": "Freudental",
                        "latitude": "49.00972000",
                        "longitude": "9.05917000"
                    },
                    {
                        "id": 25266,
                        "name": "Frickenhausen",
                        "latitude": "48.59353000",
                        "longitude": "9.36005000"
                    },
                    {
                        "id": 25267,
                        "name": "Frickingen",
                        "latitude": "47.81438000",
                        "longitude": "9.27349000"
                    },
                    {
                        "id": 25268,
                        "name": "Fridingen an der Donau",
                        "latitude": "48.01955000",
                        "longitude": "8.92322000"
                    },
                    {
                        "id": 25276,
                        "name": "Friedenweiler",
                        "latitude": "47.91778000",
                        "longitude": "8.25627000"
                    },
                    {
                        "id": 25288,
                        "name": "Friedrichshafen",
                        "latitude": "47.65689000",
                        "longitude": "9.47554000"
                    },
                    {
                        "id": 25301,
                        "name": "Friolzheim",
                        "latitude": "48.83333000",
                        "longitude": "8.83333000"
                    },
                    {
                        "id": 25302,
                        "name": "Frittlingen",
                        "latitude": "48.12709000",
                        "longitude": "8.70774000"
                    },
                    {
                        "id": 25307,
                        "name": "Fronreute",
                        "latitude": "47.87053000",
                        "longitude": "9.56944000"
                    },
                    {
                        "id": 25329,
                        "name": "Fürstenberg",
                        "latitude": "47.67895000",
                        "longitude": "9.15535000"
                    },
                    {
                        "id": 25319,
                        "name": "Furtwangen",
                        "latitude": "48.05156000",
                        "longitude": "8.20715000"
                    },
                    {
                        "id": 25345,
                        "name": "Gaggenau",
                        "latitude": "48.80000000",
                        "longitude": "8.33333000"
                    },
                    {
                        "id": 25346,
                        "name": "Gaiberg",
                        "latitude": "49.36639000",
                        "longitude": "8.74972000"
                    },
                    {
                        "id": 25347,
                        "name": "Gaienhofen",
                        "latitude": "47.68333000",
                        "longitude": "8.98333000"
                    },
                    {
                        "id": 25348,
                        "name": "Gaildorf",
                        "latitude": "49.00027000",
                        "longitude": "9.76953000"
                    },
                    {
                        "id": 25349,
                        "name": "Gailingen",
                        "latitude": "47.69711000",
                        "longitude": "8.75567000"
                    },
                    {
                        "id": 25354,
                        "name": "Gammelshausen",
                        "latitude": "48.64023000",
                        "longitude": "9.65072000"
                    },
                    {
                        "id": 25355,
                        "name": "Gammertingen",
                        "latitude": "48.25240000",
                        "longitude": "9.22349000"
                    },
                    {
                        "id": 25774,
                        "name": "Gärtringen",
                        "latitude": "48.64176000",
                        "longitude": "8.90073000"
                    },
                    {
                        "id": 25387,
                        "name": "Gechingen",
                        "latitude": "48.69527000",
                        "longitude": "8.82915000"
                    },
                    {
                        "id": 25405,
                        "name": "Geisingen",
                        "latitude": "47.92504000",
                        "longitude": "8.65002000"
                    },
                    {
                        "id": 25407,
                        "name": "Geislingen",
                        "latitude": "48.28768000",
                        "longitude": "8.81241000"
                    },
                    {
                        "id": 25408,
                        "name": "Geislingen an der Steige",
                        "latitude": "48.62423000",
                        "longitude": "9.82736000"
                    },
                    {
                        "id": 25420,
                        "name": "Gemmingen",
                        "latitude": "49.15639000",
                        "longitude": "8.98194000"
                    },
                    {
                        "id": 25421,
                        "name": "Gemmrigheim",
                        "latitude": "49.02833000",
                        "longitude": "9.15556000"
                    },
                    {
                        "id": 25426,
                        "name": "Gengenbach",
                        "latitude": "48.40476000",
                        "longitude": "8.01433000"
                    },
                    {
                        "id": 25436,
                        "name": "Gerabronn",
                        "latitude": "48.97071000",
                        "longitude": "9.91986000"
                    },
                    {
                        "id": 25444,
                        "name": "Gerlingen",
                        "latitude": "48.79954000",
                        "longitude": "9.06316000"
                    },
                    {
                        "id": 25449,
                        "name": "Gernsbach",
                        "latitude": "48.77034000",
                        "longitude": "8.34306000"
                    },
                    {
                        "id": 25462,
                        "name": "Gerstetten",
                        "latitude": "48.62254000",
                        "longitude": "10.01984000"
                    },
                    {
                        "id": 25484,
                        "name": "Giengen an der Brenz",
                        "latitude": "48.62219000",
                        "longitude": "10.24312000"
                    },
                    {
                        "id": 25494,
                        "name": "Gingen an der Fils",
                        "latitude": "48.65979000",
                        "longitude": "9.78092000"
                    },
                    {
                        "id": 25507,
                        "name": "Glatten",
                        "latitude": "48.44246000",
                        "longitude": "8.51116000"
                    },
                    {
                        "id": 25776,
                        "name": "Göggingen",
                        "latitude": "48.86123000",
                        "longitude": "9.88398000"
                    },
                    {
                        "id": 25537,
                        "name": "Gomadingen",
                        "latitude": "48.39980000",
                        "longitude": "9.39065000"
                    },
                    {
                        "id": 25538,
                        "name": "Gomaringen",
                        "latitude": "48.45349000",
                        "longitude": "9.09582000"
                    },
                    {
                        "id": 25541,
                        "name": "Gondelsheim",
                        "latitude": "49.05917000",
                        "longitude": "8.65833000"
                    },
                    {
                        "id": 25779,
                        "name": "Göppingen",
                        "latitude": "48.70354000",
                        "longitude": "9.65209000"
                    },
                    {
                        "id": 25784,
                        "name": "Görwihl",
                        "latitude": "47.64275000",
                        "longitude": "8.07482000"
                    },
                    {
                        "id": 25546,
                        "name": "Gosheim",
                        "latitude": "48.13430000",
                        "longitude": "8.75426000"
                    },
                    {
                        "id": 25550,
                        "name": "Gottenheim",
                        "latitude": "48.05000000",
                        "longitude": "7.73333000"
                    },
                    {
                        "id": 25553,
                        "name": "Gottmadingen",
                        "latitude": "47.73511000",
                        "longitude": "8.77687000"
                    },
                    {
                        "id": 25556,
                        "name": "Graben-Neudorf",
                        "latitude": "49.16695000",
                        "longitude": "8.49243000"
                    },
                    {
                        "id": 25557,
                        "name": "Grabenstetten",
                        "latitude": "48.52397000",
                        "longitude": "9.46155000"
                    },
                    {
                        "id": 25563,
                        "name": "Grafenau",
                        "latitude": "48.71427000",
                        "longitude": "8.91219000"
                    },
                    {
                        "id": 25565,
                        "name": "Grafenhausen",
                        "latitude": "48.28427000",
                        "longitude": "7.76678000"
                    },
                    {
                        "id": 25588,
                        "name": "Greffern",
                        "latitude": "48.75205000",
                        "longitude": "8.00515000"
                    },
                    {
                        "id": 25599,
                        "name": "Grenzach-Wyhlen",
                        "latitude": "47.55000000",
                        "longitude": "7.68333000"
                    },
                    {
                        "id": 25654,
                        "name": "Großbettlingen",
                        "latitude": "48.59052000",
                        "longitude": "9.30782000"
                    },
                    {
                        "id": 25657,
                        "name": "Großbottwar",
                        "latitude": "49.00147000",
                        "longitude": "9.29348000"
                    },
                    {
                        "id": 25617,
                        "name": "Grosselfingen",
                        "latitude": "48.33229000",
                        "longitude": "8.88704000"
                    },
                    {
                        "id": 25671,
                        "name": "Großerlach",
                        "latitude": "49.05368000",
                        "longitude": "9.51356000"
                    },
                    {
                        "id": 25700,
                        "name": "Großrinderfeld",
                        "latitude": "49.66536000",
                        "longitude": "9.73356000"
                    },
                    {
                        "id": 25718,
                        "name": "Gruibingen",
                        "latitude": "48.59483000",
                        "longitude": "9.64389000"
                    },
                    {
                        "id": 25742,
                        "name": "Grünkraut",
                        "latitude": "47.74417000",
                        "longitude": "9.65588000"
                    },
                    {
                        "id": 25743,
                        "name": "Grünsfeld",
                        "latitude": "49.60949000",
                        "longitude": "9.74725000"
                    },
                    {
                        "id": 25746,
                        "name": "Gschwend",
                        "latitude": "48.93333000",
                        "longitude": "9.74436000"
                    },
                    {
                        "id": 25792,
                        "name": "Güglingen",
                        "latitude": "49.06642000",
                        "longitude": "9.00175000"
                    },
                    {
                        "id": 25754,
                        "name": "Gundelfingen",
                        "latitude": "48.04246000",
                        "longitude": "7.86570000"
                    },
                    {
                        "id": 25756,
                        "name": "Gundelsheim",
                        "latitude": "49.28330000",
                        "longitude": "9.16037000"
                    },
                    {
                        "id": 25764,
                        "name": "Gutach",
                        "latitude": "48.24844000",
                        "longitude": "8.21293000"
                    },
                    {
                        "id": 25765,
                        "name": "Gutach im Breisgau",
                        "latitude": "48.11667000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 25801,
                        "name": "Gütenbach",
                        "latitude": "48.05000000",
                        "longitude": "8.15000000"
                    },
                    {
                        "id": 25769,
                        "name": "Gutenzell-Hürbel",
                        "latitude": "48.11667000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 25824,
                        "name": "Hagnau",
                        "latitude": "47.67666000",
                        "longitude": "9.31787000"
                    },
                    {
                        "id": 25831,
                        "name": "Haigerloch",
                        "latitude": "48.36614000",
                        "longitude": "8.80357000"
                    },
                    {
                        "id": 25840,
                        "name": "Haiterbach",
                        "latitude": "48.52066000",
                        "longitude": "8.64435000"
                    },
                    {
                        "id": 25865,
                        "name": "Hambrücken",
                        "latitude": "49.19000000",
                        "longitude": "8.54056000"
                    },
                    {
                        "id": 25900,
                        "name": "Hardheim",
                        "latitude": "49.61194000",
                        "longitude": "9.47194000"
                    },
                    {
                        "id": 25901,
                        "name": "Hardt",
                        "latitude": "48.18333000",
                        "longitude": "8.41667000"
                    },
                    {
                        "id": 25916,
                        "name": "Hartheim",
                        "latitude": "47.93333000",
                        "longitude": "7.63333000"
                    },
                    {
                        "id": 25921,
                        "name": "Hasel",
                        "latitude": "47.65342000",
                        "longitude": "7.89720000"
                    },
                    {
                        "id": 25928,
                        "name": "Haslach",
                        "latitude": "48.56531000",
                        "longitude": "8.05658000"
                    },
                    {
                        "id": 25965,
                        "name": "Haßmersheim",
                        "latitude": "49.30000000",
                        "longitude": "9.15000000"
                    },
                    {
                        "id": 25937,
                        "name": "Hattenhofen",
                        "latitude": "48.66648000",
                        "longitude": "9.57456000"
                    },
                    {
                        "id": 25949,
                        "name": "Hausach",
                        "latitude": "48.28426000",
                        "longitude": "8.17602000"
                    },
                    {
                        "id": 25952,
                        "name": "Hausen",
                        "latitude": "47.68128000",
                        "longitude": "7.83986000"
                    },
                    {
                        "id": 26297,
                        "name": "Häusern",
                        "latitude": "47.75000000",
                        "longitude": "8.16667000"
                    },
                    {
                        "id": 25960,
                        "name": "Hayingen",
                        "latitude": "48.27531000",
                        "longitude": "9.47760000"
                    },
                    {
                        "id": 25968,
                        "name": "Hechingen",
                        "latitude": "48.35149000",
                        "longitude": "8.96317000"
                    },
                    {
                        "id": 25971,
                        "name": "Heddesheim",
                        "latitude": "49.50556000",
                        "longitude": "8.60361000"
                    },
                    {
                        "id": 25982,
                        "name": "Heidelberg",
                        "latitude": "49.40768000",
                        "longitude": "8.69079000"
                    },
                    {
                        "id": 25987,
                        "name": "Heidenheim an der Brenz",
                        "latitude": "48.67798000",
                        "longitude": "10.15162000"
                    },
                    {
                        "id": 25994,
                        "name": "Heilbronn",
                        "latitude": "49.13995000",
                        "longitude": "9.22054000"
                    },
                    {
                        "id": 25995,
                        "name": "Heiligenberg",
                        "latitude": "47.82094000",
                        "longitude": "9.31280000"
                    },
                    {
                        "id": 26003,
                        "name": "Heiligkreuzsteinach",
                        "latitude": "49.48333000",
                        "longitude": "8.79500000"
                    },
                    {
                        "id": 26010,
                        "name": "Heimsheim",
                        "latitude": "48.80656000",
                        "longitude": "8.86744000"
                    },
                    {
                        "id": 26014,
                        "name": "Heiningen",
                        "latitude": "48.66177000",
                        "longitude": "9.64977000"
                    },
                    {
                        "id": 26019,
                        "name": "Heitersheim",
                        "latitude": "47.87468000",
                        "longitude": "7.65721000"
                    },
                    {
                        "id": 26031,
                        "name": "Helmstadt-Bargen",
                        "latitude": "49.31427000",
                        "longitude": "8.99712000"
                    },
                    {
                        "id": 26041,
                        "name": "Hemmingen",
                        "latitude": "48.86667000",
                        "longitude": "9.03333000"
                    },
                    {
                        "id": 26044,
                        "name": "Hemsbach",
                        "latitude": "49.59075000",
                        "longitude": "8.64779000"
                    },
                    {
                        "id": 26057,
                        "name": "Herbertingen",
                        "latitude": "48.06667000",
                        "longitude": "9.43333000"
                    },
                    {
                        "id": 26058,
                        "name": "Herbolzheim",
                        "latitude": "48.21884000",
                        "longitude": "7.77746000"
                    },
                    {
                        "id": 26060,
                        "name": "Herbrechtingen",
                        "latitude": "48.62173000",
                        "longitude": "10.17600000"
                    },
                    {
                        "id": 26065,
                        "name": "Herdwangen-Schönach",
                        "latitude": "47.85000000",
                        "longitude": "9.20000000"
                    },
                    {
                        "id": 26076,
                        "name": "Hermaringen",
                        "latitude": "48.59544000",
                        "longitude": "10.26065000"
                    },
                    {
                        "id": 26086,
                        "name": "Herrenberg",
                        "latitude": "48.59523000",
                        "longitude": "8.86648000"
                    },
                    {
                        "id": 26088,
                        "name": "Herrischried",
                        "latitude": "47.66667000",
                        "longitude": "8.00000000"
                    },
                    {
                        "id": 26106,
                        "name": "Hessigheim",
                        "latitude": "48.99407000",
                        "longitude": "9.18629000"
                    },
                    {
                        "id": 26112,
                        "name": "Hettingen",
                        "latitude": "48.21601000",
                        "longitude": "9.23169000"
                    },
                    {
                        "id": 26117,
                        "name": "Heubach",
                        "latitude": "48.79267000",
                        "longitude": "9.93370000"
                    },
                    {
                        "id": 26120,
                        "name": "Heuchlingen",
                        "latitude": "48.85215000",
                        "longitude": "9.94391000"
                    },
                    {
                        "id": 26138,
                        "name": "Hildrizhausen",
                        "latitude": "48.62423000",
                        "longitude": "8.96605000"
                    },
                    {
                        "id": 26150,
                        "name": "Hilzingen",
                        "latitude": "47.76667000",
                        "longitude": "8.78333000"
                    },
                    {
                        "id": 26158,
                        "name": "Hinterzarten",
                        "latitude": "47.90276000",
                        "longitude": "8.10701000"
                    },
                    {
                        "id": 26160,
                        "name": "Hirrlingen",
                        "latitude": "48.41245000",
                        "longitude": "8.88742000"
                    },
                    {
                        "id": 26164,
                        "name": "Hirschberg an der Bergstraße",
                        "latitude": "49.50710000",
                        "longitude": "8.65693000"
                    },
                    {
                        "id": 26173,
                        "name": "Hochdorf",
                        "latitude": "48.02560000",
                        "longitude": "9.78778000"
                    },
                    {
                        "id": 26299,
                        "name": "Höchenschwand",
                        "latitude": "47.73333000",
                        "longitude": "8.16667000"
                    },
                    {
                        "id": 26182,
                        "name": "Hockenheim",
                        "latitude": "49.32334000",
                        "longitude": "8.55194000"
                    },
                    {
                        "id": 26306,
                        "name": "Höfen an der Enz",
                        "latitude": "48.80000000",
                        "longitude": "8.58333000"
                    },
                    {
                        "id": 26191,
                        "name": "Hofstetten",
                        "latitude": "48.25846000",
                        "longitude": "8.06595000"
                    },
                    {
                        "id": 26193,
                        "name": "Hohberg",
                        "latitude": "48.32270000",
                        "longitude": "7.89972000"
                    },
                    {
                        "id": 26216,
                        "name": "Hohentengen",
                        "latitude": "47.57005000",
                        "longitude": "8.43250000"
                    },
                    {
                        "id": 26242,
                        "name": "Holzgerlingen",
                        "latitude": "48.63969000",
                        "longitude": "9.01149000"
                    },
                    {
                        "id": 26247,
                        "name": "Holzmaden",
                        "latitude": "48.63333000",
                        "longitude": "9.51667000"
                    },
                    {
                        "id": 26315,
                        "name": "Höpfingen",
                        "latitude": "49.60250000",
                        "longitude": "9.42861000"
                    },
                    {
                        "id": 26256,
                        "name": "Horb am Neckar",
                        "latitude": "48.44423000",
                        "longitude": "8.69130000"
                    },
                    {
                        "id": 26257,
                        "name": "Horben",
                        "latitude": "47.93333000",
                        "longitude": "7.86667000"
                    },
                    {
                        "id": 26260,
                        "name": "Horgenzell",
                        "latitude": "47.80534000",
                        "longitude": "9.49727000"
                    },
                    {
                        "id": 26266,
                        "name": "Hornberg",
                        "latitude": "48.21068000",
                        "longitude": "8.23275000"
                    },
                    {
                        "id": 26271,
                        "name": "Horrenberg",
                        "latitude": "49.28040000",
                        "longitude": "8.78087000"
                    },
                    {
                        "id": 26331,
                        "name": "Hüffenhardt",
                        "latitude": "49.29194000",
                        "longitude": "9.08167000"
                    },
                    {
                        "id": 26332,
                        "name": "Hüfingen",
                        "latitude": "47.92543000",
                        "longitude": "8.48831000"
                    },
                    {
                        "id": 26333,
                        "name": "Hügelsheim",
                        "latitude": "48.80000000",
                        "longitude": "8.11667000"
                    },
                    {
                        "id": 26334,
                        "name": "Hülben",
                        "latitude": "48.51982000",
                        "longitude": "9.40790000"
                    },
                    {
                        "id": 26344,
                        "name": "Hüttisheim",
                        "latitude": "48.27965000",
                        "longitude": "9.94246000"
                    },
                    {
                        "id": 26345,
                        "name": "Hüttlingen",
                        "latitude": "48.89266000",
                        "longitude": "10.10064000"
                    },
                    {
                        "id": 26353,
                        "name": "Iffezheim",
                        "latitude": "48.82167000",
                        "longitude": "8.14310000"
                    },
                    {
                        "id": 26357,
                        "name": "Igersheim",
                        "latitude": "49.49444000",
                        "longitude": "9.81694000"
                    },
                    {
                        "id": 26359,
                        "name": "Iggingen",
                        "latitude": "48.83167000",
                        "longitude": "9.87894000"
                    },
                    {
                        "id": 26361,
                        "name": "Ihringen",
                        "latitude": "48.04303000",
                        "longitude": "7.64760000"
                    },
                    {
                        "id": 26366,
                        "name": "Illerrieden",
                        "latitude": "48.27017000",
                        "longitude": "10.05155000"
                    },
                    {
                        "id": 26368,
                        "name": "Illingen",
                        "latitude": "48.95616000",
                        "longitude": "8.92459000"
                    },
                    {
                        "id": 26370,
                        "name": "Illmensee",
                        "latitude": "47.86229000",
                        "longitude": "9.37235000"
                    },
                    {
                        "id": 26376,
                        "name": "Ilsfeld",
                        "latitude": "49.05548000",
                        "longitude": "9.24598000"
                    },
                    {
                        "id": 26377,
                        "name": "Ilshofen",
                        "latitude": "49.17015000",
                        "longitude": "9.91825000"
                    },
                    {
                        "id": 26378,
                        "name": "Ilvesheim",
                        "latitude": "49.47404000",
                        "longitude": "8.56740000"
                    },
                    {
                        "id": 26380,
                        "name": "Immendingen",
                        "latitude": "47.93333000",
                        "longitude": "8.73333000"
                    },
                    {
                        "id": 26383,
                        "name": "Immenstaad am Bodensee",
                        "latitude": "47.66667000",
                        "longitude": "9.36667000"
                    },
                    {
                        "id": 26388,
                        "name": "Ingelfingen",
                        "latitude": "49.30028000",
                        "longitude": "9.65303000"
                    },
                    {
                        "id": 26391,
                        "name": "Ingoldingen",
                        "latitude": "48.02552000",
                        "longitude": "9.74195000"
                    },
                    {
                        "id": 26399,
                        "name": "Inzigkofen",
                        "latitude": "48.07034000",
                        "longitude": "9.17998000"
                    },
                    {
                        "id": 26400,
                        "name": "Inzlingen",
                        "latitude": "47.58851000",
                        "longitude": "7.69094000"
                    },
                    {
                        "id": 26416,
                        "name": "Isny",
                        "latitude": "47.69260000",
                        "longitude": "10.03857000"
                    },
                    {
                        "id": 26417,
                        "name": "Ispringen",
                        "latitude": "48.91667000",
                        "longitude": "8.66667000"
                    },
                    {
                        "id": 26421,
                        "name": "Ittlingen",
                        "latitude": "49.19083000",
                        "longitude": "8.93083000"
                    },
                    {
                        "id": 26425,
                        "name": "Jagsthausen",
                        "latitude": "49.31056000",
                        "longitude": "9.46833000"
                    },
                    {
                        "id": 26426,
                        "name": "Jagstzell",
                        "latitude": "49.03055000",
                        "longitude": "10.09751000"
                    },
                    {
                        "id": 26446,
                        "name": "Jestetten",
                        "latitude": "47.65000000",
                        "longitude": "8.56667000"
                    },
                    {
                        "id": 26466,
                        "name": "Jöhlingen",
                        "latitude": "49.03218000",
                        "longitude": "8.57350000"
                    },
                    {
                        "id": 26463,
                        "name": "Jungingen",
                        "latitude": "48.32787000",
                        "longitude": "9.04095000"
                    },
                    {
                        "id": 26481,
                        "name": "Kaisersbach",
                        "latitude": "48.93023000",
                        "longitude": "9.63898000"
                    },
                    {
                        "id": 26506,
                        "name": "Kandern",
                        "latitude": "47.71393000",
                        "longitude": "7.66237000"
                    },
                    {
                        "id": 26508,
                        "name": "Kappel-Grafenhausen",
                        "latitude": "48.28382000",
                        "longitude": "7.76605000"
                    },
                    {
                        "id": 26510,
                        "name": "Kappelrodeck",
                        "latitude": "48.59182000",
                        "longitude": "8.11692000"
                    },
                    {
                        "id": 26514,
                        "name": "Karlsdorf-Neuthard",
                        "latitude": "49.13472000",
                        "longitude": "8.53028000"
                    },
                    {
                        "id": 26520,
                        "name": "Karlsruhe",
                        "latitude": "49.00937000",
                        "longitude": "8.40444000"
                    },
                    {
                        "id": 26521,
                        "name": "Karlsruhe Region",
                        "latitude": "49.00000000",
                        "longitude": "8.66667000"
                    },
                    {
                        "id": 26551,
                        "name": "Kehl",
                        "latitude": "48.57297000",
                        "longitude": "7.81523000"
                    },
                    {
                        "id": 26571,
                        "name": "Kenzingen",
                        "latitude": "48.19630000",
                        "longitude": "7.76974000"
                    },
                    {
                        "id": 26575,
                        "name": "Ketsch",
                        "latitude": "49.36778000",
                        "longitude": "8.53111000"
                    },
                    {
                        "id": 26587,
                        "name": "Kieselbronn",
                        "latitude": "48.93333000",
                        "longitude": "8.75000000"
                    },
                    {
                        "id": 26592,
                        "name": "Kippenheim",
                        "latitude": "48.29564000",
                        "longitude": "7.82510000"
                    },
                    {
                        "id": 26594,
                        "name": "Kirchardt",
                        "latitude": "49.20500000",
                        "longitude": "8.99167000"
                    },
                    {
                        "id": 26598,
                        "name": "Kirchberg an der Iller",
                        "latitude": "48.13333000",
                        "longitude": "10.08333000"
                    },
                    {
                        "id": 26599,
                        "name": "Kirchberg an der Jagst",
                        "latitude": "49.20056000",
                        "longitude": "9.98226000"
                    },
                    {
                        "id": 26600,
                        "name": "Kirchberg an der Murr",
                        "latitude": "48.94297000",
                        "longitude": "9.34083000"
                    },
                    {
                        "id": 26603,
                        "name": "Kirchdorf",
                        "latitude": "48.07667000",
                        "longitude": "10.12629000"
                    },
                    {
                        "id": 26612,
                        "name": "Kirchentellinsfurt",
                        "latitude": "48.53315000",
                        "longitude": "9.14732000"
                    },
                    {
                        "id": 26621,
                        "name": "Kirchheim am Neckar",
                        "latitude": "49.04500000",
                        "longitude": "9.14222000"
                    },
                    {
                        "id": 26622,
                        "name": "Kirchheim am Ries",
                        "latitude": "48.87922000",
                        "longitude": "10.40028000"
                    },
                    {
                        "id": 26625,
                        "name": "Kirchheim unter Teck",
                        "latitude": "48.64683000",
                        "longitude": "9.45378000"
                    },
                    {
                        "id": 26639,
                        "name": "Kirchzarten",
                        "latitude": "47.96667000",
                        "longitude": "7.95000000"
                    },
                    {
                        "id": 26654,
                        "name": "Kißlegg",
                        "latitude": "47.78894000",
                        "longitude": "9.88383000"
                    },
                    {
                        "id": 26688,
                        "name": "Klingenstein",
                        "latitude": "48.41849000",
                        "longitude": "9.90812000"
                    },
                    {
                        "id": 26703,
                        "name": "Knittlingen",
                        "latitude": "49.02487000",
                        "longitude": "8.75606000"
                    },
                    {
                        "id": 26709,
                        "name": "Kohlberg",
                        "latitude": "48.55845000",
                        "longitude": "9.33576000"
                    },
                    {
                        "id": 26711,
                        "name": "Kolbingen",
                        "latitude": "48.05227000",
                        "longitude": "8.88957000"
                    },
                    {
                        "id": 26819,
                        "name": "Köngen",
                        "latitude": "48.68333000",
                        "longitude": "9.36667000"
                    },
                    {
                        "id": 26821,
                        "name": "Königheim",
                        "latitude": "49.62028000",
                        "longitude": "9.59583000"
                    },
                    {
                        "id": 26823,
                        "name": "Königsbach-Stein",
                        "latitude": "48.96585000",
                        "longitude": "8.60573000"
                    },
                    {
                        "id": 26824,
                        "name": "Königsbronn",
                        "latitude": "48.74317000",
                        "longitude": "10.11193000"
                    },
                    {
                        "id": 26831,
                        "name": "Königsfeld im Schwarzwald",
                        "latitude": "48.13814000",
                        "longitude": "8.41973000"
                    },
                    {
                        "id": 26718,
                        "name": "Konstanz",
                        "latitude": "47.66033000",
                        "longitude": "9.17582000"
                    },
                    {
                        "id": 26721,
                        "name": "Korb",
                        "latitude": "48.84303000",
                        "longitude": "9.36258000"
                    },
                    {
                        "id": 26724,
                        "name": "Korntal",
                        "latitude": "48.83218000",
                        "longitude": "9.12140000"
                    },
                    {
                        "id": 26725,
                        "name": "Kornwestheim",
                        "latitude": "48.86158000",
                        "longitude": "9.18569000"
                    },
                    {
                        "id": 26735,
                        "name": "Kraichtal",
                        "latitude": "49.14623000",
                        "longitude": "8.73276000"
                    },
                    {
                        "id": 26741,
                        "name": "Krauchenwies",
                        "latitude": "48.01651000",
                        "longitude": "9.24757000"
                    },
                    {
                        "id": 26744,
                        "name": "Krautheim",
                        "latitude": "49.38789000",
                        "longitude": "9.63553000"
                    },
                    {
                        "id": 26752,
                        "name": "Kressbronn am Bodensee",
                        "latitude": "47.59760000",
                        "longitude": "9.59707000"
                    },
                    {
                        "id": 26768,
                        "name": "Kronau",
                        "latitude": "49.22250000",
                        "longitude": "8.63111000"
                    },
                    {
                        "id": 26789,
                        "name": "Kuchen",
                        "latitude": "48.63583000",
                        "longitude": "9.79989000"
                    },
                    {
                        "id": 26853,
                        "name": "Külsheim",
                        "latitude": "49.66942000",
                        "longitude": "9.52361000"
                    },
                    {
                        "id": 26856,
                        "name": "Künzelsau",
                        "latitude": "49.28180000",
                        "longitude": "9.68352000"
                    },
                    {
                        "id": 26799,
                        "name": "Kupferzell",
                        "latitude": "49.22778000",
                        "longitude": "9.69000000"
                    },
                    {
                        "id": 26800,
                        "name": "Kuppenheim",
                        "latitude": "48.82794000",
                        "longitude": "8.25417000"
                    },
                    {
                        "id": 26859,
                        "name": "Kürnbach",
                        "latitude": "49.07750000",
                        "longitude": "8.84556000"
                    },
                    {
                        "id": 26807,
                        "name": "Kusterdingen",
                        "latitude": "48.52291000",
                        "longitude": "9.11977000"
                    },
                    {
                        "id": 26872,
                        "name": "Ladenburg",
                        "latitude": "49.47307000",
                        "longitude": "8.60896000"
                    },
                    {
                        "id": 26876,
                        "name": "Lahr",
                        "latitude": "48.34042000",
                        "longitude": "7.86886000"
                    },
                    {
                        "id": 26877,
                        "name": "Laichingen",
                        "latitude": "48.48939000",
                        "longitude": "9.68612000"
                    },
                    {
                        "id": 26905,
                        "name": "Langenargen",
                        "latitude": "47.59858000",
                        "longitude": "9.54163000"
                    },
                    {
                        "id": 26906,
                        "name": "Langenau",
                        "latitude": "48.49616000",
                        "longitude": "10.11849000"
                    },
                    {
                        "id": 26912,
                        "name": "Langenbrettach",
                        "latitude": "49.22601000",
                        "longitude": "9.41842000"
                    },
                    {
                        "id": 26913,
                        "name": "Langenburg",
                        "latitude": "49.25401000",
                        "longitude": "9.85673000"
                    },
                    {
                        "id": 26916,
                        "name": "Langenenslingen",
                        "latitude": "48.14851000",
                        "longitude": "9.37765000"
                    },
                    {
                        "id": 26960,
                        "name": "Lauchheim",
                        "latitude": "48.87135000",
                        "longitude": "10.24222000"
                    },
                    {
                        "id": 26961,
                        "name": "Lauchringen",
                        "latitude": "47.62699000",
                        "longitude": "8.31442000"
                    },
                    {
                        "id": 26963,
                        "name": "Lauda-Königshofen",
                        "latitude": "49.56526000",
                        "longitude": "9.70816000"
                    },
                    {
                        "id": 26965,
                        "name": "Laudenbach",
                        "latitude": "49.61333000",
                        "longitude": "8.65389000"
                    },
                    {
                        "id": 26970,
                        "name": "Lauf",
                        "latitude": "48.65000000",
                        "longitude": "8.13333000"
                    },
                    {
                        "id": 26975,
                        "name": "Laufenburg",
                        "latitude": "47.56512000",
                        "longitude": "8.06045000"
                    },
                    {
                        "id": 26976,
                        "name": "Lauffen am Neckar",
                        "latitude": "49.07340000",
                        "longitude": "9.14567000"
                    },
                    {
                        "id": 26979,
                        "name": "Laupheim",
                        "latitude": "48.22786000",
                        "longitude": "9.87874000"
                    },
                    {
                        "id": 26981,
                        "name": "Lautenbach",
                        "latitude": "48.48185000",
                        "longitude": "8.02732000"
                    },
                    {
                        "id": 26985,
                        "name": "Lauterbach\/Schwarzwald",
                        "latitude": "48.22999000",
                        "longitude": "8.34240000"
                    },
                    {
                        "id": 27012,
                        "name": "Lehrensteinsfeld",
                        "latitude": "49.13111000",
                        "longitude": "9.32722000"
                    },
                    {
                        "id": 27014,
                        "name": "Leibertingen",
                        "latitude": "48.04263000",
                        "longitude": "9.01308000"
                    },
                    {
                        "id": 27020,
                        "name": "Leimen",
                        "latitude": "49.34737000",
                        "longitude": "8.68733000"
                    },
                    {
                        "id": 27024,
                        "name": "Leinfelden-Echterdingen",
                        "latitude": "48.69406000",
                        "longitude": "9.16809000"
                    },
                    {
                        "id": 27025,
                        "name": "Leingarten",
                        "latitude": "49.14639000",
                        "longitude": "9.11694000"
                    },
                    {
                        "id": 27026,
                        "name": "Leinzell",
                        "latitude": "48.84941000",
                        "longitude": "9.87750000"
                    },
                    {
                        "id": 27047,
                        "name": "Lenningen",
                        "latitude": "48.55048000",
                        "longitude": "9.47674000"
                    },
                    {
                        "id": 27051,
                        "name": "Lenzkirch",
                        "latitude": "47.86832000",
                        "longitude": "8.20211000"
                    },
                    {
                        "id": 27053,
                        "name": "Leonberg",
                        "latitude": "48.80000000",
                        "longitude": "9.01667000"
                    },
                    {
                        "id": 27065,
                        "name": "Leutenbach",
                        "latitude": "48.88791000",
                        "longitude": "9.39267000"
                    },
                    {
                        "id": 27070,
                        "name": "Leutkirch",
                        "latitude": "47.82672000",
                        "longitude": "10.02050000"
                    },
                    {
                        "id": 27076,
                        "name": "Lichtenau",
                        "latitude": "48.72607000",
                        "longitude": "8.00486000"
                    },
                    {
                        "id": 27116,
                        "name": "Linkenheim-Hochstetten",
                        "latitude": "49.13197000",
                        "longitude": "8.41244000"
                    },
                    {
                        "id": 27124,
                        "name": "Lobbach",
                        "latitude": "49.37519000",
                        "longitude": "8.88884000"
                    },
                    {
                        "id": 27190,
                        "name": "Löchgau",
                        "latitude": "49.00361000",
                        "longitude": "9.10639000"
                    },
                    {
                        "id": 27129,
                        "name": "Loffenau",
                        "latitude": "48.77214000",
                        "longitude": "8.38463000"
                    },
                    {
                        "id": 27193,
                        "name": "Löffingen",
                        "latitude": "47.88405000",
                        "longitude": "8.34384000"
                    },
                    {
                        "id": 27147,
                        "name": "Lonsee",
                        "latitude": "48.54340000",
                        "longitude": "9.91999000"
                    },
                    {
                        "id": 27148,
                        "name": "Lorch",
                        "latitude": "48.79833000",
                        "longitude": "9.69140000"
                    },
                    {
                        "id": 27197,
                        "name": "Lörrach",
                        "latitude": "47.61497000",
                        "longitude": "7.66457000"
                    },
                    {
                        "id": 27157,
                        "name": "Loßburg",
                        "latitude": "48.40000000",
                        "longitude": "8.45000000"
                    },
                    {
                        "id": 27154,
                        "name": "Lottstetten",
                        "latitude": "47.63333000",
                        "longitude": "8.56667000"
                    },
                    {
                        "id": 27199,
                        "name": "Löwenstein",
                        "latitude": "49.09558000",
                        "longitude": "9.38000000"
                    },
                    {
                        "id": 27163,
                        "name": "Ludwigsburg",
                        "latitude": "48.89731000",
                        "longitude": "9.19161000"
                    },
                    {
                        "id": 27231,
                        "name": "Magstadt",
                        "latitude": "48.74471000",
                        "longitude": "8.96675000"
                    },
                    {
                        "id": 27232,
                        "name": "Mahlberg",
                        "latitude": "48.28639000",
                        "longitude": "7.81411000"
                    },
                    {
                        "id": 27240,
                        "name": "Mainhardt",
                        "latitude": "49.07611000",
                        "longitude": "9.55639000"
                    },
                    {
                        "id": 27256,
                        "name": "Malsch",
                        "latitude": "49.24722000",
                        "longitude": "8.68278000"
                    },
                    {
                        "id": 27259,
                        "name": "Malterdingen",
                        "latitude": "48.15719000",
                        "longitude": "7.78608000"
                    },
                    {
                        "id": 27265,
                        "name": "Mannheim",
                        "latitude": "49.48910000",
                        "longitude": "8.46694000"
                    },
                    {
                        "id": 27269,
                        "name": "Marbach am Neckar",
                        "latitude": "48.93964000",
                        "longitude": "9.25995000"
                    },
                    {
                        "id": 27283,
                        "name": "Markdorf",
                        "latitude": "47.71916000",
                        "longitude": "9.39028000"
                    },
                    {
                        "id": 27286,
                        "name": "Markgröningen",
                        "latitude": "48.90493000",
                        "longitude": "9.08059000"
                    },
                    {
                        "id": 27337,
                        "name": "Maselheim",
                        "latitude": "48.13333000",
                        "longitude": "9.88333000"
                    },
                    {
                        "id": 27338,
                        "name": "Massenbachhausen",
                        "latitude": "49.17778000",
                        "longitude": "9.04333000"
                    },
                    {
                        "id": 27342,
                        "name": "Mauer",
                        "latitude": "49.34083000",
                        "longitude": "8.80028000"
                    },
                    {
                        "id": 27345,
                        "name": "Maulbronn",
                        "latitude": "48.99958000",
                        "longitude": "8.80337000"
                    },
                    {
                        "id": 27346,
                        "name": "Maulburg",
                        "latitude": "47.64631000",
                        "longitude": "7.78210000"
                    },
                    {
                        "id": 27356,
                        "name": "Meckenbeuren",
                        "latitude": "47.70000000",
                        "longitude": "9.56667000"
                    },
                    {
                        "id": 27359,
                        "name": "Meckesheim",
                        "latitude": "49.32167000",
                        "longitude": "8.81944000"
                    },
                    {
                        "id": 27369,
                        "name": "Meersburg",
                        "latitude": "47.69419000",
                        "longitude": "9.27113000"
                    },
                    {
                        "id": 27379,
                        "name": "Mehrstetten",
                        "latitude": "48.37609000",
                        "longitude": "9.56600000"
                    },
                    {
                        "id": 27388,
                        "name": "Meißenheim",
                        "latitude": "48.41035000",
                        "longitude": "7.77266000"
                    },
                    {
                        "id": 27406,
                        "name": "Mengen",
                        "latitude": "48.04951000",
                        "longitude": "9.33005000"
                    },
                    {
                        "id": 27416,
                        "name": "Merdingen",
                        "latitude": "48.01667000",
                        "longitude": "7.68333000"
                    },
                    {
                        "id": 27421,
                        "name": "Merklingen",
                        "latitude": "48.51135000",
                        "longitude": "9.75496000"
                    },
                    {
                        "id": 27429,
                        "name": "Merzhausen",
                        "latitude": "47.96667000",
                        "longitude": "7.83333000"
                    },
                    {
                        "id": 27449,
                        "name": "Meßkirch",
                        "latitude": "47.99457000",
                        "longitude": "9.11479000"
                    },
                    {
                        "id": 27450,
                        "name": "Meßstetten",
                        "latitude": "48.18317000",
                        "longitude": "8.96565000"
                    },
                    {
                        "id": 27444,
                        "name": "Metzingen",
                        "latitude": "48.53695000",
                        "longitude": "9.28330000"
                    },
                    {
                        "id": 27452,
                        "name": "Michelbach an der Bilz",
                        "latitude": "49.07028000",
                        "longitude": "9.76250000"
                    },
                    {
                        "id": 27453,
                        "name": "Michelfeld",
                        "latitude": "49.09750000",
                        "longitude": "9.67861000"
                    },
                    {
                        "id": 27463,
                        "name": "Mietingen",
                        "latitude": "48.18333000",
                        "longitude": "9.90000000"
                    },
                    {
                        "id": 27480,
                        "name": "Mittelbiberach",
                        "latitude": "48.08333000",
                        "longitude": "9.75000000"
                    },
                    {
                        "id": 27485,
                        "name": "Mittelschöntal",
                        "latitude": "48.94615000",
                        "longitude": "9.39520000"
                    },
                    {
                        "id": 27556,
                        "name": "Möckmühl",
                        "latitude": "49.32490000",
                        "longitude": "9.35837000"
                    },
                    {
                        "id": 27558,
                        "name": "Mögglingen",
                        "latitude": "48.82320000",
                        "longitude": "9.96250000"
                    },
                    {
                        "id": 27559,
                        "name": "Möglingen",
                        "latitude": "48.88741000",
                        "longitude": "9.12694000"
                    },
                    {
                        "id": 27573,
                        "name": "Mönchweiler",
                        "latitude": "48.10040000",
                        "longitude": "8.42219000"
                    },
                    {
                        "id": 27575,
                        "name": "Mönsheim",
                        "latitude": "48.86667000",
                        "longitude": "8.86667000"
                    },
                    {
                        "id": 27517,
                        "name": "Moos",
                        "latitude": "47.72439000",
                        "longitude": "8.93479000"
                    },
                    {
                        "id": 27528,
                        "name": "Mosbach",
                        "latitude": "49.35357000",
                        "longitude": "9.15106000"
                    },
                    {
                        "id": 27579,
                        "name": "Mössingen",
                        "latitude": "48.40567000",
                        "longitude": "9.05419000"
                    },
                    {
                        "id": 27582,
                        "name": "Mötzingen",
                        "latitude": "48.53320000",
                        "longitude": "8.77447000"
                    },
                    {
                        "id": 27531,
                        "name": "Mudau",
                        "latitude": "49.53444000",
                        "longitude": "9.20444000"
                    },
                    {
                        "id": 27533,
                        "name": "Muggensturm",
                        "latitude": "48.86667000",
                        "longitude": "8.28333000"
                    },
                    {
                        "id": 27589,
                        "name": "Mühlacker",
                        "latitude": "48.94754000",
                        "longitude": "8.83675000"
                    },
                    {
                        "id": 27595,
                        "name": "Mühlenbach",
                        "latitude": "48.25000000",
                        "longitude": "8.11667000"
                    },
                    {
                        "id": 27598,
                        "name": "Mühlhausen",
                        "latitude": "49.24861000",
                        "longitude": "8.72667000"
                    },
                    {
                        "id": 27599,
                        "name": "Mühlhausen-Ehingen",
                        "latitude": "47.81102000",
                        "longitude": "8.81224000"
                    },
                    {
                        "id": 27600,
                        "name": "Mühlheim am Bach",
                        "latitude": "48.37863000",
                        "longitude": "8.69735000"
                    },
                    {
                        "id": 27602,
                        "name": "Mühlingen",
                        "latitude": "47.91667000",
                        "longitude": "9.01667000"
                    },
                    {
                        "id": 27537,
                        "name": "Mulfingen",
                        "latitude": "49.34028000",
                        "longitude": "9.80083000"
                    },
                    {
                        "id": 27606,
                        "name": "Müllheim",
                        "latitude": "47.80820000",
                        "longitude": "7.63035000"
                    },
                    {
                        "id": 27538,
                        "name": "Mundelsheim",
                        "latitude": "49.00083000",
                        "longitude": "9.20778000"
                    },
                    {
                        "id": 27539,
                        "name": "Munderkingen",
                        "latitude": "48.23568000",
                        "longitude": "9.64398000"
                    },
                    {
                        "id": 27619,
                        "name": "Münsingen",
                        "latitude": "48.41126000",
                        "longitude": "9.49704000"
                    },
                    {
                        "id": 27627,
                        "name": "Münstertal\/Schwarzwald",
                        "latitude": "47.85472000",
                        "longitude": "7.78417000"
                    },
                    {
                        "id": 27544,
                        "name": "Murg",
                        "latitude": "47.55492000",
                        "longitude": "8.02182000"
                    },
                    {
                        "id": 27546,
                        "name": "Murr",
                        "latitude": "48.96207000",
                        "longitude": "9.25924000"
                    },
                    {
                        "id": 27547,
                        "name": "Murrhardt",
                        "latitude": "48.98191000",
                        "longitude": "9.57047000"
                    },
                    {
                        "id": 27549,
                        "name": "Mutlangen",
                        "latitude": "48.82588000",
                        "longitude": "9.79714000"
                    },
                    {
                        "id": 27635,
                        "name": "Nagold",
                        "latitude": "48.54980000",
                        "longitude": "8.72366000"
                    },
                    {
                        "id": 27646,
                        "name": "Nattheim",
                        "latitude": "48.69963000",
                        "longitude": "10.24209000"
                    },
                    {
                        "id": 27658,
                        "name": "Neckarbischofsheim",
                        "latitude": "49.29625000",
                        "longitude": "8.96380000"
                    },
                    {
                        "id": 27659,
                        "name": "Neckargemünd",
                        "latitude": "49.38899000",
                        "longitude": "8.79590000"
                    },
                    {
                        "id": 27660,
                        "name": "Neckargerach",
                        "latitude": "49.40000000",
                        "longitude": "9.06667000"
                    },
                    {
                        "id": 27662,
                        "name": "Neckarsulm",
                        "latitude": "49.18912000",
                        "longitude": "9.22527000"
                    },
                    {
                        "id": 27663,
                        "name": "Neckartailfingen",
                        "latitude": "48.61172000",
                        "longitude": "9.26371000"
                    },
                    {
                        "id": 27664,
                        "name": "Neckartenzlingen",
                        "latitude": "48.58981000",
                        "longitude": "9.23478000"
                    },
                    {
                        "id": 27665,
                        "name": "Neckarwestheim",
                        "latitude": "49.04694000",
                        "longitude": "9.19000000"
                    },
                    {
                        "id": 27666,
                        "name": "Neckarzimmern",
                        "latitude": "49.31917000",
                        "longitude": "9.13278000"
                    },
                    {
                        "id": 27668,
                        "name": "Nehren",
                        "latitude": "48.43097000",
                        "longitude": "9.06990000"
                    },
                    {
                        "id": 27669,
                        "name": "Neidenstein",
                        "latitude": "49.31667000",
                        "longitude": "8.88472000"
                    },
                    {
                        "id": 27670,
                        "name": "Neidlingen",
                        "latitude": "48.57865000",
                        "longitude": "9.56454000"
                    },
                    {
                        "id": 27672,
                        "name": "Nellingen",
                        "latitude": "48.54196000",
                        "longitude": "9.79053000"
                    },
                    {
                        "id": 27678,
                        "name": "Neresheim",
                        "latitude": "48.75511000",
                        "longitude": "10.33041000"
                    },
                    {
                        "id": 27705,
                        "name": "Neubulach",
                        "latitude": "48.66092000",
                        "longitude": "8.69611000"
                    },
                    {
                        "id": 27711,
                        "name": "Neudenau",
                        "latitude": "49.29181000",
                        "longitude": "9.26975000"
                    },
                    {
                        "id": 27718,
                        "name": "Neuenbürg",
                        "latitude": "48.84516000",
                        "longitude": "8.59574000"
                    },
                    {
                        "id": 27717,
                        "name": "Neuenburg am Rhein",
                        "latitude": "47.81431000",
                        "longitude": "7.56005000"
                    },
                    {
                        "id": 27727,
                        "name": "Neuenstadt am Kocher",
                        "latitude": "49.23498000",
                        "longitude": "9.33215000"
                    },
                    {
                        "id": 27728,
                        "name": "Neuenstein",
                        "latitude": "49.20490000",
                        "longitude": "9.58000000"
                    },
                    {
                        "id": 27733,
                        "name": "Neuffen",
                        "latitude": "48.55460000",
                        "longitude": "9.37550000"
                    },
                    {
                        "id": 27734,
                        "name": "Neufra",
                        "latitude": "48.12880000",
                        "longitude": "9.47554000"
                    },
                    {
                        "id": 27746,
                        "name": "Neuhausen",
                        "latitude": "48.79260000",
                        "longitude": "8.77649000"
                    },
                    {
                        "id": 27747,
                        "name": "Neuhausen auf den Fildern",
                        "latitude": "48.68333000",
                        "longitude": "9.28333000"
                    },
                    {
                        "id": 27757,
                        "name": "Neukirch",
                        "latitude": "47.65738000",
                        "longitude": "9.70333000"
                    },
                    {
                        "id": 27766,
                        "name": "Neuler",
                        "latitude": "48.92803000",
                        "longitude": "10.06888000"
                    },
                    {
                        "id": 153784,
                        "name": "Neulingen",
                        "latitude": "48.95912670",
                        "longitude": "8.62857370"
                    },
                    {
                        "id": 27768,
                        "name": "Neulußheim",
                        "latitude": "49.29806000",
                        "longitude": "8.51833000"
                    },
                    {
                        "id": 27778,
                        "name": "Neunkirchen",
                        "latitude": "49.38694000",
                        "longitude": "9.01056000"
                    },
                    {
                        "id": 27813,
                        "name": "Neuweiler",
                        "latitude": "48.66667000",
                        "longitude": "8.60000000"
                    },
                    {
                        "id": 27844,
                        "name": "Niedereschach",
                        "latitude": "48.13333000",
                        "longitude": "8.53333000"
                    },
                    {
                        "id": 27863,
                        "name": "Niedernhall",
                        "latitude": "49.29516000",
                        "longitude": "9.61604000"
                    },
                    {
                        "id": 27875,
                        "name": "Niederstetten",
                        "latitude": "49.40000000",
                        "longitude": "9.91944000"
                    },
                    {
                        "id": 27876,
                        "name": "Niederstotzingen",
                        "latitude": "48.54127000",
                        "longitude": "10.23505000"
                    },
                    {
                        "id": 27880,
                        "name": "Niederwangen",
                        "latitude": "47.67192000",
                        "longitude": "9.79880000"
                    },
                    {
                        "id": 27888,
                        "name": "Niefern-Öschelbronn",
                        "latitude": "48.91667000",
                        "longitude": "8.78333000"
                    },
                    {
                        "id": 27921,
                        "name": "Nordheim",
                        "latitude": "49.10861000",
                        "longitude": "9.12778000"
                    },
                    {
                        "id": 27926,
                        "name": "Nordrach",
                        "latitude": "48.40000000",
                        "longitude": "8.08333000"
                    },
                    {
                        "id": 27938,
                        "name": "Notzingen",
                        "latitude": "48.67076000",
                        "longitude": "9.45721000"
                    },
                    {
                        "id": 27940,
                        "name": "Nufringen",
                        "latitude": "48.62253000",
                        "longitude": "8.89009000"
                    },
                    {
                        "id": 27955,
                        "name": "Nürtingen",
                        "latitude": "48.62565000",
                        "longitude": "9.34203000"
                    },
                    {
                        "id": 27944,
                        "name": "Nußloch",
                        "latitude": "49.32389000",
                        "longitude": "8.69556000"
                    },
                    {
                        "id": 27968,
                        "name": "Oberboihingen",
                        "latitude": "48.65000000",
                        "longitude": "9.36667000"
                    },
                    {
                        "id": 27971,
                        "name": "Oberderdingen",
                        "latitude": "49.06556000",
                        "longitude": "8.80306000"
                    },
                    {
                        "id": 27973,
                        "name": "Oberdischingen",
                        "latitude": "48.30000000",
                        "longitude": "9.83333000"
                    },
                    {
                        "id": 27983,
                        "name": "Oberharmersbach",
                        "latitude": "48.37358000",
                        "longitude": "8.12542000"
                    },
                    {
                        "id": 27986,
                        "name": "Oberhausen-Rheinhausen",
                        "latitude": "49.27389000",
                        "longitude": "8.47167000"
                    },
                    {
                        "id": 27988,
                        "name": "Oberjettingen",
                        "latitude": "48.57468000",
                        "longitude": "8.77636000"
                    },
                    {
                        "id": 27989,
                        "name": "Oberkirch",
                        "latitude": "48.53241000",
                        "longitude": "8.07864000"
                    },
                    {
                        "id": 27990,
                        "name": "Oberkochen",
                        "latitude": "48.78379000",
                        "longitude": "10.10519000"
                    },
                    {
                        "id": 27995,
                        "name": "Obermarchtal",
                        "latitude": "48.23279000",
                        "longitude": "9.57235000"
                    },
                    {
                        "id": 28004,
                        "name": "Oberndorf",
                        "latitude": "48.29050000",
                        "longitude": "8.57221000"
                    },
                    {
                        "id": 28008,
                        "name": "Obernheim",
                        "latitude": "48.16297000",
                        "longitude": "8.86113000"
                    },
                    {
                        "id": 28020,
                        "name": "Oberreichenbach",
                        "latitude": "48.73333000",
                        "longitude": "8.66667000"
                    },
                    {
                        "id": 28022,
                        "name": "Oberried",
                        "latitude": "47.93333000",
                        "longitude": "7.95000000"
                    },
                    {
                        "id": 28024,
                        "name": "Oberriexingen",
                        "latitude": "48.92652000",
                        "longitude": "9.02701000"
                    },
                    {
                        "id": 28025,
                        "name": "Oberrot",
                        "latitude": "49.01444000",
                        "longitude": "9.66722000"
                    },
                    {
                        "id": 28026,
                        "name": "Oberrotweil",
                        "latitude": "48.08990000",
                        "longitude": "7.63601000"
                    },
                    {
                        "id": 28036,
                        "name": "Obersontheim",
                        "latitude": "49.05667000",
                        "longitude": "9.89917000"
                    },
                    {
                        "id": 28037,
                        "name": "Oberstadion",
                        "latitude": "48.18596000",
                        "longitude": "9.69241000"
                    },
                    {
                        "id": 28040,
                        "name": "Oberstenfeld",
                        "latitude": "49.02611000",
                        "longitude": "9.32083000"
                    },
                    {
                        "id": 28045,
                        "name": "Oberteuringen",
                        "latitude": "47.72409000",
                        "longitude": "9.46979000"
                    },
                    {
                        "id": 28056,
                        "name": "Oberwolfach",
                        "latitude": "48.31667000",
                        "longitude": "8.21667000"
                    },
                    {
                        "id": 28060,
                        "name": "Obrigheim",
                        "latitude": "49.35194000",
                        "longitude": "9.09083000"
                    },
                    {
                        "id": 28063,
                        "name": "Ochsenhausen",
                        "latitude": "48.07029000",
                        "longitude": "9.95030000"
                    },
                    {
                        "id": 28075,
                        "name": "Oedheim",
                        "latitude": "49.24028000",
                        "longitude": "9.25333000"
                    },
                    {
                        "id": 28085,
                        "name": "Offenau",
                        "latitude": "49.24583000",
                        "longitude": "9.16056000"
                    },
                    {
                        "id": 28090,
                        "name": "Offenburg",
                        "latitude": "48.47377000",
                        "longitude": "7.94495000"
                    },
                    {
                        "id": 28094,
                        "name": "Ofterdingen",
                        "latitude": "48.41667000",
                        "longitude": "9.03333000"
                    },
                    {
                        "id": 28096,
                        "name": "Oftersheim",
                        "latitude": "49.36528000",
                        "longitude": "8.58306000"
                    },
                    {
                        "id": 28097,
                        "name": "Ohlsbach",
                        "latitude": "48.43222000",
                        "longitude": "7.99384000"
                    },
                    {
                        "id": 28100,
                        "name": "Ohmden",
                        "latitude": "48.64599000",
                        "longitude": "9.52698000"
                    },
                    {
                        "id": 30545,
                        "name": "Öhningen",
                        "latitude": "47.66186000",
                        "longitude": "8.88674000"
                    },
                    {
                        "id": 30546,
                        "name": "Öhringen",
                        "latitude": "49.19884000",
                        "longitude": "9.50720000"
                    },
                    {
                        "id": 30547,
                        "name": "Ölbronn-Dürrn",
                        "latitude": "48.96667000",
                        "longitude": "8.75000000"
                    },
                    {
                        "id": 30548,
                        "name": "Öpfingen",
                        "latitude": "48.28636000",
                        "longitude": "9.80259000"
                    },
                    {
                        "id": 28118,
                        "name": "Oppenau",
                        "latitude": "48.47332000",
                        "longitude": "8.15970000"
                    },
                    {
                        "id": 28120,
                        "name": "Oppenweiler",
                        "latitude": "48.98270000",
                        "longitude": "9.45850000"
                    },
                    {
                        "id": 28129,
                        "name": "Orsingen-Nenzingen",
                        "latitude": "47.84272000",
                        "longitude": "8.95909000"
                    },
                    {
                        "id": 28131,
                        "name": "Ortenberg",
                        "latitude": "48.45158000",
                        "longitude": "7.97178000"
                    },
                    {
                        "id": 28144,
                        "name": "Ostelsheim",
                        "latitude": "48.72633000",
                        "longitude": "8.84816000"
                    },
                    {
                        "id": 28148,
                        "name": "Osterburken",
                        "latitude": "49.42997000",
                        "longitude": "9.42252000"
                    },
                    {
                        "id": 28160,
                        "name": "Ostfildern",
                        "latitude": "48.72704000",
                        "longitude": "9.24954000"
                    },
                    {
                        "id": 28164,
                        "name": "Ostrach",
                        "latitude": "47.95000000",
                        "longitude": "9.38333000"
                    },
                    {
                        "id": 30549,
                        "name": "Östringen",
                        "latitude": "49.21911000",
                        "longitude": "8.71192000"
                    },
                    {
                        "id": 30550,
                        "name": "Ötigheim",
                        "latitude": "48.89085000",
                        "longitude": "8.23442000"
                    },
                    {
                        "id": 30551,
                        "name": "Ötisheim",
                        "latitude": "48.96667000",
                        "longitude": "8.80000000"
                    },
                    {
                        "id": 28177,
                        "name": "Ottenbach",
                        "latitude": "48.73649000",
                        "longitude": "9.74844000"
                    },
                    {
                        "id": 28180,
                        "name": "Ottenhofen",
                        "latitude": "48.73560000",
                        "longitude": "8.12981000"
                    },
                    {
                        "id": 28192,
                        "name": "Ottersweier",
                        "latitude": "48.67022000",
                        "longitude": "8.11323000"
                    },
                    {
                        "id": 28201,
                        "name": "Owen",
                        "latitude": "48.58742000",
                        "longitude": "9.44978000"
                    },
                    {
                        "id": 28202,
                        "name": "Owingen",
                        "latitude": "47.80967000",
                        "longitude": "9.17173000"
                    },
                    {
                        "id": 28272,
                        "name": "Pfaffenhofen",
                        "latitude": "49.06444000",
                        "longitude": "8.97639000"
                    },
                    {
                        "id": 28276,
                        "name": "Pfaffenweiler",
                        "latitude": "47.93333000",
                        "longitude": "7.75000000"
                    },
                    {
                        "id": 28280,
                        "name": "Pfalzgrafenweiler",
                        "latitude": "48.52650000",
                        "longitude": "8.56582000"
                    },
                    {
                        "id": 28284,
                        "name": "Pfedelbach",
                        "latitude": "49.17806000",
                        "longitude": "9.50500000"
                    },
                    {
                        "id": 28289,
                        "name": "Pforzheim",
                        "latitude": "48.88436000",
                        "longitude": "8.69892000"
                    },
                    {
                        "id": 28291,
                        "name": "Pfronstetten",
                        "latitude": "48.27641000",
                        "longitude": "9.35995000"
                    },
                    {
                        "id": 28293,
                        "name": "Pfullendorf",
                        "latitude": "47.92610000",
                        "longitude": "9.25780000"
                    },
                    {
                        "id": 28294,
                        "name": "Pfullingen",
                        "latitude": "48.46458000",
                        "longitude": "9.22796000"
                    },
                    {
                        "id": 28296,
                        "name": "Philippsburg",
                        "latitude": "49.23170000",
                        "longitude": "8.46074000"
                    },
                    {
                        "id": 28313,
                        "name": "Plankstadt",
                        "latitude": "49.39444000",
                        "longitude": "8.59611000"
                    },
                    {
                        "id": 28320,
                        "name": "Pleidelsheim",
                        "latitude": "48.95920000",
                        "longitude": "9.20311000"
                    },
                    {
                        "id": 28327,
                        "name": "Pliezhausen",
                        "latitude": "48.55934000",
                        "longitude": "9.20749000"
                    },
                    {
                        "id": 28328,
                        "name": "Plochingen",
                        "latitude": "48.71067000",
                        "longitude": "9.41949000"
                    },
                    {
                        "id": 28335,
                        "name": "Plüderhausen",
                        "latitude": "48.79875000",
                        "longitude": "9.59587000"
                    },
                    {
                        "id": 28448,
                        "name": "Radolfzell",
                        "latitude": "47.74194000",
                        "longitude": "8.97098000"
                    },
                    {
                        "id": 28463,
                        "name": "Rammingen",
                        "latitude": "48.51814000",
                        "longitude": "10.17197000"
                    },
                    {
                        "id": 28470,
                        "name": "Rangendingen",
                        "latitude": "48.38168000",
                        "longitude": "8.88940000"
                    },
                    {
                        "id": 28479,
                        "name": "Rastatt",
                        "latitude": "48.85851000",
                        "longitude": "8.20965000"
                    },
                    {
                        "id": 28495,
                        "name": "Rauenberg",
                        "latitude": "49.26943000",
                        "longitude": "8.70344000"
                    },
                    {
                        "id": 28498,
                        "name": "Ravensburg",
                        "latitude": "47.78198000",
                        "longitude": "9.61062000"
                    },
                    {
                        "id": 28500,
                        "name": "Rechberghausen",
                        "latitude": "48.73080000",
                        "longitude": "9.64419000"
                    },
                    {
                        "id": 28524,
                        "name": "Regierungsbezirk Stuttgart",
                        "latitude": "49.08333000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 28536,
                        "name": "Reichartshausen",
                        "latitude": "49.35500000",
                        "longitude": "8.94528000"
                    },
                    {
                        "id": 28538,
                        "name": "Reichenau",
                        "latitude": "47.68885000",
                        "longitude": "9.06355000"
                    },
                    {
                        "id": 28541,
                        "name": "Reichenbach an der Fils",
                        "latitude": "48.71011000",
                        "longitude": "9.46429000"
                    },
                    {
                        "id": 28553,
                        "name": "Reilingen",
                        "latitude": "49.29833000",
                        "longitude": "8.56417000"
                    },
                    {
                        "id": 28578,
                        "name": "Renchen",
                        "latitude": "48.58850000",
                        "longitude": "8.01321000"
                    },
                    {
                        "id": 28583,
                        "name": "Renningen",
                        "latitude": "48.76974000",
                        "longitude": "8.93871000"
                    },
                    {
                        "id": 28596,
                        "name": "Reutlingen",
                        "latitude": "48.49144000",
                        "longitude": "9.20427000"
                    },
                    {
                        "id": 28604,
                        "name": "Rheinau",
                        "latitude": "48.66602000",
                        "longitude": "7.93659000"
                    },
                    {
                        "id": 28611,
                        "name": "Rheinfelden",
                        "latitude": "47.56013000",
                        "longitude": "7.78715000"
                    },
                    {
                        "id": 28613,
                        "name": "Rheinstetten",
                        "latitude": "48.96850000",
                        "longitude": "8.30704000"
                    },
                    {
                        "id": 28623,
                        "name": "Rickenbach",
                        "latitude": "47.61895000",
                        "longitude": "7.97873000"
                    },
                    {
                        "id": 28634,
                        "name": "Riederich",
                        "latitude": "48.56029000",
                        "longitude": "9.26883000"
                    },
                    {
                        "id": 28636,
                        "name": "Riedlingen",
                        "latitude": "48.15455000",
                        "longitude": "9.47558000"
                    },
                    {
                        "id": 28638,
                        "name": "Riegel",
                        "latitude": "48.15111000",
                        "longitude": "7.74915000"
                    },
                    {
                        "id": 28642,
                        "name": "Rielasingen-Worblingen",
                        "latitude": "47.73465000",
                        "longitude": "8.84013000"
                    },
                    {
                        "id": 28651,
                        "name": "Rietheim-Weilheim",
                        "latitude": "48.01667000",
                        "longitude": "8.76667000"
                    },
                    {
                        "id": 28663,
                        "name": "Ringsheim",
                        "latitude": "48.24765000",
                        "longitude": "7.77823000"
                    },
                    {
                        "id": 28692,
                        "name": "Rohrdorf",
                        "latitude": "48.56667000",
                        "longitude": "8.70000000"
                    },
                    {
                        "id": 28694,
                        "name": "Roigheim",
                        "latitude": "49.36472000",
                        "longitude": "9.34000000"
                    },
                    {
                        "id": 28705,
                        "name": "Rosenberg",
                        "latitude": "49.01892000",
                        "longitude": "10.02960000"
                    },
                    {
                        "id": 28706,
                        "name": "Rosenfeld",
                        "latitude": "48.28639000",
                        "longitude": "8.72357000"
                    },
                    {
                        "id": 28716,
                        "name": "Rot",
                        "latitude": "47.92278000",
                        "longitude": "9.10485000"
                    },
                    {
                        "id": 28717,
                        "name": "Rot am See",
                        "latitude": "49.25000000",
                        "longitude": "10.01667000"
                    },
                    {
                        "id": 28731,
                        "name": "Rottenacker",
                        "latitude": "48.23485000",
                        "longitude": "9.68956000"
                    },
                    {
                        "id": 28734,
                        "name": "Rottenburg",
                        "latitude": "48.47629000",
                        "longitude": "8.93528000"
                    },
                    {
                        "id": 28739,
                        "name": "Rottweil",
                        "latitude": "48.16783000",
                        "longitude": "8.62719000"
                    },
                    {
                        "id": 28750,
                        "name": "Rudersberg",
                        "latitude": "48.88515000",
                        "longitude": "9.52927000"
                    },
                    {
                        "id": 28807,
                        "name": "Rümmingen",
                        "latitude": "47.64120000",
                        "longitude": "7.64198000"
                    },
                    {
                        "id": 28767,
                        "name": "Ruppertshofen",
                        "latitude": "48.88275000",
                        "longitude": "9.81506000"
                    },
                    {
                        "id": 28770,
                        "name": "Rust",
                        "latitude": "48.26667000",
                        "longitude": "7.73333000"
                    },
                    {
                        "id": 28771,
                        "name": "Rutesheim",
                        "latitude": "48.80808000",
                        "longitude": "8.94536000"
                    },
                    {
                        "id": 28824,
                        "name": "Sachsenheim",
                        "latitude": "48.96000000",
                        "longitude": "9.06472000"
                    },
                    {
                        "id": 28830,
                        "name": "Salach",
                        "latitude": "48.69198000",
                        "longitude": "9.73715000"
                    },
                    {
                        "id": 28833,
                        "name": "Salem",
                        "latitude": "47.76258000",
                        "longitude": "9.29031000"
                    },
                    {
                        "id": 28856,
                        "name": "Sandhausen",
                        "latitude": "49.34278000",
                        "longitude": "8.65917000"
                    },
                    {
                        "id": 28862,
                        "name": "Sankt Blasien",
                        "latitude": "47.76252000",
                        "longitude": "8.12714000"
                    },
                    {
                        "id": 28866,
                        "name": "Sankt Georgen im Schwarzwald",
                        "latitude": "48.12716000",
                        "longitude": "8.33513000"
                    },
                    {
                        "id": 28870,
                        "name": "Sankt Johann",
                        "latitude": "48.45397000",
                        "longitude": "9.34396000"
                    },
                    {
                        "id": 28874,
                        "name": "Sankt Leon-Rot",
                        "latitude": "49.26593000",
                        "longitude": "8.61803000"
                    },
                    {
                        "id": 28879,
                        "name": "Sankt Märgen",
                        "latitude": "48.00805000",
                        "longitude": "8.09283000"
                    },
                    {
                        "id": 28880,
                        "name": "Sankt Peter",
                        "latitude": "48.01475000",
                        "longitude": "8.03294000"
                    },
                    {
                        "id": 28886,
                        "name": "Sasbach",
                        "latitude": "48.63971000",
                        "longitude": "8.09375000"
                    },
                    {
                        "id": 28887,
                        "name": "Sasbachwalden",
                        "latitude": "48.61667000",
                        "longitude": "8.13333000"
                    },
                    {
                        "id": 28893,
                        "name": "Satteldorf",
                        "latitude": "49.16953000",
                        "longitude": "10.07957000"
                    },
                    {
                        "id": 28896,
                        "name": "Sauldorf",
                        "latitude": "47.94371000",
                        "longitude": "9.10833000"
                    },
                    {
                        "id": 28897,
                        "name": "Saulgau",
                        "latitude": "48.01676000",
                        "longitude": "9.50064000"
                    },
                    {
                        "id": 28908,
                        "name": "Schallstadt",
                        "latitude": "47.95855000",
                        "longitude": "7.75755000"
                    },
                    {
                        "id": 28917,
                        "name": "Schechingen",
                        "latitude": "48.87341000",
                        "longitude": "9.91744000"
                    },
                    {
                        "id": 28919,
                        "name": "Scheer",
                        "latitude": "48.07292000",
                        "longitude": "9.29486000"
                    },
                    {
                        "id": 28925,
                        "name": "Schelklingen",
                        "latitude": "48.37575000",
                        "longitude": "9.73273000"
                    },
                    {
                        "id": 28930,
                        "name": "Schenkenzell",
                        "latitude": "48.31202000",
                        "longitude": "8.37212000"
                    },
                    {
                        "id": 28949,
                        "name": "Schiltach",
                        "latitude": "48.28932000",
                        "longitude": "8.34169000"
                    },
                    {
                        "id": 28960,
                        "name": "Schlaitdorf",
                        "latitude": "48.60431000",
                        "longitude": "9.22268000"
                    },
                    {
                        "id": 28964,
                        "name": "Schlat",
                        "latitude": "48.65321000",
                        "longitude": "9.70625000"
                    },
                    {
                        "id": 28976,
                        "name": "Schliengen",
                        "latitude": "47.75698000",
                        "longitude": "7.57645000"
                    },
                    {
                        "id": 28977,
                        "name": "Schlier",
                        "latitude": "47.77004000",
                        "longitude": "9.67354000"
                    },
                    {
                        "id": 28978,
                        "name": "Schlierbach",
                        "latitude": "48.67362000",
                        "longitude": "9.51811000"
                    },
                    {
                        "id": 28983,
                        "name": "Schluchsee",
                        "latitude": "47.81667000",
                        "longitude": "8.18333000"
                    },
                    {
                        "id": 29010,
                        "name": "Schnürpflingen",
                        "latitude": "48.27280000",
                        "longitude": "9.99292000"
                    },
                    {
                        "id": 29103,
                        "name": "Schömberg",
                        "latitude": "48.78713000",
                        "longitude": "8.64495000"
                    },
                    {
                        "id": 29013,
                        "name": "Schonach im Schwarzwald",
                        "latitude": "48.14229000",
                        "longitude": "8.20289000"
                    },
                    {
                        "id": 29104,
                        "name": "Schönaich",
                        "latitude": "48.65871000",
                        "longitude": "9.06012000"
                    },
                    {
                        "id": 29106,
                        "name": "Schönau",
                        "latitude": "49.43665000",
                        "longitude": "8.80880000"
                    },
                    {
                        "id": 29108,
                        "name": "Schönau im Schwarzwald",
                        "latitude": "47.78623000",
                        "longitude": "7.89445000"
                    },
                    {
                        "id": 29133,
                        "name": "Schönwald",
                        "latitude": "48.10549000",
                        "longitude": "8.20387000"
                    },
                    {
                        "id": 29019,
                        "name": "Schopfheim",
                        "latitude": "47.65105000",
                        "longitude": "7.82089000"
                    },
                    {
                        "id": 29021,
                        "name": "Schopfloch",
                        "latitude": "48.45477000",
                        "longitude": "8.55131000"
                    },
                    {
                        "id": 29024,
                        "name": "Schorndorf",
                        "latitude": "48.80537000",
                        "longitude": "9.52721000"
                    },
                    {
                        "id": 29028,
                        "name": "Schramberg",
                        "latitude": "48.22399000",
                        "longitude": "8.38583000"
                    },
                    {
                        "id": 29031,
                        "name": "Schriesheim",
                        "latitude": "49.47372000",
                        "longitude": "8.66360000"
                    },
                    {
                        "id": 29033,
                        "name": "Schrozberg",
                        "latitude": "49.34528000",
                        "longitude": "9.97944000"
                    },
                    {
                        "id": 29036,
                        "name": "Schuttertal",
                        "latitude": "48.26667000",
                        "longitude": "7.95000000"
                    },
                    {
                        "id": 29037,
                        "name": "Schutterwald",
                        "latitude": "48.45000000",
                        "longitude": "7.88333000"
                    },
                    {
                        "id": 29095,
                        "name": "Schwäbisch Gmünd",
                        "latitude": "48.79947000",
                        "longitude": "9.79809000"
                    },
                    {
                        "id": 29096,
                        "name": "Schwäbisch Hall",
                        "latitude": "49.11127000",
                        "longitude": "9.73908000"
                    },
                    {
                        "id": 29047,
                        "name": "Schwaigern",
                        "latitude": "49.14494000",
                        "longitude": "9.05525000"
                    },
                    {
                        "id": 29048,
                        "name": "Schwaikheim",
                        "latitude": "48.87733000",
                        "longitude": "9.34958000"
                    },
                    {
                        "id": 29056,
                        "name": "Schwanau",
                        "latitude": "48.36669000",
                        "longitude": "7.76244000"
                    },
                    {
                        "id": 29065,
                        "name": "Schwarzach",
                        "latitude": "48.74738000",
                        "longitude": "8.03738000"
                    },
                    {
                        "id": 29086,
                        "name": "Schwendi",
                        "latitude": "48.17424000",
                        "longitude": "9.97541000"
                    },
                    {
                        "id": 29088,
                        "name": "Schwenningen",
                        "latitude": "48.10000000",
                        "longitude": "9.00000000"
                    },
                    {
                        "id": 29092,
                        "name": "Schwetzingen",
                        "latitude": "49.38217000",
                        "longitude": "8.58230000"
                    },
                    {
                        "id": 29093,
                        "name": "Schwieberdingen",
                        "latitude": "48.87644000",
                        "longitude": "9.07439000"
                    },
                    {
                        "id": 29097,
                        "name": "Schwörstadt",
                        "latitude": "47.59314000",
                        "longitude": "7.87840000"
                    },
                    {
                        "id": 29141,
                        "name": "Seckach",
                        "latitude": "49.44222000",
                        "longitude": "9.33417000"
                    },
                    {
                        "id": 29143,
                        "name": "Seebach",
                        "latitude": "48.57621000",
                        "longitude": "8.17048000"
                    },
                    {
                        "id": 29148,
                        "name": "Seedorf",
                        "latitude": "48.24908000",
                        "longitude": "8.48993000"
                    },
                    {
                        "id": 29157,
                        "name": "Seelbach",
                        "latitude": "48.31055000",
                        "longitude": "7.94069000"
                    },
                    {
                        "id": 29175,
                        "name": "Seitingen-Oberflacht",
                        "latitude": "48.01667000",
                        "longitude": "8.71667000"
                    },
                    {
                        "id": 29196,
                        "name": "Sersheim",
                        "latitude": "48.96667000",
                        "longitude": "9.01667000"
                    },
                    {
                        "id": 29201,
                        "name": "Sexau",
                        "latitude": "48.10209000",
                        "longitude": "7.90757000"
                    },
                    {
                        "id": 29206,
                        "name": "Sickenhausen",
                        "latitude": "48.53252000",
                        "longitude": "9.18114000"
                    },
                    {
                        "id": 29212,
                        "name": "Siegelsbach",
                        "latitude": "49.26972000",
                        "longitude": "9.08972000"
                    },
                    {
                        "id": 29226,
                        "name": "Sigmaringen",
                        "latitude": "48.08829000",
                        "longitude": "9.23033000"
                    },
                    {
                        "id": 29227,
                        "name": "Sigmaringendorf",
                        "latitude": "48.06586000",
                        "longitude": "9.26208000"
                    },
                    {
                        "id": 29236,
                        "name": "Simmersfeld",
                        "latitude": "48.61667000",
                        "longitude": "8.51667000"
                    },
                    {
                        "id": 29238,
                        "name": "Simmozheim",
                        "latitude": "48.75127000",
                        "longitude": "8.81142000"
                    },
                    {
                        "id": 29239,
                        "name": "Sindelfingen",
                        "latitude": "48.70000000",
                        "longitude": "9.01667000"
                    },
                    {
                        "id": 29241,
                        "name": "Singen",
                        "latitude": "47.75935000",
                        "longitude": "8.84030000"
                    },
                    {
                        "id": 29245,
                        "name": "Sinsheim",
                        "latitude": "49.25290000",
                        "longitude": "8.87867000"
                    },
                    {
                        "id": 29246,
                        "name": "Sinzheim",
                        "latitude": "48.76667000",
                        "longitude": "8.16667000"
                    },
                    {
                        "id": 29250,
                        "name": "Sipplingen",
                        "latitude": "47.79678000",
                        "longitude": "9.09737000"
                    },
                    {
                        "id": 29493,
                        "name": "Sölden",
                        "latitude": "47.93333000",
                        "longitude": "7.81667000"
                    },
                    {
                        "id": 29277,
                        "name": "Sontheim an der Brenz",
                        "latitude": "48.55235000",
                        "longitude": "10.29097000"
                    },
                    {
                        "id": 29284,
                        "name": "Spaichingen",
                        "latitude": "48.07477000",
                        "longitude": "8.73508000"
                    },
                    {
                        "id": 29291,
                        "name": "Spechbach",
                        "latitude": "49.34639000",
                        "longitude": "8.88333000"
                    },
                    {
                        "id": 29301,
                        "name": "Spiegelberg",
                        "latitude": "49.04083000",
                        "longitude": "9.44444000"
                    },
                    {
                        "id": 29305,
                        "name": "Spraitbach",
                        "latitude": "48.88065000",
                        "longitude": "9.76217000"
                    },
                    {
                        "id": 29334,
                        "name": "Staig",
                        "latitude": "48.29998000",
                        "longitude": "9.99138000"
                    },
                    {
                        "id": 29345,
                        "name": "Staufen",
                        "latitude": "47.75686000",
                        "longitude": "8.21078000"
                    },
                    {
                        "id": 29352,
                        "name": "Stegen",
                        "latitude": "47.98333000",
                        "longitude": "7.96667000"
                    },
                    {
                        "id": 29360,
                        "name": "Steinach",
                        "latitude": "48.30000000",
                        "longitude": "8.05000000"
                    },
                    {
                        "id": 29369,
                        "name": "Steinen",
                        "latitude": "47.64446000",
                        "longitude": "7.73914000"
                    },
                    {
                        "id": 29370,
                        "name": "Steinenbronn",
                        "latitude": "48.66667000",
                        "longitude": "9.11667000"
                    },
                    {
                        "id": 29381,
                        "name": "Steinheim am Albuch",
                        "latitude": "48.69090000",
                        "longitude": "10.06382000"
                    },
                    {
                        "id": 29382,
                        "name": "Steinheim am der Murr",
                        "latitude": "48.96821000",
                        "longitude": "9.27708000"
                    },
                    {
                        "id": 29389,
                        "name": "Steinmauern",
                        "latitude": "48.90095000",
                        "longitude": "8.19692000"
                    },
                    {
                        "id": 29394,
                        "name": "Steißlingen",
                        "latitude": "47.80000000",
                        "longitude": "8.93333000"
                    },
                    {
                        "id": 29402,
                        "name": "Sternenfels",
                        "latitude": "49.05139000",
                        "longitude": "8.85083000"
                    },
                    {
                        "id": 29405,
                        "name": "Stetten am Kalten Markt",
                        "latitude": "48.12419000",
                        "longitude": "9.07775000"
                    },
                    {
                        "id": 29409,
                        "name": "Stimpfach",
                        "latitude": "49.06135000",
                        "longitude": "10.09274000"
                    },
                    {
                        "id": 29410,
                        "name": "Stockach",
                        "latitude": "47.85105000",
                        "longitude": "9.00910000"
                    },
                    {
                        "id": 29450,
                        "name": "Stödtlen",
                        "latitude": "49.00000000",
                        "longitude": "10.30000000"
                    },
                    {
                        "id": 29432,
                        "name": "Straßberg",
                        "latitude": "48.17805000",
                        "longitude": "9.09059000"
                    },
                    {
                        "id": 29455,
                        "name": "Stühlingen",
                        "latitude": "47.74580000",
                        "longitude": "8.44813000"
                    },
                    {
                        "id": 29444,
                        "name": "Stuttgart",
                        "latitude": "48.78232000",
                        "longitude": "9.17702000"
                    },
                    {
                        "id": 29445,
                        "name": "Stuttgart Feuerbach",
                        "latitude": "48.80867000",
                        "longitude": "9.15719000"
                    },
                    {
                        "id": 29446,
                        "name": "Stuttgart Mühlhausen",
                        "latitude": "48.84232000",
                        "longitude": "9.23028000"
                    },
                    {
                        "id": 29447,
                        "name": "Stuttgart-Ost",
                        "latitude": "48.78363000",
                        "longitude": "9.21032000"
                    },
                    {
                        "id": 29466,
                        "name": "Sulz am Neckar",
                        "latitude": "48.36241000",
                        "longitude": "8.63309000"
                    },
                    {
                        "id": 29470,
                        "name": "Sulzbach an der Murr",
                        "latitude": "49.00303000",
                        "longitude": "9.50030000"
                    },
                    {
                        "id": 29473,
                        "name": "Sulzburg",
                        "latitude": "47.84116000",
                        "longitude": "7.70777000"
                    },
                    {
                        "id": 29477,
                        "name": "Sulzfeld",
                        "latitude": "49.10472000",
                        "longitude": "8.85583000"
                    },
                    {
                        "id": 29509,
                        "name": "Süßen",
                        "latitude": "48.67934000",
                        "longitude": "9.75534000"
                    },
                    {
                        "id": 29698,
                        "name": "Täferrot",
                        "latitude": "48.84972000",
                        "longitude": "9.83824000"
                    },
                    {
                        "id": 29514,
                        "name": "Talheim",
                        "latitude": "49.08333000",
                        "longitude": "9.19306000"
                    },
                    {
                        "id": 29516,
                        "name": "Tamm",
                        "latitude": "48.91988000",
                        "longitude": "9.11556000"
                    },
                    {
                        "id": 29525,
                        "name": "Tannhausen",
                        "latitude": "48.97870000",
                        "longitude": "10.36129000"
                    },
                    {
                        "id": 29526,
                        "name": "Tannheim",
                        "latitude": "48.00000000",
                        "longitude": "10.08333000"
                    },
                    {
                        "id": 29533,
                        "name": "Tauberbischofsheim",
                        "latitude": "49.62472000",
                        "longitude": "9.66278000"
                    },
                    {
                        "id": 29557,
                        "name": "Tengen",
                        "latitude": "47.82128000",
                        "longitude": "8.66117000"
                    },
                    {
                        "id": 29558,
                        "name": "Teningen",
                        "latitude": "48.12952000",
                        "longitude": "7.81205000"
                    },
                    {
                        "id": 29559,
                        "name": "Tennenbronn",
                        "latitude": "48.19041000",
                        "longitude": "8.35176000"
                    },
                    {
                        "id": 29565,
                        "name": "Tettnang",
                        "latitude": "47.66857000",
                        "longitude": "9.59132000"
                    },
                    {
                        "id": 29610,
                        "name": "Tiefenbronn",
                        "latitude": "48.82398000",
                        "longitude": "8.80129000"
                    },
                    {
                        "id": 29619,
                        "name": "Titisee-Neustadt",
                        "latitude": "47.92104000",
                        "longitude": "8.19063000"
                    },
                    {
                        "id": 29627,
                        "name": "Todtmoos",
                        "latitude": "47.74014000",
                        "longitude": "8.00183000"
                    },
                    {
                        "id": 29628,
                        "name": "Todtnau",
                        "latitude": "47.82941000",
                        "longitude": "7.94380000"
                    },
                    {
                        "id": 29664,
                        "name": "Triberg",
                        "latitude": "48.13175000",
                        "longitude": "8.23317000"
                    },
                    {
                        "id": 29676,
                        "name": "Trochtelfingen",
                        "latitude": "48.30843000",
                        "longitude": "9.24491000"
                    },
                    {
                        "id": 29681,
                        "name": "Trossingen",
                        "latitude": "48.07667000",
                        "longitude": "8.64409000"
                    },
                    {
                        "id": 29704,
                        "name": "Tübingen",
                        "latitude": "48.52266000",
                        "longitude": "9.05222000"
                    },
                    {
                        "id": 29705,
                        "name": "Tübingen Region",
                        "latitude": "48.16667000",
                        "longitude": "9.50000000"
                    },
                    {
                        "id": 29690,
                        "name": "Tuningen",
                        "latitude": "48.03333000",
                        "longitude": "8.60000000"
                    },
                    {
                        "id": 29694,
                        "name": "Tuttlingen",
                        "latitude": "47.98464000",
                        "longitude": "8.81770000"
                    },
                    {
                        "id": 30555,
                        "name": "Überlingen",
                        "latitude": "47.76977000",
                        "longitude": "9.17136000"
                    },
                    {
                        "id": 29712,
                        "name": "Ubstadt-Weiher",
                        "latitude": "49.16296000",
                        "longitude": "8.63165000"
                    },
                    {
                        "id": 29733,
                        "name": "Uhingen",
                        "latitude": "48.70475000",
                        "longitude": "9.58570000"
                    },
                    {
                        "id": 29734,
                        "name": "Uhldingen-Mühlhofen",
                        "latitude": "47.73333000",
                        "longitude": "9.25000000"
                    },
                    {
                        "id": 30559,
                        "name": "Ühlingen-Birkendorf",
                        "latitude": "47.71667000",
                        "longitude": "8.31667000"
                    },
                    {
                        "id": 29737,
                        "name": "Ulm",
                        "latitude": "48.39841000",
                        "longitude": "9.99155000"
                    },
                    {
                        "id": 29740,
                        "name": "Umkirch",
                        "latitude": "48.03333000",
                        "longitude": "7.76667000"
                    },
                    {
                        "id": 29742,
                        "name": "Ummendorf",
                        "latitude": "48.06667000",
                        "longitude": "9.83333000"
                    },
                    {
                        "id": 29747,
                        "name": "Unlingen",
                        "latitude": "48.16734000",
                        "longitude": "9.52219000"
                    },
                    {
                        "id": 29757,
                        "name": "Untereisesheim",
                        "latitude": "49.21111000",
                        "longitude": "9.20194000"
                    },
                    {
                        "id": 29758,
                        "name": "Unterensingen",
                        "latitude": "48.65452000",
                        "longitude": "9.35799000"
                    },
                    {
                        "id": 29761,
                        "name": "Untergruppenbach",
                        "latitude": "49.08940000",
                        "longitude": "9.27516000"
                    },
                    {
                        "id": 29763,
                        "name": "Unterhausen",
                        "latitude": "48.42980000",
                        "longitude": "9.25504000"
                    },
                    {
                        "id": 29764,
                        "name": "Unterjettingen",
                        "latitude": "48.56230000",
                        "longitude": "8.78445000"
                    },
                    {
                        "id": 29765,
                        "name": "Unterkirnach",
                        "latitude": "48.07946000",
                        "longitude": "8.36575000"
                    },
                    {
                        "id": 29766,
                        "name": "Unterkrozingen",
                        "latitude": "47.91933000",
                        "longitude": "7.69045000"
                    },
                    {
                        "id": 29772,
                        "name": "Untermünkheim",
                        "latitude": "49.15255000",
                        "longitude": "9.73384000"
                    },
                    {
                        "id": 29775,
                        "name": "Unterreichenbach",
                        "latitude": "48.82496000",
                        "longitude": "8.70885000"
                    },
                    {
                        "id": 29778,
                        "name": "Unterschneidheim",
                        "latitude": "48.93333000",
                        "longitude": "10.36667000"
                    },
                    {
                        "id": 29790,
                        "name": "Urbach",
                        "latitude": "48.81680000",
                        "longitude": "9.57690000"
                    },
                    {
                        "id": 29804,
                        "name": "Uttenweiler",
                        "latitude": "48.15000000",
                        "longitude": "9.61667000"
                    },
                    {
                        "id": 29810,
                        "name": "Vaihingen an der Enz",
                        "latitude": "48.93563000",
                        "longitude": "8.96045000"
                    },
                    {
                        "id": 29828,
                        "name": "Vellberg",
                        "latitude": "49.08430000",
                        "longitude": "9.87914000"
                    },
                    {
                        "id": 29835,
                        "name": "Veringenstadt",
                        "latitude": "48.18515000",
                        "longitude": "9.21079000"
                    },
                    {
                        "id": 29852,
                        "name": "Villingen-Schwenningen",
                        "latitude": "48.06226000",
                        "longitude": "8.49358000"
                    },
                    {
                        "id": 29853,
                        "name": "Villingendorf",
                        "latitude": "48.20000000",
                        "longitude": "8.58333000"
                    },
                    {
                        "id": 29866,
                        "name": "Vogt",
                        "latitude": "47.76667000",
                        "longitude": "9.76667000"
                    },
                    {
                        "id": 29868,
                        "name": "Vogtsburg",
                        "latitude": "48.09688000",
                        "longitude": "7.64185000"
                    },
                    {
                        "id": 29888,
                        "name": "Vöhrenbach",
                        "latitude": "48.05000000",
                        "longitude": "8.30000000"
                    },
                    {
                        "id": 29889,
                        "name": "Vöhringen",
                        "latitude": "48.33446000",
                        "longitude": "8.66392000"
                    },
                    {
                        "id": 29874,
                        "name": "Volkertshausen",
                        "latitude": "47.81667000",
                        "longitude": "8.86667000"
                    },
                    {
                        "id": 29894,
                        "name": "Vörstetten",
                        "latitude": "48.06667000",
                        "longitude": "7.85000000"
                    },
                    {
                        "id": 29916,
                        "name": "Waghäusel",
                        "latitude": "49.24991000",
                        "longitude": "8.51257000"
                    },
                    {
                        "id": 29922,
                        "name": "Waiblingen",
                        "latitude": "48.83241000",
                        "longitude": "9.31641000"
                    },
                    {
                        "id": 29923,
                        "name": "Waibstadt",
                        "latitude": "49.29505000",
                        "longitude": "8.91771000"
                    },
                    {
                        "id": 29928,
                        "name": "Wain",
                        "latitude": "48.18904000",
                        "longitude": "10.02090000"
                    },
                    {
                        "id": 29932,
                        "name": "Wald",
                        "latitude": "47.93333000",
                        "longitude": "9.16667000"
                    },
                    {
                        "id": 29940,
                        "name": "Waldburg",
                        "latitude": "47.75710000",
                        "longitude": "9.71342000"
                    },
                    {
                        "id": 29945,
                        "name": "Waldenbuch",
                        "latitude": "48.63830000",
                        "longitude": "9.13256000"
                    },
                    {
                        "id": 29947,
                        "name": "Waldenburg",
                        "latitude": "49.18468000",
                        "longitude": "9.63994000"
                    },
                    {
                        "id": 29954,
                        "name": "Waldkirch",
                        "latitude": "48.09585000",
                        "longitude": "7.96371000"
                    },
                    {
                        "id": 29963,
                        "name": "Waldshut-Tiengen",
                        "latitude": "47.62323000",
                        "longitude": "8.21717000"
                    },
                    {
                        "id": 29965,
                        "name": "Waldstetten",
                        "latitude": "48.76615000",
                        "longitude": "9.82135000"
                    },
                    {
                        "id": 29968,
                        "name": "Walheim",
                        "latitude": "49.01417000",
                        "longitude": "9.15111000"
                    },
                    {
                        "id": 29972,
                        "name": "Walldorf",
                        "latitude": "49.30637000",
                        "longitude": "8.64236000"
                    },
                    {
                        "id": 29973,
                        "name": "Walldürn",
                        "latitude": "49.58358000",
                        "longitude": "9.36642000"
                    },
                    {
                        "id": 29985,
                        "name": "Wallhausen",
                        "latitude": "49.21042000",
                        "longitude": "10.06219000"
                    },
                    {
                        "id": 30004,
                        "name": "Wangen",
                        "latitude": "47.68950000",
                        "longitude": "9.83247000"
                    },
                    {
                        "id": 30009,
                        "name": "Wannweil",
                        "latitude": "48.51667000",
                        "longitude": "9.15000000"
                    },
                    {
                        "id": 30026,
                        "name": "Warthausen",
                        "latitude": "48.12863000",
                        "longitude": "9.79749000"
                    },
                    {
                        "id": 30437,
                        "name": "Wäschenbeuren",
                        "latitude": "48.75991000",
                        "longitude": "9.68735000"
                    },
                    {
                        "id": 30059,
                        "name": "Wehingen",
                        "latitude": "48.14533000",
                        "longitude": "8.79151000"
                    },
                    {
                        "id": 30061,
                        "name": "Wehr",
                        "latitude": "47.62983000",
                        "longitude": "7.90423000"
                    },
                    {
                        "id": 30071,
                        "name": "Weidenstetten",
                        "latitude": "48.55250000",
                        "longitude": "9.99610000"
                    },
                    {
                        "id": 30079,
                        "name": "Weikersheim",
                        "latitude": "49.47866000",
                        "longitude": "9.89977000"
                    },
                    {
                        "id": 30081,
                        "name": "Weil am Rhein",
                        "latitude": "47.59331000",
                        "longitude": "7.62082000"
                    },
                    {
                        "id": 30082,
                        "name": "Weil der Stadt",
                        "latitude": "48.74953000",
                        "longitude": "8.87176000"
                    },
                    {
                        "id": 30083,
                        "name": "Weil im Schönbuch",
                        "latitude": "48.62270000",
                        "longitude": "9.06355000"
                    },
                    {
                        "id": 30092,
                        "name": "Weilheim",
                        "latitude": "47.66667000",
                        "longitude": "8.23333000"
                    },
                    {
                        "id": 30093,
                        "name": "Weilheim an der Teck",
                        "latitude": "48.61572000",
                        "longitude": "9.53751000"
                    },
                    {
                        "id": 30100,
                        "name": "Weingarten",
                        "latitude": "49.05457000",
                        "longitude": "8.52678000"
                    },
                    {
                        "id": 30101,
                        "name": "Weinheim",
                        "latitude": "49.54887000",
                        "longitude": "8.66697000"
                    },
                    {
                        "id": 30102,
                        "name": "Weinsberg",
                        "latitude": "49.15127000",
                        "longitude": "9.28762000"
                    },
                    {
                        "id": 30104,
                        "name": "Weinstadt-Endersbach",
                        "latitude": "48.81311000",
                        "longitude": "9.36387000"
                    },
                    {
                        "id": 30108,
                        "name": "Weisenbach",
                        "latitude": "48.72757000",
                        "longitude": "8.35378000"
                    },
                    {
                        "id": 30112,
                        "name": "Weissach",
                        "latitude": "48.84687000",
                        "longitude": "8.92828000"
                    },
                    {
                        "id": 30122,
                        "name": "Weißbach",
                        "latitude": "49.29717000",
                        "longitude": "9.59531000"
                    },
                    {
                        "id": 30113,
                        "name": "Weisweil",
                        "latitude": "48.19939000",
                        "longitude": "7.67713000"
                    },
                    {
                        "id": 30144,
                        "name": "Wellendingen",
                        "latitude": "48.14745000",
                        "longitude": "8.70375000"
                    },
                    {
                        "id": 30149,
                        "name": "Welzheim",
                        "latitude": "48.87675000",
                        "longitude": "9.63434000"
                    },
                    {
                        "id": 30158,
                        "name": "Wendlingen am Neckar",
                        "latitude": "48.67124000",
                        "longitude": "9.37632000"
                    },
                    {
                        "id": 30166,
                        "name": "Werbach",
                        "latitude": "49.67083000",
                        "longitude": "9.63944000"
                    },
                    {
                        "id": 30178,
                        "name": "Wernau",
                        "latitude": "48.69306000",
                        "longitude": "9.41533000"
                    },
                    {
                        "id": 30188,
                        "name": "Wertheim",
                        "latitude": "49.75900000",
                        "longitude": "9.50852000"
                    },
                    {
                        "id": 30208,
                        "name": "Westerheim",
                        "latitude": "48.51511000",
                        "longitude": "9.62424000"
                    },
                    {
                        "id": 30216,
                        "name": "Westerstetten",
                        "latitude": "48.51916000",
                        "longitude": "9.95494000"
                    },
                    {
                        "id": 30218,
                        "name": "Westhausen",
                        "latitude": "48.88333000",
                        "longitude": "10.18333000"
                    },
                    {
                        "id": 30237,
                        "name": "Widdern",
                        "latitude": "49.31825000",
                        "longitude": "9.42209000"
                    },
                    {
                        "id": 30251,
                        "name": "Wiernsheim",
                        "latitude": "48.88333000",
                        "longitude": "8.85000000"
                    },
                    {
                        "id": 30257,
                        "name": "Wiesenbach",
                        "latitude": "49.36139000",
                        "longitude": "8.80361000"
                    },
                    {
                        "id": 30260,
                        "name": "Wiesensteig",
                        "latitude": "48.56127000",
                        "longitude": "9.62540000"
                    },
                    {
                        "id": 30264,
                        "name": "Wiesloch",
                        "latitude": "49.29504000",
                        "longitude": "8.69846000"
                    },
                    {
                        "id": 30273,
                        "name": "Wildberg",
                        "latitude": "48.62336000",
                        "longitude": "8.74518000"
                    },
                    {
                        "id": 30283,
                        "name": "Wilhelmsdorf",
                        "latitude": "47.86612000",
                        "longitude": "9.42621000"
                    },
                    {
                        "id": 30285,
                        "name": "Wilhelmsfeld",
                        "latitude": "49.47056000",
                        "longitude": "8.75361000"
                    },
                    {
                        "id": 30298,
                        "name": "Willstätt",
                        "latitude": "48.54071000",
                        "longitude": "7.89314000"
                    },
                    {
                        "id": 30308,
                        "name": "Wimsheim",
                        "latitude": "48.85000000",
                        "longitude": "8.83333000"
                    },
                    {
                        "id": 30326,
                        "name": "Winnenden",
                        "latitude": "48.87563000",
                        "longitude": "9.39819000"
                    },
                    {
                        "id": 30330,
                        "name": "Winterbach",
                        "latitude": "48.79918000",
                        "longitude": "9.47914000"
                    },
                    {
                        "id": 30334,
                        "name": "Winterlingen",
                        "latitude": "48.18333000",
                        "longitude": "9.11667000"
                    },
                    {
                        "id": 30364,
                        "name": "Wittnau",
                        "latitude": "47.95000000",
                        "longitude": "7.81667000"
                    },
                    {
                        "id": 30374,
                        "name": "Wolfach",
                        "latitude": "48.29319000",
                        "longitude": "8.21580000"
                    },
                    {
                        "id": 30375,
                        "name": "Wolfegg",
                        "latitude": "47.82030000",
                        "longitude": "9.79491000"
                    },
                    {
                        "id": 30386,
                        "name": "Wolfschlugen",
                        "latitude": "48.65000000",
                        "longitude": "9.28333000"
                    },
                    {
                        "id": 30397,
                        "name": "Wolpertshausen",
                        "latitude": "49.16750000",
                        "longitude": "9.84472000"
                    },
                    {
                        "id": 30398,
                        "name": "Wolpertswende",
                        "latitude": "47.89471000",
                        "longitude": "9.61202000"
                    },
                    {
                        "id": 30445,
                        "name": "Wört",
                        "latitude": "49.03047000",
                        "longitude": "10.27239000"
                    },
                    {
                        "id": 30452,
                        "name": "Wössingen",
                        "latitude": "49.01205000",
                        "longitude": "8.60754000"
                    },
                    {
                        "id": 30422,
                        "name": "Wurmberg",
                        "latitude": "48.86667000",
                        "longitude": "8.81667000"
                    },
                    {
                        "id": 30423,
                        "name": "Wurmlingen",
                        "latitude": "48.00000000",
                        "longitude": "8.78333000"
                    },
                    {
                        "id": 30460,
                        "name": "Wüstenrot",
                        "latitude": "49.08083000",
                        "longitude": "9.46056000"
                    },
                    {
                        "id": 30433,
                        "name": "Wutöschingen",
                        "latitude": "47.66019000",
                        "longitude": "8.36755000"
                    },
                    {
                        "id": 30434,
                        "name": "Wyhl",
                        "latitude": "48.16617000",
                        "longitude": "7.64917000"
                    },
                    {
                        "id": 30463,
                        "name": "Zaberfeld",
                        "latitude": "49.05611000",
                        "longitude": "8.92694000"
                    },
                    {
                        "id": 30466,
                        "name": "Zaisenhausen",
                        "latitude": "49.10667000",
                        "longitude": "8.81278000"
                    },
                    {
                        "id": 30484,
                        "name": "Zell",
                        "latitude": "48.69235000",
                        "longitude": "8.06301000"
                    },
                    {
                        "id": 30487,
                        "name": "Zell im Wiesental",
                        "latitude": "47.70555000",
                        "longitude": "7.85248000"
                    },
                    {
                        "id": 30488,
                        "name": "Zell unter Aichelberg",
                        "latitude": "48.64882000",
                        "longitude": "9.57137000"
                    },
                    {
                        "id": 30508,
                        "name": "Zimmern ob Rottweil",
                        "latitude": "48.16660000",
                        "longitude": "8.59436000"
                    },
                    {
                        "id": 30530,
                        "name": "Zuzenhausen",
                        "latitude": "49.29636000",
                        "longitude": "8.82254000"
                    },
                    {
                        "id": 30532,
                        "name": "Zweiflingen",
                        "latitude": "49.25639000",
                        "longitude": "9.51806000"
                    },
                    {
                        "id": 30535,
                        "name": "Zwiefalten",
                        "latitude": "48.23396000",
                        "longitude": "9.46232000"
                    }
                ]
            },
            {
                "id": 3009,
                "name": "Bavaria",
                "iso2": "BY",
                "latitude": "48.79044720",
                "longitude": "11.49788950",
                "type": "land",
                "cities": [
                    {
                        "id": 23466,
                        "name": "Abenberg",
                        "latitude": "49.24282000",
                        "longitude": "10.96401000"
                    },
                    {
                        "id": 23467,
                        "name": "Abensberg",
                        "latitude": "48.81684000",
                        "longitude": "11.84980000"
                    },
                    {
                        "id": 23468,
                        "name": "Absberg",
                        "latitude": "49.14438000",
                        "longitude": "10.88101000"
                    },
                    {
                        "id": 23474,
                        "name": "Achslach",
                        "latitude": "48.97171000",
                        "longitude": "12.93511000"
                    },
                    {
                        "id": 23481,
                        "name": "Adelsdorf",
                        "latitude": "49.47022000",
                        "longitude": "10.68522000"
                    },
                    {
                        "id": 23483,
                        "name": "Adelshofen",
                        "latitude": "48.18333000",
                        "longitude": "11.11667000"
                    },
                    {
                        "id": 23484,
                        "name": "Adelsried",
                        "latitude": "48.42465000",
                        "longitude": "10.71828000"
                    },
                    {
                        "id": 23485,
                        "name": "Adelzhausen",
                        "latitude": "48.35671000",
                        "longitude": "11.13851000"
                    },
                    {
                        "id": 23491,
                        "name": "Adlkofen",
                        "latitude": "48.55000000",
                        "longitude": "12.26667000"
                    },
                    {
                        "id": 23496,
                        "name": "Affing",
                        "latitude": "48.46667000",
                        "longitude": "10.98333000"
                    },
                    {
                        "id": 23499,
                        "name": "Aham",
                        "latitude": "48.34821000",
                        "longitude": "12.16156000"
                    },
                    {
                        "id": 23509,
                        "name": "Aholfing",
                        "latitude": "48.94283000",
                        "longitude": "12.46857000"
                    },
                    {
                        "id": 23510,
                        "name": "Aholming",
                        "latitude": "48.73542000",
                        "longitude": "12.90997000"
                    },
                    {
                        "id": 23511,
                        "name": "Ahorn",
                        "latitude": "50.23762000",
                        "longitude": "10.95417000"
                    },
                    {
                        "id": 23516,
                        "name": "Aichach",
                        "latitude": "48.45755000",
                        "longitude": "11.13413000"
                    },
                    {
                        "id": 23518,
                        "name": "Aichen",
                        "latitude": "48.22898000",
                        "longitude": "10.53949000"
                    },
                    {
                        "id": 23521,
                        "name": "Aidenbach",
                        "latitude": "48.57028000",
                        "longitude": "13.09000000"
                    },
                    {
                        "id": 23522,
                        "name": "Aidhausen",
                        "latitude": "50.15000000",
                        "longitude": "10.43333000"
                    },
                    {
                        "id": 23524,
                        "name": "Aiglsbach",
                        "latitude": "48.69211000",
                        "longitude": "11.70831000"
                    },
                    {
                        "id": 23525,
                        "name": "Aindling",
                        "latitude": "48.51360000",
                        "longitude": "10.95315000"
                    },
                    {
                        "id": 23526,
                        "name": "Ainring",
                        "latitude": "47.81311000",
                        "longitude": "12.94048000"
                    },
                    {
                        "id": 23527,
                        "name": "Aislingen",
                        "latitude": "48.50648000",
                        "longitude": "10.45778000"
                    },
                    {
                        "id": 23529,
                        "name": "Aitrang",
                        "latitude": "47.81667000",
                        "longitude": "10.53333000"
                    },
                    {
                        "id": 23531,
                        "name": "Albaching",
                        "latitude": "48.11011000",
                        "longitude": "12.11074000"
                    },
                    {
                        "id": 23536,
                        "name": "Albertshofen",
                        "latitude": "49.76667000",
                        "longitude": "10.16667000"
                    },
                    {
                        "id": 23543,
                        "name": "Aldersbach",
                        "latitude": "48.58972000",
                        "longitude": "13.08971000"
                    },
                    {
                        "id": 23545,
                        "name": "Alerheim",
                        "latitude": "48.85000000",
                        "longitude": "10.61667000"
                    },
                    {
                        "id": 23546,
                        "name": "Alesheim",
                        "latitude": "49.04648000",
                        "longitude": "10.86496000"
                    },
                    {
                        "id": 23547,
                        "name": "Aletshausen",
                        "latitude": "48.19859000",
                        "longitude": "10.38877000"
                    },
                    {
                        "id": 23550,
                        "name": "Alfeld",
                        "latitude": "49.43333000",
                        "longitude": "11.55000000"
                    },
                    {
                        "id": 23558,
                        "name": "Allersberg",
                        "latitude": "49.25132000",
                        "longitude": "11.23659000"
                    },
                    {
                        "id": 23559,
                        "name": "Allershausen",
                        "latitude": "48.43333000",
                        "longitude": "11.60000000"
                    },
                    {
                        "id": 23560,
                        "name": "Alling",
                        "latitude": "48.14034000",
                        "longitude": "11.30144000"
                    },
                    {
                        "id": 23583,
                        "name": "Altdorf",
                        "latitude": "49.38560000",
                        "longitude": "11.35730000"
                    },
                    {
                        "id": 23587,
                        "name": "Alteglofsheim",
                        "latitude": "48.91667000",
                        "longitude": "12.20000000"
                    },
                    {
                        "id": 23595,
                        "name": "Altenbuch",
                        "latitude": "49.82861000",
                        "longitude": "9.40139000"
                    },
                    {
                        "id": 23599,
                        "name": "Altendorf",
                        "latitude": "50.08424000",
                        "longitude": "11.16786000"
                    },
                    {
                        "id": 23607,
                        "name": "Altenkunstadt",
                        "latitude": "50.12504000",
                        "longitude": "11.25030000"
                    },
                    {
                        "id": 23608,
                        "name": "Altenmarkt",
                        "latitude": "47.77960000",
                        "longitude": "12.13560000"
                    },
                    {
                        "id": 23610,
                        "name": "Altenmünster",
                        "latitude": "48.46495000",
                        "longitude": "10.59065000"
                    },
                    {
                        "id": 23614,
                        "name": "Altenstadt",
                        "latitude": "48.16030000",
                        "longitude": "10.11437000"
                    },
                    {
                        "id": 23616,
                        "name": "Altenthann",
                        "latitude": "49.10000000",
                        "longitude": "12.30000000"
                    },
                    {
                        "id": 23618,
                        "name": "Alterhofen",
                        "latitude": "48.84659000",
                        "longitude": "12.62012000"
                    },
                    {
                        "id": 23620,
                        "name": "Altfraunhofen",
                        "latitude": "48.45000000",
                        "longitude": "12.16667000"
                    },
                    {
                        "id": 23622,
                        "name": "Althegnenberg",
                        "latitude": "48.23333000",
                        "longitude": "11.06667000"
                    },
                    {
                        "id": 23630,
                        "name": "Altomünster",
                        "latitude": "48.38767000",
                        "longitude": "11.25691000"
                    },
                    {
                        "id": 23639,
                        "name": "Altötting",
                        "latitude": "48.22533000",
                        "longitude": "12.67665000"
                    },
                    {
                        "id": 23638,
                        "name": "Altusried",
                        "latitude": "47.80410000",
                        "longitude": "10.21429000"
                    },
                    {
                        "id": 23641,
                        "name": "Alzenau in Unterfranken",
                        "latitude": "50.08880000",
                        "longitude": "9.06455000"
                    },
                    {
                        "id": 23643,
                        "name": "Amberg",
                        "latitude": "49.44287000",
                        "longitude": "11.86267000"
                    },
                    {
                        "id": 23645,
                        "name": "Amendingen",
                        "latitude": "48.00302000",
                        "longitude": "10.17918000"
                    },
                    {
                        "id": 23646,
                        "name": "Amerang",
                        "latitude": "47.99139000",
                        "longitude": "12.30795000"
                    },
                    {
                        "id": 23647,
                        "name": "Ammerndorf",
                        "latitude": "49.42335000",
                        "longitude": "10.85011000"
                    },
                    {
                        "id": 23648,
                        "name": "Ammerthal",
                        "latitude": "49.44123000",
                        "longitude": "11.76181000"
                    },
                    {
                        "id": 23649,
                        "name": "Ampfing",
                        "latitude": "48.25400000",
                        "longitude": "12.41515000"
                    },
                    {
                        "id": 23653,
                        "name": "Andechs",
                        "latitude": "47.97464000",
                        "longitude": "11.18279000"
                    },
                    {
                        "id": 23666,
                        "name": "Ansbach",
                        "latitude": "49.30481000",
                        "longitude": "10.59310000"
                    },
                    {
                        "id": 23667,
                        "name": "Antdorf",
                        "latitude": "47.75133000",
                        "longitude": "11.30845000"
                    },
                    {
                        "id": 23668,
                        "name": "Anzing",
                        "latitude": "48.15171000",
                        "longitude": "11.85330000"
                    },
                    {
                        "id": 23672,
                        "name": "Apfeldorf",
                        "latitude": "47.90000000",
                        "longitude": "10.93333000"
                    },
                    {
                        "id": 23679,
                        "name": "Arberg",
                        "latitude": "49.14428000",
                        "longitude": "10.61722000"
                    },
                    {
                        "id": 23681,
                        "name": "Aresing",
                        "latitude": "48.27704000",
                        "longitude": "12.60538000"
                    },
                    {
                        "id": 23684,
                        "name": "Arnbruck",
                        "latitude": "49.13012000",
                        "longitude": "12.99820000"
                    },
                    {
                        "id": 23687,
                        "name": "Arnschwang",
                        "latitude": "49.27663000",
                        "longitude": "12.81595000"
                    },
                    {
                        "id": 23689,
                        "name": "Arnstein",
                        "latitude": "49.97767000",
                        "longitude": "9.96983000"
                    },
                    {
                        "id": 23690,
                        "name": "Arnstorf",
                        "latitude": "48.55840000",
                        "longitude": "12.81674000"
                    },
                    {
                        "id": 23692,
                        "name": "Arrach",
                        "latitude": "49.19149000",
                        "longitude": "12.99387000"
                    },
                    {
                        "id": 23697,
                        "name": "Arzberg",
                        "latitude": "50.05774000",
                        "longitude": "12.18676000"
                    },
                    {
                        "id": 23700,
                        "name": "Asbach-Bäumenheim",
                        "latitude": "48.68333000",
                        "longitude": "10.81667000"
                    },
                    {
                        "id": 23701,
                        "name": "Ascha",
                        "latitude": "49.00000000",
                        "longitude": "12.63333000"
                    },
                    {
                        "id": 23702,
                        "name": "Aschaffenburg",
                        "latitude": "49.97704000",
                        "longitude": "9.15214000"
                    },
                    {
                        "id": 23703,
                        "name": "Aschau am Inn",
                        "latitude": "48.19845000",
                        "longitude": "12.35003000"
                    },
                    {
                        "id": 23704,
                        "name": "Aschau im Chiemgau",
                        "latitude": "47.77689000",
                        "longitude": "12.32297000"
                    },
                    {
                        "id": 23708,
                        "name": "Aschheim",
                        "latitude": "48.17112000",
                        "longitude": "11.71675000"
                    },
                    {
                        "id": 23749,
                        "name": "Aßling",
                        "latitude": "47.99297000",
                        "longitude": "12.00643000"
                    },
                    {
                        "id": 23715,
                        "name": "Attenhofen",
                        "latitude": "48.65072000",
                        "longitude": "11.84850000"
                    },
                    {
                        "id": 23716,
                        "name": "Attenkirchen",
                        "latitude": "48.50526000",
                        "longitude": "11.76011000"
                    },
                    {
                        "id": 23718,
                        "name": "Atting",
                        "latitude": "48.89412000",
                        "longitude": "12.48776000"
                    },
                    {
                        "id": 23722,
                        "name": "Au in der Hallertau",
                        "latitude": "48.55838000",
                        "longitude": "11.74138000"
                    },
                    {
                        "id": 23723,
                        "name": "Aub",
                        "latitude": "49.55267000",
                        "longitude": "10.06530000"
                    },
                    {
                        "id": 23725,
                        "name": "Auerbach",
                        "latitude": "48.80353000",
                        "longitude": "13.09952000"
                    },
                    {
                        "id": 23728,
                        "name": "Aufhausen",
                        "latitude": "48.87205000",
                        "longitude": "12.28210000"
                    },
                    {
                        "id": 23729,
                        "name": "Aufseß",
                        "latitude": "49.88370000",
                        "longitude": "11.22692000"
                    },
                    {
                        "id": 23731,
                        "name": "Augsburg",
                        "latitude": "48.37154000",
                        "longitude": "10.89851000"
                    },
                    {
                        "id": 23735,
                        "name": "Auhausen",
                        "latitude": "49.00790000",
                        "longitude": "10.62240000"
                    },
                    {
                        "id": 23740,
                        "name": "Aura im Sinngrund",
                        "latitude": "50.17819000",
                        "longitude": "9.57547000"
                    },
                    {
                        "id": 23743,
                        "name": "Außernzell",
                        "latitude": "48.72409000",
                        "longitude": "13.20291000"
                    },
                    {
                        "id": 23745,
                        "name": "Aying",
                        "latitude": "47.97010000",
                        "longitude": "11.77752000"
                    },
                    {
                        "id": 23747,
                        "name": "Aystetten",
                        "latitude": "48.40556000",
                        "longitude": "10.77742000"
                    },
                    {
                        "id": 23751,
                        "name": "Baar-Ebenhausen",
                        "latitude": "48.67065000",
                        "longitude": "11.46983000"
                    },
                    {
                        "id": 23752,
                        "name": "Babenhausen",
                        "latitude": "48.14497000",
                        "longitude": "10.25325000"
                    },
                    {
                        "id": 23754,
                        "name": "Babensham",
                        "latitude": "48.08333000",
                        "longitude": "12.26667000"
                    },
                    {
                        "id": 23755,
                        "name": "Bach",
                        "latitude": "49.40000000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 23757,
                        "name": "Bachhagel",
                        "latitude": "48.63217000",
                        "longitude": "10.32045000"
                    },
                    {
                        "id": 24458,
                        "name": "Bächingen an der Brenz",
                        "latitude": "48.54627000",
                        "longitude": "10.31281000"
                    },
                    {
                        "id": 23759,
                        "name": "Bad Abbach",
                        "latitude": "48.93754000",
                        "longitude": "12.04494000"
                    },
                    {
                        "id": 23760,
                        "name": "Bad Aibling",
                        "latitude": "47.86380000",
                        "longitude": "12.01055000"
                    },
                    {
                        "id": 23761,
                        "name": "Bad Alexandersbad",
                        "latitude": "50.01667000",
                        "longitude": "12.01667000"
                    },
                    {
                        "id": 23769,
                        "name": "Bad Berneck im Fichtelgebirge",
                        "latitude": "50.04564000",
                        "longitude": "11.67238000"
                    },
                    {
                        "id": 23772,
                        "name": "Bad Birnbach",
                        "latitude": "48.44489000",
                        "longitude": "13.09103000"
                    },
                    {
                        "id": 23774,
                        "name": "Bad Bocklet",
                        "latitude": "50.26648000",
                        "longitude": "10.07902000"
                    },
                    {
                        "id": 23778,
                        "name": "Bad Brückenau",
                        "latitude": "50.30853000",
                        "longitude": "9.78985000"
                    },
                    {
                        "id": 23792,
                        "name": "Bad Endorf",
                        "latitude": "47.90901000",
                        "longitude": "12.29795000"
                    },
                    {
                        "id": 23795,
                        "name": "Bad Feilnbach",
                        "latitude": "47.77331000",
                        "longitude": "12.00973000"
                    },
                    {
                        "id": 23799,
                        "name": "Bad Füssing",
                        "latitude": "48.35100000",
                        "longitude": "13.31200000"
                    },
                    {
                        "id": 23801,
                        "name": "Bad Griesbach",
                        "latitude": "48.45181000",
                        "longitude": "13.19329000"
                    },
                    {
                        "id": 23804,
                        "name": "Bad Heilbrunn",
                        "latitude": "47.74671000",
                        "longitude": "11.45934000"
                    },
                    {
                        "id": 23813,
                        "name": "Bad Kissingen",
                        "latitude": "50.20228000",
                        "longitude": "10.07784000"
                    },
                    {
                        "id": 23816,
                        "name": "Bad Kohlgrub",
                        "latitude": "47.66667000",
                        "longitude": "11.05000000"
                    },
                    {
                        "id": 23819,
                        "name": "Bad Königshofen im Grabfeld",
                        "latitude": "50.30082000",
                        "longitude": "10.46887000"
                    },
                    {
                        "id": 23843,
                        "name": "Bad Neustadt an der Saale",
                        "latitude": "50.32174000",
                        "longitude": "10.20673000"
                    },
                    {
                        "id": 23850,
                        "name": "Bad Reichenhall",
                        "latitude": "47.72947000",
                        "longitude": "12.87819000"
                    },
                    {
                        "id": 23870,
                        "name": "Bad Staffelstein",
                        "latitude": "50.10199000",
                        "longitude": "11.00128000"
                    },
                    {
                        "id": 23871,
                        "name": "Bad Steben",
                        "latitude": "50.36648000",
                        "longitude": "11.64438000"
                    },
                    {
                        "id": 23878,
                        "name": "Bad Tölz",
                        "latitude": "47.76111000",
                        "longitude": "11.55890000"
                    },
                    {
                        "id": 23882,
                        "name": "Bad Wiessee",
                        "latitude": "47.71667000",
                        "longitude": "11.71667000"
                    },
                    {
                        "id": 23887,
                        "name": "Bad Windsheim",
                        "latitude": "49.50274000",
                        "longitude": "10.41539000"
                    },
                    {
                        "id": 23889,
                        "name": "Bad Wörishofen",
                        "latitude": "48.00674000",
                        "longitude": "10.59666000"
                    },
                    {
                        "id": 23903,
                        "name": "Baierbrunn",
                        "latitude": "48.02030000",
                        "longitude": "11.48689000"
                    },
                    {
                        "id": 23905,
                        "name": "Baiersdorf",
                        "latitude": "49.65807000",
                        "longitude": "11.03594000"
                    },
                    {
                        "id": 23907,
                        "name": "Baisweil",
                        "latitude": "47.94439000",
                        "longitude": "10.54007000"
                    },
                    {
                        "id": 23916,
                        "name": "Balzhausen",
                        "latitude": "48.24228000",
                        "longitude": "10.49366000"
                    },
                    {
                        "id": 23917,
                        "name": "Bamberg",
                        "latitude": "49.89873000",
                        "longitude": "10.90067000"
                    },
                    {
                        "id": 23924,
                        "name": "Barbing",
                        "latitude": "49.00000000",
                        "longitude": "12.20000000"
                    },
                    {
                        "id": 24460,
                        "name": "Bärnau",
                        "latitude": "49.81079000",
                        "longitude": "12.43318000"
                    },
                    {
                        "id": 23954,
                        "name": "Bastheim",
                        "latitude": "50.40080000",
                        "longitude": "10.20372000"
                    },
                    {
                        "id": 23957,
                        "name": "Baudenbach",
                        "latitude": "49.62512000",
                        "longitude": "10.53598000"
                    },
                    {
                        "id": 23960,
                        "name": "Baunach",
                        "latitude": "49.98592000",
                        "longitude": "10.85179000"
                    },
                    {
                        "id": 23966,
                        "name": "Bayerbach",
                        "latitude": "48.70450000",
                        "longitude": "12.29750000"
                    },
                    {
                        "id": 23967,
                        "name": "Bayerisch Eisenstein",
                        "latitude": "49.11667000",
                        "longitude": "13.20000000"
                    },
                    {
                        "id": 23968,
                        "name": "Bayerisch Gmain",
                        "latitude": "47.71667000",
                        "longitude": "12.90000000"
                    },
                    {
                        "id": 23969,
                        "name": "Bayreuth",
                        "latitude": "49.94782000",
                        "longitude": "11.57893000"
                    },
                    {
                        "id": 23970,
                        "name": "Bayrischzell",
                        "latitude": "47.67440000",
                        "longitude": "12.01449000"
                    },
                    {
                        "id": 23975,
                        "name": "Bechtsrieth",
                        "latitude": "49.64487000",
                        "longitude": "12.20997000"
                    },
                    {
                        "id": 24002,
                        "name": "Bellenberg",
                        "latitude": "48.25726000",
                        "longitude": "10.09094000"
                    },
                    {
                        "id": 24009,
                        "name": "Benediktbeuern",
                        "latitude": "47.70624000",
                        "longitude": "11.41522000"
                    },
                    {
                        "id": 24013,
                        "name": "Benningen",
                        "latitude": "47.96667000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 24022,
                        "name": "Beratzhausen",
                        "latitude": "49.09517000",
                        "longitude": "11.80970000"
                    },
                    {
                        "id": 24023,
                        "name": "Berching",
                        "latitude": "49.10695000",
                        "longitude": "11.44138000"
                    },
                    {
                        "id": 24024,
                        "name": "Berchtesgaden",
                        "latitude": "47.63236000",
                        "longitude": "13.00187000"
                    },
                    {
                        "id": 24025,
                        "name": "Berg",
                        "latitude": "49.81417000",
                        "longitude": "12.14161000"
                    },
                    {
                        "id": 24027,
                        "name": "Berg im Gau",
                        "latitude": "48.63333000",
                        "longitude": "11.25000000"
                    },
                    {
                        "id": 24035,
                        "name": "Bergen",
                        "latitude": "47.80837000",
                        "longitude": "12.58982000"
                    },
                    {
                        "id": 24043,
                        "name": "Bergkirchen",
                        "latitude": "48.25671000",
                        "longitude": "11.36488000"
                    },
                    {
                        "id": 24044,
                        "name": "Berglern",
                        "latitude": "48.38407000",
                        "longitude": "11.93012000"
                    },
                    {
                        "id": 24046,
                        "name": "Bergrheinfeld",
                        "latitude": "50.01028000",
                        "longitude": "10.18089000"
                    },
                    {
                        "id": 24048,
                        "name": "Bergtheim",
                        "latitude": "49.90000000",
                        "longitude": "10.06667000"
                    },
                    {
                        "id": 24060,
                        "name": "Bernau am Chiemsee",
                        "latitude": "47.81167000",
                        "longitude": "12.37566000"
                    },
                    {
                        "id": 24062,
                        "name": "Bernbeuren",
                        "latitude": "47.73696000",
                        "longitude": "10.77707000"
                    },
                    {
                        "id": 24064,
                        "name": "Berngau",
                        "latitude": "49.25000000",
                        "longitude": "11.40000000"
                    },
                    {
                        "id": 24065,
                        "name": "Bernhardswald",
                        "latitude": "49.09123000",
                        "longitude": "12.24744000"
                    },
                    {
                        "id": 24068,
                        "name": "Bernried",
                        "latitude": "48.91667000",
                        "longitude": "12.88333000"
                    },
                    {
                        "id": 24085,
                        "name": "Betzigau",
                        "latitude": "47.73333000",
                        "longitude": "10.38333000"
                    },
                    {
                        "id": 24089,
                        "name": "Beutelsbach",
                        "latitude": "48.55000000",
                        "longitude": "13.11667000"
                    },
                    {
                        "id": 24097,
                        "name": "Biberbach",
                        "latitude": "48.51778000",
                        "longitude": "10.81139000"
                    },
                    {
                        "id": 24099,
                        "name": "Biburg",
                        "latitude": "48.79066000",
                        "longitude": "11.85726000"
                    },
                    {
                        "id": 24100,
                        "name": "Bichl",
                        "latitude": "47.72010000",
                        "longitude": "11.41231000"
                    },
                    {
                        "id": 24102,
                        "name": "Bidingen",
                        "latitude": "47.82974000",
                        "longitude": "10.72623000"
                    },
                    {
                        "id": 24103,
                        "name": "Biebelried",
                        "latitude": "49.76667000",
                        "longitude": "10.08333000"
                    },
                    {
                        "id": 24113,
                        "name": "Biessenhofen",
                        "latitude": "47.83057000",
                        "longitude": "10.64022000"
                    },
                    {
                        "id": 24122,
                        "name": "Bindlach",
                        "latitude": "49.98167000",
                        "longitude": "11.61389000"
                    },
                    {
                        "id": 24127,
                        "name": "Binswangen",
                        "latitude": "48.55798000",
                        "longitude": "10.64249000"
                    },
                    {
                        "id": 24136,
                        "name": "Birkenfeld",
                        "latitude": "49.85861000",
                        "longitude": "9.69556000"
                    },
                    {
                        "id": 24142,
                        "name": "Bischberg",
                        "latitude": "49.91087000",
                        "longitude": "10.83212000"
                    },
                    {
                        "id": 24143,
                        "name": "Bischbrunn",
                        "latitude": "49.87028000",
                        "longitude": "9.48917000"
                    },
                    {
                        "id": 24146,
                        "name": "Bischofsgrün",
                        "latitude": "50.05122000",
                        "longitude": "11.79997000"
                    },
                    {
                        "id": 24148,
                        "name": "Bischofsheim an der Rhön",
                        "latitude": "50.40239000",
                        "longitude": "10.00751000"
                    },
                    {
                        "id": 24149,
                        "name": "Bischofsmais",
                        "latitude": "48.91796000",
                        "longitude": "13.08184000"
                    },
                    {
                        "id": 24151,
                        "name": "Bischofswiesen",
                        "latitude": "47.63115000",
                        "longitude": "12.98305000"
                    },
                    {
                        "id": 24157,
                        "name": "Bissingen",
                        "latitude": "48.71694000",
                        "longitude": "10.61766000"
                    },
                    {
                        "id": 24162,
                        "name": "Blaibach",
                        "latitude": "49.16667000",
                        "longitude": "12.81667000"
                    },
                    {
                        "id": 24163,
                        "name": "Blaichach",
                        "latitude": "47.54208000",
                        "longitude": "10.25846000"
                    },
                    {
                        "id": 24164,
                        "name": "Blankenbach",
                        "latitude": "50.06667000",
                        "longitude": "9.23333000"
                    },
                    {
                        "id": 24183,
                        "name": "Blindheim",
                        "latitude": "48.63138000",
                        "longitude": "10.61992000"
                    },
                    {
                        "id": 24461,
                        "name": "Böbing",
                        "latitude": "47.75562000",
                        "longitude": "10.98877000"
                    },
                    {
                        "id": 24190,
                        "name": "Bobingen",
                        "latitude": "48.27091000",
                        "longitude": "10.83390000"
                    },
                    {
                        "id": 24464,
                        "name": "Böbrach",
                        "latitude": "48.93322000",
                        "longitude": "12.88304000"
                    },
                    {
                        "id": 24201,
                        "name": "Bockhorn",
                        "latitude": "48.31471000",
                        "longitude": "11.98694000"
                    },
                    {
                        "id": 24206,
                        "name": "Bodenkirchen",
                        "latitude": "48.38333000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 24207,
                        "name": "Bodenmais",
                        "latitude": "49.06667000",
                        "longitude": "13.10000000"
                    },
                    {
                        "id": 24209,
                        "name": "Bodenwöhr",
                        "latitude": "49.27082000",
                        "longitude": "12.30146000"
                    },
                    {
                        "id": 24212,
                        "name": "Bodolz",
                        "latitude": "47.56667000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 24214,
                        "name": "Bogen",
                        "latitude": "48.91122000",
                        "longitude": "12.68955000"
                    },
                    {
                        "id": 24215,
                        "name": "Bogenhausen",
                        "latitude": "48.15221000",
                        "longitude": "11.61585000"
                    },
                    {
                        "id": 24227,
                        "name": "Bolsterlang",
                        "latitude": "47.46667000",
                        "longitude": "10.23333000"
                    },
                    {
                        "id": 24233,
                        "name": "Bonstetten",
                        "latitude": "48.44002000",
                        "longitude": "10.70532000"
                    },
                    {
                        "id": 24234,
                        "name": "Boos",
                        "latitude": "48.07521000",
                        "longitude": "10.19523000"
                    },
                    {
                        "id": 24277,
                        "name": "Brand",
                        "latitude": "49.95972000",
                        "longitude": "11.91072000"
                    },
                    {
                        "id": 24283,
                        "name": "Brannenburg",
                        "latitude": "47.73996000",
                        "longitude": "12.09166000"
                    },
                    {
                        "id": 24303,
                        "name": "Breitbrunn",
                        "latitude": "48.04320000",
                        "longitude": "12.15431000"
                    },
                    {
                        "id": 24306,
                        "name": "Breitenberg",
                        "latitude": "48.70439000",
                        "longitude": "13.79333000"
                    },
                    {
                        "id": 24307,
                        "name": "Breitenbrunn",
                        "latitude": "49.36388000",
                        "longitude": "12.02013000"
                    },
                    {
                        "id": 24311,
                        "name": "Breitengüßbach",
                        "latitude": "49.97209000",
                        "longitude": "10.88591000"
                    },
                    {
                        "id": 24312,
                        "name": "Breitenthal",
                        "latitude": "48.23782000",
                        "longitude": "10.29951000"
                    },
                    {
                        "id": 24323,
                        "name": "Brennberg",
                        "latitude": "49.06667000",
                        "longitude": "12.40000000"
                    },
                    {
                        "id": 24353,
                        "name": "Bruck",
                        "latitude": "48.02116000",
                        "longitude": "11.90781000"
                    },
                    {
                        "id": 24354,
                        "name": "Bruck in der Oberpfalz",
                        "latitude": "49.24927000",
                        "longitude": "12.30710000"
                    },
                    {
                        "id": 24355,
                        "name": "Bruckberg",
                        "latitude": "48.52244000",
                        "longitude": "11.99448000"
                    },
                    {
                        "id": 24356,
                        "name": "Bruckmühl",
                        "latitude": "47.87859000",
                        "longitude": "11.91098000"
                    },
                    {
                        "id": 24359,
                        "name": "Brunn",
                        "latitude": "49.23632000",
                        "longitude": "12.19156000"
                    },
                    {
                        "id": 24360,
                        "name": "Brunnen",
                        "latitude": "48.22956000",
                        "longitude": "10.97332000"
                    },
                    {
                        "id": 24361,
                        "name": "Brunnthal",
                        "latitude": "48.00652000",
                        "longitude": "11.68405000"
                    },
                    {
                        "id": 24375,
                        "name": "Bubenreuth",
                        "latitude": "49.62745000",
                        "longitude": "11.01723000"
                    },
                    {
                        "id": 24376,
                        "name": "Bubesheim",
                        "latitude": "48.43333000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 24378,
                        "name": "Buch",
                        "latitude": "48.22479000",
                        "longitude": "10.18055000"
                    },
                    {
                        "id": 24381,
                        "name": "Buch am Buchrain",
                        "latitude": "48.21510000",
                        "longitude": "11.99509000"
                    },
                    {
                        "id": 24383,
                        "name": "Buchbach",
                        "latitude": "48.31231000",
                        "longitude": "12.27343000"
                    },
                    {
                        "id": 24384,
                        "name": "Buchbrunn",
                        "latitude": "49.75981000",
                        "longitude": "10.13686000"
                    },
                    {
                        "id": 24385,
                        "name": "Buchdorf",
                        "latitude": "48.78333000",
                        "longitude": "10.83333000"
                    },
                    {
                        "id": 24487,
                        "name": "Büchenbach",
                        "latitude": "49.26778000",
                        "longitude": "11.05889000"
                    },
                    {
                        "id": 24388,
                        "name": "Buchenberg",
                        "latitude": "47.69593000",
                        "longitude": "10.23927000"
                    },
                    {
                        "id": 24489,
                        "name": "Büchlberg",
                        "latitude": "48.67112000",
                        "longitude": "13.52100000"
                    },
                    {
                        "id": 24394,
                        "name": "Buchloe",
                        "latitude": "48.03719000",
                        "longitude": "10.72548000"
                    },
                    {
                        "id": 24395,
                        "name": "Buckenhof",
                        "latitude": "49.59324000",
                        "longitude": "11.05044000"
                    },
                    {
                        "id": 24411,
                        "name": "Burgau",
                        "latitude": "48.43159000",
                        "longitude": "10.40989000"
                    },
                    {
                        "id": 24412,
                        "name": "Burgberg",
                        "latitude": "47.53657000",
                        "longitude": "10.28883000"
                    },
                    {
                        "id": 24413,
                        "name": "Burgbernheim",
                        "latitude": "49.45103000",
                        "longitude": "10.32385000"
                    },
                    {
                        "id": 24416,
                        "name": "Burgebrach",
                        "latitude": "49.82832000",
                        "longitude": "10.74338000"
                    },
                    {
                        "id": 24417,
                        "name": "Burggen",
                        "latitude": "47.77689000",
                        "longitude": "10.81724000"
                    },
                    {
                        "id": 24418,
                        "name": "Burghaslach",
                        "latitude": "49.73313000",
                        "longitude": "10.60070000"
                    },
                    {
                        "id": 24420,
                        "name": "Burghausen",
                        "latitude": "48.16925000",
                        "longitude": "12.83139000"
                    },
                    {
                        "id": 24421,
                        "name": "Burgheim",
                        "latitude": "48.70035000",
                        "longitude": "11.01599000"
                    },
                    {
                        "id": 24422,
                        "name": "Burgkirchen an der Alz",
                        "latitude": "48.16753000",
                        "longitude": "12.73250000"
                    },
                    {
                        "id": 24423,
                        "name": "Burgkunstadt",
                        "latitude": "50.14093000",
                        "longitude": "11.25205000"
                    },
                    {
                        "id": 24424,
                        "name": "Burglauer",
                        "latitude": "50.27645000",
                        "longitude": "10.17939000"
                    },
                    {
                        "id": 24425,
                        "name": "Burglengenfeld",
                        "latitude": "49.20379000",
                        "longitude": "12.04452000"
                    },
                    {
                        "id": 24427,
                        "name": "Burgoberbach",
                        "latitude": "49.23333000",
                        "longitude": "10.58333000"
                    },
                    {
                        "id": 24428,
                        "name": "Burgpreppach",
                        "latitude": "50.14149000",
                        "longitude": "10.64977000"
                    },
                    {
                        "id": 24430,
                        "name": "Burgsalach",
                        "latitude": "49.03316000",
                        "longitude": "11.09766000"
                    },
                    {
                        "id": 24432,
                        "name": "Burgsinn",
                        "latitude": "50.14968000",
                        "longitude": "9.65119000"
                    },
                    {
                        "id": 24503,
                        "name": "Bürgstadt",
                        "latitude": "49.71476000",
                        "longitude": "9.26916000"
                    },
                    {
                        "id": 24436,
                        "name": "Burgthann",
                        "latitude": "49.35202000",
                        "longitude": "11.31154000"
                    },
                    {
                        "id": 24438,
                        "name": "Burgwindheim",
                        "latitude": "49.82733000",
                        "longitude": "10.59631000"
                    },
                    {
                        "id": 24439,
                        "name": "Burk",
                        "latitude": "49.13318000",
                        "longitude": "10.47891000"
                    },
                    {
                        "id": 24440,
                        "name": "Burkardroth",
                        "latitude": "50.27125000",
                        "longitude": "9.99162000"
                    },
                    {
                        "id": 24446,
                        "name": "Burtenbach",
                        "latitude": "48.34051000",
                        "longitude": "10.45280000"
                    },
                    {
                        "id": 24451,
                        "name": "Buttenheim",
                        "latitude": "49.80365000",
                        "longitude": "11.03002000"
                    },
                    {
                        "id": 24452,
                        "name": "Buttenwiesen",
                        "latitude": "48.60000000",
                        "longitude": "10.71667000"
                    },
                    {
                        "id": 24508,
                        "name": "Bütthard",
                        "latitude": "49.59913000",
                        "longitude": "9.87987000"
                    },
                    {
                        "id": 24456,
                        "name": "Buxheim",
                        "latitude": "48.00000000",
                        "longitude": "10.13333000"
                    },
                    {
                        "id": 24512,
                        "name": "Cadolzburg",
                        "latitude": "49.45730000",
                        "longitude": "10.85329000"
                    },
                    {
                        "id": 24529,
                        "name": "Cham",
                        "latitude": "49.22565000",
                        "longitude": "12.65501000"
                    },
                    {
                        "id": 24530,
                        "name": "Chamerau",
                        "latitude": "49.20000000",
                        "longitude": "12.75000000"
                    },
                    {
                        "id": 24534,
                        "name": "Chieming",
                        "latitude": "47.89258000",
                        "longitude": "12.54012000"
                    },
                    {
                        "id": 24536,
                        "name": "Chostlarn",
                        "latitude": "48.37144000",
                        "longitude": "13.12064000"
                    },
                    {
                        "id": 24544,
                        "name": "Coburg",
                        "latitude": "50.25937000",
                        "longitude": "10.96384000"
                    },
                    {
                        "id": 24550,
                        "name": "Colmberg",
                        "latitude": "49.35480000",
                        "longitude": "10.41157000"
                    },
                    {
                        "id": 24562,
                        "name": "Creußen",
                        "latitude": "49.84495000",
                        "longitude": "11.62683000"
                    },
                    {
                        "id": 24574,
                        "name": "Dachau",
                        "latitude": "48.26000000",
                        "longitude": "11.43402000"
                    },
                    {
                        "id": 24598,
                        "name": "Dasing",
                        "latitude": "48.38482000",
                        "longitude": "11.04667000"
                    },
                    {
                        "id": 24610,
                        "name": "Deggendorf",
                        "latitude": "48.84085000",
                        "longitude": "12.96068000"
                    },
                    {
                        "id": 24615,
                        "name": "Deining",
                        "latitude": "49.22556000",
                        "longitude": "11.53968000"
                    },
                    {
                        "id": 24616,
                        "name": "Deiningen",
                        "latitude": "48.86667000",
                        "longitude": "10.56667000"
                    },
                    {
                        "id": 24618,
                        "name": "Deisenhausen",
                        "latitude": "48.25554000",
                        "longitude": "10.32698000"
                    },
                    {
                        "id": 24632,
                        "name": "Denklingen",
                        "latitude": "47.91667000",
                        "longitude": "10.85000000"
                    },
                    {
                        "id": 24634,
                        "name": "Dentlein am Forst",
                        "latitude": "49.14772000",
                        "longitude": "10.42309000"
                    },
                    {
                        "id": 24648,
                        "name": "Dettelbach",
                        "latitude": "49.80295000",
                        "longitude": "10.16519000"
                    },
                    {
                        "id": 24656,
                        "name": "Deuerling",
                        "latitude": "49.03720000",
                        "longitude": "11.91045000"
                    },
                    {
                        "id": 24663,
                        "name": "Diebach",
                        "latitude": "49.30912000",
                        "longitude": "10.19188000"
                    },
                    {
                        "id": 24666,
                        "name": "Diedorf",
                        "latitude": "48.35320000",
                        "longitude": "10.78206000"
                    },
                    {
                        "id": 24676,
                        "name": "Diespeck",
                        "latitude": "49.60000000",
                        "longitude": "10.63333000"
                    },
                    {
                        "id": 24688,
                        "name": "Dießen am Ammersee",
                        "latitude": "47.95085000",
                        "longitude": "11.10306000"
                    },
                    {
                        "id": 24678,
                        "name": "Dietenhofen",
                        "latitude": "49.39997000",
                        "longitude": "10.68975000"
                    },
                    {
                        "id": 24679,
                        "name": "Dietersburg",
                        "latitude": "48.49249000",
                        "longitude": "12.92499000"
                    },
                    {
                        "id": 24680,
                        "name": "Dietersheim",
                        "latitude": "49.55631000",
                        "longitude": "10.54074000"
                    },
                    {
                        "id": 24681,
                        "name": "Dieterskirchen",
                        "latitude": "49.41667000",
                        "longitude": "12.41667000"
                    },
                    {
                        "id": 24682,
                        "name": "Dietfurt",
                        "latitude": "49.03578000",
                        "longitude": "11.58624000"
                    },
                    {
                        "id": 24684,
                        "name": "Dietmannsried",
                        "latitude": "47.80787000",
                        "longitude": "10.28948000"
                    },
                    {
                        "id": 24685,
                        "name": "Dietramszell",
                        "latitude": "47.84871000",
                        "longitude": "11.59530000"
                    },
                    {
                        "id": 24691,
                        "name": "Dillingen an der Donau",
                        "latitude": "48.58153000",
                        "longitude": "10.49527000"
                    },
                    {
                        "id": 24693,
                        "name": "Dingolfing",
                        "latitude": "48.64244000",
                        "longitude": "12.49283000"
                    },
                    {
                        "id": 24694,
                        "name": "Dingolshausen",
                        "latitude": "49.90710000",
                        "longitude": "10.39032000"
                    },
                    {
                        "id": 24695,
                        "name": "Dinkelsbühl",
                        "latitude": "49.06942000",
                        "longitude": "10.31985000"
                    },
                    {
                        "id": 24696,
                        "name": "Dinkelscherben",
                        "latitude": "48.34826000",
                        "longitude": "10.58893000"
                    },
                    {
                        "id": 24702,
                        "name": "Dirlewang",
                        "latitude": "48.00195000",
                        "longitude": "10.50306000"
                    },
                    {
                        "id": 24707,
                        "name": "Dittelbrunn",
                        "latitude": "50.07212000",
                        "longitude": "10.21974000"
                    },
                    {
                        "id": 24709,
                        "name": "Dittenheim",
                        "latitude": "49.05536000",
                        "longitude": "10.79201000"
                    },
                    {
                        "id": 24794,
                        "name": "Döhlau",
                        "latitude": "50.28333000",
                        "longitude": "11.95000000"
                    },
                    {
                        "id": 24724,
                        "name": "Dombühl",
                        "latitude": "49.25349000",
                        "longitude": "10.28542000"
                    },
                    {
                        "id": 24730,
                        "name": "Donaustauf",
                        "latitude": "49.03258000",
                        "longitude": "12.20459000"
                    },
                    {
                        "id": 24731,
                        "name": "Donauwörth",
                        "latitude": "48.71804000",
                        "longitude": "10.77930000"
                    },
                    {
                        "id": 24732,
                        "name": "Donnersdorf",
                        "latitude": "49.96667000",
                        "longitude": "10.41667000"
                    },
                    {
                        "id": 24735,
                        "name": "Dorfen",
                        "latitude": "48.27037000",
                        "longitude": "12.16056000"
                    },
                    {
                        "id": 24737,
                        "name": "Dorfprozelten",
                        "latitude": "49.78056000",
                        "longitude": "9.38028000"
                    },
                    {
                        "id": 24740,
                        "name": "Dormitz",
                        "latitude": "49.59786000",
                        "longitude": "11.11765000"
                    },
                    {
                        "id": 24751,
                        "name": "Drachselsried",
                        "latitude": "49.10759000",
                        "longitude": "13.01185000"
                    },
                    {
                        "id": 24778,
                        "name": "Duggendorf",
                        "latitude": "49.11667000",
                        "longitude": "11.91667000"
                    },
                    {
                        "id": 24784,
                        "name": "Durach",
                        "latitude": "47.69440000",
                        "longitude": "10.34449000"
                    },
                    {
                        "id": 24814,
                        "name": "Dürrlauingen",
                        "latitude": "48.46666000",
                        "longitude": "10.42860000"
                    },
                    {
                        "id": 24816,
                        "name": "Dürrwangen",
                        "latitude": "49.10778000",
                        "longitude": "10.38500000"
                    },
                    {
                        "id": 24821,
                        "name": "Ebelsbach",
                        "latitude": "49.98572000",
                        "longitude": "10.67442000"
                    },
                    {
                        "id": 24823,
                        "name": "Ebensfeld",
                        "latitude": "50.06640000",
                        "longitude": "10.95835000"
                    },
                    {
                        "id": 24829,
                        "name": "Ebermannsdorf",
                        "latitude": "49.39375000",
                        "longitude": "11.93582000"
                    },
                    {
                        "id": 24830,
                        "name": "Ebermannstadt",
                        "latitude": "49.78154000",
                        "longitude": "11.18168000"
                    },
                    {
                        "id": 24835,
                        "name": "Ebersberg",
                        "latitude": "48.07710000",
                        "longitude": "11.97063000"
                    },
                    {
                        "id": 24837,
                        "name": "Ebersdorf",
                        "latitude": "50.32898000",
                        "longitude": "11.15266000"
                    },
                    {
                        "id": 24842,
                        "name": "Ebnath",
                        "latitude": "49.95000000",
                        "longitude": "11.93333000"
                    },
                    {
                        "id": 24846,
                        "name": "Eching",
                        "latitude": "48.30000000",
                        "longitude": "11.61667000"
                    },
                    {
                        "id": 24850,
                        "name": "Eckersdorf",
                        "latitude": "50.02874000",
                        "longitude": "11.39611000"
                    },
                    {
                        "id": 24853,
                        "name": "Edelsfeld",
                        "latitude": "49.57644000",
                        "longitude": "11.69589000"
                    },
                    {
                        "id": 24856,
                        "name": "Ederheim",
                        "latitude": "48.80827000",
                        "longitude": "10.46609000"
                    },
                    {
                        "id": 24863,
                        "name": "Effeltrich",
                        "latitude": "49.65929000",
                        "longitude": "11.09319000"
                    },
                    {
                        "id": 24868,
                        "name": "Egenhofen",
                        "latitude": "48.28333000",
                        "longitude": "11.16667000"
                    },
                    {
                        "id": 24870,
                        "name": "Egg an der Günz",
                        "latitude": "48.08714000",
                        "longitude": "10.28495000"
                    },
                    {
                        "id": 24872,
                        "name": "Eggenfelden",
                        "latitude": "48.40509000",
                        "longitude": "12.75752000"
                    },
                    {
                        "id": 24874,
                        "name": "Eggenthal",
                        "latitude": "47.91667000",
                        "longitude": "10.51667000"
                    },
                    {
                        "id": 24879,
                        "name": "Egglham",
                        "latitude": "48.52902000",
                        "longitude": "13.05402000"
                    },
                    {
                        "id": 24880,
                        "name": "Egglkofen",
                        "latitude": "48.40000000",
                        "longitude": "12.45000000"
                    },
                    {
                        "id": 24881,
                        "name": "Eggolsheim",
                        "latitude": "49.76961000",
                        "longitude": "11.05701000"
                    },
                    {
                        "id": 24882,
                        "name": "Eggstätt",
                        "latitude": "47.92698000",
                        "longitude": "12.37919000"
                    },
                    {
                        "id": 24883,
                        "name": "Eging",
                        "latitude": "48.46328000",
                        "longitude": "12.18957000"
                    },
                    {
                        "id": 24884,
                        "name": "Egling",
                        "latitude": "47.92316000",
                        "longitude": "11.50517000"
                    },
                    {
                        "id": 24885,
                        "name": "Egloffstein",
                        "latitude": "49.70182000",
                        "longitude": "11.25749000"
                    },
                    {
                        "id": 24886,
                        "name": "Egmating",
                        "latitude": "48.00405000",
                        "longitude": "11.79528000"
                    },
                    {
                        "id": 24887,
                        "name": "Ehekirchen",
                        "latitude": "48.63333000",
                        "longitude": "11.10000000"
                    },
                    {
                        "id": 24889,
                        "name": "Ehingen",
                        "latitude": "48.60000000",
                        "longitude": "10.80000000"
                    },
                    {
                        "id": 24896,
                        "name": "Eibelstadt",
                        "latitude": "49.72392000",
                        "longitude": "9.99962000"
                    },
                    {
                        "id": 24898,
                        "name": "Eichenau",
                        "latitude": "48.16667000",
                        "longitude": "11.31667000"
                    },
                    {
                        "id": 24900,
                        "name": "Eichenbühl",
                        "latitude": "49.70556000",
                        "longitude": "9.32917000"
                    },
                    {
                        "id": 24901,
                        "name": "Eichendorf",
                        "latitude": "48.63266000",
                        "longitude": "12.85586000"
                    },
                    {
                        "id": 24902,
                        "name": "Eichenried",
                        "latitude": "48.27748000",
                        "longitude": "11.78206000"
                    },
                    {
                        "id": 24906,
                        "name": "Eichstätt",
                        "latitude": "48.88854000",
                        "longitude": "11.19675000"
                    },
                    {
                        "id": 24923,
                        "name": "Eiselfing",
                        "latitude": "48.04114000",
                        "longitude": "12.24272000"
                    },
                    {
                        "id": 24928,
                        "name": "Eisenburg",
                        "latitude": "48.01404000",
                        "longitude": "10.20870000"
                    },
                    {
                        "id": 24932,
                        "name": "Eisingen",
                        "latitude": "49.75972000",
                        "longitude": "9.83111000"
                    },
                    {
                        "id": 24938,
                        "name": "Eitting",
                        "latitude": "48.35957000",
                        "longitude": "11.89110000"
                    },
                    {
                        "id": 24943,
                        "name": "Elfershausen",
                        "latitude": "50.14743000",
                        "longitude": "9.96151000"
                    },
                    {
                        "id": 24952,
                        "name": "Ellgau",
                        "latitude": "48.60000000",
                        "longitude": "10.86667000"
                    },
                    {
                        "id": 24954,
                        "name": "Ellingen",
                        "latitude": "49.06076000",
                        "longitude": "10.96783000"
                    },
                    {
                        "id": 24957,
                        "name": "Ellzee",
                        "latitude": "48.33971000",
                        "longitude": "10.31891000"
                    },
                    {
                        "id": 24965,
                        "name": "Elsendorf",
                        "latitude": "48.70757000",
                        "longitude": "11.80982000"
                    },
                    {
                        "id": 24966,
                        "name": "Elsenfeld",
                        "latitude": "49.84289000",
                        "longitude": "9.16355000"
                    },
                    {
                        "id": 24975,
                        "name": "Eltmann",
                        "latitude": "49.97148000",
                        "longitude": "10.66712000"
                    },
                    {
                        "id": 24983,
                        "name": "Emersacker",
                        "latitude": "48.48965000",
                        "longitude": "10.67380000"
                    },
                    {
                        "id": 24990,
                        "name": "Emmering",
                        "latitude": "48.18333000",
                        "longitude": "11.28333000"
                    },
                    {
                        "id": 24995,
                        "name": "Emskirchen",
                        "latitude": "49.55282000",
                        "longitude": "10.71278000"
                    },
                    {
                        "id": 24998,
                        "name": "Emtmannsberg",
                        "latitude": "49.89231000",
                        "longitude": "11.64466000"
                    },
                    {
                        "id": 25001,
                        "name": "Engelsberg",
                        "latitude": "48.11631000",
                        "longitude": "12.54267000"
                    },
                    {
                        "id": 25004,
                        "name": "Engelthal",
                        "latitude": "49.47181000",
                        "longitude": "11.39943000"
                    },
                    {
                        "id": 25013,
                        "name": "Ensdorf",
                        "latitude": "49.34062000",
                        "longitude": "11.93587000"
                    },
                    {
                        "id": 25025,
                        "name": "Eppishausen",
                        "latitude": "48.16667000",
                        "longitude": "10.51667000"
                    },
                    {
                        "id": 25029,
                        "name": "Erbendorf",
                        "latitude": "49.83983000",
                        "longitude": "12.04593000"
                    },
                    {
                        "id": 25032,
                        "name": "Erding",
                        "latitude": "48.30603000",
                        "longitude": "11.90686000"
                    },
                    {
                        "id": 25034,
                        "name": "Erdweg",
                        "latitude": "48.33180000",
                        "longitude": "11.30339000"
                    },
                    {
                        "id": 25035,
                        "name": "Eresing",
                        "latitude": "48.08700000",
                        "longitude": "11.02388000"
                    },
                    {
                        "id": 25040,
                        "name": "Ergersheim",
                        "latitude": "49.51667000",
                        "longitude": "10.33333000"
                    },
                    {
                        "id": 25041,
                        "name": "Ergolding",
                        "latitude": "48.57654000",
                        "longitude": "12.17102000"
                    },
                    {
                        "id": 25042,
                        "name": "Ergoldsbach",
                        "latitude": "48.69263000",
                        "longitude": "12.20442000"
                    },
                    {
                        "id": 25043,
                        "name": "Ering",
                        "latitude": "48.29921000",
                        "longitude": "13.15029000"
                    },
                    {
                        "id": 25048,
                        "name": "Erkheim",
                        "latitude": "48.03730000",
                        "longitude": "10.33570000"
                    },
                    {
                        "id": 25051,
                        "name": "Erlabrunn",
                        "latitude": "49.85972000",
                        "longitude": "9.84417000"
                    },
                    {
                        "id": 25052,
                        "name": "Erlangen",
                        "latitude": "49.59099000",
                        "longitude": "11.00783000"
                    },
                    {
                        "id": 25055,
                        "name": "Erlbach",
                        "latitude": "48.30000000",
                        "longitude": "12.78333000"
                    },
                    {
                        "id": 25056,
                        "name": "Erlenbach",
                        "latitude": "49.97857000",
                        "longitude": "9.64459000"
                    },
                    {
                        "id": 25058,
                        "name": "Erlenbach am Main",
                        "latitude": "49.80341000",
                        "longitude": "9.16311000"
                    },
                    {
                        "id": 25064,
                        "name": "Ernsgaden",
                        "latitude": "48.73333000",
                        "longitude": "11.58333000"
                    },
                    {
                        "id": 25075,
                        "name": "Eschau",
                        "latitude": "49.81889000",
                        "longitude": "9.25920000"
                    },
                    {
                        "id": 25081,
                        "name": "Eschenlohe",
                        "latitude": "48.01731000",
                        "longitude": "12.03012000"
                    },
                    {
                        "id": 25083,
                        "name": "Eschlkam",
                        "latitude": "49.29883000",
                        "longitude": "12.91573000"
                    },
                    {
                        "id": 25087,
                        "name": "Eslarn",
                        "latitude": "49.58345000",
                        "longitude": "12.52156000"
                    },
                    {
                        "id": 25093,
                        "name": "Esselbach",
                        "latitude": "49.85528000",
                        "longitude": "9.52583000"
                    },
                    {
                        "id": 25096,
                        "name": "Essenbach",
                        "latitude": "48.61332000",
                        "longitude": "12.21833000"
                    },
                    {
                        "id": 25098,
                        "name": "Essing",
                        "latitude": "48.93467000",
                        "longitude": "11.78972000"
                    },
                    {
                        "id": 25102,
                        "name": "Estenfeld",
                        "latitude": "49.82896000",
                        "longitude": "10.00588000"
                    },
                    {
                        "id": 25109,
                        "name": "Ettringen",
                        "latitude": "48.10000000",
                        "longitude": "10.65000000"
                    },
                    {
                        "id": 25111,
                        "name": "Etzelwang",
                        "latitude": "49.52760000",
                        "longitude": "11.58603000"
                    },
                    {
                        "id": 25112,
                        "name": "Etzenricht",
                        "latitude": "49.63333000",
                        "longitude": "12.10000000"
                    },
                    {
                        "id": 25113,
                        "name": "Euerbach",
                        "latitude": "50.06199000",
                        "longitude": "10.13695000"
                    },
                    {
                        "id": 25114,
                        "name": "Euerdorf",
                        "latitude": "50.14853000",
                        "longitude": "10.02331000"
                    },
                    {
                        "id": 25115,
                        "name": "Eurasburg",
                        "latitude": "47.85389000",
                        "longitude": "11.40587000"
                    },
                    {
                        "id": 25119,
                        "name": "Eußenheim",
                        "latitude": "49.98589000",
                        "longitude": "9.80899000"
                    },
                    {
                        "id": 25129,
                        "name": "Fahrenzhausen",
                        "latitude": "48.35317000",
                        "longitude": "11.55521000"
                    },
                    {
                        "id": 25132,
                        "name": "Falkenberg",
                        "latitude": "48.46154000",
                        "longitude": "12.73049000"
                    },
                    {
                        "id": 25135,
                        "name": "Falkenfels",
                        "latitude": "49.00415000",
                        "longitude": "12.59480000"
                    },
                    {
                        "id": 25140,
                        "name": "Falkenstein",
                        "latitude": "49.09750000",
                        "longitude": "12.48802000"
                    },
                    {
                        "id": 25142,
                        "name": "Farchant",
                        "latitude": "47.53036000",
                        "longitude": "11.11151000"
                    },
                    {
                        "id": 25145,
                        "name": "Faulbach",
                        "latitude": "49.78528000",
                        "longitude": "9.44417000"
                    },
                    {
                        "id": 25151,
                        "name": "Feilitzsch",
                        "latitude": "50.36667000",
                        "longitude": "11.93333000"
                    },
                    {
                        "id": 25152,
                        "name": "Feldafing",
                        "latitude": "47.94602000",
                        "longitude": "11.29326000"
                    },
                    {
                        "id": 25155,
                        "name": "Feldkirchen",
                        "latitude": "48.14811000",
                        "longitude": "11.73100000"
                    },
                    {
                        "id": 25156,
                        "name": "Feldkirchen-Westerham",
                        "latitude": "47.90748000",
                        "longitude": "11.84266000"
                    },
                    {
                        "id": 25160,
                        "name": "Fellheim",
                        "latitude": "48.07280000",
                        "longitude": "10.15224000"
                    },
                    {
                        "id": 25165,
                        "name": "Feucht",
                        "latitude": "49.37597000",
                        "longitude": "11.21433000"
                    },
                    {
                        "id": 25166,
                        "name": "Feuchtwangen",
                        "latitude": "49.16287000",
                        "longitude": "10.33850000"
                    },
                    {
                        "id": 25167,
                        "name": "Fichtelberg",
                        "latitude": "50.00288000",
                        "longitude": "11.85425000"
                    },
                    {
                        "id": 25173,
                        "name": "Finningen",
                        "latitude": "48.65452000",
                        "longitude": "10.49864000"
                    },
                    {
                        "id": 25174,
                        "name": "Finsing",
                        "latitude": "48.21615000",
                        "longitude": "11.82412000"
                    },
                    {
                        "id": 25178,
                        "name": "Fischach",
                        "latitude": "48.29047000",
                        "longitude": "10.65592000"
                    },
                    {
                        "id": 25180,
                        "name": "Fischbachau",
                        "latitude": "47.71952000",
                        "longitude": "11.95081000"
                    },
                    {
                        "id": 25182,
                        "name": "Flachslanden",
                        "latitude": "49.39845000",
                        "longitude": "10.51323000"
                    },
                    {
                        "id": 25184,
                        "name": "Fladungen",
                        "latitude": "50.52054000",
                        "longitude": "10.14581000"
                    },
                    {
                        "id": 25193,
                        "name": "Flintsbach",
                        "latitude": "47.72576000",
                        "longitude": "12.12419000"
                    },
                    {
                        "id": 25198,
                        "name": "Floß",
                        "latitude": "49.72395000",
                        "longitude": "12.27593000"
                    },
                    {
                        "id": 25197,
                        "name": "Flossenbürg",
                        "latitude": "49.73333000",
                        "longitude": "12.35000000"
                    },
                    {
                        "id": 25204,
                        "name": "Forchheim",
                        "latitude": "49.71754000",
                        "longitude": "11.05877000"
                    },
                    {
                        "id": 25209,
                        "name": "Forstinning",
                        "latitude": "48.16866000",
                        "longitude": "11.91244000"
                    },
                    {
                        "id": 25211,
                        "name": "Frammersbach",
                        "latitude": "50.06468000",
                        "longitude": "9.46888000"
                    },
                    {
                        "id": 25220,
                        "name": "Frankenwinheim",
                        "latitude": "49.88733000",
                        "longitude": "10.31432000"
                    },
                    {
                        "id": 25226,
                        "name": "Frasdorf",
                        "latitude": "47.80376000",
                        "longitude": "12.28512000"
                    },
                    {
                        "id": 25227,
                        "name": "Frauenau",
                        "latitude": "48.98895000",
                        "longitude": "13.30067000"
                    },
                    {
                        "id": 25228,
                        "name": "Fraueneuharting",
                        "latitude": "48.03873000",
                        "longitude": "12.04780000"
                    },
                    {
                        "id": 25232,
                        "name": "Fraunberg",
                        "latitude": "48.36667000",
                        "longitude": "12.00000000"
                    },
                    {
                        "id": 25246,
                        "name": "Freihung",
                        "latitude": "49.62134000",
                        "longitude": "11.90817000"
                    },
                    {
                        "id": 25247,
                        "name": "Freilassing",
                        "latitude": "47.84085000",
                        "longitude": "12.98114000"
                    },
                    {
                        "id": 25251,
                        "name": "Freising",
                        "latitude": "48.40351000",
                        "longitude": "11.74876000"
                    },
                    {
                        "id": 25253,
                        "name": "Fremdingen",
                        "latitude": "48.97241000",
                        "longitude": "10.45754000"
                    },
                    {
                        "id": 25254,
                        "name": "Frensdorf",
                        "latitude": "49.81667000",
                        "longitude": "10.86667000"
                    },
                    {
                        "id": 25257,
                        "name": "Freudenberg",
                        "latitude": "49.48333000",
                        "longitude": "11.98333000"
                    },
                    {
                        "id": 25263,
                        "name": "Freystadt",
                        "latitude": "49.20007000",
                        "longitude": "11.33032000"
                    },
                    {
                        "id": 25264,
                        "name": "Freyung",
                        "latitude": "48.80952000",
                        "longitude": "13.54768000"
                    },
                    {
                        "id": 25265,
                        "name": "Frickenhausen",
                        "latitude": "49.67089000",
                        "longitude": "10.09268000"
                    },
                    {
                        "id": 25269,
                        "name": "Fridolfing",
                        "latitude": "47.99773000",
                        "longitude": "12.82628000"
                    },
                    {
                        "id": 25270,
                        "name": "Friedberg",
                        "latitude": "48.35693000",
                        "longitude": "10.98461000"
                    },
                    {
                        "id": 25275,
                        "name": "Friedenfels",
                        "latitude": "49.88260000",
                        "longitude": "12.10124000"
                    },
                    {
                        "id": 25299,
                        "name": "Friesenried",
                        "latitude": "47.87477000",
                        "longitude": "10.53464000"
                    },
                    {
                        "id": 25308,
                        "name": "Frontenhausen",
                        "latitude": "48.54628000",
                        "longitude": "12.53118000"
                    },
                    {
                        "id": 25312,
                        "name": "Fuchsmühl",
                        "latitude": "49.92265000",
                        "longitude": "12.14582000"
                    },
                    {
                        "id": 25313,
                        "name": "Fuchsstadt",
                        "latitude": "50.10825000",
                        "longitude": "9.93370000"
                    },
                    {
                        "id": 25324,
                        "name": "Fünfstetten",
                        "latitude": "48.83215000",
                        "longitude": "10.76540000"
                    },
                    {
                        "id": 25330,
                        "name": "Fürsteneck",
                        "latitude": "48.71667000",
                        "longitude": "13.46667000"
                    },
                    {
                        "id": 25331,
                        "name": "Fürstenfeldbruck",
                        "latitude": "48.17904000",
                        "longitude": "11.25470000"
                    },
                    {
                        "id": 25333,
                        "name": "Fürstenstein",
                        "latitude": "48.71667000",
                        "longitude": "13.33333000"
                    },
                    {
                        "id": 25335,
                        "name": "Fürstenzell",
                        "latitude": "48.52163000",
                        "longitude": "13.31749000"
                    },
                    {
                        "id": 25317,
                        "name": "Furth",
                        "latitude": "48.40616000",
                        "longitude": "12.38121000"
                    },
                    {
                        "id": 25318,
                        "name": "Furth im Wald",
                        "latitude": "49.30955000",
                        "longitude": "12.84156000"
                    },
                    {
                        "id": 25339,
                        "name": "Füssen",
                        "latitude": "47.57143000",
                        "longitude": "10.70171000"
                    },
                    {
                        "id": 25341,
                        "name": "Gablingen",
                        "latitude": "48.45000000",
                        "longitude": "10.81667000"
                    },
                    {
                        "id": 25342,
                        "name": "Gachenbach",
                        "latitude": "48.50000000",
                        "longitude": "11.23333000"
                    },
                    {
                        "id": 25344,
                        "name": "Gadheim",
                        "latitude": "49.84584000",
                        "longitude": "9.90566000"
                    },
                    {
                        "id": 25350,
                        "name": "Gaimersheim",
                        "latitude": "48.80705000",
                        "longitude": "11.36801000"
                    },
                    {
                        "id": 25351,
                        "name": "Gaißach",
                        "latitude": "47.75000000",
                        "longitude": "11.58333000"
                    },
                    {
                        "id": 25353,
                        "name": "Gammelsdorf",
                        "latitude": "48.55000000",
                        "longitude": "11.95000000"
                    },
                    {
                        "id": 25358,
                        "name": "Gangkofen",
                        "latitude": "48.43701000",
                        "longitude": "12.56419000"
                    },
                    {
                        "id": 25362,
                        "name": "Garching an der Alz",
                        "latitude": "48.13451000",
                        "longitude": "12.58152000"
                    },
                    {
                        "id": 25363,
                        "name": "Garching bei München",
                        "latitude": "48.24896000",
                        "longitude": "11.65101000"
                    },
                    {
                        "id": 25367,
                        "name": "Garmisch-Partenkirchen",
                        "latitude": "47.49209000",
                        "longitude": "11.09576000"
                    },
                    {
                        "id": 25369,
                        "name": "Gars",
                        "latitude": "48.15386000",
                        "longitude": "12.27767000"
                    },
                    {
                        "id": 25377,
                        "name": "Gattendorf",
                        "latitude": "50.32207000",
                        "longitude": "11.99776000"
                    },
                    {
                        "id": 25382,
                        "name": "Gaukönigshofen",
                        "latitude": "49.63333000",
                        "longitude": "10.00000000"
                    },
                    {
                        "id": 25383,
                        "name": "Gauting",
                        "latitude": "48.06919000",
                        "longitude": "11.37703000"
                    },
                    {
                        "id": 25386,
                        "name": "Gebsattel",
                        "latitude": "49.35000000",
                        "longitude": "10.20000000"
                    },
                    {
                        "id": 25391,
                        "name": "Gefrees",
                        "latitude": "50.09538000",
                        "longitude": "11.73772000"
                    },
                    {
                        "id": 25395,
                        "name": "Geiersthal",
                        "latitude": "49.04569000",
                        "longitude": "12.98171000"
                    },
                    {
                        "id": 25398,
                        "name": "Geiselbach",
                        "latitude": "50.12329000",
                        "longitude": "9.19664000"
                    },
                    {
                        "id": 25399,
                        "name": "Geiselhöring",
                        "latitude": "48.82505000",
                        "longitude": "12.39649000"
                    },
                    {
                        "id": 25400,
                        "name": "Geiselwind",
                        "latitude": "49.77356000",
                        "longitude": "10.47063000"
                    },
                    {
                        "id": 25401,
                        "name": "Geisenfeld",
                        "latitude": "48.68426000",
                        "longitude": "11.61233000"
                    },
                    {
                        "id": 25402,
                        "name": "Geisenhausen",
                        "latitude": "48.47609000",
                        "longitude": "12.25817000"
                    },
                    {
                        "id": 25413,
                        "name": "Geldersheim",
                        "latitude": "50.04286000",
                        "longitude": "10.15609000"
                    },
                    {
                        "id": 25417,
                        "name": "Geltendorf",
                        "latitude": "48.11737000",
                        "longitude": "11.03216000"
                    },
                    {
                        "id": 25423,
                        "name": "Gemünden am Main",
                        "latitude": "50.04946000",
                        "longitude": "9.70593000"
                    },
                    {
                        "id": 25425,
                        "name": "Genderkingen",
                        "latitude": "48.70000000",
                        "longitude": "10.88333000"
                    },
                    {
                        "id": 25429,
                        "name": "Georgenberg",
                        "latitude": "49.70297000",
                        "longitude": "12.42082000"
                    },
                    {
                        "id": 25430,
                        "name": "Georgensgmünd",
                        "latitude": "49.18972000",
                        "longitude": "11.01667000"
                    },
                    {
                        "id": 25437,
                        "name": "Gerach",
                        "latitude": "50.03333000",
                        "longitude": "10.80000000"
                    },
                    {
                        "id": 25438,
                        "name": "Gerbrunn",
                        "latitude": "49.77528000",
                        "longitude": "9.99361000"
                    },
                    {
                        "id": 25441,
                        "name": "Geretsried",
                        "latitude": "47.85775000",
                        "longitude": "11.48054000"
                    },
                    {
                        "id": 25442,
                        "name": "Gerhardshofen",
                        "latitude": "49.63123000",
                        "longitude": "10.69133000"
                    },
                    {
                        "id": 25445,
                        "name": "Germering",
                        "latitude": "48.13392000",
                        "longitude": "11.37650000"
                    },
                    {
                        "id": 25451,
                        "name": "Geroldsgrün",
                        "latitude": "50.33333000",
                        "longitude": "11.60000000"
                    },
                    {
                        "id": 25452,
                        "name": "Geroldshausen",
                        "latitude": "49.68361000",
                        "longitude": "9.90222000"
                    },
                    {
                        "id": 25453,
                        "name": "Gerolfingen",
                        "latitude": "49.05340000",
                        "longitude": "10.51151000"
                    },
                    {
                        "id": 25454,
                        "name": "Gerolsbach",
                        "latitude": "48.49283000",
                        "longitude": "11.36149000"
                    },
                    {
                        "id": 25457,
                        "name": "Gerolzhofen",
                        "latitude": "49.90025000",
                        "longitude": "10.34832000"
                    },
                    {
                        "id": 25463,
                        "name": "Gersthofen",
                        "latitude": "48.42432000",
                        "longitude": "10.87273000"
                    },
                    {
                        "id": 25467,
                        "name": "Gerzen",
                        "latitude": "48.50706000",
                        "longitude": "12.42686000"
                    },
                    {
                        "id": 25470,
                        "name": "Gesees",
                        "latitude": "50.03207000",
                        "longitude": "11.66623000"
                    },
                    {
                        "id": 25472,
                        "name": "Geslau",
                        "latitude": "49.36643000",
                        "longitude": "10.31528000"
                    },
                    {
                        "id": 25473,
                        "name": "Gessertshausen",
                        "latitude": "48.32904000",
                        "longitude": "10.73278000"
                    },
                    {
                        "id": 25474,
                        "name": "Gestratz",
                        "latitude": "47.65000000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 25480,
                        "name": "Giebelstadt",
                        "latitude": "49.65308000",
                        "longitude": "9.94441000"
                    },
                    {
                        "id": 25489,
                        "name": "Gilching",
                        "latitude": "48.10755000",
                        "longitude": "11.29360000"
                    },
                    {
                        "id": 25504,
                        "name": "Glashütten",
                        "latitude": "49.88739000",
                        "longitude": "11.44870000"
                    },
                    {
                        "id": 25506,
                        "name": "Glattbach",
                        "latitude": "50.00000000",
                        "longitude": "9.15000000"
                    },
                    {
                        "id": 25515,
                        "name": "Glonn",
                        "latitude": "47.98751000",
                        "longitude": "11.86721000"
                    },
                    {
                        "id": 25518,
                        "name": "Glött",
                        "latitude": "48.50000000",
                        "longitude": "10.48333000"
                    },
                    {
                        "id": 25521,
                        "name": "Gmund am Tegernsee",
                        "latitude": "47.75119000",
                        "longitude": "11.73810000"
                    },
                    {
                        "id": 25526,
                        "name": "Gochsheim",
                        "latitude": "50.01667000",
                        "longitude": "10.28333000"
                    },
                    {
                        "id": 25528,
                        "name": "Goldbach",
                        "latitude": "49.99951000",
                        "longitude": "9.18440000"
                    },
                    {
                        "id": 25533,
                        "name": "Goldkronach",
                        "latitude": "50.01086000",
                        "longitude": "11.68750000"
                    },
                    {
                        "id": 25780,
                        "name": "Görisried",
                        "latitude": "47.70668000",
                        "longitude": "10.51015000"
                    },
                    {
                        "id": 25787,
                        "name": "Gössenheim",
                        "latitude": "50.01667000",
                        "longitude": "9.78333000"
                    },
                    {
                        "id": 25790,
                        "name": "Gößweinstein",
                        "latitude": "49.76898000",
                        "longitude": "11.33841000"
                    },
                    {
                        "id": 25551,
                        "name": "Gotteszell",
                        "latitude": "48.96667000",
                        "longitude": "12.96667000"
                    },
                    {
                        "id": 25552,
                        "name": "Gottfrieding",
                        "latitude": "48.63737000",
                        "longitude": "12.53561000"
                    },
                    {
                        "id": 25555,
                        "name": "Graben",
                        "latitude": "48.18732000",
                        "longitude": "10.82222000"
                    },
                    {
                        "id": 25558,
                        "name": "Grabenstätt",
                        "latitude": "47.84531000",
                        "longitude": "12.54330000"
                    },
                    {
                        "id": 25720,
                        "name": "Gräfelfing",
                        "latitude": "48.11878000",
                        "longitude": "11.42939000"
                    },
                    {
                        "id": 25562,
                        "name": "Grafenau",
                        "latitude": "48.85768000",
                        "longitude": "13.39740000"
                    },
                    {
                        "id": 25721,
                        "name": "Gräfenberg",
                        "latitude": "49.64426000",
                        "longitude": "11.24971000"
                    },
                    {
                        "id": 25722,
                        "name": "Gräfendorf",
                        "latitude": "50.12267000",
                        "longitude": "9.74050000"
                    },
                    {
                        "id": 25564,
                        "name": "Grafengehaig",
                        "latitude": "50.20310000",
                        "longitude": "11.59358000"
                    },
                    {
                        "id": 25566,
                        "name": "Grafenrheinfeld",
                        "latitude": "50.00000000",
                        "longitude": "10.20000000"
                    },
                    {
                        "id": 25567,
                        "name": "Grafenwiesen",
                        "latitude": "49.20000000",
                        "longitude": "12.88333000"
                    },
                    {
                        "id": 25568,
                        "name": "Grafenwöhr",
                        "latitude": "49.71728000",
                        "longitude": "11.90645000"
                    },
                    {
                        "id": 25570,
                        "name": "Grafing bei München",
                        "latitude": "48.04596000",
                        "longitude": "11.96797000"
                    },
                    {
                        "id": 25571,
                        "name": "Grafrath",
                        "latitude": "48.11667000",
                        "longitude": "11.16667000"
                    },
                    {
                        "id": 25572,
                        "name": "Grainau",
                        "latitude": "47.47614000",
                        "longitude": "11.02405000"
                    },
                    {
                        "id": 25573,
                        "name": "Grainet",
                        "latitude": "48.80000000",
                        "longitude": "13.65000000"
                    },
                    {
                        "id": 25579,
                        "name": "Grasbrunn",
                        "latitude": "48.07905000",
                        "longitude": "11.74361000"
                    },
                    {
                        "id": 25581,
                        "name": "Grassau",
                        "latitude": "47.78099000",
                        "longitude": "12.45359000"
                    },
                    {
                        "id": 25582,
                        "name": "Grattersdorf",
                        "latitude": "48.80364000",
                        "longitude": "13.15372000"
                    },
                    {
                        "id": 25587,
                        "name": "Greding",
                        "latitude": "49.04699000",
                        "longitude": "11.35703000"
                    },
                    {
                        "id": 25590,
                        "name": "Greifenberg",
                        "latitude": "48.07062000",
                        "longitude": "11.08349000"
                    },
                    {
                        "id": 25593,
                        "name": "Greiling",
                        "latitude": "47.76667000",
                        "longitude": "11.61667000"
                    },
                    {
                        "id": 25598,
                        "name": "Gremsdorf",
                        "latitude": "49.69506000",
                        "longitude": "10.83218000"
                    },
                    {
                        "id": 25601,
                        "name": "Grettstadt",
                        "latitude": "49.98333000",
                        "longitude": "10.31667000"
                    },
                    {
                        "id": 25603,
                        "name": "Greußenheim",
                        "latitude": "49.81667000",
                        "longitude": "9.76667000"
                    },
                    {
                        "id": 25609,
                        "name": "Griesstätt",
                        "latitude": "47.99403000",
                        "longitude": "12.17727000"
                    },
                    {
                        "id": 25727,
                        "name": "Gröbenzell",
                        "latitude": "48.20000000",
                        "longitude": "11.36667000"
                    },
                    {
                        "id": 25648,
                        "name": "Großaitingen",
                        "latitude": "48.22753000",
                        "longitude": "10.77948000"
                    },
                    {
                        "id": 25651,
                        "name": "Großbardorf",
                        "latitude": "50.26667000",
                        "longitude": "10.36667000"
                    },
                    {
                        "id": 25660,
                        "name": "Großeibstadt",
                        "latitude": "50.30102000",
                        "longitude": "10.40980000"
                    },
                    {
                        "id": 25668,
                        "name": "Großenseebach",
                        "latitude": "49.63251000",
                        "longitude": "10.87483000"
                    },
                    {
                        "id": 25673,
                        "name": "Großhabersdorf",
                        "latitude": "49.40000000",
                        "longitude": "10.78333000"
                    },
                    {
                        "id": 25677,
                        "name": "Großheirath",
                        "latitude": "50.17603000",
                        "longitude": "10.95050000"
                    },
                    {
                        "id": 25679,
                        "name": "Großheubach",
                        "latitude": "49.72834000",
                        "longitude": "9.22280000"
                    },
                    {
                        "id": 25682,
                        "name": "Großkarolinenfeld",
                        "latitude": "47.89102000",
                        "longitude": "12.08101000"
                    },
                    {
                        "id": 25688,
                        "name": "Großlangheim",
                        "latitude": "49.75620000",
                        "longitude": "10.24065000"
                    },
                    {
                        "id": 25696,
                        "name": "Großostheim",
                        "latitude": "49.91985000",
                        "longitude": "9.07596000"
                    },
                    {
                        "id": 25699,
                        "name": "Großreuth bei Schweinau",
                        "latitude": "49.43449000",
                        "longitude": "11.02273000"
                    },
                    {
                        "id": 25711,
                        "name": "Großwallstadt",
                        "latitude": "49.87936000",
                        "longitude": "9.15338000"
                    },
                    {
                        "id": 25712,
                        "name": "Großweil",
                        "latitude": "47.67598000",
                        "longitude": "11.30108000"
                    },
                    {
                        "id": 25716,
                        "name": "Grub",
                        "latitude": "50.10285000",
                        "longitude": "11.92904000"
                    },
                    {
                        "id": 25737,
                        "name": "Grünenbach",
                        "latitude": "47.62864000",
                        "longitude": "10.00843000"
                    },
                    {
                        "id": 25745,
                        "name": "Grünwald",
                        "latitude": "48.03947000",
                        "longitude": "11.52320000"
                    },
                    {
                        "id": 25747,
                        "name": "Gstadt am Chiemsee",
                        "latitude": "47.88453000",
                        "longitude": "12.41813000"
                    },
                    {
                        "id": 25755,
                        "name": "Gundelfingen",
                        "latitude": "48.55347000",
                        "longitude": "10.37223000"
                    },
                    {
                        "id": 25757,
                        "name": "Gundelsheim",
                        "latitude": "49.93708000",
                        "longitude": "10.91990000"
                    },
                    {
                        "id": 25759,
                        "name": "Gundremmingen",
                        "latitude": "48.50000000",
                        "longitude": "10.40000000"
                    },
                    {
                        "id": 25794,
                        "name": "Güntersleben",
                        "latitude": "49.86972000",
                        "longitude": "9.90500000"
                    },
                    {
                        "id": 25796,
                        "name": "Günzach",
                        "latitude": "47.82491000",
                        "longitude": "10.43547000"
                    },
                    {
                        "id": 25797,
                        "name": "Günzburg",
                        "latitude": "48.45599000",
                        "longitude": "10.27695000"
                    },
                    {
                        "id": 25761,
                        "name": "Gunzenhausen",
                        "latitude": "49.11663000",
                        "longitude": "10.75971000"
                    },
                    {
                        "id": 25768,
                        "name": "Gutenstetten",
                        "latitude": "49.61667000",
                        "longitude": "10.63333000"
                    },
                    {
                        "id": 25804,
                        "name": "Haag an der Amper",
                        "latitude": "48.45840000",
                        "longitude": "11.82796000"
                    },
                    {
                        "id": 25805,
                        "name": "Haag in Oberbayern",
                        "latitude": "48.16196000",
                        "longitude": "12.17942000"
                    },
                    {
                        "id": 25807,
                        "name": "Haar",
                        "latitude": "48.10881000",
                        "longitude": "11.72653000"
                    },
                    {
                        "id": 25808,
                        "name": "Haarbach",
                        "latitude": "48.50000000",
                        "longitude": "13.15000000"
                    },
                    {
                        "id": 25809,
                        "name": "Habach",
                        "latitude": "47.73333000",
                        "longitude": "11.28333000"
                    },
                    {
                        "id": 25814,
                        "name": "Hafenlohr",
                        "latitude": "49.86944000",
                        "longitude": "9.60222000"
                    },
                    {
                        "id": 25816,
                        "name": "Hagelstadt",
                        "latitude": "48.90000000",
                        "longitude": "12.21667000"
                    },
                    {
                        "id": 25822,
                        "name": "Hagenbüchach",
                        "latitude": "49.53333000",
                        "longitude": "10.76667000"
                    },
                    {
                        "id": 25825,
                        "name": "Hahnbach",
                        "latitude": "49.53389000",
                        "longitude": "11.80302000"
                    },
                    {
                        "id": 25828,
                        "name": "Haibach",
                        "latitude": "49.96444000",
                        "longitude": "9.20722000"
                    },
                    {
                        "id": 25829,
                        "name": "Haidmühle",
                        "latitude": "48.82565000",
                        "longitude": "13.77649000"
                    },
                    {
                        "id": 25832,
                        "name": "Haimhausen",
                        "latitude": "48.31545000",
                        "longitude": "11.55453000"
                    },
                    {
                        "id": 25833,
                        "name": "Haiming",
                        "latitude": "48.21667000",
                        "longitude": "12.90000000"
                    },
                    {
                        "id": 25839,
                        "name": "Hainsfarth",
                        "latitude": "48.95839000",
                        "longitude": "10.62491000"
                    },
                    {
                        "id": 25845,
                        "name": "Halblech",
                        "latitude": "47.63155000",
                        "longitude": "10.82024000"
                    },
                    {
                        "id": 25847,
                        "name": "Haldenwang",
                        "latitude": "47.80000000",
                        "longitude": "10.35000000"
                    },
                    {
                        "id": 25849,
                        "name": "Halfing",
                        "latitude": "47.95197000",
                        "longitude": "12.27525000"
                    },
                    {
                        "id": 25850,
                        "name": "Hallbergmoos",
                        "latitude": "48.32747000",
                        "longitude": "11.75142000"
                    },
                    {
                        "id": 25856,
                        "name": "Hallerndorf",
                        "latitude": "49.75909000",
                        "longitude": "10.97946000"
                    },
                    {
                        "id": 25857,
                        "name": "Hallstadt",
                        "latitude": "49.92901000",
                        "longitude": "10.87539000"
                    },
                    {
                        "id": 25876,
                        "name": "Hammelburg",
                        "latitude": "50.11633000",
                        "longitude": "9.89143000"
                    },
                    {
                        "id": 25895,
                        "name": "Happurg",
                        "latitude": "49.49372000",
                        "longitude": "11.47119000"
                    },
                    {
                        "id": 25898,
                        "name": "Harburg",
                        "latitude": "48.78674000",
                        "longitude": "10.68927000"
                    },
                    {
                        "id": 25906,
                        "name": "Harsdorf",
                        "latitude": "50.03333000",
                        "longitude": "11.56667000"
                    },
                    {
                        "id": 25912,
                        "name": "Hartenstein",
                        "latitude": "49.60000000",
                        "longitude": "11.51667000"
                    },
                    {
                        "id": 25923,
                        "name": "Haselbach",
                        "latitude": "48.64564000",
                        "longitude": "13.38956000"
                    },
                    {
                        "id": 25929,
                        "name": "Hasloch",
                        "latitude": "49.79194000",
                        "longitude": "9.49361000"
                    },
                    {
                        "id": 25962,
                        "name": "Haßfurt",
                        "latitude": "50.03521000",
                        "longitude": "10.51560000"
                    },
                    {
                        "id": 25936,
                        "name": "Hattenhofen",
                        "latitude": "48.22231000",
                        "longitude": "11.11551000"
                    },
                    {
                        "id": 25946,
                        "name": "Haundorf",
                        "latitude": "49.17598000",
                        "longitude": "10.77124000"
                    },
                    {
                        "id": 25947,
                        "name": "Haunsheim",
                        "latitude": "48.59977000",
                        "longitude": "10.37401000"
                    },
                    {
                        "id": 25950,
                        "name": "Hausen",
                        "latitude": "48.85953000",
                        "longitude": "12.00630000"
                    },
                    {
                        "id": 25953,
                        "name": "Hausham",
                        "latitude": "47.74660000",
                        "longitude": "11.84069000"
                    },
                    {
                        "id": 25955,
                        "name": "Hauzenberg",
                        "latitude": "48.64957000",
                        "longitude": "13.62645000"
                    },
                    {
                        "id": 25959,
                        "name": "Hawangen",
                        "latitude": "47.96667000",
                        "longitude": "10.26667000"
                    },
                    {
                        "id": 25966,
                        "name": "Hebertsfelden",
                        "latitude": "48.40596000",
                        "longitude": "12.82259000"
                    },
                    {
                        "id": 25967,
                        "name": "Hebertshausen",
                        "latitude": "48.28959000",
                        "longitude": "11.46526000"
                    },
                    {
                        "id": 25981,
                        "name": "Heideck",
                        "latitude": "49.13365000",
                        "longitude": "11.12726000"
                    },
                    {
                        "id": 25986,
                        "name": "Heidenheim",
                        "latitude": "49.01719000",
                        "longitude": "10.74347000"
                    },
                    {
                        "id": 25991,
                        "name": "Heigenbrücken",
                        "latitude": "50.02820000",
                        "longitude": "9.37116000"
                    },
                    {
                        "id": 26001,
                        "name": "Heiligenstadt",
                        "latitude": "49.86303000",
                        "longitude": "11.17185000"
                    },
                    {
                        "id": 26004,
                        "name": "Heilsbronn",
                        "latitude": "49.33572000",
                        "longitude": "10.78741000"
                    },
                    {
                        "id": 26007,
                        "name": "Heimbuchenthal",
                        "latitude": "49.88917000",
                        "longitude": "9.29556000"
                    },
                    {
                        "id": 26008,
                        "name": "Heimenkirch",
                        "latitude": "47.62959000",
                        "longitude": "9.90304000"
                    },
                    {
                        "id": 26009,
                        "name": "Heimertingen",
                        "latitude": "48.03333000",
                        "longitude": "10.15000000"
                    },
                    {
                        "id": 26029,
                        "name": "Helmbrechts",
                        "latitude": "50.23557000",
                        "longitude": "11.71589000"
                    },
                    {
                        "id": 26030,
                        "name": "Helmstadt",
                        "latitude": "49.76180000",
                        "longitude": "9.70803000"
                    },
                    {
                        "id": 26036,
                        "name": "Hemau",
                        "latitude": "49.05399000",
                        "longitude": "11.78195000"
                    },
                    {
                        "id": 26039,
                        "name": "Hemhofen",
                        "latitude": "49.68333000",
                        "longitude": "10.93333000"
                    },
                    {
                        "id": 26047,
                        "name": "Hendungen",
                        "latitude": "50.39462000",
                        "longitude": "10.35204000"
                    },
                    {
                        "id": 26048,
                        "name": "Henfenfeld",
                        "latitude": "49.49846000",
                        "longitude": "11.39059000"
                    },
                    {
                        "id": 26049,
                        "name": "Hengersberg",
                        "latitude": "48.77255000",
                        "longitude": "13.05485000"
                    },
                    {
                        "id": 26066,
                        "name": "Heretsried",
                        "latitude": "48.45972000",
                        "longitude": "10.73601000"
                    },
                    {
                        "id": 26069,
                        "name": "Hergensweiler",
                        "latitude": "47.61667000",
                        "longitude": "9.78333000"
                    },
                    {
                        "id": 26084,
                        "name": "Heroldsbach",
                        "latitude": "49.69342000",
                        "longitude": "10.99882000"
                    },
                    {
                        "id": 26085,
                        "name": "Heroldsberg",
                        "latitude": "49.53247000",
                        "longitude": "11.15551000"
                    },
                    {
                        "id": 26087,
                        "name": "Herrieden",
                        "latitude": "49.23779000",
                        "longitude": "10.50350000"
                    },
                    {
                        "id": 26089,
                        "name": "Herrngiersdorf",
                        "latitude": "48.78863000",
                        "longitude": "12.07200000"
                    },
                    {
                        "id": 26091,
                        "name": "Herrsching am Ammersee",
                        "latitude": "47.99888000",
                        "longitude": "11.17679000"
                    },
                    {
                        "id": 26092,
                        "name": "Hersbruck",
                        "latitude": "49.51083000",
                        "longitude": "11.43151000"
                    },
                    {
                        "id": 26102,
                        "name": "Herzogenaurach",
                        "latitude": "49.56798000",
                        "longitude": "10.88565000"
                    },
                    {
                        "id": 26128,
                        "name": "Heßdorf",
                        "latitude": "49.62728000",
                        "longitude": "10.91002000"
                    },
                    {
                        "id": 26111,
                        "name": "Hettenshausen",
                        "latitude": "48.50000000",
                        "longitude": "11.50000000"
                    },
                    {
                        "id": 26113,
                        "name": "Hettstadt",
                        "latitude": "49.79944000",
                        "longitude": "9.81500000"
                    },
                    {
                        "id": 26116,
                        "name": "Hetzles",
                        "latitude": "49.63333000",
                        "longitude": "11.13333000"
                    },
                    {
                        "id": 26124,
                        "name": "Heustreu",
                        "latitude": "50.35485000",
                        "longitude": "10.26069000"
                    },
                    {
                        "id": 26141,
                        "name": "Hilgertshausen-Tandern",
                        "latitude": "48.42960000",
                        "longitude": "11.35428000"
                    },
                    {
                        "id": 26146,
                        "name": "Hilpoltstein",
                        "latitude": "49.19047000",
                        "longitude": "11.19060000"
                    },
                    {
                        "id": 26147,
                        "name": "Hiltenfingen",
                        "latitude": "48.16085000",
                        "longitude": "10.71750000"
                    },
                    {
                        "id": 26149,
                        "name": "Hiltpoltstein",
                        "latitude": "49.66075000",
                        "longitude": "11.32272000"
                    },
                    {
                        "id": 26152,
                        "name": "Himmelkron",
                        "latitude": "50.06667000",
                        "longitude": "11.60000000"
                    },
                    {
                        "id": 26154,
                        "name": "Himmelstadt",
                        "latitude": "49.92389000",
                        "longitude": "9.80167000"
                    },
                    {
                        "id": 26156,
                        "name": "Hinterschmiding",
                        "latitude": "48.82337000",
                        "longitude": "13.60369000"
                    },
                    {
                        "id": 26161,
                        "name": "Hirschaid",
                        "latitude": "49.81789000",
                        "longitude": "10.98918000"
                    },
                    {
                        "id": 26162,
                        "name": "Hirschau",
                        "latitude": "49.54396000",
                        "longitude": "11.94617000"
                    },
                    {
                        "id": 26163,
                        "name": "Hirschbach",
                        "latitude": "49.55000000",
                        "longitude": "11.53333000"
                    },
                    {
                        "id": 26298,
                        "name": "Höchberg",
                        "latitude": "49.78446000",
                        "longitude": "9.88223000"
                    },
                    {
                        "id": 26300,
                        "name": "Höchheim",
                        "latitude": "50.36667000",
                        "longitude": "10.45000000"
                    },
                    {
                        "id": 26180,
                        "name": "Hochstadt am Main",
                        "latitude": "50.15009000",
                        "longitude": "11.17116000"
                    },
                    {
                        "id": 26302,
                        "name": "Höchstadt an der Aisch",
                        "latitude": "49.70617000",
                        "longitude": "10.81329000"
                    },
                    {
                        "id": 26303,
                        "name": "Höchstädt an der Donau",
                        "latitude": "48.61124000",
                        "longitude": "10.56816000"
                    },
                    {
                        "id": 26304,
                        "name": "Höchstädt bei Thiersheim",
                        "latitude": "50.10157000",
                        "longitude": "12.08711000"
                    },
                    {
                        "id": 26185,
                        "name": "Hof",
                        "latitude": "50.31297000",
                        "longitude": "11.91261000"
                    },
                    {
                        "id": 26189,
                        "name": "Hofheim in Unterfranken",
                        "latitude": "50.13675000",
                        "longitude": "10.52321000"
                    },
                    {
                        "id": 26190,
                        "name": "Hofkirchen",
                        "latitude": "48.67805000",
                        "longitude": "13.11917000"
                    },
                    {
                        "id": 26192,
                        "name": "Hofstetten",
                        "latitude": "48.00847000",
                        "longitude": "10.97114000"
                    },
                    {
                        "id": 26197,
                        "name": "Hohenau",
                        "latitude": "48.84983000",
                        "longitude": "13.48825000"
                    },
                    {
                        "id": 26198,
                        "name": "Hohenberg an der Eger",
                        "latitude": "50.09501000",
                        "longitude": "12.22008000"
                    },
                    {
                        "id": 26200,
                        "name": "Hohenbrunn",
                        "latitude": "48.04785000",
                        "longitude": "11.70224000"
                    },
                    {
                        "id": 26201,
                        "name": "Hohenburg",
                        "latitude": "49.29507000",
                        "longitude": "11.79906000"
                    },
                    {
                        "id": 26204,
                        "name": "Hohenfels",
                        "latitude": "49.20397000",
                        "longitude": "11.84841000"
                    },
                    {
                        "id": 26205,
                        "name": "Hohenfurch",
                        "latitude": "47.85000000",
                        "longitude": "10.90000000"
                    },
                    {
                        "id": 26207,
                        "name": "Hohenkammer",
                        "latitude": "48.42406000",
                        "longitude": "11.52522000"
                    },
                    {
                        "id": 26310,
                        "name": "Höhenkirchen-Siegertsbrunn",
                        "latitude": "48.01932000",
                        "longitude": "11.71906000"
                    },
                    {
                        "id": 26210,
                        "name": "Hohenlinden",
                        "latitude": "48.15612000",
                        "longitude": "11.99458000"
                    },
                    {
                        "id": 26213,
                        "name": "Hohenpeißenberg",
                        "latitude": "47.80000000",
                        "longitude": "11.00000000"
                    },
                    {
                        "id": 26214,
                        "name": "Hohenpolding",
                        "latitude": "48.38333000",
                        "longitude": "12.13333000"
                    },
                    {
                        "id": 26217,
                        "name": "Hohenthann",
                        "latitude": "48.66115000",
                        "longitude": "12.09251000"
                    },
                    {
                        "id": 26220,
                        "name": "Hohenwarth",
                        "latitude": "49.20000000",
                        "longitude": "12.93333000"
                    },
                    {
                        "id": 26231,
                        "name": "Hollenbach",
                        "latitude": "48.48333000",
                        "longitude": "11.06667000"
                    },
                    {
                        "id": 26234,
                        "name": "Hollfeld",
                        "latitude": "49.93793000",
                        "longitude": "11.29153000"
                    },
                    {
                        "id": 26236,
                        "name": "Hollstadt",
                        "latitude": "50.35000000",
                        "longitude": "10.30000000"
                    },
                    {
                        "id": 26243,
                        "name": "Holzgünz",
                        "latitude": "48.02503000",
                        "longitude": "10.25901000"
                    },
                    {
                        "id": 26245,
                        "name": "Holzheim",
                        "latitude": "48.51422000",
                        "longitude": "10.53057000"
                    },
                    {
                        "id": 26246,
                        "name": "Holzkirchen",
                        "latitude": "47.87663000",
                        "longitude": "11.70181000"
                    },
                    {
                        "id": 26254,
                        "name": "Hopferau",
                        "latitude": "47.61667000",
                        "longitude": "10.63333000"
                    },
                    {
                        "id": 26259,
                        "name": "Horgau",
                        "latitude": "48.39507000",
                        "longitude": "10.68283000"
                    },
                    {
                        "id": 26318,
                        "name": "Hörgertshausen",
                        "latitude": "48.55000000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 26322,
                        "name": "Hösbach",
                        "latitude": "50.00646000",
                        "longitude": "9.20765000"
                    },
                    {
                        "id": 26323,
                        "name": "Höslwang",
                        "latitude": "47.95378000",
                        "longitude": "12.32915000"
                    },
                    {
                        "id": 26325,
                        "name": "Höttingen",
                        "latitude": "49.06262000",
                        "longitude": "11.00530000"
                    },
                    {
                        "id": 26281,
                        "name": "Huglfing",
                        "latitude": "47.76667000",
                        "longitude": "11.16667000"
                    },
                    {
                        "id": 26282,
                        "name": "Huisheim",
                        "latitude": "48.82510000",
                        "longitude": "10.70331000"
                    },
                    {
                        "id": 26285,
                        "name": "Hunderdorf",
                        "latitude": "48.89162000",
                        "longitude": "12.67382000"
                    },
                    {
                        "id": 26287,
                        "name": "Hunding",
                        "latitude": "48.84227000",
                        "longitude": "13.17681000"
                    },
                    {
                        "id": 26290,
                        "name": "Hurlach",
                        "latitude": "48.11838000",
                        "longitude": "10.81115000"
                    },
                    {
                        "id": 26293,
                        "name": "Hutthurm",
                        "latitude": "48.67276000",
                        "longitude": "13.47146000"
                    },
                    {
                        "id": 26347,
                        "name": "Ichenhausen",
                        "latitude": "48.37119000",
                        "longitude": "10.30706000"
                    },
                    {
                        "id": 26349,
                        "name": "Icking",
                        "latitude": "47.95000000",
                        "longitude": "11.43333000"
                    },
                    {
                        "id": 26352,
                        "name": "Iffeldorf",
                        "latitude": "47.76667000",
                        "longitude": "11.31667000"
                    },
                    {
                        "id": 26356,
                        "name": "Igensdorf",
                        "latitude": "49.62322000",
                        "longitude": "11.23137000"
                    },
                    {
                        "id": 26358,
                        "name": "Iggensbach",
                        "latitude": "48.73014000",
                        "longitude": "13.14229000"
                    },
                    {
                        "id": 26362,
                        "name": "Ihrlerstein",
                        "latitude": "48.93333000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 26367,
                        "name": "Illertissen",
                        "latitude": "48.22336000",
                        "longitude": "10.10347000"
                    },
                    {
                        "id": 26371,
                        "name": "Illschwang",
                        "latitude": "49.45000000",
                        "longitude": "11.68333000"
                    },
                    {
                        "id": 26373,
                        "name": "Ilmmünster",
                        "latitude": "48.48333000",
                        "longitude": "11.50000000"
                    },
                    {
                        "id": 26382,
                        "name": "Immenreuth",
                        "latitude": "49.90000000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 26384,
                        "name": "Immenstadt im Allgäu",
                        "latitude": "47.55996000",
                        "longitude": "10.21394000"
                    },
                    {
                        "id": 26386,
                        "name": "Inchenhofen",
                        "latitude": "48.51288000",
                        "longitude": "11.11458000"
                    },
                    {
                        "id": 26392,
                        "name": "Ingolstadt",
                        "latitude": "48.76508000",
                        "longitude": "11.42372000"
                    },
                    {
                        "id": 26393,
                        "name": "Innernzell",
                        "latitude": "48.85150000",
                        "longitude": "13.27539000"
                    },
                    {
                        "id": 26394,
                        "name": "Inning am Ammersee",
                        "latitude": "48.07636000",
                        "longitude": "11.15232000"
                    },
                    {
                        "id": 26395,
                        "name": "Inning am Holz",
                        "latitude": "48.34687000",
                        "longitude": "12.07506000"
                    },
                    {
                        "id": 26397,
                        "name": "Insingen",
                        "latitude": "49.30000000",
                        "longitude": "10.16667000"
                    },
                    {
                        "id": 26398,
                        "name": "Inzell",
                        "latitude": "47.76302000",
                        "longitude": "12.75146000"
                    },
                    {
                        "id": 26401,
                        "name": "Iphofen",
                        "latitude": "49.70239000",
                        "longitude": "10.26037000"
                    },
                    {
                        "id": 26402,
                        "name": "Ippesheim",
                        "latitude": "49.60214000",
                        "longitude": "10.22552000"
                    },
                    {
                        "id": 26403,
                        "name": "Ipsheim",
                        "latitude": "49.52750000",
                        "longitude": "10.48176000"
                    },
                    {
                        "id": 26404,
                        "name": "Irchenrieth",
                        "latitude": "49.62286000",
                        "longitude": "12.22495000"
                    },
                    {
                        "id": 26405,
                        "name": "Irlbach",
                        "latitude": "48.84128000",
                        "longitude": "12.75135000"
                    },
                    {
                        "id": 26408,
                        "name": "Irschenberg",
                        "latitude": "47.83333000",
                        "longitude": "11.91667000"
                    },
                    {
                        "id": 26409,
                        "name": "Irsee",
                        "latitude": "47.90815000",
                        "longitude": "10.57177000"
                    },
                    {
                        "id": 26411,
                        "name": "Isen",
                        "latitude": "48.21203000",
                        "longitude": "12.05672000"
                    },
                    {
                        "id": 26415,
                        "name": "Ismaning",
                        "latitude": "48.23333000",
                        "longitude": "11.68333000"
                    },
                    {
                        "id": 154477,
                        "name": "Issigau",
                        "latitude": "50.38045280",
                        "longitude": "11.67949810"
                    },
                    {
                        "id": 26429,
                        "name": "Jandelsbrunn",
                        "latitude": "48.73333000",
                        "longitude": "13.70000000"
                    },
                    {
                        "id": 26436,
                        "name": "Jengen",
                        "latitude": "47.99934000",
                        "longitude": "10.72575000"
                    },
                    {
                        "id": 26442,
                        "name": "Jesenwang",
                        "latitude": "48.16667000",
                        "longitude": "11.13333000"
                    },
                    {
                        "id": 26447,
                        "name": "Jettingen-Scheppach",
                        "latitude": "48.38960000",
                        "longitude": "10.43810000"
                    },
                    {
                        "id": 26448,
                        "name": "Jetzendorf",
                        "latitude": "48.43333000",
                        "longitude": "11.41667000"
                    },
                    {
                        "id": 26454,
                        "name": "Johannesberg",
                        "latitude": "50.03159000",
                        "longitude": "9.14252000"
                    },
                    {
                        "id": 26456,
                        "name": "Johanniskirchen",
                        "latitude": "48.53333000",
                        "longitude": "12.95000000"
                    },
                    {
                        "id": 26462,
                        "name": "Julbach",
                        "latitude": "48.25430000",
                        "longitude": "12.95793000"
                    },
                    {
                        "id": 26479,
                        "name": "Kahl am Main",
                        "latitude": "50.06981000",
                        "longitude": "9.00553000"
                    },
                    {
                        "id": 26484,
                        "name": "Kaisheim",
                        "latitude": "48.76751000",
                        "longitude": "10.79639000"
                    },
                    {
                        "id": 26487,
                        "name": "Kalchreuth",
                        "latitude": "49.55785000",
                        "longitude": "11.13350000"
                    },
                    {
                        "id": 26493,
                        "name": "Kallmünz",
                        "latitude": "49.16094000",
                        "longitude": "11.96051000"
                    },
                    {
                        "id": 26501,
                        "name": "Kammerstein",
                        "latitude": "49.29317000",
                        "longitude": "10.97277000"
                    },
                    {
                        "id": 26512,
                        "name": "Karbach",
                        "latitude": "49.86701000",
                        "longitude": "9.63806000"
                    },
                    {
                        "id": 26515,
                        "name": "Karlsfeld",
                        "latitude": "48.22697000",
                        "longitude": "11.47573000"
                    },
                    {
                        "id": 26518,
                        "name": "Karlshuld",
                        "latitude": "48.68190000",
                        "longitude": "11.28503000"
                    },
                    {
                        "id": 26519,
                        "name": "Karlskron",
                        "latitude": "48.68333000",
                        "longitude": "11.41667000"
                    },
                    {
                        "id": 26522,
                        "name": "Karlstadt",
                        "latitude": "49.96034000",
                        "longitude": "9.77239000"
                    },
                    {
                        "id": 26524,
                        "name": "Karsbach",
                        "latitude": "50.04091000",
                        "longitude": "9.78534000"
                    },
                    {
                        "id": 26529,
                        "name": "Kasendorf",
                        "latitude": "50.03665000",
                        "longitude": "11.35203000"
                    },
                    {
                        "id": 26533,
                        "name": "Kastl",
                        "latitude": "49.36960000",
                        "longitude": "11.68261000"
                    },
                    {
                        "id": 26542,
                        "name": "Kaufbeuren",
                        "latitude": "47.88238000",
                        "longitude": "10.62192000"
                    },
                    {
                        "id": 26543,
                        "name": "Kaufering",
                        "latitude": "48.09121000",
                        "longitude": "10.87913000"
                    },
                    {
                        "id": 26556,
                        "name": "Kelheim",
                        "latitude": "48.91725000",
                        "longitude": "11.88618000"
                    },
                    {
                        "id": 26561,
                        "name": "Kellmünz",
                        "latitude": "48.12159000",
                        "longitude": "10.12811000"
                    },
                    {
                        "id": 26564,
                        "name": "Kemmern",
                        "latitude": "49.95486000",
                        "longitude": "10.87784000"
                    },
                    {
                        "id": 26565,
                        "name": "Kemnath",
                        "latitude": "49.87007000",
                        "longitude": "11.89077000"
                    },
                    {
                        "id": 26569,
                        "name": "Kempten (Allgäu)",
                        "latitude": "47.72674000",
                        "longitude": "10.31389000"
                    },
                    {
                        "id": 26577,
                        "name": "Kettershausen",
                        "latitude": "48.18333000",
                        "longitude": "10.26667000"
                    },
                    {
                        "id": 26583,
                        "name": "Kiefersfelden",
                        "latitude": "47.61409000",
                        "longitude": "12.19096000"
                    },
                    {
                        "id": 26585,
                        "name": "Kienberg",
                        "latitude": "48.03481000",
                        "longitude": "12.46330000"
                    },
                    {
                        "id": 26593,
                        "name": "Kirchanschöring",
                        "latitude": "47.95303000",
                        "longitude": "12.83435000"
                    },
                    {
                        "id": 26597,
                        "name": "Kirchberg",
                        "latitude": "48.90006000",
                        "longitude": "13.18200000"
                    },
                    {
                        "id": 26602,
                        "name": "Kirchdorf",
                        "latitude": "48.45942000",
                        "longitude": "11.65438000"
                    },
                    {
                        "id": 26605,
                        "name": "Kirchdorf am Inn",
                        "latitude": "48.24755000",
                        "longitude": "12.98453000"
                    },
                    {
                        "id": 26606,
                        "name": "Kirchdorf im Wald",
                        "latitude": "48.91048000",
                        "longitude": "13.26614000"
                    },
                    {
                        "id": 26607,
                        "name": "Kirchehrenbach",
                        "latitude": "49.73333000",
                        "longitude": "11.15000000"
                    },
                    {
                        "id": 26609,
                        "name": "Kirchenlamitz",
                        "latitude": "50.15190000",
                        "longitude": "11.94831000"
                    },
                    {
                        "id": 26610,
                        "name": "Kirchenpingarten",
                        "latitude": "49.93333000",
                        "longitude": "11.78333000"
                    },
                    {
                        "id": 26611,
                        "name": "Kirchensittenbach",
                        "latitude": "49.55601000",
                        "longitude": "11.42226000"
                    },
                    {
                        "id": 26613,
                        "name": "Kirchenthumbach",
                        "latitude": "49.74866000",
                        "longitude": "11.72542000"
                    },
                    {
                        "id": 26616,
                        "name": "Kirchham",
                        "latitude": "48.34638000",
                        "longitude": "13.26719000"
                    },
                    {
                        "id": 26617,
                        "name": "Kirchhaslach",
                        "latitude": "48.15040000",
                        "longitude": "10.31015000"
                    },
                    {
                        "id": 26619,
                        "name": "Kirchheim",
                        "latitude": "48.17490000",
                        "longitude": "10.47461000"
                    },
                    {
                        "id": 26624,
                        "name": "Kirchheim bei München",
                        "latitude": "48.17656000",
                        "longitude": "11.75563000"
                    },
                    {
                        "id": 26628,
                        "name": "Kirchlauter",
                        "latitude": "50.04430000",
                        "longitude": "10.71776000"
                    },
                    {
                        "id": 26631,
                        "name": "Kirchroth",
                        "latitude": "48.95000000",
                        "longitude": "12.55000000"
                    },
                    {
                        "id": 26633,
                        "name": "Kirchseeon",
                        "latitude": "48.07143000",
                        "longitude": "11.88875000"
                    },
                    {
                        "id": 26637,
                        "name": "Kirchweidach",
                        "latitude": "48.08575000",
                        "longitude": "12.64530000"
                    },
                    {
                        "id": 26640,
                        "name": "Kirchzell",
                        "latitude": "49.61800000",
                        "longitude": "9.17785000"
                    },
                    {
                        "id": 26649,
                        "name": "Kissing",
                        "latitude": "48.30375000",
                        "longitude": "10.97088000"
                    },
                    {
                        "id": 26650,
                        "name": "Kist",
                        "latitude": "49.74278000",
                        "longitude": "9.84389000"
                    },
                    {
                        "id": 26652,
                        "name": "Kitzingen",
                        "latitude": "49.73973000",
                        "longitude": "10.15072000"
                    },
                    {
                        "id": 26668,
                        "name": "Kleinaitingen",
                        "latitude": "48.21850000",
                        "longitude": "10.86923000"
                    },
                    {
                        "id": 26672,
                        "name": "Kleinheubach",
                        "latitude": "49.72109000",
                        "longitude": "9.21346000"
                    },
                    {
                        "id": 26673,
                        "name": "Kleinkahl",
                        "latitude": "50.11667000",
                        "longitude": "9.26667000"
                    },
                    {
                        "id": 26674,
                        "name": "Kleinlangheim",
                        "latitude": "49.77087000",
                        "longitude": "10.28430000"
                    },
                    {
                        "id": 26677,
                        "name": "Kleinostheim",
                        "latitude": "50.00000000",
                        "longitude": "9.06667000"
                    },
                    {
                        "id": 26678,
                        "name": "Kleinrinderfeld",
                        "latitude": "49.70028000",
                        "longitude": "9.84472000"
                    },
                    {
                        "id": 26679,
                        "name": "Kleinsendelbach",
                        "latitude": "49.59558000",
                        "longitude": "11.15773000"
                    },
                    {
                        "id": 26680,
                        "name": "Kleinwallstadt",
                        "latitude": "49.87464000",
                        "longitude": "9.16927000"
                    },
                    {
                        "id": 26686,
                        "name": "Klingenberg am Main",
                        "latitude": "49.78507000",
                        "longitude": "9.18025000"
                    },
                    {
                        "id": 26694,
                        "name": "Klosterlechfeld",
                        "latitude": "48.15586000",
                        "longitude": "10.82986000"
                    },
                    {
                        "id": 26701,
                        "name": "Knetzgau",
                        "latitude": "49.98333000",
                        "longitude": "10.55000000"
                    },
                    {
                        "id": 26706,
                        "name": "Kochel",
                        "latitude": "47.65926000",
                        "longitude": "11.36827000"
                    },
                    {
                        "id": 26812,
                        "name": "Köditz",
                        "latitude": "50.33333000",
                        "longitude": "11.85000000"
                    },
                    {
                        "id": 26813,
                        "name": "Ködnitz",
                        "latitude": "50.10000000",
                        "longitude": "11.53333000"
                    },
                    {
                        "id": 26814,
                        "name": "Köfering",
                        "latitude": "48.93333000",
                        "longitude": "12.20000000"
                    },
                    {
                        "id": 26708,
                        "name": "Kohlberg",
                        "latitude": "49.59121000",
                        "longitude": "12.01948000"
                    },
                    {
                        "id": 26710,
                        "name": "Kolbermoor",
                        "latitude": "47.84965000",
                        "longitude": "12.06696000"
                    },
                    {
                        "id": 26712,
                        "name": "Kolitzheim",
                        "latitude": "49.91667000",
                        "longitude": "10.23333000"
                    },
                    {
                        "id": 26715,
                        "name": "Kollnburg",
                        "latitude": "49.04664000",
                        "longitude": "12.86121000"
                    },
                    {
                        "id": 26825,
                        "name": "Königsbrunn",
                        "latitude": "48.27506000",
                        "longitude": "10.89178000"
                    },
                    {
                        "id": 26827,
                        "name": "Königsdorf",
                        "latitude": "47.81546000",
                        "longitude": "11.48063000"
                    },
                    {
                        "id": 26830,
                        "name": "Königsfeld",
                        "latitude": "49.94603000",
                        "longitude": "11.16520000"
                    },
                    {
                        "id": 26835,
                        "name": "Königstein",
                        "latitude": "49.60854000",
                        "longitude": "11.63143000"
                    },
                    {
                        "id": 26717,
                        "name": "Konradsreuth",
                        "latitude": "50.26667000",
                        "longitude": "11.85000000"
                    },
                    {
                        "id": 26720,
                        "name": "Konzell",
                        "latitude": "49.07240000",
                        "longitude": "12.71114000"
                    },
                    {
                        "id": 26731,
                        "name": "Kottgeisering",
                        "latitude": "48.11667000",
                        "longitude": "11.13333000"
                    },
                    {
                        "id": 26848,
                        "name": "Kötzting",
                        "latitude": "49.17649000",
                        "longitude": "12.85515000"
                    },
                    {
                        "id": 26734,
                        "name": "Kraiburg am Inn",
                        "latitude": "48.18191000",
                        "longitude": "12.43073000"
                    },
                    {
                        "id": 26736,
                        "name": "Krailling",
                        "latitude": "48.10000000",
                        "longitude": "11.40000000"
                    },
                    {
                        "id": 26754,
                        "name": "Kreut",
                        "latitude": "47.79868000",
                        "longitude": "11.48312000"
                    },
                    {
                        "id": 26758,
                        "name": "Kreuzwertheim",
                        "latitude": "49.76818000",
                        "longitude": "9.51819000"
                    },
                    {
                        "id": 26765,
                        "name": "Krombach",
                        "latitude": "50.08319000",
                        "longitude": "9.20609000"
                    },
                    {
                        "id": 26767,
                        "name": "Kronach",
                        "latitude": "50.23963000",
                        "longitude": "11.33308000"
                    },
                    {
                        "id": 26771,
                        "name": "Kronburg",
                        "latitude": "47.90432000",
                        "longitude": "10.15720000"
                    },
                    {
                        "id": 26778,
                        "name": "Krumbach",
                        "latitude": "48.24182000",
                        "longitude": "10.36320000"
                    },
                    {
                        "id": 26779,
                        "name": "Krummennaab",
                        "latitude": "49.83333000",
                        "longitude": "12.10000000"
                    },
                    {
                        "id": 26787,
                        "name": "Krün",
                        "latitude": "47.50515000",
                        "longitude": "11.27924000"
                    },
                    {
                        "id": 26791,
                        "name": "Kueps Oberfranken",
                        "latitude": "50.19265000",
                        "longitude": "11.27599000"
                    },
                    {
                        "id": 26849,
                        "name": "Kühbach",
                        "latitude": "48.49101000",
                        "longitude": "11.18691000"
                    },
                    {
                        "id": 26793,
                        "name": "Kulmain",
                        "latitude": "49.90000000",
                        "longitude": "11.90000000"
                    },
                    {
                        "id": 26794,
                        "name": "Kulmbach",
                        "latitude": "50.10068000",
                        "longitude": "11.45032000"
                    },
                    {
                        "id": 26795,
                        "name": "Kumhausen",
                        "latitude": "48.50938000",
                        "longitude": "12.15637000"
                    },
                    {
                        "id": 26854,
                        "name": "Kümmersbruck",
                        "latitude": "49.41917000",
                        "longitude": "11.88833000"
                    },
                    {
                        "id": 26797,
                        "name": "Kunreuth",
                        "latitude": "50.23321000",
                        "longitude": "11.53119000"
                    },
                    {
                        "id": 26857,
                        "name": "Künzing",
                        "latitude": "48.66667000",
                        "longitude": "13.08333000"
                    },
                    {
                        "id": 26798,
                        "name": "Kupferberg",
                        "latitude": "50.13960000",
                        "longitude": "11.57762000"
                    },
                    {
                        "id": 26858,
                        "name": "Kürnach",
                        "latitude": "49.85000000",
                        "longitude": "10.03333000"
                    },
                    {
                        "id": 26809,
                        "name": "Kutzenhausen",
                        "latitude": "48.34202000",
                        "longitude": "10.69459000"
                    },
                    {
                        "id": 26865,
                        "name": "Laberweinting",
                        "latitude": "48.80000000",
                        "longitude": "12.31667000"
                    },
                    {
                        "id": 26867,
                        "name": "Lachen",
                        "latitude": "47.94590000",
                        "longitude": "10.23943000"
                    },
                    {
                        "id": 26879,
                        "name": "Lalling",
                        "latitude": "48.84525000",
                        "longitude": "13.14008000"
                    },
                    {
                        "id": 26880,
                        "name": "Lam",
                        "latitude": "49.19665000",
                        "longitude": "13.05051000"
                    },
                    {
                        "id": 26884,
                        "name": "Lamerdingen",
                        "latitude": "48.09195000",
                        "longitude": "10.73982000"
                    },
                    {
                        "id": 26889,
                        "name": "Landau an der Isar",
                        "latitude": "48.67249000",
                        "longitude": "12.69316000"
                    },
                    {
                        "id": 26894,
                        "name": "Landsberg am Lech",
                        "latitude": "48.04819000",
                        "longitude": "10.88282000"
                    },
                    {
                        "id": 26895,
                        "name": "Landsberied",
                        "latitude": "48.16667000",
                        "longitude": "11.16667000"
                    },
                    {
                        "id": 26897,
                        "name": "Landshut",
                        "latitude": "48.52961000",
                        "longitude": "12.16179000"
                    },
                    {
                        "id": 26904,
                        "name": "Langenaltheim",
                        "latitude": "48.89318000",
                        "longitude": "10.93107000"
                    },
                    {
                        "id": 26907,
                        "name": "Langenbach",
                        "latitude": "48.43333000",
                        "longitude": "11.85000000"
                    },
                    {
                        "id": 26917,
                        "name": "Langenfeld",
                        "latitude": "49.61667000",
                        "longitude": "10.51667000"
                    },
                    {
                        "id": 26924,
                        "name": "Langenmosen",
                        "latitude": "48.60658000",
                        "longitude": "11.21378000"
                    },
                    {
                        "id": 26925,
                        "name": "Langenneufnach",
                        "latitude": "48.26667000",
                        "longitude": "10.60000000"
                    },
                    {
                        "id": 26927,
                        "name": "Langenpreising",
                        "latitude": "48.42569000",
                        "longitude": "11.97217000"
                    },
                    {
                        "id": 26929,
                        "name": "Langensendelbach",
                        "latitude": "49.64051000",
                        "longitude": "11.07104000"
                    },
                    {
                        "id": 26932,
                        "name": "Langenzenn",
                        "latitude": "49.49463000",
                        "longitude": "10.79230000"
                    },
                    {
                        "id": 26934,
                        "name": "Langerringen",
                        "latitude": "48.14590000",
                        "longitude": "10.75894000"
                    },
                    {
                        "id": 26937,
                        "name": "Langfurth",
                        "latitude": "49.10112000",
                        "longitude": "10.45359000"
                    },
                    {
                        "id": 26940,
                        "name": "Langquaid",
                        "latitude": "48.82318000",
                        "longitude": "12.05134000"
                    },
                    {
                        "id": 26946,
                        "name": "Langweid",
                        "latitude": "48.49095000",
                        "longitude": "10.85310000"
                    },
                    {
                        "id": 26950,
                        "name": "Lappersdorf",
                        "latitude": "49.04694000",
                        "longitude": "12.09130000"
                    },
                    {
                        "id": 26957,
                        "name": "Lauben",
                        "latitude": "48.05928000",
                        "longitude": "10.29014000"
                    },
                    {
                        "id": 26964,
                        "name": "Laudenbach",
                        "latitude": "49.74583000",
                        "longitude": "9.17611000"
                    },
                    {
                        "id": 26971,
                        "name": "Lauf an der Pegnitz",
                        "latitude": "49.51386000",
                        "longitude": "11.28247000"
                    },
                    {
                        "id": 26972,
                        "name": "Laufach",
                        "latitude": "50.01667000",
                        "longitude": "9.30000000"
                    },
                    {
                        "id": 26974,
                        "name": "Laufen",
                        "latitude": "47.93568000",
                        "longitude": "12.92856000"
                    },
                    {
                        "id": 26977,
                        "name": "Laugna",
                        "latitude": "48.53333000",
                        "longitude": "10.70000000"
                    },
                    {
                        "id": 26978,
                        "name": "Lauingen",
                        "latitude": "48.56775000",
                        "longitude": "10.42706000"
                    },
                    {
                        "id": 26983,
                        "name": "Lauter",
                        "latitude": "49.97317000",
                        "longitude": "10.78842000"
                    },
                    {
                        "id": 26987,
                        "name": "Lauterhofen",
                        "latitude": "49.36840000",
                        "longitude": "11.60294000"
                    },
                    {
                        "id": 26989,
                        "name": "Lautertal",
                        "latitude": "50.33333000",
                        "longitude": "10.96667000"
                    },
                    {
                        "id": 26990,
                        "name": "Lautrach",
                        "latitude": "47.89805000",
                        "longitude": "10.11806000"
                    },
                    {
                        "id": 26996,
                        "name": "Lechbruck",
                        "latitude": "47.70162000",
                        "longitude": "10.79493000"
                    },
                    {
                        "id": 27004,
                        "name": "Legau",
                        "latitude": "47.85628000",
                        "longitude": "10.12981000"
                    },
                    {
                        "id": 27010,
                        "name": "Lehrberg",
                        "latitude": "49.34568000",
                        "longitude": "10.51101000"
                    },
                    {
                        "id": 27015,
                        "name": "Leiblfing",
                        "latitude": "48.77565000",
                        "longitude": "12.51793000"
                    },
                    {
                        "id": 27017,
                        "name": "Leidersbach",
                        "latitude": "49.90139000",
                        "longitude": "9.22167000"
                    },
                    {
                        "id": 27022,
                        "name": "Leinburg",
                        "latitude": "49.45167000",
                        "longitude": "11.31000000"
                    },
                    {
                        "id": 27027,
                        "name": "Leipheim",
                        "latitude": "48.45004000",
                        "longitude": "10.22278000"
                    },
                    {
                        "id": 27038,
                        "name": "Lengdorf",
                        "latitude": "48.25737000",
                        "longitude": "12.04973000"
                    },
                    {
                        "id": 27042,
                        "name": "Lengenwang",
                        "latitude": "47.70000000",
                        "longitude": "10.60000000"
                    },
                    {
                        "id": 27045,
                        "name": "Lenggries",
                        "latitude": "47.68333000",
                        "longitude": "11.56667000"
                    },
                    {
                        "id": 27052,
                        "name": "Leonberg",
                        "latitude": "49.94708000",
                        "longitude": "12.28520000"
                    },
                    {
                        "id": 27060,
                        "name": "Leuchtenberg",
                        "latitude": "49.59737000",
                        "longitude": "12.25840000"
                    },
                    {
                        "id": 27063,
                        "name": "Leupoldsgrün",
                        "latitude": "50.30000000",
                        "longitude": "11.80000000"
                    },
                    {
                        "id": 27064,
                        "name": "Leutenbach",
                        "latitude": "49.70950000",
                        "longitude": "11.17224000"
                    },
                    {
                        "id": 27068,
                        "name": "Leutershausen",
                        "latitude": "49.29869000",
                        "longitude": "10.41189000"
                    },
                    {
                        "id": 27077,
                        "name": "Lichtenau",
                        "latitude": "49.15979000",
                        "longitude": "10.37935000"
                    },
                    {
                        "id": 27079,
                        "name": "Lichtenberg",
                        "latitude": "50.38335000",
                        "longitude": "11.67624000"
                    },
                    {
                        "id": 27081,
                        "name": "Lichtenfels",
                        "latitude": "50.14567000",
                        "longitude": "11.05928000"
                    },
                    {
                        "id": 27102,
                        "name": "Lindau",
                        "latitude": "47.54612000",
                        "longitude": "9.68431000"
                    },
                    {
                        "id": 27105,
                        "name": "Lindberg",
                        "latitude": "49.03680000",
                        "longitude": "13.25423000"
                    },
                    {
                        "id": 27123,
                        "name": "Litzendorf",
                        "latitude": "49.91444000",
                        "longitude": "11.01028000"
                    },
                    {
                        "id": 27130,
                        "name": "Lohberg",
                        "latitude": "49.17604000",
                        "longitude": "13.10549000"
                    },
                    {
                        "id": 27136,
                        "name": "Lohr am Main",
                        "latitude": "49.98922000",
                        "longitude": "9.57223000"
                    },
                    {
                        "id": 27139,
                        "name": "Loiching",
                        "latitude": "48.61667000",
                        "longitude": "12.43333000"
                    },
                    {
                        "id": 27145,
                        "name": "Lonnerstadt",
                        "latitude": "49.69882000",
                        "longitude": "10.76711000"
                    },
                    {
                        "id": 27155,
                        "name": "Lower Bavaria",
                        "latitude": "48.75000000",
                        "longitude": "12.83333000"
                    },
                    {
                        "id": 27167,
                        "name": "Ludwigsstadt",
                        "latitude": "50.48605000",
                        "longitude": "11.38734000"
                    },
                    {
                        "id": 27171,
                        "name": "Luhe-Wildenau",
                        "latitude": "49.58367000",
                        "longitude": "12.14921000"
                    },
                    {
                        "id": 27177,
                        "name": "Lupburg",
                        "latitude": "49.15510000",
                        "longitude": "11.75640000"
                    },
                    {
                        "id": 27553,
                        "name": "Mähring",
                        "latitude": "49.91095000",
                        "longitude": "12.52448000"
                    },
                    {
                        "id": 27234,
                        "name": "Maierhöfen",
                        "latitude": "47.65000000",
                        "longitude": "10.05000000"
                    },
                    {
                        "id": 27235,
                        "name": "Maihingen",
                        "latitude": "48.92745000",
                        "longitude": "10.49867000"
                    },
                    {
                        "id": 27237,
                        "name": "Mainaschaff",
                        "latitude": "49.98167000",
                        "longitude": "9.09000000"
                    },
                    {
                        "id": 27238,
                        "name": "Mainbernheim",
                        "latitude": "49.70794000",
                        "longitude": "10.21900000"
                    },
                    {
                        "id": 27239,
                        "name": "Mainburg",
                        "latitude": "48.64182000",
                        "longitude": "11.78093000"
                    },
                    {
                        "id": 27241,
                        "name": "Mainleus",
                        "latitude": "50.09987000",
                        "longitude": "11.37664000"
                    },
                    {
                        "id": 27242,
                        "name": "Mainstockheim",
                        "latitude": "49.77156000",
                        "longitude": "10.14807000"
                    },
                    {
                        "id": 27246,
                        "name": "Maisach",
                        "latitude": "48.21667000",
                        "longitude": "11.26667000"
                    },
                    {
                        "id": 27247,
                        "name": "Maitenbeth",
                        "latitude": "48.15053000",
                        "longitude": "12.09335000"
                    },
                    {
                        "id": 27250,
                        "name": "Malching",
                        "latitude": "48.31226000",
                        "longitude": "13.18746000"
                    },
                    {
                        "id": 27253,
                        "name": "Malgersdorf",
                        "latitude": "48.53333000",
                        "longitude": "12.75000000"
                    },
                    {
                        "id": 27254,
                        "name": "Mallersdorf-Pfaffenberg",
                        "latitude": "48.76637000",
                        "longitude": "12.23096000"
                    },
                    {
                        "id": 27261,
                        "name": "Mammendorf",
                        "latitude": "48.20836000",
                        "longitude": "11.16326000"
                    },
                    {
                        "id": 27262,
                        "name": "Mamming",
                        "latitude": "48.65174000",
                        "longitude": "12.60784000"
                    },
                    {
                        "id": 27263,
                        "name": "Manching",
                        "latitude": "48.71656000",
                        "longitude": "11.49393000"
                    },
                    {
                        "id": 27268,
                        "name": "Mantel",
                        "latitude": "49.65412000",
                        "longitude": "12.04074000"
                    },
                    {
                        "id": 27271,
                        "name": "Margetshöchheim",
                        "latitude": "49.83750000",
                        "longitude": "9.86389000"
                    },
                    {
                        "id": 27272,
                        "name": "Mariaposching",
                        "latitude": "48.83333000",
                        "longitude": "12.80000000"
                    },
                    {
                        "id": 27288,
                        "name": "Marklkofen",
                        "latitude": "48.55000000",
                        "longitude": "12.56667000"
                    },
                    {
                        "id": 27293,
                        "name": "Markt Berolzheim",
                        "latitude": "49.00955000",
                        "longitude": "10.84473000"
                    },
                    {
                        "id": 27294,
                        "name": "Markt Bibart",
                        "latitude": "49.64787000",
                        "longitude": "10.42492000"
                    },
                    {
                        "id": 27295,
                        "name": "Markt Einersheim",
                        "latitude": "49.68663000",
                        "longitude": "10.29155000"
                    },
                    {
                        "id": 27296,
                        "name": "Markt Erlbach",
                        "latitude": "49.49367000",
                        "longitude": "10.65265000"
                    },
                    {
                        "id": 27297,
                        "name": "Markt Indersdorf",
                        "latitude": "48.36058000",
                        "longitude": "11.37789000"
                    },
                    {
                        "id": 27298,
                        "name": "Markt Nordheim",
                        "latitude": "49.59095000",
                        "longitude": "10.35564000"
                    },
                    {
                        "id": 27299,
                        "name": "Markt Rettenbach",
                        "latitude": "47.94733000",
                        "longitude": "10.39608000"
                    },
                    {
                        "id": 27300,
                        "name": "Markt Schwaben",
                        "latitude": "48.18949000",
                        "longitude": "11.86910000"
                    },
                    {
                        "id": 27301,
                        "name": "Markt Taschendorf",
                        "latitude": "49.70111000",
                        "longitude": "10.55557000"
                    },
                    {
                        "id": 27302,
                        "name": "Markt Wald",
                        "latitude": "48.13680000",
                        "longitude": "10.58198000"
                    },
                    {
                        "id": 27303,
                        "name": "Marktbergel",
                        "latitude": "49.44156000",
                        "longitude": "10.36355000"
                    },
                    {
                        "id": 27304,
                        "name": "Marktbreit",
                        "latitude": "49.66541000",
                        "longitude": "10.14811000"
                    },
                    {
                        "id": 27305,
                        "name": "Marktgraitz",
                        "latitude": "50.18358000",
                        "longitude": "11.19441000"
                    },
                    {
                        "id": 27306,
                        "name": "Marktheidenfeld",
                        "latitude": "49.84540000",
                        "longitude": "9.60359000"
                    },
                    {
                        "id": 27307,
                        "name": "Marktl",
                        "latitude": "48.25516000",
                        "longitude": "12.84470000"
                    },
                    {
                        "id": 27308,
                        "name": "Marktleugast",
                        "latitude": "50.17306000",
                        "longitude": "11.63389000"
                    },
                    {
                        "id": 27309,
                        "name": "Marktleuthen",
                        "latitude": "50.13007000",
                        "longitude": "12.00226000"
                    },
                    {
                        "id": 27310,
                        "name": "Marktoberdorf",
                        "latitude": "47.77964000",
                        "longitude": "10.61713000"
                    },
                    {
                        "id": 27311,
                        "name": "Marktoffingen",
                        "latitude": "48.92566000",
                        "longitude": "10.47078000"
                    },
                    {
                        "id": 27312,
                        "name": "Marktredwitz",
                        "latitude": "50.00443000",
                        "longitude": "12.08593000"
                    },
                    {
                        "id": 27313,
                        "name": "Marktrodach",
                        "latitude": "50.25000000",
                        "longitude": "11.38333000"
                    },
                    {
                        "id": 27314,
                        "name": "Marktschellenberg",
                        "latitude": "47.69657000",
                        "longitude": "13.04340000"
                    },
                    {
                        "id": 27315,
                        "name": "Marktschorgast",
                        "latitude": "50.09475000",
                        "longitude": "11.65465000"
                    },
                    {
                        "id": 27316,
                        "name": "Marktsteft",
                        "latitude": "49.69606000",
                        "longitude": "10.13626000"
                    },
                    {
                        "id": 27317,
                        "name": "Marktzeuln",
                        "latitude": "50.16673000",
                        "longitude": "11.16692000"
                    },
                    {
                        "id": 27319,
                        "name": "Marloffstein",
                        "latitude": "49.61794000",
                        "longitude": "11.06323000"
                    },
                    {
                        "id": 27322,
                        "name": "Maroldsweisach",
                        "latitude": "50.19578000",
                        "longitude": "10.66003000"
                    },
                    {
                        "id": 27324,
                        "name": "Marquartstein",
                        "latitude": "47.75857000",
                        "longitude": "12.46219000"
                    },
                    {
                        "id": 27330,
                        "name": "Martinsheim",
                        "latitude": "49.62350000",
                        "longitude": "10.14879000"
                    },
                    {
                        "id": 27333,
                        "name": "Marxheim",
                        "latitude": "48.74153000",
                        "longitude": "10.94504000"
                    },
                    {
                        "id": 27335,
                        "name": "Marzling",
                        "latitude": "48.40904000",
                        "longitude": "11.79382000"
                    },
                    {
                        "id": 27352,
                        "name": "Maßbach",
                        "latitude": "50.18321000",
                        "longitude": "10.27522000"
                    },
                    {
                        "id": 27340,
                        "name": "Massing",
                        "latitude": "48.39118000",
                        "longitude": "12.60947000"
                    },
                    {
                        "id": 27343,
                        "name": "Mauern",
                        "latitude": "48.51667000",
                        "longitude": "11.90000000"
                    },
                    {
                        "id": 27344,
                        "name": "Mauerstetten",
                        "latitude": "47.89358000",
                        "longitude": "10.67127000"
                    },
                    {
                        "id": 27347,
                        "name": "Mauth",
                        "latitude": "48.88972000",
                        "longitude": "13.58459000"
                    },
                    {
                        "id": 27349,
                        "name": "Maxhütte-Haidhof",
                        "latitude": "49.19963000",
                        "longitude": "12.09229000"
                    },
                    {
                        "id": 27363,
                        "name": "Medlingen",
                        "latitude": "48.57027000",
                        "longitude": "10.31608000"
                    },
                    {
                        "id": 27364,
                        "name": "Meeder",
                        "latitude": "50.32118000",
                        "longitude": "10.90697000"
                    },
                    {
                        "id": 27372,
                        "name": "Mehlmeisel",
                        "latitude": "49.97421000",
                        "longitude": "11.86200000"
                    },
                    {
                        "id": 27377,
                        "name": "Mehring",
                        "latitude": "48.18333000",
                        "longitude": "12.78333000"
                    },
                    {
                        "id": 27386,
                        "name": "Meitingen",
                        "latitude": "48.54586000",
                        "longitude": "10.85179000"
                    },
                    {
                        "id": 27397,
                        "name": "Mellrichstadt",
                        "latitude": "50.42849000",
                        "longitude": "10.30334000"
                    },
                    {
                        "id": 27401,
                        "name": "Memmelsdorf",
                        "latitude": "49.93012000",
                        "longitude": "10.95921000"
                    },
                    {
                        "id": 27402,
                        "name": "Memmingen",
                        "latitude": "47.98372000",
                        "longitude": "10.18527000"
                    },
                    {
                        "id": 27403,
                        "name": "Memmingerberg",
                        "latitude": "47.98803000",
                        "longitude": "10.22295000"
                    },
                    {
                        "id": 27410,
                        "name": "Mengkofen",
                        "latitude": "48.71894000",
                        "longitude": "12.44047000"
                    },
                    {
                        "id": 27414,
                        "name": "Merching",
                        "latitude": "48.24594000",
                        "longitude": "10.98530000"
                    },
                    {
                        "id": 27418,
                        "name": "Mering",
                        "latitude": "48.26560000",
                        "longitude": "10.98461000"
                    },
                    {
                        "id": 27420,
                        "name": "Merkendorf",
                        "latitude": "49.20361000",
                        "longitude": "10.70416000"
                    },
                    {
                        "id": 27424,
                        "name": "Mertingen",
                        "latitude": "48.65695000",
                        "longitude": "10.80557000"
                    },
                    {
                        "id": 27433,
                        "name": "Mespelbrunn",
                        "latitude": "49.91444000",
                        "longitude": "9.29194000"
                    },
                    {
                        "id": 27437,
                        "name": "Metten",
                        "latitude": "48.85512000",
                        "longitude": "12.91554000"
                    },
                    {
                        "id": 27440,
                        "name": "Mettenheim",
                        "latitude": "48.26667000",
                        "longitude": "12.46667000"
                    },
                    {
                        "id": 27451,
                        "name": "Michelau",
                        "latitude": "50.16233000",
                        "longitude": "11.11207000"
                    },
                    {
                        "id": 27454,
                        "name": "Michelsneukirchen",
                        "latitude": "49.12291000",
                        "longitude": "12.55284000"
                    },
                    {
                        "id": 27457,
                        "name": "Mickhausen",
                        "latitude": "48.24171000",
                        "longitude": "10.64026000"
                    },
                    {
                        "id": 27461,
                        "name": "Miesbach",
                        "latitude": "47.78903000",
                        "longitude": "11.83382000"
                    },
                    {
                        "id": 27468,
                        "name": "Miltach",
                        "latitude": "49.16196000",
                        "longitude": "12.76843000"
                    },
                    {
                        "id": 27469,
                        "name": "Miltenberg",
                        "latitude": "49.70452000",
                        "longitude": "9.26725000"
                    },
                    {
                        "id": 27471,
                        "name": "Mindelheim",
                        "latitude": "48.04578000",
                        "longitude": "10.49222000"
                    },
                    {
                        "id": 27474,
                        "name": "Mintraching",
                        "latitude": "48.95357000",
                        "longitude": "12.24209000"
                    },
                    {
                        "id": 27476,
                        "name": "Missen-Wilhams",
                        "latitude": "47.60000000",
                        "longitude": "10.11667000"
                    },
                    {
                        "id": 27477,
                        "name": "Mistelgau",
                        "latitude": "49.91260000",
                        "longitude": "11.46586000"
                    },
                    {
                        "id": 27481,
                        "name": "Mitteleschenbach",
                        "latitude": "49.21186000",
                        "longitude": "10.79784000"
                    },
                    {
                        "id": 27484,
                        "name": "Mittelneufnach",
                        "latitude": "48.17642000",
                        "longitude": "10.59754000"
                    },
                    {
                        "id": 27486,
                        "name": "Mittelstetten",
                        "latitude": "48.25000000",
                        "longitude": "11.10000000"
                    },
                    {
                        "id": 27488,
                        "name": "Mittenwald",
                        "latitude": "47.44220000",
                        "longitude": "11.26187000"
                    },
                    {
                        "id": 27490,
                        "name": "Mitterfels",
                        "latitude": "48.97633000",
                        "longitude": "12.67848000"
                    },
                    {
                        "id": 27491,
                        "name": "Mitterskirchen",
                        "latitude": "48.35000000",
                        "longitude": "12.73333000"
                    },
                    {
                        "id": 27492,
                        "name": "Mitterteich",
                        "latitude": "49.95141000",
                        "longitude": "12.24206000"
                    },
                    {
                        "id": 27494,
                        "name": "Mitwitz",
                        "latitude": "50.25111000",
                        "longitude": "11.20818000"
                    },
                    {
                        "id": 27557,
                        "name": "Mödingen",
                        "latitude": "48.64327000",
                        "longitude": "10.43173000"
                    },
                    {
                        "id": 27562,
                        "name": "Möhrendorf",
                        "latitude": "49.63333000",
                        "longitude": "11.00000000"
                    },
                    {
                        "id": 27565,
                        "name": "Mömbris",
                        "latitude": "50.06921000",
                        "longitude": "9.16371000"
                    },
                    {
                        "id": 27566,
                        "name": "Mömlingen",
                        "latitude": "49.85972000",
                        "longitude": "9.08333000"
                    },
                    {
                        "id": 27567,
                        "name": "Mönchberg",
                        "latitude": "49.79326000",
                        "longitude": "9.26858000"
                    },
                    {
                        "id": 27571,
                        "name": "Mönchsdeggingen",
                        "latitude": "48.77605000",
                        "longitude": "10.58043000"
                    },
                    {
                        "id": 27572,
                        "name": "Mönchsroth",
                        "latitude": "49.01851000",
                        "longitude": "10.35856000"
                    },
                    {
                        "id": 27508,
                        "name": "Monheim",
                        "latitude": "48.84389000",
                        "longitude": "10.85834000"
                    },
                    {
                        "id": 27515,
                        "name": "Moorenweis",
                        "latitude": "48.15561000",
                        "longitude": "11.07851000"
                    },
                    {
                        "id": 27518,
                        "name": "Moosach",
                        "latitude": "48.03213000",
                        "longitude": "11.87510000"
                    },
                    {
                        "id": 27519,
                        "name": "Moosbach",
                        "latitude": "49.58909000",
                        "longitude": "12.41036000"
                    },
                    {
                        "id": 27520,
                        "name": "Moosburg",
                        "latitude": "48.47089000",
                        "longitude": "11.93811000"
                    },
                    {
                        "id": 27521,
                        "name": "Moosinning",
                        "latitude": "48.27708000",
                        "longitude": "11.84446000"
                    },
                    {
                        "id": 27522,
                        "name": "Moosthenning",
                        "latitude": "48.67659000",
                        "longitude": "12.49737000"
                    },
                    {
                        "id": 27529,
                        "name": "Motten",
                        "latitude": "50.39561000",
                        "longitude": "9.77251000"
                    },
                    {
                        "id": 27580,
                        "name": "Möttingen",
                        "latitude": "48.80924000",
                        "longitude": "10.59022000"
                    },
                    {
                        "id": 27581,
                        "name": "Mötzing",
                        "latitude": "48.89350000",
                        "longitude": "12.37361000"
                    },
                    {
                        "id": 27593,
                        "name": "Mühldorf",
                        "latitude": "48.24670000",
                        "longitude": "12.52155000"
                    },
                    {
                        "id": 27597,
                        "name": "Mühlhausen",
                        "latitude": "49.75443000",
                        "longitude": "10.77563000"
                    },
                    {
                        "id": 27534,
                        "name": "Muhr am See",
                        "latitude": "49.15445000",
                        "longitude": "10.71845000"
                    },
                    {
                        "id": 27609,
                        "name": "Münchberg",
                        "latitude": "50.18952000",
                        "longitude": "11.78823000"
                    },
                    {
                        "id": 27613,
                        "name": "Münchsmünster",
                        "latitude": "48.76667000",
                        "longitude": "11.68333000"
                    },
                    {
                        "id": 27614,
                        "name": "Münchsteinach",
                        "latitude": "49.63937000",
                        "longitude": "10.59502000"
                    },
                    {
                        "id": 27540,
                        "name": "Munich",
                        "latitude": "48.13743000",
                        "longitude": "11.57549000"
                    },
                    {
                        "id": 27617,
                        "name": "Münnerstadt",
                        "latitude": "50.24636000",
                        "longitude": "10.20187000"
                    },
                    {
                        "id": 27542,
                        "name": "Munningen",
                        "latitude": "48.91667000",
                        "longitude": "10.60000000"
                    },
                    {
                        "id": 27618,
                        "name": "Münsing",
                        "latitude": "47.90000000",
                        "longitude": "11.36667000"
                    },
                    {
                        "id": 27622,
                        "name": "Münster",
                        "latitude": "48.22904000",
                        "longitude": "10.63623000"
                    },
                    {
                        "id": 27625,
                        "name": "Münsterhausen",
                        "latitude": "48.30973000",
                        "longitude": "10.45500000"
                    },
                    {
                        "id": 27545,
                        "name": "Murnau am Staffelsee",
                        "latitude": "47.68085000",
                        "longitude": "11.20125000"
                    },
                    {
                        "id": 27630,
                        "name": "Nabburg",
                        "latitude": "49.45347000",
                        "longitude": "12.17996000"
                    },
                    {
                        "id": 27634,
                        "name": "Nagel",
                        "latitude": "49.98333000",
                        "longitude": "11.91667000"
                    },
                    {
                        "id": 27638,
                        "name": "Naila",
                        "latitude": "50.33034000",
                        "longitude": "11.70463000"
                    },
                    {
                        "id": 27641,
                        "name": "Nandlstadt",
                        "latitude": "48.53644000",
                        "longitude": "11.80730000"
                    },
                    {
                        "id": 27674,
                        "name": "Nennslingen",
                        "latitude": "49.04709000",
                        "longitude": "11.13052000"
                    },
                    {
                        "id": 27679,
                        "name": "Nersingen",
                        "latitude": "48.42829000",
                        "longitude": "10.12356000"
                    },
                    {
                        "id": 27682,
                        "name": "Nesselwang",
                        "latitude": "47.62342000",
                        "longitude": "10.50243000"
                    },
                    {
                        "id": 27695,
                        "name": "Neu-Ulm",
                        "latitude": "48.39279000",
                        "longitude": "10.01112000"
                    },
                    {
                        "id": 27696,
                        "name": "Neualbenreuth",
                        "latitude": "49.98037000",
                        "longitude": "12.44373000"
                    },
                    {
                        "id": 27698,
                        "name": "Neubeuern",
                        "latitude": "47.77368000",
                        "longitude": "12.14002000"
                    },
                    {
                        "id": 27699,
                        "name": "Neubiberg",
                        "latitude": "48.07710000",
                        "longitude": "11.65812000"
                    },
                    {
                        "id": 27701,
                        "name": "Neubrunn",
                        "latitude": "49.73088000",
                        "longitude": "9.67161000"
                    },
                    {
                        "id": 27707,
                        "name": "Neuburg",
                        "latitude": "48.50654000",
                        "longitude": "13.44718000"
                    },
                    {
                        "id": 27709,
                        "name": "Neuburg an der Donau",
                        "latitude": "48.73218000",
                        "longitude": "11.18709000"
                    },
                    {
                        "id": 27714,
                        "name": "Neudrossenfeld",
                        "latitude": "50.01667000",
                        "longitude": "11.50000000"
                    },
                    {
                        "id": 27719,
                        "name": "Neuendettelsau",
                        "latitude": "49.28333000",
                        "longitude": "10.78333000"
                    },
                    {
                        "id": 27724,
                        "name": "Neuenmarkt",
                        "latitude": "50.09193000",
                        "longitude": "11.58033000"
                    },
                    {
                        "id": 27731,
                        "name": "Neufahrn",
                        "latitude": "48.25587000",
                        "longitude": "12.44078000"
                    },
                    {
                        "id": 27732,
                        "name": "Neufahrn bei Freising",
                        "latitude": "48.31588000",
                        "longitude": "11.66316000"
                    },
                    {
                        "id": 27735,
                        "name": "Neufraunhofen",
                        "latitude": "48.40000000",
                        "longitude": "12.21667000"
                    },
                    {
                        "id": 27740,
                        "name": "Neuhaus am Inn",
                        "latitude": "48.46086000",
                        "longitude": "13.42083000"
                    },
                    {
                        "id": 27743,
                        "name": "Neuhaus an der Pegnitz",
                        "latitude": "49.62799000",
                        "longitude": "11.55066000"
                    },
                    {
                        "id": 27749,
                        "name": "Neuhof an der Zenn",
                        "latitude": "49.45690000",
                        "longitude": "10.64548000"
                    },
                    {
                        "id": 27752,
                        "name": "Neuhütten",
                        "latitude": "50.00000000",
                        "longitude": "9.41667000"
                    },
                    {
                        "id": 27759,
                        "name": "Neukirchen",
                        "latitude": "49.26015000",
                        "longitude": "12.96921000"
                    },
                    {
                        "id": 27763,
                        "name": "Neukirchen-Balbini",
                        "latitude": "49.29101000",
                        "longitude": "12.43643000"
                    },
                    {
                        "id": 27771,
                        "name": "Neumarkt in der Oberpfalz",
                        "latitude": "49.28028000",
                        "longitude": "11.46278000"
                    },
                    {
                        "id": 27772,
                        "name": "Neumarkt-Sankt Veit",
                        "latitude": "48.36051000",
                        "longitude": "12.50723000"
                    },
                    {
                        "id": 27775,
                        "name": "Neunburg vorm Wald",
                        "latitude": "49.34782000",
                        "longitude": "12.38621000"
                    },
                    {
                        "id": 27781,
                        "name": "Neunkirchen am Brand",
                        "latitude": "49.61204000",
                        "longitude": "11.12967000"
                    },
                    {
                        "id": 27782,
                        "name": "Neunkirchen am Main",
                        "latitude": "49.92300000",
                        "longitude": "11.64793000"
                    },
                    {
                        "id": 27783,
                        "name": "Neunkirchen am Sand",
                        "latitude": "49.52464000",
                        "longitude": "11.31955000"
                    },
                    {
                        "id": 27817,
                        "name": "Neuötting",
                        "latitude": "48.24102000",
                        "longitude": "12.68998000"
                    },
                    {
                        "id": 27785,
                        "name": "Neureichenau",
                        "latitude": "48.74861000",
                        "longitude": "13.74699000"
                    },
                    {
                        "id": 27786,
                        "name": "Neuried",
                        "latitude": "48.09322000",
                        "longitude": "11.46561000"
                    },
                    {
                        "id": 27789,
                        "name": "Neuschönau",
                        "latitude": "48.88419000",
                        "longitude": "13.47576000"
                    },
                    {
                        "id": 27790,
                        "name": "Neusitz",
                        "latitude": "49.37185000",
                        "longitude": "10.22559000"
                    },
                    {
                        "id": 27791,
                        "name": "Neusorg",
                        "latitude": "49.93333000",
                        "longitude": "11.96667000"
                    },
                    {
                        "id": 27797,
                        "name": "Neustadt am Main",
                        "latitude": "49.93021000",
                        "longitude": "9.56808000"
                    },
                    {
                        "id": 27800,
                        "name": "Neustadt an der Aisch",
                        "latitude": "49.57953000",
                        "longitude": "10.61126000"
                    },
                    {
                        "id": 27801,
                        "name": "Neustadt an der Donau",
                        "latitude": "48.80705000",
                        "longitude": "11.76952000"
                    },
                    {
                        "id": 27803,
                        "name": "Neustadt an der Waldnaab",
                        "latitude": "49.73287000",
                        "longitude": "12.17773000"
                    },
                    {
                        "id": 27804,
                        "name": "Neustadt bei Coburg",
                        "latitude": "50.32975000",
                        "longitude": "11.12058000"
                    },
                    {
                        "id": 27811,
                        "name": "Neutraubling",
                        "latitude": "48.98737000",
                        "longitude": "12.20100000"
                    },
                    {
                        "id": 27829,
                        "name": "Niederaichbach",
                        "latitude": "48.60000000",
                        "longitude": "12.31667000"
                    },
                    {
                        "id": 27830,
                        "name": "Niederalteich",
                        "latitude": "48.76564000",
                        "longitude": "13.02412000"
                    },
                    {
                        "id": 27833,
                        "name": "Niederbergkirchen",
                        "latitude": "48.31667000",
                        "longitude": "12.50000000"
                    },
                    {
                        "id": 27848,
                        "name": "Niederfüllbach",
                        "latitude": "50.22002000",
                        "longitude": "10.99086000"
                    },
                    {
                        "id": 27856,
                        "name": "Niederlauer",
                        "latitude": "50.29411000",
                        "longitude": "10.17712000"
                    },
                    {
                        "id": 27859,
                        "name": "Niedermurach",
                        "latitude": "49.44999000",
                        "longitude": "12.37610000"
                    },
                    {
                        "id": 27860,
                        "name": "Niedernberg",
                        "latitude": "49.91222000",
                        "longitude": "9.13694000"
                    },
                    {
                        "id": 27868,
                        "name": "Niederrieden",
                        "latitude": "48.05760000",
                        "longitude": "10.18321000"
                    },
                    {
                        "id": 27872,
                        "name": "Niederschönenfeld",
                        "latitude": "48.71667000",
                        "longitude": "10.93333000"
                    },
                    {
                        "id": 27878,
                        "name": "Niedertaufkirchen",
                        "latitude": "48.33333000",
                        "longitude": "12.55000000"
                    },
                    {
                        "id": 27879,
                        "name": "Niederviehbach",
                        "latitude": "48.61667000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 27881,
                        "name": "Niederwerrn",
                        "latitude": "50.06149000",
                        "longitude": "10.18270000"
                    },
                    {
                        "id": 27884,
                        "name": "Niederwinkling",
                        "latitude": "48.88333000",
                        "longitude": "12.80000000"
                    },
                    {
                        "id": 27904,
                        "name": "Nittenau",
                        "latitude": "49.19425000",
                        "longitude": "12.26741000"
                    },
                    {
                        "id": 27905,
                        "name": "Nittendorf",
                        "latitude": "49.02459000",
                        "longitude": "11.96126000"
                    },
                    {
                        "id": 27909,
                        "name": "Nonnenhorn",
                        "latitude": "47.57386000",
                        "longitude": "9.61038000"
                    },
                    {
                        "id": 27913,
                        "name": "Nordendorf",
                        "latitude": "48.59478000",
                        "longitude": "10.83183000"
                    },
                    {
                        "id": 27917,
                        "name": "Nordhalben",
                        "latitude": "50.37411000",
                        "longitude": "11.50992000"
                    },
                    {
                        "id": 27920,
                        "name": "Nordheim",
                        "latitude": "49.85870000",
                        "longitude": "10.18545000"
                    },
                    {
                        "id": 27946,
                        "name": "Nördlingen",
                        "latitude": "48.85122000",
                        "longitude": "10.48868000"
                    },
                    {
                        "id": 27951,
                        "name": "Nüdlingen",
                        "latitude": "50.22063000",
                        "longitude": "10.12296000"
                    },
                    {
                        "id": 27954,
                        "name": "Nürnberg",
                        "latitude": "49.45421000",
                        "longitude": "11.07752000"
                    },
                    {
                        "id": 27942,
                        "name": "Nußdorf",
                        "latitude": "47.90564000",
                        "longitude": "12.59608000"
                    },
                    {
                        "id": 27943,
                        "name": "Nußdorf am Inn",
                        "latitude": "47.74232000",
                        "longitude": "12.15611000"
                    },
                    {
                        "id": 27962,
                        "name": "Oberammergau",
                        "latitude": "47.59812000",
                        "longitude": "11.06692000"
                    },
                    {
                        "id": 27963,
                        "name": "Oberasbach",
                        "latitude": "49.42275000",
                        "longitude": "10.95766000"
                    },
                    {
                        "id": 27964,
                        "name": "Oberaudorf",
                        "latitude": "47.64822000",
                        "longitude": "12.17242000"
                    },
                    {
                        "id": 27966,
                        "name": "Oberbergkirchen",
                        "latitude": "48.30000000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 27970,
                        "name": "Oberdachstetten",
                        "latitude": "49.41667000",
                        "longitude": "10.43333000"
                    },
                    {
                        "id": 27972,
                        "name": "Oberding",
                        "latitude": "48.31667000",
                        "longitude": "11.85000000"
                    },
                    {
                        "id": 27976,
                        "name": "Oberelsbach",
                        "latitude": "50.44118000",
                        "longitude": "10.11692000"
                    },
                    {
                        "id": 27978,
                        "name": "Obergriesbach",
                        "latitude": "48.42305000",
                        "longitude": "11.06850000"
                    },
                    {
                        "id": 27980,
                        "name": "Obergünzburg",
                        "latitude": "47.84545000",
                        "longitude": "10.41821000"
                    },
                    {
                        "id": 27981,
                        "name": "Oberhaching",
                        "latitude": "48.02455000",
                        "longitude": "11.59744000"
                    },
                    {
                        "id": 27982,
                        "name": "Oberhaid",
                        "latitude": "50.12614000",
                        "longitude": "11.80514000"
                    },
                    {
                        "id": 27984,
                        "name": "Oberhausen",
                        "latitude": "48.72201000",
                        "longitude": "11.11151000"
                    },
                    {
                        "id": 27991,
                        "name": "Oberkotzau",
                        "latitude": "50.26236000",
                        "longitude": "11.93484000"
                    },
                    {
                        "id": 27992,
                        "name": "Oberleichtersbach",
                        "latitude": "50.28333000",
                        "longitude": "9.80000000"
                    },
                    {
                        "id": 27998,
                        "name": "Obermeitingen",
                        "latitude": "48.14685000",
                        "longitude": "10.80626000"
                    },
                    {
                        "id": 27999,
                        "name": "Obermichelbach",
                        "latitude": "49.53117000",
                        "longitude": "10.90891000"
                    },
                    {
                        "id": 28002,
                        "name": "Obernbreit",
                        "latitude": "49.65863000",
                        "longitude": "10.16424000"
                    },
                    {
                        "id": 28003,
                        "name": "Obernburg am Main",
                        "latitude": "49.83577000",
                        "longitude": "9.13101000"
                    },
                    {
                        "id": 28006,
                        "name": "Oberndorf",
                        "latitude": "48.66918000",
                        "longitude": "10.86749000"
                    },
                    {
                        "id": 28011,
                        "name": "Obernzell",
                        "latitude": "48.55485000",
                        "longitude": "13.63729000"
                    },
                    {
                        "id": 28012,
                        "name": "Obernzenn",
                        "latitude": "49.45193000",
                        "longitude": "10.46670000"
                    },
                    {
                        "id": 28013,
                        "name": "Oberostendorf",
                        "latitude": "47.94360000",
                        "longitude": "10.74270000"
                    },
                    {
                        "id": 28015,
                        "name": "Oberottmarshausen",
                        "latitude": "48.23716000",
                        "longitude": "10.85754000"
                    },
                    {
                        "id": 28016,
                        "name": "Oberpframmern",
                        "latitude": "48.02202000",
                        "longitude": "11.81331000"
                    },
                    {
                        "id": 28017,
                        "name": "Oberpleichfeld",
                        "latitude": "49.87694000",
                        "longitude": "10.08682000"
                    },
                    {
                        "id": 28018,
                        "name": "Oberpöring",
                        "latitude": "48.70178000",
                        "longitude": "12.82482000"
                    },
                    {
                        "id": 28019,
                        "name": "Oberreichenbach",
                        "latitude": "49.58946000",
                        "longitude": "10.76892000"
                    },
                    {
                        "id": 28021,
                        "name": "Oberreute",
                        "latitude": "47.56303000",
                        "longitude": "9.94449000"
                    },
                    {
                        "id": 28023,
                        "name": "Oberrieden",
                        "latitude": "48.08886000",
                        "longitude": "10.42611000"
                    },
                    {
                        "id": 28028,
                        "name": "Oberscheinfeld",
                        "latitude": "49.70829000",
                        "longitude": "10.43418000"
                    },
                    {
                        "id": 28029,
                        "name": "Oberschleißheim",
                        "latitude": "48.25000000",
                        "longitude": "11.56667000"
                    },
                    {
                        "id": 28030,
                        "name": "Oberschneiding",
                        "latitude": "48.79573000",
                        "longitude": "12.64200000"
                    },
                    {
                        "id": 28031,
                        "name": "Oberschwarzach",
                        "latitude": "49.86051000",
                        "longitude": "10.40999000"
                    },
                    {
                        "id": 28032,
                        "name": "Oberschweinbach",
                        "latitude": "48.23817000",
                        "longitude": "11.15571000"
                    },
                    {
                        "id": 28035,
                        "name": "Obersinn",
                        "latitude": "50.20875000",
                        "longitude": "9.61545000"
                    },
                    {
                        "id": 28042,
                        "name": "Obersöchering",
                        "latitude": "47.73333000",
                        "longitude": "11.21667000"
                    },
                    {
                        "id": 28038,
                        "name": "Oberstaufen",
                        "latitude": "47.55568000",
                        "longitude": "10.02245000"
                    },
                    {
                        "id": 28039,
                        "name": "Oberstdorf",
                        "latitude": "47.40724000",
                        "longitude": "10.27939000"
                    },
                    {
                        "id": 28041,
                        "name": "Oberstreu",
                        "latitude": "50.40338000",
                        "longitude": "10.28775000"
                    },
                    {
                        "id": 28043,
                        "name": "Obersüßbach",
                        "latitude": "48.61667000",
                        "longitude": "11.95000000"
                    },
                    {
                        "id": 28044,
                        "name": "Obertaufkirchen",
                        "latitude": "48.26046000",
                        "longitude": "12.27904000"
                    },
                    {
                        "id": 28047,
                        "name": "Oberthulba",
                        "latitude": "50.19904000",
                        "longitude": "9.95882000"
                    },
                    {
                        "id": 28048,
                        "name": "Obertraubling",
                        "latitude": "48.96667000",
                        "longitude": "12.16667000"
                    },
                    {
                        "id": 28049,
                        "name": "Obertrubach",
                        "latitude": "49.70000000",
                        "longitude": "11.35000000"
                    },
                    {
                        "id": 28052,
                        "name": "Oberviechtach",
                        "latitude": "49.45809000",
                        "longitude": "12.41669000"
                    },
                    {
                        "id": 28059,
                        "name": "Obing",
                        "latitude": "48.00049000",
                        "longitude": "12.40528000"
                    },
                    {
                        "id": 28062,
                        "name": "Ochsenfurt",
                        "latitude": "49.66429000",
                        "longitude": "10.06227000"
                    },
                    {
                        "id": 28068,
                        "name": "Odelzhausen",
                        "latitude": "48.30889000",
                        "longitude": "11.19889000"
                    },
                    {
                        "id": 28081,
                        "name": "Oerlenbach",
                        "latitude": "50.15000000",
                        "longitude": "10.13333000"
                    },
                    {
                        "id": 28083,
                        "name": "Oettingen in Bayern",
                        "latitude": "48.95274000",
                        "longitude": "10.60465000"
                    },
                    {
                        "id": 28089,
                        "name": "Offenberg",
                        "latitude": "48.86195000",
                        "longitude": "12.86293000"
                    },
                    {
                        "id": 28091,
                        "name": "Offenhausen",
                        "latitude": "49.44971000",
                        "longitude": "11.41316000"
                    },
                    {
                        "id": 28092,
                        "name": "Offingen",
                        "latitude": "48.48258000",
                        "longitude": "10.36249000"
                    },
                    {
                        "id": 28095,
                        "name": "Ofterschwang",
                        "latitude": "47.50000000",
                        "longitude": "10.23333000"
                    },
                    {
                        "id": 28099,
                        "name": "Ohlstadt",
                        "latitude": "47.63333000",
                        "longitude": "11.23333000"
                    },
                    {
                        "id": 28104,
                        "name": "Olching",
                        "latitude": "48.20000000",
                        "longitude": "11.33333000"
                    },
                    {
                        "id": 28115,
                        "name": "Opfenbach",
                        "latitude": "47.63333000",
                        "longitude": "9.83333000"
                    },
                    {
                        "id": 28127,
                        "name": "Ornbau",
                        "latitude": "49.17623000",
                        "longitude": "10.65797000"
                    },
                    {
                        "id": 28132,
                        "name": "Ortenburg",
                        "latitude": "48.54597000",
                        "longitude": "13.22250000"
                    },
                    {
                        "id": 28152,
                        "name": "Osterhofen",
                        "latitude": "48.70000000",
                        "longitude": "13.02221000"
                    },
                    {
                        "id": 28162,
                        "name": "Ostheim vor der Rhön",
                        "latitude": "50.45996000",
                        "longitude": "10.23057000"
                    },
                    {
                        "id": 28179,
                        "name": "Ottenhofen",
                        "latitude": "48.21667000",
                        "longitude": "11.88333000"
                    },
                    {
                        "id": 28182,
                        "name": "Ottensoos",
                        "latitude": "49.50949000",
                        "longitude": "11.34158000"
                    },
                    {
                        "id": 28187,
                        "name": "Otterfing",
                        "latitude": "47.90898000",
                        "longitude": "11.67546000"
                    },
                    {
                        "id": 28194,
                        "name": "Ottobeuren",
                        "latitude": "47.94130000",
                        "longitude": "10.29971000"
                    },
                    {
                        "id": 28195,
                        "name": "Ottobrunn",
                        "latitude": "48.06489000",
                        "longitude": "11.66327000"
                    },
                    {
                        "id": 28198,
                        "name": "Otzing",
                        "latitude": "48.76134000",
                        "longitude": "12.80877000"
                    },
                    {
                        "id": 28204,
                        "name": "Oy-Mittelberg",
                        "latitude": "47.63333000",
                        "longitude": "10.43333000"
                    },
                    {
                        "id": 28412,
                        "name": "Pähl",
                        "latitude": "47.90000000",
                        "longitude": "11.18333000"
                    },
                    {
                        "id": 28211,
                        "name": "Painten",
                        "latitude": "48.99731000",
                        "longitude": "11.81947000"
                    },
                    {
                        "id": 28212,
                        "name": "Palling",
                        "latitude": "48.00204000",
                        "longitude": "12.63702000"
                    },
                    {
                        "id": 28220,
                        "name": "Pappenheim",
                        "latitude": "48.93383000",
                        "longitude": "10.97431000"
                    },
                    {
                        "id": 28223,
                        "name": "Parkstein",
                        "latitude": "49.72921000",
                        "longitude": "12.06755000"
                    },
                    {
                        "id": 28224,
                        "name": "Parkstetten",
                        "latitude": "48.91667000",
                        "longitude": "12.60000000"
                    },
                    {
                        "id": 28226,
                        "name": "Parsberg",
                        "latitude": "49.16074000",
                        "longitude": "11.71834000"
                    },
                    {
                        "id": 28228,
                        "name": "Partenstein",
                        "latitude": "50.04176000",
                        "longitude": "9.51991000"
                    },
                    {
                        "id": 28230,
                        "name": "Pasing",
                        "latitude": "48.14146000",
                        "longitude": "11.45599000"
                    },
                    {
                        "id": 28231,
                        "name": "Passau",
                        "latitude": "48.56650000",
                        "longitude": "13.43122000"
                    },
                    {
                        "id": 28232,
                        "name": "Pastetten",
                        "latitude": "48.19911000",
                        "longitude": "11.94368000"
                    },
                    {
                        "id": 28233,
                        "name": "Patersdorf",
                        "latitude": "49.01667000",
                        "longitude": "12.98333000"
                    },
                    {
                        "id": 28237,
                        "name": "Paunzhausen",
                        "latitude": "48.47486000",
                        "longitude": "11.56463000"
                    },
                    {
                        "id": 28239,
                        "name": "Pechbrunn",
                        "latitude": "49.96667000",
                        "longitude": "12.16667000"
                    },
                    {
                        "id": 28241,
                        "name": "Pegnitz",
                        "latitude": "49.75216000",
                        "longitude": "11.54187000"
                    },
                    {
                        "id": 28246,
                        "name": "Peißenberg",
                        "latitude": "47.80466000",
                        "longitude": "11.06990000"
                    },
                    {
                        "id": 28243,
                        "name": "Peiting",
                        "latitude": "47.79549000",
                        "longitude": "10.92951000"
                    },
                    {
                        "id": 28250,
                        "name": "Pemfling",
                        "latitude": "49.26667000",
                        "longitude": "12.61667000"
                    },
                    {
                        "id": 28254,
                        "name": "Pentling",
                        "latitude": "48.98343000",
                        "longitude": "12.05870000"
                    },
                    {
                        "id": 28255,
                        "name": "Penzberg",
                        "latitude": "47.75293000",
                        "longitude": "11.37700000"
                    },
                    {
                        "id": 28256,
                        "name": "Penzing",
                        "latitude": "48.07481000",
                        "longitude": "10.92745000"
                    },
                    {
                        "id": 28258,
                        "name": "Perach",
                        "latitude": "48.26667000",
                        "longitude": "12.76667000"
                    },
                    {
                        "id": 28259,
                        "name": "Perkam",
                        "latitude": "48.85528000",
                        "longitude": "12.43979000"
                    },
                    {
                        "id": 28261,
                        "name": "Perlesreut",
                        "latitude": "48.78181000",
                        "longitude": "13.43840000"
                    },
                    {
                        "id": 28262,
                        "name": "Petersaurach",
                        "latitude": "49.30000000",
                        "longitude": "10.75000000"
                    },
                    {
                        "id": 28263,
                        "name": "Petersdorf",
                        "latitude": "48.51667000",
                        "longitude": "11.03333000"
                    },
                    {
                        "id": 28266,
                        "name": "Petershausen",
                        "latitude": "48.40967000",
                        "longitude": "11.47056000"
                    },
                    {
                        "id": 28267,
                        "name": "Pettendorf",
                        "latitude": "49.35475000",
                        "longitude": "12.35926000"
                    },
                    {
                        "id": 28268,
                        "name": "Petting",
                        "latitude": "47.91232000",
                        "longitude": "12.81512000"
                    },
                    {
                        "id": 28269,
                        "name": "Pettstadt",
                        "latitude": "49.82996000",
                        "longitude": "10.92839000"
                    },
                    {
                        "id": 28271,
                        "name": "Pfaffenhausen",
                        "latitude": "48.11878000",
                        "longitude": "10.45504000"
                    },
                    {
                        "id": 28273,
                        "name": "Pfaffenhofen",
                        "latitude": "48.39334000",
                        "longitude": "11.20563000"
                    },
                    {
                        "id": 28274,
                        "name": "Pfaffenhofen an der Ilm",
                        "latitude": "48.53053000",
                        "longitude": "11.50500000"
                    },
                    {
                        "id": 28275,
                        "name": "Pfaffenhofen an der Roth",
                        "latitude": "48.35454000",
                        "longitude": "10.16184000"
                    },
                    {
                        "id": 28277,
                        "name": "Pfaffing",
                        "latitude": "48.05456000",
                        "longitude": "12.10917000"
                    },
                    {
                        "id": 28279,
                        "name": "Pfakofen",
                        "latitude": "48.85822000",
                        "longitude": "12.22744000"
                    },
                    {
                        "id": 28281,
                        "name": "Pfarrkirchen",
                        "latitude": "48.43205000",
                        "longitude": "12.93812000"
                    },
                    {
                        "id": 28282,
                        "name": "Pfarrweisach",
                        "latitude": "50.15000000",
                        "longitude": "10.73333000"
                    },
                    {
                        "id": 28283,
                        "name": "Pfatter",
                        "latitude": "48.96309000",
                        "longitude": "12.38254000"
                    },
                    {
                        "id": 28286,
                        "name": "Pfeffenhausen",
                        "latitude": "48.66466000",
                        "longitude": "11.96594000"
                    },
                    {
                        "id": 28287,
                        "name": "Pfofeld",
                        "latitude": "49.10590000",
                        "longitude": "10.83664000"
                    },
                    {
                        "id": 28288,
                        "name": "Pforzen",
                        "latitude": "47.92997000",
                        "longitude": "10.61357000"
                    },
                    {
                        "id": 28290,
                        "name": "Pfreimd",
                        "latitude": "49.49114000",
                        "longitude": "12.18069000"
                    },
                    {
                        "id": 28292,
                        "name": "Pfronten",
                        "latitude": "47.58220000",
                        "longitude": "10.54962000"
                    },
                    {
                        "id": 28298,
                        "name": "Piding",
                        "latitude": "47.76667000",
                        "longitude": "12.91667000"
                    },
                    {
                        "id": 28299,
                        "name": "Pielenhofen",
                        "latitude": "49.07235000",
                        "longitude": "11.95699000"
                    },
                    {
                        "id": 28302,
                        "name": "Pilsach",
                        "latitude": "49.32137000",
                        "longitude": "11.50311000"
                    },
                    {
                        "id": 28303,
                        "name": "Pilsting",
                        "latitude": "48.70116000",
                        "longitude": "12.65105000"
                    },
                    {
                        "id": 28306,
                        "name": "Pinzberg",
                        "latitude": "49.68971000",
                        "longitude": "11.10207000"
                    },
                    {
                        "id": 28307,
                        "name": "Pirk",
                        "latitude": "49.63333000",
                        "longitude": "12.16667000"
                    },
                    {
                        "id": 28310,
                        "name": "Pittenhart",
                        "latitude": "47.97724000",
                        "longitude": "12.38997000"
                    },
                    {
                        "id": 28312,
                        "name": "Planegg",
                        "latitude": "48.10672000",
                        "longitude": "11.42483000"
                    },
                    {
                        "id": 28316,
                        "name": "Plattling",
                        "latitude": "48.77866000",
                        "longitude": "12.87509000"
                    },
                    {
                        "id": 28321,
                        "name": "Pleinfeld",
                        "latitude": "49.10473000",
                        "longitude": "10.98194000"
                    },
                    {
                        "id": 28322,
                        "name": "Pleiskirchen",
                        "latitude": "48.30713000",
                        "longitude": "12.59832000"
                    },
                    {
                        "id": 28325,
                        "name": "Pleystein",
                        "latitude": "49.64907000",
                        "longitude": "12.40631000"
                    },
                    {
                        "id": 28326,
                        "name": "Pliening",
                        "latitude": "48.19556000",
                        "longitude": "11.80069000"
                    },
                    {
                        "id": 28334,
                        "name": "Plößberg",
                        "latitude": "49.91977000",
                        "longitude": "11.86883000"
                    },
                    {
                        "id": 28338,
                        "name": "Pocking",
                        "latitude": "48.40149000",
                        "longitude": "13.31315000"
                    },
                    {
                        "id": 28340,
                        "name": "Poing",
                        "latitude": "48.17004000",
                        "longitude": "11.81863000"
                    },
                    {
                        "id": 28346,
                        "name": "Polling",
                        "latitude": "48.21667000",
                        "longitude": "12.56667000"
                    },
                    {
                        "id": 28347,
                        "name": "Polsingen",
                        "latitude": "48.92067000",
                        "longitude": "10.71150000"
                    },
                    {
                        "id": 28348,
                        "name": "Pommelsbrunn",
                        "latitude": "49.50437000",
                        "longitude": "11.51101000"
                    },
                    {
                        "id": 28349,
                        "name": "Pommersfelden",
                        "latitude": "49.76667000",
                        "longitude": "10.81667000"
                    },
                    {
                        "id": 28352,
                        "name": "Poppenhausen",
                        "latitude": "50.09999000",
                        "longitude": "10.14244000"
                    },
                    {
                        "id": 28354,
                        "name": "Poppenricht",
                        "latitude": "49.47557000",
                        "longitude": "11.79778000"
                    },
                    {
                        "id": 28418,
                        "name": "Pörnbach",
                        "latitude": "48.61667000",
                        "longitude": "11.46667000"
                    },
                    {
                        "id": 28359,
                        "name": "Postau",
                        "latitude": "48.65000000",
                        "longitude": "12.33333000"
                    },
                    {
                        "id": 28360,
                        "name": "Postbauer-Heng",
                        "latitude": "49.30528000",
                        "longitude": "11.35722000"
                    },
                    {
                        "id": 28361,
                        "name": "Postmünster",
                        "latitude": "48.41667000",
                        "longitude": "12.90000000"
                    },
                    {
                        "id": 28363,
                        "name": "Pottenstein",
                        "latitude": "49.77131000",
                        "longitude": "11.40784000"
                    },
                    {
                        "id": 28419,
                        "name": "Pöttmes",
                        "latitude": "48.58383000",
                        "longitude": "11.08762000"
                    },
                    {
                        "id": 28366,
                        "name": "Poxdorf",
                        "latitude": "49.93642000",
                        "longitude": "11.12211000"
                    },
                    {
                        "id": 28368,
                        "name": "Prackenbach",
                        "latitude": "49.09543000",
                        "longitude": "12.82614000"
                    },
                    {
                        "id": 28370,
                        "name": "Prebitz",
                        "latitude": "49.83333000",
                        "longitude": "11.68333000"
                    },
                    {
                        "id": 28376,
                        "name": "Pressath",
                        "latitude": "49.76859000",
                        "longitude": "11.93972000"
                    },
                    {
                        "id": 28377,
                        "name": "Presseck",
                        "latitude": "50.22804000",
                        "longitude": "11.55508000"
                    },
                    {
                        "id": 28378,
                        "name": "Pressig",
                        "latitude": "50.35245000",
                        "longitude": "11.30969000"
                    },
                    {
                        "id": 28380,
                        "name": "Pretzfeld",
                        "latitude": "49.75454000",
                        "longitude": "11.17430000"
                    },
                    {
                        "id": 28385,
                        "name": "Prichsenstadt",
                        "latitude": "49.81933000",
                        "longitude": "10.34773000"
                    },
                    {
                        "id": 28386,
                        "name": "Prien am Chiemsee",
                        "latitude": "47.85602000",
                        "longitude": "12.34623000"
                    },
                    {
                        "id": 28387,
                        "name": "Priesendorf",
                        "latitude": "49.90750000",
                        "longitude": "10.71183000"
                    },
                    {
                        "id": 28391,
                        "name": "Prittriching",
                        "latitude": "48.20074000",
                        "longitude": "10.92801000"
                    },
                    {
                        "id": 28397,
                        "name": "Prosselsheim",
                        "latitude": "49.86309000",
                        "longitude": "10.12666000"
                    },
                    {
                        "id": 28398,
                        "name": "Prutting",
                        "latitude": "47.89321000",
                        "longitude": "12.20238000"
                    },
                    {
                        "id": 28421,
                        "name": "Püchersreuth",
                        "latitude": "49.75000000",
                        "longitude": "12.23333000"
                    },
                    {
                        "id": 28401,
                        "name": "Puchheim",
                        "latitude": "48.15000000",
                        "longitude": "11.35000000"
                    },
                    {
                        "id": 28404,
                        "name": "Pullach im Isartal",
                        "latitude": "48.06122000",
                        "longitude": "11.52148000"
                    },
                    {
                        "id": 28405,
                        "name": "Pullenreuth",
                        "latitude": "49.93333000",
                        "longitude": "12.00000000"
                    },
                    {
                        "id": 28422,
                        "name": "Pürgen",
                        "latitude": "48.02472000",
                        "longitude": "10.92213000"
                    },
                    {
                        "id": 28406,
                        "name": "Puschendorf",
                        "latitude": "49.52398000",
                        "longitude": "10.83192000"
                    },
                    {
                        "id": 28410,
                        "name": "Putzbrunn",
                        "latitude": "48.07579000",
                        "longitude": "11.71572000"
                    },
                    {
                        "id": 28411,
                        "name": "Pyrbaum",
                        "latitude": "49.29622000",
                        "longitude": "11.28655000"
                    },
                    {
                        "id": 28453,
                        "name": "Rain",
                        "latitude": "48.69029000",
                        "longitude": "10.91611000"
                    },
                    {
                        "id": 28455,
                        "name": "Raisting",
                        "latitude": "47.91667000",
                        "longitude": "11.10000000"
                    },
                    {
                        "id": 28456,
                        "name": "Raitenbuch",
                        "latitude": "49.01468000",
                        "longitude": "11.12486000"
                    },
                    {
                        "id": 28460,
                        "name": "Ramerberg",
                        "latitude": "48.01806000",
                        "longitude": "12.14513000"
                    },
                    {
                        "id": 28464,
                        "name": "Ramsau",
                        "latitude": "48.17277000",
                        "longitude": "12.22957000"
                    },
                    {
                        "id": 28468,
                        "name": "Ramsthal",
                        "latitude": "50.14039000",
                        "longitude": "10.06777000"
                    },
                    {
                        "id": 28469,
                        "name": "Randersacker",
                        "latitude": "49.76021000",
                        "longitude": "9.98277000"
                    },
                    {
                        "id": 28473,
                        "name": "Rannungen",
                        "latitude": "50.16537000",
                        "longitude": "10.20484000"
                    },
                    {
                        "id": 28488,
                        "name": "Rattelsdorf",
                        "latitude": "50.01502000",
                        "longitude": "10.88857000"
                    },
                    {
                        "id": 28489,
                        "name": "Rattenberg",
                        "latitude": "49.08612000",
                        "longitude": "12.74912000"
                    },
                    {
                        "id": 28490,
                        "name": "Rattiszell",
                        "latitude": "49.02573000",
                        "longitude": "12.65924000"
                    },
                    {
                        "id": 28493,
                        "name": "Raubling",
                        "latitude": "47.79050000",
                        "longitude": "12.11088000"
                    },
                    {
                        "id": 28503,
                        "name": "Rechtenbach",
                        "latitude": "49.98306000",
                        "longitude": "9.50833000"
                    },
                    {
                        "id": 28504,
                        "name": "Rechtmehring",
                        "latitude": "48.11667000",
                        "longitude": "12.16667000"
                    },
                    {
                        "id": 28508,
                        "name": "Rednitzhembach",
                        "latitude": "49.30095000",
                        "longitude": "11.07997000"
                    },
                    {
                        "id": 28509,
                        "name": "Redwitz an der Rodach",
                        "latitude": "50.17323000",
                        "longitude": "11.20833000"
                    },
                    {
                        "id": 28512,
                        "name": "Regen",
                        "latitude": "48.97190000",
                        "longitude": "13.12824000"
                    },
                    {
                        "id": 28513,
                        "name": "Regensburg",
                        "latitude": "49.01513000",
                        "longitude": "12.10161000"
                    },
                    {
                        "id": 28514,
                        "name": "Regenstauf",
                        "latitude": "49.12014000",
                        "longitude": "12.13027000"
                    },
                    {
                        "id": 28522,
                        "name": "Regierungsbezirk Mittelfranken",
                        "latitude": "49.33333000",
                        "longitude": "10.83333000"
                    },
                    {
                        "id": 28525,
                        "name": "Regierungsbezirk Unterfranken",
                        "latitude": "50.00000000",
                        "longitude": "10.00000000"
                    },
                    {
                        "id": 28527,
                        "name": "Regnitzlosau",
                        "latitude": "50.30000000",
                        "longitude": "12.05000000"
                    },
                    {
                        "id": 28528,
                        "name": "Rehau",
                        "latitude": "50.24921000",
                        "longitude": "12.03422000"
                    },
                    {
                        "id": 28533,
                        "name": "Rehling",
                        "latitude": "48.48333000",
                        "longitude": "10.93333000"
                    },
                    {
                        "id": 28539,
                        "name": "Reichenbach",
                        "latitude": "49.18333000",
                        "longitude": "12.35000000"
                    },
                    {
                        "id": 28544,
                        "name": "Reichenberg",
                        "latitude": "49.73193000",
                        "longitude": "9.91478000"
                    },
                    {
                        "id": 28545,
                        "name": "Reichenschwand",
                        "latitude": "49.51384000",
                        "longitude": "11.37274000"
                    },
                    {
                        "id": 28547,
                        "name": "Reichersbeuern",
                        "latitude": "47.76667000",
                        "longitude": "11.63333000"
                    },
                    {
                        "id": 28548,
                        "name": "Reichertshausen",
                        "latitude": "47.89882000",
                        "longitude": "11.55843000"
                    },
                    {
                        "id": 28549,
                        "name": "Reichertsheim",
                        "latitude": "48.20000000",
                        "longitude": "12.28333000"
                    },
                    {
                        "id": 28550,
                        "name": "Reichertshofen",
                        "latitude": "48.65775000",
                        "longitude": "11.46612000"
                    },
                    {
                        "id": 28551,
                        "name": "Reichling",
                        "latitude": "47.92280000",
                        "longitude": "10.92847000"
                    },
                    {
                        "id": 28554,
                        "name": "Reimlingen",
                        "latitude": "48.81667000",
                        "longitude": "10.51667000"
                    },
                    {
                        "id": 28560,
                        "name": "Reinhausen",
                        "latitude": "49.03092000",
                        "longitude": "12.11329000"
                    },
                    {
                        "id": 28567,
                        "name": "Reisbach",
                        "latitude": "48.57008000",
                        "longitude": "12.62799000"
                    },
                    {
                        "id": 28568,
                        "name": "Reischach",
                        "latitude": "48.29073000",
                        "longitude": "12.72620000"
                    },
                    {
                        "id": 28570,
                        "name": "Reit im Winkl",
                        "latitude": "47.67729000",
                        "longitude": "12.47086000"
                    },
                    {
                        "id": 28574,
                        "name": "Remlingen",
                        "latitude": "49.80477000",
                        "longitude": "9.69484000"
                    },
                    {
                        "id": 28582,
                        "name": "Rennertshofen",
                        "latitude": "48.75943000",
                        "longitude": "11.04544000"
                    },
                    {
                        "id": 28584,
                        "name": "Rentweinsdorf",
                        "latitude": "50.06342000",
                        "longitude": "10.79922000"
                    },
                    {
                        "id": 28590,
                        "name": "Rettenbach",
                        "latitude": "49.06667000",
                        "longitude": "12.45000000"
                    },
                    {
                        "id": 28591,
                        "name": "Rettenberg",
                        "latitude": "47.57428000",
                        "longitude": "10.29173000"
                    },
                    {
                        "id": 28592,
                        "name": "Retzstadt",
                        "latitude": "49.91250000",
                        "longitude": "9.88194000"
                    },
                    {
                        "id": 28593,
                        "name": "Reut",
                        "latitude": "48.59170000",
                        "longitude": "13.12332000"
                    },
                    {
                        "id": 28595,
                        "name": "Reuth",
                        "latitude": "49.99052000",
                        "longitude": "11.69480000"
                    },
                    {
                        "id": 28626,
                        "name": "Ried",
                        "latitude": "48.47698000",
                        "longitude": "11.26060000"
                    },
                    {
                        "id": 28629,
                        "name": "Rieden",
                        "latitude": "49.32361000",
                        "longitude": "11.94205000"
                    },
                    {
                        "id": 28630,
                        "name": "Rieden an der Kötz",
                        "latitude": "48.38499000",
                        "longitude": "10.25711000"
                    },
                    {
                        "id": 28631,
                        "name": "Riedenberg",
                        "latitude": "50.31993000",
                        "longitude": "9.86100000"
                    },
                    {
                        "id": 28632,
                        "name": "Riedenburg",
                        "latitude": "48.96383000",
                        "longitude": "11.68880000"
                    },
                    {
                        "id": 28635,
                        "name": "Riedering",
                        "latitude": "47.83874000",
                        "longitude": "12.20778000"
                    },
                    {
                        "id": 28640,
                        "name": "Riegsee",
                        "latitude": "47.69867000",
                        "longitude": "11.23391000"
                    },
                    {
                        "id": 28643,
                        "name": "Rieneck",
                        "latitude": "50.09349000",
                        "longitude": "9.64797000"
                    },
                    {
                        "id": 28656,
                        "name": "Rimbach",
                        "latitude": "49.23333000",
                        "longitude": "12.88333000"
                    },
                    {
                        "id": 28657,
                        "name": "Rimpar",
                        "latitude": "49.85692000",
                        "longitude": "9.95705000"
                    },
                    {
                        "id": 28659,
                        "name": "Rimsting",
                        "latitude": "47.88078000",
                        "longitude": "12.33713000"
                    },
                    {
                        "id": 28660,
                        "name": "Rinchnach",
                        "latitude": "48.94956000",
                        "longitude": "13.20102000"
                    },
                    {
                        "id": 28661,
                        "name": "Ringelai",
                        "latitude": "48.81336000",
                        "longitude": "13.47130000"
                    },
                    {
                        "id": 28776,
                        "name": "Rödelsee",
                        "latitude": "49.72840000",
                        "longitude": "10.24360000"
                    },
                    {
                        "id": 28674,
                        "name": "Roden",
                        "latitude": "49.89556000",
                        "longitude": "9.62639000"
                    },
                    {
                        "id": 28777,
                        "name": "Rödental",
                        "latitude": "50.29516000",
                        "longitude": "11.04122000"
                    },
                    {
                        "id": 28680,
                        "name": "Roding",
                        "latitude": "49.19426000",
                        "longitude": "12.51956000"
                    },
                    {
                        "id": 28780,
                        "name": "Röfingen",
                        "latitude": "48.42442000",
                        "longitude": "10.44268000"
                    },
                    {
                        "id": 28683,
                        "name": "Roggenburg",
                        "latitude": "48.27588000",
                        "longitude": "10.23136000"
                    },
                    {
                        "id": 28687,
                        "name": "Rohr",
                        "latitude": "48.76768000",
                        "longitude": "11.97152000"
                    },
                    {
                        "id": 28689,
                        "name": "Rohrbach",
                        "latitude": "48.28933000",
                        "longitude": "12.55603000"
                    },
                    {
                        "id": 28691,
                        "name": "Rohrdorf",
                        "latitude": "47.79713000",
                        "longitude": "12.17010000"
                    },
                    {
                        "id": 28693,
                        "name": "Rohrenfels",
                        "latitude": "48.68654000",
                        "longitude": "11.15619000"
                    },
                    {
                        "id": 28781,
                        "name": "Röhrmoos",
                        "latitude": "48.32966000",
                        "longitude": "11.44672000"
                    },
                    {
                        "id": 28782,
                        "name": "Röhrnbach",
                        "latitude": "48.73859000",
                        "longitude": "13.52271000"
                    },
                    {
                        "id": 28784,
                        "name": "Röllbach",
                        "latitude": "49.77306000",
                        "longitude": "9.24611000"
                    },
                    {
                        "id": 28700,
                        "name": "Ronsberg",
                        "latitude": "47.89580000",
                        "longitude": "10.41571000"
                    },
                    {
                        "id": 28707,
                        "name": "Rosenheim",
                        "latitude": "47.85637000",
                        "longitude": "12.12247000"
                    },
                    {
                        "id": 28786,
                        "name": "Röslau",
                        "latitude": "50.08333000",
                        "longitude": "11.98333000"
                    },
                    {
                        "id": 28714,
                        "name": "Rossbach",
                        "latitude": "48.58333000",
                        "longitude": "12.95000000"
                    },
                    {
                        "id": 28742,
                        "name": "Roßhaupten",
                        "latitude": "48.42943000",
                        "longitude": "10.46911000"
                    },
                    {
                        "id": 28746,
                        "name": "Roßtal",
                        "latitude": "49.39567000",
                        "longitude": "10.88848000"
                    },
                    {
                        "id": 28720,
                        "name": "Roth",
                        "latitude": "49.24762000",
                        "longitude": "11.09111000"
                    },
                    {
                        "id": 28790,
                        "name": "Röthenbach",
                        "latitude": "47.62303000",
                        "longitude": "9.97387000"
                    },
                    {
                        "id": 28791,
                        "name": "Röthenbach an der Pegnitz",
                        "latitude": "49.48301000",
                        "longitude": "11.24116000"
                    },
                    {
                        "id": 28723,
                        "name": "Rothenbuch",
                        "latitude": "49.96528000",
                        "longitude": "9.39389000"
                    },
                    {
                        "id": 28725,
                        "name": "Rothenburg ob der Tauber",
                        "latitude": "49.37885000",
                        "longitude": "10.18711000"
                    },
                    {
                        "id": 28727,
                        "name": "Rothenfels",
                        "latitude": "49.89135000",
                        "longitude": "9.59260000"
                    },
                    {
                        "id": 28792,
                        "name": "Röthlein",
                        "latitude": "49.98333000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 28729,
                        "name": "Rott",
                        "latitude": "47.92008000",
                        "longitude": "12.08771000"
                    },
                    {
                        "id": 28730,
                        "name": "Rottach-Egern",
                        "latitude": "47.68966000",
                        "longitude": "11.77065000"
                    },
                    {
                        "id": 28793,
                        "name": "Röttenbach",
                        "latitude": "49.66429000",
                        "longitude": "10.92607000"
                    },
                    {
                        "id": 28733,
                        "name": "Rottenbuch",
                        "latitude": "47.73333000",
                        "longitude": "10.96667000"
                    },
                    {
                        "id": 28735,
                        "name": "Rottenburg an der Laaber",
                        "latitude": "48.70233000",
                        "longitude": "12.02717000"
                    },
                    {
                        "id": 28736,
                        "name": "Rottendorf",
                        "latitude": "49.79230000",
                        "longitude": "10.02593000"
                    },
                    {
                        "id": 28737,
                        "name": "Rotthalmünster",
                        "latitude": "48.35825000",
                        "longitude": "13.20162000"
                    },
                    {
                        "id": 28794,
                        "name": "Röttingen",
                        "latitude": "49.50969000",
                        "longitude": "9.97082000"
                    },
                    {
                        "id": 28795,
                        "name": "Rötz",
                        "latitude": "49.34316000",
                        "longitude": "12.52963000"
                    },
                    {
                        "id": 28798,
                        "name": "Rückersdorf",
                        "latitude": "49.49757000",
                        "longitude": "11.24751000"
                    },
                    {
                        "id": 28748,
                        "name": "Rudelzhausen",
                        "latitude": "48.60000000",
                        "longitude": "11.76667000"
                    },
                    {
                        "id": 28749,
                        "name": "Ruderatshofen",
                        "latitude": "47.81667000",
                        "longitude": "10.58333000"
                    },
                    {
                        "id": 28751,
                        "name": "Ruderting",
                        "latitude": "48.65000000",
                        "longitude": "13.41667000"
                    },
                    {
                        "id": 28754,
                        "name": "Rugendorf",
                        "latitude": "50.20000000",
                        "longitude": "11.46667000"
                    },
                    {
                        "id": 28803,
                        "name": "Rügland",
                        "latitude": "49.40000000",
                        "longitude": "10.58333000"
                    },
                    {
                        "id": 28757,
                        "name": "Ruhmannsfelden",
                        "latitude": "48.98327000",
                        "longitude": "12.98347000"
                    },
                    {
                        "id": 28758,
                        "name": "Ruhpolding",
                        "latitude": "47.76667000",
                        "longitude": "12.65000000"
                    },
                    {
                        "id": 28759,
                        "name": "Ruhstorf",
                        "latitude": "48.53976000",
                        "longitude": "12.68305000"
                    },
                    {
                        "id": 28763,
                        "name": "Runding",
                        "latitude": "49.21513000",
                        "longitude": "12.76208000"
                    },
                    {
                        "id": 28812,
                        "name": "Saal",
                        "latitude": "48.90099000",
                        "longitude": "11.93196000"
                    },
                    {
                        "id": 28813,
                        "name": "Saal an der Saale",
                        "latitude": "50.31673000",
                        "longitude": "10.35769000"
                    },
                    {
                        "id": 28821,
                        "name": "Sachsen",
                        "latitude": "49.28999000",
                        "longitude": "10.65971000"
                    },
                    {
                        "id": 28825,
                        "name": "Sachsenkam",
                        "latitude": "47.80543000",
                        "longitude": "11.64396000"
                    },
                    {
                        "id": 28829,
                        "name": "Sailauf",
                        "latitude": "50.02461000",
                        "longitude": "9.25932000"
                    },
                    {
                        "id": 28831,
                        "name": "Salching",
                        "latitude": "48.81047000",
                        "longitude": "12.57043000"
                    },
                    {
                        "id": 28832,
                        "name": "Saldenburg",
                        "latitude": "48.77310000",
                        "longitude": "13.35586000"
                    },
                    {
                        "id": 28834,
                        "name": "Salgen",
                        "latitude": "48.13069000",
                        "longitude": "10.47890000"
                    },
                    {
                        "id": 28837,
                        "name": "Salz",
                        "latitude": "50.30842000",
                        "longitude": "10.21205000"
                    },
                    {
                        "id": 28845,
                        "name": "Salzweg",
                        "latitude": "48.61667000",
                        "longitude": "13.48333000"
                    },
                    {
                        "id": 28846,
                        "name": "Samerberg",
                        "latitude": "47.77654000",
                        "longitude": "12.19139000"
                    },
                    {
                        "id": 28849,
                        "name": "Sand",
                        "latitude": "49.98585000",
                        "longitude": "10.58620000"
                    },
                    {
                        "id": 28851,
                        "name": "Sandberg",
                        "latitude": "50.34824000",
                        "longitude": "10.00814000"
                    },
                    {
                        "id": 28864,
                        "name": "Sankt Englmar",
                        "latitude": "49.00298000",
                        "longitude": "12.82658000"
                    },
                    {
                        "id": 28875,
                        "name": "Sankt Leonhard am Wonneberg",
                        "latitude": "47.91533000",
                        "longitude": "12.71926000"
                    },
                    {
                        "id": 28884,
                        "name": "Sankt Wolfgang",
                        "latitude": "48.21667000",
                        "longitude": "12.13333000"
                    },
                    {
                        "id": 28895,
                        "name": "Sauerlach",
                        "latitude": "47.97171000",
                        "longitude": "11.65383000"
                    },
                    {
                        "id": 28898,
                        "name": "Saulgrub",
                        "latitude": "47.66643000",
                        "longitude": "11.02469000"
                    },
                    {
                        "id": 29098,
                        "name": "Schäftlarn",
                        "latitude": "47.99027000",
                        "longitude": "11.45591000"
                    },
                    {
                        "id": 28914,
                        "name": "Schauenstein",
                        "latitude": "50.27826000",
                        "longitude": "11.74169000"
                    },
                    {
                        "id": 28915,
                        "name": "Schaufling",
                        "latitude": "48.85000000",
                        "longitude": "13.06667000"
                    },
                    {
                        "id": 28916,
                        "name": "Schechen",
                        "latitude": "47.92911000",
                        "longitude": "12.12393000"
                    },
                    {
                        "id": 28922,
                        "name": "Scheidegg",
                        "latitude": "47.58141000",
                        "longitude": "9.84829000"
                    },
                    {
                        "id": 28923,
                        "name": "Scheinfeld",
                        "latitude": "49.66931000",
                        "longitude": "10.46554000"
                    },
                    {
                        "id": 28935,
                        "name": "Scherstetten",
                        "latitude": "48.18032000",
                        "longitude": "10.64005000"
                    },
                    {
                        "id": 28939,
                        "name": "Scheßlitz",
                        "latitude": "49.97568000",
                        "longitude": "11.03299000"
                    },
                    {
                        "id": 28937,
                        "name": "Scheuring",
                        "latitude": "48.16769000",
                        "longitude": "10.89569000"
                    },
                    {
                        "id": 28938,
                        "name": "Scheyern",
                        "latitude": "48.50000000",
                        "longitude": "11.46667000"
                    },
                    {
                        "id": 28941,
                        "name": "Schierling",
                        "latitude": "48.83422000",
                        "longitude": "12.13946000"
                    },
                    {
                        "id": 28948,
                        "name": "Schillingsfürst",
                        "latitude": "49.28775000",
                        "longitude": "10.26276000"
                    },
                    {
                        "id": 28950,
                        "name": "Schiltberg",
                        "latitude": "48.46293000",
                        "longitude": "11.24876000"
                    },
                    {
                        "id": 28953,
                        "name": "Schirmitz",
                        "latitude": "49.65000000",
                        "longitude": "12.16667000"
                    },
                    {
                        "id": 28954,
                        "name": "Schirnding",
                        "latitude": "50.08205000",
                        "longitude": "12.22742000"
                    },
                    {
                        "id": 28965,
                        "name": "Schleching",
                        "latitude": "47.72098000",
                        "longitude": "12.39481000"
                    },
                    {
                        "id": 28967,
                        "name": "Schlehdorf",
                        "latitude": "47.65795000",
                        "longitude": "11.31494000"
                    },
                    {
                        "id": 28979,
                        "name": "Schliersee",
                        "latitude": "47.73621000",
                        "longitude": "11.85936000"
                    },
                    {
                        "id": 28985,
                        "name": "Schlüsselfeld",
                        "latitude": "49.75621000",
                        "longitude": "10.61873000"
                    },
                    {
                        "id": 28991,
                        "name": "Schmidgaden",
                        "latitude": "49.42340000",
                        "longitude": "12.09247000"
                    },
                    {
                        "id": 28992,
                        "name": "Schmidmühlen",
                        "latitude": "49.26898000",
                        "longitude": "11.92429000"
                    },
                    {
                        "id": 28993,
                        "name": "Schmiechen",
                        "latitude": "48.21667000",
                        "longitude": "10.96667000"
                    },
                    {
                        "id": 29000,
                        "name": "Schnaitsee",
                        "latitude": "48.06667000",
                        "longitude": "12.36667000"
                    },
                    {
                        "id": 29001,
                        "name": "Schnaittach",
                        "latitude": "49.55958000",
                        "longitude": "11.34328000"
                    },
                    {
                        "id": 29002,
                        "name": "Schnaittenbach",
                        "latitude": "49.54692000",
                        "longitude": "12.00184000"
                    },
                    {
                        "id": 29003,
                        "name": "Schneckenlohe",
                        "latitude": "50.21184000",
                        "longitude": "11.19395000"
                    },
                    {
                        "id": 29007,
                        "name": "Schneizlreuth",
                        "latitude": "47.68333000",
                        "longitude": "12.80000000"
                    },
                    {
                        "id": 29008,
                        "name": "Schnelldorf",
                        "latitude": "49.20000000",
                        "longitude": "10.18333000"
                    },
                    {
                        "id": 29100,
                        "name": "Schöfweg",
                        "latitude": "48.83882000",
                        "longitude": "13.22861000"
                    },
                    {
                        "id": 29101,
                        "name": "Schöllkrippen",
                        "latitude": "50.08545000",
                        "longitude": "9.24697000"
                    },
                    {
                        "id": 29102,
                        "name": "Schöllnach",
                        "latitude": "48.75412000",
                        "longitude": "13.17781000"
                    },
                    {
                        "id": 29105,
                        "name": "Schönau",
                        "latitude": "48.48333000",
                        "longitude": "12.85000000"
                    },
                    {
                        "id": 29107,
                        "name": "Schönau am Königssee",
                        "latitude": "47.60055000",
                        "longitude": "12.98704000"
                    },
                    {
                        "id": 29014,
                        "name": "Schondorf am Ammersee",
                        "latitude": "48.05296000",
                        "longitude": "11.09138000"
                    },
                    {
                        "id": 29015,
                        "name": "Schondra",
                        "latitude": "50.26814000",
                        "longitude": "9.86277000"
                    },
                    {
                        "id": 29016,
                        "name": "Schongau",
                        "latitude": "47.81240000",
                        "longitude": "10.89664000"
                    },
                    {
                        "id": 29124,
                        "name": "Schöngeising",
                        "latitude": "48.14135000",
                        "longitude": "11.20399000"
                    },
                    {
                        "id": 29129,
                        "name": "Schönsee",
                        "latitude": "49.51030000",
                        "longitude": "12.54763000"
                    },
                    {
                        "id": 29017,
                        "name": "Schonstett",
                        "latitude": "47.98333000",
                        "longitude": "12.25000000"
                    },
                    {
                        "id": 29131,
                        "name": "Schönthal",
                        "latitude": "49.35000000",
                        "longitude": "12.60000000"
                    },
                    {
                        "id": 29018,
                        "name": "Schonungen",
                        "latitude": "50.05008000",
                        "longitude": "10.30809000"
                    },
                    {
                        "id": 29132,
                        "name": "Schönwald",
                        "latitude": "50.19970000",
                        "longitude": "12.08503000"
                    },
                    {
                        "id": 29020,
                        "name": "Schopfloch",
                        "latitude": "49.11917000",
                        "longitude": "10.30774000"
                    },
                    {
                        "id": 29023,
                        "name": "Schorndorf",
                        "latitude": "49.16041000",
                        "longitude": "12.59316000"
                    },
                    {
                        "id": 29032,
                        "name": "Schrobenhausen",
                        "latitude": "48.56067000",
                        "longitude": "11.26071000"
                    },
                    {
                        "id": 29039,
                        "name": "Schwabach",
                        "latitude": "49.33047000",
                        "longitude": "11.02346000"
                    },
                    {
                        "id": 29041,
                        "name": "Schwabhausen",
                        "latitude": "48.40157000",
                        "longitude": "11.35729000"
                    },
                    {
                        "id": 29042,
                        "name": "Schwabmünchen",
                        "latitude": "48.17928000",
                        "longitude": "10.75675000"
                    },
                    {
                        "id": 29043,
                        "name": "Schwabsoien",
                        "latitude": "47.83333000",
                        "longitude": "10.83333000"
                    },
                    {
                        "id": 29046,
                        "name": "Schwaig",
                        "latitude": "49.46955000",
                        "longitude": "11.20064000"
                    },
                    {
                        "id": 29057,
                        "name": "Schwandorf in Bayern",
                        "latitude": "49.32534000",
                        "longitude": "12.10980000"
                    },
                    {
                        "id": 29060,
                        "name": "Schwanfeld",
                        "latitude": "49.92166000",
                        "longitude": "10.13866000"
                    },
                    {
                        "id": 29061,
                        "name": "Schwangau",
                        "latitude": "47.57722000",
                        "longitude": "10.73416000"
                    },
                    {
                        "id": 29066,
                        "name": "Schwarzach",
                        "latitude": "48.91567000",
                        "longitude": "12.81143000"
                    },
                    {
                        "id": 29067,
                        "name": "Schwarzenbach",
                        "latitude": "49.83876000",
                        "longitude": "12.38005000"
                    },
                    {
                        "id": 29068,
                        "name": "Schwarzenbach an der Saale",
                        "latitude": "50.22279000",
                        "longitude": "11.93504000"
                    },
                    {
                        "id": 29072,
                        "name": "Schwarzenbruck",
                        "latitude": "49.35778000",
                        "longitude": "11.24333000"
                    },
                    {
                        "id": 29073,
                        "name": "Schwarzenfeld",
                        "latitude": "49.38774000",
                        "longitude": "12.13484000"
                    },
                    {
                        "id": 29075,
                        "name": "Schwarzhofen",
                        "latitude": "49.37749000",
                        "longitude": "12.34490000"
                    },
                    {
                        "id": 29076,
                        "name": "Schwebheim",
                        "latitude": "49.99036000",
                        "longitude": "10.24776000"
                    },
                    {
                        "id": 29083,
                        "name": "Schweinfurt",
                        "latitude": "50.04937000",
                        "longitude": "10.22175000"
                    },
                    {
                        "id": 29084,
                        "name": "Schweitenkirchen",
                        "latitude": "48.50333000",
                        "longitude": "11.60451000"
                    },
                    {
                        "id": 29087,
                        "name": "Schwenningen",
                        "latitude": "48.65000000",
                        "longitude": "10.65000000"
                    },
                    {
                        "id": 29094,
                        "name": "Schwindegg",
                        "latitude": "48.27155000",
                        "longitude": "12.25978000"
                    },
                    {
                        "id": 29150,
                        "name": "Seefeld",
                        "latitude": "48.03505000",
                        "longitude": "11.21395000"
                    },
                    {
                        "id": 29151,
                        "name": "Seeg",
                        "latitude": "47.65000000",
                        "longitude": "10.60000000"
                    },
                    {
                        "id": 29153,
                        "name": "Seehausen am Staffelsee",
                        "latitude": "47.68928000",
                        "longitude": "11.18498000"
                    },
                    {
                        "id": 29162,
                        "name": "Seeon-Seebruck",
                        "latitude": "47.96667000",
                        "longitude": "12.46667000"
                    },
                    {
                        "id": 29164,
                        "name": "Seeshaupt",
                        "latitude": "47.82468000",
                        "longitude": "11.30219000"
                    },
                    {
                        "id": 29174,
                        "name": "Seinsheim",
                        "latitude": "49.64073000",
                        "longitude": "10.22038000"
                    },
                    {
                        "id": 29176,
                        "name": "Selb",
                        "latitude": "50.17058000",
                        "longitude": "12.13054000"
                    },
                    {
                        "id": 29177,
                        "name": "Selbitz",
                        "latitude": "50.31702000",
                        "longitude": "11.75019000"
                    },
                    {
                        "id": 29188,
                        "name": "Senden",
                        "latitude": "48.32441000",
                        "longitude": "10.04442000"
                    },
                    {
                        "id": 29192,
                        "name": "Sengenthal",
                        "latitude": "49.23333000",
                        "longitude": "11.46667000"
                    },
                    {
                        "id": 29194,
                        "name": "Sennfeld",
                        "latitude": "50.03895000",
                        "longitude": "10.25986000"
                    },
                    {
                        "id": 29204,
                        "name": "Seßlach",
                        "latitude": "50.18969000",
                        "longitude": "10.84197000"
                    },
                    {
                        "id": 29198,
                        "name": "Seubersdorf",
                        "latitude": "49.16212000",
                        "longitude": "11.62714000"
                    },
                    {
                        "id": 29199,
                        "name": "Seukendorf",
                        "latitude": "49.48844000",
                        "longitude": "10.87999000"
                    },
                    {
                        "id": 29202,
                        "name": "Seybothenreuth",
                        "latitude": "49.89372000",
                        "longitude": "11.70531000"
                    },
                    {
                        "id": 29214,
                        "name": "Siegenburg",
                        "latitude": "48.75421000",
                        "longitude": "11.84831000"
                    },
                    {
                        "id": 29215,
                        "name": "Siegsdorf",
                        "latitude": "47.82278000",
                        "longitude": "12.64277000"
                    },
                    {
                        "id": 29217,
                        "name": "Sielenbach",
                        "latitude": "48.40000000",
                        "longitude": "11.16667000"
                    },
                    {
                        "id": 29228,
                        "name": "Sigmarszell",
                        "latitude": "47.58333000",
                        "longitude": "9.76667000"
                    },
                    {
                        "id": 29231,
                        "name": "Simbach",
                        "latitude": "48.56606000",
                        "longitude": "12.73888000"
                    },
                    {
                        "id": 29232,
                        "name": "Simbach am Inn",
                        "latitude": "48.26548000",
                        "longitude": "13.02309000"
                    },
                    {
                        "id": 29233,
                        "name": "Simmelsdorf",
                        "latitude": "49.59775000",
                        "longitude": "11.33901000"
                    },
                    {
                        "id": 29240,
                        "name": "Sindelsdorf",
                        "latitude": "47.72458000",
                        "longitude": "11.33295000"
                    },
                    {
                        "id": 29248,
                        "name": "Sinzing",
                        "latitude": "49.00000000",
                        "longitude": "12.03333000"
                    },
                    {
                        "id": 29489,
                        "name": "Söchtenau",
                        "latitude": "47.93118000",
                        "longitude": "12.22959000"
                    },
                    {
                        "id": 29261,
                        "name": "Solnhofen",
                        "latitude": "48.89582000",
                        "longitude": "10.99560000"
                    },
                    {
                        "id": 29264,
                        "name": "Sommerach",
                        "latitude": "49.82923000",
                        "longitude": "10.20792000"
                    },
                    {
                        "id": 29265,
                        "name": "Sommerhausen",
                        "latitude": "49.70361000",
                        "longitude": "10.02605000"
                    },
                    {
                        "id": 29266,
                        "name": "Sommerkahl",
                        "latitude": "50.06961000",
                        "longitude": "9.25676000"
                    },
                    {
                        "id": 29269,
                        "name": "Sondheim vor der Rhön",
                        "latitude": "50.46510000",
                        "longitude": "10.15675000"
                    },
                    {
                        "id": 29272,
                        "name": "Sonnefeld",
                        "latitude": "50.21667000",
                        "longitude": "11.13333000"
                    },
                    {
                        "id": 29273,
                        "name": "Sonnen",
                        "latitude": "48.68333000",
                        "longitude": "13.71667000"
                    },
                    {
                        "id": 29276,
                        "name": "Sontheim",
                        "latitude": "48.00704000",
                        "longitude": "10.35461000"
                    },
                    {
                        "id": 29278,
                        "name": "Sonthofen",
                        "latitude": "47.51821000",
                        "longitude": "10.28262000"
                    },
                    {
                        "id": 29282,
                        "name": "Soyen",
                        "latitude": "48.10808000",
                        "longitude": "12.21006000"
                    },
                    {
                        "id": 29285,
                        "name": "Spalt",
                        "latitude": "49.17553000",
                        "longitude": "10.92453000"
                    },
                    {
                        "id": 29288,
                        "name": "Spardorf",
                        "latitude": "49.60854000",
                        "longitude": "11.05585000"
                    },
                    {
                        "id": 29289,
                        "name": "Sparneck",
                        "latitude": "50.16214000",
                        "longitude": "11.84349000"
                    },
                    {
                        "id": 29293,
                        "name": "Speichersdorf",
                        "latitude": "49.87133000",
                        "longitude": "11.78123000"
                    },
                    {
                        "id": 29294,
                        "name": "Speinshart",
                        "latitude": "49.79002000",
                        "longitude": "11.81949000"
                    },
                    {
                        "id": 29300,
                        "name": "Spiegelau",
                        "latitude": "48.91517000",
                        "longitude": "13.36229000"
                    },
                    {
                        "id": 29316,
                        "name": "Stadelhofen",
                        "latitude": "50.00317000",
                        "longitude": "11.19757000"
                    },
                    {
                        "id": 29320,
                        "name": "Stadtbergen",
                        "latitude": "48.36641000",
                        "longitude": "10.84636000"
                    },
                    {
                        "id": 29324,
                        "name": "Stadtlauringen",
                        "latitude": "50.18708000",
                        "longitude": "10.36164000"
                    },
                    {
                        "id": 29328,
                        "name": "Stadtprozelten",
                        "latitude": "49.78466000",
                        "longitude": "9.41184000"
                    },
                    {
                        "id": 29331,
                        "name": "Stadtsteinach",
                        "latitude": "50.16433000",
                        "longitude": "11.50349000"
                    },
                    {
                        "id": 29335,
                        "name": "Stallwang",
                        "latitude": "48.55838000",
                        "longitude": "12.23108000"
                    },
                    {
                        "id": 29336,
                        "name": "Stammbach",
                        "latitude": "50.14551000",
                        "longitude": "11.69129000"
                    },
                    {
                        "id": 29337,
                        "name": "Stammham",
                        "latitude": "48.29604000",
                        "longitude": "11.86961000"
                    },
                    {
                        "id": 29338,
                        "name": "Stamsried",
                        "latitude": "49.26755000",
                        "longitude": "12.53051000"
                    },
                    {
                        "id": 29341,
                        "name": "Starnberg",
                        "latitude": "48.00193000",
                        "longitude": "11.34416000"
                    },
                    {
                        "id": 29343,
                        "name": "Staudach-Egerndach",
                        "latitude": "47.78333000",
                        "longitude": "12.48333000"
                    },
                    {
                        "id": 29351,
                        "name": "Stegaurach",
                        "latitude": "49.86543000",
                        "longitude": "10.84385000"
                    },
                    {
                        "id": 29357,
                        "name": "Stein",
                        "latitude": "49.41581000",
                        "longitude": "11.01599000"
                    },
                    {
                        "id": 29359,
                        "name": "Steinach",
                        "latitude": "48.95417000",
                        "longitude": "12.60709000"
                    },
                    {
                        "id": 29364,
                        "name": "Steinbach",
                        "latitude": "50.15328000",
                        "longitude": "11.65055000"
                    },
                    {
                        "id": 29371,
                        "name": "Steinfeld",
                        "latitude": "49.95278000",
                        "longitude": "9.66944000"
                    },
                    {
                        "id": 29375,
                        "name": "Steingaden",
                        "latitude": "47.70000000",
                        "longitude": "10.86667000"
                    },
                    {
                        "id": 29380,
                        "name": "Steinheim",
                        "latitude": "48.01473000",
                        "longitude": "10.16081000"
                    },
                    {
                        "id": 29385,
                        "name": "Steinhöring",
                        "latitude": "48.08679000",
                        "longitude": "12.03140000"
                    },
                    {
                        "id": 29388,
                        "name": "Steinkirchen",
                        "latitude": "48.38333000",
                        "longitude": "12.08333000"
                    },
                    {
                        "id": 29390,
                        "name": "Steinsfeld",
                        "latitude": "49.41667000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 29393,
                        "name": "Steinwiesen",
                        "latitude": "50.29444000",
                        "longitude": "11.46295000"
                    },
                    {
                        "id": 29399,
                        "name": "Stephanskirchen",
                        "latitude": "47.85389000",
                        "longitude": "12.18560000"
                    },
                    {
                        "id": 29400,
                        "name": "Stephansposching",
                        "latitude": "48.81667000",
                        "longitude": "12.80000000"
                    },
                    {
                        "id": 29404,
                        "name": "Stetten",
                        "latitude": "48.02382000",
                        "longitude": "10.44474000"
                    },
                    {
                        "id": 29406,
                        "name": "Stettfeld",
                        "latitude": "49.97090000",
                        "longitude": "10.72170000"
                    },
                    {
                        "id": 29408,
                        "name": "Stiefenhofen",
                        "latitude": "47.59320000",
                        "longitude": "10.00365000"
                    },
                    {
                        "id": 29412,
                        "name": "Stockheim",
                        "latitude": "50.30639000",
                        "longitude": "11.28172000"
                    },
                    {
                        "id": 29413,
                        "name": "Stockstadt am Main",
                        "latitude": "49.97005000",
                        "longitude": "9.07153000"
                    },
                    {
                        "id": 29451,
                        "name": "Störnstein",
                        "latitude": "49.73232000",
                        "longitude": "12.20547000"
                    },
                    {
                        "id": 29452,
                        "name": "Stötten am Auerberg",
                        "latitude": "47.73871000",
                        "longitude": "10.68881000"
                    },
                    {
                        "id": 29453,
                        "name": "Stöttwang",
                        "latitude": "47.88333000",
                        "longitude": "10.71667000"
                    },
                    {
                        "id": 29433,
                        "name": "Straßkirchen",
                        "latitude": "48.83071000",
                        "longitude": "12.72105000"
                    },
                    {
                        "id": 29434,
                        "name": "Straßlach-Dingharting",
                        "latitude": "48.00491000",
                        "longitude": "11.51410000"
                    },
                    {
                        "id": 29428,
                        "name": "Straubing",
                        "latitude": "48.88126000",
                        "longitude": "12.57385000"
                    },
                    {
                        "id": 29437,
                        "name": "Strullendorf",
                        "latitude": "49.84429000",
                        "longitude": "10.97208000"
                    },
                    {
                        "id": 29441,
                        "name": "Stubenberg",
                        "latitude": "48.31667000",
                        "longitude": "13.08333000"
                    },
                    {
                        "id": 29443,
                        "name": "Stulln",
                        "latitude": "49.41667000",
                        "longitude": "12.13333000"
                    },
                    {
                        "id": 29461,
                        "name": "Sugenheim",
                        "latitude": "49.60276000",
                        "longitude": "10.43563000"
                    },
                    {
                        "id": 29469,
                        "name": "Sulzbach am Main",
                        "latitude": "49.91149000",
                        "longitude": "9.15315000"
                    },
                    {
                        "id": 29471,
                        "name": "Sulzbach-Rosenberg",
                        "latitude": "49.50126000",
                        "longitude": "11.74598000"
                    },
                    {
                        "id": 29472,
                        "name": "Sulzberg",
                        "latitude": "47.66033000",
                        "longitude": "10.34991000"
                    },
                    {
                        "id": 29474,
                        "name": "Sulzdorf",
                        "latitude": "49.65002000",
                        "longitude": "9.90389000"
                    },
                    {
                        "id": 29475,
                        "name": "Sulzemoos",
                        "latitude": "48.29107000",
                        "longitude": "11.26356000"
                    },
                    {
                        "id": 29476,
                        "name": "Sulzfeld",
                        "latitude": "50.25972000",
                        "longitude": "10.40525000"
                    },
                    {
                        "id": 29478,
                        "name": "Sulzfeld am Main",
                        "latitude": "49.70694000",
                        "longitude": "10.13248000"
                    },
                    {
                        "id": 29479,
                        "name": "Sulzheim",
                        "latitude": "49.95000000",
                        "longitude": "10.33333000"
                    },
                    {
                        "id": 29504,
                        "name": "Sünching",
                        "latitude": "48.87855000",
                        "longitude": "12.35129000"
                    },
                    {
                        "id": 29482,
                        "name": "Surberg",
                        "latitude": "47.86667000",
                        "longitude": "12.70000000"
                    },
                    {
                        "id": 29485,
                        "name": "Swabia",
                        "latitude": "48.33333000",
                        "longitude": "10.50000000"
                    },
                    {
                        "id": 29511,
                        "name": "Tacherting",
                        "latitude": "48.07825000",
                        "longitude": "12.57008000"
                    },
                    {
                        "id": 29512,
                        "name": "Taching am See",
                        "latitude": "47.95942000",
                        "longitude": "12.72933000"
                    },
                    {
                        "id": 29513,
                        "name": "Tagmersheim",
                        "latitude": "48.81667000",
                        "longitude": "10.96667000"
                    },
                    {
                        "id": 29521,
                        "name": "Tann",
                        "latitude": "48.31463000",
                        "longitude": "12.89301000"
                    },
                    {
                        "id": 29699,
                        "name": "Tännesberg",
                        "latitude": "49.53182000",
                        "longitude": "12.32765000"
                    },
                    {
                        "id": 29527,
                        "name": "Tapfheim",
                        "latitude": "48.67322000",
                        "longitude": "10.68377000"
                    },
                    {
                        "id": 29536,
                        "name": "Taufkirchen",
                        "latitude": "48.04860000",
                        "longitude": "11.61701000"
                    },
                    {
                        "id": 29544,
                        "name": "Tegernheim",
                        "latitude": "49.02394000",
                        "longitude": "12.17303000"
                    },
                    {
                        "id": 29545,
                        "name": "Tegernsee",
                        "latitude": "47.71230000",
                        "longitude": "11.75820000"
                    },
                    {
                        "id": 29548,
                        "name": "Teisendorf",
                        "latitude": "47.84921000",
                        "longitude": "12.81919000"
                    },
                    {
                        "id": 29549,
                        "name": "Teising",
                        "latitude": "48.22721000",
                        "longitude": "12.61137000"
                    },
                    {
                        "id": 29550,
                        "name": "Teisnach",
                        "latitude": "49.04114000",
                        "longitude": "12.98784000"
                    },
                    {
                        "id": 29563,
                        "name": "Tettau",
                        "latitude": "50.46979000",
                        "longitude": "11.25888000"
                    },
                    {
                        "id": 29564,
                        "name": "Tettenweis",
                        "latitude": "48.44281000",
                        "longitude": "13.26955000"
                    },
                    {
                        "id": 29566,
                        "name": "Teublitz",
                        "latitude": "49.22289000",
                        "longitude": "12.08727000"
                    },
                    {
                        "id": 29569,
                        "name": "Teugn",
                        "latitude": "48.89299000",
                        "longitude": "12.01175000"
                    },
                    {
                        "id": 29570,
                        "name": "Teunz",
                        "latitude": "49.48333000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 29572,
                        "name": "Teuschnitz",
                        "latitude": "50.39839000",
                        "longitude": "11.38235000"
                    },
                    {
                        "id": 29581,
                        "name": "Thalmassing",
                        "latitude": "48.91167000",
                        "longitude": "12.15500000"
                    },
                    {
                        "id": 29583,
                        "name": "Thannhausen",
                        "latitude": "48.28334000",
                        "longitude": "10.46917000"
                    },
                    {
                        "id": 29584,
                        "name": "Thanstein",
                        "latitude": "49.38333000",
                        "longitude": "12.46667000"
                    },
                    {
                        "id": 29587,
                        "name": "Theilheim",
                        "latitude": "49.75403000",
                        "longitude": "10.03056000"
                    },
                    {
                        "id": 29588,
                        "name": "Theisseil",
                        "latitude": "49.69034000",
                        "longitude": "12.22744000"
                    },
                    {
                        "id": 29593,
                        "name": "Thierhaupten",
                        "latitude": "48.56531000",
                        "longitude": "10.90862000"
                    },
                    {
                        "id": 29594,
                        "name": "Thiersheim",
                        "latitude": "50.07609000",
                        "longitude": "12.12650000"
                    },
                    {
                        "id": 29595,
                        "name": "Thierstein",
                        "latitude": "50.10643000",
                        "longitude": "12.10203000"
                    },
                    {
                        "id": 29601,
                        "name": "Thundorf in Unterfranken",
                        "latitude": "50.20097000",
                        "longitude": "10.31906000"
                    },
                    {
                        "id": 29605,
                        "name": "Thüngen",
                        "latitude": "49.94140000",
                        "longitude": "9.85860000"
                    },
                    {
                        "id": 29606,
                        "name": "Thüngersheim",
                        "latitude": "49.87833000",
                        "longitude": "9.84917000"
                    },
                    {
                        "id": 29602,
                        "name": "Thurmansbang",
                        "latitude": "48.76627000",
                        "longitude": "13.31550000"
                    },
                    {
                        "id": 29603,
                        "name": "Thurnau",
                        "latitude": "50.02542000",
                        "longitude": "11.39348000"
                    },
                    {
                        "id": 29604,
                        "name": "Thyrnau",
                        "latitude": "48.61667000",
                        "longitude": "13.53333000"
                    },
                    {
                        "id": 29609,
                        "name": "Tiefenbach",
                        "latitude": "48.50000000",
                        "longitude": "12.10000000"
                    },
                    {
                        "id": 29618,
                        "name": "Tirschenreuth",
                        "latitude": "49.88263000",
                        "longitude": "12.33112000"
                    },
                    {
                        "id": 29620,
                        "name": "Tittling",
                        "latitude": "48.72619000",
                        "longitude": "13.38221000"
                    },
                    {
                        "id": 29621,
                        "name": "Tittmoning",
                        "latitude": "48.06164000",
                        "longitude": "12.76760000"
                    },
                    {
                        "id": 29626,
                        "name": "Todtenweis",
                        "latitude": "48.51712000",
                        "longitude": "10.92856000"
                    },
                    {
                        "id": 29700,
                        "name": "Töging am Inn",
                        "latitude": "48.26018000",
                        "longitude": "12.58460000"
                    },
                    {
                        "id": 29703,
                        "name": "Töpen",
                        "latitude": "50.39067000",
                        "longitude": "11.87329000"
                    },
                    {
                        "id": 29637,
                        "name": "Trabitz",
                        "latitude": "49.80000000",
                        "longitude": "11.90000000"
                    },
                    {
                        "id": 29638,
                        "name": "Train",
                        "latitude": "48.73333000",
                        "longitude": "11.83333000"
                    },
                    {
                        "id": 29639,
                        "name": "Traitsching",
                        "latitude": "49.15000000",
                        "longitude": "12.65000000"
                    },
                    {
                        "id": 29641,
                        "name": "Trappstadt",
                        "latitude": "50.31880000",
                        "longitude": "10.56995000"
                    },
                    {
                        "id": 29643,
                        "name": "Traunreut",
                        "latitude": "47.96269000",
                        "longitude": "12.59231000"
                    },
                    {
                        "id": 29644,
                        "name": "Traunstein",
                        "latitude": "47.86825000",
                        "longitude": "12.64335000"
                    },
                    {
                        "id": 29645,
                        "name": "Trausnitz",
                        "latitude": "49.52114000",
                        "longitude": "12.26249000"
                    },
                    {
                        "id": 29646,
                        "name": "Trautskirchen",
                        "latitude": "49.45810000",
                        "longitude": "10.59361000"
                    },
                    {
                        "id": 29650,
                        "name": "Trebgast",
                        "latitude": "50.06667000",
                        "longitude": "11.55000000"
                    },
                    {
                        "id": 29655,
                        "name": "Treffelstein",
                        "latitude": "49.42246000",
                        "longitude": "12.61574000"
                    },
                    {
                        "id": 29661,
                        "name": "Treuchtlingen",
                        "latitude": "48.95473000",
                        "longitude": "10.90833000"
                    },
                    {
                        "id": 29670,
                        "name": "Triftern",
                        "latitude": "48.39468000",
                        "longitude": "13.00627000"
                    },
                    {
                        "id": 29677,
                        "name": "Trogen",
                        "latitude": "50.36667000",
                        "longitude": "11.95000000"
                    },
                    {
                        "id": 29686,
                        "name": "Tröstau",
                        "latitude": "50.01667000",
                        "longitude": "11.95000000"
                    },
                    {
                        "id": 29682,
                        "name": "Trostberg an der Alz",
                        "latitude": "48.02802000",
                        "longitude": "12.55804000"
                    },
                    {
                        "id": 29684,
                        "name": "Trunkelsberg",
                        "latitude": "48.00000000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 29689,
                        "name": "Tuchenbach",
                        "latitude": "49.52794000",
                        "longitude": "10.85973000"
                    },
                    {
                        "id": 29691,
                        "name": "Tuntenhausen",
                        "latitude": "47.93509000",
                        "longitude": "12.01518000"
                    },
                    {
                        "id": 29707,
                        "name": "Türkenfeld",
                        "latitude": "48.10531000",
                        "longitude": "11.08303000"
                    },
                    {
                        "id": 29708,
                        "name": "Türkheim",
                        "latitude": "48.06401000",
                        "longitude": "10.64156000"
                    },
                    {
                        "id": 29692,
                        "name": "Tussenhausen",
                        "latitude": "48.10218000",
                        "longitude": "10.56069000"
                    },
                    {
                        "id": 29711,
                        "name": "Tüßling",
                        "latitude": "48.21218000",
                        "longitude": "12.59954000"
                    },
                    {
                        "id": 29695,
                        "name": "Tutzing",
                        "latitude": "47.90938000",
                        "longitude": "11.28030000"
                    },
                    {
                        "id": 29697,
                        "name": "Tyrlaching",
                        "latitude": "48.06667000",
                        "longitude": "12.66667000"
                    },
                    {
                        "id": 30556,
                        "name": "Übersee",
                        "latitude": "47.81667000",
                        "longitude": "12.48333000"
                    },
                    {
                        "id": 30557,
                        "name": "Üchtelhausen",
                        "latitude": "50.09184000",
                        "longitude": "10.26861000"
                    },
                    {
                        "id": 29721,
                        "name": "Uehlfeld",
                        "latitude": "49.67085000",
                        "longitude": "10.72017000"
                    },
                    {
                        "id": 29728,
                        "name": "Uettingen",
                        "latitude": "49.79472000",
                        "longitude": "9.73056000"
                    },
                    {
                        "id": 29730,
                        "name": "Uffenheim",
                        "latitude": "49.54415000",
                        "longitude": "10.23286000"
                    },
                    {
                        "id": 29731,
                        "name": "Uffing",
                        "latitude": "47.71378000",
                        "longitude": "11.15034000"
                    },
                    {
                        "id": 29745,
                        "name": "Ungerhausen",
                        "latitude": "48.00566000",
                        "longitude": "10.26672000"
                    },
                    {
                        "id": 29752,
                        "name": "Unterammergau",
                        "latitude": "47.61658000",
                        "longitude": "11.02718000"
                    },
                    {
                        "id": 29755,
                        "name": "Unterdießen",
                        "latitude": "47.98333000",
                        "longitude": "10.83333000"
                    },
                    {
                        "id": 29754,
                        "name": "Unterdietfurt",
                        "latitude": "48.38333000",
                        "longitude": "12.66667000"
                    },
                    {
                        "id": 29756,
                        "name": "Unteregg",
                        "latitude": "47.96667000",
                        "longitude": "10.46667000"
                    },
                    {
                        "id": 29759,
                        "name": "Unterföhring",
                        "latitude": "48.19253000",
                        "longitude": "11.64293000"
                    },
                    {
                        "id": 29760,
                        "name": "Untergriesbach",
                        "latitude": "48.57434000",
                        "longitude": "13.66725000"
                    },
                    {
                        "id": 29762,
                        "name": "Unterhaching",
                        "latitude": "48.06598000",
                        "longitude": "11.61564000"
                    },
                    {
                        "id": 29767,
                        "name": "Unterleinleiter",
                        "latitude": "49.82303000",
                        "longitude": "11.18906000"
                    },
                    {
                        "id": 29770,
                        "name": "Untermeitingen",
                        "latitude": "48.16082000",
                        "longitude": "10.80694000"
                    },
                    {
                        "id": 29771,
                        "name": "Untermerzbach",
                        "latitude": "50.12754000",
                        "longitude": "10.85634000"
                    },
                    {
                        "id": 29773,
                        "name": "Unterneukirchen",
                        "latitude": "48.16667000",
                        "longitude": "12.61667000"
                    },
                    {
                        "id": 29774,
                        "name": "Unterpleichfeld",
                        "latitude": "49.86886000",
                        "longitude": "10.04399000"
                    },
                    {
                        "id": 29776,
                        "name": "Unterreit",
                        "latitude": "48.11667000",
                        "longitude": "12.33333000"
                    },
                    {
                        "id": 29777,
                        "name": "Unterschleißheim",
                        "latitude": "48.28038000",
                        "longitude": "11.57684000"
                    },
                    {
                        "id": 29779,
                        "name": "Untersiemau",
                        "latitude": "50.19415000",
                        "longitude": "10.97448000"
                    },
                    {
                        "id": 29780,
                        "name": "Untersteinach",
                        "latitude": "50.13333000",
                        "longitude": "11.51667000"
                    },
                    {
                        "id": 29781,
                        "name": "Unterthingau",
                        "latitude": "47.77155000",
                        "longitude": "10.50446000"
                    },
                    {
                        "id": 29783,
                        "name": "Unterwössen",
                        "latitude": "47.73333000",
                        "longitude": "12.46667000"
                    },
                    {
                        "id": 29784,
                        "name": "Untrasried",
                        "latitude": "47.83333000",
                        "longitude": "10.38333000"
                    },
                    {
                        "id": 29786,
                        "name": "Upper Bavaria",
                        "latitude": "48.00000000",
                        "longitude": "11.00000000"
                    },
                    {
                        "id": 29787,
                        "name": "Upper Franconia",
                        "latitude": "49.83333000",
                        "longitude": "11.33333000"
                    },
                    {
                        "id": 29788,
                        "name": "Upper Palatinate",
                        "latitude": "49.50000000",
                        "longitude": "12.00000000"
                    },
                    {
                        "id": 29794,
                        "name": "Ursberg",
                        "latitude": "48.26428000",
                        "longitude": "10.44594000"
                    },
                    {
                        "id": 29795,
                        "name": "Ursensollen",
                        "latitude": "49.40204000",
                        "longitude": "11.75503000"
                    },
                    {
                        "id": 29796,
                        "name": "Urspringen",
                        "latitude": "49.90166000",
                        "longitude": "9.67123000"
                    },
                    {
                        "id": 29800,
                        "name": "Ustersbach",
                        "latitude": "48.31667000",
                        "longitude": "10.65000000"
                    },
                    {
                        "id": 29803,
                        "name": "Uttenreuth",
                        "latitude": "49.59675000",
                        "longitude": "11.07216000"
                    },
                    {
                        "id": 29805,
                        "name": "Utting am Ammersee",
                        "latitude": "48.02608000",
                        "longitude": "11.08612000"
                    },
                    {
                        "id": 29808,
                        "name": "Vachendorf",
                        "latitude": "47.84256000",
                        "longitude": "12.60606000"
                    },
                    {
                        "id": 29809,
                        "name": "Vagen",
                        "latitude": "47.87410000",
                        "longitude": "11.88446000"
                    },
                    {
                        "id": 29812,
                        "name": "Valley",
                        "latitude": "47.89310000",
                        "longitude": "11.77915000"
                    },
                    {
                        "id": 29815,
                        "name": "Vaterstetten",
                        "latitude": "48.10537000",
                        "longitude": "11.76825000"
                    },
                    {
                        "id": 29821,
                        "name": "Veitsbronn",
                        "latitude": "49.51239000",
                        "longitude": "10.88797000"
                    },
                    {
                        "id": 29822,
                        "name": "Veitshöchheim",
                        "latitude": "49.83278000",
                        "longitude": "9.88167000"
                    },
                    {
                        "id": 29824,
                        "name": "Velburg",
                        "latitude": "49.23212000",
                        "longitude": "11.67160000"
                    },
                    {
                        "id": 29825,
                        "name": "Velden",
                        "latitude": "48.36632000",
                        "longitude": "12.25596000"
                    },
                    {
                        "id": 29838,
                        "name": "Vestenbergsgreuth",
                        "latitude": "49.68764000",
                        "longitude": "10.65157000"
                    },
                    {
                        "id": 29842,
                        "name": "Viechtach",
                        "latitude": "49.08001000",
                        "longitude": "12.88566000"
                    },
                    {
                        "id": 29845,
                        "name": "Viereth-Trunstadt",
                        "latitude": "49.92222000",
                        "longitude": "10.77716000"
                    },
                    {
                        "id": 29846,
                        "name": "Vierkirchen",
                        "latitude": "48.36667000",
                        "longitude": "11.46667000"
                    },
                    {
                        "id": 29850,
                        "name": "Vilgertshofen",
                        "latitude": "47.95000000",
                        "longitude": "10.91667000"
                    },
                    {
                        "id": 29851,
                        "name": "Villenbach",
                        "latitude": "48.50887000",
                        "longitude": "10.61468000"
                    },
                    {
                        "id": 29855,
                        "name": "Vilsbiburg",
                        "latitude": "48.45296000",
                        "longitude": "12.35604000"
                    },
                    {
                        "id": 29856,
                        "name": "Vilseck",
                        "latitude": "49.61480000",
                        "longitude": "11.80261000"
                    },
                    {
                        "id": 29857,
                        "name": "Vilsheim",
                        "latitude": "48.44882000",
                        "longitude": "12.10686000"
                    },
                    {
                        "id": 29858,
                        "name": "Vilshofen",
                        "latitude": "48.62695000",
                        "longitude": "13.19222000"
                    },
                    {
                        "id": 29867,
                        "name": "Vogtareuth",
                        "latitude": "47.94694000",
                        "longitude": "12.18126000"
                    },
                    {
                        "id": 29869,
                        "name": "Vohburg an der Donau",
                        "latitude": "48.76977000",
                        "longitude": "11.61845000"
                    },
                    {
                        "id": 29870,
                        "name": "Vohenstrauß",
                        "latitude": "49.62383000",
                        "longitude": "12.33808000"
                    },
                    {
                        "id": 29890,
                        "name": "Vöhringen",
                        "latitude": "48.27839000",
                        "longitude": "10.08236000"
                    },
                    {
                        "id": 29872,
                        "name": "Volkach",
                        "latitude": "49.86352000",
                        "longitude": "10.22813000"
                    },
                    {
                        "id": 29873,
                        "name": "Volkenschwand",
                        "latitude": "48.60000000",
                        "longitude": "11.88333000"
                    },
                    {
                        "id": 29880,
                        "name": "Vorbach",
                        "latitude": "49.82136000",
                        "longitude": "11.73625000"
                    },
                    {
                        "id": 29882,
                        "name": "Vorra",
                        "latitude": "49.55718000",
                        "longitude": "11.49419000"
                    },
                    {
                        "id": 29897,
                        "name": "Waakirchen",
                        "latitude": "47.77250000",
                        "longitude": "11.67315000"
                    },
                    {
                        "id": 29898,
                        "name": "Waal",
                        "latitude": "47.99679000",
                        "longitude": "10.77786000"
                    },
                    {
                        "id": 29902,
                        "name": "Wachenroth",
                        "latitude": "49.75185000",
                        "longitude": "10.71335000"
                    },
                    {
                        "id": 29908,
                        "name": "Wackersberg",
                        "latitude": "47.73333000",
                        "longitude": "11.55000000"
                    },
                    {
                        "id": 29909,
                        "name": "Wackersdorf",
                        "latitude": "49.31667000",
                        "longitude": "12.18333000"
                    },
                    {
                        "id": 29913,
                        "name": "Waffenbrunn",
                        "latitude": "49.26667000",
                        "longitude": "12.66667000"
                    },
                    {
                        "id": 29917,
                        "name": "Waging am See",
                        "latitude": "47.93414000",
                        "longitude": "12.73392000"
                    },
                    {
                        "id": 29924,
                        "name": "Waidhaus",
                        "latitude": "49.64218000",
                        "longitude": "12.49523000"
                    },
                    {
                        "id": 29925,
                        "name": "Waidhofen",
                        "latitude": "48.57681000",
                        "longitude": "11.33537000"
                    },
                    {
                        "id": 29927,
                        "name": "Waigolshausen",
                        "latitude": "49.96430000",
                        "longitude": "10.12001000"
                    },
                    {
                        "id": 29929,
                        "name": "Waischenfeld",
                        "latitude": "49.84645000",
                        "longitude": "11.34810000"
                    },
                    {
                        "id": 29931,
                        "name": "Wald",
                        "latitude": "49.15000000",
                        "longitude": "12.35000000"
                    },
                    {
                        "id": 29935,
                        "name": "Waldaschaff",
                        "latitude": "49.97528000",
                        "longitude": "9.30194000"
                    },
                    {
                        "id": 29937,
                        "name": "Waldbrunn",
                        "latitude": "49.75861000",
                        "longitude": "9.80361000"
                    },
                    {
                        "id": 29942,
                        "name": "Waldbüttelbrunn",
                        "latitude": "49.78833000",
                        "longitude": "9.84667000"
                    },
                    {
                        "id": 29948,
                        "name": "Walderbach",
                        "latitude": "49.18333000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 29949,
                        "name": "Waldershof",
                        "latitude": "49.98144000",
                        "longitude": "12.06291000"
                    },
                    {
                        "id": 29956,
                        "name": "Waldkirchen",
                        "latitude": "48.73270000",
                        "longitude": "13.60082000"
                    },
                    {
                        "id": 29957,
                        "name": "Waldkraiburg",
                        "latitude": "48.20854000",
                        "longitude": "12.39893000"
                    },
                    {
                        "id": 29959,
                        "name": "Waldmünchen",
                        "latitude": "49.37804000",
                        "longitude": "12.70905000"
                    },
                    {
                        "id": 29961,
                        "name": "Waldsassen",
                        "latitude": "50.00167000",
                        "longitude": "12.30434000"
                    },
                    {
                        "id": 29966,
                        "name": "Waldstetten",
                        "latitude": "48.34815000",
                        "longitude": "10.29385000"
                    },
                    {
                        "id": 29967,
                        "name": "Waldthurn",
                        "latitude": "49.67221000",
                        "longitude": "12.32919000"
                    },
                    {
                        "id": 29970,
                        "name": "Walkertshofen",
                        "latitude": "48.22613000",
                        "longitude": "10.58836000"
                    },
                    {
                        "id": 29975,
                        "name": "Wallenfels",
                        "latitude": "50.26850000",
                        "longitude": "11.47058000"
                    },
                    {
                        "id": 29978,
                        "name": "Wallerfing",
                        "latitude": "48.68416000",
                        "longitude": "12.88035000"
                    },
                    {
                        "id": 29979,
                        "name": "Wallersdorf",
                        "latitude": "48.73767000",
                        "longitude": "12.74744000"
                    },
                    {
                        "id": 29980,
                        "name": "Wallerstein",
                        "latitude": "48.88741000",
                        "longitude": "10.47591000"
                    },
                    {
                        "id": 29982,
                        "name": "Wallgau",
                        "latitude": "47.51667000",
                        "longitude": "11.28333000"
                    },
                    {
                        "id": 29990,
                        "name": "Walpertskirchen",
                        "latitude": "48.25840000",
                        "longitude": "11.97527000"
                    },
                    {
                        "id": 29992,
                        "name": "Walsdorf",
                        "latitude": "49.86667000",
                        "longitude": "10.78333000"
                    },
                    {
                        "id": 29994,
                        "name": "Waltenhofen",
                        "latitude": "47.67319000",
                        "longitude": "10.30703000"
                    },
                    {
                        "id": 30002,
                        "name": "Wang",
                        "latitude": "48.49549000",
                        "longitude": "11.93641000"
                    },
                    {
                        "id": 30018,
                        "name": "Warmensteinach",
                        "latitude": "49.99348000",
                        "longitude": "11.77866000"
                    },
                    {
                        "id": 30021,
                        "name": "Warngau",
                        "latitude": "47.83217000",
                        "longitude": "11.72173000"
                    },
                    {
                        "id": 30024,
                        "name": "Wartenberg",
                        "latitude": "48.40597000",
                        "longitude": "11.98865000"
                    },
                    {
                        "id": 30027,
                        "name": "Wartmannsroth",
                        "latitude": "50.16667000",
                        "longitude": "9.78333000"
                    },
                    {
                        "id": 30032,
                        "name": "Wasserburg",
                        "latitude": "48.44105000",
                        "longitude": "10.26930000"
                    },
                    {
                        "id": 30033,
                        "name": "Wasserburg am Inn",
                        "latitude": "48.05250000",
                        "longitude": "12.22341000"
                    },
                    {
                        "id": 30036,
                        "name": "Wasserlosen",
                        "latitude": "50.09476000",
                        "longitude": "10.03017000"
                    },
                    {
                        "id": 30037,
                        "name": "Wassertrüdingen",
                        "latitude": "49.04328000",
                        "longitude": "10.59906000"
                    },
                    {
                        "id": 30044,
                        "name": "Wechingen",
                        "latitude": "48.89229000",
                        "longitude": "10.61331000"
                    },
                    {
                        "id": 30058,
                        "name": "Wegscheid",
                        "latitude": "48.60136000",
                        "longitude": "13.78733000"
                    },
                    {
                        "id": 30063,
                        "name": "Wehringen",
                        "latitude": "48.25000000",
                        "longitude": "10.80000000"
                    },
                    {
                        "id": 30065,
                        "name": "Weibersbrunn",
                        "latitude": "49.93083000",
                        "longitude": "9.36611000"
                    },
                    {
                        "id": 30066,
                        "name": "Weichering",
                        "latitude": "48.71713000",
                        "longitude": "11.32141000"
                    },
                    {
                        "id": 30067,
                        "name": "Weichs",
                        "latitude": "48.38333000",
                        "longitude": "11.41667000"
                    },
                    {
                        "id": 30069,
                        "name": "Weiden",
                        "latitude": "49.67682000",
                        "longitude": "12.15613000"
                    },
                    {
                        "id": 30070,
                        "name": "Weidenbach",
                        "latitude": "49.19817000",
                        "longitude": "10.64489000"
                    },
                    {
                        "id": 30073,
                        "name": "Weidhausen bei Coburg",
                        "latitude": "50.20354000",
                        "longitude": "11.14006000"
                    },
                    {
                        "id": 30074,
                        "name": "Weiding",
                        "latitude": "49.26282000",
                        "longitude": "12.76311000"
                    },
                    {
                        "id": 30075,
                        "name": "Weigendorf",
                        "latitude": "49.49773000",
                        "longitude": "11.56869000"
                    },
                    {
                        "id": 30076,
                        "name": "Weihenzell",
                        "latitude": "49.35000000",
                        "longitude": "10.61667000"
                    },
                    {
                        "id": 30077,
                        "name": "Weiherhammer",
                        "latitude": "49.63333000",
                        "longitude": "12.06667000"
                    },
                    {
                        "id": 30078,
                        "name": "Weihmichl",
                        "latitude": "48.60000000",
                        "longitude": "12.05000000"
                    },
                    {
                        "id": 30080,
                        "name": "Weil",
                        "latitude": "48.11717000",
                        "longitude": "10.92161000"
                    },
                    {
                        "id": 30084,
                        "name": "Weilbach",
                        "latitude": "49.66812000",
                        "longitude": "9.21639000"
                    },
                    {
                        "id": 30087,
                        "name": "Weiler-Simmerberg",
                        "latitude": "47.58261000",
                        "longitude": "9.91352000"
                    },
                    {
                        "id": 30089,
                        "name": "Weilersbach",
                        "latitude": "49.75000000",
                        "longitude": "11.11667000"
                    },
                    {
                        "id": 30091,
                        "name": "Weilheim",
                        "latitude": "47.84147000",
                        "longitude": "11.15484000"
                    },
                    {
                        "id": 30095,
                        "name": "Weiltingen",
                        "latitude": "49.03878000",
                        "longitude": "10.45052000"
                    },
                    {
                        "id": 30109,
                        "name": "Weisendorf",
                        "latitude": "49.62283000",
                        "longitude": "10.82531000"
                    },
                    {
                        "id": 30111,
                        "name": "Weismain",
                        "latitude": "50.08512000",
                        "longitude": "11.24024000"
                    },
                    {
                        "id": 30123,
                        "name": "Weißdorf",
                        "latitude": "50.18333000",
                        "longitude": "11.85000000"
                    },
                    {
                        "id": 30128,
                        "name": "Weißenbrunn",
                        "latitude": "50.20000000",
                        "longitude": "11.35000000"
                    },
                    {
                        "id": 30129,
                        "name": "Weißenburg in Bayern",
                        "latitude": "49.03095000",
                        "longitude": "10.97221000"
                    },
                    {
                        "id": 30131,
                        "name": "Weißenhorn",
                        "latitude": "48.30501000",
                        "longitude": "10.16047000"
                    },
                    {
                        "id": 30132,
                        "name": "Weißenohe",
                        "latitude": "49.63089000",
                        "longitude": "11.25369000"
                    },
                    {
                        "id": 30133,
                        "name": "Weißensberg",
                        "latitude": "47.58130000",
                        "longitude": "9.72586000"
                    },
                    {
                        "id": 30136,
                        "name": "Weißenstadt",
                        "latitude": "50.10217000",
                        "longitude": "11.88849000"
                    },
                    {
                        "id": 30119,
                        "name": "Weitnau",
                        "latitude": "47.64171000",
                        "longitude": "10.12732000"
                    },
                    {
                        "id": 30120,
                        "name": "Weitramsdorf",
                        "latitude": "50.25600000",
                        "longitude": "10.87989000"
                    },
                    {
                        "id": 30141,
                        "name": "Welden",
                        "latitude": "48.45505000",
                        "longitude": "10.66086000"
                    },
                    {
                        "id": 30151,
                        "name": "Wemding",
                        "latitude": "48.87461000",
                        "longitude": "10.72452000"
                    },
                    {
                        "id": 30154,
                        "name": "Wendelstein",
                        "latitude": "49.35230000",
                        "longitude": "11.15069000"
                    },
                    {
                        "id": 30161,
                        "name": "Weng",
                        "latitude": "48.65866000",
                        "longitude": "12.36927000"
                    },
                    {
                        "id": 30164,
                        "name": "Wenzenbach",
                        "latitude": "49.07561000",
                        "longitude": "12.19954000"
                    },
                    {
                        "id": 30179,
                        "name": "Wernberg-Köblitz",
                        "latitude": "49.53931000",
                        "longitude": "12.16130000"
                    },
                    {
                        "id": 30181,
                        "name": "Werneck",
                        "latitude": "49.98201000",
                        "longitude": "10.09884000"
                    },
                    {
                        "id": 30187,
                        "name": "Wertach",
                        "latitude": "47.60301000",
                        "longitude": "10.40966000"
                    },
                    {
                        "id": 30190,
                        "name": "Wertingen",
                        "latitude": "48.56314000",
                        "longitude": "10.68149000"
                    },
                    {
                        "id": 30235,
                        "name": "Weßling",
                        "latitude": "48.07452000",
                        "longitude": "11.24820000"
                    },
                    {
                        "id": 30198,
                        "name": "Wessobrunn",
                        "latitude": "47.87407000",
                        "longitude": "11.02461000"
                    },
                    {
                        "id": 30201,
                        "name": "Westendorf",
                        "latitude": "47.93333000",
                        "longitude": "10.71667000"
                    },
                    {
                        "id": 30209,
                        "name": "Westerheim",
                        "latitude": "48.01667000",
                        "longitude": "10.30000000"
                    },
                    {
                        "id": 30220,
                        "name": "Westheim",
                        "latitude": "49.00000000",
                        "longitude": "10.66667000"
                    },
                    {
                        "id": 30229,
                        "name": "Wetzendorf",
                        "latitude": "49.47056000",
                        "longitude": "11.04148000"
                    },
                    {
                        "id": 30232,
                        "name": "Weyarn",
                        "latitude": "47.85838000",
                        "longitude": "11.79923000"
                    },
                    {
                        "id": 30241,
                        "name": "Wiedergeltingen",
                        "latitude": "48.03946000",
                        "longitude": "10.67406000"
                    },
                    {
                        "id": 30253,
                        "name": "Wiesau",
                        "latitude": "49.90817000",
                        "longitude": "12.18889000"
                    },
                    {
                        "id": 30255,
                        "name": "Wiesen",
                        "latitude": "50.11667000",
                        "longitude": "9.36667000"
                    },
                    {
                        "id": 30259,
                        "name": "Wiesenfelden",
                        "latitude": "49.04066000",
                        "longitude": "12.54008000"
                    },
                    {
                        "id": 30261,
                        "name": "Wiesent",
                        "latitude": "49.01667000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 30262,
                        "name": "Wiesenthau",
                        "latitude": "49.71326000",
                        "longitude": "11.13564000"
                    },
                    {
                        "id": 30263,
                        "name": "Wiesentheid",
                        "latitude": "49.79451000",
                        "longitude": "10.34509000"
                    },
                    {
                        "id": 30266,
                        "name": "Wiesthal",
                        "latitude": "50.03333000",
                        "longitude": "9.43333000"
                    },
                    {
                        "id": 30271,
                        "name": "Wiggensbach",
                        "latitude": "47.74781000",
                        "longitude": "10.22987000"
                    },
                    {
                        "id": 30272,
                        "name": "Wilburgstetten",
                        "latitude": "49.02427000",
                        "longitude": "10.39505000"
                    },
                    {
                        "id": 30275,
                        "name": "Wildenberg",
                        "latitude": "48.72981000",
                        "longitude": "11.89845000"
                    },
                    {
                        "id": 30279,
                        "name": "Wildflecken",
                        "latitude": "50.37764000",
                        "longitude": "9.91092000"
                    },
                    {
                        "id": 30280,
                        "name": "Wildpoldsried",
                        "latitude": "47.76667000",
                        "longitude": "10.40000000"
                    },
                    {
                        "id": 30281,
                        "name": "Wildsteig",
                        "latitude": "47.70145000",
                        "longitude": "10.93753000"
                    },
                    {
                        "id": 30284,
                        "name": "Wilhelmsdorf",
                        "latitude": "49.56419000",
                        "longitude": "10.73716000"
                    },
                    {
                        "id": 30289,
                        "name": "Wilhelmsthal",
                        "latitude": "50.31113000",
                        "longitude": "11.37278000"
                    },
                    {
                        "id": 30290,
                        "name": "Wilhermsdorf",
                        "latitude": "49.48308000",
                        "longitude": "10.71555000"
                    },
                    {
                        "id": 30292,
                        "name": "Willanzheim",
                        "latitude": "49.68011000",
                        "longitude": "10.23248000"
                    },
                    {
                        "id": 30297,
                        "name": "Willmering",
                        "latitude": "49.25000000",
                        "longitude": "12.66667000"
                    },
                    {
                        "id": 30310,
                        "name": "Windach",
                        "latitude": "48.06667000",
                        "longitude": "11.03333000"
                    },
                    {
                        "id": 30311,
                        "name": "Windberg",
                        "latitude": "48.94285000",
                        "longitude": "12.74620000"
                    },
                    {
                        "id": 30313,
                        "name": "Windelsbach",
                        "latitude": "49.40000000",
                        "longitude": "10.30000000"
                    },
                    {
                        "id": 30318,
                        "name": "Windischeschenbach",
                        "latitude": "49.80108000",
                        "longitude": "12.15710000"
                    },
                    {
                        "id": 30320,
                        "name": "Windsbach",
                        "latitude": "49.24786000",
                        "longitude": "10.82651000"
                    },
                    {
                        "id": 30323,
                        "name": "Winhöring",
                        "latitude": "48.26667000",
                        "longitude": "12.65000000"
                    },
                    {
                        "id": 30324,
                        "name": "Winkelhaid",
                        "latitude": "49.38963000",
                        "longitude": "11.29888000"
                    },
                    {
                        "id": 30325,
                        "name": "Winklarn",
                        "latitude": "49.42688000",
                        "longitude": "12.47986000"
                    },
                    {
                        "id": 30332,
                        "name": "Winterhausen",
                        "latitude": "49.70683000",
                        "longitude": "10.01661000"
                    },
                    {
                        "id": 30336,
                        "name": "Winzer",
                        "latitude": "48.72285000",
                        "longitude": "13.07751000"
                    },
                    {
                        "id": 30337,
                        "name": "Wipfeld",
                        "latitude": "49.91667000",
                        "longitude": "10.16667000"
                    },
                    {
                        "id": 30343,
                        "name": "Wirsberg",
                        "latitude": "50.10572000",
                        "longitude": "11.60515000"
                    },
                    {
                        "id": 30348,
                        "name": "Wittelshofen",
                        "latitude": "49.06121000",
                        "longitude": "10.48121000"
                    },
                    {
                        "id": 30360,
                        "name": "Wittislingen",
                        "latitude": "48.61917000",
                        "longitude": "10.41722000"
                    },
                    {
                        "id": 30369,
                        "name": "Witzmannsberg",
                        "latitude": "48.62224000",
                        "longitude": "13.49444000"
                    },
                    {
                        "id": 30379,
                        "name": "Wolfersdorf",
                        "latitude": "48.47937000",
                        "longitude": "11.70949000"
                    },
                    {
                        "id": 30380,
                        "name": "Wolferstadt",
                        "latitude": "48.90352000",
                        "longitude": "10.78129000"
                    },
                    {
                        "id": 30381,
                        "name": "Wolfertschwenden",
                        "latitude": "47.89350000",
                        "longitude": "10.26715000"
                    },
                    {
                        "id": 30383,
                        "name": "Wolframs-Eschenbach",
                        "latitude": "49.22675000",
                        "longitude": "10.72769000"
                    },
                    {
                        "id": 30384,
                        "name": "Wolfratshausen",
                        "latitude": "47.91289000",
                        "longitude": "11.42166000"
                    },
                    {
                        "id": 30387,
                        "name": "Wolfsegg",
                        "latitude": "49.10731000",
                        "longitude": "11.97810000"
                    },
                    {
                        "id": 30393,
                        "name": "Wollbach",
                        "latitude": "50.36667000",
                        "longitude": "10.23333000"
                    },
                    {
                        "id": 30396,
                        "name": "Wolnzach",
                        "latitude": "48.60380000",
                        "longitude": "11.62568000"
                    },
                    {
                        "id": 30402,
                        "name": "Wonfurt",
                        "latitude": "50.01667000",
                        "longitude": "10.46667000"
                    },
                    {
                        "id": 30403,
                        "name": "Wonsees",
                        "latitude": "49.97614000",
                        "longitude": "11.30047000"
                    },
                    {
                        "id": 30405,
                        "name": "Woringen",
                        "latitude": "47.91667000",
                        "longitude": "10.20000000"
                    },
                    {
                        "id": 30446,
                        "name": "Wörth",
                        "latitude": "48.24531000",
                        "longitude": "11.90214000"
                    },
                    {
                        "id": 30447,
                        "name": "Wörth am Main",
                        "latitude": "49.79720000",
                        "longitude": "9.15389000"
                    },
                    {
                        "id": 30449,
                        "name": "Wörth an der Donau",
                        "latitude": "49.00093000",
                        "longitude": "12.40539000"
                    },
                    {
                        "id": 30450,
                        "name": "Wörth an der Isar",
                        "latitude": "48.62300000",
                        "longitude": "12.33944000"
                    },
                    {
                        "id": 30451,
                        "name": "Wörthsee",
                        "latitude": "48.07250000",
                        "longitude": "11.20175000"
                    },
                    {
                        "id": 30453,
                        "name": "Wülfershausen",
                        "latitude": "50.33201000",
                        "longitude": "10.34084000"
                    },
                    {
                        "id": 30418,
                        "name": "Wunsiedel",
                        "latitude": "50.03923000",
                        "longitude": "12.00342000"
                    },
                    {
                        "id": 30421,
                        "name": "Wurmannsquick",
                        "latitude": "48.35334000",
                        "longitude": "12.78603000"
                    },
                    {
                        "id": 30424,
                        "name": "Wurmsham",
                        "latitude": "48.35000000",
                        "longitude": "12.33333000"
                    },
                    {
                        "id": 30459,
                        "name": "Würzburg",
                        "latitude": "49.79391000",
                        "longitude": "9.95121000"
                    },
                    {
                        "id": 30464,
                        "name": "Zachenberg",
                        "latitude": "48.96667000",
                        "longitude": "13.00000000"
                    },
                    {
                        "id": 30467,
                        "name": "Zandt",
                        "latitude": "49.15000000",
                        "longitude": "12.73333000"
                    },
                    {
                        "id": 30468,
                        "name": "Zangberg",
                        "latitude": "48.27480000",
                        "longitude": "12.42311000"
                    },
                    {
                        "id": 30469,
                        "name": "Zapfendorf",
                        "latitude": "50.01783000",
                        "longitude": "10.93243000"
                    },
                    {
                        "id": 30476,
                        "name": "Zeil",
                        "latitude": "50.00986000",
                        "longitude": "10.59470000"
                    },
                    {
                        "id": 30477,
                        "name": "Zeilarn",
                        "latitude": "48.30003000",
                        "longitude": "12.84260000"
                    },
                    {
                        "id": 30480,
                        "name": "Zeitlarn",
                        "latitude": "49.07848000",
                        "longitude": "12.11174000"
                    },
                    {
                        "id": 30481,
                        "name": "Zeitlofs",
                        "latitude": "50.26189000",
                        "longitude": "9.67243000"
                    },
                    {
                        "id": 30485,
                        "name": "Zell am Main",
                        "latitude": "49.81214000",
                        "longitude": "9.86962000"
                    },
                    {
                        "id": 30486,
                        "name": "Zell im Fichtelgebirge",
                        "latitude": "50.13532000",
                        "longitude": "11.82266000"
                    },
                    {
                        "id": 30490,
                        "name": "Zellingen",
                        "latitude": "49.89737000",
                        "longitude": "9.81746000"
                    },
                    {
                        "id": 30493,
                        "name": "Zenting",
                        "latitude": "48.79128000",
                        "longitude": "13.25968000"
                    },
                    {
                        "id": 30502,
                        "name": "Ziemetshausen",
                        "latitude": "48.29244000",
                        "longitude": "10.53503000"
                    },
                    {
                        "id": 30504,
                        "name": "Ziertheim",
                        "latitude": "48.65244000",
                        "longitude": "10.39882000"
                    },
                    {
                        "id": 30511,
                        "name": "Zirndorf",
                        "latitude": "49.44240000",
                        "longitude": "10.95414000"
                    },
                    {
                        "id": 30513,
                        "name": "Zolling",
                        "latitude": "48.45000000",
                        "longitude": "11.76667000"
                    },
                    {
                        "id": 30515,
                        "name": "Zorneding",
                        "latitude": "48.08433000",
                        "longitude": "11.82446000"
                    },
                    {
                        "id": 30528,
                        "name": "Zusamaltheim",
                        "latitude": "48.53104000",
                        "longitude": "10.63562000"
                    },
                    {
                        "id": 30529,
                        "name": "Zusmarshausen",
                        "latitude": "48.40014000",
                        "longitude": "10.59917000"
                    },
                    {
                        "id": 30536,
                        "name": "Zwiesel",
                        "latitude": "49.01693000",
                        "longitude": "13.23765000"
                    }
                ]
            },
            {
                "id": 3010,
                "name": "Berlin",
                "iso2": "BE",
                "latitude": "52.52000660",
                "longitude": "13.40495400",
                "type": "land",
                "cities": [
                    {
                        "id": 23490,
                        "name": "Adlershof",
                        "latitude": "52.43548000",
                        "longitude": "13.54825000"
                    },
                    {
                        "id": 23579,
                        "name": "Alt-Hohenschönhausen",
                        "latitude": "52.54608000",
                        "longitude": "13.50130000"
                    },
                    {
                        "id": 23581,
                        "name": "Alt-Treptow",
                        "latitude": "52.48863000",
                        "longitude": "13.45860000"
                    },
                    {
                        "id": 23621,
                        "name": "Altglienicke",
                        "latitude": "52.41116000",
                        "longitude": "13.53550000"
                    },
                    {
                        "id": 23959,
                        "name": "Baumschulenweg",
                        "latitude": "52.46583000",
                        "longitude": "13.48523000"
                    },
                    {
                        "id": 24053,
                        "name": "Berlin",
                        "latitude": "52.52437000",
                        "longitude": "13.41053000"
                    },
                    {
                        "id": 24054,
                        "name": "Berlin Köpenick",
                        "latitude": "52.44254000",
                        "longitude": "13.58228000"
                    },
                    {
                        "id": 24055,
                        "name": "Berlin Treptow",
                        "latitude": "52.49376000",
                        "longitude": "13.44469000"
                    },
                    {
                        "id": 24111,
                        "name": "Biesdorf",
                        "latitude": "52.50906000",
                        "longitude": "13.55340000"
                    },
                    {
                        "id": 24165,
                        "name": "Blankenburg",
                        "latitude": "52.59293000",
                        "longitude": "13.45516000"
                    },
                    {
                        "id": 24167,
                        "name": "Blankenfelde",
                        "latitude": "52.61863000",
                        "longitude": "13.39057000"
                    },
                    {
                        "id": 24217,
                        "name": "Bohnsdorf",
                        "latitude": "52.39434000",
                        "longitude": "13.57339000"
                    },
                    {
                        "id": 24338,
                        "name": "Britz",
                        "latitude": "52.44293000",
                        "longitude": "13.43388000"
                    },
                    {
                        "id": 24379,
                        "name": "Buch",
                        "latitude": "52.63470000",
                        "longitude": "13.49679000"
                    },
                    {
                        "id": 24397,
                        "name": "Buckow",
                        "latitude": "52.43200000",
                        "longitude": "13.46018000"
                    },
                    {
                        "id": 24531,
                        "name": "Charlottenburg",
                        "latitude": "52.51667000",
                        "longitude": "13.28333000"
                    },
                    {
                        "id": 24532,
                        "name": "Charlottenburg-Nord",
                        "latitude": "52.53048000",
                        "longitude": "13.29371000"
                    },
                    {
                        "id": 24578,
                        "name": "Dahlem",
                        "latitude": "52.45810000",
                        "longitude": "13.28702000"
                    },
                    {
                        "id": 25134,
                        "name": "Falkenberg",
                        "latitude": "52.56800000",
                        "longitude": "13.54597000"
                    },
                    {
                        "id": 25136,
                        "name": "Falkenhagener Feld",
                        "latitude": "52.55191000",
                        "longitude": "13.16802000"
                    },
                    {
                        "id": 25163,
                        "name": "Fennpfuhl",
                        "latitude": "52.52921000",
                        "longitude": "13.47267000"
                    },
                    {
                        "id": 25225,
                        "name": "Französisch Buchholz",
                        "latitude": "52.60242000",
                        "longitude": "13.43019000"
                    },
                    {
                        "id": 25274,
                        "name": "Friedenau",
                        "latitude": "52.47133000",
                        "longitude": "13.32813000"
                    },
                    {
                        "id": 25287,
                        "name": "Friedrichsfelde",
                        "latitude": "52.50575000",
                        "longitude": "13.50812000"
                    },
                    {
                        "id": 25289,
                        "name": "Friedrichshagen",
                        "latitude": "52.45052000",
                        "longitude": "13.62463000"
                    },
                    {
                        "id": 25290,
                        "name": "Friedrichshain",
                        "latitude": "52.51559000",
                        "longitude": "13.45482000"
                    },
                    {
                        "id": 25305,
                        "name": "Frohnau",
                        "latitude": "52.63336000",
                        "longitude": "13.29024000"
                    },
                    {
                        "id": 25376,
                        "name": "Gatow",
                        "latitude": "52.48324000",
                        "longitude": "13.18285000"
                    },
                    {
                        "id": 25475,
                        "name": "Gesundbrunnen",
                        "latitude": "52.55035000",
                        "longitude": "13.39139000"
                    },
                    {
                        "id": 25616,
                        "name": "Gropiusstadt",
                        "latitude": "52.42500000",
                        "longitude": "13.46667000"
                    },
                    {
                        "id": 25734,
                        "name": "Grünau",
                        "latitude": "52.41642000",
                        "longitude": "13.58039000"
                    },
                    {
                        "id": 25719,
                        "name": "Grunewald",
                        "latitude": "52.48338000",
                        "longitude": "13.26586000"
                    },
                    {
                        "id": 25841,
                        "name": "Hakenfelde",
                        "latitude": "52.55877000",
                        "longitude": "13.20831000"
                    },
                    {
                        "id": 25848,
                        "name": "Halensee",
                        "latitude": "52.49005000",
                        "longitude": "13.29602000"
                    },
                    {
                        "id": 25892,
                        "name": "Hansaviertel",
                        "latitude": "52.51853000",
                        "longitude": "13.34178000"
                    },
                    {
                        "id": 25926,
                        "name": "Haselhorst",
                        "latitude": "52.54409000",
                        "longitude": "13.23743000"
                    },
                    {
                        "id": 26000,
                        "name": "Heiligensee",
                        "latitude": "52.61449000",
                        "longitude": "13.24501000"
                    },
                    {
                        "id": 26013,
                        "name": "Heinersdorf",
                        "latitude": "52.57173000",
                        "longitude": "13.43757000"
                    },
                    {
                        "id": 26026,
                        "name": "Hellersdorf",
                        "latitude": "52.53319000",
                        "longitude": "13.60880000"
                    },
                    {
                        "id": 26082,
                        "name": "Hermsdorf",
                        "latitude": "52.61421000",
                        "longitude": "13.30587000"
                    },
                    {
                        "id": 26457,
                        "name": "Johannisthal",
                        "latitude": "52.44653000",
                        "longitude": "13.50660000"
                    },
                    {
                        "id": 26517,
                        "name": "Karlshorst",
                        "latitude": "52.48419000",
                        "longitude": "13.53185000"
                    },
                    {
                        "id": 26523,
                        "name": "Karow",
                        "latitude": "52.60904000",
                        "longitude": "13.48117000"
                    },
                    {
                        "id": 26545,
                        "name": "Kaulsdorf",
                        "latitude": "52.51732000",
                        "longitude": "13.58871000"
                    },
                    {
                        "id": 26655,
                        "name": "Kladow",
                        "latitude": "52.45423000",
                        "longitude": "13.14445000"
                    },
                    {
                        "id": 26716,
                        "name": "Konradshöhe",
                        "latitude": "52.58535000",
                        "longitude": "13.22758000"
                    },
                    {
                        "id": 26842,
                        "name": "Köpenick",
                        "latitude": "52.44550000",
                        "longitude": "13.57455000"
                    },
                    {
                        "id": 26756,
                        "name": "Kreuzberg",
                        "latitude": "52.49973000",
                        "longitude": "13.40338000"
                    },
                    {
                        "id": 26948,
                        "name": "Lankwitz",
                        "latitude": "52.43623000",
                        "longitude": "13.34590000"
                    },
                    {
                        "id": 27078,
                        "name": "Lichtenberg",
                        "latitude": "52.51395000",
                        "longitude": "13.49975000"
                    },
                    {
                        "id": 27082,
                        "name": "Lichtenrade",
                        "latitude": "52.39844000",
                        "longitude": "13.40637000"
                    },
                    {
                        "id": 27085,
                        "name": "Lichterfelde",
                        "latitude": "52.43330000",
                        "longitude": "13.30762000"
                    },
                    {
                        "id": 27201,
                        "name": "Lübars",
                        "latitude": "52.61591000",
                        "longitude": "13.35350000"
                    },
                    {
                        "id": 27233,
                        "name": "Mahlsdorf",
                        "latitude": "52.50935000",
                        "longitude": "13.61373000"
                    },
                    {
                        "id": 27274,
                        "name": "Mariendorf",
                        "latitude": "52.43780000",
                        "longitude": "13.38109000"
                    },
                    {
                        "id": 27275,
                        "name": "Marienfelde",
                        "latitude": "52.41868000",
                        "longitude": "13.36723000"
                    },
                    {
                        "id": 27554,
                        "name": "Märkisches Viertel",
                        "latitude": "52.59841000",
                        "longitude": "13.35766000"
                    },
                    {
                        "id": 27334,
                        "name": "Marzahn",
                        "latitude": "52.54525000",
                        "longitude": "13.56983000"
                    },
                    {
                        "id": 27478,
                        "name": "Mitte",
                        "latitude": "52.52003000",
                        "longitude": "13.40489000"
                    },
                    {
                        "id": 27496,
                        "name": "Moabit",
                        "latitude": "52.52635000",
                        "longitude": "13.33903000"
                    },
                    {
                        "id": 27587,
                        "name": "Müggelheim",
                        "latitude": "52.41137000",
                        "longitude": "13.66403000"
                    },
                    {
                        "id": 27693,
                        "name": "Neu-Hohenschönhausen",
                        "latitude": "52.56681000",
                        "longitude": "13.51255000"
                    },
                    {
                        "id": 27765,
                        "name": "Neukölln",
                        "latitude": "52.47719000",
                        "longitude": "13.43126000"
                    },
                    {
                        "id": 27873,
                        "name": "Niederschöneweide",
                        "latitude": "52.45564000",
                        "longitude": "13.51554000"
                    },
                    {
                        "id": 27874,
                        "name": "Niederschönhausen",
                        "latitude": "52.58483000",
                        "longitude": "13.40272000"
                    },
                    {
                        "id": 27899,
                        "name": "Nikolassee",
                        "latitude": "52.43440000",
                        "longitude": "13.20095000"
                    },
                    {
                        "id": 28034,
                        "name": "Oberschöneweide",
                        "latitude": "52.46106000",
                        "longitude": "13.52108000"
                    },
                    {
                        "id": 28216,
                        "name": "Pankow",
                        "latitude": "52.56926000",
                        "longitude": "13.40186000"
                    },
                    {
                        "id": 28330,
                        "name": "Plänterwald",
                        "latitude": "52.48106000",
                        "longitude": "13.47276000"
                    },
                    {
                        "id": 28375,
                        "name": "Prenzlauer Berg",
                        "latitude": "52.53878000",
                        "longitude": "13.42443000"
                    },
                    {
                        "id": 28452,
                        "name": "Rahnsdorf",
                        "latitude": "52.44115000",
                        "longitude": "13.68708000"
                    },
                    {
                        "id": 28562,
                        "name": "Reinickendorf",
                        "latitude": "52.56667000",
                        "longitude": "13.33333000"
                    },
                    {
                        "id": 28710,
                        "name": "Rosenthal",
                        "latitude": "52.59976000",
                        "longitude": "13.37774000"
                    },
                    {
                        "id": 28753,
                        "name": "Rudow",
                        "latitude": "52.42407000",
                        "longitude": "13.48529000"
                    },
                    {
                        "id": 28762,
                        "name": "Rummelsburg",
                        "latitude": "52.50146000",
                        "longitude": "13.49340000"
                    },
                    {
                        "id": 28989,
                        "name": "Schmargendorf",
                        "latitude": "52.47517000",
                        "longitude": "13.29071000"
                    },
                    {
                        "id": 28998,
                        "name": "Schmöckwitz",
                        "latitude": "52.37513000",
                        "longitude": "13.64948000"
                    },
                    {
                        "id": 29116,
                        "name": "Schöneberg",
                        "latitude": "52.46667000",
                        "longitude": "13.35000000"
                    },
                    {
                        "id": 29218,
                        "name": "Siemensstadt",
                        "latitude": "52.54053000",
                        "longitude": "13.26294000"
                    },
                    {
                        "id": 29286,
                        "name": "Spandau",
                        "latitude": "52.55110000",
                        "longitude": "13.19921000"
                    },
                    {
                        "id": 29313,
                        "name": "Staaken",
                        "latitude": "52.53661000",
                        "longitude": "13.15057000"
                    },
                    {
                        "id": 29329,
                        "name": "Stadtrandsiedlung Malchow",
                        "latitude": "52.58295000",
                        "longitude": "13.47811000"
                    },
                    {
                        "id": 29353,
                        "name": "Steglitz",
                        "latitude": "52.45606000",
                        "longitude": "13.33200000"
                    },
                    {
                        "id": 29543,
                        "name": "Tegel",
                        "latitude": "52.57601000",
                        "longitude": "13.29389000"
                    },
                    {
                        "id": 29555,
                        "name": "Tempelhof",
                        "latitude": "52.46667000",
                        "longitude": "13.40000000"
                    },
                    {
                        "id": 29612,
                        "name": "Tiergarten",
                        "latitude": "52.51667000",
                        "longitude": "13.36667000"
                    },
                    {
                        "id": 29926,
                        "name": "Waidmannslust",
                        "latitude": "52.60691000",
                        "longitude": "13.31968000"
                    },
                    {
                        "id": 30008,
                        "name": "Wannsee",
                        "latitude": "52.41915000",
                        "longitude": "13.15531000"
                    },
                    {
                        "id": 30025,
                        "name": "Wartenberg",
                        "latitude": "52.57520000",
                        "longitude": "13.51559000"
                    },
                    {
                        "id": 30048,
                        "name": "Wedding",
                        "latitude": "52.54734000",
                        "longitude": "13.35594000"
                    },
                    {
                        "id": 30134,
                        "name": "Weißensee",
                        "latitude": "52.55632000",
                        "longitude": "13.46649000"
                    },
                    {
                        "id": 30200,
                        "name": "Westend",
                        "latitude": "52.51708000",
                        "longitude": "13.27636000"
                    },
                    {
                        "id": 30287,
                        "name": "Wilhelmsruh",
                        "latitude": "52.58710000",
                        "longitude": "13.36855000"
                    },
                    {
                        "id": 30288,
                        "name": "Wilhelmstadt",
                        "latitude": "52.52462000",
                        "longitude": "13.17707000"
                    },
                    {
                        "id": 30299,
                        "name": "Wilmersdorf",
                        "latitude": "52.48333000",
                        "longitude": "13.31667000"
                    },
                    {
                        "id": 30350,
                        "name": "Wittenau",
                        "latitude": "52.59319000",
                        "longitude": "13.32127000"
                    },
                    {
                        "id": 30475,
                        "name": "Zehlendorf",
                        "latitude": "52.43333000",
                        "longitude": "13.25000000"
                    }
                ]
            },
            {
                "id": 3013,
                "name": "Brandenburg",
                "iso2": "BB",
                "latitude": "52.41252870",
                "longitude": "12.53164440",
                "type": "land",
                "cities": [
                    {
                        "id": 23577,
                        "name": "Alt Tucheband",
                        "latitude": "52.53732000",
                        "longitude": "14.51225000"
                    },
                    {
                        "id": 23585,
                        "name": "Altdöbern",
                        "latitude": "51.65000000",
                        "longitude": "14.03333000"
                    },
                    {
                        "id": 23626,
                        "name": "Altlandsberg",
                        "latitude": "52.56503000",
                        "longitude": "13.72815000"
                    },
                    {
                        "id": 23655,
                        "name": "Angermünde",
                        "latitude": "53.01499000",
                        "longitude": "13.99924000"
                    },
                    {
                        "id": 23764,
                        "name": "Bad Belzig",
                        "latitude": "52.14184000",
                        "longitude": "12.59272000"
                    },
                    {
                        "id": 23798,
                        "name": "Bad Freienwalde",
                        "latitude": "52.78730000",
                        "longitude": "14.03040000"
                    },
                    {
                        "id": 23829,
                        "name": "Bad Liebenwerda",
                        "latitude": "51.51826000",
                        "longitude": "13.39459000"
                    },
                    {
                        "id": 23853,
                        "name": "Bad Saarow",
                        "latitude": "52.28333000",
                        "longitude": "14.06667000"
                    },
                    {
                        "id": 23885,
                        "name": "Bad Wilsnack",
                        "latitude": "52.95607000",
                        "longitude": "11.94903000"
                    },
                    {
                        "id": 23947,
                        "name": "Baruth",
                        "latitude": "52.04468000",
                        "longitude": "13.50270000"
                    },
                    {
                        "id": 23983,
                        "name": "Beelitz",
                        "latitude": "52.23812000",
                        "longitude": "12.97140000"
                    },
                    {
                        "id": 23987,
                        "name": "Beeskow",
                        "latitude": "52.17291000",
                        "longitude": "14.24597000"
                    },
                    {
                        "id": 24017,
                        "name": "Bensdorf",
                        "latitude": "52.41667000",
                        "longitude": "12.33333000"
                    },
                    {
                        "id": 24050,
                        "name": "Berkenbrück",
                        "latitude": "52.35000000",
                        "longitude": "14.15000000"
                    },
                    {
                        "id": 24061,
                        "name": "Bernau bei Berlin",
                        "latitude": "52.67982000",
                        "longitude": "13.58708000"
                    },
                    {
                        "id": 24079,
                        "name": "Bestensee",
                        "latitude": "52.23978000",
                        "longitude": "13.63732000"
                    },
                    {
                        "id": 24112,
                        "name": "Biesenthal",
                        "latitude": "52.76616000",
                        "longitude": "13.64416000"
                    },
                    {
                        "id": 24138,
                        "name": "Birkenwerder",
                        "latitude": "52.68333000",
                        "longitude": "13.28333000"
                    },
                    {
                        "id": 24181,
                        "name": "Bliesdorf",
                        "latitude": "52.69298000",
                        "longitude": "14.15949000"
                    },
                    {
                        "id": 24246,
                        "name": "Borkheide",
                        "latitude": "52.21667000",
                        "longitude": "12.85000000"
                    },
                    {
                        "id": 24248,
                        "name": "Borkwalde",
                        "latitude": "52.25000000",
                        "longitude": "12.83333000"
                    },
                    {
                        "id": 24280,
                        "name": "Brandenburg an der Havel",
                        "latitude": "52.41667000",
                        "longitude": "12.55000000"
                    },
                    {
                        "id": 24293,
                        "name": "Breddin",
                        "latitude": "52.88560000",
                        "longitude": "12.22366000"
                    },
                    {
                        "id": 24297,
                        "name": "Breese",
                        "latitude": "53.00000000",
                        "longitude": "11.80000000"
                    },
                    {
                        "id": 24331,
                        "name": "Brieselang",
                        "latitude": "52.58333000",
                        "longitude": "13.00000000"
                    },
                    {
                        "id": 24332,
                        "name": "Briesen",
                        "latitude": "52.34383000",
                        "longitude": "14.27804000"
                    },
                    {
                        "id": 24333,
                        "name": "Brieskow-Finkenheerd",
                        "latitude": "52.25387000",
                        "longitude": "14.57285000"
                    },
                    {
                        "id": 24337,
                        "name": "Britz",
                        "latitude": "52.88726000",
                        "longitude": "13.81119000"
                    },
                    {
                        "id": 24365,
                        "name": "Brück",
                        "latitude": "52.19766000",
                        "longitude": "12.76868000"
                    },
                    {
                        "id": 24374,
                        "name": "Brüssow",
                        "latitude": "53.39971000",
                        "longitude": "14.12533000"
                    },
                    {
                        "id": 24396,
                        "name": "Buckow",
                        "latitude": "52.56610000",
                        "longitude": "14.07429000"
                    },
                    {
                        "id": 24406,
                        "name": "Burg",
                        "latitude": "51.83448000",
                        "longitude": "14.14856000"
                    },
                    {
                        "id": 24513,
                        "name": "Calau",
                        "latitude": "51.74402000",
                        "longitude": "13.95329000"
                    },
                    {
                        "id": 24525,
                        "name": "Casekow",
                        "latitude": "53.21117000",
                        "longitude": "14.20824000"
                    },
                    {
                        "id": 24535,
                        "name": "Chorin",
                        "latitude": "52.90197000",
                        "longitude": "13.87153000"
                    },
                    {
                        "id": 24556,
                        "name": "Cottbus",
                        "latitude": "51.75769000",
                        "longitude": "14.32888000"
                    },
                    {
                        "id": 24564,
                        "name": "Crinitz",
                        "latitude": "51.73333000",
                        "longitude": "13.76667000"
                    },
                    {
                        "id": 24583,
                        "name": "Dahme",
                        "latitude": "51.87008000",
                        "longitude": "13.42743000"
                    },
                    {
                        "id": 24587,
                        "name": "Dallgow-Döberitz",
                        "latitude": "52.54269000",
                        "longitude": "13.05837000"
                    },
                    {
                        "id": 24713,
                        "name": "Doberlug-Kirchhain",
                        "latitude": "51.62578000",
                        "longitude": "13.56232000"
                    },
                    {
                        "id": 24758,
                        "name": "Drebkau",
                        "latitude": "51.65412000",
                        "longitude": "14.22316000"
                    },
                    {
                        "id": 24759,
                        "name": "Dreetz",
                        "latitude": "52.80297000",
                        "longitude": "12.45961000"
                    },
                    {
                        "id": 24839,
                        "name": "Eberswalde",
                        "latitude": "52.83492000",
                        "longitude": "13.81951000"
                    },
                    {
                        "id": 24907,
                        "name": "Eichwalde",
                        "latitude": "52.36667000",
                        "longitude": "13.61667000"
                    },
                    {
                        "id": 24929,
                        "name": "Eisenhüttenstadt",
                        "latitude": "52.15000000",
                        "longitude": "14.65000000"
                    },
                    {
                        "id": 24972,
                        "name": "Elsterwerda",
                        "latitude": "51.46043000",
                        "longitude": "13.52001000"
                    },
                    {
                        "id": 25049,
                        "name": "Erkner",
                        "latitude": "52.42000000",
                        "longitude": "13.75437000"
                    },
                    {
                        "id": 25133,
                        "name": "Falkenberg",
                        "latitude": "51.58557000",
                        "longitude": "13.24347000"
                    },
                    {
                        "id": 25138,
                        "name": "Falkensee",
                        "latitude": "52.56014000",
                        "longitude": "13.09270000"
                    },
                    {
                        "id": 25149,
                        "name": "Fehrbellin",
                        "latitude": "52.81350000",
                        "longitude": "12.76440000"
                    },
                    {
                        "id": 25169,
                        "name": "Fichtenwalde",
                        "latitude": "52.28038000",
                        "longitude": "12.88349000"
                    },
                    {
                        "id": 25176,
                        "name": "Finsterwalde",
                        "latitude": "51.63388000",
                        "longitude": "13.70662000"
                    },
                    {
                        "id": 25207,
                        "name": "Forst",
                        "latitude": "51.73544000",
                        "longitude": "14.63971000"
                    },
                    {
                        "id": 25221,
                        "name": "Frankfurt (Oder)",
                        "latitude": "52.34714000",
                        "longitude": "14.55062000"
                    },
                    {
                        "id": 25282,
                        "name": "Friedland",
                        "latitude": "52.10493000",
                        "longitude": "14.26399000"
                    },
                    {
                        "id": 25297,
                        "name": "Friesack",
                        "latitude": "52.73764000",
                        "longitude": "12.57969000"
                    },
                    {
                        "id": 25328,
                        "name": "Fürstenberg",
                        "latitude": "53.18427000",
                        "longitude": "13.14442000"
                    },
                    {
                        "id": 25334,
                        "name": "Fürstenwalde",
                        "latitude": "52.36067000",
                        "longitude": "14.06185000"
                    },
                    {
                        "id": 25373,
                        "name": "Gartz",
                        "latitude": "53.20829000",
                        "longitude": "14.39226000"
                    },
                    {
                        "id": 25465,
                        "name": "Gerswalde",
                        "latitude": "53.16988000",
                        "longitude": "13.74853000"
                    },
                    {
                        "id": 25512,
                        "name": "Glienicke",
                        "latitude": "52.63353000",
                        "longitude": "13.32564000"
                    },
                    {
                        "id": 25536,
                        "name": "Golßen",
                        "latitude": "51.97204000",
                        "longitude": "13.60115000"
                    },
                    {
                        "id": 25535,
                        "name": "Golzow",
                        "latitude": "52.27617000",
                        "longitude": "12.60052000"
                    },
                    {
                        "id": 25786,
                        "name": "Görzke",
                        "latitude": "52.17179000",
                        "longitude": "12.37506000"
                    },
                    {
                        "id": 25575,
                        "name": "Gramzow",
                        "latitude": "53.21246000",
                        "longitude": "14.00748000"
                    },
                    {
                        "id": 25577,
                        "name": "Gransee",
                        "latitude": "53.00704000",
                        "longitude": "13.15750000"
                    },
                    {
                        "id": 25730,
                        "name": "Gröden",
                        "latitude": "51.40000000",
                        "longitude": "13.56667000"
                    },
                    {
                        "id": 25627,
                        "name": "Groß Köris",
                        "latitude": "52.16587000",
                        "longitude": "13.65935000"
                    },
                    {
                        "id": 25625,
                        "name": "Groß Kreutz",
                        "latitude": "52.40281000",
                        "longitude": "12.77940000"
                    },
                    {
                        "id": 25629,
                        "name": "Groß Lindow",
                        "latitude": "52.23333000",
                        "longitude": "14.53333000"
                    },
                    {
                        "id": 25634,
                        "name": "Groß Pankow",
                        "latitude": "53.11952000",
                        "longitude": "12.04975000"
                    },
                    {
                        "id": 25653,
                        "name": "Großbeeren",
                        "latitude": "52.35862000",
                        "longitude": "13.30994000"
                    },
                    {
                        "id": 25684,
                        "name": "Großkmehlen",
                        "latitude": "51.37901000",
                        "longitude": "13.72501000"
                    },
                    {
                        "id": 25703,
                        "name": "Großräschen",
                        "latitude": "51.58760000",
                        "longitude": "14.01093000"
                    },
                    {
                        "id": 25710,
                        "name": "Großthiemig",
                        "latitude": "51.38333000",
                        "longitude": "13.66667000"
                    },
                    {
                        "id": 25714,
                        "name": "Großwoltersdorf",
                        "latitude": "53.06667000",
                        "longitude": "13.10000000"
                    },
                    {
                        "id": 25741,
                        "name": "Grünheide",
                        "latitude": "52.42343000",
                        "longitude": "13.81324000"
                    },
                    {
                        "id": 25748,
                        "name": "Guben",
                        "latitude": "51.94987000",
                        "longitude": "14.71447000"
                    },
                    {
                        "id": 25753,
                        "name": "Gumtow",
                        "latitude": "52.98333000",
                        "longitude": "12.25000000"
                    },
                    {
                        "id": 25842,
                        "name": "Halbe",
                        "latitude": "52.11667000",
                        "longitude": "13.70000000"
                    },
                    {
                        "id": 25996,
                        "name": "Heiligengrabe",
                        "latitude": "53.14461000",
                        "longitude": "12.36254000"
                    },
                    {
                        "id": 26051,
                        "name": "Hennigsdorf",
                        "latitude": "52.63598000",
                        "longitude": "13.20419000"
                    },
                    {
                        "id": 26098,
                        "name": "Herzberg",
                        "latitude": "51.68692000",
                        "longitude": "13.22016000"
                    },
                    {
                        "id": 26166,
                        "name": "Hirschfeld",
                        "latitude": "51.38333000",
                        "longitude": "13.61667000"
                    },
                    {
                        "id": 26195,
                        "name": "Hohen Neuendorf",
                        "latitude": "52.67631000",
                        "longitude": "13.27775000"
                    },
                    {
                        "id": 26199,
                        "name": "Hohenbocka",
                        "latitude": "51.43099000",
                        "longitude": "14.00982000"
                    },
                    {
                        "id": 26208,
                        "name": "Hohenleipisch",
                        "latitude": "51.50000000",
                        "longitude": "13.55000000"
                    },
                    {
                        "id": 26424,
                        "name": "Jacobsdorf",
                        "latitude": "52.33333000",
                        "longitude": "14.35000000"
                    },
                    {
                        "id": 26464,
                        "name": "Jänschwalde",
                        "latitude": "51.86066000",
                        "longitude": "14.49813000"
                    },
                    {
                        "id": 26452,
                        "name": "Joachimsthal",
                        "latitude": "52.97945000",
                        "longitude": "13.74493000"
                    },
                    {
                        "id": 26476,
                        "name": "Jüterbog",
                        "latitude": "51.99607000",
                        "longitude": "13.07979000"
                    },
                    {
                        "id": 26526,
                        "name": "Karstädt",
                        "latitude": "53.16215000",
                        "longitude": "11.74242000"
                    },
                    {
                        "id": 26579,
                        "name": "Ketzin",
                        "latitude": "52.47809000",
                        "longitude": "12.84530000"
                    },
                    {
                        "id": 26675,
                        "name": "Kleinmachnow",
                        "latitude": "52.40786000",
                        "longitude": "13.22514000"
                    },
                    {
                        "id": 26693,
                        "name": "Kloster Lehnin",
                        "latitude": "52.32039000",
                        "longitude": "12.74320000"
                    },
                    {
                        "id": 26713,
                        "name": "Kolkwitz",
                        "latitude": "51.75000000",
                        "longitude": "14.25000000"
                    },
                    {
                        "id": 26822,
                        "name": "Königs Wusterhausen",
                        "latitude": "52.30141000",
                        "longitude": "13.63300000"
                    },
                    {
                        "id": 26749,
                        "name": "Kremmen",
                        "latitude": "52.76216000",
                        "longitude": "13.02515000"
                    },
                    {
                        "id": 26811,
                        "name": "Kyritz",
                        "latitude": "52.94212000",
                        "longitude": "12.39704000"
                    },
                    {
                        "id": 26959,
                        "name": "Lauchhammer",
                        "latitude": "51.48813000",
                        "longitude": "13.76623000"
                    },
                    {
                        "id": 26995,
                        "name": "Lebus",
                        "latitude": "52.42719000",
                        "longitude": "14.53235000"
                    },
                    {
                        "id": 26998,
                        "name": "Leegebruch",
                        "latitude": "52.72340000",
                        "longitude": "13.19304000"
                    },
                    {
                        "id": 27050,
                        "name": "Lenzen",
                        "latitude": "53.09176000",
                        "longitude": "11.47453000"
                    },
                    {
                        "id": 27055,
                        "name": "Letschin",
                        "latitude": "52.64379000",
                        "longitude": "14.36007000"
                    },
                    {
                        "id": 27089,
                        "name": "Liebenwalde",
                        "latitude": "52.87125000",
                        "longitude": "13.39465000"
                    },
                    {
                        "id": 27090,
                        "name": "Lieberose",
                        "latitude": "51.98491000",
                        "longitude": "14.29987000"
                    },
                    {
                        "id": 27112,
                        "name": "Lindow",
                        "latitude": "52.96689000",
                        "longitude": "12.98498000"
                    },
                    {
                        "id": 27203,
                        "name": "Lübben",
                        "latitude": "51.93814000",
                        "longitude": "13.88826000"
                    },
                    {
                        "id": 27204,
                        "name": "Lübbenau",
                        "latitude": "51.86217000",
                        "longitude": "13.95168000"
                    },
                    {
                        "id": 27160,
                        "name": "Luckau",
                        "latitude": "51.85245000",
                        "longitude": "13.70735000"
                    },
                    {
                        "id": 27161,
                        "name": "Luckenwalde",
                        "latitude": "52.09029000",
                        "longitude": "13.16772000"
                    },
                    {
                        "id": 27164,
                        "name": "Ludwigsfelde",
                        "latitude": "52.30322000",
                        "longitude": "13.25405000"
                    },
                    {
                        "id": 27182,
                        "name": "Lychen",
                        "latitude": "53.21242000",
                        "longitude": "13.31483000"
                    },
                    {
                        "id": 27266,
                        "name": "Manschnow",
                        "latitude": "52.54990000",
                        "longitude": "14.55332000"
                    },
                    {
                        "id": 27281,
                        "name": "Marienwerder",
                        "latitude": "52.84208000",
                        "longitude": "13.59927000"
                    },
                    {
                        "id": 27391,
                        "name": "Melchow",
                        "latitude": "52.77613000",
                        "longitude": "13.70647000"
                    },
                    {
                        "id": 27448,
                        "name": "Meyenburg",
                        "latitude": "53.04524000",
                        "longitude": "14.23691000"
                    },
                    {
                        "id": 27456,
                        "name": "Michendorf",
                        "latitude": "52.31352000",
                        "longitude": "13.02996000"
                    },
                    {
                        "id": 27467,
                        "name": "Milmersdorf",
                        "latitude": "53.11185000",
                        "longitude": "13.64150000"
                    },
                    {
                        "id": 27489,
                        "name": "Mittenwalde",
                        "latitude": "52.26007000",
                        "longitude": "13.53945000"
                    },
                    {
                        "id": 27495,
                        "name": "Mixdorf",
                        "latitude": "52.20000000",
                        "longitude": "14.40000000"
                    },
                    {
                        "id": 27592,
                        "name": "Mühlberg",
                        "latitude": "51.43453000",
                        "longitude": "13.22177000"
                    },
                    {
                        "id": 27607,
                        "name": "Müllrose",
                        "latitude": "52.24736000",
                        "longitude": "14.41794000"
                    },
                    {
                        "id": 27610,
                        "name": "Müncheberg",
                        "latitude": "52.50704000",
                        "longitude": "14.13716000"
                    },
                    {
                        "id": 27647,
                        "name": "Nauen",
                        "latitude": "52.60701000",
                        "longitude": "12.87374000"
                    },
                    {
                        "id": 27673,
                        "name": "Nennhausen",
                        "latitude": "52.60000000",
                        "longitude": "12.50000000"
                    },
                    {
                        "id": 27691,
                        "name": "Neu Zauche",
                        "latitude": "51.92757000",
                        "longitude": "14.08812000"
                    },
                    {
                        "id": 27720,
                        "name": "Neuenhagen",
                        "latitude": "52.52985000",
                        "longitude": "13.68914000"
                    },
                    {
                        "id": 27737,
                        "name": "Neuhardenberg",
                        "latitude": "52.59601000",
                        "longitude": "14.23768000"
                    },
                    {
                        "id": 27767,
                        "name": "Neulewin",
                        "latitude": "52.72434000",
                        "longitude": "14.27922000"
                    },
                    {
                        "id": 27787,
                        "name": "Neuruppin",
                        "latitude": "52.92815000",
                        "longitude": "12.80311000"
                    },
                    {
                        "id": 27812,
                        "name": "Neutrebbin",
                        "latitude": "52.66482000",
                        "longitude": "14.22802000"
                    },
                    {
                        "id": 27816,
                        "name": "Neuzelle",
                        "latitude": "52.09016000",
                        "longitude": "14.64804000"
                    },
                    {
                        "id": 27849,
                        "name": "Niedergörsdorf",
                        "latitude": "51.97943000",
                        "longitude": "12.98541000"
                    },
                    {
                        "id": 27891,
                        "name": "Niemegk",
                        "latitude": "52.07388000",
                        "longitude": "12.68947000"
                    },
                    {
                        "id": 28070,
                        "name": "Oderberg",
                        "latitude": "52.86571000",
                        "longitude": "14.04508000"
                    },
                    {
                        "id": 28124,
                        "name": "Oranienburg",
                        "latitude": "52.75577000",
                        "longitude": "13.24197000"
                    },
                    {
                        "id": 28133,
                        "name": "Ortrand",
                        "latitude": "51.37505000",
                        "longitude": "13.75982000"
                    },
                    {
                        "id": 28235,
                        "name": "Paulinenaue",
                        "latitude": "52.67701000",
                        "longitude": "12.71067000"
                    },
                    {
                        "id": 28244,
                        "name": "Peitz",
                        "latitude": "51.85841000",
                        "longitude": "14.41138000"
                    },
                    {
                        "id": 28260,
                        "name": "Perleberg",
                        "latitude": "53.07583000",
                        "longitude": "11.85739000"
                    },
                    {
                        "id": 28265,
                        "name": "Petershagen",
                        "latitude": "52.52078000",
                        "longitude": "13.78748000"
                    },
                    {
                        "id": 28315,
                        "name": "Plattenburg",
                        "latitude": "52.95919000",
                        "longitude": "12.02951000"
                    },
                    {
                        "id": 28323,
                        "name": "Plessa",
                        "latitude": "51.46667000",
                        "longitude": "13.61667000"
                    },
                    {
                        "id": 28339,
                        "name": "Podelzig",
                        "latitude": "52.47175000",
                        "longitude": "14.53465000"
                    },
                    {
                        "id": 28362,
                        "name": "Potsdam",
                        "latitude": "52.39886000",
                        "longitude": "13.06566000"
                    },
                    {
                        "id": 28373,
                        "name": "Premnitz",
                        "latitude": "52.53184000",
                        "longitude": "12.34845000"
                    },
                    {
                        "id": 28374,
                        "name": "Prenzlau",
                        "latitude": "53.31625000",
                        "longitude": "13.86261000"
                    },
                    {
                        "id": 28392,
                        "name": "Pritzwalk",
                        "latitude": "53.14945000",
                        "longitude": "12.17405000"
                    },
                    {
                        "id": 28399,
                        "name": "Prötzel",
                        "latitude": "52.63723000",
                        "longitude": "13.98783000"
                    },
                    {
                        "id": 28409,
                        "name": "Putlitz",
                        "latitude": "53.24899000",
                        "longitude": "12.04179000"
                    },
                    {
                        "id": 28471,
                        "name": "Rangsdorf",
                        "latitude": "52.29126000",
                        "longitude": "13.41946000"
                    },
                    {
                        "id": 28485,
                        "name": "Rathenow",
                        "latitude": "52.60659000",
                        "longitude": "12.33696000"
                    },
                    {
                        "id": 28494,
                        "name": "Rauen",
                        "latitude": "52.33227000",
                        "longitude": "14.02797000"
                    },
                    {
                        "id": 28532,
                        "name": "Rehfelde",
                        "latitude": "52.53417000",
                        "longitude": "13.90884000"
                    },
                    {
                        "id": 28546,
                        "name": "Reichenwalde",
                        "latitude": "52.26667000",
                        "longitude": "14.00000000"
                    },
                    {
                        "id": 28612,
                        "name": "Rheinsberg",
                        "latitude": "53.09972000",
                        "longitude": "12.89885000"
                    },
                    {
                        "id": 28617,
                        "name": "Rhinow",
                        "latitude": "52.75094000",
                        "longitude": "12.34194000"
                    },
                    {
                        "id": 28654,
                        "name": "Rietz Neuendorf",
                        "latitude": "52.22758000",
                        "longitude": "14.17463000"
                    },
                    {
                        "id": 28712,
                        "name": "Roskow",
                        "latitude": "52.47237000",
                        "longitude": "12.71886000"
                    },
                    {
                        "id": 28799,
                        "name": "Rückersdorf",
                        "latitude": "51.56955000",
                        "longitude": "13.57226000"
                    },
                    {
                        "id": 28802,
                        "name": "Rüdnitz",
                        "latitude": "52.72137000",
                        "longitude": "13.62502000"
                    },
                    {
                        "id": 28756,
                        "name": "Ruhland",
                        "latitude": "51.45755000",
                        "longitude": "13.86643000"
                    },
                    {
                        "id": 28835,
                        "name": "Sallgast",
                        "latitude": "51.58870000",
                        "longitude": "13.84861000"
                    },
                    {
                        "id": 28929,
                        "name": "Schenkendöbern",
                        "latitude": "51.95723000",
                        "longitude": "14.63541000"
                    },
                    {
                        "id": 28951,
                        "name": "Schipkau",
                        "latitude": "51.51766000",
                        "longitude": "13.89738000"
                    },
                    {
                        "id": 28975,
                        "name": "Schlieben",
                        "latitude": "51.72379000",
                        "longitude": "13.38304000"
                    },
                    {
                        "id": 29113,
                        "name": "Schönborn",
                        "latitude": "51.60016000",
                        "longitude": "13.48967000"
                    },
                    {
                        "id": 29119,
                        "name": "Schönefeld",
                        "latitude": "52.38897000",
                        "longitude": "13.50374000"
                    },
                    {
                        "id": 29120,
                        "name": "Schöneiche",
                        "latitude": "52.47286000",
                        "longitude": "13.69226000"
                    },
                    {
                        "id": 29122,
                        "name": "Schönewalde",
                        "latitude": "51.67901000",
                        "longitude": "13.60247000"
                    },
                    {
                        "id": 29035,
                        "name": "Schulzendorf",
                        "latitude": "52.35818000",
                        "longitude": "13.59842000"
                    },
                    {
                        "id": 29074,
                        "name": "Schwarzheide",
                        "latitude": "51.47671000",
                        "longitude": "13.85559000"
                    },
                    {
                        "id": 29078,
                        "name": "Schwedt (Oder)",
                        "latitude": "53.05963000",
                        "longitude": "14.28154000"
                    },
                    {
                        "id": 29160,
                        "name": "Seelow",
                        "latitude": "52.53392000",
                        "longitude": "14.38128000"
                    },
                    {
                        "id": 29191,
                        "name": "Senftenberg",
                        "latitude": "51.52517000",
                        "longitude": "14.00164000"
                    },
                    {
                        "id": 29274,
                        "name": "Sonnewalde",
                        "latitude": "51.69223000",
                        "longitude": "13.64730000"
                    },
                    {
                        "id": 29297,
                        "name": "Sperenberg",
                        "latitude": "52.14113000",
                        "longitude": "13.36500000"
                    },
                    {
                        "id": 29307,
                        "name": "Spreenhagen",
                        "latitude": "52.34325000",
                        "longitude": "13.87663000"
                    },
                    {
                        "id": 29333,
                        "name": "Stahnsdorf",
                        "latitude": "52.38333000",
                        "longitude": "13.21667000"
                    },
                    {
                        "id": 29384,
                        "name": "Steinhöfel",
                        "latitude": "52.40000000",
                        "longitude": "14.16667000"
                    },
                    {
                        "id": 29421,
                        "name": "Storkow",
                        "latitude": "52.25662000",
                        "longitude": "13.93337000"
                    },
                    {
                        "id": 29429,
                        "name": "Straupitz",
                        "latitude": "51.91357000",
                        "longitude": "14.12275000"
                    },
                    {
                        "id": 29430,
                        "name": "Strausberg",
                        "latitude": "52.57859000",
                        "longitude": "13.88741000"
                    },
                    {
                        "id": 29535,
                        "name": "Tauche",
                        "latitude": "52.15000000",
                        "longitude": "14.16667000"
                    },
                    {
                        "id": 29554,
                        "name": "Teltow",
                        "latitude": "52.40310000",
                        "longitude": "13.26014000"
                    },
                    {
                        "id": 29556,
                        "name": "Templin",
                        "latitude": "53.11865000",
                        "longitude": "13.50220000"
                    },
                    {
                        "id": 29571,
                        "name": "Teupitz",
                        "latitude": "52.12967000",
                        "longitude": "13.61960000"
                    },
                    {
                        "id": 29648,
                        "name": "Trebbin",
                        "latitude": "52.21675000",
                        "longitude": "13.22496000"
                    },
                    {
                        "id": 29663,
                        "name": "Treuenbrietzen",
                        "latitude": "52.09754000",
                        "longitude": "12.87258000"
                    },
                    {
                        "id": 29687,
                        "name": "Tschernitz",
                        "latitude": "51.58333000",
                        "longitude": "14.61667000"
                    },
                    {
                        "id": 29718,
                        "name": "Uebigau",
                        "latitude": "51.59415000",
                        "longitude": "13.29983000"
                    },
                    {
                        "id": 29831,
                        "name": "Velten",
                        "latitude": "52.69149000",
                        "longitude": "13.17533000"
                    },
                    {
                        "id": 29839,
                        "name": "Vetschau",
                        "latitude": "51.78638000",
                        "longitude": "14.07941000"
                    },
                    {
                        "id": 29964,
                        "name": "Waldsieversdorf",
                        "latitude": "52.54221000",
                        "longitude": "14.07022000"
                    },
                    {
                        "id": 29999,
                        "name": "Wandlitz",
                        "latitude": "52.74196000",
                        "longitude": "13.45799000"
                    },
                    {
                        "id": 30107,
                        "name": "Weisen",
                        "latitude": "53.02518000",
                        "longitude": "11.78710000"
                    },
                    {
                        "id": 30150,
                        "name": "Welzow",
                        "latitude": "51.58381000",
                        "longitude": "14.17082000"
                    },
                    {
                        "id": 30157,
                        "name": "Wendisch Rietz",
                        "latitude": "52.21613000",
                        "longitude": "14.00845000"
                    },
                    {
                        "id": 30167,
                        "name": "Werben",
                        "latitude": "51.81667000",
                        "longitude": "14.18333000"
                    },
                    {
                        "id": 30170,
                        "name": "Werder",
                        "latitude": "52.37874000",
                        "longitude": "12.93400000"
                    },
                    {
                        "id": 30173,
                        "name": "Werftpfuhl",
                        "latitude": "52.66014000",
                        "longitude": "13.79351000"
                    },
                    {
                        "id": 30183,
                        "name": "Werneuchen",
                        "latitude": "52.63275000",
                        "longitude": "13.73437000"
                    },
                    {
                        "id": 30256,
                        "name": "Wiesenau",
                        "latitude": "52.23071000",
                        "longitude": "14.59107000"
                    },
                    {
                        "id": 30258,
                        "name": "Wiesenburg",
                        "latitude": "52.11456000",
                        "longitude": "12.45534000"
                    },
                    {
                        "id": 30352,
                        "name": "Wittenberge",
                        "latitude": "53.00543000",
                        "longitude": "11.75032000"
                    },
                    {
                        "id": 30366,
                        "name": "Wittstock",
                        "latitude": "53.16118000",
                        "longitude": "12.48287000"
                    },
                    {
                        "id": 30400,
                        "name": "Woltersdorf",
                        "latitude": "52.45554000",
                        "longitude": "13.74986000"
                    },
                    {
                        "id": 30411,
                        "name": "Wriezen",
                        "latitude": "52.72091000",
                        "longitude": "14.13425000"
                    },
                    {
                        "id": 30427,
                        "name": "Wusterhausen",
                        "latitude": "52.89120000",
                        "longitude": "12.46021000"
                    },
                    {
                        "id": 30429,
                        "name": "Wustermark",
                        "latitude": "52.55000000",
                        "longitude": "12.95000000"
                    },
                    {
                        "id": 30430,
                        "name": "Wusterwitz",
                        "latitude": "52.36666000",
                        "longitude": "12.38488000"
                    },
                    {
                        "id": 30474,
                        "name": "Zehdenick",
                        "latitude": "52.97852000",
                        "longitude": "13.33165000"
                    },
                    {
                        "id": 30499,
                        "name": "Zeuthen",
                        "latitude": "52.34803000",
                        "longitude": "13.62174000"
                    },
                    {
                        "id": 30505,
                        "name": "Ziesar",
                        "latitude": "52.26616000",
                        "longitude": "12.28997000"
                    },
                    {
                        "id": 30507,
                        "name": "Ziltendorf",
                        "latitude": "52.20608000",
                        "longitude": "14.62411000"
                    },
                    {
                        "id": 30517,
                        "name": "Zossen",
                        "latitude": "52.21600000",
                        "longitude": "13.44909000"
                    }
                ]
            },
            {
                "id": 3014,
                "name": "Bremen",
                "iso2": "HB",
                "latitude": "53.07929620",
                "longitude": "8.80169360",
                "type": "land",
                "cities": [
                    {
                        "id": 24320,
                        "name": "Bremen",
                        "latitude": "53.07516000",
                        "longitude": "8.80777000"
                    },
                    {
                        "id": 24321,
                        "name": "Bremerhaven",
                        "latitude": "53.55021000",
                        "longitude": "8.57673000"
                    },
                    {
                        "id": 24426,
                        "name": "Burglesum",
                        "latitude": "53.16532000",
                        "longitude": "8.68873000"
                    },
                    {
                        "id": 29819,
                        "name": "Vegesack",
                        "latitude": "53.16667000",
                        "longitude": "8.61667000"
                    }
                ]
            },
            {
                "id": 3016,
                "name": "Hamburg",
                "iso2": "HH",
                "latitude": "53.55108460",
                "longitude": "9.99368190",
                "type": "land",
                "cities": [
                    {
                        "id": 23574,
                        "name": "Alsterdorf",
                        "latitude": "53.61083000",
                        "longitude": "10.01306000"
                    },
                    {
                        "id": 23631,
                        "name": "Altona",
                        "latitude": "53.55000000",
                        "longitude": "9.93333000"
                    },
                    {
                        "id": 23936,
                        "name": "Barmbek-Nord",
                        "latitude": "53.60520000",
                        "longitude": "10.03988000"
                    },
                    {
                        "id": 24032,
                        "name": "Bergedorf",
                        "latitude": "53.48462000",
                        "longitude": "10.22904000"
                    },
                    {
                        "id": 24047,
                        "name": "Bergstedt",
                        "latitude": "53.67111000",
                        "longitude": "10.12694000"
                    },
                    {
                        "id": 24241,
                        "name": "Borgfelde",
                        "latitude": "53.55475000",
                        "longitude": "10.03447000"
                    },
                    {
                        "id": 24788,
                        "name": "Duvenstedt",
                        "latitude": "53.70806000",
                        "longitude": "10.10444000"
                    },
                    {
                        "id": 24910,
                        "name": "Eidelstedt",
                        "latitude": "53.60697000",
                        "longitude": "9.90538000"
                    },
                    {
                        "id": 24919,
                        "name": "Eimsbüttel",
                        "latitude": "53.57416000",
                        "longitude": "9.95679000"
                    },
                    {
                        "id": 25143,
                        "name": "Farmsen-Berne",
                        "latitude": "53.60639000",
                        "longitude": "10.11972000"
                    },
                    {
                        "id": 25314,
                        "name": "Fuhlsbüttel",
                        "latitude": "53.63459000",
                        "longitude": "10.01608000"
                    },
                    {
                        "id": 25866,
                        "name": "Hamburg",
                        "latitude": "53.57532000",
                        "longitude": "10.01534000"
                    },
                    {
                        "id": 25867,
                        "name": "Hamburg-Altstadt",
                        "latitude": "53.55000000",
                        "longitude": "10.00000000"
                    },
                    {
                        "id": 25868,
                        "name": "Hamburg-Mitte",
                        "latitude": "53.55000000",
                        "longitude": "10.01667000"
                    },
                    {
                        "id": 25869,
                        "name": "Hamburg-Nord",
                        "latitude": "53.58935000",
                        "longitude": "9.98400000"
                    },
                    {
                        "id": 25877,
                        "name": "Hammerbrook",
                        "latitude": "53.54527000",
                        "longitude": "10.03042000"
                    },
                    {
                        "id": 25897,
                        "name": "Harburg",
                        "latitude": "53.46057000",
                        "longitude": "9.98388000"
                    },
                    {
                        "id": 26284,
                        "name": "Hummelsbüttel",
                        "latitude": "53.64773000",
                        "longitude": "10.04149000"
                    },
                    {
                        "id": 26670,
                        "name": "Kleiner Grasbrook",
                        "latitude": "53.53111000",
                        "longitude": "9.99361000"
                    },
                    {
                        "id": 26922,
                        "name": "Langenhorn",
                        "latitude": "53.66667000",
                        "longitude": "10.01667000"
                    },
                    {
                        "id": 27036,
                        "name": "Lemsahl-Mellingstedt",
                        "latitude": "53.68998000",
                        "longitude": "10.09648000"
                    },
                    {
                        "id": 27178,
                        "name": "Lurup",
                        "latitude": "53.59266000",
                        "longitude": "9.87697000"
                    },
                    {
                        "id": 27280,
                        "name": "Marienthal",
                        "latitude": "53.56667000",
                        "longitude": "10.08333000"
                    },
                    {
                        "id": 27793,
                        "name": "Neustadt",
                        "latitude": "53.55196000",
                        "longitude": "9.98558000"
                    },
                    {
                        "id": 28098,
                        "name": "Ohlsdorf",
                        "latitude": "53.62594000",
                        "longitude": "10.03145000"
                    },
                    {
                        "id": 28181,
                        "name": "Ottensen",
                        "latitude": "53.55000000",
                        "longitude": "9.91667000"
                    },
                    {
                        "id": 28351,
                        "name": "Poppenbüttel",
                        "latitude": "53.65917000",
                        "longitude": "10.08472000"
                    },
                    {
                        "id": 28726,
                        "name": "Rothenburgsort",
                        "latitude": "53.53500000",
                        "longitude": "10.04082000"
                    },
                    {
                        "id": 28888,
                        "name": "Sasel",
                        "latitude": "53.65385000",
                        "longitude": "10.11184000"
                    },
                    {
                        "id": 29311,
                        "name": "St. Georg",
                        "latitude": "53.55513000",
                        "longitude": "10.01231000"
                    },
                    {
                        "id": 29312,
                        "name": "St. Pauli",
                        "latitude": "53.55700000",
                        "longitude": "9.96400000"
                    },
                    {
                        "id": 29354,
                        "name": "Steilshoop",
                        "latitude": "53.61028000",
                        "longitude": "10.05917000"
                    },
                    {
                        "id": 29396,
                        "name": "Stellingen",
                        "latitude": "53.59220000",
                        "longitude": "9.92870000"
                    },
                    {
                        "id": 30000,
                        "name": "Wandsbek",
                        "latitude": "53.58334000",
                        "longitude": "10.08305000"
                    },
                    {
                        "id": 30145,
                        "name": "Wellingsbüttel",
                        "latitude": "53.64104000",
                        "longitude": "10.07980000"
                    },
                    {
                        "id": 30333,
                        "name": "Winterhude",
                        "latitude": "53.60000000",
                        "longitude": "10.00000000"
                    },
                    {
                        "id": 30370,
                        "name": "Wohldorf-Ohlstedt",
                        "latitude": "53.69282000",
                        "longitude": "10.13117000"
                    }
                ]
            },
            {
                "id": 3018,
                "name": "Hessen",
                "iso2": "HE",
                "latitude": "50.65205150",
                "longitude": "9.16243760",
                "type": "land",
                "cities": [
                    {
                        "id": 23540,
                        "name": "Albshausen",
                        "latitude": "50.54431000",
                        "longitude": "8.43784000"
                    },
                    {
                        "id": 23554,
                        "name": "Alheim",
                        "latitude": "51.03333000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 23555,
                        "name": "Allendorf",
                        "latitude": "51.02995000",
                        "longitude": "8.67232000"
                    },
                    {
                        "id": 23556,
                        "name": "Allendorf an der Lahn",
                        "latitude": "50.55109000",
                        "longitude": "8.62008000"
                    },
                    {
                        "id": 23567,
                        "name": "Alsbach-Hähnlein",
                        "latitude": "49.73861000",
                        "longitude": "8.59583000"
                    },
                    {
                        "id": 23571,
                        "name": "Alsfeld",
                        "latitude": "50.75185000",
                        "longitude": "9.27082000"
                    },
                    {
                        "id": 23588,
                        "name": "Alten Buseck",
                        "latitude": "50.62218000",
                        "longitude": "8.75322000"
                    },
                    {
                        "id": 23613,
                        "name": "Altenstadt",
                        "latitude": "50.28747000",
                        "longitude": "8.94373000"
                    },
                    {
                        "id": 23652,
                        "name": "Amöneburg",
                        "latitude": "50.79595000",
                        "longitude": "8.92330000"
                    },
                    {
                        "id": 23748,
                        "name": "Aßlar",
                        "latitude": "50.59163000",
                        "longitude": "8.46273000"
                    },
                    {
                        "id": 23753,
                        "name": "Babenhausen",
                        "latitude": "49.96519000",
                        "longitude": "8.95129000"
                    },
                    {
                        "id": 23762,
                        "name": "Bad Arolsen",
                        "latitude": "51.37982000",
                        "longitude": "9.01445000"
                    },
                    {
                        "id": 23780,
                        "name": "Bad Camberg",
                        "latitude": "50.29695000",
                        "longitude": "8.26896000"
                    },
                    {
                        "id": 23791,
                        "name": "Bad Endbach",
                        "latitude": "50.75000000",
                        "longitude": "8.50000000"
                    },
                    {
                        "id": 23806,
                        "name": "Bad Hersfeld",
                        "latitude": "50.87197000",
                        "longitude": "9.70891000"
                    },
                    {
                        "id": 23808,
                        "name": "Bad Homburg vor der Höhe",
                        "latitude": "50.22683000",
                        "longitude": "8.61816000"
                    },
                    {
                        "id": 23812,
                        "name": "Bad Karlshafen",
                        "latitude": "51.64263000",
                        "longitude": "9.45477000"
                    },
                    {
                        "id": 23818,
                        "name": "Bad König",
                        "latitude": "49.74320000",
                        "longitude": "9.00750000"
                    },
                    {
                        "id": 23840,
                        "name": "Bad Nauheim",
                        "latitude": "50.36463000",
                        "longitude": "8.73859000"
                    },
                    {
                        "id": 23846,
                        "name": "Bad Orb",
                        "latitude": "50.22788000",
                        "longitude": "9.34782000"
                    },
                    {
                        "id": 23856,
                        "name": "Bad Salzschlirf",
                        "latitude": "50.62388000",
                        "longitude": "9.50815000"
                    },
                    {
                        "id": 23864,
                        "name": "Bad Schwalbach",
                        "latitude": "50.14196000",
                        "longitude": "8.06964000"
                    },
                    {
                        "id": 23867,
                        "name": "Bad Soden am Taunus",
                        "latitude": "50.14080000",
                        "longitude": "8.50449000"
                    },
                    {
                        "id": 23868,
                        "name": "Bad Soden-Salmünster",
                        "latitude": "50.27574000",
                        "longitude": "9.36705000"
                    },
                    {
                        "id": 23869,
                        "name": "Bad Sooden-Allendorf",
                        "latitude": "51.27092000",
                        "longitude": "9.97483000"
                    },
                    {
                        "id": 23880,
                        "name": "Bad Vilbel",
                        "latitude": "50.17866000",
                        "longitude": "8.73756000"
                    },
                    {
                        "id": 23884,
                        "name": "Bad Wildungen",
                        "latitude": "51.11963000",
                        "longitude": "9.12475000"
                    },
                    {
                        "id": 23956,
                        "name": "Battenberg",
                        "latitude": "51.01391000",
                        "longitude": "8.64603000"
                    },
                    {
                        "id": 23961,
                        "name": "Baunatal",
                        "latitude": "51.25182000",
                        "longitude": "9.40747000"
                    },
                    {
                        "id": 23971,
                        "name": "Bebra",
                        "latitude": "50.97445000",
                        "longitude": "9.79562000"
                    },
                    {
                        "id": 23984,
                        "name": "Beerfelden",
                        "latitude": "49.56858000",
                        "longitude": "8.97444000"
                    },
                    {
                        "id": 24019,
                        "name": "Bensheim",
                        "latitude": "49.68369000",
                        "longitude": "8.61839000"
                    },
                    {
                        "id": 24074,
                        "name": "Berstadt",
                        "latitude": "50.42606000",
                        "longitude": "8.86621000"
                    },
                    {
                        "id": 24086,
                        "name": "Beuern",
                        "latitude": "50.62745000",
                        "longitude": "8.82108000"
                    },
                    {
                        "id": 24098,
                        "name": "Biblis",
                        "latitude": "49.69167000",
                        "longitude": "8.45861000"
                    },
                    {
                        "id": 24101,
                        "name": "Bickenbach",
                        "latitude": "49.75917000",
                        "longitude": "8.61750000"
                    },
                    {
                        "id": 24104,
                        "name": "Biebesheim",
                        "latitude": "49.78088000",
                        "longitude": "8.46696000"
                    },
                    {
                        "id": 24105,
                        "name": "Biedenkopf",
                        "latitude": "50.91125000",
                        "longitude": "8.53016000"
                    },
                    {
                        "id": 24133,
                        "name": "Birkenau",
                        "latitude": "49.56250000",
                        "longitude": "8.70694000"
                    },
                    {
                        "id": 24141,
                        "name": "Birstein",
                        "latitude": "50.35000000",
                        "longitude": "9.30000000"
                    },
                    {
                        "id": 24144,
                        "name": "Bischoffen",
                        "latitude": "50.70000000",
                        "longitude": "8.45000000"
                    },
                    {
                        "id": 24147,
                        "name": "Bischofsheim",
                        "latitude": "49.99389000",
                        "longitude": "8.36722000"
                    },
                    {
                        "id": 24245,
                        "name": "Borken",
                        "latitude": "51.04501000",
                        "longitude": "9.28440000"
                    },
                    {
                        "id": 24287,
                        "name": "Braunfels",
                        "latitude": "50.51545000",
                        "longitude": "8.38918000"
                    },
                    {
                        "id": 24300,
                        "name": "Breidenbach",
                        "latitude": "50.88734000",
                        "longitude": "8.45748000"
                    },
                    {
                        "id": 24304,
                        "name": "Breitenbach",
                        "latitude": "50.95655000",
                        "longitude": "9.78285000"
                    },
                    {
                        "id": 24315,
                        "name": "Breitscheid",
                        "latitude": "50.68507000",
                        "longitude": "8.19120000"
                    },
                    {
                        "id": 24324,
                        "name": "Brensbach",
                        "latitude": "49.77389000",
                        "longitude": "8.88444000"
                    },
                    {
                        "id": 24328,
                        "name": "Breuna",
                        "latitude": "51.41575000",
                        "longitude": "9.18500000"
                    },
                    {
                        "id": 24346,
                        "name": "Bromskirchen",
                        "latitude": "51.09363000",
                        "longitude": "8.62640000"
                    },
                    {
                        "id": 24349,
                        "name": "Bruchköbel",
                        "latitude": "50.17853000",
                        "longitude": "8.92315000"
                    },
                    {
                        "id": 24494,
                        "name": "Büdingen",
                        "latitude": "50.29013000",
                        "longitude": "9.11140000"
                    },
                    {
                        "id": 24419,
                        "name": "Burghaun",
                        "latitude": "50.69684000",
                        "longitude": "9.72453000"
                    },
                    {
                        "id": 24433,
                        "name": "Burgsolms",
                        "latitude": "50.54191000",
                        "longitude": "8.40411000"
                    },
                    {
                        "id": 24504,
                        "name": "Bürstadt",
                        "latitude": "49.64266000",
                        "longitude": "8.45936000"
                    },
                    {
                        "id": 24507,
                        "name": "Büttelborn",
                        "latitude": "49.90333000",
                        "longitude": "8.52333000"
                    },
                    {
                        "id": 24455,
                        "name": "Butzbach",
                        "latitude": "50.43395000",
                        "longitude": "8.67122000"
                    },
                    {
                        "id": 24516,
                        "name": "Calden",
                        "latitude": "51.40943000",
                        "longitude": "9.40189000"
                    },
                    {
                        "id": 24571,
                        "name": "Cölbe",
                        "latitude": "50.85098000",
                        "longitude": "8.78092000"
                    },
                    {
                        "id": 24553,
                        "name": "Cornberg",
                        "latitude": "51.04160000",
                        "longitude": "9.86051000"
                    },
                    {
                        "id": 24597,
                        "name": "Darmstadt",
                        "latitude": "49.87167000",
                        "longitude": "8.65027000"
                    },
                    {
                        "id": 24612,
                        "name": "Dehrn",
                        "latitude": "50.42049000",
                        "longitude": "8.09846000"
                    },
                    {
                        "id": 24665,
                        "name": "Dieburg",
                        "latitude": "49.89738000",
                        "longitude": "8.84613000"
                    },
                    {
                        "id": 24686,
                        "name": "Dietzenbach",
                        "latitude": "50.00976000",
                        "longitude": "8.77783000"
                    },
                    {
                        "id": 24689,
                        "name": "Dillenburg",
                        "latitude": "50.74114000",
                        "longitude": "8.28699000"
                    },
                    {
                        "id": 24700,
                        "name": "Dipperz",
                        "latitude": "50.54333000",
                        "longitude": "9.79586000"
                    },
                    {
                        "id": 24760,
                        "name": "Dreieich",
                        "latitude": "50.01997000",
                        "longitude": "8.69611000"
                    },
                    {
                        "id": 24769,
                        "name": "Driedorf",
                        "latitude": "50.63333000",
                        "longitude": "8.18333000"
                    },
                    {
                        "id": 24847,
                        "name": "Echzell",
                        "latitude": "50.38888000",
                        "longitude": "8.88605000"
                    },
                    {
                        "id": 24866,
                        "name": "Egelsbach",
                        "latitude": "49.96792000",
                        "longitude": "8.66341000"
                    },
                    {
                        "id": 24894,
                        "name": "Ehringshausen",
                        "latitude": "50.60000000",
                        "longitude": "8.38333000"
                    },
                    {
                        "id": 24903,
                        "name": "Eichenzell",
                        "latitude": "50.49536000",
                        "longitude": "9.69672000"
                    },
                    {
                        "id": 24921,
                        "name": "Einhausen",
                        "latitude": "49.67667000",
                        "longitude": "8.54833000"
                    },
                    {
                        "id": 24936,
                        "name": "Eiterfeld",
                        "latitude": "50.76667000",
                        "longitude": "9.80000000"
                    },
                    {
                        "id": 24976,
                        "name": "Eltville",
                        "latitude": "50.02858000",
                        "longitude": "8.11754000"
                    },
                    {
                        "id": 24978,
                        "name": "Elz",
                        "latitude": "50.41667000",
                        "longitude": "8.03333000"
                    },
                    {
                        "id": 25023,
                        "name": "Eppertshausen",
                        "latitude": "49.95056000",
                        "longitude": "8.85389000"
                    },
                    {
                        "id": 25026,
                        "name": "Eppstein",
                        "latitude": "50.14277000",
                        "longitude": "8.39231000"
                    },
                    {
                        "id": 25027,
                        "name": "Erbach",
                        "latitude": "49.66148000",
                        "longitude": "8.99402000"
                    },
                    {
                        "id": 25060,
                        "name": "Erlensee",
                        "latitude": "50.16304000",
                        "longitude": "8.97823000"
                    },
                    {
                        "id": 25073,
                        "name": "Erzhausen",
                        "latitude": "49.95528000",
                        "longitude": "8.64750000"
                    },
                    {
                        "id": 25076,
                        "name": "Eschborn",
                        "latitude": "50.14328000",
                        "longitude": "8.57111000"
                    },
                    {
                        "id": 25084,
                        "name": "Eschwege",
                        "latitude": "51.18386000",
                        "longitude": "10.05329000"
                    },
                    {
                        "id": 25090,
                        "name": "Espenau",
                        "latitude": "51.39664000",
                        "longitude": "9.47021000"
                    },
                    {
                        "id": 25162,
                        "name": "Felsberg",
                        "latitude": "51.13763000",
                        "longitude": "9.42139000"
                    },
                    {
                        "id": 25191,
                        "name": "Flieden",
                        "latitude": "50.42389000",
                        "longitude": "9.56660000"
                    },
                    {
                        "id": 25200,
                        "name": "Flörsheim",
                        "latitude": "50.01311000",
                        "longitude": "8.42779000"
                    },
                    {
                        "id": 25196,
                        "name": "Florstadt",
                        "latitude": "50.31667000",
                        "longitude": "8.86667000"
                    },
                    {
                        "id": 25212,
                        "name": "Frankenau",
                        "latitude": "51.09269000",
                        "longitude": "8.93447000"
                    },
                    {
                        "id": 25213,
                        "name": "Frankenberg",
                        "latitude": "51.05890000",
                        "longitude": "8.80077000"
                    },
                    {
                        "id": 25222,
                        "name": "Frankfurt am Main",
                        "latitude": "50.11552000",
                        "longitude": "8.68417000"
                    },
                    {
                        "id": 25310,
                        "name": "Fränkisch-Crumbach",
                        "latitude": "49.74611000",
                        "longitude": "8.85861000"
                    },
                    {
                        "id": 25244,
                        "name": "Freiensteinau",
                        "latitude": "50.42509000",
                        "longitude": "9.40267000"
                    },
                    {
                        "id": 25271,
                        "name": "Friedberg",
                        "latitude": "50.33739000",
                        "longitude": "8.75591000"
                    },
                    {
                        "id": 25279,
                        "name": "Friedewald",
                        "latitude": "50.88333000",
                        "longitude": "9.86667000"
                    },
                    {
                        "id": 25286,
                        "name": "Friedrichsdorf",
                        "latitude": "50.24962000",
                        "longitude": "8.64281000"
                    },
                    {
                        "id": 25295,
                        "name": "Frielendorf",
                        "latitude": "50.97073000",
                        "longitude": "9.32269000"
                    },
                    {
                        "id": 25303,
                        "name": "Fritzlar",
                        "latitude": "51.13181000",
                        "longitude": "9.27557000"
                    },
                    {
                        "id": 25306,
                        "name": "Fronhausen",
                        "latitude": "50.70000000",
                        "longitude": "8.70000000"
                    },
                    {
                        "id": 25315,
                        "name": "Fulda",
                        "latitude": "50.55162000",
                        "longitude": "9.67518000"
                    },
                    {
                        "id": 25316,
                        "name": "Fuldatal",
                        "latitude": "51.38333000",
                        "longitude": "9.56667000"
                    },
                    {
                        "id": 25336,
                        "name": "Fürth",
                        "latitude": "49.65083000",
                        "longitude": "8.78472000"
                    },
                    {
                        "id": 25352,
                        "name": "Gallus",
                        "latitude": "50.10038000",
                        "longitude": "8.62950000"
                    },
                    {
                        "id": 25388,
                        "name": "Gedern",
                        "latitude": "50.42482000",
                        "longitude": "9.19840000"
                    },
                    {
                        "id": 25403,
                        "name": "Geisenheim",
                        "latitude": "49.98470000",
                        "longitude": "7.96835000"
                    },
                    {
                        "id": 25415,
                        "name": "Gelnhausen",
                        "latitude": "50.20164000",
                        "longitude": "9.18742000"
                    },
                    {
                        "id": 25424,
                        "name": "Gemünden an der Wohra",
                        "latitude": "50.97401000",
                        "longitude": "8.96946000"
                    },
                    {
                        "id": 25450,
                        "name": "Gernsheim",
                        "latitude": "49.75305000",
                        "longitude": "8.48859000"
                    },
                    {
                        "id": 25459,
                        "name": "Gersfeld",
                        "latitude": "50.45138000",
                        "longitude": "9.91422000"
                    },
                    {
                        "id": 25487,
                        "name": "Gießen",
                        "latitude": "50.58727000",
                        "longitude": "8.67554000"
                    },
                    {
                        "id": 25491,
                        "name": "Gilserberg",
                        "latitude": "50.95000000",
                        "longitude": "9.06667000"
                    },
                    {
                        "id": 25496,
                        "name": "Ginsheim-Gustavsburg",
                        "latitude": "49.97110000",
                        "longitude": "8.34532000"
                    },
                    {
                        "id": 25500,
                        "name": "Gladenbach",
                        "latitude": "50.76847000",
                        "longitude": "8.58085000"
                    },
                    {
                        "id": 25505,
                        "name": "Glashütten",
                        "latitude": "50.21667000",
                        "longitude": "8.40000000"
                    },
                    {
                        "id": 25509,
                        "name": "Glauburg",
                        "latitude": "50.31667000",
                        "longitude": "9.00000000"
                    },
                    {
                        "id": 25726,
                        "name": "Grävenwiesbach",
                        "latitude": "50.39024000",
                        "longitude": "8.45690000"
                    },
                    {
                        "id": 25583,
                        "name": "Grebenau",
                        "latitude": "50.74242000",
                        "longitude": "9.47307000"
                    },
                    {
                        "id": 25584,
                        "name": "Grebenhain",
                        "latitude": "50.48924000",
                        "longitude": "9.33855000"
                    },
                    {
                        "id": 25585,
                        "name": "Grebenstein",
                        "latitude": "51.44648000",
                        "longitude": "9.41250000"
                    },
                    {
                        "id": 25591,
                        "name": "Greifenstein",
                        "latitude": "50.61667000",
                        "longitude": "8.30000000"
                    },
                    {
                        "id": 25608,
                        "name": "Griesheim",
                        "latitude": "49.86085000",
                        "longitude": "8.57250000"
                    },
                    {
                        "id": 25643,
                        "name": "Groß-Bieberau",
                        "latitude": "49.80064000",
                        "longitude": "8.82430000"
                    },
                    {
                        "id": 25644,
                        "name": "Groß-Gerau",
                        "latitude": "49.92139000",
                        "longitude": "8.48255000"
                    },
                    {
                        "id": 25645,
                        "name": "Groß-Rohrheim",
                        "latitude": "49.72111000",
                        "longitude": "8.48278000"
                    },
                    {
                        "id": 25646,
                        "name": "Groß-Umstadt",
                        "latitude": "49.86899000",
                        "longitude": "8.93210000"
                    },
                    {
                        "id": 25647,
                        "name": "Groß-Zimmern",
                        "latitude": "49.87410000",
                        "longitude": "8.82898000"
                    },
                    {
                        "id": 25649,
                        "name": "Großalmerode",
                        "latitude": "51.25858000",
                        "longitude": "9.78450000"
                    },
                    {
                        "id": 25666,
                        "name": "Großenlüder",
                        "latitude": "50.59250000",
                        "longitude": "9.54231000"
                    },
                    {
                        "id": 25686,
                        "name": "Großkrotzenburg",
                        "latitude": "50.08333000",
                        "longitude": "8.98333000"
                    },
                    {
                        "id": 25736,
                        "name": "Grünberg",
                        "latitude": "50.59403000",
                        "longitude": "8.95866000"
                    },
                    {
                        "id": 25749,
                        "name": "Gudensberg",
                        "latitude": "51.17706000",
                        "longitude": "9.36748000"
                    },
                    {
                        "id": 25771,
                        "name": "Guxhagen",
                        "latitude": "51.20000000",
                        "longitude": "9.48333000"
                    },
                    {
                        "id": 25812,
                        "name": "Hadamar",
                        "latitude": "50.44593000",
                        "longitude": "8.04253000"
                    },
                    {
                        "id": 25830,
                        "name": "Haiger",
                        "latitude": "50.74162000",
                        "longitude": "8.20778000"
                    },
                    {
                        "id": 25834,
                        "name": "Hain-Gründau",
                        "latitude": "50.24284000",
                        "longitude": "9.14287000"
                    },
                    {
                        "id": 25836,
                        "name": "Haina",
                        "latitude": "51.02774000",
                        "longitude": "8.97441000"
                    },
                    {
                        "id": 25879,
                        "name": "Hammersbach",
                        "latitude": "50.21667000",
                        "longitude": "8.98333000"
                    },
                    {
                        "id": 25882,
                        "name": "Hanau am Main",
                        "latitude": "50.13423000",
                        "longitude": "8.91418000"
                    },
                    {
                        "id": 25938,
                        "name": "Hattersheim",
                        "latitude": "50.07854000",
                        "longitude": "8.47552000"
                    },
                    {
                        "id": 25944,
                        "name": "Hatzfeld",
                        "latitude": "50.99334000",
                        "longitude": "8.54570000"
                    },
                    {
                        "id": 26034,
                        "name": "Helsa",
                        "latitude": "51.25981000",
                        "longitude": "9.68872000"
                    },
                    {
                        "id": 26055,
                        "name": "Heppenheim an der Bergstrasse",
                        "latitude": "49.64145000",
                        "longitude": "8.63206000"
                    },
                    {
                        "id": 26059,
                        "name": "Herborn",
                        "latitude": "50.68135000",
                        "longitude": "8.30369000"
                    },
                    {
                        "id": 26062,
                        "name": "Herbstein",
                        "latitude": "50.56105000",
                        "longitude": "9.34592000"
                    },
                    {
                        "id": 26072,
                        "name": "Heringen",
                        "latitude": "50.88798000",
                        "longitude": "10.00717000"
                    },
                    {
                        "id": 26074,
                        "name": "Herleshausen",
                        "latitude": "51.00629000",
                        "longitude": "10.16731000"
                    },
                    {
                        "id": 26107,
                        "name": "Hessisch Lichtenau",
                        "latitude": "51.19954000",
                        "longitude": "9.71857000"
                    },
                    {
                        "id": 26118,
                        "name": "Heuchelheim",
                        "latitude": "50.58333000",
                        "longitude": "8.63333000"
                    },
                    {
                        "id": 26123,
                        "name": "Heusenstamm",
                        "latitude": "50.05553000",
                        "longitude": "8.80076000"
                    },
                    {
                        "id": 26136,
                        "name": "Hilders",
                        "latitude": "50.57190000",
                        "longitude": "10.00297000"
                    },
                    {
                        "id": 26168,
                        "name": "Hirschhorn",
                        "latitude": "49.44566000",
                        "longitude": "8.89594000"
                    },
                    {
                        "id": 26169,
                        "name": "Hirzenhain",
                        "latitude": "50.40000000",
                        "longitude": "9.13333000"
                    },
                    {
                        "id": 26176,
                        "name": "Hochheim am Main",
                        "latitude": "50.01436000",
                        "longitude": "8.35218000"
                    },
                    {
                        "id": 26301,
                        "name": "Höchst im Odenwald",
                        "latitude": "49.79972000",
                        "longitude": "8.99944000"
                    },
                    {
                        "id": 26186,
                        "name": "Hofbieber",
                        "latitude": "50.58629000",
                        "longitude": "9.83534000"
                    },
                    {
                        "id": 26187,
                        "name": "Hofgeismar",
                        "latitude": "51.49607000",
                        "longitude": "9.38500000"
                    },
                    {
                        "id": 26188,
                        "name": "Hofheim am Taunus",
                        "latitude": "50.09019000",
                        "longitude": "8.44930000"
                    },
                    {
                        "id": 26314,
                        "name": "Höingen",
                        "latitude": "50.71910000",
                        "longitude": "8.91961000"
                    },
                    {
                        "id": 26251,
                        "name": "Homberg",
                        "latitude": "50.73108000",
                        "longitude": "8.99644000"
                    },
                    {
                        "id": 26319,
                        "name": "Hörnsheim",
                        "latitude": "50.51828000",
                        "longitude": "8.62976000"
                    },
                    {
                        "id": 26275,
                        "name": "Hosenfeld",
                        "latitude": "50.50502000",
                        "longitude": "9.47966000"
                    },
                    {
                        "id": 26337,
                        "name": "Hünfeld",
                        "latitude": "50.67966000",
                        "longitude": "9.76727000"
                    },
                    {
                        "id": 26289,
                        "name": "Hungen",
                        "latitude": "50.47368000",
                        "longitude": "8.89326000"
                    },
                    {
                        "id": 26351,
                        "name": "Idstein",
                        "latitude": "50.21773000",
                        "longitude": "8.26679000"
                    },
                    {
                        "id": 26381,
                        "name": "Immenhausen",
                        "latitude": "51.42763000",
                        "longitude": "9.48017000"
                    },
                    {
                        "id": 26441,
                        "name": "Jesberg",
                        "latitude": "51.00000000",
                        "longitude": "9.15000000"
                    },
                    {
                        "id": 26513,
                        "name": "Karben",
                        "latitude": "50.23019000",
                        "longitude": "8.77155000"
                    },
                    {
                        "id": 26531,
                        "name": "Kassel",
                        "latitude": "51.31667000",
                        "longitude": "9.50000000"
                    },
                    {
                        "id": 26544,
                        "name": "Kaufungen",
                        "latitude": "51.28111000",
                        "longitude": "9.61861000"
                    },
                    {
                        "id": 26550,
                        "name": "Kefenrod",
                        "latitude": "50.34475000",
                        "longitude": "9.21141000"
                    },
                    {
                        "id": 26557,
                        "name": "Kelkheim (Taunus)",
                        "latitude": "50.13703000",
                        "longitude": "8.45020000"
                    },
                    {
                        "id": 26562,
                        "name": "Kelsterbach",
                        "latitude": "50.06135000",
                        "longitude": "8.52916000"
                    },
                    {
                        "id": 26582,
                        "name": "Kiedrich",
                        "latitude": "50.03965000",
                        "longitude": "8.08531000"
                    },
                    {
                        "id": 26615,
                        "name": "Kirchhain",
                        "latitude": "50.82720000",
                        "longitude": "8.92806000"
                    },
                    {
                        "id": 26620,
                        "name": "Kirchheim",
                        "latitude": "50.83333000",
                        "longitude": "9.56667000"
                    },
                    {
                        "id": 26646,
                        "name": "Kirtorf",
                        "latitude": "50.76942000",
                        "longitude": "9.10389000"
                    },
                    {
                        "id": 26836,
                        "name": "Königstein im Taunus",
                        "latitude": "50.17943000",
                        "longitude": "8.47132000"
                    },
                    {
                        "id": 26722,
                        "name": "Korbach",
                        "latitude": "51.27561000",
                        "longitude": "8.87300000"
                    },
                    {
                        "id": 26843,
                        "name": "Körle",
                        "latitude": "51.16667000",
                        "longitude": "9.51667000"
                    },
                    {
                        "id": 26763,
                        "name": "Kriftel",
                        "latitude": "50.08408000",
                        "longitude": "8.46977000"
                    },
                    {
                        "id": 26769,
                        "name": "Kronberg",
                        "latitude": "50.18424000",
                        "longitude": "8.52320000"
                    },
                    {
                        "id": 26770,
                        "name": "Kronberg Tal",
                        "latitude": "50.17929000",
                        "longitude": "8.50370000"
                    },
                    {
                        "id": 26855,
                        "name": "Künzell",
                        "latitude": "50.54420000",
                        "longitude": "9.71792000"
                    },
                    {
                        "id": 26885,
                        "name": "Lampertheim",
                        "latitude": "49.59786000",
                        "longitude": "8.47250000"
                    },
                    {
                        "id": 26902,
                        "name": "Langen",
                        "latitude": "49.98955000",
                        "longitude": "8.66852000"
                    },
                    {
                        "id": 26928,
                        "name": "Langenselbold",
                        "latitude": "50.17657000",
                        "longitude": "9.04003000"
                    },
                    {
                        "id": 26938,
                        "name": "Langgöns",
                        "latitude": "50.50000000",
                        "longitude": "8.66667000"
                    },
                    {
                        "id": 26955,
                        "name": "Laubach",
                        "latitude": "50.54196000",
                        "longitude": "8.99034000"
                    },
                    {
                        "id": 26973,
                        "name": "Laufdorf",
                        "latitude": "50.51605000",
                        "longitude": "8.45982000"
                    },
                    {
                        "id": 26984,
                        "name": "Lauterbach",
                        "latitude": "50.63558000",
                        "longitude": "9.39777000"
                    },
                    {
                        "id": 26988,
                        "name": "Lautertal",
                        "latitude": "50.58333000",
                        "longitude": "9.28333000"
                    },
                    {
                        "id": 27061,
                        "name": "Leun",
                        "latitude": "50.55129000",
                        "longitude": "8.35836000"
                    },
                    {
                        "id": 27073,
                        "name": "Lich",
                        "latitude": "50.52085000",
                        "longitude": "8.81567000"
                    },
                    {
                        "id": 27086,
                        "name": "Liebenau",
                        "latitude": "51.49699000",
                        "longitude": "9.28207000"
                    },
                    {
                        "id": 27092,
                        "name": "Liederbach",
                        "latitude": "50.12221000",
                        "longitude": "8.49397000"
                    },
                    {
                        "id": 27099,
                        "name": "Limburg an der Lahn",
                        "latitude": "50.38360000",
                        "longitude": "8.05030000"
                    },
                    {
                        "id": 27108,
                        "name": "Lindenfels",
                        "latitude": "49.68369000",
                        "longitude": "8.78151000"
                    },
                    {
                        "id": 27132,
                        "name": "Lohfelden",
                        "latitude": "51.26667000",
                        "longitude": "9.53333000"
                    },
                    {
                        "id": 27194,
                        "name": "Löhnberg",
                        "latitude": "50.51299000",
                        "longitude": "8.27202000"
                    },
                    {
                        "id": 27137,
                        "name": "Lohra",
                        "latitude": "50.73333000",
                        "longitude": "8.63333000"
                    },
                    {
                        "id": 27141,
                        "name": "Lollar",
                        "latitude": "50.64652000",
                        "longitude": "8.70495000"
                    },
                    {
                        "id": 27149,
                        "name": "Lorsch",
                        "latitude": "49.65000000",
                        "longitude": "8.56667000"
                    },
                    {
                        "id": 27224,
                        "name": "Lützelbach",
                        "latitude": "49.74233000",
                        "longitude": "8.76687000"
                    },
                    {
                        "id": 27243,
                        "name": "Maintal",
                        "latitude": "50.15000000",
                        "longitude": "8.83333000"
                    },
                    {
                        "id": 27258,
                        "name": "Malsfeld",
                        "latitude": "51.09083000",
                        "longitude": "9.53889000"
                    },
                    {
                        "id": 27270,
                        "name": "Marburg an der Lahn",
                        "latitude": "50.80904000",
                        "longitude": "8.77069000"
                    },
                    {
                        "id": 27329,
                        "name": "Martinhagen",
                        "latitude": "51.28688000",
                        "longitude": "9.28611000"
                    },
                    {
                        "id": 27389,
                        "name": "Melbach",
                        "latitude": "50.37908000",
                        "longitude": "8.80926000"
                    },
                    {
                        "id": 27400,
                        "name": "Melsungen",
                        "latitude": "51.13029000",
                        "longitude": "9.55236000"
                    },
                    {
                        "id": 27409,
                        "name": "Mengerskirchen",
                        "latitude": "50.56392000",
                        "longitude": "8.15555000"
                    },
                    {
                        "id": 27417,
                        "name": "Merenberg",
                        "latitude": "50.50707000",
                        "longitude": "8.19194000"
                    },
                    {
                        "id": 27419,
                        "name": "Merkenbach",
                        "latitude": "50.65626000",
                        "longitude": "8.29513000"
                    },
                    {
                        "id": 27434,
                        "name": "Messel",
                        "latitude": "49.93833000",
                        "longitude": "8.74056000"
                    },
                    {
                        "id": 27455,
                        "name": "Michelstadt",
                        "latitude": "49.67569000",
                        "longitude": "9.00373000"
                    },
                    {
                        "id": 27487,
                        "name": "Mittenaar",
                        "latitude": "50.70000000",
                        "longitude": "8.38333000"
                    },
                    {
                        "id": 27576,
                        "name": "Mörfelden-Walldorf",
                        "latitude": "49.99472000",
                        "longitude": "8.58361000"
                    },
                    {
                        "id": 27577,
                        "name": "Mörlenbach",
                        "latitude": "49.59917000",
                        "longitude": "8.73472000"
                    },
                    {
                        "id": 27601,
                        "name": "Mühlheim am Main",
                        "latitude": "50.11667000",
                        "longitude": "8.83333000"
                    },
                    {
                        "id": 27612,
                        "name": "Münchhausen",
                        "latitude": "50.96081000",
                        "longitude": "8.71837000"
                    },
                    {
                        "id": 27620,
                        "name": "Münster",
                        "latitude": "49.92278000",
                        "longitude": "8.86778000"
                    },
                    {
                        "id": 27628,
                        "name": "Münzenberg",
                        "latitude": "50.45346000",
                        "longitude": "8.77430000"
                    },
                    {
                        "id": 27650,
                        "name": "Naumburg",
                        "latitude": "51.24816000",
                        "longitude": "9.16569000"
                    },
                    {
                        "id": 27661,
                        "name": "Neckarsteinach",
                        "latitude": "49.40735000",
                        "longitude": "8.84342000"
                    },
                    {
                        "id": 27675,
                        "name": "Nentershausen",
                        "latitude": "51.01667000",
                        "longitude": "9.93333000"
                    },
                    {
                        "id": 27688,
                        "name": "Neu Isenburg",
                        "latitude": "50.04832000",
                        "longitude": "8.69406000"
                    },
                    {
                        "id": 27692,
                        "name": "Neu-Anspach",
                        "latitude": "50.31667000",
                        "longitude": "8.50000000"
                    },
                    {
                        "id": 27729,
                        "name": "Neuental",
                        "latitude": "51.00000000",
                        "longitude": "9.21667000"
                    },
                    {
                        "id": 27748,
                        "name": "Neuhof",
                        "latitude": "50.45313000",
                        "longitude": "9.61750000"
                    },
                    {
                        "id": 27761,
                        "name": "Neukirchen",
                        "latitude": "50.86906000",
                        "longitude": "9.34655000"
                    },
                    {
                        "id": 27795,
                        "name": "Neustadt (Hessen)",
                        "latitude": "50.85000000",
                        "longitude": "9.11667000"
                    },
                    {
                        "id": 27821,
                        "name": "Nidda",
                        "latitude": "50.41330000",
                        "longitude": "9.00638000"
                    },
                    {
                        "id": 27822,
                        "name": "Nidderau",
                        "latitude": "50.23805000",
                        "longitude": "8.86704000"
                    },
                    {
                        "id": 27825,
                        "name": "Niedenstein",
                        "latitude": "51.23342000",
                        "longitude": "9.31029000"
                    },
                    {
                        "id": 27826,
                        "name": "Nieder-Gründau",
                        "latitude": "50.21097000",
                        "longitude": "9.10801000"
                    },
                    {
                        "id": 27832,
                        "name": "Niederaula",
                        "latitude": "50.80000000",
                        "longitude": "9.60000000"
                    },
                    {
                        "id": 27834,
                        "name": "Niederbiel",
                        "latitude": "50.55505000",
                        "longitude": "8.39845000"
                    },
                    {
                        "id": 27838,
                        "name": "Niederdorfelden",
                        "latitude": "50.19415000",
                        "longitude": "8.80005000"
                    },
                    {
                        "id": 27853,
                        "name": "Niederklein",
                        "latitude": "50.79400000",
                        "longitude": "8.99694000"
                    },
                    {
                        "id": 27864,
                        "name": "Niedernhausen",
                        "latitude": "50.16307000",
                        "longitude": "8.31338000"
                    },
                    {
                        "id": 27867,
                        "name": "Niederrad",
                        "latitude": "50.08309000",
                        "longitude": "8.62852000"
                    },
                    {
                        "id": 27958,
                        "name": "Ober-Mörlen",
                        "latitude": "50.37350000",
                        "longitude": "8.69087000"
                    },
                    {
                        "id": 27960,
                        "name": "Ober-Ramstadt",
                        "latitude": "49.83078000",
                        "longitude": "8.74887000"
                    },
                    {
                        "id": 27965,
                        "name": "Oberaula",
                        "latitude": "50.85000000",
                        "longitude": "9.46667000"
                    },
                    {
                        "id": 27967,
                        "name": "Oberbiel",
                        "latitude": "50.55320000",
                        "longitude": "8.42797000"
                    },
                    {
                        "id": 28050,
                        "name": "Obertshausen",
                        "latitude": "50.07139000",
                        "longitude": "8.85123000"
                    },
                    {
                        "id": 28051,
                        "name": "Oberursel",
                        "latitude": "50.20731000",
                        "longitude": "8.57747000"
                    },
                    {
                        "id": 28086,
                        "name": "Offenbach",
                        "latitude": "50.10061000",
                        "longitude": "8.76647000"
                    },
                    {
                        "id": 28130,
                        "name": "Ortenberg",
                        "latitude": "50.35584000",
                        "longitude": "9.05602000"
                    },
                    {
                        "id": 28196,
                        "name": "Ottrau",
                        "latitude": "50.80599000",
                        "longitude": "9.38575000"
                    },
                    {
                        "id": 28295,
                        "name": "Pfungstadt",
                        "latitude": "49.80557000",
                        "longitude": "8.60307000"
                    },
                    {
                        "id": 28297,
                        "name": "Philippsthal",
                        "latitude": "50.83948000",
                        "longitude": "10.00906000"
                    },
                    {
                        "id": 28353,
                        "name": "Poppenhausen",
                        "latitude": "50.48793000",
                        "longitude": "9.86795000"
                    },
                    {
                        "id": 28437,
                        "name": "Rabenau",
                        "latitude": "50.67753000",
                        "longitude": "8.86425000"
                    },
                    {
                        "id": 28475,
                        "name": "Ranstadt",
                        "latitude": "50.35739000",
                        "longitude": "8.98375000"
                    },
                    {
                        "id": 28478,
                        "name": "Rasdorf",
                        "latitude": "50.71667000",
                        "longitude": "9.90000000"
                    },
                    {
                        "id": 28496,
                        "name": "Raunheim",
                        "latitude": "50.01320000",
                        "longitude": "8.45253000"
                    },
                    {
                        "id": 28497,
                        "name": "Rauschenberg",
                        "latitude": "50.88329000",
                        "longitude": "8.91864000"
                    },
                    {
                        "id": 28517,
                        "name": "Regierungsbezirk Darmstadt",
                        "latitude": "50.00000000",
                        "longitude": "8.75000000"
                    },
                    {
                        "id": 28519,
                        "name": "Regierungsbezirk Gießen",
                        "latitude": "50.69806000",
                        "longitude": "8.76861000"
                    },
                    {
                        "id": 28520,
                        "name": "Regierungsbezirk Kassel",
                        "latitude": "51.08333000",
                        "longitude": "9.40000000"
                    },
                    {
                        "id": 28537,
                        "name": "Reichelsheim",
                        "latitude": "49.71211000",
                        "longitude": "8.83896000"
                    },
                    {
                        "id": 28558,
                        "name": "Reinhardshausen",
                        "latitude": "51.11166000",
                        "longitude": "9.07514000"
                    },
                    {
                        "id": 28561,
                        "name": "Reinheim",
                        "latitude": "49.82923000",
                        "longitude": "8.83572000"
                    },
                    {
                        "id": 28569,
                        "name": "Reiskirchen",
                        "latitude": "50.60000000",
                        "longitude": "8.83333000"
                    },
                    {
                        "id": 28637,
                        "name": "Riedstadt",
                        "latitude": "49.83411000",
                        "longitude": "8.49621000"
                    },
                    {
                        "id": 28655,
                        "name": "Rimbach",
                        "latitude": "49.62500000",
                        "longitude": "8.76306000"
                    },
                    {
                        "id": 28671,
                        "name": "Rockenberg",
                        "latitude": "50.43050000",
                        "longitude": "8.73688000"
                    },
                    {
                        "id": 28676,
                        "name": "Rodenbach",
                        "latitude": "50.15000000",
                        "longitude": "9.03333000"
                    },
                    {
                        "id": 28679,
                        "name": "Rodgau",
                        "latitude": "50.02627000",
                        "longitude": "8.88588000"
                    },
                    {
                        "id": 28697,
                        "name": "Romrod",
                        "latitude": "50.71341000",
                        "longitude": "9.22010000"
                    },
                    {
                        "id": 28701,
                        "name": "Ronshausen",
                        "latitude": "50.95000000",
                        "longitude": "9.85000000"
                    },
                    {
                        "id": 28702,
                        "name": "Rosbach vor der Höhe",
                        "latitude": "50.30332000",
                        "longitude": "8.68976000"
                    },
                    {
                        "id": 28709,
                        "name": "Rosenthal",
                        "latitude": "50.97439000",
                        "longitude": "8.86736000"
                    },
                    {
                        "id": 28741,
                        "name": "Roßdorf",
                        "latitude": "49.85972000",
                        "longitude": "8.76167000"
                    },
                    {
                        "id": 28719,
                        "name": "Rotenburg an der Fulda",
                        "latitude": "50.99556000",
                        "longitude": "9.72838000"
                    },
                    {
                        "id": 28722,
                        "name": "Rothenberg",
                        "latitude": "49.49917000",
                        "longitude": "8.91917000"
                    },
                    {
                        "id": 28801,
                        "name": "Rüdesheim am Rhein",
                        "latitude": "49.97890000",
                        "longitude": "7.92442000"
                    },
                    {
                        "id": 28764,
                        "name": "Runkel",
                        "latitude": "50.40574000",
                        "longitude": "8.15457000"
                    },
                    {
                        "id": 28809,
                        "name": "Rüsselsheim",
                        "latitude": "49.98955000",
                        "longitude": "8.42251000"
                    },
                    {
                        "id": 28823,
                        "name": "Sachsenhausen",
                        "latitude": "51.24338000",
                        "longitude": "9.00973000"
                    },
                    {
                        "id": 28901,
                        "name": "Schaafheim",
                        "latitude": "49.92417000",
                        "longitude": "9.00944000"
                    },
                    {
                        "id": 28931,
                        "name": "Schenklengsfeld",
                        "latitude": "50.81667000",
                        "longitude": "9.85000000"
                    },
                    {
                        "id": 28963,
                        "name": "Schlangenbad",
                        "latitude": "50.09322000",
                        "longitude": "8.10312000"
                    },
                    {
                        "id": 28980,
                        "name": "Schlitz",
                        "latitude": "50.67416000",
                        "longitude": "9.56102000"
                    },
                    {
                        "id": 28984,
                        "name": "Schlüchtern",
                        "latitude": "50.34891000",
                        "longitude": "9.52532000"
                    },
                    {
                        "id": 28997,
                        "name": "Schmitten",
                        "latitude": "50.26667000",
                        "longitude": "8.45000000"
                    },
                    {
                        "id": 29099,
                        "name": "Schöffengrund",
                        "latitude": "50.49345000",
                        "longitude": "8.47183000"
                    },
                    {
                        "id": 29027,
                        "name": "Schotten",
                        "latitude": "50.50346000",
                        "longitude": "9.12516000"
                    },
                    {
                        "id": 29030,
                        "name": "Schrecksbach",
                        "latitude": "50.83333000",
                        "longitude": "9.28333000"
                    },
                    {
                        "id": 29050,
                        "name": "Schwalbach",
                        "latitude": "50.49672000",
                        "longitude": "8.46943000"
                    },
                    {
                        "id": 29051,
                        "name": "Schwalbach am Taunus",
                        "latitude": "50.15000000",
                        "longitude": "8.53333000"
                    },
                    {
                        "id": 29053,
                        "name": "Schwalmstadt",
                        "latitude": "50.93333000",
                        "longitude": "9.21667000"
                    },
                    {
                        "id": 29055,
                        "name": "Schwalmtal",
                        "latitude": "50.68333000",
                        "longitude": "9.21667000"
                    },
                    {
                        "id": 29071,
                        "name": "Schwarzenborn",
                        "latitude": "50.90977000",
                        "longitude": "9.44658000"
                    },
                    {
                        "id": 29155,
                        "name": "Seeheim-Jugenheim",
                        "latitude": "49.76500000",
                        "longitude": "8.65194000"
                    },
                    {
                        "id": 29179,
                        "name": "Seligenstadt",
                        "latitude": "50.04320000",
                        "longitude": "8.97394000"
                    },
                    {
                        "id": 29185,
                        "name": "Selters",
                        "latitude": "50.51681000",
                        "longitude": "8.28953000"
                    },
                    {
                        "id": 29243,
                        "name": "Sinn",
                        "latitude": "50.65000000",
                        "longitude": "8.33333000"
                    },
                    {
                        "id": 29490,
                        "name": "Södel",
                        "latitude": "50.39382000",
                        "longitude": "8.80474000"
                    },
                    {
                        "id": 29260,
                        "name": "Solms",
                        "latitude": "50.53620000",
                        "longitude": "8.40704000"
                    },
                    {
                        "id": 29279,
                        "name": "Sontra",
                        "latitude": "51.07171000",
                        "longitude": "9.93558000"
                    },
                    {
                        "id": 29287,
                        "name": "Spangenberg",
                        "latitude": "51.11644000",
                        "longitude": "9.66270000"
                    },
                    {
                        "id": 29319,
                        "name": "Stadtallendorf",
                        "latitude": "50.82261000",
                        "longitude": "9.01294000"
                    },
                    {
                        "id": 29346,
                        "name": "Staufenberg",
                        "latitude": "50.66197000",
                        "longitude": "8.73158000"
                    },
                    {
                        "id": 29350,
                        "name": "Steeden",
                        "latitude": "50.41539000",
                        "longitude": "8.12748000"
                    },
                    {
                        "id": 29362,
                        "name": "Steinau an der Straße",
                        "latitude": "50.31401000",
                        "longitude": "9.46335000"
                    },
                    {
                        "id": 29365,
                        "name": "Steinbach am Taunus",
                        "latitude": "50.16774000",
                        "longitude": "8.57278000"
                    },
                    {
                        "id": 29414,
                        "name": "Stockstadt am Rhein",
                        "latitude": "49.80944000",
                        "longitude": "8.47278000"
                    },
                    {
                        "id": 29468,
                        "name": "Sulzbach",
                        "latitude": "50.13396000",
                        "longitude": "8.52797000"
                    },
                    {
                        "id": 29520,
                        "name": "Tann",
                        "latitude": "50.64284000",
                        "longitude": "10.02385000"
                    },
                    {
                        "id": 29537,
                        "name": "Taunusstein",
                        "latitude": "50.14993000",
                        "longitude": "8.15206000"
                    },
                    {
                        "id": 29653,
                        "name": "Trebur",
                        "latitude": "49.92639000",
                        "longitude": "8.40732000"
                    },
                    {
                        "id": 29660,
                        "name": "Trendelburg",
                        "latitude": "51.57408000",
                        "longitude": "9.42095000"
                    },
                    {
                        "id": 29715,
                        "name": "Udenhausen",
                        "latitude": "51.46385000",
                        "longitude": "9.46335000"
                    },
                    {
                        "id": 29739,
                        "name": "Ulrichstein",
                        "latitude": "50.57550000",
                        "longitude": "9.19272000"
                    },
                    {
                        "id": 29751,
                        "name": "Unter-Abtsteinach",
                        "latitude": "49.52711000",
                        "longitude": "8.78679000"
                    },
                    {
                        "id": 29798,
                        "name": "Usingen",
                        "latitude": "50.33554000",
                        "longitude": "8.53688000"
                    },
                    {
                        "id": 29829,
                        "name": "Vellmar",
                        "latitude": "51.35806000",
                        "longitude": "9.47974000"
                    },
                    {
                        "id": 29848,
                        "name": "Viernheim",
                        "latitude": "49.54033000",
                        "longitude": "8.57820000"
                    },
                    {
                        "id": 29854,
                        "name": "Villmar",
                        "latitude": "50.39287000",
                        "longitude": "8.19310000"
                    },
                    {
                        "id": 29887,
                        "name": "Vöhl",
                        "latitude": "51.20565000",
                        "longitude": "8.94510000"
                    },
                    {
                        "id": 29875,
                        "name": "Volkmarsen",
                        "latitude": "51.40895000",
                        "longitude": "9.11814000"
                    },
                    {
                        "id": 29899,
                        "name": "Wabern",
                        "latitude": "51.10000000",
                        "longitude": "9.35000000"
                    },
                    {
                        "id": 30436,
                        "name": "Wächtersbach",
                        "latitude": "50.25511000",
                        "longitude": "9.29564000"
                    },
                    {
                        "id": 29933,
                        "name": "Wald-Michelbach",
                        "latitude": "49.57000000",
                        "longitude": "8.83167000"
                    },
                    {
                        "id": 29938,
                        "name": "Waldbrunn",
                        "latitude": "50.51875000",
                        "longitude": "8.10812000"
                    },
                    {
                        "id": 29943,
                        "name": "Waldeck",
                        "latitude": "51.20618000",
                        "longitude": "9.06286000"
                    },
                    {
                        "id": 29944,
                        "name": "Waldems",
                        "latitude": "50.25000000",
                        "longitude": "8.33333000"
                    },
                    {
                        "id": 29953,
                        "name": "Waldkappel",
                        "latitude": "51.14462000",
                        "longitude": "9.87695000"
                    },
                    {
                        "id": 29988,
                        "name": "Walluf",
                        "latitude": "50.04003000",
                        "longitude": "8.15545000"
                    },
                    {
                        "id": 30001,
                        "name": "Wanfried",
                        "latitude": "51.18207000",
                        "longitude": "10.17283000"
                    },
                    {
                        "id": 30062,
                        "name": "Wehrheim",
                        "latitude": "50.30000000",
                        "longitude": "8.56667000"
                    },
                    {
                        "id": 30085,
                        "name": "Weilburg",
                        "latitude": "50.48438000",
                        "longitude": "8.26249000"
                    },
                    {
                        "id": 30094,
                        "name": "Weilmünster",
                        "latitude": "50.43143000",
                        "longitude": "8.37673000"
                    },
                    {
                        "id": 30097,
                        "name": "Weinbach",
                        "latitude": "50.43843000",
                        "longitude": "8.29133000"
                    },
                    {
                        "id": 30118,
                        "name": "Weiterstadt",
                        "latitude": "49.90390000",
                        "longitude": "8.58874000"
                    },
                    {
                        "id": 30224,
                        "name": "Wetter",
                        "latitude": "50.90254000",
                        "longitude": "8.72366000"
                    },
                    {
                        "id": 30230,
                        "name": "Wetzlar",
                        "latitude": "50.56109000",
                        "longitude": "8.50495000"
                    },
                    {
                        "id": 30254,
                        "name": "Wiesbaden",
                        "latitude": "50.08258000",
                        "longitude": "8.24932000"
                    },
                    {
                        "id": 30295,
                        "name": "Willingen",
                        "latitude": "51.29418000",
                        "longitude": "8.60910000"
                    },
                    {
                        "id": 30296,
                        "name": "Willingshausen",
                        "latitude": "50.85000000",
                        "longitude": "9.20000000"
                    },
                    {
                        "id": 30367,
                        "name": "Witzenhausen",
                        "latitude": "51.34103000",
                        "longitude": "9.85540000"
                    },
                    {
                        "id": 30372,
                        "name": "Wohnbach",
                        "latitude": "50.42864000",
                        "longitude": "8.82923000"
                    },
                    {
                        "id": 30439,
                        "name": "Wölfersheim",
                        "latitude": "50.40000000",
                        "longitude": "8.81667000"
                    },
                    {
                        "id": 30382,
                        "name": "Wolfhagen",
                        "latitude": "51.32611000",
                        "longitude": "9.17015000"
                    },
                    {
                        "id": 30503,
                        "name": "Zierenberg",
                        "latitude": "51.36948000",
                        "longitude": "9.30164000"
                    },
                    {
                        "id": 30537,
                        "name": "Zwingenberg",
                        "latitude": "49.72389000",
                        "longitude": "8.61084000"
                    }
                ]
            },
            {
                "id": 3008,
                "name": "Lower Saxony",
                "iso2": "NI",
                "latitude": "52.63670360",
                "longitude": "9.84507660",
                "type": "land",
                "cities": [
                    {
                        "id": 23465,
                        "name": "Abbesbüttel",
                        "latitude": "52.35233000",
                        "longitude": "10.55649000"
                    },
                    {
                        "id": 23473,
                        "name": "Achim",
                        "latitude": "53.01416000",
                        "longitude": "9.02630000"
                    },
                    {
                        "id": 23478,
                        "name": "Adelebsen",
                        "latitude": "51.58272000",
                        "longitude": "9.75461000"
                    },
                    {
                        "id": 23479,
                        "name": "Adelheidsdorf",
                        "latitude": "52.56404000",
                        "longitude": "10.06039000"
                    },
                    {
                        "id": 23487,
                        "name": "Adenbüttel",
                        "latitude": "52.37984000",
                        "longitude": "10.45079000"
                    },
                    {
                        "id": 23488,
                        "name": "Adendorf",
                        "latitude": "53.28189000",
                        "longitude": "10.43787000"
                    },
                    {
                        "id": 23489,
                        "name": "Adenstedt",
                        "latitude": "51.99852000",
                        "longitude": "9.93516000"
                    },
                    {
                        "id": 23494,
                        "name": "Aerzen",
                        "latitude": "52.04953000",
                        "longitude": "9.25856000"
                    },
                    {
                        "id": 23497,
                        "name": "Agathenburg",
                        "latitude": "53.56065000",
                        "longitude": "9.53180000"
                    },
                    {
                        "id": 23501,
                        "name": "Ahausen",
                        "latitude": "53.06667000",
                        "longitude": "9.31667000"
                    },
                    {
                        "id": 23503,
                        "name": "Ahlden",
                        "latitude": "52.75968000",
                        "longitude": "9.55115000"
                    },
                    {
                        "id": 23505,
                        "name": "Ahlerstedt",
                        "latitude": "53.40000000",
                        "longitude": "9.45000000"
                    },
                    {
                        "id": 23507,
                        "name": "Ahnsbeck",
                        "latitude": "52.61071000",
                        "longitude": "10.28534000"
                    },
                    {
                        "id": 23508,
                        "name": "Ahnsen",
                        "latitude": "52.25466000",
                        "longitude": "9.10089000"
                    },
                    {
                        "id": 23515,
                        "name": "Ahsen-Oetzen",
                        "latitude": "52.95868000",
                        "longitude": "9.07933000"
                    },
                    {
                        "id": 23549,
                        "name": "Alfeld",
                        "latitude": "51.98382000",
                        "longitude": "9.81989000"
                    },
                    {
                        "id": 23551,
                        "name": "Alfhausen",
                        "latitude": "52.50000000",
                        "longitude": "7.95000000"
                    },
                    {
                        "id": 23553,
                        "name": "Algermissen",
                        "latitude": "52.25332000",
                        "longitude": "9.96915000"
                    },
                    {
                        "id": 23578,
                        "name": "Alt Wallmoden",
                        "latitude": "52.01933000",
                        "longitude": "10.30294000"
                    },
                    {
                        "id": 23591,
                        "name": "Altenau",
                        "latitude": "51.80113000",
                        "longitude": "10.44148000"
                    },
                    {
                        "id": 23609,
                        "name": "Altenmedingen",
                        "latitude": "53.13050000",
                        "longitude": "10.60163000"
                    },
                    {
                        "id": 23644,
                        "name": "Amelinghausen",
                        "latitude": "53.12397000",
                        "longitude": "10.21274000"
                    },
                    {
                        "id": 23660,
                        "name": "Ankum",
                        "latitude": "52.55000000",
                        "longitude": "7.88333000"
                    },
                    {
                        "id": 23669,
                        "name": "Apelern",
                        "latitude": "52.28979000",
                        "longitude": "9.33580000"
                    },
                    {
                        "id": 23670,
                        "name": "Apen",
                        "latitude": "53.21667000",
                        "longitude": "7.80000000"
                    },
                    {
                        "id": 23671,
                        "name": "Apensen",
                        "latitude": "53.43333000",
                        "longitude": "9.61667000"
                    },
                    {
                        "id": 23676,
                        "name": "Appel",
                        "latitude": "53.39060000",
                        "longitude": "9.74565000"
                    },
                    {
                        "id": 23691,
                        "name": "Arpke",
                        "latitude": "52.38597000",
                        "longitude": "10.10047000"
                    },
                    {
                        "id": 23694,
                        "name": "Artlenburg",
                        "latitude": "53.37182000",
                        "longitude": "10.48793000"
                    },
                    {
                        "id": 23709,
                        "name": "Asendorf",
                        "latitude": "52.77219000",
                        "longitude": "9.00489000"
                    },
                    {
                        "id": 23727,
                        "name": "Auf der Horst",
                        "latitude": "52.41943000",
                        "longitude": "9.60248000"
                    },
                    {
                        "id": 23734,
                        "name": "Auhagen",
                        "latitude": "52.39828000",
                        "longitude": "9.29194000"
                    },
                    {
                        "id": 23741,
                        "name": "Aurich",
                        "latitude": "53.46919000",
                        "longitude": "7.48232000"
                    },
                    {
                        "id": 23744,
                        "name": "Axstedt",
                        "latitude": "53.35466000",
                        "longitude": "8.77485000"
                    },
                    {
                        "id": 23765,
                        "name": "Bad Bentheim",
                        "latitude": "52.30066000",
                        "longitude": "7.15763000"
                    },
                    {
                        "id": 23770,
                        "name": "Bad Bevensen",
                        "latitude": "53.07923000",
                        "longitude": "10.58129000"
                    },
                    {
                        "id": 23788,
                        "name": "Bad Eilsen",
                        "latitude": "52.24215000",
                        "longitude": "9.09822000"
                    },
                    {
                        "id": 23793,
                        "name": "Bad Essen",
                        "latitude": "52.31667000",
                        "longitude": "8.33333000"
                    },
                    {
                        "id": 23794,
                        "name": "Bad Fallingbostel",
                        "latitude": "52.86641000",
                        "longitude": "9.69558000"
                    },
                    {
                        "id": 23800,
                        "name": "Bad Gandersheim",
                        "latitude": "51.87167000",
                        "longitude": "10.02537000"
                    },
                    {
                        "id": 23802,
                        "name": "Bad Grund",
                        "latitude": "51.81021000",
                        "longitude": "10.23694000"
                    },
                    {
                        "id": 23803,
                        "name": "Bad Harzburg",
                        "latitude": "51.88268000",
                        "longitude": "10.56157000"
                    },
                    {
                        "id": 23811,
                        "name": "Bad Iburg",
                        "latitude": "52.15490000",
                        "longitude": "8.04216000"
                    },
                    {
                        "id": 23823,
                        "name": "Bad Laer",
                        "latitude": "52.10000000",
                        "longitude": "8.08333000"
                    },
                    {
                        "id": 23827,
                        "name": "Bad Lauterberg im Harz",
                        "latitude": "51.63272000",
                        "longitude": "10.47031000"
                    },
                    {
                        "id": 23837,
                        "name": "Bad Münder am Deister",
                        "latitude": "52.19551000",
                        "longitude": "9.46421000"
                    },
                    {
                        "id": 23841,
                        "name": "Bad Nenndorf",
                        "latitude": "52.33703000",
                        "longitude": "9.37904000"
                    },
                    {
                        "id": 23848,
                        "name": "Bad Pyrmont",
                        "latitude": "51.98589000",
                        "longitude": "9.25246000"
                    },
                    {
                        "id": 23852,
                        "name": "Bad Rothenfelde",
                        "latitude": "52.11667000",
                        "longitude": "8.16667000"
                    },
                    {
                        "id": 23854,
                        "name": "Bad Sachsa",
                        "latitude": "51.59499000",
                        "longitude": "10.55546000"
                    },
                    {
                        "id": 23855,
                        "name": "Bad Salzdetfurth",
                        "latitude": "52.05777000",
                        "longitude": "10.00580000"
                    },
                    {
                        "id": 23890,
                        "name": "Bad Zwischenahn",
                        "latitude": "53.18333000",
                        "longitude": "8.00000000"
                    },
                    {
                        "id": 23892,
                        "name": "Badbergen",
                        "latitude": "52.63333000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 23893,
                        "name": "Baddeckenstedt",
                        "latitude": "52.08333000",
                        "longitude": "10.23333000"
                    },
                    {
                        "id": 23896,
                        "name": "Badenhausen",
                        "latitude": "51.76996000",
                        "longitude": "10.20493000"
                    },
                    {
                        "id": 23900,
                        "name": "Bahrdorf",
                        "latitude": "52.38587000",
                        "longitude": "11.00040000"
                    },
                    {
                        "id": 23901,
                        "name": "Bahrenborstel",
                        "latitude": "52.57009000",
                        "longitude": "8.80863000"
                    },
                    {
                        "id": 23908,
                        "name": "Bakum",
                        "latitude": "52.74118000",
                        "longitude": "8.19546000"
                    },
                    {
                        "id": 23909,
                        "name": "Balge",
                        "latitude": "52.71667000",
                        "longitude": "9.16667000"
                    },
                    {
                        "id": 23911,
                        "name": "Balje",
                        "latitude": "53.83333000",
                        "longitude": "9.13333000"
                    },
                    {
                        "id": 23922,
                        "name": "Banteln",
                        "latitude": "52.06667000",
                        "longitude": "9.75000000"
                    },
                    {
                        "id": 23927,
                        "name": "Bardowick",
                        "latitude": "53.29354000",
                        "longitude": "10.38811000"
                    },
                    {
                        "id": 23928,
                        "name": "Barenburg",
                        "latitude": "52.61953000",
                        "longitude": "8.79999000"
                    },
                    {
                        "id": 23929,
                        "name": "Barendorf",
                        "latitude": "53.22896000",
                        "longitude": "10.52158000"
                    },
                    {
                        "id": 23931,
                        "name": "Bargstedt",
                        "latitude": "53.46667000",
                        "longitude": "9.45000000"
                    },
                    {
                        "id": 23938,
                        "name": "Barnstorf",
                        "latitude": "52.71009000",
                        "longitude": "8.50256000"
                    },
                    {
                        "id": 23942,
                        "name": "Barsinghausen",
                        "latitude": "52.30000000",
                        "longitude": "9.45000000"
                    },
                    {
                        "id": 23950,
                        "name": "Barßel",
                        "latitude": "53.16981000",
                        "longitude": "7.75012000"
                    },
                    {
                        "id": 23946,
                        "name": "Barum",
                        "latitude": "53.35000000",
                        "longitude": "10.40000000"
                    },
                    {
                        "id": 23948,
                        "name": "Barver",
                        "latitude": "52.62066000",
                        "longitude": "8.59251000"
                    },
                    {
                        "id": 23949,
                        "name": "Barwedel",
                        "latitude": "52.52192000",
                        "longitude": "10.77488000"
                    },
                    {
                        "id": 23951,
                        "name": "Basdahl",
                        "latitude": "53.44502000",
                        "longitude": "9.00025000"
                    },
                    {
                        "id": 23953,
                        "name": "Bassum",
                        "latitude": "52.85059000",
                        "longitude": "8.72791000"
                    },
                    {
                        "id": 23964,
                        "name": "Bawinkel",
                        "latitude": "52.60000000",
                        "longitude": "7.40000000"
                    },
                    {
                        "id": 23976,
                        "name": "Beckdorf",
                        "latitude": "53.41667000",
                        "longitude": "9.61667000"
                    },
                    {
                        "id": 23977,
                        "name": "Beckedorf",
                        "latitude": "52.35000000",
                        "longitude": "9.31667000"
                    },
                    {
                        "id": 23981,
                        "name": "Beedenbostel",
                        "latitude": "52.64288000",
                        "longitude": "10.25907000"
                    },
                    {
                        "id": 23988,
                        "name": "Beesten",
                        "latitude": "52.43333000",
                        "longitude": "7.50000000"
                    },
                    {
                        "id": 23991,
                        "name": "Bei der Höhne",
                        "latitude": "53.51351000",
                        "longitude": "9.11191000"
                    },
                    {
                        "id": 24004,
                        "name": "Belm",
                        "latitude": "52.30000000",
                        "longitude": "8.13333000"
                    },
                    {
                        "id": 24007,
                        "name": "Bendestorf",
                        "latitude": "53.33583000",
                        "longitude": "9.96154000"
                    },
                    {
                        "id": 24031,
                        "name": "Berge",
                        "latitude": "52.62326000",
                        "longitude": "7.74550000"
                    },
                    {
                        "id": 24033,
                        "name": "Bergen",
                        "latitude": "52.80837000",
                        "longitude": "9.96374000"
                    },
                    {
                        "id": 24036,
                        "name": "Bergen an der Dumme",
                        "latitude": "52.89109000",
                        "longitude": "10.95629000"
                    },
                    {
                        "id": 24073,
                        "name": "Bersenbrück",
                        "latitude": "52.55160000",
                        "longitude": "7.94836000"
                    },
                    {
                        "id": 24077,
                        "name": "Berumbur",
                        "latitude": "53.60000000",
                        "longitude": "7.31667000"
                    },
                    {
                        "id": 24081,
                        "name": "Betheln",
                        "latitude": "52.11431000",
                        "longitude": "9.79397000"
                    },
                    {
                        "id": 24084,
                        "name": "Betzendorf",
                        "latitude": "53.13750000",
                        "longitude": "10.31273000"
                    },
                    {
                        "id": 24090,
                        "name": "Bevenrode",
                        "latitude": "52.34026000",
                        "longitude": "10.57743000"
                    },
                    {
                        "id": 24091,
                        "name": "Bevern",
                        "latitude": "51.85826000",
                        "longitude": "9.49408000"
                    },
                    {
                        "id": 24092,
                        "name": "Beverstedt",
                        "latitude": "53.43413000",
                        "longitude": "8.81915000"
                    },
                    {
                        "id": 24109,
                        "name": "Bienenbüttel",
                        "latitude": "53.14157000",
                        "longitude": "10.48679000"
                    },
                    {
                        "id": 24120,
                        "name": "Bilshausen",
                        "latitude": "51.62974000",
                        "longitude": "10.15859000"
                    },
                    {
                        "id": 24125,
                        "name": "Binnen",
                        "latitude": "52.61667000",
                        "longitude": "9.13333000"
                    },
                    {
                        "id": 24129,
                        "name": "Bippen",
                        "latitude": "52.58333000",
                        "longitude": "7.73333000"
                    },
                    {
                        "id": 24155,
                        "name": "Bispingen",
                        "latitude": "53.08312000",
                        "longitude": "9.99772000"
                    },
                    {
                        "id": 24156,
                        "name": "Bissendorf",
                        "latitude": "52.23333000",
                        "longitude": "8.16667000"
                    },
                    {
                        "id": 24175,
                        "name": "Bleckede",
                        "latitude": "53.28972000",
                        "longitude": "10.73372000"
                    },
                    {
                        "id": 24179,
                        "name": "Blender",
                        "latitude": "52.91667000",
                        "longitude": "9.13333000"
                    },
                    {
                        "id": 24180,
                        "name": "Bliedersdorf",
                        "latitude": "53.48333000",
                        "longitude": "9.56667000"
                    },
                    {
                        "id": 24185,
                        "name": "Blomberg",
                        "latitude": "53.57678000",
                        "longitude": "7.55824000"
                    },
                    {
                        "id": 24198,
                        "name": "Bockenem",
                        "latitude": "52.00993000",
                        "longitude": "10.13197000"
                    },
                    {
                        "id": 24200,
                        "name": "Bockhorn",
                        "latitude": "53.40000000",
                        "longitude": "8.01667000"
                    },
                    {
                        "id": 24202,
                        "name": "Bockhorst",
                        "latitude": "53.03296000",
                        "longitude": "7.57576000"
                    },
                    {
                        "id": 24204,
                        "name": "Bodenfelde",
                        "latitude": "51.64044000",
                        "longitude": "9.55569000"
                    },
                    {
                        "id": 24208,
                        "name": "Bodenwerder",
                        "latitude": "51.97156000",
                        "longitude": "9.51931000"
                    },
                    {
                        "id": 24213,
                        "name": "Boffzen",
                        "latitude": "51.75000000",
                        "longitude": "9.38333000"
                    },
                    {
                        "id": 24216,
                        "name": "Bohmte",
                        "latitude": "52.36667000",
                        "longitude": "8.31667000"
                    },
                    {
                        "id": 24219,
                        "name": "Bokel",
                        "latitude": "53.39326000",
                        "longitude": "8.76803000"
                    },
                    {
                        "id": 24228,
                        "name": "Bomlitz",
                        "latitude": "52.90000000",
                        "longitude": "9.65000000"
                    },
                    {
                        "id": 24472,
                        "name": "Börger",
                        "latitude": "52.91211000",
                        "longitude": "7.53576000"
                    },
                    {
                        "id": 24247,
                        "name": "Borkum",
                        "latitude": "53.58094000",
                        "longitude": "6.69153000"
                    },
                    {
                        "id": 24477,
                        "name": "Börßum",
                        "latitude": "52.06921000",
                        "longitude": "10.58431000"
                    },
                    {
                        "id": 24258,
                        "name": "Borstel",
                        "latitude": "52.67034000",
                        "longitude": "8.96896000"
                    },
                    {
                        "id": 24479,
                        "name": "Bösel",
                        "latitude": "53.00000000",
                        "longitude": "7.95000000"
                    },
                    {
                        "id": 24482,
                        "name": "Bötersen",
                        "latitude": "53.13333000",
                        "longitude": "9.31667000"
                    },
                    {
                        "id": 24262,
                        "name": "Bothel",
                        "latitude": "53.06667000",
                        "longitude": "9.50000000"
                    },
                    {
                        "id": 24266,
                        "name": "Bovenden",
                        "latitude": "51.58836000",
                        "longitude": "9.92220000"
                    },
                    {
                        "id": 24270,
                        "name": "Brackel",
                        "latitude": "53.29974000",
                        "longitude": "10.04860000"
                    },
                    {
                        "id": 24273,
                        "name": "Brake (Unterweser)",
                        "latitude": "53.33333000",
                        "longitude": "8.48333000"
                    },
                    {
                        "id": 24275,
                        "name": "Bramsche",
                        "latitude": "52.40881000",
                        "longitude": "7.97288000"
                    },
                    {
                        "id": 24276,
                        "name": "Bramstedt",
                        "latitude": "53.36603000",
                        "longitude": "8.69005000"
                    },
                    {
                        "id": 24288,
                        "name": "Braunlage",
                        "latitude": "51.72651000",
                        "longitude": "10.61090000"
                    },
                    {
                        "id": 24291,
                        "name": "Braunschweig",
                        "latitude": "52.26594000",
                        "longitude": "10.52673000"
                    },
                    {
                        "id": 24294,
                        "name": "Breddorf",
                        "latitude": "53.29262000",
                        "longitude": "9.08089000"
                    },
                    {
                        "id": 24322,
                        "name": "Bremervörde",
                        "latitude": "53.48458000",
                        "longitude": "9.14306000"
                    },
                    {
                        "id": 24334,
                        "name": "Brietlingen",
                        "latitude": "53.33333000",
                        "longitude": "10.45000000"
                    },
                    {
                        "id": 24339,
                        "name": "Brockel",
                        "latitude": "53.10000000",
                        "longitude": "9.51667000"
                    },
                    {
                        "id": 24340,
                        "name": "Brockum",
                        "latitude": "52.46667000",
                        "longitude": "8.41667000"
                    },
                    {
                        "id": 24345,
                        "name": "Brome",
                        "latitude": "52.60019000",
                        "longitude": "10.93754000"
                    },
                    {
                        "id": 24348,
                        "name": "Bruchhausen-Vilsen",
                        "latitude": "52.82931000",
                        "longitude": "8.99066000"
                    },
                    {
                        "id": 24370,
                        "name": "Brüggen",
                        "latitude": "52.04250000",
                        "longitude": "9.77450000"
                    },
                    {
                        "id": 24392,
                        "name": "Buchholz",
                        "latitude": "53.00884000",
                        "longitude": "9.56287000"
                    },
                    {
                        "id": 24393,
                        "name": "Buchholz in der Nordheide",
                        "latitude": "53.32641000",
                        "longitude": "9.86812000"
                    },
                    {
                        "id": 24490,
                        "name": "Bückeburg",
                        "latitude": "52.26065000",
                        "longitude": "9.04939000"
                    },
                    {
                        "id": 24491,
                        "name": "Bücken",
                        "latitude": "52.77876000",
                        "longitude": "9.13371000"
                    },
                    {
                        "id": 24492,
                        "name": "Büddenstedt",
                        "latitude": "52.17035000",
                        "longitude": "11.01877000"
                    },
                    {
                        "id": 24499,
                        "name": "Bühren",
                        "latitude": "52.80629000",
                        "longitude": "8.21880000"
                    },
                    {
                        "id": 24402,
                        "name": "Bunde",
                        "latitude": "53.18333000",
                        "longitude": "7.26667000"
                    },
                    {
                        "id": 24415,
                        "name": "Burgdorf",
                        "latitude": "52.44628000",
                        "longitude": "10.00640000"
                    },
                    {
                        "id": 24449,
                        "name": "Butjadingen",
                        "latitude": "53.54722000",
                        "longitude": "8.33500000"
                    },
                    {
                        "id": 24457,
                        "name": "Buxtehude",
                        "latitude": "53.46716000",
                        "longitude": "9.68636000"
                    },
                    {
                        "id": 24511,
                        "name": "Cadenberge",
                        "latitude": "53.76926000",
                        "longitude": "9.06269000"
                    },
                    {
                        "id": 24515,
                        "name": "Calberlah",
                        "latitude": "52.42074000",
                        "longitude": "10.62326000"
                    },
                    {
                        "id": 24521,
                        "name": "Cappeln",
                        "latitude": "52.81085000",
                        "longitude": "8.11474000"
                    },
                    {
                        "id": 24528,
                        "name": "Celle",
                        "latitude": "52.62264000",
                        "longitude": "10.08047000"
                    },
                    {
                        "id": 24538,
                        "name": "Clausthal-Zellerfeld",
                        "latitude": "51.80949000",
                        "longitude": "10.33821000"
                    },
                    {
                        "id": 24541,
                        "name": "Clenze",
                        "latitude": "52.93729000",
                        "longitude": "10.95750000"
                    },
                    {
                        "id": 24543,
                        "name": "Cloppenburg",
                        "latitude": "52.84754000",
                        "longitude": "8.04500000"
                    },
                    {
                        "id": 24552,
                        "name": "Coppenbrügge",
                        "latitude": "52.11852000",
                        "longitude": "9.54870000"
                    },
                    {
                        "id": 24560,
                        "name": "Cremlingen",
                        "latitude": "52.25000000",
                        "longitude": "10.65000000"
                    },
                    {
                        "id": 24570,
                        "name": "Cuxhaven",
                        "latitude": "53.87176000",
                        "longitude": "8.69087000"
                    },
                    {
                        "id": 24580,
                        "name": "Dahlenburg",
                        "latitude": "53.18767000",
                        "longitude": "10.73650000"
                    },
                    {
                        "id": 24588,
                        "name": "Damme",
                        "latitude": "52.52157000",
                        "longitude": "8.19793000"
                    },
                    {
                        "id": 24591,
                        "name": "Danndorf",
                        "latitude": "52.42472000",
                        "longitude": "10.91286000"
                    },
                    {
                        "id": 24592,
                        "name": "Dannenberg",
                        "latitude": "53.09670000",
                        "longitude": "11.09001000"
                    },
                    {
                        "id": 24599,
                        "name": "Dassel",
                        "latitude": "51.80179000",
                        "longitude": "9.68904000"
                    },
                    {
                        "id": 24608,
                        "name": "Dedelstorf",
                        "latitude": "52.70000000",
                        "longitude": "10.50000000"
                    },
                    {
                        "id": 24609,
                        "name": "Deensen",
                        "latitude": "51.86053000",
                        "longitude": "9.59322000"
                    },
                    {
                        "id": 24617,
                        "name": "Deinste",
                        "latitude": "53.52903000",
                        "longitude": "9.44376000"
                    },
                    {
                        "id": 24625,
                        "name": "Delligsen",
                        "latitude": "51.94120000",
                        "longitude": "9.80272000"
                    },
                    {
                        "id": 24626,
                        "name": "Delmenhorst",
                        "latitude": "53.05110000",
                        "longitude": "8.63091000"
                    },
                    {
                        "id": 24642,
                        "name": "Dersum",
                        "latitude": "52.96112000",
                        "longitude": "7.27394000"
                    },
                    {
                        "id": 24644,
                        "name": "Destedt",
                        "latitude": "52.23801000",
                        "longitude": "10.71063000"
                    },
                    {
                        "id": 24645,
                        "name": "Detern",
                        "latitude": "53.20927000",
                        "longitude": "7.67395000"
                    },
                    {
                        "id": 24646,
                        "name": "Detmerode",
                        "latitude": "52.39016000",
                        "longitude": "10.74480000"
                    },
                    {
                        "id": 24654,
                        "name": "Dettum",
                        "latitude": "52.17246000",
                        "longitude": "10.66807000"
                    },
                    {
                        "id": 24658,
                        "name": "Deutsch Evern",
                        "latitude": "53.20000000",
                        "longitude": "10.43333000"
                    },
                    {
                        "id": 24662,
                        "name": "Didderse",
                        "latitude": "52.38042000",
                        "longitude": "10.40294000"
                    },
                    {
                        "id": 24667,
                        "name": "Diekholzen",
                        "latitude": "52.09617000",
                        "longitude": "9.91945000"
                    },
                    {
                        "id": 24670,
                        "name": "Diepholz",
                        "latitude": "52.60783000",
                        "longitude": "8.37005000"
                    },
                    {
                        "id": 24697,
                        "name": "Dinklage",
                        "latitude": "52.66223000",
                        "longitude": "8.12440000"
                    },
                    {
                        "id": 24705,
                        "name": "Dissen",
                        "latitude": "52.11591000",
                        "longitude": "8.19956000"
                    },
                    {
                        "id": 24720,
                        "name": "Dohren",
                        "latitude": "52.65000000",
                        "longitude": "7.58333000"
                    },
                    {
                        "id": 24721,
                        "name": "Dollbergen",
                        "latitude": "52.40671000",
                        "longitude": "10.18098000"
                    },
                    {
                        "id": 24722,
                        "name": "Dollern",
                        "latitude": "53.53333000",
                        "longitude": "9.55000000"
                    },
                    {
                        "id": 24745,
                        "name": "Dornum",
                        "latitude": "53.64648000",
                        "longitude": "7.42957000"
                    },
                    {
                        "id": 24800,
                        "name": "Dörpen",
                        "latitude": "52.96469000",
                        "longitude": "7.32273000"
                    },
                    {
                        "id": 24748,
                        "name": "Dorum",
                        "latitude": "53.68790000",
                        "longitude": "8.56734000"
                    },
                    {
                        "id": 24802,
                        "name": "Dörverden",
                        "latitude": "52.85000000",
                        "longitude": "9.23333000"
                    },
                    {
                        "id": 24804,
                        "name": "Dötlingen",
                        "latitude": "52.93333000",
                        "longitude": "8.38333000"
                    },
                    {
                        "id": 24752,
                        "name": "Drage",
                        "latitude": "53.41667000",
                        "longitude": "10.26667000"
                    },
                    {
                        "id": 24753,
                        "name": "Drakenburg",
                        "latitude": "52.68689000",
                        "longitude": "9.21083000"
                    },
                    {
                        "id": 24754,
                        "name": "Drangstedt",
                        "latitude": "53.61359000",
                        "longitude": "8.75576000"
                    },
                    {
                        "id": 24755,
                        "name": "Dransfeld",
                        "latitude": "51.49910000",
                        "longitude": "9.76179000"
                    },
                    {
                        "id": 24767,
                        "name": "Drentwede",
                        "latitude": "52.74388000",
                        "longitude": "8.56504000"
                    },
                    {
                        "id": 24770,
                        "name": "Drochtersen",
                        "latitude": "53.71015000",
                        "longitude": "9.38463000"
                    },
                    {
                        "id": 24777,
                        "name": "Duderstadt",
                        "latitude": "51.51312000",
                        "longitude": "10.25951000"
                    },
                    {
                        "id": 24779,
                        "name": "Duingen",
                        "latitude": "52.00449000",
                        "longitude": "9.69578000"
                    },
                    {
                        "id": 24808,
                        "name": "Dünsen",
                        "latitude": "52.92749000",
                        "longitude": "8.64191000"
                    },
                    {
                        "id": 24783,
                        "name": "Dunum",
                        "latitude": "53.60000000",
                        "longitude": "7.65000000"
                    },
                    {
                        "id": 24827,
                        "name": "Ebergötzen",
                        "latitude": "51.57096000",
                        "longitude": "10.10632000"
                    },
                    {
                        "id": 24836,
                        "name": "Ebersdorf",
                        "latitude": "53.52514000",
                        "longitude": "9.04897000"
                    },
                    {
                        "id": 24844,
                        "name": "Ebstorf",
                        "latitude": "53.02785000",
                        "longitude": "10.41839000"
                    },
                    {
                        "id": 24845,
                        "name": "Echem",
                        "latitude": "53.33333000",
                        "longitude": "10.53333000"
                    },
                    {
                        "id": 24854,
                        "name": "Edemissen",
                        "latitude": "52.38702000",
                        "longitude": "10.26140000"
                    },
                    {
                        "id": 24859,
                        "name": "Edewecht",
                        "latitude": "53.12699000",
                        "longitude": "7.98406000"
                    },
                    {
                        "id": 24869,
                        "name": "Egestorf",
                        "latitude": "52.28568000",
                        "longitude": "9.51676000"
                    },
                    {
                        "id": 24875,
                        "name": "Eggermühlen",
                        "latitude": "52.56667000",
                        "longitude": "7.81667000"
                    },
                    {
                        "id": 24892,
                        "name": "Ehrenburg",
                        "latitude": "52.75000000",
                        "longitude": "8.70000000"
                    },
                    {
                        "id": 24909,
                        "name": "Eicklingen",
                        "latitude": "52.55037000",
                        "longitude": "10.18439000"
                    },
                    {
                        "id": 24915,
                        "name": "Eime",
                        "latitude": "52.07449000",
                        "longitude": "9.72118000"
                    },
                    {
                        "id": 24917,
                        "name": "Eimen",
                        "latitude": "51.88333000",
                        "longitude": "9.78333000"
                    },
                    {
                        "id": 24918,
                        "name": "Eimke",
                        "latitude": "52.96601000",
                        "longitude": "10.31324000"
                    },
                    {
                        "id": 24920,
                        "name": "Einbeck",
                        "latitude": "51.82018000",
                        "longitude": "9.86961000"
                    },
                    {
                        "id": 24922,
                        "name": "Eisdorf am Harz",
                        "latitude": "51.76152000",
                        "longitude": "10.17591000"
                    },
                    {
                        "id": 24939,
                        "name": "Elbe",
                        "latitude": "52.08333000",
                        "longitude": "10.28333000"
                    },
                    {
                        "id": 24942,
                        "name": "Eldingen",
                        "latitude": "52.68333000",
                        "longitude": "10.33333000"
                    },
                    {
                        "id": 24962,
                        "name": "Elsdorf",
                        "latitude": "53.24120000",
                        "longitude": "9.35056000"
                    },
                    {
                        "id": 24967,
                        "name": "Elsfleth",
                        "latitude": "53.23748000",
                        "longitude": "8.45664000"
                    },
                    {
                        "id": 24980,
                        "name": "Elze",
                        "latitude": "52.12263000",
                        "longitude": "9.73595000"
                    },
                    {
                        "id": 24981,
                        "name": "Embsen",
                        "latitude": "53.17606000",
                        "longitude": "10.34625000"
                    },
                    {
                        "id": 24982,
                        "name": "Emden",
                        "latitude": "53.36745000",
                        "longitude": "7.20778000"
                    },
                    {
                        "id": 24985,
                        "name": "Emlichheim",
                        "latitude": "52.61667000",
                        "longitude": "6.85000000"
                    },
                    {
                        "id": 24993,
                        "name": "Emsbüren",
                        "latitude": "52.40000000",
                        "longitude": "7.30000000"
                    },
                    {
                        "id": 24996,
                        "name": "Emstek",
                        "latitude": "52.83333000",
                        "longitude": "8.15000000"
                    },
                    {
                        "id": 24997,
                        "name": "Emtinghausen",
                        "latitude": "52.93333000",
                        "longitude": "8.96667000"
                    },
                    {
                        "id": 25000,
                        "name": "Engeln",
                        "latitude": "52.79363000",
                        "longitude": "8.91815000"
                    },
                    {
                        "id": 25047,
                        "name": "Erkerode",
                        "latitude": "52.20485000",
                        "longitude": "10.70982000"
                    },
                    {
                        "id": 25078,
                        "name": "Eschede",
                        "latitude": "52.73494000",
                        "longitude": "10.23540000"
                    },
                    {
                        "id": 25082,
                        "name": "Eschershausen",
                        "latitude": "51.92664000",
                        "longitude": "9.64282000"
                    },
                    {
                        "id": 25086,
                        "name": "Esens",
                        "latitude": "53.64866000",
                        "longitude": "7.61267000"
                    },
                    {
                        "id": 25092,
                        "name": "Essel",
                        "latitude": "52.69131000",
                        "longitude": "9.64141000"
                    },
                    {
                        "id": 25094,
                        "name": "Essen",
                        "latitude": "52.72258000",
                        "longitude": "7.93710000"
                    },
                    {
                        "id": 25103,
                        "name": "Esterwegen",
                        "latitude": "52.99288000",
                        "longitude": "7.63327000"
                    },
                    {
                        "id": 25105,
                        "name": "Estorf",
                        "latitude": "52.58850000",
                        "longitude": "9.14147000"
                    },
                    {
                        "id": 25121,
                        "name": "Evessen",
                        "latitude": "52.18888000",
                        "longitude": "10.71081000"
                    },
                    {
                        "id": 25122,
                        "name": "Eydelstedt",
                        "latitude": "52.69241000",
                        "longitude": "8.54668000"
                    },
                    {
                        "id": 25123,
                        "name": "Eyendorf",
                        "latitude": "53.20000000",
                        "longitude": "10.15000000"
                    },
                    {
                        "id": 25124,
                        "name": "Eystrup",
                        "latitude": "52.77935000",
                        "longitude": "9.21315000"
                    },
                    {
                        "id": 25146,
                        "name": "Faßberg",
                        "latitude": "52.90000000",
                        "longitude": "10.16667000"
                    },
                    {
                        "id": 25147,
                        "name": "Fedderwarden",
                        "latitude": "53.56142000",
                        "longitude": "8.04371000"
                    },
                    {
                        "id": 25171,
                        "name": "Filsum",
                        "latitude": "53.24213000",
                        "longitude": "7.62785000"
                    },
                    {
                        "id": 25177,
                        "name": "Fintel",
                        "latitude": "53.17188000",
                        "longitude": "9.66969000"
                    },
                    {
                        "id": 25201,
                        "name": "Flöthe",
                        "latitude": "52.08333000",
                        "longitude": "10.48333000"
                    },
                    {
                        "id": 25236,
                        "name": "Freden",
                        "latitude": "51.92771000",
                        "longitude": "9.89350000"
                    },
                    {
                        "id": 25241,
                        "name": "Freiburg",
                        "latitude": "53.82529000",
                        "longitude": "9.28803000"
                    },
                    {
                        "id": 25255,
                        "name": "Freren",
                        "latitude": "52.48700000",
                        "longitude": "7.54313000"
                    },
                    {
                        "id": 25272,
                        "name": "Friedeburg",
                        "latitude": "53.45000000",
                        "longitude": "7.83333000"
                    },
                    {
                        "id": 25283,
                        "name": "Friedland",
                        "latitude": "51.41917000",
                        "longitude": "9.91762000"
                    },
                    {
                        "id": 25300,
                        "name": "Friesoythe",
                        "latitude": "53.02260000",
                        "longitude": "7.85764000"
                    },
                    {
                        "id": 25326,
                        "name": "Fürstenau",
                        "latitude": "52.51667000",
                        "longitude": "7.67670000"
                    },
                    {
                        "id": 25327,
                        "name": "Fürstenberg",
                        "latitude": "51.73333000",
                        "longitude": "9.40000000"
                    },
                    {
                        "id": 25356,
                        "name": "Ganderkesee",
                        "latitude": "53.03333000",
                        "longitude": "8.53333000"
                    },
                    {
                        "id": 25360,
                        "name": "Garbsen",
                        "latitude": "52.41371000",
                        "longitude": "9.58990000"
                    },
                    {
                        "id": 25361,
                        "name": "Garbsen-Mitte",
                        "latitude": "52.42659000",
                        "longitude": "9.60383000"
                    },
                    {
                        "id": 25366,
                        "name": "Garlstorf",
                        "latitude": "53.23728000",
                        "longitude": "10.10137000"
                    },
                    {
                        "id": 25368,
                        "name": "Garrel",
                        "latitude": "52.95000000",
                        "longitude": "8.01667000"
                    },
                    {
                        "id": 25370,
                        "name": "Garstedt",
                        "latitude": "53.28467000",
                        "longitude": "10.16137000"
                    },
                    {
                        "id": 25372,
                        "name": "Gartow",
                        "latitude": "53.02470000",
                        "longitude": "11.46200000"
                    },
                    {
                        "id": 25389,
                        "name": "Geeste",
                        "latitude": "52.60000000",
                        "longitude": "7.26667000"
                    },
                    {
                        "id": 25392,
                        "name": "Gehrde",
                        "latitude": "52.57684000",
                        "longitude": "8.00342000"
                    },
                    {
                        "id": 25393,
                        "name": "Gehrden",
                        "latitude": "52.31362000",
                        "longitude": "9.60033000"
                    },
                    {
                        "id": 25419,
                        "name": "Gemeinde Friedland",
                        "latitude": "51.41667000",
                        "longitude": "9.93333000"
                    },
                    {
                        "id": 25432,
                        "name": "Georgsdorf",
                        "latitude": "52.56667000",
                        "longitude": "7.08333000"
                    },
                    {
                        "id": 25433,
                        "name": "Georgsmarienhütte",
                        "latitude": "52.20296000",
                        "longitude": "8.04480000"
                    },
                    {
                        "id": 25440,
                        "name": "Gerdau",
                        "latitude": "52.96667000",
                        "longitude": "10.41667000"
                    },
                    {
                        "id": 25461,
                        "name": "Gersten",
                        "latitude": "52.58333000",
                        "longitude": "7.51667000"
                    },
                    {
                        "id": 25481,
                        "name": "Gieboldehausen",
                        "latitude": "51.60962000",
                        "longitude": "10.21619000"
                    },
                    {
                        "id": 25486,
                        "name": "Giesen",
                        "latitude": "52.19716000",
                        "longitude": "9.89890000"
                    },
                    {
                        "id": 25488,
                        "name": "Gifhorn",
                        "latitude": "52.47774000",
                        "longitude": "10.55110000"
                    },
                    {
                        "id": 25492,
                        "name": "Gilten",
                        "latitude": "52.70000000",
                        "longitude": "9.58333000"
                    },
                    {
                        "id": 25498,
                        "name": "Gittelde",
                        "latitude": "51.79840000",
                        "longitude": "10.18780000"
                    },
                    {
                        "id": 25502,
                        "name": "Glandorf",
                        "latitude": "52.08474000",
                        "longitude": "7.99944000"
                    },
                    {
                        "id": 25522,
                        "name": "Gnarrenburg",
                        "latitude": "53.38333000",
                        "longitude": "9.00000000"
                    },
                    {
                        "id": 25532,
                        "name": "Goldenstedt",
                        "latitude": "52.78833000",
                        "longitude": "8.43201000"
                    },
                    {
                        "id": 25534,
                        "name": "Golmbach",
                        "latitude": "51.90000000",
                        "longitude": "9.55000000"
                    },
                    {
                        "id": 25547,
                        "name": "Goslar",
                        "latitude": "51.90425000",
                        "longitude": "10.42766000"
                    },
                    {
                        "id": 25788,
                        "name": "Göttingen",
                        "latitude": "51.53443000",
                        "longitude": "9.93228000"
                    },
                    {
                        "id": 25569,
                        "name": "Grafhorst",
                        "latitude": "52.44482000",
                        "longitude": "10.94513000"
                    },
                    {
                        "id": 25578,
                        "name": "Grasberg",
                        "latitude": "53.18333000",
                        "longitude": "8.98333000"
                    },
                    {
                        "id": 25580,
                        "name": "Grasleben",
                        "latitude": "52.30638000",
                        "longitude": "11.01465000"
                    },
                    {
                        "id": 25615,
                        "name": "Gronau",
                        "latitude": "52.08460000",
                        "longitude": "9.77678000"
                    },
                    {
                        "id": 25623,
                        "name": "Groß Ippener",
                        "latitude": "52.96667000",
                        "longitude": "8.61667000"
                    },
                    {
                        "id": 25631,
                        "name": "Groß Munzel",
                        "latitude": "52.36554000",
                        "longitude": "9.47828000"
                    },
                    {
                        "id": 25633,
                        "name": "Groß Oesingen",
                        "latitude": "52.64761000",
                        "longitude": "10.46366000"
                    },
                    {
                        "id": 25640,
                        "name": "Groß Twülpstedt",
                        "latitude": "52.37361000",
                        "longitude": "10.91929000"
                    },
                    {
                        "id": 25665,
                        "name": "Großenkneten",
                        "latitude": "52.94377000",
                        "longitude": "8.25323000"
                    },
                    {
                        "id": 25672,
                        "name": "Großgoltern",
                        "latitude": "52.33261000",
                        "longitude": "9.50111000"
                    },
                    {
                        "id": 25738,
                        "name": "Grünendeich",
                        "latitude": "53.56952000",
                        "longitude": "9.61218000"
                    },
                    {
                        "id": 25750,
                        "name": "Guderhandviertel",
                        "latitude": "53.54919000",
                        "longitude": "9.60960000"
                    },
                    {
                        "id": 25772,
                        "name": "Gyhum",
                        "latitude": "53.21667000",
                        "longitude": "9.31667000"
                    },
                    {
                        "id": 25815,
                        "name": "Hage",
                        "latitude": "53.60274000",
                        "longitude": "7.28527000"
                    },
                    {
                        "id": 25817,
                        "name": "Hagen",
                        "latitude": "52.19629000",
                        "longitude": "7.98041000"
                    },
                    {
                        "id": 25819,
                        "name": "Hagen im Bremischen",
                        "latitude": "53.35707000",
                        "longitude": "8.64341000"
                    },
                    {
                        "id": 25821,
                        "name": "Hagenburg",
                        "latitude": "52.43367000",
                        "longitude": "9.32473000"
                    },
                    {
                        "id": 25843,
                        "name": "Halbemond",
                        "latitude": "53.56710000",
                        "longitude": "7.29038000"
                    },
                    {
                        "id": 25852,
                        "name": "Halle",
                        "latitude": "51.99122000",
                        "longitude": "9.56532000"
                    },
                    {
                        "id": 25864,
                        "name": "Hambergen",
                        "latitude": "53.30826000",
                        "longitude": "8.82520000"
                    },
                    {
                        "id": 25870,
                        "name": "Hambühren",
                        "latitude": "52.63333000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 25872,
                        "name": "Hameln",
                        "latitude": "52.10397000",
                        "longitude": "9.35623000"
                    },
                    {
                        "id": 25875,
                        "name": "Hammah",
                        "latitude": "53.61667000",
                        "longitude": "9.36667000"
                    },
                    {
                        "id": 25883,
                        "name": "Handeloh",
                        "latitude": "53.24563000",
                        "longitude": "9.83923000"
                    },
                    {
                        "id": 25885,
                        "name": "Handorf",
                        "latitude": "53.34084000",
                        "longitude": "10.34652000"
                    },
                    {
                        "id": 26296,
                        "name": "Hänigsen",
                        "latitude": "52.48425000",
                        "longitude": "10.09129000"
                    },
                    {
                        "id": 25889,
                        "name": "Hankensbüttel",
                        "latitude": "52.73333000",
                        "longitude": "10.60000000"
                    },
                    {
                        "id": 25890,
                        "name": "Hannover",
                        "latitude": "52.37052000",
                        "longitude": "9.73322000"
                    },
                    {
                        "id": 25891,
                        "name": "Hannoversch Münden",
                        "latitude": "51.41505000",
                        "longitude": "9.65046000"
                    },
                    {
                        "id": 25893,
                        "name": "Hanstedt",
                        "latitude": "53.26667000",
                        "longitude": "10.01667000"
                    },
                    {
                        "id": 25894,
                        "name": "Hanstedt Eins",
                        "latitude": "53.04642000",
                        "longitude": "10.37444000"
                    },
                    {
                        "id": 25899,
                        "name": "Hardegsen",
                        "latitude": "51.65227000",
                        "longitude": "9.83050000"
                    },
                    {
                        "id": 25902,
                        "name": "Haren",
                        "latitude": "52.79262000",
                        "longitude": "7.24142000"
                    },
                    {
                        "id": 25904,
                        "name": "Harpstedt",
                        "latitude": "52.90942000",
                        "longitude": "8.58962000"
                    },
                    {
                        "id": 25907,
                        "name": "Harsefeld",
                        "latitude": "53.45399000",
                        "longitude": "9.50297000"
                    },
                    {
                        "id": 25910,
                        "name": "Harsum",
                        "latitude": "52.21045000",
                        "longitude": "9.96486000"
                    },
                    {
                        "id": 25920,
                        "name": "Hasbergen",
                        "latitude": "52.23754000",
                        "longitude": "7.96114000"
                    },
                    {
                        "id": 25927,
                        "name": "Haselünne",
                        "latitude": "52.67412000",
                        "longitude": "7.48460000"
                    },
                    {
                        "id": 25961,
                        "name": "Haßbergen",
                        "latitude": "52.73333000",
                        "longitude": "9.23333000"
                    },
                    {
                        "id": 25931,
                        "name": "Hassel",
                        "latitude": "52.69688000",
                        "longitude": "8.83198000"
                    },
                    {
                        "id": 25933,
                        "name": "Hassendorf",
                        "latitude": "53.10859000",
                        "longitude": "9.26482000"
                    },
                    {
                        "id": 25934,
                        "name": "Haste",
                        "latitude": "52.38105000",
                        "longitude": "9.39280000"
                    },
                    {
                        "id": 25935,
                        "name": "Hatten",
                        "latitude": "53.05000000",
                        "longitude": "8.38333000"
                    },
                    {
                        "id": 25941,
                        "name": "Hattorf",
                        "latitude": "51.65035000",
                        "longitude": "10.23681000"
                    },
                    {
                        "id": 25957,
                        "name": "Haverlah",
                        "latitude": "52.06667000",
                        "longitude": "10.16667000"
                    },
                    {
                        "id": 25969,
                        "name": "Hechthausen",
                        "latitude": "53.64041000",
                        "longitude": "9.23942000"
                    },
                    {
                        "id": 25973,
                        "name": "Heede",
                        "latitude": "52.99205000",
                        "longitude": "7.29830000"
                    },
                    {
                        "id": 25975,
                        "name": "Heemsen",
                        "latitude": "52.70000000",
                        "longitude": "9.26667000"
                    },
                    {
                        "id": 25976,
                        "name": "Heere",
                        "latitude": "52.06667000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 25977,
                        "name": "Heeslingen",
                        "latitude": "53.31667000",
                        "longitude": "9.33333000"
                    },
                    {
                        "id": 25978,
                        "name": "Heeßen",
                        "latitude": "52.23211000",
                        "longitude": "9.09642000"
                    },
                    {
                        "id": 25979,
                        "name": "Hehlen",
                        "latitude": "51.98858000",
                        "longitude": "9.47004000"
                    },
                    {
                        "id": 25984,
                        "name": "Heidenau",
                        "latitude": "53.31667000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 26011,
                        "name": "Heinade",
                        "latitude": "51.83333000",
                        "longitude": "9.63333000"
                    },
                    {
                        "id": 26012,
                        "name": "Heinböckel",
                        "latitude": "53.57457000",
                        "longitude": "9.32644000"
                    },
                    {
                        "id": 26016,
                        "name": "Heinsen",
                        "latitude": "52.06257000",
                        "longitude": "9.66316000"
                    },
                    {
                        "id": 26028,
                        "name": "Hellwege",
                        "latitude": "53.07346000",
                        "longitude": "9.23566000"
                    },
                    {
                        "id": 26032,
                        "name": "Helmstedt",
                        "latitude": "52.22790000",
                        "longitude": "11.00985000"
                    },
                    {
                        "id": 26033,
                        "name": "Helpsen",
                        "latitude": "52.31131000",
                        "longitude": "9.11676000"
                    },
                    {
                        "id": 26040,
                        "name": "Hemmingen",
                        "latitude": "52.31425000",
                        "longitude": "9.72359000"
                    },
                    {
                        "id": 26043,
                        "name": "Hemmoor",
                        "latitude": "53.68702000",
                        "longitude": "9.15492000"
                    },
                    {
                        "id": 26045,
                        "name": "Hemsbünde",
                        "latitude": "53.08998000",
                        "longitude": "9.47261000"
                    },
                    {
                        "id": 26046,
                        "name": "Hemslingen",
                        "latitude": "53.08333000",
                        "longitude": "9.60000000"
                    },
                    {
                        "id": 26056,
                        "name": "Hepstedt",
                        "latitude": "53.25874000",
                        "longitude": "9.08209000"
                    },
                    {
                        "id": 26075,
                        "name": "Hermannsburg",
                        "latitude": "52.83254000",
                        "longitude": "10.08957000"
                    },
                    {
                        "id": 26099,
                        "name": "Herzberg am Harz",
                        "latitude": "51.65546000",
                        "longitude": "10.33938000"
                    },
                    {
                        "id": 26101,
                        "name": "Herzlake",
                        "latitude": "52.68530000",
                        "longitude": "7.59946000"
                    },
                    {
                        "id": 26104,
                        "name": "Hesel",
                        "latitude": "53.30000000",
                        "longitude": "7.60000000"
                    },
                    {
                        "id": 26105,
                        "name": "Hespe",
                        "latitude": "52.32999000",
                        "longitude": "9.10818000"
                    },
                    {
                        "id": 26108,
                        "name": "Hessisch Oldendorf",
                        "latitude": "52.17269000",
                        "longitude": "9.24913000"
                    },
                    {
                        "id": 26122,
                        "name": "Heuerßen",
                        "latitude": "52.32946000",
                        "longitude": "9.27718000"
                    },
                    {
                        "id": 26127,
                        "name": "Heyersum",
                        "latitude": "52.15678000",
                        "longitude": "9.81265000"
                    },
                    {
                        "id": 26137,
                        "name": "Hildesheim",
                        "latitude": "52.15077000",
                        "longitude": "9.95112000"
                    },
                    {
                        "id": 26139,
                        "name": "Hilgermissen",
                        "latitude": "52.85000000",
                        "longitude": "9.16667000"
                    },
                    {
                        "id": 26143,
                        "name": "Hillerse",
                        "latitude": "51.68558000",
                        "longitude": "9.94973000"
                    },
                    {
                        "id": 26148,
                        "name": "Hilter",
                        "latitude": "52.13573000",
                        "longitude": "8.14715000"
                    },
                    {
                        "id": 26151,
                        "name": "Himbergen",
                        "latitude": "53.09418000",
                        "longitude": "10.72909000"
                    },
                    {
                        "id": 26153,
                        "name": "Himmelpforten",
                        "latitude": "53.61413000",
                        "longitude": "9.30516000"
                    },
                    {
                        "id": 26155,
                        "name": "Hinte",
                        "latitude": "53.41667000",
                        "longitude": "7.18333000"
                    },
                    {
                        "id": 26159,
                        "name": "Hipstedt",
                        "latitude": "53.48333000",
                        "longitude": "8.96667000"
                    },
                    {
                        "id": 26170,
                        "name": "Hitzacker",
                        "latitude": "53.15254000",
                        "longitude": "11.04418000"
                    },
                    {
                        "id": 26183,
                        "name": "Hodenhagen",
                        "latitude": "52.76506000",
                        "longitude": "9.59495000"
                    },
                    {
                        "id": 26206,
                        "name": "Hohenhameln",
                        "latitude": "52.25755000",
                        "longitude": "10.06416000"
                    },
                    {
                        "id": 26225,
                        "name": "Hohnhorst",
                        "latitude": "52.36942000",
                        "longitude": "9.37168000"
                    },
                    {
                        "id": 26228,
                        "name": "Holdorf",
                        "latitude": "52.58333000",
                        "longitude": "8.11667000"
                    },
                    {
                        "id": 26229,
                        "name": "Holle",
                        "latitude": "52.08721000",
                        "longitude": "10.16012000"
                    },
                    {
                        "id": 26232,
                        "name": "Hollenstedt",
                        "latitude": "53.36667000",
                        "longitude": "9.71667000"
                    },
                    {
                        "id": 26238,
                        "name": "Holtland",
                        "latitude": "53.28333000",
                        "longitude": "7.58333000"
                    },
                    {
                        "id": 26248,
                        "name": "Holzminden",
                        "latitude": "51.82798000",
                        "longitude": "9.44550000"
                    },
                    {
                        "id": 26253,
                        "name": "Hoogstede",
                        "latitude": "52.58333000",
                        "longitude": "6.95000000"
                    },
                    {
                        "id": 26316,
                        "name": "Hörden",
                        "latitude": "51.66835000",
                        "longitude": "10.28372000"
                    },
                    {
                        "id": 26267,
                        "name": "Hornburg",
                        "latitude": "52.03095000",
                        "longitude": "10.60490000"
                    },
                    {
                        "id": 26268,
                        "name": "Horneburg",
                        "latitude": "53.50672000",
                        "longitude": "9.57546000"
                    },
                    {
                        "id": 26273,
                        "name": "Horstedt",
                        "latitude": "53.18333000",
                        "longitude": "9.23333000"
                    },
                    {
                        "id": 26276,
                        "name": "Hoya",
                        "latitude": "52.80781000",
                        "longitude": "9.14028000"
                    },
                    {
                        "id": 26279,
                        "name": "Hude",
                        "latitude": "53.10766000",
                        "longitude": "8.46322000"
                    },
                    {
                        "id": 26280,
                        "name": "Huede",
                        "latitude": "52.49588000",
                        "longitude": "8.35804000"
                    },
                    {
                        "id": 26336,
                        "name": "Hülsede",
                        "latitude": "52.24951000",
                        "longitude": "9.36147000"
                    },
                    {
                        "id": 26291,
                        "name": "Husum",
                        "latitude": "52.56667000",
                        "longitude": "9.25000000"
                    },
                    {
                        "id": 26360,
                        "name": "Ihlienworth",
                        "latitude": "53.73333000",
                        "longitude": "8.91667000"
                    },
                    {
                        "id": 26374,
                        "name": "Ilsede",
                        "latitude": "52.26340000",
                        "longitude": "10.19922000"
                    },
                    {
                        "id": 26412,
                        "name": "Isenbüttel",
                        "latitude": "52.43333000",
                        "longitude": "10.58333000"
                    },
                    {
                        "id": 26414,
                        "name": "Isernhagen Farster Bauerschaft",
                        "latitude": "52.47093000",
                        "longitude": "9.84179000"
                    },
                    {
                        "id": 26420,
                        "name": "Itterbeck",
                        "latitude": "52.50618000",
                        "longitude": "6.80354000"
                    },
                    {
                        "id": 26428,
                        "name": "Jameln",
                        "latitude": "53.05000000",
                        "longitude": "11.08333000"
                    },
                    {
                        "id": 26433,
                        "name": "Jembke",
                        "latitude": "52.50000000",
                        "longitude": "10.76667000"
                    },
                    {
                        "id": 26434,
                        "name": "Jemgum",
                        "latitude": "53.26667000",
                        "longitude": "7.38333000"
                    },
                    {
                        "id": 26440,
                        "name": "Jerxheim",
                        "latitude": "52.08172000",
                        "longitude": "10.89844000"
                    },
                    {
                        "id": 26445,
                        "name": "Jesteburg",
                        "latitude": "53.30966000",
                        "longitude": "9.95262000"
                    },
                    {
                        "id": 26450,
                        "name": "Jever",
                        "latitude": "53.57368000",
                        "longitude": "7.89806000"
                    },
                    {
                        "id": 26458,
                        "name": "Jork",
                        "latitude": "53.53198000",
                        "longitude": "9.68076000"
                    },
                    {
                        "id": 26472,
                        "name": "Jühnde",
                        "latitude": "51.46667000",
                        "longitude": "9.80000000"
                    },
                    {
                        "id": 26461,
                        "name": "Juist",
                        "latitude": "53.67787000",
                        "longitude": "6.99575000"
                    },
                    {
                        "id": 26485,
                        "name": "Kakenstorf",
                        "latitude": "53.30317000",
                        "longitude": "9.76289000"
                    },
                    {
                        "id": 26488,
                        "name": "Kalefeld",
                        "latitude": "51.80000000",
                        "longitude": "10.03333000"
                    },
                    {
                        "id": 26536,
                        "name": "Katlenburg-Lindau",
                        "latitude": "51.68333000",
                        "longitude": "10.10000000"
                    },
                    {
                        "id": 26576,
                        "name": "Kettenkamp",
                        "latitude": "52.58333000",
                        "longitude": "7.83333000"
                    },
                    {
                        "id": 26601,
                        "name": "Kirchbrak",
                        "latitude": "51.96585000",
                        "longitude": "9.57510000"
                    },
                    {
                        "id": 26604,
                        "name": "Kirchdorf",
                        "latitude": "52.59523000",
                        "longitude": "8.83490000"
                    },
                    {
                        "id": 26614,
                        "name": "Kirchgellersen",
                        "latitude": "53.23333000",
                        "longitude": "10.30000000"
                    },
                    {
                        "id": 26630,
                        "name": "Kirchlinteln",
                        "latitude": "52.94236000",
                        "longitude": "9.31811000"
                    },
                    {
                        "id": 26632,
                        "name": "Kirchseelte",
                        "latitude": "52.95000000",
                        "longitude": "8.68333000"
                    },
                    {
                        "id": 26634,
                        "name": "Kirchtimke",
                        "latitude": "53.25000000",
                        "longitude": "9.15000000"
                    },
                    {
                        "id": 26636,
                        "name": "Kirchwalsede",
                        "latitude": "53.01667000",
                        "longitude": "9.40000000"
                    },
                    {
                        "id": 26648,
                        "name": "Kissenbrück",
                        "latitude": "52.10956000",
                        "longitude": "10.58996000"
                    },
                    {
                        "id": 26658,
                        "name": "Klein Berßen",
                        "latitude": "52.76797000",
                        "longitude": "7.46182000"
                    },
                    {
                        "id": 26659,
                        "name": "Klein Gusborn",
                        "latitude": "53.08331000",
                        "longitude": "11.19323000"
                    },
                    {
                        "id": 26665,
                        "name": "Klein Schwülper",
                        "latitude": "52.34153000",
                        "longitude": "10.42903000"
                    },
                    {
                        "id": 26697,
                        "name": "Kluse",
                        "latitude": "52.93633000",
                        "longitude": "7.34093000"
                    },
                    {
                        "id": 26833,
                        "name": "Königslutter am Elm",
                        "latitude": "52.25116000",
                        "longitude": "10.81683000"
                    },
                    {
                        "id": 26745,
                        "name": "Krebeck",
                        "latitude": "51.58333000",
                        "longitude": "10.11667000"
                    },
                    {
                        "id": 26747,
                        "name": "Kreiensen",
                        "latitude": "51.85363000",
                        "longitude": "9.96481000"
                    },
                    {
                        "id": 26851,
                        "name": "Kührstedt",
                        "latitude": "53.57747000",
                        "longitude": "8.80091000"
                    },
                    {
                        "id": 26861,
                        "name": "Küsten",
                        "latitude": "52.97779000",
                        "longitude": "11.06240000"
                    },
                    {
                        "id": 26808,
                        "name": "Kutenholz",
                        "latitude": "53.48152000",
                        "longitude": "9.32118000"
                    },
                    {
                        "id": 26863,
                        "name": "Laar",
                        "latitude": "52.35581000",
                        "longitude": "8.25388000"
                    },
                    {
                        "id": 26864,
                        "name": "Laatzen",
                        "latitude": "52.31506000",
                        "longitude": "9.79739000"
                    },
                    {
                        "id": 26869,
                        "name": "Lachendorf",
                        "latitude": "52.61667000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 27184,
                        "name": "Lähden",
                        "latitude": "52.74547000",
                        "longitude": "7.57036000"
                    },
                    {
                        "id": 26887,
                        "name": "Lamspringe",
                        "latitude": "51.96071000",
                        "longitude": "10.01105000"
                    },
                    {
                        "id": 26888,
                        "name": "Lamstedt",
                        "latitude": "53.63333000",
                        "longitude": "9.10000000"
                    },
                    {
                        "id": 26891,
                        "name": "Landesbergen",
                        "latitude": "52.55598000",
                        "longitude": "9.12505000"
                    },
                    {
                        "id": 26892,
                        "name": "Landolfshausen",
                        "latitude": "51.53333000",
                        "longitude": "10.10000000"
                    },
                    {
                        "id": 26901,
                        "name": "Langelsheim",
                        "latitude": "51.93789000",
                        "longitude": "10.33264000"
                    },
                    {
                        "id": 26903,
                        "name": "Langen",
                        "latitude": "53.60554000",
                        "longitude": "8.59509000"
                    },
                    {
                        "id": 26919,
                        "name": "Langenhagen",
                        "latitude": "52.44758000",
                        "longitude": "9.73741000"
                    },
                    {
                        "id": 26933,
                        "name": "Langeoog",
                        "latitude": "53.75000000",
                        "longitude": "7.48333000"
                    },
                    {
                        "id": 26939,
                        "name": "Langlingen",
                        "latitude": "52.55593000",
                        "longitude": "10.28291000"
                    },
                    {
                        "id": 26945,
                        "name": "Langwedel",
                        "latitude": "52.97864000",
                        "longitude": "9.18542000"
                    },
                    {
                        "id": 26953,
                        "name": "Lastrup",
                        "latitude": "52.79468000",
                        "longitude": "7.86715000"
                    },
                    {
                        "id": 26954,
                        "name": "Lathen",
                        "latitude": "52.86667000",
                        "longitude": "7.31667000"
                    },
                    {
                        "id": 26966,
                        "name": "Lauenau",
                        "latitude": "52.27393000",
                        "longitude": "9.36928000"
                    },
                    {
                        "id": 26967,
                        "name": "Lauenbrück",
                        "latitude": "53.20000000",
                        "longitude": "9.56667000"
                    },
                    {
                        "id": 26969,
                        "name": "Lauenhagen",
                        "latitude": "52.35547000",
                        "longitude": "9.20637000"
                    },
                    {
                        "id": 26999,
                        "name": "Leer",
                        "latitude": "53.23157000",
                        "longitude": "7.46100000"
                    },
                    {
                        "id": 27000,
                        "name": "Leese",
                        "latitude": "52.50000000",
                        "longitude": "9.11667000"
                    },
                    {
                        "id": 27001,
                        "name": "Leezdorf",
                        "latitude": "53.55000000",
                        "longitude": "7.30000000"
                    },
                    {
                        "id": 27011,
                        "name": "Lehre",
                        "latitude": "52.33333000",
                        "longitude": "10.66667000"
                    },
                    {
                        "id": 27013,
                        "name": "Lehrte",
                        "latitude": "52.37193000",
                        "longitude": "9.97919000"
                    },
                    {
                        "id": 27018,
                        "name": "Leiferde",
                        "latitude": "52.20445000",
                        "longitude": "10.50842000"
                    },
                    {
                        "id": 27034,
                        "name": "Lemförde",
                        "latitude": "52.46557000",
                        "longitude": "8.37621000"
                    },
                    {
                        "id": 27037,
                        "name": "Lemwerder",
                        "latitude": "53.16667000",
                        "longitude": "8.61667000"
                    },
                    {
                        "id": 27039,
                        "name": "Lengede",
                        "latitude": "52.20487000",
                        "longitude": "10.30775000"
                    },
                    {
                        "id": 27043,
                        "name": "Lengerich",
                        "latitude": "52.55381000",
                        "longitude": "7.53164000"
                    },
                    {
                        "id": 27087,
                        "name": "Liebenau",
                        "latitude": "52.60362000",
                        "longitude": "9.09719000"
                    },
                    {
                        "id": 27088,
                        "name": "Liebenburg",
                        "latitude": "52.02176000",
                        "longitude": "10.43169000"
                    },
                    {
                        "id": 27096,
                        "name": "Lilienthal",
                        "latitude": "53.14193000",
                        "longitude": "8.90338000"
                    },
                    {
                        "id": 27110,
                        "name": "Lindhorst",
                        "latitude": "52.35789000",
                        "longitude": "9.28319000"
                    },
                    {
                        "id": 27113,
                        "name": "Lindwedel",
                        "latitude": "52.60784000",
                        "longitude": "9.68737000"
                    },
                    {
                        "id": 27114,
                        "name": "Lingen",
                        "latitude": "52.52143000",
                        "longitude": "7.31845000"
                    },
                    {
                        "id": 27118,
                        "name": "Lintig",
                        "latitude": "53.60341000",
                        "longitude": "8.87876000"
                    },
                    {
                        "id": 27135,
                        "name": "Lohne",
                        "latitude": "52.66625000",
                        "longitude": "8.23750000"
                    },
                    {
                        "id": 27196,
                        "name": "Löningen",
                        "latitude": "52.73678000",
                        "longitude": "7.75809000"
                    },
                    {
                        "id": 27150,
                        "name": "Lorup",
                        "latitude": "52.92495000",
                        "longitude": "7.64339000"
                    },
                    {
                        "id": 27156,
                        "name": "Loxstedt",
                        "latitude": "53.46667000",
                        "longitude": "8.65000000"
                    },
                    {
                        "id": 27210,
                        "name": "Lüchow",
                        "latitude": "52.96811000",
                        "longitude": "11.15397000"
                    },
                    {
                        "id": 27212,
                        "name": "Lüder",
                        "latitude": "52.80878000",
                        "longitude": "10.66609000"
                    },
                    {
                        "id": 27215,
                        "name": "Lüdersfeld",
                        "latitude": "52.35993000",
                        "longitude": "9.25422000"
                    },
                    {
                        "id": 27170,
                        "name": "Luhden",
                        "latitude": "52.22538000",
                        "longitude": "9.09256000"
                    },
                    {
                        "id": 27218,
                        "name": "Lüneburg",
                        "latitude": "53.25090000",
                        "longitude": "10.41409000"
                    },
                    {
                        "id": 27175,
                        "name": "Lunestedt",
                        "latitude": "53.43621000",
                        "longitude": "8.75193000"
                    },
                    {
                        "id": 27220,
                        "name": "Lünne",
                        "latitude": "52.42958000",
                        "longitude": "7.42653000"
                    },
                    {
                        "id": 27180,
                        "name": "Lutter am Barenberge",
                        "latitude": "51.98943000",
                        "longitude": "10.26930000"
                    },
                    {
                        "id": 27276,
                        "name": "Marienhafe",
                        "latitude": "53.52274000",
                        "longitude": "7.27306000"
                    },
                    {
                        "id": 27279,
                        "name": "Mariental",
                        "latitude": "52.27593000",
                        "longitude": "10.98371000"
                    },
                    {
                        "id": 27289,
                        "name": "Marklohe",
                        "latitude": "52.66857000",
                        "longitude": "9.14219000"
                    },
                    {
                        "id": 27326,
                        "name": "Marschacht",
                        "latitude": "53.41520000",
                        "longitude": "10.37524000"
                    },
                    {
                        "id": 27328,
                        "name": "Martfeld",
                        "latitude": "52.87572000",
                        "longitude": "9.06081000"
                    },
                    {
                        "id": 27332,
                        "name": "Marxen",
                        "latitude": "53.31211000",
                        "longitude": "10.00415000"
                    },
                    {
                        "id": 27366,
                        "name": "Meerbeck",
                        "latitude": "52.34174000",
                        "longitude": "9.15067000"
                    },
                    {
                        "id": 27368,
                        "name": "Meerdorf",
                        "latitude": "52.34583000",
                        "longitude": "10.31745000"
                    },
                    {
                        "id": 27381,
                        "name": "Meinersen",
                        "latitude": "52.47436000",
                        "longitude": "10.35247000"
                    },
                    {
                        "id": 27390,
                        "name": "Melbeck",
                        "latitude": "53.18333000",
                        "longitude": "10.40000000"
                    },
                    {
                        "id": 27393,
                        "name": "Melle",
                        "latitude": "52.20197000",
                        "longitude": "8.33826000"
                    },
                    {
                        "id": 27396,
                        "name": "Mellinghausen",
                        "latitude": "52.70697000",
                        "longitude": "8.89704000"
                    },
                    {
                        "id": 27411,
                        "name": "Menslage",
                        "latitude": "52.68333000",
                        "longitude": "7.81667000"
                    },
                    {
                        "id": 27413,
                        "name": "Meppen",
                        "latitude": "52.69064000",
                        "longitude": "7.29097000"
                    },
                    {
                        "id": 27428,
                        "name": "Merzen",
                        "latitude": "52.48333000",
                        "longitude": "7.83333000"
                    },
                    {
                        "id": 27435,
                        "name": "Messingen",
                        "latitude": "52.46667000",
                        "longitude": "7.46667000"
                    },
                    {
                        "id": 27458,
                        "name": "Midlum",
                        "latitude": "53.73135000",
                        "longitude": "8.61695000"
                    },
                    {
                        "id": 27479,
                        "name": "Mittegroßefehn",
                        "latitude": "53.39165000",
                        "longitude": "7.56602000"
                    },
                    {
                        "id": 27503,
                        "name": "Moisburg",
                        "latitude": "53.40620000",
                        "longitude": "9.69880000"
                    },
                    {
                        "id": 27504,
                        "name": "Molbergen",
                        "latitude": "52.85805000",
                        "longitude": "7.92548000"
                    },
                    {
                        "id": 27524,
                        "name": "Moringen",
                        "latitude": "51.69915000",
                        "longitude": "9.87107000"
                    },
                    {
                        "id": 27527,
                        "name": "Morsum",
                        "latitude": "52.95347000",
                        "longitude": "9.07962000"
                    },
                    {
                        "id": 27585,
                        "name": "Müden",
                        "latitude": "52.52771000",
                        "longitude": "10.36011000"
                    },
                    {
                        "id": 27543,
                        "name": "Munster",
                        "latitude": "52.98569000",
                        "longitude": "10.08756000"
                    },
                    {
                        "id": 27637,
                        "name": "Nahrendorf",
                        "latitude": "53.17389000",
                        "longitude": "10.81381000"
                    },
                    {
                        "id": 27687,
                        "name": "Neu Darchau",
                        "latitude": "53.22901000",
                        "longitude": "10.88529000"
                    },
                    {
                        "id": 27690,
                        "name": "Neu Wulmstorf",
                        "latitude": "53.46667000",
                        "longitude": "9.80000000"
                    },
                    {
                        "id": 27710,
                        "name": "Neubörger",
                        "latitude": "52.95815000",
                        "longitude": "7.44839000"
                    },
                    {
                        "id": 27703,
                        "name": "Neubrück",
                        "latitude": "52.37088000",
                        "longitude": "10.41761000"
                    },
                    {
                        "id": 27721,
                        "name": "Neuenkirchen",
                        "latitude": "52.13778000",
                        "longitude": "8.38835000"
                    },
                    {
                        "id": 27738,
                        "name": "Neuharlingersiel",
                        "latitude": "53.69993000",
                        "longitude": "7.70288000"
                    },
                    {
                        "id": 27742,
                        "name": "Neuhaus an der Oste",
                        "latitude": "53.80043000",
                        "longitude": "9.03348000"
                    },
                    {
                        "id": 27754,
                        "name": "Neukamperfehn",
                        "latitude": "53.33642000",
                        "longitude": "7.56189000"
                    },
                    {
                        "id": 27799,
                        "name": "Neustadt am Rübenberge",
                        "latitude": "52.50462000",
                        "longitude": "9.45871000"
                    },
                    {
                        "id": 27855,
                        "name": "Niederlangen",
                        "latitude": "52.85712000",
                        "longitude": "7.28199000"
                    },
                    {
                        "id": 27865,
                        "name": "Niedernwöhren",
                        "latitude": "52.35214000",
                        "longitude": "9.14788000"
                    },
                    {
                        "id": 27892,
                        "name": "Nienburg",
                        "latitude": "52.64610000",
                        "longitude": "9.22086000"
                    },
                    {
                        "id": 27895,
                        "name": "Nienstädt",
                        "latitude": "52.29242000",
                        "longitude": "9.16440000"
                    },
                    {
                        "id": 27911,
                        "name": "Norddeich",
                        "latitude": "53.61349000",
                        "longitude": "7.16043000"
                    },
                    {
                        "id": 27912,
                        "name": "Norden",
                        "latitude": "53.59552000",
                        "longitude": "7.20639000"
                    },
                    {
                        "id": 27914,
                        "name": "Nordenham",
                        "latitude": "53.48610000",
                        "longitude": "8.48093000"
                    },
                    {
                        "id": 27915,
                        "name": "Norderney",
                        "latitude": "53.70828000",
                        "longitude": "7.15819000"
                    },
                    {
                        "id": 27922,
                        "name": "Nordholz",
                        "latitude": "53.78448000",
                        "longitude": "8.61354000"
                    },
                    {
                        "id": 27923,
                        "name": "Nordhorn",
                        "latitude": "52.43081000",
                        "longitude": "7.06833000"
                    },
                    {
                        "id": 27925,
                        "name": "Nordleda",
                        "latitude": "53.76667000",
                        "longitude": "8.83333000"
                    },
                    {
                        "id": 27927,
                        "name": "Nordstemmen",
                        "latitude": "52.16196000",
                        "longitude": "9.78350000"
                    },
                    {
                        "id": 27947,
                        "name": "Nörten-Hardenberg",
                        "latitude": "51.62878000",
                        "longitude": "9.93593000"
                    },
                    {
                        "id": 27930,
                        "name": "Northeim",
                        "latitude": "51.70662000",
                        "longitude": "9.99997000"
                    },
                    {
                        "id": 27931,
                        "name": "Nortmoor",
                        "latitude": "53.24608000",
                        "longitude": "7.57178000"
                    },
                    {
                        "id": 27933,
                        "name": "Nortrup",
                        "latitude": "52.61503000",
                        "longitude": "7.86072000"
                    },
                    {
                        "id": 27936,
                        "name": "Nottensdorf",
                        "latitude": "53.48333000",
                        "longitude": "9.60000000"
                    },
                    {
                        "id": 28005,
                        "name": "Oberndorf",
                        "latitude": "53.75000000",
                        "longitude": "9.15000000"
                    },
                    {
                        "id": 28007,
                        "name": "Obernfeld",
                        "latitude": "51.55000000",
                        "longitude": "10.23333000"
                    },
                    {
                        "id": 28010,
                        "name": "Obernkirchen",
                        "latitude": "52.27210000",
                        "longitude": "9.12912000"
                    },
                    {
                        "id": 28074,
                        "name": "Oederquart",
                        "latitude": "53.80267000",
                        "longitude": "9.23680000"
                    },
                    {
                        "id": 28080,
                        "name": "Oerel",
                        "latitude": "53.48333000",
                        "longitude": "9.05000000"
                    },
                    {
                        "id": 28105,
                        "name": "Oldenburg",
                        "latitude": "53.14118000",
                        "longitude": "8.21467000"
                    },
                    {
                        "id": 28108,
                        "name": "Oldendorf",
                        "latitude": "53.15580000",
                        "longitude": "10.21431000"
                    },
                    {
                        "id": 28139,
                        "name": "Osloß",
                        "latitude": "52.46925000",
                        "longitude": "10.68011000"
                    },
                    {
                        "id": 28140,
                        "name": "Osnabrück",
                        "latitude": "52.27264000",
                        "longitude": "8.04980000"
                    },
                    {
                        "id": 28143,
                        "name": "Osteel",
                        "latitude": "53.54417000",
                        "longitude": "7.25400000"
                    },
                    {
                        "id": 28145,
                        "name": "Osten",
                        "latitude": "53.70000000",
                        "longitude": "9.20000000"
                    },
                    {
                        "id": 28149,
                        "name": "Ostercappeln",
                        "latitude": "52.35000000",
                        "longitude": "8.23333000"
                    },
                    {
                        "id": 28153,
                        "name": "Osterholz-Scharmbeck",
                        "latitude": "53.22698000",
                        "longitude": "8.79528000"
                    },
                    {
                        "id": 28156,
                        "name": "Osterode am Harz",
                        "latitude": "51.72686000",
                        "longitude": "10.25089000"
                    },
                    {
                        "id": 28166,
                        "name": "Ostrhauderfehn",
                        "latitude": "53.13333000",
                        "longitude": "7.61667000"
                    },
                    {
                        "id": 28183,
                        "name": "Ottenstein",
                        "latitude": "51.94707000",
                        "longitude": "9.40700000"
                    },
                    {
                        "id": 28184,
                        "name": "Otter",
                        "latitude": "53.24015000",
                        "longitude": "9.74247000"
                    },
                    {
                        "id": 28188,
                        "name": "Otterndorf",
                        "latitude": "53.80908000",
                        "longitude": "8.90068000"
                    },
                    {
                        "id": 28189,
                        "name": "Ottersberg",
                        "latitude": "53.10990000",
                        "longitude": "9.14408000"
                    },
                    {
                        "id": 28199,
                        "name": "Ovelgönne",
                        "latitude": "53.34189000",
                        "longitude": "8.42179000"
                    },
                    {
                        "id": 28205,
                        "name": "Oyten",
                        "latitude": "53.05000000",
                        "longitude": "9.01667000"
                    },
                    {
                        "id": 28218,
                        "name": "Papenburg",
                        "latitude": "53.07738000",
                        "longitude": "7.40444000"
                    },
                    {
                        "id": 28225,
                        "name": "Parsau",
                        "latitude": "52.53471000",
                        "longitude": "10.89020000"
                    },
                    {
                        "id": 28234,
                        "name": "Pattensen",
                        "latitude": "52.26448000",
                        "longitude": "9.76436000"
                    },
                    {
                        "id": 28242,
                        "name": "Peine",
                        "latitude": "52.31928000",
                        "longitude": "10.23520000"
                    },
                    {
                        "id": 28253,
                        "name": "Pennigsehl",
                        "latitude": "52.64181000",
                        "longitude": "9.02630000"
                    },
                    {
                        "id": 28343,
                        "name": "Polle",
                        "latitude": "51.89871000",
                        "longitude": "9.40386000"
                    },
                    {
                        "id": 28345,
                        "name": "Pollhagen",
                        "latitude": "52.38529000",
                        "longitude": "9.18813000"
                    },
                    {
                        "id": 28424,
                        "name": "Quakenbrück",
                        "latitude": "52.67502000",
                        "longitude": "7.94983000"
                    },
                    {
                        "id": 28439,
                        "name": "Radbruch",
                        "latitude": "53.31667000",
                        "longitude": "10.28333000"
                    },
                    {
                        "id": 28440,
                        "name": "Raddestorf",
                        "latitude": "52.45000000",
                        "longitude": "8.96667000"
                    },
                    {
                        "id": 28480,
                        "name": "Rastede",
                        "latitude": "53.25000000",
                        "longitude": "8.20000000"
                    },
                    {
                        "id": 28505,
                        "name": "Rechtsupweg",
                        "latitude": "53.53333000",
                        "longitude": "7.33333000"
                    },
                    {
                        "id": 28511,
                        "name": "Reeßum",
                        "latitude": "53.13333000",
                        "longitude": "9.21667000"
                    },
                    {
                        "id": 28515,
                        "name": "Regesbostel",
                        "latitude": "53.38333000",
                        "longitude": "9.65000000"
                    },
                    {
                        "id": 28529,
                        "name": "Rehburg-Loccum",
                        "latitude": "52.46952000",
                        "longitude": "9.19957000"
                    },
                    {
                        "id": 28530,
                        "name": "Rehden",
                        "latitude": "52.61024000",
                        "longitude": "8.48093000"
                    },
                    {
                        "id": 28566,
                        "name": "Reinstorf",
                        "latitude": "53.23445000",
                        "longitude": "10.57323000"
                    },
                    {
                        "id": 28573,
                        "name": "Remlingen",
                        "latitude": "52.11367000",
                        "longitude": "10.67408000"
                    },
                    {
                        "id": 28585,
                        "name": "Reppenstedt",
                        "latitude": "53.25000000",
                        "longitude": "10.35000000"
                    },
                    {
                        "id": 28587,
                        "name": "Rethem",
                        "latitude": "52.78621000",
                        "longitude": "9.37862000"
                    },
                    {
                        "id": 28588,
                        "name": "Rethen",
                        "latitude": "52.37707000",
                        "longitude": "10.47855000"
                    },
                    {
                        "id": 28598,
                        "name": "Rhade",
                        "latitude": "53.32872000",
                        "longitude": "9.11350000"
                    },
                    {
                        "id": 28602,
                        "name": "Rhede",
                        "latitude": "53.06020000",
                        "longitude": "7.27127000"
                    },
                    {
                        "id": 28603,
                        "name": "Rheden",
                        "latitude": "52.05784000",
                        "longitude": "9.78714000"
                    },
                    {
                        "id": 28619,
                        "name": "Rhumspringe",
                        "latitude": "51.58333000",
                        "longitude": "10.30000000"
                    },
                    {
                        "id": 28620,
                        "name": "Ribbesbüttel",
                        "latitude": "52.43435000",
                        "longitude": "10.50997000"
                    },
                    {
                        "id": 28627,
                        "name": "Riede",
                        "latitude": "52.96667000",
                        "longitude": "8.95000000"
                    },
                    {
                        "id": 28648,
                        "name": "Rieste",
                        "latitude": "52.48333000",
                        "longitude": "8.01667000"
                    },
                    {
                        "id": 28664,
                        "name": "Rinteln",
                        "latitude": "52.18604000",
                        "longitude": "9.07917000"
                    },
                    {
                        "id": 28667,
                        "name": "Ritterhude",
                        "latitude": "53.18289000",
                        "longitude": "8.73550000"
                    },
                    {
                        "id": 28677,
                        "name": "Rodenberg",
                        "latitude": "52.31152000",
                        "longitude": "9.35640000"
                    },
                    {
                        "id": 28783,
                        "name": "Röhrsen",
                        "latitude": "52.71078000",
                        "longitude": "9.23139000"
                    },
                    {
                        "id": 28699,
                        "name": "Ronnenberg",
                        "latitude": "52.31939000",
                        "longitude": "9.65544000"
                    },
                    {
                        "id": 28703,
                        "name": "Rosche",
                        "latitude": "52.98663000",
                        "longitude": "10.75184000"
                    },
                    {
                        "id": 28704,
                        "name": "Rosdorf",
                        "latitude": "51.50000000",
                        "longitude": "9.90000000"
                    },
                    {
                        "id": 28718,
                        "name": "Rotenburg",
                        "latitude": "53.11125000",
                        "longitude": "9.41082000"
                    },
                    {
                        "id": 28788,
                        "name": "Rötgesbüttel",
                        "latitude": "52.41667000",
                        "longitude": "10.53333000"
                    },
                    {
                        "id": 28804,
                        "name": "Rühen",
                        "latitude": "52.48560000",
                        "longitude": "10.88642000"
                    },
                    {
                        "id": 28761,
                        "name": "Rullstorf",
                        "latitude": "53.28645000",
                        "longitude": "10.52972000"
                    },
                    {
                        "id": 28822,
                        "name": "Sachsenhagen",
                        "latitude": "52.39734000",
                        "longitude": "9.26791000"
                    },
                    {
                        "id": 28838,
                        "name": "Salzbergen",
                        "latitude": "52.33333000",
                        "longitude": "7.35000000"
                    },
                    {
                        "id": 28839,
                        "name": "Salzgitter",
                        "latitude": "52.15705000",
                        "longitude": "10.41540000"
                    },
                    {
                        "id": 28840,
                        "name": "Salzhausen",
                        "latitude": "53.22339000",
                        "longitude": "10.16981000"
                    },
                    {
                        "id": 28841,
                        "name": "Salzhemmendorf",
                        "latitude": "52.06700000",
                        "longitude": "9.58720000"
                    },
                    {
                        "id": 28852,
                        "name": "Sande",
                        "latitude": "53.50489000",
                        "longitude": "8.01418000"
                    },
                    {
                        "id": 28857,
                        "name": "Sandstedt",
                        "latitude": "53.35981000",
                        "longitude": "8.52137000"
                    },
                    {
                        "id": 28860,
                        "name": "Sankt Andreasberg",
                        "latitude": "51.71004000",
                        "longitude": "10.51867000"
                    },
                    {
                        "id": 28885,
                        "name": "Sarstedt",
                        "latitude": "52.23495000",
                        "longitude": "9.85411000"
                    },
                    {
                        "id": 28890,
                        "name": "Sassenburg",
                        "latitude": "52.51667000",
                        "longitude": "10.63333000"
                    },
                    {
                        "id": 28894,
                        "name": "Sauensiek",
                        "latitude": "53.38333000",
                        "longitude": "9.60000000"
                    },
                    {
                        "id": 28909,
                        "name": "Schapen",
                        "latitude": "52.40000000",
                        "longitude": "7.56667000"
                    },
                    {
                        "id": 28912,
                        "name": "Scharnebeck",
                        "latitude": "53.29237000",
                        "longitude": "10.50188000"
                    },
                    {
                        "id": 28918,
                        "name": "Scheden",
                        "latitude": "51.45000000",
                        "longitude": "9.73333000"
                    },
                    {
                        "id": 28920,
                        "name": "Scheeßel",
                        "latitude": "53.16667000",
                        "longitude": "9.48333000"
                    },
                    {
                        "id": 28926,
                        "name": "Schellerten",
                        "latitude": "52.18530000",
                        "longitude": "10.10227000"
                    },
                    {
                        "id": 28942,
                        "name": "Schiffdorf",
                        "latitude": "53.53333000",
                        "longitude": "8.65000000"
                    },
                    {
                        "id": 28946,
                        "name": "Schillig",
                        "latitude": "53.70378000",
                        "longitude": "8.02170000"
                    },
                    {
                        "id": 28958,
                        "name": "Schladen",
                        "latitude": "52.02218000",
                        "longitude": "10.53967000"
                    },
                    {
                        "id": 29005,
                        "name": "Schnega",
                        "latitude": "52.89130000",
                        "longitude": "10.89226000"
                    },
                    {
                        "id": 29009,
                        "name": "Schneverdingen",
                        "latitude": "53.11685000",
                        "longitude": "9.79524000"
                    },
                    {
                        "id": 29127,
                        "name": "Schöningen",
                        "latitude": "52.13802000",
                        "longitude": "10.96745000"
                    },
                    {
                        "id": 29135,
                        "name": "Schöppenstedt",
                        "latitude": "52.14308000",
                        "longitude": "10.77450000"
                    },
                    {
                        "id": 29026,
                        "name": "Schortens",
                        "latitude": "53.53333000",
                        "longitude": "7.95000000"
                    },
                    {
                        "id": 29138,
                        "name": "Schüttorf",
                        "latitude": "52.32281000",
                        "longitude": "7.22176000"
                    },
                    {
                        "id": 29045,
                        "name": "Schwaförden",
                        "latitude": "52.73775000",
                        "longitude": "8.83026000"
                    },
                    {
                        "id": 29059,
                        "name": "Schwanewede",
                        "latitude": "53.23333000",
                        "longitude": "8.60000000"
                    },
                    {
                        "id": 29062,
                        "name": "Schwarme",
                        "latitude": "52.90000000",
                        "longitude": "9.01667000"
                    },
                    {
                        "id": 29063,
                        "name": "Schwarmstedt",
                        "latitude": "52.67794000",
                        "longitude": "9.61767000"
                    },
                    {
                        "id": 29147,
                        "name": "Seeburg",
                        "latitude": "51.56667000",
                        "longitude": "10.15000000"
                    },
                    {
                        "id": 29161,
                        "name": "Seelze",
                        "latitude": "52.39635000",
                        "longitude": "9.59727000"
                    },
                    {
                        "id": 29163,
                        "name": "Seesen",
                        "latitude": "51.89095000",
                        "longitude": "10.17847000"
                    },
                    {
                        "id": 29165,
                        "name": "Seevetal",
                        "latitude": "53.40000000",
                        "longitude": "9.96667000"
                    },
                    {
                        "id": 29166,
                        "name": "Seggebruch",
                        "latitude": "52.30050000",
                        "longitude": "9.09462000"
                    },
                    {
                        "id": 29167,
                        "name": "Sehlde",
                        "latitude": "52.03887000",
                        "longitude": "10.26569000"
                    },
                    {
                        "id": 29168,
                        "name": "Sehlem",
                        "latitude": "52.01236000",
                        "longitude": "9.97593000"
                    },
                    {
                        "id": 29170,
                        "name": "Sehnde",
                        "latitude": "52.31394000",
                        "longitude": "9.96820000"
                    },
                    {
                        "id": 29183,
                        "name": "Selsingen",
                        "latitude": "53.37329000",
                        "longitude": "9.21289000"
                    },
                    {
                        "id": 29200,
                        "name": "Seulingen",
                        "latitude": "51.54129000",
                        "longitude": "10.16263000"
                    },
                    {
                        "id": 29205,
                        "name": "Sibbesse",
                        "latitude": "52.05000000",
                        "longitude": "9.90000000"
                    },
                    {
                        "id": 29207,
                        "name": "Sickte",
                        "latitude": "52.21847000",
                        "longitude": "10.64240000"
                    },
                    {
                        "id": 29209,
                        "name": "Siedenburg",
                        "latitude": "52.69293000",
                        "longitude": "8.93961000"
                    },
                    {
                        "id": 29230,
                        "name": "Sillenstede",
                        "latitude": "53.57437000",
                        "longitude": "7.98500000"
                    },
                    {
                        "id": 29251,
                        "name": "Sittensen",
                        "latitude": "53.27615000",
                        "longitude": "9.50429000"
                    },
                    {
                        "id": 29253,
                        "name": "Soderstorf",
                        "latitude": "53.14275000",
                        "longitude": "10.14807000"
                    },
                    {
                        "id": 29491,
                        "name": "Sögel",
                        "latitude": "52.85000000",
                        "longitude": "7.51667000"
                    },
                    {
                        "id": 29492,
                        "name": "Söhlde",
                        "latitude": "52.18898000",
                        "longitude": "10.23239000"
                    },
                    {
                        "id": 29262,
                        "name": "Soltau",
                        "latitude": "52.98638000",
                        "longitude": "9.84338000"
                    },
                    {
                        "id": 29263,
                        "name": "Soltendieck",
                        "latitude": "52.87369000",
                        "longitude": "10.76162000"
                    },
                    {
                        "id": 29281,
                        "name": "Sottrum",
                        "latitude": "53.11667000",
                        "longitude": "9.23333000"
                    },
                    {
                        "id": 29295,
                        "name": "Spelle",
                        "latitude": "52.36667000",
                        "longitude": "7.46667000"
                    },
                    {
                        "id": 29306,
                        "name": "Sprakensehl",
                        "latitude": "52.76668000",
                        "longitude": "10.49177000"
                    },
                    {
                        "id": 29309,
                        "name": "Springe",
                        "latitude": "52.20845000",
                        "longitude": "9.55416000"
                    },
                    {
                        "id": 29314,
                        "name": "Stade",
                        "latitude": "53.59337000",
                        "longitude": "9.47629000"
                    },
                    {
                        "id": 29317,
                        "name": "Stadensen",
                        "latitude": "52.87571000",
                        "longitude": "10.55619000"
                    },
                    {
                        "id": 29321,
                        "name": "Stadthagen",
                        "latitude": "52.32333000",
                        "longitude": "9.20311000"
                    },
                    {
                        "id": 29327,
                        "name": "Stadtoldendorf",
                        "latitude": "51.88242000",
                        "longitude": "9.62650000"
                    },
                    {
                        "id": 29348,
                        "name": "Stedesdorf",
                        "latitude": "53.63333000",
                        "longitude": "7.66667000"
                    },
                    {
                        "id": 29355,
                        "name": "Steimbke",
                        "latitude": "52.65483000",
                        "longitude": "9.39091000"
                    },
                    {
                        "id": 29373,
                        "name": "Steinfeld",
                        "latitude": "52.58596000",
                        "longitude": "8.21417000"
                    },
                    {
                        "id": 29383,
                        "name": "Steinhorst",
                        "latitude": "52.68333000",
                        "longitude": "10.40000000"
                    },
                    {
                        "id": 29387,
                        "name": "Steinkirchen",
                        "latitude": "53.56601000",
                        "longitude": "9.61111000"
                    },
                    {
                        "id": 29395,
                        "name": "Stelle",
                        "latitude": "53.38416000",
                        "longitude": "10.11138000"
                    },
                    {
                        "id": 29407,
                        "name": "Steyerberg",
                        "latitude": "52.57017000",
                        "longitude": "9.02423000"
                    },
                    {
                        "id": 29449,
                        "name": "Stöckse",
                        "latitude": "52.64067000",
                        "longitude": "9.34027000"
                    },
                    {
                        "id": 29420,
                        "name": "Stolzenau",
                        "latitude": "52.51667000",
                        "longitude": "9.06667000"
                    },
                    {
                        "id": 29442,
                        "name": "Stuhr",
                        "latitude": "53.03333000",
                        "longitude": "8.75000000"
                    },
                    {
                        "id": 29458,
                        "name": "Suddendorf",
                        "latitude": "52.30096000",
                        "longitude": "7.22572000"
                    },
                    {
                        "id": 29459,
                        "name": "Suderburg",
                        "latitude": "52.89586000",
                        "longitude": "10.45141000"
                    },
                    {
                        "id": 29498,
                        "name": "Südergellersen",
                        "latitude": "53.21667000",
                        "longitude": "10.30000000"
                    },
                    {
                        "id": 29460,
                        "name": "Sudwalde",
                        "latitude": "52.79337000",
                        "longitude": "8.83611000"
                    },
                    {
                        "id": 29463,
                        "name": "Suhlendorf",
                        "latitude": "52.93333000",
                        "longitude": "10.76667000"
                    },
                    {
                        "id": 29465,
                        "name": "Sulingen",
                        "latitude": "52.68373000",
                        "longitude": "8.80949000"
                    },
                    {
                        "id": 29506,
                        "name": "Süpplingen",
                        "latitude": "52.22811000",
                        "longitude": "10.90393000"
                    },
                    {
                        "id": 29483,
                        "name": "Surwold",
                        "latitude": "52.97800000",
                        "longitude": "7.51534000"
                    },
                    {
                        "id": 29508,
                        "name": "Süstedt",
                        "latitude": "52.86165000",
                        "longitude": "8.92213000"
                    },
                    {
                        "id": 29484,
                        "name": "Sustrum",
                        "latitude": "52.91667000",
                        "longitude": "7.28333000"
                    },
                    {
                        "id": 29486,
                        "name": "Syke",
                        "latitude": "52.91345000",
                        "longitude": "8.82209000"
                    },
                    {
                        "id": 29528,
                        "name": "Tappenbeck",
                        "latitude": "52.47055000",
                        "longitude": "10.74068000"
                    },
                    {
                        "id": 29529,
                        "name": "Tarmstedt",
                        "latitude": "53.22505000",
                        "longitude": "9.07763000"
                    },
                    {
                        "id": 29560,
                        "name": "Tespe",
                        "latitude": "53.39640000",
                        "longitude": "10.41084000"
                    },
                    {
                        "id": 29586,
                        "name": "Thedinghausen",
                        "latitude": "52.96667000",
                        "longitude": "9.01667000"
                    },
                    {
                        "id": 29597,
                        "name": "Thomasburg",
                        "latitude": "53.23333000",
                        "longitude": "10.66667000"
                    },
                    {
                        "id": 29599,
                        "name": "Thuine",
                        "latitude": "52.50000000",
                        "longitude": "7.48333000"
                    },
                    {
                        "id": 29608,
                        "name": "Tiddische",
                        "latitude": "52.51667000",
                        "longitude": "10.80000000"
                    },
                    {
                        "id": 29631,
                        "name": "Toppenstedt",
                        "latitude": "53.26430000",
                        "longitude": "10.11451000"
                    },
                    {
                        "id": 29635,
                        "name": "Tostedt",
                        "latitude": "53.28333000",
                        "longitude": "9.71667000"
                    },
                    {
                        "id": 29706,
                        "name": "Tülau",
                        "latitude": "52.57578000",
                        "longitude": "10.87818000"
                    },
                    {
                        "id": 29696,
                        "name": "Twistringen",
                        "latitude": "52.79926000",
                        "longitude": "8.64163000"
                    },
                    {
                        "id": 29713,
                        "name": "Uchte",
                        "latitude": "52.49975000",
                        "longitude": "8.90928000"
                    },
                    {
                        "id": 29722,
                        "name": "Uehrde",
                        "latitude": "52.09902000",
                        "longitude": "10.76523000"
                    },
                    {
                        "id": 29723,
                        "name": "Uelsen",
                        "latitude": "52.50000000",
                        "longitude": "6.88333000"
                    },
                    {
                        "id": 29725,
                        "name": "Uelzen",
                        "latitude": "52.96572000",
                        "longitude": "10.56111000"
                    },
                    {
                        "id": 29729,
                        "name": "Uetze",
                        "latitude": "52.46511000",
                        "longitude": "10.20467000"
                    },
                    {
                        "id": 29743,
                        "name": "Ummern",
                        "latitude": "52.59111000",
                        "longitude": "10.43195000"
                    },
                    {
                        "id": 29768,
                        "name": "Unterlüß",
                        "latitude": "52.83471000",
                        "longitude": "10.29685000"
                    },
                    {
                        "id": 29785,
                        "name": "Upgant-Schott",
                        "latitude": "53.51667000",
                        "longitude": "7.28333000"
                    },
                    {
                        "id": 29799,
                        "name": "Uslar",
                        "latitude": "51.65690000",
                        "longitude": "9.63501000"
                    },
                    {
                        "id": 29802,
                        "name": "Uthlede",
                        "latitude": "53.31119000",
                        "longitude": "8.57861000"
                    },
                    {
                        "id": 29813,
                        "name": "Varel",
                        "latitude": "53.39693000",
                        "longitude": "8.13621000"
                    },
                    {
                        "id": 29814,
                        "name": "Varrel",
                        "latitude": "52.62150000",
                        "longitude": "8.73310000"
                    },
                    {
                        "id": 29816,
                        "name": "Vechelde",
                        "latitude": "52.26038000",
                        "longitude": "10.36491000"
                    },
                    {
                        "id": 29817,
                        "name": "Vechta",
                        "latitude": "52.72632000",
                        "longitude": "8.28598000"
                    },
                    {
                        "id": 29830,
                        "name": "Velpke",
                        "latitude": "52.40797000",
                        "longitude": "10.93637000"
                    },
                    {
                        "id": 29832,
                        "name": "Veltheim",
                        "latitude": "52.21874000",
                        "longitude": "10.68327000"
                    },
                    {
                        "id": 29834,
                        "name": "Verden",
                        "latitude": "52.92343000",
                        "longitude": "9.23491000"
                    },
                    {
                        "id": 29843,
                        "name": "Vienenburg",
                        "latitude": "51.95242000",
                        "longitude": "10.56374000"
                    },
                    {
                        "id": 29860,
                        "name": "Visbek",
                        "latitude": "52.83333000",
                        "longitude": "8.31667000"
                    },
                    {
                        "id": 29861,
                        "name": "Visselhövede",
                        "latitude": "52.98546000",
                        "longitude": "9.58265000"
                    },
                    {
                        "id": 29886,
                        "name": "Vögelsen",
                        "latitude": "53.27447000",
                        "longitude": "10.35372000"
                    },
                    {
                        "id": 29877,
                        "name": "Vollersode",
                        "latitude": "53.33333000",
                        "longitude": "8.91667000"
                    },
                    {
                        "id": 29878,
                        "name": "Voltlage",
                        "latitude": "52.43333000",
                        "longitude": "7.75000000"
                    },
                    {
                        "id": 29881,
                        "name": "Vordorf",
                        "latitude": "52.36522000",
                        "longitude": "10.52035000"
                    },
                    {
                        "id": 29883,
                        "name": "Vorwerk",
                        "latitude": "53.18333000",
                        "longitude": "9.15000000"
                    },
                    {
                        "id": 29885,
                        "name": "Vrees",
                        "latitude": "52.88333000",
                        "longitude": "7.76667000"
                    },
                    {
                        "id": 29896,
                        "name": "Waake",
                        "latitude": "51.55637000",
                        "longitude": "10.05713000"
                    },
                    {
                        "id": 29914,
                        "name": "Wagenfeld",
                        "latitude": "52.55000000",
                        "longitude": "8.58333000"
                    },
                    {
                        "id": 29915,
                        "name": "Wagenhoff",
                        "latitude": "52.55233000",
                        "longitude": "10.52337000"
                    },
                    {
                        "id": 29921,
                        "name": "Wahrenholz",
                        "latitude": "52.61667000",
                        "longitude": "10.60000000"
                    },
                    {
                        "id": 29930,
                        "name": "Walchum",
                        "latitude": "52.92717000",
                        "longitude": "7.28325000"
                    },
                    {
                        "id": 29969,
                        "name": "Walkenried",
                        "latitude": "51.58333000",
                        "longitude": "10.61667000"
                    },
                    {
                        "id": 29976,
                        "name": "Wallenhorst",
                        "latitude": "52.35000000",
                        "longitude": "8.01667000"
                    },
                    {
                        "id": 29993,
                        "name": "Walsrode",
                        "latitude": "52.86147000",
                        "longitude": "9.59260000"
                    },
                    {
                        "id": 30005,
                        "name": "Wangerooge",
                        "latitude": "53.79002000",
                        "longitude": "7.89938000"
                    },
                    {
                        "id": 30007,
                        "name": "Wanna",
                        "latitude": "53.75000000",
                        "longitude": "8.80000000"
                    },
                    {
                        "id": 30013,
                        "name": "Wardenburg",
                        "latitude": "53.06667000",
                        "longitude": "8.20000000"
                    },
                    {
                        "id": 30019,
                        "name": "Warmsen",
                        "latitude": "52.45695000",
                        "longitude": "8.84949000"
                    },
                    {
                        "id": 30029,
                        "name": "Wasbüttel",
                        "latitude": "52.41331000",
                        "longitude": "10.59357000"
                    },
                    {
                        "id": 30039,
                        "name": "Wathlingen",
                        "latitude": "52.53690000",
                        "longitude": "10.15069000"
                    },
                    {
                        "id": 30051,
                        "name": "Weener",
                        "latitude": "53.16332000",
                        "longitude": "7.35052000"
                    },
                    {
                        "id": 30142,
                        "name": "Welle",
                        "latitude": "53.23985000",
                        "longitude": "9.80178000"
                    },
                    {
                        "id": 30152,
                        "name": "Wendeburg",
                        "latitude": "52.32957000",
                        "longitude": "10.39255000"
                    },
                    {
                        "id": 30156,
                        "name": "Wendisch Evern",
                        "latitude": "53.21667000",
                        "longitude": "10.46667000"
                    },
                    {
                        "id": 30162,
                        "name": "Wennigsen",
                        "latitude": "52.27404000",
                        "longitude": "9.57287000"
                    },
                    {
                        "id": 30165,
                        "name": "Wenzendorf",
                        "latitude": "53.34948000",
                        "longitude": "9.77234000"
                    },
                    {
                        "id": 30175,
                        "name": "Werlte",
                        "latitude": "52.85000000",
                        "longitude": "7.68333000"
                    },
                    {
                        "id": 30186,
                        "name": "Werpeloh",
                        "latitude": "52.87207000",
                        "longitude": "7.50831000"
                    },
                    {
                        "id": 30194,
                        "name": "Wesendorf",
                        "latitude": "52.60000000",
                        "longitude": "10.53333000"
                    },
                    {
                        "id": 30199,
                        "name": "Weste",
                        "latitude": "53.05943000",
                        "longitude": "10.70283000"
                    },
                    {
                        "id": 30206,
                        "name": "Westergellersen",
                        "latitude": "53.23333000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 30210,
                        "name": "Westerholt",
                        "latitude": "53.60000000",
                        "longitude": "7.45000000"
                    },
                    {
                        "id": 30215,
                        "name": "Westerstede",
                        "latitude": "53.25682000",
                        "longitude": "7.92737000"
                    },
                    {
                        "id": 30217,
                        "name": "Westhagen",
                        "latitude": "52.40425000",
                        "longitude": "10.73939000"
                    },
                    {
                        "id": 30223,
                        "name": "Wetschen",
                        "latitude": "52.61295000",
                        "longitude": "8.44883000"
                    },
                    {
                        "id": 30234,
                        "name": "Weyhausen",
                        "latitude": "52.46208000",
                        "longitude": "10.71699000"
                    },
                    {
                        "id": 30238,
                        "name": "Wieda",
                        "latitude": "51.63400000",
                        "longitude": "10.58704000"
                    },
                    {
                        "id": 30240,
                        "name": "Wiedensahl",
                        "latitude": "52.38385000",
                        "longitude": "9.12019000"
                    },
                    {
                        "id": 30244,
                        "name": "Wiefelstede",
                        "latitude": "53.25000000",
                        "longitude": "8.11667000"
                    },
                    {
                        "id": 30249,
                        "name": "Wienhausen",
                        "latitude": "52.58021000",
                        "longitude": "10.18862000"
                    },
                    {
                        "id": 30250,
                        "name": "Wieren",
                        "latitude": "52.88529000",
                        "longitude": "10.65871000"
                    },
                    {
                        "id": 30265,
                        "name": "Wiesmoor",
                        "latitude": "53.41667000",
                        "longitude": "7.73333000"
                    },
                    {
                        "id": 30267,
                        "name": "Wietmarschen",
                        "latitude": "52.51806000",
                        "longitude": "7.13408000"
                    },
                    {
                        "id": 30268,
                        "name": "Wietze",
                        "latitude": "52.65000000",
                        "longitude": "9.83333000"
                    },
                    {
                        "id": 30269,
                        "name": "Wietzen",
                        "latitude": "52.71667000",
                        "longitude": "9.08333000"
                    },
                    {
                        "id": 30270,
                        "name": "Wietzendorf",
                        "latitude": "52.91667000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 30274,
                        "name": "Wildemann",
                        "latitude": "51.82810000",
                        "longitude": "10.28152000"
                    },
                    {
                        "id": 30278,
                        "name": "Wildeshausen",
                        "latitude": "52.89446000",
                        "longitude": "8.43375000"
                    },
                    {
                        "id": 30286,
                        "name": "Wilhelmshaven",
                        "latitude": "53.52998000",
                        "longitude": "8.11253000"
                    },
                    {
                        "id": 30302,
                        "name": "Wilstedt",
                        "latitude": "53.19493000",
                        "longitude": "9.09595000"
                    },
                    {
                        "id": 30304,
                        "name": "Wilsum",
                        "latitude": "52.53333000",
                        "longitude": "6.85000000"
                    },
                    {
                        "id": 30317,
                        "name": "Windhausen",
                        "latitude": "51.78544000",
                        "longitude": "10.21218000"
                    },
                    {
                        "id": 30322,
                        "name": "Wingst",
                        "latitude": "53.73572000",
                        "longitude": "9.08054000"
                    },
                    {
                        "id": 30329,
                        "name": "Winsen",
                        "latitude": "53.35753000",
                        "longitude": "10.21282000"
                    },
                    {
                        "id": 30341,
                        "name": "Wirdum",
                        "latitude": "53.47667000",
                        "longitude": "7.20594000"
                    },
                    {
                        "id": 30344,
                        "name": "Wischhafen",
                        "latitude": "53.78333000",
                        "longitude": "9.31667000"
                    },
                    {
                        "id": 30347,
                        "name": "Wistedt",
                        "latitude": "53.26667000",
                        "longitude": "9.68333000"
                    },
                    {
                        "id": 30359,
                        "name": "Wittingen",
                        "latitude": "52.72694000",
                        "longitude": "10.73613000"
                    },
                    {
                        "id": 30362,
                        "name": "Wittmar",
                        "latitude": "52.12969000",
                        "longitude": "10.64000000"
                    },
                    {
                        "id": 30363,
                        "name": "Wittmund",
                        "latitude": "53.57674000",
                        "longitude": "7.77839000"
                    },
                    {
                        "id": 30365,
                        "name": "Wittorf",
                        "latitude": "53.33333000",
                        "longitude": "10.38333000"
                    },
                    {
                        "id": 30377,
                        "name": "Wolfenbüttel",
                        "latitude": "52.16442000",
                        "longitude": "10.54095000"
                    },
                    {
                        "id": 30385,
                        "name": "Wolfsburg",
                        "latitude": "52.42452000",
                        "longitude": "10.78150000"
                    },
                    {
                        "id": 30442,
                        "name": "Wölpinghausen",
                        "latitude": "52.41667000",
                        "longitude": "9.23333000"
                    },
                    {
                        "id": 30399,
                        "name": "Wolsdorf",
                        "latitude": "52.19098000",
                        "longitude": "10.93878000"
                    },
                    {
                        "id": 30401,
                        "name": "Woltersdorf",
                        "latitude": "52.95000000",
                        "longitude": "11.21667000"
                    },
                    {
                        "id": 30407,
                        "name": "Worpswede",
                        "latitude": "53.21667000",
                        "longitude": "8.93333000"
                    },
                    {
                        "id": 30408,
                        "name": "Wremen",
                        "latitude": "53.65000000",
                        "longitude": "8.51667000"
                    },
                    {
                        "id": 30409,
                        "name": "Wrestedt",
                        "latitude": "52.90435000",
                        "longitude": "10.57494000"
                    },
                    {
                        "id": 30410,
                        "name": "Wriedel",
                        "latitude": "53.03130000",
                        "longitude": "10.29848000"
                    },
                    {
                        "id": 30414,
                        "name": "Wulfsen",
                        "latitude": "53.30000000",
                        "longitude": "10.15000000"
                    },
                    {
                        "id": 30415,
                        "name": "Wulften",
                        "latitude": "51.65999000",
                        "longitude": "10.17437000"
                    },
                    {
                        "id": 30417,
                        "name": "Wulsbüttel",
                        "latitude": "53.31667000",
                        "longitude": "8.66667000"
                    },
                    {
                        "id": 30419,
                        "name": "Wunstorf",
                        "latitude": "52.42377000",
                        "longitude": "9.43585000"
                    },
                    {
                        "id": 30432,
                        "name": "Wustrow",
                        "latitude": "52.92370000",
                        "longitude": "11.12846000"
                    },
                    {
                        "id": 30496,
                        "name": "Zernien",
                        "latitude": "53.06845000",
                        "longitude": "10.88325000"
                    },
                    {
                        "id": 30497,
                        "name": "Zetel",
                        "latitude": "53.41667000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 30500,
                        "name": "Zeven",
                        "latitude": "53.29657000",
                        "longitude": "9.27685000"
                    },
                    {
                        "id": 30514,
                        "name": "Zorge",
                        "latitude": "51.63333000",
                        "longitude": "10.63333000"
                    }
                ]
            },
            {
                "id": 3007,
                "name": "Mecklenburg-Vorpommern",
                "iso2": "MV",
                "latitude": "53.61265050",
                "longitude": "12.42959530",
                "type": "land",
                "cities": [
                    {
                        "id": 23492,
                        "name": "Admannshagen-Bargeshagen",
                        "latitude": "54.13038000",
                        "longitude": "11.99915000"
                    },
                    {
                        "id": 23502,
                        "name": "Ahlbeck",
                        "latitude": "53.66972000",
                        "longitude": "14.18622000"
                    },
                    {
                        "id": 23576,
                        "name": "Alt Meteln",
                        "latitude": "53.74709000",
                        "longitude": "11.34056000"
                    },
                    {
                        "id": 23580,
                        "name": "Alt-Sanitz",
                        "latitude": "53.81363000",
                        "longitude": "13.58786000"
                    },
                    {
                        "id": 23586,
                        "name": "Altefähr",
                        "latitude": "54.32994000",
                        "longitude": "13.12643000"
                    },
                    {
                        "id": 23604,
                        "name": "Altenkirchen",
                        "latitude": "54.63624000",
                        "longitude": "13.34332000"
                    },
                    {
                        "id": 23611,
                        "name": "Altenpleen",
                        "latitude": "54.35456000",
                        "longitude": "12.95640000"
                    },
                    {
                        "id": 23617,
                        "name": "Altentreptow",
                        "latitude": "53.69416000",
                        "longitude": "13.26504000"
                    },
                    {
                        "id": 23635,
                        "name": "Altstadt",
                        "latitude": "53.62805000",
                        "longitude": "11.41582000"
                    },
                    {
                        "id": 23659,
                        "name": "Anklam",
                        "latitude": "53.85637000",
                        "longitude": "13.68965000"
                    },
                    {
                        "id": 23782,
                        "name": "Bad Doberan",
                        "latitude": "54.10712000",
                        "longitude": "11.90051000"
                    },
                    {
                        "id": 23814,
                        "name": "Bad Kleinen",
                        "latitude": "53.77134000",
                        "longitude": "11.47165000"
                    },
                    {
                        "id": 23875,
                        "name": "Bad Sülze",
                        "latitude": "54.11084000",
                        "longitude": "12.66054000"
                    },
                    {
                        "id": 23923,
                        "name": "Banzkow",
                        "latitude": "53.52497000",
                        "longitude": "11.52306000"
                    },
                    {
                        "id": 23943,
                        "name": "Bartenshagen-Parkentin",
                        "latitude": "54.08116000",
                        "longitude": "11.97849000"
                    },
                    {
                        "id": 23944,
                        "name": "Barth",
                        "latitude": "54.36346000",
                        "longitude": "12.72491000"
                    },
                    {
                        "id": 23955,
                        "name": "Bastorf",
                        "latitude": "54.12566000",
                        "longitude": "11.69695000"
                    },
                    {
                        "id": 24020,
                        "name": "Bentwisch",
                        "latitude": "54.11503000",
                        "longitude": "12.20465000"
                    },
                    {
                        "id": 24021,
                        "name": "Bentzin",
                        "latitude": "53.94608000",
                        "longitude": "13.27320000"
                    },
                    {
                        "id": 24037,
                        "name": "Bergen auf Rügen",
                        "latitude": "54.41823000",
                        "longitude": "13.43349000"
                    },
                    {
                        "id": 24066,
                        "name": "Bernitt",
                        "latitude": "53.90403000",
                        "longitude": "11.88669000"
                    },
                    {
                        "id": 24108,
                        "name": "Biendorf",
                        "latitude": "54.07520000",
                        "longitude": "11.70127000"
                    },
                    {
                        "id": 24172,
                        "name": "Blankensee",
                        "latitude": "53.40390000",
                        "longitude": "13.26836000"
                    },
                    {
                        "id": 24186,
                        "name": "Blowatz",
                        "latitude": "53.98972000",
                        "longitude": "11.53360000"
                    },
                    {
                        "id": 24191,
                        "name": "Bobitz",
                        "latitude": "53.80450000",
                        "longitude": "11.35914000"
                    },
                    {
                        "id": 24218,
                        "name": "Boizenburg",
                        "latitude": "53.38153000",
                        "longitude": "10.72375000"
                    },
                    {
                        "id": 24473,
                        "name": "Börgerende-Rethwisch",
                        "latitude": "54.14177000",
                        "longitude": "11.92528000"
                    },
                    {
                        "id": 24249,
                        "name": "Born",
                        "latitude": "54.38536000",
                        "longitude": "12.53051000"
                    },
                    {
                        "id": 24256,
                        "name": "Borrentin",
                        "latitude": "53.80968000",
                        "longitude": "12.96718000"
                    },
                    {
                        "id": 24282,
                        "name": "Brandshagen",
                        "latitude": "54.23945000",
                        "longitude": "13.16917000"
                    },
                    {
                        "id": 24341,
                        "name": "Broderstorf",
                        "latitude": "54.08114000",
                        "longitude": "12.26350000"
                    },
                    {
                        "id": 24367,
                        "name": "Brüel",
                        "latitude": "53.73719000",
                        "longitude": "11.71471000"
                    },
                    {
                        "id": 24358,
                        "name": "Brunn",
                        "latitude": "53.67076000",
                        "longitude": "13.37032000"
                    },
                    {
                        "id": 24373,
                        "name": "Brüsewitz",
                        "latitude": "53.67588000",
                        "longitude": "11.24379000"
                    },
                    {
                        "id": 24408,
                        "name": "Burg Stargard",
                        "latitude": "53.49582000",
                        "longitude": "13.31122000"
                    },
                    {
                        "id": 24444,
                        "name": "Burow",
                        "latitude": "53.77372000",
                        "longitude": "13.27318000"
                    },
                    {
                        "id": 24510,
                        "name": "Bützow",
                        "latitude": "53.84832000",
                        "longitude": "11.98256000"
                    },
                    {
                        "id": 24522,
                        "name": "Carlow",
                        "latitude": "53.75861000",
                        "longitude": "10.93789000"
                    },
                    {
                        "id": 24524,
                        "name": "Carpin",
                        "latitude": "53.35691000",
                        "longitude": "13.24328000"
                    },
                    {
                        "id": 24565,
                        "name": "Crivitz",
                        "latitude": "53.57316000",
                        "longitude": "11.65194000"
                    },
                    {
                        "id": 24573,
                        "name": "Dabel",
                        "latitude": "53.66112000",
                        "longitude": "11.90025000"
                    },
                    {
                        "id": 24595,
                        "name": "Dargun",
                        "latitude": "53.90090000",
                        "longitude": "12.85014000"
                    },
                    {
                        "id": 24601,
                        "name": "Dassow",
                        "latitude": "53.91096000",
                        "longitude": "10.97551000"
                    },
                    {
                        "id": 24627,
                        "name": "Demen",
                        "latitude": "53.62967000",
                        "longitude": "11.76639000"
                    },
                    {
                        "id": 24629,
                        "name": "Demmin",
                        "latitude": "53.90762000",
                        "longitude": "13.03142000"
                    },
                    {
                        "id": 24641,
                        "name": "Dersekow",
                        "latitude": "54.04583000",
                        "longitude": "13.29243000"
                    },
                    {
                        "id": 24672,
                        "name": "Dierkow-Neu",
                        "latitude": "54.10571000",
                        "longitude": "12.16753000"
                    },
                    {
                        "id": 24673,
                        "name": "Dierkow-West",
                        "latitude": "54.10608000",
                        "longitude": "12.15041000"
                    },
                    {
                        "id": 24711,
                        "name": "Dobbertin",
                        "latitude": "53.62306000",
                        "longitude": "12.07466000"
                    },
                    {
                        "id": 24798,
                        "name": "Dömitz",
                        "latitude": "53.14080000",
                        "longitude": "11.25017000"
                    },
                    {
                        "id": 24728,
                        "name": "Domsühl",
                        "latitude": "53.48723000",
                        "longitude": "11.77099000"
                    },
                    {
                        "id": 24756,
                        "name": "Dranske",
                        "latitude": "54.63118000",
                        "longitude": "13.22831000"
                    },
                    {
                        "id": 24774,
                        "name": "Ducherow",
                        "latitude": "53.76436000",
                        "longitude": "13.78216000"
                    },
                    {
                        "id": 24806,
                        "name": "Dümmer",
                        "latitude": "53.57629000",
                        "longitude": "11.20497000"
                    },
                    {
                        "id": 24781,
                        "name": "Dummerstorf",
                        "latitude": "54.01484000",
                        "longitude": "12.22821000"
                    },
                    {
                        "id": 24877,
                        "name": "Eggesin",
                        "latitude": "53.67973000",
                        "longitude": "14.07992000"
                    },
                    {
                        "id": 24941,
                        "name": "Eldena",
                        "latitude": "53.23191000",
                        "longitude": "11.41804000"
                    },
                    {
                        "id": 24959,
                        "name": "Elmenhorst",
                        "latitude": "54.15583000",
                        "longitude": "12.01084000"
                    },
                    {
                        "id": 25157,
                        "name": "Feldstadt",
                        "latitude": "53.62331000",
                        "longitude": "11.40673000"
                    },
                    {
                        "id": 25164,
                        "name": "Ferdinandshof",
                        "latitude": "53.66124000",
                        "longitude": "13.88724000"
                    },
                    {
                        "id": 25224,
                        "name": "Franzburg",
                        "latitude": "54.18501000",
                        "longitude": "12.88210000"
                    },
                    {
                        "id": 25281,
                        "name": "Friedland",
                        "latitude": "53.67028000",
                        "longitude": "13.55400000"
                    },
                    {
                        "id": 25343,
                        "name": "Gadebusch",
                        "latitude": "53.70137000",
                        "longitude": "11.11676000"
                    },
                    {
                        "id": 25773,
                        "name": "Gägelow",
                        "latitude": "53.68558000",
                        "longitude": "11.89639000"
                    },
                    {
                        "id": 25374,
                        "name": "Garz",
                        "latitude": "54.31843000",
                        "longitude": "13.35125000"
                    },
                    {
                        "id": 25411,
                        "name": "Gelbensande",
                        "latitude": "54.20272000",
                        "longitude": "12.30168000"
                    },
                    {
                        "id": 25483,
                        "name": "Gielow",
                        "latitude": "53.69756000",
                        "longitude": "12.74521000"
                    },
                    {
                        "id": 25495,
                        "name": "Gingst",
                        "latitude": "54.45654000",
                        "longitude": "13.25737000"
                    },
                    {
                        "id": 25516,
                        "name": "Glowe",
                        "latitude": "54.56911000",
                        "longitude": "13.46550000"
                    },
                    {
                        "id": 25523,
                        "name": "Gnoien",
                        "latitude": "53.96870000",
                        "longitude": "12.71099000"
                    },
                    {
                        "id": 25531,
                        "name": "Goldberg",
                        "latitude": "53.58878000",
                        "longitude": "12.08855000"
                    },
                    {
                        "id": 25782,
                        "name": "Görmin",
                        "latitude": "53.99092000",
                        "longitude": "13.27054000"
                    },
                    {
                        "id": 25559,
                        "name": "Grabow",
                        "latitude": "53.27966000",
                        "longitude": "11.56502000"
                    },
                    {
                        "id": 25560,
                        "name": "Grabowhöfe",
                        "latitude": "53.56865000",
                        "longitude": "12.59482000"
                    },
                    {
                        "id": 25574,
                        "name": "Gramkow",
                        "latitude": "53.92092000",
                        "longitude": "11.31740000"
                    },
                    {
                        "id": 25592,
                        "name": "Greifswald",
                        "latitude": "54.09311000",
                        "longitude": "13.38786000"
                    },
                    {
                        "id": 25606,
                        "name": "Grevesmühlen",
                        "latitude": "53.86337000",
                        "longitude": "11.19160000"
                    },
                    {
                        "id": 25611,
                        "name": "Grimmen",
                        "latitude": "54.11215000",
                        "longitude": "13.04051000"
                    },
                    {
                        "id": 25624,
                        "name": "Groß Kiesow",
                        "latitude": "54.01261000",
                        "longitude": "13.47851000"
                    },
                    {
                        "id": 25628,
                        "name": "Groß Laasch",
                        "latitude": "53.34646000",
                        "longitude": "11.54919000"
                    },
                    {
                        "id": 25630,
                        "name": "Groß Miltzow",
                        "latitude": "53.53565000",
                        "longitude": "13.59354000"
                    },
                    {
                        "id": 25632,
                        "name": "Groß Nemerow",
                        "latitude": "53.47342000",
                        "longitude": "13.22482000"
                    },
                    {
                        "id": 25642,
                        "name": "Groß Wokern",
                        "latitude": "53.75135000",
                        "longitude": "12.49249000"
                    },
                    {
                        "id": 25800,
                        "name": "Güstrow",
                        "latitude": "53.79720000",
                        "longitude": "12.17337000"
                    },
                    {
                        "id": 25803,
                        "name": "Gützkow",
                        "latitude": "53.72432000",
                        "longitude": "13.10664000"
                    },
                    {
                        "id": 25823,
                        "name": "Hagenow",
                        "latitude": "53.43134000",
                        "longitude": "11.19159000"
                    },
                    {
                        "id": 26131,
                        "name": "Hiddensee",
                        "latitude": "54.56689000",
                        "longitude": "13.10411000"
                    },
                    {
                        "id": 26270,
                        "name": "Hornstorf",
                        "latitude": "53.90994000",
                        "longitude": "11.53214000"
                    },
                    {
                        "id": 26430,
                        "name": "Jarmen",
                        "latitude": "53.92385000",
                        "longitude": "13.34032000"
                    },
                    {
                        "id": 26432,
                        "name": "Jatznick",
                        "latitude": "53.57951000",
                        "longitude": "13.93955000"
                    },
                    {
                        "id": 26468,
                        "name": "Jördenstorf",
                        "latitude": "53.87823000",
                        "longitude": "12.61619000"
                    },
                    {
                        "id": 26475,
                        "name": "Jürgenshagen",
                        "latitude": "53.95417000",
                        "longitude": "11.89665000"
                    },
                    {
                        "id": 26491,
                        "name": "Kalkhorst",
                        "latitude": "53.97012000",
                        "longitude": "11.04469000"
                    },
                    {
                        "id": 26516,
                        "name": "Karlshagen",
                        "latitude": "54.11107000",
                        "longitude": "13.83193000"
                    },
                    {
                        "id": 26547,
                        "name": "Kavelstorf",
                        "latitude": "54.00596000",
                        "longitude": "12.19082000"
                    },
                    {
                        "id": 26566,
                        "name": "Kemnitz",
                        "latitude": "54.07723000",
                        "longitude": "13.53528000"
                    },
                    {
                        "id": 26574,
                        "name": "Kessin",
                        "latitude": "53.72928000",
                        "longitude": "13.30773000"
                    },
                    {
                        "id": 26663,
                        "name": "Klein Rogahn",
                        "latitude": "53.60534000",
                        "longitude": "11.34579000"
                    },
                    {
                        "id": 26690,
                        "name": "Klink",
                        "latitude": "53.47758000",
                        "longitude": "12.62131000"
                    },
                    {
                        "id": 26700,
                        "name": "Klütz",
                        "latitude": "53.96470000",
                        "longitude": "11.16367000"
                    },
                    {
                        "id": 26728,
                        "name": "Koserow",
                        "latitude": "54.05189000",
                        "longitude": "14.00197000"
                    },
                    {
                        "id": 26737,
                        "name": "Krakow am See",
                        "latitude": "53.65163000",
                        "longitude": "12.27034000"
                    },
                    {
                        "id": 26738,
                        "name": "Kramerhof",
                        "latitude": "54.35366000",
                        "longitude": "13.05412000"
                    },
                    {
                        "id": 26764,
                        "name": "Kritzmow",
                        "latitude": "54.05237000",
                        "longitude": "12.05311000"
                    },
                    {
                        "id": 26783,
                        "name": "Kröpelin",
                        "latitude": "54.06963000",
                        "longitude": "11.79473000"
                    },
                    {
                        "id": 26785,
                        "name": "Kröslin",
                        "latitude": "54.11662000",
                        "longitude": "13.75067000"
                    },
                    {
                        "id": 26862,
                        "name": "Laage",
                        "latitude": "53.92560000",
                        "longitude": "12.34694000"
                    },
                    {
                        "id": 26878,
                        "name": "Lalendorf",
                        "latitude": "53.75774000",
                        "longitude": "12.38983000"
                    },
                    {
                        "id": 26882,
                        "name": "Lambrechtshagen",
                        "latitude": "54.10208000",
                        "longitude": "12.01645000"
                    },
                    {
                        "id": 26947,
                        "name": "Lankow",
                        "latitude": "53.64983000",
                        "longitude": "11.36913000"
                    },
                    {
                        "id": 26952,
                        "name": "Lassan",
                        "latitude": "53.94874000",
                        "longitude": "13.85219000"
                    },
                    {
                        "id": 27003,
                        "name": "Leezen",
                        "latitude": "53.66265000",
                        "longitude": "11.49874000"
                    },
                    {
                        "id": 27072,
                        "name": "Lewenberg",
                        "latitude": "53.64591000",
                        "longitude": "11.40767000"
                    },
                    {
                        "id": 27191,
                        "name": "Löcknitz",
                        "latitude": "53.28694000",
                        "longitude": "11.78108000"
                    },
                    {
                        "id": 27128,
                        "name": "Loddin",
                        "latitude": "54.02252000",
                        "longitude": "14.00754000"
                    },
                    {
                        "id": 27140,
                        "name": "Loitz",
                        "latitude": "53.44205000",
                        "longitude": "13.38802000"
                    },
                    {
                        "id": 27158,
                        "name": "Lubmin",
                        "latitude": "54.13509000",
                        "longitude": "13.61687000"
                    },
                    {
                        "id": 27206,
                        "name": "Lübow",
                        "latitude": "53.85256000",
                        "longitude": "11.52440000"
                    },
                    {
                        "id": 27207,
                        "name": "Lübstorf",
                        "latitude": "53.72561000",
                        "longitude": "11.41471000"
                    },
                    {
                        "id": 27208,
                        "name": "Lübtheen",
                        "latitude": "53.30118000",
                        "longitude": "11.08368000"
                    },
                    {
                        "id": 27209,
                        "name": "Lübz",
                        "latitude": "53.46261000",
                        "longitude": "12.02917000"
                    },
                    {
                        "id": 27214,
                        "name": "Lüdersdorf",
                        "latitude": "53.86835000",
                        "longitude": "11.74902000"
                    },
                    {
                        "id": 27166,
                        "name": "Ludwigslust",
                        "latitude": "53.32917000",
                        "longitude": "11.49714000"
                    },
                    {
                        "id": 27226,
                        "name": "Lützow",
                        "latitude": "53.65345000",
                        "longitude": "11.17582000"
                    },
                    {
                        "id": 27249,
                        "name": "Malchin",
                        "latitude": "53.73990000",
                        "longitude": "12.76539000"
                    },
                    {
                        "id": 27251,
                        "name": "Malchow",
                        "latitude": "53.47477000",
                        "longitude": "12.42210000"
                    },
                    {
                        "id": 27255,
                        "name": "Malliß",
                        "latitude": "53.21132000",
                        "longitude": "11.32716000"
                    },
                    {
                        "id": 27320,
                        "name": "Marlow",
                        "latitude": "54.15439000",
                        "longitude": "12.57261000"
                    },
                    {
                        "id": 27360,
                        "name": "Mecklenburg",
                        "latitude": "53.84270000",
                        "longitude": "11.46330000"
                    },
                    {
                        "id": 27432,
                        "name": "Mesekenhagen",
                        "latitude": "54.14846000",
                        "longitude": "13.31843000"
                    },
                    {
                        "id": 27475,
                        "name": "Mirow",
                        "latitude": "53.50510000",
                        "longitude": "11.50294000"
                    },
                    {
                        "id": 27563,
                        "name": "Möllenhagen",
                        "latitude": "53.52388000",
                        "longitude": "12.92868000"
                    },
                    {
                        "id": 27570,
                        "name": "Mönchhagen",
                        "latitude": "54.15146000",
                        "longitude": "12.21670000"
                    },
                    {
                        "id": 27588,
                        "name": "Mühl Rosin",
                        "latitude": "53.76383000",
                        "longitude": "12.21388000"
                    },
                    {
                        "id": 27594,
                        "name": "Mühlen Eichsen",
                        "latitude": "53.75775000",
                        "longitude": "11.25006000"
                    },
                    {
                        "id": 27689,
                        "name": "Neu Kaliß",
                        "latitude": "53.17466000",
                        "longitude": "11.29446000"
                    },
                    {
                        "id": 27700,
                        "name": "Neubrandenburg",
                        "latitude": "53.56414000",
                        "longitude": "13.27532000"
                    },
                    {
                        "id": 27704,
                        "name": "Neubukow",
                        "latitude": "54.03177000",
                        "longitude": "11.67391000"
                    },
                    {
                        "id": 27706,
                        "name": "Neuburg",
                        "latitude": "53.40677000",
                        "longitude": "11.91742000"
                    },
                    {
                        "id": 27722,
                        "name": "Neuenkirchen",
                        "latitude": "53.59729000",
                        "longitude": "13.36942000"
                    },
                    {
                        "id": 27753,
                        "name": "Neukalen",
                        "latitude": "53.82275000",
                        "longitude": "12.79015000"
                    },
                    {
                        "id": 27764,
                        "name": "Neukloster",
                        "latitude": "53.86548000",
                        "longitude": "11.68512000"
                    },
                    {
                        "id": 27773,
                        "name": "Neumühle",
                        "latitude": "53.63171000",
                        "longitude": "11.37085000"
                    },
                    {
                        "id": 27807,
                        "name": "Neustadt-Glewe",
                        "latitude": "53.37846000",
                        "longitude": "11.59264000"
                    },
                    {
                        "id": 27810,
                        "name": "Neustrelitz",
                        "latitude": "53.36130000",
                        "longitude": "13.07292000"
                    },
                    {
                        "id": 27818,
                        "name": "Neverin",
                        "latitude": "53.62067000",
                        "longitude": "13.33660000"
                    },
                    {
                        "id": 27894,
                        "name": "Nienhagen",
                        "latitude": "54.14869000",
                        "longitude": "12.17434000"
                    },
                    {
                        "id": 27896,
                        "name": "Niepars",
                        "latitude": "54.31447000",
                        "longitude": "12.92447000"
                    },
                    {
                        "id": 27935,
                        "name": "Nostorf",
                        "latitude": "53.40656000",
                        "longitude": "10.65408000"
                    },
                    {
                        "id": 28168,
                        "name": "Ostseebad Binz",
                        "latitude": "54.39995000",
                        "longitude": "13.61052000"
                    },
                    {
                        "id": 28169,
                        "name": "Ostseebad Boltenhagen",
                        "latitude": "53.98779000",
                        "longitude": "11.20193000"
                    },
                    {
                        "id": 28170,
                        "name": "Ostseebad Dierhagen",
                        "latitude": "54.29243000",
                        "longitude": "12.35799000"
                    },
                    {
                        "id": 28171,
                        "name": "Ostseebad Göhren",
                        "latitude": "54.34140000",
                        "longitude": "13.73823000"
                    },
                    {
                        "id": 28172,
                        "name": "Ostseebad Kühlungsborn",
                        "latitude": "54.15035000",
                        "longitude": "11.75994000"
                    },
                    {
                        "id": 28173,
                        "name": "Ostseebad Prerow",
                        "latitude": "54.44469000",
                        "longitude": "12.57677000"
                    },
                    {
                        "id": 28174,
                        "name": "Ostseebad Sellin",
                        "latitude": "54.37846000",
                        "longitude": "13.69394000"
                    },
                    {
                        "id": 28175,
                        "name": "Ostseebad Zinnowitz",
                        "latitude": "54.07668000",
                        "longitude": "13.91127000"
                    },
                    {
                        "id": 28214,
                        "name": "Pampow",
                        "latitude": "53.75513000",
                        "longitude": "12.60815000"
                    },
                    {
                        "id": 28219,
                        "name": "Papendorf",
                        "latitude": "54.03523000",
                        "longitude": "12.13263000"
                    },
                    {
                        "id": 28222,
                        "name": "Parchim",
                        "latitude": "53.42631000",
                        "longitude": "11.84875000"
                    },
                    {
                        "id": 28229,
                        "name": "Pasewalk",
                        "latitude": "53.50627000",
                        "longitude": "13.98997000"
                    },
                    {
                        "id": 28236,
                        "name": "Paulsstadt",
                        "latitude": "53.63283000",
                        "longitude": "11.40372000"
                    },
                    {
                        "id": 28252,
                        "name": "Penkun",
                        "latitude": "53.29695000",
                        "longitude": "14.23616000"
                    },
                    {
                        "id": 28257,
                        "name": "Penzlin",
                        "latitude": "53.50400000",
                        "longitude": "13.08407000"
                    },
                    {
                        "id": 28305,
                        "name": "Pinnow",
                        "latitude": "53.60164000",
                        "longitude": "11.54577000"
                    },
                    {
                        "id": 28314,
                        "name": "Plate",
                        "latitude": "53.55145000",
                        "longitude": "11.50927000"
                    },
                    {
                        "id": 28317,
                        "name": "Plau am See",
                        "latitude": "53.45821000",
                        "longitude": "12.26246000"
                    },
                    {
                        "id": 28358,
                        "name": "Poseritz",
                        "latitude": "54.29811000",
                        "longitude": "13.27492000"
                    },
                    {
                        "id": 28372,
                        "name": "Preetz",
                        "latitude": "54.35017000",
                        "longitude": "12.98936000"
                    },
                    {
                        "id": 28395,
                        "name": "Prohn",
                        "latitude": "54.36901000",
                        "longitude": "13.02369000"
                    },
                    {
                        "id": 28408,
                        "name": "Putbus",
                        "latitude": "54.35511000",
                        "longitude": "13.47634000"
                    },
                    {
                        "id": 28435,
                        "name": "Raben Steinfeld",
                        "latitude": "53.60141000",
                        "longitude": "11.50487000"
                    },
                    {
                        "id": 28459,
                        "name": "Rambin",
                        "latitude": "54.35566000",
                        "longitude": "13.20445000"
                    },
                    {
                        "id": 28482,
                        "name": "Rastow",
                        "latitude": "53.45709000",
                        "longitude": "11.43145000"
                    },
                    {
                        "id": 28502,
                        "name": "Rechlin",
                        "latitude": "53.33549000",
                        "longitude": "12.72543000"
                    },
                    {
                        "id": 28534,
                        "name": "Rehna",
                        "latitude": "53.77877000",
                        "longitude": "11.04929000"
                    },
                    {
                        "id": 28556,
                        "name": "Reinberg",
                        "latitude": "53.67484000",
                        "longitude": "13.14417000"
                    },
                    {
                        "id": 28586,
                        "name": "Retgendorf",
                        "latitude": "53.72922000",
                        "longitude": "11.50359000"
                    },
                    {
                        "id": 28589,
                        "name": "Retschow",
                        "latitude": "54.04552000",
                        "longitude": "11.87780000"
                    },
                    {
                        "id": 28621,
                        "name": "Ribnitz-Damgarten",
                        "latitude": "54.24220000",
                        "longitude": "12.45666000"
                    },
                    {
                        "id": 28622,
                        "name": "Richtenberg",
                        "latitude": "54.20131000",
                        "longitude": "12.89409000"
                    },
                    {
                        "id": 28773,
                        "name": "Röbel",
                        "latitude": "53.37555000",
                        "longitude": "12.60372000"
                    },
                    {
                        "id": 28684,
                        "name": "Roggendorf",
                        "latitude": "53.69292000",
                        "longitude": "11.01440000"
                    },
                    {
                        "id": 28685,
                        "name": "Roggentin",
                        "latitude": "54.07070000",
                        "longitude": "12.20424000"
                    },
                    {
                        "id": 28708,
                        "name": "Rosenow",
                        "latitude": "53.62966000",
                        "longitude": "13.03849000"
                    },
                    {
                        "id": 28715,
                        "name": "Rostock",
                        "latitude": "54.08870000",
                        "longitude": "12.14049000"
                    },
                    {
                        "id": 28796,
                        "name": "Rövershagen",
                        "latitude": "54.17668000",
                        "longitude": "12.24276000"
                    },
                    {
                        "id": 28811,
                        "name": "Saal",
                        "latitude": "54.31051000",
                        "longitude": "12.49935000"
                    },
                    {
                        "id": 28828,
                        "name": "Sagard",
                        "latitude": "54.52556000",
                        "longitude": "13.55387000"
                    },
                    {
                        "id": 28848,
                        "name": "Samtens",
                        "latitude": "54.35481000",
                        "longitude": "13.29311000"
                    },
                    {
                        "id": 28900,
                        "name": "Saßnitz",
                        "latitude": "54.51570000",
                        "longitude": "13.64451000"
                    },
                    {
                        "id": 28891,
                        "name": "Satow-Oberhagen",
                        "latitude": "53.99545000",
                        "longitude": "11.88466000"
                    },
                    {
                        "id": 28924,
                        "name": "Schelfstadt",
                        "latitude": "53.63382000",
                        "longitude": "11.41711000"
                    },
                    {
                        "id": 28959,
                        "name": "Schlagsdorf",
                        "latitude": "53.73363000",
                        "longitude": "10.82556000"
                    },
                    {
                        "id": 29038,
                        "name": "Schwaan",
                        "latitude": "53.94047000",
                        "longitude": "12.10715000"
                    },
                    {
                        "id": 29090,
                        "name": "Schwerin",
                        "latitude": "53.62937000",
                        "longitude": "11.41316000"
                    },
                    {
                        "id": 29144,
                        "name": "Seebad Bansin",
                        "latitude": "53.97102000",
                        "longitude": "14.14147000"
                    },
                    {
                        "id": 29145,
                        "name": "Seebad Heringsdorf",
                        "latitude": "53.95379000",
                        "longitude": "14.16852000"
                    },
                    {
                        "id": 29154,
                        "name": "Seeheilbad Graal-Müritz",
                        "latitude": "54.25124000",
                        "longitude": "12.25139000"
                    },
                    {
                        "id": 29156,
                        "name": "Seehof",
                        "latitude": "53.69249000",
                        "longitude": "11.43256000"
                    },
                    {
                        "id": 29169,
                        "name": "Sehlen",
                        "latitude": "54.37971000",
                        "longitude": "13.38907000"
                    },
                    {
                        "id": 29180,
                        "name": "Sellin",
                        "latitude": "53.88495000",
                        "longitude": "11.60790000"
                    },
                    {
                        "id": 29182,
                        "name": "Selmsdorf",
                        "latitude": "53.88224000",
                        "longitude": "10.85997000"
                    },
                    {
                        "id": 29225,
                        "name": "Siggelkow",
                        "latitude": "53.38742000",
                        "longitude": "11.93802000"
                    },
                    {
                        "id": 29304,
                        "name": "Spornitz",
                        "latitude": "53.40749000",
                        "longitude": "11.71864000"
                    },
                    {
                        "id": 29448,
                        "name": "Stäbelow",
                        "latitude": "54.04119000",
                        "longitude": "12.02336000"
                    },
                    {
                        "id": 29377,
                        "name": "Steinhagen",
                        "latitude": "54.22616000",
                        "longitude": "12.98867000"
                    },
                    {
                        "id": 29401,
                        "name": "Sternberg",
                        "latitude": "53.71236000",
                        "longitude": "11.82678000"
                    },
                    {
                        "id": 29424,
                        "name": "Stralendorf",
                        "latitude": "53.57498000",
                        "longitude": "11.30356000"
                    },
                    {
                        "id": 29425,
                        "name": "Stralsund",
                        "latitude": "54.30911000",
                        "longitude": "13.08180000"
                    },
                    {
                        "id": 29427,
                        "name": "Strasburg",
                        "latitude": "53.51030000",
                        "longitude": "13.74513000"
                    },
                    {
                        "id": 29464,
                        "name": "Sukow",
                        "latitude": "53.54428000",
                        "longitude": "11.56194000"
                    },
                    {
                        "id": 29503,
                        "name": "Sülstorf",
                        "latitude": "53.50931000",
                        "longitude": "11.37463000"
                    },
                    {
                        "id": 29530,
                        "name": "Tarnow",
                        "latitude": "53.77941000",
                        "longitude": "12.01785000"
                    },
                    {
                        "id": 29561,
                        "name": "Tessin",
                        "latitude": "54.02764000",
                        "longitude": "12.46519000"
                    },
                    {
                        "id": 29562,
                        "name": "Teterow",
                        "latitude": "53.77545000",
                        "longitude": "12.57487000"
                    },
                    {
                        "id": 29633,
                        "name": "Torgelow",
                        "latitude": "53.63415000",
                        "longitude": "14.01346000"
                    },
                    {
                        "id": 29665,
                        "name": "Tribsees",
                        "latitude": "54.09556000",
                        "longitude": "12.75683000"
                    },
                    {
                        "id": 29671,
                        "name": "Trinwillershagen",
                        "latitude": "54.25048000",
                        "longitude": "12.62312000"
                    },
                    {
                        "id": 29679,
                        "name": "Trollenhagen",
                        "latitude": "53.60706000",
                        "longitude": "13.29103000"
                    },
                    {
                        "id": 29693,
                        "name": "Tutow",
                        "latitude": "53.91566000",
                        "longitude": "13.24814000"
                    },
                    {
                        "id": 29719,
                        "name": "Ueckermünde",
                        "latitude": "53.73795000",
                        "longitude": "14.04473000"
                    },
                    {
                        "id": 29797,
                        "name": "Usedom",
                        "latitude": "53.87537000",
                        "longitude": "13.92394000"
                    },
                    {
                        "id": 29827,
                        "name": "Velgast",
                        "latitude": "54.27204000",
                        "longitude": "12.81075000"
                    },
                    {
                        "id": 29844,
                        "name": "Viereck",
                        "latitude": "53.54898000",
                        "longitude": "14.04001000"
                    },
                    {
                        "id": 29907,
                        "name": "Wackerow",
                        "latitude": "53.67683000",
                        "longitude": "12.98164000"
                    },
                    {
                        "id": 30014,
                        "name": "Wardow",
                        "latitude": "53.93054000",
                        "longitude": "12.40818000"
                    },
                    {
                        "id": 30015,
                        "name": "Waren",
                        "latitude": "53.52040000",
                        "longitude": "12.67985000"
                    },
                    {
                        "id": 30017,
                        "name": "Warin",
                        "latitude": "53.80026000",
                        "longitude": "11.70504000"
                    },
                    {
                        "id": 30020,
                        "name": "Warnemünde",
                        "latitude": "54.17670000",
                        "longitude": "12.08402000"
                    },
                    {
                        "id": 30022,
                        "name": "Warnow",
                        "latitude": "53.78580000",
                        "longitude": "11.88106000"
                    },
                    {
                        "id": 30042,
                        "name": "Wattmannshagen",
                        "latitude": "53.77590000",
                        "longitude": "12.40701000"
                    },
                    {
                        "id": 30116,
                        "name": "Weitenhagen",
                        "latitude": "54.05372000",
                        "longitude": "13.40998000"
                    },
                    {
                        "id": 30159,
                        "name": "Wendorf",
                        "latitude": "54.25540000",
                        "longitude": "13.07682000"
                    },
                    {
                        "id": 30171,
                        "name": "Werdervorstadt",
                        "latitude": "53.63909000",
                        "longitude": "11.42767000"
                    },
                    {
                        "id": 30193,
                        "name": "Wesenberg",
                        "latitude": "53.28030000",
                        "longitude": "12.96936000"
                    },
                    {
                        "id": 30222,
                        "name": "Weststadt",
                        "latitude": "53.63472000",
                        "longitude": "11.39565000"
                    },
                    {
                        "id": 30247,
                        "name": "Wiek",
                        "latitude": "54.62000000",
                        "longitude": "13.28914000"
                    },
                    {
                        "id": 30345,
                        "name": "Wismar",
                        "latitude": "53.89314000",
                        "longitude": "11.45286000"
                    },
                    {
                        "id": 30353,
                        "name": "Wittenburg",
                        "latitude": "53.50599000",
                        "longitude": "11.08049000"
                    },
                    {
                        "id": 30354,
                        "name": "Wittenförden",
                        "latitude": "53.62917000",
                        "longitude": "11.32982000"
                    },
                    {
                        "id": 30355,
                        "name": "Wittenhagen",
                        "latitude": "54.18379000",
                        "longitude": "13.07133000"
                    },
                    {
                        "id": 30373,
                        "name": "Woldegk",
                        "latitude": "53.46058000",
                        "longitude": "13.58356000"
                    },
                    {
                        "id": 30389,
                        "name": "Wolgast",
                        "latitude": "54.05275000",
                        "longitude": "13.77201000"
                    },
                    {
                        "id": 30416,
                        "name": "Wulkenzin",
                        "latitude": "53.54445000",
                        "longitude": "13.16921000"
                    },
                    {
                        "id": 30428,
                        "name": "Wusterhusen",
                        "latitude": "54.11312000",
                        "longitude": "13.61608000"
                    },
                    {
                        "id": 30431,
                        "name": "Wustrow",
                        "latitude": "53.47765000",
                        "longitude": "13.15569000"
                    },
                    {
                        "id": 30472,
                        "name": "Zarrendorf",
                        "latitude": "54.23689000",
                        "longitude": "13.10094000"
                    },
                    {
                        "id": 30473,
                        "name": "Zarrentin",
                        "latitude": "53.55075000",
                        "longitude": "10.91550000"
                    },
                    {
                        "id": 30506,
                        "name": "Ziesendorf",
                        "latitude": "53.99433000",
                        "longitude": "12.03933000"
                    },
                    {
                        "id": 30509,
                        "name": "Zingst",
                        "latitude": "54.43572000",
                        "longitude": "12.68880000"
                    },
                    {
                        "id": 30527,
                        "name": "Zurow",
                        "latitude": "53.86429000",
                        "longitude": "11.61434000"
                    },
                    {
                        "id": 30544,
                        "name": "Züssow",
                        "latitude": "53.97709000",
                        "longitude": "13.54855000"
                    }
                ]
            },
            {
                "id": 3017,
                "name": "North Rhine-Westphalia",
                "iso2": "NW",
                "latitude": "51.43323670",
                "longitude": "7.66159380",
                "type": "land",
                "cities": [
                    {
                        "id": 23463,
                        "name": "Aachen",
                        "latitude": "50.77664000",
                        "longitude": "6.08342000"
                    },
                    {
                        "id": 23500,
                        "name": "Ahaus",
                        "latitude": "52.07936000",
                        "longitude": "7.01344000"
                    },
                    {
                        "id": 23504,
                        "name": "Ahlen",
                        "latitude": "51.76338000",
                        "longitude": "7.88870000"
                    },
                    {
                        "id": 23542,
                        "name": "Aldenhoven",
                        "latitude": "50.90000000",
                        "longitude": "6.28333000"
                    },
                    {
                        "id": 23552,
                        "name": "Alfter",
                        "latitude": "50.73333000",
                        "longitude": "7.01667000"
                    },
                    {
                        "id": 23564,
                        "name": "Alpen",
                        "latitude": "51.58333000",
                        "longitude": "6.51667000"
                    },
                    {
                        "id": 23568,
                        "name": "Alsdorf",
                        "latitude": "50.87673000",
                        "longitude": "6.16399000"
                    },
                    {
                        "id": 23589,
                        "name": "Altena",
                        "latitude": "51.29472000",
                        "longitude": "7.67337000"
                    },
                    {
                        "id": 23592,
                        "name": "Altenbeken",
                        "latitude": "51.76455000",
                        "longitude": "8.94201000"
                    },
                    {
                        "id": 23594,
                        "name": "Altenberge",
                        "latitude": "52.05000000",
                        "longitude": "7.46667000"
                    },
                    {
                        "id": 23597,
                        "name": "Altenbüren",
                        "latitude": "51.38634000",
                        "longitude": "8.50584000"
                    },
                    {
                        "id": 23636,
                        "name": "Altstadt Nord",
                        "latitude": "50.93893000",
                        "longitude": "6.95752000"
                    },
                    {
                        "id": 23637,
                        "name": "Altstadt Sud",
                        "latitude": "50.93331000",
                        "longitude": "6.95954000"
                    },
                    {
                        "id": 23665,
                        "name": "Anröchte",
                        "latitude": "51.56667000",
                        "longitude": "8.33333000"
                    },
                    {
                        "id": 23686,
                        "name": "Arnsberg",
                        "latitude": "51.38333000",
                        "longitude": "8.08333000"
                    },
                    {
                        "id": 23705,
                        "name": "Ascheberg",
                        "latitude": "51.78333000",
                        "longitude": "7.61667000"
                    },
                    {
                        "id": 23714,
                        "name": "Attendorn",
                        "latitude": "51.12645000",
                        "longitude": "7.90333000"
                    },
                    {
                        "id": 23732,
                        "name": "Augustdorf",
                        "latitude": "51.90944000",
                        "longitude": "8.73173000"
                    },
                    {
                        "id": 23768,
                        "name": "Bad Berleburg",
                        "latitude": "51.05224000",
                        "longitude": "8.39227000"
                    },
                    {
                        "id": 23783,
                        "name": "Bad Driburg",
                        "latitude": "51.73297000",
                        "longitude": "9.01969000"
                    },
                    {
                        "id": 23797,
                        "name": "Bad Fredeburg",
                        "latitude": "51.18930000",
                        "longitude": "8.30978000"
                    },
                    {
                        "id": 23807,
                        "name": "Bad Holzhausen",
                        "latitude": "52.28971000",
                        "longitude": "8.53954000"
                    },
                    {
                        "id": 23809,
                        "name": "Bad Honnef",
                        "latitude": "50.64336000",
                        "longitude": "7.22780000"
                    },
                    {
                        "id": 23822,
                        "name": "Bad Laasphe",
                        "latitude": "50.93139000",
                        "longitude": "8.42502000"
                    },
                    {
                        "id": 23831,
                        "name": "Bad Lippspringe",
                        "latitude": "51.78333000",
                        "longitude": "8.81683000"
                    },
                    {
                        "id": 23834,
                        "name": "Bad Meinberg",
                        "latitude": "51.89588000",
                        "longitude": "8.98313000"
                    },
                    {
                        "id": 23839,
                        "name": "Bad Münstereifel",
                        "latitude": "50.55667000",
                        "longitude": "6.76424000"
                    },
                    {
                        "id": 23844,
                        "name": "Bad Oeynhausen",
                        "latitude": "52.20699000",
                        "longitude": "8.80365000"
                    },
                    {
                        "id": 23857,
                        "name": "Bad Salzuflen",
                        "latitude": "52.08620000",
                        "longitude": "8.74434000"
                    },
                    {
                        "id": 23859,
                        "name": "Bad Sassendorf",
                        "latitude": "51.58333000",
                        "longitude": "8.16667000"
                    },
                    {
                        "id": 23898,
                        "name": "Baesweiler",
                        "latitude": "50.90964000",
                        "longitude": "6.18874000"
                    },
                    {
                        "id": 23914,
                        "name": "Balve",
                        "latitude": "51.33150000",
                        "longitude": "7.86424000"
                    },
                    {
                        "id": 23918,
                        "name": "Bamenohl",
                        "latitude": "51.16527000",
                        "longitude": "7.98412000"
                    },
                    {
                        "id": 23940,
                        "name": "Barntrup",
                        "latitude": "51.99038000",
                        "longitude": "9.11642000"
                    },
                    {
                        "id": 23965,
                        "name": "Bayenthal",
                        "latitude": "50.91218000",
                        "longitude": "6.96799000"
                    },
                    {
                        "id": 23979,
                        "name": "Beckum",
                        "latitude": "51.75571000",
                        "longitude": "8.04075000"
                    },
                    {
                        "id": 23980,
                        "name": "Bedburg",
                        "latitude": "50.99258000",
                        "longitude": "6.57128000"
                    },
                    {
                        "id": 23982,
                        "name": "Beelen",
                        "latitude": "51.92906000",
                        "longitude": "8.11117000"
                    },
                    {
                        "id": 24039,
                        "name": "Bergheim",
                        "latitude": "50.95572000",
                        "longitude": "6.63986000"
                    },
                    {
                        "id": 24041,
                        "name": "Bergisch Gladbach",
                        "latitude": "50.98560000",
                        "longitude": "7.13298000"
                    },
                    {
                        "id": 24042,
                        "name": "Bergkamen",
                        "latitude": "51.61633000",
                        "longitude": "7.64451000"
                    },
                    {
                        "id": 24045,
                        "name": "Bergneustadt",
                        "latitude": "51.02496000",
                        "longitude": "7.65599000"
                    },
                    {
                        "id": 24080,
                        "name": "Bestwig",
                        "latitude": "51.36081000",
                        "longitude": "8.40082000"
                    },
                    {
                        "id": 24093,
                        "name": "Beverungen",
                        "latitude": "51.66801000",
                        "longitude": "9.37417000"
                    },
                    {
                        "id": 24107,
                        "name": "Bielefeld",
                        "latitude": "52.03333000",
                        "longitude": "8.53333000"
                    },
                    {
                        "id": 24116,
                        "name": "Bilderstoeckchen",
                        "latitude": "50.96983000",
                        "longitude": "6.92997000"
                    },
                    {
                        "id": 24117,
                        "name": "Billerbeck",
                        "latitude": "51.97829000",
                        "longitude": "7.29261000"
                    },
                    {
                        "id": 24131,
                        "name": "Birgte",
                        "latitude": "52.24790000",
                        "longitude": "7.64833000"
                    },
                    {
                        "id": 24169,
                        "name": "Blankenheim",
                        "latitude": "50.43333000",
                        "longitude": "6.65000000"
                    },
                    {
                        "id": 24184,
                        "name": "Blomberg",
                        "latitude": "51.94331000",
                        "longitude": "9.09067000"
                    },
                    {
                        "id": 24192,
                        "name": "Bocholt",
                        "latitude": "51.83879000",
                        "longitude": "6.61531000"
                    },
                    {
                        "id": 24193,
                        "name": "Bochum",
                        "latitude": "51.48165000",
                        "longitude": "7.21648000"
                    },
                    {
                        "id": 24194,
                        "name": "Bochum-Hordel",
                        "latitude": "51.50168000",
                        "longitude": "7.17560000"
                    },
                    {
                        "id": 24469,
                        "name": "Bönen",
                        "latitude": "51.60000000",
                        "longitude": "7.76667000"
                    },
                    {
                        "id": 24231,
                        "name": "Bonn",
                        "latitude": "50.73438000",
                        "longitude": "7.09549000"
                    },
                    {
                        "id": 24240,
                        "name": "Borgentreich",
                        "latitude": "51.56917000",
                        "longitude": "9.24113000"
                    },
                    {
                        "id": 24242,
                        "name": "Borgholzhausen",
                        "latitude": "52.10343000",
                        "longitude": "8.30211000"
                    },
                    {
                        "id": 24244,
                        "name": "Borken",
                        "latitude": "51.84382000",
                        "longitude": "6.85774000"
                    },
                    {
                        "id": 24253,
                        "name": "Bornheim",
                        "latitude": "50.76313000",
                        "longitude": "6.99089000"
                    },
                    {
                        "id": 24263,
                        "name": "Bottrop",
                        "latitude": "51.52392000",
                        "longitude": "6.92850000"
                    },
                    {
                        "id": 24274,
                        "name": "Brakel",
                        "latitude": "51.71750000",
                        "longitude": "9.18596000"
                    },
                    {
                        "id": 24292,
                        "name": "Breckerfeld",
                        "latitude": "51.25926000",
                        "longitude": "7.46807000"
                    },
                    {
                        "id": 24335,
                        "name": "Brilon",
                        "latitude": "51.39462000",
                        "longitude": "8.57146000"
                    },
                    {
                        "id": 24369,
                        "name": "Brüggen",
                        "latitude": "51.24053000",
                        "longitude": "6.18376000"
                    },
                    {
                        "id": 24372,
                        "name": "Brühl",
                        "latitude": "50.82928000",
                        "longitude": "6.90499000"
                    },
                    {
                        "id": 24389,
                        "name": "Buchforst",
                        "latitude": "50.95093000",
                        "longitude": "7.00579000"
                    },
                    {
                        "id": 24390,
                        "name": "Buchheim",
                        "latitude": "50.95152000",
                        "longitude": "7.02093000"
                    },
                    {
                        "id": 24500,
                        "name": "Bünde",
                        "latitude": "52.19837000",
                        "longitude": "8.58644000"
                    },
                    {
                        "id": 24405,
                        "name": "Burbach",
                        "latitude": "50.75105000",
                        "longitude": "8.07939000"
                    },
                    {
                        "id": 24501,
                        "name": "Büren",
                        "latitude": "51.55109000",
                        "longitude": "8.55956000"
                    },
                    {
                        "id": 24445,
                        "name": "Burscheid",
                        "latitude": "51.08468000",
                        "longitude": "7.11393000"
                    },
                    {
                        "id": 24526,
                        "name": "Castrop-Rauxel",
                        "latitude": "51.55657000",
                        "longitude": "7.31155000"
                    },
                    {
                        "id": 24547,
                        "name": "Coesfeld",
                        "latitude": "51.94349000",
                        "longitude": "7.16809000"
                    },
                    {
                        "id": 24577,
                        "name": "Dahlem",
                        "latitude": "50.38607000",
                        "longitude": "6.54768000"
                    },
                    {
                        "id": 24602,
                        "name": "Datteln",
                        "latitude": "51.65598000",
                        "longitude": "7.34530000"
                    },
                    {
                        "id": 24621,
                        "name": "Delbrück",
                        "latitude": "51.76503000",
                        "longitude": "8.56223000"
                    },
                    {
                        "id": 24647,
                        "name": "Detmold",
                        "latitude": "51.93855000",
                        "longitude": "8.87318000"
                    },
                    {
                        "id": 24659,
                        "name": "Deutz",
                        "latitude": "50.93463000",
                        "longitude": "6.97495000"
                    },
                    {
                        "id": 24698,
                        "name": "Dinslaken",
                        "latitude": "51.56227000",
                        "longitude": "6.74340000"
                    },
                    {
                        "id": 24799,
                        "name": "Dörentrup",
                        "latitude": "52.04109000",
                        "longitude": "9.00278000"
                    },
                    {
                        "id": 24738,
                        "name": "Dormagen",
                        "latitude": "51.09683000",
                        "longitude": "6.83167000"
                    },
                    {
                        "id": 24746,
                        "name": "Dorsten",
                        "latitude": "51.66166000",
                        "longitude": "6.96514000"
                    },
                    {
                        "id": 24747,
                        "name": "Dortmund",
                        "latitude": "51.51494000",
                        "longitude": "7.46600000"
                    },
                    {
                        "id": 24761,
                        "name": "Dreierwalde",
                        "latitude": "52.33194000",
                        "longitude": "7.50333000"
                    },
                    {
                        "id": 24766,
                        "name": "Drensteinfurt",
                        "latitude": "51.79535000",
                        "longitude": "7.73815000"
                    },
                    {
                        "id": 24771,
                        "name": "Drolshagen",
                        "latitude": "51.02358000",
                        "longitude": "7.77355000"
                    },
                    {
                        "id": 24780,
                        "name": "Duisburg",
                        "latitude": "51.43247000",
                        "longitude": "6.76516000"
                    },
                    {
                        "id": 24805,
                        "name": "Dülmen",
                        "latitude": "51.83149000",
                        "longitude": "7.28075000"
                    },
                    {
                        "id": 24810,
                        "name": "Düren",
                        "latitude": "50.80434000",
                        "longitude": "6.49299000"
                    },
                    {
                        "id": 24817,
                        "name": "Düsseldorf",
                        "latitude": "51.22172000",
                        "longitude": "6.77616000"
                    },
                    {
                        "id": 24818,
                        "name": "Düsseldorf District",
                        "latitude": "51.40000000",
                        "longitude": "6.60000000"
                    },
                    {
                        "id": 24819,
                        "name": "Düsseldorf-Pempelfort",
                        "latitude": "51.23812000",
                        "longitude": "6.78678000"
                    },
                    {
                        "id": 24912,
                        "name": "Eil",
                        "latitude": "50.89362000",
                        "longitude": "7.07967000"
                    },
                    {
                        "id": 24937,
                        "name": "Eitorf",
                        "latitude": "50.76667000",
                        "longitude": "7.45000000"
                    },
                    {
                        "id": 24963,
                        "name": "Elsdorf",
                        "latitude": "50.93739000",
                        "longitude": "6.56828000"
                    },
                    {
                        "id": 24989,
                        "name": "Emmerich",
                        "latitude": "51.83933000",
                        "longitude": "6.24792000"
                    },
                    {
                        "id": 24994,
                        "name": "Emsdetten",
                        "latitude": "52.17340000",
                        "longitude": "7.52781000"
                    },
                    {
                        "id": 25003,
                        "name": "Engelskirchen",
                        "latitude": "50.98854000",
                        "longitude": "7.41391000"
                    },
                    {
                        "id": 25006,
                        "name": "Enger",
                        "latitude": "52.14063000",
                        "longitude": "8.55772000"
                    },
                    {
                        "id": 25010,
                        "name": "Ennepetal",
                        "latitude": "51.29848000",
                        "longitude": "7.36290000"
                    },
                    {
                        "id": 25012,
                        "name": "Ennigerloh",
                        "latitude": "51.83843000",
                        "longitude": "8.03093000"
                    },
                    {
                        "id": 25037,
                        "name": "Erftstadt",
                        "latitude": "50.81481000",
                        "longitude": "6.79387000"
                    },
                    {
                        "id": 25045,
                        "name": "Erkelenz",
                        "latitude": "51.07947000",
                        "longitude": "6.31531000"
                    },
                    {
                        "id": 25050,
                        "name": "Erkrath",
                        "latitude": "51.22235000",
                        "longitude": "6.90831000"
                    },
                    {
                        "id": 25063,
                        "name": "Erndtebrück",
                        "latitude": "50.98927000",
                        "longitude": "8.25288000"
                    },
                    {
                        "id": 25071,
                        "name": "Erwitte",
                        "latitude": "51.61270000",
                        "longitude": "8.33840000"
                    },
                    {
                        "id": 25085,
                        "name": "Eschweiler",
                        "latitude": "50.81854000",
                        "longitude": "6.27184000"
                    },
                    {
                        "id": 25088,
                        "name": "Eslohe",
                        "latitude": "51.25369000",
                        "longitude": "8.16949000"
                    },
                    {
                        "id": 25089,
                        "name": "Espelkamp",
                        "latitude": "52.38251000",
                        "longitude": "8.62127000"
                    },
                    {
                        "id": 25095,
                        "name": "Essen",
                        "latitude": "51.45657000",
                        "longitude": "7.01228000"
                    },
                    {
                        "id": 25116,
                        "name": "Euskirchen",
                        "latitude": "50.66057000",
                        "longitude": "6.78722000"
                    },
                    {
                        "id": 25120,
                        "name": "Everswinkel",
                        "latitude": "51.92595000",
                        "longitude": "7.84690000"
                    },
                    {
                        "id": 25172,
                        "name": "Finnentrop",
                        "latitude": "51.16800000",
                        "longitude": "7.97300000"
                    },
                    {
                        "id": 25234,
                        "name": "Frechen",
                        "latitude": "50.91485000",
                        "longitude": "6.81180000"
                    },
                    {
                        "id": 25256,
                        "name": "Freudenberg",
                        "latitude": "50.89741000",
                        "longitude": "7.87415000"
                    },
                    {
                        "id": 25311,
                        "name": "Fröndenberg",
                        "latitude": "51.47563000",
                        "longitude": "7.76946000"
                    },
                    {
                        "id": 25357,
                        "name": "Gangelt",
                        "latitude": "50.99247000",
                        "longitude": "5.99802000"
                    },
                    {
                        "id": 25396,
                        "name": "Geilenkirchen",
                        "latitude": "50.96745000",
                        "longitude": "6.11763000"
                    },
                    {
                        "id": 25412,
                        "name": "Geldern",
                        "latitude": "51.51908000",
                        "longitude": "6.32363000"
                    },
                    {
                        "id": 25416,
                        "name": "Gelsenkirchen",
                        "latitude": "51.50508000",
                        "longitude": "7.09654000"
                    },
                    {
                        "id": 25468,
                        "name": "Gescher",
                        "latitude": "51.95400000",
                        "longitude": "7.00481000"
                    },
                    {
                        "id": 25471,
                        "name": "Geseke",
                        "latitude": "51.64091000",
                        "longitude": "8.51090000"
                    },
                    {
                        "id": 25478,
                        "name": "Gevelsberg",
                        "latitude": "51.31971000",
                        "longitude": "7.33920000"
                    },
                    {
                        "id": 25499,
                        "name": "Gladbeck",
                        "latitude": "51.57077000",
                        "longitude": "6.98593000"
                    },
                    {
                        "id": 25525,
                        "name": "Goch",
                        "latitude": "51.67873000",
                        "longitude": "6.15895000"
                    },
                    {
                        "id": 25589,
                        "name": "Grefrath",
                        "latitude": "51.33630000",
                        "longitude": "6.34072000"
                    },
                    {
                        "id": 25596,
                        "name": "Gremberghoven",
                        "latitude": "50.90152000",
                        "longitude": "7.06129000"
                    },
                    {
                        "id": 25604,
                        "name": "Greven",
                        "latitude": "52.09364000",
                        "longitude": "7.59396000"
                    },
                    {
                        "id": 25605,
                        "name": "Grevenbroich",
                        "latitude": "51.09102000",
                        "longitude": "6.58270000"
                    },
                    {
                        "id": 25614,
                        "name": "Gronau",
                        "latitude": "52.21099000",
                        "longitude": "7.02238000"
                    },
                    {
                        "id": 25752,
                        "name": "Gummersbach",
                        "latitude": "51.02608000",
                        "longitude": "7.56473000"
                    },
                    {
                        "id": 25802,
                        "name": "Gütersloh",
                        "latitude": "51.90693000",
                        "longitude": "8.37853000"
                    },
                    {
                        "id": 25806,
                        "name": "Haan",
                        "latitude": "51.19382000",
                        "longitude": "7.01330000"
                    },
                    {
                        "id": 25818,
                        "name": "Hagen",
                        "latitude": "51.36081000",
                        "longitude": "7.47168000"
                    },
                    {
                        "id": 25851,
                        "name": "Halle",
                        "latitude": "52.06007000",
                        "longitude": "8.36083000"
                    },
                    {
                        "id": 25855,
                        "name": "Hallenberg",
                        "latitude": "51.11115000",
                        "longitude": "8.62008000"
                    },
                    {
                        "id": 25861,
                        "name": "Haltern am See",
                        "latitude": "51.74297000",
                        "longitude": "7.18163000"
                    },
                    {
                        "id": 25862,
                        "name": "Halver",
                        "latitude": "51.18612000",
                        "longitude": "7.49817000"
                    },
                    {
                        "id": 25873,
                        "name": "Hamm",
                        "latitude": "51.68033000",
                        "longitude": "7.82089000"
                    },
                    {
                        "id": 25880,
                        "name": "Hamminkeln",
                        "latitude": "51.73262000",
                        "longitude": "6.59031000"
                    },
                    {
                        "id": 25908,
                        "name": "Harsewinkel",
                        "latitude": "51.96224000",
                        "longitude": "8.22766000"
                    },
                    {
                        "id": 25940,
                        "name": "Hattingen",
                        "latitude": "51.39894000",
                        "longitude": "7.18557000"
                    },
                    {
                        "id": 25958,
                        "name": "Havixbeck",
                        "latitude": "51.98333000",
                        "longitude": "7.41667000"
                    },
                    {
                        "id": 25974,
                        "name": "Heek",
                        "latitude": "52.11667000",
                        "longitude": "7.10000000"
                    },
                    {
                        "id": 25983,
                        "name": "Heiden",
                        "latitude": "51.83333000",
                        "longitude": "6.93333000"
                    },
                    {
                        "id": 25998,
                        "name": "Heiligenhaus",
                        "latitude": "51.32662000",
                        "longitude": "6.97106000"
                    },
                    {
                        "id": 26005,
                        "name": "Heimbach",
                        "latitude": "50.63693000",
                        "longitude": "6.46896000"
                    },
                    {
                        "id": 26015,
                        "name": "Heinsberg",
                        "latitude": "51.06358000",
                        "longitude": "6.09980000"
                    },
                    {
                        "id": 26025,
                        "name": "Hellenthal",
                        "latitude": "50.48333000",
                        "longitude": "6.43333000"
                    },
                    {
                        "id": 26038,
                        "name": "Hemer",
                        "latitude": "51.38707000",
                        "longitude": "7.77019000"
                    },
                    {
                        "id": 26050,
                        "name": "Hennef",
                        "latitude": "50.77555000",
                        "longitude": "7.28308000"
                    },
                    {
                        "id": 26063,
                        "name": "Herdecke",
                        "latitude": "51.39999000",
                        "longitude": "7.43584000"
                    },
                    {
                        "id": 26067,
                        "name": "Herford",
                        "latitude": "52.11457000",
                        "longitude": "8.67343000"
                    },
                    {
                        "id": 26083,
                        "name": "Herne",
                        "latitude": "51.53880000",
                        "longitude": "7.22572000"
                    },
                    {
                        "id": 26094,
                        "name": "Herscheid",
                        "latitude": "51.17901000",
                        "longitude": "7.74355000"
                    },
                    {
                        "id": 26096,
                        "name": "Herten",
                        "latitude": "51.59638000",
                        "longitude": "7.14387000"
                    },
                    {
                        "id": 26103,
                        "name": "Herzogenrath",
                        "latitude": "50.86874000",
                        "longitude": "6.09317000"
                    },
                    {
                        "id": 26130,
                        "name": "Hiddenhausen",
                        "latitude": "52.16667000",
                        "longitude": "8.61667000"
                    },
                    {
                        "id": 26133,
                        "name": "Hilchenbach",
                        "latitude": "50.99687000",
                        "longitude": "8.11062000"
                    },
                    {
                        "id": 26135,
                        "name": "Hilden",
                        "latitude": "51.16818000",
                        "longitude": "6.93093000"
                    },
                    {
                        "id": 26142,
                        "name": "Hille",
                        "latitude": "52.33333000",
                        "longitude": "8.75000000"
                    },
                    {
                        "id": 26175,
                        "name": "Hochfeld",
                        "latitude": "51.41943000",
                        "longitude": "6.75462000"
                    },
                    {
                        "id": 26309,
                        "name": "Höhenberg",
                        "latitude": "50.93323000",
                        "longitude": "7.04138000"
                    },
                    {
                        "id": 26250,
                        "name": "Holzwickede",
                        "latitude": "51.50000000",
                        "longitude": "7.63333000"
                    },
                    {
                        "id": 26258,
                        "name": "Hordel",
                        "latitude": "51.49784000",
                        "longitude": "7.17620000"
                    },
                    {
                        "id": 26264,
                        "name": "Horn",
                        "latitude": "51.87151000",
                        "longitude": "8.94510000"
                    },
                    {
                        "id": 26321,
                        "name": "Hörstel",
                        "latitude": "52.29763000",
                        "longitude": "7.58382000"
                    },
                    {
                        "id": 26274,
                        "name": "Horstmar",
                        "latitude": "52.08098000",
                        "longitude": "7.30539000"
                    },
                    {
                        "id": 26326,
                        "name": "Hövelhof",
                        "latitude": "51.81667000",
                        "longitude": "8.65000000"
                    },
                    {
                        "id": 26327,
                        "name": "Höxter",
                        "latitude": "51.77501000",
                        "longitude": "9.38155000"
                    },
                    {
                        "id": 26328,
                        "name": "Hückelhoven",
                        "latitude": "51.05550000",
                        "longitude": "6.22658000"
                    },
                    {
                        "id": 26329,
                        "name": "Hückeswagen",
                        "latitude": "51.14979000",
                        "longitude": "7.34471000"
                    },
                    {
                        "id": 26335,
                        "name": "Hüllhorst",
                        "latitude": "52.28333000",
                        "longitude": "8.66667000"
                    },
                    {
                        "id": 26283,
                        "name": "Humboldtkolonie",
                        "latitude": "50.93182000",
                        "longitude": "6.99469000"
                    },
                    {
                        "id": 26338,
                        "name": "Hünxe",
                        "latitude": "51.63405000",
                        "longitude": "6.69741000"
                    },
                    {
                        "id": 26339,
                        "name": "Hürtgenwald",
                        "latitude": "50.71667000",
                        "longitude": "6.36667000"
                    },
                    {
                        "id": 26340,
                        "name": "Hürth",
                        "latitude": "50.87079000",
                        "longitude": "6.86761000"
                    },
                    {
                        "id": 26346,
                        "name": "Ibbenbüren",
                        "latitude": "52.27964000",
                        "longitude": "7.71457000"
                    },
                    {
                        "id": 26387,
                        "name": "Inden",
                        "latitude": "50.84306000",
                        "longitude": "6.36004000"
                    },
                    {
                        "id": 26413,
                        "name": "Iserlohn",
                        "latitude": "51.37547000",
                        "longitude": "7.70281000"
                    },
                    {
                        "id": 26418,
                        "name": "Isselburg",
                        "latitude": "51.83232000",
                        "longitude": "6.46428000"
                    },
                    {
                        "id": 26419,
                        "name": "Issum",
                        "latitude": "51.53333000",
                        "longitude": "6.43333000"
                    },
                    {
                        "id": 26470,
                        "name": "Jüchen",
                        "latitude": "51.10000000",
                        "longitude": "6.50000000"
                    },
                    {
                        "id": 26473,
                        "name": "Jülich",
                        "latitude": "50.92149000",
                        "longitude": "6.36267000"
                    },
                    {
                        "id": 26477,
                        "name": "Kaarst",
                        "latitude": "51.22929000",
                        "longitude": "6.61883000"
                    },
                    {
                        "id": 26489,
                        "name": "Kalk",
                        "latitude": "50.94013000",
                        "longitude": "7.00605000"
                    },
                    {
                        "id": 26490,
                        "name": "Kalkar",
                        "latitude": "51.73907000",
                        "longitude": "6.29101000"
                    },
                    {
                        "id": 26492,
                        "name": "Kall",
                        "latitude": "50.54223000",
                        "longitude": "6.56297000"
                    },
                    {
                        "id": 26499,
                        "name": "Kamen",
                        "latitude": "51.59231000",
                        "longitude": "7.66380000"
                    },
                    {
                        "id": 26503,
                        "name": "Kamp-Lintfort",
                        "latitude": "51.50467000",
                        "longitude": "6.54587000"
                    },
                    {
                        "id": 26567,
                        "name": "Kempen",
                        "latitude": "51.36432000",
                        "longitude": "6.41858000"
                    },
                    {
                        "id": 26572,
                        "name": "Kerpen",
                        "latitude": "50.86991000",
                        "longitude": "6.69691000"
                    },
                    {
                        "id": 26580,
                        "name": "Kevelaer",
                        "latitude": "51.58243000",
                        "longitude": "6.24603000"
                    },
                    {
                        "id": 26586,
                        "name": "Kierspe",
                        "latitude": "51.13403000",
                        "longitude": "7.59075000"
                    },
                    {
                        "id": 26627,
                        "name": "Kirchhundem",
                        "latitude": "51.08556000",
                        "longitude": "8.08893000"
                    },
                    {
                        "id": 26629,
                        "name": "Kirchlengern",
                        "latitude": "52.20000000",
                        "longitude": "8.63333000"
                    },
                    {
                        "id": 26662,
                        "name": "Klein Reken",
                        "latitude": "51.78710000",
                        "longitude": "7.04367000"
                    },
                    {
                        "id": 26683,
                        "name": "Kleve",
                        "latitude": "51.78826000",
                        "longitude": "6.13865000"
                    },
                    {
                        "id": 26818,
                        "name": "Köln",
                        "latitude": "50.93333000",
                        "longitude": "6.95000000"
                    },
                    {
                        "id": 26839,
                        "name": "Königswinter",
                        "latitude": "50.68376000",
                        "longitude": "7.18675000"
                    },
                    {
                        "id": 26726,
                        "name": "Korschenbroich",
                        "latitude": "51.19139000",
                        "longitude": "6.51352000"
                    },
                    {
                        "id": 26739,
                        "name": "Kranenburg",
                        "latitude": "51.78333000",
                        "longitude": "6.01667000"
                    },
                    {
                        "id": 26746,
                        "name": "Krefeld",
                        "latitude": "51.33645000",
                        "longitude": "6.55381000"
                    },
                    {
                        "id": 26755,
                        "name": "Kreuzau",
                        "latitude": "50.74699000",
                        "longitude": "6.49069000"
                    },
                    {
                        "id": 26757,
                        "name": "Kreuztal",
                        "latitude": "50.96775000",
                        "longitude": "7.98848000"
                    },
                    {
                        "id": 26860,
                        "name": "Kürten",
                        "latitude": "51.05000000",
                        "longitude": "7.26667000"
                    },
                    {
                        "id": 26870,
                        "name": "Ladbergen",
                        "latitude": "52.13333000",
                        "longitude": "7.75000000"
                    },
                    {
                        "id": 26873,
                        "name": "Laer",
                        "latitude": "52.05555000",
                        "longitude": "7.35775000"
                    },
                    {
                        "id": 26874,
                        "name": "Lage",
                        "latitude": "51.99223000",
                        "longitude": "8.79301000"
                    },
                    {
                        "id": 26909,
                        "name": "Langenberg",
                        "latitude": "51.77206000",
                        "longitude": "8.31809000"
                    },
                    {
                        "id": 26918,
                        "name": "Langenfeld",
                        "latitude": "51.10821000",
                        "longitude": "6.94831000"
                    },
                    {
                        "id": 26935,
                        "name": "Langerwehe",
                        "latitude": "50.81667000",
                        "longitude": "6.35000000"
                    },
                    {
                        "id": 26949,
                        "name": "Lanstrop",
                        "latitude": "51.57504000",
                        "longitude": "7.56752000"
                    },
                    {
                        "id": 27005,
                        "name": "Legden",
                        "latitude": "52.03333000",
                        "longitude": "7.10000000"
                    },
                    {
                        "id": 27016,
                        "name": "Leichlingen",
                        "latitude": "51.10628000",
                        "longitude": "7.01873000"
                    },
                    {
                        "id": 27035,
                        "name": "Lemgo",
                        "latitude": "52.02786000",
                        "longitude": "8.89901000"
                    },
                    {
                        "id": 27044,
                        "name": "Lengerich",
                        "latitude": "52.18661000",
                        "longitude": "7.86043000"
                    },
                    {
                        "id": 27046,
                        "name": "Lennestadt",
                        "latitude": "51.11721000",
                        "longitude": "8.06707000"
                    },
                    {
                        "id": 27054,
                        "name": "Leopoldshöhe",
                        "latitude": "52.01246000",
                        "longitude": "8.69834000"
                    },
                    {
                        "id": 27071,
                        "name": "Leverkusen",
                        "latitude": "51.03030000",
                        "longitude": "6.98432000"
                    },
                    {
                        "id": 27075,
                        "name": "Lichtenau",
                        "latitude": "51.61707000",
                        "longitude": "8.89665000"
                    },
                    {
                        "id": 27093,
                        "name": "Lienen",
                        "latitude": "52.15000000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 27111,
                        "name": "Lindlar",
                        "latitude": "51.01959000",
                        "longitude": "7.37758000"
                    },
                    {
                        "id": 27117,
                        "name": "Linnich",
                        "latitude": "50.98002000",
                        "longitude": "6.27049000"
                    },
                    {
                        "id": 27120,
                        "name": "Lippstadt",
                        "latitude": "51.67369000",
                        "longitude": "8.34482000"
                    },
                    {
                        "id": 27133,
                        "name": "Lohmar",
                        "latitude": "50.83868000",
                        "longitude": "7.21399000"
                    },
                    {
                        "id": 27195,
                        "name": "Löhne",
                        "latitude": "52.18848000",
                        "longitude": "8.69220000"
                    },
                    {
                        "id": 27153,
                        "name": "Lotte",
                        "latitude": "52.28333000",
                        "longitude": "7.91667000"
                    },
                    {
                        "id": 27202,
                        "name": "Lübbecke",
                        "latitude": "52.30699000",
                        "longitude": "8.61423000"
                    },
                    {
                        "id": 27211,
                        "name": "Lüdenscheid",
                        "latitude": "51.21977000",
                        "longitude": "7.62730000"
                    },
                    {
                        "id": 27216,
                        "name": "Lüdinghausen",
                        "latitude": "51.76830000",
                        "longitude": "7.44379000"
                    },
                    {
                        "id": 27217,
                        "name": "Lügde",
                        "latitude": "51.95828000",
                        "longitude": "9.24706000"
                    },
                    {
                        "id": 27219,
                        "name": "Lünen",
                        "latitude": "51.61634000",
                        "longitude": "7.52872000"
                    },
                    {
                        "id": 27277,
                        "name": "Marienheide",
                        "latitude": "51.08317000",
                        "longitude": "7.53087000"
                    },
                    {
                        "id": 27318,
                        "name": "Marl",
                        "latitude": "51.65671000",
                        "longitude": "7.09038000"
                    },
                    {
                        "id": 27325,
                        "name": "Marsberg",
                        "latitude": "51.46171000",
                        "longitude": "8.84949000"
                    },
                    {
                        "id": 27354,
                        "name": "Mechernich",
                        "latitude": "50.59304000",
                        "longitude": "6.65224000"
                    },
                    {
                        "id": 27358,
                        "name": "Meckenheim",
                        "latitude": "50.62388000",
                        "longitude": "7.02942000"
                    },
                    {
                        "id": 27362,
                        "name": "Medebach",
                        "latitude": "51.19713000",
                        "longitude": "8.70635000"
                    },
                    {
                        "id": 27367,
                        "name": "Meerbusch",
                        "latitude": "51.25268000",
                        "longitude": "6.68807000"
                    },
                    {
                        "id": 27375,
                        "name": "Mehrhoog",
                        "latitude": "51.73826000",
                        "longitude": "6.51164000"
                    },
                    {
                        "id": 27380,
                        "name": "Meiderich",
                        "latitude": "51.46667000",
                        "longitude": "6.76667000"
                    },
                    {
                        "id": 27382,
                        "name": "Meinerzhagen",
                        "latitude": "51.10740000",
                        "longitude": "7.64838000"
                    },
                    {
                        "id": 27404,
                        "name": "Menden",
                        "latitude": "51.44337000",
                        "longitude": "7.77825000"
                    },
                    {
                        "id": 27407,
                        "name": "Mengenich",
                        "latitude": "50.97850000",
                        "longitude": "6.86737000"
                    },
                    {
                        "id": 27431,
                        "name": "Meschede",
                        "latitude": "51.35020000",
                        "longitude": "8.28332000"
                    },
                    {
                        "id": 27436,
                        "name": "Metelen",
                        "latitude": "52.14434000",
                        "longitude": "7.21270000"
                    },
                    {
                        "id": 27441,
                        "name": "Mettingen",
                        "latitude": "52.31667000",
                        "longitude": "7.78333000"
                    },
                    {
                        "id": 27443,
                        "name": "Mettmann",
                        "latitude": "51.25040000",
                        "longitude": "6.97536000"
                    },
                    {
                        "id": 27472,
                        "name": "Minden",
                        "latitude": "52.28953000",
                        "longitude": "8.91455000"
                    },
                    {
                        "id": 27499,
                        "name": "Moers",
                        "latitude": "51.45342000",
                        "longitude": "6.63260000"
                    },
                    {
                        "id": 27561,
                        "name": "Möhnesee",
                        "latitude": "51.50000000",
                        "longitude": "8.13333000"
                    },
                    {
                        "id": 27568,
                        "name": "Mönchengladbach",
                        "latitude": "51.18539000",
                        "longitude": "6.44172000"
                    },
                    {
                        "id": 27509,
                        "name": "Monheim am Rhein",
                        "latitude": "51.09162000",
                        "longitude": "6.89217000"
                    },
                    {
                        "id": 27510,
                        "name": "Monschau",
                        "latitude": "50.55462000",
                        "longitude": "6.24001000"
                    },
                    {
                        "id": 27526,
                        "name": "Morsbach",
                        "latitude": "50.86665000",
                        "longitude": "7.72787000"
                    },
                    {
                        "id": 27530,
                        "name": "Much",
                        "latitude": "50.90383000",
                        "longitude": "7.40306000"
                    },
                    {
                        "id": 27604,
                        "name": "Mülheim",
                        "latitude": "51.43218000",
                        "longitude": "6.87967000"
                    },
                    {
                        "id": 27621,
                        "name": "Münster",
                        "latitude": "51.96236000",
                        "longitude": "7.62571000"
                    },
                    {
                        "id": 27631,
                        "name": "Nachrodt-Wiblingwerde",
                        "latitude": "51.31667000",
                        "longitude": "7.61667000"
                    },
                    {
                        "id": 27683,
                        "name": "Netphen",
                        "latitude": "50.91667000",
                        "longitude": "8.10000000"
                    },
                    {
                        "id": 27684,
                        "name": "Nettersheim",
                        "latitude": "50.49372000",
                        "longitude": "6.62896000"
                    },
                    {
                        "id": 27685,
                        "name": "Nettetal",
                        "latitude": "51.31667000",
                        "longitude": "6.28333000"
                    },
                    {
                        "id": 27694,
                        "name": "Neu-Pattern",
                        "latitude": "50.88854000",
                        "longitude": "6.27688000"
                    },
                    {
                        "id": 27702,
                        "name": "Neubrück",
                        "latitude": "51.13434000",
                        "longitude": "6.63857000"
                    },
                    {
                        "id": 27716,
                        "name": "Neuehrenfeld",
                        "latitude": "50.95753000",
                        "longitude": "6.93611000"
                    },
                    {
                        "id": 27723,
                        "name": "Neuenkirchen",
                        "latitude": "52.24472000",
                        "longitude": "7.37183000"
                    },
                    {
                        "id": 27725,
                        "name": "Neuenrade",
                        "latitude": "51.28278000",
                        "longitude": "7.78250000"
                    },
                    {
                        "id": 27779,
                        "name": "Neunkirchen",
                        "latitude": "50.80000000",
                        "longitude": "8.00000000"
                    },
                    {
                        "id": 27792,
                        "name": "Neuss",
                        "latitude": "51.19807000",
                        "longitude": "6.68504000"
                    },
                    {
                        "id": 27808,
                        "name": "Neustadt\/Nord",
                        "latitude": "50.94900000",
                        "longitude": "6.94790000"
                    },
                    {
                        "id": 27809,
                        "name": "Neustadt\/Süd",
                        "latitude": "50.92509000",
                        "longitude": "6.94762000"
                    },
                    {
                        "id": 27823,
                        "name": "Nideggen",
                        "latitude": "50.69268000",
                        "longitude": "6.48437000"
                    },
                    {
                        "id": 27850,
                        "name": "Niederkassel",
                        "latitude": "50.81503000",
                        "longitude": "7.03777000"
                    },
                    {
                        "id": 27854,
                        "name": "Niederkrüchten",
                        "latitude": "51.20000000",
                        "longitude": "6.21667000"
                    },
                    {
                        "id": 27857,
                        "name": "Niedermerz",
                        "latitude": "50.88151000",
                        "longitude": "6.26651000"
                    },
                    {
                        "id": 27885,
                        "name": "Niederzier",
                        "latitude": "50.88333000",
                        "longitude": "6.46667000"
                    },
                    {
                        "id": 27889,
                        "name": "Nieheim",
                        "latitude": "51.80499000",
                        "longitude": "9.11302000"
                    },
                    {
                        "id": 27901,
                        "name": "Nippes",
                        "latitude": "50.96545000",
                        "longitude": "6.95314000"
                    },
                    {
                        "id": 27924,
                        "name": "Nordkirchen",
                        "latitude": "51.73827000",
                        "longitude": "7.52197000"
                    },
                    {
                        "id": 27928,
                        "name": "Nordwalde",
                        "latitude": "52.08333000",
                        "longitude": "7.48333000"
                    },
                    {
                        "id": 27949,
                        "name": "Nörvenich",
                        "latitude": "50.80604000",
                        "longitude": "6.63952000"
                    },
                    {
                        "id": 27937,
                        "name": "Nottuln",
                        "latitude": "51.93333000",
                        "longitude": "7.35000000"
                    },
                    {
                        "id": 27952,
                        "name": "Nümbrecht",
                        "latitude": "50.90427000",
                        "longitude": "7.54063000"
                    },
                    {
                        "id": 27985,
                        "name": "Oberhausen",
                        "latitude": "51.47805000",
                        "longitude": "6.86250000"
                    },
                    {
                        "id": 28001,
                        "name": "Obernbeck",
                        "latitude": "52.20178000",
                        "longitude": "8.70404000"
                    },
                    {
                        "id": 28065,
                        "name": "Ochtrup",
                        "latitude": "52.20802000",
                        "longitude": "7.18988000"
                    },
                    {
                        "id": 28069,
                        "name": "Odenthal",
                        "latitude": "51.03333000",
                        "longitude": "7.11667000"
                    },
                    {
                        "id": 28076,
                        "name": "Oelde",
                        "latitude": "51.82890000",
                        "longitude": "8.14724000"
                    },
                    {
                        "id": 28079,
                        "name": "Oer-Erkenschwick",
                        "latitude": "51.64198000",
                        "longitude": "7.26451000"
                    },
                    {
                        "id": 28082,
                        "name": "Oerlinghausen",
                        "latitude": "51.95453000",
                        "longitude": "8.66220000"
                    },
                    {
                        "id": 28111,
                        "name": "Olfen",
                        "latitude": "51.70787000",
                        "longitude": "7.37893000"
                    },
                    {
                        "id": 28112,
                        "name": "Olpe",
                        "latitude": "51.02899000",
                        "longitude": "7.85139000"
                    },
                    {
                        "id": 28113,
                        "name": "Olsberg",
                        "latitude": "51.35613000",
                        "longitude": "8.48899000"
                    },
                    {
                        "id": 28116,
                        "name": "Opladen",
                        "latitude": "51.06863000",
                        "longitude": "7.00387000"
                    },
                    {
                        "id": 28141,
                        "name": "Ossendorf",
                        "latitude": "50.97059000",
                        "longitude": "6.90628000"
                    },
                    {
                        "id": 28142,
                        "name": "Ostbevern",
                        "latitude": "52.04018000",
                        "longitude": "7.84229000"
                    },
                    {
                        "id": 28161,
                        "name": "Ostheim",
                        "latitude": "50.93117000",
                        "longitude": "7.04412000"
                    },
                    {
                        "id": 28200,
                        "name": "Overath",
                        "latitude": "50.93275000",
                        "longitude": "7.28389000"
                    },
                    {
                        "id": 28209,
                        "name": "Paderborn",
                        "latitude": "51.71905000",
                        "longitude": "8.75439000"
                    },
                    {
                        "id": 28264,
                        "name": "Petershagen",
                        "latitude": "52.37513000",
                        "longitude": "8.96538000"
                    },
                    {
                        "id": 28324,
                        "name": "Plettenberg",
                        "latitude": "51.20949000",
                        "longitude": "7.87261000"
                    },
                    {
                        "id": 28342,
                        "name": "Poll",
                        "latitude": "50.91256000",
                        "longitude": "6.99057000"
                    },
                    {
                        "id": 28356,
                        "name": "Porta Westfalica",
                        "latitude": "52.22961000",
                        "longitude": "8.91612000"
                    },
                    {
                        "id": 28357,
                        "name": "Porz am Rhein",
                        "latitude": "50.88637000",
                        "longitude": "7.05830000"
                    },
                    {
                        "id": 28384,
                        "name": "Preußisch Oldendorf",
                        "latitude": "52.30589000",
                        "longitude": "8.49341000"
                    },
                    {
                        "id": 28403,
                        "name": "Pulheim",
                        "latitude": "50.99965000",
                        "longitude": "6.80632000"
                    },
                    {
                        "id": 28445,
                        "name": "Radevormwald",
                        "latitude": "51.20219000",
                        "longitude": "7.36027000"
                    },
                    {
                        "id": 28449,
                        "name": "Raesfeld",
                        "latitude": "51.76667000",
                        "longitude": "6.85000000"
                    },
                    {
                        "id": 28451,
                        "name": "Rahden",
                        "latitude": "52.43367000",
                        "longitude": "8.61263000"
                    },
                    {
                        "id": 28484,
                        "name": "Rath",
                        "latitude": "50.92379000",
                        "longitude": "7.09270000"
                    },
                    {
                        "id": 28487,
                        "name": "Ratingen",
                        "latitude": "51.29724000",
                        "longitude": "6.84929000"
                    },
                    {
                        "id": 28506,
                        "name": "Recke",
                        "latitude": "52.36885000",
                        "longitude": "7.72116000"
                    },
                    {
                        "id": 28507,
                        "name": "Recklinghausen",
                        "latitude": "51.61379000",
                        "longitude": "7.19738000"
                    },
                    {
                        "id": 28510,
                        "name": "Rees",
                        "latitude": "51.76263000",
                        "longitude": "6.39778000"
                    },
                    {
                        "id": 28516,
                        "name": "Regierungsbezirk Arnsberg",
                        "latitude": "51.32967000",
                        "longitude": "8.00710000"
                    },
                    {
                        "id": 28518,
                        "name": "Regierungsbezirk Detmold",
                        "latitude": "51.96660000",
                        "longitude": "8.78333000"
                    },
                    {
                        "id": 28521,
                        "name": "Regierungsbezirk Köln",
                        "latitude": "50.78333000",
                        "longitude": "6.86660000"
                    },
                    {
                        "id": 28523,
                        "name": "Regierungsbezirk Münster",
                        "latitude": "51.96660000",
                        "longitude": "7.43330000"
                    },
                    {
                        "id": 28576,
                        "name": "Remscheid",
                        "latitude": "51.17983000",
                        "longitude": "7.19250000"
                    },
                    {
                        "id": 28600,
                        "name": "Rheda-Wiedenbrück",
                        "latitude": "51.84967000",
                        "longitude": "8.30017000"
                    },
                    {
                        "id": 28601,
                        "name": "Rhede",
                        "latitude": "51.83537000",
                        "longitude": "6.69602000"
                    },
                    {
                        "id": 28605,
                        "name": "Rheinbach",
                        "latitude": "50.62562000",
                        "longitude": "6.94911000"
                    },
                    {
                        "id": 28606,
                        "name": "Rheinberg",
                        "latitude": "51.54649000",
                        "longitude": "6.59525000"
                    },
                    {
                        "id": 28610,
                        "name": "Rheine",
                        "latitude": "52.28509000",
                        "longitude": "7.44055000"
                    },
                    {
                        "id": 28616,
                        "name": "Rheurdt",
                        "latitude": "51.46667000",
                        "longitude": "6.46667000"
                    },
                    {
                        "id": 28641,
                        "name": "Riehl",
                        "latitude": "50.96686000",
                        "longitude": "6.97572000"
                    },
                    {
                        "id": 28650,
                        "name": "Rietberg",
                        "latitude": "51.80924000",
                        "longitude": "8.42841000"
                    },
                    {
                        "id": 28779,
                        "name": "Rödinghausen",
                        "latitude": "52.25000000",
                        "longitude": "8.48333000"
                    },
                    {
                        "id": 28682,
                        "name": "Roetgen",
                        "latitude": "50.65000000",
                        "longitude": "6.20000000"
                    },
                    {
                        "id": 28696,
                        "name": "Rommerskirchen",
                        "latitude": "51.03333000",
                        "longitude": "6.68333000"
                    },
                    {
                        "id": 28787,
                        "name": "Rösrath",
                        "latitude": "50.89559000",
                        "longitude": "7.18175000"
                    },
                    {
                        "id": 28769,
                        "name": "Ruppichteroth",
                        "latitude": "50.84367000",
                        "longitude": "7.48409000"
                    },
                    {
                        "id": 28810,
                        "name": "Rüthen",
                        "latitude": "51.49090000",
                        "longitude": "8.43596000"
                    },
                    {
                        "id": 28826,
                        "name": "Saerbeck",
                        "latitude": "52.17372000",
                        "longitude": "7.63395000"
                    },
                    {
                        "id": 28842,
                        "name": "Salzkotten",
                        "latitude": "51.67170000",
                        "longitude": "8.60092000"
                    },
                    {
                        "id": 28861,
                        "name": "Sankt Augustin",
                        "latitude": "50.77538000",
                        "longitude": "7.19700000"
                    },
                    {
                        "id": 28889,
                        "name": "Sassenberg",
                        "latitude": "51.99223000",
                        "longitude": "8.04068000"
                    },
                    {
                        "id": 28907,
                        "name": "Schalksmühle",
                        "latitude": "51.24120000",
                        "longitude": "7.52790000"
                    },
                    {
                        "id": 28932,
                        "name": "Schermbeck",
                        "latitude": "51.68333000",
                        "longitude": "6.86667000"
                    },
                    {
                        "id": 28940,
                        "name": "Schieder-Schwalenberg",
                        "latitude": "51.87713000",
                        "longitude": "9.19538000"
                    },
                    {
                        "id": 28962,
                        "name": "Schlangen",
                        "latitude": "51.80978000",
                        "longitude": "8.84605000"
                    },
                    {
                        "id": 28969,
                        "name": "Schleiden",
                        "latitude": "50.52896000",
                        "longitude": "6.47692000"
                    },
                    {
                        "id": 28988,
                        "name": "Schmallenberg",
                        "latitude": "51.15473000",
                        "longitude": "8.28505000"
                    },
                    {
                        "id": 29136,
                        "name": "Schöppingen",
                        "latitude": "52.10000000",
                        "longitude": "7.23333000"
                    },
                    {
                        "id": 29054,
                        "name": "Schwalmtal",
                        "latitude": "51.21667000",
                        "longitude": "6.26667000"
                    },
                    {
                        "id": 29085,
                        "name": "Schwelm",
                        "latitude": "51.28635000",
                        "longitude": "7.29388000"
                    },
                    {
                        "id": 29091,
                        "name": "Schwerte",
                        "latitude": "51.44387000",
                        "longitude": "7.56750000"
                    },
                    {
                        "id": 29181,
                        "name": "Selm",
                        "latitude": "51.69689000",
                        "longitude": "7.46809000"
                    },
                    {
                        "id": 29189,
                        "name": "Senden",
                        "latitude": "51.85645000",
                        "longitude": "7.48327000"
                    },
                    {
                        "id": 29190,
                        "name": "Sendenhorst",
                        "latitude": "51.84303000",
                        "longitude": "7.82996000"
                    },
                    {
                        "id": 29211,
                        "name": "Siegburg",
                        "latitude": "50.80019000",
                        "longitude": "7.20769000"
                    },
                    {
                        "id": 29213,
                        "name": "Siegen",
                        "latitude": "50.87481000",
                        "longitude": "8.02431000"
                    },
                    {
                        "id": 29220,
                        "name": "Siersdorf",
                        "latitude": "50.89827000",
                        "longitude": "6.22684000"
                    },
                    {
                        "id": 29234,
                        "name": "Simmerath",
                        "latitude": "50.60000000",
                        "longitude": "6.30000000"
                    },
                    {
                        "id": 29244,
                        "name": "Sinnersdorf",
                        "latitude": "51.02445000",
                        "longitude": "6.81787000"
                    },
                    {
                        "id": 29254,
                        "name": "Soest",
                        "latitude": "51.57558000",
                        "longitude": "8.10619000"
                    },
                    {
                        "id": 29258,
                        "name": "Solingen",
                        "latitude": "51.17343000",
                        "longitude": "7.08450000"
                    },
                    {
                        "id": 29275,
                        "name": "Sonsbeck",
                        "latitude": "51.60741000",
                        "longitude": "6.37916000"
                    },
                    {
                        "id": 29296,
                        "name": "Spenge",
                        "latitude": "52.14021000",
                        "longitude": "8.48475000"
                    },
                    {
                        "id": 29310,
                        "name": "Sprockhövel",
                        "latitude": "51.34669000",
                        "longitude": "7.24343000"
                    },
                    {
                        "id": 29326,
                        "name": "Stadtlohn",
                        "latitude": "51.99399000",
                        "longitude": "6.91918000"
                    },
                    {
                        "id": 29374,
                        "name": "Steinfurt",
                        "latitude": "52.15045000",
                        "longitude": "7.33664000"
                    },
                    {
                        "id": 29376,
                        "name": "Steinhagen",
                        "latitude": "52.00000000",
                        "longitude": "8.40000000"
                    },
                    {
                        "id": 29379,
                        "name": "Steinheim",
                        "latitude": "51.87066000",
                        "longitude": "9.09136000"
                    },
                    {
                        "id": 29416,
                        "name": "Stolberg",
                        "latitude": "50.77368000",
                        "longitude": "6.22595000"
                    },
                    {
                        "id": 29422,
                        "name": "Stoßdorf",
                        "latitude": "50.78248000",
                        "longitude": "7.25126000"
                    },
                    {
                        "id": 29423,
                        "name": "Straelen",
                        "latitude": "51.44190000",
                        "longitude": "6.26639000"
                    },
                    {
                        "id": 29501,
                        "name": "Südlohn",
                        "latitude": "51.93333000",
                        "longitude": "6.86667000"
                    },
                    {
                        "id": 29481,
                        "name": "Sundern",
                        "latitude": "51.32810000",
                        "longitude": "8.00369000"
                    },
                    {
                        "id": 29542,
                        "name": "Tecklenburg",
                        "latitude": "52.21957000",
                        "longitude": "7.81357000"
                    },
                    {
                        "id": 29552,
                        "name": "Telgte",
                        "latitude": "51.97995000",
                        "longitude": "7.78293000"
                    },
                    {
                        "id": 29622,
                        "name": "Titz",
                        "latitude": "51.00619000",
                        "longitude": "6.42477000"
                    },
                    {
                        "id": 29701,
                        "name": "Tönisvorst",
                        "latitude": "51.32092000",
                        "longitude": "6.49412000"
                    },
                    {
                        "id": 29678,
                        "name": "Troisdorf",
                        "latitude": "50.80901000",
                        "longitude": "7.14968000"
                    },
                    {
                        "id": 29709,
                        "name": "Türnich",
                        "latitude": "50.85892000",
                        "longitude": "6.75535000"
                    },
                    {
                        "id": 30553,
                        "name": "Übach-Palenberg",
                        "latitude": "50.91775000",
                        "longitude": "6.12336000"
                    },
                    {
                        "id": 29720,
                        "name": "Uedem",
                        "latitude": "51.66520000",
                        "longitude": "6.27371000"
                    },
                    {
                        "id": 29748,
                        "name": "Unna",
                        "latitude": "51.53795000",
                        "longitude": "7.68969000"
                    },
                    {
                        "id": 29823,
                        "name": "Velbert",
                        "latitude": "51.33537000",
                        "longitude": "7.04348000"
                    },
                    {
                        "id": 29826,
                        "name": "Velen",
                        "latitude": "51.89447000",
                        "longitude": "6.98807000"
                    },
                    {
                        "id": 29836,
                        "name": "Verl",
                        "latitude": "51.88333000",
                        "longitude": "8.51667000"
                    },
                    {
                        "id": 29837,
                        "name": "Versmold",
                        "latitude": "52.04009000",
                        "longitude": "8.15272000"
                    },
                    {
                        "id": 29841,
                        "name": "Vettweiß",
                        "latitude": "50.73333000",
                        "longitude": "6.60000000"
                    },
                    {
                        "id": 29849,
                        "name": "Viersen",
                        "latitude": "51.25435000",
                        "longitude": "6.39441000"
                    },
                    {
                        "id": 29863,
                        "name": "Vlotho",
                        "latitude": "52.16530000",
                        "longitude": "8.85996000"
                    },
                    {
                        "id": 29865,
                        "name": "Voerde",
                        "latitude": "51.59703000",
                        "longitude": "6.68630000"
                    },
                    {
                        "id": 29884,
                        "name": "Vreden",
                        "latitude": "52.03792000",
                        "longitude": "6.82800000"
                    },
                    {
                        "id": 29903,
                        "name": "Wachtberg",
                        "latitude": "50.63333000",
                        "longitude": "7.10000000"
                    },
                    {
                        "id": 29904,
                        "name": "Wachtendonk",
                        "latitude": "51.40916000",
                        "longitude": "6.33894000"
                    },
                    {
                        "id": 29911,
                        "name": "Wadersloh",
                        "latitude": "51.73333000",
                        "longitude": "8.25000000"
                    },
                    {
                        "id": 29920,
                        "name": "Wahn-Heide",
                        "latitude": "50.85891000",
                        "longitude": "7.10662000"
                    },
                    {
                        "id": 29939,
                        "name": "Waldbröl",
                        "latitude": "50.87576000",
                        "longitude": "7.61688000"
                    },
                    {
                        "id": 29950,
                        "name": "Waldfeucht",
                        "latitude": "51.06610000",
                        "longitude": "5.98815000"
                    },
                    {
                        "id": 29996,
                        "name": "Waltrop",
                        "latitude": "51.62125000",
                        "longitude": "7.40238000"
                    },
                    {
                        "id": 30012,
                        "name": "Warburg",
                        "latitude": "51.49011000",
                        "longitude": "9.14641000"
                    },
                    {
                        "id": 30016,
                        "name": "Warendorf",
                        "latitude": "51.95109000",
                        "longitude": "7.98756000"
                    },
                    {
                        "id": 30023,
                        "name": "Warstein",
                        "latitude": "51.44488000",
                        "longitude": "8.34851000"
                    },
                    {
                        "id": 30031,
                        "name": "Wassenberg",
                        "latitude": "51.10009000",
                        "longitude": "6.15484000"
                    },
                    {
                        "id": 30053,
                        "name": "Weeze",
                        "latitude": "51.62678000",
                        "longitude": "6.19792000"
                    },
                    {
                        "id": 30056,
                        "name": "Wegberg",
                        "latitude": "51.14221000",
                        "longitude": "6.28436000"
                    },
                    {
                        "id": 30090,
                        "name": "Weilerswist",
                        "latitude": "50.75292000",
                        "longitude": "6.84585000"
                    },
                    {
                        "id": 30148,
                        "name": "Welver",
                        "latitude": "51.61667000",
                        "longitude": "7.96667000"
                    },
                    {
                        "id": 30155,
                        "name": "Wenden",
                        "latitude": "50.96667000",
                        "longitude": "7.86667000"
                    },
                    {
                        "id": 30172,
                        "name": "Werdohl",
                        "latitude": "51.26011000",
                        "longitude": "7.76608000"
                    },
                    {
                        "id": 30174,
                        "name": "Werl",
                        "latitude": "51.55493000",
                        "longitude": "7.91403000"
                    },
                    {
                        "id": 30176,
                        "name": "Wermelskirchen",
                        "latitude": "51.13970000",
                        "longitude": "7.21583000"
                    },
                    {
                        "id": 30180,
                        "name": "Werne",
                        "latitude": "51.66446000",
                        "longitude": "7.63421000"
                    },
                    {
                        "id": 30189,
                        "name": "Werther",
                        "latitude": "52.07771000",
                        "longitude": "8.41793000"
                    },
                    {
                        "id": 30191,
                        "name": "Wesel",
                        "latitude": "51.66690000",
                        "longitude": "6.62037000"
                    },
                    {
                        "id": 30196,
                        "name": "Wesseling",
                        "latitude": "50.82709000",
                        "longitude": "6.97470000"
                    },
                    {
                        "id": 30212,
                        "name": "Westerkappeln",
                        "latitude": "52.31667000",
                        "longitude": "7.88333000"
                    },
                    {
                        "id": 30225,
                        "name": "Wetter (Ruhr)",
                        "latitude": "51.38747000",
                        "longitude": "7.39277000"
                    },
                    {
                        "id": 30228,
                        "name": "Wettringen",
                        "latitude": "52.20939000",
                        "longitude": "7.31895000"
                    },
                    {
                        "id": 30236,
                        "name": "Wickede",
                        "latitude": "51.49640000",
                        "longitude": "7.86587000"
                    },
                    {
                        "id": 30246,
                        "name": "Wiehl",
                        "latitude": "50.94950000",
                        "longitude": "7.55062000"
                    },
                    {
                        "id": 30293,
                        "name": "Willebadessen",
                        "latitude": "51.62564000",
                        "longitude": "9.03694000"
                    },
                    {
                        "id": 30294,
                        "name": "Willich",
                        "latitude": "51.26371000",
                        "longitude": "6.54734000"
                    },
                    {
                        "id": 30300,
                        "name": "Wilnsdorf",
                        "latitude": "50.81667000",
                        "longitude": "8.10000000"
                    },
                    {
                        "id": 30331,
                        "name": "Winterberg",
                        "latitude": "51.19248000",
                        "longitude": "8.53468000"
                    },
                    {
                        "id": 30339,
                        "name": "Wipperfürth",
                        "latitude": "51.11610000",
                        "longitude": "7.39865000"
                    },
                    {
                        "id": 30349,
                        "name": "Witten",
                        "latitude": "51.44362000",
                        "longitude": "7.35258000"
                    },
                    {
                        "id": 30454,
                        "name": "Wülfrath",
                        "latitude": "51.28195000",
                        "longitude": "7.03821000"
                    },
                    {
                        "id": 30456,
                        "name": "Wünnenberg",
                        "latitude": "51.52002000",
                        "longitude": "8.69934000"
                    },
                    {
                        "id": 30420,
                        "name": "Wuppertal",
                        "latitude": "51.25627000",
                        "longitude": "7.14816000"
                    },
                    {
                        "id": 30458,
                        "name": "Würselen",
                        "latitude": "50.81809000",
                        "longitude": "6.13470000"
                    },
                    {
                        "id": 30461,
                        "name": "Xanten",
                        "latitude": "51.65877000",
                        "longitude": "6.45297000"
                    },
                    {
                        "id": 30526,
                        "name": "Zulpich",
                        "latitude": "50.69447000",
                        "longitude": "6.65414000"
                    }
                ]
            },
            {
                "id": 3019,
                "name": "Rhineland-Palatinate",
                "iso2": "RP",
                "latitude": "50.11834600",
                "longitude": "7.30895270",
                "type": "land",
                "cities": [
                    {
                        "id": 23462,
                        "name": "Aach",
                        "latitude": "49.78333000",
                        "longitude": "6.60000000"
                    },
                    {
                        "id": 23486,
                        "name": "Adenau",
                        "latitude": "50.38238000",
                        "longitude": "6.93291000"
                    },
                    {
                        "id": 23512,
                        "name": "Ahrbrück",
                        "latitude": "50.48225000",
                        "longitude": "6.98804000"
                    },
                    {
                        "id": 23535,
                        "name": "Albersweiler",
                        "latitude": "49.21917000",
                        "longitude": "8.03000000"
                    },
                    {
                        "id": 23538,
                        "name": "Albig",
                        "latitude": "49.77361000",
                        "longitude": "8.12139000"
                    },
                    {
                        "id": 23539,
                        "name": "Albisheim",
                        "latitude": "49.64941000",
                        "longitude": "8.09442000"
                    },
                    {
                        "id": 23565,
                        "name": "Alpenrod",
                        "latitude": "50.63333000",
                        "longitude": "7.86667000"
                    },
                    {
                        "id": 23569,
                        "name": "Alsdorf",
                        "latitude": "50.77736000",
                        "longitude": "7.88562000"
                    },
                    {
                        "id": 23570,
                        "name": "Alsenz",
                        "latitude": "49.71667000",
                        "longitude": "7.81667000"
                    },
                    {
                        "id": 23572,
                        "name": "Alsheim",
                        "latitude": "49.76806000",
                        "longitude": "8.34028000"
                    },
                    {
                        "id": 23590,
                        "name": "Altenahr",
                        "latitude": "50.51694000",
                        "longitude": "6.99206000"
                    },
                    {
                        "id": 23598,
                        "name": "Altendiez",
                        "latitude": "50.36667000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 23601,
                        "name": "Altenglan",
                        "latitude": "49.55000000",
                        "longitude": "7.46667000"
                    },
                    {
                        "id": 23605,
                        "name": "Altenkirchen",
                        "latitude": "50.68594000",
                        "longitude": "7.64176000"
                    },
                    {
                        "id": 23627,
                        "name": "Altleiningen",
                        "latitude": "49.50750000",
                        "longitude": "8.07333000"
                    },
                    {
                        "id": 23632,
                        "name": "Altrich",
                        "latitude": "49.95701000",
                        "longitude": "6.91217000"
                    },
                    {
                        "id": 23633,
                        "name": "Altrip",
                        "latitude": "49.43556000",
                        "longitude": "8.49472000"
                    },
                    {
                        "id": 23642,
                        "name": "Alzey",
                        "latitude": "49.74657000",
                        "longitude": "8.11513000"
                    },
                    {
                        "id": 23654,
                        "name": "Andernach",
                        "latitude": "50.43109000",
                        "longitude": "7.40425000"
                    },
                    {
                        "id": 23658,
                        "name": "Anhausen",
                        "latitude": "50.50000000",
                        "longitude": "7.55000000"
                    },
                    {
                        "id": 23663,
                        "name": "Annweiler am Trifels",
                        "latitude": "49.20613000",
                        "longitude": "7.97527000"
                    },
                    {
                        "id": 23678,
                        "name": "Appenheim",
                        "latitude": "49.93000000",
                        "longitude": "8.03333000"
                    },
                    {
                        "id": 23682,
                        "name": "Argenthal",
                        "latitude": "49.96667000",
                        "longitude": "7.60000000"
                    },
                    {
                        "id": 23683,
                        "name": "Armsheim",
                        "latitude": "49.80972000",
                        "longitude": "8.05667000"
                    },
                    {
                        "id": 23695,
                        "name": "Arzbach",
                        "latitude": "50.37902000",
                        "longitude": "7.74948000"
                    },
                    {
                        "id": 23698,
                        "name": "Arzfeld",
                        "latitude": "50.08957000",
                        "longitude": "6.27069000"
                    },
                    {
                        "id": 23699,
                        "name": "Asbach",
                        "latitude": "50.66667000",
                        "longitude": "7.41667000"
                    },
                    {
                        "id": 23746,
                        "name": "Ayl",
                        "latitude": "49.63333000",
                        "longitude": "6.55000000"
                    },
                    {
                        "id": 23756,
                        "name": "Bacharach",
                        "latitude": "50.05725000",
                        "longitude": "7.76948000"
                    },
                    {
                        "id": 23766,
                        "name": "Bad Bergzabern",
                        "latitude": "49.10245000",
                        "longitude": "8.00092000"
                    },
                    {
                        "id": 23777,
                        "name": "Bad Breisig",
                        "latitude": "50.50523000",
                        "longitude": "7.28861000"
                    },
                    {
                        "id": 23785,
                        "name": "Bad Dürkheim",
                        "latitude": "49.46180000",
                        "longitude": "8.17236000"
                    },
                    {
                        "id": 23790,
                        "name": "Bad Ems",
                        "latitude": "50.33544000",
                        "longitude": "7.71369000"
                    },
                    {
                        "id": 23810,
                        "name": "Bad Hönningen",
                        "latitude": "50.51689000",
                        "longitude": "7.31195000"
                    },
                    {
                        "id": 23817,
                        "name": "Bad Kreuznach",
                        "latitude": "49.84140000",
                        "longitude": "7.86713000"
                    },
                    {
                        "id": 23833,
                        "name": "Bad Marienberg",
                        "latitude": "50.64947000",
                        "longitude": "7.94958000"
                    },
                    {
                        "id": 23838,
                        "name": "Bad Münster am Stein-Ebernburg",
                        "latitude": "49.81159000",
                        "longitude": "7.84523000"
                    },
                    {
                        "id": 23842,
                        "name": "Bad Neuenahr-Ahrweiler",
                        "latitude": "50.54322000",
                        "longitude": "7.11130000"
                    },
                    {
                        "id": 23894,
                        "name": "Badem",
                        "latitude": "50.00000000",
                        "longitude": "6.61667000"
                    },
                    {
                        "id": 23920,
                        "name": "Bann",
                        "latitude": "49.38333000",
                        "longitude": "7.61667000"
                    },
                    {
                        "id": 23952,
                        "name": "Bassenheim",
                        "latitude": "50.35820000",
                        "longitude": "7.45961000"
                    },
                    {
                        "id": 23958,
                        "name": "Baumholder",
                        "latitude": "49.61738000",
                        "longitude": "7.33381000"
                    },
                    {
                        "id": 23962,
                        "name": "Bausendorf",
                        "latitude": "50.01667000",
                        "longitude": "7.00000000"
                    },
                    {
                        "id": 23972,
                        "name": "Bechhofen",
                        "latitude": "49.35000000",
                        "longitude": "7.40000000"
                    },
                    {
                        "id": 23973,
                        "name": "Bechtheim",
                        "latitude": "49.72778000",
                        "longitude": "8.29222000"
                    },
                    {
                        "id": 23974,
                        "name": "Bechtolsheim",
                        "latitude": "49.80417000",
                        "longitude": "8.19389000"
                    },
                    {
                        "id": 23997,
                        "name": "Beindersheim",
                        "latitude": "49.56056000",
                        "longitude": "8.31944000"
                    },
                    {
                        "id": 24000,
                        "name": "Bell",
                        "latitude": "50.06139000",
                        "longitude": "7.41515000"
                    },
                    {
                        "id": 24003,
                        "name": "Bellheim",
                        "latitude": "49.19833000",
                        "longitude": "8.27944000"
                    },
                    {
                        "id": 24005,
                        "name": "Beltheim",
                        "latitude": "50.10606000",
                        "longitude": "7.46208000"
                    },
                    {
                        "id": 24008,
                        "name": "Bendorf",
                        "latitude": "50.42289000",
                        "longitude": "7.57924000"
                    },
                    {
                        "id": 24026,
                        "name": "Berg",
                        "latitude": "48.98403000",
                        "longitude": "8.20232000"
                    },
                    {
                        "id": 24067,
                        "name": "Bernkastel-Kues",
                        "latitude": "49.91602000",
                        "longitude": "7.07664000"
                    },
                    {
                        "id": 24082,
                        "name": "Bettingen",
                        "latitude": "49.94211000",
                        "longitude": "6.40160000"
                    },
                    {
                        "id": 24083,
                        "name": "Betzdorf",
                        "latitude": "50.79094000",
                        "longitude": "7.87189000"
                    },
                    {
                        "id": 24119,
                        "name": "Billigheim-Ingenheim",
                        "latitude": "49.13667000",
                        "longitude": "8.09056000"
                    },
                    {
                        "id": 24124,
                        "name": "Bingen am Rhein",
                        "latitude": "49.96675000",
                        "longitude": "7.89920000"
                    },
                    {
                        "id": 24126,
                        "name": "Binsfeld",
                        "latitude": "49.96667000",
                        "longitude": "6.71667000"
                    },
                    {
                        "id": 24132,
                        "name": "Birken-Honigsessen",
                        "latitude": "50.81667000",
                        "longitude": "7.73333000"
                    },
                    {
                        "id": 24135,
                        "name": "Birkenfeld",
                        "latitude": "49.65245000",
                        "longitude": "7.16668000"
                    },
                    {
                        "id": 24137,
                        "name": "Birkenheide",
                        "latitude": "49.48139000",
                        "longitude": "8.26194000"
                    },
                    {
                        "id": 24139,
                        "name": "Birlenbach",
                        "latitude": "50.35815000",
                        "longitude": "8.00273000"
                    },
                    {
                        "id": 24140,
                        "name": "Birresborn",
                        "latitude": "50.18333000",
                        "longitude": "6.63333000"
                    },
                    {
                        "id": 24159,
                        "name": "Bitburg",
                        "latitude": "49.96794000",
                        "longitude": "6.52734000"
                    },
                    {
                        "id": 24171,
                        "name": "Blankenrath",
                        "latitude": "50.03898000",
                        "longitude": "7.30214000"
                    },
                    {
                        "id": 24176,
                        "name": "Bleialf",
                        "latitude": "50.23333000",
                        "longitude": "6.28333000"
                    },
                    {
                        "id": 24189,
                        "name": "Bobenheim-Roxheim",
                        "latitude": "49.58750000",
                        "longitude": "8.35778000"
                    },
                    {
                        "id": 24197,
                        "name": "Bockenau",
                        "latitude": "49.83333000",
                        "longitude": "7.68333000"
                    },
                    {
                        "id": 24199,
                        "name": "Bockenheim",
                        "latitude": "49.60669000",
                        "longitude": "8.18486000"
                    },
                    {
                        "id": 24205,
                        "name": "Bodenheim",
                        "latitude": "49.93528000",
                        "longitude": "8.32000000"
                    },
                    {
                        "id": 24465,
                        "name": "Böhl-Iggelheim",
                        "latitude": "49.38056000",
                        "longitude": "8.30389000"
                    },
                    {
                        "id": 24221,
                        "name": "Bolanden",
                        "latitude": "49.63917000",
                        "longitude": "8.01194000"
                    },
                    {
                        "id": 24224,
                        "name": "Bollendorf",
                        "latitude": "49.85268000",
                        "longitude": "6.35795000"
                    },
                    {
                        "id": 24230,
                        "name": "Bonefeld",
                        "latitude": "50.52388000",
                        "longitude": "7.48932000"
                    },
                    {
                        "id": 24237,
                        "name": "Boppard",
                        "latitude": "50.23085000",
                        "longitude": "7.58992000"
                    },
                    {
                        "id": 24252,
                        "name": "Bornheim",
                        "latitude": "49.22250000",
                        "longitude": "8.16333000"
                    },
                    {
                        "id": 24255,
                        "name": "Bornich",
                        "latitude": "50.12687000",
                        "longitude": "7.76580000"
                    },
                    {
                        "id": 24269,
                        "name": "Brachbach",
                        "latitude": "50.81667000",
                        "longitude": "7.93333000"
                    },
                    {
                        "id": 24285,
                        "name": "Braubach",
                        "latitude": "50.27360000",
                        "longitude": "7.64508000"
                    },
                    {
                        "id": 24286,
                        "name": "Brauneberg",
                        "latitude": "49.90583000",
                        "longitude": "6.98127000"
                    },
                    {
                        "id": 24316,
                        "name": "Breitscheidt",
                        "latitude": "50.75000000",
                        "longitude": "7.65000000"
                    },
                    {
                        "id": 24326,
                        "name": "Bretzenheim",
                        "latitude": "49.87796000",
                        "longitude": "7.89653000"
                    },
                    {
                        "id": 24329,
                        "name": "Brey",
                        "latitude": "50.27253000",
                        "longitude": "7.62645000"
                    },
                    {
                        "id": 24330,
                        "name": "Briedel",
                        "latitude": "50.01667000",
                        "longitude": "7.15000000"
                    },
                    {
                        "id": 24342,
                        "name": "Brohl-Lützing",
                        "latitude": "50.48296000",
                        "longitude": "7.32908000"
                    },
                    {
                        "id": 24350,
                        "name": "Bruchmühlbach-Miesau",
                        "latitude": "49.38333000",
                        "longitude": "7.43333000"
                    },
                    {
                        "id": 24352,
                        "name": "Bruchweiler-Bärenbach",
                        "latitude": "49.11667000",
                        "longitude": "7.80000000"
                    },
                    {
                        "id": 24366,
                        "name": "Brücken",
                        "latitude": "49.43174000",
                        "longitude": "7.35998000"
                    },
                    {
                        "id": 24363,
                        "name": "Bruttig-Fankel",
                        "latitude": "50.13333000",
                        "longitude": "7.23333000"
                    },
                    {
                        "id": 24485,
                        "name": "Büchel",
                        "latitude": "50.17289000",
                        "longitude": "7.08318000"
                    },
                    {
                        "id": 24488,
                        "name": "Büchenbeuren",
                        "latitude": "49.92097000",
                        "longitude": "7.27999000"
                    },
                    {
                        "id": 24398,
                        "name": "Budenheim",
                        "latitude": "50.01667000",
                        "longitude": "8.16667000"
                    },
                    {
                        "id": 24401,
                        "name": "Bullay",
                        "latitude": "50.05448000",
                        "longitude": "7.13730000"
                    },
                    {
                        "id": 24403,
                        "name": "Bundenbach",
                        "latitude": "49.84280000",
                        "longitude": "7.37826000"
                    },
                    {
                        "id": 24404,
                        "name": "Bundenthal",
                        "latitude": "49.09549000",
                        "longitude": "7.80839000"
                    },
                    {
                        "id": 24414,
                        "name": "Burgbrohl",
                        "latitude": "50.45463000",
                        "longitude": "7.27720000"
                    },
                    {
                        "id": 24431,
                        "name": "Burgschwalbach",
                        "latitude": "50.28333000",
                        "longitude": "8.08333000"
                    },
                    {
                        "id": 24448,
                        "name": "Busenberg",
                        "latitude": "49.13024000",
                        "longitude": "7.82930000"
                    },
                    {
                        "id": 24523,
                        "name": "Carlsberg",
                        "latitude": "49.50389000",
                        "longitude": "8.04167000"
                    },
                    {
                        "id": 24537,
                        "name": "Clausen",
                        "latitude": "49.26075000",
                        "longitude": "7.67730000"
                    },
                    {
                        "id": 24545,
                        "name": "Cochem",
                        "latitude": "50.14511000",
                        "longitude": "7.16379000"
                    },
                    {
                        "id": 24551,
                        "name": "Contwig",
                        "latitude": "49.25000000",
                        "longitude": "7.43333000"
                    },
                    {
                        "id": 24572,
                        "name": "Daaden",
                        "latitude": "50.73333000",
                        "longitude": "7.96667000"
                    },
                    {
                        "id": 24575,
                        "name": "Dachsenhausen",
                        "latitude": "50.25415000",
                        "longitude": "7.72725000"
                    },
                    {
                        "id": 24584,
                        "name": "Dahn",
                        "latitude": "49.15098000",
                        "longitude": "7.77843000"
                    },
                    {
                        "id": 24586,
                        "name": "Dalheim",
                        "latitude": "49.82667000",
                        "longitude": "8.29528000"
                    },
                    {
                        "id": 24594,
                        "name": "Dannstadt-Schauernheim",
                        "latitude": "49.44028000",
                        "longitude": "8.30861000"
                    },
                    {
                        "id": 24603,
                        "name": "Dattenberg",
                        "latitude": "50.55362000",
                        "longitude": "7.29393000"
                    },
                    {
                        "id": 24605,
                        "name": "Daun",
                        "latitude": "50.19716000",
                        "longitude": "6.82942000"
                    },
                    {
                        "id": 24606,
                        "name": "Dausenau",
                        "latitude": "50.33333000",
                        "longitude": "7.76667000"
                    },
                    {
                        "id": 24613,
                        "name": "Deidesheim",
                        "latitude": "49.40782000",
                        "longitude": "8.18445000"
                    },
                    {
                        "id": 24624,
                        "name": "Dellfeld",
                        "latitude": "49.23397000",
                        "longitude": "7.47399000"
                    },
                    {
                        "id": 24638,
                        "name": "Dernau",
                        "latitude": "50.53333000",
                        "longitude": "7.05000000"
                    },
                    {
                        "id": 24639,
                        "name": "Dernbach",
                        "latitude": "50.45551000",
                        "longitude": "7.79003000"
                    },
                    {
                        "id": 24640,
                        "name": "Derschen",
                        "latitude": "50.71667000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 24661,
                        "name": "Dexheim",
                        "latitude": "49.84722000",
                        "longitude": "8.31667000"
                    },
                    {
                        "id": 24664,
                        "name": "Dieblich",
                        "latitude": "50.31396000",
                        "longitude": "7.47185000"
                    },
                    {
                        "id": 24669,
                        "name": "Dienheim",
                        "latitude": "49.83722000",
                        "longitude": "8.34972000"
                    },
                    {
                        "id": 24671,
                        "name": "Dierdorf",
                        "latitude": "50.54647000",
                        "longitude": "7.65271000"
                    },
                    {
                        "id": 24687,
                        "name": "Diez",
                        "latitude": "50.37419000",
                        "longitude": "8.00735000"
                    },
                    {
                        "id": 24703,
                        "name": "Dirmstein",
                        "latitude": "49.56333000",
                        "longitude": "8.24472000"
                    },
                    {
                        "id": 24708,
                        "name": "Dittelsheim-Heßloch",
                        "latitude": "49.74389000",
                        "longitude": "8.23694000"
                    },
                    {
                        "id": 24726,
                        "name": "Dommershausen",
                        "latitude": "50.15000000",
                        "longitude": "7.40000000"
                    },
                    {
                        "id": 24801,
                        "name": "Dörrenbach",
                        "latitude": "49.08972000",
                        "longitude": "7.96140000"
                    },
                    {
                        "id": 24762,
                        "name": "Dreikirchen",
                        "latitude": "50.43333000",
                        "longitude": "7.95000000"
                    },
                    {
                        "id": 24763,
                        "name": "Dreis",
                        "latitude": "49.94090000",
                        "longitude": "6.81845000"
                    },
                    {
                        "id": 24764,
                        "name": "Dreisen",
                        "latitude": "49.60333000",
                        "longitude": "8.01056000"
                    },
                    {
                        "id": 24775,
                        "name": "Dudeldorf",
                        "latitude": "49.97494000",
                        "longitude": "6.63724000"
                    },
                    {
                        "id": 24776,
                        "name": "Dudenhofen",
                        "latitude": "49.31861000",
                        "longitude": "8.38861000"
                    },
                    {
                        "id": 24807,
                        "name": "Düngenheim",
                        "latitude": "50.26062000",
                        "longitude": "7.16523000"
                    },
                    {
                        "id": 24831,
                        "name": "Ebernhahn",
                        "latitude": "50.47278000",
                        "longitude": "7.77000000"
                    },
                    {
                        "id": 24840,
                        "name": "Ebertsheim",
                        "latitude": "49.56833000",
                        "longitude": "8.10861000"
                    },
                    {
                        "id": 24855,
                        "name": "Edenkoben",
                        "latitude": "49.28393000",
                        "longitude": "8.12714000"
                    },
                    {
                        "id": 24858,
                        "name": "Edesheim",
                        "latitude": "49.26333000",
                        "longitude": "8.13500000"
                    },
                    {
                        "id": 24860,
                        "name": "Ediger-Eller",
                        "latitude": "50.11667000",
                        "longitude": "7.15000000"
                    },
                    {
                        "id": 24890,
                        "name": "Ehlscheid",
                        "latitude": "50.51448000",
                        "longitude": "7.46655000"
                    },
                    {
                        "id": 24927,
                        "name": "Eisenberg",
                        "latitude": "49.55859000",
                        "longitude": "8.07199000"
                    },
                    {
                        "id": 24935,
                        "name": "Eitelborn",
                        "latitude": "50.37806000",
                        "longitude": "7.72333000"
                    },
                    {
                        "id": 24945,
                        "name": "Elkenroth",
                        "latitude": "50.73333000",
                        "longitude": "7.88333000"
                    },
                    {
                        "id": 24951,
                        "name": "Ellerstadt",
                        "latitude": "49.46167000",
                        "longitude": "8.25944000"
                    },
                    {
                        "id": 24961,
                        "name": "Elmstein",
                        "latitude": "49.36667000",
                        "longitude": "7.93333000"
                    },
                    {
                        "id": 24987,
                        "name": "Emmelshausen",
                        "latitude": "50.15484000",
                        "longitude": "7.55185000"
                    },
                    {
                        "id": 25008,
                        "name": "Enkenbach-Alsenborn",
                        "latitude": "49.48333000",
                        "longitude": "7.90000000"
                    },
                    {
                        "id": 25009,
                        "name": "Enkirch",
                        "latitude": "49.98434000",
                        "longitude": "7.12997000"
                    },
                    {
                        "id": 25020,
                        "name": "Eppelsheim",
                        "latitude": "49.70556000",
                        "longitude": "8.16528000"
                    },
                    {
                        "id": 25021,
                        "name": "Eppenbrunn",
                        "latitude": "49.11667000",
                        "longitude": "7.56667000"
                    },
                    {
                        "id": 25030,
                        "name": "Erbes-Büdesheim",
                        "latitude": "49.75444000",
                        "longitude": "8.03139000"
                    },
                    {
                        "id": 25039,
                        "name": "Erfweiler",
                        "latitude": "49.15712000",
                        "longitude": "7.81231000"
                    },
                    {
                        "id": 25067,
                        "name": "Erpel",
                        "latitude": "50.58333000",
                        "longitude": "7.23333000"
                    },
                    {
                        "id": 25068,
                        "name": "Erpolzheim",
                        "latitude": "49.48917000",
                        "longitude": "8.22472000"
                    },
                    {
                        "id": 25097,
                        "name": "Essenheim",
                        "latitude": "49.93056000",
                        "longitude": "8.15556000"
                    },
                    {
                        "id": 25100,
                        "name": "Essingen",
                        "latitude": "49.23583000",
                        "longitude": "8.17472000"
                    },
                    {
                        "id": 25104,
                        "name": "Esthal",
                        "latitude": "49.38333000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 25108,
                        "name": "Ettringen",
                        "latitude": "50.35000000",
                        "longitude": "7.21667000"
                    },
                    {
                        "id": 25110,
                        "name": "Etzbach",
                        "latitude": "50.77831000",
                        "longitude": "7.68800000"
                    },
                    {
                        "id": 25125,
                        "name": "Fachbach",
                        "latitude": "50.33333000",
                        "longitude": "7.68333000"
                    },
                    {
                        "id": 25130,
                        "name": "Faid",
                        "latitude": "50.14454000",
                        "longitude": "7.11951000"
                    },
                    {
                        "id": 25150,
                        "name": "Feilbingert",
                        "latitude": "49.76667000",
                        "longitude": "7.80000000"
                    },
                    {
                        "id": 25158,
                        "name": "Fell",
                        "latitude": "49.76667000",
                        "longitude": "6.78333000"
                    },
                    {
                        "id": 25179,
                        "name": "Fischbach",
                        "latitude": "49.08771000",
                        "longitude": "7.71160000"
                    },
                    {
                        "id": 25183,
                        "name": "Flacht",
                        "latitude": "50.34528000",
                        "longitude": "8.05028000"
                    },
                    {
                        "id": 25185,
                        "name": "Flammersfeld",
                        "latitude": "50.64711000",
                        "longitude": "7.52713000"
                    },
                    {
                        "id": 25194,
                        "name": "Flomborn",
                        "latitude": "49.69056000",
                        "longitude": "8.14917000"
                    },
                    {
                        "id": 25195,
                        "name": "Flonheim",
                        "latitude": "49.78500000",
                        "longitude": "8.04000000"
                    },
                    {
                        "id": 25321,
                        "name": "Föhren",
                        "latitude": "49.85929000",
                        "longitude": "6.76480000"
                    },
                    {
                        "id": 25210,
                        "name": "Framersheim",
                        "latitude": "49.75806000",
                        "longitude": "8.17417000"
                    },
                    {
                        "id": 25217,
                        "name": "Frankenstein",
                        "latitude": "49.44015000",
                        "longitude": "7.97744000"
                    },
                    {
                        "id": 25218,
                        "name": "Frankenthal",
                        "latitude": "49.53414000",
                        "longitude": "8.35357000"
                    },
                    {
                        "id": 25235,
                        "name": "Freckenfeld",
                        "latitude": "49.06500000",
                        "longitude": "8.11389000"
                    },
                    {
                        "id": 25237,
                        "name": "Frei-Laubersheim",
                        "latitude": "49.80000000",
                        "longitude": "7.90000000"
                    },
                    {
                        "id": 25248,
                        "name": "Freinsheim",
                        "latitude": "49.50649000",
                        "longitude": "8.21186000"
                    },
                    {
                        "id": 25249,
                        "name": "Freisbach",
                        "latitude": "49.27167000",
                        "longitude": "8.27194000"
                    },
                    {
                        "id": 25259,
                        "name": "Freudenburg",
                        "latitude": "49.54348000",
                        "longitude": "6.53292000"
                    },
                    {
                        "id": 25273,
                        "name": "Friedelsheim",
                        "latitude": "49.44694000",
                        "longitude": "8.22306000"
                    },
                    {
                        "id": 25280,
                        "name": "Friedewald",
                        "latitude": "50.71106000",
                        "longitude": "7.96040000"
                    },
                    {
                        "id": 25298,
                        "name": "Friesenhagen",
                        "latitude": "50.90377000",
                        "longitude": "7.80961000"
                    },
                    {
                        "id": 25325,
                        "name": "Fürfeld",
                        "latitude": "49.77737000",
                        "longitude": "7.89264000"
                    },
                    {
                        "id": 25338,
                        "name": "Fürthen",
                        "latitude": "50.78333000",
                        "longitude": "7.66667000"
                    },
                    {
                        "id": 25320,
                        "name": "Fußgönheim",
                        "latitude": "49.46111000",
                        "longitude": "8.29222000"
                    },
                    {
                        "id": 25371,
                        "name": "Gartenstadt",
                        "latitude": "49.45937000",
                        "longitude": "8.40377000"
                    },
                    {
                        "id": 25378,
                        "name": "Gau-Algesheim",
                        "latitude": "49.95669000",
                        "longitude": "8.01569000"
                    },
                    {
                        "id": 25379,
                        "name": "Gau-Bickelheim",
                        "latitude": "49.83528000",
                        "longitude": "8.02056000"
                    },
                    {
                        "id": 25380,
                        "name": "Gau-Bischofsheim",
                        "latitude": "49.91583000",
                        "longitude": "8.27278000"
                    },
                    {
                        "id": 25381,
                        "name": "Gau-Odernheim",
                        "latitude": "49.78472000",
                        "longitude": "8.19417000"
                    },
                    {
                        "id": 25385,
                        "name": "Gebhardshain",
                        "latitude": "50.75000000",
                        "longitude": "7.81667000"
                    },
                    {
                        "id": 25422,
                        "name": "Gemünden",
                        "latitude": "49.89444000",
                        "longitude": "7.47750000"
                    },
                    {
                        "id": 25427,
                        "name": "Gensingen",
                        "latitude": "49.90000000",
                        "longitude": "7.93333000"
                    },
                    {
                        "id": 25446,
                        "name": "Germersheim",
                        "latitude": "49.22306000",
                        "longitude": "8.36389000"
                    },
                    {
                        "id": 25455,
                        "name": "Gerolsheim",
                        "latitude": "49.54778000",
                        "longitude": "8.26389000"
                    },
                    {
                        "id": 25456,
                        "name": "Gerolstein",
                        "latitude": "50.22224000",
                        "longitude": "6.65984000"
                    },
                    {
                        "id": 25490,
                        "name": "Gillenfeld",
                        "latitude": "50.12790000",
                        "longitude": "6.90383000"
                    },
                    {
                        "id": 25493,
                        "name": "Gimbsheim",
                        "latitude": "49.77778000",
                        "longitude": "8.37500000"
                    },
                    {
                        "id": 25497,
                        "name": "Girod",
                        "latitude": "50.45000000",
                        "longitude": "7.91667000"
                    },
                    {
                        "id": 25501,
                        "name": "Glan-Münchweiler",
                        "latitude": "49.47222000",
                        "longitude": "7.44204000"
                    },
                    {
                        "id": 25777,
                        "name": "Göllheim",
                        "latitude": "49.59500000",
                        "longitude": "8.05083000"
                    },
                    {
                        "id": 25540,
                        "name": "Gommersheim",
                        "latitude": "49.29111000",
                        "longitude": "8.26583000"
                    },
                    {
                        "id": 25542,
                        "name": "Gondershausen",
                        "latitude": "50.15000000",
                        "longitude": "7.50000000"
                    },
                    {
                        "id": 25778,
                        "name": "Gönnheim",
                        "latitude": "49.44806000",
                        "longitude": "8.23861000"
                    },
                    {
                        "id": 25548,
                        "name": "Gossersweiler-Stein",
                        "latitude": "49.15000000",
                        "longitude": "7.93333000"
                    },
                    {
                        "id": 25594,
                        "name": "Greimerath",
                        "latitude": "49.56155000",
                        "longitude": "6.68374000"
                    },
                    {
                        "id": 25607,
                        "name": "Gries",
                        "latitude": "49.41667000",
                        "longitude": "7.40000000"
                    },
                    {
                        "id": 25613,
                        "name": "Grolsheim",
                        "latitude": "49.90834000",
                        "longitude": "7.91599000"
                    },
                    {
                        "id": 25680,
                        "name": "Großholbach",
                        "latitude": "50.45000000",
                        "longitude": "7.88333000"
                    },
                    {
                        "id": 25681,
                        "name": "Großkarlbach",
                        "latitude": "49.53833000",
                        "longitude": "8.22472000"
                    },
                    {
                        "id": 25690,
                        "name": "Großlittgen",
                        "latitude": "50.02787000",
                        "longitude": "6.79865000"
                    },
                    {
                        "id": 25691,
                        "name": "Großmaischeid",
                        "latitude": "50.50000000",
                        "longitude": "7.63333000"
                    },
                    {
                        "id": 25694,
                        "name": "Großniedesheim",
                        "latitude": "49.57528000",
                        "longitude": "8.31222000"
                    },
                    {
                        "id": 25744,
                        "name": "Grünstadt",
                        "latitude": "49.56302000",
                        "longitude": "8.16279000"
                    },
                    {
                        "id": 25791,
                        "name": "Gückingen",
                        "latitude": "50.39091000",
                        "longitude": "8.00726000"
                    },
                    {
                        "id": 25758,
                        "name": "Gundersheim",
                        "latitude": "49.69611000",
                        "longitude": "8.20250000"
                    },
                    {
                        "id": 25760,
                        "name": "Guntersblum",
                        "latitude": "49.79750000",
                        "longitude": "8.34556000"
                    },
                    {
                        "id": 25762,
                        "name": "Gusenburg",
                        "latitude": "49.63333000",
                        "longitude": "6.90000000"
                    },
                    {
                        "id": 25763,
                        "name": "Gusterath",
                        "latitude": "49.70000000",
                        "longitude": "6.71667000"
                    },
                    {
                        "id": 25766,
                        "name": "Gutenberg",
                        "latitude": "49.88333000",
                        "longitude": "7.80000000"
                    },
                    {
                        "id": 25810,
                        "name": "Hachenburg",
                        "latitude": "50.65998000",
                        "longitude": "7.82276000"
                    },
                    {
                        "id": 25811,
                        "name": "Hackenheim",
                        "latitude": "49.82524000",
                        "longitude": "7.89907000"
                    },
                    {
                        "id": 25820,
                        "name": "Hagenbach",
                        "latitude": "49.01734000",
                        "longitude": "8.25024000"
                    },
                    {
                        "id": 25826,
                        "name": "Hahnheim",
                        "latitude": "49.86083000",
                        "longitude": "8.23694000"
                    },
                    {
                        "id": 25827,
                        "name": "Hahnstätten",
                        "latitude": "50.30000000",
                        "longitude": "8.06667000"
                    },
                    {
                        "id": 25859,
                        "name": "Halsenbach",
                        "latitude": "50.17174000",
                        "longitude": "7.55673000"
                    },
                    {
                        "id": 25874,
                        "name": "Hamm",
                        "latitude": "50.76531000",
                        "longitude": "7.67761000"
                    },
                    {
                        "id": 25888,
                        "name": "Hanhofen",
                        "latitude": "49.31667000",
                        "longitude": "8.34083000"
                    },
                    {
                        "id": 25903,
                        "name": "Hargesheim",
                        "latitude": "49.86230000",
                        "longitude": "7.82881000"
                    },
                    {
                        "id": 25915,
                        "name": "Harthausen",
                        "latitude": "49.29417000",
                        "longitude": "8.34500000"
                    },
                    {
                        "id": 25918,
                        "name": "Harxheim",
                        "latitude": "49.90528000",
                        "longitude": "8.26417000"
                    },
                    {
                        "id": 25964,
                        "name": "Haßloch",
                        "latitude": "49.36278000",
                        "longitude": "8.25806000"
                    },
                    {
                        "id": 25939,
                        "name": "Hattert",
                        "latitude": "50.66667000",
                        "longitude": "7.76667000"
                    },
                    {
                        "id": 25943,
                        "name": "Hatzenbühl",
                        "latitude": "49.11111000",
                        "longitude": "8.24528000"
                    },
                    {
                        "id": 25945,
                        "name": "Hauenstein",
                        "latitude": "49.19211000",
                        "longitude": "7.85492000"
                    },
                    {
                        "id": 25948,
                        "name": "Hauptstuhl",
                        "latitude": "49.40000000",
                        "longitude": "7.48333000"
                    },
                    {
                        "id": 25951,
                        "name": "Hausen",
                        "latitude": "50.54242000",
                        "longitude": "7.40703000"
                    },
                    {
                        "id": 25988,
                        "name": "Heidesheim",
                        "latitude": "49.58247000",
                        "longitude": "8.19537000"
                    },
                    {
                        "id": 25999,
                        "name": "Heiligenroth",
                        "latitude": "50.45000000",
                        "longitude": "7.86667000"
                    },
                    {
                        "id": 26006,
                        "name": "Heimbach",
                        "latitude": "50.45000000",
                        "longitude": "7.53333000"
                    },
                    {
                        "id": 26018,
                        "name": "Heistenbach",
                        "latitude": "50.37933000",
                        "longitude": "7.98629000"
                    },
                    {
                        "id": 26022,
                        "name": "Helferskirchen",
                        "latitude": "50.51028000",
                        "longitude": "7.81184000"
                    },
                    {
                        "id": 26024,
                        "name": "Hellenhahn-Schellenberg",
                        "latitude": "50.61278000",
                        "longitude": "8.02639000"
                    },
                    {
                        "id": 26035,
                        "name": "Heltersberg",
                        "latitude": "49.31667000",
                        "longitude": "7.71667000"
                    },
                    {
                        "id": 26053,
                        "name": "Hennweiler",
                        "latitude": "49.81667000",
                        "longitude": "7.43333000"
                    },
                    {
                        "id": 26064,
                        "name": "Herdorf",
                        "latitude": "50.77704000",
                        "longitude": "7.95366000"
                    },
                    {
                        "id": 26068,
                        "name": "Herforst",
                        "latitude": "49.95000000",
                        "longitude": "6.70000000"
                    },
                    {
                        "id": 26077,
                        "name": "Hermersberg",
                        "latitude": "49.31667000",
                        "longitude": "7.63333000"
                    },
                    {
                        "id": 26078,
                        "name": "Hermeskeil",
                        "latitude": "49.65528000",
                        "longitude": "6.94407000"
                    },
                    {
                        "id": 26095,
                        "name": "Herschweiler-Pettersheim",
                        "latitude": "49.48333000",
                        "longitude": "7.35000000"
                    },
                    {
                        "id": 26097,
                        "name": "Herxheim am Berg",
                        "latitude": "49.50917000",
                        "longitude": "8.17917000"
                    },
                    {
                        "id": 26129,
                        "name": "Heßheim",
                        "latitude": "49.54583000",
                        "longitude": "8.30778000"
                    },
                    {
                        "id": 26110,
                        "name": "Hettenleidelheim",
                        "latitude": "49.53556000",
                        "longitude": "8.07361000"
                    },
                    {
                        "id": 26115,
                        "name": "Hetzerath",
                        "latitude": "49.88333000",
                        "longitude": "6.81667000"
                    },
                    {
                        "id": 26119,
                        "name": "Heuchelheim bei Frankenthal",
                        "latitude": "49.56306000",
                        "longitude": "8.29083000"
                    },
                    {
                        "id": 26140,
                        "name": "Hilgert",
                        "latitude": "50.45634000",
                        "longitude": "7.68735000"
                    },
                    {
                        "id": 26144,
                        "name": "Hillesheim",
                        "latitude": "50.29177000",
                        "longitude": "6.66963000"
                    },
                    {
                        "id": 26145,
                        "name": "Hillscheid",
                        "latitude": "50.40639000",
                        "longitude": "7.69861000"
                    },
                    {
                        "id": 26157,
                        "name": "Hinterweidenthal",
                        "latitude": "49.20000000",
                        "longitude": "7.75000000"
                    },
                    {
                        "id": 26174,
                        "name": "Hochdorf-Assenheim",
                        "latitude": "49.41944000",
                        "longitude": "8.28167000"
                    },
                    {
                        "id": 26178,
                        "name": "Hochspeyer",
                        "latitude": "49.44207000",
                        "longitude": "7.89504000"
                    },
                    {
                        "id": 26179,
                        "name": "Hochstadt",
                        "latitude": "49.24750000",
                        "longitude": "8.20889000"
                    },
                    {
                        "id": 26181,
                        "name": "Hochstetten-Dhaun",
                        "latitude": "49.80000000",
                        "longitude": "7.50000000"
                    },
                    {
                        "id": 26184,
                        "name": "Hof",
                        "latitude": "50.66667000",
                        "longitude": "8.01667000"
                    },
                    {
                        "id": 26307,
                        "name": "Höheinöd",
                        "latitude": "49.28966000",
                        "longitude": "7.60673000"
                    },
                    {
                        "id": 26308,
                        "name": "Höheischweiler",
                        "latitude": "49.23333000",
                        "longitude": "7.55000000"
                    },
                    {
                        "id": 26311,
                        "name": "Höhn",
                        "latitude": "50.61667000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 26313,
                        "name": "Höhr-Grenzhausen",
                        "latitude": "50.43474000",
                        "longitude": "7.66903000"
                    },
                    {
                        "id": 26233,
                        "name": "Holler",
                        "latitude": "50.41667000",
                        "longitude": "7.83333000"
                    },
                    {
                        "id": 26240,
                        "name": "Holzappel",
                        "latitude": "50.35000000",
                        "longitude": "7.90000000"
                    },
                    {
                        "id": 26244,
                        "name": "Holzhausen an der Haide",
                        "latitude": "50.21855000",
                        "longitude": "7.90973000"
                    },
                    {
                        "id": 26255,
                        "name": "Hoppstädten-Weiersbach",
                        "latitude": "49.61667000",
                        "longitude": "7.20000000"
                    },
                    {
                        "id": 26317,
                        "name": "Hördt",
                        "latitude": "49.16583000",
                        "longitude": "8.32639000"
                    },
                    {
                        "id": 26261,
                        "name": "Horhausen",
                        "latitude": "50.58745000",
                        "longitude": "7.53028000"
                    },
                    {
                        "id": 26265,
                        "name": "Hornbach",
                        "latitude": "49.18778000",
                        "longitude": "7.36883000"
                    },
                    {
                        "id": 26330,
                        "name": "Hüffelsheim",
                        "latitude": "49.81667000",
                        "longitude": "7.80000000"
                    },
                    {
                        "id": 26288,
                        "name": "Hundsangen",
                        "latitude": "50.45000000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 26342,
                        "name": "Hütschenhausen",
                        "latitude": "49.41667000",
                        "longitude": "7.48333000"
                    },
                    {
                        "id": 26350,
                        "name": "Idar-Oberstein",
                        "latitude": "49.71443000",
                        "longitude": "7.30776000"
                    },
                    {
                        "id": 26355,
                        "name": "Igel",
                        "latitude": "49.71033000",
                        "longitude": "6.55498000"
                    },
                    {
                        "id": 26364,
                        "name": "Ilbesheim",
                        "latitude": "49.18277000",
                        "longitude": "8.05363000"
                    },
                    {
                        "id": 26385,
                        "name": "Imsbach",
                        "latitude": "49.58333000",
                        "longitude": "7.88333000"
                    },
                    {
                        "id": 26389,
                        "name": "Ingelheim am Rhein",
                        "latitude": "49.97078000",
                        "longitude": "8.05883000"
                    },
                    {
                        "id": 26396,
                        "name": "Insheim",
                        "latitude": "49.15806000",
                        "longitude": "8.14722000"
                    },
                    {
                        "id": 26406,
                        "name": "Irrel",
                        "latitude": "49.84539000",
                        "longitude": "6.45705000"
                    },
                    {
                        "id": 26407,
                        "name": "Irsch",
                        "latitude": "49.72620000",
                        "longitude": "6.69806000"
                    },
                    {
                        "id": 26453,
                        "name": "Jockgrim",
                        "latitude": "49.09288000",
                        "longitude": "8.27468000"
                    },
                    {
                        "id": 26460,
                        "name": "Jugenheim",
                        "latitude": "49.89362000",
                        "longitude": "8.08468000"
                    },
                    {
                        "id": 26474,
                        "name": "Jünkerath",
                        "latitude": "50.34412000",
                        "longitude": "6.58138000"
                    },
                    {
                        "id": 26478,
                        "name": "Kadenbach",
                        "latitude": "50.38333000",
                        "longitude": "7.73333000"
                    },
                    {
                        "id": 26482,
                        "name": "Kaisersesch",
                        "latitude": "50.23148000",
                        "longitude": "7.13864000"
                    },
                    {
                        "id": 26483,
                        "name": "Kaiserslautern",
                        "latitude": "49.44300000",
                        "longitude": "7.77161000"
                    },
                    {
                        "id": 26494,
                        "name": "Kallstadt",
                        "latitude": "49.49083000",
                        "longitude": "8.17611000"
                    },
                    {
                        "id": 26495,
                        "name": "Kaltenengers",
                        "latitude": "50.41667000",
                        "longitude": "7.55000000"
                    },
                    {
                        "id": 26502,
                        "name": "Kamp-Bornhofen",
                        "latitude": "50.22282000",
                        "longitude": "7.62364000"
                    },
                    {
                        "id": 26505,
                        "name": "Kandel",
                        "latitude": "49.08277000",
                        "longitude": "8.19720000"
                    },
                    {
                        "id": 26511,
                        "name": "Kapsweyer",
                        "latitude": "49.04389000",
                        "longitude": "8.02167000"
                    },
                    {
                        "id": 26527,
                        "name": "Kasbach-Ohlenberg",
                        "latitude": "50.58333000",
                        "longitude": "7.26667000"
                    },
                    {
                        "id": 26528,
                        "name": "Kasel",
                        "latitude": "49.76170000",
                        "longitude": "6.73222000"
                    },
                    {
                        "id": 26532,
                        "name": "Kastellaun",
                        "latitude": "50.06922000",
                        "longitude": "7.44154000"
                    },
                    {
                        "id": 26537,
                        "name": "Katzenelnbogen",
                        "latitude": "50.26745000",
                        "longitude": "7.97322000"
                    },
                    {
                        "id": 26539,
                        "name": "Katzweiler",
                        "latitude": "49.50000000",
                        "longitude": "7.70000000"
                    },
                    {
                        "id": 26540,
                        "name": "Katzwinkel",
                        "latitude": "50.81470000",
                        "longitude": "7.82236000"
                    },
                    {
                        "id": 26541,
                        "name": "Kaub",
                        "latitude": "50.08831000",
                        "longitude": "7.76069000"
                    },
                    {
                        "id": 26552,
                        "name": "Kehrig",
                        "latitude": "50.28333000",
                        "longitude": "7.21667000"
                    },
                    {
                        "id": 26554,
                        "name": "Kelberg",
                        "latitude": "50.29164000",
                        "longitude": "6.91950000"
                    },
                    {
                        "id": 26558,
                        "name": "Kell",
                        "latitude": "49.63425000",
                        "longitude": "6.82390000"
                    },
                    {
                        "id": 26568,
                        "name": "Kempenich",
                        "latitude": "50.42024000",
                        "longitude": "7.11698000"
                    },
                    {
                        "id": 26570,
                        "name": "Kenn",
                        "latitude": "49.80000000",
                        "longitude": "6.71667000"
                    },
                    {
                        "id": 26573,
                        "name": "Kerzenheim",
                        "latitude": "49.57639000",
                        "longitude": "8.05972000"
                    },
                    {
                        "id": 26578,
                        "name": "Kettig",
                        "latitude": "50.40000000",
                        "longitude": "7.46667000"
                    },
                    {
                        "id": 26589,
                        "name": "Kindenheim",
                        "latitude": "49.61111000",
                        "longitude": "8.16417000"
                    },
                    {
                        "id": 26590,
                        "name": "Kinderbeuern",
                        "latitude": "50.00935000",
                        "longitude": "7.02355000"
                    },
                    {
                        "id": 26591,
                        "name": "Kindsbach",
                        "latitude": "49.41667000",
                        "longitude": "7.61667000"
                    },
                    {
                        "id": 26596,
                        "name": "Kirchberg",
                        "latitude": "49.94395000",
                        "longitude": "7.40700000"
                    },
                    {
                        "id": 26608,
                        "name": "Kirchen",
                        "latitude": "50.80849000",
                        "longitude": "7.88634000"
                    },
                    {
                        "id": 26623,
                        "name": "Kirchheim an der Weinstraße",
                        "latitude": "49.53722000",
                        "longitude": "8.18083000"
                    },
                    {
                        "id": 26626,
                        "name": "Kirchheimbolanden",
                        "latitude": "49.66249000",
                        "longitude": "8.01513000"
                    },
                    {
                        "id": 26635,
                        "name": "Kirchwald",
                        "latitude": "50.36667000",
                        "longitude": "7.15000000"
                    },
                    {
                        "id": 26642,
                        "name": "Kirn",
                        "latitude": "49.78912000",
                        "longitude": "7.45765000"
                    },
                    {
                        "id": 26643,
                        "name": "Kirrweiler",
                        "latitude": "49.30124000",
                        "longitude": "8.16288000"
                    },
                    {
                        "id": 26645,
                        "name": "Kirschweiler",
                        "latitude": "49.75000000",
                        "longitude": "7.25000000"
                    },
                    {
                        "id": 26657,
                        "name": "Klausen",
                        "latitude": "49.90000000",
                        "longitude": "6.88333000"
                    },
                    {
                        "id": 26667,
                        "name": "Klein-Winternheim",
                        "latitude": "49.93833000",
                        "longitude": "8.21194000"
                    },
                    {
                        "id": 26676,
                        "name": "Kleinmaischeid",
                        "latitude": "50.51345000",
                        "longitude": "7.60830000"
                    },
                    {
                        "id": 26687,
                        "name": "Klingenmünster",
                        "latitude": "49.14056000",
                        "longitude": "8.01861000"
                    },
                    {
                        "id": 26696,
                        "name": "Klotten",
                        "latitude": "50.16667000",
                        "longitude": "7.20000000"
                    },
                    {
                        "id": 26699,
                        "name": "Klüsserath",
                        "latitude": "49.84500000",
                        "longitude": "6.85086000"
                    },
                    {
                        "id": 26702,
                        "name": "Knittelsheim",
                        "latitude": "49.19167000",
                        "longitude": "8.25139000"
                    },
                    {
                        "id": 26704,
                        "name": "Kobern-Gondorf",
                        "latitude": "50.30230000",
                        "longitude": "7.45612000"
                    },
                    {
                        "id": 26705,
                        "name": "Koblenz",
                        "latitude": "50.35357000",
                        "longitude": "7.57883000"
                    },
                    {
                        "id": 26815,
                        "name": "Kölbingen",
                        "latitude": "50.55000000",
                        "longitude": "7.93333000"
                    },
                    {
                        "id": 26820,
                        "name": "Köngernheim",
                        "latitude": "49.84583000",
                        "longitude": "8.24667000"
                    },
                    {
                        "id": 26719,
                        "name": "Konz",
                        "latitude": "49.70045000",
                        "longitude": "6.57652000"
                    },
                    {
                        "id": 26723,
                        "name": "Kordel",
                        "latitude": "49.83333000",
                        "longitude": "6.63333000"
                    },
                    {
                        "id": 26845,
                        "name": "Körperich",
                        "latitude": "49.92449000",
                        "longitude": "6.25973000"
                    },
                    {
                        "id": 26730,
                        "name": "Kottenheim",
                        "latitude": "50.35000000",
                        "longitude": "7.25000000"
                    },
                    {
                        "id": 26732,
                        "name": "Kottweiler-Schwanden",
                        "latitude": "49.48333000",
                        "longitude": "7.53333000"
                    },
                    {
                        "id": 26759,
                        "name": "Krickenbach",
                        "latitude": "49.36667000",
                        "longitude": "7.66667000"
                    },
                    {
                        "id": 26762,
                        "name": "Kriegsfeld",
                        "latitude": "49.70992000",
                        "longitude": "7.91687000"
                    },
                    {
                        "id": 26786,
                        "name": "Kröv",
                        "latitude": "49.98333000",
                        "longitude": "7.08333000"
                    },
                    {
                        "id": 26777,
                        "name": "Kruft",
                        "latitude": "50.38333000",
                        "longitude": "7.33333000"
                    },
                    {
                        "id": 26792,
                        "name": "Kuhardt",
                        "latitude": "49.14583000",
                        "longitude": "8.31444000"
                    },
                    {
                        "id": 26805,
                        "name": "Kusel",
                        "latitude": "49.53772000",
                        "longitude": "7.40472000"
                    },
                    {
                        "id": 26810,
                        "name": "Kyllburg",
                        "latitude": "50.03864000",
                        "longitude": "6.59478000"
                    },
                    {
                        "id": 26868,
                        "name": "Lachen-Speyerdorf",
                        "latitude": "49.33049000",
                        "longitude": "8.19983000"
                    },
                    {
                        "id": 26875,
                        "name": "Lahnstein",
                        "latitude": "50.30000000",
                        "longitude": "7.61667000"
                    },
                    {
                        "id": 26881,
                        "name": "Lambrecht",
                        "latitude": "49.37055000",
                        "longitude": "8.07264000"
                    },
                    {
                        "id": 26883,
                        "name": "Lambsheim",
                        "latitude": "49.51361000",
                        "longitude": "8.28778000"
                    },
                    {
                        "id": 26890,
                        "name": "Landau in der Pfalz",
                        "latitude": "49.19844000",
                        "longitude": "8.11692000"
                    },
                    {
                        "id": 26896,
                        "name": "Landscheid",
                        "latitude": "49.98333000",
                        "longitude": "6.76667000"
                    },
                    {
                        "id": 26898,
                        "name": "Landstuhl",
                        "latitude": "49.41306000",
                        "longitude": "7.57021000"
                    },
                    {
                        "id": 26908,
                        "name": "Langenbach bei Marienberg",
                        "latitude": "50.63806000",
                        "longitude": "7.94787000"
                    },
                    {
                        "id": 26920,
                        "name": "Langenhahn",
                        "latitude": "50.58333000",
                        "longitude": "7.91667000"
                    },
                    {
                        "id": 26923,
                        "name": "Langenlonsheim",
                        "latitude": "49.90000000",
                        "longitude": "7.90000000"
                    },
                    {
                        "id": 26942,
                        "name": "Langsur",
                        "latitude": "49.72442000",
                        "longitude": "6.49906000"
                    },
                    {
                        "id": 26956,
                        "name": "Laubach",
                        "latitude": "50.23277000",
                        "longitude": "7.07333000"
                    },
                    {
                        "id": 26986,
                        "name": "Lauterecken",
                        "latitude": "49.64993000",
                        "longitude": "7.59265000"
                    },
                    {
                        "id": 27008,
                        "name": "Lehmen",
                        "latitude": "50.28333000",
                        "longitude": "7.45000000"
                    },
                    {
                        "id": 27021,
                        "name": "Leimersheim",
                        "latitude": "49.12421000",
                        "longitude": "8.34531000"
                    },
                    {
                        "id": 27031,
                        "name": "Leiwen",
                        "latitude": "49.81667000",
                        "longitude": "6.88333000"
                    },
                    {
                        "id": 27033,
                        "name": "Lemberg",
                        "latitude": "49.17309000",
                        "longitude": "7.65111000"
                    },
                    {
                        "id": 27059,
                        "name": "Leubsdorf",
                        "latitude": "50.55000000",
                        "longitude": "7.30000000"
                    },
                    {
                        "id": 27069,
                        "name": "Leutesdorf",
                        "latitude": "50.45000000",
                        "longitude": "7.38333000"
                    },
                    {
                        "id": 27094,
                        "name": "Lieser",
                        "latitude": "49.91667000",
                        "longitude": "7.01667000"
                    },
                    {
                        "id": 27100,
                        "name": "Limburgerhof",
                        "latitude": "49.42444000",
                        "longitude": "8.39194000"
                    },
                    {
                        "id": 27106,
                        "name": "Linden",
                        "latitude": "49.35000000",
                        "longitude": "7.65000000"
                    },
                    {
                        "id": 27107,
                        "name": "Lindenberg",
                        "latitude": "49.38028000",
                        "longitude": "8.09861000"
                    },
                    {
                        "id": 27115,
                        "name": "Lingenfeld",
                        "latitude": "49.25389000",
                        "longitude": "8.33861000"
                    },
                    {
                        "id": 27119,
                        "name": "Linz am Rhein",
                        "latitude": "50.56884000",
                        "longitude": "7.28445000"
                    },
                    {
                        "id": 27121,
                        "name": "Lissendorf",
                        "latitude": "50.31667000",
                        "longitude": "6.60000000"
                    },
                    {
                        "id": 27192,
                        "name": "Löf",
                        "latitude": "50.23333000",
                        "longitude": "7.43333000"
                    },
                    {
                        "id": 27143,
                        "name": "Longkamp",
                        "latitude": "49.89044000",
                        "longitude": "7.11764000"
                    },
                    {
                        "id": 27144,
                        "name": "Longuich",
                        "latitude": "49.80841000",
                        "longitude": "6.76832000"
                    },
                    {
                        "id": 27146,
                        "name": "Lonnig",
                        "latitude": "50.31002000",
                        "longitude": "7.40509000"
                    },
                    {
                        "id": 27198,
                        "name": "Lörzweiler",
                        "latitude": "49.89833000",
                        "longitude": "8.29472000"
                    },
                    {
                        "id": 27165,
                        "name": "Ludwigshafen am Rhein",
                        "latitude": "49.48121000",
                        "longitude": "8.44641000"
                    },
                    {
                        "id": 27179,
                        "name": "Lustadt",
                        "latitude": "49.24476000",
                        "longitude": "8.27407000"
                    },
                    {
                        "id": 27181,
                        "name": "Lutzerath",
                        "latitude": "50.12695000",
                        "longitude": "7.00740000"
                    },
                    {
                        "id": 27228,
                        "name": "Mackenbach",
                        "latitude": "49.46667000",
                        "longitude": "7.58333000"
                    },
                    {
                        "id": 27236,
                        "name": "Maikammer",
                        "latitude": "49.30528000",
                        "longitude": "8.13167000"
                    },
                    {
                        "id": 27244,
                        "name": "Mainz",
                        "latitude": "49.98419000",
                        "longitude": "8.27910000"
                    },
                    {
                        "id": 27248,
                        "name": "Malborn",
                        "latitude": "49.71667000",
                        "longitude": "6.98333000"
                    },
                    {
                        "id": 27260,
                        "name": "Mammelzen",
                        "latitude": "50.70000000",
                        "longitude": "7.66667000"
                    },
                    {
                        "id": 27264,
                        "name": "Manderscheid",
                        "latitude": "50.09672000",
                        "longitude": "6.80981000"
                    },
                    {
                        "id": 27278,
                        "name": "Marienrachdorf",
                        "latitude": "50.55000000",
                        "longitude": "7.71667000"
                    },
                    {
                        "id": 27282,
                        "name": "Maring-Noviand",
                        "latitude": "49.93333000",
                        "longitude": "7.00000000"
                    },
                    {
                        "id": 27321,
                        "name": "Marnheim",
                        "latitude": "49.63278000",
                        "longitude": "8.04000000"
                    },
                    {
                        "id": 27331,
                        "name": "Martinshöhe",
                        "latitude": "49.36667000",
                        "longitude": "7.48333000"
                    },
                    {
                        "id": 27336,
                        "name": "Masburg",
                        "latitude": "50.24065000",
                        "longitude": "7.11736000"
                    },
                    {
                        "id": 27353,
                        "name": "Maßweiler",
                        "latitude": "49.26667000",
                        "longitude": "7.53333000"
                    },
                    {
                        "id": 27341,
                        "name": "Mastershausen",
                        "latitude": "50.06667000",
                        "longitude": "7.35000000"
                    },
                    {
                        "id": 27348,
                        "name": "Maxdorf",
                        "latitude": "49.48806000",
                        "longitude": "8.29167000"
                    },
                    {
                        "id": 27350,
                        "name": "Maxsain",
                        "latitude": "50.54316000",
                        "longitude": "7.78512000"
                    },
                    {
                        "id": 27351,
                        "name": "Mayen",
                        "latitude": "50.32797000",
                        "longitude": "7.22277000"
                    },
                    {
                        "id": 27357,
                        "name": "Meckenheim",
                        "latitude": "49.40444000",
                        "longitude": "8.23917000"
                    },
                    {
                        "id": 27361,
                        "name": "Meddersheim",
                        "latitude": "49.77636000",
                        "longitude": "7.61708000"
                    },
                    {
                        "id": 27370,
                        "name": "Mehlbach",
                        "latitude": "49.51667000",
                        "longitude": "7.71667000"
                    },
                    {
                        "id": 27371,
                        "name": "Mehlingen",
                        "latitude": "49.49136000",
                        "longitude": "7.85467000"
                    },
                    {
                        "id": 27374,
                        "name": "Mehren",
                        "latitude": "50.18333000",
                        "longitude": "6.88333000"
                    },
                    {
                        "id": 27376,
                        "name": "Mehring",
                        "latitude": "49.80000000",
                        "longitude": "6.83333000"
                    },
                    {
                        "id": 27384,
                        "name": "Meisenheim",
                        "latitude": "49.70721000",
                        "longitude": "7.66765000"
                    },
                    {
                        "id": 27398,
                        "name": "Melsbach",
                        "latitude": "50.48333000",
                        "longitude": "7.48333000"
                    },
                    {
                        "id": 27405,
                        "name": "Mendig",
                        "latitude": "50.36667000",
                        "longitude": "7.28333000"
                    },
                    {
                        "id": 27423,
                        "name": "Mertesdorf",
                        "latitude": "49.77212000",
                        "longitude": "6.73290000"
                    },
                    {
                        "id": 27425,
                        "name": "Mertloch",
                        "latitude": "50.26948000",
                        "longitude": "7.30814000"
                    },
                    {
                        "id": 27426,
                        "name": "Merxheim",
                        "latitude": "49.79297000",
                        "longitude": "7.56010000"
                    },
                    {
                        "id": 27427,
                        "name": "Merzalben",
                        "latitude": "49.24467000",
                        "longitude": "7.73077000"
                    },
                    {
                        "id": 27438,
                        "name": "Mettendorf",
                        "latitude": "49.94784000",
                        "longitude": "6.33003000"
                    },
                    {
                        "id": 27439,
                        "name": "Mettenheim",
                        "latitude": "49.74000000",
                        "longitude": "8.32583000"
                    },
                    {
                        "id": 27445,
                        "name": "Meudt",
                        "latitude": "50.49889000",
                        "longitude": "7.89500000"
                    },
                    {
                        "id": 27459,
                        "name": "Miehlen",
                        "latitude": "50.22574000",
                        "longitude": "7.83196000"
                    },
                    {
                        "id": 27473,
                        "name": "Minfeld",
                        "latitude": "49.07167000",
                        "longitude": "8.14528000"
                    },
                    {
                        "id": 27483,
                        "name": "Mittelhof",
                        "latitude": "50.77517000",
                        "longitude": "7.80466000"
                    },
                    {
                        "id": 27500,
                        "name": "Mogendorf",
                        "latitude": "50.49444000",
                        "longitude": "7.75972000"
                    },
                    {
                        "id": 27507,
                        "name": "Mommenheim",
                        "latitude": "49.88028000",
                        "longitude": "8.26500000"
                    },
                    {
                        "id": 27511,
                        "name": "Monsheim",
                        "latitude": "49.63722000",
                        "longitude": "8.21194000"
                    },
                    {
                        "id": 27512,
                        "name": "Montabaur",
                        "latitude": "50.43588000",
                        "longitude": "7.82320000"
                    },
                    {
                        "id": 27513,
                        "name": "Monzelfeld",
                        "latitude": "49.89237000",
                        "longitude": "7.07318000"
                    },
                    {
                        "id": 27514,
                        "name": "Monzingen",
                        "latitude": "49.79763000",
                        "longitude": "7.59284000"
                    },
                    {
                        "id": 27523,
                        "name": "Morbach",
                        "latitude": "49.80772000",
                        "longitude": "7.12714000"
                    },
                    {
                        "id": 27532,
                        "name": "Mudersbach",
                        "latitude": "50.82515000",
                        "longitude": "7.94347000"
                    },
                    {
                        "id": 27605,
                        "name": "Mülheim-Kärlich",
                        "latitude": "50.38510000",
                        "longitude": "7.49890000"
                    },
                    {
                        "id": 27615,
                        "name": "Münchweiler an der Alsenz",
                        "latitude": "49.55000000",
                        "longitude": "7.88333000"
                    },
                    {
                        "id": 27616,
                        "name": "Münchweiler an der Rodalbe",
                        "latitude": "49.21798000",
                        "longitude": "7.70295000"
                    },
                    {
                        "id": 27623,
                        "name": "Münster-Sarmsheim",
                        "latitude": "49.94341000",
                        "longitude": "7.89426000"
                    },
                    {
                        "id": 27626,
                        "name": "Münstermaifeld",
                        "latitude": "50.24638000",
                        "longitude": "7.36208000"
                    },
                    {
                        "id": 27629,
                        "name": "Müschenbach",
                        "latitude": "50.68333000",
                        "longitude": "7.78333000"
                    },
                    {
                        "id": 27550,
                        "name": "Mutterstadt",
                        "latitude": "49.44139000",
                        "longitude": "8.35611000"
                    },
                    {
                        "id": 27633,
                        "name": "Nackenheim",
                        "latitude": "49.91528000",
                        "longitude": "8.33889000"
                    },
                    {
                        "id": 27642,
                        "name": "Nanzdietschweiler",
                        "latitude": "49.45000000",
                        "longitude": "7.45000000"
                    },
                    {
                        "id": 27644,
                        "name": "Nassau",
                        "latitude": "50.31453000",
                        "longitude": "7.80025000"
                    },
                    {
                        "id": 27645,
                        "name": "Nastätten",
                        "latitude": "50.19883000",
                        "longitude": "7.85892000"
                    },
                    {
                        "id": 27653,
                        "name": "Nauort",
                        "latitude": "50.46667000",
                        "longitude": "7.63333000"
                    },
                    {
                        "id": 27654,
                        "name": "Nauroth",
                        "latitude": "50.69927000",
                        "longitude": "7.87543000"
                    },
                    {
                        "id": 27676,
                        "name": "Nentershausen",
                        "latitude": "50.41667000",
                        "longitude": "7.93333000"
                    },
                    {
                        "id": 27708,
                        "name": "Neuburg",
                        "latitude": "48.98933000",
                        "longitude": "8.24715000"
                    },
                    {
                        "id": 27730,
                        "name": "Neuerburg",
                        "latitude": "50.00102000",
                        "longitude": "6.94828000"
                    },
                    {
                        "id": 27751,
                        "name": "Neuhäusel",
                        "latitude": "50.38360000",
                        "longitude": "7.70960000"
                    },
                    {
                        "id": 27750,
                        "name": "Neuhofen",
                        "latitude": "49.42778000",
                        "longitude": "8.42472000"
                    },
                    {
                        "id": 27769,
                        "name": "Neumagen-Dhron",
                        "latitude": "49.85553000",
                        "longitude": "6.89777000"
                    },
                    {
                        "id": 27777,
                        "name": "Neunkhausen",
                        "latitude": "50.70722000",
                        "longitude": "7.90278000"
                    },
                    {
                        "id": 27784,
                        "name": "Neupotz",
                        "latitude": "49.11778000",
                        "longitude": "8.31944000"
                    },
                    {
                        "id": 27794,
                        "name": "Neustadt",
                        "latitude": "49.35009000",
                        "longitude": "8.13886000"
                    },
                    {
                        "id": 27814,
                        "name": "Neuwied",
                        "latitude": "50.43360000",
                        "longitude": "7.47057000"
                    },
                    {
                        "id": 27819,
                        "name": "Newel",
                        "latitude": "49.81240000",
                        "longitude": "6.58304000"
                    },
                    {
                        "id": 27820,
                        "name": "Nickenich",
                        "latitude": "50.41421000",
                        "longitude": "7.32728000"
                    },
                    {
                        "id": 27827,
                        "name": "Nieder-Ingelheim",
                        "latitude": "49.97756000",
                        "longitude": "8.07246000"
                    },
                    {
                        "id": 27828,
                        "name": "Nieder-Olm",
                        "latitude": "49.91166000",
                        "longitude": "8.20533000"
                    },
                    {
                        "id": 27835,
                        "name": "Niederbreitbach",
                        "latitude": "50.53051000",
                        "longitude": "7.42099000"
                    },
                    {
                        "id": 27840,
                        "name": "Niederdreisbach",
                        "latitude": "50.74955000",
                        "longitude": "7.92352000"
                    },
                    {
                        "id": 27841,
                        "name": "Niederdürenbach",
                        "latitude": "50.45000000",
                        "longitude": "7.18333000"
                    },
                    {
                        "id": 27842,
                        "name": "Niederelbert",
                        "latitude": "50.40775000",
                        "longitude": "7.80990000"
                    },
                    {
                        "id": 27843,
                        "name": "Niedererbach",
                        "latitude": "50.42610000",
                        "longitude": "7.97425000"
                    },
                    {
                        "id": 27845,
                        "name": "Niederfell",
                        "latitude": "50.28333000",
                        "longitude": "7.46667000"
                    },
                    {
                        "id": 27846,
                        "name": "Niederfischbach",
                        "latitude": "50.85000000",
                        "longitude": "7.86667000"
                    },
                    {
                        "id": 27851,
                        "name": "Niederkirchen",
                        "latitude": "49.58333000",
                        "longitude": "7.70000000"
                    },
                    {
                        "id": 27852,
                        "name": "Niederkirchen bei Deidesheim",
                        "latitude": "49.41500000",
                        "longitude": "8.21000000"
                    },
                    {
                        "id": 27858,
                        "name": "Niedermohr",
                        "latitude": "49.45899000",
                        "longitude": "7.46955000"
                    },
                    {
                        "id": 27862,
                        "name": "Niederneisen",
                        "latitude": "50.33333000",
                        "longitude": "8.05000000"
                    },
                    {
                        "id": 27882,
                        "name": "Niederwerth",
                        "latitude": "50.40000000",
                        "longitude": "7.61667000"
                    },
                    {
                        "id": 27887,
                        "name": "Niederzissen",
                        "latitude": "50.45876000",
                        "longitude": "7.21810000"
                    },
                    {
                        "id": 27897,
                        "name": "Nierstein",
                        "latitude": "49.87003000",
                        "longitude": "8.33647000"
                    },
                    {
                        "id": 27902,
                        "name": "Nister",
                        "latitude": "50.67583000",
                        "longitude": "7.83833000"
                    },
                    {
                        "id": 27903,
                        "name": "Nittel",
                        "latitude": "49.65000000",
                        "longitude": "6.45000000"
                    },
                    {
                        "id": 27929,
                        "name": "Norheim",
                        "latitude": "49.81091000",
                        "longitude": "7.81478000"
                    },
                    {
                        "id": 27948,
                        "name": "Nörtershausen",
                        "latitude": "50.21667000",
                        "longitude": "7.48333000"
                    },
                    {
                        "id": 27957,
                        "name": "Ober-Flörsheim",
                        "latitude": "49.68306000",
                        "longitude": "8.15528000"
                    },
                    {
                        "id": 27959,
                        "name": "Ober-Olm",
                        "latitude": "49.93722000",
                        "longitude": "8.18889000"
                    },
                    {
                        "id": 27961,
                        "name": "Ober-Saulheim",
                        "latitude": "49.86376000",
                        "longitude": "8.13526000"
                    },
                    {
                        "id": 27975,
                        "name": "Oberelbert",
                        "latitude": "50.39167000",
                        "longitude": "7.81722000"
                    },
                    {
                        "id": 27977,
                        "name": "Oberfell",
                        "latitude": "50.26038000",
                        "longitude": "7.44461000"
                    },
                    {
                        "id": 28000,
                        "name": "Obermoschel",
                        "latitude": "49.72797000",
                        "longitude": "7.77266000"
                    },
                    {
                        "id": 28009,
                        "name": "Obernheim-Kirchenarnbach",
                        "latitude": "49.35000000",
                        "longitude": "7.58333000"
                    },
                    {
                        "id": 28014,
                        "name": "Oberotterbach",
                        "latitude": "49.07044000",
                        "longitude": "7.96955000"
                    },
                    {
                        "id": 28054,
                        "name": "Oberwesel",
                        "latitude": "50.10777000",
                        "longitude": "7.72522000"
                    },
                    {
                        "id": 28057,
                        "name": "Oberzissen",
                        "latitude": "50.45000000",
                        "longitude": "7.20000000"
                    },
                    {
                        "id": 28061,
                        "name": "Obrigheim",
                        "latitude": "49.59161000",
                        "longitude": "8.20483000"
                    },
                    {
                        "id": 28064,
                        "name": "Ochtendung",
                        "latitude": "50.35000000",
                        "longitude": "7.38333000"
                    },
                    {
                        "id": 28066,
                        "name": "Ockenfels",
                        "latitude": "50.57610000",
                        "longitude": "7.27535000"
                    },
                    {
                        "id": 28067,
                        "name": "Ockenheim",
                        "latitude": "49.94371000",
                        "longitude": "7.97127000"
                    },
                    {
                        "id": 28071,
                        "name": "Odernheim",
                        "latitude": "49.76511000",
                        "longitude": "7.70427000"
                    },
                    {
                        "id": 28087,
                        "name": "Offenbach an der Queich",
                        "latitude": "49.19546000",
                        "longitude": "8.19779000"
                    },
                    {
                        "id": 28088,
                        "name": "Offenbach-Hundheim",
                        "latitude": "49.61729000",
                        "longitude": "7.55117000"
                    },
                    {
                        "id": 28093,
                        "name": "Offstein",
                        "latitude": "49.60611000",
                        "longitude": "8.23806000"
                    },
                    {
                        "id": 28114,
                        "name": "Olsbrücken",
                        "latitude": "49.53884000",
                        "longitude": "7.65857000"
                    },
                    {
                        "id": 28119,
                        "name": "Oppenheim",
                        "latitude": "49.85470000",
                        "longitude": "8.35974000"
                    },
                    {
                        "id": 28125,
                        "name": "Orenhofen",
                        "latitude": "49.90000000",
                        "longitude": "6.65000000"
                    },
                    {
                        "id": 28134,
                        "name": "Osann-Monzel",
                        "latitude": "49.91667000",
                        "longitude": "6.95000000"
                    },
                    {
                        "id": 28135,
                        "name": "Osburg",
                        "latitude": "49.71667000",
                        "longitude": "6.78333000"
                    },
                    {
                        "id": 28158,
                        "name": "Osterspai",
                        "latitude": "50.24453000",
                        "longitude": "7.61227000"
                    },
                    {
                        "id": 28163,
                        "name": "Osthofen",
                        "latitude": "49.70382000",
                        "longitude": "8.32419000"
                    },
                    {
                        "id": 28185,
                        "name": "Otterbach",
                        "latitude": "49.48554000",
                        "longitude": "7.73450000"
                    },
                    {
                        "id": 28186,
                        "name": "Otterberg",
                        "latitude": "49.50301000",
                        "longitude": "7.76995000"
                    },
                    {
                        "id": 28190,
                        "name": "Ottersheim",
                        "latitude": "49.19129000",
                        "longitude": "8.23176000"
                    },
                    {
                        "id": 28191,
                        "name": "Otterstadt",
                        "latitude": "49.37222000",
                        "longitude": "8.44778000"
                    },
                    {
                        "id": 30552,
                        "name": "Ötzingen",
                        "latitude": "50.50000000",
                        "longitude": "7.83333000"
                    },
                    {
                        "id": 28213,
                        "name": "Palzem",
                        "latitude": "49.56667000",
                        "longitude": "6.36667000"
                    },
                    {
                        "id": 28227,
                        "name": "Partenheim",
                        "latitude": "49.88389000",
                        "longitude": "8.08222000"
                    },
                    {
                        "id": 28247,
                        "name": "Pellingen",
                        "latitude": "49.67552000",
                        "longitude": "6.67085000"
                    },
                    {
                        "id": 28249,
                        "name": "Pelm",
                        "latitude": "50.23188000",
                        "longitude": "6.69076000"
                    },
                    {
                        "id": 28270,
                        "name": "Pfaffen-Schwabenheim",
                        "latitude": "49.85000000",
                        "longitude": "7.95000000"
                    },
                    {
                        "id": 28285,
                        "name": "Pfeffelbach",
                        "latitude": "49.53948000",
                        "longitude": "7.32768000"
                    },
                    {
                        "id": 28300,
                        "name": "Piesport",
                        "latitude": "49.88640000",
                        "longitude": "6.91649000"
                    },
                    {
                        "id": 28308,
                        "name": "Pirmasens",
                        "latitude": "49.20145000",
                        "longitude": "7.60529000"
                    },
                    {
                        "id": 28311,
                        "name": "Plaidt",
                        "latitude": "50.39260000",
                        "longitude": "7.39251000"
                    },
                    {
                        "id": 28329,
                        "name": "Pluwig",
                        "latitude": "49.68976000",
                        "longitude": "6.71239000"
                    },
                    {
                        "id": 28341,
                        "name": "Polch",
                        "latitude": "50.29973000",
                        "longitude": "7.31315000"
                    },
                    {
                        "id": 28364,
                        "name": "Pottum",
                        "latitude": "50.60000000",
                        "longitude": "8.00000000"
                    },
                    {
                        "id": 28367,
                        "name": "Pracht",
                        "latitude": "50.76031000",
                        "longitude": "7.64871000"
                    },
                    {
                        "id": 28400,
                        "name": "Prüm",
                        "latitude": "50.20785000",
                        "longitude": "6.42019000"
                    },
                    {
                        "id": 28402,
                        "name": "Puderbach",
                        "latitude": "50.60000000",
                        "longitude": "7.61667000"
                    },
                    {
                        "id": 28427,
                        "name": "Queidersbach",
                        "latitude": "49.36667000",
                        "longitude": "7.63333000"
                    },
                    {
                        "id": 28457,
                        "name": "Ralingen",
                        "latitude": "49.81667000",
                        "longitude": "6.50000000"
                    },
                    {
                        "id": 28458,
                        "name": "Ramberg",
                        "latitude": "49.26028000",
                        "longitude": "8.00833000"
                    },
                    {
                        "id": 28461,
                        "name": "Rammelsbach",
                        "latitude": "49.54170000",
                        "longitude": "7.44392000"
                    },
                    {
                        "id": 28465,
                        "name": "Ramsen",
                        "latitude": "49.53694000",
                        "longitude": "8.01333000"
                    },
                    {
                        "id": 28467,
                        "name": "Ramstein-Miesenbach",
                        "latitude": "49.44452000",
                        "longitude": "7.55533000"
                    },
                    {
                        "id": 28474,
                        "name": "Ransbach-Baumbach",
                        "latitude": "50.46496000",
                        "longitude": "7.72830000"
                    },
                    {
                        "id": 28492,
                        "name": "Raubach",
                        "latitude": "50.57489000",
                        "longitude": "7.62496000"
                    },
                    {
                        "id": 28531,
                        "name": "Rehe",
                        "latitude": "50.63333000",
                        "longitude": "8.11667000"
                    },
                    {
                        "id": 28542,
                        "name": "Reichenbach-Steegen",
                        "latitude": "49.50000000",
                        "longitude": "7.55000000"
                    },
                    {
                        "id": 28552,
                        "name": "Reil",
                        "latitude": "50.01667000",
                        "longitude": "7.11667000"
                    },
                    {
                        "id": 28565,
                        "name": "Reinsfeld",
                        "latitude": "49.68333000",
                        "longitude": "6.88333000"
                    },
                    {
                        "id": 28572,
                        "name": "Remagen",
                        "latitude": "50.57879000",
                        "longitude": "7.22703000"
                    },
                    {
                        "id": 28580,
                        "name": "Rengsdorf",
                        "latitude": "50.50000000",
                        "longitude": "7.50000000"
                    },
                    {
                        "id": 28581,
                        "name": "Rennerod",
                        "latitude": "50.60820000",
                        "longitude": "8.06697000"
                    },
                    {
                        "id": 28599,
                        "name": "Rhaunen",
                        "latitude": "49.86380000",
                        "longitude": "7.34198000"
                    },
                    {
                        "id": 28609,
                        "name": "Rheinböllen",
                        "latitude": "50.01127000",
                        "longitude": "7.67249000"
                    },
                    {
                        "id": 28607,
                        "name": "Rheinbreitbach",
                        "latitude": "50.61667000",
                        "longitude": "7.23333000"
                    },
                    {
                        "id": 28608,
                        "name": "Rheinbrohl",
                        "latitude": "50.50000000",
                        "longitude": "7.33333000"
                    },
                    {
                        "id": 28614,
                        "name": "Rheinzabern",
                        "latitude": "49.11806000",
                        "longitude": "8.27806000"
                    },
                    {
                        "id": 28615,
                        "name": "Rhens",
                        "latitude": "50.28125000",
                        "longitude": "7.61750000"
                    },
                    {
                        "id": 28618,
                        "name": "Rhodt unter Rietburg",
                        "latitude": "49.26972000",
                        "longitude": "8.10778000"
                    },
                    {
                        "id": 28628,
                        "name": "Rieden",
                        "latitude": "50.40000000",
                        "longitude": "7.18333000"
                    },
                    {
                        "id": 28646,
                        "name": "Rieschweiler-Mühlbach",
                        "latitude": "49.23333000",
                        "longitude": "7.50000000"
                    },
                    {
                        "id": 28658,
                        "name": "Rimschweiler",
                        "latitude": "49.21880000",
                        "longitude": "7.37571000"
                    },
                    {
                        "id": 28665,
                        "name": "Riol",
                        "latitude": "49.79301000",
                        "longitude": "6.79211000"
                    },
                    {
                        "id": 28668,
                        "name": "Rittersdorf",
                        "latitude": "50.00000000",
                        "longitude": "6.50000000"
                    },
                    {
                        "id": 28672,
                        "name": "Rockenhausen",
                        "latitude": "49.62974000",
                        "longitude": "7.82134000"
                    },
                    {
                        "id": 28673,
                        "name": "Rodalben",
                        "latitude": "49.23940000",
                        "longitude": "7.63962000"
                    },
                    {
                        "id": 28675,
                        "name": "Rodenbach",
                        "latitude": "49.57414000",
                        "longitude": "8.10695000"
                    },
                    {
                        "id": 28778,
                        "name": "Rödersheim-Gronau",
                        "latitude": "49.43000000",
                        "longitude": "8.26139000"
                    },
                    {
                        "id": 28690,
                        "name": "Rohrbach",
                        "latitude": "49.13667000",
                        "longitude": "8.12861000"
                    },
                    {
                        "id": 28721,
                        "name": "Roth",
                        "latitude": "50.76230000",
                        "longitude": "7.70016000"
                    },
                    {
                        "id": 28740,
                        "name": "Roxheim",
                        "latitude": "49.86374000",
                        "longitude": "7.80980000"
                    },
                    {
                        "id": 28800,
                        "name": "Rüdesheim",
                        "latitude": "49.84546000",
                        "longitude": "7.81452000"
                    },
                    {
                        "id": 28805,
                        "name": "Rülzheim",
                        "latitude": "49.15312000",
                        "longitude": "8.29287000"
                    },
                    {
                        "id": 28806,
                        "name": "Rümmelsheim",
                        "latitude": "49.93307000",
                        "longitude": "7.85977000"
                    },
                    {
                        "id": 28765,
                        "name": "Ruppach-Goldhausen",
                        "latitude": "50.46667000",
                        "longitude": "7.88333000"
                    },
                    {
                        "id": 28766,
                        "name": "Ruppertsberg",
                        "latitude": "49.40028000",
                        "longitude": "8.19611000"
                    },
                    {
                        "id": 28768,
                        "name": "Ruppertsweiler",
                        "latitude": "49.19707000",
                        "longitude": "7.68957000"
                    },
                    {
                        "id": 28817,
                        "name": "Saarburg",
                        "latitude": "49.60641000",
                        "longitude": "6.54365000"
                    },
                    {
                        "id": 28827,
                        "name": "Saffig",
                        "latitude": "50.38333000",
                        "longitude": "7.41667000"
                    },
                    {
                        "id": 28836,
                        "name": "Salmtal",
                        "latitude": "49.93333000",
                        "longitude": "6.85000000"
                    },
                    {
                        "id": 28867,
                        "name": "Sankt Goar",
                        "latitude": "50.14878000",
                        "longitude": "7.70720000"
                    },
                    {
                        "id": 28868,
                        "name": "Sankt Goarshausen",
                        "latitude": "50.15839000",
                        "longitude": "7.71374000"
                    },
                    {
                        "id": 28871,
                        "name": "Sankt Julian",
                        "latitude": "49.61667000",
                        "longitude": "7.51667000"
                    },
                    {
                        "id": 28872,
                        "name": "Sankt Katharinen",
                        "latitude": "50.58333000",
                        "longitude": "7.38333000"
                    },
                    {
                        "id": 28877,
                        "name": "Sankt Martin",
                        "latitude": "49.30028000",
                        "longitude": "8.10528000"
                    },
                    {
                        "id": 28882,
                        "name": "Sankt Sebastian",
                        "latitude": "50.41077000",
                        "longitude": "7.56175000"
                    },
                    {
                        "id": 28936,
                        "name": "Scheuerfeld",
                        "latitude": "50.78736000",
                        "longitude": "7.84128000"
                    },
                    {
                        "id": 28943,
                        "name": "Schifferstadt",
                        "latitude": "49.38417000",
                        "longitude": "8.37750000"
                    },
                    {
                        "id": 28947,
                        "name": "Schillingen",
                        "latitude": "49.63333000",
                        "longitude": "6.78333000"
                    },
                    {
                        "id": 29118,
                        "name": "Schönecken",
                        "latitude": "50.15909000",
                        "longitude": "6.46820000"
                    },
                    {
                        "id": 29121,
                        "name": "Schönenberg-Kübelberg",
                        "latitude": "49.40740000",
                        "longitude": "7.37233000"
                    },
                    {
                        "id": 29022,
                        "name": "Schopp",
                        "latitude": "49.35000000",
                        "longitude": "7.68333000"
                    },
                    {
                        "id": 29025,
                        "name": "Schornsheim",
                        "latitude": "49.84583000",
                        "longitude": "8.17500000"
                    },
                    {
                        "id": 29040,
                        "name": "Schwabenheim",
                        "latitude": "49.92879000",
                        "longitude": "8.09525000"
                    },
                    {
                        "id": 29077,
                        "name": "Schwedelbach",
                        "latitude": "49.49557000",
                        "longitude": "7.59366000"
                    },
                    {
                        "id": 29079,
                        "name": "Schwegenheim",
                        "latitude": "49.27000000",
                        "longitude": "8.32861000"
                    },
                    {
                        "id": 29080,
                        "name": "Schweich",
                        "latitude": "49.82215000",
                        "longitude": "6.75256000"
                    },
                    {
                        "id": 29081,
                        "name": "Schweigen-Rechtenbach",
                        "latitude": "49.05314000",
                        "longitude": "7.95638000"
                    },
                    {
                        "id": 29140,
                        "name": "Seck",
                        "latitude": "50.57722000",
                        "longitude": "8.04972000"
                    },
                    {
                        "id": 29171,
                        "name": "Seibersbach",
                        "latitude": "49.96667000",
                        "longitude": "7.71667000"
                    },
                    {
                        "id": 29184,
                        "name": "Selters",
                        "latitude": "50.53253000",
                        "longitude": "7.75577000"
                    },
                    {
                        "id": 29186,
                        "name": "Selzen",
                        "latitude": "49.86056000",
                        "longitude": "8.25528000"
                    },
                    {
                        "id": 29187,
                        "name": "Sembach",
                        "latitude": "49.51177000",
                        "longitude": "7.86661000"
                    },
                    {
                        "id": 29195,
                        "name": "Serrig",
                        "latitude": "49.57519000",
                        "longitude": "6.57454000"
                    },
                    {
                        "id": 29208,
                        "name": "Siebeldingen",
                        "latitude": "49.20889000",
                        "longitude": "8.05139000"
                    },
                    {
                        "id": 29210,
                        "name": "Siefersheim",
                        "latitude": "49.80000000",
                        "longitude": "7.95000000"
                    },
                    {
                        "id": 29221,
                        "name": "Siershahn",
                        "latitude": "50.48639000",
                        "longitude": "7.77972000"
                    },
                    {
                        "id": 29235,
                        "name": "Simmern",
                        "latitude": "49.98198000",
                        "longitude": "7.52351000"
                    },
                    {
                        "id": 29237,
                        "name": "Simmertal",
                        "latitude": "49.80981000",
                        "longitude": "7.52282000"
                    },
                    {
                        "id": 29242,
                        "name": "Singhofen",
                        "latitude": "50.27440000",
                        "longitude": "7.83333000"
                    },
                    {
                        "id": 29247,
                        "name": "Sinzig",
                        "latitude": "50.54384000",
                        "longitude": "7.24639000"
                    },
                    {
                        "id": 29249,
                        "name": "Sippersfeld",
                        "latitude": "49.55000000",
                        "longitude": "7.93333000"
                    },
                    {
                        "id": 29257,
                        "name": "Sohren",
                        "latitude": "49.93333000",
                        "longitude": "7.31667000"
                    },
                    {
                        "id": 29495,
                        "name": "Sörgenloch",
                        "latitude": "49.88306000",
                        "longitude": "8.20111000"
                    },
                    {
                        "id": 29283,
                        "name": "Spabrücken",
                        "latitude": "49.90000000",
                        "longitude": "7.71667000"
                    },
                    {
                        "id": 29290,
                        "name": "Spay",
                        "latitude": "50.25881000",
                        "longitude": "7.64839000"
                    },
                    {
                        "id": 29292,
                        "name": "Speicher",
                        "latitude": "49.93333000",
                        "longitude": "6.63333000"
                    },
                    {
                        "id": 29299,
                        "name": "Speyer",
                        "latitude": "49.32083000",
                        "longitude": "8.43111000"
                    },
                    {
                        "id": 29303,
                        "name": "Spiesheim",
                        "latitude": "49.81028000",
                        "longitude": "8.12750000"
                    },
                    {
                        "id": 29308,
                        "name": "Sprendlingen",
                        "latitude": "49.86667000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 29315,
                        "name": "Stadecken-Elsheim",
                        "latitude": "49.91222000",
                        "longitude": "8.12528000"
                    },
                    {
                        "id": 29323,
                        "name": "Stadtkyll",
                        "latitude": "50.35000000",
                        "longitude": "6.53333000"
                    },
                    {
                        "id": 29344,
                        "name": "Staudernheim",
                        "latitude": "49.77675000",
                        "longitude": "7.68890000"
                    },
                    {
                        "id": 29356,
                        "name": "Steimel",
                        "latitude": "50.61667000",
                        "longitude": "7.63333000"
                    },
                    {
                        "id": 29372,
                        "name": "Steinfeld",
                        "latitude": "49.04833000",
                        "longitude": "8.03694000"
                    },
                    {
                        "id": 29391,
                        "name": "Steinweiler",
                        "latitude": "49.12111000",
                        "longitude": "8.14139000"
                    },
                    {
                        "id": 29392,
                        "name": "Steinwenden",
                        "latitude": "49.45708000",
                        "longitude": "7.52726000"
                    },
                    {
                        "id": 29397,
                        "name": "Stelzenberg",
                        "latitude": "49.37756000",
                        "longitude": "7.73814000"
                    },
                    {
                        "id": 29436,
                        "name": "Stromberg",
                        "latitude": "50.45779000",
                        "longitude": "7.60041000"
                    },
                    {
                        "id": 29480,
                        "name": "Sulzheim",
                        "latitude": "49.84306000",
                        "longitude": "8.09167000"
                    },
                    {
                        "id": 29541,
                        "name": "Tawern",
                        "latitude": "49.66667000",
                        "longitude": "6.51667000"
                    },
                    {
                        "id": 29576,
                        "name": "Thaleischweiler-Fröschen",
                        "latitude": "49.26667000",
                        "longitude": "7.58333000"
                    },
                    {
                        "id": 29577,
                        "name": "Thalfang",
                        "latitude": "49.75000000",
                        "longitude": "7.00000000"
                    },
                    {
                        "id": 29598,
                        "name": "Thomm",
                        "latitude": "49.74140000",
                        "longitude": "6.80492000"
                    },
                    {
                        "id": 29607,
                        "name": "Thür",
                        "latitude": "50.35692000",
                        "longitude": "7.27689000"
                    },
                    {
                        "id": 29636,
                        "name": "Traben-Trarbach",
                        "latitude": "49.95076000",
                        "longitude": "7.11562000"
                    },
                    {
                        "id": 29642,
                        "name": "Trassem",
                        "latitude": "49.57849000",
                        "longitude": "6.52540000"
                    },
                    {
                        "id": 29654,
                        "name": "Trechtingshausen",
                        "latitude": "50.01031000",
                        "longitude": "7.84709000"
                    },
                    {
                        "id": 29658,
                        "name": "Treis-Karden",
                        "latitude": "50.17174000",
                        "longitude": "7.30218000"
                    },
                    {
                        "id": 29668,
                        "name": "Trier",
                        "latitude": "49.75565000",
                        "longitude": "6.63935000"
                    },
                    {
                        "id": 29669,
                        "name": "Trierweiler",
                        "latitude": "49.76231000",
                        "longitude": "6.55987000"
                    },
                    {
                        "id": 29672,
                        "name": "Trippstadt",
                        "latitude": "49.35935000",
                        "longitude": "7.77480000"
                    },
                    {
                        "id": 29675,
                        "name": "Trittenheim",
                        "latitude": "49.82471000",
                        "longitude": "6.89929000"
                    },
                    {
                        "id": 29683,
                        "name": "Trulben",
                        "latitude": "49.13916000",
                        "longitude": "7.54370000"
                    },
                    {
                        "id": 29716,
                        "name": "Udenheim",
                        "latitude": "49.86472000",
                        "longitude": "8.17167000"
                    },
                    {
                        "id": 30558,
                        "name": "Üdersdorf",
                        "latitude": "50.15000000",
                        "longitude": "6.80000000"
                    },
                    {
                        "id": 29724,
                        "name": "Uelversheim",
                        "latitude": "49.81000000",
                        "longitude": "8.28861000"
                    },
                    {
                        "id": 29738,
                        "name": "Ulmen",
                        "latitude": "50.20943000",
                        "longitude": "6.97941000"
                    },
                    {
                        "id": 29744,
                        "name": "Undenheim",
                        "latitude": "49.83806000",
                        "longitude": "8.21889000"
                    },
                    {
                        "id": 29746,
                        "name": "Unkel",
                        "latitude": "50.59653000",
                        "longitude": "7.21888000"
                    },
                    {
                        "id": 29749,
                        "name": "Unnau",
                        "latitude": "50.64881000",
                        "longitude": "7.90827000"
                    },
                    {
                        "id": 29791,
                        "name": "Urbach-Überdorf",
                        "latitude": "50.55690000",
                        "longitude": "7.58695000"
                    },
                    {
                        "id": 29792,
                        "name": "Urbar",
                        "latitude": "50.38333000",
                        "longitude": "7.63333000"
                    },
                    {
                        "id": 29793,
                        "name": "Urmitz",
                        "latitude": "50.41667000",
                        "longitude": "7.51667000"
                    },
                    {
                        "id": 30560,
                        "name": "Üxheim",
                        "latitude": "50.35000000",
                        "longitude": "6.75000000"
                    },
                    {
                        "id": 29811,
                        "name": "Vallendar",
                        "latitude": "50.39586000",
                        "longitude": "7.62427000"
                    },
                    {
                        "id": 29840,
                        "name": "Vettelschoß",
                        "latitude": "50.61667000",
                        "longitude": "7.35000000"
                    },
                    {
                        "id": 29859,
                        "name": "Vinningen",
                        "latitude": "49.15635000",
                        "longitude": "7.55191000"
                    },
                    {
                        "id": 29879,
                        "name": "Volxheim",
                        "latitude": "49.81667000",
                        "longitude": "7.93333000"
                    },
                    {
                        "id": 29901,
                        "name": "Wachenheim",
                        "latitude": "49.44045000",
                        "longitude": "8.18041000"
                    },
                    {
                        "id": 29906,
                        "name": "Wackernheim",
                        "latitude": "49.97444000",
                        "longitude": "8.11667000"
                    },
                    {
                        "id": 29934,
                        "name": "Waldalgesheim",
                        "latitude": "49.95000000",
                        "longitude": "7.83333000"
                    },
                    {
                        "id": 29941,
                        "name": "Waldböckelheim",
                        "latitude": "49.81667000",
                        "longitude": "7.71667000"
                    },
                    {
                        "id": 29936,
                        "name": "Waldbreitbach",
                        "latitude": "50.55000000",
                        "longitude": "7.41667000"
                    },
                    {
                        "id": 29951,
                        "name": "Waldfischbach-Burgalben",
                        "latitude": "49.28333000",
                        "longitude": "7.66667000"
                    },
                    {
                        "id": 29958,
                        "name": "Waldmohr",
                        "latitude": "49.38333000",
                        "longitude": "7.33333000"
                    },
                    {
                        "id": 29960,
                        "name": "Waldrach",
                        "latitude": "49.74623000",
                        "longitude": "6.74543000"
                    },
                    {
                        "id": 29962,
                        "name": "Waldsee",
                        "latitude": "49.39528000",
                        "longitude": "8.44028000"
                    },
                    {
                        "id": 29981,
                        "name": "Wallertheim",
                        "latitude": "49.83556000",
                        "longitude": "8.05139000"
                    },
                    {
                        "id": 29984,
                        "name": "Wallhausen",
                        "latitude": "49.88333000",
                        "longitude": "7.76667000"
                    },
                    {
                        "id": 29986,
                        "name": "Wallmenroth",
                        "latitude": "50.80000000",
                        "longitude": "7.83333000"
                    },
                    {
                        "id": 29987,
                        "name": "Wallmerod",
                        "latitude": "50.48333000",
                        "longitude": "7.95000000"
                    },
                    {
                        "id": 30030,
                        "name": "Wassenach",
                        "latitude": "50.43333000",
                        "longitude": "7.28333000"
                    },
                    {
                        "id": 30035,
                        "name": "Wasserliesch",
                        "latitude": "49.70739000",
                        "longitude": "6.53944000"
                    },
                    {
                        "id": 30041,
                        "name": "Wattenheim",
                        "latitude": "49.52167000",
                        "longitude": "8.06167000"
                    },
                    {
                        "id": 30043,
                        "name": "Waxweiler",
                        "latitude": "50.09257000",
                        "longitude": "6.36299000"
                    },
                    {
                        "id": 30060,
                        "name": "Wehr",
                        "latitude": "50.41667000",
                        "longitude": "7.21667000"
                    },
                    {
                        "id": 30064,
                        "name": "Weibern",
                        "latitude": "50.40808000",
                        "longitude": "7.14669000"
                    },
                    {
                        "id": 30072,
                        "name": "Weidenthal",
                        "latitude": "49.41667000",
                        "longitude": "8.00000000"
                    },
                    {
                        "id": 30086,
                        "name": "Weiler",
                        "latitude": "49.95696000",
                        "longitude": "7.86484000"
                    },
                    {
                        "id": 30088,
                        "name": "Weilerbach",
                        "latitude": "49.48333000",
                        "longitude": "7.63333000"
                    },
                    {
                        "id": 30099,
                        "name": "Weingarten",
                        "latitude": "49.25946000",
                        "longitude": "8.28620000"
                    },
                    {
                        "id": 30103,
                        "name": "Weinsheim",
                        "latitude": "49.83333000",
                        "longitude": "7.76667000"
                    },
                    {
                        "id": 30106,
                        "name": "Weisel",
                        "latitude": "50.11667000",
                        "longitude": "7.80000000"
                    },
                    {
                        "id": 30137,
                        "name": "Weißenthurm",
                        "latitude": "50.41719000",
                        "longitude": "7.45072000"
                    },
                    {
                        "id": 30114,
                        "name": "Weitefeld",
                        "latitude": "50.72541000",
                        "longitude": "7.92805000"
                    },
                    {
                        "id": 30117,
                        "name": "Weitersburg",
                        "latitude": "50.41667000",
                        "longitude": "7.60000000"
                    },
                    {
                        "id": 30146,
                        "name": "Welschbillig",
                        "latitude": "49.85000000",
                        "longitude": "6.56667000"
                    },
                    {
                        "id": 30153,
                        "name": "Wendelsheim",
                        "latitude": "49.76667000",
                        "longitude": "8.00000000"
                    },
                    {
                        "id": 30182,
                        "name": "Wernersberg",
                        "latitude": "49.19062000",
                        "longitude": "7.92756000"
                    },
                    {
                        "id": 30192,
                        "name": "Weselberg",
                        "latitude": "49.33662000",
                        "longitude": "7.60780000"
                    },
                    {
                        "id": 30204,
                        "name": "Westerburg",
                        "latitude": "50.55938000",
                        "longitude": "7.97482000"
                    },
                    {
                        "id": 30219,
                        "name": "Westheim",
                        "latitude": "49.24640000",
                        "longitude": "8.32357000"
                    },
                    {
                        "id": 30221,
                        "name": "Westhofen",
                        "latitude": "49.70444000",
                        "longitude": "8.24806000"
                    },
                    {
                        "id": 30233,
                        "name": "Weyerbusch",
                        "latitude": "50.71667000",
                        "longitude": "7.55000000"
                    },
                    {
                        "id": 30282,
                        "name": "Wilgartswiesen",
                        "latitude": "49.20891000",
                        "longitude": "7.87346000"
                    },
                    {
                        "id": 30306,
                        "name": "Wiltingen",
                        "latitude": "49.65919000",
                        "longitude": "6.59255000"
                    },
                    {
                        "id": 30309,
                        "name": "Wincheringen",
                        "latitude": "49.60904000",
                        "longitude": "6.42597000"
                    },
                    {
                        "id": 30314,
                        "name": "Winden",
                        "latitude": "49.09778000",
                        "longitude": "8.11694000"
                    },
                    {
                        "id": 30315,
                        "name": "Windesheim",
                        "latitude": "49.90000000",
                        "longitude": "7.81667000"
                    },
                    {
                        "id": 30316,
                        "name": "Windhagen",
                        "latitude": "50.64121000",
                        "longitude": "7.35352000"
                    },
                    {
                        "id": 30327,
                        "name": "Winningen",
                        "latitude": "50.31667000",
                        "longitude": "7.51667000"
                    },
                    {
                        "id": 30328,
                        "name": "Winnweiler",
                        "latitude": "49.56667000",
                        "longitude": "7.85000000"
                    },
                    {
                        "id": 30342,
                        "name": "Wirges",
                        "latitude": "50.47195000",
                        "longitude": "7.79844000"
                    },
                    {
                        "id": 30346,
                        "name": "Wissen",
                        "latitude": "50.77915000",
                        "longitude": "7.73466000"
                    },
                    {
                        "id": 30361,
                        "name": "Wittlich",
                        "latitude": "49.98596000",
                        "longitude": "6.89308000"
                    },
                    {
                        "id": 30388,
                        "name": "Wolfstein",
                        "latitude": "49.58411000",
                        "longitude": "7.60496000"
                    },
                    {
                        "id": 30390,
                        "name": "Wolken",
                        "latitude": "50.33333000",
                        "longitude": "7.46667000"
                    },
                    {
                        "id": 30441,
                        "name": "Wöllstein",
                        "latitude": "49.81667000",
                        "longitude": "7.96667000"
                    },
                    {
                        "id": 30406,
                        "name": "Worms",
                        "latitude": "49.63278000",
                        "longitude": "8.35916000"
                    },
                    {
                        "id": 30444,
                        "name": "Wörrstadt",
                        "latitude": "49.84861000",
                        "longitude": "8.12417000"
                    },
                    {
                        "id": 30448,
                        "name": "Wörth am Rhein",
                        "latitude": "49.04888000",
                        "longitude": "8.25959000"
                    },
                    {
                        "id": 30478,
                        "name": "Zeiskam",
                        "latitude": "49.23278000",
                        "longitude": "8.24722000"
                    },
                    {
                        "id": 30483,
                        "name": "Zell",
                        "latitude": "50.02918000",
                        "longitude": "7.18232000"
                    },
                    {
                        "id": 30491,
                        "name": "Zeltingen-Rachtig",
                        "latitude": "49.95000000",
                        "longitude": "7.01667000"
                    },
                    {
                        "id": 30492,
                        "name": "Zemmer",
                        "latitude": "49.90000000",
                        "longitude": "6.70000000"
                    },
                    {
                        "id": 30495,
                        "name": "Zerf",
                        "latitude": "49.60000000",
                        "longitude": "6.68333000"
                    },
                    {
                        "id": 30516,
                        "name": "Zornheim",
                        "latitude": "49.89000000",
                        "longitude": "8.22472000"
                    },
                    {
                        "id": 30531,
                        "name": "Zweibrücken",
                        "latitude": "49.24686000",
                        "longitude": "7.36977000"
                    }
                ]
            },
            {
                "id": 3020,
                "name": "Saarland",
                "iso2": "SL",
                "latitude": "49.39642340",
                "longitude": "7.02296070",
                "type": "land",
                "cities": [
                    {
                        "id": 23978,
                        "name": "Beckingen",
                        "latitude": "49.40000000",
                        "longitude": "6.70000000"
                    },
                    {
                        "id": 24094,
                        "name": "Bexbach",
                        "latitude": "49.34615000",
                        "longitude": "7.25527000"
                    },
                    {
                        "id": 24182,
                        "name": "Blieskastel",
                        "latitude": "49.23724000",
                        "longitude": "7.25617000"
                    },
                    {
                        "id": 24264,
                        "name": "Bous",
                        "latitude": "49.27732000",
                        "longitude": "6.80131000"
                    },
                    {
                        "id": 24336,
                        "name": "Britten",
                        "latitude": "49.52061000",
                        "longitude": "6.67651000"
                    },
                    {
                        "id": 24690,
                        "name": "Dillingen",
                        "latitude": "49.35557000",
                        "longitude": "6.72781000"
                    },
                    {
                        "id": 25014,
                        "name": "Ensdorf",
                        "latitude": "49.30000000",
                        "longitude": "6.78333000"
                    },
                    {
                        "id": 25018,
                        "name": "Eppelborn",
                        "latitude": "49.40000000",
                        "longitude": "6.96667000"
                    },
                    {
                        "id": 25250,
                        "name": "Freisen",
                        "latitude": "49.55000000",
                        "longitude": "7.25000000"
                    },
                    {
                        "id": 25294,
                        "name": "Friedrichsthal",
                        "latitude": "49.32786000",
                        "longitude": "7.09622000"
                    },
                    {
                        "id": 25332,
                        "name": "Fürstenhausen",
                        "latitude": "49.24075000",
                        "longitude": "6.86817000"
                    },
                    {
                        "id": 25460,
                        "name": "Gersheim",
                        "latitude": "49.15000000",
                        "longitude": "7.20000000"
                    },
                    {
                        "id": 25701,
                        "name": "Großrosseln",
                        "latitude": "49.20296000",
                        "longitude": "6.84148000"
                    },
                    {
                        "id": 25887,
                        "name": "Hangard",
                        "latitude": "49.38260000",
                        "longitude": "7.21046000"
                    },
                    {
                        "id": 25990,
                        "name": "Heidstock",
                        "latitude": "49.25571000",
                        "longitude": "6.88156000"
                    },
                    {
                        "id": 26125,
                        "name": "Heusweiler",
                        "latitude": "49.33632000",
                        "longitude": "6.93036000"
                    },
                    {
                        "id": 26252,
                        "name": "Homburg",
                        "latitude": "49.32637000",
                        "longitude": "7.33867000"
                    },
                    {
                        "id": 26369,
                        "name": "Illingen",
                        "latitude": "49.37362000",
                        "longitude": "7.04758000"
                    },
                    {
                        "id": 26641,
                        "name": "Kirkel",
                        "latitude": "49.28333000",
                        "longitude": "7.23333000"
                    },
                    {
                        "id": 26669,
                        "name": "Kleinblittersdorf",
                        "latitude": "49.15780000",
                        "longitude": "7.03734000"
                    },
                    {
                        "id": 26994,
                        "name": "Lebach",
                        "latitude": "49.41122000",
                        "longitude": "6.90988000"
                    },
                    {
                        "id": 27151,
                        "name": "Losheim",
                        "latitude": "49.50990000",
                        "longitude": "6.74549000"
                    },
                    {
                        "id": 27162,
                        "name": "Ludweiler-Warndt",
                        "latitude": "49.22074000",
                        "longitude": "6.81195000"
                    },
                    {
                        "id": 27173,
                        "name": "Luisenthal",
                        "latitude": "49.24932000",
                        "longitude": "6.90057000"
                    },
                    {
                        "id": 27245,
                        "name": "Mainzweiler",
                        "latitude": "49.41714000",
                        "longitude": "7.11804000"
                    },
                    {
                        "id": 27323,
                        "name": "Marpingen",
                        "latitude": "49.45228000",
                        "longitude": "7.05820000"
                    },
                    {
                        "id": 27415,
                        "name": "Merchweiler",
                        "latitude": "49.35000000",
                        "longitude": "7.05000000"
                    },
                    {
                        "id": 27430,
                        "name": "Merzig",
                        "latitude": "49.44331000",
                        "longitude": "6.63874000"
                    },
                    {
                        "id": 27442,
                        "name": "Mettlach",
                        "latitude": "49.49489000",
                        "longitude": "6.58562000"
                    },
                    {
                        "id": 27639,
                        "name": "Nalbach",
                        "latitude": "49.38333000",
                        "longitude": "6.78333000"
                    },
                    {
                        "id": 27640,
                        "name": "Namborn",
                        "latitude": "49.52166000",
                        "longitude": "7.14070000"
                    },
                    {
                        "id": 27780,
                        "name": "Neunkirchen",
                        "latitude": "49.34449000",
                        "longitude": "7.18045000"
                    },
                    {
                        "id": 27907,
                        "name": "Nohfelden",
                        "latitude": "49.58693000",
                        "longitude": "7.14283000"
                    },
                    {
                        "id": 27910,
                        "name": "Nonnweiler",
                        "latitude": "49.60762000",
                        "longitude": "6.96986000"
                    },
                    {
                        "id": 28046,
                        "name": "Oberthal",
                        "latitude": "49.51257000",
                        "longitude": "7.08382000"
                    },
                    {
                        "id": 28128,
                        "name": "Orscholz",
                        "latitude": "49.50593000",
                        "longitude": "6.52502000"
                    },
                    {
                        "id": 28197,
                        "name": "Ottweiler",
                        "latitude": "49.40133000",
                        "longitude": "7.16424000"
                    },
                    {
                        "id": 28423,
                        "name": "Püttlingen",
                        "latitude": "49.28550000",
                        "longitude": "6.88723000"
                    },
                    {
                        "id": 28433,
                        "name": "Quierschied",
                        "latitude": "49.31667000",
                        "longitude": "7.05000000"
                    },
                    {
                        "id": 28639,
                        "name": "Riegelsberg",
                        "latitude": "49.30000000",
                        "longitude": "6.93333000"
                    },
                    {
                        "id": 28775,
                        "name": "Röchling-Höhe",
                        "latitude": "49.27102000",
                        "longitude": "6.83457000"
                    },
                    {
                        "id": 28816,
                        "name": "Saarbrücken",
                        "latitude": "49.23262000",
                        "longitude": "7.00982000"
                    },
                    {
                        "id": 28818,
                        "name": "Saarhölzbach",
                        "latitude": "49.51585000",
                        "longitude": "6.60742000"
                    },
                    {
                        "id": 28819,
                        "name": "Saarlouis",
                        "latitude": "49.31366000",
                        "longitude": "6.75154000"
                    },
                    {
                        "id": 28820,
                        "name": "Saarwellingen",
                        "latitude": "49.35430000",
                        "longitude": "6.80487000"
                    },
                    {
                        "id": 28869,
                        "name": "Sankt Ingbert",
                        "latitude": "49.27697000",
                        "longitude": "7.11672000"
                    },
                    {
                        "id": 28883,
                        "name": "Sankt Wendel",
                        "latitude": "49.46633000",
                        "longitude": "7.16814000"
                    },
                    {
                        "id": 28944,
                        "name": "Schiffweiler",
                        "latitude": "49.36667000",
                        "longitude": "7.13333000"
                    },
                    {
                        "id": 28990,
                        "name": "Schmelz",
                        "latitude": "49.43333000",
                        "longitude": "6.85000000"
                    },
                    {
                        "id": 29049,
                        "name": "Schwalbach",
                        "latitude": "49.30000000",
                        "longitude": "6.81667000"
                    },
                    {
                        "id": 29302,
                        "name": "Spiesen-Elversberg",
                        "latitude": "49.31667000",
                        "longitude": "7.13333000"
                    },
                    {
                        "id": 29467,
                        "name": "Sulzbach",
                        "latitude": "49.29882000",
                        "longitude": "7.05696000"
                    },
                    {
                        "id": 29596,
                        "name": "Tholey",
                        "latitude": "49.48374000",
                        "longitude": "7.03691000"
                    },
                    {
                        "id": 30554,
                        "name": "Überherrn",
                        "latitude": "49.24187000",
                        "longitude": "6.69840000"
                    },
                    {
                        "id": 29892,
                        "name": "Völklingen",
                        "latitude": "49.25162000",
                        "longitude": "6.85873000"
                    },
                    {
                        "id": 29910,
                        "name": "Wadern",
                        "latitude": "49.54122000",
                        "longitude": "6.88774000"
                    },
                    {
                        "id": 29912,
                        "name": "Wadgassen",
                        "latitude": "49.26667000",
                        "longitude": "6.78333000"
                    },
                    {
                        "id": 29977,
                        "name": "Wallerfangen",
                        "latitude": "49.32749000",
                        "longitude": "6.71102000"
                    },
                    {
                        "id": 30110,
                        "name": "Weiskirchen",
                        "latitude": "49.55000000",
                        "longitude": "6.81667000"
                    },
                    {
                        "id": 30115,
                        "name": "Weiten",
                        "latitude": "49.53011000",
                        "longitude": "6.54064000"
                    }
                ]
            },
            {
                "id": 3021,
                "name": "Saxony",
                "iso2": "SN",
                "latitude": "51.10454070",
                "longitude": "13.20173840",
                "type": "land",
                "cities": [
                    {
                        "id": 23493,
                        "name": "Adorf",
                        "latitude": "50.32011000",
                        "longitude": "12.25986000"
                    },
                    {
                        "id": 23537,
                        "name": "Albertstadt",
                        "latitude": "51.08333000",
                        "longitude": "13.76667000"
                    },
                    {
                        "id": 23593,
                        "name": "Altenberg",
                        "latitude": "50.76556000",
                        "longitude": "13.75334000"
                    },
                    {
                        "id": 23629,
                        "name": "Altmittweida",
                        "latitude": "50.96667000",
                        "longitude": "12.95000000"
                    },
                    {
                        "id": 23661,
                        "name": "Annaberg-Buchholz",
                        "latitude": "50.57953000",
                        "longitude": "13.00627000"
                    },
                    {
                        "id": 23696,
                        "name": "Arzberg",
                        "latitude": "51.52887000",
                        "longitude": "13.12565000"
                    },
                    {
                        "id": 23724,
                        "name": "Aue",
                        "latitude": "50.59034000",
                        "longitude": "12.70657000"
                    },
                    {
                        "id": 23726,
                        "name": "Auerbach",
                        "latitude": "50.51155000",
                        "longitude": "12.40083000"
                    },
                    {
                        "id": 23733,
                        "name": "Augustusburg",
                        "latitude": "50.81192000",
                        "longitude": "13.10197000"
                    },
                    {
                        "id": 23775,
                        "name": "Bad Brambach",
                        "latitude": "50.21667000",
                        "longitude": "12.31667000"
                    },
                    {
                        "id": 23784,
                        "name": "Bad Düben",
                        "latitude": "51.59174000",
                        "longitude": "12.58492000"
                    },
                    {
                        "id": 23789,
                        "name": "Bad Elster",
                        "latitude": "50.28192000",
                        "longitude": "12.23430000"
                    },
                    {
                        "id": 23826,
                        "name": "Bad Lausick",
                        "latitude": "51.14495000",
                        "longitude": "12.64449000"
                    },
                    {
                        "id": 23836,
                        "name": "Bad Muskau",
                        "latitude": "51.55051000",
                        "longitude": "14.71240000"
                    },
                    {
                        "id": 23860,
                        "name": "Bad Schandau",
                        "latitude": "50.91743000",
                        "longitude": "14.15494000"
                    },
                    {
                        "id": 23861,
                        "name": "Bad Schlema",
                        "latitude": "50.60257000",
                        "longitude": "12.67288000"
                    },
                    {
                        "id": 23921,
                        "name": "Bannewitz",
                        "latitude": "50.99291000",
                        "longitude": "13.71712000"
                    },
                    {
                        "id": 24459,
                        "name": "Bärenstein",
                        "latitude": "50.50000000",
                        "longitude": "13.03333000"
                    },
                    {
                        "id": 23963,
                        "name": "Bautzen",
                        "latitude": "51.18035000",
                        "longitude": "14.43494000"
                    },
                    {
                        "id": 23992,
                        "name": "Beierfeld",
                        "latitude": "50.56529000",
                        "longitude": "12.79049000"
                    },
                    {
                        "id": 23993,
                        "name": "Beiersdorf",
                        "latitude": "51.07405000",
                        "longitude": "14.53828000"
                    },
                    {
                        "id": 23994,
                        "name": "Beilrode",
                        "latitude": "51.56667000",
                        "longitude": "13.06667000"
                    },
                    {
                        "id": 23998,
                        "name": "Belgern",
                        "latitude": "51.48263000",
                        "longitude": "13.12382000"
                    },
                    {
                        "id": 23999,
                        "name": "Belgershain",
                        "latitude": "51.23333000",
                        "longitude": "12.55000000"
                    },
                    {
                        "id": 24012,
                        "name": "Bennewitz",
                        "latitude": "51.36074000",
                        "longitude": "12.71376000"
                    },
                    {
                        "id": 24034,
                        "name": "Bergen",
                        "latitude": "50.47100000",
                        "longitude": "12.27448000"
                    },
                    {
                        "id": 24069,
                        "name": "Bernsbach",
                        "latitude": "50.57624000",
                        "longitude": "12.76751000"
                    },
                    {
                        "id": 24070,
                        "name": "Bernsdorf",
                        "latitude": "51.37350000",
                        "longitude": "14.06886000"
                    },
                    {
                        "id": 24071,
                        "name": "Bernstadt",
                        "latitude": "51.04736000",
                        "longitude": "14.82784000"
                    },
                    {
                        "id": 24075,
                        "name": "Berthelsdorf",
                        "latitude": "51.04679000",
                        "longitude": "14.22197000"
                    },
                    {
                        "id": 24076,
                        "name": "Bertsdorf-Hörnitz",
                        "latitude": "50.88593000",
                        "longitude": "14.73696000"
                    },
                    {
                        "id": 24150,
                        "name": "Bischofswerda",
                        "latitude": "51.12771000",
                        "longitude": "14.17974000"
                    },
                    {
                        "id": 24195,
                        "name": "Bockau",
                        "latitude": "50.54209000",
                        "longitude": "12.68639000"
                    },
                    {
                        "id": 24196,
                        "name": "Bockelwitz",
                        "latitude": "51.19942000",
                        "longitude": "12.95618000"
                    },
                    {
                        "id": 24466,
                        "name": "Böhlen",
                        "latitude": "51.20061000",
                        "longitude": "12.38622000"
                    },
                    {
                        "id": 24250,
                        "name": "Borna",
                        "latitude": "51.12416000",
                        "longitude": "12.49639000"
                    },
                    {
                        "id": 24474,
                        "name": "Börnichen",
                        "latitude": "50.75010000",
                        "longitude": "13.14075000"
                    },
                    {
                        "id": 24257,
                        "name": "Borsdorf",
                        "latitude": "51.35000000",
                        "longitude": "12.53333000"
                    },
                    {
                        "id": 24260,
                        "name": "Borstendorf",
                        "latitude": "50.77323000",
                        "longitude": "13.17918000"
                    },
                    {
                        "id": 24480,
                        "name": "Bösenbrunn",
                        "latitude": "50.39703000",
                        "longitude": "12.09998000"
                    },
                    {
                        "id": 24267,
                        "name": "Boxberg",
                        "latitude": "51.40373000",
                        "longitude": "14.57598000"
                    },
                    {
                        "id": 24278,
                        "name": "Brand-Erbisdorf",
                        "latitude": "50.86643000",
                        "longitude": "13.32285000"
                    },
                    {
                        "id": 24281,
                        "name": "Brandis",
                        "latitude": "51.33597000",
                        "longitude": "12.61024000"
                    },
                    {
                        "id": 24308,
                        "name": "Breitenbrunn",
                        "latitude": "50.47553000",
                        "longitude": "12.76649000"
                    },
                    {
                        "id": 24435,
                        "name": "Burgstädt",
                        "latitude": "50.91333000",
                        "longitude": "12.80600000"
                    },
                    {
                        "id": 24441,
                        "name": "Burkau",
                        "latitude": "51.17579000",
                        "longitude": "14.17329000"
                    },
                    {
                        "id": 24442,
                        "name": "Burkhardtsdorf",
                        "latitude": "50.73333000",
                        "longitude": "12.91667000"
                    },
                    {
                        "id": 24517,
                        "name": "Callenberg",
                        "latitude": "50.85000000",
                        "longitude": "12.63333000"
                    },
                    {
                        "id": 24527,
                        "name": "Cavertitz",
                        "latitude": "51.38333000",
                        "longitude": "13.13333000"
                    },
                    {
                        "id": 24533,
                        "name": "Chemnitz",
                        "latitude": "50.83570000",
                        "longitude": "12.92922000"
                    },
                    {
                        "id": 24539,
                        "name": "Claußnitz",
                        "latitude": "50.93333000",
                        "longitude": "12.88333000"
                    },
                    {
                        "id": 24549,
                        "name": "Colditz",
                        "latitude": "51.12821000",
                        "longitude": "12.80295000"
                    },
                    {
                        "id": 24554,
                        "name": "Coswig",
                        "latitude": "51.13204000",
                        "longitude": "13.58312000"
                    },
                    {
                        "id": 24563,
                        "name": "Crimmitschau",
                        "latitude": "50.81644000",
                        "longitude": "12.39045000"
                    },
                    {
                        "id": 24566,
                        "name": "Crostau",
                        "latitude": "51.08462000",
                        "longitude": "14.45589000"
                    },
                    {
                        "id": 24567,
                        "name": "Crostwitz",
                        "latitude": "51.23832000",
                        "longitude": "14.24338000"
                    },
                    {
                        "id": 24568,
                        "name": "Crottendorf",
                        "latitude": "50.51667000",
                        "longitude": "12.95000000"
                    },
                    {
                        "id": 24569,
                        "name": "Cunewalde",
                        "latitude": "51.10000000",
                        "longitude": "14.51667000"
                    },
                    {
                        "id": 24579,
                        "name": "Dahlen",
                        "latitude": "51.36495000",
                        "longitude": "12.99881000"
                    },
                    {
                        "id": 24623,
                        "name": "Delitzsch",
                        "latitude": "51.52546000",
                        "longitude": "12.34284000"
                    },
                    {
                        "id": 24628,
                        "name": "Demitz-Thumitz",
                        "latitude": "51.14149000",
                        "longitude": "14.24719000"
                    },
                    {
                        "id": 24633,
                        "name": "Dennheritz",
                        "latitude": "50.81412000",
                        "longitude": "12.46519000"
                    },
                    {
                        "id": 24660,
                        "name": "Deutzen",
                        "latitude": "51.11217000",
                        "longitude": "12.42541000"
                    },
                    {
                        "id": 24701,
                        "name": "Dippoldiswalde",
                        "latitude": "50.89621000",
                        "longitude": "13.66905000"
                    },
                    {
                        "id": 24792,
                        "name": "Döbeln",
                        "latitude": "51.12210000",
                        "longitude": "13.11027000"
                    },
                    {
                        "id": 24793,
                        "name": "Döbernitz",
                        "latitude": "51.51241000",
                        "longitude": "12.34753000"
                    },
                    {
                        "id": 24714,
                        "name": "Doberschütz",
                        "latitude": "51.49870000",
                        "longitude": "12.74792000"
                    },
                    {
                        "id": 24718,
                        "name": "Dohma",
                        "latitude": "50.91667000",
                        "longitude": "13.93333000"
                    },
                    {
                        "id": 24719,
                        "name": "Dohna",
                        "latitude": "50.95621000",
                        "longitude": "13.85839000"
                    },
                    {
                        "id": 24727,
                        "name": "Dommitzsch",
                        "latitude": "51.64071000",
                        "longitude": "12.87940000"
                    },
                    {
                        "id": 24734,
                        "name": "Dorfchemnitz",
                        "latitude": "50.66363000",
                        "longitude": "12.83651000"
                    },
                    {
                        "id": 24736,
                        "name": "Dorfhain",
                        "latitude": "50.93333000",
                        "longitude": "13.56667000"
                    },
                    {
                        "id": 24757,
                        "name": "Drebach",
                        "latitude": "50.67583000",
                        "longitude": "13.01620000"
                    },
                    {
                        "id": 24768,
                        "name": "Dresden",
                        "latitude": "51.05089000",
                        "longitude": "13.73832000"
                    },
                    {
                        "id": 24813,
                        "name": "Dürrhennersdorf",
                        "latitude": "51.04863000",
                        "longitude": "14.60383000"
                    },
                    {
                        "id": 24815,
                        "name": "Dürrröhrsdorf",
                        "latitude": "51.03395000",
                        "longitude": "13.99718000"
                    },
                    {
                        "id": 24832,
                        "name": "Ebersbach",
                        "latitude": "51.00762000",
                        "longitude": "14.58621000"
                    },
                    {
                        "id": 24893,
                        "name": "Ehrenfriedersdorf",
                        "latitude": "50.64934000",
                        "longitude": "12.97009000"
                    },
                    {
                        "id": 24895,
                        "name": "Eibau",
                        "latitude": "50.98272000",
                        "longitude": "14.66214000"
                    },
                    {
                        "id": 24897,
                        "name": "Eibenstock",
                        "latitude": "50.49431000",
                        "longitude": "12.59978000"
                    },
                    {
                        "id": 24904,
                        "name": "Eichigt",
                        "latitude": "50.35000000",
                        "longitude": "12.16667000"
                    },
                    {
                        "id": 24913,
                        "name": "Eilenburg",
                        "latitude": "51.45984000",
                        "longitude": "12.63338000"
                    },
                    {
                        "id": 24946,
                        "name": "Ellefeld",
                        "latitude": "50.48367000",
                        "longitude": "12.38880000"
                    },
                    {
                        "id": 24968,
                        "name": "Elsnig",
                        "latitude": "51.61024000",
                        "longitude": "12.92833000"
                    },
                    {
                        "id": 24970,
                        "name": "Elsterberg",
                        "latitude": "50.60841000",
                        "longitude": "12.16787000"
                    },
                    {
                        "id": 24971,
                        "name": "Elstertrebnitz",
                        "latitude": "51.15000000",
                        "longitude": "12.23333000"
                    },
                    {
                        "id": 24973,
                        "name": "Elstra",
                        "latitude": "51.22172000",
                        "longitude": "14.13201000"
                    },
                    {
                        "id": 24974,
                        "name": "Elterlein",
                        "latitude": "50.57663000",
                        "longitude": "12.86836000"
                    },
                    {
                        "id": 25022,
                        "name": "Eppendorf",
                        "latitude": "50.80000000",
                        "longitude": "13.23333000"
                    },
                    {
                        "id": 25053,
                        "name": "Erlau",
                        "latitude": "51.00938000",
                        "longitude": "12.94549000"
                    },
                    {
                        "id": 25054,
                        "name": "Erlbach",
                        "latitude": "50.31667000",
                        "longitude": "12.36667000"
                    },
                    {
                        "id": 25091,
                        "name": "Espenhain",
                        "latitude": "51.18926000",
                        "longitude": "12.47885000"
                    },
                    {
                        "id": 25131,
                        "name": "Falkenau",
                        "latitude": "50.85559000",
                        "longitude": "13.11718000"
                    },
                    {
                        "id": 25137,
                        "name": "Falkenhain",
                        "latitude": "51.39888000",
                        "longitude": "12.87083000"
                    },
                    {
                        "id": 25139,
                        "name": "Falkenstein",
                        "latitude": "50.47788000",
                        "longitude": "12.37129000"
                    },
                    {
                        "id": 25199,
                        "name": "Flöha",
                        "latitude": "50.85613000",
                        "longitude": "13.07407000"
                    },
                    {
                        "id": 25214,
                        "name": "Frankenberg",
                        "latitude": "50.91297000",
                        "longitude": "13.04011000"
                    },
                    {
                        "id": 25216,
                        "name": "Frankenstein",
                        "latitude": "50.90064000",
                        "longitude": "13.20933000"
                    },
                    {
                        "id": 25219,
                        "name": "Frankenthal",
                        "latitude": "51.13129000",
                        "longitude": "14.10893000"
                    },
                    {
                        "id": 25230,
                        "name": "Frauenstein",
                        "latitude": "50.80279000",
                        "longitude": "13.53790000"
                    },
                    {
                        "id": 25233,
                        "name": "Fraureuth",
                        "latitude": "50.70000000",
                        "longitude": "12.35000000"
                    },
                    {
                        "id": 25238,
                        "name": "Freiberg",
                        "latitude": "50.91089000",
                        "longitude": "13.33881000"
                    },
                    {
                        "id": 25252,
                        "name": "Freital",
                        "latitude": "51.00166000",
                        "longitude": "13.64880000"
                    },
                    {
                        "id": 25277,
                        "name": "Friedersdorf",
                        "latitude": "51.02416000",
                        "longitude": "14.56246000"
                    },
                    {
                        "id": 25304,
                        "name": "Frohburg",
                        "latitude": "51.05719000",
                        "longitude": "12.55746000"
                    },
                    {
                        "id": 25340,
                        "name": "Gablenz",
                        "latitude": "51.53333000",
                        "longitude": "14.66667000"
                    },
                    {
                        "id": 25404,
                        "name": "Geising",
                        "latitude": "50.75742000",
                        "longitude": "13.79278000"
                    },
                    {
                        "id": 25410,
                        "name": "Geithain",
                        "latitude": "51.05528000",
                        "longitude": "12.69674000"
                    },
                    {
                        "id": 25414,
                        "name": "Gelenau",
                        "latitude": "50.71151000",
                        "longitude": "12.96666000"
                    },
                    {
                        "id": 25443,
                        "name": "Geringswalde",
                        "latitude": "51.07677000",
                        "longitude": "12.90725000"
                    },
                    {
                        "id": 25458,
                        "name": "Gersdorf",
                        "latitude": "51.11220000",
                        "longitude": "12.93889000"
                    },
                    {
                        "id": 25479,
                        "name": "Geyer",
                        "latitude": "50.62632000",
                        "longitude": "12.92074000"
                    },
                    {
                        "id": 25503,
                        "name": "Glashütte",
                        "latitude": "50.85196000",
                        "longitude": "13.77977000"
                    },
                    {
                        "id": 25508,
                        "name": "Glaubitz",
                        "latitude": "51.32498000",
                        "longitude": "13.37817000"
                    },
                    {
                        "id": 25510,
                        "name": "Glauchau",
                        "latitude": "50.81987000",
                        "longitude": "12.54493000"
                    },
                    {
                        "id": 25775,
                        "name": "Göda",
                        "latitude": "51.17800000",
                        "longitude": "14.31951000"
                    },
                    {
                        "id": 25781,
                        "name": "Görlitz",
                        "latitude": "51.15518000",
                        "longitude": "14.98853000"
                    },
                    {
                        "id": 25543,
                        "name": "Gornau",
                        "latitude": "50.75901000",
                        "longitude": "13.03731000"
                    },
                    {
                        "id": 25544,
                        "name": "Gornsdorf",
                        "latitude": "50.70000000",
                        "longitude": "12.88333000"
                    },
                    {
                        "id": 25610,
                        "name": "Grimma",
                        "latitude": "51.23367000",
                        "longitude": "12.71959000"
                    },
                    {
                        "id": 25612,
                        "name": "Groitzsch",
                        "latitude": "51.15536000",
                        "longitude": "12.28279000"
                    },
                    {
                        "id": 25621,
                        "name": "Groß Düben",
                        "latitude": "51.56667000",
                        "longitude": "14.56667000"
                    },
                    {
                        "id": 25650,
                        "name": "Großbardau",
                        "latitude": "51.20419000",
                        "longitude": "12.69848000"
                    },
                    {
                        "id": 25656,
                        "name": "Großbothen",
                        "latitude": "51.18784000",
                        "longitude": "12.75101000"
                    },
                    {
                        "id": 25659,
                        "name": "Großdubrau",
                        "latitude": "51.25422000",
                        "longitude": "14.45897000"
                    },
                    {
                        "id": 25664,
                        "name": "Großenhain",
                        "latitude": "51.28951000",
                        "longitude": "13.53350000"
                    },
                    {
                        "id": 25675,
                        "name": "Großharthau",
                        "latitude": "51.10694000",
                        "longitude": "14.09911000"
                    },
                    {
                        "id": 25676,
                        "name": "Großhartmannsdorf",
                        "latitude": "50.80000000",
                        "longitude": "13.33333000"
                    },
                    {
                        "id": 25678,
                        "name": "Großhennersdorf",
                        "latitude": "50.98597000",
                        "longitude": "14.78776000"
                    },
                    {
                        "id": 25689,
                        "name": "Großlehna",
                        "latitude": "51.30687000",
                        "longitude": "12.17190000"
                    },
                    {
                        "id": 25693,
                        "name": "Großnaundorf",
                        "latitude": "51.20000000",
                        "longitude": "13.93333000"
                    },
                    {
                        "id": 25695,
                        "name": "Großolbersdorf",
                        "latitude": "50.70000000",
                        "longitude": "13.08333000"
                    },
                    {
                        "id": 25698,
                        "name": "Großpösna",
                        "latitude": "51.26667000",
                        "longitude": "12.50000000"
                    },
                    {
                        "id": 25697,
                        "name": "Großpostwitz",
                        "latitude": "51.12083000",
                        "longitude": "14.44065000"
                    },
                    {
                        "id": 25704,
                        "name": "Großröhrsdorf",
                        "latitude": "51.14528000",
                        "longitude": "14.01917000"
                    },
                    {
                        "id": 25705,
                        "name": "Großrückerswalde",
                        "latitude": "50.63333000",
                        "longitude": "13.11667000"
                    },
                    {
                        "id": 25706,
                        "name": "Großschirma",
                        "latitude": "50.96602000",
                        "longitude": "13.28590000"
                    },
                    {
                        "id": 25708,
                        "name": "Großschönau",
                        "latitude": "50.90000000",
                        "longitude": "14.68333000"
                    },
                    {
                        "id": 25707,
                        "name": "Großschweidnitz",
                        "latitude": "51.06939000",
                        "longitude": "14.64297000"
                    },
                    {
                        "id": 25713,
                        "name": "Großweitzschen",
                        "latitude": "51.15845000",
                        "longitude": "13.04517000"
                    },
                    {
                        "id": 25735,
                        "name": "Grünbach",
                        "latitude": "50.44995000",
                        "longitude": "12.36186000"
                    },
                    {
                        "id": 25739,
                        "name": "Grünhain",
                        "latitude": "50.58019000",
                        "longitude": "12.80695000"
                    },
                    {
                        "id": 25740,
                        "name": "Grünhainichen",
                        "latitude": "50.76720000",
                        "longitude": "13.15366000"
                    },
                    {
                        "id": 25770,
                        "name": "Guttau",
                        "latitude": "51.25904000",
                        "longitude": "14.56132000"
                    },
                    {
                        "id": 26295,
                        "name": "Hähnichen",
                        "latitude": "51.36540000",
                        "longitude": "14.86098000"
                    },
                    {
                        "id": 25837,
                        "name": "Hainewalde",
                        "latitude": "50.91014000",
                        "longitude": "14.70387000"
                    },
                    {
                        "id": 25838,
                        "name": "Hainichen",
                        "latitude": "50.97044000",
                        "longitude": "13.12287000"
                    },
                    {
                        "id": 25858,
                        "name": "Halsbrücke",
                        "latitude": "50.95000000",
                        "longitude": "13.35000000"
                    },
                    {
                        "id": 25878,
                        "name": "Hammerbrücke",
                        "latitude": "50.43504000",
                        "longitude": "12.41500000"
                    },
                    {
                        "id": 25913,
                        "name": "Hartenstein",
                        "latitude": "50.66236000",
                        "longitude": "12.66966000"
                    },
                    {
                        "id": 25914,
                        "name": "Hartha",
                        "latitude": "51.09863000",
                        "longitude": "12.97391000"
                    },
                    {
                        "id": 25917,
                        "name": "Hartmannsdorf",
                        "latitude": "50.75804000",
                        "longitude": "12.42687000"
                    },
                    {
                        "id": 25924,
                        "name": "Haselbachtal",
                        "latitude": "51.23570000",
                        "longitude": "14.02576000"
                    },
                    {
                        "id": 25954,
                        "name": "Hauswalde",
                        "latitude": "51.15212000",
                        "longitude": "14.08630000"
                    },
                    {
                        "id": 25985,
                        "name": "Heidenau",
                        "latitude": "50.97221000",
                        "longitude": "13.86741000"
                    },
                    {
                        "id": 26081,
                        "name": "Hermsdorf",
                        "latitude": "50.92338000",
                        "longitude": "13.73480000"
                    },
                    {
                        "id": 26090,
                        "name": "Herrnhut",
                        "latitude": "51.01624000",
                        "longitude": "14.74381000"
                    },
                    {
                        "id": 26132,
                        "name": "Hilbersdorf",
                        "latitude": "50.85400000",
                        "longitude": "12.94776000"
                    },
                    {
                        "id": 26165,
                        "name": "Hirschfeld",
                        "latitude": "50.62453000",
                        "longitude": "12.45722000"
                    },
                    {
                        "id": 26167,
                        "name": "Hirschfelde",
                        "latitude": "50.94437000",
                        "longitude": "14.88510000"
                    },
                    {
                        "id": 26177,
                        "name": "Hochkirch",
                        "latitude": "51.14898000",
                        "longitude": "14.57063000"
                    },
                    {
                        "id": 26305,
                        "name": "Höckendorf",
                        "latitude": "51.22423000",
                        "longitude": "13.90935000"
                    },
                    {
                        "id": 26194,
                        "name": "Hohburg",
                        "latitude": "51.41168000",
                        "longitude": "12.80508000"
                    },
                    {
                        "id": 26215,
                        "name": "Hohenstein-Ernstthal",
                        "latitude": "50.80064000",
                        "longitude": "12.71287000"
                    },
                    {
                        "id": 26224,
                        "name": "Hohndorf",
                        "latitude": "50.74044000",
                        "longitude": "12.68058000"
                    },
                    {
                        "id": 26226,
                        "name": "Hohnstein",
                        "latitude": "50.97991000",
                        "longitude": "14.11408000"
                    },
                    {
                        "id": 26262,
                        "name": "Horka",
                        "latitude": "51.26342000",
                        "longitude": "14.25523000"
                    },
                    {
                        "id": 26263,
                        "name": "Hormersdorf",
                        "latitude": "50.67406000",
                        "longitude": "12.88194000"
                    },
                    {
                        "id": 26277,
                        "name": "Hoyerswerda",
                        "latitude": "51.43787000",
                        "longitude": "14.23549000"
                    },
                    {
                        "id": 26427,
                        "name": "Jahnsdorf",
                        "latitude": "50.74509000",
                        "longitude": "12.85414000"
                    },
                    {
                        "id": 26443,
                        "name": "Jesewitz",
                        "latitude": "51.42276000",
                        "longitude": "12.56312000"
                    },
                    {
                        "id": 26455,
                        "name": "Johanngeorgenstadt",
                        "latitude": "50.43254000",
                        "longitude": "12.71140000"
                    },
                    {
                        "id": 26467,
                        "name": "Jöhstadt",
                        "latitude": "50.51229000",
                        "longitude": "13.09460000"
                    },
                    {
                        "id": 26500,
                        "name": "Kamenz",
                        "latitude": "51.26798000",
                        "longitude": "14.09374000"
                    },
                    {
                        "id": 26595,
                        "name": "Kirchberg",
                        "latitude": "50.62190000",
                        "longitude": "12.52449000"
                    },
                    {
                        "id": 26644,
                        "name": "Kirschau",
                        "latitude": "51.09317000",
                        "longitude": "14.42840000"
                    },
                    {
                        "id": 26651,
                        "name": "Kitzen",
                        "latitude": "51.22172000",
                        "longitude": "12.22349000"
                    },
                    {
                        "id": 26653,
                        "name": "Kitzscher",
                        "latitude": "51.16444000",
                        "longitude": "12.55260000"
                    },
                    {
                        "id": 26689,
                        "name": "Klingenthal",
                        "latitude": "50.35963000",
                        "longitude": "12.46463000"
                    },
                    {
                        "id": 26691,
                        "name": "Klipphausen",
                        "latitude": "51.06841000",
                        "longitude": "13.51374000"
                    },
                    {
                        "id": 26692,
                        "name": "Klitten",
                        "latitude": "51.35109000",
                        "longitude": "14.60526000"
                    },
                    {
                        "id": 26707,
                        "name": "Kodersdorf",
                        "latitude": "51.24272000",
                        "longitude": "14.89336000"
                    },
                    {
                        "id": 26826,
                        "name": "Königsbrück",
                        "latitude": "51.26451000",
                        "longitude": "13.90540000"
                    },
                    {
                        "id": 26829,
                        "name": "Königsfeld",
                        "latitude": "51.06667000",
                        "longitude": "12.75000000"
                    },
                    {
                        "id": 26832,
                        "name": "Königshain",
                        "latitude": "51.18333000",
                        "longitude": "14.86667000"
                    },
                    {
                        "id": 26834,
                        "name": "Königstein",
                        "latitude": "50.91570000",
                        "longitude": "14.07186000"
                    },
                    {
                        "id": 26837,
                        "name": "Königswalde",
                        "latitude": "50.55000000",
                        "longitude": "13.05000000"
                    },
                    {
                        "id": 26838,
                        "name": "Königswartha",
                        "latitude": "51.31028000",
                        "longitude": "14.32797000"
                    },
                    {
                        "id": 26729,
                        "name": "Kossa",
                        "latitude": "51.61707000",
                        "longitude": "12.68197000"
                    },
                    {
                        "id": 26742,
                        "name": "Krauschwitz",
                        "latitude": "51.52153000",
                        "longitude": "14.71211000"
                    },
                    {
                        "id": 26748,
                        "name": "Kreischa",
                        "latitude": "50.94534000",
                        "longitude": "13.75514000"
                    },
                    {
                        "id": 26761,
                        "name": "Kriebstein",
                        "latitude": "51.05000000",
                        "longitude": "13.01667000"
                    },
                    {
                        "id": 26776,
                        "name": "Krostitz",
                        "latitude": "51.46208000",
                        "longitude": "12.45360000"
                    },
                    {
                        "id": 26788,
                        "name": "Kubschütz",
                        "latitude": "51.16667000",
                        "longitude": "14.50000000"
                    },
                    {
                        "id": 26801,
                        "name": "Kurort Gohrisch",
                        "latitude": "50.91234000",
                        "longitude": "14.10687000"
                    },
                    {
                        "id": 26802,
                        "name": "Kurort Jonsdorf",
                        "latitude": "50.85751000",
                        "longitude": "14.70922000"
                    },
                    {
                        "id": 26803,
                        "name": "Kurort Oberwiesenthal",
                        "latitude": "50.41943000",
                        "longitude": "12.96836000"
                    },
                    {
                        "id": 26804,
                        "name": "Kurort Oybin",
                        "latitude": "50.84105000",
                        "longitude": "14.74124000"
                    },
                    {
                        "id": 26886,
                        "name": "Lampertswalde",
                        "latitude": "51.31108000",
                        "longitude": "13.67694000"
                    },
                    {
                        "id": 26910,
                        "name": "Langenbernsdorf",
                        "latitude": "50.75583000",
                        "longitude": "12.32669000"
                    },
                    {
                        "id": 26991,
                        "name": "Laußig",
                        "latitude": "51.54676000",
                        "longitude": "12.62930000"
                    },
                    {
                        "id": 26992,
                        "name": "Laußnitz",
                        "latitude": "51.25000000",
                        "longitude": "13.88333000"
                    },
                    {
                        "id": 26982,
                        "name": "Lauter",
                        "latitude": "50.56264000",
                        "longitude": "12.73513000"
                    },
                    {
                        "id": 26993,
                        "name": "Lawalde",
                        "latitude": "51.08333000",
                        "longitude": "14.60000000"
                    },
                    {
                        "id": 27028,
                        "name": "Leipzig",
                        "latitude": "51.33962000",
                        "longitude": "12.37129000"
                    },
                    {
                        "id": 27029,
                        "name": "Leisnig",
                        "latitude": "51.15743000",
                        "longitude": "12.92790000"
                    },
                    {
                        "id": 27040,
                        "name": "Lengefeld",
                        "latitude": "50.71911000",
                        "longitude": "13.19290000"
                    },
                    {
                        "id": 27041,
                        "name": "Lengenfeld",
                        "latitude": "50.56940000",
                        "longitude": "12.36408000"
                    },
                    {
                        "id": 27057,
                        "name": "Leubnitz",
                        "latitude": "50.72313000",
                        "longitude": "12.35660000"
                    },
                    {
                        "id": 27058,
                        "name": "Leubsdorf",
                        "latitude": "50.80000000",
                        "longitude": "13.16667000"
                    },
                    {
                        "id": 27067,
                        "name": "Leutersdorf",
                        "latitude": "50.95000000",
                        "longitude": "14.65000000"
                    },
                    {
                        "id": 27080,
                        "name": "Lichtenberg",
                        "latitude": "50.83492000",
                        "longitude": "13.42478000"
                    },
                    {
                        "id": 27083,
                        "name": "Lichtenstein",
                        "latitude": "50.75659000",
                        "longitude": "12.63025000"
                    },
                    {
                        "id": 27084,
                        "name": "Lichtentanne",
                        "latitude": "50.69255000",
                        "longitude": "12.42585000"
                    },
                    {
                        "id": 27091,
                        "name": "Liebstadt",
                        "latitude": "50.86417000",
                        "longitude": "13.85694000"
                    },
                    {
                        "id": 27097,
                        "name": "Limbach",
                        "latitude": "50.58333000",
                        "longitude": "12.25000000"
                    },
                    {
                        "id": 27098,
                        "name": "Limbach-Oberfrohna",
                        "latitude": "50.85882000",
                        "longitude": "12.76165000"
                    },
                    {
                        "id": 27185,
                        "name": "Löbau",
                        "latitude": "51.09954000",
                        "longitude": "14.66738000"
                    },
                    {
                        "id": 27189,
                        "name": "Löbnitz",
                        "latitude": "51.59238000",
                        "longitude": "12.46347000"
                    },
                    {
                        "id": 27125,
                        "name": "Lobstädt",
                        "latitude": "51.13361000",
                        "longitude": "12.44861000"
                    },
                    {
                        "id": 27134,
                        "name": "Lohmen",
                        "latitude": "50.98831000",
                        "longitude": "14.00268000"
                    },
                    {
                        "id": 27138,
                        "name": "Lohsa",
                        "latitude": "51.38333000",
                        "longitude": "14.40000000"
                    },
                    {
                        "id": 27142,
                        "name": "Lommatzsch",
                        "latitude": "51.19537000",
                        "longitude": "13.30917000"
                    },
                    {
                        "id": 27200,
                        "name": "Lößnitz",
                        "latitude": "50.62181000",
                        "longitude": "12.73147000"
                    },
                    {
                        "id": 27169,
                        "name": "Lugau",
                        "latitude": "50.73843000",
                        "longitude": "12.74861000"
                    },
                    {
                        "id": 27176,
                        "name": "Lunzenau",
                        "latitude": "50.96269000",
                        "longitude": "12.75594000"
                    },
                    {
                        "id": 27227,
                        "name": "Machern",
                        "latitude": "51.36667000",
                        "longitude": "12.63333000"
                    },
                    {
                        "id": 27257,
                        "name": "Malschwitz",
                        "latitude": "51.23759000",
                        "longitude": "14.52163000"
                    },
                    {
                        "id": 27273,
                        "name": "Marienberg",
                        "latitude": "50.65051000",
                        "longitude": "13.16122000"
                    },
                    {
                        "id": 27284,
                        "name": "Markersbach",
                        "latitude": "50.53545000",
                        "longitude": "12.86149000"
                    },
                    {
                        "id": 27285,
                        "name": "Markersdorf",
                        "latitude": "51.13333000",
                        "longitude": "14.88333000"
                    },
                    {
                        "id": 27287,
                        "name": "Markkleeberg",
                        "latitude": "51.27550000",
                        "longitude": "12.36906000"
                    },
                    {
                        "id": 27290,
                        "name": "Markneukirchen",
                        "latitude": "50.31144000",
                        "longitude": "12.32951000"
                    },
                    {
                        "id": 27291,
                        "name": "Markranstädt",
                        "latitude": "51.30146000",
                        "longitude": "12.22020000"
                    },
                    {
                        "id": 27365,
                        "name": "Meerane",
                        "latitude": "50.84688000",
                        "longitude": "12.46473000"
                    },
                    {
                        "id": 27373,
                        "name": "Mehltheuer",
                        "latitude": "50.54530000",
                        "longitude": "12.03700000"
                    },
                    {
                        "id": 27385,
                        "name": "Meissen",
                        "latitude": "51.16158000",
                        "longitude": "13.47370000"
                    },
                    {
                        "id": 27465,
                        "name": "Mildenau",
                        "latitude": "50.58689000",
                        "longitude": "13.07263000"
                    },
                    {
                        "id": 27482,
                        "name": "Mittelherwigsdorf",
                        "latitude": "50.91667000",
                        "longitude": "14.76667000"
                    },
                    {
                        "id": 27493,
                        "name": "Mittweida",
                        "latitude": "50.98622000",
                        "longitude": "12.97537000"
                    },
                    {
                        "id": 27497,
                        "name": "Mochau",
                        "latitude": "51.13333000",
                        "longitude": "13.18333000"
                    },
                    {
                        "id": 27498,
                        "name": "Mockrehna",
                        "latitude": "51.50757000",
                        "longitude": "12.81418000"
                    },
                    {
                        "id": 27525,
                        "name": "Moritzburg",
                        "latitude": "51.15922000",
                        "longitude": "13.68021000"
                    },
                    {
                        "id": 27584,
                        "name": "Mücka",
                        "latitude": "51.31667000",
                        "longitude": "14.70000000"
                    },
                    {
                        "id": 27586,
                        "name": "Mügeln",
                        "latitude": "51.23619000",
                        "longitude": "13.04567000"
                    },
                    {
                        "id": 27591,
                        "name": "Mühlau",
                        "latitude": "50.90000000",
                        "longitude": "12.76667000"
                    },
                    {
                        "id": 27603,
                        "name": "Mühltroff",
                        "latitude": "50.53919000",
                        "longitude": "11.92828000"
                    },
                    {
                        "id": 27535,
                        "name": "Mulda",
                        "latitude": "50.80789000",
                        "longitude": "13.41477000"
                    },
                    {
                        "id": 27608,
                        "name": "Mülsen",
                        "latitude": "50.75000000",
                        "longitude": "12.56667000"
                    },
                    {
                        "id": 27551,
                        "name": "Mutzschen",
                        "latitude": "51.26159000",
                        "longitude": "12.89125000"
                    },
                    {
                        "id": 27552,
                        "name": "Mylau",
                        "latitude": "50.61861000",
                        "longitude": "12.26535000"
                    },
                    {
                        "id": 27643,
                        "name": "Narsdorf",
                        "latitude": "51.01667000",
                        "longitude": "12.71667000"
                    },
                    {
                        "id": 27651,
                        "name": "Naundorf",
                        "latitude": "51.25718000",
                        "longitude": "13.10810000"
                    },
                    {
                        "id": 27652,
                        "name": "Naunhof",
                        "latitude": "51.27770000",
                        "longitude": "12.58827000"
                    },
                    {
                        "id": 27655,
                        "name": "Nauwalde",
                        "latitude": "51.41837000",
                        "longitude": "13.40974000"
                    },
                    {
                        "id": 27656,
                        "name": "Nebelschütz",
                        "latitude": "51.26227000",
                        "longitude": "14.15849000"
                    },
                    {
                        "id": 27677,
                        "name": "Nerchau",
                        "latitude": "51.27094000",
                        "longitude": "12.78912000"
                    },
                    {
                        "id": 27680,
                        "name": "Neschwitz",
                        "latitude": "51.27056000",
                        "longitude": "14.32900000"
                    },
                    {
                        "id": 27686,
                        "name": "Netzschkau",
                        "latitude": "50.61411000",
                        "longitude": "12.24382000"
                    },
                    {
                        "id": 27726,
                        "name": "Neuensalz",
                        "latitude": "50.50000000",
                        "longitude": "12.21667000"
                    },
                    {
                        "id": 27736,
                        "name": "Neugersdorf",
                        "latitude": "50.97729000",
                        "longitude": "14.60881000"
                    },
                    {
                        "id": 27745,
                        "name": "Neuhausen",
                        "latitude": "50.67647000",
                        "longitude": "13.46750000"
                    },
                    {
                        "id": 27755,
                        "name": "Neukieritzsch",
                        "latitude": "51.14995000",
                        "longitude": "12.41090000"
                    },
                    {
                        "id": 27756,
                        "name": "Neukirch",
                        "latitude": "51.28333000",
                        "longitude": "13.98333000"
                    },
                    {
                        "id": 27758,
                        "name": "Neukirch\/Lausitz",
                        "latitude": "51.09727000",
                        "longitude": "14.30789000"
                    },
                    {
                        "id": 27762,
                        "name": "Neukirchen",
                        "latitude": "50.77955000",
                        "longitude": "12.86755000"
                    },
                    {
                        "id": 27770,
                        "name": "Neumark",
                        "latitude": "50.66010000",
                        "longitude": "12.35619000"
                    },
                    {
                        "id": 27788,
                        "name": "Neusalza-Spremberg",
                        "latitude": "51.03945000",
                        "longitude": "14.53560000"
                    },
                    {
                        "id": 27806,
                        "name": "Neustadt in Sachsen",
                        "latitude": "51.02844000",
                        "longitude": "14.21785000"
                    },
                    {
                        "id": 27796,
                        "name": "Neustadt Vogtland",
                        "latitude": "50.46100000",
                        "longitude": "12.33224000"
                    },
                    {
                        "id": 27831,
                        "name": "Niederau",
                        "latitude": "51.17730000",
                        "longitude": "13.54563000"
                    },
                    {
                        "id": 27836,
                        "name": "Niedercunnersdorf",
                        "latitude": "51.05398000",
                        "longitude": "14.65830000"
                    },
                    {
                        "id": 27837,
                        "name": "Niederdorf",
                        "latitude": "50.72623000",
                        "longitude": "12.78587000"
                    },
                    {
                        "id": 27847,
                        "name": "Niederfrohna",
                        "latitude": "50.90000000",
                        "longitude": "12.71667000"
                    },
                    {
                        "id": 27871,
                        "name": "Niederschöna",
                        "latitude": "50.96671000",
                        "longitude": "13.41910000"
                    },
                    {
                        "id": 27877,
                        "name": "Niederstriegis",
                        "latitude": "51.08243000",
                        "longitude": "13.14925000"
                    },
                    {
                        "id": 27883,
                        "name": "Niederwiesa",
                        "latitude": "50.86667000",
                        "longitude": "13.01667000"
                    },
                    {
                        "id": 27898,
                        "name": "Niesky",
                        "latitude": "51.29241000",
                        "longitude": "14.82107000"
                    },
                    {
                        "id": 27934,
                        "name": "Nossen",
                        "latitude": "51.05798000",
                        "longitude": "13.29652000"
                    },
                    {
                        "id": 27953,
                        "name": "Nünchritz",
                        "latitude": "51.29993000",
                        "longitude": "13.38555000"
                    },
                    {
                        "id": 27969,
                        "name": "Obercunnersdorf",
                        "latitude": "50.91711000",
                        "longitude": "13.56015000"
                    },
                    {
                        "id": 27979,
                        "name": "Obergurig",
                        "latitude": "51.13294000",
                        "longitude": "14.40488000"
                    },
                    {
                        "id": 27993,
                        "name": "Oberlichtenau",
                        "latitude": "51.21875000",
                        "longitude": "13.98992000"
                    },
                    {
                        "id": 27994,
                        "name": "Oberlungwitz",
                        "latitude": "50.78230000",
                        "longitude": "12.70789000"
                    },
                    {
                        "id": 28033,
                        "name": "Oberschöna",
                        "latitude": "50.89759000",
                        "longitude": "13.25379000"
                    },
                    {
                        "id": 28055,
                        "name": "Oberwiera",
                        "latitude": "50.88913000",
                        "longitude": "12.54415000"
                    },
                    {
                        "id": 28073,
                        "name": "Oederan",
                        "latitude": "50.86064000",
                        "longitude": "13.17164000"
                    },
                    {
                        "id": 28078,
                        "name": "Oelsnitz",
                        "latitude": "50.41470000",
                        "longitude": "12.16950000"
                    },
                    {
                        "id": 28101,
                        "name": "Ohorn",
                        "latitude": "51.17199000",
                        "longitude": "14.04669000"
                    },
                    {
                        "id": 28102,
                        "name": "Olbernhau",
                        "latitude": "50.65870000",
                        "longitude": "13.34250000"
                    },
                    {
                        "id": 28103,
                        "name": "Olbersdorf",
                        "latitude": "50.87304000",
                        "longitude": "14.77035000"
                    },
                    {
                        "id": 28117,
                        "name": "Oppach",
                        "latitude": "51.06667000",
                        "longitude": "14.50000000"
                    },
                    {
                        "id": 28136,
                        "name": "Oschatz",
                        "latitude": "51.30001000",
                        "longitude": "13.10984000"
                    },
                    {
                        "id": 28206,
                        "name": "Oßling",
                        "latitude": "51.35999000",
                        "longitude": "14.16567000"
                    },
                    {
                        "id": 28165,
                        "name": "Ostrau",
                        "latitude": "51.20639000",
                        "longitude": "12.88421000"
                    },
                    {
                        "id": 28167,
                        "name": "Ostritz",
                        "latitude": "51.01451000",
                        "longitude": "14.93059000"
                    },
                    {
                        "id": 28178,
                        "name": "Ottendorf-Okrilla",
                        "latitude": "51.18333000",
                        "longitude": "13.83333000"
                    },
                    {
                        "id": 28193,
                        "name": "Otterwisch",
                        "latitude": "51.20000000",
                        "longitude": "12.61667000"
                    },
                    {
                        "id": 28217,
                        "name": "Panschwitz-Kuckau",
                        "latitude": "51.23395000",
                        "longitude": "14.19791000"
                    },
                    {
                        "id": 28238,
                        "name": "Pausa",
                        "latitude": "50.58172000",
                        "longitude": "11.99732000"
                    },
                    {
                        "id": 28240,
                        "name": "Pegau",
                        "latitude": "51.16715000",
                        "longitude": "12.25144000"
                    },
                    {
                        "id": 28251,
                        "name": "Penig",
                        "latitude": "50.93336000",
                        "longitude": "12.70422000"
                    },
                    {
                        "id": 28278,
                        "name": "Pfaffroda",
                        "latitude": "50.86134000",
                        "longitude": "12.51497000"
                    },
                    {
                        "id": 28309,
                        "name": "Pirna",
                        "latitude": "50.95843000",
                        "longitude": "13.93702000"
                    },
                    {
                        "id": 28319,
                        "name": "Plauen",
                        "latitude": "50.49730000",
                        "longitude": "12.13782000"
                    },
                    {
                        "id": 28336,
                        "name": "Pobershau",
                        "latitude": "50.64079000",
                        "longitude": "13.21776000"
                    },
                    {
                        "id": 28337,
                        "name": "Pockau",
                        "latitude": "50.70000000",
                        "longitude": "13.23333000"
                    },
                    {
                        "id": 28414,
                        "name": "Pöhl",
                        "latitude": "50.39311000",
                        "longitude": "12.32908000"
                    },
                    {
                        "id": 28415,
                        "name": "Pöhla",
                        "latitude": "50.51143000",
                        "longitude": "12.81889000"
                    },
                    {
                        "id": 28355,
                        "name": "Porschdorf",
                        "latitude": "50.94180000",
                        "longitude": "14.12687000"
                    },
                    {
                        "id": 28383,
                        "name": "Pretzschendorf",
                        "latitude": "50.87385000",
                        "longitude": "13.52499000"
                    },
                    {
                        "id": 28388,
                        "name": "Priestewitz",
                        "latitude": "51.25000000",
                        "longitude": "13.51667000"
                    },
                    {
                        "id": 28407,
                        "name": "Puschwitz",
                        "latitude": "51.25501000",
                        "longitude": "14.30111000"
                    },
                    {
                        "id": 28434,
                        "name": "Quitzdorf",
                        "latitude": "51.28333000",
                        "longitude": "14.76667000"
                    },
                    {
                        "id": 28436,
                        "name": "Rabenau",
                        "latitude": "50.96484000",
                        "longitude": "13.64305000"
                    },
                    {
                        "id": 28772,
                        "name": "Räckelwitz",
                        "latitude": "51.25000000",
                        "longitude": "14.23333000"
                    },
                    {
                        "id": 28438,
                        "name": "Rackwitz",
                        "latitude": "51.43333000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 28441,
                        "name": "Radeberg",
                        "latitude": "51.11112000",
                        "longitude": "13.91199000"
                    },
                    {
                        "id": 28442,
                        "name": "Radebeul",
                        "latitude": "51.10654000",
                        "longitude": "13.66047000"
                    },
                    {
                        "id": 28443,
                        "name": "Radeburg",
                        "latitude": "51.21516000",
                        "longitude": "13.72810000"
                    },
                    {
                        "id": 28446,
                        "name": "Radibor",
                        "latitude": "51.24481000",
                        "longitude": "14.39842000"
                    },
                    {
                        "id": 28462,
                        "name": "Rammenau",
                        "latitude": "51.15000000",
                        "longitude": "14.13333000"
                    },
                    {
                        "id": 28477,
                        "name": "Raschau",
                        "latitude": "50.53127000",
                        "longitude": "12.83312000"
                    },
                    {
                        "id": 28486,
                        "name": "Rathmannsdorf",
                        "latitude": "50.92993000",
                        "longitude": "14.14224000"
                    },
                    {
                        "id": 28501,
                        "name": "Rechenberg-Bienenmühle",
                        "latitude": "50.73777000",
                        "longitude": "13.53502000"
                    },
                    {
                        "id": 28526,
                        "name": "Regis-Breitingen",
                        "latitude": "51.08883000",
                        "longitude": "12.43841000"
                    },
                    {
                        "id": 28540,
                        "name": "Reichenbach",
                        "latitude": "51.14144000",
                        "longitude": "14.80270000"
                    },
                    {
                        "id": 28543,
                        "name": "Reichenbach\/Vogtland",
                        "latitude": "50.62279000",
                        "longitude": "12.30344000"
                    },
                    {
                        "id": 28559,
                        "name": "Reinhardtsgrimma",
                        "latitude": "50.89270000",
                        "longitude": "13.75534000"
                    },
                    {
                        "id": 28563,
                        "name": "Reinsberg",
                        "latitude": "51.00823000",
                        "longitude": "13.36542000"
                    },
                    {
                        "id": 28564,
                        "name": "Reinsdorf",
                        "latitude": "50.69775000",
                        "longitude": "12.55555000"
                    },
                    {
                        "id": 28577,
                        "name": "Remse",
                        "latitude": "50.85000000",
                        "longitude": "12.56667000"
                    },
                    {
                        "id": 28594,
                        "name": "Reuth",
                        "latitude": "50.61667000",
                        "longitude": "12.21667000"
                    },
                    {
                        "id": 28645,
                        "name": "Riesa",
                        "latitude": "51.30777000",
                        "longitude": "13.29168000"
                    },
                    {
                        "id": 28653,
                        "name": "Rietschen",
                        "latitude": "51.40000000",
                        "longitude": "14.78333000"
                    },
                    {
                        "id": 28669,
                        "name": "Rittersgrün",
                        "latitude": "50.48031000",
                        "longitude": "12.79336000"
                    },
                    {
                        "id": 28670,
                        "name": "Rochlitz",
                        "latitude": "51.05007000",
                        "longitude": "12.79754000"
                    },
                    {
                        "id": 28678,
                        "name": "Rodewisch",
                        "latitude": "50.53083000",
                        "longitude": "12.41329000"
                    },
                    {
                        "id": 28713,
                        "name": "Rossau",
                        "latitude": "51.00000000",
                        "longitude": "13.06667000"
                    },
                    {
                        "id": 28747,
                        "name": "Roßwein",
                        "latitude": "51.06589000",
                        "longitude": "13.18308000"
                    },
                    {
                        "id": 28789,
                        "name": "Rötha",
                        "latitude": "51.19783000",
                        "longitude": "12.41447000"
                    },
                    {
                        "id": 28724,
                        "name": "Rothenburg",
                        "latitude": "51.33400000",
                        "longitude": "14.96874000"
                    },
                    {
                        "id": 28863,
                        "name": "Sankt Egidien",
                        "latitude": "50.78617000",
                        "longitude": "12.62395000"
                    },
                    {
                        "id": 28899,
                        "name": "Sayda",
                        "latitude": "50.71123000",
                        "longitude": "13.42172000"
                    },
                    {
                        "id": 28911,
                        "name": "Scharfenstein",
                        "latitude": "50.70405000",
                        "longitude": "13.05654000"
                    },
                    {
                        "id": 28921,
                        "name": "Scheibenberg",
                        "latitude": "50.54023000",
                        "longitude": "12.91215000"
                    },
                    {
                        "id": 28945,
                        "name": "Schildau",
                        "latitude": "51.45721000",
                        "longitude": "12.93024000"
                    },
                    {
                        "id": 28952,
                        "name": "Schirgiswalde",
                        "latitude": "51.07641000",
                        "longitude": "14.42834000"
                    },
                    {
                        "id": 28955,
                        "name": "Schkeuditz",
                        "latitude": "51.39678000",
                        "longitude": "12.22141000"
                    },
                    {
                        "id": 28966,
                        "name": "Schlegel",
                        "latitude": "50.97775000",
                        "longitude": "14.87686000"
                    },
                    {
                        "id": 28970,
                        "name": "Schleife",
                        "latitude": "51.53333000",
                        "longitude": "14.53333000"
                    },
                    {
                        "id": 28973,
                        "name": "Schlettau",
                        "latitude": "50.55882000",
                        "longitude": "12.95269000"
                    },
                    {
                        "id": 28994,
                        "name": "Schmiedeberg",
                        "latitude": "50.83644000",
                        "longitude": "13.67622000"
                    },
                    {
                        "id": 29004,
                        "name": "Schneeberg",
                        "latitude": "50.59465000",
                        "longitude": "12.64139000"
                    },
                    {
                        "id": 29109,
                        "name": "Schönau-Berzdorf",
                        "latitude": "51.06402000",
                        "longitude": "14.88402000"
                    },
                    {
                        "id": 29110,
                        "name": "Schönbach",
                        "latitude": "51.06667000",
                        "longitude": "14.56667000"
                    },
                    {
                        "id": 29112,
                        "name": "Schönberg",
                        "latitude": "50.86752000",
                        "longitude": "12.49126000"
                    },
                    {
                        "id": 29117,
                        "name": "Schöneck",
                        "latitude": "50.39052000",
                        "longitude": "12.32731000"
                    },
                    {
                        "id": 29123,
                        "name": "Schönfeld",
                        "latitude": "51.30000000",
                        "longitude": "13.70000000"
                    },
                    {
                        "id": 29126,
                        "name": "Schönheide",
                        "latitude": "50.50458000",
                        "longitude": "12.52158000"
                    },
                    {
                        "id": 29070,
                        "name": "Schwarzenberg",
                        "latitude": "50.53791000",
                        "longitude": "12.78522000"
                    },
                    {
                        "id": 29089,
                        "name": "Schwepnitz",
                        "latitude": "51.32809000",
                        "longitude": "13.95772000"
                    },
                    {
                        "id": 29139,
                        "name": "Sebnitz",
                        "latitude": "50.97540000",
                        "longitude": "14.27579000"
                    },
                    {
                        "id": 29159,
                        "name": "Seelitz",
                        "latitude": "51.03333000",
                        "longitude": "12.81667000"
                    },
                    {
                        "id": 29172,
                        "name": "Seiffen",
                        "latitude": "50.65000000",
                        "longitude": "13.45000000"
                    },
                    {
                        "id": 29173,
                        "name": "Seifhennersdorf",
                        "latitude": "50.93492000",
                        "longitude": "14.60194000"
                    },
                    {
                        "id": 29255,
                        "name": "Sohland",
                        "latitude": "51.04089000",
                        "longitude": "14.41897000"
                    },
                    {
                        "id": 29256,
                        "name": "Sohland am Rotstein",
                        "latitude": "51.11643000",
                        "longitude": "14.78372000"
                    },
                    {
                        "id": 29280,
                        "name": "Sosa",
                        "latitude": "50.49917000",
                        "longitude": "12.65120000"
                    },
                    {
                        "id": 29318,
                        "name": "Stadt Wehlen",
                        "latitude": "50.95821000",
                        "longitude": "14.03091000"
                    },
                    {
                        "id": 29342,
                        "name": "Stauchitz",
                        "latitude": "51.24350000",
                        "longitude": "13.21437000"
                    },
                    {
                        "id": 29358,
                        "name": "Steina",
                        "latitude": "51.20000000",
                        "longitude": "14.05000000"
                    },
                    {
                        "id": 29386,
                        "name": "Steinigtwolmsdorf",
                        "latitude": "51.06314000",
                        "longitude": "14.34540000"
                    },
                    {
                        "id": 29417,
                        "name": "Stollberg",
                        "latitude": "50.70999000",
                        "longitude": "12.78034000"
                    },
                    {
                        "id": 29419,
                        "name": "Stolpen",
                        "latitude": "51.04901000",
                        "longitude": "14.07943000"
                    },
                    {
                        "id": 29435,
                        "name": "Strehla",
                        "latitude": "51.35248000",
                        "longitude": "13.22660000"
                    },
                    {
                        "id": 29438,
                        "name": "Struppen",
                        "latitude": "50.93333000",
                        "longitude": "14.01667000"
                    },
                    {
                        "id": 29456,
                        "name": "Stützengrün",
                        "latitude": "50.53333000",
                        "longitude": "12.53333000"
                    },
                    {
                        "id": 29488,
                        "name": "Syrau",
                        "latitude": "50.54297000",
                        "longitude": "12.07933000"
                    },
                    {
                        "id": 29523,
                        "name": "Tannenberg",
                        "latitude": "50.60738000",
                        "longitude": "12.93798000"
                    },
                    {
                        "id": 29524,
                        "name": "Tannenbergsthal",
                        "latitude": "50.43665000",
                        "longitude": "12.45754000"
                    },
                    {
                        "id": 29534,
                        "name": "Taucha",
                        "latitude": "51.38333000",
                        "longitude": "12.48333000"
                    },
                    {
                        "id": 29538,
                        "name": "Taura",
                        "latitude": "50.91667000",
                        "longitude": "12.85000000"
                    },
                    {
                        "id": 29539,
                        "name": "Tauscha",
                        "latitude": "51.26667000",
                        "longitude": "13.80000000"
                    },
                    {
                        "id": 29579,
                        "name": "Thalheim",
                        "latitude": "50.70077000",
                        "longitude": "12.84996000"
                    },
                    {
                        "id": 29580,
                        "name": "Thallwitz",
                        "latitude": "51.43333000",
                        "longitude": "12.68333000"
                    },
                    {
                        "id": 29585,
                        "name": "Tharandt",
                        "latitude": "50.98525000",
                        "longitude": "13.58035000"
                    },
                    {
                        "id": 29591,
                        "name": "Theuma",
                        "latitude": "50.47007000",
                        "longitude": "12.22195000"
                    },
                    {
                        "id": 29592,
                        "name": "Thiendorf",
                        "latitude": "51.29375000",
                        "longitude": "13.74124000"
                    },
                    {
                        "id": 29600,
                        "name": "Thum",
                        "latitude": "50.67081000",
                        "longitude": "12.95091000"
                    },
                    {
                        "id": 29617,
                        "name": "Tirpersdorf",
                        "latitude": "50.43333000",
                        "longitude": "12.25000000"
                    },
                    {
                        "id": 29632,
                        "name": "Torgau",
                        "latitude": "51.56016000",
                        "longitude": "12.99617000"
                    },
                    {
                        "id": 29649,
                        "name": "Trebendorf",
                        "latitude": "51.53333000",
                        "longitude": "14.56667000"
                    },
                    {
                        "id": 29652,
                        "name": "Trebsen",
                        "latitude": "51.28898000",
                        "longitude": "12.75496000"
                    },
                    {
                        "id": 29662,
                        "name": "Treuen",
                        "latitude": "50.54247000",
                        "longitude": "12.30339000"
                    },
                    {
                        "id": 29666,
                        "name": "Triebel",
                        "latitude": "50.37153000",
                        "longitude": "12.12118000"
                    },
                    {
                        "id": 29680,
                        "name": "Trossin",
                        "latitude": "51.61667000",
                        "longitude": "12.81667000"
                    },
                    {
                        "id": 29735,
                        "name": "Uhyst",
                        "latitude": "51.36469000",
                        "longitude": "14.50600000"
                    },
                    {
                        "id": 29833,
                        "name": "Venusberg",
                        "latitude": "50.69918000",
                        "longitude": "13.01854000"
                    },
                    {
                        "id": 29900,
                        "name": "Wachau",
                        "latitude": "51.16172000",
                        "longitude": "13.90651000"
                    },
                    {
                        "id": 29946,
                        "name": "Waldenburg",
                        "latitude": "50.87653000",
                        "longitude": "12.59919000"
                    },
                    {
                        "id": 29952,
                        "name": "Waldheim",
                        "latitude": "51.07282000",
                        "longitude": "13.02004000"
                    },
                    {
                        "id": 29955,
                        "name": "Waldkirchen",
                        "latitude": "50.59667000",
                        "longitude": "12.37994000"
                    },
                    {
                        "id": 30045,
                        "name": "Wechselburg",
                        "latitude": "51.00214000",
                        "longitude": "12.77661000"
                    },
                    {
                        "id": 30098,
                        "name": "Weinböhla",
                        "latitude": "51.16667000",
                        "longitude": "13.56667000"
                    },
                    {
                        "id": 30105,
                        "name": "Weischlitz",
                        "latitude": "50.45000000",
                        "longitude": "12.06667000"
                    },
                    {
                        "id": 30124,
                        "name": "Weißenberg",
                        "latitude": "51.19644000",
                        "longitude": "14.65874000"
                    },
                    {
                        "id": 30126,
                        "name": "Weißenborn",
                        "latitude": "50.73952000",
                        "longitude": "12.47051000"
                    },
                    {
                        "id": 30138,
                        "name": "Weißig",
                        "latitude": "51.29192000",
                        "longitude": "13.44117000"
                    },
                    {
                        "id": 30139,
                        "name": "Weißkeißel",
                        "latitude": "51.49405000",
                        "longitude": "14.71515000"
                    },
                    {
                        "id": 30140,
                        "name": "Weißwasser",
                        "latitude": "51.50403000",
                        "longitude": "14.64017000"
                    },
                    {
                        "id": 30168,
                        "name": "Werda",
                        "latitude": "50.43811000",
                        "longitude": "12.30473000"
                    },
                    {
                        "id": 30169,
                        "name": "Werdau",
                        "latitude": "50.73604000",
                        "longitude": "12.37534000"
                    },
                    {
                        "id": 30177,
                        "name": "Wermsdorf",
                        "latitude": "51.28333000",
                        "longitude": "12.95000000"
                    },
                    {
                        "id": 30239,
                        "name": "Wiedemar",
                        "latitude": "51.46667000",
                        "longitude": "12.20000000"
                    },
                    {
                        "id": 30243,
                        "name": "Wiednitz",
                        "latitude": "51.38608000",
                        "longitude": "14.02683000"
                    },
                    {
                        "id": 30252,
                        "name": "Wiesa",
                        "latitude": "50.61114000",
                        "longitude": "13.01377000"
                    },
                    {
                        "id": 30276,
                        "name": "Wildenfels",
                        "latitude": "50.66784000",
                        "longitude": "12.60886000"
                    },
                    {
                        "id": 30277,
                        "name": "Wildenhain",
                        "latitude": "51.30760000",
                        "longitude": "13.47678000"
                    },
                    {
                        "id": 30291,
                        "name": "Wilkau-Haßlau",
                        "latitude": "50.67504000",
                        "longitude": "12.51482000"
                    },
                    {
                        "id": 30301,
                        "name": "Wilsdruff",
                        "latitude": "51.05199000",
                        "longitude": "13.53657000"
                    },
                    {
                        "id": 30305,
                        "name": "Wilthen",
                        "latitude": "51.09745000",
                        "longitude": "14.39290000"
                    },
                    {
                        "id": 30357,
                        "name": "Wittgensdorf",
                        "latitude": "50.88316000",
                        "longitude": "12.87031000"
                    },
                    {
                        "id": 30358,
                        "name": "Wittichenau",
                        "latitude": "51.38496000",
                        "longitude": "14.24403000"
                    },
                    {
                        "id": 30391,
                        "name": "Wolkenstein",
                        "latitude": "50.65552000",
                        "longitude": "13.07132000"
                    },
                    {
                        "id": 30455,
                        "name": "Wülknitz",
                        "latitude": "51.36667000",
                        "longitude": "13.40000000"
                    },
                    {
                        "id": 30426,
                        "name": "Wurzen",
                        "latitude": "51.37070000",
                        "longitude": "12.73939000"
                    },
                    {
                        "id": 30462,
                        "name": "Zabeltitz",
                        "latitude": "51.35147000",
                        "longitude": "13.50462000"
                    },
                    {
                        "id": 30479,
                        "name": "Zeithain",
                        "latitude": "51.33356000",
                        "longitude": "13.33809000"
                    },
                    {
                        "id": 30510,
                        "name": "Zinna",
                        "latitude": "51.56790000",
                        "longitude": "12.95354000"
                    },
                    {
                        "id": 30512,
                        "name": "Zittau",
                        "latitude": "50.89772000",
                        "longitude": "14.80764000"
                    },
                    {
                        "id": 30541,
                        "name": "Zöblitz",
                        "latitude": "50.65912000",
                        "longitude": "13.22981000"
                    },
                    {
                        "id": 30518,
                        "name": "Zschadrass",
                        "latitude": "51.13828000",
                        "longitude": "12.81848000"
                    },
                    {
                        "id": 30519,
                        "name": "Zschepplin",
                        "latitude": "51.50000000",
                        "longitude": "12.60000000"
                    },
                    {
                        "id": 30522,
                        "name": "Zschopau",
                        "latitude": "50.74818000",
                        "longitude": "13.07691000"
                    },
                    {
                        "id": 30523,
                        "name": "Zschorlau",
                        "latitude": "50.56667000",
                        "longitude": "12.65000000"
                    },
                    {
                        "id": 30525,
                        "name": "Zschortau",
                        "latitude": "51.47930000",
                        "longitude": "12.35893000"
                    },
                    {
                        "id": 30533,
                        "name": "Zwenkau",
                        "latitude": "51.21872000",
                        "longitude": "12.33008000"
                    },
                    {
                        "id": 30534,
                        "name": "Zwickau",
                        "latitude": "50.72724000",
                        "longitude": "12.48839000"
                    },
                    {
                        "id": 30538,
                        "name": "Zwochau",
                        "latitude": "51.46467000",
                        "longitude": "12.26844000"
                    },
                    {
                        "id": 30540,
                        "name": "Zwönitz",
                        "latitude": "50.63027000",
                        "longitude": "12.80999000"
                    },
                    {
                        "id": 30539,
                        "name": "Zwota",
                        "latitude": "50.35103000",
                        "longitude": "12.42241000"
                    }
                ]
            },
            {
                "id": 3011,
                "name": "Saxony-Anhalt",
                "iso2": "ST",
                "latitude": "51.95026490",
                "longitude": "11.69227340",
                "type": "land",
                "cities": [
                    {
                        "id": 23470,
                        "name": "Abtsdorf",
                        "latitude": "51.88984000",
                        "longitude": "12.72526000"
                    },
                    {
                        "id": 23506,
                        "name": "Ahlsdorf",
                        "latitude": "51.54543000",
                        "longitude": "11.46655000"
                    },
                    {
                        "id": 23530,
                        "name": "Aken",
                        "latitude": "51.85274000",
                        "longitude": "12.04461000"
                    },
                    {
                        "id": 23563,
                        "name": "Allstedt",
                        "latitude": "51.40379000",
                        "longitude": "11.38689000"
                    },
                    {
                        "id": 23573,
                        "name": "Alsleben",
                        "latitude": "51.70161000",
                        "longitude": "11.67648000"
                    },
                    {
                        "id": 23656,
                        "name": "Angern",
                        "latitude": "52.35000000",
                        "longitude": "11.73333000"
                    },
                    {
                        "id": 23657,
                        "name": "Angersdorf",
                        "latitude": "51.46025000",
                        "longitude": "11.90705000"
                    },
                    {
                        "id": 23662,
                        "name": "Annaburg",
                        "latitude": "51.73298000",
                        "longitude": "13.04729000"
                    },
                    {
                        "id": 23675,
                        "name": "Apollensdorf",
                        "latitude": "51.87634000",
                        "longitude": "12.55012000"
                    },
                    {
                        "id": 23685,
                        "name": "Arneburg",
                        "latitude": "52.67565000",
                        "longitude": "12.00514000"
                    },
                    {
                        "id": 23707,
                        "name": "Aschersleben",
                        "latitude": "51.75742000",
                        "longitude": "11.46084000"
                    },
                    {
                        "id": 23719,
                        "name": "Atzendorf",
                        "latitude": "51.91954000",
                        "longitude": "11.59906000"
                    },
                    {
                        "id": 23742,
                        "name": "Ausleben",
                        "latitude": "52.09049000",
                        "longitude": "11.11192000"
                    },
                    {
                        "id": 23750,
                        "name": "Baalberge",
                        "latitude": "51.76469000",
                        "longitude": "11.79880000"
                    },
                    {
                        "id": 23771,
                        "name": "Bad Bibra",
                        "latitude": "51.20796000",
                        "longitude": "11.58517000"
                    },
                    {
                        "id": 23786,
                        "name": "Bad Dürrenberg",
                        "latitude": "51.29545000",
                        "longitude": "12.06583000"
                    },
                    {
                        "id": 23820,
                        "name": "Bad Kösen",
                        "latitude": "51.13431000",
                        "longitude": "11.72203000"
                    },
                    {
                        "id": 23825,
                        "name": "Bad Lauchstädt",
                        "latitude": "51.38652000",
                        "longitude": "11.86956000"
                    },
                    {
                        "id": 23862,
                        "name": "Bad Schmiedeberg",
                        "latitude": "51.68516000",
                        "longitude": "12.73483000"
                    },
                    {
                        "id": 23872,
                        "name": "Bad Suderode",
                        "latitude": "51.73333000",
                        "longitude": "11.11667000"
                    },
                    {
                        "id": 23912,
                        "name": "Ballenstedt",
                        "latitude": "51.71900000",
                        "longitude": "11.23265000"
                    },
                    {
                        "id": 23925,
                        "name": "Barby",
                        "latitude": "51.96711000",
                        "longitude": "11.88261000"
                    },
                    {
                        "id": 23935,
                        "name": "Barleben",
                        "latitude": "52.20193000",
                        "longitude": "11.61770000"
                    },
                    {
                        "id": 23939,
                        "name": "Barnstädt",
                        "latitude": "51.34401000",
                        "longitude": "11.63735000"
                    },
                    {
                        "id": 23985,
                        "name": "Beesenlaublingen",
                        "latitude": "51.71274000",
                        "longitude": "11.69729000"
                    },
                    {
                        "id": 23986,
                        "name": "Beesenstedt",
                        "latitude": "51.56828000",
                        "longitude": "11.73323000"
                    },
                    {
                        "id": 23989,
                        "name": "Beetzendorf",
                        "latitude": "52.70226000",
                        "longitude": "11.08890000"
                    },
                    {
                        "id": 24001,
                        "name": "Belleben",
                        "latitude": "51.67499000",
                        "longitude": "11.63420000"
                    },
                    {
                        "id": 24010,
                        "name": "Benndorf",
                        "latitude": "51.57035000",
                        "longitude": "11.49290000"
                    },
                    {
                        "id": 24011,
                        "name": "Benneckenstein",
                        "latitude": "51.66823000",
                        "longitude": "10.71716000"
                    },
                    {
                        "id": 24015,
                        "name": "Bennstedt",
                        "latitude": "51.48201000",
                        "longitude": "11.82620000"
                    },
                    {
                        "id": 24016,
                        "name": "Bennungen",
                        "latitude": "51.46085000",
                        "longitude": "11.11816000"
                    },
                    {
                        "id": 24028,
                        "name": "Berga",
                        "latitude": "51.45561000",
                        "longitude": "11.00710000"
                    },
                    {
                        "id": 24049,
                        "name": "Bergwitz",
                        "latitude": "51.79479000",
                        "longitude": "12.58954000"
                    },
                    {
                        "id": 24063,
                        "name": "Bernburg",
                        "latitude": "51.79464000",
                        "longitude": "11.74010000"
                    },
                    {
                        "id": 24087,
                        "name": "Beuna",
                        "latitude": "51.31667000",
                        "longitude": "11.95000000"
                    },
                    {
                        "id": 24106,
                        "name": "Biederitz",
                        "latitude": "52.15000000",
                        "longitude": "11.71667000"
                    },
                    {
                        "id": 24110,
                        "name": "Biere",
                        "latitude": "51.97431000",
                        "longitude": "11.65443000"
                    },
                    {
                        "id": 24154,
                        "name": "Bismark",
                        "latitude": "52.66195000",
                        "longitude": "11.55638000"
                    },
                    {
                        "id": 24160,
                        "name": "Bitterfeld-Wolfen",
                        "latitude": "51.62355000",
                        "longitude": "12.32395000"
                    },
                    {
                        "id": 24166,
                        "name": "Blankenburg",
                        "latitude": "51.79025000",
                        "longitude": "10.95509000"
                    },
                    {
                        "id": 24170,
                        "name": "Blankenheim",
                        "latitude": "51.50717000",
                        "longitude": "11.42878000"
                    },
                    {
                        "id": 24188,
                        "name": "Bobbau",
                        "latitude": "51.68747000",
                        "longitude": "12.27253000"
                    },
                    {
                        "id": 24251,
                        "name": "Borne",
                        "latitude": "51.94881000",
                        "longitude": "11.55865000"
                    },
                    {
                        "id": 24284,
                        "name": "Braschwitz",
                        "latitude": "51.52284000",
                        "longitude": "12.05867000"
                    },
                    {
                        "id": 24290,
                        "name": "Braunsbedra",
                        "latitude": "51.28602000",
                        "longitude": "11.88987000"
                    },
                    {
                        "id": 24299,
                        "name": "Brehna",
                        "latitude": "51.55790000",
                        "longitude": "12.21276000"
                    },
                    {
                        "id": 24357,
                        "name": "Brumby",
                        "latitude": "51.89635000",
                        "longitude": "11.71751000"
                    },
                    {
                        "id": 24410,
                        "name": "Burg bei Magdeburg",
                        "latitude": "52.27152000",
                        "longitude": "11.85493000"
                    },
                    {
                        "id": 24437,
                        "name": "Burgwerben",
                        "latitude": "51.22270000",
                        "longitude": "11.98396000"
                    },
                    {
                        "id": 24514,
                        "name": "Calbe",
                        "latitude": "51.90668000",
                        "longitude": "11.77478000"
                    },
                    {
                        "id": 24518,
                        "name": "Calvörde",
                        "latitude": "52.39551000",
                        "longitude": "11.29463000"
                    },
                    {
                        "id": 24546,
                        "name": "Cochstedt",
                        "latitude": "51.88247000",
                        "longitude": "11.41085000"
                    },
                    {
                        "id": 24548,
                        "name": "Colbitz",
                        "latitude": "52.31708000",
                        "longitude": "11.60534000"
                    },
                    {
                        "id": 24555,
                        "name": "Coswig",
                        "latitude": "51.88618000",
                        "longitude": "12.45009000"
                    },
                    {
                        "id": 24581,
                        "name": "Dahlenwarsleben",
                        "latitude": "52.19519000",
                        "longitude": "11.53736000"
                    },
                    {
                        "id": 24596,
                        "name": "Darlingerode",
                        "latitude": "51.84712000",
                        "longitude": "10.73097000"
                    },
                    {
                        "id": 24636,
                        "name": "Derenburg",
                        "latitude": "51.87086000",
                        "longitude": "10.91029000"
                    },
                    {
                        "id": 24643,
                        "name": "Dessau",
                        "latitude": "51.83864000",
                        "longitude": "12.24555000"
                    },
                    {
                        "id": 153640,
                        "name": "Dessau-Roßlau",
                        "latitude": "51.86055555",
                        "longitude": "12.24694444"
                    },
                    {
                        "id": 24655,
                        "name": "Deuben",
                        "latitude": "51.10968000",
                        "longitude": "12.07259000"
                    },
                    {
                        "id": 24674,
                        "name": "Diesdorf",
                        "latitude": "52.13075000",
                        "longitude": "11.56483000"
                    },
                    {
                        "id": 24675,
                        "name": "Dieskau",
                        "latitude": "51.43553000",
                        "longitude": "12.04035000"
                    },
                    {
                        "id": 24706,
                        "name": "Ditfurt",
                        "latitude": "51.83333000",
                        "longitude": "11.20000000"
                    },
                    {
                        "id": 24716,
                        "name": "Dobien",
                        "latitude": "51.90519000",
                        "longitude": "12.61068000"
                    },
                    {
                        "id": 24795,
                        "name": "Dölbau",
                        "latitude": "51.46701000",
                        "longitude": "12.05735000"
                    },
                    {
                        "id": 24796,
                        "name": "Döllnitz",
                        "latitude": "51.40777000",
                        "longitude": "12.02831000"
                    },
                    {
                        "id": 24725,
                        "name": "Domersleben",
                        "latitude": "52.09199000",
                        "longitude": "11.43757000"
                    },
                    {
                        "id": 24772,
                        "name": "Droyßig",
                        "latitude": "51.04247000",
                        "longitude": "12.02590000"
                    },
                    {
                        "id": 24773,
                        "name": "Drübeck",
                        "latitude": "51.85820000",
                        "longitude": "10.71839000"
                    },
                    {
                        "id": 24822,
                        "name": "Ebendorf",
                        "latitude": "52.18551000",
                        "longitude": "11.57478000"
                    },
                    {
                        "id": 24848,
                        "name": "Eckartsberga",
                        "latitude": "51.12380000",
                        "longitude": "11.56045000"
                    },
                    {
                        "id": 24852,
                        "name": "Edderitz",
                        "latitude": "51.69933000",
                        "longitude": "11.93712000"
                    },
                    {
                        "id": 24857,
                        "name": "Edersleben",
                        "latitude": "51.41667000",
                        "longitude": "11.28333000"
                    },
                    {
                        "id": 24865,
                        "name": "Egeln",
                        "latitude": "51.94384000",
                        "longitude": "11.43265000"
                    },
                    {
                        "id": 24876,
                        "name": "Eggersdorf",
                        "latitude": "51.97621000",
                        "longitude": "11.70971000"
                    },
                    {
                        "id": 24899,
                        "name": "Eichenbarleben",
                        "latitude": "52.16688000",
                        "longitude": "11.40125000"
                    },
                    {
                        "id": 24908,
                        "name": "Eickendorf",
                        "latitude": "51.94765000",
                        "longitude": "11.67538000"
                    },
                    {
                        "id": 24914,
                        "name": "Eilsleben",
                        "latitude": "52.14708000",
                        "longitude": "11.21035000"
                    },
                    {
                        "id": 24933,
                        "name": "Eisleben Lutherstadt",
                        "latitude": "51.52754000",
                        "longitude": "11.54835000"
                    },
                    {
                        "id": 24940,
                        "name": "Elbingerode",
                        "latitude": "51.77039000",
                        "longitude": "10.80557000"
                    },
                    {
                        "id": 24969,
                        "name": "Elster",
                        "latitude": "51.83011000",
                        "longitude": "12.82424000"
                    },
                    {
                        "id": 25031,
                        "name": "Erdeborn",
                        "latitude": "51.47554000",
                        "longitude": "11.63487000"
                    },
                    {
                        "id": 25062,
                        "name": "Ermlitz",
                        "latitude": "51.39182000",
                        "longitude": "12.15946000"
                    },
                    {
                        "id": 25072,
                        "name": "Erxleben",
                        "latitude": "52.21812000",
                        "longitude": "11.24245000"
                    },
                    {
                        "id": 25144,
                        "name": "Farnstädt",
                        "latitude": "51.43333000",
                        "longitude": "11.56667000"
                    },
                    {
                        "id": 25186,
                        "name": "Flechtingen",
                        "latitude": "52.33083000",
                        "longitude": "11.24176000"
                    },
                    {
                        "id": 25190,
                        "name": "Flessau",
                        "latitude": "52.75996000",
                        "longitude": "11.67093000"
                    },
                    {
                        "id": 25322,
                        "name": "Förderstedt",
                        "latitude": "51.89717000",
                        "longitude": "11.63349000"
                    },
                    {
                        "id": 25223,
                        "name": "Frankleben",
                        "latitude": "51.31144000",
                        "longitude": "11.92932000"
                    },
                    {
                        "id": 25262,
                        "name": "Freyburg",
                        "latitude": "51.21362000",
                        "longitude": "11.76804000"
                    },
                    {
                        "id": 25278,
                        "name": "Friedersdorf",
                        "latitude": "51.64809000",
                        "longitude": "12.36555000"
                    },
                    {
                        "id": 25285,
                        "name": "Friedrichsbrunn",
                        "latitude": "51.69028000",
                        "longitude": "11.03737000"
                    },
                    {
                        "id": 25292,
                        "name": "Friedrichstadt",
                        "latitude": "51.88751000",
                        "longitude": "12.66947000"
                    },
                    {
                        "id": 25309,
                        "name": "Frose",
                        "latitude": "51.79581000",
                        "longitude": "11.37914000"
                    },
                    {
                        "id": 25364,
                        "name": "Gardelegen",
                        "latitude": "52.52520000",
                        "longitude": "11.39523000"
                    },
                    {
                        "id": 25375,
                        "name": "Gatersleben",
                        "latitude": "51.82215000",
                        "longitude": "11.28661000"
                    },
                    {
                        "id": 25428,
                        "name": "Genthin",
                        "latitude": "52.40668000",
                        "longitude": "12.15920000"
                    },
                    {
                        "id": 25439,
                        "name": "Gerbstedt",
                        "latitude": "51.63281000",
                        "longitude": "11.62669000"
                    },
                    {
                        "id": 25447,
                        "name": "Gernrode",
                        "latitude": "51.72575000",
                        "longitude": "11.13876000"
                    },
                    {
                        "id": 25466,
                        "name": "Gerwisch",
                        "latitude": "52.17662000",
                        "longitude": "11.73972000"
                    },
                    {
                        "id": 25477,
                        "name": "Geusa",
                        "latitude": "51.33914000",
                        "longitude": "11.94382000"
                    },
                    {
                        "id": 25485,
                        "name": "Giersleben",
                        "latitude": "51.76667000",
                        "longitude": "11.56667000"
                    },
                    {
                        "id": 25514,
                        "name": "Glindenberg",
                        "latitude": "52.23857000",
                        "longitude": "11.68361000"
                    },
                    {
                        "id": 25517,
                        "name": "Glöthe",
                        "latitude": "51.91000000",
                        "longitude": "11.67471000"
                    },
                    {
                        "id": 25530,
                        "name": "Goldbeck",
                        "latitude": "52.71695000",
                        "longitude": "11.86060000"
                    },
                    {
                        "id": 25539,
                        "name": "Gommern",
                        "latitude": "52.07391000",
                        "longitude": "11.82297000"
                    },
                    {
                        "id": 25785,
                        "name": "Görzig",
                        "latitude": "51.66381000",
                        "longitude": "11.99759000"
                    },
                    {
                        "id": 25545,
                        "name": "Goseck",
                        "latitude": "51.20000000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 25724,
                        "name": "Gräfenhainichen",
                        "latitude": "51.72892000",
                        "longitude": "12.45651000"
                    },
                    {
                        "id": 25576,
                        "name": "Granschütz",
                        "latitude": "51.18431000",
                        "longitude": "12.05149000"
                    },
                    {
                        "id": 25600,
                        "name": "Greppin",
                        "latitude": "51.64682000",
                        "longitude": "12.30066000"
                    },
                    {
                        "id": 25728,
                        "name": "Gröbers",
                        "latitude": "51.43050000",
                        "longitude": "12.11623000"
                    },
                    {
                        "id": 25729,
                        "name": "Gröbzig",
                        "latitude": "51.68226000",
                        "longitude": "11.87453000"
                    },
                    {
                        "id": 25732,
                        "name": "Gröningen",
                        "latitude": "51.93744000",
                        "longitude": "11.21601000"
                    },
                    {
                        "id": 25619,
                        "name": "Groß Ammensleben",
                        "latitude": "52.23279000",
                        "longitude": "11.52195000"
                    },
                    {
                        "id": 25620,
                        "name": "Groß Börnecke",
                        "latitude": "51.88468000",
                        "longitude": "11.47032000"
                    },
                    {
                        "id": 25635,
                        "name": "Groß Quenstedt",
                        "latitude": "51.93333000",
                        "longitude": "11.11667000"
                    },
                    {
                        "id": 25637,
                        "name": "Groß Rodensleben",
                        "latitude": "52.12139000",
                        "longitude": "11.38367000"
                    },
                    {
                        "id": 25638,
                        "name": "Groß Rosenburg",
                        "latitude": "51.91696000",
                        "longitude": "11.89184000"
                    },
                    {
                        "id": 25639,
                        "name": "Groß Santersleben",
                        "latitude": "52.19143000",
                        "longitude": "11.45486000"
                    },
                    {
                        "id": 25683,
                        "name": "Großkayna",
                        "latitude": "51.29068000",
                        "longitude": "11.93269000"
                    },
                    {
                        "id": 25685,
                        "name": "Großkorbetha",
                        "latitude": "51.26002000",
                        "longitude": "12.03012000"
                    },
                    {
                        "id": 25687,
                        "name": "Großkugel",
                        "latitude": "51.41728000",
                        "longitude": "12.14641000"
                    },
                    {
                        "id": 25715,
                        "name": "Großörner",
                        "latitude": "51.61527000",
                        "longitude": "11.48980000"
                    },
                    {
                        "id": 25795,
                        "name": "Günthersdorf",
                        "latitude": "51.34570000",
                        "longitude": "12.17175000"
                    },
                    {
                        "id": 25798,
                        "name": "Güsten",
                        "latitude": "51.79637000",
                        "longitude": "11.61246000"
                    },
                    {
                        "id": 25767,
                        "name": "Gutenberg",
                        "latitude": "51.54710000",
                        "longitude": "11.97181000"
                    },
                    {
                        "id": 25813,
                        "name": "Hadmersleben",
                        "latitude": "51.99275000",
                        "longitude": "11.30283000"
                    },
                    {
                        "id": 25844,
                        "name": "Halberstadt",
                        "latitude": "51.89562000",
                        "longitude": "11.05622000"
                    },
                    {
                        "id": 25846,
                        "name": "Haldensleben I",
                        "latitude": "52.28906000",
                        "longitude": "11.40982000"
                    },
                    {
                        "id": 25853,
                        "name": "Halle (Saale)",
                        "latitude": "51.48158000",
                        "longitude": "11.97947000"
                    },
                    {
                        "id": 25854,
                        "name": "Halle Neustadt",
                        "latitude": "51.47924000",
                        "longitude": "11.91605000"
                    },
                    {
                        "id": 25896,
                        "name": "Harbke",
                        "latitude": "52.18877000",
                        "longitude": "11.04624000"
                    },
                    {
                        "id": 25909,
                        "name": "Harsleben",
                        "latitude": "51.86667000",
                        "longitude": "11.10000000"
                    },
                    {
                        "id": 25919,
                        "name": "Harzgerode",
                        "latitude": "51.64189000",
                        "longitude": "11.14330000"
                    },
                    {
                        "id": 25932,
                        "name": "Hasselfelde",
                        "latitude": "51.69051000",
                        "longitude": "10.85373000"
                    },
                    {
                        "id": 25956,
                        "name": "Havelberg",
                        "latitude": "52.83088000",
                        "longitude": "12.07552000"
                    },
                    {
                        "id": 25970,
                        "name": "Hecklingen",
                        "latitude": "51.84705000",
                        "longitude": "11.53416000"
                    },
                    {
                        "id": 25972,
                        "name": "Hedersleben",
                        "latitude": "51.54891000",
                        "longitude": "11.64983000"
                    },
                    {
                        "id": 26020,
                        "name": "Helbra",
                        "latitude": "51.55000000",
                        "longitude": "11.50000000"
                    },
                    {
                        "id": 26070,
                        "name": "Hergisdorf",
                        "latitude": "51.53333000",
                        "longitude": "11.48333000"
                    },
                    {
                        "id": 26080,
                        "name": "Hermsdorf",
                        "latitude": "52.18740000",
                        "longitude": "11.47556000"
                    },
                    {
                        "id": 26114,
                        "name": "Hettstedt",
                        "latitude": "51.65030000",
                        "longitude": "11.51146000"
                    },
                    {
                        "id": 26121,
                        "name": "Heudeber",
                        "latitude": "51.90245000",
                        "longitude": "10.84321000"
                    },
                    {
                        "id": 26202,
                        "name": "Hohendodeleben",
                        "latitude": "52.10412000",
                        "longitude": "11.50473000"
                    },
                    {
                        "id": 26212,
                        "name": "Hohenmölsen",
                        "latitude": "51.15769000",
                        "longitude": "12.10000000"
                    },
                    {
                        "id": 26218,
                        "name": "Hohenthurm",
                        "latitude": "51.51807000",
                        "longitude": "12.09749000"
                    },
                    {
                        "id": 26219,
                        "name": "Hohenwarsleben",
                        "latitude": "52.17898000",
                        "longitude": "11.49994000"
                    },
                    {
                        "id": 26221,
                        "name": "Hohenwarthe",
                        "latitude": "52.22968000",
                        "longitude": "11.71528000"
                    },
                    {
                        "id": 26312,
                        "name": "Höhnstedt",
                        "latitude": "51.50268000",
                        "longitude": "11.73844000"
                    },
                    {
                        "id": 26230,
                        "name": "Holleben",
                        "latitude": "51.44047000",
                        "longitude": "11.89915000"
                    },
                    {
                        "id": 26241,
                        "name": "Holzdorf",
                        "latitude": "51.77873000",
                        "longitude": "13.12756000"
                    },
                    {
                        "id": 26249,
                        "name": "Holzweißig",
                        "latitude": "51.59819000",
                        "longitude": "12.30842000"
                    },
                    {
                        "id": 26269,
                        "name": "Hornhausen",
                        "latitude": "52.04510000",
                        "longitude": "11.17104000"
                    },
                    {
                        "id": 26324,
                        "name": "Hötensleben",
                        "latitude": "52.11974000",
                        "longitude": "11.02238000"
                    },
                    {
                        "id": 26278,
                        "name": "Hoym",
                        "latitude": "51.78292000",
                        "longitude": "11.31244000"
                    },
                    {
                        "id": 26343,
                        "name": "Hüttenrode",
                        "latitude": "51.76880000",
                        "longitude": "10.90384000"
                    },
                    {
                        "id": 26294,
                        "name": "Huy-Neinstedt",
                        "latitude": "51.96585000",
                        "longitude": "10.91457000"
                    },
                    {
                        "id": 26363,
                        "name": "Ilberstedt",
                        "latitude": "51.80000000",
                        "longitude": "11.66667000"
                    },
                    {
                        "id": 26375,
                        "name": "Ilsenburg",
                        "latitude": "51.86695000",
                        "longitude": "10.67817000"
                    },
                    {
                        "id": 26410,
                        "name": "Irxleben",
                        "latitude": "52.16689000",
                        "longitude": "11.48064000"
                    },
                    {
                        "id": 26465,
                        "name": "Jävenitz",
                        "latitude": "52.52410000",
                        "longitude": "11.49909000"
                    },
                    {
                        "id": 26437,
                        "name": "Jerichow",
                        "latitude": "52.50049000",
                        "longitude": "12.02383000"
                    },
                    {
                        "id": 26444,
                        "name": "Jessen",
                        "latitude": "51.79337000",
                        "longitude": "12.95762000"
                    },
                    {
                        "id": 26451,
                        "name": "Jeßnitz",
                        "latitude": "51.68307000",
                        "longitude": "12.29992000"
                    },
                    {
                        "id": 26486,
                        "name": "Kalbe",
                        "latitude": "52.65656000",
                        "longitude": "11.38456000"
                    },
                    {
                        "id": 26525,
                        "name": "Karsdorf",
                        "latitude": "51.27134000",
                        "longitude": "11.65775000"
                    },
                    {
                        "id": 26549,
                        "name": "Kayna",
                        "latitude": "50.99414000",
                        "longitude": "12.23710000"
                    },
                    {
                        "id": 26555,
                        "name": "Kelbra",
                        "latitude": "51.43528000",
                        "longitude": "11.04143000"
                    },
                    {
                        "id": 26563,
                        "name": "Kemberg",
                        "latitude": "51.77189000",
                        "longitude": "12.63227000"
                    },
                    {
                        "id": 26666,
                        "name": "Klein Wanzleben",
                        "latitude": "52.07005000",
                        "longitude": "11.36594000"
                    },
                    {
                        "id": 26684,
                        "name": "Klieken",
                        "latitude": "51.88806000",
                        "longitude": "12.37070000"
                    },
                    {
                        "id": 26685,
                        "name": "Klietz",
                        "latitude": "52.66835000",
                        "longitude": "12.06812000"
                    },
                    {
                        "id": 26695,
                        "name": "Klostermansfeld",
                        "latitude": "51.58333000",
                        "longitude": "11.50000000"
                    },
                    {
                        "id": 26698,
                        "name": "Klötze",
                        "latitude": "52.62725000",
                        "longitude": "11.16424000"
                    },
                    {
                        "id": 26841,
                        "name": "Könnern",
                        "latitude": "51.67120000",
                        "longitude": "11.77068000"
                    },
                    {
                        "id": 26846,
                        "name": "Köthen",
                        "latitude": "51.75185000",
                        "longitude": "11.97093000"
                    },
                    {
                        "id": 26847,
                        "name": "Kötzschau",
                        "latitude": "51.31244000",
                        "longitude": "12.13044000"
                    },
                    {
                        "id": 26753,
                        "name": "Kretzschau",
                        "latitude": "51.05000000",
                        "longitude": "12.06667000"
                    },
                    {
                        "id": 26774,
                        "name": "Kroppenstedt",
                        "latitude": "51.94211000",
                        "longitude": "11.30841000"
                    },
                    {
                        "id": 26775,
                        "name": "Kropstädt",
                        "latitude": "51.96307000",
                        "longitude": "12.74550000"
                    },
                    {
                        "id": 26781,
                        "name": "Krumpa",
                        "latitude": "51.29724000",
                        "longitude": "11.84412000"
                    },
                    {
                        "id": 26806,
                        "name": "Kusey",
                        "latitude": "52.57987000",
                        "longitude": "11.09056000"
                    },
                    {
                        "id": 26893,
                        "name": "Landsberg",
                        "latitude": "51.52698000",
                        "longitude": "12.16076000"
                    },
                    {
                        "id": 26900,
                        "name": "Langeln",
                        "latitude": "51.91188000",
                        "longitude": "10.79436000"
                    },
                    {
                        "id": 26911,
                        "name": "Langenbogen",
                        "latitude": "51.48300000",
                        "longitude": "11.77786000"
                    },
                    {
                        "id": 26914,
                        "name": "Langendorf",
                        "latitude": "51.17972000",
                        "longitude": "11.96140000"
                    },
                    {
                        "id": 26915,
                        "name": "Langeneichstädt",
                        "latitude": "51.34537000",
                        "longitude": "11.74330000"
                    },
                    {
                        "id": 26930,
                        "name": "Langenstein",
                        "latitude": "51.85551000",
                        "longitude": "10.98822000"
                    },
                    {
                        "id": 26958,
                        "name": "Laucha",
                        "latitude": "51.22422000",
                        "longitude": "11.67988000"
                    },
                    {
                        "id": 27032,
                        "name": "Leißling",
                        "latitude": "51.18260000",
                        "longitude": "11.90954000"
                    },
                    {
                        "id": 27030,
                        "name": "Leitzkau",
                        "latitude": "52.05818000",
                        "longitude": "11.95203000"
                    },
                    {
                        "id": 27056,
                        "name": "Letzlingen",
                        "latitude": "52.44615000",
                        "longitude": "11.48518000"
                    },
                    {
                        "id": 27062,
                        "name": "Leuna",
                        "latitude": "51.31783000",
                        "longitude": "12.01589000"
                    },
                    {
                        "id": 27095,
                        "name": "Lieskau",
                        "latitude": "51.50395000",
                        "longitude": "11.86208000"
                    },
                    {
                        "id": 27103,
                        "name": "Lindau",
                        "latitude": "52.03751000",
                        "longitude": "12.10788000"
                    },
                    {
                        "id": 27186,
                        "name": "Löbejün",
                        "latitude": "51.63533000",
                        "longitude": "11.90106000"
                    },
                    {
                        "id": 27187,
                        "name": "Löberitz",
                        "latitude": "51.65393000",
                        "longitude": "12.14655000"
                    },
                    {
                        "id": 27126,
                        "name": "Loburg",
                        "latitude": "52.11509000",
                        "longitude": "12.07840000"
                    },
                    {
                        "id": 27127,
                        "name": "Lochau",
                        "latitude": "51.39738000",
                        "longitude": "12.05303000"
                    },
                    {
                        "id": 27152,
                        "name": "Lostau",
                        "latitude": "52.20871000",
                        "longitude": "11.73795000"
                    },
                    {
                        "id": 27213,
                        "name": "Lüderitz",
                        "latitude": "52.50912000",
                        "longitude": "11.74301000"
                    },
                    {
                        "id": 27168,
                        "name": "Luftkurort Arendsee",
                        "latitude": "52.88073000",
                        "longitude": "11.48621000"
                    },
                    {
                        "id": 27225,
                        "name": "Lützen",
                        "latitude": "51.25671000",
                        "longitude": "12.14164000"
                    },
                    {
                        "id": 27230,
                        "name": "Magdeburg",
                        "latitude": "52.12773000",
                        "longitude": "11.62916000"
                    },
                    {
                        "id": 27267,
                        "name": "Mansfeld",
                        "latitude": "51.59234000",
                        "longitude": "11.45223000"
                    },
                    {
                        "id": 27378,
                        "name": "Mehringen",
                        "latitude": "51.72663000",
                        "longitude": "11.51264000"
                    },
                    {
                        "id": 27387,
                        "name": "Meitzendorf",
                        "latitude": "52.21308000",
                        "longitude": "11.56174000"
                    },
                    {
                        "id": 27422,
                        "name": "Merseburg",
                        "latitude": "51.35478000",
                        "longitude": "11.98923000"
                    },
                    {
                        "id": 27462,
                        "name": "Mieste",
                        "latitude": "52.48226000",
                        "longitude": "11.20640000"
                    },
                    {
                        "id": 27555,
                        "name": "Möckern",
                        "latitude": "52.14099000",
                        "longitude": "11.95203000"
                    },
                    {
                        "id": 27560,
                        "name": "Möhlau",
                        "latitude": "51.73126000",
                        "longitude": "12.35282000"
                    },
                    {
                        "id": 27578,
                        "name": "Möser",
                        "latitude": "52.21397000",
                        "longitude": "11.79279000"
                    },
                    {
                        "id": 27583,
                        "name": "Mücheln",
                        "latitude": "51.29688000",
                        "longitude": "11.80759000"
                    },
                    {
                        "id": 27590,
                        "name": "Mühlanger",
                        "latitude": "51.85000000",
                        "longitude": "12.75000000"
                    },
                    {
                        "id": 27536,
                        "name": "Muldenstein",
                        "latitude": "51.67192000",
                        "longitude": "12.34548000"
                    },
                    {
                        "id": 27548,
                        "name": "Muschwitz",
                        "latitude": "51.19296000",
                        "longitude": "12.12065000"
                    },
                    {
                        "id": 27632,
                        "name": "Nachterstedt",
                        "latitude": "51.80081000",
                        "longitude": "11.33489000"
                    },
                    {
                        "id": 27648,
                        "name": "Nauendorf",
                        "latitude": "51.60178000",
                        "longitude": "11.88525000"
                    },
                    {
                        "id": 27649,
                        "name": "Naumburg",
                        "latitude": "51.14987000",
                        "longitude": "11.80979000"
                    },
                    {
                        "id": 27657,
                        "name": "Nebra",
                        "latitude": "51.28810000",
                        "longitude": "11.57749000"
                    },
                    {
                        "id": 27671,
                        "name": "Neinstedt",
                        "latitude": "51.74950000",
                        "longitude": "11.08721000"
                    },
                    {
                        "id": 27681,
                        "name": "Nessa",
                        "latitude": "51.14565000",
                        "longitude": "12.00874000"
                    },
                    {
                        "id": 27715,
                        "name": "Neue Neustadt",
                        "latitude": "52.15000000",
                        "longitude": "11.63333000"
                    },
                    {
                        "id": 27776,
                        "name": "Neundorf",
                        "latitude": "51.82080000",
                        "longitude": "11.57484000"
                    },
                    {
                        "id": 27861,
                        "name": "Niederndodeleben",
                        "latitude": "52.13416000",
                        "longitude": "11.50085000"
                    },
                    {
                        "id": 27890,
                        "name": "Niemberg",
                        "latitude": "51.55035000",
                        "longitude": "12.09089000"
                    },
                    {
                        "id": 27893,
                        "name": "Nienburg\/Saale",
                        "latitude": "51.83747000",
                        "longitude": "11.76979000"
                    },
                    {
                        "id": 27939,
                        "name": "Nudersdorf",
                        "latitude": "51.93025000",
                        "longitude": "12.59554000"
                    },
                    {
                        "id": 28027,
                        "name": "Oberröblingen",
                        "latitude": "51.43705000",
                        "longitude": "11.30750000"
                    },
                    {
                        "id": 28058,
                        "name": "Obhausen",
                        "latitude": "51.39172000",
                        "longitude": "11.65312000"
                    },
                    {
                        "id": 28072,
                        "name": "Oebisfelde",
                        "latitude": "52.43421000",
                        "longitude": "10.98786000"
                    },
                    {
                        "id": 28121,
                        "name": "Oppin",
                        "latitude": "51.55136000",
                        "longitude": "12.03274000"
                    },
                    {
                        "id": 28123,
                        "name": "Oranienbaum",
                        "latitude": "51.79860000",
                        "longitude": "12.40583000"
                    },
                    {
                        "id": 28137,
                        "name": "Oschersleben",
                        "latitude": "52.03039000",
                        "longitude": "11.22898000"
                    },
                    {
                        "id": 28147,
                        "name": "Osterburg",
                        "latitude": "52.78721000",
                        "longitude": "11.75297000"
                    },
                    {
                        "id": 28150,
                        "name": "Osterfeld",
                        "latitude": "51.08014000",
                        "longitude": "11.93047000"
                    },
                    {
                        "id": 28151,
                        "name": "Osterhausen",
                        "latitude": "51.45417000",
                        "longitude": "11.50456000"
                    },
                    {
                        "id": 28154,
                        "name": "Osternienburg",
                        "latitude": "51.79384000",
                        "longitude": "12.02616000"
                    },
                    {
                        "id": 28155,
                        "name": "Osternienburger Land",
                        "latitude": "51.80000000",
                        "longitude": "12.01667000"
                    },
                    {
                        "id": 28159,
                        "name": "Osterwieck",
                        "latitude": "51.96990000",
                        "longitude": "10.71042000"
                    },
                    {
                        "id": 28245,
                        "name": "Peißen",
                        "latitude": "51.74347000",
                        "longitude": "11.75756000"
                    },
                    {
                        "id": 28301,
                        "name": "Piesteritz",
                        "latitude": "51.86956000",
                        "longitude": "12.59835000"
                    },
                    {
                        "id": 28332,
                        "name": "Plötzkau",
                        "latitude": "51.75000000",
                        "longitude": "11.68333000"
                    },
                    {
                        "id": 28333,
                        "name": "Plötzky",
                        "latitude": "52.05207000",
                        "longitude": "11.80202000"
                    },
                    {
                        "id": 28344,
                        "name": "Polleben",
                        "latitude": "51.57966000",
                        "longitude": "11.59931000"
                    },
                    {
                        "id": 28365,
                        "name": "Pouch",
                        "latitude": "51.62324000",
                        "longitude": "12.40133000"
                    },
                    {
                        "id": 28369,
                        "name": "Pratau",
                        "latitude": "51.84226000",
                        "longitude": "12.64373000"
                    },
                    {
                        "id": 28379,
                        "name": "Prettin",
                        "latitude": "51.66077000",
                        "longitude": "12.92353000"
                    },
                    {
                        "id": 28381,
                        "name": "Pretzier",
                        "latitude": "52.83224000",
                        "longitude": "11.26105000"
                    },
                    {
                        "id": 28382,
                        "name": "Pretzsch",
                        "latitude": "51.71466000",
                        "longitude": "12.80663000"
                    },
                    {
                        "id": 28390,
                        "name": "Prittitz",
                        "latitude": "51.14996000",
                        "longitude": "11.93020000"
                    },
                    {
                        "id": 28426,
                        "name": "Quedlinburg",
                        "latitude": "51.78843000",
                        "longitude": "11.15006000"
                    },
                    {
                        "id": 28428,
                        "name": "Queis",
                        "latitude": "51.47626000",
                        "longitude": "12.13455000"
                    },
                    {
                        "id": 28429,
                        "name": "Quellendorf",
                        "latitude": "51.74916000",
                        "longitude": "12.12796000"
                    },
                    {
                        "id": 28430,
                        "name": "Querfurt",
                        "latitude": "51.38124000",
                        "longitude": "11.60047000"
                    },
                    {
                        "id": 28444,
                        "name": "Radegast",
                        "latitude": "51.65654000",
                        "longitude": "12.09485000"
                    },
                    {
                        "id": 28447,
                        "name": "Radis",
                        "latitude": "51.75226000",
                        "longitude": "12.51453000"
                    },
                    {
                        "id": 28450,
                        "name": "Raguhn",
                        "latitude": "51.71167000",
                        "longitude": "12.27531000"
                    },
                    {
                        "id": 28466,
                        "name": "Ramsin",
                        "latitude": "51.61095000",
                        "longitude": "12.23812000"
                    },
                    {
                        "id": 28499,
                        "name": "Raßnitz",
                        "latitude": "51.39085000",
                        "longitude": "12.09406000"
                    },
                    {
                        "id": 28535,
                        "name": "Reichardtswerben",
                        "latitude": "51.24851000",
                        "longitude": "11.95349000"
                    },
                    {
                        "id": 28597,
                        "name": "Reußen",
                        "latitude": "51.50109000",
                        "longitude": "12.13044000"
                    },
                    {
                        "id": 28633,
                        "name": "Rieder",
                        "latitude": "51.73333000",
                        "longitude": "11.16667000"
                    },
                    {
                        "id": 28649,
                        "name": "Riestedt",
                        "latitude": "51.49496000",
                        "longitude": "11.36023000"
                    },
                    {
                        "id": 28774,
                        "name": "Röblingen am See",
                        "latitude": "51.45944000",
                        "longitude": "11.68231000"
                    },
                    {
                        "id": 28681,
                        "name": "Rodleben",
                        "latitude": "51.89607000",
                        "longitude": "12.20061000"
                    },
                    {
                        "id": 28686,
                        "name": "Rogätz",
                        "latitude": "52.31667000",
                        "longitude": "11.76667000"
                    },
                    {
                        "id": 28695,
                        "name": "Roitzsch",
                        "latitude": "51.57526000",
                        "longitude": "12.26331000"
                    },
                    {
                        "id": 28743,
                        "name": "Roßla",
                        "latitude": "51.46331000",
                        "longitude": "11.07576000"
                    },
                    {
                        "id": 28744,
                        "name": "Roßlau",
                        "latitude": "51.88736000",
                        "longitude": "12.24192000"
                    },
                    {
                        "id": 28738,
                        "name": "Rottleberode",
                        "latitude": "51.51636000",
                        "longitude": "10.94658000"
                    },
                    {
                        "id": 28797,
                        "name": "Rübeland",
                        "latitude": "51.75591000",
                        "longitude": "10.84660000"
                    },
                    {
                        "id": 28843,
                        "name": "Salzmünde",
                        "latitude": "51.52662000",
                        "longitude": "11.82650000"
                    },
                    {
                        "id": 28844,
                        "name": "Salzwedel",
                        "latitude": "52.85435000",
                        "longitude": "11.15250000"
                    },
                    {
                        "id": 28847,
                        "name": "Samswegen",
                        "latitude": "52.26059000",
                        "longitude": "11.56174000"
                    },
                    {
                        "id": 28850,
                        "name": "Sandau",
                        "latitude": "52.78968000",
                        "longitude": "12.04582000"
                    },
                    {
                        "id": 28853,
                        "name": "Sandersdorf",
                        "latitude": "51.62841000",
                        "longitude": "12.26492000"
                    },
                    {
                        "id": 28854,
                        "name": "Sandersleben",
                        "latitude": "51.67745000",
                        "longitude": "11.56795000"
                    },
                    {
                        "id": 28858,
                        "name": "Sangerhausen",
                        "latitude": "51.47221000",
                        "longitude": "11.29533000"
                    },
                    {
                        "id": 28905,
                        "name": "Schafstädt",
                        "latitude": "51.38131000",
                        "longitude": "11.77302000"
                    },
                    {
                        "id": 28933,
                        "name": "Schermen",
                        "latitude": "52.23206000",
                        "longitude": "11.81382000"
                    },
                    {
                        "id": 28956,
                        "name": "Schkopau",
                        "latitude": "51.39186000",
                        "longitude": "11.95224000"
                    },
                    {
                        "id": 28961,
                        "name": "Schlaitz",
                        "latitude": "51.65871000",
                        "longitude": "12.42839000"
                    },
                    {
                        "id": 29006,
                        "name": "Schneidlingen",
                        "latitude": "51.89454000",
                        "longitude": "11.44487000"
                    },
                    {
                        "id": 29012,
                        "name": "Schochwitz",
                        "latitude": "51.53174000",
                        "longitude": "11.75485000"
                    },
                    {
                        "id": 29114,
                        "name": "Schönburg",
                        "latitude": "51.16667000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 29115,
                        "name": "Schönebeck",
                        "latitude": "52.01682000",
                        "longitude": "11.73070000"
                    },
                    {
                        "id": 29125,
                        "name": "Schönhausen",
                        "latitude": "52.58076000",
                        "longitude": "12.03923000"
                    },
                    {
                        "id": 29029,
                        "name": "Schraplau",
                        "latitude": "51.43750000",
                        "longitude": "11.66823000"
                    },
                    {
                        "id": 29058,
                        "name": "Schwanebeck",
                        "latitude": "51.96790000",
                        "longitude": "11.12393000"
                    },
                    {
                        "id": 29152,
                        "name": "Seehausen",
                        "latitude": "52.88872000",
                        "longitude": "11.75236000"
                    },
                    {
                        "id": 29193,
                        "name": "Sennewitz",
                        "latitude": "51.54326000",
                        "longitude": "11.95218000"
                    },
                    {
                        "id": 29203,
                        "name": "Seyda",
                        "latitude": "51.88163000",
                        "longitude": "12.90812000"
                    },
                    {
                        "id": 29222,
                        "name": "Siersleben",
                        "latitude": "51.60411000",
                        "longitude": "11.54334000"
                    },
                    {
                        "id": 29267,
                        "name": "Sommersdorf",
                        "latitude": "52.16667000",
                        "longitude": "11.08333000"
                    },
                    {
                        "id": 29298,
                        "name": "Spergau",
                        "latitude": "51.29347000",
                        "longitude": "12.02292000"
                    },
                    {
                        "id": 29339,
                        "name": "Stapelburg",
                        "latitude": "51.90075000",
                        "longitude": "10.66240000"
                    },
                    {
                        "id": 29347,
                        "name": "Staßfurt",
                        "latitude": "51.85186000",
                        "longitude": "11.58508000"
                    },
                    {
                        "id": 29349,
                        "name": "Stedten",
                        "latitude": "51.44308000",
                        "longitude": "11.69291000"
                    },
                    {
                        "id": 29398,
                        "name": "Stendal",
                        "latitude": "52.60690000",
                        "longitude": "11.85867000"
                    },
                    {
                        "id": 29415,
                        "name": "Stolberg",
                        "latitude": "51.57426000",
                        "longitude": "10.95582000"
                    },
                    {
                        "id": 29454,
                        "name": "Stößen",
                        "latitude": "51.11440000",
                        "longitude": "11.92405000"
                    },
                    {
                        "id": 29440,
                        "name": "Ströbeck",
                        "latitude": "51.91406000",
                        "longitude": "10.94445000"
                    },
                    {
                        "id": 29505,
                        "name": "Süplingen",
                        "latitude": "52.28759000",
                        "longitude": "11.32450000"
                    },
                    {
                        "id": 29517,
                        "name": "Tangerhütte",
                        "latitude": "52.43530000",
                        "longitude": "11.80724000"
                    },
                    {
                        "id": 29518,
                        "name": "Tangermünde",
                        "latitude": "52.54463000",
                        "longitude": "11.97647000"
                    },
                    {
                        "id": 29546,
                        "name": "Teicha",
                        "latitude": "51.55887000",
                        "longitude": "11.95482000"
                    },
                    {
                        "id": 29567,
                        "name": "Teuchel",
                        "latitude": "51.88842000",
                        "longitude": "12.64587000"
                    },
                    {
                        "id": 29568,
                        "name": "Teuchern",
                        "latitude": "51.12094000",
                        "longitude": "12.02410000"
                    },
                    {
                        "id": 29573,
                        "name": "Teutschenthal",
                        "latitude": "51.45000000",
                        "longitude": "11.80000000"
                    },
                    {
                        "id": 29575,
                        "name": "Thale",
                        "latitude": "51.74861000",
                        "longitude": "11.04100000"
                    },
                    {
                        "id": 29578,
                        "name": "Thalheim",
                        "latitude": "51.65268000",
                        "longitude": "12.22756000"
                    },
                    {
                        "id": 29589,
                        "name": "Theißen",
                        "latitude": "51.08748000",
                        "longitude": "12.10659000"
                    },
                    {
                        "id": 29615,
                        "name": "Timmenrode",
                        "latitude": "51.77113000",
                        "longitude": "11.00624000"
                    },
                    {
                        "id": 29630,
                        "name": "Tollwitz",
                        "latitude": "51.28601000",
                        "longitude": "12.09733000"
                    },
                    {
                        "id": 29651,
                        "name": "Trebitz",
                        "latitude": "51.58615000",
                        "longitude": "11.91965000"
                    },
                    {
                        "id": 29688,
                        "name": "Tucheim",
                        "latitude": "52.28923000",
                        "longitude": "12.18423000"
                    },
                    {
                        "id": 29714,
                        "name": "Uchtspringe",
                        "latitude": "52.54011000",
                        "longitude": "11.59959000"
                    },
                    {
                        "id": 29726,
                        "name": "Uenglingen",
                        "latitude": "52.61797000",
                        "longitude": "11.80893000"
                    },
                    {
                        "id": 29732,
                        "name": "Uftrungen",
                        "latitude": "51.49859000",
                        "longitude": "10.98066000"
                    },
                    {
                        "id": 29736,
                        "name": "Uichteritz",
                        "latitude": "51.20652000",
                        "longitude": "11.92215000"
                    },
                    {
                        "id": 29741,
                        "name": "Ummendorf",
                        "latitude": "52.15645000",
                        "longitude": "11.18151000"
                    },
                    {
                        "id": 29750,
                        "name": "Unseburg",
                        "latitude": "51.93284000",
                        "longitude": "11.51281000"
                    },
                    {
                        "id": 29818,
                        "name": "Veckenstedt",
                        "latitude": "51.90113000",
                        "longitude": "10.73203000"
                    },
                    {
                        "id": 29864,
                        "name": "Vockerode",
                        "latitude": "51.84698000",
                        "longitude": "12.35208000"
                    },
                    {
                        "id": 29876,
                        "name": "Volkstedt",
                        "latitude": "51.56267000",
                        "longitude": "11.55658000"
                    },
                    {
                        "id": 29893,
                        "name": "Völpke",
                        "latitude": "52.13865000",
                        "longitude": "11.09877000"
                    },
                    {
                        "id": 29918,
                        "name": "Wahlitz",
                        "latitude": "52.10376000",
                        "longitude": "11.77947000"
                    },
                    {
                        "id": 29974,
                        "name": "Wallendorf",
                        "latitude": "51.35983000",
                        "longitude": "12.07537000"
                    },
                    {
                        "id": 29983,
                        "name": "Wallhausen",
                        "latitude": "51.46117000",
                        "longitude": "11.20760000"
                    },
                    {
                        "id": 29989,
                        "name": "Wallwitz",
                        "latitude": "51.58029000",
                        "longitude": "11.92888000"
                    },
                    {
                        "id": 30010,
                        "name": "Wansleben",
                        "latitude": "51.46034000",
                        "longitude": "11.75135000"
                    },
                    {
                        "id": 30011,
                        "name": "Wanzleben",
                        "latitude": "52.06087000",
                        "longitude": "11.44080000"
                    },
                    {
                        "id": 30034,
                        "name": "Wasserleben",
                        "latitude": "51.92089000",
                        "longitude": "10.75670000"
                    },
                    {
                        "id": 30047,
                        "name": "Weddersleben",
                        "latitude": "51.76533000",
                        "longitude": "11.08531000"
                    },
                    {
                        "id": 30054,
                        "name": "Wefensleben",
                        "latitude": "52.18319000",
                        "longitude": "11.16074000"
                    },
                    {
                        "id": 30055,
                        "name": "Weferlingen",
                        "latitude": "52.31205000",
                        "longitude": "11.05791000"
                    },
                    {
                        "id": 30057,
                        "name": "Wegeleben",
                        "latitude": "51.88376000",
                        "longitude": "11.17347000"
                    },
                    {
                        "id": 30121,
                        "name": "Weißandt-Gölzau",
                        "latitude": "51.67070000",
                        "longitude": "12.07338000"
                    },
                    {
                        "id": 30130,
                        "name": "Weißenfels",
                        "latitude": "51.20148000",
                        "longitude": "11.96843000"
                    },
                    {
                        "id": 30143,
                        "name": "Wellen",
                        "latitude": "52.14518000",
                        "longitude": "11.44106000"
                    },
                    {
                        "id": 30147,
                        "name": "Welsleben",
                        "latitude": "52.00304000",
                        "longitude": "11.63851000"
                    },
                    {
                        "id": 30184,
                        "name": "Wernigerode",
                        "latitude": "51.83652000",
                        "longitude": "10.78216000"
                    },
                    {
                        "id": 30205,
                        "name": "Westeregeln",
                        "latitude": "51.96328000",
                        "longitude": "11.39265000"
                    },
                    {
                        "id": 30207,
                        "name": "Westerhausen",
                        "latitude": "51.80566000",
                        "longitude": "11.05631000"
                    },
                    {
                        "id": 30226,
                        "name": "Wetterzeube",
                        "latitude": "51.00000000",
                        "longitude": "12.01667000"
                    },
                    {
                        "id": 30227,
                        "name": "Wettin",
                        "latitude": "51.58604000",
                        "longitude": "11.80630000"
                    },
                    {
                        "id": 30242,
                        "name": "Wiederstedt",
                        "latitude": "51.66526000",
                        "longitude": "11.52723000"
                    },
                    {
                        "id": 30307,
                        "name": "Wimmelburg",
                        "latitude": "51.52069000",
                        "longitude": "11.50696000"
                    },
                    {
                        "id": 30340,
                        "name": "Wippra",
                        "latitude": "51.57300000",
                        "longitude": "11.27498000"
                    },
                    {
                        "id": 30351,
                        "name": "Wittenberg",
                        "latitude": "51.86610000",
                        "longitude": "12.64973000"
                    },
                    {
                        "id": 30376,
                        "name": "Wolfen",
                        "latitude": "51.66122000",
                        "longitude": "12.26873000"
                    },
                    {
                        "id": 30378,
                        "name": "Wolferode",
                        "latitude": "51.50650000",
                        "longitude": "11.51299000"
                    },
                    {
                        "id": 30394,
                        "name": "Wolmirsleben",
                        "latitude": "51.95000000",
                        "longitude": "11.48333000"
                    },
                    {
                        "id": 30395,
                        "name": "Wolmirstedt",
                        "latitude": "52.24856000",
                        "longitude": "11.62945000"
                    },
                    {
                        "id": 30443,
                        "name": "Wörlitz",
                        "latitude": "51.84172000",
                        "longitude": "12.42116000"
                    },
                    {
                        "id": 30413,
                        "name": "Wulfen",
                        "latitude": "51.81938000",
                        "longitude": "11.93063000"
                    },
                    {
                        "id": 30465,
                        "name": "Zahna",
                        "latitude": "51.91410000",
                        "longitude": "12.78561000"
                    },
                    {
                        "id": 30470,
                        "name": "Zappendorf",
                        "latitude": "51.51024000",
                        "longitude": "11.79514000"
                    },
                    {
                        "id": 30482,
                        "name": "Zeitz",
                        "latitude": "51.04962000",
                        "longitude": "12.13690000"
                    },
                    {
                        "id": 30494,
                        "name": "Zerbst",
                        "latitude": "51.96620000",
                        "longitude": "12.08517000"
                    },
                    {
                        "id": 30501,
                        "name": "Zielitz",
                        "latitude": "52.28958000",
                        "longitude": "11.67572000"
                    },
                    {
                        "id": 30542,
                        "name": "Zörbig",
                        "latitude": "51.62894000",
                        "longitude": "12.11740000"
                    },
                    {
                        "id": 30543,
                        "name": "Zöschen",
                        "latitude": "51.35802000",
                        "longitude": "12.11652000"
                    },
                    {
                        "id": 30520,
                        "name": "Zscherben",
                        "latitude": "51.46709000",
                        "longitude": "11.87058000"
                    },
                    {
                        "id": 30521,
                        "name": "Zscherndorf",
                        "latitude": "51.61087000",
                        "longitude": "12.26755000"
                    },
                    {
                        "id": 30524,
                        "name": "Zschornewitz",
                        "latitude": "51.71585000",
                        "longitude": "12.39998000"
                    }
                ]
            },
            {
                "id": 3005,
                "name": "Schleswig-Holstein",
                "iso2": "SH",
                "latitude": "54.21936720",
                "longitude": "9.69611670",
                "type": "land",
                "cities": [
                    {
                        "id": 23476,
                        "name": "Achtrup",
                        "latitude": "54.79053000",
                        "longitude": "9.02848000"
                    },
                    {
                        "id": 23514,
                        "name": "Ahrensbök",
                        "latitude": "54.00862000",
                        "longitude": "10.57434000"
                    },
                    {
                        "id": 23513,
                        "name": "Ahrensburg",
                        "latitude": "53.67515000",
                        "longitude": "10.22593000"
                    },
                    {
                        "id": 23533,
                        "name": "Albersdorf",
                        "latitude": "54.15000000",
                        "longitude": "9.28333000"
                    },
                    {
                        "id": 23575,
                        "name": "Alt Duvenstedt",
                        "latitude": "54.36667000",
                        "longitude": "9.65000000"
                    },
                    {
                        "id": 23603,
                        "name": "Altenholz",
                        "latitude": "54.40000000",
                        "longitude": "10.13333000"
                    },
                    {
                        "id": 23606,
                        "name": "Altenkrempe",
                        "latitude": "54.13333000",
                        "longitude": "10.83333000"
                    },
                    {
                        "id": 23640,
                        "name": "Alveslohe",
                        "latitude": "53.78333000",
                        "longitude": "9.91667000"
                    },
                    {
                        "id": 23677,
                        "name": "Appen",
                        "latitude": "53.65813000",
                        "longitude": "9.74582000"
                    },
                    {
                        "id": 23706,
                        "name": "Ascheberg",
                        "latitude": "54.15027000",
                        "longitude": "10.34552000"
                    },
                    {
                        "id": 23736,
                        "name": "Aukrug",
                        "latitude": "54.08333000",
                        "longitude": "9.78333000"
                    },
                    {
                        "id": 23776,
                        "name": "Bad Bramstedt",
                        "latitude": "53.91830000",
                        "longitude": "9.88424000"
                    },
                    {
                        "id": 23845,
                        "name": "Bad Oldesloe",
                        "latitude": "53.81167000",
                        "longitude": "10.37417000"
                    },
                    {
                        "id": 23865,
                        "name": "Bad Schwartau",
                        "latitude": "53.91887000",
                        "longitude": "10.69691000"
                    },
                    {
                        "id": 23866,
                        "name": "Bad Segeberg",
                        "latitude": "53.94313000",
                        "longitude": "10.30215000"
                    },
                    {
                        "id": 23930,
                        "name": "Bargfeld-Stegen",
                        "latitude": "53.76778000",
                        "longitude": "10.18750000"
                    },
                    {
                        "id": 23932,
                        "name": "Bargteheide",
                        "latitude": "53.72856000",
                        "longitude": "10.26695000"
                    },
                    {
                        "id": 23933,
                        "name": "Bark",
                        "latitude": "53.91146000",
                        "longitude": "10.17949000"
                    },
                    {
                        "id": 23934,
                        "name": "Barkelsby",
                        "latitude": "54.50000000",
                        "longitude": "9.83333000"
                    },
                    {
                        "id": 23937,
                        "name": "Barmstedt",
                        "latitude": "53.79209000",
                        "longitude": "9.76739000"
                    },
                    {
                        "id": 23941,
                        "name": "Barsbüttel",
                        "latitude": "53.56667000",
                        "longitude": "10.16667000"
                    },
                    {
                        "id": 24051,
                        "name": "Berkenthin",
                        "latitude": "53.73333000",
                        "longitude": "10.65000000"
                    },
                    {
                        "id": 24178,
                        "name": "Blekendorf",
                        "latitude": "54.28211000",
                        "longitude": "10.65820000"
                    },
                    {
                        "id": 24220,
                        "name": "Bokholt-Hanredder",
                        "latitude": "53.78808000",
                        "longitude": "9.73586000"
                    },
                    {
                        "id": 24225,
                        "name": "Bollingstedt",
                        "latitude": "54.59229000",
                        "longitude": "9.41738000"
                    },
                    {
                        "id": 24468,
                        "name": "Bönebüttel",
                        "latitude": "54.08333000",
                        "longitude": "10.06667000"
                    },
                    {
                        "id": 24471,
                        "name": "Bönningstedt",
                        "latitude": "53.66667000",
                        "longitude": "9.91667000"
                    },
                    {
                        "id": 24235,
                        "name": "Boostedt",
                        "latitude": "54.01667000",
                        "longitude": "10.03333000"
                    },
                    {
                        "id": 24238,
                        "name": "Bordelum",
                        "latitude": "54.63333000",
                        "longitude": "8.93333000"
                    },
                    {
                        "id": 24239,
                        "name": "Bordesholm",
                        "latitude": "54.17611000",
                        "longitude": "10.03146000"
                    },
                    {
                        "id": 24243,
                        "name": "Borgstedt",
                        "latitude": "54.33268000",
                        "longitude": "9.70954000"
                    },
                    {
                        "id": 24254,
                        "name": "Bornhöved",
                        "latitude": "54.06667000",
                        "longitude": "10.23333000"
                    },
                    {
                        "id": 24475,
                        "name": "Börnsen",
                        "latitude": "53.47620000",
                        "longitude": "10.28160000"
                    },
                    {
                        "id": 24259,
                        "name": "Borstel-Hohenraden",
                        "latitude": "53.68333000",
                        "longitude": "9.81667000"
                    },
                    {
                        "id": 24261,
                        "name": "Bosau",
                        "latitude": "54.09787000",
                        "longitude": "10.43570000"
                    },
                    {
                        "id": 24478,
                        "name": "Bösdorf",
                        "latitude": "54.15000000",
                        "longitude": "10.48333000"
                    },
                    {
                        "id": 24265,
                        "name": "Bovenau",
                        "latitude": "54.33333000",
                        "longitude": "9.83333000"
                    },
                    {
                        "id": 24279,
                        "name": "Brande-Hörnerkirchen",
                        "latitude": "53.85000000",
                        "longitude": "9.71667000"
                    },
                    {
                        "id": 24295,
                        "name": "Bredenbek",
                        "latitude": "54.32247000",
                        "longitude": "9.87293000"
                    },
                    {
                        "id": 24296,
                        "name": "Bredstedt",
                        "latitude": "54.61868000",
                        "longitude": "8.96441000"
                    },
                    {
                        "id": 24301,
                        "name": "Breiholz",
                        "latitude": "54.20554000",
                        "longitude": "9.52371000"
                    },
                    {
                        "id": 24309,
                        "name": "Breitenburg",
                        "latitude": "53.90572000",
                        "longitude": "9.57041000"
                    },
                    {
                        "id": 24310,
                        "name": "Breitenfelde",
                        "latitude": "53.60592000",
                        "longitude": "10.63339000"
                    },
                    {
                        "id": 24318,
                        "name": "Brekendorf",
                        "latitude": "54.42120000",
                        "longitude": "9.63350000"
                    },
                    {
                        "id": 24319,
                        "name": "Breklum",
                        "latitude": "54.60000000",
                        "longitude": "8.98333000"
                    },
                    {
                        "id": 24343,
                        "name": "Brokdorf",
                        "latitude": "53.86380000",
                        "longitude": "9.32314000"
                    },
                    {
                        "id": 24344,
                        "name": "Brokstedt",
                        "latitude": "53.98333000",
                        "longitude": "9.81667000"
                    },
                    {
                        "id": 24368,
                        "name": "Brügge",
                        "latitude": "54.17578000",
                        "longitude": "10.06913000"
                    },
                    {
                        "id": 24362,
                        "name": "Brunsbüttel",
                        "latitude": "53.89504000",
                        "longitude": "9.10484000"
                    },
                    {
                        "id": 24486,
                        "name": "Büchen",
                        "latitude": "53.48008000",
                        "longitude": "10.61760000"
                    },
                    {
                        "id": 24391,
                        "name": "Buchholz",
                        "latitude": "53.98829000",
                        "longitude": "9.22362000"
                    },
                    {
                        "id": 24493,
                        "name": "Büdelsdorf",
                        "latitude": "54.31844000",
                        "longitude": "9.67295000"
                    },
                    {
                        "id": 24407,
                        "name": "Burg",
                        "latitude": "53.99708000",
                        "longitude": "9.25891000"
                    },
                    {
                        "id": 24409,
                        "name": "Burg auf Fehmarn",
                        "latitude": "54.43333000",
                        "longitude": "11.20000000"
                    },
                    {
                        "id": 24447,
                        "name": "Busdorf",
                        "latitude": "54.10345000",
                        "longitude": "10.08242000"
                    },
                    {
                        "id": 24506,
                        "name": "Büsum",
                        "latitude": "54.13398000",
                        "longitude": "8.85756000"
                    },
                    {
                        "id": 24790,
                        "name": "Dägeling",
                        "latitude": "53.88333000",
                        "longitude": "9.53333000"
                    },
                    {
                        "id": 24582,
                        "name": "Dahme",
                        "latitude": "54.21667000",
                        "longitude": "11.08333000"
                    },
                    {
                        "id": 24589,
                        "name": "Damp",
                        "latitude": "54.58469000",
                        "longitude": "10.01785000"
                    },
                    {
                        "id": 24791,
                        "name": "Dänischenhagen",
                        "latitude": "54.42775000",
                        "longitude": "10.12596000"
                    },
                    {
                        "id": 24593,
                        "name": "Dannewerk",
                        "latitude": "54.48333000",
                        "longitude": "9.50000000"
                    },
                    {
                        "id": 24600,
                        "name": "Dassendorf",
                        "latitude": "53.49532000",
                        "longitude": "10.35987000"
                    },
                    {
                        "id": 24622,
                        "name": "Delingsdorf",
                        "latitude": "53.70000000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 24715,
                        "name": "Dobersdorf",
                        "latitude": "54.31893000",
                        "longitude": "10.28011000"
                    },
                    {
                        "id": 24723,
                        "name": "Dollerup",
                        "latitude": "54.77798000",
                        "longitude": "9.67981000"
                    },
                    {
                        "id": 24765,
                        "name": "Drelsdorf",
                        "latitude": "54.60548000",
                        "longitude": "9.04449000"
                    },
                    {
                        "id": 24849,
                        "name": "Eckernförde",
                        "latitude": "54.46854000",
                        "longitude": "9.83824000"
                    },
                    {
                        "id": 24851,
                        "name": "Eddelak",
                        "latitude": "53.95000000",
                        "longitude": "9.15000000"
                    },
                    {
                        "id": 24871,
                        "name": "Eggebek",
                        "latitude": "54.61667000",
                        "longitude": "9.36667000"
                    },
                    {
                        "id": 24948,
                        "name": "Ellerau",
                        "latitude": "53.75000000",
                        "longitude": "9.91667000"
                    },
                    {
                        "id": 24949,
                        "name": "Ellerbek",
                        "latitude": "53.65817000",
                        "longitude": "9.86991000"
                    },
                    {
                        "id": 24950,
                        "name": "Ellerhoop",
                        "latitude": "53.72603000",
                        "longitude": "9.76933000"
                    },
                    {
                        "id": 24958,
                        "name": "Elmenhorst",
                        "latitude": "53.76667000",
                        "longitude": "10.26667000"
                    },
                    {
                        "id": 24960,
                        "name": "Elmshorn",
                        "latitude": "53.75396000",
                        "longitude": "9.65339000"
                    },
                    {
                        "id": 24964,
                        "name": "Elsdorf-Westermühlen",
                        "latitude": "54.26667000",
                        "longitude": "9.51667000"
                    },
                    {
                        "id": 24984,
                        "name": "Emkendorf",
                        "latitude": "54.26667000",
                        "longitude": "9.85000000"
                    },
                    {
                        "id": 24986,
                        "name": "Emmelsbüll-Horsbüll",
                        "latitude": "54.81667000",
                        "longitude": "8.70000000"
                    },
                    {
                        "id": 25036,
                        "name": "Erfde",
                        "latitude": "54.30000000",
                        "longitude": "9.31667000"
                    },
                    {
                        "id": 25077,
                        "name": "Escheburg",
                        "latitude": "53.46667000",
                        "longitude": "10.31667000"
                    },
                    {
                        "id": 25117,
                        "name": "Eutin",
                        "latitude": "54.14054000",
                        "longitude": "10.60751000"
                    },
                    {
                        "id": 25126,
                        "name": "Fahrdorf",
                        "latitude": "54.50000000",
                        "longitude": "9.60000000"
                    },
                    {
                        "id": 25128,
                        "name": "Fahrenkrug",
                        "latitude": "53.95000000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 25148,
                        "name": "Fehmarn",
                        "latitude": "54.43780000",
                        "longitude": "11.19352000"
                    },
                    {
                        "id": 25154,
                        "name": "Felde",
                        "latitude": "54.30000000",
                        "longitude": "9.93333000"
                    },
                    {
                        "id": 25161,
                        "name": "Felm",
                        "latitude": "54.41667000",
                        "longitude": "10.05000000"
                    },
                    {
                        "id": 25187,
                        "name": "Fleckeby",
                        "latitude": "54.48333000",
                        "longitude": "9.70000000"
                    },
                    {
                        "id": 25189,
                        "name": "Flensburg",
                        "latitude": "54.78431000",
                        "longitude": "9.43961000"
                    },
                    {
                        "id": 25192,
                        "name": "Flintbek",
                        "latitude": "54.25000000",
                        "longitude": "10.06667000"
                    },
                    {
                        "id": 25202,
                        "name": "Fockbek",
                        "latitude": "54.30000000",
                        "longitude": "9.60000000"
                    },
                    {
                        "id": 25245,
                        "name": "Freienwill",
                        "latitude": "54.72752000",
                        "longitude": "9.49414000"
                    },
                    {
                        "id": 25291,
                        "name": "Friedrichskoog",
                        "latitude": "54.01667000",
                        "longitude": "8.91667000"
                    },
                    {
                        "id": 25293,
                        "name": "Friedrichstadt",
                        "latitude": "54.37566000",
                        "longitude": "9.08672000"
                    },
                    {
                        "id": 25365,
                        "name": "Garding",
                        "latitude": "54.33056000",
                        "longitude": "8.78056000"
                    },
                    {
                        "id": 25390,
                        "name": "Geesthacht",
                        "latitude": "53.43575000",
                        "longitude": "10.37790000"
                    },
                    {
                        "id": 25418,
                        "name": "Gelting",
                        "latitude": "54.75000000",
                        "longitude": "9.90000000"
                    },
                    {
                        "id": 25476,
                        "name": "Gettorf",
                        "latitude": "54.40000000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 25482,
                        "name": "Giekau",
                        "latitude": "54.31667000",
                        "longitude": "10.51667000"
                    },
                    {
                        "id": 25513,
                        "name": "Glinde",
                        "latitude": "53.54410000",
                        "longitude": "10.20048000"
                    },
                    {
                        "id": 25519,
                        "name": "Glücksburg",
                        "latitude": "54.83522000",
                        "longitude": "9.54853000"
                    },
                    {
                        "id": 25520,
                        "name": "Glückstadt",
                        "latitude": "53.78893000",
                        "longitude": "9.42576000"
                    },
                    {
                        "id": 25524,
                        "name": "Gnutz",
                        "latitude": "54.13333000",
                        "longitude": "9.81667000"
                    },
                    {
                        "id": 25527,
                        "name": "Goel",
                        "latitude": "54.28350000",
                        "longitude": "10.94036000"
                    },
                    {
                        "id": 25586,
                        "name": "Grebin",
                        "latitude": "54.20000000",
                        "longitude": "10.50000000"
                    },
                    {
                        "id": 25597,
                        "name": "Gremersdorf",
                        "latitude": "54.33333000",
                        "longitude": "10.93333000"
                    },
                    {
                        "id": 25731,
                        "name": "Grömitz",
                        "latitude": "54.15000000",
                        "longitude": "10.96667000"
                    },
                    {
                        "id": 25733,
                        "name": "Grönwohld",
                        "latitude": "53.64162000",
                        "longitude": "10.40784000"
                    },
                    {
                        "id": 25622,
                        "name": "Groß Grönau",
                        "latitude": "53.80000000",
                        "longitude": "10.75000000"
                    },
                    {
                        "id": 25626,
                        "name": "Groß Kummerfeld",
                        "latitude": "54.05000000",
                        "longitude": "10.08333000"
                    },
                    {
                        "id": 25636,
                        "name": "Groß Rheide",
                        "latitude": "54.44154000",
                        "longitude": "9.43508000"
                    },
                    {
                        "id": 25641,
                        "name": "Groß Wittensee",
                        "latitude": "54.40000000",
                        "longitude": "9.76667000"
                    },
                    {
                        "id": 25661,
                        "name": "Großenaspe",
                        "latitude": "53.98333000",
                        "longitude": "9.96667000"
                    },
                    {
                        "id": 25618,
                        "name": "Grossenbrode",
                        "latitude": "54.38333000",
                        "longitude": "11.08333000"
                    },
                    {
                        "id": 25667,
                        "name": "Großensee",
                        "latitude": "53.61263000",
                        "longitude": "10.33961000"
                    },
                    {
                        "id": 25670,
                        "name": "Großenwiehe",
                        "latitude": "54.70000000",
                        "longitude": "9.25000000"
                    },
                    {
                        "id": 25674,
                        "name": "Großhansdorf",
                        "latitude": "53.66667000",
                        "longitude": "10.28333000"
                    },
                    {
                        "id": 25709,
                        "name": "Großsolt",
                        "latitude": "54.70000000",
                        "longitude": "9.51667000"
                    },
                    {
                        "id": 25717,
                        "name": "Grube",
                        "latitude": "54.23333000",
                        "longitude": "11.03333000"
                    },
                    {
                        "id": 25751,
                        "name": "Gudow",
                        "latitude": "53.55556000",
                        "longitude": "10.77021000"
                    },
                    {
                        "id": 25793,
                        "name": "Gülzow",
                        "latitude": "53.45000000",
                        "longitude": "10.50000000"
                    },
                    {
                        "id": 25799,
                        "name": "Güster",
                        "latitude": "53.53851000",
                        "longitude": "10.67607000"
                    },
                    {
                        "id": 25860,
                        "name": "Halstenbek",
                        "latitude": "53.63333000",
                        "longitude": "9.85000000"
                    },
                    {
                        "id": 25863,
                        "name": "Hamberge",
                        "latitude": "53.83333000",
                        "longitude": "10.58333000"
                    },
                    {
                        "id": 25871,
                        "name": "Hamdorf",
                        "latitude": "54.22522000",
                        "longitude": "9.51866000"
                    },
                    {
                        "id": 25881,
                        "name": "Hammoor",
                        "latitude": "53.71378000",
                        "longitude": "10.32200000"
                    },
                    {
                        "id": 25884,
                        "name": "Handewitt",
                        "latitude": "54.76667000",
                        "longitude": "9.33333000"
                    },
                    {
                        "id": 25886,
                        "name": "Hanerau-Hademarschen",
                        "latitude": "54.13333000",
                        "longitude": "9.41667000"
                    },
                    {
                        "id": 25905,
                        "name": "Harrislee",
                        "latitude": "54.80000000",
                        "longitude": "9.38333000"
                    },
                    {
                        "id": 25911,
                        "name": "Hartenholm",
                        "latitude": "53.89856000",
                        "longitude": "10.05953000"
                    },
                    {
                        "id": 25922,
                        "name": "Haselau",
                        "latitude": "53.66181000",
                        "longitude": "9.62010000"
                    },
                    {
                        "id": 25925,
                        "name": "Haseldorf",
                        "latitude": "53.63780000",
                        "longitude": "9.59151000"
                    },
                    {
                        "id": 25930,
                        "name": "Hasloh",
                        "latitude": "53.69471000",
                        "longitude": "9.91682000"
                    },
                    {
                        "id": 25942,
                        "name": "Hattstedt",
                        "latitude": "54.53333000",
                        "longitude": "9.03333000"
                    },
                    {
                        "id": 25980,
                        "name": "Heide",
                        "latitude": "54.19579000",
                        "longitude": "9.09880000"
                    },
                    {
                        "id": 25989,
                        "name": "Heidgraben",
                        "latitude": "53.70787000",
                        "longitude": "9.68099000"
                    },
                    {
                        "id": 25992,
                        "name": "Heikendorf",
                        "latitude": "54.36667000",
                        "longitude": "10.20000000"
                    },
                    {
                        "id": 25997,
                        "name": "Heiligenhafen",
                        "latitude": "54.36964000",
                        "longitude": "10.98022000"
                    },
                    {
                        "id": 26002,
                        "name": "Heiligenstedten",
                        "latitude": "53.93264000",
                        "longitude": "9.47462000"
                    },
                    {
                        "id": 26017,
                        "name": "Heist",
                        "latitude": "53.65000000",
                        "longitude": "9.65000000"
                    },
                    {
                        "id": 26023,
                        "name": "Helgoland",
                        "latitude": "54.18143000",
                        "longitude": "7.88630000"
                    },
                    {
                        "id": 26037,
                        "name": "Hemdingen",
                        "latitude": "53.76667000",
                        "longitude": "9.83333000"
                    },
                    {
                        "id": 26042,
                        "name": "Hemmingstedt",
                        "latitude": "54.15000000",
                        "longitude": "9.06667000"
                    },
                    {
                        "id": 26052,
                        "name": "Hennstedt",
                        "latitude": "54.28333000",
                        "longitude": "9.16667000"
                    },
                    {
                        "id": 26054,
                        "name": "Henstedt-Ulzburg",
                        "latitude": "53.80500000",
                        "longitude": "9.97452000"
                    },
                    {
                        "id": 26073,
                        "name": "Heringsdorf",
                        "latitude": "54.30100000",
                        "longitude": "11.00658000"
                    },
                    {
                        "id": 26100,
                        "name": "Herzhorn",
                        "latitude": "53.78333000",
                        "longitude": "9.48333000"
                    },
                    {
                        "id": 26109,
                        "name": "Hetlingen",
                        "latitude": "53.60712000",
                        "longitude": "9.63718000"
                    },
                    {
                        "id": 26171,
                        "name": "Hitzhusen",
                        "latitude": "53.92397000",
                        "longitude": "9.85262000"
                    },
                    {
                        "id": 26172,
                        "name": "Hochdonn",
                        "latitude": "54.02663000",
                        "longitude": "9.27624000"
                    },
                    {
                        "id": 26196,
                        "name": "Hohenaspe",
                        "latitude": "53.98898000",
                        "longitude": "9.52774000"
                    },
                    {
                        "id": 26203,
                        "name": "Hohenfelde",
                        "latitude": "54.36667000",
                        "longitude": "10.50000000"
                    },
                    {
                        "id": 26211,
                        "name": "Hohenlockstedt",
                        "latitude": "53.96667000",
                        "longitude": "9.61667000"
                    },
                    {
                        "id": 26222,
                        "name": "Hohenwestedt",
                        "latitude": "54.08886000",
                        "longitude": "9.65359000"
                    },
                    {
                        "id": 26223,
                        "name": "Hohn",
                        "latitude": "54.30000000",
                        "longitude": "9.50000000"
                    },
                    {
                        "id": 26227,
                        "name": "Hoisdorf",
                        "latitude": "53.65000000",
                        "longitude": "10.31667000"
                    },
                    {
                        "id": 26235,
                        "name": "Hollingstedt",
                        "latitude": "54.45934000",
                        "longitude": "9.33695000"
                    },
                    {
                        "id": 26237,
                        "name": "Holm",
                        "latitude": "53.61667000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 26239,
                        "name": "Holtsee",
                        "latitude": "54.40000000",
                        "longitude": "9.85000000"
                    },
                    {
                        "id": 26272,
                        "name": "Horst",
                        "latitude": "53.81195000",
                        "longitude": "9.62307000"
                    },
                    {
                        "id": 26341,
                        "name": "Hürup",
                        "latitude": "54.75000000",
                        "longitude": "9.53333000"
                    },
                    {
                        "id": 26292,
                        "name": "Husum",
                        "latitude": "54.48580000",
                        "longitude": "9.05239000"
                    },
                    {
                        "id": 26422,
                        "name": "Itzehoe",
                        "latitude": "53.92099000",
                        "longitude": "9.51529000"
                    },
                    {
                        "id": 26423,
                        "name": "Itzstedt",
                        "latitude": "53.80800000",
                        "longitude": "10.15797000"
                    },
                    {
                        "id": 26431,
                        "name": "Jarplund-Weding",
                        "latitude": "54.73714000",
                        "longitude": "9.41813000"
                    },
                    {
                        "id": 26438,
                        "name": "Jerrishoe",
                        "latitude": "54.65670000",
                        "longitude": "9.36918000"
                    },
                    {
                        "id": 26439,
                        "name": "Jersbek",
                        "latitude": "53.73333000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 26449,
                        "name": "Jevenstedt",
                        "latitude": "54.23333000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 26469,
                        "name": "Jübek",
                        "latitude": "54.55709000",
                        "longitude": "9.39773000"
                    },
                    {
                        "id": 26496,
                        "name": "Kaltenkirchen",
                        "latitude": "53.83292000",
                        "longitude": "9.95810000"
                    },
                    {
                        "id": 26509,
                        "name": "Kappeln",
                        "latitude": "54.66122000",
                        "longitude": "9.93130000"
                    },
                    {
                        "id": 26530,
                        "name": "Kasseedorf",
                        "latitude": "54.16667000",
                        "longitude": "10.71667000"
                    },
                    {
                        "id": 26534,
                        "name": "Kastorf",
                        "latitude": "53.74569000",
                        "longitude": "10.56723000"
                    },
                    {
                        "id": 26548,
                        "name": "Kayhude",
                        "latitude": "53.75629000",
                        "longitude": "10.13232000"
                    },
                    {
                        "id": 26553,
                        "name": "Keitum",
                        "latitude": "54.89333000",
                        "longitude": "8.37083000"
                    },
                    {
                        "id": 26559,
                        "name": "Kellenhusen",
                        "latitude": "54.19338000",
                        "longitude": "11.06165000"
                    },
                    {
                        "id": 26560,
                        "name": "Kellinghusen",
                        "latitude": "53.95202000",
                        "longitude": "9.71959000"
                    },
                    {
                        "id": 26581,
                        "name": "Kiebitzreihe",
                        "latitude": "53.78333000",
                        "longitude": "9.61667000"
                    },
                    {
                        "id": 26584,
                        "name": "Kiel",
                        "latitude": "54.32133000",
                        "longitude": "10.13489000"
                    },
                    {
                        "id": 26647,
                        "name": "Kisdorf",
                        "latitude": "53.81667000",
                        "longitude": "10.01667000"
                    },
                    {
                        "id": 26656,
                        "name": "Klausdorf",
                        "latitude": "54.30899000",
                        "longitude": "10.21372000"
                    },
                    {
                        "id": 26660,
                        "name": "Klein Nordende",
                        "latitude": "53.72219000",
                        "longitude": "9.65424000"
                    },
                    {
                        "id": 26661,
                        "name": "Klein Offenseth-Sparrieshoop",
                        "latitude": "53.79748000",
                        "longitude": "9.68653000"
                    },
                    {
                        "id": 26664,
                        "name": "Klein Rönnau",
                        "latitude": "53.96667000",
                        "longitude": "10.31667000"
                    },
                    {
                        "id": 26714,
                        "name": "Kollmar",
                        "latitude": "53.72936000",
                        "longitude": "9.47880000"
                    },
                    {
                        "id": 26817,
                        "name": "Kölln-Reisiek",
                        "latitude": "53.75748000",
                        "longitude": "9.69772000"
                    },
                    {
                        "id": 26727,
                        "name": "Kosel",
                        "latitude": "54.50580000",
                        "longitude": "9.75653000"
                    },
                    {
                        "id": 26750,
                        "name": "Krempe",
                        "latitude": "53.83694000",
                        "longitude": "9.48831000"
                    },
                    {
                        "id": 26751,
                        "name": "Kremperheide",
                        "latitude": "53.88721000",
                        "longitude": "9.47809000"
                    },
                    {
                        "id": 26772,
                        "name": "Kronshagen",
                        "latitude": "54.33333000",
                        "longitude": "10.08333000"
                    },
                    {
                        "id": 26773,
                        "name": "Kropp",
                        "latitude": "54.41667000",
                        "longitude": "9.51667000"
                    },
                    {
                        "id": 26784,
                        "name": "Kröppelshagen-Fahrendorf",
                        "latitude": "53.48979000",
                        "longitude": "10.31697000"
                    },
                    {
                        "id": 26780,
                        "name": "Krummesse",
                        "latitude": "53.78333000",
                        "longitude": "10.65000000"
                    },
                    {
                        "id": 26790,
                        "name": "Kuddewörde",
                        "latitude": "53.58333000",
                        "longitude": "10.40000000"
                    },
                    {
                        "id": 26796,
                        "name": "Kummerfeld",
                        "latitude": "53.69262000",
                        "longitude": "9.79099000"
                    },
                    {
                        "id": 26866,
                        "name": "Laboe",
                        "latitude": "54.40000000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 26871,
                        "name": "Ladelund",
                        "latitude": "54.84084000",
                        "longitude": "9.02135000"
                    },
                    {
                        "id": 27183,
                        "name": "Lägerdorf",
                        "latitude": "53.88333000",
                        "longitude": "9.58333000"
                    },
                    {
                        "id": 26899,
                        "name": "Langballig",
                        "latitude": "54.80000000",
                        "longitude": "9.63333000"
                    },
                    {
                        "id": 26921,
                        "name": "Langenhorn",
                        "latitude": "54.66667000",
                        "longitude": "8.91667000"
                    },
                    {
                        "id": 26941,
                        "name": "Langstedt",
                        "latitude": "54.61667000",
                        "longitude": "9.38333000"
                    },
                    {
                        "id": 26944,
                        "name": "Langwedel",
                        "latitude": "54.21033000",
                        "longitude": "9.92761000"
                    },
                    {
                        "id": 26951,
                        "name": "Lasbek",
                        "latitude": "53.73333000",
                        "longitude": "10.36667000"
                    },
                    {
                        "id": 26968,
                        "name": "Lauenburg",
                        "latitude": "53.37199000",
                        "longitude": "10.55654000"
                    },
                    {
                        "id": 26997,
                        "name": "Leck",
                        "latitude": "54.76667000",
                        "longitude": "8.98333000"
                    },
                    {
                        "id": 27002,
                        "name": "Leezen",
                        "latitude": "53.86667000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 27006,
                        "name": "Lehe",
                        "latitude": "54.34143000",
                        "longitude": "9.02374000"
                    },
                    {
                        "id": 27009,
                        "name": "Lehmkuhlen",
                        "latitude": "54.23333000",
                        "longitude": "10.36667000"
                    },
                    {
                        "id": 27048,
                        "name": "Lensahn",
                        "latitude": "54.21652000",
                        "longitude": "10.88326000"
                    },
                    {
                        "id": 27049,
                        "name": "Lentföhrden",
                        "latitude": "53.86667000",
                        "longitude": "9.88333000"
                    },
                    {
                        "id": 27101,
                        "name": "Linau",
                        "latitude": "53.64446000",
                        "longitude": "10.46853000"
                    },
                    {
                        "id": 27104,
                        "name": "Lindau",
                        "latitude": "54.38333000",
                        "longitude": "9.90000000"
                    },
                    {
                        "id": 27109,
                        "name": "Lindewitt",
                        "latitude": "54.70000000",
                        "longitude": "9.20000000"
                    },
                    {
                        "id": 27122,
                        "name": "List",
                        "latitude": "55.01917000",
                        "longitude": "8.43132000"
                    },
                    {
                        "id": 27131,
                        "name": "Lohe-Rickelshof",
                        "latitude": "54.18803000",
                        "longitude": "9.07066000"
                    },
                    {
                        "id": 27205,
                        "name": "Lübeck",
                        "latitude": "53.86893000",
                        "longitude": "10.68729000"
                    },
                    {
                        "id": 27174,
                        "name": "Lunden",
                        "latitude": "54.33131000",
                        "longitude": "9.02523000"
                    },
                    {
                        "id": 27221,
                        "name": "Lürschau",
                        "latitude": "54.55000000",
                        "longitude": "9.50000000"
                    },
                    {
                        "id": 27222,
                        "name": "Lütjenburg",
                        "latitude": "54.29188000",
                        "longitude": "10.58945000"
                    },
                    {
                        "id": 27223,
                        "name": "Lütjensee",
                        "latitude": "53.65000000",
                        "longitude": "10.36667000"
                    },
                    {
                        "id": 27252,
                        "name": "Malente",
                        "latitude": "54.17226000",
                        "longitude": "10.55968000"
                    },
                    {
                        "id": 27327,
                        "name": "Martensrade",
                        "latitude": "54.28333000",
                        "longitude": "10.40000000"
                    },
                    {
                        "id": 27392,
                        "name": "Meldorf",
                        "latitude": "54.09182000",
                        "longitude": "9.06870000"
                    },
                    {
                        "id": 27399,
                        "name": "Melsdorf",
                        "latitude": "54.31667000",
                        "longitude": "10.03333000"
                    },
                    {
                        "id": 27460,
                        "name": "Mielkendorf",
                        "latitude": "54.28333000",
                        "longitude": "10.05000000"
                    },
                    {
                        "id": 27466,
                        "name": "Mildstedt",
                        "latitude": "54.46667000",
                        "longitude": "9.10000000"
                    },
                    {
                        "id": 27502,
                        "name": "Mohrkirch",
                        "latitude": "54.66667000",
                        "longitude": "9.71667000"
                    },
                    {
                        "id": 27505,
                        "name": "Molfsee",
                        "latitude": "54.26667000",
                        "longitude": "10.06667000"
                    },
                    {
                        "id": 27564,
                        "name": "Mölln",
                        "latitude": "53.61702000",
                        "longitude": "10.68742000"
                    },
                    {
                        "id": 27574,
                        "name": "Mönkeberg",
                        "latitude": "54.35000000",
                        "longitude": "10.18333000"
                    },
                    {
                        "id": 27516,
                        "name": "Moorrege",
                        "latitude": "53.66667000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 27541,
                        "name": "Munkbrarup",
                        "latitude": "54.80000000",
                        "longitude": "9.56667000"
                    },
                    {
                        "id": 27624,
                        "name": "Münsterdorf",
                        "latitude": "53.90232000",
                        "longitude": "9.54123000"
                    },
                    {
                        "id": 27636,
                        "name": "Nahe",
                        "latitude": "53.80000000",
                        "longitude": "10.13333000"
                    },
                    {
                        "id": 27667,
                        "name": "Negernbötel",
                        "latitude": "53.98333000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 27697,
                        "name": "Neuberend",
                        "latitude": "54.55000000",
                        "longitude": "9.53333000"
                    },
                    {
                        "id": 27713,
                        "name": "Neudorf-Bornstein",
                        "latitude": "54.43333000",
                        "longitude": "9.95000000"
                    },
                    {
                        "id": 27760,
                        "name": "Neukirchen",
                        "latitude": "54.21465000",
                        "longitude": "10.55381000"
                    },
                    {
                        "id": 27774,
                        "name": "Neumünster",
                        "latitude": "54.07477000",
                        "longitude": "9.98195000"
                    },
                    {
                        "id": 27805,
                        "name": "Neustadt in Holstein",
                        "latitude": "54.10707000",
                        "longitude": "10.81450000"
                    },
                    {
                        "id": 27815,
                        "name": "Neuwittenbek",
                        "latitude": "54.36667000",
                        "longitude": "10.01667000"
                    },
                    {
                        "id": 27824,
                        "name": "Niebüll",
                        "latitude": "54.78663000",
                        "longitude": "8.82854000"
                    },
                    {
                        "id": 27900,
                        "name": "Nindorf",
                        "latitude": "54.08333000",
                        "longitude": "9.11667000"
                    },
                    {
                        "id": 27916,
                        "name": "Norderstedt",
                        "latitude": "53.68590000",
                        "longitude": "9.98041000"
                    },
                    {
                        "id": 27918,
                        "name": "Nordhastedt",
                        "latitude": "54.16667000",
                        "longitude": "9.18333000"
                    },
                    {
                        "id": 27932,
                        "name": "Nortorf",
                        "latitude": "54.16738000",
                        "longitude": "9.85437000"
                    },
                    {
                        "id": 27950,
                        "name": "Nübbel",
                        "latitude": "54.26667000",
                        "longitude": "9.61667000"
                    },
                    {
                        "id": 27941,
                        "name": "Nusse",
                        "latitude": "53.65654000",
                        "longitude": "10.58391000"
                    },
                    {
                        "id": 27956,
                        "name": "Nützen",
                        "latitude": "53.86667000",
                        "longitude": "9.91667000"
                    },
                    {
                        "id": 28077,
                        "name": "Oelixdorf",
                        "latitude": "53.92738000",
                        "longitude": "9.56383000"
                    },
                    {
                        "id": 28084,
                        "name": "Oeversee",
                        "latitude": "54.70000000",
                        "longitude": "9.43333000"
                    },
                    {
                        "id": 28106,
                        "name": "Oldenburg in Holstein",
                        "latitude": "54.29576000",
                        "longitude": "10.90156000"
                    },
                    {
                        "id": 28107,
                        "name": "Oldendorf",
                        "latitude": "53.95341000",
                        "longitude": "9.45858000"
                    },
                    {
                        "id": 28109,
                        "name": "Oldenswort",
                        "latitude": "54.37243000",
                        "longitude": "8.93996000"
                    },
                    {
                        "id": 28138,
                        "name": "Osdorf",
                        "latitude": "54.43333000",
                        "longitude": "10.01667000"
                    },
                    {
                        "id": 28146,
                        "name": "Ostenfeld",
                        "latitude": "54.46400000",
                        "longitude": "9.23430000"
                    },
                    {
                        "id": 28157,
                        "name": "Osterrönfeld",
                        "latitude": "54.29013000",
                        "longitude": "9.69900000"
                    },
                    {
                        "id": 28176,
                        "name": "Oststeinbek",
                        "latitude": "53.54321000",
                        "longitude": "10.16939000"
                    },
                    {
                        "id": 28203,
                        "name": "Owschlag",
                        "latitude": "54.39336000",
                        "longitude": "9.59243000"
                    },
                    {
                        "id": 28208,
                        "name": "Padenstedt",
                        "latitude": "54.05000000",
                        "longitude": "9.91667000"
                    },
                    {
                        "id": 28210,
                        "name": "Pahlen",
                        "latitude": "54.26667000",
                        "longitude": "9.30000000"
                    },
                    {
                        "id": 28215,
                        "name": "Panker",
                        "latitude": "54.33333000",
                        "longitude": "10.56667000"
                    },
                    {
                        "id": 28248,
                        "name": "Pellworm",
                        "latitude": "54.51610000",
                        "longitude": "8.64512000"
                    },
                    {
                        "id": 28304,
                        "name": "Pinneberg",
                        "latitude": "53.66732000",
                        "longitude": "9.78936000"
                    },
                    {
                        "id": 28331,
                        "name": "Plön",
                        "latitude": "54.16241000",
                        "longitude": "10.42333000"
                    },
                    {
                        "id": 28416,
                        "name": "Pölitz",
                        "latitude": "53.77303000",
                        "longitude": "10.38276000"
                    },
                    {
                        "id": 28371,
                        "name": "Preetz",
                        "latitude": "54.23540000",
                        "longitude": "10.27795000"
                    },
                    {
                        "id": 28389,
                        "name": "Prisdorf",
                        "latitude": "53.68333000",
                        "longitude": "9.75000000"
                    },
                    {
                        "id": 28393,
                        "name": "Probsteierhagen",
                        "latitude": "54.36153000",
                        "longitude": "10.28772000"
                    },
                    {
                        "id": 28396,
                        "name": "Pronstorf",
                        "latitude": "53.95000000",
                        "longitude": "10.46667000"
                    },
                    {
                        "id": 28425,
                        "name": "Quarnbek",
                        "latitude": "54.33333000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 28431,
                        "name": "Quern",
                        "latitude": "54.75000000",
                        "longitude": "9.71667000"
                    },
                    {
                        "id": 28432,
                        "name": "Quickborn",
                        "latitude": "53.72831000",
                        "longitude": "9.90934000"
                    },
                    {
                        "id": 28454,
                        "name": "Raisdorf",
                        "latitude": "54.28127000",
                        "longitude": "10.24915000"
                    },
                    {
                        "id": 28476,
                        "name": "Rantrum",
                        "latitude": "54.44062000",
                        "longitude": "9.12872000"
                    },
                    {
                        "id": 28483,
                        "name": "Ratekau",
                        "latitude": "53.95000000",
                        "longitude": "10.73333000"
                    },
                    {
                        "id": 28491,
                        "name": "Ratzeburg",
                        "latitude": "53.69965000",
                        "longitude": "10.77256000"
                    },
                    {
                        "id": 28555,
                        "name": "Reinbek",
                        "latitude": "53.51703000",
                        "longitude": "10.24880000"
                    },
                    {
                        "id": 28557,
                        "name": "Reinfeld",
                        "latitude": "53.83184000",
                        "longitude": "10.49126000"
                    },
                    {
                        "id": 28571,
                        "name": "Rellingen",
                        "latitude": "53.65000000",
                        "longitude": "9.81667000"
                    },
                    {
                        "id": 28579,
                        "name": "Rendsburg",
                        "latitude": "54.30663000",
                        "longitude": "9.66313000"
                    },
                    {
                        "id": 28624,
                        "name": "Rickert",
                        "latitude": "54.33333000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 28625,
                        "name": "Rickling",
                        "latitude": "54.01667000",
                        "longitude": "10.16667000"
                    },
                    {
                        "id": 28644,
                        "name": "Riepsdorf",
                        "latitude": "54.22611000",
                        "longitude": "10.97242000"
                    },
                    {
                        "id": 28647,
                        "name": "Rieseby",
                        "latitude": "54.54140000",
                        "longitude": "9.81689000"
                    },
                    {
                        "id": 28666,
                        "name": "Risum-Lindholm",
                        "latitude": "54.75802000",
                        "longitude": "8.86906000"
                    },
                    {
                        "id": 28760,
                        "name": "Ruhwinkel",
                        "latitude": "54.10000000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 28808,
                        "name": "Rümpel",
                        "latitude": "53.78333000",
                        "longitude": "10.35000000"
                    },
                    {
                        "id": 28855,
                        "name": "Sandesneben",
                        "latitude": "53.68333000",
                        "longitude": "10.50000000"
                    },
                    {
                        "id": 28859,
                        "name": "Sankelmark",
                        "latitude": "54.71803000",
                        "longitude": "9.42344000"
                    },
                    {
                        "id": 28876,
                        "name": "Sankt Margarethen",
                        "latitude": "53.89199000",
                        "longitude": "9.25301000"
                    },
                    {
                        "id": 28878,
                        "name": "Sankt Michaelisdonn",
                        "latitude": "53.98333000",
                        "longitude": "9.11667000"
                    },
                    {
                        "id": 28881,
                        "name": "Sankt Peter-Ording",
                        "latitude": "54.30363000",
                        "longitude": "8.64138000"
                    },
                    {
                        "id": 28892,
                        "name": "Satrup",
                        "latitude": "54.69237000",
                        "longitude": "9.60549000"
                    },
                    {
                        "id": 28902,
                        "name": "Schaalby",
                        "latitude": "54.55000000",
                        "longitude": "9.63333000"
                    },
                    {
                        "id": 28903,
                        "name": "Schacht-Audorf",
                        "latitude": "54.31282000",
                        "longitude": "9.71586000"
                    },
                    {
                        "id": 28904,
                        "name": "Schafflund",
                        "latitude": "54.75845000",
                        "longitude": "9.18329000"
                    },
                    {
                        "id": 28910,
                        "name": "Scharbeutz",
                        "latitude": "54.03333000",
                        "longitude": "10.75000000"
                    },
                    {
                        "id": 28913,
                        "name": "Schashagen",
                        "latitude": "54.13333000",
                        "longitude": "10.88333000"
                    },
                    {
                        "id": 28927,
                        "name": "Schellhorn",
                        "latitude": "54.22952000",
                        "longitude": "10.29402000"
                    },
                    {
                        "id": 28928,
                        "name": "Schenefeld",
                        "latitude": "54.05000000",
                        "longitude": "9.48333000"
                    },
                    {
                        "id": 28972,
                        "name": "Schleswig",
                        "latitude": "54.52156000",
                        "longitude": "9.55860000"
                    },
                    {
                        "id": 28986,
                        "name": "Schmalfeld",
                        "latitude": "53.88333000",
                        "longitude": "9.96667000"
                    },
                    {
                        "id": 29011,
                        "name": "Schobüll",
                        "latitude": "54.50920000",
                        "longitude": "9.00621000"
                    },
                    {
                        "id": 29111,
                        "name": "Schönberg",
                        "latitude": "53.68319000",
                        "longitude": "10.42671000"
                    },
                    {
                        "id": 29128,
                        "name": "Schönkirchen",
                        "latitude": "54.33333000",
                        "longitude": "10.23333000"
                    },
                    {
                        "id": 29134,
                        "name": "Schönwalde am Bungsberg",
                        "latitude": "54.18333000",
                        "longitude": "10.75000000"
                    },
                    {
                        "id": 29034,
                        "name": "Schuby",
                        "latitude": "54.51667000",
                        "longitude": "9.48333000"
                    },
                    {
                        "id": 29137,
                        "name": "Schülp",
                        "latitude": "54.25896000",
                        "longitude": "9.63034000"
                    },
                    {
                        "id": 29044,
                        "name": "Schwabstedt",
                        "latitude": "54.39705000",
                        "longitude": "9.18646000"
                    },
                    {
                        "id": 29069,
                        "name": "Schwarzenbek",
                        "latitude": "53.50303000",
                        "longitude": "10.48055000"
                    },
                    {
                        "id": 29149,
                        "name": "Seedorf",
                        "latitude": "54.05000000",
                        "longitude": "10.41667000"
                    },
                    {
                        "id": 29178,
                        "name": "Selent",
                        "latitude": "54.28893000",
                        "longitude": "10.42702000"
                    },
                    {
                        "id": 29197,
                        "name": "Seth",
                        "latitude": "53.84718000",
                        "longitude": "10.17421000"
                    },
                    {
                        "id": 29216,
                        "name": "Siek",
                        "latitude": "53.63333000",
                        "longitude": "10.30000000"
                    },
                    {
                        "id": 29219,
                        "name": "Sierksdorf",
                        "latitude": "54.06667000",
                        "longitude": "10.76667000"
                    },
                    {
                        "id": 29223,
                        "name": "Sievershütten",
                        "latitude": "53.84238000",
                        "longitude": "10.11216000"
                    },
                    {
                        "id": 29224,
                        "name": "Sieverstedt",
                        "latitude": "54.64145000",
                        "longitude": "9.46949000"
                    },
                    {
                        "id": 29229,
                        "name": "Silberstedt",
                        "latitude": "54.51667000",
                        "longitude": "9.38333000"
                    },
                    {
                        "id": 29496,
                        "name": "Sörup",
                        "latitude": "54.71667000",
                        "longitude": "9.66667000"
                    },
                    {
                        "id": 29332,
                        "name": "Stadum",
                        "latitude": "54.73333000",
                        "longitude": "9.05000000"
                    },
                    {
                        "id": 29340,
                        "name": "Stapelfeld",
                        "latitude": "53.60000000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 29367,
                        "name": "Steinberg",
                        "latitude": "54.76667000",
                        "longitude": "9.78333000"
                    },
                    {
                        "id": 29368,
                        "name": "Steinbergkirche",
                        "latitude": "54.75463000",
                        "longitude": "9.76069000"
                    },
                    {
                        "id": 29403,
                        "name": "Sterup",
                        "latitude": "54.72650000",
                        "longitude": "9.73572000"
                    },
                    {
                        "id": 29411,
                        "name": "Stockelsdorf",
                        "latitude": "53.89220000",
                        "longitude": "10.64713000"
                    },
                    {
                        "id": 29418,
                        "name": "Stolpe",
                        "latitude": "54.13333000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 29426,
                        "name": "Strande",
                        "latitude": "54.43333000",
                        "longitude": "10.16667000"
                    },
                    {
                        "id": 29439,
                        "name": "Struvenhütten",
                        "latitude": "53.86667000",
                        "longitude": "10.05000000"
                    },
                    {
                        "id": 29497,
                        "name": "Süderbrarup",
                        "latitude": "54.63333000",
                        "longitude": "9.78333000"
                    },
                    {
                        "id": 29499,
                        "name": "Süderlügum",
                        "latitude": "54.87391000",
                        "longitude": "8.91111000"
                    },
                    {
                        "id": 29500,
                        "name": "Süderstapel",
                        "latitude": "54.34967000",
                        "longitude": "9.21907000"
                    },
                    {
                        "id": 29502,
                        "name": "Sülfeld",
                        "latitude": "53.80000000",
                        "longitude": "10.23333000"
                    },
                    {
                        "id": 29507,
                        "name": "Süsel",
                        "latitude": "54.08135000",
                        "longitude": "10.70172000"
                    },
                    {
                        "id": 29487,
                        "name": "Sylt-Ost",
                        "latitude": "54.86110000",
                        "longitude": "8.41141000"
                    },
                    {
                        "id": 29519,
                        "name": "Tangstedt",
                        "latitude": "53.73333000",
                        "longitude": "10.08333000"
                    },
                    {
                        "id": 29531,
                        "name": "Tarp",
                        "latitude": "54.66667000",
                        "longitude": "9.40000000"
                    },
                    {
                        "id": 29532,
                        "name": "Tating",
                        "latitude": "54.32607000",
                        "longitude": "8.70802000"
                    },
                    {
                        "id": 29553,
                        "name": "Tellingstedt",
                        "latitude": "54.21667000",
                        "longitude": "9.28333000"
                    },
                    {
                        "id": 29613,
                        "name": "Timmaspe",
                        "latitude": "54.13967000",
                        "longitude": "9.89430000"
                    },
                    {
                        "id": 29614,
                        "name": "Timmendorfer Strand",
                        "latitude": "53.99530000",
                        "longitude": "10.77676000"
                    },
                    {
                        "id": 29616,
                        "name": "Tinnum",
                        "latitude": "54.89932000",
                        "longitude": "8.33476000"
                    },
                    {
                        "id": 29623,
                        "name": "Todenbüttel",
                        "latitude": "54.13333000",
                        "longitude": "9.55000000"
                    },
                    {
                        "id": 29624,
                        "name": "Todendorf",
                        "latitude": "53.69461000",
                        "longitude": "10.34781000"
                    },
                    {
                        "id": 29625,
                        "name": "Todesfelde",
                        "latitude": "53.90000000",
                        "longitude": "10.18333000"
                    },
                    {
                        "id": 29629,
                        "name": "Tolk",
                        "latitude": "54.57987000",
                        "longitude": "9.63844000"
                    },
                    {
                        "id": 29702,
                        "name": "Tönning",
                        "latitude": "54.31879000",
                        "longitude": "8.94234000"
                    },
                    {
                        "id": 29634,
                        "name": "Tornesch",
                        "latitude": "53.70000000",
                        "longitude": "9.71667000"
                    },
                    {
                        "id": 29640,
                        "name": "Trappenkamp",
                        "latitude": "54.03988000",
                        "longitude": "10.21496000"
                    },
                    {
                        "id": 29647,
                        "name": "Travemünde",
                        "latitude": "53.96304000",
                        "longitude": "10.87090000"
                    },
                    {
                        "id": 29657,
                        "name": "Treia",
                        "latitude": "54.50000000",
                        "longitude": "9.31667000"
                    },
                    {
                        "id": 29659,
                        "name": "Tremsbüttel",
                        "latitude": "53.74384000",
                        "longitude": "10.31024000"
                    },
                    {
                        "id": 29674,
                        "name": "Trittau",
                        "latitude": "53.61667000",
                        "longitude": "10.40000000"
                    },
                    {
                        "id": 29710,
                        "name": "Tüttendorf",
                        "latitude": "54.40000000",
                        "longitude": "10.00000000"
                    },
                    {
                        "id": 29727,
                        "name": "Uetersen",
                        "latitude": "53.68769000",
                        "longitude": "9.66394000"
                    },
                    {
                        "id": 29806,
                        "name": "Vaale",
                        "latitude": "54.00000000",
                        "longitude": "9.38333000"
                    },
                    {
                        "id": 29862,
                        "name": "Viöl",
                        "latitude": "54.56667000",
                        "longitude": "9.18333000"
                    },
                    {
                        "id": 29895,
                        "name": "Waabs",
                        "latitude": "54.53333000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 29905,
                        "name": "Wacken",
                        "latitude": "54.02078000",
                        "longitude": "9.37597000"
                    },
                    {
                        "id": 29919,
                        "name": "Wahlstedt",
                        "latitude": "53.95161000",
                        "longitude": "10.20626000"
                    },
                    {
                        "id": 29998,
                        "name": "Wanderup",
                        "latitude": "54.68333000",
                        "longitude": "9.33333000"
                    },
                    {
                        "id": 30003,
                        "name": "Wangels",
                        "latitude": "54.26667000",
                        "longitude": "10.76667000"
                    },
                    {
                        "id": 30006,
                        "name": "Wankendorf",
                        "latitude": "54.11224000",
                        "longitude": "10.20546000"
                    },
                    {
                        "id": 30028,
                        "name": "Wasbek",
                        "latitude": "54.07427000",
                        "longitude": "9.89738000"
                    },
                    {
                        "id": 30040,
                        "name": "Wattenbek",
                        "latitude": "54.16667000",
                        "longitude": "10.05000000"
                    },
                    {
                        "id": 30046,
                        "name": "Weddelbrook",
                        "latitude": "53.90000000",
                        "longitude": "9.83333000"
                    },
                    {
                        "id": 30049,
                        "name": "Weddingstedt",
                        "latitude": "54.23428000",
                        "longitude": "9.09103000"
                    },
                    {
                        "id": 30050,
                        "name": "Wedel",
                        "latitude": "53.58374000",
                        "longitude": "9.69835000"
                    },
                    {
                        "id": 30052,
                        "name": "Wees",
                        "latitude": "54.80621000",
                        "longitude": "9.51695000"
                    },
                    {
                        "id": 30160,
                        "name": "Wendtorf",
                        "latitude": "54.41212000",
                        "longitude": "10.28952000"
                    },
                    {
                        "id": 30163,
                        "name": "Wentorf bei Hamburg",
                        "latitude": "53.50000000",
                        "longitude": "10.25000000"
                    },
                    {
                        "id": 30195,
                        "name": "Wesselburen",
                        "latitude": "54.21217000",
                        "longitude": "8.92419000"
                    },
                    {
                        "id": 30197,
                        "name": "Wesseln",
                        "latitude": "54.20985000",
                        "longitude": "9.07644000"
                    },
                    {
                        "id": 30202,
                        "name": "Westensee",
                        "latitude": "54.27452000",
                        "longitude": "9.89584000"
                    },
                    {
                        "id": 30203,
                        "name": "Wester-Ohrstedt",
                        "latitude": "54.50796000",
                        "longitude": "9.18574000"
                    },
                    {
                        "id": 30211,
                        "name": "Westerhorn",
                        "latitude": "53.85711000",
                        "longitude": "9.67959000"
                    },
                    {
                        "id": 30213,
                        "name": "Westerland",
                        "latitude": "54.90790000",
                        "longitude": "8.30326000"
                    },
                    {
                        "id": 30214,
                        "name": "Westerrönfeld",
                        "latitude": "54.28333000",
                        "longitude": "9.65000000"
                    },
                    {
                        "id": 30231,
                        "name": "Wewelsfleth",
                        "latitude": "53.85000000",
                        "longitude": "9.40000000"
                    },
                    {
                        "id": 30248,
                        "name": "Wiemersdorf",
                        "latitude": "53.95815000",
                        "longitude": "9.90297000"
                    },
                    {
                        "id": 30303,
                        "name": "Wilster",
                        "latitude": "53.92253000",
                        "longitude": "9.37465000"
                    },
                    {
                        "id": 30312,
                        "name": "Windeby",
                        "latitude": "54.46667000",
                        "longitude": "9.81667000"
                    },
                    {
                        "id": 30368,
                        "name": "Witzhave",
                        "latitude": "53.56667000",
                        "longitude": "10.33333000"
                    },
                    {
                        "id": 30371,
                        "name": "Wohltorf",
                        "latitude": "53.51667000",
                        "longitude": "10.28333000"
                    },
                    {
                        "id": 30438,
                        "name": "Wöhrden",
                        "latitude": "54.16667000",
                        "longitude": "9.00000000"
                    },
                    {
                        "id": 30412,
                        "name": "Wrist",
                        "latitude": "53.93333000",
                        "longitude": "9.76667000"
                    },
                    {
                        "id": 30435,
                        "name": "Wyk auf Föhr",
                        "latitude": "54.69140000",
                        "longitude": "8.56702000"
                    },
                    {
                        "id": 30471,
                        "name": "Zarpen",
                        "latitude": "53.86667000",
                        "longitude": "10.51667000"
                    }
                ]
            },
            {
                "id": 3015,
                "name": "Thuringia",
                "iso2": "TH",
                "latitude": "51.01098920",
                "longitude": "10.84534600",
                "type": "land",
                "cities": [
                    {
                        "id": 23596,
                        "name": "Altenburg",
                        "latitude": "50.98763000",
                        "longitude": "12.43684000"
                    },
                    {
                        "id": 23600,
                        "name": "Altenfeld",
                        "latitude": "50.56667000",
                        "longitude": "10.96667000"
                    },
                    {
                        "id": 23602,
                        "name": "Altengottern",
                        "latitude": "51.16395000",
                        "longitude": "10.58093000"
                    },
                    {
                        "id": 23625,
                        "name": "Altkirchen",
                        "latitude": "50.93333000",
                        "longitude": "12.35000000"
                    },
                    {
                        "id": 23664,
                        "name": "Anrode",
                        "latitude": "51.26667000",
                        "longitude": "10.33333000"
                    },
                    {
                        "id": 23673,
                        "name": "Apfelstädt",
                        "latitude": "50.90157000",
                        "longitude": "10.88977000"
                    },
                    {
                        "id": 23674,
                        "name": "Apolda",
                        "latitude": "51.02624000",
                        "longitude": "11.51638000"
                    },
                    {
                        "id": 23680,
                        "name": "Arenshausen",
                        "latitude": "51.37613000",
                        "longitude": "9.96870000"
                    },
                    {
                        "id": 23688,
                        "name": "Arnstadt",
                        "latitude": "50.84048000",
                        "longitude": "10.95198000"
                    },
                    {
                        "id": 23693,
                        "name": "Artern",
                        "latitude": "51.36431000",
                        "longitude": "11.29167000"
                    },
                    {
                        "id": 23737,
                        "name": "Auleben",
                        "latitude": "51.42640000",
                        "longitude": "10.92968000"
                    },
                    {
                        "id": 23739,
                        "name": "Auma",
                        "latitude": "50.70044000",
                        "longitude": "11.89958000"
                    },
                    {
                        "id": 23767,
                        "name": "Bad Berka",
                        "latitude": "50.89982000",
                        "longitude": "11.28245000"
                    },
                    {
                        "id": 23773,
                        "name": "Bad Blankenburg",
                        "latitude": "50.68189000",
                        "longitude": "11.27369000"
                    },
                    {
                        "id": 23796,
                        "name": "Bad Frankenhausen",
                        "latitude": "51.35609000",
                        "longitude": "11.09977000"
                    },
                    {
                        "id": 23815,
                        "name": "Bad Klosterlausnitz",
                        "latitude": "50.91667000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 23821,
                        "name": "Bad Köstritz",
                        "latitude": "50.93032000",
                        "longitude": "12.01005000"
                    },
                    {
                        "id": 23824,
                        "name": "Bad Langensalza",
                        "latitude": "51.10771000",
                        "longitude": "10.64600000"
                    },
                    {
                        "id": 23828,
                        "name": "Bad Liebenstein",
                        "latitude": "50.81569000",
                        "longitude": "10.35123000"
                    },
                    {
                        "id": 23832,
                        "name": "Bad Lobenstein",
                        "latitude": "50.45223000",
                        "longitude": "11.63930000"
                    },
                    {
                        "id": 23858,
                        "name": "Bad Salzungen",
                        "latitude": "50.81342000",
                        "longitude": "10.23610000"
                    },
                    {
                        "id": 23873,
                        "name": "Bad Sulza",
                        "latitude": "51.08929000",
                        "longitude": "11.62474000"
                    },
                    {
                        "id": 23877,
                        "name": "Bad Tennstedt",
                        "latitude": "51.15447000",
                        "longitude": "10.83873000"
                    },
                    {
                        "id": 23926,
                        "name": "Barchfeld",
                        "latitude": "50.82872000",
                        "longitude": "11.17955000"
                    },
                    {
                        "id": 23990,
                        "name": "Behringen",
                        "latitude": "50.77283000",
                        "longitude": "11.01403000"
                    },
                    {
                        "id": 24018,
                        "name": "Benshausen",
                        "latitude": "50.65000000",
                        "longitude": "10.60000000"
                    },
                    {
                        "id": 24029,
                        "name": "Berga",
                        "latitude": "50.75184000",
                        "longitude": "12.16445000"
                    },
                    {
                        "id": 24056,
                        "name": "Berlingerode",
                        "latitude": "51.45775000",
                        "longitude": "10.23840000"
                    },
                    {
                        "id": 24057,
                        "name": "Berlstedt",
                        "latitude": "51.06142000",
                        "longitude": "11.24288000"
                    },
                    {
                        "id": 24145,
                        "name": "Bischofferode",
                        "latitude": "51.49656000",
                        "longitude": "10.44396000"
                    },
                    {
                        "id": 24168,
                        "name": "Blankenhain",
                        "latitude": "50.85993000",
                        "longitude": "11.34390000"
                    },
                    {
                        "id": 24177,
                        "name": "Bleicherode",
                        "latitude": "51.44026000",
                        "longitude": "10.57202000"
                    },
                    {
                        "id": 24272,
                        "name": "Brahmenau",
                        "latitude": "50.92359000",
                        "longitude": "12.15886000"
                    },
                    {
                        "id": 24298,
                        "name": "Brehme",
                        "latitude": "51.49421000",
                        "longitude": "10.35908000"
                    },
                    {
                        "id": 24305,
                        "name": "Breitenbach",
                        "latitude": "50.68895000",
                        "longitude": "10.49148000"
                    },
                    {
                        "id": 24313,
                        "name": "Breitenworbis",
                        "latitude": "51.41267000",
                        "longitude": "10.42820000"
                    },
                    {
                        "id": 24317,
                        "name": "Breitungen",
                        "latitude": "50.76355000",
                        "longitude": "10.32724000"
                    },
                    {
                        "id": 24347,
                        "name": "Brotterode",
                        "latitude": "50.82412000",
                        "longitude": "10.44446000"
                    },
                    {
                        "id": 24382,
                        "name": "Bucha",
                        "latitude": "50.88333000",
                        "longitude": "11.51667000"
                    },
                    {
                        "id": 24399,
                        "name": "Bufleben",
                        "latitude": "51.00000000",
                        "longitude": "10.73333000"
                    },
                    {
                        "id": 24502,
                        "name": "Bürgel",
                        "latitude": "50.94217000",
                        "longitude": "11.75635000"
                    },
                    {
                        "id": 24450,
                        "name": "Buttelstedt",
                        "latitude": "51.07650000",
                        "longitude": "11.34353000"
                    },
                    {
                        "id": 24453,
                        "name": "Buttlar",
                        "latitude": "50.75770000",
                        "longitude": "9.95277000"
                    },
                    {
                        "id": 24454,
                        "name": "Buttstädt",
                        "latitude": "51.12227000",
                        "longitude": "11.41721000"
                    },
                    {
                        "id": 24509,
                        "name": "Büttstedt",
                        "latitude": "51.25972000",
                        "longitude": "10.30636000"
                    },
                    {
                        "id": 24520,
                        "name": "Camburg",
                        "latitude": "51.05524000",
                        "longitude": "11.70967000"
                    },
                    {
                        "id": 24542,
                        "name": "Clingen",
                        "latitude": "51.23206000",
                        "longitude": "10.93281000"
                    },
                    {
                        "id": 24558,
                        "name": "Crawinkel",
                        "latitude": "50.78333000",
                        "longitude": "10.78333000"
                    },
                    {
                        "id": 24561,
                        "name": "Creuzburg",
                        "latitude": "51.05288000",
                        "longitude": "10.24750000"
                    },
                    {
                        "id": 24576,
                        "name": "Dachwig",
                        "latitude": "51.07770000",
                        "longitude": "10.85479000"
                    },
                    {
                        "id": 24590,
                        "name": "Dankmarshausen",
                        "latitude": "50.92527000",
                        "longitude": "10.01601000"
                    },
                    {
                        "id": 24637,
                        "name": "Dermbach",
                        "latitude": "50.71383000",
                        "longitude": "10.11839000"
                    },
                    {
                        "id": 24657,
                        "name": "Deuna",
                        "latitude": "51.35450000",
                        "longitude": "10.47439000"
                    },
                    {
                        "id": 24692,
                        "name": "Dingelstädt",
                        "latitude": "51.31529000",
                        "longitude": "10.31740000"
                    },
                    {
                        "id": 24699,
                        "name": "Dippach",
                        "latitude": "50.91959000",
                        "longitude": "10.04236000"
                    },
                    {
                        "id": 24797,
                        "name": "Döllstädt",
                        "latitude": "51.08333000",
                        "longitude": "10.81667000"
                    },
                    {
                        "id": 24741,
                        "name": "Dorndorf",
                        "latitude": "50.83472000",
                        "longitude": "10.08921000"
                    },
                    {
                        "id": 24820,
                        "name": "Ebeleben",
                        "latitude": "51.28283000",
                        "longitude": "10.72999000"
                    },
                    {
                        "id": 24862,
                        "name": "Effelder",
                        "latitude": "51.23948000",
                        "longitude": "10.24778000"
                    },
                    {
                        "id": 24924,
                        "name": "Eisenach",
                        "latitude": "50.98070000",
                        "longitude": "10.31522000"
                    },
                    {
                        "id": 24926,
                        "name": "Eisenberg",
                        "latitude": "50.96860000",
                        "longitude": "11.90207000"
                    },
                    {
                        "id": 24930,
                        "name": "Eisfeld",
                        "latitude": "50.42648000",
                        "longitude": "10.90695000"
                    },
                    {
                        "id": 24944,
                        "name": "Elgersburg",
                        "latitude": "50.70603000",
                        "longitude": "10.85310000"
                    },
                    {
                        "id": 24955,
                        "name": "Ellrich",
                        "latitude": "51.58656000",
                        "longitude": "10.66326000"
                    },
                    {
                        "id": 24977,
                        "name": "Elxleben",
                        "latitude": "51.05000000",
                        "longitude": "10.95000000"
                    },
                    {
                        "id": 25038,
                        "name": "Erfurt",
                        "latitude": "50.97870000",
                        "longitude": "11.03283000"
                    },
                    {
                        "id": 25065,
                        "name": "Ernstroda",
                        "latitude": "50.86484000",
                        "longitude": "10.62056000"
                    },
                    {
                        "id": 25141,
                        "name": "Fambach",
                        "latitude": "50.73333000",
                        "longitude": "10.36667000"
                    },
                    {
                        "id": 25175,
                        "name": "Finsterbergen",
                        "latitude": "50.83464000",
                        "longitude": "10.58916000"
                    },
                    {
                        "id": 25323,
                        "name": "Föritz",
                        "latitude": "50.34174000",
                        "longitude": "11.23180000"
                    },
                    {
                        "id": 25215,
                        "name": "Frankenheim",
                        "latitude": "50.54452000",
                        "longitude": "10.06828000"
                    },
                    {
                        "id": 25229,
                        "name": "Frauenprießnitz",
                        "latitude": "51.01667000",
                        "longitude": "11.73333000"
                    },
                    {
                        "id": 25231,
                        "name": "Frauenwald",
                        "latitude": "50.58430000",
                        "longitude": "10.85841000"
                    },
                    {
                        "id": 25243,
                        "name": "Freienbessingen",
                        "latitude": "51.23333000",
                        "longitude": "10.76667000"
                    },
                    {
                        "id": 25284,
                        "name": "Friedrichroda",
                        "latitude": "50.85754000",
                        "longitude": "10.56507000"
                    },
                    {
                        "id": 25296,
                        "name": "Friemar",
                        "latitude": "50.97702000",
                        "longitude": "10.78851000"
                    },
                    {
                        "id": 25359,
                        "name": "Gangloffsömmern",
                        "latitude": "51.18940000",
                        "longitude": "10.94332000"
                    },
                    {
                        "id": 25384,
                        "name": "Gebesee",
                        "latitude": "51.11488000",
                        "longitude": "10.93455000"
                    },
                    {
                        "id": 154478,
                        "name": "Gefell",
                        "latitude": "50.43737680",
                        "longitude": "11.66059250"
                    },
                    {
                        "id": 25394,
                        "name": "Gehren",
                        "latitude": "50.64852000",
                        "longitude": "11.00471000"
                    },
                    {
                        "id": 25397,
                        "name": "Geisa",
                        "latitude": "50.71465000",
                        "longitude": "9.95075000"
                    },
                    {
                        "id": 25406,
                        "name": "Geisleden",
                        "latitude": "51.35000000",
                        "longitude": "10.20000000"
                    },
                    {
                        "id": 25409,
                        "name": "Geismar",
                        "latitude": "51.23169000",
                        "longitude": "10.16548000"
                    },
                    {
                        "id": 25431,
                        "name": "Georgenthal",
                        "latitude": "50.83205000",
                        "longitude": "10.66266000"
                    },
                    {
                        "id": 25434,
                        "name": "Gera",
                        "latitude": "50.88029000",
                        "longitude": "12.08187000"
                    },
                    {
                        "id": 25435,
                        "name": "Geraberg",
                        "latitude": "50.71594000",
                        "longitude": "10.83737000"
                    },
                    {
                        "id": 25448,
                        "name": "Gernrode",
                        "latitude": "51.40000000",
                        "longitude": "10.40000000"
                    },
                    {
                        "id": 25464,
                        "name": "Gerstungen",
                        "latitude": "50.96667000",
                        "longitude": "10.06667000"
                    },
                    {
                        "id": 25469,
                        "name": "Geschwenda",
                        "latitude": "50.73178000",
                        "longitude": "10.82540000"
                    },
                    {
                        "id": 25511,
                        "name": "Gleichamberg",
                        "latitude": "50.37068000",
                        "longitude": "10.59822000"
                    },
                    {
                        "id": 25529,
                        "name": "Goldbach",
                        "latitude": "51.04566000",
                        "longitude": "11.43289000"
                    },
                    {
                        "id": 25783,
                        "name": "Görsbach",
                        "latitude": "51.46224000",
                        "longitude": "10.93706000"
                    },
                    {
                        "id": 25789,
                        "name": "Gößnitz",
                        "latitude": "50.88902000",
                        "longitude": "12.43292000"
                    },
                    {
                        "id": 25554,
                        "name": "Goßwitz",
                        "latitude": "50.63536000",
                        "longitude": "11.47737000"
                    },
                    {
                        "id": 25549,
                        "name": "Gotha",
                        "latitude": "50.94823000",
                        "longitude": "10.70193000"
                    },
                    {
                        "id": 25561,
                        "name": "Grabsleben",
                        "latitude": "50.93633000",
                        "longitude": "10.83508000"
                    },
                    {
                        "id": 25723,
                        "name": "Gräfenhain",
                        "latitude": "50.81667000",
                        "longitude": "10.70000000"
                    },
                    {
                        "id": 25725,
                        "name": "Gräfenroda",
                        "latitude": "50.74781000",
                        "longitude": "10.81063000"
                    },
                    {
                        "id": 25595,
                        "name": "Greiz",
                        "latitude": "50.65778000",
                        "longitude": "12.19918000"
                    },
                    {
                        "id": 25602,
                        "name": "Greußen",
                        "latitude": "51.22964000",
                        "longitude": "10.94422000"
                    },
                    {
                        "id": 25652,
                        "name": "Großbartloff",
                        "latitude": "51.25000000",
                        "longitude": "10.21667000"
                    },
                    {
                        "id": 25655,
                        "name": "Großbodungen",
                        "latitude": "51.47572000",
                        "longitude": "10.48104000"
                    },
                    {
                        "id": 25658,
                        "name": "Großbreitenbach",
                        "latitude": "50.58335000",
                        "longitude": "11.00955000"
                    },
                    {
                        "id": 25662,
                        "name": "Großenehrich",
                        "latitude": "51.24838000",
                        "longitude": "10.83458000"
                    },
                    {
                        "id": 25663,
                        "name": "Großengottern",
                        "latitude": "51.14821000",
                        "longitude": "10.56232000"
                    },
                    {
                        "id": 25669,
                        "name": "Großenstein",
                        "latitude": "50.90000000",
                        "longitude": "12.20000000"
                    },
                    {
                        "id": 25692,
                        "name": "Großmonra",
                        "latitude": "51.21299000",
                        "longitude": "11.29578000"
                    },
                    {
                        "id": 25702,
                        "name": "Großrudestedt",
                        "latitude": "51.09305000",
                        "longitude": "11.09977000"
                    },
                    {
                        "id": 25835,
                        "name": "Haina",
                        "latitude": "50.98971000",
                        "longitude": "10.51774000"
                    },
                    {
                        "id": 25963,
                        "name": "Haßleben",
                        "latitude": "51.10878000",
                        "longitude": "10.99637000"
                    },
                    {
                        "id": 25993,
                        "name": "Heilbad Heiligenstadt",
                        "latitude": "51.37819000",
                        "longitude": "10.13744000"
                    },
                    {
                        "id": 26021,
                        "name": "Heldrungen",
                        "latitude": "51.30208000",
                        "longitude": "11.21816000"
                    },
                    {
                        "id": 26027,
                        "name": "Hellingen",
                        "latitude": "50.25000000",
                        "longitude": "10.68333000"
                    },
                    {
                        "id": 26061,
                        "name": "Herbsleben",
                        "latitude": "51.11667000",
                        "longitude": "10.83333000"
                    },
                    {
                        "id": 26071,
                        "name": "Heringen",
                        "latitude": "51.44705000",
                        "longitude": "10.87612000"
                    },
                    {
                        "id": 26079,
                        "name": "Hermsdorf",
                        "latitude": "50.89694000",
                        "longitude": "11.85549000"
                    },
                    {
                        "id": 26093,
                        "name": "Herschdorf",
                        "latitude": "50.71168000",
                        "longitude": "11.53736000"
                    },
                    {
                        "id": 26126,
                        "name": "Heyerode",
                        "latitude": "51.16439000",
                        "longitude": "10.32009000"
                    },
                    {
                        "id": 26134,
                        "name": "Hildburghausen",
                        "latitude": "50.42553000",
                        "longitude": "10.73184000"
                    },
                    {
                        "id": 154480,
                        "name": "Hirschberg",
                        "latitude": "50.41822460",
                        "longitude": "11.73012200"
                    },
                    {
                        "id": 26209,
                        "name": "Hohenleuben",
                        "latitude": "50.71128000",
                        "longitude": "12.05427000"
                    },
                    {
                        "id": 26320,
                        "name": "Hörselgau",
                        "latitude": "50.91988000",
                        "longitude": "10.58444000"
                    },
                    {
                        "id": 26286,
                        "name": "Hundeshagen",
                        "latitude": "51.43333000",
                        "longitude": "10.28333000"
                    },
                    {
                        "id": 26348,
                        "name": "Ichtershausen",
                        "latitude": "50.87602000",
                        "longitude": "10.97028000"
                    },
                    {
                        "id": 26354,
                        "name": "Ifta",
                        "latitude": "51.06667000",
                        "longitude": "10.18333000"
                    },
                    {
                        "id": 26365,
                        "name": "Ilfeld",
                        "latitude": "51.57570000",
                        "longitude": "10.78469000"
                    },
                    {
                        "id": 26372,
                        "name": "Ilmenau",
                        "latitude": "50.68322000",
                        "longitude": "10.91858000"
                    },
                    {
                        "id": 26379,
                        "name": "Immelborn",
                        "latitude": "50.79229000",
                        "longitude": "10.27812000"
                    },
                    {
                        "id": 26390,
                        "name": "Ingersleben",
                        "latitude": "50.92167000",
                        "longitude": "10.93646000"
                    },
                    {
                        "id": 26435,
                        "name": "Jena",
                        "latitude": "50.92878000",
                        "longitude": "11.58990000"
                    },
                    {
                        "id": 26471,
                        "name": "Jüchsen",
                        "latitude": "50.47993000",
                        "longitude": "10.50183000"
                    },
                    {
                        "id": 26459,
                        "name": "Judenbach",
                        "latitude": "50.39591000",
                        "longitude": "11.22099000"
                    },
                    {
                        "id": 26480,
                        "name": "Kahla",
                        "latitude": "50.80651000",
                        "longitude": "11.58516000"
                    },
                    {
                        "id": 26497,
                        "name": "Kaltennordheim",
                        "latitude": "50.62649000",
                        "longitude": "10.15915000"
                    },
                    {
                        "id": 26498,
                        "name": "Kaltenwestheim",
                        "latitude": "50.60991000",
                        "longitude": "10.11692000"
                    },
                    {
                        "id": 26504,
                        "name": "Kamsdorf",
                        "latitude": "50.64312000",
                        "longitude": "11.45401000"
                    },
                    {
                        "id": 26507,
                        "name": "Kannawurf",
                        "latitude": "51.26667000",
                        "longitude": "11.13333000"
                    },
                    {
                        "id": 26535,
                        "name": "Katharinenberg",
                        "latitude": "51.18137000",
                        "longitude": "10.26084000"
                    },
                    {
                        "id": 26538,
                        "name": "Katzhütte",
                        "latitude": "50.55191000",
                        "longitude": "11.05293000"
                    },
                    {
                        "id": 26546,
                        "name": "Kaulsdorf",
                        "latitude": "50.61670000",
                        "longitude": "11.43295000"
                    },
                    {
                        "id": 26588,
                        "name": "Kindelbrück",
                        "latitude": "51.26171000",
                        "longitude": "11.08999000"
                    },
                    {
                        "id": 26618,
                        "name": "Kirchheim",
                        "latitude": "50.88333000",
                        "longitude": "11.01667000"
                    },
                    {
                        "id": 26638,
                        "name": "Kirchworbis",
                        "latitude": "51.41122000",
                        "longitude": "10.39625000"
                    },
                    {
                        "id": 26671,
                        "name": "Kleinfurra",
                        "latitude": "51.41556000",
                        "longitude": "10.76454000"
                    },
                    {
                        "id": 26681,
                        "name": "Kleinwenden",
                        "latitude": "51.41611000",
                        "longitude": "10.65902000"
                    },
                    {
                        "id": 26682,
                        "name": "Klettbach",
                        "latitude": "50.91667000",
                        "longitude": "11.15000000"
                    },
                    {
                        "id": 26816,
                        "name": "Kölleda",
                        "latitude": "51.18745000",
                        "longitude": "11.24488000"
                    },
                    {
                        "id": 26828,
                        "name": "Königsee",
                        "latitude": "50.66143000",
                        "longitude": "11.09748000"
                    },
                    {
                        "id": 26840,
                        "name": "Könitz",
                        "latitude": "50.64979000",
                        "longitude": "11.48809000"
                    },
                    {
                        "id": 26844,
                        "name": "Körner",
                        "latitude": "51.23126000",
                        "longitude": "10.58878000"
                    },
                    {
                        "id": 26733,
                        "name": "Kraftsdorf",
                        "latitude": "50.87574000",
                        "longitude": "11.92944000"
                    },
                    {
                        "id": 26740,
                        "name": "Kranichfeld",
                        "latitude": "50.85446000",
                        "longitude": "11.20057000"
                    },
                    {
                        "id": 26743,
                        "name": "Krauthausen",
                        "latitude": "51.01667000",
                        "longitude": "10.26667000"
                    },
                    {
                        "id": 26760,
                        "name": "Kriebitzsch",
                        "latitude": "51.02347000",
                        "longitude": "12.33318000"
                    },
                    {
                        "id": 26782,
                        "name": "Krölpa",
                        "latitude": "50.67743000",
                        "longitude": "11.53848000"
                    },
                    {
                        "id": 26766,
                        "name": "Kromsdorf",
                        "latitude": "51.00000000",
                        "longitude": "11.36667000"
                    },
                    {
                        "id": 26850,
                        "name": "Kühndorf",
                        "latitude": "50.60860000",
                        "longitude": "10.48940000"
                    },
                    {
                        "id": 26852,
                        "name": "Küllstedt",
                        "latitude": "51.27582000",
                        "longitude": "10.28040000"
                    },
                    {
                        "id": 26926,
                        "name": "Langenorla",
                        "latitude": "50.74067000",
                        "longitude": "11.58023000"
                    },
                    {
                        "id": 26931,
                        "name": "Langenwetzendorf",
                        "latitude": "50.67884000",
                        "longitude": "12.09407000"
                    },
                    {
                        "id": 26936,
                        "name": "Langewiesen",
                        "latitude": "50.67252000",
                        "longitude": "10.97102000"
                    },
                    {
                        "id": 26943,
                        "name": "Langula",
                        "latitude": "51.15001000",
                        "longitude": "10.41670000"
                    },
                    {
                        "id": 26962,
                        "name": "Lauchröden",
                        "latitude": "50.99371000",
                        "longitude": "10.15694000"
                    },
                    {
                        "id": 26980,
                        "name": "Lauscha",
                        "latitude": "50.47687000",
                        "longitude": "11.15962000"
                    },
                    {
                        "id": 27007,
                        "name": "Lehesten",
                        "latitude": "50.98333000",
                        "longitude": "11.58333000"
                    },
                    {
                        "id": 27019,
                        "name": "Leimbach",
                        "latitude": "50.81667000",
                        "longitude": "10.20000000"
                    },
                    {
                        "id": 27023,
                        "name": "Leinefelde-Worbis",
                        "latitude": "51.38796000",
                        "longitude": "10.32620000"
                    },
                    {
                        "id": 27066,
                        "name": "Leutenberg",
                        "latitude": "50.56354000",
                        "longitude": "11.45619000"
                    },
                    {
                        "id": 27074,
                        "name": "Lichte",
                        "latitude": "50.51667000",
                        "longitude": "11.18333000"
                    },
                    {
                        "id": 27188,
                        "name": "Löbichau",
                        "latitude": "50.89383000",
                        "longitude": "12.26366000"
                    },
                    {
                        "id": 27159,
                        "name": "Lucka",
                        "latitude": "51.09727000",
                        "longitude": "12.33336000"
                    },
                    {
                        "id": 27172,
                        "name": "Luisenthal",
                        "latitude": "50.78333000",
                        "longitude": "10.73333000"
                    },
                    {
                        "id": 27229,
                        "name": "Magdala",
                        "latitude": "50.90698000",
                        "longitude": "11.44801000"
                    },
                    {
                        "id": 27292,
                        "name": "Marksuhl",
                        "latitude": "50.91667000",
                        "longitude": "10.20000000"
                    },
                    {
                        "id": 27339,
                        "name": "Masserberg",
                        "latitude": "50.51981000",
                        "longitude": "10.97087000"
                    },
                    {
                        "id": 27355,
                        "name": "Mechterstädt",
                        "latitude": "50.94201000",
                        "longitude": "10.52380000"
                    },
                    {
                        "id": 27383,
                        "name": "Meiningen",
                        "latitude": "50.56787000",
                        "longitude": "10.41521000"
                    },
                    {
                        "id": 27394,
                        "name": "Mellenbach-Glasbach",
                        "latitude": "50.61667000",
                        "longitude": "11.10000000"
                    },
                    {
                        "id": 27395,
                        "name": "Mellingen",
                        "latitude": "50.94123000",
                        "longitude": "11.39640000"
                    },
                    {
                        "id": 27408,
                        "name": "Mengersgereuth-Hämmern",
                        "latitude": "50.39730000",
                        "longitude": "11.11649000"
                    },
                    {
                        "id": 27412,
                        "name": "Menteroda",
                        "latitude": "51.30763000",
                        "longitude": "10.56323000"
                    },
                    {
                        "id": 27446,
                        "name": "Meuselbach",
                        "latitude": "50.57152000",
                        "longitude": "11.09143000"
                    },
                    {
                        "id": 27447,
                        "name": "Meuselwitz",
                        "latitude": "51.04315000",
                        "longitude": "12.29935000"
                    },
                    {
                        "id": 27464,
                        "name": "Mihla",
                        "latitude": "51.07617000",
                        "longitude": "10.33175000"
                    },
                    {
                        "id": 27470,
                        "name": "Milz",
                        "latitude": "50.37760000",
                        "longitude": "10.53757000"
                    },
                    {
                        "id": 27501,
                        "name": "Mohlsdorf",
                        "latitude": "50.66974000",
                        "longitude": "12.26519000"
                    },
                    {
                        "id": 27506,
                        "name": "Molschleben",
                        "latitude": "51.00000000",
                        "longitude": "10.78333000"
                    },
                    {
                        "id": 27569,
                        "name": "Mönchenholzhausen",
                        "latitude": "50.96667000",
                        "longitude": "11.15000000"
                    },
                    {
                        "id": 27596,
                        "name": "Mühlhausen",
                        "latitude": "51.20896000",
                        "longitude": "10.45275000"
                    },
                    {
                        "id": 27611,
                        "name": "Münchenbernsdorf",
                        "latitude": "50.82114000",
                        "longitude": "11.93226000"
                    },
                    {
                        "id": 27712,
                        "name": "Neudietendorf",
                        "latitude": "50.91250000",
                        "longitude": "10.91346000"
                    },
                    {
                        "id": 27739,
                        "name": "Neuhaus",
                        "latitude": "50.68333000",
                        "longitude": "10.93333000"
                    },
                    {
                        "id": 27741,
                        "name": "Neuhaus am Rennweg",
                        "latitude": "50.51006000",
                        "longitude": "11.13787000"
                    },
                    {
                        "id": 27744,
                        "name": "Neuhaus-Schierschnitz",
                        "latitude": "50.31237000",
                        "longitude": "11.24019000"
                    },
                    {
                        "id": 27798,
                        "name": "Neustadt am Rennsteig",
                        "latitude": "50.58333000",
                        "longitude": "10.93333000"
                    },
                    {
                        "id": 27802,
                        "name": "Neustadt an der Orla",
                        "latitude": "50.73640000",
                        "longitude": "11.74619000"
                    },
                    {
                        "id": 27839,
                        "name": "Niederdorla",
                        "latitude": "51.16025000",
                        "longitude": "10.44820000"
                    },
                    {
                        "id": 27866,
                        "name": "Niederorschel",
                        "latitude": "51.37222000",
                        "longitude": "10.42372000"
                    },
                    {
                        "id": 27869,
                        "name": "Niederroßla",
                        "latitude": "51.03333000",
                        "longitude": "11.48333000"
                    },
                    {
                        "id": 27870,
                        "name": "Niedersachswerfen",
                        "latitude": "51.55062000",
                        "longitude": "10.76594000"
                    },
                    {
                        "id": 27886,
                        "name": "Niederzimmern",
                        "latitude": "51.00476000",
                        "longitude": "11.19028000"
                    },
                    {
                        "id": 27945,
                        "name": "Nöbdenitz",
                        "latitude": "50.86667000",
                        "longitude": "12.28333000"
                    },
                    {
                        "id": 27906,
                        "name": "Nobitz",
                        "latitude": "50.97621000",
                        "longitude": "12.48605000"
                    },
                    {
                        "id": 27908,
                        "name": "Nohra",
                        "latitude": "50.96136000",
                        "longitude": "11.25971000"
                    },
                    {
                        "id": 27919,
                        "name": "Nordhausen",
                        "latitude": "51.50180000",
                        "longitude": "10.79570000"
                    },
                    {
                        "id": 27974,
                        "name": "Oberdorla",
                        "latitude": "51.16585000",
                        "longitude": "10.42163000"
                    },
                    {
                        "id": 27987,
                        "name": "Oberhof",
                        "latitude": "50.70435000",
                        "longitude": "10.72716000"
                    },
                    {
                        "id": 27996,
                        "name": "Obermaßfeld-Grimmenthal",
                        "latitude": "50.52898000",
                        "longitude": "10.43963000"
                    },
                    {
                        "id": 27997,
                        "name": "Obermehler",
                        "latitude": "51.26996000",
                        "longitude": "10.59754000"
                    },
                    {
                        "id": 28053,
                        "name": "Oberweißbach",
                        "latitude": "50.58231000",
                        "longitude": "11.14382000"
                    },
                    {
                        "id": 28110,
                        "name": "Oldisleben",
                        "latitude": "51.30975000",
                        "longitude": "11.17112000"
                    },
                    {
                        "id": 28122,
                        "name": "Oppurg",
                        "latitude": "50.71065000",
                        "longitude": "11.65289000"
                    },
                    {
                        "id": 28126,
                        "name": "Orlamünde",
                        "latitude": "50.77486000",
                        "longitude": "11.51929000"
                    },
                    {
                        "id": 28207,
                        "name": "Oßmanstedt",
                        "latitude": "51.01815000",
                        "longitude": "11.42746000"
                    },
                    {
                        "id": 28221,
                        "name": "Pappenheim",
                        "latitude": "50.79631000",
                        "longitude": "10.47489000"
                    },
                    {
                        "id": 28318,
                        "name": "Plaue",
                        "latitude": "50.77835000",
                        "longitude": "10.89969000"
                    },
                    {
                        "id": 28417,
                        "name": "Pölzig",
                        "latitude": "50.95000000",
                        "longitude": "12.20000000"
                    },
                    {
                        "id": 28350,
                        "name": "Ponitz",
                        "latitude": "50.85762000",
                        "longitude": "12.42309000"
                    },
                    {
                        "id": 28420,
                        "name": "Pößneck",
                        "latitude": "50.69358000",
                        "longitude": "11.59229000"
                    },
                    {
                        "id": 28394,
                        "name": "Probstzella",
                        "latitude": "50.53333000",
                        "longitude": "11.38333000"
                    },
                    {
                        "id": 28472,
                        "name": "Ranis",
                        "latitude": "50.66132000",
                        "longitude": "11.56912000"
                    },
                    {
                        "id": 28481,
                        "name": "Rastenberg",
                        "latitude": "51.17496000",
                        "longitude": "11.42029000"
                    },
                    {
                        "id": 28575,
                        "name": "Remptendorf",
                        "latitude": "50.53333000",
                        "longitude": "11.65000000"
                    },
                    {
                        "id": 28652,
                        "name": "Riethnordhausen",
                        "latitude": "51.08333000",
                        "longitude": "11.00000000"
                    },
                    {
                        "id": 28662,
                        "name": "Ringleben",
                        "latitude": "51.36667000",
                        "longitude": "11.21667000"
                    },
                    {
                        "id": 28688,
                        "name": "Rohr",
                        "latitude": "50.57644000",
                        "longitude": "10.49725000"
                    },
                    {
                        "id": 28785,
                        "name": "Römhild",
                        "latitude": "50.39639000",
                        "longitude": "10.53889000"
                    },
                    {
                        "id": 28698,
                        "name": "Ronneburg",
                        "latitude": "50.86340000",
                        "longitude": "12.18666000"
                    },
                    {
                        "id": 153781,
                        "name": "Rosenthal am Rennsteig",
                        "latitude": "50.41869230",
                        "longitude": "11.49320040"
                    },
                    {
                        "id": 28711,
                        "name": "Rositz",
                        "latitude": "51.01728000",
                        "longitude": "12.36354000"
                    },
                    {
                        "id": 28745,
                        "name": "Roßleben",
                        "latitude": "51.29886000",
                        "longitude": "11.43435000"
                    },
                    {
                        "id": 28728,
                        "name": "Rothenstein",
                        "latitude": "50.85000000",
                        "longitude": "11.60000000"
                    },
                    {
                        "id": 28732,
                        "name": "Rottenbach",
                        "latitude": "50.68782000",
                        "longitude": "11.16674000"
                    },
                    {
                        "id": 28752,
                        "name": "Rudolstadt",
                        "latitude": "50.72043000",
                        "longitude": "11.34046000"
                    },
                    {
                        "id": 28755,
                        "name": "Ruhla",
                        "latitude": "50.89296000",
                        "longitude": "10.36573000"
                    },
                    {
                        "id": 28814,
                        "name": "Saalfeld",
                        "latitude": "50.64826000",
                        "longitude": "11.36536000"
                    },
                    {
                        "id": 28815,
                        "name": "Saara",
                        "latitude": "50.93284000",
                        "longitude": "12.42096000"
                    },
                    {
                        "id": 28865,
                        "name": "Sankt Gangloff",
                        "latitude": "50.85522000",
                        "longitude": "11.89446000"
                    },
                    {
                        "id": 28873,
                        "name": "Sankt Kilian",
                        "latitude": "50.52749000",
                        "longitude": "10.76301000"
                    },
                    {
                        "id": 28906,
                        "name": "Schalkau",
                        "latitude": "50.39536000",
                        "longitude": "11.00732000"
                    },
                    {
                        "id": 28934,
                        "name": "Schernberg",
                        "latitude": "51.32774000",
                        "longitude": "10.76928000"
                    },
                    {
                        "id": 28957,
                        "name": "Schkölen",
                        "latitude": "51.04166000",
                        "longitude": "11.82141000"
                    },
                    {
                        "id": 28968,
                        "name": "Schleid",
                        "latitude": "50.70000000",
                        "longitude": "9.96667000"
                    },
                    {
                        "id": 28971,
                        "name": "Schleiz",
                        "latitude": "50.57866000",
                        "longitude": "11.81024000"
                    },
                    {
                        "id": 28974,
                        "name": "Schleusingen",
                        "latitude": "50.51076000",
                        "longitude": "10.75658000"
                    },
                    {
                        "id": 28982,
                        "name": "Schloßvippach",
                        "latitude": "51.10499000",
                        "longitude": "11.14512000"
                    },
                    {
                        "id": 28981,
                        "name": "Schlotheim",
                        "latitude": "51.24643000",
                        "longitude": "10.65842000"
                    },
                    {
                        "id": 28987,
                        "name": "Schmalkalden",
                        "latitude": "50.72136000",
                        "longitude": "10.44386000"
                    },
                    {
                        "id": 28995,
                        "name": "Schmiedefeld",
                        "latitude": "50.53333000",
                        "longitude": "11.21667000"
                    },
                    {
                        "id": 28996,
                        "name": "Schmiedefeld am Rennsteig",
                        "latitude": "50.60863000",
                        "longitude": "10.81284000"
                    },
                    {
                        "id": 28999,
                        "name": "Schmölln",
                        "latitude": "50.89678000",
                        "longitude": "12.35339000"
                    },
                    {
                        "id": 29130,
                        "name": "Schönstedt",
                        "latitude": "51.12000000",
                        "longitude": "10.57743000"
                    },
                    {
                        "id": 29052,
                        "name": "Schwallungen",
                        "latitude": "50.69260000",
                        "longitude": "10.35706000"
                    },
                    {
                        "id": 29064,
                        "name": "Schwarza",
                        "latitude": "50.85386000",
                        "longitude": "11.32433000"
                    },
                    {
                        "id": 29082,
                        "name": "Schweina",
                        "latitude": "50.82502000",
                        "longitude": "10.33788000"
                    },
                    {
                        "id": 29142,
                        "name": "Seebach",
                        "latitude": "51.16506000",
                        "longitude": "10.51428000"
                    },
                    {
                        "id": 29146,
                        "name": "Seebergen",
                        "latitude": "50.92077000",
                        "longitude": "10.79920000"
                    },
                    {
                        "id": 29158,
                        "name": "Seelingstädt",
                        "latitude": "50.77266000",
                        "longitude": "12.24361000"
                    },
                    {
                        "id": 29252,
                        "name": "Sitzendorf",
                        "latitude": "50.63182000",
                        "longitude": "11.17215000"
                    },
                    {
                        "id": 29259,
                        "name": "Sollstedt",
                        "latitude": "51.30976000",
                        "longitude": "10.48810000"
                    },
                    {
                        "id": 29494,
                        "name": "Sömmerda",
                        "latitude": "51.15914000",
                        "longitude": "11.11524000"
                    },
                    {
                        "id": 29268,
                        "name": "Sondershausen",
                        "latitude": "51.36973000",
                        "longitude": "10.87011000"
                    },
                    {
                        "id": 29270,
                        "name": "Sonneberg",
                        "latitude": "50.35920000",
                        "longitude": "11.17463000"
                    },
                    {
                        "id": 29271,
                        "name": "Sonneborn",
                        "latitude": "50.99270000",
                        "longitude": "10.59173000"
                    },
                    {
                        "id": 29322,
                        "name": "Stadtilm",
                        "latitude": "50.77596000",
                        "longitude": "11.08262000"
                    },
                    {
                        "id": 29325,
                        "name": "Stadtlengsfeld",
                        "latitude": "50.78329000",
                        "longitude": "10.12918000"
                    },
                    {
                        "id": 29330,
                        "name": "Stadtroda",
                        "latitude": "50.85684000",
                        "longitude": "11.72677000"
                    },
                    {
                        "id": 29361,
                        "name": "Steinach",
                        "latitude": "50.43129000",
                        "longitude": "11.15909000"
                    },
                    {
                        "id": 29363,
                        "name": "Steinbach",
                        "latitude": "50.83321000",
                        "longitude": "10.36393000"
                    },
                    {
                        "id": 29366,
                        "name": "Steinbach-Hallenberg",
                        "latitude": "50.69624000",
                        "longitude": "10.56541000"
                    },
                    {
                        "id": 29378,
                        "name": "Steinheid",
                        "latitude": "50.46538000",
                        "longitude": "11.08265000"
                    },
                    {
                        "id": 29431,
                        "name": "Straußfurt",
                        "latitude": "51.16667000",
                        "longitude": "10.98333000"
                    },
                    {
                        "id": 29457,
                        "name": "Stützerbach",
                        "latitude": "50.63333000",
                        "longitude": "10.86667000"
                    },
                    {
                        "id": 29462,
                        "name": "Suhl",
                        "latitude": "50.60911000",
                        "longitude": "10.69401000"
                    },
                    {
                        "id": 29510,
                        "name": "Tabarz",
                        "latitude": "50.87529000",
                        "longitude": "10.51607000"
                    },
                    {
                        "id": 29515,
                        "name": "Tambach-Dietharz",
                        "latitude": "50.79245000",
                        "longitude": "10.61568000"
                    },
                    {
                        "id": 29522,
                        "name": "Tanna",
                        "latitude": "50.49460000",
                        "longitude": "11.85725000"
                    },
                    {
                        "id": 29540,
                        "name": "Tautenhain",
                        "latitude": "50.92470000",
                        "longitude": "11.91945000"
                    },
                    {
                        "id": 29547,
                        "name": "Teichwolframsdorf",
                        "latitude": "50.72093000",
                        "longitude": "12.24689000"
                    },
                    {
                        "id": 29551,
                        "name": "Teistungen",
                        "latitude": "51.46667000",
                        "longitude": "10.26667000"
                    },
                    {
                        "id": 29574,
                        "name": "Thal",
                        "latitude": "50.91684000",
                        "longitude": "10.39209000"
                    },
                    {
                        "id": 29590,
                        "name": "Themar",
                        "latitude": "50.50465000",
                        "longitude": "10.61536000"
                    },
                    {
                        "id": 29611,
                        "name": "Tiefenort",
                        "latitude": "50.83946000",
                        "longitude": "10.16604000"
                    },
                    {
                        "id": 29656,
                        "name": "Treffurt",
                        "latitude": "51.13691000",
                        "longitude": "10.23361000"
                    },
                    {
                        "id": 29667,
                        "name": "Triebes",
                        "latitude": "50.68489000",
                        "longitude": "12.02042000"
                    },
                    {
                        "id": 29673,
                        "name": "Triptis",
                        "latitude": "50.73567000",
                        "longitude": "11.87015000"
                    },
                    {
                        "id": 29685,
                        "name": "Trusetal",
                        "latitude": "50.78333000",
                        "longitude": "10.41667000"
                    },
                    {
                        "id": 29717,
                        "name": "Uder",
                        "latitude": "51.36243000",
                        "longitude": "10.07210000"
                    },
                    {
                        "id": 29753,
                        "name": "Unterbreizbach",
                        "latitude": "50.81667000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 29769,
                        "name": "Untermaßfeld",
                        "latitude": "50.53333000",
                        "longitude": "10.41667000"
                    },
                    {
                        "id": 29782,
                        "name": "Unterwellenborn",
                        "latitude": "50.65000000",
                        "longitude": "11.43333000"
                    },
                    {
                        "id": 29789,
                        "name": "Urbach",
                        "latitude": "51.29468000",
                        "longitude": "10.60540000"
                    },
                    {
                        "id": 29801,
                        "name": "Uthleben",
                        "latitude": "51.44912000",
                        "longitude": "10.83800000"
                    },
                    {
                        "id": 29807,
                        "name": "Vacha",
                        "latitude": "50.82790000",
                        "longitude": "10.02185000"
                    },
                    {
                        "id": 29820,
                        "name": "Veilsdorf",
                        "latitude": "50.40876000",
                        "longitude": "10.80947000"
                    },
                    {
                        "id": 29847,
                        "name": "Viernau",
                        "latitude": "50.66225000",
                        "longitude": "10.55778000"
                    },
                    {
                        "id": 29871,
                        "name": "Voigtstedt",
                        "latitude": "51.39169000",
                        "longitude": "11.30888000"
                    },
                    {
                        "id": 29891,
                        "name": "Völkershausen",
                        "latitude": "50.80000000",
                        "longitude": "10.05000000"
                    },
                    {
                        "id": 29971,
                        "name": "Walldorf",
                        "latitude": "50.61667000",
                        "longitude": "10.38333000"
                    },
                    {
                        "id": 29991,
                        "name": "Walschleben",
                        "latitude": "51.06667000",
                        "longitude": "10.93333000"
                    },
                    {
                        "id": 29995,
                        "name": "Waltershausen",
                        "latitude": "50.89827000",
                        "longitude": "10.55791000"
                    },
                    {
                        "id": 29997,
                        "name": "Wandersleben",
                        "latitude": "50.89946000",
                        "longitude": "10.84959000"
                    },
                    {
                        "id": 30038,
                        "name": "Wasungen",
                        "latitude": "50.66190000",
                        "longitude": "10.36947000"
                    },
                    {
                        "id": 30068,
                        "name": "Weida",
                        "latitude": "50.77449000",
                        "longitude": "12.06028000"
                    },
                    {
                        "id": 30096,
                        "name": "Weimar",
                        "latitude": "50.98030000",
                        "longitude": "11.32903000"
                    },
                    {
                        "id": 30125,
                        "name": "Weißenborn",
                        "latitude": "50.92393000",
                        "longitude": "11.87947000"
                    },
                    {
                        "id": 30127,
                        "name": "Weißenborn-Lüderode",
                        "latitude": "51.53190000",
                        "longitude": "10.41889000"
                    },
                    {
                        "id": 30135,
                        "name": "Weißensee",
                        "latitude": "51.19989000",
                        "longitude": "11.06914000"
                    },
                    {
                        "id": 30185,
                        "name": "Wernshausen",
                        "latitude": "50.72404000",
                        "longitude": "10.35086000"
                    },
                    {
                        "id": 30245,
                        "name": "Wiehe",
                        "latitude": "51.26586000",
                        "longitude": "11.41282000"
                    },
                    {
                        "id": 30319,
                        "name": "Windischleuba",
                        "latitude": "51.01556000",
                        "longitude": "12.46914000"
                    },
                    {
                        "id": 30321,
                        "name": "Wingerode",
                        "latitude": "51.39032000",
                        "longitude": "10.23954000"
                    },
                    {
                        "id": 30335,
                        "name": "Wintersdorf",
                        "latitude": "51.05320000",
                        "longitude": "12.35445000"
                    },
                    {
                        "id": 30338,
                        "name": "Wipperdorf",
                        "latitude": "51.45560000",
                        "longitude": "10.64388000"
                    },
                    {
                        "id": 30356,
                        "name": "Witterda",
                        "latitude": "51.03615000",
                        "longitude": "10.89028000"
                    },
                    {
                        "id": 30440,
                        "name": "Wölfis",
                        "latitude": "50.80825000",
                        "longitude": "10.77905000"
                    },
                    {
                        "id": 30392,
                        "name": "Wolkramshausen",
                        "latitude": "51.42185000",
                        "longitude": "10.73815000"
                    },
                    {
                        "id": 30404,
                        "name": "Worbis",
                        "latitude": "51.41997000",
                        "longitude": "10.36330000"
                    },
                    {
                        "id": 30457,
                        "name": "Wünschendorf",
                        "latitude": "50.79662000",
                        "longitude": "12.09824000"
                    },
                    {
                        "id": 30425,
                        "name": "Wurzbach",
                        "latitude": "50.46357000",
                        "longitude": "11.53779000"
                    },
                    {
                        "id": 30489,
                        "name": "Zella-Mehlis",
                        "latitude": "50.65642000",
                        "longitude": "10.66046000"
                    },
                    {
                        "id": 30498,
                        "name": "Zeulenroda",
                        "latitude": "50.65278000",
                        "longitude": "11.98377000"
                    },
                    {
                        "id": 154479,
                        "name": "Ziegenrück",
                        "latitude": "50.60971450",
                        "longitude": "11.61681810"
                    }
                ]
            }
        ]
    },
    {
        "id": 83,
        "name": "Ghana",
        "iso3": "GHA",
        "iso2": "GH",
        "numeric_code": "288",
        "phonecode": "233",
        "capital": "Accra",
        "currency": "GHS",
        "currency_name": "Ghanaian cedi",
        "currency_symbol": "GH₵",
        "tld": ".gh",
        "native": "Ghana",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Ghanaian",
        "timezones": [
            {
                "zoneName": "Africa\/Accra",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Ghana",
            "ko": "가나",
            "pt-BR": "Gana",
            "pt": "Gana",
            "nl": "Ghana",
            "hr": "Gana",
            "fa": "غنا",
            "de": "Ghana",
            "es": "Ghana",
            "fr": "Ghana",
            "ja": "ガーナ",
            "it": "Ghana",
            "zh-CN": "加纳",
            "tr": "Gana",
            "ru": "Гана",
            "uk": "Гана",
            "pl": "Ghana"
        },
        "latitude": "8.00000000",
        "longitude": "-2.00000000",
        "emoji": "🇬🇭",
        "emojiU": "U+1F1EC U+1F1ED",
        "states": [
            {
                "id": 53,
                "name": "Ahafo",
                "iso2": "AF",
                "latitude": "7.58213720",
                "longitude": "-2.54974630",
                "type": "region",
                "cities": [
                    {
                        "id": 149070,
                        "name": "Asunafo North",
                        "latitude": "6.81968910",
                        "longitude": "-2.80770500"
                    },
                    {
                        "id": 149071,
                        "name": "Asunafo South",
                        "latitude": "6.64801380",
                        "longitude": "-2.68874370"
                    },
                    {
                        "id": 149072,
                        "name": "Asutifi North",
                        "latitude": "6.94774860",
                        "longitude": "-2.76757160"
                    },
                    {
                        "id": 149073,
                        "name": "Asutifi South",
                        "latitude": "6.64801380",
                        "longitude": "-2.68874370"
                    },
                    {
                        "id": 149069,
                        "name": "Tano North",
                        "latitude": "7.22603010",
                        "longitude": "-2.30456560"
                    },
                    {
                        "id": 149068,
                        "name": "Tano South",
                        "latitude": "7.19537930",
                        "longitude": "-2.12586610"
                    }
                ]
            },
            {
                "id": 48,
                "name": "Ashanti",
                "iso2": "AH",
                "latitude": "6.74704360",
                "longitude": "-1.52086240",
                "type": "region",
                "cities": [
                    {
                        "id": 52151,
                        "name": "Agogo",
                        "latitude": "6.80004000",
                        "longitude": "-1.08193000"
                    },
                    {
                        "id": 52164,
                        "name": "Bekwai",
                        "latitude": "6.45195000",
                        "longitude": "-1.57866000"
                    },
                    {
                        "id": 52172,
                        "name": "Ejura",
                        "latitude": "7.38558000",
                        "longitude": "-1.35617000"
                    },
                    {
                        "id": 52185,
                        "name": "Konongo",
                        "latitude": "6.61667000",
                        "longitude": "-1.21667000"
                    },
                    {
                        "id": 52188,
                        "name": "Kumasi",
                        "latitude": "6.68848000",
                        "longitude": "-1.62443000"
                    },
                    {
                        "id": 52189,
                        "name": "Mampong",
                        "latitude": "7.06273000",
                        "longitude": "-1.40010000"
                    },
                    {
                        "id": 52196,
                        "name": "Obuase",
                        "latitude": "6.20228000",
                        "longitude": "-1.66796000"
                    },
                    {
                        "id": 52206,
                        "name": "Tafo",
                        "latitude": "6.73156000",
                        "longitude": "-1.61370000"
                    }
                ]
            },
            {
                "id": 4959,
                "name": "Bono",
                "iso2": "BO",
                "latitude": "7.65000000",
                "longitude": "-2.50000000",
                "type": "region",
                "cities": [
                    {
                        "id": 149086,
                        "name": "Banda",
                        "latitude": "8.14956710",
                        "longitude": "-2.36639500"
                    },
                    {
                        "id": 149087,
                        "name": "Berekum East",
                        "latitude": "7.51117580",
                        "longitude": "-2.75998310"
                    },
                    {
                        "id": 149088,
                        "name": "Berekum West",
                        "latitude": "7.51117580",
                        "longitude": "-2.75998310"
                    },
                    {
                        "id": 149089,
                        "name": "Dormaa Central",
                        "latitude": "7.27750000",
                        "longitude": "-2.87833300"
                    },
                    {
                        "id": 149090,
                        "name": "Dormaa East",
                        "latitude": "7.30000000",
                        "longitude": "-2.70000000"
                    },
                    {
                        "id": 149091,
                        "name": "Dormaa West",
                        "latitude": "7.01666700",
                        "longitude": "-3.05000000"
                    },
                    {
                        "id": 149092,
                        "name": "Jaman North",
                        "latitude": "7.98832340",
                        "longitude": "-2.96858690"
                    },
                    {
                        "id": 149093,
                        "name": "Jaman South",
                        "latitude": "7.70843750",
                        "longitude": "-3.07501700"
                    },
                    {
                        "id": 149094,
                        "name": "Sunyani",
                        "latitude": "7.33803320",
                        "longitude": "-2.34871460"
                    },
                    {
                        "id": 149095,
                        "name": "Sunyani West",
                        "latitude": "7.35660520",
                        "longitude": "-2.44618620"
                    },
                    {
                        "id": 149096,
                        "name": "Tain",
                        "latitude": "8.18114110",
                        "longitude": "-2.86487620"
                    },
                    {
                        "id": 149097,
                        "name": "Wenchi",
                        "latitude": "7.74059920",
                        "longitude": "-2.12267880"
                    }
                ]
            },
            {
                "id": 4958,
                "name": "Bono East",
                "iso2": "BE",
                "latitude": "7.75000000",
                "longitude": "-1.05000000",
                "type": "region",
                "cities": [
                    {
                        "id": 149076,
                        "name": "Atebubu-Amantin",
                        "latitude": "7.70237000",
                        "longitude": "-1.21979430"
                    },
                    {
                        "id": 149077,
                        "name": "Kintampo North",
                        "latitude": "8.39635790",
                        "longitude": "-1.82000070"
                    },
                    {
                        "id": 149078,
                        "name": "Kintampo South",
                        "latitude": "7.98971320",
                        "longitude": "-2.00711150"
                    },
                    {
                        "id": 149079,
                        "name": "Nkoranza North",
                        "latitude": "7.56603310",
                        "longitude": "-1.72365200"
                    },
                    {
                        "id": 149080,
                        "name": "Nkoranza South",
                        "latitude": "7.62405120",
                        "longitude": "-1.79974460"
                    },
                    {
                        "id": 149082,
                        "name": "Pru East",
                        "latitude": "8.22620000",
                        "longitude": "-0.65360000"
                    },
                    {
                        "id": 149081,
                        "name": "Pru West",
                        "latitude": "8.07359930",
                        "longitude": "-1.29055410"
                    },
                    {
                        "id": 149083,
                        "name": "Sene East",
                        "latitude": "7.78300000",
                        "longitude": "-0.21700000"
                    },
                    {
                        "id": 149084,
                        "name": "Sene West",
                        "latitude": "7.73420000",
                        "longitude": "-0.68180000"
                    },
                    {
                        "id": 149074,
                        "name": "Techiman",
                        "latitude": "7.58968560",
                        "longitude": "-1.95122140"
                    },
                    {
                        "id": 149075,
                        "name": "Techiman North",
                        "latitude": "7.70428020",
                        "longitude": "-2.08140570"
                    }
                ]
            },
            {
                "id": 52,
                "name": "Central",
                "iso2": "CP",
                "latitude": "5.50000000",
                "longitude": "-1.00000000",
                "type": "region",
                "cities": [
                    {
                        "id": 52157,
                        "name": "Apam",
                        "latitude": "5.28483000",
                        "longitude": "-0.73711000"
                    },
                    {
                        "id": 52168,
                        "name": "Cape Coast",
                        "latitude": "5.10535000",
                        "longitude": "-1.24660000"
                    },
                    {
                        "id": 52171,
                        "name": "Dunkwa",
                        "latitude": "5.95996000",
                        "longitude": "-1.77792000"
                    },
                    {
                        "id": 52173,
                        "name": "Elmina",
                        "latitude": "5.08470000",
                        "longitude": "-1.35093000"
                    },
                    {
                        "id": 52174,
                        "name": "Foso",
                        "latitude": "5.70119000",
                        "longitude": "-1.28657000"
                    },
                    {
                        "id": 52179,
                        "name": "Kasoa",
                        "latitude": "5.53449000",
                        "longitude": "-0.41679000"
                    },
                    {
                        "id": 52192,
                        "name": "Mumford",
                        "latitude": "5.26176000",
                        "longitude": "-0.75897000"
                    },
                    {
                        "id": 52199,
                        "name": "Saltpond",
                        "latitude": "5.20913000",
                        "longitude": "-1.06058000"
                    },
                    {
                        "id": 52205,
                        "name": "Swedru",
                        "latitude": "5.53711000",
                        "longitude": "-0.69984000"
                    },
                    {
                        "id": 52215,
                        "name": "Winneba",
                        "latitude": "5.35113000",
                        "longitude": "-0.62313000"
                    }
                ]
            },
            {
                "id": 50,
                "name": "Eastern",
                "iso2": "EP",
                "latitude": "6.50000000",
                "longitude": "-0.50000000",
                "type": "region",
                "cities": [
                    {
                        "id": 52148,
                        "name": "Aburi",
                        "latitude": "5.84802000",
                        "longitude": "-0.17449000"
                    },
                    {
                        "id": 52152,
                        "name": "Akim Oda",
                        "latitude": "5.92665000",
                        "longitude": "-0.98577000"
                    },
                    {
                        "id": 52153,
                        "name": "Akim Swedru",
                        "latitude": "5.89380000",
                        "longitude": "-1.01636000"
                    },
                    {
                        "id": 52154,
                        "name": "Akropong",
                        "latitude": "5.97462000",
                        "longitude": "-0.08542000"
                    },
                    {
                        "id": 52155,
                        "name": "Akwatia",
                        "latitude": "6.04024000",
                        "longitude": "-0.80876000"
                    },
                    {
                        "id": 52158,
                        "name": "Asamankese",
                        "latitude": "5.86006000",
                        "longitude": "-0.66350000"
                    },
                    {
                        "id": 52163,
                        "name": "Begoro",
                        "latitude": "6.38706000",
                        "longitude": "-0.37738000"
                    },
                    {
                        "id": 52182,
                        "name": "Kibi",
                        "latitude": "6.16494000",
                        "longitude": "-0.55376000"
                    },
                    {
                        "id": 52184,
                        "name": "Koforidua",
                        "latitude": "6.09408000",
                        "longitude": "-0.25913000"
                    },
                    {
                        "id": 52191,
                        "name": "Mpraeso",
                        "latitude": "6.59321000",
                        "longitude": "-0.73462000"
                    },
                    {
                        "id": 52194,
                        "name": "Nsawam",
                        "latitude": "5.80893000",
                        "longitude": "-0.35026000"
                    },
                    {
                        "id": 52203,
                        "name": "Suhum",
                        "latitude": "6.04089000",
                        "longitude": "-0.45004000"
                    }
                ]
            },
            {
                "id": 54,
                "name": "Greater Accra",
                "iso2": "AA",
                "latitude": "5.81428360",
                "longitude": "0.07467670",
                "type": "region",
                "cities": [
                    {
                        "id": 52149,
                        "name": "Accra",
                        "latitude": "5.55602000",
                        "longitude": "-0.19690000"
                    },
                    {
                        "id": 52159,
                        "name": "Atsiaman",
                        "latitude": "5.69775000",
                        "longitude": "-0.32824000"
                    },
                    {
                        "id": 52169,
                        "name": "Dome",
                        "latitude": "5.65003000",
                        "longitude": "-0.23610000"
                    },
                    {
                        "id": 52175,
                        "name": "Gbawe",
                        "latitude": "5.57692000",
                        "longitude": "-0.31038000"
                    },
                    {
                        "id": 52190,
                        "name": "Medina Estates",
                        "latitude": "5.66580000",
                        "longitude": "-0.16307000"
                    },
                    {
                        "id": 52195,
                        "name": "Nungua",
                        "latitude": "5.60105000",
                        "longitude": "-0.07713000"
                    },
                    {
                        "id": 52211,
                        "name": "Tema",
                        "latitude": "5.66980000",
                        "longitude": "-0.01657000"
                    },
                    {
                        "id": 52212,
                        "name": "Teshi Old Town",
                        "latitude": "5.58365000",
                        "longitude": "-0.10722000"
                    }
                ]
            },
            {
                "id": 4960,
                "name": "North East",
                "iso2": "NE",
                "latitude": "10.51666700",
                "longitude": "-0.36666700",
                "type": "region",
                "cities": [
                    {
                        "id": 149098,
                        "name": "Bunkpurugu-Nyakpanduri",
                        "latitude": "10.46609170",
                        "longitude": "-0.22711950"
                    },
                    {
                        "id": 149099,
                        "name": "Chereponi",
                        "latitude": "10.13827720",
                        "longitude": "0.28242580"
                    },
                    {
                        "id": 149100,
                        "name": "East Mamprusi",
                        "latitude": "10.42931860",
                        "longitude": "-0.53078850"
                    },
                    {
                        "id": 149101,
                        "name": "Mamprugu-Moagduri",
                        "latitude": "10.23290000",
                        "longitude": "-1.28360000"
                    },
                    {
                        "id": 149102,
                        "name": "West Mamprusi",
                        "latitude": "10.29906060",
                        "longitude": "-1.36750100"
                    },
                    {
                        "id": 149103,
                        "name": "Yunyoo-Nasuan",
                        "latitude": "10.48400000",
                        "longitude": "-0.00900000"
                    }
                ]
            },
            {
                "id": 51,
                "name": "Northern",
                "iso2": "NP",
                "latitude": "9.50000000",
                "longitude": "-1.00000000",
                "type": "region",
                "cities": [
                    {
                        "id": 52186,
                        "name": "Kpandae",
                        "latitude": "8.46885000",
                        "longitude": "-0.01127000"
                    },
                    {
                        "id": 52198,
                        "name": "Salaga",
                        "latitude": "8.55083000",
                        "longitude": "-0.51875000"
                    },
                    {
                        "id": 52200,
                        "name": "Savelugu",
                        "latitude": "9.62441000",
                        "longitude": "-0.82530000"
                    },
                    {
                        "id": 52208,
                        "name": "Tamale",
                        "latitude": "9.40079000",
                        "longitude": "-0.83930000"
                    },
                    {
                        "id": 52216,
                        "name": "Yendi",
                        "latitude": "9.44272000",
                        "longitude": "-0.00991000"
                    }
                ]
            },
            {
                "id": 4961,
                "name": "Oti",
                "iso2": "OT",
                "latitude": "7.90000000",
                "longitude": "0.30000000",
                "type": "region",
                "cities": [
                    {
                        "id": 149104,
                        "name": "Biakoye",
                        "latitude": "7.11698690",
                        "longitude": "0.32324300"
                    },
                    {
                        "id": 149105,
                        "name": "Jasikan",
                        "latitude": "7.40940880",
                        "longitude": "0.44301500"
                    },
                    {
                        "id": 149106,
                        "name": "Kadjebi",
                        "latitude": "7.52631920",
                        "longitude": "0.46704770"
                    },
                    {
                        "id": 149107,
                        "name": "Krachi East",
                        "latitude": "7.77196980",
                        "longitude": "-0.07763760"
                    },
                    {
                        "id": 149108,
                        "name": "Krachi Nchumuru",
                        "latitude": "8.14849800",
                        "longitude": "-0.16349880"
                    },
                    {
                        "id": 149109,
                        "name": "Krachi West",
                        "latitude": "7.98282160",
                        "longitude": "-0.34886270"
                    },
                    {
                        "id": 149110,
                        "name": "Nkwanta North",
                        "latitude": "8.35180760",
                        "longitude": "0.12217620"
                    },
                    {
                        "id": 149111,
                        "name": "Nkwanta South",
                        "latitude": "8.25931340",
                        "longitude": "0.50185190"
                    }
                ]
            },
            {
                "id": 4962,
                "name": "Savannah",
                "iso2": "SV",
                "latitude": "9.08333300",
                "longitude": "-1.81666700",
                "type": "region",
                "cities": [
                    {
                        "id": 149112,
                        "name": "Bole",
                        "latitude": "9.02996640",
                        "longitude": "-2.50694300"
                    },
                    {
                        "id": 149113,
                        "name": "Central Gonja",
                        "latitude": "8.92784320",
                        "longitude": "-1.95369720"
                    },
                    {
                        "id": 149115,
                        "name": "East Gonja",
                        "latitude": "8.72568400",
                        "longitude": "-1.07135790"
                    },
                    {
                        "id": 149116,
                        "name": "North East Gonja",
                        "latitude": "9.11746690",
                        "longitude": "-0.55579360"
                    },
                    {
                        "id": 149114,
                        "name": "North Gonja",
                        "latitude": "9.54130850",
                        "longitude": "-1.39766920"
                    },
                    {
                        "id": 149117,
                        "name": "Sawla-Tuna-Kalba",
                        "latitude": "9.39114570",
                        "longitude": "-2.70611660"
                    },
                    {
                        "id": 149118,
                        "name": "West Gonja",
                        "latitude": "9.57513170",
                        "longitude": "-2.26440410"
                    }
                ]
            },
            {
                "id": 55,
                "name": "Upper East",
                "iso2": "UE",
                "latitude": "10.70824990",
                "longitude": "-0.98206680",
                "type": "region",
                "cities": [
                    {
                        "id": 52161,
                        "name": "Bawku",
                        "latitude": "11.06160000",
                        "longitude": "-0.24169000"
                    },
                    {
                        "id": 52167,
                        "name": "Bolgatanga",
                        "latitude": "10.78556000",
                        "longitude": "-0.85139000"
                    },
                    {
                        "id": 52193,
                        "name": "Navrongo",
                        "latitude": "10.89557000",
                        "longitude": "-1.09210000"
                    }
                ]
            },
            {
                "id": 57,
                "name": "Upper West",
                "iso2": "UW",
                "latitude": "10.25297570",
                "longitude": "-2.14502450",
                "type": "region",
                "cities": [
                    {
                        "id": 52213,
                        "name": "Wa",
                        "latitude": "10.06069000",
                        "longitude": "-2.50192000"
                    }
                ]
            },
            {
                "id": 56,
                "name": "Volta",
                "iso2": "TV",
                "latitude": "6.57813730",
                "longitude": "0.45023680",
                "type": "region",
                "cities": [
                    {
                        "id": 52150,
                        "name": "Aflao",
                        "latitude": "6.11982000",
                        "longitude": "1.19012000"
                    },
                    {
                        "id": 52156,
                        "name": "Anloga",
                        "latitude": "5.79473000",
                        "longitude": "0.89728000"
                    },
                    {
                        "id": 52176,
                        "name": "Ho",
                        "latitude": "6.60084000",
                        "longitude": "0.47130000"
                    },
                    {
                        "id": 52177,
                        "name": "Hohoe",
                        "latitude": "7.15181000",
                        "longitude": "0.47362000"
                    },
                    {
                        "id": 52180,
                        "name": "Keta",
                        "latitude": "5.91793000",
                        "longitude": "0.98789000"
                    },
                    {
                        "id": 52181,
                        "name": "Kete Krachi",
                        "latitude": "7.79391000",
                        "longitude": "-0.04980000"
                    },
                    {
                        "id": 52187,
                        "name": "Kpandu",
                        "latitude": "6.99536000",
                        "longitude": "0.29306000"
                    }
                ]
            },
            {
                "id": 49,
                "name": "Western",
                "iso2": "WP",
                "latitude": "5.50000000",
                "longitude": "-2.50000000",
                "type": "region",
                "cities": [
                    {
                        "id": 52147,
                        "name": "Aboso",
                        "latitude": "5.36073000",
                        "longitude": "-1.94856000"
                    },
                    {
                        "id": 52160,
                        "name": "Axim",
                        "latitude": "4.86641000",
                        "longitude": "-2.24181000"
                    },
                    {
                        "id": 52166,
                        "name": "Bibiani",
                        "latitude": "6.46346000",
                        "longitude": "-2.31938000"
                    },
                    {
                        "id": 52197,
                        "name": "Prestea",
                        "latitude": "5.43385000",
                        "longitude": "-2.14295000"
                    },
                    {
                        "id": 52201,
                        "name": "Sekondi-Takoradi",
                        "latitude": "4.92678000",
                        "longitude": "-1.75773000"
                    },
                    {
                        "id": 52202,
                        "name": "Shama Junction",
                        "latitude": "5.01806000",
                        "longitude": "-1.66437000"
                    },
                    {
                        "id": 52207,
                        "name": "Takoradi",
                        "latitude": "4.89816000",
                        "longitude": "-1.76029000"
                    },
                    {
                        "id": 52209,
                        "name": "Tarkwa",
                        "latitude": "5.30383000",
                        "longitude": "-1.98956000"
                    }
                ]
            },
            {
                "id": 4963,
                "name": "Western North",
                "iso2": "WN",
                "latitude": "6.30000000",
                "longitude": "-2.80000000",
                "type": "region",
                "cities": [
                    {
                        "id": 149119,
                        "name": "Aowin",
                        "latitude": "5.75309280",
                        "longitude": "-3.07518870"
                    },
                    {
                        "id": 149120,
                        "name": "Bia East",
                        "latitude": "6.76860400",
                        "longitude": "-3.33302410"
                    },
                    {
                        "id": 149121,
                        "name": "Bia West",
                        "latitude": "6.76860400",
                        "longitude": "-3.33302410"
                    },
                    {
                        "id": 149122,
                        "name": "Bibiani-Anhwiaso-Bekwai",
                        "latitude": "6.30210040",
                        "longitude": "-2.35675070"
                    },
                    {
                        "id": 149123,
                        "name": "Bodi",
                        "latitude": "6.22240910",
                        "longitude": "-2.76615150"
                    },
                    {
                        "id": 149124,
                        "name": "Juaboso",
                        "latitude": "6.33331570",
                        "longitude": "-2.84206140"
                    },
                    {
                        "id": 149125,
                        "name": "Sefwi-Akontombra",
                        "latitude": "6.04285480",
                        "longitude": "-2.88133620"
                    },
                    {
                        "id": 149126,
                        "name": "Sefwi-Wiawso",
                        "latitude": "6.21965670",
                        "longitude": "-2.50059150"
                    },
                    {
                        "id": 149127,
                        "name": "Suaman",
                        "latitude": "5.75309280",
                        "longitude": "-3.07518870"
                    }
                ]
            }
        ]
    },
    {
        "id": 84,
        "name": "Gibraltar",
        "iso3": "GIB",
        "iso2": "GI",
        "numeric_code": "292",
        "phonecode": "350",
        "capital": "Gibraltar",
        "currency": "GIP",
        "currency_name": "Gibraltar pound",
        "currency_symbol": "£",
        "tld": ".gi",
        "native": "Gibraltar",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Gibraltar",
        "timezones": [
            {
                "zoneName": "Europe\/Gibraltar",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Jibraltar",
            "ko": "지브롤터",
            "pt-BR": "Gibraltar",
            "pt": "Gibraltar",
            "nl": "Gibraltar",
            "hr": "Gibraltar",
            "fa": "جبل‌طارق",
            "de": "Gibraltar",
            "es": "Gibraltar",
            "fr": "Gibraltar",
            "ja": "ジブラルタル",
            "it": "Gibilterra",
            "zh-CN": "直布罗陀",
            "tr": "Cebelitarik",
            "ru": "Гибралтар",
            "uk": "Гібралтар",
            "pl": "Gibraltar"
        },
        "latitude": "36.13333333",
        "longitude": "-5.35000000",
        "emoji": "🇬🇮",
        "emojiU": "U+1F1EC U+1F1EE",
        "states": []
    },
    {
        "id": 85,
        "name": "Greece",
        "iso3": "GRC",
        "iso2": "GR",
        "numeric_code": "300",
        "phonecode": "30",
        "capital": "Athens",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".gr",
        "native": "Ελλάδα",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Greek, Hellenic",
        "timezones": [
            {
                "zoneName": "Europe\/Athens",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Gres",
            "ko": "그리스",
            "pt-BR": "Grécia",
            "pt": "Grécia",
            "nl": "Griekenland",
            "hr": "Grčka",
            "fa": "یونان",
            "de": "Griechenland",
            "es": "Grecia",
            "fr": "Grèce",
            "ja": "ギリシャ",
            "it": "Grecia",
            "zh-CN": "希腊",
            "tr": "Yunanistan",
            "ru": "Греция",
            "uk": "Греція",
            "pl": "Grecja"
        },
        "latitude": "39.00000000",
        "longitude": "22.00000000",
        "emoji": "🇬🇷",
        "emojiU": "U+1F1EC U+1F1F7",
        "states": [
            {
                "id": 2116,
                "name": "Achaea",
                "iso2": "13",
                "latitude": "38.11587290",
                "longitude": "21.95224910",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2123,
                "name": "Aetolia-Acarnania",
                "iso2": "01",
                "latitude": "38.70843860",
                "longitude": "21.37989280",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2098,
                "name": "Arcadia",
                "iso2": "12",
                "latitude": "37.55578250",
                "longitude": "22.33377690",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2105,
                "name": "Argolis",
                "iso2": "11",
                "latitude": "37.57109700",
                "longitude": "22.26347370",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2122,
                "name": "Attica",
                "iso2": "I",
                "latitude": "38.04575680",
                "longitude": "23.85847370",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52399,
                        "name": "Acharnés",
                        "latitude": "38.08333000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 52402,
                        "name": "Aegina",
                        "latitude": "37.74667000",
                        "longitude": "23.42750000"
                    },
                    {
                        "id": 52403,
                        "name": "Afidnés",
                        "latitude": "38.20332000",
                        "longitude": "23.83982000"
                    },
                    {
                        "id": 52406,
                        "name": "Aghios Panteleímon",
                        "latitude": "38.11643000",
                        "longitude": "23.98182000"
                    },
                    {
                        "id": 52421,
                        "name": "Agía Paraskeví",
                        "latitude": "38.01667000",
                        "longitude": "23.83333000"
                    },
                    {
                        "id": 52426,
                        "name": "Agía Varvára",
                        "latitude": "37.98938000",
                        "longitude": "23.66011000"
                    },
                    {
                        "id": 53370,
                        "name": "Ágioi Anárgyroi",
                        "latitude": "38.03013000",
                        "longitude": "23.72379000"
                    },
                    {
                        "id": 52407,
                        "name": "Agios Dimitrios",
                        "latitude": "37.93333000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 52408,
                        "name": "Agios Dimítrios Kropiás",
                        "latitude": "37.80612000",
                        "longitude": "23.85793000"
                    },
                    {
                        "id": 52410,
                        "name": "Agios Ioannis Rentis",
                        "latitude": "37.96491000",
                        "longitude": "23.66511000"
                    },
                    {
                        "id": 53385,
                        "name": "Ágios Stéfanos",
                        "latitude": "38.14657000",
                        "longitude": "23.85608000"
                    },
                    {
                        "id": 52433,
                        "name": "Aiánteio",
                        "latitude": "37.92135000",
                        "longitude": "23.45877000"
                    },
                    {
                        "id": 52430,
                        "name": "Aigáleo",
                        "latitude": "37.98333000",
                        "longitude": "23.68333000"
                    },
                    {
                        "id": 53387,
                        "name": "Álimos",
                        "latitude": "37.91033000",
                        "longitude": "23.72361000"
                    },
                    {
                        "id": 52454,
                        "name": "Ampelákia",
                        "latitude": "37.95055000",
                        "longitude": "23.52803000"
                    },
                    {
                        "id": 52478,
                        "name": "Anávyssos",
                        "latitude": "37.73414000",
                        "longitude": "23.94389000"
                    },
                    {
                        "id": 53394,
                        "name": "Áno Liósia",
                        "latitude": "38.08333000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 52468,
                        "name": "Anoixi",
                        "latitude": "38.13267000",
                        "longitude": "23.85874000"
                    },
                    {
                        "id": 52470,
                        "name": "Anthoúsa",
                        "latitude": "38.02544000",
                        "longitude": "23.87617000"
                    },
                    {
                        "id": 52487,
                        "name": "Argithéa",
                        "latitude": "37.97506000",
                        "longitude": "23.88556000"
                    },
                    {
                        "id": 52490,
                        "name": "Argyroúpoli",
                        "latitude": "37.90594000",
                        "longitude": "23.75035000"
                    },
                    {
                        "id": 52500,
                        "name": "Artémida",
                        "latitude": "37.96727000",
                        "longitude": "23.99684000"
                    },
                    {
                        "id": 52508,
                        "name": "Asprópyrgos",
                        "latitude": "38.06134000",
                        "longitude": "23.58971000"
                    },
                    {
                        "id": 52515,
                        "name": "Athens",
                        "latitude": "37.98376000",
                        "longitude": "23.72784000"
                    },
                    {
                        "id": 52518,
                        "name": "Avlónas",
                        "latitude": "38.25149000",
                        "longitude": "23.69554000"
                    },
                    {
                        "id": 53409,
                        "name": "Áyioi Apóstoloi",
                        "latitude": "38.29169000",
                        "longitude": "23.91011000"
                    },
                    {
                        "id": 52532,
                        "name": "Chaïdári",
                        "latitude": "38.01135000",
                        "longitude": "23.66597000"
                    },
                    {
                        "id": 52534,
                        "name": "Cholargós",
                        "latitude": "38.00000000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 52549,
                        "name": "Dhafní",
                        "latitude": "37.95002000",
                        "longitude": "23.73437000"
                    },
                    {
                        "id": 52552,
                        "name": "Dhráfi",
                        "latitude": "38.02375000",
                        "longitude": "23.90788000"
                    },
                    {
                        "id": 52557,
                        "name": "Dióni",
                        "latitude": "38.02328000",
                        "longitude": "23.93286000"
                    },
                    {
                        "id": 52558,
                        "name": "Diónysos",
                        "latitude": "38.10458000",
                        "longitude": "23.87938000"
                    },
                    {
                        "id": 52561,
                        "name": "Drapetsóna",
                        "latitude": "37.94988000",
                        "longitude": "23.62309000"
                    },
                    {
                        "id": 52563,
                        "name": "Drosiá",
                        "latitude": "38.11977000",
                        "longitude": "23.86428000"
                    },
                    {
                        "id": 52575,
                        "name": "Ekáli",
                        "latitude": "38.11035000",
                        "longitude": "23.83505000"
                    },
                    {
                        "id": 52577,
                        "name": "Elefsína",
                        "latitude": "38.04135000",
                        "longitude": "23.54295000"
                    },
                    {
                        "id": 52581,
                        "name": "Ellinikó",
                        "latitude": "37.89013000",
                        "longitude": "23.74406000"
                    },
                    {
                        "id": 52591,
                        "name": "Erythrés",
                        "latitude": "38.21741000",
                        "longitude": "23.32234000"
                    },
                    {
                        "id": 52604,
                        "name": "Filothéi",
                        "latitude": "38.02524000",
                        "longitude": "23.78257000"
                    },
                    {
                        "id": 52613,
                        "name": "Fylí",
                        "latitude": "38.10235000",
                        "longitude": "23.66901000"
                    },
                    {
                        "id": 52624,
                        "name": "Galatás",
                        "latitude": "37.49618000",
                        "longitude": "23.44886000"
                    },
                    {
                        "id": 52627,
                        "name": "Galátsi",
                        "latitude": "38.01667000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 52653,
                        "name": "Gérakas",
                        "latitude": "38.02277000",
                        "longitude": "23.85760000"
                    },
                    {
                        "id": 52638,
                        "name": "Glyfáda",
                        "latitude": "37.86289000",
                        "longitude": "23.75802000"
                    },
                    {
                        "id": 52644,
                        "name": "Grammatikó",
                        "latitude": "38.20251000",
                        "longitude": "23.96504000"
                    },
                    {
                        "id": 53421,
                        "name": "Ílion",
                        "latitude": "38.03333000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 52662,
                        "name": "Ilioúpoli",
                        "latitude": "37.93149000",
                        "longitude": "23.76779000"
                    },
                    {
                        "id": 52665,
                        "name": "Irákleio",
                        "latitude": "38.05282000",
                        "longitude": "23.76523000"
                    },
                    {
                        "id": 52674,
                        "name": "Kaisarianí",
                        "latitude": "37.96340000",
                        "longitude": "23.76523000"
                    },
                    {
                        "id": 52802,
                        "name": "Kálamos",
                        "latitude": "38.28447000",
                        "longitude": "23.86308000"
                    },
                    {
                        "id": 52681,
                        "name": "Kallithéa",
                        "latitude": "37.95000000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 52695,
                        "name": "Kalývia Thorikoú",
                        "latitude": "37.83894000",
                        "longitude": "23.92505000"
                    },
                    {
                        "id": 52697,
                        "name": "Kamaterón",
                        "latitude": "38.05586000",
                        "longitude": "23.70515000"
                    },
                    {
                        "id": 52705,
                        "name": "Kapandríti",
                        "latitude": "38.21579000",
                        "longitude": "23.87938000"
                    },
                    {
                        "id": 52714,
                        "name": "Karellás",
                        "latitude": "37.93445000",
                        "longitude": "23.86484000"
                    },
                    {
                        "id": 52817,
                        "name": "Káto Soúlion",
                        "latitude": "38.16803000",
                        "longitude": "24.01628000"
                    },
                    {
                        "id": 52742,
                        "name": "Keratéa",
                        "latitude": "37.80585000",
                        "longitude": "23.97740000"
                    },
                    {
                        "id": 52741,
                        "name": "Keratsíni",
                        "latitude": "37.96250000",
                        "longitude": "23.61972000"
                    },
                    {
                        "id": 52744,
                        "name": "Khalándrion",
                        "latitude": "38.02369000",
                        "longitude": "23.80068000"
                    },
                    {
                        "id": 52743,
                        "name": "Khalkoútsion",
                        "latitude": "38.33263000",
                        "longitude": "23.73188000"
                    },
                    {
                        "id": 52746,
                        "name": "Kifisiá",
                        "latitude": "38.07438000",
                        "longitude": "23.81106000"
                    },
                    {
                        "id": 52749,
                        "name": "Kinéta",
                        "latitude": "37.96843000",
                        "longitude": "23.21351000"
                    },
                    {
                        "id": 52750,
                        "name": "Kipséli",
                        "latitude": "38.00288000",
                        "longitude": "23.73755000"
                    },
                    {
                        "id": 52824,
                        "name": "Kítsi",
                        "latitude": "37.85181000",
                        "longitude": "23.84068000"
                    },
                    {
                        "id": 52769,
                        "name": "Koropí",
                        "latitude": "37.89886000",
                        "longitude": "23.87181000"
                    },
                    {
                        "id": 52770,
                        "name": "Korydallós",
                        "latitude": "37.98468000",
                        "longitude": "23.64711000"
                    },
                    {
                        "id": 52779,
                        "name": "Kouvarás",
                        "latitude": "37.82711000",
                        "longitude": "23.96715000"
                    },
                    {
                        "id": 52790,
                        "name": "Kryonéri",
                        "latitude": "38.13712000",
                        "longitude": "23.83055000"
                    },
                    {
                        "id": 52799,
                        "name": "Kypséli",
                        "latitude": "37.76021000",
                        "longitude": "23.45448000"
                    },
                    {
                        "id": 52830,
                        "name": "Kýthira",
                        "latitude": "36.14955000",
                        "longitude": "22.98979000"
                    },
                    {
                        "id": 52877,
                        "name": "Lávrio",
                        "latitude": "37.71445000",
                        "longitude": "24.05647000"
                    },
                    {
                        "id": 52844,
                        "name": "Leondárion",
                        "latitude": "37.98700000",
                        "longitude": "23.85518000"
                    },
                    {
                        "id": 52856,
                        "name": "Limín Mesoyaías",
                        "latitude": "37.89108000",
                        "longitude": "24.00307000"
                    },
                    {
                        "id": 52871,
                        "name": "Lykóvrysi",
                        "latitude": "38.06933000",
                        "longitude": "23.78223000"
                    },
                    {
                        "id": 52885,
                        "name": "Magoúla",
                        "latitude": "38.07989000",
                        "longitude": "23.52108000"
                    },
                    {
                        "id": 52955,
                        "name": "Mándra",
                        "latitude": "38.06667000",
                        "longitude": "23.50000000"
                    },
                    {
                        "id": 52898,
                        "name": "Marathónas",
                        "latitude": "38.15317000",
                        "longitude": "23.96278000"
                    },
                    {
                        "id": 52899,
                        "name": "Markópoulo",
                        "latitude": "37.88333000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 52900,
                        "name": "Markópoulo Oropoú",
                        "latitude": "38.28980000",
                        "longitude": "23.82475000"
                    },
                    {
                        "id": 52902,
                        "name": "Maroúsi",
                        "latitude": "38.05000000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 52911,
                        "name": "Megalochóri",
                        "latitude": "37.71051000",
                        "longitude": "23.34659000"
                    },
                    {
                        "id": 52956,
                        "name": "Mégara",
                        "latitude": "37.99471000",
                        "longitude": "23.34324000"
                    },
                    {
                        "id": 52922,
                        "name": "Melíssia",
                        "latitude": "38.05000000",
                        "longitude": "23.83333000"
                    },
                    {
                        "id": 52931,
                        "name": "Metamórfosi",
                        "latitude": "38.06576000",
                        "longitude": "23.76356000"
                    },
                    {
                        "id": 52943,
                        "name": "Moskháton",
                        "latitude": "37.94789000",
                        "longitude": "23.67880000"
                    },
                    {
                        "id": 53004,
                        "name": "Néa Chalkidóna",
                        "latitude": "38.02710000",
                        "longitude": "23.73051000"
                    },
                    {
                        "id": 53005,
                        "name": "Néa Erythraía",
                        "latitude": "38.09270000",
                        "longitude": "23.82223000"
                    },
                    {
                        "id": 53006,
                        "name": "Néa Filadélfeia",
                        "latitude": "38.03491000",
                        "longitude": "23.73811000"
                    },
                    {
                        "id": 53009,
                        "name": "Néa Ionía",
                        "latitude": "38.03570000",
                        "longitude": "23.75733000"
                    },
                    {
                        "id": 53022,
                        "name": "Néa Mákri",
                        "latitude": "38.08733000",
                        "longitude": "23.97642000"
                    },
                    {
                        "id": 53024,
                        "name": "Néa Palátia",
                        "latitude": "38.31942000",
                        "longitude": "23.79649000"
                    },
                    {
                        "id": 53025,
                        "name": "Néa Pentéli",
                        "latitude": "38.06059000",
                        "longitude": "23.85926000"
                    },
                    {
                        "id": 53030,
                        "name": "Néa Péramos",
                        "latitude": "38.00647000",
                        "longitude": "23.42348000"
                    },
                    {
                        "id": 53034,
                        "name": "Néa Smýrni",
                        "latitude": "37.94504000",
                        "longitude": "23.71416000"
                    },
                    {
                        "id": 53045,
                        "name": "Néo Psychikó",
                        "latitude": "38.00624000",
                        "longitude": "23.78373000"
                    },
                    {
                        "id": 52970,
                        "name": "Neos Voutzás",
                        "latitude": "38.04312000",
                        "longitude": "23.97749000"
                    },
                    {
                        "id": 53054,
                        "name": "Níkaia",
                        "latitude": "37.96667000",
                        "longitude": "23.65000000"
                    },
                    {
                        "id": 53065,
                        "name": "Oropós",
                        "latitude": "38.30326000",
                        "longitude": "23.75549000"
                    },
                    {
                        "id": 53070,
                        "name": "Paianía",
                        "latitude": "37.95527000",
                        "longitude": "23.85443000"
                    },
                    {
                        "id": 53076,
                        "name": "Palaiá Fókaia",
                        "latitude": "37.71998000",
                        "longitude": "23.94792000"
                    },
                    {
                        "id": 53077,
                        "name": "Palaió Fáliro",
                        "latitude": "37.92812000",
                        "longitude": "23.70105000"
                    },
                    {
                        "id": 53084,
                        "name": "Pallíni",
                        "latitude": "38.00514000",
                        "longitude": "23.88302000"
                    },
                    {
                        "id": 53089,
                        "name": "Papágou",
                        "latitude": "37.98642000",
                        "longitude": "23.79347000"
                    },
                    {
                        "id": 53171,
                        "name": "Péfki",
                        "latitude": "38.06019000",
                        "longitude": "23.79264000"
                    },
                    {
                        "id": 53107,
                        "name": "Pentéli",
                        "latitude": "38.05000000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 53175,
                        "name": "Pérama",
                        "latitude": "37.96775000",
                        "longitude": "23.57210000"
                    },
                    {
                        "id": 53112,
                        "name": "Peristéri",
                        "latitude": "38.01539000",
                        "longitude": "23.69187000"
                    },
                    {
                        "id": 53119,
                        "name": "Petroúpolis",
                        "latitude": "38.04187000",
                        "longitude": "23.68494000"
                    },
                    {
                        "id": 53122,
                        "name": "Pikérmi",
                        "latitude": "38.00161000",
                        "longitude": "23.94075000"
                    },
                    {
                        "id": 53123,
                        "name": "Piraeus",
                        "latitude": "37.94203000",
                        "longitude": "23.64619000"
                    },
                    {
                        "id": 53132,
                        "name": "Polydéndri",
                        "latitude": "38.21600000",
                        "longitude": "23.86806000"
                    },
                    {
                        "id": 53180,
                        "name": "Póros",
                        "latitude": "37.49944000",
                        "longitude": "23.45361000"
                    },
                    {
                        "id": 53155,
                        "name": "Psychikó",
                        "latitude": "38.01324000",
                        "longitude": "23.77223000"
                    },
                    {
                        "id": 53186,
                        "name": "Rafína",
                        "latitude": "38.01812000",
                        "longitude": "24.00599000"
                    },
                    {
                        "id": 53197,
                        "name": "Rodópoli",
                        "latitude": "38.11669000",
                        "longitude": "23.87572000"
                    },
                    {
                        "id": 53204,
                        "name": "Salamína",
                        "latitude": "37.96427000",
                        "longitude": "23.49649000"
                    },
                    {
                        "id": 53207,
                        "name": "Saronída",
                        "latitude": "37.74809000",
                        "longitude": "23.91059000"
                    },
                    {
                        "id": 53211,
                        "name": "Selínia",
                        "latitude": "37.93320000",
                        "longitude": "23.53147000"
                    },
                    {
                        "id": 53226,
                        "name": "Skála Oropoú",
                        "latitude": "38.31964000",
                        "longitude": "23.78763000"
                    },
                    {
                        "id": 53220,
                        "name": "Skarmagkás",
                        "latitude": "38.01133000",
                        "longitude": "23.60303000"
                    },
                    {
                        "id": 53242,
                        "name": "Spáta",
                        "latitude": "37.96163000",
                        "longitude": "23.91514000"
                    },
                    {
                        "id": 53243,
                        "name": "Spétses",
                        "latitude": "37.26191000",
                        "longitude": "23.15943000"
                    },
                    {
                        "id": 53245,
                        "name": "Stamáta",
                        "latitude": "38.12546000",
                        "longitude": "23.88038000"
                    },
                    {
                        "id": 53300,
                        "name": "Távros",
                        "latitude": "37.97064000",
                        "longitude": "23.69043000"
                    },
                    {
                        "id": 53280,
                        "name": "Thrakomakedónes",
                        "latitude": "38.12964000",
                        "longitude": "23.75751000"
                    },
                    {
                        "id": 53340,
                        "name": "Vári",
                        "latitude": "37.83320000",
                        "longitude": "23.80311000"
                    },
                    {
                        "id": 53308,
                        "name": "Varnávas",
                        "latitude": "38.22358000",
                        "longitude": "23.92307000"
                    },
                    {
                        "id": 53311,
                        "name": "Varybóbi",
                        "latitude": "38.12723000",
                        "longitude": "23.78729000"
                    },
                    {
                        "id": 53316,
                        "name": "Vathý",
                        "latitude": "37.76420000",
                        "longitude": "23.48011000"
                    },
                    {
                        "id": 53344,
                        "name": "Vília",
                        "latitude": "38.16716000",
                        "longitude": "23.33659000"
                    },
                    {
                        "id": 53325,
                        "name": "Vlycháda",
                        "latitude": "38.02734000",
                        "longitude": "23.43663000"
                    },
                    {
                        "id": 53331,
                        "name": "Voúla",
                        "latitude": "37.84221000",
                        "longitude": "23.77651000"
                    },
                    {
                        "id": 53329,
                        "name": "Vouliagméni",
                        "latitude": "37.81423000",
                        "longitude": "23.77892000"
                    },
                    {
                        "id": 53334,
                        "name": "Vraná",
                        "latitude": "38.12497000",
                        "longitude": "23.95198000"
                    },
                    {
                        "id": 53335,
                        "name": "Vrilissia",
                        "latitude": "38.03381000",
                        "longitude": "23.82962000"
                    },
                    {
                        "id": 53347,
                        "name": "Výronas",
                        "latitude": "37.96105000",
                        "longitude": "23.75300000"
                    },
                    {
                        "id": 53424,
                        "name": "Ýdra",
                        "latitude": "37.34976000",
                        "longitude": "23.46560000"
                    },
                    {
                        "id": 53355,
                        "name": "Ymittos",
                        "latitude": "37.95342000",
                        "longitude": "23.74897000"
                    },
                    {
                        "id": 53360,
                        "name": "Zefyri",
                        "latitude": "38.06647000",
                        "longitude": "23.71701000"
                    },
                    {
                        "id": 53363,
                        "name": "Zográfos",
                        "latitude": "37.97574000",
                        "longitude": "23.76911000"
                    }
                ]
            },
            {
                "id": 2126,
                "name": "Boeotia",
                "iso2": "03",
                "latitude": "38.36636640",
                "longitude": "23.09650640",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2128,
                "name": "Central Greece",
                "iso2": "H",
                "latitude": "38.60439840",
                "longitude": "22.71521310",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52404,
                        "name": "Afrátion",
                        "latitude": "38.45212000",
                        "longitude": "23.68775000"
                    },
                    {
                        "id": 52423,
                        "name": "Agía Triáda",
                        "latitude": "38.35505000",
                        "longitude": "22.90881000"
                    },
                    {
                        "id": 53376,
                        "name": "Ágios Geórgios",
                        "latitude": "38.39343000",
                        "longitude": "22.93189000"
                    },
                    {
                        "id": 52429,
                        "name": "Aidipsós",
                        "latitude": "38.87924000",
                        "longitude": "23.04691000"
                    },
                    {
                        "id": 52434,
                        "name": "Akraifnía",
                        "latitude": "38.45663000",
                        "longitude": "23.22093000"
                    },
                    {
                        "id": 52446,
                        "name": "Alíartos",
                        "latitude": "38.36667000",
                        "longitude": "23.10000000"
                    },
                    {
                        "id": 52444,
                        "name": "Alivéri",
                        "latitude": "38.41667000",
                        "longitude": "24.03333000"
                    },
                    {
                        "id": 52457,
                        "name": "Amárynthos",
                        "latitude": "38.39300000",
                        "longitude": "23.88492000"
                    },
                    {
                        "id": 52450,
                        "name": "Amfíkleia",
                        "latitude": "38.63912000",
                        "longitude": "22.59171000"
                    },
                    {
                        "id": 53389,
                        "name": "Ámfissa",
                        "latitude": "38.52813000",
                        "longitude": "22.37713000"
                    },
                    {
                        "id": 52471,
                        "name": "Anthíli",
                        "latitude": "38.85000000",
                        "longitude": "22.47906000"
                    },
                    {
                        "id": 52472,
                        "name": "Antikyra",
                        "latitude": "38.38333000",
                        "longitude": "22.63333000"
                    },
                    {
                        "id": 52501,
                        "name": "Aráchova",
                        "latitude": "38.47958000",
                        "longitude": "22.58350000"
                    },
                    {
                        "id": 53401,
                        "name": "Árma",
                        "latitude": "38.35121000",
                        "longitude": "23.48599000"
                    },
                    {
                        "id": 52504,
                        "name": "Asopía",
                        "latitude": "38.29882000",
                        "longitude": "23.50189000"
                    },
                    {
                        "id": 52514,
                        "name": "Atalánti",
                        "latitude": "38.65111000",
                        "longitude": "22.99917000"
                    },
                    {
                        "id": 53412,
                        "name": "Áyios Konstandínos",
                        "latitude": "38.75612000",
                        "longitude": "22.85757000"
                    },
                    {
                        "id": 53413,
                        "name": "Áyios Nikólaos",
                        "latitude": "38.42051000",
                        "longitude": "23.64772000"
                    },
                    {
                        "id": 53414,
                        "name": "Áyios Thomás",
                        "latitude": "38.27717000",
                        "longitude": "23.58906000"
                    },
                    {
                        "id": 52524,
                        "name": "Chairóneia",
                        "latitude": "38.49551000",
                        "longitude": "22.84424000"
                    },
                    {
                        "id": 52528,
                        "name": "Chalkída",
                        "latitude": "38.46354000",
                        "longitude": "23.60284000"
                    },
                    {
                        "id": 52547,
                        "name": "Delphi",
                        "latitude": "38.47942000",
                        "longitude": "22.49357000"
                    },
                    {
                        "id": 52551,
                        "name": "Dhrosiá",
                        "latitude": "38.48413000",
                        "longitude": "23.54774000"
                    },
                    {
                        "id": 52568,
                        "name": "Dílesi",
                        "latitude": "38.33762000",
                        "longitude": "23.67077000"
                    },
                    {
                        "id": 52570,
                        "name": "Dístomo",
                        "latitude": "38.42892000",
                        "longitude": "22.66728000"
                    },
                    {
                        "id": 52559,
                        "name": "Domokós",
                        "latitude": "39.12722000",
                        "longitude": "22.30028000"
                    },
                    {
                        "id": 52560,
                        "name": "Domvraína",
                        "latitude": "38.25300000",
                        "longitude": "22.98211000"
                    },
                    {
                        "id": 52583,
                        "name": "Eláteia",
                        "latitude": "38.62770000",
                        "longitude": "22.76492000"
                    },
                    {
                        "id": 52593,
                        "name": "Erétria",
                        "latitude": "38.40097000",
                        "longitude": "23.80220000"
                    },
                    {
                        "id": 52615,
                        "name": "Fáros",
                        "latitude": "38.39959000",
                        "longitude": "23.62275000"
                    },
                    {
                        "id": 52619,
                        "name": "Fílla",
                        "latitude": "38.44177000",
                        "longitude": "23.68306000"
                    },
                    {
                        "id": 52625,
                        "name": "Galaxídhion",
                        "latitude": "38.38067000",
                        "longitude": "22.38001000"
                    },
                    {
                        "id": 52668,
                        "name": "Istiaía",
                        "latitude": "38.95520000",
                        "longitude": "23.15210000"
                    },
                    {
                        "id": 52671,
                        "name": "Itéa",
                        "latitude": "38.43201000",
                        "longitude": "22.42443000"
                    },
                    {
                        "id": 52673,
                        "name": "Kainoúryion",
                        "latitude": "38.79283000",
                        "longitude": "22.72470000"
                    },
                    {
                        "id": 52700,
                        "name": "Kaména Voúrla",
                        "latitude": "38.77844000",
                        "longitude": "22.78573000"
                    },
                    {
                        "id": 52706,
                        "name": "Kaparéllion",
                        "latitude": "38.23697000",
                        "longitude": "23.21411000"
                    },
                    {
                        "id": 52716,
                        "name": "Karpenísi",
                        "latitude": "38.91218000",
                        "longitude": "21.79836000"
                    },
                    {
                        "id": 52804,
                        "name": "Kárystos",
                        "latitude": "38.01333000",
                        "longitude": "24.41611000"
                    },
                    {
                        "id": 52727,
                        "name": "Kastélla",
                        "latitude": "38.57048000",
                        "longitude": "23.63131000"
                    },
                    {
                        "id": 52818,
                        "name": "Káto Tithoréa",
                        "latitude": "38.60751000",
                        "longitude": "22.71348000"
                    },
                    {
                        "id": 52740,
                        "name": "Kerasochóri",
                        "latitude": "39.00556000",
                        "longitude": "21.63778000"
                    },
                    {
                        "id": 52821,
                        "name": "Kírra",
                        "latitude": "38.42944000",
                        "longitude": "22.44443000"
                    },
                    {
                        "id": 52827,
                        "name": "Kými",
                        "latitude": "38.63477000",
                        "longitude": "24.10287000"
                    },
                    {
                        "id": 52800,
                        "name": "Kyriáki",
                        "latitude": "38.35365000",
                        "longitude": "22.78841000"
                    },
                    {
                        "id": 52837,
                        "name": "Lamía",
                        "latitude": "38.90000000",
                        "longitude": "22.43333000"
                    },
                    {
                        "id": 52849,
                        "name": "Lianokládhion",
                        "latitude": "38.91655000",
                        "longitude": "22.30336000"
                    },
                    {
                        "id": 52851,
                        "name": "Lidoríki",
                        "latitude": "38.52389000",
                        "longitude": "22.19972000"
                    },
                    {
                        "id": 52880,
                        "name": "Límni",
                        "latitude": "38.76667000",
                        "longitude": "23.31667000"
                    },
                    {
                        "id": 52860,
                        "name": "Livadeiá",
                        "latitude": "38.43616000",
                        "longitude": "22.87665000"
                    },
                    {
                        "id": 52862,
                        "name": "Livanátes",
                        "latitude": "38.71100000",
                        "longitude": "23.05030000"
                    },
                    {
                        "id": 52864,
                        "name": "Loukísia",
                        "latitude": "38.47946000",
                        "longitude": "23.44796000"
                    },
                    {
                        "id": 52865,
                        "name": "Loutrá Aidhipsoú",
                        "latitude": "38.85695000",
                        "longitude": "23.04739000"
                    },
                    {
                        "id": 52883,
                        "name": "Magoúla",
                        "latitude": "38.41178000",
                        "longitude": "23.82128000"
                    },
                    {
                        "id": 52887,
                        "name": "Makrakómi",
                        "latitude": "38.94150000",
                        "longitude": "22.11535000"
                    },
                    {
                        "id": 52892,
                        "name": "Malakónta",
                        "latitude": "38.40000000",
                        "longitude": "23.76667000"
                    },
                    {
                        "id": 52893,
                        "name": "Malesína",
                        "latitude": "38.62225000",
                        "longitude": "23.23370000"
                    },
                    {
                        "id": 52897,
                        "name": "Mantoúdi",
                        "latitude": "38.79808000",
                        "longitude": "23.47967000"
                    },
                    {
                        "id": 52901,
                        "name": "Marmárion",
                        "latitude": "38.04839000",
                        "longitude": "24.32039000"
                    },
                    {
                        "id": 52903,
                        "name": "Martínon",
                        "latitude": "38.56817000",
                        "longitude": "23.21458000"
                    },
                    {
                        "id": 52958,
                        "name": "Mólos",
                        "latitude": "38.80998000",
                        "longitude": "22.64544000"
                    },
                    {
                        "id": 52952,
                        "name": "Mytikas",
                        "latitude": "38.44373000",
                        "longitude": "23.65365000"
                    },
                    {
                        "id": 53003,
                        "name": "Néa Artáki",
                        "latitude": "38.52027000",
                        "longitude": "23.63296000"
                    },
                    {
                        "id": 53016,
                        "name": "Néa Lámpsakos",
                        "latitude": "38.43729000",
                        "longitude": "23.62824000"
                    },
                    {
                        "id": 53035,
                        "name": "Néa Stíra",
                        "latitude": "38.17935000",
                        "longitude": "24.20842000"
                    },
                    {
                        "id": 53049,
                        "name": "Néon Monastírion",
                        "latitude": "39.23988000",
                        "longitude": "22.27465000"
                    },
                    {
                        "id": 52982,
                        "name": "Nomós Evrytanías",
                        "latitude": "39.00000000",
                        "longitude": "21.66667000"
                    },
                    {
                        "id": 52983,
                        "name": "Nomós Fokídos",
                        "latitude": "38.50000000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 53057,
                        "name": "Oinófyta",
                        "latitude": "38.31163000",
                        "longitude": "23.64000000"
                    },
                    {
                        "id": 53058,
                        "name": "Omvriakí",
                        "latitude": "39.10118000",
                        "longitude": "22.27106000"
                    },
                    {
                        "id": 53060,
                        "name": "Orchomenós",
                        "latitude": "38.49290000",
                        "longitude": "22.97962000"
                    },
                    {
                        "id": 53061,
                        "name": "Oreoí",
                        "latitude": "38.95034000",
                        "longitude": "23.09191000"
                    },
                    {
                        "id": 53068,
                        "name": "Oxílithos",
                        "latitude": "38.57988000",
                        "longitude": "24.11184000"
                    },
                    {
                        "id": 53092,
                        "name": "Paralía Avlídhos",
                        "latitude": "38.38002000",
                        "longitude": "23.62842000"
                    },
                    {
                        "id": 53103,
                        "name": "Pelasgía",
                        "latitude": "38.94813000",
                        "longitude": "22.83980000"
                    },
                    {
                        "id": 53129,
                        "name": "Pláka Dílesi",
                        "latitude": "38.34950000",
                        "longitude": "23.65056000"
                    },
                    {
                        "id": 53131,
                        "name": "Politiká",
                        "latitude": "38.59673000",
                        "longitude": "23.54457000"
                    },
                    {
                        "id": 53144,
                        "name": "Prokópi",
                        "latitude": "38.73402000",
                        "longitude": "23.49060000"
                    },
                    {
                        "id": 53154,
                        "name": "Psachná",
                        "latitude": "38.57852000",
                        "longitude": "23.64326000"
                    },
                    {
                        "id": 53193,
                        "name": "Rodhítsa",
                        "latitude": "38.88829000",
                        "longitude": "22.46410000"
                    },
                    {
                        "id": 53198,
                        "name": "Roviés",
                        "latitude": "38.80971000",
                        "longitude": "23.23073000"
                    },
                    {
                        "id": 53209,
                        "name": "Schimatári",
                        "latitude": "38.35000000",
                        "longitude": "23.58333000"
                    },
                    {
                        "id": 53229,
                        "name": "Skýros",
                        "latitude": "38.90417000",
                        "longitude": "24.56306000"
                    },
                    {
                        "id": 53239,
                        "name": "Spercheiáda",
                        "latitude": "38.90656000",
                        "longitude": "22.12792000"
                    },
                    {
                        "id": 53249,
                        "name": "Stavrós",
                        "latitude": "38.89641000",
                        "longitude": "22.37082000"
                    },
                    {
                        "id": 53252,
                        "name": "Steíri",
                        "latitude": "38.40831000",
                        "longitude": "22.71162000"
                    },
                    {
                        "id": 53255,
                        "name": "Stylída",
                        "latitude": "38.91667000",
                        "longitude": "22.61667000"
                    },
                    {
                        "id": 53276,
                        "name": "Thespiés",
                        "latitude": "38.30300000",
                        "longitude": "23.15016000"
                    },
                    {
                        "id": 53285,
                        "name": "Thívai",
                        "latitude": "38.32500000",
                        "longitude": "23.31889000"
                    },
                    {
                        "id": 53338,
                        "name": "Vágia",
                        "latitude": "38.31748000",
                        "longitude": "23.17752000"
                    },
                    {
                        "id": 53314,
                        "name": "Vasilikón",
                        "latitude": "38.42586000",
                        "longitude": "23.67189000"
                    },
                    {
                        "id": 53315,
                        "name": "Vathí",
                        "latitude": "38.40490000",
                        "longitude": "23.60332000"
                    },
                    {
                        "id": 53354,
                        "name": "Yimnón",
                        "latitude": "38.44048000",
                        "longitude": "23.88400000"
                    }
                ]
            },
            {
                "id": 2125,
                "name": "Central Macedonia",
                "iso2": "B",
                "latitude": "40.62117300",
                "longitude": "23.19180210",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 53367,
                        "name": "Ádendro",
                        "latitude": "40.67131000",
                        "longitude": "22.60466000"
                    },
                    {
                        "id": 53368,
                        "name": "Áfytos",
                        "latitude": "40.09915000",
                        "longitude": "23.43670000"
                    },
                    {
                        "id": 52422,
                        "name": "Agía Paraskeví",
                        "latitude": "40.48150000",
                        "longitude": "23.04863000"
                    },
                    {
                        "id": 52425,
                        "name": "Agía Triáda",
                        "latitude": "40.50003000",
                        "longitude": "22.87351000"
                    },
                    {
                        "id": 53369,
                        "name": "Ágio Pnévma",
                        "latitude": "41.10142000",
                        "longitude": "23.67992000"
                    },
                    {
                        "id": 53374,
                        "name": "Ágios Athanásios",
                        "latitude": "40.71598000",
                        "longitude": "22.72841000"
                    },
                    {
                        "id": 53377,
                        "name": "Ágios Geórgios",
                        "latitude": "40.60215000",
                        "longitude": "22.19430000"
                    },
                    {
                        "id": 53378,
                        "name": "Ágios Loukás",
                        "latitude": "40.71799000",
                        "longitude": "22.29545000"
                    },
                    {
                        "id": 53381,
                        "name": "Ágios Nikólaos",
                        "latitude": "40.24926000",
                        "longitude": "23.69616000"
                    },
                    {
                        "id": 53382,
                        "name": "Ágios Pávlos",
                        "latitude": "40.64075000",
                        "longitude": "22.96039000"
                    },
                    {
                        "id": 53383,
                        "name": "Ágios Pétros",
                        "latitude": "40.86725000",
                        "longitude": "22.58298000"
                    },
                    {
                        "id": 53384,
                        "name": "Ágios Spyrídon",
                        "latitude": "40.20778000",
                        "longitude": "22.44311000"
                    },
                    {
                        "id": 53386,
                        "name": "Ágios Vasíleios",
                        "latitude": "40.66424000",
                        "longitude": "23.11373000"
                    },
                    {
                        "id": 52411,
                        "name": "Agkathiá",
                        "latitude": "40.55535000",
                        "longitude": "22.47083000"
                    },
                    {
                        "id": 52431,
                        "name": "Aigínio",
                        "latitude": "40.50139000",
                        "longitude": "22.54000000"
                    },
                    {
                        "id": 52436,
                        "name": "Akrolímni",
                        "latitude": "40.68020000",
                        "longitude": "22.26450000"
                    },
                    {
                        "id": 52441,
                        "name": "Alexándreia",
                        "latitude": "40.62667000",
                        "longitude": "22.44417000"
                    },
                    {
                        "id": 52443,
                        "name": "Alistráti",
                        "latitude": "41.06443000",
                        "longitude": "23.95751000"
                    },
                    {
                        "id": 52453,
                        "name": "Ampeleíes",
                        "latitude": "40.83417000",
                        "longitude": "22.38767000"
                    },
                    {
                        "id": 52455,
                        "name": "Ampelókipoi",
                        "latitude": "40.65304000",
                        "longitude": "22.92624000"
                    },
                    {
                        "id": 52461,
                        "name": "Anatolikó",
                        "latitude": "40.66152000",
                        "longitude": "22.71190000"
                    },
                    {
                        "id": 52465,
                        "name": "Angelochóri",
                        "latitude": "40.67862000",
                        "longitude": "22.19933000"
                    },
                    {
                        "id": 53397,
                        "name": "Ápsalos",
                        "latitude": "40.89240000",
                        "longitude": "22.05709000"
                    },
                    {
                        "id": 52481,
                        "name": "Aravissós",
                        "latitude": "40.84352000",
                        "longitude": "22.30178000"
                    },
                    {
                        "id": 52492,
                        "name": "Aridaía",
                        "latitude": "40.97306000",
                        "longitude": "22.05639000"
                    },
                    {
                        "id": 52496,
                        "name": "Arnaía",
                        "latitude": "40.48652000",
                        "longitude": "23.59537000"
                    },
                    {
                        "id": 53402,
                        "name": "Árnissa",
                        "latitude": "40.79555000",
                        "longitude": "21.83577000"
                    },
                    {
                        "id": 52498,
                        "name": "Arsénio",
                        "latitude": "40.71412000",
                        "longitude": "22.15923000"
                    },
                    {
                        "id": 52503,
                        "name": "Askós",
                        "latitude": "40.75105000",
                        "longitude": "23.38721000"
                    },
                    {
                        "id": 52506,
                        "name": "Asproválta",
                        "latitude": "40.73049000",
                        "longitude": "23.71180000"
                    },
                    {
                        "id": 53404,
                        "name": "Ássiros",
                        "latitude": "40.82143000",
                        "longitude": "23.03008000"
                    },
                    {
                        "id": 52511,
                        "name": "Asvestochóri",
                        "latitude": "40.64125000",
                        "longitude": "23.02528000"
                    },
                    {
                        "id": 53407,
                        "name": "Áthyra",
                        "latitude": "40.82615000",
                        "longitude": "22.59279000"
                    },
                    {
                        "id": 52519,
                        "name": "Axioúpoli",
                        "latitude": "40.98582000",
                        "longitude": "22.54165000"
                    },
                    {
                        "id": 52520,
                        "name": "Axós",
                        "latitude": "40.80223000",
                        "longitude": "22.36158000"
                    },
                    {
                        "id": 52529,
                        "name": "Chalástra",
                        "latitude": "40.62643000",
                        "longitude": "22.73291000"
                    },
                    {
                        "id": 52526,
                        "name": "Chalkidóna",
                        "latitude": "40.73184000",
                        "longitude": "22.59992000"
                    },
                    {
                        "id": 52531,
                        "name": "Charopó",
                        "latitude": "41.26031000",
                        "longitude": "23.37279000"
                    },
                    {
                        "id": 52536,
                        "name": "Chortiátis",
                        "latitude": "40.60954000",
                        "longitude": "23.10014000"
                    },
                    {
                        "id": 52540,
                        "name": "Chrysó",
                        "latitude": "41.05806000",
                        "longitude": "23.65108000"
                    },
                    {
                        "id": 52537,
                        "name": "Chrysochórafa",
                        "latitude": "41.18097000",
                        "longitude": "23.23551000"
                    },
                    {
                        "id": 52553,
                        "name": "Diavatá",
                        "latitude": "40.68744000",
                        "longitude": "22.85799000"
                    },
                    {
                        "id": 52554,
                        "name": "Diavatós",
                        "latitude": "40.54606000",
                        "longitude": "22.26686000"
                    },
                    {
                        "id": 52569,
                        "name": "Díon",
                        "latitude": "40.17169000",
                        "longitude": "22.48463000"
                    },
                    {
                        "id": 52562,
                        "name": "Dravískos",
                        "latitude": "40.92393000",
                        "longitude": "23.87119000"
                    },
                    {
                        "id": 52564,
                        "name": "Drymós",
                        "latitude": "40.78099000",
                        "longitude": "22.95889000"
                    },
                    {
                        "id": 53416,
                        "name": "Édessa",
                        "latitude": "40.80260000",
                        "longitude": "22.04751000"
                    },
                    {
                        "id": 52572,
                        "name": "Efkarpía",
                        "latitude": "40.68797000",
                        "longitude": "22.95348000"
                    },
                    {
                        "id": 52573,
                        "name": "Eirinoúpoli",
                        "latitude": "40.67806000",
                        "longitude": "22.19278000"
                    },
                    {
                        "id": 52586,
                        "name": "Epanomí",
                        "latitude": "40.42614000",
                        "longitude": "22.92782000"
                    },
                    {
                        "id": 52587,
                        "name": "Episkopí",
                        "latitude": "40.68748000",
                        "longitude": "22.13640000"
                    },
                    {
                        "id": 53419,
                        "name": "Évosmos",
                        "latitude": "40.67056000",
                        "longitude": "22.90833000"
                    },
                    {
                        "id": 52594,
                        "name": "Evropós",
                        "latitude": "40.89703000",
                        "longitude": "22.55277000"
                    },
                    {
                        "id": 52597,
                        "name": "Exaplátanos",
                        "latitude": "40.97643000",
                        "longitude": "22.12958000"
                    },
                    {
                        "id": 52618,
                        "name": "Fíliro",
                        "latitude": "40.69151000",
                        "longitude": "23.00460000"
                    },
                    {
                        "id": 52621,
                        "name": "Galatádes",
                        "latitude": "40.75590000",
                        "longitude": "22.28062000"
                    },
                    {
                        "id": 52626,
                        "name": "Galátista",
                        "latitude": "40.46820000",
                        "longitude": "23.28015000"
                    },
                    {
                        "id": 52649,
                        "name": "Gázoros",
                        "latitude": "41.02557000",
                        "longitude": "23.77574000"
                    },
                    {
                        "id": 52651,
                        "name": "Géfyra",
                        "latitude": "40.73253000",
                        "longitude": "22.69359000"
                    },
                    {
                        "id": 52634,
                        "name": "Gerakaroú",
                        "latitude": "40.62666000",
                        "longitude": "23.21566000"
                    },
                    {
                        "id": 52637,
                        "name": "Giannitsá",
                        "latitude": "40.79194000",
                        "longitude": "22.40750000"
                    },
                    {
                        "id": 52639,
                        "name": "Gouménissa",
                        "latitude": "40.94604000",
                        "longitude": "22.44974000"
                    },
                    {
                        "id": 52658,
                        "name": "Ierissós",
                        "latitude": "40.39748000",
                        "longitude": "23.87505000"
                    },
                    {
                        "id": 52664,
                        "name": "Irákleia",
                        "latitude": "41.18217000",
                        "longitude": "23.28243000"
                    },
                    {
                        "id": 52687,
                        "name": "Kalá Déndra",
                        "latitude": "41.09941000",
                        "longitude": "23.42396000"
                    },
                    {
                        "id": 52675,
                        "name": "Kalamariá",
                        "latitude": "40.58250000",
                        "longitude": "22.95028000"
                    },
                    {
                        "id": 52689,
                        "name": "Kalí",
                        "latitude": "40.81931000",
                        "longitude": "22.17761000"
                    },
                    {
                        "id": 52682,
                        "name": "Kallithéa",
                        "latitude": "40.07374000",
                        "longitude": "23.44637000"
                    },
                    {
                        "id": 52685,
                        "name": "Kalochóri",
                        "latitude": "40.64189000",
                        "longitude": "22.85734000"
                    },
                    {
                        "id": 52693,
                        "name": "Kalýves Polygýrou",
                        "latitude": "40.28659000",
                        "longitude": "23.39033000"
                    },
                    {
                        "id": 52694,
                        "name": "Kalývia",
                        "latitude": "40.75508000",
                        "longitude": "22.21753000"
                    },
                    {
                        "id": 52698,
                        "name": "Kampánis",
                        "latitude": "40.88951000",
                        "longitude": "22.91682000"
                    },
                    {
                        "id": 52711,
                        "name": "Kardiá",
                        "latitude": "40.46909000",
                        "longitude": "22.99378000"
                    },
                    {
                        "id": 52721,
                        "name": "Karítsa",
                        "latitude": "40.18745000",
                        "longitude": "22.48171000"
                    },
                    {
                        "id": 52719,
                        "name": "Karyótissa",
                        "latitude": "40.76915000",
                        "longitude": "22.31331000"
                    },
                    {
                        "id": 52722,
                        "name": "Kassándreia",
                        "latitude": "40.04835000",
                        "longitude": "23.41362000"
                    },
                    {
                        "id": 52730,
                        "name": "Kateríni",
                        "latitude": "40.26956000",
                        "longitude": "22.50608000"
                    },
                    {
                        "id": 52810,
                        "name": "Káto Kamíla",
                        "latitude": "41.02119000",
                        "longitude": "23.48336000"
                    },
                    {
                        "id": 52812,
                        "name": "Káto Lipochóri",
                        "latitude": "40.75754000",
                        "longitude": "22.17962000"
                    },
                    {
                        "id": 52814,
                        "name": "Káto Miliá",
                        "latitude": "40.25403000",
                        "longitude": "22.34342000"
                    },
                    {
                        "id": 52816,
                        "name": "Káto Scholári",
                        "latitude": "40.42906000",
                        "longitude": "23.02978000"
                    },
                    {
                        "id": 52734,
                        "name": "Kavallári",
                        "latitude": "40.71539000",
                        "longitude": "23.04588000"
                    },
                    {
                        "id": 52747,
                        "name": "Kilkís",
                        "latitude": "40.99302000",
                        "longitude": "22.87433000"
                    },
                    {
                        "id": 52823,
                        "name": "Kítros",
                        "latitude": "40.37399000",
                        "longitude": "22.57862000"
                    },
                    {
                        "id": 52752,
                        "name": "Kleidí",
                        "latitude": "40.56632000",
                        "longitude": "22.59033000"
                    },
                    {
                        "id": 52782,
                        "name": "Koímisi",
                        "latitude": "41.21282000",
                        "longitude": "23.30035000"
                    },
                    {
                        "id": 52758,
                        "name": "Kolchikón",
                        "latitude": "40.75662000",
                        "longitude": "23.13377000"
                    },
                    {
                        "id": 52759,
                        "name": "Kolindrós",
                        "latitude": "40.47888000",
                        "longitude": "22.48319000"
                    },
                    {
                        "id": 52764,
                        "name": "Kontariótissa",
                        "latitude": "40.22754000",
                        "longitude": "22.46100000"
                    },
                    {
                        "id": 52767,
                        "name": "Kopanós",
                        "latitude": "40.63382000",
                        "longitude": "22.12893000"
                    },
                    {
                        "id": 52768,
                        "name": "Korinós",
                        "latitude": "40.31659000",
                        "longitude": "22.58817000"
                    },
                    {
                        "id": 52771,
                        "name": "Koryfí",
                        "latitude": "40.60286000",
                        "longitude": "22.50681000"
                    },
                    {
                        "id": 52775,
                        "name": "Koufália",
                        "latitude": "40.77778000",
                        "longitude": "22.57194000"
                    },
                    {
                        "id": 52776,
                        "name": "Kouloúra",
                        "latitude": "40.54652000",
                        "longitude": "22.31795000"
                    },
                    {
                        "id": 52786,
                        "name": "Krithiá",
                        "latitude": "40.84184000",
                        "longitude": "22.98292000"
                    },
                    {
                        "id": 52794,
                        "name": "Krýa Vrýsi",
                        "latitude": "40.68738000",
                        "longitude": "22.30516000"
                    },
                    {
                        "id": 52828,
                        "name": "Kýmina",
                        "latitude": "40.61354000",
                        "longitude": "22.69278000"
                    },
                    {
                        "id": 52832,
                        "name": "Lagkadás",
                        "latitude": "40.75000000",
                        "longitude": "23.06667000"
                    },
                    {
                        "id": 52833,
                        "name": "Lagyná",
                        "latitude": "40.72351000",
                        "longitude": "23.00420000"
                    },
                    {
                        "id": 52872,
                        "name": "Lákkoma",
                        "latitude": "40.39139000",
                        "longitude": "23.05578000"
                    },
                    {
                        "id": 52843,
                        "name": "Lefkónas",
                        "latitude": "41.10029000",
                        "longitude": "23.49658000"
                    },
                    {
                        "id": 52847,
                        "name": "Leptokaryá",
                        "latitude": "40.06032000",
                        "longitude": "22.56120000"
                    },
                    {
                        "id": 52850,
                        "name": "Lianovérgi",
                        "latitude": "40.63526000",
                        "longitude": "22.50820000"
                    },
                    {
                        "id": 52858,
                        "name": "Lití",
                        "latitude": "40.74533000",
                        "longitude": "22.97982000"
                    },
                    {
                        "id": 52859,
                        "name": "Litóchoro",
                        "latitude": "40.10056000",
                        "longitude": "22.49778000"
                    },
                    {
                        "id": 52881,
                        "name": "Lófos",
                        "latitude": "40.24395000",
                        "longitude": "22.38033000"
                    },
                    {
                        "id": 52868,
                        "name": "Loutráki",
                        "latitude": "40.97116000",
                        "longitude": "21.94659000"
                    },
                    {
                        "id": 52869,
                        "name": "Loutrós",
                        "latitude": "40.58873000",
                        "longitude": "22.39976000"
                    },
                    {
                        "id": 52888,
                        "name": "Makrochóri",
                        "latitude": "40.55125000",
                        "longitude": "22.24955000"
                    },
                    {
                        "id": 52891,
                        "name": "Makrýgialos",
                        "latitude": "40.41551000",
                        "longitude": "22.60392000"
                    },
                    {
                        "id": 52954,
                        "name": "Mándalo",
                        "latitude": "40.85677000",
                        "longitude": "22.21264000"
                    },
                    {
                        "id": 52904,
                        "name": "Marína",
                        "latitude": "40.69200000",
                        "longitude": "22.10099000"
                    },
                    {
                        "id": 52908,
                        "name": "Mavrothálassa",
                        "latitude": "40.89427000",
                        "longitude": "23.75048000"
                    },
                    {
                        "id": 52909,
                        "name": "Mavrovoúni",
                        "latitude": "40.78243000",
                        "longitude": "22.15629000"
                    },
                    {
                        "id": 52915,
                        "name": "Megáli Panagía",
                        "latitude": "40.44505000",
                        "longitude": "23.67999000"
                    },
                    {
                        "id": 52920,
                        "name": "Melíki",
                        "latitude": "40.51685000",
                        "longitude": "22.39599000"
                    },
                    {
                        "id": 52921,
                        "name": "Melíssi",
                        "latitude": "40.77406000",
                        "longitude": "22.35304000"
                    },
                    {
                        "id": 52919,
                        "name": "Melissochóri",
                        "latitude": "40.76796000",
                        "longitude": "22.92858000"
                    },
                    {
                        "id": 52924,
                        "name": "Meneméni",
                        "latitude": "40.65829000",
                        "longitude": "22.89712000"
                    },
                    {
                        "id": 52927,
                        "name": "Mesiméri",
                        "latitude": "40.41344000",
                        "longitude": "23.00750000"
                    },
                    {
                        "id": 52934,
                        "name": "Mikró Monastíri",
                        "latitude": "40.70430000",
                        "longitude": "22.54112000"
                    },
                    {
                        "id": 52937,
                        "name": "Mitroúsi",
                        "latitude": "41.07041000",
                        "longitude": "23.46064000"
                    },
                    {
                        "id": 52996,
                        "name": "Náousa",
                        "latitude": "40.62944000",
                        "longitude": "22.06806000"
                    },
                    {
                        "id": 53002,
                        "name": "Néa Apollonía",
                        "latitude": "40.62558000",
                        "longitude": "23.44074000"
                    },
                    {
                        "id": 53042,
                        "name": "Néa Éfesos",
                        "latitude": "40.22923000",
                        "longitude": "22.49811000"
                    },
                    {
                        "id": 53007,
                        "name": "Néa Flogitá",
                        "latitude": "40.26108000",
                        "longitude": "23.22107000"
                    },
                    {
                        "id": 53008,
                        "name": "Néa Fókaia",
                        "latitude": "40.13333000",
                        "longitude": "23.39754000"
                    },
                    {
                        "id": 53012,
                        "name": "Néa Kallikráteia",
                        "latitude": "40.31312000",
                        "longitude": "23.06343000"
                    },
                    {
                        "id": 53017,
                        "name": "Néa Magnisía",
                        "latitude": "40.68785000",
                        "longitude": "22.84582000"
                    },
                    {
                        "id": 53023,
                        "name": "Néa Málgara",
                        "latitude": "40.60985000",
                        "longitude": "22.68196000"
                    },
                    {
                        "id": 53019,
                        "name": "Néa Mesimvría",
                        "latitude": "40.75158000",
                        "longitude": "22.76904000"
                    },
                    {
                        "id": 53020,
                        "name": "Néa Michanióna",
                        "latitude": "40.46371000",
                        "longitude": "22.86170000"
                    },
                    {
                        "id": 53021,
                        "name": "Néa Moudhaniá",
                        "latitude": "40.24390000",
                        "longitude": "23.28484000"
                    },
                    {
                        "id": 53029,
                        "name": "Néa Pélla",
                        "latitude": "40.76516000",
                        "longitude": "22.49173000"
                    },
                    {
                        "id": 53026,
                        "name": "Néa Plágia",
                        "latitude": "40.26537000",
                        "longitude": "23.20376000"
                    },
                    {
                        "id": 53027,
                        "name": "Néa Poteídaia",
                        "latitude": "40.19409000",
                        "longitude": "23.32832000"
                    },
                    {
                        "id": 53028,
                        "name": "Néa Potídhaia",
                        "latitude": "40.19428000",
                        "longitude": "23.32874000"
                    },
                    {
                        "id": 53032,
                        "name": "Néa Róda",
                        "latitude": "40.38119000",
                        "longitude": "23.92374000"
                    },
                    {
                        "id": 53036,
                        "name": "Néa Sánta",
                        "latitude": "40.84084000",
                        "longitude": "22.92163000"
                    },
                    {
                        "id": 53037,
                        "name": "Néa Tríglia",
                        "latitude": "40.30575000",
                        "longitude": "23.20660000"
                    },
                    {
                        "id": 53039,
                        "name": "Néa Vrasná",
                        "latitude": "40.70592000",
                        "longitude": "23.69850000"
                    },
                    {
                        "id": 53041,
                        "name": "Néa Zíchni",
                        "latitude": "41.03204000",
                        "longitude": "23.82870000"
                    },
                    {
                        "id": 52961,
                        "name": "Neapoli",
                        "latitude": "40.65320000",
                        "longitude": "22.94156000"
                    },
                    {
                        "id": 53043,
                        "name": "Néo Agionéri",
                        "latitude": "40.80826000",
                        "longitude": "22.70733000"
                    },
                    {
                        "id": 53044,
                        "name": "Néo Petrítsi",
                        "latitude": "41.27459000",
                        "longitude": "23.29381000"
                    },
                    {
                        "id": 53046,
                        "name": "Néo Rýsi",
                        "latitude": "40.49605000",
                        "longitude": "22.98794000"
                    },
                    {
                        "id": 53047,
                        "name": "Néo Soúli",
                        "latitude": "41.09397000",
                        "longitude": "23.64376000"
                    },
                    {
                        "id": 52966,
                        "name": "Neochóri",
                        "latitude": "41.05231000",
                        "longitude": "23.57997000"
                    },
                    {
                        "id": 52963,
                        "name": "Neochoroúda",
                        "latitude": "40.73817000",
                        "longitude": "22.87557000"
                    },
                    {
                        "id": 53048,
                        "name": "Néoi Epivátes",
                        "latitude": "40.49863000",
                        "longitude": "22.91192000"
                    },
                    {
                        "id": 53050,
                        "name": "Néos Marmarás",
                        "latitude": "40.09610000",
                        "longitude": "23.78323000"
                    },
                    {
                        "id": 53051,
                        "name": "Néos Mylótopos",
                        "latitude": "40.81872000",
                        "longitude": "22.35489000"
                    },
                    {
                        "id": 53053,
                        "name": "Néos Skopós",
                        "latitude": "41.02390000",
                        "longitude": "23.60927000"
                    },
                    {
                        "id": 52975,
                        "name": "Nigríta",
                        "latitude": "40.90528000",
                        "longitude": "23.49944000"
                    },
                    {
                        "id": 53055,
                        "name": "Níkiti",
                        "latitude": "40.22204000",
                        "longitude": "23.66837000"
                    },
                    {
                        "id": 52977,
                        "name": "Nisí",
                        "latitude": "40.63610000",
                        "longitude": "22.38884000"
                    },
                    {
                        "id": 52981,
                        "name": "Nomós Chalkidikís",
                        "latitude": "40.41667000",
                        "longitude": "23.50000000"
                    },
                    {
                        "id": 52990,
                        "name": "Nomós Péllis",
                        "latitude": "40.83333000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 52992,
                        "name": "Nomós Thessaloníkis",
                        "latitude": "40.66667000",
                        "longitude": "23.00000000"
                    },
                    {
                        "id": 53423,
                        "name": "Ólynthos",
                        "latitude": "40.29147000",
                        "longitude": "23.34205000"
                    },
                    {
                        "id": 53059,
                        "name": "Oraiókastro",
                        "latitude": "40.73083000",
                        "longitude": "22.91722000"
                    },
                    {
                        "id": 53063,
                        "name": "Ormýlia",
                        "latitude": "40.29451000",
                        "longitude": "23.54332000"
                    },
                    {
                        "id": 53066,
                        "name": "Ouranoupolis",
                        "latitude": "40.33333000",
                        "longitude": "23.98333000"
                    },
                    {
                        "id": 53082,
                        "name": "Palaífyto",
                        "latitude": "40.78283000",
                        "longitude": "22.27388000"
                    },
                    {
                        "id": 53072,
                        "name": "Palaiochóri",
                        "latitude": "40.49186000",
                        "longitude": "23.64928000"
                    },
                    {
                        "id": 53073,
                        "name": "Palaiokómi",
                        "latitude": "40.87068000",
                        "longitude": "23.90121000"
                    },
                    {
                        "id": 53086,
                        "name": "Panórama",
                        "latitude": "40.58779000",
                        "longitude": "23.03150000"
                    },
                    {
                        "id": 53091,
                        "name": "Paralía",
                        "latitude": "40.26710000",
                        "longitude": "22.59615000"
                    },
                    {
                        "id": 53100,
                        "name": "Patrída",
                        "latitude": "40.56071000",
                        "longitude": "22.18545000"
                    },
                    {
                        "id": 53170,
                        "name": "Péfka",
                        "latitude": "40.65806000",
                        "longitude": "22.99378000"
                    },
                    {
                        "id": 53102,
                        "name": "Pefkochóri",
                        "latitude": "39.98784000",
                        "longitude": "23.61219000"
                    },
                    {
                        "id": 53172,
                        "name": "Pélla",
                        "latitude": "40.76169000",
                        "longitude": "22.52637000"
                    },
                    {
                        "id": 53106,
                        "name": "Pentálofos",
                        "latitude": "40.74296000",
                        "longitude": "22.85256000"
                    },
                    {
                        "id": 53105,
                        "name": "Pentaplátano",
                        "latitude": "40.81902000",
                        "longitude": "22.41903000"
                    },
                    {
                        "id": 53110,
                        "name": "Peraía",
                        "latitude": "40.49874000",
                        "longitude": "22.92617000"
                    },
                    {
                        "id": 53116,
                        "name": "Perístasi",
                        "latitude": "40.27443000",
                        "longitude": "22.54164000"
                    },
                    {
                        "id": 53111,
                        "name": "Peristerá",
                        "latitude": "40.54881000",
                        "longitude": "23.16540000"
                    },
                    {
                        "id": 53125,
                        "name": "Plagiári",
                        "latitude": "40.47276000",
                        "longitude": "22.95790000"
                    },
                    {
                        "id": 53128,
                        "name": "Platý",
                        "latitude": "40.64241000",
                        "longitude": "22.53458000"
                    },
                    {
                        "id": 53134,
                        "name": "Políchni",
                        "latitude": "40.66671000",
                        "longitude": "22.94881000"
                    },
                    {
                        "id": 53135,
                        "name": "Polýgyros",
                        "latitude": "40.37704000",
                        "longitude": "23.44135000"
                    },
                    {
                        "id": 53133,
                        "name": "Polykárpi",
                        "latitude": "40.92598000",
                        "longitude": "22.01634000"
                    },
                    {
                        "id": 53136,
                        "name": "Polýkastro",
                        "latitude": "40.99444000",
                        "longitude": "22.56909000"
                    },
                    {
                        "id": 53137,
                        "name": "Pontisméno",
                        "latitude": "41.20885000",
                        "longitude": "23.28325000"
                    },
                    {
                        "id": 53139,
                        "name": "Portariá",
                        "latitude": "40.28405000",
                        "longitude": "23.29549000"
                    },
                    {
                        "id": 53151,
                        "name": "Próchoma",
                        "latitude": "40.79826000",
                        "longitude": "22.66659000"
                    },
                    {
                        "id": 53143,
                        "name": "Profítis Ilías",
                        "latitude": "40.81373000",
                        "longitude": "22.16166000"
                    },
                    {
                        "id": 53152,
                        "name": "Prómachoi",
                        "latitude": "41.02517000",
                        "longitude": "22.00437000"
                    },
                    {
                        "id": 53153,
                        "name": "Próti",
                        "latitude": "40.94411000",
                        "longitude": "24.00118000"
                    },
                    {
                        "id": 53146,
                        "name": "Provatás",
                        "latitude": "41.06825000",
                        "longitude": "23.39030000"
                    },
                    {
                        "id": 53158,
                        "name": "Pylaía",
                        "latitude": "40.59918000",
                        "longitude": "22.98613000"
                    },
                    {
                        "id": 53188,
                        "name": "Ritíni",
                        "latitude": "40.28835000",
                        "longitude": "22.28361000"
                    },
                    {
                        "id": 53189,
                        "name": "Rizári",
                        "latitude": "40.78373000",
                        "longitude": "22.08800000"
                    },
                    {
                        "id": 53190,
                        "name": "Rizó",
                        "latitude": "40.73331000",
                        "longitude": "22.13674000"
                    },
                    {
                        "id": 53191,
                        "name": "Rizómata",
                        "latitude": "40.35061000",
                        "longitude": "22.21079000"
                    },
                    {
                        "id": 53195,
                        "name": "Rodolívos",
                        "latitude": "40.92055000",
                        "longitude": "23.97489000"
                    },
                    {
                        "id": 53265,
                        "name": "Sárti",
                        "latitude": "40.09369000",
                        "longitude": "23.97859000"
                    },
                    {
                        "id": 53268,
                        "name": "Sérres",
                        "latitude": "41.08499000",
                        "longitude": "23.54757000"
                    },
                    {
                        "id": 53212,
                        "name": "Sevastianá",
                        "latitude": "40.76874000",
                        "longitude": "22.12346000"
                    },
                    {
                        "id": 53213,
                        "name": "Sfendámi",
                        "latitude": "40.41307000",
                        "longitude": "22.54677000"
                    },
                    {
                        "id": 53214,
                        "name": "Sidirókastro",
                        "latitude": "41.23499000",
                        "longitude": "23.38899000"
                    },
                    {
                        "id": 53270,
                        "name": "Símantra",
                        "latitude": "40.34563000",
                        "longitude": "23.31026000"
                    },
                    {
                        "id": 53271,
                        "name": "Síndos",
                        "latitude": "40.67045000",
                        "longitude": "22.80545000"
                    },
                    {
                        "id": 53222,
                        "name": "Skotoússa",
                        "latitude": "41.12844000",
                        "longitude": "23.38174000"
                    },
                    {
                        "id": 53223,
                        "name": "Skoútari",
                        "latitude": "41.01871000",
                        "longitude": "23.51971000"
                    },
                    {
                        "id": 53228,
                        "name": "Skýdra",
                        "latitude": "40.76722000",
                        "longitude": "22.15194000"
                    },
                    {
                        "id": 53231,
                        "name": "Sochós",
                        "latitude": "40.81788000",
                        "longitude": "23.35546000"
                    },
                    {
                        "id": 53234,
                        "name": "Sosándra",
                        "latitude": "40.99894000",
                        "longitude": "22.03254000"
                    },
                    {
                        "id": 53236,
                        "name": "Sourotí",
                        "latitude": "40.47274000",
                        "longitude": "23.09197000"
                    },
                    {
                        "id": 53246,
                        "name": "Stathmós Mourión",
                        "latitude": "41.26378000",
                        "longitude": "22.83855000"
                    },
                    {
                        "id": 53250,
                        "name": "Stavrós",
                        "latitude": "40.66498000",
                        "longitude": "23.70015000"
                    },
                    {
                        "id": 53247,
                        "name": "Stavroúpoli",
                        "latitude": "40.66944000",
                        "longitude": "22.93806000"
                    },
                    {
                        "id": 53253,
                        "name": "Stratónion",
                        "latitude": "40.51406000",
                        "longitude": "23.82471000"
                    },
                    {
                        "id": 53254,
                        "name": "Strymonikó",
                        "latitude": "41.04144000",
                        "longitude": "23.31487000"
                    },
                    {
                        "id": 53257,
                        "name": "Svorónos",
                        "latitude": "40.26805000",
                        "longitude": "22.46366000"
                    },
                    {
                        "id": 53259,
                        "name": "Sykiá",
                        "latitude": "40.03874000",
                        "longitude": "23.94046000"
                    },
                    {
                        "id": 53260,
                        "name": "Sykiés",
                        "latitude": "40.64944000",
                        "longitude": "22.95083000"
                    },
                    {
                        "id": 53275,
                        "name": "Terpní",
                        "latitude": "40.91643000",
                        "longitude": "23.48137000"
                    },
                    {
                        "id": 53283,
                        "name": "Thérmi",
                        "latitude": "40.54712000",
                        "longitude": "23.01967000"
                    },
                    {
                        "id": 53278,
                        "name": "Thessaloníki",
                        "latitude": "40.64361000",
                        "longitude": "22.93086000"
                    },
                    {
                        "id": 53289,
                        "name": "Triandría",
                        "latitude": "40.61500000",
                        "longitude": "22.97620000"
                    },
                    {
                        "id": 53290,
                        "name": "Tríkala",
                        "latitude": "40.59814000",
                        "longitude": "22.55733000"
                    },
                    {
                        "id": 53293,
                        "name": "Trílofos",
                        "latitude": "40.46898000",
                        "longitude": "22.97180000"
                    },
                    {
                        "id": 53305,
                        "name": "Valteró",
                        "latitude": "41.17927000",
                        "longitude": "23.32022000"
                    },
                    {
                        "id": 53306,
                        "name": "Vamvakófyto",
                        "latitude": "41.17916000",
                        "longitude": "23.39602000"
                    },
                    {
                        "id": 53312,
                        "name": "Vasiliká",
                        "latitude": "40.47966000",
                        "longitude": "23.13695000"
                    },
                    {
                        "id": 53317,
                        "name": "Vathýlakkos",
                        "latitude": "40.76942000",
                        "longitude": "22.70880000"
                    },
                    {
                        "id": 53320,
                        "name": "Vergína",
                        "latitude": "40.48654000",
                        "longitude": "22.31735000"
                    },
                    {
                        "id": 53343,
                        "name": "Véroia",
                        "latitude": "40.52437000",
                        "longitude": "22.20242000"
                    },
                    {
                        "id": 53336,
                        "name": "Vrontoú",
                        "latitude": "40.19356000",
                        "longitude": "22.43203000"
                    },
                    {
                        "id": 53348,
                        "name": "Xilópolis",
                        "latitude": "40.92713000",
                        "longitude": "23.17944000"
                    }
                ]
            },
            {
                "id": 2115,
                "name": "Chania",
                "iso2": "94",
                "latitude": "35.51382980",
                "longitude": "24.01803670",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2124,
                "name": "Corfu",
                "iso2": "22",
                "latitude": "39.62498380",
                "longitude": "19.92234610",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 52599,
                        "name": "Farkadóna",
                        "latitude": "39.60000000",
                        "longitude": "22.06667000"
                    },
                    {
                        "id": 52617,
                        "name": "Fíki",
                        "latitude": "39.51602000",
                        "longitude": "21.65556000"
                    },
                    {
                        "id": 52655,
                        "name": "Gómfoi",
                        "latitude": "39.46413000",
                        "longitude": "21.69342000"
                    },
                    {
                        "id": 52647,
                        "name": "Grizáno",
                        "latitude": "39.63192000",
                        "longitude": "22.05258000"
                    },
                    {
                        "id": 52678,
                        "name": "Kalampáka",
                        "latitude": "39.70444000",
                        "longitude": "21.62694000"
                    },
                    {
                        "id": 52725,
                        "name": "Kastráki",
                        "latitude": "39.71692000",
                        "longitude": "21.61865000"
                    },
                    {
                        "id": 52913,
                        "name": "Megála Kalývia",
                        "latitude": "39.49693000",
                        "longitude": "21.78802000"
                    },
                    {
                        "id": 52910,
                        "name": "Megalochóri",
                        "latitude": "39.55982000",
                        "longitude": "21.84195000"
                    },
                    {
                        "id": 53056,
                        "name": "Oichalía",
                        "latitude": "39.60827000",
                        "longitude": "21.97996000"
                    },
                    {
                        "id": 53074,
                        "name": "Palaiomonástiro",
                        "latitude": "39.46269000",
                        "longitude": "21.65793000"
                    },
                    {
                        "id": 53080,
                        "name": "Palaiópyrgos",
                        "latitude": "39.60845000",
                        "longitude": "21.81720000"
                    },
                    {
                        "id": 53121,
                        "name": "Pigí",
                        "latitude": "39.51061000",
                        "longitude": "21.70103000"
                    },
                    {
                        "id": 53182,
                        "name": "Pýli",
                        "latitude": "39.45806000",
                        "longitude": "21.61889000"
                    },
                    {
                        "id": 53160,
                        "name": "Pyrgetós",
                        "latitude": "39.55276000",
                        "longitude": "21.74846000"
                    },
                    {
                        "id": 53202,
                        "name": "Rízoma",
                        "latitude": "39.66432000",
                        "longitude": "21.73541000"
                    },
                    {
                        "id": 53274,
                        "name": "Taxiárches",
                        "latitude": "39.57565000",
                        "longitude": "21.89245000"
                    },
                    {
                        "id": 53291,
                        "name": "Tríkala",
                        "latitude": "39.55493000",
                        "longitude": "21.76837000"
                    },
                    {
                        "id": 53313,
                        "name": "Vasilikí",
                        "latitude": "39.63984000",
                        "longitude": "21.70448000"
                    },
                    {
                        "id": 53366,
                        "name": "Zárkos",
                        "latitude": "39.60860000",
                        "longitude": "22.12336000"
                    }
                ]
            },
            {
                "id": 2129,
                "name": "Corinthia",
                "iso2": "15",
                "latitude": "37.92064310",
                "longitude": "22.03965530",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2109,
                "name": "Crete",
                "iso2": "M",
                "latitude": "35.24011700",
                "longitude": "24.80926910",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52415,
                        "name": "Agía Foteiní",
                        "latitude": "35.25459000",
                        "longitude": "24.63495000"
                    },
                    {
                        "id": 52416,
                        "name": "Agía Galíni",
                        "latitude": "35.09707000",
                        "longitude": "24.68818000"
                    },
                    {
                        "id": 52418,
                        "name": "Agía Marína",
                        "latitude": "35.51778000",
                        "longitude": "23.92675000"
                    },
                    {
                        "id": 52427,
                        "name": "Agía Varvára",
                        "latitude": "35.13715000",
                        "longitude": "25.00131000"
                    },
                    {
                        "id": 53371,
                        "name": "Ágioi Déka",
                        "latitude": "35.06667000",
                        "longitude": "24.96667000"
                    },
                    {
                        "id": 53380,
                        "name": "Ágios Nikólaos",
                        "latitude": "35.19106000",
                        "longitude": "25.71524000"
                    },
                    {
                        "id": 52467,
                        "name": "Ano Arhanes",
                        "latitude": "35.23333000",
                        "longitude": "25.16667000"
                    },
                    {
                        "id": 52480,
                        "name": "Anógeia",
                        "latitude": "35.29084000",
                        "longitude": "24.88412000"
                    },
                    {
                        "id": 52493,
                        "name": "Arkalochóri",
                        "latitude": "35.14634000",
                        "longitude": "25.26538000"
                    },
                    {
                        "id": 52512,
                        "name": "Asímion",
                        "latitude": "35.04321000",
                        "longitude": "25.09277000"
                    },
                    {
                        "id": 52517,
                        "name": "Atsipópoulo",
                        "latitude": "35.35253000",
                        "longitude": "24.43378000"
                    },
                    {
                        "id": 52530,
                        "name": "Chaniá",
                        "latitude": "35.51124000",
                        "longitude": "24.02921000"
                    },
                    {
                        "id": 52544,
                        "name": "Chóra Sfakíon",
                        "latitude": "35.20176000",
                        "longitude": "24.13711000"
                    },
                    {
                        "id": 52546,
                        "name": "Darátsos",
                        "latitude": "35.49955000",
                        "longitude": "23.97488000"
                    },
                    {
                        "id": 52582,
                        "name": "Eloúnda",
                        "latitude": "35.26500000",
                        "longitude": "25.72127000"
                    },
                    {
                        "id": 52623,
                        "name": "Galatás",
                        "latitude": "35.49864000",
                        "longitude": "23.96341000"
                    },
                    {
                        "id": 52648,
                        "name": "Gázi",
                        "latitude": "35.32531000",
                        "longitude": "25.06694000"
                    },
                    {
                        "id": 52633,
                        "name": "Georgioupolis",
                        "latitude": "35.36225000",
                        "longitude": "24.26013000"
                    },
                    {
                        "id": 52636,
                        "name": "Geráni",
                        "latitude": "35.51721000",
                        "longitude": "23.87818000"
                    },
                    {
                        "id": 52654,
                        "name": "Gérgeri",
                        "latitude": "35.13281000",
                        "longitude": "24.94963000"
                    },
                    {
                        "id": 52641,
                        "name": "Goúrnes",
                        "latitude": "35.32626000",
                        "longitude": "25.27740000"
                    },
                    {
                        "id": 52642,
                        "name": "Gra Liyiá",
                        "latitude": "35.01467000",
                        "longitude": "25.69127000"
                    },
                    {
                        "id": 153541,
                        "name": "Heraklion",
                        "latitude": "35.33870000",
                        "longitude": "25.14420000"
                    },
                    {
                        "id": 52659,
                        "name": "Ierápetra",
                        "latitude": "35.01186000",
                        "longitude": "25.74234000"
                    },
                    {
                        "id": 52666,
                        "name": "Irákleion",
                        "latitude": "35.32787000",
                        "longitude": "25.14341000"
                    },
                    {
                        "id": 52692,
                        "name": "Kalýves",
                        "latitude": "35.45046000",
                        "longitude": "24.17507000"
                    },
                    {
                        "id": 52728,
                        "name": "Kastélli",
                        "latitude": "35.20902000",
                        "longitude": "25.33773000"
                    },
                    {
                        "id": 52726,
                        "name": "Kastrí",
                        "latitude": "34.83460000",
                        "longitude": "24.08572000"
                    },
                    {
                        "id": 52806,
                        "name": "Káto Asítai",
                        "latitude": "35.20271000",
                        "longitude": "24.99827000"
                    },
                    {
                        "id": 52809,
                        "name": "Káto Goúves",
                        "latitude": "35.32934000",
                        "longitude": "25.31353000"
                    },
                    {
                        "id": 52738,
                        "name": "Kentrí",
                        "latitude": "35.03258000",
                        "longitude": "25.75280000"
                    },
                    {
                        "id": 52822,
                        "name": "Kíssamos",
                        "latitude": "35.49459000",
                        "longitude": "23.65375000"
                    },
                    {
                        "id": 52756,
                        "name": "Kokkíni Cháni",
                        "latitude": "35.32827000",
                        "longitude": "25.25810000"
                    },
                    {
                        "id": 52760,
                        "name": "Kolympári",
                        "latitude": "35.54115000",
                        "longitude": "23.77995000"
                    },
                    {
                        "id": 52787,
                        "name": "Kritsá",
                        "latitude": "35.15821000",
                        "longitude": "25.64459000"
                    },
                    {
                        "id": 52789,
                        "name": "Krousón",
                        "latitude": "35.23062000",
                        "longitude": "24.98291000"
                    },
                    {
                        "id": 52855,
                        "name": "Limín Khersonísou",
                        "latitude": "35.32297000",
                        "longitude": "25.39275000"
                    },
                    {
                        "id": 52953,
                        "name": "Mália",
                        "latitude": "35.28367000",
                        "longitude": "25.46262000"
                    },
                    {
                        "id": 52948,
                        "name": "Moíres",
                        "latitude": "35.05143000",
                        "longitude": "24.87330000"
                    },
                    {
                        "id": 52939,
                        "name": "Mokhós",
                        "latitude": "35.26342000",
                        "longitude": "25.42305000"
                    },
                    {
                        "id": 52944,
                        "name": "Mourniés",
                        "latitude": "35.48228000",
                        "longitude": "24.01253000"
                    },
                    {
                        "id": 52946,
                        "name": "Mouzourás",
                        "latitude": "35.53885000",
                        "longitude": "24.15554000"
                    },
                    {
                        "id": 52999,
                        "name": "Néa Alikarnassós",
                        "latitude": "35.33977000",
                        "longitude": "25.15895000"
                    },
                    {
                        "id": 53000,
                        "name": "Néa Anatolí",
                        "latitude": "35.00920000",
                        "longitude": "25.66170000"
                    },
                    {
                        "id": 52973,
                        "name": "Neápoli",
                        "latitude": "35.25627000",
                        "longitude": "25.60415000"
                    },
                    {
                        "id": 52971,
                        "name": "Nerokoúros",
                        "latitude": "35.47587000",
                        "longitude": "24.03995000"
                    },
                    {
                        "id": 52986,
                        "name": "Nomós Irakleíou",
                        "latitude": "35.32969000",
                        "longitude": "25.12985000"
                    },
                    {
                        "id": 52991,
                        "name": "Nomós Rethýmnis",
                        "latitude": "35.25000000",
                        "longitude": "24.58333000"
                    },
                    {
                        "id": 53079,
                        "name": "Palaióchora",
                        "latitude": "35.23128000",
                        "longitude": "23.68185000"
                    },
                    {
                        "id": 53083,
                        "name": "Palekastro",
                        "latitude": "35.19793000",
                        "longitude": "26.25429000"
                    },
                    {
                        "id": 53163,
                        "name": "Pánormos",
                        "latitude": "35.41815000",
                        "longitude": "24.69091000"
                    },
                    {
                        "id": 53176,
                        "name": "Pérama",
                        "latitude": "35.37030000",
                        "longitude": "24.70345000"
                    },
                    {
                        "id": 53114,
                        "name": "Perivólia",
                        "latitude": "35.48491000",
                        "longitude": "23.99421000"
                    },
                    {
                        "id": 53124,
                        "name": "Pithári",
                        "latitude": "35.51672000",
                        "longitude": "24.08653000"
                    },
                    {
                        "id": 53142,
                        "name": "Profítis Ilías",
                        "latitude": "35.20555000",
                        "longitude": "25.09985000"
                    },
                    {
                        "id": 53185,
                        "name": "Pýrgos",
                        "latitude": "35.00611000",
                        "longitude": "25.15191000"
                    },
                    {
                        "id": 53187,
                        "name": "Rethymno",
                        "latitude": "35.36555000",
                        "longitude": "24.48232000"
                    },
                    {
                        "id": 53210,
                        "name": "Schísma Eloúndas",
                        "latitude": "35.25757000",
                        "longitude": "25.72796000"
                    },
                    {
                        "id": 53272,
                        "name": "Sísion",
                        "latitude": "35.30770000",
                        "longitude": "25.52021000"
                    },
                    {
                        "id": 53217,
                        "name": "Sitia",
                        "latitude": "35.20783000",
                        "longitude": "26.10467000"
                    },
                    {
                        "id": 53219,
                        "name": "Skalánion",
                        "latitude": "35.28262000",
                        "longitude": "25.18684000"
                    },
                    {
                        "id": 53237,
                        "name": "Soúda",
                        "latitude": "35.48717000",
                        "longitude": "24.07344000"
                    },
                    {
                        "id": 53244,
                        "name": "Stalís",
                        "latitude": "35.29257000",
                        "longitude": "25.43292000"
                    },
                    {
                        "id": 53281,
                        "name": "Thrapsanón",
                        "latitude": "35.18798000",
                        "longitude": "25.28091000"
                    },
                    {
                        "id": 53302,
                        "name": "Tílisos",
                        "latitude": "35.29607000",
                        "longitude": "25.01587000"
                    },
                    {
                        "id": 53296,
                        "name": "Tsikalariá",
                        "latitude": "35.47623000",
                        "longitude": "24.06274000"
                    },
                    {
                        "id": 53299,
                        "name": "Tympáki",
                        "latitude": "35.07286000",
                        "longitude": "24.76851000"
                    },
                    {
                        "id": 53321,
                        "name": "Violí Charáki",
                        "latitude": "35.35864000",
                        "longitude": "24.43857000"
                    },
                    {
                        "id": 53337,
                        "name": "Vrýses",
                        "latitude": "35.37585000",
                        "longitude": "24.20109000"
                    },
                    {
                        "id": 53359,
                        "name": "Zarós",
                        "latitude": "35.13030000",
                        "longitude": "24.90412000"
                    },
                    {
                        "id": 53364,
                        "name": "Zonianá",
                        "latitude": "35.29502000",
                        "longitude": "24.82944000"
                    }
                ]
            },
            {
                "id": 2130,
                "name": "Drama",
                "iso2": "52",
                "latitude": "41.23400230",
                "longitude": "24.23904980",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2120,
                "name": "East Attica",
                "iso2": "A2",
                "latitude": "38.20540930",
                "longitude": "23.85847370",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 53375,
                        "name": "Ágios Athanásios",
                        "latitude": "41.07463000",
                        "longitude": "24.24545000"
                    },
                    {
                        "id": 154260,
                        "name": "Agios Efstratios",
                        "latitude": "39.53910500",
                        "longitude": "24.98451130"
                    },
                    {
                        "id": 52440,
                        "name": "Alexandroupoli",
                        "latitude": "40.84995000",
                        "longitude": "25.87644000"
                    },
                    {
                        "id": 52456,
                        "name": "Amygdaleónas",
                        "latitude": "40.96346000",
                        "longitude": "24.36007000"
                    },
                    {
                        "id": 53398,
                        "name": "Áratos",
                        "latitude": "41.08139000",
                        "longitude": "25.55186000"
                    },
                    {
                        "id": 52502,
                        "name": "Arísvi",
                        "latitude": "41.07000000",
                        "longitude": "25.59041000"
                    },
                    {
                        "id": 52497,
                        "name": "Arrianá",
                        "latitude": "41.08131000",
                        "longitude": "25.69494000"
                    },
                    {
                        "id": 53408,
                        "name": "Ávato",
                        "latitude": "40.96279000",
                        "longitude": "24.80441000"
                    },
                    {
                        "id": 154252,
                        "name": "Chios",
                        "latitude": "38.37451400",
                        "longitude": "26.08940520"
                    },
                    {
                        "id": 52535,
                        "name": "Choristí",
                        "latitude": "41.13056000",
                        "longitude": "24.20843000"
                    },
                    {
                        "id": 52538,
                        "name": "Chrysochóri",
                        "latitude": "40.93328000",
                        "longitude": "24.71088000"
                    },
                    {
                        "id": 52539,
                        "name": "Chrysoúpolis",
                        "latitude": "40.98556000",
                        "longitude": "24.69389000"
                    },
                    {
                        "id": 52555,
                        "name": "Didymóteicho",
                        "latitude": "41.34806000",
                        "longitude": "26.49611000"
                    },
                    {
                        "id": 52565,
                        "name": "Dráma",
                        "latitude": "41.15283000",
                        "longitude": "24.14730000"
                    },
                    {
                        "id": 52571,
                        "name": "Echínos",
                        "latitude": "41.27558000",
                        "longitude": "24.97237000"
                    },
                    {
                        "id": 52576,
                        "name": "Elaiochóri",
                        "latitude": "40.82030000",
                        "longitude": "24.24373000"
                    },
                    {
                        "id": 52579,
                        "name": "Eleftherés",
                        "latitude": "40.84666000",
                        "longitude": "24.25431000"
                    },
                    {
                        "id": 52578,
                        "name": "Eleftheroúpolis",
                        "latitude": "40.91389000",
                        "longitude": "24.25139000"
                    },
                    {
                        "id": 53418,
                        "name": "Évlalo",
                        "latitude": "40.98333000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 52616,
                        "name": "Féres",
                        "latitude": "40.89305000",
                        "longitude": "26.17234000"
                    },
                    {
                        "id": 52603,
                        "name": "Fillýra",
                        "latitude": "41.11667000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 52610,
                        "name": "Fotolívos",
                        "latitude": "41.06013000",
                        "longitude": "24.04724000"
                    },
                    {
                        "id": 154259,
                        "name": "Fournoi Korseon",
                        "latitude": "37.57978470",
                        "longitude": "26.31761320"
                    },
                    {
                        "id": 52612,
                        "name": "Fteliá",
                        "latitude": "41.08266000",
                        "longitude": "24.18968000"
                    },
                    {
                        "id": 52632,
                        "name": "Genisséa",
                        "latitude": "41.06165000",
                        "longitude": "24.96248000"
                    },
                    {
                        "id": 53420,
                        "name": "Íasmos",
                        "latitude": "41.12747000",
                        "longitude": "25.18573000"
                    },
                    {
                        "id": 154253,
                        "name": "Ikaria",
                        "latitude": "37.59739620",
                        "longitude": "25.94166430"
                    },
                    {
                        "id": 52661,
                        "name": "Iliokentima",
                        "latitude": "40.94931000",
                        "longitude": "24.78859000"
                    },
                    {
                        "id": 52679,
                        "name": "Kalampáki",
                        "latitude": "41.05000000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 52690,
                        "name": "Kalí Vrýsi",
                        "latitude": "41.14653000",
                        "longitude": "23.90667000"
                    },
                    {
                        "id": 52683,
                        "name": "Kallífytos",
                        "latitude": "41.17280000",
                        "longitude": "24.21527000"
                    },
                    {
                        "id": 52691,
                        "name": "Kalós Agrós",
                        "latitude": "41.10543000",
                        "longitude": "24.08570000"
                    },
                    {
                        "id": 52696,
                        "name": "Kamariótissa",
                        "latitude": "40.47501000",
                        "longitude": "25.47456000"
                    },
                    {
                        "id": 52723,
                        "name": "Kastaniés",
                        "latitude": "41.64551000",
                        "longitude": "26.47676000"
                    },
                    {
                        "id": 52815,
                        "name": "Káto Nevrokópi",
                        "latitude": "41.35000000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 52735,
                        "name": "Kavála",
                        "latitude": "40.93959000",
                        "longitude": "24.40687000"
                    },
                    {
                        "id": 52737,
                        "name": "Kavýli",
                        "latitude": "41.56225000",
                        "longitude": "26.51470000"
                    },
                    {
                        "id": 52739,
                        "name": "Keramotí",
                        "latitude": "40.85591000",
                        "longitude": "24.70595000"
                    },
                    {
                        "id": 52748,
                        "name": "Kimméria",
                        "latitude": "41.14788000",
                        "longitude": "24.93869000"
                    },
                    {
                        "id": 52755,
                        "name": "Kokkinóchoma",
                        "latitude": "40.92690000",
                        "longitude": "24.30805000"
                    },
                    {
                        "id": 52762,
                        "name": "Komotiní",
                        "latitude": "41.11917000",
                        "longitude": "25.40535000"
                    },
                    {
                        "id": 52785,
                        "name": "Krinídes",
                        "latitude": "41.01396000",
                        "longitude": "24.29647000"
                    },
                    {
                        "id": 52798,
                        "name": "Kyprínos",
                        "latitude": "41.57542000",
                        "longitude": "26.22905000"
                    },
                    {
                        "id": 52829,
                        "name": "Kýria",
                        "latitude": "41.09900000",
                        "longitude": "24.28915000"
                    },
                    {
                        "id": 52834,
                        "name": "Lagós",
                        "latitude": "41.45102000",
                        "longitude": "26.46067000"
                    },
                    {
                        "id": 52876,
                        "name": "Lávara",
                        "latitude": "41.26957000",
                        "longitude": "26.38522000"
                    },
                    {
                        "id": 154254,
                        "name": "Lemnos",
                        "latitude": "39.90904130",
                        "longitude": "25.07552530"
                    },
                    {
                        "id": 154255,
                        "name": "Lesbos",
                        "latitude": "39.17107260",
                        "longitude": "25.04098590"
                    },
                    {
                        "id": 52853,
                        "name": "Limenária",
                        "latitude": "40.62741000",
                        "longitude": "24.57650000"
                    },
                    {
                        "id": 52882,
                        "name": "Lýkeio",
                        "latitude": "41.06413000",
                        "longitude": "25.68570000"
                    },
                    {
                        "id": 52935,
                        "name": "Mikrópolis",
                        "latitude": "41.19351000",
                        "longitude": "23.81570000"
                    },
                    {
                        "id": 52959,
                        "name": "Mýki",
                        "latitude": "41.24384000",
                        "longitude": "24.92084000"
                    },
                    {
                        "id": 154261,
                        "name": "Mytilene ",
                        "latitude": "39.09953820",
                        "longitude": "26.51545290"
                    },
                    {
                        "id": 53011,
                        "name": "Néa Iraklítsa",
                        "latitude": "40.86442000",
                        "longitude": "24.31650000"
                    },
                    {
                        "id": 53013,
                        "name": "Néa Karváli",
                        "latitude": "40.96148000",
                        "longitude": "24.51132000"
                    },
                    {
                        "id": 53014,
                        "name": "Néa Karyá",
                        "latitude": "40.90621000",
                        "longitude": "24.70726000"
                    },
                    {
                        "id": 53031,
                        "name": "Néa Péramos",
                        "latitude": "40.83854000",
                        "longitude": "24.30130000"
                    },
                    {
                        "id": 53040,
                        "name": "Néa Výssa",
                        "latitude": "41.58449000",
                        "longitude": "26.54318000"
                    },
                    {
                        "id": 52967,
                        "name": "Neochóri",
                        "latitude": "41.51131000",
                        "longitude": "26.45740000"
                    },
                    {
                        "id": 52976,
                        "name": "Nikísiani",
                        "latitude": "40.94739000",
                        "longitude": "24.14311000"
                    },
                    {
                        "id": 154257,
                        "name": "Oinousses",
                        "latitude": "38.51457460",
                        "longitude": "26.21526900"
                    },
                    {
                        "id": 53062,
                        "name": "Orestiáda",
                        "latitude": "41.50306000",
                        "longitude": "26.52972000"
                    },
                    {
                        "id": 53161,
                        "name": "Páchni",
                        "latitude": "41.30506000",
                        "longitude": "24.89438000"
                    },
                    {
                        "id": 53078,
                        "name": "Palaió Tsiflíki",
                        "latitude": "40.90495000",
                        "longitude": "24.35083000"
                    },
                    {
                        "id": 53071,
                        "name": "Palaiochóri",
                        "latitude": "40.94338000",
                        "longitude": "24.17747000"
                    },
                    {
                        "id": 53093,
                        "name": "Paralía Ofryníou",
                        "latitude": "40.76663000",
                        "longitude": "23.90039000"
                    },
                    {
                        "id": 53096,
                        "name": "Paranésti",
                        "latitude": "41.26667000",
                        "longitude": "24.50000000"
                    },
                    {
                        "id": 53173,
                        "name": "Péplos",
                        "latitude": "40.95755000",
                        "longitude": "26.26577000"
                    },
                    {
                        "id": 53117,
                        "name": "Peteinós",
                        "latitude": "41.10056000",
                        "longitude": "24.89847000"
                    },
                    {
                        "id": 53118,
                        "name": "Petrochóri",
                        "latitude": "41.08742000",
                        "longitude": "24.84092000"
                    },
                    {
                        "id": 53120,
                        "name": "Petroússa",
                        "latitude": "41.19470000",
                        "longitude": "24.01731000"
                    },
                    {
                        "id": 53140,
                        "name": "Potamiá",
                        "latitude": "40.71633000",
                        "longitude": "24.72859000"
                    },
                    {
                        "id": 53150,
                        "name": "Prínos",
                        "latitude": "40.74090000",
                        "longitude": "24.57787000"
                    },
                    {
                        "id": 53145,
                        "name": "Prosotsáni",
                        "latitude": "41.18333000",
                        "longitude": "23.96667000"
                    },
                    {
                        "id": 154258,
                        "name": "Psara",
                        "latitude": "38.54144180",
                        "longitude": "25.55847730"
                    },
                    {
                        "id": 53201,
                        "name": "Rízia",
                        "latitude": "41.62490000",
                        "longitude": "26.42771000"
                    },
                    {
                        "id": 154256,
                        "name": "Samos",
                        "latitude": "37.71356740",
                        "longitude": "25.63515040"
                    },
                    {
                        "id": 53205,
                        "name": "Samothráki",
                        "latitude": "40.47333000",
                        "longitude": "25.52222000"
                    },
                    {
                        "id": 53264,
                        "name": "Sápes",
                        "latitude": "41.02861000",
                        "longitude": "25.69306000"
                    },
                    {
                        "id": 53266,
                        "name": "Sélero",
                        "latitude": "41.13382000",
                        "longitude": "24.99408000"
                    },
                    {
                        "id": 53216,
                        "name": "Sitagroí",
                        "latitude": "41.11067000",
                        "longitude": "24.02755000"
                    },
                    {
                        "id": 53230,
                        "name": "Smínthi",
                        "latitude": "41.23333000",
                        "longitude": "24.86667000"
                    },
                    {
                        "id": 53235,
                        "name": "Souflí",
                        "latitude": "41.19194000",
                        "longitude": "26.29944000"
                    },
                    {
                        "id": 53282,
                        "name": "Thásos",
                        "latitude": "40.77806000",
                        "longitude": "24.70944000"
                    },
                    {
                        "id": 53298,
                        "name": "Tycheró",
                        "latitude": "41.02878000",
                        "longitude": "26.29455000"
                    },
                    {
                        "id": 53345,
                        "name": "Vólakas",
                        "latitude": "41.31661000",
                        "longitude": "24.00215000"
                    },
                    {
                        "id": 154262,
                        "name": "West Lesbos",
                        "latitude": "39.17605250",
                        "longitude": "25.89404220"
                    },
                    {
                        "id": 53353,
                        "name": "Xánthi",
                        "latitude": "41.13488000",
                        "longitude": "24.88800000"
                    },
                    {
                        "id": 53350,
                        "name": "Xiropótamos",
                        "latitude": "41.19206000",
                        "longitude": "24.10385000"
                    },
                    {
                        "id": 53351,
                        "name": "Xylaganí",
                        "latitude": "40.97437000",
                        "longitude": "25.42022000"
                    },
                    {
                        "id": 53365,
                        "name": "Zygós",
                        "latitude": "41.01320000",
                        "longitude": "24.38132000"
                    }
                ]
            },
            {
                "id": 2117,
                "name": "East Macedonia and Thrace",
                "iso2": "A",
                "latitude": "41.12951260",
                "longitude": "24.88771910",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 154188,
                        "name": "Alexandroupolis",
                        "latitude": "40.84916600",
                        "longitude": "25.85471070"
                    },
                    {
                        "id": 154197,
                        "name": "Arriana",
                        "latitude": "41.08210780",
                        "longitude": "25.69035930"
                    },
                    {
                        "id": 154189,
                        "name": "Didymoteicho",
                        "latitude": "41.34985800",
                        "longitude": "26.48682660"
                    },
                    {
                        "id": 154193,
                        "name": "Doxato",
                        "latitude": "41.09262850",
                        "longitude": "24.21979930"
                    },
                    {
                        "id": 154184,
                        "name": "Drama",
                        "latitude": "41.26985920",
                        "longitude": "23.54427950"
                    },
                    {
                        "id": 154183,
                        "name": "Evros",
                        "latitude": "41.06578980",
                        "longitude": "24.71987800"
                    },
                    {
                        "id": 154198,
                        "name": "Iasmos",
                        "latitude": "41.12625120",
                        "longitude": "25.17428610"
                    },
                    {
                        "id": 154194,
                        "name": "Kato Nevrokopi",
                        "latitude": "41.34224440",
                        "longitude": "23.85693120"
                    },
                    {
                        "id": 154186,
                        "name": "Kavala",
                        "latitude": "40.96273800",
                        "longitude": "24.00269490"
                    },
                    {
                        "id": 154199,
                        "name": "Komotini",
                        "latitude": "41.11812720",
                        "longitude": "25.38632950"
                    },
                    {
                        "id": 154200,
                        "name": "Maroneia-Sapes",
                        "latitude": "40.99670860",
                        "longitude": "25.49721720"
                    },
                    {
                        "id": 154202,
                        "name": "Myki",
                        "latitude": "41.24495670",
                        "longitude": "24.91486140"
                    },
                    {
                        "id": 154190,
                        "name": "Orestiada",
                        "latitude": "41.50437790",
                        "longitude": "26.45344230"
                    },
                    {
                        "id": 154201,
                        "name": "Pangaio",
                        "latitude": "40.86237500",
                        "longitude": "23.77916640"
                    },
                    {
                        "id": 154195,
                        "name": "Paranesti",
                        "latitude": "41.26771080",
                        "longitude": "24.49470930"
                    },
                    {
                        "id": 154196,
                        "name": "Prosotsani",
                        "latitude": "41.18128940",
                        "longitude": "23.96177490"
                    },
                    {
                        "id": 154185,
                        "name": "Rhodope",
                        "latitude": "41.10265440",
                        "longitude": "25.17488780"
                    },
                    {
                        "id": 154191,
                        "name": "Samothrace",
                        "latitude": "40.45142390",
                        "longitude": "25.40676720"
                    },
                    {
                        "id": 154192,
                        "name": "Soufli",
                        "latitude": "41.17943070",
                        "longitude": "25.85285960"
                    },
                    {
                        "id": 154203,
                        "name": "Topeiros",
                        "latitude": "41.01017360",
                        "longitude": "24.47431520"
                    },
                    {
                        "id": 154187,
                        "name": "Xanthi",
                        "latitude": "41.12706480",
                        "longitude": "24.51328930"
                    }
                ]
            },
            {
                "id": 2110,
                "name": "Epirus",
                "iso2": "D",
                "latitude": "39.57064130",
                "longitude": "20.76428430",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52417,
                        "name": "Agía Kyriakí",
                        "latitude": "39.52264000",
                        "longitude": "20.88358000"
                    },
                    {
                        "id": 52462,
                        "name": "Anatolí",
                        "latitude": "39.63531000",
                        "longitude": "20.86578000"
                    },
                    {
                        "id": 52479,
                        "name": "Anéza",
                        "latitude": "39.08658000",
                        "longitude": "20.92300000"
                    },
                    {
                        "id": 53390,
                        "name": "Áno Kalentíni",
                        "latitude": "39.25000000",
                        "longitude": "21.18528000"
                    },
                    {
                        "id": 53403,
                        "name": "Árta",
                        "latitude": "39.16014000",
                        "longitude": "20.98561000"
                    },
                    {
                        "id": 52507,
                        "name": "Asprángeloi",
                        "latitude": "39.82328000",
                        "longitude": "20.72862000"
                    },
                    {
                        "id": 52527,
                        "name": "Chalkiádes",
                        "latitude": "39.15981000",
                        "longitude": "20.93292000"
                    },
                    {
                        "id": 52574,
                        "name": "Eksochí",
                        "latitude": "39.68744000",
                        "longitude": "20.82240000"
                    },
                    {
                        "id": 52580,
                        "name": "Eleoúsa",
                        "latitude": "39.15278000",
                        "longitude": "20.96214000"
                    },
                    {
                        "id": 52602,
                        "name": "Filiátes",
                        "latitude": "39.60111000",
                        "longitude": "20.31194000"
                    },
                    {
                        "id": 52601,
                        "name": "Filippiáda",
                        "latitude": "39.20472000",
                        "longitude": "20.88222000"
                    },
                    {
                        "id": 52643,
                        "name": "Graikochóri",
                        "latitude": "39.49789000",
                        "longitude": "20.27608000"
                    },
                    {
                        "id": 52645,
                        "name": "Grammenítsa",
                        "latitude": "39.18444000",
                        "longitude": "20.97933000"
                    },
                    {
                        "id": 52660,
                        "name": "Igoumenítsa",
                        "latitude": "39.50342000",
                        "longitude": "20.26728000"
                    },
                    {
                        "id": 52663,
                        "name": "Ioánnina",
                        "latitude": "39.66486000",
                        "longitude": "20.85189000"
                    },
                    {
                        "id": 52677,
                        "name": "Kalamiá",
                        "latitude": "39.16528000",
                        "longitude": "20.93206000"
                    },
                    {
                        "id": 52686,
                        "name": "Kalpáki",
                        "latitude": "39.88778000",
                        "longitude": "20.62389000"
                    },
                    {
                        "id": 52701,
                        "name": "Kanaláki",
                        "latitude": "39.23361000",
                        "longitude": "20.60000000"
                    },
                    {
                        "id": 52708,
                        "name": "Kardamítsia",
                        "latitude": "39.67816000",
                        "longitude": "20.81956000"
                    },
                    {
                        "id": 52733,
                        "name": "Katsikás",
                        "latitude": "39.62281000",
                        "longitude": "20.88758000"
                    },
                    {
                        "id": 52763,
                        "name": "Kompóti",
                        "latitude": "39.10255000",
                        "longitude": "21.08389000"
                    },
                    {
                        "id": 52825,
                        "name": "Kónitsa",
                        "latitude": "40.04861000",
                        "longitude": "20.75667000"
                    },
                    {
                        "id": 52774,
                        "name": "Kostakioí",
                        "latitude": "39.13672000",
                        "longitude": "20.95761000"
                    },
                    {
                        "id": 52777,
                        "name": "Koutselió",
                        "latitude": "39.58808000",
                        "longitude": "20.91197000"
                    },
                    {
                        "id": 52870,
                        "name": "Loúros",
                        "latitude": "39.16600000",
                        "longitude": "20.75608000"
                    },
                    {
                        "id": 52933,
                        "name": "Metsovo",
                        "latitude": "39.76944000",
                        "longitude": "21.18222000"
                    },
                    {
                        "id": 53033,
                        "name": "Néa Seléfkeia",
                        "latitude": "39.52461000",
                        "longitude": "20.25519000"
                    },
                    {
                        "id": 52965,
                        "name": "Neochóri",
                        "latitude": "39.07025000",
                        "longitude": "21.01892000"
                    },
                    {
                        "id": 52964,
                        "name": "Neochorópoulo",
                        "latitude": "39.62553000",
                        "longitude": "20.83558000"
                    },
                    {
                        "id": 53052,
                        "name": "Néos Oropós",
                        "latitude": "39.15064000",
                        "longitude": "20.73636000"
                    },
                    {
                        "id": 52985,
                        "name": "Nomós Ioannínon",
                        "latitude": "39.75000000",
                        "longitude": "20.66667000"
                    },
                    {
                        "id": 53088,
                        "name": "Pappadátes",
                        "latitude": "39.31444000",
                        "longitude": "20.79314000"
                    },
                    {
                        "id": 53095,
                        "name": "Paramythiá",
                        "latitude": "39.47111000",
                        "longitude": "20.51111000"
                    },
                    {
                        "id": 53097,
                        "name": "Parapótamos",
                        "latitude": "39.54858000",
                        "longitude": "20.32436000"
                    },
                    {
                        "id": 53165,
                        "name": "Párga",
                        "latitude": "39.28572000",
                        "longitude": "20.40044000"
                    },
                    {
                        "id": 53101,
                        "name": "Pediní",
                        "latitude": "39.59994000",
                        "longitude": "20.84261000"
                    },
                    {
                        "id": 53174,
                        "name": "Pérama",
                        "latitude": "39.69331000",
                        "longitude": "20.84656000"
                    },
                    {
                        "id": 53177,
                        "name": "Pérdika",
                        "latitude": "39.36967000",
                        "longitude": "20.30419000"
                    },
                    {
                        "id": 53178,
                        "name": "Péta",
                        "latitude": "39.16667000",
                        "longitude": "21.03472000"
                    },
                    {
                        "id": 53127,
                        "name": "Platariá",
                        "latitude": "39.45044000",
                        "longitude": "20.27781000"
                    },
                    {
                        "id": 53148,
                        "name": "Prámanta",
                        "latitude": "39.52306000",
                        "longitude": "21.10139000"
                    },
                    {
                        "id": 53149,
                        "name": "Préveza",
                        "latitude": "38.95617000",
                        "longitude": "20.75050000"
                    },
                    {
                        "id": 53196,
                        "name": "Rodotópi",
                        "latitude": "39.70822000",
                        "longitude": "20.72656000"
                    },
                    {
                        "id": 53248,
                        "name": "Stavráki",
                        "latitude": "39.65614000",
                        "longitude": "20.81806000"
                    },
                    {
                        "id": 53277,
                        "name": "Thesprotikó",
                        "latitude": "39.25114000",
                        "longitude": "20.78528000"
                    },
                    {
                        "id": 53295,
                        "name": "Tsiflikópoulo",
                        "latitude": "39.65624000",
                        "longitude": "20.83882000"
                    },
                    {
                        "id": 53328,
                        "name": "Voulgaréli",
                        "latitude": "39.37194000",
                        "longitude": "21.18333000"
                    },
                    {
                        "id": 53330,
                        "name": "Vounoplagiá",
                        "latitude": "39.69161000",
                        "longitude": "20.78597000"
                    }
                ]
            },
            {
                "id": 2101,
                "name": "Euboea",
                "iso2": "04",
                "latitude": "38.52360360",
                "longitude": "23.85847370",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2102,
                "name": "Grevena",
                "iso2": "51",
                "latitude": "40.08376260",
                "longitude": "21.42732990",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2099,
                "name": "Imathia ",
                "iso2": "53",
                "latitude": "40.60600670",
                "longitude": "22.14302150",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2113,
                "name": "Ioannina",
                "iso2": "33",
                "latitude": "39.66502880",
                "longitude": "20.85374660",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2131,
                "name": "Ionian Islands",
                "iso2": "F",
                "latitude": "37.96948980",
                "longitude": "21.38023720",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52400,
                        "name": "Acharávi",
                        "latitude": "39.79360000",
                        "longitude": "19.81736000"
                    },
                    {
                        "id": 52409,
                        "name": "Agios Georgis",
                        "latitude": "39.72363000",
                        "longitude": "19.69969000"
                    },
                    {
                        "id": 53379,
                        "name": "Ágios Matthaíos",
                        "latitude": "39.49506000",
                        "longitude": "19.87336000"
                    },
                    {
                        "id": 52439,
                        "name": "Alepoú",
                        "latitude": "39.61594000",
                        "longitude": "19.89564000"
                    },
                    {
                        "id": 52448,
                        "name": "Ambelókipoi",
                        "latitude": "37.75809000",
                        "longitude": "20.87248000"
                    },
                    {
                        "id": 52489,
                        "name": "Argostólion",
                        "latitude": "38.18109000",
                        "longitude": "20.48903000"
                    },
                    {
                        "id": 52545,
                        "name": "Corfu",
                        "latitude": "39.62069000",
                        "longitude": "19.91975000"
                    },
                    {
                        "id": 52650,
                        "name": "Gáïos",
                        "latitude": "39.19722000",
                        "longitude": "20.18556000"
                    },
                    {
                        "id": 52631,
                        "name": "Gaïtánion",
                        "latitude": "37.79134000",
                        "longitude": "20.87407000"
                    },
                    {
                        "id": 52669,
                        "name": "Itháki",
                        "latitude": "38.36421000",
                        "longitude": "20.71848000"
                    },
                    {
                        "id": 52703,
                        "name": "Kanáli",
                        "latitude": "39.60556000",
                        "longitude": "19.89250000"
                    },
                    {
                        "id": 52729,
                        "name": "Katastárion",
                        "latitude": "37.83012000",
                        "longitude": "20.75755000"
                    },
                    {
                        "id": 52765,
                        "name": "Kontokáli",
                        "latitude": "39.64436000",
                        "longitude": "19.85194000"
                    },
                    {
                        "id": 52796,
                        "name": "Kynopiástes",
                        "latitude": "39.56785000",
                        "longitude": "19.88362000"
                    },
                    {
                        "id": 52840,
                        "name": "Lefkada",
                        "latitude": "38.75000000",
                        "longitude": "20.66667000"
                    },
                    {
                        "id": 52842,
                        "name": "Lefkímmi",
                        "latitude": "39.42336000",
                        "longitude": "20.07094000"
                    },
                    {
                        "id": 52857,
                        "name": "Lithakiá",
                        "latitude": "37.71935000",
                        "longitude": "20.83013000"
                    },
                    {
                        "id": 52863,
                        "name": "Lixoúri",
                        "latitude": "38.20133000",
                        "longitude": "20.43706000"
                    },
                    {
                        "id": 52945,
                        "name": "Mouzaki",
                        "latitude": "37.73565000",
                        "longitude": "20.82291000"
                    },
                    {
                        "id": 52987,
                        "name": "Nomós Kerkýras",
                        "latitude": "39.66667000",
                        "longitude": "19.75000000"
                    },
                    {
                        "id": 52993,
                        "name": "Nomós Zakýnthou",
                        "latitude": "37.75000000",
                        "longitude": "20.75000000"
                    },
                    {
                        "id": 53109,
                        "name": "Perama",
                        "latitude": "39.58289000",
                        "longitude": "19.91220000"
                    },
                    {
                        "id": 53113,
                        "name": "Perivóli",
                        "latitude": "39.41936000",
                        "longitude": "20.01469000"
                    },
                    {
                        "id": 53179,
                        "name": "Póros",
                        "latitude": "38.15369000",
                        "longitude": "20.77120000"
                    },
                    {
                        "id": 53141,
                        "name": "Potamós",
                        "latitude": "39.62420000",
                        "longitude": "19.87826000"
                    },
                    {
                        "id": 53263,
                        "name": "Sámi",
                        "latitude": "38.25081000",
                        "longitude": "20.64686000"
                    },
                    {
                        "id": 53304,
                        "name": "Valsamáta",
                        "latitude": "38.17600000",
                        "longitude": "20.58392000"
                    },
                    {
                        "id": 53307,
                        "name": "Vanáton",
                        "latitude": "37.79446000",
                        "longitude": "20.85188000"
                    },
                    {
                        "id": 53322,
                        "name": "Virós",
                        "latitude": "39.58340000",
                        "longitude": "19.88270000"
                    },
                    {
                        "id": 53358,
                        "name": "Zakynthos",
                        "latitude": "37.78022000",
                        "longitude": "20.89555000"
                    }
                ]
            },
            {
                "id": 2095,
                "name": "Karditsa",
                "iso2": "41",
                "latitude": "39.36402580",
                "longitude": "21.92140490",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2100,
                "name": "Kastoria",
                "iso2": "56",
                "latitude": "40.51926910",
                "longitude": "21.26871710",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2127,
                "name": "Kefalonia",
                "iso2": "23",
                "latitude": "38.17536750",
                "longitude": "20.56921790",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 52424,
                        "name": "Agía Triáda",
                        "latitude": "39.46361000",
                        "longitude": "21.89848000"
                    },
                    {
                        "id": 52412,
                        "name": "Agnanteró",
                        "latitude": "39.48586000",
                        "longitude": "21.84789000"
                    },
                    {
                        "id": 52477,
                        "name": "Anávra",
                        "latitude": "39.18996000",
                        "longitude": "22.09308000"
                    },
                    {
                        "id": 52469,
                        "name": "Anthiró",
                        "latitude": "39.34722000",
                        "longitude": "21.45833000"
                    },
                    {
                        "id": 52499,
                        "name": "Artesianó",
                        "latitude": "39.40194000",
                        "longitude": "21.89649000"
                    },
                    {
                        "id": 52670,
                        "name": "Itéa",
                        "latitude": "39.45669000",
                        "longitude": "22.16577000"
                    },
                    {
                        "id": 52680,
                        "name": "Kallifóni",
                        "latitude": "39.27712000",
                        "longitude": "21.96128000"
                    },
                    {
                        "id": 52684,
                        "name": "Kallíthiro",
                        "latitude": "39.28099000",
                        "longitude": "21.90491000"
                    },
                    {
                        "id": 52713,
                        "name": "Kardítsa",
                        "latitude": "39.36485000",
                        "longitude": "21.92191000"
                    },
                    {
                        "id": 52710,
                        "name": "Karditsomagoúla",
                        "latitude": "39.39061000",
                        "longitude": "21.92330000"
                    },
                    {
                        "id": 52717,
                        "name": "Karpochóri",
                        "latitude": "39.33575000",
                        "longitude": "22.01129000"
                    },
                    {
                        "id": 52884,
                        "name": "Magoúla",
                        "latitude": "39.45395000",
                        "longitude": "21.80351000"
                    },
                    {
                        "id": 52889,
                        "name": "Makrychóri",
                        "latitude": "39.43978000",
                        "longitude": "21.96582000"
                    },
                    {
                        "id": 52907,
                        "name": "Mavrommáti",
                        "latitude": "39.42386000",
                        "longitude": "21.69379000"
                    },
                    {
                        "id": 52938,
                        "name": "Mitrópoli",
                        "latitude": "39.33933000",
                        "longitude": "21.83751000"
                    },
                    {
                        "id": 52942,
                        "name": "Morfovoúni",
                        "latitude": "39.35250000",
                        "longitude": "21.75000000"
                    },
                    {
                        "id": 52947,
                        "name": "Mouzáki",
                        "latitude": "39.42972000",
                        "longitude": "21.66361000"
                    },
                    {
                        "id": 53081,
                        "name": "Palamás",
                        "latitude": "39.46667000",
                        "longitude": "22.08333000"
                    },
                    {
                        "id": 53147,
                        "name": "Proástio",
                        "latitude": "39.48682000",
                        "longitude": "21.90288000"
                    },
                    {
                        "id": 53233,
                        "name": "Sofádes",
                        "latitude": "39.33333000",
                        "longitude": "22.10000000"
                    }
                ]
            },
            {
                "id": 2111,
                "name": "Kilkis",
                "iso2": "57",
                "latitude": "40.99370710",
                "longitude": "22.87536740",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2112,
                "name": "Kozani",
                "iso2": "58",
                "latitude": "40.30055860",
                "longitude": "21.78877370",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2106,
                "name": "Laconia",
                "iso2": "16",
                "latitude": "43.52785460",
                "longitude": "-71.47035090",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2132,
                "name": "Larissa",
                "iso2": "42",
                "latitude": "39.63902240",
                "longitude": "22.41912540",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2104,
                "name": "Lefkada",
                "iso2": "24",
                "latitude": "38.83336630",
                "longitude": "20.70691080",
                "type": "regional unit",
                "cities": [
                    {
                        "id": 52413,
                        "name": "Agriá",
                        "latitude": "39.34078000",
                        "longitude": "23.01258000"
                    },
                    {
                        "id": 53388,
                        "name": "Álli Meriá",
                        "latitude": "39.37039000",
                        "longitude": "22.98350000"
                    },
                    {
                        "id": 52445,
                        "name": "Almyrós",
                        "latitude": "39.18222000",
                        "longitude": "22.75944000"
                    },
                    {
                        "id": 52459,
                        "name": "Anakasiá",
                        "latitude": "39.38112000",
                        "longitude": "22.97484000"
                    },
                    {
                        "id": 53393,
                        "name": "Áno Lekhónia",
                        "latitude": "39.32763000",
                        "longitude": "23.05395000"
                    },
                    {
                        "id": 52486,
                        "name": "Argalastí",
                        "latitude": "39.22627000",
                        "longitude": "23.21868000"
                    },
                    {
                        "id": 52595,
                        "name": "Evxinoúpolis",
                        "latitude": "39.18414000",
                        "longitude": "22.73831000"
                    },
                    {
                        "id": 52704,
                        "name": "Kanália",
                        "latitude": "39.49928000",
                        "longitude": "22.88589000"
                    },
                    {
                        "id": 52811,
                        "name": "Káto Lekhónia",
                        "latitude": "39.33091000",
                        "longitude": "23.03957000"
                    },
                    {
                        "id": 53001,
                        "name": "Néa Anchiálos",
                        "latitude": "39.28015000",
                        "longitude": "22.81819000"
                    },
                    {
                        "id": 53010,
                        "name": "Néa Ionía",
                        "latitude": "39.37904000",
                        "longitude": "22.92752000"
                    },
                    {
                        "id": 53099,
                        "name": "Patitírion",
                        "latitude": "39.14657000",
                        "longitude": "23.86494000"
                    },
                    {
                        "id": 53138,
                        "name": "Portariá",
                        "latitude": "39.38950000",
                        "longitude": "22.99948000"
                    },
                    {
                        "id": 53156,
                        "name": "Pteleós",
                        "latitude": "39.05261000",
                        "longitude": "22.95271000"
                    },
                    {
                        "id": 53192,
                        "name": "Rizómylos",
                        "latitude": "39.42763000",
                        "longitude": "22.74717000"
                    },
                    {
                        "id": 53221,
                        "name": "Skiáthos",
                        "latitude": "39.16227000",
                        "longitude": "23.49089000"
                    },
                    {
                        "id": 53227,
                        "name": "Skópelos",
                        "latitude": "39.12144000",
                        "longitude": "23.72686000"
                    },
                    {
                        "id": 53238,
                        "name": "Soúrpi",
                        "latitude": "39.10319000",
                        "longitude": "22.89789000"
                    },
                    {
                        "id": 53251,
                        "name": "Stefanovíkeio",
                        "latitude": "39.46354000",
                        "longitude": "22.74198000"
                    },
                    {
                        "id": 53292,
                        "name": "Tríkeri",
                        "latitude": "39.10114000",
                        "longitude": "23.07669000"
                    },
                    {
                        "id": 53318,
                        "name": "Velestíno",
                        "latitude": "39.38181000",
                        "longitude": "22.74616000"
                    },
                    {
                        "id": 53327,
                        "name": "Volos",
                        "latitude": "39.36103000",
                        "longitude": "22.94248000"
                    },
                    {
                        "id": 53357,
                        "name": "Zagorá",
                        "latitude": "39.45000000",
                        "longitude": "23.10000000"
                    }
                ]
            },
            {
                "id": 2107,
                "name": "Pella",
                "iso2": "59",
                "latitude": "40.91480390",
                "longitude": "22.14302150",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2119,
                "name": "Peloponnese",
                "iso2": "J",
                "latitude": "37.50794720",
                "longitude": "22.37349000",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 53372,
                        "name": "Ágioi Theódoroi",
                        "latitude": "37.92736000",
                        "longitude": "23.14221000"
                    },
                    {
                        "id": 53373,
                        "name": "Ágios Andréas",
                        "latitude": "37.34519000",
                        "longitude": "22.76466000"
                    },
                    {
                        "id": 52485,
                        "name": "Arfará",
                        "latitude": "37.15619000",
                        "longitude": "22.04485000"
                    },
                    {
                        "id": 53399,
                        "name": "Árgos",
                        "latitude": "37.63333000",
                        "longitude": "22.73333000"
                    },
                    {
                        "id": 52491,
                        "name": "Aria",
                        "latitude": "37.57372000",
                        "longitude": "22.83539000"
                    },
                    {
                        "id": 53400,
                        "name": "Áris",
                        "latitude": "37.09920000",
                        "longitude": "22.00443000"
                    },
                    {
                        "id": 52494,
                        "name": "Arkhaía Kórinthos",
                        "latitude": "37.90953000",
                        "longitude": "22.88353000"
                    },
                    {
                        "id": 52513,
                        "name": "Asíni",
                        "latitude": "37.54431000",
                        "longitude": "22.86435000"
                    },
                    {
                        "id": 52505,
                        "name": "Asopós",
                        "latitude": "36.72986000",
                        "longitude": "22.85455000"
                    },
                    {
                        "id": 53405,
                        "name": "Ássos",
                        "latitude": "37.93955000",
                        "longitude": "22.82223000"
                    },
                    {
                        "id": 53406,
                        "name": "Ástros",
                        "latitude": "37.40395000",
                        "longitude": "22.72118000"
                    },
                    {
                        "id": 52516,
                        "name": "Athíkia",
                        "latitude": "37.81675000",
                        "longitude": "22.92939000"
                    },
                    {
                        "id": 52521,
                        "name": "Ayía Triás",
                        "latitude": "37.63707000",
                        "longitude": "22.80504000"
                    },
                    {
                        "id": 53410,
                        "name": "Áyios Adhrianós",
                        "latitude": "37.59975000",
                        "longitude": "22.84560000"
                    },
                    {
                        "id": 53415,
                        "name": "Áyios Vasílios",
                        "latitude": "37.79763000",
                        "longitude": "22.79727000"
                    },
                    {
                        "id": 52543,
                        "name": "Chóra",
                        "latitude": "37.05106000",
                        "longitude": "21.71690000"
                    },
                    {
                        "id": 52567,
                        "name": "Dídyma",
                        "latitude": "37.46250000",
                        "longitude": "23.17183000"
                    },
                    {
                        "id": 52556,
                        "name": "Dimitsána",
                        "latitude": "37.59524000",
                        "longitude": "22.04025000"
                    },
                    {
                        "id": 52566,
                        "name": "Drépanon",
                        "latitude": "37.53888000",
                        "longitude": "22.89323000"
                    },
                    {
                        "id": 52589,
                        "name": "Ermióni",
                        "latitude": "37.38492000",
                        "longitude": "23.24686000"
                    },
                    {
                        "id": 52596,
                        "name": "Examília",
                        "latitude": "37.89736000",
                        "longitude": "22.92832000"
                    },
                    {
                        "id": 52600,
                        "name": "Filiatrá",
                        "latitude": "37.15637000",
                        "longitude": "21.58532000"
                    },
                    {
                        "id": 52628,
                        "name": "Gargaliánoi",
                        "latitude": "37.06518000",
                        "longitude": "21.63809000"
                    },
                    {
                        "id": 52652,
                        "name": "Géfyra",
                        "latitude": "36.68715000",
                        "longitude": "23.03509000"
                    },
                    {
                        "id": 52635,
                        "name": "Geráki",
                        "latitude": "36.99227000",
                        "longitude": "22.70663000"
                    },
                    {
                        "id": 52656,
                        "name": "Gýtheio",
                        "latitude": "36.75500000",
                        "longitude": "22.56417000"
                    },
                    {
                        "id": 52667,
                        "name": "Isthmía",
                        "latitude": "37.91356000",
                        "longitude": "23.00460000"
                    },
                    {
                        "id": 52676,
                        "name": "Kalamata",
                        "latitude": "37.03913000",
                        "longitude": "22.11265000"
                    },
                    {
                        "id": 52709,
                        "name": "Kardamýli",
                        "latitude": "36.88778000",
                        "longitude": "22.23317000"
                    },
                    {
                        "id": 52718,
                        "name": "Karyés",
                        "latitude": "37.29119000",
                        "longitude": "22.50066000"
                    },
                    {
                        "id": 52807,
                        "name": "Káto Dhiminió",
                        "latitude": "38.02490000",
                        "longitude": "22.73294000"
                    },
                    {
                        "id": 52808,
                        "name": "Káto Glykóvrysi",
                        "latitude": "36.82791000",
                        "longitude": "22.77732000"
                    },
                    {
                        "id": 52745,
                        "name": "Khiliomódhi",
                        "latitude": "37.81016000",
                        "longitude": "22.86972000"
                    },
                    {
                        "id": 52751,
                        "name": "Kiáto",
                        "latitude": "38.01321000",
                        "longitude": "22.74839000"
                    },
                    {
                        "id": 52754,
                        "name": "Koilás",
                        "latitude": "37.41230000",
                        "longitude": "23.12553000"
                    },
                    {
                        "id": 52757,
                        "name": "Kokkónion",
                        "latitude": "37.97061000",
                        "longitude": "22.78018000"
                    },
                    {
                        "id": 52766,
                        "name": "Kopanáki",
                        "latitude": "37.28913000",
                        "longitude": "21.81854000"
                    },
                    {
                        "id": 52826,
                        "name": "Kórinthos",
                        "latitude": "37.94007000",
                        "longitude": "22.95130000"
                    },
                    {
                        "id": 52772,
                        "name": "Koróni",
                        "latitude": "36.79526000",
                        "longitude": "21.95794000"
                    },
                    {
                        "id": 52778,
                        "name": "Koutsopódi",
                        "latitude": "37.68426000",
                        "longitude": "22.71355000"
                    },
                    {
                        "id": 52783,
                        "name": "Kranídi",
                        "latitude": "37.37974000",
                        "longitude": "23.15969000"
                    },
                    {
                        "id": 52788,
                        "name": "Krokeés",
                        "latitude": "36.88297000",
                        "longitude": "22.54683000"
                    },
                    {
                        "id": 52797,
                        "name": "Kyparissía",
                        "latitude": "37.25111000",
                        "longitude": "21.67361000"
                    },
                    {
                        "id": 52801,
                        "name": "Kyrás Vrýsi",
                        "latitude": "37.91295000",
                        "longitude": "22.98651000"
                    },
                    {
                        "id": 52838,
                        "name": "Langádhia",
                        "latitude": "37.68186000",
                        "longitude": "22.03002000"
                    },
                    {
                        "id": 52879,
                        "name": "Lékhaio",
                        "latitude": "37.93279000",
                        "longitude": "22.85002000"
                    },
                    {
                        "id": 52845,
                        "name": "Leonídio",
                        "latitude": "37.16679000",
                        "longitude": "22.85773000"
                    },
                    {
                        "id": 52848,
                        "name": "Levídion",
                        "latitude": "37.68269000",
                        "longitude": "22.29586000"
                    },
                    {
                        "id": 52852,
                        "name": "Ligourión",
                        "latitude": "37.61233000",
                        "longitude": "23.03773000"
                    },
                    {
                        "id": 52866,
                        "name": "Loutrá Oraías Elénis",
                        "latitude": "37.86466000",
                        "longitude": "22.99614000"
                    },
                    {
                        "id": 52867,
                        "name": "Loutráki",
                        "latitude": "37.97830000",
                        "longitude": "22.97781000"
                    },
                    {
                        "id": 52886,
                        "name": "Magoúla",
                        "latitude": "37.08007000",
                        "longitude": "22.40469000"
                    },
                    {
                        "id": 52912,
                        "name": "Megalópoli",
                        "latitude": "37.40111000",
                        "longitude": "22.14222000"
                    },
                    {
                        "id": 52918,
                        "name": "Meligalás",
                        "latitude": "37.21667000",
                        "longitude": "21.96667000"
                    },
                    {
                        "id": 52930,
                        "name": "Messíni",
                        "latitude": "37.05111000",
                        "longitude": "22.00778000"
                    },
                    {
                        "id": 52932,
                        "name": "Methóni",
                        "latitude": "36.81973000",
                        "longitude": "21.70486000"
                    },
                    {
                        "id": 52940,
                        "name": "Moláoi",
                        "latitude": "36.80757000",
                        "longitude": "22.85132000"
                    },
                    {
                        "id": 52949,
                        "name": "Moúlki",
                        "latitude": "37.99319000",
                        "longitude": "22.72531000"
                    },
                    {
                        "id": 52995,
                        "name": "Náfplio",
                        "latitude": "37.56863000",
                        "longitude": "22.80691000"
                    },
                    {
                        "id": 53015,
                        "name": "Néa Kíos",
                        "latitude": "37.59023000",
                        "longitude": "22.74342000"
                    },
                    {
                        "id": 53038,
                        "name": "Néa Tírins",
                        "latitude": "37.60793000",
                        "longitude": "22.81996000"
                    },
                    {
                        "id": 52962,
                        "name": "Neméa",
                        "latitude": "37.82068000",
                        "longitude": "22.66102000"
                    },
                    {
                        "id": 52980,
                        "name": "Nomós Arkadías",
                        "latitude": "37.58333000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 53075,
                        "name": "Palaiá Epídavros",
                        "latitude": "37.63847000",
                        "longitude": "23.15609000"
                    },
                    {
                        "id": 53094,
                        "name": "Paralía Vérgas",
                        "latitude": "37.00708000",
                        "longitude": "22.15676000"
                    },
                    {
                        "id": 53167,
                        "name": "Pásion",
                        "latitude": "38.01294000",
                        "longitude": "22.72814000"
                    },
                    {
                        "id": 53108,
                        "name": "Perachóra",
                        "latitude": "38.03021000",
                        "longitude": "22.94902000"
                    },
                    {
                        "id": 53115,
                        "name": "Periyiáli",
                        "latitude": "37.94041000",
                        "longitude": "22.83946000"
                    },
                    {
                        "id": 53181,
                        "name": "Pórto Chéli",
                        "latitude": "37.32786000",
                        "longitude": "23.14384000"
                    },
                    {
                        "id": 53183,
                        "name": "Pýlos",
                        "latitude": "36.91298000",
                        "longitude": "21.69650000"
                    },
                    {
                        "id": 53215,
                        "name": "Sikyón",
                        "latitude": "37.98230000",
                        "longitude": "22.72462000"
                    },
                    {
                        "id": 53225,
                        "name": "Skála",
                        "latitude": "36.85000000",
                        "longitude": "22.66667000"
                    },
                    {
                        "id": 53232,
                        "name": "Sofikón",
                        "latitude": "37.79412000",
                        "longitude": "23.05204000"
                    },
                    {
                        "id": 53241,
                        "name": "Spárti",
                        "latitude": "37.07446000",
                        "longitude": "22.43009000"
                    },
                    {
                        "id": 53240,
                        "name": "Sperchógeia",
                        "latitude": "37.07405000",
                        "longitude": "22.06248000"
                    },
                    {
                        "id": 53258,
                        "name": "Sykiá",
                        "latitude": "36.76398000",
                        "longitude": "22.94302000"
                    },
                    {
                        "id": 53279,
                        "name": "Thouría",
                        "latitude": "37.08356000",
                        "longitude": "22.04891000"
                    },
                    {
                        "id": 53286,
                        "name": "Tolón",
                        "latitude": "37.52021000",
                        "longitude": "22.85860000"
                    },
                    {
                        "id": 53287,
                        "name": "Traganón",
                        "latitude": "37.89789000",
                        "longitude": "21.31245000"
                    },
                    {
                        "id": 53294,
                        "name": "Trípoli",
                        "latitude": "37.50889000",
                        "longitude": "22.37944000"
                    },
                    {
                        "id": 53342,
                        "name": "Vélo",
                        "latitude": "37.97610000",
                        "longitude": "22.75985000"
                    },
                    {
                        "id": 53323,
                        "name": "Vlachiótis",
                        "latitude": "36.86094000",
                        "longitude": "22.70831000"
                    },
                    {
                        "id": 53324,
                        "name": "Vlachópoulo",
                        "latitude": "37.03186000",
                        "longitude": "21.79158000"
                    },
                    {
                        "id": 53326,
                        "name": "Vokhaïkó",
                        "latitude": "37.94843000",
                        "longitude": "22.79203000"
                    },
                    {
                        "id": 53333,
                        "name": "Vrakháti",
                        "latitude": "37.95895000",
                        "longitude": "22.80573000"
                    },
                    {
                        "id": 53352,
                        "name": "Xylókastro",
                        "latitude": "38.07762000",
                        "longitude": "22.63166000"
                    },
                    {
                        "id": 53361,
                        "name": "Zevgolateió",
                        "latitude": "37.93333000",
                        "longitude": "22.80000000"
                    }
                ]
            },
            {
                "id": 2114,
                "name": "Phthiotis",
                "iso2": "06",
                "latitude": "38.99978500",
                "longitude": "22.33377690",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2103,
                "name": "Preveza",
                "iso2": "34",
                "latitude": "38.95926490",
                "longitude": "20.75171550",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2121,
                "name": "Serres",
                "iso2": "62",
                "latitude": "41.08638540",
                "longitude": "23.54838190",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2118,
                "name": "South Aegean",
                "iso2": "L",
                "latitude": "37.08553020",
                "longitude": "25.14892150",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52401,
                        "name": "Adámas",
                        "latitude": "36.72506000",
                        "longitude": "24.44685000"
                    },
                    {
                        "id": 52405,
                        "name": "Afántou",
                        "latitude": "36.29354000",
                        "longitude": "28.16225000"
                    },
                    {
                        "id": 52452,
                        "name": "Amorgós",
                        "latitude": "36.83175000",
                        "longitude": "25.89821000"
                    },
                    {
                        "id": 52476,
                        "name": "Anáfi",
                        "latitude": "36.35000000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 52464,
                        "name": "Andros",
                        "latitude": "37.83333000",
                        "longitude": "24.93333000"
                    },
                    {
                        "id": 53395,
                        "name": "Áno Merá",
                        "latitude": "37.44904000",
                        "longitude": "25.39095000"
                    },
                    {
                        "id": 53396,
                        "name": "Áno Sýros",
                        "latitude": "37.44997000",
                        "longitude": "24.93562000"
                    },
                    {
                        "id": 52473,
                        "name": "Antimácheia",
                        "latitude": "36.80888000",
                        "longitude": "27.09764000"
                    },
                    {
                        "id": 52475,
                        "name": "Antíparos",
                        "latitude": "37.03940000",
                        "longitude": "25.08258000"
                    },
                    {
                        "id": 52484,
                        "name": "Archángelos",
                        "latitude": "36.21492000",
                        "longitude": "28.11487000"
                    },
                    {
                        "id": 52510,
                        "name": "Astypálaia",
                        "latitude": "36.55000000",
                        "longitude": "26.35000000"
                    },
                    {
                        "id": 52541,
                        "name": "Chálki",
                        "latitude": "36.22243000",
                        "longitude": "27.61191000"
                    },
                    {
                        "id": 53417,
                        "name": "Émponas",
                        "latitude": "36.22683000",
                        "longitude": "27.85645000"
                    },
                    {
                        "id": 52584,
                        "name": "Emporeío",
                        "latitude": "36.35816000",
                        "longitude": "25.44615000"
                    },
                    {
                        "id": 52590,
                        "name": "Ermoúpolis",
                        "latitude": "37.44466000",
                        "longitude": "24.94290000"
                    },
                    {
                        "id": 52598,
                        "name": "Faliraki",
                        "latitude": "36.33981000",
                        "longitude": "28.19942000"
                    },
                    {
                        "id": 52606,
                        "name": "Filótion",
                        "latitude": "37.05167000",
                        "longitude": "25.49829000"
                    },
                    {
                        "id": 52607,
                        "name": "Fira",
                        "latitude": "36.42107000",
                        "longitude": "25.43087000"
                    },
                    {
                        "id": 52609,
                        "name": "Folégandros",
                        "latitude": "36.62794000",
                        "longitude": "24.92021000"
                    },
                    {
                        "id": 52611,
                        "name": "Fry",
                        "latitude": "35.41623000",
                        "longitude": "26.92328000"
                    },
                    {
                        "id": 52657,
                        "name": "Ialysós",
                        "latitude": "36.41352000",
                        "longitude": "28.15516000"
                    },
                    {
                        "id": 53422,
                        "name": "Íos",
                        "latitude": "36.73333000",
                        "longitude": "25.28333000"
                    },
                    {
                        "id": 52803,
                        "name": "Kálymnos",
                        "latitude": "36.95030000",
                        "longitude": "26.98388000"
                    },
                    {
                        "id": 52712,
                        "name": "Kardámaina",
                        "latitude": "36.78305000",
                        "longitude": "27.14289000"
                    },
                    {
                        "id": 52715,
                        "name": "Karpathos",
                        "latitude": "35.50701000",
                        "longitude": "27.21322000"
                    },
                    {
                        "id": 52819,
                        "name": "Kéfalos",
                        "latitude": "36.74507000",
                        "longitude": "26.95961000"
                    },
                    {
                        "id": 52820,
                        "name": "Kímolos",
                        "latitude": "36.79368000",
                        "longitude": "24.57577000"
                    },
                    {
                        "id": 52773,
                        "name": "Kos",
                        "latitude": "36.89295000",
                        "longitude": "27.28768000"
                    },
                    {
                        "id": 52784,
                        "name": "Kremastí",
                        "latitude": "36.40981000",
                        "longitude": "28.11920000"
                    },
                    {
                        "id": 52831,
                        "name": "Kýthnos",
                        "latitude": "37.41237000",
                        "longitude": "24.43068000"
                    },
                    {
                        "id": 52836,
                        "name": "Lakkí",
                        "latitude": "37.13344000",
                        "longitude": "26.85237000"
                    },
                    {
                        "id": 52875,
                        "name": "Lárdos",
                        "latitude": "36.09419000",
                        "longitude": "28.01565000"
                    },
                    {
                        "id": 52894,
                        "name": "Mandráki",
                        "latitude": "36.61139000",
                        "longitude": "27.13333000"
                    },
                    {
                        "id": 52916,
                        "name": "Megálo Chorió",
                        "latitude": "37.45820000",
                        "longitude": "26.97272000"
                    },
                    {
                        "id": 52917,
                        "name": "Megísti",
                        "latitude": "36.14889000",
                        "longitude": "29.59361000"
                    },
                    {
                        "id": 52926,
                        "name": "Mesariá",
                        "latitude": "36.39893000",
                        "longitude": "25.44807000"
                    },
                    {
                        "id": 52957,
                        "name": "Mílos",
                        "latitude": "36.74536000",
                        "longitude": "24.42650000"
                    },
                    {
                        "id": 52950,
                        "name": "Mykonos",
                        "latitude": "37.44529000",
                        "longitude": "25.32872000"
                    },
                    {
                        "id": 52997,
                        "name": "Náousa",
                        "latitude": "37.12181000",
                        "longitude": "25.24014000"
                    },
                    {
                        "id": 52998,
                        "name": "Náxos",
                        "latitude": "37.10556000",
                        "longitude": "25.37639000"
                    },
                    {
                        "id": 52989,
                        "name": "Nomós Kykládon",
                        "latitude": "37.41667000",
                        "longitude": "24.91667000"
                    },
                    {
                        "id": 53069,
                        "name": "Oía",
                        "latitude": "36.46260000",
                        "longitude": "25.37637000"
                    },
                    {
                        "id": 53064,
                        "name": "Ornós",
                        "latitude": "37.42391000",
                        "longitude": "25.32248000"
                    },
                    {
                        "id": 53164,
                        "name": "Pánormos",
                        "latitude": "36.97156000",
                        "longitude": "26.93727000"
                    },
                    {
                        "id": 53166,
                        "name": "Páros",
                        "latitude": "37.08333000",
                        "longitude": "25.15000000"
                    },
                    {
                        "id": 53168,
                        "name": "Pátmos",
                        "latitude": "37.30895000",
                        "longitude": "26.54723000"
                    },
                    {
                        "id": 53159,
                        "name": "Pylí",
                        "latitude": "36.84472000",
                        "longitude": "27.15932000"
                    },
                    {
                        "id": 53203,
                        "name": "Ródos",
                        "latitude": "36.43556000",
                        "longitude": "28.22199000"
                    },
                    {
                        "id": 53267,
                        "name": "Sérifos",
                        "latitude": "37.15397000",
                        "longitude": "24.50614000"
                    },
                    {
                        "id": 53224,
                        "name": "Skála",
                        "latitude": "37.32218000",
                        "longitude": "26.54300000"
                    },
                    {
                        "id": 53273,
                        "name": "Sými",
                        "latitude": "36.61547000",
                        "longitude": "27.83619000"
                    },
                    {
                        "id": 53303,
                        "name": "Tínos",
                        "latitude": "37.53753000",
                        "longitude": "25.16343000"
                    },
                    {
                        "id": 53341,
                        "name": "Vári",
                        "latitude": "37.39859000",
                        "longitude": "24.94904000"
                    },
                    {
                        "id": 53362,
                        "name": "Zipári",
                        "latitude": "36.87696000",
                        "longitude": "27.20532000"
                    }
                ]
            },
            {
                "id": 2097,
                "name": "Thessaloniki",
                "iso2": "54",
                "latitude": "40.64006290",
                "longitude": "22.94441910",
                "type": "regional unit",
                "cities": []
            },
            {
                "id": 2096,
                "name": "West Greece",
                "iso2": "G",
                "latitude": "38.51154960",
                "longitude": "21.57067860",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52414,
                        "name": "Agrínio",
                        "latitude": "38.62139000",
                        "longitude": "21.40778000"
                    },
                    {
                        "id": 52522,
                        "name": "Aígio",
                        "latitude": "38.24861000",
                        "longitude": "22.08194000"
                    },
                    {
                        "id": 52432,
                        "name": "Aitolikó",
                        "latitude": "38.43704000",
                        "longitude": "21.35358000"
                    },
                    {
                        "id": 52523,
                        "name": "Aíyira",
                        "latitude": "38.14846000",
                        "longitude": "22.35426000"
                    },
                    {
                        "id": 52437,
                        "name": "Akráta",
                        "latitude": "38.15469000",
                        "longitude": "22.31830000"
                    },
                    {
                        "id": 52438,
                        "name": "Aktaío",
                        "latitude": "38.30444000",
                        "longitude": "21.79440000"
                    },
                    {
                        "id": 52442,
                        "name": "Alfeioúsa",
                        "latitude": "37.64019000",
                        "longitude": "21.53750000"
                    },
                    {
                        "id": 52447,
                        "name": "Amaliáda",
                        "latitude": "37.79842000",
                        "longitude": "21.35068000"
                    },
                    {
                        "id": 52449,
                        "name": "Amfilochía",
                        "latitude": "38.85944000",
                        "longitude": "21.16639000"
                    },
                    {
                        "id": 52463,
                        "name": "Andravída",
                        "latitude": "37.90588000",
                        "longitude": "21.26936000"
                    },
                    {
                        "id": 52466,
                        "name": "Angelókastro",
                        "latitude": "38.56585000",
                        "longitude": "21.29631000"
                    },
                    {
                        "id": 53391,
                        "name": "Áno Kastrítsi",
                        "latitude": "38.27228000",
                        "longitude": "21.83600000"
                    },
                    {
                        "id": 52474,
                        "name": "Antirrio",
                        "latitude": "38.33014000",
                        "longitude": "21.76413000"
                    },
                    {
                        "id": 52482,
                        "name": "Archaía Olympía",
                        "latitude": "37.64788000",
                        "longitude": "21.62710000"
                    },
                    {
                        "id": 52483,
                        "name": "Archontochóri",
                        "latitude": "38.70053000",
                        "longitude": "21.03896000"
                    },
                    {
                        "id": 52495,
                        "name": "Arkoúdi",
                        "latitude": "37.84681000",
                        "longitude": "21.11022000"
                    },
                    {
                        "id": 52509,
                        "name": "Astakós",
                        "latitude": "38.53556000",
                        "longitude": "21.08135000"
                    },
                    {
                        "id": 53411,
                        "name": "Áyios Konstandínos",
                        "latitude": "38.63337000",
                        "longitude": "21.39950000"
                    },
                    {
                        "id": 52525,
                        "name": "Chalandrítsa",
                        "latitude": "38.10843000",
                        "longitude": "21.78349000"
                    },
                    {
                        "id": 52542,
                        "name": "Chávari",
                        "latitude": "37.84842000",
                        "longitude": "21.38403000"
                    },
                    {
                        "id": 52550,
                        "name": "Dhokímion",
                        "latitude": "38.61352000",
                        "longitude": "21.38072000"
                    },
                    {
                        "id": 52588,
                        "name": "Epitálio",
                        "latitude": "37.62675000",
                        "longitude": "21.49528000"
                    },
                    {
                        "id": 52614,
                        "name": "Fyteíes",
                        "latitude": "38.69524000",
                        "longitude": "21.18467000"
                    },
                    {
                        "id": 52622,
                        "name": "Galatás",
                        "latitude": "38.35742000",
                        "longitude": "21.56222000"
                    },
                    {
                        "id": 52629,
                        "name": "Gastoúni",
                        "latitude": "37.85000000",
                        "longitude": "21.25000000"
                    },
                    {
                        "id": 52630,
                        "name": "Gavaloú",
                        "latitude": "38.52903000",
                        "longitude": "21.53226000"
                    },
                    {
                        "id": 52640,
                        "name": "Goúmero",
                        "latitude": "37.76236000",
                        "longitude": "21.61853000"
                    },
                    {
                        "id": 52672,
                        "name": "Kainoúryion",
                        "latitude": "38.60453000",
                        "longitude": "21.48776000"
                    },
                    {
                        "id": 52688,
                        "name": "Kalávryta",
                        "latitude": "38.03222000",
                        "longitude": "22.11250000"
                    },
                    {
                        "id": 52699,
                        "name": "Kamárai",
                        "latitude": "38.29881000",
                        "longitude": "21.99892000"
                    },
                    {
                        "id": 52702,
                        "name": "Kandíla",
                        "latitude": "38.70564000",
                        "longitude": "20.94749000"
                    },
                    {
                        "id": 52720,
                        "name": "Karátoula",
                        "latitude": "37.73564000",
                        "longitude": "21.53578000"
                    },
                    {
                        "id": 52707,
                        "name": "Kardamás",
                        "latitude": "37.76729000",
                        "longitude": "21.33946000"
                    },
                    {
                        "id": 52805,
                        "name": "Káto Achaḯa",
                        "latitude": "38.15000000",
                        "longitude": "21.55000000"
                    },
                    {
                        "id": 52813,
                        "name": "Káto Mazaráki",
                        "latitude": "38.07035000",
                        "longitude": "21.65097000"
                    },
                    {
                        "id": 52731,
                        "name": "Katochí",
                        "latitude": "38.41237000",
                        "longitude": "21.25258000"
                    },
                    {
                        "id": 52732,
                        "name": "Katoúna",
                        "latitude": "38.78547000",
                        "longitude": "21.11417000"
                    },
                    {
                        "id": 52736,
                        "name": "Kavásila",
                        "latitude": "37.87581000",
                        "longitude": "21.26422000"
                    },
                    {
                        "id": 52791,
                        "name": "Kréstena",
                        "latitude": "37.59193000",
                        "longitude": "21.62034000"
                    },
                    {
                        "id": 52792,
                        "name": "Kríkellos",
                        "latitude": "38.94532000",
                        "longitude": "21.17910000"
                    },
                    {
                        "id": 52795,
                        "name": "Kyllíni",
                        "latitude": "37.93542000",
                        "longitude": "21.14503000"
                    },
                    {
                        "id": 52873,
                        "name": "Lálas",
                        "latitude": "37.70936000",
                        "longitude": "21.72117000"
                    },
                    {
                        "id": 52874,
                        "name": "Lápas",
                        "latitude": "38.09755000",
                        "longitude": "21.41861000"
                    },
                    {
                        "id": 52839,
                        "name": "Lechainá",
                        "latitude": "37.93333000",
                        "longitude": "21.26667000"
                    },
                    {
                        "id": 52846,
                        "name": "Lepenoú",
                        "latitude": "38.70839000",
                        "longitude": "21.28970000"
                    },
                    {
                        "id": 52854,
                        "name": "Limnokhórion",
                        "latitude": "38.14115000",
                        "longitude": "21.48047000"
                    },
                    {
                        "id": 52890,
                        "name": "Makrísia",
                        "latitude": "37.60957000",
                        "longitude": "21.60509000"
                    },
                    {
                        "id": 52896,
                        "name": "Manoláda",
                        "latitude": "38.04708000",
                        "longitude": "21.34814000"
                    },
                    {
                        "id": 52905,
                        "name": "Mataránga",
                        "latitude": "38.52359000",
                        "longitude": "21.47325000"
                    },
                    {
                        "id": 52914,
                        "name": "Megáli Khóra",
                        "latitude": "38.64629000",
                        "longitude": "21.37309000"
                    },
                    {
                        "id": 52925,
                        "name": "Menídi",
                        "latitude": "39.04213000",
                        "longitude": "21.11875000"
                    },
                    {
                        "id": 52928,
                        "name": "Mesolóngi",
                        "latitude": "38.37138000",
                        "longitude": "21.43151000"
                    },
                    {
                        "id": 52936,
                        "name": "Mindilóglion",
                        "latitude": "38.18387000",
                        "longitude": "21.70133000"
                    },
                    {
                        "id": 52941,
                        "name": "Monastiráki",
                        "latitude": "38.85053000",
                        "longitude": "20.94458000"
                    },
                    {
                        "id": 52951,
                        "name": "Myrsíni",
                        "latitude": "37.92117000",
                        "longitude": "21.23700000"
                    },
                    {
                        "id": 52994,
                        "name": "Náfpaktos",
                        "latitude": "38.39167000",
                        "longitude": "21.82750000"
                    },
                    {
                        "id": 53018,
                        "name": "Néa Manoláda",
                        "latitude": "38.05378000",
                        "longitude": "21.38189000"
                    },
                    {
                        "id": 52974,
                        "name": "Neápolis",
                        "latitude": "38.67144000",
                        "longitude": "21.36274000"
                    },
                    {
                        "id": 52968,
                        "name": "Neochóri",
                        "latitude": "37.90794000",
                        "longitude": "21.20392000"
                    },
                    {
                        "id": 52969,
                        "name": "Neochórion",
                        "latitude": "38.40847000",
                        "longitude": "21.27511000"
                    },
                    {
                        "id": 52978,
                        "name": "Nomós Achaḯas",
                        "latitude": "38.00000000",
                        "longitude": "22.00000000"
                    },
                    {
                        "id": 52979,
                        "name": "Nomós Aitolías kai Akarnanías",
                        "latitude": "38.50000000",
                        "longitude": "21.50000000"
                    },
                    {
                        "id": 52984,
                        "name": "Nomós Ileías",
                        "latitude": "37.75000000",
                        "longitude": "21.58333000"
                    },
                    {
                        "id": 53067,
                        "name": "Ovriá",
                        "latitude": "38.18866000",
                        "longitude": "21.72903000"
                    },
                    {
                        "id": 53162,
                        "name": "Pálairos",
                        "latitude": "38.78300000",
                        "longitude": "20.88183000"
                    },
                    {
                        "id": 53085,
                        "name": "Panaitólion",
                        "latitude": "38.58316000",
                        "longitude": "21.44729000"
                    },
                    {
                        "id": 53087,
                        "name": "Pappadhátai",
                        "latitude": "38.52816000",
                        "longitude": "21.45016000"
                    },
                    {
                        "id": 53090,
                        "name": "Paralía",
                        "latitude": "38.19833000",
                        "longitude": "21.70263000"
                    },
                    {
                        "id": 53098,
                        "name": "Paravóla",
                        "latitude": "38.61472000",
                        "longitude": "21.52046000"
                    },
                    {
                        "id": 53169,
                        "name": "Pátra",
                        "latitude": "38.24444000",
                        "longitude": "21.73444000"
                    },
                    {
                        "id": 53104,
                        "name": "Pelópi",
                        "latitude": "37.67444000",
                        "longitude": "21.59344000"
                    },
                    {
                        "id": 53130,
                        "name": "Plátanos",
                        "latitude": "37.66731000",
                        "longitude": "21.61108000"
                    },
                    {
                        "id": 53184,
                        "name": "Pýrgos",
                        "latitude": "37.67513000",
                        "longitude": "21.44102000"
                    },
                    {
                        "id": 53200,
                        "name": "Río",
                        "latitude": "38.29558000",
                        "longitude": "21.78504000"
                    },
                    {
                        "id": 53194,
                        "name": "Rododáfni",
                        "latitude": "38.26976000",
                        "longitude": "22.04875000"
                    },
                    {
                        "id": 53199,
                        "name": "Royítika",
                        "latitude": "38.18268000",
                        "longitude": "21.68414000"
                    },
                    {
                        "id": 53206,
                        "name": "Sardínia",
                        "latitude": "38.89003000",
                        "longitude": "21.20619000"
                    },
                    {
                        "id": 53208,
                        "name": "Savália",
                        "latitude": "37.82158000",
                        "longitude": "21.29425000"
                    },
                    {
                        "id": 53256,
                        "name": "Stános",
                        "latitude": "38.80453000",
                        "longitude": "21.17461000"
                    },
                    {
                        "id": 53261,
                        "name": "Sylivainiótika",
                        "latitude": "38.16139000",
                        "longitude": "22.33156000"
                    },
                    {
                        "id": 53262,
                        "name": "Synoikismós Chavaríou",
                        "latitude": "37.85575000",
                        "longitude": "21.38789000"
                    },
                    {
                        "id": 53301,
                        "name": "Témeni",
                        "latitude": "38.23707000",
                        "longitude": "22.12533000"
                    },
                    {
                        "id": 53284,
                        "name": "Thérmo",
                        "latitude": "38.57358000",
                        "longitude": "21.66628000"
                    },
                    {
                        "id": 53288,
                        "name": "Triandaíika",
                        "latitude": "38.65530000",
                        "longitude": "21.38315000"
                    },
                    {
                        "id": 53339,
                        "name": "Várda",
                        "latitude": "38.03058000",
                        "longitude": "21.36506000"
                    },
                    {
                        "id": 53309,
                        "name": "Vartholomió",
                        "latitude": "37.86219000",
                        "longitude": "21.20575000"
                    },
                    {
                        "id": 53310,
                        "name": "Varvásaina",
                        "latitude": "37.67106000",
                        "longitude": "21.49886000"
                    },
                    {
                        "id": 53346,
                        "name": "Vónitsa",
                        "latitude": "38.91639000",
                        "longitude": "20.88639000"
                    },
                    {
                        "id": 53332,
                        "name": "Vrachnaíika",
                        "latitude": "38.16253000",
                        "longitude": "21.66693000"
                    },
                    {
                        "id": 53356,
                        "name": "Zacháro",
                        "latitude": "37.48333000",
                        "longitude": "21.65000000"
                    }
                ]
            },
            {
                "id": 2108,
                "name": "West Macedonia",
                "iso2": "C",
                "latitude": "40.30040580",
                "longitude": "21.79035590",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52428,
                        "name": "Aianí",
                        "latitude": "40.16381000",
                        "longitude": "21.81945000"
                    },
                    {
                        "id": 52435,
                        "name": "Akriní",
                        "latitude": "40.43492000",
                        "longitude": "21.90609000"
                    },
                    {
                        "id": 52451,
                        "name": "Ammochóri",
                        "latitude": "40.78203000",
                        "longitude": "21.48458000"
                    },
                    {
                        "id": 52458,
                        "name": "Amýntaio",
                        "latitude": "40.68967000",
                        "longitude": "21.67974000"
                    },
                    {
                        "id": 52460,
                        "name": "Anaráchi",
                        "latitude": "40.49234000",
                        "longitude": "21.57279000"
                    },
                    {
                        "id": 53392,
                        "name": "Áno Kómi",
                        "latitude": "40.22660000",
                        "longitude": "21.82827000"
                    },
                    {
                        "id": 52488,
                        "name": "Argos Orestiko",
                        "latitude": "40.45354000",
                        "longitude": "21.25889000"
                    },
                    {
                        "id": 52533,
                        "name": "Chlói",
                        "latitude": "40.53918000",
                        "longitude": "21.25923000"
                    },
                    {
                        "id": 52548,
                        "name": "Deskáti",
                        "latitude": "39.92422000",
                        "longitude": "21.81031000"
                    },
                    {
                        "id": 52585,
                        "name": "Empório",
                        "latitude": "40.48866000",
                        "longitude": "21.55768000"
                    },
                    {
                        "id": 52592,
                        "name": "Erátyra",
                        "latitude": "40.34253000",
                        "longitude": "21.51333000"
                    },
                    {
                        "id": 52605,
                        "name": "Filótas",
                        "latitude": "40.62520000",
                        "longitude": "21.70851000"
                    },
                    {
                        "id": 52608,
                        "name": "Flórina",
                        "latitude": "40.78197000",
                        "longitude": "21.40981000"
                    },
                    {
                        "id": 52620,
                        "name": "Galatiní",
                        "latitude": "40.31966000",
                        "longitude": "21.55148000"
                    },
                    {
                        "id": 52646,
                        "name": "Grevená",
                        "latitude": "40.08452000",
                        "longitude": "21.42744000"
                    },
                    {
                        "id": 52724,
                        "name": "Kastoria",
                        "latitude": "40.52165000",
                        "longitude": "21.26341000"
                    },
                    {
                        "id": 52753,
                        "name": "Kleítos",
                        "latitude": "40.43140000",
                        "longitude": "21.85806000"
                    },
                    {
                        "id": 52781,
                        "name": "Koíla",
                        "latitude": "40.33055000",
                        "longitude": "21.79102000"
                    },
                    {
                        "id": 52761,
                        "name": "Komniná",
                        "latitude": "40.59057000",
                        "longitude": "21.77671000"
                    },
                    {
                        "id": 52780,
                        "name": "Kozáni",
                        "latitude": "40.30069000",
                        "longitude": "21.78896000"
                    },
                    {
                        "id": 52793,
                        "name": "Krókos",
                        "latitude": "40.26349000",
                        "longitude": "21.81760000"
                    },
                    {
                        "id": 52835,
                        "name": "Laimós",
                        "latitude": "40.83628000",
                        "longitude": "21.14061000"
                    },
                    {
                        "id": 52878,
                        "name": "Léchovo",
                        "latitude": "40.58442000",
                        "longitude": "21.49218000"
                    },
                    {
                        "id": 52861,
                        "name": "Livaderó",
                        "latitude": "40.03455000",
                        "longitude": "21.94279000"
                    },
                    {
                        "id": 52895,
                        "name": "Maniákoi",
                        "latitude": "40.50064000",
                        "longitude": "21.24446000"
                    },
                    {
                        "id": 52906,
                        "name": "Mavrochóri",
                        "latitude": "40.51224000",
                        "longitude": "21.32038000"
                    },
                    {
                        "id": 52923,
                        "name": "Melíti",
                        "latitude": "40.83434000",
                        "longitude": "21.58426000"
                    },
                    {
                        "id": 52929,
                        "name": "Mesopotamía",
                        "latitude": "40.50252000",
                        "longitude": "21.16110000"
                    },
                    {
                        "id": 52960,
                        "name": "Nea Lava",
                        "latitude": "40.19048000",
                        "longitude": "22.01320000"
                    },
                    {
                        "id": 52972,
                        "name": "Nestório",
                        "latitude": "40.41278000",
                        "longitude": "21.06222000"
                    },
                    {
                        "id": 52988,
                        "name": "Nomós Kozánis",
                        "latitude": "40.33333000",
                        "longitude": "21.71667000"
                    },
                    {
                        "id": 53126,
                        "name": "Platanórevma",
                        "latitude": "40.20083000",
                        "longitude": "22.02488000"
                    },
                    {
                        "id": 53157,
                        "name": "Ptolemaḯda",
                        "latitude": "40.51472000",
                        "longitude": "21.67861000"
                    },
                    {
                        "id": 53269,
                        "name": "Sérvia",
                        "latitude": "40.17972000",
                        "longitude": "21.99444000"
                    },
                    {
                        "id": 53218,
                        "name": "Siátista",
                        "latitude": "40.26194000",
                        "longitude": "21.54417000"
                    },
                    {
                        "id": 53297,
                        "name": "Tsotíli",
                        "latitude": "40.26147000",
                        "longitude": "21.32533000"
                    },
                    {
                        "id": 53319,
                        "name": "Velventós",
                        "latitude": "40.25532000",
                        "longitude": "22.07543000"
                    },
                    {
                        "id": 53349,
                        "name": "Xinó Neró",
                        "latitude": "40.69028000",
                        "longitude": "21.62324000"
                    }
                ]
            }
        ]
    },
    {
        "id": 86,
        "name": "Greenland",
        "iso3": "GRL",
        "iso2": "GL",
        "numeric_code": "304",
        "phonecode": "299",
        "capital": "Nuuk",
        "currency": "DKK",
        "currency_name": "Danish krone",
        "currency_symbol": "Kr.",
        "tld": ".gl",
        "native": "Kalaallit Nunaat",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Northern America",
        "subregion_id": 6,
        "nationality": "Greenlandic",
        "timezones": [
            {
                "zoneName": "America\/Danmarkshavn",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            },
            {
                "zoneName": "America\/Nuuk",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "WGT",
                "tzName": "West Greenland Time"
            },
            {
                "zoneName": "America\/Scoresbysund",
                "gmtOffset": -3600,
                "gmtOffsetName": "UTC-01:00",
                "abbreviation": "EGT",
                "tzName": "Eastern Greenland Time"
            },
            {
                "zoneName": "America\/Thule",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Greunland",
            "ko": "그린란드",
            "pt-BR": "Groelândia",
            "pt": "Gronelândia",
            "nl": "Groenland",
            "hr": "Grenland",
            "fa": "گرینلند",
            "de": "Grönland",
            "es": "Groenlandia",
            "fr": "Groenland",
            "ja": "グリーンランド",
            "it": "Groenlandia",
            "zh-CN": "格陵兰岛",
            "tr": "Grönland",
            "ru": "Гренландия",
            "uk": "Гренландія",
            "pl": "Grenlandia"
        },
        "latitude": "72.00000000",
        "longitude": "-40.00000000",
        "emoji": "🇬🇱",
        "emojiU": "U+1F1EC U+1F1F1",
        "states": [
            {
                "id": 5379,
                "name": "Avannaata",
                "iso2": "AV",
                "latitude": "74.10267430",
                "longitude": "-78.98755600",
                "type": "municipality",
                "cities": [
                    {
                        "id": 154930,
                        "name": "Ilulissat",
                        "latitude": "69.22794880",
                        "longitude": "-51.12805390"
                    },
                    {
                        "id": 154931,
                        "name": "Qaanaaq",
                        "latitude": "77.46740090",
                        "longitude": "-69.24837110"
                    },
                    {
                        "id": 154933,
                        "name": "Upernavik",
                        "latitude": "72.78686030",
                        "longitude": "-56.16236710"
                    },
                    {
                        "id": 154932,
                        "name": "Uummannaq",
                        "latitude": "70.67868970",
                        "longitude": "-52.14978240"
                    }
                ]
            },
            {
                "id": 5380,
                "name": "Kujalleq",
                "iso2": "KU",
                "latitude": "61.16666930",
                "longitude": "-50.50997880",
                "type": "municipality",
                "cities": [
                    {
                        "id": 154934,
                        "name": "Nanortalik",
                        "latitude": "60.14308250",
                        "longitude": "-45.25629050"
                    },
                    {
                        "id": 154935,
                        "name": "Narsaq",
                        "latitude": "60.91140780",
                        "longitude": "-46.06857080"
                    },
                    {
                        "id": 154936,
                        "name": "Qaqortoq",
                        "latitude": "60.71959600",
                        "longitude": "-46.05481630"
                    }
                ]
            },
            {
                "id": 5381,
                "name": "Qeqertalik",
                "iso2": "QT",
                "latitude": "68.82495530",
                "longitude": "-54.76224720",
                "type": "municipality",
                "cities": [
                    {
                        "id": 154937,
                        "name": "Aasiaat",
                        "latitude": "68.70762800",
                        "longitude": "-52.89951360"
                    },
                    {
                        "id": 154938,
                        "name": "Kangaatsiaq",
                        "latitude": "68.30818450",
                        "longitude": "-53.47685330"
                    },
                    {
                        "id": 154939,
                        "name": "Qasigiannguit",
                        "latitude": "68.81986320",
                        "longitude": "-51.20916370"
                    },
                    {
                        "id": 154940,
                        "name": "Qeqertarsuaq",
                        "latitude": "69.24430370",
                        "longitude": "-53.56440060"
                    }
                ]
            },
            {
                "id": 5382,
                "name": "Qeqqata",
                "iso2": "QE",
                "latitude": "66.08057190",
                "longitude": "-54.26546390",
                "type": "municipality",
                "cities": [
                    {
                        "id": 154941,
                        "name": "Maniitsoq",
                        "latitude": "65.40657990",
                        "longitude": "-52.94225730"
                    },
                    {
                        "id": 154942,
                        "name": "Sisimiut",
                        "latitude": "66.93945740",
                        "longitude": "-53.74567660"
                    }
                ]
            },
            {
                "id": 5383,
                "name": "Sermersooq",
                "iso2": "SM",
                "latitude": "65.08230580",
                "longitude": "-57.28311950",
                "type": "municipality",
                "cities": [
                    {
                        "id": 154943,
                        "name": "Ammassalik",
                        "latitude": "65.61452670",
                        "longitude": "-37.65014660"
                    },
                    {
                        "id": 154944,
                        "name": "Ittoqqortoormiit",
                        "latitude": "70.48634210",
                        "longitude": "-21.97986600"
                    },
                    {
                        "id": 154945,
                        "name": "Ivittuut",
                        "latitude": "61.20651840",
                        "longitude": "-48.18198510"
                    },
                    {
                        "id": 154946,
                        "name": "Nuuk",
                        "latitude": "64.17910090",
                        "longitude": "-51.74800910"
                    },
                    {
                        "id": 154947,
                        "name": "Paamiut",
                        "latitude": "62.00259620",
                        "longitude": "-49.70519590"
                    }
                ]
            }
        ]
    },
    {
        "id": 87,
        "name": "Grenada",
        "iso3": "GRD",
        "iso2": "GD",
        "numeric_code": "308",
        "phonecode": "1",
        "capital": "St. George's",
        "currency": "XCD",
        "currency_name": "Eastern Caribbean dollar",
        "currency_symbol": "$",
        "tld": ".gd",
        "native": "Grenada",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Grenadian",
        "timezones": [
            {
                "zoneName": "America\/Grenada",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Grenada",
            "ko": "그레나다",
            "pt-BR": "Granada",
            "pt": "Granada",
            "nl": "Grenada",
            "hr": "Grenada",
            "fa": "گرنادا",
            "de": "Grenada",
            "es": "Grenada",
            "fr": "Grenade",
            "ja": "グレナダ",
            "it": "Grenada",
            "zh-CN": "格林纳达",
            "tr": "Grenada",
            "ru": "Гренада",
            "uk": "Гренада",
            "pl": "Grenada"
        },
        "latitude": "12.11666666",
        "longitude": "-61.66666666",
        "emoji": "🇬🇩",
        "emojiU": "U+1F1EC U+1F1E9",
        "states": [
            {
                "id": 3867,
                "name": "Carriacou",
                "iso2": "10",
                "latitude": "12.48289710",
                "longitude": "-61.50102610",
                "type": "dependency",
                "cities": [
                    {
                        "id": 52030,
                        "name": "Hillsborough",
                        "latitude": "12.48292000",
                        "longitude": "-61.45597000"
                    }
                ]
            },
            {
                "id": 3865,
                "name": "Saint Andrew",
                "iso2": "01",
                "latitude": "12.11093730",
                "longitude": "-61.72935040",
                "type": "parish",
                "cities": [
                    {
                        "id": 52029,
                        "name": "Grenville",
                        "latitude": "12.12278000",
                        "longitude": "-61.62498000"
                    }
                ]
            },
            {
                "id": 3869,
                "name": "Saint David",
                "iso2": "02",
                "latitude": "12.04121250",
                "longitude": "-61.71730420",
                "type": "parish",
                "cities": [
                    {
                        "id": 52031,
                        "name": "Saint David’s",
                        "latitude": "12.04903000",
                        "longitude": "-61.66875000"
                    }
                ]
            },
            {
                "id": 3864,
                "name": "Saint George",
                "iso2": "03",
                "latitude": "12.04788240",
                "longitude": "-61.83131890",
                "type": "parish",
                "cities": [
                    {
                        "id": 52032,
                        "name": "Saint George's",
                        "latitude": "12.05288000",
                        "longitude": "-61.75226000"
                    }
                ]
            },
            {
                "id": 3868,
                "name": "Saint John",
                "iso2": "04",
                "latitude": "12.14319830",
                "longitude": "-61.75857370",
                "type": "parish",
                "cities": [
                    {
                        "id": 52028,
                        "name": "Gouyave",
                        "latitude": "12.16462000",
                        "longitude": "-61.72965000"
                    }
                ]
            },
            {
                "id": 3866,
                "name": "Saint Mark",
                "iso2": "05",
                "latitude": "12.18577640",
                "longitude": "-61.73841480",
                "type": "parish",
                "cities": [
                    {
                        "id": 52034,
                        "name": "Victoria",
                        "latitude": "12.19021000",
                        "longitude": "-61.70677000"
                    }
                ]
            },
            {
                "id": 3863,
                "name": "Saint Patrick",
                "iso2": "06",
                "latitude": "12.24896480",
                "longitude": "-61.69578480",
                "type": "parish",
                "cities": [
                    {
                        "id": 52033,
                        "name": "Sauteurs",
                        "latitude": "12.21833000",
                        "longitude": "-61.63917000"
                    }
                ]
            }
        ]
    },
    {
        "id": 88,
        "name": "Guadeloupe",
        "iso3": "GLP",
        "iso2": "GP",
        "numeric_code": "312",
        "phonecode": "590",
        "capital": "Basse-Terre",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".gp",
        "native": "Guadeloupe",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Guadeloupe",
        "timezones": [
            {
                "zoneName": "America\/Guadeloupe",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Gwadloup",
            "ko": "과들루프",
            "pt-BR": "Guadalupe",
            "pt": "Guadalupe",
            "nl": "Guadeloupe",
            "hr": "Gvadalupa",
            "fa": "جزیره گوادلوپ",
            "de": "Guadeloupe",
            "es": "Guadalupe",
            "fr": "Guadeloupe",
            "ja": "グアドループ",
            "it": "Guadeloupa",
            "zh-CN": "瓜德罗普岛",
            "tr": "Guadeloupe",
            "ru": "Гваделупа",
            "uk": "Гваделупа",
            "pl": "Gwadelupa"
        },
        "latitude": "16.25000000",
        "longitude": "-61.58333300",
        "emoji": "🇬🇵",
        "emojiU": "U+1F1EC U+1F1F5",
        "states": [
            {
                "id": 5384,
                "name": "Basse-Terre",
                "iso2": "01",
                "latitude": "16.10110190",
                "longitude": "-62.00545460",
                "type": "district",
                "cities": [
                    {
                        "id": 154948,
                        "name": "Baie-Mahault",
                        "latitude": "16.24976070",
                        "longitude": "-61.67750720"
                    },
                    {
                        "id": 154949,
                        "name": "Baillif",
                        "latitude": "16.04973310",
                        "longitude": "-61.75705910"
                    },
                    {
                        "id": 154950,
                        "name": "Basse-Terre",
                        "latitude": "15.99916310",
                        "longitude": "-61.74998100"
                    },
                    {
                        "id": 154951,
                        "name": "Bouillante",
                        "latitude": "16.13869370",
                        "longitude": "-61.79898970"
                    },
                    {
                        "id": 154952,
                        "name": "Capesterre-Belle-Eau",
                        "latitude": "16.04854020",
                        "longitude": "-61.70210450"
                    },
                    {
                        "id": 154953,
                        "name": "Deshaies",
                        "latitude": "16.31936050",
                        "longitude": "-61.82425780"
                    },
                    {
                        "id": 154954,
                        "name": "Gourbeyre",
                        "latitude": "16.00565950",
                        "longitude": "-61.73023870"
                    },
                    {
                        "id": 154955,
                        "name": "Goyave",
                        "latitude": "16.12310770",
                        "longitude": "-61.69740210"
                    },
                    {
                        "id": 154956,
                        "name": "Lamentin",
                        "latitude": "16.24431320",
                        "longitude": "-61.75191940"
                    },
                    {
                        "id": 154957,
                        "name": "Petit-Bourg",
                        "latitude": "16.16948810",
                        "longitude": "-61.74043310"
                    },
                    {
                        "id": 154958,
                        "name": "Pointe-Noire",
                        "latitude": "16.22702770",
                        "longitude": "-61.80631220"
                    },
                    {
                        "id": 154959,
                        "name": "Saint-Claude",
                        "latitude": "16.04057440",
                        "longitude": "-61.73648730"
                    },
                    {
                        "id": 154960,
                        "name": "Sainte-Rose",
                        "latitude": "16.29372520",
                        "longitude": "-61.76595760"
                    },
                    {
                        "id": 154961,
                        "name": "Terre-de-Bas",
                        "latitude": "15.85541960",
                        "longitude": "-61.65329200"
                    },
                    {
                        "id": 154962,
                        "name": "Terre-de-Haut",
                        "latitude": "15.85803760",
                        "longitude": "-61.60960980"
                    },
                    {
                        "id": 154963,
                        "name": "Trois-Rivières",
                        "latitude": "15.99313620",
                        "longitude": "-61.69052960"
                    },
                    {
                        "id": 154964,
                        "name": "Vieux-Fort",
                        "latitude": "15.96070380",
                        "longitude": "-61.71351770"
                    },
                    {
                        "id": 154965,
                        "name": "Vieux-Habitants",
                        "latitude": "16.08466180",
                        "longitude": "-61.79939230"
                    }
                ]
            },
            {
                "id": 5385,
                "name": "Pointe-à-Pitre",
                "iso2": "02",
                "latitude": "16.19024380",
                "longitude": "-61.62917130",
                "type": "district",
                "cities": [
                    {
                        "id": 154967,
                        "name": "Anse-Bertrand",
                        "latitude": "16.46681810",
                        "longitude": "-61.55217680"
                    },
                    {
                        "id": 154968,
                        "name": "Capesterre-de-Marie-Galante",
                        "latitude": "15.91763990",
                        "longitude": "-61.27077860"
                    },
                    {
                        "id": 154971,
                        "name": "Grand-Bourg",
                        "latitude": "15.90853800",
                        "longitude": "-61.33406180"
                    },
                    {
                        "id": 154969,
                        "name": "La Désirade",
                        "latitude": "16.25845450",
                        "longitude": "-61.14902790"
                    },
                    {
                        "id": 154970,
                        "name": "Le Gosier",
                        "latitude": "16.22726250",
                        "longitude": "-61.55734490"
                    },
                    {
                        "id": 154973,
                        "name": "Le Moule",
                        "latitude": "16.33536870",
                        "longitude": "-61.44242930"
                    },
                    {
                        "id": 154966,
                        "name": "Les Abymes",
                        "latitude": "16.26773830",
                        "longitude": "-61.57907270"
                    },
                    {
                        "id": 154972,
                        "name": "Morne-à-l'Eau",
                        "latitude": "16.32110610",
                        "longitude": "-61.66356890"
                    },
                    {
                        "id": 154974,
                        "name": "Petit-Canal",
                        "latitude": "16.39213100",
                        "longitude": "-61.53713120"
                    },
                    {
                        "id": 154975,
                        "name": "Pointe-à-Pitre",
                        "latitude": "16.23313040",
                        "longitude": "-61.56234850"
                    },
                    {
                        "id": 154976,
                        "name": "Port-Louis",
                        "latitude": "16.42012820",
                        "longitude": "-61.57039890"
                    },
                    {
                        "id": 154977,
                        "name": "Saint-François",
                        "latitude": "16.27834950",
                        "longitude": "-61.33624980"
                    },
                    {
                        "id": 154978,
                        "name": "Saint-Louis",
                        "latitude": "15.96535890",
                        "longitude": "-61.35562500"
                    },
                    {
                        "id": 154979,
                        "name": "Sainte-Anne",
                        "latitude": "16.25646130",
                        "longitude": "-61.47202880"
                    }
                ]
            }
        ]
    },
    {
        "id": 89,
        "name": "Guam",
        "iso3": "GUM",
        "iso2": "GU",
        "numeric_code": "316",
        "phonecode": "1",
        "capital": "Hagatna",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".gu",
        "native": "Guam",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Micronesia",
        "subregion_id": 21,
        "nationality": "Guamanian, Guambat",
        "timezones": [
            {
                "zoneName": "Pacific\/Guam",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "CHST",
                "tzName": "Chamorro Standard Time"
            }
        ],
        "translations": {
            "br": "Guam",
            "ko": "괌",
            "pt-BR": "Guam",
            "pt": "Guame",
            "nl": "Guam",
            "hr": "Guam",
            "fa": "گوام",
            "de": "Guam",
            "es": "Guam",
            "fr": "Guam",
            "ja": "グアム",
            "it": "Guam",
            "zh-CN": "关岛",
            "tr": "Guam",
            "ru": "Гуам",
            "uk": "Гуам",
            "pl": "Guam"
        },
        "latitude": "13.46666666",
        "longitude": "144.78333333",
        "emoji": "🇬🇺",
        "emojiU": "U+1F1EC U+1F1FA",
        "states": [
            {
                "id": 5254,
                "name": "Agana Heights",
                "iso2": null,
                "latitude": "13.46575920",
                "longitude": "144.73195330",
                "type": "village",
                "cities": []
            },
            {
                "id": 5255,
                "name": "Asan-Maina",
                "iso2": null,
                "latitude": "13.47291240",
                "longitude": "144.71180410",
                "type": "village",
                "cities": []
            },
            {
                "id": 5256,
                "name": "Barrigada",
                "iso2": null,
                "latitude": "13.46418270",
                "longitude": "144.78822470",
                "type": "village",
                "cities": []
            },
            {
                "id": 5257,
                "name": "Chalan Pago-Ordot",
                "iso2": null,
                "latitude": "13.43699800",
                "longitude": "144.74867080",
                "type": "village",
                "cities": []
            },
            {
                "id": 5258,
                "name": "Dededo",
                "iso2": null,
                "latitude": "13.52289900",
                "longitude": "144.79892870",
                "type": "village",
                "cities": []
            },
            {
                "id": 5259,
                "name": "Hågat",
                "iso2": null,
                "latitude": "13.38522240",
                "longitude": "144.63996980",
                "type": "village",
                "cities": []
            },
            {
                "id": 5265,
                "name": "Hagåtña",
                "iso2": null,
                "latitude": "13.47298290",
                "longitude": "144.72740380",
                "type": "village",
                "cities": []
            },
            {
                "id": 5261,
                "name": "Inarajan (Inalåhan)",
                "iso2": null,
                "latitude": "13.27620490",
                "longitude": "144.72038630",
                "type": "village",
                "cities": []
            },
            {
                "id": 5263,
                "name": "Mangilao",
                "iso2": null,
                "latitude": "13.44985090",
                "longitude": "144.78302680",
                "type": "village",
                "cities": []
            },
            {
                "id": 5262,
                "name": "Merizo (Malesso)",
                "iso2": null,
                "latitude": "13.26860850",
                "longitude": "144.65797490",
                "type": "village",
                "cities": []
            },
            {
                "id": 5264,
                "name": "Mongmong-Toto-Maite",
                "iso2": null,
                "latitude": "13.46922010",
                "longitude": "144.75338080",
                "type": "village",
                "cities": []
            },
            {
                "id": 5266,
                "name": "Piti",
                "iso2": null,
                "latitude": "13.46474460",
                "longitude": "144.68769820",
                "type": "village",
                "cities": []
            },
            {
                "id": 5267,
                "name": "Santa Rita (Sånta Rita-Sumai)",
                "iso2": null,
                "latitude": "13.38678740",
                "longitude": "144.66642270",
                "type": "village",
                "cities": []
            },
            {
                "id": 5268,
                "name": "Sinajana",
                "iso2": null,
                "latitude": "13.46094860",
                "longitude": "144.74612080",
                "type": "village",
                "cities": []
            },
            {
                "id": 5269,
                "name": "Talofofo (Talo'fo'fo)",
                "iso2": null,
                "latitude": "13.35471440",
                "longitude": "144.73459730",
                "type": "village",
                "cities": []
            },
            {
                "id": 5270,
                "name": "Tamuning",
                "iso2": null,
                "latitude": "13.49447620",
                "longitude": "144.78045820",
                "type": "village",
                "cities": []
            },
            {
                "id": 5260,
                "name": "Umatac (Humåtak)",
                "iso2": null,
                "latitude": "13.29457770",
                "longitude": "144.65382830",
                "type": "village",
                "cities": []
            },
            {
                "id": 5271,
                "name": "Yigo",
                "iso2": null,
                "latitude": "13.57293770",
                "longitude": "144.82315220",
                "type": "village",
                "cities": []
            },
            {
                "id": 5272,
                "name": "Yona",
                "iso2": null,
                "latitude": "13.41020600",
                "longitude": "144.75557470",
                "type": "village",
                "cities": []
            }
        ]
    },
    {
        "id": 90,
        "name": "Guatemala",
        "iso3": "GTM",
        "iso2": "GT",
        "numeric_code": "320",
        "phonecode": "502",
        "capital": "Guatemala City",
        "currency": "GTQ",
        "currency_name": "Guatemalan quetzal",
        "currency_symbol": "Q",
        "tld": ".gt",
        "native": "Guatemala",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Central America",
        "subregion_id": 9,
        "nationality": "Guatemalan",
        "timezones": [
            {
                "zoneName": "America\/Guatemala",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Guatemala",
            "ko": "과테말라",
            "pt-BR": "Guatemala",
            "pt": "Guatemala",
            "nl": "Guatemala",
            "hr": "Gvatemala",
            "fa": "گواتمالا",
            "de": "Guatemala",
            "es": "Guatemala",
            "fr": "Guatemala",
            "ja": "グアテマラ",
            "it": "Guatemala",
            "zh-CN": "危地马拉",
            "tr": "Guatemala",
            "ru": "Гватемала",
            "uk": "Гватемала",
            "pl": "Gwatemala"
        },
        "latitude": "15.50000000",
        "longitude": "-90.25000000",
        "emoji": "🇬🇹",
        "emojiU": "U+1F1EC U+1F1F9",
        "states": [
            {
                "id": 3671,
                "name": "Alta Verapaz ",
                "iso2": "16",
                "latitude": "15.59428830",
                "longitude": "-90.14949880",
                "type": "department",
                "cities": [
                    {
                        "id": 53437,
                        "name": "Cahabón",
                        "latitude": "15.56667000",
                        "longitude": "-89.81667000"
                    },
                    {
                        "id": 53444,
                        "name": "Chahal Guatemala",
                        "latitude": "15.79122000",
                        "longitude": "-89.60518000"
                    },
                    {
                        "id": 53457,
                        "name": "Chisec",
                        "latitude": "15.81667000",
                        "longitude": "-90.28333000"
                    },
                    {
                        "id": 53462,
                        "name": "Cobán",
                        "latitude": "15.47083000",
                        "longitude": "-90.37083000"
                    },
                    {
                        "id": 53523,
                        "name": "La Tinta",
                        "latitude": "15.31667000",
                        "longitude": "-89.88333000"
                    },
                    {
                        "id": 53524,
                        "name": "Lanquín",
                        "latitude": "15.56667000",
                        "longitude": "-89.96667000"
                    },
                    {
                        "id": 53620,
                        "name": "Panzós",
                        "latitude": "15.40000000",
                        "longitude": "-89.66667000"
                    },
                    {
                        "id": 53671,
                        "name": "San Cristóbal Verapaz",
                        "latitude": "15.39632000",
                        "longitude": "-90.56513000"
                    },
                    {
                        "id": 53693,
                        "name": "San Juan Chamelco",
                        "latitude": "15.43333000",
                        "longitude": "-90.33333000"
                    },
                    {
                        "id": 53725,
                        "name": "San Pedro Carchá",
                        "latitude": "15.48333000",
                        "longitude": "-90.26667000"
                    },
                    {
                        "id": 53758,
                        "name": "Santa Cruz Verapaz",
                        "latitude": "15.36667000",
                        "longitude": "-90.43333000"
                    },
                    {
                        "id": 53777,
                        "name": "Senahú",
                        "latitude": "15.40000000",
                        "longitude": "-89.83333000"
                    },
                    {
                        "id": 53786,
                        "name": "Tactic",
                        "latitude": "15.32218000",
                        "longitude": "-90.35448000"
                    },
                    {
                        "id": 53788,
                        "name": "Tamahú",
                        "latitude": "15.30890000",
                        "longitude": "-90.23599000"
                    },
                    {
                        "id": 53796,
                        "name": "Tucurú",
                        "latitude": "15.30000000",
                        "longitude": "-90.06667000"
                    }
                ]
            },
            {
                "id": 3674,
                "name": "Baja Verapaz ",
                "iso2": "15",
                "latitude": "15.12558670",
                "longitude": "-90.37483540",
                "type": "department",
                "cities": [
                    {
                        "id": 53474,
                        "name": "Cubulco",
                        "latitude": "15.10452000",
                        "longitude": "-90.62871000"
                    },
                    {
                        "id": 53482,
                        "name": "El Chol",
                        "latitude": "14.96055000",
                        "longitude": "-90.48799000"
                    },
                    {
                        "id": 53497,
                        "name": "Granados",
                        "latitude": "14.91649000",
                        "longitude": "-90.52292000"
                    },
                    {
                        "id": 53636,
                        "name": "Purulhá",
                        "latitude": "15.26667000",
                        "longitude": "-90.20000000"
                    },
                    {
                        "id": 53640,
                        "name": "Rabinal",
                        "latitude": "15.08530000",
                        "longitude": "-90.49255000"
                    },
                    {
                        "id": 53645,
                        "name": "Salamá",
                        "latitude": "15.10278000",
                        "longitude": "-90.31806000"
                    },
                    {
                        "id": 53680,
                        "name": "San Jerónimo",
                        "latitude": "15.06032000",
                        "longitude": "-90.24050000"
                    },
                    {
                        "id": 53716,
                        "name": "San Miguel Chicaj",
                        "latitude": "15.09472000",
                        "longitude": "-90.39442000"
                    }
                ]
            },
            {
                "id": 3675,
                "name": "Chimaltenango ",
                "iso2": "04",
                "latitude": "14.56347870",
                "longitude": "-90.98206680",
                "type": "department",
                "cities": [
                    {
                        "id": 53425,
                        "name": "Acatenango",
                        "latitude": "14.55451000",
                        "longitude": "-90.94368000"
                    },
                    {
                        "id": 53452,
                        "name": "Chimaltenango",
                        "latitude": "14.66111000",
                        "longitude": "-90.81944000"
                    },
                    {
                        "id": 53465,
                        "name": "Comalapa",
                        "latitude": "14.74086000",
                        "longitude": "-90.88761000"
                    },
                    {
                        "id": 53489,
                        "name": "El Tejar",
                        "latitude": "14.64683000",
                        "longitude": "-90.79122000"
                    },
                    {
                        "id": 53621,
                        "name": "Parramos",
                        "latitude": "14.60891000",
                        "longitude": "-90.80303000"
                    },
                    {
                        "id": 53625,
                        "name": "Patzicía",
                        "latitude": "14.63194000",
                        "longitude": "-90.92659000"
                    },
                    {
                        "id": 53627,
                        "name": "Patzún",
                        "latitude": "14.68189000",
                        "longitude": "-91.01397000"
                    },
                    {
                        "id": 53630,
                        "name": "Pochuta",
                        "latitude": "14.54450000",
                        "longitude": "-91.08904000"
                    },
                    {
                        "id": 53650,
                        "name": "San Andrés Itzapa",
                        "latitude": "14.62222000",
                        "longitude": "-90.84314000"
                    },
                    {
                        "id": 53689,
                        "name": "San José Poaquil",
                        "latitude": "14.81808000",
                        "longitude": "-90.91248000"
                    },
                    {
                        "id": 53710,
                        "name": "San Martín Jilotepeque",
                        "latitude": "14.78008000",
                        "longitude": "-90.79259000"
                    },
                    {
                        "id": 53745,
                        "name": "Santa Apolonia",
                        "latitude": "14.79049000",
                        "longitude": "-90.97267000"
                    },
                    {
                        "id": 53754,
                        "name": "Santa Cruz Balanyá",
                        "latitude": "14.68522000",
                        "longitude": "-90.91906000"
                    },
                    {
                        "id": 53790,
                        "name": "Tecpán Guatemala",
                        "latitude": "14.76181000",
                        "longitude": "-90.99247000"
                    },
                    {
                        "id": 53800,
                        "name": "Yepocapa",
                        "latitude": "14.50195000",
                        "longitude": "-90.95396000"
                    },
                    {
                        "id": 53804,
                        "name": "Zaragoza",
                        "latitude": "14.64968000",
                        "longitude": "-90.89034000"
                    }
                ]
            },
            {
                "id": 3666,
                "name": "Chiquimula ",
                "iso2": "20",
                "latitude": "14.75149990",
                "longitude": "-89.47421770",
                "type": "department",
                "cities": [
                    {
                        "id": 53439,
                        "name": "Camotán",
                        "latitude": "14.82017000",
                        "longitude": "-89.37224000"
                    },
                    {
                        "id": 53455,
                        "name": "Chiquimula",
                        "latitude": "14.80000000",
                        "longitude": "-89.54583000"
                    },
                    {
                        "id": 53471,
                        "name": "Concepción Las Minas",
                        "latitude": "14.52173000",
                        "longitude": "-89.45717000"
                    },
                    {
                        "id": 53492,
                        "name": "Esquipulas",
                        "latitude": "14.56571000",
                        "longitude": "-89.35166000"
                    },
                    {
                        "id": 53505,
                        "name": "Ipala",
                        "latitude": "14.61667000",
                        "longitude": "-89.61667000"
                    },
                    {
                        "id": 53514,
                        "name": "Jocotán",
                        "latitude": "14.82072000",
                        "longitude": "-89.38991000"
                    },
                    {
                        "id": 53611,
                        "name": "Olopa",
                        "latitude": "14.69229000",
                        "longitude": "-89.35003000"
                    },
                    {
                        "id": 53639,
                        "name": "Quezaltepeque",
                        "latitude": "14.63553000",
                        "longitude": "-89.44241000"
                    },
                    {
                        "id": 53679,
                        "name": "San Jacinto",
                        "latitude": "14.66667000",
                        "longitude": "-89.50000000"
                    },
                    {
                        "id": 53685,
                        "name": "San José La Arada",
                        "latitude": "14.71667000",
                        "longitude": "-89.58333000"
                    },
                    {
                        "id": 53695,
                        "name": "San Juan Ermita",
                        "latitude": "14.76471000",
                        "longitude": "-89.43014000"
                    }
                ]
            },
            {
                "id": 3662,
                "name": "El Progreso ",
                "iso2": "02",
                "latitude": "14.93887320",
                "longitude": "-90.07467670",
                "type": "department",
                "cities": [
                    {
                        "id": 53484,
                        "name": "El Jícaro",
                        "latitude": "14.91667000",
                        "longitude": "-89.90000000"
                    },
                    {
                        "id": 53499,
                        "name": "Guastatoya",
                        "latitude": "14.85417000",
                        "longitude": "-90.06944000"
                    },
                    {
                        "id": 53538,
                        "name": "Morazán",
                        "latitude": "14.93278000",
                        "longitude": "-90.14306000"
                    },
                    {
                        "id": 53648,
                        "name": "San Agustín Acasaguastlán",
                        "latitude": "14.95000000",
                        "longitude": "-89.96667000"
                    },
                    {
                        "id": 53658,
                        "name": "San Antonio La Paz",
                        "latitude": "14.75888000",
                        "longitude": "-90.28485000"
                    },
                    {
                        "id": 53668,
                        "name": "San Cristóbal Acasaguastlán",
                        "latitude": "14.91667000",
                        "longitude": "-89.88333000"
                    },
                    {
                        "id": 53741,
                        "name": "Sanarate",
                        "latitude": "14.78828000",
                        "longitude": "-90.19876000"
                    },
                    {
                        "id": 53742,
                        "name": "Sansare",
                        "latitude": "14.74572000",
                        "longitude": "-90.11615000"
                    }
                ]
            },
            {
                "id": 3677,
                "name": "Escuintla ",
                "iso2": "05",
                "latitude": "14.19109120",
                "longitude": "-90.98206680",
                "type": "department",
                "cities": [
                    {
                        "id": 53491,
                        "name": "Escuintla",
                        "latitude": "14.30500000",
                        "longitude": "-90.78500000"
                    },
                    {
                        "id": 53498,
                        "name": "Guanagazapa",
                        "latitude": "14.22528000",
                        "longitude": "-90.64333000"
                    },
                    {
                        "id": 53508,
                        "name": "Iztapa",
                        "latitude": "13.93333000",
                        "longitude": "-90.70750000"
                    },
                    {
                        "id": 53517,
                        "name": "La Democracia",
                        "latitude": "14.23083000",
                        "longitude": "-90.94722000"
                    },
                    {
                        "id": 53519,
                        "name": "La Gomera",
                        "latitude": "14.08213000",
                        "longitude": "-91.05383000"
                    },
                    {
                        "id": 53530,
                        "name": "Masagua",
                        "latitude": "14.20306000",
                        "longitude": "-90.84806000"
                    },
                    {
                        "id": 53605,
                        "name": "Nueva Concepción",
                        "latitude": "14.20000000",
                        "longitude": "-91.30000000"
                    },
                    {
                        "id": 53618,
                        "name": "Palín",
                        "latitude": "14.40358000",
                        "longitude": "-90.69659000"
                    },
                    {
                        "id": 53635,
                        "name": "Puerto San José",
                        "latitude": "13.92740000",
                        "longitude": "-90.82166000"
                    },
                    {
                        "id": 53740,
                        "name": "San Vicente Pacaya",
                        "latitude": "14.41466000",
                        "longitude": "-90.63613000"
                    },
                    {
                        "id": 53762,
                        "name": "Santa Lucía Cotzumalguapa",
                        "latitude": "14.33505000",
                        "longitude": "-91.02339000"
                    },
                    {
                        "id": 53781,
                        "name": "Siquinalá",
                        "latitude": "14.30611000",
                        "longitude": "-90.96500000"
                    },
                    {
                        "id": 53793,
                        "name": "Tiquisate",
                        "latitude": "14.28356000",
                        "longitude": "-91.36063000"
                    }
                ]
            },
            {
                "id": 3672,
                "name": "Guatemala ",
                "iso2": "01",
                "latitude": "14.56494010",
                "longitude": "-90.52578230",
                "type": "department",
                "cities": [
                    {
                        "id": 53430,
                        "name": "Amatitlán",
                        "latitude": "14.47740000",
                        "longitude": "-90.63489000"
                    },
                    {
                        "id": 53453,
                        "name": "Chinautla",
                        "latitude": "14.70289000",
                        "longitude": "-90.49983000"
                    },
                    {
                        "id": 53458,
                        "name": "Chuarrancho",
                        "latitude": "14.81794000",
                        "longitude": "-90.51568000"
                    },
                    {
                        "id": 53496,
                        "name": "Fraijanes",
                        "latitude": "14.46528000",
                        "longitude": "-90.44083000"
                    },
                    {
                        "id": 53500,
                        "name": "Guatemala City",
                        "latitude": "14.64072000",
                        "longitude": "-90.51327000"
                    },
                    {
                        "id": 53534,
                        "name": "Mixco",
                        "latitude": "14.63077000",
                        "longitude": "-90.60711000"
                    },
                    {
                        "id": 53616,
                        "name": "Palencia",
                        "latitude": "14.66715000",
                        "longitude": "-90.35721000"
                    },
                    {
                        "id": 53628,
                        "name": "Petapa",
                        "latitude": "14.50189000",
                        "longitude": "-90.56196000"
                    },
                    {
                        "id": 53690,
                        "name": "San José del Golfo",
                        "latitude": "14.76414000",
                        "longitude": "-90.37228000"
                    },
                    {
                        "id": 53688,
                        "name": "San José Pinula",
                        "latitude": "14.54600000",
                        "longitude": "-90.41288000"
                    },
                    {
                        "id": 53698,
                        "name": "San Juan Sacatepéquez",
                        "latitude": "14.71889000",
                        "longitude": "-90.64417000"
                    },
                    {
                        "id": 53724,
                        "name": "San Pedro Ayampuc",
                        "latitude": "14.77943000",
                        "longitude": "-90.45318000"
                    },
                    {
                        "id": 53730,
                        "name": "San Pedro Sacatepéquez",
                        "latitude": "14.68612000",
                        "longitude": "-90.64253000"
                    },
                    {
                        "id": 53736,
                        "name": "San Raimundo",
                        "latitude": "14.76462000",
                        "longitude": "-90.59493000"
                    },
                    {
                        "id": 53752,
                        "name": "Santa Catarina Pinula",
                        "latitude": "14.57047000",
                        "longitude": "-90.49925000"
                    },
                    {
                        "id": 53798,
                        "name": "Villa Canales",
                        "latitude": "14.48285000",
                        "longitude": "-90.53425000"
                    },
                    {
                        "id": 53799,
                        "name": "Villa Nueva",
                        "latitude": "14.52512000",
                        "longitude": "-90.58544000"
                    }
                ]
            },
            {
                "id": 3670,
                "name": "Huehuetenango ",
                "iso2": "13",
                "latitude": "15.58799140",
                "longitude": "-91.67606910",
                "type": "department",
                "cities": [
                    {
                        "id": 53427,
                        "name": "Aguacatán",
                        "latitude": "15.34222000",
                        "longitude": "-91.31141000"
                    },
                    {
                        "id": 53435,
                        "name": "Barillas",
                        "latitude": "15.80361000",
                        "longitude": "-91.31583000"
                    },
                    {
                        "id": 53447,
                        "name": "Chiantla",
                        "latitude": "15.35484000",
                        "longitude": "-91.45807000"
                    },
                    {
                        "id": 53464,
                        "name": "Colotenango",
                        "latitude": "15.40602000",
                        "longitude": "-91.71267000"
                    },
                    {
                        "id": 53470,
                        "name": "Concepción Huista",
                        "latitude": "15.62378000",
                        "longitude": "-91.66521000"
                    },
                    {
                        "id": 53476,
                        "name": "Cuilco",
                        "latitude": "15.40719000",
                        "longitude": "-91.94667000"
                    },
                    {
                        "id": 53503,
                        "name": "Huehuetenango",
                        "latitude": "15.31918000",
                        "longitude": "-91.47241000"
                    },
                    {
                        "id": 53507,
                        "name": "Ixtahuacán",
                        "latitude": "15.41688000",
                        "longitude": "-91.76927000"
                    },
                    {
                        "id": 53509,
                        "name": "Jacaltenango",
                        "latitude": "15.66662000",
                        "longitude": "-91.71177000"
                    },
                    {
                        "id": 53521,
                        "name": "La Libertad",
                        "latitude": "15.51421000",
                        "longitude": "-91.86944000"
                    },
                    {
                        "id": 53528,
                        "name": "Malacatancito",
                        "latitude": "15.24457000",
                        "longitude": "-91.49901000"
                    },
                    {
                        "id": 53604,
                        "name": "Nentón",
                        "latitude": "15.80070000",
                        "longitude": "-91.75464000"
                    },
                    {
                        "id": 53656,
                        "name": "San Antonio Huista",
                        "latitude": "15.65010000",
                        "longitude": "-91.77163000"
                    },
                    {
                        "id": 53678,
                        "name": "San Gaspar Ixchil",
                        "latitude": "15.38796000",
                        "longitude": "-91.72564000"
                    },
                    {
                        "id": 53691,
                        "name": "San Juan Atitán",
                        "latitude": "15.42886000",
                        "longitude": "-91.62398000"
                    },
                    {
                        "id": 53696,
                        "name": "San Juan Ixcoy",
                        "latitude": "15.60022000",
                        "longitude": "-91.44639000"
                    },
                    {
                        "id": 53714,
                        "name": "San Mateo Ixtatán",
                        "latitude": "15.83194000",
                        "longitude": "-91.47806000"
                    },
                    {
                        "id": 53715,
                        "name": "San Miguel Acatán",
                        "latitude": "15.70401000",
                        "longitude": "-91.59771000"
                    },
                    {
                        "id": 53727,
                        "name": "San Pedro Necta",
                        "latitude": "15.49142000",
                        "longitude": "-91.76551000"
                    },
                    {
                        "id": 53732,
                        "name": "San Rafael La Independencia",
                        "latitude": "15.70150000",
                        "longitude": "-91.53553000"
                    },
                    {
                        "id": 53734,
                        "name": "San Rafael Petzal",
                        "latitude": "15.40487000",
                        "longitude": "-91.66451000"
                    },
                    {
                        "id": 53738,
                        "name": "San Sebastián Coatán",
                        "latitude": "15.73584000",
                        "longitude": "-91.56285000"
                    },
                    {
                        "id": 53739,
                        "name": "San Sebastián Huehuetenango",
                        "latitude": "15.38768000",
                        "longitude": "-91.61530000"
                    },
                    {
                        "id": 53744,
                        "name": "Santa Ana Huista",
                        "latitude": "15.68085000",
                        "longitude": "-91.82005000"
                    },
                    {
                        "id": 53747,
                        "name": "Santa Bárbara",
                        "latitude": "15.31617000",
                        "longitude": "-91.63279000"
                    },
                    {
                        "id": 53760,
                        "name": "Santa Eulalia",
                        "latitude": "15.73060000",
                        "longitude": "-91.45846000"
                    },
                    {
                        "id": 53771,
                        "name": "Santiago Chimaltenango",
                        "latitude": "15.47658000",
                        "longitude": "-91.69656000"
                    },
                    {
                        "id": 53783,
                        "name": "Soloma",
                        "latitude": "15.65841000",
                        "longitude": "-91.42994000"
                    },
                    {
                        "id": 53791,
                        "name": "Tectitán",
                        "latitude": "15.30630000",
                        "longitude": "-92.06051000"
                    },
                    {
                        "id": 53794,
                        "name": "Todos Santos Cuchumatán",
                        "latitude": "15.50846000",
                        "longitude": "-91.60382000"
                    }
                ]
            },
            {
                "id": 3659,
                "name": "Izabal ",
                "iso2": "18",
                "latitude": "15.49765170",
                "longitude": "-88.86469800",
                "type": "department",
                "cities": [
                    {
                        "id": 53483,
                        "name": "El Estor",
                        "latitude": "15.53333000",
                        "longitude": "-89.35000000"
                    },
                    {
                        "id": 53526,
                        "name": "Lívingston",
                        "latitude": "15.82826000",
                        "longitude": "-88.75039000"
                    },
                    {
                        "id": 53525,
                        "name": "Los Amates",
                        "latitude": "15.25645000",
                        "longitude": "-89.09723000"
                    },
                    {
                        "id": 53537,
                        "name": "Morales",
                        "latitude": "15.48333000",
                        "longitude": "-88.81667000"
                    },
                    {
                        "id": 53571,
                        "name": "Municipio de Morales",
                        "latitude": "15.44494000",
                        "longitude": "-88.76646000"
                    },
                    {
                        "id": 53577,
                        "name": "Municipio de Puerto Barrios",
                        "latitude": "15.71754000",
                        "longitude": "-88.58517000"
                    },
                    {
                        "id": 53634,
                        "name": "Puerto Barrios",
                        "latitude": "15.72778000",
                        "longitude": "-88.59444000"
                    }
                ]
            },
            {
                "id": 3658,
                "name": "Jalapa ",
                "iso2": "21",
                "latitude": "14.61214460",
                "longitude": "-89.96267990",
                "type": "department",
                "cities": [
                    {
                        "id": 53510,
                        "name": "Jalapa",
                        "latitude": "14.63472000",
                        "longitude": "-89.98889000"
                    },
                    {
                        "id": 53531,
                        "name": "Mataquescuintla",
                        "latitude": "14.52917000",
                        "longitude": "-90.18417000"
                    },
                    {
                        "id": 53536,
                        "name": "Monjas",
                        "latitude": "14.50000000",
                        "longitude": "-89.86667000"
                    },
                    {
                        "id": 53564,
                        "name": "Municipio de Jalapa",
                        "latitude": "14.63275000",
                        "longitude": "-90.03301000"
                    },
                    {
                        "id": 53569,
                        "name": "Municipio de Mataquescuintla",
                        "latitude": "14.54777000",
                        "longitude": "-90.20008000"
                    },
                    {
                        "id": 53706,
                        "name": "San Luis Jilotepeque",
                        "latitude": "14.65000000",
                        "longitude": "-89.73333000"
                    },
                    {
                        "id": 53707,
                        "name": "San Manuel Chaparrón",
                        "latitude": "14.51667000",
                        "longitude": "-89.76667000"
                    },
                    {
                        "id": 53728,
                        "name": "San Pedro Pinula",
                        "latitude": "14.66667000",
                        "longitude": "-89.85000000"
                    }
                ]
            },
            {
                "id": 3673,
                "name": "Jutiapa ",
                "iso2": "22",
                "latitude": "14.19308020",
                "longitude": "-89.92532330",
                "type": "department",
                "cities": [
                    {
                        "id": 53426,
                        "name": "Agua Blanca",
                        "latitude": "14.50000000",
                        "longitude": "-89.65000000"
                    },
                    {
                        "id": 53432,
                        "name": "Asunción Mita",
                        "latitude": "14.33083000",
                        "longitude": "-89.71083000"
                    },
                    {
                        "id": 53433,
                        "name": "Atescatempa",
                        "latitude": "14.17444000",
                        "longitude": "-89.74250000"
                    },
                    {
                        "id": 53466,
                        "name": "Comapa",
                        "latitude": "14.11667000",
                        "longitude": "-89.91667000"
                    },
                    {
                        "id": 53473,
                        "name": "Conguaco",
                        "latitude": "14.04417000",
                        "longitude": "-90.03111000"
                    },
                    {
                        "id": 53480,
                        "name": "El Adelanto",
                        "latitude": "14.16667000",
                        "longitude": "-89.83333000"
                    },
                    {
                        "id": 53486,
                        "name": "El Progreso",
                        "latitude": "14.35000000",
                        "longitude": "-89.85000000"
                    },
                    {
                        "id": 53511,
                        "name": "Jalpatagua",
                        "latitude": "14.14167000",
                        "longitude": "-90.00861000"
                    },
                    {
                        "id": 53512,
                        "name": "Jerez",
                        "latitude": "14.10000000",
                        "longitude": "-89.75000000"
                    },
                    {
                        "id": 53516,
                        "name": "Jutiapa",
                        "latitude": "14.29167000",
                        "longitude": "-89.89583000"
                    },
                    {
                        "id": 53539,
                        "name": "Moyuta",
                        "latitude": "14.03861000",
                        "longitude": "-90.08083000"
                    },
                    {
                        "id": 53543,
                        "name": "Municipio de Asunción Mita",
                        "latitude": "14.30330000",
                        "longitude": "-89.67623000"
                    },
                    {
                        "id": 53622,
                        "name": "Pasaco",
                        "latitude": "13.97722000",
                        "longitude": "-90.20639000"
                    },
                    {
                        "id": 53637,
                        "name": "Quesada",
                        "latitude": "14.27028000",
                        "longitude": "-90.04028000"
                    },
                    {
                        "id": 53682,
                        "name": "San José Acatempa",
                        "latitude": "14.26528000",
                        "longitude": "-90.12694000"
                    },
                    {
                        "id": 53750,
                        "name": "Santa Catarina Mita",
                        "latitude": "14.45000000",
                        "longitude": "-89.75000000"
                    },
                    {
                        "id": 53801,
                        "name": "Yupiltepeque",
                        "latitude": "14.20000000",
                        "longitude": "-89.78333000"
                    },
                    {
                        "id": 53803,
                        "name": "Zapotitlán",
                        "latitude": "14.13333000",
                        "longitude": "-89.83333000"
                    }
                ]
            },
            {
                "id": 3669,
                "name": "Petén ",
                "iso2": "17",
                "latitude": "16.91203300",
                "longitude": "-90.29957850",
                "type": "department",
                "cities": [
                    {
                        "id": 53479,
                        "name": "Dolores",
                        "latitude": "16.51178000",
                        "longitude": "-89.41704000"
                    },
                    {
                        "id": 53494,
                        "name": "Flores",
                        "latitude": "16.92258000",
                        "longitude": "-89.89941000"
                    },
                    {
                        "id": 53520,
                        "name": "La Libertad",
                        "latitude": "16.78850000",
                        "longitude": "-90.11698000"
                    },
                    {
                        "id": 53533,
                        "name": "Melchor de Mencos",
                        "latitude": "17.06606000",
                        "longitude": "-89.15229000"
                    },
                    {
                        "id": 53560,
                        "name": "Municipio de Flores",
                        "latitude": "16.92381000",
                        "longitude": "-89.89709000"
                    },
                    {
                        "id": 53576,
                        "name": "Municipio de Poptún",
                        "latitude": "16.35687000",
                        "longitude": "-89.58912000"
                    },
                    {
                        "id": 53578,
                        "name": "Municipio de San Andrés",
                        "latitude": "17.49541000",
                        "longitude": "-90.39883000"
                    },
                    {
                        "id": 53582,
                        "name": "Municipio de San Benito",
                        "latitude": "16.91289000",
                        "longitude": "-89.90979000"
                    },
                    {
                        "id": 53584,
                        "name": "Municipio de San Francisco",
                        "latitude": "16.72425000",
                        "longitude": "-89.90877000"
                    },
                    {
                        "id": 53589,
                        "name": "Municipio de Santa Ana",
                        "latitude": "16.77305000",
                        "longitude": "-89.66878000"
                    },
                    {
                        "id": 53596,
                        "name": "Municipio de Sayaxché",
                        "latitude": "16.33160000",
                        "longitude": "-90.16339000"
                    },
                    {
                        "id": 53631,
                        "name": "Poptún",
                        "latitude": "16.33111000",
                        "longitude": "-89.41694000"
                    },
                    {
                        "id": 53649,
                        "name": "San Andrés",
                        "latitude": "16.96667000",
                        "longitude": "-89.91667000"
                    },
                    {
                        "id": 53665,
                        "name": "San Benito",
                        "latitude": "16.91675000",
                        "longitude": "-89.91898000"
                    },
                    {
                        "id": 53673,
                        "name": "San Francisco",
                        "latitude": "16.80000000",
                        "longitude": "-89.93333000"
                    },
                    {
                        "id": 53681,
                        "name": "San José",
                        "latitude": "16.98333000",
                        "longitude": "-89.90000000"
                    },
                    {
                        "id": 53704,
                        "name": "San Luis",
                        "latitude": "16.19889000",
                        "longitude": "-89.44028000"
                    },
                    {
                        "id": 53743,
                        "name": "Santa Ana",
                        "latitude": "16.80000000",
                        "longitude": "-89.83333000"
                    },
                    {
                        "id": 53776,
                        "name": "Sayaxché",
                        "latitude": "16.52446000",
                        "longitude": "-90.18801000"
                    }
                ]
            },
            {
                "id": 3668,
                "name": "Quetzaltenango ",
                "iso2": "09",
                "latitude": "14.79243300",
                "longitude": "-91.71495800",
                "type": "department",
                "cities": [
                    {
                        "id": 53428,
                        "name": "Almolonga",
                        "latitude": "14.81591000",
                        "longitude": "-91.49464000"
                    },
                    {
                        "id": 53436,
                        "name": "Cabricán",
                        "latitude": "15.07485000",
                        "longitude": "-91.64800000"
                    },
                    {
                        "id": 53438,
                        "name": "Cajolá",
                        "latitude": "14.92205000",
                        "longitude": "-91.61478000"
                    },
                    {
                        "id": 53441,
                        "name": "Cantel",
                        "latitude": "14.81154000",
                        "longitude": "-91.45536000"
                    },
                    {
                        "id": 53461,
                        "name": "Coatepeque",
                        "latitude": "14.70413000",
                        "longitude": "-91.86426000"
                    },
                    {
                        "id": 53463,
                        "name": "Colomba",
                        "latitude": "14.70730000",
                        "longitude": "-91.73167000"
                    },
                    {
                        "id": 53469,
                        "name": "Concepción Chiquirichapa",
                        "latitude": "14.85510000",
                        "longitude": "-91.62360000"
                    },
                    {
                        "id": 53485,
                        "name": "El Palmar",
                        "latitude": "14.65083000",
                        "longitude": "-91.57800000"
                    },
                    {
                        "id": 53495,
                        "name": "Flores Costa Cuca",
                        "latitude": "14.63238000",
                        "longitude": "-91.86341000"
                    },
                    {
                        "id": 53502,
                        "name": "Génova",
                        "latitude": "14.61667000",
                        "longitude": "-91.83333000"
                    },
                    {
                        "id": 53504,
                        "name": "Huitán",
                        "latitude": "15.04920000",
                        "longitude": "-91.63944000"
                    },
                    {
                        "id": 53518,
                        "name": "La Esperanza",
                        "latitude": "14.87169000",
                        "longitude": "-91.56140000"
                    },
                    {
                        "id": 53540,
                        "name": "Municipio de Almolonga",
                        "latitude": "14.81118000",
                        "longitude": "-91.48354000"
                    },
                    {
                        "id": 53544,
                        "name": "Municipio de Cabricán",
                        "latitude": "15.10305000",
                        "longitude": "-91.64918000"
                    },
                    {
                        "id": 53546,
                        "name": "Municipio de Cantel",
                        "latitude": "14.81659000",
                        "longitude": "-91.43781000"
                    },
                    {
                        "id": 53555,
                        "name": "Municipio de Coatepeque",
                        "latitude": "14.64309000",
                        "longitude": "-91.97926000"
                    },
                    {
                        "id": 53556,
                        "name": "Municipio de Colomba",
                        "latitude": "14.71002000",
                        "longitude": "-91.74691000"
                    },
                    {
                        "id": 53557,
                        "name": "Municipio de Concepción Chiquirichapa",
                        "latitude": "14.84624000",
                        "longitude": "-91.61854000"
                    },
                    {
                        "id": 53561,
                        "name": "Municipio de Flores Costa Cuca",
                        "latitude": "14.63238000",
                        "longitude": "-91.86341000"
                    },
                    {
                        "id": 53586,
                        "name": "Municipio de San Juan Ostuncalco",
                        "latitude": "14.87477000",
                        "longitude": "-91.68842000"
                    },
                    {
                        "id": 53610,
                        "name": "Olintepeque",
                        "latitude": "14.88605000",
                        "longitude": "-91.51472000"
                    },
                    {
                        "id": 53613,
                        "name": "Ostuncalco",
                        "latitude": "14.86899000",
                        "longitude": "-91.62137000"
                    },
                    {
                        "id": 53617,
                        "name": "Palestina de los Altos",
                        "latitude": "14.93338000",
                        "longitude": "-91.69403000"
                    },
                    {
                        "id": 53638,
                        "name": "Quetzaltenango",
                        "latitude": "14.83472000",
                        "longitude": "-91.51806000"
                    },
                    {
                        "id": 53646,
                        "name": "Salcajá",
                        "latitude": "14.87964000",
                        "longitude": "-91.45699000"
                    },
                    {
                        "id": 53647,
                        "name": "Samayac",
                        "latitude": "14.58084000",
                        "longitude": "-91.46135000"
                    },
                    {
                        "id": 53667,
                        "name": "San Carlos Sija",
                        "latitude": "14.98436000",
                        "longitude": "-91.54912000"
                    },
                    {
                        "id": 53676,
                        "name": "San Francisco la Unión",
                        "latitude": "14.92350000",
                        "longitude": "-91.54157000"
                    },
                    {
                        "id": 53711,
                        "name": "San Martín Sacatepéquez",
                        "latitude": "14.82443000",
                        "longitude": "-91.64192000"
                    },
                    {
                        "id": 53713,
                        "name": "San Mateo",
                        "latitude": "14.85800000",
                        "longitude": "-91.59004000"
                    },
                    {
                        "id": 53720,
                        "name": "San Miguel Sigüilá",
                        "latitude": "14.89547000",
                        "longitude": "-91.61457000"
                    },
                    {
                        "id": 53778,
                        "name": "Sibilia",
                        "latitude": "14.99391000",
                        "longitude": "-91.62371000"
                    },
                    {
                        "id": 53805,
                        "name": "Zunil",
                        "latitude": "14.78463000",
                        "longitude": "-91.48345000"
                    }
                ]
            },
            {
                "id": 3657,
                "name": "Quiché ",
                "iso2": "14",
                "latitude": "15.49838080",
                "longitude": "-90.98206680",
                "type": "department",
                "cities": [
                    {
                        "id": 53440,
                        "name": "Canillá",
                        "latitude": "15.16549000",
                        "longitude": "-90.85256000"
                    },
                    {
                        "id": 53445,
                        "name": "Chajul",
                        "latitude": "15.48523000",
                        "longitude": "-91.03520000"
                    },
                    {
                        "id": 53449,
                        "name": "Chicamán",
                        "latitude": "15.34786000",
                        "longitude": "-90.79968000"
                    },
                    {
                        "id": 53451,
                        "name": "Chiché",
                        "latitude": "15.00885000",
                        "longitude": "-91.06379000"
                    },
                    {
                        "id": 53450,
                        "name": "Chichicastenango",
                        "latitude": "14.94333000",
                        "longitude": "-91.11116000"
                    },
                    {
                        "id": 53454,
                        "name": "Chinique",
                        "latitude": "15.04147000",
                        "longitude": "-91.02594000"
                    },
                    {
                        "id": 53477,
                        "name": "Cunén",
                        "latitude": "15.33626000",
                        "longitude": "-91.02776000"
                    },
                    {
                        "id": 53515,
                        "name": "Joyabaj",
                        "latitude": "14.99311000",
                        "longitude": "-90.80161000"
                    },
                    {
                        "id": 53545,
                        "name": "Municipio de Canillá",
                        "latitude": "15.19546000",
                        "longitude": "-90.85970000"
                    },
                    {
                        "id": 53548,
                        "name": "Municipio de Chajul",
                        "latitude": "15.48710000",
                        "longitude": "-91.03786000"
                    },
                    {
                        "id": 53549,
                        "name": "Municipio de Chicaman",
                        "latitude": "15.34833000",
                        "longitude": "-90.79944000"
                    },
                    {
                        "id": 53551,
                        "name": "Municipio de Chiché",
                        "latitude": "15.01196000",
                        "longitude": "-91.03836000"
                    },
                    {
                        "id": 53550,
                        "name": "Municipio de Chichicastenango",
                        "latitude": "14.89203000",
                        "longitude": "-91.08808000"
                    },
                    {
                        "id": 53552,
                        "name": "Municipio de Chinique",
                        "latitude": "15.06947000",
                        "longitude": "-91.01803000"
                    },
                    {
                        "id": 53559,
                        "name": "Municipio de Cunén",
                        "latitude": "15.36312000",
                        "longitude": "-91.01889000"
                    },
                    {
                        "id": 53563,
                        "name": "Municipio de Ixcan",
                        "latitude": "15.98333000",
                        "longitude": "-90.76667000"
                    },
                    {
                        "id": 53566,
                        "name": "Municipio de Joyabaj",
                        "latitude": "14.98073000",
                        "longitude": "-90.82079000"
                    },
                    {
                        "id": 53573,
                        "name": "Municipio de Pachalum",
                        "latitude": "14.91798000",
                        "longitude": "-90.65443000"
                    },
                    {
                        "id": 53575,
                        "name": "Municipio de Patzité",
                        "latitude": "14.97097000",
                        "longitude": "-91.19722000"
                    },
                    {
                        "id": 53579,
                        "name": "Municipio de San Andrés Sajcabajá",
                        "latitude": "15.22527000",
                        "longitude": "-90.93018000"
                    },
                    {
                        "id": 53580,
                        "name": "Municipio de San Antonio Ilotenango",
                        "latitude": "15.04898000",
                        "longitude": "-91.20872000"
                    },
                    {
                        "id": 53585,
                        "name": "Municipio de San Juan Cotzal",
                        "latitude": "15.42699000",
                        "longitude": "-91.02097000"
                    },
                    {
                        "id": 53588,
                        "name": "Municipio de San Pedro Jocopilas",
                        "latitude": "15.15472000",
                        "longitude": "-91.15610000"
                    },
                    {
                        "id": 53600,
                        "name": "Municipio de Uspantán",
                        "latitude": "15.44393000",
                        "longitude": "-90.84398000"
                    },
                    {
                        "id": 53601,
                        "name": "Municipio de Zacualpa",
                        "latitude": "15.09239000",
                        "longitude": "-90.88514000"
                    },
                    {
                        "id": 53603,
                        "name": "Nebaj",
                        "latitude": "15.40614000",
                        "longitude": "-91.14682000"
                    },
                    {
                        "id": 53614,
                        "name": "Pachalum",
                        "latitude": "14.92472000",
                        "longitude": "-90.66278000"
                    },
                    {
                        "id": 53626,
                        "name": "Patzité",
                        "latitude": "14.96426000",
                        "longitude": "-91.20788000"
                    },
                    {
                        "id": 53629,
                        "name": "Playa Grande",
                        "latitude": "15.93333000",
                        "longitude": "-90.73333000"
                    },
                    {
                        "id": 53644,
                        "name": "Sacapulas",
                        "latitude": "15.28801000",
                        "longitude": "-91.08914000"
                    },
                    {
                        "id": 53651,
                        "name": "San Andrés Sajcabajá",
                        "latitude": "15.17603000",
                        "longitude": "-90.94220000"
                    },
                    {
                        "id": 53657,
                        "name": "San Antonio Ilotenango",
                        "latitude": "15.05472000",
                        "longitude": "-91.22986000"
                    },
                    {
                        "id": 53663,
                        "name": "San Bartolomé Jocotenango",
                        "latitude": "15.19153000",
                        "longitude": "-91.07806000"
                    },
                    {
                        "id": 53694,
                        "name": "San Juan Cotzal",
                        "latitude": "15.43368000",
                        "longitude": "-91.03481000"
                    },
                    {
                        "id": 53705,
                        "name": "San Luis Ixcán",
                        "latitude": "15.78722000",
                        "longitude": "-91.09500000"
                    },
                    {
                        "id": 53731,
                        "name": "San Pédro Jocopilas",
                        "latitude": "15.09525000",
                        "longitude": "-91.15135000"
                    },
                    {
                        "id": 53759,
                        "name": "Santa Cruz del Quiché",
                        "latitude": "15.03085000",
                        "longitude": "-91.14871000"
                    },
                    {
                        "id": 53797,
                        "name": "Uspantán",
                        "latitude": "15.34672000",
                        "longitude": "-90.87050000"
                    },
                    {
                        "id": 53802,
                        "name": "Zacualpa",
                        "latitude": "15.02681000",
                        "longitude": "-90.87815000"
                    }
                ]
            },
            {
                "id": 3664,
                "name": "Retalhuleu ",
                "iso2": "11",
                "latitude": "14.52454850",
                "longitude": "-91.68578800",
                "type": "department",
                "cities": [
                    {
                        "id": 53446,
                        "name": "Champerico",
                        "latitude": "14.29337000",
                        "longitude": "-91.91214000"
                    },
                    {
                        "id": 53481,
                        "name": "El Asintal",
                        "latitude": "14.59626000",
                        "longitude": "-91.72744000"
                    },
                    {
                        "id": 53583,
                        "name": "Municipio de San Felipe",
                        "latitude": "14.63009000",
                        "longitude": "-91.60261000"
                    },
                    {
                        "id": 53608,
                        "name": "Nuevo San Carlos",
                        "latitude": "14.59300000",
                        "longitude": "-91.69390000"
                    },
                    {
                        "id": 53641,
                        "name": "Retalhuleu",
                        "latitude": "14.53611000",
                        "longitude": "-91.67778000"
                    },
                    {
                        "id": 53653,
                        "name": "San Andrés Villa Seca",
                        "latitude": "14.57801000",
                        "longitude": "-91.58539000"
                    },
                    {
                        "id": 53672,
                        "name": "San Felipe",
                        "latitude": "14.62304000",
                        "longitude": "-91.59500000"
                    },
                    {
                        "id": 53712,
                        "name": "San Martín Zapotitlán",
                        "latitude": "14.60794000",
                        "longitude": "-91.60613000"
                    },
                    {
                        "id": 53737,
                        "name": "San Sebastián",
                        "latitude": "14.56177000",
                        "longitude": "-91.64865000"
                    },
                    {
                        "id": 53756,
                        "name": "Santa Cruz Muluá",
                        "latitude": "14.58153000",
                        "longitude": "-91.62441000"
                    }
                ]
            },
            {
                "id": 3676,
                "name": "Sacatepéquez ",
                "iso2": "03",
                "latitude": "14.51783790",
                "longitude": "-90.71527490",
                "type": "department",
                "cities": [
                    {
                        "id": 53429,
                        "name": "Alotenango",
                        "latitude": "14.48028000",
                        "longitude": "-90.80750000"
                    },
                    {
                        "id": 53431,
                        "name": "Antigua Guatemala",
                        "latitude": "14.56111000",
                        "longitude": "-90.73444000"
                    },
                    {
                        "id": 53460,
                        "name": "Ciudad Vieja",
                        "latitude": "14.52396000",
                        "longitude": "-90.76308000"
                    },
                    {
                        "id": 53513,
                        "name": "Jocotenango",
                        "latitude": "14.57814000",
                        "longitude": "-90.73804000"
                    },
                    {
                        "id": 53527,
                        "name": "Magdalena Milpas Altas",
                        "latitude": "14.54801000",
                        "longitude": "-90.67477000"
                    },
                    {
                        "id": 53541,
                        "name": "Municipio de Alotenango",
                        "latitude": "14.46485000",
                        "longitude": "-90.82773000"
                    },
                    {
                        "id": 53542,
                        "name": "Municipio de Antigua Guatemala",
                        "latitude": "14.54313000",
                        "longitude": "-90.72683000"
                    },
                    {
                        "id": 53554,
                        "name": "Municipio de Ciudad Vieja",
                        "latitude": "14.50800000",
                        "longitude": "-90.77028000"
                    },
                    {
                        "id": 53565,
                        "name": "Municipio de Jocotenango",
                        "latitude": "14.58658000",
                        "longitude": "-90.73579000"
                    },
                    {
                        "id": 53567,
                        "name": "Municipio de Magdalena Milpas Altas",
                        "latitude": "14.54206000",
                        "longitude": "-90.67553000"
                    },
                    {
                        "id": 53593,
                        "name": "Municipio de Santa Lucía Milpas Altas",
                        "latitude": "14.56753000",
                        "longitude": "-90.67551000"
                    },
                    {
                        "id": 53595,
                        "name": "Municipio de Santa María de Jesús",
                        "latitude": "14.47849000",
                        "longitude": "-90.69989000"
                    },
                    {
                        "id": 53623,
                        "name": "Pastores",
                        "latitude": "14.59433000",
                        "longitude": "-90.75473000"
                    },
                    {
                        "id": 53655,
                        "name": "San Antonio Aguas Calientes",
                        "latitude": "14.54676000",
                        "longitude": "-90.78054000"
                    },
                    {
                        "id": 53664,
                        "name": "San Bartolomé Milpas Altas",
                        "latitude": "14.60690000",
                        "longitude": "-90.67807000"
                    },
                    {
                        "id": 53702,
                        "name": "San Lucas Sacatepéquez",
                        "latitude": "14.61075000",
                        "longitude": "-90.65681000"
                    },
                    {
                        "id": 53717,
                        "name": "San Miguel Dueñas",
                        "latitude": "14.52241000",
                        "longitude": "-90.79938000"
                    },
                    {
                        "id": 53748,
                        "name": "Santa Catarina Barahona",
                        "latitude": "14.55135000",
                        "longitude": "-90.78598000"
                    },
                    {
                        "id": 53763,
                        "name": "Santa Lucía Milpas Altas",
                        "latitude": "14.57655000",
                        "longitude": "-90.67632000"
                    },
                    {
                        "id": 53768,
                        "name": "Santa María de Jesús",
                        "latitude": "14.49452000",
                        "longitude": "-90.71036000"
                    },
                    {
                        "id": 53772,
                        "name": "Santiago Sacatepéquez",
                        "latitude": "14.63510000",
                        "longitude": "-90.67654000"
                    },
                    {
                        "id": 53774,
                        "name": "Santo Domingo Xenacoj",
                        "latitude": "14.68057000",
                        "longitude": "-90.70012000"
                    },
                    {
                        "id": 53784,
                        "name": "Sumpango",
                        "latitude": "14.64623000",
                        "longitude": "-90.73427000"
                    }
                ]
            },
            {
                "id": 3667,
                "name": "San Marcos ",
                "iso2": "12",
                "latitude": "14.93095690",
                "longitude": "-91.90992380",
                "type": "department",
                "cities": [
                    {
                        "id": 53443,
                        "name": "Catarina",
                        "latitude": "14.85354000",
                        "longitude": "-92.07682000"
                    },
                    {
                        "id": 53459,
                        "name": "Ciudad Tecún Umán",
                        "latitude": "14.67737000",
                        "longitude": "-92.14039000"
                    },
                    {
                        "id": 53467,
                        "name": "Comitancillo",
                        "latitude": "15.08937000",
                        "longitude": "-91.74971000"
                    },
                    {
                        "id": 53472,
                        "name": "Concepción Tutuapa",
                        "latitude": "15.23940000",
                        "longitude": "-91.84460000"
                    },
                    {
                        "id": 53487,
                        "name": "El Quetzal",
                        "latitude": "14.76865000",
                        "longitude": "-91.81757000"
                    },
                    {
                        "id": 53488,
                        "name": "El Rodeo",
                        "latitude": "14.91447000",
                        "longitude": "-91.97631000"
                    },
                    {
                        "id": 53490,
                        "name": "El Tumbador",
                        "latitude": "14.86375000",
                        "longitude": "-91.93416000"
                    },
                    {
                        "id": 53493,
                        "name": "Esquipulas Palo Gordo",
                        "latitude": "14.94135000",
                        "longitude": "-91.82564000"
                    },
                    {
                        "id": 53506,
                        "name": "Ixchiguán",
                        "latitude": "15.16375000",
                        "longitude": "-91.93256000"
                    },
                    {
                        "id": 53522,
                        "name": "La Reforma",
                        "latitude": "14.80104000",
                        "longitude": "-91.82233000"
                    },
                    {
                        "id": 53529,
                        "name": "Malacatán",
                        "latitude": "14.91132000",
                        "longitude": "-92.05788000"
                    },
                    {
                        "id": 53558,
                        "name": "Municipio de Concepción Tutuapa",
                        "latitude": "15.28795000",
                        "longitude": "-91.86738000"
                    },
                    {
                        "id": 53568,
                        "name": "Municipio de Malacatán",
                        "latitude": "14.91829000",
                        "longitude": "-92.10548000"
                    },
                    {
                        "id": 53597,
                        "name": "Municipio de Sipacapa",
                        "latitude": "15.19243000",
                        "longitude": "-91.65541000"
                    },
                    {
                        "id": 53598,
                        "name": "Municipio de Tejutla",
                        "latitude": "15.15638000",
                        "longitude": "-91.82457000"
                    },
                    {
                        "id": 53607,
                        "name": "Nuevo Progreso",
                        "latitude": "14.79174000",
                        "longitude": "-91.91946000"
                    },
                    {
                        "id": 53609,
                        "name": "Ocós",
                        "latitude": "14.50998000",
                        "longitude": "-92.19298000"
                    },
                    {
                        "id": 53615,
                        "name": "Pajapita",
                        "latitude": "14.72152000",
                        "longitude": "-92.03521000"
                    },
                    {
                        "id": 53642,
                        "name": "Río Blanco",
                        "latitude": "15.03820000",
                        "longitude": "-91.68463000"
                    },
                    {
                        "id": 53660,
                        "name": "San Antonio Sacatepéquez",
                        "latitude": "14.96060000",
                        "longitude": "-91.73154000"
                    },
                    {
                        "id": 53669,
                        "name": "San Cristóbal Cucho",
                        "latitude": "14.90505000",
                        "longitude": "-91.78123000"
                    },
                    {
                        "id": 53686,
                        "name": "San José Ojetenam",
                        "latitude": "15.23443000",
                        "longitude": "-91.97317000"
                    },
                    {
                        "id": 53687,
                        "name": "San José Ojetenán",
                        "latitude": "15.21667000",
                        "longitude": "-91.96667000"
                    },
                    {
                        "id": 53700,
                        "name": "San Lorenzo",
                        "latitude": "15.03087000",
                        "longitude": "-91.73534000"
                    },
                    {
                        "id": 53708,
                        "name": "San Marcos",
                        "latitude": "14.96389000",
                        "longitude": "-91.79444000"
                    },
                    {
                        "id": 53718,
                        "name": "San Miguel Ixtahuacán",
                        "latitude": "15.27247000",
                        "longitude": "-91.74785000"
                    },
                    {
                        "id": 53721,
                        "name": "San Pablo",
                        "latitude": "14.93269000",
                        "longitude": "-92.00415000"
                    },
                    {
                        "id": 53729,
                        "name": "San Pedro Sacatepéquez",
                        "latitude": "14.96807000",
                        "longitude": "-91.76172000"
                    },
                    {
                        "id": 53735,
                        "name": "San Rafael Pie de la Cuesta",
                        "latitude": "14.93052000",
                        "longitude": "-91.91388000"
                    },
                    {
                        "id": 53779,
                        "name": "Sibinal",
                        "latitude": "15.14963000",
                        "longitude": "-92.04892000"
                    },
                    {
                        "id": 53780,
                        "name": "Sipacapa",
                        "latitude": "15.21246000",
                        "longitude": "-91.63416000"
                    },
                    {
                        "id": 53785,
                        "name": "Tacaná",
                        "latitude": "15.24058000",
                        "longitude": "-92.06721000"
                    },
                    {
                        "id": 53787,
                        "name": "Tajumulco",
                        "latitude": "15.08349000",
                        "longitude": "-91.92225000"
                    },
                    {
                        "id": 53792,
                        "name": "Tejutla",
                        "latitude": "15.12254000",
                        "longitude": "-91.80635000"
                    }
                ]
            },
            {
                "id": 3665,
                "name": "Santa Rosa ",
                "iso2": "06",
                "latitude": "38.44057590",
                "longitude": "-122.70375430",
                "type": "department",
                "cities": [
                    {
                        "id": 53434,
                        "name": "Barberena",
                        "latitude": "14.30739000",
                        "longitude": "-90.36156000"
                    },
                    {
                        "id": 53442,
                        "name": "Casillas",
                        "latitude": "14.42222000",
                        "longitude": "-90.24417000"
                    },
                    {
                        "id": 53456,
                        "name": "Chiquimulilla",
                        "latitude": "14.08380000",
                        "longitude": "-90.38547000"
                    },
                    {
                        "id": 53475,
                        "name": "Cuilapa",
                        "latitude": "14.27639000",
                        "longitude": "-90.29889000"
                    },
                    {
                        "id": 53501,
                        "name": "Guazacapán",
                        "latitude": "14.07417000",
                        "longitude": "-90.41667000"
                    },
                    {
                        "id": 53547,
                        "name": "Municipio de Casillas",
                        "latitude": "14.37854000",
                        "longitude": "-90.17260000"
                    },
                    {
                        "id": 53553,
                        "name": "Municipio de Chiquimulilla",
                        "latitude": "14.09716000",
                        "longitude": "-90.37903000"
                    },
                    {
                        "id": 53562,
                        "name": "Municipio de Guazacapán",
                        "latitude": "14.01786000",
                        "longitude": "-90.43400000"
                    },
                    {
                        "id": 53606,
                        "name": "Nueva Santa Rosa",
                        "latitude": "14.38111000",
                        "longitude": "-90.27611000"
                    },
                    {
                        "id": 53612,
                        "name": "Oratorio",
                        "latitude": "14.22806000",
                        "longitude": "-90.17583000"
                    },
                    {
                        "id": 53633,
                        "name": "Pueblo Nuevo Viñas",
                        "latitude": "14.22576000",
                        "longitude": "-90.47613000"
                    },
                    {
                        "id": 53699,
                        "name": "San Juan Tecuaco",
                        "latitude": "14.08361000",
                        "longitude": "-90.26649000"
                    },
                    {
                        "id": 53733,
                        "name": "San Rafael Las Flores",
                        "latitude": "14.48139000",
                        "longitude": "-90.17333000"
                    },
                    {
                        "id": 53757,
                        "name": "Santa Cruz Naranjo",
                        "latitude": "14.38806000",
                        "longitude": "-90.36972000"
                    },
                    {
                        "id": 53766,
                        "name": "Santa María Ixhuatán",
                        "latitude": "14.19000000",
                        "longitude": "-90.27472000"
                    },
                    {
                        "id": 53769,
                        "name": "Santa Rosa de Lima",
                        "latitude": "14.38806000",
                        "longitude": "-90.29556000"
                    },
                    {
                        "id": 53789,
                        "name": "Taxisco",
                        "latitude": "14.06719000",
                        "longitude": "-90.46791000"
                    }
                ]
            },
            {
                "id": 3661,
                "name": "Sololá ",
                "iso2": "07",
                "latitude": "14.74852300",
                "longitude": "-91.28910360",
                "type": "department",
                "cities": [
                    {
                        "id": 53468,
                        "name": "Concepción",
                        "latitude": "14.78417000",
                        "longitude": "-91.14754000"
                    },
                    {
                        "id": 53572,
                        "name": "Municipio de Nahualá",
                        "latitude": "14.77548000",
                        "longitude": "-91.41616000"
                    },
                    {
                        "id": 53574,
                        "name": "Municipio de Panajachel",
                        "latitude": "14.74676000",
                        "longitude": "-91.14935000"
                    },
                    {
                        "id": 53591,
                        "name": "Municipio de Santa Catarina Palopó",
                        "latitude": "14.71794000",
                        "longitude": "-91.13060000"
                    },
                    {
                        "id": 53592,
                        "name": "Municipio de Santa Cruz La Laguna",
                        "latitude": "14.74324000",
                        "longitude": "-91.22178000"
                    },
                    {
                        "id": 53602,
                        "name": "Nahualá",
                        "latitude": "14.84290000",
                        "longitude": "-91.31799000"
                    },
                    {
                        "id": 53619,
                        "name": "Panajachel",
                        "latitude": "14.74185000",
                        "longitude": "-91.15676000"
                    },
                    {
                        "id": 53652,
                        "name": "San Andrés Semetabaj",
                        "latitude": "14.74497000",
                        "longitude": "-91.13344000"
                    },
                    {
                        "id": 53659,
                        "name": "San Antonio Palopó",
                        "latitude": "14.69232000",
                        "longitude": "-91.11638000"
                    },
                    {
                        "id": 53683,
                        "name": "San José Chacayá",
                        "latitude": "14.77096000",
                        "longitude": "-91.21564000"
                    },
                    {
                        "id": 53697,
                        "name": "San Juan La Laguna",
                        "latitude": "14.69453000",
                        "longitude": "-91.28666000"
                    },
                    {
                        "id": 53703,
                        "name": "San Lucas Tolimán",
                        "latitude": "14.59471000",
                        "longitude": "-91.14659000"
                    },
                    {
                        "id": 53709,
                        "name": "San Marcos La Laguna",
                        "latitude": "14.72504000",
                        "longitude": "-91.25844000"
                    },
                    {
                        "id": 53723,
                        "name": "San Pablo La Laguna",
                        "latitude": "14.72092000",
                        "longitude": "-91.27242000"
                    },
                    {
                        "id": 53726,
                        "name": "San Pedro La Laguna",
                        "latitude": "14.69297000",
                        "longitude": "-91.27201000"
                    },
                    {
                        "id": 53749,
                        "name": "Santa Catarina Ixtahuacán",
                        "latitude": "14.79797000",
                        "longitude": "-91.35866000"
                    },
                    {
                        "id": 53751,
                        "name": "Santa Catarina Palopó",
                        "latitude": "14.72335000",
                        "longitude": "-91.13428000"
                    },
                    {
                        "id": 53753,
                        "name": "Santa Clara La Laguna",
                        "latitude": "14.71509000",
                        "longitude": "-91.30355000"
                    },
                    {
                        "id": 53755,
                        "name": "Santa Cruz La Laguna",
                        "latitude": "14.74421000",
                        "longitude": "-91.20716000"
                    },
                    {
                        "id": 53764,
                        "name": "Santa Lucía Utatlán",
                        "latitude": "14.77135000",
                        "longitude": "-91.26700000"
                    },
                    {
                        "id": 53767,
                        "name": "Santa María Visitación",
                        "latitude": "14.71717000",
                        "longitude": "-91.30844000"
                    },
                    {
                        "id": 53770,
                        "name": "Santiago Atitlán",
                        "latitude": "14.63823000",
                        "longitude": "-91.22901000"
                    },
                    {
                        "id": 53782,
                        "name": "Sololá",
                        "latitude": "14.77222000",
                        "longitude": "-91.18333000"
                    }
                ]
            },
            {
                "id": 3660,
                "name": "Suchitepéquez ",
                "iso2": "10",
                "latitude": "14.42159820",
                "longitude": "-91.40482490",
                "type": "department",
                "cities": [
                    {
                        "id": 53448,
                        "name": "Chicacao",
                        "latitude": "14.54295000",
                        "longitude": "-91.32636000"
                    },
                    {
                        "id": 53478,
                        "name": "Cuyotenango",
                        "latitude": "14.54006000",
                        "longitude": "-91.57179000"
                    },
                    {
                        "id": 53532,
                        "name": "Mazatenango",
                        "latitude": "14.53417000",
                        "longitude": "-91.50333000"
                    },
                    {
                        "id": 53581,
                        "name": "Municipio de San Antonio Suchitepéquez",
                        "latitude": "14.51839000",
                        "longitude": "-91.40438000"
                    },
                    {
                        "id": 53587,
                        "name": "Municipio de San Miguel Panán",
                        "latitude": "14.50525000",
                        "longitude": "-91.35956000"
                    },
                    {
                        "id": 53590,
                        "name": "Municipio de Santa Bárbara",
                        "latitude": "14.47317000",
                        "longitude": "-91.24688000"
                    },
                    {
                        "id": 53624,
                        "name": "Patulul",
                        "latitude": "14.42321000",
                        "longitude": "-91.16049000"
                    },
                    {
                        "id": 53632,
                        "name": "Pueblo Nuevo",
                        "latitude": "14.64709000",
                        "longitude": "-91.53946000"
                    },
                    {
                        "id": 53643,
                        "name": "Río Bravo",
                        "latitude": "14.40042000",
                        "longitude": "-91.31713000"
                    },
                    {
                        "id": 53661,
                        "name": "San Antonio Suchitepéquez",
                        "latitude": "14.53938000",
                        "longitude": "-91.41442000"
                    },
                    {
                        "id": 53666,
                        "name": "San Bernardino",
                        "latitude": "14.54240000",
                        "longitude": "-91.45811000"
                    },
                    {
                        "id": 53675,
                        "name": "San Francisco Zapotitlán",
                        "latitude": "14.58939000",
                        "longitude": "-91.52144000"
                    },
                    {
                        "id": 53677,
                        "name": "San Gabriel",
                        "latitude": "14.51076000",
                        "longitude": "-91.50745000"
                    },
                    {
                        "id": 53684,
                        "name": "San José El Ídolo",
                        "latitude": "14.45016000",
                        "longitude": "-91.42222000"
                    },
                    {
                        "id": 53692,
                        "name": "San Juan Bautista",
                        "latitude": "14.42274000",
                        "longitude": "-91.17904000"
                    },
                    {
                        "id": 53701,
                        "name": "San Lorenzo",
                        "latitude": "14.48606000",
                        "longitude": "-91.51263000"
                    },
                    {
                        "id": 53719,
                        "name": "San Miguel Panán",
                        "latitude": "14.52865000",
                        "longitude": "-91.36733000"
                    },
                    {
                        "id": 53722,
                        "name": "San Pablo Jocopilas",
                        "latitude": "14.58882000",
                        "longitude": "-91.45188000"
                    },
                    {
                        "id": 53746,
                        "name": "Santa Bárbara",
                        "latitude": "14.43563000",
                        "longitude": "-91.22685000"
                    },
                    {
                        "id": 53773,
                        "name": "Santo Domingo Suchitepéquez",
                        "latitude": "14.47901000",
                        "longitude": "-91.48327000"
                    },
                    {
                        "id": 53775,
                        "name": "Santo Tomás La Unión",
                        "latitude": "14.63219000",
                        "longitude": "-91.41075000"
                    },
                    {
                        "id": 53806,
                        "name": "Zunilito",
                        "latitude": "14.61264000",
                        "longitude": "-91.50980000"
                    }
                ]
            },
            {
                "id": 3663,
                "name": "Totonicapán ",
                "iso2": "08",
                "latitude": "14.91734020",
                "longitude": "-91.36139230",
                "type": "department",
                "cities": [
                    {
                        "id": 53535,
                        "name": "Momostenango",
                        "latitude": "15.04437000",
                        "longitude": "-91.40864000"
                    },
                    {
                        "id": 53570,
                        "name": "Municipio de Momostenango",
                        "latitude": "15.04726000",
                        "longitude": "-91.40625000"
                    },
                    {
                        "id": 53594,
                        "name": "Municipio de Santa María Chiquimula",
                        "latitude": "15.02886000",
                        "longitude": "-91.32917000"
                    },
                    {
                        "id": 53599,
                        "name": "Municipio de Totonicapán",
                        "latitude": "14.90193000",
                        "longitude": "-91.31999000"
                    },
                    {
                        "id": 53654,
                        "name": "San Andrés Xecul",
                        "latitude": "14.90482000",
                        "longitude": "-91.48307000"
                    },
                    {
                        "id": 53662,
                        "name": "San Bartolo",
                        "latitude": "15.08438000",
                        "longitude": "-91.45606000"
                    },
                    {
                        "id": 53670,
                        "name": "San Cristóbal Totonicapán",
                        "latitude": "14.91682000",
                        "longitude": "-91.44060000"
                    },
                    {
                        "id": 53674,
                        "name": "San Francisco El Alto",
                        "latitude": "14.94490000",
                        "longitude": "-91.44310000"
                    },
                    {
                        "id": 53761,
                        "name": "Santa Lucia La Reforma",
                        "latitude": "15.12819000",
                        "longitude": "-91.23619000"
                    },
                    {
                        "id": 53765,
                        "name": "Santa María Chiquimula",
                        "latitude": "15.02992000",
                        "longitude": "-91.32920000"
                    },
                    {
                        "id": 53795,
                        "name": "Totonicapán",
                        "latitude": "14.91167000",
                        "longitude": "-91.36111000"
                    }
                ]
            },
            {
                "id": 5239,
                "name": "Zacapa",
                "iso2": "19",
                "latitude": "15.00928280",
                "longitude": "-89.92532330",
                "type": "department",
                "cities": []
            }
        ]
    },
    {
        "id": 91,
        "name": "Guernsey",
        "iso3": "GGY",
        "iso2": "GG",
        "numeric_code": "831",
        "phonecode": "44",
        "capital": "St Peter Port",
        "currency": "GBP",
        "currency_name": "British pound",
        "currency_symbol": "£",
        "tld": ".gg",
        "native": "Guernsey",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Channel Island",
        "timezones": [
            {
                "zoneName": "Europe\/Guernsey",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Gwernenez",
            "ko": "건지, 올더니",
            "pt-BR": "Guernsey",
            "pt": "Guernsey",
            "nl": "Guernsey",
            "hr": "Guernsey",
            "fa": "گرنزی",
            "de": "Guernsey",
            "es": "Guernsey",
            "fr": "Guernesey",
            "ja": "ガーンジー",
            "it": "Guernsey",
            "zh-CN": "根西岛",
            "tr": "Alderney",
            "ru": "Гернси и Олдерни",
            "uk": "Гернсі та Олдерні",
            "pl": "Guernsey i Alderney"
        },
        "latitude": "49.46666666",
        "longitude": "-2.58333333",
        "emoji": "🇬🇬",
        "emojiU": "U+1F1EC U+1F1EC",
        "states": [
            {
                "id": 5389,
                "name": "Alderney",
                "iso2": "04",
                "latitude": "49.71637100",
                "longitude": "-2.24033700",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5386,
                "name": "Castel",
                "iso2": "01",
                "latitude": "49.46663810",
                "longitude": "-2.63785010",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5387,
                "name": "Forest",
                "iso2": "02",
                "latitude": "49.42677930",
                "longitude": "-2.61700450",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5392,
                "name": "Sark",
                "iso2": "07",
                "latitude": "49.42542520",
                "longitude": "-2.40995270",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5388,
                "name": "St Andrew",
                "iso2": "03",
                "latitude": "49.45058530",
                "longitude": "-2.60204130",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5390,
                "name": "St Martin",
                "iso2": "05",
                "latitude": "49.43376590",
                "longitude": "-2.59799650",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5391,
                "name": "St Peter Port",
                "iso2": "06",
                "latitude": "49.45922770",
                "longitude": "-2.58609300",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5393,
                "name": "St Pierre du Bois",
                "iso2": "08",
                "latitude": "49.44119220",
                "longitude": "-2.68438550",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5394,
                "name": "St Sampson",
                "iso2": "09",
                "latitude": "49.48442020",
                "longitude": "-2.58103190",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5395,
                "name": "St Saviour",
                "iso2": "10",
                "latitude": "49.45114440",
                "longitude": "-2.65977520",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5396,
                "name": "Torteval",
                "iso2": "11",
                "latitude": "49.42885870",
                "longitude": "-2.68990940",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5397,
                "name": "Vale",
                "iso2": "12",
                "latitude": "49.48846050",
                "longitude": "-2.58075770",
                "type": "parish",
                "cities": []
            }
        ]
    },
    {
        "id": 92,
        "name": "Guinea",
        "iso3": "GIN",
        "iso2": "GN",
        "numeric_code": "324",
        "phonecode": "224",
        "capital": "Conakry",
        "currency": "GNF",
        "currency_name": "Guinean franc",
        "currency_symbol": "FG",
        "tld": ".gn",
        "native": "Guinée",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Guinean",
        "timezones": [
            {
                "zoneName": "Africa\/Conakry",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Ginea",
            "ko": "기니",
            "pt-BR": "Guiné",
            "pt": "Guiné",
            "nl": "Guinee",
            "hr": "Gvineja",
            "fa": "گینه",
            "de": "Guinea",
            "es": "Guinea",
            "fr": "Guinée",
            "ja": "ギニア",
            "it": "Guinea",
            "zh-CN": "几内亚",
            "tr": "Gine",
            "ru": "Гвинея",
            "uk": "Гвінея",
            "pl": "Gwinea"
        },
        "latitude": "11.00000000",
        "longitude": "-10.00000000",
        "emoji": "🇬🇳",
        "emojiU": "U+1F1EC U+1F1F3",
        "states": [
            {
                "id": 2672,
                "name": "Beyla",
                "iso2": "BE",
                "latitude": "8.91981780",
                "longitude": "-8.30884410",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2699,
                "name": "Boffa",
                "iso2": "BF",
                "latitude": "10.18082540",
                "longitude": "-14.03916150",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2676,
                "name": "Boké",
                "iso2": "B",
                "latitude": "11.18646720",
                "longitude": "-14.10013260",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52323,
                        "name": "Boffa",
                        "latitude": "10.33333000",
                        "longitude": "-14.16667000"
                    },
                    {
                        "id": 52325,
                        "name": "Boké",
                        "latitude": "10.93217000",
                        "longitude": "-14.29055000"
                    },
                    {
                        "id": 52324,
                        "name": "Boke Prefecture",
                        "latitude": "11.08333000",
                        "longitude": "-14.41667000"
                    },
                    {
                        "id": 52332,
                        "name": "Fria",
                        "latitude": "10.41667000",
                        "longitude": "-13.58333000"
                    },
                    {
                        "id": 52333,
                        "name": "Gaoual",
                        "latitude": "11.75000000",
                        "longitude": "-13.20000000"
                    },
                    {
                        "id": 52334,
                        "name": "Gaoual Prefecture",
                        "latitude": "11.75000000",
                        "longitude": "-13.20000000"
                    },
                    {
                        "id": 52339,
                        "name": "Kimbo",
                        "latitude": "10.40000000",
                        "longitude": "-13.55000000"
                    },
                    {
                        "id": 52342,
                        "name": "Koundara",
                        "latitude": "12.48333000",
                        "longitude": "-13.30000000"
                    },
                    {
                        "id": 52343,
                        "name": "Koundara Prefecture",
                        "latitude": "12.41667000",
                        "longitude": "-13.16667000"
                    },
                    {
                        "id": 52364,
                        "name": "Sanguéya",
                        "latitude": "10.70000000",
                        "longitude": "-14.36667000"
                    },
                    {
                        "id": 52374,
                        "name": "Youkounkoun",
                        "latitude": "12.53110000",
                        "longitude": "-13.12240000"
                    }
                ]
            },
            {
                "id": 2709,
                "name": "Boké",
                "iso2": "BK",
                "latitude": "11.08473790",
                "longitude": "-14.37919120",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2686,
                "name": "Conakry",
                "iso2": "C",
                "latitude": "9.64118550",
                "longitude": "-13.57840120",
                "type": "governorate",
                "cities": [
                    {
                        "id": 52326,
                        "name": "Camayenne",
                        "latitude": "9.53500000",
                        "longitude": "-13.68778000"
                    },
                    {
                        "id": 52327,
                        "name": "Conakry",
                        "latitude": "9.53795000",
                        "longitude": "-13.67729000"
                    }
                ]
            },
            {
                "id": 2705,
                "name": "Coyah",
                "iso2": "CO",
                "latitude": "9.77155350",
                "longitude": "-13.31252990",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2679,
                "name": "Dabola",
                "iso2": "DB",
                "latitude": "10.72978060",
                "longitude": "-11.11078540",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2706,
                "name": "Dalaba",
                "iso2": "DL",
                "latitude": "10.68681760",
                "longitude": "-12.24906970",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2688,
                "name": "Dinguiraye",
                "iso2": "DI",
                "latitude": "11.68442220",
                "longitude": "-10.80000510",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2681,
                "name": "Dubréka",
                "iso2": "DU",
                "latitude": "9.79073480",
                "longitude": "-13.51477350",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 5344,
                "name": "Faranah",
                "iso2": "F",
                "latitude": "10.54730350",
                "longitude": "-11.85076440",
                "type": "administrative region",
                "cities": []
            },
            {
                "id": 2682,
                "name": "Faranah",
                "iso2": "FA",
                "latitude": "9.90573990",
                "longitude": "-10.80000510",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2683,
                "name": "Forécariah",
                "iso2": "FO",
                "latitude": "9.38861870",
                "longitude": "-13.08179030",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2675,
                "name": "Fria",
                "iso2": "FR",
                "latitude": "10.36745430",
                "longitude": "-13.58418710",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2685,
                "name": "Gaoual",
                "iso2": "GA",
                "latitude": "11.57628040",
                "longitude": "-13.35872880",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2711,
                "name": "Guéckédou",
                "iso2": "GU",
                "latitude": "8.56496880",
                "longitude": "-10.13111630",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2704,
                "name": "Kankan",
                "iso2": "KA",
                "latitude": "10.30344650",
                "longitude": "-9.36730840",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2697,
                "name": "Kankan",
                "iso2": "K",
                "latitude": "10.12092300",
                "longitude": "-9.54509740",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52336,
                        "name": "Kankan",
                        "latitude": "10.38542000",
                        "longitude": "-9.30568000"
                    },
                    {
                        "id": 52337,
                        "name": "Kankan Prefecture",
                        "latitude": "10.27100000",
                        "longitude": "-9.17800000"
                    },
                    {
                        "id": 52345,
                        "name": "Kérouané",
                        "latitude": "9.26667000",
                        "longitude": "-9.01667000"
                    },
                    {
                        "id": 52338,
                        "name": "Kerouane Prefecture",
                        "latitude": "9.16667000",
                        "longitude": "-9.08333000"
                    },
                    {
                        "id": 52344,
                        "name": "Kouroussa",
                        "latitude": "10.66667000",
                        "longitude": "-9.91667000"
                    },
                    {
                        "id": 52356,
                        "name": "Mandiana",
                        "latitude": "10.62577000",
                        "longitude": "-8.69413000"
                    },
                    {
                        "id": 52357,
                        "name": "Mandiana Prefecture",
                        "latitude": "10.65800000",
                        "longitude": "-8.61500000"
                    },
                    {
                        "id": 52365,
                        "name": "Siguiri",
                        "latitude": "11.42282000",
                        "longitude": "-9.16852000"
                    },
                    {
                        "id": 52366,
                        "name": "Siguiri Prefecture",
                        "latitude": "11.66667000",
                        "longitude": "-9.50000000"
                    },
                    {
                        "id": 52368,
                        "name": "Tokonou",
                        "latitude": "9.65000000",
                        "longitude": "-9.78333000"
                    }
                ]
            },
            {
                "id": 2710,
                "name": "Kérouané",
                "iso2": "KE",
                "latitude": "9.25366430",
                "longitude": "-9.01289260",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2701,
                "name": "Kindia",
                "iso2": "D",
                "latitude": "10.17816940",
                "longitude": "-12.98961500",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52328,
                        "name": "Coyah",
                        "latitude": "9.75000000",
                        "longitude": "-13.41667000"
                    },
                    {
                        "id": 52330,
                        "name": "Dubréka",
                        "latitude": "9.79111000",
                        "longitude": "-13.52333000"
                    },
                    {
                        "id": 52331,
                        "name": "Forécariah",
                        "latitude": "9.43056000",
                        "longitude": "-13.08806000"
                    },
                    {
                        "id": 52340,
                        "name": "Kindia",
                        "latitude": "10.08333000",
                        "longitude": "-12.80000000"
                    },
                    {
                        "id": 52361,
                        "name": "Préfecture de Dubréka",
                        "latitude": "10.25000000",
                        "longitude": "-13.41667000"
                    },
                    {
                        "id": 52362,
                        "name": "Préfecture de Forécariah",
                        "latitude": "9.43333000",
                        "longitude": "-13.10000000"
                    },
                    {
                        "id": 52372,
                        "name": "Télimélé",
                        "latitude": "10.90000000",
                        "longitude": "-13.03333000"
                    },
                    {
                        "id": 52367,
                        "name": "Telimele Prefecture",
                        "latitude": "10.91667000",
                        "longitude": "-13.33333000"
                    },
                    {
                        "id": 52369,
                        "name": "Tondon",
                        "latitude": "10.36667000",
                        "longitude": "-13.35000000"
                    }
                ]
            },
            {
                "id": 2693,
                "name": "Kindia",
                "iso2": "KD",
                "latitude": "10.10132920",
                "longitude": "-12.71351210",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2691,
                "name": "Kissidougou",
                "iso2": "KS",
                "latitude": "9.22520220",
                "longitude": "-10.08072980",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2692,
                "name": "Koubia",
                "iso2": "KB",
                "latitude": "11.58235400",
                "longitude": "-11.89202370",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2703,
                "name": "Koundara",
                "iso2": "KN",
                "latitude": "12.48940210",
                "longitude": "-13.30675620",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2695,
                "name": "Kouroussa",
                "iso2": "KO",
                "latitude": "10.64892290",
                "longitude": "-9.88505860",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2680,
                "name": "Labé",
                "iso2": "LA",
                "latitude": "11.35419390",
                "longitude": "-12.34638750",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2677,
                "name": "Labé",
                "iso2": "L",
                "latitude": "11.32320420",
                "longitude": "-12.28913140",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52341,
                        "name": "Koubia",
                        "latitude": "11.58333000",
                        "longitude": "-11.83333000"
                    },
                    {
                        "id": 52347,
                        "name": "Labé",
                        "latitude": "11.31823000",
                        "longitude": "-12.28332000"
                    },
                    {
                        "id": 52346,
                        "name": "Labe Prefecture",
                        "latitude": "11.36600000",
                        "longitude": "-12.30000000"
                    },
                    {
                        "id": 52350,
                        "name": "Lélouma",
                        "latitude": "11.42383000",
                        "longitude": "-12.68183000"
                    },
                    {
                        "id": 52348,
                        "name": "Lelouma Prefecture",
                        "latitude": "11.41667000",
                        "longitude": "-12.66667000"
                    },
                    {
                        "id": 52352,
                        "name": "Mali",
                        "latitude": "12.07900000",
                        "longitude": "-12.29820000"
                    },
                    {
                        "id": 52353,
                        "name": "Mali Prefecture",
                        "latitude": "12.08333000",
                        "longitude": "-12.08333000"
                    },
                    {
                        "id": 52371,
                        "name": "Tougué",
                        "latitude": "11.44503000",
                        "longitude": "-11.66422000"
                    },
                    {
                        "id": 52370,
                        "name": "Tougue Prefecture",
                        "latitude": "11.46667000",
                        "longitude": "-11.60000000"
                    }
                ]
            },
            {
                "id": 2690,
                "name": "Lélouma",
                "iso2": "LE",
                "latitude": "11.18333300",
                "longitude": "-12.93333300",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2708,
                "name": "Lola",
                "iso2": "LO",
                "latitude": "7.96138180",
                "longitude": "-8.39649380",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2702,
                "name": "Macenta",
                "iso2": "MC",
                "latitude": "8.46157950",
                "longitude": "-9.27855830",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2700,
                "name": "Mali",
                "iso2": "ML",
                "latitude": "11.98370900",
                "longitude": "-12.25479190",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2698,
                "name": "Mamou",
                "iso2": "M",
                "latitude": "10.60341100",
                "longitude": "-12.83371550",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52329,
                        "name": "Dalaba",
                        "latitude": "10.75000000",
                        "longitude": "-12.30000000"
                    },
                    {
                        "id": 52354,
                        "name": "Mamou",
                        "latitude": "10.37546000",
                        "longitude": "-12.09148000"
                    },
                    {
                        "id": 52355,
                        "name": "Mamou Prefecture",
                        "latitude": "10.45900000",
                        "longitude": "-11.81500000"
                    },
                    {
                        "id": 52360,
                        "name": "Pita",
                        "latitude": "10.83333000",
                        "longitude": "-12.58333000"
                    }
                ]
            },
            {
                "id": 2689,
                "name": "Mamou",
                "iso2": "MM",
                "latitude": "10.49131090",
                "longitude": "-12.56792500",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2673,
                "name": "Mandiana",
                "iso2": "MD",
                "latitude": "10.61728270",
                "longitude": "-8.69857160",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2684,
                "name": "Nzérékoré",
                "iso2": "N",
                "latitude": "8.03858700",
                "longitude": "-8.83627550",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 52321,
                        "name": "Beyla",
                        "latitude": "8.69011000",
                        "longitude": "-8.64869000"
                    },
                    {
                        "id": 52322,
                        "name": "Beyla Prefecture",
                        "latitude": "8.91667000",
                        "longitude": "-8.41667000"
                    },
                    {
                        "id": 52335,
                        "name": "Gueckedou",
                        "latitude": "8.56744000",
                        "longitude": "-10.13360000"
                    },
                    {
                        "id": 52349,
                        "name": "Lola",
                        "latitude": "7.83333000",
                        "longitude": "-8.33333000"
                    },
                    {
                        "id": 52351,
                        "name": "Macenta",
                        "latitude": "8.50000000",
                        "longitude": "-9.41667000"
                    },
                    {
                        "id": 52359,
                        "name": "Nzérékoré",
                        "latitude": "7.75624000",
                        "longitude": "-8.81790000"
                    },
                    {
                        "id": 52358,
                        "name": "Nzerekore Prefecture",
                        "latitude": "7.94500000",
                        "longitude": "-8.78300000"
                    },
                    {
                        "id": 52363,
                        "name": "Préfecture de Guékédou",
                        "latitude": "8.66667000",
                        "longitude": "-10.25000000"
                    },
                    {
                        "id": 52373,
                        "name": "Yomou",
                        "latitude": "7.50000000",
                        "longitude": "-9.16667000"
                    }
                ]
            },
            {
                "id": 2678,
                "name": "Nzérékoré",
                "iso2": "NZ",
                "latitude": "7.74783590",
                "longitude": "-8.82525020",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2694,
                "name": "Pita",
                "iso2": "PI",
                "latitude": "10.80620860",
                "longitude": "-12.71351210",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2707,
                "name": "Siguiri",
                "iso2": "SI",
                "latitude": "11.41481130",
                "longitude": "-9.17883040",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2687,
                "name": "Télimélé",
                "iso2": "TE",
                "latitude": "10.90893640",
                "longitude": "-13.02993310",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2696,
                "name": "Tougué",
                "iso2": "TO",
                "latitude": "11.38415830",
                "longitude": "-11.61577730",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 2674,
                "name": "Yomou",
                "iso2": "YO",
                "latitude": "7.56962790",
                "longitude": "-9.25915710",
                "type": "prefecture",
                "cities": []
            }
        ]
    },
    {
        "id": 93,
        "name": "Guinea-Bissau",
        "iso3": "GNB",
        "iso2": "GW",
        "numeric_code": "624",
        "phonecode": "245",
        "capital": "Bissau",
        "currency": "XOF",
        "currency_name": "West African CFA franc",
        "currency_symbol": "CFA",
        "tld": ".gw",
        "native": "Guiné-Bissau",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Bissau-Guinean",
        "timezones": [
            {
                "zoneName": "Africa\/Bissau",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Ginea-Bissau",
            "ko": "기니비사우",
            "pt-BR": "Guiné-Bissau",
            "pt": "Guiné-Bissau",
            "nl": "Guinee-Bissau",
            "hr": "Gvineja Bisau",
            "fa": "گینه بیسائو",
            "de": "Guinea-Bissau",
            "es": "Guinea-Bisáu",
            "fr": "Guinée-Bissau",
            "ja": "ギニアビサウ",
            "it": "Guinea-Bissau",
            "zh-CN": "几内亚比绍",
            "tr": "Gine-bissau",
            "ru": "Гвинея-Бисау",
            "uk": "Гвінея-Бісау",
            "pl": "Gwinea Bissau"
        },
        "latitude": "12.00000000",
        "longitude": "-15.00000000",
        "emoji": "🇬🇼",
        "emojiU": "U+1F1EC U+1F1FC",
        "states": [
            {
                "id": 2720,
                "name": "Bafatá",
                "iso2": "BA",
                "latitude": "12.17352430",
                "longitude": "-14.65295200",
                "type": "region",
                "cities": [
                    {
                        "id": 53807,
                        "name": "Bafatá",
                        "latitude": "12.16583000",
                        "longitude": "-14.66167000"
                    },
                    {
                        "id": 53815,
                        "name": "Contuboel Sector",
                        "latitude": "12.55500000",
                        "longitude": "-14.64100000"
                    }
                ]
            },
            {
                "id": 2714,
                "name": "Biombo",
                "iso2": "BM",
                "latitude": "11.85290610",
                "longitude": "-15.73511710",
                "type": "region",
                "cities": [
                    {
                        "id": 53820,
                        "name": "Quinhámel",
                        "latitude": "11.88694000",
                        "longitude": "-15.85556000"
                    }
                ]
            },
            {
                "id": 2722,
                "name": "Bolama",
                "iso2": "BL",
                "latitude": "11.14805910",
                "longitude": "-16.13457050",
                "type": "region",
                "cities": [
                    {
                        "id": 53809,
                        "name": "Bolama",
                        "latitude": "11.57694000",
                        "longitude": "-15.47611000"
                    },
                    {
                        "id": 53811,
                        "name": "Bubaque",
                        "latitude": "11.28333000",
                        "longitude": "-15.83333000"
                    }
                ]
            },
            {
                "id": 2713,
                "name": "Cacheu",
                "iso2": "CA",
                "latitude": "12.05514160",
                "longitude": "-16.06401790",
                "type": "region",
                "cities": [
                    {
                        "id": 53812,
                        "name": "Cacheu",
                        "latitude": "12.27444000",
                        "longitude": "-16.16528000"
                    },
                    {
                        "id": 53813,
                        "name": "Canchungo",
                        "latitude": "12.06722000",
                        "longitude": "-16.03333000"
                    }
                ]
            },
            {
                "id": 2719,
                "name": "Gabú",
                "iso2": "GA",
                "latitude": "11.89624880",
                "longitude": "-14.10013260",
                "type": "region",
                "cities": [
                    {
                        "id": 53817,
                        "name": "Gabú",
                        "latitude": "12.28000000",
                        "longitude": "-14.22222000"
                    }
                ]
            },
            {
                "id": 2721,
                "name": "Leste",
                "iso2": "L",
                "latitude": null,
                "longitude": null,
                "type": "province",
                "cities": []
            },
            {
                "id": 2717,
                "name": "Norte",
                "iso2": "N",
                "latitude": "7.87218110",
                "longitude": "123.88577470",
                "type": "province",
                "cities": []
            },
            {
                "id": 2718,
                "name": "Oio",
                "iso2": "OI",
                "latitude": "12.27607090",
                "longitude": "-15.31311850",
                "type": "region",
                "cities": [
                    {
                        "id": 53808,
                        "name": "Bissorã",
                        "latitude": "12.22306000",
                        "longitude": "-15.44750000"
                    },
                    {
                        "id": 53816,
                        "name": "Farim",
                        "latitude": "12.48389000",
                        "longitude": "-15.22167000"
                    },
                    {
                        "id": 53818,
                        "name": "Mansôa",
                        "latitude": "12.07333000",
                        "longitude": "-15.31889000"
                    }
                ]
            },
            {
                "id": 2715,
                "name": "Quinara",
                "iso2": "QU",
                "latitude": "11.79556200",
                "longitude": "-15.17268160",
                "type": "region",
                "cities": [
                    {
                        "id": 53810,
                        "name": "Buba",
                        "latitude": "11.58889000",
                        "longitude": "-14.99583000"
                    }
                ]
            },
            {
                "id": 2716,
                "name": "Sul",
                "iso2": "S",
                "latitude": "-10.28665780",
                "longitude": "20.71224650",
                "type": "province",
                "cities": []
            },
            {
                "id": 2712,
                "name": "Tombali",
                "iso2": "TO",
                "latitude": "11.36326960",
                "longitude": "-14.98561760",
                "type": "region",
                "cities": [
                    {
                        "id": 53814,
                        "name": "Catió",
                        "latitude": "11.28250000",
                        "longitude": "-15.25472000"
                    },
                    {
                        "id": 53819,
                        "name": "Quebo",
                        "latitude": "11.33333000",
                        "longitude": "-14.93333000"
                    }
                ]
            }
        ]
    },
    {
        "id": 94,
        "name": "Guyana",
        "iso3": "GUY",
        "iso2": "GY",
        "numeric_code": "328",
        "phonecode": "592",
        "capital": "Georgetown",
        "currency": "GYD",
        "currency_name": "Guyanese dollar",
        "currency_symbol": "$",
        "tld": ".gy",
        "native": "Guyana",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Guyanese",
        "timezones": [
            {
                "zoneName": "America\/Guyana",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "GYT",
                "tzName": "Guyana Time"
            }
        ],
        "translations": {
            "br": "Guyana",
            "ko": "가이아나",
            "pt-BR": "Guiana",
            "pt": "Guiana",
            "nl": "Guyana",
            "hr": "Gvajana",
            "fa": "گویان",
            "de": "Guyana",
            "es": "Guyana",
            "fr": "Guyane",
            "ja": "ガイアナ",
            "it": "Guyana",
            "zh-CN": "圭亚那",
            "tr": "Guyana",
            "ru": "Гайана",
            "uk": "Гайана",
            "pl": "Gujana"
        },
        "latitude": "5.00000000",
        "longitude": "-59.00000000",
        "emoji": "🇬🇾",
        "emojiU": "U+1F1EC U+1F1FE",
        "states": [
            {
                "id": 2764,
                "name": "Barima-Waini",
                "iso2": "BA",
                "latitude": "7.48824190",
                "longitude": "-59.65644940",
                "type": "region",
                "cities": [
                    {
                        "id": 53826,
                        "name": "Mabaruma",
                        "latitude": "8.20000000",
                        "longitude": "-59.78333000"
                    }
                ]
            },
            {
                "id": 2760,
                "name": "Cuyuni-Mazaruni",
                "iso2": "CU",
                "latitude": "6.46421410",
                "longitude": "-60.21107520",
                "type": "region",
                "cities": [
                    {
                        "id": 53822,
                        "name": "Bartica",
                        "latitude": "6.40799000",
                        "longitude": "-58.62192000"
                    }
                ]
            },
            {
                "id": 2767,
                "name": "Demerara-Mahaica",
                "iso2": "DE",
                "latitude": "6.54642600",
                "longitude": "-58.09820460",
                "type": "region",
                "cities": [
                    {
                        "id": 53823,
                        "name": "Georgetown",
                        "latitude": "6.80448000",
                        "longitude": "-58.15527000"
                    },
                    {
                        "id": 53827,
                        "name": "Mahaica Village",
                        "latitude": "6.68405000",
                        "longitude": "-57.92181000"
                    }
                ]
            },
            {
                "id": 2766,
                "name": "East Berbice-Corentyne",
                "iso2": "EB",
                "latitude": "2.74779220",
                "longitude": "-57.46272590",
                "type": "region",
                "cities": [
                    {
                        "id": 53830,
                        "name": "New Amsterdam",
                        "latitude": "6.24793000",
                        "longitude": "-57.51710000"
                    },
                    {
                        "id": 53833,
                        "name": "Skeldon",
                        "latitude": "5.88333000",
                        "longitude": "-57.13333000"
                    }
                ]
            },
            {
                "id": 2768,
                "name": "Essequibo Islands-West Demerara",
                "iso2": "ES",
                "latitude": "6.57201320",
                "longitude": "-58.46299970",
                "type": "region",
                "cities": [
                    {
                        "id": 53831,
                        "name": "Parika",
                        "latitude": "6.83712000",
                        "longitude": "-58.42941000"
                    },
                    {
                        "id": 53834,
                        "name": "Vreed-en-Hoop",
                        "latitude": "6.80927000",
                        "longitude": "-58.19798000"
                    }
                ]
            },
            {
                "id": 2762,
                "name": "Mahaica-Berbice",
                "iso2": "MA",
                "latitude": "6.23849600",
                "longitude": "-57.91625550",
                "type": "region",
                "cities": [
                    {
                        "id": 53828,
                        "name": "Mahaicony Village",
                        "latitude": "6.57633000",
                        "longitude": "-57.80486000"
                    },
                    {
                        "id": 53832,
                        "name": "Rosignol",
                        "latitude": "6.27095000",
                        "longitude": "-57.53697000"
                    }
                ]
            },
            {
                "id": 2765,
                "name": "Pomeroon-Supenaam",
                "iso2": "PM",
                "latitude": "7.12941660",
                "longitude": "-58.92062950",
                "type": "region",
                "cities": [
                    {
                        "id": 53821,
                        "name": "Anna Regina",
                        "latitude": "7.26439000",
                        "longitude": "-58.50769000"
                    }
                ]
            },
            {
                "id": 2761,
                "name": "Potaro-Siparuni",
                "iso2": "PT",
                "latitude": "4.78558530",
                "longitude": "-59.28799770",
                "type": "region",
                "cities": [
                    {
                        "id": 53829,
                        "name": "Mahdia",
                        "latitude": "5.26667000",
                        "longitude": "-59.15000000"
                    }
                ]
            },
            {
                "id": 2763,
                "name": "Upper Demerara-Berbice",
                "iso2": "UD",
                "latitude": "5.30648790",
                "longitude": "-58.18929210",
                "type": "region",
                "cities": [
                    {
                        "id": 53825,
                        "name": "Linden",
                        "latitude": "6.00809000",
                        "longitude": "-58.30714000"
                    }
                ]
            },
            {
                "id": 2769,
                "name": "Upper Takutu-Upper Essequibo",
                "iso2": "UT",
                "latitude": "2.92395950",
                "longitude": "-58.73736340",
                "type": "region",
                "cities": [
                    {
                        "id": 53824,
                        "name": "Lethem",
                        "latitude": "3.38333000",
                        "longitude": "-59.80000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 95,
        "name": "Haiti",
        "iso3": "HTI",
        "iso2": "HT",
        "numeric_code": "332",
        "phonecode": "509",
        "capital": "Port-au-Prince",
        "currency": "HTG",
        "currency_name": "Haitian gourde",
        "currency_symbol": "G",
        "tld": ".ht",
        "native": "Haïti",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Haitian",
        "timezones": [
            {
                "zoneName": "America\/Port-au-Prince",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Haiti",
            "ko": "아이티",
            "pt-BR": "Haiti",
            "pt": "Haiti",
            "nl": "Haïti",
            "hr": "Haiti",
            "fa": "هائیتی",
            "de": "Haiti",
            "es": "Haiti",
            "fr": "Haïti",
            "ja": "ハイチ",
            "it": "Haiti",
            "zh-CN": "海地",
            "tr": "Haiti",
            "ru": "Гаити",
            "uk": "Гаїті",
            "pl": "Haiti"
        },
        "latitude": "19.00000000",
        "longitude": "-72.41666666",
        "emoji": "🇭🇹",
        "emojiU": "U+1F1ED U+1F1F9",
        "states": [
            {
                "id": 4123,
                "name": "Artibonite",
                "iso2": "AR",
                "latitude": "19.36290200",
                "longitude": "-72.42581450",
                "type": "department",
                "cities": [
                    {
                        "id": 55046,
                        "name": "Anse Rouge",
                        "latitude": "19.63382000",
                        "longitude": "-73.05530000"
                    },
                    {
                        "id": 55064,
                        "name": "Arrondissement de Saint-Marc",
                        "latitude": "19.00000000",
                        "longitude": "-72.50000000"
                    },
                    {
                        "id": 55094,
                        "name": "Désarmes",
                        "latitude": "18.99345000",
                        "longitude": "-72.39058000"
                    },
                    {
                        "id": 55091,
                        "name": "Dessalines",
                        "latitude": "19.26177000",
                        "longitude": "-72.51611000"
                    },
                    {
                        "id": 55095,
                        "name": "Ennery",
                        "latitude": "19.48342000",
                        "longitude": "-72.48537000"
                    },
                    {
                        "id": 55102,
                        "name": "Gonaïves",
                        "latitude": "19.44755000",
                        "longitude": "-72.68928000"
                    },
                    {
                        "id": 55104,
                        "name": "Grande Saline",
                        "latitude": "19.26513000",
                        "longitude": "-72.76897000"
                    },
                    {
                        "id": 55107,
                        "name": "Gros Morne",
                        "latitude": "19.67080000",
                        "longitude": "-72.67808000"
                    },
                    {
                        "id": 55126,
                        "name": "Marmelade",
                        "latitude": "19.51736000",
                        "longitude": "-72.36133000"
                    },
                    {
                        "id": 55155,
                        "name": "Saint-Marc",
                        "latitude": "19.10819000",
                        "longitude": "-72.69379000"
                    },
                    {
                        "id": 55166,
                        "name": "Verrettes",
                        "latitude": "19.05050000",
                        "longitude": "-72.46585000"
                    }
                ]
            },
            {
                "id": 4125,
                "name": "Centre",
                "iso2": "CE",
                "latitude": "32.83702510",
                "longitude": "-96.77738820",
                "type": "department",
                "cities": [
                    {
                        "id": 55054,
                        "name": "Arrondissement de Cerca La Source",
                        "latitude": "19.11667000",
                        "longitude": "-71.75000000"
                    },
                    {
                        "id": 55082,
                        "name": "Cerca la Source",
                        "latitude": "19.16696000",
                        "longitude": "-71.79015000"
                    },
                    {
                        "id": 55108,
                        "name": "Hinche",
                        "latitude": "19.15000000",
                        "longitude": "-72.01667000"
                    },
                    {
                        "id": 55117,
                        "name": "Lascahobas",
                        "latitude": "18.83047000",
                        "longitude": "-71.93563000"
                    },
                    {
                        "id": 55127,
                        "name": "Mayisad",
                        "latitude": "19.17607000",
                        "longitude": "-72.13958000"
                    },
                    {
                        "id": 55130,
                        "name": "Mirebalais",
                        "latitude": "18.83455000",
                        "longitude": "-72.10480000"
                    },
                    {
                        "id": 55158,
                        "name": "Thomassique",
                        "latitude": "19.08209000",
                        "longitude": "-71.83855000"
                    },
                    {
                        "id": 55160,
                        "name": "Thomonde",
                        "latitude": "19.01730000",
                        "longitude": "-71.96235000"
                    }
                ]
            },
            {
                "id": 4119,
                "name": "Grand'Anse",
                "iso2": "GA",
                "latitude": "12.01666670",
                "longitude": "-61.76666670",
                "type": "department",
                "cities": [
                    {
                        "id": 55049,
                        "name": "Anse-à-Veau",
                        "latitude": "18.50110000",
                        "longitude": "-73.34490000"
                    },
                    {
                        "id": 55083,
                        "name": "Chambellan",
                        "latitude": "18.55037000",
                        "longitude": "-74.31317000"
                    },
                    {
                        "id": 55086,
                        "name": "Corail",
                        "latitude": "18.56766000",
                        "longitude": "-73.88942000"
                    },
                    {
                        "id": 55089,
                        "name": "Dame-Marie",
                        "latitude": "18.56107000",
                        "longitude": "-74.42167000"
                    },
                    {
                        "id": 55111,
                        "name": "Jeremi",
                        "latitude": "18.58333000",
                        "longitude": "-74.20000000"
                    },
                    {
                        "id": 55112,
                        "name": "Jérémie",
                        "latitude": "18.65000000",
                        "longitude": "-74.11667000"
                    },
                    {
                        "id": 55119,
                        "name": "Les Abricots",
                        "latitude": "18.64901000",
                        "longitude": "-74.30786000"
                    },
                    {
                        "id": 55122,
                        "name": "Les Irois",
                        "latitude": "18.40490000",
                        "longitude": "-74.45280000"
                    },
                    {
                        "id": 55132,
                        "name": "Moron",
                        "latitude": "18.56039000",
                        "longitude": "-74.25777000"
                    },
                    {
                        "id": 55139,
                        "name": "Petite Rivière de Nippes",
                        "latitude": "18.47611000",
                        "longitude": "-73.23495000"
                    }
                ]
            },
            {
                "id": 4118,
                "name": "Nippes",
                "iso2": "NI",
                "latitude": "18.39907350",
                "longitude": "-73.41802110",
                "type": "department",
                "cities": [
                    {
                        "id": 55045,
                        "name": "Ansavo",
                        "latitude": "18.41667000",
                        "longitude": "-73.50000000"
                    },
                    {
                        "id": 55072,
                        "name": "Baradères",
                        "latitude": "18.48255000",
                        "longitude": "-73.63884000"
                    },
                    {
                        "id": 55129,
                        "name": "Miragoâne",
                        "latitude": "18.44599000",
                        "longitude": "-73.08957000"
                    },
                    {
                        "id": 55137,
                        "name": "Petit Trou de Nippes",
                        "latitude": "18.52535000",
                        "longitude": "-73.50815000"
                    }
                ]
            },
            {
                "id": 4117,
                "name": "Nord",
                "iso2": "ND",
                "latitude": "43.19052600",
                "longitude": "-89.43792100",
                "type": "department",
                "cities": [
                    {
                        "id": 55044,
                        "name": "Acul du Nord",
                        "latitude": "19.66667000",
                        "longitude": "-72.28333000"
                    },
                    {
                        "id": 55065,
                        "name": "Arrondissement de la Grande Rivière du Nord",
                        "latitude": "19.51667000",
                        "longitude": "-72.16667000"
                    },
                    {
                        "id": 55059,
                        "name": "Arrondissement de Plaisance",
                        "latitude": "19.66756000",
                        "longitude": "-72.54908000"
                    },
                    {
                        "id": 55067,
                        "name": "Arrondissement du Borgne",
                        "latitude": "19.75000000",
                        "longitude": "-72.50000000"
                    },
                    {
                        "id": 55070,
                        "name": "Bahon",
                        "latitude": "19.46959000",
                        "longitude": "-72.11466000"
                    },
                    {
                        "id": 55075,
                        "name": "Borgne",
                        "latitude": "19.84507000",
                        "longitude": "-72.52349000"
                    },
                    {
                        "id": 55092,
                        "name": "Dondon",
                        "latitude": "19.52734000",
                        "longitude": "-72.24337000"
                    },
                    {
                        "id": 55103,
                        "name": "Grande Rivière du Nord",
                        "latitude": "19.57744000",
                        "longitude": "-72.16872000"
                    },
                    {
                        "id": 55118,
                        "name": "Lenbe",
                        "latitude": "19.70603000",
                        "longitude": "-72.40336000"
                    },
                    {
                        "id": 55123,
                        "name": "Limonade",
                        "latitude": "19.67014000",
                        "longitude": "-72.12430000"
                    },
                    {
                        "id": 55128,
                        "name": "Milot",
                        "latitude": "19.60837000",
                        "longitude": "-72.21319000"
                    },
                    {
                        "id": 55134,
                        "name": "Okap",
                        "latitude": "19.75938000",
                        "longitude": "-72.19815000"
                    },
                    {
                        "id": 55141,
                        "name": "Pignon",
                        "latitude": "19.33594000",
                        "longitude": "-72.11662000"
                    },
                    {
                        "id": 55142,
                        "name": "Pilate",
                        "latitude": "19.66745000",
                        "longitude": "-72.55229000"
                    },
                    {
                        "id": 55143,
                        "name": "Plaine du Nord",
                        "latitude": "19.67707000",
                        "longitude": "-72.26969000"
                    },
                    {
                        "id": 55144,
                        "name": "Plaisance",
                        "latitude": "19.59795000",
                        "longitude": "-72.46994000"
                    },
                    {
                        "id": 55145,
                        "name": "Port-Margot",
                        "latitude": "19.75180000",
                        "longitude": "-72.43006000"
                    },
                    {
                        "id": 55150,
                        "name": "Quartier Morin",
                        "latitude": "19.69696000",
                        "longitude": "-72.15712000"
                    },
                    {
                        "id": 55151,
                        "name": "Ranquitte",
                        "latitude": "19.41327000",
                        "longitude": "-72.08077000"
                    },
                    {
                        "id": 55156,
                        "name": "Saint-Raphaël",
                        "latitude": "19.43877000",
                        "longitude": "-72.19910000"
                    }
                ]
            },
            {
                "id": 4121,
                "name": "Nord-Est",
                "iso2": "NE",
                "latitude": "19.48897230",
                "longitude": "-71.85713310",
                "type": "department",
                "cities": [
                    {
                        "id": 55056,
                        "name": "Arrondissement de Fort Liberté",
                        "latitude": "19.56667000",
                        "longitude": "-71.83333000"
                    },
                    {
                        "id": 55069,
                        "name": "Arrondissement du Trou du Nord",
                        "latitude": "19.55000000",
                        "longitude": "-71.98333000"
                    },
                    {
                        "id": 55077,
                        "name": "Caracol",
                        "latitude": "19.69274000",
                        "longitude": "-72.01733000"
                    },
                    {
                        "id": 55078,
                        "name": "Carice",
                        "latitude": "19.37795000",
                        "longitude": "-71.83030000"
                    },
                    {
                        "id": 55093,
                        "name": "Dérac",
                        "latitude": "19.65476000",
                        "longitude": "-71.81451000"
                    },
                    {
                        "id": 55096,
                        "name": "Ferrier",
                        "latitude": "19.61549000",
                        "longitude": "-71.77792000"
                    },
                    {
                        "id": 55101,
                        "name": "Fort Liberté",
                        "latitude": "19.66273000",
                        "longitude": "-71.83798000"
                    },
                    {
                        "id": 55131,
                        "name": "Montòrganize",
                        "latitude": "19.40815000",
                        "longitude": "-71.78132000"
                    },
                    {
                        "id": 55135,
                        "name": "Ouanaminthe",
                        "latitude": "19.54934000",
                        "longitude": "-71.72475000"
                    },
                    {
                        "id": 55136,
                        "name": "Perches",
                        "latitude": "19.52201000",
                        "longitude": "-71.92323000"
                    },
                    {
                        "id": 55140,
                        "name": "Phaëton",
                        "latitude": "19.67525000",
                        "longitude": "-71.89691000"
                    },
                    {
                        "id": 55165,
                        "name": "Trou du Nord",
                        "latitude": "19.61668000",
                        "longitude": "-72.02442000"
                    },
                    {
                        "id": 55167,
                        "name": "Wanament",
                        "latitude": "19.48333000",
                        "longitude": "-71.76667000"
                    }
                ]
            },
            {
                "id": 4126,
                "name": "Nord-Ouest",
                "iso2": "NO",
                "latitude": "19.83740090",
                "longitude": "-73.04052770",
                "type": "department",
                "cities": [
                    {
                        "id": 55051,
                        "name": "Arcahaie",
                        "latitude": "19.81667000",
                        "longitude": "-72.91667000"
                    },
                    {
                        "id": 55062,
                        "name": "Arrondissement de Port-de-Paix",
                        "latitude": "19.83333000",
                        "longitude": "-72.88333000"
                    },
                    {
                        "id": 55063,
                        "name": "Arrondissement de Saint-Louis du Nord",
                        "latitude": "19.85000000",
                        "longitude": "-72.66667000"
                    },
                    {
                        "id": 55068,
                        "name": "Arrondissement du Môle Saint-Nicolas",
                        "latitude": "19.75000000",
                        "longitude": "-73.25000000"
                    },
                    {
                        "id": 55071,
                        "name": "Baie de Henne",
                        "latitude": "19.66307000",
                        "longitude": "-73.20943000"
                    },
                    {
                        "id": 55074,
                        "name": "Bombardopolis",
                        "latitude": "19.69142000",
                        "longitude": "-73.33769000"
                    },
                    {
                        "id": 55097,
                        "name": "Fond Bassin Bleu",
                        "latitude": "19.79445000",
                        "longitude": "-72.79949000"
                    },
                    {
                        "id": 55110,
                        "name": "Jean-Rabel",
                        "latitude": "19.85379000",
                        "longitude": "-73.19131000"
                    },
                    {
                        "id": 55133,
                        "name": "Môle Saint-Nicolas",
                        "latitude": "19.80700000",
                        "longitude": "-73.37605000"
                    },
                    {
                        "id": 55138,
                        "name": "Petite Anse",
                        "latitude": "19.63011000",
                        "longitude": "-73.15499000"
                    },
                    {
                        "id": 55147,
                        "name": "Port-de-Paix",
                        "latitude": "19.93984000",
                        "longitude": "-72.83037000"
                    },
                    {
                        "id": 55153,
                        "name": "Saint-Louis du Nord",
                        "latitude": "19.93397000",
                        "longitude": "-72.72138000"
                    },
                    {
                        "id": 55161,
                        "name": "Ti Port-de-Paix",
                        "latitude": "19.93333000",
                        "longitude": "-72.83333000"
                    }
                ]
            },
            {
                "id": 4120,
                "name": "Ouest",
                "iso2": "OU",
                "latitude": "45.45472490",
                "longitude": "-73.65023650",
                "type": "department",
                "cities": [
                    {
                        "id": 55047,
                        "name": "Anse à Galets",
                        "latitude": "18.83449000",
                        "longitude": "-72.86644000"
                    },
                    {
                        "id": 55052,
                        "name": "Arcahaie",
                        "latitude": "18.83333000",
                        "longitude": "-72.41667000"
                    },
                    {
                        "id": 55055,
                        "name": "Arrondissement de Croix des Bouquets",
                        "latitude": "18.48333000",
                        "longitude": "-72.01667000"
                    },
                    {
                        "id": 55058,
                        "name": "Arrondissement de Léogâne",
                        "latitude": "18.41667000",
                        "longitude": "-72.75000000"
                    },
                    {
                        "id": 55061,
                        "name": "Arrondissement de Port-au-Prince",
                        "latitude": "18.50000000",
                        "longitude": "-72.36667000"
                    },
                    {
                        "id": 55076,
                        "name": "Cabaret",
                        "latitude": "18.73582000",
                        "longitude": "-72.41929000"
                    },
                    {
                        "id": 55079,
                        "name": "Carrefour",
                        "latitude": "18.54114000",
                        "longitude": "-72.39922000"
                    },
                    {
                        "id": 55087,
                        "name": "Cornillon",
                        "latitude": "18.67546000",
                        "longitude": "-71.95271000"
                    },
                    {
                        "id": 55088,
                        "name": "Croix-des-Bouquets",
                        "latitude": "18.57677000",
                        "longitude": "-72.22625000"
                    },
                    {
                        "id": 55090,
                        "name": "Delmas 73",
                        "latitude": "18.54472000",
                        "longitude": "-72.30278000"
                    },
                    {
                        "id": 55098,
                        "name": "Fond Parisien",
                        "latitude": "18.50547000",
                        "longitude": "-71.98122000"
                    },
                    {
                        "id": 55100,
                        "name": "Fonds Verrettes",
                        "latitude": "18.39566000",
                        "longitude": "-71.85634000"
                    },
                    {
                        "id": 55105,
                        "name": "Grangwav",
                        "latitude": "18.42590000",
                        "longitude": "-72.76995000"
                    },
                    {
                        "id": 55106,
                        "name": "Gressier",
                        "latitude": "18.54091000",
                        "longitude": "-72.52679000"
                    },
                    {
                        "id": 55113,
                        "name": "Kenscoff",
                        "latitude": "18.44773000",
                        "longitude": "-72.28398000"
                    },
                    {
                        "id": 55116,
                        "name": "Lagonav",
                        "latitude": "18.85000000",
                        "longitude": "-73.05000000"
                    },
                    {
                        "id": 55124,
                        "name": "Léogâne",
                        "latitude": "18.51110000",
                        "longitude": "-72.63343000"
                    },
                    {
                        "id": 55149,
                        "name": "Pétionville",
                        "latitude": "18.51250000",
                        "longitude": "-72.28528000"
                    },
                    {
                        "id": 55146,
                        "name": "Port-au-Prince",
                        "latitude": "18.54349000",
                        "longitude": "-72.33881000"
                    },
                    {
                        "id": 55159,
                        "name": "Thomazeau",
                        "latitude": "18.65297000",
                        "longitude": "-72.09391000"
                    },
                    {
                        "id": 55163,
                        "name": "Tigwav",
                        "latitude": "18.43117000",
                        "longitude": "-72.86521000"
                    }
                ]
            },
            {
                "id": 4122,
                "name": "Sud",
                "iso2": "SD",
                "latitude": "29.92132480",
                "longitude": "-90.09737720",
                "type": "department",
                "cities": [
                    {
                        "id": 55050,
                        "name": "Aquin",
                        "latitude": "18.27974000",
                        "longitude": "-73.39433000"
                    },
                    {
                        "id": 55060,
                        "name": "Arrondissement de Port-Salut",
                        "latitude": "18.13333000",
                        "longitude": "-73.90000000"
                    },
                    {
                        "id": 55066,
                        "name": "Arrondissement des Cayes",
                        "latitude": "18.30000000",
                        "longitude": "-73.83333000"
                    },
                    {
                        "id": 55080,
                        "name": "Cavaillon",
                        "latitude": "18.29987000",
                        "longitude": "-73.65455000"
                    },
                    {
                        "id": 55084,
                        "name": "Chantal",
                        "latitude": "18.20169000",
                        "longitude": "-73.88957000"
                    },
                    {
                        "id": 55085,
                        "name": "Chardonnière",
                        "latitude": "18.27484000",
                        "longitude": "-74.16613000"
                    },
                    {
                        "id": 55099,
                        "name": "Fond des Blancs",
                        "latitude": "18.27782000",
                        "longitude": "-73.12733000"
                    },
                    {
                        "id": 55115,
                        "name": "Koto",
                        "latitude": "18.20601000",
                        "longitude": "-74.04013000"
                    },
                    {
                        "id": 55120,
                        "name": "Les Anglais",
                        "latitude": "18.30540000",
                        "longitude": "-74.21968000"
                    },
                    {
                        "id": 55121,
                        "name": "Les Cayes",
                        "latitude": "18.19331000",
                        "longitude": "-73.74601000"
                    },
                    {
                        "id": 55148,
                        "name": "Port-à-Piment",
                        "latitude": "18.24963000",
                        "longitude": "-74.09710000"
                    },
                    {
                        "id": 55152,
                        "name": "Roche-à-Bateau",
                        "latitude": "18.18182000",
                        "longitude": "-74.00345000"
                    },
                    {
                        "id": 55154,
                        "name": "Saint-Louis du Sud",
                        "latitude": "18.26241000",
                        "longitude": "-73.54603000"
                    },
                    {
                        "id": 55162,
                        "name": "Tiburon",
                        "latitude": "18.32589000",
                        "longitude": "-74.39598000"
                    },
                    {
                        "id": 55164,
                        "name": "Torbeck",
                        "latitude": "18.16338000",
                        "longitude": "-73.80949000"
                    }
                ]
            },
            {
                "id": 4124,
                "name": "Sud-Est",
                "iso2": "SE",
                "latitude": "18.27835980",
                "longitude": "-72.35479150",
                "type": "department",
                "cities": [
                    {
                        "id": 55048,
                        "name": "Anse-à-Pitre",
                        "latitude": "18.05000000",
                        "longitude": "-71.75000000"
                    },
                    {
                        "id": 55053,
                        "name": "Arrondissement de Bainet",
                        "latitude": "18.25000000",
                        "longitude": "-72.85000000"
                    },
                    {
                        "id": 55057,
                        "name": "Arrondissement de Jacmel",
                        "latitude": "18.33333000",
                        "longitude": "-72.50000000"
                    },
                    {
                        "id": 55073,
                        "name": "Belle-Anse",
                        "latitude": "18.23768000",
                        "longitude": "-72.06638000"
                    },
                    {
                        "id": 55081,
                        "name": "Cayes-Jacmel",
                        "latitude": "18.23110000",
                        "longitude": "-72.39545000"
                    },
                    {
                        "id": 55109,
                        "name": "Jacmel",
                        "latitude": "18.23427000",
                        "longitude": "-72.53539000"
                    },
                    {
                        "id": 55114,
                        "name": "Kotdefè",
                        "latitude": "18.18872000",
                        "longitude": "-73.00287000"
                    },
                    {
                        "id": 55125,
                        "name": "Marigot",
                        "latitude": "18.23167000",
                        "longitude": "-72.32289000"
                    },
                    {
                        "id": 55157,
                        "name": "Thiotte",
                        "latitude": "18.24384000",
                        "longitude": "-71.84157000"
                    }
                ]
            }
        ]
    },
    {
        "id": 96,
        "name": "Heard Island and McDonald Islands",
        "iso3": "HMD",
        "iso2": "HM",
        "numeric_code": "334",
        "phonecode": "672",
        "capital": "",
        "currency": "AUD",
        "currency_name": "Australian dollar",
        "currency_symbol": "$",
        "tld": ".hm",
        "native": "Heard Island and McDonald Islands",
        "region": "",
        "region_id": 0,
        "subregion": "",
        "subregion_id": 0,
        "nationality": "Heard Island or McDonald Islands",
        "timezones": [
            {
                "zoneName": "Indian\/Kerguelen",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "TFT",
                "tzName": "French Southern and Antarctic Time"
            }
        ],
        "translations": {
            "br": "Inizi Heard ha McDonald",
            "ko": "허드 맥도날드 제도",
            "pt-BR": "Ilha Heard e Ilhas McDonald",
            "pt": "Ilha Heard e Ilhas McDonald",
            "nl": "Heard- en McDonaldeilanden",
            "hr": "Otok Heard i otočje McDonald",
            "fa": "جزیره هرد و جزایر مک‌دونالد",
            "de": "Heard und die McDonaldinseln",
            "es": "Islas Heard y McDonald",
            "fr": "Îles Heard-et-MacDonald",
            "ja": "ハード島とマクドナルド諸島",
            "it": "Isole Heard e McDonald",
            "zh-CN": "赫德·唐纳岛及麦唐纳岛",
            "tr": "Heard Adasi Ve Mcdonald Adalari",
            "ru": "Остров Херд и острова Макдональд",
            "uk": "Острів Херд та острови Макдональд",
            "pl": "Wyspa Heard i Wyspy McDonalda"
        },
        "latitude": "-53.10000000",
        "longitude": "72.51666666",
        "emoji": "🇭🇲",
        "emojiU": "U+1F1ED U+1F1F2",
        "states": []
    },
    {
        "id": 97,
        "name": "Honduras",
        "iso3": "HND",
        "iso2": "HN",
        "numeric_code": "340",
        "phonecode": "504",
        "capital": "Tegucigalpa",
        "currency": "HNL",
        "currency_name": "Honduran lempira",
        "currency_symbol": "L",
        "tld": ".hn",
        "native": "Honduras",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Central America",
        "subregion_id": 9,
        "nationality": "Honduran",
        "timezones": [
            {
                "zoneName": "America\/Tegucigalpa",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Honduras",
            "ko": "온두라스",
            "pt-BR": "Honduras",
            "pt": "Honduras",
            "nl": "Honduras",
            "hr": "Honduras",
            "fa": "هندوراس",
            "de": "Honduras",
            "es": "Honduras",
            "fr": "Honduras",
            "ja": "ホンジュラス",
            "it": "Honduras",
            "zh-CN": "洪都拉斯",
            "tr": "Honduras",
            "ru": "Гондурас",
            "uk": "Гондурас",
            "pl": "Honduras"
        },
        "latitude": "15.00000000",
        "longitude": "-86.50000000",
        "emoji": "🇭🇳",
        "emojiU": "U+1F1ED U+1F1F3",
        "states": [
            {
                "id": 4047,
                "name": "Atlántida",
                "iso2": "AT",
                "latitude": "15.66962830",
                "longitude": "-87.14228950",
                "type": "department",
                "cities": [
                    {
                        "id": 53857,
                        "name": "Arizona",
                        "latitude": "15.63333000",
                        "longitude": "-87.31667000"
                    },
                    {
                        "id": 53860,
                        "name": "Atenas de San Cristóbal",
                        "latitude": "15.68333000",
                        "longitude": "-87.31667000"
                    },
                    {
                        "id": 53921,
                        "name": "Corozal",
                        "latitude": "15.80000000",
                        "longitude": "-86.71667000"
                    },
                    {
                        "id": 53974,
                        "name": "El Pino",
                        "latitude": "15.70000000",
                        "longitude": "-86.93333000"
                    },
                    {
                        "id": 53976,
                        "name": "El Porvenir",
                        "latitude": "15.75000000",
                        "longitude": "-86.93333000"
                    },
                    {
                        "id": 53995,
                        "name": "El Triunfo de la Cruz",
                        "latitude": "15.76667000",
                        "longitude": "-87.43333000"
                    },
                    {
                        "id": 54001,
                        "name": "Esparta",
                        "latitude": "15.66291000",
                        "longitude": "-87.25622000"
                    },
                    {
                        "id": 54041,
                        "name": "Jutiapa",
                        "latitude": "15.69586000",
                        "longitude": "-86.50414000"
                    },
                    {
                        "id": 54048,
                        "name": "La Ceiba",
                        "latitude": "15.75971000",
                        "longitude": "-86.78221000"
                    },
                    {
                        "id": 54071,
                        "name": "La Masica",
                        "latitude": "15.59865000",
                        "longitude": "-87.13500000"
                    },
                    {
                        "id": 54080,
                        "name": "La Unión",
                        "latitude": "15.71667000",
                        "longitude": "-87.00000000"
                    },
                    {
                        "id": 54127,
                        "name": "Mezapa",
                        "latitude": "15.58333000",
                        "longitude": "-87.65000000"
                    },
                    {
                        "id": 54145,
                        "name": "Nueva Armenia",
                        "latitude": "15.79556000",
                        "longitude": "-86.49845000"
                    },
                    {
                        "id": 54208,
                        "name": "Sambo Creek",
                        "latitude": "15.81667000",
                        "longitude": "-86.68333000"
                    },
                    {
                        "id": 54212,
                        "name": "San Antonio",
                        "latitude": "15.60000000",
                        "longitude": "-87.15000000"
                    },
                    {
                        "id": 54226,
                        "name": "San Francisco",
                        "latitude": "15.65246000",
                        "longitude": "-87.01736000"
                    },
                    {
                        "id": 54259,
                        "name": "San Juan Pueblo",
                        "latitude": "15.58333000",
                        "longitude": "-87.23333000"
                    },
                    {
                        "id": 54290,
                        "name": "Santa Ana",
                        "latitude": "15.65000000",
                        "longitude": "-87.06667000"
                    },
                    {
                        "id": 54334,
                        "name": "Tela",
                        "latitude": "15.77425000",
                        "longitude": "-87.46731000"
                    },
                    {
                        "id": 54341,
                        "name": "Tornabé",
                        "latitude": "15.75000000",
                        "longitude": "-87.55000000"
                    }
                ]
            },
            {
                "id": 4045,
                "name": "Bay Islands",
                "iso2": "IB",
                "latitude": "16.48266140",
                "longitude": "-85.87932520",
                "type": "department",
                "cities": [
                    {
                        "id": 53925,
                        "name": "Coxen Hole",
                        "latitude": "16.31759000",
                        "longitude": "-86.53793000"
                    },
                    {
                        "id": 54008,
                        "name": "French Harbor",
                        "latitude": "16.35000000",
                        "longitude": "-86.43333000"
                    },
                    {
                        "id": 54019,
                        "name": "Guanaja",
                        "latitude": "16.44795000",
                        "longitude": "-85.89431000"
                    },
                    {
                        "id": 54038,
                        "name": "José Santos Guardiola",
                        "latitude": "16.41765000",
                        "longitude": "-86.30631000"
                    },
                    {
                        "id": 54197,
                        "name": "Roatán",
                        "latitude": "16.34098000",
                        "longitude": "-86.53763000"
                    },
                    {
                        "id": 54289,
                        "name": "Sandy Bay",
                        "latitude": "16.32923000",
                        "longitude": "-86.56446000"
                    },
                    {
                        "id": 54315,
                        "name": "Savannah Bight",
                        "latitude": "16.45000000",
                        "longitude": "-85.85000000"
                    },
                    {
                        "id": 54351,
                        "name": "Utila",
                        "latitude": "16.10026000",
                        "longitude": "-86.93070000"
                    }
                ]
            },
            {
                "id": 4041,
                "name": "Choluteca",
                "iso2": "CH",
                "latitude": "13.25043250",
                "longitude": "-87.14228950",
                "type": "department",
                "cities": [
                    {
                        "id": 53851,
                        "name": "Apacilagua",
                        "latitude": "13.45821000",
                        "longitude": "-87.01122000"
                    },
                    {
                        "id": 53901,
                        "name": "Choluteca",
                        "latitude": "13.28261000",
                        "longitude": "-87.20119000"
                    },
                    {
                        "id": 53903,
                        "name": "Ciudad Choluteca",
                        "latitude": "13.30028000",
                        "longitude": "-87.19083000"
                    },
                    {
                        "id": 53913,
                        "name": "Concepción de María",
                        "latitude": "13.22363000",
                        "longitude": "-86.96244000"
                    },
                    {
                        "id": 53922,
                        "name": "Corpus",
                        "latitude": "13.28889000",
                        "longitude": "-87.03472000"
                    },
                    {
                        "id": 53939,
                        "name": "Duyure",
                        "latitude": "13.63333000",
                        "longitude": "-86.81667000"
                    },
                    {
                        "id": 53949,
                        "name": "El Corpus",
                        "latitude": "13.30464000",
                        "longitude": "-87.00970000"
                    },
                    {
                        "id": 53965,
                        "name": "El Obraje",
                        "latitude": "13.15417000",
                        "longitude": "-87.13083000"
                    },
                    {
                        "id": 53981,
                        "name": "El Puente",
                        "latitude": "13.28333000",
                        "longitude": "-87.11667000"
                    },
                    {
                        "id": 53994,
                        "name": "El Triunfo",
                        "latitude": "13.08024000",
                        "longitude": "-87.01780000"
                    },
                    {
                        "id": 54108,
                        "name": "Los Llanitos",
                        "latitude": "13.28694000",
                        "longitude": "-87.33444000"
                    },
                    {
                        "id": 54121,
                        "name": "Marcovia",
                        "latitude": "13.28806000",
                        "longitude": "-87.30972000"
                    },
                    {
                        "id": 54131,
                        "name": "Monjarás",
                        "latitude": "13.20056000",
                        "longitude": "-87.37417000"
                    },
                    {
                        "id": 54135,
                        "name": "Morolica",
                        "latitude": "13.56800000",
                        "longitude": "-86.88821000"
                    },
                    {
                        "id": 54141,
                        "name": "Namasigüe",
                        "latitude": "13.20472000",
                        "longitude": "-87.13889000"
                    },
                    {
                        "id": 54162,
                        "name": "Orocuina",
                        "latitude": "13.48167000",
                        "longitude": "-87.10500000"
                    },
                    {
                        "id": 54168,
                        "name": "Pespire",
                        "latitude": "13.59222000",
                        "longitude": "-87.36167000"
                    },
                    {
                        "id": 54216,
                        "name": "San Antonio de Flores",
                        "latitude": "13.64152000",
                        "longitude": "-87.34075000"
                    },
                    {
                        "id": 54237,
                        "name": "San Isidro",
                        "latitude": "13.64454000",
                        "longitude": "-87.26093000"
                    },
                    {
                        "id": 54239,
                        "name": "San Jerónimo",
                        "latitude": "13.17667000",
                        "longitude": "-87.13639000"
                    },
                    {
                        "id": 54247,
                        "name": "San José",
                        "latitude": "13.71415000",
                        "longitude": "-87.42256000"
                    },
                    {
                        "id": 54251,
                        "name": "San José de Las Conchas",
                        "latitude": "13.32528000",
                        "longitude": "-87.39556000"
                    },
                    {
                        "id": 54273,
                        "name": "San Marcos de Colón",
                        "latitude": "13.41512000",
                        "longitude": "-86.82095000"
                    },
                    {
                        "id": 54293,
                        "name": "Santa Ana de Yusguare",
                        "latitude": "13.30056000",
                        "longitude": "-87.11389000"
                    },
                    {
                        "id": 54295,
                        "name": "Santa Cruz",
                        "latitude": "13.25806000",
                        "longitude": "-87.34833000"
                    }
                ]
            },
            {
                "id": 4051,
                "name": "Colón",
                "iso2": "CL",
                "latitude": "15.64259650",
                "longitude": "-85.52002400",
                "type": "department",
                "cities": [
                    {
                        "id": 53867,
                        "name": "Balfate",
                        "latitude": "15.75709000",
                        "longitude": "-86.29048000"
                    },
                    {
                        "id": 53874,
                        "name": "Bonito Oriental",
                        "latitude": "15.74641000",
                        "longitude": "-85.73610000"
                    },
                    {
                        "id": 53920,
                        "name": "Corocito",
                        "latitude": "15.75000000",
                        "longitude": "-85.78333000"
                    },
                    {
                        "id": 53929,
                        "name": "Cusuna",
                        "latitude": "15.85000000",
                        "longitude": "-85.23333000"
                    },
                    {
                        "id": 53999,
                        "name": "Elíxir",
                        "latitude": "15.48333000",
                        "longitude": "-86.30000000"
                    },
                    {
                        "id": 54006,
                        "name": "Francia",
                        "latitude": "15.85000000",
                        "longitude": "-85.58333000"
                    },
                    {
                        "id": 54029,
                        "name": "Iriona",
                        "latitude": "15.59079000",
                        "longitude": "-85.20549000"
                    },
                    {
                        "id": 54033,
                        "name": "Jericó",
                        "latitude": "15.95000000",
                        "longitude": "-85.96667000"
                    },
                    {
                        "id": 54046,
                        "name": "La Brea",
                        "latitude": "15.80000000",
                        "longitude": "-85.96667000"
                    },
                    {
                        "id": 54055,
                        "name": "La Esperanza",
                        "latitude": "15.63333000",
                        "longitude": "-85.76667000"
                    },
                    {
                        "id": 54103,
                        "name": "Limón",
                        "latitude": "15.79664000",
                        "longitude": "-85.50805000"
                    },
                    {
                        "id": 54136,
                        "name": "Municipio de Sabá",
                        "latitude": "15.48654000",
                        "longitude": "-86.16322000"
                    },
                    {
                        "id": 54178,
                        "name": "Prieta",
                        "latitude": "15.58060000",
                        "longitude": "-86.13664000"
                    },
                    {
                        "id": 54183,
                        "name": "Puerto Castilla",
                        "latitude": "16.01667000",
                        "longitude": "-85.96667000"
                    },
                    {
                        "id": 54188,
                        "name": "Punta Piedra",
                        "latitude": "15.90000000",
                        "longitude": "-85.28333000"
                    },
                    {
                        "id": 54192,
                        "name": "Quebrada de Arena",
                        "latitude": "15.76667000",
                        "longitude": "-85.91667000"
                    },
                    {
                        "id": 54202,
                        "name": "Río Esteban",
                        "latitude": "15.83333000",
                        "longitude": "-86.30000000"
                    },
                    {
                        "id": 54205,
                        "name": "Sabá",
                        "latitude": "15.46667000",
                        "longitude": "-86.25000000"
                    },
                    {
                        "id": 54206,
                        "name": "Salamá",
                        "latitude": "15.75000000",
                        "longitude": "-85.96667000"
                    },
                    {
                        "id": 54302,
                        "name": "Santa Fe",
                        "latitude": "15.85424000",
                        "longitude": "-86.11083000"
                    },
                    {
                        "id": 54312,
                        "name": "Santa Rosa de Aguán",
                        "latitude": "15.95000000",
                        "longitude": "-85.71667000"
                    },
                    {
                        "id": 54321,
                        "name": "Sonaguera",
                        "latitude": "15.64000000",
                        "longitude": "-86.26000000"
                    },
                    {
                        "id": 54330,
                        "name": "Taujica",
                        "latitude": "15.70000000",
                        "longitude": "-85.91667000"
                    },
                    {
                        "id": 54339,
                        "name": "Tocoa",
                        "latitude": "15.68333000",
                        "longitude": "-86.00000000"
                    },
                    {
                        "id": 54349,
                        "name": "Trujillo",
                        "latitude": "15.91667000",
                        "longitude": "-85.95417000"
                    },
                    {
                        "id": 54378,
                        "name": "Zamora",
                        "latitude": "15.63333000",
                        "longitude": "-86.06667000"
                    }
                ]
            },
            {
                "id": 4042,
                "name": "Comayagua",
                "iso2": "CM",
                "latitude": "14.55348280",
                "longitude": "-87.61863790",
                "type": "department",
                "cities": [
                    {
                        "id": 53843,
                        "name": "Aguas del Padre",
                        "latitude": "14.56667000",
                        "longitude": "-87.88333000"
                    },
                    {
                        "id": 53845,
                        "name": "Ajuterique",
                        "latitude": "14.38333000",
                        "longitude": "-87.70000000"
                    },
                    {
                        "id": 53894,
                        "name": "Cerro Blanco",
                        "latitude": "14.66667000",
                        "longitude": "-87.78333000"
                    },
                    {
                        "id": 53908,
                        "name": "Comayagua",
                        "latitude": "14.48412000",
                        "longitude": "-87.60060000"
                    },
                    {
                        "id": 53912,
                        "name": "Concepción de Guasistagua",
                        "latitude": "14.60000000",
                        "longitude": "-87.65000000"
                    },
                    {
                        "id": 53941,
                        "name": "El Agua Dulcita",
                        "latitude": "14.70000000",
                        "longitude": "-87.75000000"
                    },
                    {
                        "id": 53978,
                        "name": "El Porvenir",
                        "latitude": "14.58333000",
                        "longitude": "-87.88333000"
                    },
                    {
                        "id": 53983,
                        "name": "El Rancho",
                        "latitude": "14.68333000",
                        "longitude": "-87.50000000"
                    },
                    {
                        "id": 53984,
                        "name": "El Rincón",
                        "latitude": "14.58333000",
                        "longitude": "-87.93333000"
                    },
                    {
                        "id": 53985,
                        "name": "El Rosario",
                        "latitude": "14.57500000",
                        "longitude": "-87.74306000"
                    },
                    {
                        "id": 53988,
                        "name": "El Sauce",
                        "latitude": "14.52850000",
                        "longitude": "-87.66571000"
                    },
                    {
                        "id": 53989,
                        "name": "El Socorro",
                        "latitude": "14.63333000",
                        "longitude": "-87.91667000"
                    },
                    {
                        "id": 54003,
                        "name": "Esquías",
                        "latitude": "14.73333000",
                        "longitude": "-87.36667000"
                    },
                    {
                        "id": 54004,
                        "name": "Flores",
                        "latitude": "14.28333000",
                        "longitude": "-87.56667000"
                    },
                    {
                        "id": 54025,
                        "name": "Humuya",
                        "latitude": "14.25000000",
                        "longitude": "-87.66667000"
                    },
                    {
                        "id": 54031,
                        "name": "Jamalteca",
                        "latitude": "14.70000000",
                        "longitude": "-87.58333000"
                    },
                    {
                        "id": 54068,
                        "name": "La Libertad",
                        "latitude": "14.88000000",
                        "longitude": "-87.55000000"
                    },
                    {
                        "id": 54079,
                        "name": "La Trinidad",
                        "latitude": "14.70000000",
                        "longitude": "-87.66286000"
                    },
                    {
                        "id": 54089,
                        "name": "Lamaní",
                        "latitude": "14.20000000",
                        "longitude": "-87.61667000"
                    },
                    {
                        "id": 54092,
                        "name": "Las Lajas",
                        "latitude": "14.90000000",
                        "longitude": "-87.58333000"
                    },
                    {
                        "id": 54100,
                        "name": "Lejamaní",
                        "latitude": "14.36667000",
                        "longitude": "-87.70000000"
                    },
                    {
                        "id": 54128,
                        "name": "Meámbar",
                        "latitude": "14.82047000",
                        "longitude": "-87.78424000"
                    },
                    {
                        "id": 54129,
                        "name": "Minas de Oro",
                        "latitude": "14.80000000",
                        "longitude": "-87.35000000"
                    },
                    {
                        "id": 54157,
                        "name": "Ojos de Agua",
                        "latitude": "14.79498000",
                        "longitude": "-87.65010000"
                    },
                    {
                        "id": 54175,
                        "name": "Potrerillos",
                        "latitude": "14.55000000",
                        "longitude": "-87.86667000"
                    },
                    {
                        "id": 54200,
                        "name": "Río Bonito",
                        "latitude": "14.76667000",
                        "longitude": "-87.88333000"
                    },
                    {
                        "id": 54219,
                        "name": "San Antonio de la Cuesta",
                        "latitude": "14.63333000",
                        "longitude": "-87.60000000"
                    },
                    {
                        "id": 54240,
                        "name": "San Jerónimo",
                        "latitude": "14.64043000",
                        "longitude": "-87.56768000"
                    },
                    {
                        "id": 54249,
                        "name": "San José de Comayagua",
                        "latitude": "14.73333000",
                        "longitude": "-88.03333000"
                    },
                    {
                        "id": 54255,
                        "name": "San José del Potrero",
                        "latitude": "14.86203000",
                        "longitude": "-87.29049000"
                    },
                    {
                        "id": 54266,
                        "name": "San Luis",
                        "latitude": "14.75000000",
                        "longitude": "-87.41667000"
                    },
                    {
                        "id": 54286,
                        "name": "San Sebastián",
                        "latitude": "14.23687000",
                        "longitude": "-87.63215000"
                    },
                    {
                        "id": 54317,
                        "name": "Siguatepeque",
                        "latitude": "14.60000000",
                        "longitude": "-87.83333000"
                    },
                    {
                        "id": 54331,
                        "name": "Taulabé",
                        "latitude": "14.67145000",
                        "longitude": "-87.98693000"
                    },
                    {
                        "id": 54355,
                        "name": "Valle de Ángeles",
                        "latitude": "14.50000000",
                        "longitude": "-87.63333000"
                    },
                    {
                        "id": 54360,
                        "name": "Villa de San Antonio",
                        "latitude": "14.31667000",
                        "longitude": "-87.61667000"
                    }
                ]
            },
            {
                "id": 4049,
                "name": "Copán",
                "iso2": "CP",
                "latitude": "14.93608380",
                "longitude": "-88.86469800",
                "type": "department",
                "cities": [
                    {
                        "id": 53839,
                        "name": "Agua Caliente",
                        "latitude": "14.88333000",
                        "longitude": "-88.81667000"
                    },
                    {
                        "id": 53876,
                        "name": "Buenos Aires",
                        "latitude": "15.03333000",
                        "longitude": "-88.96667000"
                    },
                    {
                        "id": 53878,
                        "name": "Cabañas",
                        "latitude": "14.76000000",
                        "longitude": "-89.06000000"
                    },
                    {
                        "id": 53896,
                        "name": "Chalmeca",
                        "latitude": "15.10000000",
                        "longitude": "-88.68333000"
                    },
                    {
                        "id": 53911,
                        "name": "Concepción",
                        "latitude": "14.88077000",
                        "longitude": "-88.87919000"
                    },
                    {
                        "id": 53914,
                        "name": "Concepción de la Barranca",
                        "latitude": "15.16667000",
                        "longitude": "-88.71667000"
                    },
                    {
                        "id": 53918,
                        "name": "Copán",
                        "latitude": "14.83333000",
                        "longitude": "-89.15000000"
                    },
                    {
                        "id": 53919,
                        "name": "Copán Ruinas",
                        "latitude": "14.92000000",
                        "longitude": "-89.15000000"
                    },
                    {
                        "id": 53923,
                        "name": "Corquín",
                        "latitude": "14.56667000",
                        "longitude": "-88.86667000"
                    },
                    {
                        "id": 53927,
                        "name": "Cucuyagua",
                        "latitude": "14.65000000",
                        "longitude": "-88.86667000"
                    },
                    {
                        "id": 53934,
                        "name": "Dolores",
                        "latitude": "14.86667000",
                        "longitude": "-88.83333000"
                    },
                    {
                        "id": 53937,
                        "name": "Dulce Nombre",
                        "latitude": "14.85552000",
                        "longitude": "-88.83856000"
                    },
                    {
                        "id": 53948,
                        "name": "El Corpus",
                        "latitude": "14.70000000",
                        "longitude": "-88.91667000"
                    },
                    {
                        "id": 53968,
                        "name": "El Ocotón",
                        "latitude": "15.03333000",
                        "longitude": "-88.88333000"
                    },
                    {
                        "id": 53971,
                        "name": "El Paraíso",
                        "latitude": "15.04217000",
                        "longitude": "-88.98045000"
                    },
                    {
                        "id": 54005,
                        "name": "Florida",
                        "latitude": "15.03333000",
                        "longitude": "-88.83333000"
                    },
                    {
                        "id": 54052,
                        "name": "La Entrada",
                        "latitude": "15.05000000",
                        "longitude": "-88.73333000"
                    },
                    {
                        "id": 54064,
                        "name": "La Jigua",
                        "latitude": "15.10000000",
                        "longitude": "-88.76000000"
                    },
                    {
                        "id": 54074,
                        "name": "La Playona",
                        "latitude": "15.11667000",
                        "longitude": "-88.98333000"
                    },
                    {
                        "id": 54083,
                        "name": "La Unión",
                        "latitude": "14.69350000",
                        "longitude": "-88.94734000"
                    },
                    {
                        "id": 54086,
                        "name": "La Zumbadora",
                        "latitude": "15.01667000",
                        "longitude": "-88.90000000"
                    },
                    {
                        "id": 54111,
                        "name": "Los Tangos",
                        "latitude": "15.15000000",
                        "longitude": "-88.68333000"
                    },
                    {
                        "id": 54144,
                        "name": "Nueva Arcadia",
                        "latitude": "15.08000000",
                        "longitude": "-88.69000000"
                    },
                    {
                        "id": 54156,
                        "name": "Ojos de Agua",
                        "latitude": "14.70000000",
                        "longitude": "-88.81667000"
                    },
                    {
                        "id": 54181,
                        "name": "Pueblo Nuevo",
                        "latitude": "15.00000000",
                        "longitude": "-88.75000000"
                    },
                    {
                        "id": 54194,
                        "name": "Quezailica",
                        "latitude": "14.88333000",
                        "longitude": "-88.73333000"
                    },
                    {
                        "id": 54209,
                        "name": "San Agustín",
                        "latitude": "14.81973000",
                        "longitude": "-88.93027000"
                    },
                    {
                        "id": 54214,
                        "name": "San Antonio",
                        "latitude": "15.04000000",
                        "longitude": "-88.88000000"
                    },
                    {
                        "id": 54241,
                        "name": "San Jerónimo",
                        "latitude": "14.96207000",
                        "longitude": "-88.90270000"
                    },
                    {
                        "id": 54242,
                        "name": "San Joaquín",
                        "latitude": "15.05000000",
                        "longitude": "-88.90000000"
                    },
                    {
                        "id": 54245,
                        "name": "San José",
                        "latitude": "14.91184000",
                        "longitude": "-88.71667000"
                    },
                    {
                        "id": 54250,
                        "name": "San José de Copán",
                        "latitude": "14.90000000",
                        "longitude": "-88.71667000"
                    },
                    {
                        "id": 54261,
                        "name": "San Juan de Opoa",
                        "latitude": "14.78333000",
                        "longitude": "-88.70000000"
                    },
                    {
                        "id": 54262,
                        "name": "San Juan de Planes",
                        "latitude": "14.93333000",
                        "longitude": "-88.78333000"
                    },
                    {
                        "id": 54279,
                        "name": "San Nicolás",
                        "latitude": "14.98000000",
                        "longitude": "-88.73000000"
                    },
                    {
                        "id": 54283,
                        "name": "San Pedro de Copán",
                        "latitude": "14.61667000",
                        "longitude": "-88.80000000"
                    },
                    {
                        "id": 54310,
                        "name": "Santa Rita",
                        "latitude": "14.88000000",
                        "longitude": "-89.01000000"
                    },
                    {
                        "id": 54311,
                        "name": "Santa Rita Copan",
                        "latitude": "14.86748000",
                        "longitude": "-89.10000000"
                    },
                    {
                        "id": 54313,
                        "name": "Santa Rosa de Copán",
                        "latitude": "14.76667000",
                        "longitude": "-88.77917000"
                    },
                    {
                        "id": 54346,
                        "name": "Trinidad de Copán",
                        "latitude": "14.95000000",
                        "longitude": "-88.75000000"
                    },
                    {
                        "id": 54357,
                        "name": "Veracruz",
                        "latitude": "14.88343000",
                        "longitude": "-88.78570000"
                    }
                ]
            },
            {
                "id": 4046,
                "name": "Cortés",
                "iso2": "CR",
                "latitude": "15.49235080",
                "longitude": "-88.09007620",
                "type": "department",
                "cities": [
                    {
                        "id": 53836,
                        "name": "Agua Azul",
                        "latitude": "14.91667000",
                        "longitude": "-87.96667000"
                    },
                    {
                        "id": 53837,
                        "name": "Agua Azul Rancho",
                        "latitude": "14.90000000",
                        "longitude": "-87.95000000"
                    },
                    {
                        "id": 53859,
                        "name": "Armenta",
                        "latitude": "15.50000000",
                        "longitude": "-88.05000000"
                    },
                    {
                        "id": 53866,
                        "name": "Baja Mar",
                        "latitude": "15.88851000",
                        "longitude": "-87.85547000"
                    },
                    {
                        "id": 53868,
                        "name": "Baracoa",
                        "latitude": "15.76667000",
                        "longitude": "-87.85000000"
                    },
                    {
                        "id": 53870,
                        "name": "Bejuco",
                        "latitude": "15.13333000",
                        "longitude": "-87.93333000"
                    },
                    {
                        "id": 53891,
                        "name": "Cañaveral",
                        "latitude": "14.98333000",
                        "longitude": "-88.01667000"
                    },
                    {
                        "id": 53889,
                        "name": "Casa Quemada",
                        "latitude": "15.11667000",
                        "longitude": "-88.08333000"
                    },
                    {
                        "id": 53899,
                        "name": "Chivana",
                        "latitude": "15.75000000",
                        "longitude": "-87.98333000"
                    },
                    {
                        "id": 53900,
                        "name": "Choloma",
                        "latitude": "15.64000000",
                        "longitude": "-87.92000000"
                    },
                    {
                        "id": 53902,
                        "name": "Chotepe",
                        "latitude": "15.41667000",
                        "longitude": "-87.98333000"
                    },
                    {
                        "id": 53904,
                        "name": "Cofradía",
                        "latitude": "15.40000000",
                        "longitude": "-88.15000000"
                    },
                    {
                        "id": 53931,
                        "name": "Cuyamel",
                        "latitude": "15.66667000",
                        "longitude": "-88.20000000"
                    },
                    {
                        "id": 53958,
                        "name": "El Llano",
                        "latitude": "15.15000000",
                        "longitude": "-87.88333000"
                    },
                    {
                        "id": 53960,
                        "name": "El Marañón",
                        "latitude": "15.40000000",
                        "longitude": "-88.05000000"
                    },
                    {
                        "id": 53961,
                        "name": "El Milagro",
                        "latitude": "15.40000000",
                        "longitude": "-87.96667000"
                    },
                    {
                        "id": 53969,
                        "name": "El Olivar",
                        "latitude": "15.08333000",
                        "longitude": "-87.88333000"
                    },
                    {
                        "id": 53973,
                        "name": "El Perico",
                        "latitude": "15.08333000",
                        "longitude": "-88.10000000"
                    },
                    {
                        "id": 53975,
                        "name": "El Plan",
                        "latitude": "15.28333000",
                        "longitude": "-87.96667000"
                    },
                    {
                        "id": 53977,
                        "name": "El Porvenir",
                        "latitude": "15.83333000",
                        "longitude": "-87.93333000"
                    },
                    {
                        "id": 53982,
                        "name": "El Rancho",
                        "latitude": "15.66667000",
                        "longitude": "-87.95000000"
                    },
                    {
                        "id": 53993,
                        "name": "El Tigre",
                        "latitude": "14.93333000",
                        "longitude": "-87.98333000"
                    },
                    {
                        "id": 53998,
                        "name": "El Zapotal del Norte",
                        "latitude": "15.51667000",
                        "longitude": "-88.05000000"
                    },
                    {
                        "id": 54060,
                        "name": "La Guama",
                        "latitude": "14.88333000",
                        "longitude": "-87.93333000"
                    },
                    {
                        "id": 54062,
                        "name": "La Huesa",
                        "latitude": "15.58333000",
                        "longitude": "-87.88333000"
                    },
                    {
                        "id": 54065,
                        "name": "La Jutosa",
                        "latitude": "15.63333000",
                        "longitude": "-88.00000000"
                    },
                    {
                        "id": 54070,
                        "name": "La Lima",
                        "latitude": "15.43333000",
                        "longitude": "-87.91667000"
                    },
                    {
                        "id": 54076,
                        "name": "La Sabana",
                        "latitude": "15.36667000",
                        "longitude": "-87.93333000"
                    },
                    {
                        "id": 54107,
                        "name": "Los Caminos",
                        "latitude": "14.95000000",
                        "longitude": "-87.96667000"
                    },
                    {
                        "id": 54109,
                        "name": "Los Naranjos",
                        "latitude": "14.90000000",
                        "longitude": "-88.05000000"
                    },
                    {
                        "id": 54132,
                        "name": "Monterrey",
                        "latitude": "15.58333000",
                        "longitude": "-87.88333000"
                    },
                    {
                        "id": 54152,
                        "name": "Nuevo Chamelecón",
                        "latitude": "15.38333000",
                        "longitude": "-88.01667000"
                    },
                    {
                        "id": 54159,
                        "name": "Omoa",
                        "latitude": "15.76667000",
                        "longitude": "-88.03333000"
                    },
                    {
                        "id": 54164,
                        "name": "Oropéndolas",
                        "latitude": "15.01667000",
                        "longitude": "-87.93333000"
                    },
                    {
                        "id": 54170,
                        "name": "Peña Blanca",
                        "latitude": "15.53333000",
                        "longitude": "-88.05000000"
                    },
                    {
                        "id": 54171,
                        "name": "Pimienta",
                        "latitude": "15.26500000",
                        "longitude": "-87.96667000"
                    },
                    {
                        "id": 54172,
                        "name": "Pimienta Vieja",
                        "latitude": "15.23333000",
                        "longitude": "-87.96667000"
                    },
                    {
                        "id": 54176,
                        "name": "Potrerillos",
                        "latitude": "15.21000000",
                        "longitude": "-87.95000000"
                    },
                    {
                        "id": 54180,
                        "name": "Pueblo Nuevo",
                        "latitude": "15.28333000",
                        "longitude": "-88.01667000"
                    },
                    {
                        "id": 54182,
                        "name": "Puerto Alto",
                        "latitude": "15.70000000",
                        "longitude": "-87.86667000"
                    },
                    {
                        "id": 54185,
                        "name": "Puerto Cortés",
                        "latitude": "15.79000000",
                        "longitude": "-87.84900000"
                    },
                    {
                        "id": 54184,
                        "name": "Puerto Cortez",
                        "latitude": "15.82562000",
                        "longitude": "-87.92968000"
                    },
                    {
                        "id": 54191,
                        "name": "Quebrada Seca",
                        "latitude": "15.66667000",
                        "longitude": "-87.95000000"
                    },
                    {
                        "id": 54199,
                        "name": "Río Blanquito",
                        "latitude": "15.73333000",
                        "longitude": "-87.90000000"
                    },
                    {
                        "id": 54201,
                        "name": "Río Chiquito",
                        "latitude": "15.63333000",
                        "longitude": "-88.25000000"
                    },
                    {
                        "id": 54203,
                        "name": "Río Lindo",
                        "latitude": "15.03333000",
                        "longitude": "-87.98333000"
                    },
                    {
                        "id": 54215,
                        "name": "San Antonio de Cortés",
                        "latitude": "15.11667000",
                        "longitude": "-88.03333000"
                    },
                    {
                        "id": 54221,
                        "name": "San Buenaventura",
                        "latitude": "15.01667000",
                        "longitude": "-88.00000000"
                    },
                    {
                        "id": 54233,
                        "name": "San Francisco de Yojoa",
                        "latitude": "15.01667000",
                        "longitude": "-87.96667000"
                    },
                    {
                        "id": 54254,
                        "name": "San José del Boquerón",
                        "latitude": "15.48333000",
                        "longitude": "-87.86667000"
                    },
                    {
                        "id": 54268,
                        "name": "San Manuel",
                        "latitude": "15.37279000",
                        "longitude": "-87.90167000"
                    },
                    {
                        "id": 54281,
                        "name": "San Pedro Sula",
                        "latitude": "15.50417000",
                        "longitude": "-88.02500000"
                    },
                    {
                        "id": 54298,
                        "name": "Santa Cruz de Yojoa",
                        "latitude": "14.98333000",
                        "longitude": "-87.90000000"
                    },
                    {
                        "id": 54299,
                        "name": "Santa Elena",
                        "latitude": "15.38333000",
                        "longitude": "-88.13333000"
                    },
                    {
                        "id": 54344,
                        "name": "Travesía",
                        "latitude": "15.86667000",
                        "longitude": "-87.90000000"
                    },
                    {
                        "id": 54362,
                        "name": "Villanueva",
                        "latitude": "15.31667000",
                        "longitude": "-88.00000000"
                    }
                ]
            },
            {
                "id": 4043,
                "name": "El Paraíso",
                "iso2": "EP",
                "latitude": "13.98212940",
                "longitude": "-86.49965460",
                "type": "department",
                "cities": [
                    {
                        "id": 53846,
                        "name": "Alauca",
                        "latitude": "13.84020000",
                        "longitude": "-86.69526000"
                    },
                    {
                        "id": 53854,
                        "name": "Araulí",
                        "latitude": "13.95000000",
                        "longitude": "-86.55000000"
                    },
                    {
                        "id": 53930,
                        "name": "Cuyalí",
                        "latitude": "13.88333000",
                        "longitude": "-86.55000000"
                    },
                    {
                        "id": 53932,
                        "name": "Danlí",
                        "latitude": "14.03333000",
                        "longitude": "-86.58333000"
                    },
                    {
                        "id": 53942,
                        "name": "El Benque",
                        "latitude": "14.03333000",
                        "longitude": "-86.46667000"
                    },
                    {
                        "id": 53944,
                        "name": "El Chichicaste",
                        "latitude": "14.06667000",
                        "longitude": "-86.30000000"
                    },
                    {
                        "id": 53966,
                        "name": "El Obraje",
                        "latitude": "14.00000000",
                        "longitude": "-86.43333000"
                    },
                    {
                        "id": 53970,
                        "name": "El Paraíso",
                        "latitude": "13.85381000",
                        "longitude": "-86.53094000"
                    },
                    {
                        "id": 54024,
                        "name": "Güinope",
                        "latitude": "13.88333000",
                        "longitude": "-86.93333000"
                    },
                    {
                        "id": 54030,
                        "name": "Jacaleapa",
                        "latitude": "14.01667000",
                        "longitude": "-86.66667000"
                    },
                    {
                        "id": 54040,
                        "name": "Jutiapa",
                        "latitude": "13.98333000",
                        "longitude": "-86.40000000"
                    },
                    {
                        "id": 54098,
                        "name": "Las Ánimas",
                        "latitude": "14.25000000",
                        "longitude": "-86.56667000"
                    },
                    {
                        "id": 54094,
                        "name": "Las Trojes",
                        "latitude": "14.06667000",
                        "longitude": "-85.98333000"
                    },
                    {
                        "id": 54104,
                        "name": "Liure",
                        "latitude": "13.53583000",
                        "longitude": "-87.09194000"
                    },
                    {
                        "id": 54134,
                        "name": "Morocelí",
                        "latitude": "14.11667000",
                        "longitude": "-86.86667000"
                    },
                    {
                        "id": 54138,
                        "name": "Municipio de Texiguat",
                        "latitude": "13.66372000",
                        "longitude": "-87.03479000"
                    },
                    {
                        "id": 54154,
                        "name": "Ojo de Agua",
                        "latitude": "14.01667000",
                        "longitude": "-86.35000000"
                    },
                    {
                        "id": 54163,
                        "name": "Oropolí",
                        "latitude": "13.81667000",
                        "longitude": "-86.81667000"
                    },
                    {
                        "id": 54177,
                        "name": "Potrerillos",
                        "latitude": "14.04478000",
                        "longitude": "-86.76201000"
                    },
                    {
                        "id": 54190,
                        "name": "Quebrada Larga",
                        "latitude": "14.10000000",
                        "longitude": "-86.36667000"
                    },
                    {
                        "id": 54217,
                        "name": "San Antonio de Flores",
                        "latitude": "13.71089000",
                        "longitude": "-86.84226000"
                    },
                    {
                        "id": 54223,
                        "name": "San Diego",
                        "latitude": "14.05000000",
                        "longitude": "-86.46667000"
                    },
                    {
                        "id": 54264,
                        "name": "San Lucas",
                        "latitude": "13.74586000",
                        "longitude": "-86.95163000"
                    },
                    {
                        "id": 54275,
                        "name": "San Matías",
                        "latitude": "13.95966000",
                        "longitude": "-86.64032000"
                    },
                    {
                        "id": 54296,
                        "name": "Santa Cruz",
                        "latitude": "13.86667000",
                        "longitude": "-86.63333000"
                    },
                    {
                        "id": 54320,
                        "name": "Soledad",
                        "latitude": "13.58333000",
                        "longitude": "-87.11667000"
                    },
                    {
                        "id": 54337,
                        "name": "Teupasenti",
                        "latitude": "14.21667000",
                        "longitude": "-86.70000000"
                    },
                    {
                        "id": 54338,
                        "name": "Texíguat",
                        "latitude": "13.64972000",
                        "longitude": "-87.02250000"
                    },
                    {
                        "id": 54348,
                        "name": "Trojes",
                        "latitude": "14.05966000",
                        "longitude": "-86.00166000"
                    },
                    {
                        "id": 54352,
                        "name": "Vado Ancho",
                        "latitude": "13.64355000",
                        "longitude": "-86.95546000"
                    },
                    {
                        "id": 54372,
                        "name": "Yauyupe",
                        "latitude": "13.74867000",
                        "longitude": "-87.07610000"
                    },
                    {
                        "id": 54376,
                        "name": "Yuscarán",
                        "latitude": "13.95708000",
                        "longitude": "-86.83170000"
                    }
                ]
            },
            {
                "id": 4052,
                "name": "Francisco Morazán",
                "iso2": "FM",
                "latitude": "14.45411000",
                "longitude": "-87.06242610",
                "type": "department",
                "cities": [
                    {
                        "id": 53835,
                        "name": "Agalteca",
                        "latitude": "14.45000000",
                        "longitude": "-87.26667000"
                    },
                    {
                        "id": 53848,
                        "name": "Alubarén",
                        "latitude": "13.78226000",
                        "longitude": "-87.46990000"
                    },
                    {
                        "id": 53892,
                        "name": "Cedros",
                        "latitude": "14.50464000",
                        "longitude": "-87.21680000"
                    },
                    {
                        "id": 53895,
                        "name": "Cerro Grande",
                        "latitude": "13.81667000",
                        "longitude": "-87.25000000"
                    },
                    {
                        "id": 53905,
                        "name": "Cofradía",
                        "latitude": "14.21667000",
                        "longitude": "-87.18333000"
                    },
                    {
                        "id": 53928,
                        "name": "Curarén",
                        "latitude": "13.83000000",
                        "longitude": "-87.57000000"
                    },
                    {
                        "id": 53933,
                        "name": "Distrito Central",
                        "latitude": "14.14975000",
                        "longitude": "-87.24806000"
                    },
                    {
                        "id": 53945,
                        "name": "El Chimbo",
                        "latitude": "14.13333000",
                        "longitude": "-87.11667000"
                    },
                    {
                        "id": 53951,
                        "name": "El Escanito",
                        "latitude": "14.66667000",
                        "longitude": "-87.10000000"
                    },
                    {
                        "id": 53952,
                        "name": "El Escaño de Tepale",
                        "latitude": "14.75000000",
                        "longitude": "-87.06667000"
                    },
                    {
                        "id": 53953,
                        "name": "El Guante",
                        "latitude": "14.55000000",
                        "longitude": "-87.10000000"
                    },
                    {
                        "id": 53954,
                        "name": "El Guantillo",
                        "latitude": "14.60000000",
                        "longitude": "-87.30000000"
                    },
                    {
                        "id": 53955,
                        "name": "El Guapinol",
                        "latitude": "13.76667000",
                        "longitude": "-87.46667000"
                    },
                    {
                        "id": 53959,
                        "name": "El Lolo",
                        "latitude": "14.11667000",
                        "longitude": "-87.26667000"
                    },
                    {
                        "id": 53972,
                        "name": "El Pedernal",
                        "latitude": "14.70000000",
                        "longitude": "-87.11667000"
                    },
                    {
                        "id": 53979,
                        "name": "El Porvenir",
                        "latitude": "14.72009000",
                        "longitude": "-87.21039000"
                    },
                    {
                        "id": 53990,
                        "name": "El Suyatal",
                        "latitude": "14.51667000",
                        "longitude": "-87.21667000"
                    },
                    {
                        "id": 53991,
                        "name": "El Tablón",
                        "latitude": "14.03333000",
                        "longitude": "-87.16667000"
                    },
                    {
                        "id": 53992,
                        "name": "El Terrero",
                        "latitude": "14.06667000",
                        "longitude": "-87.06667000"
                    },
                    {
                        "id": 54012,
                        "name": "Guaimaca",
                        "latitude": "14.53333000",
                        "longitude": "-86.81667000"
                    },
                    {
                        "id": 54053,
                        "name": "La Ermita",
                        "latitude": "14.46667000",
                        "longitude": "-87.06667000"
                    },
                    {
                        "id": 54069,
                        "name": "La Libertad",
                        "latitude": "13.70662000",
                        "longitude": "-87.50421000"
                    },
                    {
                        "id": 54084,
                        "name": "La Venta",
                        "latitude": "13.73113000",
                        "longitude": "-87.32874000"
                    },
                    {
                        "id": 54102,
                        "name": "Lepaterique",
                        "latitude": "14.05590000",
                        "longitude": "-87.47908000"
                    },
                    {
                        "id": 54118,
                        "name": "Maraita",
                        "latitude": "13.87197000",
                        "longitude": "-87.05633000"
                    },
                    {
                        "id": 54119,
                        "name": "Marale",
                        "latitude": "14.94113000",
                        "longitude": "-87.09892000"
                    },
                    {
                        "id": 54123,
                        "name": "Mata de Plátano",
                        "latitude": "14.60000000",
                        "longitude": "-87.28333000"
                    },
                    {
                        "id": 54124,
                        "name": "Mateo",
                        "latitude": "14.08333000",
                        "longitude": "-87.31667000"
                    },
                    {
                        "id": 54146,
                        "name": "Nueva Armenia",
                        "latitude": "13.75000000",
                        "longitude": "-87.15307000"
                    },
                    {
                        "id": 54155,
                        "name": "Ojojona",
                        "latitude": "13.93389000",
                        "longitude": "-87.29583000"
                    },
                    {
                        "id": 54161,
                        "name": "Orica",
                        "latitude": "14.80645000",
                        "longitude": "-86.95760000"
                    },
                    {
                        "id": 54193,
                        "name": "Quebradas",
                        "latitude": "14.50000000",
                        "longitude": "-87.35000000"
                    },
                    {
                        "id": 54196,
                        "name": "Reitoca",
                        "latitude": "13.82583000",
                        "longitude": "-87.46528000"
                    },
                    {
                        "id": 54198,
                        "name": "Río Abajo",
                        "latitude": "14.16667000",
                        "longitude": "-87.21667000"
                    },
                    {
                        "id": 54204,
                        "name": "Sabanagrande",
                        "latitude": "13.80778000",
                        "longitude": "-87.25917000"
                    },
                    {
                        "id": 54218,
                        "name": "San Antonio de Oriente",
                        "latitude": "14.03859000",
                        "longitude": "-86.98951000"
                    },
                    {
                        "id": 54222,
                        "name": "San Buenaventura",
                        "latitude": "13.89100000",
                        "longitude": "-87.18554000"
                    },
                    {
                        "id": 54236,
                        "name": "San Ignacio",
                        "latitude": "14.73795000",
                        "longitude": "-87.04759000"
                    },
                    {
                        "id": 54260,
                        "name": "San Juan de Flores",
                        "latitude": "14.26667000",
                        "longitude": "-87.03333000"
                    },
                    {
                        "id": 54276,
                        "name": "San Miguelito",
                        "latitude": "13.74572000",
                        "longitude": "-87.49233000"
                    },
                    {
                        "id": 54291,
                        "name": "Santa Ana",
                        "latitude": "13.94000000",
                        "longitude": "-87.21000000"
                    },
                    {
                        "id": 54305,
                        "name": "Santa Lucía",
                        "latitude": "14.12595000",
                        "longitude": "-87.09175000"
                    },
                    {
                        "id": 54325,
                        "name": "Talanga",
                        "latitude": "14.41393000",
                        "longitude": "-87.06941000"
                    },
                    {
                        "id": 54350,
                        "name": "Támara",
                        "latitude": "14.15000000",
                        "longitude": "-87.33333000"
                    },
                    {
                        "id": 54329,
                        "name": "Tatumbla",
                        "latitude": "13.98467000",
                        "longitude": "-87.06977000"
                    },
                    {
                        "id": 54333,
                        "name": "Tegucigalpa",
                        "latitude": "14.08180000",
                        "longitude": "-87.20681000"
                    },
                    {
                        "id": 54354,
                        "name": "Valle de Ángeles",
                        "latitude": "14.15000000",
                        "longitude": "-87.03333000"
                    },
                    {
                        "id": 54356,
                        "name": "Vallecillo",
                        "latitude": "14.51313000",
                        "longitude": "-87.40242000"
                    },
                    {
                        "id": 54361,
                        "name": "Villa de San Francisco",
                        "latitude": "14.16667000",
                        "longitude": "-86.96667000"
                    },
                    {
                        "id": 54359,
                        "name": "Villa Nueva",
                        "latitude": "14.03333000",
                        "longitude": "-87.13333000"
                    },
                    {
                        "id": 54367,
                        "name": "Yaguacire",
                        "latitude": "14.01667000",
                        "longitude": "-87.21667000"
                    },
                    {
                        "id": 54377,
                        "name": "Zambrano",
                        "latitude": "14.26667000",
                        "longitude": "-87.40000000"
                    }
                ]
            },
            {
                "id": 4048,
                "name": "Gracias a Dios",
                "iso2": "GD",
                "latitude": "15.34180600",
                "longitude": "-84.60604490",
                "type": "department",
                "cities": [
                    {
                        "id": 53844,
                        "name": "Ahuas",
                        "latitude": "15.46923000",
                        "longitude": "-84.34479000"
                    },
                    {
                        "id": 53862,
                        "name": "Auas",
                        "latitude": "15.48333000",
                        "longitude": "-84.33333000"
                    },
                    {
                        "id": 53863,
                        "name": "Auka",
                        "latitude": "14.94087000",
                        "longitude": "-83.83229000"
                    },
                    {
                        "id": 53869,
                        "name": "Barra Patuca",
                        "latitude": "15.80000000",
                        "longitude": "-84.28333000"
                    },
                    {
                        "id": 53875,
                        "name": "Brus Laguna",
                        "latitude": "15.75000000",
                        "longitude": "-84.48333000"
                    },
                    {
                        "id": 54028,
                        "name": "Iralaya",
                        "latitude": "15.00000000",
                        "longitude": "-83.23333000"
                    },
                    {
                        "id": 54039,
                        "name": "Juan Francisco Bulnes",
                        "latitude": "15.91676000",
                        "longitude": "-84.90990000"
                    },
                    {
                        "id": 54165,
                        "name": "Paptalaya",
                        "latitude": "15.50000000",
                        "longitude": "-84.31667000"
                    },
                    {
                        "id": 54186,
                        "name": "Puerto Lempira",
                        "latitude": "15.26667000",
                        "longitude": "-83.77222000"
                    },
                    {
                        "id": 54363,
                        "name": "Villeda Morales",
                        "latitude": "15.08472000",
                        "longitude": "-83.35361000"
                    },
                    {
                        "id": 54365,
                        "name": "Wampusirpi",
                        "latitude": "15.18333000",
                        "longitude": "-84.61667000"
                    },
                    {
                        "id": 54366,
                        "name": "Wawina",
                        "latitude": "15.41667000",
                        "longitude": "-84.43333000"
                    }
                ]
            },
            {
                "id": 4044,
                "name": "Intibucá",
                "iso2": "IN",
                "latitude": "14.37273400",
                "longitude": "-88.24611830",
                "type": "department",
                "cities": [
                    {
                        "id": 53882,
                        "name": "Camasca",
                        "latitude": "14.00000000",
                        "longitude": "-88.38333000"
                    },
                    {
                        "id": 53907,
                        "name": "Colomoncagua",
                        "latitude": "13.97245000",
                        "longitude": "-88.27673000"
                    },
                    {
                        "id": 53910,
                        "name": "Concepción",
                        "latitude": "14.04725000",
                        "longitude": "-88.31942000"
                    },
                    {
                        "id": 53935,
                        "name": "Dolores",
                        "latitude": "14.26188000",
                        "longitude": "-88.35787000"
                    },
                    {
                        "id": 54027,
                        "name": "Intibucá",
                        "latitude": "14.43000000",
                        "longitude": "-88.17000000"
                    },
                    {
                        "id": 54034,
                        "name": "Jesús de Otoro",
                        "latitude": "14.48333000",
                        "longitude": "-87.98333000"
                    },
                    {
                        "id": 54035,
                        "name": "Jiquinlaca",
                        "latitude": "14.00000000",
                        "longitude": "-88.35000000"
                    },
                    {
                        "id": 54054,
                        "name": "La Esperanza",
                        "latitude": "14.31111000",
                        "longitude": "-88.18056000"
                    },
                    {
                        "id": 54114,
                        "name": "Magdalena",
                        "latitude": "13.92452000",
                        "longitude": "-88.36675000"
                    },
                    {
                        "id": 54122,
                        "name": "Masaguara",
                        "latitude": "14.40428000",
                        "longitude": "-87.98247000"
                    },
                    {
                        "id": 54213,
                        "name": "San Antonio",
                        "latitude": "13.95043000",
                        "longitude": "-88.46493000"
                    },
                    {
                        "id": 54232,
                        "name": "San Francisco de Opalaca",
                        "latitude": "14.58441000",
                        "longitude": "-88.30253000"
                    },
                    {
                        "id": 54238,
                        "name": "San Isidro",
                        "latitude": "14.56763000",
                        "longitude": "-88.11743000"
                    },
                    {
                        "id": 54256,
                        "name": "San Juan",
                        "latitude": "14.42127000",
                        "longitude": "-88.41953000"
                    },
                    {
                        "id": 54274,
                        "name": "San Marcos de la Sierra",
                        "latitude": "14.13236000",
                        "longitude": "-88.24690000"
                    },
                    {
                        "id": 54277,
                        "name": "San Miguelito",
                        "latitude": "14.34875000",
                        "longitude": "-88.33983000"
                    },
                    {
                        "id": 54304,
                        "name": "Santa Lucía",
                        "latitude": "13.90812000",
                        "longitude": "-88.41566000"
                    },
                    {
                        "id": 54368,
                        "name": "Yamaranguila",
                        "latitude": "14.26826000",
                        "longitude": "-88.24652000"
                    }
                ]
            },
            {
                "id": 4058,
                "name": "La Paz",
                "iso2": "LP",
                "latitude": "-15.08924160",
                "longitude": "-68.52471490",
                "type": "department",
                "cities": [
                    {
                        "id": 53842,
                        "name": "Aguanqueterique",
                        "latitude": "13.98606000",
                        "longitude": "-87.64622000"
                    },
                    {
                        "id": 53879,
                        "name": "Cabañas",
                        "latitude": "13.99419000",
                        "longitude": "-88.02864000"
                    },
                    {
                        "id": 53885,
                        "name": "Cane",
                        "latitude": "14.28333000",
                        "longitude": "-87.66667000"
                    },
                    {
                        "id": 53897,
                        "name": "Chinacla",
                        "latitude": "14.18289000",
                        "longitude": "-87.95395000"
                    },
                    {
                        "id": 54014,
                        "name": "Guajiquiro",
                        "latitude": "14.06982000",
                        "longitude": "-87.77451000"
                    },
                    {
                        "id": 54073,
                        "name": "La Paz",
                        "latitude": "14.31944000",
                        "longitude": "-87.67917000"
                    },
                    {
                        "id": 54099,
                        "name": "Lauterique",
                        "latitude": "13.86425000",
                        "longitude": "-87.65792000"
                    },
                    {
                        "id": 54110,
                        "name": "Los Planes",
                        "latitude": "14.05000000",
                        "longitude": "-88.01667000"
                    },
                    {
                        "id": 54120,
                        "name": "Marcala",
                        "latitude": "14.14845000",
                        "longitude": "-88.02405000"
                    },
                    {
                        "id": 54126,
                        "name": "Mercedes de Oriente",
                        "latitude": "13.90937000",
                        "longitude": "-87.77795000"
                    },
                    {
                        "id": 54160,
                        "name": "Opatoro",
                        "latitude": "14.02451000",
                        "longitude": "-87.87982000"
                    },
                    {
                        "id": 54220,
                        "name": "San Antonio del Norte",
                        "latitude": "13.88000000",
                        "longitude": "-87.72000000"
                    },
                    {
                        "id": 54246,
                        "name": "San José",
                        "latitude": "14.22642000",
                        "longitude": "-87.96238000"
                    },
                    {
                        "id": 54257,
                        "name": "San Juan",
                        "latitude": "13.95428000",
                        "longitude": "-87.72948000"
                    },
                    {
                        "id": 54284,
                        "name": "San Pedro de Tutule",
                        "latitude": "14.25000000",
                        "longitude": "-87.85000000"
                    },
                    {
                        "id": 54292,
                        "name": "Santa Ana",
                        "latitude": "14.00011000",
                        "longitude": "-87.94107000"
                    },
                    {
                        "id": 54300,
                        "name": "Santa Elena",
                        "latitude": "14.07149000",
                        "longitude": "-88.15445000"
                    },
                    {
                        "id": 54306,
                        "name": "Santa María",
                        "latitude": "14.26904000",
                        "longitude": "-87.91164000"
                    },
                    {
                        "id": 54314,
                        "name": "Santiago Puringla",
                        "latitude": "14.35000000",
                        "longitude": "-87.90000000"
                    },
                    {
                        "id": 54335,
                        "name": "Tepanguare",
                        "latitude": "14.33333000",
                        "longitude": "-87.75000000"
                    },
                    {
                        "id": 54370,
                        "name": "Yarula",
                        "latitude": "14.10000000",
                        "longitude": "-88.08000000"
                    },
                    {
                        "id": 54371,
                        "name": "Yarumela",
                        "latitude": "14.33333000",
                        "longitude": "-87.63333000"
                    }
                ]
            },
            {
                "id": 4054,
                "name": "Lempira",
                "iso2": "LE",
                "latitude": "14.18876980",
                "longitude": "-88.55653100",
                "type": "department",
                "cities": [
                    {
                        "id": 53871,
                        "name": "Belén",
                        "latitude": "14.50834000",
                        "longitude": "-88.42819000"
                    },
                    {
                        "id": 53884,
                        "name": "Candelaria",
                        "latitude": "14.06072000",
                        "longitude": "-88.55913000"
                    },
                    {
                        "id": 53906,
                        "name": "Cololaca",
                        "latitude": "14.31189000",
                        "longitude": "-88.87720000"
                    },
                    {
                        "id": 53940,
                        "name": "El Achiotal",
                        "latitude": "14.08333000",
                        "longitude": "-88.75000000"
                    },
                    {
                        "id": 54000,
                        "name": "Erandique",
                        "latitude": "14.23333000",
                        "longitude": "-88.46667000"
                    },
                    {
                        "id": 54010,
                        "name": "Gracias",
                        "latitude": "14.59028000",
                        "longitude": "-88.58194000"
                    },
                    {
                        "id": 54017,
                        "name": "Gualcince",
                        "latitude": "14.12869000",
                        "longitude": "-88.56812000"
                    },
                    {
                        "id": 54020,
                        "name": "Guarita",
                        "latitude": "14.20784000",
                        "longitude": "-88.85161000"
                    },
                    {
                        "id": 54047,
                        "name": "La Campa",
                        "latitude": "14.47280000",
                        "longitude": "-88.56090000"
                    },
                    {
                        "id": 54063,
                        "name": "La Iguala",
                        "latitude": "14.66441000",
                        "longitude": "-88.46360000"
                    },
                    {
                        "id": 54067,
                        "name": "La Libertad",
                        "latitude": "14.80000000",
                        "longitude": "-88.58333000"
                    },
                    {
                        "id": 54081,
                        "name": "La Unión",
                        "latitude": "14.81667000",
                        "longitude": "-88.40000000"
                    },
                    {
                        "id": 54085,
                        "name": "La Virtud",
                        "latitude": "14.07156000",
                        "longitude": "-88.68584000"
                    },
                    {
                        "id": 54091,
                        "name": "Las Flores",
                        "latitude": "14.67930000",
                        "longitude": "-88.65040000"
                    },
                    {
                        "id": 54093,
                        "name": "Las Tejeras",
                        "latitude": "14.80000000",
                        "longitude": "-88.60000000"
                    },
                    {
                        "id": 54101,
                        "name": "Lepaera",
                        "latitude": "14.78333000",
                        "longitude": "-88.58333000"
                    },
                    {
                        "id": 54117,
                        "name": "Mapulaca",
                        "latitude": "14.04293000",
                        "longitude": "-88.62440000"
                    },
                    {
                        "id": 54174,
                        "name": "Piraera",
                        "latitude": "14.06261000",
                        "longitude": "-88.46319000"
                    },
                    {
                        "id": 54210,
                        "name": "San Andrés",
                        "latitude": "14.21968000",
                        "longitude": "-88.54981000"
                    },
                    {
                        "id": 54227,
                        "name": "San Francisco",
                        "latitude": "14.12435000",
                        "longitude": "-88.37189000"
                    },
                    {
                        "id": 54258,
                        "name": "San Juan Guarita",
                        "latitude": "14.15492000",
                        "longitude": "-88.77477000"
                    },
                    {
                        "id": 54269,
                        "name": "San Manuel Colohete",
                        "latitude": "14.44435000",
                        "longitude": "-88.67050000"
                    },
                    {
                        "id": 54272,
                        "name": "San Marcos de Caiquin",
                        "latitude": "14.41614000",
                        "longitude": "-88.60126000"
                    },
                    {
                        "id": 54285,
                        "name": "San Rafael",
                        "latitude": "14.73333000",
                        "longitude": "-88.41667000"
                    },
                    {
                        "id": 54287,
                        "name": "San Sebastián",
                        "latitude": "14.34594000",
                        "longitude": "-88.73487000"
                    },
                    {
                        "id": 54297,
                        "name": "Santa Cruz",
                        "latitude": "14.34427000",
                        "longitude": "-88.52684000"
                    },
                    {
                        "id": 54326,
                        "name": "Talgua",
                        "latitude": "14.68110000",
                        "longitude": "-88.72800000"
                    },
                    {
                        "id": 54327,
                        "name": "Tambla",
                        "latitude": "14.21276000",
                        "longitude": "-88.76768000"
                    },
                    {
                        "id": 54328,
                        "name": "Taragual",
                        "latitude": "14.75000000",
                        "longitude": "-88.48333000"
                    },
                    {
                        "id": 54340,
                        "name": "Tomalá",
                        "latitude": "14.24330000",
                        "longitude": "-88.73140000"
                    },
                    {
                        "id": 54353,
                        "name": "Valladolid",
                        "latitude": "14.14710000",
                        "longitude": "-88.70840000"
                    },
                    {
                        "id": 54364,
                        "name": "Virginia",
                        "latitude": "14.00522000",
                        "longitude": "-88.56193000"
                    }
                ]
            },
            {
                "id": 4056,
                "name": "Ocotepeque",
                "iso2": "OC",
                "latitude": "14.51703470",
                "longitude": "-89.05615320",
                "type": "department",
                "cities": [
                    {
                        "id": 53850,
                        "name": "Antigua Ocotepeque",
                        "latitude": "14.40000000",
                        "longitude": "-89.20000000"
                    },
                    {
                        "id": 53872,
                        "name": "Belén Gualcho",
                        "latitude": "14.48333000",
                        "longitude": "-88.80000000"
                    },
                    {
                        "id": 53909,
                        "name": "Concepción",
                        "latitude": "14.52383000",
                        "longitude": "-89.19371000"
                    },
                    {
                        "id": 53936,
                        "name": "Dolores Merendón",
                        "latitude": "14.55095000",
                        "longitude": "-89.12493000"
                    },
                    {
                        "id": 53996,
                        "name": "El Tránsito",
                        "latitude": "14.38333000",
                        "longitude": "-88.91667000"
                    },
                    {
                        "id": 54007,
                        "name": "Fraternidad",
                        "latitude": "14.58087000",
                        "longitude": "-89.07740000"
                    },
                    {
                        "id": 54051,
                        "name": "La Encarnación",
                        "latitude": "14.66667000",
                        "longitude": "-89.04742000"
                    },
                    {
                        "id": 54066,
                        "name": "La Labor",
                        "latitude": "14.48333000",
                        "longitude": "-89.00000000"
                    },
                    {
                        "id": 54112,
                        "name": "Lucerna",
                        "latitude": "14.55000000",
                        "longitude": "-88.93333000"
                    },
                    {
                        "id": 54125,
                        "name": "Mercedes",
                        "latitude": "14.31667000",
                        "longitude": "-88.98333000"
                    },
                    {
                        "id": 54150,
                        "name": "Nueva Ocotepeque",
                        "latitude": "14.43333000",
                        "longitude": "-89.18333000"
                    },
                    {
                        "id": 54225,
                        "name": "San Fernando",
                        "latitude": "14.68793000",
                        "longitude": "-89.10153000"
                    },
                    {
                        "id": 54229,
                        "name": "San Francisco de Cones",
                        "latitude": "14.51667000",
                        "longitude": "-88.90000000"
                    },
                    {
                        "id": 54235,
                        "name": "San Francisco del Valle",
                        "latitude": "14.43333000",
                        "longitude": "-88.95000000"
                    },
                    {
                        "id": 54243,
                        "name": "San Jorge",
                        "latitude": "14.63697000",
                        "longitude": "-89.11860000"
                    },
                    {
                        "id": 54271,
                        "name": "San Marcos",
                        "latitude": "14.38000000",
                        "longitude": "-88.92000000"
                    },
                    {
                        "id": 54301,
                        "name": "Santa Fe",
                        "latitude": "14.50038000",
                        "longitude": "-89.27320000"
                    },
                    {
                        "id": 54303,
                        "name": "Santa Lucía",
                        "latitude": "14.41667000",
                        "longitude": "-89.20000000"
                    },
                    {
                        "id": 54316,
                        "name": "Sensenti",
                        "latitude": "14.48333000",
                        "longitude": "-88.93333000"
                    },
                    {
                        "id": 54319,
                        "name": "Sinuapa",
                        "latitude": "14.45000000",
                        "longitude": "-89.18333000"
                    },
                    {
                        "id": 54369,
                        "name": "Yaruchel",
                        "latitude": "14.53333000",
                        "longitude": "-88.81667000"
                    }
                ]
            },
            {
                "id": 4050,
                "name": "Olancho",
                "iso2": "OL",
                "latitude": "14.80674060",
                "longitude": "-85.76666450",
                "type": "department",
                "cities": [
                    {
                        "id": 53856,
                        "name": "Arimís",
                        "latitude": "14.78333000",
                        "longitude": "-86.00000000"
                    },
                    {
                        "id": 53883,
                        "name": "Campamento",
                        "latitude": "14.55000000",
                        "longitude": "-86.65000000"
                    },
                    {
                        "id": 53890,
                        "name": "Catacamas",
                        "latitude": "14.60384000",
                        "longitude": "-85.54261000"
                    },
                    {
                        "id": 53917,
                        "name": "Concordia",
                        "latitude": "14.61667000",
                        "longitude": "-86.65000000"
                    },
                    {
                        "id": 53938,
                        "name": "Dulce Nombre de Culmí",
                        "latitude": "15.10000000",
                        "longitude": "-85.53333000"
                    },
                    {
                        "id": 53956,
                        "name": "El Guayabito",
                        "latitude": "14.83333000",
                        "longitude": "-86.03333000"
                    },
                    {
                        "id": 53986,
                        "name": "El Rosario",
                        "latitude": "14.88720000",
                        "longitude": "-86.68764000"
                    },
                    {
                        "id": 53987,
                        "name": "El Rusio",
                        "latitude": "14.46667000",
                        "longitude": "-86.36667000"
                    },
                    {
                        "id": 54002,
                        "name": "Esquipulas del Norte",
                        "latitude": "15.27763000",
                        "longitude": "-86.55760000"
                    },
                    {
                        "id": 54015,
                        "name": "Gualaco",
                        "latitude": "15.02521000",
                        "longitude": "-86.07076000"
                    },
                    {
                        "id": 54021,
                        "name": "Guarizama",
                        "latitude": "14.91667000",
                        "longitude": "-86.33333000"
                    },
                    {
                        "id": 54022,
                        "name": "Guata",
                        "latitude": "15.15133000",
                        "longitude": "-86.37624000"
                    },
                    {
                        "id": 54023,
                        "name": "Guayape",
                        "latitude": "14.71667000",
                        "longitude": "-86.83333000"
                    },
                    {
                        "id": 54032,
                        "name": "Jano",
                        "latitude": "15.07902000",
                        "longitude": "-86.51521000"
                    },
                    {
                        "id": 54042,
                        "name": "Juticalpa",
                        "latitude": "14.66667000",
                        "longitude": "-86.21944000"
                    },
                    {
                        "id": 54043,
                        "name": "Jutiquile",
                        "latitude": "14.71667000",
                        "longitude": "-86.08333000"
                    },
                    {
                        "id": 54049,
                        "name": "La Concepción",
                        "latitude": "14.70000000",
                        "longitude": "-86.23333000"
                    },
                    {
                        "id": 54057,
                        "name": "La Estancia",
                        "latitude": "15.05000000",
                        "longitude": "-86.35000000"
                    },
                    {
                        "id": 54061,
                        "name": "La Guata",
                        "latitude": "15.08333000",
                        "longitude": "-86.38333000"
                    },
                    {
                        "id": 54082,
                        "name": "La Unión",
                        "latitude": "15.09759000",
                        "longitude": "-86.68910000"
                    },
                    {
                        "id": 54087,
                        "name": "Laguna Seca",
                        "latitude": "14.70000000",
                        "longitude": "-86.10000000"
                    },
                    {
                        "id": 54115,
                        "name": "Mangulile",
                        "latitude": "15.06667000",
                        "longitude": "-86.80000000"
                    },
                    {
                        "id": 54116,
                        "name": "Manto",
                        "latitude": "14.91667000",
                        "longitude": "-86.38333000"
                    },
                    {
                        "id": 54137,
                        "name": "Municipio de San Francisco de La Paz",
                        "latitude": "14.84183000",
                        "longitude": "-86.11819000"
                    },
                    {
                        "id": 54166,
                        "name": "Patuca",
                        "latitude": "14.36000000",
                        "longitude": "-85.97000000"
                    },
                    {
                        "id": 54189,
                        "name": "Punuare",
                        "latitude": "14.73333000",
                        "longitude": "-85.96667000"
                    },
                    {
                        "id": 54207,
                        "name": "Salamá",
                        "latitude": "14.81052000",
                        "longitude": "-86.61996000"
                    },
                    {
                        "id": 54224,
                        "name": "San Esteban",
                        "latitude": "15.29467000",
                        "longitude": "-85.69487000"
                    },
                    {
                        "id": 54228,
                        "name": "San Francisco de Becerra",
                        "latitude": "14.63333000",
                        "longitude": "-86.10000000"
                    },
                    {
                        "id": 54234,
                        "name": "San Francisco de la Paz",
                        "latitude": "14.90000000",
                        "longitude": "-86.20000000"
                    },
                    {
                        "id": 54252,
                        "name": "San José de Río Tinto",
                        "latitude": "14.93333000",
                        "longitude": "-85.70000000"
                    },
                    {
                        "id": 54278,
                        "name": "San Nicolás",
                        "latitude": "14.55000000",
                        "longitude": "-86.25000000"
                    },
                    {
                        "id": 54307,
                        "name": "Santa María del Real",
                        "latitude": "14.76667000",
                        "longitude": "-85.95000000"
                    },
                    {
                        "id": 54318,
                        "name": "Silca",
                        "latitude": "14.76205000",
                        "longitude": "-86.51521000"
                    },
                    {
                        "id": 54373,
                        "name": "Yocón",
                        "latitude": "14.95000000",
                        "longitude": "-86.82000000"
                    },
                    {
                        "id": 54379,
                        "name": "Zopilotepe",
                        "latitude": "14.60000000",
                        "longitude": "-86.26667000"
                    }
                ]
            },
            {
                "id": 4053,
                "name": "Santa Bárbara",
                "iso2": "SB",
                "latitude": "15.12027950",
                "longitude": "-88.40160410",
                "type": "department",
                "cities": [
                    {
                        "id": 53841,
                        "name": "Agualote",
                        "latitude": "15.33528000",
                        "longitude": "-88.55306000"
                    },
                    {
                        "id": 53852,
                        "name": "Arada",
                        "latitude": "14.85000000",
                        "longitude": "-88.30000000"
                    },
                    {
                        "id": 53861,
                        "name": "Atima",
                        "latitude": "14.93333000",
                        "longitude": "-88.48333000"
                    },
                    {
                        "id": 53865,
                        "name": "Azacualpa",
                        "latitude": "14.71667000",
                        "longitude": "-88.10000000"
                    },
                    {
                        "id": 53873,
                        "name": "Berlín",
                        "latitude": "14.83333000",
                        "longitude": "-88.50000000"
                    },
                    {
                        "id": 53880,
                        "name": "Callejones",
                        "latitude": "15.16667000",
                        "longitude": "-88.65000000"
                    },
                    {
                        "id": 53881,
                        "name": "Camalote",
                        "latitude": "15.33333000",
                        "longitude": "-88.33333000"
                    },
                    {
                        "id": 53888,
                        "name": "Casa Quemada",
                        "latitude": "15.26667000",
                        "longitude": "-88.55000000"
                    },
                    {
                        "id": 53893,
                        "name": "Ceguaca",
                        "latitude": "14.80000000",
                        "longitude": "-88.20000000"
                    },
                    {
                        "id": 53898,
                        "name": "Chinda",
                        "latitude": "15.11667000",
                        "longitude": "-88.20000000"
                    },
                    {
                        "id": 53915,
                        "name": "Concepción del Norte",
                        "latitude": "15.20227000",
                        "longitude": "-88.13728000"
                    },
                    {
                        "id": 53916,
                        "name": "Concepción del Sur",
                        "latitude": "14.81263000",
                        "longitude": "-88.15316000"
                    },
                    {
                        "id": 53924,
                        "name": "Correderos",
                        "latitude": "15.41667000",
                        "longitude": "-88.45000000"
                    },
                    {
                        "id": 53946,
                        "name": "El Ciruelo",
                        "latitude": "15.30000000",
                        "longitude": "-88.50000000"
                    },
                    {
                        "id": 53947,
                        "name": "El Corozal",
                        "latitude": "15.06667000",
                        "longitude": "-88.61667000"
                    },
                    {
                        "id": 53962,
                        "name": "El Mochito",
                        "latitude": "14.86667000",
                        "longitude": "-88.08333000"
                    },
                    {
                        "id": 53964,
                        "name": "El Níspero",
                        "latitude": "14.75957000",
                        "longitude": "-88.34438000"
                    },
                    {
                        "id": 54011,
                        "name": "Guacamaya",
                        "latitude": "15.01667000",
                        "longitude": "-88.15000000"
                    },
                    {
                        "id": 54016,
                        "name": "Gualala",
                        "latitude": "14.98000000",
                        "longitude": "-88.17000000"
                    },
                    {
                        "id": 54018,
                        "name": "Gualjoco",
                        "latitude": "14.95000000",
                        "longitude": "-88.23333000"
                    },
                    {
                        "id": 54026,
                        "name": "Ilama",
                        "latitude": "15.06667000",
                        "longitude": "-88.21667000"
                    },
                    {
                        "id": 54036,
                        "name": "Joconal",
                        "latitude": "15.35444000",
                        "longitude": "-88.63556000"
                    },
                    {
                        "id": 54058,
                        "name": "La Flecha",
                        "latitude": "15.28333000",
                        "longitude": "-88.48333000"
                    },
                    {
                        "id": 54088,
                        "name": "Laguna Verde",
                        "latitude": "15.20000000",
                        "longitude": "-88.16667000"
                    },
                    {
                        "id": 54096,
                        "name": "Las Vegas",
                        "latitude": "14.86636000",
                        "longitude": "-88.07233000"
                    },
                    {
                        "id": 54097,
                        "name": "Las Vegas Santa Barbara",
                        "latitude": "14.87649000",
                        "longitude": "-88.07473000"
                    },
                    {
                        "id": 54105,
                        "name": "Loma Alta",
                        "latitude": "15.39667000",
                        "longitude": "-88.55972000"
                    },
                    {
                        "id": 54113,
                        "name": "Macuelizo",
                        "latitude": "15.26000000",
                        "longitude": "-88.66000000"
                    },
                    {
                        "id": 54140,
                        "name": "Naco",
                        "latitude": "15.38333000",
                        "longitude": "-88.18333000"
                    },
                    {
                        "id": 54142,
                        "name": "Naranjito",
                        "latitude": "14.95000000",
                        "longitude": "-88.68333000"
                    },
                    {
                        "id": 54148,
                        "name": "Nueva Frontera",
                        "latitude": "15.21000000",
                        "longitude": "-88.56000000"
                    },
                    {
                        "id": 54149,
                        "name": "Nueva Jalapa",
                        "latitude": "14.91667000",
                        "longitude": "-88.33333000"
                    },
                    {
                        "id": 54151,
                        "name": "Nuevo Celilac",
                        "latitude": "14.97554000",
                        "longitude": "-88.36726000"
                    },
                    {
                        "id": 54169,
                        "name": "Petoa",
                        "latitude": "15.26667000",
                        "longitude": "-88.28333000"
                    },
                    {
                        "id": 54173,
                        "name": "Pinalejo",
                        "latitude": "15.38333000",
                        "longitude": "-88.40000000"
                    },
                    {
                        "id": 54179,
                        "name": "Protección",
                        "latitude": "15.03333000",
                        "longitude": "-88.65000000"
                    },
                    {
                        "id": 54195,
                        "name": "Quimistán",
                        "latitude": "15.35000000",
                        "longitude": "-88.40000000"
                    },
                    {
                        "id": 54231,
                        "name": "San Francisco de Ojuera",
                        "latitude": "14.67000000",
                        "longitude": "-88.21000000"
                    },
                    {
                        "id": 54248,
                        "name": "San José de Colinas",
                        "latitude": "15.03333000",
                        "longitude": "-88.30000000"
                    },
                    {
                        "id": 54253,
                        "name": "San José de Tarros",
                        "latitude": "15.30000000",
                        "longitude": "-88.70000000"
                    },
                    {
                        "id": 54265,
                        "name": "San Luis",
                        "latitude": "15.08333000",
                        "longitude": "-88.38333000"
                    },
                    {
                        "id": 54267,
                        "name": "San Luis de Planes",
                        "latitude": "14.98333000",
                        "longitude": "-88.13333000"
                    },
                    {
                        "id": 54270,
                        "name": "San Marcos",
                        "latitude": "15.30000000",
                        "longitude": "-88.41667000"
                    },
                    {
                        "id": 54280,
                        "name": "San Nicolás",
                        "latitude": "14.91913000",
                        "longitude": "-88.37910000"
                    },
                    {
                        "id": 54282,
                        "name": "San Pedro Zacapa",
                        "latitude": "14.75000000",
                        "longitude": "-88.11667000"
                    },
                    {
                        "id": 54288,
                        "name": "San Vicente Centenario",
                        "latitude": "14.88333000",
                        "longitude": "-88.28333000"
                    },
                    {
                        "id": 54294,
                        "name": "Santa Bárbara",
                        "latitude": "14.91944000",
                        "longitude": "-88.23611000"
                    },
                    {
                        "id": 54309,
                        "name": "Santa Rita",
                        "latitude": "14.76015000",
                        "longitude": "-88.26782000"
                    },
                    {
                        "id": 54323,
                        "name": "Sula",
                        "latitude": "15.25000000",
                        "longitude": "-88.56667000"
                    },
                    {
                        "id": 54343,
                        "name": "Tras Cerros",
                        "latitude": "15.30000000",
                        "longitude": "-88.66667000"
                    },
                    {
                        "id": 54345,
                        "name": "Trinidad",
                        "latitude": "15.13333000",
                        "longitude": "-88.23333000"
                    }
                ]
            },
            {
                "id": 4055,
                "name": "Valle",
                "iso2": "VA",
                "latitude": "13.57829360",
                "longitude": "-87.57912870",
                "type": "department",
                "cities": [
                    {
                        "id": 53840,
                        "name": "Agua Fría",
                        "latitude": "13.46889000",
                        "longitude": "-87.55111000"
                    },
                    {
                        "id": 53847,
                        "name": "Alianza",
                        "latitude": "13.44815000",
                        "longitude": "-87.68643000"
                    },
                    {
                        "id": 53849,
                        "name": "Amapala",
                        "latitude": "13.29222000",
                        "longitude": "-87.65389000"
                    },
                    {
                        "id": 53853,
                        "name": "Aramecina",
                        "latitude": "13.74222000",
                        "longitude": "-87.71028000"
                    },
                    {
                        "id": 53887,
                        "name": "Caridad",
                        "latitude": "13.81562000",
                        "longitude": "-87.68121000"
                    },
                    {
                        "id": 53950,
                        "name": "El Cubolero",
                        "latitude": "13.46667000",
                        "longitude": "-87.66667000"
                    },
                    {
                        "id": 53997,
                        "name": "El Tular",
                        "latitude": "13.46639000",
                        "longitude": "-87.51528000"
                    },
                    {
                        "id": 54009,
                        "name": "Goascorán",
                        "latitude": "13.58333000",
                        "longitude": "-87.61667000"
                    },
                    {
                        "id": 54044,
                        "name": "Jícaro Galán",
                        "latitude": "13.53167000",
                        "longitude": "-87.43889000"
                    },
                    {
                        "id": 54045,
                        "name": "La Alianza",
                        "latitude": "13.51222000",
                        "longitude": "-87.72444000"
                    },
                    {
                        "id": 54050,
                        "name": "La Criba",
                        "latitude": "13.45361000",
                        "longitude": "-87.41333000"
                    },
                    {
                        "id": 54090,
                        "name": "Langue",
                        "latitude": "13.62083000",
                        "longitude": "-87.65250000"
                    },
                    {
                        "id": 54139,
                        "name": "Nacaome",
                        "latitude": "13.52209000",
                        "longitude": "-87.52477000"
                    },
                    {
                        "id": 54230,
                        "name": "San Francisco de Coray",
                        "latitude": "13.66139000",
                        "longitude": "-87.53278000"
                    },
                    {
                        "id": 54263,
                        "name": "San Lorenzo",
                        "latitude": "13.45149000",
                        "longitude": "-87.40743000"
                    }
                ]
            },
            {
                "id": 4057,
                "name": "Yoro",
                "iso2": "YO",
                "latitude": "15.29496790",
                "longitude": "-87.14228950",
                "type": "department",
                "cities": [
                    {
                        "id": 53838,
                        "name": "Agua Blanca Sur",
                        "latitude": "15.25000000",
                        "longitude": "-87.88333000"
                    },
                    {
                        "id": 53855,
                        "name": "Arenal",
                        "latitude": "15.35000000",
                        "longitude": "-86.83333000"
                    },
                    {
                        "id": 53858,
                        "name": "Armenia",
                        "latitude": "15.46667000",
                        "longitude": "-86.36667000"
                    },
                    {
                        "id": 53864,
                        "name": "Ayapa",
                        "latitude": "15.11174000",
                        "longitude": "-87.17557000"
                    },
                    {
                        "id": 53877,
                        "name": "Bálsamo Oriental",
                        "latitude": "15.48333000",
                        "longitude": "-86.33333000"
                    },
                    {
                        "id": 53886,
                        "name": "Carbajales",
                        "latitude": "15.51667000",
                        "longitude": "-86.35000000"
                    },
                    {
                        "id": 53926,
                        "name": "Coyoles Central",
                        "latitude": "15.40000000",
                        "longitude": "-86.66667000"
                    },
                    {
                        "id": 53943,
                        "name": "El Bálsamo",
                        "latitude": "15.06667000",
                        "longitude": "-87.46667000"
                    },
                    {
                        "id": 53957,
                        "name": "El Juncal",
                        "latitude": "15.45000000",
                        "longitude": "-86.43333000"
                    },
                    {
                        "id": 53963,
                        "name": "El Negrito",
                        "latitude": "15.31667000",
                        "longitude": "-87.70000000"
                    },
                    {
                        "id": 53967,
                        "name": "El Ocote",
                        "latitude": "15.41667000",
                        "longitude": "-86.56667000"
                    },
                    {
                        "id": 53980,
                        "name": "El Progreso",
                        "latitude": "15.42762000",
                        "longitude": "-87.77396000"
                    },
                    {
                        "id": 54013,
                        "name": "Guaimitas",
                        "latitude": "15.50000000",
                        "longitude": "-87.71667000"
                    },
                    {
                        "id": 54037,
                        "name": "Jocón",
                        "latitude": "15.28333000",
                        "longitude": "-86.96667000"
                    },
                    {
                        "id": 54056,
                        "name": "La Estancia",
                        "latitude": "15.28333000",
                        "longitude": "-87.55000000"
                    },
                    {
                        "id": 54059,
                        "name": "La Guacamaya",
                        "latitude": "15.25000000",
                        "longitude": "-87.80000000"
                    },
                    {
                        "id": 54072,
                        "name": "La Mina",
                        "latitude": "15.31667000",
                        "longitude": "-87.83333000"
                    },
                    {
                        "id": 54075,
                        "name": "La Rosa",
                        "latitude": "15.35000000",
                        "longitude": "-87.06667000"
                    },
                    {
                        "id": 54077,
                        "name": "La Sarrosa",
                        "latitude": "15.23333000",
                        "longitude": "-87.83333000"
                    },
                    {
                        "id": 54078,
                        "name": "La Trinidad",
                        "latitude": "15.10000000",
                        "longitude": "-87.20000000"
                    },
                    {
                        "id": 54095,
                        "name": "Las Vegas",
                        "latitude": "15.01667000",
                        "longitude": "-87.45000000"
                    },
                    {
                        "id": 54106,
                        "name": "Lomitas",
                        "latitude": "15.10000000",
                        "longitude": "-87.21667000"
                    },
                    {
                        "id": 54130,
                        "name": "Mojimán",
                        "latitude": "15.26667000",
                        "longitude": "-87.60000000"
                    },
                    {
                        "id": 54133,
                        "name": "Morazán",
                        "latitude": "15.31667000",
                        "longitude": "-87.60000000"
                    },
                    {
                        "id": 54143,
                        "name": "Nombre de Jesús",
                        "latitude": "15.35000000",
                        "longitude": "-86.68333000"
                    },
                    {
                        "id": 54147,
                        "name": "Nueva Esperanza",
                        "latitude": "15.26667000",
                        "longitude": "-87.60000000"
                    },
                    {
                        "id": 54153,
                        "name": "Ocote Paulino",
                        "latitude": "15.41667000",
                        "longitude": "-87.60000000"
                    },
                    {
                        "id": 54158,
                        "name": "Olanchito",
                        "latitude": "15.48131000",
                        "longitude": "-86.57415000"
                    },
                    {
                        "id": 54167,
                        "name": "Paujiles",
                        "latitude": "15.10000000",
                        "longitude": "-87.35000000"
                    },
                    {
                        "id": 54187,
                        "name": "Punta Ocote",
                        "latitude": "15.20000000",
                        "longitude": "-87.28333000"
                    },
                    {
                        "id": 54211,
                        "name": "San Antonio",
                        "latitude": "15.33333000",
                        "longitude": "-87.15000000"
                    },
                    {
                        "id": 54244,
                        "name": "San José",
                        "latitude": "15.31667000",
                        "longitude": "-87.16667000"
                    },
                    {
                        "id": 54308,
                        "name": "Santa Rita",
                        "latitude": "15.18000000",
                        "longitude": "-87.81000000"
                    },
                    {
                        "id": 54322,
                        "name": "Subirana",
                        "latitude": "15.20000000",
                        "longitude": "-87.45000000"
                    },
                    {
                        "id": 54324,
                        "name": "Sulaco",
                        "latitude": "14.91667000",
                        "longitude": "-87.26667000"
                    },
                    {
                        "id": 54332,
                        "name": "Teguajinal",
                        "latitude": "15.36667000",
                        "longitude": "-86.60000000"
                    },
                    {
                        "id": 54336,
                        "name": "Tepusteca",
                        "latitude": "15.41667000",
                        "longitude": "-86.31667000"
                    },
                    {
                        "id": 54342,
                        "name": "Toyós",
                        "latitude": "15.55000000",
                        "longitude": "-87.65000000"
                    },
                    {
                        "id": 54347,
                        "name": "Trojas",
                        "latitude": "15.35000000",
                        "longitude": "-86.70000000"
                    },
                    {
                        "id": 54358,
                        "name": "Victoria",
                        "latitude": "15.10012000",
                        "longitude": "-87.53020000"
                    },
                    {
                        "id": 54374,
                        "name": "Yorito",
                        "latitude": "15.06667000",
                        "longitude": "-87.28333000"
                    },
                    {
                        "id": 54375,
                        "name": "Yoro",
                        "latitude": "15.13750000",
                        "longitude": "-87.12778000"
                    }
                ]
            }
        ]
    },
    {
        "id": 98,
        "name": "Hong Kong S.A.R.",
        "iso3": "HKG",
        "iso2": "HK",
        "numeric_code": "344",
        "phonecode": "852",
        "capital": "Hong Kong",
        "currency": "HKD",
        "currency_name": "Hong Kong dollar",
        "currency_symbol": "$",
        "tld": ".hk",
        "native": "香港",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Eastern Asia",
        "subregion_id": 12,
        "nationality": "Hong Kong, Hong Kongese",
        "timezones": [
            {
                "zoneName": "Asia\/Hong_Kong",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "HKT",
                "tzName": "Hong Kong Time"
            }
        ],
        "translations": {
            "br": "Hong Kong",
            "ko": "홍콩",
            "pt-BR": "Hong Kong",
            "pt": "Hong Kong",
            "nl": "Hongkong",
            "hr": "Hong Kong",
            "fa": "هنگ‌کنگ",
            "de": "Hong Kong",
            "es": "Hong Kong",
            "fr": "Hong Kong",
            "ja": "香港",
            "it": "Hong Kong",
            "zh-CN": "中国香港",
            "tr": "Hong Kong",
            "ru": "Гонконг С.А.Р.",
            "uk": "Гонконг САР.",
            "pl": "Hongkong S.A.R."
        },
        "latitude": "22.25000000",
        "longitude": "114.16666666",
        "emoji": "🇭🇰",
        "emojiU": "U+1F1ED U+1F1F0",
        "states": [
            {
                "id": 4889,
                "name": "Central and Western",
                "iso2": "HCW",
                "latitude": "22.28666000",
                "longitude": "114.15497000",
                "type": "district",
                "cities": [
                    {
                        "id": 153484,
                        "name": "Admiralty",
                        "latitude": "22.27800000",
                        "longitude": "114.16400000"
                    },
                    {
                        "id": 153483,
                        "name": "Central",
                        "latitude": "22.28100000",
                        "longitude": "114.15900000"
                    }
                ]
            },
            {
                "id": 4891,
                "name": "Eastern",
                "iso2": "HEA",
                "latitude": "22.28411000",
                "longitude": "114.22414000",
                "type": "district",
                "cities": []
            },
            {
                "id": 4888,
                "name": "Islands",
                "iso2": "NIS",
                "latitude": "22.26114000",
                "longitude": "113.94608000",
                "type": "district",
                "cities": [
                    {
                        "id": 153508,
                        "name": "Tai O",
                        "latitude": "22.24700000",
                        "longitude": "113.86900000"
                    }
                ]
            },
            {
                "id": 4895,
                "name": "Kowloon City",
                "iso2": "KKC",
                "latitude": "22.32820000",
                "longitude": "114.19155000",
                "type": "district",
                "cities": [
                    {
                        "id": 153500,
                        "name": "Kowloon Tong",
                        "latitude": "22.33700000",
                        "longitude": "114.17900000"
                    }
                ]
            },
            {
                "id": 4898,
                "name": "Kwai Tsing",
                "iso2": "NKT",
                "latitude": "22.35488000",
                "longitude": "114.08401000",
                "type": "district",
                "cities": []
            },
            {
                "id": 4897,
                "name": "Kwun Tong",
                "iso2": "KKT",
                "latitude": "22.31326000",
                "longitude": "114.22581000",
                "type": "district",
                "cities": [
                    {
                        "id": 153505,
                        "name": "Kwun Tong",
                        "latitude": "22.31000000",
                        "longitude": "114.22500000"
                    },
                    {
                        "id": 153504,
                        "name": "Lam Tin",
                        "latitude": "22.30700000",
                        "longitude": "114.23500000"
                    }
                ]
            },
            {
                "id": 4900,
                "name": "North",
                "iso2": "NNO",
                "latitude": "22.49471000",
                "longitude": "114.13812000",
                "type": "district",
                "cities": [
                    {
                        "id": 153497,
                        "name": "Sheung Shui",
                        "latitude": "22.50100000",
                        "longitude": "114.12300000"
                    }
                ]
            },
            {
                "id": 4887,
                "name": "Sai Kung",
                "iso2": "NSK",
                "latitude": "22.38143000",
                "longitude": "114.27052000",
                "type": "district",
                "cities": [
                    {
                        "id": 153493,
                        "name": "Sai Kung",
                        "latitude": "22.38400000",
                        "longitude": "114.27300000"
                    },
                    {
                        "id": 153498,
                        "name": "Tseung Kwan O",
                        "latitude": "22.31900000",
                        "longitude": "114.26300000"
                    }
                ]
            },
            {
                "id": 4901,
                "name": "Sha Tin",
                "iso2": "NST",
                "latitude": "22.38715000",
                "longitude": "114.19534000",
                "type": "district",
                "cities": [
                    {
                        "id": 153494,
                        "name": "Ma On Shan",
                        "latitude": "22.42200000",
                        "longitude": "114.23000000"
                    },
                    {
                        "id": 153489,
                        "name": "Sha Tin",
                        "latitude": "22.38300000",
                        "longitude": "114.18800000"
                    },
                    {
                        "id": 153499,
                        "name": "Sha Tin Wai",
                        "latitude": "22.38000000",
                        "longitude": "114.19100000"
                    }
                ]
            },
            {
                "id": 4894,
                "name": "Sham Shui Po",
                "iso2": "KSS",
                "latitude": "22.33074000",
                "longitude": "114.16220000",
                "type": "district",
                "cities": [
                    {
                        "id": 153501,
                        "name": "Cheung Sha Wan",
                        "latitude": "22.33600000",
                        "longitude": "114.15100000"
                    },
                    {
                        "id": 153502,
                        "name": "Lai Chi Kok",
                        "latitude": "22.33700000",
                        "longitude": "114.14600000"
                    }
                ]
            },
            {
                "id": 4892,
                "name": "Southern",
                "iso2": "HSO",
                "latitude": "22.24725000",
                "longitude": "114.15884000",
                "type": "district",
                "cities": [
                    {
                        "id": 153506,
                        "name": "Aberdeen",
                        "latitude": "22.24700000",
                        "longitude": "114.15200000"
                    },
                    {
                        "id": 153496,
                        "name": "Stanley",
                        "latitude": "22.22000000",
                        "longitude": "114.21400000"
                    },
                    {
                        "id": 153507,
                        "name": "Stanley Peninsula",
                        "latitude": "22.21000000",
                        "longitude": "114.21700000"
                    }
                ]
            },
            {
                "id": 4885,
                "name": "Tai Po",
                "iso2": "NTP",
                "latitude": "22.45085000",
                "longitude": "114.16422000",
                "type": "district",
                "cities": [
                    {
                        "id": 153509,
                        "name": "Tai Mei Tuk",
                        "latitude": "22.45700000",
                        "longitude": "114.18400000"
                    },
                    {
                        "id": 153495,
                        "name": "Tai Po",
                        "latitude": "22.44900000",
                        "longitude": "114.16000000"
                    }
                ]
            },
            {
                "id": 4884,
                "name": "Tsuen Wan",
                "iso2": "NTW",
                "latitude": "22.36281000",
                "longitude": "114.12907000",
                "type": "district",
                "cities": [
                    {
                        "id": 153490,
                        "name": "Tsuen Wan",
                        "latitude": "22.37100000",
                        "longitude": "114.11400000"
                    },
                    {
                        "id": 153491,
                        "name": "Tuen Mun\t",
                        "latitude": "22.39500000",
                        "longitude": "113.97300000"
                    }
                ]
            },
            {
                "id": 4899,
                "name": "Tuen Mun",
                "iso2": "NTM",
                "latitude": "22.39163000",
                "longitude": "113.97708850",
                "type": "district",
                "cities": []
            },
            {
                "id": 4890,
                "name": "Wan Chai",
                "iso2": "HWC",
                "latitude": "22.27968000",
                "longitude": "114.17168000",
                "type": "district",
                "cities": [
                    {
                        "id": 153486,
                        "name": "Causeway Bay",
                        "latitude": "22.28000000",
                        "longitude": "114.18500000"
                    },
                    {
                        "id": 153485,
                        "name": "Wan Chai",
                        "latitude": "22.27800000",
                        "longitude": "114.18200000"
                    }
                ]
            },
            {
                "id": 4896,
                "name": "Wong Tai Sin",
                "iso2": "KWT",
                "latitude": "22.33353000",
                "longitude": "114.19686000",
                "type": "district",
                "cities": [
                    {
                        "id": 153503,
                        "name": "Wong Tai Sin",
                        "latitude": "22.34100000",
                        "longitude": "114.19300000"
                    }
                ]
            },
            {
                "id": 4893,
                "name": "Yau Tsim Mong",
                "iso2": "KYT",
                "latitude": "22.32138000",
                "longitude": "114.17260000",
                "type": "district",
                "cities": [
                    {
                        "id": 153488,
                        "name": "Mong Kok",
                        "latitude": "22.31900000",
                        "longitude": "114.16900000"
                    },
                    {
                        "id": 153487,
                        "name": "Tsim Sha Tsui",
                        "latitude": "22.29800000",
                        "longitude": "114.17200000"
                    }
                ]
            },
            {
                "id": 4883,
                "name": "Yuen Long",
                "iso2": "NYL",
                "latitude": "22.44559000",
                "longitude": "114.02218000",
                "type": "district",
                "cities": [
                    {
                        "id": 153492,
                        "name": "Yuen Long",
                        "latitude": "22.44400000",
                        "longitude": "114.02700000"
                    }
                ]
            }
        ]
    },
    {
        "id": 99,
        "name": "Hungary",
        "iso3": "HUN",
        "iso2": "HU",
        "numeric_code": "348",
        "phonecode": "36",
        "capital": "Budapest",
        "currency": "HUF",
        "currency_name": "Hungarian forint",
        "currency_symbol": "Ft",
        "tld": ".hu",
        "native": "Magyarország",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Hungarian, Magyar",
        "timezones": [
            {
                "zoneName": "Europe\/Budapest",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Hungaria",
            "ko": "헝가리",
            "pt-BR": "Hungria",
            "pt": "Hungria",
            "nl": "Hongarije",
            "hr": "Mađarska",
            "fa": "مجارستان",
            "de": "Ungarn",
            "es": "Hungría",
            "fr": "Hongrie",
            "ja": "ハンガリー",
            "it": "Ungheria",
            "zh-CN": "匈牙利",
            "tr": "Macaristan",
            "ru": "Венгрия",
            "uk": "Угорщина",
            "pl": "Węgry"
        },
        "latitude": "47.00000000",
        "longitude": "20.00000000",
        "emoji": "🇭🇺",
        "emojiU": "U+1F1ED U+1F1FA",
        "states": [
            {
                "id": 1048,
                "name": "Bács-Kiskun",
                "iso2": "BK",
                "latitude": "46.56614370",
                "longitude": "19.42724640",
                "type": "county",
                "cities": [
                    {
                        "id": 56141,
                        "name": "Ágasegyháza",
                        "latitude": "46.84025000",
                        "longitude": "19.45208000"
                    },
                    {
                        "id": 55180,
                        "name": "Akasztó",
                        "latitude": "46.69167000",
                        "longitude": "19.20423000"
                    },
                    {
                        "id": 55191,
                        "name": "Apostag",
                        "latitude": "46.88208000",
                        "longitude": "18.96210000"
                    },
                    {
                        "id": 55287,
                        "name": "Bácsalmás",
                        "latitude": "46.12648000",
                        "longitude": "19.33260000"
                    },
                    {
                        "id": 55288,
                        "name": "Bácsalmási Járás",
                        "latitude": "46.10167000",
                        "longitude": "19.33063000"
                    },
                    {
                        "id": 55289,
                        "name": "Bácsbokod",
                        "latitude": "46.12500000",
                        "longitude": "19.15621000"
                    },
                    {
                        "id": 55203,
                        "name": "Baja",
                        "latitude": "46.18299000",
                        "longitude": "18.95307000"
                    },
                    {
                        "id": 55204,
                        "name": "Bajai Járás",
                        "latitude": "46.14507000",
                        "longitude": "19.01359000"
                    },
                    {
                        "id": 55225,
                        "name": "Ballószög",
                        "latitude": "46.86216000",
                        "longitude": "19.57092000"
                    },
                    {
                        "id": 55295,
                        "name": "Bátya",
                        "latitude": "46.48800000",
                        "longitude": "18.95419000"
                    },
                    {
                        "id": 55283,
                        "name": "Bugac",
                        "latitude": "46.68704000",
                        "longitude": "19.68074000"
                    },
                    {
                        "id": 55347,
                        "name": "Császártöltés",
                        "latitude": "46.42194000",
                        "longitude": "19.18361000"
                    },
                    {
                        "id": 55348,
                        "name": "Csávoly",
                        "latitude": "46.18917000",
                        "longitude": "19.14667000"
                    },
                    {
                        "id": 55331,
                        "name": "Csengőd",
                        "latitude": "46.71543000",
                        "longitude": "19.26802000"
                    },
                    {
                        "id": 55386,
                        "name": "Dávod",
                        "latitude": "45.99500000",
                        "longitude": "18.91722000"
                    },
                    {
                        "id": 55377,
                        "name": "Dunapataj",
                        "latitude": "46.64400000",
                        "longitude": "18.99632000"
                    },
                    {
                        "id": 55381,
                        "name": "Dunavecse",
                        "latitude": "46.91478000",
                        "longitude": "18.97127000"
                    },
                    {
                        "id": 55383,
                        "name": "Dusnok",
                        "latitude": "46.39085000",
                        "longitude": "18.96296000"
                    },
                    {
                        "id": 56147,
                        "name": "Érsekcsanád",
                        "latitude": "46.25352000",
                        "longitude": "18.98457000"
                    },
                    {
                        "id": 55424,
                        "name": "Felsőszentiván",
                        "latitude": "46.19713000",
                        "longitude": "19.18686000"
                    },
                    {
                        "id": 55439,
                        "name": "Fülöpjakab",
                        "latitude": "46.74221000",
                        "longitude": "19.72132000"
                    },
                    {
                        "id": 55440,
                        "name": "Fülöpszállás",
                        "latitude": "46.82075000",
                        "longitude": "19.23748000"
                    },
                    {
                        "id": 55446,
                        "name": "Gara",
                        "latitude": "46.03194000",
                        "longitude": "19.04278000"
                    },
                    {
                        "id": 55493,
                        "name": "Hajós",
                        "latitude": "46.39861000",
                        "longitude": "19.12056000"
                    },
                    {
                        "id": 55499,
                        "name": "Harta",
                        "latitude": "46.69758000",
                        "longitude": "19.03110000"
                    },
                    {
                        "id": 55504,
                        "name": "Helvécia",
                        "latitude": "46.83661000",
                        "longitude": "19.62251000"
                    },
                    {
                        "id": 55505,
                        "name": "Hercegszántó",
                        "latitude": "45.95000000",
                        "longitude": "18.93917000"
                    },
                    {
                        "id": 55531,
                        "name": "Izsák",
                        "latitude": "46.80454000",
                        "longitude": "19.35172000"
                    },
                    {
                        "id": 55535,
                        "name": "Jánoshalma",
                        "latitude": "46.29861000",
                        "longitude": "19.32583000"
                    },
                    {
                        "id": 55536,
                        "name": "Jánoshalmai Járás",
                        "latitude": "46.28283000",
                        "longitude": "19.31742000"
                    },
                    {
                        "id": 55552,
                        "name": "Jászszentlászló",
                        "latitude": "46.56685000",
                        "longitude": "19.76065000"
                    },
                    {
                        "id": 55558,
                        "name": "Kalocsa",
                        "latitude": "46.52981000",
                        "longitude": "18.97283000"
                    },
                    {
                        "id": 55559,
                        "name": "Kalocsai Járás",
                        "latitude": "46.55646000",
                        "longitude": "19.04211000"
                    },
                    {
                        "id": 55574,
                        "name": "Katymár",
                        "latitude": "46.03398000",
                        "longitude": "19.20935000"
                    },
                    {
                        "id": 55578,
                        "name": "Kecel",
                        "latitude": "46.52528000",
                        "longitude": "19.25194000"
                    },
                    {
                        "id": 55579,
                        "name": "Kecskemét",
                        "latitude": "46.90618000",
                        "longitude": "19.69128000"
                    },
                    {
                        "id": 55580,
                        "name": "Kecskeméti Járás",
                        "latitude": "46.88283000",
                        "longitude": "19.58701000"
                    },
                    {
                        "id": 55581,
                        "name": "Kelebia",
                        "latitude": "46.19680000",
                        "longitude": "19.61659000"
                    },
                    {
                        "id": 55587,
                        "name": "Kerekegyháza",
                        "latitude": "46.93722000",
                        "longitude": "19.47806000"
                    },
                    {
                        "id": 55602,
                        "name": "Kiskőrös",
                        "latitude": "46.62139000",
                        "longitude": "19.28528000"
                    },
                    {
                        "id": 55603,
                        "name": "Kiskőrösi Járás",
                        "latitude": "46.63309000",
                        "longitude": "19.33726000"
                    },
                    {
                        "id": 55594,
                        "name": "Kiskunfélegyháza",
                        "latitude": "46.71213000",
                        "longitude": "19.84458000"
                    },
                    {
                        "id": 55595,
                        "name": "Kiskunfélegyházi Járás",
                        "latitude": "46.65721000",
                        "longitude": "19.77006000"
                    },
                    {
                        "id": 55596,
                        "name": "Kiskunhalas",
                        "latitude": "46.43402000",
                        "longitude": "19.48479000"
                    },
                    {
                        "id": 55597,
                        "name": "Kiskunhalasi Járás",
                        "latitude": "46.35832000",
                        "longitude": "19.53067000"
                    },
                    {
                        "id": 55599,
                        "name": "Kiskunmajsa",
                        "latitude": "46.49028000",
                        "longitude": "19.74000000"
                    },
                    {
                        "id": 55600,
                        "name": "Kiskunmajsai Járás",
                        "latitude": "46.49608000",
                        "longitude": "19.72316000"
                    },
                    {
                        "id": 55608,
                        "name": "Kisszállás",
                        "latitude": "46.28009000",
                        "longitude": "19.48954000"
                    },
                    {
                        "id": 55626,
                        "name": "Kunfehértó",
                        "latitude": "46.36091000",
                        "longitude": "19.41454000"
                    },
                    {
                        "id": 55630,
                        "name": "Kunszentmiklós",
                        "latitude": "47.02699000",
                        "longitude": "19.12575000"
                    },
                    {
                        "id": 55631,
                        "name": "Kunszentmiklósi Járás",
                        "latitude": "46.94810000",
                        "longitude": "19.15563000"
                    },
                    {
                        "id": 55654,
                        "name": "Lajosmizse",
                        "latitude": "47.02133000",
                        "longitude": "19.56171000"
                    },
                    {
                        "id": 55655,
                        "name": "Lakitelek",
                        "latitude": "46.87601000",
                        "longitude": "19.99504000"
                    },
                    {
                        "id": 55672,
                        "name": "Madaras",
                        "latitude": "46.05870000",
                        "longitude": "19.26121000"
                    },
                    {
                        "id": 55731,
                        "name": "Mélykút",
                        "latitude": "46.21509000",
                        "longitude": "19.38102000"
                    },
                    {
                        "id": 55741,
                        "name": "Nagybaracska",
                        "latitude": "46.04248000",
                        "longitude": "18.90590000"
                    },
                    {
                        "id": 55765,
                        "name": "Nemesnádudvar",
                        "latitude": "46.34051000",
                        "longitude": "19.05115000"
                    },
                    {
                        "id": 55768,
                        "name": "Nyárlőrinc",
                        "latitude": "46.86017000",
                        "longitude": "19.87836000"
                    },
                    {
                        "id": 55799,
                        "name": "Orgovány",
                        "latitude": "46.75087000",
                        "longitude": "19.47259000"
                    },
                    {
                        "id": 55840,
                        "name": "Pálmonostora",
                        "latitude": "46.62417000",
                        "longitude": "19.95156000"
                    },
                    {
                        "id": 55903,
                        "name": "Solt",
                        "latitude": "46.80101000",
                        "longitude": "19.00098000"
                    },
                    {
                        "id": 55904,
                        "name": "Soltvadkert",
                        "latitude": "46.57889000",
                        "longitude": "19.39389000"
                    },
                    {
                        "id": 55997,
                        "name": "Sükösd",
                        "latitude": "46.28181000",
                        "longitude": "18.99524000"
                    },
                    {
                        "id": 55913,
                        "name": "Szabadszállás",
                        "latitude": "46.87575000",
                        "longitude": "19.22324000"
                    },
                    {
                        "id": 55917,
                        "name": "Szalkszentmárton",
                        "latitude": "46.97565000",
                        "longitude": "19.01178000"
                    },
                    {
                        "id": 55919,
                        "name": "Szank",
                        "latitude": "46.55713000",
                        "longitude": "19.66103000"
                    },
                    {
                        "id": 55942,
                        "name": "Szentkirály",
                        "latitude": "46.91892000",
                        "longitude": "19.91846000"
                    },
                    {
                        "id": 56016,
                        "name": "Tass",
                        "latitude": "47.02095000",
                        "longitude": "19.02988000"
                    },
                    {
                        "id": 56072,
                        "name": "Tázlár",
                        "latitude": "46.54824000",
                        "longitude": "19.51436000"
                    },
                    {
                        "id": 56021,
                        "name": "Tiszaalpár",
                        "latitude": "46.81279000",
                        "longitude": "19.99841000"
                    },
                    {
                        "id": 56035,
                        "name": "Tiszakécske",
                        "latitude": "46.93261000",
                        "longitude": "20.10349000"
                    },
                    {
                        "id": 56036,
                        "name": "Tiszakécskei Járás",
                        "latitude": "46.86013000",
                        "longitude": "19.97298000"
                    },
                    {
                        "id": 56055,
                        "name": "Tompa",
                        "latitude": "46.20605000",
                        "longitude": "19.53910000"
                    },
                    {
                        "id": 56111,
                        "name": "Városföld",
                        "latitude": "46.81674000",
                        "longitude": "19.75668000"
                    },
                    {
                        "id": 56091,
                        "name": "Vaskút",
                        "latitude": "46.10782000",
                        "longitude": "18.98514000"
                    }
                ]
            },
            {
                "id": 1055,
                "name": "Baranya",
                "iso2": "BA",
                "latitude": "46.04845850",
                "longitude": "18.27191730",
                "type": "county",
                "cities": [
                    {
                        "id": 55238,
                        "name": "Beremend",
                        "latitude": "45.79108000",
                        "longitude": "18.43263000"
                    },
                    {
                        "id": 55304,
                        "name": "Bóly",
                        "latitude": "45.96722000",
                        "longitude": "18.51833000"
                    },
                    {
                        "id": 55305,
                        "name": "Bólyi Járás",
                        "latitude": "45.98075000",
                        "longitude": "18.48449000"
                    },
                    {
                        "id": 55310,
                        "name": "Bükkösd",
                        "latitude": "46.10751000",
                        "longitude": "17.98820000"
                    },
                    {
                        "id": 55378,
                        "name": "Dunaszekcső",
                        "latitude": "46.08740000",
                        "longitude": "18.75870000"
                    },
                    {
                        "id": 55497,
                        "name": "Harkány",
                        "latitude": "45.85002000",
                        "longitude": "18.23668000"
                    },
                    {
                        "id": 55502,
                        "name": "Hegyháti Járás",
                        "latitude": "46.27247000",
                        "longitude": "18.13758000"
                    },
                    {
                        "id": 55512,
                        "name": "Hidas",
                        "latitude": "46.25680000",
                        "longitude": "18.49540000"
                    },
                    {
                        "id": 55516,
                        "name": "Hosszúhetény",
                        "latitude": "46.16414000",
                        "longitude": "18.35077000"
                    },
                    {
                        "id": 55618,
                        "name": "Komló",
                        "latitude": "46.19278000",
                        "longitude": "18.26494000"
                    },
                    {
                        "id": 55619,
                        "name": "Komlói Járás",
                        "latitude": "46.22019000",
                        "longitude": "18.28620000"
                    },
                    {
                        "id": 55625,
                        "name": "Kozármisleny",
                        "latitude": "46.02967000",
                        "longitude": "18.29210000"
                    },
                    {
                        "id": 55667,
                        "name": "Lánycsók",
                        "latitude": "46.00543000",
                        "longitude": "18.62526000"
                    },
                    {
                        "id": 55719,
                        "name": "Mágocs",
                        "latitude": "46.34998000",
                        "longitude": "18.23240000"
                    },
                    {
                        "id": 55684,
                        "name": "Mecseknádasd",
                        "latitude": "46.22468000",
                        "longitude": "18.47076000"
                    },
                    {
                        "id": 55708,
                        "name": "Mohács",
                        "latitude": "45.99020000",
                        "longitude": "18.68621000"
                    },
                    {
                        "id": 55709,
                        "name": "Mohácsi Járás",
                        "latitude": "46.02004000",
                        "longitude": "18.68000000"
                    },
                    {
                        "id": 55850,
                        "name": "Pécs",
                        "latitude": "46.08333000",
                        "longitude": "18.23333000"
                    },
                    {
                        "id": 55851,
                        "name": "Pécsi Járás",
                        "latitude": "46.07990000",
                        "longitude": "18.25253000"
                    },
                    {
                        "id": 55852,
                        "name": "Pécsvárad",
                        "latitude": "46.16033000",
                        "longitude": "18.42321000"
                    },
                    {
                        "id": 55853,
                        "name": "Pécsváradi Járás",
                        "latitude": "46.16782000",
                        "longitude": "18.45456000"
                    },
                    {
                        "id": 55812,
                        "name": "Pellérd",
                        "latitude": "46.03438000",
                        "longitude": "18.15403000"
                    },
                    {
                        "id": 55993,
                        "name": "Sásd",
                        "latitude": "46.25520000",
                        "longitude": "18.10776000"
                    },
                    {
                        "id": 55894,
                        "name": "Sellye",
                        "latitude": "45.87247000",
                        "longitude": "17.84711000"
                    },
                    {
                        "id": 55895,
                        "name": "Sellyei Járás",
                        "latitude": "45.86955000",
                        "longitude": "17.89827000"
                    },
                    {
                        "id": 55897,
                        "name": "Siklós",
                        "latitude": "45.85499000",
                        "longitude": "18.29752000"
                    },
                    {
                        "id": 55898,
                        "name": "Siklósi Járás",
                        "latitude": "45.84981000",
                        "longitude": "18.31052000"
                    },
                    {
                        "id": 55970,
                        "name": "Szászvár",
                        "latitude": "46.27673000",
                        "longitude": "18.37566000"
                    },
                    {
                        "id": 55944,
                        "name": "Szentlőrinc",
                        "latitude": "46.04016000",
                        "longitude": "17.98719000"
                    },
                    {
                        "id": 55945,
                        "name": "Szentlőrinci Járás",
                        "latitude": "46.04694000",
                        "longitude": "18.01528000"
                    },
                    {
                        "id": 55954,
                        "name": "Szigetvár",
                        "latitude": "46.04865000",
                        "longitude": "17.80554000"
                    },
                    {
                        "id": 55955,
                        "name": "Szigetvári Járás",
                        "latitude": "46.07336000",
                        "longitude": "17.80391000"
                    },
                    {
                        "id": 56089,
                        "name": "Vajszló",
                        "latitude": "45.85957000",
                        "longitude": "17.98406000"
                    },
                    {
                        "id": 56102,
                        "name": "Villány",
                        "latitude": "45.86889000",
                        "longitude": "18.45389000"
                    }
                ]
            },
            {
                "id": 1060,
                "name": "Békés",
                "iso2": "BE",
                "latitude": "46.67048990",
                "longitude": "21.04349960",
                "type": "county",
                "cities": [
                    {
                        "id": 55233,
                        "name": "Battonya",
                        "latitude": "46.28333000",
                        "longitude": "21.01667000"
                    },
                    {
                        "id": 55296,
                        "name": "Békés",
                        "latitude": "46.76667000",
                        "longitude": "21.13333000"
                    },
                    {
                        "id": 55297,
                        "name": "Békéscsaba",
                        "latitude": "46.68333000",
                        "longitude": "21.10000000"
                    },
                    {
                        "id": 55298,
                        "name": "Békéscsabai Járás",
                        "latitude": "46.68133000",
                        "longitude": "21.07413000"
                    },
                    {
                        "id": 55299,
                        "name": "Békési Járás",
                        "latitude": "46.83317000",
                        "longitude": "21.10000000"
                    },
                    {
                        "id": 55301,
                        "name": "Békéssámson",
                        "latitude": "46.41667000",
                        "longitude": "20.63333000"
                    },
                    {
                        "id": 55300,
                        "name": "Békésszentandrás",
                        "latitude": "46.86667000",
                        "longitude": "20.48333000"
                    },
                    {
                        "id": 55259,
                        "name": "Bucsa",
                        "latitude": "47.20000000",
                        "longitude": "21.00000000"
                    },
                    {
                        "id": 55325,
                        "name": "Csanádapáca",
                        "latitude": "46.55000000",
                        "longitude": "20.88333000"
                    },
                    {
                        "id": 55342,
                        "name": "Csorvás",
                        "latitude": "46.63333000",
                        "longitude": "20.83333000"
                    },
                    {
                        "id": 55389,
                        "name": "Dévaványa",
                        "latitude": "47.03333000",
                        "longitude": "20.96667000"
                    },
                    {
                        "id": 55364,
                        "name": "Doboz",
                        "latitude": "46.73333000",
                        "longitude": "21.25000000"
                    },
                    {
                        "id": 55366,
                        "name": "Dombegyház",
                        "latitude": "46.33333000",
                        "longitude": "21.13333000"
                    },
                    {
                        "id": 55402,
                        "name": "Elek",
                        "latitude": "46.53333000",
                        "longitude": "21.25000000"
                    },
                    {
                        "id": 55443,
                        "name": "Füzesgyarmat",
                        "latitude": "47.10000000",
                        "longitude": "21.21667000"
                    },
                    {
                        "id": 55470,
                        "name": "Gádoros",
                        "latitude": "46.66667000",
                        "longitude": "20.60000000"
                    },
                    {
                        "id": 55451,
                        "name": "Gyomaendrőd",
                        "latitude": "46.93333000",
                        "longitude": "20.83333000"
                    },
                    {
                        "id": 55452,
                        "name": "Gyomaendrődi Járás",
                        "latitude": "46.98216000",
                        "longitude": "20.84851000"
                    },
                    {
                        "id": 55453,
                        "name": "Gyula",
                        "latitude": "46.65000000",
                        "longitude": "21.28333000"
                    },
                    {
                        "id": 55455,
                        "name": "Gyulai Járás",
                        "latitude": "46.58626000",
                        "longitude": "21.22454000"
                    },
                    {
                        "id": 55573,
                        "name": "Kaszaper",
                        "latitude": "46.46667000",
                        "longitude": "20.83333000"
                    },
                    {
                        "id": 55642,
                        "name": "Kétegyháza",
                        "latitude": "46.53333000",
                        "longitude": "21.18333000"
                    },
                    {
                        "id": 55591,
                        "name": "Kevermes",
                        "latitude": "46.41667000",
                        "longitude": "21.18333000"
                    },
                    {
                        "id": 55622,
                        "name": "Kondoros",
                        "latitude": "46.76667000",
                        "longitude": "20.80000000"
                    },
                    {
                        "id": 55649,
                        "name": "Körösladány",
                        "latitude": "46.96667000",
                        "longitude": "21.08333000"
                    },
                    {
                        "id": 55650,
                        "name": "Köröstarcsa",
                        "latitude": "46.88333000",
                        "longitude": "21.03333000"
                    },
                    {
                        "id": 55634,
                        "name": "Kunágota",
                        "latitude": "46.43333000",
                        "longitude": "21.05000000"
                    },
                    {
                        "id": 55670,
                        "name": "Lőkösháza",
                        "latitude": "46.43333000",
                        "longitude": "21.23333000"
                    },
                    {
                        "id": 55675,
                        "name": "Magyarbánhegyes",
                        "latitude": "46.45000000",
                        "longitude": "20.96667000"
                    },
                    {
                        "id": 55685,
                        "name": "Medgyesegyháza",
                        "latitude": "46.50000000",
                        "longitude": "21.03333000"
                    },
                    {
                        "id": 55730,
                        "name": "Méhkerék",
                        "latitude": "46.78333000",
                        "longitude": "21.45000000"
                    },
                    {
                        "id": 55688,
                        "name": "Mezőberény",
                        "latitude": "46.81667000",
                        "longitude": "21.03333000"
                    },
                    {
                        "id": 55692,
                        "name": "Mezőhegyes",
                        "latitude": "46.31667000",
                        "longitude": "20.81667000"
                    },
                    {
                        "id": 55694,
                        "name": "Mezőkovácsháza",
                        "latitude": "46.40000000",
                        "longitude": "20.91667000"
                    },
                    {
                        "id": 55695,
                        "name": "Mezőkovácsházai Járás",
                        "latitude": "46.40888000",
                        "longitude": "21.00318000"
                    },
                    {
                        "id": 55762,
                        "name": "Nagyszénás",
                        "latitude": "46.68333000",
                        "longitude": "20.66667000"
                    },
                    {
                        "id": 55796,
                        "name": "Okány",
                        "latitude": "46.90000000",
                        "longitude": "21.35000000"
                    },
                    {
                        "id": 55800,
                        "name": "Orosháza",
                        "latitude": "46.56667000",
                        "longitude": "20.66667000"
                    },
                    {
                        "id": 55801,
                        "name": "Orosházi Járás",
                        "latitude": "46.56355000",
                        "longitude": "20.73357000"
                    },
                    {
                        "id": 55833,
                        "name": "Pusztaföldvár",
                        "latitude": "46.53333000",
                        "longitude": "20.80000000"
                    },
                    {
                        "id": 55891,
                        "name": "Sarkad",
                        "latitude": "46.75000000",
                        "longitude": "21.38333000"
                    },
                    {
                        "id": 55892,
                        "name": "Sarkadi Járás",
                        "latitude": "46.86154000",
                        "longitude": "21.44875000"
                    },
                    {
                        "id": 55912,
                        "name": "Szabadkígyós",
                        "latitude": "46.61667000",
                        "longitude": "21.10000000"
                    },
                    {
                        "id": 55921,
                        "name": "Szarvas",
                        "latitude": "46.86667000",
                        "longitude": "20.55000000"
                    },
                    {
                        "id": 55922,
                        "name": "Szarvasi Járás",
                        "latitude": "46.82891000",
                        "longitude": "20.63707000"
                    },
                    {
                        "id": 55927,
                        "name": "Szeghalmi Járás",
                        "latitude": "47.00000000",
                        "longitude": "21.17000000"
                    },
                    {
                        "id": 55928,
                        "name": "Szeghalom",
                        "latitude": "47.03333000",
                        "longitude": "21.16667000"
                    },
                    {
                        "id": 56078,
                        "name": "Tótkomlós",
                        "latitude": "46.41667000",
                        "longitude": "20.73333000"
                    },
                    {
                        "id": 56162,
                        "name": "Újkígyós",
                        "latitude": "46.58333000",
                        "longitude": "21.03333000"
                    },
                    {
                        "id": 56117,
                        "name": "Vésztő",
                        "latitude": "46.91667000",
                        "longitude": "21.26667000"
                    }
                ]
            },
            {
                "id": 1036,
                "name": "Békéscsaba",
                "iso2": "BC",
                "latitude": "46.67359390",
                "longitude": "21.08773090",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1058,
                "name": "Borsod-Abaúj-Zemplén",
                "iso2": "BZ",
                "latitude": "48.29394010",
                "longitude": "20.69341120",
                "type": "county",
                "cities": [
                    {
                        "id": 55170,
                        "name": "Abaújszántó",
                        "latitude": "48.28333000",
                        "longitude": "21.20000000"
                    },
                    {
                        "id": 55186,
                        "name": "Alsózsolca",
                        "latitude": "48.06982000",
                        "longitude": "20.88046000"
                    },
                    {
                        "id": 55194,
                        "name": "Arló",
                        "latitude": "48.18333000",
                        "longitude": "20.26667000"
                    },
                    {
                        "id": 55195,
                        "name": "Arnót",
                        "latitude": "48.13058000",
                        "longitude": "20.85832000"
                    },
                    {
                        "id": 55196,
                        "name": "Aszaló",
                        "latitude": "48.21667000",
                        "longitude": "20.96667000"
                    },
                    {
                        "id": 55235,
                        "name": "Bekecs",
                        "latitude": "48.15000000",
                        "longitude": "21.18333000"
                    },
                    {
                        "id": 55311,
                        "name": "Bőcs",
                        "latitude": "48.05000000",
                        "longitude": "20.96667000"
                    },
                    {
                        "id": 55252,
                        "name": "Bogács",
                        "latitude": "47.90000000",
                        "longitude": "20.53333000"
                    },
                    {
                        "id": 55254,
                        "name": "Boldva",
                        "latitude": "48.21667000",
                        "longitude": "20.80000000"
                    },
                    {
                        "id": 55258,
                        "name": "Borsodnádasd",
                        "latitude": "48.11667000",
                        "longitude": "20.25000000"
                    },
                    {
                        "id": 55321,
                        "name": "Cigánd",
                        "latitude": "48.25561000",
                        "longitude": "21.89195000"
                    },
                    {
                        "id": 55322,
                        "name": "Cigándi Járás",
                        "latitude": "48.30338000",
                        "longitude": "21.87651000"
                    },
                    {
                        "id": 55396,
                        "name": "Edelény",
                        "latitude": "48.30000000",
                        "longitude": "20.73333000"
                    },
                    {
                        "id": 55397,
                        "name": "Edelényi Járás",
                        "latitude": "48.40864000",
                        "longitude": "20.77506000"
                    },
                    {
                        "id": 55404,
                        "name": "Emőd",
                        "latitude": "47.93333000",
                        "longitude": "20.81667000"
                    },
                    {
                        "id": 55405,
                        "name": "Encs",
                        "latitude": "48.33333000",
                        "longitude": "21.13333000"
                    },
                    {
                        "id": 55407,
                        "name": "Encsi Járás",
                        "latitude": "48.39948000",
                        "longitude": "21.08169000"
                    },
                    {
                        "id": 55416,
                        "name": "Farkaslyuk",
                        "latitude": "48.18333000",
                        "longitude": "20.31667000"
                    },
                    {
                        "id": 55426,
                        "name": "Felsőzsolca",
                        "latitude": "48.10000000",
                        "longitude": "20.86667000"
                    },
                    {
                        "id": 55448,
                        "name": "Gesztely",
                        "latitude": "48.10000000",
                        "longitude": "20.96667000"
                    },
                    {
                        "id": 55477,
                        "name": "Gönc",
                        "latitude": "48.46667000",
                        "longitude": "21.28333000"
                    },
                    {
                        "id": 55478,
                        "name": "Gönci Járás",
                        "latitude": "48.39948000",
                        "longitude": "21.28307000"
                    },
                    {
                        "id": 55494,
                        "name": "Halmaj",
                        "latitude": "48.25000000",
                        "longitude": "21.00000000"
                    },
                    {
                        "id": 55498,
                        "name": "Harsány",
                        "latitude": "47.96667000",
                        "longitude": "20.75000000"
                    },
                    {
                        "id": 55503,
                        "name": "Hejőbába",
                        "latitude": "47.90000000",
                        "longitude": "20.95000000"
                    },
                    {
                        "id": 55508,
                        "name": "Hernádnémeti",
                        "latitude": "48.06667000",
                        "longitude": "20.98333000"
                    },
                    {
                        "id": 55532,
                        "name": "Izsófalva",
                        "latitude": "48.30000000",
                        "longitude": "20.66667000"
                    },
                    {
                        "id": 55540,
                        "name": "Járdánháza",
                        "latitude": "48.15000000",
                        "longitude": "20.25000000"
                    },
                    {
                        "id": 55569,
                        "name": "Karcsa",
                        "latitude": "48.31130000",
                        "longitude": "21.80537000"
                    },
                    {
                        "id": 55575,
                        "name": "Kazincbarcika",
                        "latitude": "48.25000000",
                        "longitude": "20.63333000"
                    },
                    {
                        "id": 55576,
                        "name": "Kazincbarcikai Járás",
                        "latitude": "48.26371000",
                        "longitude": "20.57978000"
                    },
                    {
                        "id": 55718,
                        "name": "Mád",
                        "latitude": "48.19442000",
                        "longitude": "21.28208000"
                    },
                    {
                        "id": 55720,
                        "name": "Mályi",
                        "latitude": "48.01667000",
                        "longitude": "20.83333000"
                    },
                    {
                        "id": 55686,
                        "name": "Megyaszó",
                        "latitude": "48.18333000",
                        "longitude": "21.05000000"
                    },
                    {
                        "id": 55689,
                        "name": "Mezőcsát",
                        "latitude": "47.81667000",
                        "longitude": "20.91667000"
                    },
                    {
                        "id": 55690,
                        "name": "Mezőcsáti Járás",
                        "latitude": "47.79841000",
                        "longitude": "20.91693000"
                    },
                    {
                        "id": 55693,
                        "name": "Mezőkeresztes",
                        "latitude": "47.83333000",
                        "longitude": "20.70000000"
                    },
                    {
                        "id": 55696,
                        "name": "Mezőkövesd",
                        "latitude": "47.81667000",
                        "longitude": "20.58333000"
                    },
                    {
                        "id": 55697,
                        "name": "Mezőkövesdi Járás",
                        "latitude": "47.84876000",
                        "longitude": "20.63623000"
                    },
                    {
                        "id": 55701,
                        "name": "Mezőzombor",
                        "latitude": "48.15000000",
                        "longitude": "21.26667000"
                    },
                    {
                        "id": 55705,
                        "name": "Miskolc",
                        "latitude": "48.10000000",
                        "longitude": "20.78333000"
                    },
                    {
                        "id": 55706,
                        "name": "Miskolci Járás",
                        "latitude": "48.08675000",
                        "longitude": "20.77353000"
                    },
                    {
                        "id": 55710,
                        "name": "Monok",
                        "latitude": "48.21102000",
                        "longitude": "21.15052000"
                    },
                    {
                        "id": 55737,
                        "name": "Múcsony",
                        "latitude": "48.26667000",
                        "longitude": "20.68333000"
                    },
                    {
                        "id": 55769,
                        "name": "Nyékládháza",
                        "latitude": "47.98333000",
                        "longitude": "20.83333000"
                    },
                    {
                        "id": 55797,
                        "name": "Olaszliszka",
                        "latitude": "48.25000000",
                        "longitude": "21.43333000"
                    },
                    {
                        "id": 55798,
                        "name": "Onga",
                        "latitude": "48.11667000",
                        "longitude": "20.91667000"
                    },
                    {
                        "id": 56151,
                        "name": "Ónod",
                        "latitude": "48.00000000",
                        "longitude": "20.91667000"
                    },
                    {
                        "id": 56154,
                        "name": "Ózd",
                        "latitude": "48.21667000",
                        "longitude": "20.30000000"
                    },
                    {
                        "id": 56155,
                        "name": "Ózdi Járás",
                        "latitude": "48.18133000",
                        "longitude": "20.24874000"
                    },
                    {
                        "id": 55832,
                        "name": "Prügy",
                        "latitude": "48.08333000",
                        "longitude": "21.25000000"
                    },
                    {
                        "id": 55837,
                        "name": "Putnok",
                        "latitude": "48.30000000",
                        "longitude": "20.43333000"
                    },
                    {
                        "id": 55838,
                        "name": "Putnoki Járás",
                        "latitude": "48.33694000",
                        "longitude": "20.46384000"
                    },
                    {
                        "id": 55864,
                        "name": "Ricse",
                        "latitude": "48.32565000",
                        "longitude": "21.97069000"
                    },
                    {
                        "id": 55867,
                        "name": "Rudabánya",
                        "latitude": "48.38333000",
                        "longitude": "20.63333000"
                    },
                    {
                        "id": 55882,
                        "name": "Sajóbábony",
                        "latitude": "48.16667000",
                        "longitude": "20.73333000"
                    },
                    {
                        "id": 55883,
                        "name": "Sajókaza",
                        "latitude": "48.28333000",
                        "longitude": "20.58333000"
                    },
                    {
                        "id": 55884,
                        "name": "Sajólád",
                        "latitude": "48.05000000",
                        "longitude": "20.90000000"
                    },
                    {
                        "id": 55888,
                        "name": "Sajóörös",
                        "latitude": "47.95000000",
                        "longitude": "21.03333000"
                    },
                    {
                        "id": 55885,
                        "name": "Sajószentpéter",
                        "latitude": "48.21667000",
                        "longitude": "20.71667000"
                    },
                    {
                        "id": 55886,
                        "name": "Sajószöged",
                        "latitude": "47.95000000",
                        "longitude": "21.00000000"
                    },
                    {
                        "id": 55887,
                        "name": "Sajóvámos",
                        "latitude": "48.18171000",
                        "longitude": "20.83149000"
                    },
                    {
                        "id": 55979,
                        "name": "Sály",
                        "latitude": "47.95000000",
                        "longitude": "20.66667000"
                    },
                    {
                        "id": 55986,
                        "name": "Sárospatak",
                        "latitude": "48.32450000",
                        "longitude": "21.57383000"
                    },
                    {
                        "id": 55987,
                        "name": "Sárospataki Járás",
                        "latitude": "48.29575000",
                        "longitude": "21.52716000"
                    },
                    {
                        "id": 55994,
                        "name": "Sátoraljaújhely",
                        "latitude": "48.39492000",
                        "longitude": "21.65871000"
                    },
                    {
                        "id": 55995,
                        "name": "Sátoraljaújhelyi Járás",
                        "latitude": "48.45898000",
                        "longitude": "21.54394000"
                    },
                    {
                        "id": 55933,
                        "name": "Szendrő",
                        "latitude": "48.40000000",
                        "longitude": "20.73333000"
                    },
                    {
                        "id": 55941,
                        "name": "Szentistván",
                        "latitude": "47.76667000",
                        "longitude": "20.66667000"
                    },
                    {
                        "id": 55948,
                        "name": "Szerencs",
                        "latitude": "48.15993000",
                        "longitude": "21.20970000"
                    },
                    {
                        "id": 55949,
                        "name": "Szerencsi Járás",
                        "latitude": "48.14929000",
                        "longitude": "21.16865000"
                    },
                    {
                        "id": 55958,
                        "name": "Szikszó",
                        "latitude": "48.20000000",
                        "longitude": "20.93333000"
                    },
                    {
                        "id": 55959,
                        "name": "Szikszói Járás",
                        "latitude": "48.30032000",
                        "longitude": "20.95507000"
                    },
                    {
                        "id": 55961,
                        "name": "Szirmabesenyő",
                        "latitude": "48.15000000",
                        "longitude": "20.80000000"
                    },
                    {
                        "id": 56005,
                        "name": "Taktaharkány",
                        "latitude": "48.08333000",
                        "longitude": "21.13333000"
                    },
                    {
                        "id": 56006,
                        "name": "Taktaszada",
                        "latitude": "48.11667000",
                        "longitude": "21.18333000"
                    },
                    {
                        "id": 56062,
                        "name": "Tállya",
                        "latitude": "48.23333000",
                        "longitude": "21.23333000"
                    },
                    {
                        "id": 56012,
                        "name": "Tarcal",
                        "latitude": "48.13333000",
                        "longitude": "21.35000000"
                    },
                    {
                        "id": 56033,
                        "name": "Tiszakarád",
                        "latitude": "48.20000000",
                        "longitude": "21.71667000"
                    },
                    {
                        "id": 56034,
                        "name": "Tiszakeszi",
                        "latitude": "47.78333000",
                        "longitude": "21.00000000"
                    },
                    {
                        "id": 56038,
                        "name": "Tiszalúc",
                        "latitude": "48.03774000",
                        "longitude": "21.07261000"
                    },
                    {
                        "id": 56048,
                        "name": "Tiszaújváros",
                        "latitude": "47.93333000",
                        "longitude": "21.08333000"
                    },
                    {
                        "id": 56049,
                        "name": "Tiszaújvárosi Járás",
                        "latitude": "47.92656000",
                        "longitude": "20.99321000"
                    },
                    {
                        "id": 56050,
                        "name": "Tokaj",
                        "latitude": "48.11667000",
                        "longitude": "21.41667000"
                    },
                    {
                        "id": 56051,
                        "name": "Tokaji Járás",
                        "latitude": "48.14014000",
                        "longitude": "21.37002000"
                    },
                    {
                        "id": 56052,
                        "name": "Tolcsva",
                        "latitude": "48.28333000",
                        "longitude": "21.45000000"
                    }
                ]
            },
            {
                "id": 1064,
                "name": "Budapest",
                "iso2": "BU",
                "latitude": "47.49791200",
                "longitude": "19.04023500",
                "type": "capital city",
                "cities": [
                    {
                        "id": 55263,
                        "name": "Budapest",
                        "latitude": "47.49835000",
                        "longitude": "19.04045000"
                    },
                    {
                        "id": 55264,
                        "name": "Budapest I. kerület",
                        "latitude": "47.49705000",
                        "longitude": "19.03961000"
                    },
                    {
                        "id": 55265,
                        "name": "Budapest II. kerület",
                        "latitude": "47.51984000",
                        "longitude": "19.02218000"
                    },
                    {
                        "id": 55266,
                        "name": "Budapest III. kerület",
                        "latitude": "47.54157000",
                        "longitude": "19.04501000"
                    },
                    {
                        "id": 55267,
                        "name": "Budapest IV. kerület",
                        "latitude": "47.56182000",
                        "longitude": "19.08909000"
                    },
                    {
                        "id": 55268,
                        "name": "Budapest VI. kerület",
                        "latitude": "47.50369000",
                        "longitude": "19.06583000"
                    },
                    {
                        "id": 55269,
                        "name": "Budapest VIII. kerület",
                        "latitude": "47.48919000",
                        "longitude": "19.07012000"
                    },
                    {
                        "id": 55270,
                        "name": "Budapest X. kerület",
                        "latitude": "47.47910000",
                        "longitude": "19.15835000"
                    },
                    {
                        "id": 55271,
                        "name": "Budapest XI. kerület",
                        "latitude": "47.47603000",
                        "longitude": "19.03605000"
                    },
                    {
                        "id": 55272,
                        "name": "Budapest XII. kerület",
                        "latitude": "47.49192000",
                        "longitude": "19.01493000"
                    },
                    {
                        "id": 55273,
                        "name": "Budapest XIII. kerület",
                        "latitude": "47.52978000",
                        "longitude": "19.08068000"
                    },
                    {
                        "id": 55274,
                        "name": "Budapest XV. kerület",
                        "latitude": "47.56263000",
                        "longitude": "19.11681000"
                    },
                    {
                        "id": 55275,
                        "name": "Budapest XVI. kerület",
                        "latitude": "47.51482000",
                        "longitude": "19.17028000"
                    },
                    {
                        "id": 55276,
                        "name": "Budapest XVII. kerület",
                        "latitude": "47.47997000",
                        "longitude": "19.25388000"
                    },
                    {
                        "id": 55277,
                        "name": "Budapest XVIII. kerület",
                        "latitude": "47.44417000",
                        "longitude": "19.17595000"
                    },
                    {
                        "id": 55278,
                        "name": "Budapest XX. kerület",
                        "latitude": "47.43674000",
                        "longitude": "19.10093000"
                    },
                    {
                        "id": 55279,
                        "name": "Budapest XXI. kerület",
                        "latitude": "47.43047000",
                        "longitude": "19.07098000"
                    },
                    {
                        "id": 55280,
                        "name": "Budapest XXII. kerület",
                        "latitude": "47.42698000",
                        "longitude": "19.04016000"
                    },
                    {
                        "id": 55281,
                        "name": "Budapest XXIII. kerület",
                        "latitude": "47.39788000",
                        "longitude": "19.11492000"
                    },
                    {
                        "id": 55413,
                        "name": "Erzsébetváros",
                        "latitude": "47.50207000",
                        "longitude": "19.07218000"
                    },
                    {
                        "id": 55554,
                        "name": "Józsefváros",
                        "latitude": "47.48938000",
                        "longitude": "19.07292000"
                    },
                    {
                        "id": 55607,
                        "name": "Kispest",
                        "latitude": "47.45150000",
                        "longitude": "19.14017000"
                    },
                    {
                        "id": 56133,
                        "name": "Zugló",
                        "latitude": "47.51758000",
                        "longitude": "19.10549000"
                    }
                ]
            },
            {
                "id": 1031,
                "name": "Csongrád County",
                "iso2": "CS",
                "latitude": "46.41670500",
                "longitude": "20.25661610",
                "type": "county",
                "cities": [
                    {
                        "id": 55184,
                        "name": "Algyő",
                        "latitude": "46.33472000",
                        "longitude": "20.20849000"
                    },
                    {
                        "id": 55192,
                        "name": "Apátfalva",
                        "latitude": "46.16667000",
                        "longitude": "20.58333000"
                    },
                    {
                        "id": 56143,
                        "name": "Ásotthalom",
                        "latitude": "46.19875000",
                        "longitude": "19.78334000"
                    },
                    {
                        "id": 55207,
                        "name": "Baks",
                        "latitude": "46.54297000",
                        "longitude": "20.10213000"
                    },
                    {
                        "id": 55228,
                        "name": "Balástya",
                        "latitude": "46.42277000",
                        "longitude": "20.00816000"
                    },
                    {
                        "id": 55257,
                        "name": "Bordány",
                        "latitude": "46.31843000",
                        "longitude": "19.92306000"
                    },
                    {
                        "id": 55326,
                        "name": "Csanádpalota",
                        "latitude": "46.25000000",
                        "longitude": "20.73333000"
                    },
                    {
                        "id": 55324,
                        "name": "Csanytelek",
                        "latitude": "46.59501000",
                        "longitude": "20.12342000"
                    },
                    {
                        "id": 55328,
                        "name": "Csengele",
                        "latitude": "46.54234000",
                        "longitude": "19.86358000"
                    },
                    {
                        "id": 55337,
                        "name": "Csongrád",
                        "latitude": "46.71332000",
                        "longitude": "20.14241000"
                    },
                    {
                        "id": 55338,
                        "name": "Csongrádi Járás",
                        "latitude": "46.66146000",
                        "longitude": "20.08792000"
                    },
                    {
                        "id": 55359,
                        "name": "Deszk",
                        "latitude": "46.21802000",
                        "longitude": "20.24322000"
                    },
                    {
                        "id": 55365,
                        "name": "Domaszék",
                        "latitude": "46.24917000",
                        "longitude": "20.01111000"
                    },
                    {
                        "id": 55434,
                        "name": "Fábiánsebestyén",
                        "latitude": "46.68333000",
                        "longitude": "20.46667000"
                    },
                    {
                        "id": 55438,
                        "name": "Földeák",
                        "latitude": "46.31667000",
                        "longitude": "20.50000000"
                    },
                    {
                        "id": 55432,
                        "name": "Forráskút",
                        "latitude": "46.36528000",
                        "longitude": "19.90973000"
                    },
                    {
                        "id": 55521,
                        "name": "Hódmezővásárhely",
                        "latitude": "46.41667000",
                        "longitude": "20.33333000"
                    },
                    {
                        "id": 55522,
                        "name": "Hódmezővásárhelyi Járás",
                        "latitude": "46.43301000",
                        "longitude": "20.37598000"
                    },
                    {
                        "id": 55610,
                        "name": "Kistelek",
                        "latitude": "46.47250000",
                        "longitude": "19.97972000"
                    },
                    {
                        "id": 55611,
                        "name": "Kisteleki Járás",
                        "latitude": "46.48835000",
                        "longitude": "19.99568000"
                    },
                    {
                        "id": 55614,
                        "name": "Kiszombor",
                        "latitude": "46.18333000",
                        "longitude": "20.43333000"
                    },
                    {
                        "id": 55677,
                        "name": "Makó",
                        "latitude": "46.21667000",
                        "longitude": "20.48333000"
                    },
                    {
                        "id": 55678,
                        "name": "Makói Járás",
                        "latitude": "46.26698000",
                        "longitude": "20.54200000"
                    },
                    {
                        "id": 55681,
                        "name": "Maroslele",
                        "latitude": "46.26667000",
                        "longitude": "20.35000000"
                    },
                    {
                        "id": 55704,
                        "name": "Mindszent",
                        "latitude": "46.52362000",
                        "longitude": "20.19038000"
                    },
                    {
                        "id": 55734,
                        "name": "Mórahalmi Járás",
                        "latitude": "46.26840000",
                        "longitude": "19.82256000"
                    },
                    {
                        "id": 55735,
                        "name": "Mórahalom",
                        "latitude": "46.21806000",
                        "longitude": "19.88510000"
                    },
                    {
                        "id": 56152,
                        "name": "Ópusztaszer",
                        "latitude": "46.48592000",
                        "longitude": "20.08722000"
                    },
                    {
                        "id": 55835,
                        "name": "Pusztaszer",
                        "latitude": "46.55083000",
                        "longitude": "19.98823000"
                    },
                    {
                        "id": 55881,
                        "name": "Röszke",
                        "latitude": "46.18796000",
                        "longitude": "20.03372000"
                    },
                    {
                        "id": 55868,
                        "name": "Ruzsa",
                        "latitude": "46.28806000",
                        "longitude": "19.74714000"
                    },
                    {
                        "id": 55980,
                        "name": "Sándorfalva",
                        "latitude": "46.36087000",
                        "longitude": "20.09889000"
                    },
                    {
                        "id": 55923,
                        "name": "Szatymaz",
                        "latitude": "46.34306000",
                        "longitude": "20.04020000"
                    },
                    {
                        "id": 55925,
                        "name": "Szeged",
                        "latitude": "46.25300000",
                        "longitude": "20.14824000"
                    },
                    {
                        "id": 55926,
                        "name": "Szegedi Járás",
                        "latitude": "46.29536000",
                        "longitude": "20.13758000"
                    },
                    {
                        "id": 55929,
                        "name": "Szegvár",
                        "latitude": "46.58740000",
                        "longitude": "20.22408000"
                    },
                    {
                        "id": 55976,
                        "name": "Székkutas",
                        "latitude": "46.50000000",
                        "longitude": "20.53333000"
                    },
                    {
                        "id": 55936,
                        "name": "Szentes",
                        "latitude": "46.65834000",
                        "longitude": "20.26080000"
                    },
                    {
                        "id": 55937,
                        "name": "Szentesi Járás",
                        "latitude": "46.66005000",
                        "longitude": "20.37314000"
                    },
                    {
                        "id": 56081,
                        "name": "Tömörkény",
                        "latitude": "46.61716000",
                        "longitude": "20.04357000"
                    },
                    {
                        "id": 56167,
                        "name": "Üllés",
                        "latitude": "46.33611000",
                        "longitude": "19.84454000"
                    },
                    {
                        "id": 56136,
                        "name": "Zákányszék",
                        "latitude": "46.27453000",
                        "longitude": "19.88975000"
                    },
                    {
                        "id": 56130,
                        "name": "Zsombó",
                        "latitude": "46.32566000",
                        "longitude": "19.97464000"
                    }
                ]
            },
            {
                "id": 1032,
                "name": "Debrecen",
                "iso2": "DE",
                "latitude": "47.53160490",
                "longitude": "21.62731240",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1049,
                "name": "Dunaújváros",
                "iso2": "DU",
                "latitude": "46.96190590",
                "longitude": "18.93552270",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1037,
                "name": "Eger",
                "iso2": "EG",
                "latitude": "47.90253480",
                "longitude": "20.37722840",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1028,
                "name": "Érd",
                "iso2": "ER",
                "latitude": "47.39197180",
                "longitude": "18.90454400",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1044,
                "name": "Fejér County",
                "iso2": "FE",
                "latitude": "47.12179320",
                "longitude": "18.52948150",
                "type": "county",
                "cities": [
                    {
                        "id": 55168,
                        "name": "Aba",
                        "latitude": "47.02907000",
                        "longitude": "18.52172000"
                    },
                    {
                        "id": 55175,
                        "name": "Adony",
                        "latitude": "47.11940000",
                        "longitude": "18.86493000"
                    },
                    {
                        "id": 55181,
                        "name": "Alap",
                        "latitude": "46.79915000",
                        "longitude": "18.68938000"
                    },
                    {
                        "id": 55205,
                        "name": "Bakonycsernye",
                        "latitude": "47.32395000",
                        "longitude": "18.07509000"
                    },
                    {
                        "id": 55229,
                        "name": "Baracs",
                        "latitude": "46.88202000",
                        "longitude": "18.90658000"
                    },
                    {
                        "id": 55230,
                        "name": "Baracska",
                        "latitude": "47.28225000",
                        "longitude": "18.75853000"
                    },
                    {
                        "id": 55246,
                        "name": "Bicske",
                        "latitude": "47.48419000",
                        "longitude": "18.64404000"
                    },
                    {
                        "id": 55247,
                        "name": "Bicskei Járás",
                        "latitude": "47.43380000",
                        "longitude": "18.56757000"
                    },
                    {
                        "id": 55250,
                        "name": "Bodajk",
                        "latitude": "47.32352000",
                        "longitude": "18.23312000"
                    },
                    {
                        "id": 55314,
                        "name": "Cece",
                        "latitude": "46.77056000",
                        "longitude": "18.62826000"
                    },
                    {
                        "id": 55345,
                        "name": "Csákvár",
                        "latitude": "47.39184000",
                        "longitude": "18.46501000"
                    },
                    {
                        "id": 55387,
                        "name": "Dég",
                        "latitude": "46.86807000",
                        "longitude": "18.45042000"
                    },
                    {
                        "id": 56139,
                        "name": "dunaújváros",
                        "latitude": "46.96737000",
                        "longitude": "18.93288000"
                    },
                    {
                        "id": 55382,
                        "name": "Dunaújvárosi Járás",
                        "latitude": "47.02801000",
                        "longitude": "18.82997000"
                    },
                    {
                        "id": 55403,
                        "name": "Előszállás",
                        "latitude": "46.83094000",
                        "longitude": "18.83481000"
                    },
                    {
                        "id": 55408,
                        "name": "Enying",
                        "latitude": "46.93046000",
                        "longitude": "18.24202000"
                    },
                    {
                        "id": 55409,
                        "name": "Enyingi Járás",
                        "latitude": "46.87240000",
                        "longitude": "18.30975000"
                    },
                    {
                        "id": 55410,
                        "name": "Ercsi",
                        "latitude": "47.25194000",
                        "longitude": "18.89623000"
                    },
                    {
                        "id": 55414,
                        "name": "Etyek",
                        "latitude": "47.44794000",
                        "longitude": "18.75328000"
                    },
                    {
                        "id": 55422,
                        "name": "Fehérvárcsurgó",
                        "latitude": "47.29349000",
                        "longitude": "18.26460000"
                    },
                    {
                        "id": 55471,
                        "name": "Gárdony",
                        "latitude": "47.20942000",
                        "longitude": "18.63607000"
                    },
                    {
                        "id": 55472,
                        "name": "Gárdonyi Járás",
                        "latitude": "47.22785000",
                        "longitude": "18.63622000"
                    },
                    {
                        "id": 55530,
                        "name": "Iváncsa",
                        "latitude": "47.15670000",
                        "longitude": "18.82030000"
                    },
                    {
                        "id": 55638,
                        "name": "Káloz",
                        "latitude": "46.95464000",
                        "longitude": "18.48259000"
                    },
                    {
                        "id": 55640,
                        "name": "Kápolnásnyék",
                        "latitude": "47.24004000",
                        "longitude": "18.67564000"
                    },
                    {
                        "id": 55593,
                        "name": "Kincsesbánya",
                        "latitude": "47.26444000",
                        "longitude": "18.27790000"
                    },
                    {
                        "id": 55604,
                        "name": "Kisláng",
                        "latitude": "46.95744000",
                        "longitude": "18.38813000"
                    },
                    {
                        "id": 55653,
                        "name": "Lajoskomárom",
                        "latitude": "46.84201000",
                        "longitude": "18.33763000"
                    },
                    {
                        "id": 55659,
                        "name": "Lepsény",
                        "latitude": "46.99036000",
                        "longitude": "18.24357000"
                    },
                    {
                        "id": 55665,
                        "name": "Lovasberény",
                        "latitude": "47.30997000",
                        "longitude": "18.55177000"
                    },
                    {
                        "id": 55722,
                        "name": "Mány",
                        "latitude": "47.53352000",
                        "longitude": "18.65627000"
                    },
                    {
                        "id": 55682,
                        "name": "Martonvásár",
                        "latitude": "47.31601000",
                        "longitude": "18.79045000"
                    },
                    {
                        "id": 55683,
                        "name": "Martonvásári Járás",
                        "latitude": "47.29040000",
                        "longitude": "18.79945000"
                    },
                    {
                        "id": 55691,
                        "name": "Mezőfalva",
                        "latitude": "46.93184000",
                        "longitude": "18.77177000"
                    },
                    {
                        "id": 55698,
                        "name": "Mezőszilas",
                        "latitude": "46.81109000",
                        "longitude": "18.47789000"
                    },
                    {
                        "id": 55733,
                        "name": "Mór",
                        "latitude": "47.37787000",
                        "longitude": "18.20353000"
                    },
                    {
                        "id": 55736,
                        "name": "Móri Járás",
                        "latitude": "47.34685000",
                        "longitude": "18.19838000"
                    },
                    {
                        "id": 55839,
                        "name": "Pákozd",
                        "latitude": "47.21369000",
                        "longitude": "18.53306000"
                    },
                    {
                        "id": 55848,
                        "name": "Pázmánd",
                        "latitude": "47.28755000",
                        "longitude": "18.65356000"
                    },
                    {
                        "id": 55814,
                        "name": "Perkáta",
                        "latitude": "47.04701000",
                        "longitude": "18.78734000"
                    },
                    {
                        "id": 55828,
                        "name": "Polgárdi",
                        "latitude": "47.06099000",
                        "longitude": "18.30200000"
                    },
                    {
                        "id": 55834,
                        "name": "Pusztaszabolcs",
                        "latitude": "47.13718000",
                        "longitude": "18.76704000"
                    },
                    {
                        "id": 55836,
                        "name": "Pusztavám",
                        "latitude": "47.42948000",
                        "longitude": "18.22648000"
                    },
                    {
                        "id": 55870,
                        "name": "Rácalmás",
                        "latitude": "47.02263000",
                        "longitude": "18.94056000"
                    },
                    {
                        "id": 55871,
                        "name": "Ráckeresztúr",
                        "latitude": "47.27360000",
                        "longitude": "18.83343000"
                    },
                    {
                        "id": 55981,
                        "name": "Sárbogárd",
                        "latitude": "46.88692000",
                        "longitude": "18.62041000"
                    },
                    {
                        "id": 55982,
                        "name": "Sárbogárdi Járás",
                        "latitude": "46.84036000",
                        "longitude": "18.60723000"
                    },
                    {
                        "id": 55983,
                        "name": "Sárkeresztúr",
                        "latitude": "47.00540000",
                        "longitude": "18.54391000"
                    },
                    {
                        "id": 55985,
                        "name": "Sárosd",
                        "latitude": "47.04273000",
                        "longitude": "18.64357000"
                    },
                    {
                        "id": 55989,
                        "name": "Sárszentmihály",
                        "latitude": "47.15321000",
                        "longitude": "18.33879000"
                    },
                    {
                        "id": 55896,
                        "name": "Seregélyes",
                        "latitude": "47.11050000",
                        "longitude": "18.56500000"
                    },
                    {
                        "id": 55908,
                        "name": "Soponya",
                        "latitude": "47.01485000",
                        "longitude": "18.45343000"
                    },
                    {
                        "id": 55911,
                        "name": "Szabadbattyán",
                        "latitude": "47.11902000",
                        "longitude": "18.36823000"
                    },
                    {
                        "id": 55969,
                        "name": "Szárliget",
                        "latitude": "47.51581000",
                        "longitude": "18.49480000"
                    },
                    {
                        "id": 55974,
                        "name": "Székesfehérvár",
                        "latitude": "47.18995000",
                        "longitude": "18.41034000"
                    },
                    {
                        "id": 55975,
                        "name": "Székesfehérvári Járás",
                        "latitude": "47.16531000",
                        "longitude": "18.41349000"
                    },
                    {
                        "id": 56108,
                        "name": "Vál",
                        "latitude": "47.36264000",
                        "longitude": "18.67931000"
                    },
                    {
                        "id": 56096,
                        "name": "Velence",
                        "latitude": "47.23855000",
                        "longitude": "18.65484000"
                    },
                    {
                        "id": 56137,
                        "name": "Zámoly",
                        "latitude": "47.31667000",
                        "longitude": "18.40810000"
                    }
                ]
            },
            {
                "id": 1041,
                "name": "Győr",
                "iso2": "GY",
                "latitude": "47.68745690",
                "longitude": "17.65039740",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1042,
                "name": "Győr-Moson-Sopron County",
                "iso2": "GS",
                "latitude": "47.65092850",
                "longitude": "17.25058830",
                "type": "county",
                "cities": [
                    {
                        "id": 55171,
                        "name": "Abda",
                        "latitude": "47.69464000",
                        "longitude": "17.54489000"
                    },
                    {
                        "id": 56142,
                        "name": "Ágfalva",
                        "latitude": "47.68991000",
                        "longitude": "16.51658000"
                    },
                    {
                        "id": 56144,
                        "name": "Ásványráró",
                        "latitude": "47.82733000",
                        "longitude": "17.49418000"
                    },
                    {
                        "id": 55206,
                        "name": "Bakonyszentlászló",
                        "latitude": "47.38901000",
                        "longitude": "17.80321000"
                    },
                    {
                        "id": 55236,
                        "name": "Beled",
                        "latitude": "47.46594000",
                        "longitude": "17.09294000"
                    },
                    {
                        "id": 55312,
                        "name": "Bőny",
                        "latitude": "47.65000000",
                        "longitude": "17.86977000"
                    },
                    {
                        "id": 55313,
                        "name": "Bősárkány",
                        "latitude": "47.68821000",
                        "longitude": "17.25000000"
                    },
                    {
                        "id": 55340,
                        "name": "Csorna",
                        "latitude": "47.61155000",
                        "longitude": "17.25012000"
                    },
                    {
                        "id": 55341,
                        "name": "Csornai Járás",
                        "latitude": "47.58403000",
                        "longitude": "17.26041000"
                    },
                    {
                        "id": 55418,
                        "name": "Farád",
                        "latitude": "47.60633000",
                        "longitude": "17.20024000"
                    },
                    {
                        "id": 55427,
                        "name": "Fertőd",
                        "latitude": "47.62173000",
                        "longitude": "16.87088000"
                    },
                    {
                        "id": 55428,
                        "name": "Fertőrákos",
                        "latitude": "47.72017000",
                        "longitude": "16.65040000"
                    },
                    {
                        "id": 55429,
                        "name": "Fertőszentmiklós",
                        "latitude": "47.58996000",
                        "longitude": "16.87517000"
                    },
                    {
                        "id": 55466,
                        "name": "Győr",
                        "latitude": "47.68333000",
                        "longitude": "17.63512000"
                    },
                    {
                        "id": 55467,
                        "name": "Győri Járás",
                        "latitude": "47.67273000",
                        "longitude": "17.67936000"
                    },
                    {
                        "id": 55468,
                        "name": "Győrszemere",
                        "latitude": "47.55256000",
                        "longitude": "17.56356000"
                    },
                    {
                        "id": 55469,
                        "name": "Győrújbarát",
                        "latitude": "47.60643000",
                        "longitude": "17.64875000"
                    },
                    {
                        "id": 55495,
                        "name": "Halászi",
                        "latitude": "47.88930000",
                        "longitude": "17.32615000"
                    },
                    {
                        "id": 55539,
                        "name": "Jánossomorja",
                        "latitude": "47.78621000",
                        "longitude": "17.13603000"
                    },
                    {
                        "id": 55563,
                        "name": "Kapuvár",
                        "latitude": "47.59224000",
                        "longitude": "17.02886000"
                    },
                    {
                        "id": 55564,
                        "name": "Kapuvári Járás",
                        "latitude": "47.56705000",
                        "longitude": "17.04056000"
                    },
                    {
                        "id": 55592,
                        "name": "Kimle",
                        "latitude": "47.81726000",
                        "longitude": "17.36642000"
                    },
                    {
                        "id": 55645,
                        "name": "Kóny",
                        "latitude": "47.63053000",
                        "longitude": "17.35717000"
                    },
                    {
                        "id": 55668,
                        "name": "Lébény",
                        "latitude": "47.73574000",
                        "longitude": "17.39076000"
                    },
                    {
                        "id": 55702,
                        "name": "Mihályi",
                        "latitude": "47.51384000",
                        "longitude": "17.09507000"
                    },
                    {
                        "id": 55714,
                        "name": "Mosonmagyaróvár",
                        "latitude": "47.86789000",
                        "longitude": "17.26994000"
                    },
                    {
                        "id": 55715,
                        "name": "Mosonmagyaróvári Járás",
                        "latitude": "47.85767000",
                        "longitude": "17.28212000"
                    },
                    {
                        "id": 55716,
                        "name": "Mosonszentmiklós",
                        "latitude": "47.72778000",
                        "longitude": "17.42784000"
                    },
                    {
                        "id": 55742,
                        "name": "Nagycenk",
                        "latitude": "47.60435000",
                        "longitude": "16.69732000"
                    },
                    {
                        "id": 55793,
                        "name": "Nyúl",
                        "latitude": "47.59047000",
                        "longitude": "17.68904000"
                    },
                    {
                        "id": 56159,
                        "name": "Öttevény",
                        "latitude": "47.71946000",
                        "longitude": "17.48474000"
                    },
                    {
                        "id": 55808,
                        "name": "Pannonhalma",
                        "latitude": "47.54946000",
                        "longitude": "17.75535000"
                    },
                    {
                        "id": 55809,
                        "name": "Pannonhalmi Járás",
                        "latitude": "47.45571000",
                        "longitude": "17.81335000"
                    },
                    {
                        "id": 55854,
                        "name": "Pér",
                        "latitude": "47.61153000",
                        "longitude": "17.80632000"
                    },
                    {
                        "id": 55869,
                        "name": "Rábapatona",
                        "latitude": "47.63224000",
                        "longitude": "17.48004000"
                    },
                    {
                        "id": 55861,
                        "name": "Rajka",
                        "latitude": "47.99643000",
                        "longitude": "17.19821000"
                    },
                    {
                        "id": 55909,
                        "name": "Sopron",
                        "latitude": "47.68501000",
                        "longitude": "16.59049000"
                    },
                    {
                        "id": 55910,
                        "name": "Soproni Járás",
                        "latitude": "47.60385000",
                        "longitude": "16.75654000"
                    },
                    {
                        "id": 55920,
                        "name": "Szany",
                        "latitude": "47.46423000",
                        "longitude": "17.30402000"
                    },
                    {
                        "id": 56074,
                        "name": "Tét",
                        "latitude": "47.51922000",
                        "longitude": "17.50802000"
                    },
                    {
                        "id": 56075,
                        "name": "Téti Járás",
                        "latitude": "47.51515000",
                        "longitude": "17.51612000"
                    },
                    {
                        "id": 56080,
                        "name": "Töltéstava",
                        "latitude": "47.62609000",
                        "longitude": "17.73376000"
                    }
                ]
            },
            {
                "id": 1063,
                "name": "Hajdú-Bihar County",
                "iso2": "HB",
                "latitude": "47.46883550",
                "longitude": "21.54532270",
                "type": "county",
                "cities": [
                    {
                        "id": 55202,
                        "name": "Bagamér",
                        "latitude": "47.44882000",
                        "longitude": "21.98900000"
                    },
                    {
                        "id": 55226,
                        "name": "Balmazújváros",
                        "latitude": "47.61667000",
                        "longitude": "21.35000000"
                    },
                    {
                        "id": 55227,
                        "name": "Balmazújvárosi Járás",
                        "latitude": "47.61840000",
                        "longitude": "21.14882000"
                    },
                    {
                        "id": 55290,
                        "name": "Báránd",
                        "latitude": "47.30000000",
                        "longitude": "21.23333000"
                    },
                    {
                        "id": 55239,
                        "name": "Berettyóújfalu",
                        "latitude": "47.21667000",
                        "longitude": "21.55000000"
                    },
                    {
                        "id": 55240,
                        "name": "Berettyóújfalui Járás",
                        "latitude": "47.14109000",
                        "longitude": "21.55233000"
                    },
                    {
                        "id": 55248,
                        "name": "Biharkeresztes",
                        "latitude": "47.13333000",
                        "longitude": "21.71667000"
                    },
                    {
                        "id": 55249,
                        "name": "Biharnagybajom",
                        "latitude": "47.21667000",
                        "longitude": "21.23333000"
                    },
                    {
                        "id": 55349,
                        "name": "Csökmő",
                        "latitude": "47.03333000",
                        "longitude": "21.30000000"
                    },
                    {
                        "id": 55353,
                        "name": "Debrecen",
                        "latitude": "47.53333000",
                        "longitude": "21.63333000"
                    },
                    {
                        "id": 55354,
                        "name": "Debreceni Járás",
                        "latitude": "47.52706000",
                        "longitude": "21.66869000"
                    },
                    {
                        "id": 55357,
                        "name": "Derecske",
                        "latitude": "47.35000000",
                        "longitude": "21.56667000"
                    },
                    {
                        "id": 55358,
                        "name": "Derecskei Járás",
                        "latitude": "47.38194000",
                        "longitude": "21.74836000"
                    },
                    {
                        "id": 55393,
                        "name": "Ebes",
                        "latitude": "47.46667000",
                        "longitude": "21.50000000"
                    },
                    {
                        "id": 55401,
                        "name": "Egyek",
                        "latitude": "47.63333000",
                        "longitude": "20.90000000"
                    },
                    {
                        "id": 55437,
                        "name": "Földes",
                        "latitude": "47.30000000",
                        "longitude": "21.36667000"
                    },
                    {
                        "id": 55479,
                        "name": "Görbeháza",
                        "latitude": "47.83333000",
                        "longitude": "21.23333000"
                    },
                    {
                        "id": 55480,
                        "name": "Hadjúszoboszlói Járás",
                        "latitude": "47.48110000",
                        "longitude": "21.31000000"
                    },
                    {
                        "id": 55481,
                        "name": "Hajdúbagos",
                        "latitude": "47.39295000",
                        "longitude": "21.66551000"
                    },
                    {
                        "id": 55482,
                        "name": "Hajdúböszörmény",
                        "latitude": "47.66667000",
                        "longitude": "21.51667000"
                    },
                    {
                        "id": 55483,
                        "name": "Hajdúböszörményi Járás",
                        "latitude": "47.74000000",
                        "longitude": "21.50000000"
                    },
                    {
                        "id": 55484,
                        "name": "Hajdúdorog",
                        "latitude": "47.81667000",
                        "longitude": "21.50000000"
                    },
                    {
                        "id": 55485,
                        "name": "Hajdúhadház",
                        "latitude": "47.68333000",
                        "longitude": "21.66667000"
                    },
                    {
                        "id": 55486,
                        "name": "Hajdúhadházi Járás",
                        "latitude": "47.67000000",
                        "longitude": "21.70000000"
                    },
                    {
                        "id": 55487,
                        "name": "Hajdúnánás",
                        "latitude": "47.85000000",
                        "longitude": "21.43333000"
                    },
                    {
                        "id": 55488,
                        "name": "Hajdúnánási Járás",
                        "latitude": "47.83350000",
                        "longitude": "21.25256000"
                    },
                    {
                        "id": 55491,
                        "name": "Hajdúsámson",
                        "latitude": "47.60000000",
                        "longitude": "21.76667000"
                    },
                    {
                        "id": 55489,
                        "name": "Hajdúszoboszló",
                        "latitude": "47.45000000",
                        "longitude": "21.40000000"
                    },
                    {
                        "id": 55490,
                        "name": "Hajdúszovát",
                        "latitude": "47.38333000",
                        "longitude": "21.48333000"
                    },
                    {
                        "id": 55515,
                        "name": "Hortobágy",
                        "latitude": "47.58278000",
                        "longitude": "21.15108000"
                    },
                    {
                        "id": 55517,
                        "name": "Hosszúpályi",
                        "latitude": "47.39303000",
                        "longitude": "21.73280000"
                    },
                    {
                        "id": 55555,
                        "name": "Kaba",
                        "latitude": "47.35000000",
                        "longitude": "21.28333000"
                    },
                    {
                        "id": 55621,
                        "name": "Komádi",
                        "latitude": "47.00000000",
                        "longitude": "21.50000000"
                    },
                    {
                        "id": 55623,
                        "name": "Konyár",
                        "latitude": "47.31667000",
                        "longitude": "21.66667000"
                    },
                    {
                        "id": 55669,
                        "name": "Létavértes",
                        "latitude": "47.38333000",
                        "longitude": "21.90000000"
                    },
                    {
                        "id": 55703,
                        "name": "Mikepércs",
                        "latitude": "47.45000000",
                        "longitude": "21.63333000"
                    },
                    {
                        "id": 55713,
                        "name": "Monostorpályi",
                        "latitude": "47.40000000",
                        "longitude": "21.78333000"
                    },
                    {
                        "id": 55794,
                        "name": "Nádudvar",
                        "latitude": "47.41667000",
                        "longitude": "21.16667000"
                    },
                    {
                        "id": 55760,
                        "name": "Nagyrábé",
                        "latitude": "47.20000000",
                        "longitude": "21.33333000"
                    },
                    {
                        "id": 55792,
                        "name": "Nyírábrány",
                        "latitude": "47.55311000",
                        "longitude": "22.02401000"
                    },
                    {
                        "id": 55770,
                        "name": "Nyíracsád",
                        "latitude": "47.60330000",
                        "longitude": "21.97208000"
                    },
                    {
                        "id": 55771,
                        "name": "Nyíradony",
                        "latitude": "47.69746000",
                        "longitude": "21.91878000"
                    },
                    {
                        "id": 55772,
                        "name": "Nyíradonyi Járás",
                        "latitude": "47.57873000",
                        "longitude": "22.01381000"
                    },
                    {
                        "id": 55787,
                        "name": "Nyírmártonfalva",
                        "latitude": "47.58333000",
                        "longitude": "21.90000000"
                    },
                    {
                        "id": 55826,
                        "name": "Pocsaj",
                        "latitude": "47.28333000",
                        "longitude": "21.81667000"
                    },
                    {
                        "id": 55827,
                        "name": "Polgár",
                        "latitude": "47.86667000",
                        "longitude": "21.11667000"
                    },
                    {
                        "id": 55859,
                        "name": "Püspökladány",
                        "latitude": "47.31667000",
                        "longitude": "21.11667000"
                    },
                    {
                        "id": 55860,
                        "name": "Püspökladányi Járás",
                        "latitude": "47.31279000",
                        "longitude": "21.21177000"
                    },
                    {
                        "id": 55992,
                        "name": "Sáránd",
                        "latitude": "47.40000000",
                        "longitude": "21.63333000"
                    },
                    {
                        "id": 55988,
                        "name": "Sárrétudvari",
                        "latitude": "47.23333000",
                        "longitude": "21.20000000"
                    },
                    {
                        "id": 56073,
                        "name": "Téglás",
                        "latitude": "47.71667000",
                        "longitude": "21.68333000"
                    },
                    {
                        "id": 56026,
                        "name": "Tiszacsege",
                        "latitude": "47.70000000",
                        "longitude": "21.00000000"
                    },
                    {
                        "id": 56110,
                        "name": "Vámospércs",
                        "latitude": "47.53333000",
                        "longitude": "21.90000000"
                    }
                ]
            },
            {
                "id": 1040,
                "name": "Heves County",
                "iso2": "HE",
                "latitude": "47.80576170",
                "longitude": "20.20385590",
                "type": "county",
                "cities": [
                    {
                        "id": 55169,
                        "name": "Abasár",
                        "latitude": "47.79705000",
                        "longitude": "20.00324000"
                    },
                    {
                        "id": 55176,
                        "name": "Adács",
                        "latitude": "47.69210000",
                        "longitude": "19.97696000"
                    },
                    {
                        "id": 55188,
                        "name": "Andornaktálya",
                        "latitude": "47.85000000",
                        "longitude": "20.41667000"
                    },
                    {
                        "id": 55190,
                        "name": "Apc",
                        "latitude": "47.79419000",
                        "longitude": "19.69429000"
                    },
                    {
                        "id": 55302,
                        "name": "Bélapátfalva",
                        "latitude": "48.05000000",
                        "longitude": "20.36667000"
                    },
                    {
                        "id": 55303,
                        "name": "Bélapátfalvai Járás",
                        "latitude": "48.06386000",
                        "longitude": "20.36163000"
                    },
                    {
                        "id": 55244,
                        "name": "Besenyőtelek",
                        "latitude": "47.70000000",
                        "longitude": "20.43333000"
                    },
                    {
                        "id": 55253,
                        "name": "Boldog",
                        "latitude": "47.60285000",
                        "longitude": "19.68839000"
                    },
                    {
                        "id": 55346,
                        "name": "Csány",
                        "latitude": "47.64829000",
                        "longitude": "19.82972000"
                    },
                    {
                        "id": 55371,
                        "name": "Domoszló",
                        "latitude": "47.83333000",
                        "longitude": "20.11667000"
                    },
                    {
                        "id": 55395,
                        "name": "Ecséd",
                        "latitude": "47.73267000",
                        "longitude": "19.76696000"
                    },
                    {
                        "id": 55398,
                        "name": "Eger",
                        "latitude": "47.90265000",
                        "longitude": "20.37329000"
                    },
                    {
                        "id": 55399,
                        "name": "Egerszalók",
                        "latitude": "47.86667000",
                        "longitude": "20.33333000"
                    },
                    {
                        "id": 55400,
                        "name": "Egri Járás",
                        "latitude": "47.92961000",
                        "longitude": "20.37383000"
                    },
                    {
                        "id": 55412,
                        "name": "Erdőtelek",
                        "latitude": "47.68333000",
                        "longitude": "20.31667000"
                    },
                    {
                        "id": 55425,
                        "name": "Felsőtárkány",
                        "latitude": "47.96667000",
                        "longitude": "20.41667000"
                    },
                    {
                        "id": 55441,
                        "name": "Füzesabony",
                        "latitude": "47.75000000",
                        "longitude": "20.41667000"
                    },
                    {
                        "id": 55442,
                        "name": "Füzesabonyi Járás",
                        "latitude": "47.72671000",
                        "longitude": "20.42875000"
                    },
                    {
                        "id": 55459,
                        "name": "Gyöngyös",
                        "latitude": "47.78257000",
                        "longitude": "19.92800000"
                    },
                    {
                        "id": 55460,
                        "name": "Gyöngyöshalász",
                        "latitude": "47.74161000",
                        "longitude": "19.92876000"
                    },
                    {
                        "id": 55461,
                        "name": "Gyöngyösi Járás",
                        "latitude": "47.79079000",
                        "longitude": "19.95430000"
                    },
                    {
                        "id": 55462,
                        "name": "Gyöngyöspata",
                        "latitude": "47.81505000",
                        "longitude": "19.78925000"
                    },
                    {
                        "id": 55463,
                        "name": "Gyöngyössolymos",
                        "latitude": "47.81724000",
                        "longitude": "19.93619000"
                    },
                    {
                        "id": 55464,
                        "name": "Gyöngyöstarján",
                        "latitude": "47.81369000",
                        "longitude": "19.86724000"
                    },
                    {
                        "id": 55500,
                        "name": "Hatvan",
                        "latitude": "47.66667000",
                        "longitude": "19.68333000"
                    },
                    {
                        "id": 55501,
                        "name": "Hatvani Járás",
                        "latitude": "47.69468000",
                        "longitude": "19.72852000"
                    },
                    {
                        "id": 55509,
                        "name": "Heréd",
                        "latitude": "47.70638000",
                        "longitude": "19.63314000"
                    },
                    {
                        "id": 55510,
                        "name": "Heves",
                        "latitude": "47.60000000",
                        "longitude": "20.28333000"
                    },
                    {
                        "id": 55511,
                        "name": "Hevesi Járás",
                        "latitude": "47.61535000",
                        "longitude": "20.31739000"
                    },
                    {
                        "id": 55514,
                        "name": "Hort",
                        "latitude": "47.69081000",
                        "longitude": "19.78930000"
                    },
                    {
                        "id": 55635,
                        "name": "Kál",
                        "latitude": "47.73333000",
                        "longitude": "20.26667000"
                    },
                    {
                        "id": 55571,
                        "name": "Karácsond",
                        "latitude": "47.72962000",
                        "longitude": "20.03076000"
                    },
                    {
                        "id": 55586,
                        "name": "Kerecsend",
                        "latitude": "47.80000000",
                        "longitude": "20.35000000"
                    },
                    {
                        "id": 55601,
                        "name": "Kisköre",
                        "latitude": "47.50000000",
                        "longitude": "20.50000000"
                    },
                    {
                        "id": 55620,
                        "name": "Kompolt",
                        "latitude": "47.73333000",
                        "longitude": "20.25000000"
                    },
                    {
                        "id": 55671,
                        "name": "Lőrinci",
                        "latitude": "47.73295000",
                        "longitude": "19.67867000"
                    },
                    {
                        "id": 55676,
                        "name": "Maklár",
                        "latitude": "47.80000000",
                        "longitude": "20.41667000"
                    },
                    {
                        "id": 55724,
                        "name": "Mátraderecske",
                        "latitude": "47.95000000",
                        "longitude": "20.08333000"
                    },
                    {
                        "id": 55761,
                        "name": "Nagyréde",
                        "latitude": "47.76543000",
                        "longitude": "19.84819000"
                    },
                    {
                        "id": 55802,
                        "name": "Ostoros",
                        "latitude": "47.86667000",
                        "longitude": "20.43333000"
                    },
                    {
                        "id": 55810,
                        "name": "Parád",
                        "latitude": "47.92323000",
                        "longitude": "20.02972000"
                    },
                    {
                        "id": 55811,
                        "name": "Parádsasvár",
                        "latitude": "47.91260000",
                        "longitude": "19.97709000"
                    },
                    {
                        "id": 55856,
                        "name": "Pétervására",
                        "latitude": "48.01667000",
                        "longitude": "20.10000000"
                    },
                    {
                        "id": 55857,
                        "name": "Pétervásárai Járás",
                        "latitude": "48.00589000",
                        "longitude": "20.09466000"
                    },
                    {
                        "id": 55816,
                        "name": "Petőfibánya",
                        "latitude": "47.76960000",
                        "longitude": "19.69988000"
                    },
                    {
                        "id": 55831,
                        "name": "Poroszló",
                        "latitude": "47.65000000",
                        "longitude": "20.66667000"
                    },
                    {
                        "id": 55863,
                        "name": "Recsk",
                        "latitude": "47.93333000",
                        "longitude": "20.11667000"
                    },
                    {
                        "id": 55880,
                        "name": "Rózsaszentmárton",
                        "latitude": "47.78200000",
                        "longitude": "19.74210000"
                    },
                    {
                        "id": 55900,
                        "name": "Sirok",
                        "latitude": "47.93333000",
                        "longitude": "20.20000000"
                    },
                    {
                        "id": 55957,
                        "name": "Szihalom",
                        "latitude": "47.76667000",
                        "longitude": "20.48333000"
                    },
                    {
                        "id": 55960,
                        "name": "Szilvásvárad",
                        "latitude": "48.10000000",
                        "longitude": "20.40000000"
                    },
                    {
                        "id": 56013,
                        "name": "Tarnalelesz",
                        "latitude": "48.05000000",
                        "longitude": "20.18333000"
                    },
                    {
                        "id": 56014,
                        "name": "Tarnaörs",
                        "latitude": "47.59499000",
                        "longitude": "20.05254000"
                    },
                    {
                        "id": 56040,
                        "name": "Tiszanána",
                        "latitude": "47.56667000",
                        "longitude": "20.53333000"
                    },
                    {
                        "id": 56109,
                        "name": "Vámosgyörk",
                        "latitude": "47.68429000",
                        "longitude": "19.92924000"
                    },
                    {
                        "id": 56098,
                        "name": "Verpelét",
                        "latitude": "47.85000000",
                        "longitude": "20.23333000"
                    },
                    {
                        "id": 56119,
                        "name": "Zagyvaszántó",
                        "latitude": "47.77703000",
                        "longitude": "19.67092000"
                    }
                ]
            },
            {
                "id": 1027,
                "name": "Hódmezővásárhely",
                "iso2": "HV",
                "latitude": "46.41812620",
                "longitude": "20.33003150",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1043,
                "name": "Jász-Nagykun-Szolnok County",
                "iso2": "JN",
                "latitude": "47.25555790",
                "longitude": "20.52324560",
                "type": "county",
                "cities": [
                    {
                        "id": 55173,
                        "name": "Abádszalók",
                        "latitude": "47.46667000",
                        "longitude": "20.60000000"
                    },
                    {
                        "id": 55182,
                        "name": "Alattyán",
                        "latitude": "47.42705000",
                        "longitude": "20.04219000"
                    },
                    {
                        "id": 55243,
                        "name": "Besenyszög",
                        "latitude": "47.30000000",
                        "longitude": "20.26667000"
                    },
                    {
                        "id": 55320,
                        "name": "Cibakháza",
                        "latitude": "46.95976000",
                        "longitude": "20.19753000"
                    },
                    {
                        "id": 55333,
                        "name": "Cserkeszőlő",
                        "latitude": "46.86320000",
                        "longitude": "20.18701000"
                    },
                    {
                        "id": 55419,
                        "name": "Fegyvernek",
                        "latitude": "47.26667000",
                        "longitude": "20.53333000"
                    },
                    {
                        "id": 55537,
                        "name": "Jánoshida",
                        "latitude": "47.38333000",
                        "longitude": "20.06667000"
                    },
                    {
                        "id": 55541,
                        "name": "Jászalsószentgyörgy",
                        "latitude": "47.36667000",
                        "longitude": "20.10000000"
                    },
                    {
                        "id": 55542,
                        "name": "Jászapáti",
                        "latitude": "47.51667000",
                        "longitude": "20.15000000"
                    },
                    {
                        "id": 55543,
                        "name": "Jászapáti Járás",
                        "latitude": "47.46126000",
                        "longitude": "20.06567000"
                    },
                    {
                        "id": 55553,
                        "name": "Jászárokszállás",
                        "latitude": "47.64238000",
                        "longitude": "19.98038000"
                    },
                    {
                        "id": 55544,
                        "name": "Jászberény",
                        "latitude": "47.50000000",
                        "longitude": "19.91667000"
                    },
                    {
                        "id": 55545,
                        "name": "Jászberényi Járás",
                        "latitude": "47.56500000",
                        "longitude": "19.86887000"
                    },
                    {
                        "id": 55546,
                        "name": "Jászdózsa",
                        "latitude": "47.56610000",
                        "longitude": "20.01534000"
                    },
                    {
                        "id": 55547,
                        "name": "Jászjákóhalma",
                        "latitude": "47.52038000",
                        "longitude": "19.99086000"
                    },
                    {
                        "id": 55549,
                        "name": "Jászkisér",
                        "latitude": "47.45000000",
                        "longitude": "20.21667000"
                    },
                    {
                        "id": 55550,
                        "name": "Jászladány",
                        "latitude": "47.36667000",
                        "longitude": "20.16667000"
                    },
                    {
                        "id": 55551,
                        "name": "Jászszentandrás",
                        "latitude": "47.58333000",
                        "longitude": "20.18333000"
                    },
                    {
                        "id": 55567,
                        "name": "Karcag",
                        "latitude": "47.31667000",
                        "longitude": "20.93333000"
                    },
                    {
                        "id": 55568,
                        "name": "Karcagi Járás",
                        "latitude": "47.28583000",
                        "longitude": "20.84218000"
                    },
                    {
                        "id": 55584,
                        "name": "Kenderes",
                        "latitude": "47.25000000",
                        "longitude": "20.68333000"
                    },
                    {
                        "id": 55585,
                        "name": "Kengyel",
                        "latitude": "47.08333000",
                        "longitude": "20.33333000"
                    },
                    {
                        "id": 55615,
                        "name": "Kisújszállás",
                        "latitude": "47.21667000",
                        "longitude": "20.76667000"
                    },
                    {
                        "id": 55627,
                        "name": "Kunhegyes",
                        "latitude": "47.36667000",
                        "longitude": "20.63333000"
                    },
                    {
                        "id": 55628,
                        "name": "Kunhegyesi Járás",
                        "latitude": "47.40329000",
                        "longitude": "20.59199000"
                    },
                    {
                        "id": 55629,
                        "name": "Kunmadaras",
                        "latitude": "47.43333000",
                        "longitude": "20.80000000"
                    },
                    {
                        "id": 55632,
                        "name": "Kunszentmárton",
                        "latitude": "46.83916000",
                        "longitude": "20.28879000"
                    },
                    {
                        "id": 55633,
                        "name": "Kunszentmártoni Járás",
                        "latitude": "46.87698000",
                        "longitude": "20.25179000"
                    },
                    {
                        "id": 55699,
                        "name": "Mezőtúr",
                        "latitude": "47.00000000",
                        "longitude": "20.63333000"
                    },
                    {
                        "id": 55700,
                        "name": "Mezőtúri Járás",
                        "latitude": "47.02495000",
                        "longitude": "20.59046000"
                    },
                    {
                        "id": 56156,
                        "name": "Öcsöd",
                        "latitude": "46.90000000",
                        "longitude": "20.40000000"
                    },
                    {
                        "id": 55874,
                        "name": "Rákóczifalva",
                        "latitude": "47.08333000",
                        "longitude": "20.23333000"
                    },
                    {
                        "id": 55875,
                        "name": "Rákócziújfalu",
                        "latitude": "47.06667000",
                        "longitude": "20.26667000"
                    },
                    {
                        "id": 55915,
                        "name": "Szajol",
                        "latitude": "47.18333000",
                        "longitude": "20.30000000"
                    },
                    {
                        "id": 55932,
                        "name": "Szelevény",
                        "latitude": "46.80259000",
                        "longitude": "20.20283000"
                    },
                    {
                        "id": 55964,
                        "name": "Szolnok",
                        "latitude": "47.18333000",
                        "longitude": "20.20000000"
                    },
                    {
                        "id": 55965,
                        "name": "Szolnoki Járás",
                        "latitude": "47.22480000",
                        "longitude": "20.19839000"
                    },
                    {
                        "id": 56025,
                        "name": "Tiszabő",
                        "latitude": "47.30000000",
                        "longitude": "20.48333000"
                    },
                    {
                        "id": 56024,
                        "name": "Tiszabura",
                        "latitude": "47.45000000",
                        "longitude": "20.46667000"
                    },
                    {
                        "id": 56030,
                        "name": "Tiszaföldvár",
                        "latitude": "46.98333000",
                        "longitude": "20.25000000"
                    },
                    {
                        "id": 56031,
                        "name": "Tiszafüred",
                        "latitude": "47.61667000",
                        "longitude": "20.76667000"
                    },
                    {
                        "id": 56032,
                        "name": "Tiszafüredi Járás",
                        "latitude": "47.53907000",
                        "longitude": "20.78879000"
                    },
                    {
                        "id": 56041,
                        "name": "Tiszapüspöki",
                        "latitude": "47.21667000",
                        "longitude": "20.31667000"
                    },
                    {
                        "id": 56042,
                        "name": "Tiszaroff",
                        "latitude": "47.40000000",
                        "longitude": "20.45000000"
                    },
                    {
                        "id": 56045,
                        "name": "Tiszasüly",
                        "latitude": "47.38333000",
                        "longitude": "20.40000000"
                    },
                    {
                        "id": 56043,
                        "name": "Tiszaszentimre",
                        "latitude": "47.48333000",
                        "longitude": "20.73333000"
                    },
                    {
                        "id": 56044,
                        "name": "Tiszaszőlős",
                        "latitude": "47.55707000",
                        "longitude": "20.71949000"
                    },
                    {
                        "id": 56084,
                        "name": "Törökszentmiklós",
                        "latitude": "47.18333000",
                        "longitude": "20.41667000"
                    },
                    {
                        "id": 56085,
                        "name": "Törökszentmiklósi Járás",
                        "latitude": "47.18209000",
                        "longitude": "20.44859000"
                    },
                    {
                        "id": 56077,
                        "name": "Tószeg",
                        "latitude": "47.10000000",
                        "longitude": "20.15000000"
                    },
                    {
                        "id": 56086,
                        "name": "Túrkeve",
                        "latitude": "47.10000000",
                        "longitude": "20.75000000"
                    },
                    {
                        "id": 56164,
                        "name": "Újszász",
                        "latitude": "47.30000000",
                        "longitude": "20.08333000"
                    },
                    {
                        "id": 56118,
                        "name": "Zagyvarékas",
                        "latitude": "47.26667000",
                        "longitude": "20.13333000"
                    }
                ]
            },
            {
                "id": 1067,
                "name": "Kaposvár",
                "iso2": "KV",
                "latitude": "46.35936060",
                "longitude": "17.79676390",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1056,
                "name": "Kecskemét",
                "iso2": "KM",
                "latitude": "46.89637110",
                "longitude": "19.68968610",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 5085,
                "name": "Komárom-Esztergom",
                "iso2": "KE",
                "latitude": "47.57797860",
                "longitude": "18.12568550",
                "type": "county",
                "cities": [
                    {
                        "id": 149667,
                        "name": "Ács",
                        "latitude": "47.71000000",
                        "longitude": "18.01555556"
                    },
                    {
                        "id": 149601,
                        "name": "Aka",
                        "latitude": "47.40206944",
                        "longitude": "18.07163056"
                    },
                    {
                        "id": 149602,
                        "name": "Almásfüzitő",
                        "latitude": "47.72870000",
                        "longitude": "18.25538889"
                    },
                    {
                        "id": 149668,
                        "name": "Ászár",
                        "latitude": "47.50950000",
                        "longitude": "18.00313889"
                    },
                    {
                        "id": 149608,
                        "name": "Bábolna",
                        "latitude": "47.64166667",
                        "longitude": "17.97861111"
                    },
                    {
                        "id": 149603,
                        "name": "Bajót",
                        "latitude": "47.72722222",
                        "longitude": "18.55583333"
                    },
                    {
                        "id": 149604,
                        "name": "Bakonybánk",
                        "latitude": "47.46548056",
                        "longitude": "17.90243056"
                    },
                    {
                        "id": 149606,
                        "name": "Bakonysárkány",
                        "latitude": "47.44851944",
                        "longitude": "18.09916111"
                    },
                    {
                        "id": 149605,
                        "name": "Bakonyszombathely",
                        "latitude": "47.47208056",
                        "longitude": "17.96018056"
                    },
                    {
                        "id": 149607,
                        "name": "Bana",
                        "latitude": "47.64986111",
                        "longitude": "17.92116944"
                    },
                    {
                        "id": 149609,
                        "name": "Bánhida",
                        "latitude": "47.57111111",
                        "longitude": "18.38611111"
                    },
                    {
                        "id": 149610,
                        "name": "Bársonyos",
                        "latitude": "47.51140000",
                        "longitude": "17.91896944"
                    },
                    {
                        "id": 149613,
                        "name": "Császár",
                        "latitude": "47.50203056",
                        "longitude": "18.14206111"
                    },
                    {
                        "id": 149611,
                        "name": "Csatka",
                        "latitude": "47.38031944",
                        "longitude": "17.97628889"
                    },
                    {
                        "id": 149614,
                        "name": "Csém",
                        "latitude": "47.68118056",
                        "longitude": "18.08686111"
                    },
                    {
                        "id": 149615,
                        "name": "Csép",
                        "latitude": "47.57863056",
                        "longitude": "18.06365000"
                    },
                    {
                        "id": 149612,
                        "name": "Csolnok",
                        "latitude": "47.69346944",
                        "longitude": "18.71303889"
                    },
                    {
                        "id": 149616,
                        "name": "Dad",
                        "latitude": "47.51881111",
                        "longitude": "18.22463056"
                    },
                    {
                        "id": 149620,
                        "name": "Dág",
                        "latitude": "47.66250000",
                        "longitude": "18.72000000"
                    },
                    {
                        "id": 149621,
                        "name": "Dömös",
                        "latitude": "47.76480000",
                        "longitude": "18.91436944"
                    },
                    {
                        "id": 149617,
                        "name": "Dorog",
                        "latitude": "47.72095000",
                        "longitude": "18.73641000"
                    },
                    {
                        "id": 149618,
                        "name": "Dunaalmás",
                        "latitude": "47.72961111",
                        "longitude": "18.32170000"
                    },
                    {
                        "id": 149619,
                        "name": "Dunaszentmiklós",
                        "latitude": "47.70566944",
                        "longitude": "18.37958056"
                    },
                    {
                        "id": 149622,
                        "name": "Epöl",
                        "latitude": "47.64708056",
                        "longitude": "18.63558056"
                    },
                    {
                        "id": 149623,
                        "name": "Esztergom",
                        "latitude": "47.78555556",
                        "longitude": "18.74027778"
                    },
                    {
                        "id": 149624,
                        "name": "Ete",
                        "latitude": "47.53168889",
                        "longitude": "18.07201111"
                    },
                    {
                        "id": 149625,
                        "name": "Gyermely",
                        "latitude": "47.59186944",
                        "longitude": "18.64178056"
                    },
                    {
                        "id": 149626,
                        "name": "Héreg",
                        "latitude": "47.64703056",
                        "longitude": "18.51063889"
                    },
                    {
                        "id": 149627,
                        "name": "Kecskéd",
                        "latitude": "47.52311111",
                        "longitude": "18.30683056"
                    },
                    {
                        "id": 149628,
                        "name": "Kerékteleki",
                        "latitude": "47.51635000",
                        "longitude": "17.93891944"
                    },
                    {
                        "id": 149629,
                        "name": "Kesztölc",
                        "latitude": "47.71358056",
                        "longitude": "18.79520000"
                    },
                    {
                        "id": 149630,
                        "name": "Kisbér",
                        "latitude": "47.50166667",
                        "longitude": "18.02666667"
                    },
                    {
                        "id": 149631,
                        "name": "Kisigmánd",
                        "latitude": "47.65440000",
                        "longitude": "18.09710000"
                    },
                    {
                        "id": 149632,
                        "name": "Kocs",
                        "latitude": "47.60668056",
                        "longitude": "18.21536111"
                    },
                    {
                        "id": 149633,
                        "name": "Komárom",
                        "latitude": "47.74318000",
                        "longitude": "18.11913000"
                    },
                    {
                        "id": 149634,
                        "name": "Kömlőd",
                        "latitude": "47.54678056",
                        "longitude": "18.26048056"
                    },
                    {
                        "id": 149635,
                        "name": "Környe",
                        "latitude": "47.54533889",
                        "longitude": "18.32696944"
                    },
                    {
                        "id": 149637,
                        "name": "Lábatlan",
                        "latitude": "47.74694444",
                        "longitude": "18.49611111"
                    },
                    {
                        "id": 149636,
                        "name": "Leányvár",
                        "latitude": "47.68268056",
                        "longitude": "18.77020000"
                    },
                    {
                        "id": 149640,
                        "name": "Máriahalom",
                        "latitude": "47.62746944",
                        "longitude": "18.70760000"
                    },
                    {
                        "id": 149638,
                        "name": "Mocsa",
                        "latitude": "47.67120000",
                        "longitude": "18.18465000"
                    },
                    {
                        "id": 149639,
                        "name": "Mogyorósbánya",
                        "latitude": "47.72806000",
                        "longitude": "18.60351000"
                    },
                    {
                        "id": 149641,
                        "name": "Nagyigmánd",
                        "latitude": "47.63253056",
                        "longitude": "18.05568889"
                    },
                    {
                        "id": 149642,
                        "name": "Nagysáp",
                        "latitude": "47.68481111",
                        "longitude": "18.60163056"
                    },
                    {
                        "id": 149643,
                        "name": "Naszály",
                        "latitude": "47.69873056",
                        "longitude": "18.26075000"
                    },
                    {
                        "id": 149644,
                        "name": "Neszmély",
                        "latitude": "47.73290000",
                        "longitude": "18.34510000"
                    },
                    {
                        "id": 149645,
                        "name": "Nyergesújfalu",
                        "latitude": "47.76027778",
                        "longitude": "18.55666667"
                    },
                    {
                        "id": 149646,
                        "name": "Oroszlány",
                        "latitude": "47.48916667",
                        "longitude": "18.31638889"
                    },
                    {
                        "id": 149647,
                        "name": "Piliscsév",
                        "latitude": "47.67710000",
                        "longitude": "18.81488889"
                    },
                    {
                        "id": 149648,
                        "name": "Pilismarót",
                        "latitude": "47.78403889",
                        "longitude": "18.87551944"
                    },
                    {
                        "id": 149649,
                        "name": "Réde",
                        "latitude": "47.43058056",
                        "longitude": "17.91865000"
                    },
                    {
                        "id": 149654,
                        "name": "Sárisáp",
                        "latitude": "47.67465278",
                        "longitude": "18.68096944"
                    },
                    {
                        "id": 149655,
                        "name": "Súr",
                        "latitude": "47.37083889",
                        "longitude": "18.02876111"
                    },
                    {
                        "id": 149656,
                        "name": "Süttő",
                        "latitude": "47.75675000",
                        "longitude": "18.44145000"
                    },
                    {
                        "id": 149652,
                        "name": "Szákszend",
                        "latitude": "47.55713056",
                        "longitude": "18.16313056"
                    },
                    {
                        "id": 149651,
                        "name": "Szomód",
                        "latitude": "47.68253000",
                        "longitude": "18.34180000"
                    },
                    {
                        "id": 149650,
                        "name": "Szomor",
                        "latitude": "47.59305000",
                        "longitude": "18.66328889"
                    },
                    {
                        "id": 149653,
                        "name": "Szőny",
                        "latitude": "47.73333333",
                        "longitude": "18.16666667"
                    },
                    {
                        "id": 149657,
                        "name": "Tardos",
                        "latitude": "47.66180000",
                        "longitude": "18.44358000"
                    },
                    {
                        "id": 149658,
                        "name": "Tarján",
                        "latitude": "47.61055556",
                        "longitude": "18.51083333"
                    },
                    {
                        "id": 149661,
                        "name": "Tárkány",
                        "latitude": "47.59135000",
                        "longitude": "18.00366111"
                    },
                    {
                        "id": 149659,
                        "name": "Tatabánya",
                        "latitude": "47.58616000",
                        "longitude": "18.39485000"
                    },
                    {
                        "id": 149660,
                        "name": "Tokodaltáró",
                        "latitude": "47.73390000",
                        "longitude": "18.68946000"
                    },
                    {
                        "id": 149669,
                        "name": "Úny",
                        "latitude": "47.64246944",
                        "longitude": "18.73786944"
                    },
                    {
                        "id": 149662,
                        "name": "Várgesztes",
                        "latitude": "47.47526944",
                        "longitude": "18.39731944"
                    },
                    {
                        "id": 149663,
                        "name": "Vérteskethely",
                        "latitude": "47.48721111",
                        "longitude": "18.08346944"
                    },
                    {
                        "id": 149664,
                        "name": "Vértessomló",
                        "latitude": "47.50973889",
                        "longitude": "18.36705000"
                    },
                    {
                        "id": 149665,
                        "name": "Vértesszőlős",
                        "latitude": "47.61883889",
                        "longitude": "18.38030000"
                    },
                    {
                        "id": 149666,
                        "name": "Vértestolna",
                        "latitude": "47.62838889",
                        "longitude": "18.45643889"
                    }
                ]
            },
            {
                "id": 1065,
                "name": "Miskolc",
                "iso2": "MI",
                "latitude": "48.10347750",
                "longitude": "20.77843840",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1030,
                "name": "Nagykanizsa",
                "iso2": "NK",
                "latitude": "46.45902180",
                "longitude": "16.98967960",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1051,
                "name": "Nógrád County",
                "iso2": "NO",
                "latitude": "47.90410310",
                "longitude": "19.04985040",
                "type": "county",
                "cities": [
                    {
                        "id": 55210,
                        "name": "Balassagyarmat",
                        "latitude": "48.07296000",
                        "longitude": "19.29614000"
                    },
                    {
                        "id": 55211,
                        "name": "Balassagyarmati Járás",
                        "latitude": "48.01657000",
                        "longitude": "19.30594000"
                    },
                    {
                        "id": 55293,
                        "name": "Bátonyterenye",
                        "latitude": "47.96962000",
                        "longitude": "19.84076000"
                    },
                    {
                        "id": 55294,
                        "name": "Bátonyterenyei Járás",
                        "latitude": "47.97691000",
                        "longitude": "19.87345000"
                    },
                    {
                        "id": 55237,
                        "name": "Bercel",
                        "latitude": "47.87057000",
                        "longitude": "19.40715000"
                    },
                    {
                        "id": 55286,
                        "name": "Buják",
                        "latitude": "47.88352000",
                        "longitude": "19.54381000"
                    },
                    {
                        "id": 55363,
                        "name": "Diósjenő",
                        "latitude": "47.93968000",
                        "longitude": "19.04317000"
                    },
                    {
                        "id": 56148,
                        "name": "Érsekvadkert",
                        "latitude": "47.99619000",
                        "longitude": "19.20231000"
                    },
                    {
                        "id": 55518,
                        "name": "Héhalom",
                        "latitude": "47.78017000",
                        "longitude": "19.58519000"
                    },
                    {
                        "id": 55533,
                        "name": "Jobbágyi",
                        "latitude": "47.83238000",
                        "longitude": "19.67762000"
                    },
                    {
                        "id": 55565,
                        "name": "Karancskeszi",
                        "latitude": "48.16353000",
                        "longitude": "19.69686000"
                    },
                    {
                        "id": 55566,
                        "name": "Karancslapujtő",
                        "latitude": "48.15000000",
                        "longitude": "19.73333000"
                    },
                    {
                        "id": 55577,
                        "name": "Kazár",
                        "latitude": "48.04952000",
                        "longitude": "19.86143000"
                    },
                    {
                        "id": 55725,
                        "name": "Mátranovák",
                        "latitude": "48.03809000",
                        "longitude": "19.98257000"
                    },
                    {
                        "id": 55726,
                        "name": "Mátraterenye",
                        "latitude": "48.03267000",
                        "longitude": "19.94762000"
                    },
                    {
                        "id": 55727,
                        "name": "Mátraverebély",
                        "latitude": "47.97421000",
                        "longitude": "19.78049000"
                    },
                    {
                        "id": 55759,
                        "name": "Nagyoroszi",
                        "latitude": "48.00503000",
                        "longitude": "19.09050000"
                    },
                    {
                        "id": 55807,
                        "name": "Palotás",
                        "latitude": "47.79528000",
                        "longitude": "19.59618000"
                    },
                    {
                        "id": 55844,
                        "name": "Pásztó",
                        "latitude": "47.92019000",
                        "longitude": "19.69829000"
                    },
                    {
                        "id": 55845,
                        "name": "Pásztói Járás",
                        "latitude": "47.87012000",
                        "longitude": "19.60648000"
                    },
                    {
                        "id": 55877,
                        "name": "Rétság",
                        "latitude": "47.92816000",
                        "longitude": "19.13720000"
                    },
                    {
                        "id": 55878,
                        "name": "Rétsági Járás",
                        "latitude": "47.91741000",
                        "longitude": "19.16101000"
                    },
                    {
                        "id": 55865,
                        "name": "Rimóc",
                        "latitude": "48.03695000",
                        "longitude": "19.53010000"
                    },
                    {
                        "id": 55866,
                        "name": "Romhány",
                        "latitude": "47.92618000",
                        "longitude": "19.25723000"
                    },
                    {
                        "id": 55889,
                        "name": "Salgótarján",
                        "latitude": "48.09872000",
                        "longitude": "19.80303000"
                    },
                    {
                        "id": 55890,
                        "name": "Salgótarjáni Járás",
                        "latitude": "48.10048000",
                        "longitude": "19.81548000"
                    },
                    {
                        "id": 55907,
                        "name": "Somoskőújfalu",
                        "latitude": "48.16374000",
                        "longitude": "19.82303000"
                    },
                    {
                        "id": 55972,
                        "name": "Szécsény",
                        "latitude": "48.08057000",
                        "longitude": "19.52019000"
                    },
                    {
                        "id": 55973,
                        "name": "Szécsényi Járás",
                        "latitude": "48.07301000",
                        "longitude": "19.55156000"
                    },
                    {
                        "id": 55968,
                        "name": "Szurdokpüspöki",
                        "latitude": "47.85923000",
                        "longitude": "19.69218000"
                    },
                    {
                        "id": 56011,
                        "name": "Tar",
                        "latitude": "47.95371000",
                        "longitude": "19.74610000"
                    }
                ]
            },
            {
                "id": 1034,
                "name": "Nyíregyháza",
                "iso2": "NY",
                "latitude": "47.94953240",
                "longitude": "21.72440530",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1053,
                "name": "Pécs",
                "iso2": "PS",
                "latitude": "46.07273450",
                "longitude": "18.23226600",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1059,
                "name": "Pest County",
                "iso2": "PE",
                "latitude": "47.44800010",
                "longitude": "19.46181280",
                "type": "county",
                "cities": [
                    {
                        "id": 55172,
                        "name": "Abony",
                        "latitude": "47.18990000",
                        "longitude": "20.00476000"
                    },
                    {
                        "id": 55174,
                        "name": "Acsa",
                        "latitude": "47.79425000",
                        "longitude": "19.38795000"
                    },
                    {
                        "id": 55183,
                        "name": "Albertirsa",
                        "latitude": "47.24315000",
                        "longitude": "19.61686000"
                    },
                    {
                        "id": 55185,
                        "name": "Alsónémedi",
                        "latitude": "47.31524000",
                        "longitude": "19.15843000"
                    },
                    {
                        "id": 55197,
                        "name": "Aszód",
                        "latitude": "47.65174000",
                        "longitude": "19.47850000"
                    },
                    {
                        "id": 55198,
                        "name": "Aszódi Járás",
                        "latitude": "47.64738000",
                        "longitude": "19.54240000"
                    },
                    {
                        "id": 55201,
                        "name": "Bag",
                        "latitude": "47.63333000",
                        "longitude": "19.48333000"
                    },
                    {
                        "id": 55245,
                        "name": "Biatorbágy",
                        "latitude": "47.47060000",
                        "longitude": "18.81892000"
                    },
                    {
                        "id": 55260,
                        "name": "Budakalász",
                        "latitude": "47.61667000",
                        "longitude": "19.05000000"
                    },
                    {
                        "id": 55261,
                        "name": "Budakeszi",
                        "latitude": "47.51083000",
                        "longitude": "18.92717000"
                    },
                    {
                        "id": 55262,
                        "name": "Budakeszi Járás",
                        "latitude": "47.49788000",
                        "longitude": "18.84980000"
                    },
                    {
                        "id": 55282,
                        "name": "Budaörs",
                        "latitude": "47.46181000",
                        "longitude": "18.95845000"
                    },
                    {
                        "id": 55284,
                        "name": "Bugyi",
                        "latitude": "47.22748000",
                        "longitude": "19.14664000"
                    },
                    {
                        "id": 55315,
                        "name": "Cegléd",
                        "latitude": "47.17266000",
                        "longitude": "19.79952000"
                    },
                    {
                        "id": 55316,
                        "name": "Ceglédbercel",
                        "latitude": "47.22370000",
                        "longitude": "19.66828000"
                    },
                    {
                        "id": 55317,
                        "name": "Ceglédi Járás",
                        "latitude": "47.20000000",
                        "longitude": "19.82463000"
                    },
                    {
                        "id": 55327,
                        "name": "Csemő",
                        "latitude": "47.11799000",
                        "longitude": "19.69092000"
                    },
                    {
                        "id": 55336,
                        "name": "Csobánka",
                        "latitude": "47.64637000",
                        "longitude": "18.96189000"
                    },
                    {
                        "id": 55350,
                        "name": "Csömör",
                        "latitude": "47.55000000",
                        "longitude": "19.23333000"
                    },
                    {
                        "id": 55351,
                        "name": "Dabas",
                        "latitude": "47.18594000",
                        "longitude": "19.31091000"
                    },
                    {
                        "id": 55352,
                        "name": "Dabasi Járás",
                        "latitude": "47.19000000",
                        "longitude": "19.33000000"
                    },
                    {
                        "id": 55384,
                        "name": "Dánszentmiklós",
                        "latitude": "47.21486000",
                        "longitude": "19.54695000"
                    },
                    {
                        "id": 55385,
                        "name": "Dány",
                        "latitude": "47.52000000",
                        "longitude": "19.54400000"
                    },
                    {
                        "id": 55388,
                        "name": "Délegyháza",
                        "latitude": "47.24135000",
                        "longitude": "19.09019000"
                    },
                    {
                        "id": 55362,
                        "name": "Diósd",
                        "latitude": "47.40950000",
                        "longitude": "18.94898000"
                    },
                    {
                        "id": 55370,
                        "name": "Domony",
                        "latitude": "47.65552000",
                        "longitude": "19.43229000"
                    },
                    {
                        "id": 55392,
                        "name": "Dömsöd",
                        "latitude": "47.09005000",
                        "longitude": "19.01106000"
                    },
                    {
                        "id": 55372,
                        "name": "Dunabogdány",
                        "latitude": "47.79052000",
                        "longitude": "19.04125000"
                    },
                    {
                        "id": 55374,
                        "name": "Dunaharaszti",
                        "latitude": "47.35450000",
                        "longitude": "19.09822000"
                    },
                    {
                        "id": 55375,
                        "name": "Dunakeszi",
                        "latitude": "47.63641000",
                        "longitude": "19.13864000"
                    },
                    {
                        "id": 55376,
                        "name": "Dunakeszi Járás",
                        "latitude": "47.63365000",
                        "longitude": "19.16254000"
                    },
                    {
                        "id": 55380,
                        "name": "Dunavarsány",
                        "latitude": "47.27859000",
                        "longitude": "19.06617000"
                    },
                    {
                        "id": 55394,
                        "name": "Ecser",
                        "latitude": "47.44389000",
                        "longitude": "19.32450000"
                    },
                    {
                        "id": 56145,
                        "name": "Érd",
                        "latitude": "47.39489000",
                        "longitude": "18.91361000"
                    },
                    {
                        "id": 56146,
                        "name": "Érdi Járás",
                        "latitude": "47.35600000",
                        "longitude": "18.90167000"
                    },
                    {
                        "id": 55411,
                        "name": "Erdőkertes",
                        "latitude": "47.67261000",
                        "longitude": "19.30786000"
                    },
                    {
                        "id": 55417,
                        "name": "Farmos",
                        "latitude": "47.36067000",
                        "longitude": "19.84619000"
                    },
                    {
                        "id": 55423,
                        "name": "Felsőpakony",
                        "latitude": "47.34329000",
                        "longitude": "19.23698000"
                    },
                    {
                        "id": 55433,
                        "name": "Forrópuszta",
                        "latitude": "47.45504000",
                        "longitude": "19.66001000"
                    },
                    {
                        "id": 55436,
                        "name": "Fót",
                        "latitude": "47.61770000",
                        "longitude": "19.18870000"
                    },
                    {
                        "id": 55444,
                        "name": "Galgahévíz",
                        "latitude": "47.61667000",
                        "longitude": "19.56667000"
                    },
                    {
                        "id": 55445,
                        "name": "Galgamácsa",
                        "latitude": "47.69562000",
                        "longitude": "19.38724000"
                    },
                    {
                        "id": 55474,
                        "name": "Göd",
                        "latitude": "47.68324000",
                        "longitude": "19.13417000"
                    },
                    {
                        "id": 55475,
                        "name": "Gödöllő",
                        "latitude": "47.59657000",
                        "longitude": "19.35515000"
                    },
                    {
                        "id": 55476,
                        "name": "Gödöllői Járás",
                        "latitude": "47.55127000",
                        "longitude": "19.39595000"
                    },
                    {
                        "id": 55449,
                        "name": "Gomba",
                        "latitude": "47.37095000",
                        "longitude": "19.53057000"
                    },
                    {
                        "id": 55456,
                        "name": "Gyál",
                        "latitude": "47.38449000",
                        "longitude": "19.22140000"
                    },
                    {
                        "id": 55457,
                        "name": "Gyáli Járás",
                        "latitude": "47.36821000",
                        "longitude": "19.27543000"
                    },
                    {
                        "id": 55458,
                        "name": "Gyömrő",
                        "latitude": "47.42733000",
                        "longitude": "19.40133000"
                    },
                    {
                        "id": 55496,
                        "name": "Halásztelek",
                        "latitude": "47.36173000",
                        "longitude": "18.98119000"
                    },
                    {
                        "id": 55507,
                        "name": "Hernád",
                        "latitude": "47.16238000",
                        "longitude": "19.43295000"
                    },
                    {
                        "id": 55520,
                        "name": "Hévízgyörk",
                        "latitude": "47.63333000",
                        "longitude": "19.51667000"
                    },
                    {
                        "id": 55526,
                        "name": "Iklad",
                        "latitude": "47.66533000",
                        "longitude": "19.43610000"
                    },
                    {
                        "id": 55527,
                        "name": "Inárcs",
                        "latitude": "47.26200000",
                        "longitude": "19.32700000"
                    },
                    {
                        "id": 55529,
                        "name": "Isaszeg",
                        "latitude": "47.53011000",
                        "longitude": "19.40205000"
                    },
                    {
                        "id": 55548,
                        "name": "Jászkarajenő",
                        "latitude": "47.05000000",
                        "longitude": "20.06667000"
                    },
                    {
                        "id": 55557,
                        "name": "Kakucs",
                        "latitude": "47.24200000",
                        "longitude": "19.36467000"
                    },
                    {
                        "id": 55570,
                        "name": "Kartal",
                        "latitude": "47.67133000",
                        "longitude": "19.54200000"
                    },
                    {
                        "id": 55588,
                        "name": "Kerepes",
                        "latitude": "47.56008000",
                        "longitude": "19.28289000"
                    },
                    {
                        "id": 55598,
                        "name": "Kiskunlacháza",
                        "latitude": "47.18839000",
                        "longitude": "19.00930000"
                    },
                    {
                        "id": 55606,
                        "name": "Kismaros",
                        "latitude": "47.83742000",
                        "longitude": "19.00463000"
                    },
                    {
                        "id": 55609,
                        "name": "Kistarcsa",
                        "latitude": "47.54757000",
                        "longitude": "19.26247000"
                    },
                    {
                        "id": 55617,
                        "name": "Kocsér",
                        "latitude": "47.00165000",
                        "longitude": "19.92067000"
                    },
                    {
                        "id": 55644,
                        "name": "Kóka",
                        "latitude": "47.48552000",
                        "longitude": "19.57876000"
                    },
                    {
                        "id": 55624,
                        "name": "Kosd",
                        "latitude": "47.80791000",
                        "longitude": "19.17821000"
                    },
                    {
                        "id": 55663,
                        "name": "Leányfalu",
                        "latitude": "47.71778000",
                        "longitude": "19.08585000"
                    },
                    {
                        "id": 55674,
                        "name": "Maglód",
                        "latitude": "47.44258000",
                        "longitude": "19.36438000"
                    },
                    {
                        "id": 55687,
                        "name": "Mende",
                        "latitude": "47.43133000",
                        "longitude": "19.45628000"
                    },
                    {
                        "id": 55707,
                        "name": "Mogyoród",
                        "latitude": "47.59748000",
                        "longitude": "19.24070000"
                    },
                    {
                        "id": 55711,
                        "name": "Monor",
                        "latitude": "47.35133000",
                        "longitude": "19.44733000"
                    },
                    {
                        "id": 55712,
                        "name": "Monori Járás",
                        "latitude": "47.34990000",
                        "longitude": "19.47680000"
                    },
                    {
                        "id": 55753,
                        "name": "Nagykáta",
                        "latitude": "47.41514000",
                        "longitude": "19.74410000"
                    },
                    {
                        "id": 55754,
                        "name": "Nagykátai Járás",
                        "latitude": "47.39109000",
                        "longitude": "19.73920000"
                    },
                    {
                        "id": 55755,
                        "name": "Nagykőrös",
                        "latitude": "47.03419000",
                        "longitude": "19.77857000"
                    },
                    {
                        "id": 55756,
                        "name": "Nagykőrösi Járás",
                        "latitude": "47.03563000",
                        "longitude": "19.79259000"
                    },
                    {
                        "id": 55750,
                        "name": "Nagykovácsi",
                        "latitude": "47.65000000",
                        "longitude": "19.01667000"
                    },
                    {
                        "id": 55757,
                        "name": "Nagymaros",
                        "latitude": "47.79280000",
                        "longitude": "18.95984000"
                    },
                    {
                        "id": 55763,
                        "name": "Nagytarcsa",
                        "latitude": "47.53128000",
                        "longitude": "19.28343000"
                    },
                    {
                        "id": 55767,
                        "name": "Nyáregyháza",
                        "latitude": "47.26175000",
                        "longitude": "19.50146000"
                    },
                    {
                        "id": 56149,
                        "name": "Ócsa",
                        "latitude": "47.29986000",
                        "longitude": "19.23057000"
                    },
                    {
                        "id": 56171,
                        "name": "Őrbottyán",
                        "latitude": "47.68711000",
                        "longitude": "19.28239000"
                    },
                    {
                        "id": 56158,
                        "name": "Örkény",
                        "latitude": "47.12991000",
                        "longitude": "19.43324000"
                    },
                    {
                        "id": 55841,
                        "name": "Pánd",
                        "latitude": "47.35333000",
                        "longitude": "19.63571000"
                    },
                    {
                        "id": 55847,
                        "name": "Páty",
                        "latitude": "47.51709000",
                        "longitude": "18.82851000"
                    },
                    {
                        "id": 55849,
                        "name": "Pécel",
                        "latitude": "47.48962000",
                        "longitude": "19.34162000"
                    },
                    {
                        "id": 55813,
                        "name": "Perbál",
                        "latitude": "47.58957000",
                        "longitude": "18.76099000"
                    },
                    {
                        "id": 55855,
                        "name": "Péteri",
                        "latitude": "47.39104000",
                        "longitude": "19.40981000"
                    },
                    {
                        "id": 55817,
                        "name": "Pilis",
                        "latitude": "47.28904000",
                        "longitude": "19.54848000"
                    },
                    {
                        "id": 55818,
                        "name": "Pilisborosjenő",
                        "latitude": "47.60744000",
                        "longitude": "18.99322000"
                    },
                    {
                        "id": 55819,
                        "name": "Piliscsaba",
                        "latitude": "47.63417000",
                        "longitude": "18.82886000"
                    },
                    {
                        "id": 55822,
                        "name": "Pilisszántó",
                        "latitude": "47.66909000",
                        "longitude": "18.88762000"
                    },
                    {
                        "id": 55820,
                        "name": "Pilisszentiván",
                        "latitude": "47.60964000",
                        "longitude": "18.89940000"
                    },
                    {
                        "id": 55821,
                        "name": "Pilisszentkereszt",
                        "latitude": "47.69143000",
                        "longitude": "18.90503000"
                    },
                    {
                        "id": 55823,
                        "name": "Pilisvörösvár",
                        "latitude": "47.61386000",
                        "longitude": "18.90893000"
                    },
                    {
                        "id": 55824,
                        "name": "Pilisvörösvári Járás",
                        "latitude": "47.60925000",
                        "longitude": "18.86658000"
                    },
                    {
                        "id": 55829,
                        "name": "Pomáz",
                        "latitude": "47.64227000",
                        "longitude": "19.02784000"
                    },
                    {
                        "id": 55872,
                        "name": "Ráckeve",
                        "latitude": "47.16095000",
                        "longitude": "18.94478000"
                    },
                    {
                        "id": 55873,
                        "name": "Ráckevei Járás",
                        "latitude": "47.15158000",
                        "longitude": "19.01456000"
                    },
                    {
                        "id": 55905,
                        "name": "Solymár",
                        "latitude": "47.59246000",
                        "longitude": "18.93212000"
                    },
                    {
                        "id": 55996,
                        "name": "Sóskút",
                        "latitude": "47.40665000",
                        "longitude": "18.82247000"
                    },
                    {
                        "id": 55998,
                        "name": "Sülysáp",
                        "latitude": "47.45206000",
                        "longitude": "19.53369000"
                    },
                    {
                        "id": 55914,
                        "name": "Szada",
                        "latitude": "47.63333000",
                        "longitude": "19.31667000"
                    },
                    {
                        "id": 55971,
                        "name": "Százhalombatta",
                        "latitude": "47.32949000",
                        "longitude": "18.93878000"
                    },
                    {
                        "id": 55934,
                        "name": "Szentendre",
                        "latitude": "47.66943000",
                        "longitude": "19.07561000"
                    },
                    {
                        "id": 55935,
                        "name": "Szentendrei Járás",
                        "latitude": "47.71146000",
                        "longitude": "19.02524000"
                    },
                    {
                        "id": 55946,
                        "name": "Szentlőrinckáta",
                        "latitude": "47.51947000",
                        "longitude": "19.75286000"
                    },
                    {
                        "id": 55947,
                        "name": "Szentmártonkáta",
                        "latitude": "47.45419000",
                        "longitude": "19.70143000"
                    },
                    {
                        "id": 55950,
                        "name": "Szigetcsép",
                        "latitude": "47.26492000",
                        "longitude": "18.97048000"
                    },
                    {
                        "id": 55951,
                        "name": "Szigethalom",
                        "latitude": "47.32228000",
                        "longitude": "19.00262000"
                    },
                    {
                        "id": 55952,
                        "name": "Szigetszentmiklós",
                        "latitude": "47.34382000",
                        "longitude": "19.04335000"
                    },
                    {
                        "id": 55953,
                        "name": "Szigetszentmiklósi Járás",
                        "latitude": "47.30566000",
                        "longitude": "19.02829000"
                    },
                    {
                        "id": 55956,
                        "name": "Szigetújfalu",
                        "latitude": "47.23417000",
                        "longitude": "18.92746000"
                    },
                    {
                        "id": 55962,
                        "name": "Szob",
                        "latitude": "47.81921000",
                        "longitude": "18.87020000"
                    },
                    {
                        "id": 55963,
                        "name": "Szobi Járás",
                        "latitude": "47.93419000",
                        "longitude": "18.85438000"
                    },
                    {
                        "id": 55977,
                        "name": "Sződ",
                        "latitude": "47.72439000",
                        "longitude": "19.17046000"
                    },
                    {
                        "id": 55978,
                        "name": "Sződliget",
                        "latitude": "47.73259000",
                        "longitude": "19.14749000"
                    },
                    {
                        "id": 56061,
                        "name": "Táborfalva",
                        "latitude": "47.09942000",
                        "longitude": "19.47837000"
                    },
                    {
                        "id": 56003,
                        "name": "Tahitótfalu",
                        "latitude": "47.75000000",
                        "longitude": "19.10000000"
                    },
                    {
                        "id": 56004,
                        "name": "Taksony",
                        "latitude": "47.32968000",
                        "longitude": "19.06695000"
                    },
                    {
                        "id": 56063,
                        "name": "Tápióbicske",
                        "latitude": "47.36096000",
                        "longitude": "19.68609000"
                    },
                    {
                        "id": 56064,
                        "name": "Tápiógyörgye",
                        "latitude": "47.33505000",
                        "longitude": "19.95276000"
                    },
                    {
                        "id": 56069,
                        "name": "Tápióság",
                        "latitude": "47.40200000",
                        "longitude": "19.63047000"
                    },
                    {
                        "id": 56065,
                        "name": "Tápiószecső",
                        "latitude": "47.45000000",
                        "longitude": "19.60923000"
                    },
                    {
                        "id": 56066,
                        "name": "Tápiószele",
                        "latitude": "47.33609000",
                        "longitude": "19.87724000"
                    },
                    {
                        "id": 56067,
                        "name": "Tápiószentmárton",
                        "latitude": "47.33990000",
                        "longitude": "19.74648000"
                    },
                    {
                        "id": 56068,
                        "name": "Tápiószőlős",
                        "latitude": "47.30248000",
                        "longitude": "19.85133000"
                    },
                    {
                        "id": 56071,
                        "name": "Tárnok",
                        "latitude": "47.37327000",
                        "longitude": "18.84579000"
                    },
                    {
                        "id": 56018,
                        "name": "Telki",
                        "latitude": "47.54791000",
                        "longitude": "18.82816000"
                    },
                    {
                        "id": 56076,
                        "name": "Tóalmás",
                        "latitude": "47.50782000",
                        "longitude": "19.66657000"
                    },
                    {
                        "id": 56079,
                        "name": "Tököl",
                        "latitude": "47.32178000",
                        "longitude": "18.96249000"
                    },
                    {
                        "id": 56083,
                        "name": "Törökbálint",
                        "latitude": "47.42931000",
                        "longitude": "18.91356000"
                    },
                    {
                        "id": 56082,
                        "name": "Törtel",
                        "latitude": "47.12209000",
                        "longitude": "19.93714000"
                    },
                    {
                        "id": 56058,
                        "name": "Tura",
                        "latitude": "47.60924000",
                        "longitude": "19.60279000"
                    },
                    {
                        "id": 56161,
                        "name": "Újhartyán",
                        "latitude": "47.21981000",
                        "longitude": "19.38638000"
                    },
                    {
                        "id": 56163,
                        "name": "Újszilvás",
                        "latitude": "47.27477000",
                        "longitude": "19.92477000"
                    },
                    {
                        "id": 56168,
                        "name": "Üllő",
                        "latitude": "47.38771000",
                        "longitude": "19.35533000"
                    },
                    {
                        "id": 56165,
                        "name": "Úri",
                        "latitude": "47.41429000",
                        "longitude": "19.52762000"
                    },
                    {
                        "id": 56169,
                        "name": "Üröm",
                        "latitude": "47.59674000",
                        "longitude": "19.01583000"
                    },
                    {
                        "id": 56105,
                        "name": "Vác",
                        "latitude": "47.77591000",
                        "longitude": "19.13612000"
                    },
                    {
                        "id": 56106,
                        "name": "Váci Járás",
                        "latitude": "47.78316000",
                        "longitude": "19.23882000"
                    },
                    {
                        "id": 56107,
                        "name": "Vácszentlászló",
                        "latitude": "47.57400000",
                        "longitude": "19.53771000"
                    },
                    {
                        "id": 56090,
                        "name": "Valkó",
                        "latitude": "47.56391000",
                        "longitude": "19.51267000"
                    },
                    {
                        "id": 56094,
                        "name": "Vecsés",
                        "latitude": "47.40705000",
                        "longitude": "19.28648000"
                    },
                    {
                        "id": 56095,
                        "name": "Vecsési Járás",
                        "latitude": "47.42923000",
                        "longitude": "19.30136000"
                    },
                    {
                        "id": 56097,
                        "name": "Veresegyház",
                        "latitude": "47.64590000",
                        "longitude": "19.29536000"
                    },
                    {
                        "id": 56099,
                        "name": "Verőce",
                        "latitude": "47.82468000",
                        "longitude": "19.03484000"
                    },
                    {
                        "id": 56103,
                        "name": "Visegrád",
                        "latitude": "47.78526000",
                        "longitude": "18.97090000"
                    },
                    {
                        "id": 56132,
                        "name": "Zsámbék",
                        "latitude": "47.54814000",
                        "longitude": "18.72011000"
                    },
                    {
                        "id": 56131,
                        "name": "Zsámbok",
                        "latitude": "47.54381000",
                        "longitude": "19.61048000"
                    }
                ]
            },
            {
                "id": 1068,
                "name": "Salgótarján",
                "iso2": "ST",
                "latitude": "48.09352370",
                "longitude": "19.79998130",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1035,
                "name": "Somogy County",
                "iso2": "SO",
                "latitude": "46.55485900",
                "longitude": "17.58667320",
                "type": "county",
                "cities": [
                    {
                        "id": 56140,
                        "name": "Ádánd",
                        "latitude": "46.85931000",
                        "longitude": "18.16442000"
                    },
                    {
                        "id": 55199,
                        "name": "Babócsa",
                        "latitude": "46.04155000",
                        "longitude": "17.34332000"
                    },
                    {
                        "id": 55214,
                        "name": "Balatonberény",
                        "latitude": "46.70701000",
                        "longitude": "17.32013000"
                    },
                    {
                        "id": 55215,
                        "name": "Balatonboglár",
                        "latitude": "46.77525000",
                        "longitude": "17.64415000"
                    },
                    {
                        "id": 55216,
                        "name": "Balatonfenyves",
                        "latitude": "46.71542000",
                        "longitude": "17.49223000"
                    },
                    {
                        "id": 55217,
                        "name": "Balatonföldvár",
                        "latitude": "46.85255000",
                        "longitude": "17.88123000"
                    },
                    {
                        "id": 55221,
                        "name": "Balatonlelle",
                        "latitude": "46.78318000",
                        "longitude": "17.69498000"
                    },
                    {
                        "id": 55222,
                        "name": "Balatonszabadi",
                        "latitude": "46.89397000",
                        "longitude": "18.13737000"
                    },
                    {
                        "id": 55223,
                        "name": "Balatonszárszó",
                        "latitude": "46.82946000",
                        "longitude": "17.82426000"
                    },
                    {
                        "id": 55231,
                        "name": "Barcs",
                        "latitude": "45.96000000",
                        "longitude": "17.45861000"
                    },
                    {
                        "id": 55232,
                        "name": "Barcsi Járás",
                        "latitude": "46.03687000",
                        "longitude": "17.47434000"
                    },
                    {
                        "id": 55242,
                        "name": "Berzence",
                        "latitude": "46.20907000",
                        "longitude": "17.14810000"
                    },
                    {
                        "id": 55306,
                        "name": "Böhönye",
                        "latitude": "46.41345000",
                        "longitude": "17.38037000"
                    },
                    {
                        "id": 55343,
                        "name": "Csurgó",
                        "latitude": "46.25314000",
                        "longitude": "17.10060000"
                    },
                    {
                        "id": 55344,
                        "name": "Csurgói Járás",
                        "latitude": "46.29502000",
                        "longitude": "17.10021000"
                    },
                    {
                        "id": 55430,
                        "name": "Fonyód",
                        "latitude": "46.75552000",
                        "longitude": "17.57945000"
                    },
                    {
                        "id": 55431,
                        "name": "Fonyódi Járás",
                        "latitude": "46.67289000",
                        "longitude": "17.70000000"
                    },
                    {
                        "id": 55556,
                        "name": "Kadarkút",
                        "latitude": "46.23623000",
                        "longitude": "17.62014000"
                    },
                    {
                        "id": 55560,
                        "name": "Kaposmérő",
                        "latitude": "46.36167000",
                        "longitude": "17.70400000"
                    },
                    {
                        "id": 55561,
                        "name": "Kaposvár",
                        "latitude": "46.36667000",
                        "longitude": "17.80000000"
                    },
                    {
                        "id": 55562,
                        "name": "Kaposvári Járás",
                        "latitude": "46.39791000",
                        "longitude": "17.76990000"
                    },
                    {
                        "id": 55572,
                        "name": "Karád",
                        "latitude": "46.69076000",
                        "longitude": "17.84136000"
                    },
                    {
                        "id": 55643,
                        "name": "Kéthely",
                        "latitude": "46.64605000",
                        "longitude": "17.39362000"
                    },
                    {
                        "id": 55666,
                        "name": "Lábod",
                        "latitude": "46.20535000",
                        "longitude": "17.45419000"
                    },
                    {
                        "id": 55656,
                        "name": "Lengyeltóti",
                        "latitude": "46.67013000",
                        "longitude": "17.64398000"
                    },
                    {
                        "id": 55679,
                        "name": "Marcali",
                        "latitude": "46.58498000",
                        "longitude": "17.41196000"
                    },
                    {
                        "id": 55680,
                        "name": "Marcali Járás",
                        "latitude": "46.54382000",
                        "longitude": "17.39203000"
                    },
                    {
                        "id": 55738,
                        "name": "Nagyatád",
                        "latitude": "46.22961000",
                        "longitude": "17.35788000"
                    },
                    {
                        "id": 55739,
                        "name": "Nagyatádi Járás",
                        "latitude": "46.25200000",
                        "longitude": "17.37520000"
                    },
                    {
                        "id": 55740,
                        "name": "Nagybajom",
                        "latitude": "46.39232000",
                        "longitude": "17.51147000"
                    },
                    {
                        "id": 55893,
                        "name": "Segesd",
                        "latitude": "46.34142000",
                        "longitude": "17.35132000"
                    },
                    {
                        "id": 55901,
                        "name": "Siófok",
                        "latitude": "46.90413000",
                        "longitude": "18.05800000"
                    },
                    {
                        "id": 55902,
                        "name": "Siófoki Járás",
                        "latitude": "46.85060000",
                        "longitude": "17.99625000"
                    },
                    {
                        "id": 55906,
                        "name": "Somogyvár",
                        "latitude": "46.58140000",
                        "longitude": "17.66289000"
                    },
                    {
                        "id": 56001,
                        "name": "Tab",
                        "latitude": "46.73135000",
                        "longitude": "18.03201000"
                    },
                    {
                        "id": 56002,
                        "name": "Tabi Járás",
                        "latitude": "46.68037000",
                        "longitude": "18.00560000"
                    },
                    {
                        "id": 56017,
                        "name": "Taszár",
                        "latitude": "46.37467000",
                        "longitude": "17.90594000"
                    },
                    {
                        "id": 56126,
                        "name": "Zamárdi",
                        "latitude": "46.88488000",
                        "longitude": "17.95366000"
                    }
                ]
            },
            {
                "id": 1057,
                "name": "Sopron",
                "iso2": "SN",
                "latitude": "47.68166190",
                "longitude": "16.58447950",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1045,
                "name": "Szabolcs-Szatmár-Bereg County",
                "iso2": "SZ",
                "latitude": "48.03949540",
                "longitude": "22.00333000",
                "type": "county",
                "cities": [
                    {
                        "id": 55177,
                        "name": "Ajak",
                        "latitude": "48.17664000",
                        "longitude": "22.06273000"
                    },
                    {
                        "id": 55187,
                        "name": "Anarcs",
                        "latitude": "48.17642000",
                        "longitude": "22.11167000"
                    },
                    {
                        "id": 55189,
                        "name": "Apagy",
                        "latitude": "47.96431000",
                        "longitude": "21.93539000"
                    },
                    {
                        "id": 55193,
                        "name": "Aranyosapáti",
                        "latitude": "48.20595000",
                        "longitude": "22.25916000"
                    },
                    {
                        "id": 55208,
                        "name": "Baktalórántháza",
                        "latitude": "48.00000000",
                        "longitude": "22.08333000"
                    },
                    {
                        "id": 55209,
                        "name": "Baktalórántházai Járás",
                        "latitude": "48.00436000",
                        "longitude": "22.02449000"
                    },
                    {
                        "id": 55224,
                        "name": "Balkány",
                        "latitude": "47.77066000",
                        "longitude": "21.86314000"
                    },
                    {
                        "id": 55307,
                        "name": "Bököny",
                        "latitude": "47.73333000",
                        "longitude": "21.75000000"
                    },
                    {
                        "id": 55285,
                        "name": "Buj",
                        "latitude": "48.10000000",
                        "longitude": "21.65000000"
                    },
                    {
                        "id": 55329,
                        "name": "Csenger",
                        "latitude": "47.83582000",
                        "longitude": "22.68096000"
                    },
                    {
                        "id": 55330,
                        "name": "Csengeri Járás",
                        "latitude": "47.83045000",
                        "longitude": "22.59810000"
                    },
                    {
                        "id": 55356,
                        "name": "Demecser",
                        "latitude": "48.11648000",
                        "longitude": "21.92624000"
                    },
                    {
                        "id": 55391,
                        "name": "Döge",
                        "latitude": "48.26246000",
                        "longitude": "22.06339000"
                    },
                    {
                        "id": 55367,
                        "name": "Dombrád",
                        "latitude": "48.23333000",
                        "longitude": "21.93333000"
                    },
                    {
                        "id": 55406,
                        "name": "Encsencs",
                        "latitude": "47.73333000",
                        "longitude": "22.11667000"
                    },
                    {
                        "id": 55420,
                        "name": "Fehérgyarmat",
                        "latitude": "47.98333000",
                        "longitude": "22.51667000"
                    },
                    {
                        "id": 55421,
                        "name": "Fehérgyarmati Járás",
                        "latitude": "48.00436000",
                        "longitude": "22.63014000"
                    },
                    {
                        "id": 55435,
                        "name": "Fényeslitke",
                        "latitude": "48.27133000",
                        "longitude": "22.10009000"
                    },
                    {
                        "id": 55473,
                        "name": "Gégény",
                        "latitude": "48.15000000",
                        "longitude": "21.95000000"
                    },
                    {
                        "id": 55454,
                        "name": "Gyulaháza",
                        "latitude": "48.13333000",
                        "longitude": "22.11667000"
                    },
                    {
                        "id": 55513,
                        "name": "Hodász",
                        "latitude": "47.91834000",
                        "longitude": "22.20153000"
                    },
                    {
                        "id": 55524,
                        "name": "Ibrány",
                        "latitude": "48.12329000",
                        "longitude": "21.70953000"
                    },
                    {
                        "id": 55525,
                        "name": "Ibrányi Járás",
                        "latitude": "48.12794000",
                        "longitude": "21.69344000"
                    },
                    {
                        "id": 55636,
                        "name": "Kállósemjén",
                        "latitude": "47.86081000",
                        "longitude": "21.93929000"
                    },
                    {
                        "id": 55637,
                        "name": "Kálmánháza",
                        "latitude": "47.88333000",
                        "longitude": "21.58333000"
                    },
                    {
                        "id": 55639,
                        "name": "Kántorjánosi",
                        "latitude": "47.93333000",
                        "longitude": "22.15000000"
                    },
                    {
                        "id": 55641,
                        "name": "Kék",
                        "latitude": "48.11667000",
                        "longitude": "21.88333000"
                    },
                    {
                        "id": 55582,
                        "name": "Kemecse",
                        "latitude": "48.07532000",
                        "longitude": "21.80625000"
                    },
                    {
                        "id": 55583,
                        "name": "Kemecsei Járás",
                        "latitude": "48.10048000",
                        "longitude": "21.88414000"
                    },
                    {
                        "id": 55605,
                        "name": "Kisléta",
                        "latitude": "47.84244000",
                        "longitude": "22.00393000"
                    },
                    {
                        "id": 55612,
                        "name": "Kisvárda",
                        "latitude": "48.21667000",
                        "longitude": "22.08333000"
                    },
                    {
                        "id": 55613,
                        "name": "Kisvárdai Járás",
                        "latitude": "48.22100000",
                        "longitude": "22.06415000"
                    },
                    {
                        "id": 55616,
                        "name": "Kocsord",
                        "latitude": "47.93912000",
                        "longitude": "22.38333000"
                    },
                    {
                        "id": 55646,
                        "name": "Kótaj",
                        "latitude": "48.05000000",
                        "longitude": "21.71667000"
                    },
                    {
                        "id": 55662,
                        "name": "Levelek",
                        "latitude": "47.96282000",
                        "longitude": "21.98537000"
                    },
                    {
                        "id": 55721,
                        "name": "Mándok",
                        "latitude": "48.32149000",
                        "longitude": "22.19107000"
                    },
                    {
                        "id": 55723,
                        "name": "Máriapócs",
                        "latitude": "47.88303000",
                        "longitude": "22.02501000"
                    },
                    {
                        "id": 55728,
                        "name": "Mátészalka",
                        "latitude": "47.95528000",
                        "longitude": "22.32348000"
                    },
                    {
                        "id": 55729,
                        "name": "Mátészalkai Járás",
                        "latitude": "47.92961000",
                        "longitude": "22.31892000"
                    },
                    {
                        "id": 55732,
                        "name": "Mérk",
                        "latitude": "47.78824000",
                        "longitude": "22.38038000"
                    },
                    {
                        "id": 55743,
                        "name": "Nagycserkesz",
                        "latitude": "47.96667000",
                        "longitude": "21.53333000"
                    },
                    {
                        "id": 55744,
                        "name": "Nagydobos",
                        "latitude": "48.05759000",
                        "longitude": "22.30423000"
                    },
                    {
                        "id": 55746,
                        "name": "Nagyecsed",
                        "latitude": "47.86547000",
                        "longitude": "22.39159000"
                    },
                    {
                        "id": 55747,
                        "name": "Nagyhalász",
                        "latitude": "48.13266000",
                        "longitude": "21.76104000"
                    },
                    {
                        "id": 55751,
                        "name": "Nagykálló",
                        "latitude": "47.87491000",
                        "longitude": "21.84082000"
                    },
                    {
                        "id": 55752,
                        "name": "Nagykállói Járás",
                        "latitude": "47.79994000",
                        "longitude": "21.84753000"
                    },
                    {
                        "id": 55764,
                        "name": "Napkor",
                        "latitude": "47.93797000",
                        "longitude": "21.86763000"
                    },
                    {
                        "id": 55775,
                        "name": "Nyírbátor",
                        "latitude": "47.83333000",
                        "longitude": "22.13333000"
                    },
                    {
                        "id": 55776,
                        "name": "Nyírbátori Járás",
                        "latitude": "47.77553000",
                        "longitude": "22.11755000"
                    },
                    {
                        "id": 55777,
                        "name": "Nyírbéltek",
                        "latitude": "47.70000000",
                        "longitude": "22.13333000"
                    },
                    {
                        "id": 55774,
                        "name": "Nyírbogát",
                        "latitude": "47.80340000",
                        "longitude": "22.06561000"
                    },
                    {
                        "id": 55773,
                        "name": "Nyírbogdány",
                        "latitude": "48.05723000",
                        "longitude": "21.88242000"
                    },
                    {
                        "id": 55778,
                        "name": "Nyírcsaholy",
                        "latitude": "47.90383000",
                        "longitude": "22.33630000"
                    },
                    {
                        "id": 55779,
                        "name": "Nyíregyháza",
                        "latitude": "47.95539000",
                        "longitude": "21.71671000"
                    },
                    {
                        "id": 55780,
                        "name": "Nyíregyházi Járás",
                        "latitude": "47.97691000",
                        "longitude": "21.64463000"
                    },
                    {
                        "id": 55781,
                        "name": "Nyírgyulaj",
                        "latitude": "47.88622000",
                        "longitude": "22.09781000"
                    },
                    {
                        "id": 55782,
                        "name": "Nyírkarász",
                        "latitude": "48.09477000",
                        "longitude": "22.10463000"
                    },
                    {
                        "id": 55783,
                        "name": "Nyírlugos",
                        "latitude": "47.69315000",
                        "longitude": "22.04476000"
                    },
                    {
                        "id": 55784,
                        "name": "Nyírmada",
                        "latitude": "48.06667000",
                        "longitude": "22.20000000"
                    },
                    {
                        "id": 55785,
                        "name": "Nyírmeggyes",
                        "latitude": "47.91667000",
                        "longitude": "22.26667000"
                    },
                    {
                        "id": 55786,
                        "name": "Nyírmihálydi",
                        "latitude": "47.73976000",
                        "longitude": "21.96445000"
                    },
                    {
                        "id": 55788,
                        "name": "Nyírpazony",
                        "latitude": "47.98333000",
                        "longitude": "21.80000000"
                    },
                    {
                        "id": 55789,
                        "name": "Nyírtass",
                        "latitude": "48.11667000",
                        "longitude": "22.03333000"
                    },
                    {
                        "id": 55790,
                        "name": "Nyírtelek",
                        "latitude": "48.01667000",
                        "longitude": "21.63333000"
                    },
                    {
                        "id": 55791,
                        "name": "Nyírvasvári",
                        "latitude": "47.81667000",
                        "longitude": "22.18683000"
                    },
                    {
                        "id": 56150,
                        "name": "Ófehértó",
                        "latitude": "47.93333000",
                        "longitude": "22.05000000"
                    },
                    {
                        "id": 56157,
                        "name": "Ököritófülpös",
                        "latitude": "47.91862000",
                        "longitude": "22.50810000"
                    },
                    {
                        "id": 56153,
                        "name": "Ópályi",
                        "latitude": "47.99771000",
                        "longitude": "22.32617000"
                    },
                    {
                        "id": 55846,
                        "name": "Pátroha",
                        "latitude": "48.16667000",
                        "longitude": "22.00000000"
                    },
                    {
                        "id": 55815,
                        "name": "Petneháza",
                        "latitude": "48.06084000",
                        "longitude": "22.07485000"
                    },
                    {
                        "id": 55830,
                        "name": "Porcsalma",
                        "latitude": "47.88333000",
                        "longitude": "22.56667000"
                    },
                    {
                        "id": 55862,
                        "name": "Rakamaz",
                        "latitude": "48.12372000",
                        "longitude": "21.46429000"
                    },
                    {
                        "id": 55916,
                        "name": "Szakoly",
                        "latitude": "47.76667000",
                        "longitude": "21.91667000"
                    },
                    {
                        "id": 55918,
                        "name": "Szamosszeg",
                        "latitude": "48.04561000",
                        "longitude": "22.36582000"
                    },
                    {
                        "id": 56015,
                        "name": "Tarpa",
                        "latitude": "48.10480000",
                        "longitude": "22.53744000"
                    },
                    {
                        "id": 56022,
                        "name": "Tiszabercel",
                        "latitude": "48.15000000",
                        "longitude": "21.65000000"
                    },
                    {
                        "id": 56023,
                        "name": "Tiszabezdéd",
                        "latitude": "48.36667000",
                        "longitude": "22.15000000"
                    },
                    {
                        "id": 56027,
                        "name": "Tiszadada",
                        "latitude": "48.03333000",
                        "longitude": "21.25000000"
                    },
                    {
                        "id": 56028,
                        "name": "Tiszadob",
                        "latitude": "48.01667000",
                        "longitude": "21.16667000"
                    },
                    {
                        "id": 56029,
                        "name": "Tiszaeszlár",
                        "latitude": "48.05000000",
                        "longitude": "21.46667000"
                    },
                    {
                        "id": 56037,
                        "name": "Tiszalök",
                        "latitude": "48.01667000",
                        "longitude": "21.38333000"
                    },
                    {
                        "id": 56039,
                        "name": "Tiszanagyfalu",
                        "latitude": "48.10000000",
                        "longitude": "21.48333000"
                    },
                    {
                        "id": 56046,
                        "name": "Tiszavasvári",
                        "latitude": "47.96667000",
                        "longitude": "21.35000000"
                    },
                    {
                        "id": 56047,
                        "name": "Tiszavasvári Járás",
                        "latitude": "47.98606000",
                        "longitude": "21.36545000"
                    },
                    {
                        "id": 56056,
                        "name": "Tornyospálca",
                        "latitude": "48.26667000",
                        "longitude": "22.18333000"
                    },
                    {
                        "id": 56057,
                        "name": "Tunyogmatolcs",
                        "latitude": "47.96667000",
                        "longitude": "22.46667000"
                    },
                    {
                        "id": 56059,
                        "name": "Tuzsér",
                        "latitude": "48.34407000",
                        "longitude": "22.11762000"
                    },
                    {
                        "id": 56060,
                        "name": "Tyukod",
                        "latitude": "47.85378000",
                        "longitude": "22.56330000"
                    },
                    {
                        "id": 56160,
                        "name": "Újfehértó",
                        "latitude": "47.80000000",
                        "longitude": "21.68333000"
                    },
                    {
                        "id": 56088,
                        "name": "Vaja",
                        "latitude": "48.00574000",
                        "longitude": "22.16761000"
                    },
                    {
                        "id": 56114,
                        "name": "Vásárosnamény",
                        "latitude": "48.12542000",
                        "longitude": "22.31325000"
                    },
                    {
                        "id": 56115,
                        "name": "Vásárosnaményi Járás",
                        "latitude": "48.17981000",
                        "longitude": "22.35859000"
                    },
                    {
                        "id": 56134,
                        "name": "Záhony",
                        "latitude": "48.40906000",
                        "longitude": "22.17614000"
                    },
                    {
                        "id": 56135,
                        "name": "Záhonyi Járás",
                        "latitude": "48.34914000",
                        "longitude": "22.18925000"
                    }
                ]
            },
            {
                "id": 1029,
                "name": "Szeged",
                "iso2": "SD",
                "latitude": "46.25301020",
                "longitude": "20.14142530",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1033,
                "name": "Székesfehérvár",
                "iso2": "SF",
                "latitude": "47.18602620",
                "longitude": "18.42213580",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1061,
                "name": "Szekszárd",
                "iso2": "SS",
                "latitude": "46.34743260",
                "longitude": "18.70622930",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1047,
                "name": "Szolnok",
                "iso2": "SK",
                "latitude": "47.16213550",
                "longitude": "20.18247120",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1052,
                "name": "Szombathely",
                "iso2": "SH",
                "latitude": "47.23068510",
                "longitude": "16.62184410",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1066,
                "name": "Tatabánya",
                "iso2": "TB",
                "latitude": "47.56924600",
                "longitude": "18.40481800",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1038,
                "name": "Tolna County",
                "iso2": "TO",
                "latitude": "46.47627540",
                "longitude": "18.55706270",
                "type": "county",
                "cities": [
                    {
                        "id": 55291,
                        "name": "Báta",
                        "latitude": "46.12864000",
                        "longitude": "18.77027000"
                    },
                    {
                        "id": 55292,
                        "name": "Bátaszék",
                        "latitude": "46.19373000",
                        "longitude": "18.72307000"
                    },
                    {
                        "id": 55251,
                        "name": "Bogyiszló",
                        "latitude": "46.38638000",
                        "longitude": "18.82962000"
                    },
                    {
                        "id": 55308,
                        "name": "Bölcske",
                        "latitude": "46.74102000",
                        "longitude": "18.96736000"
                    },
                    {
                        "id": 55255,
                        "name": "Bonyhád",
                        "latitude": "46.29921000",
                        "longitude": "18.53024000"
                    },
                    {
                        "id": 55256,
                        "name": "Bonyhádi Járás",
                        "latitude": "46.33998000",
                        "longitude": "18.49739000"
                    },
                    {
                        "id": 55355,
                        "name": "Decs",
                        "latitude": "46.28428000",
                        "longitude": "18.76000000"
                    },
                    {
                        "id": 55390,
                        "name": "Döbrököz",
                        "latitude": "46.42178000",
                        "longitude": "18.23953000"
                    },
                    {
                        "id": 55368,
                        "name": "Dombóvár",
                        "latitude": "46.37657000",
                        "longitude": "18.13696000"
                    },
                    {
                        "id": 55369,
                        "name": "Dombóvári Járás",
                        "latitude": "46.45592000",
                        "longitude": "18.19076000"
                    },
                    {
                        "id": 55373,
                        "name": "Dunaföldvár",
                        "latitude": "46.80713000",
                        "longitude": "18.92763000"
                    },
                    {
                        "id": 55379,
                        "name": "Dunaszentgyörgy",
                        "latitude": "46.52852000",
                        "longitude": "18.81771000"
                    },
                    {
                        "id": 55415,
                        "name": "Fadd",
                        "latitude": "46.46476000",
                        "longitude": "18.81925000"
                    },
                    {
                        "id": 55465,
                        "name": "Gyönk",
                        "latitude": "46.55603000",
                        "longitude": "18.47694000"
                    },
                    {
                        "id": 55523,
                        "name": "Hőgyész",
                        "latitude": "46.49697000",
                        "longitude": "18.41841000"
                    },
                    {
                        "id": 55528,
                        "name": "Iregszemcse",
                        "latitude": "46.69286000",
                        "longitude": "18.18581000"
                    },
                    {
                        "id": 55673,
                        "name": "Madocsa",
                        "latitude": "46.68790000",
                        "longitude": "18.95791000"
                    },
                    {
                        "id": 55745,
                        "name": "Nagydorog",
                        "latitude": "46.62749000",
                        "longitude": "18.65565000"
                    },
                    {
                        "id": 55758,
                        "name": "Nagymányok",
                        "latitude": "46.27911000",
                        "longitude": "18.45489000"
                    },
                    {
                        "id": 55795,
                        "name": "Németkér",
                        "latitude": "46.71637000",
                        "longitude": "18.76311000"
                    },
                    {
                        "id": 56170,
                        "name": "Őcsény",
                        "latitude": "46.31370000",
                        "longitude": "18.75749000"
                    },
                    {
                        "id": 55803,
                        "name": "Ozora",
                        "latitude": "46.75133000",
                        "longitude": "18.40010000"
                    },
                    {
                        "id": 55805,
                        "name": "Paks",
                        "latitude": "46.62210000",
                        "longitude": "18.85569000"
                    },
                    {
                        "id": 55806,
                        "name": "Paksi Járás",
                        "latitude": "46.66035000",
                        "longitude": "18.78572000"
                    },
                    {
                        "id": 55825,
                        "name": "Pincehely",
                        "latitude": "46.68095000",
                        "longitude": "18.43935000"
                    },
                    {
                        "id": 55899,
                        "name": "Simontornya",
                        "latitude": "46.75462000",
                        "longitude": "18.55490000"
                    },
                    {
                        "id": 55924,
                        "name": "Szedres",
                        "latitude": "46.47551000",
                        "longitude": "18.68305000"
                    },
                    {
                        "id": 55930,
                        "name": "Szekszárd",
                        "latitude": "46.35014000",
                        "longitude": "18.70905000"
                    },
                    {
                        "id": 55931,
                        "name": "Szekszárdi Járás",
                        "latitude": "46.33998000",
                        "longitude": "18.67893000"
                    },
                    {
                        "id": 55940,
                        "name": "Szentgálpuszta",
                        "latitude": "46.37479000",
                        "longitude": "18.62601000"
                    },
                    {
                        "id": 56007,
                        "name": "Tamási",
                        "latitude": "46.63333000",
                        "longitude": "18.28333000"
                    },
                    {
                        "id": 56008,
                        "name": "Tamási Járás",
                        "latitude": "46.65424000",
                        "longitude": "18.35857000"
                    },
                    {
                        "id": 56019,
                        "name": "Tengelic",
                        "latitude": "46.52878000",
                        "longitude": "18.71117000"
                    },
                    {
                        "id": 56053,
                        "name": "Tolna",
                        "latitude": "46.42677000",
                        "longitude": "18.78248000"
                    },
                    {
                        "id": 56054,
                        "name": "Tolnai Járás",
                        "latitude": "46.42541000",
                        "longitude": "18.82691000"
                    },
                    {
                        "id": 56129,
                        "name": "Zomba",
                        "latitude": "46.41084000",
                        "longitude": "18.56577000"
                    }
                ]
            },
            {
                "id": 1039,
                "name": "Vas County",
                "iso2": "VA",
                "latitude": "47.09291110",
                "longitude": "16.68121830",
                "type": "county",
                "cities": [
                    {
                        "id": 55309,
                        "name": "Bük",
                        "latitude": "47.38486000",
                        "longitude": "16.75065000"
                    },
                    {
                        "id": 55318,
                        "name": "Celldömölk",
                        "latitude": "47.25713000",
                        "longitude": "17.15027000"
                    },
                    {
                        "id": 55319,
                        "name": "Celldömölki Járás",
                        "latitude": "47.25001000",
                        "longitude": "17.13209000"
                    },
                    {
                        "id": 55332,
                        "name": "Csepreg",
                        "latitude": "47.40098000",
                        "longitude": "16.70881000"
                    },
                    {
                        "id": 55447,
                        "name": "Gencsapáti",
                        "latitude": "47.28496000",
                        "longitude": "16.59575000"
                    },
                    {
                        "id": 55534,
                        "name": "Ják",
                        "latitude": "47.14249000",
                        "longitude": "16.58148000"
                    },
                    {
                        "id": 55538,
                        "name": "Jánosháza",
                        "latitude": "47.11937000",
                        "longitude": "17.16503000"
                    },
                    {
                        "id": 55647,
                        "name": "Körmend",
                        "latitude": "47.01096000",
                        "longitude": "16.60596000"
                    },
                    {
                        "id": 55648,
                        "name": "Körmendi Járás",
                        "latitude": "46.92164000",
                        "longitude": "16.53291000"
                    },
                    {
                        "id": 55651,
                        "name": "Kőszeg",
                        "latitude": "47.38922000",
                        "longitude": "16.54100000"
                    },
                    {
                        "id": 55652,
                        "name": "Kőszegi Járás",
                        "latitude": "47.37500000",
                        "longitude": "16.65650000"
                    },
                    {
                        "id": 55876,
                        "name": "Répcelak",
                        "latitude": "47.42105000",
                        "longitude": "17.01795000"
                    },
                    {
                        "id": 55990,
                        "name": "Sárvár",
                        "latitude": "47.25395000",
                        "longitude": "16.93525000"
                    },
                    {
                        "id": 55991,
                        "name": "Sárvári Járás",
                        "latitude": "47.23868000",
                        "longitude": "16.93299000"
                    },
                    {
                        "id": 55938,
                        "name": "Szentgotthárd",
                        "latitude": "46.95261000",
                        "longitude": "16.27358000"
                    },
                    {
                        "id": 55939,
                        "name": "Szentgotthárdi Járás",
                        "latitude": "46.93674000",
                        "longitude": "16.30362000"
                    },
                    {
                        "id": 55966,
                        "name": "Szombathely",
                        "latitude": "47.23088000",
                        "longitude": "16.62155000"
                    },
                    {
                        "id": 55967,
                        "name": "Szombathelyi Járás",
                        "latitude": "47.21037000",
                        "longitude": "16.63954000"
                    },
                    {
                        "id": 56070,
                        "name": "Táplánszentkereszt",
                        "latitude": "47.19496000",
                        "longitude": "16.69613000"
                    },
                    {
                        "id": 56092,
                        "name": "Vasvár",
                        "latitude": "47.04928000",
                        "longitude": "16.79954000"
                    },
                    {
                        "id": 56093,
                        "name": "Vasvári Járás",
                        "latitude": "47.03487000",
                        "longitude": "16.85939000"
                    },
                    {
                        "id": 56116,
                        "name": "Vép",
                        "latitude": "47.23041000",
                        "longitude": "16.72248000"
                    }
                ]
            },
            {
                "id": 1062,
                "name": "Veszprém",
                "iso2": "VM",
                "latitude": "47.10280870",
                "longitude": "17.90930190",
                "type": "city with county rights",
                "cities": []
            },
            {
                "id": 1054,
                "name": "Veszprém County",
                "iso2": "VE",
                "latitude": "47.09309740",
                "longitude": "17.91007630",
                "type": "county",
                "cities": [
                    {
                        "id": 55178,
                        "name": "Ajka",
                        "latitude": "47.10196000",
                        "longitude": "17.55892000"
                    },
                    {
                        "id": 55179,
                        "name": "Ajkai Járás",
                        "latitude": "47.07988000",
                        "longitude": "17.56375000"
                    },
                    {
                        "id": 55200,
                        "name": "Badacsonytomaj",
                        "latitude": "46.80711000",
                        "longitude": "17.51385000"
                    },
                    {
                        "id": 55212,
                        "name": "Balatonalmádi",
                        "latitude": "47.03526000",
                        "longitude": "18.02076000"
                    },
                    {
                        "id": 55213,
                        "name": "Balatonalmádi Járás",
                        "latitude": "47.04174000",
                        "longitude": "18.09617000"
                    },
                    {
                        "id": 55218,
                        "name": "Balatonfüred",
                        "latitude": "46.96188000",
                        "longitude": "17.87187000"
                    },
                    {
                        "id": 55219,
                        "name": "Balatonfüredi Járás",
                        "latitude": "46.93952000",
                        "longitude": "17.79411000"
                    },
                    {
                        "id": 55220,
                        "name": "Balatonkenese",
                        "latitude": "47.04019000",
                        "longitude": "18.10671000"
                    },
                    {
                        "id": 55241,
                        "name": "Berhida",
                        "latitude": "47.11131000",
                        "longitude": "18.12948000"
                    },
                    {
                        "id": 55323,
                        "name": "Csabrendek",
                        "latitude": "47.01356000",
                        "longitude": "17.29108000"
                    },
                    {
                        "id": 55335,
                        "name": "Csetény",
                        "latitude": "47.31806000",
                        "longitude": "17.99208000"
                    },
                    {
                        "id": 55339,
                        "name": "Csopak",
                        "latitude": "46.97709000",
                        "longitude": "17.91819000"
                    },
                    {
                        "id": 55360,
                        "name": "Devecser",
                        "latitude": "47.10316000",
                        "longitude": "17.43802000"
                    },
                    {
                        "id": 55361,
                        "name": "Devecseri Járás",
                        "latitude": "47.16836000",
                        "longitude": "17.32271000"
                    },
                    {
                        "id": 55492,
                        "name": "Hajmáskér",
                        "latitude": "47.14513000",
                        "longitude": "18.01964000"
                    },
                    {
                        "id": 55506,
                        "name": "Herend",
                        "latitude": "47.13333000",
                        "longitude": "17.75000000"
                    },
                    {
                        "id": 55664,
                        "name": "Litér",
                        "latitude": "47.10104000",
                        "longitude": "18.00454000"
                    },
                    {
                        "id": 55766,
                        "name": "Nemesvámos",
                        "latitude": "47.05514000",
                        "longitude": "17.87477000"
                    },
                    {
                        "id": 56172,
                        "name": "Ősi",
                        "latitude": "47.14722000",
                        "longitude": "18.18833000"
                    },
                    {
                        "id": 55842,
                        "name": "Pápa",
                        "latitude": "47.33004000",
                        "longitude": "17.46740000"
                    },
                    {
                        "id": 55843,
                        "name": "Pápai Járás",
                        "latitude": "47.33769000",
                        "longitude": "17.49663000"
                    },
                    {
                        "id": 55858,
                        "name": "Pétfürdő",
                        "latitude": "47.16667000",
                        "longitude": "18.11667000"
                    },
                    {
                        "id": 55879,
                        "name": "Révfülöp",
                        "latitude": "46.82573000",
                        "longitude": "17.61967000"
                    },
                    {
                        "id": 55999,
                        "name": "Sümeg",
                        "latitude": "46.97703000",
                        "longitude": "17.28209000"
                    },
                    {
                        "id": 56000,
                        "name": "Sümegi Járás",
                        "latitude": "47.02648000",
                        "longitude": "17.26779000"
                    },
                    {
                        "id": 55943,
                        "name": "Szentkirályszabadja",
                        "latitude": "47.05760000",
                        "longitude": "17.97052000"
                    },
                    {
                        "id": 56009,
                        "name": "Tapolca",
                        "latitude": "46.88152000",
                        "longitude": "17.44117000"
                    },
                    {
                        "id": 56010,
                        "name": "Tapolcai Járás",
                        "latitude": "46.89833000",
                        "longitude": "17.49510000"
                    },
                    {
                        "id": 56020,
                        "name": "Tihany",
                        "latitude": "46.91369000",
                        "longitude": "17.88918000"
                    },
                    {
                        "id": 56166,
                        "name": "Úrkút",
                        "latitude": "47.08505000",
                        "longitude": "17.64393000"
                    },
                    {
                        "id": 56112,
                        "name": "Várpalota",
                        "latitude": "47.19936000",
                        "longitude": "18.13954000"
                    },
                    {
                        "id": 56113,
                        "name": "Várpalotai Járás",
                        "latitude": "47.18514000",
                        "longitude": "18.12211000"
                    },
                    {
                        "id": 56100,
                        "name": "Veszprém",
                        "latitude": "47.09327000",
                        "longitude": "17.91149000"
                    },
                    {
                        "id": 56101,
                        "name": "Veszprémi Járás",
                        "latitude": "47.09666000",
                        "longitude": "17.82157000"
                    },
                    {
                        "id": 56138,
                        "name": "Zánka",
                        "latitude": "46.87146000",
                        "longitude": "17.68473000"
                    },
                    {
                        "id": 56127,
                        "name": "Zirc",
                        "latitude": "47.26362000",
                        "longitude": "17.87373000"
                    },
                    {
                        "id": 56128,
                        "name": "Zirci Járás",
                        "latitude": "47.28583000",
                        "longitude": "17.88412000"
                    }
                ]
            },
            {
                "id": 1046,
                "name": "Zala County",
                "iso2": "ZA",
                "latitude": "46.73844040",
                "longitude": "16.91522520",
                "type": "county",
                "cities": [
                    {
                        "id": 55234,
                        "name": "Becsehely",
                        "latitude": "46.44755000",
                        "longitude": "16.77710000"
                    },
                    {
                        "id": 55334,
                        "name": "Cserszegtomaj",
                        "latitude": "46.80165000",
                        "longitude": "17.22096000"
                    },
                    {
                        "id": 55450,
                        "name": "Gyenesdiás",
                        "latitude": "46.77058000",
                        "longitude": "17.28660000"
                    },
                    {
                        "id": 55519,
                        "name": "Hévíz",
                        "latitude": "46.79031000",
                        "longitude": "17.18408000"
                    },
                    {
                        "id": 55589,
                        "name": "Keszthely",
                        "latitude": "46.76812000",
                        "longitude": "17.24317000"
                    },
                    {
                        "id": 55590,
                        "name": "Keszthelyi Járás",
                        "latitude": "46.78356000",
                        "longitude": "17.22381000"
                    },
                    {
                        "id": 55657,
                        "name": "Lenti",
                        "latitude": "46.62403000",
                        "longitude": "16.53863000"
                    },
                    {
                        "id": 55658,
                        "name": "Lenti Járás",
                        "latitude": "46.65649000",
                        "longitude": "16.57443000"
                    },
                    {
                        "id": 55660,
                        "name": "Letenye",
                        "latitude": "46.43301000",
                        "longitude": "16.72583000"
                    },
                    {
                        "id": 55661,
                        "name": "Letenyei Járás",
                        "latitude": "46.50552000",
                        "longitude": "16.76503000"
                    },
                    {
                        "id": 55717,
                        "name": "Murakeresztúr",
                        "latitude": "46.36422000",
                        "longitude": "16.88177000"
                    },
                    {
                        "id": 55748,
                        "name": "Nagykanizsa",
                        "latitude": "46.45347000",
                        "longitude": "16.99104000"
                    },
                    {
                        "id": 55749,
                        "name": "Nagykanizsai Járás",
                        "latitude": "46.51873000",
                        "longitude": "17.04433000"
                    },
                    {
                        "id": 55804,
                        "name": "Pacsa",
                        "latitude": "46.71981000",
                        "longitude": "17.01401000"
                    },
                    {
                        "id": 55984,
                        "name": "Sármellék",
                        "latitude": "46.71221000",
                        "longitude": "17.16865000"
                    },
                    {
                        "id": 56087,
                        "name": "Türje",
                        "latitude": "46.98366000",
                        "longitude": "17.10742000"
                    },
                    {
                        "id": 56104,
                        "name": "Vonyarcvashegy",
                        "latitude": "46.75742000",
                        "longitude": "17.31172000"
                    },
                    {
                        "id": 56120,
                        "name": "Zalaegerszeg",
                        "latitude": "46.84000000",
                        "longitude": "16.84389000"
                    },
                    {
                        "id": 56121,
                        "name": "Zalaegerszegi Járás",
                        "latitude": "46.80000000",
                        "longitude": "16.83000000"
                    },
                    {
                        "id": 56122,
                        "name": "Zalakomár",
                        "latitude": "46.53795000",
                        "longitude": "17.18094000"
                    },
                    {
                        "id": 56123,
                        "name": "Zalalövő",
                        "latitude": "46.84802000",
                        "longitude": "16.58750000"
                    },
                    {
                        "id": 56124,
                        "name": "Zalaszentgrót",
                        "latitude": "46.94474000",
                        "longitude": "17.07925000"
                    },
                    {
                        "id": 56125,
                        "name": "Zalaszentgróti Járás",
                        "latitude": "46.92070000",
                        "longitude": "17.10095000"
                    }
                ]
            },
            {
                "id": 1050,
                "name": "Zalaegerszeg",
                "iso2": "ZE",
                "latitude": "46.84169360",
                "longitude": "16.84163220",
                "type": "county",
                "cities": []
            }
        ]
    },
    {
        "id": 100,
        "name": "Iceland",
        "iso3": "ISL",
        "iso2": "IS",
        "numeric_code": "352",
        "phonecode": "354",
        "capital": "Reykjavik",
        "currency": "ISK",
        "currency_name": "Icelandic króna",
        "currency_symbol": "ko",
        "tld": ".is",
        "native": "Ísland",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Icelandic",
        "timezones": [
            {
                "zoneName": "Atlantic\/Reykjavik",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Island",
            "ko": "아이슬란드",
            "pt-BR": "Islândia",
            "pt": "Islândia",
            "nl": "IJsland",
            "hr": "Island",
            "fa": "ایسلند",
            "de": "Island",
            "es": "Islandia",
            "fr": "Islande",
            "ja": "アイスランド",
            "it": "Islanda",
            "zh-CN": "冰岛",
            "tr": "İzlanda",
            "ru": "Исландия",
            "uk": "Ісландія",
            "pl": "Islandia"
        },
        "latitude": "65.00000000",
        "longitude": "-18.00000000",
        "emoji": "🇮🇸",
        "emojiU": "U+1F1EE U+1F1F8",
        "states": [
            {
                "id": 3431,
                "name": "Capital",
                "iso2": "1",
                "latitude": "64.10638390",
                "longitude": "-22.29105810",
                "type": "region",
                "cities": [
                    {
                        "id": 135228,
                        "name": "Álftanes",
                        "latitude": "64.10000000",
                        "longitude": "-22.01667000"
                    },
                    {
                        "id": 135181,
                        "name": "Garðabær",
                        "latitude": "64.08865000",
                        "longitude": "-21.92298000"
                    },
                    {
                        "id": 135186,
                        "name": "Hafnarfjörður",
                        "latitude": "64.06710000",
                        "longitude": "-21.93774000"
                    },
                    {
                        "id": 135196,
                        "name": "Kjósarhreppur",
                        "latitude": "64.30644000",
                        "longitude": "-21.49919000"
                    },
                    {
                        "id": 135197,
                        "name": "Kópavogur",
                        "latitude": "64.11234000",
                        "longitude": "-21.91298000"
                    },
                    {
                        "id": 135200,
                        "name": "Mosfellsbaer",
                        "latitude": "64.15000000",
                        "longitude": "-21.65000000"
                    },
                    {
                        "id": 135206,
                        "name": "Reykjavík",
                        "latitude": "64.13548000",
                        "longitude": "-21.89541000"
                    },
                    {
                        "id": 135211,
                        "name": "Seltjarnarnes",
                        "latitude": "64.15309000",
                        "longitude": "-21.99499000"
                    }
                ]
            },
            {
                "id": 3433,
                "name": "Eastern",
                "iso2": "7",
                "latitude": "64.95976540",
                "longitude": "-18.06910380",
                "type": "region",
                "cities": [
                    {
                        "id": 135166,
                        "name": "Borgarfjarðarhreppur",
                        "latitude": "65.43401000",
                        "longitude": "-13.82933000"
                    },
                    {
                        "id": 135168,
                        "name": "Breiðdalshreppur",
                        "latitude": "64.83333000",
                        "longitude": "-14.25000000"
                    },
                    {
                        "id": 135172,
                        "name": "Egilsstaðir",
                        "latitude": "65.26687000",
                        "longitude": "-14.39485000"
                    },
                    {
                        "id": 135173,
                        "name": "Eskifjörður",
                        "latitude": "65.07306000",
                        "longitude": "-14.01525000"
                    },
                    {
                        "id": 135177,
                        "name": "Fjarðabyggð",
                        "latitude": "65.08333000",
                        "longitude": "-14.00000000"
                    },
                    {
                        "id": 135179,
                        "name": "Fljótsdalshérað",
                        "latitude": "65.25020000",
                        "longitude": "-15.37211000"
                    },
                    {
                        "id": 135178,
                        "name": "Fljótsdalshreppur",
                        "latitude": "64.85275000",
                        "longitude": "-15.25680000"
                    },
                    {
                        "id": 135191,
                        "name": "Höfn",
                        "latitude": "64.25388000",
                        "longitude": "-15.21212000"
                    },
                    {
                        "id": 135203,
                        "name": "Neskaupstaður",
                        "latitude": "65.14819000",
                        "longitude": "-13.68368000"
                    },
                    {
                        "id": 135207,
                        "name": "Reyðarfjörður",
                        "latitude": "65.03164000",
                        "longitude": "-14.21832000"
                    }
                ]
            },
            {
                "id": 3437,
                "name": "Northeastern",
                "iso2": "6",
                "latitude": "65.46399840",
                "longitude": "-19.43273710",
                "type": "region",
                "cities": [
                    {
                        "id": 135163,
                        "name": "Akureyri",
                        "latitude": "65.68353000",
                        "longitude": "-18.08780000"
                    },
                    {
                        "id": 135170,
                        "name": "Dalvík",
                        "latitude": "65.97018000",
                        "longitude": "-18.52861000"
                    },
                    {
                        "id": 135171,
                        "name": "Dalvíkurbyggð",
                        "latitude": "65.87318000",
                        "longitude": "-18.60844000"
                    },
                    {
                        "id": 135175,
                        "name": "Eyjafjarðarsveit",
                        "latitude": "65.33333000",
                        "longitude": "-18.16667000"
                    },
                    {
                        "id": 135176,
                        "name": "Fjallabyggð",
                        "latitude": "66.05962000",
                        "longitude": "-18.78220000"
                    },
                    {
                        "id": 135185,
                        "name": "Grýtubakkahreppur",
                        "latitude": "65.98333000",
                        "longitude": "-18.11667000"
                    },
                    {
                        "id": 135192,
                        "name": "Hörgársveit",
                        "latitude": "65.64828000",
                        "longitude": "-18.49599000"
                    },
                    {
                        "id": 135194,
                        "name": "Húsavík",
                        "latitude": "66.04148000",
                        "longitude": "-17.33834000"
                    },
                    {
                        "id": 135198,
                        "name": "Langanesbyggð",
                        "latitude": "66.05186000",
                        "longitude": "-15.18969000"
                    },
                    {
                        "id": 135199,
                        "name": "Laugar",
                        "latitude": "65.72159000",
                        "longitude": "-17.37352000"
                    },
                    {
                        "id": 135212,
                        "name": "Siglufjörður",
                        "latitude": "66.15198000",
                        "longitude": "-18.90815000"
                    },
                    {
                        "id": 135217,
                        "name": "Skútustaðahreppur",
                        "latitude": "65.17177000",
                        "longitude": "-16.77890000"
                    },
                    {
                        "id": 135221,
                        "name": "Svalbarðsstrandarhreppur",
                        "latitude": "65.74138000",
                        "longitude": "-18.03513000"
                    },
                    {
                        "id": 135223,
                        "name": "Tjörneshreppur",
                        "latitude": "66.11667000",
                        "longitude": "-17.20000000"
                    },
                    {
                        "id": 135233,
                        "name": "Þingeyjarsveit",
                        "latitude": "65.37229000",
                        "longitude": "-17.59927000"
                    }
                ]
            },
            {
                "id": 3435,
                "name": "Northwestern",
                "iso2": "5",
                "latitude": "65.46218120",
                "longitude": "-21.02708000",
                "type": "region",
                "cities": [
                    {
                        "id": 135161,
                        "name": "Akrahreppur",
                        "latitude": "65.35505000",
                        "longitude": "-18.79572000"
                    },
                    {
                        "id": 135193,
                        "name": "Húnaþing Vestra",
                        "latitude": "65.25000000",
                        "longitude": "-20.91667000"
                    },
                    {
                        "id": 135209,
                        "name": "Sauðárkrókur",
                        "latitude": "65.74611000",
                        "longitude": "-19.63944000"
                    },
                    {
                        "id": 135214,
                        "name": "Skagabyggð",
                        "latitude": "65.95000000",
                        "longitude": "-20.25000000"
                    },
                    {
                        "id": 135222,
                        "name": "Sveitarfélagið Skagafjörður",
                        "latitude": "65.50018000",
                        "longitude": "-19.44566000"
                    }
                ]
            },
            {
                "id": 3434,
                "name": "Southern",
                "iso2": "8",
                "latitude": "64.05815480",
                "longitude": "-22.23117400",
                "type": "region",
                "cities": [
                    {
                        "id": 135229,
                        "name": "Ásahreppur",
                        "latitude": "63.87589000",
                        "longitude": "-20.59484000"
                    },
                    {
                        "id": 135164,
                        "name": "Bláskógabyggð",
                        "latitude": "64.41667000",
                        "longitude": "-20.33333000"
                    },
                    {
                        "id": 135180,
                        "name": "Flóahreppur",
                        "latitude": "63.89569000",
                        "longitude": "-20.80159000"
                    },
                    {
                        "id": 135184,
                        "name": "Grímsnes- og Grafningshreppur",
                        "latitude": "64.08533000",
                        "longitude": "-20.96710000"
                    },
                    {
                        "id": 135188,
                        "name": "Hrunamannahreppur",
                        "latitude": "64.40944000",
                        "longitude": "-19.72237000"
                    },
                    {
                        "id": 135190,
                        "name": "Hveragerði",
                        "latitude": "64.00039000",
                        "longitude": "-21.18602000"
                    },
                    {
                        "id": 135202,
                        "name": "Mýrdalshreppur",
                        "latitude": "63.50000000",
                        "longitude": "-19.00000000"
                    },
                    {
                        "id": 135210,
                        "name": "Selfoss",
                        "latitude": "63.93311000",
                        "longitude": "-20.99712000"
                    },
                    {
                        "id": 135213,
                        "name": "Skaftárhreppur",
                        "latitude": "63.95948000",
                        "longitude": "-18.14491000"
                    },
                    {
                        "id": 135215,
                        "name": "Skeiða- og Gnúpverjahreppur",
                        "latitude": "64.34738000",
                        "longitude": "-19.37757000"
                    },
                    {
                        "id": 135225,
                        "name": "Vestmannaeyjabær",
                        "latitude": "63.43877000",
                        "longitude": "-20.26900000"
                    },
                    {
                        "id": 135226,
                        "name": "Vestmannaeyjar",
                        "latitude": "63.44273000",
                        "longitude": "-20.27339000"
                    },
                    {
                        "id": 135234,
                        "name": "Þorlákshöfn",
                        "latitude": "63.85591000",
                        "longitude": "-21.38337000"
                    }
                ]
            },
            {
                "id": 3430,
                "name": "Southern Peninsula",
                "iso2": "2",
                "latitude": "63.91548030",
                "longitude": "-22.36496670",
                "type": "region",
                "cities": [
                    {
                        "id": 135182,
                        "name": "Garður",
                        "latitude": "64.06558000",
                        "longitude": "-22.64656000"
                    },
                    {
                        "id": 135183,
                        "name": "Grindavík",
                        "latitude": "63.83849000",
                        "longitude": "-22.43931000"
                    },
                    {
                        "id": 135195,
                        "name": "Keflavík",
                        "latitude": "64.00492000",
                        "longitude": "-22.56242000"
                    },
                    {
                        "id": 135205,
                        "name": "Reykjanesbær",
                        "latitude": "63.99813000",
                        "longitude": "-22.56111000"
                    },
                    {
                        "id": 135208,
                        "name": "Sandgerði",
                        "latitude": "64.03762000",
                        "longitude": "-22.70799000"
                    },
                    {
                        "id": 135227,
                        "name": "Vogar",
                        "latitude": "63.98160000",
                        "longitude": "-22.38473000"
                    }
                ]
            },
            {
                "id": 3436,
                "name": "Western",
                "iso2": "3",
                "latitude": "64.88654670",
                "longitude": "-24.55592960",
                "type": "region",
                "cities": [
                    {
                        "id": 135162,
                        "name": "Akranes",
                        "latitude": "64.32179000",
                        "longitude": "-22.07490000"
                    },
                    {
                        "id": 135165,
                        "name": "Borgarbyggð",
                        "latitude": "64.71446000",
                        "longitude": "-21.23788000"
                    },
                    {
                        "id": 135167,
                        "name": "Borgarnes",
                        "latitude": "64.53834000",
                        "longitude": "-21.92064000"
                    },
                    {
                        "id": 135169,
                        "name": "Dalabyggð",
                        "latitude": "65.10121000",
                        "longitude": "-21.72871000"
                    },
                    {
                        "id": 135174,
                        "name": "Eyja- og Miklaholtshreppur",
                        "latitude": "64.85846000",
                        "longitude": "-22.54557000"
                    },
                    {
                        "id": 135187,
                        "name": "Helgafellssveit",
                        "latitude": "64.99069000",
                        "longitude": "-22.78948000"
                    },
                    {
                        "id": 135189,
                        "name": "Hvalfjarðarsveit",
                        "latitude": "64.44265000",
                        "longitude": "-21.61086000"
                    },
                    {
                        "id": 135232,
                        "name": "Ólafsvík",
                        "latitude": "64.89429000",
                        "longitude": "-23.70918000"
                    },
                    {
                        "id": 135216,
                        "name": "Skorradalshreppur",
                        "latitude": "64.51667000",
                        "longitude": "-21.50000000"
                    },
                    {
                        "id": 135218,
                        "name": "Snæfellsbær",
                        "latitude": "64.86667000",
                        "longitude": "-23.50000000"
                    },
                    {
                        "id": 135220,
                        "name": "Stykkishólmur",
                        "latitude": "65.07537000",
                        "longitude": "-22.72977000"
                    }
                ]
            },
            {
                "id": 3432,
                "name": "Westfjords",
                "iso2": "4",
                "latitude": "65.69368200",
                "longitude": "-25.39762350",
                "type": "region",
                "cities": [
                    {
                        "id": 135230,
                        "name": "Ísafjarðarbær",
                        "latitude": "66.07586000",
                        "longitude": "-23.12794000"
                    },
                    {
                        "id": 135231,
                        "name": "Ísafjörður",
                        "latitude": "66.07475000",
                        "longitude": "-23.13498000"
                    },
                    {
                        "id": 135204,
                        "name": "Reykhólahreppur",
                        "latitude": "65.60990000",
                        "longitude": "-22.33324000"
                    },
                    {
                        "id": 135219,
                        "name": "Strandabyggð",
                        "latitude": "65.77455000",
                        "longitude": "-21.95725000"
                    },
                    {
                        "id": 135224,
                        "name": "Tálknafjarðarhreppur",
                        "latitude": "65.61667000",
                        "longitude": "-23.88333000"
                    }
                ]
            }
        ]
    },
    {
        "id": 101,
        "name": "India",
        "iso3": "IND",
        "iso2": "IN",
        "numeric_code": "356",
        "phonecode": "91",
        "capital": "New Delhi",
        "currency": "INR",
        "currency_name": "Indian rupee",
        "currency_symbol": "₹",
        "tld": ".in",
        "native": "भारत",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Southern Asia",
        "subregion_id": 14,
        "nationality": "Indian",
        "timezones": [
            {
                "zoneName": "Asia\/Kolkata",
                "gmtOffset": 19800,
                "gmtOffsetName": "UTC+05:30",
                "abbreviation": "IST",
                "tzName": "Indian Standard Time"
            }
        ],
        "translations": {
            "br": "India",
            "ko": "인도",
            "pt-BR": "Índia",
            "pt": "Índia",
            "nl": "India",
            "hr": "Indija",
            "fa": "هند",
            "de": "Indien",
            "es": "India",
            "fr": "Inde",
            "ja": "インド",
            "it": "India",
            "zh-CN": "印度",
            "tr": "Hindistan",
            "ru": "Индия",
            "uk": "Індія",
            "pl": "Indie"
        },
        "latitude": "20.00000000",
        "longitude": "77.00000000",
        "emoji": "🇮🇳",
        "emojiU": "U+1F1EE U+1F1F3",
        "states": [
            {
                "id": 4023,
                "name": "Andaman and Nicobar Islands",
                "iso2": "AN",
                "latitude": "11.74008670",
                "longitude": "92.65864010",
                "type": "union territory",
                "cities": [
                    {
                        "id": 57837,
                        "name": "Bamboo Flat",
                        "latitude": "11.70000000",
                        "longitude": "92.71667000"
                    },
                    {
                        "id": 133213,
                        "name": "Nicobar",
                        "latitude": "7.03002000",
                        "longitude": "93.79028000"
                    },
                    {
                        "id": 133482,
                        "name": "Port Blair",
                        "latitude": "11.66613000",
                        "longitude": "92.74635000"
                    },
                    {
                        "id": 134006,
                        "name": "South Andaman",
                        "latitude": "10.75776000",
                        "longitude": "92.52136000"
                    }
                ]
            },
            {
                "id": 4017,
                "name": "Andhra Pradesh",
                "iso2": "AP",
                "latitude": "15.91289980",
                "longitude": "79.73998750",
                "type": "state",
                "cities": [
                    {
                        "id": 57593,
                        "name": "Addanki",
                        "latitude": "15.81061000",
                        "longitude": "79.97338000"
                    },
                    {
                        "id": 134452,
                        "name": "Adoni",
                        "latitude": "15.62788000",
                        "longitude": "77.27495000"
                    },
                    {
                        "id": 57620,
                        "name": "Akasahebpet",
                        "latitude": "17.50455000",
                        "longitude": "82.56597000"
                    },
                    {
                        "id": 57623,
                        "name": "Akividu",
                        "latitude": "16.58225000",
                        "longitude": "81.38112000"
                    },
                    {
                        "id": 57624,
                        "name": "Akkarampalle",
                        "latitude": "13.65000000",
                        "longitude": "79.42000000"
                    },
                    {
                        "id": 57658,
                        "name": "Amalapuram",
                        "latitude": "16.57868000",
                        "longitude": "82.00609000"
                    },
                    {
                        "id": 57690,
                        "name": "Amudalavalasa",
                        "latitude": "18.41025000",
                        "longitude": "83.90295000"
                    },
                    {
                        "id": 57693,
                        "name": "Anakapalle",
                        "latitude": "17.69134000",
                        "longitude": "83.00395000"
                    },
                    {
                        "id": 57698,
                        "name": "Anantapur",
                        "latitude": "14.55000000",
                        "longitude": "77.41667000"
                    },
                    {
                        "id": 57758,
                        "name": "Atmakur",
                        "latitude": "15.88109000",
                        "longitude": "78.58704000"
                    },
                    {
                        "id": 57761,
                        "name": "Attili",
                        "latitude": "16.70000000",
                        "longitude": "81.60000000"
                    },
                    {
                        "id": 57771,
                        "name": "Avanigadda",
                        "latitude": "16.02148000",
                        "longitude": "80.91808000"
                    },
                    {
                        "id": 57794,
                        "name": "Badvel",
                        "latitude": "14.74510000",
                        "longitude": "79.06288000"
                    },
                    {
                        "id": 57849,
                        "name": "Banganapalle",
                        "latitude": "15.31771000",
                        "longitude": "78.22669000"
                    },
                    {
                        "id": 58137,
                        "name": "Bapatla",
                        "latitude": "15.90422000",
                        "longitude": "80.46743000"
                    },
                    {
                        "id": 57939,
                        "name": "Betamcherla",
                        "latitude": "15.45144000",
                        "longitude": "78.14797000"
                    },
                    {
                        "id": 57971,
                        "name": "Bhattiprolu",
                        "latitude": "16.10260000",
                        "longitude": "80.78074000"
                    },
                    {
                        "id": 58021,
                        "name": "Bhimavaram",
                        "latitude": "16.54078000",
                        "longitude": "81.52322000"
                    },
                    {
                        "id": 58022,
                        "name": "Bhimunipatnam",
                        "latitude": "17.89017000",
                        "longitude": "83.45203000"
                    },
                    {
                        "id": 58070,
                        "name": "Bobbili",
                        "latitude": "18.57366000",
                        "longitude": "83.35925000"
                    },
                    {
                        "id": 58179,
                        "name": "Challapalle",
                        "latitude": "16.11756000",
                        "longitude": "80.93139000"
                    },
                    {
                        "id": 131514,
                        "name": "Chemmumiahpet",
                        "latitude": "15.89794000",
                        "longitude": "79.32129000"
                    },
                    {
                        "id": 131556,
                        "name": "Chilakalurupet",
                        "latitude": "16.08987000",
                        "longitude": "80.16705000"
                    },
                    {
                        "id": 131563,
                        "name": "Chinnachowk",
                        "latitude": "14.47516000",
                        "longitude": "78.83540000"
                    },
                    {
                        "id": 131611,
                        "name": "Chipurupalle",
                        "latitude": "18.31142000",
                        "longitude": "83.56846000"
                    },
                    {
                        "id": 131612,
                        "name": "Chirala",
                        "latitude": "15.82385000",
                        "longitude": "80.35219000"
                    },
                    {
                        "id": 131575,
                        "name": "Chittoor",
                        "latitude": "13.41667000",
                        "longitude": "79.00000000"
                    },
                    {
                        "id": 131577,
                        "name": "Chodavaram",
                        "latitude": "17.82884000",
                        "longitude": "82.93526000"
                    },
                    {
                        "id": 131627,
                        "name": "Cuddapah",
                        "latitude": "14.41667000",
                        "longitude": "78.75000000"
                    },
                    {
                        "id": 131628,
                        "name": "Cumbum",
                        "latitude": "15.58171000",
                        "longitude": "79.11059000"
                    },
                    {
                        "id": 131658,
                        "name": "Darsi",
                        "latitude": "15.76978000",
                        "longitude": "79.67939000"
                    },
                    {
                        "id": 131727,
                        "name": "Dharmavaram",
                        "latitude": "14.41435000",
                        "longitude": "77.72035000"
                    },
                    {
                        "id": 131740,
                        "name": "Dhone",
                        "latitude": "15.39520000",
                        "longitude": "77.87150000"
                    },
                    {
                        "id": 131769,
                        "name": "Diguvametta",
                        "latitude": "15.39507000",
                        "longitude": "78.82930000"
                    },
                    {
                        "id": 131823,
                        "name": "East Godavari",
                        "latitude": "17.83333000",
                        "longitude": "81.83333000"
                    },
                    {
                        "id": 131830,
                        "name": "Elamanchili",
                        "latitude": "17.54907000",
                        "longitude": "82.85749000"
                    },
                    {
                        "id": 131832,
                        "name": "Ellore",
                        "latitude": "16.71311000",
                        "longitude": "81.10437000"
                    },
                    {
                        "id": 131836,
                        "name": "Emmiganur",
                        "latitude": "15.77203000",
                        "longitude": "77.48345000"
                    },
                    {
                        "id": 131842,
                        "name": "Erraguntla",
                        "latitude": "14.63853000",
                        "longitude": "78.53974000"
                    },
                    {
                        "id": 131846,
                        "name": "Etikoppaka",
                        "latitude": "17.50000000",
                        "longitude": "82.73333000"
                    },
                    {
                        "id": 131895,
                        "name": "Gajuwaka",
                        "latitude": "17.70000000",
                        "longitude": "83.21667000"
                    },
                    {
                        "id": 131906,
                        "name": "Ganguvada",
                        "latitude": "18.66667000",
                        "longitude": "84.11667000"
                    },
                    {
                        "id": 131915,
                        "name": "Gannavaram",
                        "latitude": "16.54092000",
                        "longitude": "80.80213000"
                    },
                    {
                        "id": 131955,
                        "name": "Giddalur",
                        "latitude": "15.37439000",
                        "longitude": "78.92609000"
                    },
                    {
                        "id": 131972,
                        "name": "Gokavaram",
                        "latitude": "17.25823000",
                        "longitude": "81.84985000"
                    },
                    {
                        "id": 131993,
                        "name": "Gorantla",
                        "latitude": "13.98411000",
                        "longitude": "77.77224000"
                    },
                    {
                        "id": 132001,
                        "name": "GovindapuramChilakaluripetGuntur",
                        "latitude": "16.15477000",
                        "longitude": "80.10279000"
                    },
                    {
                        "id": 132010,
                        "name": "Gudivada",
                        "latitude": "16.43547000",
                        "longitude": "80.99555000"
                    },
                    {
                        "id": 132012,
                        "name": "Gudlavalleru",
                        "latitude": "16.35000000",
                        "longitude": "81.05000000"
                    },
                    {
                        "id": 132051,
                        "name": "Gudur",
                        "latitude": "14.15093000",
                        "longitude": "79.85210000"
                    },
                    {
                        "id": 132027,
                        "name": "Guntakal Junction",
                        "latitude": "15.17112000",
                        "longitude": "77.36244000"
                    },
                    {
                        "id": 132028,
                        "name": "Guntur",
                        "latitude": "16.29974000",
                        "longitude": "80.45729000"
                    },
                    {
                        "id": 132099,
                        "name": "Hindupur",
                        "latitude": "13.82807000",
                        "longitude": "77.49143000"
                    },
                    {
                        "id": 132151,
                        "name": "Ichchapuram",
                        "latitude": "19.11393000",
                        "longitude": "84.68721000"
                    },
                    {
                        "id": 132189,
                        "name": "Jaggayyapeta",
                        "latitude": "16.89380000",
                        "longitude": "80.09807000"
                    },
                    {
                        "id": 132228,
                        "name": "Jammalamadugu",
                        "latitude": "14.84677000",
                        "longitude": "78.38314000"
                    },
                    {
                        "id": 132328,
                        "name": "Kadiri",
                        "latitude": "14.11168000",
                        "longitude": "78.15982000"
                    },
                    {
                        "id": 132332,
                        "name": "Kaikalur",
                        "latitude": "16.55154000",
                        "longitude": "81.21400000"
                    },
                    {
                        "id": 132678,
                        "name": "Kakinada",
                        "latitude": "16.96036000",
                        "longitude": "82.23809000"
                    },
                    {
                        "id": 132358,
                        "name": "Kalyandurg",
                        "latitude": "14.54519000",
                        "longitude": "77.10552000"
                    },
                    {
                        "id": 132691,
                        "name": "Kamalapuram",
                        "latitude": "14.59830000",
                        "longitude": "78.66948000"
                    },
                    {
                        "id": 132372,
                        "name": "Kandukur",
                        "latitude": "15.21542000",
                        "longitude": "79.90390000"
                    },
                    {
                        "id": 132374,
                        "name": "Kanigiri",
                        "latitude": "15.40555000",
                        "longitude": "79.50694000"
                    },
                    {
                        "id": 132376,
                        "name": "Kankipadu",
                        "latitude": "16.43530000",
                        "longitude": "80.76715000"
                    },
                    {
                        "id": 132388,
                        "name": "Kanuru",
                        "latitude": "16.28584000",
                        "longitude": "81.25464000"
                    },
                    {
                        "id": 132729,
                        "name": "Kavali",
                        "latitude": "14.91630000",
                        "longitude": "79.99449000"
                    },
                    {
                        "id": 132552,
                        "name": "Kolanukonda",
                        "latitude": "16.45392000",
                        "longitude": "80.61046000"
                    },
                    {
                        "id": 132567,
                        "name": "Kondapalle",
                        "latitude": "16.61989000",
                        "longitude": "80.54244000"
                    },
                    {
                        "id": 132584,
                        "name": "Korukollu",
                        "latitude": "16.50000000",
                        "longitude": "81.25000000"
                    },
                    {
                        "id": 132590,
                        "name": "Kosigi",
                        "latitude": "15.85510000",
                        "longitude": "77.24463000"
                    },
                    {
                        "id": 132616,
                        "name": "Kovvur",
                        "latitude": "17.01620000",
                        "longitude": "81.72934000"
                    },
                    {
                        "id": 132621,
                        "name": "Krishna",
                        "latitude": "16.66667000",
                        "longitude": "81.00000000"
                    },
                    {
                        "id": 132653,
                        "name": "Kuppam",
                        "latitude": "12.74931000",
                        "longitude": "78.34189000"
                    },
                    {
                        "id": 132660,
                        "name": "Kurnool",
                        "latitude": "15.58333000",
                        "longitude": "78.33333000"
                    },
                    {
                        "id": 133055,
                        "name": "Macherla",
                        "latitude": "16.47635000",
                        "longitude": "79.43533000"
                    },
                    {
                        "id": 132806,
                        "name": "Machilipatnam",
                        "latitude": "16.18747000",
                        "longitude": "81.13888000"
                    },
                    {
                        "id": 132808,
                        "name": "Madanapalle",
                        "latitude": "13.55030000",
                        "longitude": "78.50288000"
                    },
                    {
                        "id": 133059,
                        "name": "Madugula",
                        "latitude": "17.91589000",
                        "longitude": "82.81578000"
                    },
                    {
                        "id": 132890,
                        "name": "Mandapeta",
                        "latitude": "16.86254000",
                        "longitude": "81.92921000"
                    },
                    {
                        "id": 132891,
                        "name": "Mandasa",
                        "latitude": "18.86830000",
                        "longitude": "84.46296000"
                    },
                    {
                        "id": 132902,
                        "name": "Mangalagiri",
                        "latitude": "16.43083000",
                        "longitude": "80.56815000"
                    },
                    {
                        "id": 133088,
                        "name": "Markapur",
                        "latitude": "15.73534000",
                        "longitude": "79.26848000"
                    },
                    {
                        "id": 133114,
                        "name": "Nagari",
                        "latitude": "13.32139000",
                        "longitude": "79.58557000"
                    },
                    {
                        "id": 133258,
                        "name": "Nagireddipalli",
                        "latitude": "14.27005000",
                        "longitude": "79.10131000"
                    },
                    {
                        "id": 133143,
                        "name": "Nandigama",
                        "latitude": "16.77170000",
                        "longitude": "80.28596000"
                    },
                    {
                        "id": 133144,
                        "name": "Nandikotkur",
                        "latitude": "15.85668000",
                        "longitude": "78.26569000"
                    },
                    {
                        "id": 133146,
                        "name": "Nandyal",
                        "latitude": "15.47799000",
                        "longitude": "78.48360000"
                    },
                    {
                        "id": 133156,
                        "name": "Narasannapeta",
                        "latitude": "18.41428000",
                        "longitude": "84.04463000"
                    },
                    {
                        "id": 133157,
                        "name": "Narasapur",
                        "latitude": "16.43425000",
                        "longitude": "81.69845000"
                    },
                    {
                        "id": 133158,
                        "name": "Narasaraopet",
                        "latitude": "16.23488000",
                        "longitude": "80.04927000"
                    },
                    {
                        "id": 133160,
                        "name": "Narasingapuram",
                        "latitude": "13.60759000",
                        "longitude": "79.31652000"
                    },
                    {
                        "id": 133275,
                        "name": "Narayanavanam",
                        "latitude": "13.42565000",
                        "longitude": "79.58881000"
                    },
                    {
                        "id": 133173,
                        "name": "Narsipatnam",
                        "latitude": "17.66709000",
                        "longitude": "82.61245000"
                    },
                    {
                        "id": 133283,
                        "name": "Nayudupet",
                        "latitude": "13.90742000",
                        "longitude": "79.89465000"
                    },
                    {
                        "id": 133206,
                        "name": "Nellore",
                        "latitude": "14.08333000",
                        "longitude": "79.58333000"
                    },
                    {
                        "id": 133214,
                        "name": "Nidadavole",
                        "latitude": "16.90572000",
                        "longitude": "81.67222000"
                    },
                    {
                        "id": 133294,
                        "name": "Nuzvid",
                        "latitude": "16.78854000",
                        "longitude": "80.84593000"
                    },
                    {
                        "id": 133300,
                        "name": "Ongole",
                        "latitude": "15.50357000",
                        "longitude": "80.04454000"
                    },
                    {
                        "id": 133521,
                        "name": "Pakala",
                        "latitude": "13.44903000",
                        "longitude": "79.11493000"
                    },
                    {
                        "id": 133523,
                        "name": "Palakollu",
                        "latitude": "16.51670000",
                        "longitude": "81.73000000"
                    },
                    {
                        "id": 133340,
                        "name": "Palasa",
                        "latitude": "18.77257000",
                        "longitude": "84.41012000"
                    },
                    {
                        "id": 133534,
                        "name": "Palkonda",
                        "latitude": "18.60374000",
                        "longitude": "83.75568000"
                    },
                    {
                        "id": 133331,
                        "name": "Pallevada",
                        "latitude": "16.57790000",
                        "longitude": "81.29463000"
                    },
                    {
                        "id": 133336,
                        "name": "Palmaner",
                        "latitude": "13.20000000",
                        "longitude": "78.74725000"
                    },
                    {
                        "id": 133361,
                        "name": "Parlakimidi",
                        "latitude": "18.78113000",
                        "longitude": "84.08836000"
                    },
                    {
                        "id": 133549,
                        "name": "Parvatipuram",
                        "latitude": "18.78392000",
                        "longitude": "83.42569000"
                    },
                    {
                        "id": 133395,
                        "name": "Pavuluru",
                        "latitude": "15.85292000",
                        "longitude": "80.16468000"
                    },
                    {
                        "id": 133400,
                        "name": "Pedana",
                        "latitude": "16.25582000",
                        "longitude": "81.14378000"
                    },
                    {
                        "id": 134447,
                        "name": "pedda nakkalapalem",
                        "latitude": "15.86680000",
                        "longitude": "80.16202000"
                    },
                    {
                        "id": 133402,
                        "name": "Peddapuram",
                        "latitude": "17.07701000",
                        "longitude": "82.13836000"
                    },
                    {
                        "id": 133409,
                        "name": "Penugonda",
                        "latitude": "16.65363000",
                        "longitude": "81.74550000"
                    },
                    {
                        "id": 133410,
                        "name": "Penukonda",
                        "latitude": "14.08286000",
                        "longitude": "77.59473000"
                    },
                    {
                        "id": 133440,
                        "name": "Phirangipuram",
                        "latitude": "16.29078000",
                        "longitude": "80.26233000"
                    },
                    {
                        "id": 133455,
                        "name": "Pippara",
                        "latitude": "16.71667000",
                        "longitude": "81.55000000"
                    },
                    {
                        "id": 133465,
                        "name": "Pithapuram",
                        "latitude": "17.11680000",
                        "longitude": "82.25284000"
                    },
                    {
                        "id": 133468,
                        "name": "Polavaram",
                        "latitude": "17.24754000",
                        "longitude": "81.64372000"
                    },
                    {
                        "id": 133476,
                        "name": "Ponnur",
                        "latitude": "16.07114000",
                        "longitude": "80.54944000"
                    },
                    {
                        "id": 133478,
                        "name": "Ponnuru",
                        "latitude": "16.06547000",
                        "longitude": "80.55203000"
                    },
                    {
                        "id": 133485,
                        "name": "Prakasam",
                        "latitude": "15.50000000",
                        "longitude": "79.50000000"
                    },
                    {
                        "id": 133489,
                        "name": "Proddatur",
                        "latitude": "14.75020000",
                        "longitude": "78.54813000"
                    },
                    {
                        "id": 133497,
                        "name": "Pulivendla",
                        "latitude": "14.42139000",
                        "longitude": "78.22502000"
                    },
                    {
                        "id": 133506,
                        "name": "Punganuru",
                        "latitude": "13.36672000",
                        "longitude": "78.57186000"
                    },
                    {
                        "id": 133517,
                        "name": "Puttaparthi",
                        "latitude": "14.16520000",
                        "longitude": "77.81170000"
                    },
                    {
                        "id": 133519,
                        "name": "Puttur",
                        "latitude": "13.44189000",
                        "longitude": "79.55314000"
                    },
                    {
                        "id": 133671,
                        "name": "Rajahmundry",
                        "latitude": "17.00517000",
                        "longitude": "81.77784000"
                    },
                    {
                        "id": 133691,
                        "name": "Ramachandrapuram",
                        "latitude": "16.83636000",
                        "longitude": "82.02871000"
                    },
                    {
                        "id": 133600,
                        "name": "Ramanayyapeta",
                        "latitude": "16.94516000",
                        "longitude": "82.23850000"
                    },
                    {
                        "id": 133712,
                        "name": "Ramapuram",
                        "latitude": "15.28749000",
                        "longitude": "77.86722000"
                    },
                    {
                        "id": 133605,
                        "name": "Rampachodavaram",
                        "latitude": "17.44088000",
                        "longitude": "81.77558000"
                    },
                    {
                        "id": 133729,
                        "name": "Rayachoti",
                        "latitude": "14.05723000",
                        "longitude": "78.75056000"
                    },
                    {
                        "id": 133730,
                        "name": "Rayadrug",
                        "latitude": "14.69971000",
                        "longitude": "76.85241000"
                    },
                    {
                        "id": 133734,
                        "name": "Razam",
                        "latitude": "18.44909000",
                        "longitude": "83.65957000"
                    },
                    {
                        "id": 133732,
                        "name": "Razampeta",
                        "latitude": "14.19544000",
                        "longitude": "79.15896000"
                    },
                    {
                        "id": 133733,
                        "name": "Razole",
                        "latitude": "16.47608000",
                        "longitude": "81.83912000"
                    },
                    {
                        "id": 133627,
                        "name": "Renigunta",
                        "latitude": "13.65143000",
                        "longitude": "79.51256000"
                    },
                    {
                        "id": 133630,
                        "name": "Repalle",
                        "latitude": "16.01840000",
                        "longitude": "80.82958000"
                    },
                    {
                        "id": 134065,
                        "name": "Salur",
                        "latitude": "18.51716000",
                        "longitude": "83.20548000"
                    },
                    {
                        "id": 134066,
                        "name": "Samalkot",
                        "latitude": "17.05675000",
                        "longitude": "82.17639000"
                    },
                    {
                        "id": 133822,
                        "name": "Sattenapalle",
                        "latitude": "16.39381000",
                        "longitude": "80.15221000"
                    },
                    {
                        "id": 133946,
                        "name": "Singarayakonda",
                        "latitude": "15.23046000",
                        "longitude": "80.02794000"
                    },
                    {
                        "id": 133990,
                        "name": "Sompeta",
                        "latitude": "18.94419000",
                        "longitude": "84.58449000"
                    },
                    {
                        "id": 134019,
                        "name": "Srikakulam",
                        "latitude": "18.29890000",
                        "longitude": "83.89751000"
                    },
                    {
                        "id": 134032,
                        "name": "Srisailain",
                        "latitude": "16.07217000",
                        "longitude": "78.86816000"
                    },
                    {
                        "id": 134093,
                        "name": "Suluru",
                        "latitude": "13.70000000",
                        "longitude": "80.01667000"
                    },
                    {
                        "id": 134226,
                        "name": "Tadepalle",
                        "latitude": "16.48333000",
                        "longitude": "80.60000000"
                    },
                    {
                        "id": 134227,
                        "name": "Tadepallegudem",
                        "latitude": "16.81467000",
                        "longitude": "81.52717000"
                    },
                    {
                        "id": 134228,
                        "name": "Tadpatri",
                        "latitude": "14.90832000",
                        "longitude": "78.01031000"
                    },
                    {
                        "id": 134113,
                        "name": "Tanuku",
                        "latitude": "16.75438000",
                        "longitude": "81.68143000"
                    },
                    {
                        "id": 134126,
                        "name": "Tekkali",
                        "latitude": "18.60570000",
                        "longitude": "84.23546000"
                    },
                    {
                        "id": 134183,
                        "name": "Tirumala",
                        "latitude": "13.68333000",
                        "longitude": "79.35000000"
                    },
                    {
                        "id": 134187,
                        "name": "Tirupati",
                        "latitude": "13.63551000",
                        "longitude": "79.41989000"
                    },
                    {
                        "id": 134222,
                        "name": "Tuni",
                        "latitude": "17.35905000",
                        "longitude": "82.54607000"
                    },
                    {
                        "id": 134292,
                        "name": "Uravakonda",
                        "latitude": "14.94348000",
                        "longitude": "77.25494000"
                    },
                    {
                        "id": 134448,
                        "name": "vadlamuru",
                        "latitude": "17.09545000",
                        "longitude": "82.16565000"
                    },
                    {
                        "id": 134308,
                        "name": "Vadlapudi",
                        "latitude": "14.31119000",
                        "longitude": "79.80430000"
                    },
                    {
                        "id": 134347,
                        "name": "Venkatagiri",
                        "latitude": "13.96005000",
                        "longitude": "79.58032000"
                    },
                    {
                        "id": 134348,
                        "name": "Vepagunta",
                        "latitude": "17.77844000",
                        "longitude": "83.21577000"
                    },
                    {
                        "id": 134350,
                        "name": "Vetapalem",
                        "latitude": "15.78502000",
                        "longitude": "80.30663000"
                    },
                    {
                        "id": 134356,
                        "name": "Vijayawada",
                        "latitude": "16.50745000",
                        "longitude": "80.64660000"
                    },
                    {
                        "id": 134364,
                        "name": "Vinukonda",
                        "latitude": "16.05310000",
                        "longitude": "79.73964000"
                    },
                    {
                        "id": 134369,
                        "name": "Visakhapatnam",
                        "latitude": "17.68009000",
                        "longitude": "83.20161000"
                    },
                    {
                        "id": 134373,
                        "name": "Vizianagaram",
                        "latitude": "18.11692000",
                        "longitude": "83.41148000"
                    },
                    {
                        "id": 134374,
                        "name": "Vizianagaram District",
                        "latitude": "18.41102000",
                        "longitude": "83.37677000"
                    },
                    {
                        "id": 134377,
                        "name": "Vuyyuru",
                        "latitude": "16.36307000",
                        "longitude": "80.84406000"
                    },
                    {
                        "id": 134407,
                        "name": "West Godavari",
                        "latitude": "17.00000000",
                        "longitude": "81.16667000"
                    },
                    {
                        "id": 134424,
                        "name": "Yanam",
                        "latitude": "16.73308000",
                        "longitude": "82.21364000"
                    },
                    {
                        "id": 134426,
                        "name": "Yanamalakuduru",
                        "latitude": "16.48531000",
                        "longitude": "80.66746000"
                    },
                    {
                        "id": 134437,
                        "name": "Yarada",
                        "latitude": "17.65872000",
                        "longitude": "83.27419000"
                    }
                ]
            },
            {
                "id": 4024,
                "name": "Arunachal Pradesh",
                "iso2": "AR",
                "latitude": "28.21799940",
                "longitude": "94.72775280",
                "type": "state",
                "cities": [
                    {
                        "id": 57645,
                        "name": "Along",
                        "latitude": "28.16951000",
                        "longitude": "94.80060000"
                    },
                    {
                        "id": 57708,
                        "name": "Anjaw",
                        "latitude": "28.06549000",
                        "longitude": "96.82878000"
                    },
                    {
                        "id": 58151,
                        "name": "Basar",
                        "latitude": "27.99008000",
                        "longitude": "94.69451000"
                    },
                    {
                        "id": 58080,
                        "name": "Bomdila",
                        "latitude": "27.26475000",
                        "longitude": "92.42472000"
                    },
                    {
                        "id": 58196,
                        "name": "Changlang",
                        "latitude": "27.36265000",
                        "longitude": "96.34518000"
                    },
                    {
                        "id": 131763,
                        "name": "Dibang Valley",
                        "latitude": "28.70000000",
                        "longitude": "95.70000000"
                    },
                    {
                        "id": 131826,
                        "name": "East Kameng",
                        "latitude": "27.30000000",
                        "longitude": "93.05000000"
                    },
                    {
                        "id": 131828,
                        "name": "East Siang",
                        "latitude": "28.12379000",
                        "longitude": "95.16339000"
                    },
                    {
                        "id": 132090,
                        "name": "Hayuliang",
                        "latitude": "28.07301000",
                        "longitude": "96.54305000"
                    },
                    {
                        "id": 132178,
                        "name": "Itanagar",
                        "latitude": "27.08694000",
                        "longitude": "93.60987000"
                    },
                    {
                        "id": 132499,
                        "name": "Khonsa",
                        "latitude": "27.01667000",
                        "longitude": "95.56667000"
                    },
                    {
                        "id": 132663,
                        "name": "Kurung Kumey",
                        "latitude": "27.99983000",
                        "longitude": "93.39240000"
                    },
                    {
                        "id": 132769,
                        "name": "Lohit District",
                        "latitude": "27.84012000",
                        "longitude": "96.19521000"
                    },
                    {
                        "id": 132779,
                        "name": "Lower Dibang Valley",
                        "latitude": "28.37258000",
                        "longitude": "95.88040000"
                    },
                    {
                        "id": 132780,
                        "name": "Lower Subansiri",
                        "latitude": "27.62554000",
                        "longitude": "93.93908000"
                    },
                    {
                        "id": 132934,
                        "name": "Margherita",
                        "latitude": "27.28482000",
                        "longitude": "95.66796000"
                    },
                    {
                        "id": 133121,
                        "name": "Naharlagun",
                        "latitude": "27.10467000",
                        "longitude": "93.69518000"
                    },
                    {
                        "id": 133551,
                        "name": "Pasighat",
                        "latitude": "28.06631000",
                        "longitude": "95.32678000"
                    },
                    {
                        "id": 134120,
                        "name": "Tawang",
                        "latitude": "27.57417000",
                        "longitude": "91.92437000"
                    },
                    {
                        "id": 134135,
                        "name": "Tezu",
                        "latitude": "27.91256000",
                        "longitude": "96.12882000"
                    },
                    {
                        "id": 134199,
                        "name": "Tirap",
                        "latitude": "27.01917000",
                        "longitude": "95.51788000"
                    },
                    {
                        "id": 134288,
                        "name": "Upper Siang",
                        "latitude": "28.83355000",
                        "longitude": "94.91806000"
                    },
                    {
                        "id": 134289,
                        "name": "Upper Subansiri",
                        "latitude": "28.30000000",
                        "longitude": "94.00000000"
                    },
                    {
                        "id": 134409,
                        "name": "West Kameng",
                        "latitude": "27.40000000",
                        "longitude": "92.35000000"
                    },
                    {
                        "id": 134411,
                        "name": "West Siang",
                        "latitude": "28.40000000",
                        "longitude": "94.55000000"
                    },
                    {
                        "id": 134444,
                        "name": "Ziro",
                        "latitude": "27.59497000",
                        "longitude": "93.83854000"
                    }
                ]
            },
            {
                "id": 4027,
                "name": "Assam",
                "iso2": "AS",
                "latitude": "26.20060430",
                "longitude": "92.93757390",
                "type": "state",
                "cities": [
                    {
                        "id": 57585,
                        "name": "Abhayapuri",
                        "latitude": "26.32255000",
                        "longitude": "90.68526000"
                    },
                    {
                        "id": 57679,
                        "name": "Amguri",
                        "latitude": "26.81482000",
                        "longitude": "94.52614000"
                    },
                    {
                        "id": 57787,
                        "name": "Badarpur",
                        "latitude": "24.86852000",
                        "longitude": "92.59606000"
                    },
                    {
                        "id": 57820,
                        "name": "Baksa",
                        "latitude": "26.69804000",
                        "longitude": "91.15142000"
                    },
                    {
                        "id": 57883,
                        "name": "Barpathar",
                        "latitude": "26.28709000",
                        "longitude": "93.88844000"
                    },
                    {
                        "id": 57884,
                        "name": "Barpeta",
                        "latitude": "26.47104000",
                        "longitude": "91.03080000"
                    },
                    {
                        "id": 57885,
                        "name": "Barpeta Road",
                        "latitude": "26.50284000",
                        "longitude": "90.96937000"
                    },
                    {
                        "id": 58150,
                        "name": "Basugaon",
                        "latitude": "26.46742000",
                        "longitude": "90.41951000"
                    },
                    {
                        "id": 58028,
                        "name": "Bihpuriagaon",
                        "latitude": "27.01718000",
                        "longitude": "93.91673000"
                    },
                    {
                        "id": 58034,
                        "name": "Bijni",
                        "latitude": "26.49588000",
                        "longitude": "90.70298000"
                    },
                    {
                        "id": 58053,
                        "name": "Bilasipara",
                        "latitude": "26.23285000",
                        "longitude": "90.23410000"
                    },
                    {
                        "id": 58075,
                        "name": "Bokajan",
                        "latitude": "26.02131000",
                        "longitude": "93.77945000"
                    },
                    {
                        "id": 58077,
                        "name": "Bokakhat",
                        "latitude": "26.64018000",
                        "longitude": "93.60052000"
                    },
                    {
                        "id": 58081,
                        "name": "Bongaigaon",
                        "latitude": "26.46030000",
                        "longitude": "90.64640000"
                    },
                    {
                        "id": 131634,
                        "name": "Cachar",
                        "latitude": "24.78213000",
                        "longitude": "92.85771000"
                    },
                    {
                        "id": 131588,
                        "name": "Chabua",
                        "latitude": "27.48253000",
                        "longitude": "95.17451000"
                    },
                    {
                        "id": 131604,
                        "name": "Chapar",
                        "latitude": "26.27266000",
                        "longitude": "90.44556000"
                    },
                    {
                        "id": 131568,
                        "name": "Chirang",
                        "latitude": "26.52527000",
                        "longitude": "90.49066000"
                    },
                    {
                        "id": 131657,
                        "name": "Darrang",
                        "latitude": "26.51195000",
                        "longitude": "92.16843000"
                    },
                    {
                        "id": 131695,
                        "name": "Dergaon",
                        "latitude": "26.70000000",
                        "longitude": "93.96667000"
                    },
                    {
                        "id": 131732,
                        "name": "Dhekiajuli",
                        "latitude": "26.70367000",
                        "longitude": "92.47808000"
                    },
                    {
                        "id": 131733,
                        "name": "Dhemaji",
                        "latitude": "27.60910000",
                        "longitude": "94.79420000"
                    },
                    {
                        "id": 131737,
                        "name": "Dhing",
                        "latitude": "26.46793000",
                        "longitude": "92.47336000"
                    },
                    {
                        "id": 131744,
                        "name": "Dhubri",
                        "latitude": "26.06749000",
                        "longitude": "90.02238000"
                    },
                    {
                        "id": 131762,
                        "name": "Dibrugarh",
                        "latitude": "27.50000000",
                        "longitude": "95.00000000"
                    },
                    {
                        "id": 131766,
                        "name": "Digboi",
                        "latitude": "27.39321000",
                        "longitude": "95.61839000"
                    },
                    {
                        "id": 131770,
                        "name": "Dima Hasao District",
                        "latitude": "25.50000000",
                        "longitude": "93.00000000"
                    },
                    {
                        "id": 131776,
                        "name": "Diphu",
                        "latitude": "25.84341000",
                        "longitude": "93.43116000"
                    },
                    {
                        "id": 131778,
                        "name": "Dispur",
                        "latitude": "26.13564000",
                        "longitude": "91.80069000"
                    },
                    {
                        "id": 131795,
                        "name": "Duliagaon",
                        "latitude": "27.37227000",
                        "longitude": "95.30754000"
                    },
                    {
                        "id": 131796,
                        "name": "Dum Duma",
                        "latitude": "27.56884000",
                        "longitude": "95.55664000"
                    },
                    {
                        "id": 131928,
                        "name": "Gauripur",
                        "latitude": "26.08334000",
                        "longitude": "89.96118000"
                    },
                    {
                        "id": 132004,
                        "name": "Goalpara",
                        "latitude": "26.12791000",
                        "longitude": "90.60974000"
                    },
                    {
                        "id": 131967,
                        "name": "Gohpur",
                        "latitude": "26.88184000",
                        "longitude": "93.61560000"
                    },
                    {
                        "id": 131976,
                        "name": "Golaghat",
                        "latitude": "26.40920000",
                        "longitude": "93.91193000"
                    },
                    {
                        "id": 131977,
                        "name": "Golakganj",
                        "latitude": "26.10216000",
                        "longitude": "89.82275000"
                    },
                    {
                        "id": 131997,
                        "name": "Goshaingaon",
                        "latitude": "26.43946000",
                        "longitude": "89.96307000"
                    },
                    {
                        "id": 132039,
                        "name": "Guwahati",
                        "latitude": "26.18440000",
                        "longitude": "91.74580000"
                    },
                    {
                        "id": 132134,
                        "name": "Haflong",
                        "latitude": "25.16478000",
                        "longitude": "93.01744000"
                    },
                    {
                        "id": 132055,
                        "name": "Hailakandi",
                        "latitude": "24.50170000",
                        "longitude": "92.60069000"
                    },
                    {
                        "id": 132137,
                        "name": "Hajo",
                        "latitude": "26.24520000",
                        "longitude": "91.52525000"
                    },
                    {
                        "id": 132110,
                        "name": "Hojai",
                        "latitude": "26.00281000",
                        "longitude": "92.85605000"
                    },
                    {
                        "id": 132126,
                        "name": "Howli",
                        "latitude": "26.42237000",
                        "longitude": "90.98004000"
                    },
                    {
                        "id": 132291,
                        "name": "Jogighopa",
                        "latitude": "26.22646000",
                        "longitude": "90.57247000"
                    },
                    {
                        "id": 132294,
                        "name": "Jorhat",
                        "latitude": "26.80000000",
                        "longitude": "94.26000000"
                    },
                    {
                        "id": 132693,
                        "name": "Kamrup",
                        "latitude": "26.22322000",
                        "longitude": "91.65344000"
                    },
                    {
                        "id": 132366,
                        "name": "Kamrup Metropolitan",
                        "latitude": "26.05375000",
                        "longitude": "92.00763000"
                    },
                    {
                        "id": 132718,
                        "name": "Karbi Anglong",
                        "latitude": "26.00000000",
                        "longitude": "93.50000000"
                    },
                    {
                        "id": 132402,
                        "name": "Karimganj",
                        "latitude": "24.60000000",
                        "longitude": "92.40000000"
                    },
                    {
                        "id": 132518,
                        "name": "Kharupatia",
                        "latitude": "26.51839000",
                        "longitude": "92.14722000"
                    },
                    {
                        "id": 132551,
                        "name": "Kokrajhar",
                        "latitude": "26.60000000",
                        "longitude": "90.20000000"
                    },
                    {
                        "id": 132742,
                        "name": "Lakhimpur",
                        "latitude": "27.35000000",
                        "longitude": "94.25000000"
                    },
                    {
                        "id": 132743,
                        "name": "Lakhipur",
                        "latitude": "24.79281000",
                        "longitude": "93.00910000"
                    },
                    {
                        "id": 132793,
                        "name": "Lala",
                        "latitude": "24.55418000",
                        "longitude": "92.61592000"
                    },
                    {
                        "id": 132786,
                        "name": "Lumding Railway Colony",
                        "latitude": "25.74903000",
                        "longitude": "93.16998000"
                    },
                    {
                        "id": 132842,
                        "name": "Mahur",
                        "latitude": "25.18305000",
                        "longitude": "93.11342000"
                    },
                    {
                        "id": 132853,
                        "name": "Maibong",
                        "latitude": "25.30125000",
                        "longitude": "93.13811000"
                    },
                    {
                        "id": 133064,
                        "name": "Makum",
                        "latitude": "27.48652000",
                        "longitude": "95.43646000"
                    },
                    {
                        "id": 132904,
                        "name": "Mangaldai",
                        "latitude": "26.44212000",
                        "longitude": "92.03047000"
                    },
                    {
                        "id": 132937,
                        "name": "Mariani",
                        "latitude": "26.65725000",
                        "longitude": "94.31529000"
                    },
                    {
                        "id": 133002,
                        "name": "Moranha",
                        "latitude": "27.18735000",
                        "longitude": "94.91557000"
                    },
                    {
                        "id": 132995,
                        "name": "Morigaon",
                        "latitude": "26.25213000",
                        "longitude": "92.34238000"
                    },
                    {
                        "id": 133110,
                        "name": "Nagaon",
                        "latitude": "26.35037000",
                        "longitude": "92.69225000"
                    },
                    {
                        "id": 133122,
                        "name": "Nahorkatiya",
                        "latitude": "27.28912000",
                        "longitude": "95.34180000"
                    },
                    {
                        "id": 133130,
                        "name": "Nalbari",
                        "latitude": "26.50000000",
                        "longitude": "91.40000000"
                    },
                    {
                        "id": 133266,
                        "name": "Namrup",
                        "latitude": "27.19395000",
                        "longitude": "95.31929000"
                    },
                    {
                        "id": 133284,
                        "name": "Nazira",
                        "latitude": "26.91649000",
                        "longitude": "94.73611000"
                    },
                    {
                        "id": 133239,
                        "name": "North Guwahati",
                        "latitude": "26.19749000",
                        "longitude": "91.72020000"
                    },
                    {
                        "id": 133240,
                        "name": "North Lakhimpur",
                        "latitude": "27.23517000",
                        "longitude": "94.10357000"
                    },
                    {
                        "id": 133248,
                        "name": "Numaligarh",
                        "latitude": "26.62249000",
                        "longitude": "93.72225000"
                    },
                    {
                        "id": 133341,
                        "name": "Palasbari",
                        "latitude": "26.12388000",
                        "longitude": "91.53974000"
                    },
                    {
                        "id": 133584,
                        "name": "Raha",
                        "latitude": "26.23333000",
                        "longitude": "92.51667000"
                    },
                    {
                        "id": 133610,
                        "name": "Rangapara",
                        "latitude": "26.83772000",
                        "longitude": "92.66876000"
                    },
                    {
                        "id": 133608,
                        "name": "Rangia",
                        "latitude": "26.44931000",
                        "longitude": "91.61356000"
                    },
                    {
                        "id": 133798,
                        "name": "Sapatgram",
                        "latitude": "26.33732000",
                        "longitude": "90.12360000"
                    },
                    {
                        "id": 133809,
                        "name": "Sarupathar",
                        "latitude": "26.20600000",
                        "longitude": "96.81000000"
                    },
                    {
                        "id": 133916,
                        "name": "Sibsagar",
                        "latitude": "26.98427000",
                        "longitude": "94.63784000"
                    },
                    {
                        "id": 133934,
                        "name": "Silapathar",
                        "latitude": "27.59441000",
                        "longitude": "94.72402000"
                    },
                    {
                        "id": 133935,
                        "name": "Silchar",
                        "latitude": "24.82733000",
                        "longitude": "92.79787000"
                    },
                    {
                        "id": 133979,
                        "name": "Soalkuchi",
                        "latitude": "26.16806000",
                        "longitude": "91.57111000"
                    },
                    {
                        "id": 133998,
                        "name": "Sonari",
                        "latitude": "27.02462000",
                        "longitude": "95.01629000"
                    },
                    {
                        "id": 133996,
                        "name": "Sonitpur",
                        "latitude": "26.76748000",
                        "longitude": "92.96425000"
                    },
                    {
                        "id": 134003,
                        "name": "Sorbhog",
                        "latitude": "26.48612000",
                        "longitude": "90.88590000"
                    },
                    {
                        "id": 134134,
                        "name": "Tezpur",
                        "latitude": "26.63333000",
                        "longitude": "92.80000000"
                    },
                    {
                        "id": 134175,
                        "name": "Tinsukia",
                        "latitude": "27.60000000",
                        "longitude": "95.60000000"
                    },
                    {
                        "id": 134203,
                        "name": "Titabar",
                        "latitude": "26.60140000",
                        "longitude": "94.20386000"
                    },
                    {
                        "id": 134252,
                        "name": "Udalguri",
                        "latitude": "26.75367000",
                        "longitude": "92.10215000"
                    }
                ]
            },
            {
                "id": 4037,
                "name": "Bihar",
                "iso2": "BR",
                "latitude": "25.09607420",
                "longitude": "85.31311940",
                "type": "state",
                "cities": [
                    {
                        "id": 57661,
                        "name": "Amarpur",
                        "latitude": "25.03967000",
                        "longitude": "86.90247000"
                    },
                    {
                        "id": 57730,
                        "name": "Araria",
                        "latitude": "26.20000000",
                        "longitude": "87.40000000"
                    },
                    {
                        "id": 57739,
                        "name": "Arrah",
                        "latitude": "25.55629000",
                        "longitude": "84.66335000"
                    },
                    {
                        "id": 57747,
                        "name": "Arwal",
                        "latitude": "25.16158000",
                        "longitude": "84.69040000"
                    },
                    {
                        "id": 57749,
                        "name": "Asarganj",
                        "latitude": "25.15046000",
                        "longitude": "86.68639000"
                    },
                    {
                        "id": 57766,
                        "name": "Aurangabad",
                        "latitude": "24.75204000",
                        "longitude": "84.37420000"
                    },
                    {
                        "id": 57796,
                        "name": "Bagaha",
                        "latitude": "27.09918000",
                        "longitude": "84.09003000"
                    },
                    {
                        "id": 57809,
                        "name": "Bahadurganj",
                        "latitude": "26.26172000",
                        "longitude": "87.82443000"
                    },
                    {
                        "id": 57815,
                        "name": "Bairagnia",
                        "latitude": "26.74063000",
                        "longitude": "85.27323000"
                    },
                    {
                        "id": 57816,
                        "name": "Baisi",
                        "latitude": "25.86302000",
                        "longitude": "87.74487000"
                    },
                    {
                        "id": 57818,
                        "name": "Bakhtiyarpur",
                        "latitude": "25.46179000",
                        "longitude": "85.53179000"
                    },
                    {
                        "id": 57850,
                        "name": "Bangaon",
                        "latitude": "25.86728000",
                        "longitude": "86.51152000"
                    },
                    {
                        "id": 57854,
                        "name": "Banka",
                        "latitude": "24.89214000",
                        "longitude": "86.98425000"
                    },
                    {
                        "id": 57855,
                        "name": "Banmankhi",
                        "latitude": "25.88857000",
                        "longitude": "87.19421000"
                    },
                    {
                        "id": 57860,
                        "name": "Bar Bigha",
                        "latitude": "25.21855000",
                        "longitude": "85.73320000"
                    },
                    {
                        "id": 57864,
                        "name": "Barauli",
                        "latitude": "26.38109000",
                        "longitude": "84.58648000"
                    },
                    {
                        "id": 58141,
                        "name": "Barh",
                        "latitude": "25.48339000",
                        "longitude": "85.70928000"
                    },
                    {
                        "id": 57873,
                        "name": "Barhiya",
                        "latitude": "25.28814000",
                        "longitude": "86.02055000"
                    },
                    {
                        "id": 57875,
                        "name": "Bariarpur",
                        "latitude": "25.28791000",
                        "longitude": "86.57643000"
                    },
                    {
                        "id": 58145,
                        "name": "Baruni",
                        "latitude": "25.47509000",
                        "longitude": "85.96813000"
                    },
                    {
                        "id": 57915,
                        "name": "Begusarai",
                        "latitude": "25.41853000",
                        "longitude": "86.13389000"
                    },
                    {
                        "id": 57927,
                        "name": "Belsand",
                        "latitude": "26.44365000",
                        "longitude": "85.40076000"
                    },
                    {
                        "id": 57941,
                        "name": "Bettiah",
                        "latitude": "26.80229000",
                        "longitude": "84.50311000"
                    },
                    {
                        "id": 57947,
                        "name": "Bhabhua",
                        "latitude": "25.04049000",
                        "longitude": "83.60749000"
                    },
                    {
                        "id": 58009,
                        "name": "Bhagalpur",
                        "latitude": "25.29023000",
                        "longitude": "87.06665000"
                    },
                    {
                        "id": 57957,
                        "name": "Bhagirathpur",
                        "latitude": "26.26950000",
                        "longitude": "86.06346000"
                    },
                    {
                        "id": 57974,
                        "name": "Bhawanipur",
                        "latitude": "26.45352000",
                        "longitude": "87.02744000"
                    },
                    {
                        "id": 57991,
                        "name": "Bhojpur",
                        "latitude": "25.30886000",
                        "longitude": "84.44504000"
                    },
                    {
                        "id": 58029,
                        "name": "Bihar Sharif",
                        "latitude": "25.20084000",
                        "longitude": "85.52389000"
                    },
                    {
                        "id": 58030,
                        "name": "Bihariganj",
                        "latitude": "25.73415000",
                        "longitude": "86.98837000"
                    },
                    {
                        "id": 58039,
                        "name": "Bikramganj",
                        "latitude": "25.21073000",
                        "longitude": "84.25508000"
                    },
                    {
                        "id": 58160,
                        "name": "Birpur",
                        "latitude": "26.50823000",
                        "longitude": "87.01194000"
                    },
                    {
                        "id": 58089,
                        "name": "Bodh Gaya",
                        "latitude": "24.69808000",
                        "longitude": "84.98690000"
                    },
                    {
                        "id": 58100,
                        "name": "Buxar",
                        "latitude": "25.50000000",
                        "longitude": "84.10000000"
                    },
                    {
                        "id": 131590,
                        "name": "Chakia",
                        "latitude": "26.41598000",
                        "longitude": "85.04665000"
                    },
                    {
                        "id": 131605,
                        "name": "Chapra",
                        "latitude": "25.78031000",
                        "longitude": "84.74709000"
                    },
                    {
                        "id": 131541,
                        "name": "Chhatapur",
                        "latitude": "26.21965000",
                        "longitude": "87.00479000"
                    },
                    {
                        "id": 131620,
                        "name": "Colgong",
                        "latitude": "25.26328000",
                        "longitude": "87.23264000"
                    },
                    {
                        "id": 131647,
                        "name": "Dalsingh Sarai",
                        "latitude": "25.66795000",
                        "longitude": "85.83636000"
                    },
                    {
                        "id": 131654,
                        "name": "Darbhanga",
                        "latitude": "26.00000000",
                        "longitude": "86.00000000"
                    },
                    {
                        "id": 131664,
                        "name": "Daudnagar",
                        "latitude": "25.03473000",
                        "longitude": "84.40095000"
                    },
                    {
                        "id": 131677,
                        "name": "Dehri",
                        "latitude": "24.90247000",
                        "longitude": "84.18217000"
                    },
                    {
                        "id": 131748,
                        "name": "Dhaka",
                        "latitude": "26.67479000",
                        "longitude": "85.16698000"
                    },
                    {
                        "id": 131767,
                        "name": "Dighwara",
                        "latitude": "25.74434000",
                        "longitude": "85.01003000"
                    },
                    {
                        "id": 131773,
                        "name": "Dinapore",
                        "latitude": "25.63705000",
                        "longitude": "85.04794000"
                    },
                    {
                        "id": 131798,
                        "name": "Dumra",
                        "latitude": "26.56708000",
                        "longitude": "85.52040000"
                    },
                    {
                        "id": 131799,
                        "name": "Dumraon",
                        "latitude": "25.55265000",
                        "longitude": "84.15149000"
                    },
                    {
                        "id": 131873,
                        "name": "Fatwa",
                        "latitude": "25.50958000",
                        "longitude": "85.30504000"
                    },
                    {
                        "id": 131878,
                        "name": "Forbesganj",
                        "latitude": "26.30253000",
                        "longitude": "87.26556000"
                    },
                    {
                        "id": 131932,
                        "name": "Gaya",
                        "latitude": "24.79686000",
                        "longitude": "85.00385000"
                    },
                    {
                        "id": 131943,
                        "name": "Ghoga",
                        "latitude": "25.21738000",
                        "longitude": "87.15710000"
                    },
                    {
                        "id": 131987,
                        "name": "Gopalganj",
                        "latitude": "26.50000000",
                        "longitude": "84.33333000"
                    },
                    {
                        "id": 132138,
                        "name": "Hajipur",
                        "latitude": "25.68544000",
                        "longitude": "85.20981000"
                    },
                    {
                        "id": 132095,
                        "name": "Hilsa",
                        "latitude": "25.31642000",
                        "longitude": "85.28234000"
                    },
                    {
                        "id": 132107,
                        "name": "Hisua",
                        "latitude": "24.83360000",
                        "longitude": "85.41729000"
                    },
                    {
                        "id": 132174,
                        "name": "Islampur",
                        "latitude": "25.14075000",
                        "longitude": "85.20587000"
                    },
                    {
                        "id": 132188,
                        "name": "Jagdispur",
                        "latitude": "25.46811000",
                        "longitude": "84.41939000"
                    },
                    {
                        "id": 132198,
                        "name": "Jahanabad",
                        "latitude": "25.21368000",
                        "longitude": "84.98710000"
                    },
                    {
                        "id": 132234,
                        "name": "Jamalpur",
                        "latitude": "25.31258000",
                        "longitude": "86.48888000"
                    },
                    {
                        "id": 132233,
                        "name": "Jamui",
                        "latitude": "24.92082000",
                        "longitude": "86.17538000"
                    },
                    {
                        "id": 132258,
                        "name": "Jaynagar",
                        "latitude": "26.59048000",
                        "longitude": "86.13791000"
                    },
                    {
                        "id": 132259,
                        "name": "Jehanabad",
                        "latitude": "25.20701000",
                        "longitude": "84.99573000"
                    },
                    {
                        "id": 132274,
                        "name": "Jha-Jha",
                        "latitude": "24.77107000",
                        "longitude": "86.37888000"
                    },
                    {
                        "id": 132267,
                        "name": "Jhanjharpur",
                        "latitude": "26.26467000",
                        "longitude": "86.27993000"
                    },
                    {
                        "id": 132288,
                        "name": "Jogbani",
                        "latitude": "26.39905000",
                        "longitude": "87.26525000"
                    },
                    {
                        "id": 132337,
                        "name": "Kaimur District",
                        "latitude": "25.05077000",
                        "longitude": "83.58261000"
                    },
                    {
                        "id": 132417,
                        "name": "Kasba",
                        "latitude": "25.85643000",
                        "longitude": "87.53836000"
                    },
                    {
                        "id": 132423,
                        "name": "Katihar",
                        "latitude": "25.50000000",
                        "longitude": "87.60000000"
                    },
                    {
                        "id": 132451,
                        "name": "Khagaria",
                        "latitude": "25.50220000",
                        "longitude": "86.46708000"
                    },
                    {
                        "id": 132452,
                        "name": "Khagaul",
                        "latitude": "25.57898000",
                        "longitude": "85.04564000"
                    },
                    {
                        "id": 132470,
                        "name": "Kharagpur",
                        "latitude": "25.12446000",
                        "longitude": "86.55578000"
                    },
                    {
                        "id": 132510,
                        "name": "Khusropur",
                        "latitude": "25.48174000",
                        "longitude": "85.38492000"
                    },
                    {
                        "id": 132529,
                        "name": "Kishanganj",
                        "latitude": "26.30000000",
                        "longitude": "88.00000000"
                    },
                    {
                        "id": 132620,
                        "name": "Koath",
                        "latitude": "25.32643000",
                        "longitude": "84.25983000"
                    },
                    {
                        "id": 132548,
                        "name": "Koelwar",
                        "latitude": "25.58055000",
                        "longitude": "84.79751000"
                    },
                    {
                        "id": 132744,
                        "name": "Lakhisarai",
                        "latitude": "25.20000000",
                        "longitude": "86.20000000"
                    },
                    {
                        "id": 132795,
                        "name": "Lalganj",
                        "latitude": "25.86894000",
                        "longitude": "85.17394000"
                    },
                    {
                        "id": 132781,
                        "name": "Luckeesarai",
                        "latitude": "25.17650000",
                        "longitude": "86.09470000"
                    },
                    {
                        "id": 132812,
                        "name": "Madhepura",
                        "latitude": "25.80000000",
                        "longitude": "87.00000000"
                    },
                    {
                        "id": 132815,
                        "name": "Madhubani",
                        "latitude": "26.35367000",
                        "longitude": "86.07169000"
                    },
                    {
                        "id": 132849,
                        "name": "Maharajgani",
                        "latitude": "26.11017000",
                        "longitude": "84.50365000"
                    },
                    {
                        "id": 132859,
                        "name": "Mairwa",
                        "latitude": "26.23218000",
                        "longitude": "84.16349000"
                    },
                    {
                        "id": 132901,
                        "name": "Maner",
                        "latitude": "25.64602000",
                        "longitude": "84.87291000"
                    },
                    {
                        "id": 132911,
                        "name": "Manihari",
                        "latitude": "25.33891000",
                        "longitude": "87.61998000"
                    },
                    {
                        "id": 132935,
                        "name": "Marhaura",
                        "latitude": "25.97349000",
                        "longitude": "84.86796000"
                    },
                    {
                        "id": 132938,
                        "name": "Masaurhi Buzurg",
                        "latitude": "25.35417000",
                        "longitude": "85.03195000"
                    },
                    {
                        "id": 132984,
                        "name": "Mohiuddi nagar",
                        "latitude": "25.57374000",
                        "longitude": "85.66944000"
                    },
                    {
                        "id": 132988,
                        "name": "Mokameh",
                        "latitude": "25.39662000",
                        "longitude": "85.92190000"
                    },
                    {
                        "id": 132991,
                        "name": "Monghyr",
                        "latitude": "25.37459000",
                        "longitude": "86.47455000"
                    },
                    {
                        "id": 133005,
                        "name": "Mothihari",
                        "latitude": "26.64862000",
                        "longitude": "84.91656000"
                    },
                    {
                        "id": 133032,
                        "name": "Munger",
                        "latitude": "25.36099000",
                        "longitude": "86.46515000"
                    },
                    {
                        "id": 133037,
                        "name": "Murliganj",
                        "latitude": "25.89690000",
                        "longitude": "86.99577000"
                    },
                    {
                        "id": 133052,
                        "name": "Muzaffarpur",
                        "latitude": "26.16667000",
                        "longitude": "85.41667000"
                    },
                    {
                        "id": 133105,
                        "name": "Nabinagar",
                        "latitude": "24.60681000",
                        "longitude": "84.12624000"
                    },
                    {
                        "id": 133262,
                        "name": "Nalanda",
                        "latitude": "25.25000000",
                        "longitude": "85.58333000"
                    },
                    {
                        "id": 133279,
                        "name": "Nasriganj",
                        "latitude": "25.05140000",
                        "longitude": "84.32839000"
                    },
                    {
                        "id": 133182,
                        "name": "Naugachhia",
                        "latitude": "25.38807000",
                        "longitude": "87.09906000"
                    },
                    {
                        "id": 133192,
                        "name": "Nawada",
                        "latitude": "24.75000000",
                        "longitude": "85.50000000"
                    },
                    {
                        "id": 133222,
                        "name": "Nirmali",
                        "latitude": "26.31397000",
                        "longitude": "86.58537000"
                    },
                    {
                        "id": 133373,
                        "name": "Pashchim Champaran",
                        "latitude": "27.00000000",
                        "longitude": "84.50000000"
                    },
                    {
                        "id": 133386,
                        "name": "Patna",
                        "latitude": "25.41667000",
                        "longitude": "85.16667000"
                    },
                    {
                        "id": 133459,
                        "name": "Piro",
                        "latitude": "25.33218000",
                        "longitude": "84.40454000"
                    },
                    {
                        "id": 133509,
                        "name": "Pupri",
                        "latitude": "26.47079000",
                        "longitude": "85.70311000"
                    },
                    {
                        "id": 133570,
                        "name": "Purba Champaran",
                        "latitude": "26.58333000",
                        "longitude": "84.83333000"
                    },
                    {
                        "id": 133512,
                        "name": "Purnia",
                        "latitude": "25.81614000",
                        "longitude": "87.40708000"
                    },
                    {
                        "id": 133581,
                        "name": "Rafiganj",
                        "latitude": "24.81757000",
                        "longitude": "84.63445000"
                    },
                    {
                        "id": 133582,
                        "name": "Raghunathpur",
                        "latitude": "25.64492000",
                        "longitude": "87.91762000"
                    },
                    {
                        "id": 133678,
                        "name": "Rajgir",
                        "latitude": "25.02828000",
                        "longitude": "85.42079000"
                    },
                    {
                        "id": 133701,
                        "name": "Ramnagar",
                        "latitude": "27.16371000",
                        "longitude": "84.32342000"
                    },
                    {
                        "id": 133621,
                        "name": "Raxaul",
                        "latitude": "26.97982000",
                        "longitude": "84.85065000"
                    },
                    {
                        "id": 133632,
                        "name": "Revelganj",
                        "latitude": "25.78976000",
                        "longitude": "84.63596000"
                    },
                    {
                        "id": 133648,
                        "name": "Rohtas",
                        "latitude": "24.97941000",
                        "longitude": "84.02774000"
                    },
                    {
                        "id": 133656,
                        "name": "Rusera",
                        "latitude": "25.75355000",
                        "longitude": "86.02597000"
                    },
                    {
                        "id": 133748,
                        "name": "Sagauli",
                        "latitude": "26.76390000",
                        "longitude": "84.74341000"
                    },
                    {
                        "id": 133749,
                        "name": "Saharsa",
                        "latitude": "25.87498000",
                        "longitude": "86.59611000"
                    },
                    {
                        "id": 133767,
                        "name": "Samastipur",
                        "latitude": "25.75000000",
                        "longitude": "85.91667000"
                    },
                    {
                        "id": 134076,
                        "name": "Saran",
                        "latitude": "25.91667000",
                        "longitude": "84.75000000"
                    },
                    {
                        "id": 133852,
                        "name": "Shahbazpur",
                        "latitude": "26.30511000",
                        "longitude": "87.28865000"
                    },
                    {
                        "id": 133902,
                        "name": "Shahpur",
                        "latitude": "25.60293000",
                        "longitude": "84.40412000"
                    },
                    {
                        "id": 133858,
                        "name": "Sheikhpura",
                        "latitude": "25.13073000",
                        "longitude": "85.78176000"
                    },
                    {
                        "id": 133860,
                        "name": "Sheohar",
                        "latitude": "26.50000000",
                        "longitude": "85.30000000"
                    },
                    {
                        "id": 133863,
                        "name": "Sherghati",
                        "latitude": "24.55950000",
                        "longitude": "84.79162000"
                    },
                    {
                        "id": 133933,
                        "name": "Silao",
                        "latitude": "25.08358000",
                        "longitude": "85.42804000"
                    },
                    {
                        "id": 134089,
                        "name": "Sitamarhi",
                        "latitude": "26.66667000",
                        "longitude": "85.50000000"
                    },
                    {
                        "id": 133977,
                        "name": "Siwan",
                        "latitude": "26.22096000",
                        "longitude": "84.35609000"
                    },
                    {
                        "id": 134049,
                        "name": "Supaul",
                        "latitude": "26.25000000",
                        "longitude": "86.80000000"
                    },
                    {
                        "id": 134121,
                        "name": "Teghra",
                        "latitude": "25.49043000",
                        "longitude": "85.94001000"
                    },
                    {
                        "id": 134127,
                        "name": "Tekari",
                        "latitude": "24.94253000",
                        "longitude": "84.84265000"
                    },
                    {
                        "id": 134163,
                        "name": "Thakurganj",
                        "latitude": "26.42742000",
                        "longitude": "88.13112000"
                    },
                    {
                        "id": 134314,
                        "name": "Vaishali",
                        "latitude": "25.75000000",
                        "longitude": "85.41667000"
                    },
                    {
                        "id": 134417,
                        "name": "Waris Aliganj",
                        "latitude": "25.01720000",
                        "longitude": "85.64047000"
                    }
                ]
            },
            {
                "id": 4031,
                "name": "Chandigarh",
                "iso2": "CH",
                "latitude": "30.73331480",
                "longitude": "76.77941790",
                "type": "union territory",
                "cities": [
                    {
                        "id": 58190,
                        "name": "Chandigarh",
                        "latitude": "30.73629000",
                        "longitude": "76.78840000"
                    }
                ]
            },
            {
                "id": 4040,
                "name": "Chhattisgarh",
                "iso2": "CT",
                "latitude": "21.27865670",
                "longitude": "81.86614420",
                "type": "state",
                "cities": [
                    {
                        "id": 57619,
                        "name": "Akaltara",
                        "latitude": "22.02463000",
                        "longitude": "82.42641000"
                    },
                    {
                        "id": 57672,
                        "name": "Ambagarh Chauki",
                        "latitude": "20.77644000",
                        "longitude": "80.74608000"
                    },
                    {
                        "id": 57670,
                        "name": "Ambikapur",
                        "latitude": "23.11892000",
                        "longitude": "83.19537000"
                    },
                    {
                        "id": 57728,
                        "name": "Arang",
                        "latitude": "21.19639000",
                        "longitude": "81.96912000"
                    },
                    {
                        "id": 57812,
                        "name": "Baikunthpur",
                        "latitude": "23.26206000",
                        "longitude": "82.56051000"
                    },
                    {
                        "id": 57830,
                        "name": "Balod",
                        "latitude": "20.73081000",
                        "longitude": "81.20578000"
                    },
                    {
                        "id": 57831,
                        "name": "Baloda",
                        "latitude": "22.13890000",
                        "longitude": "82.48171000"
                    },
                    {
                        "id": 57832,
                        "name": "Baloda Bazar",
                        "latitude": "21.65678000",
                        "longitude": "82.16062000"
                    },
                    {
                        "id": 57898,
                        "name": "Basna",
                        "latitude": "21.27885000",
                        "longitude": "82.82670000"
                    },
                    {
                        "id": 57900,
                        "name": "Bastar",
                        "latitude": "19.26794000",
                        "longitude": "81.73828000"
                    },
                    {
                        "id": 57931,
                        "name": "Bemetara",
                        "latitude": "21.71556000",
                        "longitude": "81.53423000"
                    },
                    {
                        "id": 58013,
                        "name": "Bhanpuri",
                        "latitude": "21.09190000",
                        "longitude": "80.93218000"
                    },
                    {
                        "id": 58015,
                        "name": "Bhatapara",
                        "latitude": "21.73500000",
                        "longitude": "81.94711000"
                    },
                    {
                        "id": 57969,
                        "name": "Bhatgaon",
                        "latitude": "21.15000000",
                        "longitude": "81.70000000"
                    },
                    {
                        "id": 57981,
                        "name": "Bhilai",
                        "latitude": "21.20919000",
                        "longitude": "81.42850000"
                    },
                    {
                        "id": 58032,
                        "name": "Bijapur",
                        "latitude": "18.84322000",
                        "longitude": "80.77610000"
                    },
                    {
                        "id": 58055,
                        "name": "Bilaspur",
                        "latitude": "22.38333000",
                        "longitude": "82.13333000"
                    },
                    {
                        "id": 131593,
                        "name": "Champa",
                        "latitude": "22.03532000",
                        "longitude": "82.64234000"
                    },
                    {
                        "id": 131538,
                        "name": "Chhuikhadan",
                        "latitude": "21.52316000",
                        "longitude": "80.99788000"
                    },
                    {
                        "id": 153519,
                        "name": "Dantewada",
                        "latitude": "18.89984800",
                        "longitude": "81.33867520"
                    },
                    {
                        "id": 131690,
                        "name": "Deori",
                        "latitude": "21.45000000",
                        "longitude": "82.61667000"
                    },
                    {
                        "id": 131712,
                        "name": "Dhamtari",
                        "latitude": "20.70718000",
                        "longitude": "81.54874000"
                    },
                    {
                        "id": 131787,
                        "name": "Dongargaon",
                        "latitude": "20.97172000",
                        "longitude": "80.85077000"
                    },
                    {
                        "id": 131788,
                        "name": "Dongargarh",
                        "latitude": "21.18893000",
                        "longitude": "80.75459000"
                    },
                    {
                        "id": 131801,
                        "name": "Durg",
                        "latitude": "21.15000000",
                        "longitude": "81.40000000"
                    },
                    {
                        "id": 131897,
                        "name": "Gandai",
                        "latitude": "21.66667000",
                        "longitude": "81.10013000"
                    },
                    {
                        "id": 131926,
                        "name": "Gariaband",
                        "latitude": "20.63323000",
                        "longitude": "82.06221000"
                    },
                    {
                        "id": 131927,
                        "name": "Gaurela",
                        "latitude": "22.75449000",
                        "longitude": "81.90107000"
                    },
                    {
                        "id": 131938,
                        "name": "Gharghoda",
                        "latitude": "22.17427000",
                        "longitude": "83.35170000"
                    },
                    {
                        "id": 132048,
                        "name": "Gidam",
                        "latitude": "18.97431000",
                        "longitude": "81.39894000"
                    },
                    {
                        "id": 132186,
                        "name": "Jagdalpur",
                        "latitude": "19.08136000",
                        "longitude": "82.02131000"
                    },
                    {
                        "id": 132312,
                        "name": "Janjgir",
                        "latitude": "22.00922000",
                        "longitude": "82.57780000"
                    },
                    {
                        "id": 132240,
                        "name": "Janjgir-Champa",
                        "latitude": "21.90000000",
                        "longitude": "82.70000000"
                    },
                    {
                        "id": 132244,
                        "name": "Jashpur",
                        "latitude": "22.78495000",
                        "longitude": "83.84573000"
                    },
                    {
                        "id": 132245,
                        "name": "Jashpurnagar",
                        "latitude": "22.88783000",
                        "longitude": "84.13864000"
                    },
                    {
                        "id": 132318,
                        "name": "Junagarh",
                        "latitude": "19.85993000",
                        "longitude": "82.93385000"
                    },
                    {
                        "id": 132319,
                        "name": "Kabeerdham",
                        "latitude": "22.10000000",
                        "longitude": "81.20000000"
                    },
                    {
                        "id": 132704,
                        "name": "Kanker",
                        "latitude": "20.27193000",
                        "longitude": "81.49177000"
                    },
                    {
                        "id": 132421,
                        "name": "Katghora",
                        "latitude": "22.50247000",
                        "longitude": "82.54279000"
                    },
                    {
                        "id": 132433,
                        "name": "Kawardha",
                        "latitude": "22.00853000",
                        "longitude": "81.23148000"
                    },
                    {
                        "id": 132456,
                        "name": "Khairagarh",
                        "latitude": "21.41859000",
                        "longitude": "80.97942000"
                    },
                    {
                        "id": 132463,
                        "name": "Khamharia",
                        "latitude": "20.97600000",
                        "longitude": "82.25116000"
                    },
                    {
                        "id": 132480,
                        "name": "Kharod",
                        "latitude": "21.74420000",
                        "longitude": "82.57880000"
                    },
                    {
                        "id": 132481,
                        "name": "Kharsia",
                        "latitude": "21.98953000",
                        "longitude": "83.10476000"
                    },
                    {
                        "id": 132525,
                        "name": "Kirandul",
                        "latitude": "18.63649000",
                        "longitude": "81.25827000"
                    },
                    {
                        "id": 132565,
                        "name": "Kondagaon",
                        "latitude": "19.59083000",
                        "longitude": "81.66400000"
                    },
                    {
                        "id": 132581,
                        "name": "Korba",
                        "latitude": "22.50000000",
                        "longitude": "82.60000000"
                    },
                    {
                        "id": 132583,
                        "name": "Koria",
                        "latitude": "23.48326000",
                        "longitude": "82.15037000"
                    },
                    {
                        "id": 132612,
                        "name": "Kota",
                        "latitude": "22.29507000",
                        "longitude": "82.02366000"
                    },
                    {
                        "id": 132596,
                        "name": "Kotaparh",
                        "latitude": "19.14256000",
                        "longitude": "82.32536000"
                    },
                    {
                        "id": 132641,
                        "name": "Kumhari",
                        "latitude": "21.26667000",
                        "longitude": "81.51667000"
                    },
                    {
                        "id": 132661,
                        "name": "Kurud",
                        "latitude": "20.83073000",
                        "longitude": "81.72212000"
                    },
                    {
                        "id": 132777,
                        "name": "Lormi",
                        "latitude": "22.27434000",
                        "longitude": "81.70181000"
                    },
                    {
                        "id": 132827,
                        "name": "Mahasamund",
                        "latitude": "21.20000000",
                        "longitude": "82.50000000"
                    },
                    {
                        "id": 133031,
                        "name": "Mungeli",
                        "latitude": "22.06566000",
                        "longitude": "81.68543000"
                    },
                    {
                        "id": 133163,
                        "name": "Narayanpur",
                        "latitude": "19.60426000",
                        "longitude": "81.08119000"
                    },
                    {
                        "id": 133168,
                        "name": "Narharpur",
                        "latitude": "20.44892000",
                        "longitude": "81.62004000"
                    },
                    {
                        "id": 133346,
                        "name": "Pandaria",
                        "latitude": "22.22495000",
                        "longitude": "81.40994000"
                    },
                    {
                        "id": 133540,
                        "name": "Pandatarai",
                        "latitude": "22.18714000",
                        "longitude": "81.32815000"
                    },
                    {
                        "id": 133375,
                        "name": "Pasan",
                        "latitude": "22.84412000",
                        "longitude": "82.19823000"
                    },
                    {
                        "id": 133552,
                        "name": "Patan",
                        "latitude": "21.03333000",
                        "longitude": "81.53333000"
                    },
                    {
                        "id": 133379,
                        "name": "Pathalgaon",
                        "latitude": "22.55656000",
                        "longitude": "83.46355000"
                    },
                    {
                        "id": 133405,
                        "name": "Pendra",
                        "latitude": "22.77548000",
                        "longitude": "81.95968000"
                    },
                    {
                        "id": 133463,
                        "name": "Pithora",
                        "latitude": "21.25021000",
                        "longitude": "82.51707000"
                    },
                    {
                        "id": 133587,
                        "name": "Raigarh",
                        "latitude": "22.08582000",
                        "longitude": "83.30603000"
                    },
                    {
                        "id": 133590,
                        "name": "Raipur",
                        "latitude": "21.25621000",
                        "longitude": "81.69022000"
                    },
                    {
                        "id": 133668,
                        "name": "Raj Nandgaon",
                        "latitude": "21.16667000",
                        "longitude": "81.00000000"
                    },
                    {
                        "id": 133711,
                        "name": "Ramanuj Ganj",
                        "latitude": "23.80637000",
                        "longitude": "83.69981000"
                    },
                    {
                        "id": 133616,
                        "name": "Ratanpur",
                        "latitude": "22.28660000",
                        "longitude": "82.16823000"
                    },
                    {
                        "id": 133761,
                        "name": "Sakti",
                        "latitude": "22.02662000",
                        "longitude": "82.96091000"
                    },
                    {
                        "id": 133801,
                        "name": "Saraipali",
                        "latitude": "21.31530000",
                        "longitude": "83.00629000"
                    },
                    {
                        "id": 134077,
                        "name": "Sarangarh",
                        "latitude": "21.58614000",
                        "longitude": "83.07850000"
                    },
                    {
                        "id": 133845,
                        "name": "Seorinarayan",
                        "latitude": "21.72055000",
                        "longitude": "82.59344000"
                    },
                    {
                        "id": 133940,
                        "name": "Simga",
                        "latitude": "21.62810000",
                        "longitude": "81.70376000"
                    },
                    {
                        "id": 134051,
                        "name": "Surguja",
                        "latitude": "22.89624000",
                        "longitude": "83.09631000"
                    },
                    {
                        "id": 134099,
                        "name": "Takhatpur",
                        "latitude": "22.12915000",
                        "longitude": "81.86959000"
                    },
                    {
                        "id": 134273,
                        "name": "Umarkot",
                        "latitude": "19.66529000",
                        "longitude": "82.20629000"
                    },
                    {
                        "id": 134299,
                        "name": "Uttar Bastar Kanker",
                        "latitude": "20.20000000",
                        "longitude": "81.10000000"
                    }
                ]
            },
            {
                "id": 4033,
                "name": "Dadra and Nagar Haveli and Daman and Diu",
                "iso2": "DH",
                "latitude": "20.39737360",
                "longitude": "72.83279910",
                "type": "union territory",
                "cities": [
                    {
                        "id": 134459,
                        "name": "Amli",
                        "latitude": "20.28333000",
                        "longitude": "73.01667000"
                    },
                    {
                        "id": 131639,
                        "name": "Dadra",
                        "latitude": "20.32504000",
                        "longitude": "72.96618000"
                    },
                    {
                        "id": 131640,
                        "name": "Dadra & Nagar Haveli",
                        "latitude": "20.20651000",
                        "longitude": "73.00811000"
                    },
                    {
                        "id": 131649,
                        "name": "Daman",
                        "latitude": "20.41431000",
                        "longitude": "72.83236000"
                    },
                    {
                        "id": 131779,
                        "name": "Diu",
                        "latitude": "20.72081000",
                        "longitude": "70.93989000"
                    },
                    {
                        "id": 133937,
                        "name": "Silvassa",
                        "latitude": "20.27386000",
                        "longitude": "72.99673000"
                    }
                ]
            },
            {
                "id": 4021,
                "name": "Delhi",
                "iso2": "DL",
                "latitude": "28.70405920",
                "longitude": "77.10249020",
                "type": "union territory",
                "cities": [
                    {
                        "id": 57655,
                        "name": "Alipur",
                        "latitude": "28.79862000",
                        "longitude": "77.13314000"
                    },
                    {
                        "id": 57909,
                        "name": "Bawana",
                        "latitude": "28.79820000",
                        "longitude": "77.03431000"
                    },
                    {
                        "id": 58171,
                        "name": "Central Delhi",
                        "latitude": "28.64857000",
                        "longitude": "77.21895000"
                    },
                    {
                        "id": 131679,
                        "name": "Delhi",
                        "latitude": "28.65195000",
                        "longitude": "77.23149000"
                    },
                    {
                        "id": 131687,
                        "name": "Deoli",
                        "latitude": "28.50254000",
                        "longitude": "77.23117000"
                    },
                    {
                        "id": 131821,
                        "name": "East Delhi",
                        "latitude": "28.66242000",
                        "longitude": "77.29122000"
                    },
                    {
                        "id": 132406,
                        "name": "Karol Bagh",
                        "latitude": "28.65136000",
                        "longitude": "77.19072000"
                    },
                    {
                        "id": 133126,
                        "name": "Najafgarh",
                        "latitude": "28.60922000",
                        "longitude": "76.97982000"
                    },
                    {
                        "id": 133269,
                        "name": "Nangloi Jat",
                        "latitude": "28.67957000",
                        "longitude": "77.06799000"
                    },
                    {
                        "id": 133165,
                        "name": "Narela",
                        "latitude": "28.85267000",
                        "longitude": "77.09288000"
                    },
                    {
                        "id": 133210,
                        "name": "New Delhi",
                        "latitude": "28.63576000",
                        "longitude": "77.22445000"
                    },
                    {
                        "id": 133234,
                        "name": "North Delhi",
                        "latitude": "28.66920000",
                        "longitude": "77.22273000"
                    },
                    {
                        "id": 133236,
                        "name": "North East Delhi",
                        "latitude": "28.68690000",
                        "longitude": "77.30195000"
                    },
                    {
                        "id": 133243,
                        "name": "North West Delhi",
                        "latitude": "28.70113000",
                        "longitude": "77.10154000"
                    },
                    {
                        "id": 133461,
                        "name": "Pitampura",
                        "latitude": "28.68964000",
                        "longitude": "77.13126000"
                    },
                    {
                        "id": 133645,
                        "name": "Rohini",
                        "latitude": "28.74322000",
                        "longitude": "77.06778000"
                    },
                    {
                        "id": 134007,
                        "name": "South Delhi",
                        "latitude": "28.53009000",
                        "longitude": "77.25174000"
                    },
                    {
                        "id": 134012,
                        "name": "South West Delhi",
                        "latitude": "28.58060000",
                        "longitude": "77.06720000"
                    },
                    {
                        "id": 134404,
                        "name": "West Delhi",
                        "latitude": "28.65655000",
                        "longitude": "77.10068000"
                    }
                ]
            },
            {
                "id": 4009,
                "name": "Goa",
                "iso2": "GA",
                "latitude": "15.29932650",
                "longitude": "74.12399600",
                "type": "state",
                "cities": [
                    {
                        "id": 57638,
                        "name": "Aldona",
                        "latitude": "15.59337000",
                        "longitude": "73.87482000"
                    },
                    {
                        "id": 57727,
                        "name": "Arambol",
                        "latitude": "15.68681000",
                        "longitude": "73.70449000"
                    },
                    {
                        "id": 57795,
                        "name": "Baga",
                        "latitude": "15.56517000",
                        "longitude": "73.75517000"
                    },
                    {
                        "id": 57836,
                        "name": "Bambolim",
                        "latitude": "15.46361000",
                        "longitude": "73.85310000"
                    },
                    {
                        "id": 57845,
                        "name": "Bandora",
                        "latitude": "15.40823000",
                        "longitude": "73.98129000"
                    },
                    {
                        "id": 57932,
                        "name": "Benaulim",
                        "latitude": "15.26435000",
                        "longitude": "73.92812000"
                    },
                    {
                        "id": 58165,
                        "name": "Calangute",
                        "latitude": "15.54390000",
                        "longitude": "73.75530000"
                    },
                    {
                        "id": 58167,
                        "name": "Candolim",
                        "latitude": "15.51807000",
                        "longitude": "73.76259000"
                    },
                    {
                        "id": 58169,
                        "name": "Carapur",
                        "latitude": "15.56588000",
                        "longitude": "73.98713000"
                    },
                    {
                        "id": 58170,
                        "name": "Cavelossim",
                        "latitude": "15.17255000",
                        "longitude": "73.94194000"
                    },
                    {
                        "id": 131542,
                        "name": "Chicalim",
                        "latitude": "15.39835000",
                        "longitude": "73.84216000"
                    },
                    {
                        "id": 131559,
                        "name": "Chinchinim",
                        "latitude": "15.21447000",
                        "longitude": "73.97555000"
                    },
                    {
                        "id": 131622,
                        "name": "Colovale",
                        "latitude": "15.63522000",
                        "longitude": "73.82426000"
                    },
                    {
                        "id": 131623,
                        "name": "Colva",
                        "latitude": "15.27976000",
                        "longitude": "73.92285000"
                    },
                    {
                        "id": 131625,
                        "name": "Cortalim",
                        "latitude": "15.40247000",
                        "longitude": "73.90881000"
                    },
                    {
                        "id": 131630,
                        "name": "Cuncolim",
                        "latitude": "15.17730000",
                        "longitude": "73.99392000"
                    },
                    {
                        "id": 131631,
                        "name": "Curchorem",
                        "latitude": "15.26349000",
                        "longitude": "74.10875000"
                    },
                    {
                        "id": 131632,
                        "name": "Curti",
                        "latitude": "15.41667000",
                        "longitude": "74.01667000"
                    },
                    {
                        "id": 131672,
                        "name": "Davorlim",
                        "latitude": "15.27221000",
                        "longitude": "73.99242000"
                    },
                    {
                        "id": 131764,
                        "name": "Dicholi",
                        "latitude": "15.59319000",
                        "longitude": "73.94571000"
                    },
                    {
                        "id": 131960,
                        "name": "Goa Velha",
                        "latitude": "15.44384000",
                        "longitude": "73.88572000"
                    },
                    {
                        "id": 132015,
                        "name": "Guirim",
                        "latitude": "15.57552000",
                        "longitude": "73.80722000"
                    },
                    {
                        "id": 132297,
                        "name": "Jua",
                        "latitude": "15.53070000",
                        "longitude": "73.95047000"
                    },
                    {
                        "id": 132705,
                        "name": "Kankon",
                        "latitude": "15.02698000",
                        "longitude": "74.04617000"
                    },
                    {
                        "id": 132811,
                        "name": "Madgaon",
                        "latitude": "15.27501000",
                        "longitude": "73.95786000"
                    },
                    {
                        "id": 133086,
                        "name": "Mapuca",
                        "latitude": "15.59154000",
                        "longitude": "73.80898000"
                    },
                    {
                        "id": 132997,
                        "name": "Morjim",
                        "latitude": "15.63097000",
                        "longitude": "73.73903000"
                    },
                    {
                        "id": 132998,
                        "name": "Mormugao",
                        "latitude": "15.38914000",
                        "longitude": "73.81491000"
                    },
                    {
                        "id": 133185,
                        "name": "Navelim",
                        "latitude": "15.53333000",
                        "longitude": "73.98333000"
                    },
                    {
                        "id": 133238,
                        "name": "North Goa",
                        "latitude": "15.53397000",
                        "longitude": "73.96408000"
                    },
                    {
                        "id": 133330,
                        "name": "Palle",
                        "latitude": "15.46667000",
                        "longitude": "74.08333000"
                    },
                    {
                        "id": 133342,
                        "name": "Panaji",
                        "latitude": "15.49574000",
                        "longitude": "73.82624000"
                    },
                    {
                        "id": 133422,
                        "name": "Pernem",
                        "latitude": "15.72300000",
                        "longitude": "73.79511000"
                    },
                    {
                        "id": 133471,
                        "name": "Ponda",
                        "latitude": "15.40341000",
                        "longitude": "74.01519000"
                    },
                    {
                        "id": 133572,
                        "name": "Quepem",
                        "latitude": "15.21280000",
                        "longitude": "74.07720000"
                    },
                    {
                        "id": 133573,
                        "name": "Queula",
                        "latitude": "15.39011000",
                        "longitude": "73.98557000"
                    },
                    {
                        "id": 133585,
                        "name": "Raia",
                        "latitude": "15.30499000",
                        "longitude": "73.97096000"
                    },
                    {
                        "id": 133764,
                        "name": "Saligao",
                        "latitude": "15.55359000",
                        "longitude": "73.79036000"
                    },
                    {
                        "id": 133777,
                        "name": "Sancoale",
                        "latitude": "15.37794000",
                        "longitude": "73.90352000"
                    },
                    {
                        "id": 133786,
                        "name": "Sanguem",
                        "latitude": "15.22901000",
                        "longitude": "74.15149000"
                    },
                    {
                        "id": 133791,
                        "name": "Sanquelim",
                        "latitude": "15.56422000",
                        "longitude": "74.00799000"
                    },
                    {
                        "id": 133795,
                        "name": "Sanvordem",
                        "latitude": "15.26269000",
                        "longitude": "74.11965000"
                    },
                    {
                        "id": 133850,
                        "name": "Serula",
                        "latitude": "15.54774000",
                        "longitude": "73.84329000"
                    },
                    {
                        "id": 133987,
                        "name": "Solim",
                        "latitude": "15.61521000",
                        "longitude": "73.76740000"
                    },
                    {
                        "id": 134010,
                        "name": "South Goa",
                        "latitude": "15.20425000",
                        "longitude": "74.16733000"
                    },
                    {
                        "id": 134101,
                        "name": "Taleigao",
                        "latitude": "15.46915000",
                        "longitude": "73.83285000"
                    },
                    {
                        "id": 134311,
                        "name": "Vagator",
                        "latitude": "15.59766000",
                        "longitude": "73.74496000"
                    },
                    {
                        "id": 134321,
                        "name": "Valpoy",
                        "latitude": "15.53239000",
                        "longitude": "74.13671000"
                    },
                    {
                        "id": 134329,
                        "name": "Varca",
                        "latitude": "15.23237000",
                        "longitude": "73.94311000"
                    },
                    {
                        "id": 134333,
                        "name": "Vasco da Gama",
                        "latitude": "15.39585000",
                        "longitude": "73.81568000"
                    }
                ]
            },
            {
                "id": 4030,
                "name": "Gujarat",
                "iso2": "GJ",
                "latitude": "22.25865200",
                "longitude": "71.19238050",
                "type": "state",
                "cities": [
                    {
                        "id": 57588,
                        "name": "Abrama",
                        "latitude": "20.85865000",
                        "longitude": "72.90648000"
                    },
                    {
                        "id": 57591,
                        "name": "Adalaj",
                        "latitude": "23.16453000",
                        "longitude": "72.58107000"
                    },
                    {
                        "id": 147572,
                        "name": "Agol",
                        "latitude": "23.15000000",
                        "longitude": "72.26666667"
                    },
                    {
                        "id": 57606,
                        "name": "Ahmedabad",
                        "latitude": "23.02579000",
                        "longitude": "72.58727000"
                    },
                    {
                        "id": 57608,
                        "name": "Ahwa",
                        "latitude": "20.75718000",
                        "longitude": "73.68626000"
                    },
                    {
                        "id": 147573,
                        "name": "Akrund",
                        "latitude": "23.28333333",
                        "longitude": "73.11666667"
                    },
                    {
                        "id": 57683,
                        "name": "Amod",
                        "latitude": "21.99317000",
                        "longitude": "72.87047000"
                    },
                    {
                        "id": 57685,
                        "name": "Amreli",
                        "latitude": "21.50789000",
                        "longitude": "71.18323000"
                    },
                    {
                        "id": 57688,
                        "name": "Amroli",
                        "latitude": "21.25084000",
                        "longitude": "72.83878000"
                    },
                    {
                        "id": 57695,
                        "name": "Anand",
                        "latitude": "22.40000000",
                        "longitude": "72.75000000"
                    },
                    {
                        "id": 57709,
                        "name": "Anjar",
                        "latitude": "23.11316000",
                        "longitude": "70.02671000"
                    },
                    {
                        "id": 57710,
                        "name": "Ankleshwar",
                        "latitude": "21.63236000",
                        "longitude": "72.99001000"
                    },
                    {
                        "id": 58104,
                        "name": "Babra",
                        "latitude": "21.84577000",
                        "longitude": "71.30544000"
                    },
                    {
                        "id": 142125,
                        "name": "Bagasara",
                        "latitude": "21.48333333",
                        "longitude": "70.95000000"
                    },
                    {
                        "id": 57799,
                        "name": "Bagasra",
                        "latitude": "21.48719000",
                        "longitude": "70.95516000"
                    },
                    {
                        "id": 147575,
                        "name": "Bakharla",
                        "latitude": "21.73151700",
                        "longitude": "69.63529600"
                    },
                    {
                        "id": 147576,
                        "name": "Balagam",
                        "latitude": "21.36666667",
                        "longitude": "70.10000000"
                    },
                    {
                        "id": 147577,
                        "name": "Balasinor",
                        "latitude": "22.95589100",
                        "longitude": "73.33649900"
                    },
                    {
                        "id": 147578,
                        "name": "Balisana",
                        "latitude": "23.81643600",
                        "longitude": "72.25753600"
                    },
                    {
                        "id": 147579,
                        "name": "Bamanbore",
                        "latitude": "22.41666667",
                        "longitude": "71.01666667"
                    },
                    {
                        "id": 57858,
                        "name": "Banas Kantha",
                        "latitude": "24.25000000",
                        "longitude": "72.50000000"
                    },
                    {
                        "id": 147580,
                        "name": "Bandia",
                        "latitude": "23.39604000",
                        "longitude": "69.01155000"
                    },
                    {
                        "id": 58135,
                        "name": "Bantva",
                        "latitude": "21.48815000",
                        "longitude": "70.07576000"
                    },
                    {
                        "id": 58140,
                        "name": "Bardoli",
                        "latitude": "21.12297000",
                        "longitude": "73.11151000"
                    },
                    {
                        "id": 153924,
                        "name": "Bavla",
                        "latitude": "22.83672406",
                        "longitude": "72.36277938"
                    },
                    {
                        "id": 57911,
                        "name": "Bedi",
                        "latitude": "22.50143000",
                        "longitude": "70.04363000"
                    },
                    {
                        "id": 57948,
                        "name": "Bhachau",
                        "latitude": "23.29858000",
                        "longitude": "70.34279000"
                    },
                    {
                        "id": 147581,
                        "name": "Bhadran",
                        "latitude": "22.35930000",
                        "longitude": "72.90050000"
                    },
                    {
                        "id": 147582,
                        "name": "Bhandu",
                        "latitude": "23.70000000",
                        "longitude": "72.36666667"
                    },
                    {
                        "id": 58014,
                        "name": "Bhanvad",
                        "latitude": "21.93053000",
                        "longitude": "69.78081000"
                    },
                    {
                        "id": 57967,
                        "name": "Bharuch",
                        "latitude": "21.69482000",
                        "longitude": "72.98050000"
                    },
                    {
                        "id": 147583,
                        "name": "Bhatha",
                        "latitude": "21.18333333",
                        "longitude": "72.76666667"
                    },
                    {
                        "id": 57972,
                        "name": "Bhavnagar",
                        "latitude": "21.76287000",
                        "longitude": "72.15331000"
                    },
                    {
                        "id": 58017,
                        "name": "Bhayavadar",
                        "latitude": "21.85523000",
                        "longitude": "70.24791000"
                    },
                    {
                        "id": 147584,
                        "name": "Bhildi",
                        "latitude": "24.18333333",
                        "longitude": "72.03333333"
                    },
                    {
                        "id": 147585,
                        "name": "Bhojpur Dharampur",
                        "latitude": "23.25000000",
                        "longitude": "69.67000000"
                    },
                    {
                        "id": 58002,
                        "name": "Bhuj",
                        "latitude": "23.25397000",
                        "longitude": "69.66928000"
                    },
                    {
                        "id": 58045,
                        "name": "Bilimora",
                        "latitude": "20.76957000",
                        "longitude": "72.96134000"
                    },
                    {
                        "id": 58046,
                        "name": "Bilkha",
                        "latitude": "21.44150000",
                        "longitude": "70.60063000"
                    },
                    {
                        "id": 58084,
                        "name": "Borsad",
                        "latitude": "22.40788000",
                        "longitude": "72.89817000"
                    },
                    {
                        "id": 58085,
                        "name": "Botad",
                        "latitude": "22.16917000",
                        "longitude": "71.66671000"
                    },
                    {
                        "id": 58174,
                        "name": "Chaklasi",
                        "latitude": "22.65320000",
                        "longitude": "72.94497000"
                    },
                    {
                        "id": 58180,
                        "name": "Chalala",
                        "latitude": "21.41073000",
                        "longitude": "71.16621000"
                    },
                    {
                        "id": 147586,
                        "name": "Chaloda",
                        "latitude": "22.80000000",
                        "longitude": "72.45000000"
                    },
                    {
                        "id": 147587,
                        "name": "Champaner",
                        "latitude": "22.48590000",
                        "longitude": "73.53710000"
                    },
                    {
                        "id": 131595,
                        "name": "Chanasma",
                        "latitude": "23.71472000",
                        "longitude": "72.11279000"
                    },
                    {
                        "id": 131529,
                        "name": "Chhala",
                        "latitude": "23.30779000",
                        "longitude": "72.77404000"
                    },
                    {
                        "id": 131535,
                        "name": "Chhota Udepur",
                        "latitude": "22.30401000",
                        "longitude": "74.01580000"
                    },
                    {
                        "id": 131548,
                        "name": "Chikhli",
                        "latitude": "20.75751000",
                        "longitude": "73.06268000"
                    },
                    {
                        "id": 131582,
                        "name": "Chotila",
                        "latitude": "22.42347000",
                        "longitude": "71.19641000"
                    },
                    {
                        "id": 147588,
                        "name": "Chuda",
                        "latitude": "22.48333333",
                        "longitude": "71.68333333"
                    },
                    {
                        "id": 147589,
                        "name": "Dabhoda",
                        "latitude": "23.16666667",
                        "longitude": "72.73333333"
                    },
                    {
                        "id": 131635,
                        "name": "Dabhoi",
                        "latitude": "22.18333000",
                        "longitude": "73.43333000"
                    },
                    {
                        "id": 131642,
                        "name": "Dahegam",
                        "latitude": "23.16903000",
                        "longitude": "72.82161000"
                    },
                    {
                        "id": 142126,
                        "name": "Dahod",
                        "latitude": "22.52000000",
                        "longitude": "74.15000000"
                    },
                    {
                        "id": 131808,
                        "name": "Dakor",
                        "latitude": "22.75268000",
                        "longitude": "73.14967000"
                    },
                    {
                        "id": 131809,
                        "name": "Damnagar",
                        "latitude": "21.69232000",
                        "longitude": "71.51747000"
                    },
                    {
                        "id": 147590,
                        "name": "Dandi",
                        "latitude": "21.32988000",
                        "longitude": "72.62484000"
                    },
                    {
                        "id": 142127,
                        "name": "Dangs (India)",
                        "latitude": "20.75000000",
                        "longitude": "73.75000000"
                    },
                    {
                        "id": 147591,
                        "name": "Danta",
                        "latitude": "24.18861111",
                        "longitude": "72.76583333"
                    },
                    {
                        "id": 131673,
                        "name": "Dayapar",
                        "latitude": "23.63371000",
                        "longitude": "68.90192000"
                    },
                    {
                        "id": 131680,
                        "name": "Delvada",
                        "latitude": "20.77544000",
                        "longitude": "71.04646000"
                    },
                    {
                        "id": 142128,
                        "name": "Delwada",
                        "latitude": "20.78330000",
                        "longitude": "71.05000000"
                    },
                    {
                        "id": 147592,
                        "name": "Detroj",
                        "latitude": "23.33333333",
                        "longitude": "72.18333333"
                    },
                    {
                        "id": 131704,
                        "name": "Devbhumi Dwarka",
                        "latitude": "22.20253000",
                        "longitude": "69.65498000"
                    },
                    {
                        "id": 131705,
                        "name": "Devgadh Bariya",
                        "latitude": "22.70517000",
                        "longitude": "73.90882000"
                    },
                    {
                        "id": 131716,
                        "name": "Dhandhuka",
                        "latitude": "22.38185000",
                        "longitude": "71.98664000"
                    },
                    {
                        "id": 131717,
                        "name": "Dhanera",
                        "latitude": "24.50967000",
                        "longitude": "72.02343000"
                    },
                    {
                        "id": 147593,
                        "name": "Dhansura",
                        "latitude": "23.35000000",
                        "longitude": "73.20000000"
                    },
                    {
                        "id": 131719,
                        "name": "Dharampur",
                        "latitude": "20.53693000",
                        "longitude": "73.17368000"
                    },
                    {
                        "id": 147594,
                        "name": "Dharasana",
                        "latitude": "20.68333333",
                        "longitude": "72.91666667"
                    },
                    {
                        "id": 131755,
                        "name": "Dhari",
                        "latitude": "21.32855000",
                        "longitude": "71.02645000"
                    },
                    {
                        "id": 147595,
                        "name": "Dhasa",
                        "latitude": "21.80000000",
                        "longitude": "71.51666667"
                    },
                    {
                        "id": 131738,
                        "name": "Dhola",
                        "latitude": "21.88129000",
                        "longitude": "71.77269000"
                    },
                    {
                        "id": 147596,
                        "name": "Dholera",
                        "latitude": "22.24800000",
                        "longitude": "72.19500000"
                    },
                    {
                        "id": 131739,
                        "name": "Dholka",
                        "latitude": "22.72732000",
                        "longitude": "72.44128000"
                    },
                    {
                        "id": 131741,
                        "name": "Dhoraji",
                        "latitude": "21.73359000",
                        "longitude": "70.45004000"
                    },
                    {
                        "id": 131743,
                        "name": "Dhrangadhra",
                        "latitude": "22.99167000",
                        "longitude": "71.46793000"
                    },
                    {
                        "id": 131742,
                        "name": "Dhrol",
                        "latitude": "22.56700000",
                        "longitude": "70.41769000"
                    },
                    {
                        "id": 131747,
                        "name": "Dhuwaran",
                        "latitude": "22.23779000",
                        "longitude": "72.75910000"
                    },
                    {
                        "id": 131817,
                        "name": "Disa",
                        "latitude": "24.25612000",
                        "longitude": "72.17928000"
                    },
                    {
                        "id": 131782,
                        "name": "Dohad",
                        "latitude": "22.90000000",
                        "longitude": "74.00000000"
                    },
                    {
                        "id": 147597,
                        "name": "Dumkhal",
                        "latitude": "21.73960000",
                        "longitude": "73.84490000"
                    },
                    {
                        "id": 131800,
                        "name": "Dungarpur",
                        "latitude": "21.28777000",
                        "longitude": "71.75560000"
                    },
                    {
                        "id": 131803,
                        "name": "Dwarka",
                        "latitude": "22.23944000",
                        "longitude": "68.96778000"
                    },
                    {
                        "id": 131888,
                        "name": "Gadhada",
                        "latitude": "21.96957000",
                        "longitude": "71.57828000"
                    },
                    {
                        "id": 131899,
                        "name": "Gandevi",
                        "latitude": "20.81214000",
                        "longitude": "72.99811000"
                    },
                    {
                        "id": 132046,
                        "name": "Gandhidham",
                        "latitude": "23.08333000",
                        "longitude": "70.13333000"
                    },
                    {
                        "id": 131900,
                        "name": "Gandhinagar",
                        "latitude": "23.21667000",
                        "longitude": "72.68333000"
                    },
                    {
                        "id": 131925,
                        "name": "Gariadhar",
                        "latitude": "21.53889000",
                        "longitude": "71.57737000"
                    },
                    {
                        "id": 147598,
                        "name": "Ghodasar",
                        "latitude": "24.45000000",
                        "longitude": "71.85000000"
                    },
                    {
                        "id": 131944,
                        "name": "Ghogha",
                        "latitude": "21.68813000",
                        "longitude": "72.27630000"
                    },
                    {
                        "id": 131958,
                        "name": "Gir Somnath",
                        "latitude": "20.91287000",
                        "longitude": "70.36710000"
                    },
                    {
                        "id": 131964,
                        "name": "Godhra",
                        "latitude": "22.77547000",
                        "longitude": "73.61488000"
                    },
                    {
                        "id": 131982,
                        "name": "Gondal",
                        "latitude": "21.96074000",
                        "longitude": "70.80255000"
                    },
                    {
                        "id": 147599,
                        "name": "Gorwa",
                        "latitude": "22.33010000",
                        "longitude": "73.16110000"
                    },
                    {
                        "id": 147600,
                        "name": "Halenda",
                        "latitude": "22.08818500",
                        "longitude": "71.05171000"
                    },
                    {
                        "id": 132139,
                        "name": "Halol",
                        "latitude": "22.50321000",
                        "longitude": "73.47242000"
                    },
                    {
                        "id": 132060,
                        "name": "Halvad",
                        "latitude": "23.01516000",
                        "longitude": "71.18029000"
                    },
                    {
                        "id": 132065,
                        "name": "Hansot",
                        "latitude": "21.58496000",
                        "longitude": "72.80764000"
                    },
                    {
                        "id": 132143,
                        "name": "Harij",
                        "latitude": "23.69356000",
                        "longitude": "71.90700000"
                    },
                    {
                        "id": 147601,
                        "name": "Harsol",
                        "latitude": "23.36000000",
                        "longitude": "73.02000000"
                    },
                    {
                        "id": 147602,
                        "name": "Hathuran",
                        "latitude": "21.50000000",
                        "longitude": "72.97000000"
                    },
                    {
                        "id": 132096,
                        "name": "Himatnagar",
                        "latitude": "23.59893000",
                        "longitude": "72.96602000"
                    },
                    {
                        "id": 147603,
                        "name": "Idar",
                        "latitude": "23.83000000",
                        "longitude": "73.00000000"
                    },
                    {
                        "id": 147604,
                        "name": "Jakhau",
                        "latitude": "23.21861111",
                        "longitude": "68.71694444"
                    },
                    {
                        "id": 142129,
                        "name": "Jalalpore",
                        "latitude": "20.94910000",
                        "longitude": "72.91360000"
                    },
                    {
                        "id": 132219,
                        "name": "Jalalpur",
                        "latitude": "20.94896000",
                        "longitude": "72.89829000"
                    },
                    {
                        "id": 147605,
                        "name": "Jalia",
                        "latitude": "21.80000000",
                        "longitude": "70.25000000"
                    },
                    {
                        "id": 147606,
                        "name": "Jambuda",
                        "latitude": "22.51666667",
                        "longitude": "70.21666667"
                    },
                    {
                        "id": 132226,
                        "name": "Jambusar",
                        "latitude": "22.05236000",
                        "longitude": "72.80074000"
                    },
                    {
                        "id": 132230,
                        "name": "Jamnagar",
                        "latitude": "22.47292000",
                        "longitude": "70.06673000"
                    },
                    {
                        "id": 147607,
                        "name": "Jarod",
                        "latitude": "22.43300000",
                        "longitude": "73.33300000"
                    },
                    {
                        "id": 132243,
                        "name": "Jasdan",
                        "latitude": "22.03709000",
                        "longitude": "71.20794000"
                    },
                    {
                        "id": 147608,
                        "name": "Jetalpur",
                        "latitude": "22.88333333",
                        "longitude": "72.60000000"
                    },
                    {
                        "id": 132261,
                        "name": "Jetalsar",
                        "latitude": "21.70891000",
                        "longitude": "70.57695000"
                    },
                    {
                        "id": 132262,
                        "name": "Jetpur",
                        "latitude": "21.75482000",
                        "longitude": "70.62347000"
                    },
                    {
                        "id": 147609,
                        "name": "Jetpur (Navagadh)",
                        "latitude": "21.75482000",
                        "longitude": "70.62347000"
                    },
                    {
                        "id": 147610,
                        "name": "Jhalod",
                        "latitude": "23.10027778",
                        "longitude": "74.15611111"
                    },
                    {
                        "id": 132272,
                        "name": "Jhulasan",
                        "latitude": "23.32860000",
                        "longitude": "72.47314000"
                    },
                    {
                        "id": 132285,
                        "name": "Jodhpur",
                        "latitude": "21.90174000",
                        "longitude": "70.03270000"
                    },
                    {
                        "id": 147611,
                        "name": "Jodhpur (Ahmedabad)",
                        "latitude": "21.88000000",
                        "longitude": "70.03000000"
                    },
                    {
                        "id": 142130,
                        "name": "Jodia",
                        "latitude": "22.71667000",
                        "longitude": "70.28333000"
                    },
                    {
                        "id": 132287,
                        "name": "Jodiya Bandar",
                        "latitude": "22.71667000",
                        "longitude": "70.28333000"
                    },
                    {
                        "id": 132317,
                        "name": "Junagadh",
                        "latitude": "21.25000000",
                        "longitude": "70.33333000"
                    },
                    {
                        "id": 132321,
                        "name": "Kachchh",
                        "latitude": "23.58333000",
                        "longitude": "70.00000000"
                    },
                    {
                        "id": 147612,
                        "name": "Kachholi",
                        "latitude": "20.83333333",
                        "longitude": "72.96666667"
                    },
                    {
                        "id": 132327,
                        "name": "Kadi",
                        "latitude": "23.29908000",
                        "longitude": "72.33362000"
                    },
                    {
                        "id": 132329,
                        "name": "Kadod",
                        "latitude": "21.21717000",
                        "longitude": "73.21972000"
                    },
                    {
                        "id": 132689,
                        "name": "Kalavad",
                        "latitude": "22.20789000",
                        "longitude": "70.38343000"
                    },
                    {
                        "id": 132682,
                        "name": "Kalol",
                        "latitude": "22.60777000",
                        "longitude": "73.46272000"
                    },
                    {
                        "id": 132698,
                        "name": "Kandla",
                        "latitude": "23.03333000",
                        "longitude": "70.21667000"
                    },
                    {
                        "id": 147613,
                        "name": "Kandla port",
                        "latitude": "23.03000000",
                        "longitude": "70.22000000"
                    },
                    {
                        "id": 132708,
                        "name": "Kanodar",
                        "latitude": "24.08932000",
                        "longitude": "72.39354000"
                    },
                    {
                        "id": 132390,
                        "name": "Kapadvanj",
                        "latitude": "23.02302000",
                        "longitude": "73.07113000"
                    },
                    {
                        "id": 132394,
                        "name": "Karamsad",
                        "latitude": "22.54243000",
                        "longitude": "72.90392000"
                    },
                    {
                        "id": 147614,
                        "name": "Kariana",
                        "latitude": "21.88333333",
                        "longitude": "71.35000000"
                    },
                    {
                        "id": 147615,
                        "name": "Karjan",
                        "latitude": "22.05304167",
                        "longitude": "73.12351389"
                    },
                    {
                        "id": 132723,
                        "name": "Kathor",
                        "latitude": "21.28854000",
                        "longitude": "72.94070000"
                    },
                    {
                        "id": 132425,
                        "name": "Katpur",
                        "latitude": "21.05869000",
                        "longitude": "71.79457000"
                    },
                    {
                        "id": 132434,
                        "name": "Kawant",
                        "latitude": "22.09282000",
                        "longitude": "74.05078000"
                    },
                    {
                        "id": 147616,
                        "name": "Kayavarohan",
                        "latitude": "22.06700000",
                        "longitude": "73.25000000"
                    },
                    {
                        "id": 147617,
                        "name": "Kerwada",
                        "latitude": "21.90000000",
                        "longitude": "72.85000000"
                    },
                    {
                        "id": 132446,
                        "name": "Keshod",
                        "latitude": "21.30328000",
                        "longitude": "70.24861000"
                    },
                    {
                        "id": 142132,
                        "name": "Khambhalia",
                        "latitude": "22.20000000",
                        "longitude": "69.65000000"
                    },
                    {
                        "id": 132462,
                        "name": "Khambhat",
                        "latitude": "22.31744000",
                        "longitude": "72.61916000"
                    },
                    {
                        "id": 147618,
                        "name": "Khavda",
                        "latitude": "23.85000000",
                        "longitude": "69.72000000"
                    },
                    {
                        "id": 132488,
                        "name": "Kheda",
                        "latitude": "22.75000000",
                        "longitude": "72.83333000"
                    },
                    {
                        "id": 132489,
                        "name": "Khedbrahma",
                        "latitude": "24.02990000",
                        "longitude": "73.04632000"
                    },
                    {
                        "id": 147619,
                        "name": "Khedoi",
                        "latitude": "23.05927778",
                        "longitude": "69.91895556"
                    },
                    {
                        "id": 147620,
                        "name": "Kherali",
                        "latitude": "22.68333333",
                        "longitude": "71.60000000"
                    },
                    {
                        "id": 132494,
                        "name": "Kheralu",
                        "latitude": "23.88534000",
                        "longitude": "72.61869000"
                    },
                    {
                        "id": 132547,
                        "name": "Kodinar",
                        "latitude": "20.79393000",
                        "longitude": "70.70216000"
                    },
                    {
                        "id": 132588,
                        "name": "Kosamba",
                        "latitude": "21.46202000",
                        "longitude": "72.95842000"
                    },
                    {
                        "id": 147621,
                        "name": "Kothara",
                        "latitude": "23.13300000",
                        "longitude": "68.93200000"
                    },
                    {
                        "id": 147622,
                        "name": "Kotharia",
                        "latitude": "22.23000000",
                        "longitude": "70.81000000"
                    },
                    {
                        "id": 147623,
                        "name": "Kukarmunda",
                        "latitude": "21.51666667",
                        "longitude": "74.13333333"
                    },
                    {
                        "id": 147624,
                        "name": "Kukma",
                        "latitude": "23.21782200",
                        "longitude": "69.77792200"
                    },
                    {
                        "id": 132647,
                        "name": "Kundla",
                        "latitude": "21.34222000",
                        "longitude": "71.30633000"
                    },
                    {
                        "id": 142133,
                        "name": "Kutch district",
                        "latitude": "23.91500000",
                        "longitude": "70.36700000"
                    },
                    {
                        "id": 132670,
                        "name": "Kutiyana",
                        "latitude": "21.62410000",
                        "longitude": "69.98494000"
                    },
                    {
                        "id": 147628,
                        "name": "Ladol",
                        "latitude": "23.61666667",
                        "longitude": "72.73333333"
                    },
                    {
                        "id": 147625,
                        "name": "Lakhpat",
                        "latitude": "23.82611111",
                        "longitude": "68.77694444"
                    },
                    {
                        "id": 132747,
                        "name": "Lakhtar",
                        "latitude": "22.85683000",
                        "longitude": "71.78844000"
                    },
                    {
                        "id": 132797,
                        "name": "Lalpur",
                        "latitude": "22.19073000",
                        "longitude": "69.96351000"
                    },
                    {
                        "id": 147626,
                        "name": "Langhnaj",
                        "latitude": "23.45000000",
                        "longitude": "72.48333333"
                    },
                    {
                        "id": 132802,
                        "name": "Lathi",
                        "latitude": "21.72310000",
                        "longitude": "71.38843000"
                    },
                    {
                        "id": 132764,
                        "name": "Limbdi",
                        "latitude": "22.56507000",
                        "longitude": "71.81076000"
                    },
                    {
                        "id": 147627,
                        "name": "Limkheda",
                        "latitude": "22.81666667",
                        "longitude": "73.98333333"
                    },
                    {
                        "id": 132804,
                        "name": "Lunavada",
                        "latitude": "23.12841000",
                        "longitude": "73.61043000"
                    },
                    {
                        "id": 147629,
                        "name": "Madhavpur Ghed",
                        "latitude": "21.29929167",
                        "longitude": "70.02513889"
                    },
                    {
                        "id": 147630,
                        "name": "Madhi",
                        "latitude": "22.10000000",
                        "longitude": "69.10000000"
                    },
                    {
                        "id": 132831,
                        "name": "Mahemdavad",
                        "latitude": "22.82359000",
                        "longitude": "72.75551000"
                    },
                    {
                        "id": 132834,
                        "name": "Mahesana",
                        "latitude": "23.66667000",
                        "longitude": "72.50000000"
                    },
                    {
                        "id": 147631,
                        "name": "Mahisa",
                        "latitude": "22.85000000",
                        "longitude": "73.05000000"
                    },
                    {
                        "id": 132841,
                        "name": "Mahudha",
                        "latitude": "22.82082000",
                        "longitude": "72.94032000"
                    },
                    {
                        "id": 147632,
                        "name": "Mahuva",
                        "latitude": "21.08330000",
                        "longitude": "71.80000000"
                    },
                    {
                        "id": 147633,
                        "name": "Mahuva (Surat)",
                        "latitude": "21.02000000",
                        "longitude": "73.15000000"
                    },
                    {
                        "id": 133068,
                        "name": "Malpur",
                        "latitude": "23.36035000",
                        "longitude": "73.46595000"
                    },
                    {
                        "id": 133085,
                        "name": "Manavadar",
                        "latitude": "21.49813000",
                        "longitude": "70.13775000"
                    },
                    {
                        "id": 133073,
                        "name": "Mandal",
                        "latitude": "23.28865000",
                        "longitude": "71.91854000"
                    },
                    {
                        "id": 133076,
                        "name": "Mandvi",
                        "latitude": "22.83282000",
                        "longitude": "69.35237000"
                    },
                    {
                        "id": 142134,
                        "name": "Mandvi (Surat)",
                        "latitude": "21.25526000",
                        "longitude": "73.30412000"
                    },
                    {
                        "id": 133077,
                        "name": "Mangrol",
                        "latitude": "21.12268000",
                        "longitude": "70.11484000"
                    },
                    {
                        "id": 147634,
                        "name": "Mangrol (Junagadh)",
                        "latitude": "21.12000000",
                        "longitude": "70.12000000"
                    },
                    {
                        "id": 133081,
                        "name": "Mansa",
                        "latitude": "23.42564000",
                        "longitude": "72.65739000"
                    },
                    {
                        "id": 132960,
                        "name": "Meghraj",
                        "latitude": "23.49805000",
                        "longitude": "73.51352000"
                    },
                    {
                        "id": 142135,
                        "name": "Mehsana",
                        "latitude": "23.60000000",
                        "longitude": "72.40000000"
                    },
                    {
                        "id": 132966,
                        "name": "Mendarda",
                        "latitude": "21.32112000",
                        "longitude": "70.44078000"
                    },
                    {
                        "id": 147635,
                        "name": "Mithapur",
                        "latitude": "22.41000000",
                        "longitude": "69.00000000"
                    },
                    {
                        "id": 132978,
                        "name": "Modasa",
                        "latitude": "23.46253000",
                        "longitude": "73.29857000"
                    },
                    {
                        "id": 132993,
                        "name": "Morbi",
                        "latitude": "22.81731000",
                        "longitude": "70.83770000"
                    },
                    {
                        "id": 142136,
                        "name": "Morva (Hadaf)",
                        "latitude": "22.90469000",
                        "longitude": "73.83912000"
                    },
                    {
                        "id": 133000,
                        "name": "Morwa",
                        "latitude": "22.90469000",
                        "longitude": "73.83912000"
                    },
                    {
                        "id": 133029,
                        "name": "Mundra",
                        "latitude": "22.83918000",
                        "longitude": "69.72190000"
                    },
                    {
                        "id": 133106,
                        "name": "Nadiad",
                        "latitude": "22.69385000",
                        "longitude": "72.86157000"
                    },
                    {
                        "id": 147637,
                        "name": "Nagwa",
                        "latitude": "25.69621000",
                        "longitude": "84.23590000"
                    },
                    {
                        "id": 147638,
                        "name": "Naldhara",
                        "latitude": "20.96666667",
                        "longitude": "73.16666667"
                    },
                    {
                        "id": 133133,
                        "name": "Naliya",
                        "latitude": "23.26058000",
                        "longitude": "68.82655000"
                    },
                    {
                        "id": 147639,
                        "name": "Nargol",
                        "latitude": "20.23300000",
                        "longitude": "72.75000000"
                    },
                    {
                        "id": 133169,
                        "name": "Narmada",
                        "latitude": "21.87377000",
                        "longitude": "73.49527000"
                    },
                    {
                        "id": 133170,
                        "name": "Naroda",
                        "latitude": "23.07041000",
                        "longitude": "72.65702000"
                    },
                    {
                        "id": 133187,
                        "name": "Navsari",
                        "latitude": "20.95000000",
                        "longitude": "72.92000000"
                    },
                    {
                        "id": 147640,
                        "name": "Nikora",
                        "latitude": "21.78586000",
                        "longitude": "73.13968000"
                    },
                    {
                        "id": 147641,
                        "name": "Nizar",
                        "latitude": "21.47727000",
                        "longitude": "74.19595000"
                    },
                    {
                        "id": 147642,
                        "name": "Odadar",
                        "latitude": "21.56666667",
                        "longitude": "69.66666667"
                    },
                    {
                        "id": 133297,
                        "name": "Okha",
                        "latitude": "22.46756000",
                        "longitude": "69.07002000"
                    },
                    {
                        "id": 133298,
                        "name": "Olpad",
                        "latitude": "21.33649000",
                        "longitude": "72.75161000"
                    },
                    {
                        "id": 133313,
                        "name": "Paddhari",
                        "latitude": "22.43654000",
                        "longitude": "70.60162000"
                    },
                    {
                        "id": 133315,
                        "name": "Padra",
                        "latitude": "22.23980000",
                        "longitude": "73.08451000"
                    },
                    {
                        "id": 133526,
                        "name": "Palanpur",
                        "latitude": "24.17128000",
                        "longitude": "72.43827000"
                    },
                    {
                        "id": 147643,
                        "name": "Palanswa",
                        "latitude": "23.46666667",
                        "longitude": "70.93333333"
                    },
                    {
                        "id": 133532,
                        "name": "Palitana",
                        "latitude": "21.52519000",
                        "longitude": "71.82309000"
                    },
                    {
                        "id": 133533,
                        "name": "Paliyad",
                        "latitude": "22.25757000",
                        "longitude": "71.56024000"
                    },
                    {
                        "id": 147645,
                        "name": "Palsana",
                        "latitude": "21.08000000",
                        "longitude": "72.98000000"
                    },
                    {
                        "id": 133536,
                        "name": "Panch Mahals",
                        "latitude": "22.75000000",
                        "longitude": "73.60000000"
                    },
                    {
                        "id": 142137,
                        "name": "Panchmahal district",
                        "latitude": "22.75000000",
                        "longitude": "73.60000000"
                    },
                    {
                        "id": 133548,
                        "name": "Pardi",
                        "latitude": "20.50870000",
                        "longitude": "72.94569000"
                    },
                    {
                        "id": 133362,
                        "name": "Parnera",
                        "latitude": "20.56101000",
                        "longitude": "72.94846000"
                    },
                    {
                        "id": 133376,
                        "name": "Patan",
                        "latitude": "23.70000000",
                        "longitude": "71.80000000"
                    },
                    {
                        "id": 142138,
                        "name": "Pavi Jetpur",
                        "latitude": "22.34472000",
                        "longitude": "73.84093000"
                    },
                    {
                        "id": 133429,
                        "name": "Petlad",
                        "latitude": "22.47681000",
                        "longitude": "72.79995000"
                    },
                    {
                        "id": 147646,
                        "name": "Pipavav",
                        "latitude": "20.96666667",
                        "longitude": "71.56666667"
                    },
                    {
                        "id": 147647,
                        "name": "Piplod",
                        "latitude": "22.81666667",
                        "longitude": "73.90000000"
                    },
                    {
                        "id": 133480,
                        "name": "Porbandar",
                        "latitude": "21.64219000",
                        "longitude": "69.60929000"
                    },
                    {
                        "id": 147648,
                        "name": "Prabhas Patan",
                        "latitude": "20.88808000",
                        "longitude": "70.40129000"
                    },
                    {
                        "id": 147649,
                        "name": "Prantij",
                        "latitude": "23.43841944",
                        "longitude": "72.85718056"
                    },
                    {
                        "id": 133657,
                        "name": "Radhanpur",
                        "latitude": "23.83238000",
                        "longitude": "71.60470000"
                    },
                    {
                        "id": 133679,
                        "name": "Rajkot",
                        "latitude": "22.33333000",
                        "longitude": "70.83333000"
                    },
                    {
                        "id": 133682,
                        "name": "Rajpipla",
                        "latitude": "21.86667000",
                        "longitude": "73.50000000"
                    },
                    {
                        "id": 133684,
                        "name": "Rajula",
                        "latitude": "21.03854000",
                        "longitude": "71.44345000"
                    },
                    {
                        "id": 133718,
                        "name": "Ranavav",
                        "latitude": "21.68734000",
                        "longitude": "69.74485000"
                    },
                    {
                        "id": 147650,
                        "name": "Ranpur",
                        "latitude": "22.36670000",
                        "longitude": "71.75000000"
                    },
                    {
                        "id": 133722,
                        "name": "Rapar",
                        "latitude": "23.57267000",
                        "longitude": "70.64718000"
                    },
                    {
                        "id": 147651,
                        "name": "Reha",
                        "latitude": "23.15172500",
                        "longitude": "69.75008600"
                    },
                    {
                        "id": 133643,
                        "name": "Roha",
                        "latitude": "23.19646000",
                        "longitude": "69.27076000"
                    },
                    {
                        "id": 133739,
                        "name": "Sabar Kantha",
                        "latitude": "23.62974000",
                        "longitude": "73.00197000"
                    },
                    {
                        "id": 133742,
                        "name": "Sachin",
                        "latitude": "21.08718000",
                        "longitude": "72.88153000"
                    },
                    {
                        "id": 133766,
                        "name": "Salaya",
                        "latitude": "22.31038000",
                        "longitude": "69.60376000"
                    },
                    {
                        "id": 147652,
                        "name": "Samakhiali",
                        "latitude": "23.30340000",
                        "longitude": "70.50688000"
                    },
                    {
                        "id": 134069,
                        "name": "Sanand",
                        "latitude": "22.99227000",
                        "longitude": "72.38177000"
                    },
                    {
                        "id": 133790,
                        "name": "Sankheda",
                        "latitude": "22.17021000",
                        "longitude": "73.57820000"
                    },
                    {
                        "id": 147653,
                        "name": "Sarbhon",
                        "latitude": "21.05000000",
                        "longitude": "73.08330000"
                    },
                    {
                        "id": 147654,
                        "name": "Sardoi",
                        "latitude": "23.56670000",
                        "longitude": "73.26670000"
                    },
                    {
                        "id": 133808,
                        "name": "Sarkhej",
                        "latitude": "22.98297000",
                        "longitude": "72.50196000"
                    },
                    {
                        "id": 147655,
                        "name": "Sathamba",
                        "latitude": "23.16912500",
                        "longitude": "73.32661667"
                    },
                    {
                        "id": 133831,
                        "name": "Savarkundla",
                        "latitude": "21.33726000",
                        "longitude": "71.30350000"
                    },
                    {
                        "id": 147656,
                        "name": "Savli",
                        "latitude": "22.56666667",
                        "longitude": "73.21666667"
                    },
                    {
                        "id": 134085,
                        "name": "Sayla",
                        "latitude": "22.54925000",
                        "longitude": "71.48324000"
                    },
                    {
                        "id": 133900,
                        "name": "Shahpur",
                        "latitude": "22.15611000",
                        "longitude": "70.77068000"
                    },
                    {
                        "id": 133882,
                        "name": "Shivrajpur",
                        "latitude": "22.42319000",
                        "longitude": "73.60865000"
                    },
                    {
                        "id": 142139,
                        "name": "Siddhpur",
                        "latitude": "23.91670000",
                        "longitude": "72.38330000"
                    },
                    {
                        "id": 133925,
                        "name": "Sihor",
                        "latitude": "21.71134000",
                        "longitude": "71.96179000"
                    },
                    {
                        "id": 133932,
                        "name": "Sikka",
                        "latitude": "22.43218000",
                        "longitude": "69.84158000"
                    },
                    {
                        "id": 133954,
                        "name": "Sinor",
                        "latitude": "21.91117000",
                        "longitude": "73.33974000"
                    },
                    {
                        "id": 133984,
                        "name": "Sojitra",
                        "latitude": "22.53884000",
                        "longitude": "72.71984000"
                    },
                    {
                        "id": 133995,
                        "name": "Songadh",
                        "latitude": "21.16966000",
                        "longitude": "73.56357000"
                    },
                    {
                        "id": 147657,
                        "name": "Supedi",
                        "latitude": "21.76200000",
                        "longitude": "70.37800000"
                    },
                    {
                        "id": 134096,
                        "name": "Surat",
                        "latitude": "21.17801000",
                        "longitude": "72.81189000"
                    },
                    {
                        "id": 134050,
                        "name": "Surendranagar",
                        "latitude": "22.72706000",
                        "longitude": "71.64856000"
                    },
                    {
                        "id": 147658,
                        "name": "Sutrapada",
                        "latitude": "20.89280000",
                        "longitude": "70.46500000"
                    },
                    {
                        "id": 134107,
                        "name": "Talaja",
                        "latitude": "21.35270000",
                        "longitude": "72.03524000"
                    },
                    {
                        "id": 134112,
                        "name": "Tankara",
                        "latitude": "22.65622000",
                        "longitude": "70.74945000"
                    },
                    {
                        "id": 134114,
                        "name": "Tapi",
                        "latitude": "21.12000000",
                        "longitude": "73.40000000"
                    },
                    {
                        "id": 134164,
                        "name": "Than",
                        "latitude": "22.57422000",
                        "longitude": "71.19942000"
                    },
                    {
                        "id": 142140,
                        "name": "Thangadh",
                        "latitude": "22.56666667",
                        "longitude": "71.18333333"
                    },
                    {
                        "id": 134144,
                        "name": "Tharad",
                        "latitude": "24.39597000",
                        "longitude": "71.62577000"
                    },
                    {
                        "id": 134168,
                        "name": "Thasra",
                        "latitude": "22.79831000",
                        "longitude": "73.21174000"
                    },
                    {
                        "id": 134145,
                        "name": "The Dangs",
                        "latitude": "20.75000000",
                        "longitude": "73.75000000"
                    },
                    {
                        "id": 147659,
                        "name": "Umarpada",
                        "latitude": "21.45000000",
                        "longitude": "73.50000000"
                    },
                    {
                        "id": 134277,
                        "name": "Umrala",
                        "latitude": "21.84353000",
                        "longitude": "71.80305000"
                    },
                    {
                        "id": 134275,
                        "name": "Umreth",
                        "latitude": "22.69881000",
                        "longitude": "73.11561000"
                    },
                    {
                        "id": 134278,
                        "name": "Un",
                        "latitude": "23.88745000",
                        "longitude": "71.76975000"
                    },
                    {
                        "id": 134280,
                        "name": "Una",
                        "latitude": "20.82318000",
                        "longitude": "71.03795000"
                    },
                    {
                        "id": 134284,
                        "name": "Unjha",
                        "latitude": "23.80366000",
                        "longitude": "72.39101000"
                    },
                    {
                        "id": 134286,
                        "name": "Upleta",
                        "latitude": "21.74015000",
                        "longitude": "70.28256000"
                    },
                    {
                        "id": 134297,
                        "name": "Utran",
                        "latitude": "21.23333000",
                        "longitude": "72.86667000"
                    },
                    {
                        "id": 147660,
                        "name": "Vadgam",
                        "latitude": "24.08333333",
                        "longitude": "72.48333333"
                    },
                    {
                        "id": 134309,
                        "name": "Vadnagar",
                        "latitude": "23.78593000",
                        "longitude": "72.63893000"
                    },
                    {
                        "id": 134310,
                        "name": "Vadodara",
                        "latitude": "22.29941000",
                        "longitude": "73.20812000"
                    },
                    {
                        "id": 134381,
                        "name": "Vaghodia",
                        "latitude": "22.30505000",
                        "longitude": "73.40016000"
                    },
                    {
                        "id": 147661,
                        "name": "Vaghodia INA",
                        "latitude": "22.30000000",
                        "longitude": "73.38330000"
                    },
                    {
                        "id": 134318,
                        "name": "Vallabh Vidyanagar",
                        "latitude": "22.53333000",
                        "longitude": "72.90000000"
                    },
                    {
                        "id": 142141,
                        "name": "Vallabhipur",
                        "latitude": "21.88780000",
                        "longitude": "71.87950000"
                    },
                    {
                        "id": 134322,
                        "name": "Valsad",
                        "latitude": "20.50000000",
                        "longitude": "73.08333000"
                    },
                    {
                        "id": 147662,
                        "name": "Vanala",
                        "latitude": "22.45000000",
                        "longitude": "71.98333333"
                    },
                    {
                        "id": 142142,
                        "name": "Vansda",
                        "latitude": "20.45000000",
                        "longitude": "73.22000000"
                    },
                    {
                        "id": 147663,
                        "name": "Vanthli",
                        "latitude": "21.48330000",
                        "longitude": "70.33330000"
                    },
                    {
                        "id": 134326,
                        "name": "Vapi",
                        "latitude": "20.37175000",
                        "longitude": "72.90493000"
                    },
                    {
                        "id": 134331,
                        "name": "Vartej",
                        "latitude": "21.73947000",
                        "longitude": "72.06553000"
                    },
                    {
                        "id": 134332,
                        "name": "Vasa",
                        "latitude": "22.66079000",
                        "longitude": "72.75519000"
                    },
                    {
                        "id": 147664,
                        "name": "Vasavad",
                        "latitude": "21.82657000",
                        "longitude": "71.02436000"
                    },
                    {
                        "id": 142143,
                        "name": "Vaso",
                        "latitude": "22.66079000",
                        "longitude": "72.75519000"
                    },
                    {
                        "id": 147665,
                        "name": "Vataman",
                        "latitude": "22.53000000",
                        "longitude": "72.42000000"
                    },
                    {
                        "id": 134339,
                        "name": "Vejalpur",
                        "latitude": "22.69021000",
                        "longitude": "73.56299000"
                    },
                    {
                        "id": 134349,
                        "name": "Veraval",
                        "latitude": "20.90770000",
                        "longitude": "70.36786000"
                    },
                    {
                        "id": 134357,
                        "name": "Vijapur",
                        "latitude": "23.56230000",
                        "longitude": "72.74848000"
                    },
                    {
                        "id": 142144,
                        "name": "Vinchhiya",
                        "latitude": "22.21027000",
                        "longitude": "71.37967000"
                    },
                    {
                        "id": 147666,
                        "name": "Viramgam",
                        "latitude": "23.12000000",
                        "longitude": "72.03000000"
                    },
                    {
                        "id": 134365,
                        "name": "Virpur",
                        "latitude": "23.18920000",
                        "longitude": "73.47987000"
                    },
                    {
                        "id": 134387,
                        "name": "Visavadar",
                        "latitude": "21.33954000",
                        "longitude": "70.74966000"
                    },
                    {
                        "id": 134371,
                        "name": "Visnagar",
                        "latitude": "23.69855000",
                        "longitude": "72.55210000"
                    },
                    {
                        "id": 134378,
                        "name": "Vyara",
                        "latitude": "21.11079000",
                        "longitude": "73.39365000"
                    },
                    {
                        "id": 142145,
                        "name": "Wadhai",
                        "latitude": "20.76666667",
                        "longitude": "73.48333333"
                    },
                    {
                        "id": 142146,
                        "name": "Wadhwan",
                        "latitude": "22.70000000",
                        "longitude": "71.68333333"
                    },
                    {
                        "id": 134389,
                        "name": "Waghai",
                        "latitude": "20.77048000",
                        "longitude": "73.50074000"
                    },
                    {
                        "id": 134416,
                        "name": "Wankaner",
                        "latitude": "22.61198000",
                        "longitude": "70.94379000"
                    }
                ]
            },
            {
                "id": 4007,
                "name": "Haryana",
                "iso2": "HR",
                "latitude": "29.05877570",
                "longitude": "76.08560100",
                "type": "state",
                "cities": [
                    {
                        "id": 57675,
                        "name": "Ambala",
                        "latitude": "30.32854000",
                        "longitude": "76.94220000"
                    },
                    {
                        "id": 134464,
                        "name": "Asandh",
                        "latitude": "29.52119000",
                        "longitude": "76.60552000"
                    },
                    {
                        "id": 57756,
                        "name": "Ateli Mandi",
                        "latitude": "28.10080000",
                        "longitude": "76.25980000"
                    },
                    {
                        "id": 57810,
                        "name": "Bahadurgarh",
                        "latitude": "28.69287000",
                        "longitude": "76.93555000"
                    },
                    {
                        "id": 57861,
                        "name": "Bara Uchana",
                        "latitude": "29.46747000",
                        "longitude": "76.17798000"
                    },
                    {
                        "id": 57890,
                        "name": "Barwala",
                        "latitude": "29.36747000",
                        "longitude": "75.90809000"
                    },
                    {
                        "id": 58152,
                        "name": "Bawal",
                        "latitude": "28.07184000",
                        "longitude": "76.58312000"
                    },
                    {
                        "id": 57937,
                        "name": "Beri Khas",
                        "latitude": "28.70146000",
                        "longitude": "76.57708000"
                    },
                    {
                        "id": 57988,
                        "name": "Bhiwani",
                        "latitude": "28.75000000",
                        "longitude": "76.16667000"
                    },
                    {
                        "id": 58054,
                        "name": "Bilaspur",
                        "latitude": "30.30450000",
                        "longitude": "77.30424000"
                    },
                    {
                        "id": 58164,
                        "name": "Buriya",
                        "latitude": "30.15911000",
                        "longitude": "77.35814000"
                    },
                    {
                        "id": 58200,
                        "name": "Charkhi Dadri",
                        "latitude": "28.59166000",
                        "longitude": "76.27161000"
                    },
                    {
                        "id": 131528,
                        "name": "Chhachhrauli",
                        "latitude": "30.24492000",
                        "longitude": "77.36027000"
                    },
                    {
                        "id": 131638,
                        "name": "Dabwali",
                        "latitude": "29.94906000",
                        "longitude": "74.73832000"
                    },
                    {
                        "id": 131757,
                        "name": "Dharuhera",
                        "latitude": "28.20553000",
                        "longitude": "76.79691000"
                    },
                    {
                        "id": 131831,
                        "name": "Ellenabad",
                        "latitude": "29.45282000",
                        "longitude": "74.66122000"
                    },
                    {
                        "id": 131853,
                        "name": "Faridabad",
                        "latitude": "28.41124000",
                        "longitude": "77.31316000"
                    },
                    {
                        "id": 131856,
                        "name": "Farrukhnagar",
                        "latitude": "28.44745000",
                        "longitude": "76.82391000"
                    },
                    {
                        "id": 131872,
                        "name": "Fatehabad",
                        "latitude": "29.51525000",
                        "longitude": "75.45554000"
                    },
                    {
                        "id": 131882,
                        "name": "Firozpur Jhirka",
                        "latitude": "27.78853000",
                        "longitude": "76.94496000"
                    },
                    {
                        "id": 131937,
                        "name": "Gharaunda",
                        "latitude": "29.53692000",
                        "longitude": "76.97142000"
                    },
                    {
                        "id": 131968,
                        "name": "Gohana",
                        "latitude": "29.13777000",
                        "longitude": "76.70247000"
                    },
                    {
                        "id": 131991,
                        "name": "Gorakhpur",
                        "latitude": "29.44768000",
                        "longitude": "75.67206000"
                    },
                    {
                        "id": 132032,
                        "name": "Gurgaon",
                        "latitude": "28.43891000",
                        "longitude": "77.00592000"
                    },
                    {
                        "id": 132141,
                        "name": "Hansi",
                        "latitude": "29.10239000",
                        "longitude": "75.96253000"
                    },
                    {
                        "id": 132084,
                        "name": "Hasanpur",
                        "latitude": "27.96944000",
                        "longitude": "77.49544000"
                    },
                    {
                        "id": 132106,
                        "name": "Hisar",
                        "latitude": "29.15394000",
                        "longitude": "75.72294000"
                    },
                    {
                        "id": 132109,
                        "name": "Hodal",
                        "latitude": "27.89196000",
                        "longitude": "77.36744000"
                    },
                    {
                        "id": 132163,
                        "name": "Inda Chhoi",
                        "latitude": "29.64042000",
                        "longitude": "75.79041000"
                    },
                    {
                        "id": 132167,
                        "name": "Indri",
                        "latitude": "29.87999000",
                        "longitude": "77.05972000"
                    },
                    {
                        "id": 132194,
                        "name": "Jagadhri",
                        "latitude": "30.16719000",
                        "longitude": "77.30367000"
                    },
                    {
                        "id": 132305,
                        "name": "Jakhal",
                        "latitude": "29.79627000",
                        "longitude": "75.82392000"
                    },
                    {
                        "id": 132266,
                        "name": "Jhajjar",
                        "latitude": "28.60630000",
                        "longitude": "76.65650000"
                    },
                    {
                        "id": 132315,
                        "name": "Jind",
                        "latitude": "29.31577000",
                        "longitude": "76.31502000"
                    },
                    {
                        "id": 132340,
                        "name": "Kaithal",
                        "latitude": "29.80153000",
                        "longitude": "76.39959000"
                    },
                    {
                        "id": 132360,
                        "name": "Kalanaur",
                        "latitude": "28.82823000",
                        "longitude": "76.39550000"
                    },
                    {
                        "id": 132688,
                        "name": "Kalanwali",
                        "latitude": "29.83573000",
                        "longitude": "74.97170000"
                    },
                    {
                        "id": 132389,
                        "name": "Kanina Khas",
                        "latitude": "28.33093000",
                        "longitude": "76.31099000"
                    },
                    {
                        "id": 132405,
                        "name": "Karnal",
                        "latitude": "29.66667000",
                        "longitude": "76.83333000"
                    },
                    {
                        "id": 132478,
                        "name": "Kharkhauda",
                        "latitude": "28.87870000",
                        "longitude": "76.91069000"
                    },
                    {
                        "id": 132493,
                        "name": "Kheri Sampla",
                        "latitude": "28.77810000",
                        "longitude": "76.77560000"
                    },
                    {
                        "id": 132662,
                        "name": "Kurukshetra",
                        "latitude": "30.00000000",
                        "longitude": "76.75000000"
                    },
                    {
                        "id": 132789,
                        "name": "Ladwa",
                        "latitude": "29.99350000",
                        "longitude": "77.04563000"
                    },
                    {
                        "id": 132772,
                        "name": "Loharu",
                        "latitude": "28.42993000",
                        "longitude": "75.80779000"
                    },
                    {
                        "id": 132825,
                        "name": "Maham",
                        "latitude": "28.96912000",
                        "longitude": "76.29495000"
                    },
                    {
                        "id": 132832,
                        "name": "Mahendragarh",
                        "latitude": "28.25000000",
                        "longitude": "76.16667000"
                    },
                    {
                        "id": 132892,
                        "name": "Mandholi Kalan",
                        "latitude": "28.70850000",
                        "longitude": "75.68296000"
                    },
                    {
                        "id": 133047,
                        "name": "Mustafabad",
                        "latitude": "30.20220000",
                        "longitude": "77.14873000"
                    },
                    {
                        "id": 133176,
                        "name": "Narayangarh",
                        "latitude": "30.47798000",
                        "longitude": "77.12804000"
                    },
                    {
                        "id": 133272,
                        "name": "Narnaul",
                        "latitude": "28.04444000",
                        "longitude": "76.10833000"
                    },
                    {
                        "id": 133273,
                        "name": "Narnaund",
                        "latitude": "29.22047000",
                        "longitude": "76.14278000"
                    },
                    {
                        "id": 133175,
                        "name": "Narwana",
                        "latitude": "29.59903000",
                        "longitude": "76.11927000"
                    },
                    {
                        "id": 133286,
                        "name": "Nilokheri",
                        "latitude": "29.83671000",
                        "longitude": "76.93191000"
                    },
                    {
                        "id": 133290,
                        "name": "Nuh",
                        "latitude": "28.10296000",
                        "longitude": "77.00144000"
                    },
                    {
                        "id": 133337,
                        "name": "Palwal",
                        "latitude": "28.14469000",
                        "longitude": "77.32546000"
                    },
                    {
                        "id": 133345,
                        "name": "Panchkula",
                        "latitude": "30.72883000",
                        "longitude": "76.94716000"
                    },
                    {
                        "id": 133350,
                        "name": "Panipat",
                        "latitude": "29.33259000",
                        "longitude": "76.92634000"
                    },
                    {
                        "id": 133378,
                        "name": "Pataudi",
                        "latitude": "28.32547000",
                        "longitude": "76.77858000"
                    },
                    {
                        "id": 133403,
                        "name": "Pehowa",
                        "latitude": "29.97897000",
                        "longitude": "76.58249000"
                    },
                    {
                        "id": 133451,
                        "name": "Pinjaur",
                        "latitude": "30.79873000",
                        "longitude": "76.91822000"
                    },
                    {
                        "id": 133568,
                        "name": "Punahana",
                        "latitude": "27.86371000",
                        "longitude": "77.20432000"
                    },
                    {
                        "id": 133567,
                        "name": "Pundri",
                        "latitude": "29.76096000",
                        "longitude": "76.56034000"
                    },
                    {
                        "id": 133579,
                        "name": "Radaur",
                        "latitude": "30.02706000",
                        "longitude": "77.15177000"
                    },
                    {
                        "id": 133715,
                        "name": "Rania",
                        "latitude": "29.52454000",
                        "longitude": "74.83689000"
                    },
                    {
                        "id": 133617,
                        "name": "Ratia",
                        "latitude": "29.69029000",
                        "longitude": "75.57688000"
                    },
                    {
                        "id": 133635,
                        "name": "Rewari",
                        "latitude": "28.19900000",
                        "longitude": "76.61830000"
                    },
                    {
                        "id": 133647,
                        "name": "Rohtak",
                        "latitude": "28.83333000",
                        "longitude": "76.66667000"
                    },
                    {
                        "id": 133746,
                        "name": "Safidon",
                        "latitude": "29.40596000",
                        "longitude": "76.67042000"
                    },
                    {
                        "id": 133774,
                        "name": "Samalkha",
                        "latitude": "29.23552000",
                        "longitude": "77.01273000"
                    },
                    {
                        "id": 133891,
                        "name": "Shadipur Julana",
                        "latitude": "29.12368000",
                        "longitude": "76.40516000"
                    },
                    {
                        "id": 133906,
                        "name": "Shahabad",
                        "latitude": "30.16776000",
                        "longitude": "76.87046000"
                    },
                    {
                        "id": 133961,
                        "name": "Sirsa",
                        "latitude": "29.53489000",
                        "longitude": "75.02898000"
                    },
                    {
                        "id": 133980,
                        "name": "Sohna",
                        "latitude": "28.24737000",
                        "longitude": "77.06544000"
                    },
                    {
                        "id": 133999,
                        "name": "Sonipat",
                        "latitude": "29.00000000",
                        "longitude": "76.91667000"
                    },
                    {
                        "id": 134238,
                        "name": "Taoru",
                        "latitude": "28.21173000",
                        "longitude": "76.94984000"
                    },
                    {
                        "id": 134167,
                        "name": "Thanesar",
                        "latitude": "29.97323000",
                        "longitude": "76.83214000"
                    },
                    {
                        "id": 134206,
                        "name": "Tohana",
                        "latitude": "29.71332000",
                        "longitude": "75.90441000"
                    },
                    {
                        "id": 134211,
                        "name": "Tosham",
                        "latitude": "28.86993000",
                        "longitude": "75.91650000"
                    },
                    {
                        "id": 134265,
                        "name": "Uklana",
                        "latitude": "29.51124000",
                        "longitude": "75.87823000"
                    },
                    {
                        "id": 134422,
                        "name": "Yamunanagar",
                        "latitude": "30.23644000",
                        "longitude": "77.30498000"
                    }
                ]
            },
            {
                "id": 4020,
                "name": "Himachal Pradesh",
                "iso2": "HP",
                "latitude": "31.10482940",
                "longitude": "77.17339010",
                "type": "state",
                "cities": [
                    {
                        "id": 57736,
                        "name": "Arki",
                        "latitude": "31.15196000",
                        "longitude": "76.96675000"
                    },
                    {
                        "id": 57789,
                        "name": "Baddi",
                        "latitude": "30.95783000",
                        "longitude": "76.79136000"
                    },
                    {
                        "id": 57853,
                        "name": "Banjar",
                        "latitude": "31.63900000",
                        "longitude": "77.34055000"
                    },
                    {
                        "id": 58041,
                        "name": "Bilaspur",
                        "latitude": "31.33027000",
                        "longitude": "76.75663000"
                    },
                    {
                        "id": 58181,
                        "name": "Chamba",
                        "latitude": "32.57147000",
                        "longitude": "76.10229000"
                    },
                    {
                        "id": 131512,
                        "name": "Chaupal",
                        "latitude": "30.94647000",
                        "longitude": "77.58840000"
                    },
                    {
                        "id": 131583,
                        "name": "Chowari",
                        "latitude": "32.43190000",
                        "longitude": "76.01200000"
                    },
                    {
                        "id": 131587,
                        "name": "Chuari Khas",
                        "latitude": "32.43058000",
                        "longitude": "76.01428000"
                    },
                    {
                        "id": 131641,
                        "name": "Dagshai",
                        "latitude": "30.88431000",
                        "longitude": "77.05228000"
                    },
                    {
                        "id": 131645,
                        "name": "Dalhousie",
                        "latitude": "32.55219000",
                        "longitude": "75.94663000"
                    },
                    {
                        "id": 131665,
                        "name": "Daulatpur",
                        "latitude": "31.78871000",
                        "longitude": "75.99154000"
                    },
                    {
                        "id": 131694,
                        "name": "Dera Gopipur",
                        "latitude": "31.87919000",
                        "longitude": "76.21871000"
                    },
                    {
                        "id": 131721,
                        "name": "Dharamsala",
                        "latitude": "32.22006000",
                        "longitude": "76.32013000"
                    },
                    {
                        "id": 131891,
                        "name": "Gagret",
                        "latitude": "31.65846000",
                        "longitude": "76.06144000"
                    },
                    {
                        "id": 131949,
                        "name": "Ghumarwin",
                        "latitude": "31.44166000",
                        "longitude": "76.71509000"
                    },
                    {
                        "id": 132063,
                        "name": "Hamirpur",
                        "latitude": "31.75000000",
                        "longitude": "76.50000000"
                    },
                    {
                        "id": 132255,
                        "name": "Jawala Mukhi",
                        "latitude": "31.87456000",
                        "longitude": "76.32013000"
                    },
                    {
                        "id": 132289,
                        "name": "Jogindarnagar",
                        "latitude": "31.98727000",
                        "longitude": "76.78906000"
                    },
                    {
                        "id": 132298,
                        "name": "Jubbal",
                        "latitude": "31.10923000",
                        "longitude": "77.65085000"
                    },
                    {
                        "id": 132302,
                        "name": "Jutogh",
                        "latitude": "31.10000000",
                        "longitude": "77.11667000"
                    },
                    {
                        "id": 132681,
                        "name": "Kalka",
                        "latitude": "30.83982000",
                        "longitude": "76.94065000"
                    },
                    {
                        "id": 132701,
                        "name": "Kangar",
                        "latitude": "32.09135000",
                        "longitude": "76.26267000"
                    },
                    {
                        "id": 132702,
                        "name": "Kangra",
                        "latitude": "32.16667000",
                        "longitude": "76.25000000"
                    },
                    {
                        "id": 132416,
                        "name": "Kasauli",
                        "latitude": "30.89856000",
                        "longitude": "76.96587000"
                    },
                    {
                        "id": 132523,
                        "name": "Kinnaur",
                        "latitude": "31.58333000",
                        "longitude": "78.41667000"
                    },
                    {
                        "id": 132601,
                        "name": "Kotkhai",
                        "latitude": "31.11728000",
                        "longitude": "77.53936000"
                    },
                    {
                        "id": 132602,
                        "name": "Kotla",
                        "latitude": "32.25000000",
                        "longitude": "76.03333000"
                    },
                    {
                        "id": 132636,
                        "name": "Kulu",
                        "latitude": "32.00000000",
                        "longitude": "77.25000000"
                    },
                    {
                        "id": 132675,
                        "name": "Kyelang",
                        "latitude": "32.57170000",
                        "longitude": "77.02448000"
                    },
                    {
                        "id": 132791,
                        "name": "Lahul and Spiti",
                        "latitude": "32.50000000",
                        "longitude": "77.83333000"
                    },
                    {
                        "id": 132929,
                        "name": "Manali",
                        "latitude": "32.25740000",
                        "longitude": "77.17481000"
                    },
                    {
                        "id": 132893,
                        "name": "Mandi",
                        "latitude": "31.71194000",
                        "longitude": "76.93273000"
                    },
                    {
                        "id": 133251,
                        "name": "Nadaun",
                        "latitude": "31.78303000",
                        "longitude": "76.34310000"
                    },
                    {
                        "id": 133113,
                        "name": "Nagar",
                        "latitude": "32.13808000",
                        "longitude": "77.17393000"
                    },
                    {
                        "id": 133118,
                        "name": "Nagrota",
                        "latitude": "32.05710000",
                        "longitude": "76.09139000"
                    },
                    {
                        "id": 133261,
                        "name": "Nahan",
                        "latitude": "30.56029000",
                        "longitude": "77.29426000"
                    },
                    {
                        "id": 133263,
                        "name": "Nalagarh",
                        "latitude": "31.04168000",
                        "longitude": "76.72285000"
                    },
                    {
                        "id": 133525,
                        "name": "Palampur",
                        "latitude": "32.11453000",
                        "longitude": "76.55681000"
                    },
                    {
                        "id": 133539,
                        "name": "Pandoh",
                        "latitude": "31.66902000",
                        "longitude": "77.05359000"
                    },
                    {
                        "id": 133544,
                        "name": "Paonta Sahib",
                        "latitude": "30.43666000",
                        "longitude": "77.62462000"
                    },
                    {
                        "id": 133369,
                        "name": "Parwanoo",
                        "latitude": "30.83716000",
                        "longitude": "76.96143000"
                    },
                    {
                        "id": 133676,
                        "name": "Rajgarh",
                        "latitude": "30.85142000",
                        "longitude": "77.30066000"
                    },
                    {
                        "id": 133706,
                        "name": "Rampur",
                        "latitude": "31.44943000",
                        "longitude": "77.63087000"
                    },
                    {
                        "id": 133646,
                        "name": "Rohru",
                        "latitude": "31.20269000",
                        "longitude": "77.75484000"
                    },
                    {
                        "id": 133741,
                        "name": "Sabathu",
                        "latitude": "30.97494000",
                        "longitude": "76.99137000"
                    },
                    {
                        "id": 133794,
                        "name": "Santokhgarh",
                        "latitude": "31.35205000",
                        "longitude": "76.31775000"
                    },
                    {
                        "id": 133811,
                        "name": "Sarahan",
                        "latitude": "31.50988000",
                        "longitude": "77.79395000"
                    },
                    {
                        "id": 133807,
                        "name": "Sarka Ghat",
                        "latitude": "31.69887000",
                        "longitude": "76.73529000"
                    },
                    {
                        "id": 133841,
                        "name": "Seoni",
                        "latitude": "31.24188000",
                        "longitude": "77.12362000"
                    },
                    {
                        "id": 133871,
                        "name": "Shimla",
                        "latitude": "31.16667000",
                        "longitude": "77.58333000"
                    },
                    {
                        "id": 133957,
                        "name": "Sirmaur",
                        "latitude": "30.75000000",
                        "longitude": "77.50000000"
                    },
                    {
                        "id": 133985,
                        "name": "Solan",
                        "latitude": "31.08333000",
                        "longitude": "76.83333000"
                    },
                    {
                        "id": 134045,
                        "name": "Sundarnagar",
                        "latitude": "31.53523000",
                        "longitude": "76.90500000"
                    },
                    {
                        "id": 134149,
                        "name": "Theog",
                        "latitude": "31.12155000",
                        "longitude": "77.35838000"
                    },
                    {
                        "id": 134246,
                        "name": "Tira Sujanpur",
                        "latitude": "31.83364000",
                        "longitude": "76.50539000"
                    },
                    {
                        "id": 134279,
                        "name": "Una",
                        "latitude": "31.46493000",
                        "longitude": "76.26914000"
                    },
                    {
                        "id": 134435,
                        "name": "Yol",
                        "latitude": "32.16423000",
                        "longitude": "76.19622000"
                    }
                ]
            },
            {
                "id": 4029,
                "name": "Jammu and Kashmir",
                "iso2": "JK",
                "latitude": "33.27783900",
                "longitude": "75.34121790",
                "type": "union territory",
                "cities": [
                    {
                        "id": 57622,
                        "name": "Akhnur",
                        "latitude": "32.86667000",
                        "longitude": "74.73333000"
                    },
                    {
                        "id": 57699,
                        "name": "Anantnag",
                        "latitude": "33.73068000",
                        "longitude": "75.15418000"
                    },
                    {
                        "id": 57774,
                        "name": "Awantipur",
                        "latitude": "33.91978000",
                        "longitude": "75.01515000"
                    },
                    {
                        "id": 57790,
                        "name": "Badgam",
                        "latitude": "33.89001000",
                        "longitude": "74.66297000"
                    },
                    {
                        "id": 57843,
                        "name": "Bandipore",
                        "latitude": "34.50404000",
                        "longitude": "74.82832000"
                    },
                    {
                        "id": 57852,
                        "name": "Banihal",
                        "latitude": "33.43647000",
                        "longitude": "75.19684000"
                    },
                    {
                        "id": 58139,
                        "name": "Baramula",
                        "latitude": "34.19287000",
                        "longitude": "74.36920000"
                    },
                    {
                        "id": 57905,
                        "name": "Batoti",
                        "latitude": "33.11826000",
                        "longitude": "75.30889000"
                    },
                    {
                        "id": 57949,
                        "name": "Bhadarwah",
                        "latitude": "32.97941000",
                        "longitude": "75.71723000"
                    },
                    {
                        "id": 58033,
                        "name": "Bijbehara",
                        "latitude": "33.79378000",
                        "longitude": "75.10700000"
                    },
                    {
                        "id": 58065,
                        "name": "Bishnah",
                        "latitude": "32.61060000",
                        "longitude": "74.85557000"
                    },
                    {
                        "id": 131781,
                        "name": "Doda",
                        "latitude": "33.14916000",
                        "longitude": "75.54746000"
                    },
                    {
                        "id": 131898,
                        "name": "Ganderbal",
                        "latitude": "34.29467000",
                        "longitude": "75.19996000"
                    },
                    {
                        "id": 131942,
                        "name": "Gho Brahmanan de",
                        "latitude": "32.55590000",
                        "longitude": "74.95390000"
                    },
                    {
                        "id": 132135,
                        "name": "Hajan",
                        "latitude": "34.29895000",
                        "longitude": "74.61681000"
                    },
                    {
                        "id": 132105,
                        "name": "Hiranagar",
                        "latitude": "32.45493000",
                        "longitude": "75.27187000"
                    },
                    {
                        "id": 132229,
                        "name": "Jammu",
                        "latitude": "32.75000000",
                        "longitude": "74.83333000"
                    },
                    {
                        "id": 132253,
                        "name": "Jaurian",
                        "latitude": "32.83255000",
                        "longitude": "74.57612000"
                    },
                    {
                        "id": 132422,
                        "name": "Kathua",
                        "latitude": "32.58333000",
                        "longitude": "75.50000000"
                    },
                    {
                        "id": 132427,
                        "name": "Katra",
                        "latitude": "32.99167000",
                        "longitude": "74.93195000"
                    },
                    {
                        "id": 132485,
                        "name": "Khaur",
                        "latitude": "32.60270000",
                        "longitude": "74.80918000"
                    },
                    {
                        "id": 132533,
                        "name": "Kishtwar",
                        "latitude": "33.52958000",
                        "longitude": "76.01462000"
                    },
                    {
                        "id": 132735,
                        "name": "Kud",
                        "latitude": "33.07246000",
                        "longitude": "75.28727000"
                    },
                    {
                        "id": 132633,
                        "name": "Kulgam",
                        "latitude": "33.64456000",
                        "longitude": "75.01923000"
                    },
                    {
                        "id": 132654,
                        "name": "Kupwara",
                        "latitude": "34.53193000",
                        "longitude": "74.26605000"
                    },
                    {
                        "id": 132740,
                        "name": "Ladakh",
                        "latitude": "34.33333000",
                        "longitude": "77.41667000"
                    },
                    {
                        "id": 133061,
                        "name": "Magam",
                        "latitude": "34.09256000",
                        "longitude": "74.59016000"
                    },
                    {
                        "id": 133193,
                        "name": "Nawanshahr",
                        "latitude": "32.76505000",
                        "longitude": "74.52772000"
                    },
                    {
                        "id": 133244,
                        "name": "Noria",
                        "latitude": "32.52095000",
                        "longitude": "74.79845000"
                    },
                    {
                        "id": 133310,
                        "name": "Padam",
                        "latitude": "33.46659000",
                        "longitude": "76.88488000"
                    },
                    {
                        "id": 133317,
                        "name": "Pahlgam",
                        "latitude": "34.01592000",
                        "longitude": "75.31899000"
                    },
                    {
                        "id": 133363,
                        "name": "Parol",
                        "latitude": "32.34598000",
                        "longitude": "75.43441000"
                    },
                    {
                        "id": 133388,
                        "name": "Pattan",
                        "latitude": "34.16125000",
                        "longitude": "74.55634000"
                    },
                    {
                        "id": 133501,
                        "name": "Pulwama",
                        "latitude": "33.87405000",
                        "longitude": "74.89955000"
                    },
                    {
                        "id": 133503,
                        "name": "Punch",
                        "latitude": "33.70178000",
                        "longitude": "74.19916000"
                    },
                    {
                        "id": 133576,
                        "name": "Qazigund",
                        "latitude": "33.63828000",
                        "longitude": "75.14261000"
                    },
                    {
                        "id": 133593,
                        "name": "Rajaori",
                        "latitude": "33.37526000",
                        "longitude": "74.30920000"
                    },
                    {
                        "id": 133673,
                        "name": "Rajauri",
                        "latitude": "33.25000000",
                        "longitude": "74.25000000"
                    },
                    {
                        "id": 133601,
                        "name": "Ramban",
                        "latitude": "33.32301000",
                        "longitude": "75.18610000"
                    },
                    {
                        "id": 133698,
                        "name": "Ramgarh",
                        "latitude": "33.40379000",
                        "longitude": "74.22388000"
                    },
                    {
                        "id": 133702,
                        "name": "Ramnagar",
                        "latitude": "32.80728000",
                        "longitude": "75.31119000"
                    },
                    {
                        "id": 133640,
                        "name": "Riasi",
                        "latitude": "33.08115000",
                        "longitude": "74.83242000"
                    },
                    {
                        "id": 133768,
                        "name": "Samba",
                        "latitude": "32.57523000",
                        "longitude": "75.10929000"
                    },
                    {
                        "id": 133889,
                        "name": "Shupiyan",
                        "latitude": "33.73067000",
                        "longitude": "74.81869000"
                    },
                    {
                        "id": 134000,
                        "name": "Sopur",
                        "latitude": "34.28671000",
                        "longitude": "74.47228000"
                    },
                    {
                        "id": 134016,
                        "name": "Soyibug",
                        "latitude": "34.07677000",
                        "longitude": "74.70570000"
                    },
                    {
                        "id": 134020,
                        "name": "Srinagar",
                        "latitude": "34.08565000",
                        "longitude": "74.80555000"
                    },
                    {
                        "id": 134043,
                        "name": "Sumbal",
                        "latitude": "34.23072000",
                        "longitude": "74.64720000"
                    },
                    {
                        "id": 134139,
                        "name": "Thang",
                        "latitude": "34.92740000",
                        "longitude": "76.79336000"
                    },
                    {
                        "id": 134141,
                        "name": "Thanna Mandi",
                        "latitude": "33.54204000",
                        "longitude": "74.38100000"
                    },
                    {
                        "id": 134213,
                        "name": "Tral",
                        "latitude": "33.92708000",
                        "longitude": "75.11585000"
                    },
                    {
                        "id": 134214,
                        "name": "Tsrar Sharif",
                        "latitude": "33.86319000",
                        "longitude": "74.76524000"
                    },
                    {
                        "id": 134257,
                        "name": "Udhampur",
                        "latitude": "33.00000000",
                        "longitude": "75.16667000"
                    },
                    {
                        "id": 134293,
                        "name": "Uri",
                        "latitude": "34.08064000",
                        "longitude": "74.05088000"
                    }
                ]
            },
            {
                "id": 4025,
                "name": "Jharkhand",
                "iso2": "JH",
                "latitude": "23.61018080",
                "longitude": "85.27993540",
                "type": "state",
                "cities": [
                    {
                        "id": 57802,
                        "name": "Bagra",
                        "latitude": "23.73333000",
                        "longitude": "86.31667000"
                    },
                    {
                        "id": 57880,
                        "name": "Barka Kana",
                        "latitude": "23.62118000",
                        "longitude": "85.46748000"
                    },
                    {
                        "id": 57878,
                        "name": "Barki Saria",
                        "latitude": "24.17594000",
                        "longitude": "85.88938000"
                    },
                    {
                        "id": 57889,
                        "name": "Barwadih",
                        "latitude": "23.84780000",
                        "longitude": "84.11049000"
                    },
                    {
                        "id": 57992,
                        "name": "Bhojudih",
                        "latitude": "23.63962000",
                        "longitude": "86.44105000"
                    },
                    {
                        "id": 58076,
                        "name": "Bokaro",
                        "latitude": "23.68562000",
                        "longitude": "85.99026000"
                    },
                    {
                        "id": 58163,
                        "name": "Bundu",
                        "latitude": "23.16095000",
                        "longitude": "85.59007000"
                    },
                    {
                        "id": 131608,
                        "name": "Chaibasa",
                        "latitude": "22.55038000",
                        "longitude": "85.80249000"
                    },
                    {
                        "id": 58175,
                        "name": "Chakradharpur",
                        "latitude": "22.67611000",
                        "longitude": "85.62892000"
                    },
                    {
                        "id": 131591,
                        "name": "Chakulia",
                        "latitude": "22.48301000",
                        "longitude": "86.71793000"
                    },
                    {
                        "id": 131598,
                        "name": "Chandil",
                        "latitude": "22.95745000",
                        "longitude": "86.05331000"
                    },
                    {
                        "id": 131606,
                        "name": "Chas",
                        "latitude": "23.63556000",
                        "longitude": "86.16712000"
                    },
                    {
                        "id": 131511,
                        "name": "Chatra",
                        "latitude": "24.20645000",
                        "longitude": "84.87085000"
                    },
                    {
                        "id": 131570,
                        "name": "Chiria",
                        "latitude": "22.31093000",
                        "longitude": "85.27601000"
                    },
                    {
                        "id": 131648,
                        "name": "Daltonganj",
                        "latitude": "24.03971000",
                        "longitude": "84.06580000"
                    },
                    {
                        "id": 131684,
                        "name": "Deogarh",
                        "latitude": "24.44382000",
                        "longitude": "86.72607000"
                    },
                    {
                        "id": 131715,
                        "name": "Dhanbad",
                        "latitude": "23.80199000",
                        "longitude": "86.44324000"
                    },
                    {
                        "id": 131718,
                        "name": "Dhanwar",
                        "latitude": "24.41074000",
                        "longitude": "85.98183000"
                    },
                    {
                        "id": 131794,
                        "name": "Dugda",
                        "latitude": "23.74516000",
                        "longitude": "86.17175000"
                    },
                    {
                        "id": 131797,
                        "name": "Dumka",
                        "latitude": "24.30000000",
                        "longitude": "87.25000000"
                    },
                    {
                        "id": 131922,
                        "name": "Garhwa",
                        "latitude": "24.07494000",
                        "longitude": "83.71023000"
                    },
                    {
                        "id": 131952,
                        "name": "Ghatsila",
                        "latitude": "22.58531000",
                        "longitude": "86.47682000"
                    },
                    {
                        "id": 131959,
                        "name": "Giridih",
                        "latitude": "24.25000000",
                        "longitude": "85.91667000"
                    },
                    {
                        "id": 131962,
                        "name": "Gobindpur",
                        "latitude": "22.63393000",
                        "longitude": "86.07162000"
                    },
                    {
                        "id": 131963,
                        "name": "Godda",
                        "latitude": "24.83333000",
                        "longitude": "87.21667000"
                    },
                    {
                        "id": 131980,
                        "name": "Gomoh",
                        "latitude": "23.87355000",
                        "longitude": "86.15160000"
                    },
                    {
                        "id": 131986,
                        "name": "Gopinathpur",
                        "latitude": "22.66301000",
                        "longitude": "86.07500000"
                    },
                    {
                        "id": 132006,
                        "name": "Gua",
                        "latitude": "22.21361000",
                        "longitude": "85.38774000"
                    },
                    {
                        "id": 132020,
                        "name": "Gumia",
                        "latitude": "23.79750000",
                        "longitude": "85.82523000"
                    },
                    {
                        "id": 132021,
                        "name": "Gumla",
                        "latitude": "23.08055000",
                        "longitude": "84.53834000"
                    },
                    {
                        "id": 132092,
                        "name": "Hazaribag",
                        "latitude": "24.00000000",
                        "longitude": "85.25000000"
                    },
                    {
                        "id": 132091,
                        "name": "Hazaribagh",
                        "latitude": "23.99241000",
                        "longitude": "85.36162000"
                    },
                    {
                        "id": 132094,
                        "name": "Hesla",
                        "latitude": "24.06313000",
                        "longitude": "85.87905000"
                    },
                    {
                        "id": 132131,
                        "name": "Husainabad",
                        "latitude": "24.52849000",
                        "longitude": "84.00000000"
                    },
                    {
                        "id": 132183,
                        "name": "Jagannathpur",
                        "latitude": "22.22115000",
                        "longitude": "85.63917000"
                    },
                    {
                        "id": 132308,
                        "name": "Jamadoba",
                        "latitude": "23.71667000",
                        "longitude": "86.40000000"
                    },
                    {
                        "id": 132231,
                        "name": "Jamshedpur",
                        "latitude": "22.80278000",
                        "longitude": "86.18545000"
                    },
                    {
                        "id": 132232,
                        "name": "Jamtara",
                        "latitude": "24.00000000",
                        "longitude": "86.85000000"
                    },
                    {
                        "id": 132246,
                        "name": "Jasidih",
                        "latitude": "24.51379000",
                        "longitude": "86.64576000"
                    },
                    {
                        "id": 132268,
                        "name": "Jharia",
                        "latitude": "23.74079000",
                        "longitude": "86.41456000"
                    },
                    {
                        "id": 132299,
                        "name": "Jugsalai",
                        "latitude": "22.77668000",
                        "longitude": "86.18351000"
                    },
                    {
                        "id": 132300,
                        "name": "Jumri Tilaiya",
                        "latitude": "24.43490000",
                        "longitude": "85.52951000"
                    },
                    {
                        "id": 132680,
                        "name": "Kalikapur",
                        "latitude": "22.61662000",
                        "longitude": "86.28810000"
                    },
                    {
                        "id": 132699,
                        "name": "Kandra",
                        "latitude": "22.85170000",
                        "longitude": "86.05192000"
                    },
                    {
                        "id": 132703,
                        "name": "Kanke",
                        "latitude": "23.43478000",
                        "longitude": "85.32059000"
                    },
                    {
                        "id": 132727,
                        "name": "Katras",
                        "latitude": "23.79752000",
                        "longitude": "86.29834000"
                    },
                    {
                        "id": 132443,
                        "name": "Kenduadih",
                        "latitude": "23.77574000",
                        "longitude": "86.37609000"
                    },
                    {
                        "id": 132482,
                        "name": "Kharsawan",
                        "latitude": "22.79093000",
                        "longitude": "85.83102000"
                    },
                    {
                        "id": 132506,
                        "name": "Khunti",
                        "latitude": "23.07602000",
                        "longitude": "85.27818000"
                    },
                    {
                        "id": 132540,
                        "name": "Kodarma",
                        "latitude": "24.46753000",
                        "longitude": "85.59397000"
                    },
                    {
                        "id": 132630,
                        "name": "Kuju",
                        "latitude": "23.72536000",
                        "longitude": "85.51023000"
                    },
                    {
                        "id": 132758,
                        "name": "Latehar",
                        "latitude": "23.75000000",
                        "longitude": "84.40000000"
                    },
                    {
                        "id": 132768,
                        "name": "Lohardaga",
                        "latitude": "23.50000000",
                        "longitude": "84.60000000"
                    },
                    {
                        "id": 132816,
                        "name": "Madhupur",
                        "latitude": "24.27419000",
                        "longitude": "86.63929000"
                    },
                    {
                        "id": 132873,
                        "name": "Malkera",
                        "latitude": "23.78213000",
                        "longitude": "86.28767000"
                    },
                    {
                        "id": 132923,
                        "name": "Manoharpur",
                        "latitude": "22.37456000",
                        "longitude": "85.19234000"
                    },
                    {
                        "id": 133015,
                        "name": "Mugma",
                        "latitude": "23.77015000",
                        "longitude": "86.72746000"
                    },
                    {
                        "id": 133044,
                        "name": "Mushabani",
                        "latitude": "22.51135000",
                        "longitude": "86.45713000"
                    },
                    {
                        "id": 133209,
                        "name": "Neturhat",
                        "latitude": "23.47457000",
                        "longitude": "84.26780000"
                    },
                    {
                        "id": 133223,
                        "name": "Nirsa",
                        "latitude": "23.78438000",
                        "longitude": "86.70692000"
                    },
                    {
                        "id": 133246,
                        "name": "Noamundi",
                        "latitude": "22.16094000",
                        "longitude": "85.50416000"
                    },
                    {
                        "id": 133320,
                        "name": "Pakur",
                        "latitude": "24.63925000",
                        "longitude": "87.84239000"
                    },
                    {
                        "id": 133339,
                        "name": "Palamu",
                        "latitude": "23.91667000",
                        "longitude": "84.08333000"
                    },
                    {
                        "id": 133374,
                        "name": "Pashchim Singhbhum",
                        "latitude": "22.50000000",
                        "longitude": "85.50000000"
                    },
                    {
                        "id": 134446,
                        "name": "patamda",
                        "latitude": "24.30000000",
                        "longitude": "85.41667000"
                    },
                    {
                        "id": 133557,
                        "name": "Pathardih",
                        "latitude": "23.66580000",
                        "longitude": "86.43166000"
                    },
                    {
                        "id": 133510,
                        "name": "Purba Singhbhum",
                        "latitude": "22.59238000",
                        "longitude": "86.48341000"
                    },
                    {
                        "id": 133604,
                        "name": "Ramgarh",
                        "latitude": "23.63073000",
                        "longitude": "85.56057000"
                    },
                    {
                        "id": 133606,
                        "name": "Ranchi",
                        "latitude": "23.34316000",
                        "longitude": "85.30940000"
                    },
                    {
                        "id": 133727,
                        "name": "Ray",
                        "latitude": "23.68430000",
                        "longitude": "85.05457000"
                    },
                    {
                        "id": 133752,
                        "name": "Sahibganj",
                        "latitude": "24.99354000",
                        "longitude": "87.67333000"
                    },
                    {
                        "id": 133800,
                        "name": "Saraikela",
                        "latitude": "22.69963000",
                        "longitude": "85.93126000"
                    },
                    {
                        "id": 134079,
                        "name": "Sarubera",
                        "latitude": "23.81813000",
                        "longitude": "85.99628000"
                    },
                    {
                        "id": 133927,
                        "name": "Sijua",
                        "latitude": "23.77617000",
                        "longitude": "86.33028000"
                    },
                    {
                        "id": 133939,
                        "name": "Simdega",
                        "latitude": "22.61523000",
                        "longitude": "84.50208000"
                    },
                    {
                        "id": 133952,
                        "name": "Sini",
                        "latitude": "22.79325000",
                        "longitude": "85.94543000"
                    },
                    {
                        "id": 134209,
                        "name": "Topchanchi",
                        "latitude": "23.90381000",
                        "longitude": "86.19792000"
                    }
                ]
            },
            {
                "id": 4026,
                "name": "Karnataka",
                "iso2": "KA",
                "latitude": "15.31727750",
                "longitude": "75.71388840",
                "type": "state",
                "cities": [
                    {
                        "id": 57598,
                        "name": "Afzalpur",
                        "latitude": "17.19986000",
                        "longitude": "76.36018000"
                    },
                    {
                        "id": 57613,
                        "name": "Ajjampur",
                        "latitude": "13.72794000",
                        "longitude": "76.00680000"
                    },
                    {
                        "id": 57632,
                        "name": "Aland",
                        "latitude": "17.56425000",
                        "longitude": "76.56854000"
                    },
                    {
                        "id": 57644,
                        "name": "Alnavar",
                        "latitude": "15.42727000",
                        "longitude": "74.74111000"
                    },
                    {
                        "id": 57656,
                        "name": "Alur",
                        "latitude": "12.97805000",
                        "longitude": "75.99094000"
                    },
                    {
                        "id": 57702,
                        "name": "Anekal",
                        "latitude": "12.71110000",
                        "longitude": "77.69557000"
                    },
                    {
                        "id": 57711,
                        "name": "Ankola",
                        "latitude": "14.66049000",
                        "longitude": "74.30470000"
                    },
                    {
                        "id": 57713,
                        "name": "Annigeri",
                        "latitude": "15.42513000",
                        "longitude": "75.43350000"
                    },
                    {
                        "id": 57735,
                        "name": "Arkalgud",
                        "latitude": "12.76171000",
                        "longitude": "76.06035000"
                    },
                    {
                        "id": 57740,
                        "name": "Arsikere",
                        "latitude": "13.31446000",
                        "longitude": "76.25704000"
                    },
                    {
                        "id": 57757,
                        "name": "Athni",
                        "latitude": "16.72613000",
                        "longitude": "75.06421000"
                    },
                    {
                        "id": 57768,
                        "name": "Aurad",
                        "latitude": "18.25397000",
                        "longitude": "77.41761000"
                    },
                    {
                        "id": 58105,
                        "name": "Badami",
                        "latitude": "15.91495000",
                        "longitude": "75.67683000"
                    },
                    {
                        "id": 57797,
                        "name": "Bagalkot",
                        "latitude": "16.18000000",
                        "longitude": "75.69000000"
                    },
                    {
                        "id": 58107,
                        "name": "Bagepalli",
                        "latitude": "13.78338000",
                        "longitude": "77.79667000"
                    },
                    {
                        "id": 57814,
                        "name": "Bail-Hongal",
                        "latitude": "15.81370000",
                        "longitude": "74.85895000"
                    },
                    {
                        "id": 57827,
                        "name": "Ballari",
                        "latitude": "15.15000000",
                        "longitude": "76.55000000"
                    },
                    {
                        "id": 58136,
                        "name": "Banavar",
                        "latitude": "13.41029000",
                        "longitude": "76.16314000"
                    },
                    {
                        "id": 57851,
                        "name": "Bangarapet",
                        "latitude": "12.99116000",
                        "longitude": "78.17804000"
                    },
                    {
                        "id": 57856,
                        "name": "Bannur",
                        "latitude": "12.33295000",
                        "longitude": "76.86201000"
                    },
                    {
                        "id": 57857,
                        "name": "Bantval",
                        "latitude": "12.89050000",
                        "longitude": "75.03489000"
                    },
                    {
                        "id": 57893,
                        "name": "Basavakalyan",
                        "latitude": "17.87445000",
                        "longitude": "76.94972000"
                    },
                    {
                        "id": 57894,
                        "name": "Basavana Bagevadi",
                        "latitude": "16.57278000",
                        "longitude": "75.97252000"
                    },
                    {
                        "id": 57922,
                        "name": "Belagavi",
                        "latitude": "16.33333000",
                        "longitude": "74.75000000"
                    },
                    {
                        "id": 57925,
                        "name": "Belluru",
                        "latitude": "12.98140000",
                        "longitude": "76.73308000"
                    },
                    {
                        "id": 57928,
                        "name": "Beltangadi",
                        "latitude": "13.98333000",
                        "longitude": "75.30000000"
                    },
                    {
                        "id": 57930,
                        "name": "Belur",
                        "latitude": "13.16558000",
                        "longitude": "75.86519000"
                    },
                    {
                        "id": 57933,
                        "name": "Bengaluru",
                        "latitude": "12.97194000",
                        "longitude": "77.59369000"
                    },
                    {
                        "id": 57847,
                        "name": "Bengaluru Rural",
                        "latitude": "13.22567000",
                        "longitude": "77.57501000"
                    },
                    {
                        "id": 57848,
                        "name": "Bengaluru Urban",
                        "latitude": "13.00000000",
                        "longitude": "77.58333000"
                    },
                    {
                        "id": 57956,
                        "name": "Bhadravati",
                        "latitude": "13.84846000",
                        "longitude": "75.70502000"
                    },
                    {
                        "id": 58010,
                        "name": "Bhalki",
                        "latitude": "18.04348000",
                        "longitude": "77.20600000"
                    },
                    {
                        "id": 57970,
                        "name": "Bhatkal",
                        "latitude": "13.98534000",
                        "longitude": "74.55531000"
                    },
                    {
                        "id": 58154,
                        "name": "Bidar",
                        "latitude": "18.08333000",
                        "longitude": "77.33333000"
                    },
                    {
                        "id": 58042,
                        "name": "Bilgi",
                        "latitude": "16.34714000",
                        "longitude": "75.61804000"
                    },
                    {
                        "id": 58061,
                        "name": "Birur",
                        "latitude": "13.59723000",
                        "longitude": "75.97167000"
                    },
                    {
                        "id": 58102,
                        "name": "Byadgi",
                        "latitude": "14.67325000",
                        "longitude": "75.48680000"
                    },
                    {
                        "id": 58101,
                        "name": "Byndoor",
                        "latitude": "13.86667000",
                        "longitude": "74.63333000"
                    },
                    {
                        "id": 58166,
                        "name": "Canacona",
                        "latitude": "14.99590000",
                        "longitude": "74.05056000"
                    },
                    {
                        "id": 58178,
                        "name": "Challakere",
                        "latitude": "14.31800000",
                        "longitude": "76.65165000"
                    },
                    {
                        "id": 58185,
                        "name": "Chamrajnagar",
                        "latitude": "11.96000000",
                        "longitude": "77.09000000"
                    },
                    {
                        "id": 58197,
                        "name": "Channagiri",
                        "latitude": "14.02399000",
                        "longitude": "75.92577000"
                    },
                    {
                        "id": 58198,
                        "name": "Channapatna",
                        "latitude": "12.65143000",
                        "longitude": "77.20672000"
                    },
                    {
                        "id": 58199,
                        "name": "Channarayapatna",
                        "latitude": "12.90642000",
                        "longitude": "76.38775000"
                    },
                    {
                        "id": 131547,
                        "name": "Chik Ballapur",
                        "latitude": "13.43512000",
                        "longitude": "77.72787000"
                    },
                    {
                        "id": 131551,
                        "name": "Chikkaballapur",
                        "latitude": "13.55000000",
                        "longitude": "77.87000000"
                    },
                    {
                        "id": 131552,
                        "name": "Chikkamagaluru",
                        "latitude": "13.49000000",
                        "longitude": "75.73000000"
                    },
                    {
                        "id": 131554,
                        "name": "Chiknayakanhalli",
                        "latitude": "13.41609000",
                        "longitude": "76.62063000"
                    },
                    {
                        "id": 131555,
                        "name": "Chikodi",
                        "latitude": "16.42898000",
                        "longitude": "74.58591000"
                    },
                    {
                        "id": 131560,
                        "name": "Chincholi",
                        "latitude": "17.46508000",
                        "longitude": "77.41874000"
                    },
                    {
                        "id": 131566,
                        "name": "Chintamani",
                        "latitude": "13.40051000",
                        "longitude": "78.05172000"
                    },
                    {
                        "id": 131613,
                        "name": "Chitapur",
                        "latitude": "17.12357000",
                        "longitude": "77.08240000"
                    },
                    {
                        "id": 131571,
                        "name": "Chitradurga",
                        "latitude": "14.20000000",
                        "longitude": "76.50000000"
                    },
                    {
                        "id": 131616,
                        "name": "Closepet",
                        "latitude": "12.72181000",
                        "longitude": "77.28149000"
                    },
                    {
                        "id": 131624,
                        "name": "Coondapoor",
                        "latitude": "13.63126000",
                        "longitude": "74.69020000"
                    },
                    {
                        "id": 131644,
                        "name": "Dakshina Kannada",
                        "latitude": "12.84000000",
                        "longitude": "75.29000000"
                    },
                    {
                        "id": 131652,
                        "name": "Dandeli",
                        "latitude": "15.26667000",
                        "longitude": "74.61667000"
                    },
                    {
                        "id": 131670,
                        "name": "Davanagere",
                        "latitude": "14.43000000",
                        "longitude": "75.90000000"
                    },
                    {
                        "id": 131701,
                        "name": "Devanhalli",
                        "latitude": "13.24655000",
                        "longitude": "77.71183000"
                    },
                    {
                        "id": 131729,
                        "name": "Dharwad",
                        "latitude": "15.37000000",
                        "longitude": "75.14000000"
                    },
                    {
                        "id": 131780,
                        "name": "Dod Ballapur",
                        "latitude": "13.29452000",
                        "longitude": "77.53777000"
                    },
                    {
                        "id": 131879,
                        "name": "French Rocks",
                        "latitude": "12.50094000",
                        "longitude": "76.67416000"
                    },
                    {
                        "id": 131884,
                        "name": "Gadag",
                        "latitude": "15.49835000",
                        "longitude": "75.65187000"
                    },
                    {
                        "id": 131885,
                        "name": "Gadag-Betageri",
                        "latitude": "15.41670000",
                        "longitude": "75.61670000"
                    },
                    {
                        "id": 131893,
                        "name": "Gajendragarh",
                        "latitude": "15.73628000",
                        "longitude": "75.96976000"
                    },
                    {
                        "id": 131911,
                        "name": "Gangawati",
                        "latitude": "15.43130000",
                        "longitude": "76.52933000"
                    },
                    {
                        "id": 131904,
                        "name": "Gangolli",
                        "latitude": "13.65024000",
                        "longitude": "74.67072000"
                    },
                    {
                        "id": 131970,
                        "name": "Gokak",
                        "latitude": "16.16901000",
                        "longitude": "74.82393000"
                    },
                    {
                        "id": 131971,
                        "name": "Gokarna",
                        "latitude": "14.55000000",
                        "longitude": "74.31667000"
                    },
                    {
                        "id": 131995,
                        "name": "Goribidnur",
                        "latitude": "13.61072000",
                        "longitude": "77.51738000"
                    },
                    {
                        "id": 131996,
                        "name": "Gorur",
                        "latitude": "12.82297000",
                        "longitude": "76.06463000"
                    },
                    {
                        "id": 132007,
                        "name": "Gubbi",
                        "latitude": "13.31216000",
                        "longitude": "76.94102000"
                    },
                    {
                        "id": 132009,
                        "name": "Gudibanda",
                        "latitude": "13.67099000",
                        "longitude": "77.70414000"
                    },
                    {
                        "id": 132017,
                        "name": "Guledagudda",
                        "latitude": "16.05025000",
                        "longitude": "75.78997000"
                    },
                    {
                        "id": 132025,
                        "name": "Gundlupet",
                        "latitude": "11.81004000",
                        "longitude": "76.69027000"
                    },
                    {
                        "id": 132034,
                        "name": "Gurmatkal",
                        "latitude": "16.86773000",
                        "longitude": "77.39088000"
                    },
                    {
                        "id": 132053,
                        "name": "Hadagalli",
                        "latitude": "15.02048000",
                        "longitude": "75.93185000"
                    },
                    {
                        "id": 132059,
                        "name": "Haliyal",
                        "latitude": "15.32864000",
                        "longitude": "74.75638000"
                    },
                    {
                        "id": 132061,
                        "name": "Hampi",
                        "latitude": "15.33520000",
                        "longitude": "76.46030000"
                    },
                    {
                        "id": 132140,
                        "name": "Hangal",
                        "latitude": "14.76465000",
                        "longitude": "75.12460000"
                    },
                    {
                        "id": 132076,
                        "name": "Harihar",
                        "latitude": "14.51288000",
                        "longitude": "75.80716000"
                    },
                    {
                        "id": 132079,
                        "name": "Harpanahalli",
                        "latitude": "14.78766000",
                        "longitude": "75.98863000"
                    },
                    {
                        "id": 132086,
                        "name": "Hassan",
                        "latitude": "12.95000000",
                        "longitude": "76.08333000"
                    },
                    {
                        "id": 132089,
                        "name": "Haveri",
                        "latitude": "14.73732000",
                        "longitude": "75.41062000"
                    },
                    {
                        "id": 132093,
                        "name": "Heggadadevankote",
                        "latitude": "12.08809000",
                        "longitude": "76.32957000"
                    },
                    {
                        "id": 132103,
                        "name": "Hirekerur",
                        "latitude": "14.45506000",
                        "longitude": "75.39520000"
                    },
                    {
                        "id": 132104,
                        "name": "Hiriyur",
                        "latitude": "13.94455000",
                        "longitude": "76.61723000"
                    },
                    {
                        "id": 132111,
                        "name": "Holalkere",
                        "latitude": "14.04295000",
                        "longitude": "76.18496000"
                    },
                    {
                        "id": 132112,
                        "name": "Hole Narsipur",
                        "latitude": "12.78635000",
                        "longitude": "76.24331000"
                    },
                    {
                        "id": 132113,
                        "name": "Homnabad",
                        "latitude": "17.77074000",
                        "longitude": "77.12519000"
                    },
                    {
                        "id": 132115,
                        "name": "Honavar",
                        "latitude": "14.28088000",
                        "longitude": "74.44497000"
                    },
                    {
                        "id": 132114,
                        "name": "Honnali",
                        "latitude": "14.23976000",
                        "longitude": "75.64507000"
                    },
                    {
                        "id": 132117,
                        "name": "Hosanagara",
                        "latitude": "13.91387000",
                        "longitude": "75.06503000"
                    },
                    {
                        "id": 132118,
                        "name": "Hosangadi",
                        "latitude": "13.69756000",
                        "longitude": "74.95427000"
                    },
                    {
                        "id": 132119,
                        "name": "Hosdurga",
                        "latitude": "13.79631000",
                        "longitude": "76.28408000"
                    },
                    {
                        "id": 132123,
                        "name": "Hoskote",
                        "latitude": "13.07070000",
                        "longitude": "77.79814000"
                    },
                    {
                        "id": 132124,
                        "name": "Hospet",
                        "latitude": "15.26954000",
                        "longitude": "76.38710000"
                    },
                    {
                        "id": 132127,
                        "name": "Hubballi",
                        "latitude": "15.34776000",
                        "longitude": "75.13378000"
                    },
                    {
                        "id": 132128,
                        "name": "Hukeri",
                        "latitude": "16.23082000",
                        "longitude": "74.60244000"
                    },
                    {
                        "id": 132129,
                        "name": "Hungund",
                        "latitude": "16.06213000",
                        "longitude": "76.05860000"
                    },
                    {
                        "id": 132130,
                        "name": "Hunsur",
                        "latitude": "12.30359000",
                        "longitude": "76.29275000"
                    },
                    {
                        "id": 132160,
                        "name": "Ilkal",
                        "latitude": "15.95923000",
                        "longitude": "76.11351000"
                    },
                    {
                        "id": 132165,
                        "name": "Indi",
                        "latitude": "17.17735000",
                        "longitude": "75.95260000"
                    },
                    {
                        "id": 132182,
                        "name": "Jagalur",
                        "latitude": "14.51957000",
                        "longitude": "76.33915000"
                    },
                    {
                        "id": 132227,
                        "name": "Jamkhandi",
                        "latitude": "16.50461000",
                        "longitude": "75.29146000"
                    },
                    {
                        "id": 132263,
                        "name": "Jevargi",
                        "latitude": "17.01394000",
                        "longitude": "76.77317000"
                    },
                    {
                        "id": 132330,
                        "name": "Kadur",
                        "latitude": "13.55285000",
                        "longitude": "76.01164000"
                    },
                    {
                        "id": 132016,
                        "name": "Kalaburgi",
                        "latitude": "17.16667000",
                        "longitude": "77.08333000"
                    },
                    {
                        "id": 132351,
                        "name": "Kalghatgi",
                        "latitude": "15.18315000",
                        "longitude": "74.97099000"
                    },
                    {
                        "id": 132365,
                        "name": "Kampli",
                        "latitude": "15.40626000",
                        "longitude": "76.60013000"
                    },
                    {
                        "id": 132706,
                        "name": "Kankanhalli",
                        "latitude": "12.54654000",
                        "longitude": "77.42005000"
                    },
                    {
                        "id": 132719,
                        "name": "Karkala",
                        "latitude": "13.21428000",
                        "longitude": "74.99234000"
                    },
                    {
                        "id": 132411,
                        "name": "Karwar",
                        "latitude": "14.81361000",
                        "longitude": "74.12972000"
                    },
                    {
                        "id": 132431,
                        "name": "Kavalur",
                        "latitude": "15.28829000",
                        "longitude": "75.94330000"
                    },
                    {
                        "id": 132445,
                        "name": "Kerur",
                        "latitude": "16.01384000",
                        "longitude": "75.54631000"
                    },
                    {
                        "id": 132516,
                        "name": "Khanapur",
                        "latitude": "15.63969000",
                        "longitude": "74.50847000"
                    },
                    {
                        "id": 132537,
                        "name": "Kodagu",
                        "latitude": "12.41667000",
                        "longitude": "75.75000000"
                    },
                    {
                        "id": 132541,
                        "name": "Kodigenahalli",
                        "latitude": "13.72136000",
                        "longitude": "77.38629000"
                    },
                    {
                        "id": 132542,
                        "name": "Kodlipet",
                        "latitude": "12.80087000",
                        "longitude": "75.88662000"
                    },
                    {
                        "id": 132553,
                        "name": "Kolar",
                        "latitude": "13.13000000",
                        "longitude": "78.23000000"
                    },
                    {
                        "id": 132559,
                        "name": "Kollegal",
                        "latitude": "12.15449000",
                        "longitude": "77.11051000"
                    },
                    {
                        "id": 132563,
                        "name": "Konanur",
                        "latitude": "12.63016000",
                        "longitude": "76.05037000"
                    },
                    {
                        "id": 132569,
                        "name": "Konnur",
                        "latitude": "16.20138000",
                        "longitude": "74.74886000"
                    },
                    {
                        "id": 132573,
                        "name": "Koppa",
                        "latitude": "13.53044000",
                        "longitude": "75.36329000"
                    },
                    {
                        "id": 132574,
                        "name": "Koppal",
                        "latitude": "15.50000000",
                        "longitude": "76.20000000"
                    },
                    {
                        "id": 132579,
                        "name": "Koratagere",
                        "latitude": "13.52200000",
                        "longitude": "77.23730000"
                    },
                    {
                        "id": 132610,
                        "name": "Kotturu",
                        "latitude": "14.82442000",
                        "longitude": "76.22005000"
                    },
                    {
                        "id": 132623,
                        "name": "Krishnarajpet",
                        "latitude": "12.66621000",
                        "longitude": "76.48770000"
                    },
                    {
                        "id": 132628,
                        "name": "Kudachi",
                        "latitude": "16.62784000",
                        "longitude": "74.85408000"
                    },
                    {
                        "id": 132736,
                        "name": "Kudligi",
                        "latitude": "14.90500000",
                        "longitude": "76.38527000"
                    },
                    {
                        "id": 132642,
                        "name": "Kumsi",
                        "latitude": "14.05455000",
                        "longitude": "75.39992000"
                    },
                    {
                        "id": 132643,
                        "name": "Kumta",
                        "latitude": "14.42853000",
                        "longitude": "74.41890000"
                    },
                    {
                        "id": 132646,
                        "name": "Kundgol",
                        "latitude": "15.25612000",
                        "longitude": "75.24735000"
                    },
                    {
                        "id": 132648,
                        "name": "Kunigal",
                        "latitude": "13.02319000",
                        "longitude": "77.02518000"
                    },
                    {
                        "id": 132658,
                        "name": "Kurgunta",
                        "latitude": "17.19321000",
                        "longitude": "77.35772000"
                    },
                    {
                        "id": 132668,
                        "name": "Kushalnagar",
                        "latitude": "12.45795000",
                        "longitude": "75.95904000"
                    },
                    {
                        "id": 132666,
                        "name": "Kushtagi",
                        "latitude": "15.75623000",
                        "longitude": "76.19112000"
                    },
                    {
                        "id": 132752,
                        "name": "Lakshmeshwar",
                        "latitude": "15.12689000",
                        "longitude": "75.46935000"
                    },
                    {
                        "id": 132765,
                        "name": "Lingsugur",
                        "latitude": "16.15876000",
                        "longitude": "76.52174000"
                    },
                    {
                        "id": 132774,
                        "name": "Londa",
                        "latitude": "15.46907000",
                        "longitude": "74.51906000"
                    },
                    {
                        "id": 132809,
                        "name": "Maddagiri",
                        "latitude": "13.66035000",
                        "longitude": "77.21239000"
                    },
                    {
                        "id": 132810,
                        "name": "Maddur",
                        "latitude": "12.58283000",
                        "longitude": "77.04294000"
                    },
                    {
                        "id": 132817,
                        "name": "Madikeri",
                        "latitude": "12.42602000",
                        "longitude": "75.73820000"
                    },
                    {
                        "id": 133060,
                        "name": "Magadi",
                        "latitude": "12.95706000",
                        "longitude": "77.22374000"
                    },
                    {
                        "id": 132847,
                        "name": "Mahalingpur",
                        "latitude": "16.38880000",
                        "longitude": "75.10873000"
                    },
                    {
                        "id": 132868,
                        "name": "Malavalli",
                        "latitude": "12.38556000",
                        "longitude": "77.06045000"
                    },
                    {
                        "id": 132877,
                        "name": "Malpe",
                        "latitude": "13.34962000",
                        "longitude": "74.70394000"
                    },
                    {
                        "id": 133071,
                        "name": "Malur",
                        "latitude": "13.00322000",
                        "longitude": "77.93798000"
                    },
                    {
                        "id": 132898,
                        "name": "Mandya",
                        "latitude": "12.52230000",
                        "longitude": "76.89746000"
                    },
                    {
                        "id": 132905,
                        "name": "Mangaluru",
                        "latitude": "12.91723000",
                        "longitude": "74.85603000"
                    },
                    {
                        "id": 132912,
                        "name": "Manipal",
                        "latitude": "13.35000000",
                        "longitude": "74.78333000"
                    },
                    {
                        "id": 133083,
                        "name": "Manvi",
                        "latitude": "15.99126000",
                        "longitude": "77.05034000"
                    },
                    {
                        "id": 133093,
                        "name": "Mayakonda",
                        "latitude": "14.28894000",
                        "longitude": "76.08305000"
                    },
                    {
                        "id": 132964,
                        "name": "Melukote",
                        "latitude": "12.66258000",
                        "longitude": "76.64861000"
                    },
                    {
                        "id": 133098,
                        "name": "Mudbidri",
                        "latitude": "13.06653000",
                        "longitude": "74.99525000"
                    },
                    {
                        "id": 133008,
                        "name": "Muddebihal",
                        "latitude": "16.33782000",
                        "longitude": "76.13173000"
                    },
                    {
                        "id": 133009,
                        "name": "Mudgal",
                        "latitude": "16.01191000",
                        "longitude": "76.44203000"
                    },
                    {
                        "id": 133010,
                        "name": "Mudgere",
                        "latitude": "13.13353000",
                        "longitude": "75.64160000"
                    },
                    {
                        "id": 133011,
                        "name": "Mudhol",
                        "latitude": "16.33354000",
                        "longitude": "75.28305000"
                    },
                    {
                        "id": 133020,
                        "name": "Mulbagal",
                        "latitude": "13.16352000",
                        "longitude": "78.39346000"
                    },
                    {
                        "id": 133021,
                        "name": "Mulgund",
                        "latitude": "15.28070000",
                        "longitude": "75.52132000"
                    },
                    {
                        "id": 133101,
                        "name": "Mulki",
                        "latitude": "13.09101000",
                        "longitude": "74.79353000"
                    },
                    {
                        "id": 133026,
                        "name": "Mundargi",
                        "latitude": "15.20677000",
                        "longitude": "75.88390000"
                    },
                    {
                        "id": 133027,
                        "name": "Mundgod",
                        "latitude": "14.97144000",
                        "longitude": "75.03658000"
                    },
                    {
                        "id": 133033,
                        "name": "Munirabad",
                        "latitude": "15.30928000",
                        "longitude": "76.33830000"
                    },
                    {
                        "id": 133041,
                        "name": "Murudeshwara",
                        "latitude": "14.09430000",
                        "longitude": "74.48450000"
                    },
                    {
                        "id": 133053,
                        "name": "Mysuru",
                        "latitude": "12.23000000",
                        "longitude": "76.42000000"
                    },
                    {
                        "id": 133254,
                        "name": "Nagamangala",
                        "latitude": "12.81939000",
                        "longitude": "76.75456000"
                    },
                    {
                        "id": 133151,
                        "name": "Nanjangud",
                        "latitude": "12.11764000",
                        "longitude": "76.68397000"
                    },
                    {
                        "id": 133159,
                        "name": "Narasimharajapura",
                        "latitude": "13.61075000",
                        "longitude": "75.51200000"
                    },
                    {
                        "id": 133164,
                        "name": "Naregal",
                        "latitude": "15.57316000",
                        "longitude": "75.80805000"
                    },
                    {
                        "id": 133167,
                        "name": "Nargund",
                        "latitude": "15.72299000",
                        "longitude": "75.38666000"
                    },
                    {
                        "id": 133184,
                        "name": "Navalgund",
                        "latitude": "15.55877000",
                        "longitude": "75.35305000"
                    },
                    {
                        "id": 133204,
                        "name": "Nelamangala",
                        "latitude": "13.09978000",
                        "longitude": "77.39364000"
                    },
                    {
                        "id": 133249,
                        "name": "Nyamti",
                        "latitude": "14.14869000",
                        "longitude": "75.57641000"
                    },
                    {
                        "id": 133541,
                        "name": "Pangala",
                        "latitude": "13.25000000",
                        "longitude": "74.75000000"
                    },
                    {
                        "id": 133560,
                        "name": "Pavugada",
                        "latitude": "14.09953000",
                        "longitude": "77.28018000"
                    },
                    {
                        "id": 133458,
                        "name": "Piriyapatna",
                        "latitude": "12.33497000",
                        "longitude": "76.10073000"
                    },
                    {
                        "id": 133474,
                        "name": "Ponnampet",
                        "latitude": "12.14473000",
                        "longitude": "75.94514000"
                    },
                    {
                        "id": 133518,
                        "name": "Puttur",
                        "latitude": "12.75975000",
                        "longitude": "75.20169000"
                    },
                    {
                        "id": 133577,
                        "name": "Rabkavi",
                        "latitude": "16.47567000",
                        "longitude": "75.11060000"
                    },
                    {
                        "id": 133586,
                        "name": "Raichur",
                        "latitude": "16.16000000",
                        "longitude": "76.91000000"
                    },
                    {
                        "id": 133598,
                        "name": "Ramanagara",
                        "latitude": "12.65000000",
                        "longitude": "77.35000000"
                    },
                    {
                        "id": 133719,
                        "name": "Ranibennur",
                        "latitude": "14.62239000",
                        "longitude": "75.62951000"
                    },
                    {
                        "id": 133731,
                        "name": "Raybag",
                        "latitude": "16.49178000",
                        "longitude": "74.77391000"
                    },
                    {
                        "id": 133642,
                        "name": "Robertsonpet",
                        "latitude": "12.95629000",
                        "longitude": "78.27539000"
                    },
                    {
                        "id": 133649,
                        "name": "Ron",
                        "latitude": "15.69935000",
                        "longitude": "75.73408000"
                    },
                    {
                        "id": 133743,
                        "name": "Sadalgi",
                        "latitude": "16.55870000",
                        "longitude": "74.53211000"
                    },
                    {
                        "id": 134060,
                        "name": "Sagar",
                        "latitude": "14.16498000",
                        "longitude": "75.02901000"
                    },
                    {
                        "id": 133760,
                        "name": "Sakleshpur",
                        "latitude": "12.94119000",
                        "longitude": "75.78467000"
                    },
                    {
                        "id": 133779,
                        "name": "Sandur",
                        "latitude": "15.08613000",
                        "longitude": "76.54692000"
                    },
                    {
                        "id": 133788,
                        "name": "Sanivarsante",
                        "latitude": "12.72824000",
                        "longitude": "75.88669000"
                    },
                    {
                        "id": 133789,
                        "name": "Sankeshwar",
                        "latitude": "16.25649000",
                        "longitude": "74.48195000"
                    },
                    {
                        "id": 133806,
                        "name": "Sargur",
                        "latitude": "11.99971000",
                        "longitude": "76.39611000"
                    },
                    {
                        "id": 133827,
                        "name": "Saundatti",
                        "latitude": "15.76615000",
                        "longitude": "75.11778000"
                    },
                    {
                        "id": 133830,
                        "name": "Savanur",
                        "latitude": "14.97335000",
                        "longitude": "75.33724000"
                    },
                    {
                        "id": 133846,
                        "name": "Seram",
                        "latitude": "17.17859000",
                        "longitude": "77.28998000"
                    },
                    {
                        "id": 133907,
                        "name": "Shahabad",
                        "latitude": "17.13070000",
                        "longitude": "76.94361000"
                    },
                    {
                        "id": 133898,
                        "name": "Shahpur",
                        "latitude": "16.69605000",
                        "longitude": "76.84220000"
                    },
                    {
                        "id": 133866,
                        "name": "Shiggaon",
                        "latitude": "14.99053000",
                        "longitude": "75.22499000"
                    },
                    {
                        "id": 133868,
                        "name": "Shikarpur",
                        "latitude": "14.26980000",
                        "longitude": "75.35643000"
                    },
                    {
                        "id": 133872,
                        "name": "Shimoga",
                        "latitude": "14.05000000",
                        "longitude": "75.16000000"
                    },
                    {
                        "id": 133876,
                        "name": "Shirhatti",
                        "latitude": "15.23352000",
                        "longitude": "75.57996000"
                    },
                    {
                        "id": 133884,
                        "name": "Shorapur",
                        "latitude": "16.52100000",
                        "longitude": "76.75738000"
                    },
                    {
                        "id": 133887,
                        "name": "Shrirangapattana",
                        "latitude": "12.42264000",
                        "longitude": "76.68439000"
                    },
                    {
                        "id": 133920,
                        "name": "Siddapur",
                        "latitude": "14.34322000",
                        "longitude": "74.89400000"
                    },
                    {
                        "id": 133924,
                        "name": "Sidlaghatta",
                        "latitude": "13.38896000",
                        "longitude": "77.86444000"
                    },
                    {
                        "id": 133941,
                        "name": "Sindgi",
                        "latitude": "16.91883000",
                        "longitude": "76.23368000"
                    },
                    {
                        "id": 133942,
                        "name": "Sindhnur",
                        "latitude": "15.76983000",
                        "longitude": "76.75581000"
                    },
                    {
                        "id": 134087,
                        "name": "Sira",
                        "latitude": "13.74155000",
                        "longitude": "76.90430000"
                    },
                    {
                        "id": 133962,
                        "name": "Sirsi",
                        "latitude": "14.62072000",
                        "longitude": "74.83554000"
                    },
                    {
                        "id": 133967,
                        "name": "Siruguppa",
                        "latitude": "15.63000000",
                        "longitude": "76.89217000"
                    },
                    {
                        "id": 133989,
                        "name": "Someshwar",
                        "latitude": "13.49112000",
                        "longitude": "75.06646000"
                    },
                    {
                        "id": 133991,
                        "name": "Somvarpet",
                        "latitude": "12.59698000",
                        "longitude": "75.84957000"
                    },
                    {
                        "id": 134001,
                        "name": "Sorab",
                        "latitude": "14.38144000",
                        "longitude": "75.09183000"
                    },
                    {
                        "id": 134024,
                        "name": "Sravana Belgola",
                        "latitude": "12.85737000",
                        "longitude": "76.48886000"
                    },
                    {
                        "id": 134021,
                        "name": "Sringeri",
                        "latitude": "13.41698000",
                        "longitude": "75.25271000"
                    },
                    {
                        "id": 134029,
                        "name": "Srinivaspur",
                        "latitude": "13.33914000",
                        "longitude": "78.21175000"
                    },
                    {
                        "id": 134042,
                        "name": "Sulya",
                        "latitude": "12.56100000",
                        "longitude": "75.38741000"
                    },
                    {
                        "id": 134047,
                        "name": "Suntikoppa",
                        "latitude": "12.45594000",
                        "longitude": "75.82970000"
                    },
                    {
                        "id": 134234,
                        "name": "Talikota",
                        "latitude": "16.47311000",
                        "longitude": "76.31085000"
                    },
                    {
                        "id": 134116,
                        "name": "Tarikere",
                        "latitude": "13.70954000",
                        "longitude": "75.81382000"
                    },
                    {
                        "id": 134125,
                        "name": "Tekkalakote",
                        "latitude": "15.53444000",
                        "longitude": "76.87703000"
                    },
                    {
                        "id": 134133,
                        "name": "Terdal",
                        "latitude": "16.49379000",
                        "longitude": "75.04667000"
                    },
                    {
                        "id": 134176,
                        "name": "Tiptur",
                        "latitude": "13.25630000",
                        "longitude": "76.47768000"
                    },
                    {
                        "id": 134247,
                        "name": "Tirthahalli",
                        "latitude": "13.68835000",
                        "longitude": "75.24548000"
                    },
                    {
                        "id": 134182,
                        "name": "Tirumakudal Narsipur",
                        "latitude": "12.21207000",
                        "longitude": "76.90180000"
                    },
                    {
                        "id": 134219,
                        "name": "Tumakuru",
                        "latitude": "13.50000000",
                        "longitude": "77.00000000"
                    },
                    {
                        "id": 134225,
                        "name": "Turuvekere",
                        "latitude": "13.16374000",
                        "longitude": "76.66641000"
                    },
                    {
                        "id": 134260,
                        "name": "Udupi",
                        "latitude": "13.50000000",
                        "longitude": "74.87000000"
                    },
                    {
                        "id": 134268,
                        "name": "Ullal",
                        "latitude": "12.80569000",
                        "longitude": "74.86058000"
                    },
                    {
                        "id": 134300,
                        "name": "Uttar Kannada",
                        "latitude": "14.88333000",
                        "longitude": "74.58333000"
                    },
                    {
                        "id": 134307,
                        "name": "Vadigenhalli",
                        "latitude": "13.29724000",
                        "longitude": "77.80184000"
                    },
                    {
                        "id": 58031,
                        "name": "Vijayapura",
                        "latitude": "16.82442000",
                        "longitude": "75.71537000"
                    },
                    {
                        "id": 134386,
                        "name": "Virarajendrapet",
                        "latitude": "12.19644000",
                        "longitude": "75.80512000"
                    },
                    {
                        "id": 134414,
                        "name": "Wadi",
                        "latitude": "17.05183000",
                        "longitude": "76.99048000"
                    },
                    {
                        "id": 134420,
                        "name": "Yadgir",
                        "latitude": "16.73000000",
                        "longitude": "76.94000000"
                    },
                    {
                        "id": 134429,
                        "name": "Yelahanka",
                        "latitude": "13.10073000",
                        "longitude": "77.59632000"
                    },
                    {
                        "id": 134430,
                        "name": "Yelandur",
                        "latitude": "12.04629000",
                        "longitude": "77.03034000"
                    },
                    {
                        "id": 134431,
                        "name": "Yelbarga",
                        "latitude": "15.61545000",
                        "longitude": "76.01184000"
                    },
                    {
                        "id": 134433,
                        "name": "Yellapur",
                        "latitude": "14.96370000",
                        "longitude": "74.70929000"
                    }
                ]
            },
            {
                "id": 4028,
                "name": "Kerala",
                "iso2": "KL",
                "latitude": "10.85051590",
                "longitude": "76.27108330",
                "type": "state",
                "cities": [
                    {
                        "id": 57596,
                        "name": "Adoor",
                        "latitude": "9.15595000",
                        "longitude": "76.73192000"
                    },
                    {
                        "id": 57637,
                        "name": "Alappuzha",
                        "latitude": "9.49004000",
                        "longitude": "76.32640000"
                    },
                    {
                        "id": 57647,
                        "name": "Aluva",
                        "latitude": "10.10764000",
                        "longitude": "76.35158000"
                    },
                    {
                        "id": 57650,
                        "name": "Alwaye",
                        "latitude": "10.10649000",
                        "longitude": "76.35484000"
                    },
                    {
                        "id": 57703,
                        "name": "Angamali",
                        "latitude": "10.19055000",
                        "longitude": "76.38789000"
                    },
                    {
                        "id": 57738,
                        "name": "Aroor",
                        "latitude": "9.86940000",
                        "longitude": "76.30498000"
                    },
                    {
                        "id": 57742,
                        "name": "Arukutti",
                        "latitude": "9.86667000",
                        "longitude": "76.35000000"
                    },
                    {
                        "id": 57762,
                        "name": "Attingal",
                        "latitude": "8.69609000",
                        "longitude": "76.81507000"
                    },
                    {
                        "id": 57772,
                        "name": "Avanoor",
                        "latitude": "10.60826000",
                        "longitude": "76.17620000"
                    },
                    {
                        "id": 57778,
                        "name": "Azhikkal",
                        "latitude": "11.91524000",
                        "longitude": "75.34761000"
                    },
                    {
                        "id": 57945,
                        "name": "Beypore",
                        "latitude": "11.17151000",
                        "longitude": "75.80611000"
                    },
                    {
                        "id": 58195,
                        "name": "Changanacheri",
                        "latitude": "9.44203000",
                        "longitude": "76.53604000"
                    },
                    {
                        "id": 131609,
                        "name": "Chelakara",
                        "latitude": "10.69289000",
                        "longitude": "76.34387000"
                    },
                    {
                        "id": 131516,
                        "name": "Chengannur",
                        "latitude": "9.31575000",
                        "longitude": "76.61513000"
                    },
                    {
                        "id": 131519,
                        "name": "Cherpulassery",
                        "latitude": "10.87655000",
                        "longitude": "76.30932000"
                    },
                    {
                        "id": 131521,
                        "name": "Cherthala",
                        "latitude": "9.68444000",
                        "longitude": "76.33558000"
                    },
                    {
                        "id": 131524,
                        "name": "Chetwayi",
                        "latitude": "10.52885000",
                        "longitude": "76.04793000"
                    },
                    {
                        "id": 131576,
                        "name": "Chittur",
                        "latitude": "10.69967000",
                        "longitude": "76.74710000"
                    },
                    {
                        "id": 131617,
                        "name": "Cochin",
                        "latitude": "9.93988000",
                        "longitude": "76.26022000"
                    },
                    {
                        "id": 131724,
                        "name": "Dharmadom",
                        "latitude": "11.77538000",
                        "longitude": "75.46459000"
                    },
                    {
                        "id": 131829,
                        "name": "Edakkulam",
                        "latitude": "10.61020000",
                        "longitude": "76.18352000"
                    },
                    {
                        "id": 131835,
                        "name": "Elur",
                        "latitude": "10.06667000",
                        "longitude": "76.28333000"
                    },
                    {
                        "id": 131844,
                        "name": "Erattupetta",
                        "latitude": "9.68747000",
                        "longitude": "76.77891000"
                    },
                    {
                        "id": 131840,
                        "name": "Ernakulam",
                        "latitude": "10.00000000",
                        "longitude": "76.50000000"
                    },
                    {
                        "id": 131874,
                        "name": "Ferokh",
                        "latitude": "11.17989000",
                        "longitude": "75.84141000"
                    },
                    {
                        "id": 132038,
                        "name": "Guruvayur",
                        "latitude": "10.59430000",
                        "longitude": "76.04110000"
                    },
                    {
                        "id": 132154,
                        "name": "Idukki",
                        "latitude": "10.00000000",
                        "longitude": "77.00000000"
                    },
                    {
                        "id": 132170,
                        "name": "Iringal",
                        "latitude": "11.55929000",
                        "longitude": "75.61663000"
                    },
                    {
                        "id": 132171,
                        "name": "Irinjalakuda",
                        "latitude": "10.34238000",
                        "longitude": "76.21124000"
                    },
                    {
                        "id": 132323,
                        "name": "Kadakkavoor",
                        "latitude": "8.67921000",
                        "longitude": "76.76714000"
                    },
                    {
                        "id": 132344,
                        "name": "Kalamassery",
                        "latitude": "10.06140000",
                        "longitude": "76.32631000"
                    },
                    {
                        "id": 132350,
                        "name": "Kalavoor",
                        "latitude": "9.57046000",
                        "longitude": "76.32756000"
                    },
                    {
                        "id": 132356,
                        "name": "Kalpetta",
                        "latitude": "11.60871000",
                        "longitude": "76.08343000"
                    },
                    {
                        "id": 132707,
                        "name": "Kanhangad",
                        "latitude": "12.30814000",
                        "longitude": "75.10632000"
                    },
                    {
                        "id": 132379,
                        "name": "Kannavam",
                        "latitude": "11.84450000",
                        "longitude": "75.66266000"
                    },
                    {
                        "id": 132383,
                        "name": "Kannur",
                        "latitude": "12.16667000",
                        "longitude": "75.33333000"
                    },
                    {
                        "id": 132720,
                        "name": "Kasaragod",
                        "latitude": "12.49838000",
                        "longitude": "74.98959000"
                    },
                    {
                        "id": 132428,
                        "name": "Kattanam",
                        "latitude": "9.17614000",
                        "longitude": "76.56325000"
                    },
                    {
                        "id": 132731,
                        "name": "Kayankulam",
                        "latitude": "9.18173000",
                        "longitude": "76.50093000"
                    },
                    {
                        "id": 132536,
                        "name": "Kizhake Chalakudi",
                        "latitude": "10.30067000",
                        "longitude": "76.33763000"
                    },
                    {
                        "id": 132545,
                        "name": "Kodungallur",
                        "latitude": "10.23263000",
                        "longitude": "76.19513000"
                    },
                    {
                        "id": 132558,
                        "name": "Kollam",
                        "latitude": "8.88113000",
                        "longitude": "76.58469000"
                    },
                    {
                        "id": 132595,
                        "name": "Kotamangalam",
                        "latitude": "10.06435000",
                        "longitude": "76.62843000"
                    },
                    {
                        "id": 132609,
                        "name": "Kottayam",
                        "latitude": "9.66667000",
                        "longitude": "76.66667000"
                    },
                    {
                        "id": 132614,
                        "name": "Kovalam",
                        "latitude": "8.36667000",
                        "longitude": "76.99667000"
                    },
                    {
                        "id": 132619,
                        "name": "Kozhikode",
                        "latitude": "11.50000000",
                        "longitude": "76.00000000"
                    },
                    {
                        "id": 132639,
                        "name": "Kumbalam",
                        "latitude": "9.90630000",
                        "longitude": "76.31127000"
                    },
                    {
                        "id": 132649,
                        "name": "Kunnamangalam",
                        "latitude": "11.30459000",
                        "longitude": "75.87772000"
                    },
                    {
                        "id": 132650,
                        "name": "Kunnamkulam",
                        "latitude": "10.64667000",
                        "longitude": "76.06695000"
                    },
                    {
                        "id": 132652,
                        "name": "Kunnumma",
                        "latitude": "9.35672000",
                        "longitude": "76.41343000"
                    },
                    {
                        "id": 132669,
                        "name": "Kutiatodu",
                        "latitude": "9.80000000",
                        "longitude": "76.33333000"
                    },
                    {
                        "id": 132671,
                        "name": "Kuttampuzha",
                        "latitude": "10.15033000",
                        "longitude": "76.73544000"
                    },
                    {
                        "id": 132794,
                        "name": "Lalam",
                        "latitude": "9.71667000",
                        "longitude": "76.70000000"
                    },
                    {
                        "id": 132852,
                        "name": "Mahe",
                        "latitude": "11.70172000",
                        "longitude": "75.53474000"
                    },
                    {
                        "id": 132866,
                        "name": "Malappuram",
                        "latitude": "11.00000000",
                        "longitude": "76.16667000"
                    },
                    {
                        "id": 132913,
                        "name": "Manjeri",
                        "latitude": "11.12018000",
                        "longitude": "76.11996000"
                    },
                    {
                        "id": 132915,
                        "name": "Manjeshwaram",
                        "latitude": "12.71287000",
                        "longitude": "74.88857000"
                    },
                    {
                        "id": 132920,
                        "name": "Mannarakkat",
                        "latitude": "10.99223000",
                        "longitude": "76.46418000"
                    },
                    {
                        "id": 132933,
                        "name": "Marayur",
                        "latitude": "10.27641000",
                        "longitude": "77.16205000"
                    },
                    {
                        "id": 132942,
                        "name": "Mattanur",
                        "latitude": "11.93018000",
                        "longitude": "75.57152000"
                    },
                    {
                        "id": 133092,
                        "name": "Mavelikara",
                        "latitude": "9.25929000",
                        "longitude": "76.55642000"
                    },
                    {
                        "id": 132950,
                        "name": "Mavoor",
                        "latitude": "11.26667000",
                        "longitude": "75.91667000"
                    },
                    {
                        "id": 133023,
                        "name": "Muluppilagadu",
                        "latitude": "11.79788000",
                        "longitude": "75.45111000"
                    },
                    {
                        "id": 133034,
                        "name": "Munnar",
                        "latitude": "10.08818000",
                        "longitude": "77.06239000"
                    },
                    {
                        "id": 133103,
                        "name": "Muvattupula",
                        "latitude": "9.98493000",
                        "longitude": "76.57728000"
                    },
                    {
                        "id": 133050,
                        "name": "Muvattupuzha",
                        "latitude": "9.97985000",
                        "longitude": "76.57381000"
                    },
                    {
                        "id": 133253,
                        "name": "Nadapuram",
                        "latitude": "11.68465000",
                        "longitude": "75.65493000"
                    },
                    {
                        "id": 133107,
                        "name": "Naduvannur",
                        "latitude": "11.48772000",
                        "longitude": "75.77511000"
                    },
                    {
                        "id": 133198,
                        "name": "Nedumangad",
                        "latitude": "8.60267000",
                        "longitude": "77.00139000"
                    },
                    {
                        "id": 133211,
                        "name": "Neyyattinkara",
                        "latitude": "8.39854000",
                        "longitude": "77.08586000"
                    },
                    {
                        "id": 133287,
                        "name": "Nileshwar",
                        "latitude": "12.25953000",
                        "longitude": "75.13520000"
                    },
                    {
                        "id": 133306,
                        "name": "Ottappalam",
                        "latitude": "10.77350000",
                        "longitude": "76.37758000"
                    },
                    {
                        "id": 133321,
                        "name": "Palackattumala",
                        "latitude": "9.74356000",
                        "longitude": "76.62940000"
                    },
                    {
                        "id": 133322,
                        "name": "Palakkad district",
                        "latitude": "10.77500000",
                        "longitude": "76.65100000"
                    },
                    {
                        "id": 133528,
                        "name": "Palghat",
                        "latitude": "10.77319000",
                        "longitude": "76.65366000"
                    },
                    {
                        "id": 133343,
                        "name": "Panamaram",
                        "latitude": "11.74014000",
                        "longitude": "76.07369000"
                    },
                    {
                        "id": 133546,
                        "name": "Pappinissheri",
                        "latitude": "11.95655000",
                        "longitude": "75.34034000"
                    },
                    {
                        "id": 133357,
                        "name": "Paravur Tekkumbhagam",
                        "latitude": "8.79470000",
                        "longitude": "76.66798000"
                    },
                    {
                        "id": 133359,
                        "name": "Pariyapuram",
                        "latitude": "11.01667000",
                        "longitude": "75.86667000"
                    },
                    {
                        "id": 133380,
                        "name": "Pathanamthitta",
                        "latitude": "9.26667000",
                        "longitude": "76.78333000"
                    },
                    {
                        "id": 133389,
                        "name": "Pattanamtitta",
                        "latitude": "9.28068000",
                        "longitude": "76.86967000"
                    },
                    {
                        "id": 133399,
                        "name": "Payyanur",
                        "latitude": "12.09350000",
                        "longitude": "75.20249000"
                    },
                    {
                        "id": 153628,
                        "name": "Perinthalmanna",
                        "latitude": "10.97768000",
                        "longitude": "76.22850800"
                    },
                    {
                        "id": 133423,
                        "name": "Perumbavoor",
                        "latitude": "10.10695000",
                        "longitude": "76.47366000"
                    },
                    {
                        "id": 133424,
                        "name": "Perumpavur",
                        "latitude": "10.11544000",
                        "longitude": "76.47611000"
                    },
                    {
                        "id": 133427,
                        "name": "Perya",
                        "latitude": "11.83334000",
                        "longitude": "75.85408000"
                    },
                    {
                        "id": 133457,
                        "name": "Piravam",
                        "latitude": "9.86667000",
                        "longitude": "76.50000000"
                    },
                    {
                        "id": 133472,
                        "name": "Ponmana",
                        "latitude": "9.00798000",
                        "longitude": "76.52023000"
                    },
                    {
                        "id": 133477,
                        "name": "Ponnani",
                        "latitude": "10.76695000",
                        "longitude": "75.92523000"
                    },
                    {
                        "id": 133502,
                        "name": "Punalur",
                        "latitude": "9.01956000",
                        "longitude": "76.92261000"
                    },
                    {
                        "id": 133692,
                        "name": "Ramamangalam",
                        "latitude": "9.93333000",
                        "longitude": "76.50000000"
                    },
                    {
                        "id": 133865,
                        "name": "Shertallai",
                        "latitude": "9.68581000",
                        "longitude": "76.33996000"
                    },
                    {
                        "id": 133915,
                        "name": "Shoranur",
                        "latitude": "10.76181000",
                        "longitude": "76.27078000"
                    },
                    {
                        "id": 134103,
                        "name": "Taliparamba",
                        "latitude": "12.04161000",
                        "longitude": "75.35927000"
                    },
                    {
                        "id": 134129,
                        "name": "Thalassery",
                        "latitude": "11.74811000",
                        "longitude": "75.49290000"
                    },
                    {
                        "id": 134142,
                        "name": "Thanniyam",
                        "latitude": "10.41667000",
                        "longitude": "76.13333000"
                    },
                    {
                        "id": 134154,
                        "name": "Thiruvananthapuram",
                        "latitude": "8.60399000",
                        "longitude": "76.98574000"
                    },
                    {
                        "id": 134161,
                        "name": "Thrissur",
                        "latitude": "10.51667000",
                        "longitude": "76.21667000"
                    },
                    {
                        "id": 134192,
                        "name": "Tirur",
                        "latitude": "10.91368000",
                        "longitude": "75.92118000"
                    },
                    {
                        "id": 134194,
                        "name": "Tiruvalla",
                        "latitude": "9.38160000",
                        "longitude": "76.57489000"
                    },
                    {
                        "id": 134313,
                        "name": "Vaikam",
                        "latitude": "9.74858000",
                        "longitude": "76.39637000"
                    },
                    {
                        "id": 134330,
                        "name": "Varkala",
                        "latitude": "8.73330000",
                        "longitude": "76.71670000"
                    },
                    {
                        "id": 57786,
                        "name": "Vatakara",
                        "latitude": "11.59776000",
                        "longitude": "75.58142000"
                    },
                    {
                        "id": 134336,
                        "name": "Vayalar",
                        "latitude": "9.71158000",
                        "longitude": "76.33888000"
                    },
                    {
                        "id": 134353,
                        "name": "Vettur",
                        "latitude": "8.71742000",
                        "longitude": "76.72582000"
                    },
                    {
                        "id": 134400,
                        "name": "Wayanad",
                        "latitude": "11.60500000",
                        "longitude": "76.08300000"
                    }
                ]
            },
            {
                "id": 4852,
                "name": "Ladakh",
                "iso2": "LA",
                "latitude": "34.22684750",
                "longitude": "77.56194190",
                "type": "union territory",
                "cities": [
                    {
                        "id": 132399,
                        "name": "Kargil",
                        "latitude": "34.55765000",
                        "longitude": "76.12622000"
                    },
                    {
                        "id": 132762,
                        "name": "Leh",
                        "latitude": "34.16504000",
                        "longitude": "77.58402000"
                    }
                ]
            },
            {
                "id": 4019,
                "name": "Lakshadweep",
                "iso2": "LD",
                "latitude": "10.32802650",
                "longitude": "72.78463360",
                "type": "union territory",
                "cities": [
                    {
                        "id": 132432,
                        "name": "Kavaratti",
                        "latitude": "10.56688000",
                        "longitude": "72.64203000"
                    },
                    {
                        "id": 132750,
                        "name": "Lakshadweep",
                        "latitude": "11.27333000",
                        "longitude": "74.04582000"
                    }
                ]
            },
            {
                "id": 4039,
                "name": "Madhya Pradesh",
                "iso2": "MP",
                "latitude": "22.97342290",
                "longitude": "78.65689420",
                "type": "state",
                "cities": [
                    {
                        "id": 57599,
                        "name": "Agar",
                        "latitude": "23.71177000",
                        "longitude": "76.01571000"
                    },
                    {
                        "id": 57611,
                        "name": "Ajaigarh",
                        "latitude": "24.89879000",
                        "longitude": "80.25921000"
                    },
                    {
                        "id": 57626,
                        "name": "Akodia",
                        "latitude": "23.38027000",
                        "longitude": "76.59875000"
                    },
                    {
                        "id": 57631,
                        "name": "Alampur",
                        "latitude": "26.02514000",
                        "longitude": "78.79697000"
                    },
                    {
                        "id": 57639,
                        "name": "Alirajpur",
                        "latitude": "22.31384000",
                        "longitude": "74.36452000"
                    },
                    {
                        "id": 57646,
                        "name": "Alot",
                        "latitude": "23.76336000",
                        "longitude": "75.55662000"
                    },
                    {
                        "id": 57691,
                        "name": "Amanganj",
                        "latitude": "24.42664000",
                        "longitude": "80.03579000"
                    },
                    {
                        "id": 57659,
                        "name": "Amarkantak",
                        "latitude": "22.67486000",
                        "longitude": "81.75908000"
                    },
                    {
                        "id": 57663,
                        "name": "Amarpatan",
                        "latitude": "24.31371000",
                        "longitude": "80.97703000"
                    },
                    {
                        "id": 57664,
                        "name": "Amarwara",
                        "latitude": "22.29780000",
                        "longitude": "79.16943000"
                    },
                    {
                        "id": 57673,
                        "name": "Ambah",
                        "latitude": "26.70423000",
                        "longitude": "78.22678000"
                    },
                    {
                        "id": 57680,
                        "name": "Amla",
                        "latitude": "21.92485000",
                        "longitude": "78.12786000"
                    },
                    {
                        "id": 57706,
                        "name": "Anjad",
                        "latitude": "22.04171000",
                        "longitude": "75.05519000"
                    },
                    {
                        "id": 57719,
                        "name": "Antri",
                        "latitude": "26.05804000",
                        "longitude": "78.21027000"
                    },
                    {
                        "id": 57721,
                        "name": "Anuppur",
                        "latitude": "23.05674000",
                        "longitude": "81.68399000"
                    },
                    {
                        "id": 134462,
                        "name": "Aron",
                        "latitude": "24.38109000",
                        "longitude": "77.41739000"
                    },
                    {
                        "id": 57750,
                        "name": "Ashoknagar",
                        "latitude": "24.58000000",
                        "longitude": "77.73000000"
                    },
                    {
                        "id": 57752,
                        "name": "Ashta",
                        "latitude": "23.01754000",
                        "longitude": "76.72208000"
                    },
                    {
                        "id": 58103,
                        "name": "Babai",
                        "latitude": "22.70256000",
                        "longitude": "77.93494000"
                    },
                    {
                        "id": 57788,
                        "name": "Badarwas",
                        "latitude": "24.97516000",
                        "longitude": "77.56490000"
                    },
                    {
                        "id": 57793,
                        "name": "Badnawar",
                        "latitude": "23.02181000",
                        "longitude": "75.23268000"
                    },
                    {
                        "id": 58106,
                        "name": "Bagh",
                        "latitude": "22.35905000",
                        "longitude": "74.79052000"
                    },
                    {
                        "id": 58111,
                        "name": "Bagli",
                        "latitude": "22.64124000",
                        "longitude": "76.34877000"
                    },
                    {
                        "id": 57811,
                        "name": "Baihar",
                        "latitude": "22.10133000",
                        "longitude": "80.54967000"
                    },
                    {
                        "id": 57813,
                        "name": "Baikunthpur",
                        "latitude": "24.72768000",
                        "longitude": "81.40975000"
                    },
                    {
                        "id": 57821,
                        "name": "Bakshwaha",
                        "latitude": "24.25106000",
                        "longitude": "79.28618000"
                    },
                    {
                        "id": 58119,
                        "name": "Balaghat",
                        "latitude": "21.96667000",
                        "longitude": "80.33333000"
                    },
                    {
                        "id": 57824,
                        "name": "Baldeogarh",
                        "latitude": "24.75619000",
                        "longitude": "79.06715000"
                    },
                    {
                        "id": 57838,
                        "name": "Bamna",
                        "latitude": "23.09454000",
                        "longitude": "74.76164000"
                    },
                    {
                        "id": 58122,
                        "name": "Bamor Kalan",
                        "latitude": "24.89298000",
                        "longitude": "78.15105000"
                    },
                    {
                        "id": 57839,
                        "name": "Bamora",
                        "latitude": "24.05539000",
                        "longitude": "78.08925000"
                    },
                    {
                        "id": 57842,
                        "name": "Banda",
                        "latitude": "24.04488000",
                        "longitude": "78.96094000"
                    },
                    {
                        "id": 57868,
                        "name": "Barela",
                        "latitude": "23.09678000",
                        "longitude": "80.05084000"
                    },
                    {
                        "id": 57870,
                        "name": "Barghat",
                        "latitude": "22.03065000",
                        "longitude": "79.73280000"
                    },
                    {
                        "id": 57871,
                        "name": "Bargi",
                        "latitude": "22.99138000",
                        "longitude": "79.87550000"
                    },
                    {
                        "id": 57872,
                        "name": "Barhi",
                        "latitude": "23.90326000",
                        "longitude": "80.81516000"
                    },
                    {
                        "id": 57888,
                        "name": "Barwani",
                        "latitude": "22.02485000",
                        "longitude": "74.91805000"
                    },
                    {
                        "id": 58148,
                        "name": "Basoda",
                        "latitude": "23.85153000",
                        "longitude": "77.93652000"
                    },
                    {
                        "id": 57913,
                        "name": "Begamganj",
                        "latitude": "23.59917000",
                        "longitude": "78.34064000"
                    },
                    {
                        "id": 57935,
                        "name": "Beohari",
                        "latitude": "24.02423000",
                        "longitude": "81.37831000"
                    },
                    {
                        "id": 57936,
                        "name": "Berasia",
                        "latitude": "23.63134000",
                        "longitude": "77.43351000"
                    },
                    {
                        "id": 57940,
                        "name": "Betma",
                        "latitude": "22.68653000",
                        "longitude": "75.61456000"
                    },
                    {
                        "id": 57942,
                        "name": "Betul",
                        "latitude": "21.83333000",
                        "longitude": "77.83333000"
                    },
                    {
                        "id": 57943,
                        "name": "Betul Bazar",
                        "latitude": "21.85572000",
                        "longitude": "77.92913000"
                    },
                    {
                        "id": 58006,
                        "name": "Bhabhra",
                        "latitude": "22.53048000",
                        "longitude": "74.32846000"
                    },
                    {
                        "id": 57959,
                        "name": "Bhainsdehi",
                        "latitude": "21.64491000",
                        "longitude": "77.63023000"
                    },
                    {
                        "id": 58011,
                        "name": "Bhander",
                        "latitude": "25.73581000",
                        "longitude": "78.74555000"
                    },
                    {
                        "id": 58012,
                        "name": "Bhanpura",
                        "latitude": "24.51300000",
                        "longitude": "75.74690000"
                    },
                    {
                        "id": 57975,
                        "name": "Bhawaniganj",
                        "latitude": "24.41582000",
                        "longitude": "75.83552000"
                    },
                    {
                        "id": 57980,
                        "name": "Bhikangaon",
                        "latitude": "21.86764000",
                        "longitude": "75.96391000"
                    },
                    {
                        "id": 57982,
                        "name": "Bhind",
                        "latitude": "26.50000000",
                        "longitude": "78.75000000"
                    },
                    {
                        "id": 57985,
                        "name": "Bhitarwar",
                        "latitude": "25.79216000",
                        "longitude": "78.11085000"
                    },
                    {
                        "id": 57995,
                        "name": "Bhopal",
                        "latitude": "23.25469000",
                        "longitude": "77.40289000"
                    },
                    {
                        "id": 58025,
                        "name": "Biaora",
                        "latitude": "23.92050000",
                        "longitude": "76.91074000"
                    },
                    {
                        "id": 58038,
                        "name": "Bijawar",
                        "latitude": "24.62351000",
                        "longitude": "79.48994000"
                    },
                    {
                        "id": 58036,
                        "name": "Bijrauni",
                        "latitude": "24.93296000",
                        "longitude": "77.64352000"
                    },
                    {
                        "id": 58073,
                        "name": "Bodri",
                        "latitude": "23.16524000",
                        "longitude": "81.43262000"
                    },
                    {
                        "id": 58096,
                        "name": "Burhanpur",
                        "latitude": "21.31000000",
                        "longitude": "76.23000000"
                    },
                    {
                        "id": 58097,
                        "name": "Burhar",
                        "latitude": "23.21494000",
                        "longitude": "81.53204000"
                    },
                    {
                        "id": 58188,
                        "name": "Chanderi",
                        "latitude": "24.71312000",
                        "longitude": "78.13809000"
                    },
                    {
                        "id": 58189,
                        "name": "Chandia",
                        "latitude": "23.65647000",
                        "longitude": "80.70911000"
                    },
                    {
                        "id": 58191,
                        "name": "Chandla",
                        "latitude": "25.07148000",
                        "longitude": "80.19294000"
                    },
                    {
                        "id": 131532,
                        "name": "Chhatarpur",
                        "latitude": "24.75000000",
                        "longitude": "79.75000000"
                    },
                    {
                        "id": 131534,
                        "name": "Chhindwara",
                        "latitude": "22.05697000",
                        "longitude": "78.93958000"
                    },
                    {
                        "id": 131543,
                        "name": "Chichli",
                        "latitude": "22.83363000",
                        "longitude": "78.82611000"
                    },
                    {
                        "id": 131581,
                        "name": "Chorhat",
                        "latitude": "24.42743000",
                        "longitude": "81.66948000"
                    },
                    {
                        "id": 131636,
                        "name": "Daboh",
                        "latitude": "26.00239000",
                        "longitude": "78.87658000"
                    },
                    {
                        "id": 131637,
                        "name": "Dabra",
                        "latitude": "25.88572000",
                        "longitude": "78.33221000"
                    },
                    {
                        "id": 131651,
                        "name": "Damoh",
                        "latitude": "23.75000000",
                        "longitude": "79.58333000"
                    },
                    {
                        "id": 131662,
                        "name": "Datia",
                        "latitude": "25.75000000",
                        "longitude": "78.50000000"
                    },
                    {
                        "id": 131691,
                        "name": "Deori Khas",
                        "latitude": "23.39017000",
                        "longitude": "79.01630000"
                    },
                    {
                        "id": 131693,
                        "name": "Depalpur",
                        "latitude": "22.85095000",
                        "longitude": "75.54224000"
                    },
                    {
                        "id": 131707,
                        "name": "Dewas",
                        "latitude": "23.00000000",
                        "longitude": "76.16667000"
                    },
                    {
                        "id": 131749,
                        "name": "Dhamnod",
                        "latitude": "22.20928000",
                        "longitude": "75.47057000"
                    },
                    {
                        "id": 131751,
                        "name": "Dhana",
                        "latitude": "23.74697000",
                        "longitude": "78.86234000"
                    },
                    {
                        "id": 131753,
                        "name": "Dhar",
                        "latitude": "22.59373000",
                        "longitude": "75.29774000"
                    },
                    {
                        "id": 131720,
                        "name": "Dharampuri",
                        "latitude": "22.14951000",
                        "longitude": "75.34439000"
                    },
                    {
                        "id": 131775,
                        "name": "Dindori",
                        "latitude": "22.80000000",
                        "longitude": "81.10000000"
                    },
                    {
                        "id": 131848,
                        "name": "Etawa",
                        "latitude": "24.18351000",
                        "longitude": "78.20289000"
                    },
                    {
                        "id": 132043,
                        "name": "Gadarwara",
                        "latitude": "22.92350000",
                        "longitude": "78.78490000"
                    },
                    {
                        "id": 131917,
                        "name": "Garha Brahman",
                        "latitude": "23.86873000",
                        "longitude": "77.35731000"
                    },
                    {
                        "id": 131924,
                        "name": "Garhakota",
                        "latitude": "23.77910000",
                        "longitude": "79.14321000"
                    },
                    {
                        "id": 131930,
                        "name": "Gautampura",
                        "latitude": "22.98664000",
                        "longitude": "75.51921000"
                    },
                    {
                        "id": 131936,
                        "name": "Ghansor",
                        "latitude": "22.65976000",
                        "longitude": "79.95013000"
                    },
                    {
                        "id": 131965,
                        "name": "Gogapur",
                        "latitude": "23.55746000",
                        "longitude": "75.51665000"
                    },
                    {
                        "id": 131966,
                        "name": "Gohadi",
                        "latitude": "26.43278000",
                        "longitude": "78.44205000"
                    },
                    {
                        "id": 132002,
                        "name": "Govindgarh",
                        "latitude": "24.37845000",
                        "longitude": "81.29644000"
                    },
                    {
                        "id": 132024,
                        "name": "Guna",
                        "latitude": "24.55464000",
                        "longitude": "77.20082000"
                    },
                    {
                        "id": 132033,
                        "name": "Gurh",
                        "latitude": "24.50265000",
                        "longitude": "81.50037000"
                    },
                    {
                        "id": 132040,
                        "name": "Gwalior",
                        "latitude": "26.22983000",
                        "longitude": "78.17337000"
                    },
                    {
                        "id": 132070,
                        "name": "Harda",
                        "latitude": "22.23406000",
                        "longitude": "76.96431000"
                    },
                    {
                        "id": 132071,
                        "name": "Harda Khas",
                        "latitude": "22.34414000",
                        "longitude": "77.09536000"
                    },
                    {
                        "id": 132080,
                        "name": "Harpalpur",
                        "latitude": "25.28773000",
                        "longitude": "79.33279000"
                    },
                    {
                        "id": 132081,
                        "name": "Harrai",
                        "latitude": "22.61428000",
                        "longitude": "79.22207000"
                    },
                    {
                        "id": 132082,
                        "name": "Harsud",
                        "latitude": "22.09947000",
                        "longitude": "76.73423000"
                    },
                    {
                        "id": 132145,
                        "name": "Hatod",
                        "latitude": "22.79378000",
                        "longitude": "75.73928000"
                    },
                    {
                        "id": 132088,
                        "name": "Hatta",
                        "latitude": "24.13406000",
                        "longitude": "79.60119000"
                    },
                    {
                        "id": 132098,
                        "name": "Hindoria",
                        "latitude": "23.90345000",
                        "longitude": "79.56861000"
                    },
                    {
                        "id": 132120,
                        "name": "Hoshangabad",
                        "latitude": "22.58827000",
                        "longitude": "77.98887000"
                    },
                    {
                        "id": 132180,
                        "name": "Iawar",
                        "latitude": "23.00943000",
                        "longitude": "76.50070000"
                    },
                    {
                        "id": 132152,
                        "name": "Ichhawar",
                        "latitude": "23.02816000",
                        "longitude": "77.01729000"
                    },
                    {
                        "id": 132158,
                        "name": "Iklehra",
                        "latitude": "23.14667000",
                        "longitude": "76.39044000"
                    },
                    {
                        "id": 132166,
                        "name": "Indore",
                        "latitude": "22.66667000",
                        "longitude": "75.75000000"
                    },
                    {
                        "id": 132175,
                        "name": "Isagarh",
                        "latitude": "24.83906000",
                        "longitude": "77.88274000"
                    },
                    {
                        "id": 132179,
                        "name": "Itarsi",
                        "latitude": "22.61477000",
                        "longitude": "77.76222000"
                    },
                    {
                        "id": 132181,
                        "name": "Jabalpur",
                        "latitude": "23.16000000",
                        "longitude": "79.95000000"
                    },
                    {
                        "id": 132204,
                        "name": "Jaisinghnagar",
                        "latitude": "23.68582000",
                        "longitude": "81.39085000"
                    },
                    {
                        "id": 132206,
                        "name": "Jaithari",
                        "latitude": "23.20856000",
                        "longitude": "78.61487000"
                    },
                    {
                        "id": 132309,
                        "name": "Jamai",
                        "latitude": "22.19644000",
                        "longitude": "78.59191000"
                    },
                    {
                        "id": 132241,
                        "name": "Jaora",
                        "latitude": "23.63783000",
                        "longitude": "75.12711000"
                    },
                    {
                        "id": 132251,
                        "name": "Jatara",
                        "latitude": "25.00964000",
                        "longitude": "79.04869000"
                    },
                    {
                        "id": 132314,
                        "name": "Jawad",
                        "latitude": "24.59916000",
                        "longitude": "74.86261000"
                    },
                    {
                        "id": 132275,
                        "name": "Jhabua",
                        "latitude": "22.76772000",
                        "longitude": "74.59087000"
                    },
                    {
                        "id": 132316,
                        "name": "Jiran",
                        "latitude": "24.30871000",
                        "longitude": "74.89087000"
                    },
                    {
                        "id": 132283,
                        "name": "Jobat",
                        "latitude": "22.41599000",
                        "longitude": "74.56828000"
                    },
                    {
                        "id": 132333,
                        "name": "Kailaras",
                        "latitude": "26.30498000",
                        "longitude": "77.61600000"
                    },
                    {
                        "id": 132336,
                        "name": "Kaimori",
                        "latitude": "23.38465000",
                        "longitude": "79.74420000"
                    },
                    {
                        "id": 132382,
                        "name": "Kannod",
                        "latitude": "22.66764000",
                        "longitude": "76.74286000"
                    },
                    {
                        "id": 132397,
                        "name": "Kareli",
                        "latitude": "22.91533000",
                        "longitude": "79.06378000"
                    },
                    {
                        "id": 132398,
                        "name": "Karera",
                        "latitude": "25.45815000",
                        "longitude": "78.13583000"
                    },
                    {
                        "id": 132407,
                        "name": "Karrapur",
                        "latitude": "23.94891000",
                        "longitude": "78.86584000"
                    },
                    {
                        "id": 132419,
                        "name": "Kasrawad",
                        "latitude": "22.12745000",
                        "longitude": "75.61101000"
                    },
                    {
                        "id": 132420,
                        "name": "Katangi",
                        "latitude": "21.77369000",
                        "longitude": "79.80513000"
                    },
                    {
                        "id": 132424,
                        "name": "Katni",
                        "latitude": "23.83555000",
                        "longitude": "80.39417000"
                    },
                    {
                        "id": 132511,
                        "name": "Khachrod",
                        "latitude": "23.42322000",
                        "longitude": "75.28185000"
                    },
                    {
                        "id": 132453,
                        "name": "Khailar",
                        "latitude": "25.34127000",
                        "longitude": "78.53133000"
                    },
                    {
                        "id": 132457,
                        "name": "Khajuraho Group of Monuments",
                        "latitude": "24.84809000",
                        "longitude": "79.93351000"
                    },
                    {
                        "id": 132460,
                        "name": "Khamaria",
                        "latitude": "23.22558000",
                        "longitude": "79.88007000"
                    },
                    {
                        "id": 132467,
                        "name": "Khandwa",
                        "latitude": "21.82427000",
                        "longitude": "76.35086000"
                    },
                    {
                        "id": 132476,
                        "name": "Khargapur",
                        "latitude": "24.82300000",
                        "longitude": "79.14400000"
                    },
                    {
                        "id": 132474,
                        "name": "Khargone",
                        "latitude": "21.82306000",
                        "longitude": "75.61028000"
                    },
                    {
                        "id": 132519,
                        "name": "Khategaon",
                        "latitude": "22.59573000",
                        "longitude": "76.91330000"
                    },
                    {
                        "id": 132497,
                        "name": "Khilchipur",
                        "latitude": "24.03943000",
                        "longitude": "76.57800000"
                    },
                    {
                        "id": 132498,
                        "name": "Khirkiyan",
                        "latitude": "22.16732000",
                        "longitude": "76.86137000"
                    },
                    {
                        "id": 132504,
                        "name": "Khujner",
                        "latitude": "23.78597000",
                        "longitude": "76.61773000"
                    },
                    {
                        "id": 132507,
                        "name": "Khurai",
                        "latitude": "24.04372000",
                        "longitude": "78.33014000"
                    },
                    {
                        "id": 132561,
                        "name": "Kolaras",
                        "latitude": "25.21928000",
                        "longitude": "77.61167000"
                    },
                    {
                        "id": 132585,
                        "name": "Korwai",
                        "latitude": "24.11774000",
                        "longitude": "78.04007000"
                    },
                    {
                        "id": 132613,
                        "name": "Kotar",
                        "latitude": "24.69802000",
                        "longitude": "80.98073000"
                    },
                    {
                        "id": 132598,
                        "name": "Kothi",
                        "latitude": "24.75260000",
                        "longitude": "80.77751000"
                    },
                    {
                        "id": 132603,
                        "name": "Kotma",
                        "latitude": "23.20383000",
                        "longitude": "81.97904000"
                    },
                    {
                        "id": 132611,
                        "name": "Kotwa",
                        "latitude": "25.03080000",
                        "longitude": "81.31908000"
                    },
                    {
                        "id": 132631,
                        "name": "Kukshi",
                        "latitude": "22.20677000",
                        "longitude": "74.75788000"
                    },
                    {
                        "id": 132640,
                        "name": "Kumbhraj",
                        "latitude": "24.37338000",
                        "longitude": "77.04841000"
                    },
                    {
                        "id": 132741,
                        "name": "Lahar",
                        "latitude": "26.19401000",
                        "longitude": "78.94137000"
                    },
                    {
                        "id": 132746,
                        "name": "Lakhnadon",
                        "latitude": "22.60049000",
                        "longitude": "79.60094000"
                    },
                    {
                        "id": 132763,
                        "name": "Leteri",
                        "latitude": "24.05979000",
                        "longitude": "77.40858000"
                    },
                    {
                        "id": 132766,
                        "name": "Lodhikheda",
                        "latitude": "21.58235000",
                        "longitude": "78.85911000"
                    },
                    {
                        "id": 133054,
                        "name": "Machalpur",
                        "latitude": "24.12767000",
                        "longitude": "76.31672000"
                    },
                    {
                        "id": 132814,
                        "name": "Madhogarh",
                        "latitude": "24.56401000",
                        "longitude": "80.91126000"
                    },
                    {
                        "id": 132833,
                        "name": "Maheshwar",
                        "latitude": "22.17592000",
                        "longitude": "75.58715000"
                    },
                    {
                        "id": 132835,
                        "name": "Mahgawan",
                        "latitude": "26.49471000",
                        "longitude": "78.61593000"
                    },
                    {
                        "id": 132854,
                        "name": "Maihar",
                        "latitude": "24.26594000",
                        "longitude": "80.76063000"
                    },
                    {
                        "id": 132860,
                        "name": "Majholi",
                        "latitude": "23.50114000",
                        "longitude": "79.92396000"
                    },
                    {
                        "id": 132864,
                        "name": "Maksi",
                        "latitude": "23.25999000",
                        "longitude": "76.14567000"
                    },
                    {
                        "id": 132869,
                        "name": "Malhargarh",
                        "latitude": "24.28286000",
                        "longitude": "74.99024000"
                    },
                    {
                        "id": 132930,
                        "name": "Manasa",
                        "latitude": "24.47764000",
                        "longitude": "75.14095000"
                    },
                    {
                        "id": 132931,
                        "name": "Manawar",
                        "latitude": "22.23566000",
                        "longitude": "75.08917000"
                    },
                    {
                        "id": 132894,
                        "name": "Mandideep",
                        "latitude": "23.08166000",
                        "longitude": "77.53328000"
                    },
                    {
                        "id": 132895,
                        "name": "Mandla",
                        "latitude": "22.64041000",
                        "longitude": "80.51344000"
                    },
                    {
                        "id": 133075,
                        "name": "Mandleshwar",
                        "latitude": "22.17598000",
                        "longitude": "75.65995000"
                    },
                    {
                        "id": 132897,
                        "name": "Mandsaur",
                        "latitude": "24.33333000",
                        "longitude": "75.25000000"
                    },
                    {
                        "id": 132907,
                        "name": "Mangawan",
                        "latitude": "24.66754000",
                        "longitude": "81.54644000"
                    },
                    {
                        "id": 133080,
                        "name": "Manpur",
                        "latitude": "22.43151000",
                        "longitude": "75.62107000"
                    },
                    {
                        "id": 132943,
                        "name": "Mau",
                        "latitude": "26.26584000",
                        "longitude": "78.67108000"
                    },
                    {
                        "id": 132947,
                        "name": "Mauganj",
                        "latitude": "24.66721000",
                        "longitude": "81.87339000"
                    },
                    {
                        "id": 132973,
                        "name": "Mihona",
                        "latitude": "26.28373000",
                        "longitude": "78.98048000"
                    },
                    {
                        "id": 132983,
                        "name": "Mohgaon",
                        "latitude": "21.63941000",
                        "longitude": "78.73638000"
                    },
                    {
                        "id": 133003,
                        "name": "Morar",
                        "latitude": "26.22640000",
                        "longitude": "78.22482000"
                    },
                    {
                        "id": 132994,
                        "name": "Morena",
                        "latitude": "26.16667000",
                        "longitude": "77.50000000"
                    },
                    {
                        "id": 133022,
                        "name": "Multai",
                        "latitude": "21.77463000",
                        "longitude": "78.25756000"
                    },
                    {
                        "id": 133028,
                        "name": "Mundi",
                        "latitude": "22.06693000",
                        "longitude": "76.49326000"
                    },
                    {
                        "id": 133030,
                        "name": "Mungaoli",
                        "latitude": "24.40837000",
                        "longitude": "78.09588000"
                    },
                    {
                        "id": 133042,
                        "name": "Murwara",
                        "latitude": "23.83776000",
                        "longitude": "80.39405000"
                    },
                    {
                        "id": 133115,
                        "name": "Nagda",
                        "latitude": "23.45834000",
                        "longitude": "75.41759000"
                    },
                    {
                        "id": 133259,
                        "name": "Nagod",
                        "latitude": "24.56924000",
                        "longitude": "80.58809000"
                    },
                    {
                        "id": 133197,
                        "name": "Naigarhi",
                        "latitude": "24.78686000",
                        "longitude": "81.77868000"
                    },
                    {
                        "id": 133124,
                        "name": "Nainpur",
                        "latitude": "22.42996000",
                        "longitude": "80.10561000"
                    },
                    {
                        "id": 133138,
                        "name": "Namli",
                        "latitude": "23.46115000",
                        "longitude": "75.06036000"
                    },
                    {
                        "id": 133155,
                        "name": "Naraini",
                        "latitude": "25.19033000",
                        "longitude": "80.47500000"
                    },
                    {
                        "id": 133276,
                        "name": "Narayangarh",
                        "latitude": "24.27083000",
                        "longitude": "75.05007000"
                    },
                    {
                        "id": 133171,
                        "name": "Narsimhapur",
                        "latitude": "22.91667000",
                        "longitude": "79.16667000"
                    },
                    {
                        "id": 133172,
                        "name": "Narsinghgarh",
                        "latitude": "23.70758000",
                        "longitude": "77.09319000"
                    },
                    {
                        "id": 133174,
                        "name": "Narwar",
                        "latitude": "25.64390000",
                        "longitude": "77.91290000"
                    },
                    {
                        "id": 133179,
                        "name": "Nasrullahganj",
                        "latitude": "22.68370000",
                        "longitude": "77.27069000"
                    },
                    {
                        "id": 133202,
                        "name": "Neemuch",
                        "latitude": "24.47000000",
                        "longitude": "74.87000000"
                    },
                    {
                        "id": 133207,
                        "name": "Nepanagar",
                        "latitude": "21.45380000",
                        "longitude": "76.39335000"
                    },
                    {
                        "id": 133304,
                        "name": "Orchha",
                        "latitude": "25.35192000",
                        "longitude": "78.64033000"
                    },
                    {
                        "id": 133308,
                        "name": "Pachmarhi",
                        "latitude": "22.46791000",
                        "longitude": "78.43312000"
                    },
                    {
                        "id": 133325,
                        "name": "Palera",
                        "latitude": "25.02013000",
                        "longitude": "79.22818000"
                    },
                    {
                        "id": 133530,
                        "name": "Pali",
                        "latitude": "23.36453000",
                        "longitude": "81.04374000"
                    },
                    {
                        "id": 133354,
                        "name": "Panagar",
                        "latitude": "23.28539000",
                        "longitude": "79.99509000"
                    },
                    {
                        "id": 133344,
                        "name": "Panara",
                        "latitude": "22.20568000",
                        "longitude": "78.55093000"
                    },
                    {
                        "id": 133348,
                        "name": "Pandhana",
                        "latitude": "21.69816000",
                        "longitude": "76.22487000"
                    },
                    {
                        "id": 133538,
                        "name": "Pandhurna",
                        "latitude": "21.59556000",
                        "longitude": "78.52628000"
                    },
                    {
                        "id": 133351,
                        "name": "Panna",
                        "latitude": "24.50000000",
                        "longitude": "80.25000000"
                    },
                    {
                        "id": 133542,
                        "name": "Pansemal",
                        "latitude": "21.65981000",
                        "longitude": "74.69937000"
                    },
                    {
                        "id": 133371,
                        "name": "Parasia",
                        "latitude": "22.19130000",
                        "longitude": "78.75904000"
                    },
                    {
                        "id": 133555,
                        "name": "Patan",
                        "latitude": "23.28636000",
                        "longitude": "79.68962000"
                    },
                    {
                        "id": 133381,
                        "name": "Patharia",
                        "latitude": "23.89921000",
                        "longitude": "79.19393000"
                    },
                    {
                        "id": 133396,
                        "name": "Pawai",
                        "latitude": "24.26635000",
                        "longitude": "80.16196000"
                    },
                    {
                        "id": 133430,
                        "name": "Petlawad",
                        "latitude": "23.01102000",
                        "longitude": "74.79772000"
                    },
                    {
                        "id": 133454,
                        "name": "Piploda",
                        "latitude": "23.35000000",
                        "longitude": "75.43333000"
                    },
                    {
                        "id": 133462,
                        "name": "Pithampur",
                        "latitude": "22.60197000",
                        "longitude": "75.69649000"
                    },
                    {
                        "id": 133481,
                        "name": "Porsa",
                        "latitude": "26.67444000",
                        "longitude": "78.37081000"
                    },
                    {
                        "id": 133508,
                        "name": "Punasa",
                        "latitude": "22.23507000",
                        "longitude": "76.39335000"
                    },
                    {
                        "id": 133660,
                        "name": "Raghogarh",
                        "latitude": "24.44318000",
                        "longitude": "77.19768000"
                    },
                    {
                        "id": 133661,
                        "name": "Rahatgarh",
                        "latitude": "23.78968000",
                        "longitude": "78.39473000"
                    },
                    {
                        "id": 133591,
                        "name": "Raisen",
                        "latitude": "23.25000000",
                        "longitude": "78.08333000"
                    },
                    {
                        "id": 133675,
                        "name": "Rajgarh",
                        "latitude": "22.67821000",
                        "longitude": "74.94483000"
                    },
                    {
                        "id": 133680,
                        "name": "Rajnagar",
                        "latitude": "24.88929000",
                        "longitude": "79.91178000"
                    },
                    {
                        "id": 133595,
                        "name": "Rajpur",
                        "latitude": "22.30393000",
                        "longitude": "74.35568000"
                    },
                    {
                        "id": 133709,
                        "name": "Rampura",
                        "latitude": "24.46700000",
                        "longitude": "75.43996000"
                    },
                    {
                        "id": 133717,
                        "name": "Ranapur",
                        "latitude": "22.64704000",
                        "longitude": "74.52118000"
                    },
                    {
                        "id": 133615,
                        "name": "Ratangarh",
                        "latitude": "24.81667000",
                        "longitude": "75.11667000"
                    },
                    {
                        "id": 133618,
                        "name": "Ratlam",
                        "latitude": "23.33033000",
                        "longitude": "75.04032000"
                    },
                    {
                        "id": 133623,
                        "name": "Rehli",
                        "latitude": "23.63722000",
                        "longitude": "79.06275000"
                    },
                    {
                        "id": 133624,
                        "name": "Rehti",
                        "latitude": "22.73781000",
                        "longitude": "77.43399000"
                    },
                    {
                        "id": 133633,
                        "name": "Rewa",
                        "latitude": "24.53256000",
                        "longitude": "81.29234000"
                    },
                    {
                        "id": 133738,
                        "name": "Sabalgarh",
                        "latitude": "26.24918000",
                        "longitude": "77.40786000"
                    },
                    {
                        "id": 134061,
                        "name": "Sagar",
                        "latitude": "23.75000000",
                        "longitude": "78.75000000"
                    },
                    {
                        "id": 133757,
                        "name": "Sailana",
                        "latitude": "23.46219000",
                        "longitude": "74.92318000"
                    },
                    {
                        "id": 133796,
                        "name": "Sanawad",
                        "latitude": "22.17391000",
                        "longitude": "76.06993000"
                    },
                    {
                        "id": 134070,
                        "name": "Sanchi",
                        "latitude": "23.48646000",
                        "longitude": "77.73780000"
                    },
                    {
                        "id": 134075,
                        "name": "Sanwer",
                        "latitude": "22.97415000",
                        "longitude": "75.82710000"
                    },
                    {
                        "id": 134078,
                        "name": "Sarangpur",
                        "latitude": "23.56651000",
                        "longitude": "76.47306000"
                    },
                    {
                        "id": 133820,
                        "name": "Satna",
                        "latitude": "24.50000000",
                        "longitude": "81.00000000"
                    },
                    {
                        "id": 133824,
                        "name": "Satwas",
                        "latitude": "22.53628000",
                        "longitude": "76.68452000"
                    },
                    {
                        "id": 133826,
                        "name": "Saugor",
                        "latitude": "23.83877000",
                        "longitude": "78.73874000"
                    },
                    {
                        "id": 133829,
                        "name": "Sausar",
                        "latitude": "21.65576000",
                        "longitude": "78.79669000"
                    },
                    {
                        "id": 133835,
                        "name": "Sehore",
                        "latitude": "23.20000000",
                        "longitude": "77.08333000"
                    },
                    {
                        "id": 133838,
                        "name": "Sendhwa",
                        "latitude": "21.68562000",
                        "longitude": "75.09622000"
                    },
                    {
                        "id": 133840,
                        "name": "Seondha",
                        "latitude": "26.15422000",
                        "longitude": "78.78120000"
                    },
                    {
                        "id": 133842,
                        "name": "Seoni",
                        "latitude": "22.08503000",
                        "longitude": "79.55037000"
                    },
                    {
                        "id": 133843,
                        "name": "Seoni Malwa",
                        "latitude": "22.45046000",
                        "longitude": "77.46650000"
                    },
                    {
                        "id": 133853,
                        "name": "Shahdol",
                        "latitude": "23.50000000",
                        "longitude": "81.50000000"
                    },
                    {
                        "id": 133893,
                        "name": "Shahgarh",
                        "latitude": "24.31365000",
                        "longitude": "79.11806000"
                    },
                    {
                        "id": 133899,
                        "name": "Shahpur",
                        "latitude": "21.23742000",
                        "longitude": "76.22558000"
                    },
                    {
                        "id": 133904,
                        "name": "Shahpura",
                        "latitude": "23.13663000",
                        "longitude": "79.66402000"
                    },
                    {
                        "id": 133910,
                        "name": "Shajapur",
                        "latitude": "23.50000000",
                        "longitude": "76.25000000"
                    },
                    {
                        "id": 133912,
                        "name": "Shamgarh",
                        "latitude": "24.18817000",
                        "longitude": "75.63903000"
                    },
                    {
                        "id": 133861,
                        "name": "Sheopur",
                        "latitude": "25.80000000",
                        "longitude": "77.00000000"
                    },
                    {
                        "id": 133880,
                        "name": "Shivpuri",
                        "latitude": "25.42378000",
                        "longitude": "77.66223000"
                    },
                    {
                        "id": 133888,
                        "name": "Shujalpur",
                        "latitude": "23.40673000",
                        "longitude": "76.70980000"
                    },
                    {
                        "id": 133922,
                        "name": "Sidhi",
                        "latitude": "24.25000000",
                        "longitude": "82.00000000"
                    },
                    {
                        "id": 133926,
                        "name": "Sihora",
                        "latitude": "23.48710000",
                        "longitude": "80.10404000"
                    },
                    {
                        "id": 133938,
                        "name": "Simaria",
                        "latitude": "24.79497000",
                        "longitude": "81.15200000"
                    },
                    {
                        "id": 133947,
                        "name": "Singoli",
                        "latitude": "24.96667000",
                        "longitude": "75.30000000"
                    },
                    {
                        "id": 133948,
                        "name": "Singrauli",
                        "latitude": "24.19973000",
                        "longitude": "82.67535000"
                    },
                    {
                        "id": 133956,
                        "name": "Sirmaur",
                        "latitude": "24.83648000",
                        "longitude": "81.36448000"
                    },
                    {
                        "id": 133959,
                        "name": "Sironj",
                        "latitude": "24.10313000",
                        "longitude": "77.69055000"
                    },
                    {
                        "id": 134090,
                        "name": "Sitamau",
                        "latitude": "24.01473000",
                        "longitude": "75.35324000"
                    },
                    {
                        "id": 133981,
                        "name": "Sohagi",
                        "latitude": "24.98181000",
                        "longitude": "81.69558000"
                    },
                    {
                        "id": 133982,
                        "name": "Sohagpur",
                        "latitude": "22.70055000",
                        "longitude": "78.19522000"
                    },
                    {
                        "id": 134039,
                        "name": "Sultanpur",
                        "latitude": "23.13812000",
                        "longitude": "77.93404000"
                    },
                    {
                        "id": 134055,
                        "name": "Susner",
                        "latitude": "23.94667000",
                        "longitude": "76.08825000"
                    },
                    {
                        "id": 134230,
                        "name": "Tal",
                        "latitude": "23.71979000",
                        "longitude": "75.38514000"
                    },
                    {
                        "id": 134102,
                        "name": "Talen",
                        "latitude": "23.56949000",
                        "longitude": "76.72821000"
                    },
                    {
                        "id": 134119,
                        "name": "Tarana",
                        "latitude": "23.33383000",
                        "longitude": "76.04253000"
                    },
                    {
                        "id": 134124,
                        "name": "Tekanpur",
                        "latitude": "25.99401000",
                        "longitude": "78.28322000"
                    },
                    {
                        "id": 134130,
                        "name": "Tendukheda",
                        "latitude": "23.39620000",
                        "longitude": "79.53947000"
                    },
                    {
                        "id": 134132,
                        "name": "Teonthar",
                        "latitude": "24.98207000",
                        "longitude": "81.64194000"
                    },
                    {
                        "id": 134137,
                        "name": "Thandla",
                        "latitude": "23.00959000",
                        "longitude": "74.57747000"
                    },
                    {
                        "id": 134244,
                        "name": "Tikamgarh",
                        "latitude": "24.74327000",
                        "longitude": "78.83061000"
                    },
                    {
                        "id": 134177,
                        "name": "Tirodi",
                        "latitude": "21.68522000",
                        "longitude": "79.71906000"
                    },
                    {
                        "id": 134251,
                        "name": "Udaipura",
                        "latitude": "23.07434000",
                        "longitude": "78.51108000"
                    },
                    {
                        "id": 134263,
                        "name": "Ujjain",
                        "latitude": "23.41667000",
                        "longitude": "75.50000000"
                    },
                    {
                        "id": 134266,
                        "name": "Ukwa",
                        "latitude": "21.97102000",
                        "longitude": "80.46625000"
                    },
                    {
                        "id": 134270,
                        "name": "Umaria",
                        "latitude": "23.52473000",
                        "longitude": "80.83716000"
                    },
                    {
                        "id": 134276,
                        "name": "Umri",
                        "latitude": "26.51056000",
                        "longitude": "78.93667000"
                    },
                    {
                        "id": 134282,
                        "name": "Unhel",
                        "latitude": "23.33794000",
                        "longitude": "75.55931000"
                    },
                    {
                        "id": 134354,
                        "name": "Vidisha",
                        "latitude": "23.91667000",
                        "longitude": "78.00000000"
                    },
                    {
                        "id": 134418,
                        "name": "Waraseoni",
                        "latitude": "21.76184000",
                        "longitude": "80.04301000"
                    }
                ]
            },
            {
                "id": 4008,
                "name": "Maharashtra",
                "iso2": "MH",
                "latitude": "19.75147980",
                "longitude": "75.71388840",
                "type": "state",
                "cities": [
                    {
                        "id": 57589,
                        "name": "Achalpur",
                        "latitude": "21.25665000",
                        "longitude": "77.51006000"
                    },
                    {
                        "id": 147667,
                        "name": "Adawad",
                        "latitude": "21.21666667",
                        "longitude": "75.45000000"
                    },
                    {
                        "id": 147668,
                        "name": "Agar Panchaitan",
                        "latitude": "18.17369200",
                        "longitude": "72.98853300"
                    },
                    {
                        "id": 147669,
                        "name": "Aheri",
                        "latitude": "19.41166667",
                        "longitude": "80.00388889"
                    },
                    {
                        "id": 57604,
                        "name": "Ahmadpur",
                        "latitude": "18.70622000",
                        "longitude": "76.93731000"
                    },
                    {
                        "id": 147670,
                        "name": "Ahmednagar",
                        "latitude": "19.08333333",
                        "longitude": "74.73333333"
                    },
                    {
                        "id": 57609,
                        "name": "Airoli",
                        "latitude": "19.15096000",
                        "longitude": "72.99625000"
                    },
                    {
                        "id": 57617,
                        "name": "Ajara",
                        "latitude": "16.11601000",
                        "longitude": "74.21097000"
                    },
                    {
                        "id": 57618,
                        "name": "Akalkot",
                        "latitude": "17.52532000",
                        "longitude": "76.20611000"
                    },
                    {
                        "id": 147672,
                        "name": "Akluj",
                        "latitude": "17.88333333",
                        "longitude": "75.01666667"
                    },
                    {
                        "id": 57627,
                        "name": "Akola",
                        "latitude": "20.50000000",
                        "longitude": "77.16667000"
                    },
                    {
                        "id": 147673,
                        "name": "Akolner",
                        "latitude": "18.98333333",
                        "longitude": "74.66666667"
                    },
                    {
                        "id": 57628,
                        "name": "Akot",
                        "latitude": "21.09630000",
                        "longitude": "77.05880000"
                    },
                    {
                        "id": 147674,
                        "name": "Akrani",
                        "latitude": "21.82423611",
                        "longitude": "74.21687222"
                    },
                    {
                        "id": 57633,
                        "name": "Alandi",
                        "latitude": "18.67756000",
                        "longitude": "73.89868000"
                    },
                    {
                        "id": 147675,
                        "name": "Ale",
                        "latitude": "19.17000000",
                        "longitude": "74.12000000"
                    },
                    {
                        "id": 57652,
                        "name": "Alibag",
                        "latitude": "18.64813000",
                        "longitude": "72.87579000"
                    },
                    {
                        "id": 147676,
                        "name": "Alkuti",
                        "latitude": "19.05000000",
                        "longitude": "74.23000000"
                    },
                    {
                        "id": 57642,
                        "name": "Allapalli",
                        "latitude": "19.43172000",
                        "longitude": "80.06377000"
                    },
                    {
                        "id": 57657,
                        "name": "Amalner",
                        "latitude": "21.03983000",
                        "longitude": "75.05887000"
                    },
                    {
                        "id": 57660,
                        "name": "Amarnath",
                        "latitude": "19.20000000",
                        "longitude": "73.16667000"
                    },
                    {
                        "id": 57665,
                        "name": "Ambad",
                        "latitude": "19.61301000",
                        "longitude": "75.78906000"
                    },
                    {
                        "id": 57674,
                        "name": "Ambajogai",
                        "latitude": "18.73312000",
                        "longitude": "76.38616000"
                    },
                    {
                        "id": 147678,
                        "name": "Ambegaon",
                        "latitude": "19.11666667",
                        "longitude": "73.73333333"
                    },
                    {
                        "id": 147677,
                        "name": "Ambernath",
                        "latitude": "19.20900000",
                        "longitude": "73.18600000"
                    },
                    {
                        "id": 147679,
                        "name": "Amgaon",
                        "latitude": "20.65000000",
                        "longitude": "79.95000000"
                    },
                    {
                        "id": 57689,
                        "name": "Amravati",
                        "latitude": "20.93333000",
                        "longitude": "77.75000000"
                    },
                    {
                        "id": 147680,
                        "name": "Andheri",
                        "latitude": "19.11916667",
                        "longitude": "72.84694444"
                    },
                    {
                        "id": 147681,
                        "name": "Andura",
                        "latitude": "20.88333333",
                        "longitude": "76.86666667"
                    },
                    {
                        "id": 57707,
                        "name": "Anjangaon",
                        "latitude": "21.16516000",
                        "longitude": "77.30910000"
                    },
                    {
                        "id": 147682,
                        "name": "Anjarle",
                        "latitude": "17.85000000",
                        "longitude": "73.09000000"
                    },
                    {
                        "id": 57716,
                        "name": "Anshing",
                        "latitude": "20.04090000",
                        "longitude": "77.31501000"
                    },
                    {
                        "id": 147683,
                        "name": "Arag",
                        "latitude": "16.78000000",
                        "longitude": "74.80000000"
                    },
                    {
                        "id": 134461,
                        "name": "Arangaon",
                        "latitude": "19.02681000",
                        "longitude": "74.71487000"
                    },
                    {
                        "id": 147684,
                        "name": "Ardhapur",
                        "latitude": "19.28333333",
                        "longitude": "77.38333333"
                    },
                    {
                        "id": 147685,
                        "name": "Argaon",
                        "latitude": "16.77899900",
                        "longitude": "73.64553000"
                    },
                    {
                        "id": 57741,
                        "name": "Artist Village",
                        "latitude": "19.03227000",
                        "longitude": "73.04276000"
                    },
                    {
                        "id": 134463,
                        "name": "Arvi",
                        "latitude": "20.99585000",
                        "longitude": "78.22914000"
                    },
                    {
                        "id": 57751,
                        "name": "Ashta",
                        "latitude": "16.94943000",
                        "longitude": "74.40936000"
                    },
                    {
                        "id": 57753,
                        "name": "Ashti",
                        "latitude": "19.37671000",
                        "longitude": "76.22520000"
                    },
                    {
                        "id": 147686,
                        "name": "Asoda",
                        "latitude": "21.03333333",
                        "longitude": "75.60000000"
                    },
                    {
                        "id": 147687,
                        "name": "Assaye",
                        "latitude": "20.24512778",
                        "longitude": "75.88739722"
                    },
                    {
                        "id": 147688,
                        "name": "Astagaon",
                        "latitude": "19.66666667",
                        "longitude": "74.50000000"
                    },
                    {
                        "id": 147689,
                        "name": "Aundh Satara",
                        "latitude": "17.54583333",
                        "longitude": "74.37500000"
                    },
                    {
                        "id": 57765,
                        "name": "Aurangabad",
                        "latitude": "19.88467000",
                        "longitude": "75.33986000"
                    },
                    {
                        "id": 57770,
                        "name": "Ausa",
                        "latitude": "18.24728000",
                        "longitude": "76.49930000"
                    },
                    {
                        "id": 57792,
                        "name": "Badlapur",
                        "latitude": "19.15516000",
                        "longitude": "73.26553000"
                    },
                    {
                        "id": 147690,
                        "name": "Badnapur",
                        "latitude": "19.86666667",
                        "longitude": "75.73333333"
                    },
                    {
                        "id": 147691,
                        "name": "Badnera",
                        "latitude": "20.85463056",
                        "longitude": "77.72931111"
                    },
                    {
                        "id": 147692,
                        "name": "Bagewadi",
                        "latitude": "16.29000000",
                        "longitude": "74.60000000"
                    },
                    {
                        "id": 58121,
                        "name": "Balapur",
                        "latitude": "20.66612000",
                        "longitude": "76.77386000"
                    },
                    {
                        "id": 147693,
                        "name": "Balapur Akola district",
                        "latitude": "20.66612000",
                        "longitude": "76.77386000"
                    },
                    {
                        "id": 57829,
                        "name": "Ballalpur",
                        "latitude": "19.84696000",
                        "longitude": "79.34578000"
                    },
                    {
                        "id": 147694,
                        "name": "Ballard Estate",
                        "latitude": "18.95000000",
                        "longitude": "72.84000000"
                    },
                    {
                        "id": 147695,
                        "name": "Ballarpur",
                        "latitude": "19.83333333",
                        "longitude": "79.35000000"
                    },
                    {
                        "id": 147696,
                        "name": "Banda Maharashtra",
                        "latitude": "15.81273611",
                        "longitude": "73.86132778"
                    },
                    {
                        "id": 147697,
                        "name": "Bandra",
                        "latitude": "19.05444444",
                        "longitude": "72.84055556"
                    },
                    {
                        "id": 147698,
                        "name": "Baner",
                        "latitude": "18.56000000",
                        "longitude": "73.79027778"
                    },
                    {
                        "id": 147699,
                        "name": "Bankot",
                        "latitude": "17.98333333",
                        "longitude": "73.05000000"
                    },
                    {
                        "id": 58146,
                        "name": "Baramati",
                        "latitude": "18.15174000",
                        "longitude": "74.57767000"
                    },
                    {
                        "id": 58144,
                        "name": "Barsi",
                        "latitude": "18.23454000",
                        "longitude": "75.69275000"
                    },
                    {
                        "id": 57897,
                        "name": "Basmat",
                        "latitude": "19.32872000",
                        "longitude": "77.15746000"
                    },
                    {
                        "id": 147701,
                        "name": "Bavdhan",
                        "latitude": "18.53527778",
                        "longitude": "73.78277778"
                    },
                    {
                        "id": 147702,
                        "name": "Bawanbir",
                        "latitude": "21.08333333",
                        "longitude": "76.71666667"
                    },
                    {
                        "id": 57912,
                        "name": "Beed",
                        "latitude": "18.98921000",
                        "longitude": "75.75634000"
                    },
                    {
                        "id": 147703,
                        "name": "Bhadgaon Maharashtra",
                        "latitude": "20.16666667",
                        "longitude": "75.23333333"
                    },
                    {
                        "id": 57961,
                        "name": "Bhandara",
                        "latitude": "21.18333000",
                        "longitude": "80.00000000"
                    },
                    {
                        "id": 147704,
                        "name": "Bhandardara",
                        "latitude": "19.52916667",
                        "longitude": "73.75138889"
                    },
                    {
                        "id": 147705,
                        "name": "Bhandup",
                        "latitude": "19.14000000",
                        "longitude": "72.93000000"
                    },
                    {
                        "id": 57978,
                        "name": "Bhayandar",
                        "latitude": "19.30157000",
                        "longitude": "72.85107000"
                    },
                    {
                        "id": 57979,
                        "name": "Bhigvan",
                        "latitude": "18.30070000",
                        "longitude": "74.76701000"
                    },
                    {
                        "id": 57987,
                        "name": "Bhiwandi",
                        "latitude": "19.30023000",
                        "longitude": "73.05881000"
                    },
                    {
                        "id": 147706,
                        "name": "Bhiwapur",
                        "latitude": "20.83555556",
                        "longitude": "79.50111111"
                    },
                    {
                        "id": 147707,
                        "name": "Bhokar",
                        "latitude": "19.21780300",
                        "longitude": "77.66939200"
                    },
                    {
                        "id": 147708,
                        "name": "Bhokardan",
                        "latitude": "20.27000000",
                        "longitude": "75.77000000"
                    },
                    {
                        "id": 58024,
                        "name": "Bhoom",
                        "latitude": "18.45908000",
                        "longitude": "75.65877000"
                    },
                    {
                        "id": 57997,
                        "name": "Bhor",
                        "latitude": "18.14861000",
                        "longitude": "73.84336000"
                    },
                    {
                        "id": 58001,
                        "name": "Bhudgaon",
                        "latitude": "16.90742000",
                        "longitude": "74.59954000"
                    },
                    {
                        "id": 147710,
                        "name": "Bhugaon",
                        "latitude": "18.50128400",
                        "longitude": "73.75016100"
                    },
                    {
                        "id": 58005,
                        "name": "Bhusaval",
                        "latitude": "21.04365000",
                        "longitude": "75.78506000"
                    },
                    {
                        "id": 147712,
                        "name": "Bijur",
                        "latitude": "13.84388889",
                        "longitude": "74.63972222"
                    },
                    {
                        "id": 147713,
                        "name": "Bilashi",
                        "latitude": "16.98333000",
                        "longitude": "74.03333000"
                    },
                    {
                        "id": 58047,
                        "name": "Biloli",
                        "latitude": "18.77385000",
                        "longitude": "77.72463000"
                    },
                    {
                        "id": 58074,
                        "name": "Boisar",
                        "latitude": "19.80362000",
                        "longitude": "72.75598000"
                    },
                    {
                        "id": 147714,
                        "name": "Borgaon Manju",
                        "latitude": "20.71944444",
                        "longitude": "77.15277778"
                    },
                    {
                        "id": 147715,
                        "name": "Borivali",
                        "latitude": "19.23000000",
                        "longitude": "72.86000000"
                    },
                    {
                        "id": 147716,
                        "name": "Brahmapuri",
                        "latitude": "20.60840000",
                        "longitude": "79.85590000"
                    },
                    {
                        "id": 147717,
                        "name": "Breach Candy",
                        "latitude": "18.96700000",
                        "longitude": "72.80500000"
                    },
                    {
                        "id": 58094,
                        "name": "Buldana",
                        "latitude": "20.58333000",
                        "longitude": "76.41667000"
                    },
                    {
                        "id": 147719,
                        "name": "Byculla",
                        "latitude": "18.98000000",
                        "longitude": "72.83500000"
                    },
                    {
                        "id": 131589,
                        "name": "Chakan",
                        "latitude": "18.76059000",
                        "longitude": "73.86351000"
                    },
                    {
                        "id": 147720,
                        "name": "Chakur",
                        "latitude": "18.51305556",
                        "longitude": "76.87527778"
                    },
                    {
                        "id": 131592,
                        "name": "Chalisgaon",
                        "latitude": "20.45781000",
                        "longitude": "75.01596000"
                    },
                    {
                        "id": 131596,
                        "name": "Chanda",
                        "latitude": "19.95076000",
                        "longitude": "79.29523000"
                    },
                    {
                        "id": 147721,
                        "name": "Chandgad",
                        "latitude": "15.00000000",
                        "longitude": "74.00000000"
                    },
                    {
                        "id": 131599,
                        "name": "Chandor",
                        "latitude": "20.33060000",
                        "longitude": "74.24467000"
                    },
                    {
                        "id": 58192,
                        "name": "Chandrapur",
                        "latitude": "20.11793000",
                        "longitude": "79.44377000"
                    },
                    {
                        "id": 131601,
                        "name": "Chandur",
                        "latitude": "19.73444000",
                        "longitude": "79.17167000"
                    },
                    {
                        "id": 131603,
                        "name": "Chandur Bazar",
                        "latitude": "21.23853000",
                        "longitude": "77.74713000"
                    },
                    {
                        "id": 147722,
                        "name": "Chausala",
                        "latitude": "18.70869200",
                        "longitude": "75.69159500"
                    },
                    {
                        "id": 147723,
                        "name": "Chembur",
                        "latitude": "19.05871111",
                        "longitude": "72.89969444"
                    },
                    {
                        "id": 131544,
                        "name": "Chicholi",
                        "latitude": "21.46926000",
                        "longitude": "79.70151000"
                    },
                    {
                        "id": 147724,
                        "name": "Chichondi Patil",
                        "latitude": "19.00000000",
                        "longitude": "74.91666667"
                    },
                    {
                        "id": 131549,
                        "name": "Chikhli (Buldhana)",
                        "latitude": "20.35046000",
                        "longitude": "76.25774000"
                    },
                    {
                        "id": 147725,
                        "name": "Chikhli (Jalna)",
                        "latitude": "20.02193000",
                        "longitude": "75.78544000"
                    },
                    {
                        "id": 147726,
                        "name": "Chimur",
                        "latitude": "20.49694444",
                        "longitude": "79.37666667"
                    },
                    {
                        "id": 131558,
                        "name": "Chinchani",
                        "latitude": "19.87458000",
                        "longitude": "72.68510000"
                    },
                    {
                        "id": 147727,
                        "name": "Chinchpokli",
                        "latitude": "18.98333333",
                        "longitude": "72.83333333"
                    },
                    {
                        "id": 131567,
                        "name": "Chiplun",
                        "latitude": "17.53339000",
                        "longitude": "73.50935000"
                    },
                    {
                        "id": 131580,
                        "name": "Chopda",
                        "latitude": "21.24578000",
                        "longitude": "75.29946000"
                    },
                    {
                        "id": 147728,
                        "name": "Colaba",
                        "latitude": "18.91000000",
                        "longitude": "72.81000000"
                    },
                    {
                        "id": 131805,
                        "name": "Dabhol",
                        "latitude": "17.58971000",
                        "longitude": "73.18001000"
                    },
                    {
                        "id": 147729,
                        "name": "Daddi",
                        "latitude": "16.06666667",
                        "longitude": "74.43333333"
                    },
                    {
                        "id": 131807,
                        "name": "Dahanu",
                        "latitude": "19.96778000",
                        "longitude": "72.71263000"
                    },
                    {
                        "id": 147730,
                        "name": "Dahivel",
                        "latitude": "21.06666667",
                        "longitude": "74.16666667"
                    },
                    {
                        "id": 147731,
                        "name": "Dapoli",
                        "latitude": "17.75888889",
                        "longitude": "73.18555556"
                    },
                    {
                        "id": 131810,
                        "name": "Darwha",
                        "latitude": "20.31017000",
                        "longitude": "77.77257000"
                    },
                    {
                        "id": 131659,
                        "name": "Daryapur",
                        "latitude": "20.92489000",
                        "longitude": "77.32644000"
                    },
                    {
                        "id": 131663,
                        "name": "Dattapur",
                        "latitude": "20.78075000",
                        "longitude": "78.14070000"
                    },
                    {
                        "id": 131666,
                        "name": "Daulatabad",
                        "latitude": "19.93611000",
                        "longitude": "75.22148000"
                    },
                    {
                        "id": 131667,
                        "name": "Daund",
                        "latitude": "18.46515000",
                        "longitude": "74.58375000"
                    },
                    {
                        "id": 147732,
                        "name": "Deccan Gymkhana",
                        "latitude": "18.51840000",
                        "longitude": "73.84060000"
                    },
                    {
                        "id": 147733,
                        "name": "Deglur",
                        "latitude": "18.54777778",
                        "longitude": "77.57722222"
                    },
                    {
                        "id": 131678,
                        "name": "Dehu",
                        "latitude": "18.71851000",
                        "longitude": "73.76635000"
                    },
                    {
                        "id": 131688,
                        "name": "Deolali",
                        "latitude": "19.94404000",
                        "longitude": "73.83441000"
                    },
                    {
                        "id": 147734,
                        "name": "Deolapar",
                        "latitude": "21.58611111",
                        "longitude": "79.36944444"
                    },
                    {
                        "id": 131686,
                        "name": "Deoli",
                        "latitude": "20.64920000",
                        "longitude": "78.48023000"
                    },
                    {
                        "id": 147735,
                        "name": "Deoni",
                        "latitude": "18.26388889",
                        "longitude": "77.08222222"
                    },
                    {
                        "id": 131709,
                        "name": "Deulgaon Raja",
                        "latitude": "20.01757000",
                        "longitude": "76.03755000"
                    },
                    {
                        "id": 147736,
                        "name": "Devrukh",
                        "latitude": "17.06500000",
                        "longitude": "73.61583333"
                    },
                    {
                        "id": 131722,
                        "name": "Dharangaon",
                        "latitude": "21.01187000",
                        "longitude": "75.27407000"
                    },
                    {
                        "id": 147737,
                        "name": "Dharavi",
                        "latitude": "19.05000000",
                        "longitude": "72.86667000"
                    },
                    {
                        "id": 131728,
                        "name": "Dharmabad",
                        "latitude": "18.89116000",
                        "longitude": "77.84940000"
                    },
                    {
                        "id": 131758,
                        "name": "Dharur",
                        "latitude": "18.82017000",
                        "longitude": "76.10937000"
                    },
                    {
                        "id": 147738,
                        "name": "Dhawalpuri",
                        "latitude": "19.16666667",
                        "longitude": "74.51666667"
                    },
                    {
                        "id": 131746,
                        "name": "Dhule",
                        "latitude": "21.06852000",
                        "longitude": "74.58837000"
                    },
                    {
                        "id": 131759,
                        "name": "Dhulia",
                        "latitude": "20.90130000",
                        "longitude": "74.77737000"
                    },
                    {
                        "id": 147739,
                        "name": "Dighori",
                        "latitude": "20.88620000",
                        "longitude": "79.93420000"
                    },
                    {
                        "id": 131815,
                        "name": "Diglur",
                        "latitude": "18.54829000",
                        "longitude": "77.57695000"
                    },
                    {
                        "id": 131768,
                        "name": "Digras",
                        "latitude": "20.10350000",
                        "longitude": "77.71846000"
                    },
                    {
                        "id": 147740,
                        "name": "Dindori Maharashtra",
                        "latitude": "20.20000000",
                        "longitude": "73.83305556"
                    },
                    {
                        "id": 147741,
                        "name": "Diveagar",
                        "latitude": "18.17333333",
                        "longitude": "72.99166667"
                    },
                    {
                        "id": 131785,
                        "name": "Dombivli",
                        "latitude": "19.21667000",
                        "longitude": "73.08333000"
                    },
                    {
                        "id": 131786,
                        "name": "Dondaicha",
                        "latitude": "21.32360000",
                        "longitude": "74.56804000"
                    },
                    {
                        "id": 147742,
                        "name": "Dongri",
                        "latitude": "19.28333333",
                        "longitude": "72.78333333"
                    },
                    {
                        "id": 131792,
                        "name": "Dudhani",
                        "latitude": "17.35792000",
                        "longitude": "76.36688000"
                    },
                    {
                        "id": 131802,
                        "name": "Durgapur",
                        "latitude": "20.00540000",
                        "longitude": "79.30273000"
                    },
                    {
                        "id": 147743,
                        "name": "Durgapur Chandrapur",
                        "latitude": "20.00000000",
                        "longitude": "79.30000000"
                    },
                    {
                        "id": 131838,
                        "name": "Erandol",
                        "latitude": "20.92206000",
                        "longitude": "75.32641000"
                    },
                    {
                        "id": 131850,
                        "name": "Faizpur",
                        "latitude": "21.16766000",
                        "longitude": "75.86006000"
                    },
                    {
                        "id": 147744,
                        "name": "Fort",
                        "latitude": "18.93500000",
                        "longitude": "72.83590000"
                    },
                    {
                        "id": 131886,
                        "name": "Gadchiroli",
                        "latitude": "19.80000000",
                        "longitude": "80.20000000"
                    },
                    {
                        "id": 131889,
                        "name": "Gadhinglaj",
                        "latitude": "16.22291000",
                        "longitude": "74.35010000"
                    },
                    {
                        "id": 131907,
                        "name": "Gangakher",
                        "latitude": "18.96962000",
                        "longitude": "76.74946000"
                    },
                    {
                        "id": 131910,
                        "name": "Gangapur",
                        "latitude": "19.69718000",
                        "longitude": "75.01045000"
                    },
                    {
                        "id": 147745,
                        "name": "Ganpatipule",
                        "latitude": "17.14480000",
                        "longitude": "73.26660000"
                    },
                    {
                        "id": 131934,
                        "name": "Gevrai",
                        "latitude": "19.26372000",
                        "longitude": "75.75007000"
                    },
                    {
                        "id": 147746,
                        "name": "Ghargaon",
                        "latitude": "18.74868400",
                        "longitude": "74.63673400"
                    },
                    {
                        "id": 131951,
                        "name": "Ghatanji",
                        "latitude": "20.14183000",
                        "longitude": "78.31333000"
                    },
                    {
                        "id": 147747,
                        "name": "Ghatkopar",
                        "latitude": "19.08000000",
                        "longitude": "72.91000000"
                    },
                    {
                        "id": 131947,
                        "name": "Ghoti Budrukh",
                        "latitude": "19.71641000",
                        "longitude": "73.62821000"
                    },
                    {
                        "id": 131948,
                        "name": "Ghugus",
                        "latitude": "19.93810000",
                        "longitude": "79.11192000"
                    },
                    {
                        "id": 147748,
                        "name": "Girgaon",
                        "latitude": "18.95300000",
                        "longitude": "72.81300000"
                    },
                    {
                        "id": 147749,
                        "name": "Gondia",
                        "latitude": "21.45000000",
                        "longitude": "80.20000000"
                    },
                    {
                        "id": 147750,
                        "name": "Gorai",
                        "latitude": "19.25005700",
                        "longitude": "72.78202100"
                    },
                    {
                        "id": 131994,
                        "name": "Goregaon",
                        "latitude": "18.15483000",
                        "longitude": "73.29147000"
                    },
                    {
                        "id": 132014,
                        "name": "Guhagar",
                        "latitude": "17.48415000",
                        "longitude": "73.19289000"
                    },
                    {
                        "id": 147751,
                        "name": "Hadapsar Pune",
                        "latitude": "18.49666667",
                        "longitude": "73.94166667"
                    },
                    {
                        "id": 132054,
                        "name": "Hadgaon",
                        "latitude": "19.49552000",
                        "longitude": "77.65863000"
                    },
                    {
                        "id": 147752,
                        "name": "Halkarni",
                        "latitude": "16.16666667",
                        "longitude": "74.46666667"
                    },
                    {
                        "id": 147753,
                        "name": "Harangul",
                        "latitude": "18.90000000",
                        "longitude": "76.66666667"
                    },
                    {
                        "id": 132078,
                        "name": "Harnai",
                        "latitude": "17.81340000",
                        "longitude": "73.09668000"
                    },
                    {
                        "id": 147754,
                        "name": "Helwak",
                        "latitude": "17.38500000",
                        "longitude": "73.73500000"
                    },
                    {
                        "id": 132100,
                        "name": "Hinganghat",
                        "latitude": "20.54875000",
                        "longitude": "78.83978000"
                    },
                    {
                        "id": 132101,
                        "name": "Hingoli",
                        "latitude": "19.70000000",
                        "longitude": "77.15000000"
                    },
                    {
                        "id": 147755,
                        "name": "Hirapur",
                        "latitude": "21.53000000",
                        "longitude": "79.77000000"
                    },
                    {
                        "id": 132149,
                        "name": "Hirapur Hamesha",
                        "latitude": "21.55546000",
                        "longitude": "79.78581000"
                    },
                    {
                        "id": 147756,
                        "name": "Hotgi",
                        "latitude": "17.58333333",
                        "longitude": "75.98333333"
                    },
                    {
                        "id": 132150,
                        "name": "Ichalkaranji",
                        "latitude": "16.69117000",
                        "longitude": "74.46054000"
                    },
                    {
                        "id": 132155,
                        "name": "Igatpuri",
                        "latitude": "19.69522000",
                        "longitude": "73.56260000"
                    },
                    {
                        "id": 132168,
                        "name": "Indapur",
                        "latitude": "18.30000000",
                        "longitude": "73.25000000"
                    },
                    {
                        "id": 132205,
                        "name": "Jaisingpur",
                        "latitude": "16.77639000",
                        "longitude": "74.55361000"
                    },
                    {
                        "id": 147757,
                        "name": "Jaitapur",
                        "latitude": "16.59000000",
                        "longitude": "73.35000000"
                    },
                    {
                        "id": 147758,
                        "name": "Jakhangaon",
                        "latitude": "17.64639000",
                        "longitude": "74.32111000"
                    },
                    {
                        "id": 132214,
                        "name": "Jalgaon",
                        "latitude": "21.00292000",
                        "longitude": "75.56602000"
                    },
                    {
                        "id": 132215,
                        "name": "Jalgaon Jamod",
                        "latitude": "21.05194000",
                        "longitude": "76.53464000"
                    },
                    {
                        "id": 147759,
                        "name": "Jalkot",
                        "latitude": "18.62916667",
                        "longitude": "77.18111111"
                    },
                    {
                        "id": 132216,
                        "name": "Jalna",
                        "latitude": "19.80000000",
                        "longitude": "75.90000000"
                    },
                    {
                        "id": 147760,
                        "name": "Jamkhed",
                        "latitude": "18.72000000",
                        "longitude": "75.32000000"
                    },
                    {
                        "id": 147761,
                        "name": "Jamod",
                        "latitude": "21.10000000",
                        "longitude": "76.60000000"
                    },
                    {
                        "id": 147762,
                        "name": "Janephal",
                        "latitude": "20.29361111",
                        "longitude": "76.57583333"
                    },
                    {
                        "id": 147763,
                        "name": "Jaoli",
                        "latitude": "17.90000000",
                        "longitude": "76.40000000"
                    },
                    {
                        "id": 147764,
                        "name": "Jat Sangli",
                        "latitude": "17.05000000",
                        "longitude": "75.21666667"
                    },
                    {
                        "id": 147765,
                        "name": "Jategaon",
                        "latitude": "19.91666667",
                        "longitude": "73.65000000"
                    },
                    {
                        "id": 132254,
                        "name": "Jawhar",
                        "latitude": "19.91213000",
                        "longitude": "73.22679000"
                    },
                    {
                        "id": 147766,
                        "name": "Jaysingpur",
                        "latitude": "16.78350556",
                        "longitude": "74.56644167"
                    },
                    {
                        "id": 132260,
                        "name": "Jejuri",
                        "latitude": "18.27658000",
                        "longitude": "74.16008000"
                    },
                    {
                        "id": 132282,
                        "name": "Jintur",
                        "latitude": "19.61186000",
                        "longitude": "76.68740000"
                    },
                    {
                        "id": 147767,
                        "name": "Jogeshwari",
                        "latitude": "19.12000000",
                        "longitude": "72.85000000"
                    },
                    {
                        "id": 147768,
                        "name": "Juhu",
                        "latitude": "19.10000000",
                        "longitude": "72.83000000"
                    },
                    {
                        "id": 132301,
                        "name": "Junnar",
                        "latitude": "19.20815000",
                        "longitude": "73.87520000"
                    },
                    {
                        "id": 147769,
                        "name": "Kachurwahi",
                        "latitude": "21.33330000",
                        "longitude": "79.38330000"
                    },
                    {
                        "id": 147770,
                        "name": "Kadegaon",
                        "latitude": "17.30000000",
                        "longitude": "74.35000000"
                    },
                    {
                        "id": 147771,
                        "name": "Kadus",
                        "latitude": "18.88333333",
                        "longitude": "73.81666667"
                    },
                    {
                        "id": 132677,
                        "name": "Kagal",
                        "latitude": "16.57702000",
                        "longitude": "74.31544000"
                    },
                    {
                        "id": 147772,
                        "name": "Kaij",
                        "latitude": "18.70000000",
                        "longitude": "76.08333333"
                    },
                    {
                        "id": 132345,
                        "name": "Kalamb",
                        "latitude": "19.04437000",
                        "longitude": "73.95554000"
                    },
                    {
                        "id": 147773,
                        "name": "Kalamb Osmanabad",
                        "latitude": "18.57416667",
                        "longitude": "76.02166667"
                    },
                    {
                        "id": 147774,
                        "name": "Kalamboli",
                        "latitude": "19.03333000",
                        "longitude": "73.10000000"
                    },
                    {
                        "id": 132346,
                        "name": "Kalamnuri",
                        "latitude": "19.67386000",
                        "longitude": "77.31149000"
                    },
                    {
                        "id": 132348,
                        "name": "Kalas",
                        "latitude": "18.17241000",
                        "longitude": "74.79045000"
                    },
                    {
                        "id": 147775,
                        "name": "Kali(DK)",
                        "latitude": "19.93877800",
                        "longitude": "77.73285700"
                    },
                    {
                        "id": 132355,
                        "name": "Kalmeshwar",
                        "latitude": "21.23219000",
                        "longitude": "78.91988000"
                    },
                    {
                        "id": 132684,
                        "name": "Kalundri",
                        "latitude": "18.98020000",
                        "longitude": "73.12708000"
                    },
                    {
                        "id": 132359,
                        "name": "Kalyan",
                        "latitude": "19.24370000",
                        "longitude": "73.13554000"
                    },
                    {
                        "id": 147776,
                        "name": "Kalyani Nagar",
                        "latitude": "18.54810000",
                        "longitude": "73.90330000"
                    },
                    {
                        "id": 147777,
                        "name": "Kamargaon",
                        "latitude": "20.61666667",
                        "longitude": "77.50000000"
                    },
                    {
                        "id": 147778,
                        "name": "Kamatgi",
                        "latitude": "16.11900000",
                        "longitude": "75.84820000"
                    },
                    {
                        "id": 147779,
                        "name": "Kamptee",
                        "latitude": "21.23330000",
                        "longitude": "79.20000000"
                    },
                    {
                        "id": 132700,
                        "name": "Kandri",
                        "latitude": "21.42030000",
                        "longitude": "79.27663000"
                    },
                    {
                        "id": 132375,
                        "name": "Kankauli",
                        "latitude": "16.26609000",
                        "longitude": "73.71217000"
                    },
                    {
                        "id": 147780,
                        "name": "Kankavli",
                        "latitude": "16.28551111",
                        "longitude": "73.68446111"
                    },
                    {
                        "id": 132377,
                        "name": "Kannad",
                        "latitude": "20.25684000",
                        "longitude": "75.13786000"
                    },
                    {
                        "id": 132412,
                        "name": "Karad",
                        "latitude": "17.28937000",
                        "longitude": "74.18183000"
                    },
                    {
                        "id": 147781,
                        "name": "Karajagi",
                        "latitude": "17.11666667",
                        "longitude": "75.58333333"
                    },
                    {
                        "id": 132717,
                        "name": "Karanja",
                        "latitude": "20.48273000",
                        "longitude": "77.48857000"
                    },
                    {
                        "id": 147782,
                        "name": "Karanja Lad",
                        "latitude": "20.48330000",
                        "longitude": "77.48330000"
                    },
                    {
                        "id": 132403,
                        "name": "Karjat",
                        "latitude": "18.91070000",
                        "longitude": "73.32354000"
                    },
                    {
                        "id": 147783,
                        "name": "Karkamb",
                        "latitude": "17.86530000",
                        "longitude": "75.29640000"
                    },
                    {
                        "id": 132404,
                        "name": "Karmala",
                        "latitude": "18.40770000",
                        "longitude": "75.19386000"
                    },
                    {
                        "id": 147784,
                        "name": "Kasara",
                        "latitude": "19.63330000",
                        "longitude": "73.48330000"
                    },
                    {
                        "id": 147785,
                        "name": "Kasoda",
                        "latitude": "20.81666667",
                        "longitude": "75.30000000"
                    },
                    {
                        "id": 132724,
                        "name": "Kati",
                        "latitude": "17.96137000",
                        "longitude": "75.88895000"
                    },
                    {
                        "id": 132725,
                        "name": "Katol",
                        "latitude": "21.27388000",
                        "longitude": "78.58580000"
                    },
                    {
                        "id": 147786,
                        "name": "Katral",
                        "latitude": "17.16666667",
                        "longitude": "75.63333333"
                    },
                    {
                        "id": 132450,
                        "name": "Khadki",
                        "latitude": "18.56350000",
                        "longitude": "73.85205000"
                    },
                    {
                        "id": 147787,
                        "name": "Khalapur",
                        "latitude": "18.81666667",
                        "longitude": "73.26666667"
                    },
                    {
                        "id": 147788,
                        "name": "Khallar",
                        "latitude": "21.04028690",
                        "longitude": "77.46562960"
                    },
                    {
                        "id": 132513,
                        "name": "Khamgaon",
                        "latitude": "20.70738000",
                        "longitude": "76.56827000"
                    },
                    {
                        "id": 147789,
                        "name": "Khanapur",
                        "latitude": "17.26111111",
                        "longitude": "74.70166667"
                    },
                    {
                        "id": 147790,
                        "name": "Khandala",
                        "latitude": "18.05918056",
                        "longitude": "74.01262778"
                    },
                    {
                        "id": 147791,
                        "name": "Khangaon",
                        "latitude": "20.50000000",
                        "longitude": "78.61666667"
                    },
                    {
                        "id": 132517,
                        "name": "Khapa",
                        "latitude": "21.42243000",
                        "longitude": "78.98168000"
                    },
                    {
                        "id": 132471,
                        "name": "Kharakvasla",
                        "latitude": "18.43997000",
                        "longitude": "73.77545000"
                    },
                    {
                        "id": 147792,
                        "name": "Kharda",
                        "latitude": "18.63753000",
                        "longitude": "75.47513000"
                    },
                    {
                        "id": 147793,
                        "name": "Kharghar",
                        "latitude": "19.03614722",
                        "longitude": "73.06172222"
                    },
                    {
                        "id": 147794,
                        "name": "Kharsundi",
                        "latitude": "17.34158500",
                        "longitude": "74.77599600"
                    },
                    {
                        "id": 132487,
                        "name": "Khed",
                        "latitude": "17.71888000",
                        "longitude": "73.39693000"
                    },
                    {
                        "id": 132495,
                        "name": "Khetia",
                        "latitude": "21.67124000",
                        "longitude": "74.58535000"
                    },
                    {
                        "id": 147796,
                        "name": "Khoni",
                        "latitude": "19.31130000",
                        "longitude": "73.05440000"
                    },
                    {
                        "id": 132500,
                        "name": "Khopoli",
                        "latitude": "18.78562000",
                        "longitude": "73.34589000"
                    },
                    {
                        "id": 132505,
                        "name": "Khuldabad",
                        "latitude": "20.00671000",
                        "longitude": "75.19245000"
                    },
                    {
                        "id": 132524,
                        "name": "Kinwat",
                        "latitude": "19.62557000",
                        "longitude": "78.19870000"
                    },
                    {
                        "id": 132543,
                        "name": "Kodoli",
                        "latitude": "16.87639000",
                        "longitude": "74.19090000"
                    },
                    {
                        "id": 132556,
                        "name": "Kolhapur",
                        "latitude": "16.69013000",
                        "longitude": "74.22981000"
                    },
                    {
                        "id": 132566,
                        "name": "Kondalwadi",
                        "latitude": "18.80727000",
                        "longitude": "77.77031000"
                    },
                    {
                        "id": 147797,
                        "name": "Kondhali",
                        "latitude": "21.15000000",
                        "longitude": "78.61666667"
                    },
                    {
                        "id": 147798,
                        "name": "Kopar Khairane",
                        "latitude": "19.10305556",
                        "longitude": "73.01055556"
                    },
                    {
                        "id": 132572,
                        "name": "Kopargaon",
                        "latitude": "19.88239000",
                        "longitude": "74.47605000"
                    },
                    {
                        "id": 147799,
                        "name": "Kopela",
                        "latitude": "18.83000000",
                        "longitude": "80.23000000"
                    },
                    {
                        "id": 132586,
                        "name": "Koradi",
                        "latitude": "21.24758000",
                        "longitude": "79.10575000"
                    },
                    {
                        "id": 132582,
                        "name": "Koregaon",
                        "latitude": "18.64573000",
                        "longitude": "74.05909000"
                    },
                    {
                        "id": 132618,
                        "name": "Koynanagar",
                        "latitude": "17.40000000",
                        "longitude": "73.76667000"
                    },
                    {
                        "id": 132629,
                        "name": "Kudal",
                        "latitude": "16.01148000",
                        "longitude": "73.68867000"
                    },
                    {
                        "id": 147800,
                        "name": "Kuhi",
                        "latitude": "21.01082222",
                        "longitude": "79.35242222"
                    },
                    {
                        "id": 132656,
                        "name": "Kurandvad",
                        "latitude": "16.68317000",
                        "longitude": "74.58892000"
                    },
                    {
                        "id": 147801,
                        "name": "Kurankhed",
                        "latitude": "20.70194444",
                        "longitude": "77.24972222"
                    },
                    {
                        "id": 132657,
                        "name": "Kurduvadi",
                        "latitude": "18.09339000",
                        "longitude": "75.41567000"
                    },
                    {
                        "id": 147802,
                        "name": "Kusumba",
                        "latitude": "20.91666667",
                        "longitude": "74.65000000"
                    },
                    {
                        "id": 147803,
                        "name": "Lakhandur",
                        "latitude": "20.75000000",
                        "longitude": "79.88333333"
                    },
                    {
                        "id": 132799,
                        "name": "Lanja",
                        "latitude": "16.86086000",
                        "longitude": "73.54993000"
                    },
                    {
                        "id": 132800,
                        "name": "Lasalgaon",
                        "latitude": "20.14270000",
                        "longitude": "74.23946000"
                    },
                    {
                        "id": 132759,
                        "name": "Latur",
                        "latitude": "18.40000000",
                        "longitude": "76.80000000"
                    },
                    {
                        "id": 147804,
                        "name": "Lavasa",
                        "latitude": "18.40528056",
                        "longitude": "73.50626944"
                    },
                    {
                        "id": 132770,
                        "name": "Lohogaon",
                        "latitude": "18.59921000",
                        "longitude": "73.92701000"
                    },
                    {
                        "id": 132776,
                        "name": "Lonar",
                        "latitude": "19.98533000",
                        "longitude": "76.52046000"
                    },
                    {
                        "id": 132773,
                        "name": "Lonavla",
                        "latitude": "18.75275000",
                        "longitude": "73.40575000"
                    },
                    {
                        "id": 132844,
                        "name": "Mahabaleshwar",
                        "latitude": "17.56000000",
                        "longitude": "73.40000000"
                    },
                    {
                        "id": 132846,
                        "name": "Mahad",
                        "latitude": "18.08333000",
                        "longitude": "73.41667000"
                    },
                    {
                        "id": 147805,
                        "name": "Mahape",
                        "latitude": "19.11776000",
                        "longitude": "73.02693800"
                    },
                    {
                        "id": 147806,
                        "name": "Mahim",
                        "latitude": "19.03500000",
                        "longitude": "72.84000000"
                    },
                    {
                        "id": 132856,
                        "name": "Maindargi",
                        "latitude": "17.45739000",
                        "longitude": "76.29320000"
                    },
                    {
                        "id": 133062,
                        "name": "Majalgaon",
                        "latitude": "19.15988000",
                        "longitude": "76.20832000"
                    },
                    {
                        "id": 133063,
                        "name": "Makhjan",
                        "latitude": "17.26980000",
                        "longitude": "73.50031000"
                    },
                    {
                        "id": 147807,
                        "name": "Malabar Hill",
                        "latitude": "18.95000000",
                        "longitude": "72.79500000"
                    },
                    {
                        "id": 147808,
                        "name": "Malad",
                        "latitude": "19.18611111",
                        "longitude": "72.84861111"
                    },
                    {
                        "id": 133065,
                        "name": "Malegaon",
                        "latitude": "20.54966000",
                        "longitude": "74.53462000"
                    },
                    {
                        "id": 132872,
                        "name": "Malkapur",
                        "latitude": "17.26214000",
                        "longitude": "74.17574000"
                    },
                    {
                        "id": 133070,
                        "name": "Malvan",
                        "latitude": "16.05981000",
                        "longitude": "73.46290000"
                    },
                    {
                        "id": 132886,
                        "name": "Manchar",
                        "latitude": "19.00436000",
                        "longitude": "73.94346000"
                    },
                    {
                        "id": 147809,
                        "name": "Mandangad",
                        "latitude": "17.98333333",
                        "longitude": "73.25000000"
                    },
                    {
                        "id": 147810,
                        "name": "Mandhal",
                        "latitude": "20.95000000",
                        "longitude": "79.46666667"
                    },
                    {
                        "id": 147811,
                        "name": "Mandwa",
                        "latitude": "18.80300000",
                        "longitude": "72.88200000"
                    },
                    {
                        "id": 147812,
                        "name": "Mangaon",
                        "latitude": "18.23333333",
                        "longitude": "73.28333333"
                    },
                    {
                        "id": 132909,
                        "name": "Mangrul Pir",
                        "latitude": "20.31379000",
                        "longitude": "77.34178000"
                    },
                    {
                        "id": 147813,
                        "name": "Manjlegaon",
                        "latitude": "19.15000000",
                        "longitude": "76.23000000"
                    },
                    {
                        "id": 147814,
                        "name": "Mankeshwar",
                        "latitude": "18.35416667",
                        "longitude": "75.63916667"
                    },
                    {
                        "id": 147815,
                        "name": "Mankhurd",
                        "latitude": "19.05000000",
                        "longitude": "72.93000000"
                    },
                    {
                        "id": 132918,
                        "name": "Manmad",
                        "latitude": "20.25334000",
                        "longitude": "74.43755000"
                    },
                    {
                        "id": 132924,
                        "name": "Manor",
                        "latitude": "19.72440000",
                        "longitude": "72.90966000"
                    },
                    {
                        "id": 132926,
                        "name": "Mansar",
                        "latitude": "21.39602000",
                        "longitude": "79.26350000"
                    },
                    {
                        "id": 133084,
                        "name": "Manwat",
                        "latitude": "19.30133000",
                        "longitude": "76.49735000"
                    },
                    {
                        "id": 147817,
                        "name": "Maregaon",
                        "latitude": "20.10000000",
                        "longitude": "78.81666667"
                    },
                    {
                        "id": 147818,
                        "name": "Mastiholi",
                        "latitude": "16.08333333",
                        "longitude": "74.55000000"
                    },
                    {
                        "id": 147819,
                        "name": "Masur India",
                        "latitude": "17.40000000",
                        "longitude": "74.15000000"
                    },
                    {
                        "id": 133090,
                        "name": "Matheran",
                        "latitude": "18.98281000",
                        "longitude": "73.26520000"
                    },
                    {
                        "id": 147820,
                        "name": "Matunga",
                        "latitude": "19.01798056",
                        "longitude": "72.84476389"
                    },
                    {
                        "id": 147821,
                        "name": "Mazagaon",
                        "latitude": "18.97000000",
                        "longitude": "72.85000000"
                    },
                    {
                        "id": 132961,
                        "name": "Mehekar",
                        "latitude": "20.15050000",
                        "longitude": "76.56841000"
                    },
                    {
                        "id": 147822,
                        "name": "Mehergaon",
                        "latitude": "20.96666667",
                        "longitude": "74.63333333"
                    },
                    {
                        "id": 147823,
                        "name": "Mehkar",
                        "latitude": "20.15000000",
                        "longitude": "76.57500000"
                    },
                    {
                        "id": 132971,
                        "name": "Mhasla",
                        "latitude": "18.13340000",
                        "longitude": "73.11162000"
                    },
                    {
                        "id": 132972,
                        "name": "Mhasvad",
                        "latitude": "17.63359000",
                        "longitude": "74.78773000"
                    },
                    {
                        "id": 147824,
                        "name": "Miraj",
                        "latitude": "16.83000000",
                        "longitude": "74.63000000"
                    },
                    {
                        "id": 147825,
                        "name": "Mohadi",
                        "latitude": "21.30833333",
                        "longitude": "79.67500000"
                    },
                    {
                        "id": 147826,
                        "name": "Mohol",
                        "latitude": "17.81670000",
                        "longitude": "75.66670000"
                    },
                    {
                        "id": 132985,
                        "name": "Mohpa",
                        "latitude": "21.31012000",
                        "longitude": "78.82969000"
                    },
                    {
                        "id": 147827,
                        "name": "Mokhada taluka",
                        "latitude": "19.93333333",
                        "longitude": "73.33333333"
                    },
                    {
                        "id": 147828,
                        "name": "Mora Maharashtra",
                        "latitude": "18.88900000",
                        "longitude": "72.93400000"
                    },
                    {
                        "id": 132992,
                        "name": "Moram",
                        "latitude": "17.78812000",
                        "longitude": "76.47077000"
                    },
                    {
                        "id": 132999,
                        "name": "Morsi",
                        "latitude": "21.34030000",
                        "longitude": "78.01258000"
                    },
                    {
                        "id": 133006,
                        "name": "Mowad",
                        "latitude": "21.46475000",
                        "longitude": "78.45103000"
                    },
                    {
                        "id": 133012,
                        "name": "Mudkhed",
                        "latitude": "19.15657000",
                        "longitude": "77.50304000"
                    },
                    {
                        "id": 133018,
                        "name": "Mukher",
                        "latitude": "18.70636000",
                        "longitude": "77.36795000"
                    },
                    {
                        "id": 133099,
                        "name": "Mul",
                        "latitude": "20.06987000",
                        "longitude": "79.67826000"
                    },
                    {
                        "id": 147829,
                        "name": "Mulher",
                        "latitude": "20.78138889",
                        "longitude": "74.06388889"
                    },
                    {
                        "id": 147830,
                        "name": "Mulund",
                        "latitude": "19.17168056",
                        "longitude": "72.95600000"
                    },
                    {
                        "id": 133024,
                        "name": "Mumbai",
                        "latitude": "19.07283000",
                        "longitude": "72.88261000"
                    },
                    {
                        "id": 133025,
                        "name": "Mumbai Suburban",
                        "latitude": "19.12636000",
                        "longitude": "72.84897000"
                    },
                    {
                        "id": 133035,
                        "name": "Murbad",
                        "latitude": "19.25395000",
                        "longitude": "73.38993000"
                    },
                    {
                        "id": 133036,
                        "name": "Murgud",
                        "latitude": "16.39604000",
                        "longitude": "74.19142000"
                    },
                    {
                        "id": 133039,
                        "name": "Murtajapur",
                        "latitude": "20.73299000",
                        "longitude": "77.36694000"
                    },
                    {
                        "id": 133040,
                        "name": "Murud (Raigad)",
                        "latitude": "18.32817000",
                        "longitude": "72.96210000"
                    },
                    {
                        "id": 147831,
                        "name": "Murud (Ratnagiri)",
                        "latitude": "17.77494444",
                        "longitude": "73.11815000"
                    },
                    {
                        "id": 147832,
                        "name": "Murum",
                        "latitude": "17.78777778",
                        "longitude": "76.47000000"
                    },
                    {
                        "id": 147833,
                        "name": "Nadgaon",
                        "latitude": "20.90101389",
                        "longitude": "76.01396389"
                    },
                    {
                        "id": 147834,
                        "name": "Nagapur",
                        "latitude": "18.87000000",
                        "longitude": "76.43000000"
                    },
                    {
                        "id": 133260,
                        "name": "Nagothana",
                        "latitude": "18.54225000",
                        "longitude": "73.13493000"
                    },
                    {
                        "id": 133116,
                        "name": "Nagpur",
                        "latitude": "21.14631000",
                        "longitude": "79.08491000"
                    },
                    {
                        "id": 133117,
                        "name": "Nagpur Division",
                        "latitude": "21.14911000",
                        "longitude": "79.10748000"
                    },
                    {
                        "id": 147835,
                        "name": "Nala Sopara",
                        "latitude": "19.41540000",
                        "longitude": "72.86130000"
                    },
                    {
                        "id": 133131,
                        "name": "Naldurg",
                        "latitude": "17.81667000",
                        "longitude": "76.28182000"
                    },
                    {
                        "id": 147836,
                        "name": "Nalegaon",
                        "latitude": "18.41666667",
                        "longitude": "76.81666667"
                    },
                    {
                        "id": 147837,
                        "name": "Nampur",
                        "latitude": "20.72861111",
                        "longitude": "74.31083333"
                    },
                    {
                        "id": 133141,
                        "name": "Nanded",
                        "latitude": "18.91667000",
                        "longitude": "77.50000000"
                    },
                    {
                        "id": 133267,
                        "name": "Nandgaon",
                        "latitude": "20.30680000",
                        "longitude": "74.65501000"
                    },
                    {
                        "id": 147838,
                        "name": "Nandnee",
                        "latitude": "17.45500000",
                        "longitude": "75.84555556"
                    },
                    {
                        "id": 147839,
                        "name": "Nandura",
                        "latitude": "20.83333333",
                        "longitude": "76.45972222"
                    },
                    {
                        "id": 133268,
                        "name": "Nandura Buzurg",
                        "latitude": "20.83417000",
                        "longitude": "76.45924000"
                    },
                    {
                        "id": 133145,
                        "name": "Nandurbar",
                        "latitude": "21.37000000",
                        "longitude": "74.20000000"
                    },
                    {
                        "id": 147840,
                        "name": "Narayangaon",
                        "latitude": "19.07000000",
                        "longitude": "73.97000000"
                    },
                    {
                        "id": 147841,
                        "name": "Nardana",
                        "latitude": "21.20000000",
                        "longitude": "74.81666667"
                    },
                    {
                        "id": 147842,
                        "name": "Nariman Point",
                        "latitude": "18.92000000",
                        "longitude": "72.83000000"
                    },
                    {
                        "id": 147843,
                        "name": "Narkhed",
                        "latitude": "21.47000000",
                        "longitude": "78.53000000"
                    },
                    {
                        "id": 133177,
                        "name": "Nashik",
                        "latitude": "19.99727000",
                        "longitude": "73.79096000"
                    },
                    {
                        "id": 133178,
                        "name": "Nashik Division",
                        "latitude": "19.98295000",
                        "longitude": "73.78942000"
                    },
                    {
                        "id": 147844,
                        "name": "Navapur",
                        "latitude": "21.17000000",
                        "longitude": "73.78000000"
                    },
                    {
                        "id": 133186,
                        "name": "Navi Mumbai",
                        "latitude": "19.03681000",
                        "longitude": "73.01582000"
                    },
                    {
                        "id": 133208,
                        "name": "Neral",
                        "latitude": "19.02475000",
                        "longitude": "73.31688000"
                    },
                    {
                        "id": 147845,
                        "name": "Nerur",
                        "latitude": "15.98333333",
                        "longitude": "73.65000000"
                    },
                    {
                        "id": 147846,
                        "name": "Nevasa",
                        "latitude": "19.53333333",
                        "longitude": "74.93333333"
                    },
                    {
                        "id": 147847,
                        "name": "Nighoj",
                        "latitude": "18.95972222",
                        "longitude": "74.27694444"
                    },
                    {
                        "id": 133217,
                        "name": "Nilanga",
                        "latitude": "18.11675000",
                        "longitude": "76.75279000"
                    },
                    {
                        "id": 133220,
                        "name": "Nipani",
                        "latitude": "16.39900000",
                        "longitude": "74.38285000"
                    },
                    {
                        "id": 147848,
                        "name": "Niphad",
                        "latitude": "20.08330000",
                        "longitude": "73.80000000"
                    },
                    {
                        "id": 147849,
                        "name": "Nira Narsingpur",
                        "latitude": "17.98350000",
                        "longitude": "75.12396000"
                    },
                    {
                        "id": 133305,
                        "name": "Osmanabad",
                        "latitude": "18.25000000",
                        "longitude": "76.16667000"
                    },
                    {
                        "id": 133307,
                        "name": "Ozar",
                        "latitude": "20.09473000",
                        "longitude": "73.92816000"
                    },
                    {
                        "id": 147850,
                        "name": "Pabal",
                        "latitude": "18.83083333",
                        "longitude": "74.05277778"
                    },
                    {
                        "id": 133520,
                        "name": "Pachora",
                        "latitude": "20.66727000",
                        "longitude": "75.35305000"
                    },
                    {
                        "id": 147851,
                        "name": "Pahur Maharashtra",
                        "latitude": "20.70000000",
                        "longitude": "75.68333333"
                    },
                    {
                        "id": 133319,
                        "name": "Paithan",
                        "latitude": "19.47506000",
                        "longitude": "75.38558000"
                    },
                    {
                        "id": 133527,
                        "name": "Palghar",
                        "latitude": "19.69693000",
                        "longitude": "72.76543000"
                    },
                    {
                        "id": 147852,
                        "name": "Pali Raigad",
                        "latitude": "18.54138400",
                        "longitude": "73.21996500"
                    },
                    {
                        "id": 147853,
                        "name": "Palso",
                        "latitude": "20.76666667",
                        "longitude": "77.23333333"
                    },
                    {
                        "id": 133537,
                        "name": "Panchgani",
                        "latitude": "17.92449000",
                        "longitude": "73.80080000"
                    },
                    {
                        "id": 133347,
                        "name": "Pandharpur",
                        "latitude": "17.67924000",
                        "longitude": "75.33098000"
                    },
                    {
                        "id": 147854,
                        "name": "Pandhurli",
                        "latitude": "19.82905200",
                        "longitude": "73.85474500"
                    },
                    {
                        "id": 133349,
                        "name": "Panhala",
                        "latitude": "16.81210000",
                        "longitude": "74.11007000"
                    },
                    {
                        "id": 133353,
                        "name": "Panvel",
                        "latitude": "18.98878000",
                        "longitude": "73.11013000"
                    },
                    {
                        "id": 133358,
                        "name": "Parbhani",
                        "latitude": "19.50000000",
                        "longitude": "76.75000000"
                    },
                    {
                        "id": 147855,
                        "name": "Parel",
                        "latitude": "18.99000000",
                        "longitude": "72.84000000"
                    },
                    {
                        "id": 133360,
                        "name": "Parli Vaijnath",
                        "latitude": "18.85057000",
                        "longitude": "76.53163000"
                    },
                    {
                        "id": 147856,
                        "name": "Parner",
                        "latitude": "19.00300000",
                        "longitude": "74.43800000"
                    },
                    {
                        "id": 133364,
                        "name": "Parola",
                        "latitude": "20.88098000",
                        "longitude": "75.11937000"
                    },
                    {
                        "id": 147857,
                        "name": "Parseoni",
                        "latitude": "21.38333333",
                        "longitude": "79.15000000"
                    },
                    {
                        "id": 133367,
                        "name": "Partur",
                        "latitude": "19.59925000",
                        "longitude": "76.21541000"
                    },
                    {
                        "id": 133554,
                        "name": "Patan",
                        "latitude": "17.37513000",
                        "longitude": "73.90143000"
                    },
                    {
                        "id": 133556,
                        "name": "Pathardi",
                        "latitude": "19.17279000",
                        "longitude": "75.17425000"
                    },
                    {
                        "id": 133558,
                        "name": "Pathri",
                        "latitude": "19.25880000",
                        "longitude": "76.43412000"
                    },
                    {
                        "id": 133559,
                        "name": "Patur",
                        "latitude": "20.46093000",
                        "longitude": "76.93725000"
                    },
                    {
                        "id": 147858,
                        "name": "Paturda",
                        "latitude": "20.95000000",
                        "longitude": "76.71666667"
                    },
                    {
                        "id": 147859,
                        "name": "Paud",
                        "latitude": "18.52416667",
                        "longitude": "73.61583333"
                    },
                    {
                        "id": 147860,
                        "name": "Pauni",
                        "latitude": "20.78000000",
                        "longitude": "79.63000000"
                    },
                    {
                        "id": 133397,
                        "name": "Pawni",
                        "latitude": "20.79229000",
                        "longitude": "79.63644000"
                    },
                    {
                        "id": 147861,
                        "name": "Pedgaon",
                        "latitude": "18.51166667",
                        "longitude": "74.70750000"
                    },
                    {
                        "id": 147862,
                        "name": "Peint",
                        "latitude": "20.25844722",
                        "longitude": "73.50305278"
                    },
                    {
                        "id": 133404,
                        "name": "Pen",
                        "latitude": "18.73734000",
                        "longitude": "73.09603000"
                    },
                    {
                        "id": 133434,
                        "name": "Phaltan",
                        "latitude": "17.99113000",
                        "longitude": "74.43177000"
                    },
                    {
                        "id": 147863,
                        "name": "Phulambri",
                        "latitude": "20.10000000",
                        "longitude": "75.41666667"
                    },
                    {
                        "id": 147864,
                        "name": "Piliv",
                        "latitude": "17.67884200",
                        "longitude": "74.96641200"
                    },
                    {
                        "id": 147865,
                        "name": "Pimpalgaon Baswant",
                        "latitude": "20.16666667",
                        "longitude": "73.98333333"
                    },
                    {
                        "id": 147866,
                        "name": "Pimpalgaon Raja",
                        "latitude": "20.71666667",
                        "longitude": "76.43333333"
                    },
                    {
                        "id": 133449,
                        "name": "Pimpri",
                        "latitude": "18.62292000",
                        "longitude": "73.80696000"
                    },
                    {
                        "id": 147867,
                        "name": "Pimpri-Chinchwad",
                        "latitude": "18.62777778",
                        "longitude": "73.81305556"
                    },
                    {
                        "id": 133564,
                        "name": "Pipri",
                        "latitude": "19.79371000",
                        "longitude": "75.53519000"
                    },
                    {
                        "id": 133484,
                        "name": "Powai",
                        "latitude": "19.11640000",
                        "longitude": "72.90471000"
                    },
                    {
                        "id": 147868,
                        "name": "Prabhadevi",
                        "latitude": "19.01690500",
                        "longitude": "72.82864900"
                    },
                    {
                        "id": 147869,
                        "name": "Prakasha",
                        "latitude": "21.51666667",
                        "longitude": "74.31666667"
                    },
                    {
                        "id": 133496,
                        "name": "Pulgaon",
                        "latitude": "20.72204000",
                        "longitude": "78.32056000"
                    },
                    {
                        "id": 133504,
                        "name": "Pune",
                        "latitude": "18.51957000",
                        "longitude": "73.85535000"
                    },
                    {
                        "id": 133505,
                        "name": "Pune Division",
                        "latitude": "18.74673000",
                        "longitude": "73.75465000"
                    },
                    {
                        "id": 147870,
                        "name": "Puntamba",
                        "latitude": "19.75000000",
                        "longitude": "74.63333333"
                    },
                    {
                        "id": 147871,
                        "name": "Pural",
                        "latitude": "16.45000000",
                        "longitude": "73.36666667"
                    },
                    {
                        "id": 133571,
                        "name": "Purna",
                        "latitude": "19.18170000",
                        "longitude": "77.02566000"
                    },
                    {
                        "id": 133515,
                        "name": "Pusad",
                        "latitude": "19.91274000",
                        "longitude": "77.57838000"
                    },
                    {
                        "id": 147872,
                        "name": "Radhanagari",
                        "latitude": "16.41388889",
                        "longitude": "73.99777778"
                    },
                    {
                        "id": 147873,
                        "name": "Rahata",
                        "latitude": "19.71666667",
                        "longitude": "74.48333333"
                    },
                    {
                        "id": 133583,
                        "name": "Rahimatpur",
                        "latitude": "17.59210000",
                        "longitude": "74.19966000"
                    },
                    {
                        "id": 133663,
                        "name": "Rahuri",
                        "latitude": "19.39069000",
                        "longitude": "74.64979000"
                    },
                    {
                        "id": 133588,
                        "name": "Raigarh",
                        "latitude": "18.57000000",
                        "longitude": "73.13000000"
                    },
                    {
                        "id": 147874,
                        "name": "Raireshwar",
                        "latitude": "18.05000000",
                        "longitude": "73.73333333"
                    },
                    {
                        "id": 133687,
                        "name": "Rajapur",
                        "latitude": "16.65679000",
                        "longitude": "73.51701000"
                    },
                    {
                        "id": 133677,
                        "name": "Rajgurunagar",
                        "latitude": "18.86667000",
                        "longitude": "73.90000000"
                    },
                    {
                        "id": 133685,
                        "name": "Rajur",
                        "latitude": "20.11087000",
                        "longitude": "78.89311000"
                    },
                    {
                        "id": 133689,
                        "name": "Rajura",
                        "latitude": "19.77947000",
                        "longitude": "79.36459000"
                    },
                    {
                        "id": 147875,
                        "name": "Ralegaon",
                        "latitude": "20.25000000",
                        "longitude": "79.81000000"
                    },
                    {
                        "id": 147876,
                        "name": "Ramewadi",
                        "latitude": "16.03333333",
                        "longitude": "74.35000000"
                    },
                    {
                        "id": 133710,
                        "name": "Ramtek",
                        "latitude": "21.39562000",
                        "longitude": "79.32725000"
                    },
                    {
                        "id": 133619,
                        "name": "Ratnagiri",
                        "latitude": "17.00000000",
                        "longitude": "73.50000000"
                    },
                    {
                        "id": 133724,
                        "name": "Raver",
                        "latitude": "21.24757000",
                        "longitude": "76.03509000"
                    },
                    {
                        "id": 147877,
                        "name": "Renapur",
                        "latitude": "18.51666667",
                        "longitude": "76.60000000"
                    },
                    {
                        "id": 147878,
                        "name": "Renavi",
                        "latitude": "17.26972222",
                        "longitude": "74.61055556"
                    },
                    {
                        "id": 133631,
                        "name": "Revadanda",
                        "latitude": "18.55363000",
                        "longitude": "72.92559000"
                    },
                    {
                        "id": 147879,
                        "name": "Revdanda",
                        "latitude": "18.55000000",
                        "longitude": "72.93333333"
                    },
                    {
                        "id": 133639,
                        "name": "Risod",
                        "latitude": "19.97671000",
                        "longitude": "76.78799000"
                    },
                    {
                        "id": 133644,
                        "name": "Roha",
                        "latitude": "18.43687000",
                        "longitude": "73.11964000"
                    },
                    {
                        "id": 147880,
                        "name": "Sailu",
                        "latitude": "19.47000000",
                        "longitude": "76.47000000"
                    },
                    {
                        "id": 147881,
                        "name": "Sakol",
                        "latitude": "18.28250000",
                        "longitude": "76.88444444"
                    },
                    {
                        "id": 147882,
                        "name": "Sakoli",
                        "latitude": "21.08000000",
                        "longitude": "79.98000000"
                    },
                    {
                        "id": 147883,
                        "name": "Sakri",
                        "latitude": "20.99027778",
                        "longitude": "74.31444444"
                    },
                    {
                        "id": 147884,
                        "name": "Samudrapur",
                        "latitude": "20.65000000",
                        "longitude": "78.96666667"
                    },
                    {
                        "id": 147885,
                        "name": "Sangameshwar",
                        "latitude": "17.18694444",
                        "longitude": "73.55305556"
                    },
                    {
                        "id": 133780,
                        "name": "Sangamner",
                        "latitude": "19.56784000",
                        "longitude": "74.21154000"
                    },
                    {
                        "id": 133782,
                        "name": "Sangli",
                        "latitude": "17.11202000",
                        "longitude": "74.76990000"
                    },
                    {
                        "id": 134074,
                        "name": "Sangola",
                        "latitude": "17.43948000",
                        "longitude": "75.19379000"
                    },
                    {
                        "id": 147887,
                        "name": "Sangrampur Maharashtra",
                        "latitude": "21.03000000",
                        "longitude": "76.68000000"
                    },
                    {
                        "id": 147888,
                        "name": "Saoli",
                        "latitude": "20.08133056",
                        "longitude": "79.78286111"
                    },
                    {
                        "id": 133797,
                        "name": "Saoner",
                        "latitude": "21.38510000",
                        "longitude": "78.92155000"
                    },
                    {
                        "id": 147889,
                        "name": "Sarangkheda",
                        "latitude": "21.43327300",
                        "longitude": "74.52642100"
                    },
                    {
                        "id": 147890,
                        "name": "Saswad",
                        "latitude": "18.55000000",
                        "longitude": "74.00000000"
                    },
                    {
                        "id": 133825,
                        "name": "Satana",
                        "latitude": "20.59483000",
                        "longitude": "74.20301000"
                    },
                    {
                        "id": 133815,
                        "name": "Satara",
                        "latitude": "17.68589000",
                        "longitude": "73.99333000"
                    },
                    {
                        "id": 133816,
                        "name": "Satara Division",
                        "latitude": "17.72601000",
                        "longitude": "74.06433000"
                    },
                    {
                        "id": 147891,
                        "name": "Satpati",
                        "latitude": "19.71666667",
                        "longitude": "72.70000000"
                    },
                    {
                        "id": 134082,
                        "name": "Savantvadi",
                        "latitude": "15.90413000",
                        "longitude": "73.82191000"
                    },
                    {
                        "id": 134083,
                        "name": "Savda",
                        "latitude": "21.15054000",
                        "longitude": "75.88938000"
                    },
                    {
                        "id": 147892,
                        "name": "Savlaj",
                        "latitude": "17.10000000",
                        "longitude": "74.78000000"
                    },
                    {
                        "id": 147893,
                        "name": "Sawantvadi",
                        "latitude": "16.00000000",
                        "longitude": "73.75000000"
                    },
                    {
                        "id": 133836,
                        "name": "Selu",
                        "latitude": "19.45512000",
                        "longitude": "76.44073000"
                    },
                    {
                        "id": 147894,
                        "name": "Sevagram",
                        "latitude": "20.73499167",
                        "longitude": "78.66256944"
                    },
                    {
                        "id": 147895,
                        "name": "Sewri",
                        "latitude": "19.00000000",
                        "longitude": "72.86000000"
                    },
                    {
                        "id": 133908,
                        "name": "Shahada",
                        "latitude": "21.54538000",
                        "longitude": "74.47106000"
                    },
                    {
                        "id": 133909,
                        "name": "Shahapur",
                        "latitude": "19.45231000",
                        "longitude": "73.32572000"
                    },
                    {
                        "id": 147896,
                        "name": "Shedbal",
                        "latitude": "16.68916667",
                        "longitude": "74.75425556"
                    },
                    {
                        "id": 133857,
                        "name": "Shegaon",
                        "latitude": "20.79320000",
                        "longitude": "76.69921000"
                    },
                    {
                        "id": 147897,
                        "name": "Shevgaon",
                        "latitude": "19.35000000",
                        "longitude": "75.23333333"
                    },
                    {
                        "id": 147898,
                        "name": "Shikrapur",
                        "latitude": "18.69361111",
                        "longitude": "74.13805556"
                    },
                    {
                        "id": 133873,
                        "name": "Shiraguppi",
                        "latitude": "16.61875000",
                        "longitude": "74.70907000"
                    },
                    {
                        "id": 147899,
                        "name": "Shirala",
                        "latitude": "16.98401111",
                        "longitude": "74.12415278"
                    },
                    {
                        "id": 133874,
                        "name": "Shirdi",
                        "latitude": "19.76616000",
                        "longitude": "74.47738000"
                    },
                    {
                        "id": 133875,
                        "name": "Shirgaon",
                        "latitude": "19.69589000",
                        "longitude": "72.71527000"
                    },
                    {
                        "id": 147900,
                        "name": "Shirol",
                        "latitude": "16.73333333",
                        "longitude": "74.60000000"
                    },
                    {
                        "id": 133877,
                        "name": "Shirpur",
                        "latitude": "21.34821000",
                        "longitude": "74.88035000"
                    },
                    {
                        "id": 147901,
                        "name": "Shirud",
                        "latitude": "20.71666667",
                        "longitude": "74.90000000"
                    },
                    {
                        "id": 133878,
                        "name": "Shirwal",
                        "latitude": "18.15059000",
                        "longitude": "73.97788000"
                    },
                    {
                        "id": 133879,
                        "name": "Shivaji Nagar",
                        "latitude": "18.53017000",
                        "longitude": "73.85263000"
                    },
                    {
                        "id": 133886,
                        "name": "Shrigonda",
                        "latitude": "18.61527000",
                        "longitude": "74.69895000"
                    },
                    {
                        "id": 133936,
                        "name": "Sillod",
                        "latitude": "20.30303000",
                        "longitude": "75.65284000"
                    },
                    {
                        "id": 147902,
                        "name": "Sindewahi",
                        "latitude": "20.28333333",
                        "longitude": "79.65000000"
                    },
                    {
                        "id": 133943,
                        "name": "Sindhudurg",
                        "latitude": "16.17000000",
                        "longitude": "73.70000000"
                    },
                    {
                        "id": 133944,
                        "name": "Sindi",
                        "latitude": "20.80509000",
                        "longitude": "78.88752000"
                    },
                    {
                        "id": 147903,
                        "name": "Sindkheda",
                        "latitude": "21.26666667",
                        "longitude": "74.73333333"
                    },
                    {
                        "id": 133953,
                        "name": "Sinnar",
                        "latitude": "19.84505000",
                        "longitude": "73.99866000"
                    },
                    {
                        "id": 147904,
                        "name": "Sion Mumbai",
                        "latitude": "19.04000000",
                        "longitude": "72.86000000"
                    },
                    {
                        "id": 147905,
                        "name": "Sironcha",
                        "latitude": "18.83000000",
                        "longitude": "79.96000000"
                    },
                    {
                        "id": 133970,
                        "name": "Sirur",
                        "latitude": "18.82760000",
                        "longitude": "74.37475000"
                    },
                    {
                        "id": 147906,
                        "name": "Sivala East Godavari district",
                        "latitude": "16.75722222",
                        "longitude": "82.08861111"
                    },
                    {
                        "id": 133986,
                        "name": "Solapur",
                        "latitude": "17.75000000",
                        "longitude": "75.50000000"
                    },
                    {
                        "id": 147907,
                        "name": "Sonala",
                        "latitude": "21.11666667",
                        "longitude": "76.73333333"
                    },
                    {
                        "id": 133993,
                        "name": "Sonegaon",
                        "latitude": "20.62915000",
                        "longitude": "78.69207000"
                    },
                    {
                        "id": 147908,
                        "name": "Songir",
                        "latitude": "21.08333333",
                        "longitude": "74.78333333"
                    },
                    {
                        "id": 147909,
                        "name": "Sonvad",
                        "latitude": "21.08333333",
                        "longitude": "75.35000000"
                    },
                    {
                        "id": 134015,
                        "name": "Soygaon",
                        "latitude": "20.59606000",
                        "longitude": "75.61765000"
                    },
                    {
                        "id": 134033,
                        "name": "Srivardhan",
                        "latitude": "18.04592000",
                        "longitude": "73.01552000"
                    },
                    {
                        "id": 134052,
                        "name": "Surgana",
                        "latitude": "20.55956000",
                        "longitude": "73.63747000"
                    },
                    {
                        "id": 147910,
                        "name": "Taklibhan",
                        "latitude": "19.61670000",
                        "longitude": "74.80000000"
                    },
                    {
                        "id": 147911,
                        "name": "Talbid",
                        "latitude": "17.35000000",
                        "longitude": "74.13000000"
                    },
                    {
                        "id": 134100,
                        "name": "Talegaon Dabhade",
                        "latitude": "18.73502000",
                        "longitude": "73.67561000"
                    },
                    {
                        "id": 147912,
                        "name": "Talegaon Dhamdhere",
                        "latitude": "18.66780000",
                        "longitude": "74.15360000"
                    },
                    {
                        "id": 134104,
                        "name": "Taloda",
                        "latitude": "21.56128000",
                        "longitude": "74.21238000"
                    },
                    {
                        "id": 147913,
                        "name": "Talode",
                        "latitude": "21.56074167",
                        "longitude": "74.83000000"
                    },
                    {
                        "id": 134241,
                        "name": "Tarapur",
                        "latitude": "19.86499000",
                        "longitude": "72.68426000"
                    },
                    {
                        "id": 147914,
                        "name": "Tardeo",
                        "latitude": "18.97000000",
                        "longitude": "72.81000000"
                    },
                    {
                        "id": 134242,
                        "name": "Tasgaon",
                        "latitude": "17.03700000",
                        "longitude": "74.60171000"
                    },
                    {
                        "id": 134128,
                        "name": "Telhara",
                        "latitude": "21.02694000",
                        "longitude": "76.83889000"
                    },
                    {
                        "id": 147915,
                        "name": "Thalner",
                        "latitude": "21.25000000",
                        "longitude": "74.96670000"
                    },
                    {
                        "id": 134138,
                        "name": "Thane",
                        "latitude": "19.33333000",
                        "longitude": "73.25000000"
                    },
                    {
                        "id": 134212,
                        "name": "Trimbak",
                        "latitude": "19.93268000",
                        "longitude": "73.52907000"
                    },
                    {
                        "id": 147916,
                        "name": "Trombay",
                        "latitude": "19.00000000",
                        "longitude": "72.90000000"
                    },
                    {
                        "id": 134217,
                        "name": "Tuljapur",
                        "latitude": "18.00804000",
                        "longitude": "76.07011000"
                    },
                    {
                        "id": 134221,
                        "name": "Tumsar",
                        "latitude": "21.38333000",
                        "longitude": "79.73333000"
                    },
                    {
                        "id": 134255,
                        "name": "Udgir",
                        "latitude": "18.39258000",
                        "longitude": "77.11756000"
                    },
                    {
                        "id": 134267,
                        "name": "Ulhasnagar",
                        "latitude": "19.21667000",
                        "longitude": "73.15000000"
                    },
                    {
                        "id": 134269,
                        "name": "Umarga",
                        "latitude": "17.83841000",
                        "longitude": "76.62331000"
                    },
                    {
                        "id": 134272,
                        "name": "Umarkhed",
                        "latitude": "19.60144000",
                        "longitude": "77.68878000"
                    },
                    {
                        "id": 134274,
                        "name": "Umred",
                        "latitude": "20.85396000",
                        "longitude": "79.32466000"
                    },
                    {
                        "id": 134291,
                        "name": "Uran",
                        "latitude": "18.87813000",
                        "longitude": "72.93924000"
                    },
                    {
                        "id": 147917,
                        "name": "Uruli Kanchan",
                        "latitude": "18.48333333",
                        "longitude": "74.13333333"
                    },
                    {
                        "id": 134379,
                        "name": "Vada",
                        "latitude": "19.65347000",
                        "longitude": "73.14811000"
                    },
                    {
                        "id": 147918,
                        "name": "Vadgaon",
                        "latitude": "18.74860000",
                        "longitude": "73.64100000"
                    },
                    {
                        "id": 147919,
                        "name": "Vadner",
                        "latitude": "20.25000000",
                        "longitude": "74.03330000"
                    },
                    {
                        "id": 134312,
                        "name": "Vaijapur",
                        "latitude": "19.92672000",
                        "longitude": "74.72750000"
                    },
                    {
                        "id": 147920,
                        "name": "Vairag",
                        "latitude": "18.05000000",
                        "longitude": "75.80000000"
                    },
                    {
                        "id": 147921,
                        "name": "Valsang",
                        "latitude": "17.60000000",
                        "longitude": "76.08330000"
                    },
                    {
                        "id": 147922,
                        "name": "Vangaon",
                        "latitude": "19.86666667",
                        "longitude": "72.75000000"
                    },
                    {
                        "id": 134328,
                        "name": "Varangaon",
                        "latitude": "21.01767000",
                        "longitude": "75.91042000"
                    },
                    {
                        "id": 147923,
                        "name": "Vashi",
                        "latitude": "19.08000000",
                        "longitude": "73.01000000"
                    },
                    {
                        "id": 134334,
                        "name": "Vasind",
                        "latitude": "19.40844000",
                        "longitude": "73.26285000"
                    },
                    {
                        "id": 147924,
                        "name": "Vatul",
                        "latitude": "16.75000000",
                        "longitude": "73.60000000"
                    },
                    {
                        "id": 147925,
                        "name": "Velas Maharashtra",
                        "latitude": "17.95850000",
                        "longitude": "73.04980000"
                    },
                    {
                        "id": 147926,
                        "name": "Velneshwar",
                        "latitude": "17.38330000",
                        "longitude": "73.20000000"
                    },
                    {
                        "id": 134346,
                        "name": "Vengurla",
                        "latitude": "15.86125000",
                        "longitude": "73.63182000"
                    },
                    {
                        "id": 147927,
                        "name": "Vijaydurg",
                        "latitude": "16.56670000",
                        "longitude": "73.33330000"
                    },
                    {
                        "id": 147928,
                        "name": "Vikhroli",
                        "latitude": "19.11000000",
                        "longitude": "72.94000000"
                    },
                    {
                        "id": 147929,
                        "name": "Vile Parle",
                        "latitude": "19.10000000",
                        "longitude": "72.83000000"
                    },
                    {
                        "id": 147930,
                        "name": "Vinchur",
                        "latitude": "20.11666667",
                        "longitude": "74.28333333"
                    },
                    {
                        "id": 134368,
                        "name": "Virar",
                        "latitude": "19.45591000",
                        "longitude": "72.81136000"
                    },
                    {
                        "id": 147931,
                        "name": "Vita Maharashtra",
                        "latitude": "17.27110000",
                        "longitude": "74.53780000"
                    },
                    {
                        "id": 134372,
                        "name": "Vite",
                        "latitude": "17.27343000",
                        "longitude": "74.53792000"
                    },
                    {
                        "id": 147932,
                        "name": "Wadala",
                        "latitude": "19.02163056",
                        "longitude": "72.86458889"
                    },
                    {
                        "id": 134388,
                        "name": "Wadgaon",
                        "latitude": "18.73920000",
                        "longitude": "73.63945000"
                    },
                    {
                        "id": 147933,
                        "name": "Wadner",
                        "latitude": "20.84972222",
                        "longitude": "76.33333333"
                    },
                    {
                        "id": 147934,
                        "name": "Wadwani",
                        "latitude": "18.98333333",
                        "longitude": "76.05000000"
                    },
                    {
                        "id": 147935,
                        "name": "Wagholi",
                        "latitude": "17.90000000",
                        "longitude": "74.08300000"
                    },
                    {
                        "id": 134390,
                        "name": "Wai",
                        "latitude": "17.95276000",
                        "longitude": "73.89058000"
                    },
                    {
                        "id": 147936,
                        "name": "Wakad",
                        "latitude": "18.59930000",
                        "longitude": "73.76250000"
                    },
                    {
                        "id": 147937,
                        "name": "Walgaon",
                        "latitude": "20.99890000",
                        "longitude": "77.70640000"
                    },
                    {
                        "id": 147938,
                        "name": "Walki",
                        "latitude": "18.95000000",
                        "longitude": "74.75000000"
                    },
                    {
                        "id": 134393,
                        "name": "Wani",
                        "latitude": "20.05507000",
                        "longitude": "78.95313000"
                    },
                    {
                        "id": 134396,
                        "name": "Wardha",
                        "latitude": "20.73933000",
                        "longitude": "78.59784000"
                    },
                    {
                        "id": 134397,
                        "name": "Warora",
                        "latitude": "20.22885000",
                        "longitude": "79.00277000"
                    },
                    {
                        "id": 134398,
                        "name": "Warud",
                        "latitude": "21.47101000",
                        "longitude": "78.26965000"
                    },
                    {
                        "id": 134399,
                        "name": "Washim",
                        "latitude": "20.20000000",
                        "longitude": "77.20000000"
                    },
                    {
                        "id": 147939,
                        "name": "Worli",
                        "latitude": "19.00000000",
                        "longitude": "72.81500000"
                    },
                    {
                        "id": 134438,
                        "name": "Yaval",
                        "latitude": "21.16772000",
                        "longitude": "75.69762000"
                    },
                    {
                        "id": 134427,
                        "name": "Yavatmal",
                        "latitude": "20.15000000",
                        "longitude": "78.35000000"
                    },
                    {
                        "id": 134434,
                        "name": "Yeola",
                        "latitude": "20.04240000",
                        "longitude": "74.48944000"
                    }
                ]
            },
            {
                "id": 4010,
                "name": "Manipur",
                "iso2": "MN",
                "latitude": "24.66371730",
                "longitude": "93.90626880",
                "type": "state",
                "cities": [
                    {
                        "id": 58064,
                        "name": "Bishnupur",
                        "latitude": "24.60769000",
                        "longitude": "93.77998000"
                    },
                    {
                        "id": 153522,
                        "name": "Chandel",
                        "latitude": "24.57390000",
                        "longitude": "94.29130000"
                    },
                    {
                        "id": 131585,
                        "name": "Churachandpur",
                        "latitude": "24.33333000",
                        "longitude": "93.68333000"
                    },
                    {
                        "id": 132162,
                        "name": "Imphal East",
                        "latitude": "24.79110000",
                        "longitude": "93.93480000"
                    },
                    {
                        "id": 132953,
                        "name": "Imphal West",
                        "latitude": "24.60998000",
                        "longitude": "93.88873000"
                    },
                    {
                        "id": 153527,
                        "name": "Jiribam",
                        "latitude": "24.79410040",
                        "longitude": "93.11709860"
                    },
                    {
                        "id": 132341,
                        "name": "Kakching",
                        "latitude": "24.49820000",
                        "longitude": "93.98126000"
                    },
                    {
                        "id": 153526,
                        "name": "Kamjong",
                        "latitude": "24.85996860",
                        "longitude": "94.50586430"
                    },
                    {
                        "id": 153523,
                        "name": "Kangpokpi",
                        "latitude": "24.08950000",
                        "longitude": "93.99010000"
                    },
                    {
                        "id": 153528,
                        "name": "Noney",
                        "latitude": "24.84911310",
                        "longitude": "93.59673660"
                    },
                    {
                        "id": 153525,
                        "name": "Pherzawl",
                        "latitude": "24.14370000",
                        "longitude": "93.52700000"
                    },
                    {
                        "id": 133837,
                        "name": "Senapati",
                        "latitude": "25.26705000",
                        "longitude": "94.02237000"
                    },
                    {
                        "id": 134109,
                        "name": "Tamenglong",
                        "latitude": "24.97548000",
                        "longitude": "93.51563000"
                    },
                    {
                        "id": 153524,
                        "name": "Tengnoupal",
                        "latitude": "24.39450000",
                        "longitude": "94.10530000"
                    },
                    {
                        "id": 134159,
                        "name": "Thoubal",
                        "latitude": "24.62205000",
                        "longitude": "94.01001000"
                    },
                    {
                        "id": 134264,
                        "name": "Ukhrul",
                        "latitude": "25.04828000",
                        "longitude": "94.35883000"
                    }
                ]
            },
            {
                "id": 4006,
                "name": "Meghalaya",
                "iso2": "ML",
                "latitude": "25.46703080",
                "longitude": "91.36621600",
                "type": "state",
                "cities": [
                    {
                        "id": 131520,
                        "name": "Cherrapunji",
                        "latitude": "25.30089000",
                        "longitude": "91.69619000"
                    },
                    {
                        "id": 131824,
                        "name": "East Garo Hills",
                        "latitude": "25.61372000",
                        "longitude": "90.62426000"
                    },
                    {
                        "id": 131825,
                        "name": "East Jaintia Hills",
                        "latitude": "25.35976000",
                        "longitude": "92.36680000"
                    },
                    {
                        "id": 131827,
                        "name": "East Khasi Hills",
                        "latitude": "25.38050000",
                        "longitude": "91.78905000"
                    },
                    {
                        "id": 132858,
                        "name": "Mairang",
                        "latitude": "25.56165000",
                        "longitude": "91.63602000"
                    },
                    {
                        "id": 132916,
                        "name": "Mankachar",
                        "latitude": "25.53347000",
                        "longitude": "89.86373000"
                    },
                    {
                        "id": 133232,
                        "name": "Nongpoh",
                        "latitude": "25.90230000",
                        "longitude": "91.87694000"
                    },
                    {
                        "id": 133233,
                        "name": "Nongstoin",
                        "latitude": "25.51704000",
                        "longitude": "91.26484000"
                    },
                    {
                        "id": 133237,
                        "name": "North Garo Hills",
                        "latitude": "25.89682000",
                        "longitude": "90.61602000"
                    },
                    {
                        "id": 133636,
                        "name": "Ri-Bhoi",
                        "latitude": "25.88997000",
                        "longitude": "91.82707000"
                    },
                    {
                        "id": 133870,
                        "name": "Shillong",
                        "latitude": "25.56892000",
                        "longitude": "91.88313000"
                    },
                    {
                        "id": 134009,
                        "name": "South Garo Hills",
                        "latitude": "25.30162000",
                        "longitude": "90.58530000"
                    },
                    {
                        "id": 134013,
                        "name": "South West Garo Hills",
                        "latitude": "25.47245000",
                        "longitude": "89.93399000"
                    },
                    {
                        "id": 134014,
                        "name": "South West Khasi Hills",
                        "latitude": "25.32155000",
                        "longitude": "91.29462000"
                    },
                    {
                        "id": 134223,
                        "name": "Tura",
                        "latitude": "25.51421000",
                        "longitude": "90.20239000"
                    },
                    {
                        "id": 134406,
                        "name": "West Garo Hills",
                        "latitude": "25.56794000",
                        "longitude": "90.22447000"
                    },
                    {
                        "id": 134408,
                        "name": "West Jaintia Hills",
                        "latitude": "25.50000000",
                        "longitude": "92.25000000"
                    },
                    {
                        "id": 134410,
                        "name": "West Khasi Hills",
                        "latitude": "25.54776000",
                        "longitude": "91.26957000"
                    }
                ]
            },
            {
                "id": 4036,
                "name": "Mizoram",
                "iso2": "MZ",
                "latitude": "23.16454300",
                "longitude": "92.93757390",
                "type": "state",
                "cities": [
                    {
                        "id": 57610,
                        "name": "Aizawl",
                        "latitude": "23.80000000",
                        "longitude": "92.90000000"
                    },
                    {
                        "id": 58184,
                        "name": "Champhai",
                        "latitude": "23.47444000",
                        "longitude": "93.32556000"
                    },
                    {
                        "id": 131656,
                        "name": "Darlawn",
                        "latitude": "24.01336000",
                        "longitude": "92.92439000"
                    },
                    {
                        "id": 132486,
                        "name": "Khawhai",
                        "latitude": "23.37807000",
                        "longitude": "93.12797000"
                    },
                    {
                        "id": 132554,
                        "name": "Kolasib",
                        "latitude": "24.22388000",
                        "longitude": "92.67869000"
                    },
                    {
                        "id": 132761,
                        "name": "Lawngtlai",
                        "latitude": "22.53000000",
                        "longitude": "92.90000000"
                    },
                    {
                        "id": 132787,
                        "name": "Lunglei",
                        "latitude": "22.90000000",
                        "longitude": "92.75000000"
                    },
                    {
                        "id": 132879,
                        "name": "Mamit",
                        "latitude": "23.78492000",
                        "longitude": "92.46939000"
                    },
                    {
                        "id": 133242,
                        "name": "North Vanlaiphai",
                        "latitude": "23.13227000",
                        "longitude": "93.06532000"
                    },
                    {
                        "id": 133756,
                        "name": "Saiha",
                        "latitude": "22.49183000",
                        "longitude": "92.98143000"
                    },
                    {
                        "id": 133759,
                        "name": "Sairang",
                        "latitude": "23.81034000",
                        "longitude": "92.65226000"
                    },
                    {
                        "id": 134063,
                        "name": "Saitlaw",
                        "latitude": "23.97187000",
                        "longitude": "92.57454000"
                    },
                    {
                        "id": 133847,
                        "name": "Serchhip",
                        "latitude": "23.28172000",
                        "longitude": "92.90039000"
                    },
                    {
                        "id": 134148,
                        "name": "Thenzawl",
                        "latitude": "23.31667000",
                        "longitude": "92.75000000"
                    }
                ]
            },
            {
                "id": 4018,
                "name": "Nagaland",
                "iso2": "NL",
                "latitude": "26.15843540",
                "longitude": "94.56244260",
                "type": "state",
                "cities": [
                    {
                        "id": 131771,
                        "name": "Dimapur",
                        "latitude": "25.77852000",
                        "longitude": "93.78508000"
                    },
                    {
                        "id": 132549,
                        "name": "Kohima",
                        "latitude": "25.67467000",
                        "longitude": "94.11099000"
                    },
                    {
                        "id": 132989,
                        "name": "Mokokchung",
                        "latitude": "26.31393000",
                        "longitude": "94.51675000"
                    },
                    {
                        "id": 132990,
                        "name": "Mon",
                        "latitude": "26.75000000",
                        "longitude": "94.83333000"
                    },
                    {
                        "id": 133416,
                        "name": "Peren",
                        "latitude": "25.51276000",
                        "longitude": "93.73716000"
                    },
                    {
                        "id": 133438,
                        "name": "Phek",
                        "latitude": "25.75000000",
                        "longitude": "94.50000000"
                    },
                    {
                        "id": 134215,
                        "name": "Tuensang",
                        "latitude": "26.26704000",
                        "longitude": "94.82415000"
                    },
                    {
                        "id": 134216,
                        "name": "Tuensang District",
                        "latitude": "26.25000000",
                        "longitude": "94.75000000"
                    },
                    {
                        "id": 134413,
                        "name": "Wokha",
                        "latitude": "26.16667000",
                        "longitude": "94.25000000"
                    },
                    {
                        "id": 134445,
                        "name": "Zunheboto",
                        "latitude": "26.00000000",
                        "longitude": "94.50000000"
                    }
                ]
            },
            {
                "id": 4013,
                "name": "Odisha",
                "iso2": "OR",
                "latitude": "20.95166580",
                "longitude": "85.09852360",
                "type": "state",
                "cities": [
                    {
                        "id": 57704,
                        "name": "Angul",
                        "latitude": "20.84089000",
                        "longitude": "85.10192000"
                    },
                    {
                        "id": 57705,
                        "name": "Angul District",
                        "latitude": "20.84903000",
                        "longitude": "85.06079000"
                    },
                    {
                        "id": 134465,
                        "name": "Asika",
                        "latitude": "19.61114000",
                        "longitude": "84.65998000"
                    },
                    {
                        "id": 134467,
                        "name": "Athagarh",
                        "latitude": "20.51999000",
                        "longitude": "85.62965000"
                    },
                    {
                        "id": 57785,
                        "name": "Bada Barabil",
                        "latitude": "22.11186000",
                        "longitude": "85.38684000"
                    },
                    {
                        "id": 57835,
                        "name": "Balangir",
                        "latitude": "20.75000000",
                        "longitude": "83.25000000"
                    },
                    {
                        "id": 57823,
                        "name": "Balasore",
                        "latitude": "21.49266000",
                        "longitude": "86.93348000"
                    },
                    {
                        "id": 58114,
                        "name": "Baleshwar",
                        "latitude": "21.50000000",
                        "longitude": "86.75000000"
                    },
                    {
                        "id": 57826,
                        "name": "Balimila",
                        "latitude": "18.25167000",
                        "longitude": "82.10659000"
                    },
                    {
                        "id": 58117,
                        "name": "Balugaon",
                        "latitude": "20.17838000",
                        "longitude": "85.11327000"
                    },
                    {
                        "id": 58123,
                        "name": "Banapur",
                        "latitude": "19.77889000",
                        "longitude": "85.17033000"
                    },
                    {
                        "id": 58128,
                        "name": "Banki",
                        "latitude": "20.37912000",
                        "longitude": "85.52953000"
                    },
                    {
                        "id": 58129,
                        "name": "Banposh",
                        "latitude": "22.24834000",
                        "longitude": "84.81044000"
                    },
                    {
                        "id": 57862,
                        "name": "Baragarh",
                        "latitude": "21.33333000",
                        "longitude": "83.61667000"
                    },
                    {
                        "id": 57866,
                        "name": "Barbil",
                        "latitude": "22.10194000",
                        "longitude": "85.37752000"
                    },
                    {
                        "id": 57869,
                        "name": "Bargarh",
                        "latitude": "21.33348000",
                        "longitude": "83.61905000"
                    },
                    {
                        "id": 57886,
                        "name": "Barpali",
                        "latitude": "21.19005000",
                        "longitude": "83.58721000"
                    },
                    {
                        "id": 58149,
                        "name": "Basudebpur",
                        "latitude": "21.11974000",
                        "longitude": "86.72896000"
                    },
                    {
                        "id": 57907,
                        "name": "Baud",
                        "latitude": "20.83773000",
                        "longitude": "84.32618000"
                    },
                    {
                        "id": 57908,
                        "name": "Baudh",
                        "latitude": "20.83300000",
                        "longitude": "84.33300000"
                    },
                    {
                        "id": 57921,
                        "name": "Belaguntha",
                        "latitude": "19.88249000",
                        "longitude": "84.63801000"
                    },
                    {
                        "id": 57953,
                        "name": "Bhadrak",
                        "latitude": "21.00000000",
                        "longitude": "86.60000000"
                    },
                    {
                        "id": 57954,
                        "name": "Bhadrakh",
                        "latitude": "21.05447000",
                        "longitude": "86.51560000"
                    },
                    {
                        "id": 57963,
                        "name": "Bhanjanagar",
                        "latitude": "19.92719000",
                        "longitude": "84.58201000"
                    },
                    {
                        "id": 57976,
                        "name": "Bhawanipatna",
                        "latitude": "19.90717000",
                        "longitude": "83.16697000"
                    },
                    {
                        "id": 57999,
                        "name": "Bhuban",
                        "latitude": "20.88197000",
                        "longitude": "85.83334000"
                    },
                    {
                        "id": 58000,
                        "name": "Bhubaneswar",
                        "latitude": "20.27241000",
                        "longitude": "85.83385000"
                    },
                    {
                        "id": 58058,
                        "name": "Binka",
                        "latitude": "21.02626000",
                        "longitude": "83.81197000"
                    },
                    {
                        "id": 58060,
                        "name": "Birmitrapur",
                        "latitude": "22.40000000",
                        "longitude": "84.76667000"
                    },
                    {
                        "id": 58079,
                        "name": "Bolanikhodan",
                        "latitude": "22.11312000",
                        "longitude": "85.33645000"
                    },
                    {
                        "id": 58086,
                        "name": "Brahmapur",
                        "latitude": "19.31151000",
                        "longitude": "84.79290000"
                    },
                    {
                        "id": 58087,
                        "name": "Brajarajnagar",
                        "latitude": "21.81667000",
                        "longitude": "83.91667000"
                    },
                    {
                        "id": 58092,
                        "name": "Buguda",
                        "latitude": "19.80806000",
                        "longitude": "84.79084000"
                    },
                    {
                        "id": 58099,
                        "name": "Burla",
                        "latitude": "21.50976000",
                        "longitude": "83.87259000"
                    },
                    {
                        "id": 131594,
                        "name": "Champua",
                        "latitude": "22.06734000",
                        "longitude": "85.66463000"
                    },
                    {
                        "id": 131597,
                        "name": "Chandbali",
                        "latitude": "20.77519000",
                        "longitude": "86.74139000"
                    },
                    {
                        "id": 131510,
                        "name": "Chatrapur",
                        "latitude": "19.35574000",
                        "longitude": "84.98359000"
                    },
                    {
                        "id": 131550,
                        "name": "Chikitigarh",
                        "latitude": "19.20233000",
                        "longitude": "84.61450000"
                    },
                    {
                        "id": 131573,
                        "name": "Chittarkonda",
                        "latitude": "18.12533000",
                        "longitude": "82.10890000"
                    },
                    {
                        "id": 131633,
                        "name": "Cuttack",
                        "latitude": "20.50000000",
                        "longitude": "86.25000000"
                    },
                    {
                        "id": 131643,
                        "name": "Daitari",
                        "latitude": "21.10000000",
                        "longitude": "85.75000000"
                    },
                    {
                        "id": 131683,
                        "name": "Deogarh",
                        "latitude": "21.53827000",
                        "longitude": "84.73337000"
                    },
                    {
                        "id": 131735,
                        "name": "Dhenkanal",
                        "latitude": "20.75000000",
                        "longitude": "85.50000000"
                    },
                    {
                        "id": 131765,
                        "name": "Digapahandi",
                        "latitude": "19.37275000",
                        "longitude": "84.57184000"
                    },
                    {
                        "id": 131892,
                        "name": "Gajapati",
                        "latitude": "18.91000000",
                        "longitude": "84.20000000"
                    },
                    {
                        "id": 131914,
                        "name": "Ganjam",
                        "latitude": "19.38705000",
                        "longitude": "85.05079000"
                    },
                    {
                        "id": 131988,
                        "name": "Gopalpur",
                        "latitude": "19.25861000",
                        "longitude": "84.90517000"
                    },
                    {
                        "id": 132013,
                        "name": "Gudari",
                        "latitude": "19.34762000",
                        "longitude": "83.78128000"
                    },
                    {
                        "id": 132030,
                        "name": "Gunupur",
                        "latitude": "19.08040000",
                        "longitude": "83.80879000"
                    },
                    {
                        "id": 132102,
                        "name": "Hinjilikatu",
                        "latitude": "19.48166000",
                        "longitude": "84.74489000"
                    },
                    {
                        "id": 132148,
                        "name": "Hirakud",
                        "latitude": "21.52502000",
                        "longitude": "83.87275000"
                    },
                    {
                        "id": 132185,
                        "name": "Jagatsinghpur",
                        "latitude": "20.20000000",
                        "longitude": "86.30000000"
                    },
                    {
                        "id": 132209,
                        "name": "Jajpur",
                        "latitude": "20.84149000",
                        "longitude": "86.31237000"
                    },
                    {
                        "id": 132213,
                        "name": "Jaleshwar",
                        "latitude": "21.80176000",
                        "longitude": "87.22250000"
                    },
                    {
                        "id": 132250,
                        "name": "Jatani",
                        "latitude": "20.15975000",
                        "longitude": "85.70742000"
                    },
                    {
                        "id": 132265,
                        "name": "Jeypore",
                        "latitude": "18.85630000",
                        "longitude": "82.57160000"
                    },
                    {
                        "id": 132269,
                        "name": "Jharsuguda",
                        "latitude": "21.85531000",
                        "longitude": "84.00698000"
                    },
                    {
                        "id": 132270,
                        "name": "Jharsuguda District",
                        "latitude": "21.85000000",
                        "longitude": "84.00000000"
                    },
                    {
                        "id": 132338,
                        "name": "Kaintragarh",
                        "latitude": "20.72115000",
                        "longitude": "84.53514000"
                    },
                    {
                        "id": 132687,
                        "name": "Kalahandi",
                        "latitude": "19.75000000",
                        "longitude": "83.00000000"
                    },
                    {
                        "id": 132695,
                        "name": "Kamakhyanagar",
                        "latitude": "20.93385000",
                        "longitude": "85.54489000"
                    },
                    {
                        "id": 132371,
                        "name": "Kandhamal",
                        "latitude": "20.30000000",
                        "longitude": "84.00000000"
                    },
                    {
                        "id": 132387,
                        "name": "Kantabanji",
                        "latitude": "20.46709000",
                        "longitude": "82.92042000"
                    },
                    {
                        "id": 132386,
                        "name": "Kantilo",
                        "latitude": "20.36152000",
                        "longitude": "85.19212000"
                    },
                    {
                        "id": 132441,
                        "name": "Kendrapara",
                        "latitude": "20.50000000",
                        "longitude": "86.50000000"
                    },
                    {
                        "id": 132444,
                        "name": "Kendujhar",
                        "latitude": "21.50000000",
                        "longitude": "85.50000000"
                    },
                    {
                        "id": 132448,
                        "name": "Kesinga",
                        "latitude": "20.18778000",
                        "longitude": "83.21949000"
                    },
                    {
                        "id": 132458,
                        "name": "Khallikot",
                        "latitude": "19.60908000",
                        "longitude": "85.08609000"
                    },
                    {
                        "id": 132477,
                        "name": "Kharhial",
                        "latitude": "20.28845000",
                        "longitude": "82.76060000"
                    },
                    {
                        "id": 132501,
                        "name": "Khordha",
                        "latitude": "20.20000000",
                        "longitude": "85.60000000"
                    },
                    {
                        "id": 132508,
                        "name": "Khurda",
                        "latitude": "20.18268000",
                        "longitude": "85.61629000"
                    },
                    {
                        "id": 132527,
                        "name": "Kiri Buru",
                        "latitude": "22.08333000",
                        "longitude": "85.35000000"
                    },
                    {
                        "id": 132539,
                        "name": "Kodala",
                        "latitude": "19.62425000",
                        "longitude": "84.94075000"
                    },
                    {
                        "id": 132570,
                        "name": "Konarka",
                        "latitude": "19.89758000",
                        "longitude": "86.11413000"
                    },
                    {
                        "id": 132578,
                        "name": "Koraput",
                        "latitude": "19.00000000",
                        "longitude": "83.00000000"
                    },
                    {
                        "id": 132624,
                        "name": "Kuchaiburi",
                        "latitude": "22.26675000",
                        "longitude": "86.17385000"
                    },
                    {
                        "id": 132626,
                        "name": "Kuchinda",
                        "latitude": "21.74356000",
                        "longitude": "84.34848000"
                    },
                    {
                        "id": 132871,
                        "name": "Malkangiri",
                        "latitude": "18.25000000",
                        "longitude": "81.95000000"
                    },
                    {
                        "id": 132954,
                        "name": "Mayurbhanj",
                        "latitude": "21.75000000",
                        "longitude": "86.50000000"
                    },
                    {
                        "id": 133104,
                        "name": "Nabarangpur",
                        "latitude": "19.23330000",
                        "longitude": "82.55000000"
                    },
                    {
                        "id": 133196,
                        "name": "Nayagarh",
                        "latitude": "20.12882000",
                        "longitude": "85.09626000"
                    },
                    {
                        "id": 133195,
                        "name": "Nayagarh District",
                        "latitude": "20.13000000",
                        "longitude": "85.10000000"
                    },
                    {
                        "id": 133285,
                        "name": "Nilgiri",
                        "latitude": "21.46235000",
                        "longitude": "86.76794000"
                    },
                    {
                        "id": 133219,
                        "name": "Nimaparha",
                        "latitude": "20.05756000",
                        "longitude": "86.00436000"
                    },
                    {
                        "id": 133245,
                        "name": "Nowrangapur",
                        "latitude": "19.23114000",
                        "longitude": "82.54826000"
                    },
                    {
                        "id": 133247,
                        "name": "Nuapada",
                        "latitude": "20.60000000",
                        "longitude": "82.50000000"
                    },
                    {
                        "id": 133312,
                        "name": "Padampur",
                        "latitude": "20.99932000",
                        "longitude": "83.06325000"
                    },
                    {
                        "id": 133370,
                        "name": "Paradip Garh",
                        "latitude": "20.31641000",
                        "longitude": "86.60850000"
                    },
                    {
                        "id": 133393,
                        "name": "Patamundai",
                        "latitude": "20.57806000",
                        "longitude": "86.56063000"
                    },
                    {
                        "id": 133387,
                        "name": "Patnagarh",
                        "latitude": "20.70833000",
                        "longitude": "83.13263000"
                    },
                    {
                        "id": 133441,
                        "name": "Phulbani",
                        "latitude": "20.48101000",
                        "longitude": "84.23063000"
                    },
                    {
                        "id": 133453,
                        "name": "Pipili",
                        "latitude": "20.11357000",
                        "longitude": "85.83147000"
                    },
                    {
                        "id": 133467,
                        "name": "Polasara",
                        "latitude": "19.69386000",
                        "longitude": "84.81401000"
                    },
                    {
                        "id": 133511,
                        "name": "Puri",
                        "latitude": "19.90000000",
                        "longitude": "85.60000000"
                    },
                    {
                        "id": 133513,
                        "name": "Purushottampur",
                        "latitude": "19.52024000",
                        "longitude": "84.88514000"
                    },
                    {
                        "id": 133602,
                        "name": "Rambha",
                        "latitude": "19.51667000",
                        "longitude": "85.10000000"
                    },
                    {
                        "id": 133620,
                        "name": "Raurkela",
                        "latitude": "22.22496000",
                        "longitude": "84.86414000"
                    },
                    {
                        "id": 133622,
                        "name": "Rayagada",
                        "latitude": "19.40000000",
                        "longitude": "83.50000000"
                    },
                    {
                        "id": 133625,
                        "name": "Remuna",
                        "latitude": "21.52798000",
                        "longitude": "86.87156000"
                    },
                    {
                        "id": 133626,
                        "name": "Rengali",
                        "latitude": "21.64602000",
                        "longitude": "84.05311000"
                    },
                    {
                        "id": 133769,
                        "name": "Sambalpur",
                        "latitude": "21.40000000",
                        "longitude": "83.88333000"
                    },
                    {
                        "id": 133994,
                        "name": "Sonepur",
                        "latitude": "20.83333000",
                        "longitude": "83.91667000"
                    },
                    {
                        "id": 134002,
                        "name": "Sorada",
                        "latitude": "19.76082000",
                        "longitude": "84.42997000"
                    },
                    {
                        "id": 134004,
                        "name": "Soro",
                        "latitude": "21.27851000",
                        "longitude": "86.68833000"
                    },
                    {
                        "id": 134034,
                        "name": "Subarnapur",
                        "latitude": "20.93154000",
                        "longitude": "83.82486000"
                    },
                    {
                        "id": 134044,
                        "name": "Sundargarh",
                        "latitude": "22.25000000",
                        "longitude": "84.50000000"
                    },
                    {
                        "id": 134232,
                        "name": "Talcher",
                        "latitude": "20.94927000",
                        "longitude": "85.23354000"
                    },
                    {
                        "id": 134115,
                        "name": "Tarabha",
                        "latitude": "20.73252000",
                        "longitude": "83.67443000"
                    },
                    {
                        "id": 134201,
                        "name": "Titlagarh",
                        "latitude": "20.28961000",
                        "longitude": "83.15233000"
                    },
                    {
                        "id": 134254,
                        "name": "Udayagiri",
                        "latitude": "20.12416000",
                        "longitude": "84.36869000"
                    }
                ]
            },
            {
                "id": 4011,
                "name": "Puducherry",
                "iso2": "PY",
                "latitude": "11.94159150",
                "longitude": "79.80831330",
                "type": "union territory",
                "cities": [
                    {
                        "id": 132715,
                        "name": "Karaikal",
                        "latitude": "10.92209000",
                        "longitude": "79.83353000"
                    },
                    {
                        "id": 132830,
                        "name": "Mahe",
                        "latitude": "11.70000000",
                        "longitude": "75.53333000"
                    },
                    {
                        "id": 133490,
                        "name": "Puducherry",
                        "latitude": "11.93381000",
                        "longitude": "79.82979000"
                    },
                    {
                        "id": 134425,
                        "name": "Yanam",
                        "latitude": "16.73463000",
                        "longitude": "82.21773000"
                    }
                ]
            },
            {
                "id": 4015,
                "name": "Punjab",
                "iso2": "PB",
                "latitude": "31.00476470",
                "longitude": "72.77559820",
                "type": "state",
                "cities": [
                    {
                        "id": 57587,
                        "name": "Abohar",
                        "latitude": "30.14453000",
                        "longitude": "74.19552000"
                    },
                    {
                        "id": 57592,
                        "name": "Adampur",
                        "latitude": "31.43224000",
                        "longitude": "75.71484000"
                    },
                    {
                        "id": 57612,
                        "name": "Ajitgarh",
                        "latitude": "30.65000000",
                        "longitude": "76.70000000"
                    },
                    {
                        "id": 57615,
                        "name": "Ajnala",
                        "latitude": "31.84473000",
                        "longitude": "74.76295000"
                    },
                    {
                        "id": 57629,
                        "name": "Akalgarh",
                        "latitude": "29.82074000",
                        "longitude": "75.89078000"
                    },
                    {
                        "id": 57651,
                        "name": "Alawalpur",
                        "latitude": "31.43161000",
                        "longitude": "75.65614000"
                    },
                    {
                        "id": 57681,
                        "name": "Amloh",
                        "latitude": "30.60837000",
                        "longitude": "76.23199000"
                    },
                    {
                        "id": 57686,
                        "name": "Amritsar",
                        "latitude": "31.67000000",
                        "longitude": "74.84000000"
                    },
                    {
                        "id": 57697,
                        "name": "Anandpur Sahib",
                        "latitude": "31.23926000",
                        "longitude": "76.50253000"
                    },
                    {
                        "id": 57791,
                        "name": "Badhni Kalan",
                        "latitude": "30.68130000",
                        "longitude": "75.29087000"
                    },
                    {
                        "id": 58109,
                        "name": "Bagha Purana",
                        "latitude": "30.68809000",
                        "longitude": "75.09838000"
                    },
                    {
                        "id": 57819,
                        "name": "Bakloh",
                        "latitude": "32.47939000",
                        "longitude": "75.91874000"
                    },
                    {
                        "id": 58118,
                        "name": "Balachor",
                        "latitude": "31.06062000",
                        "longitude": "76.30166000"
                    },
                    {
                        "id": 57846,
                        "name": "Banga",
                        "latitude": "31.18874000",
                        "longitude": "75.99495000"
                    },
                    {
                        "id": 57859,
                        "name": "Banur",
                        "latitude": "30.55407000",
                        "longitude": "76.71948000"
                    },
                    {
                        "id": 57882,
                        "name": "Barnala",
                        "latitude": "30.37451000",
                        "longitude": "75.54870000"
                    },
                    {
                        "id": 57906,
                        "name": "Batala",
                        "latitude": "31.80921000",
                        "longitude": "75.20294000"
                    },
                    {
                        "id": 57914,
                        "name": "Begowal",
                        "latitude": "31.61152000",
                        "longitude": "75.52135000"
                    },
                    {
                        "id": 57950,
                        "name": "Bhadaur",
                        "latitude": "30.47651000",
                        "longitude": "75.33049000"
                    },
                    {
                        "id": 57904,
                        "name": "Bhatinda",
                        "latitude": "30.20747000",
                        "longitude": "74.93893000"
                    },
                    {
                        "id": 57977,
                        "name": "Bhawanigarh",
                        "latitude": "30.26685000",
                        "longitude": "76.03854000"
                    },
                    {
                        "id": 58018,
                        "name": "Bhikhi",
                        "latitude": "30.05918000",
                        "longitude": "75.53500000"
                    },
                    {
                        "id": 57990,
                        "name": "Bhogpur",
                        "latitude": "31.55442000",
                        "longitude": "75.64271000"
                    },
                    {
                        "id": 143761,
                        "name": "Bholath",
                        "latitude": "31.54277778",
                        "longitude": "75.50750000"
                    },
                    {
                        "id": 58090,
                        "name": "Budhlada",
                        "latitude": "29.92799000",
                        "longitude": "75.56205000"
                    },
                    {
                        "id": 131610,
                        "name": "Chima",
                        "latitude": "30.68540000",
                        "longitude": "76.08643000"
                    },
                    {
                        "id": 131661,
                        "name": "Dasuya",
                        "latitude": "31.81679000",
                        "longitude": "75.65310000"
                    },
                    {
                        "id": 131696,
                        "name": "Dera Baba Nanak",
                        "latitude": "32.03733000",
                        "longitude": "75.02787000"
                    },
                    {
                        "id": 143763,
                        "name": "Dera Bassi",
                        "latitude": "30.58720000",
                        "longitude": "76.84280000"
                    },
                    {
                        "id": 131713,
                        "name": "Dhanaula",
                        "latitude": "30.28216000",
                        "longitude": "75.57341000"
                    },
                    {
                        "id": 131756,
                        "name": "Dhariwal",
                        "latitude": "31.95616000",
                        "longitude": "75.32386000"
                    },
                    {
                        "id": 131736,
                        "name": "Dhilwan",
                        "latitude": "31.51432000",
                        "longitude": "75.34574000"
                    },
                    {
                        "id": 143762,
                        "name": "Dhudi",
                        "latitude": "30.69636000",
                        "longitude": "74.85246000"
                    },
                    {
                        "id": 131760,
                        "name": "Dhuri",
                        "latitude": "30.36846000",
                        "longitude": "75.86791000"
                    },
                    {
                        "id": 131816,
                        "name": "Dina Nagar",
                        "latitude": "32.13664000",
                        "longitude": "75.47291000"
                    },
                    {
                        "id": 131777,
                        "name": "Dirba",
                        "latitude": "30.07222000",
                        "longitude": "75.99607000"
                    },
                    {
                        "id": 131790,
                        "name": "Doraha",
                        "latitude": "30.79953000",
                        "longitude": "76.02355000"
                    },
                    {
                        "id": 131859,
                        "name": "Faridkot",
                        "latitude": "30.67399000",
                        "longitude": "74.75579000"
                    },
                    {
                        "id": 131865,
                        "name": "Fatehgarh Churian",
                        "latitude": "31.86431000",
                        "longitude": "74.95665000"
                    },
                    {
                        "id": 131866,
                        "name": "Fatehgarh Sahib",
                        "latitude": "30.64379000",
                        "longitude": "76.34787000"
                    },
                    {
                        "id": 131881,
                        "name": "Fazilka",
                        "latitude": "30.40207000",
                        "longitude": "74.02836000"
                    },
                    {
                        "id": 131875,
                        "name": "Firozpur",
                        "latitude": "30.92574000",
                        "longitude": "74.61311000"
                    },
                    {
                        "id": 131877,
                        "name": "Firozpur District",
                        "latitude": "30.89000000",
                        "longitude": "74.56000000"
                    },
                    {
                        "id": 131918,
                        "name": "Gardhiwala",
                        "latitude": "31.74147000",
                        "longitude": "75.75567000"
                    },
                    {
                        "id": 131921,
                        "name": "Garhshankar",
                        "latitude": "31.21537000",
                        "longitude": "76.14149000"
                    },
                    {
                        "id": 131935,
                        "name": "Ghanaur",
                        "latitude": "30.33092000",
                        "longitude": "76.61203000"
                    },
                    {
                        "id": 131956,
                        "name": "Giddarbaha",
                        "latitude": "30.19953000",
                        "longitude": "74.66627000"
                    },
                    {
                        "id": 132031,
                        "name": "Gurdaspur",
                        "latitude": "31.92000000",
                        "longitude": "75.27000000"
                    },
                    {
                        "id": 132037,
                        "name": "Guru Har Sahai",
                        "latitude": "30.70862000",
                        "longitude": "74.40407000"
                    },
                    {
                        "id": 132136,
                        "name": "Hajipur",
                        "latitude": "31.97714000",
                        "longitude": "75.75438000"
                    },
                    {
                        "id": 132077,
                        "name": "Hariana",
                        "latitude": "31.63512000",
                        "longitude": "75.83887000"
                    },
                    {
                        "id": 132122,
                        "name": "Hoshiarpur",
                        "latitude": "31.53723000",
                        "longitude": "75.91269000"
                    },
                    {
                        "id": 143764,
                        "name": "Ishanpur",
                        "latitude": "30.63929000",
                        "longitude": "76.11761000"
                    },
                    {
                        "id": 132192,
                        "name": "Jagraon",
                        "latitude": "30.78783000",
                        "longitude": "75.47391000"
                    },
                    {
                        "id": 132207,
                        "name": "Jaito",
                        "latitude": "30.45126000",
                        "longitude": "74.89189000"
                    },
                    {
                        "id": 132223,
                        "name": "Jalalabad",
                        "latitude": "30.60622000",
                        "longitude": "74.25727000"
                    },
                    {
                        "id": 132211,
                        "name": "Jalandhar",
                        "latitude": "31.41667000",
                        "longitude": "75.61667000"
                    },
                    {
                        "id": 132236,
                        "name": "Jandiala",
                        "latitude": "31.15930000",
                        "longitude": "75.61755000"
                    },
                    {
                        "id": 132237,
                        "name": "Jandiala Guru",
                        "latitude": "31.56198000",
                        "longitude": "75.02770000"
                    },
                    {
                        "id": 132347,
                        "name": "Kalanaur",
                        "latitude": "32.01227000",
                        "longitude": "75.15063000"
                    },
                    {
                        "id": 132392,
                        "name": "Kapurthala",
                        "latitude": "31.38011000",
                        "longitude": "75.38105000"
                    },
                    {
                        "id": 132408,
                        "name": "Kartarpur",
                        "latitude": "31.44268000",
                        "longitude": "75.49847000"
                    },
                    {
                        "id": 132465,
                        "name": "Khamanon",
                        "latitude": "30.81725000",
                        "longitude": "76.35478000"
                    },
                    {
                        "id": 132469,
                        "name": "Khanna",
                        "latitude": "30.70547000",
                        "longitude": "76.22196000"
                    },
                    {
                        "id": 132472,
                        "name": "Kharar",
                        "latitude": "30.74632000",
                        "longitude": "76.64689000"
                    },
                    {
                        "id": 132491,
                        "name": "Khemkaran",
                        "latitude": "31.14443000",
                        "longitude": "74.55938000"
                    },
                    {
                        "id": 132591,
                        "name": "Kot Isa Khan",
                        "latitude": "30.94659000",
                        "longitude": "75.13780000"
                    },
                    {
                        "id": 132600,
                        "name": "Kotkapura",
                        "latitude": "30.58190000",
                        "longitude": "74.83298000"
                    },
                    {
                        "id": 132760,
                        "name": "Laungowal",
                        "latitude": "30.19393000",
                        "longitude": "75.68089000"
                    },
                    {
                        "id": 132785,
                        "name": "Ludhiana",
                        "latitude": "30.91204000",
                        "longitude": "75.85379000"
                    },
                    {
                        "id": 133056,
                        "name": "Machhiwara",
                        "latitude": "30.91557000",
                        "longitude": "76.20016000"
                    },
                    {
                        "id": 132861,
                        "name": "Majitha",
                        "latitude": "31.75711000",
                        "longitude": "74.95891000"
                    },
                    {
                        "id": 132862,
                        "name": "Makhu",
                        "latitude": "31.10335000",
                        "longitude": "74.99631000"
                    },
                    {
                        "id": 132867,
                        "name": "Malaut",
                        "latitude": "30.21121000",
                        "longitude": "74.48180000"
                    },
                    {
                        "id": 133066,
                        "name": "Malerkotla",
                        "latitude": "30.53090000",
                        "longitude": "75.87949000"
                    },
                    {
                        "id": 133082,
                        "name": "Mansa",
                        "latitude": "29.98844000",
                        "longitude": "75.40167000"
                    },
                    {
                        "id": 132948,
                        "name": "Maur Mandi",
                        "latitude": "30.08333000",
                        "longitude": "75.25000000"
                    },
                    {
                        "id": 132979,
                        "name": "Moga",
                        "latitude": "30.80376000",
                        "longitude": "75.14938000"
                    },
                    {
                        "id": 132980,
                        "name": "Mohali",
                        "latitude": "30.67995000",
                        "longitude": "76.72211000"
                    },
                    {
                        "id": 132996,
                        "name": "Morinda",
                        "latitude": "30.79014000",
                        "longitude": "76.49883000"
                    },
                    {
                        "id": 133017,
                        "name": "Mukerian",
                        "latitude": "31.95394000",
                        "longitude": "75.61716000"
                    },
                    {
                        "id": 133250,
                        "name": "Nabha",
                        "latitude": "30.37577000",
                        "longitude": "76.15292000"
                    },
                    {
                        "id": 133128,
                        "name": "Nakodar",
                        "latitude": "31.12586000",
                        "longitude": "75.47508000"
                    },
                    {
                        "id": 133147,
                        "name": "Nangal",
                        "latitude": "31.38966000",
                        "longitude": "76.37574000"
                    },
                    {
                        "id": 133190,
                        "name": "Nawanshahr",
                        "latitude": "31.12450000",
                        "longitude": "76.11613000"
                    },
                    {
                        "id": 133291,
                        "name": "Nurmahal",
                        "latitude": "31.09662000",
                        "longitude": "75.59386000"
                    },
                    {
                        "id": 133293,
                        "name": "Nurpur Kalan",
                        "latitude": "31.16667000",
                        "longitude": "76.48333000"
                    },
                    {
                        "id": 133382,
                        "name": "Pathankot",
                        "latitude": "32.27484000",
                        "longitude": "75.65287000"
                    },
                    {
                        "id": 133384,
                        "name": "Patiala",
                        "latitude": "30.33625000",
                        "longitude": "76.39220000"
                    },
                    {
                        "id": 133390,
                        "name": "Patti",
                        "latitude": "31.28092000",
                        "longitude": "74.85849000"
                    },
                    {
                        "id": 133431,
                        "name": "Phagwara",
                        "latitude": "31.22452000",
                        "longitude": "75.77387000"
                    },
                    {
                        "id": 133439,
                        "name": "Phillaur",
                        "latitude": "31.01887000",
                        "longitude": "75.79111000"
                    },
                    {
                        "id": 133575,
                        "name": "Qadian",
                        "latitude": "31.82198000",
                        "longitude": "75.37663000"
                    },
                    {
                        "id": 133662,
                        "name": "Rahon",
                        "latitude": "31.05275000",
                        "longitude": "76.11907000"
                    },
                    {
                        "id": 133665,
                        "name": "Raikot",
                        "latitude": "30.65000000",
                        "longitude": "75.60000000"
                    },
                    {
                        "id": 133670,
                        "name": "Rajasansi",
                        "latitude": "31.72021000",
                        "longitude": "74.80080000"
                    },
                    {
                        "id": 133681,
                        "name": "Rajpura",
                        "latitude": "30.47856000",
                        "longitude": "76.59284000"
                    },
                    {
                        "id": 133690,
                        "name": "Ram Das",
                        "latitude": "31.96739000",
                        "longitude": "74.90870000"
                    },
                    {
                        "id": 133708,
                        "name": "Rampura",
                        "latitude": "30.25600000",
                        "longitude": "75.24116000"
                    },
                    {
                        "id": 133654,
                        "name": "Rupnagar",
                        "latitude": "31.04000000",
                        "longitude": "76.52000000"
                    },
                    {
                        "id": 133772,
                        "name": "Samrala",
                        "latitude": "30.83601000",
                        "longitude": "76.19324000"
                    },
                    {
                        "id": 133776,
                        "name": "Sanaur",
                        "latitude": "30.30182000",
                        "longitude": "76.45786000"
                    },
                    {
                        "id": 133785,
                        "name": "Sangrur",
                        "latitude": "30.24506000",
                        "longitude": "75.84488000"
                    },
                    {
                        "id": 133804,
                        "name": "Sardulgarh",
                        "latitude": "29.69224000",
                        "longitude": "75.23608000"
                    },
                    {
                        "id": 133854,
                        "name": "Shahid Bhagat Singh Nagar",
                        "latitude": "31.13183000",
                        "longitude": "76.13328000"
                    },
                    {
                        "id": 133897,
                        "name": "Shahkot",
                        "latitude": "31.08173000",
                        "longitude": "75.33708000"
                    },
                    {
                        "id": 133911,
                        "name": "Sham Churasi",
                        "latitude": "31.50028000",
                        "longitude": "75.74917000"
                    },
                    {
                        "id": 133955,
                        "name": "Sirhind-Fategarh",
                        "latitude": "30.64321000",
                        "longitude": "76.38421000"
                    },
                    {
                        "id": 133019,
                        "name": "Sri Muktsar Sahib",
                        "latitude": "30.47426000",
                        "longitude": "74.51660000"
                    },
                    {
                        "id": 134037,
                        "name": "Sultanpur Lodhi",
                        "latitude": "31.21468000",
                        "longitude": "75.19602000"
                    },
                    {
                        "id": 134048,
                        "name": "Sunam",
                        "latitude": "30.12883000",
                        "longitude": "75.79943000"
                    },
                    {
                        "id": 134105,
                        "name": "Talwandi Bhai",
                        "latitude": "30.85584000",
                        "longitude": "74.92979000"
                    },
                    {
                        "id": 134106,
                        "name": "Talwara",
                        "latitude": "31.93760000",
                        "longitude": "75.88657000"
                    },
                    {
                        "id": 134118,
                        "name": "Tarn Taran Sahib",
                        "latitude": "31.45191000",
                        "longitude": "74.92777000"
                    },
                    {
                        "id": 134443,
                        "name": "Zira",
                        "latitude": "30.96853000",
                        "longitude": "74.99106000"
                    }
                ]
            },
            {
                "id": 4014,
                "name": "Rajasthan",
                "iso2": "RJ",
                "latitude": "27.02380360",
                "longitude": "74.21793260",
                "type": "state",
                "cities": [
                    {
                        "id": 57584,
                        "name": "Abhaneri",
                        "latitude": "27.00743000",
                        "longitude": "76.60760000"
                    },
                    {
                        "id": 134449,
                        "name": "Abu",
                        "latitude": "24.59365000",
                        "longitude": "72.71756000"
                    },
                    {
                        "id": 134450,
                        "name": "Abu Road",
                        "latitude": "24.48012000",
                        "longitude": "72.78186000"
                    },
                    {
                        "id": 57614,
                        "name": "Ajmer",
                        "latitude": "26.25000000",
                        "longitude": "74.66667000"
                    },
                    {
                        "id": 57625,
                        "name": "Aklera",
                        "latitude": "24.41288000",
                        "longitude": "76.56719000"
                    },
                    {
                        "id": 57649,
                        "name": "Alwar",
                        "latitude": "27.50000000",
                        "longitude": "76.50000000"
                    },
                    {
                        "id": 57676,
                        "name": "Amet",
                        "latitude": "25.30609000",
                        "longitude": "73.92580000"
                    },
                    {
                        "id": 57717,
                        "name": "Anta",
                        "latitude": "25.15000000",
                        "longitude": "76.30000000"
                    },
                    {
                        "id": 57722,
                        "name": "Anupgarh",
                        "latitude": "29.19111000",
                        "longitude": "73.20861000"
                    },
                    {
                        "id": 134466,
                        "name": "Asind",
                        "latitude": "25.73420000",
                        "longitude": "74.33278000"
                    },
                    {
                        "id": 57798,
                        "name": "Bagar",
                        "latitude": "28.18784000",
                        "longitude": "75.50012000"
                    },
                    {
                        "id": 57822,
                        "name": "Bakani",
                        "latitude": "24.28624000",
                        "longitude": "76.23709000"
                    },
                    {
                        "id": 58115,
                        "name": "Bali",
                        "latitude": "25.19725000",
                        "longitude": "73.29117000"
                    },
                    {
                        "id": 58116,
                        "name": "Balotra",
                        "latitude": "25.83242000",
                        "longitude": "72.24000000"
                    },
                    {
                        "id": 58125,
                        "name": "Bandikui",
                        "latitude": "27.05087000",
                        "longitude": "76.57325000"
                    },
                    {
                        "id": 58134,
                        "name": "Banswara",
                        "latitude": "23.54109000",
                        "longitude": "74.44250000"
                    },
                    {
                        "id": 57863,
                        "name": "Baran",
                        "latitude": "25.09000000",
                        "longitude": "76.66000000"
                    },
                    {
                        "id": 58142,
                        "name": "Bari",
                        "latitude": "26.64661000",
                        "longitude": "77.61634000"
                    },
                    {
                        "id": 57874,
                        "name": "Bari Sadri",
                        "latitude": "24.41339000",
                        "longitude": "74.47331000"
                    },
                    {
                        "id": 58143,
                        "name": "Barmer",
                        "latitude": "25.75000000",
                        "longitude": "71.50000000"
                    },
                    {
                        "id": 57895,
                        "name": "Basi",
                        "latitude": "26.83150000",
                        "longitude": "76.04856000"
                    },
                    {
                        "id": 57899,
                        "name": "Basni",
                        "latitude": "27.17232000",
                        "longitude": "73.64519000"
                    },
                    {
                        "id": 57903,
                        "name": "Baswa",
                        "latitude": "27.14955000",
                        "longitude": "76.58345000"
                    },
                    {
                        "id": 57910,
                        "name": "Bayana",
                        "latitude": "26.90791000",
                        "longitude": "77.28985000"
                    },
                    {
                        "id": 57946,
                        "name": "Beawar",
                        "latitude": "26.10119000",
                        "longitude": "74.32028000"
                    },
                    {
                        "id": 57917,
                        "name": "Begun",
                        "latitude": "24.98333000",
                        "longitude": "75.00000000"
                    },
                    {
                        "id": 57919,
                        "name": "Behror",
                        "latitude": "27.88832000",
                        "longitude": "76.28108000"
                    },
                    {
                        "id": 58008,
                        "name": "Bhadasar",
                        "latitude": "28.31457000",
                        "longitude": "74.28952000"
                    },
                    {
                        "id": 58007,
                        "name": "Bhadra",
                        "latitude": "29.10298000",
                        "longitude": "75.17138000"
                    },
                    {
                        "id": 57964,
                        "name": "Bharatpur",
                        "latitude": "27.21000000",
                        "longitude": "77.29000000"
                    },
                    {
                        "id": 57968,
                        "name": "Bhasawar",
                        "latitude": "27.03895000",
                        "longitude": "77.04849000"
                    },
                    {
                        "id": 58019,
                        "name": "Bhilwara",
                        "latitude": "25.50000000",
                        "longitude": "74.75000000"
                    },
                    {
                        "id": 57983,
                        "name": "Bhindar",
                        "latitude": "24.50235000",
                        "longitude": "74.18551000"
                    },
                    {
                        "id": 58023,
                        "name": "Bhinmal",
                        "latitude": "24.99944000",
                        "longitude": "72.27141000"
                    },
                    {
                        "id": 57986,
                        "name": "Bhiwadi",
                        "latitude": "28.21024000",
                        "longitude": "76.86056000"
                    },
                    {
                        "id": 58004,
                        "name": "Bhuma",
                        "latitude": "27.78333000",
                        "longitude": "74.93333000"
                    },
                    {
                        "id": 58156,
                        "name": "Bikaner",
                        "latitude": "28.01762000",
                        "longitude": "73.31495000"
                    },
                    {
                        "id": 58051,
                        "name": "Bilara",
                        "latitude": "26.18067000",
                        "longitude": "73.70550000"
                    },
                    {
                        "id": 58067,
                        "name": "Bissau",
                        "latitude": "28.24737000",
                        "longitude": "75.07666000"
                    },
                    {
                        "id": 58083,
                        "name": "Borkhera",
                        "latitude": "25.52115000",
                        "longitude": "75.64028000"
                    },
                    {
                        "id": 58162,
                        "name": "Bundi",
                        "latitude": "25.43855000",
                        "longitude": "75.63735000"
                    },
                    {
                        "id": 58177,
                        "name": "Chaksu",
                        "latitude": "26.60510000",
                        "longitude": "75.94814000"
                    },
                    {
                        "id": 131513,
                        "name": "Chechat",
                        "latitude": "24.76667000",
                        "longitude": "75.88333000"
                    },
                    {
                        "id": 131527,
                        "name": "Chhabra",
                        "latitude": "24.66472000",
                        "longitude": "76.84379000"
                    },
                    {
                        "id": 131539,
                        "name": "Chhapar",
                        "latitude": "27.81900000",
                        "longitude": "74.43936000"
                    },
                    {
                        "id": 131536,
                        "name": "Chhoti Sadri",
                        "latitude": "24.38145000",
                        "longitude": "74.70120000"
                    },
                    {
                        "id": 131546,
                        "name": "Chidawa",
                        "latitude": "28.23937000",
                        "longitude": "75.64035000"
                    },
                    {
                        "id": 131574,
                        "name": "Chittaurgarh",
                        "latitude": "24.50000000",
                        "longitude": "74.50000000"
                    },
                    {
                        "id": 131614,
                        "name": "Churu",
                        "latitude": "28.30415000",
                        "longitude": "74.96718000"
                    },
                    {
                        "id": 131655,
                        "name": "Dariba",
                        "latitude": "24.94865000",
                        "longitude": "74.13420000"
                    },
                    {
                        "id": 131669,
                        "name": "Dausa",
                        "latitude": "26.88269000",
                        "longitude": "76.57053000"
                    },
                    {
                        "id": 131685,
                        "name": "Deoli",
                        "latitude": "25.75728000",
                        "longitude": "75.37991000"
                    },
                    {
                        "id": 131697,
                        "name": "Deshnoke",
                        "latitude": "27.79836000",
                        "longitude": "73.34297000"
                    },
                    {
                        "id": 131706,
                        "name": "Devgarh",
                        "latitude": "25.52533000",
                        "longitude": "73.90812000"
                    },
                    {
                        "id": 131730,
                        "name": "Dhaulpur",
                        "latitude": "26.71183000",
                        "longitude": "77.73956000"
                    },
                    {
                        "id": 131813,
                        "name": "Didwana",
                        "latitude": "27.40096000",
                        "longitude": "74.57537000"
                    },
                    {
                        "id": 131814,
                        "name": "Dig",
                        "latitude": "27.47188000",
                        "longitude": "77.32564000"
                    },
                    {
                        "id": 131819,
                        "name": "Dungarpur",
                        "latitude": "23.84306000",
                        "longitude": "73.71466000"
                    },
                    {
                        "id": 131867,
                        "name": "Fatehpur",
                        "latitude": "27.99486000",
                        "longitude": "74.95628000"
                    },
                    {
                        "id": 131896,
                        "name": "Galiakot",
                        "latitude": "23.51995000",
                        "longitude": "74.02028000"
                    },
                    {
                        "id": 131908,
                        "name": "Ganganagar",
                        "latitude": "29.92009000",
                        "longitude": "73.87496000"
                    },
                    {
                        "id": 131909,
                        "name": "Gangapur",
                        "latitude": "26.47249000",
                        "longitude": "76.71744000"
                    },
                    {
                        "id": 132003,
                        "name": "Govindgarh",
                        "latitude": "27.50423000",
                        "longitude": "76.99938000"
                    },
                    {
                        "id": 132018,
                        "name": "Gulabpura",
                        "latitude": "25.90448000",
                        "longitude": "74.66025000"
                    },
                    {
                        "id": 132066,
                        "name": "Hanumangarh",
                        "latitude": "29.11000000",
                        "longitude": "74.60000000"
                    },
                    {
                        "id": 132097,
                        "name": "Hindaun",
                        "latitude": "26.73411000",
                        "longitude": "77.03519000"
                    },
                    {
                        "id": 132199,
                        "name": "Jahazpur",
                        "latitude": "25.61994000",
                        "longitude": "75.27609000"
                    },
                    {
                        "id": 132201,
                        "name": "Jaipur",
                        "latitude": "27.00000000",
                        "longitude": "76.00000000"
                    },
                    {
                        "id": 132203,
                        "name": "Jaisalmer",
                        "latitude": "26.99382000",
                        "longitude": "71.00889000"
                    },
                    {
                        "id": 132208,
                        "name": "Jaitaran",
                        "latitude": "26.20446000",
                        "longitude": "73.93676000"
                    },
                    {
                        "id": 132217,
                        "name": "Jalor",
                        "latitude": "25.34558000",
                        "longitude": "72.61559000"
                    },
                    {
                        "id": 132218,
                        "name": "Jalore",
                        "latitude": "25.08000000",
                        "longitude": "72.29000000"
                    },
                    {
                        "id": 132278,
                        "name": "Jhalawar",
                        "latitude": "24.59633000",
                        "longitude": "76.16499000"
                    },
                    {
                        "id": 132276,
                        "name": "Jhalrapatan",
                        "latitude": "24.54205000",
                        "longitude": "76.17242000"
                    },
                    {
                        "id": 132273,
                        "name": "Jhunjhunun",
                        "latitude": "28.12559000",
                        "longitude": "75.39797000"
                    },
                    {
                        "id": 132284,
                        "name": "Jobner",
                        "latitude": "26.97257000",
                        "longitude": "75.38752000"
                    },
                    {
                        "id": 132286,
                        "name": "Jodhpur",
                        "latitude": "26.75000000",
                        "longitude": "72.75000000"
                    },
                    {
                        "id": 132692,
                        "name": "Kaman",
                        "latitude": "27.65791000",
                        "longitude": "77.26908000"
                    },
                    {
                        "id": 132709,
                        "name": "Kanor",
                        "latitude": "24.43437000",
                        "longitude": "74.26546000"
                    },
                    {
                        "id": 132713,
                        "name": "Kapren",
                        "latitude": "25.40529000",
                        "longitude": "76.07431000"
                    },
                    {
                        "id": 132395,
                        "name": "Karanpur",
                        "latitude": "29.84042000",
                        "longitude": "73.45519000"
                    },
                    {
                        "id": 132396,
                        "name": "Karauli",
                        "latitude": "26.58000000",
                        "longitude": "77.10000000"
                    },
                    {
                        "id": 132438,
                        "name": "Kekri",
                        "latitude": "25.97132000",
                        "longitude": "75.14992000"
                    },
                    {
                        "id": 132447,
                        "name": "Keshorai Patan",
                        "latitude": "25.29275000",
                        "longitude": "75.93948000"
                    },
                    {
                        "id": 132466,
                        "name": "Khandela",
                        "latitude": "27.60499000",
                        "longitude": "75.50200000"
                    },
                    {
                        "id": 132515,
                        "name": "Khanpur",
                        "latitude": "24.73241000",
                        "longitude": "76.39601000"
                    },
                    {
                        "id": 132496,
                        "name": "Khetri",
                        "latitude": "28.00069000",
                        "longitude": "75.78644000"
                    },
                    {
                        "id": 132530,
                        "name": "Kishangarh",
                        "latitude": "26.59006000",
                        "longitude": "74.85397000"
                    },
                    {
                        "id": 132593,
                        "name": "Kota",
                        "latitude": "25.17512000",
                        "longitude": "75.84412000"
                    },
                    {
                        "id": 132604,
                        "name": "Kotputli",
                        "latitude": "27.70207000",
                        "longitude": "76.19911000"
                    },
                    {
                        "id": 132627,
                        "name": "Kuchaman",
                        "latitude": "27.14745000",
                        "longitude": "74.85655000"
                    },
                    {
                        "id": 132625,
                        "name": "Kuchera",
                        "latitude": "26.98747000",
                        "longitude": "73.97108000"
                    },
                    {
                        "id": 132738,
                        "name": "Kumher",
                        "latitude": "27.31657000",
                        "longitude": "77.37079000"
                    },
                    {
                        "id": 132667,
                        "name": "Kushalgarh",
                        "latitude": "23.19899000",
                        "longitude": "74.45074000"
                    },
                    {
                        "id": 132739,
                        "name": "Lachhmangarh Sikar",
                        "latitude": "27.82294000",
                        "longitude": "75.02754000"
                    },
                    {
                        "id": 132788,
                        "name": "Ladnun",
                        "latitude": "27.65312000",
                        "longitude": "74.39993000"
                    },
                    {
                        "id": 132792,
                        "name": "Lakheri",
                        "latitude": "25.67237000",
                        "longitude": "76.17692000"
                    },
                    {
                        "id": 132798,
                        "name": "Lalsot",
                        "latitude": "26.55951000",
                        "longitude": "76.32915000"
                    },
                    {
                        "id": 132778,
                        "name": "Losal",
                        "latitude": "27.40000000",
                        "longitude": "74.91667000"
                    },
                    {
                        "id": 132843,
                        "name": "Mahwah",
                        "latitude": "27.04594000",
                        "longitude": "76.93152000"
                    },
                    {
                        "id": 132863,
                        "name": "Makrana",
                        "latitude": "27.04361000",
                        "longitude": "74.72445000"
                    },
                    {
                        "id": 133069,
                        "name": "Malpura",
                        "latitude": "26.28380000",
                        "longitude": "75.36458000"
                    },
                    {
                        "id": 133072,
                        "name": "Mandal",
                        "latitude": "25.44126000",
                        "longitude": "74.56979000"
                    },
                    {
                        "id": 133074,
                        "name": "Mandalgarh",
                        "latitude": "25.19407000",
                        "longitude": "75.07215000"
                    },
                    {
                        "id": 132900,
                        "name": "Mandawar",
                        "latitude": "27.86374000",
                        "longitude": "76.54999000"
                    },
                    {
                        "id": 133078,
                        "name": "Mangrol",
                        "latitude": "25.33061000",
                        "longitude": "76.50973000"
                    },
                    {
                        "id": 132921,
                        "name": "Manohar Thana",
                        "latitude": "24.24000000",
                        "longitude": "76.80182000"
                    },
                    {
                        "id": 132922,
                        "name": "Manoharpur",
                        "latitude": "27.29769000",
                        "longitude": "75.94950000"
                    },
                    {
                        "id": 132959,
                        "name": "Meethari Marwar",
                        "latitude": "27.57615000",
                        "longitude": "74.68661000"
                    },
                    {
                        "id": 132967,
                        "name": "Merta",
                        "latitude": "26.64859000",
                        "longitude": "74.03414000"
                    },
                    {
                        "id": 133102,
                        "name": "Mundwa",
                        "latitude": "27.06310000",
                        "longitude": "73.82304000"
                    },
                    {
                        "id": 133252,
                        "name": "Nadbai",
                        "latitude": "27.22288000",
                        "longitude": "77.19569000"
                    },
                    {
                        "id": 133112,
                        "name": "Nagar",
                        "latitude": "27.42397000",
                        "longitude": "77.09922000"
                    },
                    {
                        "id": 133256,
                        "name": "Nagaur",
                        "latitude": "27.20201000",
                        "longitude": "73.73394000"
                    },
                    {
                        "id": 133125,
                        "name": "Nainwa",
                        "latitude": "25.77145000",
                        "longitude": "75.84978000"
                    },
                    {
                        "id": 133153,
                        "name": "Napasar",
                        "latitude": "27.96059000",
                        "longitude": "73.55913000"
                    },
                    {
                        "id": 133154,
                        "name": "Naraina",
                        "latitude": "26.79069000",
                        "longitude": "75.20608000"
                    },
                    {
                        "id": 133180,
                        "name": "Nasirabad",
                        "latitude": "26.30473000",
                        "longitude": "74.73364000"
                    },
                    {
                        "id": 133280,
                        "name": "Nathdwara",
                        "latitude": "24.93805000",
                        "longitude": "73.82392000"
                    },
                    {
                        "id": 133282,
                        "name": "Nawa",
                        "latitude": "27.01950000",
                        "longitude": "75.00226000"
                    },
                    {
                        "id": 133189,
                        "name": "Nawalgarh",
                        "latitude": "27.85161000",
                        "longitude": "75.27384000"
                    },
                    {
                        "id": 133201,
                        "name": "Neem ka Thana",
                        "latitude": "27.73976000",
                        "longitude": "75.78652000"
                    },
                    {
                        "id": 133289,
                        "name": "Nimaj",
                        "latitude": "26.14995000",
                        "longitude": "74.00094000"
                    },
                    {
                        "id": 133288,
                        "name": "Nimbahera",
                        "latitude": "24.62166000",
                        "longitude": "74.67999000"
                    },
                    {
                        "id": 133224,
                        "name": "Niwai",
                        "latitude": "26.36073000",
                        "longitude": "75.91836000"
                    },
                    {
                        "id": 133229,
                        "name": "Nohar",
                        "latitude": "29.18292000",
                        "longitude": "74.77064000"
                    },
                    {
                        "id": 133231,
                        "name": "Nokha",
                        "latitude": "27.56155000",
                        "longitude": "73.47141000"
                    },
                    {
                        "id": 133311,
                        "name": "Padampur",
                        "latitude": "29.70885000",
                        "longitude": "73.62539000"
                    },
                    {
                        "id": 133529,
                        "name": "Pali",
                        "latitude": "25.77276000",
                        "longitude": "73.32335000"
                    },
                    {
                        "id": 133366,
                        "name": "Partapur",
                        "latitude": "23.59276000",
                        "longitude": "74.17396000"
                    },
                    {
                        "id": 133368,
                        "name": "Parvatsar",
                        "latitude": "26.88604000",
                        "longitude": "74.76602000"
                    },
                    {
                        "id": 133433,
                        "name": "Phalodi",
                        "latitude": "27.13102000",
                        "longitude": "72.36826000"
                    },
                    {
                        "id": 133442,
                        "name": "Phulera",
                        "latitude": "26.87401000",
                        "longitude": "75.24171000"
                    },
                    {
                        "id": 133448,
                        "name": "Pilani",
                        "latitude": "28.36725000",
                        "longitude": "75.60352000"
                    },
                    {
                        "id": 133446,
                        "name": "Pilibangan",
                        "latitude": "29.44964000",
                        "longitude": "74.10093000"
                    },
                    {
                        "id": 133450,
                        "name": "Pindwara",
                        "latitude": "24.79749000",
                        "longitude": "73.05505000"
                    },
                    {
                        "id": 133565,
                        "name": "Pipar",
                        "latitude": "26.38441000",
                        "longitude": "73.54394000"
                    },
                    {
                        "id": 133460,
                        "name": "Pirawa",
                        "latitude": "24.15506000",
                        "longitude": "76.02728000"
                    },
                    {
                        "id": 133466,
                        "name": "Pokaran",
                        "latitude": "26.92007000",
                        "longitude": "71.91631000"
                    },
                    {
                        "id": 133486,
                        "name": "Pratapgarh",
                        "latitude": "24.03000000",
                        "longitude": "74.78000000"
                    },
                    {
                        "id": 133516,
                        "name": "Pushkar",
                        "latitude": "26.49022000",
                        "longitude": "74.55211000"
                    },
                    {
                        "id": 133589,
                        "name": "Raipur",
                        "latitude": "26.04259000",
                        "longitude": "74.02373000"
                    },
                    {
                        "id": 133667,
                        "name": "Raisinghnagar",
                        "latitude": "29.53583000",
                        "longitude": "73.44917000"
                    },
                    {
                        "id": 133686,
                        "name": "Rajakhera",
                        "latitude": "26.89802000",
                        "longitude": "78.17100000"
                    },
                    {
                        "id": 133672,
                        "name": "Rajaldesar",
                        "latitude": "28.02849000",
                        "longitude": "74.47442000"
                    },
                    {
                        "id": 133674,
                        "name": "Rajgarh",
                        "latitude": "27.23731000",
                        "longitude": "76.62243000"
                    },
                    {
                        "id": 133596,
                        "name": "Rajsamand",
                        "latitude": "25.23822000",
                        "longitude": "73.93503000"
                    },
                    {
                        "id": 133695,
                        "name": "Ramganj Mandi",
                        "latitude": "24.64648000",
                        "longitude": "75.94325000"
                    },
                    {
                        "id": 133696,
                        "name": "Ramgarh",
                        "latitude": "27.25097000",
                        "longitude": "75.17893000"
                    },
                    {
                        "id": 133714,
                        "name": "Rani",
                        "latitude": "25.35031000",
                        "longitude": "73.30885000"
                    },
                    {
                        "id": 133614,
                        "name": "Ratangarh",
                        "latitude": "28.08137000",
                        "longitude": "74.61854000"
                    },
                    {
                        "id": 133725,
                        "name": "Rawatbhata",
                        "latitude": "24.92981000",
                        "longitude": "75.59209000"
                    },
                    {
                        "id": 133726,
                        "name": "Rawatsar",
                        "latitude": "29.26724000",
                        "longitude": "74.40288000"
                    },
                    {
                        "id": 133736,
                        "name": "Ringas",
                        "latitude": "27.36360000",
                        "longitude": "75.56838000"
                    },
                    {
                        "id": 134058,
                        "name": "Sadri",
                        "latitude": "25.18555000",
                        "longitude": "73.45288000"
                    },
                    {
                        "id": 134064,
                        "name": "Salumbar",
                        "latitude": "24.13524000",
                        "longitude": "74.04442000"
                    },
                    {
                        "id": 134068,
                        "name": "Sambhar",
                        "latitude": "26.90806000",
                        "longitude": "75.19137000"
                    },
                    {
                        "id": 133771,
                        "name": "Samdari",
                        "latitude": "25.81299000",
                        "longitude": "72.57879000"
                    },
                    {
                        "id": 134071,
                        "name": "Sanchor",
                        "latitude": "24.75361000",
                        "longitude": "71.77280000"
                    },
                    {
                        "id": 133781,
                        "name": "Sangaria",
                        "latitude": "29.79886000",
                        "longitude": "74.46683000"
                    },
                    {
                        "id": 133783,
                        "name": "Sangod",
                        "latitude": "24.92707000",
                        "longitude": "76.28649000"
                    },
                    {
                        "id": 133805,
                        "name": "Sardarshahr",
                        "latitude": "28.44062000",
                        "longitude": "74.49100000"
                    },
                    {
                        "id": 133810,
                        "name": "Sarwar",
                        "latitude": "26.06272000",
                        "longitude": "75.01104000"
                    },
                    {
                        "id": 133832,
                        "name": "Sawai Madhopur",
                        "latitude": "26.02301000",
                        "longitude": "76.34408000"
                    },
                    {
                        "id": 133903,
                        "name": "Shahpura",
                        "latitude": "25.62094000",
                        "longitude": "74.92487000"
                    },
                    {
                        "id": 133859,
                        "name": "Sheoganj",
                        "latitude": "25.13915000",
                        "longitude": "73.06784000"
                    },
                    {
                        "id": 134086,
                        "name": "Sikar",
                        "latitude": "27.61206000",
                        "longitude": "75.13996000"
                    },
                    {
                        "id": 133958,
                        "name": "Sirohi",
                        "latitude": "24.83333000",
                        "longitude": "72.75000000"
                    },
                    {
                        "id": 133978,
                        "name": "Siwana",
                        "latitude": "25.65154000",
                        "longitude": "72.42243000"
                    },
                    {
                        "id": 133983,
                        "name": "Sojat",
                        "latitude": "25.92493000",
                        "longitude": "73.66633000"
                    },
                    {
                        "id": 134017,
                        "name": "Sri Dungargarh",
                        "latitude": "28.09617000",
                        "longitude": "74.00868000"
                    },
                    {
                        "id": 134018,
                        "name": "Sri Madhopur",
                        "latitude": "27.46599000",
                        "longitude": "75.59736000"
                    },
                    {
                        "id": 134092,
                        "name": "Sujangarh",
                        "latitude": "27.70000000",
                        "longitude": "74.46667000"
                    },
                    {
                        "id": 134036,
                        "name": "Suket",
                        "latitude": "24.64609000",
                        "longitude": "76.04170000"
                    },
                    {
                        "id": 134046,
                        "name": "Sunel",
                        "latitude": "24.37065000",
                        "longitude": "75.95708000"
                    },
                    {
                        "id": 134094,
                        "name": "Surajgarh",
                        "latitude": "28.31005000",
                        "longitude": "75.73271000"
                    },
                    {
                        "id": 134097,
                        "name": "Suratgarh",
                        "latitude": "29.32150000",
                        "longitude": "73.89979000"
                    },
                    {
                        "id": 134098,
                        "name": "Takhatgarh",
                        "latitude": "25.32235000",
                        "longitude": "73.00487000"
                    },
                    {
                        "id": 134240,
                        "name": "Taranagar",
                        "latitude": "28.66860000",
                        "longitude": "75.03207000"
                    },
                    {
                        "id": 134169,
                        "name": "Tijara",
                        "latitude": "27.93411000",
                        "longitude": "76.85541000"
                    },
                    {
                        "id": 134204,
                        "name": "Todabhim",
                        "latitude": "26.91667000",
                        "longitude": "76.81667000"
                    },
                    {
                        "id": 134205,
                        "name": "Todaraisingh",
                        "latitude": "26.02401000",
                        "longitude": "75.48182000"
                    },
                    {
                        "id": 134208,
                        "name": "Tonk",
                        "latitude": "26.16667000",
                        "longitude": "75.58333000"
                    },
                    {
                        "id": 134250,
                        "name": "Udaipur",
                        "latitude": "24.33000000",
                        "longitude": "73.77000000"
                    },
                    {
                        "id": 134258,
                        "name": "Udpura",
                        "latitude": "24.73355000",
                        "longitude": "75.97514000"
                    },
                    {
                        "id": 134283,
                        "name": "Uniara",
                        "latitude": "26.15336000",
                        "longitude": "75.21523000"
                    },
                    {
                        "id": 134403,
                        "name": "Wer",
                        "latitude": "27.01860000",
                        "longitude": "77.17636000"
                    }
                ]
            },
            {
                "id": 4034,
                "name": "Sikkim",
                "iso2": "SK",
                "latitude": "27.53297180",
                "longitude": "88.51221780",
                "type": "state",
                "cities": [
                    {
                        "id": 131822,
                        "name": "East District",
                        "latitude": "27.33333000",
                        "longitude": "88.66667000"
                    },
                    {
                        "id": 131905,
                        "name": "Gangtok",
                        "latitude": "27.32574000",
                        "longitude": "88.61216000"
                    },
                    {
                        "id": 132041,
                        "name": "Gyalshing",
                        "latitude": "27.28952000",
                        "longitude": "88.25764000"
                    },
                    {
                        "id": 132293,
                        "name": "Jorethang",
                        "latitude": "27.10696000",
                        "longitude": "88.32332000"
                    },
                    {
                        "id": 132906,
                        "name": "Mangan",
                        "latitude": "27.50965000",
                        "longitude": "88.52206000"
                    },
                    {
                        "id": 133137,
                        "name": "Namchi",
                        "latitude": "27.16494000",
                        "longitude": "88.36380000"
                    },
                    {
                        "id": 133194,
                        "name": "Naya Bazar",
                        "latitude": "27.13082000",
                        "longitude": "88.23972000"
                    },
                    {
                        "id": 133235,
                        "name": "North District",
                        "latitude": "27.66667000",
                        "longitude": "88.50000000"
                    },
                    {
                        "id": 133609,
                        "name": "Rangpo",
                        "latitude": "27.17733000",
                        "longitude": "88.53358000"
                    },
                    {
                        "id": 133949,
                        "name": "Singtam",
                        "latitude": "27.23467000",
                        "longitude": "88.50168000"
                    },
                    {
                        "id": 134008,
                        "name": "South District",
                        "latitude": "27.33333000",
                        "longitude": "88.41667000"
                    },
                    {
                        "id": 134405,
                        "name": "West District",
                        "latitude": "27.33333000",
                        "longitude": "88.25000000"
                    }
                ]
            },
            {
                "id": 4035,
                "name": "Tamil Nadu",
                "iso2": "TN",
                "latitude": "11.12712250",
                "longitude": "78.65689420",
                "type": "state",
                "cities": [
                    {
                        "id": 57586,
                        "name": "Abiramam",
                        "latitude": "9.44230000",
                        "longitude": "78.43990000"
                    },
                    {
                        "id": 57594,
                        "name": "Adirampattinam",
                        "latitude": "10.34059000",
                        "longitude": "79.37905000"
                    },
                    {
                        "id": 57595,
                        "name": "Aduthurai",
                        "latitude": "11.01542000",
                        "longitude": "79.48093000"
                    },
                    {
                        "id": 57630,
                        "name": "Alagapuram",
                        "latitude": "11.88705000",
                        "longitude": "78.91758000"
                    },
                    {
                        "id": 57634,
                        "name": "Alandur",
                        "latitude": "13.00250000",
                        "longitude": "80.20611000"
                    },
                    {
                        "id": 57635,
                        "name": "Alanganallur",
                        "latitude": "10.04697000",
                        "longitude": "78.09033000"
                    },
                    {
                        "id": 57636,
                        "name": "Alangayam",
                        "latitude": "12.62235000",
                        "longitude": "78.75207000"
                    },
                    {
                        "id": 134455,
                        "name": "Alangudi",
                        "latitude": "10.36060000",
                        "longitude": "78.98492000"
                    },
                    {
                        "id": 134456,
                        "name": "Alangulam",
                        "latitude": "8.86404000",
                        "longitude": "77.49937000"
                    },
                    {
                        "id": 134457,
                        "name": "Alappakkam",
                        "latitude": "11.59895000",
                        "longitude": "79.71893000"
                    },
                    {
                        "id": 57648,
                        "name": "Alwa Tirunagari",
                        "latitude": "8.60635000",
                        "longitude": "77.93983000"
                    },
                    {
                        "id": 57667,
                        "name": "Ambasamudram",
                        "latitude": "8.71068000",
                        "longitude": "77.45190000"
                    },
                    {
                        "id": 57668,
                        "name": "Ambattur",
                        "latitude": "13.09818000",
                        "longitude": "80.16152000"
                    },
                    {
                        "id": 57671,
                        "name": "Ambur",
                        "latitude": "12.79163000",
                        "longitude": "78.71644000"
                    },
                    {
                        "id": 57682,
                        "name": "Ammapettai",
                        "latitude": "10.79476000",
                        "longitude": "79.31986000"
                    },
                    {
                        "id": 57694,
                        "name": "Anamalais",
                        "latitude": "10.58303000",
                        "longitude": "76.93441000"
                    },
                    {
                        "id": 134460,
                        "name": "Andippatti",
                        "latitude": "9.99797000",
                        "longitude": "77.62097000"
                    },
                    {
                        "id": 57715,
                        "name": "Annamalainagar",
                        "latitude": "11.40000000",
                        "longitude": "79.73333000"
                    },
                    {
                        "id": 57712,
                        "name": "Annavasal",
                        "latitude": "10.46060000",
                        "longitude": "78.70029000"
                    },
                    {
                        "id": 57714,
                        "name": "Annur",
                        "latitude": "11.23616000",
                        "longitude": "77.10514000"
                    },
                    {
                        "id": 57718,
                        "name": "Anthiyur",
                        "latitude": "11.57506000",
                        "longitude": "77.59043000"
                    },
                    {
                        "id": 57726,
                        "name": "Arakkonam",
                        "latitude": "13.08449000",
                        "longitude": "79.67053000"
                    },
                    {
                        "id": 57729,
                        "name": "Arantangi",
                        "latitude": "10.17235000",
                        "longitude": "78.99118000"
                    },
                    {
                        "id": 57731,
                        "name": "Arcot",
                        "latitude": "12.90569000",
                        "longitude": "79.31897000"
                    },
                    {
                        "id": 57732,
                        "name": "Arimalam",
                        "latitude": "10.25498000",
                        "longitude": "78.88403000"
                    },
                    {
                        "id": 57733,
                        "name": "Ariyalur",
                        "latitude": "11.15000000",
                        "longitude": "79.25000000"
                    },
                    {
                        "id": 57737,
                        "name": "Arni",
                        "latitude": "12.66771000",
                        "longitude": "79.28529000"
                    },
                    {
                        "id": 57743,
                        "name": "Arumbavur",
                        "latitude": "11.38096000",
                        "longitude": "78.72965000"
                    },
                    {
                        "id": 57744,
                        "name": "Arumuganeri",
                        "latitude": "8.56880000",
                        "longitude": "78.09091000"
                    },
                    {
                        "id": 57745,
                        "name": "Aruppukkottai",
                        "latitude": "9.50960000",
                        "longitude": "78.09588000"
                    },
                    {
                        "id": 57746,
                        "name": "Aruvankad",
                        "latitude": "11.36315000",
                        "longitude": "76.75790000"
                    },
                    {
                        "id": 134468,
                        "name": "Attayyampatti",
                        "latitude": "11.53272000",
                        "longitude": "78.05363000"
                    },
                    {
                        "id": 57763,
                        "name": "Attur",
                        "latitude": "11.59414000",
                        "longitude": "78.60143000"
                    },
                    {
                        "id": 57767,
                        "name": "Auroville",
                        "latitude": "12.00549000",
                        "longitude": "79.80885000"
                    },
                    {
                        "id": 134469,
                        "name": "Avadi",
                        "latitude": "13.11470000",
                        "longitude": "80.10981000"
                    },
                    {
                        "id": 57773,
                        "name": "Avinashi",
                        "latitude": "11.19297000",
                        "longitude": "77.26865000"
                    },
                    {
                        "id": 57775,
                        "name": "Ayakudi",
                        "latitude": "10.44992000",
                        "longitude": "77.55198000"
                    },
                    {
                        "id": 57776,
                        "name": "Ayyampettai",
                        "latitude": "10.90141000",
                        "longitude": "79.17984000"
                    },
                    {
                        "id": 57929,
                        "name": "Belur",
                        "latitude": "11.70752000",
                        "longitude": "78.41437000"
                    },
                    {
                        "id": 57973,
                        "name": "Bhavani",
                        "latitude": "11.44553000",
                        "longitude": "77.68215000"
                    },
                    {
                        "id": 58072,
                        "name": "Bodinayakkanur",
                        "latitude": "10.01171000",
                        "longitude": "77.34976000"
                    },
                    {
                        "id": 131515,
                        "name": "Chengam",
                        "latitude": "12.30889000",
                        "longitude": "78.79137000"
                    },
                    {
                        "id": 131517,
                        "name": "Chennai",
                        "latitude": "13.08784000",
                        "longitude": "80.27847000"
                    },
                    {
                        "id": 131518,
                        "name": "Chennimalai",
                        "latitude": "11.16378000",
                        "longitude": "77.60388000"
                    },
                    {
                        "id": 131522,
                        "name": "Chetput",
                        "latitude": "13.07000000",
                        "longitude": "80.24083000"
                    },
                    {
                        "id": 131523,
                        "name": "Chettipalaiyam",
                        "latitude": "10.91248000",
                        "longitude": "77.03699000"
                    },
                    {
                        "id": 131525,
                        "name": "Cheyyar",
                        "latitude": "12.66052000",
                        "longitude": "79.54308000"
                    },
                    {
                        "id": 131526,
                        "name": "Cheyyur",
                        "latitude": "12.34948000",
                        "longitude": "80.00304000"
                    },
                    {
                        "id": 131545,
                        "name": "Chidambaram",
                        "latitude": "11.39933000",
                        "longitude": "79.69144000"
                    },
                    {
                        "id": 131561,
                        "name": "Chingleput",
                        "latitude": "12.69184000",
                        "longitude": "79.97661000"
                    },
                    {
                        "id": 131562,
                        "name": "Chinna Salem",
                        "latitude": "11.63422000",
                        "longitude": "78.87412000"
                    },
                    {
                        "id": 131564,
                        "name": "Chinnamanur",
                        "latitude": "9.83999000",
                        "longitude": "77.38109000"
                    },
                    {
                        "id": 131565,
                        "name": "Chinnasekkadu",
                        "latitude": "13.16089000",
                        "longitude": "80.25727000"
                    },
                    {
                        "id": 131578,
                        "name": "Cholapuram",
                        "latitude": "9.35193000",
                        "longitude": "77.56839000"
                    },
                    {
                        "id": 131618,
                        "name": "Coimbatore",
                        "latitude": "10.80000000",
                        "longitude": "77.09000000"
                    },
                    {
                        "id": 131619,
                        "name": "Colachel",
                        "latitude": "8.17938000",
                        "longitude": "77.25818000"
                    },
                    {
                        "id": 131626,
                        "name": "Cuddalore",
                        "latitude": "11.52000000",
                        "longitude": "79.51000000"
                    },
                    {
                        "id": 131629,
                        "name": "Cumbum",
                        "latitude": "9.73647000",
                        "longitude": "77.28470000"
                    },
                    {
                        "id": 131681,
                        "name": "Denkanikota",
                        "latitude": "12.53010000",
                        "longitude": "77.78887000"
                    },
                    {
                        "id": 131698,
                        "name": "Desur",
                        "latitude": "12.43727000",
                        "longitude": "79.48145000"
                    },
                    {
                        "id": 131699,
                        "name": "Devadanappatti",
                        "latitude": "10.14673000",
                        "longitude": "77.64390000"
                    },
                    {
                        "id": 131700,
                        "name": "Devakottai",
                        "latitude": "9.94704000",
                        "longitude": "78.82330000"
                    },
                    {
                        "id": 131711,
                        "name": "Dhali",
                        "latitude": "10.51049000",
                        "longitude": "77.18806000"
                    },
                    {
                        "id": 131723,
                        "name": "Dharapuram",
                        "latitude": "10.73828000",
                        "longitude": "77.53223000"
                    },
                    {
                        "id": 131726,
                        "name": "Dharmapuri",
                        "latitude": "12.12770000",
                        "longitude": "78.15794000"
                    },
                    {
                        "id": 131774,
                        "name": "Dindigul",
                        "latitude": "10.40000000",
                        "longitude": "77.80000000"
                    },
                    {
                        "id": 131820,
                        "name": "Dusi",
                        "latitude": "12.77574000",
                        "longitude": "79.67892000"
                    },
                    {
                        "id": 131834,
                        "name": "Elayirampannai",
                        "latitude": "9.27033000",
                        "longitude": "77.82494000"
                    },
                    {
                        "id": 131833,
                        "name": "Elumalai",
                        "latitude": "9.86501000",
                        "longitude": "77.69923000"
                    },
                    {
                        "id": 131837,
                        "name": "Eral",
                        "latitude": "8.62584000",
                        "longitude": "78.02282000"
                    },
                    {
                        "id": 131839,
                        "name": "Eraniel",
                        "latitude": "8.20589000",
                        "longitude": "77.31726000"
                    },
                    {
                        "id": 131841,
                        "name": "Erode",
                        "latitude": "11.34000000",
                        "longitude": "77.55000000"
                    },
                    {
                        "id": 131843,
                        "name": "Erumaippatti",
                        "latitude": "11.14671000",
                        "longitude": "78.28996000"
                    },
                    {
                        "id": 131847,
                        "name": "Ettaiyapuram",
                        "latitude": "9.14405000",
                        "longitude": "77.99066000"
                    },
                    {
                        "id": 132045,
                        "name": "Gandhi Nagar",
                        "latitude": "13.00639000",
                        "longitude": "80.25417000"
                    },
                    {
                        "id": 131901,
                        "name": "Gangaikondan",
                        "latitude": "8.85785000",
                        "longitude": "77.78019000"
                    },
                    {
                        "id": 131902,
                        "name": "Gangavalli",
                        "latitude": "11.49828000",
                        "longitude": "78.64966000"
                    },
                    {
                        "id": 131957,
                        "name": "Gingee",
                        "latitude": "12.25282000",
                        "longitude": "79.41727000"
                    },
                    {
                        "id": 131961,
                        "name": "Gobichettipalayam",
                        "latitude": "11.45496000",
                        "longitude": "77.44220000"
                    },
                    {
                        "id": 132008,
                        "name": "Gudalur",
                        "latitude": "9.67826000",
                        "longitude": "77.24951000"
                    },
                    {
                        "id": 132011,
                        "name": "Gudiyatham",
                        "latitude": "12.94601000",
                        "longitude": "78.87377000"
                    },
                    {
                        "id": 132050,
                        "name": "Guduvancheri",
                        "latitude": "12.84519000",
                        "longitude": "80.06055000"
                    },
                    {
                        "id": 132023,
                        "name": "Gummidipundi",
                        "latitude": "13.40765000",
                        "longitude": "80.10879000"
                    },
                    {
                        "id": 132083,
                        "name": "Harur",
                        "latitude": "12.05267000",
                        "longitude": "78.48023000"
                    },
                    {
                        "id": 132125,
                        "name": "Hosur",
                        "latitude": "12.73647000",
                        "longitude": "77.83264000"
                    },
                    {
                        "id": 132153,
                        "name": "Idappadi",
                        "latitude": "11.58624000",
                        "longitude": "77.83891000"
                    },
                    {
                        "id": 132159,
                        "name": "Ilampillai",
                        "latitude": "11.60659000",
                        "longitude": "78.00676000"
                    },
                    {
                        "id": 132161,
                        "name": "Iluppur",
                        "latitude": "10.51347000",
                        "longitude": "78.62357000"
                    },
                    {
                        "id": 132169,
                        "name": "Injambakkam",
                        "latitude": "12.91620000",
                        "longitude": "80.24880000"
                    },
                    {
                        "id": 132172,
                        "name": "Irugur",
                        "latitude": "11.01782000",
                        "longitude": "77.06285000"
                    },
                    {
                        "id": 132210,
                        "name": "Jalakandapuram",
                        "latitude": "11.69779000",
                        "longitude": "77.87298000"
                    },
                    {
                        "id": 132225,
                        "name": "Jalarpet",
                        "latitude": "12.57025000",
                        "longitude": "78.57318000"
                    },
                    {
                        "id": 132256,
                        "name": "Jayamkondacholapuram",
                        "latitude": "11.21266000",
                        "longitude": "79.36369000"
                    },
                    {
                        "id": 132324,
                        "name": "Kadambur",
                        "latitude": "8.99739000",
                        "longitude": "77.86191000"
                    },
                    {
                        "id": 132326,
                        "name": "Kadayanallur",
                        "latitude": "9.07277000",
                        "longitude": "77.34152000"
                    },
                    {
                        "id": 132343,
                        "name": "Kalakkadu",
                        "latitude": "8.51380000",
                        "longitude": "77.54944000"
                    },
                    {
                        "id": 132349,
                        "name": "Kalavai",
                        "latitude": "12.77029000",
                        "longitude": "79.41999000"
                    },
                    {
                        "id": 132352,
                        "name": "Kallakkurichchi",
                        "latitude": "11.74040000",
                        "longitude": "78.95900000"
                    },
                    {
                        "id": 132353,
                        "name": "Kallidaikurichi",
                        "latitude": "8.68591000",
                        "longitude": "77.46592000"
                    },
                    {
                        "id": 132354,
                        "name": "Kallupatti",
                        "latitude": "9.71667000",
                        "longitude": "77.86667000"
                    },
                    {
                        "id": 132357,
                        "name": "Kalugumalai",
                        "latitude": "9.14941000",
                        "longitude": "77.70569000"
                    },
                    {
                        "id": 132367,
                        "name": "Kamuthi",
                        "latitude": "9.40732000",
                        "longitude": "78.37337000"
                    },
                    {
                        "id": 132368,
                        "name": "Kanadukattan",
                        "latitude": "10.17209000",
                        "longitude": "78.77935000"
                    },
                    {
                        "id": 132369,
                        "name": "Kancheepuram",
                        "latitude": "12.67000000",
                        "longitude": "79.99000000"
                    },
                    {
                        "id": 132370,
                        "name": "Kanchipuram",
                        "latitude": "12.83515000",
                        "longitude": "79.70006000"
                    },
                    {
                        "id": 132373,
                        "name": "Kangayam",
                        "latitude": "11.00599000",
                        "longitude": "77.56090000"
                    },
                    {
                        "id": 132380,
                        "name": "Kanniyakumari",
                        "latitude": "8.32000000",
                        "longitude": "77.34000000"
                    },
                    {
                        "id": 132714,
                        "name": "Karaikkudi",
                        "latitude": "10.06615000",
                        "longitude": "78.76784000"
                    },
                    {
                        "id": 132716,
                        "name": "Karamadai",
                        "latitude": "11.24058000",
                        "longitude": "76.96009000"
                    },
                    {
                        "id": 132393,
                        "name": "Karambakkudi",
                        "latitude": "10.45866000",
                        "longitude": "79.14101000"
                    },
                    {
                        "id": 132401,
                        "name": "Kariapatti",
                        "latitude": "9.67505000",
                        "longitude": "78.09992000"
                    },
                    {
                        "id": 132409,
                        "name": "Karumbakkam",
                        "latitude": "12.70203000",
                        "longitude": "80.09110000"
                    },
                    {
                        "id": 132410,
                        "name": "Karur",
                        "latitude": "10.95771000",
                        "longitude": "78.08095000"
                    },
                    {
                        "id": 132726,
                        "name": "Katpadi",
                        "latitude": "12.96951000",
                        "longitude": "79.14552000"
                    },
                    {
                        "id": 132429,
                        "name": "Kattivakkam",
                        "latitude": "13.21667000",
                        "longitude": "80.31667000"
                    },
                    {
                        "id": 132728,
                        "name": "Kattupputtur",
                        "latitude": "10.99385000",
                        "longitude": "78.21929000"
                    },
                    {
                        "id": 132730,
                        "name": "Kaveripatnam",
                        "latitude": "12.42186000",
                        "longitude": "78.21880000"
                    },
                    {
                        "id": 132435,
                        "name": "Kayalpattinam",
                        "latitude": "8.57143000",
                        "longitude": "78.11992000"
                    },
                    {
                        "id": 132436,
                        "name": "Kayattar",
                        "latitude": "8.94834000",
                        "longitude": "77.77424000"
                    },
                    {
                        "id": 132437,
                        "name": "Keelakarai",
                        "latitude": "9.23183000",
                        "longitude": "78.78545000"
                    },
                    {
                        "id": 132439,
                        "name": "Kelamangalam",
                        "latitude": "12.60307000",
                        "longitude": "77.85193000"
                    },
                    {
                        "id": 132732,
                        "name": "Kil Bhuvanagiri",
                        "latitude": "11.44216000",
                        "longitude": "79.64763000"
                    },
                    {
                        "id": 132522,
                        "name": "Kilvelur",
                        "latitude": "10.76721000",
                        "longitude": "79.74186000"
                    },
                    {
                        "id": 132733,
                        "name": "Kiranur",
                        "latitude": "10.56988000",
                        "longitude": "78.78682000"
                    },
                    {
                        "id": 132538,
                        "name": "Kodaikanal",
                        "latitude": "10.23925000",
                        "longitude": "77.48932000"
                    },
                    {
                        "id": 132544,
                        "name": "Kodumudi",
                        "latitude": "11.07751000",
                        "longitude": "77.88363000"
                    },
                    {
                        "id": 132562,
                        "name": "Kombai",
                        "latitude": "9.84745000",
                        "longitude": "77.29603000"
                    },
                    {
                        "id": 132568,
                        "name": "Konganapuram",
                        "latitude": "11.57105000",
                        "longitude": "77.90040000"
                    },
                    {
                        "id": 132571,
                        "name": "Koothanallur",
                        "latitude": "10.71990000",
                        "longitude": "79.51570000"
                    },
                    {
                        "id": 132576,
                        "name": "Koradachcheri",
                        "latitude": "10.77019000",
                        "longitude": "79.49158000"
                    },
                    {
                        "id": 132577,
                        "name": "Korampallam",
                        "latitude": "8.77506000",
                        "longitude": "78.09158000"
                    },
                    {
                        "id": 132594,
                        "name": "Kotagiri",
                        "latitude": "11.42072000",
                        "longitude": "76.86035000"
                    },
                    {
                        "id": 132607,
                        "name": "Kottaiyur",
                        "latitude": "10.10956000",
                        "longitude": "78.79560000"
                    },
                    {
                        "id": 132615,
                        "name": "Kovilpatti",
                        "latitude": "9.17167000",
                        "longitude": "77.86989000"
                    },
                    {
                        "id": 132622,
                        "name": "Krishnagiri",
                        "latitude": "12.58000000",
                        "longitude": "77.96000000"
                    },
                    {
                        "id": 132632,
                        "name": "Kulattur",
                        "latitude": "9.00320000",
                        "longitude": "78.19280000"
                    },
                    {
                        "id": 132634,
                        "name": "Kulittalai",
                        "latitude": "10.93487000",
                        "longitude": "78.41251000"
                    },
                    {
                        "id": 132637,
                        "name": "Kumaralingam",
                        "latitude": "10.48936000",
                        "longitude": "77.34990000"
                    },
                    {
                        "id": 132638,
                        "name": "Kumbakonam",
                        "latitude": "10.96209000",
                        "longitude": "79.39124000"
                    },
                    {
                        "id": 132651,
                        "name": "Kunnattur",
                        "latitude": "12.34782000",
                        "longitude": "78.51046000"
                    },
                    {
                        "id": 132659,
                        "name": "Kurinjippadi",
                        "latitude": "11.55028000",
                        "longitude": "79.59066000"
                    },
                    {
                        "id": 132672,
                        "name": "Kuttalam",
                        "latitude": "8.93030000",
                        "longitude": "77.26951000"
                    },
                    {
                        "id": 132673,
                        "name": "Kuzhithurai",
                        "latitude": "8.31792000",
                        "longitude": "77.19192000"
                    },
                    {
                        "id": 132754,
                        "name": "Lalgudi",
                        "latitude": "10.87419000",
                        "longitude": "78.81935000"
                    },
                    {
                        "id": 132807,
                        "name": "Madambakkam",
                        "latitude": "12.85250000",
                        "longitude": "80.04667000"
                    },
                    {
                        "id": 132818,
                        "name": "Madipakkam",
                        "latitude": "12.96226000",
                        "longitude": "80.19864000"
                    },
                    {
                        "id": 132819,
                        "name": "Madukkarai",
                        "latitude": "10.90568000",
                        "longitude": "76.96344000"
                    },
                    {
                        "id": 132820,
                        "name": "Madukkur",
                        "latitude": "10.48098000",
                        "longitude": "79.39939000"
                    },
                    {
                        "id": 132821,
                        "name": "Madurai",
                        "latitude": "9.89000000",
                        "longitude": "78.03000000"
                    },
                    {
                        "id": 132822,
                        "name": "Madurantakam",
                        "latitude": "12.51167000",
                        "longitude": "79.88485000"
                    },
                    {
                        "id": 132876,
                        "name": "Mallapuram",
                        "latitude": "11.98231000",
                        "longitude": "78.24796000"
                    },
                    {
                        "id": 132875,
                        "name": "Mallasamudram",
                        "latitude": "11.49333000",
                        "longitude": "78.03119000"
                    },
                    {
                        "id": 133067,
                        "name": "Mallur",
                        "latitude": "11.54424000",
                        "longitude": "78.14078000"
                    },
                    {
                        "id": 132880,
                        "name": "Manali",
                        "latitude": "13.16667000",
                        "longitude": "80.26667000"
                    },
                    {
                        "id": 132881,
                        "name": "Manalurpettai",
                        "latitude": "12.00788000",
                        "longitude": "79.09184000"
                    },
                    {
                        "id": 132882,
                        "name": "Manamadurai",
                        "latitude": "9.67318000",
                        "longitude": "78.47096000"
                    },
                    {
                        "id": 132883,
                        "name": "Manappakkam",
                        "latitude": "13.01083000",
                        "longitude": "80.16861000"
                    },
                    {
                        "id": 132884,
                        "name": "Manapparai",
                        "latitude": "10.60772000",
                        "longitude": "78.42582000"
                    },
                    {
                        "id": 132885,
                        "name": "Manavalakurichi",
                        "latitude": "8.14776000",
                        "longitude": "77.30552000"
                    },
                    {
                        "id": 132889,
                        "name": "Mandapam",
                        "latitude": "9.27571000",
                        "longitude": "79.12362000"
                    },
                    {
                        "id": 132903,
                        "name": "Mangalam",
                        "latitude": "9.76473000",
                        "longitude": "78.64037000"
                    },
                    {
                        "id": 132919,
                        "name": "Mannargudi",
                        "latitude": "10.66626000",
                        "longitude": "79.45064000"
                    },
                    {
                        "id": 132932,
                        "name": "Marakkanam",
                        "latitude": "12.19214000",
                        "longitude": "79.94193000"
                    },
                    {
                        "id": 133089,
                        "name": "Marandahalli",
                        "latitude": "12.38826000",
                        "longitude": "78.00316000"
                    },
                    {
                        "id": 132939,
                        "name": "Masinigudi",
                        "latitude": "11.56831000",
                        "longitude": "76.64087000"
                    },
                    {
                        "id": 133091,
                        "name": "Mattur",
                        "latitude": "11.32147000",
                        "longitude": "79.20245000"
                    },
                    {
                        "id": 132952,
                        "name": "Mayiladuthurai",
                        "latitude": "11.10354000",
                        "longitude": "79.65500000"
                    },
                    {
                        "id": 132965,
                        "name": "Melur",
                        "latitude": "10.03241000",
                        "longitude": "78.33930000"
                    },
                    {
                        "id": 132969,
                        "name": "Mettuppalaiyam",
                        "latitude": "11.16806000",
                        "longitude": "78.44944000"
                    },
                    {
                        "id": 132970,
                        "name": "Mettur",
                        "latitude": "11.78796000",
                        "longitude": "77.80080000"
                    },
                    {
                        "id": 133094,
                        "name": "Minjur",
                        "latitude": "13.27951000",
                        "longitude": "80.25815000"
                    },
                    {
                        "id": 132982,
                        "name": "Mohanur",
                        "latitude": "11.05936000",
                        "longitude": "78.13965000"
                    },
                    {
                        "id": 133013,
                        "name": "Mudukulattur",
                        "latitude": "9.34169000",
                        "longitude": "78.51388000"
                    },
                    {
                        "id": 133100,
                        "name": "Mulanur",
                        "latitude": "10.79426000",
                        "longitude": "77.71150000"
                    },
                    {
                        "id": 133045,
                        "name": "Musiri",
                        "latitude": "10.95299000",
                        "longitude": "78.44427000"
                    },
                    {
                        "id": 133049,
                        "name": "Muttupet",
                        "latitude": "10.39505000",
                        "longitude": "79.49353000"
                    },
                    {
                        "id": 133108,
                        "name": "Naduvattam",
                        "latitude": "11.48075000",
                        "longitude": "76.54365000"
                    },
                    {
                        "id": 133111,
                        "name": "Nagapattinam",
                        "latitude": "10.85000000",
                        "longitude": "79.74000000"
                    },
                    {
                        "id": 133257,
                        "name": "Nagercoil",
                        "latitude": "8.17899000",
                        "longitude": "77.43227000"
                    },
                    {
                        "id": 133264,
                        "name": "Namagiripettai",
                        "latitude": "11.45513000",
                        "longitude": "78.26818000"
                    },
                    {
                        "id": 133134,
                        "name": "Namakkal",
                        "latitude": "11.30000000",
                        "longitude": "78.13000000"
                    },
                    {
                        "id": 133135,
                        "name": "Nambiyur",
                        "latitude": "11.35811000",
                        "longitude": "77.32115000"
                    },
                    {
                        "id": 133136,
                        "name": "Nambutalai",
                        "latitude": "9.72766000",
                        "longitude": "79.00707000"
                    },
                    {
                        "id": 133140,
                        "name": "Nandambakkam",
                        "latitude": "12.97795000",
                        "longitude": "80.06781000"
                    },
                    {
                        "id": 133148,
                        "name": "Nangavalli",
                        "latitude": "11.76189000",
                        "longitude": "77.89093000"
                    },
                    {
                        "id": 133149,
                        "name": "Nangilickondan",
                        "latitude": "12.25539000",
                        "longitude": "79.47508000"
                    },
                    {
                        "id": 133150,
                        "name": "Nanguneri",
                        "latitude": "8.49326000",
                        "longitude": "77.65806000"
                    },
                    {
                        "id": 133152,
                        "name": "Nannilam",
                        "latitude": "10.87933000",
                        "longitude": "79.61062000"
                    },
                    {
                        "id": 133271,
                        "name": "Naravarikuppam",
                        "latitude": "13.19133000",
                        "longitude": "80.18473000"
                    },
                    {
                        "id": 133181,
                        "name": "Nattam",
                        "latitude": "10.22776000",
                        "longitude": "78.22969000"
                    },
                    {
                        "id": 133281,
                        "name": "Nattarasankottai",
                        "latitude": "9.86905000",
                        "longitude": "78.55305000"
                    },
                    {
                        "id": 133199,
                        "name": "Needamangalam",
                        "latitude": "10.77378000",
                        "longitude": "79.41875000"
                    },
                    {
                        "id": 133200,
                        "name": "Neelankarai",
                        "latitude": "12.94950000",
                        "longitude": "80.25920000"
                    },
                    {
                        "id": 133203,
                        "name": "Negapatam",
                        "latitude": "10.76377000",
                        "longitude": "79.84313000"
                    },
                    {
                        "id": 133205,
                        "name": "Nellikkuppam",
                        "latitude": "11.77554000",
                        "longitude": "79.67016000"
                    },
                    {
                        "id": 133216,
                        "name": "Nilakottai",
                        "latitude": "10.16500000",
                        "longitude": "77.85024000"
                    },
                    {
                        "id": 133218,
                        "name": "Nilgiris",
                        "latitude": "11.46000000",
                        "longitude": "76.64000000"
                    },
                    {
                        "id": 133296,
                        "name": "Odugattur",
                        "latitude": "12.76793000",
                        "longitude": "78.88304000"
                    },
                    {
                        "id": 133299,
                        "name": "Omalur",
                        "latitude": "11.74099000",
                        "longitude": "78.04559000"
                    },
                    {
                        "id": 133301,
                        "name": "Ooty",
                        "latitude": "11.41340000",
                        "longitude": "76.69521000"
                    },
                    {
                        "id": 133314,
                        "name": "Padmanabhapuram",
                        "latitude": "8.24462000",
                        "longitude": "77.32581000"
                    },
                    {
                        "id": 133522,
                        "name": "Palakkodu",
                        "latitude": "12.30696000",
                        "longitude": "78.07022000"
                    },
                    {
                        "id": 133524,
                        "name": "Palamedu",
                        "latitude": "10.10501000",
                        "longitude": "78.11336000"
                    },
                    {
                        "id": 133323,
                        "name": "Palani",
                        "latitude": "10.45034000",
                        "longitude": "77.52090000"
                    },
                    {
                        "id": 133324,
                        "name": "Palavakkam",
                        "latitude": "12.95350000",
                        "longitude": "80.25720000"
                    },
                    {
                        "id": 133327,
                        "name": "Palladam",
                        "latitude": "10.99175000",
                        "longitude": "77.28633000"
                    },
                    {
                        "id": 133328,
                        "name": "Pallappatti",
                        "latitude": "10.72057000",
                        "longitude": "77.87951000"
                    },
                    {
                        "id": 133329,
                        "name": "Pallattur",
                        "latitude": "10.14609000",
                        "longitude": "78.80309000"
                    },
                    {
                        "id": 133335,
                        "name": "Pallavaram",
                        "latitude": "12.96796000",
                        "longitude": "80.15025000"
                    },
                    {
                        "id": 133332,
                        "name": "Pallikondai",
                        "latitude": "12.90518000",
                        "longitude": "78.94270000"
                    },
                    {
                        "id": 133333,
                        "name": "Pallipattu",
                        "latitude": "13.33860000",
                        "longitude": "79.44489000"
                    },
                    {
                        "id": 133334,
                        "name": "Pallippatti",
                        "latitude": "11.93990000",
                        "longitude": "78.40161000"
                    },
                    {
                        "id": 133352,
                        "name": "Panruti",
                        "latitude": "11.77662000",
                        "longitude": "79.55269000"
                    },
                    {
                        "id": 133355,
                        "name": "Papanasam",
                        "latitude": "10.92687000",
                        "longitude": "79.27056000"
                    },
                    {
                        "id": 133545,
                        "name": "Papireddippatti",
                        "latitude": "11.91774000",
                        "longitude": "78.36865000"
                    },
                    {
                        "id": 133547,
                        "name": "Papparappatti",
                        "latitude": "12.22086000",
                        "longitude": "78.05920000"
                    },
                    {
                        "id": 133356,
                        "name": "Paramagudi",
                        "latitude": "9.54633000",
                        "longitude": "78.59070000"
                    },
                    {
                        "id": 133392,
                        "name": "Pattukkottai",
                        "latitude": "10.42358000",
                        "longitude": "79.31949000"
                    },
                    {
                        "id": 133406,
                        "name": "Pennadam",
                        "latitude": "11.40389000",
                        "longitude": "79.24156000"
                    },
                    {
                        "id": 133407,
                        "name": "Pennagaram",
                        "latitude": "12.13433000",
                        "longitude": "77.89525000"
                    },
                    {
                        "id": 133408,
                        "name": "Pennathur",
                        "latitude": "12.24681000",
                        "longitude": "79.22592000"
                    },
                    {
                        "id": 133411,
                        "name": "Peraiyur",
                        "latitude": "9.73579000",
                        "longitude": "77.78955000"
                    },
                    {
                        "id": 133412,
                        "name": "Perambalur",
                        "latitude": "11.27200000",
                        "longitude": "78.87380000"
                    },
                    {
                        "id": 133413,
                        "name": "Peranamallur",
                        "latitude": "12.57052000",
                        "longitude": "79.43332000"
                    },
                    {
                        "id": 133414,
                        "name": "Peranampattu",
                        "latitude": "12.93430000",
                        "longitude": "78.71890000"
                    },
                    {
                        "id": 133415,
                        "name": "Peravurani",
                        "latitude": "10.29035000",
                        "longitude": "79.20156000"
                    },
                    {
                        "id": 133417,
                        "name": "Periyakulam",
                        "latitude": "10.12268000",
                        "longitude": "77.54372000"
                    },
                    {
                        "id": 133418,
                        "name": "Periyanayakkanpalaiyam",
                        "latitude": "11.15255000",
                        "longitude": "76.95159000"
                    },
                    {
                        "id": 133419,
                        "name": "Periyanegamam",
                        "latitude": "10.74317000",
                        "longitude": "77.10296000"
                    },
                    {
                        "id": 133420,
                        "name": "Periyapatti",
                        "latitude": "10.75812000",
                        "longitude": "77.27087000"
                    },
                    {
                        "id": 133421,
                        "name": "Periyapattinam",
                        "latitude": "9.27263000",
                        "longitude": "78.90232000"
                    },
                    {
                        "id": 133425,
                        "name": "Perundurai",
                        "latitude": "11.27564000",
                        "longitude": "77.58794000"
                    },
                    {
                        "id": 133426,
                        "name": "Perungudi",
                        "latitude": "12.96095000",
                        "longitude": "80.24094000"
                    },
                    {
                        "id": 133428,
                        "name": "Perur",
                        "latitude": "10.97519000",
                        "longitude": "76.91292000"
                    },
                    {
                        "id": 133469,
                        "name": "Pollachi",
                        "latitude": "10.65825000",
                        "longitude": "77.00850000"
                    },
                    {
                        "id": 133470,
                        "name": "Polur",
                        "latitude": "12.51217000",
                        "longitude": "79.12405000"
                    },
                    {
                        "id": 133473,
                        "name": "Ponnamaravati",
                        "latitude": "10.28032000",
                        "longitude": "78.53601000"
                    },
                    {
                        "id": 133475,
                        "name": "Ponneri",
                        "latitude": "13.33868000",
                        "longitude": "80.19487000"
                    },
                    {
                        "id": 133479,
                        "name": "Poonamalle",
                        "latitude": "13.04888000",
                        "longitude": "80.11488000"
                    },
                    {
                        "id": 133483,
                        "name": "Porur",
                        "latitude": "13.03565000",
                        "longitude": "80.15821000"
                    },
                    {
                        "id": 133491,
                        "name": "Pudukkottai",
                        "latitude": "10.35000000",
                        "longitude": "78.90000000"
                    },
                    {
                        "id": 133492,
                        "name": "Puduppatti",
                        "latitude": "11.15217000",
                        "longitude": "78.21205000"
                    },
                    {
                        "id": 133494,
                        "name": "Pudur",
                        "latitude": "12.99801000",
                        "longitude": "79.14352000"
                    },
                    {
                        "id": 133493,
                        "name": "Puduvayal",
                        "latitude": "13.33015000",
                        "longitude": "80.14577000"
                    },
                    {
                        "id": 133498,
                        "name": "Puliyangudi",
                        "latitude": "9.17489000",
                        "longitude": "77.39799000"
                    },
                    {
                        "id": 133499,
                        "name": "Puliyur",
                        "latitude": "10.63375000",
                        "longitude": "78.84139000"
                    },
                    {
                        "id": 133500,
                        "name": "Pullambadi",
                        "latitude": "10.94110000",
                        "longitude": "78.91041000"
                    },
                    {
                        "id": 133507,
                        "name": "Punjai Puliyampatti",
                        "latitude": "11.35163000",
                        "longitude": "77.16671000"
                    },
                    {
                        "id": 133594,
                        "name": "Rajapalaiyam",
                        "latitude": "9.45296000",
                        "longitude": "77.55335000"
                    },
                    {
                        "id": 133599,
                        "name": "Ramanathapuram",
                        "latitude": "9.37158000",
                        "longitude": "78.83077000"
                    },
                    {
                        "id": 133603,
                        "name": "Rameswaram",
                        "latitude": "9.28850000",
                        "longitude": "79.31271000"
                    },
                    {
                        "id": 149548,
                        "name": "Ranipet",
                        "latitude": "12.95347490",
                        "longitude": "79.28159160"
                    },
                    {
                        "id": 133611,
                        "name": "Rasipuram",
                        "latitude": "11.46009000",
                        "longitude": "78.18635000"
                    },
                    {
                        "id": 133758,
                        "name": "Saint Thomas Mount",
                        "latitude": "13.00334000",
                        "longitude": "80.19614000"
                    },
                    {
                        "id": 133763,
                        "name": "Salem",
                        "latitude": "11.65370120",
                        "longitude": "77.99821060"
                    },
                    {
                        "id": 133817,
                        "name": "Sathankulam",
                        "latitude": "8.44164000",
                        "longitude": "77.91349000"
                    },
                    {
                        "id": 133819,
                        "name": "Sathyamangalam",
                        "latitude": "11.50526000",
                        "longitude": "77.23826000"
                    },
                    {
                        "id": 133823,
                        "name": "Sattur",
                        "latitude": "9.35592000",
                        "longitude": "77.92457000"
                    },
                    {
                        "id": 134084,
                        "name": "Sayalkudi",
                        "latitude": "9.16925000",
                        "longitude": "78.44702000"
                    },
                    {
                        "id": 133851,
                        "name": "Seven Pagodas",
                        "latitude": "12.62091000",
                        "longitude": "80.19331000"
                    },
                    {
                        "id": 133883,
                        "name": "Sholinghur",
                        "latitude": "13.11810000",
                        "longitude": "79.42025000"
                    },
                    {
                        "id": 133950,
                        "name": "Singanallur",
                        "latitude": "10.99898000",
                        "longitude": "77.03238000"
                    },
                    {
                        "id": 133945,
                        "name": "Singapperumalkovil",
                        "latitude": "12.75947000",
                        "longitude": "80.00750000"
                    },
                    {
                        "id": 134088,
                        "name": "Sirkazhi",
                        "latitude": "11.23725000",
                        "longitude": "79.73585000"
                    },
                    {
                        "id": 133968,
                        "name": "Sirumugai",
                        "latitude": "11.32137000",
                        "longitude": "77.00521000"
                    },
                    {
                        "id": 133974,
                        "name": "Sivaganga",
                        "latitude": "9.92762000",
                        "longitude": "78.53763000"
                    },
                    {
                        "id": 133975,
                        "name": "Sivagiri",
                        "latitude": "9.34461000",
                        "longitude": "77.42911000"
                    },
                    {
                        "id": 133976,
                        "name": "Sivakasi",
                        "latitude": "9.44999000",
                        "longitude": "77.79797000"
                    },
                    {
                        "id": 134026,
                        "name": "Srimushnam",
                        "latitude": "11.40118000",
                        "longitude": "79.40384000"
                    },
                    {
                        "id": 134030,
                        "name": "Sriperumbudur",
                        "latitude": "12.96763000",
                        "longitude": "79.94197000"
                    },
                    {
                        "id": 134022,
                        "name": "Srivaikuntam",
                        "latitude": "8.62931000",
                        "longitude": "77.91281000"
                    },
                    {
                        "id": 134023,
                        "name": "Srivilliputhur",
                        "latitude": "9.51272000",
                        "longitude": "77.63369000"
                    },
                    {
                        "id": 134035,
                        "name": "Suchindram",
                        "latitude": "8.15442000",
                        "longitude": "77.46704000"
                    },
                    {
                        "id": 134041,
                        "name": "Sulur",
                        "latitude": "11.02427000",
                        "longitude": "77.12565000"
                    },
                    {
                        "id": 134095,
                        "name": "Surandai",
                        "latitude": "8.97574000",
                        "longitude": "77.41923000"
                    },
                    {
                        "id": 134057,
                        "name": "Swamimalai",
                        "latitude": "10.95747000",
                        "longitude": "79.32931000"
                    },
                    {
                        "id": 134108,
                        "name": "Tambaram",
                        "latitude": "12.92460000",
                        "longitude": "80.12707000"
                    },
                    {
                        "id": 134111,
                        "name": "Tanjore",
                        "latitude": "10.78523000",
                        "longitude": "79.13909000"
                    },
                    {
                        "id": 134239,
                        "name": "Taramangalam",
                        "latitude": "11.69403000",
                        "longitude": "77.97035000"
                    },
                    {
                        "id": 134243,
                        "name": "Tattayyangarpettai",
                        "latitude": "11.12417000",
                        "longitude": "78.44916000"
                    },
                    {
                        "id": 134140,
                        "name": "Thanjavur",
                        "latitude": "10.64000000",
                        "longitude": "79.22000000"
                    },
                    {
                        "id": 134143,
                        "name": "Tharangambadi",
                        "latitude": "11.02764000",
                        "longitude": "79.85425000"
                    },
                    {
                        "id": 134146,
                        "name": "Theni",
                        "latitude": "9.85000000",
                        "longitude": "77.42000000"
                    },
                    {
                        "id": 134147,
                        "name": "Thenkasi",
                        "latitude": "8.96003000",
                        "longitude": "77.31525000"
                    },
                    {
                        "id": 134150,
                        "name": "Thirukattupalli",
                        "latitude": "10.84431000",
                        "longitude": "78.95647000"
                    },
                    {
                        "id": 134151,
                        "name": "Thiruthani",
                        "latitude": "13.17594000",
                        "longitude": "79.61637000"
                    },
                    {
                        "id": 134152,
                        "name": "Thiruvaiyaru",
                        "latitude": "10.88405000",
                        "longitude": "79.10362000"
                    },
                    {
                        "id": 134153,
                        "name": "Thiruvallur",
                        "latitude": "13.25000000",
                        "longitude": "80.00000000"
                    },
                    {
                        "id": 134155,
                        "name": "Thiruvarur",
                        "latitude": "10.77269000",
                        "longitude": "79.63680000"
                    },
                    {
                        "id": 134156,
                        "name": "Thiruvidaimaruthur",
                        "latitude": "10.99857000",
                        "longitude": "79.45227000"
                    },
                    {
                        "id": 134158,
                        "name": "Thoothukudi",
                        "latitude": "8.76735000",
                        "longitude": "78.13425000"
                    },
                    {
                        "id": 134172,
                        "name": "Tindivanam",
                        "latitude": "12.23400000",
                        "longitude": "79.65551000"
                    },
                    {
                        "id": 134174,
                        "name": "Tinnanur",
                        "latitude": "13.11448000",
                        "longitude": "80.02713000"
                    },
                    {
                        "id": 134178,
                        "name": "Tiruchchendur",
                        "latitude": "8.49725000",
                        "longitude": "78.11906000"
                    },
                    {
                        "id": 134179,
                        "name": "Tiruchengode",
                        "latitude": "11.38016000",
                        "longitude": "77.89444000"
                    },
                    {
                        "id": 134180,
                        "name": "Tiruchirappalli",
                        "latitude": "10.97000000",
                        "longitude": "78.65000000"
                    },
                    {
                        "id": 134181,
                        "name": "Tirukkoyilur",
                        "latitude": "11.96620000",
                        "longitude": "79.20259000"
                    },
                    {
                        "id": 134184,
                        "name": "Tirumullaivasal",
                        "latitude": "11.23996000",
                        "longitude": "79.83705000"
                    },
                    {
                        "id": 134185,
                        "name": "Tirunelveli",
                        "latitude": "8.72742000",
                        "longitude": "77.68380000"
                    },
                    {
                        "id": 134186,
                        "name": "Tirunelveli Kattabo",
                        "latitude": "8.79270000",
                        "longitude": "77.57409000"
                    },
                    {
                        "id": 134191,
                        "name": "Tiruppalaikudi",
                        "latitude": "9.54606000",
                        "longitude": "78.91721000"
                    },
                    {
                        "id": 134188,
                        "name": "Tirupparangunram",
                        "latitude": "9.88151000",
                        "longitude": "78.07306000"
                    },
                    {
                        "id": 134189,
                        "name": "Tiruppur",
                        "latitude": "11.11541000",
                        "longitude": "77.35456000"
                    },
                    {
                        "id": 134190,
                        "name": "Tiruppuvanam",
                        "latitude": "9.82564000",
                        "longitude": "78.25795000"
                    },
                    {
                        "id": 134193,
                        "name": "Tiruttangal",
                        "latitude": "9.48333000",
                        "longitude": "77.83333000"
                    },
                    {
                        "id": 134196,
                        "name": "Tiruvannamalai",
                        "latitude": "12.51000000",
                        "longitude": "79.09000000"
                    },
                    {
                        "id": 134198,
                        "name": "Tiruvottiyur",
                        "latitude": "13.15823000",
                        "longitude": "80.30181000"
                    },
                    {
                        "id": 134200,
                        "name": "Tisaiyanvilai",
                        "latitude": "8.33702000",
                        "longitude": "77.86776000"
                    },
                    {
                        "id": 134207,
                        "name": "Tondi",
                        "latitude": "9.74173000",
                        "longitude": "79.01774000"
                    },
                    {
                        "id": 134224,
                        "name": "Turaiyur",
                        "latitude": "11.14968000",
                        "longitude": "78.59870000"
                    },
                    {
                        "id": 134253,
                        "name": "Udangudi",
                        "latitude": "8.42918000",
                        "longitude": "78.02968000"
                    },
                    {
                        "id": 134259,
                        "name": "Udumalaippettai",
                        "latitude": "10.58806000",
                        "longitude": "77.24779000"
                    },
                    {
                        "id": 134290,
                        "name": "Uppiliyapuram",
                        "latitude": "11.26356000",
                        "longitude": "78.51390000"
                    },
                    {
                        "id": 134295,
                        "name": "Usilampatti",
                        "latitude": "9.96936000",
                        "longitude": "77.78621000"
                    },
                    {
                        "id": 134298,
                        "name": "Uttamapalaiyam",
                        "latitude": "9.80701000",
                        "longitude": "77.32718000"
                    },
                    {
                        "id": 134302,
                        "name": "Uttiramerur",
                        "latitude": "12.61433000",
                        "longitude": "79.75748000"
                    },
                    {
                        "id": 134472,
                        "name": "Uttukkuli",
                        "latitude": "11.16892000",
                        "longitude": "77.45431000"
                    },
                    {
                        "id": 134303,
                        "name": "V.S.K.Valasai (Dindigul-Dist.)",
                        "latitude": "10.31549000",
                        "longitude": "78.15141000"
                    },
                    {
                        "id": 134304,
                        "name": "Vadakku Valliyur",
                        "latitude": "8.38286000",
                        "longitude": "77.61221000"
                    },
                    {
                        "id": 134305,
                        "name": "Vadakku Viravanallur",
                        "latitude": "8.69786000",
                        "longitude": "77.51916000"
                    },
                    {
                        "id": 134306,
                        "name": "Vadamadurai",
                        "latitude": "10.44081000",
                        "longitude": "78.09784000"
                    },
                    {
                        "id": 134380,
                        "name": "Vadippatti",
                        "latitude": "10.08481000",
                        "longitude": "77.96113000"
                    },
                    {
                        "id": 134316,
                        "name": "Valangaiman",
                        "latitude": "10.89012000",
                        "longitude": "79.39322000"
                    },
                    {
                        "id": 134317,
                        "name": "Valavanur",
                        "latitude": "11.92094000",
                        "longitude": "79.58239000"
                    },
                    {
                        "id": 134319,
                        "name": "Vallam",
                        "latitude": "10.71988000",
                        "longitude": "79.05981000"
                    },
                    {
                        "id": 134320,
                        "name": "Valparai",
                        "latitude": "10.32691000",
                        "longitude": "76.95116000"
                    },
                    {
                        "id": 134323,
                        "name": "Vandalur",
                        "latitude": "12.89240000",
                        "longitude": "80.08079000"
                    },
                    {
                        "id": 134324,
                        "name": "Vandavasi",
                        "latitude": "12.50429000",
                        "longitude": "79.60556000"
                    },
                    {
                        "id": 134325,
                        "name": "Vaniyambadi",
                        "latitude": "12.68162000",
                        "longitude": "78.62014000"
                    },
                    {
                        "id": 134384,
                        "name": "Vasudevanallur",
                        "latitude": "9.24171000",
                        "longitude": "77.41177000"
                    },
                    {
                        "id": 134335,
                        "name": "Vattalkundu",
                        "latitude": "10.16069000",
                        "longitude": "77.75883000"
                    },
                    {
                        "id": 134337,
                        "name": "Vedaraniyam",
                        "latitude": "10.37208000",
                        "longitude": "79.85095000"
                    },
                    {
                        "id": 134338,
                        "name": "Vedasandur",
                        "latitude": "10.53102000",
                        "longitude": "77.95019000"
                    },
                    {
                        "id": 134340,
                        "name": "Velankanni",
                        "latitude": "10.68333000",
                        "longitude": "79.83333000"
                    },
                    {
                        "id": 134342,
                        "name": "Vellanur",
                        "latitude": "13.15804000",
                        "longitude": "80.10634000"
                    },
                    {
                        "id": 134341,
                        "name": "Vellore",
                        "latitude": "12.86000000",
                        "longitude": "79.03500000"
                    },
                    {
                        "id": 134343,
                        "name": "Velur",
                        "latitude": "11.10825000",
                        "longitude": "78.00113000"
                    },
                    {
                        "id": 134345,
                        "name": "Vengavasal",
                        "latitude": "12.89911000",
                        "longitude": "80.16900000"
                    },
                    {
                        "id": 134351,
                        "name": "Vettaikkaranpudur",
                        "latitude": "10.56207000",
                        "longitude": "76.91305000"
                    },
                    {
                        "id": 134352,
                        "name": "Vettavalam",
                        "latitude": "12.10769000",
                        "longitude": "79.24516000"
                    },
                    {
                        "id": 134355,
                        "name": "Vijayapuri",
                        "latitude": "11.24530000",
                        "longitude": "77.50066000"
                    },
                    {
                        "id": 134358,
                        "name": "Vikravandi",
                        "latitude": "12.03690000",
                        "longitude": "79.54595000"
                    },
                    {
                        "id": 134361,
                        "name": "Vilattikulam",
                        "latitude": "9.13227000",
                        "longitude": "78.16635000"
                    },
                    {
                        "id": 134362,
                        "name": "Villupuram",
                        "latitude": "11.99000000",
                        "longitude": "79.37000000"
                    },
                    {
                        "id": 134385,
                        "name": "Viraganur",
                        "latitude": "11.47613000",
                        "longitude": "78.73553000"
                    },
                    {
                        "id": 134366,
                        "name": "Virudhunagar",
                        "latitude": "9.45000000",
                        "longitude": "77.92000000"
                    },
                    {
                        "id": 134375,
                        "name": "Vriddhachalam",
                        "latitude": "11.51830000",
                        "longitude": "79.32411000"
                    },
                    {
                        "id": 134391,
                        "name": "Walajapet",
                        "latitude": "12.92510000",
                        "longitude": "79.36626000"
                    },
                    {
                        "id": 134392,
                        "name": "Wallajahbad",
                        "latitude": "12.79041000",
                        "longitude": "79.82358000"
                    },
                    {
                        "id": 134402,
                        "name": "Wellington",
                        "latitude": "11.36552000",
                        "longitude": "76.78442000"
                    }
                ]
            },
            {
                "id": 4012,
                "name": "Telangana",
                "iso2": "TG",
                "latitude": "18.11243720",
                "longitude": "79.01929970",
                "type": "state",
                "cities": [
                    {
                        "id": 134451,
                        "name": "Adilabad",
                        "latitude": "19.50000000",
                        "longitude": "78.50000000"
                    },
                    {
                        "id": 134454,
                        "name": "Alampur",
                        "latitude": "15.87987000",
                        "longitude": "78.13352000"
                    },
                    {
                        "id": 57701,
                        "name": "Andol",
                        "latitude": "17.81458000",
                        "longitude": "78.07713000"
                    },
                    {
                        "id": 57754,
                        "name": "Asifabad",
                        "latitude": "19.35851000",
                        "longitude": "79.28415000"
                    },
                    {
                        "id": 58120,
                        "name": "Balapur",
                        "latitude": "17.31018000",
                        "longitude": "78.49969000"
                    },
                    {
                        "id": 58133,
                        "name": "Banswada",
                        "latitude": "18.37725000",
                        "longitude": "77.88007000"
                    },
                    {
                        "id": 57923,
                        "name": "Bellampalli",
                        "latitude": "19.05577000",
                        "longitude": "79.49300000"
                    },
                    {
                        "id": 57955,
                        "name": "Bhadrachalam",
                        "latitude": "17.66846000",
                        "longitude": "80.88887000"
                    },
                    {
                        "id": 57952,
                        "name": "Bhadradri Kothagudem",
                        "latitude": "17.55460000",
                        "longitude": "80.61976000"
                    },
                    {
                        "id": 57960,
                        "name": "Bhaisa",
                        "latitude": "19.11285000",
                        "longitude": "77.96336000"
                    },
                    {
                        "id": 57994,
                        "name": "Bhongir",
                        "latitude": "17.51544000",
                        "longitude": "78.88563000"
                    },
                    {
                        "id": 58071,
                        "name": "Bodhan",
                        "latitude": "18.66208000",
                        "longitude": "77.88581000"
                    },
                    {
                        "id": 58194,
                        "name": "Chandur",
                        "latitude": "17.87455000",
                        "longitude": "78.10017000"
                    },
                    {
                        "id": 131607,
                        "name": "Chatakonda",
                        "latitude": "17.55303000",
                        "longitude": "80.64770000"
                    },
                    {
                        "id": 131660,
                        "name": "Dasnapur",
                        "latitude": "19.65399000",
                        "longitude": "78.51213000"
                    },
                    {
                        "id": 131703,
                        "name": "Devarkonda",
                        "latitude": "16.69186000",
                        "longitude": "78.92073000"
                    },
                    {
                        "id": 131789,
                        "name": "Dornakal",
                        "latitude": "17.44475000",
                        "longitude": "80.14905000"
                    },
                    {
                        "id": 131857,
                        "name": "Farrukhnagar",
                        "latitude": "17.07787000",
                        "longitude": "78.20339000"
                    },
                    {
                        "id": 131887,
                        "name": "Gaddi Annaram",
                        "latitude": "17.36687000",
                        "longitude": "78.52420000"
                    },
                    {
                        "id": 131890,
                        "name": "Gadwal",
                        "latitude": "16.23504000",
                        "longitude": "77.79556000"
                    },
                    {
                        "id": 131939,
                        "name": "Ghatkesar",
                        "latitude": "17.45081000",
                        "longitude": "78.68366000"
                    },
                    {
                        "id": 131989,
                        "name": "Gopalur",
                        "latitude": "16.61220000",
                        "longitude": "77.80728000"
                    },
                    {
                        "id": 132052,
                        "name": "Gudur",
                        "latitude": "17.49174000",
                        "longitude": "78.82302000"
                    },
                    {
                        "id": 132132,
                        "name": "Hyderabad",
                        "latitude": "17.38405000",
                        "longitude": "78.45636000"
                    },
                    {
                        "id": 132193,
                        "name": "Jagtial",
                        "latitude": "18.79473000",
                        "longitude": "78.91661000"
                    },
                    {
                        "id": 132238,
                        "name": "Jangaon",
                        "latitude": "17.72602000",
                        "longitude": "79.15236000"
                    },
                    {
                        "id": 132257,
                        "name": "Jayashankar Bhupalapally",
                        "latitude": "18.19678000",
                        "longitude": "79.93976000"
                    },
                    {
                        "id": 132290,
                        "name": "Jogulamba Gadwal",
                        "latitude": "16.23401000",
                        "longitude": "77.80564000"
                    },
                    {
                        "id": 132331,
                        "name": "Kagaznagar",
                        "latitude": "19.33159000",
                        "longitude": "79.46605000"
                    },
                    {
                        "id": 132696,
                        "name": "Kamareddi",
                        "latitude": "18.32001000",
                        "longitude": "78.34177000"
                    },
                    {
                        "id": 132363,
                        "name": "Kamareddy",
                        "latitude": "18.32567000",
                        "longitude": "78.33416000"
                    },
                    {
                        "id": 132415,
                        "name": "Karimnagar",
                        "latitude": "18.33844000",
                        "longitude": "79.22938000"
                    },
                    {
                        "id": 132464,
                        "name": "Khammam",
                        "latitude": "17.50000000",
                        "longitude": "80.33333000"
                    },
                    {
                        "id": 132546,
                        "name": "Kodar",
                        "latitude": "16.99850000",
                        "longitude": "79.96560000"
                    },
                    {
                        "id": 132580,
                        "name": "Koratla",
                        "latitude": "18.82154000",
                        "longitude": "78.71186000"
                    },
                    {
                        "id": 132599,
                        "name": "Kothapet",
                        "latitude": "19.35176000",
                        "longitude": "79.48323000"
                    },
                    {
                        "id": 132606,
                        "name": "Kottagudem",
                        "latitude": "17.55106000",
                        "longitude": "80.61779000"
                    },
                    {
                        "id": 132608,
                        "name": "Kottapalli",
                        "latitude": "18.49543000",
                        "longitude": "79.09430000"
                    },
                    {
                        "id": 132737,
                        "name": "Kukatpally",
                        "latitude": "17.48486000",
                        "longitude": "78.41376000"
                    },
                    {
                        "id": 132674,
                        "name": "Kyathampalle",
                        "latitude": "19.66781000",
                        "longitude": "78.52890000"
                    },
                    {
                        "id": 132751,
                        "name": "Lakshettipet",
                        "latitude": "18.86667000",
                        "longitude": "79.21667000"
                    },
                    {
                        "id": 132753,
                        "name": "Lal Bahadur Nagar",
                        "latitude": "17.34769000",
                        "longitude": "78.55757000"
                    },
                    {
                        "id": 132824,
                        "name": "Mahabubabad",
                        "latitude": "17.60040000",
                        "longitude": "80.00543000"
                    },
                    {
                        "id": 132828,
                        "name": "Mahbubnagar",
                        "latitude": "16.63171000",
                        "longitude": "77.75556000"
                    },
                    {
                        "id": 132870,
                        "name": "Malkajgiri",
                        "latitude": "17.44781000",
                        "longitude": "78.52633000"
                    },
                    {
                        "id": 132887,
                        "name": "Mancheral",
                        "latitude": "18.87074000",
                        "longitude": "79.42863000"
                    },
                    {
                        "id": 132888,
                        "name": "Mandamarri",
                        "latitude": "18.96506000",
                        "longitude": "79.47475000"
                    },
                    {
                        "id": 132927,
                        "name": "Manthani",
                        "latitude": "18.65087000",
                        "longitude": "79.66501000"
                    },
                    {
                        "id": 132928,
                        "name": "Manuguru",
                        "latitude": "17.98102000",
                        "longitude": "80.75470000"
                    },
                    {
                        "id": 132955,
                        "name": "Medak",
                        "latitude": "17.75000000",
                        "longitude": "78.25000000"
                    },
                    {
                        "id": 132956,
                        "name": "Medchal",
                        "latitude": "17.62972000",
                        "longitude": "78.48139000"
                    },
                    {
                        "id": 132957,
                        "name": "Medchal Malkajgiri",
                        "latitude": "17.60644000",
                        "longitude": "78.54007000"
                    },
                    {
                        "id": 132975,
                        "name": "Mirialguda",
                        "latitude": "16.87220000",
                        "longitude": "79.56247000"
                    },
                    {
                        "id": 133255,
                        "name": "Nagar Karnul",
                        "latitude": "16.48210000",
                        "longitude": "78.32471000"
                    },
                    {
                        "id": 133132,
                        "name": "Nalgonda",
                        "latitude": "17.16667000",
                        "longitude": "79.50000000"
                    },
                    {
                        "id": 133277,
                        "name": "Narayanpet",
                        "latitude": "16.74799000",
                        "longitude": "77.49540000"
                    },
                    {
                        "id": 133274,
                        "name": "Narsingi",
                        "latitude": "18.04468000",
                        "longitude": "78.42516000"
                    },
                    {
                        "id": 133278,
                        "name": "Naspur",
                        "latitude": "18.84577000",
                        "longitude": "79.46165000"
                    },
                    {
                        "id": 133221,
                        "name": "Nirmal",
                        "latitude": "19.09685000",
                        "longitude": "78.34407000"
                    },
                    {
                        "id": 133226,
                        "name": "Nizamabad",
                        "latitude": "18.75000000",
                        "longitude": "78.25000000"
                    },
                    {
                        "id": 133535,
                        "name": "Paloncha",
                        "latitude": "17.60184000",
                        "longitude": "80.70509000"
                    },
                    {
                        "id": 133338,
                        "name": "Palwancha",
                        "latitude": "17.58152000",
                        "longitude": "80.67651000"
                    },
                    {
                        "id": 133377,
                        "name": "Patancheru",
                        "latitude": "17.53334000",
                        "longitude": "78.26450000"
                    },
                    {
                        "id": 133401,
                        "name": "Peddapalli",
                        "latitude": "18.61357000",
                        "longitude": "79.37442000"
                    },
                    {
                        "id": 133574,
                        "name": "Quthbullapur",
                        "latitude": "17.50107000",
                        "longitude": "78.45818000"
                    },
                    {
                        "id": 133592,
                        "name": "Rajanna Sircilla",
                        "latitude": "18.38629000",
                        "longitude": "78.81560000"
                    },
                    {
                        "id": 133597,
                        "name": "Ramagundam",
                        "latitude": "18.75500000",
                        "longitude": "79.47400000"
                    },
                    {
                        "id": 133699,
                        "name": "Ramgundam",
                        "latitude": "18.80084000",
                        "longitude": "79.45206000"
                    },
                    {
                        "id": 133607,
                        "name": "Rangareddi",
                        "latitude": "17.27883000",
                        "longitude": "78.16844000"
                    },
                    {
                        "id": 133745,
                        "name": "Sadaseopet",
                        "latitude": "17.61925000",
                        "longitude": "77.95263000"
                    },
                    {
                        "id": 133787,
                        "name": "Sangareddi",
                        "latitude": "17.62477000",
                        "longitude": "78.08669000"
                    },
                    {
                        "id": 133818,
                        "name": "Sathupalli",
                        "latitude": "17.24968000",
                        "longitude": "80.86899000"
                    },
                    {
                        "id": 133834,
                        "name": "Secunderabad",
                        "latitude": "17.50427000",
                        "longitude": "78.54263000"
                    },
                    {
                        "id": 133849,
                        "name": "Serilingampalle",
                        "latitude": "17.49313000",
                        "longitude": "78.30196000"
                    },
                    {
                        "id": 133919,
                        "name": "Siddipet",
                        "latitude": "18.10483000",
                        "longitude": "78.84858000"
                    },
                    {
                        "id": 133951,
                        "name": "Singapur",
                        "latitude": "17.46982000",
                        "longitude": "78.12574000"
                    },
                    {
                        "id": 133960,
                        "name": "Sirpur",
                        "latitude": "19.47953000",
                        "longitude": "79.57558000"
                    },
                    {
                        "id": 133964,
                        "name": "Sirsilla",
                        "latitude": "18.38865000",
                        "longitude": "78.81048000"
                    },
                    {
                        "id": 134031,
                        "name": "Sriramnagar",
                        "latitude": "17.26652000",
                        "longitude": "78.25544000"
                    },
                    {
                        "id": 134054,
                        "name": "Suriapet",
                        "latitude": "17.14054000",
                        "longitude": "79.62045000"
                    },
                    {
                        "id": 134237,
                        "name": "Tandur",
                        "latitude": "17.24849000",
                        "longitude": "77.57698000"
                    },
                    {
                        "id": 134287,
                        "name": "Uppal Kalan",
                        "latitude": "17.40577000",
                        "longitude": "78.55911000"
                    },
                    {
                        "id": 134344,
                        "name": "Vemalwada",
                        "latitude": "18.46523000",
                        "longitude": "78.86894000"
                    },
                    {
                        "id": 134359,
                        "name": "Vikarabad",
                        "latitude": "17.33810000",
                        "longitude": "77.90441000"
                    },
                    {
                        "id": 134394,
                        "name": "Wanparti",
                        "latitude": "16.36738000",
                        "longitude": "78.06889000"
                    },
                    {
                        "id": 134395,
                        "name": "Warangal",
                        "latitude": "18.00000000",
                        "longitude": "79.83333000"
                    },
                    {
                        "id": 134432,
                        "name": "Yellandu",
                        "latitude": "17.59064000",
                        "longitude": "80.32146000"
                    },
                    {
                        "id": 134440,
                        "name": "Zahirabad",
                        "latitude": "17.68138000",
                        "longitude": "77.60743000"
                    }
                ]
            },
            {
                "id": 4038,
                "name": "Tripura",
                "iso2": "TR",
                "latitude": "23.94084820",
                "longitude": "91.98815270",
                "type": "state",
                "cities": [
                    {
                        "id": 57600,
                        "name": "Agartala",
                        "latitude": "23.83605000",
                        "longitude": "91.27939000"
                    },
                    {
                        "id": 57662,
                        "name": "Amarpur",
                        "latitude": "23.52570000",
                        "longitude": "91.65879000"
                    },
                    {
                        "id": 134458,
                        "name": "Ambasa",
                        "latitude": "23.93600000",
                        "longitude": "91.85436000"
                    },
                    {
                        "id": 57876,
                        "name": "Barjala",
                        "latitude": "23.61820000",
                        "longitude": "91.35596000"
                    },
                    {
                        "id": 57926,
                        "name": "Belonia",
                        "latitude": "23.25178000",
                        "longitude": "91.45407000"
                    },
                    {
                        "id": 131710,
                        "name": "Dhalai",
                        "latitude": "23.84307000",
                        "longitude": "91.92591000"
                    },
                    {
                        "id": 131725,
                        "name": "Dharmanagar",
                        "latitude": "24.36667000",
                        "longitude": "92.16667000"
                    },
                    {
                        "id": 131979,
                        "name": "Gomati",
                        "latitude": "23.53399000",
                        "longitude": "91.48122000"
                    },
                    {
                        "id": 132334,
                        "name": "Kailashahar",
                        "latitude": "24.33199000",
                        "longitude": "92.00391000"
                    },
                    {
                        "id": 132362,
                        "name": "Kamalpur",
                        "latitude": "24.19593000",
                        "longitude": "91.83438000"
                    },
                    {
                        "id": 132502,
                        "name": "Khowai",
                        "latitude": "24.07964000",
                        "longitude": "91.59972000"
                    },
                    {
                        "id": 133241,
                        "name": "North Tripura",
                        "latitude": "24.13050000",
                        "longitude": "92.15552000"
                    },
                    {
                        "id": 133721,
                        "name": "Ranir Bazar",
                        "latitude": "23.83463000",
                        "longitude": "91.36614000"
                    },
                    {
                        "id": 133740,
                        "name": "Sabrum",
                        "latitude": "23.00153000",
                        "longitude": "91.72427000"
                    },
                    {
                        "id": 133997,
                        "name": "Sonamura",
                        "latitude": "23.47547000",
                        "longitude": "91.26590000"
                    },
                    {
                        "id": 134011,
                        "name": "South Tripura",
                        "latitude": "23.16710000",
                        "longitude": "91.60953000"
                    },
                    {
                        "id": 134249,
                        "name": "Udaipur",
                        "latitude": "23.53333000",
                        "longitude": "91.48333000"
                    },
                    {
                        "id": 134281,
                        "name": "Unakoti",
                        "latitude": "24.32781000",
                        "longitude": "92.00377000"
                    },
                    {
                        "id": 134412,
                        "name": "West Tripura",
                        "latitude": "23.91667000",
                        "longitude": "91.50000000"
                    }
                ]
            },
            {
                "id": 4022,
                "name": "Uttar Pradesh",
                "iso2": "UP",
                "latitude": "26.84670880",
                "longitude": "80.94615920",
                "type": "state",
                "cities": [
                    {
                        "id": 57590,
                        "name": "Achhnera",
                        "latitude": "27.17826000",
                        "longitude": "77.75674000"
                    },
                    {
                        "id": 57597,
                        "name": "Afzalgarh",
                        "latitude": "29.39370000",
                        "longitude": "78.67393000"
                    },
                    {
                        "id": 57601,
                        "name": "Agra",
                        "latitude": "27.18333000",
                        "longitude": "78.01667000"
                    },
                    {
                        "id": 57607,
                        "name": "Ahraura",
                        "latitude": "25.01579000",
                        "longitude": "83.03294000"
                    },
                    {
                        "id": 147426,
                        "name": "Aidalpur",
                        "latitude": "26.13333333",
                        "longitude": "79.45000000"
                    },
                    {
                        "id": 147427,
                        "name": "Airwa",
                        "latitude": "26.90000000",
                        "longitude": "79.43333333"
                    },
                    {
                        "id": 57621,
                        "name": "Akbarpur",
                        "latitude": "26.42953000",
                        "longitude": "82.53431000"
                    },
                    {
                        "id": 147428,
                        "name": "Akola",
                        "latitude": "27.06547000",
                        "longitude": "77.88084000"
                    },
                    {
                        "id": 57653,
                        "name": "Aliganj",
                        "latitude": "27.49358000",
                        "longitude": "79.17127000"
                    },
                    {
                        "id": 57654,
                        "name": "Aligarh",
                        "latitude": "27.83333000",
                        "longitude": "78.16667000"
                    },
                    {
                        "id": 147429,
                        "name": "Allahabad",
                        "latitude": "25.45000000",
                        "longitude": "81.85000000"
                    },
                    {
                        "id": 57641,
                        "name": "Allahganj",
                        "latitude": "27.54540000",
                        "longitude": "79.68715000"
                    },
                    {
                        "id": 57692,
                        "name": "Amanpur",
                        "latitude": "27.71222000",
                        "longitude": "78.73788000"
                    },
                    {
                        "id": 147430,
                        "name": "Amauli",
                        "latitude": "26.01666667",
                        "longitude": "80.30000000"
                    },
                    {
                        "id": 57666,
                        "name": "Ambahta",
                        "latitude": "29.85706000",
                        "longitude": "77.33583000"
                    },
                    {
                        "id": 57669,
                        "name": "Ambedkar Nagar",
                        "latitude": "26.40544000",
                        "longitude": "82.69762000"
                    },
                    {
                        "id": 57677,
                        "name": "Amethi",
                        "latitude": "28.01667000",
                        "longitude": "81.05000000"
                    },
                    {
                        "id": 57687,
                        "name": "Amroha",
                        "latitude": "28.90314000",
                        "longitude": "78.46984000"
                    },
                    {
                        "id": 57696,
                        "name": "Anandnagar",
                        "latitude": "27.10062000",
                        "longitude": "83.27156000"
                    },
                    {
                        "id": 57720,
                        "name": "Antu",
                        "latitude": "26.05654000",
                        "longitude": "81.90267000"
                    },
                    {
                        "id": 57724,
                        "name": "Anupshahr",
                        "latitude": "28.35748000",
                        "longitude": "78.26914000"
                    },
                    {
                        "id": 57725,
                        "name": "Aonla",
                        "latitude": "28.27402000",
                        "longitude": "79.16521000"
                    },
                    {
                        "id": 147431,
                        "name": "Araul",
                        "latitude": "26.91700000",
                        "longitude": "80.03300000"
                    },
                    {
                        "id": 147432,
                        "name": "Asalatganj",
                        "latitude": "26.68333333",
                        "longitude": "79.85000000"
                    },
                    {
                        "id": 57755,
                        "name": "Atarra",
                        "latitude": "25.28618000",
                        "longitude": "80.57155000"
                    },
                    {
                        "id": 57760,
                        "name": "Atrauli",
                        "latitude": "28.02964000",
                        "longitude": "78.28571000"
                    },
                    {
                        "id": 57759,
                        "name": "Atraulia",
                        "latitude": "26.33330000",
                        "longitude": "82.94727000"
                    },
                    {
                        "id": 57764,
                        "name": "Auraiya",
                        "latitude": "26.64692000",
                        "longitude": "79.42858000"
                    },
                    {
                        "id": 57769,
                        "name": "Auras",
                        "latitude": "26.91414000",
                        "longitude": "80.50792000"
                    },
                    {
                        "id": 57616,
                        "name": "Ayodhya",
                        "latitude": "26.79909000",
                        "longitude": "82.20470000"
                    },
                    {
                        "id": 57777,
                        "name": "Azamgarh",
                        "latitude": "26.06832000",
                        "longitude": "83.18358000"
                    },
                    {
                        "id": 147433,
                        "name": "Azizpur",
                        "latitude": "26.97638889",
                        "longitude": "79.22138889"
                    },
                    {
                        "id": 57779,
                        "name": "Baberu",
                        "latitude": "25.54711000",
                        "longitude": "80.70443000"
                    },
                    {
                        "id": 57782,
                        "name": "Babina",
                        "latitude": "25.23947000",
                        "longitude": "78.47028000"
                    },
                    {
                        "id": 57780,
                        "name": "Babrala",
                        "latitude": "28.26419000",
                        "longitude": "78.40560000"
                    },
                    {
                        "id": 57781,
                        "name": "Babugarh",
                        "latitude": "28.72353000",
                        "longitude": "77.84677000"
                    },
                    {
                        "id": 57783,
                        "name": "Bachhraon",
                        "latitude": "28.92694000",
                        "longitude": "78.23456000"
                    },
                    {
                        "id": 57784,
                        "name": "Bachhrawan",
                        "latitude": "26.47090000",
                        "longitude": "81.11580000"
                    },
                    {
                        "id": 57801,
                        "name": "Baghpat",
                        "latitude": "28.95000000",
                        "longitude": "77.21670000"
                    },
                    {
                        "id": 147434,
                        "name": "Baghra",
                        "latitude": "29.46666667",
                        "longitude": "77.58333333"
                    },
                    {
                        "id": 58112,
                        "name": "Bah",
                        "latitude": "26.86912000",
                        "longitude": "78.59385000"
                    },
                    {
                        "id": 57803,
                        "name": "Baheri",
                        "latitude": "28.77416000",
                        "longitude": "79.49740000"
                    },
                    {
                        "id": 57804,
                        "name": "Bahjoi",
                        "latitude": "28.39502000",
                        "longitude": "78.62659000"
                    },
                    {
                        "id": 57805,
                        "name": "Bahraich",
                        "latitude": "27.80021000",
                        "longitude": "81.51855000"
                    },
                    {
                        "id": 57806,
                        "name": "Bahraigh",
                        "latitude": "27.57429000",
                        "longitude": "81.59474000"
                    },
                    {
                        "id": 57807,
                        "name": "Bahsuma",
                        "latitude": "29.20063000",
                        "longitude": "77.97221000"
                    },
                    {
                        "id": 57808,
                        "name": "Bahua",
                        "latitude": "25.83942000",
                        "longitude": "80.62255000"
                    },
                    {
                        "id": 58113,
                        "name": "Bajna",
                        "latitude": "27.89793000",
                        "longitude": "77.67836000"
                    },
                    {
                        "id": 57817,
                        "name": "Bakewar",
                        "latitude": "26.66226000",
                        "longitude": "79.17625000"
                    },
                    {
                        "id": 147435,
                        "name": "Baksar",
                        "latitude": "28.76666667",
                        "longitude": "78.01666667"
                    },
                    {
                        "id": 147436,
                        "name": "Balamau",
                        "latitude": "27.16666667",
                        "longitude": "80.35000000"
                    },
                    {
                        "id": 147437,
                        "name": "Baldeo",
                        "latitude": "27.41666667",
                        "longitude": "77.81666667"
                    },
                    {
                        "id": 57825,
                        "name": "Baldev",
                        "latitude": "27.40684000",
                        "longitude": "77.82214000"
                    },
                    {
                        "id": 57828,
                        "name": "Ballia",
                        "latitude": "25.83333000",
                        "longitude": "84.16667000"
                    },
                    {
                        "id": 57833,
                        "name": "Balrampur",
                        "latitude": "27.43449000",
                        "longitude": "82.40281000"
                    },
                    {
                        "id": 57840,
                        "name": "Banat",
                        "latitude": "29.46355000",
                        "longitude": "77.35478000"
                    },
                    {
                        "id": 57841,
                        "name": "Banbasa",
                        "latitude": "28.99132000",
                        "longitude": "80.07608000"
                    },
                    {
                        "id": 58124,
                        "name": "Banda",
                        "latitude": "25.50000000",
                        "longitude": "80.50000000"
                    },
                    {
                        "id": 58126,
                        "name": "Bangarmau",
                        "latitude": "26.89120000",
                        "longitude": "80.21149000"
                    },
                    {
                        "id": 58130,
                        "name": "Bansdih",
                        "latitude": "25.88377000",
                        "longitude": "84.21827000"
                    },
                    {
                        "id": 58131,
                        "name": "Bansgaon",
                        "latitude": "26.55032000",
                        "longitude": "83.34503000"
                    },
                    {
                        "id": 58132,
                        "name": "Bansi",
                        "latitude": "27.17749000",
                        "longitude": "82.93442000"
                    },
                    {
                        "id": 147438,
                        "name": "Banthra",
                        "latitude": "27.91720000",
                        "longitude": "79.81740000"
                    },
                    {
                        "id": 58138,
                        "name": "Bara Banki",
                        "latitude": "26.93864000",
                        "longitude": "81.32740000"
                    },
                    {
                        "id": 57892,
                        "name": "Baragaon",
                        "latitude": "25.47554000",
                        "longitude": "78.71224000"
                    },
                    {
                        "id": 57865,
                        "name": "Baraut",
                        "latitude": "29.10199000",
                        "longitude": "77.26334000"
                    },
                    {
                        "id": 57867,
                        "name": "Bareilly",
                        "latitude": "28.41667000",
                        "longitude": "79.38333000"
                    },
                    {
                        "id": 147439,
                        "name": "Barhalganj",
                        "latitude": "26.28333333",
                        "longitude": "83.50000000"
                    },
                    {
                        "id": 147440,
                        "name": "Barkhera",
                        "latitude": "28.45000000",
                        "longitude": "79.80000000"
                    },
                    {
                        "id": 57877,
                        "name": "Barkhera Kalan",
                        "latitude": "28.45209000",
                        "longitude": "79.80655000"
                    },
                    {
                        "id": 147441,
                        "name": "Barokhar",
                        "latitude": "24.91666667",
                        "longitude": "81.96666667"
                    },
                    {
                        "id": 57887,
                        "name": "Barsana",
                        "latitude": "27.64802000",
                        "longitude": "77.37640000"
                    },
                    {
                        "id": 147442,
                        "name": "Barwar (Lakhimpur Kheri)",
                        "latitude": "25.50583333",
                        "longitude": "79.13972222"
                    },
                    {
                        "id": 57901,
                        "name": "Basti",
                        "latitude": "26.82816000",
                        "longitude": "82.77924000"
                    },
                    {
                        "id": 57918,
                        "name": "Behat",
                        "latitude": "30.17180000",
                        "longitude": "77.61390000"
                    },
                    {
                        "id": 57920,
                        "name": "Bela",
                        "latitude": "25.92058000",
                        "longitude": "81.99629000"
                    },
                    {
                        "id": 147443,
                        "name": "Belthara",
                        "latitude": "26.12694444",
                        "longitude": "83.89138889"
                    },
                    {
                        "id": 57934,
                        "name": "Beniganj",
                        "latitude": "27.29293000",
                        "longitude": "80.44364000"
                    },
                    {
                        "id": 57938,
                        "name": "Beswan",
                        "latitude": "27.63792000",
                        "longitude": "77.88019000"
                    },
                    {
                        "id": 57944,
                        "name": "Bewar",
                        "latitude": "27.21869000",
                        "longitude": "79.29761000"
                    },
                    {
                        "id": 147444,
                        "name": "Bhadarsa",
                        "latitude": "26.66027778",
                        "longitude": "82.12416667"
                    },
                    {
                        "id": 57951,
                        "name": "Bhadohi",
                        "latitude": "25.39526000",
                        "longitude": "82.57030000"
                    },
                    {
                        "id": 57958,
                        "name": "Bhagwantnagar",
                        "latitude": "26.22383000",
                        "longitude": "80.75750000"
                    },
                    {
                        "id": 147445,
                        "name": "Bharatpura",
                        "latitude": "25.23333333",
                        "longitude": "78.96666667"
                    },
                    {
                        "id": 147446,
                        "name": "Bhargain",
                        "latitude": "27.61500000",
                        "longitude": "79.14416667"
                    },
                    {
                        "id": 57965,
                        "name": "Bharthana",
                        "latitude": "26.75231000",
                        "longitude": "79.22180000"
                    },
                    {
                        "id": 57966,
                        "name": "Bharwari",
                        "latitude": "25.56078000",
                        "longitude": "81.49164000"
                    },
                    {
                        "id": 147447,
                        "name": "Bhaupur",
                        "latitude": "26.91666667",
                        "longitude": "79.21666667"
                    },
                    {
                        "id": 147448,
                        "name": "Bhimtal",
                        "latitude": "29.34444444",
                        "longitude": "79.56305556"
                    },
                    {
                        "id": 57984,
                        "name": "Bhinga",
                        "latitude": "27.70283000",
                        "longitude": "81.93430000"
                    },
                    {
                        "id": 147449,
                        "name": "Bhognipur",
                        "latitude": "26.24000000",
                        "longitude": "79.80000000"
                    },
                    {
                        "id": 57993,
                        "name": "Bhongaon",
                        "latitude": "27.25515000",
                        "longitude": "79.18118000"
                    },
                    {
                        "id": 147450,
                        "name": "Bidhnu",
                        "latitude": "26.33333333",
                        "longitude": "80.28333333"
                    },
                    {
                        "id": 58027,
                        "name": "Bidhuna",
                        "latitude": "26.80172000",
                        "longitude": "79.50829000"
                    },
                    {
                        "id": 147451,
                        "name": "Bighapur",
                        "latitude": "26.35000000",
                        "longitude": "80.68000000"
                    },
                    {
                        "id": 58155,
                        "name": "Bighapur Khurd",
                        "latitude": "26.34734000",
                        "longitude": "80.65698000"
                    },
                    {
                        "id": 58035,
                        "name": "Bijnor",
                        "latitude": "29.41667000",
                        "longitude": "78.51667000"
                    },
                    {
                        "id": 58158,
                        "name": "Bikapur",
                        "latitude": "26.59534000",
                        "longitude": "82.13272000"
                    },
                    {
                        "id": 58052,
                        "name": "Bilari",
                        "latitude": "28.62146000",
                        "longitude": "78.80361000"
                    },
                    {
                        "id": 58040,
                        "name": "Bilariaganj",
                        "latitude": "26.19593000",
                        "longitude": "83.22690000"
                    },
                    {
                        "id": 58159,
                        "name": "Bilaspur",
                        "latitude": "28.88655000",
                        "longitude": "79.27030000"
                    },
                    {
                        "id": 58043,
                        "name": "Bilgram",
                        "latitude": "27.17509000",
                        "longitude": "80.03201000"
                    },
                    {
                        "id": 58044,
                        "name": "Bilhaur",
                        "latitude": "26.84345000",
                        "longitude": "80.06388000"
                    },
                    {
                        "id": 58048,
                        "name": "Bilsanda",
                        "latitude": "28.24341000",
                        "longitude": "79.95135000"
                    },
                    {
                        "id": 58049,
                        "name": "Bilsi",
                        "latitude": "28.12941000",
                        "longitude": "78.91090000"
                    },
                    {
                        "id": 58050,
                        "name": "Bilthra",
                        "latitude": "26.12705000",
                        "longitude": "83.89148000"
                    },
                    {
                        "id": 147452,
                        "name": "Binauli",
                        "latitude": "29.09416667",
                        "longitude": "77.40083333"
                    },
                    {
                        "id": 147453,
                        "name": "Binaur",
                        "latitude": "26.38333333",
                        "longitude": "80.16666667"
                    },
                    {
                        "id": 58057,
                        "name": "Bindki",
                        "latitude": "26.03613000",
                        "longitude": "80.57617000"
                    },
                    {
                        "id": 147454,
                        "name": "Birdpur",
                        "latitude": "27.38330000",
                        "longitude": "83.11670000"
                    },
                    {
                        "id": 147455,
                        "name": "Birpur",
                        "latitude": "26.53000000",
                        "longitude": "86.25000000"
                    },
                    {
                        "id": 58161,
                        "name": "Bisalpur",
                        "latitude": "28.29253000",
                        "longitude": "79.80472000"
                    },
                    {
                        "id": 147456,
                        "name": "Bisanda Buzurg",
                        "latitude": "25.41666667",
                        "longitude": "80.61666667"
                    },
                    {
                        "id": 58062,
                        "name": "Bisauli",
                        "latitude": "28.30772000",
                        "longitude": "78.93678000"
                    },
                    {
                        "id": 58063,
                        "name": "Bisenda Buzurg",
                        "latitude": "25.40350000",
                        "longitude": "80.61889000"
                    },
                    {
                        "id": 58066,
                        "name": "Bishunpur Urf Maharajganj",
                        "latitude": "26.25914000",
                        "longitude": "83.11643000"
                    },
                    {
                        "id": 58068,
                        "name": "Biswan",
                        "latitude": "27.49581000",
                        "longitude": "80.99618000"
                    },
                    {
                        "id": 58069,
                        "name": "Bithur",
                        "latitude": "26.60664000",
                        "longitude": "80.27098000"
                    },
                    {
                        "id": 58088,
                        "name": "Budaun",
                        "latitude": "28.11667000",
                        "longitude": "78.98333000"
                    },
                    {
                        "id": 58091,
                        "name": "Budhana",
                        "latitude": "29.28805000",
                        "longitude": "77.47534000"
                    },
                    {
                        "id": 58093,
                        "name": "Bulandshahr",
                        "latitude": "28.41667000",
                        "longitude": "77.83333000"
                    },
                    {
                        "id": 58168,
                        "name": "Captainganj",
                        "latitude": "26.92640000",
                        "longitude": "83.71334000"
                    },
                    {
                        "id": 58172,
                        "name": "Chail",
                        "latitude": "25.42654000",
                        "longitude": "81.63198000"
                    },
                    {
                        "id": 58173,
                        "name": "Chakia",
                        "latitude": "25.04891000",
                        "longitude": "83.22155000"
                    },
                    {
                        "id": 58186,
                        "name": "Chandauli",
                        "latitude": "25.25803000",
                        "longitude": "83.26825000"
                    },
                    {
                        "id": 58187,
                        "name": "Chandauli District",
                        "latitude": "25.26134000",
                        "longitude": "83.26408000"
                    },
                    {
                        "id": 147457,
                        "name": "Chandausi",
                        "latitude": "28.45000000",
                        "longitude": "78.77000000"
                    },
                    {
                        "id": 131600,
                        "name": "Chandpur",
                        "latitude": "29.13489000",
                        "longitude": "78.27187000"
                    },
                    {
                        "id": 58193,
                        "name": "Chanduasi",
                        "latitude": "28.45178000",
                        "longitude": "78.78277000"
                    },
                    {
                        "id": 58201,
                        "name": "Charkhari",
                        "latitude": "25.40304000",
                        "longitude": "79.74877000"
                    },
                    {
                        "id": 131509,
                        "name": "Charthawal",
                        "latitude": "29.54687000",
                        "longitude": "77.59438000"
                    },
                    {
                        "id": 131530,
                        "name": "Chhaprauli",
                        "latitude": "29.20989000",
                        "longitude": "77.17454000"
                    },
                    {
                        "id": 131531,
                        "name": "Chharra",
                        "latitude": "27.92470000",
                        "longitude": "78.40102000"
                    },
                    {
                        "id": 131540,
                        "name": "Chhata",
                        "latitude": "27.72374000",
                        "longitude": "77.50810000"
                    },
                    {
                        "id": 131533,
                        "name": "Chhibramau",
                        "latitude": "27.14872000",
                        "longitude": "79.50078000"
                    },
                    {
                        "id": 147458,
                        "name": "Chhitauni",
                        "latitude": "27.11666667",
                        "longitude": "83.98333333"
                    },
                    {
                        "id": 131537,
                        "name": "Chhutmalpur",
                        "latitude": "30.03209000",
                        "longitude": "77.75329000"
                    },
                    {
                        "id": 131557,
                        "name": "Chillupar",
                        "latitude": "26.28221000",
                        "longitude": "83.50640000"
                    },
                    {
                        "id": 131569,
                        "name": "Chirgaon",
                        "latitude": "25.57198000",
                        "longitude": "78.81432000"
                    },
                    {
                        "id": 131572,
                        "name": "Chitrakoot",
                        "latitude": "25.20511000",
                        "longitude": "81.08962000"
                    },
                    {
                        "id": 147459,
                        "name": "Chitrakoot Dham",
                        "latitude": "25.20000000",
                        "longitude": "80.90000000"
                    },
                    {
                        "id": 131579,
                        "name": "Chopan",
                        "latitude": "24.51954000",
                        "longitude": "83.02287000"
                    },
                    {
                        "id": 131584,
                        "name": "Chunar",
                        "latitude": "25.12776000",
                        "longitude": "82.88210000"
                    },
                    {
                        "id": 147460,
                        "name": "Churk",
                        "latitude": "24.65000000",
                        "longitude": "83.10000000"
                    },
                    {
                        "id": 131621,
                        "name": "Colonelganj",
                        "latitude": "27.13432000",
                        "longitude": "81.69868000"
                    },
                    {
                        "id": 131806,
                        "name": "Dadri",
                        "latitude": "28.55257000",
                        "longitude": "77.55403000"
                    },
                    {
                        "id": 131646,
                        "name": "Dalmau",
                        "latitude": "26.06477000",
                        "longitude": "81.02980000"
                    },
                    {
                        "id": 131653,
                        "name": "Dankaur",
                        "latitude": "28.35121000",
                        "longitude": "77.55508000"
                    },
                    {
                        "id": 147461,
                        "name": "Daraganj",
                        "latitude": "25.43333333",
                        "longitude": "81.88333333"
                    },
                    {
                        "id": 147462,
                        "name": "Daranagar",
                        "latitude": "25.68162080",
                        "longitude": "81.34975790"
                    },
                    {
                        "id": 131811,
                        "name": "Dasna",
                        "latitude": "28.67736000",
                        "longitude": "77.52252000"
                    },
                    {
                        "id": 131812,
                        "name": "Dataganj",
                        "latitude": "28.02530000",
                        "longitude": "79.40819000"
                    },
                    {
                        "id": 131668,
                        "name": "Daurala",
                        "latitude": "29.11344000",
                        "longitude": "77.70467000"
                    },
                    {
                        "id": 131674,
                        "name": "Dayal Bagh",
                        "latitude": "27.22122000",
                        "longitude": "78.01095000"
                    },
                    {
                        "id": 131682,
                        "name": "Deoband",
                        "latitude": "29.69505000",
                        "longitude": "77.67964000"
                    },
                    {
                        "id": 147463,
                        "name": "Deogarh",
                        "latitude": "24.52600000",
                        "longitude": "78.23800000"
                    },
                    {
                        "id": 131689,
                        "name": "Deoranian",
                        "latitude": "28.62989000",
                        "longitude": "79.47648000"
                    },
                    {
                        "id": 131692,
                        "name": "Deoria",
                        "latitude": "26.66667000",
                        "longitude": "83.75000000"
                    },
                    {
                        "id": 147464,
                        "name": "Derapur",
                        "latitude": "26.41666667",
                        "longitude": "79.80000000"
                    },
                    {
                        "id": 131708,
                        "name": "Dewa",
                        "latitude": "27.03621000",
                        "longitude": "81.16692000"
                    },
                    {
                        "id": 131750,
                        "name": "Dhampur",
                        "latitude": "29.30883000",
                        "longitude": "78.51083000"
                    },
                    {
                        "id": 131714,
                        "name": "Dhanaura",
                        "latitude": "28.95912000",
                        "longitude": "78.25629000"
                    },
                    {
                        "id": 147465,
                        "name": "Dhanghata",
                        "latitude": "26.55419444",
                        "longitude": "83.00806111"
                    },
                    {
                        "id": 147466,
                        "name": "Dharau",
                        "latitude": "26.38333333",
                        "longitude": "79.96666667"
                    },
                    {
                        "id": 131731,
                        "name": "Dhaurahra",
                        "latitude": "27.99814000",
                        "longitude": "81.08975000"
                    },
                    {
                        "id": 131761,
                        "name": "Dibai",
                        "latitude": "28.20849000",
                        "longitude": "78.26173000"
                    },
                    {
                        "id": 147467,
                        "name": "Divrasai",
                        "latitude": "26.81900000",
                        "longitude": "79.14900000"
                    },
                    {
                        "id": 131783,
                        "name": "Dohrighat",
                        "latitude": "26.27217000",
                        "longitude": "83.50916000"
                    },
                    {
                        "id": 147468,
                        "name": "Domariaganj",
                        "latitude": "27.22000000",
                        "longitude": "82.67000000"
                    },
                    {
                        "id": 131791,
                        "name": "Dostpur",
                        "latitude": "26.27486000",
                        "longitude": "82.47091000"
                    },
                    {
                        "id": 131818,
                        "name": "Dudhi",
                        "latitude": "24.21357000",
                        "longitude": "83.24067000"
                    },
                    {
                        "id": 131845,
                        "name": "Etah",
                        "latitude": "27.50000000",
                        "longitude": "78.75000000"
                    },
                    {
                        "id": 131849,
                        "name": "Etawah",
                        "latitude": "26.75000000",
                        "longitude": "79.25000000"
                    },
                    {
                        "id": 147469,
                        "name": "Etmadpur",
                        "latitude": "27.23971944",
                        "longitude": "78.20000000"
                    },
                    {
                        "id": 131851,
                        "name": "Faizabad",
                        "latitude": "26.75000000",
                        "longitude": "82.00000000"
                    },
                    {
                        "id": 131852,
                        "name": "Farah",
                        "latitude": "27.32081000",
                        "longitude": "77.76185000"
                    },
                    {
                        "id": 131860,
                        "name": "Faridnagar",
                        "latitude": "28.76923000",
                        "longitude": "77.62934000"
                    },
                    {
                        "id": 131861,
                        "name": "Faridpur",
                        "latitude": "28.20997000",
                        "longitude": "79.54149000"
                    },
                    {
                        "id": 131858,
                        "name": "Farrukhabad",
                        "latitude": "27.50000000",
                        "longitude": "79.50000000"
                    },
                    {
                        "id": 131871,
                        "name": "Fatehabad",
                        "latitude": "27.02645000",
                        "longitude": "78.30270000"
                    },
                    {
                        "id": 131863,
                        "name": "Fatehganj West",
                        "latitude": "28.46620000",
                        "longitude": "79.30657000"
                    },
                    {
                        "id": 131864,
                        "name": "Fatehgarh",
                        "latitude": "27.36409000",
                        "longitude": "79.63111000"
                    },
                    {
                        "id": 131868,
                        "name": "Fatehpur",
                        "latitude": "25.75000000",
                        "longitude": "80.75000000"
                    },
                    {
                        "id": 147470,
                        "name": "Fatehpur (Barabanki)",
                        "latitude": "27.17000000",
                        "longitude": "81.22000000"
                    },
                    {
                        "id": 131869,
                        "name": "Fatehpur Chaurasi",
                        "latitude": "26.78925000",
                        "longitude": "80.26547000"
                    },
                    {
                        "id": 131870,
                        "name": "Fatehpur Sikri",
                        "latitude": "27.09370000",
                        "longitude": "77.66003000"
                    },
                    {
                        "id": 131876,
                        "name": "Firozabad",
                        "latitude": "27.20072000",
                        "longitude": "78.42867000"
                    },
                    {
                        "id": 131880,
                        "name": "Fyzabad",
                        "latitude": "26.77549000",
                        "longitude": "82.15018000"
                    },
                    {
                        "id": 147471,
                        "name": "Gahlon",
                        "latitude": "26.53333333",
                        "longitude": "79.96666667"
                    },
                    {
                        "id": 147472,
                        "name": "Gahmar",
                        "latitude": "25.49700000",
                        "longitude": "83.82200000"
                    },
                    {
                        "id": 147473,
                        "name": "Gaini",
                        "latitude": "28.21000000",
                        "longitude": "79.16000000"
                    },
                    {
                        "id": 131894,
                        "name": "Gajraula",
                        "latitude": "28.84570000",
                        "longitude": "78.23960000"
                    },
                    {
                        "id": 131903,
                        "name": "Gangoh",
                        "latitude": "29.78004000",
                        "longitude": "77.26346000"
                    },
                    {
                        "id": 147474,
                        "name": "Ganj Dundawara",
                        "latitude": "27.73277778",
                        "longitude": "78.94166667"
                    },
                    {
                        "id": 131912,
                        "name": "Ganj Dundwara",
                        "latitude": "27.73308000",
                        "longitude": "78.94119000"
                    },
                    {
                        "id": 131913,
                        "name": "Ganj Muradabad",
                        "latitude": "26.95733000",
                        "longitude": "80.18400000"
                    },
                    {
                        "id": 131916,
                        "name": "Garautha",
                        "latitude": "25.57190000",
                        "longitude": "79.29764000"
                    },
                    {
                        "id": 131919,
                        "name": "Garhi Pukhta",
                        "latitude": "29.54980000",
                        "longitude": "77.30881000"
                    },
                    {
                        "id": 131920,
                        "name": "Garhmuktesar",
                        "latitude": "28.78732000",
                        "longitude": "78.10214000"
                    },
                    {
                        "id": 147475,
                        "name": "Garhwa",
                        "latitude": "24.18000000",
                        "longitude": "83.82000000"
                    },
                    {
                        "id": 147476,
                        "name": "Gauriganj",
                        "latitude": "26.20600000",
                        "longitude": "81.69000000"
                    },
                    {
                        "id": 131929,
                        "name": "Gautam Buddha Nagar",
                        "latitude": "28.35898000",
                        "longitude": "77.55076000"
                    },
                    {
                        "id": 131931,
                        "name": "Gawan",
                        "latitude": "28.41969000",
                        "longitude": "78.35186000"
                    },
                    {
                        "id": 131950,
                        "name": "Ghatampur",
                        "latitude": "26.15272000",
                        "longitude": "80.16803000"
                    },
                    {
                        "id": 131953,
                        "name": "Ghaziabad",
                        "latitude": "28.66535000",
                        "longitude": "77.43915000"
                    },
                    {
                        "id": 131940,
                        "name": "Ghazipur",
                        "latitude": "25.58333000",
                        "longitude": "83.58526000"
                    },
                    {
                        "id": 131941,
                        "name": "Ghiror",
                        "latitude": "27.18912000",
                        "longitude": "78.79312000"
                    },
                    {
                        "id": 131945,
                        "name": "Ghorawal",
                        "latitude": "24.75459000",
                        "longitude": "82.77965000"
                    },
                    {
                        "id": 131946,
                        "name": "Ghosi",
                        "latitude": "26.10587000",
                        "longitude": "83.53930000"
                    },
                    {
                        "id": 131969,
                        "name": "Gohand",
                        "latitude": "25.69871000",
                        "longitude": "79.54567000"
                    },
                    {
                        "id": 131973,
                        "name": "Gokul",
                        "latitude": "27.43926000",
                        "longitude": "77.72019000"
                    },
                    {
                        "id": 131974,
                        "name": "Gola Bazar",
                        "latitude": "26.34460000",
                        "longitude": "83.35303000"
                    },
                    {
                        "id": 131975,
                        "name": "Gola Gokarannath",
                        "latitude": "28.07837000",
                        "longitude": "80.47054000"
                    },
                    {
                        "id": 131981,
                        "name": "Gonda",
                        "latitude": "27.18581000",
                        "longitude": "81.96693000"
                    },
                    {
                        "id": 131990,
                        "name": "Gopamau",
                        "latitude": "27.53468000",
                        "longitude": "80.28507000"
                    },
                    {
                        "id": 131992,
                        "name": "Gorakhpur",
                        "latitude": "26.91667000",
                        "longitude": "83.25000000"
                    },
                    {
                        "id": 147478,
                        "name": "Gosainganj",
                        "latitude": "26.77000000",
                        "longitude": "81.12000000"
                    },
                    {
                        "id": 131998,
                        "name": "Goshainganj",
                        "latitude": "26.57115000",
                        "longitude": "82.38091000"
                    },
                    {
                        "id": 132000,
                        "name": "Govardhan",
                        "latitude": "27.49658000",
                        "longitude": "77.46263000"
                    },
                    {
                        "id": 132005,
                        "name": "Greater Noida",
                        "latitude": "28.49615000",
                        "longitude": "77.53601000"
                    },
                    {
                        "id": 132019,
                        "name": "Gulaothi",
                        "latitude": "28.58938000",
                        "longitude": "77.79318000"
                    },
                    {
                        "id": 132026,
                        "name": "Gunnaur",
                        "latitude": "28.23995000",
                        "longitude": "78.43994000"
                    },
                    {
                        "id": 132035,
                        "name": "Gursahaiganj",
                        "latitude": "27.11518000",
                        "longitude": "79.73174000"
                    },
                    {
                        "id": 132036,
                        "name": "Gursarai",
                        "latitude": "25.61677000",
                        "longitude": "79.18053000"
                    },
                    {
                        "id": 132042,
                        "name": "Gyanpur",
                        "latitude": "25.33268000",
                        "longitude": "82.46637000"
                    },
                    {
                        "id": 132057,
                        "name": "Haldaur",
                        "latitude": "29.28988000",
                        "longitude": "78.28437000"
                    },
                    {
                        "id": 132062,
                        "name": "Hamirpur",
                        "latitude": "25.75000000",
                        "longitude": "80.00000000"
                    },
                    {
                        "id": 132064,
                        "name": "Handia",
                        "latitude": "25.36379000",
                        "longitude": "82.18655000"
                    },
                    {
                        "id": 132142,
                        "name": "Hapur",
                        "latitude": "28.72985000",
                        "longitude": "77.78068000"
                    },
                    {
                        "id": 147479,
                        "name": "Haraipur",
                        "latitude": "26.90000000",
                        "longitude": "79.70000000"
                    },
                    {
                        "id": 132068,
                        "name": "Haraiya",
                        "latitude": "26.79477000",
                        "longitude": "82.46436000"
                    },
                    {
                        "id": 147480,
                        "name": "Harchandpur",
                        "latitude": "26.36000000",
                        "longitude": "81.17000000"
                    },
                    {
                        "id": 132072,
                        "name": "Hardoi",
                        "latitude": "27.41667000",
                        "longitude": "80.25000000"
                    },
                    {
                        "id": 132074,
                        "name": "Harduaganj",
                        "latitude": "27.94361000",
                        "longitude": "78.15789000"
                    },
                    {
                        "id": 132085,
                        "name": "Hasanpur",
                        "latitude": "28.72249000",
                        "longitude": "78.28436000"
                    },
                    {
                        "id": 132087,
                        "name": "Hastinapur",
                        "latitude": "29.16042000",
                        "longitude": "78.00762000"
                    },
                    {
                        "id": 132146,
                        "name": "Hata",
                        "latitude": "26.74120000",
                        "longitude": "83.74526000"
                    },
                    {
                        "id": 147481,
                        "name": "Hata (India)",
                        "latitude": "26.75000000",
                        "longitude": "83.74000000"
                    },
                    {
                        "id": 132144,
                        "name": "Hathras",
                        "latitude": "27.59551000",
                        "longitude": "78.05201000"
                    },
                    {
                        "id": 147482,
                        "name": "Hulas",
                        "latitude": "29.69027778",
                        "longitude": "77.36027778"
                    },
                    {
                        "id": 147483,
                        "name": "Ibrahimpur",
                        "latitude": "26.01027778",
                        "longitude": "83.16861111"
                    },
                    {
                        "id": 132156,
                        "name": "Iglas",
                        "latitude": "27.71100000",
                        "longitude": "77.93967000"
                    },
                    {
                        "id": 132157,
                        "name": "Ikauna",
                        "latitude": "27.53097000",
                        "longitude": "81.96917000"
                    },
                    {
                        "id": 132164,
                        "name": "Indergarh",
                        "latitude": "26.93521000",
                        "longitude": "79.67120000"
                    },
                    {
                        "id": 147484,
                        "name": "Indragarh",
                        "latitude": "29.91299444",
                        "longitude": "74.32284167"
                    },
                    {
                        "id": 132173,
                        "name": "Islamnagar",
                        "latitude": "28.32896000",
                        "longitude": "78.72524000"
                    },
                    {
                        "id": 147485,
                        "name": "Islamnagar (Badaun)",
                        "latitude": "28.33000000",
                        "longitude": "78.72000000"
                    },
                    {
                        "id": 132176,
                        "name": "Itaunja",
                        "latitude": "27.08347000",
                        "longitude": "80.89672000"
                    },
                    {
                        "id": 132177,
                        "name": "Itimadpur",
                        "latitude": "27.23541000",
                        "longitude": "78.19829000"
                    },
                    {
                        "id": 132187,
                        "name": "Jagdishpur",
                        "latitude": "26.74967000",
                        "longitude": "80.54510000"
                    },
                    {
                        "id": 132191,
                        "name": "Jagnair",
                        "latitude": "26.86360000",
                        "longitude": "77.60231000"
                    },
                    {
                        "id": 132197,
                        "name": "Jahanabad",
                        "latitude": "28.63025000",
                        "longitude": "79.71818000"
                    },
                    {
                        "id": 147486,
                        "name": "Jahanabad (Pilibhit)",
                        "latitude": "28.63330000",
                        "longitude": "79.80000000"
                    },
                    {
                        "id": 132196,
                        "name": "Jahangirabad",
                        "latitude": "28.40549000",
                        "longitude": "78.10588000"
                    },
                    {
                        "id": 132195,
                        "name": "Jahangirpur",
                        "latitude": "28.17919000",
                        "longitude": "77.70501000"
                    },
                    {
                        "id": 132200,
                        "name": "Jainpur",
                        "latitude": "26.15389000",
                        "longitude": "83.33505000"
                    },
                    {
                        "id": 132202,
                        "name": "Jais",
                        "latitude": "26.26490000",
                        "longitude": "81.54855000"
                    },
                    {
                        "id": 132221,
                        "name": "Jalalabad",
                        "latitude": "29.61853000",
                        "longitude": "77.43908000"
                    },
                    {
                        "id": 132224,
                        "name": "Jalali",
                        "latitude": "27.86680000",
                        "longitude": "78.25267000"
                    },
                    {
                        "id": 132220,
                        "name": "Jalalpur",
                        "latitude": "26.31162000",
                        "longitude": "82.73859000"
                    },
                    {
                        "id": 132306,
                        "name": "Jalaun",
                        "latitude": "26.00000000",
                        "longitude": "79.50000000"
                    },
                    {
                        "id": 132212,
                        "name": "Jalesar",
                        "latitude": "27.47315000",
                        "longitude": "78.30310000"
                    },
                    {
                        "id": 147487,
                        "name": "Janghai",
                        "latitude": "25.55000000",
                        "longitude": "82.31666667"
                    },
                    {
                        "id": 132313,
                        "name": "Jansath",
                        "latitude": "29.32502000",
                        "longitude": "77.85044000"
                    },
                    {
                        "id": 147488,
                        "name": "Jarwa",
                        "latitude": "27.65000000",
                        "longitude": "82.51666667"
                    },
                    {
                        "id": 132242,
                        "name": "Jarwal",
                        "latitude": "27.16290000",
                        "longitude": "81.54179000"
                    },
                    {
                        "id": 132248,
                        "name": "Jasrana",
                        "latitude": "27.23587000",
                        "longitude": "78.65244000"
                    },
                    {
                        "id": 132249,
                        "name": "Jaswantnagar",
                        "latitude": "26.88271000",
                        "longitude": "78.90256000"
                    },
                    {
                        "id": 132252,
                        "name": "Jaunpur",
                        "latitude": "25.75000000",
                        "longitude": "82.75000000"
                    },
                    {
                        "id": 132264,
                        "name": "Jewar",
                        "latitude": "28.12200000",
                        "longitude": "77.55734000"
                    },
                    {
                        "id": 147489,
                        "name": "Jhajhar",
                        "latitude": "27.86000000",
                        "longitude": "75.28000000"
                    },
                    {
                        "id": 132277,
                        "name": "Jhalu",
                        "latitude": "29.33609000",
                        "longitude": "78.22608000"
                    },
                    {
                        "id": 132279,
                        "name": "Jhansi",
                        "latitude": "25.50000000",
                        "longitude": "78.50000000"
                    },
                    {
                        "id": 132280,
                        "name": "Jhinjhak",
                        "latitude": "26.56093000",
                        "longitude": "79.73423000"
                    },
                    {
                        "id": 132271,
                        "name": "Jhinjhana",
                        "latitude": "29.52118000",
                        "longitude": "77.22470000"
                    },
                    {
                        "id": 132281,
                        "name": "Jhusi",
                        "latitude": "25.43745000",
                        "longitude": "81.90550000"
                    },
                    {
                        "id": 147490,
                        "name": "Jiyanpur",
                        "latitude": "26.15000000",
                        "longitude": "83.33000000"
                    },
                    {
                        "id": 132303,
                        "name": "Jyotiba Phule Nagar",
                        "latitude": "28.77160000",
                        "longitude": "78.33871000"
                    },
                    {
                        "id": 132320,
                        "name": "Kabrai",
                        "latitude": "25.40281000",
                        "longitude": "79.99970000"
                    },
                    {
                        "id": 132322,
                        "name": "Kachhwa",
                        "latitude": "25.20615000",
                        "longitude": "82.71442000"
                    },
                    {
                        "id": 132325,
                        "name": "Kadaura",
                        "latitude": "25.98537000",
                        "longitude": "79.83842000"
                    },
                    {
                        "id": 132676,
                        "name": "Kadipur",
                        "latitude": "26.16779000",
                        "longitude": "82.37028000"
                    },
                    {
                        "id": 147491,
                        "name": "Kagarol",
                        "latitude": "27.01666667",
                        "longitude": "77.85000000"
                    },
                    {
                        "id": 132335,
                        "name": "Kaimganj",
                        "latitude": "27.55441000",
                        "longitude": "79.33525000"
                    },
                    {
                        "id": 132339,
                        "name": "Kairana",
                        "latitude": "29.39541000",
                        "longitude": "77.20540000"
                    },
                    {
                        "id": 132679,
                        "name": "Kakori",
                        "latitude": "26.86800000",
                        "longitude": "80.78570000"
                    },
                    {
                        "id": 132342,
                        "name": "Kakrala",
                        "latitude": "27.89269000",
                        "longitude": "79.19450000"
                    },
                    {
                        "id": 132690,
                        "name": "Kalinagar",
                        "latitude": "28.62019000",
                        "longitude": "80.08152000"
                    },
                    {
                        "id": 132683,
                        "name": "Kalpi",
                        "latitude": "26.11667000",
                        "longitude": "79.73333000"
                    },
                    {
                        "id": 147492,
                        "name": "Kalyanpur",
                        "latitude": "26.51912222",
                        "longitude": "80.24980556"
                    },
                    {
                        "id": 132361,
                        "name": "Kamalganj",
                        "latitude": "27.26181000",
                        "longitude": "79.63134000"
                    },
                    {
                        "id": 132364,
                        "name": "Kampil",
                        "latitude": "27.61268000",
                        "longitude": "79.27687000"
                    },
                    {
                        "id": 132697,
                        "name": "Kandhla",
                        "latitude": "29.32104000",
                        "longitude": "77.27101000"
                    },
                    {
                        "id": 132378,
                        "name": "Kannauj",
                        "latitude": "27.01770000",
                        "longitude": "79.67846000"
                    },
                    {
                        "id": 132384,
                        "name": "Kanpur",
                        "latitude": "26.46523000",
                        "longitude": "80.34975000"
                    },
                    {
                        "id": 132385,
                        "name": "Kanpur Dehat",
                        "latitude": "26.41506000",
                        "longitude": "79.98957000"
                    },
                    {
                        "id": 132711,
                        "name": "Kant",
                        "latitude": "27.81049000",
                        "longitude": "79.79185000"
                    },
                    {
                        "id": 132712,
                        "name": "Kanth",
                        "latitude": "29.05939000",
                        "longitude": "78.62951000"
                    },
                    {
                        "id": 147493,
                        "name": "Kaptanganj",
                        "latitude": "26.93000000",
                        "longitude": "83.72000000"
                    },
                    {
                        "id": 147494,
                        "name": "Kara",
                        "latitude": "25.70000000",
                        "longitude": "81.35000000"
                    },
                    {
                        "id": 132413,
                        "name": "Karari",
                        "latitude": "25.45241000",
                        "longitude": "81.42675000"
                    },
                    {
                        "id": 147495,
                        "name": "Karbigwan",
                        "latitude": "26.20000000",
                        "longitude": "80.50000000"
                    },
                    {
                        "id": 147496,
                        "name": "Karchana",
                        "latitude": "25.28000000",
                        "longitude": "81.93000000"
                    },
                    {
                        "id": 132400,
                        "name": "Karhal",
                        "latitude": "27.00089000",
                        "longitude": "78.93935000"
                    },
                    {
                        "id": 132722,
                        "name": "Kasganj",
                        "latitude": "27.80882000",
                        "longitude": "78.64579000"
                    },
                    {
                        "id": 132426,
                        "name": "Katra",
                        "latitude": "27.50871000",
                        "longitude": "82.02636000"
                    },
                    {
                        "id": 147497,
                        "name": "Kausani",
                        "latitude": "29.84305556",
                        "longitude": "79.60333333"
                    },
                    {
                        "id": 132430,
                        "name": "Kaushambi District",
                        "latitude": "25.53074000",
                        "longitude": "81.37729000"
                    },
                    {
                        "id": 132440,
                        "name": "Kemri",
                        "latitude": "28.80673000",
                        "longitude": "79.20480000"
                    },
                    {
                        "id": 132449,
                        "name": "Khada",
                        "latitude": "27.18333000",
                        "longitude": "83.88333000"
                    },
                    {
                        "id": 132512,
                        "name": "Khaga",
                        "latitude": "25.77215000",
                        "longitude": "81.10393000"
                    },
                    {
                        "id": 147498,
                        "name": "Khailar",
                        "latitude": "25.35000000",
                        "longitude": "78.53000000"
                    },
                    {
                        "id": 132454,
                        "name": "Khair",
                        "latitude": "27.94195000",
                        "longitude": "77.84243000"
                    },
                    {
                        "id": 132455,
                        "name": "Khairabad",
                        "latitude": "27.52698000",
                        "longitude": "80.75461000"
                    },
                    {
                        "id": 132459,
                        "name": "Khalilabad",
                        "latitude": "26.77268000",
                        "longitude": "83.07179000"
                    },
                    {
                        "id": 132514,
                        "name": "Khanpur",
                        "latitude": "28.53446000",
                        "longitude": "78.06546000"
                    },
                    {
                        "id": 132473,
                        "name": "Kharela",
                        "latitude": "25.54277000",
                        "longitude": "79.81235000"
                    },
                    {
                        "id": 132475,
                        "name": "Khargupur",
                        "latitude": "27.37611000",
                        "longitude": "81.98820000"
                    },
                    {
                        "id": 132479,
                        "name": "Kharkhauda",
                        "latitude": "28.83644000",
                        "longitude": "77.74159000"
                    },
                    {
                        "id": 132483,
                        "name": "Khatauli",
                        "latitude": "29.27844000",
                        "longitude": "77.73302000"
                    },
                    {
                        "id": 132490,
                        "name": "Khekra",
                        "latitude": "28.86586000",
                        "longitude": "77.28410000"
                    },
                    {
                        "id": 132492,
                        "name": "Kheri",
                        "latitude": "28.11667000",
                        "longitude": "80.71667000"
                    },
                    {
                        "id": 132503,
                        "name": "Khudaganj",
                        "latitude": "28.14607000",
                        "longitude": "79.71472000"
                    },
                    {
                        "id": 132509,
                        "name": "Khurja",
                        "latitude": "28.25382000",
                        "longitude": "77.85535000"
                    },
                    {
                        "id": 132520,
                        "name": "Khutar",
                        "latitude": "28.20307000",
                        "longitude": "80.27046000"
                    },
                    {
                        "id": 132528,
                        "name": "Kirakat",
                        "latitude": "25.63745000",
                        "longitude": "82.91596000"
                    },
                    {
                        "id": 132526,
                        "name": "Kiraoli",
                        "latitude": "27.13768000",
                        "longitude": "77.78516000"
                    },
                    {
                        "id": 132734,
                        "name": "Kiratpur",
                        "latitude": "29.50671000",
                        "longitude": "78.20613000"
                    },
                    {
                        "id": 132531,
                        "name": "Kishanpur",
                        "latitude": "25.64232000",
                        "longitude": "81.02270000"
                    },
                    {
                        "id": 147499,
                        "name": "Kishanpur baral",
                        "latitude": "29.20000000",
                        "longitude": "77.28333333"
                    },
                    {
                        "id": 132532,
                        "name": "Kishni",
                        "latitude": "27.02487000",
                        "longitude": "79.26200000"
                    },
                    {
                        "id": 132535,
                        "name": "Kithor",
                        "latitude": "28.86684000",
                        "longitude": "77.93861000"
                    },
                    {
                        "id": 132564,
                        "name": "Konch",
                        "latitude": "25.99451000",
                        "longitude": "79.15127000"
                    },
                    {
                        "id": 132575,
                        "name": "Kopaganj",
                        "latitude": "26.01923000",
                        "longitude": "83.56630000"
                    },
                    {
                        "id": 132589,
                        "name": "Kosi",
                        "latitude": "27.79449000",
                        "longitude": "77.43680000"
                    },
                    {
                        "id": 132592,
                        "name": "Kota",
                        "latitude": "24.44643000",
                        "longitude": "83.13063000"
                    },
                    {
                        "id": 132605,
                        "name": "Kotra",
                        "latitude": "25.80770000",
                        "longitude": "79.30909000"
                    },
                    {
                        "id": 147500,
                        "name": "Kuchesar",
                        "latitude": "28.68333333",
                        "longitude": "77.95000000"
                    },
                    {
                        "id": 147501,
                        "name": "Kudarkot",
                        "latitude": "26.81666667",
                        "longitude": "79.40000000"
                    },
                    {
                        "id": 132635,
                        "name": "Kulpahar",
                        "latitude": "25.32007000",
                        "longitude": "79.63931000"
                    },
                    {
                        "id": 132644,
                        "name": "Kunda",
                        "latitude": "25.71702000",
                        "longitude": "81.51396000"
                    },
                    {
                        "id": 132645,
                        "name": "Kundarkhi",
                        "latitude": "28.68304000",
                        "longitude": "78.78559000"
                    },
                    {
                        "id": 147502,
                        "name": "Kundarki",
                        "latitude": "28.68300000",
                        "longitude": "78.78500000"
                    },
                    {
                        "id": 132664,
                        "name": "Kurara",
                        "latitude": "25.98046000",
                        "longitude": "79.98984000"
                    },
                    {
                        "id": 147503,
                        "name": "Kurebharsaidkhanpur",
                        "latitude": "26.43333333",
                        "longitude": "82.11666667"
                    },
                    {
                        "id": 132665,
                        "name": "Kushinagar",
                        "latitude": "26.74028000",
                        "longitude": "83.88889000"
                    },
                    {
                        "id": 147504,
                        "name": "Kusmara",
                        "latitude": "27.11666667",
                        "longitude": "79.28333333"
                    },
                    {
                        "id": 147505,
                        "name": "Kuthaund",
                        "latitude": "26.36666667",
                        "longitude": "79.41666667"
                    },
                    {
                        "id": 132790,
                        "name": "Laharpur",
                        "latitude": "27.70827000",
                        "longitude": "80.90256000"
                    },
                    {
                        "id": 132748,
                        "name": "Lakhimpur",
                        "latitude": "27.94822000",
                        "longitude": "80.77935000"
                    },
                    {
                        "id": 132745,
                        "name": "Lakhna",
                        "latitude": "26.64822000",
                        "longitude": "79.14770000"
                    },
                    {
                        "id": 132796,
                        "name": "Lalganj",
                        "latitude": "25.93182000",
                        "longitude": "81.70478000"
                    },
                    {
                        "id": 132755,
                        "name": "Lalitpur",
                        "latitude": "24.50000000",
                        "longitude": "78.50000000"
                    },
                    {
                        "id": 147506,
                        "name": "Lambhua",
                        "latitude": "26.15000000",
                        "longitude": "82.21000000"
                    },
                    {
                        "id": 132757,
                        "name": "Lar",
                        "latitude": "26.20394000",
                        "longitude": "83.96906000"
                    },
                    {
                        "id": 147507,
                        "name": "Lawar",
                        "latitude": "29.11666667",
                        "longitude": "77.76666667"
                    },
                    {
                        "id": 132803,
                        "name": "Lawar Khas",
                        "latitude": "29.11091000",
                        "longitude": "77.77767000"
                    },
                    {
                        "id": 132775,
                        "name": "Loni",
                        "latitude": "28.75143000",
                        "longitude": "77.29023000"
                    },
                    {
                        "id": 132782,
                        "name": "Lucknow",
                        "latitude": "26.83928000",
                        "longitude": "80.92313000"
                    },
                    {
                        "id": 132783,
                        "name": "Lucknow District",
                        "latitude": "26.75000000",
                        "longitude": "81.00000000"
                    },
                    {
                        "id": 147508,
                        "name": "Machhali Shahar",
                        "latitude": "25.68000000",
                        "longitude": "82.42000000"
                    },
                    {
                        "id": 132805,
                        "name": "Machhlishahr",
                        "latitude": "25.68564000",
                        "longitude": "82.41106000"
                    },
                    {
                        "id": 133057,
                        "name": "Madhoganj",
                        "latitude": "27.11807000",
                        "longitude": "80.14058000"
                    },
                    {
                        "id": 133058,
                        "name": "Madhogarh",
                        "latitude": "26.27522000",
                        "longitude": "79.18590000"
                    },
                    {
                        "id": 132823,
                        "name": "Maghar",
                        "latitude": "26.75586000",
                        "longitude": "83.12773000"
                    },
                    {
                        "id": 132845,
                        "name": "Mahaban",
                        "latitude": "27.43262000",
                        "longitude": "77.74338000"
                    },
                    {
                        "id": 132826,
                        "name": "Maharajganj",
                        "latitude": "27.16945000",
                        "longitude": "83.50667000"
                    },
                    {
                        "id": 132836,
                        "name": "Mahmudabad",
                        "latitude": "27.29191000",
                        "longitude": "81.11775000"
                    },
                    {
                        "id": 132837,
                        "name": "Mahoba",
                        "latitude": "25.29210000",
                        "longitude": "79.87242000"
                    },
                    {
                        "id": 132839,
                        "name": "Maholi",
                        "latitude": "27.66368000",
                        "longitude": "80.47371000"
                    },
                    {
                        "id": 147509,
                        "name": "Mahrajganj",
                        "latitude": "26.26666667",
                        "longitude": "83.11666667"
                    },
                    {
                        "id": 147510,
                        "name": "Mahrajganj (Raebareli)",
                        "latitude": "26.38333333",
                        "longitude": "81.28333333"
                    },
                    {
                        "id": 132840,
                        "name": "Mahroni",
                        "latitude": "24.58624000",
                        "longitude": "78.72771000"
                    },
                    {
                        "id": 147511,
                        "name": "Mahul",
                        "latitude": "26.13333333",
                        "longitude": "82.81666667"
                    },
                    {
                        "id": 132855,
                        "name": "Mailani",
                        "latitude": "28.29088000",
                        "longitude": "80.34380000"
                    },
                    {
                        "id": 132857,
                        "name": "Mainpuri",
                        "latitude": "27.16667000",
                        "longitude": "79.00000000"
                    },
                    {
                        "id": 147512,
                        "name": "Majhupur",
                        "latitude": "27.03333333",
                        "longitude": "79.41666667"
                    },
                    {
                        "id": 147513,
                        "name": "Makanpur",
                        "latitude": "26.90222222",
                        "longitude": "79.97805556"
                    },
                    {
                        "id": 147514,
                        "name": "Malasa",
                        "latitude": "26.26755000",
                        "longitude": "79.94489000"
                    },
                    {
                        "id": 132878,
                        "name": "Malihabad",
                        "latitude": "26.92223000",
                        "longitude": "80.71078000"
                    },
                    {
                        "id": 132899,
                        "name": "Mandawar",
                        "latitude": "29.48655000",
                        "longitude": "78.12732000"
                    },
                    {
                        "id": 132910,
                        "name": "Maniar",
                        "latitude": "25.98546000",
                        "longitude": "84.17233000"
                    },
                    {
                        "id": 133079,
                        "name": "Manikpur",
                        "latitude": "25.06083000",
                        "longitude": "81.09961000"
                    },
                    {
                        "id": 132914,
                        "name": "Manjhanpur",
                        "latitude": "25.53046000",
                        "longitude": "81.37566000"
                    },
                    {
                        "id": 132917,
                        "name": "Mankapur",
                        "latitude": "27.05189000",
                        "longitude": "82.22961000"
                    },
                    {
                        "id": 133087,
                        "name": "Marahra",
                        "latitude": "27.73680000",
                        "longitude": "78.56891000"
                    },
                    {
                        "id": 132936,
                        "name": "Mariahu",
                        "latitude": "25.60404000",
                        "longitude": "82.60379000"
                    },
                    {
                        "id": 132940,
                        "name": "Mataundh",
                        "latitude": "25.43594000",
                        "longitude": "80.15653000"
                    },
                    {
                        "id": 132941,
                        "name": "Mathura",
                        "latitude": "27.63333000",
                        "longitude": "77.58333000"
                    },
                    {
                        "id": 132944,
                        "name": "Mau",
                        "latitude": "26.02940000",
                        "longitude": "83.50756000"
                    },
                    {
                        "id": 147515,
                        "name": "Mau Aima",
                        "latitude": "25.70000000",
                        "longitude": "81.91666667"
                    },
                    {
                        "id": 132945,
                        "name": "Mau Aimma",
                        "latitude": "25.69515000",
                        "longitude": "81.92336000"
                    },
                    {
                        "id": 132946,
                        "name": "Maudaha",
                        "latitude": "25.68312000",
                        "longitude": "80.11419000"
                    },
                    {
                        "id": 147516,
                        "name": "Maurawan",
                        "latitude": "26.43000000",
                        "longitude": "80.88000000"
                    },
                    {
                        "id": 132951,
                        "name": "Mawana",
                        "latitude": "29.10288000",
                        "longitude": "77.92199000"
                    },
                    {
                        "id": 147517,
                        "name": "Mawar",
                        "latitude": "26.30416667",
                        "longitude": "79.92111111"
                    },
                    {
                        "id": 132958,
                        "name": "Meerut",
                        "latitude": "28.91667000",
                        "longitude": "77.68333000"
                    },
                    {
                        "id": 147518,
                        "name": "Mehdawal",
                        "latitude": "26.98333333",
                        "longitude": "83.11666667"
                    },
                    {
                        "id": 132962,
                        "name": "Mehnagar",
                        "latitude": "25.87889000",
                        "longitude": "83.11611000"
                    },
                    {
                        "id": 132963,
                        "name": "Mehndawal",
                        "latitude": "26.97579000",
                        "longitude": "83.10995000"
                    },
                    {
                        "id": 132974,
                        "name": "Milak",
                        "latitude": "28.61031000",
                        "longitude": "79.16997000"
                    },
                    {
                        "id": 147519,
                        "name": "Milkipur",
                        "latitude": "26.60000000",
                        "longitude": "81.91000000"
                    },
                    {
                        "id": 133096,
                        "name": "Miranpur",
                        "latitude": "29.29026000",
                        "longitude": "77.94939000"
                    },
                    {
                        "id": 133097,
                        "name": "Miranpur Katra",
                        "latitude": "28.02963000",
                        "longitude": "79.66778000"
                    },
                    {
                        "id": 133095,
                        "name": "Mirganj",
                        "latitude": "28.54012000",
                        "longitude": "79.20817000"
                    },
                    {
                        "id": 132976,
                        "name": "Mirzapur",
                        "latitude": "25.14490000",
                        "longitude": "82.56534000"
                    },
                    {
                        "id": 132977,
                        "name": "Misrikh",
                        "latitude": "27.43137000",
                        "longitude": "80.53157000"
                    },
                    {
                        "id": 132986,
                        "name": "Mohan",
                        "latitude": "26.78008000",
                        "longitude": "80.67497000"
                    },
                    {
                        "id": 132981,
                        "name": "Mohanpur",
                        "latitude": "28.25261000",
                        "longitude": "80.24498000"
                    },
                    {
                        "id": 133001,
                        "name": "Moradabad",
                        "latitude": "28.85250000",
                        "longitude": "78.79703000"
                    },
                    {
                        "id": 133004,
                        "name": "Moth",
                        "latitude": "25.72595000",
                        "longitude": "78.95029000"
                    },
                    {
                        "id": 133007,
                        "name": "Mubarakpur",
                        "latitude": "26.08866000",
                        "longitude": "83.29088000"
                    },
                    {
                        "id": 133014,
                        "name": "Mughal Sarai",
                        "latitude": "25.28307000",
                        "longitude": "83.11968000"
                    },
                    {
                        "id": 133016,
                        "name": "Muhammadabad",
                        "latitude": "25.61907000",
                        "longitude": "83.75576000"
                    },
                    {
                        "id": 147520,
                        "name": "Mukteshwar",
                        "latitude": "29.47220000",
                        "longitude": "79.64790000"
                    },
                    {
                        "id": 147521,
                        "name": "Mungra Badshahpur",
                        "latitude": "25.65000000",
                        "longitude": "82.18000000"
                    },
                    {
                        "id": 147522,
                        "name": "Munsyari",
                        "latitude": "30.06741389",
                        "longitude": "80.23856111"
                    },
                    {
                        "id": 147523,
                        "name": "Muradabad",
                        "latitude": "28.83888889",
                        "longitude": "78.77694444"
                    },
                    {
                        "id": 133043,
                        "name": "Muradnagar",
                        "latitude": "28.78069000",
                        "longitude": "77.49865000"
                    },
                    {
                        "id": 133038,
                        "name": "Mursan",
                        "latitude": "27.57788000",
                        "longitude": "77.94091000"
                    },
                    {
                        "id": 133048,
                        "name": "Musafir-Khana",
                        "latitude": "26.37837000",
                        "longitude": "81.79607000"
                    },
                    {
                        "id": 147524,
                        "name": "Musafirkhana",
                        "latitude": "26.45000000",
                        "longitude": "81.80000000"
                    },
                    {
                        "id": 133051,
                        "name": "Muzaffarnagar",
                        "latitude": "29.45000000",
                        "longitude": "77.58333000"
                    },
                    {
                        "id": 133109,
                        "name": "Nadigaon",
                        "latitude": "26.10784000",
                        "longitude": "79.02283000"
                    },
                    {
                        "id": 133120,
                        "name": "Nagina",
                        "latitude": "29.44433000",
                        "longitude": "78.43646000"
                    },
                    {
                        "id": 147525,
                        "name": "Nagla",
                        "latitude": "29.01000000",
                        "longitude": "79.51000000"
                    },
                    {
                        "id": 133119,
                        "name": "Nagram",
                        "latitude": "26.61872000",
                        "longitude": "81.14043000"
                    },
                    {
                        "id": 133127,
                        "name": "Najibabad",
                        "latitude": "29.61194000",
                        "longitude": "78.34274000"
                    },
                    {
                        "id": 133129,
                        "name": "Nakur",
                        "latitude": "29.91964000",
                        "longitude": "77.30438000"
                    },
                    {
                        "id": 133139,
                        "name": "Nanauta",
                        "latitude": "29.71215000",
                        "longitude": "77.41728000"
                    },
                    {
                        "id": 133142,
                        "name": "Nandgaon",
                        "latitude": "27.71102000",
                        "longitude": "77.38653000"
                    },
                    {
                        "id": 133270,
                        "name": "Nanpara",
                        "latitude": "27.86459000",
                        "longitude": "81.50036000"
                    },
                    {
                        "id": 133161,
                        "name": "Narauli",
                        "latitude": "28.48547000",
                        "longitude": "78.71484000"
                    },
                    {
                        "id": 133162,
                        "name": "Naraura",
                        "latitude": "28.20147000",
                        "longitude": "78.38723000"
                    },
                    {
                        "id": 147526,
                        "name": "Narora",
                        "latitude": "28.19666667",
                        "longitude": "78.38138889"
                    },
                    {
                        "id": 147527,
                        "name": "Naugama",
                        "latitude": "27.70000000",
                        "longitude": "79.65000000"
                    },
                    {
                        "id": 147528,
                        "name": "Naurangpur",
                        "latitude": "27.16666667",
                        "longitude": "79.78333333"
                    },
                    {
                        "id": 133183,
                        "name": "Nautanwa",
                        "latitude": "27.42752000",
                        "longitude": "83.41789000"
                    },
                    {
                        "id": 133191,
                        "name": "Nawabganj",
                        "latitude": "26.93129000",
                        "longitude": "81.19841000"
                    },
                    {
                        "id": 147529,
                        "name": "Nawabganj (Barabanki)",
                        "latitude": "26.94000000",
                        "longitude": "81.19000000"
                    },
                    {
                        "id": 147530,
                        "name": "Nawabganj (Bareilly)",
                        "latitude": "28.54000000",
                        "longitude": "79.63300000"
                    },
                    {
                        "id": 147531,
                        "name": "Newara",
                        "latitude": "27.76666667",
                        "longitude": "79.28333333"
                    },
                    {
                        "id": 133212,
                        "name": "Nichlaul",
                        "latitude": "27.31247000",
                        "longitude": "83.72530000"
                    },
                    {
                        "id": 147532,
                        "name": "Nigoh",
                        "latitude": "26.75000000",
                        "longitude": "79.15000000"
                    },
                    {
                        "id": 133215,
                        "name": "Nihtaur",
                        "latitude": "29.32416000",
                        "longitude": "78.38724000"
                    },
                    {
                        "id": 133225,
                        "name": "Niwari",
                        "latitude": "28.87611000",
                        "longitude": "77.53820000"
                    },
                    {
                        "id": 133228,
                        "name": "Nizamabad",
                        "latitude": "26.05295000",
                        "longitude": "83.05787000"
                    },
                    {
                        "id": 133230,
                        "name": "Noida",
                        "latitude": "28.58000000",
                        "longitude": "77.33000000"
                    },
                    {
                        "id": 133292,
                        "name": "Nurpur",
                        "latitude": "29.14956000",
                        "longitude": "78.40840000"
                    },
                    {
                        "id": 133295,
                        "name": "Obra",
                        "latitude": "24.41863000",
                        "longitude": "82.98797000"
                    },
                    {
                        "id": 133302,
                        "name": "Orai",
                        "latitude": "25.99023000",
                        "longitude": "79.45334000"
                    },
                    {
                        "id": 133303,
                        "name": "Oran",
                        "latitude": "25.36882000",
                        "longitude": "80.74230000"
                    },
                    {
                        "id": 133309,
                        "name": "Pachperwa",
                        "latitude": "27.51234000",
                        "longitude": "82.64297000"
                    },
                    {
                        "id": 133316,
                        "name": "Padrauna",
                        "latitude": "26.90403000",
                        "longitude": "83.98087000"
                    },
                    {
                        "id": 133318,
                        "name": "Pahasu",
                        "latitude": "28.17220000",
                        "longitude": "78.06376000"
                    },
                    {
                        "id": 147533,
                        "name": "Paigaon",
                        "latitude": "27.78333333",
                        "longitude": "77.53333333"
                    },
                    {
                        "id": 133531,
                        "name": "Pali",
                        "latitude": "24.49188000",
                        "longitude": "78.41617000"
                    },
                    {
                        "id": 133326,
                        "name": "Palia Kalan",
                        "latitude": "28.43205000",
                        "longitude": "80.58137000"
                    },
                    {
                        "id": 147534,
                        "name": "Paras Rampur",
                        "latitude": "31.32388889",
                        "longitude": "75.67472222"
                    },
                    {
                        "id": 133550,
                        "name": "Parichha",
                        "latitude": "25.50789000",
                        "longitude": "78.75954000"
                    },
                    {
                        "id": 133372,
                        "name": "Parichhatgarh",
                        "latitude": "28.97841000",
                        "longitude": "77.93422000"
                    },
                    {
                        "id": 133365,
                        "name": "Parshadepur",
                        "latitude": "26.07354000",
                        "longitude": "81.49207000"
                    },
                    {
                        "id": 147535,
                        "name": "Pathakpura",
                        "latitude": "26.84441000",
                        "longitude": "78.74037000"
                    },
                    {
                        "id": 133385,
                        "name": "Patiali",
                        "latitude": "27.69086000",
                        "longitude": "78.99823000"
                    },
                    {
                        "id": 133391,
                        "name": "Patti",
                        "latitude": "25.92150000",
                        "longitude": "82.20048000"
                    },
                    {
                        "id": 133398,
                        "name": "Pawayan",
                        "latitude": "28.06626000",
                        "longitude": "80.10305000"
                    },
                    {
                        "id": 147536,
                        "name": "Payagpur",
                        "latitude": "27.40000000",
                        "longitude": "81.80000000"
                    },
                    {
                        "id": 133432,
                        "name": "Phalauda",
                        "latitude": "29.18824000",
                        "longitude": "77.82996000"
                    },
                    {
                        "id": 147537,
                        "name": "Phaphamau",
                        "latitude": "25.53333333",
                        "longitude": "81.86666667"
                    },
                    {
                        "id": 133435,
                        "name": "Phaphund",
                        "latitude": "26.59888000",
                        "longitude": "79.46437000"
                    },
                    {
                        "id": 133436,
                        "name": "Phariha",
                        "latitude": "27.32166000",
                        "longitude": "78.47267000"
                    },
                    {
                        "id": 147538,
                        "name": "Pheona",
                        "latitude": "29.08333333",
                        "longitude": "78.35000000"
                    },
                    {
                        "id": 133443,
                        "name": "Phulpur",
                        "latitude": "25.54895000",
                        "longitude": "82.08950000"
                    },
                    {
                        "id": 147539,
                        "name": "Pichhaura",
                        "latitude": "26.33333333",
                        "longitude": "79.31666667"
                    },
                    {
                        "id": 133445,
                        "name": "Pihani",
                        "latitude": "27.61987000",
                        "longitude": "80.20343000"
                    },
                    {
                        "id": 133561,
                        "name": "Pilibhit",
                        "latitude": "28.63124000",
                        "longitude": "79.80436000"
                    },
                    {
                        "id": 133447,
                        "name": "Pilkhua",
                        "latitude": "28.71271000",
                        "longitude": "77.65600000"
                    },
                    {
                        "id": 147540,
                        "name": "Pilkhuwa",
                        "latitude": "28.71196944",
                        "longitude": "77.65445556"
                    },
                    {
                        "id": 133452,
                        "name": "Pinahat",
                        "latitude": "26.88487000",
                        "longitude": "78.37647000"
                    },
                    {
                        "id": 133456,
                        "name": "Pipraich",
                        "latitude": "26.82745000",
                        "longitude": "83.52632000"
                    },
                    {
                        "id": 147541,
                        "name": "Pipri",
                        "latitude": "24.18000000",
                        "longitude": "83.00000000"
                    },
                    {
                        "id": 133488,
                        "name": "Pratapgarh",
                        "latitude": "25.75000000",
                        "longitude": "81.75000000"
                    },
                    {
                        "id": 57640,
                        "name": "Prayagraj (Allahabad)",
                        "latitude": "25.42012000",
                        "longitude": "81.88385000"
                    },
                    {
                        "id": 133495,
                        "name": "Pukhrayan",
                        "latitude": "26.22375000",
                        "longitude": "79.83739000"
                    },
                    {
                        "id": 133569,
                        "name": "Puranpur",
                        "latitude": "28.51283000",
                        "longitude": "80.14829000"
                    },
                    {
                        "id": 147542,
                        "name": "Purmafi",
                        "latitude": "29.55000000",
                        "longitude": "77.26666667"
                    },
                    {
                        "id": 133514,
                        "name": "Purwa",
                        "latitude": "26.45756000",
                        "longitude": "80.77403000"
                    },
                    {
                        "id": 147543,
                        "name": "Qadirganj",
                        "latitude": "27.78333333",
                        "longitude": "79.06666667"
                    },
                    {
                        "id": 133578,
                        "name": "Rabupura",
                        "latitude": "28.25153000",
                        "longitude": "77.60253000"
                    },
                    {
                        "id": 147544,
                        "name": "Radha Kund",
                        "latitude": "27.52444444",
                        "longitude": "77.49027778"
                    },
                    {
                        "id": 133658,
                        "name": "Radhakund",
                        "latitude": "27.52432000",
                        "longitude": "77.49101000"
                    },
                    {
                        "id": 133580,
                        "name": "Raebareli",
                        "latitude": "26.23090000",
                        "longitude": "81.23315000"
                    },
                    {
                        "id": 133688,
                        "name": "Rajapur",
                        "latitude": "25.38725000",
                        "longitude": "81.15125000"
                    },
                    {
                        "id": 133700,
                        "name": "Ramkola",
                        "latitude": "26.90172000",
                        "longitude": "83.83758000"
                    },
                    {
                        "id": 133704,
                        "name": "Ramnagar",
                        "latitude": "25.26907000",
                        "longitude": "83.02971000"
                    },
                    {
                        "id": 133705,
                        "name": "Rampur",
                        "latitude": "28.81014000",
                        "longitude": "79.02699000"
                    },
                    {
                        "id": 133707,
                        "name": "Rampura",
                        "latitude": "26.34967000",
                        "longitude": "79.18234000"
                    },
                    {
                        "id": 133720,
                        "name": "Ranipur",
                        "latitude": "25.25034000",
                        "longitude": "79.06204000"
                    },
                    {
                        "id": 147545,
                        "name": "Ranipur Barsi",
                        "latitude": "29.90000000",
                        "longitude": "77.21666667"
                    },
                    {
                        "id": 133612,
                        "name": "Rasra",
                        "latitude": "25.85760000",
                        "longitude": "83.85487000"
                    },
                    {
                        "id": 133613,
                        "name": "Rasulabad",
                        "latitude": "26.74491000",
                        "longitude": "80.49012000"
                    },
                    {
                        "id": 133723,
                        "name": "Rath",
                        "latitude": "25.59474000",
                        "longitude": "79.56660000"
                    },
                    {
                        "id": 133728,
                        "name": "Raya",
                        "latitude": "27.55607000",
                        "longitude": "77.78972000"
                    },
                    {
                        "id": 147546,
                        "name": "Rehar",
                        "latitude": "29.36666667",
                        "longitude": "78.76666667"
                    },
                    {
                        "id": 147547,
                        "name": "Renukoot",
                        "latitude": "24.20000000",
                        "longitude": "83.03000000"
                    },
                    {
                        "id": 133628,
                        "name": "Renukut",
                        "latitude": "24.21641000",
                        "longitude": "83.03580000"
                    },
                    {
                        "id": 133629,
                        "name": "Reoti",
                        "latitude": "25.85091000",
                        "longitude": "84.37780000"
                    },
                    {
                        "id": 147548,
                        "name": "Reotipur",
                        "latitude": "25.55000000",
                        "longitude": "83.71666667"
                    },
                    {
                        "id": 133637,
                        "name": "Richha",
                        "latitude": "28.69467000",
                        "longitude": "79.52284000"
                    },
                    {
                        "id": 133641,
                        "name": "Robertsganj",
                        "latitude": "24.68860000",
                        "longitude": "83.06784000"
                    },
                    {
                        "id": 133737,
                        "name": "Rudarpur",
                        "latitude": "26.44467000",
                        "longitude": "83.61302000"
                    },
                    {
                        "id": 147549,
                        "name": "Rudauli",
                        "latitude": "26.75000000",
                        "longitude": "81.75000000"
                    },
                    {
                        "id": 133655,
                        "name": "Rura",
                        "latitude": "26.49001000",
                        "longitude": "79.90108000"
                    },
                    {
                        "id": 147550,
                        "name": "Sabalpur",
                        "latitude": "27.17604900",
                        "longitude": "79.42012000"
                    },
                    {
                        "id": 147551,
                        "name": "Sachendi",
                        "latitude": "26.37116500",
                        "longitude": "80.11230000"
                    },
                    {
                        "id": 133744,
                        "name": "Sadabad",
                        "latitude": "27.43818000",
                        "longitude": "78.03758000"
                    },
                    {
                        "id": 134059,
                        "name": "Sadat",
                        "latitude": "25.67117000",
                        "longitude": "83.30269000"
                    },
                    {
                        "id": 133747,
                        "name": "Safipur",
                        "latitude": "26.73783000",
                        "longitude": "80.34350000"
                    },
                    {
                        "id": 133753,
                        "name": "Saharanpur",
                        "latitude": "29.90000000",
                        "longitude": "77.68333000"
                    },
                    {
                        "id": 133750,
                        "name": "Sahaspur",
                        "latitude": "29.12125000",
                        "longitude": "78.62273000"
                    },
                    {
                        "id": 133751,
                        "name": "Sahaswan",
                        "latitude": "28.07227000",
                        "longitude": "78.75082000"
                    },
                    {
                        "id": 133754,
                        "name": "Sahawar",
                        "latitude": "27.79603000",
                        "longitude": "78.83373000"
                    },
                    {
                        "id": 147552,
                        "name": "Sahibabad",
                        "latitude": "28.68333333",
                        "longitude": "77.40000000"
                    },
                    {
                        "id": 147553,
                        "name": "Sahpau",
                        "latitude": "27.43527778",
                        "longitude": "78.14138889"
                    },
                    {
                        "id": 133755,
                        "name": "Saidpur",
                        "latitude": "25.53749000",
                        "longitude": "83.22378000"
                    },
                    {
                        "id": 147554,
                        "name": "Sakhanu",
                        "latitude": "27.95472222",
                        "longitude": "79.22750000"
                    },
                    {
                        "id": 133762,
                        "name": "Sakit",
                        "latitude": "27.43463000",
                        "longitude": "78.77903000"
                    },
                    {
                        "id": 147555,
                        "name": "Salempur",
                        "latitude": "26.30000000",
                        "longitude": "83.91666667"
                    },
                    {
                        "id": 133765,
                        "name": "Salon",
                        "latitude": "26.02857000",
                        "longitude": "81.45403000"
                    },
                    {
                        "id": 133770,
                        "name": "Sambhal",
                        "latitude": "28.58498000",
                        "longitude": "78.56959000"
                    },
                    {
                        "id": 133773,
                        "name": "Samthar",
                        "latitude": "25.84348000",
                        "longitude": "78.90683000"
                    },
                    {
                        "id": 134072,
                        "name": "Sandi",
                        "latitude": "27.28867000",
                        "longitude": "79.95190000"
                    },
                    {
                        "id": 133778,
                        "name": "Sandila",
                        "latitude": "27.06989000",
                        "longitude": "80.51497000"
                    },
                    {
                        "id": 133792,
                        "name": "Sant Kabir Nagar",
                        "latitude": "26.79016000",
                        "longitude": "83.03481000"
                    },
                    {
                        "id": 133793,
                        "name": "Sant Ravi Das Nagar",
                        "latitude": "25.35792000",
                        "longitude": "82.43080000"
                    },
                    {
                        "id": 133813,
                        "name": "Sarai Akil",
                        "latitude": "25.37890000",
                        "longitude": "81.51035000"
                    },
                    {
                        "id": 133799,
                        "name": "Sarai Ekdil",
                        "latitude": "26.74442000",
                        "longitude": "79.09353000"
                    },
                    {
                        "id": 133812,
                        "name": "Sarai Mir",
                        "latitude": "26.02705000",
                        "longitude": "82.91843000"
                    },
                    {
                        "id": 133802,
                        "name": "Sarauli",
                        "latitude": "28.49404000",
                        "longitude": "79.09177000"
                    },
                    {
                        "id": 133803,
                        "name": "Sardhana",
                        "latitude": "29.14551000",
                        "longitude": "77.61433000"
                    },
                    {
                        "id": 133814,
                        "name": "Sarila",
                        "latitude": "25.77579000",
                        "longitude": "79.67535000"
                    },
                    {
                        "id": 147556,
                        "name": "Sarurpur",
                        "latitude": "29.03333333",
                        "longitude": "77.23333333"
                    },
                    {
                        "id": 134080,
                        "name": "Sasni",
                        "latitude": "27.70287000",
                        "longitude": "78.08278000"
                    },
                    {
                        "id": 133821,
                        "name": "Satrikh",
                        "latitude": "26.86045000",
                        "longitude": "81.19567000"
                    },
                    {
                        "id": 133828,
                        "name": "Saurikh",
                        "latitude": "27.03051000",
                        "longitude": "79.48813000"
                    },
                    {
                        "id": 133833,
                        "name": "Sector",
                        "latitude": "28.57080000",
                        "longitude": "77.32610000"
                    },
                    {
                        "id": 133839,
                        "name": "Seohara",
                        "latitude": "29.20904000",
                        "longitude": "78.58837000"
                    },
                    {
                        "id": 133905,
                        "name": "Shahabad",
                        "latitude": "27.64310000",
                        "longitude": "79.94020000"
                    },
                    {
                        "id": 133892,
                        "name": "Shahganj",
                        "latitude": "26.04965000",
                        "longitude": "82.68423000"
                    },
                    {
                        "id": 133894,
                        "name": "Shahi",
                        "latitude": "28.55023000",
                        "longitude": "79.31761000"
                    },
                    {
                        "id": 133895,
                        "name": "Shahjahanpur",
                        "latitude": "28.00000000",
                        "longitude": "79.83333000"
                    },
                    {
                        "id": 133901,
                        "name": "Shahpur",
                        "latitude": "29.35010000",
                        "longitude": "77.55160000"
                    },
                    {
                        "id": 133913,
                        "name": "Shamli",
                        "latitude": "29.44970000",
                        "longitude": "77.30959000"
                    },
                    {
                        "id": 133855,
                        "name": "Shamsabad",
                        "latitude": "27.01718000",
                        "longitude": "78.12358000"
                    },
                    {
                        "id": 133856,
                        "name": "Shankargarh",
                        "latitude": "25.18200000",
                        "longitude": "81.61769000"
                    },
                    {
                        "id": 133862,
                        "name": "Shergarh",
                        "latitude": "28.65128000",
                        "longitude": "79.36815000"
                    },
                    {
                        "id": 133864,
                        "name": "Sherkot",
                        "latitude": "29.32704000",
                        "longitude": "78.57429000"
                    },
                    {
                        "id": 147557,
                        "name": "Shibnagar",
                        "latitude": "28.50000000",
                        "longitude": "79.98333333"
                    },
                    {
                        "id": 133869,
                        "name": "Shikarpur",
                        "latitude": "28.28072000",
                        "longitude": "78.01411000"
                    },
                    {
                        "id": 147558,
                        "name": "Shikarpur (Bulandshahr)",
                        "latitude": "28.28000000",
                        "longitude": "78.02000000"
                    },
                    {
                        "id": 133867,
                        "name": "Shikohabad",
                        "latitude": "27.10800000",
                        "longitude": "78.58661000"
                    },
                    {
                        "id": 133914,
                        "name": "Shishgarh",
                        "latitude": "28.72928000",
                        "longitude": "79.31469000"
                    },
                    {
                        "id": 147559,
                        "name": "Shivrajpur",
                        "latitude": "26.85722222",
                        "longitude": "79.11500000"
                    },
                    {
                        "id": 133885,
                        "name": "Shrawasti",
                        "latitude": "27.50746000",
                        "longitude": "82.00470000"
                    },
                    {
                        "id": 133918,
                        "name": "Siddharthnagar",
                        "latitude": "27.25797000",
                        "longitude": "83.01465000"
                    },
                    {
                        "id": 147560,
                        "name": "Siddhaur",
                        "latitude": "26.76944444",
                        "longitude": "81.41805556"
                    },
                    {
                        "id": 133921,
                        "name": "Sidhauli",
                        "latitude": "27.28202000",
                        "longitude": "80.83450000"
                    },
                    {
                        "id": 133923,
                        "name": "Sidhpura",
                        "latitude": "27.63312000",
                        "longitude": "78.86918000"
                    },
                    {
                        "id": 133929,
                        "name": "Sikandarabad",
                        "latitude": "28.45226000",
                        "longitude": "77.70004000"
                    },
                    {
                        "id": 133928,
                        "name": "Sikandarpur",
                        "latitude": "26.04327000",
                        "longitude": "84.05298000"
                    },
                    {
                        "id": 133930,
                        "name": "Sikandra",
                        "latitude": "26.36722000",
                        "longitude": "79.62980000"
                    },
                    {
                        "id": 133931,
                        "name": "Sikandra Rao",
                        "latitude": "27.68859000",
                        "longitude": "78.37985000"
                    },
                    {
                        "id": 147561,
                        "name": "Sikandrabad",
                        "latitude": "28.44952500",
                        "longitude": "77.69415278"
                    },
                    {
                        "id": 133969,
                        "name": "Sirathu",
                        "latitude": "25.64292000",
                        "longitude": "81.31855000"
                    },
                    {
                        "id": 133965,
                        "name": "Sirsa",
                        "latitude": "25.26340000",
                        "longitude": "82.09190000"
                    },
                    {
                        "id": 133966,
                        "name": "Sirsaganj",
                        "latitude": "27.05715000",
                        "longitude": "78.68661000"
                    },
                    {
                        "id": 133963,
                        "name": "Sirsi",
                        "latitude": "28.63916000",
                        "longitude": "78.64303000"
                    },
                    {
                        "id": 133971,
                        "name": "Sisauli",
                        "latitude": "29.41386000",
                        "longitude": "77.46890000"
                    },
                    {
                        "id": 133972,
                        "name": "Siswa Bazar",
                        "latitude": "27.14652000",
                        "longitude": "83.75803000"
                    },
                    {
                        "id": 134091,
                        "name": "Sitapur",
                        "latitude": "27.50000000",
                        "longitude": "80.91667000"
                    },
                    {
                        "id": 133992,
                        "name": "Sonbhadra",
                        "latitude": "24.40212000",
                        "longitude": "83.05352000"
                    },
                    {
                        "id": 134005,
                        "name": "Soron",
                        "latitude": "27.89055000",
                        "longitude": "78.74621000"
                    },
                    {
                        "id": 134056,
                        "name": "Suar",
                        "latitude": "29.02841000",
                        "longitude": "79.05654000"
                    },
                    {
                        "id": 134040,
                        "name": "Sultanpur",
                        "latitude": "26.25000000",
                        "longitude": "82.00000000"
                    },
                    {
                        "id": 134053,
                        "name": "Surianwan",
                        "latitude": "25.46387000",
                        "longitude": "82.41922000"
                    },
                    {
                        "id": 134229,
                        "name": "Tajpur",
                        "latitude": "29.16242000",
                        "longitude": "78.48458000"
                    },
                    {
                        "id": 134231,
                        "name": "Talbahat",
                        "latitude": "25.04357000",
                        "longitude": "78.43441000"
                    },
                    {
                        "id": 134233,
                        "name": "Talgram",
                        "latitude": "27.04753000",
                        "longitude": "79.64811000"
                    },
                    {
                        "id": 134235,
                        "name": "Tanda",
                        "latitude": "28.97621000",
                        "longitude": "78.94187000"
                    },
                    {
                        "id": 147562,
                        "name": "Terha",
                        "latitude": "25.83330000",
                        "longitude": "80.25000000"
                    },
                    {
                        "id": 134136,
                        "name": "Thakurdwara",
                        "latitude": "29.19203000",
                        "longitude": "78.86145000"
                    },
                    {
                        "id": 134165,
                        "name": "Thana Bhawan",
                        "latitude": "29.58605000",
                        "longitude": "77.41811000"
                    },
                    {
                        "id": 147563,
                        "name": "Tigri",
                        "latitude": "28.51083333",
                        "longitude": "77.23888889"
                    },
                    {
                        "id": 134170,
                        "name": "Tikaitnagar",
                        "latitude": "26.94612000",
                        "longitude": "81.56583000"
                    },
                    {
                        "id": 134245,
                        "name": "Tikri",
                        "latitude": "29.22910000",
                        "longitude": "77.35479000"
                    },
                    {
                        "id": 134171,
                        "name": "Tilhar",
                        "latitude": "27.96282000",
                        "longitude": "79.73827000"
                    },
                    {
                        "id": 147564,
                        "name": "Tilsahri",
                        "latitude": "26.33330000",
                        "longitude": "80.41670000"
                    },
                    {
                        "id": 134173,
                        "name": "Tindwari",
                        "latitude": "25.61739000",
                        "longitude": "80.52718000"
                    },
                    {
                        "id": 134202,
                        "name": "Titron",
                        "latitude": "29.66824000",
                        "longitude": "77.32391000"
                    },
                    {
                        "id": 147565,
                        "name": "Tori Fatehpur",
                        "latitude": "25.45000000",
                        "longitude": "79.13330000"
                    },
                    {
                        "id": 134210,
                        "name": "Tori-Fatehpur",
                        "latitude": "25.45505000",
                        "longitude": "79.11428000"
                    },
                    {
                        "id": 134218,
                        "name": "Tulsipur",
                        "latitude": "27.53370000",
                        "longitude": "82.41653000"
                    },
                    {
                        "id": 134248,
                        "name": "Tundla",
                        "latitude": "27.21460000",
                        "longitude": "78.23683000"
                    },
                    {
                        "id": 134261,
                        "name": "Ugu",
                        "latitude": "26.79681000",
                        "longitude": "80.32093000"
                    },
                    {
                        "id": 134262,
                        "name": "Ujhani",
                        "latitude": "28.00311000",
                        "longitude": "79.00821000"
                    },
                    {
                        "id": 147566,
                        "name": "Umri",
                        "latitude": "26.33333333",
                        "longitude": "79.25000000"
                    },
                    {
                        "id": 134471,
                        "name": "Un",
                        "latitude": "29.58479000",
                        "longitude": "77.25540000"
                    },
                    {
                        "id": 134285,
                        "name": "Unnao",
                        "latitude": "26.50000000",
                        "longitude": "80.50000000"
                    },
                    {
                        "id": 147567,
                        "name": "Usawan",
                        "latitude": "27.81583333",
                        "longitude": "79.34861111"
                    },
                    {
                        "id": 134294,
                        "name": "Usehat",
                        "latitude": "27.79796000",
                        "longitude": "79.23763000"
                    },
                    {
                        "id": 147568,
                        "name": "Uska",
                        "latitude": "27.20000000",
                        "longitude": "83.11666667"
                    },
                    {
                        "id": 134296,
                        "name": "Utraula",
                        "latitude": "27.31933000",
                        "longitude": "82.41872000"
                    },
                    {
                        "id": 134327,
                        "name": "Varanasi",
                        "latitude": "25.31668000",
                        "longitude": "83.01041000"
                    },
                    {
                        "id": 147569,
                        "name": "Vindhyachal",
                        "latitude": "25.16670000",
                        "longitude": "82.50000000"
                    },
                    {
                        "id": 134376,
                        "name": "Vrindavan",
                        "latitude": "27.58105000",
                        "longitude": "77.69662000"
                    },
                    {
                        "id": 147570,
                        "name": "Walterganj",
                        "latitude": "26.86670000",
                        "longitude": "82.71670000"
                    },
                    {
                        "id": 134401,
                        "name": "Wazirganj",
                        "latitude": "28.21145000",
                        "longitude": "79.05665000"
                    },
                    {
                        "id": 147571,
                        "name": "Yusufpur",
                        "latitude": "25.66670000",
                        "longitude": "83.46670000"
                    },
                    {
                        "id": 134439,
                        "name": "Zafarabad",
                        "latitude": "25.69867000",
                        "longitude": "82.73354000"
                    },
                    {
                        "id": 134441,
                        "name": "Zaidpur",
                        "latitude": "26.83093000",
                        "longitude": "81.32929000"
                    },
                    {
                        "id": 134442,
                        "name": "Zamania",
                        "latitude": "25.41961000",
                        "longitude": "83.55786000"
                    }
                ]
            },
            {
                "id": 4016,
                "name": "Uttarakhand",
                "iso2": "UK",
                "latitude": "30.06675300",
                "longitude": "79.01929970",
                "type": "state",
                "cities": [
                    {
                        "id": 57643,
                        "name": "Almora",
                        "latitude": "29.69223000",
                        "longitude": "79.49789000"
                    },
                    {
                        "id": 57800,
                        "name": "Bageshwar",
                        "latitude": "29.97315000",
                        "longitude": "79.83224000"
                    },
                    {
                        "id": 57879,
                        "name": "Barkot",
                        "latitude": "30.80861000",
                        "longitude": "78.20596000"
                    },
                    {
                        "id": 58153,
                        "name": "Bazpur",
                        "latitude": "29.15299000",
                        "longitude": "79.10814000"
                    },
                    {
                        "id": 58020,
                        "name": "Bhim Tal",
                        "latitude": "29.34447000",
                        "longitude": "79.56336000"
                    },
                    {
                        "id": 57998,
                        "name": "Bhowali",
                        "latitude": "29.38985000",
                        "longitude": "79.50481000"
                    },
                    {
                        "id": 58059,
                        "name": "Birbhaddar",
                        "latitude": "30.07120000",
                        "longitude": "78.28189000"
                    },
                    {
                        "id": 58176,
                        "name": "Chakrata",
                        "latitude": "30.70369000",
                        "longitude": "77.86386000"
                    },
                    {
                        "id": 58182,
                        "name": "Chamoli",
                        "latitude": "30.50000000",
                        "longitude": "79.50000000"
                    },
                    {
                        "id": 58183,
                        "name": "Champawat",
                        "latitude": "29.28756000",
                        "longitude": "80.03737000"
                    },
                    {
                        "id": 131615,
                        "name": "Clement Town",
                        "latitude": "30.26361000",
                        "longitude": "78.00862000"
                    },
                    {
                        "id": 131676,
                        "name": "Dehradun",
                        "latitude": "30.33000000",
                        "longitude": "78.06000000"
                    },
                    {
                        "id": 131702,
                        "name": "Devaprayag",
                        "latitude": "30.14603000",
                        "longitude": "78.60272000"
                    },
                    {
                        "id": 131754,
                        "name": "Dharchula",
                        "latitude": "29.84707000",
                        "longitude": "80.51951000"
                    },
                    {
                        "id": 131784,
                        "name": "Doiwala",
                        "latitude": "30.17667000",
                        "longitude": "78.11659000"
                    },
                    {
                        "id": 131793,
                        "name": "Dugadda",
                        "latitude": "29.80673000",
                        "longitude": "78.61109000"
                    },
                    {
                        "id": 131804,
                        "name": "Dwarahat",
                        "latitude": "29.77785000",
                        "longitude": "79.42731000"
                    },
                    {
                        "id": 131923,
                        "name": "Garhwal",
                        "latitude": "29.96366000",
                        "longitude": "78.92853000"
                    },
                    {
                        "id": 132058,
                        "name": "Haldwani",
                        "latitude": "29.22254000",
                        "longitude": "79.52860000"
                    },
                    {
                        "id": 132069,
                        "name": "Harbatpur",
                        "latitude": "30.43863000",
                        "longitude": "77.74058000"
                    },
                    {
                        "id": 132075,
                        "name": "Haridwar",
                        "latitude": "29.94791000",
                        "longitude": "78.16025000"
                    },
                    {
                        "id": 132247,
                        "name": "Jaspur",
                        "latitude": "29.27919000",
                        "longitude": "78.82798000"
                    },
                    {
                        "id": 132296,
                        "name": "Joshimath",
                        "latitude": "30.55543000",
                        "longitude": "79.56436000"
                    },
                    {
                        "id": 132685,
                        "name": "Kaladhungi",
                        "latitude": "29.28351000",
                        "longitude": "79.35100000"
                    },
                    {
                        "id": 132686,
                        "name": "Kalagarh Project Colony",
                        "latitude": "29.47780000",
                        "longitude": "78.78449000"
                    },
                    {
                        "id": 132418,
                        "name": "Kashipur",
                        "latitude": "29.21399000",
                        "longitude": "78.95693000"
                    },
                    {
                        "id": 132484,
                        "name": "Khatima",
                        "latitude": "28.92134000",
                        "longitude": "79.97075000"
                    },
                    {
                        "id": 132521,
                        "name": "Kichha",
                        "latitude": "28.91154000",
                        "longitude": "79.52009000"
                    },
                    {
                        "id": 132597,
                        "name": "Kotdwara",
                        "latitude": "29.74612000",
                        "longitude": "78.52219000"
                    },
                    {
                        "id": 132749,
                        "name": "Laksar",
                        "latitude": "29.75870000",
                        "longitude": "78.04148000"
                    },
                    {
                        "id": 132756,
                        "name": "Lansdowne",
                        "latitude": "29.84183000",
                        "longitude": "78.68014000"
                    },
                    {
                        "id": 132767,
                        "name": "Lohaghat",
                        "latitude": "29.40356000",
                        "longitude": "80.08965000"
                    },
                    {
                        "id": 132908,
                        "name": "Manglaur",
                        "latitude": "29.79094000",
                        "longitude": "77.87836000"
                    },
                    {
                        "id": 133046,
                        "name": "Mussoorie",
                        "latitude": "30.45498000",
                        "longitude": "78.07068000"
                    },
                    {
                        "id": 133123,
                        "name": "Naini Tal",
                        "latitude": "29.39743000",
                        "longitude": "79.44686000"
                    },
                    {
                        "id": 133166,
                        "name": "Narendranagar",
                        "latitude": "30.16173000",
                        "longitude": "78.28712000"
                    },
                    {
                        "id": 133394,
                        "name": "Pauri",
                        "latitude": "30.15286000",
                        "longitude": "78.77710000"
                    },
                    {
                        "id": 133563,
                        "name": "Pipalkoti",
                        "latitude": "30.42553000",
                        "longitude": "79.43066000"
                    },
                    {
                        "id": 133464,
                        "name": "Pithoragarh",
                        "latitude": "30.00000000",
                        "longitude": "80.25000000"
                    },
                    {
                        "id": 133666,
                        "name": "Raipur",
                        "latitude": "30.31097000",
                        "longitude": "78.08979000"
                    },
                    {
                        "id": 133735,
                        "name": "Raiwala Bara",
                        "latitude": "30.01864000",
                        "longitude": "78.22930000"
                    },
                    {
                        "id": 133703,
                        "name": "Ramnagar",
                        "latitude": "29.39250000",
                        "longitude": "79.12830000"
                    },
                    {
                        "id": 133716,
                        "name": "Ranikhet",
                        "latitude": "29.64082000",
                        "longitude": "79.43229000"
                    },
                    {
                        "id": 133638,
                        "name": "Rishikesh",
                        "latitude": "30.10778000",
                        "longitude": "78.29255000"
                    },
                    {
                        "id": 133650,
                        "name": "Roorkee",
                        "latitude": "29.86632000",
                        "longitude": "77.89118000"
                    },
                    {
                        "id": 133652,
                        "name": "Rudraprayag",
                        "latitude": "30.60872000",
                        "longitude": "79.06517000"
                    },
                    {
                        "id": 133973,
                        "name": "Sitarganj",
                        "latitude": "28.92930000",
                        "longitude": "79.70436000"
                    },
                    {
                        "id": 134027,
                        "name": "Srinagar",
                        "latitude": "30.22243000",
                        "longitude": "78.78341000"
                    },
                    {
                        "id": 134038,
                        "name": "Sultanpur",
                        "latitude": "29.75534000",
                        "longitude": "78.11034000"
                    },
                    {
                        "id": 134110,
                        "name": "Tanakpur",
                        "latitude": "29.07400000",
                        "longitude": "80.11139000"
                    },
                    {
                        "id": 134122,
                        "name": "Tehri",
                        "latitude": "30.39086000",
                        "longitude": "78.48030000"
                    },
                    {
                        "id": 134123,
                        "name": "Tehri-Garhwal",
                        "latitude": "30.50000000",
                        "longitude": "78.66667000"
                    },
                    {
                        "id": 134256,
                        "name": "Udham Singh Nagar",
                        "latitude": "29.02746000",
                        "longitude": "79.52347000"
                    },
                    {
                        "id": 134301,
                        "name": "Uttarkashi",
                        "latitude": "30.72986000",
                        "longitude": "78.44342000"
                    },
                    {
                        "id": 134360,
                        "name": "Vikasnagar",
                        "latitude": "30.46944000",
                        "longitude": "77.77275000"
                    }
                ]
            },
            {
                "id": 4853,
                "name": "West Bengal",
                "iso2": "WB",
                "latitude": "22.98675690",
                "longitude": "87.85497550",
                "type": "state",
                "cities": [
                    {
                        "id": 153350,
                        "name": "Adra",
                        "latitude": "23.49601500",
                        "longitude": "86.67249000"
                    },
                    {
                        "id": 141852,
                        "name": "Ahmedpur",
                        "latitude": "23.83009000",
                        "longitude": "87.68661000"
                    },
                    {
                        "id": 141853,
                        "name": "Aistala",
                        "latitude": "23.18000000",
                        "longitude": "88.58000000"
                    },
                    {
                        "id": 141854,
                        "name": "Aknapur",
                        "latitude": "18.38576389",
                        "longitude": "77.27225278"
                    },
                    {
                        "id": 141855,
                        "name": "Alipurduar",
                        "latitude": "26.49136000",
                        "longitude": "89.52796000"
                    },
                    {
                        "id": 142112,
                        "name": "Amlagora",
                        "latitude": "22.84616000",
                        "longitude": "87.33559000"
                    },
                    {
                        "id": 141857,
                        "name": "Amta",
                        "latitude": "22.57333333",
                        "longitude": "88.01611111"
                    },
                    {
                        "id": 141858,
                        "name": "Amtala",
                        "latitude": "22.22000000",
                        "longitude": "88.17000000"
                    },
                    {
                        "id": 141859,
                        "name": "Andal",
                        "latitude": "23.60000000",
                        "longitude": "87.20000000"
                    },
                    {
                        "id": 141860,
                        "name": "Arambagh community development block",
                        "latitude": "22.88000000",
                        "longitude": "87.78000000"
                    },
                    {
                        "id": 141861,
                        "name": "Asansol",
                        "latitude": "23.68333333",
                        "longitude": "86.96666667"
                    },
                    {
                        "id": 141862,
                        "name": "Ashoknagar Kalyangarh",
                        "latitude": "22.83300000",
                        "longitude": "88.63300000"
                    },
                    {
                        "id": 141863,
                        "name": "Badkulla",
                        "latitude": "23.28000000",
                        "longitude": "88.53000000"
                    },
                    {
                        "id": 141864,
                        "name": "Baduria",
                        "latitude": "22.74000000",
                        "longitude": "88.79000000"
                    },
                    {
                        "id": 141865,
                        "name": "Bagdogra",
                        "latitude": "26.69980400",
                        "longitude": "88.31939200"
                    },
                    {
                        "id": 141866,
                        "name": "Bagnan",
                        "latitude": "22.47000000",
                        "longitude": "87.97000000"
                    },
                    {
                        "id": 141867,
                        "name": "Bagula",
                        "latitude": "23.33500000",
                        "longitude": "88.64400000"
                    },
                    {
                        "id": 141868,
                        "name": "Bahula",
                        "latitude": "23.65741900",
                        "longitude": "87.19597400"
                    },
                    {
                        "id": 141869,
                        "name": "Baidyabati",
                        "latitude": "22.79000000",
                        "longitude": "88.32000000"
                    },
                    {
                        "id": 141870,
                        "name": "Bakreswar",
                        "latitude": "23.88320000",
                        "longitude": "87.37265000"
                    },
                    {
                        "id": 141871,
                        "name": "Balarampur",
                        "latitude": "23.09714000",
                        "longitude": "86.22292000"
                    },
                    {
                        "id": 141903,
                        "name": "Bali Chak",
                        "latitude": "22.36482000",
                        "longitude": "87.55304000"
                    },
                    {
                        "id": 141872,
                        "name": "Bally",
                        "latitude": "22.65000000",
                        "longitude": "88.34000000"
                    },
                    {
                        "id": 141873,
                        "name": "Balurghat",
                        "latitude": "25.21666667",
                        "longitude": "88.76666667"
                    },
                    {
                        "id": 141874,
                        "name": "Bamangola community development block",
                        "latitude": "25.17000000",
                        "longitude": "88.33500000"
                    },
                    {
                        "id": 141875,
                        "name": "Baneswar",
                        "latitude": "26.65000000",
                        "longitude": "89.81666667"
                    },
                    {
                        "id": 141876,
                        "name": "Bangaon",
                        "latitude": "23.07000000",
                        "longitude": "88.82000000"
                    },
                    {
                        "id": 141877,
                        "name": "Bankra",
                        "latitude": "22.63000000",
                        "longitude": "88.30000000"
                    },
                    {
                        "id": 141878,
                        "name": "Bankura",
                        "latitude": "23.25000000",
                        "longitude": "87.06666667"
                    },
                    {
                        "id": 141879,
                        "name": "Bansberia",
                        "latitude": "22.97000000",
                        "longitude": "88.40000000"
                    },
                    {
                        "id": 141880,
                        "name": "Bansihari community development block",
                        "latitude": "25.40000000",
                        "longitude": "88.41670000"
                    },
                    {
                        "id": 141881,
                        "name": "Barabazar",
                        "latitude": "23.36000000",
                        "longitude": "86.65000000"
                    },
                    {
                        "id": 141882,
                        "name": "Baranagar",
                        "latitude": "22.64000000",
                        "longitude": "88.37000000"
                    },
                    {
                        "id": 141883,
                        "name": "Barasat",
                        "latitude": "22.23333333",
                        "longitude": "88.45000000"
                    },
                    {
                        "id": 141884,
                        "name": "Bardhaman",
                        "latitude": "23.25000000",
                        "longitude": "87.85000000"
                    },
                    {
                        "id": 141885,
                        "name": "Barjora",
                        "latitude": "23.43333333",
                        "longitude": "87.28333333"
                    },
                    {
                        "id": 141886,
                        "name": "Barrackpore",
                        "latitude": "22.75000000",
                        "longitude": "88.36666667"
                    },
                    {
                        "id": 141887,
                        "name": "Baruipur",
                        "latitude": "22.35000000",
                        "longitude": "88.44000000"
                    },
                    {
                        "id": 141888,
                        "name": "Basanti",
                        "latitude": "22.18915340",
                        "longitude": "88.67056850"
                    },
                    {
                        "id": 141889,
                        "name": "Basirhat",
                        "latitude": "22.65722222",
                        "longitude": "88.89416667"
                    },
                    {
                        "id": 141904,
                        "name": "Bawali",
                        "latitude": "22.42563000",
                        "longitude": "88.19336000"
                    },
                    {
                        "id": 141890,
                        "name": "Begampur",
                        "latitude": "22.74000000",
                        "longitude": "88.24000000"
                    },
                    {
                        "id": 141891,
                        "name": "Belda",
                        "latitude": "22.08000000",
                        "longitude": "87.35000000"
                    },
                    {
                        "id": 141892,
                        "name": "Beldanga",
                        "latitude": "23.93000000",
                        "longitude": "88.25000000"
                    },
                    {
                        "id": 141893,
                        "name": "Beliatore",
                        "latitude": "23.33333333",
                        "longitude": "87.21666667"
                    },
                    {
                        "id": 141894,
                        "name": "Berhampore",
                        "latitude": "24.10000000",
                        "longitude": "88.25000000"
                    },
                    {
                        "id": 141895,
                        "name": "Bhadreswar",
                        "latitude": "22.82000000",
                        "longitude": "88.35000000"
                    },
                    {
                        "id": 141896,
                        "name": "Bhandardaha",
                        "latitude": "22.62000000",
                        "longitude": "88.21000000"
                    },
                    {
                        "id": 141897,
                        "name": "Bhatpara",
                        "latitude": "22.86666667",
                        "longitude": "88.41666667"
                    },
                    {
                        "id": 141898,
                        "name": "Birbhum district",
                        "latitude": "24.00000000",
                        "longitude": "87.58333000"
                    },
                    {
                        "id": 141899,
                        "name": "Birpara",
                        "latitude": "26.50000000",
                        "longitude": "89.50000000"
                    },
                    {
                        "id": 141900,
                        "name": "Bishnupur",
                        "latitude": "22.38000000",
                        "longitude": "88.27000000"
                    },
                    {
                        "id": 141901,
                        "name": "Bolpur",
                        "latitude": "23.67000000",
                        "longitude": "87.72000000"
                    },
                    {
                        "id": 141902,
                        "name": "Budge Budge",
                        "latitude": "22.47000000",
                        "longitude": "88.17000000"
                    },
                    {
                        "id": 141905,
                        "name": "Canning",
                        "latitude": "22.32000000",
                        "longitude": "88.67000000"
                    },
                    {
                        "id": 141906,
                        "name": "Chakapara",
                        "latitude": "22.63000000",
                        "longitude": "88.35000000"
                    },
                    {
                        "id": 141907,
                        "name": "Chakdaha",
                        "latitude": "23.08000000",
                        "longitude": "88.52000000"
                    },
                    {
                        "id": 141908,
                        "name": "Champadanga",
                        "latitude": "22.83000000",
                        "longitude": "87.96000000"
                    },
                    {
                        "id": 141914,
                        "name": "Champahati",
                        "latitude": "22.40026000",
                        "longitude": "88.49209000"
                    },
                    {
                        "id": 141909,
                        "name": "Champdani",
                        "latitude": "22.80000000",
                        "longitude": "88.37000000"
                    },
                    {
                        "id": 141910,
                        "name": "Chandannagar",
                        "latitude": "22.86666667",
                        "longitude": "88.38333333"
                    },
                    {
                        "id": 141911,
                        "name": "Chandrakona",
                        "latitude": "22.73000000",
                        "longitude": "87.52000000"
                    },
                    {
                        "id": 141912,
                        "name": "Chittaranjan",
                        "latitude": "23.87000000",
                        "longitude": "86.87000000"
                    },
                    {
                        "id": 141913,
                        "name": "Churulia",
                        "latitude": "23.78000000",
                        "longitude": "87.08000000"
                    },
                    {
                        "id": 141915,
                        "name": "Contai",
                        "latitude": "21.78000000",
                        "longitude": "87.75000000"
                    },
                    {
                        "id": 141916,
                        "name": "Cooch Behar",
                        "latitude": "26.31666667",
                        "longitude": "89.43333333"
                    },
                    {
                        "id": 141917,
                        "name": "Cossimbazar",
                        "latitude": "24.12000000",
                        "longitude": "88.28000000"
                    },
                    {
                        "id": 141918,
                        "name": "Dakshin Dinajpur district",
                        "latitude": "25.22000000",
                        "longitude": "88.76000000"
                    },
                    {
                        "id": 141919,
                        "name": "Dalkola",
                        "latitude": "25.87577000",
                        "longitude": "87.84009000"
                    },
                    {
                        "id": 141920,
                        "name": "Dam Dam",
                        "latitude": "22.63333333",
                        "longitude": "88.42277778"
                    },
                    {
                        "id": 141921,
                        "name": "Darjeeling",
                        "latitude": "27.04166667",
                        "longitude": "88.26305556"
                    },
                    {
                        "id": 141922,
                        "name": "Daulatpur",
                        "latitude": "25.32605000",
                        "longitude": "88.32989000"
                    },
                    {
                        "id": 141923,
                        "name": "Debagram",
                        "latitude": "23.68333333",
                        "longitude": "88.28333333"
                    },
                    {
                        "id": 141924,
                        "name": "Debipur",
                        "latitude": "24.25029000",
                        "longitude": "88.61824000"
                    },
                    {
                        "id": 141925,
                        "name": "Dhaniakhali community development block",
                        "latitude": "22.97000000",
                        "longitude": "88.10000000"
                    },
                    {
                        "id": 141926,
                        "name": "Dhulagari",
                        "latitude": "22.58222222",
                        "longitude": "88.17111111"
                    },
                    {
                        "id": 141927,
                        "name": "Dhulian",
                        "latitude": "24.68000000",
                        "longitude": "87.97000000"
                    },
                    {
                        "id": 141928,
                        "name": "Dhupguri",
                        "latitude": "26.60000000",
                        "longitude": "89.02000000"
                    },
                    {
                        "id": 141929,
                        "name": "Diamond Harbour",
                        "latitude": "22.20000000",
                        "longitude": "88.20000000"
                    },
                    {
                        "id": 141930,
                        "name": "Digha",
                        "latitude": "21.68000000",
                        "longitude": "87.55000000"
                    },
                    {
                        "id": 141931,
                        "name": "Dinhata",
                        "latitude": "26.13000000",
                        "longitude": "89.47000000"
                    },
                    {
                        "id": 141932,
                        "name": "Domjur",
                        "latitude": "22.64000000",
                        "longitude": "88.22000000"
                    },
                    {
                        "id": 141933,
                        "name": "Dubrajpur",
                        "latitude": "23.80000000",
                        "longitude": "87.38000000"
                    },
                    {
                        "id": 141934,
                        "name": "Durgapur",
                        "latitude": "23.55000000",
                        "longitude": "87.32000000"
                    },
                    {
                        "id": 141935,
                        "name": "Egra",
                        "latitude": "21.90000000",
                        "longitude": "87.53000000"
                    },
                    {
                        "id": 141936,
                        "name": "Falakata",
                        "latitude": "26.53000000",
                        "longitude": "89.20000000"
                    },
                    {
                        "id": 141937,
                        "name": "Farakka",
                        "latitude": "24.81667000",
                        "longitude": "87.90000000"
                    },
                    {
                        "id": 141938,
                        "name": "Fort Gloster",
                        "latitude": "22.50444444",
                        "longitude": "88.18333333"
                    },
                    {
                        "id": 141939,
                        "name": "Gaighata community development block",
                        "latitude": "22.93000000",
                        "longitude": "88.73000000"
                    },
                    {
                        "id": 141940,
                        "name": "Gairkata",
                        "latitude": "26.68000000",
                        "longitude": "89.03000000"
                    },
                    {
                        "id": 141941,
                        "name": "Gangadharpur",
                        "latitude": "22.76040000",
                        "longitude": "88.22180000"
                    },
                    {
                        "id": 141942,
                        "name": "Gangarampur",
                        "latitude": "25.40000000",
                        "longitude": "88.52000000"
                    },
                    {
                        "id": 141943,
                        "name": "Garui",
                        "latitude": "22.63333333",
                        "longitude": "88.40000000"
                    },
                    {
                        "id": 141944,
                        "name": "Garulia",
                        "latitude": "22.82000000",
                        "longitude": "88.37000000"
                    },
                    {
                        "id": 141945,
                        "name": "Ghatal",
                        "latitude": "22.67000000",
                        "longitude": "87.72000000"
                    },
                    {
                        "id": 141946,
                        "name": "Giria",
                        "latitude": "24.51666667",
                        "longitude": "88.06666667"
                    },
                    {
                        "id": 141947,
                        "name": "Gobardanga",
                        "latitude": "22.87000000",
                        "longitude": "88.76000000"
                    },
                    {
                        "id": 141948,
                        "name": "Gobindapur",
                        "latitude": "22.59306000",
                        "longitude": "88.09139000"
                    },
                    {
                        "id": 141950,
                        "name": "Gopalpur",
                        "latitude": "22.61845000",
                        "longitude": "88.75119000"
                    },
                    {
                        "id": 141949,
                        "name": "Gopinathpur",
                        "latitude": "23.22000000",
                        "longitude": "88.15000000"
                    },
                    {
                        "id": 141951,
                        "name": "Gorubathan",
                        "latitude": "26.97000000",
                        "longitude": "88.70000000"
                    },
                    {
                        "id": 141952,
                        "name": "Gosaba",
                        "latitude": "22.16000000",
                        "longitude": "88.80000000"
                    },
                    {
                        "id": 141953,
                        "name": "Gosanimari",
                        "latitude": "26.15000000",
                        "longitude": "89.36666667"
                    },
                    {
                        "id": 141954,
                        "name": "Gurdaha",
                        "latitude": "22.73472222",
                        "longitude": "88.75944444"
                    },
                    {
                        "id": 141955,
                        "name": "Guskhara",
                        "latitude": "23.49277778",
                        "longitude": "87.73472222"
                    },
                    {
                        "id": 141956,
                        "name": "Habra",
                        "latitude": "22.83000000",
                        "longitude": "88.63000000"
                    },
                    {
                        "id": 141957,
                        "name": "Haldia",
                        "latitude": "22.06046000",
                        "longitude": "88.10975000"
                    },
                    {
                        "id": 141958,
                        "name": "Haldibari",
                        "latitude": "26.33000000",
                        "longitude": "88.77000000"
                    },
                    {
                        "id": 141959,
                        "name": "Halisahar",
                        "latitude": "22.95000000",
                        "longitude": "88.42000000"
                    },
                    {
                        "id": 141960,
                        "name": "Harindanga",
                        "latitude": "22.03333333",
                        "longitude": "88.31666667"
                    },
                    {
                        "id": 141961,
                        "name": "Haringhata",
                        "latitude": "22.95000000",
                        "longitude": "88.57000000"
                    },
                    {
                        "id": 141962,
                        "name": "Haripur",
                        "latitude": "22.93611000",
                        "longitude": "88.23194000"
                    },
                    {
                        "id": 141963,
                        "name": "Hasimara",
                        "latitude": "26.75000000",
                        "longitude": "89.35000000"
                    },
                    {
                        "id": 141964,
                        "name": "Hindusthan Cables Town",
                        "latitude": "23.82000000",
                        "longitude": "86.90000000"
                    },
                    {
                        "id": 141965,
                        "name": "Hooghly district",
                        "latitude": "22.91000000",
                        "longitude": "88.39000000"
                    },
                    {
                        "id": 141966,
                        "name": "Howrah",
                        "latitude": "22.57688000",
                        "longitude": "88.31857000"
                    },
                    {
                        "id": 141967,
                        "name": "Ichapur",
                        "latitude": "22.80499000",
                        "longitude": "88.37088000"
                    },
                    {
                        "id": 141968,
                        "name": "Indpur community development block",
                        "latitude": "23.16670000",
                        "longitude": "86.93330000"
                    },
                    {
                        "id": 141969,
                        "name": "Ingraj Bazar",
                        "latitude": "25.00447000",
                        "longitude": "88.14573000"
                    },
                    {
                        "id": 141970,
                        "name": "Islampur",
                        "latitude": "26.27000000",
                        "longitude": "88.20000000"
                    },
                    {
                        "id": 141971,
                        "name": "Jafarpur",
                        "latitude": "22.32000000",
                        "longitude": "88.23000000"
                    },
                    {
                        "id": 141972,
                        "name": "Jaigaon",
                        "latitude": "26.86666667",
                        "longitude": "89.38333333"
                    },
                    {
                        "id": 141973,
                        "name": "Jalpaiguri",
                        "latitude": "26.51666667",
                        "longitude": "88.73333333"
                    },
                    {
                        "id": 141974,
                        "name": "Jamuria",
                        "latitude": "23.70000000",
                        "longitude": "87.08000000"
                    },
                    {
                        "id": 141975,
                        "name": "Jangipur",
                        "latitude": "24.47001000",
                        "longitude": "88.07659000"
                    },
                    {
                        "id": 141976,
                        "name": "Jaynagar Majilpur",
                        "latitude": "22.17722222",
                        "longitude": "88.42583333"
                    },
                    {
                        "id": 141977,
                        "name": "Jejur",
                        "latitude": "22.88000000",
                        "longitude": "88.12000000"
                    },
                    {
                        "id": 141978,
                        "name": "Jhalida",
                        "latitude": "23.36541000",
                        "longitude": "85.97581000"
                    },
                    {
                        "id": 141979,
                        "name": "Jhargram",
                        "latitude": "22.45000000",
                        "longitude": "86.98000000"
                    },
                    {
                        "id": 141980,
                        "name": "Jhilimili",
                        "latitude": "22.81670000",
                        "longitude": "86.61670000"
                    },
                    {
                        "id": 141981,
                        "name": "Kakdwip",
                        "latitude": "21.88330000",
                        "longitude": "88.18330000"
                    },
                    {
                        "id": 141982,
                        "name": "Kalaikunda",
                        "latitude": "22.33916667",
                        "longitude": "87.22638889"
                    },
                    {
                        "id": 141983,
                        "name": "Kaliaganj",
                        "latitude": "25.63000000",
                        "longitude": "88.32000000"
                    },
                    {
                        "id": 141984,
                        "name": "Kalimpong",
                        "latitude": "27.07059000",
                        "longitude": "88.47529000"
                    },
                    {
                        "id": 141985,
                        "name": "Kalna",
                        "latitude": "23.22000000",
                        "longitude": "88.37000000"
                    },
                    {
                        "id": 141986,
                        "name": "Kalyani",
                        "latitude": "22.97500000",
                        "longitude": "88.43444444"
                    },
                    {
                        "id": 141987,
                        "name": "Kamarhati",
                        "latitude": "22.67000000",
                        "longitude": "88.37000000"
                    },
                    {
                        "id": 141988,
                        "name": "Kamarpukur",
                        "latitude": "22.91000000",
                        "longitude": "87.65000000"
                    },
                    {
                        "id": 141989,
                        "name": "Kanchrapara",
                        "latitude": "22.97000000",
                        "longitude": "88.43000000"
                    },
                    {
                        "id": 141990,
                        "name": "Kandi",
                        "latitude": "23.95000000",
                        "longitude": "88.03000000"
                    },
                    {
                        "id": 141991,
                        "name": "Karimpur",
                        "latitude": "23.96666667",
                        "longitude": "88.61666667"
                    },
                    {
                        "id": 141992,
                        "name": "Katwa",
                        "latitude": "23.65000000",
                        "longitude": "88.13000000"
                    },
                    {
                        "id": 141993,
                        "name": "Kenda",
                        "latitude": "23.20000000",
                        "longitude": "86.53000000"
                    },
                    {
                        "id": 141994,
                        "name": "Keshabpur",
                        "latitude": "22.97000000",
                        "longitude": "88.26000000"
                    },
                    {
                        "id": 141995,
                        "name": "Kharagpur",
                        "latitude": "22.33023900",
                        "longitude": "87.32365300"
                    },
                    {
                        "id": 141996,
                        "name": "Kharar",
                        "latitude": "22.70000000",
                        "longitude": "87.68000000"
                    },
                    {
                        "id": 141997,
                        "name": "Kharba",
                        "latitude": "25.42000000",
                        "longitude": "88.07000000"
                    },
                    {
                        "id": 141998,
                        "name": "Khardaha",
                        "latitude": "22.72000000",
                        "longitude": "88.38000000"
                    },
                    {
                        "id": 141999,
                        "name": "Khatra",
                        "latitude": "22.98000000",
                        "longitude": "86.85000000"
                    },
                    {
                        "id": 142000,
                        "name": "Kirnahar",
                        "latitude": "23.75000000",
                        "longitude": "87.87000000"
                    },
                    {
                        "id": 142001,
                        "name": "Kolkata",
                        "latitude": "22.54111111",
                        "longitude": "88.33777778"
                    },
                    {
                        "id": 142002,
                        "name": "Konnagar",
                        "latitude": "22.70000000",
                        "longitude": "88.35000000"
                    },
                    {
                        "id": 142003,
                        "name": "Krishnanagar",
                        "latitude": "23.40000000",
                        "longitude": "88.50000000"
                    },
                    {
                        "id": 142004,
                        "name": "Krishnapur",
                        "latitude": "22.67000000",
                        "longitude": "88.26000000"
                    },
                    {
                        "id": 142005,
                        "name": "Kshirpai",
                        "latitude": "22.71096640",
                        "longitude": "87.61740380"
                    },
                    {
                        "id": 142006,
                        "name": "Kulpi",
                        "latitude": "22.08000000",
                        "longitude": "88.24000000"
                    },
                    {
                        "id": 142007,
                        "name": "Kultali",
                        "latitude": "21.90000000",
                        "longitude": "88.40000000"
                    },
                    {
                        "id": 142008,
                        "name": "Kulti",
                        "latitude": "23.73000000",
                        "longitude": "86.85000000"
                    },
                    {
                        "id": 142009,
                        "name": "Kurseong",
                        "latitude": "26.88000000",
                        "longitude": "88.28000000"
                    },
                    {
                        "id": 142010,
                        "name": "Lalgarh",
                        "latitude": "22.58000000",
                        "longitude": "87.05000000"
                    },
                    {
                        "id": 142011,
                        "name": "Lalgola",
                        "latitude": "24.42000000",
                        "longitude": "88.25000000"
                    },
                    {
                        "id": 142012,
                        "name": "Loyabad",
                        "latitude": "23.67000000",
                        "longitude": "86.67000000"
                    },
                    {
                        "id": 142013,
                        "name": "Madanpur",
                        "latitude": "23.02000000",
                        "longitude": "88.48000000"
                    },
                    {
                        "id": 142014,
                        "name": "Madhyamgram",
                        "latitude": "22.70000000",
                        "longitude": "88.45000000"
                    },
                    {
                        "id": 142015,
                        "name": "Mahiari",
                        "latitude": "22.59000000",
                        "longitude": "88.24000000"
                    },
                    {
                        "id": 142016,
                        "name": "Mahishadal community development block",
                        "latitude": "22.18333300",
                        "longitude": "87.98333300"
                    },
                    {
                        "id": 142017,
                        "name": "Mainaguri",
                        "latitude": "26.57000000",
                        "longitude": "88.82000000"
                    },
                    {
                        "id": 142018,
                        "name": "Manikpara",
                        "latitude": "22.36666667",
                        "longitude": "87.11666667"
                    },
                    {
                        "id": 142019,
                        "name": "Masila",
                        "latitude": "22.58083000",
                        "longitude": "88.23278000"
                    },
                    {
                        "id": 142020,
                        "name": "Mathabhanga",
                        "latitude": "26.34197000",
                        "longitude": "89.21555000"
                    },
                    {
                        "id": 142021,
                        "name": "Matiali community development block",
                        "latitude": "26.92715900",
                        "longitude": "88.81330490"
                    },
                    {
                        "id": 142022,
                        "name": "Matigara community development block",
                        "latitude": "26.71666700",
                        "longitude": "88.38333300"
                    },
                    {
                        "id": 142023,
                        "name": "Medinipur",
                        "latitude": "22.43333333",
                        "longitude": "87.33333333"
                    },
                    {
                        "id": 142024,
                        "name": "Mejia community development block",
                        "latitude": "23.57000000",
                        "longitude": "87.10000000"
                    },
                    {
                        "id": 142025,
                        "name": "Memari",
                        "latitude": "23.20000000",
                        "longitude": "88.12000000"
                    },
                    {
                        "id": 142026,
                        "name": "Mirik",
                        "latitude": "26.88700000",
                        "longitude": "88.18700000"
                    },
                    {
                        "id": 142028,
                        "name": "Monoharpur",
                        "latitude": "22.68000000",
                        "longitude": "88.30000000"
                    },
                    {
                        "id": 142029,
                        "name": "Muragacha",
                        "latitude": "23.53631000",
                        "longitude": "88.39425000"
                    },
                    {
                        "id": 142030,
                        "name": "Muri",
                        "latitude": "23.37000000",
                        "longitude": "85.86000000"
                    },
                    {
                        "id": 142031,
                        "name": "Murshidabad",
                        "latitude": "24.18000000",
                        "longitude": "88.27000000"
                    },
                    {
                        "id": 142032,
                        "name": "Nabadwip",
                        "latitude": "23.40722222",
                        "longitude": "88.37777778"
                    },
                    {
                        "id": 142033,
                        "name": "Nabagram",
                        "latitude": "22.29000000",
                        "longitude": "88.51000000"
                    },
                    {
                        "id": 142034,
                        "name": "Nadia district",
                        "latitude": "23.40000000",
                        "longitude": "88.50000000"
                    },
                    {
                        "id": 142035,
                        "name": "Nagarukhra",
                        "latitude": "22.94099000",
                        "longitude": "88.63701000"
                    },
                    {
                        "id": 142036,
                        "name": "Nagrakata",
                        "latitude": "26.90000000",
                        "longitude": "88.96670000"
                    },
                    {
                        "id": 142037,
                        "name": "Naihati",
                        "latitude": "22.90000000",
                        "longitude": "88.42000000"
                    },
                    {
                        "id": 142038,
                        "name": "Naksalbari",
                        "latitude": "26.68333333",
                        "longitude": "88.21666667"
                    },
                    {
                        "id": 142039,
                        "name": "Nalhati",
                        "latitude": "24.30000000",
                        "longitude": "87.82000000"
                    },
                    {
                        "id": 142040,
                        "name": "Nalpur",
                        "latitude": "22.53000000",
                        "longitude": "88.19000000"
                    },
                    {
                        "id": 142041,
                        "name": "Namkhana community development block",
                        "latitude": "21.70000000",
                        "longitude": "88.14000000"
                    },
                    {
                        "id": 142042,
                        "name": "Nandigram",
                        "latitude": "22.01000000",
                        "longitude": "87.99000000"
                    },
                    {
                        "id": 142043,
                        "name": "Nangi",
                        "latitude": "22.50833333",
                        "longitude": "88.21527778"
                    },
                    {
                        "id": 142044,
                        "name": "Nayagram community development block",
                        "latitude": "22.03190000",
                        "longitude": "87.17810000"
                    },
                    {
                        "id": 142045,
                        "name": "North 24 Parganas district",
                        "latitude": "22.13000000",
                        "longitude": "88.50000000"
                    },
                    {
                        "id": 142046,
                        "name": "Odlabari",
                        "latitude": "26.83638889",
                        "longitude": "88.62944444"
                    },
                    {
                        "id": 142047,
                        "name": "Paikpara",
                        "latitude": "24.77121000",
                        "longitude": "87.92251000"
                    },
                    {
                        "id": 142048,
                        "name": "Panagarh",
                        "latitude": "23.45000000",
                        "longitude": "87.43000000"
                    },
                    {
                        "id": 142049,
                        "name": "Panchla",
                        "latitude": "22.54000000",
                        "longitude": "88.14000000"
                    },
                    {
                        "id": 142050,
                        "name": "Panchmura",
                        "latitude": "22.96670000",
                        "longitude": "87.16670000"
                    },
                    {
                        "id": 142051,
                        "name": "Pandua",
                        "latitude": "23.08000000",
                        "longitude": "88.28000000"
                    },
                    {
                        "id": 142052,
                        "name": "Panihati",
                        "latitude": "22.69000000",
                        "longitude": "88.37000000"
                    },
                    {
                        "id": 142053,
                        "name": "Panskura",
                        "latitude": "22.42000000",
                        "longitude": "87.70000000"
                    },
                    {
                        "id": 142054,
                        "name": "Parbatipur",
                        "latitude": "22.66250000",
                        "longitude": "88.22222000"
                    },
                    {
                        "id": 142055,
                        "name": "Paschim Medinipur district",
                        "latitude": "22.43333333",
                        "longitude": "87.33333333"
                    },
                    {
                        "id": 142056,
                        "name": "Patiram",
                        "latitude": "25.31666667",
                        "longitude": "88.75000000"
                    },
                    {
                        "id": 142062,
                        "name": "Patrasaer",
                        "latitude": "23.19697000",
                        "longitude": "87.53319000"
                    },
                    {
                        "id": 142057,
                        "name": "Patuli",
                        "latitude": "23.55000000",
                        "longitude": "88.25000000"
                    },
                    {
                        "id": 142058,
                        "name": "Pujali",
                        "latitude": "22.47000000",
                        "longitude": "88.15000000"
                    },
                    {
                        "id": 142059,
                        "name": "Puncha community development block",
                        "latitude": "23.12300000",
                        "longitude": "86.65300000"
                    },
                    {
                        "id": 142060,
                        "name": "Purba Medinipur district",
                        "latitude": "22.30000000",
                        "longitude": "87.91666667"
                    },
                    {
                        "id": 142061,
                        "name": "Purulia",
                        "latitude": "23.33333333",
                        "longitude": "86.36666667"
                    },
                    {
                        "id": 142063,
                        "name": "Raghudebbati",
                        "latitude": "22.53000000",
                        "longitude": "88.20000000"
                    },
                    {
                        "id": 142064,
                        "name": "Raghunathpur",
                        "latitude": "23.55000000",
                        "longitude": "86.67000000"
                    },
                    {
                        "id": 142065,
                        "name": "Raiganj",
                        "latitude": "25.61666667",
                        "longitude": "88.11666667"
                    },
                    {
                        "id": 142066,
                        "name": "Rajmahal",
                        "latitude": "25.05000000",
                        "longitude": "87.84000000"
                    },
                    {
                        "id": 142067,
                        "name": "Rajnagar community development block",
                        "latitude": "23.94720000",
                        "longitude": "87.36250000"
                    },
                    {
                        "id": 142068,
                        "name": "Ramchandrapur",
                        "latitude": "22.90000000",
                        "longitude": "88.48000000"
                    },
                    {
                        "id": 142069,
                        "name": "Ramjibanpur",
                        "latitude": "22.83000000",
                        "longitude": "87.62000000"
                    },
                    {
                        "id": 142075,
                        "name": "Ramnagar",
                        "latitude": "22.77778000",
                        "longitude": "88.24639000"
                    },
                    {
                        "id": 142070,
                        "name": "Rampur Hat",
                        "latitude": "24.17737000",
                        "longitude": "87.78275000"
                    },
                    {
                        "id": 142071,
                        "name": "Ranaghat",
                        "latitude": "23.18000000",
                        "longitude": "88.58000000"
                    },
                    {
                        "id": 142072,
                        "name": "Raniganj",
                        "latitude": "23.62000000",
                        "longitude": "87.13000000"
                    },
                    {
                        "id": 142073,
                        "name": "Raypur",
                        "latitude": "22.41083000",
                        "longitude": "88.50944000"
                    },
                    {
                        "id": 142074,
                        "name": "Rishra",
                        "latitude": "22.71000000",
                        "longitude": "88.35000000"
                    },
                    {
                        "id": 142076,
                        "name": "Sahapur",
                        "latitude": "22.52000000",
                        "longitude": "88.17000000"
                    },
                    {
                        "id": 142077,
                        "name": "Sainthia",
                        "latitude": "23.95000000",
                        "longitude": "87.67000000"
                    },
                    {
                        "id": 142078,
                        "name": "Salanpur community development block",
                        "latitude": "23.76702000",
                        "longitude": "86.87492000"
                    },
                    {
                        "id": 142079,
                        "name": "Sankarpur",
                        "latitude": "23.60000000",
                        "longitude": "87.20000000"
                    },
                    {
                        "id": 142080,
                        "name": "Sankrail",
                        "latitude": "22.57000000",
                        "longitude": "88.24000000"
                    },
                    {
                        "id": 142081,
                        "name": "Santipur",
                        "latitude": "23.25000000",
                        "longitude": "88.43000000"
                    },
                    {
                        "id": 142082,
                        "name": "Santoshpur",
                        "latitude": "22.50000000",
                        "longitude": "88.17000000"
                    },
                    {
                        "id": 142083,
                        "name": "Santuri community development block",
                        "latitude": "23.52720000",
                        "longitude": "86.85709000"
                    },
                    {
                        "id": 142084,
                        "name": "Sarenga",
                        "latitude": "22.54000000",
                        "longitude": "88.21000000"
                    },
                    {
                        "id": 142085,
                        "name": "Serampore",
                        "latitude": "22.75000000",
                        "longitude": "88.34000000"
                    },
                    {
                        "id": 142086,
                        "name": "Serpur",
                        "latitude": "24.13000000",
                        "longitude": "88.00000000"
                    },
                    {
                        "id": 142087,
                        "name": "Shyamnagar West Bengal",
                        "latitude": "22.83000000",
                        "longitude": "88.37000000"
                    },
                    {
                        "id": 142088,
                        "name": "Siliguri",
                        "latitude": "26.71004000",
                        "longitude": "88.42851000"
                    },
                    {
                        "id": 142089,
                        "name": "Singur",
                        "latitude": "22.81000000",
                        "longitude": "88.23000000"
                    },
                    {
                        "id": 142090,
                        "name": "Sodpur",
                        "latitude": "22.70416667",
                        "longitude": "88.39166667"
                    },
                    {
                        "id": 142091,
                        "name": "Solap",
                        "latitude": "22.12777778",
                        "longitude": "88.15861111"
                    },
                    {
                        "id": 142092,
                        "name": "Sonada",
                        "latitude": "27.00000000",
                        "longitude": "88.14000000"
                    },
                    {
                        "id": 142093,
                        "name": "Sonamukhi",
                        "latitude": "23.30000000",
                        "longitude": "87.42000000"
                    },
                    {
                        "id": 142094,
                        "name": "Sonarpur community development block",
                        "latitude": "22.44259000",
                        "longitude": "88.43044000"
                    },
                    {
                        "id": 142095,
                        "name": "South 24 Parganas district",
                        "latitude": "22.16197000",
                        "longitude": "88.43170000"
                    },
                    {
                        "id": 142096,
                        "name": "Srikhanda",
                        "latitude": "23.60000000",
                        "longitude": "88.08330000"
                    },
                    {
                        "id": 142097,
                        "name": "Srirampur",
                        "latitude": "23.35000000",
                        "longitude": "88.12000000"
                    },
                    {
                        "id": 142098,
                        "name": "Suri",
                        "latitude": "23.91666667",
                        "longitude": "87.53333333"
                    },
                    {
                        "id": 142099,
                        "name": "Swarupnagar community development block",
                        "latitude": "22.83330000",
                        "longitude": "88.86670000"
                    },
                    {
                        "id": 142100,
                        "name": "Takdah",
                        "latitude": "27.03330000",
                        "longitude": "88.36670000"
                    },
                    {
                        "id": 142101,
                        "name": "Taki",
                        "latitude": "22.59000000",
                        "longitude": "88.92000000"
                    },
                    {
                        "id": 142102,
                        "name": "Tamluk",
                        "latitude": "22.30000000",
                        "longitude": "87.91666667"
                    },
                    {
                        "id": 142103,
                        "name": "Tarakeswar",
                        "latitude": "22.89000000",
                        "longitude": "88.02000000"
                    },
                    {
                        "id": 142104,
                        "name": "Titagarh",
                        "latitude": "22.74000000",
                        "longitude": "88.37000000"
                    },
                    {
                        "id": 142105,
                        "name": "Tufanganj",
                        "latitude": "26.32000000",
                        "longitude": "89.67000000"
                    },
                    {
                        "id": 142106,
                        "name": "Tulin",
                        "latitude": "23.37000000",
                        "longitude": "85.90000000"
                    },
                    {
                        "id": 142107,
                        "name": "Uchalan",
                        "latitude": "23.03330000",
                        "longitude": "87.78330000"
                    },
                    {
                        "id": 142108,
                        "name": "Ula",
                        "latitude": "22.72250000",
                        "longitude": "88.55556000"
                    },
                    {
                        "id": 142109,
                        "name": "Uluberia",
                        "latitude": "22.47000000",
                        "longitude": "88.11000000"
                    },
                    {
                        "id": 142110,
                        "name": "Uttar Dinajpur district",
                        "latitude": "25.62000000",
                        "longitude": "88.12000000"
                    },
                    {
                        "id": 142111,
                        "name": "Uttarpara Kotrung",
                        "latitude": "22.67000000",
                        "longitude": "88.35000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 102,
        "name": "Indonesia",
        "iso3": "IDN",
        "iso2": "ID",
        "numeric_code": "360",
        "phonecode": "62",
        "capital": "Jakarta",
        "currency": "IDR",
        "currency_name": "Indonesian rupiah",
        "currency_symbol": "Rp",
        "tld": ".id",
        "native": "Indonesia",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Indonesian",
        "timezones": [
            {
                "zoneName": "Asia\/Jakarta",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "WIB",
                "tzName": "Western Indonesian Time"
            },
            {
                "zoneName": "Asia\/Jayapura",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "WIT",
                "tzName": "Eastern Indonesian Time"
            },
            {
                "zoneName": "Asia\/Makassar",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "WITA",
                "tzName": "Central Indonesia Time"
            },
            {
                "zoneName": "Asia\/Pontianak",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "WIB",
                "tzName": "Western Indonesian Time"
            }
        ],
        "translations": {
            "br": "Indonezia",
            "ko": "인도네시아",
            "pt-BR": "Indonésia",
            "pt": "Indonésia",
            "nl": "Indonesië",
            "hr": "Indonezija",
            "fa": "اندونزی",
            "de": "Indonesien",
            "es": "Indonesia",
            "fr": "Indonésie",
            "ja": "インドネシア",
            "it": "Indonesia",
            "zh-CN": "印度尼西亚",
            "tr": "Endonezya",
            "ru": "Индонезия",
            "uk": "Індонезія",
            "pl": "Indonezja"
        },
        "latitude": "-5.00000000",
        "longitude": "120.00000000",
        "emoji": "🇮🇩",
        "emojiU": "U+1F1EE U+1F1E9",
        "states": [
            {
                "id": 1822,
                "name": "Aceh",
                "iso2": "AC",
                "latitude": "4.69513500",
                "longitude": "96.74939930",
                "type": "province",
                "cities": [
                    {
                        "id": 56193,
                        "name": "Banda Aceh",
                        "latitude": "5.54167000",
                        "longitude": "95.33333000"
                    },
                    {
                        "id": 56223,
                        "name": "Bireun",
                        "latitude": "5.20300000",
                        "longitude": "96.70090000"
                    },
                    {
                        "id": 56307,
                        "name": "Kabupaten Aceh Barat",
                        "latitude": "4.45000000",
                        "longitude": "96.16667000"
                    },
                    {
                        "id": 56308,
                        "name": "Kabupaten Aceh Barat Daya",
                        "latitude": "3.83333000",
                        "longitude": "96.88333000"
                    },
                    {
                        "id": 56309,
                        "name": "Kabupaten Aceh Besar",
                        "latitude": "5.38333000",
                        "longitude": "95.51667000"
                    },
                    {
                        "id": 56310,
                        "name": "Kabupaten Aceh Jaya",
                        "latitude": "4.86000000",
                        "longitude": "95.64000000"
                    },
                    {
                        "id": 56311,
                        "name": "Kabupaten Aceh Selatan",
                        "latitude": "3.16667000",
                        "longitude": "97.41667000"
                    },
                    {
                        "id": 56312,
                        "name": "Kabupaten Aceh Singkil",
                        "latitude": "2.41667000",
                        "longitude": "97.91667000"
                    },
                    {
                        "id": 56313,
                        "name": "Kabupaten Aceh Tamiang",
                        "latitude": "4.25000000",
                        "longitude": "97.96667000"
                    },
                    {
                        "id": 56314,
                        "name": "Kabupaten Aceh Tengah",
                        "latitude": "4.51000000",
                        "longitude": "96.85500000"
                    },
                    {
                        "id": 56315,
                        "name": "Kabupaten Aceh Tenggara",
                        "latitude": "3.36667000",
                        "longitude": "97.70000000"
                    },
                    {
                        "id": 56316,
                        "name": "Kabupaten Aceh Timur",
                        "latitude": "4.63333000",
                        "longitude": "97.63333000"
                    },
                    {
                        "id": 56317,
                        "name": "Kabupaten Aceh Utara",
                        "latitude": "4.97000000",
                        "longitude": "97.14000000"
                    },
                    {
                        "id": 56353,
                        "name": "Kabupaten Bener Meriah",
                        "latitude": "4.73015000",
                        "longitude": "96.86156000"
                    },
                    {
                        "id": 56362,
                        "name": "Kabupaten Bireuen",
                        "latitude": "5.08333000",
                        "longitude": "96.58333000"
                    },
                    {
                        "id": 56408,
                        "name": "Kabupaten Gayo Lues",
                        "latitude": "3.95000000",
                        "longitude": "97.39000000"
                    },
                    {
                        "id": 56552,
                        "name": "Kabupaten Nagan Raya",
                        "latitude": "4.16667000",
                        "longitude": "96.51667000"
                    },
                    {
                        "id": 56593,
                        "name": "Kabupaten Pidie",
                        "latitude": "5.08000000",
                        "longitude": "96.11000000"
                    },
                    {
                        "id": 56634,
                        "name": "Kabupaten Simeulue",
                        "latitude": "2.61667000",
                        "longitude": "96.08333000"
                    },
                    {
                        "id": 56837,
                        "name": "Langsa",
                        "latitude": "4.46830000",
                        "longitude": "97.96830000"
                    },
                    {
                        "id": 56844,
                        "name": "Lhokseumawe",
                        "latitude": "5.18010000",
                        "longitude": "97.15070000"
                    },
                    {
                        "id": 56872,
                        "name": "Meulaboh",
                        "latitude": "4.14402000",
                        "longitude": "96.12664000"
                    },
                    {
                        "id": 56955,
                        "name": "Reuleuet",
                        "latitude": "5.21667000",
                        "longitude": "96.28333000"
                    },
                    {
                        "id": 56957,
                        "name": "Sabang",
                        "latitude": "5.88969000",
                        "longitude": "95.31644000"
                    },
                    {
                        "id": 56976,
                        "name": "Sigli",
                        "latitude": "5.38480000",
                        "longitude": "95.96090000"
                    },
                    {
                        "id": 56979,
                        "name": "Sinabang",
                        "latitude": "2.48030000",
                        "longitude": "96.38010000"
                    },
                    {
                        "id": 56982,
                        "name": "Singkil",
                        "latitude": "2.28740000",
                        "longitude": "97.78840000"
                    }
                ]
            },
            {
                "id": 1826,
                "name": "Bali",
                "iso2": "BA",
                "latitude": "-8.34053890",
                "longitude": "115.09195090",
                "type": "province",
                "cities": [
                    {
                        "id": 56179,
                        "name": "Amlapura",
                        "latitude": "-8.45000000",
                        "longitude": "115.61667000"
                    },
                    {
                        "id": 56180,
                        "name": "Amlapura city",
                        "latitude": "-8.44869000",
                        "longitude": "115.60621000"
                    },
                    {
                        "id": 56200,
                        "name": "Banjar",
                        "latitude": "-8.19000000",
                        "longitude": "114.96750000"
                    },
                    {
                        "id": 56201,
                        "name": "Banjar Wangsian",
                        "latitude": "-8.49497000",
                        "longitude": "115.42342000"
                    },
                    {
                        "id": 56213,
                        "name": "Bedugul",
                        "latitude": "-8.45040000",
                        "longitude": "115.59250000"
                    },
                    {
                        "id": 56263,
                        "name": "Denpasar",
                        "latitude": "-8.65000000",
                        "longitude": "115.21667000"
                    },
                    {
                        "id": 56302,
                        "name": "Jimbaran",
                        "latitude": "-8.79093000",
                        "longitude": "115.16006000"
                    },
                    {
                        "id": 56322,
                        "name": "Kabupaten Badung",
                        "latitude": "-8.51667000",
                        "longitude": "115.20000000"
                    },
                    {
                        "id": 56334,
                        "name": "Kabupaten Bangli",
                        "latitude": "-8.28333000",
                        "longitude": "115.35000000"
                    },
                    {
                        "id": 56379,
                        "name": "Kabupaten Buleleng",
                        "latitude": "-8.25000000",
                        "longitude": "114.96667000"
                    },
                    {
                        "id": 56409,
                        "name": "Kabupaten Gianyar",
                        "latitude": "-8.46667000",
                        "longitude": "115.28333000"
                    },
                    {
                        "id": 56431,
                        "name": "Kabupaten Jembrana",
                        "latitude": "-8.30000000",
                        "longitude": "114.66667000"
                    },
                    {
                        "id": 56438,
                        "name": "Kabupaten Karang Asem",
                        "latitude": "-8.38910000",
                        "longitude": "115.53930000"
                    },
                    {
                        "id": 56460,
                        "name": "Kabupaten Klungkung",
                        "latitude": "-8.55000000",
                        "longitude": "115.40000000"
                    },
                    {
                        "id": 56658,
                        "name": "Kabupaten Tabanan",
                        "latitude": "-8.43333000",
                        "longitude": "115.06667000"
                    },
                    {
                        "id": 56720,
                        "name": "Klungkung",
                        "latitude": "-8.53333000",
                        "longitude": "115.40000000"
                    },
                    {
                        "id": 56827,
                        "name": "Kuta",
                        "latitude": "-8.72332000",
                        "longitude": "115.17234000"
                    },
                    {
                        "id": 56841,
                        "name": "Legian",
                        "latitude": "-8.70415000",
                        "longitude": "115.17028000"
                    },
                    {
                        "id": 56846,
                        "name": "Lovina",
                        "latitude": "-8.14927000",
                        "longitude": "115.03999000"
                    },
                    {
                        "id": 56879,
                        "name": "Munduk",
                        "latitude": "-8.26866000",
                        "longitude": "115.07947000"
                    },
                    {
                        "id": 56884,
                        "name": "Negara",
                        "latitude": "-8.35694000",
                        "longitude": "114.61694000"
                    },
                    {
                        "id": 56890,
                        "name": "Nusa Dua",
                        "latitude": "-8.80047000",
                        "longitude": "115.23341000"
                    },
                    {
                        "id": 56970,
                        "name": "Seririt",
                        "latitude": "-8.19280000",
                        "longitude": "114.93880000"
                    },
                    {
                        "id": 56981,
                        "name": "Singaraja",
                        "latitude": "-8.11200000",
                        "longitude": "115.08818000"
                    },
                    {
                        "id": 57013,
                        "name": "Tabanan",
                        "latitude": "-8.54130000",
                        "longitude": "115.12522000"
                    },
                    {
                        "id": 57046,
                        "name": "Ubud",
                        "latitude": "-8.50980000",
                        "longitude": "115.26540000"
                    }
                ]
            },
            {
                "id": 1810,
                "name": "Banten",
                "iso2": "BT",
                "latitude": "-6.40581720",
                "longitude": "106.06401790",
                "type": "province",
                "cities": [
                    {
                        "id": 56491,
                        "name": "Kabupaten Lebak",
                        "latitude": "-6.65000000",
                        "longitude": "106.21667000"
                    },
                    {
                        "id": 56574,
                        "name": "Kabupaten Pandeglang",
                        "latitude": "-6.63333000",
                        "longitude": "105.75000000"
                    },
                    {
                        "id": 56623,
                        "name": "Kabupaten Serang",
                        "latitude": "-6.15000000",
                        "longitude": "106.00000000"
                    },
                    {
                        "id": 56666,
                        "name": "Kabupaten Tangerang",
                        "latitude": "-6.20000000",
                        "longitude": "106.46667000"
                    },
                    {
                        "id": 56257,
                        "name": "Kota Cilegon",
                        "latitude": "-5.96849850",
                        "longitude": "105.92142320"
                    },
                    {
                        "id": 56969,
                        "name": "Kota Serang",
                        "latitude": "-6.11528000",
                        "longitude": "106.15417000"
                    },
                    {
                        "id": 57014,
                        "name": "Kota Tangerang",
                        "latitude": "-6.17806000",
                        "longitude": "106.63000000"
                    },
                    {
                        "id": 56996,
                        "name": "Kota Tangerang Selatan",
                        "latitude": "-6.28862000",
                        "longitude": "106.71789000"
                    }
                ]
            },
            {
                "id": 1793,
                "name": "Bengkulu",
                "iso2": "BE",
                "latitude": "-3.79284510",
                "longitude": "102.26076410",
                "type": "province",
                "cities": [
                    {
                        "id": 56217,
                        "name": "Bengkulu",
                        "latitude": "-3.80044000",
                        "longitude": "102.26554000"
                    },
                    {
                        "id": 56258,
                        "name": "Curup",
                        "latitude": "-3.47030000",
                        "longitude": "102.52070000"
                    },
                    {
                        "id": 56355,
                        "name": "Kabupaten Bengkulu Selatan",
                        "latitude": "-4.35000000",
                        "longitude": "103.03333000"
                    },
                    {
                        "id": 56356,
                        "name": "Kabupaten Bengkulu Tengah",
                        "latitude": "-3.20679000",
                        "longitude": "102.12616000"
                    },
                    {
                        "id": 56357,
                        "name": "Kabupaten Bengkulu Utara",
                        "latitude": "-3.33333000",
                        "longitude": "102.05000000"
                    },
                    {
                        "id": 56444,
                        "name": "Kabupaten Kaur",
                        "latitude": "-4.78179000",
                        "longitude": "103.36109000"
                    },
                    {
                        "id": 56449,
                        "name": "Kabupaten Kepahiang",
                        "latitude": "-3.60194000",
                        "longitude": "102.56424000"
                    },
                    {
                        "id": 56492,
                        "name": "Kabupaten Lebong",
                        "latitude": "-3.24278000",
                        "longitude": "102.33490000"
                    },
                    {
                        "id": 56544,
                        "name": "Kabupaten Mukomuko",
                        "latitude": "-3.07438000",
                        "longitude": "101.54766000"
                    },
                    {
                        "id": 56609,
                        "name": "Kabupaten Rejang Lebong",
                        "latitude": "-3.43333000",
                        "longitude": "102.71667000"
                    },
                    {
                        "id": 56619,
                        "name": "Kabupaten Seluma",
                        "latitude": "-3.96644000",
                        "longitude": "102.47429000"
                    }
                ]
            },
            {
                "id": 1829,
                "name": "DI Yogyakarta",
                "iso2": "YO",
                "latitude": "-7.87538490",
                "longitude": "110.42620880",
                "type": "Special region",
                "cities": [
                    {
                        "id": 56338,
                        "name": "Kabupaten Bantul",
                        "latitude": "-7.90000000",
                        "longitude": "110.36667000"
                    },
                    {
                        "id": 56414,
                        "name": "Kabupaten Gunung Kidul",
                        "latitude": "-7.98333000",
                        "longitude": "110.61667000"
                    },
                    {
                        "id": 56473,
                        "name": "Kabupaten Kulon Progo",
                        "latitude": "-7.64500000",
                        "longitude": "110.02694000"
                    },
                    {
                        "id": 56637,
                        "name": "Kabupaten Sleman",
                        "latitude": "-7.68167000",
                        "longitude": "110.32333000"
                    },
                    {
                        "id": 57061,
                        "name": "Yogyakarta",
                        "latitude": "-7.80139000",
                        "longitude": "110.36472000"
                    }
                ]
            },
            {
                "id": 1805,
                "name": "DKI Jakarta",
                "iso2": "JK",
                "latitude": "-6.20876340",
                "longitude": "106.84559900",
                "type": "capital district",
                "cities": [
                    {
                        "id": 154474,
                        "name": "Jakarta Barat",
                        "latitude": "-6.15999160",
                        "longitude": "106.67485740"
                    },
                    {
                        "id": 154470,
                        "name": "Jakarta Pusat",
                        "latitude": "-6.18222610",
                        "longitude": "106.79526480"
                    },
                    {
                        "id": 154471,
                        "name": "Jakarta Selatan",
                        "latitude": "-6.28392950",
                        "longitude": "106.71967730"
                    },
                    {
                        "id": 154473,
                        "name": "Jakarta Timur",
                        "latitude": "-6.26097100",
                        "longitude": "106.82261800"
                    },
                    {
                        "id": 154472,
                        "name": "Jakarta Utara",
                        "latitude": "-6.13570900",
                        "longitude": "106.75949840"
                    }
                ]
            },
            {
                "id": 1812,
                "name": "Gorontalo",
                "iso2": "GO",
                "latitude": "0.54354420",
                "longitude": "123.05676930",
                "type": "province",
                "cities": [
                    {
                        "id": 56285,
                        "name": "Gorontalo",
                        "latitude": "0.53750000",
                        "longitude": "123.06250000"
                    },
                    {
                        "id": 56365,
                        "name": "Kabupaten Boalemo",
                        "latitude": "0.62689000",
                        "longitude": "122.35680000"
                    },
                    {
                        "id": 56375,
                        "name": "Kabupaten Bone Bolango",
                        "latitude": "0.50296000",
                        "longitude": "123.27501000"
                    },
                    {
                        "id": 56410,
                        "name": "Kabupaten Gorontalo",
                        "latitude": "0.57280000",
                        "longitude": "122.23370000"
                    },
                    {
                        "id": 56411,
                        "name": "Kabupaten Gorontalo Utara",
                        "latitude": "0.77000000",
                        "longitude": "122.31667000"
                    },
                    {
                        "id": 56595,
                        "name": "Kabupaten Pohuwato",
                        "latitude": "0.70980000",
                        "longitude": "121.59582000"
                    }
                ]
            },
            {
                "id": 1815,
                "name": "Jambi",
                "iso2": "JA",
                "latitude": "-1.61012290",
                "longitude": "103.61312030",
                "type": "province",
                "cities": [
                    {
                        "id": 56214,
                        "name": "Bejubang Dua",
                        "latitude": "-1.79230000",
                        "longitude": "103.31670000"
                    },
                    {
                        "id": 56294,
                        "name": "Jambi City",
                        "latitude": "-1.60000000",
                        "longitude": "103.61667000"
                    },
                    {
                        "id": 56347,
                        "name": "Kabupaten Batang Hari",
                        "latitude": "-1.75000000",
                        "longitude": "103.11667000"
                    },
                    {
                        "id": 56382,
                        "name": "Kabupaten Bungo",
                        "latitude": "-1.50222000",
                        "longitude": "101.96000000"
                    },
                    {
                        "id": 56458,
                        "name": "Kabupaten Kerinci",
                        "latitude": "-2.03333000",
                        "longitude": "101.53333000"
                    },
                    {
                        "id": 56532,
                        "name": "Kabupaten Merangin",
                        "latitude": "-2.06933000",
                        "longitude": "102.13303000"
                    },
                    {
                        "id": 56543,
                        "name": "Kabupaten Muaro Jambi",
                        "latitude": "-1.55214000",
                        "longitude": "103.82163000"
                    },
                    {
                        "id": 56618,
                        "name": "Kabupaten Sarolangun",
                        "latitude": "-2.30000000",
                        "longitude": "102.65000000"
                    },
                    {
                        "id": 56668,
                        "name": "Kabupaten Tanjung Jabung Barat",
                        "latitude": "-1.15440000",
                        "longitude": "103.24402000"
                    },
                    {
                        "id": 56669,
                        "name": "Kabupaten Tanjung Jabung Timur",
                        "latitude": "-1.13198000",
                        "longitude": "103.61755000"
                    },
                    {
                        "id": 56675,
                        "name": "Kabupaten Tebo",
                        "latitude": "-1.45576000",
                        "longitude": "102.37473000"
                    },
                    {
                        "id": 56822,
                        "name": "Kuala Tungkal",
                        "latitude": "-0.81623000",
                        "longitude": "103.46111000"
                    },
                    {
                        "id": 56869,
                        "name": "Mendaha",
                        "latitude": "-1.01630000",
                        "longitude": "103.59331000"
                    },
                    {
                        "id": 56978,
                        "name": "Simpang",
                        "latitude": "-1.26424000",
                        "longitude": "104.09701000"
                    },
                    {
                        "id": 57008,
                        "name": "Sungai Penuh",
                        "latitude": "-2.05610000",
                        "longitude": "101.39130000"
                    }
                ]
            },
            {
                "id": 1825,
                "name": "Jawa Barat",
                "iso2": "JB",
                "latitude": "-7.09091100",
                "longitude": "107.66888700",
                "type": "province",
                "cities": [
                    {
                        "id": 56182,
                        "name": "Arjawinangun",
                        "latitude": "-6.64528000",
                        "longitude": "108.41028000"
                    },
                    {
                        "id": 56183,
                        "name": "Astanajapura",
                        "latitude": "-6.80170000",
                        "longitude": "108.63110000"
                    },
                    {
                        "id": 56196,
                        "name": "Bandung",
                        "latitude": "-6.92222000",
                        "longitude": "107.60694000"
                    },
                    {
                        "id": 56199,
                        "name": "Banjar",
                        "latitude": "-7.19550000",
                        "longitude": "107.43130000"
                    },
                    {
                        "id": 56202,
                        "name": "Banjaran",
                        "latitude": "-7.04528000",
                        "longitude": "107.58778000"
                    },
                    {
                        "id": 56215,
                        "name": "Bekasi",
                        "latitude": "-6.23490000",
                        "longitude": "106.98960000"
                    },
                    {
                        "id": 56226,
                        "name": "Bogor",
                        "latitude": "-6.59444000",
                        "longitude": "106.78917000"
                    },
                    {
                        "id": 56237,
                        "name": "Caringin",
                        "latitude": "-6.70611000",
                        "longitude": "106.82139000"
                    },
                    {
                        "id": 56240,
                        "name": "Ciamis",
                        "latitude": "-7.32570000",
                        "longitude": "108.35340000"
                    },
                    {
                        "id": 56241,
                        "name": "Ciampea",
                        "latitude": "-6.55472000",
                        "longitude": "106.70083000"
                    },
                    {
                        "id": 56242,
                        "name": "Cibinong",
                        "latitude": "-6.48167000",
                        "longitude": "106.85417000"
                    },
                    {
                        "id": 56243,
                        "name": "Cicurug",
                        "latitude": "-6.78139000",
                        "longitude": "106.78250000"
                    },
                    {
                        "id": 56244,
                        "name": "Cikampek",
                        "latitude": "-6.41972000",
                        "longitude": "107.45583000"
                    },
                    {
                        "id": 56245,
                        "name": "Cikarang",
                        "latitude": "-6.26111000",
                        "longitude": "107.15278000"
                    },
                    {
                        "id": 56246,
                        "name": "Cikupa",
                        "latitude": "-6.23639000",
                        "longitude": "106.50833000"
                    },
                    {
                        "id": 56247,
                        "name": "Cileungsir",
                        "latitude": "-6.39472000",
                        "longitude": "106.95917000"
                    },
                    {
                        "id": 56248,
                        "name": "Cileunyi",
                        "latitude": "-6.93889000",
                        "longitude": "107.75278000"
                    },
                    {
                        "id": 56249,
                        "name": "Cimahi",
                        "latitude": "-6.87222000",
                        "longitude": "107.54250000"
                    },
                    {
                        "id": 56250,
                        "name": "Ciputat",
                        "latitude": "-6.23750000",
                        "longitude": "106.69556000"
                    },
                    {
                        "id": 56251,
                        "name": "Ciranjang-hilir",
                        "latitude": "-6.82000000",
                        "longitude": "107.25722000"
                    },
                    {
                        "id": 56252,
                        "name": "Cirebon",
                        "latitude": "-6.70630000",
                        "longitude": "108.55700000"
                    },
                    {
                        "id": 56253,
                        "name": "Citeureup",
                        "latitude": "-6.48556000",
                        "longitude": "106.88194000"
                    },
                    {
                        "id": 56265,
                        "name": "Depok",
                        "latitude": "-6.40000000",
                        "longitude": "106.81861000"
                    },
                    {
                        "id": 56291,
                        "name": "Indramayu",
                        "latitude": "-6.32639000",
                        "longitude": "108.32000000"
                    },
                    {
                        "id": 56296,
                        "name": "Jatibarang",
                        "latitude": "-6.47472000",
                        "longitude": "108.31528000"
                    },
                    {
                        "id": 56298,
                        "name": "Jatiwangi",
                        "latitude": "-6.73361000",
                        "longitude": "108.26278000"
                    },
                    {
                        "id": 56324,
                        "name": "Kabupaten Bandung",
                        "latitude": "-7.10000000",
                        "longitude": "107.60000000"
                    },
                    {
                        "id": 56325,
                        "name": "Kabupaten Bandung Barat",
                        "latitude": "-6.83333000",
                        "longitude": "107.48333000"
                    },
                    {
                        "id": 56349,
                        "name": "Kabupaten Bekasi",
                        "latitude": "-6.24667000",
                        "longitude": "107.10833000"
                    },
                    {
                        "id": 56366,
                        "name": "Kabupaten Bogor",
                        "latitude": "-6.58333000",
                        "longitude": "106.71667000"
                    },
                    {
                        "id": 56390,
                        "name": "Kabupaten Ciamis",
                        "latitude": "-7.28333000",
                        "longitude": "108.41667000"
                    },
                    {
                        "id": 56391,
                        "name": "Kabupaten Cianjur",
                        "latitude": "-6.77250000",
                        "longitude": "107.08306000"
                    },
                    {
                        "id": 56393,
                        "name": "Kabupaten Cirebon",
                        "latitude": "-6.80000000",
                        "longitude": "108.56667000"
                    },
                    {
                        "id": 56407,
                        "name": "Kabupaten Garut",
                        "latitude": "-7.38333000",
                        "longitude": "107.76667000"
                    },
                    {
                        "id": 56426,
                        "name": "Kabupaten Indramayu",
                        "latitude": "-6.45000000",
                        "longitude": "108.16667000"
                    },
                    {
                        "id": 56440,
                        "name": "Kabupaten Karawang",
                        "latitude": "-6.26667000",
                        "longitude": "107.41667000"
                    },
                    {
                        "id": 56474,
                        "name": "Kabupaten Kuningan",
                        "latitude": "-7.00000000",
                        "longitude": "108.55000000"
                    },
                    {
                        "id": 56508,
                        "name": "Kabupaten Majalengka",
                        "latitude": "-6.81667000",
                        "longitude": "108.28333000"
                    },
                    {
                        "id": 56575,
                        "name": "Kabupaten Pangandaran",
                        "latitude": "-7.66730000",
                        "longitude": "108.64037000"
                    },
                    {
                        "id": 56606,
                        "name": "Kabupaten Purwakarta",
                        "latitude": "-6.58333000",
                        "longitude": "107.45000000"
                    },
                    {
                        "id": 56644,
                        "name": "Kabupaten Subang",
                        "latitude": "-6.50833000",
                        "longitude": "107.70250000"
                    },
                    {
                        "id": 56645,
                        "name": "Kabupaten Sukabumi",
                        "latitude": "-7.06667000",
                        "longitude": "106.70000000"
                    },
                    {
                        "id": 56654,
                        "name": "Kabupaten Sumedang",
                        "latitude": "-6.81667000",
                        "longitude": "107.98333000"
                    },
                    {
                        "id": 56674,
                        "name": "Kabupaten Tasikmalaya",
                        "latitude": "-7.50000000",
                        "longitude": "108.13333000"
                    },
                    {
                        "id": 56698,
                        "name": "Karangampel",
                        "latitude": "-6.46222000",
                        "longitude": "108.45194000"
                    },
                    {
                        "id": 56700,
                        "name": "Karangsembung",
                        "latitude": "-6.84870000",
                        "longitude": "108.64220000"
                    },
                    {
                        "id": 56704,
                        "name": "Kawalu",
                        "latitude": "-7.38170000",
                        "longitude": "108.20820000"
                    },
                    {
                        "id": 56718,
                        "name": "Klangenan",
                        "latitude": "-6.70944000",
                        "longitude": "108.44000000"
                    },
                    {
                        "id": 56819,
                        "name": "Kresek",
                        "latitude": "-6.13139000",
                        "longitude": "106.37972000"
                    },
                    {
                        "id": 56825,
                        "name": "Kuningan",
                        "latitude": "-6.97583000",
                        "longitude": "108.48306000"
                    },
                    {
                        "id": 56842,
                        "name": "Lembang",
                        "latitude": "-6.81167000",
                        "longitude": "107.61750000"
                    },
                    {
                        "id": 56852,
                        "name": "Majalengka",
                        "latitude": "-6.83611000",
                        "longitude": "108.22778000"
                    },
                    {
                        "id": 56861,
                        "name": "Margahayukencana",
                        "latitude": "-6.97083000",
                        "longitude": "107.56750000"
                    },
                    {
                        "id": 56886,
                        "name": "Ngawi",
                        "latitude": "-7.40380000",
                        "longitude": "111.44610000"
                    },
                    {
                        "id": 56892,
                        "name": "Padalarang",
                        "latitude": "-6.83778000",
                        "longitude": "107.47278000"
                    },
                    {
                        "id": 56899,
                        "name": "Palimanan",
                        "latitude": "-6.70694000",
                        "longitude": "108.42417000"
                    },
                    {
                        "id": 56902,
                        "name": "Pamanukan",
                        "latitude": "-6.28417000",
                        "longitude": "107.81056000"
                    },
                    {
                        "id": 56904,
                        "name": "Pameungpeuk",
                        "latitude": "-7.01833000",
                        "longitude": "107.60389000"
                    },
                    {
                        "id": 56905,
                        "name": "Pamulang",
                        "latitude": "-6.34278000",
                        "longitude": "106.73833000"
                    },
                    {
                        "id": 56918,
                        "name": "Parung",
                        "latitude": "-6.42139000",
                        "longitude": "106.73306000"
                    },
                    {
                        "id": 56919,
                        "name": "Pasarkemis",
                        "latitude": "-6.17028000",
                        "longitude": "106.53028000"
                    },
                    {
                        "id": 56920,
                        "name": "Paseh",
                        "latitude": "-7.10260000",
                        "longitude": "107.76410000"
                    },
                    {
                        "id": 56928,
                        "name": "Pelabuhanratu",
                        "latitude": "-6.98750000",
                        "longitude": "106.55139000"
                    },
                    {
                        "id": 56934,
                        "name": "Plumbon",
                        "latitude": "-6.70500000",
                        "longitude": "108.47278000"
                    },
                    {
                        "id": 56945,
                        "name": "Purwakarta",
                        "latitude": "-6.55694000",
                        "longitude": "107.44333000"
                    },
                    {
                        "id": 56948,
                        "name": "Rajapolah",
                        "latitude": "-7.22100000",
                        "longitude": "108.18960000"
                    },
                    {
                        "id": 56954,
                        "name": "Rengasdengklok",
                        "latitude": "-6.15917000",
                        "longitude": "107.29806000"
                    },
                    {
                        "id": 56962,
                        "name": "Sawangan",
                        "latitude": "-6.40278000",
                        "longitude": "106.77444000"
                    },
                    {
                        "id": 56968,
                        "name": "Sepatan",
                        "latitude": "-6.11889000",
                        "longitude": "106.57500000"
                    },
                    {
                        "id": 56971,
                        "name": "Serpong",
                        "latitude": "-6.31694000",
                        "longitude": "106.66417000"
                    },
                    {
                        "id": 56980,
                        "name": "Singaparna",
                        "latitude": "-7.35150000",
                        "longitude": "108.11100000"
                    },
                    {
                        "id": 56994,
                        "name": "Soreang",
                        "latitude": "-7.03306000",
                        "longitude": "107.51833000"
                    },
                    {
                        "id": 57001,
                        "name": "Sukabumi",
                        "latitude": "-6.91806000",
                        "longitude": "106.92667000"
                    },
                    {
                        "id": 57003,
                        "name": "Sumber",
                        "latitude": "-6.76028000",
                        "longitude": "108.48306000"
                    },
                    {
                        "id": 57005,
                        "name": "Sumedang",
                        "latitude": "-6.85861000",
                        "longitude": "107.91639000"
                    },
                    {
                        "id": 57006,
                        "name": "Sumedang Utara",
                        "latitude": "-6.85000000",
                        "longitude": "107.91667000"
                    },
                    {
                        "id": 57025,
                        "name": "Tasikmalaya",
                        "latitude": "-7.32740000",
                        "longitude": "108.22070000"
                    },
                    {
                        "id": 57030,
                        "name": "Teluknaga",
                        "latitude": "-6.09889000",
                        "longitude": "106.63806000"
                    },
                    {
                        "id": 57050,
                        "name": "Wanaraja",
                        "latitude": "-7.17490000",
                        "longitude": "107.98080000"
                    },
                    {
                        "id": 57056,
                        "name": "Weru",
                        "latitude": "-6.71100000",
                        "longitude": "108.50370000"
                    }
                ]
            },
            {
                "id": 1802,
                "name": "Jawa Tengah",
                "iso2": "JT",
                "latitude": "-7.15097500",
                "longitude": "110.14025940",
                "type": "province",
                "cities": [
                    {
                        "id": 56174,
                        "name": "Adiwerna",
                        "latitude": "-6.93750000",
                        "longitude": "109.13250000"
                    },
                    {
                        "id": 56176,
                        "name": "Ambarawa",
                        "latitude": "-7.26333000",
                        "longitude": "110.39750000"
                    },
                    {
                        "id": 56186,
                        "name": "Baekrajan",
                        "latitude": "-6.76740000",
                        "longitude": "110.85410000"
                    },
                    {
                        "id": 56187,
                        "name": "Baki",
                        "latitude": "-7.61278000",
                        "longitude": "110.78389000"
                    },
                    {
                        "id": 56189,
                        "name": "Balapulang",
                        "latitude": "-7.04858000",
                        "longitude": "109.10056000"
                    },
                    {
                        "id": 56205,
                        "name": "Banyumas",
                        "latitude": "-7.51417000",
                        "longitude": "109.29417000"
                    },
                    {
                        "id": 56209,
                        "name": "Batang",
                        "latitude": "-6.48460000",
                        "longitude": "110.70830000"
                    },
                    {
                        "id": 56211,
                        "name": "Baturaden",
                        "latitude": "-7.30000000",
                        "longitude": "109.21667000"
                    },
                    {
                        "id": 56225,
                        "name": "Blora",
                        "latitude": "-6.96980000",
                        "longitude": "111.41860000"
                    },
                    {
                        "id": 56230,
                        "name": "Boyolali",
                        "latitude": "-7.53306000",
                        "longitude": "110.59583000"
                    },
                    {
                        "id": 56232,
                        "name": "Buaran",
                        "latitude": "-7.05000000",
                        "longitude": "109.55000000"
                    },
                    {
                        "id": 56235,
                        "name": "Bulakamba",
                        "latitude": "-6.87480000",
                        "longitude": "108.95590000"
                    },
                    {
                        "id": 56236,
                        "name": "Candi Prambanan",
                        "latitude": "-7.75000000",
                        "longitude": "110.49417000"
                    },
                    {
                        "id": 56238,
                        "name": "Ceper",
                        "latitude": "-7.67417000",
                        "longitude": "110.67889000"
                    },
                    {
                        "id": 56239,
                        "name": "Cepu",
                        "latitude": "-7.14750000",
                        "longitude": "111.59060000"
                    },
                    {
                        "id": 56255,
                        "name": "Colomadu",
                        "latitude": "-7.53333000",
                        "longitude": "110.75000000"
                    },
                    {
                        "id": 56256,
                        "name": "Comal",
                        "latitude": "-6.90530000",
                        "longitude": "109.53470000"
                    },
                    {
                        "id": 56260,
                        "name": "Delanggu",
                        "latitude": "-7.61667000",
                        "longitude": "110.68333000"
                    },
                    {
                        "id": 56262,
                        "name": "Demak",
                        "latitude": "-6.89090000",
                        "longitude": "110.63960000"
                    },
                    {
                        "id": 56269,
                        "name": "Dukuhturi",
                        "latitude": "-6.90000000",
                        "longitude": "109.08333000"
                    },
                    {
                        "id": 56277,
                        "name": "Gatak",
                        "latitude": "-7.59083000",
                        "longitude": "110.70444000"
                    },
                    {
                        "id": 56278,
                        "name": "Gebog",
                        "latitude": "-6.73500000",
                        "longitude": "110.84440000"
                    },
                    {
                        "id": 56283,
                        "name": "Gombong",
                        "latitude": "-7.60722000",
                        "longitude": "109.51417000"
                    },
                    {
                        "id": 56288,
                        "name": "Grogol",
                        "latitude": "-7.60111000",
                        "longitude": "110.81861000"
                    },
                    {
                        "id": 56289,
                        "name": "Gunung Kendil",
                        "latitude": "-7.33167000",
                        "longitude": "110.40417000"
                    },
                    {
                        "id": 56295,
                        "name": "Jaten",
                        "latitude": "-7.57722000",
                        "longitude": "110.89750000"
                    },
                    {
                        "id": 56297,
                        "name": "Jatiroto",
                        "latitude": "-7.88333000",
                        "longitude": "111.11667000"
                    },
                    {
                        "id": 56300,
                        "name": "Jekulo",
                        "latitude": "-6.80570000",
                        "longitude": "110.92620000"
                    },
                    {
                        "id": 56303,
                        "name": "Jogonalan",
                        "latitude": "-7.70361000",
                        "longitude": "110.53611000"
                    },
                    {
                        "id": 56305,
                        "name": "Juwana",
                        "latitude": "-6.71500000",
                        "longitude": "111.15140000"
                    },
                    {
                        "id": 56336,
                        "name": "Kabupaten Banjarnegara",
                        "latitude": "-7.35111000",
                        "longitude": "109.58750000"
                    },
                    {
                        "id": 56339,
                        "name": "Kabupaten Banyumas",
                        "latitude": "-7.45000000",
                        "longitude": "109.16667000"
                    },
                    {
                        "id": 56346,
                        "name": "Kabupaten Batang",
                        "latitude": "-7.03333000",
                        "longitude": "109.88333000"
                    },
                    {
                        "id": 56364,
                        "name": "Kabupaten Blora",
                        "latitude": "-7.06667000",
                        "longitude": "111.38333000"
                    },
                    {
                        "id": 56377,
                        "name": "Kabupaten Boyolali",
                        "latitude": "-7.50000000",
                        "longitude": "110.70000000"
                    },
                    {
                        "id": 56378,
                        "name": "Kabupaten Brebes",
                        "latitude": "-7.05000000",
                        "longitude": "108.90000000"
                    },
                    {
                        "id": 56392,
                        "name": "Kabupaten Cilacap",
                        "latitude": "-7.57417000",
                        "longitude": "108.98861000"
                    },
                    {
                        "id": 56397,
                        "name": "Kabupaten Demak",
                        "latitude": "-6.89930000",
                        "longitude": "110.61220000"
                    },
                    {
                        "id": 56413,
                        "name": "Kabupaten Grobogan",
                        "latitude": "-7.11667000",
                        "longitude": "110.91667000"
                    },
                    {
                        "id": 56433,
                        "name": "Kabupaten Jepara",
                        "latitude": "-6.58333000",
                        "longitude": "110.76667000"
                    },
                    {
                        "id": 56439,
                        "name": "Kabupaten Karanganyar",
                        "latitude": "-7.62806000",
                        "longitude": "111.06250000"
                    },
                    {
                        "id": 56445,
                        "name": "Kabupaten Kebumen",
                        "latitude": "-7.63917000",
                        "longitude": "109.66056000"
                    },
                    {
                        "id": 56448,
                        "name": "Kabupaten Kendal",
                        "latitude": "-7.02560000",
                        "longitude": "110.16850000"
                    },
                    {
                        "id": 56459,
                        "name": "Kabupaten Klaten",
                        "latitude": "-7.68333000",
                        "longitude": "110.61667000"
                    },
                    {
                        "id": 56472,
                        "name": "Kabupaten Kudus",
                        "latitude": "-6.80000000",
                        "longitude": "110.86667000"
                    },
                    {
                        "id": 56505,
                        "name": "Kabupaten Magelang",
                        "latitude": "-7.42750000",
                        "longitude": "110.16194000"
                    },
                    {
                        "id": 56583,
                        "name": "Kabupaten Pati",
                        "latitude": "-6.76667000",
                        "longitude": "111.10000000"
                    },
                    {
                        "id": 56585,
                        "name": "Kabupaten Pekalongan",
                        "latitude": "-7.03190000",
                        "longitude": "109.62400000"
                    },
                    {
                        "id": 56587,
                        "name": "Kabupaten Pemalang",
                        "latitude": "-7.03333000",
                        "longitude": "109.40000000"
                    },
                    {
                        "id": 56605,
                        "name": "Kabupaten Purbalingga",
                        "latitude": "-7.28417000",
                        "longitude": "109.35028000"
                    },
                    {
                        "id": 56607,
                        "name": "Kabupaten Purworejo",
                        "latitude": "-7.70000000",
                        "longitude": "109.96667000"
                    },
                    {
                        "id": 56610,
                        "name": "Kabupaten Rembang",
                        "latitude": "-6.78333000",
                        "longitude": "111.46667000"
                    },
                    {
                        "id": 56620,
                        "name": "Kabupaten Semarang",
                        "latitude": "-7.20667000",
                        "longitude": "110.44139000"
                    },
                    {
                        "id": 56643,
                        "name": "Kabupaten Sragen",
                        "latitude": "-7.41278000",
                        "longitude": "110.93500000"
                    },
                    {
                        "id": 56647,
                        "name": "Kabupaten Sukoharjo",
                        "latitude": "-7.68333000",
                        "longitude": "110.83333000"
                    },
                    {
                        "id": 56676,
                        "name": "Kabupaten Tegal",
                        "latitude": "-7.03333000",
                        "longitude": "109.16667000"
                    },
                    {
                        "id": 56679,
                        "name": "Kabupaten Temanggung",
                        "latitude": "-7.25000000",
                        "longitude": "110.11667000"
                    },
                    {
                        "id": 56692,
                        "name": "Kabupaten Wonogiri",
                        "latitude": "-7.91667000",
                        "longitude": "111.00000000"
                    },
                    {
                        "id": 56693,
                        "name": "Kabupaten Wonosobo",
                        "latitude": "-7.36139000",
                        "longitude": "109.92667000"
                    },
                    {
                        "id": 56699,
                        "name": "Karanganom",
                        "latitude": "-7.64889000",
                        "longitude": "110.62500000"
                    },
                    {
                        "id": 56701,
                        "name": "Kartasura",
                        "latitude": "-7.55194000",
                        "longitude": "110.73778000"
                    },
                    {
                        "id": 56706,
                        "name": "Kebonarun",
                        "latitude": "-7.70028000",
                        "longitude": "110.56306000"
                    },
                    {
                        "id": 56709,
                        "name": "Kedungwuni",
                        "latitude": "-6.97038000",
                        "longitude": "109.64794000"
                    },
                    {
                        "id": 56715,
                        "name": "Ketanggungan",
                        "latitude": "-6.93830000",
                        "longitude": "108.89100000"
                    },
                    {
                        "id": 56719,
                        "name": "Klaten",
                        "latitude": "-7.70583000",
                        "longitude": "110.60639000"
                    },
                    {
                        "id": 56821,
                        "name": "Kroya",
                        "latitude": "-7.63306000",
                        "longitude": "109.24611000"
                    },
                    {
                        "id": 56824,
                        "name": "Kudus",
                        "latitude": "-6.80480000",
                        "longitude": "110.84050000"
                    },
                    {
                        "id": 56828,
                        "name": "Kutoarjo",
                        "latitude": "-7.71694000",
                        "longitude": "109.91278000"
                    },
                    {
                        "id": 56838,
                        "name": "Lasem",
                        "latitude": "-6.69220000",
                        "longitude": "111.45270000"
                    },
                    {
                        "id": 56840,
                        "name": "Lebaksiu",
                        "latitude": "-7.04960000",
                        "longitude": "109.14410000"
                    },
                    {
                        "id": 56851,
                        "name": "Magelang",
                        "latitude": "-7.47056000",
                        "longitude": "110.21778000"
                    },
                    {
                        "id": 56853,
                        "name": "Majenang",
                        "latitude": "-7.29750000",
                        "longitude": "108.76420000"
                    },
                    {
                        "id": 56862,
                        "name": "Margasari",
                        "latitude": "-7.10000000",
                        "longitude": "109.01667000"
                    },
                    {
                        "id": 56870,
                        "name": "Mertoyudan",
                        "latitude": "-7.52000000",
                        "longitude": "110.22639000"
                    },
                    {
                        "id": 56873,
                        "name": "Mlonggo",
                        "latitude": "-6.53333000",
                        "longitude": "110.70000000"
                    },
                    {
                        "id": 56877,
                        "name": "Mranggen",
                        "latitude": "-7.02680000",
                        "longitude": "110.51580000"
                    },
                    {
                        "id": 56880,
                        "name": "Muntilan",
                        "latitude": "-7.58111000",
                        "longitude": "110.29278000"
                    },
                    {
                        "id": 56887,
                        "name": "Ngemplak",
                        "latitude": "-7.54972000",
                        "longitude": "110.71639000"
                    },
                    {
                        "id": 56922,
                        "name": "Pati",
                        "latitude": "-6.75590000",
                        "longitude": "111.03800000"
                    },
                    {
                        "id": 56924,
                        "name": "Pecangaan",
                        "latitude": "-6.69780000",
                        "longitude": "110.71070000"
                    },
                    {
                        "id": 56925,
                        "name": "Pekalongan",
                        "latitude": "-6.88860000",
                        "longitude": "109.67530000"
                    },
                    {
                        "id": 56929,
                        "name": "Pemalang",
                        "latitude": "-6.89193000",
                        "longitude": "109.38263000"
                    },
                    {
                        "id": 56944,
                        "name": "Purbalingga",
                        "latitude": "-7.38806000",
                        "longitude": "109.36389000"
                    },
                    {
                        "id": 56946,
                        "name": "Purwodadi",
                        "latitude": "-7.08680000",
                        "longitude": "110.91580000"
                    },
                    {
                        "id": 56947,
                        "name": "Purwokerto",
                        "latitude": "-7.42139000",
                        "longitude": "109.23444000"
                    },
                    {
                        "id": 56949,
                        "name": "Randudongkal",
                        "latitude": "-7.09810000",
                        "longitude": "109.32430000"
                    },
                    {
                        "id": 56953,
                        "name": "Rembangan",
                        "latitude": "-6.70360000",
                        "longitude": "111.34160000"
                    },
                    {
                        "id": 56958,
                        "name": "Salatiga",
                        "latitude": "-7.33194000",
                        "longitude": "110.49278000"
                    },
                    {
                        "id": 56964,
                        "name": "Selogiri",
                        "latitude": "-7.78333000",
                        "longitude": "110.86667000"
                    },
                    {
                        "id": 56965,
                        "name": "Semarang",
                        "latitude": "-6.99306000",
                        "longitude": "110.42083000"
                    },
                    {
                        "id": 56974,
                        "name": "Sidareja",
                        "latitude": "-7.48460000",
                        "longitude": "108.79230000"
                    },
                    {
                        "id": 56987,
                        "name": "Slawi",
                        "latitude": "-6.98160000",
                        "longitude": "109.14070000"
                    },
                    {
                        "id": 56991,
                        "name": "Sokaraja",
                        "latitude": "-7.45806000",
                        "longitude": "109.28806000"
                    },
                    {
                        "id": 56997,
                        "name": "Sragen",
                        "latitude": "-7.42639000",
                        "longitude": "111.02222000"
                    },
                    {
                        "id": 57012,
                        "name": "Surakarta",
                        "latitude": "-7.55611000",
                        "longitude": "110.83167000"
                    },
                    {
                        "id": 57024,
                        "name": "Tarub",
                        "latitude": "-6.93333000",
                        "longitude": "109.16667000"
                    },
                    {
                        "id": 57026,
                        "name": "Tayu",
                        "latitude": "-6.53970000",
                        "longitude": "111.05180000"
                    },
                    {
                        "id": 57028,
                        "name": "Tegal",
                        "latitude": "-6.86940000",
                        "longitude": "109.14020000"
                    },
                    {
                        "id": 57040,
                        "name": "Trucuk",
                        "latitude": "-7.71833000",
                        "longitude": "110.65889000"
                    },
                    {
                        "id": 57047,
                        "name": "Ungaran",
                        "latitude": "-7.13972000",
                        "longitude": "110.40500000"
                    },
                    {
                        "id": 57051,
                        "name": "Wangon",
                        "latitude": "-7.51611000",
                        "longitude": "109.05389000"
                    },
                    {
                        "id": 57053,
                        "name": "Wedi",
                        "latitude": "-7.74306000",
                        "longitude": "110.57944000"
                    },
                    {
                        "id": 57054,
                        "name": "Welahan",
                        "latitude": "-6.80000000",
                        "longitude": "110.71667000"
                    },
                    {
                        "id": 57055,
                        "name": "Weleri",
                        "latitude": "-6.97130000",
                        "longitude": "110.06660000"
                    },
                    {
                        "id": 57057,
                        "name": "Wiradesa",
                        "latitude": "-6.89220000",
                        "longitude": "109.61900000"
                    },
                    {
                        "id": 57059,
                        "name": "Wonopringgo",
                        "latitude": "-6.98333000",
                        "longitude": "109.61667000"
                    },
                    {
                        "id": 57060,
                        "name": "Wonosobo",
                        "latitude": "-7.35889000",
                        "longitude": "109.90306000"
                    }
                ]
            },
            {
                "id": 1827,
                "name": "Jawa Timur",
                "iso2": "JI",
                "latitude": "-7.53606390",
                "longitude": "112.23840170",
                "type": "province",
                "cities": [
                    {
                        "id": 56185,
                        "name": "Babat",
                        "latitude": "-7.11282000",
                        "longitude": "112.16354000"
                    },
                    {
                        "id": 56191,
                        "name": "Balung",
                        "latitude": "-7.73333000",
                        "longitude": "113.91667000"
                    },
                    {
                        "id": 56197,
                        "name": "Bangil",
                        "latitude": "-7.59939000",
                        "longitude": "112.81860000"
                    },
                    {
                        "id": 56198,
                        "name": "Bangkalan",
                        "latitude": "-7.04550000",
                        "longitude": "112.73510000"
                    },
                    {
                        "id": 56206,
                        "name": "Banyuwangi",
                        "latitude": "-8.23250000",
                        "longitude": "114.35755000"
                    },
                    {
                        "id": 56210,
                        "name": "Batu",
                        "latitude": "-7.87000000",
                        "longitude": "112.52833000"
                    },
                    {
                        "id": 56219,
                        "name": "Besuki",
                        "latitude": "-7.73379000",
                        "longitude": "113.69785000"
                    },
                    {
                        "id": 56224,
                        "name": "Blitar",
                        "latitude": "-8.09830000",
                        "longitude": "112.16810000"
                    },
                    {
                        "id": 56227,
                        "name": "Bojonegoro",
                        "latitude": "-7.15020000",
                        "longitude": "111.88170000"
                    },
                    {
                        "id": 56228,
                        "name": "Bondowoso",
                        "latitude": "-7.91346000",
                        "longitude": "113.82145000"
                    },
                    {
                        "id": 56231,
                        "name": "Boyolangu",
                        "latitude": "-8.11810000",
                        "longitude": "111.89350000"
                    },
                    {
                        "id": 56233,
                        "name": "Buduran",
                        "latitude": "-7.42810000",
                        "longitude": "112.72340000"
                    },
                    {
                        "id": 56259,
                        "name": "Dampit",
                        "latitude": "-8.21162000",
                        "longitude": "112.74934000"
                    },
                    {
                        "id": 56266,
                        "name": "Diwek",
                        "latitude": "-7.57897000",
                        "longitude": "112.23109000"
                    },
                    {
                        "id": 56268,
                        "name": "Driyorejo",
                        "latitude": "-7.36590000",
                        "longitude": "112.62190000"
                    },
                    {
                        "id": 56274,
                        "name": "Gambiran Satu",
                        "latitude": "-8.39390000",
                        "longitude": "114.14640000"
                    },
                    {
                        "id": 56275,
                        "name": "Gampengrejo",
                        "latitude": "-7.76667000",
                        "longitude": "112.01667000"
                    },
                    {
                        "id": 56279,
                        "name": "Gedangan",
                        "latitude": "-7.39083000",
                        "longitude": "112.72667000"
                    },
                    {
                        "id": 56280,
                        "name": "Genteng",
                        "latitude": "-8.36667000",
                        "longitude": "114.15000000"
                    },
                    {
                        "id": 56284,
                        "name": "Gongdanglegi Kulon",
                        "latitude": "-8.17529000",
                        "longitude": "112.63594000"
                    },
                    {
                        "id": 56286,
                        "name": "Gresik",
                        "latitude": "-7.15389000",
                        "longitude": "112.65611000"
                    },
                    {
                        "id": 56287,
                        "name": "Gresik Regency",
                        "latitude": "-7.19330000",
                        "longitude": "112.55300000"
                    },
                    {
                        "id": 56301,
                        "name": "Jember",
                        "latitude": "-8.17211000",
                        "longitude": "113.69953000"
                    },
                    {
                        "id": 56304,
                        "name": "Jombang",
                        "latitude": "-7.54595000",
                        "longitude": "112.23307000"
                    },
                    {
                        "id": 56333,
                        "name": "Kabupaten Bangkalan",
                        "latitude": "-7.05000000",
                        "longitude": "112.93333000"
                    },
                    {
                        "id": 56340,
                        "name": "Kabupaten Banyuwangi",
                        "latitude": "-8.33333000",
                        "longitude": "114.20000000"
                    },
                    {
                        "id": 56363,
                        "name": "Kabupaten Blitar",
                        "latitude": "-8.13333000",
                        "longitude": "112.25000000"
                    },
                    {
                        "id": 56367,
                        "name": "Kabupaten Bojonegoro",
                        "latitude": "-7.25000000",
                        "longitude": "111.80000000"
                    },
                    {
                        "id": 56373,
                        "name": "Kabupaten Bondowoso",
                        "latitude": "-7.94040000",
                        "longitude": "113.98340000"
                    },
                    {
                        "id": 56430,
                        "name": "Kabupaten Jember",
                        "latitude": "-8.25000000",
                        "longitude": "113.65000000"
                    },
                    {
                        "id": 56434,
                        "name": "Kabupaten Jombang",
                        "latitude": "-7.55000000",
                        "longitude": "112.25000000"
                    },
                    {
                        "id": 56446,
                        "name": "Kabupaten Kediri",
                        "latitude": "-7.83333000",
                        "longitude": "112.16667000"
                    },
                    {
                        "id": 56483,
                        "name": "Kabupaten Lamongan",
                        "latitude": "-7.13333000",
                        "longitude": "112.31667000"
                    },
                    {
                        "id": 56500,
                        "name": "Kabupaten Lumajang",
                        "latitude": "-8.11667000",
                        "longitude": "113.15000000"
                    },
                    {
                        "id": 56504,
                        "name": "Kabupaten Madiun",
                        "latitude": "-7.61667000",
                        "longitude": "111.65000000"
                    },
                    {
                        "id": 56506,
                        "name": "Kabupaten Magetan",
                        "latitude": "-7.64472000",
                        "longitude": "111.35917000"
                    },
                    {
                        "id": 56511,
                        "name": "Kabupaten Malang",
                        "latitude": "-8.16667000",
                        "longitude": "112.66667000"
                    },
                    {
                        "id": 56540,
                        "name": "Kabupaten Mojokerto",
                        "latitude": "-7.55000000",
                        "longitude": "112.50000000"
                    },
                    {
                        "id": 56557,
                        "name": "Kabupaten Nganjuk",
                        "latitude": "-7.60000000",
                        "longitude": "111.93333000"
                    },
                    {
                        "id": 56558,
                        "name": "Kabupaten Ngawi",
                        "latitude": "-7.47444000",
                        "longitude": "111.33444000"
                    },
                    {
                        "id": 56568,
                        "name": "Kabupaten Pacitan",
                        "latitude": "-8.13333000",
                        "longitude": "111.16667000"
                    },
                    {
                        "id": 56573,
                        "name": "Kabupaten Pamekasan",
                        "latitude": "-7.06667000",
                        "longitude": "113.50000000"
                    },
                    {
                        "id": 56582,
                        "name": "Kabupaten Pasuruan",
                        "latitude": "-7.73333000",
                        "longitude": "112.83333000"
                    },
                    {
                        "id": 56597,
                        "name": "Kabupaten Ponorogo",
                        "latitude": "-7.93333000",
                        "longitude": "111.50000000"
                    },
                    {
                        "id": 56600,
                        "name": "Kabupaten Probolinggo",
                        "latitude": "-7.86667000",
                        "longitude": "113.31667000"
                    },
                    {
                        "id": 56616,
                        "name": "Kabupaten Sampang",
                        "latitude": "-7.05000000",
                        "longitude": "113.25000000"
                    },
                    {
                        "id": 56629,
                        "name": "Kabupaten Sidoarjo",
                        "latitude": "-7.45000000",
                        "longitude": "112.70000000"
                    },
                    {
                        "id": 56636,
                        "name": "Kabupaten Situbondo",
                        "latitude": "-7.71667000",
                        "longitude": "114.05000000"
                    },
                    {
                        "id": 56655,
                        "name": "Kabupaten Sumenep",
                        "latitude": "-7.11667000",
                        "longitude": "114.33333000"
                    },
                    {
                        "id": 56685,
                        "name": "Kabupaten Trenggalek",
                        "latitude": "-8.16667000",
                        "longitude": "111.61667000"
                    },
                    {
                        "id": 56686,
                        "name": "Kabupaten Tuban",
                        "latitude": "-6.96667000",
                        "longitude": "111.90000000"
                    },
                    {
                        "id": 56688,
                        "name": "Kabupaten Tulungagung",
                        "latitude": "-8.11667000",
                        "longitude": "111.91667000"
                    },
                    {
                        "id": 56696,
                        "name": "Kalianget",
                        "latitude": "-7.05370000",
                        "longitude": "113.94244000"
                    },
                    {
                        "id": 56697,
                        "name": "Kamal",
                        "latitude": "-7.16778000",
                        "longitude": "112.71917000"
                    },
                    {
                        "id": 56705,
                        "name": "Kebomas",
                        "latitude": "-7.16667000",
                        "longitude": "112.63330000"
                    },
                    {
                        "id": 56707,
                        "name": "Kediri",
                        "latitude": "-7.81667000",
                        "longitude": "112.01667000"
                    },
                    {
                        "id": 56708,
                        "name": "Kedungwaru",
                        "latitude": "-8.06667000",
                        "longitude": "111.91667000"
                    },
                    {
                        "id": 56711,
                        "name": "Kencong",
                        "latitude": "-8.28333000",
                        "longitude": "113.36667000"
                    },
                    {
                        "id": 56713,
                        "name": "Kepanjen",
                        "latitude": "-8.13030000",
                        "longitude": "112.57270000"
                    },
                    {
                        "id": 56714,
                        "name": "Kertosono",
                        "latitude": "-7.58333000",
                        "longitude": "112.10000000"
                    },
                    {
                        "id": 56818,
                        "name": "Kraksaan",
                        "latitude": "-7.75845000",
                        "longitude": "113.39624000"
                    },
                    {
                        "id": 56820,
                        "name": "Krian",
                        "latitude": "-7.41040000",
                        "longitude": "112.57920000"
                    },
                    {
                        "id": 56836,
                        "name": "Lamongan",
                        "latitude": "-7.11667000",
                        "longitude": "112.41667000"
                    },
                    {
                        "id": 56839,
                        "name": "Lawang",
                        "latitude": "-7.83530000",
                        "longitude": "112.69470000"
                    },
                    {
                        "id": 56848,
                        "name": "Lumajang",
                        "latitude": "-8.13350000",
                        "longitude": "113.22480000"
                    },
                    {
                        "id": 56850,
                        "name": "Madiun",
                        "latitude": "-7.62980000",
                        "longitude": "111.52390000"
                    },
                    {
                        "id": 56856,
                        "name": "Malang",
                        "latitude": "-7.97970000",
                        "longitude": "112.63040000"
                    },
                    {
                        "id": 56874,
                        "name": "Mojoagung",
                        "latitude": "-7.56667000",
                        "longitude": "112.35000000"
                    },
                    {
                        "id": 56875,
                        "name": "Mojokerto",
                        "latitude": "-7.46640000",
                        "longitude": "112.43380000"
                    },
                    {
                        "id": 56878,
                        "name": "Muncar",
                        "latitude": "-8.43333000",
                        "longitude": "114.33333000"
                    },
                    {
                        "id": 56885,
                        "name": "Nganjuk",
                        "latitude": "-7.60510000",
                        "longitude": "111.90350000"
                    },
                    {
                        "id": 56888,
                        "name": "Ngoro",
                        "latitude": "-7.68386000",
                        "longitude": "112.25804000"
                    },
                    {
                        "id": 56889,
                        "name": "Ngunut",
                        "latitude": "-8.10580000",
                        "longitude": "112.01591000"
                    },
                    {
                        "id": 56891,
                        "name": "Paciran",
                        "latitude": "-6.87666000",
                        "longitude": "112.37606000"
                    },
                    {
                        "id": 56896,
                        "name": "Pakisaji",
                        "latitude": "-8.06650000",
                        "longitude": "112.59810000"
                    },
                    {
                        "id": 56903,
                        "name": "Pamekasan",
                        "latitude": "-7.15680000",
                        "longitude": "113.47460000"
                    },
                    {
                        "id": 56906,
                        "name": "Panarukan",
                        "latitude": "-7.70181000",
                        "longitude": "113.91844000"
                    },
                    {
                        "id": 56907,
                        "name": "Pandaan",
                        "latitude": "-7.65268000",
                        "longitude": "112.68750000"
                    },
                    {
                        "id": 56913,
                        "name": "Panji",
                        "latitude": "-7.72528000",
                        "longitude": "114.09954000"
                    },
                    {
                        "id": 56915,
                        "name": "Pare",
                        "latitude": "-7.76790000",
                        "longitude": "112.19800000"
                    },
                    {
                        "id": 56921,
                        "name": "Pasuruan",
                        "latitude": "-7.64530000",
                        "longitude": "112.90750000"
                    },
                    {
                        "id": 56936,
                        "name": "Ponorogo",
                        "latitude": "-7.86850000",
                        "longitude": "111.46200000"
                    },
                    {
                        "id": 56941,
                        "name": "Prigen",
                        "latitude": "-7.68333000",
                        "longitude": "112.61667000"
                    },
                    {
                        "id": 56942,
                        "name": "Probolinggo",
                        "latitude": "-7.75430000",
                        "longitude": "113.21590000"
                    },
                    {
                        "id": 56960,
                        "name": "Sampang",
                        "latitude": "-7.18720000",
                        "longitude": "113.23940000"
                    },
                    {
                        "id": 56975,
                        "name": "Sidoarjo",
                        "latitude": "-7.44780000",
                        "longitude": "112.71830000"
                    },
                    {
                        "id": 56983,
                        "name": "Singojuruh",
                        "latitude": "-8.31667000",
                        "longitude": "114.23333000"
                    },
                    {
                        "id": 56984,
                        "name": "Singosari",
                        "latitude": "-7.89240000",
                        "longitude": "112.66580000"
                    },
                    {
                        "id": 56986,
                        "name": "Situbondo",
                        "latitude": "-7.70623000",
                        "longitude": "114.00976000"
                    },
                    {
                        "id": 56992,
                        "name": "Soko",
                        "latitude": "-7.48315000",
                        "longitude": "112.42704000"
                    },
                    {
                        "id": 56999,
                        "name": "Srono",
                        "latitude": "-8.40003000",
                        "longitude": "114.26661000"
                    },
                    {
                        "id": 57004,
                        "name": "Sumberpucung",
                        "latitude": "-8.15856000",
                        "longitude": "112.48292000"
                    },
                    {
                        "id": 57007,
                        "name": "Sumenep",
                        "latitude": "-7.01667000",
                        "longitude": "113.86667000"
                    },
                    {
                        "id": 57011,
                        "name": "Surabaya",
                        "latitude": "-7.24917000",
                        "longitude": "112.75083000"
                    },
                    {
                        "id": 57015,
                        "name": "Tanggul",
                        "latitude": "-8.16450000",
                        "longitude": "113.45250000"
                    },
                    {
                        "id": 57016,
                        "name": "Tanggulangin",
                        "latitude": "-7.49958000",
                        "longitude": "112.69992000"
                    },
                    {
                        "id": 57039,
                        "name": "Trenggalek",
                        "latitude": "-8.07640000",
                        "longitude": "111.70641000"
                    },
                    {
                        "id": 57042,
                        "name": "Tuban",
                        "latitude": "-6.89760000",
                        "longitude": "112.06490000"
                    },
                    {
                        "id": 57044,
                        "name": "Tulangan Utara",
                        "latitude": "-7.47370000",
                        "longitude": "112.65050000"
                    },
                    {
                        "id": 57045,
                        "name": "Tulungagung",
                        "latitude": "-8.06570000",
                        "longitude": "111.90250000"
                    },
                    {
                        "id": 57058,
                        "name": "Wongsorejo",
                        "latitude": "-7.99080000",
                        "longitude": "114.40090000"
                    }
                ]
            },
            {
                "id": 1806,
                "name": "Kalimantan Barat",
                "iso2": "KB",
                "latitude": "0.47734750",
                "longitude": "106.61314050",
                "type": "province",
                "cities": [
                    {
                        "id": 150090,
                        "name": "Bengkayang",
                        "latitude": "1.06911000",
                        "longitude": "109.66393000"
                    },
                    {
                        "id": 150091,
                        "name": "Kapuas Hulu",
                        "latitude": "0.83333000",
                        "longitude": "112.80000000"
                    },
                    {
                        "id": 150092,
                        "name": "Kayong Utara",
                        "latitude": "-1.06023000",
                        "longitude": "110.10402000"
                    },
                    {
                        "id": 150093,
                        "name": "Ketapang",
                        "latitude": "-1.85000000",
                        "longitude": "109.98333333"
                    },
                    {
                        "id": 150094,
                        "name": "Kubu Raya",
                        "latitude": "-0.31924000",
                        "longitude": "109.51865000"
                    },
                    {
                        "id": 150095,
                        "name": "Landak",
                        "latitude": "0.42373000",
                        "longitude": "109.75917000"
                    },
                    {
                        "id": 150096,
                        "name": "Manismata",
                        "latitude": "-2.46666667",
                        "longitude": "111.03333333"
                    },
                    {
                        "id": 150097,
                        "name": "Melawi",
                        "latitude": "-0.33617000",
                        "longitude": "111.69800000"
                    },
                    {
                        "id": 150098,
                        "name": "Mempawah",
                        "latitude": "0.25000000",
                        "longitude": "109.16667000"
                    },
                    {
                        "id": 150099,
                        "name": "Pemangkat",
                        "latitude": "1.17680000",
                        "longitude": "108.96240000"
                    },
                    {
                        "id": 150100,
                        "name": "Pontianak",
                        "latitude": "-0.02055556",
                        "longitude": "109.34138889"
                    },
                    {
                        "id": 150101,
                        "name": "Sambas",
                        "latitude": "1.43333000",
                        "longitude": "109.35000000"
                    },
                    {
                        "id": 150102,
                        "name": "Sanggau",
                        "latitude": "0.11944444",
                        "longitude": "110.58888889"
                    },
                    {
                        "id": 150103,
                        "name": "Sekadau",
                        "latitude": "0.03485000",
                        "longitude": "110.95066000"
                    },
                    {
                        "id": 150104,
                        "name": "Singkawang",
                        "latitude": "0.90000000",
                        "longitude": "108.98333333"
                    },
                    {
                        "id": 150105,
                        "name": "Sintang",
                        "latitude": "0.06805556",
                        "longitude": "111.49805556"
                    }
                ]
            },
            {
                "id": 1819,
                "name": "Kalimantan Selatan",
                "iso2": "KS",
                "latitude": "-3.09264150",
                "longitude": "115.28375850",
                "type": "province",
                "cities": [
                    {
                        "id": 56181,
                        "name": "Amuntai",
                        "latitude": "-2.41773000",
                        "longitude": "115.24941000"
                    },
                    {
                        "id": 56203,
                        "name": "Banjarmasin",
                        "latitude": "-3.31987000",
                        "longitude": "114.59075000"
                    },
                    {
                        "id": 56207,
                        "name": "Barabai",
                        "latitude": "-2.58333000",
                        "longitude": "115.38333000"
                    },
                    {
                        "id": 56323,
                        "name": "Kabupaten Balangan",
                        "latitude": "-2.32314000",
                        "longitude": "115.62922000"
                    },
                    {
                        "id": 56335,
                        "name": "Kabupaten Banjar",
                        "latitude": "-3.31667000",
                        "longitude": "115.08333000"
                    },
                    {
                        "id": 56341,
                        "name": "Kabupaten Barito Kuala",
                        "latitude": "-3.08333000",
                        "longitude": "114.61667000"
                    },
                    {
                        "id": 56420,
                        "name": "Kabupaten Hulu Sungai Selatan",
                        "latitude": "-2.75000000",
                        "longitude": "115.20000000"
                    },
                    {
                        "id": 56421,
                        "name": "Kabupaten Hulu Sungai Tengah",
                        "latitude": "-2.61667000",
                        "longitude": "115.41667000"
                    },
                    {
                        "id": 56422,
                        "name": "Kabupaten Hulu Sungai Utara",
                        "latitude": "-2.45000000",
                        "longitude": "115.13333000"
                    },
                    {
                        "id": 56468,
                        "name": "Kabupaten Kota Baru",
                        "latitude": "-3.00000000",
                        "longitude": "116.00000000"
                    },
                    {
                        "id": 56657,
                        "name": "Kabupaten Tabalong",
                        "latitude": "-1.88333000",
                        "longitude": "115.50000000"
                    },
                    {
                        "id": 56663,
                        "name": "Kabupaten Tanah Bumbu",
                        "latitude": "-3.45413000",
                        "longitude": "115.70372000"
                    },
                    {
                        "id": 56665,
                        "name": "Kabupaten Tanah Laut",
                        "latitude": "-3.88333000",
                        "longitude": "114.86667000"
                    },
                    {
                        "id": 56673,
                        "name": "Kabupaten Tapin",
                        "latitude": "-2.91667000",
                        "longitude": "115.03333000"
                    },
                    {
                        "id": 56864,
                        "name": "Martapura",
                        "latitude": "-3.41090000",
                        "longitude": "114.86420000"
                    }
                ]
            },
            {
                "id": 1794,
                "name": "Kalimantan Tengah",
                "iso2": "KT",
                "latitude": "-1.68148780",
                "longitude": "113.38235450",
                "type": "province",
                "cities": [
                    {
                        "id": 56342,
                        "name": "Kabupaten Barito Selatan",
                        "latitude": "-1.86667000",
                        "longitude": "114.73333000"
                    },
                    {
                        "id": 56343,
                        "name": "Kabupaten Barito Timur",
                        "latitude": "-1.93333000",
                        "longitude": "115.10000000"
                    },
                    {
                        "id": 56344,
                        "name": "Kabupaten Barito Utara",
                        "latitude": "-0.98333000",
                        "longitude": "115.10000000"
                    },
                    {
                        "id": 56415,
                        "name": "Kabupaten Gunung Mas",
                        "latitude": "-0.95000000",
                        "longitude": "113.50000000"
                    },
                    {
                        "id": 56437,
                        "name": "Kabupaten Kapuas",
                        "latitude": "-2.01667000",
                        "longitude": "114.38333000"
                    },
                    {
                        "id": 56443,
                        "name": "Kabupaten Katingan",
                        "latitude": "-2.06667000",
                        "longitude": "113.40000000"
                    },
                    {
                        "id": 56469,
                        "name": "Kabupaten Kotawaringin Barat",
                        "latitude": "-2.40000000",
                        "longitude": "111.73333000"
                    },
                    {
                        "id": 56470,
                        "name": "Kabupaten Kotawaringin Timur",
                        "latitude": "-2.08333000",
                        "longitude": "112.75000000"
                    },
                    {
                        "id": 56482,
                        "name": "Kabupaten Lamandau",
                        "latitude": "-1.83828000",
                        "longitude": "111.28690000"
                    },
                    {
                        "id": 56547,
                        "name": "Kabupaten Murung Raya",
                        "latitude": "-0.01667000",
                        "longitude": "114.26667000"
                    },
                    {
                        "id": 56601,
                        "name": "Kabupaten Pulang Pisau",
                        "latitude": "-3.11858000",
                        "longitude": "113.86230000"
                    },
                    {
                        "id": 56625,
                        "name": "Kabupaten Seruyan",
                        "latitude": "-2.33333000",
                        "longitude": "112.25000000"
                    },
                    {
                        "id": 56646,
                        "name": "Kabupaten Sukamara",
                        "latitude": "-2.62675000",
                        "longitude": "111.23681000"
                    },
                    {
                        "id": 56823,
                        "name": "Kualakapuas",
                        "latitude": "-3.00913000",
                        "longitude": "114.38759000"
                    },
                    {
                        "id": 56897,
                        "name": "Palangkaraya",
                        "latitude": "-2.20833000",
                        "longitude": "113.91667000"
                    },
                    {
                        "id": 56911,
                        "name": "Pangkalanbuun",
                        "latitude": "-2.68320000",
                        "longitude": "111.62590000"
                    },
                    {
                        "id": 56961,
                        "name": "Sampit",
                        "latitude": "-2.53150000",
                        "longitude": "112.94960000"
                    }
                ]
            },
            {
                "id": 1804,
                "name": "Kalimantan Timur",
                "iso2": "KI",
                "latitude": "0.53865860",
                "longitude": "116.41938900",
                "type": "province",
                "cities": [
                    {
                        "id": 56190,
                        "name": "Balikpapan",
                        "latitude": "-1.26753000",
                        "longitude": "116.82887000"
                    },
                    {
                        "id": 56229,
                        "name": "Bontang",
                        "latitude": "0.13240000",
                        "longitude": "117.48540000"
                    },
                    {
                        "id": 56254,
                        "name": "City of Balikpapan",
                        "latitude": "-1.24204000",
                        "longitude": "116.89419000"
                    },
                    {
                        "id": 56358,
                        "name": "Kabupaten Berau",
                        "latitude": "2.00000000",
                        "longitude": "117.30000000"
                    },
                    {
                        "id": 56476,
                        "name": "Kabupaten Kutai Barat",
                        "latitude": "-0.59417000",
                        "longitude": "115.51575000"
                    },
                    {
                        "id": 56477,
                        "name": "Kabupaten Kutai Kartanegara",
                        "latitude": "-0.44019000",
                        "longitude": "116.98139000"
                    },
                    {
                        "id": 56478,
                        "name": "Kabupaten Kutai Timur",
                        "latitude": "1.03769000",
                        "longitude": "117.83112000"
                    },
                    {
                        "id": 56507,
                        "name": "Kabupaten Mahakam Hulu",
                        "latitude": "0.37822000",
                        "longitude": "115.38048000"
                    },
                    {
                        "id": 56581,
                        "name": "Kabupaten Paser",
                        "latitude": "-1.43517000",
                        "longitude": "116.23535000"
                    },
                    {
                        "id": 56588,
                        "name": "Kabupaten Penajam Paser Utara",
                        "latitude": "-1.25000000",
                        "longitude": "116.83333000"
                    },
                    {
                        "id": 56845,
                        "name": "Loa Janan",
                        "latitude": "-0.58295000",
                        "longitude": "117.09503000"
                    },
                    {
                        "id": 56959,
                        "name": "Samarinda",
                        "latitude": "-0.49167000",
                        "longitude": "117.14583000"
                    }
                ]
            },
            {
                "id": 1824,
                "name": "Kalimantan Utara",
                "iso2": "KU",
                "latitude": "3.07309290",
                "longitude": "116.04138890",
                "type": "province",
                "cities": [
                    {
                        "id": 56381,
                        "name": "Kabupaten Bulungan",
                        "latitude": "3.00000000",
                        "longitude": "117.16667000"
                    },
                    {
                        "id": 56512,
                        "name": "Kabupaten Malinau",
                        "latitude": "2.45000000",
                        "longitude": "115.68333000"
                    },
                    {
                        "id": 56562,
                        "name": "Kabupaten Nunukan",
                        "latitude": "4.13333000",
                        "longitude": "116.70000000"
                    },
                    {
                        "id": 56661,
                        "name": "Kabupaten Tana Tidung",
                        "latitude": "3.55000000",
                        "longitude": "117.25000000"
                    },
                    {
                        "id": 57019,
                        "name": "Tanjung Selor",
                        "latitude": "2.83750000",
                        "longitude": "117.36528000"
                    },
                    {
                        "id": 57023,
                        "name": "Tarakan",
                        "latitude": "3.31332000",
                        "longitude": "117.59152000"
                    }
                ]
            },
            {
                "id": 1820,
                "name": "Kepulauan Bangka Belitung",
                "iso2": "BB",
                "latitude": "-2.74105130",
                "longitude": "106.44058720",
                "type": "province",
                "cities": [
                    {
                        "id": 56329,
                        "name": "Kabupaten Bangka",
                        "latitude": "-1.91667000",
                        "longitude": "105.93333000"
                    },
                    {
                        "id": 56330,
                        "name": "Kabupaten Bangka Barat",
                        "latitude": "-1.95839000",
                        "longitude": "105.53741000"
                    },
                    {
                        "id": 56331,
                        "name": "Kabupaten Bangka Selatan",
                        "latitude": "-2.66803000",
                        "longitude": "106.01257000"
                    },
                    {
                        "id": 56332,
                        "name": "Kabupaten Bangka Tengah",
                        "latitude": "-2.33989000",
                        "longitude": "106.11420000"
                    },
                    {
                        "id": 56350,
                        "name": "Kabupaten Belitung",
                        "latitude": "-2.86667000",
                        "longitude": "107.70000000"
                    },
                    {
                        "id": 56351,
                        "name": "Kabupaten Belitung Timur",
                        "latitude": "-2.96270000",
                        "longitude": "108.15216000"
                    },
                    {
                        "id": 56859,
                        "name": "Manggar",
                        "latitude": "-2.88333000",
                        "longitude": "108.26667000"
                    },
                    {
                        "id": 56881,
                        "name": "Muntok",
                        "latitude": "-2.06719000",
                        "longitude": "105.16228000"
                    },
                    {
                        "id": 56912,
                        "name": "Pangkalpinang",
                        "latitude": "-2.12914000",
                        "longitude": "106.11377000"
                    },
                    {
                        "id": 57009,
                        "name": "Sungailiat",
                        "latitude": "-1.85442000",
                        "longitude": "106.12215000"
                    },
                    {
                        "id": 57017,
                        "name": "Tanjung Pandan",
                        "latitude": "-2.73353000",
                        "longitude": "107.63477000"
                    }
                ]
            },
            {
                "id": 1807,
                "name": "Kepulauan Riau",
                "iso2": "KR",
                "latitude": "3.94565140",
                "longitude": "108.14286690",
                "type": "province",
                "cities": [
                    {
                        "id": 56361,
                        "name": "Kabupaten Bintan",
                        "latitude": "0.95000000",
                        "longitude": "104.61944000"
                    },
                    {
                        "id": 56441,
                        "name": "Kabupaten Karimun",
                        "latitude": "0.80764000",
                        "longitude": "103.41911000"
                    },
                    {
                        "id": 56450,
                        "name": "Kabupaten Kepulauan Anambas",
                        "latitude": "3.00000000",
                        "longitude": "106.00000000"
                    },
                    {
                        "id": 56495,
                        "name": "Kabupaten Lingga",
                        "latitude": "0.20000000",
                        "longitude": "104.61667000"
                    },
                    {
                        "id": 56554,
                        "name": "Kabupaten Natuna",
                        "latitude": "4.71417000",
                        "longitude": "107.97639000"
                    },
                    {
                        "id": 56716,
                        "name": "Kijang",
                        "latitude": "0.90000000",
                        "longitude": "104.63333000"
                    },
                    {
                        "id": 57018,
                        "name": "Tanjung Pinang",
                        "latitude": "0.91667000",
                        "longitude": "104.45833000"
                    }
                ]
            },
            {
                "id": 1811,
                "name": "Lampung",
                "iso2": "LA",
                "latitude": "-4.55858490",
                "longitude": "105.40680790",
                "type": "province",
                "cities": [
                    {
                        "id": 56195,
                        "name": "Bandar Lampung",
                        "latitude": "-5.42917000",
                        "longitude": "105.26111000"
                    },
                    {
                        "id": 56484,
                        "name": "Kabupaten Lampung Barat",
                        "latitude": "-5.14904000",
                        "longitude": "104.19309000"
                    },
                    {
                        "id": 56485,
                        "name": "Kabupaten Lampung Selatan",
                        "latitude": "-5.45310000",
                        "longitude": "104.98770000"
                    },
                    {
                        "id": 56486,
                        "name": "Kabupaten Lampung Tengah",
                        "latitude": "-4.86667000",
                        "longitude": "105.26667000"
                    },
                    {
                        "id": 56487,
                        "name": "Kabupaten Lampung Timur",
                        "latitude": "-5.10273000",
                        "longitude": "105.68003000"
                    },
                    {
                        "id": 56488,
                        "name": "Kabupaten Lampung Utara",
                        "latitude": "-4.81667000",
                        "longitude": "104.80000000"
                    },
                    {
                        "id": 56534,
                        "name": "Kabupaten Mesuji",
                        "latitude": "-4.04390000",
                        "longitude": "105.40130000"
                    },
                    {
                        "id": 56590,
                        "name": "Kabupaten Pesawaran",
                        "latitude": "-5.42980000",
                        "longitude": "105.17899000"
                    },
                    {
                        "id": 56591,
                        "name": "Kabupaten Pesisir Barat",
                        "latitude": "-5.19323000",
                        "longitude": "103.93976000"
                    },
                    {
                        "id": 56599,
                        "name": "Kabupaten Pringsewu",
                        "latitude": "-5.42211000",
                        "longitude": "104.93454000"
                    },
                    {
                        "id": 56667,
                        "name": "Kabupaten Tanggamus",
                        "latitude": "-5.38508000",
                        "longitude": "104.62349000"
                    },
                    {
                        "id": 56687,
                        "name": "Kabupaten Tulangbawang",
                        "latitude": "-4.20604000",
                        "longitude": "105.57999000"
                    },
                    {
                        "id": 56691,
                        "name": "Kabupaten Way Kanan",
                        "latitude": "-4.44705000",
                        "longitude": "104.52753000"
                    },
                    {
                        "id": 56817,
                        "name": "Kotabumi",
                        "latitude": "-4.82505000",
                        "longitude": "104.88170000"
                    },
                    {
                        "id": 56871,
                        "name": "Metro",
                        "latitude": "-5.11306000",
                        "longitude": "105.30667000"
                    },
                    {
                        "id": 57031,
                        "name": "Terbanggi Besar",
                        "latitude": "-4.87898000",
                        "longitude": "105.21818000"
                    }
                ]
            },
            {
                "id": 1800,
                "name": "Maluku",
                "iso2": "MA",
                "latitude": "-3.23846160",
                "longitude": "130.14527340",
                "type": "province",
                "cities": [
                    {
                        "id": 56175,
                        "name": "Amahai",
                        "latitude": "-3.33984000",
                        "longitude": "128.91975000"
                    },
                    {
                        "id": 56178,
                        "name": "Ambon",
                        "latitude": "-3.69583000",
                        "longitude": "128.18333000"
                    },
                    {
                        "id": 56384,
                        "name": "Kabupaten Buru",
                        "latitude": "-3.32767000",
                        "longitude": "126.68413000"
                    },
                    {
                        "id": 56385,
                        "name": "Kabupaten Buru Selatan",
                        "latitude": "-3.52187000",
                        "longitude": "126.59271000"
                    },
                    {
                        "id": 56451,
                        "name": "Kabupaten Kepulauan Aru",
                        "latitude": "-6.17059000",
                        "longitude": "134.46991000"
                    },
                    {
                        "id": 56513,
                        "name": "Kabupaten Maluku Barat Daya",
                        "latitude": "-7.82960000",
                        "longitude": "126.17386000"
                    },
                    {
                        "id": 56514,
                        "name": "Kabupaten Maluku Tengah",
                        "latitude": "-3.29167000",
                        "longitude": "128.96750000"
                    },
                    {
                        "id": 56515,
                        "name": "Kabupaten Maluku Tenggara",
                        "latitude": "-5.75000000",
                        "longitude": "132.73333000"
                    },
                    {
                        "id": 56516,
                        "name": "Kabupaten Maluku Tenggara Barat",
                        "latitude": "-7.61186000",
                        "longitude": "131.38000000"
                    },
                    {
                        "id": 56621,
                        "name": "Kabupaten Seram Bagian Barat",
                        "latitude": "-3.10270000",
                        "longitude": "128.42996000"
                    },
                    {
                        "id": 56622,
                        "name": "Kabupaten Seram Bagian Timur",
                        "latitude": "-3.39851000",
                        "longitude": "130.39167000"
                    },
                    {
                        "id": 57041,
                        "name": "Tual",
                        "latitude": "-5.62878000",
                        "longitude": "132.75229000"
                    }
                ]
            },
            {
                "id": 1801,
                "name": "Maluku Utara",
                "iso2": "MU",
                "latitude": "1.57099930",
                "longitude": "127.80876930",
                "type": "province",
                "cities": [
                    {
                        "id": 56271,
                        "name": "East Halmahera Regency",
                        "latitude": "1.33517000",
                        "longitude": "128.48627000"
                    },
                    {
                        "id": 56416,
                        "name": "Kabupaten Halmahera Barat",
                        "latitude": "1.41709000",
                        "longitude": "127.55264000"
                    },
                    {
                        "id": 56417,
                        "name": "Kabupaten Halmahera Selatan",
                        "latitude": "-0.39550000",
                        "longitude": "127.90833000"
                    },
                    {
                        "id": 56418,
                        "name": "Kabupaten Halmahera Tengah",
                        "latitude": "0.48056000",
                        "longitude": "128.25000000"
                    },
                    {
                        "id": 56419,
                        "name": "Kabupaten Halmahera Utara",
                        "latitude": "1.73194000",
                        "longitude": "128.00778000"
                    },
                    {
                        "id": 56455,
                        "name": "Kabupaten Kepulauan Sula",
                        "latitude": "-1.86460000",
                        "longitude": "125.69046000"
                    },
                    {
                        "id": 56602,
                        "name": "Kabupaten Pulau Morotai",
                        "latitude": "2.19924000",
                        "longitude": "128.40546000"
                    },
                    {
                        "id": 56603,
                        "name": "Kabupaten Pulau Taliabu",
                        "latitude": "-1.84578000",
                        "longitude": "124.78992000"
                    },
                    {
                        "id": 56990,
                        "name": "Sofifi",
                        "latitude": "0.73729000",
                        "longitude": "127.55880000"
                    },
                    {
                        "id": 57032,
                        "name": "Ternate",
                        "latitude": "0.79065000",
                        "longitude": "127.38424000"
                    },
                    {
                        "id": 57033,
                        "name": "Tobelo",
                        "latitude": "1.72837000",
                        "longitude": "128.00948000"
                    }
                ]
            },
            {
                "id": 1814,
                "name": "Nusa Tenggara Barat",
                "iso2": "NB",
                "latitude": "-8.65293340",
                "longitude": "117.36164760",
                "type": "province",
                "cities": [
                    {
                        "id": 56221,
                        "name": "Bima",
                        "latitude": "-8.46006000",
                        "longitude": "118.72667000"
                    },
                    {
                        "id": 56267,
                        "name": "Dompu",
                        "latitude": "-8.53650000",
                        "longitude": "118.46340000"
                    },
                    {
                        "id": 56281,
                        "name": "Gili Air",
                        "latitude": "-8.35783000",
                        "longitude": "116.08240000"
                    },
                    {
                        "id": 56360,
                        "name": "Kabupaten Bima",
                        "latitude": "-8.60000000",
                        "longitude": "118.61667000"
                    },
                    {
                        "id": 56400,
                        "name": "Kabupaten Dompu",
                        "latitude": "-8.50940000",
                        "longitude": "118.48160000"
                    },
                    {
                        "id": 56496,
                        "name": "Kabupaten Lombok Barat",
                        "latitude": "-8.69583000",
                        "longitude": "116.11667000"
                    },
                    {
                        "id": 56497,
                        "name": "Kabupaten Lombok Tengah",
                        "latitude": "-8.70000000",
                        "longitude": "116.30000000"
                    },
                    {
                        "id": 56498,
                        "name": "Kabupaten Lombok Timur",
                        "latitude": "-8.53333000",
                        "longitude": "116.53333000"
                    },
                    {
                        "id": 56499,
                        "name": "Kabupaten Lombok Utara",
                        "latitude": "-8.35214000",
                        "longitude": "116.40152000"
                    },
                    {
                        "id": 56652,
                        "name": "Kabupaten Sumbawa",
                        "latitude": "-8.74390000",
                        "longitude": "117.33240000"
                    },
                    {
                        "id": 56653,
                        "name": "Kabupaten Sumbawa Barat",
                        "latitude": "-8.75159000",
                        "longitude": "116.92132000"
                    },
                    {
                        "id": 56831,
                        "name": "Labuan Lombok",
                        "latitude": "-8.50000000",
                        "longitude": "116.66667000"
                    },
                    {
                        "id": 56843,
                        "name": "Lembar",
                        "latitude": "-8.72640000",
                        "longitude": "116.07440000"
                    },
                    {
                        "id": 56865,
                        "name": "Mataram",
                        "latitude": "-8.58333000",
                        "longitude": "116.11667000"
                    },
                    {
                        "id": 56931,
                        "name": "Pemenang",
                        "latitude": "-8.40401000",
                        "longitude": "116.10255000"
                    },
                    {
                        "id": 56938,
                        "name": "Pototano",
                        "latitude": "-8.41260000",
                        "longitude": "117.48110000"
                    },
                    {
                        "id": 56940,
                        "name": "Praya",
                        "latitude": "-8.70536000",
                        "longitude": "116.27036000"
                    },
                    {
                        "id": 56966,
                        "name": "Senggigi",
                        "latitude": "-8.49190000",
                        "longitude": "116.04240000"
                    },
                    {
                        "id": 57002,
                        "name": "Sumbawa Besar",
                        "latitude": "-8.49317000",
                        "longitude": "117.42024000"
                    }
                ]
            },
            {
                "id": 1818,
                "name": "Nusa Tenggara Timur",
                "iso2": "NT",
                "latitude": "-8.65738190",
                "longitude": "121.07937050",
                "type": "province",
                "cities": [
                    {
                        "id": 56184,
                        "name": "Atambua",
                        "latitude": "-9.10611000",
                        "longitude": "124.89250000"
                    },
                    {
                        "id": 56272,
                        "name": "Ende",
                        "latitude": "-8.84320000",
                        "longitude": "121.66230000"
                    },
                    {
                        "id": 56319,
                        "name": "Kabupaten Alor",
                        "latitude": "-8.30000000",
                        "longitude": "124.56667000"
                    },
                    {
                        "id": 56352,
                        "name": "Kabupaten Belu",
                        "latitude": "-9.41258000",
                        "longitude": "124.95066000"
                    },
                    {
                        "id": 56403,
                        "name": "Kabupaten Ende",
                        "latitude": "-8.84056000",
                        "longitude": "121.66389000"
                    },
                    {
                        "id": 56406,
                        "name": "Kabupaten Flores Timur",
                        "latitude": "-8.24224000",
                        "longitude": "122.96817000"
                    },
                    {
                        "id": 56475,
                        "name": "Kabupaten Kupang",
                        "latitude": "-9.91667000",
                        "longitude": "123.83333000"
                    },
                    {
                        "id": 56493,
                        "name": "Kabupaten Lembata",
                        "latitude": "-8.41396000",
                        "longitude": "123.55225000"
                    },
                    {
                        "id": 56510,
                        "name": "Kabupaten Malaka",
                        "latitude": "-9.56320000",
                        "longitude": "124.89481000"
                    },
                    {
                        "id": 56524,
                        "name": "Kabupaten Manggarai",
                        "latitude": "-8.56667000",
                        "longitude": "120.41667000"
                    },
                    {
                        "id": 56525,
                        "name": "Kabupaten Manggarai Barat",
                        "latitude": "-8.64484000",
                        "longitude": "119.88281000"
                    },
                    {
                        "id": 56526,
                        "name": "Kabupaten Manggarai Timur",
                        "latitude": "-8.55533000",
                        "longitude": "120.59761000"
                    },
                    {
                        "id": 56553,
                        "name": "Kabupaten Nagekeo",
                        "latitude": "-8.87210000",
                        "longitude": "121.20963000"
                    },
                    {
                        "id": 56556,
                        "name": "Kabupaten Ngada",
                        "latitude": "-8.66667000",
                        "longitude": "121.00000000"
                    },
                    {
                        "id": 56613,
                        "name": "Kabupaten Rote Ndao",
                        "latitude": "-10.73617000",
                        "longitude": "123.12054000"
                    },
                    {
                        "id": 56614,
                        "name": "Kabupaten Sabu Raijua",
                        "latitude": "-10.56286000",
                        "longitude": "121.78894000"
                    },
                    {
                        "id": 56632,
                        "name": "Kabupaten Sikka",
                        "latitude": "-8.66667000",
                        "longitude": "122.36667000"
                    },
                    {
                        "id": 56648,
                        "name": "Kabupaten Sumba Barat",
                        "latitude": "-9.56667000",
                        "longitude": "119.45000000"
                    },
                    {
                        "id": 56649,
                        "name": "Kabupaten Sumba Barat Daya",
                        "latitude": "-9.56216000",
                        "longitude": "119.08905000"
                    },
                    {
                        "id": 56650,
                        "name": "Kabupaten Sumba Tengah",
                        "latitude": "-9.62941000",
                        "longitude": "119.61914000"
                    },
                    {
                        "id": 56651,
                        "name": "Kabupaten Sumba Timur",
                        "latitude": "-9.88333000",
                        "longitude": "120.25000000"
                    },
                    {
                        "id": 56680,
                        "name": "Kabupaten Timor Tengah Selatan",
                        "latitude": "-9.83333000",
                        "longitude": "124.40000000"
                    },
                    {
                        "id": 56681,
                        "name": "Kabupaten Timor Tengah Utara",
                        "latitude": "-9.33136000",
                        "longitude": "124.51904000"
                    },
                    {
                        "id": 56710,
                        "name": "Kefamenanu",
                        "latitude": "-9.44667000",
                        "longitude": "124.47806000"
                    },
                    {
                        "id": 56721,
                        "name": "Komodo",
                        "latitude": "-8.58950000",
                        "longitude": "119.49130000"
                    },
                    {
                        "id": 56826,
                        "name": "Kupang",
                        "latitude": "-10.17083000",
                        "longitude": "123.60694000"
                    },
                    {
                        "id": 56830,
                        "name": "Labuan Bajo",
                        "latitude": "-8.49640000",
                        "longitude": "119.88770000"
                    },
                    {
                        "id": 56866,
                        "name": "Maumere",
                        "latitude": "-8.61990000",
                        "longitude": "122.21110000"
                    },
                    {
                        "id": 56883,
                        "name": "Naisano Dua",
                        "latitude": "-9.59806000",
                        "longitude": "123.77028000"
                    },
                    {
                        "id": 56956,
                        "name": "Ruteng",
                        "latitude": "-8.61139000",
                        "longitude": "120.46444000"
                    },
                    {
                        "id": 56989,
                        "name": "Soe",
                        "latitude": "-9.86071000",
                        "longitude": "124.28395000"
                    },
                    {
                        "id": 57048,
                        "name": "Waingapu",
                        "latitude": "-9.65670000",
                        "longitude": "120.26410000"
                    }
                ]
            },
            {
                "id": 1798,
                "name": "Papua",
                "iso2": "PA",
                "latitude": "-5.01222020",
                "longitude": "141.34701590",
                "type": "province",
                "cities": [
                    {
                        "id": 56173,
                        "name": "Abepura",
                        "latitude": "-2.59640000",
                        "longitude": "140.63240000"
                    },
                    {
                        "id": 56220,
                        "name": "Biak",
                        "latitude": "-1.17670000",
                        "longitude": "136.08200000"
                    },
                    {
                        "id": 56292,
                        "name": "Insrom",
                        "latitude": "-1.14473000",
                        "longitude": "136.03134000"
                    },
                    {
                        "id": 56299,
                        "name": "Jayapura",
                        "latitude": "-2.53371000",
                        "longitude": "140.71813000"
                    },
                    {
                        "id": 56359,
                        "name": "Kabupaten Biak Numfor",
                        "latitude": "-1.03333000",
                        "longitude": "136.00000000"
                    },
                    {
                        "id": 56428,
                        "name": "Kabupaten Jayapura",
                        "latitude": "-3.00000000",
                        "longitude": "139.95000000"
                    },
                    {
                        "id": 56447,
                        "name": "Kabupaten Keerom",
                        "latitude": "-3.30000000",
                        "longitude": "140.61667000"
                    },
                    {
                        "id": 56457,
                        "name": "Kabupaten Kepulauan Yapen",
                        "latitude": "-1.78773000",
                        "longitude": "136.27716000"
                    },
                    {
                        "id": 56518,
                        "name": "Kabupaten Mamberamo Raya",
                        "latitude": "-2.23561000",
                        "longitude": "137.78229000"
                    },
                    {
                        "id": 56617,
                        "name": "Kabupaten Sarmi",
                        "latitude": "-2.41667000",
                        "longitude": "139.08333000"
                    },
                    {
                        "id": 56656,
                        "name": "Kabupaten Supiori",
                        "latitude": "-0.73881000",
                        "longitude": "135.61111000"
                    },
                    {
                        "id": 56690,
                        "name": "Kabupaten Waropen",
                        "latitude": "-2.28600000",
                        "longitude": "137.01837000"
                    }
                ]
            },
            {
                "id": 1799,
                "name": "Papua Barat",
                "iso2": "PB",
                "latitude": "-1.33611540",
                "longitude": "133.17471620",
                "type": "province",
                "cities": [
                    {
                        "id": 56405,
                        "name": "Kabupaten Fakfak",
                        "latitude": "-2.92641000",
                        "longitude": "132.29608000"
                    },
                    {
                        "id": 56435,
                        "name": "Kabupaten Kaimana",
                        "latitude": "-3.66093000",
                        "longitude": "133.77451000"
                    },
                    {
                        "id": 56527,
                        "name": "Kabupaten Manokwari",
                        "latitude": "-0.90000000",
                        "longitude": "133.75000000"
                    },
                    {
                        "id": 56528,
                        "name": "Kabupaten Manokwari Selatan",
                        "latitude": "-1.07980000",
                        "longitude": "133.96729000"
                    },
                    {
                        "id": 56677,
                        "name": "Kabupaten Teluk Bintuni",
                        "latitude": "-1.88037000",
                        "longitude": "133.33105000"
                    },
                    {
                        "id": 56678,
                        "name": "Kabupaten Teluk Wondama",
                        "latitude": "-2.70000000",
                        "longitude": "134.50000000"
                    },
                    {
                        "id": 56860,
                        "name": "Manokwari",
                        "latitude": "-0.86291000",
                        "longitude": "134.06402000"
                    }
                ]
            },
            {
                "id": 5238,
                "name": "Papua Barat Daya",
                "iso2": "PD",
                "latitude": "-0.90000000",
                "longitude": "131.40000000",
                "type": "province",
                "cities": [
                    {
                        "id": 56531,
                        "name": "Kabupaten Maybrat",
                        "latitude": "-1.21550000",
                        "longitude": "132.35092000"
                    },
                    {
                        "id": 56608,
                        "name": "Kabupaten Raja Ampat",
                        "latitude": "-0.50000000",
                        "longitude": "130.00000000"
                    },
                    {
                        "id": 56641,
                        "name": "Kabupaten Sorong",
                        "latitude": "-1.16667000",
                        "longitude": "131.50000000"
                    },
                    {
                        "id": 56642,
                        "name": "Kabupaten Sorong Selatan",
                        "latitude": "-1.50495000",
                        "longitude": "132.28638000"
                    },
                    {
                        "id": 56660,
                        "name": "Kabupaten Tambrauw",
                        "latitude": "-0.60515000",
                        "longitude": "132.48962000"
                    },
                    {
                        "id": 56995,
                        "name": "Sorong",
                        "latitude": "-0.87956000",
                        "longitude": "131.26104000"
                    }
                ]
            },
            {
                "id": 5236,
                "name": "Papua Pegunungan",
                "iso2": "PE",
                "latitude": "-4.00000000",
                "longitude": "139.50000000",
                "type": "province",
                "cities": [
                    {
                        "id": 56429,
                        "name": "Kabupaten Jayawijaya",
                        "latitude": "-4.08333000",
                        "longitude": "139.08333000"
                    },
                    {
                        "id": 56490,
                        "name": "Kabupaten Lanny Jaya",
                        "latitude": "-3.91244000",
                        "longitude": "138.28766000"
                    },
                    {
                        "id": 56519,
                        "name": "Kabupaten Mamberamo Tengah",
                        "latitude": "-2.46064000",
                        "longitude": "138.45245000"
                    },
                    {
                        "id": 56555,
                        "name": "Kabupaten Nduga",
                        "latitude": "-4.45093000",
                        "longitude": "138.10089000"
                    },
                    {
                        "id": 56584,
                        "name": "Kabupaten Pegunungan Bintang",
                        "latitude": "-4.52167000",
                        "longitude": "140.29541000"
                    },
                    {
                        "id": 56683,
                        "name": "Kabupaten Tolikara",
                        "latitude": "-3.42661000",
                        "longitude": "137.41699000"
                    },
                    {
                        "id": 56694,
                        "name": "Kabupaten Yahukimo",
                        "latitude": "-4.60403000",
                        "longitude": "139.58405000"
                    },
                    {
                        "id": 56695,
                        "name": "Kabupaten Yalimo",
                        "latitude": "-3.86037000",
                        "longitude": "138.47305000"
                    }
                ]
            },
            {
                "id": 5237,
                "name": "Papua Selatan",
                "iso2": "PS",
                "latitude": "-6.50000000",
                "longitude": "139.50000000",
                "type": "province",
                "cities": [
                    {
                        "id": 56321,
                        "name": "Kabupaten Asmat",
                        "latitude": "-5.37950000",
                        "longitude": "138.46344000"
                    },
                    {
                        "id": 56376,
                        "name": "Kabupaten Boven Digoel",
                        "latitude": "-5.70519000",
                        "longitude": "140.36349000"
                    },
                    {
                        "id": 56529,
                        "name": "Kabupaten Mappi",
                        "latitude": "-6.49971000",
                        "longitude": "139.34441000"
                    },
                    {
                        "id": 56533,
                        "name": "Kabupaten Merauke",
                        "latitude": "-7.66667000",
                        "longitude": "139.66667000"
                    }
                ]
            },
            {
                "id": 5235,
                "name": "Papua Tengah",
                "iso2": "PT",
                "latitude": "-4.00000000",
                "longitude": "136.00000000",
                "type": "province",
                "cities": [
                    {
                        "id": 56395,
                        "name": "Kabupaten Deiyai",
                        "latitude": "-3.94737000",
                        "longitude": "135.95032000"
                    },
                    {
                        "id": 56399,
                        "name": "Kabupaten Dogiyai",
                        "latitude": "-4.03186000",
                        "longitude": "135.43945000"
                    },
                    {
                        "id": 56427,
                        "name": "Kabupaten Intan Jaya",
                        "latitude": "-3.41016000",
                        "longitude": "136.70837000"
                    },
                    {
                        "id": 56535,
                        "name": "Kabupaten Mimika",
                        "latitude": "-4.54357000",
                        "longitude": "136.56555000"
                    },
                    {
                        "id": 56551,
                        "name": "Kabupaten Nabire",
                        "latitude": "-3.54016000",
                        "longitude": "135.55511000"
                    },
                    {
                        "id": 56577,
                        "name": "Kabupaten Paniai",
                        "latitude": "-3.90000000",
                        "longitude": "136.60000000"
                    },
                    {
                        "id": 56604,
                        "name": "Kabupaten Puncak",
                        "latitude": "-3.67241000",
                        "longitude": "137.43896000"
                    },
                    {
                        "id": 153774,
                        "name": "Kabupaten Puncak Jaya",
                        "latitude": "-3.51069440",
                        "longitude": "137.86611111"
                    },
                    {
                        "id": 56882,
                        "name": "Nabire",
                        "latitude": "-3.35989000",
                        "longitude": "135.50074000"
                    }
                ]
            },
            {
                "id": 1809,
                "name": "Riau",
                "iso2": "RI",
                "latitude": "0.29334690",
                "longitude": "101.70682940",
                "type": "province",
                "cities": [
                    {
                        "id": 56188,
                        "name": "Balaipungut",
                        "latitude": "1.05949000",
                        "longitude": "101.29054000"
                    },
                    {
                        "id": 56208,
                        "name": "Batam",
                        "latitude": "1.14937000",
                        "longitude": "104.02491000"
                    },
                    {
                        "id": 56270,
                        "name": "Dumai",
                        "latitude": "1.66711000",
                        "longitude": "101.44316000"
                    },
                    {
                        "id": 56354,
                        "name": "Kabupaten Bengkalis",
                        "latitude": "0.98380000",
                        "longitude": "102.50960000"
                    },
                    {
                        "id": 56424,
                        "name": "Kabupaten Indragiri Hilir",
                        "latitude": "-0.33333000",
                        "longitude": "103.16667000"
                    },
                    {
                        "id": 56425,
                        "name": "Kabupaten Indragiri Hulu",
                        "latitude": "-0.55000000",
                        "longitude": "102.31667000"
                    },
                    {
                        "id": 56436,
                        "name": "Kabupaten Kampar",
                        "latitude": "0.23440000",
                        "longitude": "101.21310000"
                    },
                    {
                        "id": 56453,
                        "name": "Kabupaten Kepulauan Meranti",
                        "latitude": "0.97488000",
                        "longitude": "102.69539000"
                    },
                    {
                        "id": 56471,
                        "name": "Kabupaten Kuantan Singingi",
                        "latitude": "-0.47532000",
                        "longitude": "101.45857000"
                    },
                    {
                        "id": 56586,
                        "name": "Kabupaten Pelalawan",
                        "latitude": "0.20822000",
                        "longitude": "102.18607000"
                    },
                    {
                        "id": 56611,
                        "name": "Kabupaten Rokan Hilir",
                        "latitude": "2.16599000",
                        "longitude": "100.82514000"
                    },
                    {
                        "id": 56612,
                        "name": "Kabupaten Rokan Hulu",
                        "latitude": "0.88333000",
                        "longitude": "100.48333000"
                    },
                    {
                        "id": 56626,
                        "name": "Kabupaten Siak",
                        "latitude": "0.97453000",
                        "longitude": "102.01355000"
                    },
                    {
                        "id": 56927,
                        "name": "Pekanbaru",
                        "latitude": "0.51667000",
                        "longitude": "101.44167000"
                    }
                ]
            },
            {
                "id": 1817,
                "name": "Sulawesi Barat",
                "iso2": "SR",
                "latitude": "-2.84413710",
                "longitude": "119.23207840",
                "type": "province",
                "cities": [
                    {
                        "id": 56509,
                        "name": "Kabupaten Majene",
                        "latitude": "-3.15000000",
                        "longitude": "118.86667000"
                    },
                    {
                        "id": 56517,
                        "name": "Kabupaten Mamasa",
                        "latitude": "-2.96492000",
                        "longitude": "119.30631000"
                    },
                    {
                        "id": 56520,
                        "name": "Kabupaten Mamuju",
                        "latitude": "-2.50000000",
                        "longitude": "119.41667000"
                    },
                    {
                        "id": 56521,
                        "name": "Kabupaten Mamuju Tengah",
                        "latitude": "-2.82120000",
                        "longitude": "119.26620000"
                    },
                    {
                        "id": 56522,
                        "name": "Kabupaten Mamuju Utara",
                        "latitude": "-1.51639000",
                        "longitude": "119.42139000"
                    },
                    {
                        "id": 56596,
                        "name": "Kabupaten Polewali Mandar",
                        "latitude": "-3.30000000",
                        "longitude": "119.16667000"
                    },
                    {
                        "id": 56854,
                        "name": "Majene",
                        "latitude": "-3.54030000",
                        "longitude": "118.97070000"
                    },
                    {
                        "id": 56857,
                        "name": "Mamuju",
                        "latitude": "-2.68056000",
                        "longitude": "118.88611000"
                    },
                    {
                        "id": 56935,
                        "name": "Polewali",
                        "latitude": "-3.43240000",
                        "longitude": "119.34350000"
                    }
                ]
            },
            {
                "id": 1795,
                "name": "Sulawesi Selatan",
                "iso2": "SN",
                "latitude": "-3.66879940",
                "longitude": "119.97405340",
                "type": "province",
                "cities": [
                    {
                        "id": 56273,
                        "name": "Galesong",
                        "latitude": "-5.31660000",
                        "longitude": "119.36610000"
                    },
                    {
                        "id": 56337,
                        "name": "Kabupaten Bantaeng",
                        "latitude": "-5.48333000",
                        "longitude": "119.98333000"
                    },
                    {
                        "id": 56345,
                        "name": "Kabupaten Barru",
                        "latitude": "-4.43333000",
                        "longitude": "119.68333000"
                    },
                    {
                        "id": 56374,
                        "name": "Kabupaten Bone",
                        "latitude": "-4.70000000",
                        "longitude": "120.13333000"
                    },
                    {
                        "id": 56380,
                        "name": "Kabupaten Bulukumba",
                        "latitude": "-5.41667000",
                        "longitude": "120.23333000"
                    },
                    {
                        "id": 56404,
                        "name": "Kabupaten Enrekang",
                        "latitude": "-3.50000000",
                        "longitude": "119.86667000"
                    },
                    {
                        "id": 56412,
                        "name": "Kabupaten Gowa",
                        "latitude": "-5.31667000",
                        "longitude": "119.75000000"
                    },
                    {
                        "id": 56432,
                        "name": "Kabupaten Jeneponto",
                        "latitude": "-5.63333000",
                        "longitude": "119.73333000"
                    },
                    {
                        "id": 56501,
                        "name": "Kabupaten Luwu",
                        "latitude": "-2.55770000",
                        "longitude": "121.32420000"
                    },
                    {
                        "id": 56502,
                        "name": "Kabupaten Luwu Timur",
                        "latitude": "-2.50957000",
                        "longitude": "120.39780000"
                    },
                    {
                        "id": 56503,
                        "name": "Kabupaten Luwu Utara",
                        "latitude": "-2.60000000",
                        "longitude": "120.25000000"
                    },
                    {
                        "id": 56530,
                        "name": "Kabupaten Maros",
                        "latitude": "-5.05000000",
                        "longitude": "119.71667000"
                    },
                    {
                        "id": 56576,
                        "name": "Kabupaten Pangkajene Dan Kepulauan",
                        "latitude": "-4.78270000",
                        "longitude": "119.55060000"
                    },
                    {
                        "id": 56594,
                        "name": "Kabupaten Pinrang",
                        "latitude": "-3.61667000",
                        "longitude": "119.60000000"
                    },
                    {
                        "id": 56628,
                        "name": "Kabupaten Sidenreng Rappang",
                        "latitude": "-3.85000000",
                        "longitude": "119.96667000"
                    },
                    {
                        "id": 56635,
                        "name": "Kabupaten Sinjai",
                        "latitude": "-5.21667000",
                        "longitude": "120.15000000"
                    },
                    {
                        "id": 56640,
                        "name": "Kabupaten Soppeng",
                        "latitude": "-4.38420000",
                        "longitude": "119.89000000"
                    },
                    {
                        "id": 56659,
                        "name": "Kabupaten Takalar",
                        "latitude": "-5.41667000",
                        "longitude": "119.51667000"
                    },
                    {
                        "id": 56662,
                        "name": "Kabupaten Tana Toraja",
                        "latitude": "-3.00240000",
                        "longitude": "119.79655000"
                    },
                    {
                        "id": 56684,
                        "name": "Kabupaten Toraja Utara",
                        "latitude": "-2.92738000",
                        "longitude": "119.79218000"
                    },
                    {
                        "id": 56689,
                        "name": "Kabupaten Wajo",
                        "latitude": "-4.00000000",
                        "longitude": "120.16667000"
                    },
                    {
                        "id": 56855,
                        "name": "Makassar",
                        "latitude": "-5.14861000",
                        "longitude": "119.43194000"
                    },
                    {
                        "id": 56863,
                        "name": "Maros",
                        "latitude": "-5.00600000",
                        "longitude": "119.57270000"
                    },
                    {
                        "id": 56900,
                        "name": "Palopo",
                        "latitude": "-2.99250000",
                        "longitude": "120.19694000"
                    },
                    {
                        "id": 56916,
                        "name": "Parepare",
                        "latitude": "-4.01350000",
                        "longitude": "119.62550000"
                    },
                    {
                        "id": 56952,
                        "name": "Rantepao",
                        "latitude": "-2.97010000",
                        "longitude": "119.89780000"
                    },
                    {
                        "id": 56963,
                        "name": "Selayar Islands Regency",
                        "latitude": "-6.81667000",
                        "longitude": "120.80000000"
                    },
                    {
                        "id": 56967,
                        "name": "Sengkang",
                        "latitude": "-4.12790000",
                        "longitude": "120.02970000"
                    },
                    {
                        "id": 56985,
                        "name": "Sinjai",
                        "latitude": "-5.12410000",
                        "longitude": "120.25300000"
                    },
                    {
                        "id": 57052,
                        "name": "Watampone",
                        "latitude": "-4.53860000",
                        "longitude": "120.32790000"
                    }
                ]
            },
            {
                "id": 1813,
                "name": "Sulawesi Tengah",
                "iso2": "ST",
                "latitude": "-1.43002540",
                "longitude": "121.44561790",
                "type": "province",
                "cities": [
                    {
                        "id": 56326,
                        "name": "Kabupaten Banggai",
                        "latitude": "-0.91141000",
                        "longitude": "122.71836000"
                    },
                    {
                        "id": 56327,
                        "name": "Kabupaten Banggai Kepulauan",
                        "latitude": "-1.30236000",
                        "longitude": "123.03726000"
                    },
                    {
                        "id": 56328,
                        "name": "Kabupaten Banggai Laut",
                        "latitude": "-1.61841000",
                        "longitude": "123.49388000"
                    },
                    {
                        "id": 56383,
                        "name": "Kabupaten Buol",
                        "latitude": "1.04656000",
                        "longitude": "121.36867000"
                    },
                    {
                        "id": 56401,
                        "name": "Kabupaten Donggala",
                        "latitude": "-0.58333000",
                        "longitude": "119.85000000"
                    },
                    {
                        "id": 56541,
                        "name": "Kabupaten Morowali Utara",
                        "latitude": "-1.72070000",
                        "longitude": "121.24649000"
                    },
                    {
                        "id": 56578,
                        "name": "Kabupaten Parigi Moutong",
                        "latitude": "0.33680000",
                        "longitude": "120.17841000"
                    },
                    {
                        "id": 56598,
                        "name": "Kabupaten Poso",
                        "latitude": "-1.65000000",
                        "longitude": "120.50000000"
                    },
                    {
                        "id": 56630,
                        "name": "Kabupaten Sigi",
                        "latitude": "-1.38500000",
                        "longitude": "119.96694000"
                    },
                    {
                        "id": 56682,
                        "name": "Kabupaten Toli-Toli",
                        "latitude": "1.30862000",
                        "longitude": "120.88643000"
                    },
                    {
                        "id": 56849,
                        "name": "Luwuk",
                        "latitude": "-0.95160000",
                        "longitude": "122.78750000"
                    },
                    {
                        "id": 56876,
                        "name": "Morowali Regency",
                        "latitude": "-2.76062000",
                        "longitude": "121.95267000"
                    },
                    {
                        "id": 56901,
                        "name": "Palu",
                        "latitude": "-0.90833000",
                        "longitude": "119.87083000"
                    },
                    {
                        "id": 56937,
                        "name": "Poso",
                        "latitude": "-1.39590000",
                        "longitude": "120.75240000"
                    },
                    {
                        "id": 57034,
                        "name": "Tojo Una-Una Regency",
                        "latitude": "-1.20360000",
                        "longitude": "121.48201000"
                    }
                ]
            },
            {
                "id": 1796,
                "name": "Sulawesi Tenggara",
                "iso2": "SG",
                "latitude": "-4.14491000",
                "longitude": "122.17460500",
                "type": "province",
                "cities": [
                    {
                        "id": 56372,
                        "name": "Kabupaten Bombana",
                        "latitude": "-4.62570000",
                        "longitude": "121.81641000"
                    },
                    {
                        "id": 56386,
                        "name": "Kabupaten Buton",
                        "latitude": "-5.31667000",
                        "longitude": "122.91667000"
                    },
                    {
                        "id": 56387,
                        "name": "Kabupaten Buton Selatan",
                        "latitude": "-5.56667000",
                        "longitude": "122.70000000"
                    },
                    {
                        "id": 56388,
                        "name": "Kabupaten Buton Tengah",
                        "latitude": "-5.31667000",
                        "longitude": "122.33333000"
                    },
                    {
                        "id": 56389,
                        "name": "Kabupaten Buton Utara",
                        "latitude": "-5.01457000",
                        "longitude": "122.93015000"
                    },
                    {
                        "id": 56461,
                        "name": "Kabupaten Kolaka",
                        "latitude": "-4.08333000",
                        "longitude": "121.66667000"
                    },
                    {
                        "id": 56462,
                        "name": "Kabupaten Kolaka Timur",
                        "latitude": "-4.01807000",
                        "longitude": "121.86172000"
                    },
                    {
                        "id": 56463,
                        "name": "Kabupaten Kolaka Utara",
                        "latitude": "-3.10452000",
                        "longitude": "121.12427000"
                    },
                    {
                        "id": 56464,
                        "name": "Kabupaten Konawe",
                        "latitude": "-3.91717000",
                        "longitude": "122.08823000"
                    },
                    {
                        "id": 56465,
                        "name": "Kabupaten Konawe Kepulauan",
                        "latitude": "-4.11656000",
                        "longitude": "123.10181000"
                    },
                    {
                        "id": 56466,
                        "name": "Kabupaten Konawe Selatan",
                        "latitude": "-4.19191000",
                        "longitude": "122.44854000"
                    },
                    {
                        "id": 56467,
                        "name": "Kabupaten Konawe Utara",
                        "latitude": "-3.41552000",
                        "longitude": "121.99081000"
                    },
                    {
                        "id": 56545,
                        "name": "Kabupaten Muna",
                        "latitude": "-4.96667000",
                        "longitude": "122.66667000"
                    },
                    {
                        "id": 56546,
                        "name": "Kabupaten Muna Barat",
                        "latitude": "-4.83333000",
                        "longitude": "122.48333000"
                    },
                    {
                        "id": 56703,
                        "name": "Katabu",
                        "latitude": "-4.93330000",
                        "longitude": "122.51670000"
                    },
                    {
                        "id": 56712,
                        "name": "Kendari",
                        "latitude": "-3.97780000",
                        "longitude": "122.51507000"
                    },
                    {
                        "id": 57049,
                        "name": "Wakatobi Regency",
                        "latitude": "-5.31934000",
                        "longitude": "123.59480000"
                    }
                ]
            },
            {
                "id": 1808,
                "name": "Sulawesi Utara",
                "iso2": "SA",
                "latitude": "0.62469320",
                "longitude": "123.97500180",
                "type": "province",
                "cities": [
                    {
                        "id": 56368,
                        "name": "Kabupaten Bolaang Mongondow",
                        "latitude": "0.75000000",
                        "longitude": "124.08333000"
                    },
                    {
                        "id": 56369,
                        "name": "Kabupaten Bolaang Mongondow Selatan",
                        "latitude": "0.40912000",
                        "longitude": "123.75961000"
                    },
                    {
                        "id": 56370,
                        "name": "Kabupaten Bolaang Mongondow Timur",
                        "latitude": "0.72073000",
                        "longitude": "124.50256000"
                    },
                    {
                        "id": 56371,
                        "name": "Kabupaten Bolaang Mongondow Utara",
                        "latitude": "0.78527000",
                        "longitude": "123.41766000"
                    },
                    {
                        "id": 56454,
                        "name": "Kabupaten Kepulauan Sangihe",
                        "latitude": "3.50000000",
                        "longitude": "125.55000000"
                    },
                    {
                        "id": 56456,
                        "name": "Kabupaten Kepulauan Talaud",
                        "latitude": "4.31178000",
                        "longitude": "126.78085000"
                    },
                    {
                        "id": 56536,
                        "name": "Kabupaten Minahasa",
                        "latitude": "1.25370000",
                        "longitude": "124.83000000"
                    },
                    {
                        "id": 56537,
                        "name": "Kabupaten Minahasa Selatan",
                        "latitude": "1.21291000",
                        "longitude": "124.59708000"
                    },
                    {
                        "id": 56538,
                        "name": "Kabupaten Minahasa Tenggara",
                        "latitude": "1.05633000",
                        "longitude": "124.79250000"
                    },
                    {
                        "id": 56539,
                        "name": "Kabupaten Minahasa Utara",
                        "latitude": "1.40250000",
                        "longitude": "124.96000000"
                    },
                    {
                        "id": 56627,
                        "name": "Kabupaten Siau Tagulandang Biaro",
                        "latitude": "2.11728000",
                        "longitude": "125.37512000"
                    },
                    {
                        "id": 56835,
                        "name": "Laikit Laikit II (Dimembe)",
                        "latitude": "1.48833000",
                        "longitude": "124.97444000"
                    },
                    {
                        "id": 56858,
                        "name": "Manado",
                        "latitude": "1.48218000",
                        "longitude": "124.84892000"
                    },
                    {
                        "id": 57035,
                        "name": "Tomohon",
                        "latitude": "1.31678000",
                        "longitude": "124.80379000"
                    },
                    {
                        "id": 57037,
                        "name": "Tondano",
                        "latitude": "1.30540000",
                        "longitude": "124.91261000"
                    }
                ]
            },
            {
                "id": 1828,
                "name": "Sumatera Barat",
                "iso2": "SB",
                "latitude": "-0.73993970",
                "longitude": "100.80000510",
                "type": "province",
                "cities": [
                    {
                        "id": 56234,
                        "name": "Bukittinggi",
                        "latitude": "-0.30907000",
                        "longitude": "100.37055000"
                    },
                    {
                        "id": 56318,
                        "name": "Kabupaten Agam",
                        "latitude": "-0.25000000",
                        "longitude": "100.16667000"
                    },
                    {
                        "id": 56398,
                        "name": "Kabupaten Dharmasraya",
                        "latitude": "-1.05000000",
                        "longitude": "101.36700000"
                    },
                    {
                        "id": 56452,
                        "name": "Kabupaten Kepulauan Mentawai",
                        "latitude": "1.98917000",
                        "longitude": "99.51889000"
                    },
                    {
                        "id": 56494,
                        "name": "Kabupaten Lima Puluh Kota",
                        "latitude": "-0.01680000",
                        "longitude": "100.58720000"
                    },
                    {
                        "id": 56571,
                        "name": "Kabupaten Padang Pariaman",
                        "latitude": "-0.60000000",
                        "longitude": "100.28333000"
                    },
                    {
                        "id": 56579,
                        "name": "Kabupaten Pasaman",
                        "latitude": "0.42503000",
                        "longitude": "99.94606000"
                    },
                    {
                        "id": 56580,
                        "name": "Kabupaten Pasaman Barat",
                        "latitude": "0.28152000",
                        "longitude": "99.51965000"
                    },
                    {
                        "id": 56592,
                        "name": "Kabupaten Pesisir Selatan",
                        "latitude": "-1.58333000",
                        "longitude": "100.85000000"
                    },
                    {
                        "id": 56631,
                        "name": "Kabupaten Sijunjung",
                        "latitude": "-1.18270000",
                        "longitude": "101.60560000"
                    },
                    {
                        "id": 56638,
                        "name": "Kabupaten Solok",
                        "latitude": "-0.96667000",
                        "longitude": "100.81667000"
                    },
                    {
                        "id": 56639,
                        "name": "Kabupaten Solok Selatan",
                        "latitude": "-1.23333000",
                        "longitude": "101.41700000"
                    },
                    {
                        "id": 56664,
                        "name": "Kabupaten Tanah Datar",
                        "latitude": "-0.45550000",
                        "longitude": "100.57710000"
                    },
                    {
                        "id": 56893,
                        "name": "Padang",
                        "latitude": "-0.94924000",
                        "longitude": "100.35427000"
                    },
                    {
                        "id": 56917,
                        "name": "Pariaman",
                        "latitude": "-0.61898000",
                        "longitude": "100.11997000"
                    },
                    {
                        "id": 56923,
                        "name": "Payakumbuh",
                        "latitude": "-0.21590000",
                        "longitude": "100.63340000"
                    },
                    {
                        "id": 56977,
                        "name": "Sijunjung",
                        "latitude": "-0.70050000",
                        "longitude": "100.97740000"
                    },
                    {
                        "id": 56993,
                        "name": "Solok",
                        "latitude": "-0.80060000",
                        "longitude": "100.65710000"
                    }
                ]
            },
            {
                "id": 1816,
                "name": "Sumatera Selatan",
                "iso2": "SS",
                "latitude": "-3.31943740",
                "longitude": "103.91439900",
                "type": "province",
                "cities": [
                    {
                        "id": 56212,
                        "name": "Baturaja",
                        "latitude": "-4.12891000",
                        "longitude": "104.16695000"
                    },
                    {
                        "id": 56402,
                        "name": "Kabupaten Empat Lawang",
                        "latitude": "3.22667000",
                        "longitude": "99.09256000"
                    },
                    {
                        "id": 56542,
                        "name": "Kabupaten Muara Enim",
                        "latitude": "-4.23270000",
                        "longitude": "103.61410000"
                    },
                    {
                        "id": 56548,
                        "name": "Kabupaten Musi Banyuasin",
                        "latitude": "-2.41667000",
                        "longitude": "103.75000000"
                    },
                    {
                        "id": 56549,
                        "name": "Kabupaten Musi Rawas",
                        "latitude": "-3.08333000",
                        "longitude": "103.20000000"
                    },
                    {
                        "id": 56550,
                        "name": "Kabupaten Musi Rawas Utara",
                        "latitude": "-2.48533000",
                        "longitude": "103.29346000"
                    },
                    {
                        "id": 56563,
                        "name": "Kabupaten Ogan Ilir",
                        "latitude": "-3.43186000",
                        "longitude": "104.62727000"
                    },
                    {
                        "id": 56564,
                        "name": "Kabupaten Ogan Komering Ilir",
                        "latitude": "-3.36667000",
                        "longitude": "105.36667000"
                    },
                    {
                        "id": 56565,
                        "name": "Kabupaten Ogan Komering Ulu",
                        "latitude": "-4.13333000",
                        "longitude": "104.03333000"
                    },
                    {
                        "id": 56566,
                        "name": "Kabupaten Ogan Komering Ulu Selatan",
                        "latitude": "-4.65728000",
                        "longitude": "104.00659000"
                    },
                    {
                        "id": 56567,
                        "name": "Kabupaten Ogan Komering Ulu Timur",
                        "latitude": "-3.85679000",
                        "longitude": "104.75209000"
                    },
                    {
                        "id": 56589,
                        "name": "Kabupaten Penukal Abab Lematang Ilir",
                        "latitude": "-3.21342000",
                        "longitude": "104.08722000"
                    },
                    {
                        "id": 56833,
                        "name": "Lahat",
                        "latitude": "-3.78514000",
                        "longitude": "103.54279000"
                    },
                    {
                        "id": 56834,
                        "name": "Lahat Regency",
                        "latitude": "-3.78640000",
                        "longitude": "103.54280000"
                    },
                    {
                        "id": 56847,
                        "name": "Lubuklinggau",
                        "latitude": "-3.29450000",
                        "longitude": "102.86140000"
                    },
                    {
                        "id": 56895,
                        "name": "Pagar Alam",
                        "latitude": "-4.02506000",
                        "longitude": "103.24694000"
                    },
                    {
                        "id": 56898,
                        "name": "Palembang",
                        "latitude": "-2.91673000",
                        "longitude": "104.74580000"
                    },
                    {
                        "id": 56939,
                        "name": "Prabumulih",
                        "latitude": "-3.43447000",
                        "longitude": "104.23056000"
                    },
                    {
                        "id": 57020,
                        "name": "Tanjungagung",
                        "latitude": "-3.93728000",
                        "longitude": "103.80465000"
                    }
                ]
            },
            {
                "id": 1792,
                "name": "Sumatera Utara",
                "iso2": "SU",
                "latitude": "2.11535470",
                "longitude": "99.54509740",
                "type": "province",
                "cities": [
                    {
                        "id": 56177,
                        "name": "Ambarita",
                        "latitude": "2.68140000",
                        "longitude": "98.83110000"
                    },
                    {
                        "id": 56194,
                        "name": "Bandar",
                        "latitude": "2.05000000",
                        "longitude": "99.75000000"
                    },
                    {
                        "id": 56216,
                        "name": "Belawan",
                        "latitude": "3.77550000",
                        "longitude": "98.68320000"
                    },
                    {
                        "id": 56218,
                        "name": "Berastagi",
                        "latitude": "3.19468000",
                        "longitude": "98.50889000"
                    },
                    {
                        "id": 56222,
                        "name": "Binjai",
                        "latitude": "3.60010000",
                        "longitude": "98.48540000"
                    },
                    {
                        "id": 56261,
                        "name": "Deli Tua",
                        "latitude": "3.50780000",
                        "longitude": "98.68390000"
                    },
                    {
                        "id": 56290,
                        "name": "Gunungsitoli",
                        "latitude": "1.28880000",
                        "longitude": "97.61430000"
                    },
                    {
                        "id": 56306,
                        "name": "Kabanjahe",
                        "latitude": "3.10010000",
                        "longitude": "98.49080000"
                    },
                    {
                        "id": 56320,
                        "name": "Kabupaten Asahan",
                        "latitude": "2.78333000",
                        "longitude": "99.55000000"
                    },
                    {
                        "id": 56348,
                        "name": "Kabupaten Batu Bara",
                        "latitude": "3.16166000",
                        "longitude": "99.52652000"
                    },
                    {
                        "id": 56394,
                        "name": "Kabupaten Dairi",
                        "latitude": "2.86667000",
                        "longitude": "98.23333000"
                    },
                    {
                        "id": 56396,
                        "name": "Kabupaten Deli Serdang",
                        "latitude": "3.41667000",
                        "longitude": "98.66667000"
                    },
                    {
                        "id": 56423,
                        "name": "Kabupaten Humbang Hasundutan",
                        "latitude": "2.26551000",
                        "longitude": "98.50376000"
                    },
                    {
                        "id": 56442,
                        "name": "Kabupaten Karo",
                        "latitude": "3.11667000",
                        "longitude": "98.30000000"
                    },
                    {
                        "id": 56479,
                        "name": "Kabupaten Labuhan Batu",
                        "latitude": "2.26667000",
                        "longitude": "100.10000000"
                    },
                    {
                        "id": 56480,
                        "name": "Kabupaten Labuhan Batu Selatan",
                        "latitude": "1.98300000",
                        "longitude": "100.09760000"
                    },
                    {
                        "id": 56481,
                        "name": "Kabupaten Labuhan Batu Utara",
                        "latitude": "2.33349000",
                        "longitude": "99.63776000"
                    },
                    {
                        "id": 56489,
                        "name": "Kabupaten Langkat",
                        "latitude": "3.71667000",
                        "longitude": "98.21667000"
                    },
                    {
                        "id": 56523,
                        "name": "Kabupaten Mandailing Natal",
                        "latitude": "0.78378000",
                        "longitude": "99.25495000"
                    },
                    {
                        "id": 56559,
                        "name": "Kabupaten Nias",
                        "latitude": "1.03333000",
                        "longitude": "97.76667000"
                    },
                    {
                        "id": 56560,
                        "name": "Kabupaten Nias Barat",
                        "latitude": "1.05966000",
                        "longitude": "97.58606000"
                    },
                    {
                        "id": 56561,
                        "name": "Kabupaten Nias Utara",
                        "latitude": "1.33037000",
                        "longitude": "97.31964000"
                    },
                    {
                        "id": 56569,
                        "name": "Kabupaten Padang Lawas",
                        "latitude": "1.44684000",
                        "longitude": "99.99207000"
                    },
                    {
                        "id": 56570,
                        "name": "Kabupaten Padang Lawas Utara",
                        "latitude": "1.46011000",
                        "longitude": "99.67346000"
                    },
                    {
                        "id": 56572,
                        "name": "Kabupaten Pakpak Bharat",
                        "latitude": "2.56667000",
                        "longitude": "98.28333000"
                    },
                    {
                        "id": 56615,
                        "name": "Kabupaten Samosir",
                        "latitude": "2.64025000",
                        "longitude": "98.71525000"
                    },
                    {
                        "id": 56624,
                        "name": "Kabupaten Serdang Bedagai",
                        "latitude": "3.36667000",
                        "longitude": "99.03333000"
                    },
                    {
                        "id": 56633,
                        "name": "Kabupaten Simalungun",
                        "latitude": "2.90000000",
                        "longitude": "99.00000000"
                    },
                    {
                        "id": 56670,
                        "name": "Kabupaten Tapanuli Selatan",
                        "latitude": "1.51667000",
                        "longitude": "99.25000000"
                    },
                    {
                        "id": 56671,
                        "name": "Kabupaten Tapanuli Tengah",
                        "latitude": "1.90000000",
                        "longitude": "98.66667000"
                    },
                    {
                        "id": 56672,
                        "name": "Kabupaten Tapanuli Utara",
                        "latitude": "2.00280000",
                        "longitude": "99.07070000"
                    },
                    {
                        "id": 56717,
                        "name": "Kisaran",
                        "latitude": "2.98450000",
                        "longitude": "99.61580000"
                    },
                    {
                        "id": 56832,
                        "name": "Labuhan Deli",
                        "latitude": "3.72780000",
                        "longitude": "98.67380000"
                    },
                    {
                        "id": 56867,
                        "name": "Medan",
                        "latitude": "3.58333000",
                        "longitude": "98.66667000"
                    },
                    {
                        "id": 56894,
                        "name": "Padangsidempuan",
                        "latitude": "1.37952000",
                        "longitude": "99.27146000"
                    },
                    {
                        "id": 56910,
                        "name": "Pangkalan Brandan",
                        "latitude": "4.02380000",
                        "longitude": "98.27820000"
                    },
                    {
                        "id": 56914,
                        "name": "Parapat",
                        "latitude": "2.66300000",
                        "longitude": "98.93490000"
                    },
                    {
                        "id": 56926,
                        "name": "Pekan Bahapal",
                        "latitude": "3.11313000",
                        "longitude": "99.17352000"
                    },
                    {
                        "id": 56930,
                        "name": "Pematangsiantar",
                        "latitude": "2.95950000",
                        "longitude": "99.06870000"
                    },
                    {
                        "id": 56932,
                        "name": "Perbaungan",
                        "latitude": "3.56790000",
                        "longitude": "98.95600000"
                    },
                    {
                        "id": 56933,
                        "name": "Percut",
                        "latitude": "3.62530000",
                        "longitude": "98.86400000"
                    },
                    {
                        "id": 56951,
                        "name": "Rantauprapat",
                        "latitude": "2.10000000",
                        "longitude": "99.83333000"
                    },
                    {
                        "id": 56973,
                        "name": "Sibolga",
                        "latitude": "1.74016000",
                        "longitude": "98.78117000"
                    },
                    {
                        "id": 57000,
                        "name": "Stabat",
                        "latitude": "3.73335000",
                        "longitude": "98.45025000"
                    },
                    {
                        "id": 57010,
                        "name": "Sunggal",
                        "latitude": "3.57650000",
                        "longitude": "98.61510000"
                    },
                    {
                        "id": 57021,
                        "name": "Tanjungbalai",
                        "latitude": "2.96667000",
                        "longitude": "99.80000000"
                    },
                    {
                        "id": 57022,
                        "name": "Tanjungtiram",
                        "latitude": "4.06130000",
                        "longitude": "98.36990000"
                    },
                    {
                        "id": 57027,
                        "name": "Tebingtinggi",
                        "latitude": "3.32850000",
                        "longitude": "99.16250000"
                    },
                    {
                        "id": 57029,
                        "name": "Teluk Nibung",
                        "latitude": "3.00100000",
                        "longitude": "99.81640000"
                    },
                    {
                        "id": 57036,
                        "name": "Tomok Bolon",
                        "latitude": "2.65210000",
                        "longitude": "98.86080000"
                    },
                    {
                        "id": 57038,
                        "name": "Tongging",
                        "latitude": "2.89850000",
                        "longitude": "98.52310000"
                    },
                    {
                        "id": 57043,
                        "name": "Tuktuk Sonak",
                        "latitude": "2.66890000",
                        "longitude": "98.85760000"
                    }
                ]
            }
        ]
    },
    {
        "id": 103,
        "name": "Iran",
        "iso3": "IRN",
        "iso2": "IR",
        "numeric_code": "364",
        "phonecode": "98",
        "capital": "Tehran",
        "currency": "IRR",
        "currency_name": "Iranian rial",
        "currency_symbol": "﷼",
        "tld": ".ir",
        "native": "ایران",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Southern Asia",
        "subregion_id": 14,
        "nationality": "Iranian, Persian",
        "timezones": [
            {
                "zoneName": "Asia\/Tehran",
                "gmtOffset": 12600,
                "gmtOffsetName": "UTC+03:30",
                "abbreviation": "IRDT",
                "tzName": "Iran Daylight Time"
            }
        ],
        "translations": {
            "br": "Iran",
            "ko": "이란",
            "pt-BR": "Irã",
            "pt": "Irão",
            "nl": "Iran",
            "hr": "Iran",
            "fa": "ایران",
            "de": "Iran",
            "es": "Iran",
            "fr": "Iran",
            "ja": "イラン・イスラム共和国",
            "zh-CN": "伊朗",
            "tr": "İran",
            "ru": "Иран",
            "uk": "Іран",
            "pl": "Iran"
        },
        "latitude": "32.00000000",
        "longitude": "53.00000000",
        "emoji": "🇮🇷",
        "emojiU": "U+1F1EE U+1F1F7",
        "states": [
            {
                "id": 3929,
                "name": "Alborz",
                "iso2": "30",
                "latitude": "35.99604670",
                "longitude": "50.92892460",
                "type": "province",
                "cities": [
                    {
                        "id": 150293,
                        "name": "Asara",
                        "latitude": "36.03913120",
                        "longitude": "51.19087090"
                    },
                    {
                        "id": 150288,
                        "name": "Charbagh",
                        "latitude": "35.84060280",
                        "longitude": "50.83944800"
                    },
                    {
                        "id": 134858,
                        "name": "Eshtehard",
                        "latitude": "35.72813000",
                        "longitude": "50.41422000"
                    },
                    {
                        "id": 134635,
                        "name": "Fardis",
                        "latitude": "35.72318000",
                        "longitude": "50.97865000"
                    },
                    {
                        "id": 150295,
                        "name": "Garmdareh",
                        "latitude": "35.75371760",
                        "longitude": "51.04707220"
                    },
                    {
                        "id": 150291,
                        "name": "Golsar",
                        "latitude": "35.90777800",
                        "longitude": "50.78250000"
                    },
                    {
                        "id": 150292,
                        "name": "Hashtgerd",
                        "latitude": "35.96194400",
                        "longitude": "50.68000000"
                    },
                    {
                        "id": 150289,
                        "name": "Hashtgerd New City",
                        "latitude": "35.98327270",
                        "longitude": "50.68520960"
                    },
                    {
                        "id": 150294,
                        "name": "Kamalshahr",
                        "latitude": "35.88239360",
                        "longitude": "50.84343850"
                    },
                    {
                        "id": 134664,
                        "name": "Karaj",
                        "latitude": "35.83266000",
                        "longitude": "50.99155000"
                    },
                    {
                        "id": 150290,
                        "name": "Koohsar",
                        "latitude": "35.96242640",
                        "longitude": "50.77578280"
                    },
                    {
                        "id": 150296,
                        "name": "Mahdasht",
                        "latitude": "35.72040800",
                        "longitude": "50.76636250"
                    },
                    {
                        "id": 150297,
                        "name": "Mohammad Shahr",
                        "latitude": "35.74468970",
                        "longitude": "50.87227770"
                    },
                    {
                        "id": 134710,
                        "name": "Nazarabad",
                        "latitude": "35.95411000",
                        "longitude": "50.60607000"
                    },
                    {
                        "id": 135051,
                        "name": "Savojbolagh",
                        "latitude": "36.00000000",
                        "longitude": "50.83333000"
                    },
                    {
                        "id": 135096,
                        "name": "Taleqan",
                        "latitude": "36.20528000",
                        "longitude": "50.77610000"
                    },
                    {
                        "id": 150298,
                        "name": "Tankaman",
                        "latitude": "35.89154410",
                        "longitude": "50.60591340"
                    }
                ]
            },
            {
                "id": 3934,
                "name": "Ardabil",
                "iso2": "24",
                "latitude": "38.48532760",
                "longitude": "47.89112090",
                "type": "province",
                "cities": [
                    {
                        "id": 150198,
                        "name": "Abibeiglou",
                        "latitude": "38.28362000",
                        "longitude": "48.54482890"
                    },
                    {
                        "id": 150199,
                        "name": "Anbaran",
                        "latitude": "38.48843440",
                        "longitude": "48.41767760"
                    },
                    {
                        "id": 134568,
                        "name": "Ardabil",
                        "latitude": "38.24980000",
                        "longitude": "48.29330000"
                    },
                    {
                        "id": 150187,
                        "name": "Aslan Duz",
                        "latitude": "39.44298680",
                        "longitude": "47.40042690"
                    },
                    {
                        "id": 134602,
                        "name": "Bileh Savar",
                        "latitude": "39.37961000",
                        "longitude": "48.35463000"
                    },
                    {
                        "id": 150186,
                        "name": "Eslāmābād",
                        "latitude": "38.13110480",
                        "longitude": "47.93918600"
                    },
                    {
                        "id": 150194,
                        "name": "Fakhrabad",
                        "latitude": "38.52260140",
                        "longitude": "47.85339830"
                    },
                    {
                        "id": 134882,
                        "name": "Germi",
                        "latitude": "39.00000000",
                        "longitude": "47.95000000"
                    },
                    {
                        "id": 150190,
                        "name": "Hashjin",
                        "latitude": "37.36980870",
                        "longitude": "48.31333280"
                    },
                    {
                        "id": 150184,
                        "name": "Hir",
                        "latitude": "38.07953040",
                        "longitude": "48.48940360"
                    },
                    {
                        "id": 150185,
                        "name": "Jafarabad",
                        "latitude": "39.42213160",
                        "longitude": "48.07888930"
                    },
                    {
                        "id": 134911,
                        "name": "Khalkhal",
                        "latitude": "37.40604000",
                        "longitude": "48.54466000"
                    },
                    {
                        "id": 150192,
                        "name": "Kivi",
                        "latitude": "37.69312310",
                        "longitude": "48.32075700"
                    },
                    {
                        "id": 150189,
                        "name": "Kolor",
                        "latitude": "37.38848590",
                        "longitude": "48.71668330"
                    },
                    {
                        "id": 134932,
                        "name": "Kowsar",
                        "latitude": "37.72142000",
                        "longitude": "48.26985000"
                    },
                    {
                        "id": 150200,
                        "name": "Kuraim",
                        "latitude": "37.95500000",
                        "longitude": "48.23555600"
                    },
                    {
                        "id": 150196,
                        "name": "Lahroud",
                        "latitude": "38.50801930",
                        "longitude": "47.82212370"
                    },
                    {
                        "id": 134964,
                        "name": "Meshgin Shahr",
                        "latitude": "38.43333000",
                        "longitude": "47.75000000"
                    },
                    {
                        "id": 150197,
                        "name": "Moradlu",
                        "latitude": "38.74800000",
                        "longitude": "47.74016620"
                    },
                    {
                        "id": 134976,
                        "name": "Namin",
                        "latitude": "38.38333000",
                        "longitude": "48.51667000"
                    },
                    {
                        "id": 134986,
                        "name": "Nir",
                        "latitude": "38.00000000",
                        "longitude": "48.08333000"
                    },
                    {
                        "id": 134722,
                        "name": "Omidcheh",
                        "latitude": "38.28667000",
                        "longitude": "48.14139000"
                    },
                    {
                        "id": 134731,
                        "name": "Parsabad",
                        "latitude": "39.64820000",
                        "longitude": "47.91740000"
                    },
                    {
                        "id": 150195,
                        "name": "Qasabeh",
                        "latitude": "38.38781300",
                        "longitude": "47.53829230"
                    },
                    {
                        "id": 150193,
                        "name": "Razi",
                        "latitude": "38.62486600",
                        "longitude": "48.08286670"
                    },
                    {
                        "id": 150191,
                        "name": "Sarein",
                        "latitude": "38.14643470",
                        "longitude": "48.05716020"
                    },
                    {
                        "id": 135031,
                        "name": "Sareyn",
                        "latitude": "38.18333000",
                        "longitude": "47.98333000"
                    },
                    {
                        "id": 150188,
                        "name": "Tazakand",
                        "latitude": "39.10450420",
                        "longitude": "44.89902010"
                    }
                ]
            },
            {
                "id": 3932,
                "name": "Bushehr",
                "iso2": "18",
                "latitude": "28.76207390",
                "longitude": "51.51500770",
                "type": "province",
                "cities": [
                    {
                        "id": 150327,
                        "name": "Ab Pakhsh",
                        "latitude": "29.36788550",
                        "longitude": "51.05140670"
                    },
                    {
                        "id": 150322,
                        "name": "Abad",
                        "latitude": "29.02994140",
                        "longitude": "51.23435480"
                    },
                    {
                        "id": 134560,
                        "name": "Ahram",
                        "latitude": "28.88260000",
                        "longitude": "51.27460000"
                    },
                    {
                        "id": 150321,
                        "name": "Alishahr",
                        "latitude": "28.93079290",
                        "longitude": "51.05608460"
                    },
                    {
                        "id": 150324,
                        "name": "Anarestan",
                        "latitude": "28.03242110",
                        "longitude": "52.05895180"
                    },
                    {
                        "id": 135103,
                        "name": "Asaluyeh",
                        "latitude": "27.45000000",
                        "longitude": "52.73333000"
                    },
                    {
                        "id": 150335,
                        "name": "Baduleh",
                        "latitude": "28.39721360",
                        "longitude": "51.49332760"
                    },
                    {
                        "id": 150348,
                        "name": "Banak",
                        "latitude": "27.86259810",
                        "longitude": "52.00103740"
                    },
                    {
                        "id": 150318,
                        "name": "Bandar Bushehr",
                        "latitude": "28.91090220",
                        "longitude": "50.83002130"
                    },
                    {
                        "id": 150345,
                        "name": "Bandar Deylam",
                        "latitude": "30.06097110",
                        "longitude": "50.14617180"
                    },
                    {
                        "id": 134579,
                        "name": "Bandar Ganaveh",
                        "latitude": "29.57910000",
                        "longitude": "50.51700000"
                    },
                    {
                        "id": 150350,
                        "name": "Bandar Rig",
                        "latitude": "29.48417390",
                        "longitude": "50.61869140"
                    },
                    {
                        "id": 150347,
                        "name": "Bandar-e Kangan",
                        "latitude": "27.83288720",
                        "longitude": "52.03707510"
                    },
                    {
                        "id": 150349,
                        "name": "BandarSiraf",
                        "latitude": "27.66442800",
                        "longitude": "52.32552030"
                    },
                    {
                        "id": 150341,
                        "name": "Bardestan",
                        "latitude": "27.87006400",
                        "longitude": "51.94125630"
                    },
                    {
                        "id": 134589,
                        "name": "Borazjan",
                        "latitude": "29.26990000",
                        "longitude": "51.21880000"
                    },
                    {
                        "id": 150340,
                        "name": "Bord Khun",
                        "latitude": "28.06421750",
                        "longitude": "51.47342790"
                    },
                    {
                        "id": 150328,
                        "name": "Boshkan",
                        "latitude": "28.83166590",
                        "longitude": "51.69114580"
                    },
                    {
                        "id": 134594,
                        "name": "Bushehr",
                        "latitude": "28.96887000",
                        "longitude": "50.83657000"
                    },
                    {
                        "id": 150319,
                        "name": "Choghadak",
                        "latitude": "28.98004950",
                        "longitude": "51.00757680"
                    },
                    {
                        "id": 150330,
                        "name": "Dalaki",
                        "latitude": "29.43023450",
                        "longitude": "51.28279560"
                    },
                    {
                        "id": 134844,
                        "name": "Dashtestan",
                        "latitude": "29.28333000",
                        "longitude": "51.25000000"
                    },
                    {
                        "id": 134845,
                        "name": "Dashti",
                        "latitude": "28.48685000",
                        "longitude": "51.56182000"
                    },
                    {
                        "id": 150342,
                        "name": "Dayyer",
                        "latitude": "27.84286870",
                        "longitude": "51.91832720"
                    },
                    {
                        "id": 150323,
                        "name": "Delvar",
                        "latitude": "28.75279600",
                        "longitude": "51.05192160"
                    },
                    {
                        "id": 134621,
                        "name": "Deylam",
                        "latitude": "30.02286000",
                        "longitude": "50.35595000"
                    },
                    {
                        "id": 150343,
                        "name": "Dorahak",
                        "latitude": "27.94859620",
                        "longitude": "51.95292940"
                    },
                    {
                        "id": 134881,
                        "name": "Genaveh",
                        "latitude": "29.64574000",
                        "longitude": "50.64699000"
                    },
                    {
                        "id": 150344,
                        "name": "Imam Hassan",
                        "latitude": "29.84250000",
                        "longitude": "50.26305600"
                    },
                    {
                        "id": 150325,
                        "name": "Jam",
                        "latitude": "27.81572560",
                        "longitude": "52.30998450"
                    },
                    {
                        "id": 150338,
                        "name": "Kaki",
                        "latitude": "28.34162750",
                        "longitude": "51.50626640"
                    },
                    {
                        "id": 150333,
                        "name": "Kalameh",
                        "latitude": "28.94047610",
                        "longitude": "51.45177470"
                    },
                    {
                        "id": 134906,
                        "name": "Kangan",
                        "latitude": "27.71330000",
                        "longitude": "52.26862000"
                    },
                    {
                        "id": 150320,
                        "name": "Kharg",
                        "latitude": "29.24059200",
                        "longitude": "50.27422810"
                    },
                    {
                        "id": 134678,
                        "name": "Khark",
                        "latitude": "29.26139000",
                        "longitude": "50.33056000"
                    },
                    {
                        "id": 150336,
                        "name": "Khormoj",
                        "latitude": "28.64840690",
                        "longitude": "51.35095520"
                    },
                    {
                        "id": 150339,
                        "name": "Konar Torshan",
                        "latitude": "28.07801520",
                        "longitude": "51.74254250"
                    },
                    {
                        "id": 150346,
                        "name": "Nakhl Taghi",
                        "latitude": "27.50035250",
                        "longitude": "52.57634380"
                    },
                    {
                        "id": 150326,
                        "name": "Riz",
                        "latitude": "28.05156760",
                        "longitude": "52.06435920"
                    },
                    {
                        "id": 150331,
                        "name": "Sadabad",
                        "latitude": "29.38580150",
                        "longitude": "51.11174580"
                    },
                    {
                        "id": 150332,
                        "name": "Shaban Kareh",
                        "latitude": "29.47081580",
                        "longitude": "50.97548950"
                    },
                    {
                        "id": 150337,
                        "name": "Shonbeh",
                        "latitude": "28.39593970",
                        "longitude": "51.75433880"
                    },
                    {
                        "id": 150329,
                        "name": "Tang Eram",
                        "latitude": "29.15332260",
                        "longitude": "51.51832580"
                    },
                    {
                        "id": 135059,
                        "name": "Tangestan",
                        "latitude": "28.88333000",
                        "longitude": "51.26667000"
                    },
                    {
                        "id": 150334,
                        "name": "Vahdatiyeh",
                        "latitude": "29.48645140",
                        "longitude": "51.21830440"
                    }
                ]
            },
            {
                "id": 3921,
                "name": "Chaharmahal and Bakhtiari",
                "iso2": "14",
                "latitude": "31.99704190",
                "longitude": "50.66138490",
                "type": "province",
                "cities": [
                    {
                        "id": 150411,
                        "name": "Aluni",
                        "latitude": "31.55421910",
                        "longitude": "51.04972240"
                    },
                    {
                        "id": 150380,
                        "name": "Ardal",
                        "latitude": "32.00501060",
                        "longitude": "50.61478550"
                    },
                    {
                        "id": 150399,
                        "name": "Babaheydar",
                        "latitude": "32.33058500",
                        "longitude": "50.45960420"
                    },
                    {
                        "id": 150404,
                        "name": "Bazoft",
                        "latitude": "32.20000000",
                        "longitude": "50.05000000"
                    },
                    {
                        "id": 134586,
                        "name": "Ben",
                        "latitude": "32.53556000",
                        "longitude": "50.75201000"
                    },
                    {
                        "id": 150385,
                        "name": "Boldaji",
                        "latitude": "31.93677560",
                        "longitude": "51.04458330"
                    },
                    {
                        "id": 150384,
                        "name": "Boroujen",
                        "latitude": "31.97268680",
                        "longitude": "51.27156200"
                    },
                    {
                        "id": 134590,
                        "name": "Borujen",
                        "latitude": "31.96523000",
                        "longitude": "51.28730000"
                    },
                    {
                        "id": 134607,
                        "name": "Chelgard",
                        "latitude": "32.46720000",
                        "longitude": "50.12229000"
                    },
                    {
                        "id": 150405,
                        "name": "Chelgerd",
                        "latitude": "32.46261960",
                        "longitude": "50.12346200"
                    },
                    {
                        "id": 150402,
                        "name": "Choliche",
                        "latitude": "32.23196940",
                        "longitude": "50.62066420"
                    },
                    {
                        "id": 150381,
                        "name": "Dashtak",
                        "latitude": "32.16260720",
                        "longitude": "50.44992680"
                    },
                    {
                        "id": 150407,
                        "name": "Dastena",
                        "latitude": "32.05881780",
                        "longitude": "50.76100940"
                    },
                    {
                        "id": 150387,
                        "name": "Faradonbeh",
                        "latitude": "32.00967370",
                        "longitude": "51.19972210"
                    },
                    {
                        "id": 134637,
                        "name": "Farrokh Shahr",
                        "latitude": "32.27174000",
                        "longitude": "50.98008000"
                    },
                    {
                        "id": 150394,
                        "name": "Farrokhshahr",
                        "latitude": "32.27076050",
                        "longitude": "50.93707970"
                    },
                    {
                        "id": 134641,
                        "name": "Farsan",
                        "latitude": "32.25694000",
                        "longitude": "50.56095000"
                    },
                    {
                        "id": 150409,
                        "name": "Gahru",
                        "latitude": "32.00802020",
                        "longitude": "50.87719190"
                    },
                    {
                        "id": 150388,
                        "name": "Gandoman",
                        "latitude": "31.86348680",
                        "longitude": "51.13710870"
                    },
                    {
                        "id": 150403,
                        "name": "Gujan",
                        "latitude": "32.24561880",
                        "longitude": "50.54045680"
                    },
                    {
                        "id": 150397,
                        "name": "Haarooni",
                        "latitude": "32.39291700",
                        "longitude": "50.56652790"
                    },
                    {
                        "id": 150398,
                        "name": "Hafshejan",
                        "latitude": "32.22555600",
                        "longitude": "50.79388900"
                    },
                    {
                        "id": 150401,
                        "name": "Junqan",
                        "latitude": "32.15297870",
                        "longitude": "50.67785030"
                    },
                    {
                        "id": 150383,
                        "name": "Kaj",
                        "latitude": "32.05868180",
                        "longitude": "50.57817940"
                    },
                    {
                        "id": 150412,
                        "name": "Kal Geh-ye Sardasht",
                        "latitude": "31.39583300",
                        "longitude": "50.83583300"
                    },
                    {
                        "id": 134937,
                        "name": "Kiar",
                        "latitude": "32.00000000",
                        "longitude": "50.76667000"
                    },
                    {
                        "id": 134940,
                        "name": "Kuhrang",
                        "latitude": "32.41667000",
                        "longitude": "50.00000000"
                    },
                    {
                        "id": 134943,
                        "name": "Lordegan",
                        "latitude": "31.43333000",
                        "longitude": "50.83333000"
                    },
                    {
                        "id": 150413,
                        "name": "Mal-e Khalifeh",
                        "latitude": "31.29168000",
                        "longitude": "51.25682120"
                    },
                    {
                        "id": 150414,
                        "name": "Menj",
                        "latitude": "31.48467380",
                        "longitude": "50.87308270"
                    },
                    {
                        "id": 150396,
                        "name": "Nafch",
                        "latitude": "32.42311540",
                        "longitude": "50.77988140"
                    },
                    {
                        "id": 150410,
                        "name": "Naghan",
                        "latitude": "31.93457630",
                        "longitude": "50.72042630"
                    },
                    {
                        "id": 150389,
                        "name": "Naghneh",
                        "latitude": "31.93395290",
                        "longitude": "51.32190230"
                    },
                    {
                        "id": 150400,
                        "name": "Pordanjan",
                        "latitude": "32.25403890",
                        "longitude": "50.59079640"
                    },
                    {
                        "id": 134764,
                        "name": "Saman",
                        "latitude": "32.44980000",
                        "longitude": "50.91379000"
                    },
                    {
                        "id": 150406,
                        "name": "Samsami",
                        "latitude": "32.16811120",
                        "longitude": "50.27090540"
                    },
                    {
                        "id": 150382,
                        "name": "SarKhun",
                        "latitude": "31.74577700",
                        "longitude": "50.54092890"
                    },
                    {
                        "id": 150386,
                        "name": "Sefiddasht",
                        "latitude": "32.13223020",
                        "longitude": "51.17423050"
                    },
                    {
                        "id": 134783,
                        "name": "Shahrekord",
                        "latitude": "32.31667000",
                        "longitude": "50.80000000"
                    },
                    {
                        "id": 150395,
                        "name": "ShahrKian",
                        "latitude": "32.28446520",
                        "longitude": "50.88317860"
                    },
                    {
                        "id": 150408,
                        "name": "Shalamzar ",
                        "latitude": "32.04720560",
                        "longitude": "50.80899950"
                    },
                    {
                        "id": 150391,
                        "name": "Sudejan",
                        "latitude": "32.52143210",
                        "longitude": "50.39623970"
                    },
                    {
                        "id": 150392,
                        "name": "Sureshjan",
                        "latitude": "32.31709400",
                        "longitude": "50.67117690"
                    },
                    {
                        "id": 150393,
                        "name": "Taqanak",
                        "latitude": "32.22333300",
                        "longitude": "50.83861100"
                    },
                    {
                        "id": 150390,
                        "name": "Vardanjan ",
                        "latitude": "32.47903740",
                        "longitude": "50.75005520"
                    }
                ]
            },
            {
                "id": 3944,
                "name": "East Azerbaijan",
                "iso2": "03",
                "latitude": "37.90357330",
                "longitude": "46.26821090",
                "type": "province",
                "cities": [
                    {
                        "id": 150134,
                        "name": "Abeshahmad",
                        "latitude": "39.04976740",
                        "longitude": "47.30755790"
                    },
                    {
                        "id": 150144,
                        "name": "Achachi",
                        "latitude": "37.39543380",
                        "longitude": "47.79039870"
                    },
                    {
                        "id": 134559,
                        "name": "Ahar",
                        "latitude": "38.47740000",
                        "longitude": "47.06990000"
                    },
                    {
                        "id": 135160,
                        "name": "Ajabshir",
                        "latitude": "37.47760000",
                        "longitude": "45.89430000"
                    },
                    {
                        "id": 150143,
                        "name": "Aqkend",
                        "latitude": "37.25776990",
                        "longitude": "48.06143040"
                    },
                    {
                        "id": 135089,
                        "name": "Azarshahr",
                        "latitude": "37.75001000",
                        "longitude": "45.83334000"
                    },
                    {
                        "id": 150149,
                        "name": "Bakhshāyesh",
                        "latitude": "38.13113810",
                        "longitude": "46.93808910"
                    },
                    {
                        "id": 150114,
                        "name": "Basmenj",
                        "latitude": "38.00133160",
                        "longitude": "46.44624690"
                    },
                    {
                        "id": 150137,
                        "name": "Benab e Marand",
                        "latitude": "38.42810110",
                        "longitude": "45.90225220"
                    },
                    {
                        "id": 134588,
                        "name": "Bonab",
                        "latitude": "37.34040000",
                        "longitude": "46.05610000"
                    },
                    {
                        "id": 150112,
                        "name": "Bostan Abad",
                        "latitude": "37.83949300",
                        "longitude": "46.80963270"
                    },
                    {
                        "id": 134815,
                        "name": "Bostanabad",
                        "latitude": "37.83333000",
                        "longitude": "46.83333000"
                    },
                    {
                        "id": 134838,
                        "name": "Charavimaq",
                        "latitude": "37.10012000",
                        "longitude": "47.06680000"
                    },
                    {
                        "id": 150121,
                        "name": "Duzduzan",
                        "latitude": "37.94875740",
                        "longitude": "47.11409570"
                    },
                    {
                        "id": 150107,
                        "name": "Gogan",
                        "latitude": "37.78153460",
                        "longitude": "45.89832550"
                    },
                    {
                        "id": 150118,
                        "name": "Hadishahr",
                        "latitude": "38.82833100",
                        "longitude": "45.62179980"
                    },
                    {
                        "id": 150154,
                        "name": "Hashtrood",
                        "latitude": "37.47750290",
                        "longitude": "47.03698730"
                    },
                    {
                        "id": 134654,
                        "name": "Hashtrud",
                        "latitude": "37.47790000",
                        "longitude": "47.05080000"
                    },
                    {
                        "id": 134894,
                        "name": "Heris",
                        "latitude": "38.23058000",
                        "longitude": "46.84011000"
                    },
                    {
                        "id": 150111,
                        "name": "Hurand",
                        "latitude": "38.85916700",
                        "longitude": "47.36861100"
                    },
                    {
                        "id": 150109,
                        "name": "Ilkhichi",
                        "latitude": "37.93748590",
                        "longitude": "45.94332160"
                    },
                    {
                        "id": 150133,
                        "name": "Javan Qala",
                        "latitude": "37.49714170",
                        "longitude": "45.97186080"
                    },
                    {
                        "id": 134898,
                        "name": "Jolfa",
                        "latitude": "38.83343000",
                        "longitude": "45.91680000"
                    },
                    {
                        "id": 150135,
                        "name": "Kaleybar",
                        "latitude": "38.86672580",
                        "longitude": "47.02453120"
                    },
                    {
                        "id": 150152,
                        "name": "Kelvanaq",
                        "latitude": "38.10249790",
                        "longitude": "46.98483460"
                    },
                    {
                        "id": 150150,
                        "name": "Khaje",
                        "latitude": "38.15275670",
                        "longitude": "46.58237460"
                    },
                    {
                        "id": 150125,
                        "name": "Khamaneh",
                        "latitude": "38.18523560",
                        "longitude": "45.61308840"
                    },
                    {
                        "id": 150136,
                        "name": "Kharajoo",
                        "latitude": "37.30978140",
                        "longitude": "46.52171360"
                    },
                    {
                        "id": 150147,
                        "name": "Kharvana",
                        "latitude": "38.68560950",
                        "longitude": "46.15987300"
                    },
                    {
                        "id": 134915,
                        "name": "Khoda Afarin",
                        "latitude": "39.06667000",
                        "longitude": "46.95000000"
                    },
                    {
                        "id": 150120,
                        "name": "Khomarlu",
                        "latitude": "39.15455660",
                        "longitude": "47.02483170"
                    },
                    {
                        "id": 150115,
                        "name": "Khosrowshah",
                        "latitude": "37.96330460",
                        "longitude": "46.01503310"
                    },
                    {
                        "id": 150131,
                        "name": "Koozehkonan",
                        "latitude": "38.19320240",
                        "longitude": "45.54328630"
                    },
                    {
                        "id": 150139,
                        "name": "Koshksaray",
                        "latitude": "38.45962010",
                        "longitude": "45.55695530"
                    },
                    {
                        "id": 150141,
                        "name": "Leilan",
                        "latitude": "37.01165090",
                        "longitude": "46.19523520"
                    },
                    {
                        "id": 134951,
                        "name": "Malekan",
                        "latitude": "37.13338000",
                        "longitude": "46.21667000"
                    },
                    {
                        "id": 150108,
                        "name": "Mamaqan",
                        "latitude": "37.85616440",
                        "longitude": "45.92748410"
                    },
                    {
                        "id": 134954,
                        "name": "Maragheh",
                        "latitude": "37.38061000",
                        "longitude": "46.39372000"
                    },
                    {
                        "id": 134695,
                        "name": "Marand",
                        "latitude": "38.43290000",
                        "longitude": "45.77490000"
                    },
                    {
                        "id": 150123,
                        "name": "Mehraban",
                        "latitude": "38.08148170",
                        "longitude": "47.12825770"
                    },
                    {
                        "id": 134974,
                        "name": "Mianeh",
                        "latitude": "37.41667000",
                        "longitude": "47.70000000"
                    },
                    {
                        "id": 150142,
                        "name": "Mobarak Abad",
                        "latitude": "37.18030400",
                        "longitude": "46.05071780"
                    },
                    {
                        "id": 150153,
                        "name": "Nazarkahrizi",
                        "latitude": "37.34737060",
                        "longitude": "46.75960420"
                    },
                    {
                        "id": 134992,
                        "name": "Osku",
                        "latitude": "37.95005000",
                        "longitude": "45.88340000"
                    },
                    {
                        "id": 150119,
                        "name": "Qareh Aghaj",
                        "latitude": "37.12856190",
                        "longitude": "46.96478250"
                    },
                    {
                        "id": 150110,
                        "name": "Sahand",
                        "latitude": "37.94212840",
                        "longitude": "46.11317040"
                    },
                    {
                        "id": 134771,
                        "name": "Sarab",
                        "latitude": "37.94080000",
                        "longitude": "47.53670000"
                    },
                    {
                        "id": 150116,
                        "name": "Sardroud",
                        "latitude": "38.03123850",
                        "longitude": "46.12973630"
                    },
                    {
                        "id": 150127,
                        "name": "Shabestar",
                        "latitude": "38.18273990",
                        "longitude": "45.68192460"
                    },
                    {
                        "id": 150122,
                        "name": "Sharabian",
                        "latitude": "37.88192420",
                        "longitude": "47.09549190"
                    },
                    {
                        "id": 150128,
                        "name": "Sharafkhaneh",
                        "latitude": "38.17865710",
                        "longitude": "45.46786290"
                    },
                    {
                        "id": 150129,
                        "name": "Shendabad",
                        "latitude": "38.14561010",
                        "longitude": "45.61905390"
                    },
                    {
                        "id": 150117,
                        "name": "Siahrood",
                        "latitude": "38.86877450",
                        "longitude": "45.99665520"
                    },
                    {
                        "id": 150126,
                        "name": "Sis",
                        "latitude": "38.19685870",
                        "longitude": "45.81075660"
                    },
                    {
                        "id": 150130,
                        "name": "Soufian",
                        "latitude": "38.27831360",
                        "longitude": "45.97709660"
                    },
                    {
                        "id": 135125,
                        "name": "Tabriz",
                        "latitude": "38.08000000",
                        "longitude": "46.29190000"
                    },
                    {
                        "id": 150145,
                        "name": "Tark",
                        "latitude": "37.61736710",
                        "longitude": "47.76673070"
                    },
                    {
                        "id": 150124,
                        "name": "Tasuj",
                        "latitude": "38.31615040",
                        "longitude": "45.33654190"
                    },
                    {
                        "id": 150113,
                        "name": "Tekmeh Dash",
                        "latitude": "37.73535540",
                        "longitude": "46.93088980"
                    },
                    {
                        "id": 150106,
                        "name": "Teymourlou",
                        "latitude": "37.81040850",
                        "longitude": "45.88154540"
                    },
                    {
                        "id": 150146,
                        "name": "Turkman Chay",
                        "latitude": "37.58178980",
                        "longitude": "47.37021430"
                    },
                    {
                        "id": 150132,
                        "name": "Vaighan",
                        "latitude": "38.12844590",
                        "longitude": "45.70490600"
                    },
                    {
                        "id": 135068,
                        "name": "Varzaqan",
                        "latitude": "38.59492000",
                        "longitude": "46.46397000"
                    },
                    {
                        "id": 150148,
                        "name": "Varzeqān",
                        "latitude": "38.58136590",
                        "longitude": "46.17000800"
                    },
                    {
                        "id": 150140,
                        "name": "Yamchi",
                        "latitude": "38.52447740",
                        "longitude": "45.63416480"
                    },
                    {
                        "id": 150151,
                        "name": "Zarnaq",
                        "latitude": "38.09240870",
                        "longitude": "47.07680230"
                    },
                    {
                        "id": 150138,
                        "name": "Zonouz",
                        "latitude": "38.58949510",
                        "longitude": "45.82614190"
                    }
                ]
            },
            {
                "id": 3939,
                "name": "Fars",
                "iso2": "07",
                "latitude": "29.10438130",
                "longitude": "53.04589300",
                "type": "province",
                "cities": [
                    {
                        "id": 135151,
                        "name": "Abadeh",
                        "latitude": "31.16080000",
                        "longitude": "52.65060000"
                    },
                    {
                        "id": 150705,
                        "name": "Abadeh Tashk",
                        "latitude": "29.80720880",
                        "longitude": "53.72005450"
                    },
                    {
                        "id": 150692,
                        "name": "Ahel",
                        "latitude": "27.21120460",
                        "longitude": "53.65720510"
                    },
                    {
                        "id": 134562,
                        "name": "Akbarabad",
                        "latitude": "29.24640000",
                        "longitude": "52.77930000"
                    },
                    {
                        "id": 150693,
                        "name": "Alamarvdasht",
                        "latitude": "27.62517770",
                        "longitude": "52.99113750"
                    },
                    {
                        "id": 134795,
                        "name": "Arsanjan",
                        "latitude": "29.80000000",
                        "longitude": "53.41667000"
                    },
                    {
                        "id": 150628,
                        "name": "Arsenjan",
                        "latitude": "29.91892820",
                        "longitude": "53.28291870"
                    },
                    {
                        "id": 150691,
                        "name": "Ashkanan",
                        "latitude": "27.23524440",
                        "longitude": "53.58667360"
                    },
                    {
                        "id": 150701,
                        "name": "Asir",
                        "latitude": "27.72481010",
                        "longitude": "52.66111850"
                    },
                    {
                        "id": 150698,
                        "name": "Baba Monir",
                        "latitude": "30.07159140",
                        "longitude": "51.20029090"
                    },
                    {
                        "id": 150638,
                        "name": "BabAnar",
                        "latitude": "28.96416700",
                        "longitude": "53.21638900"
                    },
                    {
                        "id": 150625,
                        "name": "Bahman",
                        "latitude": "31.19345630",
                        "longitude": "52.47589580"
                    },
                    {
                        "id": 150678,
                        "name": "Baladeh ",
                        "latitude": "29.28302900",
                        "longitude": "51.92782400"
                    },
                    {
                        "id": 150685,
                        "name": "Banaruyeh",
                        "latitude": "28.08653670",
                        "longitude": "54.03974940"
                    },
                    {
                        "id": 134807,
                        "name": "Bavanat",
                        "latitude": "30.33333000",
                        "longitude": "53.66667000"
                    },
                    {
                        "id": 150686,
                        "name": "Beyram",
                        "latitude": "27.43173640",
                        "longitude": "53.50586420"
                    },
                    {
                        "id": 150656,
                        "name": "Beyza",
                        "latitude": "29.97198120",
                        "longitude": "52.39688860"
                    },
                    {
                        "id": 150681,
                        "name": "City Kazeroon",
                        "latitude": "29.62712330",
                        "longitude": "51.64962760"
                    },
                    {
                        "id": 150654,
                        "name": "Dabiran",
                        "latitude": "28.40752830",
                        "longitude": "54.16883220"
                    },
                    {
                        "id": 134626,
                        "name": "Darab",
                        "latitude": "28.75194000",
                        "longitude": "54.54444000"
                    },
                    {
                        "id": 150661,
                        "name": "Dariun",
                        "latitude": "29.56255730",
                        "longitude": "52.91882510"
                    },
                    {
                        "id": 150665,
                        "name": "Dehram",
                        "latitude": "28.49124870",
                        "longitude": "52.29977130"
                    },
                    {
                        "id": 150632,
                        "name": "Dezhkord",
                        "latitude": "30.72281950",
                        "longitude": "51.95147040"
                    },
                    {
                        "id": 150649,
                        "name": "DoBorji",
                        "latitude": "28.30666700",
                        "longitude": "55.19277800"
                    },
                    {
                        "id": 150641,
                        "name": "Douzeh",
                        "latitude": "28.70131620",
                        "longitude": "52.95476670"
                    },
                    {
                        "id": 150673,
                        "name": "Efzar",
                        "latitude": "28.34636970",
                        "longitude": "52.96109670"
                    },
                    {
                        "id": 150629,
                        "name": "Eij",
                        "latitude": "29.02248840",
                        "longitude": "54.23737580"
                    },
                    {
                        "id": 150689,
                        "name": "Emad Deh",
                        "latitude": "27.44620970",
                        "longitude": "53.85212660"
                    },
                    {
                        "id": 150674,
                        "name": "Emam Shahr",
                        "latitude": "28.44682660",
                        "longitude": "53.14627650"
                    },
                    {
                        "id": 134856,
                        "name": "Eqlid",
                        "latitude": "30.70000000",
                        "longitude": "52.40000000"
                    },
                    {
                        "id": 134861,
                        "name": "Estahban",
                        "latitude": "29.11667000",
                        "longitude": "54.00000000"
                    },
                    {
                        "id": 150684,
                        "name": "Evaz",
                        "latitude": "27.76295710",
                        "longitude": "53.97943440"
                    },
                    {
                        "id": 150650,
                        "name": "Fadami ",
                        "latitude": "28.21409230",
                        "longitude": "55.11737800"
                    },
                    {
                        "id": 134868,
                        "name": "Farashband",
                        "latitude": "28.75000000",
                        "longitude": "52.25000000"
                    },
                    {
                        "id": 134870,
                        "name": "Fasa",
                        "latitude": "28.96667000",
                        "longitude": "53.76667000"
                    },
                    {
                        "id": 134642,
                        "name": "Firuzabad",
                        "latitude": "28.84380000",
                        "longitude": "52.57070000"
                    },
                    {
                        "id": 150703,
                        "name": "Galehdar",
                        "latitude": "27.65744580",
                        "longitude": "52.62983260"
                    },
                    {
                        "id": 134644,
                        "name": "Gerash",
                        "latitude": "27.66966000",
                        "longitude": "54.13586000"
                    },
                    {
                        "id": 150669,
                        "name": "Ghare Bolagh",
                        "latitude": "28.92810000",
                        "longitude": "54.05090000"
                    },
                    {
                        "id": 150675,
                        "name": "Ghirokarzin",
                        "latitude": "28.33638090",
                        "longitude": "52.66841600"
                    },
                    {
                        "id": 150653,
                        "name": "HajiAbad",
                        "latitude": "29.65540700",
                        "longitude": "52.31150870"
                    },
                    {
                        "id": 150657,
                        "name": "Hamashahr",
                        "latitude": "30.11166700",
                        "longitude": "52.08277800"
                    },
                    {
                        "id": 150631,
                        "name": "HasanAbad",
                        "latitude": "30.52016170",
                        "longitude": "52.45160570"
                    },
                    {
                        "id": 150634,
                        "name": "Hesami",
                        "latitude": "29.96975010",
                        "longitude": "53.86682510"
                    },
                    {
                        "id": 150624,
                        "name": "IzadKhast",
                        "latitude": "31.51636070",
                        "longitude": "52.11609370"
                    },
                    {
                        "id": 150639,
                        "name": "Jahrom",
                        "latitude": "28.53058250",
                        "longitude": "53.51852170"
                    },
                    {
                        "id": 150648,
                        "name": "JannatShahr",
                        "latitude": "28.65398340",
                        "longitude": "54.67042500"
                    },
                    {
                        "id": 150687,
                        "name": "Juyom",
                        "latitude": "28.25891410",
                        "longitude": "53.96016580"
                    },
                    {
                        "id": 150697,
                        "name": "Kamfiruz",
                        "latitude": "30.32309970",
                        "longitude": "52.18398570"
                    },
                    {
                        "id": 150676,
                        "name": "Karzin",
                        "latitude": "28.43324410",
                        "longitude": "53.12390410"
                    },
                    {
                        "id": 134908,
                        "name": "Kavar",
                        "latitude": "29.21667000",
                        "longitude": "52.73333000"
                    },
                    {
                        "id": 134684,
                        "name": "Kazerun",
                        "latitude": "29.61919000",
                        "longitude": "51.65350000"
                    },
                    {
                        "id": 150660,
                        "name": "KhaneZenian",
                        "latitude": "29.67004760",
                        "longitude": "52.14333620"
                    },
                    {
                        "id": 150694,
                        "name": "Khaniman",
                        "latitude": "30.34916700",
                        "longitude": "52.24166700"
                    },
                    {
                        "id": 150643,
                        "name": "Kharameh",
                        "latitude": "29.50038570",
                        "longitude": "53.30107210"
                    },
                    {
                        "id": 150640,
                        "name": "Khavaran",
                        "latitude": "28.93684290",
                        "longitude": "53.31201550"
                    },
                    {
                        "id": 134914,
                        "name": "Kherameh",
                        "latitude": "29.50000000",
                        "longitude": "53.25000000"
                    },
                    {
                        "id": 150679,
                        "name": "Khesht",
                        "latitude": "27.23347270",
                        "longitude": "53.43067650"
                    },
                    {
                        "id": 150647,
                        "name": "Khonj",
                        "latitude": "27.88763700",
                        "longitude": "53.41157890"
                    },
                    {
                        "id": 150699,
                        "name": "Khoome Zar",
                        "latitude": "30.00924290",
                        "longitude": "51.56660550"
                    },
                    {
                        "id": 150702,
                        "name": "Khoozi",
                        "latitude": "27.44610520",
                        "longitude": "52.96075340"
                    },
                    {
                        "id": 134919,
                        "name": "Khorrambid",
                        "latitude": "30.50000000",
                        "longitude": "53.08333000"
                    },
                    {
                        "id": 150688,
                        "name": "Khour",
                        "latitude": "27.64191680",
                        "longitude": "54.33750230"
                    },
                    {
                        "id": 150682,
                        "name": "Konartakhteh",
                        "latitude": "29.52510620",
                        "longitude": "51.37342200"
                    },
                    {
                        "id": 150651,
                        "name": "Kopen",
                        "latitude": "30.33500890",
                        "longitude": "51.27854700"
                    },
                    {
                        "id": 150635,
                        "name": "Korei",
                        "latitude": "30.03036720",
                        "longitude": "53.70883220"
                    },
                    {
                        "id": 150659,
                        "name": "Kouhenjan",
                        "latitude": "29.23156770",
                        "longitude": "52.95320030"
                    },
                    {
                        "id": 150695,
                        "name": "Koushkak",
                        "latitude": "30.07373620",
                        "longitude": "52.58820540"
                    },
                    {
                        "id": 134946,
                        "name": "Lamerd",
                        "latitude": "27.36667000",
                        "longitude": "53.38333000"
                    },
                    {
                        "id": 150664,
                        "name": "Lapouyee",
                        "latitude": "29.79964990",
                        "longitude": "52.64236450"
                    },
                    {
                        "id": 134778,
                        "name": "Lar",
                        "latitude": "27.68336000",
                        "longitude": "54.34172000"
                    },
                    {
                        "id": 134947,
                        "name": "Larestan",
                        "latitude": "27.75000000",
                        "longitude": "54.45000000"
                    },
                    {
                        "id": 150690,
                        "name": "Latifi",
                        "latitude": "27.69024090",
                        "longitude": "54.37713040"
                    },
                    {
                        "id": 134694,
                        "name": "Mamasani",
                        "latitude": "30.03333000",
                        "longitude": "51.38333000"
                    },
                    {
                        "id": 134696,
                        "name": "Marvdasht",
                        "latitude": "30.08333000",
                        "longitude": "52.66667000"
                    },
                    {
                        "id": 150652,
                        "name": "Masiri",
                        "latitude": "30.24094560",
                        "longitude": "51.52066790"
                    },
                    {
                        "id": 150636,
                        "name": "Mazayejan",
                        "latitude": "28.05616020",
                        "longitude": "54.65025550"
                    },
                    {
                        "id": 150707,
                        "name": "Meshkan",
                        "latitude": "29.47403030",
                        "longitude": "54.32865840"
                    },
                    {
                        "id": 150672,
                        "name": "Meymand",
                        "latitude": "28.86776870",
                        "longitude": "52.73594130"
                    },
                    {
                        "id": 150670,
                        "name": "Miyanshahr",
                        "latitude": "28.71017970",
                        "longitude": "53.85154720"
                    },
                    {
                        "id": 150677,
                        "name": "Mobarakabad",
                        "latitude": "28.35972200",
                        "longitude": "53.32833300"
                    },
                    {
                        "id": 134704,
                        "name": "Mohr",
                        "latitude": "27.55520000",
                        "longitude": "52.88360000"
                    },
                    {
                        "id": 134713,
                        "name": "Neyriz",
                        "latitude": "29.19880000",
                        "longitude": "54.32780000"
                    },
                    {
                        "id": 150671,
                        "name": "No Bandegan",
                        "latitude": "28.85591230",
                        "longitude": "53.81496180"
                    },
                    {
                        "id": 150700,
                        "name": "Nourabad",
                        "latitude": "30.11349310",
                        "longitude": "51.50369100"
                    },
                    {
                        "id": 150683,
                        "name": "Nowdan",
                        "latitude": "29.80119540",
                        "longitude": "51.68421500"
                    },
                    {
                        "id": 150666,
                        "name": "Nowjein",
                        "latitude": "29.11848470",
                        "longitude": "51.98232590"
                    },
                    {
                        "id": 134721,
                        "name": "Nurabad",
                        "latitude": "30.11405000",
                        "longitude": "51.52174000"
                    },
                    {
                        "id": 134732,
                        "name": "Pasargad",
                        "latitude": "30.20194000",
                        "longitude": "53.18000000"
                    },
                    {
                        "id": 150655,
                        "name": "PirCity",
                        "latitude": "28.31454240",
                        "longitude": "54.31413150"
                    },
                    {
                        "id": 150646,
                        "name": "Qaderabad",
                        "latitude": "30.27834010",
                        "longitude": "53.25756670"
                    },
                    {
                        "id": 150680,
                        "name": "Qaemyeh",
                        "latitude": "29.85091920",
                        "longitude": "51.57323570"
                    },
                    {
                        "id": 150706,
                        "name": "Qatruyeh",
                        "latitude": "29.14584570",
                        "longitude": "54.69936130"
                    },
                    {
                        "id": 135005,
                        "name": "Qir va Karzin",
                        "latitude": "28.31667000",
                        "longitude": "52.90000000"
                    },
                    {
                        "id": 150642,
                        "name": "QotbAbad",
                        "latitude": "28.64848720",
                        "longitude": "53.61144090"
                    },
                    {
                        "id": 150630,
                        "name": "RonizOlya",
                        "latitude": "29.19133810",
                        "longitude": "53.76483680"
                    },
                    {
                        "id": 134755,
                        "name": "Rostam",
                        "latitude": "30.40000000",
                        "longitude": "51.41667000"
                    },
                    {
                        "id": 150637,
                        "name": "SaadatShahr",
                        "latitude": "30.08246270",
                        "longitude": "53.12756530"
                    },
                    {
                        "id": 150663,
                        "name": "Sadra",
                        "latitude": "29.80475780",
                        "longitude": "52.45825710"
                    },
                    {
                        "id": 150645,
                        "name": "Safashahr",
                        "latitude": "30.61431720",
                        "longitude": "53.17833400"
                    },
                    {
                        "id": 135026,
                        "name": "Sarvestan",
                        "latitude": "29.21667000",
                        "longitude": "53.13333000"
                    },
                    {
                        "id": 150633,
                        "name": "Sedeh",
                        "latitude": "30.70291140",
                        "longitude": "52.15963050"
                    },
                    {
                        "id": 135035,
                        "name": "Sepidan",
                        "latitude": "30.15000000",
                        "longitude": "52.10000000"
                    },
                    {
                        "id": 150696,
                        "name": "Seyedan",
                        "latitude": "30.00424490",
                        "longitude": "53.00122260"
                    },
                    {
                        "id": 150668,
                        "name": "Sheshdeh",
                        "latitude": "28.91250530",
                        "longitude": "53.99227100"
                    },
                    {
                        "id": 135108,
                        "name": "Shiraz",
                        "latitude": "29.61031000",
                        "longitude": "52.53113000"
                    },
                    {
                        "id": 150627,
                        "name": "Soghad",
                        "latitude": "31.19106770",
                        "longitude": "52.50031460"
                    },
                    {
                        "id": 150644,
                        "name": "SoltanShahr",
                        "latitude": "29.62961460",
                        "longitude": "53.23294400"
                    },
                    {
                        "id": 150626,
                        "name": "Surmaq",
                        "latitude": "31.03248980",
                        "longitude": "52.83048390"
                    },
                    {
                        "id": 150704,
                        "name": "Varavi",
                        "latitude": "27.46528850",
                        "longitude": "53.04411650"
                    },
                    {
                        "id": 150667,
                        "name": "Zahedshahr",
                        "latitude": "28.75180650",
                        "longitude": "53.78289130"
                    },
                    {
                        "id": 150662,
                        "name": "Zarghan",
                        "latitude": "29.76307670",
                        "longitude": "52.67474350"
                    },
                    {
                        "id": 135073,
                        "name": "Zarrin Dasht",
                        "latitude": "28.30000000",
                        "longitude": "54.46667000"
                    },
                    {
                        "id": 150658,
                        "name": "سروستان",
                        "latitude": "29.27022530",
                        "longitude": "53.20730190"
                    }
                ]
            },
            {
                "id": 3920,
                "name": "Gilan",
                "iso2": "01",
                "latitude": "37.28094550",
                "longitude": "49.59241340",
                "type": "province",
                "cities": [
                    {
                        "id": 150879,
                        "name": "Ahmadsargurab",
                        "latitude": "37.12805600",
                        "longitude": "49.36666700"
                    },
                    {
                        "id": 150860,
                        "name": "Amlash",
                        "latitude": "37.09246800",
                        "longitude": "50.17314410"
                    },
                    {
                        "id": 150883,
                        "name": "Asalem",
                        "latitude": "37.72003980",
                        "longitude": "48.92658170"
                    },
                    {
                        "id": 135154,
                        "name": "Astaneh-ye Ashrafiyeh",
                        "latitude": "37.26318000",
                        "longitude": "49.94325000"
                    },
                    {
                        "id": 135087,
                        "name": "astara",
                        "latitude": "38.33333000",
                        "longitude": "48.76667000"
                    },
                    {
                        "id": 134578,
                        "name": "Bandar Anzali",
                        "latitude": "37.47318000",
                        "longitude": "49.45785000"
                    },
                    {
                        "id": 150869,
                        "name": "Barehsar",
                        "latitude": "36.77599100",
                        "longitude": "49.74575040"
                    },
                    {
                        "id": 150894,
                        "name": "Bazar Jomeh",
                        "latitude": "37.27945660",
                        "longitude": "49.37436040"
                    },
                    {
                        "id": 150874,
                        "name": "Chaboksar",
                        "latitude": "36.97505830",
                        "longitude": "50.54664930"
                    },
                    {
                        "id": 150891,
                        "name": "Chaf and Chamkhaleh",
                        "latitude": "37.22944400",
                        "longitude": "50.25388900"
                    },
                    {
                        "id": 150884,
                        "name": "Choobar",
                        "latitude": "38.18351690",
                        "longitude": "48.87027790"
                    },
                    {
                        "id": 150878,
                        "name": "Deylaman",
                        "latitude": "36.88609010",
                        "longitude": "49.90029930"
                    },
                    {
                        "id": 134877,
                        "name": "Fuman",
                        "latitude": "37.16667000",
                        "longitude": "49.18333000"
                    },
                    {
                        "id": 150881,
                        "name": "Gurab Zarmikh",
                        "latitude": "37.29829280",
                        "longitude": "49.20505980"
                    },
                    {
                        "id": 134653,
                        "name": "Hashtpar",
                        "latitude": "37.79658000",
                        "longitude": "48.90521000"
                    },
                    {
                        "id": 150885,
                        "name": "Haviq",
                        "latitude": "38.14750000",
                        "longitude": "48.89222200"
                    },
                    {
                        "id": 150871,
                        "name": "Jirindih",
                        "latitude": "36.70054440",
                        "longitude": "49.78016850"
                    },
                    {
                        "id": 150876,
                        "name": "Kelachay",
                        "latitude": "37.07707330",
                        "longitude": "50.38030730"
                    },
                    {
                        "id": 150863,
                        "name": "Khomam",
                        "latitude": "37.38749490",
                        "longitude": "49.63949190"
                    },
                    {
                        "id": 150862,
                        "name": "Khoshkebijar",
                        "latitude": "37.37479300",
                        "longitude": "49.73922700"
                    },
                    {
                        "id": 150859,
                        "name": "Kiashahr",
                        "latitude": "37.41682790",
                        "longitude": "49.92925590"
                    },
                    {
                        "id": 150865,
                        "name": "Kuchesfahan",
                        "latitude": "37.27838040",
                        "longitude": "49.76859950"
                    },
                    {
                        "id": 150893,
                        "name": "Kumeleh",
                        "latitude": "37.15277800",
                        "longitude": "50.17694400"
                    },
                    {
                        "id": 134944,
                        "name": "Lahijan",
                        "latitude": "37.21667000",
                        "longitude": "50.01667000"
                    },
                    {
                        "id": 134689,
                        "name": "Langarud",
                        "latitude": "37.19548000",
                        "longitude": "50.15263000"
                    },
                    {
                        "id": 150866,
                        "name": "Lasht-e Nesha",
                        "latitude": "37.36018660",
                        "longitude": "49.84508860"
                    },
                    {
                        "id": 150858,
                        "name": "Lavandvil",
                        "latitude": "38.30771640",
                        "longitude": "48.84607290"
                    },
                    {
                        "id": 150886,
                        "name": "Lisar",
                        "latitude": "37.95806970",
                        "longitude": "48.88967500"
                    },
                    {
                        "id": 150867,
                        "name": "Louleman",
                        "latitude": "37.25747920",
                        "longitude": "49.80743050"
                    },
                    {
                        "id": 150873,
                        "name": "Lowshan",
                        "latitude": "36.63216940",
                        "longitude": "49.49772640"
                    },
                    {
                        "id": 150888,
                        "name": "Maklavan",
                        "latitude": "37.19555600",
                        "longitude": "49.19861100"
                    },
                    {
                        "id": 134730,
                        "name": "Manjil",
                        "latitude": "36.74150000",
                        "longitude": "49.41610000"
                    },
                    {
                        "id": 150882,
                        "name": "Marjaghal",
                        "latitude": "37.27555600",
                        "longitude": "49.36277800"
                    },
                    {
                        "id": 134969,
                        "name": "Masal",
                        "latitude": "37.35000000",
                        "longitude": "48.98333000"
                    },
                    {
                        "id": 150887,
                        "name": "Masuleh",
                        "latitude": "37.15699680",
                        "longitude": "48.97589190"
                    },
                    {
                        "id": 150890,
                        "name": "Otaghvar",
                        "latitude": "37.10889440",
                        "longitude": "50.11271960"
                    },
                    {
                        "id": 150868,
                        "name": "Paresar",
                        "latitude": "37.60172960",
                        "longitude": "49.06391210"
                    },
                    {
                        "id": 150875,
                        "name": "Rahimabad",
                        "latitude": "37.02874220",
                        "longitude": "50.32571940"
                    },
                    {
                        "id": 150861,
                        "name": "Ranekouh",
                        "latitude": "37.05229690",
                        "longitude": "50.21790480"
                    },
                    {
                        "id": 134749,
                        "name": "Rasht",
                        "latitude": "37.27611000",
                        "longitude": "49.58862000"
                    },
                    {
                        "id": 134753,
                        "name": "Rezvanshahr",
                        "latitude": "37.54976000",
                        "longitude": "49.13703000"
                    },
                    {
                        "id": 150889,
                        "name": "Rod Baneh",
                        "latitude": "37.25551520",
                        "longitude": "50.00032430"
                    },
                    {
                        "id": 150872,
                        "name": "Rostamabad",
                        "latitude": "36.89948990",
                        "longitude": "49.47362410"
                    },
                    {
                        "id": 135017,
                        "name": "Rudbar",
                        "latitude": "36.80000000",
                        "longitude": "49.60000000"
                    },
                    {
                        "id": 134761,
                        "name": "Rudsar",
                        "latitude": "37.13696000",
                        "longitude": "50.29174000"
                    },
                    {
                        "id": 150864,
                        "name": "Sangar",
                        "latitude": "37.17965610",
                        "longitude": "49.68532780"
                    },
                    {
                        "id": 150880,
                        "name": "Shaft",
                        "latitude": "37.06483110",
                        "longitude": "49.17771370"
                    },
                    {
                        "id": 150892,
                        "name": "Shalman",
                        "latitude": "37.15916990",
                        "longitude": "50.20692950"
                    },
                    {
                        "id": 135055,
                        "name": "Siahkal",
                        "latitude": "36.93333000",
                        "longitude": "49.90000000"
                    },
                    {
                        "id": 135095,
                        "name": "Someh Sara",
                        "latitude": "37.33333000",
                        "longitude": "49.30000000"
                    },
                    {
                        "id": 135065,
                        "name": "Talesh",
                        "latitude": "37.90000000",
                        "longitude": "48.78333000"
                    },
                    {
                        "id": 150870,
                        "name": "Tutkabon",
                        "latitude": "36.89090440",
                        "longitude": "49.52147480"
                    },
                    {
                        "id": 150877,
                        "name": "Vajargah",
                        "latitude": "37.04083300",
                        "longitude": "50.40861100"
                    },
                    {
                        "id": 135146,
                        "name": "Ziabar",
                        "latitude": "37.42610000",
                        "longitude": "49.24590000"
                    }
                ]
            },
            {
                "id": 3933,
                "name": "Golestan",
                "iso2": "27",
                "latitude": "37.28981230",
                "longitude": "55.13758340",
                "type": "province",
                "cities": [
                    {
                        "id": 150848,
                        "name": "Aliabad-e-Katul",
                        "latitude": "36.91016390",
                        "longitude": "54.83907210"
                    },
                    {
                        "id": 150840,
                        "name": "Anbar Olum",
                        "latitude": "37.13300090",
                        "longitude": "54.61230750"
                    },
                    {
                        "id": 135082,
                        "name": "Aq Qala",
                        "latitude": "37.16667000",
                        "longitude": "54.58333000"
                    },
                    {
                        "id": 135153,
                        "name": "Aq Qayeh",
                        "latitude": "37.27472000",
                        "longitude": "55.15889000"
                    },
                    {
                        "id": 135156,
                        "name": "Azadshahr",
                        "latitude": "37.08641000",
                        "longitude": "55.17222000"
                    },
                    {
                        "id": 150843,
                        "name": "Bandar Torkaman",
                        "latitude": "36.90507650",
                        "longitude": "54.03526730"
                    },
                    {
                        "id": 150841,
                        "name": "Bandar-e Gaz",
                        "latitude": "36.77416700",
                        "longitude": "53.94805600"
                    },
                    {
                        "id": 150846,
                        "name": "Daland",
                        "latitude": "37.03465860",
                        "longitude": "55.03712660"
                    },
                    {
                        "id": 150851,
                        "name": "Faraqi",
                        "latitude": "37.26035860",
                        "longitude": "55.16635490"
                    },
                    {
                        "id": 150849,
                        "name": "Fazelabad",
                        "latitude": "36.89410210",
                        "longitude": "54.73096840"
                    },
                    {
                        "id": 134889,
                        "name": "Galikesh",
                        "latitude": "37.30000000",
                        "longitude": "55.65000000"
                    },
                    {
                        "id": 150855,
                        "name": "Gomish Tepe",
                        "latitude": "37.07166700",
                        "longitude": "54.07666700"
                    },
                    {
                        "id": 134885,
                        "name": "Gomishan",
                        "latitude": "37.15000000",
                        "longitude": "54.15000000"
                    },
                    {
                        "id": 134646,
                        "name": "Gonbad Kavus",
                        "latitude": "37.25004000",
                        "longitude": "55.16721000"
                    },
                    {
                        "id": 134648,
                        "name": "Gorgan",
                        "latitude": "36.84270000",
                        "longitude": "54.44391000"
                    },
                    {
                        "id": 150856,
                        "name": "Incheboron",
                        "latitude": "37.45422400",
                        "longitude": "54.71541160"
                    },
                    {
                        "id": 150852,
                        "name": "Jelin",
                        "latitude": "36.85127690",
                        "longitude": "54.52793600"
                    },
                    {
                        "id": 134662,
                        "name": "Kalaleh",
                        "latitude": "37.37899000",
                        "longitude": "55.49300000"
                    },
                    {
                        "id": 150845,
                        "name": "Khānbebin",
                        "latitude": "37.00947410",
                        "longitude": "54.97964140"
                    },
                    {
                        "id": 134931,
                        "name": "Kordkuy",
                        "latitude": "36.68333000",
                        "longitude": "54.20000000"
                    },
                    {
                        "id": 150857,
                        "name": "Maraveh",
                        "latitude": "37.90416700",
                        "longitude": "55.95583300"
                    },
                    {
                        "id": 134955,
                        "name": "Maraveh Tappeh",
                        "latitude": "37.85000000",
                        "longitude": "55.91667000"
                    },
                    {
                        "id": 150850,
                        "name": "Mazraeh",
                        "latitude": "36.95386110",
                        "longitude": "54.85471500"
                    },
                    {
                        "id": 134971,
                        "name": "Minudasht",
                        "latitude": "37.11667000",
                        "longitude": "55.45000000"
                    },
                    {
                        "id": 150838,
                        "name": "Neginshahr",
                        "latitude": "37.13936470",
                        "longitude": "55.15758990"
                    },
                    {
                        "id": 150839,
                        "name": "Nowdeh Khanduz",
                        "latitude": "37.07449880",
                        "longitude": "55.25308730"
                    },
                    {
                        "id": 150842,
                        "name": "Nowkandeh",
                        "latitude": "36.74051840",
                        "longitude": "53.88399070"
                    },
                    {
                        "id": 134738,
                        "name": "Qarnabad",
                        "latitude": "36.82203000",
                        "longitude": "54.59222000"
                    },
                    {
                        "id": 135016,
                        "name": "Ramian",
                        "latitude": "36.93333000",
                        "longitude": "55.08333000"
                    },
                    {
                        "id": 150847,
                        "name": "Sangdevin",
                        "latitude": "36.99793400",
                        "longitude": "54.85263350"
                    },
                    {
                        "id": 150853,
                        "name": "Sarkhon Kalateh",
                        "latitude": "36.89138900",
                        "longitude": "54.56916700"
                    },
                    {
                        "id": 150854,
                        "name": "Siminshahr",
                        "latitude": "37.01276160",
                        "longitude": "54.21581250"
                    },
                    {
                        "id": 150844,
                        "name": "Tatar Olia",
                        "latitude": "37.11100750",
                        "longitude": "55.04270560"
                    },
                    {
                        "id": 135133,
                        "name": "Torkaman",
                        "latitude": "36.90000000",
                        "longitude": "54.16667000"
                    }
                ]
            },
            {
                "id": 4920,
                "name": "Hamadan",
                "iso2": "13",
                "latitude": "34.91936070",
                "longitude": "47.48329250",
                "type": "province",
                "cities": [
                    {
                        "id": 146942,
                        "name": "Ab Meshkin",
                        "latitude": "35.61305556",
                        "longitude": "48.26916667"
                    },
                    {
                        "id": 146943,
                        "name": "Abarlaq-e Sofla",
                        "latitude": "34.67138889",
                        "longitude": "48.22833333"
                    },
                    {
                        "id": 146944,
                        "name": "Abdalan",
                        "latitude": "34.65277778",
                        "longitude": "48.24555556"
                    },
                    {
                        "id": 146945,
                        "name": "Abdol Rahim",
                        "latitude": "34.62638889",
                        "longitude": "49.01750000"
                    },
                    {
                        "id": 146946,
                        "name": "Abrumand",
                        "latitude": "34.90277778",
                        "longitude": "48.32027778"
                    },
                    {
                        "id": 146947,
                        "name": "Abshineh",
                        "latitude": "34.78194400",
                        "longitude": "48.61472200"
                    },
                    {
                        "id": 146948,
                        "name": "Abu ol Fathabad",
                        "latitude": "34.05666667",
                        "longitude": "48.50916667"
                    },
                    {
                        "id": 146949,
                        "name": "Aghcheh Qayah",
                        "latitude": "35.35000000",
                        "longitude": "48.34250000"
                    },
                    {
                        "id": 146950,
                        "name": "Ahmadabad-e Tappeh",
                        "latitude": "34.61277778",
                        "longitude": "48.99277778"
                    },
                    {
                        "id": 146951,
                        "name": "Ahu Tappeh",
                        "latitude": "34.93777778",
                        "longitude": "48.00111111"
                    },
                    {
                        "id": 146952,
                        "name": "Ajin",
                        "latitude": "34.73611111",
                        "longitude": "47.92416667"
                    },
                    {
                        "id": 146953,
                        "name": "Ajorlu",
                        "latitude": "35.13833333",
                        "longitude": "49.22944444"
                    },
                    {
                        "id": 146954,
                        "name": "Akanlu",
                        "latitude": "35.61416667",
                        "longitude": "48.18805556"
                    },
                    {
                        "id": 146955,
                        "name": "Akleh",
                        "latitude": "35.20277778",
                        "longitude": "49.08250000"
                    },
                    {
                        "id": 146956,
                        "name": "Alan-e Sofla",
                        "latitude": "35.28416667",
                        "longitude": "48.21583333"
                    },
                    {
                        "id": 146957,
                        "name": "Alanjeh",
                        "latitude": "34.75083333",
                        "longitude": "47.95972222"
                    },
                    {
                        "id": 146958,
                        "name": "Alfavut",
                        "latitude": "34.64000000",
                        "longitude": "48.74972222"
                    },
                    {
                        "id": 146959,
                        "name": "Aliabad-e Posht Shahr",
                        "latitude": "34.83777778",
                        "longitude": "48.51111111"
                    },
                    {
                        "id": 146960,
                        "name": "Amirabad-e Kord",
                        "latitude": "34.97611111",
                        "longitude": "49.09166667"
                    },
                    {
                        "id": 146961,
                        "name": "Amzajerd",
                        "latitude": "34.93666667",
                        "longitude": "48.53250000"
                    },
                    {
                        "id": 146962,
                        "name": "Angoshteh",
                        "latitude": "34.09138900",
                        "longitude": "48.54000000"
                    },
                    {
                        "id": 146963,
                        "name": "Anjir Baghi",
                        "latitude": "35.19250000",
                        "longitude": "48.53166667"
                    },
                    {
                        "id": 146964,
                        "name": "Ansar ol Emam",
                        "latitude": "34.85861111",
                        "longitude": "48.49083333"
                    },
                    {
                        "id": 146965,
                        "name": "Anuch",
                        "latitude": "34.10805600",
                        "longitude": "48.57333300"
                    },
                    {
                        "id": 146966,
                        "name": "Aq Bolagh-e Aqdaq",
                        "latitude": "35.61166667",
                        "longitude": "48.44138889"
                    },
                    {
                        "id": 146967,
                        "name": "Aq Bolagh-e Latgah",
                        "latitude": "34.98444400",
                        "longitude": "48.55527800"
                    },
                    {
                        "id": 146968,
                        "name": "Aq Bolagh-e Morshed",
                        "latitude": "35.61777778",
                        "longitude": "48.02972222"
                    },
                    {
                        "id": 146969,
                        "name": "Aq Chay",
                        "latitude": "35.47916667",
                        "longitude": "49.10388889"
                    },
                    {
                        "id": 146970,
                        "name": "Aqa Bolaghi",
                        "latitude": "35.36694444",
                        "longitude": "48.24361111"
                    },
                    {
                        "id": 146971,
                        "name": "Aqa Jan Bolaghi",
                        "latitude": "34.84583333",
                        "longitude": "48.05305556"
                    },
                    {
                        "id": 146972,
                        "name": "Aqaj",
                        "latitude": "34.95583333",
                        "longitude": "49.32416667"
                    },
                    {
                        "id": 146973,
                        "name": "Aqcheh Kharabeh",
                        "latitude": "35.71361111",
                        "longitude": "48.77638889"
                    },
                    {
                        "id": 146974,
                        "name": "Aqchelu",
                        "latitude": "35.13138889",
                        "longitude": "48.49166667"
                    },
                    {
                        "id": 146975,
                        "name": "Arges-e Sofla",
                        "latitude": "34.07388889",
                        "longitude": "48.86388889"
                    },
                    {
                        "id": 146976,
                        "name": "Arikan",
                        "latitude": "34.53222222",
                        "longitude": "48.36055556"
                    },
                    {
                        "id": 146977,
                        "name": "Arpa Darreh",
                        "latitude": "35.69138889",
                        "longitude": "48.80500000"
                    },
                    {
                        "id": 146978,
                        "name": "Arteh Bolagh",
                        "latitude": "34.32638889",
                        "longitude": "48.54916667"
                    },
                    {
                        "id": 146979,
                        "name": "Artiman",
                        "latitude": "34.57944400",
                        "longitude": "48.44777800"
                    },
                    {
                        "id": 146980,
                        "name": "Arzan Fud",
                        "latitude": "34.65527778",
                        "longitude": "48.65416667"
                    },
                    {
                        "id": 146981,
                        "name": "Arzuvaj",
                        "latitude": "34.65444444",
                        "longitude": "48.37305556"
                    },
                    {
                        "id": 146982,
                        "name": "Asadabad",
                        "latitude": "34.78222222",
                        "longitude": "48.11833333"
                    },
                    {
                        "id": 146983,
                        "name": "Ashmizan",
                        "latitude": "34.10361111",
                        "longitude": "48.88444444"
                    },
                    {
                        "id": 146984,
                        "name": "Avarzaman",
                        "latitude": "34.26638889",
                        "longitude": "48.51222222"
                    },
                    {
                        "id": 146985,
                        "name": "Azandarian",
                        "latitude": "34.50888889",
                        "longitude": "48.68666667"
                    },
                    {
                        "id": 146986,
                        "name": "Aznahri",
                        "latitude": "34.23750000",
                        "longitude": "48.14833333"
                    },
                    {
                        "id": 146987,
                        "name": "Baba Khanjar",
                        "latitude": "35.55166667",
                        "longitude": "48.54972222"
                    },
                    {
                        "id": 146988,
                        "name": "Baba Pir",
                        "latitude": "34.61416667",
                        "longitude": "48.40194444"
                    },
                    {
                        "id": 146989,
                        "name": "Baba Qasem",
                        "latitude": "34.08000000",
                        "longitude": "48.44805556"
                    },
                    {
                        "id": 146990,
                        "name": "Babolqani",
                        "latitude": "34.24277778",
                        "longitude": "49.05750000"
                    },
                    {
                        "id": 146991,
                        "name": "Bad Khvoreh",
                        "latitude": "34.74305556",
                        "longitude": "48.08027778"
                    },
                    {
                        "id": 146992,
                        "name": "Bahar",
                        "latitude": "34.90694444",
                        "longitude": "48.44138889"
                    },
                    {
                        "id": 146993,
                        "name": "Band Aman",
                        "latitude": "34.22388889",
                        "longitude": "48.22861111"
                    },
                    {
                        "id": 146994,
                        "name": "Banesareh",
                        "latitude": "34.23750000",
                        "longitude": "48.43333333"
                    },
                    {
                        "id": 146995,
                        "name": "Baraband",
                        "latitude": "34.75194444",
                        "longitude": "48.79861111"
                    },
                    {
                        "id": 146996,
                        "name": "Bargecheh",
                        "latitude": "34.45138900",
                        "longitude": "48.30111100"
                    },
                    {
                        "id": 146997,
                        "name": "Barreh Farakh",
                        "latitude": "34.38555556",
                        "longitude": "48.08638889"
                    },
                    {
                        "id": 146998,
                        "name": "Barzul",
                        "latitude": "34.21277778",
                        "longitude": "48.25888889"
                    },
                    {
                        "id": 146999,
                        "name": "Bashqurtaran",
                        "latitude": "35.63722222",
                        "longitude": "48.11694444"
                    },
                    {
                        "id": 147000,
                        "name": "Bazeran",
                        "latitude": "35.15611111",
                        "longitude": "49.42305556"
                    },
                    {
                        "id": 147001,
                        "name": "Behkandan",
                        "latitude": "35.27222222",
                        "longitude": "49.09888889"
                    },
                    {
                        "id": 147002,
                        "name": "Belartu",
                        "latitude": "34.33555556",
                        "longitude": "48.51583333"
                    },
                    {
                        "id": 147003,
                        "name": "Beshik Tappeh",
                        "latitude": "35.53611111",
                        "longitude": "48.41805556"
                    },
                    {
                        "id": 147004,
                        "name": "Biaj",
                        "latitude": "34.81500000",
                        "longitude": "48.09916667"
                    },
                    {
                        "id": 147005,
                        "name": "Biatan-e Sofla",
                        "latitude": "34.02527778",
                        "longitude": "48.95805556"
                    },
                    {
                        "id": 147006,
                        "name": "Bid Korpeh-ye Sofla",
                        "latitude": "34.02111111",
                        "longitude": "48.89166667"
                    },
                    {
                        "id": 147007,
                        "name": "Bid Korpeh-ye Vosta",
                        "latitude": "34.01944444",
                        "longitude": "48.88722222"
                    },
                    {
                        "id": 147008,
                        "name": "Bifanaj",
                        "latitude": "34.61472222",
                        "longitude": "48.01694444"
                    },
                    {
                        "id": 147009,
                        "name": "Bighash",
                        "latitude": "34.09111111",
                        "longitude": "49.06833333"
                    },
                    {
                        "id": 147010,
                        "name": "Bish Aghaj",
                        "latitude": "34.46111111",
                        "longitude": "48.78583333"
                    },
                    {
                        "id": 147011,
                        "name": "Bitervan",
                        "latitude": "34.65444444",
                        "longitude": "47.91055556"
                    },
                    {
                        "id": 147012,
                        "name": "Borjaki",
                        "latitude": "34.32861111",
                        "longitude": "48.03305556"
                    },
                    {
                        "id": 147013,
                        "name": "Boyukabad",
                        "latitude": "35.05972222",
                        "longitude": "48.84166667"
                    },
                    {
                        "id": 147014,
                        "name": "Bozchalu",
                        "latitude": "35.16888889",
                        "longitude": "49.22444444"
                    },
                    {
                        "id": 147015,
                        "name": "Bozineh Jerd",
                        "latitude": "35.02472222",
                        "longitude": "48.94388889"
                    },
                    {
                        "id": 147016,
                        "name": "Bujin",
                        "latitude": "34.80722222",
                        "longitude": "48.05916667"
                    },
                    {
                        "id": 147017,
                        "name": "Bustandar",
                        "latitude": "34.44861111",
                        "longitude": "48.41944444"
                    },
                    {
                        "id": 147018,
                        "name": "Buyaqchi",
                        "latitude": "34.84750000",
                        "longitude": "49.08916667"
                    },
                    {
                        "id": 147019,
                        "name": "Chahar Bolagh",
                        "latitude": "35.58111111",
                        "longitude": "48.65000000"
                    },
                    {
                        "id": 147020,
                        "name": "Chal Boqa",
                        "latitude": "35.42055556",
                        "longitude": "48.92750000"
                    },
                    {
                        "id": 147021,
                        "name": "Chaleh Kand",
                        "latitude": "35.27500000",
                        "longitude": "48.29944444"
                    },
                    {
                        "id": 147022,
                        "name": "Charoq",
                        "latitude": "34.84416667",
                        "longitude": "48.06611111"
                    },
                    {
                        "id": 147023,
                        "name": "Chasht Khvoreh",
                        "latitude": "34.46444444",
                        "longitude": "48.26694444"
                    },
                    {
                        "id": 147024,
                        "name": "Chenari",
                        "latitude": "34.23194444",
                        "longitude": "48.17611111"
                    },
                    {
                        "id": 147025,
                        "name": "Cheshmeh Malek",
                        "latitude": "34.75500000",
                        "longitude": "48.49305556"
                    },
                    {
                        "id": 147026,
                        "name": "Cheshmeh Pahn-e Nanaj",
                        "latitude": "34.45888889",
                        "longitude": "48.76750000"
                    },
                    {
                        "id": 147027,
                        "name": "Cheshmeh Qandab",
                        "latitude": "34.62694444",
                        "longitude": "48.09111111"
                    },
                    {
                        "id": 147028,
                        "name": "Cheshmeh Qareh",
                        "latitude": "34.90611111",
                        "longitude": "47.87111111"
                    },
                    {
                        "id": 147029,
                        "name": "Cheshmeh Qassaban",
                        "latitude": "34.85777778",
                        "longitude": "48.41888889"
                    },
                    {
                        "id": 147030,
                        "name": "Cheshmeh Valad",
                        "latitude": "34.87805556",
                        "longitude": "47.98388889"
                    },
                    {
                        "id": 147031,
                        "name": "Cheshmeh Zowraq",
                        "latitude": "34.06611111",
                        "longitude": "49.10083333"
                    },
                    {
                        "id": 147032,
                        "name": "Choqa Sarahi",
                        "latitude": "34.31527778",
                        "longitude": "48.04888889"
                    },
                    {
                        "id": 147033,
                        "name": "Chowtash",
                        "latitude": "34.83694444",
                        "longitude": "48.25194444"
                    },
                    {
                        "id": 147034,
                        "name": "Chulak Qapanuri",
                        "latitude": "34.23472222",
                        "longitude": "48.30000000"
                    },
                    {
                        "id": 147035,
                        "name": "Dahnejerd",
                        "latitude": "34.96750000",
                        "longitude": "48.50055600"
                    },
                    {
                        "id": 147036,
                        "name": "Dali Chu",
                        "latitude": "35.52138889",
                        "longitude": "48.02027778"
                    },
                    {
                        "id": 147037,
                        "name": "Damaq",
                        "latitude": "35.44277778",
                        "longitude": "48.82305556"
                    },
                    {
                        "id": 147038,
                        "name": "Daqdaqabad",
                        "latitude": "35.18277778",
                        "longitude": "48.78833333"
                    },
                    {
                        "id": 147039,
                        "name": "Dar Qeshlaq",
                        "latitude": "35.49222222",
                        "longitude": "48.05583333"
                    },
                    {
                        "id": 147040,
                        "name": "Darani-ye Sofla",
                        "latitude": "34.49888889",
                        "longitude": "48.41222222"
                    },
                    {
                        "id": 147041,
                        "name": "Darcham",
                        "latitude": "34.26027778",
                        "longitude": "48.82083333"
                    },
                    {
                        "id": 147042,
                        "name": "Darreh Chenar",
                        "latitude": "34.09944444",
                        "longitude": "48.80305556"
                    },
                    {
                        "id": 147043,
                        "name": "Darreh Mianeh-ye Sofla",
                        "latitude": "34.07277778",
                        "longitude": "48.83527778"
                    },
                    {
                        "id": 147044,
                        "name": "Darreh Mirza",
                        "latitude": "34.37611111",
                        "longitude": "48.00750000"
                    },
                    {
                        "id": 147045,
                        "name": "Darreh-ye Ebrahim",
                        "latitude": "34.10166667",
                        "longitude": "48.39444444"
                    },
                    {
                        "id": 147046,
                        "name": "Darsibeh",
                        "latitude": "34.26972222",
                        "longitude": "48.00694444"
                    },
                    {
                        "id": 147047,
                        "name": "Davijan",
                        "latitude": "34.22027778",
                        "longitude": "48.85833333"
                    },
                    {
                        "id": 147048,
                        "name": "Deh Chaneh",
                        "latitude": "34.10527778",
                        "longitude": "49.12027778"
                    },
                    {
                        "id": 147049,
                        "name": "Deh Dalian",
                        "latitude": "34.80472222",
                        "longitude": "48.71138889"
                    },
                    {
                        "id": 147050,
                        "name": "Deh Ful",
                        "latitude": "34.22694444",
                        "longitude": "48.31388889"
                    },
                    {
                        "id": 147051,
                        "name": "Deh Mianeh",
                        "latitude": "34.17305556",
                        "longitude": "49.04944444"
                    },
                    {
                        "id": 147052,
                        "name": "Deh Nush",
                        "latitude": "34.76111111",
                        "longitude": "48.00305556"
                    },
                    {
                        "id": 147053,
                        "name": "Deh Piaz",
                        "latitude": "34.88194444",
                        "longitude": "48.51472222"
                    },
                    {
                        "id": 147054,
                        "name": "Deh-e Shaker",
                        "latitude": "34.37888889",
                        "longitude": "48.54777778"
                    },
                    {
                        "id": 147055,
                        "name": "Dehnow-e Avarzaman",
                        "latitude": "34.30694444",
                        "longitude": "48.55694444"
                    },
                    {
                        "id": 147056,
                        "name": "Dingeleh Kahriz",
                        "latitude": "34.81111111",
                        "longitude": "48.68472222"
                    },
                    {
                        "id": 147057,
                        "name": "Do Rudan",
                        "latitude": "34.55972222",
                        "longitude": "48.41472222"
                    },
                    {
                        "id": 147058,
                        "name": "Doraneh",
                        "latitude": "34.23138889",
                        "longitude": "48.21944444"
                    },
                    {
                        "id": 147059,
                        "name": "Dorudgaran",
                        "latitude": "34.02027800",
                        "longitude": "48.92472200"
                    },
                    {
                        "id": 147060,
                        "name": "Dow Baraleh",
                        "latitude": "34.90222222",
                        "longitude": "48.03361111"
                    },
                    {
                        "id": 147061,
                        "name": "Dowlatabad-e Hajjilu",
                        "latitude": "35.28111111",
                        "longitude": "48.88694444"
                    },
                    {
                        "id": 147062,
                        "name": "Dowlujerdin-e Bala",
                        "latitude": "35.34777778",
                        "longitude": "49.10944444"
                    },
                    {
                        "id": 147063,
                        "name": "Durijan",
                        "latitude": "34.30555556",
                        "longitude": "48.48972222"
                    },
                    {
                        "id": 147064,
                        "name": "Durnian",
                        "latitude": "35.48194444",
                        "longitude": "49.04000000"
                    },
                    {
                        "id": 147065,
                        "name": "Emamzadeh Khatun",
                        "latitude": "34.04972222",
                        "longitude": "48.95222222"
                    },
                    {
                        "id": 147066,
                        "name": "Emamzadeh Pir Nahan",
                        "latitude": "35.01138889",
                        "longitude": "49.04111111"
                    },
                    {
                        "id": 147067,
                        "name": "Eskanan",
                        "latitude": "34.35805556",
                        "longitude": "48.59277778"
                    },
                    {
                        "id": 147068,
                        "name": "Fahrumand",
                        "latitude": "34.22416667",
                        "longitude": "48.31194444"
                    },
                    {
                        "id": 147069,
                        "name": "Famast",
                        "latitude": "34.03897000",
                        "longitude": "48.46260000"
                    },
                    {
                        "id": 147070,
                        "name": "Famenin",
                        "latitude": "35.11388889",
                        "longitude": "48.97166667"
                    },
                    {
                        "id": 147071,
                        "name": "Farasfaj",
                        "latitude": "34.48611111",
                        "longitude": "48.28555556"
                    },
                    {
                        "id": 147072,
                        "name": "Farsban",
                        "latitude": "34.24416667",
                        "longitude": "48.11916667"
                    },
                    {
                        "id": 147073,
                        "name": "Farvaz",
                        "latitude": "34.22694444",
                        "longitude": "48.90111111"
                    },
                    {
                        "id": 147074,
                        "name": "Faryazan",
                        "latitude": "34.52305600",
                        "longitude": "48.33250000"
                    },
                    {
                        "id": 147075,
                        "name": "Fasijan",
                        "latitude": "34.83666667",
                        "longitude": "48.30472222"
                    },
                    {
                        "id": 147076,
                        "name": "Fiazaman",
                        "latitude": "34.13111111",
                        "longitude": "48.39638889"
                    },
                    {
                        "id": 147077,
                        "name": "Firuzabad-e Sofla",
                        "latitude": "34.34694444",
                        "longitude": "48.09638889"
                    },
                    {
                        "id": 147078,
                        "name": "Firuzan",
                        "latitude": "34.27861111",
                        "longitude": "48.24000000"
                    },
                    {
                        "id": 147079,
                        "name": "Gamasa",
                        "latitude": "34.23027778",
                        "longitude": "49.08750000"
                    },
                    {
                        "id": 147080,
                        "name": "Gamasb",
                        "latitude": "34.04000000",
                        "longitude": "48.46500000"
                    },
                    {
                        "id": 147081,
                        "name": "Ganj Tappeh",
                        "latitude": "34.93333300",
                        "longitude": "48.46361100"
                    },
                    {
                        "id": 147082,
                        "name": "Ganjab",
                        "latitude": "34.45277778",
                        "longitude": "48.98722222"
                    },
                    {
                        "id": 147083,
                        "name": "Gashani",
                        "latitude": "34.66055556",
                        "longitude": "48.39138889"
                    },
                    {
                        "id": 147084,
                        "name": "Gav Zaban",
                        "latitude": "35.22916667",
                        "longitude": "48.30527778"
                    },
                    {
                        "id": 147085,
                        "name": "Gavkaran",
                        "latitude": "34.48694444",
                        "longitude": "48.12000000"
                    },
                    {
                        "id": 147086,
                        "name": "Ghazyatan",
                        "latitude": "35.33222222",
                        "longitude": "48.93166667"
                    },
                    {
                        "id": 147087,
                        "name": "Gholam Veys",
                        "latitude": "35.63000000",
                        "longitude": "48.52583333"
                    },
                    {
                        "id": 147088,
                        "name": "Givaki",
                        "latitude": "34.27250000",
                        "longitude": "48.08111111"
                    },
                    {
                        "id": 147089,
                        "name": "Giyan",
                        "latitude": "34.17805556",
                        "longitude": "48.24416667"
                    },
                    {
                        "id": 147090,
                        "name": "Gol Darreh-ye Anuch",
                        "latitude": "34.10222222",
                        "longitude": "48.59861111"
                    },
                    {
                        "id": 147091,
                        "name": "Gol Heydar",
                        "latitude": "34.06250000",
                        "longitude": "48.41666667"
                    },
                    {
                        "id": 151011,
                        "name": "Gol Tappeh",
                        "latitude": "35.22083550",
                        "longitude": "48.19597000"
                    },
                    {
                        "id": 147092,
                        "name": "Golparabad",
                        "latitude": "34.15500000",
                        "longitude": "49.05777778"
                    },
                    {
                        "id": 147093,
                        "name": "Golshir",
                        "latitude": "34.40000000",
                        "longitude": "48.68333333"
                    },
                    {
                        "id": 147094,
                        "name": "Golushjerd",
                        "latitude": "34.36611111",
                        "longitude": "48.79000000"
                    },
                    {
                        "id": 147095,
                        "name": "Gomush Bolagh",
                        "latitude": "34.93194444",
                        "longitude": "48.28972222"
                    },
                    {
                        "id": 147096,
                        "name": "Gonbad Chay",
                        "latitude": "34.86833300",
                        "longitude": "48.83138900"
                    },
                    {
                        "id": 147097,
                        "name": "Gonbad-e Kabud",
                        "latitude": "34.21722222",
                        "longitude": "48.14777778"
                    },
                    {
                        "id": 147098,
                        "name": "Gostar",
                        "latitude": "35.46388889",
                        "longitude": "48.87638889"
                    },
                    {
                        "id": 147099,
                        "name": "Gozal Abdal",
                        "latitude": "35.32166667",
                        "longitude": "48.23861111"
                    },
                    {
                        "id": 147100,
                        "name": "Gug Qash",
                        "latitude": "35.68750000",
                        "longitude": "48.02530000"
                    },
                    {
                        "id": 147101,
                        "name": "Gujak",
                        "latitude": "34.54083333",
                        "longitude": "48.84027778"
                    },
                    {
                        "id": 147102,
                        "name": "Gulvand",
                        "latitude": "34.38083333",
                        "longitude": "48.97527778"
                    },
                    {
                        "id": 147103,
                        "name": "Gunestan",
                        "latitude": "34.03027778",
                        "longitude": "48.91833333"
                    },
                    {
                        "id": 147104,
                        "name": "Gur Gaz",
                        "latitude": "34.93333333",
                        "longitude": "48.79111111"
                    },
                    {
                        "id": 147105,
                        "name": "Gurjiu",
                        "latitude": "34.18583333",
                        "longitude": "48.40555556"
                    },
                    {
                        "id": 147106,
                        "name": "Gushalan",
                        "latitude": "34.83500000",
                        "longitude": "48.32250000"
                    },
                    {
                        "id": 147107,
                        "name": "Gusheh-ye Kasavand",
                        "latitude": "34.15527778",
                        "longitude": "48.95944444"
                    },
                    {
                        "id": 147108,
                        "name": "Hajji Kheder",
                        "latitude": "34.12722222",
                        "longitude": "48.74833333"
                    },
                    {
                        "id": 147109,
                        "name": "Hajji Maqsud",
                        "latitude": "34.96972222",
                        "longitude": "48.87972222"
                    },
                    {
                        "id": 147110,
                        "name": "Hajji Tu",
                        "latitude": "34.45083300",
                        "longitude": "48.35361100"
                    },
                    {
                        "id": 147111,
                        "name": "Hamadan",
                        "latitude": "34.80000000",
                        "longitude": "48.51666667"
                    },
                    {
                        "id": 151014,
                        "name": "Hamedan",
                        "latitude": "34.81230870",
                        "longitude": "48.44002710"
                    },
                    {
                        "id": 147112,
                        "name": "Hamilabad",
                        "latitude": "34.40250000",
                        "longitude": "48.46083333"
                    },
                    {
                        "id": 147113,
                        "name": "Hamzehlu-ye Sofla",
                        "latitude": "34.05777778",
                        "longitude": "49.07777778"
                    },
                    {
                        "id": 147114,
                        "name": "Haramabad",
                        "latitude": "34.28166667",
                        "longitude": "48.78250000"
                    },
                    {
                        "id": 147115,
                        "name": "Hasan Kusej",
                        "latitude": "34.24833333",
                        "longitude": "48.57527778"
                    },
                    {
                        "id": 147116,
                        "name": "Hasan Teymur",
                        "latitude": "35.37583333",
                        "longitude": "48.36361111"
                    },
                    {
                        "id": 147117,
                        "name": "Hasanabad-e Emam",
                        "latitude": "34.95027778",
                        "longitude": "48.05083333"
                    },
                    {
                        "id": 147118,
                        "name": "Hasanabad-e Qush Bolagh",
                        "latitude": "34.42361111",
                        "longitude": "48.65444444"
                    },
                    {
                        "id": 147119,
                        "name": "Hasanabad-e Sheverin",
                        "latitude": "34.84250000",
                        "longitude": "48.54916667"
                    },
                    {
                        "id": 147120,
                        "name": "Heriraz",
                        "latitude": "34.20527778",
                        "longitude": "48.74305556"
                    },
                    {
                        "id": 147121,
                        "name": "Hesar-e Qarah Baghi",
                        "latitude": "34.82250000",
                        "longitude": "48.26861111"
                    },
                    {
                        "id": 147122,
                        "name": "Hesar-e Qujeh Baghi",
                        "latitude": "35.23861111",
                        "longitude": "48.55972222"
                    },
                    {
                        "id": 147123,
                        "name": "Heydareh-ye Dar-e Emam",
                        "latitude": "34.82055556",
                        "longitude": "48.34694444"
                    },
                    {
                        "id": 147124,
                        "name": "Heydareh-ye Posht-e Shahr",
                        "latitude": "34.80250000",
                        "longitude": "48.45750000"
                    },
                    {
                        "id": 147125,
                        "name": "Hizaj",
                        "latitude": "34.93000000",
                        "longitude": "49.14333333"
                    },
                    {
                        "id": 147126,
                        "name": "Holvar-e Sofla",
                        "latitude": "34.68000000",
                        "longitude": "48.13472222"
                    },
                    {
                        "id": 147127,
                        "name": "Hom-e Khosrow",
                        "latitude": "34.31472222",
                        "longitude": "48.01000000"
                    },
                    {
                        "id": 147128,
                        "name": "Horhoreh",
                        "latitude": "34.39111111",
                        "longitude": "48.36027778"
                    },
                    {
                        "id": 147129,
                        "name": "Hoseynabad-e Bahar",
                        "latitude": "34.86750000",
                        "longitude": "48.36833333"
                    },
                    {
                        "id": 147130,
                        "name": "Hoseynabad-e Nazem",
                        "latitude": "34.29527800",
                        "longitude": "48.60416700"
                    },
                    {
                        "id": 147131,
                        "name": "Hoseynabad-e Shamlu",
                        "latitude": "34.44611111",
                        "longitude": "48.62055556"
                    },
                    {
                        "id": 147132,
                        "name": "Hudaraj",
                        "latitude": "34.73361111",
                        "longitude": "48.16194444"
                    },
                    {
                        "id": 147133,
                        "name": "Iraneh",
                        "latitude": "34.24305556",
                        "longitude": "48.59750000"
                    },
                    {
                        "id": 147134,
                        "name": "Isti Bolagh",
                        "latitude": "35.69500000",
                        "longitude": "48.26611111"
                    },
                    {
                        "id": 147135,
                        "name": "Jamishlu",
                        "latitude": "35.24583333",
                        "longitude": "48.97666667"
                    },
                    {
                        "id": 147136,
                        "name": "Jaria",
                        "latitude": "34.35166667",
                        "longitude": "48.46861111"
                    },
                    {
                        "id": 147137,
                        "name": "Javar Sajin",
                        "latitude": "35.28583333",
                        "longitude": "49.22138889"
                    },
                    {
                        "id": 147138,
                        "name": "Jerbanlu",
                        "latitude": "35.58638889",
                        "longitude": "48.92916667"
                    },
                    {
                        "id": 147139,
                        "name": "Jighi",
                        "latitude": "35.20027778",
                        "longitude": "48.49388889"
                    },
                    {
                        "id": 147140,
                        "name": "Jijan Kuh",
                        "latitude": "34.48111111",
                        "longitude": "48.50694444"
                    },
                    {
                        "id": 147141,
                        "name": "Jijian Rud",
                        "latitude": "34.35638889",
                        "longitude": "48.60861111"
                    },
                    {
                        "id": 147142,
                        "name": "Jin Taraqayah",
                        "latitude": "35.34555556",
                        "longitude": "48.43250000"
                    },
                    {
                        "id": 151012,
                        "name": "Jowkar",
                        "latitude": "34.43034520",
                        "longitude": "48.67798440"
                    },
                    {
                        "id": 147143,
                        "name": "Juraqan",
                        "latitude": "34.88472222",
                        "longitude": "48.55444444"
                    },
                    {
                        "id": 147144,
                        "name": "Kaboodrahang",
                        "latitude": "35.20833333",
                        "longitude": "48.72388889"
                    },
                    {
                        "id": 151010,
                        "name": "Kabudrahang",
                        "latitude": "35.20939460",
                        "longitude": "48.70679130"
                    },
                    {
                        "id": 147145,
                        "name": "Kahard",
                        "latitude": "35.28555556",
                        "longitude": "49.00527778"
                    },
                    {
                        "id": 147146,
                        "name": "Kahkadan",
                        "latitude": "34.14388889",
                        "longitude": "48.65805556"
                    },
                    {
                        "id": 147147,
                        "name": "Kahriz-e Baba Hoseyn",
                        "latitude": "35.53388889",
                        "longitude": "47.94027778"
                    },
                    {
                        "id": 147148,
                        "name": "Kahriz-e Boqazi",
                        "latitude": "35.51138889",
                        "longitude": "48.81833333"
                    },
                    {
                        "id": 147149,
                        "name": "Kahriz-e Hoseynabad-e Nazem",
                        "latitude": "34.31888889",
                        "longitude": "48.62777778"
                    },
                    {
                        "id": 147150,
                        "name": "Kahriz-e Jamal",
                        "latitude": "34.33500000",
                        "longitude": "48.14611111"
                    },
                    {
                        "id": 147151,
                        "name": "Kahriz-e Salim",
                        "latitude": "34.32888889",
                        "longitude": "48.16222222"
                    },
                    {
                        "id": 147152,
                        "name": "Kal Kabud",
                        "latitude": "35.48083333",
                        "longitude": "48.85277778"
                    },
                    {
                        "id": 147153,
                        "name": "Kalb Hesari",
                        "latitude": "35.36694444",
                        "longitude": "48.39583333"
                    },
                    {
                        "id": 147154,
                        "name": "Kalilabad",
                        "latitude": "34.33916667",
                        "longitude": "48.54472222"
                    },
                    {
                        "id": 147155,
                        "name": "Kamak-e Sofla",
                        "latitude": "34.88750000",
                        "longitude": "47.96861111"
                    },
                    {
                        "id": 147156,
                        "name": "Kamar Boneh",
                        "latitude": "34.17500000",
                        "longitude": "48.63500000"
                    },
                    {
                        "id": 147157,
                        "name": "Kamazan",
                        "latitude": "34.15083333",
                        "longitude": "48.95333333"
                    },
                    {
                        "id": 147158,
                        "name": "Kand Halan",
                        "latitude": "34.50111111",
                        "longitude": "48.78194444"
                    },
                    {
                        "id": 147159,
                        "name": "Kand Tappeh",
                        "latitude": "35.20138889",
                        "longitude": "48.30555556"
                    },
                    {
                        "id": 147160,
                        "name": "Kand-e Bolaghi",
                        "latitude": "35.43000000",
                        "longitude": "48.32277778"
                    },
                    {
                        "id": 147161,
                        "name": "Kangavar-e Kohneh",
                        "latitude": "34.34194444",
                        "longitude": "47.97611111"
                    },
                    {
                        "id": 147162,
                        "name": "Karafs",
                        "latitude": "35.36333333",
                        "longitude": "49.29888889"
                    },
                    {
                        "id": 147163,
                        "name": "Kark-e Sofla",
                        "latitude": "34.16944444",
                        "longitude": "48.29138889"
                    },
                    {
                        "id": 147164,
                        "name": "Kartilabad",
                        "latitude": "34.31361111",
                        "longitude": "48.64916667"
                    },
                    {
                        "id": 147165,
                        "name": "Kasavand",
                        "latitude": "34.15222222",
                        "longitude": "48.96972222"
                    },
                    {
                        "id": 147166,
                        "name": "Kaslan Qayah",
                        "latitude": "35.19388889",
                        "longitude": "48.18611111"
                    },
                    {
                        "id": 147167,
                        "name": "Kavanaj",
                        "latitude": "34.66388889",
                        "longitude": "47.89694444"
                    },
                    {
                        "id": 147168,
                        "name": "Kesb",
                        "latitude": "34.41416667",
                        "longitude": "48.72250000"
                    },
                    {
                        "id": 147169,
                        "name": "Keykaleh",
                        "latitude": "34.11500000",
                        "longitude": "48.93916667"
                    },
                    {
                        "id": 147170,
                        "name": "Keyni Sayeh",
                        "latitude": "34.82583333",
                        "longitude": "47.88638889"
                    },
                    {
                        "id": 147171,
                        "name": "Khabar Arkhi",
                        "latitude": "35.36333333",
                        "longitude": "48.27666667"
                    },
                    {
                        "id": 147172,
                        "name": "Khaku",
                        "latitude": "34.72638889",
                        "longitude": "48.53638889"
                    },
                    {
                        "id": 147173,
                        "name": "Khaleq Verdi",
                        "latitude": "35.41083333",
                        "longitude": "48.18111111"
                    },
                    {
                        "id": 147174,
                        "name": "Khalil Kord",
                        "latitude": "34.97805556",
                        "longitude": "48.25305556"
                    },
                    {
                        "id": 147175,
                        "name": "Kheradmand",
                        "latitude": "34.62583333",
                        "longitude": "48.93138889"
                    },
                    {
                        "id": 147176,
                        "name": "Kheyr Qoli",
                        "latitude": "34.20222222",
                        "longitude": "48.40138889"
                    },
                    {
                        "id": 147177,
                        "name": "Khomeygan",
                        "latitude": "35.36972222",
                        "longitude": "49.02333333"
                    },
                    {
                        "id": 147178,
                        "name": "Khvajeh Hesar",
                        "latitude": "35.00000000",
                        "longitude": "49.33916667"
                    },
                    {
                        "id": 147179,
                        "name": "Khvajeh Hoseyni",
                        "latitude": "34.15500000",
                        "longitude": "48.37861111"
                    },
                    {
                        "id": 147180,
                        "name": "Khvajeh Kandi",
                        "latitude": "35.36194444",
                        "longitude": "48.38500000"
                    },
                    {
                        "id": 147181,
                        "name": "Khvoshab-e Sofla",
                        "latitude": "35.01777778",
                        "longitude": "48.35750000"
                    },
                    {
                        "id": 147182,
                        "name": "Kitu",
                        "latitude": "35.31972222",
                        "longitude": "48.15333333"
                    },
                    {
                        "id": 147183,
                        "name": "Kohnush",
                        "latitude": "34.72583333",
                        "longitude": "48.27777778"
                    },
                    {
                        "id": 147184,
                        "name": "Kolanjan",
                        "latitude": "34.59444444",
                        "longitude": "48.39250000"
                    },
                    {
                        "id": 147185,
                        "name": "Konjineh",
                        "latitude": "34.79222222",
                        "longitude": "48.62972222"
                    },
                    {
                        "id": 147186,
                        "name": "Kord Bolagh",
                        "latitude": "34.76722222",
                        "longitude": "48.65277778"
                    },
                    {
                        "id": 147187,
                        "name": "Korzan",
                        "latitude": "34.59444444",
                        "longitude": "48.35361111"
                    },
                    {
                        "id": 147188,
                        "name": "Kowzareh",
                        "latitude": "34.69861100",
                        "longitude": "49.01138900"
                    },
                    {
                        "id": 147189,
                        "name": "Kuhani",
                        "latitude": "34.15388900",
                        "longitude": "48.40500000"
                    },
                    {
                        "id": 147190,
                        "name": "Kur Kahriz",
                        "latitude": "34.71722222",
                        "longitude": "48.77333333"
                    },
                    {
                        "id": 147191,
                        "name": "Kusaj Khalil",
                        "latitude": "34.40416667",
                        "longitude": "48.58805556"
                    },
                    {
                        "id": 147192,
                        "name": "Kutah Darreh",
                        "latitude": "34.32055556",
                        "longitude": "47.95388889"
                    },
                    {
                        "id": 147193,
                        "name": "Laleh Dan",
                        "latitude": "35.58111111",
                        "longitude": "48.95416667"
                    },
                    {
                        "id": 147194,
                        "name": "Lalejin",
                        "latitude": "34.97444444",
                        "longitude": "48.47555556"
                    },
                    {
                        "id": 147195,
                        "name": "Lamiyan",
                        "latitude": "34.46277778",
                        "longitude": "48.19277778"
                    },
                    {
                        "id": 147196,
                        "name": "Latgah",
                        "latitude": "34.98944400",
                        "longitude": "48.54638900"
                    },
                    {
                        "id": 147197,
                        "name": "Lavashan",
                        "latitude": "34.25055556",
                        "longitude": "48.27416667"
                    },
                    {
                        "id": 147198,
                        "name": "Leyli Yadegar",
                        "latitude": "34.28583333",
                        "longitude": "48.21027778"
                    },
                    {
                        "id": 147199,
                        "name": "Luluhar",
                        "latitude": "34.31611111",
                        "longitude": "48.45416667"
                    },
                    {
                        "id": 147200,
                        "name": "Mahanabad",
                        "latitude": "34.18083333",
                        "longitude": "48.20972222"
                    },
                    {
                        "id": 147201,
                        "name": "Mahbar",
                        "latitude": "34.87611111",
                        "longitude": "48.80777778"
                    },
                    {
                        "id": 147202,
                        "name": "Mahdaviyeh",
                        "latitude": "34.08333333",
                        "longitude": "48.88333333"
                    },
                    {
                        "id": 147203,
                        "name": "Mahnian",
                        "latitude": "35.50250000",
                        "longitude": "49.06583333"
                    },
                    {
                        "id": 147204,
                        "name": "Malayer",
                        "latitude": "34.29416667",
                        "longitude": "48.82000000"
                    },
                    {
                        "id": 147205,
                        "name": "Malek-e Ashtar",
                        "latitude": "34.95222222",
                        "longitude": "48.31500000"
                    },
                    {
                        "id": 147206,
                        "name": "Malusan",
                        "latitude": "34.32333333",
                        "longitude": "48.33000000"
                    },
                    {
                        "id": 147207,
                        "name": "Mangavi",
                        "latitude": "34.65750000",
                        "longitude": "48.70861111"
                    },
                    {
                        "id": 147208,
                        "name": "Marvil",
                        "latitude": "34.16805556",
                        "longitude": "48.88694444"
                    },
                    {
                        "id": 147209,
                        "name": "Maryanaj",
                        "latitude": "34.83083333",
                        "longitude": "48.45916667"
                    },
                    {
                        "id": 147210,
                        "name": "Masjedin",
                        "latitude": "35.54277778",
                        "longitude": "48.26333333"
                    },
                    {
                        "id": 147211,
                        "name": "Menjan",
                        "latitude": "34.44805556",
                        "longitude": "48.23555556"
                    },
                    {
                        "id": 147212,
                        "name": "Mesinak",
                        "latitude": "35.27222222",
                        "longitude": "49.15111111"
                    },
                    {
                        "id": 147213,
                        "name": "Meyvaleh",
                        "latitude": "34.83194444",
                        "longitude": "47.85527778"
                    },
                    {
                        "id": 147214,
                        "name": "Mianzulan",
                        "latitude": "34.31222222",
                        "longitude": "48.51555556"
                    },
                    {
                        "id": 147215,
                        "name": "Mihamleh-ye Sofla",
                        "latitude": "35.10000000",
                        "longitude": "48.30805556"
                    },
                    {
                        "id": 147216,
                        "name": "Milab",
                        "latitude": "34.05277778",
                        "longitude": "48.47972222"
                    },
                    {
                        "id": 147217,
                        "name": "Mirza Hesari",
                        "latitude": "35.12750000",
                        "longitude": "48.45944400"
                    },
                    {
                        "id": 147218,
                        "name": "Mishen",
                        "latitude": "34.15750000",
                        "longitude": "48.92722222"
                    },
                    {
                        "id": 147219,
                        "name": "Mobarakin",
                        "latitude": "35.09805556",
                        "longitude": "49.42416667"
                    },
                    {
                        "id": 147220,
                        "name": "Mohajeran",
                        "latitude": "35.07388889",
                        "longitude": "48.61666667"
                    },
                    {
                        "id": 147221,
                        "name": "Mohammadabad-e Chulak",
                        "latitude": "34.24666667",
                        "longitude": "48.30444444"
                    },
                    {
                        "id": 147222,
                        "name": "Mohammadiyeh-e Sofla",
                        "latitude": "34.14611111",
                        "longitude": "48.33861111"
                    },
                    {
                        "id": 147223,
                        "name": "Mohara",
                        "latitude": "34.55527778",
                        "longitude": "48.86861111"
                    },
                    {
                        "id": 147224,
                        "name": "Mokarrabi",
                        "latitude": "34.62500000",
                        "longitude": "48.69777778"
                    },
                    {
                        "id": 147225,
                        "name": "Molham Darreh",
                        "latitude": "34.83138889",
                        "longitude": "48.14527778"
                    },
                    {
                        "id": 147226,
                        "name": "Molla Bodagh",
                        "latitude": "35.63138889",
                        "longitude": "48.73888889"
                    },
                    {
                        "id": 147227,
                        "name": "Monavvar Tappeh",
                        "latitude": "34.72027778",
                        "longitude": "47.91111111"
                    },
                    {
                        "id": 147228,
                        "name": "Morghabad",
                        "latitude": "35.18833333",
                        "longitude": "49.28277778"
                    },
                    {
                        "id": 147229,
                        "name": "Mowdaran",
                        "latitude": "34.33250000",
                        "longitude": "48.47138889"
                    },
                    {
                        "id": 147230,
                        "name": "Musa Bolaghi",
                        "latitude": "34.59888889",
                        "longitude": "48.94111111"
                    },
                    {
                        "id": 147231,
                        "name": "Nahandar",
                        "latitude": "34.14944444",
                        "longitude": "48.96833333"
                    },
                    {
                        "id": 147232,
                        "name": "Nahavand",
                        "latitude": "34.18833333",
                        "longitude": "48.37694444"
                    },
                    {
                        "id": 147233,
                        "name": "Najafiyeh",
                        "latitude": "34.55500000",
                        "longitude": "48.38638889"
                    },
                    {
                        "id": 147234,
                        "name": "Nakilabad",
                        "latitude": "34.36777778",
                        "longitude": "48.65694444"
                    },
                    {
                        "id": 147235,
                        "name": "Nakin",
                        "latitude": "35.38805556",
                        "longitude": "49.26527778"
                    },
                    {
                        "id": 147236,
                        "name": "Namileh",
                        "latitude": "34.27111111",
                        "longitude": "48.82000000"
                    },
                    {
                        "id": 147237,
                        "name": "Nanaj",
                        "latitude": "34.42000000",
                        "longitude": "48.75388889"
                    },
                    {
                        "id": 147238,
                        "name": "Nazul",
                        "latitude": "34.22833333",
                        "longitude": "48.71805556"
                    },
                    {
                        "id": 147239,
                        "name": "Negar Khatun",
                        "latitude": "35.11861111",
                        "longitude": "48.92555556"
                    },
                    {
                        "id": 147240,
                        "name": "Negarabad",
                        "latitude": "35.47583333",
                        "longitude": "48.53277778"
                    },
                    {
                        "id": 147241,
                        "name": "Nehenjeh",
                        "latitude": "34.54111111",
                        "longitude": "48.71722222"
                    },
                    {
                        "id": 147242,
                        "name": "Nesar",
                        "latitude": "34.07694444",
                        "longitude": "48.46861111"
                    },
                    {
                        "id": 147243,
                        "name": "Neshar",
                        "latitude": "34.67722222",
                        "longitude": "48.86694444"
                    },
                    {
                        "id": 147244,
                        "name": "Niyanj",
                        "latitude": "35.34861111",
                        "longitude": "48.91722222"
                    },
                    {
                        "id": 147245,
                        "name": "Nosratabad-e Behraz",
                        "latitude": "34.69222222",
                        "longitude": "48.08555556"
                    },
                    {
                        "id": 147246,
                        "name": "Nosratabad-e Laklak",
                        "latitude": "34.66472222",
                        "longitude": "47.96277778"
                    },
                    {
                        "id": 147247,
                        "name": "Nurabad-e Simineh",
                        "latitude": "34.82194444",
                        "longitude": "48.29277778"
                    },
                    {
                        "id": 147248,
                        "name": "Ojaq",
                        "latitude": "35.64000000",
                        "longitude": "48.84583333"
                    },
                    {
                        "id": 147249,
                        "name": "Ommatlar",
                        "latitude": "35.43611111",
                        "longitude": "48.96861111"
                    },
                    {
                        "id": 147250,
                        "name": "Oshtoran",
                        "latitude": "34.63805556",
                        "longitude": "48.29555556"
                    },
                    {
                        "id": 147251,
                        "name": "Oshtorjin",
                        "latitude": "34.77583333",
                        "longitude": "48.17222222"
                    },
                    {
                        "id": 147252,
                        "name": "Ovraqin",
                        "latitude": "35.28222222",
                        "longitude": "48.69111111"
                    },
                    {
                        "id": 147253,
                        "name": "Owrteh Qamish",
                        "latitude": "35.57083333",
                        "longitude": "48.62916667"
                    },
                    {
                        "id": 147254,
                        "name": "Owryad",
                        "latitude": "35.26277778",
                        "longitude": "48.37250000"
                    },
                    {
                        "id": 147255,
                        "name": "Pahnabad",
                        "latitude": "34.84166667",
                        "longitude": "48.61472222"
                    },
                    {
                        "id": 147256,
                        "name": "Panbeh Dar",
                        "latitude": "34.06527778",
                        "longitude": "48.44555556"
                    },
                    {
                        "id": 147257,
                        "name": "Parluk",
                        "latitude": "35.06555556",
                        "longitude": "48.24611111"
                    },
                    {
                        "id": 147258,
                        "name": "Parvaraq",
                        "latitude": "35.15583333",
                        "longitude": "48.76777778"
                    },
                    {
                        "id": 147259,
                        "name": "Payandeh",
                        "latitude": "35.44194444",
                        "longitude": "48.85305556"
                    },
                    {
                        "id": 147260,
                        "name": "Peyhan",
                        "latitude": "34.12972222",
                        "longitude": "48.86750000"
                    },
                    {
                        "id": 147261,
                        "name": "Pileh Jin",
                        "latitude": "35.38388889",
                        "longitude": "48.85583333"
                    },
                    {
                        "id": 147262,
                        "name": "Pir Anbar",
                        "latitude": "35.24250000",
                        "longitude": "48.51361111"
                    },
                    {
                        "id": 147263,
                        "name": "Pir Badam",
                        "latitude": "35.56722222",
                        "longitude": "48.13888889"
                    },
                    {
                        "id": 147264,
                        "name": "Pir Khodaverdi",
                        "latitude": "34.32500000",
                        "longitude": "48.92861111"
                    },
                    {
                        "id": 147265,
                        "name": "Pir Malu",
                        "latitude": "34.91222222",
                        "longitude": "48.06611111"
                    },
                    {
                        "id": 147266,
                        "name": "Pir Mishan",
                        "latitude": "34.39166667",
                        "longitude": "48.66611111"
                    },
                    {
                        "id": 147267,
                        "name": "Pir Savaran",
                        "latitude": "34.11805556",
                        "longitude": "48.77861111"
                    },
                    {
                        "id": 147268,
                        "name": "Pir Yusof",
                        "latitude": "34.68888889",
                        "longitude": "47.89277778"
                    },
                    {
                        "id": 147269,
                        "name": "Piruz",
                        "latitude": "34.13500000",
                        "longitude": "49.04527778"
                    },
                    {
                        "id": 147270,
                        "name": "Poshtjin",
                        "latitude": "35.31416667",
                        "longitude": "49.07166667"
                    },
                    {
                        "id": 147271,
                        "name": "Qabanqoli",
                        "latitude": "35.19833333",
                        "longitude": "49.17833333"
                    },
                    {
                        "id": 147272,
                        "name": "Qader Khalaj",
                        "latitude": "35.40111111",
                        "longitude": "48.73000000"
                    },
                    {
                        "id": 147273,
                        "name": "Qadimi",
                        "latitude": "34.65194444",
                        "longitude": "48.73666667"
                    },
                    {
                        "id": 147274,
                        "name": "Qahavand",
                        "latitude": "34.86027778",
                        "longitude": "49.00472222"
                    },
                    {
                        "id": 147275,
                        "name": "Qajar Ab-e Sofla",
                        "latitude": "34.43527778",
                        "longitude": "48.97527778"
                    },
                    {
                        "id": 147276,
                        "name": "Qarah Day",
                        "latitude": "35.12527778",
                        "longitude": "49.28222222"
                    },
                    {
                        "id": 147277,
                        "name": "Qarah Tegini",
                        "latitude": "34.44027778",
                        "longitude": "48.93555556"
                    },
                    {
                        "id": 147278,
                        "name": "Qaranqu Darreh",
                        "latitude": "35.51305556",
                        "longitude": "48.17750000"
                    },
                    {
                        "id": 147279,
                        "name": "Qasabestan",
                        "latitude": "34.42000000",
                        "longitude": "48.18777778"
                    },
                    {
                        "id": 147280,
                        "name": "Qasemabad-e Laklak",
                        "latitude": "34.67527778",
                        "longitude": "47.97222222"
                    },
                    {
                        "id": 147281,
                        "name": "Qater Owlan",
                        "latitude": "35.37527778",
                        "longitude": "48.93166667"
                    },
                    {
                        "id": 147282,
                        "name": "Qayesh",
                        "latitude": "35.49611111",
                        "longitude": "48.86694444"
                    },
                    {
                        "id": 147283,
                        "name": "Qazan Qarah",
                        "latitude": "35.66190000",
                        "longitude": "48.08220000"
                    },
                    {
                        "id": 147284,
                        "name": "Qazi Mardan",
                        "latitude": "34.77694444",
                        "longitude": "48.01416667"
                    },
                    {
                        "id": 147285,
                        "name": "Qeshlaq Baba Rostam",
                        "latitude": "34.14194444",
                        "longitude": "48.36250000"
                    },
                    {
                        "id": 147286,
                        "name": "Qeshlaq-e Anuch",
                        "latitude": "34.11611111",
                        "longitude": "48.57777778"
                    },
                    {
                        "id": 147287,
                        "name": "Qeshlaq-e Deh Ful",
                        "latitude": "34.24388889",
                        "longitude": "48.33750000"
                    },
                    {
                        "id": 147288,
                        "name": "Qeshlaq-e Dehnow",
                        "latitude": "34.50000000",
                        "longitude": "48.56666667"
                    },
                    {
                        "id": 147289,
                        "name": "Qeshlaq-e Mohammadi",
                        "latitude": "34.06666667",
                        "longitude": "48.91666667"
                    },
                    {
                        "id": 147290,
                        "name": "Qeshlaq-e Najaf",
                        "latitude": "34.37222222",
                        "longitude": "48.24500000"
                    },
                    {
                        "id": 147291,
                        "name": "Qeshlaq-e Pust Shuran",
                        "latitude": "34.40305556",
                        "longitude": "48.21638889"
                    },
                    {
                        "id": 147292,
                        "name": "Qeshlaq-e Qobad",
                        "latitude": "34.58777778",
                        "longitude": "48.89583333"
                    },
                    {
                        "id": 147293,
                        "name": "Qeshlaq-e Shirazi",
                        "latitude": "34.38388889",
                        "longitude": "48.93916667"
                    },
                    {
                        "id": 147294,
                        "name": "Qeshlaq-e Sofla",
                        "latitude": "34.70083333",
                        "longitude": "49.06972222"
                    },
                    {
                        "id": 147295,
                        "name": "Qeshlaq-e Valiollah",
                        "latitude": "34.35222222",
                        "longitude": "48.22416667"
                    },
                    {
                        "id": 147296,
                        "name": "Qeydli Bolagh",
                        "latitude": "35.01500000",
                        "longitude": "48.28750000"
                    },
                    {
                        "id": 147297,
                        "name": "Qilab",
                        "latitude": "34.30444444",
                        "longitude": "48.06083333"
                    },
                    {
                        "id": 147298,
                        "name": "Qohurd-e Sofla",
                        "latitude": "35.47111100",
                        "longitude": "48.05944400"
                    },
                    {
                        "id": 147299,
                        "name": "Qoli Laleh-ye Sofla",
                        "latitude": "34.52805556",
                        "longitude": "48.25972222"
                    },
                    {
                        "id": 147300,
                        "name": "Qolqolabad",
                        "latitude": "35.13083333",
                        "longitude": "49.29083333"
                    },
                    {
                        "id": 151009,
                        "name": "Qorveh-e Darjazin",
                        "latitude": "35.31264740",
                        "longitude": "49.08991810"
                    },
                    {
                        "id": 147301,
                        "name": "Quch Tappeh",
                        "latitude": "34.92722222",
                        "longitude": "48.02611111"
                    },
                    {
                        "id": 147302,
                        "name": "Qushjeh",
                        "latitude": "35.66416667",
                        "longitude": "48.30555556"
                    },
                    {
                        "id": 147303,
                        "name": "Rahmanabad Malayer",
                        "latitude": "34.08861111",
                        "longitude": "48.58555556"
                    },
                    {
                        "id": 147304,
                        "name": "Ramishan",
                        "latitude": "35.15972222",
                        "longitude": "48.80500000"
                    },
                    {
                        "id": 147305,
                        "name": "Rastguyan",
                        "latitude": "34.91666667",
                        "longitude": "48.21666667"
                    },
                    {
                        "id": 147306,
                        "name": "Rasulabad-e Sofla",
                        "latitude": "34.87888889",
                        "longitude": "48.21861111"
                    },
                    {
                        "id": 147307,
                        "name": "Ravand-e Vosta",
                        "latitude": "34.13333333",
                        "longitude": "48.34916667"
                    },
                    {
                        "id": 147308,
                        "name": "Rayegan-e Sofla",
                        "latitude": "35.07111100",
                        "longitude": "48.66333300"
                    },
                    {
                        "id": 147309,
                        "name": "Razaj",
                        "latitude": "34.89527778",
                        "longitude": "49.14666667"
                    },
                    {
                        "id": 147310,
                        "name": "Razan",
                        "latitude": "35.38638889",
                        "longitude": "49.03361111"
                    },
                    {
                        "id": 147311,
                        "name": "Razini",
                        "latitude": "34.26777778",
                        "longitude": "48.12611111"
                    },
                    {
                        "id": 147312,
                        "name": "Reza Baghi",
                        "latitude": "35.18277778",
                        "longitude": "49.31444444"
                    },
                    {
                        "id": 147313,
                        "name": "Rezvankadeh",
                        "latitude": "34.25000000",
                        "longitude": "48.83333333"
                    },
                    {
                        "id": 147314,
                        "name": "Rivasijan",
                        "latitude": "34.57722222",
                        "longitude": "48.43194444"
                    },
                    {
                        "id": 147315,
                        "name": "Robat-e Sheverin",
                        "latitude": "34.86111111",
                        "longitude": "48.60027778"
                    },
                    {
                        "id": 147316,
                        "name": "Rud Avar",
                        "latitude": "34.55055556",
                        "longitude": "48.41055556"
                    },
                    {
                        "id": 147317,
                        "name": "Rud-e Hasan-e Sofla",
                        "latitude": "34.12444444",
                        "longitude": "48.37166667"
                    },
                    {
                        "id": 147318,
                        "name": "Safa Riz",
                        "latitude": "35.40694444",
                        "longitude": "48.30611111"
                    },
                    {
                        "id": 147319,
                        "name": "Sahamabad",
                        "latitude": "34.55388889",
                        "longitude": "48.30472222"
                    },
                    {
                        "id": 147320,
                        "name": "Salehabad",
                        "latitude": "34.92361111",
                        "longitude": "48.34250000"
                    },
                    {
                        "id": 147321,
                        "name": "Salilak",
                        "latitude": "35.25277778",
                        "longitude": "49.11888889"
                    },
                    {
                        "id": 147322,
                        "name": "Saluk",
                        "latitude": "34.34138889",
                        "longitude": "48.99305556"
                    },
                    {
                        "id": 147323,
                        "name": "Samen",
                        "latitude": "34.20916667",
                        "longitude": "48.70583333"
                    },
                    {
                        "id": 147324,
                        "name": "Sanaj",
                        "latitude": "35.12222222",
                        "longitude": "49.02555556"
                    },
                    {
                        "id": 147325,
                        "name": "Sanjuzan",
                        "latitude": "34.65611111",
                        "longitude": "48.39333333"
                    },
                    {
                        "id": 147326,
                        "name": "Sar Duran",
                        "latitude": "34.20305556",
                        "longitude": "48.26388889"
                    },
                    {
                        "id": 147327,
                        "name": "Sarab-e Tajar",
                        "latitude": "34.23222222",
                        "longitude": "48.60638889"
                    },
                    {
                        "id": 147328,
                        "name": "Saravak",
                        "latitude": "35.17916667",
                        "longitude": "48.94638889"
                    },
                    {
                        "id": 147329,
                        "name": "Sarayjuq",
                        "latitude": "35.42888889",
                        "longitude": "47.96194444"
                    },
                    {
                        "id": 147330,
                        "name": "Sarijlu",
                        "latitude": "35.61250000",
                        "longitude": "48.89222222"
                    },
                    {
                        "id": 147331,
                        "name": "Sarkan",
                        "latitude": "34.60166667",
                        "longitude": "48.45055556"
                    },
                    {
                        "id": 147332,
                        "name": "Saziyan",
                        "latitude": "34.57361111",
                        "longitude": "48.15361111"
                    },
                    {
                        "id": 147333,
                        "name": "Sefid Khaneh",
                        "latitude": "34.06972222",
                        "longitude": "48.50805556"
                    },
                    {
                        "id": 147334,
                        "name": "Segavi",
                        "latitude": "34.58527778",
                        "longitude": "48.10083333"
                    },
                    {
                        "id": 151008,
                        "name": "Serkan",
                        "latitude": "34.60070120",
                        "longitude": "48.43862940"
                    },
                    {
                        "id": 147335,
                        "name": "Setaq",
                        "latitude": "35.04583300",
                        "longitude": "49.29638900"
                    },
                    {
                        "id": 147336,
                        "name": "Shademaneh",
                        "latitude": "34.36166667",
                        "longitude": "48.28055556"
                    },
                    {
                        "id": 147337,
                        "name": "Shanabad",
                        "latitude": "34.60888889",
                        "longitude": "48.10416667"
                    },
                    {
                        "id": 147338,
                        "name": "Shanjur",
                        "latitude": "35.29722222",
                        "longitude": "49.17638889"
                    },
                    {
                        "id": 147339,
                        "name": "Sharifabad-e Quzan",
                        "latitude": "34.41222222",
                        "longitude": "48.82583333"
                    },
                    {
                        "id": 147340,
                        "name": "Sharifabad-e Tajar",
                        "latitude": "34.26472222",
                        "longitude": "48.63833333"
                    },
                    {
                        "id": 147341,
                        "name": "Shatzal",
                        "latitude": "34.30305556",
                        "longitude": "47.97388889"
                    },
                    {
                        "id": 147342,
                        "name": "Shavand",
                        "latitude": "35.37527778",
                        "longitude": "49.20972222"
                    },
                    {
                        "id": 147343,
                        "name": "Sheverin",
                        "latitude": "34.80750000",
                        "longitude": "48.57027778"
                    },
                    {
                        "id": 147344,
                        "name": "Sheykh Jarrah",
                        "latitude": "35.50222222",
                        "longitude": "48.22250000"
                    },
                    {
                        "id": 147345,
                        "name": "Shilandar-e Sofla",
                        "latitude": "34.66750000",
                        "longitude": "48.16861111"
                    },
                    {
                        "id": 147346,
                        "name": "Shir Barat",
                        "latitude": "35.63333333",
                        "longitude": "48.38250000"
                    },
                    {
                        "id": 147347,
                        "name": "Shirin Su",
                        "latitude": "35.49277778",
                        "longitude": "48.45055556"
                    },
                    {
                        "id": 147348,
                        "name": "Shush Ab",
                        "latitude": "34.35361111",
                        "longitude": "48.63222222"
                    },
                    {
                        "id": 147349,
                        "name": "Siah Goleh",
                        "latitude": "34.94583333",
                        "longitude": "47.96833333"
                    },
                    {
                        "id": 147350,
                        "name": "Sib Dar",
                        "latitude": "34.21694444",
                        "longitude": "48.78472222"
                    },
                    {
                        "id": 147351,
                        "name": "Silvar",
                        "latitude": "34.74583333",
                        "longitude": "48.50666667"
                    },
                    {
                        "id": 147352,
                        "name": "Simin-e Abaru",
                        "latitude": "34.68250000",
                        "longitude": "48.58583300"
                    },
                    {
                        "id": 147353,
                        "name": "Simin-e Zagheh",
                        "latitude": "34.87666667",
                        "longitude": "48.32166667"
                    },
                    {
                        "id": 147354,
                        "name": "Siravand",
                        "latitude": "34.79527778",
                        "longitude": "47.99638889"
                    },
                    {
                        "id": 147355,
                        "name": "Sistaneh",
                        "latitude": "34.66333333",
                        "longitude": "48.32055556"
                    },
                    {
                        "id": 147356,
                        "name": "Solulan",
                        "latitude": "34.82611111",
                        "longitude": "48.42944444"
                    },
                    {
                        "id": 147357,
                        "name": "Sorkh Kand",
                        "latitude": "34.08750000",
                        "longitude": "48.42916667"
                    },
                    {
                        "id": 147358,
                        "name": "Sulijeh",
                        "latitude": "35.26860000",
                        "longitude": "48.33440000"
                    },
                    {
                        "id": 147359,
                        "name": "Surtajin",
                        "latitude": "35.53560000",
                        "longitude": "49.01390000"
                    },
                    {
                        "id": 147360,
                        "name": "Sutlaq",
                        "latitude": "34.57640000",
                        "longitude": "48.27750000"
                    },
                    {
                        "id": 147361,
                        "name": "Tafrijan",
                        "latitude": "34.76330000",
                        "longitude": "48.58190000"
                    },
                    {
                        "id": 147362,
                        "name": "Tahunabad",
                        "latitude": "34.83860000",
                        "longitude": "48.86640000"
                    },
                    {
                        "id": 147363,
                        "name": "Tajar-e Samen",
                        "latitude": "34.22560000",
                        "longitude": "48.66500000"
                    },
                    {
                        "id": 147364,
                        "name": "Takhtiabad",
                        "latitude": "34.81220000",
                        "longitude": "47.83780000"
                    },
                    {
                        "id": 147365,
                        "name": "Taleh Jerd-e Sofla",
                        "latitude": "34.04580000",
                        "longitude": "48.87780000"
                    },
                    {
                        "id": 147366,
                        "name": "Tamuzan",
                        "latitude": "35.27970000",
                        "longitude": "49.13280000"
                    },
                    {
                        "id": 147367,
                        "name": "Tappeh Yazdan",
                        "latitude": "34.33670000",
                        "longitude": "48.02250000"
                    },
                    {
                        "id": 147368,
                        "name": "Tappeh-ye Dibi",
                        "latitude": "35.42920000",
                        "longitude": "48.69420000"
                    },
                    {
                        "id": 147369,
                        "name": "Taraqayah",
                        "latitude": "35.31890000",
                        "longitude": "48.37110000"
                    },
                    {
                        "id": 147370,
                        "name": "Tarik Darreh-ye Bala",
                        "latitude": "34.27330000",
                        "longitude": "47.93920000"
                    },
                    {
                        "id": 147371,
                        "name": "Tarkhinabad",
                        "latitude": "34.81530000",
                        "longitude": "48.12250000"
                    },
                    {
                        "id": 147372,
                        "name": "Tas Tappeh",
                        "latitude": "35.16390000",
                        "longitude": "48.48330000"
                    },
                    {
                        "id": 147373,
                        "name": "Tasbandi",
                        "latitude": "34.56140000",
                        "longitude": "48.79060000"
                    },
                    {
                        "id": 147374,
                        "name": "Tasran",
                        "latitude": "35.33830000",
                        "longitude": "48.63390000"
                    },
                    {
                        "id": 147375,
                        "name": "Tavaleh",
                        "latitude": "35.15440000",
                        "longitude": "49.04390000"
                    },
                    {
                        "id": 147376,
                        "name": "Tavaneh",
                        "latitude": "34.21138900",
                        "longitude": "48.18583300"
                    },
                    {
                        "id": 147377,
                        "name": "Taveh",
                        "latitude": "35.11670000",
                        "longitude": "49.02720000"
                    },
                    {
                        "id": 147378,
                        "name": "Tavilan-e Sofla",
                        "latitude": "34.79940000",
                        "longitude": "47.86940000"
                    },
                    {
                        "id": 147379,
                        "name": "Tazehnab-e Sofla",
                        "latitude": "34.09780000",
                        "longitude": "48.31530000"
                    },
                    {
                        "id": 147380,
                        "name": "Termianak",
                        "latitude": "34.63190000",
                        "longitude": "48.17360000"
                    },
                    {
                        "id": 147381,
                        "name": "Timi Jan",
                        "latitude": "34.69030000",
                        "longitude": "48.34140000"
                    },
                    {
                        "id": 147382,
                        "name": "Tuchaqaz",
                        "latitude": "34.29970000",
                        "longitude": "48.71500000"
                    },
                    {
                        "id": 147383,
                        "name": "Tulki Tappeh",
                        "latitude": "35.49530000",
                        "longitude": "48.95780000"
                    },
                    {
                        "id": 147384,
                        "name": "Tusk-e Sofla",
                        "latitude": "34.25000000",
                        "longitude": "48.99000000"
                    },
                    {
                        "id": 147385,
                        "name": "Tutal",
                        "latitude": "34.51500000",
                        "longitude": "49.02140000"
                    },
                    {
                        "id": 147386,
                        "name": "Tuyserkan",
                        "latitude": "34.54805556",
                        "longitude": "48.44666667"
                    },
                    {
                        "id": 147387,
                        "name": "Vafr-e Jin",
                        "latitude": "34.81030000",
                        "longitude": "48.38420000"
                    },
                    {
                        "id": 147388,
                        "name": "Vahandeh",
                        "latitude": "35.50940000",
                        "longitude": "49.04750000"
                    },
                    {
                        "id": 147389,
                        "name": "Vahman",
                        "latitude": "34.26080000",
                        "longitude": "48.27080000"
                    },
                    {
                        "id": 147390,
                        "name": "Vahnan",
                        "latitude": "34.79000000",
                        "longitude": "48.28860000"
                    },
                    {
                        "id": 147391,
                        "name": "Vali Mohammad",
                        "latitude": "35.15190000",
                        "longitude": "48.38060000"
                    },
                    {
                        "id": 147392,
                        "name": "Vali Sir Ab",
                        "latitude": "34.23280000",
                        "longitude": "48.18940000"
                    },
                    {
                        "id": 147393,
                        "name": "Vandarabad",
                        "latitude": "34.66970000",
                        "longitude": "48.07890000"
                    },
                    {
                        "id": 147394,
                        "name": "Varayeneh",
                        "latitude": "34.07920000",
                        "longitude": "48.40560000"
                    },
                    {
                        "id": 147395,
                        "name": "Varazaneh",
                        "latitude": "34.18640000",
                        "longitude": "48.18610000"
                    },
                    {
                        "id": 147396,
                        "name": "Varchaq",
                        "latitude": "34.37170000",
                        "longitude": "48.89780000"
                    },
                    {
                        "id": 147397,
                        "name": "Vardavard-e Sofla",
                        "latitude": "34.70030000",
                        "longitude": "48.29390000"
                    },
                    {
                        "id": 147398,
                        "name": "Vardavard-e Vosta",
                        "latitude": "34.70440000",
                        "longitude": "48.30170000"
                    },
                    {
                        "id": 147399,
                        "name": "Varkaneh",
                        "latitude": "34.67690000",
                        "longitude": "48.61920000"
                    },
                    {
                        "id": 147400,
                        "name": "Varqestan",
                        "latitude": "35.39640000",
                        "longitude": "49.00920000"
                    },
                    {
                        "id": 147401,
                        "name": "Varvazin",
                        "latitude": "35.36580000",
                        "longitude": "48.96060000"
                    },
                    {
                        "id": 147402,
                        "name": "Vasaj",
                        "latitude": "34.32060000",
                        "longitude": "48.22580000"
                    },
                    {
                        "id": 147403,
                        "name": "Vashur",
                        "latitude": "35.23170000",
                        "longitude": "48.35170000"
                    },
                    {
                        "id": 147404,
                        "name": "Vasleh",
                        "latitude": "35.21280000",
                        "longitude": "48.34640000"
                    },
                    {
                        "id": 147405,
                        "name": "Vesht",
                        "latitude": "34.13860000",
                        "longitude": "48.46830000"
                    },
                    {
                        "id": 147406,
                        "name": "Vezendan",
                        "latitude": "34.95810000",
                        "longitude": "49.31250000"
                    },
                    {
                        "id": 147407,
                        "name": "Yalfan",
                        "latitude": "34.73640000",
                        "longitude": "48.61110000"
                    },
                    {
                        "id": 147408,
                        "name": "Yarom Qayah",
                        "latitude": "35.06890000",
                        "longitude": "49.38170000"
                    },
                    {
                        "id": 147409,
                        "name": "Yaromjeh Bagh",
                        "latitude": "35.51750000",
                        "longitude": "48.67640000"
                    },
                    {
                        "id": 147410,
                        "name": "Yeganeh",
                        "latitude": "34.80720000",
                        "longitude": "48.63780000"
                    },
                    {
                        "id": 147411,
                        "name": "Yekanabad",
                        "latitude": "34.87360000",
                        "longitude": "48.45420000"
                    },
                    {
                        "id": 147412,
                        "name": "Yekleh",
                        "latitude": "34.87777800",
                        "longitude": "49.00666700"
                    },
                    {
                        "id": 147413,
                        "name": "Yeserlu",
                        "latitude": "35.06110000",
                        "longitude": "48.78360000"
                    },
                    {
                        "id": 147414,
                        "name": "Yunes",
                        "latitude": "34.15860000",
                        "longitude": "48.67330000"
                    },
                    {
                        "id": 147415,
                        "name": "Yunji",
                        "latitude": "34.35860000",
                        "longitude": "48.78170000"
                    },
                    {
                        "id": 147416,
                        "name": "Zagheh-ye Anuch",
                        "latitude": "34.14780000",
                        "longitude": "48.55420000"
                    },
                    {
                        "id": 147417,
                        "name": "Zagheh-ye Tasbandi",
                        "latitude": "34.60360000",
                        "longitude": "48.81110000"
                    },
                    {
                        "id": 147418,
                        "name": "Zaghlijeh",
                        "latitude": "35.15280000",
                        "longitude": "49.37580000"
                    },
                    {
                        "id": 147419,
                        "name": "Zamanabad-e Mohammadabad",
                        "latitude": "34.41250000",
                        "longitude": "48.64220000"
                    },
                    {
                        "id": 151013,
                        "name": "Zangeneh",
                        "latitude": "34.15427170",
                        "longitude": "49.00369050"
                    },
                    {
                        "id": 147420,
                        "name": "Zangeneh-ye Sofla",
                        "latitude": "34.14670000",
                        "longitude": "49.01670000"
                    },
                    {
                        "id": 147421,
                        "name": "Zapon",
                        "latitude": "34.38390000",
                        "longitude": "48.18940000"
                    },
                    {
                        "id": 147422,
                        "name": "Zaramin-e Sofla",
                        "latitude": "34.19360000",
                        "longitude": "48.30000000"
                    },
                    {
                        "id": 147423,
                        "name": "Zarrin Bagh",
                        "latitude": "34.29470000",
                        "longitude": "48.05190000"
                    },
                    {
                        "id": 147424,
                        "name": "Zeraq",
                        "latitude": "35.07140000",
                        "longitude": "49.16940000"
                    },
                    {
                        "id": 147425,
                        "name": "Zirabiyeh",
                        "latitude": "34.41330000",
                        "longitude": "48.61690000"
                    }
                ]
            },
            {
                "id": 3937,
                "name": "Hormozgan",
                "iso2": "22",
                "latitude": "27.13872300",
                "longitude": "55.13758340",
                "type": "province",
                "cities": [
                    {
                        "id": 134786,
                        "name": "Abu Musa",
                        "latitude": "26.05474000",
                        "longitude": "55.16243000"
                    },
                    {
                        "id": 150978,
                        "name": "Abumusa ",
                        "latitude": "27.19805600",
                        "longitude": "54.36861100"
                    },
                    {
                        "id": 134576,
                        "name": "Bandar Abbas",
                        "latitude": "27.18650000",
                        "longitude": "56.28080000"
                    },
                    {
                        "id": 150986,
                        "name": "Bandar Charak",
                        "latitude": "26.73055600",
                        "longitude": "54.27472200"
                    },
                    {
                        "id": 150995,
                        "name": "Bandar Khamir",
                        "latitude": "26.95185270",
                        "longitude": "55.57268840"
                    },
                    {
                        "id": 150987,
                        "name": "Bandar Kong",
                        "latitude": "26.60285650",
                        "longitude": "54.92980580"
                    },
                    {
                        "id": 134580,
                        "name": "Bandar Lengeh",
                        "latitude": "26.55792000",
                        "longitude": "54.88067000"
                    },
                    {
                        "id": 150991,
                        "name": "Bandar-e-Jask",
                        "latitude": "25.65385140",
                        "longitude": "57.76995600"
                    },
                    {
                        "id": 134806,
                        "name": "Bashagard",
                        "latitude": "26.45000000",
                        "longitude": "58.08333000"
                    },
                    {
                        "id": 134583,
                        "name": "Bastak",
                        "latitude": "27.20000000",
                        "longitude": "54.36667000"
                    },
                    {
                        "id": 150997,
                        "name": "Bikah",
                        "latitude": "27.35404360",
                        "longitude": "57.16993320"
                    },
                    {
                        "id": 151002,
                        "name": "Dargahan",
                        "latitude": "26.95833690",
                        "longitude": "56.04316930"
                    },
                    {
                        "id": 150989,
                        "name": "Dashti",
                        "latitude": "27.17918870",
                        "longitude": "52.99824000"
                    },
                    {
                        "id": 150998,
                        "name": "Dehbārez",
                        "latitude": "27.44841050",
                        "longitude": "57.16675690"
                    },
                    {
                        "id": 150994,
                        "name": "Fareghan",
                        "latitude": "28.00785210",
                        "longitude": "56.24459260"
                    },
                    {
                        "id": 150984,
                        "name": "Fin",
                        "latitude": "27.63285790",
                        "longitude": "55.88187210"
                    },
                    {
                        "id": 151001,
                        "name": "Gerouk",
                        "latitude": "26.58856490",
                        "longitude": "57.08517550"
                    },
                    {
                        "id": 150981,
                        "name": "Gouharan",
                        "latitude": "26.59615360",
                        "longitude": "57.88707010"
                    },
                    {
                        "id": 150992,
                        "name": "Haji Abad",
                        "latitude": "28.31352140",
                        "longitude": "55.89620570"
                    },
                    {
                        "id": 135098,
                        "name": "Hajjiabad",
                        "latitude": "28.33333000",
                        "longitude": "55.83333000"
                    },
                    {
                        "id": 151007,
                        "name": "Hasht Bandi",
                        "latitude": "27.14586240",
                        "longitude": "57.43326510"
                    },
                    {
                        "id": 151004,
                        "name": "Hormuz",
                        "latitude": "27.09500000",
                        "longitude": "56.45277800"
                    },
                    {
                        "id": 150979,
                        "name": "Janah",
                        "latitude": "27.02755080",
                        "longitude": "54.27128050"
                    },
                    {
                        "id": 134900,
                        "name": "Jask",
                        "latitude": "25.88333000",
                        "longitude": "58.20000000"
                    },
                    {
                        "id": 134913,
                        "name": "Khamir",
                        "latitude": "27.26667000",
                        "longitude": "55.55000000"
                    },
                    {
                        "id": 134685,
                        "name": "Kish",
                        "latitude": "26.55778000",
                        "longitude": "54.01944000"
                    },
                    {
                        "id": 150990,
                        "name": "Koshkonar",
                        "latitude": "27.25012720",
                        "longitude": "52.85715580"
                    },
                    {
                        "id": 151000,
                        "name": "Kouhestak",
                        "latitude": "26.80426850",
                        "longitude": "57.01887130"
                    },
                    {
                        "id": 150988,
                        "name": "Lemazan",
                        "latitude": "27.05369130",
                        "longitude": "54.83641080"
                    },
                    {
                        "id": 134705,
                        "name": "Minab",
                        "latitude": "27.13104000",
                        "longitude": "57.08716000"
                    },
                    {
                        "id": 134995,
                        "name": "Parsian",
                        "latitude": "27.16667000",
                        "longitude": "53.26667000"
                    },
                    {
                        "id": 150985,
                        "name": "Qaleh Qazi",
                        "latitude": "27.44472200",
                        "longitude": "56.54777800"
                    },
                    {
                        "id": 134742,
                        "name": "Qeshm",
                        "latitude": "26.78333000",
                        "longitude": "55.86667000"
                    },
                    {
                        "id": 135020,
                        "name": "Rudan",
                        "latitude": "27.53333000",
                        "longitude": "57.11667000"
                    },
                    {
                        "id": 150996,
                        "name": "Ruydar",
                        "latitude": "27.46003100",
                        "longitude": "55.40825820"
                    },
                    {
                        "id": 150980,
                        "name": "Sardasht Bashagard",
                        "latitude": "26.45871900",
                        "longitude": "57.88425900"
                    },
                    {
                        "id": 150993,
                        "name": "Sargaz",
                        "latitude": "28.42563000",
                        "longitude": "55.70177000"
                    },
                    {
                        "id": 151006,
                        "name": "Senderk",
                        "latitude": "26.83816290",
                        "longitude": "57.41788730"
                    },
                    {
                        "id": 135054,
                        "name": "Sirik",
                        "latitude": "26.50000000",
                        "longitude": "57.18333000"
                    },
                    {
                        "id": 151003,
                        "name": "Suzā",
                        "latitude": "26.77724030",
                        "longitude": "56.04379160"
                    },
                    {
                        "id": 150983,
                        "name": "Takht",
                        "latitude": "27.50356930",
                        "longitude": "56.62731160"
                    },
                    {
                        "id": 150982,
                        "name": "Tazian",
                        "latitude": "27.29016000",
                        "longitude": "56.15210300"
                    },
                    {
                        "id": 151005,
                        "name": "Tirour",
                        "latitude": "27.33793880",
                        "longitude": "56.95310350"
                    },
                    {
                        "id": 150999,
                        "name": "Ziyārat Ali",
                        "latitude": "27.73557730",
                        "longitude": "57.21072420"
                    }
                ]
            },
            {
                "id": 3918,
                "name": "Ilam",
                "iso2": "16",
                "latitude": "33.29576180",
                "longitude": "46.67053400",
                "type": "province",
                "cities": [
                    {
                        "id": 135149,
                        "name": "abdanan",
                        "latitude": "32.99260000",
                        "longitude": "47.41980000"
                    },
                    {
                        "id": 150314,
                        "name": "Arkavaz",
                        "latitude": "33.38544050",
                        "longitude": "46.57578680"
                    },
                    {
                        "id": 150304,
                        "name": "Aseman Abad",
                        "latitude": "33.85182450",
                        "longitude": "46.44400060"
                    },
                    {
                        "id": 134574,
                        "name": "Badreh",
                        "latitude": "33.00000000",
                        "longitude": "47.25000000"
                    },
                    {
                        "id": 150305,
                        "name": "Balavah Tareh",
                        "latitude": "33.66690070",
                        "longitude": "46.80243500"
                    },
                    {
                        "id": 150303,
                        "name": "Bedreh",
                        "latitude": "33.30662610",
                        "longitude": "47.02968120"
                    },
                    {
                        "id": 134606,
                        "name": "Chardavol County",
                        "latitude": "33.75910000",
                        "longitude": "46.56980000"
                    },
                    {
                        "id": 150301,
                        "name": "Chovar",
                        "latitude": "33.69522650",
                        "longitude": "46.29299630"
                    },
                    {
                        "id": 134614,
                        "name": "Darreh Shahr",
                        "latitude": "33.14447000",
                        "longitude": "47.37990000"
                    },
                    {
                        "id": 134617,
                        "name": "Dehloran",
                        "latitude": "32.69410000",
                        "longitude": "47.26790000"
                    },
                    {
                        "id": 150315,
                        "name": "Delgosha",
                        "latitude": "33.40633120",
                        "longitude": "46.58975600"
                    },
                    {
                        "id": 134862,
                        "name": "Eyvan",
                        "latitude": "33.90000000",
                        "longitude": "46.16667000"
                    },
                    {
                        "id": 135157,
                        "name": "Ilam",
                        "latitude": "33.63740000",
                        "longitude": "46.42270000"
                    },
                    {
                        "id": 150313,
                        "name": "Loumar",
                        "latitude": "33.56787760",
                        "longitude": "46.80513740"
                    },
                    {
                        "id": 134950,
                        "name": "Malekshahi",
                        "latitude": "33.30000000",
                        "longitude": "46.55000000"
                    },
                    {
                        "id": 150312,
                        "name": "Maymeh",
                        "latitude": "33.22788250",
                        "longitude": "46.91291920"
                    },
                    {
                        "id": 150309,
                        "name": "Mazhin",
                        "latitude": "32.95297150",
                        "longitude": "47.78095720"
                    },
                    {
                        "id": 150316,
                        "name": "Mehr",
                        "latitude": "33.43694400",
                        "longitude": "46.46111100"
                    },
                    {
                        "id": 134700,
                        "name": "Mehran",
                        "latitude": "33.12220000",
                        "longitude": "46.16460000"
                    },
                    {
                        "id": 150311,
                        "name": "Mousiyan",
                        "latitude": "32.51868160",
                        "longitude": "47.36810080"
                    },
                    {
                        "id": 150300,
                        "name": "Murmuri ",
                        "latitude": "32.72546810",
                        "longitude": "47.66744610"
                    },
                    {
                        "id": 150310,
                        "name": "Pahleh",
                        "latitude": "33.01059760",
                        "longitude": "46.87927360"
                    },
                    {
                        "id": 150317,
                        "name": "Saleh Abad",
                        "latitude": "33.47157940",
                        "longitude": "46.18184570"
                    },
                    {
                        "id": 150299,
                        "name": "Sarabbagh",
                        "latitude": "32.89856040",
                        "longitude": "47.57032870"
                    },
                    {
                        "id": 150307,
                        "name": "Sarableh",
                        "latitude": "33.76577730",
                        "longitude": "46.54643580"
                    },
                    {
                        "id": 150308,
                        "name": "Shabab",
                        "latitude": "33.74878600",
                        "longitude": "46.63228510"
                    },
                    {
                        "id": 135117,
                        "name": "Sirvan",
                        "latitude": "33.75460000",
                        "longitude": "46.56651000"
                    },
                    {
                        "id": 150306,
                        "name": "Tohid",
                        "latitude": "33.72550000",
                        "longitude": "47.06850000"
                    },
                    {
                        "id": 150302,
                        "name": "Zarneh",
                        "latitude": "33.92863690",
                        "longitude": "46.17875560"
                    }
                ]
            },
            {
                "id": 3923,
                "name": "Isfahan",
                "iso2": "10",
                "latitude": "33.27710730",
                "longitude": "52.36133780",
                "type": "province",
                "cities": [
                    {
                        "id": 150201,
                        "name": "Abouzeidabad",
                        "latitude": "33.90165760",
                        "longitude": "51.74337370"
                    },
                    {
                        "id": 134557,
                        "name": "Abrisham",
                        "latitude": "32.55613000",
                        "longitude": "51.57325000"
                    },
                    {
                        "id": 150226,
                        "name": "Afus",
                        "latitude": "33.02495550",
                        "longitude": "50.08812900"
                    },
                    {
                        "id": 150282,
                        "name": "Alavijeh",
                        "latitude": "33.05169010",
                        "longitude": "51.05992540"
                    },
                    {
                        "id": 150277,
                        "name": "Anarak",
                        "latitude": "33.30702060",
                        "longitude": "53.68767500"
                    },
                    {
                        "id": 135084,
                        "name": "Aran va Bidgol",
                        "latitude": "34.10000000",
                        "longitude": "51.90000000"
                    },
                    {
                        "id": 134570,
                        "name": "Ardestan",
                        "latitude": "33.37610000",
                        "longitude": "52.36940000"
                    },
                    {
                        "id": 150230,
                        "name": "Asghar Abad",
                        "latitude": "32.65260910",
                        "longitude": "51.47119400"
                    },
                    {
                        "id": 150228,
                        "name": "Askaran",
                        "latitude": "32.86623280",
                        "longitude": "50.84719420"
                    },
                    {
                        "id": 150285,
                        "name": "Badroud",
                        "latitude": "33.68939670",
                        "longitude": "51.99780820"
                    },
                    {
                        "id": 150278,
                        "name": "Bafrān",
                        "latitude": "32.83938320",
                        "longitude": "53.13662050"
                    },
                    {
                        "id": 150263,
                        "name": "Baghbahadoran",
                        "latitude": "32.37872850",
                        "longitude": "51.18191240"
                    },
                    {
                        "id": 150264,
                        "name": "Baghshad",
                        "latitude": "32.38226100",
                        "longitude": "51.22944130"
                    },
                    {
                        "id": 150250,
                        "name": "Baharan Shahr",
                        "latitude": "32.65097430",
                        "longitude": "51.72070930"
                    },
                    {
                        "id": 150207,
                        "name": "Baharestan",
                        "latitude": "32.48391000",
                        "longitude": "51.73393190"
                    },
                    {
                        "id": 150247,
                        "name": "Barf Anbar",
                        "latitude": "32.99523650",
                        "longitude": "50.17576210"
                    },
                    {
                        "id": 150255,
                        "name": "Barzok",
                        "latitude": "33.77699410",
                        "longitude": "51.19740420"
                    },
                    {
                        "id": 134812,
                        "name": "Borkhvar",
                        "latitude": "32.98333000",
                        "longitude": "51.76667000"
                    },
                    {
                        "id": 134593,
                        "name": "Buin va Miandasht",
                        "latitude": "33.07241000",
                        "longitude": "50.14641000"
                    },
                    {
                        "id": 134609,
                        "name": "Chadegan",
                        "latitude": "32.76825000",
                        "longitude": "50.62873000"
                    },
                    {
                        "id": 150266,
                        "name": "Chamgordan",
                        "latitude": "32.39291670",
                        "longitude": "51.33082860"
                    },
                    {
                        "id": 150265,
                        "name": "Chermahin",
                        "latitude": "32.32433430",
                        "longitude": "51.14324500"
                    },
                    {
                        "id": 150246,
                        "name": "Damaneh",
                        "latitude": "33.01758740",
                        "longitude": "50.47904490"
                    },
                    {
                        "id": 134627,
                        "name": "Daran",
                        "latitude": "32.98871000",
                        "longitude": "50.41267000"
                    },
                    {
                        "id": 150221,
                        "name": "Dastgerd",
                        "latitude": "32.80222710",
                        "longitude": "51.65711400"
                    },
                    {
                        "id": 150281,
                        "name": "Dehagh",
                        "latitude": "33.10728330",
                        "longitude": "50.93896840"
                    },
                    {
                        "id": 150236,
                        "name": "Dehaghan",
                        "latitude": "31.93724900",
                        "longitude": "51.64522640"
                    },
                    {
                        "id": 134618,
                        "name": "Dehaqan",
                        "latitude": "31.94004000",
                        "longitude": "51.64786000"
                    },
                    {
                        "id": 150272,
                        "name": "Diziche",
                        "latitude": "32.40433490",
                        "longitude": "51.48476550"
                    },
                    {
                        "id": 150222,
                        "name": "Dolatabad",
                        "latitude": "32.80826470",
                        "longitude": "51.67975170"
                    },
                    {
                        "id": 150231,
                        "name": "Dorcheh",
                        "latitude": "32.61500960",
                        "longitude": "51.53461450"
                    },
                    {
                        "id": 134623,
                        "name": "Dorcheh Piaz",
                        "latitude": "32.61528000",
                        "longitude": "51.55556000"
                    },
                    {
                        "id": 134624,
                        "name": "Dowlatabad",
                        "latitude": "32.79978000",
                        "longitude": "51.69553000"
                    },
                    {
                        "id": 134863,
                        "name": "Esfahan",
                        "latitude": "32.26667000",
                        "longitude": "52.45000000"
                    },
                    {
                        "id": 150206,
                        "name": "Ezhieh",
                        "latitude": "32.44236700",
                        "longitude": "52.37182610"
                    },
                    {
                        "id": 134632,
                        "name": "Falavarjan",
                        "latitude": "32.55530000",
                        "longitude": "51.50973000"
                    },
                    {
                        "id": 134636,
                        "name": "Fareydunshahr",
                        "latitude": "32.94098000",
                        "longitude": "50.12100000"
                    },
                    {
                        "id": 150235,
                        "name": "Farrokhi",
                        "latitude": "33.84195750",
                        "longitude": "54.94378560"
                    },
                    {
                        "id": 134639,
                        "name": "Fereydan",
                        "latitude": "33.10000000",
                        "longitude": "50.26667000"
                    },
                    {
                        "id": 150248,
                        "name": "Fereydun Shahr",
                        "latitude": "32.93718600",
                        "longitude": "50.12029390"
                    },
                    {
                        "id": 150270,
                        "name": "Fooladshahr",
                        "latitude": "32.52549510",
                        "longitude": "51.29630090"
                    },
                    {
                        "id": 150242,
                        "name": "Gazborkhar",
                        "latitude": "32.80222200",
                        "longitude": "51.62111100"
                    },
                    {
                        "id": 150253,
                        "name": "Ghahderijan",
                        "latitude": "32.56889540",
                        "longitude": "51.40953480"
                    },
                    {
                        "id": 150257,
                        "name": "Ghamsar",
                        "latitude": "33.74066420",
                        "longitude": "51.41000730"
                    },
                    {
                        "id": 150284,
                        "name": "Goldasht",
                        "latitude": "32.62173270",
                        "longitude": "51.42737730"
                    },
                    {
                        "id": 134645,
                        "name": "Golpayegan",
                        "latitude": "33.45370000",
                        "longitude": "50.28836000"
                    },
                    {
                        "id": 150261,
                        "name": "Golshahr",
                        "latitude": "33.50595700",
                        "longitude": "50.45278070"
                    },
                    {
                        "id": 150237,
                        "name": "Golshan",
                        "latitude": "31.92651440",
                        "longitude": "51.72279540"
                    },
                    {
                        "id": 150262,
                        "name": "Googad",
                        "latitude": "33.47637670",
                        "longitude": "50.34423700"
                    },
                    {
                        "id": 150241,
                        "name": "Gorgab",
                        "latitude": "32.86625040",
                        "longitude": "51.58879270"
                    },
                    {
                        "id": 150219,
                        "name": "Habibabad",
                        "latitude": "32.83124240",
                        "longitude": "51.76599030"
                    },
                    {
                        "id": 150238,
                        "name": "Hanna",
                        "latitude": "31.19744850",
                        "longitude": "51.71396600"
                    },
                    {
                        "id": 150218,
                        "name": "Harand",
                        "latitude": "32.57486500",
                        "longitude": "52.39937730"
                    },
                    {
                        "id": 150209,
                        "name": "Hassan Abad",
                        "latitude": "32.13927970",
                        "longitude": "52.62129300"
                    },
                    {
                        "id": 150249,
                        "name": "Imanshahr",
                        "latitude": "32.48392420",
                        "longitude": "51.43493040"
                    },
                    {
                        "id": 134656,
                        "name": "Isfahan",
                        "latitude": "32.65246000",
                        "longitude": "51.67462000"
                    },
                    {
                        "id": 150234,
                        "name": "Jandaq",
                        "latitude": "34.04261310",
                        "longitude": "54.40511230"
                    },
                    {
                        "id": 150256,
                        "name": "Josheqaneqali",
                        "latitude": "33.55601380",
                        "longitude": "51.13534680"
                    },
                    {
                        "id": 150258,
                        "name": "Jowsheqan va Kamu",
                        "latitude": "33.60000000",
                        "longitude": "51.23333300"
                    },
                    {
                        "id": 150280,
                        "name": "Jowzdan",
                        "latitude": "32.55601720",
                        "longitude": "51.35696400"
                    },
                    {
                        "id": 150283,
                        "name": "Kahrizsang",
                        "latitude": "32.63252520",
                        "longitude": "51.46807190"
                    },
                    {
                        "id": 150275,
                        "name": "Karkevand",
                        "latitude": "32.34227880",
                        "longitude": "51.43751610"
                    },
                    {
                        "id": 134935,
                        "name": "Kashan",
                        "latitude": "33.88333000",
                        "longitude": "51.28333000"
                    },
                    {
                        "id": 150254,
                        "name": "Kelishad and Soderjaan",
                        "latitude": "32.55185850",
                        "longitude": "51.52158730"
                    },
                    {
                        "id": 134666,
                        "name": "Kelishad va Sudarjan",
                        "latitude": "32.55118000",
                        "longitude": "51.52758000"
                    },
                    {
                        "id": 150286,
                        "name": "Khaled Abad",
                        "latitude": "33.70071610",
                        "longitude": "51.98288430"
                    },
                    {
                        "id": 150233,
                        "name": "Khansar",
                        "latitude": "33.26748190",
                        "longitude": "50.24871590"
                    },
                    {
                        "id": 134672,
                        "name": "Khomeyni Shahr",
                        "latitude": "32.68560000",
                        "longitude": "51.53609000"
                    },
                    {
                        "id": 150220,
                        "name": "Khorzugh",
                        "latitude": "32.78003800",
                        "longitude": "51.62544240"
                    },
                    {
                        "id": 134680,
                        "name": "Khur",
                        "latitude": "33.77512000",
                        "longitude": "55.08329000"
                    },
                    {
                        "id": 134677,
                        "name": "Khvansar",
                        "latitude": "33.22052000",
                        "longitude": "50.31497000"
                    },
                    {
                        "id": 150239,
                        "name": "Komeh",
                        "latitude": "31.06320870",
                        "longitude": "51.58456560"
                    },
                    {
                        "id": 150225,
                        "name": "Komshecheh",
                        "latitude": "32.90664920",
                        "longitude": "51.80178170"
                    },
                    {
                        "id": 150232,
                        "name": "Kooshk",
                        "latitude": "32.63866920",
                        "longitude": "51.49090280"
                    },
                    {
                        "id": 150213,
                        "name": "Kuhpayeh",
                        "latitude": "32.70287470",
                        "longitude": "52.42220820"
                    },
                    {
                        "id": 150243,
                        "name": "Laybid",
                        "latitude": "33.45682060",
                        "longitude": "50.68666930"
                    },
                    {
                        "id": 134942,
                        "name": "Lenjan",
                        "latitude": "32.36667000",
                        "longitude": "51.20000000"
                    },
                    {
                        "id": 150205,
                        "name": "Mahabad",
                        "latitude": "33.52890960",
                        "longitude": "52.21336130"
                    },
                    {
                        "id": 150276,
                        "name": "Majlesi",
                        "latitude": "32.19536780",
                        "longitude": "51.48369300"
                    },
                    {
                        "id": 150245,
                        "name": "Manzariyeh",
                        "latitude": "31.94638130",
                        "longitude": "51.87130450"
                    },
                    {
                        "id": 150259,
                        "name": "Mashkat",
                        "latitude": "34.18385200",
                        "longitude": "51.25709940"
                    },
                    {
                        "id": 135043,
                        "name": "Meymeh",
                        "latitude": "33.44504910",
                        "longitude": "51.16345880"
                    },
                    {
                        "id": 134703,
                        "name": "Mobarakeh",
                        "latitude": "32.34651000",
                        "longitude": "51.50449000"
                    },
                    {
                        "id": 150214,
                        "name": "Mohammad Abad",
                        "latitude": "32.31742670",
                        "longitude": "52.09172950"
                    },
                    {
                        "id": 150279,
                        "name": "Naein",
                        "latitude": "32.86148940",
                        "longitude": "53.07443600"
                    },
                    {
                        "id": 134718,
                        "name": "Nain",
                        "latitude": "32.86006000",
                        "longitude": "53.08749000"
                    },
                    {
                        "id": 134707,
                        "name": "Najafabad",
                        "latitude": "32.63440000",
                        "longitude": "51.36680000"
                    },
                    {
                        "id": 150215,
                        "name": "Nasr Abad",
                        "latitude": "32.28016610",
                        "longitude": "52.05294370"
                    },
                    {
                        "id": 134711,
                        "name": "Natanz",
                        "latitude": "33.51118000",
                        "longitude": "51.91808000"
                    },
                    {
                        "id": 150260,
                        "name": "Niasar",
                        "latitude": "33.97745700",
                        "longitude": "51.14122850"
                    },
                    {
                        "id": 150216,
                        "name": "Nik Abad",
                        "latitude": "32.30380070",
                        "longitude": "52.18973630"
                    },
                    {
                        "id": 150203,
                        "name": "Nushabad",
                        "latitude": "34.07957060",
                        "longitude": "51.42786020"
                    },
                    {
                        "id": 150251,
                        "name": "Pir Bakran",
                        "latitude": "32.46747760",
                        "longitude": "51.53905380"
                    },
                    {
                        "id": 134735,
                        "name": "Qahderijan",
                        "latitude": "32.57670000",
                        "longitude": "51.45500000"
                    },
                    {
                        "id": 150212,
                        "name": "Qahjavarestan",
                        "latitude": "32.70272036",
                        "longitude": "51.82802440"
                    },
                    {
                        "id": 134751,
                        "name": "Rehnan",
                        "latitude": "32.68325000",
                        "longitude": "51.60158000"
                    },
                    {
                        "id": 150227,
                        "name": "Rezvanshahr",
                        "latitude": "32.66581050",
                        "longitude": "51.02359710"
                    },
                    {
                        "id": 150229,
                        "name": "Rezveh",
                        "latitude": "32.83687710",
                        "longitude": "50.56521890"
                    },
                    {
                        "id": 150269,
                        "name": "Sedeh Lenjan",
                        "latitude": "32.37447790",
                        "longitude": "51.30912400"
                    },
                    {
                        "id": 150202,
                        "name": "Sefid Shahr",
                        "latitude": "34.12406120",
                        "longitude": "51.34705070"
                    },
                    {
                        "id": 150211,
                        "name": "Sejzi",
                        "latitude": "32.69866640",
                        "longitude": "52.06674040"
                    },
                    {
                        "id": 135034,
                        "name": "Semirom",
                        "latitude": "31.30000000",
                        "longitude": "51.53333000"
                    },
                    {
                        "id": 135111,
                        "name": "Shahin Shahr",
                        "latitude": "32.85788000",
                        "longitude": "51.55290000"
                    },
                    {
                        "id": 135104,
                        "name": "Shahreza",
                        "latitude": "32.00890000",
                        "longitude": "51.86680000"
                    },
                    {
                        "id": 150224,
                        "name": "Shapur Abad",
                        "latitude": "32.84337640",
                        "longitude": "51.73918970"
                    },
                    {
                        "id": 150223,
                        "name": "Sin",
                        "latitude": "32.85028040",
                        "longitude": "51.64761890"
                    },
                    {
                        "id": 150274,
                        "name": "Talkhooncheh",
                        "latitude": "32.24999310",
                        "longitude": "51.51884030"
                    },
                    {
                        "id": 150287,
                        "name": "Tarq Rud",
                        "latitude": "33.34682690",
                        "longitude": "51.79114390"
                    },
                    {
                        "id": 135136,
                        "name": "Tiran",
                        "latitude": "32.70260000",
                        "longitude": "51.15370000"
                    },
                    {
                        "id": 150208,
                        "name": "Toodeshk",
                        "latitude": "32.72089190",
                        "longitude": "52.65622610"
                    },
                    {
                        "id": 150240,
                        "name": "Vanak",
                        "latitude": "31.52755750",
                        "longitude": "51.32147620"
                    },
                    {
                        "id": 150271,
                        "name": "Varnamkhast",
                        "latitude": "32.35522120",
                        "longitude": "51.37205960"
                    },
                    {
                        "id": 150217,
                        "name": "Varzaneh",
                        "latitude": "32.41767450",
                        "longitude": "52.63817870"
                    },
                    {
                        "id": 150244,
                        "name": "Vazvan",
                        "latitude": "33.41799110",
                        "longitude": "51.17397300"
                    },
                    {
                        "id": 150268,
                        "name": "Zarinshahr",
                        "latitude": "32.41176360",
                        "longitude": "51.36318620"
                    },
                    {
                        "id": 135144,
                        "name": "Zarrin Shahr",
                        "latitude": "32.38970000",
                        "longitude": "51.37660000"
                    },
                    {
                        "id": 150204,
                        "name": "Zavareh",
                        "latitude": "33.44411680",
                        "longitude": "52.46542430"
                    },
                    {
                        "id": 150267,
                        "name": "Zayandehrod",
                        "latitude": "32.38257720",
                        "longitude": "51.25747000"
                    },
                    {
                        "id": 150252,
                        "name": "Zazeran",
                        "latitude": "32.59599600",
                        "longitude": "51.48399340"
                    },
                    {
                        "id": 150210,
                        "name": "Ziar",
                        "latitude": "32.51124460",
                        "longitude": "51.92680470"
                    },
                    {
                        "id": 150273,
                        "name": "Zibashahr",
                        "latitude": "32.38680810",
                        "longitude": "51.54482590"
                    }
                ]
            },
            {
                "id": 3943,
                "name": "Kerman",
                "iso2": "08",
                "latitude": "29.48500890",
                "longitude": "57.64390480",
                "type": "province",
                "cities": [
                    {
                        "id": 150753,
                        "name": "Aminshahr ",
                        "latitude": "30.84221360",
                        "longitude": "55.33205130"
                    },
                    {
                        "id": 134791,
                        "name": "Anar",
                        "latitude": "30.85000000",
                        "longitude": "55.35000000"
                    },
                    {
                        "id": 135102,
                        "name": "Anbarabad",
                        "latitude": "28.43333000",
                        "longitude": "58.16667000"
                    },
                    {
                        "id": 150790,
                        "name": "Andouhjerd",
                        "latitude": "30.23285440",
                        "longitude": "57.73551450"
                    },
                    {
                        "id": 134598,
                        "name": "Baft",
                        "latitude": "29.23310000",
                        "longitude": "56.60220000"
                    },
                    {
                        "id": 150791,
                        "name": "Bagheyn",
                        "latitude": "30.18547660",
                        "longitude": "56.80399410"
                    },
                    {
                        "id": 150765,
                        "name": "Bahreman",
                        "latitude": "30.90036410",
                        "longitude": "55.71686260"
                    },
                    {
                        "id": 150775,
                        "name": "Balvard",
                        "latitude": "29.42318820",
                        "longitude": "56.03645320"
                    },
                    {
                        "id": 134575,
                        "name": "Bam",
                        "latitude": "29.06667000",
                        "longitude": "58.23333000"
                    },
                    {
                        "id": 150759,
                        "name": "Baravat",
                        "latitude": "29.06156180",
                        "longitude": "58.38503770"
                    },
                    {
                        "id": 134582,
                        "name": "Bardsir",
                        "latitude": "29.92266000",
                        "longitude": "56.57433000"
                    },
                    {
                        "id": 150754,
                        "name": "Bezanjan",
                        "latitude": "29.24761330",
                        "longitude": "56.68898110"
                    },
                    {
                        "id": 150760,
                        "name": "Boluk",
                        "latitude": "28.23060410",
                        "longitude": "57.50465150"
                    },
                    {
                        "id": 150793,
                        "name": "Chatroud",
                        "latitude": "30.60212460",
                        "longitude": "56.90428730"
                    },
                    {
                        "id": 150762,
                        "name": "Darb-e Behesht",
                        "latitude": "29.23461930",
                        "longitude": "57.33000760"
                    },
                    {
                        "id": 150755,
                        "name": "Dashtkar",
                        "latitude": "29.90690010",
                        "longitude": "56.65785420"
                    },
                    {
                        "id": 150784,
                        "name": "Dehaj",
                        "latitude": "30.69372360",
                        "longitude": "54.86387720"
                    },
                    {
                        "id": 150785,
                        "name": "Dow Sari",
                        "latitude": "28.42500000",
                        "longitude": "57.94250000"
                    },
                    {
                        "id": 150789,
                        "name": "Ekhteyarabad",
                        "latitude": "30.32721010",
                        "longitude": "56.90308550"
                    },
                    {
                        "id": 150787,
                        "name": "Fahraj",
                        "latitude": "28.94585560",
                        "longitude": "58.87598980"
                    },
                    {
                        "id": 134872,
                        "name": "Faryab",
                        "latitude": "28.20000000",
                        "longitude": "57.21667000"
                    },
                    {
                        "id": 150788,
                        "name": "Ghalehganj",
                        "latitude": "27.52440690",
                        "longitude": "57.85301680"
                    },
                    {
                        "id": 150798,
                        "name": "Golbāf",
                        "latitude": "29.88492820",
                        "longitude": "57.71448600"
                    },
                    {
                        "id": 150756,
                        "name": "Golzar",
                        "latitude": "29.70544120",
                        "longitude": "57.02460030"
                    },
                    {
                        "id": 150770,
                        "name": "Gonbaki",
                        "latitude": "28.71475080",
                        "longitude": "58.84328830"
                    },
                    {
                        "id": 150763,
                        "name": "Hanza",
                        "latitude": "29.29845610",
                        "longitude": "57.17977030"
                    },
                    {
                        "id": 150764,
                        "name": "Hojedk",
                        "latitude": "30.75808180",
                        "longitude": "56.98747860"
                    },
                    {
                        "id": 150780,
                        "name": "Homashahr",
                        "latitude": "29.64449710",
                        "longitude": "55.80265050"
                    },
                    {
                        "id": 150761,
                        "name": "Jebalbarez",
                        "latitude": "28.90703670",
                        "longitude": "57.88232800"
                    },
                    {
                        "id": 134901,
                        "name": "Jiroft",
                        "latitude": "28.83333000",
                        "longitude": "57.58333000"
                    },
                    {
                        "id": 150792,
                        "name": "Joupar",
                        "latitude": "30.05605440",
                        "longitude": "57.09809280"
                    },
                    {
                        "id": 150781,
                        "name": "Jowzam",
                        "latitude": "30.51302580",
                        "longitude": "55.02259970"
                    },
                    {
                        "id": 150801,
                        "name": "Kahnooj",
                        "latitude": "27.97934880",
                        "longitude": "57.66592480"
                    },
                    {
                        "id": 134903,
                        "name": "Kahnuj",
                        "latitude": "27.90000000",
                        "longitude": "57.61667000"
                    },
                    {
                        "id": 150797,
                        "name": "Kazem Abad",
                        "latitude": "30.56691630",
                        "longitude": "56.83686730"
                    },
                    {
                        "id": 134667,
                        "name": "Kerman",
                        "latitude": "30.28321000",
                        "longitude": "57.07879000"
                    },
                    {
                        "id": 150777,
                        "name": "Khajoo Shahr",
                        "latitude": "29.27247370",
                        "longitude": "55.82664020"
                    },
                    {
                        "id": 150772,
                        "name": "Khanook",
                        "latitude": "30.71558630",
                        "longitude": "56.75333240"
                    },
                    {
                        "id": 150782,
                        "name": "KhatonAbad",
                        "latitude": "30.00947510",
                        "longitude": "55.41270020"
                    },
                    {
                        "id": 150783,
                        "name": "Khursand",
                        "latitude": "30.15484910",
                        "longitude": "55.07781030"
                    },
                    {
                        "id": 134781,
                        "name": "Kian Shahr",
                        "latitude": "31.13444000",
                        "longitude": "56.39806000"
                    },
                    {
                        "id": 150767,
                        "name": "Koshkuiyeh",
                        "latitude": "30.52904570",
                        "longitude": "55.63227370"
                    },
                    {
                        "id": 134686,
                        "name": "Kuh Sefid",
                        "latitude": "29.27620000",
                        "longitude": "56.80140000"
                    },
                    {
                        "id": 134938,
                        "name": "Kuhbanan",
                        "latitude": "31.38333000",
                        "longitude": "56.33333000"
                    },
                    {
                        "id": 150757,
                        "name": "Laleh zaar",
                        "latitude": "29.52051620",
                        "longitude": "56.80753450"
                    },
                    {
                        "id": 150799,
                        "name": "Mahan",
                        "latitude": "30.06414420",
                        "longitude": "57.25602090"
                    },
                    {
                        "id": 150802,
                        "name": "Manoojan",
                        "latitude": "27.36824920",
                        "longitude": "57.20289640"
                    },
                    {
                        "id": 134953,
                        "name": "Manujan",
                        "latitude": "27.35000000",
                        "longitude": "57.61667000"
                    },
                    {
                        "id": 150786,
                        "name": "Mardehak",
                        "latitude": "28.35363910",
                        "longitude": "58.14999100"
                    },
                    {
                        "id": 150771,
                        "name": "Mohammadabad",
                        "latitude": "28.62839590",
                        "longitude": "59.11886930"
                    },
                    {
                        "id": 150800,
                        "name": "MohyAbad",
                        "latitude": "30.08404130",
                        "longitude": "57.15257410"
                    },
                    {
                        "id": 150779,
                        "name": "Najaf Shahr",
                        "latitude": "29.39739100",
                        "longitude": "55.70182060"
                    },
                    {
                        "id": 134977,
                        "name": "Narmashir",
                        "latitude": "29.26667000",
                        "longitude": "58.73333000"
                    },
                    {
                        "id": 150758,
                        "name": "Negar",
                        "latitude": "29.85702120",
                        "longitude": "56.79398410"
                    },
                    {
                        "id": 150804,
                        "name": "Nezamshahr",
                        "latitude": "28.91611100",
                        "longitude": "58.55027800"
                    },
                    {
                        "id": 150803,
                        "name": "Nodej",
                        "latitude": "27.53194030",
                        "longitude": "57.44420510"
                    },
                    {
                        "id": 150752,
                        "name": "Orzueeyeh",
                        "latitude": "28.45839080",
                        "longitude": "56.35321770"
                    },
                    {
                        "id": 134989,
                        "name": "Orzuiyeh",
                        "latitude": "28.46667000",
                        "longitude": "56.53333000"
                    },
                    {
                        "id": 150776,
                        "name": "Pariz",
                        "latitude": "29.87880940",
                        "longitude": "55.72693730"
                    },
                    {
                        "id": 135000,
                        "name": "Qaleh Ganj",
                        "latitude": "27.20000000",
                        "longitude": "58.33333000"
                    },
                    {
                        "id": 135012,
                        "name": "Rabor",
                        "latitude": "29.25000000",
                        "longitude": "56.98333000"
                    },
                    {
                        "id": 134748,
                        "name": "Rafsanjan",
                        "latitude": "30.40670000",
                        "longitude": "55.99390000"
                    },
                    {
                        "id": 134759,
                        "name": "Ravar",
                        "latitude": "31.26562000",
                        "longitude": "56.80545000"
                    },
                    {
                        "id": 150794,
                        "name": "Rayen",
                        "latitude": "29.59267390",
                        "longitude": "57.42716770"
                    },
                    {
                        "id": 150773,
                        "name": "Reyhan",
                        "latitude": "30.73485380",
                        "longitude": "56.68739260"
                    },
                    {
                        "id": 134760,
                        "name": "Rigan",
                        "latitude": "28.43333000",
                        "longitude": "59.15000000"
                    },
                    {
                        "id": 135018,
                        "name": "Rudbar",
                        "latitude": "27.90000000",
                        "longitude": "58.46667000"
                    },
                    {
                        "id": 150766,
                        "name": "Safaiyeh",
                        "latitude": "30.82808130",
                        "longitude": "55.80301480"
                    },
                    {
                        "id": 150796,
                        "name": "Shahdad",
                        "latitude": "30.42195570",
                        "longitude": "57.69062500"
                    },
                    {
                        "id": 150768,
                        "name": "Shahrak Mes Sarcheshmeh",
                        "latitude": "30.00024680",
                        "longitude": "55.77831730"
                    },
                    {
                        "id": 134776,
                        "name": "Shahrbabak",
                        "latitude": "30.11650000",
                        "longitude": "55.11860000"
                    },
                    {
                        "id": 135116,
                        "name": "Sirjan",
                        "latitude": "29.45137000",
                        "longitude": "55.68090000"
                    },
                    {
                        "id": 150774,
                        "name": "Yazdan Shahr",
                        "latitude": "30.86833240",
                        "longitude": "56.33342680"
                    },
                    {
                        "id": 150795,
                        "name": "Zangiabad",
                        "latitude": "30.40467220",
                        "longitude": "56.89778550"
                    },
                    {
                        "id": 135143,
                        "name": "Zarand",
                        "latitude": "30.81271000",
                        "longitude": "56.56399000"
                    },
                    {
                        "id": 150769,
                        "name": "Zeh-e Kalut",
                        "latitude": "27.79250000",
                        "longitude": "58.58694400"
                    },
                    {
                        "id": 150778,
                        "name": "Zeydabad",
                        "latitude": "29.60092330",
                        "longitude": "55.52683340"
                    }
                ]
            },
            {
                "id": 3919,
                "name": "Kermanshah",
                "iso2": "05",
                "latitude": "34.45762330",
                "longitude": "46.67053400",
                "type": "province",
                "cities": [
                    {
                        "id": 150811,
                        "name": "azeh Abad",
                        "latitude": "34.49698980",
                        "longitude": "47.04017400"
                    },
                    {
                        "id": 150806,
                        "name": "Banevreh",
                        "latitude": "34.96917880",
                        "longitude": "46.35028830"
                    },
                    {
                        "id": 150807,
                        "name": "Bayangan",
                        "latitude": "34.98088040",
                        "longitude": "46.26785870"
                    },
                    {
                        "id": 150824,
                        "name": "Bisotun",
                        "latitude": "34.39705640",
                        "longitude": "47.43759150"
                    },
                    {
                        "id": 134851,
                        "name": "Dalahu",
                        "latitude": "34.41667000",
                        "longitude": "46.25000000"
                    },
                    {
                        "id": 134860,
                        "name": "Eslamabad-e-Gharb",
                        "latitude": "34.05000000",
                        "longitude": "46.66667000"
                    },
                    {
                        "id": 150810,
                        "name": "Ezgeleh",
                        "latitude": "34.83314400",
                        "longitude": "45.83253630"
                    },
                    {
                        "id": 150814,
                        "name": "Gahvareh",
                        "latitude": "34.34416220",
                        "longitude": "46.41101360"
                    },
                    {
                        "id": 134890,
                        "name": "Gilan Gharb",
                        "latitude": "34.13333000",
                        "longitude": "46.00000000"
                    },
                    {
                        "id": 150822,
                        "name": "Gowdin",
                        "latitude": "34.50788250",
                        "longitude": "48.07484150"
                    },
                    {
                        "id": 150821,
                        "name": "Halashi",
                        "latitude": "34.10985920",
                        "longitude": "47.08711270"
                    },
                    {
                        "id": 150805,
                        "name": "Hamil",
                        "latitude": "33.93732470",
                        "longitude": "46.76577320"
                    },
                    {
                        "id": 134652,
                        "name": "Harsin",
                        "latitude": "34.27210000",
                        "longitude": "47.58610000"
                    },
                    {
                        "id": 134657,
                        "name": "Javanrud",
                        "latitude": "34.79611000",
                        "longitude": "46.51722000"
                    },
                    {
                        "id": 134661,
                        "name": "Kahriz",
                        "latitude": "34.38380000",
                        "longitude": "47.05530000"
                    },
                    {
                        "id": 134663,
                        "name": "Kangavar",
                        "latitude": "34.50430000",
                        "longitude": "47.96530000"
                    },
                    {
                        "id": 150813,
                        "name": "Kerend-e Gharb",
                        "latitude": "34.27801600",
                        "longitude": "46.22670290"
                    },
                    {
                        "id": 134668,
                        "name": "Kermanshah",
                        "latitude": "34.31417000",
                        "longitude": "47.06500000"
                    },
                    {
                        "id": 150820,
                        "name": "Kuzaran",
                        "latitude": "34.49665360",
                        "longitude": "46.59675130"
                    },
                    {
                        "id": 150815,
                        "name": "Mansur-e Aqai",
                        "latitude": "34.93651900",
                        "longitude": "46.45208350"
                    },
                    {
                        "id": 150817,
                        "name": "Miyan Rahan",
                        "latitude": "34.58375750",
                        "longitude": "47.44153980"
                    },
                    {
                        "id": 150808,
                        "name": "Nowdeshah",
                        "latitude": "35.18205130",
                        "longitude": "46.24964120"
                    },
                    {
                        "id": 150809,
                        "name": "Nowsud",
                        "latitude": "35.16135400",
                        "longitude": "46.20011690"
                    },
                    {
                        "id": 134733,
                        "name": "Paveh",
                        "latitude": "35.04340000",
                        "longitude": "46.35650000"
                    },
                    {
                        "id": 135002,
                        "name": "Qasr-e Shirin",
                        "latitude": "34.20000000",
                        "longitude": "45.63333000"
                    },
                    {
                        "id": 135008,
                        "name": "Ravansar",
                        "latitude": "34.75000000",
                        "longitude": "46.65000000"
                    },
                    {
                        "id": 150812,
                        "name": "Rijab",
                        "latitude": "34.48030290",
                        "longitude": "46.00143560"
                    },
                    {
                        "id": 150819,
                        "name": "Robat",
                        "latitude": "34.26546230",
                        "longitude": "46.79866770"
                    },
                    {
                        "id": 135094,
                        "name": "Sahneh",
                        "latitude": "34.58333000",
                        "longitude": "47.51667000"
                    },
                    {
                        "id": 135056,
                        "name": "Salas-e Baba Jani",
                        "latitude": "34.81667000",
                        "longitude": "45.98333000"
                    },
                    {
                        "id": 135025,
                        "name": "Sarpol Zahab",
                        "latitude": "34.50000000",
                        "longitude": "45.85000000"
                    },
                    {
                        "id": 150816,
                        "name": "Satar",
                        "latitude": "34.81151280",
                        "longitude": "47.46012210"
                    },
                    {
                        "id": 135120,
                        "name": "Sonqor",
                        "latitude": "34.78187000",
                        "longitude": "47.59945000"
                    },
                    {
                        "id": 150818,
                        "name": "Soomar",
                        "latitude": "33.88124650",
                        "longitude": "45.63190690"
                    },
                    {
                        "id": 150823,
                        "name": "Srmast",
                        "latitude": "34.50537190",
                        "longitude": "47.83984780"
                    }
                ]
            },
            {
                "id": 3917,
                "name": "Khuzestan",
                "iso2": "06",
                "latitude": "31.43601490",
                "longitude": "49.04131200",
                "type": "province",
                "cities": [
                    {
                        "id": 134555,
                        "name": "Abadan",
                        "latitude": "30.33920000",
                        "longitude": "48.30430000"
                    },
                    {
                        "id": 150513,
                        "name": "Abezhdan",
                        "latitude": "32.15000000",
                        "longitude": "49.40000000"
                    },
                    {
                        "id": 150543,
                        "name": "Abou Homeyzeh",
                        "latitude": "31.52809530",
                        "longitude": "48.21535710"
                    },
                    {
                        "id": 134558,
                        "name": "Aghajari",
                        "latitude": "30.70060000",
                        "longitude": "49.83150000"
                    },
                    {
                        "id": 134561,
                        "name": "Ahvaz",
                        "latitude": "31.31901000",
                        "longitude": "48.68420000"
                    },
                    {
                        "id": 150549,
                        "name": "Alvan",
                        "latitude": "32.11138900",
                        "longitude": "48.46000000"
                    },
                    {
                        "id": 134789,
                        "name": "Andika",
                        "latitude": "32.16667000",
                        "longitude": "49.53333000"
                    },
                    {
                        "id": 134790,
                        "name": "Andimeshk",
                        "latitude": "32.70000000",
                        "longitude": "48.30000000"
                    },
                    {
                        "id": 150510,
                        "name": "Arvand Kenar",
                        "latitude": "30.05886160",
                        "longitude": "48.43110310"
                    },
                    {
                        "id": 150515,
                        "name": "Azadi",
                        "latitude": "32.40362450",
                        "longitude": "48.24791910"
                    },
                    {
                        "id": 134599,
                        "name": "Bagh Malek",
                        "latitude": "31.50000000",
                        "longitude": "49.91667000"
                    },
                    {
                        "id": 150521,
                        "name": "Baghmalek",
                        "latitude": "31.52627310",
                        "longitude": "49.86389610"
                    },
                    {
                        "id": 150528,
                        "name": "Bandar Imam Khomeini",
                        "latitude": "30.47897630",
                        "longitude": "49.00476180"
                    },
                    {
                        "id": 134804,
                        "name": "Bandar Mahshahr",
                        "latitude": "30.63333000",
                        "longitude": "49.11667000"
                    },
                    {
                        "id": 134824,
                        "name": "Bavi",
                        "latitude": "31.50000000",
                        "longitude": "48.95000000"
                    },
                    {
                        "id": 134808,
                        "name": "Behbahan",
                        "latitude": "30.56667000",
                        "longitude": "50.20000000"
                    },
                    {
                        "id": 150516,
                        "name": "Bidrubeh-ye",
                        "latitude": "32.76095130",
                        "longitude": "48.22946550"
                    },
                    {
                        "id": 150544,
                        "name": "Bostan",
                        "latitude": "31.71577230",
                        "longitude": "47.97680280"
                    },
                    {
                        "id": 150517,
                        "name": "Chamgolak",
                        "latitude": "32.44472130",
                        "longitude": "48.43590970"
                    },
                    {
                        "id": 150529,
                        "name": "Chamran Town",
                        "latitude": "30.70618820",
                        "longitude": "49.15299300"
                    },
                    {
                        "id": 150511,
                        "name": "Chavibdeh",
                        "latitude": "30.20361100",
                        "longitude": "48.55388900"
                    },
                    {
                        "id": 150535,
                        "name": "Choghamish",
                        "latitude": "32.20916700",
                        "longitude": "48.54611100"
                    },
                    {
                        "id": 150548,
                        "name": "Darkhovin",
                        "latitude": "30.74371380",
                        "longitude": "48.41850740"
                    },
                    {
                        "id": 150520,
                        "name": "Dehdez",
                        "latitude": "31.70198800",
                        "longitude": "50.28124790"
                    },
                    {
                        "id": 134850,
                        "name": "Dezful",
                        "latitude": "32.56667000",
                        "longitude": "48.78333000"
                    },
                    {
                        "id": 150519,
                        "name": "Elhayi",
                        "latitude": "31.65388900",
                        "longitude": "48.59444400"
                    },
                    {
                        "id": 150553,
                        "name": "FatholMobin",
                        "latitude": "32.42388900",
                        "longitude": "47.81000000"
                    },
                    {
                        "id": 150523,
                        "name": "Ghale Tol",
                        "latitude": "31.62757850",
                        "longitude": "49.86016210"
                    },
                    {
                        "id": 150562,
                        "name": "Golgir",
                        "latitude": "31.96470000",
                        "longitude": "49.28560000"
                    },
                    {
                        "id": 134649,
                        "name": "Gotvand",
                        "latitude": "32.21667000",
                        "longitude": "48.80000000"
                    },
                    {
                        "id": 150556,
                        "name": "Guriyeh",
                        "latitude": "31.85694400",
                        "longitude": "48.75666700"
                    },
                    {
                        "id": 150563,
                        "name": "Haftkel",
                        "latitude": "31.45494850",
                        "longitude": "49.50872880"
                    },
                    {
                        "id": 134650,
                        "name": "Hamidiyeh",
                        "latitude": "31.48107000",
                        "longitude": "48.43303000"
                    },
                    {
                        "id": 150536,
                        "name": "Hanzeh",
                        "latitude": "32.39318880",
                        "longitude": "48.57371090"
                    },
                    {
                        "id": 134893,
                        "name": "Hendijan",
                        "latitude": "30.33333000",
                        "longitude": "49.60000000"
                    },
                    {
                        "id": 150550,
                        "name": "Horr",
                        "latitude": "32.14472200",
                        "longitude": "48.39250000"
                    },
                    {
                        "id": 150518,
                        "name": "Hoseyniye",
                        "latitude": "32.67667910",
                        "longitude": "48.23694340"
                    },
                    {
                        "id": 150551,
                        "name": "Hosseinabad ",
                        "latitude": "32.05847040",
                        "longitude": "48.29463110"
                    },
                    {
                        "id": 150566,
                        "name": "Hoveyzeh",
                        "latitude": "31.46547330",
                        "longitude": "48.06143040"
                    },
                    {
                        "id": 150540,
                        "name": "Imam",
                        "latitude": "32.22777680",
                        "longitude": "48.41621160"
                    },
                    {
                        "id": 135093,
                        "name": "Izeh",
                        "latitude": "31.91667000",
                        "longitude": "49.98333000"
                    },
                    {
                        "id": 150559,
                        "name": "Jannat Makan",
                        "latitude": "32.18523730",
                        "longitude": "48.80457390"
                    },
                    {
                        "id": 150512,
                        "name": "Jayezan",
                        "latitude": "30.87428460",
                        "longitude": "49.83620500"
                    },
                    {
                        "id": 134658,
                        "name": "Jongiyeh",
                        "latitude": "31.25583000",
                        "longitude": "48.61667000"
                    },
                    {
                        "id": 134665,
                        "name": "Karun",
                        "latitude": "31.27618000",
                        "longitude": "48.64174000"
                    },
                    {
                        "id": 134675,
                        "name": "Khorramshahr",
                        "latitude": "30.44079000",
                        "longitude": "48.18428000"
                    },
                    {
                        "id": 150547,
                        "name": "Khorusi-ye Jonubi",
                        "latitude": "30.61666700",
                        "longitude": "48.61666700"
                    },
                    {
                        "id": 150557,
                        "name": "Kut Abdollah",
                        "latitude": "31.23525860",
                        "longitude": "48.64282600"
                    },
                    {
                        "id": 150545,
                        "name": "Kut-e Seyyed Naim",
                        "latitude": "31.46138900",
                        "longitude": "48.37833300"
                    },
                    {
                        "id": 134945,
                        "name": "Lali",
                        "latitude": "32.41667000",
                        "longitude": "49.16667000"
                    },
                    {
                        "id": 150532,
                        "name": "Mansuriyeh",
                        "latitude": "30.62827400",
                        "longitude": "50.29850000"
                    },
                    {
                        "id": 134699,
                        "name": "Masjed Soleyman",
                        "latitude": "31.93640000",
                        "longitude": "49.30390000"
                    },
                    {
                        "id": 150542,
                        "name": "Mianrood",
                        "latitude": "32.15313320",
                        "longitude": "48.43118900"
                    },
                    {
                        "id": 150524,
                        "name": "Midavod",
                        "latitude": "31.39148800",
                        "longitude": "49.83969100"
                    },
                    {
                        "id": 150534,
                        "name": "Minushahr",
                        "latitude": "30.34436130",
                        "longitude": "48.18489410"
                    },
                    {
                        "id": 150526,
                        "name": "Mollasani",
                        "latitude": "31.58593640",
                        "longitude": "48.87006270"
                    },
                    {
                        "id": 150533,
                        "name": "Moqavemat",
                        "latitude": "30.44583300",
                        "longitude": "48.17083300"
                    },
                    {
                        "id": 150546,
                        "name": "Moshrageh",
                        "latitude": "31.01056150",
                        "longitude": "49.43022070"
                    },
                    {
                        "id": 134723,
                        "name": "Omidiyeh",
                        "latitude": "30.76277000",
                        "longitude": "49.70226000"
                    },
                    {
                        "id": 150514,
                        "name": "Qaleh-ye Khvajeh",
                        "latitude": "32.20524790",
                        "longitude": "49.44976320"
                    },
                    {
                        "id": 134757,
                        "name": "Ramhormoz",
                        "latitude": "31.27997000",
                        "longitude": "49.60351000"
                    },
                    {
                        "id": 134758,
                        "name": "Ramshir",
                        "latitude": "30.89315000",
                        "longitude": "49.40787000"
                    },
                    {
                        "id": 150565,
                        "name": "Rofayyeh",
                        "latitude": "31.59772720",
                        "longitude": "47.88532740"
                    },
                    {
                        "id": 150541,
                        "name": "Safiabad",
                        "latitude": "32.26002660",
                        "longitude": "48.40730660"
                    },
                    {
                        "id": 150537,
                        "name": "Sāland",
                        "latitude": "32.49901190",
                        "longitude": "48.82560250"
                    },
                    {
                        "id": 150561,
                        "name": "Salehshahr",
                        "latitude": "32.21427110",
                        "longitude": "48.66241680"
                    },
                    {
                        "id": 150531,
                        "name": "Sar Dasht",
                        "latitude": "30.32761920",
                        "longitude": "50.20910740"
                    },
                    {
                        "id": 150554,
                        "name": "Sardarabad",
                        "latitude": "32.02138900",
                        "longitude": "48.79277800"
                    },
                    {
                        "id": 150560,
                        "name": "Semaleh",
                        "latitude": "32.19756680",
                        "longitude": "48.85203840"
                    },
                    {
                        "id": 150522,
                        "name": "Seydun",
                        "latitude": "31.36528970",
                        "longitude": "50.07061950"
                    },
                    {
                        "id": 135109,
                        "name": "Shadegan",
                        "latitude": "30.64924000",
                        "longitude": "48.66497000"
                    },
                    {
                        "id": 150539,
                        "name": "Shamsabad",
                        "latitude": "32.29616570",
                        "longitude": "48.42367890"
                    },
                    {
                        "id": 150555,
                        "name": "Sherafat",
                        "latitude": "32.08775530",
                        "longitude": "48.75856870"
                    },
                    {
                        "id": 150525,
                        "name": "Sheyban",
                        "latitude": "31.40816250",
                        "longitude": "48.78697870"
                    },
                    {
                        "id": 150552,
                        "name": "Shooshtar",
                        "latitude": "32.04102720",
                        "longitude": "48.79976690"
                    },
                    {
                        "id": 135113,
                        "name": "Shush",
                        "latitude": "32.19420000",
                        "longitude": "48.24360000"
                    },
                    {
                        "id": 135114,
                        "name": "Shushtar",
                        "latitude": "32.04972000",
                        "longitude": "48.84843000"
                    },
                    {
                        "id": 150538,
                        "name": "SiahMansur",
                        "latitude": "32.33225340",
                        "longitude": "48.48953250"
                    },
                    {
                        "id": 135122,
                        "name": "Susangerd",
                        "latitude": "31.56350000",
                        "longitude": "48.18958000"
                    },
                    {
                        "id": 150530,
                        "name": "Tashan",
                        "latitude": "30.82916700",
                        "longitude": "50.19833300"
                    },
                    {
                        "id": 150558,
                        "name": "Torkalaki",
                        "latitude": "32.24128960",
                        "longitude": "48.83882040"
                    },
                    {
                        "id": 150527,
                        "name": "Veys",
                        "latitude": "31.48771080",
                        "longitude": "48.86967650"
                    },
                    {
                        "id": 150564,
                        "name": "Zahreh",
                        "latitude": "30.46916700",
                        "longitude": "49.68444400"
                    }
                ]
            },
            {
                "id": 3926,
                "name": "Kohgiluyeh and Boyer-Ahmad",
                "iso2": "17",
                "latitude": "30.72458600",
                "longitude": "50.84563230",
                "type": "province",
                "cities": [
                    {
                        "id": 134799,
                        "name": "Bahmai",
                        "latitude": "31.05000000",
                        "longitude": "50.08333000"
                    },
                    {
                        "id": 134823,
                        "name": "Basht",
                        "latitude": "30.45000000",
                        "longitude": "51.11667000"
                    },
                    {
                        "id": 134832,
                        "name": "Charam",
                        "latitude": "30.76667000",
                        "longitude": "50.85000000"
                    },
                    {
                        "id": 150825,
                        "name": "Chitab",
                        "latitude": "30.79500000",
                        "longitude": "51.32555600"
                    },
                    {
                        "id": 150830,
                        "name": "Choram",
                        "latitude": "30.75374640",
                        "longitude": "50.73295340"
                    },
                    {
                        "id": 134616,
                        "name": "Dehdasht",
                        "latitude": "30.79490000",
                        "longitude": "50.56457000"
                    },
                    {
                        "id": 150834,
                        "name": "Dishmok",
                        "latitude": "31.29920680",
                        "longitude": "50.39264550"
                    },
                    {
                        "id": 134622,
                        "name": "Dogonbadan",
                        "latitude": "30.35860000",
                        "longitude": "50.79810000"
                    },
                    {
                        "id": 134878,
                        "name": "Gachsaran",
                        "latitude": "30.33333000",
                        "longitude": "50.75000000"
                    },
                    {
                        "id": 150826,
                        "name": "Garab-e Sofla",
                        "latitude": "30.94722200",
                        "longitude": "50.88777800"
                    },
                    {
                        "id": 134928,
                        "name": "Kohgiluyeh",
                        "latitude": "31.03333000",
                        "longitude": "50.45000000"
                    },
                    {
                        "id": 134688,
                        "name": "Landeh",
                        "latitude": "30.97994000",
                        "longitude": "50.42469000"
                    },
                    {
                        "id": 150837,
                        "name": "Lendeh",
                        "latitude": "30.97781800",
                        "longitude": "50.40324550"
                    },
                    {
                        "id": 150829,
                        "name": "Likak",
                        "latitude": "30.89500000",
                        "longitude": "50.09305600"
                    },
                    {
                        "id": 150827,
                        "name": "Madavan",
                        "latitude": "30.71844720",
                        "longitude": "51.53613560"
                    },
                    {
                        "id": 150828,
                        "name": "Margoon",
                        "latitude": "30.99314390",
                        "longitude": "51.06901290"
                    },
                    {
                        "id": 150832,
                        "name": "Pataveh",
                        "latitude": "30.95669820",
                        "longitude": "51.26478200"
                    },
                    {
                        "id": 150836,
                        "name": "Qaleh Raisi",
                        "latitude": "31.19000000",
                        "longitude": "50.44194400"
                    },
                    {
                        "id": 150831,
                        "name": "sarfariyab",
                        "latitude": "30.80720400",
                        "longitude": "50.84650350"
                    },
                    {
                        "id": 150833,
                        "name": "Sisakht",
                        "latitude": "30.85631130",
                        "longitude": "51.43766630"
                    },
                    {
                        "id": 150835,
                        "name": "Suq",
                        "latitude": "30.85902050",
                        "longitude": "50.45108550"
                    },
                    {
                        "id": 135139,
                        "name": "Yasuj",
                        "latitude": "30.66824000",
                        "longitude": "51.58796000"
                    }
                ]
            },
            {
                "id": 3935,
                "name": "Kurdistan",
                "iso2": "12",
                "latitude": "35.95535790",
                "longitude": "47.13621250",
                "type": "province",
                "cities": [
                    {
                        "id": 150733,
                        "name": "Armardeh",
                        "latitude": "35.93224610",
                        "longitude": "45.79138040"
                    },
                    {
                        "id": 150736,
                        "name": "Babarashani",
                        "latitude": "35.67817150",
                        "longitude": "47.79385330"
                    },
                    {
                        "id": 134600,
                        "name": "Baneh",
                        "latitude": "35.99750000",
                        "longitude": "45.88530000"
                    },
                    {
                        "id": 150749,
                        "name": "Bardeh Rasheh",
                        "latitude": "35.59324210",
                        "longitude": "46.08397320"
                    },
                    {
                        "id": 134601,
                        "name": "Bijar",
                        "latitude": "35.86680000",
                        "longitude": "47.60506000"
                    },
                    {
                        "id": 150734,
                        "name": "Boeen-e-Sofla",
                        "latitude": "35.93821400",
                        "longitude": "45.93237870"
                    },
                    {
                        "id": 150740,
                        "name": "Bolbanabad ",
                        "latitude": "35.13864820",
                        "longitude": "47.30808610"
                    },
                    {
                        "id": 150750,
                        "name": "Chnare",
                        "latitude": "35.63244780",
                        "longitude": "46.30428320"
                    },
                    {
                        "id": 134846,
                        "name": "Dehgolan",
                        "latitude": "35.35000000",
                        "longitude": "47.35000000"
                    },
                    {
                        "id": 150746,
                        "name": "Delbaran",
                        "latitude": "35.23720820",
                        "longitude": "47.97538320"
                    },
                    {
                        "id": 150745,
                        "name": "Dezej",
                        "latitude": "35.06467320",
                        "longitude": "47.95909890"
                    },
                    {
                        "id": 134854,
                        "name": "Divandarreh",
                        "latitude": "35.91667000",
                        "longitude": "47.00000000"
                    },
                    {
                        "id": 150739,
                        "name": "Hasanabad Yasukand",
                        "latitude": "36.28383610",
                        "longitude": "47.73750810"
                    },
                    {
                        "id": 134682,
                        "name": "Kamyaran",
                        "latitude": "34.79560000",
                        "longitude": "46.93550000"
                    },
                    {
                        "id": 150751,
                        "name": "Kani Dinar",
                        "latitude": "35.46323020",
                        "longitude": "46.20749840"
                    },
                    {
                        "id": 150735,
                        "name": "Kani Sur",
                        "latitude": "36.21481320",
                        "longitude": "46.81190730"
                    },
                    {
                        "id": 134697,
                        "name": "Marivan",
                        "latitude": "35.51829000",
                        "longitude": "46.18298000"
                    },
                    {
                        "id": 150748,
                        "name": "Muchesh",
                        "latitude": "35.05822680",
                        "longitude": "47.14611050"
                    },
                    {
                        "id": 150737,
                        "name": "Pir Taj",
                        "latitude": "35.77629810",
                        "longitude": "48.11167520"
                    },
                    {
                        "id": 134745,
                        "name": "Qorveh",
                        "latitude": "35.16640000",
                        "longitude": "47.80564000"
                    },
                    {
                        "id": 150743,
                        "name": "Saheb",
                        "latitude": "36.20290110",
                        "longitude": "46.45328510"
                    },
                    {
                        "id": 134765,
                        "name": "Sanandaj",
                        "latitude": "35.31495000",
                        "longitude": "46.99883000"
                    },
                    {
                        "id": 134766,
                        "name": "Saqqez",
                        "latitude": "36.24992000",
                        "longitude": "46.27350000"
                    },
                    {
                        "id": 135027,
                        "name": "Sarvabad",
                        "latitude": "35.25000000",
                        "longitude": "46.33333000"
                    },
                    {
                        "id": 150747,
                        "name": "Serish Abad",
                        "latitude": "35.24963130",
                        "longitude": "47.76967040"
                    },
                    {
                        "id": 150744,
                        "name": "Shuyesheh",
                        "latitude": "35.35699600",
                        "longitude": "46.67322630"
                    },
                    {
                        "id": 150738,
                        "name": "Tup Aghaj",
                        "latitude": "36.04829630",
                        "longitude": "47.81754160"
                    },
                    {
                        "id": 150742,
                        "name": "Uraman Takht",
                        "latitude": "35.25282120",
                        "longitude": "46.25915770"
                    },
                    {
                        "id": 150741,
                        "name": "Zarrineh ",
                        "latitude": "36.06053080",
                        "longitude": "46.91183560"
                    }
                ]
            },
            {
                "id": 3928,
                "name": "Lorestan",
                "iso2": "15",
                "latitude": "33.58183940",
                "longitude": "48.39881860",
                "type": "province",
                "cities": [
                    {
                        "id": 134564,
                        "name": "Aleshtar",
                        "latitude": "33.86419000",
                        "longitude": "48.26258000"
                    },
                    {
                        "id": 134567,
                        "name": "Aligudarz",
                        "latitude": "33.40400000",
                        "longitude": "49.69179000"
                    },
                    {
                        "id": 134573,
                        "name": "Azna",
                        "latitude": "33.45643000",
                        "longitude": "49.45646000"
                    },
                    {
                        "id": 150900,
                        "name": "Bayranshahr",
                        "latitude": "33.64777800",
                        "longitude": "48.55888900"
                    },
                    {
                        "id": 134591,
                        "name": "Borujerd",
                        "latitude": "33.89730000",
                        "longitude": "48.75160000"
                    },
                    {
                        "id": 150904,
                        "name": "Chalan Chulan",
                        "latitude": "33.66517450",
                        "longitude": "48.89954560"
                    },
                    {
                        "id": 150908,
                        "name": "Chaqabol",
                        "latitude": "33.28083300",
                        "longitude": "47.50888900"
                    },
                    {
                        "id": 150910,
                        "name": "Darb Gonbad",
                        "latitude": "33.68929030",
                        "longitude": "47.14619640"
                    },
                    {
                        "id": 134619,
                        "name": "Delfan",
                        "latitude": "34.05000000",
                        "longitude": "47.78333000"
                    },
                    {
                        "id": 150905,
                        "name": "Dorud",
                        "latitude": "33.49215260",
                        "longitude": "49.02520120"
                    },
                    {
                        "id": 150909,
                        "name": "Firouz Abad",
                        "latitude": "33.89859610",
                        "longitude": "48.09895990"
                    },
                    {
                        "id": 150912,
                        "name": "Garab",
                        "latitude": "33.48518270",
                        "longitude": "48.48797680"
                    },
                    {
                        "id": 150903,
                        "name": "Haft Cheshmeh",
                        "latitude": "34.20727710",
                        "longitude": "47.76102300"
                    },
                    {
                        "id": 134673,
                        "name": "Khorramabad",
                        "latitude": "33.48778000",
                        "longitude": "48.35583000"
                    },
                    {
                        "id": 134687,
                        "name": "Kuhdasht",
                        "latitude": "33.53335000",
                        "longitude": "47.60999000"
                    },
                    {
                        "id": 150911,
                        "name": "Kunani",
                        "latitude": "33.40296240",
                        "longitude": "47.31635560"
                    },
                    {
                        "id": 150899,
                        "name": "Mamulan",
                        "latitude": "33.37947580",
                        "longitude": "47.95176030"
                    },
                    {
                        "id": 150895,
                        "name": "Momen Abad",
                        "latitude": "33.58523350",
                        "longitude": "49.50169070"
                    },
                    {
                        "id": 134720,
                        "name": "Nurabad",
                        "latitude": "34.07340000",
                        "longitude": "47.97250000"
                    },
                    {
                        "id": 150897,
                        "name": "Oshtorinan",
                        "latitude": "34.01542270",
                        "longitude": "48.63428580"
                    },
                    {
                        "id": 150898,
                        "name": "Pol Dokhtar",
                        "latitude": "33.14617260",
                        "longitude": "47.70149940"
                    },
                    {
                        "id": 134728,
                        "name": "Pol-e Dokhtar",
                        "latitude": "33.16667000",
                        "longitude": "48.00000000"
                    },
                    {
                        "id": 134756,
                        "name": "Rumeshkhan County",
                        "latitude": "33.27960000",
                        "longitude": "47.48995000"
                    },
                    {
                        "id": 150906,
                        "name": "Sarab-e Dowreh",
                        "latitude": "33.56388900",
                        "longitude": "48.02222200"
                    },
                    {
                        "id": 134773,
                        "name": "Selseleh",
                        "latitude": "33.83333000",
                        "longitude": "48.16667000"
                    },
                    {
                        "id": 150902,
                        "name": "Sepid Dasht",
                        "latitude": "33.21903120",
                        "longitude": "48.88153190"
                    },
                    {
                        "id": 150896,
                        "name": "Shool Abad",
                        "latitude": "33.18481160",
                        "longitude": "49.18555500"
                    },
                    {
                        "id": 135138,
                        "name": "Vasian",
                        "latitude": "33.49083000",
                        "longitude": "48.04917000"
                    },
                    {
                        "id": 150907,
                        "name": "Veysian",
                        "latitude": "33.49083300",
                        "longitude": "48.04916700"
                    },
                    {
                        "id": 150901,
                        "name": "Zagheh",
                        "latitude": "33.49888900",
                        "longitude": "48.70861100"
                    }
                ]
            },
            {
                "id": 3916,
                "name": "Markazi",
                "iso2": "00",
                "latitude": "34.61230500",
                "longitude": "49.85472660",
                "type": "province",
                "cities": [
                    {
                        "id": 135150,
                        "name": "Abyek",
                        "latitude": "36.06667000",
                        "longitude": "50.55000000"
                    },
                    {
                        "id": 134571,
                        "name": "Arak",
                        "latitude": "34.09493000",
                        "longitude": "49.69809000"
                    },
                    {
                        "id": 135085,
                        "name": "Ashtian",
                        "latitude": "34.45000000",
                        "longitude": "50.05000000"
                    },
                    {
                        "id": 150968,
                        "name": "Astaneh",
                        "latitude": "33.89083300",
                        "longitude": "49.35777800"
                    },
                    {
                        "id": 150965,
                        "name": "Aveh",
                        "latitude": "34.80372130",
                        "longitude": "50.40720450"
                    },
                    {
                        "id": 150953,
                        "name": "Davoud Abad",
                        "latitude": "34.29521330",
                        "longitude": "49.84664440"
                    },
                    {
                        "id": 134620,
                        "name": "Delijan",
                        "latitude": "33.99050000",
                        "longitude": "50.68380000"
                    },
                    {
                        "id": 134865,
                        "name": "Farahan",
                        "latitude": "34.60000000",
                        "longitude": "49.63333000"
                    },
                    {
                        "id": 150974,
                        "name": "Farmahin",
                        "latitude": "34.50566860",
                        "longitude": "49.66970420"
                    },
                    {
                        "id": 150966,
                        "name": "Gharqabad",
                        "latitude": "35.10821780",
                        "longitude": "49.82183930"
                    },
                    {
                        "id": 150957,
                        "name": "Ghurchi Bashi",
                        "latitude": "33.67539870",
                        "longitude": "49.87539770"
                    },
                    {
                        "id": 150972,
                        "name": "Hendoudar",
                        "latitude": "33.78099310",
                        "longitude": "49.22662500"
                    },
                    {
                        "id": 150958,
                        "name": "Javarseyan",
                        "latitude": "34.25554870",
                        "longitude": "49.31822780"
                    },
                    {
                        "id": 150955,
                        "name": "Karchan",
                        "latitude": "34.09941170",
                        "longitude": "49.92860190"
                    },
                    {
                        "id": 150973,
                        "name": "Khenejin",
                        "latitude": "34.75851920",
                        "longitude": "49.52237610"
                    },
                    {
                        "id": 150956,
                        "name": "Khomein",
                        "latitude": "33.63710910",
                        "longitude": "50.03426970"
                    },
                    {
                        "id": 134671,
                        "name": "Khomeyn",
                        "latitude": "33.63889000",
                        "longitude": "50.08003000"
                    },
                    {
                        "id": 134918,
                        "name": "Khondab",
                        "latitude": "34.36667000",
                        "longitude": "49.18333000"
                    },
                    {
                        "id": 150961,
                        "name": "Khoshkrud",
                        "latitude": "35.39526200",
                        "longitude": "50.32892700"
                    },
                    {
                        "id": 134681,
                        "name": "Komijan",
                        "latitude": "34.72142000",
                        "longitude": "49.32653000"
                    },
                    {
                        "id": 150976,
                        "name": "Mahalat",
                        "latitude": "33.90493140",
                        "longitude": "50.44106470"
                    },
                    {
                        "id": 134959,
                        "name": "Mahallat",
                        "latitude": "33.91667000",
                        "longitude": "50.41667000"
                    },
                    {
                        "id": 150964,
                        "name": "Mamuniyeh",
                        "latitude": "35.30405590",
                        "longitude": "50.48039670"
                    },
                    {
                        "id": 150975,
                        "name": "Milajerd",
                        "latitude": "34.62165970",
                        "longitude": "49.20046800"
                    },
                    {
                        "id": 150971,
                        "name": "Mohajeran",
                        "latitude": "34.04931460",
                        "longitude": "49.41744790"
                    },
                    {
                        "id": 150959,
                        "name": "Naragh",
                        "latitude": "34.01038960",
                        "longitude": "50.83148710"
                    },
                    {
                        "id": 150977,
                        "name": "Nimvar",
                        "latitude": "33.88647470",
                        "longitude": "50.56310530"
                    },
                    {
                        "id": 150967,
                        "name": "Nowbaran",
                        "latitude": "35.13117470",
                        "longitude": "49.70070010"
                    },
                    {
                        "id": 150960,
                        "name": "Parandak",
                        "latitude": "35.36852660",
                        "longitude": "50.67722800"
                    },
                    {
                        "id": 150962,
                        "name": "Razeqan",
                        "latitude": "35.33076780",
                        "longitude": "49.95117550"
                    },
                    {
                        "id": 150954,
                        "name": "Saroogh",
                        "latitude": "34.41188360",
                        "longitude": "49.49469560"
                    },
                    {
                        "id": 135121,
                        "name": "Saveh",
                        "latitude": "35.02130000",
                        "longitude": "50.35660000"
                    },
                    {
                        "id": 150970,
                        "name": "Shahbaz",
                        "latitude": "33.93541290",
                        "longitude": "49.33569190"
                    },
                    {
                        "id": 135044,
                        "name": "Shazand",
                        "latitude": "33.90000000",
                        "longitude": "49.30000000"
                    },
                    {
                        "id": 135126,
                        "name": "Tafresh",
                        "latitude": "34.69307000",
                        "longitude": "50.01601000"
                    },
                    {
                        "id": 150969,
                        "name": "Tureh",
                        "latitude": "34.04440970",
                        "longitude": "49.28376670"
                    },
                    {
                        "id": 135072,
                        "name": "Zarandiyeh",
                        "latitude": "35.36667000",
                        "longitude": "50.33333000"
                    },
                    {
                        "id": 150963,
                        "name": "Zavieh",
                        "latitude": "35.37725590",
                        "longitude": "50.55088500"
                    }
                ]
            },
            {
                "id": 3938,
                "name": "Mazandaran",
                "iso2": "02",
                "latitude": "36.22623930",
                "longitude": "52.53186040",
                "type": "province",
                "cities": [
                    {
                        "id": 135099,
                        "name": "Abbasabad",
                        "latitude": "36.63333000",
                        "longitude": "51.15000000"
                    },
                    {
                        "id": 150935,
                        "name": "Alasht",
                        "latitude": "36.06550040",
                        "longitude": "52.83250090"
                    },
                    {
                        "id": 150917,
                        "name": "Amir Kala",
                        "latitude": "36.59866300",
                        "longitude": "52.65631190"
                    },
                    {
                        "id": 135152,
                        "name": "Amol",
                        "latitude": "36.46961000",
                        "longitude": "52.35072000"
                    },
                    {
                        "id": 150942,
                        "name": "Arateh",
                        "latitude": "36.49486060",
                        "longitude": "52.92620640"
                    },
                    {
                        "id": 134595,
                        "name": "Babol",
                        "latitude": "36.55132000",
                        "longitude": "52.67895000"
                    },
                    {
                        "id": 134596,
                        "name": "Babolsar",
                        "latitude": "36.70251000",
                        "longitude": "52.65760000"
                    },
                    {
                        "id": 150922,
                        "name": "Bahnamir",
                        "latitude": "36.67194440",
                        "longitude": "52.74325830"
                    },
                    {
                        "id": 150948,
                        "name": "Baladeh",
                        "latitude": "36.19892280",
                        "longitude": "51.79765630"
                    },
                    {
                        "id": 134585,
                        "name": "Behshahr",
                        "latitude": "36.69235000",
                        "longitude": "53.55262000"
                    },
                    {
                        "id": 134610,
                        "name": "Chalus",
                        "latitude": "36.65500000",
                        "longitude": "51.42040000"
                    },
                    {
                        "id": 150949,
                        "name": "Chamestan",
                        "latitude": "36.47860630",
                        "longitude": "52.10897640"
                    },
                    {
                        "id": 150914,
                        "name": "Dabudasht",
                        "latitude": "36.48444400",
                        "longitude": "52.45166700"
                    },
                    {
                        "id": 150913,
                        "name": "Emamzade Abdollah",
                        "latitude": "36.40886250",
                        "longitude": "52.30067250"
                    },
                    {
                        "id": 150933,
                        "name": "Farim",
                        "latitude": "36.62361100",
                        "longitude": "52.54194400"
                    },
                    {
                        "id": 134640,
                        "name": "Fereydunkenar",
                        "latitude": "36.68642000",
                        "longitude": "52.52255000"
                    },
                    {
                        "id": 134879,
                        "name": "Galugah",
                        "latitude": "36.71667000",
                        "longitude": "53.86667000"
                    },
                    {
                        "id": 150920,
                        "name": "Gatab",
                        "latitude": "36.42989710",
                        "longitude": "52.64785760"
                    },
                    {
                        "id": 150916,
                        "name": "Gazanak",
                        "latitude": "35.90314800",
                        "longitude": "52.21809470"
                    },
                    {
                        "id": 150930,
                        "name": "Hachiroud",
                        "latitude": "36.68229130",
                        "longitude": "51.34065050"
                    },
                    {
                        "id": 150947,
                        "name": "Izadshahr",
                        "latitude": "36.59444940",
                        "longitude": "52.11988020"
                    },
                    {
                        "id": 134660,
                        "name": "Juybar",
                        "latitude": "36.64115000",
                        "longitude": "52.91244000"
                    },
                    {
                        "id": 134784,
                        "name": "Kalar Dasht",
                        "latitude": "36.45000000",
                        "longitude": "51.11667000"
                    },
                    {
                        "id": 150923,
                        "name": "Kalleh Bast",
                        "latitude": "36.64199270",
                        "longitude": "52.61046750"
                    },
                    {
                        "id": 150941,
                        "name": "Kelarabad",
                        "latitude": "36.68741450",
                        "longitude": "51.23060710"
                    },
                    {
                        "id": 150944,
                        "name": "Kelardasht",
                        "latitude": "36.49314010",
                        "longitude": "51.11897660"
                    },
                    {
                        "id": 150931,
                        "name": "Ketalem and Sadat Shahr",
                        "latitude": "36.87656180",
                        "longitude": "50.70739730"
                    },
                    {
                        "id": 150924,
                        "name": "Khalil Shahr",
                        "latitude": "36.69891840",
                        "longitude": "53.62323740"
                    },
                    {
                        "id": 150926,
                        "name": "Khorramabad",
                        "latitude": "36.78182580",
                        "longitude": "50.86045490"
                    },
                    {
                        "id": 150918,
                        "name": "Khoshroud Pey",
                        "latitude": "36.37200490",
                        "longitude": "52.55749930"
                    },
                    {
                        "id": 150939,
                        "name": "Kia Kola",
                        "latitude": "36.58337860",
                        "longitude": "52.79896250"
                    },
                    {
                        "id": 150934,
                        "name": "Kiasar",
                        "latitude": "36.24016620",
                        "longitude": "53.53250060"
                    },
                    {
                        "id": 150952,
                        "name": "Kojur",
                        "latitude": "36.38226370",
                        "longitude": "51.72398280"
                    },
                    {
                        "id": 150928,
                        "name": "Kuhi Khil",
                        "latitude": "36.68877660",
                        "longitude": "52.89846190"
                    },
                    {
                        "id": 134960,
                        "name": "Mahmudabad",
                        "latitude": "36.60000000",
                        "longitude": "52.36667000"
                    },
                    {
                        "id": 150929,
                        "name": "Marzanabad",
                        "latitude": "36.45283790",
                        "longitude": "51.28507020"
                    },
                    {
                        "id": 150921,
                        "name": "Marzikola",
                        "latitude": "36.36002270",
                        "longitude": "52.73004060"
                    },
                    {
                        "id": 134972,
                        "name": "Miandorud",
                        "latitude": "36.58333000",
                        "longitude": "53.30000000"
                    },
                    {
                        "id": 134709,
                        "name": "Nashtarud",
                        "latitude": "36.75090000",
                        "longitude": "51.02362000"
                    },
                    {
                        "id": 134712,
                        "name": "Neka",
                        "latitude": "36.65079000",
                        "longitude": "53.29905000"
                    },
                    {
                        "id": 134716,
                        "name": "Nowshahr",
                        "latitude": "36.64852000",
                        "longitude": "51.49621000"
                    },
                    {
                        "id": 134987,
                        "name": "Nur",
                        "latitude": "36.31667000",
                        "longitude": "51.98333000"
                    },
                    {
                        "id": 150932,
                        "name": "Paein Hoular",
                        "latitude": "36.42892620",
                        "longitude": "53.13108150"
                    },
                    {
                        "id": 150936,
                        "name": "Pol Sefid",
                        "latitude": "36.11532040",
                        "longitude": "53.01140370"
                    },
                    {
                        "id": 150951,
                        "name": "Pul",
                        "latitude": "36.39800310",
                        "longitude": "51.57935130"
                    },
                    {
                        "id": 135003,
                        "name": "Qaem Shahr",
                        "latitude": "36.48333000",
                        "longitude": "52.90000000"
                    },
                    {
                        "id": 150943,
                        "name": "Qaemshahr",
                        "latitude": "36.46202810",
                        "longitude": "52.83104130"
                    },
                    {
                        "id": 135014,
                        "name": "Ramsar",
                        "latitude": "36.76667000",
                        "longitude": "50.53333000"
                    },
                    {
                        "id": 150915,
                        "name": "Rineh",
                        "latitude": "35.88149570",
                        "longitude": "52.16006610"
                    },
                    {
                        "id": 150925,
                        "name": "Rostam kola",
                        "latitude": "36.68009760",
                        "longitude": "53.39818930"
                    },
                    {
                        "id": 150950,
                        "name": "Royan",
                        "latitude": "36.56735610",
                        "longitude": "51.95396250"
                    },
                    {
                        "id": 150940,
                        "name": "Salman Shahr",
                        "latitude": "36.70064750",
                        "longitude": "51.19075290"
                    },
                    {
                        "id": 134769,
                        "name": "Sari",
                        "latitude": "36.56332000",
                        "longitude": "53.06009000"
                    },
                    {
                        "id": 134772,
                        "name": "Savadkuh",
                        "latitude": "35.97765000",
                        "longitude": "52.68246000"
                    },
                    {
                        "id": 150938,
                        "name": "Shirgah",
                        "latitude": "36.29749850",
                        "longitude": "52.86569940"
                    },
                    {
                        "id": 150927,
                        "name": "Shirud",
                        "latitude": "36.85088800",
                        "longitude": "50.80323940"
                    },
                    {
                        "id": 135115,
                        "name": "Simorgh County",
                        "latitude": "36.57914000",
                        "longitude": "52.82364000"
                    },
                    {
                        "id": 150945,
                        "name": "Sorkh Roud",
                        "latitude": "36.66915810",
                        "longitude": "52.44252880"
                    },
                    {
                        "id": 150946,
                        "name": "Surak",
                        "latitude": "36.59687210",
                        "longitude": "53.20168030"
                    },
                    {
                        "id": 135130,
                        "name": "Tonekabon",
                        "latitude": "36.81626000",
                        "longitude": "50.87376000"
                    },
                    {
                        "id": 150919,
                        "name": "Zargarmahalleh",
                        "latitude": "36.52138900",
                        "longitude": "52.57555600"
                    },
                    {
                        "id": 150937,
                        "name": "Zirab",
                        "latitude": "36.18055860",
                        "longitude": "52.95358650"
                    }
                ]
            },
            {
                "id": 3942,
                "name": "North Khorasan",
                "iso2": "28",
                "latitude": "37.47103530",
                "longitude": "57.10131880",
                "type": "province",
                "cities": [
                    {
                        "id": 150506,
                        "name": "Ashkhaneh",
                        "latitude": "37.55917080",
                        "longitude": "56.90694800"
                    },
                    {
                        "id": 150507,
                        "name": "Ava",
                        "latitude": "37.47722200",
                        "longitude": "56.74111100"
                    },
                    {
                        "id": 134587,
                        "name": "Bojnurd",
                        "latitude": "37.47473000",
                        "longitude": "57.32903000"
                    },
                    {
                        "id": 150494,
                        "name": "Chenaran Shahr",
                        "latitude": "37.46480280",
                        "longitude": "57.43791020"
                    },
                    {
                        "id": 150504,
                        "name": "Daraq",
                        "latitude": "36.97032870",
                        "longitude": "56.20023960"
                    },
                    {
                        "id": 134630,
                        "name": "Esfarayen",
                        "latitude": "37.07645000",
                        "longitude": "57.51009000"
                    },
                    {
                        "id": 150502,
                        "name": "Farooj",
                        "latitude": "37.18743970",
                        "longitude": "57.53594140"
                    },
                    {
                        "id": 134873,
                        "name": "Faruj",
                        "latitude": "37.21667000",
                        "longitude": "58.21667000"
                    },
                    {
                        "id": 150505,
                        "name": "Garmeh",
                        "latitude": "36.98811280",
                        "longitude": "56.26396410"
                    },
                    {
                        "id": 150495,
                        "name": "Hesar-e Garmkhan",
                        "latitude": "37.51944400",
                        "longitude": "57.48250000"
                    },
                    {
                        "id": 150503,
                        "name": "Ivar",
                        "latitude": "36.96991740",
                        "longitude": "56.25472080"
                    },
                    {
                        "id": 134899,
                        "name": "Jajarm",
                        "latitude": "37.01667000",
                        "longitude": "56.68333000"
                    },
                    {
                        "id": 150500,
                        "name": "Lujali",
                        "latitude": "37.60805600",
                        "longitude": "57.85750000"
                    },
                    {
                        "id": 134968,
                        "name": "Maneh va Samalqan",
                        "latitude": "37.70000000",
                        "longitude": "56.60000000"
                    },
                    {
                        "id": 150508,
                        "name": "Pish Ghaleh",
                        "latitude": "37.65006930",
                        "longitude": "56.98857310"
                    },
                    {
                        "id": 150509,
                        "name": "Qazi",
                        "latitude": "37.84754450",
                        "longitude": "57.31184360"
                    },
                    {
                        "id": 150499,
                        "name": "Qushkhaneh",
                        "latitude": "37.74660970",
                        "longitude": "57.70606400"
                    },
                    {
                        "id": 134750,
                        "name": "Raz",
                        "latitude": "37.93060000",
                        "longitude": "57.11940000"
                    },
                    {
                        "id": 150493,
                        "name": "Safiabad",
                        "latitude": "36.69452330",
                        "longitude": "57.92146670"
                    },
                    {
                        "id": 150496,
                        "name": "Sankhast",
                        "latitude": "37.10227080",
                        "longitude": "56.85038560"
                    },
                    {
                        "id": 135112,
                        "name": "Shirvan",
                        "latitude": "37.39669000",
                        "longitude": "57.92952000"
                    },
                    {
                        "id": 150497,
                        "name": "Shoqan",
                        "latitude": "37.34160420",
                        "longitude": "56.87828070"
                    },
                    {
                        "id": 150501,
                        "name": "Titkanlu",
                        "latitude": "37.22889760",
                        "longitude": "58.29700970"
                    },
                    {
                        "id": 150498,
                        "name": "Ziarat",
                        "latitude": "36.71608360",
                        "longitude": "58.54554170"
                    }
                ]
            },
            {
                "id": 3941,
                "name": "Qazvin",
                "iso2": "26",
                "latitude": "36.08813170",
                "longitude": "49.85472660",
                "type": "province",
                "cities": [
                    {
                        "id": 150710,
                        "name": "Abgarm",
                        "latitude": "35.75687280",
                        "longitude": "49.27735090"
                    },
                    {
                        "id": 150708,
                        "name": "Abyek",
                        "latitude": "36.04711650",
                        "longitude": "50.51818350"
                    },
                    {
                        "id": 134563,
                        "name": "Alborz",
                        "latitude": "36.18861000",
                        "longitude": "50.07829000"
                    },
                    {
                        "id": 134565,
                        "name": "Alvand",
                        "latitude": "36.18930000",
                        "longitude": "50.06430000"
                    },
                    {
                        "id": 150714,
                        "name": "Ardagh",
                        "latitude": "36.05144880",
                        "longitude": "49.81499430"
                    },
                    {
                        "id": 134572,
                        "name": "Avaj",
                        "latitude": "35.57685000",
                        "longitude": "49.22241000"
                    },
                    {
                        "id": 150711,
                        "name": "Bidestan",
                        "latitude": "36.23084220",
                        "longitude": "50.11218300"
                    },
                    {
                        "id": 134831,
                        "name": "Buin Zahra",
                        "latitude": "35.61667000",
                        "longitude": "49.70000000"
                    },
                    {
                        "id": 150715,
                        "name": "Danesfahan",
                        "latitude": "35.81572280",
                        "longitude": "49.72441600"
                    },
                    {
                        "id": 150722,
                        "name": "Eqbaliyeh",
                        "latitude": "36.22817470",
                        "longitude": "49.90673640"
                    },
                    {
                        "id": 150718,
                        "name": "Esfarvarin",
                        "latitude": "35.93684050",
                        "longitude": "49.74017140"
                    },
                    {
                        "id": 150709,
                        "name": "Khakali",
                        "latitude": "36.12998890",
                        "longitude": "50.16708250"
                    },
                    {
                        "id": 150719,
                        "name": "Khorramdasht",
                        "latitude": "35.92802320",
                        "longitude": "49.50336460"
                    },
                    {
                        "id": 150725,
                        "name": "Kouhin",
                        "latitude": "36.37223830",
                        "longitude": "49.64941610"
                    },
                    {
                        "id": 150726,
                        "name": "Mahmood Abad nemooneh",
                        "latitude": "36.29230710",
                        "longitude": "49.88979310"
                    },
                    {
                        "id": 150727,
                        "name": "Moallem Kelayeh",
                        "latitude": "36.44809600",
                        "longitude": "50.46780100"
                    },
                    {
                        "id": 150713,
                        "name": "Mohammadiyeh ",
                        "latitude": "36.22255030",
                        "longitude": "50.17574060"
                    },
                    {
                        "id": 150721,
                        "name": "Narjeh",
                        "latitude": "35.99594070",
                        "longitude": "49.61054550"
                    },
                    {
                        "id": 134740,
                        "name": "Qazvin",
                        "latitude": "36.26877000",
                        "longitude": "50.00410000"
                    },
                    {
                        "id": 150723,
                        "name": "Razmian",
                        "latitude": "36.54202690",
                        "longitude": "50.19838920"
                    },
                    {
                        "id": 150716,
                        "name": "Sagz Abad",
                        "latitude": "35.76612540",
                        "longitude": "49.91882790"
                    },
                    {
                        "id": 150717,
                        "name": "Shal",
                        "latitude": "35.89536650",
                        "longitude": "49.75102890"
                    },
                    {
                        "id": 150712,
                        "name": "Sharif Abad",
                        "latitude": "36.21499430",
                        "longitude": "50.14273880"
                    },
                    {
                        "id": 150724,
                        "name": "Sirdan",
                        "latitude": "36.64732350",
                        "longitude": "49.18877350"
                    },
                    {
                        "id": 135134,
                        "name": "Takestan",
                        "latitude": "36.07057000",
                        "longitude": "49.69571000"
                    },
                    {
                        "id": 150720,
                        "name": "Ziaabad",
                        "latitude": "35.99333300",
                        "longitude": "49.44777800"
                    }
                ]
            },
            {
                "id": 3922,
                "name": "Qom",
                "iso2": "25",
                "latitude": "34.64157640",
                "longitude": "50.87460350",
                "type": "province",
                "cities": [
                    {
                        "id": 150729,
                        "name": "Dastjerd",
                        "latitude": "34.55380730",
                        "longitude": "50.23906220"
                    },
                    {
                        "id": 150728,
                        "name": "Jafarie",
                        "latitude": "34.77450740",
                        "longitude": "50.50651060"
                    },
                    {
                        "id": 150732,
                        "name": "Kahak",
                        "latitude": "34.39196580",
                        "longitude": "50.85463990"
                    },
                    {
                        "id": 150731,
                        "name": "Qanavat",
                        "latitude": "34.61233580",
                        "longitude": "51.01366270"
                    },
                    {
                        "id": 134744,
                        "name": "Qom",
                        "latitude": "34.64010000",
                        "longitude": "50.87640000"
                    },
                    {
                        "id": 150730,
                        "name": "Salafchegan",
                        "latitude": "34.47660600",
                        "longitude": "50.45501230"
                    }
                ]
            },
            {
                "id": 3927,
                "name": "Razavi Khorasan",
                "iso2": "09",
                "latitude": "35.10202530",
                "longitude": "59.10417580",
                "type": "province",
                "cities": [
                    {
                        "id": 150445,
                        "name": "Ahmad-abad-e-Solat",
                        "latitude": "35.11510780",
                        "longitude": "60.68452830"
                    },
                    {
                        "id": 150439,
                        "name": "Anabad",
                        "latitude": "35.25017460",
                        "longitude": "57.80098200"
                    },
                    {
                        "id": 134801,
                        "name": "Bajestan",
                        "latitude": "34.58333000",
                        "longitude": "58.13333000"
                    },
                    {
                        "id": 150477,
                        "name": "Bajgiran",
                        "latitude": "37.62134430",
                        "longitude": "58.41607690"
                    },
                    {
                        "id": 134821,
                        "name": "Bakharz",
                        "latitude": "35.01667000",
                        "longitude": "60.28333000"
                    },
                    {
                        "id": 150487,
                        "name": "Bar",
                        "latitude": "36.49129220",
                        "longitude": "58.70953140"
                    },
                    {
                        "id": 134581,
                        "name": "Bardaskan",
                        "latitude": "35.26667000",
                        "longitude": "57.48333000"
                    },
                    {
                        "id": 150449,
                        "name": "Bayg",
                        "latitude": "35.37486070",
                        "longitude": "59.03061380"
                    },
                    {
                        "id": 150480,
                        "name": "Beydokht",
                        "latitude": "34.34779140",
                        "longitude": "58.74766210"
                    },
                    {
                        "id": 134827,
                        "name": "Binalud",
                        "latitude": "36.26667000",
                        "longitude": "59.33333000"
                    },
                    {
                        "id": 150488,
                        "name": "Chakaneh",
                        "latitude": "36.81366450",
                        "longitude": "58.49726210"
                    },
                    {
                        "id": 150463,
                        "name": "Chapeshlu",
                        "latitude": "37.35090120",
                        "longitude": "59.06953800"
                    },
                    {
                        "id": 134608,
                        "name": "Chenaran",
                        "latitude": "36.64546000",
                        "longitude": "59.12123000"
                    },
                    {
                        "id": 134613,
                        "name": "Dargaz",
                        "latitude": "37.33333000",
                        "longitude": "59.08333000"
                    },
                    {
                        "id": 150490,
                        "name": "Darrod",
                        "latitude": "36.13789110",
                        "longitude": "59.10554410"
                    },
                    {
                        "id": 134628,
                        "name": "Davarzan",
                        "latitude": "36.33333000",
                        "longitude": "56.83333000"
                    },
                    {
                        "id": 150468,
                        "name": "Dowlat Abad",
                        "latitude": "35.28403960",
                        "longitude": "59.51311110"
                    },
                    {
                        "id": 150491,
                        "name": "Eshqabad",
                        "latitude": "36.04380680",
                        "longitude": "58.67441650"
                    },
                    {
                        "id": 150473,
                        "name": "Farhadgerd",
                        "latitude": "35.76448180",
                        "longitude": "59.72416880"
                    },
                    {
                        "id": 134869,
                        "name": "Fariman",
                        "latitude": "35.70000000",
                        "longitude": "59.83333000"
                    },
                    {
                        "id": 150486,
                        "name": "Feyz Abad",
                        "latitude": "35.01822080",
                        "longitude": "58.76292930"
                    },
                    {
                        "id": 150475,
                        "name": "Firouzeh",
                        "latitude": "36.28288760",
                        "longitude": "58.56768590"
                    },
                    {
                        "id": 134874,
                        "name": "Firuzeh",
                        "latitude": "36.30000000",
                        "longitude": "58.41667000"
                    },
                    {
                        "id": 150492,
                        "name": "Ghadamgah",
                        "latitude": "36.11175410",
                        "longitude": "59.04797300"
                    },
                    {
                        "id": 150453,
                        "name": "Golbahar",
                        "latitude": "36.56365510",
                        "longitude": "59.13914620"
                    },
                    {
                        "id": 150454,
                        "name": "Golmakan",
                        "latitude": "36.48252780",
                        "longitude": "59.15481090"
                    },
                    {
                        "id": 134647,
                        "name": "Gonabad",
                        "latitude": "34.35287000",
                        "longitude": "58.68365000"
                    },
                    {
                        "id": 150476,
                        "name": "Hemmatabad",
                        "latitude": "36.29790420",
                        "longitude": "58.45773920"
                    },
                    {
                        "id": 150466,
                        "name": "Jangal",
                        "latitude": "34.70746780",
                        "longitude": "59.20638620"
                    },
                    {
                        "id": 134897,
                        "name": "Joghatay",
                        "latitude": "36.66667000",
                        "longitude": "57.03333000"
                    },
                    {
                        "id": 134659,
                        "name": "Joveyn",
                        "latitude": "36.58333000",
                        "longitude": "57.51667000"
                    },
                    {
                        "id": 150451,
                        "name": "Kadkan",
                        "latitude": "35.58739560",
                        "longitude": "58.87465950"
                    },
                    {
                        "id": 150481,
                        "name": "Kakhk",
                        "latitude": "34.14457510",
                        "longitude": "58.63607160"
                    },
                    {
                        "id": 134905,
                        "name": "Kalat",
                        "latitude": "36.90000000",
                        "longitude": "59.90000000"
                    },
                    {
                        "id": 150443,
                        "name": "Kariz",
                        "latitude": "34.81501620",
                        "longitude": "60.80636480"
                    },
                    {
                        "id": 134683,
                        "name": "Kashmar",
                        "latitude": "35.23831000",
                        "longitude": "58.46558000"
                    },
                    {
                        "id": 150457,
                        "name": "Khaf",
                        "latitude": "34.56989720",
                        "longitude": "60.09881910"
                    },
                    {
                        "id": 150455,
                        "name": "Khalil Abad",
                        "latitude": "35.25366100",
                        "longitude": "58.27916620"
                    },
                    {
                        "id": 134912,
                        "name": "Khalilabad",
                        "latitude": "35.11667000",
                        "longitude": "58.20000000"
                    },
                    {
                        "id": 150489,
                        "name": "Kharv",
                        "latitude": "36.15200430",
                        "longitude": "58.98408620"
                    },
                    {
                        "id": 134921,
                        "name": "Khowshab",
                        "latitude": "36.43333000",
                        "longitude": "58.06667000"
                    },
                    {
                        "id": 134922,
                        "name": "Khvaf",
                        "latitude": "34.50000000",
                        "longitude": "60.00000000"
                    },
                    {
                        "id": 150456,
                        "name": "Kondor",
                        "latitude": "35.21201740",
                        "longitude": "58.14243800"
                    },
                    {
                        "id": 150464,
                        "name": "Lotfabad",
                        "latitude": "36.17687250",
                        "longitude": "58.72503510"
                    },
                    {
                        "id": 134948,
                        "name": "Mah Velat",
                        "latitude": "34.98333000",
                        "longitude": "58.78333000"
                    },
                    {
                        "id": 134698,
                        "name": "Mashhad",
                        "latitude": "36.31559000",
                        "longitude": "59.56796000"
                    },
                    {
                        "id": 150444,
                        "name": "Mashhad Rizeh",
                        "latitude": "34.79567270",
                        "longitude": "60.49771780"
                    },
                    {
                        "id": 150471,
                        "name": "Mazdavand",
                        "latitude": "36.15644920",
                        "longitude": "60.52641750"
                    },
                    {
                        "id": 150484,
                        "name": "Molkabad",
                        "latitude": "35.99376960",
                        "longitude": "59.56460930"
                    },
                    {
                        "id": 150461,
                        "name": "Nashtifan",
                        "latitude": "34.43473260",
                        "longitude": "60.15978070"
                    },
                    {
                        "id": 150447,
                        "name": "Nasrabad",
                        "latitude": "35.41792500",
                        "longitude": "60.30567170"
                    },
                    {
                        "id": 150452,
                        "name": "Neghab",
                        "latitude": "36.70291640",
                        "longitude": "57.39315730"
                    },
                    {
                        "id": 134714,
                        "name": "Neyshabur",
                        "latitude": "36.21329000",
                        "longitude": "58.79575000"
                    },
                    {
                        "id": 150448,
                        "name": "Nil Shahr",
                        "latitude": "35.12525790",
                        "longitude": "60.76576360"
                    },
                    {
                        "id": 150465,
                        "name": "Nokhandan",
                        "latitude": "37.51838840",
                        "longitude": "58.98018830"
                    },
                    {
                        "id": 150474,
                        "name": "Qalandarabad",
                        "latitude": "35.60053760",
                        "longitude": "59.93625620"
                    },
                    {
                        "id": 150460,
                        "name": "Qasemabad",
                        "latitude": "35.91017750",
                        "longitude": "58.57594740"
                    },
                    {
                        "id": 134747,
                        "name": "Quchan",
                        "latitude": "37.10600000",
                        "longitude": "58.50955000"
                    },
                    {
                        "id": 150467,
                        "name": "Rashtkhar",
                        "latitude": "34.97462940",
                        "longitude": "59.61447710"
                    },
                    {
                        "id": 150482,
                        "name": "Razaviye",
                        "latitude": "36.20932450",
                        "longitude": "59.76103310"
                    },
                    {
                        "id": 150478,
                        "name": "Rivash",
                        "latitude": "35.47893040",
                        "longitude": "58.43782410"
                    },
                    {
                        "id": 150450,
                        "name": "Robat-e-Sang",
                        "latitude": "35.54844590",
                        "longitude": "59.18669700"
                    },
                    {
                        "id": 135011,
                        "name": "Roshtkhvar",
                        "latitude": "34.91667000",
                        "longitude": "59.36667000"
                    },
                    {
                        "id": 150469,
                        "name": "Rudab",
                        "latitude": "36.02367790",
                        "longitude": "57.30447290"
                    },
                    {
                        "id": 134762,
                        "name": "Sabzevar",
                        "latitude": "36.21260000",
                        "longitude": "57.68191000"
                    },
                    {
                        "id": 150458,
                        "name": "Salami",
                        "latitude": "34.74571990",
                        "longitude": "59.96912950"
                    },
                    {
                        "id": 150446,
                        "name": "Saleh Abad",
                        "latitude": "35.69056280",
                        "longitude": "61.08321190"
                    },
                    {
                        "id": 150483,
                        "name": "Samen",
                        "latitude": "36.42600420",
                        "longitude": "59.38201710"
                    },
                    {
                        "id": 150459,
                        "name": "Sangan",
                        "latitude": "34.40055260",
                        "longitude": "60.25382990"
                    },
                    {
                        "id": 134767,
                        "name": "Sarakhs",
                        "latitude": "36.54490000",
                        "longitude": "61.15770000"
                    },
                    {
                        "id": 150472,
                        "name": "Sefid Sang",
                        "latitude": "35.66218570",
                        "longitude": "60.08599370"
                    },
                    {
                        "id": 150485,
                        "name": "Shadmehr",
                        "latitude": "35.17244870",
                        "longitude": "59.03391840"
                    },
                    {
                        "id": 150440,
                        "name": "Shahrabad",
                        "latitude": "32.57384110",
                        "longitude": "50.99270600"
                    },
                    {
                        "id": 150479,
                        "name": "Shahrezu",
                        "latitude": "36.74907150",
                        "longitude": "59.92741590"
                    },
                    {
                        "id": 150441,
                        "name": "Shandiz",
                        "latitude": "36.39505690",
                        "longitude": "59.29064860"
                    },
                    {
                        "id": 150470,
                        "name": "Sheshtamad",
                        "latitude": "35.96042890",
                        "longitude": "57.75027730"
                    },
                    {
                        "id": 150462,
                        "name": "Soltanabad",
                        "latitude": "36.14784690",
                        "longitude": "58.86142020"
                    },
                    {
                        "id": 135066,
                        "name": "Taybad",
                        "latitude": "34.73333000",
                        "longitude": "60.73333000"
                    },
                    {
                        "id": 135063,
                        "name": "Torbat Heydariyeh",
                        "latitude": "35.46667000",
                        "longitude": "59.10000000"
                    },
                    {
                        "id": 135131,
                        "name": "Torbat-e-Jam",
                        "latitude": "35.24400000",
                        "longitude": "60.62250000"
                    },
                    {
                        "id": 150442,
                        "name": "Torghabeh",
                        "latitude": "36.31474250",
                        "longitude": "59.36767090"
                    },
                    {
                        "id": 150438,
                        "name": "Yunesi",
                        "latitude": "34.80527800",
                        "longitude": "58.43750000"
                    },
                    {
                        "id": 135076,
                        "name": "Zaveh",
                        "latitude": "35.28333000",
                        "longitude": "59.73333000"
                    }
                ]
            },
            {
                "id": 3940,
                "name": "Semnan",
                "iso2": "20",
                "latitude": "35.22555850",
                "longitude": "54.43421380",
                "type": "province",
                "cities": [
                    {
                        "id": 150585,
                        "name": "Amiriyeh",
                        "latitude": "36.02872950",
                        "longitude": "54.13541820"
                    },
                    {
                        "id": 150583,
                        "name": "Aradan",
                        "latitude": "35.24814880",
                        "longitude": "52.48640420"
                    },
                    {
                        "id": 150589,
                        "name": "Bastam",
                        "latitude": "36.48439080",
                        "longitude": "54.99071350"
                    },
                    {
                        "id": 150590,
                        "name": "Biyārjomand",
                        "latitude": "36.08175860",
                        "longitude": "55.79998970"
                    },
                    {
                        "id": 134625,
                        "name": "Damghan",
                        "latitude": "36.16790000",
                        "longitude": "54.34292000"
                    },
                    {
                        "id": 150596,
                        "name": "Darjazin",
                        "latitude": "35.62847530",
                        "longitude": "53.30819540"
                    },
                    {
                        "id": 150586,
                        "name": "Dibaj",
                        "latitude": "36.42948280",
                        "longitude": "54.21929960"
                    },
                    {
                        "id": 150595,
                        "name": "Eyvanekey",
                        "latitude": "35.34445670",
                        "longitude": "52.06075470"
                    },
                    {
                        "id": 134880,
                        "name": "Garmsar",
                        "latitude": "34.96362000",
                        "longitude": "52.21270000"
                    },
                    {
                        "id": 150593,
                        "name": "kalāte Khij",
                        "latitude": "36.67242800",
                        "longitude": "55.29090640"
                    },
                    {
                        "id": 150587,
                        "name": "Kalāteh",
                        "latitude": "36.35553790",
                        "longitude": "54.13633340"
                    },
                    {
                        "id": 150584,
                        "name": "Kohanabad",
                        "latitude": "35.22133420",
                        "longitude": "52.51071700"
                    },
                    {
                        "id": 150598,
                        "name": "Mahdi Shahr",
                        "latitude": "35.70734520",
                        "longitude": "53.25079440"
                    },
                    {
                        "id": 134690,
                        "name": "Mahdishahr",
                        "latitude": "35.70806000",
                        "longitude": "53.35083000"
                    },
                    {
                        "id": 134958,
                        "name": "Mayamey",
                        "latitude": "36.63333000",
                        "longitude": "55.95000000"
                    },
                    {
                        "id": 150594,
                        "name": "Mojen",
                        "latitude": "36.47922350",
                        "longitude": "54.63925840"
                    },
                    {
                        "id": 150591,
                        "name": "Rodian",
                        "latitude": "36.35044740",
                        "longitude": "55.00128350"
                    },
                    {
                        "id": 134774,
                        "name": "Semnan",
                        "latitude": "35.57691000",
                        "longitude": "53.39205000"
                    },
                    {
                        "id": 150597,
                        "name": "Shahmirzad",
                        "latitude": "35.77010410",
                        "longitude": "53.31802350"
                    },
                    {
                        "id": 150592,
                        "name": "Shahroud",
                        "latitude": "36.40570750",
                        "longitude": "54.93884820"
                    },
                    {
                        "id": 135105,
                        "name": "Shahrud",
                        "latitude": "36.41819000",
                        "longitude": "54.97628000"
                    },
                    {
                        "id": 150588,
                        "name": "Sorkheh",
                        "latitude": "35.46800540",
                        "longitude": "53.20981120"
                    }
                ]
            },
            {
                "id": 3931,
                "name": "Sistan and Baluchestan",
                "iso2": "11",
                "latitude": "27.52999060",
                "longitude": "60.58206760",
                "type": "province",
                "cities": [
                    {
                        "id": 150621,
                        "name": "Adimi",
                        "latitude": "31.11497090",
                        "longitude": "61.39258850"
                    },
                    {
                        "id": 150600,
                        "name": "Bampour",
                        "latitude": "27.19519200",
                        "longitude": "60.44720640"
                    },
                    {
                        "id": 150599,
                        "name": "Bazmān",
                        "latitude": "27.85550560",
                        "longitude": "60.16714090"
                    },
                    {
                        "id": 150620,
                        "name": "Bent",
                        "latitude": "26.28883260",
                        "longitude": "59.50624450"
                    },
                    {
                        "id": 150605,
                        "name": "Bonjār",
                        "latitude": "31.03910860",
                        "longitude": "61.55765160"
                    },
                    {
                        "id": 134605,
                        "name": "Chabahar",
                        "latitude": "25.29190000",
                        "longitude": "60.64300000"
                    },
                    {
                        "id": 134839,
                        "name": "Dalgan",
                        "latitude": "27.31667000",
                        "longitude": "59.30000000"
                    },
                    {
                        "id": 150623,
                        "name": "Dust Mohammad",
                        "latitude": "31.14661850",
                        "longitude": "61.77382690"
                    },
                    {
                        "id": 150619,
                        "name": "Espakeh",
                        "latitude": "26.83722420",
                        "longitude": "60.16413690"
                    },
                    {
                        "id": 150616,
                        "name": "Fanouj",
                        "latitude": "26.57336520",
                        "longitude": "59.62992650"
                    },
                    {
                        "id": 134634,
                        "name": "Fanuj",
                        "latitude": "26.57468000",
                        "longitude": "59.63856000"
                    },
                    {
                        "id": 150604,
                        "name": "Golmorti",
                        "latitude": "27.48143280",
                        "longitude": "59.43818080"
                    },
                    {
                        "id": 150610,
                        "name": "Gosht",
                        "latitude": "27.78433780",
                        "longitude": "61.92705620"
                    },
                    {
                        "id": 134651,
                        "name": "Hamoon",
                        "latitude": "30.93686000",
                        "longitude": "61.33687000"
                    },
                    {
                        "id": 150615,
                        "name": "Hidouj",
                        "latitude": "27.00415440",
                        "longitude": "62.10665690"
                    },
                    {
                        "id": 134895,
                        "name": "Hirmand",
                        "latitude": "31.25000000",
                        "longitude": "61.61667000"
                    },
                    {
                        "id": 134655,
                        "name": "Iranshahr",
                        "latitude": "27.20245000",
                        "longitude": "60.68476000"
                    },
                    {
                        "id": 150608,
                        "name": "Jālq",
                        "latitude": "27.59661720",
                        "longitude": "62.68275240"
                    },
                    {
                        "id": 134679,
                        "name": "Khash",
                        "latitude": "28.22107000",
                        "longitude": "61.21582000"
                    },
                    {
                        "id": 134930,
                        "name": "Konarak",
                        "latitude": "25.55000000",
                        "longitude": "59.85000000"
                    },
                    {
                        "id": 134961,
                        "name": "Mehrestan",
                        "latitude": "27.05000000",
                        "longitude": "61.53333000"
                    },
                    {
                        "id": 134702,
                        "name": "Mirjaveh",
                        "latitude": "29.01752000",
                        "longitude": "61.45046000"
                    },
                    {
                        "id": 150601,
                        "name": "Mohamadan",
                        "latitude": "27.20214490",
                        "longitude": "60.54998870"
                    },
                    {
                        "id": 150622,
                        "name": "Mohammadābād",
                        "latitude": "30.88253960",
                        "longitude": "61.45724050"
                    },
                    {
                        "id": 150611,
                        "name": "Mohammadi",
                        "latitude": "27.33196300",
                        "longitude": "62.38783200"
                    },
                    {
                        "id": 150602,
                        "name": "Negour",
                        "latitude": "25.38974400",
                        "longitude": "61.13295070"
                    },
                    {
                        "id": 134719,
                        "name": "Nikshahr",
                        "latitude": "26.22580000",
                        "longitude": "60.21430000"
                    },
                    {
                        "id": 134715,
                        "name": "Nimruz",
                        "latitude": "31.10333000",
                        "longitude": "61.41601000"
                    },
                    {
                        "id": 150606,
                        "name": "Nosrat Abad",
                        "latitude": "29.85348390",
                        "longitude": "59.95762810"
                    },
                    {
                        "id": 134717,
                        "name": "Nosratabad",
                        "latitude": "29.90000000",
                        "longitude": "59.98333000"
                    },
                    {
                        "id": 150603,
                        "name": "Noukābād",
                        "latitude": "28.54068480",
                        "longitude": "60.75332160"
                    },
                    {
                        "id": 150612,
                        "name": "Pishin",
                        "latitude": "26.08308740",
                        "longitude": "61.68561400"
                    },
                    {
                        "id": 134741,
                        "name": "Qasr-e-qand",
                        "latitude": "26.24833000",
                        "longitude": "60.75250000"
                    },
                    {
                        "id": 150613,
                        "name": "Rāsk",
                        "latitude": "26.24159410",
                        "longitude": "61.38488520"
                    },
                    {
                        "id": 135029,
                        "name": "Saravan",
                        "latitude": "27.32351000",
                        "longitude": "62.56796000"
                    },
                    {
                        "id": 135023,
                        "name": "Sarbaz",
                        "latitude": "26.43393000",
                        "longitude": "61.48176000"
                    },
                    {
                        "id": 135052,
                        "name": "Sib va Suran",
                        "latitude": "27.33333000",
                        "longitude": "61.91667000"
                    },
                    {
                        "id": 150609,
                        "name": "Sirkān",
                        "latitude": "26.82839760",
                        "longitude": "62.63013830"
                    },
                    {
                        "id": 150614,
                        "name": "Suran",
                        "latitude": "27.28758420",
                        "longitude": "61.98044280"
                    },
                    {
                        "id": 135147,
                        "name": "Zabol",
                        "latitude": "31.03060000",
                        "longitude": "61.49490000"
                    },
                    {
                        "id": 150618,
                        "name": "Zaboli",
                        "latitude": "27.13388980",
                        "longitude": "61.65462950"
                    },
                    {
                        "id": 150607,
                        "name": "Zahak",
                        "latitude": "30.89135860",
                        "longitude": "61.66544420"
                    },
                    {
                        "id": 135141,
                        "name": "Zahedan",
                        "latitude": "29.49630000",
                        "longitude": "60.86290000"
                    },
                    {
                        "id": 150617,
                        "name": "Zarābād",
                        "latitude": "25.58250060",
                        "longitude": "59.37785270"
                    },
                    {
                        "id": 135145,
                        "name": "Zehak",
                        "latitude": "30.86667000",
                        "longitude": "61.56667000"
                    }
                ]
            },
            {
                "id": 3930,
                "name": "South Khorasan",
                "iso2": "29",
                "latitude": "32.51756430",
                "longitude": "59.10417580",
                "type": "province",
                "cities": [
                    {
                        "id": 150432,
                        "name": "Arian Shahr",
                        "latitude": "33.33146920",
                        "longitude": "59.22934410"
                    },
                    {
                        "id": 150418,
                        "name": "Asadieh",
                        "latitude": "32.91389070",
                        "longitude": "60.01498450"
                    },
                    {
                        "id": 150424,
                        "name": "Ayask",
                        "latitude": "33.88666690",
                        "longitude": "58.36903090"
                    },
                    {
                        "id": 134828,
                        "name": "Birjand",
                        "latitude": "33.00669000",
                        "longitude": "59.07223000"
                    },
                    {
                        "id": 150416,
                        "name": "Boshrouyeh",
                        "latitude": "33.86371270",
                        "longitude": "57.40532390"
                    },
                    {
                        "id": 134592,
                        "name": "Boshruyeh",
                        "latitude": "34.16667000",
                        "longitude": "57.41667000"
                    },
                    {
                        "id": 134842,
                        "name": "Darmian",
                        "latitude": "32.95000000",
                        "longitude": "60.16667000"
                    },
                    {
                        "id": 150428,
                        "name": "Deyhuk",
                        "latitude": "33.29299580",
                        "longitude": "57.50437250"
                    },
                    {
                        "id": 150415,
                        "name": "Eresk",
                        "latitude": "33.70284870",
                        "longitude": "57.36251580"
                    },
                    {
                        "id": 150433,
                        "name": "Esfedan",
                        "latitude": "33.64611680",
                        "longitude": "59.77098940"
                    },
                    {
                        "id": 150429,
                        "name": "Eshqabad",
                        "latitude": "34.36694400",
                        "longitude": "56.93111100"
                    },
                    {
                        "id": 150430,
                        "name": "Eslamiyeh",
                        "latitude": "34.04555600",
                        "longitude": "58.22027800"
                    },
                    {
                        "id": 150431,
                        "name": "Ferdows",
                        "latitude": "34.01940280",
                        "longitude": "58.15411070"
                    },
                    {
                        "id": 150421,
                        "name": "Gazik",
                        "latitude": "32.99991820",
                        "longitude": "60.21178420"
                    },
                    {
                        "id": 150435,
                        "name": "Ghayen",
                        "latitude": "33.72482540",
                        "longitude": "59.14322310"
                    },
                    {
                        "id": 150420,
                        "name": "Ghohestan",
                        "latitude": "33.15183200",
                        "longitude": "59.69687450"
                    },
                    {
                        "id": 150422,
                        "name": "Hajiabad",
                        "latitude": "33.60327070",
                        "longitude": "59.99037270"
                    },
                    {
                        "id": 150434,
                        "name": "Khezri Dashtebayaz",
                        "latitude": "34.02110000",
                        "longitude": "58.80779740"
                    },
                    {
                        "id": 134927,
                        "name": "Khusf",
                        "latitude": "32.18333000",
                        "longitude": "58.76667000"
                    },
                    {
                        "id": 150417,
                        "name": "Mohammad Shahr",
                        "latitude": "35.74475930",
                        "longitude": "50.87227770"
                    },
                    {
                        "id": 150427,
                        "name": "Mud",
                        "latitude": "32.70890630",
                        "longitude": "59.51680120"
                    },
                    {
                        "id": 134980,
                        "name": "Nehbandan",
                        "latitude": "31.56667000",
                        "longitude": "59.81667000"
                    },
                    {
                        "id": 150436,
                        "name": "Nimbolook",
                        "latitude": "33.91169420",
                        "longitude": "58.92362600"
                    },
                    {
                        "id": 134746,
                        "name": "Qaen",
                        "latitude": "33.72654000",
                        "longitude": "59.18439000"
                    },
                    {
                        "id": 135030,
                        "name": "Sarayan",
                        "latitude": "33.41667000",
                        "longitude": "58.31667000"
                    },
                    {
                        "id": 150426,
                        "name": "Sarbishe",
                        "latitude": "32.49081810",
                        "longitude": "59.48763620"
                    },
                    {
                        "id": 135024,
                        "name": "Sarbisheh",
                        "latitude": "32.40000000",
                        "longitude": "60.08333000"
                    },
                    {
                        "id": 150425,
                        "name": "Seh Qaleh",
                        "latitude": "33.66052710",
                        "longitude": "58.39830620"
                    },
                    {
                        "id": 150437,
                        "name": "Shusf",
                        "latitude": "31.80557260",
                        "longitude": "59.99816170"
                    },
                    {
                        "id": 135124,
                        "name": "Tabas",
                        "latitude": "32.80304000",
                        "longitude": "60.22146000"
                    },
                    {
                        "id": 150419,
                        "name": "Tabas Masina",
                        "latitude": "32.80770990",
                        "longitude": "60.21503440"
                    },
                    {
                        "id": 135077,
                        "name": "Zirkuh",
                        "latitude": "33.58333000",
                        "longitude": "60.30000000"
                    },
                    {
                        "id": 150423,
                        "name": "Zohaan",
                        "latitude": "33.42331970",
                        "longitude": "59.80727440"
                    }
                ]
            },
            {
                "id": 3945,
                "name": "Tehran",
                "iso2": "23",
                "latitude": "35.72484160",
                "longitude": "51.38165300",
                "type": "province",
                "cities": [
                    {
                        "id": 150359,
                        "name": "Abali",
                        "latitude": "35.76759600",
                        "longitude": "51.94129930"
                    },
                    {
                        "id": 150358,
                        "name": "Absard",
                        "latitude": "35.62931440",
                        "longitude": "52.13407450"
                    },
                    {
                        "id": 150351,
                        "name": "Ahmadabad-E Mostowfi",
                        "latitude": "35.63518510",
                        "longitude": "51.20369200"
                    },
                    {
                        "id": 134782,
                        "name": "Andisheh",
                        "latitude": "35.68030000",
                        "longitude": "51.01930000"
                    },
                    {
                        "id": 150377,
                        "name": "Arjmand",
                        "latitude": "35.81400170",
                        "longitude": "52.50353330"
                    },
                    {
                        "id": 150364,
                        "name": "Baghershahr",
                        "latitude": "35.53356180",
                        "longitude": "51.39546910"
                    },
                    {
                        "id": 150372,
                        "name": "Baghestan",
                        "latitude": "35.64247090",
                        "longitude": "51.08020080"
                    },
                    {
                        "id": 134800,
                        "name": "Baharestan",
                        "latitude": "35.53333000",
                        "longitude": "51.15000000"
                    },
                    {
                        "id": 150357,
                        "name": "Bumehen",
                        "latitude": "35.73364600",
                        "longitude": "51.86812400"
                    },
                    {
                        "id": 150352,
                        "name": "Chahar Dangeh",
                        "latitude": "35.59615900",
                        "longitude": "51.31556500"
                    },
                    {
                        "id": 134840,
                        "name": "Damavand",
                        "latitude": "35.63005000",
                        "longitude": "52.13750000"
                    },
                    {
                        "id": 134629,
                        "name": "Eqbaliyeh",
                        "latitude": "35.30220000",
                        "longitude": "51.53580000"
                    },
                    {
                        "id": 134631,
                        "name": "Eslamshahr",
                        "latitude": "35.55222000",
                        "longitude": "51.23504000"
                    },
                    {
                        "id": 150370,
                        "name": "Fasham",
                        "latitude": "35.93172150",
                        "longitude": "51.51130900"
                    },
                    {
                        "id": 150375,
                        "name": "Ferdosiye",
                        "latitude": "35.59729320",
                        "longitude": "51.02402630"
                    },
                    {
                        "id": 150356,
                        "name": "Ferunabad",
                        "latitude": "35.51456310",
                        "longitude": "51.61007320"
                    },
                    {
                        "id": 134875,
                        "name": "Firuzkuh",
                        "latitude": "35.72852000",
                        "longitude": "52.74164000"
                    },
                    {
                        "id": 150354,
                        "name": "Golestan",
                        "latitude": "35.52074490",
                        "longitude": "51.17017500"
                    },
                    {
                        "id": 150365,
                        "name": "Hasanabad",
                        "latitude": "35.36952280",
                        "longitude": "51.22152310"
                    },
                    {
                        "id": 150379,
                        "name": "Javadabad",
                        "latitude": "35.21020010",
                        "longitude": "51.67277520"
                    },
                    {
                        "id": 150367,
                        "name": "Kahrizak",
                        "latitude": "35.51683940",
                        "longitude": "51.35078420"
                    },
                    {
                        "id": 150361,
                        "name": "Kilan",
                        "latitude": "35.55267040",
                        "longitude": "52.11622180"
                    },
                    {
                        "id": 150371,
                        "name": "Lavasan",
                        "latitude": "35.82325020",
                        "longitude": "51.60526000"
                    },
                    {
                        "id": 134693,
                        "name": "Malard",
                        "latitude": "35.66590000",
                        "longitude": "50.97670000"
                    },
                    {
                        "id": 150355,
                        "name": "Nasimshahr",
                        "latitude": "35.56385880",
                        "longitude": "51.13968360"
                    },
                    {
                        "id": 150363,
                        "name": "Nasirshahr",
                        "latitude": "35.49031160",
                        "longitude": "51.13230230"
                    },
                    {
                        "id": 134993,
                        "name": "Pakdasht",
                        "latitude": "35.49448000",
                        "longitude": "51.75302000"
                    },
                    {
                        "id": 150362,
                        "name": "Parand",
                        "latitude": "35.49026110",
                        "longitude": "50.91815410"
                    },
                    {
                        "id": 134726,
                        "name": "Pardis",
                        "latitude": "35.74169000",
                        "longitude": "51.77705000"
                    },
                    {
                        "id": 134734,
                        "name": "Pishva",
                        "latitude": "35.30800000",
                        "longitude": "51.72670000"
                    },
                    {
                        "id": 134737,
                        "name": "Qarchak",
                        "latitude": "35.42867000",
                        "longitude": "51.57544000"
                    },
                    {
                        "id": 134743,
                        "name": "Qods",
                        "latitude": "35.71667000",
                        "longitude": "51.06667000"
                    },
                    {
                        "id": 134752,
                        "name": "Rey",
                        "latitude": "35.37448000",
                        "longitude": "51.27743000"
                    },
                    {
                        "id": 134754,
                        "name": "Robat Karim",
                        "latitude": "35.48460000",
                        "longitude": "51.08290000"
                    },
                    {
                        "id": 150360,
                        "name": "Rudehen",
                        "latitude": "35.73381290",
                        "longitude": "51.89812650"
                    },
                    {
                        "id": 150374,
                        "name": "Sabashahr",
                        "latitude": "35.58323760",
                        "longitude": "51.08146840"
                    },
                    {
                        "id": 150378,
                        "name": "Safadasht",
                        "latitude": "35.68448900",
                        "longitude": "50.82465800"
                    },
                    {
                        "id": 150353,
                        "name": "salehie",
                        "latitude": "35.59992120",
                        "longitude": "51.28272270"
                    },
                    {
                        "id": 150373,
                        "name": "Shahedshahr",
                        "latitude": "35.57269240",
                        "longitude": "51.07882980"
                    },
                    {
                        "id": 150366,
                        "name": "Shahr-e-Rey",
                        "latitude": "35.57258130",
                        "longitude": "51.42336480"
                    },
                    {
                        "id": 134779,
                        "name": "Shahrak-e Emam Hasan",
                        "latitude": "35.48846000",
                        "longitude": "51.34567000"
                    },
                    {
                        "id": 135038,
                        "name": "Shahriar",
                        "latitude": "35.62828000",
                        "longitude": "51.06632000"
                    },
                    {
                        "id": 135107,
                        "name": "Sharifabad",
                        "latitude": "35.42750000",
                        "longitude": "51.78528000"
                    },
                    {
                        "id": 135039,
                        "name": "Shemiranat",
                        "latitude": "35.93141000",
                        "longitude": "51.58997000"
                    },
                    {
                        "id": 150369,
                        "name": "Shemshak",
                        "latitude": "36.01128670",
                        "longitude": "51.48654700"
                    },
                    {
                        "id": 135118,
                        "name": "Soleh Bon",
                        "latitude": "35.76841000",
                        "longitude": "52.56091000"
                    },
                    {
                        "id": 150368,
                        "name": "Tajrish",
                        "latitude": "35.80464930",
                        "longitude": "51.43132060"
                    },
                    {
                        "id": 135159,
                        "name": "Taleb abad",
                        "latitude": "35.50130000",
                        "longitude": "51.53147000"
                    },
                    {
                        "id": 135129,
                        "name": "Tehran",
                        "latitude": "35.69439000",
                        "longitude": "51.42151000"
                    },
                    {
                        "id": 150376,
                        "name": "Vahidieh",
                        "latitude": "35.60483460",
                        "longitude": "51.01625910"
                    },
                    {
                        "id": 135137,
                        "name": "Varamin",
                        "latitude": "35.32420000",
                        "longitude": "51.64570000"
                    }
                ]
            },
            {
                "id": 3924,
                "name": "West Azarbaijan",
                "iso2": "04",
                "latitude": "37.45500620",
                "longitude": "45.00000000",
                "type": "province",
                "cities": [
                    {
                        "id": 150164,
                        "name": "Avajiq",
                        "latitude": "39.31388900",
                        "longitude": "44.16472200"
                    },
                    {
                        "id": 150181,
                        "name": "Baruq",
                        "latitude": "36.95302880",
                        "longitude": "46.31413220"
                    },
                    {
                        "id": 150179,
                        "name": "Bazargan",
                        "latitude": "39.39093260",
                        "longitude": "44.37321590"
                    },
                    {
                        "id": 134829,
                        "name": "Bukan",
                        "latitude": "36.52100000",
                        "longitude": "46.13030180"
                    },
                    {
                        "id": 134836,
                        "name": "Chaldoran",
                        "latitude": "39.06667000",
                        "longitude": "44.33333000"
                    },
                    {
                        "id": 150182,
                        "name": "Charburj",
                        "latitude": "37.12187920",
                        "longitude": "45.95898600"
                    },
                    {
                        "id": 134611,
                        "name": "Chaypareh",
                        "latitude": "38.86667000",
                        "longitude": "45.00000000"
                    },
                    {
                        "id": 150168,
                        "name": "Dizaj Diz",
                        "latitude": "38.46128210",
                        "longitude": "45.00725250"
                    },
                    {
                        "id": 150166,
                        "name": "Evogli",
                        "latitude": "38.71139920",
                        "longitude": "45.19790410"
                    },
                    {
                        "id": 150170,
                        "name": "Firuraq",
                        "latitude": "38.58061010",
                        "longitude": "44.84035480"
                    },
                    {
                        "id": 150163,
                        "name": "Gerd Kashaneh",
                        "latitude": "36.81136290",
                        "longitude": "45.24764300"
                    },
                    {
                        "id": 150175,
                        "name": "Keshavarz",
                        "latitude": "36.83486050",
                        "longitude": "46.35009520"
                    },
                    {
                        "id": 150180,
                        "name": "Khalifan",
                        "latitude": "36.50681600",
                        "longitude": "45.79090840"
                    },
                    {
                        "id": 134676,
                        "name": "Khowy",
                        "latitude": "38.55030000",
                        "longitude": "44.95210000"
                    },
                    {
                        "id": 150167,
                        "name": "Khoy",
                        "latitude": "38.54849230",
                        "longitude": "44.91661490"
                    },
                    {
                        "id": 134949,
                        "name": "Mahabad",
                        "latitude": "36.76667000",
                        "longitude": "45.73333000"
                    },
                    {
                        "id": 150176,
                        "name": "Mahmoodabad",
                        "latitude": "36.71413790",
                        "longitude": "46.49164870"
                    },
                    {
                        "id": 134967,
                        "name": "Maku",
                        "latitude": "39.41669000",
                        "longitude": "44.58336000"
                    },
                    {
                        "id": 150178,
                        "name": "Marganlar",
                        "latitude": "39.14313890",
                        "longitude": "44.92987620"
                    },
                    {
                        "id": 134706,
                        "name": "Miandoab",
                        "latitude": "36.96667000",
                        "longitude": "46.10961000"
                    },
                    {
                        "id": 150173,
                        "name": "Mirabad",
                        "latitude": "36.40591310",
                        "longitude": "45.36209820"
                    },
                    {
                        "id": 150183,
                        "name": "Mohammadyar",
                        "latitude": "36.98351100",
                        "longitude": "45.51034930"
                    },
                    {
                        "id": 150160,
                        "name": "Nalous",
                        "latitude": "36.98381150",
                        "longitude": "45.13960360"
                    },
                    {
                        "id": 134708,
                        "name": "Naqadeh",
                        "latitude": "36.95530000",
                        "longitude": "45.38800000"
                    },
                    {
                        "id": 150162,
                        "name": "Nazok-e Olya",
                        "latitude": "39.01023010",
                        "longitude": "45.05091900"
                    },
                    {
                        "id": 150158,
                        "name": "Noshin",
                        "latitude": "37.73209770",
                        "longitude": "45.03828030"
                    },
                    {
                        "id": 150159,
                        "name": "Oshnavieh",
                        "latitude": "37.03578700",
                        "longitude": "45.08183940"
                    },
                    {
                        "id": 134725,
                        "name": "Oshnaviyeh",
                        "latitude": "37.03970000",
                        "longitude": "45.09830000"
                    },
                    {
                        "id": 134727,
                        "name": "Piranshahr",
                        "latitude": "36.70100000",
                        "longitude": "45.14130000"
                    },
                    {
                        "id": 134729,
                        "name": "Poldasht",
                        "latitude": "39.34800000",
                        "longitude": "45.07100000"
                    },
                    {
                        "id": 134736,
                        "name": "Qarahziyaeddin",
                        "latitude": "38.89150000",
                        "longitude": "45.02550000"
                    },
                    {
                        "id": 150171,
                        "name": "Qotur",
                        "latitude": "38.46538040",
                        "longitude": "44.38811290"
                    },
                    {
                        "id": 150157,
                        "name": "Qushchi",
                        "latitude": "37.98963410",
                        "longitude": "45.02705810"
                    },
                    {
                        "id": 150172,
                        "name": "Rabat",
                        "latitude": "36.20833300",
                        "longitude": "45.55000000"
                    },
                    {
                        "id": 134763,
                        "name": "Salmas",
                        "latitude": "38.19730000",
                        "longitude": "44.76530000"
                    },
                    {
                        "id": 134768,
                        "name": "Sardasht",
                        "latitude": "36.21670000",
                        "longitude": "45.48320000"
                    },
                    {
                        "id": 150155,
                        "name": "Serow",
                        "latitude": "37.72750000",
                        "longitude": "44.64277800"
                    },
                    {
                        "id": 135110,
                        "name": "Shahin Dej",
                        "latitude": "36.67930000",
                        "longitude": "46.56690000"
                    },
                    {
                        "id": 150177,
                        "name": "Showt",
                        "latitude": "39.22094680",
                        "longitude": "44.74915970"
                    },
                    {
                        "id": 150165,
                        "name": "Siah Cheshmeh",
                        "latitude": "39.06467800",
                        "longitude": "44.36944470"
                    },
                    {
                        "id": 150156,
                        "name": "Silvana",
                        "latitude": "37.42226160",
                        "longitude": "44.84996790"
                    },
                    {
                        "id": 150161,
                        "name": "Simmineh",
                        "latitude": "36.72972200",
                        "longitude": "46.15111100"
                    },
                    {
                        "id": 135128,
                        "name": "Takab",
                        "latitude": "36.40090000",
                        "longitude": "47.11330000"
                    },
                    {
                        "id": 150174,
                        "name": "Taze Shar",
                        "latitude": "38.17668750",
                        "longitude": "44.68377820"
                    },
                    {
                        "id": 134724,
                        "name": "Urmia",
                        "latitude": "37.55274000",
                        "longitude": "45.07605000"
                    },
                    {
                        "id": 150169,
                        "name": "Zurabad",
                        "latitude": "38.80220050",
                        "longitude": "44.57706910"
                    }
                ]
            },
            {
                "id": 3936,
                "name": "Yazd",
                "iso2": "21",
                "latitude": "32.10063870",
                "longitude": "54.43421380",
                "type": "province",
                "cities": [
                    {
                        "id": 151015,
                        "name": "Abarkooh",
                        "latitude": "31.12628100",
                        "longitude": "53.22159240"
                    },
                    {
                        "id": 134785,
                        "name": "Abarkuh",
                        "latitude": "31.00000000",
                        "longitude": "53.41667000"
                    },
                    {
                        "id": 151017,
                        "name": "Ahmadabad",
                        "latitude": "32.35666700",
                        "longitude": "53.99194400"
                    },
                    {
                        "id": 151018,
                        "name": "Aqda",
                        "latitude": "32.44319900",
                        "longitude": "53.62542610"
                    },
                    {
                        "id": 134569,
                        "name": "Ardakan",
                        "latitude": "32.31001000",
                        "longitude": "54.01747000"
                    },
                    {
                        "id": 134797,
                        "name": "Ashkezar",
                        "latitude": "32.00000000",
                        "longitude": "53.66667000"
                    },
                    {
                        "id": 151020,
                        "name": "Bafgh",
                        "latitude": "31.61251830",
                        "longitude": "55.38023410"
                    },
                    {
                        "id": 134597,
                        "name": "Bafq",
                        "latitude": "31.60350000",
                        "longitude": "55.40249000"
                    },
                    {
                        "id": 151026,
                        "name": "Bafruiyeh",
                        "latitude": "32.26992120",
                        "longitude": "53.98829480"
                    },
                    {
                        "id": 151021,
                        "name": "Bahabad",
                        "latitude": "31.87022880",
                        "longitude": "56.00460980"
                    },
                    {
                        "id": 134809,
                        "name": "Behabad",
                        "latitude": "32.01667000",
                        "longitude": "56.15000000"
                    },
                    {
                        "id": 151028,
                        "name": "Hamidia",
                        "latitude": "31.82816140",
                        "longitude": "54.37884800"
                    },
                    {
                        "id": 151024,
                        "name": "Harat",
                        "latitude": "30.05011000",
                        "longitude": "54.35108170"
                    },
                    {
                        "id": 134925,
                        "name": "Khatam",
                        "latitude": "30.38333000",
                        "longitude": "54.20000000"
                    },
                    {
                        "id": 134670,
                        "name": "Khavas Kuh",
                        "latitude": "32.30611000",
                        "longitude": "53.67444000"
                    },
                    {
                        "id": 151019,
                        "name": "Khezrabad",
                        "latitude": "31.87049590",
                        "longitude": "53.94642230"
                    },
                    {
                        "id": 134691,
                        "name": "Mahriz",
                        "latitude": "31.58428000",
                        "longitude": "54.44280000"
                    },
                    {
                        "id": 151023,
                        "name": "Marvast",
                        "latitude": "30.47856150",
                        "longitude": "54.20229430"
                    },
                    {
                        "id": 151016,
                        "name": "Mehrdasht",
                        "latitude": "31.02277800",
                        "longitude": "53.35638900"
                    },
                    {
                        "id": 151025,
                        "name": "Mehriz",
                        "latitude": "31.57977540",
                        "longitude": "54.40669420"
                    },
                    {
                        "id": 134701,
                        "name": "Meybod",
                        "latitude": "32.18333000",
                        "longitude": "53.93333000"
                    },
                    {
                        "id": 151022,
                        "name": "Nir",
                        "latitude": "31.48225780",
                        "longitude": "54.12075520"
                    },
                    {
                        "id": 151027,
                        "name": "Nodoushan",
                        "latitude": "32.03013140",
                        "longitude": "53.53182780"
                    },
                    {
                        "id": 151030,
                        "name": "Shahedieh",
                        "latitude": "31.94539800",
                        "longitude": "54.24602450"
                    },
                    {
                        "id": 135123,
                        "name": "Tabas",
                        "latitude": "33.59586000",
                        "longitude": "56.92437000"
                    },
                    {
                        "id": 135127,
                        "name": "Taft",
                        "latitude": "31.74384000",
                        "longitude": "54.20278000"
                    },
                    {
                        "id": 135140,
                        "name": "Yazd",
                        "latitude": "31.89722000",
                        "longitude": "54.36750000"
                    },
                    {
                        "id": 151029,
                        "name": "Zarach",
                        "latitude": "31.98615350",
                        "longitude": "54.22491050"
                    }
                ]
            },
            {
                "id": 3925,
                "name": "Zanjan",
                "iso2": "19",
                "latitude": "36.50181850",
                "longitude": "48.39881860",
                "type": "province",
                "cities": [
                    {
                        "id": 150580,
                        "name": "Abbar",
                        "latitude": "36.92958670",
                        "longitude": "48.93254920"
                    },
                    {
                        "id": 134556,
                        "name": "Abhar",
                        "latitude": "36.14680000",
                        "longitude": "49.21800000"
                    },
                    {
                        "id": 134566,
                        "name": "Alvand",
                        "latitude": "36.31885000",
                        "longitude": "49.16773000"
                    },
                    {
                        "id": 150578,
                        "name": "Armaqankhaneh",
                        "latitude": "36.97756320",
                        "longitude": "48.36331840"
                    },
                    {
                        "id": 150581,
                        "name": "Chavarzagh",
                        "latitude": "36.99800550",
                        "longitude": "48.77238060"
                    },
                    {
                        "id": 150582,
                        "name": "Dandi",
                        "latitude": "36.54939420",
                        "longitude": "47.59371740"
                    },
                    {
                        "id": 150576,
                        "name": "Garmaab",
                        "latitude": "35.84896910",
                        "longitude": "48.19004780"
                    },
                    {
                        "id": 150569,
                        "name": "Halab",
                        "latitude": "36.29550690",
                        "longitude": "48.05917740"
                    },
                    {
                        "id": 150568,
                        "name": "Hidaj",
                        "latitude": "36.25513060",
                        "longitude": "49.12132140"
                    },
                    {
                        "id": 135090,
                        "name": "Ijrud",
                        "latitude": "36.33333000",
                        "longitude": "48.25000000"
                    },
                    {
                        "id": 150575,
                        "name": "Karasf",
                        "latitude": "36.04488260",
                        "longitude": "48.49918840"
                    },
                    {
                        "id": 134916,
                        "name": "Khodabandeh",
                        "latitude": "36.00000000",
                        "longitude": "48.50000000"
                    },
                    {
                        "id": 134674,
                        "name": "Khorramdarreh",
                        "latitude": "36.23333000",
                        "longitude": "49.20000000"
                    },
                    {
                        "id": 134966,
                        "name": "Mahneshan",
                        "latitude": "36.66667000",
                        "longitude": "47.56667000"
                    },
                    {
                        "id": 150579,
                        "name": "Nik Pey",
                        "latitude": "36.84951730",
                        "longitude": "48.17332150"
                    },
                    {
                        "id": 150577,
                        "name": "Nurbahar",
                        "latitude": "35.93777800",
                        "longitude": "48.79472200"
                    },
                    {
                        "id": 150574,
                        "name": "Qeydar",
                        "latitude": "36.12227140",
                        "longitude": "48.57544890"
                    },
                    {
                        "id": 150567,
                        "name": "Sain Qaleh",
                        "latitude": "36.30295080",
                        "longitude": "49.06384700"
                    },
                    {
                        "id": 150573,
                        "name": "Sohrevard",
                        "latitude": "36.07305320",
                        "longitude": "48.43168260"
                    },
                    {
                        "id": 150572,
                        "name": "Sojas",
                        "latitude": "36.23940950",
                        "longitude": "48.54545110"
                    },
                    {
                        "id": 135119,
                        "name": "Soltanieh",
                        "latitude": "36.43235000",
                        "longitude": "48.79393000"
                    },
                    {
                        "id": 135097,
                        "name": "Tarom",
                        "latitude": "36.95000000",
                        "longitude": "48.90000000"
                    },
                    {
                        "id": 135142,
                        "name": "Zanjan",
                        "latitude": "36.67642000",
                        "longitude": "48.49628000"
                    },
                    {
                        "id": 150570,
                        "name": "Zarrin Abad",
                        "latitude": "36.42352420",
                        "longitude": "48.24708800"
                    },
                    {
                        "id": 150571,
                        "name": "Zarrin Rood",
                        "latitude": "35.75856190",
                        "longitude": "48.47152940"
                    }
                ]
            }
        ]
    },
    {
        "id": 104,
        "name": "Iraq",
        "iso3": "IRQ",
        "iso2": "IQ",
        "numeric_code": "368",
        "phonecode": "964",
        "capital": "Baghdad",
        "currency": "IQD",
        "currency_name": "Iraqi dinar",
        "currency_symbol": "د.ع",
        "tld": ".iq",
        "native": "العراق",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Iraqi",
        "timezones": [
            {
                "zoneName": "Asia\/Baghdad",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "br": "Irak",
            "ko": "이라크",
            "pt-BR": "Iraque",
            "pt": "Iraque",
            "nl": "Irak",
            "hr": "Irak",
            "fa": "عراق",
            "de": "Irak",
            "es": "Irak",
            "fr": "Irak",
            "ja": "イラク",
            "it": "Iraq",
            "zh-CN": "伊拉克",
            "tr": "Irak",
            "ru": "Ирак",
            "uk": "Ірак",
            "pl": "Irak"
        },
        "latitude": "33.00000000",
        "longitude": "44.00000000",
        "emoji": "🇮🇶",
        "emojiU": "U+1F1EE U+1F1F6",
        "states": [
            {
                "id": 3964,
                "name": "Al Anbar",
                "iso2": "AN",
                "latitude": "32.55976140",
                "longitude": "41.91964710",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134552,
                        "name": "‘Anah",
                        "latitude": "34.36857000",
                        "longitude": "41.98194000"
                    },
                    {
                        "id": 134553,
                        "name": "‘Anat al Qadīmah",
                        "latitude": "34.46934000",
                        "longitude": "41.94223000"
                    },
                    {
                        "id": 134478,
                        "name": "Al Fallūjah",
                        "latitude": "33.34913000",
                        "longitude": "43.78599000"
                    },
                    {
                        "id": 134495,
                        "name": "Ar Ruţbah",
                        "latitude": "33.03718000",
                        "longitude": "40.28586000"
                    },
                    {
                        "id": 134548,
                        "name": "Ḩadīthah",
                        "latitude": "34.13661000",
                        "longitude": "42.37727000"
                    },
                    {
                        "id": 134514,
                        "name": "Hīt",
                        "latitude": "33.63664000",
                        "longitude": "42.82768000"
                    },
                    {
                        "id": 134515,
                        "name": "Hīt District",
                        "latitude": "33.73482000",
                        "longitude": "42.68228000"
                    },
                    {
                        "id": 134533,
                        "name": "Ramadi",
                        "latitude": "33.42056000",
                        "longitude": "43.30778000"
                    },
                    {
                        "id": 134535,
                        "name": "Rāwah",
                        "latitude": "34.48229000",
                        "longitude": "41.91898000"
                    }
                ]
            },
            {
                "id": 3958,
                "name": "Al Muthanna",
                "iso2": "MU",
                "latitude": "29.91331710",
                "longitude": "45.29938620",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134494,
                        "name": "Ar Rumaythah",
                        "latitude": "31.52845000",
                        "longitude": "45.20377000"
                    },
                    {
                        "id": 134497,
                        "name": "As Samawah",
                        "latitude": "31.33198000",
                        "longitude": "45.29440000"
                    }
                ]
            },
            {
                "id": 3956,
                "name": "Al-Qādisiyyah",
                "iso2": "QA",
                "latitude": "32.04369100",
                "longitude": "45.14945050",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134550,
                        "name": "‘Afak",
                        "latitude": "32.06430000",
                        "longitude": "45.24743000"
                    },
                    {
                        "id": 134476,
                        "name": "Ad Dīwānīyah",
                        "latitude": "31.99289000",
                        "longitude": "44.92552000"
                    },
                    {
                        "id": 134501,
                        "name": "Ash Shāmīyah",
                        "latitude": "31.96257000",
                        "longitude": "44.60075000"
                    },
                    {
                        "id": 134530,
                        "name": "Nāḩiyat ash Shināfīyah",
                        "latitude": "31.58376000",
                        "longitude": "44.64675000"
                    },
                    {
                        "id": 134526,
                        "name": "Nahiyat Ghammas",
                        "latitude": "31.74311000",
                        "longitude": "44.61960000"
                    }
                ]
            },
            {
                "id": 3955,
                "name": "Babylon",
                "iso2": "BB",
                "latitude": "32.46819100",
                "longitude": "44.55019350",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134488,
                        "name": "Al Ḩillah",
                        "latitude": "32.46367000",
                        "longitude": "44.41963000"
                    },
                    {
                        "id": 134486,
                        "name": "Al Musayyib",
                        "latitude": "32.77872000",
                        "longitude": "44.29005000"
                    },
                    {
                        "id": 134516,
                        "name": "Imam Qasim",
                        "latitude": "32.29799000",
                        "longitude": "44.68282000"
                    },
                    {
                        "id": 134531,
                        "name": "Nāḩīyat Saddat al Hindīyah",
                        "latitude": "32.71557000",
                        "longitude": "44.27857000"
                    }
                ]
            },
            {
                "id": 3959,
                "name": "Baghdad",
                "iso2": "BG",
                "latitude": "33.31526180",
                "longitude": "44.36606530",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134473,
                        "name": "Abu Ghraib District",
                        "latitude": "33.29194000",
                        "longitude": "44.06919000"
                    },
                    {
                        "id": 134474,
                        "name": "Abū Ghurayb",
                        "latitude": "33.30563000",
                        "longitude": "44.18477000"
                    },
                    {
                        "id": 153202,
                        "name": "Adamiyah",
                        "latitude": "33.36917800",
                        "longitude": "44.33955940"
                    },
                    {
                        "id": 153203,
                        "name": "Al Adel",
                        "latitude": "33.35912830",
                        "longitude": "44.28138680"
                    },
                    {
                        "id": 153204,
                        "name": "Al Baladiyat",
                        "latitude": "33.34931610",
                        "longitude": "44.41071530"
                    },
                    {
                        "id": 153205,
                        "name": "Al Jamaa",
                        "latitude": "33.34114470",
                        "longitude": "44.34062690"
                    },
                    {
                        "id": 153206,
                        "name": "Al Saadoon Park",
                        "latitude": "33.32480360",
                        "longitude": "44.41470980"
                    },
                    {
                        "id": 153207,
                        "name": "Al Salhiah",
                        "latitude": "33.32254010",
                        "longitude": "44.38425050"
                    },
                    {
                        "id": 153208,
                        "name": "Al Za'franiya",
                        "latitude": "33.31857750",
                        "longitude": "44.48686390"
                    },
                    {
                        "id": 153209,
                        "name": "Al-Ubaidi",
                        "latitude": "33.32036030",
                        "longitude": "44.45955910"
                    },
                    {
                        "id": 153210,
                        "name": "Al-Wahda",
                        "latitude": "33.31115820",
                        "longitude": "44.43352280"
                    },
                    {
                        "id": 153211,
                        "name": "Ameria",
                        "latitude": "33.29671020",
                        "longitude": "44.27076790"
                    },
                    {
                        "id": 153212,
                        "name": "Amil District",
                        "latitude": "33.27606090",
                        "longitude": "44.31037170"
                    },
                    {
                        "id": 153213,
                        "name": "Amin",
                        "latitude": "33.31248740",
                        "longitude": "44.48634150"
                    },
                    {
                        "id": 153214,
                        "name": "Arasat AlHindiya",
                        "latitude": "33.29335790",
                        "longitude": "44.42302450"
                    },
                    {
                        "id": 153215,
                        "name": "At Taifiya",
                        "latitude": "33.35643940",
                        "longitude": "44.35791100"
                    },
                    {
                        "id": 153216,
                        "name": "Bab Al Moatham",
                        "latitude": "33.36014170",
                        "longitude": "44.36507700"
                    },
                    {
                        "id": 153217,
                        "name": "Bab Al Sharqi",
                        "latitude": "33.33249060",
                        "longitude": "44.41407910"
                    },
                    {
                        "id": 134504,
                        "name": "Baghdad",
                        "latitude": "33.34058000",
                        "longitude": "44.40088000"
                    },
                    {
                        "id": 153218,
                        "name": "Baghdad Al Jadeeda",
                        "latitude": "33.31335440",
                        "longitude": "44.47157920"
                    },
                    {
                        "id": 153219,
                        "name": "Baijai",
                        "latitude": "33.33254000",
                        "longitude": "44.34509550"
                    },
                    {
                        "id": 153220,
                        "name": "Bataween",
                        "latitude": "33.32112350",
                        "longitude": "44.40855680"
                    },
                    {
                        "id": 153221,
                        "name": "Bayaa",
                        "latitude": "33.28255440",
                        "longitude": "44.37528030"
                    },
                    {
                        "id": 153222,
                        "name": "Binouk",
                        "latitude": "33.39278120",
                        "longitude": "44.41114480"
                    },
                    {
                        "id": 153223,
                        "name": "Bo'aitha",
                        "latitude": "33.24194630",
                        "longitude": "44.42695090"
                    },
                    {
                        "id": 153224,
                        "name": "Camp Sarah",
                        "latitude": "33.30112930",
                        "longitude": "44.44469600"
                    },
                    {
                        "id": 153225,
                        "name": "Daoudi",
                        "latitude": "33.31214030",
                        "longitude": "44.32584820"
                    },
                    {
                        "id": 153226,
                        "name": "Dora",
                        "latitude": "33.23126860",
                        "longitude": "44.36198120"
                    },
                    {
                        "id": 153227,
                        "name": "Ghadeer",
                        "latitude": "33.33749740",
                        "longitude": "44.46281840"
                    },
                    {
                        "id": 153228,
                        "name": "Ghazaliya",
                        "latitude": "33.34143530",
                        "longitude": "44.22354420"
                    },
                    {
                        "id": 153229,
                        "name": "Gherai'at",
                        "latitude": "33.39208370",
                        "longitude": "44.30443140"
                    },
                    {
                        "id": 153230,
                        "name": "Green Zone",
                        "latitude": "33.31376100",
                        "longitude": "44.35900560"
                    },
                    {
                        "id": 153231,
                        "name": "Habibiya",
                        "latitude": "33.33920270",
                        "longitude": "44.46846120"
                    },
                    {
                        "id": 153232,
                        "name": "Harthiya",
                        "latitude": "33.22626120",
                        "longitude": "44.39826750"
                    },
                    {
                        "id": 153233,
                        "name": "Hurriya",
                        "latitude": "33.34241870",
                        "longitude": "44.30656300"
                    },
                    {
                        "id": 153234,
                        "name": "Iskan",
                        "latitude": "33.33405930",
                        "longitude": "44.32303100"
                    },
                    {
                        "id": 153235,
                        "name": "Jadriyah",
                        "latitude": "33.26076360",
                        "longitude": "44.41117200"
                    },
                    {
                        "id": 153236,
                        "name": "Jamila",
                        "latitude": "33.35108840",
                        "longitude": "44.41495600"
                    },
                    {
                        "id": 153237,
                        "name": "Jihad",
                        "latitude": "33.25289200",
                        "longitude": "44.29231180"
                    },
                    {
                        "id": 153238,
                        "name": "Kadhimiya",
                        "latitude": "33.38129610",
                        "longitude": "44.35139180"
                    },
                    {
                        "id": 153239,
                        "name": "Kamaliyah",
                        "latitude": "33.35008480",
                        "longitude": "44.50894110"
                    },
                    {
                        "id": 153240,
                        "name": "Karada",
                        "latitude": "33.29336610",
                        "longitude": "44.39641530"
                    },
                    {
                        "id": 153241,
                        "name": "Khadra",
                        "latitude": "33.31972470",
                        "longitude": "44.28764700"
                    },
                    {
                        "id": 153242,
                        "name": "Mansour",
                        "latitude": "33.31422960",
                        "longitude": "44.33631230"
                    },
                    {
                        "id": 153243,
                        "name": "Mashtal",
                        "latitude": "33.32443210",
                        "longitude": "44.49314830"
                    },
                    {
                        "id": 153244,
                        "name": "Mustansiriya",
                        "latitude": "33.36298920",
                        "longitude": "44.38695430"
                    },
                    {
                        "id": 153245,
                        "name": "Qadisiyah",
                        "latitude": "33.32719630",
                        "longitude": "44.31623840"
                    },
                    {
                        "id": 153246,
                        "name": "Sadr City",
                        "latitude": "33.37692330",
                        "longitude": "44.40446380"
                    },
                    {
                        "id": 153247,
                        "name": "Saidiya",
                        "latitude": "33.26500930",
                        "longitude": "44.33159340"
                    },
                    {
                        "id": 153248,
                        "name": "Sha'ab",
                        "latitude": "33.41309100",
                        "longitude": "44.38611030"
                    },
                    {
                        "id": 153249,
                        "name": "Sheik Maaruf",
                        "latitude": "33.33896010",
                        "longitude": "44.34789580"
                    },
                    {
                        "id": 153250,
                        "name": "Shorjah",
                        "latitude": "33.34613940",
                        "longitude": "44.39504420"
                    },
                    {
                        "id": 153251,
                        "name": "Suleikh",
                        "latitude": "33.39343320",
                        "longitude": "44.36144500"
                    },
                    {
                        "id": 153252,
                        "name": "Ur District",
                        "latitude": "33.41694000",
                        "longitude": "44.39060790"
                    },
                    {
                        "id": 153253,
                        "name": "Wazireya",
                        "latitude": "33.36366170",
                        "longitude": "44.38196550"
                    },
                    {
                        "id": 153254,
                        "name": "Yarmouk",
                        "latitude": "33.33938360",
                        "longitude": "44.32212520"
                    },
                    {
                        "id": 153255,
                        "name": "Ziyouna",
                        "latitude": "33.32484340",
                        "longitude": "44.45454600"
                    }
                ]
            },
            {
                "id": 3960,
                "name": "Basra",
                "iso2": "BA",
                "latitude": "30.51142520",
                "longitude": "47.82962530",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134477,
                        "name": "Al Başrah al Qadīmah",
                        "latitude": "30.50316000",
                        "longitude": "47.81507000"
                    },
                    {
                        "id": 134479,
                        "name": "Al Fāw",
                        "latitude": "29.97421000",
                        "longitude": "48.47309000"
                    },
                    {
                        "id": 134481,
                        "name": "Al Hārithah",
                        "latitude": "30.58481000",
                        "longitude": "47.76114000"
                    },
                    {
                        "id": 134502,
                        "name": "Az Zubayr",
                        "latitude": "30.39213000",
                        "longitude": "47.70175000"
                    },
                    {
                        "id": 134508,
                        "name": "Basrah",
                        "latitude": "30.50852000",
                        "longitude": "47.78040000"
                    },
                    {
                        "id": 134546,
                        "name": "Umm Qaşr",
                        "latitude": "30.03620000",
                        "longitude": "47.91951000"
                    }
                ]
            },
            {
                "id": 3954,
                "name": "Dhi Qar",
                "iso2": "DQ",
                "latitude": "31.10422920",
                "longitude": "46.36246860",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134500,
                        "name": "Ash Shaţrah",
                        "latitude": "31.40906000",
                        "longitude": "46.17270000"
                    },
                    {
                        "id": 134529,
                        "name": "Nāḩiyat al Fuhūd",
                        "latitude": "30.96972000",
                        "longitude": "46.72278000"
                    },
                    {
                        "id": 134528,
                        "name": "Nasiriyah",
                        "latitude": "31.05799000",
                        "longitude": "46.25726000"
                    }
                ]
            },
            {
                "id": 3965,
                "name": "Diyala",
                "iso2": "DI",
                "latitude": "33.77334870",
                "longitude": "45.14945050",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134484,
                        "name": "Al Miqdādīyah",
                        "latitude": "33.97861000",
                        "longitude": "44.93694000"
                    },
                    {
                        "id": 134506,
                        "name": "Baladrūz",
                        "latitude": "33.69631000",
                        "longitude": "45.07782000"
                    },
                    {
                        "id": 134507,
                        "name": "Baqubah",
                        "latitude": "33.75403000",
                        "longitude": "44.60518000"
                    },
                    {
                        "id": 134519,
                        "name": "Khāliş",
                        "latitude": "33.80809000",
                        "longitude": "44.53343000"
                    },
                    {
                        "id": 134520,
                        "name": "Kifrī",
                        "latitude": "34.68963000",
                        "longitude": "44.96057000"
                    },
                    {
                        "id": 134524,
                        "name": "Mandalī",
                        "latitude": "33.74810000",
                        "longitude": "45.55503000"
                    },
                    {
                        "id": 134532,
                        "name": "Qaḑā’ Kifrī",
                        "latitude": "34.52289000",
                        "longitude": "44.85821000"
                    }
                ]
            },
            {
                "id": 3967,
                "name": "Dohuk",
                "iso2": "DA",
                "latitude": "36.90772520",
                "longitude": "43.06316890",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134489,
                        "name": "Al ‘Amādīyah",
                        "latitude": "37.09214000",
                        "longitude": "43.48769000"
                    },
                    {
                        "id": 134509,
                        "name": "Batifa",
                        "latitude": "37.17454000",
                        "longitude": "43.01233000"
                    },
                    {
                        "id": 134512,
                        "name": "Dihok",
                        "latitude": "36.86709000",
                        "longitude": "42.98845000"
                    },
                    {
                        "id": 134541,
                        "name": "Sīnah",
                        "latitude": "36.80851000",
                        "longitude": "43.03935000"
                    },
                    {
                        "id": 134547,
                        "name": "Zaxo",
                        "latitude": "37.14871000",
                        "longitude": "42.68591000"
                    }
                ]
            },
            {
                "id": 3968,
                "name": "Erbil",
                "iso2": "AR",
                "latitude": "36.55706280",
                "longitude": "44.38512630",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134496,
                        "name": "Arbil",
                        "latitude": "36.19070000",
                        "longitude": "44.00947000"
                    },
                    {
                        "id": 134513,
                        "name": "Erbil",
                        "latitude": "36.18333000",
                        "longitude": "44.01193000"
                    },
                    {
                        "id": 134522,
                        "name": "Koysinceq",
                        "latitude": "36.08289000",
                        "longitude": "44.62873000"
                    },
                    {
                        "id": 134534,
                        "name": "Ruwāndiz",
                        "latitude": "36.61207000",
                        "longitude": "44.52372000"
                    },
                    {
                        "id": 134536,
                        "name": "Shaqlāwah",
                        "latitude": "36.40422000",
                        "longitude": "44.32563000"
                    },
                    {
                        "id": 134539,
                        "name": "Soran",
                        "latitude": "36.65320000",
                        "longitude": "44.54407000"
                    }
                ]
            },
            {
                "id": 3957,
                "name": "Karbala",
                "iso2": "KA",
                "latitude": "32.40454930",
                "longitude": "43.86732220",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134480,
                        "name": "Al Hindīyah",
                        "latitude": "32.54671000",
                        "longitude": "44.22765000"
                    },
                    {
                        "id": 134518,
                        "name": "Karbala",
                        "latitude": "32.61603000",
                        "longitude": "44.02488000"
                    }
                ]
            },
            {
                "id": 3971,
                "name": "Kirkuk",
                "iso2": "KI",
                "latitude": "35.32920140",
                "longitude": "43.94367880",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134521,
                        "name": "Kirkuk",
                        "latitude": "35.46806000",
                        "longitude": "44.39222000"
                    }
                ]
            },
            {
                "id": 3966,
                "name": "Maysan",
                "iso2": "MA",
                "latitude": "31.87340020",
                "longitude": "47.13621250",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134551,
                        "name": "‘Alī al Gharbī",
                        "latitude": "32.46186000",
                        "longitude": "46.68794000"
                    },
                    {
                        "id": 134490,
                        "name": "Al ‘Amārah",
                        "latitude": "31.83561000",
                        "longitude": "47.14483000"
                    },
                    {
                        "id": 134493,
                        "name": "Al-Mejar Al-Kabi District",
                        "latitude": "31.42940000",
                        "longitude": "47.20355000"
                    }
                ]
            },
            {
                "id": 3962,
                "name": "Najaf",
                "iso2": "NA",
                "latitude": "31.35174860",
                "longitude": "44.09603110",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134485,
                        "name": "Al Mishkhāb",
                        "latitude": "31.80437000",
                        "longitude": "44.48930000"
                    },
                    {
                        "id": 134523,
                        "name": "Kufa",
                        "latitude": "32.05114000",
                        "longitude": "44.44017000"
                    },
                    {
                        "id": 134527,
                        "name": "Najaf",
                        "latitude": "32.02594000",
                        "longitude": "44.34625000"
                    }
                ]
            },
            {
                "id": 3963,
                "name": "Nineveh",
                "iso2": "NI",
                "latitude": "36.22957400",
                "longitude": "42.23624350",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134554,
                        "name": "‘Aqrah",
                        "latitude": "36.76038000",
                        "longitude": "43.89428000"
                    },
                    {
                        "id": 134483,
                        "name": "Al Mawşil al Jadīdah",
                        "latitude": "36.33271000",
                        "longitude": "43.10555000"
                    },
                    {
                        "id": 134492,
                        "name": "Al-Hamdaniya",
                        "latitude": "36.27093000",
                        "longitude": "43.37758000"
                    },
                    {
                        "id": 134499,
                        "name": "Ash Shaykhān",
                        "latitude": "36.69595000",
                        "longitude": "43.35202000"
                    },
                    {
                        "id": 134525,
                        "name": "Mosul",
                        "latitude": "36.33500000",
                        "longitude": "43.11889000"
                    },
                    {
                        "id": 134537,
                        "name": "Sinjar",
                        "latitude": "36.29548000",
                        "longitude": "41.89315000"
                    },
                    {
                        "id": 134542,
                        "name": "Tall ‘Afar",
                        "latitude": "36.37913000",
                        "longitude": "42.44806000"
                    },
                    {
                        "id": 134543,
                        "name": "Tallkayf",
                        "latitude": "36.49118000",
                        "longitude": "43.12114000"
                    }
                ]
            },
            {
                "id": 3961,
                "name": "Saladin",
                "iso2": "SD",
                "latitude": "34.53375270",
                "longitude": "43.48373800",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134475,
                        "name": "Ad Dujayl",
                        "latitude": "33.84667000",
                        "longitude": "44.23444000"
                    },
                    {
                        "id": 134505,
                        "name": "Balad",
                        "latitude": "34.01485000",
                        "longitude": "44.14574000"
                    },
                    {
                        "id": 134510,
                        "name": "Bayjī",
                        "latitude": "34.92915000",
                        "longitude": "43.48878000"
                    },
                    {
                        "id": 134540,
                        "name": "Sāmarrā’",
                        "latitude": "34.19590000",
                        "longitude": "43.88568000"
                    },
                    {
                        "id": 134544,
                        "name": "Tikrīt",
                        "latitude": "34.61581000",
                        "longitude": "43.67861000"
                    },
                    {
                        "id": 134545,
                        "name": "Tozkhurmato",
                        "latitude": "34.88808000",
                        "longitude": "44.63256000"
                    }
                ]
            },
            {
                "id": 3969,
                "name": "Sulaymaniyah",
                "iso2": "SU",
                "latitude": "35.54663480",
                "longitude": "45.30036830",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134498,
                        "name": "As Sulaymānīyah",
                        "latitude": "35.56496000",
                        "longitude": "45.43290000"
                    },
                    {
                        "id": 134511,
                        "name": "Baynjiwayn",
                        "latitude": "35.62054000",
                        "longitude": "45.94908000"
                    },
                    {
                        "id": 134549,
                        "name": "Ḩalabjah",
                        "latitude": "35.17778000",
                        "longitude": "45.98611000"
                    },
                    {
                        "id": 134517,
                        "name": "Jamjamāl",
                        "latitude": "35.53356000",
                        "longitude": "44.83430000"
                    }
                ]
            },
            {
                "id": 3970,
                "name": "Wasit",
                "iso2": "WA",
                "latitude": "32.60240940",
                "longitude": "45.75209850",
                "type": "governorate",
                "cities": [
                    {
                        "id": 134491,
                        "name": "Al ‘Azīzīyah",
                        "latitude": "32.90941000",
                        "longitude": "45.06359000"
                    },
                    {
                        "id": 134487,
                        "name": "Al Ḩayy",
                        "latitude": "32.17419000",
                        "longitude": "46.04345000"
                    },
                    {
                        "id": 134482,
                        "name": "Al Kūt",
                        "latitude": "32.51280000",
                        "longitude": "45.81817000"
                    },
                    {
                        "id": 134503,
                        "name": "Aş Şuwayrah",
                        "latitude": "32.92556000",
                        "longitude": "44.77583000"
                    }
                ]
            }
        ]
    },
    {
        "id": 105,
        "name": "Ireland",
        "iso3": "IRL",
        "iso2": "IE",
        "numeric_code": "372",
        "phonecode": "353",
        "capital": "Dublin",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".ie",
        "native": "Éire",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Irish",
        "timezones": [
            {
                "zoneName": "Europe\/Dublin",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Iwerzhon",
            "ko": "아일랜드",
            "pt-BR": "Irlanda",
            "pt": "Irlanda",
            "nl": "Ierland",
            "hr": "Irska",
            "fa": "ایرلند",
            "de": "Irland",
            "es": "Irlanda",
            "fr": "Irlande",
            "ja": "アイルランド",
            "it": "Irlanda",
            "zh-CN": "爱尔兰",
            "tr": "İrlanda",
            "ru": "Ирландия",
            "uk": "Ірландія",
            "pl": "Irlandia"
        },
        "latitude": "53.00000000",
        "longitude": "-8.00000000",
        "emoji": "🇮🇪",
        "emojiU": "U+1F1EE U+1F1EA",
        "states": [
            {
                "id": 1095,
                "name": "Carlow",
                "iso2": "CW",
                "latitude": "52.72322170",
                "longitude": "-6.81082950",
                "type": "county",
                "cities": []
            },
            {
                "id": 1088,
                "name": "Cavan",
                "iso2": "CN",
                "latitude": "53.97654240",
                "longitude": "-7.29966230",
                "type": "county",
                "cities": []
            },
            {
                "id": 1091,
                "name": "Clare",
                "iso2": "CE",
                "latitude": "43.04664000",
                "longitude": "-87.89958100",
                "type": "county",
                "cities": []
            },
            {
                "id": 1087,
                "name": "Connacht",
                "iso2": "C",
                "latitude": "53.83762430",
                "longitude": "-8.95844810",
                "type": "province",
                "cities": [
                    {
                        "id": 57082,
                        "name": "Athenry",
                        "latitude": "53.29639000",
                        "longitude": "-8.74306000"
                    },
                    {
                        "id": 57092,
                        "name": "Ballaghaderreen",
                        "latitude": "53.90000000",
                        "longitude": "-8.58333000"
                    },
                    {
                        "id": 57093,
                        "name": "Ballina",
                        "latitude": "54.11667000",
                        "longitude": "-9.16667000"
                    },
                    {
                        "id": 57095,
                        "name": "Ballinasloe",
                        "latitude": "53.32750000",
                        "longitude": "-8.21944000"
                    },
                    {
                        "id": 57097,
                        "name": "Ballinrobe",
                        "latitude": "53.63333000",
                        "longitude": "-9.23333000"
                    },
                    {
                        "id": 57099,
                        "name": "Ballisodare",
                        "latitude": "54.21110000",
                        "longitude": "-8.50865000"
                    },
                    {
                        "id": 57107,
                        "name": "Ballyhaunis",
                        "latitude": "53.76667000",
                        "longitude": "-8.76667000"
                    },
                    {
                        "id": 57111,
                        "name": "Ballymote",
                        "latitude": "54.08333000",
                        "longitude": "-8.51667000"
                    },
                    {
                        "id": 57121,
                        "name": "Bearna",
                        "latitude": "53.25194000",
                        "longitude": "-9.14972000"
                    },
                    {
                        "id": 57123,
                        "name": "Belmullet",
                        "latitude": "54.22500000",
                        "longitude": "-9.99083000"
                    },
                    {
                        "id": 57132,
                        "name": "Boyle",
                        "latitude": "53.96667000",
                        "longitude": "-8.30000000"
                    },
                    {
                        "id": 57147,
                        "name": "Carrick-on-Shannon",
                        "latitude": "53.94694000",
                        "longitude": "-8.09000000"
                    },
                    {
                        "id": 57153,
                        "name": "Castlebar",
                        "latitude": "53.85000000",
                        "longitude": "-9.30000000"
                    },
                    {
                        "id": 57164,
                        "name": "Castlerea",
                        "latitude": "53.76667000",
                        "longitude": "-8.50000000"
                    },
                    {
                        "id": 57176,
                        "name": "Claregalway",
                        "latitude": "53.33861000",
                        "longitude": "-8.94500000"
                    },
                    {
                        "id": 57177,
                        "name": "Claremorris",
                        "latitude": "53.71667000",
                        "longitude": "-9.00000000"
                    },
                    {
                        "id": 57178,
                        "name": "Clifden",
                        "latitude": "53.48907000",
                        "longitude": "-10.01910000"
                    },
                    {
                        "id": 57187,
                        "name": "Collooney",
                        "latitude": "54.18333000",
                        "longitude": "-8.50000000"
                    },
                    {
                        "id": 57197,
                        "name": "County Galway",
                        "latitude": "53.33333000",
                        "longitude": "-9.00000000"
                    },
                    {
                        "id": 57198,
                        "name": "County Leitrim",
                        "latitude": "54.11667000",
                        "longitude": "-8.00000000"
                    },
                    {
                        "id": 57204,
                        "name": "Crossmolina",
                        "latitude": "54.10000000",
                        "longitude": "-9.31667000"
                    },
                    {
                        "id": 57253,
                        "name": "Foxford",
                        "latitude": "53.98070000",
                        "longitude": "-9.11551000"
                    },
                    {
                        "id": 57255,
                        "name": "Gaillimh",
                        "latitude": "53.27194000",
                        "longitude": "-9.04889000"
                    },
                    {
                        "id": 57256,
                        "name": "Galway City",
                        "latitude": "53.28770000",
                        "longitude": "-9.05004000"
                    },
                    {
                        "id": 57259,
                        "name": "Gort",
                        "latitude": "53.06639000",
                        "longitude": "-8.81667000"
                    },
                    {
                        "id": 57267,
                        "name": "Inishcrone",
                        "latitude": "54.21591000",
                        "longitude": "-9.09197000"
                    },
                    {
                        "id": 57291,
                        "name": "Kiltamagh",
                        "latitude": "53.85000000",
                        "longitude": "-9.00000000"
                    },
                    {
                        "id": 57293,
                        "name": "Kinlough",
                        "latitude": "54.45000000",
                        "longitude": "-8.28333000"
                    },
                    {
                        "id": 57310,
                        "name": "Loughrea",
                        "latitude": "53.19694000",
                        "longitude": "-8.56694000"
                    },
                    {
                        "id": 57318,
                        "name": "Manorhamilton",
                        "latitude": "54.30639000",
                        "longitude": "-8.17611000"
                    },
                    {
                        "id": 57321,
                        "name": "Mayo County",
                        "latitude": "53.90000000",
                        "longitude": "-9.25000000"
                    },
                    {
                        "id": 57337,
                        "name": "Moycullen",
                        "latitude": "53.33783000",
                        "longitude": "-9.18002000"
                    },
                    {
                        "id": 57356,
                        "name": "Oranmore",
                        "latitude": "53.26833000",
                        "longitude": "-8.92000000"
                    },
                    {
                        "id": 57357,
                        "name": "Oughterard",
                        "latitude": "53.41667000",
                        "longitude": "-9.33333000"
                    },
                    {
                        "id": 57366,
                        "name": "Portumna",
                        "latitude": "53.08917000",
                        "longitude": "-8.21889000"
                    },
                    {
                        "id": 57385,
                        "name": "Roscommon",
                        "latitude": "53.75000000",
                        "longitude": "-8.25000000"
                    },
                    {
                        "id": 57400,
                        "name": "Sligo",
                        "latitude": "54.25000000",
                        "longitude": "-8.66667000"
                    },
                    {
                        "id": 57404,
                        "name": "Strandhill",
                        "latitude": "54.27194000",
                        "longitude": "-8.59333000"
                    },
                    {
                        "id": 57406,
                        "name": "Swinford",
                        "latitude": "53.95000000",
                        "longitude": "-8.95000000"
                    },
                    {
                        "id": 57416,
                        "name": "Tobercurry",
                        "latitude": "54.05000000",
                        "longitude": "-8.73333000"
                    },
                    {
                        "id": 57421,
                        "name": "Tuam",
                        "latitude": "53.51667000",
                        "longitude": "-8.85000000"
                    },
                    {
                        "id": 57430,
                        "name": "Westport",
                        "latitude": "53.80000000",
                        "longitude": "-9.51667000"
                    }
                ]
            },
            {
                "id": 1074,
                "name": "Cork",
                "iso2": "CO",
                "latitude": "51.89851430",
                "longitude": "-8.47560350",
                "type": "county",
                "cities": []
            },
            {
                "id": 1071,
                "name": "Donegal",
                "iso2": "DL",
                "latitude": "54.65489930",
                "longitude": "-8.10409670",
                "type": "county",
                "cities": []
            },
            {
                "id": 1072,
                "name": "Dublin",
                "iso2": "D",
                "latitude": "53.34980530",
                "longitude": "-6.26030970",
                "type": "county",
                "cities": []
            },
            {
                "id": 1079,
                "name": "Galway",
                "iso2": "G",
                "latitude": "53.35645090",
                "longitude": "-8.85341130",
                "type": "county",
                "cities": []
            },
            {
                "id": 1077,
                "name": "Kerry",
                "iso2": "KY",
                "latitude": "52.15446070",
                "longitude": "-9.56686330",
                "type": "county",
                "cities": []
            },
            {
                "id": 1082,
                "name": "Kildare",
                "iso2": "KE",
                "latitude": "53.21204340",
                "longitude": "-6.81947080",
                "type": "county",
                "cities": []
            },
            {
                "id": 1090,
                "name": "Kilkenny",
                "iso2": "KK",
                "latitude": "52.57769570",
                "longitude": "-7.21800200",
                "type": "county",
                "cities": []
            },
            {
                "id": 1096,
                "name": "Laois",
                "iso2": "LS",
                "latitude": "52.99429500",
                "longitude": "-7.33230070",
                "type": "county",
                "cities": []
            },
            {
                "id": 1073,
                "name": "Leinster",
                "iso2": "L",
                "latitude": "53.32715380",
                "longitude": "-7.51408410",
                "type": "province",
                "cities": [
                    {
                        "id": 57063,
                        "name": "Abbeyleix",
                        "latitude": "52.91331000",
                        "longitude": "-7.34456000"
                    },
                    {
                        "id": 57068,
                        "name": "An Iarmhí",
                        "latitude": "53.50000000",
                        "longitude": "-7.50000000"
                    },
                    {
                        "id": 57069,
                        "name": "An Longfort",
                        "latitude": "53.66667000",
                        "longitude": "-7.75000000"
                    },
                    {
                        "id": 57070,
                        "name": "An Mhí",
                        "latitude": "53.66667000",
                        "longitude": "-6.66667000"
                    },
                    {
                        "id": 57071,
                        "name": "An Muileann gCearr",
                        "latitude": "53.53333000",
                        "longitude": "-7.35000000"
                    },
                    {
                        "id": 57072,
                        "name": "An Ros",
                        "latitude": "53.52424000",
                        "longitude": "-6.10497000"
                    },
                    {
                        "id": 57074,
                        "name": "Ardee",
                        "latitude": "53.85972000",
                        "longitude": "-6.54056000"
                    },
                    {
                        "id": 57076,
                        "name": "Arklow",
                        "latitude": "52.79306000",
                        "longitude": "-6.14139000"
                    },
                    {
                        "id": 57077,
                        "name": "Artane",
                        "latitude": "53.38712000",
                        "longitude": "-6.21380000"
                    },
                    {
                        "id": 57078,
                        "name": "Ashbourne",
                        "latitude": "53.51163000",
                        "longitude": "-6.39821000"
                    },
                    {
                        "id": 57079,
                        "name": "Ashford",
                        "latitude": "53.00833000",
                        "longitude": "-6.11139000"
                    },
                    {
                        "id": 57081,
                        "name": "Athboy",
                        "latitude": "53.62327000",
                        "longitude": "-6.91434000"
                    },
                    {
                        "id": 57083,
                        "name": "Athgarvan",
                        "latitude": "53.15229000",
                        "longitude": "-6.78173000"
                    },
                    {
                        "id": 57084,
                        "name": "Athlone",
                        "latitude": "53.43333000",
                        "longitude": "-7.95000000"
                    },
                    {
                        "id": 57085,
                        "name": "Athy",
                        "latitude": "52.99139000",
                        "longitude": "-6.98028000"
                    },
                    {
                        "id": 57086,
                        "name": "Aughrim",
                        "latitude": "52.85333000",
                        "longitude": "-6.32750000"
                    },
                    {
                        "id": 57087,
                        "name": "Bagenalstown",
                        "latitude": "52.70031000",
                        "longitude": "-6.96181000"
                    },
                    {
                        "id": 57089,
                        "name": "Balally",
                        "latitude": "53.27504000",
                        "longitude": "-6.23594000"
                    },
                    {
                        "id": 57090,
                        "name": "Balbriggan",
                        "latitude": "53.60846000",
                        "longitude": "-6.18310000"
                    },
                    {
                        "id": 57091,
                        "name": "Baldoyle",
                        "latitude": "53.39972000",
                        "longitude": "-6.12583000"
                    },
                    {
                        "id": 57096,
                        "name": "Ballinroad",
                        "latitude": "52.51789000",
                        "longitude": "-6.40619000"
                    },
                    {
                        "id": 57098,
                        "name": "Ballinteer",
                        "latitude": "53.27409000",
                        "longitude": "-6.25397000"
                    },
                    {
                        "id": 57100,
                        "name": "Ballivor",
                        "latitude": "53.53167000",
                        "longitude": "-6.96111000"
                    },
                    {
                        "id": 57101,
                        "name": "Ballyboden",
                        "latitude": "53.28056000",
                        "longitude": "-6.31639000"
                    },
                    {
                        "id": 57105,
                        "name": "Ballyfermot",
                        "latitude": "53.34283000",
                        "longitude": "-6.35480000"
                    },
                    {
                        "id": 57106,
                        "name": "Ballygerry",
                        "latitude": "52.24917000",
                        "longitude": "-6.35739000"
                    },
                    {
                        "id": 57109,
                        "name": "Ballylinan",
                        "latitude": "52.94497000",
                        "longitude": "-7.04073000"
                    },
                    {
                        "id": 57110,
                        "name": "Ballymahon",
                        "latitude": "53.56667000",
                        "longitude": "-7.76667000"
                    },
                    {
                        "id": 57112,
                        "name": "Ballymun",
                        "latitude": "53.39807000",
                        "longitude": "-6.26693000"
                    },
                    {
                        "id": 57113,
                        "name": "Ballyragget",
                        "latitude": "52.78889000",
                        "longitude": "-7.33028000"
                    },
                    {
                        "id": 57115,
                        "name": "Balrothery",
                        "latitude": "53.58828000",
                        "longitude": "-6.18728000"
                    },
                    {
                        "id": 57116,
                        "name": "Baltinglass",
                        "latitude": "52.93722000",
                        "longitude": "-6.70917000"
                    },
                    {
                        "id": 57117,
                        "name": "Banagher",
                        "latitude": "53.18861000",
                        "longitude": "-7.98667000"
                    },
                    {
                        "id": 57120,
                        "name": "Bayside",
                        "latitude": "53.38895000",
                        "longitude": "-6.14041000"
                    },
                    {
                        "id": 57122,
                        "name": "Beaumont",
                        "latitude": "53.38721000",
                        "longitude": "-6.22713000"
                    },
                    {
                        "id": 57125,
                        "name": "Birr",
                        "latitude": "53.09139000",
                        "longitude": "-7.91333000"
                    },
                    {
                        "id": 57126,
                        "name": "Blackrock",
                        "latitude": "53.30150000",
                        "longitude": "-6.17780000"
                    },
                    {
                        "id": 57127,
                        "name": "Blanchardstown",
                        "latitude": "53.38806000",
                        "longitude": "-6.37556000"
                    },
                    {
                        "id": 57129,
                        "name": "Blessington",
                        "latitude": "53.17000000",
                        "longitude": "-6.53250000"
                    },
                    {
                        "id": 57130,
                        "name": "Bonnybrook",
                        "latitude": "53.39835000",
                        "longitude": "-6.20749000"
                    },
                    {
                        "id": 57131,
                        "name": "Booterstown",
                        "latitude": "53.30447000",
                        "longitude": "-6.19985000"
                    },
                    {
                        "id": 57133,
                        "name": "Bray",
                        "latitude": "53.20278000",
                        "longitude": "-6.09833000"
                    },
                    {
                        "id": 57134,
                        "name": "Bunclody",
                        "latitude": "52.65530000",
                        "longitude": "-6.65359000"
                    },
                    {
                        "id": 57137,
                        "name": "Cabinteely",
                        "latitude": "53.26973000",
                        "longitude": "-6.16058000"
                    },
                    {
                        "id": 57138,
                        "name": "Cabra",
                        "latitude": "53.36694000",
                        "longitude": "-6.29444000"
                    },
                    {
                        "id": 57142,
                        "name": "Callan",
                        "latitude": "52.54500000",
                        "longitude": "-7.39111000"
                    },
                    {
                        "id": 57143,
                        "name": "Carlingford",
                        "latitude": "54.04000000",
                        "longitude": "-6.18833000"
                    },
                    {
                        "id": 57144,
                        "name": "Carlow",
                        "latitude": "52.84083000",
                        "longitude": "-6.92611000"
                    },
                    {
                        "id": 57146,
                        "name": "Carnew",
                        "latitude": "52.70806000",
                        "longitude": "-6.49444000"
                    },
                    {
                        "id": 57154,
                        "name": "Castlebellingham",
                        "latitude": "53.90083000",
                        "longitude": "-6.39028000"
                    },
                    {
                        "id": 57156,
                        "name": "Castlebridge",
                        "latitude": "52.38639000",
                        "longitude": "-6.44944000"
                    },
                    {
                        "id": 57157,
                        "name": "Castlecomer",
                        "latitude": "52.80611000",
                        "longitude": "-7.21056000"
                    },
                    {
                        "id": 57159,
                        "name": "Castledermot",
                        "latitude": "52.90889000",
                        "longitude": "-6.84222000"
                    },
                    {
                        "id": 57161,
                        "name": "Castleknock",
                        "latitude": "53.37483000",
                        "longitude": "-6.36336000"
                    },
                    {
                        "id": 57163,
                        "name": "Castlepollard",
                        "latitude": "53.67935000",
                        "longitude": "-7.29736000"
                    },
                    {
                        "id": 57165,
                        "name": "Castletown",
                        "latitude": "52.72306000",
                        "longitude": "-6.18944000"
                    },
                    {
                        "id": 57167,
                        "name": "Celbridge",
                        "latitude": "53.34165000",
                        "longitude": "-6.54419000"
                    },
                    {
                        "id": 57168,
                        "name": "Chapelizod",
                        "latitude": "53.34846000",
                        "longitude": "-6.34301000"
                    },
                    {
                        "id": 57169,
                        "name": "Charlesland",
                        "latitude": "53.12771000",
                        "longitude": "-6.06347000"
                    },
                    {
                        "id": 57170,
                        "name": "Cherry Orchard",
                        "latitude": "53.33605000",
                        "longitude": "-6.37799000"
                    },
                    {
                        "id": 57171,
                        "name": "Cherryville",
                        "latitude": "53.15694000",
                        "longitude": "-6.96667000"
                    },
                    {
                        "id": 57174,
                        "name": "Clane",
                        "latitude": "53.29139000",
                        "longitude": "-6.68917000"
                    },
                    {
                        "id": 57175,
                        "name": "Clara",
                        "latitude": "53.34250000",
                        "longitude": "-7.61389000"
                    },
                    {
                        "id": 57179,
                        "name": "Clogherhead",
                        "latitude": "53.79361000",
                        "longitude": "-6.23750000"
                    },
                    {
                        "id": 57181,
                        "name": "Clondalkin",
                        "latitude": "53.32444000",
                        "longitude": "-6.39722000"
                    },
                    {
                        "id": 57183,
                        "name": "Clonskeagh",
                        "latitude": "53.31467000",
                        "longitude": "-6.23148000"
                    },
                    {
                        "id": 57188,
                        "name": "Confey",
                        "latitude": "53.37923000",
                        "longitude": "-6.49052000"
                    },
                    {
                        "id": 57190,
                        "name": "Coolock",
                        "latitude": "53.38870000",
                        "longitude": "-6.19998000"
                    },
                    {
                        "id": 57194,
                        "name": "County Carlow",
                        "latitude": "52.66667000",
                        "longitude": "-6.83333000"
                    },
                    {
                        "id": 57201,
                        "name": "Courtown",
                        "latitude": "52.64424000",
                        "longitude": "-6.22899000"
                    },
                    {
                        "id": 57205,
                        "name": "Crumlin",
                        "latitude": "53.32154000",
                        "longitude": "-6.31439000"
                    },
                    {
                        "id": 57206,
                        "name": "Daingean",
                        "latitude": "53.29611000",
                        "longitude": "-7.28944000"
                    },
                    {
                        "id": 57207,
                        "name": "Dalkey",
                        "latitude": "53.27833000",
                        "longitude": "-6.10028000"
                    },
                    {
                        "id": 57208,
                        "name": "Darndale",
                        "latitude": "53.39948000",
                        "longitude": "-6.18886000"
                    },
                    {
                        "id": 57209,
                        "name": "Derrinturn",
                        "latitude": "53.34167000",
                        "longitude": "-6.94111000"
                    },
                    {
                        "id": 57213,
                        "name": "Dollymount",
                        "latitude": "53.36489000",
                        "longitude": "-6.18032000"
                    },
                    {
                        "id": 57214,
                        "name": "Donabate",
                        "latitude": "53.48722000",
                        "longitude": "-6.15194000"
                    },
                    {
                        "id": 57215,
                        "name": "Donaghmede",
                        "latitude": "53.39845000",
                        "longitude": "-6.16179000"
                    },
                    {
                        "id": 57217,
                        "name": "Donnybrook",
                        "latitude": "53.31375000",
                        "longitude": "-6.22274000"
                    },
                    {
                        "id": 57218,
                        "name": "Donnycarney",
                        "latitude": "53.37350000",
                        "longitude": "-6.20976000"
                    },
                    {
                        "id": 57219,
                        "name": "Drogheda",
                        "latitude": "53.71889000",
                        "longitude": "-6.34778000"
                    },
                    {
                        "id": 57220,
                        "name": "Droichead Nua",
                        "latitude": "53.18194000",
                        "longitude": "-6.79667000"
                    },
                    {
                        "id": 57221,
                        "name": "Dromiskin",
                        "latitude": "53.92538000",
                        "longitude": "-6.40292000"
                    },
                    {
                        "id": 57222,
                        "name": "Drumcondra",
                        "latitude": "53.37058000",
                        "longitude": "-6.25298000"
                    },
                    {
                        "id": 57223,
                        "name": "Dublin",
                        "latitude": "53.33306000",
                        "longitude": "-6.24889000"
                    },
                    {
                        "id": 57224,
                        "name": "Dublin City",
                        "latitude": "53.35512000",
                        "longitude": "-6.24922000"
                    },
                    {
                        "id": 57225,
                        "name": "Duleek",
                        "latitude": "53.65667000",
                        "longitude": "-6.41917000"
                    },
                    {
                        "id": 57236,
                        "name": "Dún Laoghaire",
                        "latitude": "53.29395000",
                        "longitude": "-6.13586000"
                    },
                    {
                        "id": 57237,
                        "name": "Dún Laoghaire-Rathdown",
                        "latitude": "53.29436000",
                        "longitude": "-6.13489000"
                    },
                    {
                        "id": 57226,
                        "name": "Dunboyne",
                        "latitude": "53.41901000",
                        "longitude": "-6.47375000"
                    },
                    {
                        "id": 57227,
                        "name": "Dundalk",
                        "latitude": "54.00000000",
                        "longitude": "-6.41667000"
                    },
                    {
                        "id": 57228,
                        "name": "Dundrum",
                        "latitude": "53.29067000",
                        "longitude": "-6.25714000"
                    },
                    {
                        "id": 57231,
                        "name": "Dunleer",
                        "latitude": "53.83500000",
                        "longitude": "-6.39611000"
                    },
                    {
                        "id": 57235,
                        "name": "Dunshaughlin",
                        "latitude": "53.51250000",
                        "longitude": "-6.54000000"
                    },
                    {
                        "id": 57238,
                        "name": "Eadestown",
                        "latitude": "53.20278000",
                        "longitude": "-6.57806000"
                    },
                    {
                        "id": 57239,
                        "name": "Edenderry",
                        "latitude": "53.33948000",
                        "longitude": "-7.04752000"
                    },
                    {
                        "id": 57240,
                        "name": "Edgeworthstown",
                        "latitude": "53.70000000",
                        "longitude": "-7.61667000"
                    },
                    {
                        "id": 57241,
                        "name": "Enfield",
                        "latitude": "53.41419000",
                        "longitude": "-6.83229000"
                    },
                    {
                        "id": 57243,
                        "name": "Enniscorthy",
                        "latitude": "52.50083000",
                        "longitude": "-6.55778000"
                    },
                    {
                        "id": 57244,
                        "name": "Enniskerry",
                        "latitude": "53.19250000",
                        "longitude": "-6.16917000"
                    },
                    {
                        "id": 57245,
                        "name": "Fairview",
                        "latitude": "53.36597000",
                        "longitude": "-6.23985000"
                    },
                    {
                        "id": 57246,
                        "name": "Ferbane",
                        "latitude": "53.26944000",
                        "longitude": "-7.82694000"
                    },
                    {
                        "id": 57248,
                        "name": "Ferns",
                        "latitude": "52.58833000",
                        "longitude": "-6.49972000"
                    },
                    {
                        "id": 57250,
                        "name": "Fingal County",
                        "latitude": "53.45909000",
                        "longitude": "-6.21942000"
                    },
                    {
                        "id": 57251,
                        "name": "Finglas",
                        "latitude": "53.38917000",
                        "longitude": "-6.29694000"
                    },
                    {
                        "id": 57252,
                        "name": "Firhouse",
                        "latitude": "53.28167000",
                        "longitude": "-6.33917000"
                    },
                    {
                        "id": 57254,
                        "name": "Foxrock",
                        "latitude": "53.26667000",
                        "longitude": "-6.17417000"
                    },
                    {
                        "id": 57257,
                        "name": "Glasnevin",
                        "latitude": "53.37851000",
                        "longitude": "-6.28028000"
                    },
                    {
                        "id": 57258,
                        "name": "Gorey",
                        "latitude": "52.67472000",
                        "longitude": "-6.29250000"
                    },
                    {
                        "id": 57260,
                        "name": "Graiguenamanagh",
                        "latitude": "52.54028000",
                        "longitude": "-6.95472000"
                    },
                    {
                        "id": 57261,
                        "name": "Granard",
                        "latitude": "53.77928000",
                        "longitude": "-7.49429000"
                    },
                    {
                        "id": 57262,
                        "name": "Greenhills",
                        "latitude": "53.33467000",
                        "longitude": "-6.30302000"
                    },
                    {
                        "id": 57263,
                        "name": "Greystones",
                        "latitude": "53.14083000",
                        "longitude": "-6.06306000"
                    },
                    {
                        "id": 57265,
                        "name": "Hartstown",
                        "latitude": "53.39306000",
                        "longitude": "-6.42694000"
                    },
                    {
                        "id": 57266,
                        "name": "Howth",
                        "latitude": "53.38778000",
                        "longitude": "-6.06528000"
                    },
                    {
                        "id": 57268,
                        "name": "Jobstown",
                        "latitude": "53.27866000",
                        "longitude": "-6.40803000"
                    },
                    {
                        "id": 57269,
                        "name": "Johnstown",
                        "latitude": "53.23833000",
                        "longitude": "-6.62222000"
                    },
                    {
                        "id": 57271,
                        "name": "Kells",
                        "latitude": "53.72639000",
                        "longitude": "-6.87917000"
                    },
                    {
                        "id": 57273,
                        "name": "Kentstown",
                        "latitude": "53.62754000",
                        "longitude": "-6.52674000"
                    },
                    {
                        "id": 57274,
                        "name": "Kilbeggan",
                        "latitude": "53.36944000",
                        "longitude": "-7.50333000"
                    },
                    {
                        "id": 57275,
                        "name": "Kilcock",
                        "latitude": "53.40222000",
                        "longitude": "-6.67083000"
                    },
                    {
                        "id": 57276,
                        "name": "Kilcoole",
                        "latitude": "53.10278000",
                        "longitude": "-6.06500000"
                    },
                    {
                        "id": 57277,
                        "name": "Kilcullen",
                        "latitude": "53.13028000",
                        "longitude": "-6.74444000"
                    },
                    {
                        "id": 57278,
                        "name": "Kildare",
                        "latitude": "53.16667000",
                        "longitude": "-6.75000000"
                    },
                    {
                        "id": 57279,
                        "name": "Kilkenny",
                        "latitude": "52.58333000",
                        "longitude": "-7.25000000"
                    },
                    {
                        "id": 57280,
                        "name": "Kill",
                        "latitude": "53.25139000",
                        "longitude": "-6.59167000"
                    },
                    {
                        "id": 57282,
                        "name": "Killester",
                        "latitude": "53.37322000",
                        "longitude": "-6.20431000"
                    },
                    {
                        "id": 57286,
                        "name": "Kilmacanoge",
                        "latitude": "53.16722000",
                        "longitude": "-6.13361000"
                    },
                    {
                        "id": 57288,
                        "name": "Kilpedder",
                        "latitude": "53.10917000",
                        "longitude": "-6.10667000"
                    },
                    {
                        "id": 57289,
                        "name": "Kilquade",
                        "latitude": "53.09743000",
                        "longitude": "-6.08411000"
                    },
                    {
                        "id": 57294,
                        "name": "Kinnegad",
                        "latitude": "53.45222000",
                        "longitude": "-7.09972000"
                    },
                    {
                        "id": 57296,
                        "name": "Kinsealy-Drinan",
                        "latitude": "53.44395000",
                        "longitude": "-6.20334000"
                    },
                    {
                        "id": 57297,
                        "name": "Knocklyon",
                        "latitude": "53.28030000",
                        "longitude": "-6.33130000"
                    },
                    {
                        "id": 57298,
                        "name": "Lanesborough",
                        "latitude": "53.66667000",
                        "longitude": "-7.98333000"
                    },
                    {
                        "id": 57299,
                        "name": "Laois",
                        "latitude": "53.00000000",
                        "longitude": "-7.40000000"
                    },
                    {
                        "id": 57300,
                        "name": "Laytown",
                        "latitude": "53.68194000",
                        "longitude": "-6.23917000"
                    },
                    {
                        "id": 57302,
                        "name": "Leixlip",
                        "latitude": "53.36583000",
                        "longitude": "-6.49556000"
                    },
                    {
                        "id": 57305,
                        "name": "Little Bray",
                        "latitude": "53.20444000",
                        "longitude": "-6.12083000"
                    },
                    {
                        "id": 57306,
                        "name": "Loch Garman",
                        "latitude": "52.50000000",
                        "longitude": "-6.66667000"
                    },
                    {
                        "id": 57307,
                        "name": "Longford",
                        "latitude": "53.72536000",
                        "longitude": "-7.79823000"
                    },
                    {
                        "id": 57308,
                        "name": "Longwood",
                        "latitude": "53.45389000",
                        "longitude": "-6.92194000"
                    },
                    {
                        "id": 57309,
                        "name": "Loughlinstown",
                        "latitude": "53.24389000",
                        "longitude": "-6.13306000"
                    },
                    {
                        "id": 57314,
                        "name": "Lú",
                        "latitude": "53.83333000",
                        "longitude": "-6.50000000"
                    },
                    {
                        "id": 57311,
                        "name": "Lucan",
                        "latitude": "53.35736000",
                        "longitude": "-6.44859000"
                    },
                    {
                        "id": 57313,
                        "name": "Lusk",
                        "latitude": "53.52743000",
                        "longitude": "-6.16423000"
                    },
                    {
                        "id": 57316,
                        "name": "Malahide",
                        "latitude": "53.45083000",
                        "longitude": "-6.15444000"
                    },
                    {
                        "id": 57319,
                        "name": "Marino",
                        "latitude": "53.37022000",
                        "longitude": "-6.23646000"
                    },
                    {
                        "id": 57320,
                        "name": "Maynooth",
                        "latitude": "53.38500000",
                        "longitude": "-6.59361000"
                    },
                    {
                        "id": 57324,
                        "name": "Milltown",
                        "latitude": "53.31301000",
                        "longitude": "-6.24530000"
                    },
                    {
                        "id": 57326,
                        "name": "Moate",
                        "latitude": "53.39389000",
                        "longitude": "-7.71722000"
                    },
                    {
                        "id": 57328,
                        "name": "Monasterevin",
                        "latitude": "53.14056000",
                        "longitude": "-7.06639000"
                    },
                    {
                        "id": 57329,
                        "name": "Monkstown",
                        "latitude": "53.29308000",
                        "longitude": "-6.15312000"
                    },
                    {
                        "id": 57330,
                        "name": "Mooncoin",
                        "latitude": "52.28944000",
                        "longitude": "-7.24833000"
                    },
                    {
                        "id": 57331,
                        "name": "Moone",
                        "latitude": "52.97556000",
                        "longitude": "-6.81500000"
                    },
                    {
                        "id": 57333,
                        "name": "Mount Merrion",
                        "latitude": "53.30008000",
                        "longitude": "-6.21504000"
                    },
                    {
                        "id": 57334,
                        "name": "Mountmellick",
                        "latitude": "53.11361000",
                        "longitude": "-7.32000000"
                    },
                    {
                        "id": 57335,
                        "name": "Mountrath",
                        "latitude": "52.99889000",
                        "longitude": "-7.47278000"
                    },
                    {
                        "id": 57341,
                        "name": "Naas",
                        "latitude": "53.21583000",
                        "longitude": "-6.66694000"
                    },
                    {
                        "id": 57342,
                        "name": "Navan",
                        "latitude": "53.65278000",
                        "longitude": "-6.68139000"
                    },
                    {
                        "id": 57345,
                        "name": "New Ross",
                        "latitude": "52.39667000",
                        "longitude": "-6.93667000"
                    },
                    {
                        "id": 57346,
                        "name": "Newcastle",
                        "latitude": "53.30111000",
                        "longitude": "-6.50222000"
                    },
                    {
                        "id": 57351,
                        "name": "Newtown Trim",
                        "latitude": "53.55611000",
                        "longitude": "-6.77000000"
                    },
                    {
                        "id": 57352,
                        "name": "Newtownmountkennedy",
                        "latitude": "53.09052000",
                        "longitude": "-6.11149000"
                    },
                    {
                        "id": 57353,
                        "name": "Old Kilcullen",
                        "latitude": "53.10639000",
                        "longitude": "-6.76528000"
                    },
                    {
                        "id": 57354,
                        "name": "Oldbawn",
                        "latitude": "53.27556000",
                        "longitude": "-6.36750000"
                    },
                    {
                        "id": 57355,
                        "name": "Oldcastle",
                        "latitude": "53.76648000",
                        "longitude": "-7.16284000"
                    },
                    {
                        "id": 57358,
                        "name": "Palmerstown",
                        "latitude": "53.35019000",
                        "longitude": "-6.37778000"
                    },
                    {
                        "id": 57360,
                        "name": "Piltown",
                        "latitude": "52.35333000",
                        "longitude": "-7.34028000"
                    },
                    {
                        "id": 57361,
                        "name": "Portarlington",
                        "latitude": "53.16222000",
                        "longitude": "-7.19111000"
                    },
                    {
                        "id": 57362,
                        "name": "Portlaoise",
                        "latitude": "53.03441000",
                        "longitude": "-7.29979000"
                    },
                    {
                        "id": 57364,
                        "name": "Portmarnock",
                        "latitude": "53.42306000",
                        "longitude": "-6.13750000"
                    },
                    {
                        "id": 57365,
                        "name": "Portraine",
                        "latitude": "53.49667000",
                        "longitude": "-6.11111000"
                    },
                    {
                        "id": 57367,
                        "name": "Prosperous",
                        "latitude": "53.29028000",
                        "longitude": "-6.75389000"
                    },
                    {
                        "id": 57368,
                        "name": "Raheny",
                        "latitude": "53.38681000",
                        "longitude": "-6.18067000"
                    },
                    {
                        "id": 57371,
                        "name": "Rathangan",
                        "latitude": "53.22139000",
                        "longitude": "-6.99500000"
                    },
                    {
                        "id": 57372,
                        "name": "Rathcoole",
                        "latitude": "53.28278000",
                        "longitude": "-6.47278000"
                    },
                    {
                        "id": 57374,
                        "name": "Rathdowney",
                        "latitude": "52.85472000",
                        "longitude": "-7.58028000"
                    },
                    {
                        "id": 57375,
                        "name": "Rathdrum",
                        "latitude": "52.92639000",
                        "longitude": "-6.23556000"
                    },
                    {
                        "id": 57376,
                        "name": "Rathgar",
                        "latitude": "53.31457000",
                        "longitude": "-6.27500000"
                    },
                    {
                        "id": 57378,
                        "name": "Rathmines",
                        "latitude": "53.32028000",
                        "longitude": "-6.26333000"
                    },
                    {
                        "id": 57379,
                        "name": "Rathnew",
                        "latitude": "52.99056000",
                        "longitude": "-6.08528000"
                    },
                    {
                        "id": 57380,
                        "name": "Rathwire",
                        "latitude": "53.50767000",
                        "longitude": "-7.13510000"
                    },
                    {
                        "id": 57381,
                        "name": "Ratoath",
                        "latitude": "53.50806000",
                        "longitude": "-6.46250000"
                    },
                    {
                        "id": 57382,
                        "name": "Rialto",
                        "latitude": "53.33625000",
                        "longitude": "-6.29718000"
                    },
                    {
                        "id": 57383,
                        "name": "Ringsend",
                        "latitude": "53.34194000",
                        "longitude": "-6.22639000"
                    },
                    {
                        "id": 57384,
                        "name": "Rochfortbridge",
                        "latitude": "53.41417000",
                        "longitude": "-7.29611000"
                    },
                    {
                        "id": 57387,
                        "name": "Rosslare",
                        "latitude": "52.27583000",
                        "longitude": "-6.38444000"
                    },
                    {
                        "id": 57389,
                        "name": "Saggart",
                        "latitude": "53.28028000",
                        "longitude": "-6.44444000"
                    },
                    {
                        "id": 57390,
                        "name": "Sallins",
                        "latitude": "53.24889000",
                        "longitude": "-6.66611000"
                    },
                    {
                        "id": 57391,
                        "name": "Sallynoggin",
                        "latitude": "53.27917000",
                        "longitude": "-6.14058000"
                    },
                    {
                        "id": 57392,
                        "name": "Sandyford",
                        "latitude": "53.27470000",
                        "longitude": "-6.22530000"
                    },
                    {
                        "id": 57393,
                        "name": "Sandymount",
                        "latitude": "53.32815000",
                        "longitude": "-6.22224000"
                    },
                    {
                        "id": 57394,
                        "name": "Shankill",
                        "latitude": "53.22611000",
                        "longitude": "-6.12444000"
                    },
                    {
                        "id": 57397,
                        "name": "Skerries",
                        "latitude": "53.58278000",
                        "longitude": "-6.10833000"
                    },
                    {
                        "id": 57399,
                        "name": "Slane",
                        "latitude": "53.71000000",
                        "longitude": "-6.54333000"
                    },
                    {
                        "id": 57401,
                        "name": "South Dublin",
                        "latitude": "53.28595000",
                        "longitude": "-6.37739000"
                    },
                    {
                        "id": 57402,
                        "name": "Stamullin",
                        "latitude": "53.62889000",
                        "longitude": "-6.26833000"
                    },
                    {
                        "id": 57403,
                        "name": "Stradbally",
                        "latitude": "53.01556000",
                        "longitude": "-7.15278000"
                    },
                    {
                        "id": 57405,
                        "name": "Sutton",
                        "latitude": "53.38947000",
                        "longitude": "-6.11059000"
                    },
                    {
                        "id": 57407,
                        "name": "Swords",
                        "latitude": "53.45972000",
                        "longitude": "-6.21806000"
                    },
                    {
                        "id": 57408,
                        "name": "Tallaght",
                        "latitude": "53.28590000",
                        "longitude": "-6.37344000"
                    },
                    {
                        "id": 57410,
                        "name": "Templeogue",
                        "latitude": "53.29528000",
                        "longitude": "-6.30889000"
                    },
                    {
                        "id": 57411,
                        "name": "Terenure",
                        "latitude": "53.30972000",
                        "longitude": "-6.28528000"
                    },
                    {
                        "id": 57412,
                        "name": "Termonfeckin",
                        "latitude": "53.76333000",
                        "longitude": "-6.26778000"
                    },
                    {
                        "id": 57413,
                        "name": "Thomastown",
                        "latitude": "52.52667000",
                        "longitude": "-7.13722000"
                    },
                    {
                        "id": 57419,
                        "name": "Trim",
                        "latitude": "53.55500000",
                        "longitude": "-6.79167000"
                    },
                    {
                        "id": 57422,
                        "name": "Tullamore",
                        "latitude": "53.27389000",
                        "longitude": "-7.48889000"
                    },
                    {
                        "id": 57423,
                        "name": "Tullow",
                        "latitude": "52.80028000",
                        "longitude": "-6.73694000"
                    },
                    {
                        "id": 57424,
                        "name": "Tullyallen",
                        "latitude": "53.73611000",
                        "longitude": "-6.42278000"
                    },
                    {
                        "id": 57425,
                        "name": "Uíbh Fhailí",
                        "latitude": "53.25000000",
                        "longitude": "-7.50000000"
                    },
                    {
                        "id": 57426,
                        "name": "Valleymount",
                        "latitude": "53.10389000",
                        "longitude": "-6.55361000"
                    },
                    {
                        "id": 57432,
                        "name": "Wicklow",
                        "latitude": "53.00000000",
                        "longitude": "-6.41667000"
                    }
                ]
            },
            {
                "id": 5345,
                "name": "Leitrim",
                "iso2": "LM",
                "latitude": "54.13916300",
                "longitude": "-8.66661110",
                "type": "county",
                "cities": []
            },
            {
                "id": 1094,
                "name": "Limerick",
                "iso2": "LK",
                "latitude": "52.50905170",
                "longitude": "-8.74749550",
                "type": "county",
                "cities": []
            },
            {
                "id": 1076,
                "name": "Longford",
                "iso2": "LD",
                "latitude": "53.72749820",
                "longitude": "-7.79315270",
                "type": "county",
                "cities": []
            },
            {
                "id": 1083,
                "name": "Louth",
                "iso2": "LH",
                "latitude": "53.92523240",
                "longitude": "-6.48894230",
                "type": "county",
                "cities": []
            },
            {
                "id": 1084,
                "name": "Mayo",
                "iso2": "MO",
                "latitude": "54.01526040",
                "longitude": "-9.42893690",
                "type": "county",
                "cities": []
            },
            {
                "id": 1092,
                "name": "Meath",
                "iso2": "MH",
                "latitude": "53.60554800",
                "longitude": "-6.65641690",
                "type": "county",
                "cities": []
            },
            {
                "id": 1075,
                "name": "Monaghan",
                "iso2": "MN",
                "latitude": "54.24920460",
                "longitude": "-6.96831320",
                "type": "county",
                "cities": []
            },
            {
                "id": 1080,
                "name": "Munster",
                "iso2": "M",
                "latitude": "51.94711970",
                "longitude": "7.58453200",
                "type": "province",
                "cities": [
                    {
                        "id": 57062,
                        "name": "Abbeyfeale",
                        "latitude": "52.38139000",
                        "longitude": "-9.30250000"
                    },
                    {
                        "id": 57064,
                        "name": "Adare",
                        "latitude": "52.56194000",
                        "longitude": "-8.79556000"
                    },
                    {
                        "id": 57065,
                        "name": "Aghada",
                        "latitude": "51.83917000",
                        "longitude": "-8.21222000"
                    },
                    {
                        "id": 57067,
                        "name": "An Clár",
                        "latitude": "52.83333000",
                        "longitude": "-9.00000000"
                    },
                    {
                        "id": 57073,
                        "name": "Annacotty",
                        "latitude": "52.66768000",
                        "longitude": "-8.53121000"
                    },
                    {
                        "id": 57075,
                        "name": "Ardnacrusha",
                        "latitude": "52.70908000",
                        "longitude": "-8.61431000"
                    },
                    {
                        "id": 57080,
                        "name": "Askeaton",
                        "latitude": "52.59972000",
                        "longitude": "-8.97556000"
                    },
                    {
                        "id": 57094,
                        "name": "Ballina",
                        "latitude": "52.80778000",
                        "longitude": "-8.43556000"
                    },
                    {
                        "id": 57103,
                        "name": "Ballybunnion",
                        "latitude": "52.51108000",
                        "longitude": "-9.67097000"
                    },
                    {
                        "id": 57118,
                        "name": "Bandon",
                        "latitude": "51.74694000",
                        "longitude": "-8.74250000"
                    },
                    {
                        "id": 57119,
                        "name": "Bantry",
                        "latitude": "51.68333000",
                        "longitude": "-9.45000000"
                    },
                    {
                        "id": 57128,
                        "name": "Blarney",
                        "latitude": "51.93333000",
                        "longitude": "-8.56667000"
                    },
                    {
                        "id": 57139,
                        "name": "Caherconlish",
                        "latitude": "52.59361000",
                        "longitude": "-8.47028000"
                    },
                    {
                        "id": 57140,
                        "name": "Cahersiveen",
                        "latitude": "51.94861000",
                        "longitude": "-10.22222000"
                    },
                    {
                        "id": 57141,
                        "name": "Cahir",
                        "latitude": "52.37694000",
                        "longitude": "-7.92167000"
                    },
                    {
                        "id": 57148,
                        "name": "Carrick-on-Suir",
                        "latitude": "52.34917000",
                        "longitude": "-7.41306000"
                    },
                    {
                        "id": 57150,
                        "name": "Carrigaline",
                        "latitude": "51.81167000",
                        "longitude": "-8.39861000"
                    },
                    {
                        "id": 57151,
                        "name": "Carrigtwohill",
                        "latitude": "51.90833000",
                        "longitude": "-8.26333000"
                    },
                    {
                        "id": 57152,
                        "name": "Cashel",
                        "latitude": "52.51583000",
                        "longitude": "-7.88556000"
                    },
                    {
                        "id": 57158,
                        "name": "Castleconnell",
                        "latitude": "52.71389000",
                        "longitude": "-8.49944000"
                    },
                    {
                        "id": 57160,
                        "name": "Castleisland",
                        "latitude": "52.23333000",
                        "longitude": "-9.46667000"
                    },
                    {
                        "id": 57162,
                        "name": "Castlemartyr",
                        "latitude": "51.91028000",
                        "longitude": "-8.05389000"
                    },
                    {
                        "id": 57172,
                        "name": "Ciarraí",
                        "latitude": "52.16667000",
                        "longitude": "-9.75000000"
                    },
                    {
                        "id": 57173,
                        "name": "Cill Airne",
                        "latitude": "52.05980000",
                        "longitude": "-9.50858000"
                    },
                    {
                        "id": 57180,
                        "name": "Clonakilty",
                        "latitude": "51.62306000",
                        "longitude": "-8.87056000"
                    },
                    {
                        "id": 57184,
                        "name": "Cloyne",
                        "latitude": "51.86278000",
                        "longitude": "-8.12444000"
                    },
                    {
                        "id": 57185,
                        "name": "Cluain Meala",
                        "latitude": "52.35500000",
                        "longitude": "-7.70389000"
                    },
                    {
                        "id": 57186,
                        "name": "Cobh",
                        "latitude": "51.85046000",
                        "longitude": "-8.29480000"
                    },
                    {
                        "id": 57192,
                        "name": "Cork",
                        "latitude": "51.89797000",
                        "longitude": "-8.47061000"
                    },
                    {
                        "id": 57193,
                        "name": "Cork City",
                        "latitude": "51.89755000",
                        "longitude": "-8.46773000"
                    },
                    {
                        "id": 57195,
                        "name": "County Cork",
                        "latitude": "51.96667000",
                        "longitude": "-8.58333000"
                    },
                    {
                        "id": 57200,
                        "name": "County Tipperary",
                        "latitude": "52.66667000",
                        "longitude": "-7.83333000"
                    },
                    {
                        "id": 57202,
                        "name": "Croom",
                        "latitude": "52.51944000",
                        "longitude": "-8.71778000"
                    },
                    {
                        "id": 57203,
                        "name": "Crosshaven",
                        "latitude": "51.79833000",
                        "longitude": "-8.30083000"
                    },
                    {
                        "id": 57210,
                        "name": "Derry",
                        "latitude": "51.58666000",
                        "longitude": "-9.05026000"
                    },
                    {
                        "id": 57212,
                        "name": "Dingle",
                        "latitude": "52.14083000",
                        "longitude": "-10.26889000"
                    },
                    {
                        "id": 57229,
                        "name": "Dungarvan",
                        "latitude": "52.08806000",
                        "longitude": "-7.62528000"
                    },
                    {
                        "id": 57233,
                        "name": "Dunmanway",
                        "latitude": "51.71667000",
                        "longitude": "-9.11667000"
                    },
                    {
                        "id": 57234,
                        "name": "Dunmore East",
                        "latitude": "52.15108000",
                        "longitude": "-6.99872000"
                    },
                    {
                        "id": 57242,
                        "name": "Ennis",
                        "latitude": "52.84361000",
                        "longitude": "-8.98639000"
                    },
                    {
                        "id": 57247,
                        "name": "Fermoy",
                        "latitude": "52.13583000",
                        "longitude": "-8.27583000"
                    },
                    {
                        "id": 57249,
                        "name": "Fethard",
                        "latitude": "52.46722000",
                        "longitude": "-7.69111000"
                    },
                    {
                        "id": 57270,
                        "name": "Kanturk",
                        "latitude": "52.16667000",
                        "longitude": "-8.90000000"
                    },
                    {
                        "id": 57272,
                        "name": "Kenmare",
                        "latitude": "51.88333000",
                        "longitude": "-9.58333000"
                    },
                    {
                        "id": 57281,
                        "name": "Killaloe",
                        "latitude": "52.80667000",
                        "longitude": "-8.44361000"
                    },
                    {
                        "id": 57283,
                        "name": "Killorglin",
                        "latitude": "52.10000000",
                        "longitude": "-9.78333000"
                    },
                    {
                        "id": 57284,
                        "name": "Killumney",
                        "latitude": "51.87243000",
                        "longitude": "-8.64781000"
                    },
                    {
                        "id": 57287,
                        "name": "Kilmallock",
                        "latitude": "52.40000000",
                        "longitude": "-8.57722000"
                    },
                    {
                        "id": 57290,
                        "name": "Kilrush",
                        "latitude": "52.63972000",
                        "longitude": "-9.48333000"
                    },
                    {
                        "id": 57295,
                        "name": "Kinsale",
                        "latitude": "51.70750000",
                        "longitude": "-8.53056000"
                    },
                    {
                        "id": 57312,
                        "name": "Limerick",
                        "latitude": "52.66472000",
                        "longitude": "-8.62306000"
                    },
                    {
                        "id": 57304,
                        "name": "Listowel",
                        "latitude": "52.44639000",
                        "longitude": "-9.48500000"
                    },
                    {
                        "id": 57315,
                        "name": "Macroom",
                        "latitude": "51.90663000",
                        "longitude": "-8.96968000"
                    },
                    {
                        "id": 57317,
                        "name": "Mallow",
                        "latitude": "52.13333000",
                        "longitude": "-8.63333000"
                    },
                    {
                        "id": 57322,
                        "name": "Midleton",
                        "latitude": "51.91526000",
                        "longitude": "-8.18052000"
                    },
                    {
                        "id": 57323,
                        "name": "Millstreet",
                        "latitude": "52.05935000",
                        "longitude": "-9.06031000"
                    },
                    {
                        "id": 57325,
                        "name": "Mitchelstown",
                        "latitude": "52.26583000",
                        "longitude": "-8.26806000"
                    },
                    {
                        "id": 57332,
                        "name": "Moroe",
                        "latitude": "52.65111000",
                        "longitude": "-8.39611000"
                    },
                    {
                        "id": 57338,
                        "name": "Moyross",
                        "latitude": "52.68198000",
                        "longitude": "-8.63955000"
                    },
                    {
                        "id": 57343,
                        "name": "Nenagh",
                        "latitude": "52.86194000",
                        "longitude": "-8.19667000"
                    },
                    {
                        "id": 57344,
                        "name": "Nenagh Bridge",
                        "latitude": "52.88167000",
                        "longitude": "-8.19583000"
                    },
                    {
                        "id": 57347,
                        "name": "Newcastle West",
                        "latitude": "52.44917000",
                        "longitude": "-9.06111000"
                    },
                    {
                        "id": 57348,
                        "name": "Newmarket on Fergus",
                        "latitude": "52.76000000",
                        "longitude": "-8.89556000"
                    },
                    {
                        "id": 57349,
                        "name": "Newport",
                        "latitude": "52.71111000",
                        "longitude": "-8.40972000"
                    },
                    {
                        "id": 57359,
                        "name": "Passage West",
                        "latitude": "51.87389000",
                        "longitude": "-8.34444000"
                    },
                    {
                        "id": 57363,
                        "name": "Portlaw",
                        "latitude": "52.28833000",
                        "longitude": "-7.32056000"
                    },
                    {
                        "id": 57388,
                        "name": "Ráth Luirc",
                        "latitude": "52.35000000",
                        "longitude": "-8.68333000"
                    },
                    {
                        "id": 57373,
                        "name": "Rathcormac",
                        "latitude": "52.07694000",
                        "longitude": "-8.28194000"
                    },
                    {
                        "id": 57377,
                        "name": "Rathkeale",
                        "latitude": "52.52444000",
                        "longitude": "-8.93806000"
                    },
                    {
                        "id": 57386,
                        "name": "Roscrea",
                        "latitude": "52.95111000",
                        "longitude": "-7.80167000"
                    },
                    {
                        "id": 57395,
                        "name": "Shannon",
                        "latitude": "52.70389000",
                        "longitude": "-8.86417000"
                    },
                    {
                        "id": 57396,
                        "name": "Sixmilebridge",
                        "latitude": "52.74139000",
                        "longitude": "-8.77417000"
                    },
                    {
                        "id": 57398,
                        "name": "Skibbereen",
                        "latitude": "51.55000000",
                        "longitude": "-9.26667000"
                    },
                    {
                        "id": 57409,
                        "name": "Templemore",
                        "latitude": "52.79472000",
                        "longitude": "-7.83389000"
                    },
                    {
                        "id": 57414,
                        "name": "Thurles",
                        "latitude": "52.68194000",
                        "longitude": "-7.80222000"
                    },
                    {
                        "id": 57415,
                        "name": "Tipperary",
                        "latitude": "52.47333000",
                        "longitude": "-8.15583000"
                    },
                    {
                        "id": 57417,
                        "name": "Tower",
                        "latitude": "51.92599000",
                        "longitude": "-8.60747000"
                    },
                    {
                        "id": 57420,
                        "name": "Trá Mhór",
                        "latitude": "52.16235000",
                        "longitude": "-7.15244000"
                    },
                    {
                        "id": 57418,
                        "name": "Tralee",
                        "latitude": "52.27042000",
                        "longitude": "-9.70264000"
                    },
                    {
                        "id": 57428,
                        "name": "Waterford",
                        "latitude": "52.25833000",
                        "longitude": "-7.11194000"
                    },
                    {
                        "id": 57429,
                        "name": "Watergrasshill",
                        "latitude": "52.01139000",
                        "longitude": "-8.34417000"
                    },
                    {
                        "id": 57431,
                        "name": "Whitegate",
                        "latitude": "51.83056000",
                        "longitude": "-8.22972000"
                    },
                    {
                        "id": 57433,
                        "name": "Youghal",
                        "latitude": "51.95000000",
                        "longitude": "-7.85056000"
                    }
                ]
            },
            {
                "id": 1078,
                "name": "Offaly",
                "iso2": "OY",
                "latitude": "53.23568710",
                "longitude": "-7.71222290",
                "type": "county",
                "cities": []
            },
            {
                "id": 1081,
                "name": "Roscommon",
                "iso2": "RN",
                "latitude": "53.75926040",
                "longitude": "-8.26816210",
                "type": "county",
                "cities": []
            },
            {
                "id": 1070,
                "name": "Sligo",
                "iso2": "SO",
                "latitude": "54.15532770",
                "longitude": "-8.60645320",
                "type": "county",
                "cities": []
            },
            {
                "id": 1069,
                "name": "Tipperary",
                "iso2": "TA",
                "latitude": "52.47378940",
                "longitude": "-8.16185140",
                "type": "county",
                "cities": []
            },
            {
                "id": 1086,
                "name": "Ulster",
                "iso2": "U",
                "latitude": "54.76165550",
                "longitude": "-6.96122730",
                "type": "province",
                "cities": [
                    {
                        "id": 57066,
                        "name": "An Cabhán",
                        "latitude": "53.91667000",
                        "longitude": "-7.25000000"
                    },
                    {
                        "id": 57088,
                        "name": "Bailieborough",
                        "latitude": "53.91667000",
                        "longitude": "-6.96667000"
                    },
                    {
                        "id": 57102,
                        "name": "Ballybofey",
                        "latitude": "54.80000000",
                        "longitude": "-7.78333000"
                    },
                    {
                        "id": 57104,
                        "name": "Ballyconnell",
                        "latitude": "54.11667000",
                        "longitude": "-7.58333000"
                    },
                    {
                        "id": 57108,
                        "name": "Ballyjamesduff",
                        "latitude": "53.86528000",
                        "longitude": "-7.20278000"
                    },
                    {
                        "id": 57114,
                        "name": "Ballyshannon",
                        "latitude": "54.50000000",
                        "longitude": "-8.18333000"
                    },
                    {
                        "id": 57124,
                        "name": "Belturbet",
                        "latitude": "54.10000000",
                        "longitude": "-7.45000000"
                    },
                    {
                        "id": 57135,
                        "name": "Buncrana",
                        "latitude": "55.13333000",
                        "longitude": "-7.45000000"
                    },
                    {
                        "id": 57136,
                        "name": "Bundoran",
                        "latitude": "54.47782000",
                        "longitude": "-8.28094000"
                    },
                    {
                        "id": 57145,
                        "name": "Carndonagh",
                        "latitude": "55.25000000",
                        "longitude": "-7.26667000"
                    },
                    {
                        "id": 57149,
                        "name": "Carrickmacross",
                        "latitude": "53.97278000",
                        "longitude": "-6.71889000"
                    },
                    {
                        "id": 57155,
                        "name": "Castleblayney",
                        "latitude": "54.11667000",
                        "longitude": "-6.73333000"
                    },
                    {
                        "id": 57166,
                        "name": "Cavan",
                        "latitude": "53.99083000",
                        "longitude": "-7.36056000"
                    },
                    {
                        "id": 57182,
                        "name": "Clones",
                        "latitude": "54.18333000",
                        "longitude": "-7.23333000"
                    },
                    {
                        "id": 57189,
                        "name": "Convoy",
                        "latitude": "54.86083000",
                        "longitude": "-7.66556000"
                    },
                    {
                        "id": 57191,
                        "name": "Cootehill",
                        "latitude": "54.07250000",
                        "longitude": "-7.08194000"
                    },
                    {
                        "id": 57196,
                        "name": "County Donegal",
                        "latitude": "54.91667000",
                        "longitude": "-8.00000000"
                    },
                    {
                        "id": 57199,
                        "name": "County Monaghan",
                        "latitude": "54.25000000",
                        "longitude": "-7.00000000"
                    },
                    {
                        "id": 57211,
                        "name": "Derrybeg",
                        "latitude": "55.08333000",
                        "longitude": "-8.28944000"
                    },
                    {
                        "id": 57216,
                        "name": "Donegal",
                        "latitude": "54.65378000",
                        "longitude": "-8.11134000"
                    },
                    {
                        "id": 57230,
                        "name": "Dungloe",
                        "latitude": "54.95111000",
                        "longitude": "-8.35917000"
                    },
                    {
                        "id": 57232,
                        "name": "Dunlewy",
                        "latitude": "55.01667000",
                        "longitude": "-8.10000000"
                    },
                    {
                        "id": 57264,
                        "name": "Gweedore",
                        "latitude": "55.05028000",
                        "longitude": "-8.23194000"
                    },
                    {
                        "id": 57285,
                        "name": "Killybegs",
                        "latitude": "54.63333000",
                        "longitude": "-8.45000000"
                    },
                    {
                        "id": 57292,
                        "name": "Kingscourt",
                        "latitude": "53.90806000",
                        "longitude": "-6.80556000"
                    },
                    {
                        "id": 57301,
                        "name": "Leifear",
                        "latitude": "54.83194000",
                        "longitude": "-7.48361000"
                    },
                    {
                        "id": 57303,
                        "name": "Letterkenny",
                        "latitude": "54.95000000",
                        "longitude": "-7.73333000"
                    },
                    {
                        "id": 57327,
                        "name": "Monaghan",
                        "latitude": "54.25000000",
                        "longitude": "-6.96667000"
                    },
                    {
                        "id": 57336,
                        "name": "Moville",
                        "latitude": "55.19153000",
                        "longitude": "-7.03873000"
                    },
                    {
                        "id": 57339,
                        "name": "Muff",
                        "latitude": "55.06667000",
                        "longitude": "-7.26667000"
                    },
                    {
                        "id": 57340,
                        "name": "Mullagh",
                        "latitude": "53.81306000",
                        "longitude": "-6.95139000"
                    },
                    {
                        "id": 57350,
                        "name": "Newtown Cunningham",
                        "latitude": "54.99639000",
                        "longitude": "-7.51917000"
                    },
                    {
                        "id": 57369,
                        "name": "Ramelton",
                        "latitude": "55.03673000",
                        "longitude": "-7.64923000"
                    },
                    {
                        "id": 57370,
                        "name": "Raphoe",
                        "latitude": "54.87472000",
                        "longitude": "-7.59833000"
                    },
                    {
                        "id": 57427,
                        "name": "Virginia",
                        "latitude": "53.83389000",
                        "longitude": "-7.07556000"
                    }
                ]
            },
            {
                "id": 1089,
                "name": "Waterford",
                "iso2": "WD",
                "latitude": "52.19435490",
                "longitude": "-7.62275120",
                "type": "county",
                "cities": []
            },
            {
                "id": 1097,
                "name": "Westmeath",
                "iso2": "WH",
                "latitude": "53.53453080",
                "longitude": "-7.46532170",
                "type": "county",
                "cities": []
            },
            {
                "id": 1093,
                "name": "Wexford",
                "iso2": "WX",
                "latitude": "52.47936030",
                "longitude": "-6.58399130",
                "type": "county",
                "cities": []
            },
            {
                "id": 1085,
                "name": "Wicklow",
                "iso2": "WW",
                "latitude": "52.98623130",
                "longitude": "-6.36725430",
                "type": "county",
                "cities": []
            }
        ]
    },
    {
        "id": 106,
        "name": "Israel",
        "iso3": "ISR",
        "iso2": "IL",
        "numeric_code": "376",
        "phonecode": "972",
        "capital": "Jerusalem",
        "currency": "ILS",
        "currency_name": "Israeli new shekel",
        "currency_symbol": "₪",
        "tld": ".il",
        "native": "יִשְׂרָאֵל",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Israeli",
        "timezones": [
            {
                "zoneName": "Asia\/Jerusalem",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "IST",
                "tzName": "Israel Standard Time"
            }
        ],
        "translations": {
            "br": "Israel",
            "ko": "이스라엘",
            "pt-BR": "Israel",
            "pt": "Israel",
            "nl": "Israël",
            "hr": "Izrael",
            "fa": "اسرائیل",
            "de": "Israel",
            "es": "Israel",
            "fr": "Israël",
            "ja": "イスラエル",
            "it": "Israele",
            "zh-CN": "以色列",
            "tr": "İsrail",
            "ru": "Израиль",
            "uk": "Ізраїль",
            "pl": "Izrael"
        },
        "latitude": "31.50000000",
        "longitude": "34.75000000",
        "emoji": "🇮🇱",
        "emojiU": "U+1F1EE U+1F1F1",
        "states": [
            {
                "id": 1367,
                "name": "Central",
                "iso2": "M",
                "latitude": "47.60875830",
                "longitude": "-122.29642350",
                "type": "district",
                "cities": [
                    {
                        "id": 57446,
                        "name": "Bet Dagan",
                        "latitude": "32.00191000",
                        "longitude": "34.82977000"
                    },
                    {
                        "id": 57449,
                        "name": "Bet Yiẕẖaq",
                        "latitude": "32.32751000",
                        "longitude": "34.88878000"
                    },
                    {
                        "id": 57450,
                        "name": "Bnei Ayish",
                        "latitude": "31.78333000",
                        "longitude": "34.75000000"
                    },
                    {
                        "id": 57463,
                        "name": "Elyakhin",
                        "latitude": "32.40793000",
                        "longitude": "34.92433000"
                    },
                    {
                        "id": 57467,
                        "name": "Eṭ Ṭaiyiba",
                        "latitude": "32.26616000",
                        "longitude": "35.00893000"
                    },
                    {
                        "id": 57466,
                        "name": "Even Yehuda",
                        "latitude": "32.26959000",
                        "longitude": "34.88759000"
                    },
                    {
                        "id": 57468,
                        "name": "Gan Yavne",
                        "latitude": "31.78737000",
                        "longitude": "34.70659000"
                    },
                    {
                        "id": 57469,
                        "name": "Ganei Tikva",
                        "latitude": "32.05971000",
                        "longitude": "34.87320000"
                    },
                    {
                        "id": 57470,
                        "name": "Gedera",
                        "latitude": "31.81456000",
                        "longitude": "34.77998000"
                    },
                    {
                        "id": 57478,
                        "name": "Hod HaSharon",
                        "latitude": "32.15934000",
                        "longitude": "34.89320000"
                    },
                    {
                        "id": 57483,
                        "name": "Jaljūlya",
                        "latitude": "32.15470000",
                        "longitude": "34.95372000"
                    },
                    {
                        "id": 57491,
                        "name": "Kafr Qāsim",
                        "latitude": "32.11406000",
                        "longitude": "34.97624000"
                    },
                    {
                        "id": 57494,
                        "name": "Kefar H̱abad",
                        "latitude": "31.98793000",
                        "longitude": "34.85160000"
                    },
                    {
                        "id": 57499,
                        "name": "Kefar Yona",
                        "latitude": "32.31669000",
                        "longitude": "34.93507000"
                    },
                    {
                        "id": 57500,
                        "name": "Kfar Saba",
                        "latitude": "32.17500000",
                        "longitude": "34.90694000"
                    },
                    {
                        "id": 57503,
                        "name": "Lapid",
                        "latitude": "31.91764000",
                        "longitude": "35.03222000"
                    },
                    {
                        "id": 57505,
                        "name": "Lod",
                        "latitude": "31.94670000",
                        "longitude": "34.89030000"
                    },
                    {
                        "id": 57507,
                        "name": "Mazkeret Batya",
                        "latitude": "31.85357000",
                        "longitude": "34.84646000"
                    },
                    {
                        "id": 57515,
                        "name": "Modi‘in Makkabbim Re‘ut",
                        "latitude": "31.89385000",
                        "longitude": "35.01504000"
                    },
                    {
                        "id": 57525,
                        "name": "Neẖalim",
                        "latitude": "32.06012000",
                        "longitude": "34.91069000"
                    },
                    {
                        "id": 57522,
                        "name": "Ness Ziona",
                        "latitude": "31.92933000",
                        "longitude": "34.79868000"
                    },
                    {
                        "id": 57523,
                        "name": "Netanya",
                        "latitude": "32.33291000",
                        "longitude": "34.85992000"
                    },
                    {
                        "id": 57526,
                        "name": "Nirit",
                        "latitude": "32.14677000",
                        "longitude": "34.98622000"
                    },
                    {
                        "id": 57527,
                        "name": "Nof Ayalon",
                        "latitude": "31.87111000",
                        "longitude": "34.99081000"
                    },
                    {
                        "id": 57528,
                        "name": "Nordiyya",
                        "latitude": "32.31470000",
                        "longitude": "34.89617000"
                    },
                    {
                        "id": 57531,
                        "name": "Pardesiyya",
                        "latitude": "32.30577000",
                        "longitude": "34.90911000"
                    },
                    {
                        "id": 57533,
                        "name": "Petaẖ Tiqwa",
                        "latitude": "32.08707000",
                        "longitude": "34.88747000"
                    },
                    {
                        "id": 57534,
                        "name": "Qalansuwa",
                        "latitude": "32.28493000",
                        "longitude": "34.98106000"
                    },
                    {
                        "id": 57541,
                        "name": "Ra'anana",
                        "latitude": "32.18360000",
                        "longitude": "34.87386000"
                    },
                    {
                        "id": 57546,
                        "name": "Ramla",
                        "latitude": "31.92923000",
                        "longitude": "34.86563000"
                    },
                    {
                        "id": 57548,
                        "name": "Reẖovot",
                        "latitude": "31.89421000",
                        "longitude": "34.81199000"
                    },
                    {
                        "id": 57549,
                        "name": "Rishon LeẔiyyon",
                        "latitude": "31.97102000",
                        "longitude": "34.78939000"
                    },
                    {
                        "id": 57550,
                        "name": "Rosh Ha‘Ayin",
                        "latitude": "32.09556000",
                        "longitude": "34.95664000"
                    },
                    {
                        "id": 57556,
                        "name": "Savyon",
                        "latitude": "32.04966000",
                        "longitude": "34.87770000"
                    },
                    {
                        "id": 57560,
                        "name": "Shoham",
                        "latitude": "31.99866000",
                        "longitude": "34.94559000"
                    },
                    {
                        "id": 57565,
                        "name": "Tel Mond",
                        "latitude": "32.24995000",
                        "longitude": "34.91737000"
                    },
                    {
                        "id": 57568,
                        "name": "Tirah",
                        "latitude": "32.23410000",
                        "longitude": "34.95023000"
                    },
                    {
                        "id": 57573,
                        "name": "Yavné",
                        "latitude": "31.87808000",
                        "longitude": "34.73983000"
                    },
                    {
                        "id": 57574,
                        "name": "Yehud",
                        "latitude": "32.03317000",
                        "longitude": "34.89091000"
                    },
                    {
                        "id": 57580,
                        "name": "Ẕur Moshe",
                        "latitude": "32.29819000",
                        "longitude": "34.91313000"
                    }
                ]
            },
            {
                "id": 1369,
                "name": "Haifa",
                "iso2": "HA",
                "latitude": "32.48141110",
                "longitude": "34.99475100",
                "type": "district",
                "cities": [
                    {
                        "id": 57440,
                        "name": "Atlit",
                        "latitude": "32.68889000",
                        "longitude": "34.94236000"
                    },
                    {
                        "id": 57455,
                        "name": "Caesarea",
                        "latitude": "32.51888000",
                        "longitude": "34.90459000"
                    },
                    {
                        "id": 57457,
                        "name": "Daliyat al Karmel",
                        "latitude": "32.69383000",
                        "longitude": "35.04686000"
                    },
                    {
                        "id": 57461,
                        "name": "El Fureidīs",
                        "latitude": "32.59812000",
                        "longitude": "34.95153000"
                    },
                    {
                        "id": 57473,
                        "name": "Hadera",
                        "latitude": "32.44192000",
                        "longitude": "34.90390000"
                    },
                    {
                        "id": 57474,
                        "name": "Haifa",
                        "latitude": "32.81841000",
                        "longitude": "34.98850000"
                    },
                    {
                        "id": 57480,
                        "name": "Ibṭīn",
                        "latitude": "32.76150000",
                        "longitude": "35.11402000"
                    },
                    {
                        "id": 57521,
                        "name": "Nesher",
                        "latitude": "32.76622000",
                        "longitude": "35.04425000"
                    },
                    {
                        "id": 57535,
                        "name": "Qiryat Ata",
                        "latitude": "32.81149000",
                        "longitude": "35.11323000"
                    },
                    {
                        "id": 57536,
                        "name": "Qiryat Bialik",
                        "latitude": "32.82750000",
                        "longitude": "35.08583000"
                    },
                    {
                        "id": 57538,
                        "name": "Qiryat Moẕqin",
                        "latitude": "32.83706000",
                        "longitude": "35.07760000"
                    },
                    {
                        "id": 57540,
                        "name": "Qiryat Yam",
                        "latitude": "32.84966000",
                        "longitude": "35.06973000"
                    },
                    {
                        "id": 57547,
                        "name": "Rekhasim",
                        "latitude": "32.74907000",
                        "longitude": "35.09901000"
                    },
                    {
                        "id": 57569,
                        "name": "Tirat Karmel",
                        "latitude": "32.76021000",
                        "longitude": "34.97183000"
                    },
                    {
                        "id": 57570,
                        "name": "Umm el Faḥm",
                        "latitude": "32.51725000",
                        "longitude": "35.15349000"
                    }
                ]
            },
            {
                "id": 1370,
                "name": "Jerusalem",
                "iso2": "JM",
                "latitude": "31.76482430",
                "longitude": "34.99475100",
                "type": "district",
                "cities": [
                    {
                        "id": 57434,
                        "name": "Abū Ghaush",
                        "latitude": "31.80592000",
                        "longitude": "35.10930000"
                    },
                    {
                        "id": 57447,
                        "name": "Bet Shemesh",
                        "latitude": "31.73072000",
                        "longitude": "34.99293000"
                    },
                    {
                        "id": 57475,
                        "name": "Har Adar",
                        "latitude": "31.82754000",
                        "longitude": "35.13093000"
                    },
                    {
                        "id": 57484,
                        "name": "Jerusalem",
                        "latitude": "31.76904000",
                        "longitude": "35.21633000"
                    },
                    {
                        "id": 57509,
                        "name": "Mevasseret Ẕiyyon",
                        "latitude": "31.80186000",
                        "longitude": "35.15072000"
                    },
                    {
                        "id": 57514,
                        "name": "Modiin Ilit",
                        "latitude": "31.93221000",
                        "longitude": "35.04416000"
                    },
                    {
                        "id": 57571,
                        "name": "West Jerusalem",
                        "latitude": "31.78199000",
                        "longitude": "35.21961000"
                    },
                    {
                        "id": 57579,
                        "name": "Ẕur Hadassa",
                        "latitude": "31.71912000",
                        "longitude": "35.09708000"
                    }
                ]
            },
            {
                "id": 1366,
                "name": "Northern",
                "iso2": "Z",
                "latitude": "36.15118640",
                "longitude": "-95.99517630",
                "type": "district",
                "cities": [
                    {
                        "id": 57581,
                        "name": "‘Eilabun",
                        "latitude": "32.83693000",
                        "longitude": "35.40029000"
                    },
                    {
                        "id": 57583,
                        "name": "‘Uzeir",
                        "latitude": "32.79212000",
                        "longitude": "35.32984000"
                    },
                    {
                        "id": 57435,
                        "name": "Acre",
                        "latitude": "32.92814000",
                        "longitude": "35.07647000"
                    },
                    {
                        "id": 57436,
                        "name": "Afula",
                        "latitude": "32.60907000",
                        "longitude": "35.28920000"
                    },
                    {
                        "id": 57442,
                        "name": "Basmat Ṭab‘ūn",
                        "latitude": "32.73898000",
                        "longitude": "35.15716000"
                    },
                    {
                        "id": 57445,
                        "name": "Beit Jann",
                        "latitude": "32.96464000",
                        "longitude": "35.38152000"
                    },
                    {
                        "id": 57448,
                        "name": "Bet She’an",
                        "latitude": "32.49728000",
                        "longitude": "35.49632000"
                    },
                    {
                        "id": 57454,
                        "name": "Bīr el Maksūr",
                        "latitude": "32.77732000",
                        "longitude": "35.22069000"
                    },
                    {
                        "id": 57453,
                        "name": "Bu‘eina",
                        "latitude": "32.80636000",
                        "longitude": "35.36486000"
                    },
                    {
                        "id": 57452,
                        "name": "Buqei‘a",
                        "latitude": "32.97747000",
                        "longitude": "35.33345000"
                    },
                    {
                        "id": 57456,
                        "name": "Dabbūrīya",
                        "latitude": "32.69256000",
                        "longitude": "35.37123000"
                    },
                    {
                        "id": 57458,
                        "name": "Deir Ḥannā",
                        "latitude": "32.86196000",
                        "longitude": "35.36365000"
                    },
                    {
                        "id": 57462,
                        "name": "El Mazra‘a",
                        "latitude": "32.98338000",
                        "longitude": "35.09837000"
                    },
                    {
                        "id": 57464,
                        "name": "Er Reina",
                        "latitude": "32.72339000",
                        "longitude": "35.31622000"
                    },
                    {
                        "id": 57465,
                        "name": "Esh Sheikh Dannūn",
                        "latitude": "32.99410000",
                        "longitude": "35.14805000"
                    },
                    {
                        "id": 57578,
                        "name": "Ḥurfeish",
                        "latitude": "33.01711000",
                        "longitude": "35.34835000"
                    },
                    {
                        "id": 57481,
                        "name": "Iksāl",
                        "latitude": "32.68164000",
                        "longitude": "35.32365000"
                    },
                    {
                        "id": 57486,
                        "name": "Jīsh",
                        "latitude": "33.02216000",
                        "longitude": "35.44694000"
                    },
                    {
                        "id": 57485,
                        "name": "Judeida Makr",
                        "latitude": "32.92820000",
                        "longitude": "35.15705000"
                    },
                    {
                        "id": 57502,
                        "name": "Kābūl",
                        "latitude": "32.86856000",
                        "longitude": "35.21171000"
                    },
                    {
                        "id": 57487,
                        "name": "Kafr Kammā",
                        "latitude": "32.72129000",
                        "longitude": "35.44122000"
                    },
                    {
                        "id": 57488,
                        "name": "Kafr Kannā",
                        "latitude": "32.74660000",
                        "longitude": "35.34242000"
                    },
                    {
                        "id": 57489,
                        "name": "Kafr Mandā",
                        "latitude": "32.81034000",
                        "longitude": "35.26009000"
                    },
                    {
                        "id": 57490,
                        "name": "Kafr Miṣr",
                        "latitude": "32.64521000",
                        "longitude": "35.42147000"
                    },
                    {
                        "id": 57492,
                        "name": "Karmi’el",
                        "latitude": "32.91708000",
                        "longitude": "35.30501000"
                    },
                    {
                        "id": 57493,
                        "name": "Kaukab Abū el Hījā",
                        "latitude": "32.83155000",
                        "longitude": "35.24848000"
                    },
                    {
                        "id": 57495,
                        "name": "Kefar Rosh HaNiqra",
                        "latitude": "33.08607000",
                        "longitude": "35.11348000"
                    },
                    {
                        "id": 57497,
                        "name": "Kefar Tavor",
                        "latitude": "32.68655000",
                        "longitude": "35.42118000"
                    },
                    {
                        "id": 57498,
                        "name": "Kefar Weradim",
                        "latitude": "32.99385000",
                        "longitude": "35.27793000"
                    },
                    {
                        "id": 57501,
                        "name": "Kfar Yasif",
                        "latitude": "32.95451000",
                        "longitude": "35.16230000"
                    },
                    {
                        "id": 57577,
                        "name": "maalot Tarshīhā",
                        "latitude": "33.01667000",
                        "longitude": "35.26667000"
                    },
                    {
                        "id": 57506,
                        "name": "Maghār",
                        "latitude": "32.88984000",
                        "longitude": "35.40703000"
                    },
                    {
                        "id": 57508,
                        "name": "Metulla",
                        "latitude": "33.27918000",
                        "longitude": "35.57950000"
                    },
                    {
                        "id": 57513,
                        "name": "Mi‘ilyā",
                        "latitude": "33.02781000",
                        "longitude": "35.25658000"
                    },
                    {
                        "id": 57511,
                        "name": "Migdal Ha‘Emeq",
                        "latitude": "32.67597000",
                        "longitude": "35.23986000"
                    },
                    {
                        "id": 57516,
                        "name": "Nahariyya",
                        "latitude": "33.00892000",
                        "longitude": "35.09814000"
                    },
                    {
                        "id": 57518,
                        "name": "Naḥf",
                        "latitude": "32.93444000",
                        "longitude": "35.31679000"
                    },
                    {
                        "id": 57517,
                        "name": "Nazareth",
                        "latitude": "32.70056000",
                        "longitude": "35.29722000"
                    },
                    {
                        "id": 57519,
                        "name": "Nefat ‘Akko",
                        "latitude": "32.95000000",
                        "longitude": "35.23333000"
                    },
                    {
                        "id": 57520,
                        "name": "Nein",
                        "latitude": "32.63063000",
                        "longitude": "35.34885000"
                    },
                    {
                        "id": 57532,
                        "name": "Pasuta",
                        "latitude": "33.04895000",
                        "longitude": "35.30893000"
                    },
                    {
                        "id": 57539,
                        "name": "Qiryat Shemona",
                        "latitude": "33.20733000",
                        "longitude": "35.57212000"
                    },
                    {
                        "id": 57545,
                        "name": "Ramat Yishay",
                        "latitude": "32.70444000",
                        "longitude": "35.17070000"
                    },
                    {
                        "id": 57551,
                        "name": "Rosh Pinna",
                        "latitude": "32.96894000",
                        "longitude": "35.54258000"
                    },
                    {
                        "id": 57552,
                        "name": "Rumat Heib",
                        "latitude": "32.77802000",
                        "longitude": "35.30571000"
                    },
                    {
                        "id": 57553,
                        "name": "Safed",
                        "latitude": "32.96465000",
                        "longitude": "35.49600000"
                    },
                    {
                        "id": 57561,
                        "name": "Sājūr",
                        "latitude": "32.94266000",
                        "longitude": "35.34136000"
                    },
                    {
                        "id": 57554,
                        "name": "Sakhnīn",
                        "latitude": "32.86422000",
                        "longitude": "35.29707000"
                    },
                    {
                        "id": 57555,
                        "name": "Sallama",
                        "latitude": "32.89443000",
                        "longitude": "35.36931000"
                    },
                    {
                        "id": 57558,
                        "name": "Shelomi",
                        "latitude": "33.07216000",
                        "longitude": "35.14452000"
                    },
                    {
                        "id": 57559,
                        "name": "Shibli",
                        "latitude": "32.69464000",
                        "longitude": "35.39252000"
                    },
                    {
                        "id": 57562,
                        "name": "Sūlam",
                        "latitude": "32.60606000",
                        "longitude": "35.33408000"
                    },
                    {
                        "id": 57563,
                        "name": "Tamra",
                        "latitude": "32.85301000",
                        "longitude": "35.19870000"
                    },
                    {
                        "id": 57566,
                        "name": "Tiberias",
                        "latitude": "32.79221000",
                        "longitude": "35.53124000"
                    },
                    {
                        "id": 57567,
                        "name": "Timrat",
                        "latitude": "32.70302000",
                        "longitude": "35.22359000"
                    },
                    {
                        "id": 57572,
                        "name": "Yavne’el",
                        "latitude": "32.70619000",
                        "longitude": "35.50435000"
                    }
                ]
            },
            {
                "id": 1368,
                "name": "Southern",
                "iso2": "D",
                "latitude": "40.71375860",
                "longitude": "-74.00090590",
                "type": "district",
                "cities": [
                    {
                        "id": 57582,
                        "name": "‘En Boqeq",
                        "latitude": "31.19941000",
                        "longitude": "35.36253000"
                    },
                    {
                        "id": 57437,
                        "name": "Arad",
                        "latitude": "31.25882000",
                        "longitude": "35.21282000"
                    },
                    {
                        "id": 57438,
                        "name": "Ashdod",
                        "latitude": "31.79213000",
                        "longitude": "34.64966000"
                    },
                    {
                        "id": 57439,
                        "name": "Ashkelon",
                        "latitude": "31.66926000",
                        "longitude": "34.57149000"
                    },
                    {
                        "id": 57444,
                        "name": "Beersheba",
                        "latitude": "31.25181000",
                        "longitude": "34.79130000"
                    },
                    {
                        "id": 57459,
                        "name": "Dimona",
                        "latitude": "31.07079000",
                        "longitude": "35.03269000"
                    },
                    {
                        "id": 57460,
                        "name": "Eilat",
                        "latitude": "29.55805000",
                        "longitude": "34.94821000"
                    },
                    {
                        "id": 57504,
                        "name": "Lehavim",
                        "latitude": "31.37284000",
                        "longitude": "34.81619000"
                    },
                    {
                        "id": 57510,
                        "name": "Midreshet Ben-Gurion",
                        "latitude": "30.85154000",
                        "longitude": "34.78340000"
                    },
                    {
                        "id": 57512,
                        "name": "Mitzpe Ramon",
                        "latitude": "30.60944000",
                        "longitude": "34.80111000"
                    },
                    {
                        "id": 57524,
                        "name": "Netivot",
                        "latitude": "31.42305000",
                        "longitude": "34.58911000"
                    },
                    {
                        "id": 57529,
                        "name": "Ofaqim",
                        "latitude": "31.31410000",
                        "longitude": "34.62025000"
                    },
                    {
                        "id": 57537,
                        "name": "Qiryat Gat",
                        "latitude": "31.60998000",
                        "longitude": "34.76422000"
                    },
                    {
                        "id": 57542,
                        "name": "Rahat",
                        "latitude": "31.39547000",
                        "longitude": "34.75699000"
                    },
                    {
                        "id": 57557,
                        "name": "Sederot",
                        "latitude": "31.52500000",
                        "longitude": "34.59693000"
                    },
                    {
                        "id": 57576,
                        "name": "Yeroẖam",
                        "latitude": "30.98822000",
                        "longitude": "34.93176000"
                    }
                ]
            },
            {
                "id": 1371,
                "name": "Tel Aviv",
                "iso2": "TA",
                "latitude": "32.09290750",
                "longitude": "34.80721650",
                "type": "district",
                "cities": [
                    {
                        "id": 57441,
                        "name": "Azor",
                        "latitude": "32.02430000",
                        "longitude": "34.80632000"
                    },
                    {
                        "id": 57443,
                        "name": "Bat Yam",
                        "latitude": "32.02379000",
                        "longitude": "34.75185000"
                    },
                    {
                        "id": 57451,
                        "name": "Bnei Brak",
                        "latitude": "32.08074000",
                        "longitude": "34.83380000"
                    },
                    {
                        "id": 57471,
                        "name": "Giv'at Shmuel",
                        "latitude": "32.07817000",
                        "longitude": "34.84858000"
                    },
                    {
                        "id": 57472,
                        "name": "Givatayim",
                        "latitude": "32.07225000",
                        "longitude": "34.81253000"
                    },
                    {
                        "id": 57476,
                        "name": "Herzliya",
                        "latitude": "32.16627000",
                        "longitude": "34.82536000"
                    },
                    {
                        "id": 57477,
                        "name": "Herzliya Pituah",
                        "latitude": "32.17409000",
                        "longitude": "34.80280000"
                    },
                    {
                        "id": 57479,
                        "name": "H̱olon",
                        "latitude": "32.01034000",
                        "longitude": "34.77918000"
                    },
                    {
                        "id": 57482,
                        "name": "Jaffa",
                        "latitude": "32.05043000",
                        "longitude": "34.75224000"
                    },
                    {
                        "id": 57496,
                        "name": "Kefar Shemaryahu",
                        "latitude": "32.18529000",
                        "longitude": "34.82082000"
                    },
                    {
                        "id": 57530,
                        "name": "Or Yehuda",
                        "latitude": "32.02923000",
                        "longitude": "34.85788000"
                    },
                    {
                        "id": 57543,
                        "name": "Ramat Gan",
                        "latitude": "32.08227000",
                        "longitude": "34.81065000"
                    },
                    {
                        "id": 57544,
                        "name": "Ramat HaSharon",
                        "latitude": "32.14613000",
                        "longitude": "34.83940000"
                    },
                    {
                        "id": 57564,
                        "name": "Tel Aviv",
                        "latitude": "32.08088000",
                        "longitude": "34.78057000"
                    },
                    {
                        "id": 57575,
                        "name": "Yehud-Monosson",
                        "latitude": "32.02840000",
                        "longitude": "34.87960000"
                    }
                ]
            }
        ]
    },
    {
        "id": 107,
        "name": "Italy",
        "iso3": "ITA",
        "iso2": "IT",
        "numeric_code": "380",
        "phonecode": "39",
        "capital": "Rome",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".it",
        "native": "Italia",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Italian",
        "timezones": [
            {
                "zoneName": "Europe\/Rome",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Italia",
            "ko": "이탈리아",
            "pt-BR": "Itália",
            "pt": "Itália",
            "nl": "Italië",
            "hr": "Italija",
            "fa": "ایتالیا",
            "de": "Italien",
            "es": "Italia",
            "fr": "Italie",
            "ja": "イタリア",
            "it": "Italia",
            "zh-CN": "意大利",
            "tr": "İtalya",
            "ru": "Италия",
            "uk": "Італія",
            "pl": "Włochy"
        },
        "latitude": "42.83333333",
        "longitude": "12.83333333",
        "emoji": "🇮🇹",
        "emojiU": "U+1F1EE U+1F1F9",
        "states": [
            {
                "id": 1679,
                "name": "Abruzzo",
                "iso2": "65",
                "latitude": "42.19201190",
                "longitude": "13.72891670",
                "type": "region",
                "cities": [
                    {
                        "id": 135240,
                        "name": "Abbateggio",
                        "latitude": "42.22421000",
                        "longitude": "14.01001000"
                    },
                    {
                        "id": 135250,
                        "name": "Acciano",
                        "latitude": "42.17677000",
                        "longitude": "13.71783000"
                    },
                    {
                        "id": 135325,
                        "name": "Aielli",
                        "latitude": "42.08146000",
                        "longitude": "13.59113000"
                    },
                    {
                        "id": 135342,
                        "name": "Alanno",
                        "latitude": "42.29552000",
                        "longitude": "13.97084000"
                    },
                    {
                        "id": 135347,
                        "name": "Alba Adriatica",
                        "latitude": "42.83176000",
                        "longitude": "13.92590000"
                    },
                    {
                        "id": 135400,
                        "name": "Alfedena",
                        "latitude": "41.73545000",
                        "longitude": "14.03500000"
                    },
                    {
                        "id": 135440,
                        "name": "Altino",
                        "latitude": "42.09954000",
                        "longitude": "14.33267000"
                    },
                    {
                        "id": 135477,
                        "name": "Ancarano",
                        "latitude": "42.83767000",
                        "longitude": "13.74662000"
                    },
                    {
                        "id": 135523,
                        "name": "Anversa degli Abruzzi",
                        "latitude": "41.99478000",
                        "longitude": "13.80379000"
                    },
                    {
                        "id": 135565,
                        "name": "Archi",
                        "latitude": "42.09135000",
                        "longitude": "14.38270000"
                    },
                    {
                        "id": 135597,
                        "name": "Ari",
                        "latitude": "42.28967000",
                        "longitude": "14.25856000"
                    },
                    {
                        "id": 135602,
                        "name": "Arielli",
                        "latitude": "42.26003000",
                        "longitude": "14.31004000"
                    },
                    {
                        "id": 135638,
                        "name": "Arsita",
                        "latitude": "42.50266000",
                        "longitude": "13.78516000"
                    },
                    {
                        "id": 135672,
                        "name": "Ateleta",
                        "latitude": "41.85435000",
                        "longitude": "14.19806000"
                    },
                    {
                        "id": 135675,
                        "name": "Atessa",
                        "latitude": "42.07018000",
                        "longitude": "14.45049000"
                    },
                    {
                        "id": 135679,
                        "name": "Atri",
                        "latitude": "42.57642000",
                        "longitude": "13.98899000"
                    },
                    {
                        "id": 135704,
                        "name": "Avezzano",
                        "latitude": "42.02896000",
                        "longitude": "13.42641000"
                    },
                    {
                        "id": 135795,
                        "name": "Balsorano",
                        "latitude": "41.80982000",
                        "longitude": "13.55980000"
                    },
                    {
                        "id": 135796,
                        "name": "Balsorano Nuovo",
                        "latitude": "41.80881000",
                        "longitude": "13.56069000"
                    },
                    {
                        "id": 135826,
                        "name": "Barberi",
                        "latitude": "42.44072000",
                        "longitude": "14.04268000"
                    },
                    {
                        "id": 135847,
                        "name": "Barete",
                        "latitude": "42.45009000",
                        "longitude": "13.28061000"
                    },
                    {
                        "id": 135858,
                        "name": "Barisciano",
                        "latitude": "42.32465000",
                        "longitude": "13.59036000"
                    },
                    {
                        "id": 135870,
                        "name": "Barrea",
                        "latitude": "41.75543000",
                        "longitude": "13.99095000"
                    },
                    {
                        "id": 135881,
                        "name": "Basciano",
                        "latitude": "42.59639000",
                        "longitude": "13.73561000"
                    },
                    {
                        "id": 135938,
                        "name": "Bellante",
                        "latitude": "42.74421000",
                        "longitude": "13.80234000"
                    },
                    {
                        "id": 135939,
                        "name": "Bellante Stazione",
                        "latitude": "42.70650000",
                        "longitude": "13.83953000"
                    },
                    {
                        "id": 136062,
                        "name": "Bisegna",
                        "latitude": "41.92113000",
                        "longitude": "13.75760000"
                    },
                    {
                        "id": 136063,
                        "name": "Bisenti",
                        "latitude": "42.52883000",
                        "longitude": "13.79950000"
                    },
                    {
                        "id": 136108,
                        "name": "Bolognano",
                        "latitude": "42.21814000",
                        "longitude": "13.96011000"
                    },
                    {
                        "id": 136119,
                        "name": "Bomba",
                        "latitude": "42.03343000",
                        "longitude": "14.36656000"
                    },
                    {
                        "id": 136189,
                        "name": "Borgo Santa Maria Immacolata",
                        "latitude": "42.61172000",
                        "longitude": "14.04553000"
                    },
                    {
                        "id": 136227,
                        "name": "Borrello",
                        "latitude": "41.91730000",
                        "longitude": "14.30535000"
                    },
                    {
                        "id": 136343,
                        "name": "Brittoli",
                        "latitude": "42.31518000",
                        "longitude": "13.86026000"
                    },
                    {
                        "id": 136385,
                        "name": "Bucchianico",
                        "latitude": "42.30368000",
                        "longitude": "14.18377000"
                    },
                    {
                        "id": 136397,
                        "name": "Bugnara",
                        "latitude": "42.02383000",
                        "longitude": "13.86141000"
                    },
                    {
                        "id": 136430,
                        "name": "Bussi sul Tirino",
                        "latitude": "42.21321000",
                        "longitude": "13.82511000"
                    },
                    {
                        "id": 136470,
                        "name": "Cagnano Amiterno",
                        "latitude": "42.45744000",
                        "longitude": "13.22789000"
                    },
                    {
                        "id": 136494,
                        "name": "Calascio",
                        "latitude": "42.32595000",
                        "longitude": "13.69699000"
                    },
                    {
                        "id": 136625,
                        "name": "Campli",
                        "latitude": "42.72679000",
                        "longitude": "13.68692000"
                    },
                    {
                        "id": 136635,
                        "name": "Campo di Giove",
                        "latitude": "42.01013000",
                        "longitude": "14.03941000"
                    },
                    {
                        "id": 136683,
                        "name": "Campotosto",
                        "latitude": "42.55884000",
                        "longitude": "13.36799000"
                    },
                    {
                        "id": 136716,
                        "name": "Canistro Inferiore",
                        "latitude": "41.94101000",
                        "longitude": "13.41194000"
                    },
                    {
                        "id": 136731,
                        "name": "Canosa Sannita",
                        "latitude": "42.29629000",
                        "longitude": "14.30514000"
                    },
                    {
                        "id": 136736,
                        "name": "Cansano",
                        "latitude": "42.00350000",
                        "longitude": "14.01341000"
                    },
                    {
                        "id": 136752,
                        "name": "Canzano",
                        "latitude": "42.64564000",
                        "longitude": "13.80410000"
                    },
                    {
                        "id": 136765,
                        "name": "Capestrano",
                        "latitude": "42.26807000",
                        "longitude": "13.76779000"
                    },
                    {
                        "id": 136771,
                        "name": "Capistrello",
                        "latitude": "41.97223000",
                        "longitude": "13.39616000"
                    },
                    {
                        "id": 136774,
                        "name": "Capitignano",
                        "latitude": "42.52041000",
                        "longitude": "13.30122000"
                    },
                    {
                        "id": 136786,
                        "name": "Caporciano",
                        "latitude": "42.25001000",
                        "longitude": "13.67455000"
                    },
                    {
                        "id": 136790,
                        "name": "Cappadocia",
                        "latitude": "42.00755000",
                        "longitude": "13.27806000"
                    },
                    {
                        "id": 136794,
                        "name": "Cappelle sul Tavo",
                        "latitude": "42.47709000",
                        "longitude": "14.10735000"
                    },
                    {
                        "id": 136831,
                        "name": "Caramanico Terme",
                        "latitude": "42.15593000",
                        "longitude": "14.00480000"
                    },
                    {
                        "id": 136835,
                        "name": "Carapelle Calvisio",
                        "latitude": "42.29908000",
                        "longitude": "13.68643000"
                    },
                    {
                        "id": 136920,
                        "name": "Carpineto della Nora",
                        "latitude": "42.33365000",
                        "longitude": "13.86062000"
                    },
                    {
                        "id": 136919,
                        "name": "Carpineto Sinello",
                        "latitude": "42.01044000",
                        "longitude": "14.50418000"
                    },
                    {
                        "id": 136936,
                        "name": "Carsoli",
                        "latitude": "42.09882000",
                        "longitude": "13.08856000"
                    },
                    {
                        "id": 136945,
                        "name": "Carunchio",
                        "latitude": "41.91761000",
                        "longitude": "14.52683000"
                    },
                    {
                        "id": 136954,
                        "name": "Casacanditella",
                        "latitude": "42.24643000",
                        "longitude": "14.20040000"
                    },
                    {
                        "id": 136961,
                        "name": "Casalanguida",
                        "latitude": "42.03752000",
                        "longitude": "14.49613000"
                    },
                    {
                        "id": 136965,
                        "name": "Casalbordino-Miracoli",
                        "latitude": "42.15354000",
                        "longitude": "14.59912000"
                    },
                    {
                        "id": 136995,
                        "name": "Casalincontrada",
                        "latitude": "42.29744000",
                        "longitude": "14.13511000"
                    },
                    {
                        "id": 137083,
                        "name": "Casoli",
                        "latitude": "42.61723000",
                        "longitude": "13.97910000"
                    },
                    {
                        "id": 137133,
                        "name": "Castel Castagna",
                        "latitude": "42.54294000",
                        "longitude": "13.71640000"
                    },
                    {
                        "id": 137165,
                        "name": "Castel del Monte",
                        "latitude": "42.36544000",
                        "longitude": "13.72592000"
                    },
                    {
                        "id": 137169,
                        "name": "Castel di Ieri",
                        "latitude": "42.11353000",
                        "longitude": "13.74200000"
                    },
                    {
                        "id": 137173,
                        "name": "Castel di Sangro",
                        "latitude": "41.78392000",
                        "longitude": "14.10653000"
                    },
                    {
                        "id": 137136,
                        "name": "Castel Frentano",
                        "latitude": "42.19875000",
                        "longitude": "14.35643000"
                    },
                    {
                        "id": 137205,
                        "name": "Castelguidone",
                        "latitude": "41.82258000",
                        "longitude": "14.52286000"
                    },
                    {
                        "id": 137210,
                        "name": "Castellafiume",
                        "latitude": "41.98913000",
                        "longitude": "13.33440000"
                    },
                    {
                        "id": 137211,
                        "name": "Castellalto",
                        "latitude": "42.67705000",
                        "longitude": "13.82101000"
                    },
                    {
                        "id": 137242,
                        "name": "Castelli",
                        "latitude": "42.48476000",
                        "longitude": "13.71201000"
                    },
                    {
                        "id": 137295,
                        "name": "Castelnuovo Vomano",
                        "latitude": "42.62933000",
                        "longitude": "13.85003000"
                    },
                    {
                        "id": 137321,
                        "name": "Castelvecchio Calvisio",
                        "latitude": "42.31134000",
                        "longitude": "13.68720000"
                    },
                    {
                        "id": 137322,
                        "name": "Castelvecchio Subequo",
                        "latitude": "42.12881000",
                        "longitude": "13.72868000"
                    },
                    {
                        "id": 137347,
                        "name": "Castiglione a Casauria",
                        "latitude": "42.23601000",
                        "longitude": "13.89832000"
                    },
                    {
                        "id": 137342,
                        "name": "Castiglione Messer Marino",
                        "latitude": "41.86833000",
                        "longitude": "14.44996000"
                    },
                    {
                        "id": 137343,
                        "name": "Castiglione Messer Raimondo",
                        "latitude": "42.53194000",
                        "longitude": "13.87953000"
                    },
                    {
                        "id": 137360,
                        "name": "Castilenti",
                        "latitude": "42.53334000",
                        "longitude": "13.91710000"
                    },
                    {
                        "id": 137395,
                        "name": "Catignano",
                        "latitude": "42.34697000",
                        "longitude": "13.95190000"
                    },
                    {
                        "id": 137462,
                        "name": "Celano",
                        "latitude": "42.08077000",
                        "longitude": "13.51700000"
                    },
                    {
                        "id": 137465,
                        "name": "Celenza sul Trigno",
                        "latitude": "41.87198000",
                        "longitude": "14.57893000"
                    },
                    {
                        "id": 137479,
                        "name": "Cellino Attanasio",
                        "latitude": "42.58574000",
                        "longitude": "13.86050000"
                    },
                    {
                        "id": 137505,
                        "name": "Cepagatti",
                        "latitude": "42.36506000",
                        "longitude": "14.07424000"
                    },
                    {
                        "id": 137525,
                        "name": "Cerchio",
                        "latitude": "42.06357000",
                        "longitude": "13.60006000"
                    },
                    {
                        "id": 137555,
                        "name": "Cermignano",
                        "latitude": "42.59131000",
                        "longitude": "13.79540000"
                    },
                    {
                        "id": 137560,
                        "name": "Cerratina",
                        "latitude": "42.39007000",
                        "longitude": "14.10338000"
                    },
                    {
                        "id": 137672,
                        "name": "Chieti",
                        "latitude": "42.34827000",
                        "longitude": "14.16494000"
                    },
                    {
                        "id": 137772,
                        "name": "Città Sant'Angelo",
                        "latitude": "42.51254000",
                        "longitude": "14.06203000"
                    },
                    {
                        "id": 137787,
                        "name": "Civita d'Antino",
                        "latitude": "41.88629000",
                        "longitude": "13.47215000"
                    },
                    {
                        "id": 137789,
                        "name": "Civitaluparella",
                        "latitude": "41.94490000",
                        "longitude": "14.30135000"
                    },
                    {
                        "id": 137793,
                        "name": "Civitaquana",
                        "latitude": "42.32578000",
                        "longitude": "13.90012000"
                    },
                    {
                        "id": 137795,
                        "name": "Civitella Alfedena",
                        "latitude": "41.76533000",
                        "longitude": "13.94271000"
                    },
                    {
                        "id": 137796,
                        "name": "Civitella Casanova",
                        "latitude": "42.36391000",
                        "longitude": "13.88514000"
                    },
                    {
                        "id": 137802,
                        "name": "Civitella del Tronto",
                        "latitude": "42.77298000",
                        "longitude": "13.67626000"
                    },
                    {
                        "id": 137798,
                        "name": "Civitella Messer Raimondo",
                        "latitude": "42.08893000",
                        "longitude": "14.21701000"
                    },
                    {
                        "id": 137799,
                        "name": "Civitella Roveto",
                        "latitude": "41.91329000",
                        "longitude": "13.42396000"
                    },
                    {
                        "id": 137826,
                        "name": "Cocullo",
                        "latitude": "42.03283000",
                        "longitude": "13.77500000"
                    },
                    {
                        "id": 137857,
                        "name": "Collarmele",
                        "latitude": "42.06031000",
                        "longitude": "13.62670000"
                    },
                    {
                        "id": 137876,
                        "name": "Collecorvino",
                        "latitude": "42.46024000",
                        "longitude": "14.01564000"
                    },
                    {
                        "id": 137877,
                        "name": "Colledara",
                        "latitude": "42.53918000",
                        "longitude": "13.67556000"
                    },
                    {
                        "id": 137878,
                        "name": "Colledimacine",
                        "latitude": "42.00370000",
                        "longitude": "14.20079000"
                    },
                    {
                        "id": 137879,
                        "name": "Colledimezzo",
                        "latitude": "41.98606000",
                        "longitude": "14.38690000"
                    },
                    {
                        "id": 137884,
                        "name": "Collelongo",
                        "latitude": "41.88659000",
                        "longitude": "13.58380000"
                    },
                    {
                        "id": 137889,
                        "name": "Collepietro",
                        "latitude": "42.22089000",
                        "longitude": "13.78101000"
                    },
                    {
                        "id": 137890,
                        "name": "Colleranesco",
                        "latitude": "42.72112000",
                        "longitude": "13.93732000"
                    },
                    {
                        "id": 137911,
                        "name": "Cologna Spiaggia",
                        "latitude": "42.72152000",
                        "longitude": "13.98311000"
                    },
                    {
                        "id": 137923,
                        "name": "Colonnella",
                        "latitude": "42.87230000",
                        "longitude": "13.86987000"
                    },
                    {
                        "id": 137941,
                        "name": "Cominio",
                        "latitude": "42.31248000",
                        "longitude": "13.43250000"
                    },
                    {
                        "id": 137980,
                        "name": "Controguerra",
                        "latitude": "42.85398000",
                        "longitude": "13.81775000"
                    },
                    {
                        "id": 137989,
                        "name": "Coppito",
                        "latitude": "42.36730000",
                        "longitude": "13.34358000"
                    },
                    {
                        "id": 138008,
                        "name": "Corfinio",
                        "latitude": "42.12149000",
                        "longitude": "13.83940000"
                    },
                    {
                        "id": 138044,
                        "name": "Corropoli",
                        "latitude": "42.82720000",
                        "longitude": "13.83471000"
                    },
                    {
                        "id": 138069,
                        "name": "Cortino",
                        "latitude": "42.62186000",
                        "longitude": "13.50774000"
                    },
                    {
                        "id": 138072,
                        "name": "Corvara",
                        "latitude": "42.27511000",
                        "longitude": "13.87363000"
                    },
                    {
                        "id": 138129,
                        "name": "Crecchio",
                        "latitude": "42.29778000",
                        "longitude": "14.32656000"
                    },
                    {
                        "id": 138163,
                        "name": "Crognaleto",
                        "latitude": "42.58771000",
                        "longitude": "13.48890000"
                    },
                    {
                        "id": 138186,
                        "name": "Cugnoli",
                        "latitude": "42.30692000",
                        "longitude": "13.93490000"
                    },
                    {
                        "id": 138195,
                        "name": "Cupello",
                        "latitude": "42.06936000",
                        "longitude": "14.67054000"
                    },
                    {
                        "id": 138277,
                        "name": "Dogliola",
                        "latitude": "41.94238000",
                        "longitude": "14.63507000"
                    },
                    {
                        "id": 138351,
                        "name": "Elice",
                        "latitude": "42.52279000",
                        "longitude": "13.97071000"
                    },
                    {
                        "id": 138422,
                        "name": "Fallo",
                        "latitude": "41.93833000",
                        "longitude": "14.32362000"
                    },
                    {
                        "id": 138434,
                        "name": "Fano Adriano",
                        "latitude": "42.55230000",
                        "longitude": "13.53764000"
                    },
                    {
                        "id": 138437,
                        "name": "Fara Filiorum Petri",
                        "latitude": "42.24152000",
                        "longitude": "14.18026000"
                    },
                    {
                        "id": 138441,
                        "name": "Fara San Martino",
                        "latitude": "42.09248000",
                        "longitude": "14.20896000"
                    },
                    {
                        "id": 138447,
                        "name": "Farindola",
                        "latitude": "42.44292000",
                        "longitude": "13.82137000"
                    },
                    {
                        "id": 138527,
                        "name": "Filetto",
                        "latitude": "42.22931000",
                        "longitude": "14.24501000"
                    },
                    {
                        "id": 138607,
                        "name": "Fonte Umano-San Martino Alta",
                        "latitude": "42.52084000",
                        "longitude": "14.10760000"
                    },
                    {
                        "id": 138609,
                        "name": "Fontecchio",
                        "latitude": "42.23027000",
                        "longitude": "13.60613000"
                    },
                    {
                        "id": 138667,
                        "name": "Fossa",
                        "latitude": "42.29273000",
                        "longitude": "13.48779000"
                    },
                    {
                        "id": 138669,
                        "name": "Fossacesia",
                        "latitude": "42.24198000",
                        "longitude": "14.48339000"
                    },
                    {
                        "id": 138690,
                        "name": "Fraine",
                        "latitude": "41.90624000",
                        "longitude": "14.48788000"
                    },
                    {
                        "id": 138696,
                        "name": "Francavilla al Mare",
                        "latitude": "42.42158000",
                        "longitude": "14.28217000"
                    },
                    {
                        "id": 138730,
                        "name": "Fresagrandinaria",
                        "latitude": "41.97900000",
                        "longitude": "14.66211000"
                    },
                    {
                        "id": 138736,
                        "name": "Frisa",
                        "latitude": "42.26572000",
                        "longitude": "14.37625000"
                    },
                    {
                        "id": 138755,
                        "name": "Furci",
                        "latitude": "42.00746000",
                        "longitude": "14.58802000"
                    },
                    {
                        "id": 138781,
                        "name": "Gagliano Aterno",
                        "latitude": "42.12598000",
                        "longitude": "13.70023000"
                    },
                    {
                        "id": 138832,
                        "name": "Gamberale",
                        "latitude": "41.90529000",
                        "longitude": "14.20845000"
                    },
                    {
                        "id": 138926,
                        "name": "Gessopalena",
                        "latitude": "42.05521000",
                        "longitude": "14.27367000"
                    },
                    {
                        "id": 138970,
                        "name": "Gioia dei Marsi",
                        "latitude": "41.95697000",
                        "longitude": "13.69057000"
                    },
                    {
                        "id": 138985,
                        "name": "Gissi",
                        "latitude": "42.01803000",
                        "longitude": "14.54484000"
                    },
                    {
                        "id": 138991,
                        "name": "Giuliano Teatino",
                        "latitude": "42.31220000",
                        "longitude": "14.28082000"
                    },
                    {
                        "id": 138993,
                        "name": "Giulianova",
                        "latitude": "42.75381000",
                        "longitude": "13.96650000"
                    },
                    {
                        "id": 139031,
                        "name": "Goriano Sicoli",
                        "latitude": "42.08011000",
                        "longitude": "13.77459000"
                    },
                    {
                        "id": 139163,
                        "name": "Guardiagrele",
                        "latitude": "42.19406000",
                        "longitude": "14.21939000"
                    },
                    {
                        "id": 139181,
                        "name": "Guilmi",
                        "latitude": "41.99653000",
                        "longitude": "14.47882000"
                    },
                    {
                        "id": 139201,
                        "name": "Imposte",
                        "latitude": "42.68634000",
                        "longitude": "13.52829000"
                    },
                    {
                        "id": 139212,
                        "name": "Introdacqua",
                        "latitude": "42.00968000",
                        "longitude": "13.89779000"
                    },
                    {
                        "id": 139245,
                        "name": "Isola del Gran Sasso d'Italia",
                        "latitude": "42.50324000",
                        "longitude": "13.65721000"
                    },
                    {
                        "id": 139285,
                        "name": "L'Aquila",
                        "latitude": "42.35055000",
                        "longitude": "13.39954000"
                    },
                    {
                        "id": 139341,
                        "name": "Lama dei Peligni",
                        "latitude": "42.04214000",
                        "longitude": "14.18678000"
                    },
                    {
                        "id": 139354,
                        "name": "Lanciano",
                        "latitude": "42.22718000",
                        "longitude": "14.39024000"
                    },
                    {
                        "id": 139431,
                        "name": "Lecce Nei Marsi",
                        "latitude": "41.93436000",
                        "longitude": "13.68430000"
                    },
                    {
                        "id": 139451,
                        "name": "Lentella",
                        "latitude": "41.99576000",
                        "longitude": "14.67692000"
                    },
                    {
                        "id": 139479,
                        "name": "Lettomanoppello",
                        "latitude": "42.24336000",
                        "longitude": "14.03843000"
                    },
                    {
                        "id": 139480,
                        "name": "Lettopalena",
                        "latitude": "42.00251000",
                        "longitude": "14.15652000"
                    },
                    {
                        "id": 139538,
                        "name": "Liscia",
                        "latitude": "41.95524000",
                        "longitude": "14.55532000"
                    },
                    {
                        "id": 139610,
                        "name": "Loreto Aprutino",
                        "latitude": "42.43104000",
                        "longitude": "13.98057000"
                    },
                    {
                        "id": 139638,
                        "name": "Luco dei Marsi",
                        "latitude": "41.95925000",
                        "longitude": "13.47349000"
                    },
                    {
                        "id": 139639,
                        "name": "Lucoli",
                        "latitude": "42.29093000",
                        "longitude": "13.33799000"
                    },
                    {
                        "id": 139725,
                        "name": "Magliano De'Marsi",
                        "latitude": "42.09153000",
                        "longitude": "13.36379000"
                    },
                    {
                        "id": 139802,
                        "name": "Manoppello",
                        "latitude": "42.25918000",
                        "longitude": "14.06024000"
                    },
                    {
                        "id": 139803,
                        "name": "Manoppello Scalo",
                        "latitude": "42.30762000",
                        "longitude": "14.05363000"
                    },
                    {
                        "id": 139895,
                        "name": "Marina di San Vito",
                        "latitude": "42.30514000",
                        "longitude": "14.44844000"
                    },
                    {
                        "id": 139897,
                        "name": "Marina di Vasto",
                        "latitude": "42.09373000",
                        "longitude": "14.72683000"
                    },
                    {
                        "id": 139936,
                        "name": "Martinsicuro",
                        "latitude": "42.88031000",
                        "longitude": "13.91326000"
                    },
                    {
                        "id": 139975,
                        "name": "Massa d'Albe-Corona",
                        "latitude": "42.10723000",
                        "longitude": "13.39429000"
                    },
                    {
                        "id": 140132,
                        "name": "Miglianico",
                        "latitude": "42.35773000",
                        "longitude": "14.29179000"
                    },
                    {
                        "id": 140214,
                        "name": "Molina Aterno",
                        "latitude": "42.14903000",
                        "longitude": "13.73540000"
                    },
                    {
                        "id": 140350,
                        "name": "Montazzoli",
                        "latitude": "41.94887000",
                        "longitude": "14.43069000"
                    },
                    {
                        "id": 140389,
                        "name": "Montebello di Bertona",
                        "latitude": "42.41686000",
                        "longitude": "13.87119000"
                    },
                    {
                        "id": 140390,
                        "name": "Montebello sul Sangro",
                        "latitude": "41.98663000",
                        "longitude": "14.32402000"
                    },
                    {
                        "id": 140436,
                        "name": "Monteferrante",
                        "latitude": "41.95396000",
                        "longitude": "14.38856000"
                    },
                    {
                        "id": 140438,
                        "name": "Montefino",
                        "latitude": "42.54551000",
                        "longitude": "13.88479000"
                    },
                    {
                        "id": 140465,
                        "name": "Montelapiano",
                        "latitude": "41.96267000",
                        "longitude": "14.34212000"
                    },
                    {
                        "id": 140504,
                        "name": "Montenerodomo",
                        "latitude": "41.97682000",
                        "longitude": "14.25177000"
                    },
                    {
                        "id": 140505,
                        "name": "Monteodorisio",
                        "latitude": "42.08485000",
                        "longitude": "14.65386000"
                    },
                    {
                        "id": 140514,
                        "name": "Montereale",
                        "latitude": "42.52332000",
                        "longitude": "13.24585000"
                    },
                    {
                        "id": 140541,
                        "name": "Montesilvano Marina",
                        "latitude": "42.51140000",
                        "longitude": "14.14507000"
                    },
                    {
                        "id": 140557,
                        "name": "Monticchio",
                        "latitude": "42.32035000",
                        "longitude": "13.46382000"
                    },
                    {
                        "id": 140586,
                        "name": "Montorio al Vomano",
                        "latitude": "42.58123000",
                        "longitude": "13.63715000"
                    },
                    {
                        "id": 140620,
                        "name": "Morino",
                        "latitude": "41.86442000",
                        "longitude": "13.45700000"
                    },
                    {
                        "id": 140634,
                        "name": "Morro d'Oro",
                        "latitude": "42.66291000",
                        "longitude": "13.92129000"
                    },
                    {
                        "id": 140646,
                        "name": "Mosciano Sant'Angelo",
                        "latitude": "42.74700000",
                        "longitude": "13.88891000"
                    },
                    {
                        "id": 140647,
                        "name": "Moscufo",
                        "latitude": "42.42713000",
                        "longitude": "14.05434000"
                    },
                    {
                        "id": 140671,
                        "name": "Mozzagrogna",
                        "latitude": "42.21267000",
                        "longitude": "14.44258000"
                    },
                    {
                        "id": 140731,
                        "name": "Navelli",
                        "latitude": "42.23721000",
                        "longitude": "13.72961000"
                    },
                    {
                        "id": 140743,
                        "name": "Nepezzano",
                        "latitude": "42.68994000",
                        "longitude": "13.75650000"
                    },
                    {
                        "id": 140745,
                        "name": "Nereto",
                        "latitude": "42.81548000",
                        "longitude": "13.81989000"
                    },
                    {
                        "id": 140746,
                        "name": "Nerito",
                        "latitude": "42.54763000",
                        "longitude": "13.47759000"
                    },
                    {
                        "id": 140780,
                        "name": "Nocciano",
                        "latitude": "42.33366000",
                        "longitude": "13.98571000"
                    },
                    {
                        "id": 140811,
                        "name": "Notaresco",
                        "latitude": "42.65742000",
                        "longitude": "13.89491000"
                    },
                    {
                        "id": 140842,
                        "name": "Nucleo Industriale di Bazzano",
                        "latitude": "42.33623000",
                        "longitude": "13.46755000"
                    },
                    {
                        "id": 140874,
                        "name": "Ofena",
                        "latitude": "42.32536000",
                        "longitude": "13.75864000"
                    },
                    {
                        "id": 140932,
                        "name": "Opi",
                        "latitude": "41.77838000",
                        "longitude": "13.82932000"
                    },
                    {
                        "id": 140952,
                        "name": "Oricola",
                        "latitude": "42.04922000",
                        "longitude": "13.03939000"
                    },
                    {
                        "id": 140975,
                        "name": "Orsogna",
                        "latitude": "42.22344000",
                        "longitude": "14.28085000"
                    },
                    {
                        "id": 140987,
                        "name": "Ortona",
                        "latitude": "42.35087000",
                        "longitude": "14.40342000"
                    },
                    {
                        "id": 140988,
                        "name": "Ortona dei Marsi",
                        "latitude": "41.99820000",
                        "longitude": "13.72909000"
                    },
                    {
                        "id": 140990,
                        "name": "Ortucchio",
                        "latitude": "41.95525000",
                        "longitude": "13.64651000"
                    },
                    {
                        "id": 141058,
                        "name": "Ovindoli",
                        "latitude": "42.13765000",
                        "longitude": "13.51603000"
                    },
                    {
                        "id": 141070,
                        "name": "Pacentro",
                        "latitude": "42.05043000",
                        "longitude": "13.99151000"
                    },
                    {
                        "id": 141095,
                        "name": "Paganica-Tempera",
                        "latitude": "42.35715000",
                        "longitude": "13.47138000"
                    },
                    {
                        "id": 58205,
                        "name": "Pagliare",
                        "latitude": "42.64372000",
                        "longitude": "13.95171000"
                    },
                    {
                        "id": 58209,
                        "name": "Paglieta",
                        "latitude": "42.16139000",
                        "longitude": "14.50306000"
                    },
                    {
                        "id": 58238,
                        "name": "Palena",
                        "latitude": "41.98353000",
                        "longitude": "14.13696000"
                    },
                    {
                        "id": 58260,
                        "name": "Palmoli",
                        "latitude": "41.93944000",
                        "longitude": "14.58142000"
                    },
                    {
                        "id": 58264,
                        "name": "Palombaro",
                        "latitude": "42.12323000",
                        "longitude": "14.22989000"
                    },
                    {
                        "id": 58403,
                        "name": "Penna Sant'Andrea",
                        "latitude": "42.59403000",
                        "longitude": "13.77215000"
                    },
                    {
                        "id": 58406,
                        "name": "Pennadomo",
                        "latitude": "42.00394000",
                        "longitude": "14.32338000"
                    },
                    {
                        "id": 58407,
                        "name": "Pennapiedimonte",
                        "latitude": "42.15563000",
                        "longitude": "14.19432000"
                    },
                    {
                        "id": 58408,
                        "name": "Penne",
                        "latitude": "42.45474000",
                        "longitude": "13.92754000"
                    },
                    {
                        "id": 58411,
                        "name": "Perano",
                        "latitude": "42.10460000",
                        "longitude": "14.39581000"
                    },
                    {
                        "id": 58420,
                        "name": "Pereto",
                        "latitude": "42.05821000",
                        "longitude": "13.10231000"
                    },
                    {
                        "id": 58450,
                        "name": "Pescara",
                        "latitude": "42.45840000",
                        "longitude": "14.20283000"
                    },
                    {
                        "id": 58452,
                        "name": "Pescasseroli",
                        "latitude": "41.80343000",
                        "longitude": "13.78707000"
                    },
                    {
                        "id": 58459,
                        "name": "Pescina",
                        "latitude": "42.02351000",
                        "longitude": "13.65116000"
                    },
                    {
                        "id": 58461,
                        "name": "Pescocostanzo",
                        "latitude": "41.88722000",
                        "longitude": "14.06614000"
                    },
                    {
                        "id": 58466,
                        "name": "Pescosansonesco Nuovo",
                        "latitude": "42.25524000",
                        "longitude": "13.88480000"
                    },
                    {
                        "id": 58493,
                        "name": "Pettorano sul Gizio",
                        "latitude": "41.97326000",
                        "longitude": "13.96001000"
                    },
                    {
                        "id": 58523,
                        "name": "Pianella",
                        "latitude": "42.39918000",
                        "longitude": "14.04781000"
                    },
                    {
                        "id": 58548,
                        "name": "Pianola",
                        "latitude": "42.32341000",
                        "longitude": "13.40394000"
                    },
                    {
                        "id": 58554,
                        "name": "Pianura Vomano",
                        "latitude": "42.63028000",
                        "longitude": "13.91548000"
                    },
                    {
                        "id": 58579,
                        "name": "Picciano",
                        "latitude": "42.47525000",
                        "longitude": "13.98990000"
                    },
                    {
                        "id": 58607,
                        "name": "Pietracamela",
                        "latitude": "42.52344000",
                        "longitude": "13.55431000"
                    },
                    {
                        "id": 58612,
                        "name": "Pietraferrazzana",
                        "latitude": "41.96943000",
                        "longitude": "14.37451000"
                    },
                    {
                        "id": 58619,
                        "name": "Pietranico",
                        "latitude": "42.27565000",
                        "longitude": "13.91077000"
                    },
                    {
                        "id": 58677,
                        "name": "Pineto",
                        "latitude": "42.60879000",
                        "longitude": "14.06639000"
                    },
                    {
                        "id": 58727,
                        "name": "Pizzoferrato",
                        "latitude": "41.92244000",
                        "longitude": "14.23632000"
                    },
                    {
                        "id": 58728,
                        "name": "Pizzoli",
                        "latitude": "42.43603000",
                        "longitude": "13.29886000"
                    },
                    {
                        "id": 58759,
                        "name": "Poggio Picenze",
                        "latitude": "42.32061000",
                        "longitude": "13.54036000"
                    },
                    {
                        "id": 58768,
                        "name": "Poggiofiorito",
                        "latitude": "42.25414000",
                        "longitude": "14.32082000"
                    },
                    {
                        "id": 58802,
                        "name": "Pollutri",
                        "latitude": "42.13784000",
                        "longitude": "14.59172000"
                    },
                    {
                        "id": 58900,
                        "name": "Popoli",
                        "latitude": "42.16866000",
                        "longitude": "13.82997000"
                    },
                    {
                        "id": 59015,
                        "name": "Prata d'Ansidonia",
                        "latitude": "42.27793000",
                        "longitude": "13.60830000"
                    },
                    {
                        "id": 59033,
                        "name": "Pratola Peligna",
                        "latitude": "42.09701000",
                        "longitude": "13.87467000"
                    },
                    {
                        "id": 59069,
                        "name": "Pretoro",
                        "latitude": "42.21923000",
                        "longitude": "14.14248000"
                    },
                    {
                        "id": 59070,
                        "name": "Preturo",
                        "latitude": "42.37808000",
                        "longitude": "13.29633000"
                    },
                    {
                        "id": 59072,
                        "name": "Prezza",
                        "latitude": "42.05789000",
                        "longitude": "13.83592000"
                    },
                    {
                        "id": 59087,
                        "name": "Progetto Case Bazzano",
                        "latitude": "42.33643000",
                        "longitude": "13.44410000"
                    },
                    {
                        "id": 59088,
                        "name": "Progetto Case Coppito 3",
                        "latitude": "42.36981000",
                        "longitude": "13.31973000"
                    },
                    {
                        "id": 59089,
                        "name": "Progetto Case Sassa Nsi",
                        "latitude": "42.36560000",
                        "longitude": "13.31509000"
                    },
                    {
                        "id": 59106,
                        "name": "Provincia dell' Aquila",
                        "latitude": "42.08333000",
                        "longitude": "13.66667000"
                    },
                    {
                        "id": 59124,
                        "name": "Provincia di Chieti",
                        "latitude": "42.11667000",
                        "longitude": "14.35000000"
                    },
                    {
                        "id": 59160,
                        "name": "Provincia di Pescara",
                        "latitude": "42.33333000",
                        "longitude": "13.95000000"
                    },
                    {
                        "id": 59179,
                        "name": "Provincia di Teramo",
                        "latitude": "42.65000000",
                        "longitude": "13.68333000"
                    },
                    {
                        "id": 59212,
                        "name": "Quadri",
                        "latitude": "41.92402000",
                        "longitude": "14.28768000"
                    },
                    {
                        "id": 59270,
                        "name": "Raiano",
                        "latitude": "42.10158000",
                        "longitude": "13.81386000"
                    },
                    {
                        "id": 59285,
                        "name": "Rapino",
                        "latitude": "42.20931000",
                        "longitude": "14.18493000"
                    },
                    {
                        "id": 59399,
                        "name": "Ripa Teatina",
                        "latitude": "42.36603000",
                        "longitude": "14.24441000"
                    },
                    {
                        "id": 59439,
                        "name": "Rivisondoli",
                        "latitude": "41.87023000",
                        "longitude": "14.06671000"
                    },
                    {
                        "id": 59483,
                        "name": "Rocca di Botte",
                        "latitude": "42.03102000",
                        "longitude": "13.07185000"
                    },
                    {
                        "id": 59484,
                        "name": "Rocca di Cambio",
                        "latitude": "42.23755000",
                        "longitude": "13.48906000"
                    },
                    {
                        "id": 59487,
                        "name": "Rocca di Mezzo",
                        "latitude": "42.20441000",
                        "longitude": "13.51840000"
                    },
                    {
                        "id": 59473,
                        "name": "Rocca Pia",
                        "latitude": "41.93429000",
                        "longitude": "13.97726000"
                    },
                    {
                        "id": 59478,
                        "name": "Rocca San Giovanni",
                        "latitude": "42.24604000",
                        "longitude": "14.46162000"
                    },
                    {
                        "id": 59494,
                        "name": "Roccacasale",
                        "latitude": "42.12249000",
                        "longitude": "13.88758000"
                    },
                    {
                        "id": 59510,
                        "name": "Roccamorice",
                        "latitude": "42.21274000",
                        "longitude": "14.02531000"
                    },
                    {
                        "id": 59516,
                        "name": "Roccaraso",
                        "latitude": "41.84872000",
                        "longitude": "14.07846000"
                    },
                    {
                        "id": 59518,
                        "name": "Roccascalegna",
                        "latitude": "42.06212000",
                        "longitude": "14.30802000"
                    },
                    {
                        "id": 59524,
                        "name": "Roccaspinalveti-Santa Giusta",
                        "latitude": "41.94233000",
                        "longitude": "14.47092000"
                    },
                    {
                        "id": 59531,
                        "name": "Roccavivi",
                        "latitude": "41.81214000",
                        "longitude": "13.53662000"
                    },
                    {
                        "id": 59567,
                        "name": "Roio del Sangro",
                        "latitude": "41.91153000",
                        "longitude": "14.37382000"
                    },
                    {
                        "id": 59629,
                        "name": "Rosciano",
                        "latitude": "42.32227000",
                        "longitude": "14.04555000"
                    },
                    {
                        "id": 59634,
                        "name": "Rosello",
                        "latitude": "41.90116000",
                        "longitude": "14.34919000"
                    },
                    {
                        "id": 59637,
                        "name": "Roseto degli Abruzzi",
                        "latitude": "42.67164000",
                        "longitude": "14.01481000"
                    },
                    {
                        "id": 59772,
                        "name": "Salino",
                        "latitude": "42.78571000",
                        "longitude": "13.91400000"
                    },
                    {
                        "id": 59777,
                        "name": "Salle",
                        "latitude": "42.17756000",
                        "longitude": "13.96091000"
                    },
                    {
                        "id": 59792,
                        "name": "Salvo Marina",
                        "latitude": "42.07037000",
                        "longitude": "14.76597000"
                    },
                    {
                        "id": 59806,
                        "name": "Sambuceto",
                        "latitude": "42.42168000",
                        "longitude": "14.18747000"
                    },
                    {
                        "id": 59831,
                        "name": "San Benedetto dei Marsi",
                        "latitude": "42.00760000",
                        "longitude": "13.62381000"
                    },
                    {
                        "id": 59833,
                        "name": "San Benedetto in Perillis",
                        "latitude": "42.18377000",
                        "longitude": "13.76996000"
                    },
                    {
                        "id": 59849,
                        "name": "San Buono",
                        "latitude": "41.98140000",
                        "longitude": "14.56818000"
                    },
                    {
                        "id": 59892,
                        "name": "San Demetrio Ne' Vestini",
                        "latitude": "42.28963000",
                        "longitude": "13.55519000"
                    },
                    {
                        "id": 59986,
                        "name": "San Giovanni Lipioni",
                        "latitude": "41.84383000",
                        "longitude": "14.56271000"
                    },
                    {
                        "id": 60072,
                        "name": "San Martino Bassa",
                        "latitude": "42.51827000",
                        "longitude": "14.13045000"
                    },
                    {
                        "id": 60097,
                        "name": "San Martino sulla Marrucina",
                        "latitude": "42.22419000",
                        "longitude": "14.21577000"
                    },
                    {
                        "id": 60148,
                        "name": "San Nicolò a Tordino",
                        "latitude": "42.69648000",
                        "longitude": "13.79708000"
                    },
                    {
                        "id": 60153,
                        "name": "San Panfilo d'Ocre",
                        "latitude": "42.28616000",
                        "longitude": "13.47518000"
                    },
                    {
                        "id": 60203,
                        "name": "San Pio delle Camere",
                        "latitude": "42.28423000",
                        "longitude": "13.65570000"
                    },
                    {
                        "id": 60222,
                        "name": "San Rocco",
                        "latitude": "42.24294000",
                        "longitude": "14.12891000"
                    },
                    {
                        "id": 60234,
                        "name": "San Salvo",
                        "latitude": "42.04413000",
                        "longitude": "14.73335000"
                    },
                    {
                        "id": 60259,
                        "name": "San Valentino in Abruzzo Citeriore",
                        "latitude": "42.23304000",
                        "longitude": "13.98561000"
                    },
                    {
                        "id": 60269,
                        "name": "San Vincenzo Valle Roveto",
                        "latitude": "41.84452000",
                        "longitude": "13.53566000"
                    },
                    {
                        "id": 60275,
                        "name": "San Vito Chietino",
                        "latitude": "42.29014000",
                        "longitude": "14.44270000"
                    },
                    {
                        "id": 60391,
                        "name": "Sant'Egidio alla Vibrata",
                        "latitude": "42.81705000",
                        "longitude": "13.72164000"
                    },
                    {
                        "id": 60400,
                        "name": "Sant'Eufemia a Maiella",
                        "latitude": "42.12613000",
                        "longitude": "14.02651000"
                    },
                    {
                        "id": 60403,
                        "name": "Sant'Eusanio del Sangro",
                        "latitude": "42.16908000",
                        "longitude": "14.32776000"
                    },
                    {
                        "id": 60402,
                        "name": "Sant'Eusanio Forconese",
                        "latitude": "42.28951000",
                        "longitude": "13.52425000"
                    },
                    {
                        "id": 60407,
                        "name": "Sant'Omero",
                        "latitude": "42.79011000",
                        "longitude": "13.78906000"
                    },
                    {
                        "id": 60463,
                        "name": "Santa Maria Imbaro",
                        "latitude": "42.21999000",
                        "longitude": "14.45027000"
                    },
                    {
                        "id": 60494,
                        "name": "Santa Teresa",
                        "latitude": "42.42753000",
                        "longitude": "14.15816000"
                    },
                    {
                        "id": 60504,
                        "name": "Sante Marie",
                        "latitude": "42.10369000",
                        "longitude": "13.20163000"
                    },
                    {
                        "id": 60524,
                        "name": "Santo Stefano di Sessanio",
                        "latitude": "42.34339000",
                        "longitude": "13.64477000"
                    },
                    {
                        "id": 60565,
                        "name": "Sassa",
                        "latitude": "42.35204000",
                        "longitude": "13.29924000"
                    },
                    {
                        "id": 60601,
                        "name": "Scafa",
                        "latitude": "42.26575000",
                        "longitude": "13.99665000"
                    },
                    {
                        "id": 60622,
                        "name": "Scanno",
                        "latitude": "41.90442000",
                        "longitude": "13.87961000"
                    },
                    {
                        "id": 60639,
                        "name": "Scerne",
                        "latitude": "42.64754000",
                        "longitude": "14.03791000"
                    },
                    {
                        "id": 60640,
                        "name": "Scerni",
                        "latitude": "42.10418000",
                        "longitude": "14.57428000"
                    },
                    {
                        "id": 60643,
                        "name": "Schiavi di Abruzzo",
                        "latitude": "41.81311000",
                        "longitude": "14.48655000"
                    },
                    {
                        "id": 60662,
                        "name": "Scontrone",
                        "latitude": "41.74681000",
                        "longitude": "14.03880000"
                    },
                    {
                        "id": 60665,
                        "name": "Scoppito",
                        "latitude": "42.36948000",
                        "longitude": "13.25936000"
                    },
                    {
                        "id": 60670,
                        "name": "Scurcola Marsicana",
                        "latitude": "42.06313000",
                        "longitude": "13.33919000"
                    },
                    {
                        "id": 60676,
                        "name": "Secinaro",
                        "latitude": "42.15062000",
                        "longitude": "13.68145000"
                    },
                    {
                        "id": 60704,
                        "name": "Selva",
                        "latitude": "42.11442000",
                        "longitude": "14.34425000"
                    },
                    {
                        "id": 60765,
                        "name": "Serramonacesca",
                        "latitude": "42.24795000",
                        "longitude": "14.09297000"
                    },
                    {
                        "id": 60857,
                        "name": "Silvi",
                        "latitude": "42.54984000",
                        "longitude": "14.11759000"
                    },
                    {
                        "id": 61027,
                        "name": "Spoltore",
                        "latitude": "42.45501000",
                        "longitude": "14.13988000"
                    },
                    {
                        "id": 61116,
                        "name": "Sulmona",
                        "latitude": "42.04945000",
                        "longitude": "13.92578000"
                    },
                    {
                        "id": 61142,
                        "name": "Tagliacozzo",
                        "latitude": "42.06933000",
                        "longitude": "13.25469000"
                    },
                    {
                        "id": 61163,
                        "name": "Taranta Peligna",
                        "latitude": "42.02052000",
                        "longitude": "14.17103000"
                    },
                    {
                        "id": 61217,
                        "name": "Teramo",
                        "latitude": "42.66123000",
                        "longitude": "13.69901000"
                    },
                    {
                        "id": 61280,
                        "name": "Tione degli Abruzzi",
                        "latitude": "42.20393000",
                        "longitude": "13.63570000"
                    },
                    {
                        "id": 61293,
                        "name": "Tocco da Casauria",
                        "latitude": "42.21203000",
                        "longitude": "13.91547000"
                    },
                    {
                        "id": 61301,
                        "name": "Tollo",
                        "latitude": "42.34542000",
                        "longitude": "14.32360000"
                    },
                    {
                        "id": 61317,
                        "name": "Torano Nuovo",
                        "latitude": "42.82305000",
                        "longitude": "13.77729000"
                    },
                    {
                        "id": 61330,
                        "name": "Torino di Sangro",
                        "latitude": "42.19100000",
                        "longitude": "14.54272000"
                    },
                    {
                        "id": 61334,
                        "name": "Tornareccio",
                        "latitude": "42.03763000",
                        "longitude": "14.41525000"
                    },
                    {
                        "id": 61336,
                        "name": "Tornimparte",
                        "latitude": "42.29007000",
                        "longitude": "13.30092000"
                    },
                    {
                        "id": 61368,
                        "name": "Torre de' Passeri",
                        "latitude": "42.24324000",
                        "longitude": "13.93330000"
                    },
                    {
                        "id": 61380,
                        "name": "Torrebruna",
                        "latitude": "41.86742000",
                        "longitude": "14.54148000"
                    },
                    {
                        "id": 61392,
                        "name": "Torrevecchia",
                        "latitude": "42.38274000",
                        "longitude": "14.21331000"
                    },
                    {
                        "id": 61399,
                        "name": "Torricella",
                        "latitude": "42.65904000",
                        "longitude": "13.65719000"
                    },
                    {
                        "id": 61401,
                        "name": "Torricella Peligna",
                        "latitude": "42.02397000",
                        "longitude": "14.25854000"
                    },
                    {
                        "id": 61416,
                        "name": "Tortoreto",
                        "latitude": "42.80371000",
                        "longitude": "13.91346000"
                    },
                    {
                        "id": 61417,
                        "name": "Tortoreto Lido",
                        "latitude": "42.79956000",
                        "longitude": "13.94205000"
                    },
                    {
                        "id": 61424,
                        "name": "Tossicia",
                        "latitude": "42.54472000",
                        "longitude": "13.64595000"
                    },
                    {
                        "id": 61444,
                        "name": "Trasacco",
                        "latitude": "41.95742000",
                        "longitude": "13.53270000"
                    },
                    {
                        "id": 61473,
                        "name": "Treglio",
                        "latitude": "42.26184000",
                        "longitude": "14.42315000"
                    },
                    {
                        "id": 61563,
                        "name": "Tufillo",
                        "latitude": "41.91685000",
                        "longitude": "14.62558000"
                    },
                    {
                        "id": 61578,
                        "name": "Turrivalignani",
                        "latitude": "42.26296000",
                        "longitude": "14.02852000"
                    },
                    {
                        "id": 61626,
                        "name": "Vacri",
                        "latitude": "42.29764000",
                        "longitude": "14.22901000"
                    },
                    {
                        "id": 61686,
                        "name": "Valle Castellana",
                        "latitude": "42.73614000",
                        "longitude": "13.49709000"
                    },
                    {
                        "id": 61704,
                        "name": "Vallecupa",
                        "latitude": "42.25366000",
                        "longitude": "13.57467000"
                    },
                    {
                        "id": 61781,
                        "name": "Vasto",
                        "latitude": "42.11150000",
                        "longitude": "14.70649000"
                    },
                    {
                        "id": 61922,
                        "name": "Vicoli",
                        "latitude": "42.34095000",
                        "longitude": "13.89688000"
                    },
                    {
                        "id": 61988,
                        "name": "Villa Caldari",
                        "latitude": "42.29566000",
                        "longitude": "14.36157000"
                    },
                    {
                        "id": 61992,
                        "name": "Villa Celiera",
                        "latitude": "42.38184000",
                        "longitude": "13.85860000"
                    },
                    {
                        "id": 62003,
                        "name": "Villa Lempa",
                        "latitude": "42.79345000",
                        "longitude": "13.64433000"
                    },
                    {
                        "id": 62012,
                        "name": "Villa Raspa",
                        "latitude": "42.45542000",
                        "longitude": "14.18457000"
                    },
                    {
                        "id": 62015,
                        "name": "Villa Rosa",
                        "latitude": "42.85059000",
                        "longitude": "13.92015000"
                    },
                    {
                        "id": 62022,
                        "name": "Villa Sant'Angelo",
                        "latitude": "42.27043000",
                        "longitude": "13.53710000"
                    },
                    {
                        "id": 62025,
                        "name": "Villa Santa Lucia degli Abruzzi",
                        "latitude": "42.33286000",
                        "longitude": "13.77792000"
                    },
                    {
                        "id": 62026,
                        "name": "Villa Santa Maria",
                        "latitude": "41.95130000",
                        "longitude": "14.35148000"
                    },
                    {
                        "id": 62071,
                        "name": "Villagrande",
                        "latitude": "42.29533000",
                        "longitude": "13.29999000"
                    },
                    {
                        "id": 62075,
                        "name": "Villalago",
                        "latitude": "41.93514000",
                        "longitude": "13.83868000"
                    },
                    {
                        "id": 62078,
                        "name": "Villalfonsina",
                        "latitude": "42.16038000",
                        "longitude": "14.56932000"
                    },
                    {
                        "id": 62080,
                        "name": "Villamagna",
                        "latitude": "42.32984000",
                        "longitude": "14.23689000"
                    },
                    {
                        "id": 62093,
                        "name": "Villanova",
                        "latitude": "42.38251000",
                        "longitude": "14.12338000"
                    },
                    {
                        "id": 62145,
                        "name": "Villavallelonga",
                        "latitude": "41.87104000",
                        "longitude": "13.62088000"
                    },
                    {
                        "id": 62151,
                        "name": "Villetta Barrea",
                        "latitude": "41.77646000",
                        "longitude": "13.93892000"
                    },
                    {
                        "id": 62186,
                        "name": "Vittorito",
                        "latitude": "42.12703000",
                        "longitude": "13.81670000"
                    }
                ]
            },
            {
                "id": 1727,
                "name": "Agrigento",
                "iso2": "AG",
                "latitude": "37.31052020",
                "longitude": "13.58579780",
                "type": "free municipal consortium",
                "cities": []
            },
            {
                "id": 1783,
                "name": "Alessandria",
                "iso2": "AL",
                "latitude": "44.81755870",
                "longitude": "8.70466270",
                "type": "province",
                "cities": []
            },
            {
                "id": 1672,
                "name": "Ancona",
                "iso2": "AN",
                "latitude": "43.54932450",
                "longitude": "13.26634790",
                "type": "province",
                "cities": []
            },
            {
                "id": 1716,
                "name": "Aosta Valley",
                "iso2": "23",
                "latitude": "45.73888780",
                "longitude": "7.42618660",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 135416,
                        "name": "Allein",
                        "latitude": "45.80723000",
                        "longitude": "7.27262000"
                    },
                    {
                        "id": 135511,
                        "name": "Antagnod",
                        "latitude": "45.81484000",
                        "longitude": "7.68931000"
                    },
                    {
                        "id": 135516,
                        "name": "Antey-Saint-Andrè",
                        "latitude": "45.80603000",
                        "longitude": "7.58666000"
                    },
                    {
                        "id": 135530,
                        "name": "Aosta",
                        "latitude": "45.73764000",
                        "longitude": "7.31722000"
                    },
                    {
                        "id": 135618,
                        "name": "Arnad",
                        "latitude": "45.64726000",
                        "longitude": "7.71701000"
                    },
                    {
                        "id": 135645,
                        "name": "Arvier",
                        "latitude": "45.70205000",
                        "longitude": "7.16267000"
                    },
                    {
                        "id": 135712,
                        "name": "Avise",
                        "latitude": "45.70886000",
                        "longitude": "7.13990000"
                    },
                    {
                        "id": 135716,
                        "name": "Ayas",
                        "latitude": "45.81506000",
                        "longitude": "7.68911000"
                    },
                    {
                        "id": 135717,
                        "name": "Aymavilles",
                        "latitude": "45.70130000",
                        "longitude": "7.24683000"
                    },
                    {
                        "id": 135838,
                        "name": "Bard",
                        "latitude": "45.60936000",
                        "longitude": "7.74491000"
                    },
                    {
                        "id": 135997,
                        "name": "Berriat",
                        "latitude": "45.70729000",
                        "longitude": "7.67617000"
                    },
                    {
                        "id": 136055,
                        "name": "Bionaz",
                        "latitude": "45.87356000",
                        "longitude": "7.42310000"
                    },
                    {
                        "id": 136378,
                        "name": "Brusson",
                        "latitude": "45.75926000",
                        "longitude": "7.72899000"
                    },
                    {
                        "id": 137627,
                        "name": "Challand-Saint-Anselme",
                        "latitude": "45.71456000",
                        "longitude": "7.73451000"
                    },
                    {
                        "id": 137628,
                        "name": "Challand-Saint-Victor",
                        "latitude": "45.69046000",
                        "longitude": "7.70471000"
                    },
                    {
                        "id": 137629,
                        "name": "Chambave",
                        "latitude": "45.74426000",
                        "longitude": "7.54931000"
                    },
                    {
                        "id": 137630,
                        "name": "Chamois",
                        "latitude": "45.83886000",
                        "longitude": "7.61871000"
                    },
                    {
                        "id": 137631,
                        "name": "Champdepraz",
                        "latitude": "45.68526000",
                        "longitude": "7.65681000"
                    },
                    {
                        "id": 137632,
                        "name": "Champorcher",
                        "latitude": "45.62376000",
                        "longitude": "7.62151000"
                    },
                    {
                        "id": 137633,
                        "name": "Charvensod",
                        "latitude": "45.72025000",
                        "longitude": "7.32433000"
                    },
                    {
                        "id": 137634,
                        "name": "Chatillon",
                        "latitude": "45.74991000",
                        "longitude": "7.61668000"
                    },
                    {
                        "id": 137635,
                        "name": "Chef-Lieu",
                        "latitude": "45.75091000",
                        "longitude": "7.35372000"
                    },
                    {
                        "id": 137841,
                        "name": "Cogne",
                        "latitude": "45.60742000",
                        "longitude": "7.35803000"
                    },
                    {
                        "id": 138115,
                        "name": "Courmayeur",
                        "latitude": "45.79659000",
                        "longitude": "6.96893000"
                    },
                    {
                        "id": 138301,
                        "name": "Donnas",
                        "latitude": "45.60286000",
                        "longitude": "7.77491000"
                    },
                    {
                        "id": 138321,
                        "name": "Doues",
                        "latitude": "45.81916000",
                        "longitude": "7.30600000"
                    },
                    {
                        "id": 138355,
                        "name": "Emarese",
                        "latitude": "45.72489000",
                        "longitude": "7.68976000"
                    },
                    {
                        "id": 138388,
                        "name": "Etroubles",
                        "latitude": "45.82082000",
                        "longitude": "7.23137000"
                    },
                    {
                        "id": 138765,
                        "name": "Fénis",
                        "latitude": "45.73469000",
                        "longitude": "7.49544000"
                    },
                    {
                        "id": 138591,
                        "name": "Fontainemore",
                        "latitude": "45.64746000",
                        "longitude": "7.85952000"
                    },
                    {
                        "id": 138771,
                        "name": "Gaby",
                        "latitude": "45.71300000",
                        "longitude": "7.88224000"
                    },
                    {
                        "id": 138960,
                        "name": "Gignod",
                        "latitude": "45.77996000",
                        "longitude": "7.29640000"
                    },
                    {
                        "id": 139063,
                        "name": "Grand Brissogne",
                        "latitude": "45.72566000",
                        "longitude": "7.39260000"
                    },
                    {
                        "id": 139089,
                        "name": "Gressan",
                        "latitude": "45.72050000",
                        "longitude": "7.29311000"
                    },
                    {
                        "id": 139090,
                        "name": "Gressoney-La-Trinitè",
                        "latitude": "45.82967000",
                        "longitude": "7.82321000"
                    },
                    {
                        "id": 139091,
                        "name": "Gressoney-Saint-Jean",
                        "latitude": "45.77272000",
                        "longitude": "7.82802000"
                    },
                    {
                        "id": 139187,
                        "name": "Hone",
                        "latitude": "45.61356000",
                        "longitude": "7.73851000"
                    },
                    {
                        "id": 139211,
                        "name": "Introd",
                        "latitude": "45.69306000",
                        "longitude": "7.18240000"
                    },
                    {
                        "id": 139262,
                        "name": "Issime",
                        "latitude": "45.68546000",
                        "longitude": "7.85411000"
                    },
                    {
                        "id": 139264,
                        "name": "Issogne",
                        "latitude": "45.65496000",
                        "longitude": "7.68571000"
                    },
                    {
                        "id": 139283,
                        "name": "Jovencan",
                        "latitude": "45.71486000",
                        "longitude": "7.27260000"
                    },
                    {
                        "id": 139290,
                        "name": "La Cretaz-Roisan",
                        "latitude": "45.78396000",
                        "longitude": "7.31310000"
                    },
                    {
                        "id": 139294,
                        "name": "La Magdeleine",
                        "latitude": "45.80996000",
                        "longitude": "7.61871000"
                    },
                    {
                        "id": 139299,
                        "name": "La Place",
                        "latitude": "45.65414000",
                        "longitude": "7.68414000"
                    },
                    {
                        "id": 139303,
                        "name": "La Salle",
                        "latitude": "45.74497000",
                        "longitude": "7.07295000"
                    },
                    {
                        "id": 139306,
                        "name": "La Thuile",
                        "latitude": "45.71366000",
                        "longitude": "6.95099000"
                    },
                    {
                        "id": 139383,
                        "name": "Lassolaz",
                        "latitude": "45.73851000",
                        "longitude": "7.58883000"
                    },
                    {
                        "id": 139514,
                        "name": "Lillianes",
                        "latitude": "45.62948000",
                        "longitude": "7.84126000"
                    },
                    {
                        "id": 140288,
                        "name": "Mongnod",
                        "latitude": "45.80549000",
                        "longitude": "7.56806000"
                    },
                    {
                        "id": 140337,
                        "name": "Montan-Angelin-Arensod",
                        "latitude": "45.72820000",
                        "longitude": "7.27647000"
                    },
                    {
                        "id": 140576,
                        "name": "Montjovet",
                        "latitude": "45.70796000",
                        "longitude": "7.67411000"
                    },
                    {
                        "id": 140613,
                        "name": "Morgex",
                        "latitude": "45.75664000",
                        "longitude": "7.04123000"
                    },
                    {
                        "id": 140860,
                        "name": "Nus",
                        "latitude": "45.74026000",
                        "longitude": "7.46660000"
                    },
                    {
                        "id": 140907,
                        "name": "Ollomont",
                        "latitude": "45.84976000",
                        "longitude": "7.31060000"
                    },
                    {
                        "id": 141060,
                        "name": "Oyace",
                        "latitude": "45.85116000",
                        "longitude": "7.38300000"
                    },
                    {
                        "id": 58293,
                        "name": "Paquier",
                        "latitude": "45.87879000",
                        "longitude": "7.62575000"
                    },
                    {
                        "id": 58430,
                        "name": "Perloz",
                        "latitude": "45.61386000",
                        "longitude": "7.80811000"
                    },
                    {
                        "id": 58476,
                        "name": "Petit Fenis",
                        "latitude": "45.75115000",
                        "longitude": "7.46391000"
                    },
                    {
                        "id": 58732,
                        "name": "Plan d'Introd",
                        "latitude": "45.69203000",
                        "longitude": "7.18328000"
                    },
                    {
                        "id": 58796,
                        "name": "Pollein",
                        "latitude": "45.72780000",
                        "longitude": "7.35146000"
                    },
                    {
                        "id": 58827,
                        "name": "Pont-Bozet",
                        "latitude": "45.60726000",
                        "longitude": "7.68641000"
                    },
                    {
                        "id": 58829,
                        "name": "Pont-Saint-Martin",
                        "latitude": "45.59536000",
                        "longitude": "7.79451000"
                    },
                    {
                        "id": 58881,
                        "name": "Pontey",
                        "latitude": "45.73886000",
                        "longitude": "7.58831000"
                    },
                    {
                        "id": 59193,
                        "name": "Prè Saint Didier",
                        "latitude": "45.76416000",
                        "longitude": "6.98579000"
                    },
                    {
                        "id": 59225,
                        "name": "Quart",
                        "latitude": "45.74096000",
                        "longitude": "7.41520000"
                    },
                    {
                        "id": 59244,
                        "name": "Quincod",
                        "latitude": "45.71513000",
                        "longitude": "7.73495000"
                    },
                    {
                        "id": 59350,
                        "name": "Rhemes-Notre-Dame",
                        "latitude": "45.56965000",
                        "longitude": "7.11870000"
                    },
                    {
                        "id": 59351,
                        "name": "Rhemes-Saint-Georges",
                        "latitude": "45.65226000",
                        "longitude": "7.15440000"
                    },
                    {
                        "id": 59727,
                        "name": "Saint Marcel",
                        "latitude": "45.73146000",
                        "longitude": "7.44820000"
                    },
                    {
                        "id": 59728,
                        "name": "Saint Maurice",
                        "latitude": "45.71771000",
                        "longitude": "7.25547000"
                    },
                    {
                        "id": 59729,
                        "name": "Saint-Christophe",
                        "latitude": "45.75406000",
                        "longitude": "7.34720000"
                    },
                    {
                        "id": 59730,
                        "name": "Saint-Denis",
                        "latitude": "45.75256000",
                        "longitude": "7.55531000"
                    },
                    {
                        "id": 59731,
                        "name": "Saint-Nicolas",
                        "latitude": "45.71656000",
                        "longitude": "7.16670000"
                    },
                    {
                        "id": 59732,
                        "name": "Saint-Oyen",
                        "latitude": "45.82439000",
                        "longitude": "7.21372000"
                    },
                    {
                        "id": 59733,
                        "name": "Saint-Pierre",
                        "latitude": "45.71153000",
                        "longitude": "7.22683000"
                    },
                    {
                        "id": 59734,
                        "name": "Saint-Rhémy",
                        "latitude": "45.83553000",
                        "longitude": "7.18393000"
                    },
                    {
                        "id": 59735,
                        "name": "Saint-Vincent",
                        "latitude": "45.75082000",
                        "longitude": "7.64815000"
                    },
                    {
                        "id": 60030,
                        "name": "San Leonardo",
                        "latitude": "45.82366000",
                        "longitude": "7.18140000"
                    },
                    {
                        "id": 61328,
                        "name": "Torgnon",
                        "latitude": "45.80616000",
                        "longitude": "7.56980000"
                    },
                    {
                        "id": 61677,
                        "name": "Valgrisenche",
                        "latitude": "45.63036000",
                        "longitude": "7.06400000"
                    },
                    {
                        "id": 61694,
                        "name": "Valle d'Aosta",
                        "latitude": "45.76667000",
                        "longitude": "7.41667000"
                    },
                    {
                        "id": 61735,
                        "name": "Valpelline",
                        "latitude": "45.82486000",
                        "longitude": "7.32550000"
                    },
                    {
                        "id": 61738,
                        "name": "Valsavarenche",
                        "latitude": "45.59186000",
                        "longitude": "7.21000000"
                    },
                    {
                        "id": 61744,
                        "name": "Valtournenche",
                        "latitude": "45.87607000",
                        "longitude": "7.62430000"
                    },
                    {
                        "id": 61865,
                        "name": "Verrayes",
                        "latitude": "45.76326000",
                        "longitude": "7.53460000"
                    },
                    {
                        "id": 61866,
                        "name": "Verres",
                        "latitude": "45.66656000",
                        "longitude": "7.68911000"
                    },
                    {
                        "id": 62045,
                        "name": "Villa-Nabian",
                        "latitude": "45.68970000",
                        "longitude": "7.70470000"
                    },
                    {
                        "id": 62074,
                        "name": "Villair-Amerique",
                        "latitude": "45.74793000",
                        "longitude": "7.38982000"
                    },
                    {
                        "id": 62147,
                        "name": "Ville Sur Sarre",
                        "latitude": "45.73339000",
                        "longitude": "7.25857000"
                    },
                    {
                        "id": 62148,
                        "name": "Villefranche",
                        "latitude": "45.74064000",
                        "longitude": "7.41598000"
                    },
                    {
                        "id": 62149,
                        "name": "Villeneuve",
                        "latitude": "45.70201000",
                        "longitude": "7.20682000"
                    }
                ]
            },
            {
                "id": 1688,
                "name": "Apulia",
                "iso2": "75",
                "latitude": "40.79283930",
                "longitude": "17.10119310",
                "type": "region",
                "cities": [
                    {
                        "id": 135247,
                        "name": "Accadia",
                        "latitude": "41.15768000",
                        "longitude": "15.33100000"
                    },
                    {
                        "id": 135272,
                        "name": "Acquarica del Capo",
                        "latitude": "39.90979000",
                        "longitude": "18.24680000"
                    },
                    {
                        "id": 135281,
                        "name": "Acquaviva delle Fonti",
                        "latitude": "40.89704000",
                        "longitude": "16.84330000"
                    },
                    {
                        "id": 135286,
                        "name": "Adelfia",
                        "latitude": "41.00330000",
                        "longitude": "16.87208000"
                    },
                    {
                        "id": 135365,
                        "name": "Alberobello",
                        "latitude": "40.78448000",
                        "longitude": "17.23618000"
                    },
                    {
                        "id": 135366,
                        "name": "Alberona",
                        "latitude": "41.43225000",
                        "longitude": "15.12304000"
                    },
                    {
                        "id": 135397,
                        "name": "Alessano",
                        "latitude": "39.89381000",
                        "longitude": "18.33221000"
                    },
                    {
                        "id": 135398,
                        "name": "Alezio",
                        "latitude": "40.06226000",
                        "longitude": "18.05712000"
                    },
                    {
                        "id": 135418,
                        "name": "Alliste",
                        "latitude": "39.94803000",
                        "longitude": "18.08971000"
                    },
                    {
                        "id": 135430,
                        "name": "Altamura",
                        "latitude": "40.82664000",
                        "longitude": "16.54952000"
                    },
                    {
                        "id": 135486,
                        "name": "Andrano",
                        "latitude": "39.98546000",
                        "longitude": "18.38232000"
                    },
                    {
                        "id": 135525,
                        "name": "Anzano di Puglia",
                        "latitude": "41.12162000",
                        "longitude": "15.28688000"
                    },
                    {
                        "id": 135540,
                        "name": "Apricena",
                        "latitude": "41.78629000",
                        "longitude": "15.44394000"
                    },
                    {
                        "id": 135549,
                        "name": "Aradeo",
                        "latitude": "40.12921000",
                        "longitude": "18.12951000"
                    },
                    {
                        "id": 135621,
                        "name": "Arnesano",
                        "latitude": "40.33679000",
                        "longitude": "18.09145000"
                    },
                    {
                        "id": 135656,
                        "name": "Ascoli Satriano",
                        "latitude": "41.20365000",
                        "longitude": "15.56646000"
                    },
                    {
                        "id": 135703,
                        "name": "Avetrana",
                        "latitude": "40.35070000",
                        "longitude": "17.73260000"
                    },
                    {
                        "id": 135771,
                        "name": "Bagnolo del Salento",
                        "latitude": "40.14908000",
                        "longitude": "18.35208000"
                    },
                    {
                        "id": 135853,
                        "name": "Bari",
                        "latitude": "40.93333000",
                        "longitude": "16.66667000"
                    },
                    {
                        "id": 136043,
                        "name": "Biccari",
                        "latitude": "41.39736000",
                        "longitude": "15.19644000"
                    },
                    {
                        "id": 136053,
                        "name": "Binetto",
                        "latitude": "41.02343000",
                        "longitude": "16.70988000"
                    },
                    {
                        "id": 136067,
                        "name": "Bitetto",
                        "latitude": "41.04146000",
                        "longitude": "16.74806000"
                    },
                    {
                        "id": 136068,
                        "name": "Bitonto",
                        "latitude": "41.11006000",
                        "longitude": "16.69086000"
                    },
                    {
                        "id": 136069,
                        "name": "Bitritto",
                        "latitude": "41.04336000",
                        "longitude": "16.82682000"
                    },
                    {
                        "id": 136153,
                        "name": "Borgagne",
                        "latitude": "40.24108000",
                        "longitude": "18.37661000"
                    },
                    {
                        "id": 136257,
                        "name": "Botrugno",
                        "latitude": "40.06359000",
                        "longitude": "18.32254000"
                    },
                    {
                        "id": 136272,
                        "name": "Bovino",
                        "latitude": "41.24916000",
                        "longitude": "15.33948000"
                    },
                    {
                        "id": 136334,
                        "name": "Brindisi",
                        "latitude": "40.63215000",
                        "longitude": "17.93607000"
                    },
                    {
                        "id": 136471,
                        "name": "Cagnano Varano",
                        "latitude": "41.82832000",
                        "longitude": "15.77203000"
                    },
                    {
                        "id": 136528,
                        "name": "Calimera",
                        "latitude": "40.24948000",
                        "longitude": "18.27982000"
                    },
                    {
                        "id": 136616,
                        "name": "Campi Salentina",
                        "latitude": "40.39747000",
                        "longitude": "18.02141000"
                    },
                    {
                        "id": 136697,
                        "name": "Candela",
                        "latitude": "41.13601000",
                        "longitude": "15.51537000"
                    },
                    {
                        "id": 136727,
                        "name": "Cannole",
                        "latitude": "40.16592000",
                        "longitude": "18.36456000"
                    },
                    {
                        "id": 136769,
                        "name": "Capirro",
                        "latitude": "41.25403000",
                        "longitude": "16.42242000"
                    },
                    {
                        "id": 136804,
                        "name": "Caprarica di Lecce",
                        "latitude": "40.26060000",
                        "longitude": "18.24426000"
                    },
                    {
                        "id": 136826,
                        "name": "Capurso",
                        "latitude": "41.04598000",
                        "longitude": "16.92168000"
                    },
                    {
                        "id": 136834,
                        "name": "Carapelle",
                        "latitude": "41.36365000",
                        "longitude": "15.69384000"
                    },
                    {
                        "id": 136884,
                        "name": "Carlantino",
                        "latitude": "41.59388000",
                        "longitude": "14.97681000"
                    },
                    {
                        "id": 136891,
                        "name": "Carmiano",
                        "latitude": "40.34404000",
                        "longitude": "18.04195000"
                    },
                    {
                        "id": 136903,
                        "name": "Carosino",
                        "latitude": "40.46538000",
                        "longitude": "17.39857000"
                    },
                    {
                        "id": 136904,
                        "name": "Carovigno",
                        "latitude": "40.70626000",
                        "longitude": "17.65847000"
                    },
                    {
                        "id": 136915,
                        "name": "Carpignano Salentino",
                        "latitude": "40.19537000",
                        "longitude": "18.33826000"
                    },
                    {
                        "id": 136921,
                        "name": "Carpino",
                        "latitude": "41.84450000",
                        "longitude": "15.85712000"
                    },
                    {
                        "id": 136996,
                        "name": "Casalini",
                        "latitude": "40.73777000",
                        "longitude": "17.47062000"
                    },
                    {
                        "id": 137003,
                        "name": "Casalnuovo Monterotaro",
                        "latitude": "41.61942000",
                        "longitude": "15.10411000"
                    },
                    {
                        "id": 137011,
                        "name": "Casalvecchio di Puglia",
                        "latitude": "41.59470000",
                        "longitude": "15.10999000"
                    },
                    {
                        "id": 137016,
                        "name": "Casamassella",
                        "latitude": "40.11424000",
                        "longitude": "18.45100000"
                    },
                    {
                        "id": 137017,
                        "name": "Casamassima",
                        "latitude": "40.95653000",
                        "longitude": "16.92075000"
                    },
                    {
                        "id": 137030,
                        "name": "Casarano",
                        "latitude": "40.01131000",
                        "longitude": "18.16237000"
                    },
                    {
                        "id": 137101,
                        "name": "Cassano delle Murge",
                        "latitude": "40.89112000",
                        "longitude": "16.76531000"
                    },
                    {
                        "id": 137215,
                        "name": "Castellana",
                        "latitude": "40.88643000",
                        "longitude": "17.16549000"
                    },
                    {
                        "id": 137217,
                        "name": "Castellaneta",
                        "latitude": "40.62794000",
                        "longitude": "16.93290000"
                    },
                    {
                        "id": 137267,
                        "name": "Castelluccio dei Sauri",
                        "latitude": "41.30460000",
                        "longitude": "15.47561000"
                    },
                    {
                        "id": 137266,
                        "name": "Castelluccio Valmaggiore",
                        "latitude": "41.34290000",
                        "longitude": "15.19944000"
                    },
                    {
                        "id": 137298,
                        "name": "Castelnuovo della Daunia",
                        "latitude": "41.58139000",
                        "longitude": "15.11796000"
                    },
                    {
                        "id": 137338,
                        "name": "Castiglione",
                        "latitude": "39.98333000",
                        "longitude": "18.35000000"
                    },
                    {
                        "id": 137372,
                        "name": "Castri di Lecce",
                        "latitude": "40.27360000",
                        "longitude": "18.26240000"
                    },
                    {
                        "id": 137373,
                        "name": "Castrignano De' Greci",
                        "latitude": "40.17342000",
                        "longitude": "18.29643000"
                    },
                    {
                        "id": 137374,
                        "name": "Castrignano del Capo",
                        "latitude": "39.83280000",
                        "longitude": "18.35087000"
                    },
                    {
                        "id": 137376,
                        "name": "Castro",
                        "latitude": "40.00702000",
                        "longitude": "18.42573000"
                    },
                    {
                        "id": 137382,
                        "name": "Castromediano",
                        "latitude": "40.32803000",
                        "longitude": "18.17877000"
                    },
                    {
                        "id": 137418,
                        "name": "Cavallino",
                        "latitude": "40.31020000",
                        "longitude": "18.20221000"
                    },
                    {
                        "id": 137461,
                        "name": "Ceglie Messapica",
                        "latitude": "40.64620000",
                        "longitude": "17.51661000"
                    },
                    {
                        "id": 137464,
                        "name": "Celenza Valfortore",
                        "latitude": "41.56048000",
                        "longitude": "14.97898000"
                    },
                    {
                        "id": 137469,
                        "name": "Cellamare",
                        "latitude": "41.01969000",
                        "longitude": "16.92741000"
                    },
                    {
                        "id": 137476,
                        "name": "Celle di San Vito",
                        "latitude": "41.32593000",
                        "longitude": "15.18104000"
                    },
                    {
                        "id": 137480,
                        "name": "Cellino San Marco",
                        "latitude": "40.47133000",
                        "longitude": "17.96427000"
                    },
                    {
                        "id": 137544,
                        "name": "Cerfignano",
                        "latitude": "40.06107000",
                        "longitude": "18.44291000"
                    },
                    {
                        "id": 137550,
                        "name": "Cerignola",
                        "latitude": "41.26523000",
                        "longitude": "15.89559000"
                    },
                    {
                        "id": 137673,
                        "name": "Chieuti",
                        "latitude": "41.84486000",
                        "longitude": "15.16681000"
                    },
                    {
                        "id": 137763,
                        "name": "Cisternino",
                        "latitude": "40.74326000",
                        "longitude": "17.42587000"
                    },
                    {
                        "id": 137885,
                        "name": "Collemeto",
                        "latitude": "40.20885000",
                        "longitude": "18.10285000"
                    },
                    {
                        "id": 137887,
                        "name": "Collepasso",
                        "latitude": "40.07115000",
                        "longitude": "18.16222000"
                    },
                    {
                        "id": 137983,
                        "name": "Conversano",
                        "latitude": "40.96836000",
                        "longitude": "17.11329000"
                    },
                    {
                        "id": 137986,
                        "name": "Copertino",
                        "latitude": "40.26821000",
                        "longitude": "18.05430000"
                    },
                    {
                        "id": 137991,
                        "name": "Corato",
                        "latitude": "41.15171000",
                        "longitude": "16.41143000"
                    },
                    {
                        "id": 138014,
                        "name": "Corigliano d'Otranto",
                        "latitude": "40.15925000",
                        "longitude": "18.25598000"
                    },
                    {
                        "id": 138047,
                        "name": "Corsano",
                        "latitude": "39.88911000",
                        "longitude": "18.36747000"
                    },
                    {
                        "id": 138119,
                        "name": "Cozzana",
                        "latitude": "40.92025000",
                        "longitude": "17.22259000"
                    },
                    {
                        "id": 138157,
                        "name": "Crispiano",
                        "latitude": "40.60379000",
                        "longitude": "17.23290000"
                    },
                    {
                        "id": 138206,
                        "name": "Cursi",
                        "latitude": "40.14847000",
                        "longitude": "18.31605000"
                    },
                    {
                        "id": 138219,
                        "name": "Cutrofiano",
                        "latitude": "40.12616000",
                        "longitude": "18.20260000"
                    },
                    {
                        "id": 138244,
                        "name": "Deliceto",
                        "latitude": "41.22289000",
                        "longitude": "15.38447000"
                    },
                    {
                        "id": 138249,
                        "name": "Depressa",
                        "latitude": "39.95908000",
                        "longitude": "18.36174000"
                    },
                    {
                        "id": 138270,
                        "name": "Diso",
                        "latitude": "40.00915000",
                        "longitude": "18.39144000"
                    },
                    {
                        "id": 138371,
                        "name": "Erchie",
                        "latitude": "40.43609000",
                        "longitude": "17.73610000"
                    },
                    {
                        "id": 138404,
                        "name": "Faeto",
                        "latitude": "41.32489000",
                        "longitude": "15.16045000"
                    },
                    {
                        "id": 138407,
                        "name": "Faggiano",
                        "latitude": "40.41616000",
                        "longitude": "17.38861000"
                    },
                    {
                        "id": 138454,
                        "name": "Fasano",
                        "latitude": "40.83625000",
                        "longitude": "17.36007000"
                    },
                    {
                        "id": 138473,
                        "name": "Felline",
                        "latitude": "39.93651000",
                        "longitude": "18.11822000"
                    },
                    {
                        "id": 138572,
                        "name": "Foggia",
                        "latitude": "41.45845000",
                        "longitude": "15.55188000"
                    },
                    {
                        "id": 138687,
                        "name": "Fragagnano",
                        "latitude": "40.43020000",
                        "longitude": "17.47553000"
                    },
                    {
                        "id": 138694,
                        "name": "Francavilla Fontana",
                        "latitude": "40.53123000",
                        "longitude": "17.58522000"
                    },
                    {
                        "id": 138783,
                        "name": "Gagliano del Capo",
                        "latitude": "39.84323000",
                        "longitude": "18.36962000"
                    },
                    {
                        "id": 138795,
                        "name": "Galatina",
                        "latitude": "40.17416000",
                        "longitude": "18.17032000"
                    },
                    {
                        "id": 138796,
                        "name": "Galatone",
                        "latitude": "40.14673000",
                        "longitude": "18.06937000"
                    },
                    {
                        "id": 138813,
                        "name": "Gallipoli",
                        "latitude": "40.05594000",
                        "longitude": "17.99088000"
                    },
                    {
                        "id": 138823,
                        "name": "Galugnano",
                        "latitude": "40.25601000",
                        "longitude": "18.21473000"
                    },
                    {
                        "id": 138891,
                        "name": "Gemini",
                        "latitude": "39.91134000",
                        "longitude": "18.18742000"
                    },
                    {
                        "id": 138966,
                        "name": "Ginosa",
                        "latitude": "40.57690000",
                        "longitude": "16.75655000"
                    },
                    {
                        "id": 138971,
                        "name": "Gioia del Colle",
                        "latitude": "40.79968000",
                        "longitude": "16.92298000"
                    },
                    {
                        "id": 138975,
                        "name": "Giorgilorio",
                        "latitude": "40.38683000",
                        "longitude": "18.14873000"
                    },
                    {
                        "id": 138979,
                        "name": "Giovinazzo",
                        "latitude": "41.18500000",
                        "longitude": "16.67054000"
                    },
                    {
                        "id": 138987,
                        "name": "Giuggianello",
                        "latitude": "40.09383000",
                        "longitude": "18.36894000"
                    },
                    {
                        "id": 138996,
                        "name": "Giurdignano",
                        "latitude": "40.12367000",
                        "longitude": "18.43155000"
                    },
                    {
                        "id": 139083,
                        "name": "Gravina in Puglia",
                        "latitude": "40.81748000",
                        "longitude": "16.41915000"
                    },
                    {
                        "id": 139121,
                        "name": "Grottaglie",
                        "latitude": "40.53694000",
                        "longitude": "17.43723000"
                    },
                    {
                        "id": 139139,
                        "name": "Grumo Appula",
                        "latitude": "41.01089000",
                        "longitude": "16.70844000"
                    },
                    {
                        "id": 139144,
                        "name": "Guagnano",
                        "latitude": "40.40123000",
                        "longitude": "17.94902000"
                    },
                    {
                        "id": 139230,
                        "name": "Ischitella",
                        "latitude": "41.90434000",
                        "longitude": "15.89945000"
                    },
                    {
                        "id": 139255,
                        "name": "Isole Tremiti",
                        "latitude": "42.12085000",
                        "longitude": "15.50424000"
                    },
                    {
                        "id": 139300,
                        "name": "La Rosa",
                        "latitude": "40.60674000",
                        "longitude": "17.95207000"
                    },
                    {
                        "id": 139345,
                        "name": "Lamie",
                        "latitude": "41.03364000",
                        "longitude": "16.87559000"
                    },
                    {
                        "id": 139346,
                        "name": "Lamie di Olimpie-Selva",
                        "latitude": "40.81714000",
                        "longitude": "17.33478000"
                    },
                    {
                        "id": 139388,
                        "name": "Laterza",
                        "latitude": "40.62881000",
                        "longitude": "16.79947000"
                    },
                    {
                        "id": 139389,
                        "name": "Latiano",
                        "latitude": "40.55052000",
                        "longitude": "17.71856000"
                    },
                    {
                        "id": 139430,
                        "name": "Lecce",
                        "latitude": "40.35481000",
                        "longitude": "18.17244000"
                    },
                    {
                        "id": 139458,
                        "name": "Leporano",
                        "latitude": "40.38218000",
                        "longitude": "17.33426000"
                    },
                    {
                        "id": 139459,
                        "name": "Leporano Marina",
                        "latitude": "40.37860000",
                        "longitude": "17.30960000"
                    },
                    {
                        "id": 139460,
                        "name": "Lequile",
                        "latitude": "40.30583000",
                        "longitude": "18.14022000"
                    },
                    {
                        "id": 139469,
                        "name": "Lesina",
                        "latitude": "41.86125000",
                        "longitude": "15.35322000"
                    },
                    {
                        "id": 139481,
                        "name": "Leuca",
                        "latitude": "39.79949000",
                        "longitude": "18.35815000"
                    },
                    {
                        "id": 139486,
                        "name": "Leverano",
                        "latitude": "40.28852000",
                        "longitude": "17.99650000"
                    },
                    {
                        "id": 139554,
                        "name": "Lizzanello",
                        "latitude": "40.30475000",
                        "longitude": "18.22283000"
                    },
                    {
                        "id": 139555,
                        "name": "Lizzano",
                        "latitude": "40.39301000",
                        "longitude": "17.44571000"
                    },
                    {
                        "id": 139565,
                        "name": "Locorotondo",
                        "latitude": "40.75661000",
                        "longitude": "17.32392000"
                    },
                    {
                        "id": 139616,
                        "name": "Loseto",
                        "latitude": "41.04214000",
                        "longitude": "16.84917000"
                    },
                    {
                        "id": 139631,
                        "name": "Lucera",
                        "latitude": "41.50550000",
                        "longitude": "15.33910000"
                    },
                    {
                        "id": 139641,
                        "name": "Lucugnano",
                        "latitude": "39.93490000",
                        "longitude": "18.32174000"
                    },
                    {
                        "id": 139722,
                        "name": "Magliano",
                        "latitude": "40.33740000",
                        "longitude": "18.06287000"
                    },
                    {
                        "id": 139731,
                        "name": "Maglie",
                        "latitude": "40.12069000",
                        "longitude": "18.29797000"
                    },
                    {
                        "id": 139791,
                        "name": "Manduria",
                        "latitude": "40.39899000",
                        "longitude": "17.63726000"
                    },
                    {
                        "id": 139796,
                        "name": "Manfredonia",
                        "latitude": "41.63065000",
                        "longitude": "15.91876000"
                    },
                    {
                        "id": 139886,
                        "name": "Marina di Ginosa",
                        "latitude": "40.42833000",
                        "longitude": "16.88003000"
                    },
                    {
                        "id": 139901,
                        "name": "Mariotto",
                        "latitude": "41.05028000",
                        "longitude": "16.56142000"
                    },
                    {
                        "id": 139902,
                        "name": "Marittima",
                        "latitude": "39.99609000",
                        "longitude": "18.39895000"
                    },
                    {
                        "id": 139926,
                        "name": "Martano",
                        "latitude": "40.20205000",
                        "longitude": "18.30193000"
                    },
                    {
                        "id": 139932,
                        "name": "Martignano",
                        "latitude": "40.23821000",
                        "longitude": "18.25602000"
                    },
                    {
                        "id": 139933,
                        "name": "Martina Franca",
                        "latitude": "40.70355000",
                        "longitude": "17.33814000"
                    },
                    {
                        "id": 139942,
                        "name": "Maruggio",
                        "latitude": "40.32054000",
                        "longitude": "17.57052000"
                    },
                    {
                        "id": 139977,
                        "name": "Massafra",
                        "latitude": "40.58618000",
                        "longitude": "17.11635000"
                    },
                    {
                        "id": 139994,
                        "name": "Materdomini",
                        "latitude": "40.65571000",
                        "longitude": "17.95949000"
                    },
                    {
                        "id": 139997,
                        "name": "Matino",
                        "latitude": "40.03083000",
                        "longitude": "18.13630000"
                    },
                    {
                        "id": 140001,
                        "name": "Mattinata",
                        "latitude": "41.71112000",
                        "longitude": "16.05087000"
                    },
                    {
                        "id": 140041,
                        "name": "Melendugno",
                        "latitude": "40.27252000",
                        "longitude": "18.33798000"
                    },
                    {
                        "id": 140049,
                        "name": "Melissano",
                        "latitude": "39.97315000",
                        "longitude": "18.12113000"
                    },
                    {
                        "id": 140056,
                        "name": "Melpignano",
                        "latitude": "40.15624000",
                        "longitude": "18.29194000"
                    },
                    {
                        "id": 140085,
                        "name": "Merine",
                        "latitude": "40.33418000",
                        "longitude": "18.22383000"
                    },
                    {
                        "id": 140091,
                        "name": "Mesagne",
                        "latitude": "40.55851000",
                        "longitude": "17.80774000"
                    },
                    {
                        "id": 140131,
                        "name": "Miggiano",
                        "latitude": "39.96180000",
                        "longitude": "18.31119000"
                    },
                    {
                        "id": 140160,
                        "name": "Minervino di Lecce",
                        "latitude": "40.09025000",
                        "longitude": "18.42139000"
                    },
                    {
                        "id": 140192,
                        "name": "Modugno",
                        "latitude": "41.08433000",
                        "longitude": "16.78342000"
                    },
                    {
                        "id": 140209,
                        "name": "Mola di Bari",
                        "latitude": "41.05997000",
                        "longitude": "17.09001000"
                    },
                    {
                        "id": 140213,
                        "name": "Molfetta",
                        "latitude": "41.20036000",
                        "longitude": "16.59905000"
                    },
                    {
                        "id": 140296,
                        "name": "Monopoli",
                        "latitude": "40.94918000",
                        "longitude": "17.29717000"
                    },
                    {
                        "id": 140315,
                        "name": "Montalbano",
                        "latitude": "40.77827000",
                        "longitude": "17.48157000"
                    },
                    {
                        "id": 140379,
                        "name": "Monte Sant'Angelo",
                        "latitude": "41.70530000",
                        "longitude": "15.96068000"
                    },
                    {
                        "id": 140462,
                        "name": "Monteiasi",
                        "latitude": "40.49992000",
                        "longitude": "17.38260000"
                    },
                    {
                        "id": 140471,
                        "name": "Monteleone di Puglia",
                        "latitude": "41.16711000",
                        "longitude": "15.25822000"
                    },
                    {
                        "id": 140491,
                        "name": "Montemesola",
                        "latitude": "40.56760000",
                        "longitude": "17.33665000"
                    },
                    {
                        "id": 140508,
                        "name": "Monteparano",
                        "latitude": "40.44335000",
                        "longitude": "17.41308000"
                    },
                    {
                        "id": 140520,
                        "name": "Monteroni di Lecce",
                        "latitude": "40.31929000",
                        "longitude": "18.09163000"
                    },
                    {
                        "id": 140530,
                        "name": "Montesano Salentino",
                        "latitude": "39.97544000",
                        "longitude": "18.32277000"
                    },
                    {
                        "id": 140533,
                        "name": "Montesardo",
                        "latitude": "39.87572000",
                        "longitude": "18.33967000"
                    },
                    {
                        "id": 140555,
                        "name": "Monti d'Arena-Bosco Caggione",
                        "latitude": "40.35510000",
                        "longitude": "17.36432000"
                    },
                    {
                        "id": 140604,
                        "name": "Morciano di Leuca",
                        "latitude": "39.84719000",
                        "longitude": "18.31089000"
                    },
                    {
                        "id": 140659,
                        "name": "Motta Montecorvino",
                        "latitude": "41.50743000",
                        "longitude": "15.11414000"
                    },
                    {
                        "id": 140670,
                        "name": "Mottola",
                        "latitude": "40.63890000",
                        "longitude": "17.03432000"
                    },
                    {
                        "id": 140693,
                        "name": "Muro Leccese",
                        "latitude": "40.10286000",
                        "longitude": "18.33674000"
                    },
                    {
                        "id": 140718,
                        "name": "Nardò",
                        "latitude": "40.17953000",
                        "longitude": "18.03174000"
                    },
                    {
                        "id": 140754,
                        "name": "Neviano",
                        "latitude": "40.10650000",
                        "longitude": "18.11517000"
                    },
                    {
                        "id": 140788,
                        "name": "Noci",
                        "latitude": "40.79356000",
                        "longitude": "17.12681000"
                    },
                    {
                        "id": 140789,
                        "name": "Nociglia",
                        "latitude": "40.03804000",
                        "longitude": "18.32757000"
                    },
                    {
                        "id": 140795,
                        "name": "Noha",
                        "latitude": "40.15323000",
                        "longitude": "18.16569000"
                    },
                    {
                        "id": 140796,
                        "name": "Noicattaro",
                        "latitude": "41.03449000",
                        "longitude": "16.98963000"
                    },
                    {
                        "id": 140840,
                        "name": "Novoli",
                        "latitude": "40.37673000",
                        "longitude": "18.04757000"
                    },
                    {
                        "id": 140946,
                        "name": "Ordona",
                        "latitude": "41.31501000",
                        "longitude": "15.62832000"
                    },
                    {
                        "id": 140951,
                        "name": "Oria",
                        "latitude": "40.49999000",
                        "longitude": "17.64280000"
                    },
                    {
                        "id": 140972,
                        "name": "Orsara di Puglia",
                        "latitude": "41.28163000",
                        "longitude": "15.26765000"
                    },
                    {
                        "id": 140977,
                        "name": "Orta Nova",
                        "latitude": "41.32879000",
                        "longitude": "15.70994000"
                    },
                    {
                        "id": 140983,
                        "name": "Ortelle",
                        "latitude": "40.03371000",
                        "longitude": "18.39125000"
                    },
                    {
                        "id": 141044,
                        "name": "Ostuni",
                        "latitude": "40.72913000",
                        "longitude": "17.57675000"
                    },
                    {
                        "id": 141045,
                        "name": "Otranto",
                        "latitude": "40.14789000",
                        "longitude": "18.48682000"
                    },
                    {
                        "id": 58219,
                        "name": "Palagianello",
                        "latitude": "40.60851000",
                        "longitude": "16.97802000"
                    },
                    {
                        "id": 58220,
                        "name": "Palagiano",
                        "latitude": "40.57762000",
                        "longitude": "17.03812000"
                    },
                    {
                        "id": 58256,
                        "name": "Palmariggi",
                        "latitude": "40.13099000",
                        "longitude": "18.37863000"
                    },
                    {
                        "id": 58261,
                        "name": "Palo del Colle",
                        "latitude": "41.05562000",
                        "longitude": "16.70321000"
                    },
                    {
                        "id": 58262,
                        "name": "Palombaio",
                        "latitude": "41.07036000",
                        "longitude": "16.60962000"
                    },
                    {
                        "id": 58282,
                        "name": "Panni",
                        "latitude": "41.22082000",
                        "longitude": "15.27560000"
                    },
                    {
                        "id": 58289,
                        "name": "Paolo VI",
                        "latitude": "40.52218000",
                        "longitude": "17.27401000"
                    },
                    {
                        "id": 58295,
                        "name": "Parabita",
                        "latitude": "40.05139000",
                        "longitude": "18.12651000"
                    },
                    {
                        "id": 58300,
                        "name": "Parco Scizzo-Parchitello",
                        "latitude": "41.07457000",
                        "longitude": "16.99329000"
                    },
                    {
                        "id": 58351,
                        "name": "Patù",
                        "latitude": "39.84078000",
                        "longitude": "18.33784000"
                    },
                    {
                        "id": 58455,
                        "name": "Peschici",
                        "latitude": "41.94521000",
                        "longitude": "16.01612000"
                    },
                    {
                        "id": 58500,
                        "name": "Pezze di Greco",
                        "latitude": "40.81004000",
                        "longitude": "17.41333000"
                    },
                    {
                        "id": 58617,
                        "name": "Pietramontecorvino",
                        "latitude": "41.54228000",
                        "longitude": "15.12894000"
                    },
                    {
                        "id": 58709,
                        "name": "Pisignano",
                        "latitude": "40.30470000",
                        "longitude": "18.27155000"
                    },
                    {
                        "id": 58748,
                        "name": "Poggiardo",
                        "latitude": "40.05315000",
                        "longitude": "18.37819000"
                    },
                    {
                        "id": 58755,
                        "name": "Poggio Imperiale",
                        "latitude": "41.82503000",
                        "longitude": "15.36680000"
                    },
                    {
                        "id": 58771,
                        "name": "Poggiorsini",
                        "latitude": "40.91403000",
                        "longitude": "16.25605000"
                    },
                    {
                        "id": 58790,
                        "name": "Polignano a Mare",
                        "latitude": "40.99221000",
                        "longitude": "17.22149000"
                    },
                    {
                        "id": 58926,
                        "name": "Porto Cesareo",
                        "latitude": "40.26228000",
                        "longitude": "17.89896000"
                    },
                    {
                        "id": 59067,
                        "name": "Presicce",
                        "latitude": "39.90055000",
                        "longitude": "18.26282000"
                    },
                    {
                        "id": 59112,
                        "name": "Provincia di Barletta - Andria - Trani",
                        "latitude": "41.25097000",
                        "longitude": "16.17599000"
                    },
                    {
                        "id": 59118,
                        "name": "Provincia di Brindisi",
                        "latitude": "40.58333000",
                        "longitude": "17.66667000"
                    },
                    {
                        "id": 59131,
                        "name": "Provincia di Foggia",
                        "latitude": "41.45000000",
                        "longitude": "15.53333000"
                    },
                    {
                        "id": 59141,
                        "name": "Provincia di Lecce",
                        "latitude": "40.21667000",
                        "longitude": "18.16667000"
                    },
                    {
                        "id": 59178,
                        "name": "Provincia di Taranto",
                        "latitude": "40.61667000",
                        "longitude": "17.25000000"
                    },
                    {
                        "id": 59203,
                        "name": "Pulsano",
                        "latitude": "40.38109000",
                        "longitude": "17.35612000"
                    },
                    {
                        "id": 59209,
                        "name": "Putignano",
                        "latitude": "40.85106000",
                        "longitude": "17.12190000"
                    },
                    {
                        "id": 59233,
                        "name": "Quasano",
                        "latitude": "40.96724000",
                        "longitude": "16.57354000"
                    },
                    {
                        "id": 59255,
                        "name": "Racale",
                        "latitude": "39.96086000",
                        "longitude": "18.09154000"
                    },
                    {
                        "id": 59378,
                        "name": "Rignano Garganico",
                        "latitude": "41.67934000",
                        "longitude": "15.58835000"
                    },
                    {
                        "id": 59500,
                        "name": "Roccaforzata",
                        "latitude": "40.43700000",
                        "longitude": "17.38986000"
                    },
                    {
                        "id": 59541,
                        "name": "Rocchetta Sant'Antonio",
                        "latitude": "41.10326000",
                        "longitude": "15.45993000"
                    },
                    {
                        "id": 59553,
                        "name": "Rodi Garganico",
                        "latitude": "41.92745000",
                        "longitude": "15.88217000"
                    },
                    {
                        "id": 59636,
                        "name": "Roseto Valfortore",
                        "latitude": "41.37544000",
                        "longitude": "15.09824000"
                    },
                    {
                        "id": 59696,
                        "name": "Ruffano",
                        "latitude": "39.98195000",
                        "longitude": "18.24974000"
                    },
                    {
                        "id": 59705,
                        "name": "Rutigliano",
                        "latitude": "41.00997000",
                        "longitude": "17.00558000"
                    },
                    {
                        "id": 59709,
                        "name": "Ruvo di Puglia",
                        "latitude": "41.11758000",
                        "longitude": "16.48421000"
                    },
                    {
                        "id": 59767,
                        "name": "Salice Salentino",
                        "latitude": "40.38485000",
                        "longitude": "17.96134000"
                    },
                    {
                        "id": 59789,
                        "name": "Salve",
                        "latitude": "39.86111000",
                        "longitude": "18.29493000"
                    },
                    {
                        "id": 59810,
                        "name": "Sammichele di Bari",
                        "latitude": "40.88711000",
                        "longitude": "16.94919000"
                    },
                    {
                        "id": 59859,
                        "name": "San Cassiano",
                        "latitude": "40.05631000",
                        "longitude": "18.33392000"
                    },
                    {
                        "id": 59864,
                        "name": "San Cesario di Lecce",
                        "latitude": "40.30221000",
                        "longitude": "18.16098000"
                    },
                    {
                        "id": 59894,
                        "name": "San Donaci",
                        "latitude": "40.44853000",
                        "longitude": "17.92252000"
                    },
                    {
                        "id": 59898,
                        "name": "San Donato di Lecce",
                        "latitude": "40.26728000",
                        "longitude": "18.18256000"
                    },
                    {
                        "id": 59956,
                        "name": "San Giorgio Ionico",
                        "latitude": "40.45796000",
                        "longitude": "17.38034000"
                    },
                    {
                        "id": 59988,
                        "name": "San Giovanni Rotondo",
                        "latitude": "41.70643000",
                        "longitude": "15.72770000"
                    },
                    {
                        "id": 60065,
                        "name": "San Marco in Lamis",
                        "latitude": "41.71210000",
                        "longitude": "15.63825000"
                    },
                    {
                        "id": 60066,
                        "name": "San Marco la Catola",
                        "latitude": "41.52483000",
                        "longitude": "15.00594000"
                    },
                    {
                        "id": 60099,
                        "name": "San Marzano di San Giuseppe",
                        "latitude": "40.45455000",
                        "longitude": "17.50351000"
                    },
                    {
                        "id": 60119,
                        "name": "San Michele Salentino",
                        "latitude": "40.63163000",
                        "longitude": "17.63254000"
                    },
                    {
                        "id": 60152,
                        "name": "San Pancrazio Salentino",
                        "latitude": "40.41800000",
                        "longitude": "17.83419000"
                    },
                    {
                        "id": 60156,
                        "name": "San Paolo",
                        "latitude": "41.12476000",
                        "longitude": "16.79258000"
                    },
                    {
                        "id": 60161,
                        "name": "San Paolo di Civitate",
                        "latitude": "41.73893000",
                        "longitude": "15.26080000"
                    },
                    {
                        "id": 60201,
                        "name": "San Pietro in Lama",
                        "latitude": "40.30711000",
                        "longitude": "18.12787000"
                    },
                    {
                        "id": 60184,
                        "name": "San Pietro Vernotico",
                        "latitude": "40.48890000",
                        "longitude": "17.99752000"
                    },
                    {
                        "id": 60244,
                        "name": "San Severo",
                        "latitude": "41.68564000",
                        "longitude": "15.38148000"
                    },
                    {
                        "id": 60282,
                        "name": "San Vito dei Normanni",
                        "latitude": "40.65642000",
                        "longitude": "17.70814000"
                    },
                    {
                        "id": 60298,
                        "name": "Sanarica",
                        "latitude": "40.08908000",
                        "longitude": "18.34803000"
                    },
                    {
                        "id": 60311,
                        "name": "Sannicandro di Bari",
                        "latitude": "41.00047000",
                        "longitude": "16.79714000"
                    },
                    {
                        "id": 60310,
                        "name": "Sannicandro Garganico",
                        "latitude": "41.83844000",
                        "longitude": "15.56535000"
                    },
                    {
                        "id": 60312,
                        "name": "Sannicola",
                        "latitude": "40.09244000",
                        "longitude": "18.06765000"
                    },
                    {
                        "id": 60324,
                        "name": "Sant'Agata di Puglia",
                        "latitude": "41.15127000",
                        "longitude": "15.37968000"
                    },
                    {
                        "id": 60418,
                        "name": "Santa Cesarea Terme",
                        "latitude": "40.03607000",
                        "longitude": "18.45542000"
                    },
                    {
                        "id": 60506,
                        "name": "Santeramo in Colle",
                        "latitude": "40.79236000",
                        "longitude": "16.75873000"
                    },
                    {
                        "id": 60583,
                        "name": "Sava",
                        "latitude": "40.40203000",
                        "longitude": "17.55267000"
                    },
                    {
                        "id": 60667,
                        "name": "Scorrano",
                        "latitude": "40.09018000",
                        "longitude": "18.29993000"
                    },
                    {
                        "id": 60677,
                        "name": "Seclì",
                        "latitude": "40.11897000",
                        "longitude": "18.10931000"
                    },
                    {
                        "id": 60758,
                        "name": "Serracapriola",
                        "latitude": "41.80912000",
                        "longitude": "15.16098000"
                    },
                    {
                        "id": 60766,
                        "name": "Serrano",
                        "latitude": "40.18438000",
                        "longitude": "18.35156000"
                    },
                    {
                        "id": 60896,
                        "name": "Sogliano Cavour",
                        "latitude": "40.14827000",
                        "longitude": "18.19741000"
                    },
                    {
                        "id": 60916,
                        "name": "Soleto",
                        "latitude": "40.18781000",
                        "longitude": "18.20630000"
                    },
                    {
                        "id": 60994,
                        "name": "Specchia",
                        "latitude": "39.93913000",
                        "longitude": "18.29784000"
                    },
                    {
                        "id": 61028,
                        "name": "Spongano",
                        "latitude": "40.01782000",
                        "longitude": "18.36563000"
                    },
                    {
                        "id": 61036,
                        "name": "Squinzano",
                        "latitude": "40.43513000",
                        "longitude": "18.04086000"
                    },
                    {
                        "id": 61049,
                        "name": "Statte",
                        "latitude": "40.52856000",
                        "longitude": "17.20122000"
                    },
                    {
                        "id": 61067,
                        "name": "Sternatia",
                        "latitude": "40.22022000",
                        "longitude": "18.22748000"
                    },
                    {
                        "id": 61079,
                        "name": "Stornara",
                        "latitude": "41.28672000",
                        "longitude": "15.77003000"
                    },
                    {
                        "id": 61080,
                        "name": "Stornarella",
                        "latitude": "41.25591000",
                        "longitude": "15.73023000"
                    },
                    {
                        "id": 61103,
                        "name": "Strudà",
                        "latitude": "40.31991000",
                        "longitude": "18.28176000"
                    },
                    {
                        "id": 61123,
                        "name": "Supersano",
                        "latitude": "40.01655000",
                        "longitude": "18.24205000"
                    },
                    {
                        "id": 61125,
                        "name": "Surano",
                        "latitude": "40.02818000",
                        "longitude": "18.34591000"
                    },
                    {
                        "id": 61126,
                        "name": "Surbo",
                        "latitude": "40.39383000",
                        "longitude": "18.13456000"
                    },
                    {
                        "id": 61165,
                        "name": "Taranto",
                        "latitude": "40.46438000",
                        "longitude": "17.24707000"
                    },
                    {
                        "id": 61177,
                        "name": "Taurisano",
                        "latitude": "39.95746000",
                        "longitude": "18.21498000"
                    },
                    {
                        "id": 61193,
                        "name": "Taviano",
                        "latitude": "39.98224000",
                        "longitude": "18.08151000"
                    },
                    {
                        "id": 61225,
                        "name": "Terlizzi",
                        "latitude": "41.12905000",
                        "longitude": "16.54536000"
                    },
                    {
                        "id": 61276,
                        "name": "Tiggiano",
                        "latitude": "39.90284000",
                        "longitude": "18.36501000"
                    },
                    {
                        "id": 61321,
                        "name": "Torchiarolo",
                        "latitude": "40.48349000",
                        "longitude": "18.05122000"
                    },
                    {
                        "id": 61331,
                        "name": "Toritto",
                        "latitude": "40.99774000",
                        "longitude": "16.67945000"
                    },
                    {
                        "id": 61361,
                        "name": "Torre San Giovanni",
                        "latitude": "39.89001000",
                        "longitude": "18.11159000"
                    },
                    {
                        "id": 61363,
                        "name": "Torre Santa Susanna",
                        "latitude": "40.46762000",
                        "longitude": "17.73864000"
                    },
                    {
                        "id": 61384,
                        "name": "Torremaggiore",
                        "latitude": "41.68894000",
                        "longitude": "15.29408000"
                    },
                    {
                        "id": 61400,
                        "name": "Torricella",
                        "latitude": "40.35509000",
                        "longitude": "17.49846000"
                    },
                    {
                        "id": 61489,
                        "name": "Trepuzzi",
                        "latitude": "40.40535000",
                        "longitude": "18.07625000"
                    },
                    {
                        "id": 61519,
                        "name": "Tricase",
                        "latitude": "39.93018000",
                        "longitude": "18.35421000"
                    },
                    {
                        "id": 61525,
                        "name": "Triggiano",
                        "latitude": "41.06549000",
                        "longitude": "16.92501000"
                    },
                    {
                        "id": 61549,
                        "name": "Troia",
                        "latitude": "41.36428000",
                        "longitude": "15.31730000"
                    },
                    {
                        "id": 61566,
                        "name": "Tuglie",
                        "latitude": "40.07346000",
                        "longitude": "18.09872000"
                    },
                    {
                        "id": 61574,
                        "name": "Turi",
                        "latitude": "40.91657000",
                        "longitude": "17.02038000"
                    },
                    {
                        "id": 61582,
                        "name": "Tuturano",
                        "latitude": "40.54474000",
                        "longitude": "17.94754000"
                    },
                    {
                        "id": 61588,
                        "name": "Ugento",
                        "latitude": "39.92724000",
                        "longitude": "18.15832000"
                    },
                    {
                        "id": 61591,
                        "name": "Uggiano la Chiesa",
                        "latitude": "40.10091000",
                        "longitude": "18.44872000"
                    },
                    {
                        "id": 61590,
                        "name": "Uggiano Montefusco",
                        "latitude": "40.38612000",
                        "longitude": "17.60460000"
                    },
                    {
                        "id": 61665,
                        "name": "Valenzano",
                        "latitude": "41.04376000",
                        "longitude": "16.88491000"
                    },
                    {
                        "id": 61796,
                        "name": "Veglie",
                        "latitude": "40.33474000",
                        "longitude": "17.96238000"
                    },
                    {
                        "id": 61858,
                        "name": "Vernole",
                        "latitude": "40.28834000",
                        "longitude": "18.30165000"
                    },
                    {
                        "id": 61918,
                        "name": "Vico del Gargano",
                        "latitude": "41.89661000",
                        "longitude": "15.95682000"
                    },
                    {
                        "id": 61933,
                        "name": "Vieste",
                        "latitude": "41.88209000",
                        "longitude": "16.17139000"
                    },
                    {
                        "id": 61955,
                        "name": "Vignacastrisi",
                        "latitude": "40.01604000",
                        "longitude": "18.40704000"
                    },
                    {
                        "id": 61990,
                        "name": "Villa Castelli",
                        "latitude": "40.58293000",
                        "longitude": "17.47468000"
                    },
                    {
                        "id": 62181,
                        "name": "Vitigliano",
                        "latitude": "40.03951000",
                        "longitude": "18.41170000"
                    },
                    {
                        "id": 62220,
                        "name": "Volturara Appula",
                        "latitude": "41.49603000",
                        "longitude": "15.05224000"
                    },
                    {
                        "id": 62222,
                        "name": "Volturino",
                        "latitude": "41.47723000",
                        "longitude": "15.12424000"
                    },
                    {
                        "id": 62237,
                        "name": "Zapponeta",
                        "latitude": "41.45710000",
                        "longitude": "15.95615000"
                    },
                    {
                        "id": 62269,
                        "name": "Zollino",
                        "latitude": "40.20581000",
                        "longitude": "18.24774000"
                    }
                ]
            },
            {
                "id": 1761,
                "name": "Arezzo",
                "iso2": "AR",
                "latitude": "43.51625330",
                "longitude": "11.22368720",
                "type": "province",
                "cities": []
            },
            {
                "id": 1681,
                "name": "Ascoli Piceno",
                "iso2": "AP",
                "latitude": "42.86389330",
                "longitude": "13.58997330",
                "type": "province",
                "cities": []
            },
            {
                "id": 1780,
                "name": "Asti",
                "iso2": "AT",
                "latitude": "44.90076520",
                "longitude": "8.20643150",
                "type": "province",
                "cities": []
            },
            {
                "id": 1692,
                "name": "Avellino",
                "iso2": "AV",
                "latitude": "40.99645100",
                "longitude": "15.12589550",
                "type": "province",
                "cities": []
            },
            {
                "id": 1686,
                "name": "Barletta-Andria-Trani",
                "iso2": "BT",
                "latitude": "41.20045430",
                "longitude": "16.20514840",
                "type": "province",
                "cities": [
                    {
                        "id": 135491,
                        "name": "Andria",
                        "latitude": "41.23117000",
                        "longitude": "16.29797000"
                    },
                    {
                        "id": 135860,
                        "name": "Barletta",
                        "latitude": "41.31429000",
                        "longitude": "16.28165000"
                    },
                    {
                        "id": 136061,
                        "name": "Bisceglie",
                        "latitude": "41.24264000",
                        "longitude": "16.50104000"
                    },
                    {
                        "id": 136732,
                        "name": "Canosa di Puglia",
                        "latitude": "41.21954000",
                        "longitude": "16.06768000"
                    },
                    {
                        "id": 139863,
                        "name": "Margherita di Savoia",
                        "latitude": "41.37174000",
                        "longitude": "16.15275000"
                    },
                    {
                        "id": 140159,
                        "name": "Minervino Murge",
                        "latitude": "41.08264000",
                        "longitude": "16.07861000"
                    },
                    {
                        "id": 59915,
                        "name": "San Ferdinando di Puglia",
                        "latitude": "41.30263000",
                        "longitude": "16.07046000"
                    },
                    {
                        "id": 61014,
                        "name": "Spinazzola",
                        "latitude": "40.96399000",
                        "longitude": "16.09111000"
                    },
                    {
                        "id": 61437,
                        "name": "Trani",
                        "latitude": "41.27733000",
                        "longitude": "16.41011000"
                    },
                    {
                        "id": 61528,
                        "name": "Trinitapoli",
                        "latitude": "41.35654000",
                        "longitude": "16.08924000"
                    }
                ]
            },
            {
                "id": 1706,
                "name": "Basilicata",
                "iso2": "77",
                "latitude": "40.64307660",
                "longitude": "15.96998780",
                "type": "region",
                "cities": [
                    {
                        "id": 135245,
                        "name": "Abriola",
                        "latitude": "40.50748000",
                        "longitude": "15.81310000"
                    },
                    {
                        "id": 135249,
                        "name": "Accettura",
                        "latitude": "40.49102000",
                        "longitude": "16.15798000"
                    },
                    {
                        "id": 135253,
                        "name": "Acerenza",
                        "latitude": "40.79386000",
                        "longitude": "15.93808000"
                    },
                    {
                        "id": 135354,
                        "name": "Albano di Lucania",
                        "latitude": "40.58614000",
                        "longitude": "16.03712000"
                    },
                    {
                        "id": 135407,
                        "name": "Aliano",
                        "latitude": "40.31359000",
                        "longitude": "16.22984000"
                    },
                    {
                        "id": 135526,
                        "name": "Anzi",
                        "latitude": "40.51662000",
                        "longitude": "15.92457000"
                    },
                    {
                        "id": 135614,
                        "name": "Armento",
                        "latitude": "40.30660000",
                        "longitude": "16.06550000"
                    },
                    {
                        "id": 135673,
                        "name": "Atella",
                        "latitude": "40.87855000",
                        "longitude": "15.65226000"
                    },
                    {
                        "id": 135709,
                        "name": "Avigliano",
                        "latitude": "40.73291000",
                        "longitude": "15.72004000"
                    },
                    {
                        "id": 135797,
                        "name": "Balvano",
                        "latitude": "40.64953000",
                        "longitude": "15.51345000"
                    },
                    {
                        "id": 135806,
                        "name": "Banzi",
                        "latitude": "40.86063000",
                        "longitude": "16.00976000"
                    },
                    {
                        "id": 135810,
                        "name": "Baragiano",
                        "latitude": "40.68001000",
                        "longitude": "15.59398000"
                    },
                    {
                        "id": 135857,
                        "name": "Barile",
                        "latitude": "40.94327000",
                        "longitude": "15.67167000"
                    },
                    {
                        "id": 135934,
                        "name": "Bella",
                        "latitude": "40.76059000",
                        "longitude": "15.54101000"
                    },
                    {
                        "id": 135992,
                        "name": "Bernalda",
                        "latitude": "40.41261000",
                        "longitude": "16.68919000"
                    },
                    {
                        "id": 136329,
                        "name": "Brienza",
                        "latitude": "40.47751000",
                        "longitude": "15.62927000"
                    },
                    {
                        "id": 136335,
                        "name": "Brindisi Montagna",
                        "latitude": "40.60952000",
                        "longitude": "15.93977000"
                    },
                    {
                        "id": 136504,
                        "name": "Calciano",
                        "latitude": "40.58802000",
                        "longitude": "16.19238000"
                    },
                    {
                        "id": 136553,
                        "name": "Calvello",
                        "latitude": "40.47482000",
                        "longitude": "15.85092000"
                    },
                    {
                        "id": 136556,
                        "name": "Calvera",
                        "latitude": "40.14871000",
                        "longitude": "16.14362000"
                    },
                    {
                        "id": 136667,
                        "name": "Campomaggiore",
                        "latitude": "40.56590000",
                        "longitude": "16.07250000"
                    },
                    {
                        "id": 136694,
                        "name": "Cancellara",
                        "latitude": "40.73068000",
                        "longitude": "15.92470000"
                    },
                    {
                        "id": 136850,
                        "name": "Carbone",
                        "latitude": "40.14227000",
                        "longitude": "16.08846000"
                    },
                    {
                        "id": 137203,
                        "name": "Castelgrande",
                        "latitude": "40.78639000",
                        "longitude": "15.43109000"
                    },
                    {
                        "id": 137264,
                        "name": "Castelluccio Inferiore",
                        "latitude": "40.00151000",
                        "longitude": "15.98149000"
                    },
                    {
                        "id": 137265,
                        "name": "Castelluccio Superiore",
                        "latitude": "40.01003000",
                        "longitude": "15.97184000"
                    },
                    {
                        "id": 137273,
                        "name": "Castelmezzano",
                        "latitude": "40.52832000",
                        "longitude": "16.04585000"
                    },
                    {
                        "id": 137313,
                        "name": "Castelsaraceno",
                        "latitude": "40.16213000",
                        "longitude": "15.99281000"
                    },
                    {
                        "id": 137384,
                        "name": "Castronuovo di Sant'Andrea",
                        "latitude": "40.18903000",
                        "longitude": "16.18559000"
                    },
                    {
                        "id": 137577,
                        "name": "Cersosimo",
                        "latitude": "40.04703000",
                        "longitude": "16.35059000"
                    },
                    {
                        "id": 137655,
                        "name": "Chiaromonte",
                        "latitude": "40.12323000",
                        "longitude": "16.21440000"
                    },
                    {
                        "id": 137747,
                        "name": "Cirigliano",
                        "latitude": "40.39376000",
                        "longitude": "16.17194000"
                    },
                    {
                        "id": 137910,
                        "name": "Colobraro",
                        "latitude": "40.18841000",
                        "longitude": "16.42480000"
                    },
                    {
                        "id": 138019,
                        "name": "Corleto Perticara",
                        "latitude": "40.38214000",
                        "longitude": "16.03917000"
                    },
                    {
                        "id": 138121,
                        "name": "Craco-Sant'Angelo",
                        "latitude": "40.37992000",
                        "longitude": "16.43708000"
                    },
                    {
                        "id": 138364,
                        "name": "Episcopia",
                        "latitude": "40.07481000",
                        "longitude": "16.09818000"
                    },
                    {
                        "id": 138445,
                        "name": "Fardella",
                        "latitude": "40.11381000",
                        "longitude": "16.16978000"
                    },
                    {
                        "id": 138488,
                        "name": "Ferrandina",
                        "latitude": "40.50084000",
                        "longitude": "16.45258000"
                    },
                    {
                        "id": 138529,
                        "name": "Filiano",
                        "latitude": "40.81042000",
                        "longitude": "15.70984000"
                    },
                    {
                        "id": 138624,
                        "name": "Forenza",
                        "latitude": "40.86041000",
                        "longitude": "15.85457000"
                    },
                    {
                        "id": 138699,
                        "name": "Francavilla in Sinni",
                        "latitude": "40.08142000",
                        "longitude": "16.20417000"
                    },
                    {
                        "id": 138809,
                        "name": "Gallicchio",
                        "latitude": "40.29232000",
                        "longitude": "16.13561000"
                    },
                    {
                        "id": 138843,
                        "name": "Garaguso",
                        "latitude": "40.54866000",
                        "longitude": "16.22827000"
                    },
                    {
                        "id": 138903,
                        "name": "Genzano di Lucania",
                        "latitude": "40.84589000",
                        "longitude": "16.03124000"
                    },
                    {
                        "id": 138963,
                        "name": "Ginestra",
                        "latitude": "40.93092000",
                        "longitude": "15.73497000"
                    },
                    {
                        "id": 139029,
                        "name": "Gorgoglione",
                        "latitude": "40.39532000",
                        "longitude": "16.14456000"
                    },
                    {
                        "id": 139072,
                        "name": "Grassano",
                        "latitude": "40.63457000",
                        "longitude": "16.27792000"
                    },
                    {
                        "id": 139130,
                        "name": "Grottole",
                        "latitude": "40.60333000",
                        "longitude": "16.37831000"
                    },
                    {
                        "id": 139137,
                        "name": "Grumento Nova",
                        "latitude": "40.28281000",
                        "longitude": "15.88877000"
                    },
                    {
                        "id": 139160,
                        "name": "Guardia Perticara",
                        "latitude": "40.36167000",
                        "longitude": "16.09845000"
                    },
                    {
                        "id": 139223,
                        "name": "Irsina",
                        "latitude": "40.75015000",
                        "longitude": "16.23816000"
                    },
                    {
                        "id": 139295,
                        "name": "La Martella",
                        "latitude": "40.66251000",
                        "longitude": "16.53551000"
                    },
                    {
                        "id": 139327,
                        "name": "Lagonegro",
                        "latitude": "40.12785000",
                        "longitude": "15.76212000"
                    },
                    {
                        "id": 139393,
                        "name": "Latronico",
                        "latitude": "40.08909000",
                        "longitude": "16.00947000"
                    },
                    {
                        "id": 139400,
                        "name": "Laurenzana",
                        "latitude": "40.45908000",
                        "longitude": "15.97075000"
                    },
                    {
                        "id": 139401,
                        "name": "Lauria",
                        "latitude": "40.04702000",
                        "longitude": "15.83812000"
                    },
                    {
                        "id": 139410,
                        "name": "Lavello",
                        "latitude": "41.04769000",
                        "longitude": "15.78915000"
                    },
                    {
                        "id": 139501,
                        "name": "Lido",
                        "latitude": "40.19128000",
                        "longitude": "16.70692000"
                    },
                    {
                        "id": 139832,
                        "name": "Maratea",
                        "latitude": "39.99932000",
                        "longitude": "15.71539000"
                    },
                    {
                        "id": 139855,
                        "name": "Marconia",
                        "latitude": "40.36355000",
                        "longitude": "16.68823000"
                    },
                    {
                        "id": 139922,
                        "name": "Marsico Nuovo",
                        "latitude": "40.42359000",
                        "longitude": "15.73462000"
                    },
                    {
                        "id": 139923,
                        "name": "Marsicovetere",
                        "latitude": "40.37591000",
                        "longitude": "15.82569000"
                    },
                    {
                        "id": 139954,
                        "name": "Maschito",
                        "latitude": "40.90892000",
                        "longitude": "15.82946000"
                    },
                    {
                        "id": 139993,
                        "name": "Matera",
                        "latitude": "40.66599000",
                        "longitude": "16.60463000"
                    },
                    {
                        "id": 140043,
                        "name": "Melfi",
                        "latitude": "40.99571000",
                        "longitude": "15.65578000"
                    },
                    {
                        "id": 140138,
                        "name": "Miglionico",
                        "latitude": "40.56763000",
                        "longitude": "16.49964000"
                    },
                    {
                        "id": 140183,
                        "name": "Missanello",
                        "latitude": "40.28311000",
                        "longitude": "16.16650000"
                    },
                    {
                        "id": 140228,
                        "name": "Moliterno",
                        "latitude": "40.24394000",
                        "longitude": "15.86544000"
                    },
                    {
                        "id": 140318,
                        "name": "Montalbano Jonico",
                        "latitude": "40.28591000",
                        "longitude": "16.56960000"
                    },
                    {
                        "id": 140495,
                        "name": "Montemilone",
                        "latitude": "41.02742000",
                        "longitude": "15.96661000"
                    },
                    {
                        "id": 140499,
                        "name": "Montemurro",
                        "latitude": "40.29765000",
                        "longitude": "15.99182000"
                    },
                    {
                        "id": 140534,
                        "name": "Montescaglioso",
                        "latitude": "40.55024000",
                        "longitude": "16.66541000"
                    },
                    {
                        "id": 140694,
                        "name": "Muro Lucano",
                        "latitude": "40.75379000",
                        "longitude": "15.48808000"
                    },
                    {
                        "id": 140741,
                        "name": "Nemoli",
                        "latitude": "40.06765000",
                        "longitude": "15.79962000"
                    },
                    {
                        "id": 140790,
                        "name": "Noepoli",
                        "latitude": "40.08705000",
                        "longitude": "16.32834000"
                    },
                    {
                        "id": 140816,
                        "name": "Nova Siri",
                        "latitude": "40.14823000",
                        "longitude": "16.53976000"
                    },
                    {
                        "id": 140817,
                        "name": "Nova Siri Scalo",
                        "latitude": "40.13177000",
                        "longitude": "16.63593000"
                    },
                    {
                        "id": 140902,
                        "name": "Oliveto Lucano",
                        "latitude": "40.53554000",
                        "longitude": "16.18547000"
                    },
                    {
                        "id": 140934,
                        "name": "Oppido Lucano",
                        "latitude": "40.76174000",
                        "longitude": "15.98818000"
                    },
                    {
                        "id": 58231,
                        "name": "Palazzo San Gervasio",
                        "latitude": "40.93156000",
                        "longitude": "15.98149000"
                    },
                    {
                        "id": 58343,
                        "name": "Paterno",
                        "latitude": "40.37507000",
                        "longitude": "15.73510000"
                    },
                    {
                        "id": 58463,
                        "name": "Pescopagano",
                        "latitude": "40.83494000",
                        "longitude": "15.39946000"
                    },
                    {
                        "id": 58580,
                        "name": "Picerno",
                        "latitude": "40.63975000",
                        "longitude": "15.64232000"
                    },
                    {
                        "id": 58614,
                        "name": "Pietragalla",
                        "latitude": "40.74572000",
                        "longitude": "15.87398000"
                    },
                    {
                        "id": 58621,
                        "name": "Pietrapertosa",
                        "latitude": "40.51731000",
                        "longitude": "16.06244000"
                    },
                    {
                        "id": 58663,
                        "name": "Pignola",
                        "latitude": "40.57412000",
                        "longitude": "15.78295000"
                    },
                    {
                        "id": 58713,
                        "name": "Pisticci",
                        "latitude": "40.39017000",
                        "longitude": "16.55919000"
                    },
                    {
                        "id": 58789,
                        "name": "Policoro",
                        "latitude": "40.21280000",
                        "longitude": "16.67795000"
                    },
                    {
                        "id": 58810,
                        "name": "Pomarico",
                        "latitude": "40.52804000",
                        "longitude": "16.52708000"
                    },
                    {
                        "id": 58965,
                        "name": "Potenza",
                        "latitude": "40.64175000",
                        "longitude": "15.80794000"
                    },
                    {
                        "id": 59149,
                        "name": "Provincia di Matera",
                        "latitude": "40.50000000",
                        "longitude": "16.41667000"
                    },
                    {
                        "id": 59164,
                        "name": "Provincia di Potenza",
                        "latitude": "40.46442000",
                        "longitude": "15.89938000"
                    },
                    {
                        "id": 59287,
                        "name": "Rapolla",
                        "latitude": "40.97499000",
                        "longitude": "15.67201000"
                    },
                    {
                        "id": 59288,
                        "name": "Rapone",
                        "latitude": "40.84710000",
                        "longitude": "15.49818000"
                    },
                    {
                        "id": 59397,
                        "name": "Rionero in Vulture",
                        "latitude": "40.92328000",
                        "longitude": "15.67110000"
                    },
                    {
                        "id": 59402,
                        "name": "Ripacandida",
                        "latitude": "40.91256000",
                        "longitude": "15.72597000"
                    },
                    {
                        "id": 59436,
                        "name": "Rivello",
                        "latitude": "40.07821000",
                        "longitude": "15.75798000"
                    },
                    {
                        "id": 59511,
                        "name": "Roccanova",
                        "latitude": "40.21250000",
                        "longitude": "16.20429000"
                    },
                    {
                        "id": 59659,
                        "name": "Rotonda",
                        "latitude": "39.95215000",
                        "longitude": "16.03904000"
                    },
                    {
                        "id": 59660,
                        "name": "Rotondella",
                        "latitude": "40.17136000",
                        "longitude": "16.52491000"
                    },
                    {
                        "id": 59703,
                        "name": "Ruoti",
                        "latitude": "40.71660000",
                        "longitude": "15.68369000"
                    },
                    {
                        "id": 59708,
                        "name": "Ruvo del Monte",
                        "latitude": "40.84951000",
                        "longitude": "15.54217000"
                    },
                    {
                        "id": 59746,
                        "name": "Salandra",
                        "latitude": "40.52668000",
                        "longitude": "16.32037000"
                    },
                    {
                        "id": 59848,
                        "name": "San Brancato",
                        "latitude": "40.25822000",
                        "longitude": "16.25661000"
                    },
                    {
                        "id": 59866,
                        "name": "San Chirico Nuovo",
                        "latitude": "40.67764000",
                        "longitude": "16.07892000"
                    },
                    {
                        "id": 59867,
                        "name": "San Chirico Raparo",
                        "latitude": "40.19242000",
                        "longitude": "16.07618000"
                    },
                    {
                        "id": 59880,
                        "name": "San Costantino Albanese",
                        "latitude": "40.03679000",
                        "longitude": "16.30475000"
                    },
                    {
                        "id": 59905,
                        "name": "San Fele",
                        "latitude": "40.81647000",
                        "longitude": "15.54043000"
                    },
                    {
                        "id": 59957,
                        "name": "San Giorgio Lucano",
                        "latitude": "40.11132000",
                        "longitude": "16.38930000"
                    },
                    {
                        "id": 60081,
                        "name": "San Martino d'Agri",
                        "latitude": "40.23913000",
                        "longitude": "16.05216000"
                    },
                    {
                        "id": 60107,
                        "name": "San Mauro Forte",
                        "latitude": "40.48333000",
                        "longitude": "16.25155000"
                    },
                    {
                        "id": 60157,
                        "name": "San Paolo Albanese",
                        "latitude": "40.03567000",
                        "longitude": "16.33498000"
                    },
                    {
                        "id": 60242,
                        "name": "San Severino Lucano",
                        "latitude": "40.02021000",
                        "longitude": "16.13860000"
                    },
                    {
                        "id": 60372,
                        "name": "Sant'Angelo le Fratte",
                        "latitude": "40.54490000",
                        "longitude": "15.56156000"
                    },
                    {
                        "id": 60387,
                        "name": "Sant'Arcangelo",
                        "latitude": "40.24852000",
                        "longitude": "16.27046000"
                    },
                    {
                        "id": 60542,
                        "name": "Sarconi",
                        "latitude": "40.24800000",
                        "longitude": "15.88837000"
                    },
                    {
                        "id": 60573,
                        "name": "Sasso di Castalda",
                        "latitude": "40.48525000",
                        "longitude": "15.67569000"
                    },
                    {
                        "id": 60579,
                        "name": "Satriano di Lucania",
                        "latitude": "40.54296000",
                        "longitude": "15.64024000"
                    },
                    {
                        "id": 60598,
                        "name": "Savoia di Lucania",
                        "latitude": "40.56949000",
                        "longitude": "15.55132000"
                    },
                    {
                        "id": 60611,
                        "name": "Scalo di Baragiano",
                        "latitude": "40.69500000",
                        "longitude": "15.57508000"
                    },
                    {
                        "id": 60626,
                        "name": "Scanzano Jonico",
                        "latitude": "40.25085000",
                        "longitude": "16.69824000"
                    },
                    {
                        "id": 60726,
                        "name": "Senise",
                        "latitude": "40.14616000",
                        "longitude": "16.28867000"
                    },
                    {
                        "id": 61024,
                        "name": "Spinoso",
                        "latitude": "40.26921000",
                        "longitude": "15.96658000"
                    },
                    {
                        "id": 61072,
                        "name": "Stigliano",
                        "latitude": "40.40237000",
                        "longitude": "16.22983000"
                    },
                    {
                        "id": 61198,
                        "name": "Teana",
                        "latitude": "40.12586000",
                        "longitude": "16.15281000"
                    },
                    {
                        "id": 61242,
                        "name": "Terranova di Pollino",
                        "latitude": "39.97765000",
                        "longitude": "16.29583000"
                    },
                    {
                        "id": 61287,
                        "name": "Tito",
                        "latitude": "40.58370000",
                        "longitude": "15.67621000"
                    },
                    {
                        "id": 61303,
                        "name": "Tolve",
                        "latitude": "40.69422000",
                        "longitude": "16.01627000"
                    },
                    {
                        "id": 61435,
                        "name": "Tramutola",
                        "latitude": "40.31858000",
                        "longitude": "15.78753000"
                    },
                    {
                        "id": 61467,
                        "name": "Trecchina",
                        "latitude": "40.02611000",
                        "longitude": "15.77585000"
                    },
                    {
                        "id": 61518,
                        "name": "Tricarico",
                        "latitude": "40.61458000",
                        "longitude": "16.14259000"
                    },
                    {
                        "id": 61544,
                        "name": "Trivigno",
                        "latitude": "40.58015000",
                        "longitude": "15.98857000"
                    },
                    {
                        "id": 61579,
                        "name": "Tursi",
                        "latitude": "40.24651000",
                        "longitude": "16.47140000"
                    },
                    {
                        "id": 61634,
                        "name": "Vaglio Basilicata",
                        "latitude": "40.66643000",
                        "longitude": "15.91434000"
                    },
                    {
                        "id": 61739,
                        "name": "Valsinni",
                        "latitude": "40.17098000",
                        "longitude": "16.44388000"
                    },
                    {
                        "id": 61823,
                        "name": "Venosa",
                        "latitude": "40.96283000",
                        "longitude": "15.81285000"
                    },
                    {
                        "id": 61934,
                        "name": "Vietri di Potenza",
                        "latitude": "40.60027000",
                        "longitude": "15.50787000"
                    },
                    {
                        "id": 61945,
                        "name": "Viggianello",
                        "latitude": "39.97227000",
                        "longitude": "16.08521000"
                    },
                    {
                        "id": 61946,
                        "name": "Viggiano",
                        "latitude": "40.34213000",
                        "longitude": "15.89964000"
                    },
                    {
                        "id": 62033,
                        "name": "Villa d'Agri",
                        "latitude": "40.35426000",
                        "longitude": "15.82770000"
                    },
                    {
                        "id": 62270,
                        "name": "Zona 179",
                        "latitude": "41.00313000",
                        "longitude": "15.61868000"
                    }
                ]
            },
            {
                "id": 1689,
                "name": "Belluno",
                "iso2": "BL",
                "latitude": "46.24976590",
                "longitude": "12.19695650",
                "type": "province",
                "cities": []
            },
            {
                "id": 1701,
                "name": "Benevento",
                "iso2": "BN",
                "latitude": "41.20350930",
                "longitude": "14.75209390",
                "type": "province",
                "cities": []
            },
            {
                "id": 1704,
                "name": "Bergamo",
                "iso2": "BG",
                "latitude": "45.69826420",
                "longitude": "9.67726980",
                "type": "province",
                "cities": []
            },
            {
                "id": 1778,
                "name": "Biella",
                "iso2": "BI",
                "latitude": "45.56281760",
                "longitude": "8.05827170",
                "type": "province",
                "cities": []
            },
            {
                "id": 1717,
                "name": "Brescia",
                "iso2": "BS",
                "latitude": "45.54155260",
                "longitude": "10.21180190",
                "type": "province",
                "cities": []
            },
            {
                "id": 1714,
                "name": "Brindisi",
                "iso2": "BR",
                "latitude": "40.61126630",
                "longitude": "17.76362100",
                "type": "province",
                "cities": []
            },
            {
                "id": 1703,
                "name": "Calabria",
                "iso2": "78",
                "latitude": "39.30877140",
                "longitude": "16.34637910",
                "type": "region",
                "cities": [
                    {
                        "id": 135251,
                        "name": "Acconia",
                        "latitude": "38.83585000",
                        "longitude": "16.26530000"
                    },
                    {
                        "id": 135265,
                        "name": "Acquaformosa",
                        "latitude": "39.72278000",
                        "longitude": "16.09096000"
                    },
                    {
                        "id": 135271,
                        "name": "Acquappesa",
                        "latitude": "39.49573000",
                        "longitude": "15.95419000"
                    },
                    {
                        "id": 135273,
                        "name": "Acquaro",
                        "latitude": "38.55729000",
                        "longitude": "16.18781000"
                    },
                    {
                        "id": 135284,
                        "name": "Acri",
                        "latitude": "39.49624000",
                        "longitude": "16.38635000"
                    },
                    {
                        "id": 135295,
                        "name": "Africo Nuovo",
                        "latitude": "38.05067000",
                        "longitude": "16.13320000"
                    },
                    {
                        "id": 135296,
                        "name": "Africo Vecchio",
                        "latitude": "38.06667000",
                        "longitude": "15.98333000"
                    },
                    {
                        "id": 135309,
                        "name": "Agnana Calabra",
                        "latitude": "38.30206000",
                        "longitude": "16.22718000"
                    },
                    {
                        "id": 135326,
                        "name": "Aiello Calabro",
                        "latitude": "39.11785000",
                        "longitude": "16.16539000"
                    },
                    {
                        "id": 135329,
                        "name": "Aieta",
                        "latitude": "39.92780000",
                        "longitude": "15.82348000"
                    },
                    {
                        "id": 135369,
                        "name": "Albi",
                        "latitude": "39.02456000",
                        "longitude": "16.59721000"
                    },
                    {
                        "id": 135374,
                        "name": "Albidona",
                        "latitude": "39.92332000",
                        "longitude": "16.47237000"
                    },
                    {
                        "id": 135395,
                        "name": "Alessandria del Carretto",
                        "latitude": "39.95874000",
                        "longitude": "16.37963000"
                    },
                    {
                        "id": 135439,
                        "name": "Altilia",
                        "latitude": "39.13049000",
                        "longitude": "16.25269000"
                    },
                    {
                        "id": 135445,
                        "name": "Altomonte",
                        "latitude": "39.69900000",
                        "longitude": "16.12999000"
                    },
                    {
                        "id": 135458,
                        "name": "Amantea",
                        "latitude": "39.12658000",
                        "longitude": "16.07512000"
                    },
                    {
                        "id": 135460,
                        "name": "Amaroni",
                        "latitude": "38.79424000",
                        "longitude": "16.44809000"
                    },
                    {
                        "id": 135462,
                        "name": "Amato",
                        "latitude": "38.38333000",
                        "longitude": "16.13333000"
                    },
                    {
                        "id": 135469,
                        "name": "Amendolara",
                        "latitude": "39.95162000",
                        "longitude": "16.58293000"
                    },
                    {
                        "id": 135471,
                        "name": "Amica",
                        "latitude": "39.60085000",
                        "longitude": "16.66694000"
                    },
                    {
                        "id": 135480,
                        "name": "Andali",
                        "latitude": "39.01281000",
                        "longitude": "16.76926000"
                    },
                    {
                        "id": 135489,
                        "name": "Andreotta",
                        "latitude": "39.30750000",
                        "longitude": "16.21770000"
                    },
                    {
                        "id": 135509,
                        "name": "Anoia Inferiore",
                        "latitude": "38.43618000",
                        "longitude": "16.07940000"
                    },
                    {
                        "id": 135510,
                        "name": "Anoia Superiore",
                        "latitude": "38.43144000",
                        "longitude": "16.09740000"
                    },
                    {
                        "id": 135520,
                        "name": "Antonimina",
                        "latitude": "38.27298000",
                        "longitude": "16.14824000"
                    },
                    {
                        "id": 135541,
                        "name": "Aprigliano",
                        "latitude": "39.24228000",
                        "longitude": "16.34046000"
                    },
                    {
                        "id": 135560,
                        "name": "Arcavacata",
                        "latitude": "39.35846000",
                        "longitude": "16.20844000"
                    },
                    {
                        "id": 135582,
                        "name": "Ardore",
                        "latitude": "38.19173000",
                        "longitude": "16.16734000"
                    },
                    {
                        "id": 135583,
                        "name": "Ardore Marina",
                        "latitude": "38.16667000",
                        "longitude": "16.20000000"
                    },
                    {
                        "id": 135585,
                        "name": "Arena",
                        "latitude": "38.56235000",
                        "longitude": "16.21060000"
                    },
                    {
                        "id": 135596,
                        "name": "Argusto",
                        "latitude": "38.68051000",
                        "longitude": "16.43627000"
                    },
                    {
                        "id": 135742,
                        "name": "Badolato",
                        "latitude": "38.56868000",
                        "longitude": "16.52461000"
                    },
                    {
                        "id": 135743,
                        "name": "Badolato Marina",
                        "latitude": "38.57613000",
                        "longitude": "16.56527000"
                    },
                    {
                        "id": 135744,
                        "name": "Bagaladi",
                        "latitude": "38.02560000",
                        "longitude": "15.82152000"
                    },
                    {
                        "id": 135749,
                        "name": "Bagnara Calabra",
                        "latitude": "38.28778000",
                        "longitude": "15.80591000"
                    },
                    {
                        "id": 135863,
                        "name": "Barone",
                        "latitude": "38.85225000",
                        "longitude": "16.63927000"
                    },
                    {
                        "id": 135926,
                        "name": "Belcastro",
                        "latitude": "39.01799000",
                        "longitude": "16.78641000"
                    },
                    {
                        "id": 135951,
                        "name": "Belmonte Calabro",
                        "latitude": "39.16398000",
                        "longitude": "16.08215000"
                    },
                    {
                        "id": 135958,
                        "name": "Belsito",
                        "latitude": "39.17685000",
                        "longitude": "16.28745000"
                    },
                    {
                        "id": 135963,
                        "name": "Belvedere Marittimo",
                        "latitude": "39.61930000",
                        "longitude": "15.86220000"
                    },
                    {
                        "id": 135965,
                        "name": "Belvedere Spinello",
                        "latitude": "39.20674000",
                        "longitude": "16.89233000"
                    },
                    {
                        "id": 135973,
                        "name": "Benestare",
                        "latitude": "38.18487000",
                        "longitude": "16.13900000"
                    },
                    {
                        "id": 136029,
                        "name": "Bianchi",
                        "latitude": "39.10058000",
                        "longitude": "16.41018000"
                    },
                    {
                        "id": 136030,
                        "name": "Bianco",
                        "latitude": "38.09170000",
                        "longitude": "16.15159000"
                    },
                    {
                        "id": 136064,
                        "name": "Bisignano",
                        "latitude": "39.50727000",
                        "longitude": "16.28106000"
                    },
                    {
                        "id": 136076,
                        "name": "Bivongi",
                        "latitude": "38.48328000",
                        "longitude": "16.45251000"
                    },
                    {
                        "id": 136088,
                        "name": "Bocchigliero",
                        "latitude": "39.41930000",
                        "longitude": "16.75057000"
                    },
                    {
                        "id": 136138,
                        "name": "Bonifati",
                        "latitude": "39.58595000",
                        "longitude": "15.90163000"
                    },
                    {
                        "id": 136156,
                        "name": "Borgata Marina",
                        "latitude": "39.97136000",
                        "longitude": "16.62091000"
                    },
                    {
                        "id": 136166,
                        "name": "Borgia",
                        "latitude": "38.82627000",
                        "longitude": "16.50770000"
                    },
                    {
                        "id": 136256,
                        "name": "Botricello",
                        "latitude": "38.92997000",
                        "longitude": "16.85801000"
                    },
                    {
                        "id": 136264,
                        "name": "Bova",
                        "latitude": "37.99507000",
                        "longitude": "15.93190000"
                    },
                    {
                        "id": 136265,
                        "name": "Bova Marina",
                        "latitude": "37.93503000",
                        "longitude": "15.91736000"
                    },
                    {
                        "id": 136266,
                        "name": "Bovalino",
                        "latitude": "38.15376000",
                        "longitude": "16.17232000"
                    },
                    {
                        "id": 136267,
                        "name": "Bovalino Superiore",
                        "latitude": "38.16905000",
                        "longitude": "16.15849000"
                    },
                    {
                        "id": 136285,
                        "name": "Brancaleone",
                        "latitude": "37.96297000",
                        "longitude": "16.10040000"
                    },
                    {
                        "id": 136286,
                        "name": "Brancaleone-Marina",
                        "latitude": "37.96667000",
                        "longitude": "16.10000000"
                    },
                    {
                        "id": 136325,
                        "name": "Briatico",
                        "latitude": "38.72254000",
                        "longitude": "16.02737000"
                    },
                    {
                        "id": 136347,
                        "name": "Brognaturo",
                        "latitude": "38.60128000",
                        "longitude": "16.34140000"
                    },
                    {
                        "id": 136380,
                        "name": "Bruzzano Zeffirio",
                        "latitude": "38.01327000",
                        "longitude": "16.08260000"
                    },
                    {
                        "id": 136408,
                        "name": "Buonvicino",
                        "latitude": "39.68877000",
                        "longitude": "15.88400000"
                    },
                    {
                        "id": 136452,
                        "name": "Caccuri",
                        "latitude": "39.22562000",
                        "longitude": "16.77767000"
                    },
                    {
                        "id": 136491,
                        "name": "Calanna",
                        "latitude": "38.18457000",
                        "longitude": "15.72293000"
                    },
                    {
                        "id": 136536,
                        "name": "Caloppezzati",
                        "latitude": "39.56120000",
                        "longitude": "16.80180000"
                    },
                    {
                        "id": 136538,
                        "name": "Caloveto",
                        "latitude": "39.50656000",
                        "longitude": "16.76065000"
                    },
                    {
                        "id": 136563,
                        "name": "Calvisi",
                        "latitude": "39.12739000",
                        "longitude": "16.30590000"
                    },
                    {
                        "id": 136589,
                        "name": "Camini",
                        "latitude": "38.43179000",
                        "longitude": "16.48321000"
                    },
                    {
                        "id": 136607,
                        "name": "Campana",
                        "latitude": "39.41360000",
                        "longitude": "16.82220000"
                    },
                    {
                        "id": 136627,
                        "name": "Campo Calabro",
                        "latitude": "38.21607000",
                        "longitude": "15.65919000"
                    },
                    {
                        "id": 136673,
                        "name": "Campora San Giovanni",
                        "latitude": "39.06798000",
                        "longitude": "16.09566000"
                    },
                    {
                        "id": 136705,
                        "name": "Candidoni",
                        "latitude": "38.50548000",
                        "longitude": "16.08630000"
                    },
                    {
                        "id": 136717,
                        "name": "Canna",
                        "latitude": "40.09484000",
                        "longitude": "16.50378000"
                    },
                    {
                        "id": 136728,
                        "name": "Canolo",
                        "latitude": "38.31497000",
                        "longitude": "16.19990000"
                    },
                    {
                        "id": 136749,
                        "name": "Cantinella",
                        "latitude": "39.66458000",
                        "longitude": "16.44912000"
                    },
                    {
                        "id": 136770,
                        "name": "Capistrano",
                        "latitude": "38.69131000",
                        "longitude": "16.28935000"
                    },
                    {
                        "id": 136777,
                        "name": "Capo Rizzuto",
                        "latitude": "38.90412000",
                        "longitude": "17.09872000"
                    },
                    {
                        "id": 136827,
                        "name": "Caraffa del Bianco",
                        "latitude": "38.09259000",
                        "longitude": "16.08766000"
                    },
                    {
                        "id": 136828,
                        "name": "Caraffa di Catanzaro",
                        "latitude": "38.88194000",
                        "longitude": "16.48675000"
                    },
                    {
                        "id": 136860,
                        "name": "Cardeto",
                        "latitude": "38.08440000",
                        "longitude": "15.76577000"
                    },
                    {
                        "id": 136861,
                        "name": "Cardinale",
                        "latitude": "38.65379000",
                        "longitude": "16.38715000"
                    },
                    {
                        "id": 136868,
                        "name": "Careri",
                        "latitude": "38.17741000",
                        "longitude": "16.11614000"
                    },
                    {
                        "id": 136872,
                        "name": "Carfizzi",
                        "latitude": "39.30771000",
                        "longitude": "16.97447000"
                    },
                    {
                        "id": 136874,
                        "name": "Cariati",
                        "latitude": "39.49627000",
                        "longitude": "16.95495000"
                    },
                    {
                        "id": 136889,
                        "name": "Carlopoli",
                        "latitude": "39.05406000",
                        "longitude": "16.45455000"
                    },
                    {
                        "id": 136898,
                        "name": "Carolei",
                        "latitude": "39.25472000",
                        "longitude": "16.21979000"
                    },
                    {
                        "id": 136907,
                        "name": "Carpanzano",
                        "latitude": "39.14817000",
                        "longitude": "16.30451000"
                    },
                    {
                        "id": 136952,
                        "name": "Casabona",
                        "latitude": "39.24951000",
                        "longitude": "16.95446000"
                    },
                    {
                        "id": 137069,
                        "name": "Casignana",
                        "latitude": "38.10187000",
                        "longitude": "16.08990000"
                    },
                    {
                        "id": 137081,
                        "name": "Casole Bruzio",
                        "latitude": "39.28384000",
                        "longitude": "16.33193000"
                    },
                    {
                        "id": 137095,
                        "name": "Cassano Allo Ionio",
                        "latitude": "39.78142000",
                        "longitude": "16.32738000"
                    },
                    {
                        "id": 137316,
                        "name": "Castelsilano",
                        "latitude": "39.26910000",
                        "longitude": "16.76741000"
                    },
                    {
                        "id": 137340,
                        "name": "Castiglione Cosentino",
                        "latitude": "39.35271000",
                        "longitude": "16.28821000"
                    },
                    {
                        "id": 137381,
                        "name": "Castrolibero",
                        "latitude": "39.31002000",
                        "longitude": "16.19453000"
                    },
                    {
                        "id": 137388,
                        "name": "Castroregio",
                        "latitude": "39.99220000",
                        "longitude": "16.47846000"
                    },
                    {
                        "id": 137389,
                        "name": "Castrovillari",
                        "latitude": "39.81632000",
                        "longitude": "16.20183000"
                    },
                    {
                        "id": 137392,
                        "name": "Catanzaro",
                        "latitude": "38.88247000",
                        "longitude": "16.60086000"
                    },
                    {
                        "id": 137398,
                        "name": "Caulonia",
                        "latitude": "38.38171000",
                        "longitude": "16.40951000"
                    },
                    {
                        "id": 137399,
                        "name": "Caulonia Marina",
                        "latitude": "38.34679000",
                        "longitude": "16.46353000"
                    },
                    {
                        "id": 137404,
                        "name": "Cava-Cuculera Nobile",
                        "latitude": "38.89383000",
                        "longitude": "16.62226000"
                    },
                    {
                        "id": 137440,
                        "name": "Cavoni-Ginestreto",
                        "latitude": "39.45212000",
                        "longitude": "16.26267000"
                    },
                    {
                        "id": 137466,
                        "name": "Celico",
                        "latitude": "39.31009000",
                        "longitude": "16.33989000"
                    },
                    {
                        "id": 137470,
                        "name": "Cellara",
                        "latitude": "39.21849000",
                        "longitude": "16.33480000"
                    },
                    {
                        "id": 137485,
                        "name": "Cenadi",
                        "latitude": "38.71934000",
                        "longitude": "16.41582000"
                    },
                    {
                        "id": 137500,
                        "name": "Centrache",
                        "latitude": "38.72872000",
                        "longitude": "16.43101000"
                    },
                    {
                        "id": 137512,
                        "name": "Ceramida-Pellegrina",
                        "latitude": "38.29667000",
                        "longitude": "15.82572000"
                    },
                    {
                        "id": 137524,
                        "name": "Cerchiara di Calabria",
                        "latitude": "39.85978000",
                        "longitude": "16.38368000"
                    },
                    {
                        "id": 137534,
                        "name": "Cerenzia",
                        "latitude": "39.24554000",
                        "longitude": "16.78758000"
                    },
                    {
                        "id": 137551,
                        "name": "Cerisano",
                        "latitude": "39.27715000",
                        "longitude": "16.17654000"
                    },
                    {
                        "id": 137581,
                        "name": "Cerva",
                        "latitude": "39.02397000",
                        "longitude": "16.74538000"
                    },
                    {
                        "id": 137592,
                        "name": "Cervicati",
                        "latitude": "39.54237000",
                        "longitude": "16.12682000"
                    },
                    {
                        "id": 137599,
                        "name": "Cerzeto",
                        "latitude": "39.50789000",
                        "longitude": "16.11603000"
                    },
                    {
                        "id": 137617,
                        "name": "Cessaniti",
                        "latitude": "38.66395000",
                        "longitude": "16.02959000"
                    },
                    {
                        "id": 137623,
                        "name": "Cetraro",
                        "latitude": "39.51660000",
                        "longitude": "15.94158000"
                    },
                    {
                        "id": 137624,
                        "name": "Cetraro Marina",
                        "latitude": "39.51701000",
                        "longitude": "15.93460000"
                    },
                    {
                        "id": 137653,
                        "name": "Chiaravalle Centrale",
                        "latitude": "38.67936000",
                        "longitude": "16.40864000"
                    },
                    {
                        "id": 137708,
                        "name": "Cicala",
                        "latitude": "39.02219000",
                        "longitude": "16.48610000"
                    },
                    {
                        "id": 137725,
                        "name": "Ciminà",
                        "latitude": "38.24618000",
                        "longitude": "16.14023000"
                    },
                    {
                        "id": 137737,
                        "name": "Cinque Frondi",
                        "latitude": "38.41618000",
                        "longitude": "16.08420000"
                    },
                    {
                        "id": 137750,
                        "name": "Cirò",
                        "latitude": "39.38297000",
                        "longitude": "17.06377000"
                    },
                    {
                        "id": 137751,
                        "name": "Cirò Marina",
                        "latitude": "39.36876000",
                        "longitude": "17.12477000"
                    },
                    {
                        "id": 137766,
                        "name": "Cittadella del Capo",
                        "latitude": "39.55932000",
                        "longitude": "15.87602000"
                    },
                    {
                        "id": 137768,
                        "name": "Cittanova",
                        "latitude": "38.35431000",
                        "longitude": "16.07898000"
                    },
                    {
                        "id": 137785,
                        "name": "Civita",
                        "latitude": "39.82804000",
                        "longitude": "16.31337000"
                    },
                    {
                        "id": 137812,
                        "name": "Cleto",
                        "latitude": "39.09019000",
                        "longitude": "16.15839000"
                    },
                    {
                        "id": 137927,
                        "name": "Colosimi",
                        "latitude": "39.11911000",
                        "longitude": "16.39909000"
                    },
                    {
                        "id": 137963,
                        "name": "Condofuri",
                        "latitude": "38.00447000",
                        "longitude": "15.85770000"
                    },
                    {
                        "id": 137969,
                        "name": "Conflenti",
                        "latitude": "39.07169000",
                        "longitude": "16.28450000"
                    },
                    {
                        "id": 138012,
                        "name": "Corigliano Calabro",
                        "latitude": "39.59553000",
                        "longitude": "16.51907000"
                    },
                    {
                        "id": 138013,
                        "name": "Corigliano Scalo",
                        "latitude": "39.62713000",
                        "longitude": "16.51368000"
                    },
                    {
                        "id": 138051,
                        "name": "Cortale",
                        "latitude": "38.84009000",
                        "longitude": "16.40960000"
                    },
                    {
                        "id": 138078,
                        "name": "Cosenza",
                        "latitude": "39.29890000",
                        "longitude": "16.25307000"
                    },
                    {
                        "id": 138082,
                        "name": "Cosoleto",
                        "latitude": "38.27483000",
                        "longitude": "15.92814000"
                    },
                    {
                        "id": 138112,
                        "name": "Cotronei",
                        "latitude": "39.15935000",
                        "longitude": "16.77688000"
                    },
                    {
                        "id": 138154,
                        "name": "Crichi",
                        "latitude": "38.95296000",
                        "longitude": "16.64178000"
                    },
                    {
                        "id": 138165,
                        "name": "Cropalati",
                        "latitude": "39.51673000",
                        "longitude": "16.72674000"
                    },
                    {
                        "id": 138166,
                        "name": "Cropani",
                        "latitude": "38.96690000",
                        "longitude": "16.78022000"
                    },
                    {
                        "id": 138167,
                        "name": "Cropani Marina",
                        "latitude": "38.92376000",
                        "longitude": "16.81080000"
                    },
                    {
                        "id": 138168,
                        "name": "Crosia",
                        "latitude": "39.56822000",
                        "longitude": "16.77126000"
                    },
                    {
                        "id": 138170,
                        "name": "Crotone",
                        "latitude": "39.08077000",
                        "longitude": "17.12764000"
                    },
                    {
                        "id": 138174,
                        "name": "Crucoli",
                        "latitude": "39.42713000",
                        "longitude": "17.00281000"
                    },
                    {
                        "id": 138202,
                        "name": "Curinga",
                        "latitude": "38.82811000",
                        "longitude": "16.31344000"
                    },
                    {
                        "id": 138218,
                        "name": "Cutro",
                        "latitude": "39.03484000",
                        "longitude": "16.98658000"
                    },
                    {
                        "id": 138230,
                        "name": "Dasà",
                        "latitude": "38.56514000",
                        "longitude": "16.19521000"
                    },
                    {
                        "id": 138233,
                        "name": "Davoli",
                        "latitude": "38.64904000",
                        "longitude": "16.48764000"
                    },
                    {
                        "id": 138238,
                        "name": "Decollatura",
                        "latitude": "39.04645000",
                        "longitude": "16.35753000"
                    },
                    {
                        "id": 138243,
                        "name": "Delianuova",
                        "latitude": "38.23587000",
                        "longitude": "15.91714000"
                    },
                    {
                        "id": 138259,
                        "name": "Diamante",
                        "latitude": "39.68070000",
                        "longitude": "15.82168000"
                    },
                    {
                        "id": 138268,
                        "name": "Dinami",
                        "latitude": "38.53136000",
                        "longitude": "16.14461000"
                    },
                    {
                        "id": 138269,
                        "name": "Dipignano",
                        "latitude": "39.23869000",
                        "longitude": "16.25184000"
                    },
                    {
                        "id": 138287,
                        "name": "Domanico",
                        "latitude": "39.21693000",
                        "longitude": "16.20721000"
                    },
                    {
                        "id": 138302,
                        "name": "Donnici Inferiore",
                        "latitude": "39.25020000",
                        "longitude": "16.29307000"
                    },
                    {
                        "id": 138307,
                        "name": "Doria",
                        "latitude": "39.73042000",
                        "longitude": "16.35597000"
                    },
                    {
                        "id": 138327,
                        "name": "Drapia",
                        "latitude": "38.66612000",
                        "longitude": "15.91122000"
                    },
                    {
                        "id": 138395,
                        "name": "Fabrizia",
                        "latitude": "38.48989000",
                        "longitude": "16.29832000"
                    },
                    {
                        "id": 138396,
                        "name": "Fabrizio",
                        "latitude": "39.63939000",
                        "longitude": "16.55666000"
                    },
                    {
                        "id": 138408,
                        "name": "Fagnano Castello",
                        "latitude": "39.57160000",
                        "longitude": "16.06253000"
                    },
                    {
                        "id": 138415,
                        "name": "Falconara Albanese",
                        "latitude": "39.27524000",
                        "longitude": "16.08819000"
                    },
                    {
                        "id": 138419,
                        "name": "Falerna",
                        "latitude": "39.00298000",
                        "longitude": "16.17151000"
                    },
                    {
                        "id": 138420,
                        "name": "Falerna Scalo",
                        "latitude": "38.97285000",
                        "longitude": "16.15294000"
                    },
                    {
                        "id": 138485,
                        "name": "Feroleto Antico",
                        "latitude": "38.96239000",
                        "longitude": "16.38780000"
                    },
                    {
                        "id": 138486,
                        "name": "Feroleto della Chiesa",
                        "latitude": "38.46609000",
                        "longitude": "16.07012000"
                    },
                    {
                        "id": 138498,
                        "name": "Ferruzzano",
                        "latitude": "38.03699000",
                        "longitude": "16.08918000"
                    },
                    {
                        "id": 138520,
                        "name": "Figline Vegliaturo",
                        "latitude": "39.22519000",
                        "longitude": "16.33030000"
                    },
                    {
                        "id": 138522,
                        "name": "Filadelfia",
                        "latitude": "38.78468000",
                        "longitude": "16.29200000"
                    },
                    {
                        "id": 138524,
                        "name": "Filandari",
                        "latitude": "38.61508000",
                        "longitude": "16.03140000"
                    },
                    {
                        "id": 138532,
                        "name": "Filogaso",
                        "latitude": "38.68287000",
                        "longitude": "16.22584000"
                    },
                    {
                        "id": 138544,
                        "name": "Firmo",
                        "latitude": "39.72208000",
                        "longitude": "16.16344000"
                    },
                    {
                        "id": 138549,
                        "name": "Fiumara",
                        "latitude": "38.21267000",
                        "longitude": "15.69369000"
                    },
                    {
                        "id": 138552,
                        "name": "Fiumefreddo Bruzio",
                        "latitude": "39.23568000",
                        "longitude": "16.07056000"
                    },
                    {
                        "id": 138625,
                        "name": "Foresta",
                        "latitude": "39.09939000",
                        "longitude": "16.81287000"
                    },
                    {
                        "id": 138675,
                        "name": "Fossato Ionico-Fossatello-San Luca Marcelluzzo",
                        "latitude": "38.01065000",
                        "longitude": "15.76302000"
                    },
                    {
                        "id": 138676,
                        "name": "Fossato Serralta",
                        "latitude": "38.99629000",
                        "longitude": "16.57960000"
                    },
                    {
                        "id": 138692,
                        "name": "Francavilla Angitola",
                        "latitude": "38.78016000",
                        "longitude": "16.27228000"
                    },
                    {
                        "id": 138695,
                        "name": "Francavilla Marittima",
                        "latitude": "39.81610000",
                        "longitude": "16.39499000"
                    },
                    {
                        "id": 138702,
                        "name": "Francica",
                        "latitude": "38.61697000",
                        "longitude": "16.10007000"
                    },
                    {
                        "id": 138709,
                        "name": "Frascineto",
                        "latitude": "39.83382000",
                        "longitude": "16.26378000"
                    },
                    {
                        "id": 138760,
                        "name": "Fuscaldo",
                        "latitude": "39.41421000",
                        "longitude": "16.02839000"
                    },
                    {
                        "id": 138784,
                        "name": "Gagliato",
                        "latitude": "38.67578000",
                        "longitude": "16.46061000"
                    },
                    {
                        "id": 138797,
                        "name": "Galatro",
                        "latitude": "38.46067000",
                        "longitude": "16.10840000"
                    },
                    {
                        "id": 138864,
                        "name": "Gasperina",
                        "latitude": "38.74039000",
                        "longitude": "16.50666000"
                    },
                    {
                        "id": 138907,
                        "name": "Gerace",
                        "latitude": "38.27137000",
                        "longitude": "16.22070000"
                    },
                    {
                        "id": 138919,
                        "name": "Gerocarne",
                        "latitude": "38.58767000",
                        "longitude": "16.21818000"
                    },
                    {
                        "id": 138956,
                        "name": "Giffone",
                        "latitude": "38.43957000",
                        "longitude": "16.14898000"
                    },
                    {
                        "id": 138962,
                        "name": "Gimigliano",
                        "latitude": "38.97338000",
                        "longitude": "16.53165000"
                    },
                    {
                        "id": 138969,
                        "name": "Gioia Tauro",
                        "latitude": "38.42510000",
                        "longitude": "15.89750000"
                    },
                    {
                        "id": 138972,
                        "name": "Gioiosa Ionica",
                        "latitude": "38.32723000",
                        "longitude": "16.30407000"
                    },
                    {
                        "id": 138983,
                        "name": "Girifalco",
                        "latitude": "38.82594000",
                        "longitude": "16.42688000"
                    },
                    {
                        "id": 139003,
                        "name": "Gizzeria",
                        "latitude": "38.98025000",
                        "longitude": "16.20671000"
                    },
                    {
                        "id": 139101,
                        "name": "Grimaldi",
                        "latitude": "39.14111000",
                        "longitude": "16.23511000"
                    },
                    {
                        "id": 139104,
                        "name": "Grisolia",
                        "latitude": "39.72538000",
                        "longitude": "15.85605000"
                    },
                    {
                        "id": 139128,
                        "name": "Grotteria",
                        "latitude": "38.36509000",
                        "longitude": "16.26522000"
                    },
                    {
                        "id": 139156,
                        "name": "Guardavalle",
                        "latitude": "38.50510000",
                        "longitude": "16.50669000"
                    },
                    {
                        "id": 139157,
                        "name": "Guardavalle Marina",
                        "latitude": "38.47957000",
                        "longitude": "16.57656000"
                    },
                    {
                        "id": 139161,
                        "name": "Guardia Piemontese",
                        "latitude": "39.46572000",
                        "longitude": "15.99970000"
                    },
                    {
                        "id": 139225,
                        "name": "Isca Marina",
                        "latitude": "38.60341000",
                        "longitude": "16.55733000"
                    },
                    {
                        "id": 139226,
                        "name": "Isca sullo Ionio",
                        "latitude": "38.60103000",
                        "longitude": "16.52010000"
                    },
                    {
                        "id": 139250,
                        "name": "Isola di Capo Rizzuto",
                        "latitude": "38.95844000",
                        "longitude": "17.09242000"
                    },
                    {
                        "id": 139273,
                        "name": "Jacurso",
                        "latitude": "38.84649000",
                        "longitude": "16.37980000"
                    },
                    {
                        "id": 139280,
                        "name": "Jonadi",
                        "latitude": "38.62988000",
                        "longitude": "16.06100000"
                    },
                    {
                        "id": 139281,
                        "name": "Joppolo",
                        "latitude": "38.58338000",
                        "longitude": "15.89709000"
                    },
                    {
                        "id": 139320,
                        "name": "Laganadi",
                        "latitude": "38.17391000",
                        "longitude": "15.74133000"
                    },
                    {
                        "id": 139326,
                        "name": "Lago",
                        "latitude": "39.17068000",
                        "longitude": "16.14825000"
                    },
                    {
                        "id": 139333,
                        "name": "Laino Borgo",
                        "latitude": "39.95430000",
                        "longitude": "15.97348000"
                    },
                    {
                        "id": 139334,
                        "name": "Laino Castello-Nuovo Centro",
                        "latitude": "39.93630000",
                        "longitude": "15.97658000"
                    },
                    {
                        "id": 139344,
                        "name": "Lamezia Terme",
                        "latitude": "38.96255000",
                        "longitude": "16.30938000"
                    },
                    {
                        "id": 139369,
                        "name": "Lappano",
                        "latitude": "39.31964000",
                        "longitude": "16.31143000"
                    },
                    {
                        "id": 139394,
                        "name": "Lattarico",
                        "latitude": "39.45105000",
                        "longitude": "16.12700000"
                    },
                    {
                        "id": 139398,
                        "name": "Laureana di Borrello",
                        "latitude": "38.49215000",
                        "longitude": "16.08429000"
                    },
                    {
                        "id": 139403,
                        "name": "Laurignano",
                        "latitude": "39.27915000",
                        "longitude": "16.24232000"
                    },
                    {
                        "id": 139421,
                        "name": "Lazzaro",
                        "latitude": "37.97276000",
                        "longitude": "15.66511000"
                    },
                    {
                        "id": 139425,
                        "name": "Le Castella",
                        "latitude": "38.91010000",
                        "longitude": "17.02216000"
                    },
                    {
                        "id": 139517,
                        "name": "Limbadi-Caroni",
                        "latitude": "38.55902000",
                        "longitude": "15.96441000"
                    },
                    {
                        "id": 139566,
                        "name": "Locri",
                        "latitude": "38.23868000",
                        "longitude": "16.25957000"
                    },
                    {
                        "id": 139597,
                        "name": "Longobardi",
                        "latitude": "39.21059000",
                        "longitude": "16.07464000"
                    },
                    {
                        "id": 139598,
                        "name": "Longobucco",
                        "latitude": "39.44830000",
                        "longitude": "16.61050000"
                    },
                    {
                        "id": 139661,
                        "name": "Lungro",
                        "latitude": "39.73772000",
                        "longitude": "16.12586000"
                    },
                    {
                        "id": 139685,
                        "name": "Luzzi",
                        "latitude": "39.44799000",
                        "longitude": "16.28730000"
                    },
                    {
                        "id": 139721,
                        "name": "Magisano",
                        "latitude": "39.01339000",
                        "longitude": "16.62790000"
                    },
                    {
                        "id": 139745,
                        "name": "Maida",
                        "latitude": "38.85884000",
                        "longitude": "16.36277000"
                    },
                    {
                        "id": 139747,
                        "name": "Maierà",
                        "latitude": "39.71655000",
                        "longitude": "15.85012000"
                    },
                    {
                        "id": 139746,
                        "name": "Maierato",
                        "latitude": "38.71111000",
                        "longitude": "16.17532000"
                    },
                    {
                        "id": 139767,
                        "name": "Malito",
                        "latitude": "39.15775000",
                        "longitude": "16.24677000"
                    },
                    {
                        "id": 139778,
                        "name": "Malvito",
                        "latitude": "39.60105000",
                        "longitude": "16.05341000"
                    },
                    {
                        "id": 139780,
                        "name": "Mammola",
                        "latitude": "38.36262000",
                        "longitude": "16.23871000"
                    },
                    {
                        "id": 139785,
                        "name": "Mandatoriccio",
                        "latitude": "39.46675000",
                        "longitude": "16.83420000"
                    },
                    {
                        "id": 139798,
                        "name": "Mangone",
                        "latitude": "39.20437000",
                        "longitude": "16.33262000"
                    },
                    {
                        "id": 139823,
                        "name": "Marano Marchesato",
                        "latitude": "39.31274000",
                        "longitude": "16.17354000"
                    },
                    {
                        "id": 139824,
                        "name": "Marano Principato",
                        "latitude": "39.29782000",
                        "longitude": "16.17430000"
                    },
                    {
                        "id": 139836,
                        "name": "Marcedusa",
                        "latitude": "39.02675000",
                        "longitude": "16.83612000"
                    },
                    {
                        "id": 139839,
                        "name": "Marcellina",
                        "latitude": "39.76578000",
                        "longitude": "15.82311000"
                    },
                    {
                        "id": 139840,
                        "name": "Marcellinara",
                        "latitude": "38.92574000",
                        "longitude": "16.48757000"
                    },
                    {
                        "id": 139872,
                        "name": "Marina",
                        "latitude": "39.93857000",
                        "longitude": "16.60585000"
                    },
                    {
                        "id": 139884,
                        "name": "Marina di Davoli",
                        "latitude": "38.66361000",
                        "longitude": "16.54825000"
                    },
                    {
                        "id": 139885,
                        "name": "Marina di Fuscaldo",
                        "latitude": "39.42418000",
                        "longitude": "16.00694000"
                    },
                    {
                        "id": 139887,
                        "name": "Marina di Gioiosa Ionica",
                        "latitude": "38.30159000",
                        "longitude": "16.33148000"
                    },
                    {
                        "id": 139896,
                        "name": "Marina di Schiavonea",
                        "latitude": "39.65000000",
                        "longitude": "16.53333000"
                    },
                    {
                        "id": 139912,
                        "name": "Maropati",
                        "latitude": "38.44178000",
                        "longitude": "16.09750000"
                    },
                    {
                        "id": 139928,
                        "name": "Martelli-Laganosa",
                        "latitude": "38.67930000",
                        "longitude": "16.53549000"
                    },
                    {
                        "id": 139937,
                        "name": "Martirano",
                        "latitude": "39.08119000",
                        "longitude": "16.24829000"
                    },
                    {
                        "id": 139938,
                        "name": "Martirano Lombardo",
                        "latitude": "39.07469000",
                        "longitude": "16.23200000"
                    },
                    {
                        "id": 139940,
                        "name": "Martone",
                        "latitude": "38.35353000",
                        "longitude": "16.28800000"
                    },
                    {
                        "id": 139948,
                        "name": "Marzi",
                        "latitude": "39.17063000",
                        "longitude": "16.30705000"
                    },
                    {
                        "id": 140046,
                        "name": "Melicuccà",
                        "latitude": "38.30311000",
                        "longitude": "15.88153000"
                    },
                    {
                        "id": 140045,
                        "name": "Melicucco",
                        "latitude": "38.43298000",
                        "longitude": "16.05748000"
                    },
                    {
                        "id": 140048,
                        "name": "Melissa",
                        "latitude": "39.30953000",
                        "longitude": "17.02968000"
                    },
                    {
                        "id": 140052,
                        "name": "Melito di Porto Salvo",
                        "latitude": "37.92629000",
                        "longitude": "15.74990000"
                    },
                    {
                        "id": 140063,
                        "name": "Mendicino",
                        "latitude": "39.26282000",
                        "longitude": "16.19452000"
                    },
                    {
                        "id": 140096,
                        "name": "Mesoraca",
                        "latitude": "39.07948000",
                        "longitude": "16.78808000"
                    },
                    {
                        "id": 140097,
                        "name": "Messignadi",
                        "latitude": "38.29964000",
                        "longitude": "15.99642000"
                    },
                    {
                        "id": 140137,
                        "name": "Miglierina",
                        "latitude": "38.95060000",
                        "longitude": "16.47233000"
                    },
                    {
                        "id": 140147,
                        "name": "Mileto",
                        "latitude": "38.60780000",
                        "longitude": "16.06751000"
                    },
                    {
                        "id": 140176,
                        "name": "Mirto",
                        "latitude": "39.60069000",
                        "longitude": "16.77390000"
                    },
                    {
                        "id": 140230,
                        "name": "Molochio",
                        "latitude": "38.30789000",
                        "longitude": "16.03141000"
                    },
                    {
                        "id": 140250,
                        "name": "Monasterace",
                        "latitude": "38.45318000",
                        "longitude": "16.55163000"
                    },
                    {
                        "id": 140251,
                        "name": "Monasterace Marina",
                        "latitude": "38.43489000",
                        "longitude": "16.57025000"
                    },
                    {
                        "id": 140285,
                        "name": "Mongiana",
                        "latitude": "38.51477000",
                        "longitude": "16.31940000"
                    },
                    {
                        "id": 140290,
                        "name": "Mongrassano",
                        "latitude": "39.52644000",
                        "longitude": "16.11225000"
                    },
                    {
                        "id": 140334,
                        "name": "Montalto Uffugo",
                        "latitude": "39.40331000",
                        "longitude": "16.15534000"
                    },
                    {
                        "id": 140349,
                        "name": "Montauro",
                        "latitude": "38.74927000",
                        "longitude": "16.51226000"
                    },
                    {
                        "id": 140387,
                        "name": "Montebello Jonico",
                        "latitude": "37.98277000",
                        "longitude": "15.75800000"
                    },
                    {
                        "id": 140454,
                        "name": "Montegiordano",
                        "latitude": "40.04301000",
                        "longitude": "16.53439000"
                    },
                    {
                        "id": 140506,
                        "name": "Montepaone",
                        "latitude": "38.72222000",
                        "longitude": "16.49795000"
                    },
                    {
                        "id": 140507,
                        "name": "Montepaone Lido",
                        "latitude": "38.72951000",
                        "longitude": "16.54241000"
                    },
                    {
                        "id": 140523,
                        "name": "Monterosso Calabro",
                        "latitude": "38.71746000",
                        "longitude": "16.29066000"
                    },
                    {
                        "id": 140597,
                        "name": "Morano Calabro",
                        "latitude": "39.84138000",
                        "longitude": "16.13837000"
                    },
                    {
                        "id": 140623,
                        "name": "Mormanno",
                        "latitude": "39.89340000",
                        "longitude": "15.99175000"
                    },
                    {
                        "id": 140650,
                        "name": "Mosorrofa",
                        "latitude": "38.09500000",
                        "longitude": "15.71259000"
                    },
                    {
                        "id": 140660,
                        "name": "Motta San Giovanni",
                        "latitude": "38.01027000",
                        "longitude": "15.71262000"
                    },
                    {
                        "id": 140662,
                        "name": "Motta Santa Lucia",
                        "latitude": "39.09122000",
                        "longitude": "16.29313000"
                    },
                    {
                        "id": 140666,
                        "name": "Mottafollone",
                        "latitude": "39.64850000",
                        "longitude": "16.06451000"
                    },
                    {
                        "id": 140717,
                        "name": "Nardodipace",
                        "latitude": "38.47418000",
                        "longitude": "16.34295000"
                    },
                    {
                        "id": 140725,
                        "name": "Natile Nuovo",
                        "latitude": "38.18583000",
                        "longitude": "16.08527000"
                    },
                    {
                        "id": 140761,
                        "name": "Nicastro",
                        "latitude": "38.97089000",
                        "longitude": "16.31285000"
                    },
                    {
                        "id": 140766,
                        "name": "Nicotera",
                        "latitude": "38.54915000",
                        "longitude": "15.93584000"
                    },
                    {
                        "id": 140779,
                        "name": "Nocara",
                        "latitude": "40.09941000",
                        "longitude": "16.48189000"
                    },
                    {
                        "id": 140783,
                        "name": "Nocera Scalo",
                        "latitude": "39.01576000",
                        "longitude": "16.12040000"
                    },
                    {
                        "id": 140785,
                        "name": "Nocera Terinese",
                        "latitude": "39.03474000",
                        "longitude": "16.16737000"
                    },
                    {
                        "id": 140899,
                        "name": "Olivadi",
                        "latitude": "38.72558000",
                        "longitude": "16.42370000"
                    },
                    {
                        "id": 140935,
                        "name": "Oppido Mamertina",
                        "latitude": "38.29337000",
                        "longitude": "15.98390000"
                    },
                    {
                        "id": 140958,
                        "name": "Oriolo",
                        "latitude": "40.05320000",
                        "longitude": "16.44663000"
                    },
                    {
                        "id": 140976,
                        "name": "Orsomarso",
                        "latitude": "39.79910000",
                        "longitude": "15.90748000"
                    },
                    {
                        "id": 58207,
                        "name": "Pagliarelle",
                        "latitude": "39.14017000",
                        "longitude": "16.75101000"
                    },
                    {
                        "id": 58239,
                        "name": "Palermiti",
                        "latitude": "38.74868000",
                        "longitude": "16.45220000"
                    },
                    {
                        "id": 58246,
                        "name": "Palizzi",
                        "latitude": "37.96667000",
                        "longitude": "15.98670000"
                    },
                    {
                        "id": 58247,
                        "name": "Palizzi Marina",
                        "latitude": "37.91995000",
                        "longitude": "15.97927000"
                    },
                    {
                        "id": 58248,
                        "name": "Pallagorio",
                        "latitude": "39.30764000",
                        "longitude": "16.90816000"
                    },
                    {
                        "id": 58258,
                        "name": "Palmi",
                        "latitude": "38.35943000",
                        "longitude": "15.85155000"
                    },
                    {
                        "id": 58268,
                        "name": "Paludi",
                        "latitude": "39.52943000",
                        "longitude": "16.67963000"
                    },
                    {
                        "id": 58277,
                        "name": "Panettieri",
                        "latitude": "39.06007000",
                        "longitude": "16.45375000"
                    },
                    {
                        "id": 58280,
                        "name": "Pannaconi",
                        "latitude": "38.69291000",
                        "longitude": "16.04411000"
                    },
                    {
                        "id": 58287,
                        "name": "Paola",
                        "latitude": "39.36313000",
                        "longitude": "16.03691000"
                    },
                    {
                        "id": 58290,
                        "name": "Papanice",
                        "latitude": "39.07077000",
                        "longitude": "17.02721000"
                    },
                    {
                        "id": 58291,
                        "name": "Papasidero",
                        "latitude": "39.87159000",
                        "longitude": "15.90581000"
                    },
                    {
                        "id": 58297,
                        "name": "Paravati",
                        "latitude": "38.59020000",
                        "longitude": "16.05815000"
                    },
                    {
                        "id": 58302,
                        "name": "Parenti",
                        "latitude": "39.16071000",
                        "longitude": "16.41140000"
                    },
                    {
                        "id": 58305,
                        "name": "Parghelia",
                        "latitude": "38.68189000",
                        "longitude": "15.92075000"
                    },
                    {
                        "id": 58344,
                        "name": "Paterno Calabro",
                        "latitude": "39.22849000",
                        "longitude": "16.26489000"
                    },
                    {
                        "id": 58361,
                        "name": "Pavigliana",
                        "latitude": "38.10721000",
                        "longitude": "15.72108000"
                    },
                    {
                        "id": 58366,
                        "name": "Pazzano",
                        "latitude": "38.47612000",
                        "longitude": "16.45107000"
                    },
                    {
                        "id": 58372,
                        "name": "Pedace-Perito",
                        "latitude": "39.27639000",
                        "longitude": "16.33639000"
                    },
                    {
                        "id": 58383,
                        "name": "Pedivigliano",
                        "latitude": "39.11034000",
                        "longitude": "16.30486000"
                    },
                    {
                        "id": 58392,
                        "name": "Pellaro",
                        "latitude": "38.01667000",
                        "longitude": "15.65000000"
                    },
                    {
                        "id": 58410,
                        "name": "Pentone",
                        "latitude": "38.98579000",
                        "longitude": "16.58250000"
                    },
                    {
                        "id": 58432,
                        "name": "Pernocari-Presinaci",
                        "latitude": "38.61184000",
                        "longitude": "16.00463000"
                    },
                    {
                        "id": 58474,
                        "name": "Petilia Policastro",
                        "latitude": "39.11293000",
                        "longitude": "16.78167000"
                    },
                    {
                        "id": 58485,
                        "name": "Petrizzi",
                        "latitude": "38.70179000",
                        "longitude": "16.47187000"
                    },
                    {
                        "id": 58486,
                        "name": "Petronà",
                        "latitude": "39.04370000",
                        "longitude": "16.75796000"
                    },
                    {
                        "id": 58520,
                        "name": "Piane Crati",
                        "latitude": "39.23472000",
                        "longitude": "16.32313000"
                    },
                    {
                        "id": 58549,
                        "name": "Pianopoli",
                        "latitude": "38.95246000",
                        "longitude": "16.38863000"
                    },
                    {
                        "id": 58613,
                        "name": "Pietrafitta",
                        "latitude": "39.26103000",
                        "longitude": "16.33940000"
                    },
                    {
                        "id": 58620,
                        "name": "Pietrapaola",
                        "latitude": "39.48701000",
                        "longitude": "16.81597000"
                    },
                    {
                        "id": 58708,
                        "name": "Piscopio",
                        "latitude": "38.66361000",
                        "longitude": "16.11101000"
                    },
                    {
                        "id": 58726,
                        "name": "Pizzo",
                        "latitude": "38.75259000",
                        "longitude": "16.18696000"
                    },
                    {
                        "id": 58730,
                        "name": "Pizzoni",
                        "latitude": "38.62286000",
                        "longitude": "16.24876000"
                    },
                    {
                        "id": 58731,
                        "name": "Placanica",
                        "latitude": "38.41078000",
                        "longitude": "16.45274000"
                    },
                    {
                        "id": 58733,
                        "name": "Plataci",
                        "latitude": "39.90042000",
                        "longitude": "16.43272000"
                    },
                    {
                        "id": 58734,
                        "name": "Platania",
                        "latitude": "39.00620000",
                        "longitude": "16.32194000"
                    },
                    {
                        "id": 58735,
                        "name": "Platì",
                        "latitude": "38.22149000",
                        "longitude": "16.04530000"
                    },
                    {
                        "id": 58787,
                        "name": "Polia",
                        "latitude": "38.75118000",
                        "longitude": "16.31220000"
                    },
                    {
                        "id": 58793,
                        "name": "Polistena",
                        "latitude": "38.40544000",
                        "longitude": "16.07330000"
                    },
                    {
                        "id": 58921,
                        "name": "Portigliola",
                        "latitude": "38.22712000",
                        "longitude": "16.20287000"
                    },
                    {
                        "id": 58998,
                        "name": "Praia a Mare",
                        "latitude": "39.89410000",
                        "longitude": "15.78421000"
                    },
                    {
                        "id": 59123,
                        "name": "Provincia di Catanzaro",
                        "latitude": "38.91667000",
                        "longitude": "16.43333000"
                    },
                    {
                        "id": 59126,
                        "name": "Provincia di Cosenza",
                        "latitude": "39.55697000",
                        "longitude": "16.35491000"
                    },
                    {
                        "id": 59128,
                        "name": "Provincia di Crotone",
                        "latitude": "39.12007000",
                        "longitude": "17.08134000"
                    },
                    {
                        "id": 59167,
                        "name": "Provincia di Reggio Calabria",
                        "latitude": "38.31667000",
                        "longitude": "16.08333000"
                    },
                    {
                        "id": 59188,
                        "name": "Provincia di Vibo-Valentia",
                        "latitude": "38.69958000",
                        "longitude": "16.12741000"
                    },
                    {
                        "id": 59239,
                        "name": "Quattromiglia",
                        "latitude": "39.34474000",
                        "longitude": "16.23802000"
                    },
                    {
                        "id": 59320,
                        "name": "Reggio Calabria",
                        "latitude": "38.11047000",
                        "longitude": "15.66129000"
                    },
                    {
                        "id": 59332,
                        "name": "Rende",
                        "latitude": "39.33154000",
                        "longitude": "16.18041000"
                    },
                    {
                        "id": 59353,
                        "name": "Riace",
                        "latitude": "38.41828000",
                        "longitude": "16.48121000"
                    },
                    {
                        "id": 59354,
                        "name": "Riace Marina",
                        "latitude": "38.39186000",
                        "longitude": "16.53033000"
                    },
                    {
                        "id": 59362,
                        "name": "Ricadi",
                        "latitude": "38.62517000",
                        "longitude": "15.86674000"
                    },
                    {
                        "id": 59445,
                        "name": "Rizziconi",
                        "latitude": "38.40994000",
                        "longitude": "15.95974000"
                    },
                    {
                        "id": 59488,
                        "name": "Rocca di Neto",
                        "latitude": "39.18292000",
                        "longitude": "17.00764000"
                    },
                    {
                        "id": 59470,
                        "name": "Rocca Imperiale",
                        "latitude": "40.11014000",
                        "longitude": "16.57822000"
                    },
                    {
                        "id": 59471,
                        "name": "Rocca Imperiale Marina",
                        "latitude": "40.09962000",
                        "longitude": "16.61336000"
                    },
                    {
                        "id": 59491,
                        "name": "Roccabernarda",
                        "latitude": "39.13276000",
                        "longitude": "16.86082000"
                    },
                    {
                        "id": 59499,
                        "name": "Roccaforte del Greco",
                        "latitude": "38.04751000",
                        "longitude": "15.89198000"
                    },
                    {
                        "id": 59532,
                        "name": "Roccella Ionica",
                        "latitude": "38.32117000",
                        "longitude": "16.39689000"
                    },
                    {
                        "id": 59534,
                        "name": "Roccelletta",
                        "latitude": "38.81126000",
                        "longitude": "16.59820000"
                    },
                    {
                        "id": 59558,
                        "name": "Roggiano Gravina",
                        "latitude": "39.61786000",
                        "longitude": "16.16173000"
                    },
                    {
                        "id": 59560,
                        "name": "Roghudi",
                        "latitude": "37.92499000",
                        "longitude": "15.76537000"
                    },
                    {
                        "id": 59561,
                        "name": "Rogliano",
                        "latitude": "39.17841000",
                        "longitude": "16.31709000"
                    },
                    {
                        "id": 59581,
                        "name": "Rombiolo",
                        "latitude": "38.59535000",
                        "longitude": "16.00237000"
                    },
                    {
                        "id": 59624,
                        "name": "Rosario",
                        "latitude": "39.29104000",
                        "longitude": "16.23125000"
                    },
                    {
                        "id": 59625,
                        "name": "Rosarno",
                        "latitude": "38.48717000",
                        "longitude": "15.97956000"
                    },
                    {
                        "id": 59632,
                        "name": "Rose",
                        "latitude": "39.39932000",
                        "longitude": "16.29446000"
                    },
                    {
                        "id": 59635,
                        "name": "Roseto Capo Spulico",
                        "latitude": "39.98643000",
                        "longitude": "16.60363000"
                    },
                    {
                        "id": 59647,
                        "name": "Rossano",
                        "latitude": "39.57622000",
                        "longitude": "16.63447000"
                    },
                    {
                        "id": 59648,
                        "name": "Rossano Stazione",
                        "latitude": "39.59855000",
                        "longitude": "16.63485000"
                    },
                    {
                        "id": 59654,
                        "name": "Rota Greca",
                        "latitude": "39.46703000",
                        "longitude": "16.11412000"
                    },
                    {
                        "id": 59686,
                        "name": "Rovito",
                        "latitude": "39.30636000",
                        "longitude": "16.31746000"
                    },
                    {
                        "id": 59771,
                        "name": "Saline Ioniche",
                        "latitude": "37.93957000",
                        "longitude": "15.71943000"
                    },
                    {
                        "id": 59801,
                        "name": "Sambiase",
                        "latitude": "38.96667000",
                        "longitude": "16.28333000"
                    },
                    {
                        "id": 59811,
                        "name": "Samo",
                        "latitude": "38.07399000",
                        "longitude": "16.05933000"
                    },
                    {
                        "id": 59823,
                        "name": "San Basile",
                        "latitude": "39.80960000",
                        "longitude": "16.16328000"
                    },
                    {
                        "id": 59829,
                        "name": "San Benedetto Ullano",
                        "latitude": "39.42710000",
                        "longitude": "16.12379000"
                    },
                    {
                        "id": 59850,
                        "name": "San Calogero",
                        "latitude": "38.57447000",
                        "longitude": "16.01933000"
                    },
                    {
                        "id": 59856,
                        "name": "San Carlo-Condofuri Marina",
                        "latitude": "37.93324000",
                        "longitude": "15.87166000"
                    },
                    {
                        "id": 59879,
                        "name": "San Cosmo Albanese",
                        "latitude": "39.58363000",
                        "longitude": "16.41469000"
                    },
                    {
                        "id": 59881,
                        "name": "San Costantino Calabro",
                        "latitude": "38.63283000",
                        "longitude": "16.07571000"
                    },
                    {
                        "id": 59891,
                        "name": "San Demetrio Corone",
                        "latitude": "39.56990000",
                        "longitude": "16.36149000"
                    },
                    {
                        "id": 59899,
                        "name": "San Donato di Ninea",
                        "latitude": "39.71156000",
                        "longitude": "16.04742000"
                    },
                    {
                        "id": 59913,
                        "name": "San Ferdinando",
                        "latitude": "38.48403000",
                        "longitude": "15.91877000"
                    },
                    {
                        "id": 59918,
                        "name": "San Fili",
                        "latitude": "39.33971000",
                        "longitude": "16.14448000"
                    },
                    {
                        "id": 59925,
                        "name": "San Floro",
                        "latitude": "38.83799000",
                        "longitude": "16.51870000"
                    },
                    {
                        "id": 59954,
                        "name": "San Giorgio Albanese",
                        "latitude": "39.58230000",
                        "longitude": "16.45349000"
                    },
                    {
                        "id": 59959,
                        "name": "San Giorgio Morgeto",
                        "latitude": "38.39190000",
                        "longitude": "16.08790000"
                    },
                    {
                        "id": 59995,
                        "name": "San Giovanni di Gerace",
                        "latitude": "38.36508000",
                        "longitude": "16.27770000"
                    },
                    {
                        "id": 59997,
                        "name": "San Giovanni in Fiore",
                        "latitude": "39.25446000",
                        "longitude": "16.69699000"
                    },
                    {
                        "id": 60022,
                        "name": "San Gregorio d'Ippona",
                        "latitude": "38.64528000",
                        "longitude": "16.10356000"
                    },
                    {
                        "id": 60036,
                        "name": "San Lorenzo",
                        "latitude": "38.01097000",
                        "longitude": "15.83440000"
                    },
                    {
                        "id": 60040,
                        "name": "San Lorenzo Bellizzi",
                        "latitude": "39.88867000",
                        "longitude": "16.33029000"
                    },
                    {
                        "id": 60045,
                        "name": "San Lorenzo del Vallo",
                        "latitude": "39.66739000",
                        "longitude": "16.29866000"
                    },
                    {
                        "id": 60050,
                        "name": "San Luca",
                        "latitude": "38.14672000",
                        "longitude": "16.06625000"
                    },
                    {
                        "id": 60051,
                        "name": "San Lucido",
                        "latitude": "39.31012000",
                        "longitude": "16.05317000"
                    },
                    {
                        "id": 60055,
                        "name": "San Mango d'Aquino",
                        "latitude": "39.06036000",
                        "longitude": "16.19224000"
                    },
                    {
                        "id": 60061,
                        "name": "San Marco Argentano",
                        "latitude": "39.55725000",
                        "longitude": "16.12452000"
                    },
                    {
                        "id": 60067,
                        "name": "San Martino",
                        "latitude": "38.36157000",
                        "longitude": "15.97634000"
                    },
                    {
                        "id": 60085,
                        "name": "San Martino di Finita",
                        "latitude": "39.48988000",
                        "longitude": "16.10968000"
                    },
                    {
                        "id": 60108,
                        "name": "San Mauro Marchesato",
                        "latitude": "39.10559000",
                        "longitude": "16.92561000"
                    },
                    {
                        "id": 60134,
                        "name": "San Nico",
                        "latitude": "39.66906000",
                        "longitude": "16.43182000"
                    },
                    {
                        "id": 60136,
                        "name": "San Nicola",
                        "latitude": "38.21199000",
                        "longitude": "15.69381000"
                    },
                    {
                        "id": 60137,
                        "name": "San Nicola Arcella",
                        "latitude": "39.84341000",
                        "longitude": "15.78634000"
                    },
                    {
                        "id": 60140,
                        "name": "San Nicola da Crissa",
                        "latitude": "38.66354000",
                        "longitude": "16.28592000"
                    },
                    {
                        "id": 60141,
                        "name": "San Nicola dell'Alto",
                        "latitude": "39.29094000",
                        "longitude": "16.97179000"
                    },
                    {
                        "id": 60144,
                        "name": "San Nicolò",
                        "latitude": "38.63426000",
                        "longitude": "15.85147000"
                    },
                    {
                        "id": 60186,
                        "name": "San Pietro a Maida",
                        "latitude": "38.84731000",
                        "longitude": "16.34116000"
                    },
                    {
                        "id": 60173,
                        "name": "San Pietro Apostolo",
                        "latitude": "39.00413000",
                        "longitude": "16.46783000"
                    },
                    {
                        "id": 60192,
                        "name": "San Pietro di Caridà",
                        "latitude": "38.52368000",
                        "longitude": "16.13530000"
                    },
                    {
                        "id": 60195,
                        "name": "San Pietro in Amantea",
                        "latitude": "39.13658000",
                        "longitude": "16.11243000"
                    },
                    {
                        "id": 60200,
                        "name": "San Pietro in Guarano",
                        "latitude": "39.34164000",
                        "longitude": "16.31304000"
                    },
                    {
                        "id": 60214,
                        "name": "San Procopio",
                        "latitude": "38.28214000",
                        "longitude": "15.89083000"
                    },
                    {
                        "id": 60221,
                        "name": "San Roberto",
                        "latitude": "38.21114000",
                        "longitude": "15.73594000"
                    },
                    {
                        "id": 60247,
                        "name": "San Sostene",
                        "latitude": "38.63733000",
                        "longitude": "16.48751000"
                    },
                    {
                        "id": 60248,
                        "name": "San Sosti",
                        "latitude": "39.65879000",
                        "longitude": "16.02958000"
                    },
                    {
                        "id": 60270,
                        "name": "San Vincenzo la Costa",
                        "latitude": "39.36544000",
                        "longitude": "16.15110000"
                    },
                    {
                        "id": 60278,
                        "name": "San Vito Sullo Ionio",
                        "latitude": "38.70749000",
                        "longitude": "16.40862000"
                    },
                    {
                        "id": 60306,
                        "name": "Sangineto",
                        "latitude": "39.60553000",
                        "longitude": "15.91481000"
                    },
                    {
                        "id": 60321,
                        "name": "Sant'Agata del Bianco",
                        "latitude": "38.09242000",
                        "longitude": "16.08251000"
                    },
                    {
                        "id": 60322,
                        "name": "Sant'Agata di Esaro",
                        "latitude": "39.62235000",
                        "longitude": "15.98295000"
                    },
                    {
                        "id": 60335,
                        "name": "Sant'Alessio in Aspromonte",
                        "latitude": "38.17220000",
                        "longitude": "15.75730000"
                    },
                    {
                        "id": 60344,
                        "name": "Sant'Andrea Apostolo dello Ionio",
                        "latitude": "38.62165000",
                        "longitude": "16.53048000"
                    },
                    {
                        "id": 60346,
                        "name": "Sant'Andrea Ionio Marina",
                        "latitude": "38.62001000",
                        "longitude": "16.54927000"
                    },
                    {
                        "id": 60396,
                        "name": "Sant'Elia",
                        "latitude": "38.95788000",
                        "longitude": "16.58521000"
                    },
                    {
                        "id": 60401,
                        "name": "Sant'Eufemia d'Aspromonte",
                        "latitude": "38.26314000",
                        "longitude": "15.85669000"
                    },
                    {
                        "id": 60405,
                        "name": "Sant'Ilario dello Ionio",
                        "latitude": "38.21914000",
                        "longitude": "16.19517000"
                    },
                    {
                        "id": 60409,
                        "name": "Sant'Onofrio",
                        "latitude": "38.69752000",
                        "longitude": "16.14755000"
                    },
                    {
                        "id": 60414,
                        "name": "Santa Caterina Albanese",
                        "latitude": "39.58590000",
                        "longitude": "16.07039000"
                    },
                    {
                        "id": 60416,
                        "name": "Santa Caterina dello Ionio",
                        "latitude": "38.53324000",
                        "longitude": "16.52176000"
                    },
                    {
                        "id": 60417,
                        "name": "Santa Caterina dello Ionio Marina",
                        "latitude": "38.52736000",
                        "longitude": "16.57071000"
                    },
                    {
                        "id": 60424,
                        "name": "Santa Cristina d'Aspromonte",
                        "latitude": "38.25480000",
                        "longitude": "15.96996000"
                    },
                    {
                        "id": 60431,
                        "name": "Santa Domenica",
                        "latitude": "38.66220000",
                        "longitude": "15.86289000"
                    },
                    {
                        "id": 60432,
                        "name": "Santa Domenica Talao",
                        "latitude": "39.81875000",
                        "longitude": "15.85380000"
                    },
                    {
                        "id": 60435,
                        "name": "Santa Eufemia Lamezia",
                        "latitude": "38.91982000",
                        "longitude": "16.25221000"
                    },
                    {
                        "id": 60473,
                        "name": "Santa Maria del Cedro",
                        "latitude": "39.74620000",
                        "longitude": "15.83638000"
                    },
                    {
                        "id": 60490,
                        "name": "Santa Severina",
                        "latitude": "39.14770000",
                        "longitude": "16.91112000"
                    },
                    {
                        "id": 60492,
                        "name": "Santa Sofia d'Epiro",
                        "latitude": "39.54597000",
                        "longitude": "16.32815000"
                    },
                    {
                        "id": 60511,
                        "name": "Santo Stefano",
                        "latitude": "39.34734000",
                        "longitude": "16.19898000"
                    },
                    {
                        "id": 60523,
                        "name": "Santo Stefano di Rogliano",
                        "latitude": "39.19223000",
                        "longitude": "16.32079000"
                    },
                    {
                        "id": 60525,
                        "name": "Santo Stefano in Aspromonte",
                        "latitude": "38.16909000",
                        "longitude": "15.78983000"
                    },
                    {
                        "id": 60539,
                        "name": "Saracena",
                        "latitude": "39.77862000",
                        "longitude": "16.15913000"
                    },
                    {
                        "id": 60559,
                        "name": "Sartano",
                        "latitude": "39.51169000",
                        "longitude": "16.17915000"
                    },
                    {
                        "id": 60578,
                        "name": "Satriano",
                        "latitude": "38.66640000",
                        "longitude": "16.47970000"
                    },
                    {
                        "id": 60585,
                        "name": "Savelli",
                        "latitude": "39.31278000",
                        "longitude": "16.77642000"
                    },
                    {
                        "id": 60605,
                        "name": "Scala Coeli",
                        "latitude": "39.44824000",
                        "longitude": "16.88658000"
                    },
                    {
                        "id": 60607,
                        "name": "Scalea",
                        "latitude": "39.80605000",
                        "longitude": "15.79635000"
                    },
                    {
                        "id": 60615,
                        "name": "Scandale",
                        "latitude": "39.12339000",
                        "longitude": "16.96185000"
                    },
                    {
                        "id": 60629,
                        "name": "Scarcelli",
                        "latitude": "39.40000000",
                        "longitude": "16.01667000"
                    },
                    {
                        "id": 60654,
                        "name": "Scido",
                        "latitude": "38.24439000",
                        "longitude": "15.93251000"
                    },
                    {
                        "id": 60655,
                        "name": "Scilla",
                        "latitude": "38.25201000",
                        "longitude": "15.71837000"
                    },
                    {
                        "id": 60701,
                        "name": "Sellia",
                        "latitude": "38.98206000",
                        "longitude": "16.63070000"
                    },
                    {
                        "id": 60702,
                        "name": "Sellia Marina",
                        "latitude": "38.88599000",
                        "longitude": "16.74931000"
                    },
                    {
                        "id": 60715,
                        "name": "Seminara",
                        "latitude": "38.33603000",
                        "longitude": "15.87025000"
                    },
                    {
                        "id": 60755,
                        "name": "Serra d'Aiello",
                        "latitude": "39.09004000",
                        "longitude": "16.12612000"
                    },
                    {
                        "id": 60750,
                        "name": "Serra Pedace",
                        "latitude": "39.27898000",
                        "longitude": "16.34557000"
                    },
                    {
                        "id": 60752,
                        "name": "Serra San Bruno",
                        "latitude": "38.57474000",
                        "longitude": "16.32622000"
                    },
                    {
                        "id": 60769,
                        "name": "Serrastretta",
                        "latitude": "39.01319000",
                        "longitude": "16.41630000"
                    },
                    {
                        "id": 60770,
                        "name": "Serrata",
                        "latitude": "38.51288000",
                        "longitude": "16.10070000"
                    },
                    {
                        "id": 60785,
                        "name": "Sersale",
                        "latitude": "39.01013000",
                        "longitude": "16.72960000"
                    },
                    {
                        "id": 60811,
                        "name": "Settimo",
                        "latitude": "39.39158000",
                        "longitude": "16.23998000"
                    },
                    {
                        "id": 60817,
                        "name": "Settingiano",
                        "latitude": "38.91139000",
                        "longitude": "16.51390000"
                    },
                    {
                        "id": 60835,
                        "name": "Siano",
                        "latitude": "38.91547000",
                        "longitude": "16.60224000"
                    },
                    {
                        "id": 60838,
                        "name": "Sibari",
                        "latitude": "39.74733000",
                        "longitude": "16.45510000"
                    },
                    {
                        "id": 60842,
                        "name": "Siderno",
                        "latitude": "38.26993000",
                        "longitude": "16.29607000"
                    },
                    {
                        "id": 60861,
                        "name": "Simbario",
                        "latitude": "38.61157000",
                        "longitude": "16.33597000"
                    },
                    {
                        "id": 60870,
                        "name": "Sinopoli",
                        "latitude": "38.26342000",
                        "longitude": "15.87710000"
                    },
                    {
                        "id": 60949,
                        "name": "Sorbo San Basile",
                        "latitude": "39.01939000",
                        "longitude": "16.56910000"
                    },
                    {
                        "id": 60958,
                        "name": "Sorianello",
                        "latitude": "38.59415000",
                        "longitude": "16.23212000"
                    },
                    {
                        "id": 60959,
                        "name": "Soriano Calabro",
                        "latitude": "38.60038000",
                        "longitude": "16.22205000"
                    },
                    {
                        "id": 60977,
                        "name": "Soverato Marina",
                        "latitude": "38.68498000",
                        "longitude": "16.54991000"
                    },
                    {
                        "id": 60978,
                        "name": "Soverato Superiore",
                        "latitude": "38.68993000",
                        "longitude": "16.53391000"
                    },
                    {
                        "id": 60980,
                        "name": "Soveria Mannelli",
                        "latitude": "39.07784000",
                        "longitude": "16.37708000"
                    },
                    {
                        "id": 60981,
                        "name": "Soveria Simeri",
                        "latitude": "38.94986000",
                        "longitude": "16.67854000"
                    },
                    {
                        "id": 60989,
                        "name": "Spadola",
                        "latitude": "38.60378000",
                        "longitude": "16.33700000"
                    },
                    {
                        "id": 61001,
                        "name": "Spezzano Albanese",
                        "latitude": "39.66854000",
                        "longitude": "16.30939000"
                    },
                    {
                        "id": 61003,
                        "name": "Spezzano della Sila",
                        "latitude": "39.30033000",
                        "longitude": "16.33923000"
                    },
                    {
                        "id": 61002,
                        "name": "Spezzano Piccolo",
                        "latitude": "39.29010000",
                        "longitude": "16.34211000"
                    },
                    {
                        "id": 61012,
                        "name": "Spilinga",
                        "latitude": "38.62825000",
                        "longitude": "15.90572000"
                    },
                    {
                        "id": 61034,
                        "name": "Squillace",
                        "latitude": "38.78091000",
                        "longitude": "16.51175000"
                    },
                    {
                        "id": 61035,
                        "name": "Squillace Lido",
                        "latitude": "38.77781000",
                        "longitude": "16.57007000"
                    },
                    {
                        "id": 61042,
                        "name": "Staiti",
                        "latitude": "37.99989000",
                        "longitude": "16.03341000"
                    },
                    {
                        "id": 61043,
                        "name": "Staletti",
                        "latitude": "38.76428000",
                        "longitude": "16.53932000"
                    },
                    {
                        "id": 61053,
                        "name": "Stazione Montalto-Coretto",
                        "latitude": "39.40720000",
                        "longitude": "16.24313000"
                    },
                    {
                        "id": 61060,
                        "name": "Stefanaconi",
                        "latitude": "38.67788000",
                        "longitude": "16.12420000"
                    },
                    {
                        "id": 61074,
                        "name": "Stignano",
                        "latitude": "38.41705000",
                        "longitude": "16.47011000"
                    },
                    {
                        "id": 61075,
                        "name": "Stilo",
                        "latitude": "38.47628000",
                        "longitude": "16.46746000"
                    },
                    {
                        "id": 61099,
                        "name": "Strongoli",
                        "latitude": "39.26576000",
                        "longitude": "17.05413000"
                    },
                    {
                        "id": 61127,
                        "name": "Surdo",
                        "latitude": "39.32752000",
                        "longitude": "16.20139000"
                    },
                    {
                        "id": 61168,
                        "name": "Tarsia",
                        "latitude": "39.62311000",
                        "longitude": "16.27337000"
                    },
                    {
                        "id": 61176,
                        "name": "Taurianova",
                        "latitude": "38.35525000",
                        "longitude": "16.01306000"
                    },
                    {
                        "id": 61184,
                        "name": "Taverna",
                        "latitude": "39.02200000",
                        "longitude": "16.58081000"
                    },
                    {
                        "id": 61240,
                        "name": "Terranova da Sibari",
                        "latitude": "39.65548000",
                        "longitude": "16.33979000"
                    },
                    {
                        "id": 61239,
                        "name": "Terranova Sappo Minulio",
                        "latitude": "38.32175000",
                        "longitude": "16.00747000"
                    },
                    {
                        "id": 61247,
                        "name": "Terravecchia",
                        "latitude": "39.46594000",
                        "longitude": "16.94623000"
                    },
                    {
                        "id": 61284,
                        "name": "Tiriolo",
                        "latitude": "38.94069000",
                        "longitude": "16.51046000"
                    },
                    {
                        "id": 61289,
                        "name": "Tivolille Pasquali-Merenzata",
                        "latitude": "39.27953000",
                        "longitude": "16.20738000"
                    },
                    {
                        "id": 61316,
                        "name": "Torano Castello",
                        "latitude": "39.50396000",
                        "longitude": "16.16103000"
                    },
                    {
                        "id": 61375,
                        "name": "Torre di Ruggiero",
                        "latitude": "38.65293000",
                        "longitude": "16.37211000"
                    },
                    {
                        "id": 61355,
                        "name": "Torre Melissa",
                        "latitude": "39.31013000",
                        "longitude": "17.10660000"
                    },
                    {
                        "id": 61390,
                        "name": "Torretta",
                        "latitude": "39.45358000",
                        "longitude": "17.03632000"
                    },
                    {
                        "id": 61413,
                        "name": "Tortora",
                        "latitude": "39.94130000",
                        "longitude": "15.80518000"
                    },
                    {
                        "id": 61414,
                        "name": "Tortora Marina",
                        "latitude": "39.92293000",
                        "longitude": "15.76943000"
                    },
                    {
                        "id": 61462,
                        "name": "Trebisacce",
                        "latitude": "39.87128000",
                        "longitude": "16.53420000"
                    },
                    {
                        "id": 61481,
                        "name": "Trenta",
                        "latitude": "39.28541000",
                        "longitude": "16.32093000"
                    },
                    {
                        "id": 61552,
                        "name": "Tronca",
                        "latitude": "39.24617000",
                        "longitude": "17.10582000"
                    },
                    {
                        "id": 61556,
                        "name": "Tropea",
                        "latitude": "38.67449000",
                        "longitude": "15.89505000"
                    },
                    {
                        "id": 61598,
                        "name": "Umbriatico",
                        "latitude": "39.35336000",
                        "longitude": "16.91798000"
                    },
                    {
                        "id": 61622,
                        "name": "Vaccarizzo Albanese",
                        "latitude": "39.58540000",
                        "longitude": "16.43289000"
                    },
                    {
                        "id": 61632,
                        "name": "Vadue",
                        "latitude": "39.28060000",
                        "longitude": "16.22875000"
                    },
                    {
                        "id": 61707,
                        "name": "Vallefiorita",
                        "latitude": "38.77638000",
                        "longitude": "16.46100000"
                    },
                    {
                        "id": 61709,
                        "name": "Vallelonga",
                        "latitude": "38.64742000",
                        "longitude": "16.29659000"
                    },
                    {
                        "id": 61763,
                        "name": "Varapodio",
                        "latitude": "38.31633000",
                        "longitude": "15.98347000"
                    },
                    {
                        "id": 61785,
                        "name": "Vazzano",
                        "latitude": "38.63288000",
                        "longitude": "16.24800000"
                    },
                    {
                        "id": 61835,
                        "name": "Verbicaro",
                        "latitude": "39.76076000",
                        "longitude": "15.90730000"
                    },
                    {
                        "id": 61877,
                        "name": "Verzino",
                        "latitude": "39.31325000",
                        "longitude": "16.85613000"
                    },
                    {
                        "id": 61907,
                        "name": "Vibo Valentia",
                        "latitude": "38.67618000",
                        "longitude": "16.10094000"
                    },
                    {
                        "id": 62017,
                        "name": "Villa San Giovanni",
                        "latitude": "38.21991000",
                        "longitude": "15.63689000"
                    },
                    {
                        "id": 62117,
                        "name": "Villapiana",
                        "latitude": "39.84573000",
                        "longitude": "16.45528000"
                    },
                    {
                        "id": 62118,
                        "name": "Villapiana Lido",
                        "latitude": "39.81203000",
                        "longitude": "16.48820000"
                    },
                    {
                        "id": 62227,
                        "name": "Weather Station",
                        "latitude": "37.96136000",
                        "longitude": "16.09970000"
                    },
                    {
                        "id": 62228,
                        "name": "Zaccanopoli",
                        "latitude": "38.66548000",
                        "longitude": "15.92874000"
                    },
                    {
                        "id": 62230,
                        "name": "Zagarise",
                        "latitude": "38.99985000",
                        "longitude": "16.66420000"
                    },
                    {
                        "id": 62233,
                        "name": "Zambrone",
                        "latitude": "38.69878000",
                        "longitude": "15.98982000"
                    },
                    {
                        "id": 62285,
                        "name": "Zumpano",
                        "latitude": "39.31053000",
                        "longitude": "16.29269000"
                    },
                    {
                        "id": 62287,
                        "name": "Zungri",
                        "latitude": "38.65668000",
                        "longitude": "15.98409000"
                    }
                ]
            },
            {
                "id": 1718,
                "name": "Caltanissetta",
                "iso2": "CL",
                "latitude": "37.48601300",
                "longitude": "14.06149820",
                "type": "free municipal consortium",
                "cities": []
            },
            {
                "id": 1669,
                "name": "Campania",
                "iso2": "72",
                "latitude": "40.66708870",
                "longitude": "15.10681130",
                "type": "region",
                "cities": [
                    {
                        "id": 135254,
                        "name": "Acerno",
                        "latitude": "40.73771000",
                        "longitude": "15.05695000"
                    },
                    {
                        "id": 135255,
                        "name": "Acerra",
                        "latitude": "40.94477000",
                        "longitude": "14.37140000"
                    },
                    {
                        "id": 135294,
                        "name": "Afragola",
                        "latitude": "40.92298000",
                        "longitude": "14.30935000"
                    },
                    {
                        "id": 135298,
                        "name": "Agerola",
                        "latitude": "40.63771000",
                        "longitude": "14.53884000"
                    },
                    {
                        "id": 135319,
                        "name": "Agropoli",
                        "latitude": "40.34923000",
                        "longitude": "14.99067000"
                    },
                    {
                        "id": 135328,
                        "name": "Aiello del Sabato",
                        "latitude": "40.88847000",
                        "longitude": "14.82123000"
                    },
                    {
                        "id": 135330,
                        "name": "Ailano",
                        "latitude": "41.39001000",
                        "longitude": "14.20536000"
                    },
                    {
                        "id": 135334,
                        "name": "Airola",
                        "latitude": "41.05871000",
                        "longitude": "14.55924000"
                    },
                    {
                        "id": 135350,
                        "name": "Albanella",
                        "latitude": "40.47943000",
                        "longitude": "15.11454000"
                    },
                    {
                        "id": 135399,
                        "name": "Alfano",
                        "latitude": "40.17687000",
                        "longitude": "15.42450000"
                    },
                    {
                        "id": 135411,
                        "name": "Alife",
                        "latitude": "41.32612000",
                        "longitude": "14.33403000"
                    },
                    {
                        "id": 135432,
                        "name": "Altavilla Irpina",
                        "latitude": "41.00619000",
                        "longitude": "14.78093000"
                    },
                    {
                        "id": 135435,
                        "name": "Altavilla Silentina",
                        "latitude": "40.53012000",
                        "longitude": "15.13153000"
                    },
                    {
                        "id": 135448,
                        "name": "Alvignano",
                        "latitude": "41.24427000",
                        "longitude": "14.33671000"
                    },
                    {
                        "id": 135456,
                        "name": "Amalfi",
                        "latitude": "40.63490000",
                        "longitude": "14.60238000"
                    },
                    {
                        "id": 135472,
                        "name": "Amodio-Massariola",
                        "latitude": "40.88872000",
                        "longitude": "14.09091000"
                    },
                    {
                        "id": 135473,
                        "name": "Amorosi",
                        "latitude": "41.20273000",
                        "longitude": "14.46598000"
                    },
                    {
                        "id": 135475,
                        "name": "Anacapri",
                        "latitude": "40.55170000",
                        "longitude": "14.21225000"
                    },
                    {
                        "id": 135490,
                        "name": "Andretta-Mattinella",
                        "latitude": "40.93742000",
                        "longitude": "15.32485000"
                    },
                    {
                        "id": 135500,
                        "name": "Angri",
                        "latitude": "40.73815000",
                        "longitude": "14.57070000"
                    },
                    {
                        "id": 135508,
                        "name": "Annunziata",
                        "latitude": "41.12100000",
                        "longitude": "14.36518000"
                    },
                    {
                        "id": 135515,
                        "name": "Antessano",
                        "latitude": "40.73293000",
                        "longitude": "14.77744000"
                    },
                    {
                        "id": 135532,
                        "name": "Apice Vecchio",
                        "latitude": "41.12012000",
                        "longitude": "14.93104000"
                    },
                    {
                        "id": 135534,
                        "name": "Apollosa",
                        "latitude": "41.09156000",
                        "longitude": "14.69625000"
                    },
                    {
                        "id": 135543,
                        "name": "Aquara",
                        "latitude": "40.44391000",
                        "longitude": "15.25386000"
                    },
                    {
                        "id": 135546,
                        "name": "Aquilonia",
                        "latitude": "40.98688000",
                        "longitude": "15.47510000"
                    },
                    {
                        "id": 135587,
                        "name": "Arenella",
                        "latitude": "40.85734000",
                        "longitude": "14.22280000"
                    },
                    {
                        "id": 135599,
                        "name": "Ariano",
                        "latitude": "40.65668000",
                        "longitude": "15.02481000"
                    },
                    {
                        "id": 135600,
                        "name": "Ariano Irpino-Martiri",
                        "latitude": "41.16024000",
                        "longitude": "15.10625000"
                    },
                    {
                        "id": 135603,
                        "name": "Arienzo",
                        "latitude": "41.02734000",
                        "longitude": "14.49770000"
                    },
                    {
                        "id": 135606,
                        "name": "Ariola",
                        "latitude": "40.62795000",
                        "longitude": "15.43453000"
                    },
                    {
                        "id": 135623,
                        "name": "Arola-Preazzano",
                        "latitude": "40.63333000",
                        "longitude": "14.43333000"
                    },
                    {
                        "id": 135626,
                        "name": "Arpaia",
                        "latitude": "41.03678000",
                        "longitude": "14.55175000"
                    },
                    {
                        "id": 135627,
                        "name": "Arpaise",
                        "latitude": "41.02977000",
                        "longitude": "14.74387000"
                    },
                    {
                        "id": 135629,
                        "name": "Arpino",
                        "latitude": "40.88882000",
                        "longitude": "14.32015000"
                    },
                    {
                        "id": 135649,
                        "name": "Arzano",
                        "latitude": "40.90959000",
                        "longitude": "14.26519000"
                    },
                    {
                        "id": 135653,
                        "name": "Ascea",
                        "latitude": "40.14082000",
                        "longitude": "15.18583000"
                    },
                    {
                        "id": 135674,
                        "name": "Atena Lucana",
                        "latitude": "40.45464000",
                        "longitude": "15.55633000"
                    },
                    {
                        "id": 135678,
                        "name": "Atrani",
                        "latitude": "40.63617000",
                        "longitude": "14.60933000"
                    },
                    {
                        "id": 135680,
                        "name": "Atripalda",
                        "latitude": "40.91867000",
                        "longitude": "14.82721000"
                    },
                    {
                        "id": 135686,
                        "name": "Auletta",
                        "latitude": "40.56116000",
                        "longitude": "15.42313000"
                    },
                    {
                        "id": 135699,
                        "name": "Avella",
                        "latitude": "40.95995000",
                        "longitude": "14.60087000"
                    },
                    {
                        "id": 135700,
                        "name": "Avellino",
                        "latitude": "40.91494000",
                        "longitude": "14.79103000"
                    },
                    {
                        "id": 135702,
                        "name": "Aversa",
                        "latitude": "40.97259000",
                        "longitude": "14.20745000"
                    },
                    {
                        "id": 135715,
                        "name": "Avvocata",
                        "latitude": "40.85432000",
                        "longitude": "14.24325000"
                    },
                    {
                        "id": 135729,
                        "name": "Bacoli",
                        "latitude": "40.79672000",
                        "longitude": "14.07349000"
                    },
                    {
                        "id": 135762,
                        "name": "Bagnoli",
                        "latitude": "40.81322000",
                        "longitude": "14.16807000"
                    },
                    {
                        "id": 135763,
                        "name": "Bagnoli Irpino",
                        "latitude": "40.83103000",
                        "longitude": "15.07173000"
                    },
                    {
                        "id": 135777,
                        "name": "Baia",
                        "latitude": "41.30366000",
                        "longitude": "14.25016000"
                    },
                    {
                        "id": 135778,
                        "name": "Baiano",
                        "latitude": "40.95142000",
                        "longitude": "14.61650000"
                    },
                    {
                        "id": 135805,
                        "name": "Banzano",
                        "latitude": "40.84338000",
                        "longitude": "14.80182000"
                    },
                    {
                        "id": 135812,
                        "name": "Barano d'Ischia",
                        "latitude": "40.71472000",
                        "longitude": "13.92522000"
                    },
                    {
                        "id": 135865,
                        "name": "Baronissi",
                        "latitude": "40.74817000",
                        "longitude": "14.77380000"
                    },
                    {
                        "id": 135867,
                        "name": "Barra",
                        "latitude": "40.84255000",
                        "longitude": "14.31849000"
                    },
                    {
                        "id": 135883,
                        "name": "Baselice",
                        "latitude": "41.39296000",
                        "longitude": "14.97363000"
                    },
                    {
                        "id": 135909,
                        "name": "Battipaglia",
                        "latitude": "40.60861000",
                        "longitude": "14.98209000"
                    },
                    {
                        "id": 135945,
                        "name": "Bellizzi",
                        "latitude": "40.61981000",
                        "longitude": "14.94685000"
                    },
                    {
                        "id": 135947,
                        "name": "Bellona",
                        "latitude": "41.16052000",
                        "longitude": "14.23313000"
                    },
                    {
                        "id": 135948,
                        "name": "Bellosguardo",
                        "latitude": "40.42222000",
                        "longitude": "15.31219000"
                    },
                    {
                        "id": 135959,
                        "name": "Beltiglio-San Giovanni",
                        "latitude": "41.06239000",
                        "longitude": "14.75273000"
                    },
                    {
                        "id": 135976,
                        "name": "Benevento",
                        "latitude": "41.13070000",
                        "longitude": "14.77816000"
                    },
                    {
                        "id": 136058,
                        "name": "Bisaccia",
                        "latitude": "41.00923000",
                        "longitude": "15.37699000"
                    },
                    {
                        "id": 136059,
                        "name": "Bisaccia Nuova",
                        "latitude": "41.00960000",
                        "longitude": "15.35546000"
                    },
                    {
                        "id": 136071,
                        "name": "Bivio Mortola",
                        "latitude": "41.39557000",
                        "longitude": "13.89663000"
                    },
                    {
                        "id": 136073,
                        "name": "Bivio Santa Cecilia",
                        "latitude": "40.52224000",
                        "longitude": "15.00018000"
                    },
                    {
                        "id": 136134,
                        "name": "Bonea",
                        "latitude": "41.07312000",
                        "longitude": "14.61683000"
                    },
                    {
                        "id": 136139,
                        "name": "Bonito",
                        "latitude": "41.09857000",
                        "longitude": "15.00071000"
                    },
                    {
                        "id": 136170,
                        "name": "Borgo",
                        "latitude": "40.84022000",
                        "longitude": "14.78364000"
                    },
                    {
                        "id": 136247,
                        "name": "Boscoreale",
                        "latitude": "40.77274000",
                        "longitude": "14.48118000"
                    },
                    {
                        "id": 136248,
                        "name": "Boscotrecase",
                        "latitude": "40.77296000",
                        "longitude": "14.46185000"
                    },
                    {
                        "id": 136282,
                        "name": "Bracigliano",
                        "latitude": "40.81880000",
                        "longitude": "14.70772000"
                    },
                    {
                        "id": 136322,
                        "name": "Brezza",
                        "latitude": "41.11073000",
                        "longitude": "14.11201000"
                    },
                    {
                        "id": 136375,
                        "name": "Brusciano",
                        "latitude": "40.92237000",
                        "longitude": "14.42386000"
                    },
                    {
                        "id": 136386,
                        "name": "Bucciano",
                        "latitude": "41.07756000",
                        "longitude": "14.56898000"
                    },
                    {
                        "id": 136388,
                        "name": "Buccino",
                        "latitude": "40.63670000",
                        "longitude": "15.38116000"
                    },
                    {
                        "id": 136405,
                        "name": "Buonabitacolo",
                        "latitude": "40.26855000",
                        "longitude": "15.62119000"
                    },
                    {
                        "id": 136406,
                        "name": "Buonalbergo",
                        "latitude": "41.22236000",
                        "longitude": "14.97799000"
                    },
                    {
                        "id": 136466,
                        "name": "Caggiano",
                        "latitude": "40.56240000",
                        "longitude": "15.49629000"
                    },
                    {
                        "id": 136474,
                        "name": "Caianello",
                        "latitude": "41.30509000",
                        "longitude": "14.08516000"
                    },
                    {
                        "id": 136475,
                        "name": "Caiazzo",
                        "latitude": "41.18435000",
                        "longitude": "14.35946000"
                    },
                    {
                        "id": 136481,
                        "name": "Cairano",
                        "latitude": "40.89552000",
                        "longitude": "15.37069000"
                    },
                    {
                        "id": 136484,
                        "name": "Caivano",
                        "latitude": "40.95753000",
                        "longitude": "14.30591000"
                    },
                    {
                        "id": 136486,
                        "name": "Calabritto",
                        "latitude": "40.78342000",
                        "longitude": "15.22285000"
                    },
                    {
                        "id": 136529,
                        "name": "Calitri",
                        "latitude": "40.92569000",
                        "longitude": "15.40393000"
                    },
                    {
                        "id": 136551,
                        "name": "Calvanico",
                        "latitude": "40.77616000",
                        "longitude": "14.82697000"
                    },
                    {
                        "id": 136557,
                        "name": "Calvi",
                        "latitude": "41.07162000",
                        "longitude": "14.86524000"
                    },
                    {
                        "id": 136558,
                        "name": "Calvi Risorta",
                        "latitude": "41.21598000",
                        "longitude": "14.13092000"
                    },
                    {
                        "id": 136564,
                        "name": "Calvizzano",
                        "latitude": "40.90782000",
                        "longitude": "14.18581000"
                    },
                    {
                        "id": 136585,
                        "name": "Camerota",
                        "latitude": "40.03262000",
                        "longitude": "15.37048000"
                    },
                    {
                        "id": 136586,
                        "name": "Camigliano",
                        "latitude": "41.18116000",
                        "longitude": "14.20978000"
                    },
                    {
                        "id": 136599,
                        "name": "Campagna",
                        "latitude": "40.66661000",
                        "longitude": "15.10638000"
                    },
                    {
                        "id": 136608,
                        "name": "Campanarello",
                        "latitude": "41.04717000",
                        "longitude": "14.91418000"
                    },
                    {
                        "id": 136658,
                        "name": "Campolattaro",
                        "latitude": "41.28693000",
                        "longitude": "14.73043000"
                    },
                    {
                        "id": 136661,
                        "name": "Campoli del Monte Taburno",
                        "latitude": "41.13074000",
                        "longitude": "14.64649000"
                    },
                    {
                        "id": 136672,
                        "name": "Campora",
                        "latitude": "40.30541000",
                        "longitude": "15.29236000"
                    },
                    {
                        "id": 136680,
                        "name": "Camposano",
                        "latitude": "40.95242000",
                        "longitude": "14.52991000"
                    },
                    {
                        "id": 136695,
                        "name": "Cancello-Arnone",
                        "latitude": "41.07340000",
                        "longitude": "14.02542000"
                    },
                    {
                        "id": 136703,
                        "name": "Candida",
                        "latitude": "40.94148000",
                        "longitude": "14.87230000"
                    },
                    {
                        "id": 136718,
                        "name": "Cannalonga",
                        "latitude": "40.24461000",
                        "longitude": "15.29325000"
                    },
                    {
                        "id": 136756,
                        "name": "Capaccio",
                        "latitude": "40.42435000",
                        "longitude": "15.07981000"
                    },
                    {
                        "id": 136757,
                        "name": "Capaccio Scalo",
                        "latitude": "40.45531000",
                        "longitude": "15.00891000"
                    },
                    {
                        "id": 136766,
                        "name": "Capezzano Inferiore",
                        "latitude": "40.70067000",
                        "longitude": "14.77301000"
                    },
                    {
                        "id": 136767,
                        "name": "Capezzano-Cologna",
                        "latitude": "40.71518000",
                        "longitude": "14.77364000"
                    },
                    {
                        "id": 136775,
                        "name": "Capitignano",
                        "latitude": "40.71851000",
                        "longitude": "14.90465000"
                    },
                    {
                        "id": 136782,
                        "name": "Capodrise",
                        "latitude": "41.04268000",
                        "longitude": "14.30607000"
                    },
                    {
                        "id": 136787,
                        "name": "Caposele",
                        "latitude": "40.81553000",
                        "longitude": "15.22337000"
                    },
                    {
                        "id": 136809,
                        "name": "Capri",
                        "latitude": "40.55073000",
                        "longitude": "14.24263000"
                    },
                    {
                        "id": 136816,
                        "name": "Capriati A Volturno",
                        "latitude": "41.46801000",
                        "longitude": "14.14602000"
                    },
                    {
                        "id": 136818,
                        "name": "Capriglia",
                        "latitude": "40.73216000",
                        "longitude": "14.76035000"
                    },
                    {
                        "id": 136819,
                        "name": "Capriglia Irpina",
                        "latitude": "40.96032000",
                        "longitude": "14.77724000"
                    },
                    {
                        "id": 136825,
                        "name": "Capua",
                        "latitude": "41.10519000",
                        "longitude": "14.21269000"
                    },
                    {
                        "id": 136832,
                        "name": "Carano",
                        "latitude": "41.20526000",
                        "longitude": "13.90972000"
                    },
                    {
                        "id": 136847,
                        "name": "Carbonara di Nola",
                        "latitude": "40.87441000",
                        "longitude": "14.57884000"
                    },
                    {
                        "id": 136862,
                        "name": "Cardito",
                        "latitude": "40.94590000",
                        "longitude": "14.29952000"
                    },
                    {
                        "id": 136875,
                        "name": "Carife",
                        "latitude": "41.02667000",
                        "longitude": "15.21044000"
                    },
                    {
                        "id": 136876,
                        "name": "Carifi-Torello-Priscoli",
                        "latitude": "40.79136000",
                        "longitude": "14.73212000"
                    },
                    {
                        "id": 136879,
                        "name": "Carinaro",
                        "latitude": "40.98291000",
                        "longitude": "14.21963000"
                    },
                    {
                        "id": 136881,
                        "name": "Carinola",
                        "latitude": "41.18775000",
                        "longitude": "13.98240000"
                    },
                    {
                        "id": 136956,
                        "name": "Casagiove",
                        "latitude": "41.07124000",
                        "longitude": "14.31163000"
                    },
                    {
                        "id": 136960,
                        "name": "Casal di Principe",
                        "latitude": "41.00996000",
                        "longitude": "14.13013000"
                    },
                    {
                        "id": 136959,
                        "name": "Casal Velino",
                        "latitude": "40.19034000",
                        "longitude": "15.11137000"
                    },
                    {
                        "id": 136966,
                        "name": "Casalbore",
                        "latitude": "41.23373000",
                        "longitude": "15.00752000"
                    },
                    {
                        "id": 136968,
                        "name": "Casalbuono",
                        "latitude": "40.21425000",
                        "longitude": "15.68717000"
                    },
                    {
                        "id": 136971,
                        "name": "Casalduni",
                        "latitude": "41.26080000",
                        "longitude": "14.69532000"
                    },
                    {
                        "id": 136972,
                        "name": "Casale",
                        "latitude": "41.21972000",
                        "longitude": "14.00231000"
                    },
                    {
                        "id": 136987,
                        "name": "Casaletto Spartano",
                        "latitude": "40.15134000",
                        "longitude": "15.62058000"
                    },
                    {
                        "id": 136994,
                        "name": "Casali-San Potito",
                        "latitude": "40.76390000",
                        "longitude": "14.67501000"
                    },
                    {
                        "id": 137004,
                        "name": "Casalnuovo di Napoli",
                        "latitude": "40.90969000",
                        "longitude": "14.34205000"
                    },
                    {
                        "id": 137009,
                        "name": "Casaluce",
                        "latitude": "40.99785000",
                        "longitude": "14.19671000"
                    },
                    {
                        "id": 137015,
                        "name": "Casamarciano",
                        "latitude": "40.93191000",
                        "longitude": "14.55324000"
                    },
                    {
                        "id": 137018,
                        "name": "Casamicciola Terme",
                        "latitude": "40.74661000",
                        "longitude": "13.91202000"
                    },
                    {
                        "id": 137019,
                        "name": "Casandrino",
                        "latitude": "40.92845000",
                        "longitude": "14.24744000"
                    },
                    {
                        "id": 137021,
                        "name": "Casanova",
                        "latitude": "41.19254000",
                        "longitude": "13.96344000"
                    },
                    {
                        "id": 137026,
                        "name": "Casapesenna",
                        "latitude": "40.99151000",
                        "longitude": "14.13613000"
                    },
                    {
                        "id": 137029,
                        "name": "Casapulla",
                        "latitude": "41.07665000",
                        "longitude": "14.28927000"
                    },
                    {
                        "id": 137031,
                        "name": "Casarea",
                        "latitude": "40.88828000",
                        "longitude": "14.36349000"
                    },
                    {
                        "id": 137041,
                        "name": "Casavatore",
                        "latitude": "40.89921000",
                        "longitude": "14.27663000"
                    },
                    {
                        "id": 137044,
                        "name": "Cascano",
                        "latitude": "41.23232000",
                        "longitude": "13.96927000"
                    },
                    {
                        "id": 137063,
                        "name": "Caselle in Pittari",
                        "latitude": "40.17319000",
                        "longitude": "15.54311000"
                    },
                    {
                        "id": 137065,
                        "name": "Caserta",
                        "latitude": "41.07262000",
                        "longitude": "14.33231000"
                    },
                    {
                        "id": 137077,
                        "name": "Casola",
                        "latitude": "41.09513000",
                        "longitude": "14.38172000"
                    },
                    {
                        "id": 137079,
                        "name": "Casola di Napoli",
                        "latitude": "40.69780000",
                        "longitude": "14.53006000"
                    },
                    {
                        "id": 137089,
                        "name": "Casoria",
                        "latitude": "40.90751000",
                        "longitude": "14.29300000"
                    },
                    {
                        "id": 137096,
                        "name": "Cassano Irpino",
                        "latitude": "40.87042000",
                        "longitude": "15.02595000"
                    },
                    {
                        "id": 137129,
                        "name": "Castel Baronia",
                        "latitude": "41.04832000",
                        "longitude": "15.18884000"
                    },
                    {
                        "id": 137132,
                        "name": "Castel Campagnano",
                        "latitude": "41.18240000",
                        "longitude": "14.45300000"
                    },
                    {
                        "id": 137174,
                        "name": "Castel di Sasso",
                        "latitude": "41.19242000",
                        "longitude": "14.27773000"
                    },
                    {
                        "id": 137146,
                        "name": "Castel Morrone",
                        "latitude": "41.12102000",
                        "longitude": "14.35473000"
                    },
                    {
                        "id": 137150,
                        "name": "Castel San Giorgio",
                        "latitude": "40.78198000",
                        "longitude": "14.70090000"
                    },
                    {
                        "id": 137152,
                        "name": "Castel San Lorenzo",
                        "latitude": "40.41979000",
                        "longitude": "15.22523000"
                    },
                    {
                        "id": 137161,
                        "name": "Castel Volturno",
                        "latitude": "41.03288000",
                        "longitude": "13.94354000"
                    },
                    {
                        "id": 137185,
                        "name": "Castelcivita",
                        "latitude": "40.49367000",
                        "longitude": "15.23354000"
                    },
                    {
                        "id": 137196,
                        "name": "Castelfranci",
                        "latitude": "40.93066000",
                        "longitude": "15.04331000"
                    },
                    {
                        "id": 137201,
                        "name": "Castelfranco in Miscano",
                        "latitude": "41.30072000",
                        "longitude": "15.08607000"
                    },
                    {
                        "id": 137213,
                        "name": "Castellammare di Stabia",
                        "latitude": "40.70211000",
                        "longitude": "14.48685000"
                    },
                    {
                        "id": 137257,
                        "name": "Castello del Matese",
                        "latitude": "41.36672000",
                        "longitude": "14.37773000"
                    },
                    {
                        "id": 137261,
                        "name": "Castello di Cisterna",
                        "latitude": "40.91594000",
                        "longitude": "14.41117000"
                    },
                    {
                        "id": 137288,
                        "name": "Castelnuovo Cilento",
                        "latitude": "40.21846000",
                        "longitude": "15.17802000"
                    },
                    {
                        "id": 137300,
                        "name": "Castelnuovo di Conza",
                        "latitude": "40.82062000",
                        "longitude": "15.31875000"
                    },
                    {
                        "id": 137305,
                        "name": "Castelpagano",
                        "latitude": "41.40177000",
                        "longitude": "14.80711000"
                    },
                    {
                        "id": 137309,
                        "name": "Castelpoto",
                        "latitude": "41.14066000",
                        "longitude": "14.70069000"
                    },
                    {
                        "id": 137324,
                        "name": "Castelvenere",
                        "latitude": "41.23445000",
                        "longitude": "14.54750000"
                    },
                    {
                        "id": 137327,
                        "name": "Castelvetere in Val Fortore",
                        "latitude": "41.44257000",
                        "longitude": "14.94118000"
                    },
                    {
                        "id": 137328,
                        "name": "Castelvetere sul Calore",
                        "latitude": "40.92980000",
                        "longitude": "14.98640000"
                    },
                    {
                        "id": 137352,
                        "name": "Castiglione del Genovesi",
                        "latitude": "40.72367000",
                        "longitude": "14.84796000"
                    },
                    {
                        "id": 137400,
                        "name": "Cautano",
                        "latitude": "41.15009000",
                        "longitude": "14.64425000"
                    },
                    {
                        "id": 137401,
                        "name": "Cava Dè Tirreni",
                        "latitude": "40.69954000",
                        "longitude": "14.70773000"
                    },
                    {
                        "id": 137475,
                        "name": "Celle di Bulgheria",
                        "latitude": "40.09540000",
                        "longitude": "15.40324000"
                    },
                    {
                        "id": 137482,
                        "name": "Cellole",
                        "latitude": "41.20338000",
                        "longitude": "13.85332000"
                    },
                    {
                        "id": 137499,
                        "name": "Centola",
                        "latitude": "40.06980000",
                        "longitude": "15.31191000"
                    },
                    {
                        "id": 137503,
                        "name": "Centro Urbano",
                        "latitude": "40.81986000",
                        "longitude": "15.31953000"
                    },
                    {
                        "id": 137508,
                        "name": "Ceppaloni",
                        "latitude": "41.04523000",
                        "longitude": "14.76102000"
                    },
                    {
                        "id": 137517,
                        "name": "Ceraso",
                        "latitude": "40.19430000",
                        "longitude": "15.25606000"
                    },
                    {
                        "id": 137528,
                        "name": "Cercola",
                        "latitude": "40.86043000",
                        "longitude": "14.35733000"
                    },
                    {
                        "id": 137566,
                        "name": "Cerreto Sannita",
                        "latitude": "41.28296000",
                        "longitude": "14.56147000"
                    },
                    {
                        "id": 137595,
                        "name": "Cervinara",
                        "latitude": "41.02042000",
                        "longitude": "14.61444000"
                    },
                    {
                        "id": 137596,
                        "name": "Cervino",
                        "latitude": "41.04001000",
                        "longitude": "14.42403000"
                    },
                    {
                        "id": 137600,
                        "name": "Cesa",
                        "latitude": "40.96287000",
                        "longitude": "14.23081000"
                    },
                    {
                        "id": 137613,
                        "name": "Cesinali",
                        "latitude": "40.89711000",
                        "longitude": "14.82774000"
                    },
                    {
                        "id": 137620,
                        "name": "Cetara",
                        "latitude": "40.64756000",
                        "longitude": "14.70091000"
                    },
                    {
                        "id": 137638,
                        "name": "Chiaia",
                        "latitude": "40.83255000",
                        "longitude": "14.22677000"
                    },
                    {
                        "id": 137639,
                        "name": "Chiaiano",
                        "latitude": "40.88101000",
                        "longitude": "14.20759000"
                    },
                    {
                        "id": 137642,
                        "name": "Chianche",
                        "latitude": "41.04632000",
                        "longitude": "14.78904000"
                    },
                    {
                        "id": 137693,
                        "name": "Chiusano di San Domenico",
                        "latitude": "40.93312000",
                        "longitude": "14.91634000"
                    },
                    {
                        "id": 137709,
                        "name": "Cicciano",
                        "latitude": "40.96402000",
                        "longitude": "14.53487000"
                    },
                    {
                        "id": 137710,
                        "name": "Cicerale",
                        "latitude": "40.34404000",
                        "longitude": "15.12959000"
                    },
                    {
                        "id": 137726,
                        "name": "Cimitile",
                        "latitude": "40.94231000",
                        "longitude": "14.52558000"
                    },
                    {
                        "id": 137743,
                        "name": "Ciorlano",
                        "latitude": "41.45022000",
                        "longitude": "14.15832000"
                    },
                    {
                        "id": 137746,
                        "name": "Circello",
                        "latitude": "41.35455000",
                        "longitude": "14.80910000"
                    },
                    {
                        "id": 137864,
                        "name": "Colle Sannita",
                        "latitude": "41.36374000",
                        "longitude": "14.83450000"
                    },
                    {
                        "id": 137902,
                        "name": "Colliano",
                        "latitude": "40.72293000",
                        "longitude": "15.28969000"
                    },
                    {
                        "id": 137944,
                        "name": "Comiziano",
                        "latitude": "40.95163000",
                        "longitude": "14.55124000"
                    },
                    {
                        "id": 137954,
                        "name": "Conca dei Marini",
                        "latitude": "40.61754000",
                        "longitude": "14.57311000"
                    },
                    {
                        "id": 137955,
                        "name": "Conca della Campania",
                        "latitude": "41.33174000",
                        "longitude": "13.99142000"
                    },
                    {
                        "id": 137979,
                        "name": "Contrada",
                        "latitude": "40.86811000",
                        "longitude": "14.77747000"
                    },
                    {
                        "id": 137981,
                        "name": "Controne",
                        "latitude": "40.51018000",
                        "longitude": "15.20404000"
                    },
                    {
                        "id": 137982,
                        "name": "Contursi Terme",
                        "latitude": "40.65026000",
                        "longitude": "15.24163000"
                    },
                    {
                        "id": 137985,
                        "name": "Coperchia",
                        "latitude": "40.72005000",
                        "longitude": "14.76654000"
                    },
                    {
                        "id": 137993,
                        "name": "Corbara",
                        "latitude": "40.72278000",
                        "longitude": "14.59187000"
                    },
                    {
                        "id": 138018,
                        "name": "Corleto Monforte",
                        "latitude": "40.43756000",
                        "longitude": "15.38013000"
                    },
                    {
                        "id": 138114,
                        "name": "Country Park",
                        "latitude": "40.88234000",
                        "longitude": "14.07786000"
                    },
                    {
                        "id": 138155,
                        "name": "Crispano",
                        "latitude": "40.95251000",
                        "longitude": "14.28993000"
                    },
                    {
                        "id": 138179,
                        "name": "Cuccaro Vetere",
                        "latitude": "40.16404000",
                        "longitude": "15.30677000"
                    },
                    {
                        "id": 138209,
                        "name": "Curti",
                        "latitude": "41.07616000",
                        "longitude": "14.28039000"
                    },
                    {
                        "id": 138212,
                        "name": "Cusano Mutri",
                        "latitude": "41.33624000",
                        "longitude": "14.51013000"
                    },
                    {
                        "id": 138290,
                        "name": "Domicella",
                        "latitude": "40.88019000",
                        "longitude": "14.58716000"
                    },
                    {
                        "id": 138325,
                        "name": "Dragonea",
                        "latitude": "40.67917000",
                        "longitude": "14.71094000"
                    },
                    {
                        "id": 138326,
                        "name": "Dragoni",
                        "latitude": "41.27619000",
                        "longitude": "14.30368000"
                    },
                    {
                        "id": 138340,
                        "name": "Dugenta",
                        "latitude": "41.13468000",
                        "longitude": "14.45353000"
                    },
                    {
                        "id": 138345,
                        "name": "Durazzano",
                        "latitude": "41.06286000",
                        "longitude": "14.44947000"
                    },
                    {
                        "id": 138348,
                        "name": "Eboli",
                        "latitude": "40.61747000",
                        "longitude": "15.05693000"
                    },
                    {
                        "id": 138372,
                        "name": "Ercolano",
                        "latitude": "40.80783000",
                        "longitude": "14.35012000"
                    },
                    {
                        "id": 138411,
                        "name": "Faiano",
                        "latitude": "40.66254000",
                        "longitude": "14.90244000"
                    },
                    {
                        "id": 138412,
                        "name": "Faicchio",
                        "latitude": "41.27816000",
                        "longitude": "14.47740000"
                    },
                    {
                        "id": 138414,
                        "name": "Falciano del Massico",
                        "latitude": "41.16271000",
                        "longitude": "13.94812000"
                    },
                    {
                        "id": 138444,
                        "name": "Faraldo-Nocelleto",
                        "latitude": "40.77992000",
                        "longitude": "14.76363000"
                    },
                    {
                        "id": 138470,
                        "name": "Felitto",
                        "latitude": "40.37351000",
                        "longitude": "15.24306000"
                    },
                    {
                        "id": 138545,
                        "name": "Fisciano",
                        "latitude": "40.77175000",
                        "longitude": "14.79454000"
                    },
                    {
                        "id": 138567,
                        "name": "Flumeri",
                        "latitude": "41.07623000",
                        "longitude": "15.15072000"
                    },
                    {
                        "id": 138573,
                        "name": "Foglianise",
                        "latitude": "41.16127000",
                        "longitude": "14.67112000"
                    },
                    {
                        "id": 138579,
                        "name": "Foiano di Val Fortore",
                        "latitude": "41.35283000",
                        "longitude": "14.97635000"
                    },
                    {
                        "id": 138595,
                        "name": "Fontanarosa",
                        "latitude": "41.01812000",
                        "longitude": "15.02055000"
                    },
                    {
                        "id": 138611,
                        "name": "Fontegreca",
                        "latitude": "41.45653000",
                        "longitude": "14.18385000"
                    },
                    {
                        "id": 138620,
                        "name": "Forchia",
                        "latitude": "41.03144000",
                        "longitude": "14.53573000"
                    },
                    {
                        "id": 138629,
                        "name": "Forino",
                        "latitude": "40.85829000",
                        "longitude": "14.73254000"
                    },
                    {
                        "id": 138630,
                        "name": "Forio",
                        "latitude": "40.73757000",
                        "longitude": "13.86003000"
                    },
                    {
                        "id": 138638,
                        "name": "Formicola",
                        "latitude": "41.21084000",
                        "longitude": "14.23462000"
                    },
                    {
                        "id": 138688,
                        "name": "Fragneto L'Abate",
                        "latitude": "41.25580000",
                        "longitude": "14.78382000"
                    },
                    {
                        "id": 138689,
                        "name": "Fragneto Monforte",
                        "latitude": "41.24634000",
                        "longitude": "14.76342000"
                    },
                    {
                        "id": 138701,
                        "name": "Franche",
                        "latitude": "40.67175000",
                        "longitude": "14.52139000"
                    },
                    {
                        "id": 138705,
                        "name": "Francolise",
                        "latitude": "41.18501000",
                        "longitude": "14.05672000"
                    },
                    {
                        "id": 138718,
                        "name": "Frasso Telesino",
                        "latitude": "41.15682000",
                        "longitude": "14.52783000"
                    },
                    {
                        "id": 138722,
                        "name": "Frattamaggiore",
                        "latitude": "40.94140000",
                        "longitude": "14.27588000"
                    },
                    {
                        "id": 138723,
                        "name": "Frattaminore",
                        "latitude": "40.95580000",
                        "longitude": "14.27201000"
                    },
                    {
                        "id": 138733,
                        "name": "Frigento",
                        "latitude": "41.01103000",
                        "longitude": "15.10026000"
                    },
                    {
                        "id": 138734,
                        "name": "Frignano",
                        "latitude": "40.99811000",
                        "longitude": "14.17913000"
                    },
                    {
                        "id": 138752,
                        "name": "Fuorigrotta",
                        "latitude": "40.83333000",
                        "longitude": "14.20000000"
                    },
                    {
                        "id": 138753,
                        "name": "Fuorni",
                        "latitude": "40.64063000",
                        "longitude": "14.84925000"
                    },
                    {
                        "id": 138758,
                        "name": "Furore",
                        "latitude": "40.62061000",
                        "longitude": "14.54904000"
                    },
                    {
                        "id": 138764,
                        "name": "Futani",
                        "latitude": "40.15156000",
                        "longitude": "15.32366000"
                    },
                    {
                        "id": 138816,
                        "name": "Gallo",
                        "latitude": "41.46499000",
                        "longitude": "14.22519000"
                    },
                    {
                        "id": 138817,
                        "name": "Gallo Matese",
                        "latitude": "41.46452000",
                        "longitude": "14.22502000"
                    },
                    {
                        "id": 138820,
                        "name": "Galluccio",
                        "latitude": "41.35232000",
                        "longitude": "13.95372000"
                    },
                    {
                        "id": 138928,
                        "name": "Gesualdo",
                        "latitude": "41.00554000",
                        "longitude": "15.07262000"
                    },
                    {
                        "id": 138942,
                        "name": "Giano Vetusto",
                        "latitude": "41.20272000",
                        "longitude": "14.19342000"
                    },
                    {
                        "id": 138957,
                        "name": "Giffoni Valle Piana",
                        "latitude": "40.71811000",
                        "longitude": "14.94235000"
                    },
                    {
                        "id": 138965,
                        "name": "Ginestra degli Schiavoni",
                        "latitude": "41.27992000",
                        "longitude": "15.04374000"
                    },
                    {
                        "id": 138967,
                        "name": "Gioi",
                        "latitude": "40.28970000",
                        "longitude": "15.21806000"
                    },
                    {
                        "id": 138968,
                        "name": "Gioia Sannitica",
                        "latitude": "41.29965000",
                        "longitude": "14.44381000"
                    },
                    {
                        "id": 138988,
                        "name": "Giugliano in Campania",
                        "latitude": "40.92849000",
                        "longitude": "14.20197000"
                    },
                    {
                        "id": 138995,
                        "name": "Giungano",
                        "latitude": "40.39450000",
                        "longitude": "15.10792000"
                    },
                    {
                        "id": 139056,
                        "name": "Gragnano",
                        "latitude": "40.68907000",
                        "longitude": "14.52036000"
                    },
                    {
                        "id": 139084,
                        "name": "Grazzanise",
                        "latitude": "41.08970000",
                        "longitude": "14.09878000"
                    },
                    {
                        "id": 139086,
                        "name": "Greci",
                        "latitude": "41.25182000",
                        "longitude": "15.16915000"
                    },
                    {
                        "id": 139096,
                        "name": "Gricignano di Aversa",
                        "latitude": "40.97973000",
                        "longitude": "14.23087000"
                    },
                    {
                        "id": 139122,
                        "name": "Grottaminarda",
                        "latitude": "41.06972000",
                        "longitude": "15.05894000"
                    },
                    {
                        "id": 139129,
                        "name": "Grottola",
                        "latitude": "41.31708000",
                        "longitude": "14.04121000"
                    },
                    {
                        "id": 139131,
                        "name": "Grottolella",
                        "latitude": "40.97144000",
                        "longitude": "14.78894000"
                    },
                    {
                        "id": 139140,
                        "name": "Grumo Nevano",
                        "latitude": "40.93591000",
                        "longitude": "14.25983000"
                    },
                    {
                        "id": 139159,
                        "name": "Guardia Lombardi",
                        "latitude": "40.95177000",
                        "longitude": "15.20878000"
                    },
                    {
                        "id": 139162,
                        "name": "Guardia Sanframondi",
                        "latitude": "41.25640000",
                        "longitude": "14.59851000"
                    },
                    {
                        "id": 139227,
                        "name": "Ischia",
                        "latitude": "40.73793000",
                        "longitude": "13.94862000"
                    },
                    {
                        "id": 139228,
                        "name": "Ischia Porto",
                        "latitude": "40.73913000",
                        "longitude": "13.95100000"
                    },
                    {
                        "id": 139258,
                        "name": "Ispani",
                        "latitude": "40.08730000",
                        "longitude": "15.55827000"
                    },
                    {
                        "id": 139313,
                        "name": "Lacco Ameno",
                        "latitude": "40.74901000",
                        "longitude": "13.88718000"
                    },
                    {
                        "id": 139314,
                        "name": "Lacedonia",
                        "latitude": "41.05022000",
                        "longitude": "15.42169000"
                    },
                    {
                        "id": 139355,
                        "name": "Lancusi-Penta-Bolano",
                        "latitude": "40.76125000",
                        "longitude": "14.78524000"
                    },
                    {
                        "id": 139364,
                        "name": "Lanzara",
                        "latitude": "40.77473000",
                        "longitude": "14.67619000"
                    },
                    {
                        "id": 139368,
                        "name": "Lapio",
                        "latitude": "40.98293000",
                        "longitude": "14.94650000"
                    },
                    {
                        "id": 139396,
                        "name": "Laura",
                        "latitude": "40.43220000",
                        "longitude": "14.98886000"
                    },
                    {
                        "id": 139397,
                        "name": "Laureana Cilento",
                        "latitude": "40.30110000",
                        "longitude": "15.03876000"
                    },
                    {
                        "id": 139404,
                        "name": "Laurino",
                        "latitude": "40.33915000",
                        "longitude": "15.33810000"
                    },
                    {
                        "id": 139405,
                        "name": "Laurito",
                        "latitude": "40.16915000",
                        "longitude": "15.40741000"
                    },
                    {
                        "id": 139406,
                        "name": "Lauro",
                        "latitude": "40.87972000",
                        "longitude": "14.63013000"
                    },
                    {
                        "id": 139415,
                        "name": "Laviano",
                        "latitude": "40.78619000",
                        "longitude": "15.30791000"
                    },
                    {
                        "id": 139476,
                        "name": "Letino",
                        "latitude": "41.45302000",
                        "longitude": "14.25542000"
                    },
                    {
                        "id": 139478,
                        "name": "Lettere",
                        "latitude": "40.70491000",
                        "longitude": "14.54494000"
                    },
                    {
                        "id": 139492,
                        "name": "Liberi",
                        "latitude": "41.22648000",
                        "longitude": "14.28985000"
                    },
                    {
                        "id": 139497,
                        "name": "Licinella-Torre di Paestum",
                        "latitude": "40.40656000",
                        "longitude": "14.99764000"
                    },
                    {
                        "id": 139499,
                        "name": "Licusati",
                        "latitude": "40.05410000",
                        "longitude": "15.36437000"
                    },
                    {
                        "id": 139516,
                        "name": "Limatola",
                        "latitude": "41.14012000",
                        "longitude": "14.39437000"
                    },
                    {
                        "id": 139532,
                        "name": "Lioni",
                        "latitude": "40.88083000",
                        "longitude": "15.18335000"
                    },
                    {
                        "id": 139546,
                        "name": "Liveri",
                        "latitude": "40.90406000",
                        "longitude": "14.56536000"
                    },
                    {
                        "id": 139662,
                        "name": "Luogosano",
                        "latitude": "40.98643000",
                        "longitude": "14.99206000"
                    },
                    {
                        "id": 139670,
                        "name": "Lusciano",
                        "latitude": "40.97001000",
                        "longitude": "14.19043000"
                    },
                    {
                        "id": 139679,
                        "name": "Lustra",
                        "latitude": "40.28830000",
                        "longitude": "15.06826000"
                    },
                    {
                        "id": 139683,
                        "name": "Luzzano",
                        "latitude": "41.06818000",
                        "longitude": "14.53611000"
                    },
                    {
                        "id": 139690,
                        "name": "Macchia",
                        "latitude": "40.65353000",
                        "longitude": "14.97879000"
                    },
                    {
                        "id": 139694,
                        "name": "Maccoli-Perrillo",
                        "latitude": "41.08762000",
                        "longitude": "14.80585000"
                    },
                    {
                        "id": 139697,
                        "name": "Macerata Campania",
                        "latitude": "41.06327000",
                        "longitude": "14.27750000"
                    },
                    {
                        "id": 139706,
                        "name": "Maddaloni",
                        "latitude": "41.03578000",
                        "longitude": "14.38230000"
                    },
                    {
                        "id": 139728,
                        "name": "Magliano Vetere",
                        "latitude": "40.34701000",
                        "longitude": "15.23666000"
                    },
                    {
                        "id": 139749,
                        "name": "Maiori",
                        "latitude": "40.64848000",
                        "longitude": "14.64070000"
                    },
                    {
                        "id": 139759,
                        "name": "Malche-Santa Croce-Serroni",
                        "latitude": "40.70925000",
                        "longitude": "14.90668000"
                    },
                    {
                        "id": 139801,
                        "name": "Manocalzati",
                        "latitude": "40.94151000",
                        "longitude": "14.84767000"
                    },
                    {
                        "id": 139827,
                        "name": "Marano di Napoli",
                        "latitude": "40.89710000",
                        "longitude": "14.18824000"
                    },
                    {
                        "id": 139847,
                        "name": "Marcianise",
                        "latitude": "41.03064000",
                        "longitude": "14.29868000"
                    },
                    {
                        "id": 139870,
                        "name": "Mariglianella",
                        "latitude": "40.92962000",
                        "longitude": "14.43703000"
                    },
                    {
                        "id": 139871,
                        "name": "Marigliano",
                        "latitude": "40.92480000",
                        "longitude": "14.45612000"
                    },
                    {
                        "id": 139878,
                        "name": "Marina di Camerota",
                        "latitude": "40.00356000",
                        "longitude": "15.36717000"
                    },
                    {
                        "id": 139882,
                        "name": "Marina di Casal Velino",
                        "latitude": "40.17665000",
                        "longitude": "15.12218000"
                    },
                    {
                        "id": 139944,
                        "name": "Marzanello",
                        "latitude": "41.31447000",
                        "longitude": "14.11611000"
                    },
                    {
                        "id": 139946,
                        "name": "Marzano Appio",
                        "latitude": "41.31772000",
                        "longitude": "14.04502000"
                    },
                    {
                        "id": 139947,
                        "name": "Marzano di Nola",
                        "latitude": "40.90141000",
                        "longitude": "14.58359000"
                    },
                    {
                        "id": 139976,
                        "name": "Massa di Somma",
                        "latitude": "40.84551000",
                        "longitude": "14.37513000"
                    },
                    {
                        "id": 139972,
                        "name": "Massa Lubrense",
                        "latitude": "40.60937000",
                        "longitude": "14.37202000"
                    },
                    {
                        "id": 139985,
                        "name": "Masseria Vecchia Ovest",
                        "latitude": "40.88966000",
                        "longitude": "14.06573000"
                    },
                    {
                        "id": 139996,
                        "name": "Matinella",
                        "latitude": "40.50158000",
                        "longitude": "15.06692000"
                    },
                    {
                        "id": 140051,
                        "name": "Melito di Napoli",
                        "latitude": "40.91948000",
                        "longitude": "14.23104000"
                    },
                    {
                        "id": 140050,
                        "name": "Melito Irpino",
                        "latitude": "41.10312000",
                        "longitude": "15.05235000"
                    },
                    {
                        "id": 140053,
                        "name": "Melizzano",
                        "latitude": "41.16181000",
                        "longitude": "14.50554000"
                    },
                    {
                        "id": 140076,
                        "name": "Mercato",
                        "latitude": "40.71612000",
                        "longitude": "14.94010000"
                    },
                    {
                        "id": 140077,
                        "name": "Mercato San Severino",
                        "latitude": "40.78468000",
                        "longitude": "14.75369000"
                    },
                    {
                        "id": 140081,
                        "name": "Mercogliano",
                        "latitude": "40.92157000",
                        "longitude": "14.74491000"
                    },
                    {
                        "id": 140101,
                        "name": "Meta",
                        "latitude": "40.64081000",
                        "longitude": "14.41582000"
                    },
                    {
                        "id": 140127,
                        "name": "Miano",
                        "latitude": "40.88816000",
                        "longitude": "14.25339000"
                    },
                    {
                        "id": 140141,
                        "name": "Mignano Monte Lungo",
                        "latitude": "41.40592000",
                        "longitude": "13.98552000"
                    },
                    {
                        "id": 140161,
                        "name": "Minori",
                        "latitude": "40.65030000",
                        "longitude": "14.62684000"
                    },
                    {
                        "id": 140167,
                        "name": "Mirabella Eclano",
                        "latitude": "41.04496000",
                        "longitude": "15.00022000"
                    },
                    {
                        "id": 140202,
                        "name": "Moiano",
                        "latitude": "41.07968000",
                        "longitude": "14.54431000"
                    },
                    {
                        "id": 140207,
                        "name": "Moio della Civitella-Pellare",
                        "latitude": "40.24710000",
                        "longitude": "15.26886000"
                    },
                    {
                        "id": 140216,
                        "name": "Molinara",
                        "latitude": "41.29728000",
                        "longitude": "14.90867000"
                    },
                    {
                        "id": 140276,
                        "name": "Mondragone",
                        "latitude": "41.11399000",
                        "longitude": "13.89157000"
                    },
                    {
                        "id": 140313,
                        "name": "Montaguto",
                        "latitude": "41.24873000",
                        "longitude": "15.24845000"
                    },
                    {
                        "id": 140343,
                        "name": "Montano Antilia",
                        "latitude": "40.16264000",
                        "longitude": "15.36315000"
                    },
                    {
                        "id": 140385,
                        "name": "Monte di Procida",
                        "latitude": "40.79809000",
                        "longitude": "14.05023000"
                    },
                    {
                        "id": 140369,
                        "name": "Monte San Giacomo",
                        "latitude": "40.34411000",
                        "longitude": "15.54221000"
                    },
                    {
                        "id": 140395,
                        "name": "Montecalvario",
                        "latitude": "40.84436000",
                        "longitude": "14.24555000"
                    },
                    {
                        "id": 140396,
                        "name": "Montecalvo Irpino",
                        "latitude": "41.19616000",
                        "longitude": "15.03446000"
                    },
                    {
                        "id": 140420,
                        "name": "Montecorice",
                        "latitude": "40.23444000",
                        "longitude": "14.98504000"
                    },
                    {
                        "id": 140421,
                        "name": "Montecorvino Pugliano",
                        "latitude": "40.67921000",
                        "longitude": "14.94475000"
                    },
                    {
                        "id": 140422,
                        "name": "Montecorvino Rovella",
                        "latitude": "40.69180000",
                        "longitude": "14.97862000"
                    },
                    {
                        "id": 140426,
                        "name": "Montedecoro",
                        "latitude": "41.02772000",
                        "longitude": "14.41774000"
                    },
                    {
                        "id": 140429,
                        "name": "Montefalcione",
                        "latitude": "40.96173000",
                        "longitude": "14.88312000"
                    },
                    {
                        "id": 140432,
                        "name": "Montefalcone di Val Fortore",
                        "latitude": "41.32430000",
                        "longitude": "15.00898000"
                    },
                    {
                        "id": 140443,
                        "name": "Monteforte Cilento",
                        "latitude": "40.36481000",
                        "longitude": "15.19486000"
                    },
                    {
                        "id": 140444,
                        "name": "Monteforte Irpino",
                        "latitude": "40.90246000",
                        "longitude": "14.74400000"
                    },
                    {
                        "id": 140448,
                        "name": "Montefredane",
                        "latitude": "40.95978000",
                        "longitude": "14.81374000"
                    },
                    {
                        "id": 140449,
                        "name": "Montefusco",
                        "latitude": "41.03691000",
                        "longitude": "14.85498000"
                    },
                    {
                        "id": 140476,
                        "name": "Montella",
                        "latitude": "40.84372000",
                        "longitude": "15.01785000"
                    },
                    {
                        "id": 140487,
                        "name": "Montemarano",
                        "latitude": "40.91414000",
                        "longitude": "14.99766000"
                    },
                    {
                        "id": 140494,
                        "name": "Montemiletto",
                        "latitude": "41.01168000",
                        "longitude": "14.90034000"
                    },
                    {
                        "id": 140529,
                        "name": "Monterusciello",
                        "latitude": "40.86874000",
                        "longitude": "14.08276000"
                    },
                    {
                        "id": 140531,
                        "name": "Montesano sulla Marcellana",
                        "latitude": "40.27610000",
                        "longitude": "15.70390000"
                    },
                    {
                        "id": 140532,
                        "name": "Montesarchio",
                        "latitude": "41.06227000",
                        "longitude": "14.64096000"
                    },
                    {
                        "id": 140549,
                        "name": "Monteverde",
                        "latitude": "40.99858000",
                        "longitude": "15.53361000"
                    },
                    {
                        "id": 140558,
                        "name": "Monticelli",
                        "latitude": "40.65000000",
                        "longitude": "15.01667000"
                    },
                    {
                        "id": 140587,
                        "name": "Montoro Superiore",
                        "latitude": "40.81699000",
                        "longitude": "14.79841000"
                    },
                    {
                        "id": 140606,
                        "name": "Morcone",
                        "latitude": "41.34269000",
                        "longitude": "14.66889000"
                    },
                    {
                        "id": 140618,
                        "name": "Morigerati",
                        "latitude": "40.14056000",
                        "longitude": "15.55508000"
                    },
                    {
                        "id": 140631,
                        "name": "Morra de Sanctis",
                        "latitude": "40.92902000",
                        "longitude": "15.24285000"
                    },
                    {
                        "id": 140645,
                        "name": "Moschiano",
                        "latitude": "40.87311000",
                        "longitude": "14.65594000"
                    },
                    {
                        "id": 140679,
                        "name": "Mugnano del Cardinale",
                        "latitude": "40.94248000",
                        "longitude": "14.63610000"
                    },
                    {
                        "id": 140680,
                        "name": "Mugnano di Napoli",
                        "latitude": "40.90936000",
                        "longitude": "14.20984000"
                    },
                    {
                        "id": 140697,
                        "name": "Musci",
                        "latitude": "40.87861000",
                        "longitude": "14.36600000"
                    },
                    {
                        "id": 140713,
                        "name": "Naples",
                        "latitude": "40.85216000",
                        "longitude": "14.26811000"
                    },
                    {
                        "id": 140714,
                        "name": "Napoli",
                        "latitude": "40.88333000",
                        "longitude": "14.41667000"
                    },
                    {
                        "id": 140781,
                        "name": "Nocelleto",
                        "latitude": "41.17067000",
                        "longitude": "14.01565000"
                    },
                    {
                        "id": 140782,
                        "name": "Nocera Inferiore",
                        "latitude": "40.74540000",
                        "longitude": "14.64542000"
                    },
                    {
                        "id": 140784,
                        "name": "Nocera Superiore",
                        "latitude": "40.74248000",
                        "longitude": "14.67447000"
                    },
                    {
                        "id": 140797,
                        "name": "Nola",
                        "latitude": "40.92606000",
                        "longitude": "14.52816000"
                    },
                    {
                        "id": 140836,
                        "name": "Novi Velia",
                        "latitude": "40.22262000",
                        "longitude": "15.28600000"
                    },
                    {
                        "id": 140850,
                        "name": "Nuova Conza della Campania",
                        "latitude": "40.85860000",
                        "longitude": "15.33645000"
                    },
                    {
                        "id": 140861,
                        "name": "Nusco",
                        "latitude": "40.88820000",
                        "longitude": "15.09185000"
                    },
                    {
                        "id": 140883,
                        "name": "Ogliastro Cilento",
                        "latitude": "40.35113000",
                        "longitude": "15.04638000"
                    },
                    {
                        "id": 140891,
                        "name": "Olevano sul Tusciano",
                        "latitude": "40.65721000",
                        "longitude": "15.02305000"
                    },
                    {
                        "id": 140901,
                        "name": "Oliveto Citra",
                        "latitude": "40.69039000",
                        "longitude": "15.23346000"
                    },
                    {
                        "id": 140919,
                        "name": "Omignano",
                        "latitude": "40.24932000",
                        "longitude": "15.08406000"
                    },
                    {
                        "id": 140968,
                        "name": "Orria",
                        "latitude": "40.29971000",
                        "longitude": "15.17116000"
                    },
                    {
                        "id": 140979,
                        "name": "Orta di Atella",
                        "latitude": "40.96441000",
                        "longitude": "14.26854000"
                    },
                    {
                        "id": 141020,
                        "name": "Ospedaletto d'Alpinolo",
                        "latitude": "40.93906000",
                        "longitude": "14.74652000"
                    },
                    {
                        "id": 141048,
                        "name": "Ottati",
                        "latitude": "40.46291000",
                        "longitude": "15.31526000"
                    },
                    {
                        "id": 141050,
                        "name": "Ottaviano",
                        "latitude": "40.85193000",
                        "longitude": "14.47826000"
                    },
                    {
                        "id": 141088,
                        "name": "Padula",
                        "latitude": "40.33901000",
                        "longitude": "15.65634000"
                    },
                    {
                        "id": 141090,
                        "name": "Paduli",
                        "latitude": "41.16793000",
                        "longitude": "14.88688000"
                    },
                    {
                        "id": 141094,
                        "name": "Pagani",
                        "latitude": "40.74199000",
                        "longitude": "14.61448000"
                    },
                    {
                        "id": 58208,
                        "name": "Pagliarone",
                        "latitude": "40.63006000",
                        "longitude": "14.91325000"
                    },
                    {
                        "id": 58214,
                        "name": "Pago del Vallo di Lauro",
                        "latitude": "40.89721000",
                        "longitude": "14.60764000"
                    },
                    {
                        "id": 58213,
                        "name": "Pago Veiano",
                        "latitude": "41.24243000",
                        "longitude": "14.86497000"
                    },
                    {
                        "id": 58245,
                        "name": "Palinuro",
                        "latitude": "40.03681000",
                        "longitude": "15.28812000"
                    },
                    {
                        "id": 58253,
                        "name": "Palma Campania",
                        "latitude": "40.86608000",
                        "longitude": "14.55170000"
                    },
                    {
                        "id": 58265,
                        "name": "Palomonte",
                        "latitude": "40.66251000",
                        "longitude": "15.29186000"
                    },
                    {
                        "id": 58281,
                        "name": "Pannarano",
                        "latitude": "41.01082000",
                        "longitude": "14.70293000"
                    },
                    {
                        "id": 58288,
                        "name": "Paolisi",
                        "latitude": "41.03731000",
                        "longitude": "14.57918000"
                    },
                    {
                        "id": 58303,
                        "name": "Parete",
                        "latitude": "40.95891000",
                        "longitude": "14.16193000"
                    },
                    {
                        "id": 58311,
                        "name": "Parolise",
                        "latitude": "40.93045000",
                        "longitude": "14.88172000"
                    },
                    {
                        "id": 58321,
                        "name": "Pascarola",
                        "latitude": "40.97643000",
                        "longitude": "14.30500000"
                    },
                    {
                        "id": 58332,
                        "name": "Passo di Mirabella-Pianopantano",
                        "latitude": "41.05468000",
                        "longitude": "15.01649000"
                    },
                    {
                        "id": 58339,
                        "name": "Pastorano",
                        "latitude": "41.18082000",
                        "longitude": "14.19823000"
                    },
                    {
                        "id": 58345,
                        "name": "Paternopoli",
                        "latitude": "40.97268000",
                        "longitude": "15.03242000"
                    },
                    {
                        "id": 58357,
                        "name": "Paupisi",
                        "latitude": "41.19662000",
                        "longitude": "14.66457000"
                    },
                    {
                        "id": 58395,
                        "name": "Pellezzano",
                        "latitude": "40.72521000",
                        "longitude": "14.75744000"
                    },
                    {
                        "id": 58400,
                        "name": "Pendino",
                        "latitude": "40.84708000",
                        "longitude": "14.26321000"
                    },
                    {
                        "id": 58418,
                        "name": "Perdifumo",
                        "latitude": "40.26694000",
                        "longitude": "15.01652000"
                    },
                    {
                        "id": 58426,
                        "name": "Perito",
                        "latitude": "40.29854000",
                        "longitude": "15.14746000"
                    },
                    {
                        "id": 58444,
                        "name": "Pertosa",
                        "latitude": "40.54346000",
                        "longitude": "15.45009000"
                    },
                    {
                        "id": 58460,
                        "name": "Pesco Sannita",
                        "latitude": "41.23273000",
                        "longitude": "14.81122000"
                    },
                    {
                        "id": 58475,
                        "name": "Petina",
                        "latitude": "40.53211000",
                        "longitude": "15.37346000"
                    },
                    {
                        "id": 58488,
                        "name": "Petruro Irpino",
                        "latitude": "41.03192000",
                        "longitude": "14.79754000"
                    },
                    {
                        "id": 58498,
                        "name": "Pezzano-Filetta",
                        "latitude": "40.69773000",
                        "longitude": "14.86971000"
                    },
                    {
                        "id": 58506,
                        "name": "Piaggine",
                        "latitude": "40.34498000",
                        "longitude": "15.37777000"
                    },
                    {
                        "id": 58515,
                        "name": "Piana di Monte Verna",
                        "latitude": "41.16712000",
                        "longitude": "14.33373000"
                    },
                    {
                        "id": 58536,
                        "name": "Pianillo",
                        "latitude": "40.63416000",
                        "longitude": "14.54922000"
                    },
                    {
                        "id": 58537,
                        "name": "Piano",
                        "latitude": "40.82050000",
                        "longitude": "14.76005000"
                    },
                    {
                        "id": 58545,
                        "name": "Piano di Sorrento",
                        "latitude": "40.62806000",
                        "longitude": "14.41729000"
                    },
                    {
                        "id": 58553,
                        "name": "Pianura",
                        "latitude": "40.85907000",
                        "longitude": "14.17314000"
                    },
                    {
                        "id": 58570,
                        "name": "Piazza del Galdo-Sant'Angelo",
                        "latitude": "40.77390000",
                        "longitude": "14.71696000"
                    },
                    {
                        "id": 58571,
                        "name": "Piazza di Pandola",
                        "latitude": "40.80748000",
                        "longitude": "14.77180000"
                    },
                    {
                        "id": 58568,
                        "name": "Piazza Roma",
                        "latitude": "40.70434000",
                        "longitude": "14.54300000"
                    },
                    {
                        "id": 58572,
                        "name": "Piazza-Tralia-Pendolo",
                        "latitude": "40.67351000",
                        "longitude": "14.50455000"
                    },
                    {
                        "id": 58574,
                        "name": "Piazzola",
                        "latitude": "40.87265000",
                        "longitude": "14.50016000"
                    },
                    {
                        "id": 58576,
                        "name": "Piazzolla",
                        "latitude": "40.88964000",
                        "longitude": "14.51579000"
                    },
                    {
                        "id": 58588,
                        "name": "Piedimonte",
                        "latitude": "41.18886000",
                        "longitude": "13.89856000"
                    },
                    {
                        "id": 58590,
                        "name": "Piedimonte Matese",
                        "latitude": "41.35082000",
                        "longitude": "14.36803000"
                    },
                    {
                        "id": 58596,
                        "name": "Piegolelle-San Bartolomeo",
                        "latitude": "40.68583000",
                        "longitude": "14.82312000"
                    },
                    {
                        "id": 58611,
                        "name": "Pietradefusi",
                        "latitude": "41.04316000",
                        "longitude": "14.88415000"
                    },
                    {
                        "id": 58616,
                        "name": "Pietramelara",
                        "latitude": "41.27086000",
                        "longitude": "14.18711000"
                    },
                    {
                        "id": 58624,
                        "name": "Pietraroja",
                        "latitude": "41.34782000",
                        "longitude": "14.54963000"
                    },
                    {
                        "id": 58626,
                        "name": "Pietrastornina",
                        "latitude": "40.99535000",
                        "longitude": "14.71833000"
                    },
                    {
                        "id": 58627,
                        "name": "Pietravairano",
                        "latitude": "41.32522000",
                        "longitude": "14.16592000"
                    },
                    {
                        "id": 58628,
                        "name": "Pietre",
                        "latitude": "40.70048000",
                        "longitude": "14.61993000"
                    },
                    {
                        "id": 58629,
                        "name": "Pietrelcina",
                        "latitude": "41.19942000",
                        "longitude": "14.84414000"
                    },
                    {
                        "id": 58662,
                        "name": "Pignataro Maggiore",
                        "latitude": "41.19006000",
                        "longitude": "14.16978000"
                    },
                    {
                        "id": 58670,
                        "name": "Pimonte",
                        "latitude": "40.67361000",
                        "longitude": "14.50984000"
                    },
                    {
                        "id": 58706,
                        "name": "Piscinola",
                        "latitude": "40.89299000",
                        "longitude": "14.23394000"
                    },
                    {
                        "id": 58707,
                        "name": "Pisciotta",
                        "latitude": "40.10890000",
                        "longitude": "15.23456000"
                    },
                    {
                        "id": 58769,
                        "name": "Poggiomarino",
                        "latitude": "40.80114000",
                        "longitude": "14.54066000"
                    },
                    {
                        "id": 58770,
                        "name": "Poggioreale",
                        "latitude": "40.86543000",
                        "longitude": "14.28877000"
                    },
                    {
                        "id": 58788,
                        "name": "Policastro Bussentino",
                        "latitude": "40.07511000",
                        "longitude": "15.52165000"
                    },
                    {
                        "id": 58795,
                        "name": "Polla",
                        "latitude": "40.51433000",
                        "longitude": "15.49715000"
                    },
                    {
                        "id": 58797,
                        "name": "Pollena Trocchia",
                        "latitude": "40.85134000",
                        "longitude": "14.37911000"
                    },
                    {
                        "id": 58799,
                        "name": "Pollica",
                        "latitude": "40.19070000",
                        "longitude": "15.05716000"
                    },
                    {
                        "id": 58807,
                        "name": "Polvica",
                        "latitude": "40.69484000",
                        "longitude": "14.64019000"
                    },
                    {
                        "id": 58816,
                        "name": "Pomigliano d'Arco",
                        "latitude": "40.90975000",
                        "longitude": "14.38316000"
                    },
                    {
                        "id": 58817,
                        "name": "Pompei",
                        "latitude": "40.74574000",
                        "longitude": "14.49698000"
                    },
                    {
                        "id": 58832,
                        "name": "Ponte",
                        "latitude": "41.21554000",
                        "longitude": "14.69826000"
                    },
                    {
                        "id": 58863,
                        "name": "Pontecagnano",
                        "latitude": "40.64448000",
                        "longitude": "14.87628000"
                    },
                    {
                        "id": 58871,
                        "name": "Pontelandolfo",
                        "latitude": "41.29231000",
                        "longitude": "14.68956000"
                    },
                    {
                        "id": 58873,
                        "name": "Pontelatone",
                        "latitude": "41.19460000",
                        "longitude": "14.24814000"
                    },
                    {
                        "id": 58885,
                        "name": "Ponticelli",
                        "latitude": "40.85420000",
                        "longitude": "14.33038000"
                    },
                    {
                        "id": 58917,
                        "name": "Portici",
                        "latitude": "40.81563000",
                        "longitude": "14.33716000"
                    },
                    {
                        "id": 58918,
                        "name": "Portico di Caserta",
                        "latitude": "41.05562000",
                        "longitude": "14.28022000"
                    },
                    {
                        "id": 58922,
                        "name": "Porto",
                        "latitude": "40.84395000",
                        "longitude": "14.25724000"
                    },
                    {
                        "id": 58954,
                        "name": "Posillipo",
                        "latitude": "40.81279000",
                        "longitude": "14.20001000"
                    },
                    {
                        "id": 58956,
                        "name": "Positano",
                        "latitude": "40.62829000",
                        "longitude": "14.48427000"
                    },
                    {
                        "id": 58962,
                        "name": "Postiglione",
                        "latitude": "40.55901000",
                        "longitude": "15.23236000"
                    },
                    {
                        "id": 58981,
                        "name": "Pozzillo",
                        "latitude": "41.20337000",
                        "longitude": "14.19530000"
                    },
                    {
                        "id": 58989,
                        "name": "Pozzuoli",
                        "latitude": "40.84394000",
                        "longitude": "14.09520000"
                    },
                    {
                        "id": 58999,
                        "name": "Praiano",
                        "latitude": "40.61213000",
                        "longitude": "14.52461000"
                    },
                    {
                        "id": 59017,
                        "name": "Prata di Principato Ultra",
                        "latitude": "40.98626000",
                        "longitude": "14.83803000"
                    },
                    {
                        "id": 59014,
                        "name": "Prata Sannita Centro",
                        "latitude": "41.43282000",
                        "longitude": "14.20272000"
                    },
                    {
                        "id": 59019,
                        "name": "Pratella",
                        "latitude": "41.40579000",
                        "longitude": "14.17913000"
                    },
                    {
                        "id": 59030,
                        "name": "Prato Perillo",
                        "latitude": "40.39690000",
                        "longitude": "15.52503000"
                    },
                    {
                        "id": 59034,
                        "name": "Pratola Serra",
                        "latitude": "40.98655000",
                        "longitude": "14.85149000"
                    },
                    {
                        "id": 59035,
                        "name": "Pratole",
                        "latitude": "40.62580000",
                        "longitude": "14.92565000"
                    },
                    {
                        "id": 59062,
                        "name": "Prepezzano",
                        "latitude": "40.72754000",
                        "longitude": "14.89123000"
                    },
                    {
                        "id": 59065,
                        "name": "Presenzano",
                        "latitude": "41.37823000",
                        "longitude": "14.09162000"
                    },
                    {
                        "id": 59076,
                        "name": "Prignano Cilento",
                        "latitude": "40.33335000",
                        "longitude": "15.06739000"
                    },
                    {
                        "id": 59086,
                        "name": "Procida",
                        "latitude": "40.75636000",
                        "longitude": "14.01457000"
                    },
                    {
                        "id": 59111,
                        "name": "Provincia di Avellino",
                        "latitude": "40.98333000",
                        "longitude": "15.15000000"
                    },
                    {
                        "id": 59114,
                        "name": "Provincia di Benevento",
                        "latitude": "41.21792000",
                        "longitude": "14.74640000"
                    },
                    {
                        "id": 59122,
                        "name": "Provincia di Caserta",
                        "latitude": "41.23333000",
                        "longitude": "14.16667000"
                    },
                    {
                        "id": 59172,
                        "name": "Provincia di Salerno",
                        "latitude": "40.45000000",
                        "longitude": "15.26667000"
                    },
                    {
                        "id": 59196,
                        "name": "Puglianello",
                        "latitude": "41.22179000",
                        "longitude": "14.45023000"
                    },
                    {
                        "id": 59197,
                        "name": "Pugliano",
                        "latitude": "40.67876000",
                        "longitude": "14.94543000"
                    },
                    {
                        "id": 59211,
                        "name": "Quadrelle",
                        "latitude": "40.94851000",
                        "longitude": "14.63934000"
                    },
                    {
                        "id": 59213,
                        "name": "Quadrivio",
                        "latitude": "40.62494000",
                        "longitude": "15.10353000"
                    },
                    {
                        "id": 59215,
                        "name": "Qualiano",
                        "latitude": "40.91899000",
                        "longitude": "14.15352000"
                    },
                    {
                        "id": 59228,
                        "name": "Quarto",
                        "latitude": "40.87822000",
                        "longitude": "14.14352000"
                    },
                    {
                        "id": 59245,
                        "name": "Quindici",
                        "latitude": "40.86497000",
                        "longitude": "14.64663000"
                    },
                    {
                        "id": 59298,
                        "name": "Ravello",
                        "latitude": "40.64932000",
                        "longitude": "14.61167000"
                    },
                    {
                        "id": 59302,
                        "name": "Raviscanina",
                        "latitude": "41.37090000",
                        "longitude": "14.24335000"
                    },
                    {
                        "id": 59309,
                        "name": "Recale",
                        "latitude": "41.05702000",
                        "longitude": "14.30270000"
                    },
                    {
                        "id": 59325,
                        "name": "Reino",
                        "latitude": "41.29219000",
                        "longitude": "14.82347000"
                    },
                    {
                        "id": 59339,
                        "name": "Rettifilo-Vannullo",
                        "latitude": "40.45125000",
                        "longitude": "15.02794000"
                    },
                    {
                        "id": 59358,
                        "name": "Riardo",
                        "latitude": "41.26197000",
                        "longitude": "14.15045000"
                    },
                    {
                        "id": 59370,
                        "name": "Ricigliano",
                        "latitude": "40.66803000",
                        "longitude": "15.47790000"
                    },
                    {
                        "id": 59477,
                        "name": "Rocca San Felice",
                        "latitude": "40.95014000",
                        "longitude": "15.16656000"
                    },
                    {
                        "id": 59490,
                        "name": "Roccabascerana",
                        "latitude": "41.01842000",
                        "longitude": "14.71684000"
                    },
                    {
                        "id": 59495,
                        "name": "Roccadaspide",
                        "latitude": "40.42333000",
                        "longitude": "15.19118000"
                    },
                    {
                        "id": 59503,
                        "name": "Roccagloriosa",
                        "latitude": "40.10628000",
                        "longitude": "15.43642000"
                    },
                    {
                        "id": 59509,
                        "name": "Roccamonfina",
                        "latitude": "41.28683000",
                        "longitude": "13.97905000"
                    },
                    {
                        "id": 59514,
                        "name": "Roccapiemonte",
                        "latitude": "40.76009000",
                        "longitude": "14.69089000"
                    },
                    {
                        "id": 59515,
                        "name": "Roccarainola",
                        "latitude": "40.97250000",
                        "longitude": "14.54283000"
                    },
                    {
                        "id": 59517,
                        "name": "Roccaromana",
                        "latitude": "41.27360000",
                        "longitude": "14.22190000"
                    },
                    {
                        "id": 59535,
                        "name": "Rocchetta",
                        "latitude": "41.23716000",
                        "longitude": "14.15765000"
                    },
                    {
                        "id": 59556,
                        "name": "Rofrano",
                        "latitude": "40.21277000",
                        "longitude": "15.42848000"
                    },
                    {
                        "id": 59631,
                        "name": "Roscigno",
                        "latitude": "40.39997000",
                        "longitude": "15.34585000"
                    },
                    {
                        "id": 59661,
                        "name": "Rotondi",
                        "latitude": "41.03293000",
                        "longitude": "14.59548000"
                    },
                    {
                        "id": 59706,
                        "name": "Rutino",
                        "latitude": "40.30072000",
                        "longitude": "15.07328000"
                    },
                    {
                        "id": 59707,
                        "name": "Ruviano",
                        "latitude": "41.21063000",
                        "longitude": "14.40983000"
                    },
                    {
                        "id": 59717,
                        "name": "Sacco",
                        "latitude": "40.37671000",
                        "longitude": "15.37783000"
                    },
                    {
                        "id": 59738,
                        "name": "Sala",
                        "latitude": "40.85536000",
                        "longitude": "14.87343000"
                    },
                    {
                        "id": 59743,
                        "name": "Sala Consilina",
                        "latitude": "40.40134000",
                        "longitude": "15.59140000"
                    },
                    {
                        "id": 59759,
                        "name": "Salento",
                        "latitude": "40.24913000",
                        "longitude": "15.18938000"
                    },
                    {
                        "id": 59762,
                        "name": "Salerno",
                        "latitude": "40.67545000",
                        "longitude": "14.79328000"
                    },
                    {
                        "id": 59775,
                        "name": "Salitto-Valle",
                        "latitude": "40.67412000",
                        "longitude": "15.02241000"
                    },
                    {
                        "id": 59791,
                        "name": "Salvitelle",
                        "latitude": "40.59064000",
                        "longitude": "15.45760000"
                    },
                    {
                        "id": 59793,
                        "name": "Salza Irpina",
                        "latitude": "40.91893000",
                        "longitude": "14.88996000"
                    },
                    {
                        "id": 59822,
                        "name": "San Bartolomeo in Galdo",
                        "latitude": "41.41595000",
                        "longitude": "15.01709000"
                    },
                    {
                        "id": 59854,
                        "name": "San Carlo All'Arena",
                        "latitude": "40.86511000",
                        "longitude": "14.26291000"
                    },
                    {
                        "id": 59861,
                        "name": "San Castrese",
                        "latitude": "41.25862000",
                        "longitude": "13.86541000"
                    },
                    {
                        "id": 59871,
                        "name": "San Cipriano d'Aversa",
                        "latitude": "40.99881000",
                        "longitude": "14.13173000"
                    },
                    {
                        "id": 59869,
                        "name": "San Cipriano Picentino",
                        "latitude": "40.72008000",
                        "longitude": "14.87195000"
                    },
                    {
                        "id": 59875,
                        "name": "San Clemente",
                        "latitude": "41.34027000",
                        "longitude": "13.95597000"
                    },
                    {
                        "id": 59908,
                        "name": "San Felice A Cancello",
                        "latitude": "41.01702000",
                        "longitude": "14.48736000"
                    },
                    {
                        "id": 59914,
                        "name": "San Ferdinando",
                        "latitude": "40.83342000",
                        "longitude": "14.24751000"
                    },
                    {
                        "id": 59935,
                        "name": "San Gennaro Vesuviano",
                        "latitude": "40.86226000",
                        "longitude": "14.52414000"
                    },
                    {
                        "id": 59952,
                        "name": "San Giorgio",
                        "latitude": "41.27065000",
                        "longitude": "14.31278000"
                    },
                    {
                        "id": 59963,
                        "name": "San Giorgio a Cremano",
                        "latitude": "40.83261000",
                        "longitude": "14.34162000"
                    },
                    {
                        "id": 59966,
                        "name": "San Giorgio del Sannio",
                        "latitude": "41.06844000",
                        "longitude": "14.85322000"
                    },
                    {
                        "id": 59976,
                        "name": "San Giorgio la Molara",
                        "latitude": "41.27667000",
                        "longitude": "14.93099000"
                    },
                    {
                        "id": 59981,
                        "name": "San Giovanni A Piro",
                        "latitude": "40.05150000",
                        "longitude": "15.44620000"
                    },
                    {
                        "id": 59991,
                        "name": "San Giovanni a Teduccio",
                        "latitude": "40.83808000",
                        "longitude": "14.30606000"
                    },
                    {
                        "id": 60011,
                        "name": "San Giuseppe",
                        "latitude": "40.84507000",
                        "longitude": "14.25170000"
                    },
                    {
                        "id": 60013,
                        "name": "San Giuseppe Vesuviano",
                        "latitude": "40.83560000",
                        "longitude": "14.50487000"
                    },
                    {
                        "id": 60020,
                        "name": "San Gregorio Magno",
                        "latitude": "40.65992000",
                        "longitude": "15.39914000"
                    },
                    {
                        "id": 60021,
                        "name": "San Gregorio Matese",
                        "latitude": "41.38556000",
                        "longitude": "14.37217000"
                    },
                    {
                        "id": 60033,
                        "name": "San Leucio del Sannio-Cavuoti",
                        "latitude": "41.07442000",
                        "longitude": "14.75744000"
                    },
                    {
                        "id": 60035,
                        "name": "San Lorenzello",
                        "latitude": "41.27602000",
                        "longitude": "14.54173000"
                    },
                    {
                        "id": 60038,
                        "name": "San Lorenzo",
                        "latitude": "40.75405000",
                        "longitude": "14.58974000"
                    },
                    {
                        "id": 60042,
                        "name": "San Lorenzo Maggiore",
                        "latitude": "41.24885000",
                        "longitude": "14.62438000"
                    },
                    {
                        "id": 60052,
                        "name": "San Lupo",
                        "latitude": "41.26148000",
                        "longitude": "14.63528000"
                    },
                    {
                        "id": 60054,
                        "name": "San Mango Piemonte",
                        "latitude": "40.70024000",
                        "longitude": "14.83919000"
                    },
                    {
                        "id": 60056,
                        "name": "San Mango sul Calore",
                        "latitude": "40.95890000",
                        "longitude": "14.97251000"
                    },
                    {
                        "id": 60057,
                        "name": "San Marcellino",
                        "latitude": "40.99001000",
                        "longitude": "14.17583000"
                    },
                    {
                        "id": 60060,
                        "name": "San Marco",
                        "latitude": "40.26740000",
                        "longitude": "14.93897000"
                    },
                    {
                        "id": 60064,
                        "name": "San Marco dei Cavoti",
                        "latitude": "41.30881000",
                        "longitude": "14.87924000"
                    },
                    {
                        "id": 60062,
                        "name": "San Marco Evangelista",
                        "latitude": "41.03702000",
                        "longitude": "14.33979000"
                    },
                    {
                        "id": 60076,
                        "name": "San Martino Sannita",
                        "latitude": "41.06546000",
                        "longitude": "14.83492000"
                    },
                    {
                        "id": 60078,
                        "name": "San Martino Valle Caudina",
                        "latitude": "41.02764000",
                        "longitude": "14.66446000"
                    },
                    {
                        "id": 60100,
                        "name": "San Marzano sul Sarno",
                        "latitude": "40.77801000",
                        "longitude": "14.58006000"
                    },
                    {
                        "id": 60106,
                        "name": "San Mauro Cilento",
                        "latitude": "40.22628000",
                        "longitude": "15.04476000"
                    },
                    {
                        "id": 60113,
                        "name": "San Mauro la Bruca",
                        "latitude": "40.12246000",
                        "longitude": "15.29109000"
                    },
                    {
                        "id": 60116,
                        "name": "San Michele",
                        "latitude": "40.62023000",
                        "longitude": "14.55018000"
                    },
                    {
                        "id": 60125,
                        "name": "San Michele di Serino",
                        "latitude": "40.87562000",
                        "longitude": "14.85464000"
                    },
                    {
                        "id": 60130,
                        "name": "San Nazzaro",
                        "latitude": "41.05172000",
                        "longitude": "14.85724000"
                    },
                    {
                        "id": 60138,
                        "name": "San Nicola Baronia",
                        "latitude": "41.05808000",
                        "longitude": "15.20006000"
                    },
                    {
                        "id": 60142,
                        "name": "San Nicola la Strada",
                        "latitude": "41.05237000",
                        "longitude": "14.33334000"
                    },
                    {
                        "id": 60139,
                        "name": "San Nicola Manfredi",
                        "latitude": "41.07510000",
                        "longitude": "14.82430000"
                    },
                    {
                        "id": 60158,
                        "name": "San Paolo Bel Sito",
                        "latitude": "40.91354000",
                        "longitude": "14.54862000"
                    },
                    {
                        "id": 60172,
                        "name": "San Pietro",
                        "latitude": "40.82398000",
                        "longitude": "14.78476000"
                    },
                    {
                        "id": 60187,
                        "name": "San Pietro a Patierno",
                        "latitude": "40.88566000",
                        "longitude": "14.29008000"
                    },
                    {
                        "id": 60189,
                        "name": "San Pietro al Tanagro",
                        "latitude": "40.45488000",
                        "longitude": "15.48692000"
                    },
                    {
                        "id": 60179,
                        "name": "San Pietro Infine",
                        "latitude": "41.44552000",
                        "longitude": "13.96029000"
                    },
                    {
                        "id": 60211,
                        "name": "San Potito Sannitico",
                        "latitude": "41.33698000",
                        "longitude": "14.39185000"
                    },
                    {
                        "id": 60212,
                        "name": "San Potito Ultra",
                        "latitude": "40.92796000",
                        "longitude": "14.87124000"
                    },
                    {
                        "id": 60213,
                        "name": "San Prisco",
                        "latitude": "41.08592000",
                        "longitude": "14.27675000"
                    },
                    {
                        "id": 60229,
                        "name": "San Rufo",
                        "latitude": "40.43451000",
                        "longitude": "15.46366000"
                    },
                    {
                        "id": 60232,
                        "name": "San Salvatore Telesino",
                        "latitude": "41.23537000",
                        "longitude": "14.49832000"
                    },
                    {
                        "id": 60237,
                        "name": "San Sebastiano al Vesuvio",
                        "latitude": "40.84344000",
                        "longitude": "14.36428000"
                    },
                    {
                        "id": 60246,
                        "name": "San Sossio Baronia",
                        "latitude": "41.07081000",
                        "longitude": "15.20122000"
                    },
                    {
                        "id": 60251,
                        "name": "San Tammaro",
                        "latitude": "41.07588000",
                        "longitude": "14.23105000"
                    },
                    {
                        "id": 60258,
                        "name": "San Valentino Torio",
                        "latitude": "40.79109000",
                        "longitude": "14.60333000"
                    },
                    {
                        "id": 60271,
                        "name": "San Vitaliano",
                        "latitude": "40.92442000",
                        "longitude": "14.47463000"
                    },
                    {
                        "id": 60320,
                        "name": "Sant'Agata de'Goti",
                        "latitude": "41.08932000",
                        "longitude": "14.49743000"
                    },
                    {
                        "id": 60325,
                        "name": "Sant'Agata sui Due Golfi",
                        "latitude": "40.60565000",
                        "longitude": "14.37402000"
                    },
                    {
                        "id": 60327,
                        "name": "Sant'Agnello",
                        "latitude": "40.62942000",
                        "longitude": "14.39957000"
                    },
                    {
                        "id": 60340,
                        "name": "Sant'Anastasia",
                        "latitude": "40.86842000",
                        "longitude": "14.40196000"
                    },
                    {
                        "id": 60348,
                        "name": "Sant'Andrea di Conza",
                        "latitude": "40.84482000",
                        "longitude": "15.36965000"
                    },
                    {
                        "id": 60350,
                        "name": "Sant'Andrea-Pizzone-Ciamprisco",
                        "latitude": "41.15000000",
                        "longitude": "14.03333000"
                    },
                    {
                        "id": 60352,
                        "name": "Sant'Angelo",
                        "latitude": "40.69841000",
                        "longitude": "13.89316000"
                    },
                    {
                        "id": 60353,
                        "name": "Sant'Angelo A Cupolo",
                        "latitude": "41.06912000",
                        "longitude": "14.80374000"
                    },
                    {
                        "id": 60354,
                        "name": "Sant'Angelo A Fasanella",
                        "latitude": "40.45724000",
                        "longitude": "15.34091000"
                    },
                    {
                        "id": 60355,
                        "name": "Sant'Angelo A Scala",
                        "latitude": "40.97465000",
                        "longitude": "14.74041000"
                    },
                    {
                        "id": 60356,
                        "name": "Sant'Angelo All'Esca",
                        "latitude": "41.00662000",
                        "longitude": "14.99305000"
                    },
                    {
                        "id": 60362,
                        "name": "Sant'Angelo d'Alife",
                        "latitude": "41.36119000",
                        "longitude": "14.26125000"
                    },
                    {
                        "id": 60363,
                        "name": "Sant'Angelo dei Lombardi",
                        "latitude": "40.92937000",
                        "longitude": "15.17535000"
                    },
                    {
                        "id": 60367,
                        "name": "Sant'Angelo in Formis",
                        "latitude": "41.11667000",
                        "longitude": "14.25000000"
                    },
                    {
                        "id": 60376,
                        "name": "Sant'Antimo",
                        "latitude": "40.94223000",
                        "longitude": "14.23476000"
                    },
                    {
                        "id": 60380,
                        "name": "Sant'Antonio",
                        "latitude": "40.63626000",
                        "longitude": "14.89845000"
                    },
                    {
                        "id": 60383,
                        "name": "Sant'Antonio Abate",
                        "latitude": "40.72152000",
                        "longitude": "14.54021000"
                    },
                    {
                        "id": 60388,
                        "name": "Sant'Arcangelo Trimonte",
                        "latitude": "41.16901000",
                        "longitude": "14.93883000"
                    },
                    {
                        "id": 60389,
                        "name": "Sant'Arpino",
                        "latitude": "40.95716000",
                        "longitude": "14.25075000"
                    },
                    {
                        "id": 60390,
                        "name": "Sant'Arsenio",
                        "latitude": "40.47109000",
                        "longitude": "15.48401000"
                    },
                    {
                        "id": 60392,
                        "name": "Sant'Egidio del Monte Albino",
                        "latitude": "40.73871000",
                        "longitude": "14.59454000"
                    },
                    {
                        "id": 60394,
                        "name": "Sant'Elena Irpina",
                        "latitude": "41.03741000",
                        "longitude": "14.88931000"
                    },
                    {
                        "id": 60428,
                        "name": "Santa Croce del Sannio",
                        "latitude": "41.38793000",
                        "longitude": "14.73229000"
                    },
                    {
                        "id": 60445,
                        "name": "Santa Lucia",
                        "latitude": "41.30409000",
                        "longitude": "14.07937000"
                    },
                    {
                        "id": 60449,
                        "name": "Santa Lucia di Serino",
                        "latitude": "40.87042000",
                        "longitude": "14.87594000"
                    },
                    {
                        "id": 60455,
                        "name": "Santa Maria",
                        "latitude": "40.29782000",
                        "longitude": "14.95214000"
                    },
                    {
                        "id": 60457,
                        "name": "Santa Maria A Vico",
                        "latitude": "41.02611000",
                        "longitude": "14.46515000"
                    },
                    {
                        "id": 60459,
                        "name": "Santa Maria Capua Vetere",
                        "latitude": "41.08156000",
                        "longitude": "14.25342000"
                    },
                    {
                        "id": 60464,
                        "name": "Santa Maria La Carità",
                        "latitude": "40.71611000",
                        "longitude": "14.50984000"
                    },
                    {
                        "id": 60479,
                        "name": "Santa Maria la Fossa",
                        "latitude": "41.09171000",
                        "longitude": "14.12822000"
                    },
                    {
                        "id": 60482,
                        "name": "Santa Marina",
                        "latitude": "40.10520000",
                        "longitude": "15.54153000"
                    },
                    {
                        "id": 60488,
                        "name": "Santa Paolina",
                        "latitude": "41.02202000",
                        "longitude": "14.84630000"
                    },
                    {
                        "id": 60493,
                        "name": "Santa Tecla-Castelpagano",
                        "latitude": "40.67353000",
                        "longitude": "14.91806000"
                    },
                    {
                        "id": 60519,
                        "name": "Santo Stefano del Sole",
                        "latitude": "40.89414000",
                        "longitude": "14.86674000"
                    },
                    {
                        "id": 60528,
                        "name": "Santomenna",
                        "latitude": "40.80685000",
                        "longitude": "15.32639000"
                    },
                    {
                        "id": 60532,
                        "name": "Sanza",
                        "latitude": "40.24389000",
                        "longitude": "15.55416000"
                    },
                    {
                        "id": 60538,
                        "name": "Sapri",
                        "latitude": "40.07464000",
                        "longitude": "15.63212000"
                    },
                    {
                        "id": 60554,
                        "name": "Sarno",
                        "latitude": "40.80748000",
                        "longitude": "14.62151000"
                    },
                    {
                        "id": 60567,
                        "name": "Sassano",
                        "latitude": "40.34030000",
                        "longitude": "15.56555000"
                    },
                    {
                        "id": 60571,
                        "name": "Sassinoro",
                        "latitude": "41.37472000",
                        "longitude": "14.66453000"
                    },
                    {
                        "id": 60586,
                        "name": "Saviano",
                        "latitude": "40.90507000",
                        "longitude": "14.50498000"
                    },
                    {
                        "id": 60588,
                        "name": "Savignano Irpino",
                        "latitude": "41.22698000",
                        "longitude": "15.17933000"
                    },
                    {
                        "id": 60602,
                        "name": "Scafati",
                        "latitude": "40.76020000",
                        "longitude": "14.53723000"
                    },
                    {
                        "id": 60604,
                        "name": "Scala",
                        "latitude": "40.65665000",
                        "longitude": "14.60761000"
                    },
                    {
                        "id": 60610,
                        "name": "Scalo Romagnano al Monte",
                        "latitude": "40.61031000",
                        "longitude": "15.44768000"
                    },
                    {
                        "id": 60613,
                        "name": "Scampia",
                        "latitude": "40.90347000",
                        "longitude": "14.23736000"
                    },
                    {
                        "id": 60614,
                        "name": "Scampitella",
                        "latitude": "41.09252000",
                        "longitude": "15.29995000"
                    },
                    {
                        "id": 60631,
                        "name": "Scario",
                        "latitude": "40.06207000",
                        "longitude": "15.47421000"
                    },
                    {
                        "id": 60658,
                        "name": "Scisciano",
                        "latitude": "40.90663000",
                        "longitude": "14.47451000"
                    },
                    {
                        "id": 60678,
                        "name": "Secondigliano",
                        "latitude": "40.90000000",
                        "longitude": "14.26667000"
                    },
                    {
                        "id": 60722,
                        "name": "Senerchia",
                        "latitude": "40.74133000",
                        "longitude": "15.20502000"
                    },
                    {
                        "id": 60742,
                        "name": "Serino",
                        "latitude": "40.85481000",
                        "longitude": "14.87224000"
                    },
                    {
                        "id": 60764,
                        "name": "Serramezzana",
                        "latitude": "40.24460000",
                        "longitude": "15.03246000"
                    },
                    {
                        "id": 60768,
                        "name": "Serrara Fontana",
                        "latitude": "40.71475000",
                        "longitude": "13.89593000"
                    },
                    {
                        "id": 60778,
                        "name": "Serre",
                        "latitude": "40.58251000",
                        "longitude": "15.18555000"
                    },
                    {
                        "id": 60788,
                        "name": "Sessa Aurunca",
                        "latitude": "41.23987000",
                        "longitude": "13.92966000"
                    },
                    {
                        "id": 60789,
                        "name": "Sessa Cilento",
                        "latitude": "40.25920000",
                        "longitude": "15.07576000"
                    },
                    {
                        "id": 60836,
                        "name": "Siano",
                        "latitude": "40.80207000",
                        "longitude": "14.69334000"
                    },
                    {
                        "id": 60839,
                        "name": "Sicignano degli Alburni",
                        "latitude": "40.55882000",
                        "longitude": "15.30560000"
                    },
                    {
                        "id": 60872,
                        "name": "Sirignano",
                        "latitude": "40.94969000",
                        "longitude": "14.62935000"
                    },
                    {
                        "id": 60892,
                        "name": "Soccavo",
                        "latitude": "40.84550000",
                        "longitude": "14.19262000"
                    },
                    {
                        "id": 60921,
                        "name": "Solofra",
                        "latitude": "40.83343000",
                        "longitude": "14.83705000"
                    },
                    {
                        "id": 60923,
                        "name": "Solopaca",
                        "latitude": "41.19535000",
                        "longitude": "14.54767000"
                    },
                    {
                        "id": 60929,
                        "name": "Somma Vesuviana",
                        "latitude": "40.87329000",
                        "longitude": "14.43865000"
                    },
                    {
                        "id": 60950,
                        "name": "Sorbo Serpico",
                        "latitude": "40.91685000",
                        "longitude": "14.88709000"
                    },
                    {
                        "id": 60966,
                        "name": "Sorrento",
                        "latitude": "40.62678000",
                        "longitude": "14.37771000"
                    },
                    {
                        "id": 60990,
                        "name": "Sparanise",
                        "latitude": "41.18788000",
                        "longitude": "14.09628000"
                    },
                    {
                        "id": 60993,
                        "name": "Spartimento",
                        "latitude": "40.89105000",
                        "longitude": "14.47236000"
                    },
                    {
                        "id": 60999,
                        "name": "Sperone",
                        "latitude": "40.95251000",
                        "longitude": "14.60524000"
                    },
                    {
                        "id": 61048,
                        "name": "Starza Vecchia",
                        "latitude": "40.89035000",
                        "longitude": "14.40138000"
                    },
                    {
                        "id": 61062,
                        "name": "Stella",
                        "latitude": "40.86027000",
                        "longitude": "14.25223000"
                    },
                    {
                        "id": 61063,
                        "name": "Stella Cilento",
                        "latitude": "40.23180000",
                        "longitude": "15.09286000"
                    },
                    {
                        "id": 61078,
                        "name": "Stio",
                        "latitude": "40.31020000",
                        "longitude": "15.25153000"
                    },
                    {
                        "id": 61096,
                        "name": "Striano",
                        "latitude": "40.81543000",
                        "longitude": "14.57534000"
                    },
                    {
                        "id": 61105,
                        "name": "Sturno",
                        "latitude": "41.02217000",
                        "longitude": "15.11248000"
                    },
                    {
                        "id": 61110,
                        "name": "Succivo",
                        "latitude": "40.96801000",
                        "longitude": "14.25563000"
                    },
                    {
                        "id": 61120,
                        "name": "Summonte",
                        "latitude": "40.94874000",
                        "longitude": "14.74458000"
                    },
                    {
                        "id": 61174,
                        "name": "Taurano",
                        "latitude": "40.88444000",
                        "longitude": "14.63427000"
                    },
                    {
                        "id": 61175,
                        "name": "Taurasi",
                        "latitude": "41.01080000",
                        "longitude": "14.95980000"
                    },
                    {
                        "id": 61199,
                        "name": "Teano",
                        "latitude": "41.25132000",
                        "longitude": "14.06652000"
                    },
                    {
                        "id": 61201,
                        "name": "Teggiano-Macchiaroli",
                        "latitude": "40.37921000",
                        "longitude": "15.54046000"
                    },
                    {
                        "id": 61205,
                        "name": "Telese",
                        "latitude": "41.21752000",
                        "longitude": "14.52681000"
                    },
                    {
                        "id": 61216,
                        "name": "Teora",
                        "latitude": "40.85282000",
                        "longitude": "15.25335000"
                    },
                    {
                        "id": 61255,
                        "name": "Terzigno",
                        "latitude": "40.80400000",
                        "longitude": "14.49309000"
                    },
                    {
                        "id": 61269,
                        "name": "Teverola",
                        "latitude": "40.99561000",
                        "longitude": "14.20763000"
                    },
                    {
                        "id": 61292,
                        "name": "Tocco Caudio",
                        "latitude": "41.12587000",
                        "longitude": "14.63422000"
                    },
                    {
                        "id": 61315,
                        "name": "Tora",
                        "latitude": "41.33987000",
                        "longitude": "14.02399000"
                    },
                    {
                        "id": 61320,
                        "name": "Torchiara",
                        "latitude": "40.32162000",
                        "longitude": "15.05370000"
                    },
                    {
                        "id": 61322,
                        "name": "Torchiati",
                        "latitude": "40.81837000",
                        "longitude": "14.80165000"
                    },
                    {
                        "id": 61324,
                        "name": "Torella dei Lombardi",
                        "latitude": "40.93731000",
                        "longitude": "15.10784000"
                    },
                    {
                        "id": 61326,
                        "name": "Torelli-Torrette",
                        "latitude": "40.90777000",
                        "longitude": "14.75184000"
                    },
                    {
                        "id": 61341,
                        "name": "Torraca",
                        "latitude": "40.11099000",
                        "longitude": "15.63632000"
                    },
                    {
                        "id": 61347,
                        "name": "Torre Annunziata",
                        "latitude": "40.75337000",
                        "longitude": "14.45251000"
                    },
                    {
                        "id": 61353,
                        "name": "Torre Caracciolo",
                        "latitude": "40.87551000",
                        "longitude": "14.17859000"
                    },
                    {
                        "id": 61371,
                        "name": "Torre del Greco",
                        "latitude": "40.78931000",
                        "longitude": "14.36806000"
                    },
                    {
                        "id": 61377,
                        "name": "Torre le Nocelle",
                        "latitude": "41.02312000",
                        "longitude": "14.90934000"
                    },
                    {
                        "id": 61357,
                        "name": "Torre Orsaia",
                        "latitude": "40.13277000",
                        "longitude": "15.47250000"
                    },
                    {
                        "id": 61381,
                        "name": "Torrecuso",
                        "latitude": "41.18582000",
                        "longitude": "14.68126000"
                    },
                    {
                        "id": 61391,
                        "name": "Torretta-Scalzapecora",
                        "latitude": "40.91015000",
                        "longitude": "14.13456000"
                    },
                    {
                        "id": 61408,
                        "name": "Torrioni",
                        "latitude": "41.03410000",
                        "longitude": "14.81351000"
                    },
                    {
                        "id": 61415,
                        "name": "Tortorella",
                        "latitude": "40.14236000",
                        "longitude": "15.60625000"
                    },
                    {
                        "id": 61432,
                        "name": "Tramonti",
                        "latitude": "40.69154000",
                        "longitude": "14.64490000"
                    },
                    {
                        "id": 61464,
                        "name": "Trecase",
                        "latitude": "40.76941000",
                        "longitude": "14.43773000"
                    },
                    {
                        "id": 61482,
                        "name": "Trentinara",
                        "latitude": "40.39998000",
                        "longitude": "15.11545000"
                    },
                    {
                        "id": 61484,
                        "name": "Trentola-Ducenta",
                        "latitude": "40.97517000",
                        "longitude": "14.17490000"
                    },
                    {
                        "id": 61493,
                        "name": "Trescine",
                        "latitude": "41.02256000",
                        "longitude": "14.62039000"
                    },
                    {
                        "id": 61503,
                        "name": "Trevico",
                        "latitude": "41.04808000",
                        "longitude": "15.23292000"
                    },
                    {
                        "id": 61564,
                        "name": "Tufino",
                        "latitude": "40.95586000",
                        "longitude": "14.56568000"
                    },
                    {
                        "id": 61565,
                        "name": "Tufo",
                        "latitude": "41.01262000",
                        "longitude": "14.81784000"
                    },
                    {
                        "id": 61641,
                        "name": "Vairano-Patenora",
                        "latitude": "41.33702000",
                        "longitude": "14.13112000"
                    },
                    {
                        "id": 61683,
                        "name": "Vallata",
                        "latitude": "41.04019000",
                        "longitude": "15.25383000"
                    },
                    {
                        "id": 61684,
                        "name": "Valle Agricola",
                        "latitude": "41.42477000",
                        "longitude": "14.25584000"
                    },
                    {
                        "id": 61695,
                        "name": "Valle dell'Angelo",
                        "latitude": "40.34381000",
                        "longitude": "15.36846000"
                    },
                    {
                        "id": 61698,
                        "name": "Valle di Maddaloni",
                        "latitude": "41.07946000",
                        "longitude": "14.41788000"
                    },
                    {
                        "id": 61716,
                        "name": "Vallesaccarda",
                        "latitude": "41.06312000",
                        "longitude": "15.25205000"
                    },
                    {
                        "id": 61724,
                        "name": "Vallo della Lucania",
                        "latitude": "40.22786000",
                        "longitude": "15.26635000"
                    },
                    {
                        "id": 61745,
                        "name": "Valva",
                        "latitude": "40.73871000",
                        "longitude": "15.26805000"
                    },
                    {
                        "id": 61824,
                        "name": "Venticano",
                        "latitude": "41.04722000",
                        "longitude": "14.91194000"
                    },
                    {
                        "id": 61908,
                        "name": "Vibonati",
                        "latitude": "40.09921000",
                        "longitude": "15.58357000"
                    },
                    {
                        "id": 61912,
                        "name": "Vicaria",
                        "latitude": "40.86151000",
                        "longitude": "14.27328000"
                    },
                    {
                        "id": 61917,
                        "name": "Vico Equense",
                        "latitude": "40.65977000",
                        "longitude": "14.43386000"
                    },
                    {
                        "id": 61935,
                        "name": "Vietri sul Mare",
                        "latitude": "40.67020000",
                        "longitude": "14.72661000"
                    },
                    {
                        "id": 62040,
                        "name": "Villa di Briano",
                        "latitude": "41.00001000",
                        "longitude": "14.16073000"
                    },
                    {
                        "id": 62004,
                        "name": "Villa Literno",
                        "latitude": "41.00942000",
                        "longitude": "14.07612000"
                    },
                    {
                        "id": 62081,
                        "name": "Villamaina",
                        "latitude": "40.97144000",
                        "longitude": "15.08855000"
                    },
                    {
                        "id": 62086,
                        "name": "Villammare",
                        "latitude": "40.07747000",
                        "longitude": "15.59401000"
                    },
                    {
                        "id": 62108,
                        "name": "Villanova del Battista",
                        "latitude": "41.11897000",
                        "longitude": "15.15839000"
                    },
                    {
                        "id": 62129,
                        "name": "Villaricca",
                        "latitude": "40.92006000",
                        "longitude": "14.19339000"
                    },
                    {
                        "id": 62172,
                        "name": "Visciano",
                        "latitude": "40.92380000",
                        "longitude": "14.58237000"
                    },
                    {
                        "id": 62188,
                        "name": "Vitulano",
                        "latitude": "41.17419000",
                        "longitude": "14.64821000"
                    },
                    {
                        "id": 62189,
                        "name": "Vitulazio",
                        "latitude": "41.16302000",
                        "longitude": "14.21341000"
                    },
                    {
                        "id": 62206,
                        "name": "Volla",
                        "latitude": "40.87363000",
                        "longitude": "14.34085000"
                    },
                    {
                        "id": 62221,
                        "name": "Volturara Irpina",
                        "latitude": "40.88293000",
                        "longitude": "14.91801000"
                    },
                    {
                        "id": 62224,
                        "name": "Vomero",
                        "latitude": "40.84282000",
                        "longitude": "14.23075000"
                    },
                    {
                        "id": 62272,
                        "name": "Zona Industriale",
                        "latitude": "40.84788000",
                        "longitude": "14.28355000"
                    },
                    {
                        "id": 62286,
                        "name": "Zungoli",
                        "latitude": "41.12766000",
                        "longitude": "15.20255000"
                    },
                    {
                        "id": 62288,
                        "name": "Zuni",
                        "latitude": "41.21722000",
                        "longitude": "14.13082000"
                    }
                ]
            },
            {
                "id": 1721,
                "name": "Campobasso",
                "iso2": "CB",
                "latitude": "41.67388650",
                "longitude": "14.75209390",
                "type": "province",
                "cities": []
            },
            {
                "id": 1731,
                "name": "Caserta",
                "iso2": "CE",
                "latitude": "41.20783540",
                "longitude": "14.10013260",
                "type": "province",
                "cities": []
            },
            {
                "id": 1728,
                "name": "Catanzaro",
                "iso2": "CZ",
                "latitude": "38.88963480",
                "longitude": "16.44058720",
                "type": "province",
                "cities": []
            },
            {
                "id": 1739,
                "name": "Chieti",
                "iso2": "CH",
                "latitude": "42.03344280",
                "longitude": "14.37919120",
                "type": "province",
                "cities": []
            },
            {
                "id": 1740,
                "name": "Como",
                "iso2": "CO",
                "latitude": "45.80804160",
                "longitude": "9.08517930",
                "type": "province",
                "cities": []
            },
            {
                "id": 1742,
                "name": "Cosenza",
                "iso2": "CS",
                "latitude": "39.56441050",
                "longitude": "16.25221430",
                "type": "province",
                "cities": []
            },
            {
                "id": 1751,
                "name": "Cremona",
                "iso2": "CR",
                "latitude": "45.20143750",
                "longitude": "9.98365820",
                "type": "province",
                "cities": []
            },
            {
                "id": 1754,
                "name": "Crotone",
                "iso2": "KR",
                "latitude": "39.13098560",
                "longitude": "17.00670310",
                "type": "province",
                "cities": []
            },
            {
                "id": 1775,
                "name": "Cuneo",
                "iso2": "CN",
                "latitude": "44.59703140",
                "longitude": "7.61142170",
                "type": "province",
                "cities": []
            },
            {
                "id": 1773,
                "name": "Emilia-Romagna",
                "iso2": "45",
                "latitude": "44.59676070",
                "longitude": "11.21863960",
                "type": "region",
                "cities": [
                    {
                        "id": 135297,
                        "name": "Agazzano",
                        "latitude": "44.94726000",
                        "longitude": "9.51875000"
                    },
                    {
                        "id": 135359,
                        "name": "Albareto",
                        "latitude": "44.44692000",
                        "longitude": "9.70228000"
                    },
                    {
                        "id": 135364,
                        "name": "Alberi",
                        "latitude": "44.74837000",
                        "longitude": "10.33045000"
                    },
                    {
                        "id": 135377,
                        "name": "Albinea",
                        "latitude": "44.62859000",
                        "longitude": "10.61024000"
                    },
                    {
                        "id": 135428,
                        "name": "Alseno",
                        "latitude": "44.89759000",
                        "longitude": "9.96405000"
                    },
                    {
                        "id": 135437,
                        "name": "Altedo",
                        "latitude": "44.67057000",
                        "longitude": "11.49019000"
                    },
                    {
                        "id": 135529,
                        "name": "Anzola dell'Emilia",
                        "latitude": "44.54197000",
                        "longitude": "11.20548000"
                    },
                    {
                        "id": 135563,
                        "name": "Arceto",
                        "latitude": "44.61762000",
                        "longitude": "10.72461000"
                    },
                    {
                        "id": 135592,
                        "name": "Argelato",
                        "latitude": "44.64009000",
                        "longitude": "11.34359000"
                    },
                    {
                        "id": 135593,
                        "name": "Argenta",
                        "latitude": "44.61397000",
                        "longitude": "11.83547000"
                    },
                    {
                        "id": 135594,
                        "name": "Argine",
                        "latitude": "44.77494000",
                        "longitude": "10.63432000"
                    },
                    {
                        "id": 135745,
                        "name": "Baganzola",
                        "latitude": "44.85513000",
                        "longitude": "10.30706000"
                    },
                    {
                        "id": 135746,
                        "name": "Baggiovara",
                        "latitude": "44.60416000",
                        "longitude": "10.86256000"
                    },
                    {
                        "id": 135753,
                        "name": "Bagnarola",
                        "latitude": "44.16232000",
                        "longitude": "12.34280000"
                    },
                    {
                        "id": 135759,
                        "name": "Bagno",
                        "latitude": "44.65545000",
                        "longitude": "10.75881000"
                    },
                    {
                        "id": 135773,
                        "name": "Bagnolo in Piano",
                        "latitude": "44.76437000",
                        "longitude": "10.67358000"
                    },
                    {
                        "id": 135780,
                        "name": "Baiso",
                        "latitude": "44.49668000",
                        "longitude": "10.60083000"
                    },
                    {
                        "id": 135830,
                        "name": "Barbiano",
                        "latitude": "44.38950000",
                        "longitude": "11.88650000"
                    },
                    {
                        "id": 135837,
                        "name": "Barco",
                        "latitude": "44.68833000",
                        "longitude": "10.49582000"
                    },
                    {
                        "id": 135840,
                        "name": "Bardi",
                        "latitude": "44.63138000",
                        "longitude": "9.72907000"
                    },
                    {
                        "id": 135856,
                        "name": "Baricella",
                        "latitude": "44.64820000",
                        "longitude": "11.53800000"
                    },
                    {
                        "id": 135889,
                        "name": "Basilicagoiano",
                        "latitude": "44.70545000",
                        "longitude": "10.40457000"
                    },
                    {
                        "id": 135890,
                        "name": "Basilicanova",
                        "latitude": "44.69804000",
                        "longitude": "10.35231000"
                    },
                    {
                        "id": 135904,
                        "name": "Bastiglia",
                        "latitude": "44.72697000",
                        "longitude": "10.99860000"
                    },
                    {
                        "id": 135915,
                        "name": "Bazzano",
                        "latitude": "44.50176000",
                        "longitude": "11.08675000"
                    },
                    {
                        "id": 135920,
                        "name": "Bedonia",
                        "latitude": "44.50400000",
                        "longitude": "9.63489000"
                    },
                    {
                        "id": 135940,
                        "name": "Bellaria-Igea Marina",
                        "latitude": "44.14255000",
                        "longitude": "12.47154000"
                    },
                    {
                        "id": 135978,
                        "name": "Bentivoglio",
                        "latitude": "44.63690000",
                        "longitude": "11.41737000"
                    },
                    {
                        "id": 135981,
                        "name": "Berceto",
                        "latitude": "44.50899000",
                        "longitude": "9.99104000"
                    },
                    {
                        "id": 135996,
                        "name": "Berra",
                        "latitude": "44.97656000",
                        "longitude": "11.97727000"
                    },
                    {
                        "id": 136000,
                        "name": "Bertinoro",
                        "latitude": "44.14874000",
                        "longitude": "12.13650000"
                    },
                    {
                        "id": 136006,
                        "name": "Berzantina",
                        "latitude": "44.15786000",
                        "longitude": "10.98083000"
                    },
                    {
                        "id": 136014,
                        "name": "Besenzone",
                        "latitude": "44.98689000",
                        "longitude": "9.95604000"
                    },
                    {
                        "id": 136018,
                        "name": "Bettola",
                        "latitude": "44.77826000",
                        "longitude": "9.60857000"
                    },
                    {
                        "id": 136038,
                        "name": "Bibbiano",
                        "latitude": "44.66292000",
                        "longitude": "10.47391000"
                    },
                    {
                        "id": 136085,
                        "name": "Bobbio",
                        "latitude": "44.76832000",
                        "longitude": "9.38415000"
                    },
                    {
                        "id": 136107,
                        "name": "Bologna",
                        "latitude": "44.46667000",
                        "longitude": "11.43333000"
                    },
                    {
                        "id": 136122,
                        "name": "Bomporto",
                        "latitude": "44.73389000",
                        "longitude": "11.03667000"
                    },
                    {
                        "id": 136129,
                        "name": "Bondeno",
                        "latitude": "44.88944000",
                        "longitude": "11.41542000"
                    },
                    {
                        "id": 136144,
                        "name": "Bora Bassa",
                        "latitude": "44.04636000",
                        "longitude": "12.18066000"
                    },
                    {
                        "id": 136150,
                        "name": "Bore",
                        "latitude": "44.71866000",
                        "longitude": "9.79207000"
                    },
                    {
                        "id": 136151,
                        "name": "Borello",
                        "latitude": "44.05846000",
                        "longitude": "12.17993000"
                    },
                    {
                        "id": 136152,
                        "name": "Boretto",
                        "latitude": "44.90157000",
                        "longitude": "10.55147000"
                    },
                    {
                        "id": 136165,
                        "name": "Borghi",
                        "latitude": "44.03223000",
                        "longitude": "12.35618000"
                    },
                    {
                        "id": 136192,
                        "name": "Borgo Tossignano",
                        "latitude": "44.28233000",
                        "longitude": "11.59659000"
                    },
                    {
                        "id": 136193,
                        "name": "Borgo Val di Taro",
                        "latitude": "44.48899000",
                        "longitude": "9.76906000"
                    },
                    {
                        "id": 136211,
                        "name": "Borgonovo Valtidone",
                        "latitude": "45.01436000",
                        "longitude": "9.44346000"
                    },
                    {
                        "id": 136212,
                        "name": "Borgonuovo",
                        "latitude": "44.43557000",
                        "longitude": "11.27069000"
                    },
                    {
                        "id": 136234,
                        "name": "Borzano",
                        "latitude": "44.60360000",
                        "longitude": "10.63675000"
                    },
                    {
                        "id": 136244,
                        "name": "Bosco Mesola",
                        "latitude": "44.87639000",
                        "longitude": "12.23139000"
                    },
                    {
                        "id": 136313,
                        "name": "Brescello",
                        "latitude": "44.89531000",
                        "longitude": "10.51269000"
                    },
                    {
                        "id": 136381,
                        "name": "Bubano",
                        "latitude": "44.41341000",
                        "longitude": "11.78231000"
                    },
                    {
                        "id": 136393,
                        "name": "Budrio",
                        "latitude": "44.53745000",
                        "longitude": "11.53439000"
                    },
                    {
                        "id": 136419,
                        "name": "Busana",
                        "latitude": "44.36886000",
                        "longitude": "10.32339000"
                    },
                    {
                        "id": 136429,
                        "name": "Busseto",
                        "latitude": "44.97940000",
                        "longitude": "10.04331000"
                    },
                    {
                        "id": 138222,
                        "name": "Cà Dè Fabbri",
                        "latitude": "44.61962000",
                        "longitude": "11.45503000"
                    },
                    {
                        "id": 136447,
                        "name": "Ca' di Sola",
                        "latitude": "44.52986000",
                        "longitude": "10.95448000"
                    },
                    {
                        "id": 136463,
                        "name": "Cadè-Gaida",
                        "latitude": "44.73850000",
                        "longitude": "10.51580000"
                    },
                    {
                        "id": 136454,
                        "name": "Cadelbosco di Sopra",
                        "latitude": "44.76573000",
                        "longitude": "10.59898000"
                    },
                    {
                        "id": 136455,
                        "name": "Cadelbosco di Sotto",
                        "latitude": "44.80141000",
                        "longitude": "10.61578000"
                    },
                    {
                        "id": 136499,
                        "name": "Calcara",
                        "latitude": "44.54696000",
                        "longitude": "11.13366000"
                    },
                    {
                        "id": 136513,
                        "name": "Calderara di Reno",
                        "latitude": "44.56307000",
                        "longitude": "11.27111000"
                    },
                    {
                        "id": 136514,
                        "name": "Calderino",
                        "latitude": "44.45774000",
                        "longitude": "11.19927000"
                    },
                    {
                        "id": 136521,
                        "name": "Calendasco",
                        "latitude": "45.08659000",
                        "longitude": "9.59647000"
                    },
                    {
                        "id": 136524,
                        "name": "Calerno",
                        "latitude": "44.74875000",
                        "longitude": "10.48603000"
                    },
                    {
                        "id": 136525,
                        "name": "Calestano",
                        "latitude": "44.60224000",
                        "longitude": "10.12363000"
                    },
                    {
                        "id": 136588,
                        "name": "Caminata",
                        "latitude": "44.91036000",
                        "longitude": "9.30816000"
                    },
                    {
                        "id": 136605,
                        "name": "Campagnola Emilia",
                        "latitude": "44.83925000",
                        "longitude": "10.76507000"
                    },
                    {
                        "id": 136611,
                        "name": "Campegine",
                        "latitude": "44.78085000",
                        "longitude": "10.52836000"
                    },
                    {
                        "id": 136657,
                        "name": "Campogalliano",
                        "latitude": "44.68874000",
                        "longitude": "10.84705000"
                    },
                    {
                        "id": 136681,
                        "name": "Camposanto",
                        "latitude": "44.79009000",
                        "longitude": "11.14049000"
                    },
                    {
                        "id": 136685,
                        "name": "Camugnano",
                        "latitude": "44.17110000",
                        "longitude": "11.08828000"
                    },
                    {
                        "id": 136755,
                        "name": "Caorso",
                        "latitude": "45.04911000",
                        "longitude": "9.87457000"
                    },
                    {
                        "id": 136803,
                        "name": "Caprara",
                        "latitude": "44.77521000",
                        "longitude": "10.51158000"
                    },
                    {
                        "id": 136906,
                        "name": "Carpaneto Piacentino",
                        "latitude": "44.91355000",
                        "longitude": "9.78703000"
                    },
                    {
                        "id": 136913,
                        "name": "Carpi Centro",
                        "latitude": "44.78237000",
                        "longitude": "10.87770000"
                    },
                    {
                        "id": 136917,
                        "name": "Carpineti",
                        "latitude": "44.45574000",
                        "longitude": "10.51780000"
                    },
                    {
                        "id": 136973,
                        "name": "Casale",
                        "latitude": "44.91665000",
                        "longitude": "10.43169000"
                    },
                    {
                        "id": 136981,
                        "name": "Casalecchio di Reno",
                        "latitude": "44.47563000",
                        "longitude": "11.27495000"
                    },
                    {
                        "id": 136990,
                        "name": "Casalfiumanese",
                        "latitude": "44.29686000",
                        "longitude": "11.62402000"
                    },
                    {
                        "id": 136991,
                        "name": "Casalgrande",
                        "latitude": "44.58466000",
                        "longitude": "10.73550000"
                    },
                    {
                        "id": 137070,
                        "name": "Casina",
                        "latitude": "44.50982000",
                        "longitude": "10.49951000"
                    },
                    {
                        "id": 137162,
                        "name": "Castel d'Aiano",
                        "latitude": "44.27751000",
                        "longitude": "11.00097000"
                    },
                    {
                        "id": 137167,
                        "name": "Castel del Rio",
                        "latitude": "44.21346000",
                        "longitude": "11.50409000"
                    },
                    {
                        "id": 137168,
                        "name": "Castel di Casio",
                        "latitude": "44.16276000",
                        "longitude": "11.03505000"
                    },
                    {
                        "id": 137142,
                        "name": "Castel Guelfo di Bologna",
                        "latitude": "44.43166000",
                        "longitude": "11.67591000"
                    },
                    {
                        "id": 137144,
                        "name": "Castel Maggiore",
                        "latitude": "44.57707000",
                        "longitude": "11.36071000"
                    },
                    {
                        "id": 137151,
                        "name": "Castel San Giovanni",
                        "latitude": "45.06014000",
                        "longitude": "9.43784000"
                    },
                    {
                        "id": 137155,
                        "name": "Castel San Pietro Terme",
                        "latitude": "44.39854000",
                        "longitude": "11.58546000"
                    },
                    {
                        "id": 137189,
                        "name": "Casteldelci",
                        "latitude": "43.79116000",
                        "longitude": "12.15514000"
                    },
                    {
                        "id": 137197,
                        "name": "Castelfranco Emilia",
                        "latitude": "44.59445000",
                        "longitude": "11.04979000"
                    },
                    {
                        "id": 137207,
                        "name": "Castell'Arquato",
                        "latitude": "44.85451000",
                        "longitude": "9.87326000"
                    },
                    {
                        "id": 137222,
                        "name": "Castellarano",
                        "latitude": "44.51825000",
                        "longitude": "10.73727000"
                    },
                    {
                        "id": 137229,
                        "name": "Castelletto",
                        "latitude": "44.44015000",
                        "longitude": "11.06478000"
                    },
                    {
                        "id": 137256,
                        "name": "Castello d'Argile",
                        "latitude": "44.67797000",
                        "longitude": "11.29715000"
                    },
                    {
                        "id": 137279,
                        "name": "Castelnovo di Sotto",
                        "latitude": "44.81253000",
                        "longitude": "10.56694000"
                    },
                    {
                        "id": 137280,
                        "name": "Castelnovo ne'Monti",
                        "latitude": "44.43556000",
                        "longitude": "10.40329000"
                    },
                    {
                        "id": 137293,
                        "name": "Castelnuovo Rangone",
                        "latitude": "44.54935000",
                        "longitude": "10.93350000"
                    },
                    {
                        "id": 137331,
                        "name": "Castelvetro di Modena",
                        "latitude": "44.50422000",
                        "longitude": "10.94666000"
                    },
                    {
                        "id": 137330,
                        "name": "Castelvetro Piacentino",
                        "latitude": "45.10223000",
                        "longitude": "9.99041000"
                    },
                    {
                        "id": 137333,
                        "name": "Castenaso",
                        "latitude": "44.51398000",
                        "longitude": "11.46842000"
                    },
                    {
                        "id": 137351,
                        "name": "Castiglione dei Pepoli",
                        "latitude": "44.14280000",
                        "longitude": "11.16028000"
                    },
                    {
                        "id": 137378,
                        "name": "Castrocaro Terme e Terra del Sole",
                        "latitude": "44.18676000",
                        "longitude": "11.96068000"
                    },
                    {
                        "id": 137396,
                        "name": "Cattolica",
                        "latitude": "43.96182000",
                        "longitude": "12.73631000"
                    },
                    {
                        "id": 137429,
                        "name": "Cavazzona",
                        "latitude": "44.57326000",
                        "longitude": "11.11903000"
                    },
                    {
                        "id": 137436,
                        "name": "Cavezzo",
                        "latitude": "44.83500000",
                        "longitude": "11.02890000"
                    },
                    {
                        "id": 137442,
                        "name": "Cavriago",
                        "latitude": "44.69457000",
                        "longitude": "10.52591000"
                    },
                    {
                        "id": 137497,
                        "name": "Cento",
                        "latitude": "44.73099000",
                        "longitude": "11.28716000"
                    },
                    {
                        "id": 137518,
                        "name": "Cerasolo",
                        "latitude": "43.98805000",
                        "longitude": "12.52988000"
                    },
                    {
                        "id": 137549,
                        "name": "Cerignale",
                        "latitude": "44.67785000",
                        "longitude": "9.35077000"
                    },
                    {
                        "id": 137611,
                        "name": "Cesena",
                        "latitude": "44.13910000",
                        "longitude": "12.24315000"
                    },
                    {
                        "id": 137612,
                        "name": "Cesenatico",
                        "latitude": "44.19987000",
                        "longitude": "12.39910000"
                    },
                    {
                        "id": 137704,
                        "name": "Ciano d'Enza",
                        "latitude": "44.59982000",
                        "longitude": "10.41040000"
                    },
                    {
                        "id": 137803,
                        "name": "Civitella di Romagna",
                        "latitude": "44.00785000",
                        "longitude": "11.94398000"
                    },
                    {
                        "id": 137806,
                        "name": "Classe",
                        "latitude": "44.37955000",
                        "longitude": "12.23654000"
                    },
                    {
                        "id": 137823,
                        "name": "Coccanile-Cesta",
                        "latitude": "44.91667000",
                        "longitude": "11.86667000"
                    },
                    {
                        "id": 137828,
                        "name": "Codemondo-Quaresimo",
                        "latitude": "44.69082000",
                        "longitude": "10.55098000"
                    },
                    {
                        "id": 137831,
                        "name": "Codigoro",
                        "latitude": "44.83093000",
                        "longitude": "12.11073000"
                    },
                    {
                        "id": 137832,
                        "name": "Codisotto",
                        "latitude": "44.98278000",
                        "longitude": "10.72750000"
                    },
                    {
                        "id": 137851,
                        "name": "Coli",
                        "latitude": "44.74582000",
                        "longitude": "9.41468000"
                    },
                    {
                        "id": 137854,
                        "name": "Collagna",
                        "latitude": "44.34694000",
                        "longitude": "10.27350000"
                    },
                    {
                        "id": 137875,
                        "name": "Collecchio",
                        "latitude": "44.75197000",
                        "longitude": "10.21540000"
                    },
                    {
                        "id": 137918,
                        "name": "Colombaro",
                        "latitude": "44.55153000",
                        "longitude": "10.89628000"
                    },
                    {
                        "id": 137926,
                        "name": "Colorno",
                        "latitude": "44.92572000",
                        "longitude": "10.37361000"
                    },
                    {
                        "id": 137934,
                        "name": "Comacchio",
                        "latitude": "44.69478000",
                        "longitude": "12.18194000"
                    },
                    {
                        "id": 137948,
                        "name": "Compiano",
                        "latitude": "44.49605000",
                        "longitude": "9.66207000"
                    },
                    {
                        "id": 137952,
                        "name": "Cona",
                        "latitude": "44.80583000",
                        "longitude": "11.70690000"
                    },
                    {
                        "id": 137960,
                        "name": "Concordia sulla Secchia",
                        "latitude": "44.91258000",
                        "longitude": "10.98802000"
                    },
                    {
                        "id": 137971,
                        "name": "Consandolo",
                        "latitude": "44.65606000",
                        "longitude": "11.77524000"
                    },
                    {
                        "id": 137988,
                        "name": "Copparo",
                        "latitude": "44.89263000",
                        "longitude": "11.82287000"
                    },
                    {
                        "id": 137997,
                        "name": "Corcagnano",
                        "latitude": "44.72103000",
                        "longitude": "10.30271000"
                    },
                    {
                        "id": 138011,
                        "name": "Coriano",
                        "latitude": "43.96907000",
                        "longitude": "12.60055000"
                    },
                    {
                        "id": 138032,
                        "name": "Corniglio",
                        "latitude": "44.47425000",
                        "longitude": "10.09009000"
                    },
                    {
                        "id": 138037,
                        "name": "Corpo Reno",
                        "latitude": "44.75591000",
                        "longitude": "11.30794000"
                    },
                    {
                        "id": 138038,
                        "name": "Corpolò",
                        "latitude": "44.01905000",
                        "longitude": "12.45266000"
                    },
                    {
                        "id": 138039,
                        "name": "Correggio",
                        "latitude": "44.76737000",
                        "longitude": "10.78345000"
                    },
                    {
                        "id": 138060,
                        "name": "Cortemaggiore",
                        "latitude": "44.99185000",
                        "longitude": "9.92844000"
                    },
                    {
                        "id": 138144,
                        "name": "Crespellano",
                        "latitude": "44.51196000",
                        "longitude": "11.13224000"
                    },
                    {
                        "id": 138152,
                        "name": "Crevalcore",
                        "latitude": "44.71966000",
                        "longitude": "11.14765000"
                    },
                    {
                        "id": 138213,
                        "name": "Cusercoli",
                        "latitude": "44.04514000",
                        "longitude": "12.00740000"
                    },
                    {
                        "id": 138235,
                        "name": "Decima",
                        "latitude": "44.71045000",
                        "longitude": "11.22978000"
                    },
                    {
                        "id": 138275,
                        "name": "Dodici Morelli",
                        "latitude": "44.79234000",
                        "longitude": "11.29124000"
                    },
                    {
                        "id": 138316,
                        "name": "Dosso",
                        "latitude": "44.76806000",
                        "longitude": "11.33938000"
                    },
                    {
                        "id": 138322,
                        "name": "Dovadola",
                        "latitude": "44.12211000",
                        "longitude": "11.88707000"
                    },
                    {
                        "id": 138324,
                        "name": "Dozza",
                        "latitude": "44.36195000",
                        "longitude": "11.63547000"
                    },
                    {
                        "id": 138392,
                        "name": "Fabbrico",
                        "latitude": "44.87214000",
                        "longitude": "10.80893000"
                    },
                    {
                        "id": 138429,
                        "name": "Fanano",
                        "latitude": "44.21245000",
                        "longitude": "10.79660000"
                    },
                    {
                        "id": 138448,
                        "name": "Farini",
                        "latitude": "44.71266000",
                        "longitude": "9.56887000"
                    },
                    {
                        "id": 138466,
                        "name": "Felegara",
                        "latitude": "44.72187000",
                        "longitude": "10.11273000"
                    },
                    {
                        "id": 138468,
                        "name": "Felina",
                        "latitude": "44.45478000",
                        "longitude": "10.46067000"
                    },
                    {
                        "id": 138469,
                        "name": "Felino",
                        "latitude": "44.69902000",
                        "longitude": "10.23828000"
                    },
                    {
                        "id": 138472,
                        "name": "Fellegara",
                        "latitude": "44.61052000",
                        "longitude": "10.69700000"
                    },
                    {
                        "id": 138489,
                        "name": "Ferrara",
                        "latitude": "44.83804000",
                        "longitude": "11.62057000"
                    },
                    {
                        "id": 138496,
                        "name": "Ferriere",
                        "latitude": "44.64385000",
                        "longitude": "9.49657000"
                    },
                    {
                        "id": 138507,
                        "name": "Fidenza",
                        "latitude": "44.86694000",
                        "longitude": "10.06039000"
                    },
                    {
                        "id": 138535,
                        "name": "Finale Emilia",
                        "latitude": "44.83373000",
                        "longitude": "11.29378000"
                    },
                    {
                        "id": 138539,
                        "name": "Fiorano",
                        "latitude": "44.53889000",
                        "longitude": "10.81166000"
                    },
                    {
                        "id": 138542,
                        "name": "Fiorenzuola d'Arda",
                        "latitude": "44.92435000",
                        "longitude": "9.91329000"
                    },
                    {
                        "id": 138547,
                        "name": "Fiumalbo-Dogana",
                        "latitude": "44.17925000",
                        "longitude": "10.64720000"
                    },
                    {
                        "id": 138548,
                        "name": "Fiumana",
                        "latitude": "44.14325000",
                        "longitude": "11.98719000"
                    },
                    {
                        "id": 138575,
                        "name": "Fogliano",
                        "latitude": "44.64751000",
                        "longitude": "10.64505000"
                    },
                    {
                        "id": 138577,
                        "name": "Fognano",
                        "latitude": "44.20509000",
                        "longitude": "11.73782000"
                    },
                    {
                        "id": 138597,
                        "name": "Fontanelice",
                        "latitude": "44.25932000",
                        "longitude": "11.55852000"
                    },
                    {
                        "id": 138600,
                        "name": "Fontanellato",
                        "latitude": "44.88187000",
                        "longitude": "10.17631000"
                    },
                    {
                        "id": 138613,
                        "name": "Fontevivo",
                        "latitude": "44.85942000",
                        "longitude": "10.17281000"
                    },
                    {
                        "id": 138619,
                        "name": "Forche",
                        "latitude": "44.63646000",
                        "longitude": "10.57316000"
                    },
                    {
                        "id": 138632,
                        "name": "Forlì",
                        "latitude": "44.22177000",
                        "longitude": "12.04144000"
                    },
                    {
                        "id": 138631,
                        "name": "Forlimpopoli",
                        "latitude": "44.19107000",
                        "longitude": "12.12873000"
                    },
                    {
                        "id": 138637,
                        "name": "Formica",
                        "latitude": "44.46838000",
                        "longitude": "11.01337000"
                    },
                    {
                        "id": 138640,
                        "name": "Formigine",
                        "latitude": "44.57268000",
                        "longitude": "10.84737000"
                    },
                    {
                        "id": 138642,
                        "name": "Formignana",
                        "latitude": "44.84230000",
                        "longitude": "11.85935000"
                    },
                    {
                        "id": 138644,
                        "name": "Fornace Zarattini",
                        "latitude": "44.41667000",
                        "longitude": "12.13333000"
                    },
                    {
                        "id": 138660,
                        "name": "Fornovo di Taro",
                        "latitude": "44.69465000",
                        "longitude": "10.10178000"
                    },
                    {
                        "id": 138668,
                        "name": "Fossa",
                        "latitude": "44.92304000",
                        "longitude": "11.02356000"
                    },
                    {
                        "id": 138679,
                        "name": "Fosso Ghiaia",
                        "latitude": "44.35525000",
                        "longitude": "12.25430000"
                    },
                    {
                        "id": 138680,
                        "name": "Fossoli",
                        "latitude": "44.82160000",
                        "longitude": "10.88977000"
                    },
                    {
                        "id": 138704,
                        "name": "Francolino",
                        "latitude": "44.89662000",
                        "longitude": "11.65701000"
                    },
                    {
                        "id": 138716,
                        "name": "Frassinoro",
                        "latitude": "44.29451000",
                        "longitude": "10.57117000"
                    },
                    {
                        "id": 138720,
                        "name": "Fratta Terme",
                        "latitude": "44.14157000",
                        "longitude": "12.10213000"
                    },
                    {
                        "id": 138778,
                        "name": "Gaggio",
                        "latitude": "44.63458000",
                        "longitude": "11.01334000"
                    },
                    {
                        "id": 138779,
                        "name": "Gaggio Montano",
                        "latitude": "44.19583000",
                        "longitude": "10.93518000"
                    },
                    {
                        "id": 138786,
                        "name": "Gaiano",
                        "latitude": "44.72391000",
                        "longitude": "10.17267000"
                    },
                    {
                        "id": 138789,
                        "name": "Gaibanella-Sant'Edigio",
                        "latitude": "44.76667000",
                        "longitude": "11.65000000"
                    },
                    {
                        "id": 138799,
                        "name": "Galeata",
                        "latitude": "43.99607000",
                        "longitude": "11.91057000"
                    },
                    {
                        "id": 138814,
                        "name": "Gallo",
                        "latitude": "44.73144000",
                        "longitude": "11.55284000"
                    },
                    {
                        "id": 138833,
                        "name": "Gambettola",
                        "latitude": "44.11748000",
                        "longitude": "12.33705000"
                    },
                    {
                        "id": 138866,
                        "name": "Gatteo a Mare",
                        "latitude": "44.17069000",
                        "longitude": "12.43549000"
                    },
                    {
                        "id": 138867,
                        "name": "Gatteo-Sant'Angelo",
                        "latitude": "44.11194000",
                        "longitude": "12.39139000"
                    },
                    {
                        "id": 138886,
                        "name": "Gazzola",
                        "latitude": "44.96006000",
                        "longitude": "9.54896000"
                    },
                    {
                        "id": 138892,
                        "name": "Gemmano",
                        "latitude": "43.90393000",
                        "longitude": "12.58091000"
                    },
                    {
                        "id": 139006,
                        "name": "Glorie",
                        "latitude": "44.46994000",
                        "longitude": "12.07707000"
                    },
                    {
                        "id": 139009,
                        "name": "Godo",
                        "latitude": "44.39173000",
                        "longitude": "12.07495000"
                    },
                    {
                        "id": 139039,
                        "name": "Goro",
                        "latitude": "44.85150000",
                        "longitude": "12.29651000"
                    },
                    {
                        "id": 139041,
                        "name": "Gorzano",
                        "latitude": "44.51626000",
                        "longitude": "10.87983000"
                    },
                    {
                        "id": 139044,
                        "name": "Gossolengo",
                        "latitude": "45.00248000",
                        "longitude": "9.61799000"
                    },
                    {
                        "id": 139057,
                        "name": "Gragnano Trebbiense",
                        "latitude": "45.01225000",
                        "longitude": "9.57139000"
                    },
                    {
                        "id": 139060,
                        "name": "Granarolo",
                        "latitude": "44.35859000",
                        "longitude": "11.93459000"
                    },
                    {
                        "id": 139061,
                        "name": "Granarolo dell'Emilia e Viadagola",
                        "latitude": "44.55327000",
                        "longitude": "11.44291000"
                    },
                    {
                        "id": 139105,
                        "name": "Grizzana",
                        "latitude": "44.25806000",
                        "longitude": "11.15557000"
                    },
                    {
                        "id": 139106,
                        "name": "Grizzana Morandi",
                        "latitude": "44.25820000",
                        "longitude": "11.15288000"
                    },
                    {
                        "id": 139114,
                        "name": "Gropparello",
                        "latitude": "44.83354000",
                        "longitude": "9.72801000"
                    },
                    {
                        "id": 139148,
                        "name": "Gualtieri",
                        "latitude": "44.89736000",
                        "longitude": "10.62860000"
                    },
                    {
                        "id": 139169,
                        "name": "Guastalla",
                        "latitude": "44.91172000",
                        "longitude": "10.66186000"
                    },
                    {
                        "id": 139180,
                        "name": "Guiglia",
                        "latitude": "44.42432000",
                        "longitude": "10.96125000"
                    },
                    {
                        "id": 139199,
                        "name": "Imola",
                        "latitude": "44.35916000",
                        "longitude": "11.71320000"
                    },
                    {
                        "id": 139279,
                        "name": "Jolanda di Savoia",
                        "latitude": "44.88319000",
                        "longitude": "11.97910000"
                    },
                    {
                        "id": 139302,
                        "name": "La Saletta-Tamara",
                        "latitude": "44.88151000",
                        "longitude": "11.77236000"
                    },
                    {
                        "id": 139328,
                        "name": "Lagosanto",
                        "latitude": "44.76282000",
                        "longitude": "12.14005000"
                    },
                    {
                        "id": 139339,
                        "name": "Lama",
                        "latitude": "44.30726000",
                        "longitude": "10.73060000"
                    },
                    {
                        "id": 139358,
                        "name": "Langhirano",
                        "latitude": "44.61913000",
                        "longitude": "10.26652000"
                    },
                    {
                        "id": 139414,
                        "name": "Lavezzola",
                        "latitude": "44.56099000",
                        "longitude": "11.87557000"
                    },
                    {
                        "id": 139453,
                        "name": "Lentigione-Sorbolo a Mane",
                        "latitude": "44.86667000",
                        "longitude": "10.48333000"
                    },
                    {
                        "id": 139468,
                        "name": "Lesignano de'Bagni",
                        "latitude": "44.64346000",
                        "longitude": "10.30039000"
                    },
                    {
                        "id": 139502,
                        "name": "Lido Adriano",
                        "latitude": "44.41673000",
                        "longitude": "12.30552000"
                    },
                    {
                        "id": 139503,
                        "name": "Lido degli Estensi",
                        "latitude": "44.66639000",
                        "longitude": "12.25000000"
                    },
                    {
                        "id": 139508,
                        "name": "Lido di Pomposa-Lido degli Scacchi",
                        "latitude": "44.70667000",
                        "longitude": "12.23611000"
                    },
                    {
                        "id": 139512,
                        "name": "Ligonchio",
                        "latitude": "44.31635000",
                        "longitude": "10.34224000"
                    },
                    {
                        "id": 139520,
                        "name": "Limidi",
                        "latitude": "44.76427000",
                        "longitude": "10.92002000"
                    },
                    {
                        "id": 139556,
                        "name": "Lizzano in Belvedere",
                        "latitude": "44.16135000",
                        "longitude": "10.89408000"
                    },
                    {
                        "id": 139576,
                        "name": "Loiano",
                        "latitude": "44.26806000",
                        "longitude": "11.32841000"
                    },
                    {
                        "id": 139589,
                        "name": "Longara",
                        "latitude": "44.57110000",
                        "longitude": "11.30386000"
                    },
                    {
                        "id": 139592,
                        "name": "Longastrino",
                        "latitude": "44.58848000",
                        "longitude": "12.00982000"
                    },
                    {
                        "id": 139596,
                        "name": "Longiano",
                        "latitude": "44.07446000",
                        "longitude": "12.32970000"
                    },
                    {
                        "id": 139644,
                        "name": "Lugagnano Val d'Arda",
                        "latitude": "44.82304000",
                        "longitude": "9.82828000"
                    },
                    {
                        "id": 139684,
                        "name": "Luzzara",
                        "latitude": "44.95925000",
                        "longitude": "10.68953000"
                    },
                    {
                        "id": 139709,
                        "name": "Madonna Dell'Albero",
                        "latitude": "44.38115000",
                        "longitude": "12.20044000"
                    },
                    {
                        "id": 139742,
                        "name": "Magreta",
                        "latitude": "44.60000000",
                        "longitude": "10.80000000"
                    },
                    {
                        "id": 139755,
                        "name": "Malalbergo",
                        "latitude": "44.71867000",
                        "longitude": "11.53221000"
                    },
                    {
                        "id": 139814,
                        "name": "Manzolino",
                        "latitude": "44.59577000",
                        "longitude": "11.09982000"
                    },
                    {
                        "id": 139819,
                        "name": "Maranello",
                        "latitude": "44.53101000",
                        "longitude": "10.86888000"
                    },
                    {
                        "id": 139829,
                        "name": "Marano sul Panaro",
                        "latitude": "44.45924000",
                        "longitude": "10.96879000"
                    },
                    {
                        "id": 139894,
                        "name": "Marina di Ravenna",
                        "latitude": "44.48625000",
                        "longitude": "12.28087000"
                    },
                    {
                        "id": 139873,
                        "name": "Marina Romea",
                        "latitude": "44.51494000",
                        "longitude": "12.27113000"
                    },
                    {
                        "id": 139917,
                        "name": "Marsaglia",
                        "latitude": "44.71228000",
                        "longitude": "9.38353000"
                    },
                    {
                        "id": 139943,
                        "name": "Marzabotto",
                        "latitude": "44.34297000",
                        "longitude": "11.20593000"
                    },
                    {
                        "id": 139961,
                        "name": "Masi-Torello",
                        "latitude": "44.79458000",
                        "longitude": "11.80182000"
                    },
                    {
                        "id": 139969,
                        "name": "Massa Finalese",
                        "latitude": "44.85240000",
                        "longitude": "11.21429000"
                    },
                    {
                        "id": 139970,
                        "name": "Massa Fiscaglia",
                        "latitude": "44.80983000",
                        "longitude": "12.00746000"
                    },
                    {
                        "id": 139983,
                        "name": "Massenzatico",
                        "latitude": "44.73477000",
                        "longitude": "10.69736000"
                    },
                    {
                        "id": 140019,
                        "name": "Medesano",
                        "latitude": "44.75824000",
                        "longitude": "10.13794000"
                    },
                    {
                        "id": 140020,
                        "name": "Medicina-Buda",
                        "latitude": "44.47867000",
                        "longitude": "11.63812000"
                    },
                    {
                        "id": 140025,
                        "name": "Medolla",
                        "latitude": "44.84667000",
                        "longitude": "11.06760000"
                    },
                    {
                        "id": 140037,
                        "name": "Meldola",
                        "latitude": "44.12775000",
                        "longitude": "12.06260000"
                    },
                    {
                        "id": 140078,
                        "name": "Mercato Saraceno",
                        "latitude": "43.96274000",
                        "longitude": "12.19638000"
                    },
                    {
                        "id": 140095,
                        "name": "Mesola",
                        "latitude": "44.91831000",
                        "longitude": "12.23121000"
                    },
                    {
                        "id": 140112,
                        "name": "Mezzano",
                        "latitude": "44.46625000",
                        "longitude": "12.08632000"
                    },
                    {
                        "id": 140114,
                        "name": "Mezzano Inferiore",
                        "latitude": "44.91291000",
                        "longitude": "10.45838000"
                    },
                    {
                        "id": 140119,
                        "name": "Mezzogoro",
                        "latitude": "44.90256000",
                        "longitude": "12.09925000"
                    },
                    {
                        "id": 140121,
                        "name": "Mezzolara",
                        "latitude": "44.58917000",
                        "longitude": "11.56492000"
                    },
                    {
                        "id": 140133,
                        "name": "Migliarina",
                        "latitude": "44.81042000",
                        "longitude": "10.83600000"
                    },
                    {
                        "id": 140135,
                        "name": "Migliarino",
                        "latitude": "44.76993000",
                        "longitude": "11.93304000"
                    },
                    {
                        "id": 140136,
                        "name": "Migliaro",
                        "latitude": "44.79916000",
                        "longitude": "11.97440000"
                    },
                    {
                        "id": 140144,
                        "name": "Milano Marittima",
                        "latitude": "44.27409000",
                        "longitude": "12.35172000"
                    },
                    {
                        "id": 140158,
                        "name": "Minerbio",
                        "latitude": "44.61811000",
                        "longitude": "11.47257000"
                    },
                    {
                        "id": 140169,
                        "name": "Mirabello",
                        "latitude": "44.82295000",
                        "longitude": "11.45669000"
                    },
                    {
                        "id": 140174,
                        "name": "Mirandola",
                        "latitude": "44.88515000",
                        "longitude": "11.06902000"
                    },
                    {
                        "id": 140178,
                        "name": "Misano Adriatico",
                        "latitude": "43.97714000",
                        "longitude": "12.69805000"
                    },
                    {
                        "id": 140188,
                        "name": "Modena",
                        "latitude": "44.64783000",
                        "longitude": "10.92539000"
                    },
                    {
                        "id": 140190,
                        "name": "Modigliana",
                        "latitude": "44.15954000",
                        "longitude": "11.79286000"
                    },
                    {
                        "id": 140217,
                        "name": "Molinella",
                        "latitude": "44.61758000",
                        "longitude": "11.66719000"
                    },
                    {
                        "id": 140223,
                        "name": "Molino del Pallone",
                        "latitude": "44.10028000",
                        "longitude": "10.96135000"
                    },
                    {
                        "id": 140267,
                        "name": "Monchio delle Corti",
                        "latitude": "44.41172000",
                        "longitude": "10.12370000"
                    },
                    {
                        "id": 140272,
                        "name": "Mondaino",
                        "latitude": "43.85796000",
                        "longitude": "12.66845000"
                    },
                    {
                        "id": 140284,
                        "name": "Monghidoro",
                        "latitude": "44.22327000",
                        "longitude": "11.32331000"
                    },
                    {
                        "id": 140316,
                        "name": "Montalbano",
                        "latitude": "43.95879000",
                        "longitude": "12.71646000"
                    },
                    {
                        "id": 140327,
                        "name": "Montale",
                        "latitude": "44.56923000",
                        "longitude": "10.90771000"
                    },
                    {
                        "id": 140356,
                        "name": "Monte Colombo",
                        "latitude": "43.92016000",
                        "longitude": "12.55235000"
                    },
                    {
                        "id": 140370,
                        "name": "Monte San Giovanni",
                        "latitude": "44.42014000",
                        "longitude": "11.17170000"
                    },
                    {
                        "id": 140407,
                        "name": "Montecavolo",
                        "latitude": "44.63275000",
                        "longitude": "10.54264000"
                    },
                    {
                        "id": 140410,
                        "name": "Montecchio Emilia",
                        "latitude": "44.69937000",
                        "longitude": "10.45211000"
                    },
                    {
                        "id": 140416,
                        "name": "Montechiarugolo",
                        "latitude": "44.69261000",
                        "longitude": "10.42128000"
                    },
                    {
                        "id": 140425,
                        "name": "Montecreto",
                        "latitude": "44.24596000",
                        "longitude": "10.71760000"
                    },
                    {
                        "id": 140439,
                        "name": "Montefiore Conca",
                        "latitude": "43.88916000",
                        "longitude": "12.61145000"
                    },
                    {
                        "id": 140441,
                        "name": "Montefiorino",
                        "latitude": "44.35382000",
                        "longitude": "10.62375000"
                    },
                    {
                        "id": 140457,
                        "name": "Montegridolfo",
                        "latitude": "43.85826000",
                        "longitude": "12.68995000"
                    },
                    {
                        "id": 140516,
                        "name": "Monterenzio",
                        "latitude": "44.32632000",
                        "longitude": "11.40446000"
                    },
                    {
                        "id": 140538,
                        "name": "Montescudo",
                        "latitude": "43.91753000",
                        "longitude": "12.54083000"
                    },
                    {
                        "id": 140539,
                        "name": "Montese",
                        "latitude": "44.26993000",
                        "longitude": "10.94545000"
                    },
                    {
                        "id": 140556,
                        "name": "Montiano",
                        "latitude": "44.08232000",
                        "longitude": "12.30455000"
                    },
                    {
                        "id": 140562,
                        "name": "Monticelli d'Ongina",
                        "latitude": "45.08851000",
                        "longitude": "9.93424000"
                    },
                    {
                        "id": 140561,
                        "name": "Monticelli Terme",
                        "latitude": "44.72881000",
                        "longitude": "10.39444000"
                    },
                    {
                        "id": 140596,
                        "name": "Monzuno",
                        "latitude": "44.27825000",
                        "longitude": "11.26684000"
                    },
                    {
                        "id": 140605,
                        "name": "Morciano di Romagna",
                        "latitude": "43.91440000",
                        "longitude": "12.65104000"
                    },
                    {
                        "id": 140607,
                        "name": "Mordano",
                        "latitude": "44.39696000",
                        "longitude": "11.80763000"
                    },
                    {
                        "id": 140612,
                        "name": "Morfasso",
                        "latitude": "44.72270000",
                        "longitude": "9.70221000"
                    },
                    {
                        "id": 140683,
                        "name": "Mulino",
                        "latitude": "44.49257000",
                        "longitude": "11.04667000"
                    },
                    {
                        "id": 140755,
                        "name": "Neviano degli Arduini",
                        "latitude": "44.58344000",
                        "longitude": "10.31638000"
                    },
                    {
                        "id": 140758,
                        "name": "Nibbiano",
                        "latitude": "44.90506000",
                        "longitude": "9.32826000"
                    },
                    {
                        "id": 140773,
                        "name": "Niviano",
                        "latitude": "44.94027000",
                        "longitude": "9.62878000"
                    },
                    {
                        "id": 140787,
                        "name": "Noceto",
                        "latitude": "44.80953000",
                        "longitude": "10.17730000"
                    },
                    {
                        "id": 140802,
                        "name": "Nonantola",
                        "latitude": "44.67785000",
                        "longitude": "11.03785000"
                    },
                    {
                        "id": 140818,
                        "name": "Novafeltria",
                        "latitude": "43.89486000",
                        "longitude": "12.28894000"
                    },
                    {
                        "id": 140829,
                        "name": "Novellara",
                        "latitude": "44.84488000",
                        "longitude": "10.72745000"
                    },
                    {
                        "id": 140837,
                        "name": "Novi di Modena",
                        "latitude": "44.88974000",
                        "longitude": "10.90027000"
                    },
                    {
                        "id": 141017,
                        "name": "Ospedaletto",
                        "latitude": "43.98380000",
                        "longitude": "12.57056000"
                    },
                    {
                        "id": 141031,
                        "name": "Ostellato",
                        "latitude": "44.74556000",
                        "longitude": "11.94276000"
                    },
                    {
                        "id": 141035,
                        "name": "Osteria Grande",
                        "latitude": "44.42845000",
                        "longitude": "11.52180000"
                    },
                    {
                        "id": 141037,
                        "name": "Osteria Nuova",
                        "latitude": "44.58457000",
                        "longitude": "11.23739000"
                    },
                    {
                        "id": 141053,
                        "name": "Ottone",
                        "latitude": "44.62325000",
                        "longitude": "9.33267000"
                    },
                    {
                        "id": 141065,
                        "name": "Ozzano dell'Emilia",
                        "latitude": "44.44427000",
                        "longitude": "11.47552000"
                    },
                    {
                        "id": 141064,
                        "name": "Ozzano Taro",
                        "latitude": "44.70969000",
                        "longitude": "10.14086000"
                    },
                    {
                        "id": 141091,
                        "name": "Padulle",
                        "latitude": "44.62945000",
                        "longitude": "11.27738000"
                    },
                    {
                        "id": 58218,
                        "name": "Palagano",
                        "latitude": "44.32152000",
                        "longitude": "10.64660000"
                    },
                    {
                        "id": 58223,
                        "name": "Palanzano",
                        "latitude": "44.43629000",
                        "longitude": "10.19400000"
                    },
                    {
                        "id": 58279,
                        "name": "Panighina",
                        "latitude": "44.17162000",
                        "longitude": "12.16324000"
                    },
                    {
                        "id": 58307,
                        "name": "Parma",
                        "latitude": "44.79935000",
                        "longitude": "10.32618000"
                    },
                    {
                        "id": 58365,
                        "name": "Pavullo nel Frignano",
                        "latitude": "44.33352000",
                        "longitude": "10.83544000"
                    },
                    {
                        "id": 58371,
                        "name": "Pecorara",
                        "latitude": "44.87582000",
                        "longitude": "9.38387000"
                    },
                    {
                        "id": 58393,
                        "name": "Pellegrino Parmense",
                        "latitude": "44.72950000",
                        "longitude": "9.93240000"
                    },
                    {
                        "id": 58405,
                        "name": "Pennabilli",
                        "latitude": "43.81746000",
                        "longitude": "12.26708000"
                    },
                    {
                        "id": 58502,
                        "name": "Piacenza",
                        "latitude": "45.05242000",
                        "longitude": "9.69342000"
                    },
                    {
                        "id": 58525,
                        "name": "Pianello Val Tidone",
                        "latitude": "44.94666000",
                        "longitude": "9.40516000"
                    },
                    {
                        "id": 58533,
                        "name": "Piangipane",
                        "latitude": "44.42198000",
                        "longitude": "12.09066000"
                    },
                    {
                        "id": 58550,
                        "name": "Pianoro",
                        "latitude": "44.38893000",
                        "longitude": "11.34262000"
                    },
                    {
                        "id": 58610,
                        "name": "Pietracuta",
                        "latitude": "43.95400000",
                        "longitude": "12.37138000"
                    },
                    {
                        "id": 58650,
                        "name": "Pieve di Cento",
                        "latitude": "44.71293000",
                        "longitude": "11.30922000"
                    },
                    {
                        "id": 58658,
                        "name": "Pievepelago",
                        "latitude": "44.20475000",
                        "longitude": "10.61660000"
                    },
                    {
                        "id": 58668,
                        "name": "Pilastro",
                        "latitude": "44.68254000",
                        "longitude": "10.28879000"
                    },
                    {
                        "id": 58671,
                        "name": "Pinarella",
                        "latitude": "44.24167000",
                        "longitude": "12.37111000"
                    },
                    {
                        "id": 58699,
                        "name": "Piozzano",
                        "latitude": "44.92533000",
                        "longitude": "9.49559000"
                    },
                    {
                        "id": 58710,
                        "name": "Pisignano",
                        "latitude": "44.23787000",
                        "longitude": "12.26841000"
                    },
                    {
                        "id": 58720,
                        "name": "Piumazzo",
                        "latitude": "44.54631000",
                        "longitude": "11.06727000"
                    },
                    {
                        "id": 58724,
                        "name": "Pizzano",
                        "latitude": "44.35500000",
                        "longitude": "11.41499000"
                    },
                    {
                        "id": 58745,
                        "name": "Podenzano",
                        "latitude": "44.95484000",
                        "longitude": "9.68315000"
                    },
                    {
                        "id": 58751,
                        "name": "Poggio Berni",
                        "latitude": "44.02639000",
                        "longitude": "12.40944000"
                    },
                    {
                        "id": 58760,
                        "name": "Poggio Renatico",
                        "latitude": "44.76581000",
                        "longitude": "11.48695000"
                    },
                    {
                        "id": 58785,
                        "name": "Polesine Parmense",
                        "latitude": "45.01682000",
                        "longitude": "10.09015000"
                    },
                    {
                        "id": 58791,
                        "name": "Polinago",
                        "latitude": "44.34502000",
                        "longitude": "10.72597000"
                    },
                    {
                        "id": 58852,
                        "name": "Ponte dell'Olio",
                        "latitude": "44.86762000",
                        "longitude": "9.64433000"
                    },
                    {
                        "id": 58853,
                        "name": "Ponte della Venturina",
                        "latitude": "44.13042000",
                        "longitude": "10.99113000"
                    },
                    {
                        "id": 58846,
                        "name": "Ponte Ronca",
                        "latitude": "44.50166000",
                        "longitude": "11.18973000"
                    },
                    {
                        "id": 58850,
                        "name": "Ponte Taro",
                        "latitude": "44.82872000",
                        "longitude": "10.21037000"
                    },
                    {
                        "id": 58870,
                        "name": "Pontegradella",
                        "latitude": "44.83813000",
                        "longitude": "11.66280000"
                    },
                    {
                        "id": 58872,
                        "name": "Pontelangorino",
                        "latitude": "44.86087000",
                        "longitude": "12.14864000"
                    },
                    {
                        "id": 58875,
                        "name": "Pontenure",
                        "latitude": "44.99821000",
                        "longitude": "9.79139000"
                    },
                    {
                        "id": 58884,
                        "name": "Ponticella",
                        "latitude": "44.45446000",
                        "longitude": "11.37851000"
                    },
                    {
                        "id": 58909,
                        "name": "Porotto-Cassama",
                        "latitude": "44.85000000",
                        "longitude": "11.55000000"
                    },
                    {
                        "id": 58911,
                        "name": "Porporano",
                        "latitude": "44.75266000",
                        "longitude": "10.35054000"
                    },
                    {
                        "id": 58912,
                        "name": "Porretta Terme",
                        "latitude": "44.16325000",
                        "longitude": "10.97432000"
                    },
                    {
                        "id": 58919,
                        "name": "Portico di Romagna",
                        "latitude": "44.02657000",
                        "longitude": "11.78133000"
                    },
                    {
                        "id": 58920,
                        "name": "Portico e San Benedetto",
                        "latitude": "44.02646000",
                        "longitude": "11.78153000"
                    },
                    {
                        "id": 58927,
                        "name": "Porto Corsini",
                        "latitude": "44.49410000",
                        "longitude": "12.27875000"
                    },
                    {
                        "id": 58930,
                        "name": "Porto Fuori",
                        "latitude": "44.40557000",
                        "longitude": "12.25218000"
                    },
                    {
                        "id": 58931,
                        "name": "Porto Garibaldi",
                        "latitude": "44.68123000",
                        "longitude": "12.23678000"
                    },
                    {
                        "id": 58947,
                        "name": "Portomaggiore",
                        "latitude": "44.69763000",
                        "longitude": "11.80760000"
                    },
                    {
                        "id": 58970,
                        "name": "Poviglio",
                        "latitude": "44.84227000",
                        "longitude": "10.53936000"
                    },
                    {
                        "id": 58973,
                        "name": "Pozza",
                        "latitude": "44.52641000",
                        "longitude": "10.89234000"
                    },
                    {
                        "id": 59022,
                        "name": "Praticello",
                        "latitude": "44.80436000",
                        "longitude": "10.47310000"
                    },
                    {
                        "id": 59024,
                        "name": "Pratissolo",
                        "latitude": "44.60416000",
                        "longitude": "10.67400000"
                    },
                    {
                        "id": 59027,
                        "name": "Prato",
                        "latitude": "44.71589000",
                        "longitude": "10.74797000"
                    },
                    {
                        "id": 59043,
                        "name": "Predappio",
                        "latitude": "44.10316000",
                        "longitude": "11.98413000"
                    },
                    {
                        "id": 59057,
                        "name": "Premilcuore",
                        "latitude": "43.98084000",
                        "longitude": "11.78193000"
                    },
                    {
                        "id": 59075,
                        "name": "Prignano",
                        "latitude": "44.43790000",
                        "longitude": "10.69118000"
                    },
                    {
                        "id": 59077,
                        "name": "Prignano sulla Secchia",
                        "latitude": "44.43836000",
                        "longitude": "10.69190000"
                    },
                    {
                        "id": 59090,
                        "name": "Progresso",
                        "latitude": "44.56892000",
                        "longitude": "11.36420000"
                    },
                    {
                        "id": 59130,
                        "name": "Provincia di Ferrara",
                        "latitude": "44.80000000",
                        "longitude": "11.83333000"
                    },
                    {
                        "id": 59132,
                        "name": "Provincia di Forlì-Cesena",
                        "latitude": "44.08333000",
                        "longitude": "12.03333000"
                    },
                    {
                        "id": 59150,
                        "name": "Provincia di Modena",
                        "latitude": "44.50000000",
                        "longitude": "10.90000000"
                    },
                    {
                        "id": 59156,
                        "name": "Provincia di Parma",
                        "latitude": "44.70000000",
                        "longitude": "10.08333000"
                    },
                    {
                        "id": 59161,
                        "name": "Provincia di Piacenza",
                        "latitude": "44.88333000",
                        "longitude": "9.58333000"
                    },
                    {
                        "id": 59166,
                        "name": "Provincia di Ravenna",
                        "latitude": "44.41667000",
                        "longitude": "11.98333000"
                    },
                    {
                        "id": 59168,
                        "name": "Provincia di Reggio Emilia",
                        "latitude": "44.61667000",
                        "longitude": "10.61667000"
                    },
                    {
                        "id": 59170,
                        "name": "Provincia di Rimini",
                        "latitude": "44.02405000",
                        "longitude": "12.51858000"
                    },
                    {
                        "id": 59199,
                        "name": "Puianello",
                        "latitude": "44.62630000",
                        "longitude": "10.56420000"
                    },
                    {
                        "id": 59201,
                        "name": "Pulce",
                        "latitude": "44.44909000",
                        "longitude": "11.41153000"
                    },
                    {
                        "id": 59205,
                        "name": "Punta Marina",
                        "latitude": "44.44272000",
                        "longitude": "12.29089000"
                    },
                    {
                        "id": 59217,
                        "name": "Quarantoli",
                        "latitude": "44.91954000",
                        "longitude": "11.10324000"
                    },
                    {
                        "id": 59226,
                        "name": "Quartesana",
                        "latitude": "44.80490000",
                        "longitude": "11.73873000"
                    },
                    {
                        "id": 59229,
                        "name": "Quarto Inferiore",
                        "latitude": "44.53090000",
                        "longitude": "11.41679000"
                    },
                    {
                        "id": 59236,
                        "name": "Quattro Castella",
                        "latitude": "44.63496000",
                        "longitude": "10.47429000"
                    },
                    {
                        "id": 59273,
                        "name": "Ramiola",
                        "latitude": "44.70055000",
                        "longitude": "10.09110000"
                    },
                    {
                        "id": 59274,
                        "name": "Ramiseto",
                        "latitude": "44.41284000",
                        "longitude": "10.27689000"
                    },
                    {
                        "id": 59291,
                        "name": "Rastignano-Carteria di Sesto",
                        "latitude": "44.43623000",
                        "longitude": "11.35695000"
                    },
                    {
                        "id": 59296,
                        "name": "Ravarino",
                        "latitude": "44.72475000",
                        "longitude": "11.09588000"
                    },
                    {
                        "id": 59321,
                        "name": "Reggio nell'Emilia",
                        "latitude": "44.69825000",
                        "longitude": "10.63125000"
                    },
                    {
                        "id": 59322,
                        "name": "Reggiolo",
                        "latitude": "44.91824000",
                        "longitude": "10.81016000"
                    },
                    {
                        "id": 59331,
                        "name": "Renazzo",
                        "latitude": "44.76527000",
                        "longitude": "11.28605000"
                    },
                    {
                        "id": 59355,
                        "name": "Riale",
                        "latitude": "44.48333000",
                        "longitude": "11.23333000"
                    },
                    {
                        "id": 59366,
                        "name": "Riccione",
                        "latitude": "43.99942000",
                        "longitude": "12.65689000"
                    },
                    {
                        "id": 59367,
                        "name": "Riccò",
                        "latitude": "44.70050000",
                        "longitude": "10.12095000"
                    },
                    {
                        "id": 59385,
                        "name": "Rimini",
                        "latitude": "44.05755000",
                        "longitude": "12.56528000"
                    },
                    {
                        "id": 59387,
                        "name": "Rio Saliceto",
                        "latitude": "44.81147000",
                        "longitude": "10.80414000"
                    },
                    {
                        "id": 59394,
                        "name": "Riolunato",
                        "latitude": "44.23102000",
                        "longitude": "10.65310000"
                    },
                    {
                        "id": 59433,
                        "name": "Rivazzurra",
                        "latitude": "44.04186000",
                        "longitude": "12.60894000"
                    },
                    {
                        "id": 59437,
                        "name": "Rivergaro",
                        "latitude": "44.91500000",
                        "longitude": "9.60443000"
                    },
                    {
                        "id": 59446,
                        "name": "Ro",
                        "latitude": "44.94695000",
                        "longitude": "11.76006000"
                    },
                    {
                        "id": 59476,
                        "name": "Rocca San Casciano",
                        "latitude": "44.05871000",
                        "longitude": "11.84274000"
                    },
                    {
                        "id": 59492,
                        "name": "Roccabianca",
                        "latitude": "45.00772000",
                        "longitude": "10.21824000"
                    },
                    {
                        "id": 59569,
                        "name": "Rolo",
                        "latitude": "44.88482000",
                        "longitude": "10.85961000"
                    },
                    {
                        "id": 59607,
                        "name": "Roncocesi",
                        "latitude": "44.73843000",
                        "longitude": "10.57816000"
                    },
                    {
                        "id": 59609,
                        "name": "Roncofreddo",
                        "latitude": "44.04222000",
                        "longitude": "12.30083000"
                    },
                    {
                        "id": 59610,
                        "name": "Roncofreddo-Santa Paola",
                        "latitude": "44.04251000",
                        "longitude": "12.31523000"
                    },
                    {
                        "id": 59656,
                        "name": "Roteglia",
                        "latitude": "44.48417000",
                        "longitude": "10.68832000"
                    },
                    {
                        "id": 59664,
                        "name": "Rottofreno",
                        "latitude": "45.05527000",
                        "longitude": "9.55007000"
                    },
                    {
                        "id": 59671,
                        "name": "Roveleto",
                        "latitude": "44.96332000",
                        "longitude": "9.85390000"
                    },
                    {
                        "id": 59678,
                        "name": "Rovereto",
                        "latitude": "44.83381000",
                        "longitude": "10.95157000"
                    },
                    {
                        "id": 59692,
                        "name": "Rubiera",
                        "latitude": "44.65158000",
                        "longitude": "10.77940000"
                    },
                    {
                        "id": 59737,
                        "name": "Sala",
                        "latitude": "44.15638000",
                        "longitude": "12.38340000"
                    },
                    {
                        "id": 59739,
                        "name": "Sala Baganza",
                        "latitude": "44.71563000",
                        "longitude": "10.22622000"
                    },
                    {
                        "id": 59741,
                        "name": "Sala Bolognese",
                        "latitude": "44.61387000",
                        "longitude": "11.25669000"
                    },
                    {
                        "id": 59780,
                        "name": "Salsomaggiore Terme",
                        "latitude": "44.81592000",
                        "longitude": "9.98637000"
                    },
                    {
                        "id": 59783,
                        "name": "Saludecio",
                        "latitude": "43.87540000",
                        "longitude": "12.66118000"
                    },
                    {
                        "id": 59787,
                        "name": "Salvaterra",
                        "latitude": "44.59925000",
                        "longitude": "10.76860000"
                    },
                    {
                        "id": 59797,
                        "name": "Sam Marino",
                        "latitude": "44.80738000",
                        "longitude": "10.91438000"
                    },
                    {
                        "id": 59818,
                        "name": "San Bartolomeo",
                        "latitude": "44.67402000",
                        "longitude": "10.53941000"
                    },
                    {
                        "id": 59819,
                        "name": "San Bartolomeo In Bosco",
                        "latitude": "44.73094000",
                        "longitude": "11.63573000"
                    },
                    {
                        "id": 59830,
                        "name": "San Benedetto Val di Sambro",
                        "latitude": "44.21405000",
                        "longitude": "11.23567000"
                    },
                    {
                        "id": 59837,
                        "name": "San Biagio",
                        "latitude": "44.58695000",
                        "longitude": "11.86918000"
                    },
                    {
                        "id": 59853,
                        "name": "San Carlo",
                        "latitude": "44.80361000",
                        "longitude": "11.40999000"
                    },
                    {
                        "id": 59865,
                        "name": "San Cesario sul Panaro",
                        "latitude": "44.56352000",
                        "longitude": "11.03508000"
                    },
                    {
                        "id": 59874,
                        "name": "San Clemente",
                        "latitude": "43.93269000",
                        "longitude": "12.62707000"
                    },
                    {
                        "id": 59884,
                        "name": "San Damaso",
                        "latitude": "44.60102000",
                        "longitude": "10.97373000"
                    },
                    {
                        "id": 59912,
                        "name": "San Felice sul Panaro",
                        "latitude": "44.83671000",
                        "longitude": "11.13791000"
                    },
                    {
                        "id": 59929,
                        "name": "San Gabriele-Mondonuovo",
                        "latitude": "44.66667000",
                        "longitude": "11.58333000"
                    },
                    {
                        "id": 59973,
                        "name": "San Giorgio di Piano",
                        "latitude": "44.64724000",
                        "longitude": "11.37446000"
                    },
                    {
                        "id": 59960,
                        "name": "San Giorgio Piacentino",
                        "latitude": "44.95198000",
                        "longitude": "9.73773000"
                    },
                    {
                        "id": 59999,
                        "name": "San Giovanni in Marignano",
                        "latitude": "43.93989000",
                        "longitude": "12.71166000"
                    },
                    {
                        "id": 60000,
                        "name": "San Giovanni in Persiceto",
                        "latitude": "44.63838000",
                        "longitude": "11.18419000"
                    },
                    {
                        "id": 60003,
                        "name": "San Giovanni-San Bernardino",
                        "latitude": "44.79297000",
                        "longitude": "9.60871000"
                    },
                    {
                        "id": 60009,
                        "name": "San Giuseppe",
                        "latitude": "44.72202000",
                        "longitude": "12.21712000"
                    },
                    {
                        "id": 60027,
                        "name": "San Lazzaro",
                        "latitude": "44.47050000",
                        "longitude": "11.40851000"
                    },
                    {
                        "id": 60028,
                        "name": "San Leo",
                        "latitude": "43.89637000",
                        "longitude": "12.34460000"
                    },
                    {
                        "id": 60068,
                        "name": "San Martino",
                        "latitude": "44.77794000",
                        "longitude": "11.58751000"
                    },
                    {
                        "id": 60082,
                        "name": "San Martino dei Mulini",
                        "latitude": "44.03182000",
                        "longitude": "12.46396000"
                    },
                    {
                        "id": 60088,
                        "name": "San Martino in Argine",
                        "latitude": "44.58876000",
                        "longitude": "11.60650000"
                    },
                    {
                        "id": 60094,
                        "name": "San Martino in Rio",
                        "latitude": "44.73368000",
                        "longitude": "10.78490000"
                    },
                    {
                        "id": 60111,
                        "name": "San Mauro a Mare",
                        "latitude": "44.16367000",
                        "longitude": "12.44631000"
                    },
                    {
                        "id": 60109,
                        "name": "San Mauro Pascoli",
                        "latitude": "44.10890000",
                        "longitude": "12.41953000"
                    },
                    {
                        "id": 60122,
                        "name": "San Michele dei Mucchietti",
                        "latitude": "44.50847000",
                        "longitude": "10.74726000"
                    },
                    {
                        "id": 60120,
                        "name": "San Michele Tiorre",
                        "latitude": "44.68530000",
                        "longitude": "10.26317000"
                    },
                    {
                        "id": 60146,
                        "name": "San Nicolò",
                        "latitude": "45.05685000",
                        "longitude": "9.60540000"
                    },
                    {
                        "id": 60150,
                        "name": "San Pancrazio",
                        "latitude": "44.35810000",
                        "longitude": "12.07852000"
                    },
                    {
                        "id": 60169,
                        "name": "San Piero in Bagno",
                        "latitude": "43.85793000",
                        "longitude": "11.97716000"
                    },
                    {
                        "id": 60176,
                        "name": "San Pietro Capofiume",
                        "latitude": "44.65040000",
                        "longitude": "11.64802000"
                    },
                    {
                        "id": 60197,
                        "name": "San Pietro in Casale",
                        "latitude": "44.70079000",
                        "longitude": "11.40492000"
                    },
                    {
                        "id": 60198,
                        "name": "San Pietro in Cerro",
                        "latitude": "45.02137000",
                        "longitude": "9.94987000"
                    },
                    {
                        "id": 60178,
                        "name": "San Pietro In Vincoli",
                        "latitude": "44.30051000",
                        "longitude": "12.14556000"
                    },
                    {
                        "id": 60204,
                        "name": "San Polo",
                        "latitude": "44.97868000",
                        "longitude": "9.74070000"
                    },
                    {
                        "id": 60205,
                        "name": "San Polo d'Enza",
                        "latitude": "44.62690000",
                        "longitude": "10.42667000"
                    },
                    {
                        "id": 60210,
                        "name": "San Possidonio",
                        "latitude": "44.87402000",
                        "longitude": "10.98087000"
                    },
                    {
                        "id": 60215,
                        "name": "San Prospero",
                        "latitude": "44.78967000",
                        "longitude": "11.02210000"
                    },
                    {
                        "id": 60240,
                        "name": "San Secondo Parmense",
                        "latitude": "44.92218000",
                        "longitude": "10.23038000"
                    },
                    {
                        "id": 60260,
                        "name": "San Venanzio",
                        "latitude": "44.74517000",
                        "longitude": "11.43727000"
                    },
                    {
                        "id": 60268,
                        "name": "San Vincenzo",
                        "latitude": "44.73878000",
                        "longitude": "11.43668000"
                    },
                    {
                        "id": 60274,
                        "name": "San Vito",
                        "latitude": "44.55822000",
                        "longitude": "10.97432000"
                    },
                    {
                        "id": 60315,
                        "name": "Sant'Agata Bolognese",
                        "latitude": "44.66016000",
                        "longitude": "11.13292000"
                    },
                    {
                        "id": 60316,
                        "name": "Sant'Agata Feltria",
                        "latitude": "43.86282000",
                        "longitude": "12.20690000"
                    },
                    {
                        "id": 60328,
                        "name": "Sant'Agostino",
                        "latitude": "44.79218000",
                        "longitude": "11.38522000"
                    },
                    {
                        "id": 60330,
                        "name": "Sant'Alberto",
                        "latitude": "44.53822000",
                        "longitude": "12.16191000"
                    },
                    {
                        "id": 60342,
                        "name": "Sant'Andrea",
                        "latitude": "44.03328000",
                        "longitude": "12.41893000"
                    },
                    {
                        "id": 60349,
                        "name": "Sant'Andrea in Casale",
                        "latitude": "43.93333000",
                        "longitude": "12.65000000"
                    },
                    {
                        "id": 60382,
                        "name": "Sant'Antonio",
                        "latitude": "44.36586000",
                        "longitude": "10.83646000"
                    },
                    {
                        "id": 60404,
                        "name": "Sant'Ilario d'Enza",
                        "latitude": "44.75890000",
                        "longitude": "10.44737000"
                    },
                    {
                        "id": 60427,
                        "name": "Santa Croce Scuole",
                        "latitude": "44.76281000",
                        "longitude": "10.84944000"
                    },
                    {
                        "id": 60441,
                        "name": "Santa Giustina",
                        "latitude": "44.06778000",
                        "longitude": "12.48500000"
                    },
                    {
                        "id": 60460,
                        "name": "Santa Maria Codifiume",
                        "latitude": "44.66424000",
                        "longitude": "11.65099000"
                    },
                    {
                        "id": 60468,
                        "name": "Santa Maria Nuova",
                        "latitude": "44.20000000",
                        "longitude": "12.19389000"
                    },
                    {
                        "id": 60486,
                        "name": "Santa Monica-Cella",
                        "latitude": "43.95765000",
                        "longitude": "12.68846000"
                    },
                    {
                        "id": 60491,
                        "name": "Santa Sofia",
                        "latitude": "43.94724000",
                        "longitude": "11.90867000"
                    },
                    {
                        "id": 60499,
                        "name": "Santa Vittoria",
                        "latitude": "44.85483000",
                        "longitude": "10.63348000"
                    },
                    {
                        "id": 60503,
                        "name": "Santarcangelo",
                        "latitude": "44.06326000",
                        "longitude": "12.44657000"
                    },
                    {
                        "id": 60507,
                        "name": "Santerno",
                        "latitude": "44.43697000",
                        "longitude": "12.05533000"
                    },
                    {
                        "id": 60527,
                        "name": "Santo Stefano-Carraie",
                        "latitude": "44.31525000",
                        "longitude": "12.18573000"
                    },
                    {
                        "id": 60549,
                        "name": "Sarmato",
                        "latitude": "45.05679000",
                        "longitude": "9.49683000"
                    },
                    {
                        "id": 60558,
                        "name": "Sarsina",
                        "latitude": "43.91981000",
                        "longitude": "12.14255000"
                    },
                    {
                        "id": 60572,
                        "name": "Sasso Marconi",
                        "latitude": "44.40064000",
                        "longitude": "11.25177000"
                    },
                    {
                        "id": 60577,
                        "name": "Sassuolo",
                        "latitude": "44.54320000",
                        "longitude": "10.78480000"
                    },
                    {
                        "id": 60584,
                        "name": "Savarna-Conventello",
                        "latitude": "44.50717000",
                        "longitude": "12.10621000"
                    },
                    {
                        "id": 60589,
                        "name": "Savignano sul Panaro",
                        "latitude": "44.48036000",
                        "longitude": "11.03510000"
                    },
                    {
                        "id": 60590,
                        "name": "Savignano sul Rubicone",
                        "latitude": "44.09009000",
                        "longitude": "12.39935000"
                    },
                    {
                        "id": 60591,
                        "name": "Savigno",
                        "latitude": "44.39186000",
                        "longitude": "11.07481000"
                    },
                    {
                        "id": 60593,
                        "name": "Savio",
                        "latitude": "44.31139000",
                        "longitude": "12.29472000"
                    },
                    {
                        "id": 60616,
                        "name": "Scandiano",
                        "latitude": "44.59830000",
                        "longitude": "10.69558000"
                    },
                    {
                        "id": 60668,
                        "name": "Scortichino",
                        "latitude": "44.88333000",
                        "longitude": "11.33333000"
                    },
                    {
                        "id": 60675,
                        "name": "Secchiano",
                        "latitude": "43.92399000",
                        "longitude": "12.31615000"
                    },
                    {
                        "id": 60757,
                        "name": "Serra di Maiolo",
                        "latitude": "43.87304000",
                        "longitude": "12.31129000"
                    },
                    {
                        "id": 60763,
                        "name": "Serramazzoni",
                        "latitude": "44.42735000",
                        "longitude": "10.79055000"
                    },
                    {
                        "id": 60771,
                        "name": "Serravalle",
                        "latitude": "44.96532000",
                        "longitude": "12.04664000"
                    },
                    {
                        "id": 60798,
                        "name": "Sesto Imolese",
                        "latitude": "44.45952000",
                        "longitude": "11.72919000"
                    },
                    {
                        "id": 60802,
                        "name": "Sestola",
                        "latitude": "44.22994000",
                        "longitude": "10.77349000"
                    },
                    {
                        "id": 60880,
                        "name": "Sissa",
                        "latitude": "44.95927000",
                        "longitude": "10.26058000"
                    },
                    {
                        "id": 60897,
                        "name": "Sogliano al Rubicone",
                        "latitude": "44.00500000",
                        "longitude": "12.30122000"
                    },
                    {
                        "id": 60902,
                        "name": "Solara",
                        "latitude": "44.77163000",
                        "longitude": "11.09287000"
                    },
                    {
                        "id": 60918,
                        "name": "Soliera",
                        "latitude": "44.73387000",
                        "longitude": "10.92177000"
                    },
                    {
                        "id": 60919,
                        "name": "Solignano",
                        "latitude": "44.61306000",
                        "longitude": "9.97548000"
                    },
                    {
                        "id": 60920,
                        "name": "Solignano Nuovo",
                        "latitude": "44.52746000",
                        "longitude": "10.92626000"
                    },
                    {
                        "id": 60946,
                        "name": "Soragna",
                        "latitude": "44.92686000",
                        "longitude": "10.12013000"
                    },
                    {
                        "id": 60948,
                        "name": "Sorbara",
                        "latitude": "44.74808000",
                        "longitude": "11.00731000"
                    },
                    {
                        "id": 60951,
                        "name": "Sorbolo",
                        "latitude": "44.84587000",
                        "longitude": "10.44375000"
                    },
                    {
                        "id": 61010,
                        "name": "Spilamberto",
                        "latitude": "44.53273000",
                        "longitude": "11.01697000"
                    },
                    {
                        "id": 61054,
                        "name": "Stazione Valmozzola",
                        "latitude": "44.57879000",
                        "longitude": "9.94290000"
                    },
                    {
                        "id": 61151,
                        "name": "Talamello",
                        "latitude": "43.90566000",
                        "longitude": "12.28484000"
                    },
                    {
                        "id": 61160,
                        "name": "Taneto",
                        "latitude": "44.77202000",
                        "longitude": "10.45563000"
                    },
                    {
                        "id": 61221,
                        "name": "Terenzo",
                        "latitude": "44.61048000",
                        "longitude": "10.08956000"
                    },
                    {
                        "id": 61290,
                        "name": "Tizzano Val Parma",
                        "latitude": "44.51931000",
                        "longitude": "10.19819000"
                    },
                    {
                        "id": 61291,
                        "name": "Toano",
                        "latitude": "44.37601000",
                        "longitude": "10.56311000"
                    },
                    {
                        "id": 61338,
                        "name": "Tornolo",
                        "latitude": "44.48524000",
                        "longitude": "9.62744000"
                    },
                    {
                        "id": 61397,
                        "name": "Torriana",
                        "latitude": "43.98485000",
                        "longitude": "12.38541000"
                    },
                    {
                        "id": 61406,
                        "name": "Torrile",
                        "latitude": "44.92522000",
                        "longitude": "10.32381000"
                    },
                    {
                        "id": 61422,
                        "name": "Toscanella",
                        "latitude": "44.38248000",
                        "longitude": "11.63965000"
                    },
                    {
                        "id": 61443,
                        "name": "Trarivi",
                        "latitude": "43.93672000",
                        "longitude": "12.54400000"
                    },
                    {
                        "id": 61453,
                        "name": "Traversetolo",
                        "latitude": "44.64244000",
                        "longitude": "10.38036000"
                    },
                    {
                        "id": 61456,
                        "name": "Travo",
                        "latitude": "44.86321000",
                        "longitude": "9.54430000"
                    },
                    {
                        "id": 61461,
                        "name": "Trebbo",
                        "latitude": "44.55629000",
                        "longitude": "11.31901000"
                    },
                    {
                        "id": 61463,
                        "name": "Trecasali",
                        "latitude": "44.93747000",
                        "longitude": "10.27279000"
                    },
                    {
                        "id": 61470,
                        "name": "Tredozio",
                        "latitude": "44.07958000",
                        "longitude": "11.74140000"
                    },
                    {
                        "id": 61496,
                        "name": "Tresigallo-Final di Rero",
                        "latitude": "44.81598000",
                        "longitude": "11.89472000"
                    },
                    {
                        "id": 61629,
                        "name": "Vado",
                        "latitude": "44.31689000",
                        "longitude": "11.25851000"
                    },
                    {
                        "id": 61762,
                        "name": "Varano De' Melegari",
                        "latitude": "44.68806000",
                        "longitude": "10.01148000"
                    },
                    {
                        "id": 61774,
                        "name": "Varsi",
                        "latitude": "44.66274000",
                        "longitude": "9.84879000"
                    },
                    {
                        "id": 61794,
                        "name": "Veggia-Villalunga",
                        "latitude": "44.56070000",
                        "longitude": "10.75621000"
                    },
                    {
                        "id": 61820,
                        "name": "Venezzano",
                        "latitude": "44.68333000",
                        "longitude": "11.33333000"
                    },
                    {
                        "id": 61827,
                        "name": "Ventoso",
                        "latitude": "44.58621000",
                        "longitude": "10.68767000"
                    },
                    {
                        "id": 61846,
                        "name": "Vergato",
                        "latitude": "44.28232000",
                        "longitude": "11.10953000"
                    },
                    {
                        "id": 61847,
                        "name": "Verghereto",
                        "latitude": "43.79450000",
                        "longitude": "12.00520000"
                    },
                    {
                        "id": 61854,
                        "name": "Vernasca",
                        "latitude": "44.79867000",
                        "longitude": "9.83054000"
                    },
                    {
                        "id": 61873,
                        "name": "Verucchio",
                        "latitude": "43.98171000",
                        "longitude": "12.42317000"
                    },
                    {
                        "id": 61891,
                        "name": "Vetto",
                        "latitude": "44.48407000",
                        "longitude": "10.33882000"
                    },
                    {
                        "id": 61896,
                        "name": "Vezzano sul Crostolo",
                        "latitude": "44.60241000",
                        "longitude": "10.54469000"
                    },
                    {
                        "id": 61904,
                        "name": "Viano",
                        "latitude": "44.54516000",
                        "longitude": "10.62435000"
                    },
                    {
                        "id": 61920,
                        "name": "Vicofertile",
                        "latitude": "44.78557000",
                        "longitude": "10.26200000"
                    },
                    {
                        "id": 61939,
                        "name": "Vigarano Mainarda",
                        "latitude": "44.84079000",
                        "longitude": "11.49354000"
                    },
                    {
                        "id": 61940,
                        "name": "Vigarano Pieve",
                        "latitude": "44.86126000",
                        "longitude": "11.50950000"
                    },
                    {
                        "id": 61943,
                        "name": "Vigatto",
                        "latitude": "44.71999000",
                        "longitude": "10.33037000"
                    },
                    {
                        "id": 61961,
                        "name": "Vignola",
                        "latitude": "44.48383000",
                        "longitude": "11.01096000"
                    },
                    {
                        "id": 61973,
                        "name": "Vigolzone",
                        "latitude": "44.91394000",
                        "longitude": "9.66852000"
                    },
                    {
                        "id": 61998,
                        "name": "Villa Fontana",
                        "latitude": "44.49455000",
                        "longitude": "11.60885000"
                    },
                    {
                        "id": 62005,
                        "name": "Villa Minozzo",
                        "latitude": "44.36480000",
                        "longitude": "10.46545000"
                    },
                    {
                        "id": 62030,
                        "name": "Villa Verucchio",
                        "latitude": "44.00510000",
                        "longitude": "12.43575000"
                    },
                    {
                        "id": 62089,
                        "name": "Villanova",
                        "latitude": "45.02597000",
                        "longitude": "9.99865000"
                    },
                    {
                        "id": 62132,
                        "name": "Villarotta",
                        "latitude": "44.92517000",
                        "longitude": "10.74382000"
                    },
                    {
                        "id": 62202,
                        "name": "Voghiera",
                        "latitude": "44.75558000",
                        "longitude": "11.75182000"
                    },
                    {
                        "id": 62217,
                        "name": "Voltana",
                        "latitude": "44.54109000",
                        "longitude": "11.93533000"
                    },
                    {
                        "id": 62249,
                        "name": "Zerba",
                        "latitude": "44.66551000",
                        "longitude": "9.28795000"
                    },
                    {
                        "id": 62257,
                        "name": "Ziano Piacentino",
                        "latitude": "44.99980000",
                        "longitude": "9.39486000"
                    },
                    {
                        "id": 62259,
                        "name": "Zibello",
                        "latitude": "45.01847000",
                        "longitude": "10.12968000"
                    },
                    {
                        "id": 62264,
                        "name": "Zocca",
                        "latitude": "44.34566000",
                        "longitude": "10.99308000"
                    },
                    {
                        "id": 62267,
                        "name": "Zola Predosa",
                        "latitude": "44.48967000",
                        "longitude": "11.21831000"
                    }
                ]
            },
            {
                "id": 1723,
                "name": "Enna",
                "iso2": "EN",
                "latitude": "37.56762160",
                "longitude": "14.27953490",
                "type": "free municipal consortium",
                "cities": []
            },
            {
                "id": 1744,
                "name": "Fermo",
                "iso2": "FM",
                "latitude": "43.09313670",
                "longitude": "13.58997330",
                "type": "province",
                "cities": []
            },
            {
                "id": 1746,
                "name": "Ferrara",
                "iso2": "FE",
                "latitude": "44.76636800",
                "longitude": "11.76440680",
                "type": "province",
                "cities": []
            },
            {
                "id": 1771,
                "name": "Foggia",
                "iso2": "FG",
                "latitude": "41.63844800",
                "longitude": "15.59433880",
                "type": "province",
                "cities": []
            },
            {
                "id": 1779,
                "name": "Forlì-Cesena",
                "iso2": "FC",
                "latitude": "43.99476810",
                "longitude": "11.98046130",
                "type": "province",
                "cities": []
            },
            {
                "id": 1756,
                "name": "Friuli–Venezia Giulia",
                "iso2": "36",
                "latitude": "46.22591770",
                "longitude": "13.10336460",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 135327,
                        "name": "Aiello del Friuli",
                        "latitude": "45.87276000",
                        "longitude": "13.36038000"
                    },
                    {
                        "id": 135459,
                        "name": "Amaro",
                        "latitude": "46.37367000",
                        "longitude": "13.09368000"
                    },
                    {
                        "id": 135474,
                        "name": "Ampezzo",
                        "latitude": "46.41459000",
                        "longitude": "12.79634000"
                    },
                    {
                        "id": 135488,
                        "name": "Andreis",
                        "latitude": "46.20146000",
                        "longitude": "12.61448000"
                    },
                    {
                        "id": 135493,
                        "name": "Anduins",
                        "latitude": "46.23311000",
                        "longitude": "12.95829000"
                    },
                    {
                        "id": 135545,
                        "name": "Aquileia",
                        "latitude": "45.76830000",
                        "longitude": "13.36779000"
                    },
                    {
                        "id": 135552,
                        "name": "Arba",
                        "latitude": "46.14611000",
                        "longitude": "12.79009000"
                    },
                    {
                        "id": 135641,
                        "name": "Arta Terme",
                        "latitude": "46.48021000",
                        "longitude": "13.02040000"
                    },
                    {
                        "id": 135642,
                        "name": "Artegna",
                        "latitude": "46.23929000",
                        "longitude": "13.15399000"
                    },
                    {
                        "id": 135650,
                        "name": "Arzene",
                        "latitude": "45.99965000",
                        "longitude": "12.85034000"
                    },
                    {
                        "id": 135682,
                        "name": "Attimis",
                        "latitude": "46.19022000",
                        "longitude": "13.31127000"
                    },
                    {
                        "id": 135691,
                        "name": "Aurisina",
                        "latitude": "45.74968000",
                        "longitude": "13.67345000"
                    },
                    {
                        "id": 135705,
                        "name": "Aviano",
                        "latitude": "46.07056000",
                        "longitude": "12.59472000"
                    },
                    {
                        "id": 135706,
                        "name": "Aviano-Castello",
                        "latitude": "46.06759000",
                        "longitude": "12.58324000"
                    },
                    {
                        "id": 135721,
                        "name": "Azzano Decimo",
                        "latitude": "45.90937000",
                        "longitude": "12.66420000"
                    },
                    {
                        "id": 135752,
                        "name": "Bagnaria Arsa",
                        "latitude": "45.88383000",
                        "longitude": "13.28562000"
                    },
                    {
                        "id": 135754,
                        "name": "Bagnarola",
                        "latitude": "45.86690000",
                        "longitude": "12.85886000"
                    },
                    {
                        "id": 135836,
                        "name": "Barcis",
                        "latitude": "46.19071000",
                        "longitude": "12.56068000"
                    },
                    {
                        "id": 135877,
                        "name": "Basaldella",
                        "latitude": "46.02527000",
                        "longitude": "13.21718000"
                    },
                    {
                        "id": 135887,
                        "name": "Basiliano",
                        "latitude": "46.01417000",
                        "longitude": "13.07000000"
                    },
                    {
                        "id": 135888,
                        "name": "Basiliano-Vissandone",
                        "latitude": "46.02278000",
                        "longitude": "13.09306000"
                    },
                    {
                        "id": 135923,
                        "name": "Begliano",
                        "latitude": "45.81984000",
                        "longitude": "13.46586000"
                    },
                    {
                        "id": 136001,
                        "name": "Bertiolo",
                        "latitude": "45.94463000",
                        "longitude": "13.05606000"
                    },
                    {
                        "id": 136044,
                        "name": "Bicinicco",
                        "latitude": "45.93211000",
                        "longitude": "13.25300000"
                    },
                    {
                        "id": 136147,
                        "name": "Bordano",
                        "latitude": "46.31528000",
                        "longitude": "13.10529000"
                    },
                    {
                        "id": 136316,
                        "name": "Bressa",
                        "latitude": "46.03446000",
                        "longitude": "13.14724000"
                    },
                    {
                        "id": 136365,
                        "name": "Brugnera",
                        "latitude": "45.89947000",
                        "longitude": "12.54178000"
                    },
                    {
                        "id": 136391,
                        "name": "Budoia",
                        "latitude": "46.04453000",
                        "longitude": "12.53429000"
                    },
                    {
                        "id": 136399,
                        "name": "Buia",
                        "latitude": "46.21222000",
                        "longitude": "13.11691000"
                    },
                    {
                        "id": 136441,
                        "name": "Buttrio",
                        "latitude": "46.01098000",
                        "longitude": "13.33354000"
                    },
                    {
                        "id": 136591,
                        "name": "Camino al Tagliamento",
                        "latitude": "45.92767000",
                        "longitude": "12.94489000"
                    },
                    {
                        "id": 136655,
                        "name": "Campoformido",
                        "latitude": "46.01952000",
                        "longitude": "13.15750000"
                    },
                    {
                        "id": 136664,
                        "name": "Campolongo al Torre",
                        "latitude": "45.86389000",
                        "longitude": "13.39667000"
                    },
                    {
                        "id": 136665,
                        "name": "Campolongo al Torre-Cavenzano",
                        "latitude": "45.86306000",
                        "longitude": "13.38944000"
                    },
                    {
                        "id": 136710,
                        "name": "Caneva",
                        "latitude": "45.97078000",
                        "longitude": "12.45261000"
                    },
                    {
                        "id": 136824,
                        "name": "Capriva del Friuli",
                        "latitude": "45.94093000",
                        "longitude": "13.51422000"
                    },
                    {
                        "id": 136887,
                        "name": "Carlino",
                        "latitude": "45.80321000",
                        "longitude": "13.18874000"
                    },
                    {
                        "id": 137034,
                        "name": "Casarsa della Delizia",
                        "latitude": "45.95091000",
                        "longitude": "12.84250000"
                    },
                    {
                        "id": 137093,
                        "name": "Cassacco",
                        "latitude": "46.17345000",
                        "longitude": "13.19236000"
                    },
                    {
                        "id": 137366,
                        "name": "Castions",
                        "latitude": "45.97218000",
                        "longitude": "12.79961000"
                    },
                    {
                        "id": 137367,
                        "name": "Castions di Strada",
                        "latitude": "45.91247000",
                        "longitude": "13.18167000"
                    },
                    {
                        "id": 137426,
                        "name": "Cavasso Nuovo",
                        "latitude": "46.19441000",
                        "longitude": "12.77193000"
                    },
                    {
                        "id": 137428,
                        "name": "Cavazzo Carnico",
                        "latitude": "46.36793000",
                        "longitude": "13.04075000"
                    },
                    {
                        "id": 137439,
                        "name": "Cavolano-Schiavoi",
                        "latitude": "45.93333000",
                        "longitude": "12.50000000"
                    },
                    {
                        "id": 137452,
                        "name": "Cecchini",
                        "latitude": "45.86551000",
                        "longitude": "12.62220000"
                    },
                    {
                        "id": 137527,
                        "name": "Cercivento",
                        "latitude": "46.52745000",
                        "longitude": "12.99219000"
                    },
                    {
                        "id": 137594,
                        "name": "Cervignano del Friuli",
                        "latitude": "45.82082000",
                        "longitude": "13.33929000"
                    },
                    {
                        "id": 137658,
                        "name": "Chiaulis",
                        "latitude": "46.38877000",
                        "longitude": "12.99155000"
                    },
                    {
                        "id": 137679,
                        "name": "Chions",
                        "latitude": "45.84546000",
                        "longitude": "12.71232000"
                    },
                    {
                        "id": 137680,
                        "name": "Chiopris",
                        "latitude": "45.92667000",
                        "longitude": "13.40417000"
                    },
                    {
                        "id": 137690,
                        "name": "Chiusaforte",
                        "latitude": "46.40663000",
                        "longitude": "13.30552000"
                    },
                    {
                        "id": 137727,
                        "name": "Cimolais",
                        "latitude": "46.28900000",
                        "longitude": "12.43792000"
                    },
                    {
                        "id": 137782,
                        "name": "Cividale del Friuli",
                        "latitude": "46.09019000",
                        "longitude": "13.42861000"
                    },
                    {
                        "id": 137807,
                        "name": "Claut",
                        "latitude": "46.26855000",
                        "longitude": "12.51440000"
                    },
                    {
                        "id": 137808,
                        "name": "Clauzetto",
                        "latitude": "46.22931000",
                        "longitude": "12.91662000"
                    },
                    {
                        "id": 137814,
                        "name": "Clodig",
                        "latitude": "46.15620000",
                        "longitude": "13.59399000"
                    },
                    {
                        "id": 137837,
                        "name": "Codroipo",
                        "latitude": "45.96469000",
                        "longitude": "12.97985000"
                    },
                    {
                        "id": 137906,
                        "name": "Colloredo di Monte Albano",
                        "latitude": "46.16472000",
                        "longitude": "13.13861000"
                    },
                    {
                        "id": 137907,
                        "name": "Colloredo di Monte Albano-Lauzzana",
                        "latitude": "46.15861000",
                        "longitude": "13.12278000"
                    },
                    {
                        "id": 137908,
                        "name": "Colloredo di Prato",
                        "latitude": "46.05124000",
                        "longitude": "13.14394000"
                    },
                    {
                        "id": 137930,
                        "name": "Colugna",
                        "latitude": "46.09100000",
                        "longitude": "13.20282000"
                    },
                    {
                        "id": 137938,
                        "name": "Comeglians",
                        "latitude": "46.51614000",
                        "longitude": "12.86619000"
                    },
                    {
                        "id": 138001,
                        "name": "Cordenons",
                        "latitude": "45.98360000",
                        "longitude": "12.70038000"
                    },
                    {
                        "id": 138003,
                        "name": "Cordovado",
                        "latitude": "45.84425000",
                        "longitude": "12.88537000"
                    },
                    {
                        "id": 138021,
                        "name": "Cormons",
                        "latitude": "45.95531000",
                        "longitude": "13.46683000"
                    },
                    {
                        "id": 138034,
                        "name": "Corno di Rosazzo",
                        "latitude": "45.99110000",
                        "longitude": "13.44368000"
                    },
                    {
                        "id": 138077,
                        "name": "Coseano",
                        "latitude": "46.09636000",
                        "longitude": "13.02028000"
                    },
                    {
                        "id": 138123,
                        "name": "Cras",
                        "latitude": "46.17403000",
                        "longitude": "13.62287000"
                    },
                    {
                        "id": 138266,
                        "name": "Dignano",
                        "latitude": "46.08392000",
                        "longitude": "12.94009000"
                    },
                    {
                        "id": 138274,
                        "name": "Doberdò del Lago",
                        "latitude": "45.84444000",
                        "longitude": "13.53908000"
                    },
                    {
                        "id": 138278,
                        "name": "Dogna",
                        "latitude": "46.44793000",
                        "longitude": "13.31502000"
                    },
                    {
                        "id": 138282,
                        "name": "Dolegna del Collio",
                        "latitude": "46.03094000",
                        "longitude": "13.47885000"
                    },
                    {
                        "id": 138284,
                        "name": "Dolina",
                        "latitude": "45.60080000",
                        "longitude": "13.85929000"
                    },
                    {
                        "id": 138291,
                        "name": "Domio",
                        "latitude": "45.61049000",
                        "longitude": "13.83103000"
                    },
                    {
                        "id": 138341,
                        "name": "Duino",
                        "latitude": "45.77342000",
                        "longitude": "13.60436000"
                    },
                    {
                        "id": 138359,
                        "name": "Enemonzo-Quinis",
                        "latitude": "46.40833000",
                        "longitude": "12.87944000"
                    },
                    {
                        "id": 138376,
                        "name": "Erto",
                        "latitude": "46.27640000",
                        "longitude": "12.37149000"
                    },
                    {
                        "id": 138399,
                        "name": "Faedis",
                        "latitude": "46.14931000",
                        "longitude": "13.34463000"
                    },
                    {
                        "id": 138405,
                        "name": "Fagagna",
                        "latitude": "46.10698000",
                        "longitude": "13.09361000"
                    },
                    {
                        "id": 138432,
                        "name": "Fanna",
                        "latitude": "46.18455000",
                        "longitude": "12.75161000"
                    },
                    {
                        "id": 138452,
                        "name": "Farra d'Isonzo",
                        "latitude": "45.90802000",
                        "longitude": "13.51654000"
                    },
                    {
                        "id": 138550,
                        "name": "Fiume Veneto",
                        "latitude": "45.92865000",
                        "longitude": "12.73811000"
                    },
                    {
                        "id": 138554,
                        "name": "Fiumicello",
                        "latitude": "45.79202000",
                        "longitude": "13.40964000"
                    },
                    {
                        "id": 138559,
                        "name": "Flaibano",
                        "latitude": "46.05837000",
                        "longitude": "12.98424000"
                    },
                    {
                        "id": 138574,
                        "name": "Fogliano",
                        "latitude": "45.86556000",
                        "longitude": "13.48222000"
                    },
                    {
                        "id": 138628,
                        "name": "Forgaria nel Friuli",
                        "latitude": "46.22036000",
                        "longitude": "12.97470000"
                    },
                    {
                        "id": 138653,
                        "name": "Forni Avoltri",
                        "latitude": "46.58615000",
                        "longitude": "12.77510000"
                    },
                    {
                        "id": 138654,
                        "name": "Forni di Sopra",
                        "latitude": "46.42028000",
                        "longitude": "12.58312000"
                    },
                    {
                        "id": 138655,
                        "name": "Forni di Sotto",
                        "latitude": "46.39379000",
                        "longitude": "12.67210000"
                    },
                    {
                        "id": 138737,
                        "name": "Frisanco",
                        "latitude": "46.21246000",
                        "longitude": "12.72626000"
                    },
                    {
                        "id": 138893,
                        "name": "Gemona",
                        "latitude": "46.27405000",
                        "longitude": "13.12237000"
                    },
                    {
                        "id": 139016,
                        "name": "Gonars",
                        "latitude": "45.89740000",
                        "longitude": "13.24402000"
                    },
                    {
                        "id": 139032,
                        "name": "Gorizia",
                        "latitude": "45.94088000",
                        "longitude": "13.62167000"
                    },
                    {
                        "id": 139050,
                        "name": "Gradisca d'Isonzo",
                        "latitude": "45.89250000",
                        "longitude": "13.50167000"
                    },
                    {
                        "id": 139051,
                        "name": "Grado",
                        "latitude": "45.67774000",
                        "longitude": "13.40323000"
                    },
                    {
                        "id": 139070,
                        "name": "Granvilla",
                        "latitude": "46.56755000",
                        "longitude": "12.68933000"
                    },
                    {
                        "id": 139188,
                        "name": "Ialmicco",
                        "latitude": "45.91333000",
                        "longitude": "13.34611000"
                    },
                    {
                        "id": 139236,
                        "name": "Isola",
                        "latitude": "46.25573000",
                        "longitude": "13.17906000"
                    },
                    {
                        "id": 139392,
                        "name": "Latisana",
                        "latitude": "45.76859000",
                        "longitude": "13.00618000"
                    },
                    {
                        "id": 139395,
                        "name": "Lauco",
                        "latitude": "46.42397000",
                        "longitude": "12.93222000"
                    },
                    {
                        "id": 139407,
                        "name": "Lauzacco",
                        "latitude": "45.98134000",
                        "longitude": "13.28024000"
                    },
                    {
                        "id": 139474,
                        "name": "Lestans",
                        "latitude": "46.15793000",
                        "longitude": "12.88872000"
                    },
                    {
                        "id": 139475,
                        "name": "Lestizza",
                        "latitude": "45.95656000",
                        "longitude": "13.14221000"
                    },
                    {
                        "id": 139511,
                        "name": "Lignano Sabbiadoro",
                        "latitude": "45.67590000",
                        "longitude": "13.11727000"
                    },
                    {
                        "id": 139513,
                        "name": "Ligosullo",
                        "latitude": "46.54008000",
                        "longitude": "13.07547000"
                    },
                    {
                        "id": 139674,
                        "name": "Lusevera",
                        "latitude": "46.27529000",
                        "longitude": "13.26922000"
                    },
                    {
                        "id": 139738,
                        "name": "Magnano in Riviera",
                        "latitude": "46.22369000",
                        "longitude": "13.19483000"
                    },
                    {
                        "id": 139753,
                        "name": "Majano",
                        "latitude": "46.18752000",
                        "longitude": "13.06162000"
                    },
                    {
                        "id": 139757,
                        "name": "Malborghetto",
                        "latitude": "46.50679000",
                        "longitude": "13.43946000"
                    },
                    {
                        "id": 139800,
                        "name": "Maniago",
                        "latitude": "46.16644000",
                        "longitude": "12.70602000"
                    },
                    {
                        "id": 139812,
                        "name": "Manzano",
                        "latitude": "45.98843000",
                        "longitude": "13.37674000"
                    },
                    {
                        "id": 139822,
                        "name": "Marano Lagunare",
                        "latitude": "45.76353000",
                        "longitude": "13.16733000"
                    },
                    {
                        "id": 139868,
                        "name": "Mariano del Friuli",
                        "latitude": "45.91509000",
                        "longitude": "13.45947000"
                    },
                    {
                        "id": 139924,
                        "name": "Marsure",
                        "latitude": "46.09403000",
                        "longitude": "12.59528000"
                    },
                    {
                        "id": 139930,
                        "name": "Martignacco",
                        "latitude": "46.09313000",
                        "longitude": "13.13973000"
                    },
                    {
                        "id": 140018,
                        "name": "Medea",
                        "latitude": "45.91751000",
                        "longitude": "13.42444000"
                    },
                    {
                        "id": 140022,
                        "name": "Mediis",
                        "latitude": "46.40336000",
                        "longitude": "12.82341000"
                    },
                    {
                        "id": 140027,
                        "name": "Meduno",
                        "latitude": "46.21518000",
                        "longitude": "12.79932000"
                    },
                    {
                        "id": 140082,
                        "name": "Mereto di Tomba",
                        "latitude": "46.05128000",
                        "longitude": "13.04432000"
                    },
                    {
                        "id": 140089,
                        "name": "Merso di Sopra",
                        "latitude": "46.12389000",
                        "longitude": "13.52806000"
                    },
                    {
                        "id": 140196,
                        "name": "Moggio di Sotto",
                        "latitude": "46.40651000",
                        "longitude": "13.19507000"
                    },
                    {
                        "id": 140195,
                        "name": "Moggio Udinese",
                        "latitude": "46.41083000",
                        "longitude": "13.20139000"
                    },
                    {
                        "id": 140204,
                        "name": "Moimacco",
                        "latitude": "46.09145000",
                        "longitude": "13.37270000"
                    },
                    {
                        "id": 140279,
                        "name": "Monfalcone",
                        "latitude": "45.80463000",
                        "longitude": "13.53292000"
                    },
                    {
                        "id": 140500,
                        "name": "Montenars",
                        "latitude": "46.25111000",
                        "longitude": "13.16944000"
                    },
                    {
                        "id": 140515,
                        "name": "Montereale Valcellina",
                        "latitude": "46.15110000",
                        "longitude": "12.64771000"
                    },
                    {
                        "id": 140600,
                        "name": "Moraro",
                        "latitude": "45.92971000",
                        "longitude": "13.49575000"
                    },
                    {
                        "id": 140637,
                        "name": "Morsano",
                        "latitude": "45.85969000",
                        "longitude": "12.92769000"
                    },
                    {
                        "id": 140640,
                        "name": "Mortegliano",
                        "latitude": "45.94553000",
                        "longitude": "13.17255000"
                    },
                    {
                        "id": 140642,
                        "name": "Moruzzo",
                        "latitude": "46.11967000",
                        "longitude": "13.12400000"
                    },
                    {
                        "id": 140651,
                        "name": "Mossa",
                        "latitude": "45.93674000",
                        "longitude": "13.54933000"
                    },
                    {
                        "id": 140677,
                        "name": "Muggia",
                        "latitude": "45.60419000",
                        "longitude": "13.76754000"
                    },
                    {
                        "id": 140707,
                        "name": "Muzzana del Turgnano",
                        "latitude": "45.81799000",
                        "longitude": "13.12751000"
                    },
                    {
                        "id": 140770,
                        "name": "Nimis",
                        "latitude": "46.20659000",
                        "longitude": "13.26777000"
                    },
                    {
                        "id": 140942,
                        "name": "Orcenico Inferiore",
                        "latitude": "45.94977000",
                        "longitude": "12.76452000"
                    },
                    {
                        "id": 140973,
                        "name": "Orsaria",
                        "latitude": "46.03862000",
                        "longitude": "13.38247000"
                    },
                    {
                        "id": 141013,
                        "name": "Osoppo",
                        "latitude": "46.25536000",
                        "longitude": "13.08453000"
                    },
                    {
                        "id": 141056,
                        "name": "Ovaro",
                        "latitude": "46.48409000",
                        "longitude": "12.86704000"
                    },
                    {
                        "id": 58210,
                        "name": "Pagnacco",
                        "latitude": "46.11462000",
                        "longitude": "13.18377000"
                    },
                    {
                        "id": 58235,
                        "name": "Palazzolo dello Stella",
                        "latitude": "45.79823000",
                        "longitude": "13.08776000"
                    },
                    {
                        "id": 58255,
                        "name": "Palmanova",
                        "latitude": "45.90540000",
                        "longitude": "13.30998000"
                    },
                    {
                        "id": 58267,
                        "name": "Paludea",
                        "latitude": "46.19950000",
                        "longitude": "12.90344000"
                    },
                    {
                        "id": 58269,
                        "name": "Paluzza",
                        "latitude": "46.53202000",
                        "longitude": "13.01586000"
                    },
                    {
                        "id": 58322,
                        "name": "Pasian di Prato",
                        "latitude": "46.04667000",
                        "longitude": "13.18780000"
                    },
                    {
                        "id": 58323,
                        "name": "Pasiano",
                        "latitude": "45.84972000",
                        "longitude": "12.62722000"
                    },
                    {
                        "id": 58334,
                        "name": "Passons",
                        "latitude": "46.06889000",
                        "longitude": "13.18917000"
                    },
                    {
                        "id": 58353,
                        "name": "Paularo",
                        "latitude": "46.53101000",
                        "longitude": "13.11886000"
                    },
                    {
                        "id": 58360,
                        "name": "Pavia di Udine",
                        "latitude": "45.99502000",
                        "longitude": "13.30367000"
                    },
                    {
                        "id": 58415,
                        "name": "Percoto",
                        "latitude": "45.97471000",
                        "longitude": "13.32304000"
                    },
                    {
                        "id": 58440,
                        "name": "Pertegada",
                        "latitude": "45.72179000",
                        "longitude": "13.04379000"
                    },
                    {
                        "id": 58599,
                        "name": "Pieria-Prato Carnico",
                        "latitude": "46.52037000",
                        "longitude": "12.80328000"
                    },
                    {
                        "id": 58600,
                        "name": "Pieris",
                        "latitude": "45.81243000",
                        "longitude": "13.44917000"
                    },
                    {
                        "id": 58682,
                        "name": "Pinzano al Tagliamento",
                        "latitude": "46.18216000",
                        "longitude": "12.94433000"
                    },
                    {
                        "id": 58743,
                        "name": "Pocenia",
                        "latitude": "45.83570000",
                        "longitude": "13.10145000"
                    },
                    {
                        "id": 58783,
                        "name": "Polcenigo",
                        "latitude": "46.03822000",
                        "longitude": "12.50321000"
                    },
                    {
                        "id": 58862,
                        "name": "Pontebba",
                        "latitude": "46.50540000",
                        "longitude": "13.30622000"
                    },
                    {
                        "id": 58905,
                        "name": "Porcia",
                        "latitude": "45.96301000",
                        "longitude": "12.61642000"
                    },
                    {
                        "id": 58906,
                        "name": "Pordenone",
                        "latitude": "45.95689000",
                        "longitude": "12.66051000"
                    },
                    {
                        "id": 58910,
                        "name": "Porpetto",
                        "latitude": "45.85700000",
                        "longitude": "13.21703000"
                    },
                    {
                        "id": 58972,
                        "name": "Povoletto",
                        "latitude": "46.11568000",
                        "longitude": "13.29171000"
                    },
                    {
                        "id": 58992,
                        "name": "Pozzuolo del Friuli",
                        "latitude": "45.98517000",
                        "longitude": "13.19724000"
                    },
                    {
                        "id": 58994,
                        "name": "Pradamano",
                        "latitude": "46.03391000",
                        "longitude": "13.30223000"
                    },
                    {
                        "id": 59016,
                        "name": "Prata di Pordenone",
                        "latitude": "45.89441000",
                        "longitude": "12.58843000"
                    },
                    {
                        "id": 59025,
                        "name": "Prato",
                        "latitude": "46.37364000",
                        "longitude": "13.30659000"
                    },
                    {
                        "id": 59029,
                        "name": "Prato Carnico",
                        "latitude": "46.52049000",
                        "longitude": "12.80886000"
                    },
                    {
                        "id": 59037,
                        "name": "Pravisdomini",
                        "latitude": "45.81972000",
                        "longitude": "12.69478000"
                    },
                    {
                        "id": 59041,
                        "name": "Precenicco",
                        "latitude": "45.79694000",
                        "longitude": "13.07554000"
                    },
                    {
                        "id": 59053,
                        "name": "Premariacco",
                        "latitude": "46.06145000",
                        "longitude": "13.39461000"
                    },
                    {
                        "id": 59060,
                        "name": "Preone",
                        "latitude": "46.39411000",
                        "longitude": "12.86645000"
                    },
                    {
                        "id": 59063,
                        "name": "Prepotto",
                        "latitude": "46.04522000",
                        "longitude": "13.47921000"
                    },
                    {
                        "id": 59092,
                        "name": "Prosecco-Contovello",
                        "latitude": "45.70807000",
                        "longitude": "13.73376000"
                    },
                    {
                        "id": 59135,
                        "name": "Provincia di Gorizia",
                        "latitude": "45.86548000",
                        "longitude": "13.50195000"
                    },
                    {
                        "id": 59163,
                        "name": "Provincia di Pordenone",
                        "latitude": "46.10182000",
                        "longitude": "12.69002000"
                    },
                    {
                        "id": 59182,
                        "name": "Provincia di Trieste",
                        "latitude": "45.71300000",
                        "longitude": "13.76116000"
                    },
                    {
                        "id": 59183,
                        "name": "Provincia di Udine",
                        "latitude": "46.16408000",
                        "longitude": "13.17794000"
                    },
                    {
                        "id": 59198,
                        "name": "Puia-Villanova",
                        "latitude": "45.86222000",
                        "longitude": "12.57139000"
                    },
                    {
                        "id": 59202,
                        "name": "Pulfero",
                        "latitude": "46.17376000",
                        "longitude": "13.48363000"
                    },
                    {
                        "id": 59277,
                        "name": "Ramuscello",
                        "latitude": "45.88105000",
                        "longitude": "12.88460000"
                    },
                    {
                        "id": 59294,
                        "name": "Rauscedo-Domanins",
                        "latitude": "46.04083000",
                        "longitude": "12.82472000"
                    },
                    {
                        "id": 59297,
                        "name": "Ravascletto",
                        "latitude": "46.52504000",
                        "longitude": "12.92138000"
                    },
                    {
                        "id": 59300,
                        "name": "Raveo",
                        "latitude": "46.43392000",
                        "longitude": "12.87165000"
                    },
                    {
                        "id": 59306,
                        "name": "Reana del Roiale",
                        "latitude": "46.13733000",
                        "longitude": "13.22320000"
                    },
                    {
                        "id": 59307,
                        "name": "Reana del Rojale",
                        "latitude": "46.14322000",
                        "longitude": "13.24653000"
                    },
                    {
                        "id": 59327,
                        "name": "Remanzacco",
                        "latitude": "46.08535000",
                        "longitude": "13.32358000"
                    },
                    {
                        "id": 59336,
                        "name": "Resiutta",
                        "latitude": "46.39371000",
                        "longitude": "13.21796000"
                    },
                    {
                        "id": 59380,
                        "name": "Rigolato",
                        "latitude": "46.55393000",
                        "longitude": "12.84619000"
                    },
                    {
                        "id": 59435,
                        "name": "Rive d'Arcano",
                        "latitude": "46.12722000",
                        "longitude": "13.03222000"
                    },
                    {
                        "id": 59438,
                        "name": "Rivignano",
                        "latitude": "45.87575000",
                        "longitude": "13.04190000"
                    },
                    {
                        "id": 59547,
                        "name": "Rodeano",
                        "latitude": "46.11085000",
                        "longitude": "13.01110000"
                    },
                    {
                        "id": 59580,
                        "name": "Romans d'Isonzo",
                        "latitude": "45.88816000",
                        "longitude": "13.44187000"
                    },
                    {
                        "id": 59596,
                        "name": "Ronchi dei Legionari",
                        "latitude": "45.82735000",
                        "longitude": "13.50417000"
                    },
                    {
                        "id": 59598,
                        "name": "Ronchis",
                        "latitude": "45.80792000",
                        "longitude": "12.99545000"
                    },
                    {
                        "id": 59623,
                        "name": "Rosa",
                        "latitude": "45.93056000",
                        "longitude": "12.87083000"
                    },
                    {
                        "id": 59677,
                        "name": "Roveredo in Piano",
                        "latitude": "46.00847000",
                        "longitude": "12.61938000"
                    },
                    {
                        "id": 59693,
                        "name": "Ruda",
                        "latitude": "45.83986000",
                        "longitude": "13.40177000"
                    },
                    {
                        "id": 59720,
                        "name": "Sacile",
                        "latitude": "45.95412000",
                        "longitude": "12.50274000"
                    },
                    {
                        "id": 59725,
                        "name": "Sagrado",
                        "latitude": "45.87393000",
                        "longitude": "13.48418000"
                    },
                    {
                        "id": 59852,
                        "name": "San Canzian d'Isonzo",
                        "latitude": "45.79750000",
                        "longitude": "13.46639000"
                    },
                    {
                        "id": 59889,
                        "name": "San Daniele del Friuli",
                        "latitude": "46.15714000",
                        "longitude": "13.00726000"
                    },
                    {
                        "id": 59923,
                        "name": "San Floriano del Collio",
                        "latitude": "45.98088000",
                        "longitude": "13.58875000"
                    },
                    {
                        "id": 59941,
                        "name": "San Giacomo",
                        "latitude": "46.17311000",
                        "longitude": "12.98344000"
                    },
                    {
                        "id": 59967,
                        "name": "San Giorgio della Richinvelda",
                        "latitude": "46.04778000",
                        "longitude": "12.86867000"
                    },
                    {
                        "id": 59971,
                        "name": "San Giorgio di Nogaro",
                        "latitude": "45.82745000",
                        "longitude": "13.21088000"
                    },
                    {
                        "id": 59978,
                        "name": "San Giovanni",
                        "latitude": "46.02104000",
                        "longitude": "12.51556000"
                    },
                    {
                        "id": 59992,
                        "name": "San Giovanni al Natisone",
                        "latitude": "45.97079000",
                        "longitude": "13.40182000"
                    },
                    {
                        "id": 60029,
                        "name": "San Leonardo",
                        "latitude": "46.11913000",
                        "longitude": "13.53085000"
                    },
                    {
                        "id": 60041,
                        "name": "San Lorenzo Isontino",
                        "latitude": "45.93020000",
                        "longitude": "13.52517000"
                    },
                    {
                        "id": 60080,
                        "name": "San Martino al Tagliamento",
                        "latitude": "46.01697000",
                        "longitude": "12.86989000"
                    },
                    {
                        "id": 60165,
                        "name": "San Pier d'Isonzo",
                        "latitude": "45.84452000",
                        "longitude": "13.46764000"
                    },
                    {
                        "id": 60188,
                        "name": "San Pietro al Natisone",
                        "latitude": "46.11444000",
                        "longitude": "13.48296000"
                    },
                    {
                        "id": 60218,
                        "name": "San Quirino",
                        "latitude": "46.03411000",
                        "longitude": "12.67846000"
                    },
                    {
                        "id": 60257,
                        "name": "San Valentino",
                        "latitude": "45.79039000",
                        "longitude": "13.41236000"
                    },
                    {
                        "id": 60280,
                        "name": "San Vito al Tagliamento",
                        "latitude": "45.91680000",
                        "longitude": "12.85945000"
                    },
                    {
                        "id": 60281,
                        "name": "San Vito al Torre",
                        "latitude": "45.89587000",
                        "longitude": "13.37588000"
                    },
                    {
                        "id": 60283,
                        "name": "San Vito di Fagagna",
                        "latitude": "46.09103000",
                        "longitude": "13.06569000"
                    },
                    {
                        "id": 60425,
                        "name": "Santa Croce",
                        "latitude": "45.73472000",
                        "longitude": "13.69278000"
                    },
                    {
                        "id": 60480,
                        "name": "Santa Maria la Longa",
                        "latitude": "45.93403000",
                        "longitude": "13.28911000"
                    },
                    {
                        "id": 60537,
                        "name": "Sappada",
                        "latitude": "46.56663000",
                        "longitude": "12.68421000"
                    },
                    {
                        "id": 60580,
                        "name": "Sauris di Sotto",
                        "latitude": "46.46624000",
                        "longitude": "12.70852000"
                    },
                    {
                        "id": 60596,
                        "name": "Savogna",
                        "latitude": "46.15846000",
                        "longitude": "13.53089000"
                    },
                    {
                        "id": 60597,
                        "name": "Savogna d'Isonzo",
                        "latitude": "45.90894000",
                        "longitude": "13.57936000"
                    },
                    {
                        "id": 60680,
                        "name": "Sedegliano",
                        "latitude": "46.01396000",
                        "longitude": "12.97734000"
                    },
                    {
                        "id": 60734,
                        "name": "Sequals",
                        "latitude": "46.16385000",
                        "longitude": "12.83037000"
                    },
                    {
                        "id": 60800,
                        "name": "Sesto al Reghena",
                        "latitude": "45.84938000",
                        "longitude": "12.81295000"
                    },
                    {
                        "id": 60821,
                        "name": "Sevegliano",
                        "latitude": "45.88749000",
                        "longitude": "13.30541000"
                    },
                    {
                        "id": 60831,
                        "name": "Sgonico",
                        "latitude": "45.73583000",
                        "longitude": "13.74708000"
                    },
                    {
                        "id": 60881,
                        "name": "Sistiana-Visogliano",
                        "latitude": "45.77237000",
                        "longitude": "13.63824000"
                    },
                    {
                        "id": 60975,
                        "name": "Sottoselva",
                        "latitude": "45.91134000",
                        "longitude": "13.32416000"
                    },
                    {
                        "id": 61011,
                        "name": "Spilimbergo",
                        "latitude": "46.11345000",
                        "longitude": "12.89241000"
                    },
                    {
                        "id": 61047,
                        "name": "Staranzano",
                        "latitude": "45.80233000",
                        "longitude": "13.50226000"
                    },
                    {
                        "id": 61091,
                        "name": "Stregna",
                        "latitude": "46.12689000",
                        "longitude": "13.57761000"
                    },
                    {
                        "id": 61134,
                        "name": "Sutrio",
                        "latitude": "46.51206000",
                        "longitude": "12.99325000"
                    },
                    {
                        "id": 61150,
                        "name": "Taipana",
                        "latitude": "46.24911000",
                        "longitude": "13.34150000"
                    },
                    {
                        "id": 61156,
                        "name": "Talmassons",
                        "latitude": "45.92810000",
                        "longitude": "13.12199000"
                    },
                    {
                        "id": 61158,
                        "name": "Tamai",
                        "latitude": "45.92427000",
                        "longitude": "12.57187000"
                    },
                    {
                        "id": 61166,
                        "name": "Tarcento",
                        "latitude": "46.21251000",
                        "longitude": "13.21514000"
                    },
                    {
                        "id": 61170,
                        "name": "Tarvisio",
                        "latitude": "46.50567000",
                        "longitude": "13.58689000"
                    },
                    {
                        "id": 61178,
                        "name": "Tavagnacco",
                        "latitude": "46.10976000",
                        "longitude": "13.22251000"
                    },
                    {
                        "id": 61215,
                        "name": "Teor",
                        "latitude": "45.85416000",
                        "longitude": "13.05608000"
                    },
                    {
                        "id": 61257,
                        "name": "Terzo d'Aquileia",
                        "latitude": "45.79994000",
                        "longitude": "13.34177000"
                    },
                    {
                        "id": 61302,
                        "name": "Tolmezzo",
                        "latitude": "46.39996000",
                        "longitude": "13.02051000"
                    },
                    {
                        "id": 61378,
                        "name": "Torreano",
                        "latitude": "46.12786000",
                        "longitude": "13.42933000"
                    },
                    {
                        "id": 61421,
                        "name": "Torviscosa",
                        "latitude": "45.82337000",
                        "longitude": "13.28050000"
                    },
                    {
                        "id": 61433,
                        "name": "Tramonti di Sopra",
                        "latitude": "46.31023000",
                        "longitude": "12.78994000"
                    },
                    {
                        "id": 61434,
                        "name": "Tramonti di Sotto",
                        "latitude": "46.28475000",
                        "longitude": "12.79644000"
                    },
                    {
                        "id": 61445,
                        "name": "Trasaghis",
                        "latitude": "46.28164000",
                        "longitude": "13.07545000"
                    },
                    {
                        "id": 61455,
                        "name": "Travesio",
                        "latitude": "46.19667000",
                        "longitude": "12.86740000"
                    },
                    {
                        "id": 61487,
                        "name": "Treppo Carnico",
                        "latitude": "46.53323000",
                        "longitude": "13.04292000"
                    },
                    {
                        "id": 61488,
                        "name": "Treppo Grande",
                        "latitude": "46.19988000",
                        "longitude": "13.15350000"
                    },
                    {
                        "id": 61521,
                        "name": "Tricesimo",
                        "latitude": "46.16058000",
                        "longitude": "13.21566000"
                    },
                    {
                        "id": 61524,
                        "name": "Trieste",
                        "latitude": "45.64953000",
                        "longitude": "13.77678000"
                    },
                    {
                        "id": 61543,
                        "name": "Trivignano Udinese",
                        "latitude": "45.94601000",
                        "longitude": "13.34019000"
                    },
                    {
                        "id": 61577,
                        "name": "Turriaco",
                        "latitude": "45.82119000",
                        "longitude": "13.44369000"
                    },
                    {
                        "id": 61587,
                        "name": "Udine",
                        "latitude": "46.06930000",
                        "longitude": "13.23715000"
                    },
                    {
                        "id": 61642,
                        "name": "Vajont",
                        "latitude": "46.14534000",
                        "longitude": "12.69647000"
                    },
                    {
                        "id": 61746,
                        "name": "Valvasone",
                        "latitude": "45.99331000",
                        "longitude": "12.86659000"
                    },
                    {
                        "id": 61772,
                        "name": "Varmo",
                        "latitude": "45.88630000",
                        "longitude": "12.99005000"
                    },
                    {
                        "id": 61830,
                        "name": "Venzone",
                        "latitude": "46.33031000",
                        "longitude": "13.13825000"
                    },
                    {
                        "id": 61976,
                        "name": "Vigonovo-Fontanafredda",
                        "latitude": "45.98927000",
                        "longitude": "12.54707000"
                    },
                    {
                        "id": 62007,
                        "name": "Villa Opicina",
                        "latitude": "45.68780000",
                        "longitude": "13.78861000"
                    },
                    {
                        "id": 62027,
                        "name": "Villa Santina",
                        "latitude": "46.41368000",
                        "longitude": "12.92445000"
                    },
                    {
                        "id": 62031,
                        "name": "Villa Vicentina",
                        "latitude": "45.81378000",
                        "longitude": "13.39332000"
                    },
                    {
                        "id": 62090,
                        "name": "Villanova",
                        "latitude": "46.13226000",
                        "longitude": "12.97084000"
                    },
                    {
                        "id": 62150,
                        "name": "Villesse",
                        "latitude": "45.86526000",
                        "longitude": "13.44380000"
                    },
                    {
                        "id": 62155,
                        "name": "Villotta",
                        "latitude": "45.86336000",
                        "longitude": "12.75418000"
                    },
                    {
                        "id": 62173,
                        "name": "Visco",
                        "latitude": "45.89194000",
                        "longitude": "13.34861000"
                    },
                    {
                        "id": 62190,
                        "name": "Vivaro",
                        "latitude": "46.07656000",
                        "longitude": "12.77912000"
                    },
                    {
                        "id": 62268,
                        "name": "Zolla",
                        "latitude": "45.71698000",
                        "longitude": "13.81038000"
                    },
                    {
                        "id": 62274,
                        "name": "Zoppola",
                        "latitude": "45.96624000",
                        "longitude": "12.76828000"
                    },
                    {
                        "id": 62282,
                        "name": "Zugliano-Terenzano-Cargnacco",
                        "latitude": "46.00750000",
                        "longitude": "13.21694000"
                    },
                    {
                        "id": 62283,
                        "name": "Zuglio",
                        "latitude": "46.45830000",
                        "longitude": "13.02589000"
                    }
                ]
            },
            {
                "id": 1776,
                "name": "Frosinone",
                "iso2": "FR",
                "latitude": "41.65765280",
                "longitude": "13.63627150",
                "type": "province",
                "cities": []
            },
            {
                "id": 1777,
                "name": "Gorizia",
                "iso2": "GO",
                "latitude": "45.90538990",
                "longitude": "13.51637250",
                "type": "decentralized regional entity",
                "cities": []
            },
            {
                "id": 1787,
                "name": "Grosseto",
                "iso2": "GR",
                "latitude": "42.85180070",
                "longitude": "11.25237920",
                "type": "province",
                "cities": []
            },
            {
                "id": 1788,
                "name": "Imperia",
                "iso2": "IM",
                "latitude": "43.94186600",
                "longitude": "7.82863680",
                "type": "province",
                "cities": []
            },
            {
                "id": 1789,
                "name": "Isernia",
                "iso2": "IS",
                "latitude": "41.58915550",
                "longitude": "14.19309180",
                "type": "province",
                "cities": []
            },
            {
                "id": 1781,
                "name": "L'Aquila",
                "iso2": "AQ",
                "latitude": "42.12563170",
                "longitude": "13.63627150",
                "type": "province",
                "cities": []
            },
            {
                "id": 1791,
                "name": "La Spezia",
                "iso2": "SP",
                "latitude": "44.24479130",
                "longitude": "9.76786870",
                "type": "province",
                "cities": []
            },
            {
                "id": 1674,
                "name": "Latina",
                "iso2": "LT",
                "latitude": "41.40874760",
                "longitude": "13.08179030",
                "type": "province",
                "cities": []
            },
            {
                "id": 1678,
                "name": "Lazio",
                "iso2": "62",
                "latitude": "41.81224100",
                "longitude": "12.73851000",
                "type": "region",
                "cities": [
                    {
                        "id": 135252,
                        "name": "Accumoli",
                        "latitude": "42.69476000",
                        "longitude": "13.24761000"
                    },
                    {
                        "id": 135261,
                        "name": "Acilia-Castel Fusano-Ostia Antica",
                        "latitude": "41.76337000",
                        "longitude": "12.33078000"
                    },
                    {
                        "id": 135264,
                        "name": "Acquafondata",
                        "latitude": "41.54282000",
                        "longitude": "13.95281000"
                    },
                    {
                        "id": 135270,
                        "name": "Acquapendente",
                        "latitude": "42.74259000",
                        "longitude": "11.86827000"
                    },
                    {
                        "id": 135285,
                        "name": "Acuto",
                        "latitude": "41.79107000",
                        "longitude": "13.17446000"
                    },
                    {
                        "id": 135293,
                        "name": "Affile",
                        "latitude": "41.88435000",
                        "longitude": "13.09853000"
                    },
                    {
                        "id": 135313,
                        "name": "Agosta",
                        "latitude": "41.98133000",
                        "longitude": "13.03499000"
                    },
                    {
                        "id": 135345,
                        "name": "Alatri",
                        "latitude": "41.73187000",
                        "longitude": "13.34120000"
                    },
                    {
                        "id": 135351,
                        "name": "Albano Laziale",
                        "latitude": "41.72748000",
                        "longitude": "12.65900000"
                    },
                    {
                        "id": 135386,
                        "name": "Albuccione",
                        "latitude": "41.95245000",
                        "longitude": "12.69873000"
                    },
                    {
                        "id": 135419,
                        "name": "Allumiere",
                        "latitude": "42.15751000",
                        "longitude": "11.90361000"
                    },
                    {
                        "id": 135449,
                        "name": "Alvito",
                        "latitude": "41.69002000",
                        "longitude": "13.74795000"
                    },
                    {
                        "id": 135461,
                        "name": "Amaseno",
                        "latitude": "41.46705000",
                        "longitude": "13.33457000"
                    },
                    {
                        "id": 135463,
                        "name": "Amatrice",
                        "latitude": "42.62664000",
                        "longitude": "13.29509000"
                    },
                    {
                        "id": 135476,
                        "name": "Anagni",
                        "latitude": "41.74350000",
                        "longitude": "13.15542000"
                    },
                    {
                        "id": 135502,
                        "name": "Anguillara Sabazia",
                        "latitude": "42.07920000",
                        "longitude": "12.28368000"
                    },
                    {
                        "id": 135504,
                        "name": "Anitrella-Chiaiamari",
                        "latitude": "41.63825000",
                        "longitude": "13.54835000"
                    },
                    {
                        "id": 135517,
                        "name": "Anticoli Corrado",
                        "latitude": "42.00801000",
                        "longitude": "12.99049000"
                    },
                    {
                        "id": 135521,
                        "name": "Antrodoco",
                        "latitude": "42.41498000",
                        "longitude": "13.07673000"
                    },
                    {
                        "id": 135527,
                        "name": "Anzio",
                        "latitude": "41.45263000",
                        "longitude": "12.62157000"
                    },
                    {
                        "id": 135542,
                        "name": "Aprilia",
                        "latitude": "41.59452000",
                        "longitude": "12.65419000"
                    },
                    {
                        "id": 135547,
                        "name": "Aquino",
                        "latitude": "41.49388000",
                        "longitude": "13.70520000"
                    },
                    {
                        "id": 135548,
                        "name": "Ara Nova",
                        "latitude": "41.93300000",
                        "longitude": "12.23980000"
                    },
                    {
                        "id": 135561,
                        "name": "Arce",
                        "latitude": "41.57787000",
                        "longitude": "13.58571000"
                    },
                    {
                        "id": 135566,
                        "name": "Arci-Empolitana",
                        "latitude": "41.94766000",
                        "longitude": "12.82502000"
                    },
                    {
                        "id": 135568,
                        "name": "Arcinazzo Romano",
                        "latitude": "41.87972000",
                        "longitude": "13.11439000"
                    },
                    {
                        "id": 135578,
                        "name": "Ardea",
                        "latitude": "41.60742000",
                        "longitude": "12.54158000"
                    },
                    {
                        "id": 135584,
                        "name": "Area Produttiva",
                        "latitude": "41.68211000",
                        "longitude": "12.50697000"
                    },
                    {
                        "id": 135601,
                        "name": "Ariccia",
                        "latitude": "41.72063000",
                        "longitude": "12.67230000"
                    },
                    {
                        "id": 135610,
                        "name": "Arlena di Castro",
                        "latitude": "42.46559000",
                        "longitude": "11.82090000"
                    },
                    {
                        "id": 135615,
                        "name": "Armetta",
                        "latitude": "41.81280000",
                        "longitude": "12.68782000"
                    },
                    {
                        "id": 135619,
                        "name": "Arnara",
                        "latitude": "41.58452000",
                        "longitude": "13.38840000"
                    },
                    {
                        "id": 135628,
                        "name": "Arpino",
                        "latitude": "41.64705000",
                        "longitude": "13.61155000"
                    },
                    {
                        "id": 135640,
                        "name": "Arsoli",
                        "latitude": "42.04158000",
                        "longitude": "13.01606000"
                    },
                    {
                        "id": 135643,
                        "name": "Artena",
                        "latitude": "41.74126000",
                        "longitude": "12.90667000"
                    },
                    {
                        "id": 135657,
                        "name": "Ascrea",
                        "latitude": "42.19763000",
                        "longitude": "12.99457000"
                    },
                    {
                        "id": 135676,
                        "name": "Atina",
                        "latitude": "41.62004000",
                        "longitude": "13.79905000"
                    },
                    {
                        "id": 135677,
                        "name": "Atina Inferiore",
                        "latitude": "41.62705000",
                        "longitude": "13.79258000"
                    },
                    {
                        "id": 135689,
                        "name": "Aurelia",
                        "latitude": "42.13910000",
                        "longitude": "11.78713000"
                    },
                    {
                        "id": 135694,
                        "name": "Ausonia",
                        "latitude": "41.35808000",
                        "longitude": "13.74983000"
                    },
                    {
                        "id": 135758,
                        "name": "Bagni di Tivoli",
                        "latitude": "41.95000000",
                        "longitude": "12.71667000"
                    },
                    {
                        "id": 135775,
                        "name": "Bagnoregio",
                        "latitude": "42.62845000",
                        "longitude": "12.08969000"
                    },
                    {
                        "id": 135820,
                        "name": "Barbarano Romano",
                        "latitude": "42.24908000",
                        "longitude": "12.06774000"
                    },
                    {
                        "id": 135894,
                        "name": "Bassano in Teverina",
                        "latitude": "42.46444000",
                        "longitude": "12.30752000"
                    },
                    {
                        "id": 135892,
                        "name": "Bassano Romano",
                        "latitude": "42.22228000",
                        "longitude": "12.18785000"
                    },
                    {
                        "id": 135895,
                        "name": "Bassiano",
                        "latitude": "41.55154000",
                        "longitude": "13.02732000"
                    },
                    {
                        "id": 135935,
                        "name": "Bella Farnia",
                        "latitude": "41.36780000",
                        "longitude": "12.97602000"
                    },
                    {
                        "id": 135942,
                        "name": "Bellegra",
                        "latitude": "41.88166000",
                        "longitude": "13.02861000"
                    },
                    {
                        "id": 135952,
                        "name": "Belmonte Castello",
                        "latitude": "41.57742000",
                        "longitude": "13.81581000"
                    },
                    {
                        "id": 135956,
                        "name": "Belmonte in Sabina",
                        "latitude": "42.31482000",
                        "longitude": "12.89178000"
                    },
                    {
                        "id": 136074,
                        "name": "Bivio di Capanelle",
                        "latitude": "42.11962000",
                        "longitude": "12.59395000"
                    },
                    {
                        "id": 136072,
                        "name": "Bivio San Polo",
                        "latitude": "41.97418000",
                        "longitude": "12.82993000"
                    },
                    {
                        "id": 136080,
                        "name": "Blera",
                        "latitude": "42.27293000",
                        "longitude": "12.03016000"
                    },
                    {
                        "id": 136113,
                        "name": "Bolsena",
                        "latitude": "42.64326000",
                        "longitude": "11.98514000"
                    },
                    {
                        "id": 136118,
                        "name": "Bomarzo",
                        "latitude": "42.48273000",
                        "longitude": "12.25037000"
                    },
                    {
                        "id": 136145,
                        "name": "Borbona",
                        "latitude": "42.50939000",
                        "longitude": "13.13206000"
                    },
                    {
                        "id": 136172,
                        "name": "Borgo Grappa",
                        "latitude": "41.40212000",
                        "longitude": "12.96053000"
                    },
                    {
                        "id": 136173,
                        "name": "Borgo Hermada",
                        "latitude": "41.30559000",
                        "longitude": "13.17235000"
                    },
                    {
                        "id": 136174,
                        "name": "Borgo Lotti",
                        "latitude": "41.76414000",
                        "longitude": "12.55500000"
                    },
                    {
                        "id": 136178,
                        "name": "Borgo Podgora",
                        "latitude": "41.51462000",
                        "longitude": "12.85383000"
                    },
                    {
                        "id": 136180,
                        "name": "Borgo Sabotino-Foce Verde",
                        "latitude": "41.41667000",
                        "longitude": "12.83333000"
                    },
                    {
                        "id": 136186,
                        "name": "Borgo San Michele",
                        "latitude": "41.43828000",
                        "longitude": "12.97351000"
                    },
                    {
                        "id": 136195,
                        "name": "Borgo Velino",
                        "latitude": "42.40508000",
                        "longitude": "13.05650000"
                    },
                    {
                        "id": 136216,
                        "name": "Borgorose",
                        "latitude": "42.19077000",
                        "longitude": "13.23282000"
                    },
                    {
                        "id": 136271,
                        "name": "Boville Ernica",
                        "latitude": "41.64252000",
                        "longitude": "13.47270000"
                    },
                    {
                        "id": 136281,
                        "name": "Bracciano",
                        "latitude": "42.10271000",
                        "longitude": "12.16565000"
                    },
                    {
                        "id": 136345,
                        "name": "Broccostella",
                        "latitude": "41.69972000",
                        "longitude": "13.63531000"
                    },
                    {
                        "id": 136480,
                        "name": "Caira",
                        "latitude": "41.53333000",
                        "longitude": "13.81667000"
                    },
                    {
                        "id": 136500,
                        "name": "Calcata Nuova",
                        "latitude": "42.21952000",
                        "longitude": "12.42617000"
                    },
                    {
                        "id": 136581,
                        "name": "Camerata Nuova",
                        "latitude": "42.01800000",
                        "longitude": "13.10970000"
                    },
                    {
                        "id": 136587,
                        "name": "Camilleri-Vallelata",
                        "latitude": "41.59848000",
                        "longitude": "12.61738000"
                    },
                    {
                        "id": 136601,
                        "name": "Campagnano di Roma",
                        "latitude": "42.13570000",
                        "longitude": "12.37358000"
                    },
                    {
                        "id": 136634,
                        "name": "Campo di Carne",
                        "latitude": "41.55265000",
                        "longitude": "12.64114000"
                    },
                    {
                        "id": 136628,
                        "name": "Campo Jemini",
                        "latitude": "41.62716000",
                        "longitude": "12.51258000"
                    },
                    {
                        "id": 136630,
                        "name": "Campo Limpido-Favale",
                        "latitude": "41.96732000",
                        "longitude": "12.77016000"
                    },
                    {
                        "id": 136646,
                        "name": "Campodimele",
                        "latitude": "41.38822000",
                        "longitude": "13.53081000"
                    },
                    {
                        "id": 136659,
                        "name": "Campoleone",
                        "latitude": "41.64570000",
                        "longitude": "12.64826000"
                    },
                    {
                        "id": 136660,
                        "name": "Campoli Appennino",
                        "latitude": "41.73539000",
                        "longitude": "13.68326000"
                    },
                    {
                        "id": 136688,
                        "name": "Canale Monterano",
                        "latitude": "42.13598000",
                        "longitude": "12.10284000"
                    },
                    {
                        "id": 136709,
                        "name": "Canepina",
                        "latitude": "42.38315000",
                        "longitude": "12.23179000"
                    },
                    {
                        "id": 136714,
                        "name": "Canino",
                        "latitude": "42.46592000",
                        "longitude": "11.75294000"
                    },
                    {
                        "id": 136739,
                        "name": "Cantalice",
                        "latitude": "42.46458000",
                        "longitude": "12.90461000"
                    },
                    {
                        "id": 136743,
                        "name": "Cantalupo in Sabina",
                        "latitude": "42.30689000",
                        "longitude": "12.64513000"
                    },
                    {
                        "id": 136747,
                        "name": "Canterano",
                        "latitude": "41.94322000",
                        "longitude": "13.03809000"
                    },
                    {
                        "id": 136763,
                        "name": "Capena",
                        "latitude": "42.14247000",
                        "longitude": "12.54513000"
                    },
                    {
                        "id": 136781,
                        "name": "Capodimonte",
                        "latitude": "42.54780000",
                        "longitude": "11.90657000"
                    },
                    {
                        "id": 136801,
                        "name": "Capranica",
                        "latitude": "42.25849000",
                        "longitude": "12.17278000"
                    },
                    {
                        "id": 136802,
                        "name": "Capranica Prenestina",
                        "latitude": "41.86285000",
                        "longitude": "12.95077000"
                    },
                    {
                        "id": 136805,
                        "name": "Caprarola",
                        "latitude": "42.32308000",
                        "longitude": "12.23848000"
                    },
                    {
                        "id": 136844,
                        "name": "Carbognano",
                        "latitude": "42.33024000",
                        "longitude": "12.26457000"
                    },
                    {
                        "id": 136855,
                        "name": "Carchitti",
                        "latitude": "41.78688000",
                        "longitude": "12.82955000"
                    },
                    {
                        "id": 136918,
                        "name": "Carpineto Romano",
                        "latitude": "41.60470000",
                        "longitude": "13.08410000"
                    },
                    {
                        "id": 136926,
                        "name": "Carrara-Pontenuovo",
                        "latitude": "41.54045000",
                        "longitude": "12.95468000"
                    },
                    {
                        "id": 136937,
                        "name": "Cartiera-Stazione",
                        "latitude": "41.65642000",
                        "longitude": "13.24086000"
                    },
                    {
                        "id": 136958,
                        "name": "Casal Palocco",
                        "latitude": "41.74845000",
                        "longitude": "12.34726000"
                    },
                    {
                        "id": 136962,
                        "name": "Casalattico",
                        "latitude": "41.62213000",
                        "longitude": "13.72563000"
                    },
                    {
                        "id": 136963,
                        "name": "Casalazzara",
                        "latitude": "41.62299000",
                        "longitude": "12.57634000"
                    },
                    {
                        "id": 136993,
                        "name": "Casali",
                        "latitude": "41.37812000",
                        "longitude": "13.75479000"
                    },
                    {
                        "id": 137012,
                        "name": "Casalvieri",
                        "latitude": "41.63329000",
                        "longitude": "13.71363000"
                    },
                    {
                        "id": 137025,
                        "name": "Casape",
                        "latitude": "41.90702000",
                        "longitude": "12.88579000"
                    },
                    {
                        "id": 137028,
                        "name": "Casaprota",
                        "latitude": "42.25177000",
                        "longitude": "12.80428000"
                    },
                    {
                        "id": 137054,
                        "name": "Case Campoli-Panetta",
                        "latitude": "41.67296000",
                        "longitude": "13.47170000"
                    },
                    {
                        "id": 137091,
                        "name": "Casperia",
                        "latitude": "42.33869000",
                        "longitude": "12.67017000"
                    },
                    {
                        "id": 137112,
                        "name": "Cassino",
                        "latitude": "41.48581000",
                        "longitude": "13.82835000"
                    },
                    {
                        "id": 137134,
                        "name": "Castel Chiodato",
                        "latitude": "42.05617000",
                        "longitude": "12.69764000"
                    },
                    {
                        "id": 137175,
                        "name": "Castel di Tora",
                        "latitude": "42.21392000",
                        "longitude": "12.97073000"
                    },
                    {
                        "id": 137137,
                        "name": "Castel Fusano",
                        "latitude": "41.74717000",
                        "longitude": "12.31190000"
                    },
                    {
                        "id": 137139,
                        "name": "Castel Gandolfo",
                        "latitude": "41.74875000",
                        "longitude": "12.64975000"
                    },
                    {
                        "id": 137143,
                        "name": "Castel Madama",
                        "latitude": "41.97350000",
                        "longitude": "12.86782000"
                    },
                    {
                        "id": 137154,
                        "name": "Castel San Pietro Romano",
                        "latitude": "41.84572000",
                        "longitude": "12.89489000"
                    },
                    {
                        "id": 137157,
                        "name": "Castel Sant'Angelo",
                        "latitude": "42.39373000",
                        "longitude": "13.02738000"
                    },
                    {
                        "id": 137158,
                        "name": "Castel Sant'Elia",
                        "latitude": "42.25112000",
                        "longitude": "12.37032000"
                    },
                    {
                        "id": 137195,
                        "name": "Castelforte",
                        "latitude": "41.29392000",
                        "longitude": "13.83061000"
                    },
                    {
                        "id": 137250,
                        "name": "Castelliri",
                        "latitude": "41.67764000",
                        "longitude": "13.53978000"
                    },
                    {
                        "id": 137271,
                        "name": "Castelmassimo",
                        "latitude": "41.66389000",
                        "longitude": "13.38063000"
                    },
                    {
                        "id": 137301,
                        "name": "Castelnuovo di Farfa",
                        "latitude": "42.23193000",
                        "longitude": "12.74308000"
                    },
                    {
                        "id": 137303,
                        "name": "Castelnuovo di Porto",
                        "latitude": "42.12280000",
                        "longitude": "12.51043000"
                    },
                    {
                        "id": 137292,
                        "name": "Castelnuovo Parano",
                        "latitude": "41.37912000",
                        "longitude": "13.75621000"
                    },
                    {
                        "id": 137358,
                        "name": "Castiglione in Teverina",
                        "latitude": "42.65076000",
                        "longitude": "12.20305000"
                    },
                    {
                        "id": 137377,
                        "name": "Castro dei Volsci",
                        "latitude": "41.50822000",
                        "longitude": "13.40630000"
                    },
                    {
                        "id": 137379,
                        "name": "Castrocielo",
                        "latitude": "41.52736000",
                        "longitude": "13.69588000"
                    },
                    {
                        "id": 137430,
                        "name": "Cave",
                        "latitude": "41.81682000",
                        "longitude": "12.94055000"
                    },
                    {
                        "id": 137450,
                        "name": "Ceccano",
                        "latitude": "41.57236000",
                        "longitude": "13.32901000"
                    },
                    {
                        "id": 137451,
                        "name": "Cecchina",
                        "latitude": "41.70161000",
                        "longitude": "12.64972000"
                    },
                    {
                        "id": 137477,
                        "name": "Celleno",
                        "latitude": "42.56039000",
                        "longitude": "12.12442000"
                    },
                    {
                        "id": 137478,
                        "name": "Cellere",
                        "latitude": "42.51024000",
                        "longitude": "11.77079000"
                    },
                    {
                        "id": 137510,
                        "name": "Ceprano",
                        "latitude": "41.54572000",
                        "longitude": "13.51473000"
                    },
                    {
                        "id": 137559,
                        "name": "Cerquotti-Madonna del Piano",
                        "latitude": "41.64194000",
                        "longitude": "13.21316000"
                    },
                    {
                        "id": 137565,
                        "name": "Cerreto Laziale",
                        "latitude": "41.94332000",
                        "longitude": "12.98169000"
                    },
                    {
                        "id": 137582,
                        "name": "Cervara di Roma",
                        "latitude": "41.98822000",
                        "longitude": "13.06799000"
                    },
                    {
                        "id": 137584,
                        "name": "Cervaro",
                        "latitude": "41.48278000",
                        "longitude": "13.90218000"
                    },
                    {
                        "id": 137590,
                        "name": "Cerveteri",
                        "latitude": "41.99080000",
                        "longitude": "12.09082000"
                    },
                    {
                        "id": 137604,
                        "name": "Cesano",
                        "latitude": "42.07375000",
                        "longitude": "12.33711000"
                    },
                    {
                        "id": 137701,
                        "name": "Ciampino",
                        "latitude": "41.80064000",
                        "longitude": "12.60158000"
                    },
                    {
                        "id": 137711,
                        "name": "Ciciliano",
                        "latitude": "41.95990000",
                        "longitude": "12.94163000"
                    },
                    {
                        "id": 137730,
                        "name": "Cineto Romano",
                        "latitude": "42.05014000",
                        "longitude": "12.96080000"
                    },
                    {
                        "id": 137762,
                        "name": "Cisterna di Latina",
                        "latitude": "41.59080000",
                        "longitude": "12.82808000"
                    },
                    {
                        "id": 137776,
                        "name": "Città metropolitana di Roma Capitale",
                        "latitude": "41.96667000",
                        "longitude": "12.66667000"
                    },
                    {
                        "id": 137767,
                        "name": "Cittaducale",
                        "latitude": "42.38664000",
                        "longitude": "12.95497000"
                    },
                    {
                        "id": 137769,
                        "name": "Cittareale",
                        "latitude": "42.61624000",
                        "longitude": "13.15788000"
                    },
                    {
                        "id": 137786,
                        "name": "Civita Castellana",
                        "latitude": "42.29304000",
                        "longitude": "12.40885000"
                    },
                    {
                        "id": 137794,
                        "name": "Civitavecchia",
                        "latitude": "42.09325000",
                        "longitude": "11.79674000"
                    },
                    {
                        "id": 137801,
                        "name": "Civitella d'Agliano",
                        "latitude": "42.60296000",
                        "longitude": "12.18624000"
                    },
                    {
                        "id": 137800,
                        "name": "Civitella San Paolo",
                        "latitude": "42.19935000",
                        "longitude": "12.57455000"
                    },
                    {
                        "id": 137849,
                        "name": "Coldragone",
                        "latitude": "41.55458000",
                        "longitude": "13.60399000"
                    },
                    {
                        "id": 137856,
                        "name": "Collalto Sabino",
                        "latitude": "42.13522000",
                        "longitude": "13.04841000"
                    },
                    {
                        "id": 137860,
                        "name": "Colle Campano-Scrima",
                        "latitude": "41.62364000",
                        "longitude": "13.46336000"
                    },
                    {
                        "id": 137870,
                        "name": "Colle del Pino",
                        "latitude": "41.74246000",
                        "longitude": "12.49644000"
                    },
                    {
                        "id": 137871,
                        "name": "Colle di Fuori",
                        "latitude": "41.80091000",
                        "longitude": "12.80683000"
                    },
                    {
                        "id": 137872,
                        "name": "Colle di Tora",
                        "latitude": "42.20809000",
                        "longitude": "12.94746000"
                    },
                    {
                        "id": 137862,
                        "name": "Colle Mainello",
                        "latitude": "41.86975000",
                        "longitude": "12.78767000"
                    },
                    {
                        "id": 137863,
                        "name": "Colle San Magno",
                        "latitude": "41.55019000",
                        "longitude": "13.69485000"
                    },
                    {
                        "id": 137866,
                        "name": "Colle Spina",
                        "latitude": "41.78205000",
                        "longitude": "12.84723000"
                    },
                    {
                        "id": 137868,
                        "name": "Colle Verde",
                        "latitude": "41.97694000",
                        "longitude": "12.61855000"
                    },
                    {
                        "id": 137880,
                        "name": "Colleferro",
                        "latitude": "41.72722000",
                        "longitude": "13.00481000"
                    },
                    {
                        "id": 137881,
                        "name": "Collefontana-Fontana Liri Inferiore",
                        "latitude": "41.61166000",
                        "longitude": "13.54945000"
                    },
                    {
                        "id": 137882,
                        "name": "Collegiove",
                        "latitude": "42.17506000",
                        "longitude": "13.03844000"
                    },
                    {
                        "id": 137886,
                        "name": "Collepardo",
                        "latitude": "41.76417000",
                        "longitude": "13.36846000"
                    },
                    {
                        "id": 137896,
                        "name": "Collevecchio",
                        "latitude": "42.33368000",
                        "longitude": "12.55329000"
                    },
                    {
                        "id": 137897,
                        "name": "Colleverde II",
                        "latitude": "41.97533000",
                        "longitude": "12.63191000"
                    },
                    {
                        "id": 137900,
                        "name": "Colli di Enea",
                        "latitude": "41.65554000",
                        "longitude": "12.49035000"
                    },
                    {
                        "id": 137901,
                        "name": "Colli sul Velino",
                        "latitude": "42.49828000",
                        "longitude": "12.78153000"
                    },
                    {
                        "id": 137922,
                        "name": "Colonna",
                        "latitude": "41.83454000",
                        "longitude": "12.75495000"
                    },
                    {
                        "id": 137929,
                        "name": "Colubro",
                        "latitude": "41.73506000",
                        "longitude": "12.86726000"
                    },
                    {
                        "id": 137956,
                        "name": "Concerviano",
                        "latitude": "42.32214000",
                        "longitude": "12.98534000"
                    },
                    {
                        "id": 137968,
                        "name": "Configni",
                        "latitude": "42.42543000",
                        "longitude": "12.64431000"
                    },
                    {
                        "id": 137978,
                        "name": "Contigliano",
                        "latitude": "42.41058000",
                        "longitude": "12.77202000"
                    },
                    {
                        "id": 137998,
                        "name": "Corchiano",
                        "latitude": "42.34495000",
                        "longitude": "12.35688000"
                    },
                    {
                        "id": 138000,
                        "name": "Corcolle",
                        "latitude": "41.90421000",
                        "longitude": "12.73654000"
                    },
                    {
                        "id": 138007,
                        "name": "Coreno Ausonio",
                        "latitude": "41.34735000",
                        "longitude": "13.77648000"
                    },
                    {
                        "id": 138010,
                        "name": "Cori",
                        "latitude": "41.64358000",
                        "longitude": "12.91121000"
                    },
                    {
                        "id": 138074,
                        "name": "Corvaro",
                        "latitude": "42.20538000",
                        "longitude": "13.26496000"
                    },
                    {
                        "id": 138107,
                        "name": "Costaroni",
                        "latitude": "42.07819000",
                        "longitude": "12.53712000"
                    },
                    {
                        "id": 138113,
                        "name": "Cottanello",
                        "latitude": "42.40811000",
                        "longitude": "12.68592000"
                    },
                    {
                        "id": 138150,
                        "name": "Cretone",
                        "latitude": "42.07116000",
                        "longitude": "12.70365000"
                    },
                    {
                        "id": 138384,
                        "name": "Esperia",
                        "latitude": "41.38237000",
                        "longitude": "13.68491000"
                    },
                    {
                        "id": 138394,
                        "name": "Fabrica di Roma",
                        "latitude": "42.33444000",
                        "longitude": "12.29873000"
                    },
                    {
                        "id": 138418,
                        "name": "Faleria",
                        "latitude": "42.22580000",
                        "longitude": "12.44518000"
                    },
                    {
                        "id": 138425,
                        "name": "Falvaterra",
                        "latitude": "41.50438000",
                        "longitude": "13.52341000"
                    },
                    {
                        "id": 138443,
                        "name": "Fara in Sabina",
                        "latitude": "42.20807000",
                        "longitude": "12.72960000"
                    },
                    {
                        "id": 138449,
                        "name": "Farnese",
                        "latitude": "42.54926000",
                        "longitude": "11.72638000"
                    },
                    {
                        "id": 138480,
                        "name": "Ferentino",
                        "latitude": "41.69119000",
                        "longitude": "13.25620000"
                    },
                    {
                        "id": 138499,
                        "name": "Fiamignano",
                        "latitude": "42.26546000",
                        "longitude": "13.12413000"
                    },
                    {
                        "id": 138501,
                        "name": "Fiano Romano",
                        "latitude": "42.15538000",
                        "longitude": "12.59467000"
                    },
                    {
                        "id": 138521,
                        "name": "Filacciano",
                        "latitude": "42.25445000",
                        "longitude": "12.59880000"
                    },
                    {
                        "id": 138526,
                        "name": "Filettino",
                        "latitude": "41.89131000",
                        "longitude": "13.32531000"
                    },
                    {
                        "id": 138546,
                        "name": "Fiuggi",
                        "latitude": "41.79780000",
                        "longitude": "13.22386000"
                    },
                    {
                        "id": 138555,
                        "name": "Fiumicino-Isola Sacra",
                        "latitude": "41.77093000",
                        "longitude": "12.23662000"
                    },
                    {
                        "id": 138571,
                        "name": "Focene",
                        "latitude": "41.81367000",
                        "longitude": "12.21354000"
                    },
                    {
                        "id": 138588,
                        "name": "Fondi",
                        "latitude": "41.35787000",
                        "longitude": "13.42718000"
                    },
                    {
                        "id": 138610,
                        "name": "Fontechiari",
                        "latitude": "41.66788000",
                        "longitude": "13.67504000"
                    },
                    {
                        "id": 138617,
                        "name": "Forano",
                        "latitude": "42.29768000",
                        "longitude": "12.59469000"
                    },
                    {
                        "id": 138635,
                        "name": "Formello",
                        "latitude": "42.06246000",
                        "longitude": "12.39435000"
                    },
                    {
                        "id": 138636,
                        "name": "Formia",
                        "latitude": "41.25632000",
                        "longitude": "13.60888000"
                    },
                    {
                        "id": 138678,
                        "name": "Fossignano",
                        "latitude": "41.59226000",
                        "longitude": "12.56333000"
                    },
                    {
                        "id": 138708,
                        "name": "Frascati",
                        "latitude": "41.80910000",
                        "longitude": "12.67942000"
                    },
                    {
                        "id": 138717,
                        "name": "Frasso Sabino",
                        "latitude": "42.22927000",
                        "longitude": "12.80658000"
                    },
                    {
                        "id": 138728,
                        "name": "Fregene",
                        "latitude": "41.85051000",
                        "longitude": "12.19671000"
                    },
                    {
                        "id": 138741,
                        "name": "Frosinone",
                        "latitude": "41.63976000",
                        "longitude": "13.34109000"
                    },
                    {
                        "id": 138750,
                        "name": "Fumone",
                        "latitude": "41.73461000",
                        "longitude": "13.27015000"
                    },
                    {
                        "id": 138774,
                        "name": "Gaeta",
                        "latitude": "41.21408000",
                        "longitude": "13.57082000"
                    },
                    {
                        "id": 138802,
                        "name": "Gallese",
                        "latitude": "42.37376000",
                        "longitude": "12.39646000"
                    },
                    {
                        "id": 138808,
                        "name": "Gallicano nel Lazio",
                        "latitude": "41.86433000",
                        "longitude": "12.83543000"
                    },
                    {
                        "id": 138811,
                        "name": "Gallinaro",
                        "latitude": "41.65502000",
                        "longitude": "13.79799000"
                    },
                    {
                        "id": 138877,
                        "name": "Gavignano",
                        "latitude": "41.69891000",
                        "longitude": "13.05032000"
                    },
                    {
                        "id": 138895,
                        "name": "Genazzano",
                        "latitude": "41.82807000",
                        "longitude": "12.97196000"
                    },
                    {
                        "id": 138897,
                        "name": "Genio Civile",
                        "latitude": "41.54807000",
                        "longitude": "12.69161000"
                    },
                    {
                        "id": 138904,
                        "name": "Genzano di Roma",
                        "latitude": "41.70706000",
                        "longitude": "12.68904000"
                    },
                    {
                        "id": 138909,
                        "name": "Gerano",
                        "latitude": "41.93474000",
                        "longitude": "12.99034000"
                    },
                    {
                        "id": 138981,
                        "name": "Girardi-Bellavista-Terrazze",
                        "latitude": "42.10266000",
                        "longitude": "12.57960000"
                    },
                    {
                        "id": 138990,
                        "name": "Giulianello",
                        "latitude": "41.68610000",
                        "longitude": "12.87917000"
                    },
                    {
                        "id": 138992,
                        "name": "Giuliano di Roma",
                        "latitude": "41.53933000",
                        "longitude": "13.28028000"
                    },
                    {
                        "id": 139026,
                        "name": "Gorga",
                        "latitude": "41.65468000",
                        "longitude": "13.10663000"
                    },
                    {
                        "id": 139052,
                        "name": "Gradoli",
                        "latitude": "42.64502000",
                        "longitude": "11.85580000"
                    },
                    {
                        "id": 139054,
                        "name": "Graffignano",
                        "latitude": "42.57539000",
                        "longitude": "12.20121000"
                    },
                    {
                        "id": 139120,
                        "name": "Grottaferrata",
                        "latitude": "41.78664000",
                        "longitude": "12.67144000"
                    },
                    {
                        "id": 139127,
                        "name": "Grotte di Castro",
                        "latitude": "42.67567000",
                        "longitude": "11.86908000"
                    },
                    {
                        "id": 139126,
                        "name": "Grotte Santo Stefano",
                        "latitude": "42.51691000",
                        "longitude": "12.17226000"
                    },
                    {
                        "id": 139143,
                        "name": "Grunuovo-Campomaggiore San Luca",
                        "latitude": "41.27228000",
                        "longitude": "13.80684000"
                    },
                    {
                        "id": 139152,
                        "name": "Guarcino",
                        "latitude": "41.79917000",
                        "longitude": "13.31439000"
                    },
                    {
                        "id": 139178,
                        "name": "Guidonia",
                        "latitude": "41.99232000",
                        "longitude": "12.71876000"
                    },
                    {
                        "id": 139179,
                        "name": "Guidonia Montecelio",
                        "latitude": "41.99362000",
                        "longitude": "12.72238000"
                    },
                    {
                        "id": 139229,
                        "name": "Ischia di Castro",
                        "latitude": "42.54420000",
                        "longitude": "11.75759000"
                    },
                    {
                        "id": 139246,
                        "name": "Isola del Liri",
                        "latitude": "41.68678000",
                        "longitude": "13.59679000"
                    },
                    {
                        "id": 139268,
                        "name": "Itri",
                        "latitude": "41.29034000",
                        "longitude": "13.53000000"
                    },
                    {
                        "id": 139275,
                        "name": "Jenne",
                        "latitude": "41.88882000",
                        "longitude": "13.16959000"
                    },
                    {
                        "id": 139286,
                        "name": "La Botte",
                        "latitude": "41.98176000",
                        "longitude": "12.76775000"
                    },
                    {
                        "id": 139291,
                        "name": "La Forma",
                        "latitude": "41.83449000",
                        "longitude": "13.09092000"
                    },
                    {
                        "id": 139296,
                        "name": "La Massimina-Casal Lumbroso",
                        "latitude": "41.87332000",
                        "longitude": "12.35694000"
                    },
                    {
                        "id": 139310,
                        "name": "Labico",
                        "latitude": "41.79260000",
                        "longitude": "12.87127000"
                    },
                    {
                        "id": 139311,
                        "name": "Labro",
                        "latitude": "42.52603000",
                        "longitude": "12.80068000"
                    },
                    {
                        "id": 139318,
                        "name": "Ladispoli",
                        "latitude": "41.95068000",
                        "longitude": "12.07500000"
                    },
                    {
                        "id": 139322,
                        "name": "Laghetto",
                        "latitude": "41.96734000",
                        "longitude": "12.65609000"
                    },
                    {
                        "id": 139361,
                        "name": "Lanuvio",
                        "latitude": "41.67297000",
                        "longitude": "12.69403000"
                    },
                    {
                        "id": 139375,
                        "name": "Lariano",
                        "latitude": "41.71847000",
                        "longitude": "12.82868000"
                    },
                    {
                        "id": 139386,
                        "name": "Latera",
                        "latitude": "42.62922000",
                        "longitude": "11.82922000"
                    },
                    {
                        "id": 139390,
                        "name": "Latina",
                        "latitude": "41.46614000",
                        "longitude": "12.90430000"
                    },
                    {
                        "id": 139391,
                        "name": "Latina Scalo",
                        "latitude": "41.53157000",
                        "longitude": "12.94567000"
                    },
                    {
                        "id": 139417,
                        "name": "Lavinio",
                        "latitude": "41.50350000",
                        "longitude": "12.58973000"
                    },
                    {
                        "id": 139426,
                        "name": "Le Forna",
                        "latitude": "40.92475000",
                        "longitude": "12.96896000"
                    },
                    {
                        "id": 139429,
                        "name": "Le Rughe",
                        "latitude": "42.06885000",
                        "longitude": "12.37624000"
                    },
                    {
                        "id": 139448,
                        "name": "Lenola",
                        "latitude": "41.40485000",
                        "longitude": "13.45934000"
                    },
                    {
                        "id": 139456,
                        "name": "Leonessa",
                        "latitude": "42.56855000",
                        "longitude": "12.95996000"
                    },
                    {
                        "id": 139496,
                        "name": "Licenza",
                        "latitude": "42.07413000",
                        "longitude": "12.90008000"
                    },
                    {
                        "id": 139504,
                        "name": "Lido dei Pini",
                        "latitude": "41.53660000",
                        "longitude": "12.58976000"
                    },
                    {
                        "id": 139507,
                        "name": "Lido di Ostia",
                        "latitude": "41.73212000",
                        "longitude": "12.27654000"
                    },
                    {
                        "id": 139524,
                        "name": "Limiti di Greccio",
                        "latitude": "42.45329000",
                        "longitude": "12.76955000"
                    },
                    {
                        "id": 139599,
                        "name": "Longone Sabino",
                        "latitude": "42.27260000",
                        "longitude": "12.96653000"
                    },
                    {
                        "id": 139628,
                        "name": "Lubriano",
                        "latitude": "42.63623000",
                        "longitude": "12.10876000"
                    },
                    {
                        "id": 139688,
                        "name": "Maccarese",
                        "latitude": "41.87696000",
                        "longitude": "12.21975000"
                    },
                    {
                        "id": 139699,
                        "name": "Macere",
                        "latitude": "41.74873000",
                        "longitude": "12.85835000"
                    },
                    {
                        "id": 139713,
                        "name": "Maenza",
                        "latitude": "41.52402000",
                        "longitude": "13.18344000"
                    },
                    {
                        "id": 139726,
                        "name": "Magliano Romano",
                        "latitude": "42.15750000",
                        "longitude": "12.43662000"
                    },
                    {
                        "id": 139727,
                        "name": "Magliano Sabina",
                        "latitude": "42.36568000",
                        "longitude": "12.48520000"
                    },
                    {
                        "id": 139786,
                        "name": "Mandela",
                        "latitude": "42.02795000",
                        "longitude": "12.92089000"
                    },
                    {
                        "id": 139808,
                        "name": "Mantiglia di Ardea",
                        "latitude": "41.67685000",
                        "longitude": "12.61453000"
                    },
                    {
                        "id": 139813,
                        "name": "Manziana",
                        "latitude": "42.12998000",
                        "longitude": "12.12537000"
                    },
                    {
                        "id": 139821,
                        "name": "Marano Equo",
                        "latitude": "41.99535000",
                        "longitude": "13.01501000"
                    },
                    {
                        "id": 139830,
                        "name": "Maranola-Trivio",
                        "latitude": "41.28522000",
                        "longitude": "13.62777000"
                    },
                    {
                        "id": 139838,
                        "name": "Marcellina",
                        "latitude": "42.02436000",
                        "longitude": "12.80445000"
                    },
                    {
                        "id": 139841,
                        "name": "Marcetelli",
                        "latitude": "42.22663000",
                        "longitude": "13.04589000"
                    },
                    {
                        "id": 139853,
                        "name": "Marco Simone",
                        "latitude": "41.95544000",
                        "longitude": "12.64775000"
                    },
                    {
                        "id": 139877,
                        "name": "Marina di Ardea-Tor San Lorenzo",
                        "latitude": "41.55439000",
                        "longitude": "12.54115000"
                    },
                    {
                        "id": 139883,
                        "name": "Marina di Cerveteri",
                        "latitude": "41.97997000",
                        "longitude": "12.05295000"
                    },
                    {
                        "id": 139874,
                        "name": "Marina San Nicola",
                        "latitude": "41.93102000",
                        "longitude": "12.12024000"
                    },
                    {
                        "id": 139900,
                        "name": "Marino",
                        "latitude": "41.76984000",
                        "longitude": "12.65917000"
                    },
                    {
                        "id": 139925,
                        "name": "Marta",
                        "latitude": "42.53318000",
                        "longitude": "11.92423000"
                    },
                    {
                        "id": 140006,
                        "name": "Mazzano Romano",
                        "latitude": "42.20597000",
                        "longitude": "12.39554000"
                    },
                    {
                        "id": 140065,
                        "name": "Mentana",
                        "latitude": "42.03539000",
                        "longitude": "12.64413000"
                    },
                    {
                        "id": 140130,
                        "name": "Micigliano",
                        "latitude": "42.45203000",
                        "longitude": "13.05318000"
                    },
                    {
                        "id": 140162,
                        "name": "Minturno",
                        "latitude": "41.26294000",
                        "longitude": "13.74583000"
                    },
                    {
                        "id": 140212,
                        "name": "Molella",
                        "latitude": "41.26009000",
                        "longitude": "13.06221000"
                    },
                    {
                        "id": 140246,
                        "name": "Mompeo",
                        "latitude": "42.24780000",
                        "longitude": "12.75130000"
                    },
                    {
                        "id": 140336,
                        "name": "Montalto di Castro",
                        "latitude": "42.34983000",
                        "longitude": "11.60788000"
                    },
                    {
                        "id": 140348,
                        "name": "Montasola",
                        "latitude": "42.38495000",
                        "longitude": "12.68127000"
                    },
                    {
                        "id": 140353,
                        "name": "Monte Caminetto",
                        "latitude": "42.06650000",
                        "longitude": "12.47358000"
                    },
                    {
                        "id": 140362,
                        "name": "Monte Migliore La Selvotta",
                        "latitude": "41.72060000",
                        "longitude": "12.50206000"
                    },
                    {
                        "id": 140364,
                        "name": "Monte Porzio Catone",
                        "latitude": "41.81585000",
                        "longitude": "12.71432000"
                    },
                    {
                        "id": 140367,
                        "name": "Monte Romano",
                        "latitude": "42.26745000",
                        "longitude": "11.89658000"
                    },
                    {
                        "id": 140368,
                        "name": "Monte San Biagio",
                        "latitude": "41.35360000",
                        "longitude": "13.35184000"
                    },
                    {
                        "id": 140371,
                        "name": "Monte San Giovanni Campano",
                        "latitude": "41.64310000",
                        "longitude": "13.51088000"
                    },
                    {
                        "id": 140372,
                        "name": "Monte San Giovanni in Sabina",
                        "latitude": "42.32703000",
                        "longitude": "12.77858000"
                    },
                    {
                        "id": 140374,
                        "name": "Monte San Marino",
                        "latitude": "41.71200000",
                        "longitude": "13.31199000"
                    },
                    {
                        "id": 140394,
                        "name": "Montebuono",
                        "latitude": "42.36770000",
                        "longitude": "12.59721000"
                    },
                    {
                        "id": 140413,
                        "name": "Montecelio",
                        "latitude": "42.02067000",
                        "longitude": "12.74354000"
                    },
                    {
                        "id": 140419,
                        "name": "Montecompatri",
                        "latitude": "41.80892000",
                        "longitude": "12.73778000"
                    },
                    {
                        "id": 140437,
                        "name": "Montefiascone",
                        "latitude": "42.54255000",
                        "longitude": "12.03192000"
                    },
                    {
                        "id": 140442,
                        "name": "Monteflavio",
                        "latitude": "42.10935000",
                        "longitude": "12.83076000"
                    },
                    {
                        "id": 140464,
                        "name": "Montelanico",
                        "latitude": "41.65069000",
                        "longitude": "13.04027000"
                    },
                    {
                        "id": 140466,
                        "name": "Montelarco",
                        "latitude": "42.16339000",
                        "longitude": "12.48398000"
                    },
                    {
                        "id": 140468,
                        "name": "Monteleone Sabino",
                        "latitude": "42.23267000",
                        "longitude": "12.85828000"
                    },
                    {
                        "id": 140475,
                        "name": "Montelibretti",
                        "latitude": "42.13553000",
                        "longitude": "12.73868000"
                    },
                    {
                        "id": 140501,
                        "name": "Montenero Sabino",
                        "latitude": "42.28123000",
                        "longitude": "12.81358000"
                    },
                    {
                        "id": 140521,
                        "name": "Monterosi",
                        "latitude": "42.19698000",
                        "longitude": "12.30842000"
                    },
                    {
                        "id": 140526,
                        "name": "Monterotondo",
                        "latitude": "42.05159000",
                        "longitude": "12.61969000"
                    },
                    {
                        "id": 140581,
                        "name": "Montopoli in Sabina",
                        "latitude": "42.24593000",
                        "longitude": "12.69208000"
                    },
                    {
                        "id": 140585,
                        "name": "Montorio Romano",
                        "latitude": "42.13738000",
                        "longitude": "12.80404000"
                    },
                    {
                        "id": 140617,
                        "name": "Moricone",
                        "latitude": "42.11661000",
                        "longitude": "12.77234000"
                    },
                    {
                        "id": 140622,
                        "name": "Morlupo",
                        "latitude": "42.15002000",
                        "longitude": "12.50306000"
                    },
                    {
                        "id": 140629,
                        "name": "Morolo",
                        "latitude": "41.63838000",
                        "longitude": "13.19809000"
                    },
                    {
                        "id": 140632,
                        "name": "Morro Reatino",
                        "latitude": "42.52226000",
                        "longitude": "12.83449000"
                    },
                    {
                        "id": 140733,
                        "name": "Nazzano",
                        "latitude": "42.23018000",
                        "longitude": "12.59440000"
                    },
                    {
                        "id": 140740,
                        "name": "Nemi",
                        "latitude": "41.72185000",
                        "longitude": "12.71809000"
                    },
                    {
                        "id": 140744,
                        "name": "Nepi",
                        "latitude": "42.24221000",
                        "longitude": "12.34355000"
                    },
                    {
                        "id": 140747,
                        "name": "Nerola",
                        "latitude": "42.16011000",
                        "longitude": "12.78529000"
                    },
                    {
                        "id": 140750,
                        "name": "Nespolo",
                        "latitude": "42.15671000",
                        "longitude": "13.06938000"
                    },
                    {
                        "id": 140753,
                        "name": "Nettuno",
                        "latitude": "41.45794000",
                        "longitude": "12.66393000"
                    },
                    {
                        "id": 140808,
                        "name": "Norma",
                        "latitude": "41.58643000",
                        "longitude": "12.97073000"
                    },
                    {
                        "id": 140889,
                        "name": "Olevano Romano",
                        "latitude": "41.85869000",
                        "longitude": "13.03601000"
                    },
                    {
                        "id": 140920,
                        "name": "Onano",
                        "latitude": "42.69104000",
                        "longitude": "11.81552000"
                    },
                    {
                        "id": 140959,
                        "name": "Oriolo Romano",
                        "latitude": "42.16261000",
                        "longitude": "12.13859000"
                    },
                    {
                        "id": 140981,
                        "name": "Orte",
                        "latitude": "42.46117000",
                        "longitude": "12.38635000"
                    },
                    {
                        "id": 140982,
                        "name": "Orte Scalo",
                        "latitude": "42.43483000",
                        "longitude": "12.40783000"
                    },
                    {
                        "id": 140995,
                        "name": "Orvinio",
                        "latitude": "42.13039000",
                        "longitude": "12.93762000"
                    },
                    {
                        "id": 141036,
                        "name": "Osteria Nuova",
                        "latitude": "42.03721000",
                        "longitude": "12.30924000"
                    },
                    {
                        "id": 58202,
                        "name": "Paganico Sabino",
                        "latitude": "42.18963000",
                        "longitude": "12.99689000"
                    },
                    {
                        "id": 58241,
                        "name": "Palestrina",
                        "latitude": "41.83274000",
                        "longitude": "12.88178000"
                    },
                    {
                        "id": 58243,
                        "name": "Paliano",
                        "latitude": "41.77975000",
                        "longitude": "13.07661000"
                    },
                    {
                        "id": 58263,
                        "name": "Palombara Sabina",
                        "latitude": "42.06909000",
                        "longitude": "12.76684000"
                    },
                    {
                        "id": 58299,
                        "name": "Parco Leonardo",
                        "latitude": "41.80035000",
                        "longitude": "12.30028000"
                    },
                    {
                        "id": 58335,
                        "name": "Passoscuro",
                        "latitude": "41.90209000",
                        "longitude": "12.15723000"
                    },
                    {
                        "id": 58337,
                        "name": "Pastena",
                        "latitude": "41.46842000",
                        "longitude": "13.49111000"
                    },
                    {
                        "id": 58348,
                        "name": "Patrica",
                        "latitude": "41.59085000",
                        "longitude": "13.24363000"
                    },
                    {
                        "id": 58362,
                        "name": "Pavona",
                        "latitude": "41.72629000",
                        "longitude": "12.61642000"
                    },
                    {
                        "id": 58401,
                        "name": "Penitro",
                        "latitude": "41.27328000",
                        "longitude": "13.69262000"
                    },
                    {
                        "id": 58414,
                        "name": "Percile",
                        "latitude": "42.09497000",
                        "longitude": "12.91048000"
                    },
                    {
                        "id": 58458,
                        "name": "Pescia Romana",
                        "latitude": "42.39963000",
                        "longitude": "11.49651000"
                    },
                    {
                        "id": 58465,
                        "name": "Pescorocchiano",
                        "latitude": "42.20623000",
                        "longitude": "13.14715000"
                    },
                    {
                        "id": 58467,
                        "name": "Pescosolido",
                        "latitude": "41.74864000",
                        "longitude": "13.65690000"
                    },
                    {
                        "id": 58479,
                        "name": "Petrella Salto",
                        "latitude": "42.29405000",
                        "longitude": "13.06794000"
                    },
                    {
                        "id": 58551,
                        "name": "Piansano",
                        "latitude": "42.52449000",
                        "longitude": "11.82978000"
                    },
                    {
                        "id": 58581,
                        "name": "Picinisco",
                        "latitude": "41.64568000",
                        "longitude": "13.86791000"
                    },
                    {
                        "id": 58582,
                        "name": "Pico",
                        "latitude": "41.45025000",
                        "longitude": "13.55894000"
                    },
                    {
                        "id": 58591,
                        "name": "Piedimonte San Germano",
                        "latitude": "41.49796000",
                        "longitude": "13.75017000"
                    },
                    {
                        "id": 58592,
                        "name": "Piedimonte San Germano Alta",
                        "latitude": "41.50446000",
                        "longitude": "13.74909000"
                    },
                    {
                        "id": 58659,
                        "name": "Piglio",
                        "latitude": "41.83006000",
                        "longitude": "13.13330000"
                    },
                    {
                        "id": 58661,
                        "name": "Pignataro Interamna",
                        "latitude": "41.43922000",
                        "longitude": "13.78621000"
                    },
                    {
                        "id": 58712,
                        "name": "Pisoniano",
                        "latitude": "41.90816000",
                        "longitude": "12.95794000"
                    },
                    {
                        "id": 58746,
                        "name": "Pofi",
                        "latitude": "41.56542000",
                        "longitude": "13.41460000"
                    },
                    {
                        "id": 58752,
                        "name": "Poggio Bustone",
                        "latitude": "42.50330000",
                        "longitude": "12.88524000"
                    },
                    {
                        "id": 58753,
                        "name": "Poggio Catino",
                        "latitude": "42.29420000",
                        "longitude": "12.69838000"
                    },
                    {
                        "id": 58754,
                        "name": "Poggio Ellera",
                        "latitude": "42.11380000",
                        "longitude": "12.37174000"
                    },
                    {
                        "id": 58756,
                        "name": "Poggio Mirteto",
                        "latitude": "42.26763000",
                        "longitude": "12.68837000"
                    },
                    {
                        "id": 58757,
                        "name": "Poggio Moiano",
                        "latitude": "42.20411000",
                        "longitude": "12.88136000"
                    },
                    {
                        "id": 58758,
                        "name": "Poggio Nativo",
                        "latitude": "42.21783000",
                        "longitude": "12.79691000"
                    },
                    {
                        "id": 58762,
                        "name": "Poggio San Lorenzo",
                        "latitude": "42.25174000",
                        "longitude": "12.84343000"
                    },
                    {
                        "id": 58786,
                        "name": "Poli",
                        "latitude": "41.88913000",
                        "longitude": "12.89037000"
                    },
                    {
                        "id": 58815,
                        "name": "Pomezia",
                        "latitude": "41.66931000",
                        "longitude": "12.50124000"
                    },
                    {
                        "id": 58840,
                        "name": "Ponte Galeria-La Pisana",
                        "latitude": "41.84634000",
                        "longitude": "12.33925000"
                    },
                    {
                        "id": 58866,
                        "name": "Pontecorvo",
                        "latitude": "41.45861000",
                        "longitude": "13.66618000"
                    },
                    {
                        "id": 58888,
                        "name": "Pontinia",
                        "latitude": "41.41097000",
                        "longitude": "13.04259000"
                    },
                    {
                        "id": 58892,
                        "name": "Ponton dell'Elce",
                        "latitude": "42.02270000",
                        "longitude": "12.23505000"
                    },
                    {
                        "id": 58894,
                        "name": "Ponza",
                        "latitude": "40.89541000",
                        "longitude": "12.95889000"
                    },
                    {
                        "id": 58897,
                        "name": "Ponzano Romano",
                        "latitude": "42.25693000",
                        "longitude": "12.57047000"
                    },
                    {
                        "id": 58958,
                        "name": "Posta",
                        "latitude": "42.52562000",
                        "longitude": "13.09723000"
                    },
                    {
                        "id": 58959,
                        "name": "Posta Fibreno",
                        "latitude": "41.69189000",
                        "longitude": "13.68013000"
                    },
                    {
                        "id": 58975,
                        "name": "Pozzaglia Sabino",
                        "latitude": "42.15863000",
                        "longitude": "12.96428000"
                    },
                    {
                        "id": 59032,
                        "name": "Prato di Coppola",
                        "latitude": "41.41750000",
                        "longitude": "12.88157000"
                    },
                    {
                        "id": 59083,
                        "name": "Priverno",
                        "latitude": "41.47047000",
                        "longitude": "13.17867000"
                    },
                    {
                        "id": 59085,
                        "name": "Proceno",
                        "latitude": "42.75745000",
                        "longitude": "11.82900000"
                    },
                    {
                        "id": 59094,
                        "name": "Prossedi",
                        "latitude": "41.51674000",
                        "longitude": "13.26100000"
                    },
                    {
                        "id": 59133,
                        "name": "Provincia di Frosinone",
                        "latitude": "41.61667000",
                        "longitude": "13.45000000"
                    },
                    {
                        "id": 59140,
                        "name": "Provincia di Latina",
                        "latitude": "41.45000000",
                        "longitude": "13.10000000"
                    },
                    {
                        "id": 59169,
                        "name": "Provincia di Rieti",
                        "latitude": "42.39133000",
                        "longitude": "12.95072000"
                    },
                    {
                        "id": 59190,
                        "name": "Provincia di Viterbo",
                        "latitude": "42.41667000",
                        "longitude": "12.08333000"
                    },
                    {
                        "id": 59324,
                        "name": "Regolelli",
                        "latitude": "42.29315000",
                        "longitude": "12.35131000"
                    },
                    {
                        "id": 59357,
                        "name": "Riano",
                        "latitude": "42.09347000",
                        "longitude": "12.51462000"
                    },
                    {
                        "id": 59374,
                        "name": "Rieti",
                        "latitude": "42.40476000",
                        "longitude": "12.85735000"
                    },
                    {
                        "id": 59377,
                        "name": "Rignano Flaminio",
                        "latitude": "42.20550000",
                        "longitude": "12.48068000"
                    },
                    {
                        "id": 59391,
                        "name": "Riofreddo",
                        "latitude": "42.05875000",
                        "longitude": "12.99661000"
                    },
                    {
                        "id": 59411,
                        "name": "Ripi",
                        "latitude": "41.61366000",
                        "longitude": "13.42400000"
                    },
                    {
                        "id": 59440,
                        "name": "Rivodutri",
                        "latitude": "42.51684000",
                        "longitude": "12.85595000"
                    },
                    {
                        "id": 59466,
                        "name": "Rocca Canterano",
                        "latitude": "41.95652000",
                        "longitude": "13.02179000"
                    },
                    {
                        "id": 59482,
                        "name": "Rocca d'Arce",
                        "latitude": "41.58712000",
                        "longitude": "13.58511000"
                    },
                    {
                        "id": 59486,
                        "name": "Rocca di Cave",
                        "latitude": "41.84589000",
                        "longitude": "12.94509000"
                    },
                    {
                        "id": 59489,
                        "name": "Rocca di Papa",
                        "latitude": "41.76580000",
                        "longitude": "12.70188000"
                    },
                    {
                        "id": 59472,
                        "name": "Rocca Massima",
                        "latitude": "41.67907000",
                        "longitude": "12.92116000"
                    },
                    {
                        "id": 59475,
                        "name": "Rocca Priora",
                        "latitude": "41.76585000",
                        "longitude": "12.76577000"
                    },
                    {
                        "id": 59479,
                        "name": "Rocca Santo Stefano",
                        "latitude": "41.91052000",
                        "longitude": "13.02379000"
                    },
                    {
                        "id": 59480,
                        "name": "Rocca Sinibalda",
                        "latitude": "42.27215000",
                        "longitude": "12.92469000"
                    },
                    {
                        "id": 59502,
                        "name": "Roccagiovine",
                        "latitude": "42.05069000",
                        "longitude": "12.89925000"
                    },
                    {
                        "id": 59504,
                        "name": "Roccagorga",
                        "latitude": "41.52511000",
                        "longitude": "13.15510000"
                    },
                    {
                        "id": 59512,
                        "name": "Roccantica",
                        "latitude": "42.32073000",
                        "longitude": "12.69398000"
                    },
                    {
                        "id": 59519,
                        "name": "Roccasecca",
                        "latitude": "41.55132000",
                        "longitude": "13.66711000"
                    },
                    {
                        "id": 59521,
                        "name": "Roccasecca dei Volsci",
                        "latitude": "41.47852000",
                        "longitude": "13.21280000"
                    },
                    {
                        "id": 59520,
                        "name": "Roccasecca Stazione",
                        "latitude": "41.53333000",
                        "longitude": "13.65000000"
                    },
                    {
                        "id": 59566,
                        "name": "Roiate",
                        "latitude": "41.87332000",
                        "longitude": "13.06627000"
                    },
                    {
                        "id": 59582,
                        "name": "Rome",
                        "latitude": "41.89193000",
                        "longitude": "12.51133000"
                    },
                    {
                        "id": 59599,
                        "name": "Ronciglione",
                        "latitude": "42.28899000",
                        "longitude": "12.21479000"
                    },
                    {
                        "id": 59684,
                        "name": "Roviano",
                        "latitude": "42.02643000",
                        "longitude": "12.99390000"
                    },
                    {
                        "id": 59711,
                        "name": "Sabaudia",
                        "latitude": "41.30025000",
                        "longitude": "13.02815000"
                    },
                    {
                        "id": 59721,
                        "name": "Sacrofano",
                        "latitude": "42.10457000",
                        "longitude": "12.44781000"
                    },
                    {
                        "id": 59774,
                        "name": "Salisano",
                        "latitude": "42.25947000",
                        "longitude": "12.74774000"
                    },
                    {
                        "id": 59807,
                        "name": "Sambuci",
                        "latitude": "41.98536000",
                        "longitude": "12.93817000"
                    },
                    {
                        "id": 59817,
                        "name": "San Bartolomeo",
                        "latitude": "41.48265000",
                        "longitude": "13.85747000"
                    },
                    {
                        "id": 59842,
                        "name": "San Biagio Saracinisco",
                        "latitude": "41.61322000",
                        "longitude": "13.92758000"
                    },
                    {
                        "id": 59863,
                        "name": "San Cesareo",
                        "latitude": "41.82113000",
                        "longitude": "12.80447000"
                    },
                    {
                        "id": 59897,
                        "name": "San Donato Val di Comino",
                        "latitude": "41.70726000",
                        "longitude": "13.81220000"
                    },
                    {
                        "id": 59909,
                        "name": "San Felice Circeo",
                        "latitude": "41.23716000",
                        "longitude": "13.09416000"
                    },
                    {
                        "id": 59964,
                        "name": "San Giorgio a Liri",
                        "latitude": "41.40584000",
                        "longitude": "13.75979000"
                    },
                    {
                        "id": 59985,
                        "name": "San Giovanni Incarico",
                        "latitude": "41.50001000",
                        "longitude": "13.55864000"
                    },
                    {
                        "id": 60002,
                        "name": "San Giovanni-Patoni",
                        "latitude": "41.77223000",
                        "longitude": "13.27510000"
                    },
                    {
                        "id": 60014,
                        "name": "San Giuseppe le Prata-Cotropagno",
                        "latitude": "41.67788000",
                        "longitude": "13.39664000"
                    },
                    {
                        "id": 60023,
                        "name": "San Gregorio da Sassola",
                        "latitude": "41.91881000",
                        "longitude": "12.87447000"
                    },
                    {
                        "id": 60043,
                        "name": "San Lorenzo Nuovo",
                        "latitude": "42.68626000",
                        "longitude": "11.90718000"
                    },
                    {
                        "id": 60079,
                        "name": "San Martino al Cimino",
                        "latitude": "42.36978000",
                        "longitude": "12.12515000"
                    },
                    {
                        "id": 60206,
                        "name": "San Polo dei Cavalieri",
                        "latitude": "42.01037000",
                        "longitude": "12.83989000"
                    },
                    {
                        "id": 60277,
                        "name": "San Vito Romano",
                        "latitude": "41.88001000",
                        "longitude": "12.97793000"
                    },
                    {
                        "id": 60288,
                        "name": "San Vittore del Lazio",
                        "latitude": "41.46212000",
                        "longitude": "13.93367000"
                    },
                    {
                        "id": 60339,
                        "name": "Sant'Ambrogio sul Garigliano",
                        "latitude": "41.39423000",
                        "longitude": "13.86891000"
                    },
                    {
                        "id": 60347,
                        "name": "Sant'Andrea del Garigliano",
                        "latitude": "41.36868000",
                        "longitude": "13.84198000"
                    },
                    {
                        "id": 60371,
                        "name": "Sant'Angelo in Villa-Giglio",
                        "latitude": "41.66217000",
                        "longitude": "13.42871000"
                    },
                    {
                        "id": 60361,
                        "name": "Sant'Angelo Romano",
                        "latitude": "42.03570000",
                        "longitude": "12.71342000"
                    },
                    {
                        "id": 60385,
                        "name": "Sant'Apollinare",
                        "latitude": "41.40176000",
                        "longitude": "13.82992000"
                    },
                    {
                        "id": 60397,
                        "name": "Sant'Elia Fiumerapido",
                        "latitude": "41.53304000",
                        "longitude": "13.86268000"
                    },
                    {
                        "id": 60410,
                        "name": "Sant'Oreste",
                        "latitude": "42.23298000",
                        "longitude": "12.51507000"
                    },
                    {
                        "id": 60446,
                        "name": "Santa Lucia",
                        "latitude": "41.98240000",
                        "longitude": "12.65625000"
                    },
                    {
                        "id": 60484,
                        "name": "Santa Marinella",
                        "latitude": "42.03425000",
                        "longitude": "11.85416000"
                    },
                    {
                        "id": 60489,
                        "name": "Santa Rufina",
                        "latitude": "42.40897000",
                        "longitude": "12.91843000"
                    },
                    {
                        "id": 60509,
                        "name": "Santi Cosma e Damiano",
                        "latitude": "41.30091000",
                        "longitude": "13.81565000"
                    },
                    {
                        "id": 60529,
                        "name": "Santopadre",
                        "latitude": "41.60193000",
                        "longitude": "13.63548000"
                    },
                    {
                        "id": 60540,
                        "name": "Saracinesco",
                        "latitude": "42.00332000",
                        "longitude": "12.95329000"
                    },
                    {
                        "id": 60566,
                        "name": "Sassacci",
                        "latitude": "42.32342000",
                        "longitude": "12.44108000"
                    },
                    {
                        "id": 60620,
                        "name": "Scandriglia",
                        "latitude": "42.16128000",
                        "longitude": "12.84096000"
                    },
                    {
                        "id": 60689,
                        "name": "Segni",
                        "latitude": "41.68893000",
                        "longitude": "13.01934000"
                    },
                    {
                        "id": 60694,
                        "name": "Selcetta",
                        "latitude": "41.76529000",
                        "longitude": "12.47533000"
                    },
                    {
                        "id": 60695,
                        "name": "Selci",
                        "latitude": "42.30293000",
                        "longitude": "12.62135000"
                    },
                    {
                        "id": 60745,
                        "name": "Sermoneta",
                        "latitude": "41.54919000",
                        "longitude": "12.98481000"
                    },
                    {
                        "id": 60783,
                        "name": "Serrone",
                        "latitude": "41.84212000",
                        "longitude": "13.09519000"
                    },
                    {
                        "id": 60807,
                        "name": "Settefrati",
                        "latitude": "41.67045000",
                        "longitude": "13.85070000"
                    },
                    {
                        "id": 60808,
                        "name": "Setteville",
                        "latitude": "41.94375000",
                        "longitude": "12.65122000"
                    },
                    {
                        "id": 60824,
                        "name": "Sezze",
                        "latitude": "41.50032000",
                        "longitude": "13.06176000"
                    },
                    {
                        "id": 60825,
                        "name": "Sezze Scalo",
                        "latitude": "41.49701000",
                        "longitude": "13.04257000"
                    },
                    {
                        "id": 60832,
                        "name": "Sgurgola",
                        "latitude": "41.66897000",
                        "longitude": "13.15009000"
                    },
                    {
                        "id": 60941,
                        "name": "Sonnino",
                        "latitude": "41.41673000",
                        "longitude": "13.24592000"
                    },
                    {
                        "id": 60944,
                        "name": "Sora",
                        "latitude": "41.71829000",
                        "longitude": "13.61356000"
                    },
                    {
                        "id": 60960,
                        "name": "Soriano nel Cimino",
                        "latitude": "42.41820000",
                        "longitude": "12.23414000"
                    },
                    {
                        "id": 60998,
                        "name": "Sperlonga",
                        "latitude": "41.25897000",
                        "longitude": "13.43302000"
                    },
                    {
                        "id": 61008,
                        "name": "Spigno Saturnia Inferiore",
                        "latitude": "41.31146000",
                        "longitude": "13.73685000"
                    },
                    {
                        "id": 61009,
                        "name": "Spigno Saturnia Superiore",
                        "latitude": "41.31425000",
                        "longitude": "13.70888000"
                    },
                    {
                        "id": 61076,
                        "name": "Stimigliano",
                        "latitude": "42.30103000",
                        "longitude": "12.56337000"
                    },
                    {
                        "id": 61089,
                        "name": "Strangolagalli",
                        "latitude": "41.59992000",
                        "longitude": "13.49228000"
                    },
                    {
                        "id": 61109,
                        "name": "Subiaco",
                        "latitude": "41.92619000",
                        "longitude": "13.08906000"
                    },
                    {
                        "id": 61124,
                        "name": "Supino",
                        "latitude": "41.62135000",
                        "longitude": "13.23452000"
                    },
                    {
                        "id": 61133,
                        "name": "Sutri",
                        "latitude": "42.24596000",
                        "longitude": "12.21715000"
                    },
                    {
                        "id": 61162,
                        "name": "Tarano",
                        "latitude": "42.35593000",
                        "longitude": "12.59497000"
                    },
                    {
                        "id": 61167,
                        "name": "Tarquinia",
                        "latitude": "42.25419000",
                        "longitude": "11.75657000"
                    },
                    {
                        "id": 61200,
                        "name": "Tecchiena",
                        "latitude": "41.68822000",
                        "longitude": "13.34538000"
                    },
                    {
                        "id": 61219,
                        "name": "Terelle",
                        "latitude": "41.55212000",
                        "longitude": "13.77841000"
                    },
                    {
                        "id": 61235,
                        "name": "Terracina",
                        "latitude": "41.29174000",
                        "longitude": "13.24359000"
                    },
                    {
                        "id": 61262,
                        "name": "Tessennano",
                        "latitude": "42.47803000",
                        "longitude": "11.79101000"
                    },
                    {
                        "id": 61288,
                        "name": "Tivoli",
                        "latitude": "41.95952000",
                        "longitude": "12.80160000"
                    },
                    {
                        "id": 61296,
                        "name": "Toffia",
                        "latitude": "42.21300000",
                        "longitude": "12.75500000"
                    },
                    {
                        "id": 61299,
                        "name": "Tolfa",
                        "latitude": "42.15023000",
                        "longitude": "11.93216000"
                    },
                    {
                        "id": 61314,
                        "name": "Tor Lupara",
                        "latitude": "41.99771000",
                        "longitude": "12.61814000"
                    },
                    {
                        "id": 61351,
                        "name": "Torre Caietani",
                        "latitude": "41.78672000",
                        "longitude": "13.26520000"
                    },
                    {
                        "id": 61396,
                        "name": "Torri in Sabina",
                        "latitude": "42.35057000",
                        "longitude": "12.64157000"
                    },
                    {
                        "id": 61398,
                        "name": "Torrice",
                        "latitude": "41.63374000",
                        "longitude": "13.40375000"
                    },
                    {
                        "id": 61404,
                        "name": "Torricella in Sabina",
                        "latitude": "42.26252000",
                        "longitude": "12.87170000"
                    },
                    {
                        "id": 61409,
                        "name": "Torrita Tiberina",
                        "latitude": "42.23821000",
                        "longitude": "12.61633000"
                    },
                    {
                        "id": 61419,
                        "name": "Torvaianica",
                        "latitude": "41.62112000",
                        "longitude": "12.46197000"
                    },
                    {
                        "id": 61420,
                        "name": "Torvaianica Alta",
                        "latitude": "41.63162000",
                        "longitude": "12.49765000"
                    },
                    {
                        "id": 61429,
                        "name": "Tragliatella Campitello",
                        "latitude": "42.01334000",
                        "longitude": "12.25200000"
                    },
                    {
                        "id": 61502,
                        "name": "Trevi nel Lazio",
                        "latitude": "41.86258000",
                        "longitude": "13.24793000"
                    },
                    {
                        "id": 61506,
                        "name": "Trevignano Romano",
                        "latitude": "42.16020000",
                        "longitude": "12.23775000"
                    },
                    {
                        "id": 61541,
                        "name": "Trivigliano",
                        "latitude": "41.77572000",
                        "longitude": "13.27230000"
                    },
                    {
                        "id": 61570,
                        "name": "Turania",
                        "latitude": "42.13517000",
                        "longitude": "13.00983000"
                    },
                    {
                        "id": 61581,
                        "name": "Tuscania",
                        "latitude": "42.41889000",
                        "longitude": "11.86846000"
                    },
                    {
                        "id": 61625,
                        "name": "Vacone",
                        "latitude": "42.38100000",
                        "longitude": "12.64504000"
                    },
                    {
                        "id": 61648,
                        "name": "Valcanneto",
                        "latitude": "41.95078000",
                        "longitude": "12.15734000"
                    },
                    {
                        "id": 61662,
                        "name": "Valentano",
                        "latitude": "42.56377000",
                        "longitude": "11.82748000"
                    },
                    {
                        "id": 61688,
                        "name": "Valle Martella",
                        "latitude": "41.87827000",
                        "longitude": "12.74677000"
                    },
                    {
                        "id": 61693,
                        "name": "Valle Santa",
                        "latitude": "41.94532000",
                        "longitude": "12.31971000"
                    },
                    {
                        "id": 61702,
                        "name": "Vallecorsa",
                        "latitude": "41.44351000",
                        "longitude": "13.40634000"
                    },
                    {
                        "id": 61711,
                        "name": "Vallemaio",
                        "latitude": "41.36628000",
                        "longitude": "13.80839000"
                    },
                    {
                        "id": 61712,
                        "name": "Vallepietra",
                        "latitude": "41.92552000",
                        "longitude": "13.23127000"
                    },
                    {
                        "id": 61713,
                        "name": "Vallerano",
                        "latitude": "42.38331000",
                        "longitude": "12.26144000"
                    },
                    {
                        "id": 61715,
                        "name": "Vallerotonda",
                        "latitude": "41.55135000",
                        "longitude": "13.91372000"
                    },
                    {
                        "id": 61721,
                        "name": "Vallinfreda",
                        "latitude": "42.08485000",
                        "longitude": "12.99595000"
                    },
                    {
                        "id": 61732,
                        "name": "Valmontone",
                        "latitude": "41.77323000",
                        "longitude": "12.91856000"
                    },
                    {
                        "id": 61765,
                        "name": "Varco Sabino",
                        "latitude": "42.24016000",
                        "longitude": "13.02052000"
                    },
                    {
                        "id": 61778,
                        "name": "Vasanello",
                        "latitude": "42.41507000",
                        "longitude": "12.34767000"
                    },
                    {
                        "id": 61798,
                        "name": "Vejano",
                        "latitude": "42.21905000",
                        "longitude": "12.09398000"
                    },
                    {
                        "id": 61802,
                        "name": "Velletri",
                        "latitude": "41.68573000",
                        "longitude": "12.77753000"
                    },
                    {
                        "id": 61828,
                        "name": "Ventotene",
                        "latitude": "40.79404000",
                        "longitude": "13.42777000"
                    },
                    {
                        "id": 61862,
                        "name": "Veroli",
                        "latitude": "41.69433000",
                        "longitude": "13.41664000"
                    },
                    {
                        "id": 61890,
                        "name": "Vetralla",
                        "latitude": "42.31787000",
                        "longitude": "12.07323000"
                    },
                    {
                        "id": 61909,
                        "name": "Vicalvi",
                        "latitude": "41.67809000",
                        "longitude": "13.70813000"
                    },
                    {
                        "id": 61919,
                        "name": "Vico nel Lazio",
                        "latitude": "41.77822000",
                        "longitude": "13.34279000"
                    },
                    {
                        "id": 61926,
                        "name": "Vicovaro",
                        "latitude": "42.01924000",
                        "longitude": "12.90001000"
                    },
                    {
                        "id": 61958,
                        "name": "Vignanello",
                        "latitude": "42.37879000",
                        "longitude": "12.27845000"
                    },
                    {
                        "id": 61984,
                        "name": "Villa Adriana",
                        "latitude": "41.95499000",
                        "longitude": "12.77216000"
                    },
                    {
                        "id": 62002,
                        "name": "Villa Latina",
                        "latitude": "41.61522000",
                        "longitude": "13.83591000"
                    },
                    {
                        "id": 62018,
                        "name": "Villa San Giovanni in Tuscia",
                        "latitude": "42.27882000",
                        "longitude": "12.05346000"
                    },
                    {
                        "id": 62024,
                        "name": "Villa Santa Lucia",
                        "latitude": "41.51217000",
                        "longitude": "13.76929000"
                    },
                    {
                        "id": 62028,
                        "name": "Villa Santo Stefano",
                        "latitude": "41.51683000",
                        "longitude": "13.31046000"
                    },
                    {
                        "id": 62077,
                        "name": "Villalba",
                        "latitude": "41.95387000",
                        "longitude": "12.72938000"
                    },
                    {
                        "id": 62095,
                        "name": "Villanova",
                        "latitude": "41.96357000",
                        "longitude": "12.75633000"
                    },
                    {
                        "id": 62179,
                        "name": "Viterbo",
                        "latitude": "42.41937000",
                        "longitude": "12.10560000"
                    },
                    {
                        "id": 62180,
                        "name": "Viticuso",
                        "latitude": "41.52475000",
                        "longitude": "13.97027000"
                    },
                    {
                        "id": 62182,
                        "name": "Vitinia",
                        "latitude": "41.79124000",
                        "longitude": "12.40810000"
                    },
                    {
                        "id": 62183,
                        "name": "Vitorchiano",
                        "latitude": "42.46565000",
                        "longitude": "12.17151000"
                    },
                    {
                        "id": 62191,
                        "name": "Vivaro Romano",
                        "latitude": "42.10095000",
                        "longitude": "13.00589000"
                    },
                    {
                        "id": 62231,
                        "name": "Zagarolo",
                        "latitude": "41.84159000",
                        "longitude": "12.81540000"
                    },
                    {
                        "id": 62248,
                        "name": "Zepponami",
                        "latitude": "42.52518000",
                        "longitude": "12.05411000"
                    }
                ]
            },
            {
                "id": 1675,
                "name": "Lecce",
                "iso2": "LE",
                "latitude": "40.23473930",
                "longitude": "18.14286690",
                "type": "province",
                "cities": []
            },
            {
                "id": 1677,
                "name": "Lecco",
                "iso2": "LC",
                "latitude": "45.93829410",
                "longitude": "9.38572900",
                "type": "province",
                "cities": []
            },
            {
                "id": 1768,
                "name": "Liguria",
                "iso2": "42",
                "latitude": "44.31679170",
                "longitude": "8.39649380",
                "type": "region",
                "cities": [
                    {
                        "id": 135335,
                        "name": "Airole",
                        "latitude": "43.87092000",
                        "longitude": "7.55414000"
                    },
                    {
                        "id": 135344,
                        "name": "Alassio",
                        "latitude": "44.00393000",
                        "longitude": "8.16713000"
                    },
                    {
                        "id": 135362,
                        "name": "Albenga",
                        "latitude": "44.04997000",
                        "longitude": "8.21829000"
                    },
                    {
                        "id": 135381,
                        "name": "Albisola Marina",
                        "latitude": "44.33079000",
                        "longitude": "8.50960000"
                    },
                    {
                        "id": 135382,
                        "name": "Albisola Superiore",
                        "latitude": "44.33889000",
                        "longitude": "8.51046000"
                    },
                    {
                        "id": 135431,
                        "name": "Altare",
                        "latitude": "44.33566000",
                        "longitude": "8.33411000"
                    },
                    {
                        "id": 135467,
                        "name": "Ameglia",
                        "latitude": "44.07089000",
                        "longitude": "9.96600000"
                    },
                    {
                        "id": 135484,
                        "name": "Andora",
                        "latitude": "43.95514000",
                        "longitude": "8.14121000"
                    },
                    {
                        "id": 135539,
                        "name": "Apricale",
                        "latitude": "43.88033000",
                        "longitude": "7.65993000"
                    },
                    {
                        "id": 135544,
                        "name": "Aquila di Arroscia",
                        "latitude": "44.08593000",
                        "longitude": "8.00525000"
                    },
                    {
                        "id": 135571,
                        "name": "Arcola",
                        "latitude": "44.11778000",
                        "longitude": "9.91175000"
                    },
                    {
                        "id": 135588,
                        "name": "Arenzano",
                        "latitude": "44.40521000",
                        "longitude": "8.68315000"
                    },
                    {
                        "id": 135616,
                        "name": "Armo",
                        "latitude": "44.08773000",
                        "longitude": "7.91545000"
                    },
                    {
                        "id": 135620,
                        "name": "Arnasco",
                        "latitude": "44.07823000",
                        "longitude": "8.10745000"
                    },
                    {
                        "id": 135690,
                        "name": "Aurigo",
                        "latitude": "43.98281000",
                        "longitude": "7.92342000"
                    },
                    {
                        "id": 135697,
                        "name": "Avegno",
                        "latitude": "44.38285000",
                        "longitude": "9.15797000"
                    },
                    {
                        "id": 135732,
                        "name": "Badalucco",
                        "latitude": "43.91683000",
                        "longitude": "7.84584000"
                    },
                    {
                        "id": 135781,
                        "name": "Bajardo",
                        "latitude": "43.90402000",
                        "longitude": "7.72534000"
                    },
                    {
                        "id": 135788,
                        "name": "Balestrino",
                        "latitude": "44.12426000",
                        "longitude": "8.17064000"
                    },
                    {
                        "id": 135841,
                        "name": "Bardineto",
                        "latitude": "44.18972000",
                        "longitude": "8.13529000"
                    },
                    {
                        "id": 135849,
                        "name": "Bargagli",
                        "latitude": "44.44750000",
                        "longitude": "9.09372000"
                    },
                    {
                        "id": 135989,
                        "name": "Bergeggi",
                        "latitude": "44.24833000",
                        "longitude": "8.44402000"
                    },
                    {
                        "id": 136025,
                        "name": "Beverino",
                        "latitude": "44.19766000",
                        "longitude": "9.78537000"
                    },
                    {
                        "id": 136090,
                        "name": "Bocco",
                        "latitude": "44.35111000",
                        "longitude": "9.30333000"
                    },
                    {
                        "id": 136096,
                        "name": "Bogliasco",
                        "latitude": "44.38070000",
                        "longitude": "9.06926000"
                    },
                    {
                        "id": 136098,
                        "name": "Boissano",
                        "latitude": "44.13583000",
                        "longitude": "8.22155000"
                    },
                    {
                        "id": 136101,
                        "name": "Bolano",
                        "latitude": "44.18770000",
                        "longitude": "9.89488000"
                    },
                    {
                        "id": 136124,
                        "name": "Bonassola",
                        "latitude": "44.18323000",
                        "longitude": "9.58422000"
                    },
                    {
                        "id": 136148,
                        "name": "Bordighera",
                        "latitude": "43.78064000",
                        "longitude": "7.66451000"
                    },
                    {
                        "id": 136161,
                        "name": "Borghetto d'Arroscia",
                        "latitude": "44.05672000",
                        "longitude": "7.98076000"
                    },
                    {
                        "id": 136163,
                        "name": "Borghetto di Vara",
                        "latitude": "44.22368000",
                        "longitude": "9.72118000"
                    },
                    {
                        "id": 136160,
                        "name": "Borghetto Santo Spirito",
                        "latitude": "44.11187000",
                        "longitude": "8.24129000"
                    },
                    {
                        "id": 136168,
                        "name": "Borgio",
                        "latitude": "44.15906000",
                        "longitude": "8.30832000"
                    },
                    {
                        "id": 136200,
                        "name": "Borgo di Ranzo",
                        "latitude": "44.05963000",
                        "longitude": "8.01495000"
                    },
                    {
                        "id": 136171,
                        "name": "Borgo Fornari-Pieve",
                        "latitude": "44.58933000",
                        "longitude": "8.93671000"
                    },
                    {
                        "id": 136208,
                        "name": "Borgomaro",
                        "latitude": "43.97530000",
                        "longitude": "7.94408000"
                    },
                    {
                        "id": 136219,
                        "name": "Bormida",
                        "latitude": "44.27813000",
                        "longitude": "8.23235000"
                    },
                    {
                        "id": 136220,
                        "name": "Bormida-Genepro",
                        "latitude": "44.39051000",
                        "longitude": "8.19952000"
                    },
                    {
                        "id": 136235,
                        "name": "Borzonasca",
                        "latitude": "44.42002000",
                        "longitude": "9.38851000"
                    },
                    {
                        "id": 136364,
                        "name": "Brugnato",
                        "latitude": "44.23671000",
                        "longitude": "9.72496000"
                    },
                    {
                        "id": 136418,
                        "name": "Busalla",
                        "latitude": "44.57060000",
                        "longitude": "8.94545000"
                    },
                    {
                        "id": 136483,
                        "name": "Cairo Montenotte",
                        "latitude": "44.39790000",
                        "longitude": "8.27775000"
                    },
                    {
                        "id": 136527,
                        "name": "Calice al Cornoviglio",
                        "latitude": "44.24326000",
                        "longitude": "9.83671000"
                    },
                    {
                        "id": 136526,
                        "name": "Calice Ligure",
                        "latitude": "44.20493000",
                        "longitude": "8.29535000"
                    },
                    {
                        "id": 136530,
                        "name": "Calizzano",
                        "latitude": "44.23612000",
                        "longitude": "8.11817000"
                    },
                    {
                        "id": 136597,
                        "name": "Camogli",
                        "latitude": "44.34945000",
                        "longitude": "9.15487000"
                    },
                    {
                        "id": 136629,
                        "name": "Campo Ligure",
                        "latitude": "44.53658000",
                        "longitude": "8.69896000"
                    },
                    {
                        "id": 136643,
                        "name": "Campochiesa",
                        "latitude": "44.07069000",
                        "longitude": "8.19712000"
                    },
                    {
                        "id": 136670,
                        "name": "Campomorone",
                        "latitude": "44.50954000",
                        "longitude": "8.88502000"
                    },
                    {
                        "id": 136676,
                        "name": "Camporosso",
                        "latitude": "43.81310000",
                        "longitude": "7.62829000"
                    },
                    {
                        "id": 136836,
                        "name": "Carasco",
                        "latitude": "44.34975000",
                        "longitude": "9.34567000"
                    },
                    {
                        "id": 136843,
                        "name": "Caravonica",
                        "latitude": "43.99303000",
                        "longitude": "7.95805000"
                    },
                    {
                        "id": 136853,
                        "name": "Carcare",
                        "latitude": "44.35465000",
                        "longitude": "8.29039000"
                    },
                    {
                        "id": 136908,
                        "name": "Carpasio",
                        "latitude": "43.96024000",
                        "longitude": "7.86631000"
                    },
                    {
                        "id": 136928,
                        "name": "Carro",
                        "latitude": "44.27215000",
                        "longitude": "9.60888000"
                    },
                    {
                        "id": 136929,
                        "name": "Carrodano",
                        "latitude": "44.24155000",
                        "longitude": "9.65578000"
                    },
                    {
                        "id": 137020,
                        "name": "Casano-Dogana-Isola",
                        "latitude": "44.07565000",
                        "longitude": "10.03381000"
                    },
                    {
                        "id": 137023,
                        "name": "Casanova Lerrone",
                        "latitude": "44.03213000",
                        "longitude": "8.04715000"
                    },
                    {
                        "id": 137035,
                        "name": "Casarza Ligure",
                        "latitude": "44.27188000",
                        "longitude": "9.44704000"
                    },
                    {
                        "id": 137042,
                        "name": "Casavecchia",
                        "latitude": "44.52756000",
                        "longitude": "8.62157000"
                    },
                    {
                        "id": 137058,
                        "name": "Casella",
                        "latitude": "44.53523000",
                        "longitude": "9.00080000"
                    },
                    {
                        "id": 137160,
                        "name": "Castel Vittorio",
                        "latitude": "43.92752000",
                        "longitude": "7.67471000"
                    },
                    {
                        "id": 137181,
                        "name": "Castelbianco",
                        "latitude": "44.11423000",
                        "longitude": "8.07515000"
                    },
                    {
                        "id": 137223,
                        "name": "Castellaro",
                        "latitude": "43.86436000",
                        "longitude": "7.86881000"
                    },
                    {
                        "id": 137290,
                        "name": "Castelnuovo Magra",
                        "latitude": "44.09957000",
                        "longitude": "10.01715000"
                    },
                    {
                        "id": 137323,
                        "name": "Castelvecchio di Rocca Barbena",
                        "latitude": "44.12983000",
                        "longitude": "8.11665000"
                    },
                    {
                        "id": 137339,
                        "name": "Castiglione",
                        "latitude": "44.27539000",
                        "longitude": "9.51687000"
                    },
                    {
                        "id": 137474,
                        "name": "Celle Ligure",
                        "latitude": "44.34509000",
                        "longitude": "8.54685000"
                    },
                    {
                        "id": 137493,
                        "name": "Cengio Alto",
                        "latitude": "44.38443000",
                        "longitude": "8.19758000"
                    },
                    {
                        "id": 137506,
                        "name": "Ceparana-Carpena",
                        "latitude": "44.16667000",
                        "longitude": "9.88333000"
                    },
                    {
                        "id": 137513,
                        "name": "Ceranesi",
                        "latitude": "44.50563000",
                        "longitude": "8.89343000"
                    },
                    {
                        "id": 137546,
                        "name": "Ceriale",
                        "latitude": "44.09128000",
                        "longitude": "8.22893000"
                    },
                    {
                        "id": 137547,
                        "name": "Ceriana",
                        "latitude": "43.88091000",
                        "longitude": "7.77476000"
                    },
                    {
                        "id": 137597,
                        "name": "Cervo",
                        "latitude": "43.92572000",
                        "longitude": "8.11529000"
                    },
                    {
                        "id": 137614,
                        "name": "Cesio",
                        "latitude": "44.00803000",
                        "longitude": "7.97515000"
                    },
                    {
                        "id": 137659,
                        "name": "Chiavari",
                        "latitude": "44.31771000",
                        "longitude": "9.32241000"
                    },
                    {
                        "id": 137665,
                        "name": "Chiesa",
                        "latitude": "44.07787000",
                        "longitude": "8.10891000"
                    },
                    {
                        "id": 137666,
                        "name": "Chiesa Nuova",
                        "latitude": "44.36976000",
                        "longitude": "9.31161000"
                    },
                    {
                        "id": 137691,
                        "name": "Chiusanico",
                        "latitude": "43.97303000",
                        "longitude": "7.99185000"
                    },
                    {
                        "id": 137694,
                        "name": "Chiusavecchia",
                        "latitude": "43.96726000",
                        "longitude": "7.98443000"
                    },
                    {
                        "id": 137707,
                        "name": "Cicagna",
                        "latitude": "44.40714000",
                        "longitude": "9.23917000"
                    },
                    {
                        "id": 137745,
                        "name": "Cipressa",
                        "latitude": "43.85205000",
                        "longitude": "7.93144000"
                    },
                    {
                        "id": 137753,
                        "name": "Cisano",
                        "latitude": "44.08565000",
                        "longitude": "8.14829000"
                    },
                    {
                        "id": 137779,
                        "name": "Civezza",
                        "latitude": "43.87982000",
                        "longitude": "7.95165000"
                    },
                    {
                        "id": 137842,
                        "name": "Cogoleto",
                        "latitude": "44.38996000",
                        "longitude": "8.64692000"
                    },
                    {
                        "id": 137845,
                        "name": "Cogorno",
                        "latitude": "44.32074000",
                        "longitude": "9.37117000"
                    },
                    {
                        "id": 137921,
                        "name": "Colombiera-Molicciara",
                        "latitude": "44.08750000",
                        "longitude": "10.01037000"
                    },
                    {
                        "id": 137972,
                        "name": "Conscenti",
                        "latitude": "44.34491000",
                        "longitude": "9.39537000"
                    },
                    {
                        "id": 138006,
                        "name": "Coreglia Ligure",
                        "latitude": "44.38775000",
                        "longitude": "9.26097000"
                    },
                    {
                        "id": 138080,
                        "name": "Cosio di Arroscia",
                        "latitude": "44.07743000",
                        "longitude": "7.83244000"
                    },
                    {
                        "id": 138086,
                        "name": "Cosseria",
                        "latitude": "44.36774000",
                        "longitude": "8.23485000"
                    },
                    {
                        "id": 138106,
                        "name": "Costarainera",
                        "latitude": "43.85477000",
                        "longitude": "7.94106000"
                    },
                    {
                        "id": 138159,
                        "name": "Crocefieschi",
                        "latitude": "44.58077000",
                        "longitude": "9.02360000"
                    },
                    {
                        "id": 138231,
                        "name": "Davagna",
                        "latitude": "44.46585000",
                        "longitude": "9.08666000"
                    },
                    {
                        "id": 138239,
                        "name": "Dego",
                        "latitude": "44.44455000",
                        "longitude": "8.30761000"
                    },
                    {
                        "id": 138240,
                        "name": "Deiva Marina",
                        "latitude": "44.21931000",
                        "longitude": "9.52064000"
                    },
                    {
                        "id": 138260,
                        "name": "Diano Arentino",
                        "latitude": "43.94962000",
                        "longitude": "8.04155000"
                    },
                    {
                        "id": 138261,
                        "name": "Diano Castello",
                        "latitude": "43.92423000",
                        "longitude": "8.06602000"
                    },
                    {
                        "id": 138262,
                        "name": "Diano Marina",
                        "latitude": "43.91088000",
                        "longitude": "8.08029000"
                    },
                    {
                        "id": 138263,
                        "name": "Diano San Pietro",
                        "latitude": "43.92953000",
                        "longitude": "8.07249000"
                    },
                    {
                        "id": 138279,
                        "name": "Dolceacqua",
                        "latitude": "43.84975000",
                        "longitude": "7.62373000"
                    },
                    {
                        "id": 138280,
                        "name": "Dolcedo",
                        "latitude": "43.90735000",
                        "longitude": "7.94943000"
                    },
                    {
                        "id": 138375,
                        "name": "Erli",
                        "latitude": "44.13719000",
                        "longitude": "8.10430000"
                    },
                    {
                        "id": 138455,
                        "name": "Fascia",
                        "latitude": "44.58255000",
                        "longitude": "9.22136000"
                    },
                    {
                        "id": 138458,
                        "name": "Favale di Malvaro",
                        "latitude": "44.45163000",
                        "longitude": "9.26000000"
                    },
                    {
                        "id": 138464,
                        "name": "Feglino",
                        "latitude": "44.21849000",
                        "longitude": "8.32436000"
                    },
                    {
                        "id": 138487,
                        "name": "Ferrada",
                        "latitude": "44.42008000",
                        "longitude": "9.21016000"
                    },
                    {
                        "id": 138497,
                        "name": "Ferriere",
                        "latitude": "44.44302000",
                        "longitude": "9.13675000"
                    },
                    {
                        "id": 138536,
                        "name": "Finale Ligure",
                        "latitude": "44.16952000",
                        "longitude": "8.34360000"
                    },
                    {
                        "id": 138604,
                        "name": "Fontanigorda",
                        "latitude": "44.54540000",
                        "longitude": "9.30548000"
                    },
                    {
                        "id": 138691,
                        "name": "Framura",
                        "latitude": "44.20946000",
                        "longitude": "9.55399000"
                    },
                    {
                        "id": 138860,
                        "name": "Garlenda",
                        "latitude": "44.03325000",
                        "longitude": "8.09546000"
                    },
                    {
                        "id": 138899,
                        "name": "Genoa",
                        "latitude": "44.40478000",
                        "longitude": "8.94439000"
                    },
                    {
                        "id": 138999,
                        "name": "Giustenice",
                        "latitude": "44.17293000",
                        "longitude": "8.24305000"
                    },
                    {
                        "id": 139001,
                        "name": "Giusvalla",
                        "latitude": "44.44794000",
                        "longitude": "8.39415000"
                    },
                    {
                        "id": 139040,
                        "name": "Gorreto",
                        "latitude": "44.60485000",
                        "longitude": "9.29126000"
                    },
                    {
                        "id": 139200,
                        "name": "Imperia",
                        "latitude": "43.88917000",
                        "longitude": "8.03933000"
                    },
                    {
                        "id": 139243,
                        "name": "Isola del Cantone",
                        "latitude": "44.64783000",
                        "longitude": "8.95746000"
                    },
                    {
                        "id": 139253,
                        "name": "Isolabona",
                        "latitude": "43.88076000",
                        "longitude": "7.63993000"
                    },
                    {
                        "id": 139257,
                        "name": "Isoverde",
                        "latitude": "44.52941000",
                        "longitude": "8.86049000"
                    },
                    {
                        "id": 139305,
                        "name": "La Spezia",
                        "latitude": "44.10300000",
                        "longitude": "9.82375000"
                    },
                    {
                        "id": 139330,
                        "name": "Laigueglia",
                        "latitude": "43.97590000",
                        "longitude": "8.15823000"
                    },
                    {
                        "id": 139408,
                        "name": "Lavagna",
                        "latitude": "44.30620000",
                        "longitude": "9.35383000"
                    },
                    {
                        "id": 139427,
                        "name": "Le Grazie",
                        "latitude": "44.06699000",
                        "longitude": "9.83392000"
                    },
                    {
                        "id": 139440,
                        "name": "Leivi",
                        "latitude": "44.35344000",
                        "longitude": "9.31074000"
                    },
                    {
                        "id": 139464,
                        "name": "Lerici",
                        "latitude": "44.07587000",
                        "longitude": "9.91121000"
                    },
                    {
                        "id": 139483,
                        "name": "Levanto",
                        "latitude": "44.17424000",
                        "longitude": "9.61670000"
                    },
                    {
                        "id": 139557,
                        "name": "Loano",
                        "latitude": "44.12777000",
                        "longitude": "8.25743000"
                    },
                    {
                        "id": 139615,
                        "name": "Lorsica",
                        "latitude": "44.43415000",
                        "longitude": "9.27677000"
                    },
                    {
                        "id": 139633,
                        "name": "Lucinasco",
                        "latitude": "43.96602000",
                        "longitude": "7.96005000"
                    },
                    {
                        "id": 139732,
                        "name": "Magliolo",
                        "latitude": "44.19253000",
                        "longitude": "8.24935000"
                    },
                    {
                        "id": 139752,
                        "name": "Maissana",
                        "latitude": "44.33675000",
                        "longitude": "9.53588000"
                    },
                    {
                        "id": 139768,
                        "name": "Mallare",
                        "latitude": "44.28934000",
                        "longitude": "8.29695000"
                    },
                    {
                        "id": 139795,
                        "name": "Manesseno",
                        "latitude": "44.47816000",
                        "longitude": "8.92784000"
                    },
                    {
                        "id": 139876,
                        "name": "Marina di Andora",
                        "latitude": "43.95353000",
                        "longitude": "8.15460000"
                    },
                    {
                        "id": 139965,
                        "name": "Masone",
                        "latitude": "44.50162000",
                        "longitude": "8.71891000"
                    },
                    {
                        "id": 139988,
                        "name": "Massimino",
                        "latitude": "44.29953000",
                        "longitude": "8.07134000"
                    },
                    {
                        "id": 140038,
                        "name": "Mele",
                        "latitude": "44.44573000",
                        "longitude": "8.74889000"
                    },
                    {
                        "id": 140062,
                        "name": "Mendatica",
                        "latitude": "44.07713000",
                        "longitude": "7.80564000"
                    },
                    {
                        "id": 140110,
                        "name": "Mezzanego",
                        "latitude": "44.38275000",
                        "longitude": "9.37667000"
                    },
                    {
                        "id": 140140,
                        "name": "Mignanego",
                        "latitude": "44.52748000",
                        "longitude": "8.91412000"
                    },
                    {
                        "id": 140152,
                        "name": "Millesimo",
                        "latitude": "44.36695000",
                        "longitude": "8.20354000"
                    },
                    {
                        "id": 140164,
                        "name": "Mioglia",
                        "latitude": "44.49214000",
                        "longitude": "8.41435000"
                    },
                    {
                        "id": 140187,
                        "name": "Moconesi",
                        "latitude": "44.42065000",
                        "longitude": "9.20977000"
                    },
                    {
                        "id": 140219,
                        "name": "Molini",
                        "latitude": "43.92594000",
                        "longitude": "7.93835000"
                    },
                    {
                        "id": 140220,
                        "name": "Molini di Triora",
                        "latitude": "43.98905000",
                        "longitude": "7.77463000"
                    },
                    {
                        "id": 140221,
                        "name": "Molino Vecchio-Scapitola-Baio",
                        "latitude": "44.55555000",
                        "longitude": "9.06816000"
                    },
                    {
                        "id": 140226,
                        "name": "Molino-Pera",
                        "latitude": "44.48803000",
                        "longitude": "8.30899000"
                    },
                    {
                        "id": 140277,
                        "name": "Moneglia",
                        "latitude": "44.23905000",
                        "longitude": "9.49081000"
                    },
                    {
                        "id": 140332,
                        "name": "Montalto Ligure",
                        "latitude": "43.92868000",
                        "longitude": "7.84491000"
                    },
                    {
                        "id": 140393,
                        "name": "Montebruno",
                        "latitude": "44.52577000",
                        "longitude": "9.24831000"
                    },
                    {
                        "id": 140460,
                        "name": "Montegrosso Pian Latte",
                        "latitude": "44.06631000",
                        "longitude": "7.81602000"
                    },
                    {
                        "id": 140525,
                        "name": "Monterosso al Mare",
                        "latitude": "44.14666000",
                        "longitude": "9.65494000"
                    },
                    {
                        "id": 140578,
                        "name": "Montoggio",
                        "latitude": "44.51699000",
                        "longitude": "9.04923000"
                    },
                    {
                        "id": 140690,
                        "name": "Murialdo",
                        "latitude": "44.31693000",
                        "longitude": "8.16815000"
                    },
                    {
                        "id": 140723,
                        "name": "Nasino-Borgo",
                        "latitude": "44.11363000",
                        "longitude": "8.03205000"
                    },
                    {
                        "id": 140737,
                        "name": "Neirone",
                        "latitude": "44.45482000",
                        "longitude": "9.19133000"
                    },
                    {
                        "id": 140799,
                        "name": "Noli",
                        "latitude": "44.20608000",
                        "longitude": "8.41458000"
                    },
                    {
                        "id": 140903,
                        "name": "Olivetta San Michele",
                        "latitude": "43.87872000",
                        "longitude": "7.51504000"
                    },
                    {
                        "id": 140929,
                        "name": "Onzo",
                        "latitude": "44.07013000",
                        "longitude": "8.05225000"
                    },
                    {
                        "id": 140945,
                        "name": "Orco Feglino",
                        "latitude": "44.22023000",
                        "longitude": "8.32455000"
                    },
                    {
                        "id": 140948,
                        "name": "Orero",
                        "latitude": "44.40835000",
                        "longitude": "9.26707000"
                    },
                    {
                        "id": 140989,
                        "name": "Ortovero",
                        "latitude": "44.05385000",
                        "longitude": "8.09950000"
                    },
                    {
                        "id": 141004,
                        "name": "Osiglia",
                        "latitude": "44.28145000",
                        "longitude": "8.20096000"
                    },
                    {
                        "id": 141014,
                        "name": "Ospedaletti",
                        "latitude": "43.80221000",
                        "longitude": "7.71830000"
                    },
                    {
                        "id": 141038,
                        "name": "Osteria dei Cacciatori-Stella",
                        "latitude": "44.43044000",
                        "longitude": "8.47120000"
                    },
                    {
                        "id": 141084,
                        "name": "Padivarma",
                        "latitude": "44.19648000",
                        "longitude": "9.76753000"
                    },
                    {
                        "id": 58251,
                        "name": "Pallare",
                        "latitude": "44.32770000",
                        "longitude": "8.27864000"
                    },
                    {
                        "id": 58379,
                        "name": "Pedemonte",
                        "latitude": "44.50307000",
                        "longitude": "8.92614000"
                    },
                    {
                        "id": 58425,
                        "name": "Perinaldo",
                        "latitude": "43.86689000",
                        "longitude": "7.67194000"
                    },
                    {
                        "id": 58511,
                        "name": "Piana Battolla",
                        "latitude": "44.19322000",
                        "longitude": "9.85345000"
                    },
                    {
                        "id": 58512,
                        "name": "Piana Crixia",
                        "latitude": "44.48504000",
                        "longitude": "8.30805000"
                    },
                    {
                        "id": 58538,
                        "name": "Piano",
                        "latitude": "44.31680000",
                        "longitude": "8.16639000"
                    },
                    {
                        "id": 58543,
                        "name": "Piano di Follo",
                        "latitude": "44.16375000",
                        "longitude": "9.86188000"
                    },
                    {
                        "id": 58578,
                        "name": "Piccarello",
                        "latitude": "44.48392000",
                        "longitude": "8.96595000"
                    },
                    {
                        "id": 58601,
                        "name": "Pietra Ligure",
                        "latitude": "44.14920000",
                        "longitude": "8.28206000"
                    },
                    {
                        "id": 58606,
                        "name": "Pietrabruna",
                        "latitude": "43.88927000",
                        "longitude": "7.90319000"
                    },
                    {
                        "id": 58654,
                        "name": "Pieve di Teco",
                        "latitude": "44.04706000",
                        "longitude": "7.91564000"
                    },
                    {
                        "id": 58655,
                        "name": "Pieve di Zignago",
                        "latitude": "44.27790000",
                        "longitude": "9.74573000"
                    },
                    {
                        "id": 58636,
                        "name": "Pieve Ligure",
                        "latitude": "44.37494000",
                        "longitude": "9.09410000"
                    },
                    {
                        "id": 58660,
                        "name": "Pigna",
                        "latitude": "43.93205000",
                        "longitude": "7.66123000"
                    },
                    {
                        "id": 58664,
                        "name": "Pignone",
                        "latitude": "44.17780000",
                        "longitude": "9.72327000"
                    },
                    {
                        "id": 58717,
                        "name": "Pitelli",
                        "latitude": "44.09458000",
                        "longitude": "9.88490000"
                    },
                    {
                        "id": 58740,
                        "name": "Plodio",
                        "latitude": "44.35394000",
                        "longitude": "8.24725000"
                    },
                    {
                        "id": 58818,
                        "name": "Pompeiana",
                        "latitude": "43.85297000",
                        "longitude": "7.88836000"
                    },
                    {
                        "id": 58868,
                        "name": "Pontedassio",
                        "latitude": "43.93830000",
                        "longitude": "8.01464000"
                    },
                    {
                        "id": 58889,
                        "name": "Pontinvrea",
                        "latitude": "44.44205000",
                        "longitude": "8.43623000"
                    },
                    {
                        "id": 58908,
                        "name": "Pornassio",
                        "latitude": "44.07053000",
                        "longitude": "7.86954000"
                    },
                    {
                        "id": 58945,
                        "name": "Portofino",
                        "latitude": "44.30349000",
                        "longitude": "9.20942000"
                    },
                    {
                        "id": 58950,
                        "name": "Portovenere",
                        "latitude": "44.05083000",
                        "longitude": "9.83431000"
                    },
                    {
                        "id": 59021,
                        "name": "Prati",
                        "latitude": "44.38290000",
                        "longitude": "9.37567000"
                    },
                    {
                        "id": 59051,
                        "name": "Prelà Castello",
                        "latitude": "43.94006000",
                        "longitude": "7.94409000"
                    },
                    {
                        "id": 59091,
                        "name": "Propata",
                        "latitude": "44.56487000",
                        "longitude": "9.18587000"
                    },
                    {
                        "id": 59134,
                        "name": "Provincia di Genova",
                        "latitude": "44.50000000",
                        "longitude": "9.06667000"
                    },
                    {
                        "id": 59137,
                        "name": "Provincia di Imperia",
                        "latitude": "43.96667000",
                        "longitude": "7.78333000"
                    },
                    {
                        "id": 59139,
                        "name": "Provincia di La Spezia",
                        "latitude": "44.25000000",
                        "longitude": "9.70000000"
                    },
                    {
                        "id": 59174,
                        "name": "Provincia di Savona",
                        "latitude": "44.30000000",
                        "longitude": "8.26667000"
                    },
                    {
                        "id": 59242,
                        "name": "Quiliano",
                        "latitude": "44.29215000",
                        "longitude": "8.41406000"
                    },
                    {
                        "id": 59284,
                        "name": "Rapallo",
                        "latitude": "44.34960000",
                        "longitude": "9.22796000"
                    },
                    {
                        "id": 59311,
                        "name": "Recco",
                        "latitude": "44.36227000",
                        "longitude": "9.14354000"
                    },
                    {
                        "id": 59348,
                        "name": "Rezzo",
                        "latitude": "44.02101000",
                        "longitude": "7.87199000"
                    },
                    {
                        "id": 59349,
                        "name": "Rezzoaglio",
                        "latitude": "44.52625000",
                        "longitude": "9.38827000"
                    },
                    {
                        "id": 59356,
                        "name": "Rialto",
                        "latitude": "44.22653000",
                        "longitude": "8.26135000"
                    },
                    {
                        "id": 59368,
                        "name": "Riccò del Golfo",
                        "latitude": "44.15410000",
                        "longitude": "9.76414000"
                    },
                    {
                        "id": 59395,
                        "name": "Riomaggiore",
                        "latitude": "44.09979000",
                        "longitude": "9.73869000"
                    },
                    {
                        "id": 59416,
                        "name": "Riva Ligure",
                        "latitude": "43.83883000",
                        "longitude": "7.87935000"
                    },
                    {
                        "id": 59528,
                        "name": "Roccavignale",
                        "latitude": "44.36124000",
                        "longitude": "8.19055000"
                    },
                    {
                        "id": 59544,
                        "name": "Rocchetta di Vara",
                        "latitude": "44.25059000",
                        "longitude": "9.75791000"
                    },
                    {
                        "id": 59538,
                        "name": "Rocchetta Nervina",
                        "latitude": "43.88988000",
                        "longitude": "7.60071000"
                    },
                    {
                        "id": 59587,
                        "name": "Romito Magra",
                        "latitude": "44.09838000",
                        "longitude": "9.93180000"
                    },
                    {
                        "id": 59605,
                        "name": "Ronco Scrivia",
                        "latitude": "44.61357000",
                        "longitude": "8.95042000"
                    },
                    {
                        "id": 59614,
                        "name": "Rondanina",
                        "latitude": "44.56325000",
                        "longitude": "9.21806000"
                    },
                    {
                        "id": 59650,
                        "name": "Rossi",
                        "latitude": "44.00029000",
                        "longitude": "8.05884000"
                    },
                    {
                        "id": 59651,
                        "name": "Rossiglione",
                        "latitude": "44.56358000",
                        "longitude": "8.66956000"
                    },
                    {
                        "id": 59670,
                        "name": "Rovegno",
                        "latitude": "44.57675000",
                        "longitude": "9.27917000"
                    },
                    {
                        "id": 59821,
                        "name": "San Bartolomeo al Mare",
                        "latitude": "43.92312000",
                        "longitude": "8.10482000"
                    },
                    {
                        "id": 59843,
                        "name": "San Biagio della Cima",
                        "latitude": "43.81784000",
                        "longitude": "7.65133000"
                    },
                    {
                        "id": 59904,
                        "name": "San Fedele-Lusignano",
                        "latitude": "44.04559000",
                        "longitude": "8.18078000"
                    },
                    {
                        "id": 59980,
                        "name": "San Giovanni",
                        "latitude": "44.39367000",
                        "longitude": "8.49701000"
                    },
                    {
                        "id": 60039,
                        "name": "San Lorenzo",
                        "latitude": "44.17302000",
                        "longitude": "8.24424000"
                    },
                    {
                        "id": 60044,
                        "name": "San Lorenzo al Mare",
                        "latitude": "43.85378000",
                        "longitude": "7.96406000"
                    },
                    {
                        "id": 60190,
                        "name": "San Pietro d'Olba",
                        "latitude": "44.48762000",
                        "longitude": "8.58951000"
                    },
                    {
                        "id": 60220,
                        "name": "San Remo",
                        "latitude": "43.81725000",
                        "longitude": "7.77720000"
                    },
                    {
                        "id": 60230,
                        "name": "San Salvatore",
                        "latitude": "44.33098000",
                        "longitude": "9.35479000"
                    },
                    {
                        "id": 60255,
                        "name": "San Terenzo",
                        "latitude": "44.08543000",
                        "longitude": "9.89662000"
                    },
                    {
                        "id": 60451,
                        "name": "Santa Margherita Ligure",
                        "latitude": "44.33456000",
                        "longitude": "9.21204000"
                    },
                    {
                        "id": 60485,
                        "name": "Santa Marta",
                        "latitude": "44.50401000",
                        "longitude": "8.89268000"
                    },
                    {
                        "id": 60517,
                        "name": "Santo Stefano al Mare",
                        "latitude": "43.83855000",
                        "longitude": "7.89728000"
                    },
                    {
                        "id": 60518,
                        "name": "Santo Stefano d'Aveto",
                        "latitude": "44.54677000",
                        "longitude": "9.45325000"
                    },
                    {
                        "id": 60522,
                        "name": "Santo Stefano di Magra",
                        "latitude": "44.14891000",
                        "longitude": "9.92185000"
                    },
                    {
                        "id": 60563,
                        "name": "Sarzana",
                        "latitude": "44.11178000",
                        "longitude": "9.96220000"
                    },
                    {
                        "id": 60569,
                        "name": "Sassello",
                        "latitude": "44.48036000",
                        "longitude": "8.49375000"
                    },
                    {
                        "id": 60592,
                        "name": "Savignone",
                        "latitude": "44.56435000",
                        "longitude": "8.98726000"
                    },
                    {
                        "id": 60599,
                        "name": "Savona",
                        "latitude": "44.30905000",
                        "longitude": "8.47715000"
                    },
                    {
                        "id": 60651,
                        "name": "Sciarborasca",
                        "latitude": "44.40182000",
                        "longitude": "8.61541000"
                    },
                    {
                        "id": 60674,
                        "name": "Seborga",
                        "latitude": "43.82730000",
                        "longitude": "7.69585000"
                    },
                    {
                        "id": 60751,
                        "name": "Serra Riccò",
                        "latitude": "44.51071000",
                        "longitude": "8.93806000"
                    },
                    {
                        "id": 60792,
                        "name": "Sesta Godano",
                        "latitude": "44.29375000",
                        "longitude": "9.67535000"
                    },
                    {
                        "id": 60803,
                        "name": "Sestri Levante",
                        "latitude": "44.27317000",
                        "longitude": "9.39683000"
                    },
                    {
                        "id": 60912,
                        "name": "Soldano",
                        "latitude": "43.82954000",
                        "longitude": "7.65627000"
                    },
                    {
                        "id": 60957,
                        "name": "Sori",
                        "latitude": "44.37301000",
                        "longitude": "9.10470000"
                    },
                    {
                        "id": 61031,
                        "name": "Spotorno",
                        "latitude": "44.22638000",
                        "longitude": "8.41647000"
                    },
                    {
                        "id": 61057,
                        "name": "Stazione-Fornola",
                        "latitude": "44.12984000",
                        "longitude": "9.89159000"
                    },
                    {
                        "id": 61064,
                        "name": "Stellanello",
                        "latitude": "43.99993000",
                        "longitude": "8.06025000"
                    },
                    {
                        "id": 61140,
                        "name": "Taggia",
                        "latitude": "43.84612000",
                        "longitude": "7.85223000"
                    },
                    {
                        "id": 61259,
                        "name": "Terzorio",
                        "latitude": "43.85232000",
                        "longitude": "7.89835000"
                    },
                    {
                        "id": 61264,
                        "name": "Testico",
                        "latitude": "44.00553000",
                        "longitude": "8.02639000"
                    },
                    {
                        "id": 61277,
                        "name": "Tiglieto",
                        "latitude": "44.52324000",
                        "longitude": "8.61925000"
                    },
                    {
                        "id": 61297,
                        "name": "Toirano",
                        "latitude": "44.12732000",
                        "longitude": "8.20725000"
                    },
                    {
                        "id": 61405,
                        "name": "Torriglia",
                        "latitude": "44.51755000",
                        "longitude": "9.15811000"
                    },
                    {
                        "id": 61425,
                        "name": "Tovo San Giacomo",
                        "latitude": "44.17593000",
                        "longitude": "8.27045000"
                    },
                    {
                        "id": 61517,
                        "name": "Tribogna",
                        "latitude": "44.41655000",
                        "longitude": "9.19557000"
                    },
                    {
                        "id": 61533,
                        "name": "Triora",
                        "latitude": "43.99309000",
                        "longitude": "7.76369000"
                    },
                    {
                        "id": 61603,
                        "name": "Urbe",
                        "latitude": "44.48714000",
                        "longitude": "8.58615000"
                    },
                    {
                        "id": 61610,
                        "name": "Uscio",
                        "latitude": "44.41233000",
                        "longitude": "9.16227000"
                    },
                    {
                        "id": 61630,
                        "name": "Vado Centro",
                        "latitude": "44.26857000",
                        "longitude": "8.43225000"
                    },
                    {
                        "id": 61631,
                        "name": "Vado Ligure",
                        "latitude": "44.26913000",
                        "longitude": "8.43375000"
                    },
                    {
                        "id": 61699,
                        "name": "Valle di Vado",
                        "latitude": "44.26183000",
                        "longitude": "8.41397000"
                    },
                    {
                        "id": 61701,
                        "name": "Vallebona",
                        "latitude": "43.81220000",
                        "longitude": "7.66535000"
                    },
                    {
                        "id": 61703,
                        "name": "Vallecrosia",
                        "latitude": "43.78671000",
                        "longitude": "7.63902000"
                    },
                    {
                        "id": 61708,
                        "name": "Valleggia",
                        "latitude": "44.28080000",
                        "longitude": "8.42967000"
                    },
                    {
                        "id": 61749,
                        "name": "Valzemola",
                        "latitude": "44.36393000",
                        "longitude": "8.17376000"
                    },
                    {
                        "id": 61764,
                        "name": "Varazze",
                        "latitude": "44.36412000",
                        "longitude": "8.59630000"
                    },
                    {
                        "id": 61770,
                        "name": "Varese Ligure",
                        "latitude": "44.37687000",
                        "longitude": "9.59372000"
                    },
                    {
                        "id": 61779,
                        "name": "Vasia",
                        "latitude": "43.93268000",
                        "longitude": "7.95389000"
                    },
                    {
                        "id": 61813,
                        "name": "Vendone",
                        "latitude": "44.07693000",
                        "longitude": "8.07115000"
                    },
                    {
                        "id": 61825,
                        "name": "Ventimiglia",
                        "latitude": "43.78956000",
                        "longitude": "7.60872000"
                    },
                    {
                        "id": 61856,
                        "name": "Vernazza",
                        "latitude": "44.13501000",
                        "longitude": "9.68346000"
                    },
                    {
                        "id": 61884,
                        "name": "Vessalico",
                        "latitude": "44.04559000",
                        "longitude": "7.96013000"
                    },
                    {
                        "id": 61895,
                        "name": "Vezzano Ligure",
                        "latitude": "44.14144000",
                        "longitude": "9.88692000"
                    },
                    {
                        "id": 61897,
                        "name": "Vezzi Portio",
                        "latitude": "44.22933000",
                        "longitude": "8.36505000"
                    },
                    {
                        "id": 61997,
                        "name": "Villa Faraldi",
                        "latitude": "43.96843000",
                        "longitude": "8.08965000"
                    },
                    {
                        "id": 62055,
                        "name": "Villafranca",
                        "latitude": "44.03297000",
                        "longitude": "8.10525000"
                    },
                    {
                        "id": 62105,
                        "name": "Villanova d'Albenga",
                        "latitude": "44.04725000",
                        "longitude": "8.14336000"
                    },
                    {
                        "id": 62198,
                        "name": "Vobbia",
                        "latitude": "44.60125000",
                        "longitude": "9.03866000"
                    },
                    {
                        "id": 62263,
                        "name": "Zoagli",
                        "latitude": "44.33668000",
                        "longitude": "9.26680000"
                    },
                    {
                        "id": 62279,
                        "name": "Zuccarello",
                        "latitude": "44.10973000",
                        "longitude": "8.11814000"
                    }
                ]
            },
            {
                "id": 1745,
                "name": "Livorno",
                "iso2": "LI",
                "latitude": "43.02398480",
                "longitude": "10.66471010",
                "type": "province",
                "cities": []
            },
            {
                "id": 1747,
                "name": "Lodi",
                "iso2": "LO",
                "latitude": "45.24050360",
                "longitude": "9.52925120",
                "type": "province",
                "cities": []
            },
            {
                "id": 1705,
                "name": "Lombardy",
                "iso2": "25",
                "latitude": "45.47906710",
                "longitude": "9.84524330",
                "type": "region",
                "cities": [
                    {
                        "id": 135236,
                        "name": "Abbadia Cerreto",
                        "latitude": "45.31217000",
                        "longitude": "9.59416000"
                    },
                    {
                        "id": 135237,
                        "name": "Abbadia Lariana",
                        "latitude": "45.89947000",
                        "longitude": "9.33518000"
                    },
                    {
                        "id": 135241,
                        "name": "Abbazia",
                        "latitude": "45.74800000",
                        "longitude": "9.84205000"
                    },
                    {
                        "id": 135243,
                        "name": "Abbiategrasso",
                        "latitude": "45.39821000",
                        "longitude": "8.91678000"
                    },
                    {
                        "id": 135266,
                        "name": "Acquafredda",
                        "latitude": "45.30697000",
                        "longitude": "10.41343000"
                    },
                    {
                        "id": 135268,
                        "name": "Acquanegra Cremonese",
                        "latitude": "45.16864000",
                        "longitude": "9.89074000"
                    },
                    {
                        "id": 135269,
                        "name": "Acquanegra sul Chiese",
                        "latitude": "45.16404000",
                        "longitude": "10.43323000"
                    },
                    {
                        "id": 135288,
                        "name": "Adrara San Martino",
                        "latitude": "45.70228000",
                        "longitude": "9.94896000"
                    },
                    {
                        "id": 135289,
                        "name": "Adrara San Rocco",
                        "latitude": "45.71578000",
                        "longitude": "9.95906000"
                    },
                    {
                        "id": 135291,
                        "name": "Adro",
                        "latitude": "45.62059000",
                        "longitude": "9.96159000"
                    },
                    {
                        "id": 135308,
                        "name": "Agnadello",
                        "latitude": "45.44516000",
                        "longitude": "9.55408000"
                    },
                    {
                        "id": 135311,
                        "name": "Agnosine",
                        "latitude": "45.64969000",
                        "longitude": "10.35267000"
                    },
                    {
                        "id": 135314,
                        "name": "Agra",
                        "latitude": "46.03668000",
                        "longitude": "8.76833000"
                    },
                    {
                        "id": 135316,
                        "name": "Agrate Brianza",
                        "latitude": "45.57431000",
                        "longitude": "9.34793000"
                    },
                    {
                        "id": 135322,
                        "name": "Aicurzio",
                        "latitude": "45.63998000",
                        "longitude": "9.41495000"
                    },
                    {
                        "id": 135336,
                        "name": "Airuno",
                        "latitude": "45.75352000",
                        "longitude": "9.42765000"
                    },
                    {
                        "id": 135340,
                        "name": "Alagna",
                        "latitude": "45.16917000",
                        "longitude": "8.88947000"
                    },
                    {
                        "id": 135349,
                        "name": "Albairate",
                        "latitude": "45.41957000",
                        "longitude": "8.93744000"
                    },
                    {
                        "id": 135352,
                        "name": "Albano Sant'Alessandro",
                        "latitude": "45.68762000",
                        "longitude": "9.76651000"
                    },
                    {
                        "id": 135356,
                        "name": "Albaredo",
                        "latitude": "46.10293000",
                        "longitude": "9.59046000"
                    },
                    {
                        "id": 135357,
                        "name": "Albaredo Arnaboldi",
                        "latitude": "45.10666000",
                        "longitude": "9.24296000"
                    },
                    {
                        "id": 135361,
                        "name": "Albavilla",
                        "latitude": "45.80038000",
                        "longitude": "9.18504000"
                    },
                    {
                        "id": 135367,
                        "name": "Albese Con Cassano",
                        "latitude": "45.79488000",
                        "longitude": "9.16364000"
                    },
                    {
                        "id": 135373,
                        "name": "Albiate",
                        "latitude": "45.65537000",
                        "longitude": "9.25035000"
                    },
                    {
                        "id": 135375,
                        "name": "Albignano",
                        "latitude": "45.50054000",
                        "longitude": "9.49299000"
                    },
                    {
                        "id": 135379,
                        "name": "Albino",
                        "latitude": "45.76444000",
                        "longitude": "9.79904000"
                    },
                    {
                        "id": 135380,
                        "name": "Albiolo",
                        "latitude": "45.80558000",
                        "longitude": "8.93924000"
                    },
                    {
                        "id": 135383,
                        "name": "Albizzate",
                        "latitude": "45.72698000",
                        "longitude": "8.80312000"
                    },
                    {
                        "id": 135384,
                        "name": "Albonese",
                        "latitude": "45.29285000",
                        "longitude": "8.70615000"
                    },
                    {
                        "id": 135385,
                        "name": "Albosaggia",
                        "latitude": "46.14749000",
                        "longitude": "9.85405000"
                    },
                    {
                        "id": 135388,
                        "name": "Albuzzano",
                        "latitude": "45.18719000",
                        "longitude": "9.27383000"
                    },
                    {
                        "id": 135401,
                        "name": "Alfianello",
                        "latitude": "45.26698000",
                        "longitude": "10.14817000"
                    },
                    {
                        "id": 135405,
                        "name": "Algua",
                        "latitude": "45.82584000",
                        "longitude": "9.72225000"
                    },
                    {
                        "id": 135423,
                        "name": "Almè",
                        "latitude": "45.73883000",
                        "longitude": "9.61558000"
                    },
                    {
                        "id": 135420,
                        "name": "Almenno San Bartolomeo",
                        "latitude": "45.73912000",
                        "longitude": "9.58082000"
                    },
                    {
                        "id": 135421,
                        "name": "Almenno San Salvatore",
                        "latitude": "45.74971000",
                        "longitude": "9.59699000"
                    },
                    {
                        "id": 135429,
                        "name": "Alserio",
                        "latitude": "45.77888000",
                        "longitude": "9.20014000"
                    },
                    {
                        "id": 135450,
                        "name": "Alzano Lombardo",
                        "latitude": "45.73681000",
                        "longitude": "9.72638000"
                    },
                    {
                        "id": 135452,
                        "name": "Alzate Brianza",
                        "latitude": "45.76978000",
                        "longitude": "9.18204000"
                    },
                    {
                        "id": 135464,
                        "name": "Ambivere",
                        "latitude": "45.71958000",
                        "longitude": "9.55015000"
                    },
                    {
                        "id": 135482,
                        "name": "Andalo Valtellino",
                        "latitude": "46.13599000",
                        "longitude": "9.47384000"
                    },
                    {
                        "id": 135495,
                        "name": "Anfo",
                        "latitude": "45.76575000",
                        "longitude": "10.49382000"
                    },
                    {
                        "id": 135496,
                        "name": "Angera",
                        "latitude": "45.77555000",
                        "longitude": "8.57861000"
                    },
                    {
                        "id": 135499,
                        "name": "Angolo Terme",
                        "latitude": "45.89168000",
                        "longitude": "10.14963000"
                    },
                    {
                        "id": 135505,
                        "name": "Annicco",
                        "latitude": "45.24344000",
                        "longitude": "9.87905000"
                    },
                    {
                        "id": 135507,
                        "name": "Annone di Brianza",
                        "latitude": "45.80216000",
                        "longitude": "9.33119000"
                    },
                    {
                        "id": 135512,
                        "name": "Antegnate",
                        "latitude": "45.48648000",
                        "longitude": "9.79146000"
                    },
                    {
                        "id": 135524,
                        "name": "Anzano del Parco",
                        "latitude": "45.77006000",
                        "longitude": "9.19752000"
                    },
                    {
                        "id": 135535,
                        "name": "Appiano Gentile",
                        "latitude": "45.73499000",
                        "longitude": "8.98103000"
                    },
                    {
                        "id": 135538,
                        "name": "Aprica",
                        "latitude": "46.15220000",
                        "longitude": "10.14884000"
                    },
                    {
                        "id": 135562,
                        "name": "Arcene",
                        "latitude": "45.57717000",
                        "longitude": "9.61461000"
                    },
                    {
                        "id": 135569,
                        "name": "Arcisate",
                        "latitude": "45.85578000",
                        "longitude": "8.86823000"
                    },
                    {
                        "id": 135573,
                        "name": "Arconate",
                        "latitude": "45.54134000",
                        "longitude": "8.84891000"
                    },
                    {
                        "id": 135574,
                        "name": "Arcore",
                        "latitude": "45.62675000",
                        "longitude": "9.32454000"
                    },
                    {
                        "id": 135579,
                        "name": "Ardenno",
                        "latitude": "46.16714000",
                        "longitude": "9.64729000"
                    },
                    {
                        "id": 135580,
                        "name": "Ardesio",
                        "latitude": "45.93613000",
                        "longitude": "9.92950000"
                    },
                    {
                        "id": 135581,
                        "name": "Ardole San Marino",
                        "latitude": "45.15633000",
                        "longitude": "10.10546000"
                    },
                    {
                        "id": 135586,
                        "name": "Arena Po",
                        "latitude": "45.09427000",
                        "longitude": "9.36312000"
                    },
                    {
                        "id": 135589,
                        "name": "Arese",
                        "latitude": "45.55048000",
                        "longitude": "9.07741000"
                    },
                    {
                        "id": 135591,
                        "name": "Argegno",
                        "latitude": "45.94218000",
                        "longitude": "9.12635000"
                    },
                    {
                        "id": 135609,
                        "name": "Arlate",
                        "latitude": "45.72363000",
                        "longitude": "9.44242000"
                    },
                    {
                        "id": 135612,
                        "name": "Arluno",
                        "latitude": "45.50344000",
                        "longitude": "8.94222000"
                    },
                    {
                        "id": 135625,
                        "name": "Arosio",
                        "latitude": "45.71933000",
                        "longitude": "9.20816000"
                    },
                    {
                        "id": 135636,
                        "name": "Arsago Seprio",
                        "latitude": "45.68764000",
                        "longitude": "8.73509000"
                    },
                    {
                        "id": 135644,
                        "name": "Artogne",
                        "latitude": "45.85437000",
                        "longitude": "10.16646000"
                    },
                    {
                        "id": 135647,
                        "name": "Arzago d'Adda",
                        "latitude": "45.48137000",
                        "longitude": "9.56415000"
                    },
                    {
                        "id": 135661,
                        "name": "Asola",
                        "latitude": "45.22018000",
                        "longitude": "10.41214000"
                    },
                    {
                        "id": 135664,
                        "name": "Assago",
                        "latitude": "45.40887000",
                        "longitude": "9.12565000"
                    },
                    {
                        "id": 135667,
                        "name": "Asso",
                        "latitude": "45.86061000",
                        "longitude": "9.26730000"
                    },
                    {
                        "id": 135692,
                        "name": "Aurogna",
                        "latitude": "46.17147000",
                        "longitude": "9.35536000"
                    },
                    {
                        "id": 135701,
                        "name": "Averara",
                        "latitude": "45.98847000",
                        "longitude": "9.63160000"
                    },
                    {
                        "id": 135707,
                        "name": "Aviatico",
                        "latitude": "45.79758000",
                        "longitude": "9.77145000"
                    },
                    {
                        "id": 135719,
                        "name": "Azzanello",
                        "latitude": "45.31312000",
                        "longitude": "9.91973000"
                    },
                    {
                        "id": 135720,
                        "name": "Azzano",
                        "latitude": "45.98096000",
                        "longitude": "9.20284000"
                    },
                    {
                        "id": 135722,
                        "name": "Azzano Mella",
                        "latitude": "45.45458000",
                        "longitude": "10.11717000"
                    },
                    {
                        "id": 135723,
                        "name": "Azzano San Paolo",
                        "latitude": "45.65798000",
                        "longitude": "9.67305000"
                    },
                    {
                        "id": 135725,
                        "name": "Azzate",
                        "latitude": "45.77803000",
                        "longitude": "8.79414000"
                    },
                    {
                        "id": 135726,
                        "name": "Azzio",
                        "latitude": "45.88468000",
                        "longitude": "8.70853000"
                    },
                    {
                        "id": 135727,
                        "name": "Azzone",
                        "latitude": "45.97903000",
                        "longitude": "10.11284000"
                    },
                    {
                        "id": 135731,
                        "name": "Badalasco",
                        "latitude": "45.54217000",
                        "longitude": "9.55494000"
                    },
                    {
                        "id": 135736,
                        "name": "Badia Pavese",
                        "latitude": "45.12087000",
                        "longitude": "9.46866000"
                    },
                    {
                        "id": 135740,
                        "name": "Badile",
                        "latitude": "45.35061000",
                        "longitude": "9.12705000"
                    },
                    {
                        "id": 135751,
                        "name": "Bagnaria",
                        "latitude": "44.82726000",
                        "longitude": "9.12256000"
                    },
                    {
                        "id": 135756,
                        "name": "Bagnatica",
                        "latitude": "45.66088000",
                        "longitude": "9.78106000"
                    },
                    {
                        "id": 135767,
                        "name": "Bagnolo Cremasco",
                        "latitude": "45.36117000",
                        "longitude": "9.61296000"
                    },
                    {
                        "id": 135768,
                        "name": "Bagnolo Mella",
                        "latitude": "45.42765000",
                        "longitude": "10.18638000"
                    },
                    {
                        "id": 135770,
                        "name": "Bagnolo San Vito",
                        "latitude": "45.08892000",
                        "longitude": "10.87747000"
                    },
                    {
                        "id": 135776,
                        "name": "Bagolino",
                        "latitude": "45.82519000",
                        "longitude": "10.46183000"
                    },
                    {
                        "id": 135789,
                        "name": "Ballabio",
                        "latitude": "45.89629000",
                        "longitude": "9.42294000"
                    },
                    {
                        "id": 135809,
                        "name": "Baraggia",
                        "latitude": "45.85516000",
                        "longitude": "8.90885000"
                    },
                    {
                        "id": 135813,
                        "name": "Baranzate",
                        "latitude": "45.52717000",
                        "longitude": "9.11724000"
                    },
                    {
                        "id": 135814,
                        "name": "Barasso",
                        "latitude": "45.84048000",
                        "longitude": "8.75683000"
                    },
                    {
                        "id": 135824,
                        "name": "Barbariga",
                        "latitude": "45.40508000",
                        "longitude": "10.05437000"
                    },
                    {
                        "id": 135825,
                        "name": "Barbata",
                        "latitude": "45.47498000",
                        "longitude": "9.77736000"
                    },
                    {
                        "id": 135829,
                        "name": "Barbianello",
                        "latitude": "45.07571000",
                        "longitude": "9.20602000"
                    },
                    {
                        "id": 135839,
                        "name": "Bardello",
                        "latitude": "45.83597000",
                        "longitude": "8.69683000"
                    },
                    {
                        "id": 135844,
                        "name": "Bareggio",
                        "latitude": "45.47927000",
                        "longitude": "8.99789000"
                    },
                    {
                        "id": 135850,
                        "name": "Bargano",
                        "latitude": "45.24031000",
                        "longitude": "9.44689000"
                    },
                    {
                        "id": 135852,
                        "name": "Barghe",
                        "latitude": "45.67833000",
                        "longitude": "10.40775000"
                    },
                    {
                        "id": 135855,
                        "name": "Bariano",
                        "latitude": "45.51258000",
                        "longitude": "9.70366000"
                    },
                    {
                        "id": 135859,
                        "name": "Barlassina",
                        "latitude": "45.65558000",
                        "longitude": "9.12878000"
                    },
                    {
                        "id": 135861,
                        "name": "Barni",
                        "latitude": "45.91111000",
                        "longitude": "9.26592000"
                    },
                    {
                        "id": 135873,
                        "name": "Barzago",
                        "latitude": "45.75548000",
                        "longitude": "9.31424000"
                    },
                    {
                        "id": 135874,
                        "name": "Barzana",
                        "latitude": "45.73340000",
                        "longitude": "9.56842000"
                    },
                    {
                        "id": 135875,
                        "name": "Barzanò",
                        "latitude": "45.73257000",
                        "longitude": "9.31360000"
                    },
                    {
                        "id": 135876,
                        "name": "Barzio",
                        "latitude": "45.94349000",
                        "longitude": "9.46694000"
                    },
                    {
                        "id": 135879,
                        "name": "Bascapè",
                        "latitude": "45.30598000",
                        "longitude": "9.31397000"
                    },
                    {
                        "id": 135884,
                        "name": "Basiano",
                        "latitude": "45.58248000",
                        "longitude": "9.46325000"
                    },
                    {
                        "id": 135886,
                        "name": "Basiglio",
                        "latitude": "45.35917000",
                        "longitude": "9.15855000"
                    },
                    {
                        "id": 135891,
                        "name": "Bassano Bresciano",
                        "latitude": "45.32827000",
                        "longitude": "10.12869000"
                    },
                    {
                        "id": 135903,
                        "name": "Bastida de' Dossi",
                        "latitude": "45.03976000",
                        "longitude": "8.92155000"
                    },
                    {
                        "id": 135902,
                        "name": "Bastida Pancarana",
                        "latitude": "45.08606000",
                        "longitude": "9.08515000"
                    },
                    {
                        "id": 135906,
                        "name": "Battaglione-Bagnara",
                        "latitude": "45.11638000",
                        "longitude": "10.06726000"
                    },
                    {
                        "id": 135910,
                        "name": "Battuda",
                        "latitude": "45.27466000",
                        "longitude": "9.07805000"
                    },
                    {
                        "id": 135917,
                        "name": "Bedero",
                        "latitude": "45.97776000",
                        "longitude": "8.71852000"
                    },
                    {
                        "id": 135918,
                        "name": "Bedero Valcuvia",
                        "latitude": "45.91088000",
                        "longitude": "8.79553000"
                    },
                    {
                        "id": 135919,
                        "name": "Bedizzole",
                        "latitude": "45.51038000",
                        "longitude": "10.42327000"
                    },
                    {
                        "id": 135921,
                        "name": "Bedulita",
                        "latitude": "45.79138000",
                        "longitude": "9.55165000"
                    },
                    {
                        "id": 135929,
                        "name": "Belforte",
                        "latitude": "45.08097000",
                        "longitude": "10.56156000"
                    },
                    {
                        "id": 135932,
                        "name": "Belgioioso",
                        "latitude": "45.15933000",
                        "longitude": "9.31347000"
                    },
                    {
                        "id": 135936,
                        "name": "Bellagio",
                        "latitude": "45.98772000",
                        "longitude": "9.26182000"
                    },
                    {
                        "id": 135937,
                        "name": "Bellano",
                        "latitude": "46.04426000",
                        "longitude": "9.30734000"
                    },
                    {
                        "id": 135943,
                        "name": "Bellinzago Lombardo",
                        "latitude": "45.54207000",
                        "longitude": "9.44595000"
                    },
                    {
                        "id": 135950,
                        "name": "Bellusco",
                        "latitude": "45.61958000",
                        "longitude": "9.41905000"
                    },
                    {
                        "id": 135970,
                        "name": "Bema",
                        "latitude": "46.10819000",
                        "longitude": "9.56414000"
                    },
                    {
                        "id": 135971,
                        "name": "Bene Lario",
                        "latitude": "46.02898000",
                        "longitude": "9.18414000"
                    },
                    {
                        "id": 135979,
                        "name": "Berbenno",
                        "latitude": "45.81478000",
                        "longitude": "9.57105000"
                    },
                    {
                        "id": 135980,
                        "name": "Berbenno di Valtellina",
                        "latitude": "46.16641000",
                        "longitude": "9.74734000"
                    },
                    {
                        "id": 135983,
                        "name": "Beregazzo",
                        "latitude": "45.77019000",
                        "longitude": "8.95869000"
                    },
                    {
                        "id": 135984,
                        "name": "Beregazzo con Figliaro",
                        "latitude": "45.78068000",
                        "longitude": "8.94414000"
                    },
                    {
                        "id": 135985,
                        "name": "Bereguardo",
                        "latitude": "45.25706000",
                        "longitude": "9.02735000"
                    },
                    {
                        "id": 135987,
                        "name": "Bergamo",
                        "latitude": "45.69601000",
                        "longitude": "9.66721000"
                    },
                    {
                        "id": 135991,
                        "name": "Berlingo",
                        "latitude": "45.50281000",
                        "longitude": "10.03436000"
                    },
                    {
                        "id": 135993,
                        "name": "Bernareggio",
                        "latitude": "45.64778000",
                        "longitude": "9.40505000"
                    },
                    {
                        "id": 135994,
                        "name": "Bernate Ticino",
                        "latitude": "45.47873000",
                        "longitude": "8.81834000"
                    },
                    {
                        "id": 136003,
                        "name": "Bertonico",
                        "latitude": "45.23307000",
                        "longitude": "9.66806000"
                    },
                    {
                        "id": 136007,
                        "name": "Berzo",
                        "latitude": "46.09287000",
                        "longitude": "10.33303000"
                    },
                    {
                        "id": 136008,
                        "name": "Berzo Inferiore",
                        "latitude": "45.93027000",
                        "longitude": "10.27696000"
                    },
                    {
                        "id": 136009,
                        "name": "Berzo San Fermo",
                        "latitude": "45.71938000",
                        "longitude": "9.90316000"
                    },
                    {
                        "id": 136010,
                        "name": "Besana in Brianza",
                        "latitude": "45.70235000",
                        "longitude": "9.29470000"
                    },
                    {
                        "id": 136011,
                        "name": "Besano",
                        "latitude": "45.88949000",
                        "longitude": "8.89068000"
                    },
                    {
                        "id": 136012,
                        "name": "Besate",
                        "latitude": "45.31296000",
                        "longitude": "8.96964000"
                    },
                    {
                        "id": 136015,
                        "name": "Besnate",
                        "latitude": "45.69858000",
                        "longitude": "8.76734000"
                    },
                    {
                        "id": 136016,
                        "name": "Besozzo",
                        "latitude": "45.84889000",
                        "longitude": "8.66517000"
                    },
                    {
                        "id": 136019,
                        "name": "Bettola",
                        "latitude": "45.33173000",
                        "longitude": "9.02080000"
                    },
                    {
                        "id": 136020,
                        "name": "Bettola-Zeloforomagno",
                        "latitude": "45.43080000",
                        "longitude": "9.30870000"
                    },
                    {
                        "id": 136032,
                        "name": "Biandronno",
                        "latitude": "45.81281000",
                        "longitude": "8.70882000"
                    },
                    {
                        "id": 136033,
                        "name": "Bianzano",
                        "latitude": "45.77309000",
                        "longitude": "9.91816000"
                    },
                    {
                        "id": 136034,
                        "name": "Bianzone",
                        "latitude": "46.18665000",
                        "longitude": "10.10934000"
                    },
                    {
                        "id": 136036,
                        "name": "Biassono",
                        "latitude": "45.62864000",
                        "longitude": "9.27124000"
                    },
                    {
                        "id": 136047,
                        "name": "Bienno",
                        "latitude": "45.93526000",
                        "longitude": "10.29232000"
                    },
                    {
                        "id": 136051,
                        "name": "Binago",
                        "latitude": "45.78218000",
                        "longitude": "8.92234000"
                    },
                    {
                        "id": 136052,
                        "name": "Binasco",
                        "latitude": "45.33102000",
                        "longitude": "9.09440000"
                    },
                    {
                        "id": 136056,
                        "name": "Bione",
                        "latitude": "45.67279000",
                        "longitude": "10.33887000"
                    },
                    {
                        "id": 136066,
                        "name": "Bisuschio",
                        "latitude": "45.87148000",
                        "longitude": "8.86843000"
                    },
                    {
                        "id": 136077,
                        "name": "Bizzarone",
                        "latitude": "45.83428000",
                        "longitude": "8.94274000"
                    },
                    {
                        "id": 136079,
                        "name": "Blello",
                        "latitude": "45.83778000",
                        "longitude": "9.57105000"
                    },
                    {
                        "id": 136081,
                        "name": "Blessagno",
                        "latitude": "45.95908000",
                        "longitude": "9.09754000"
                    },
                    {
                        "id": 136082,
                        "name": "Blevio",
                        "latitude": "45.84218000",
                        "longitude": "9.10514000"
                    },
                    {
                        "id": 136092,
                        "name": "Bodio",
                        "latitude": "45.78989000",
                        "longitude": "8.75146000"
                    },
                    {
                        "id": 136093,
                        "name": "Bodio Lomnago",
                        "latitude": "45.78867000",
                        "longitude": "8.75083000"
                    },
                    {
                        "id": 136095,
                        "name": "Boffalora d'Adda",
                        "latitude": "45.35851000",
                        "longitude": "9.49628000"
                    },
                    {
                        "id": 136094,
                        "name": "Boffalora Sopra Ticino",
                        "latitude": "45.46735000",
                        "longitude": "8.83095000"
                    },
                    {
                        "id": 136103,
                        "name": "Bolgare",
                        "latitude": "45.63242000",
                        "longitude": "9.81412000"
                    },
                    {
                        "id": 136104,
                        "name": "Bolladello-Peveranza",
                        "latitude": "45.68649000",
                        "longitude": "8.84517000"
                    },
                    {
                        "id": 136105,
                        "name": "Bollate",
                        "latitude": "45.54647000",
                        "longitude": "9.12054000"
                    },
                    {
                        "id": 136114,
                        "name": "Boltiere",
                        "latitude": "45.60088000",
                        "longitude": "9.57845000"
                    },
                    {
                        "id": 136125,
                        "name": "Bonate Sopra",
                        "latitude": "45.68179000",
                        "longitude": "9.55956000"
                    },
                    {
                        "id": 136126,
                        "name": "Bonate Sotto",
                        "latitude": "45.66818000",
                        "longitude": "9.55865000"
                    },
                    {
                        "id": 136130,
                        "name": "Bondeno",
                        "latitude": "44.93569000",
                        "longitude": "10.86035000"
                    },
                    {
                        "id": 136131,
                        "name": "Bondione",
                        "latitude": "46.03541000",
                        "longitude": "10.00832000"
                    },
                    {
                        "id": 136136,
                        "name": "Bonemerse",
                        "latitude": "45.11367000",
                        "longitude": "10.07747000"
                    },
                    {
                        "id": 136149,
                        "name": "Bordolano",
                        "latitude": "45.29170000",
                        "longitude": "9.98731000"
                    },
                    {
                        "id": 136154,
                        "name": "Borgarello",
                        "latitude": "45.24066000",
                        "longitude": "9.14055000"
                    },
                    {
                        "id": 136159,
                        "name": "Borghetto Lodigiano",
                        "latitude": "45.21326000",
                        "longitude": "9.49946000"
                    },
                    {
                        "id": 136201,
                        "name": "Borgo di Terzo",
                        "latitude": "45.72078000",
                        "longitude": "9.89096000"
                    },
                    {
                        "id": 136179,
                        "name": "Borgo Priolo",
                        "latitude": "44.96632000",
                        "longitude": "9.14835000"
                    },
                    {
                        "id": 136182,
                        "name": "Borgo San Giacomo",
                        "latitude": "45.34798000",
                        "longitude": "9.96817000"
                    },
                    {
                        "id": 136183,
                        "name": "Borgo San Giovanni",
                        "latitude": "45.27787000",
                        "longitude": "9.43496000"
                    },
                    {
                        "id": 136187,
                        "name": "Borgo San Siro",
                        "latitude": "45.23506000",
                        "longitude": "8.91334000"
                    },
                    {
                        "id": 136202,
                        "name": "Borgoforte",
                        "latitude": "45.05185000",
                        "longitude": "10.75018000"
                    },
                    {
                        "id": 136204,
                        "name": "Borgofranco sul Po",
                        "latitude": "45.04658000",
                        "longitude": "11.20930000"
                    },
                    {
                        "id": 136214,
                        "name": "Borgoratto Mormorolo",
                        "latitude": "44.92889000",
                        "longitude": "9.19402000"
                    },
                    {
                        "id": 136217,
                        "name": "Borgosatollo",
                        "latitude": "45.47690000",
                        "longitude": "10.24030000"
                    },
                    {
                        "id": 136221,
                        "name": "Bormio",
                        "latitude": "46.46717000",
                        "longitude": "10.37008000"
                    },
                    {
                        "id": 136222,
                        "name": "Bornasco",
                        "latitude": "45.26657000",
                        "longitude": "9.21795000"
                    },
                    {
                        "id": 136223,
                        "name": "Bornato",
                        "latitude": "45.59368000",
                        "longitude": "10.04090000"
                    },
                    {
                        "id": 136224,
                        "name": "Borno",
                        "latitude": "45.94748000",
                        "longitude": "10.20243000"
                    },
                    {
                        "id": 136238,
                        "name": "Boschetto",
                        "latitude": "45.16591000",
                        "longitude": "10.02656000"
                    },
                    {
                        "id": 136242,
                        "name": "Bosco Ex Parmigiano",
                        "latitude": "45.10697000",
                        "longitude": "10.03870000"
                    },
                    {
                        "id": 136252,
                        "name": "Bosisio Parini",
                        "latitude": "45.80075000",
                        "longitude": "9.29000000"
                    },
                    {
                        "id": 136253,
                        "name": "Bosnasco",
                        "latitude": "45.06400000",
                        "longitude": "9.35692000"
                    },
                    {
                        "id": 136254,
                        "name": "Bossico",
                        "latitude": "45.82839000",
                        "longitude": "10.04506000"
                    },
                    {
                        "id": 136258,
                        "name": "Botta",
                        "latitude": "45.83222000",
                        "longitude": "9.53257000"
                    },
                    {
                        "id": 136259,
                        "name": "Bottanuco",
                        "latitude": "45.63931000",
                        "longitude": "9.50903000"
                    },
                    {
                        "id": 136261,
                        "name": "Botticino",
                        "latitude": "45.52972000",
                        "longitude": "10.31085000"
                    },
                    {
                        "id": 136268,
                        "name": "Bovegno",
                        "latitude": "45.79121000",
                        "longitude": "10.27012000"
                    },
                    {
                        "id": 136270,
                        "name": "Bovezzo",
                        "latitude": "45.58998000",
                        "longitude": "10.24184000"
                    },
                    {
                        "id": 136273,
                        "name": "Bovisio-Masciago",
                        "latitude": "45.61019000",
                        "longitude": "9.15301000"
                    },
                    {
                        "id": 136277,
                        "name": "Bozzolo",
                        "latitude": "45.10324000",
                        "longitude": "10.47988000"
                    },
                    {
                        "id": 136279,
                        "name": "Bracca",
                        "latitude": "45.82267000",
                        "longitude": "9.70784000"
                    },
                    {
                        "id": 136287,
                        "name": "Brandico",
                        "latitude": "45.45418000",
                        "longitude": "10.05267000"
                    },
                    {
                        "id": 136289,
                        "name": "Branzi",
                        "latitude": "46.00249000",
                        "longitude": "9.75935000"
                    },
                    {
                        "id": 136290,
                        "name": "Braone",
                        "latitude": "45.99011000",
                        "longitude": "10.34178000"
                    },
                    {
                        "id": 136291,
                        "name": "Brebbia",
                        "latitude": "45.82983000",
                        "longitude": "8.65042000"
                    },
                    {
                        "id": 136293,
                        "name": "Bregano",
                        "latitude": "45.82578000",
                        "longitude": "8.68773000"
                    },
                    {
                        "id": 136295,
                        "name": "Bregnano",
                        "latitude": "45.69778000",
                        "longitude": "9.05934000"
                    },
                    {
                        "id": 136298,
                        "name": "Brembate",
                        "latitude": "45.60468000",
                        "longitude": "9.55480000"
                    },
                    {
                        "id": 136299,
                        "name": "Brembate di Sopra",
                        "latitude": "45.71668000",
                        "longitude": "9.57945000"
                    },
                    {
                        "id": 136300,
                        "name": "Brembilla",
                        "latitude": "45.82154000",
                        "longitude": "9.59679000"
                    },
                    {
                        "id": 136301,
                        "name": "Brembio",
                        "latitude": "45.21234000",
                        "longitude": "9.57244000"
                    },
                    {
                        "id": 136302,
                        "name": "Breme",
                        "latitude": "45.12756000",
                        "longitude": "8.62564000"
                    },
                    {
                        "id": 136304,
                        "name": "Brenna",
                        "latitude": "45.74338000",
                        "longitude": "9.18657000"
                    },
                    {
                        "id": 136306,
                        "name": "Brenno Useria",
                        "latitude": "45.86148000",
                        "longitude": "8.87801000"
                    },
                    {
                        "id": 136307,
                        "name": "Breno",
                        "latitude": "45.95889000",
                        "longitude": "10.30648000"
                    },
                    {
                        "id": 136308,
                        "name": "Brenta",
                        "latitude": "45.89418000",
                        "longitude": "8.68373000"
                    },
                    {
                        "id": 136314,
                        "name": "Brescia",
                        "latitude": "45.53558000",
                        "longitude": "10.21472000"
                    },
                    {
                        "id": 136317,
                        "name": "Bressana",
                        "latitude": "45.07807000",
                        "longitude": "9.13119000"
                    },
                    {
                        "id": 136320,
                        "name": "Bresso",
                        "latitude": "45.53792000",
                        "longitude": "9.18921000"
                    },
                    {
                        "id": 136323,
                        "name": "Brezzo di Bedero",
                        "latitude": "45.97838000",
                        "longitude": "8.71743000"
                    },
                    {
                        "id": 136328,
                        "name": "Brienno",
                        "latitude": "45.91175000",
                        "longitude": "9.13142000"
                    },
                    {
                        "id": 136333,
                        "name": "Brignano Gera d'Adda",
                        "latitude": "45.54324000",
                        "longitude": "9.64424000"
                    },
                    {
                        "id": 136336,
                        "name": "Brinzio",
                        "latitude": "45.88914000",
                        "longitude": "8.78683000"
                    },
                    {
                        "id": 136338,
                        "name": "Brione",
                        "latitude": "45.64228000",
                        "longitude": "10.14846000"
                    },
                    {
                        "id": 136340,
                        "name": "Briosco",
                        "latitude": "45.71008000",
                        "longitude": "9.24064000"
                    },
                    {
                        "id": 136342,
                        "name": "Brissago-Valtravaglia",
                        "latitude": "45.94921000",
                        "longitude": "8.74590000"
                    },
                    {
                        "id": 136344,
                        "name": "Brivio",
                        "latitude": "45.73725000",
                        "longitude": "9.44249000"
                    },
                    {
                        "id": 136351,
                        "name": "Brongio",
                        "latitude": "45.76535000",
                        "longitude": "9.31251000"
                    },
                    {
                        "id": 136352,
                        "name": "Broni",
                        "latitude": "45.06394000",
                        "longitude": "9.25993000"
                    },
                    {
                        "id": 136360,
                        "name": "Brozzo",
                        "latitude": "45.72019000",
                        "longitude": "10.23092000"
                    },
                    {
                        "id": 136362,
                        "name": "Brugherio",
                        "latitude": "45.55301000",
                        "longitude": "9.29907000"
                    },
                    {
                        "id": 136367,
                        "name": "Brumano",
                        "latitude": "45.85463000",
                        "longitude": "9.50064000"
                    },
                    {
                        "id": 136369,
                        "name": "Brunate",
                        "latitude": "45.82096000",
                        "longitude": "9.09869000"
                    },
                    {
                        "id": 136370,
                        "name": "Brunello",
                        "latitude": "45.76497000",
                        "longitude": "8.79533000"
                    },
                    {
                        "id": 136373,
                        "name": "Brusaporto",
                        "latitude": "45.67140000",
                        "longitude": "9.76041000"
                    },
                    {
                        "id": 136376,
                        "name": "Brusimpiano",
                        "latitude": "45.94468000",
                        "longitude": "8.88953000"
                    },
                    {
                        "id": 136382,
                        "name": "Bubbiano",
                        "latitude": "45.32727000",
                        "longitude": "9.01455000"
                    },
                    {
                        "id": 136387,
                        "name": "Buccinasco",
                        "latitude": "45.40703000",
                        "longitude": "9.10830000"
                    },
                    {
                        "id": 136394,
                        "name": "Buffalora-Bettole",
                        "latitude": "45.49681000",
                        "longitude": "10.27518000"
                    },
                    {
                        "id": 136396,
                        "name": "Buglio in Monte",
                        "latitude": "46.18336000",
                        "longitude": "9.67542000"
                    },
                    {
                        "id": 136398,
                        "name": "Buguggiate",
                        "latitude": "45.78227000",
                        "longitude": "8.81063000"
                    },
                    {
                        "id": 136400,
                        "name": "Bulciago",
                        "latitude": "45.75058000",
                        "longitude": "9.28534000"
                    },
                    {
                        "id": 136401,
                        "name": "Bulgarograsso",
                        "latitude": "45.74708000",
                        "longitude": "9.00644000"
                    },
                    {
                        "id": 136402,
                        "name": "Bulgorello",
                        "latitude": "45.72433000",
                        "longitude": "9.05524000"
                    },
                    {
                        "id": 136409,
                        "name": "Burago di Molgora",
                        "latitude": "45.59648000",
                        "longitude": "9.38165000"
                    },
                    {
                        "id": 136422,
                        "name": "Buscate",
                        "latitude": "45.54353000",
                        "longitude": "8.81297000"
                    },
                    {
                        "id": 136424,
                        "name": "Buscoldo",
                        "latitude": "45.09430000",
                        "longitude": "10.69581000"
                    },
                    {
                        "id": 136426,
                        "name": "Busnago",
                        "latitude": "45.61648000",
                        "longitude": "9.46375000"
                    },
                    {
                        "id": 136428,
                        "name": "Bussero",
                        "latitude": "45.53407000",
                        "longitude": "9.37205000"
                    },
                    {
                        "id": 136434,
                        "name": "Busto Arsizio",
                        "latitude": "45.61128000",
                        "longitude": "8.84914000"
                    },
                    {
                        "id": 136435,
                        "name": "Busto Garolfo",
                        "latitude": "45.54809000",
                        "longitude": "8.88298000"
                    },
                    {
                        "id": 136445,
                        "name": "Ca' d'Andrea",
                        "latitude": "45.11957000",
                        "longitude": "10.27748000"
                    },
                    {
                        "id": 136449,
                        "name": "Cabiate",
                        "latitude": "45.67418000",
                        "longitude": "9.17374000"
                    },
                    {
                        "id": 136453,
                        "name": "Cadegliano-Viconago",
                        "latitude": "45.95948000",
                        "longitude": "8.84343000"
                    },
                    {
                        "id": 136456,
                        "name": "Cadenabbia",
                        "latitude": "45.98861000",
                        "longitude": "9.23615000"
                    },
                    {
                        "id": 136461,
                        "name": "Cadorago-Caslino al Piano",
                        "latitude": "45.72728000",
                        "longitude": "9.03784000"
                    },
                    {
                        "id": 136462,
                        "name": "Cadrezzate",
                        "latitude": "45.79927000",
                        "longitude": "8.64333000"
                    },
                    {
                        "id": 136469,
                        "name": "Caglio",
                        "latitude": "45.87146000",
                        "longitude": "9.23719000"
                    },
                    {
                        "id": 136472,
                        "name": "Cagno",
                        "latitude": "45.81108000",
                        "longitude": "8.91733000"
                    },
                    {
                        "id": 136478,
                        "name": "Caino",
                        "latitude": "45.60939000",
                        "longitude": "10.31317000"
                    },
                    {
                        "id": 136479,
                        "name": "Caiolo",
                        "latitude": "46.14999000",
                        "longitude": "9.81455000"
                    },
                    {
                        "id": 136482,
                        "name": "Cairate",
                        "latitude": "45.68750000",
                        "longitude": "8.86807000"
                    },
                    {
                        "id": 136502,
                        "name": "Calchera-Frontale",
                        "latitude": "45.83415000",
                        "longitude": "9.51155000"
                    },
                    {
                        "id": 136506,
                        "name": "Calcinate",
                        "latitude": "45.61975000",
                        "longitude": "9.79843000"
                    },
                    {
                        "id": 136507,
                        "name": "Calcinato",
                        "latitude": "45.45739000",
                        "longitude": "10.40949000"
                    },
                    {
                        "id": 136509,
                        "name": "Calcio",
                        "latitude": "45.50826000",
                        "longitude": "9.84902000"
                    },
                    {
                        "id": 136510,
                        "name": "Calco",
                        "latitude": "45.72418000",
                        "longitude": "9.41255000"
                    },
                    {
                        "id": 136523,
                        "name": "Caleppio",
                        "latitude": "45.43436000",
                        "longitude": "9.38250000"
                    },
                    {
                        "id": 136565,
                        "name": "Calò",
                        "latitude": "45.67908000",
                        "longitude": "9.26309000"
                    },
                    {
                        "id": 136535,
                        "name": "Calolziocorte",
                        "latitude": "45.79538000",
                        "longitude": "9.43765000"
                    },
                    {
                        "id": 136539,
                        "name": "Calozzo",
                        "latitude": "46.10055000",
                        "longitude": "9.27531000"
                    },
                    {
                        "id": 136548,
                        "name": "Calusco d'Adda",
                        "latitude": "45.68841000",
                        "longitude": "9.47109000"
                    },
                    {
                        "id": 136550,
                        "name": "Calvagese della Riviera",
                        "latitude": "45.53922000",
                        "longitude": "10.44605000"
                    },
                    {
                        "id": 136552,
                        "name": "Calvatone",
                        "latitude": "45.12697000",
                        "longitude": "10.44057000"
                    },
                    {
                        "id": 136555,
                        "name": "Calvenzano",
                        "latitude": "45.49621000",
                        "longitude": "9.59953000"
                    },
                    {
                        "id": 136560,
                        "name": "Calvignano",
                        "latitude": "44.98306000",
                        "longitude": "9.16876000"
                    },
                    {
                        "id": 136561,
                        "name": "Calvignasco",
                        "latitude": "45.32597000",
                        "longitude": "9.02775000"
                    },
                    {
                        "id": 136562,
                        "name": "Calvisano",
                        "latitude": "45.34529000",
                        "longitude": "10.34266000"
                    },
                    {
                        "id": 136568,
                        "name": "Camairago",
                        "latitude": "45.20527000",
                        "longitude": "9.72746000"
                    },
                    {
                        "id": 136572,
                        "name": "Cambiago",
                        "latitude": "45.58035000",
                        "longitude": "9.43528000"
                    },
                    {
                        "id": 136580,
                        "name": "Camerata Cornello",
                        "latitude": "45.89956000",
                        "longitude": "9.65569000"
                    },
                    {
                        "id": 136592,
                        "name": "Camisano",
                        "latitude": "45.44484000",
                        "longitude": "9.74526000"
                    },
                    {
                        "id": 136595,
                        "name": "Camnago-Boscone",
                        "latitude": "45.80472000",
                        "longitude": "8.97934000"
                    },
                    {
                        "id": 136598,
                        "name": "Camoneone",
                        "latitude": "45.78547000",
                        "longitude": "9.56910000"
                    },
                    {
                        "id": 136604,
                        "name": "Campagnola Cremasca",
                        "latitude": "45.39847000",
                        "longitude": "9.66946000"
                    },
                    {
                        "id": 136610,
                        "name": "Camparada",
                        "latitude": "45.65489000",
                        "longitude": "9.32328000"
                    },
                    {
                        "id": 136622,
                        "name": "Campione",
                        "latitude": "45.96818000",
                        "longitude": "8.97181000"
                    },
                    {
                        "id": 136623,
                        "name": "Campitello",
                        "latitude": "45.08750000",
                        "longitude": "10.60632000"
                    },
                    {
                        "id": 136648,
                        "name": "Campodolcino",
                        "latitude": "46.40290000",
                        "longitude": "9.35185000"
                    },
                    {
                        "id": 136653,
                        "name": "Campofiorenzo-California",
                        "latitude": "45.66768000",
                        "longitude": "9.31708000"
                    },
                    {
                        "id": 136682,
                        "name": "Campospinoso",
                        "latitude": "45.09403000",
                        "longitude": "9.24585000"
                    },
                    {
                        "id": 136701,
                        "name": "Candia Lomellina",
                        "latitude": "45.17670000",
                        "longitude": "8.59550000"
                    },
                    {
                        "id": 136707,
                        "name": "Canegrate",
                        "latitude": "45.56825000",
                        "longitude": "8.92689000"
                    },
                    {
                        "id": 136722,
                        "name": "Canneto",
                        "latitude": "45.05116000",
                        "longitude": "9.28101000"
                    },
                    {
                        "id": 136723,
                        "name": "Canneto Pavese",
                        "latitude": "45.05046000",
                        "longitude": "9.27876000"
                    },
                    {
                        "id": 136724,
                        "name": "Canneto sull'Oglio",
                        "latitude": "45.15163000",
                        "longitude": "10.38282000"
                    },
                    {
                        "id": 136729,
                        "name": "Canonica",
                        "latitude": "45.65587000",
                        "longitude": "9.28749000"
                    },
                    {
                        "id": 136730,
                        "name": "Canonica d'Adda",
                        "latitude": "45.57568000",
                        "longitude": "9.54165000"
                    },
                    {
                        "id": 136734,
                        "name": "Canova-San Zeno",
                        "latitude": "45.72116000",
                        "longitude": "9.40030000"
                    },
                    {
                        "id": 136741,
                        "name": "Cantalupo",
                        "latitude": "45.57813000",
                        "longitude": "8.98261000"
                    },
                    {
                        "id": 136746,
                        "name": "Cantello",
                        "latitude": "45.82248000",
                        "longitude": "8.89593000"
                    },
                    {
                        "id": 136751,
                        "name": "Cantù",
                        "latitude": "45.74096000",
                        "longitude": "9.13084000"
                    },
                    {
                        "id": 136753,
                        "name": "Canzo",
                        "latitude": "45.84867000",
                        "longitude": "9.27063000"
                    },
                    {
                        "id": 136764,
                        "name": "Capergnanica",
                        "latitude": "45.33869000",
                        "longitude": "9.64475000"
                    },
                    {
                        "id": 136768,
                        "name": "Capiago-Intimiano-Olmeda",
                        "latitude": "45.76898000",
                        "longitude": "9.12764000"
                    },
                    {
                        "id": 136779,
                        "name": "Capo di Ponte",
                        "latitude": "46.03000000",
                        "longitude": "10.34283000"
                    },
                    {
                        "id": 136785,
                        "name": "Caponago",
                        "latitude": "45.56647000",
                        "longitude": "9.37585000"
                    },
                    {
                        "id": 136789,
                        "name": "Capovalle",
                        "latitude": "45.75339000",
                        "longitude": "10.54447000"
                    },
                    {
                        "id": 136791,
                        "name": "Cappella Cantone",
                        "latitude": "45.24657000",
                        "longitude": "9.83826000"
                    },
                    {
                        "id": 136793,
                        "name": "Cappella de' Picenardi",
                        "latitude": "45.15857000",
                        "longitude": "10.22998000"
                    },
                    {
                        "id": 136795,
                        "name": "Cappelletta",
                        "latitude": "45.10514000",
                        "longitude": "10.77847000"
                    },
                    {
                        "id": 136800,
                        "name": "Capralba",
                        "latitude": "45.44352000",
                        "longitude": "9.64417000"
                    },
                    {
                        "id": 136812,
                        "name": "Capriano",
                        "latitude": "45.72298000",
                        "longitude": "9.25526000"
                    },
                    {
                        "id": 136813,
                        "name": "Capriano del Colle",
                        "latitude": "45.47478000",
                        "longitude": "10.13227000"
                    },
                    {
                        "id": 136815,
                        "name": "Capriate San Gervasio",
                        "latitude": "45.61281000",
                        "longitude": "9.52974000"
                    },
                    {
                        "id": 136821,
                        "name": "Caprino",
                        "latitude": "45.74903000",
                        "longitude": "9.49235000"
                    },
                    {
                        "id": 136823,
                        "name": "Capriolo",
                        "latitude": "45.63333000",
                        "longitude": "9.93189000"
                    },
                    {
                        "id": 136838,
                        "name": "Carate Brianza",
                        "latitude": "45.67574000",
                        "longitude": "9.23723000"
                    },
                    {
                        "id": 136839,
                        "name": "Carate Urio",
                        "latitude": "45.87178000",
                        "longitude": "9.12214000"
                    },
                    {
                        "id": 136840,
                        "name": "Caravaggio",
                        "latitude": "45.49627000",
                        "longitude": "9.64165000"
                    },
                    {
                        "id": 136841,
                        "name": "Caravate",
                        "latitude": "45.87862000",
                        "longitude": "8.65431000"
                    },
                    {
                        "id": 136846,
                        "name": "Carbonara al Ticino",
                        "latitude": "45.16374000",
                        "longitude": "9.06490000"
                    },
                    {
                        "id": 136848,
                        "name": "Carbonara di Po",
                        "latitude": "45.03537000",
                        "longitude": "11.22923000"
                    },
                    {
                        "id": 136849,
                        "name": "Carbonate",
                        "latitude": "45.68507000",
                        "longitude": "8.93814000"
                    },
                    {
                        "id": 136858,
                        "name": "Cardano al Campo",
                        "latitude": "45.64887000",
                        "longitude": "8.76933000"
                    },
                    {
                        "id": 136866,
                        "name": "Carenno",
                        "latitude": "45.80155000",
                        "longitude": "9.46301000"
                    },
                    {
                        "id": 136878,
                        "name": "Carimate",
                        "latitude": "45.70659000",
                        "longitude": "9.10751000"
                    },
                    {
                        "id": 136885,
                        "name": "Carlazzo",
                        "latitude": "46.04222000",
                        "longitude": "9.16498000"
                    },
                    {
                        "id": 136894,
                        "name": "Carnago",
                        "latitude": "45.72207000",
                        "longitude": "8.83423000"
                    },
                    {
                        "id": 136895,
                        "name": "Carnate",
                        "latitude": "45.64843000",
                        "longitude": "9.37813000"
                    },
                    {
                        "id": 136896,
                        "name": "Carobbio",
                        "latitude": "45.66424000",
                        "longitude": "9.83027000"
                    },
                    {
                        "id": 136897,
                        "name": "Carobbio degli Angeli",
                        "latitude": "45.66518000",
                        "longitude": "9.82916000"
                    },
                    {
                        "id": 136899,
                        "name": "Carona",
                        "latitude": "46.02149000",
                        "longitude": "9.78494000"
                    },
                    {
                        "id": 136901,
                        "name": "Caronno Pertusella",
                        "latitude": "45.59777000",
                        "longitude": "9.04634000"
                    },
                    {
                        "id": 136902,
                        "name": "Caronno Varesino",
                        "latitude": "45.73577000",
                        "longitude": "8.83173000"
                    },
                    {
                        "id": 136910,
                        "name": "Carpenedolo",
                        "latitude": "45.36169000",
                        "longitude": "10.43124000"
                    },
                    {
                        "id": 136914,
                        "name": "Carpiano",
                        "latitude": "45.34027000",
                        "longitude": "9.27401000"
                    },
                    {
                        "id": 136943,
                        "name": "Carugate",
                        "latitude": "45.54983000",
                        "longitude": "9.34044000"
                    },
                    {
                        "id": 136944,
                        "name": "Carugo",
                        "latitude": "45.70848000",
                        "longitude": "9.19684000"
                    },
                    {
                        "id": 136946,
                        "name": "Carvico",
                        "latitude": "45.70193000",
                        "longitude": "9.48580000"
                    },
                    {
                        "id": 136947,
                        "name": "Carzago Riviera",
                        "latitude": "45.52440000",
                        "longitude": "10.46052000"
                    },
                    {
                        "id": 136949,
                        "name": "Casa Ponte",
                        "latitude": "44.87777000",
                        "longitude": "9.16509000"
                    },
                    {
                        "id": 136969,
                        "name": "Casalbuttano",
                        "latitude": "45.25187000",
                        "longitude": "9.96167000"
                    },
                    {
                        "id": 136975,
                        "name": "Casale Cremasco",
                        "latitude": "45.43187000",
                        "longitude": "9.71416000"
                    },
                    {
                        "id": 136976,
                        "name": "Casale Litta",
                        "latitude": "45.76787000",
                        "longitude": "8.74133000"
                    },
                    {
                        "id": 136985,
                        "name": "Casaletto Ceredano",
                        "latitude": "45.31831000",
                        "longitude": "9.61701000"
                    },
                    {
                        "id": 136989,
                        "name": "Casaletto di Sopra",
                        "latitude": "45.41918000",
                        "longitude": "9.78256000"
                    },
                    {
                        "id": 136986,
                        "name": "Casaletto Lodigiano",
                        "latitude": "45.29337000",
                        "longitude": "9.36194000"
                    },
                    {
                        "id": 136988,
                        "name": "Casaletto Vaprio",
                        "latitude": "45.40817000",
                        "longitude": "9.62876000"
                    },
                    {
                        "id": 136998,
                        "name": "Casalmaggiore",
                        "latitude": "44.98981000",
                        "longitude": "10.42055000"
                    },
                    {
                        "id": 136999,
                        "name": "Casalmaiocco",
                        "latitude": "45.35238000",
                        "longitude": "9.37088000"
                    },
                    {
                        "id": 137000,
                        "name": "Casalmorano",
                        "latitude": "45.28766000",
                        "longitude": "9.89860000"
                    },
                    {
                        "id": 137001,
                        "name": "Casalmoro",
                        "latitude": "45.26115000",
                        "longitude": "10.41118000"
                    },
                    {
                        "id": 137005,
                        "name": "Casaloldo",
                        "latitude": "45.25436000",
                        "longitude": "10.47691000"
                    },
                    {
                        "id": 137006,
                        "name": "Casalpusterlengo",
                        "latitude": "45.17921000",
                        "longitude": "9.64834000"
                    },
                    {
                        "id": 137007,
                        "name": "Casalromano",
                        "latitude": "45.19808000",
                        "longitude": "10.36640000"
                    },
                    {
                        "id": 137014,
                        "name": "Casalzuigno",
                        "latitude": "45.90508000",
                        "longitude": "8.70883000"
                    },
                    {
                        "id": 137024,
                        "name": "Casanova Lonati",
                        "latitude": "45.09446000",
                        "longitude": "9.21345000"
                    },
                    {
                        "id": 137032,
                        "name": "Casargo",
                        "latitude": "46.03950000",
                        "longitude": "9.38717000"
                    },
                    {
                        "id": 137033,
                        "name": "Casarile",
                        "latitude": "45.31683000",
                        "longitude": "9.10383000"
                    },
                    {
                        "id": 137037,
                        "name": "Casasco Intelvi",
                        "latitude": "45.94368000",
                        "longitude": "9.07574000"
                    },
                    {
                        "id": 137038,
                        "name": "Casate",
                        "latitude": "45.49203000",
                        "longitude": "8.82776000"
                    },
                    {
                        "id": 137039,
                        "name": "Casatenovo",
                        "latitude": "45.69514000",
                        "longitude": "9.31338000"
                    },
                    {
                        "id": 137040,
                        "name": "Casatisma",
                        "latitude": "45.04569000",
                        "longitude": "9.13099000"
                    },
                    {
                        "id": 137043,
                        "name": "Casazza",
                        "latitude": "45.74855000",
                        "longitude": "9.90627000"
                    },
                    {
                        "id": 137046,
                        "name": "Casciago",
                        "latitude": "45.83248000",
                        "longitude": "8.78333000"
                    },
                    {
                        "id": 137049,
                        "name": "Cascina Elisa",
                        "latitude": "45.60425000",
                        "longitude": "8.79978000"
                    },
                    {
                        "id": 137053,
                        "name": "Casco",
                        "latitude": "45.71078000",
                        "longitude": "9.82483000"
                    },
                    {
                        "id": 137055,
                        "name": "Case Nuove",
                        "latitude": "45.60998000",
                        "longitude": "10.39416000"
                    },
                    {
                        "id": 137056,
                        "name": "Casei",
                        "latitude": "45.00756000",
                        "longitude": "8.92675000"
                    },
                    {
                        "id": 137060,
                        "name": "Caselle Landi",
                        "latitude": "45.10257000",
                        "longitude": "9.79557000"
                    },
                    {
                        "id": 137061,
                        "name": "Caselle Lurani",
                        "latitude": "45.28044000",
                        "longitude": "9.36016000"
                    },
                    {
                        "id": 137064,
                        "name": "Caseo",
                        "latitude": "44.94369000",
                        "longitude": "9.27504000"
                    },
                    {
                        "id": 137073,
                        "name": "Casirate d'Adda",
                        "latitude": "45.49535000",
                        "longitude": "9.56932000"
                    },
                    {
                        "id": 137074,
                        "name": "Caslino d'Erba",
                        "latitude": "45.83899000",
                        "longitude": "9.22554000"
                    },
                    {
                        "id": 137075,
                        "name": "Casnate Con Bernate",
                        "latitude": "45.75628000",
                        "longitude": "9.07264000"
                    },
                    {
                        "id": 137076,
                        "name": "Casnigo",
                        "latitude": "45.81307000",
                        "longitude": "9.86878000"
                    },
                    {
                        "id": 137084,
                        "name": "Casone",
                        "latitude": "45.49818000",
                        "longitude": "8.87635000"
                    },
                    {
                        "id": 137086,
                        "name": "Casorate Primo",
                        "latitude": "45.31142000",
                        "longitude": "9.01703000"
                    },
                    {
                        "id": 137087,
                        "name": "Casorate Sempione",
                        "latitude": "45.67079000",
                        "longitude": "8.74513000"
                    },
                    {
                        "id": 137088,
                        "name": "Casorezzo",
                        "latitude": "45.52265000",
                        "longitude": "8.90186000"
                    },
                    {
                        "id": 137092,
                        "name": "Caspoggio",
                        "latitude": "46.26424000",
                        "longitude": "9.86165000"
                    },
                    {
                        "id": 137094,
                        "name": "Cassago Brianza",
                        "latitude": "45.73808000",
                        "longitude": "9.29344000"
                    },
                    {
                        "id": 137100,
                        "name": "Cassano d'Adda",
                        "latitude": "45.52637000",
                        "longitude": "9.51528000"
                    },
                    {
                        "id": 137097,
                        "name": "Cassano Magnago",
                        "latitude": "45.67206000",
                        "longitude": "8.82691000"
                    },
                    {
                        "id": 137099,
                        "name": "Cassano Valcuvia",
                        "latitude": "45.93238000",
                        "longitude": "8.76843000"
                    },
                    {
                        "id": 137104,
                        "name": "Cassiglio",
                        "latitude": "45.96679000",
                        "longitude": "9.61215000"
                    },
                    {
                        "id": 137107,
                        "name": "Cassina de' Pecchi",
                        "latitude": "45.51637000",
                        "longitude": "9.35975000"
                    },
                    {
                        "id": 137105,
                        "name": "Cassina Rizzardi",
                        "latitude": "45.75228000",
                        "longitude": "9.02454000"
                    },
                    {
                        "id": 137106,
                        "name": "Cassina Valsassina",
                        "latitude": "45.93209000",
                        "longitude": "9.47894000"
                    },
                    {
                        "id": 137111,
                        "name": "Cassinetta di Lugagnano",
                        "latitude": "45.42247000",
                        "longitude": "8.90604000"
                    },
                    {
                        "id": 137113,
                        "name": "Cassino d'Alberi",
                        "latitude": "45.39208000",
                        "longitude": "9.39090000"
                    },
                    {
                        "id": 137115,
                        "name": "Cassolnovo",
                        "latitude": "45.36106000",
                        "longitude": "8.81230000"
                    },
                    {
                        "id": 137124,
                        "name": "Castana",
                        "latitude": "45.02676000",
                        "longitude": "9.27246000"
                    },
                    {
                        "id": 137126,
                        "name": "Castano Primo",
                        "latitude": "45.55175000",
                        "longitude": "8.77562000"
                    },
                    {
                        "id": 137127,
                        "name": "Casteggio",
                        "latitude": "45.01396000",
                        "longitude": "9.12528000"
                    },
                    {
                        "id": 137128,
                        "name": "Castegnato",
                        "latitude": "45.56129000",
                        "longitude": "10.11449000"
                    },
                    {
                        "id": 137163,
                        "name": "Castel d'Ario",
                        "latitude": "45.18798000",
                        "longitude": "10.97449000"
                    },
                    {
                        "id": 137138,
                        "name": "Castel Gabbiano",
                        "latitude": "45.46847000",
                        "longitude": "9.71765000"
                    },
                    {
                        "id": 137141,
                        "name": "Castel Goffredo",
                        "latitude": "45.29403000",
                        "longitude": "10.47300000"
                    },
                    {
                        "id": 137145,
                        "name": "Castel Mella",
                        "latitude": "45.49913000",
                        "longitude": "10.14553000"
                    },
                    {
                        "id": 137149,
                        "name": "Castel Rozzone",
                        "latitude": "45.55228000",
                        "longitude": "9.61985000"
                    },
                    {
                        "id": 137177,
                        "name": "Castelbelforte",
                        "latitude": "45.21208000",
                        "longitude": "10.89249000"
                    },
                    {
                        "id": 137186,
                        "name": "Castelcovati",
                        "latitude": "45.50198000",
                        "longitude": "9.94596000"
                    },
                    {
                        "id": 137191,
                        "name": "Casteldidone",
                        "latitude": "45.07068000",
                        "longitude": "10.40581000"
                    },
                    {
                        "id": 137219,
                        "name": "Castellanza",
                        "latitude": "45.61079000",
                        "longitude": "8.89616000"
                    },
                    {
                        "id": 137226,
                        "name": "Castelleone",
                        "latitude": "45.29579000",
                        "longitude": "9.76091000"
                    },
                    {
                        "id": 137230,
                        "name": "Castelletto",
                        "latitude": "45.33150000",
                        "longitude": "10.23335000"
                    },
                    {
                        "id": 137241,
                        "name": "Castelletto di Branduzzo",
                        "latitude": "45.06936000",
                        "longitude": "9.09845000"
                    },
                    {
                        "id": 137235,
                        "name": "Castelletto Po",
                        "latitude": "45.06903000",
                        "longitude": "9.10056000"
                    },
                    {
                        "id": 137243,
                        "name": "Castelli Calepio",
                        "latitude": "45.61316000",
                        "longitude": "9.88540000"
                    },
                    {
                        "id": 137251,
                        "name": "Castello",
                        "latitude": "45.56954000",
                        "longitude": "10.50861000"
                    },
                    {
                        "id": 137252,
                        "name": "Castello Cabiaglio",
                        "latitude": "45.89358000",
                        "longitude": "8.75763000"
                    },
                    {
                        "id": 137255,
                        "name": "Castello d'Agogna",
                        "latitude": "45.23456000",
                        "longitude": "8.68714000"
                    },
                    {
                        "id": 137258,
                        "name": "Castello dell'Acqua",
                        "latitude": "46.14549000",
                        "longitude": "10.01582000"
                    },
                    {
                        "id": 137260,
                        "name": "Castello di Brianza",
                        "latitude": "45.75928000",
                        "longitude": "9.34535000"
                    },
                    {
                        "id": 137263,
                        "name": "Castellucchio",
                        "latitude": "45.15038000",
                        "longitude": "10.64875000"
                    },
                    {
                        "id": 137269,
                        "name": "Castelmarte",
                        "latitude": "45.83238000",
                        "longitude": "9.23304000"
                    },
                    {
                        "id": 137276,
                        "name": "Castelnovetto",
                        "latitude": "45.25438000",
                        "longitude": "8.61142000"
                    },
                    {
                        "id": 137284,
                        "name": "Castelnuovo Bocca d'Adda",
                        "latitude": "45.11147000",
                        "longitude": "9.86359000"
                    },
                    {
                        "id": 137286,
                        "name": "Castelnuovo Bozzente",
                        "latitude": "45.76458000",
                        "longitude": "8.94354000"
                    },
                    {
                        "id": 137315,
                        "name": "Castelseprio",
                        "latitude": "45.71372000",
                        "longitude": "8.86161000"
                    },
                    {
                        "id": 137320,
                        "name": "Castelveccana",
                        "latitude": "45.94798000",
                        "longitude": "8.66633000"
                    },
                    {
                        "id": 137325,
                        "name": "Castelverde",
                        "latitude": "45.18753000",
                        "longitude": "9.99693000"
                    },
                    {
                        "id": 137332,
                        "name": "Castelvisconti",
                        "latitude": "45.30537000",
                        "longitude": "9.94107000"
                    },
                    {
                        "id": 137334,
                        "name": "Castenedolo",
                        "latitude": "45.47430000",
                        "longitude": "10.29131000"
                    },
                    {
                        "id": 137348,
                        "name": "Castiglione d'Adda",
                        "latitude": "45.21702000",
                        "longitude": "9.69279000"
                    },
                    {
                        "id": 137349,
                        "name": "Castiglione d'Intelvi",
                        "latitude": "45.95751000",
                        "longitude": "9.08987000"
                    },
                    {
                        "id": 137355,
                        "name": "Castiglione delle Stiviere",
                        "latitude": "45.39020000",
                        "longitude": "10.48619000"
                    },
                    {
                        "id": 137344,
                        "name": "Castiglione Olona",
                        "latitude": "45.75256000",
                        "longitude": "8.87278000"
                    },
                    {
                        "id": 137363,
                        "name": "Castione",
                        "latitude": "46.17287000",
                        "longitude": "9.80032000"
                    },
                    {
                        "id": 137364,
                        "name": "Castione Andevenno",
                        "latitude": "46.17279000",
                        "longitude": "9.80025000"
                    },
                    {
                        "id": 137365,
                        "name": "Castione della Presolana",
                        "latitude": "45.91471000",
                        "longitude": "10.05540000"
                    },
                    {
                        "id": 137368,
                        "name": "Castiraga Vidardo",
                        "latitude": "45.25727000",
                        "longitude": "9.40456000"
                    },
                    {
                        "id": 137369,
                        "name": "Casto",
                        "latitude": "45.69489000",
                        "longitude": "10.32117000"
                    },
                    {
                        "id": 137371,
                        "name": "Castrezzato",
                        "latitude": "45.51128000",
                        "longitude": "9.98086000"
                    },
                    {
                        "id": 137375,
                        "name": "Castro",
                        "latitude": "45.80378000",
                        "longitude": "10.06590000"
                    },
                    {
                        "id": 137383,
                        "name": "Castronno",
                        "latitude": "45.74793000",
                        "longitude": "8.81442000"
                    },
                    {
                        "id": 137390,
                        "name": "Cataeggio",
                        "latitude": "46.21447000",
                        "longitude": "9.63781000"
                    },
                    {
                        "id": 137402,
                        "name": "Cava Manara",
                        "latitude": "45.14014000",
                        "longitude": "9.10774000"
                    },
                    {
                        "id": 137405,
                        "name": "Cavacurta",
                        "latitude": "45.18977000",
                        "longitude": "9.74186000"
                    },
                    {
                        "id": 137414,
                        "name": "Cavallasca",
                        "latitude": "45.80958000",
                        "longitude": "9.03284000"
                    },
                    {
                        "id": 137422,
                        "name": "Cavargna",
                        "latitude": "46.09068000",
                        "longitude": "9.11205000"
                    },
                    {
                        "id": 137423,
                        "name": "Cavaria Con Premezzo",
                        "latitude": "45.69247000",
                        "longitude": "8.80299000"
                    },
                    {
                        "id": 137433,
                        "name": "Cavenago d'Adda",
                        "latitude": "45.28253000",
                        "longitude": "9.59872000"
                    },
                    {
                        "id": 137434,
                        "name": "Cavenago di Brianza",
                        "latitude": "45.58297000",
                        "longitude": "9.41261000"
                    },
                    {
                        "id": 137435,
                        "name": "Cavernago",
                        "latitude": "45.62528000",
                        "longitude": "9.76556000"
                    },
                    {
                        "id": 137443,
                        "name": "Cavriana",
                        "latitude": "45.34766000",
                        "longitude": "10.59598000"
                    },
                    {
                        "id": 137445,
                        "name": "Cazzago Brabbia",
                        "latitude": "45.79588000",
                        "longitude": "8.73483000"
                    },
                    {
                        "id": 137446,
                        "name": "Cazzago San Martino-Calino",
                        "latitude": "45.58434000",
                        "longitude": "10.02328000"
                    },
                    {
                        "id": 137448,
                        "name": "Cazzano Sant'Andrea",
                        "latitude": "45.81118000",
                        "longitude": "9.88493000"
                    },
                    {
                        "id": 137453,
                        "name": "Cecima",
                        "latitude": "44.85066000",
                        "longitude": "9.08036000"
                    },
                    {
                        "id": 137455,
                        "name": "Cedegolo",
                        "latitude": "46.07398000",
                        "longitude": "10.35141000"
                    },
                    {
                        "id": 137456,
                        "name": "Cedessano",
                        "latitude": "45.68858000",
                        "longitude": "10.43395000"
                    },
                    {
                        "id": 137457,
                        "name": "Cedrasco",
                        "latitude": "46.14932000",
                        "longitude": "9.76803000"
                    },
                    {
                        "id": 137467,
                        "name": "Cella Dati",
                        "latitude": "45.09527000",
                        "longitude": "10.22148000"
                    },
                    {
                        "id": 137472,
                        "name": "Cellatica",
                        "latitude": "45.58198000",
                        "longitude": "10.18017000"
                    },
                    {
                        "id": 137488,
                        "name": "Cenate di Sotto",
                        "latitude": "45.69898000",
                        "longitude": "9.82636000"
                    },
                    {
                        "id": 137487,
                        "name": "Cenate Sopra",
                        "latitude": "45.71298000",
                        "longitude": "9.82216000"
                    },
                    {
                        "id": 137491,
                        "name": "Cene",
                        "latitude": "45.78062000",
                        "longitude": "9.82657000"
                    },
                    {
                        "id": 137507,
                        "name": "Cepina",
                        "latitude": "46.43609000",
                        "longitude": "10.35713000"
                    },
                    {
                        "id": 137515,
                        "name": "Cerano d'Intelvi",
                        "latitude": "45.94447000",
                        "longitude": "9.08767000"
                    },
                    {
                        "id": 137516,
                        "name": "Ceranova",
                        "latitude": "45.26027000",
                        "longitude": "9.24315000"
                    },
                    {
                        "id": 137526,
                        "name": "Cercino",
                        "latitude": "46.15809000",
                        "longitude": "9.50814000"
                    },
                    {
                        "id": 137533,
                        "name": "Cerello-Battuello",
                        "latitude": "45.44716000",
                        "longitude": "8.93105000"
                    },
                    {
                        "id": 137537,
                        "name": "Ceresara",
                        "latitude": "45.26228000",
                        "longitude": "10.56958000"
                    },
                    {
                        "id": 137538,
                        "name": "Cerese",
                        "latitude": "45.11814000",
                        "longitude": "10.78877000"
                    },
                    {
                        "id": 137542,
                        "name": "Cerete Alto",
                        "latitude": "45.86729000",
                        "longitude": "9.99466000"
                    },
                    {
                        "id": 137543,
                        "name": "Ceretto Lomellina",
                        "latitude": "45.24496000",
                        "longitude": "8.67244000"
                    },
                    {
                        "id": 137545,
                        "name": "Cergnago",
                        "latitude": "45.19826000",
                        "longitude": "8.77164000"
                    },
                    {
                        "id": 137548,
                        "name": "Ceriano Laghetto",
                        "latitude": "45.62928000",
                        "longitude": "9.08017000"
                    },
                    {
                        "id": 137552,
                        "name": "Cerlongo",
                        "latitude": "45.27862000",
                        "longitude": "10.64985000"
                    },
                    {
                        "id": 137553,
                        "name": "Cermenate",
                        "latitude": "45.70198000",
                        "longitude": "9.08361000"
                    },
                    {
                        "id": 137556,
                        "name": "Cernobbio",
                        "latitude": "45.84307000",
                        "longitude": "9.07194000"
                    },
                    {
                        "id": 137557,
                        "name": "Cernusco Lombardone",
                        "latitude": "45.69088000",
                        "longitude": "9.39925000"
                    },
                    {
                        "id": 137558,
                        "name": "Cernusco sul Naviglio",
                        "latitude": "45.52526000",
                        "longitude": "9.33297000"
                    },
                    {
                        "id": 137575,
                        "name": "Cerro al Lambro",
                        "latitude": "45.32997000",
                        "longitude": "9.33905000"
                    },
                    {
                        "id": 137572,
                        "name": "Cerro Maggiore",
                        "latitude": "45.59366000",
                        "longitude": "8.95428000"
                    },
                    {
                        "id": 137580,
                        "name": "Certosa di Pavia",
                        "latitude": "45.25420000",
                        "longitude": "9.13290000"
                    },
                    {
                        "id": 137587,
                        "name": "Cerveno",
                        "latitude": "46.00176000",
                        "longitude": "10.32830000"
                    },
                    {
                        "id": 137589,
                        "name": "Cervesina",
                        "latitude": "45.06054000",
                        "longitude": "9.01676000"
                    },
                    {
                        "id": 137593,
                        "name": "Cervignano d'Adda",
                        "latitude": "45.37387000",
                        "longitude": "9.42405000"
                    },
                    {
                        "id": 137602,
                        "name": "Cesana Brianza",
                        "latitude": "45.81678000",
                        "longitude": "9.29954000"
                    },
                    {
                        "id": 137605,
                        "name": "Cesano Boscone",
                        "latitude": "45.44207000",
                        "longitude": "9.09445000"
                    },
                    {
                        "id": 137606,
                        "name": "Cesano Maderno",
                        "latitude": "45.62915000",
                        "longitude": "9.15189000"
                    },
                    {
                        "id": 137610,
                        "name": "Cesate",
                        "latitude": "45.59587000",
                        "longitude": "9.07574000"
                    },
                    {
                        "id": 137621,
                        "name": "Ceto",
                        "latitude": "46.00259000",
                        "longitude": "10.35196000"
                    },
                    {
                        "id": 137626,
                        "name": "Cevo",
                        "latitude": "46.08089000",
                        "longitude": "10.36952000"
                    },
                    {
                        "id": 137652,
                        "name": "Chiaravalle",
                        "latitude": "45.41731000",
                        "longitude": "9.23985000"
                    },
                    {
                        "id": 137654,
                        "name": "Chiari",
                        "latitude": "45.53763000",
                        "longitude": "9.92699000"
                    },
                    {
                        "id": 137660,
                        "name": "Chiavenna",
                        "latitude": "46.32063000",
                        "longitude": "9.39816000"
                    },
                    {
                        "id": 137664,
                        "name": "Chiesa",
                        "latitude": "45.69011000",
                        "longitude": "9.91282000"
                    },
                    {
                        "id": 137668,
                        "name": "Chiesa in Valmalenco",
                        "latitude": "46.26715000",
                        "longitude": "9.84905000"
                    },
                    {
                        "id": 137674,
                        "name": "Chieve",
                        "latitude": "45.34047000",
                        "longitude": "9.61646000"
                    },
                    {
                        "id": 137676,
                        "name": "Chignolo d'Isola",
                        "latitude": "45.66758000",
                        "longitude": "9.52765000"
                    },
                    {
                        "id": 137675,
                        "name": "Chignolo Po",
                        "latitude": "45.14817000",
                        "longitude": "9.48156000"
                    },
                    {
                        "id": 137682,
                        "name": "Chiuduno",
                        "latitude": "45.65068000",
                        "longitude": "9.84946000"
                    },
                    {
                        "id": 137685,
                        "name": "Chiuro",
                        "latitude": "46.16722000",
                        "longitude": "9.98584000"
                    },
                    {
                        "id": 137712,
                        "name": "Cicognolo",
                        "latitude": "45.16762000",
                        "longitude": "10.19407000"
                    },
                    {
                        "id": 137717,
                        "name": "Cigognola",
                        "latitude": "45.03276000",
                        "longitude": "9.24486000"
                    },
                    {
                        "id": 137718,
                        "name": "Cigole",
                        "latitude": "45.30760000",
                        "longitude": "10.18977000"
                    },
                    {
                        "id": 137719,
                        "name": "Cilavegna",
                        "latitude": "45.31067000",
                        "longitude": "8.74469000"
                    },
                    {
                        "id": 137721,
                        "name": "Cimbergo",
                        "latitude": "46.02410000",
                        "longitude": "10.36566000"
                    },
                    {
                        "id": 137722,
                        "name": "Cimbro",
                        "latitude": "45.73570000",
                        "longitude": "8.72050000"
                    },
                    {
                        "id": 137731,
                        "name": "Cingia de' Botti",
                        "latitude": "45.08507000",
                        "longitude": "10.27548000"
                    },
                    {
                        "id": 137734,
                        "name": "Cinisello Balsamo",
                        "latitude": "45.55823000",
                        "longitude": "9.21495000"
                    },
                    {
                        "id": 137736,
                        "name": "Cino",
                        "latitude": "46.15843000",
                        "longitude": "9.48534000"
                    },
                    {
                        "id": 137748,
                        "name": "Cirimido",
                        "latitude": "45.69978000",
                        "longitude": "9.01254000"
                    },
                    {
                        "id": 137754,
                        "name": "Cisano Bergamasco",
                        "latitude": "45.74200000",
                        "longitude": "9.47146000"
                    },
                    {
                        "id": 137755,
                        "name": "Ciserano",
                        "latitude": "45.58792000",
                        "longitude": "9.60115000"
                    },
                    {
                        "id": 137756,
                        "name": "Cislago",
                        "latitude": "45.65928000",
                        "longitude": "8.97272000"
                    },
                    {
                        "id": 137757,
                        "name": "Cisliano",
                        "latitude": "45.44371000",
                        "longitude": "8.98695000"
                    },
                    {
                        "id": 137770,
                        "name": "Cittiglio",
                        "latitude": "45.89587000",
                        "longitude": "8.66551000"
                    },
                    {
                        "id": 137777,
                        "name": "Civate",
                        "latitude": "45.82808000",
                        "longitude": "9.34294000"
                    },
                    {
                        "id": 137778,
                        "name": "Civesio",
                        "latitude": "45.39556000",
                        "longitude": "9.26680000"
                    },
                    {
                        "id": 137784,
                        "name": "Cividate al Piano",
                        "latitude": "45.55465000",
                        "longitude": "9.83024000"
                    },
                    {
                        "id": 137783,
                        "name": "Cividate Camuno",
                        "latitude": "45.94087000",
                        "longitude": "10.26610000"
                    },
                    {
                        "id": 137805,
                        "name": "Cizzago-Comezzano",
                        "latitude": "45.46880000",
                        "longitude": "9.95816000"
                    },
                    {
                        "id": 137813,
                        "name": "Clivio",
                        "latitude": "45.86278000",
                        "longitude": "8.93083000"
                    },
                    {
                        "id": 137816,
                        "name": "Clusane",
                        "latitude": "45.66247000",
                        "longitude": "10.00005000"
                    },
                    {
                        "id": 137817,
                        "name": "Clusone",
                        "latitude": "45.88663000",
                        "longitude": "9.94646000"
                    },
                    {
                        "id": 137822,
                        "name": "Coccaglio",
                        "latitude": "45.56399000",
                        "longitude": "9.97224000"
                    },
                    {
                        "id": 137825,
                        "name": "Cocquio",
                        "latitude": "45.86288000",
                        "longitude": "8.68823000"
                    },
                    {
                        "id": 137830,
                        "name": "Codevilla",
                        "latitude": "44.96353000",
                        "longitude": "9.05773000"
                    },
                    {
                        "id": 137834,
                        "name": "Codogna-Cardano",
                        "latitude": "46.02769000",
                        "longitude": "9.20992000"
                    },
                    {
                        "id": 137835,
                        "name": "Codogno",
                        "latitude": "45.16187000",
                        "longitude": "9.70216000"
                    },
                    {
                        "id": 137840,
                        "name": "Cogliate",
                        "latitude": "45.64597000",
                        "longitude": "9.07884000"
                    },
                    {
                        "id": 137850,
                        "name": "Colere",
                        "latitude": "45.97522000",
                        "longitude": "10.08356000"
                    },
                    {
                        "id": 137852,
                        "name": "Colico Piano",
                        "latitude": "46.13205000",
                        "longitude": "9.37714000"
                    },
                    {
                        "id": 137853,
                        "name": "Colla-Muggiasca",
                        "latitude": "45.98343000",
                        "longitude": "9.62277000"
                    },
                    {
                        "id": 137859,
                        "name": "Colle Brianza",
                        "latitude": "45.76238000",
                        "longitude": "9.36435000"
                    },
                    {
                        "id": 137874,
                        "name": "Collebeato",
                        "latitude": "45.58118000",
                        "longitude": "10.21017000"
                    },
                    {
                        "id": 137904,
                        "name": "Collio",
                        "latitude": "45.81088000",
                        "longitude": "10.33511000"
                    },
                    {
                        "id": 137913,
                        "name": "Cologna-Caraverio",
                        "latitude": "45.75611000",
                        "longitude": "9.34579000"
                    },
                    {
                        "id": 137914,
                        "name": "Cologne",
                        "latitude": "45.57862000",
                        "longitude": "9.94180000"
                    },
                    {
                        "id": 137916,
                        "name": "Cologno al Serio",
                        "latitude": "45.57604000",
                        "longitude": "9.70892000"
                    },
                    {
                        "id": 137915,
                        "name": "Cologno Monzese",
                        "latitude": "45.53004000",
                        "longitude": "9.27795000"
                    },
                    {
                        "id": 137919,
                        "name": "Colombaro-Timoline",
                        "latitude": "45.64405000",
                        "longitude": "9.99413000"
                    },
                    {
                        "id": 137924,
                        "name": "Colonno",
                        "latitude": "45.95768000",
                        "longitude": "9.15294000"
                    },
                    {
                        "id": 137925,
                        "name": "Colorina",
                        "latitude": "46.15369000",
                        "longitude": "9.72935000"
                    },
                    {
                        "id": 137928,
                        "name": "Colturano",
                        "latitude": "45.38151000",
                        "longitude": "9.33443000"
                    },
                    {
                        "id": 137931,
                        "name": "Colzate",
                        "latitude": "45.81719000",
                        "longitude": "9.85615000"
                    },
                    {
                        "id": 137933,
                        "name": "Comabbio",
                        "latitude": "45.77359000",
                        "longitude": "8.67833000"
                    },
                    {
                        "id": 137936,
                        "name": "Comazzo",
                        "latitude": "45.44190000",
                        "longitude": "9.46278000"
                    },
                    {
                        "id": 137939,
                        "name": "Comerio",
                        "latitude": "45.84191000",
                        "longitude": "8.74207000"
                    },
                    {
                        "id": 137945,
                        "name": "Commessaggio",
                        "latitude": "45.03754000",
                        "longitude": "10.54535000"
                    },
                    {
                        "id": 137947,
                        "name": "Como",
                        "latitude": "45.80819000",
                        "longitude": "9.08320000"
                    },
                    {
                        "id": 137950,
                        "name": "Comun Nuovo",
                        "latitude": "45.62291000",
                        "longitude": "9.66200000"
                    },
                    {
                        "id": 137957,
                        "name": "Concesio",
                        "latitude": "45.60518000",
                        "longitude": "10.21697000"
                    },
                    {
                        "id": 137961,
                        "name": "Concorezzo",
                        "latitude": "45.58854000",
                        "longitude": "9.33393000"
                    },
                    {
                        "id": 137967,
                        "name": "Confienza",
                        "latitude": "45.33148000",
                        "longitude": "8.55886000"
                    },
                    {
                        "id": 137976,
                        "name": "Consiglio di Rumo",
                        "latitude": "46.14299000",
                        "longitude": "9.29334000"
                    },
                    {
                        "id": 137987,
                        "name": "Copiano",
                        "latitude": "45.19750000",
                        "longitude": "9.32462000"
                    },
                    {
                        "id": 137990,
                        "name": "Corana",
                        "latitude": "45.06289000",
                        "longitude": "8.96952000"
                    },
                    {
                        "id": 137994,
                        "name": "Corbetta",
                        "latitude": "45.46723000",
                        "longitude": "8.91867000"
                    },
                    {
                        "id": 138009,
                        "name": "Corgeno",
                        "latitude": "45.74588000",
                        "longitude": "8.68797000"
                    },
                    {
                        "id": 138020,
                        "name": "Cormano",
                        "latitude": "45.54917000",
                        "longitude": "9.15964000"
                    },
                    {
                        "id": 138022,
                        "name": "Corna Imagna",
                        "latitude": "45.83068000",
                        "longitude": "9.54485000"
                    },
                    {
                        "id": 138024,
                        "name": "Cornalba",
                        "latitude": "45.84927000",
                        "longitude": "9.74593000"
                    },
                    {
                        "id": 138025,
                        "name": "Cornale",
                        "latitude": "45.04344000",
                        "longitude": "8.91096000"
                    },
                    {
                        "id": 138026,
                        "name": "Cornaredo",
                        "latitude": "45.50128000",
                        "longitude": "9.02681000"
                    },
                    {
                        "id": 138027,
                        "name": "Cornate d'Adda",
                        "latitude": "45.62811000",
                        "longitude": "9.47378000"
                    },
                    {
                        "id": 138031,
                        "name": "Corneno-Galliano-Carella Mariaga",
                        "latitude": "45.81667000",
                        "longitude": "9.26667000"
                    },
                    {
                        "id": 138033,
                        "name": "Corno Giovine",
                        "latitude": "45.13415000",
                        "longitude": "9.75766000"
                    },
                    {
                        "id": 138035,
                        "name": "Cornovecchio",
                        "latitude": "45.13667000",
                        "longitude": "9.79937000"
                    },
                    {
                        "id": 138040,
                        "name": "Correzzana",
                        "latitude": "45.66658000",
                        "longitude": "9.30755000"
                    },
                    {
                        "id": 138042,
                        "name": "Corrido",
                        "latitude": "46.04758000",
                        "longitude": "9.13554000"
                    },
                    {
                        "id": 138048,
                        "name": "Corsico",
                        "latitude": "45.43099000",
                        "longitude": "9.11093000"
                    },
                    {
                        "id": 138057,
                        "name": "Corte de' Cortesi",
                        "latitude": "45.27265000",
                        "longitude": "10.00738000"
                    },
                    {
                        "id": 138058,
                        "name": "Corte de' Cortesi con Cignone",
                        "latitude": "45.27317000",
                        "longitude": "10.00787000"
                    },
                    {
                        "id": 138059,
                        "name": "Corte de' Frati",
                        "latitude": "45.21847000",
                        "longitude": "10.10187000"
                    },
                    {
                        "id": 138056,
                        "name": "Corte Franca",
                        "latitude": "45.62998000",
                        "longitude": "9.98846000"
                    },
                    {
                        "id": 138062,
                        "name": "Corteno Golgi",
                        "latitude": "46.16620000",
                        "longitude": "10.24346000"
                    },
                    {
                        "id": 138063,
                        "name": "Cortenova",
                        "latitude": "46.00029000",
                        "longitude": "9.38454000"
                    },
                    {
                        "id": 138064,
                        "name": "Cortenuova",
                        "latitude": "45.53898000",
                        "longitude": "9.78786000"
                    },
                    {
                        "id": 138065,
                        "name": "Corteolona",
                        "latitude": "45.15787000",
                        "longitude": "9.37215000"
                    },
                    {
                        "id": 138075,
                        "name": "Corvino San Quirico",
                        "latitude": "45.01086000",
                        "longitude": "9.16245000"
                    },
                    {
                        "id": 138076,
                        "name": "Corzano",
                        "latitude": "45.44378000",
                        "longitude": "10.00737000"
                    },
                    {
                        "id": 138079,
                        "name": "Cosio Valtellino",
                        "latitude": "46.13509000",
                        "longitude": "9.55164000"
                    },
                    {
                        "id": 138097,
                        "name": "Costa de' Nobili",
                        "latitude": "45.13217000",
                        "longitude": "9.37886000"
                    },
                    {
                        "id": 138098,
                        "name": "Costa di Mezzate",
                        "latitude": "45.66278000",
                        "longitude": "9.79556000"
                    },
                    {
                        "id": 138100,
                        "name": "Costa di Serina",
                        "latitude": "45.83268000",
                        "longitude": "9.74165000"
                    },
                    {
                        "id": 138091,
                        "name": "Costa Lambro",
                        "latitude": "45.68531000",
                        "longitude": "9.24728000"
                    },
                    {
                        "id": 138092,
                        "name": "Costa Masnaga",
                        "latitude": "45.76963000",
                        "longitude": "9.27632000"
                    },
                    {
                        "id": 138093,
                        "name": "Costa Sant'Abramo",
                        "latitude": "45.16667000",
                        "longitude": "9.96667000"
                    },
                    {
                        "id": 138094,
                        "name": "Costa Valle Imagna",
                        "latitude": "45.80280000",
                        "longitude": "9.50413000"
                    },
                    {
                        "id": 138096,
                        "name": "Costa Volpino",
                        "latitude": "45.82768000",
                        "longitude": "10.10076000"
                    },
                    {
                        "id": 138101,
                        "name": "Costa-Barco",
                        "latitude": "45.58337000",
                        "longitude": "10.03907000"
                    },
                    {
                        "id": 138117,
                        "name": "Covo",
                        "latitude": "45.49906000",
                        "longitude": "9.77068000"
                    },
                    {
                        "id": 138120,
                        "name": "Cozzo",
                        "latitude": "45.19213000",
                        "longitude": "8.61112000"
                    },
                    {
                        "id": 138122,
                        "name": "Crandola Valsassina",
                        "latitude": "46.02329000",
                        "longitude": "9.37914000"
                    },
                    {
                        "id": 138130,
                        "name": "Credaro",
                        "latitude": "45.66058000",
                        "longitude": "9.93106000"
                    },
                    {
                        "id": 138131,
                        "name": "Credera",
                        "latitude": "45.30301000",
                        "longitude": "9.65498000"
                    },
                    {
                        "id": 138132,
                        "name": "Crema",
                        "latitude": "45.36264000",
                        "longitude": "9.68176000"
                    },
                    {
                        "id": 138133,
                        "name": "Cremella",
                        "latitude": "45.73858000",
                        "longitude": "9.30064000"
                    },
                    {
                        "id": 138134,
                        "name": "Cremenaga",
                        "latitude": "45.98938000",
                        "longitude": "8.80333000"
                    },
                    {
                        "id": 138135,
                        "name": "Cremeno",
                        "latitude": "45.93492000",
                        "longitude": "9.47099000"
                    },
                    {
                        "id": 138136,
                        "name": "Cremia",
                        "latitude": "46.08649000",
                        "longitude": "9.27114000"
                    },
                    {
                        "id": 138138,
                        "name": "Cremona",
                        "latitude": "45.13325000",
                        "longitude": "10.02129000"
                    },
                    {
                        "id": 138139,
                        "name": "Cremosano",
                        "latitude": "45.39467000",
                        "longitude": "9.63826000"
                    },
                    {
                        "id": 138145,
                        "name": "Crespiatica",
                        "latitude": "45.35136000",
                        "longitude": "9.57659000"
                    },
                    {
                        "id": 138164,
                        "name": "Crone",
                        "latitude": "45.73741000",
                        "longitude": "10.47503000"
                    },
                    {
                        "id": 138169,
                        "name": "Crosio della Valle",
                        "latitude": "45.75997000",
                        "longitude": "8.77043000"
                    },
                    {
                        "id": 138171,
                        "name": "Crotta d'Adda",
                        "latitude": "45.15888000",
                        "longitude": "9.85684000"
                    },
                    {
                        "id": 138175,
                        "name": "Crugnola",
                        "latitude": "45.72955000",
                        "longitude": "8.74525000"
                    },
                    {
                        "id": 138176,
                        "name": "Cuasso al Monte",
                        "latitude": "45.91478000",
                        "longitude": "8.87923000"
                    },
                    {
                        "id": 138177,
                        "name": "Cuasso al Piano",
                        "latitude": "45.89454000",
                        "longitude": "8.87951000"
                    },
                    {
                        "id": 138180,
                        "name": "Cucciago",
                        "latitude": "45.73928000",
                        "longitude": "9.09294000"
                    },
                    {
                        "id": 138183,
                        "name": "Cuggiono",
                        "latitude": "45.50683000",
                        "longitude": "8.81550000"
                    },
                    {
                        "id": 138184,
                        "name": "Cugliate-Fabiasco",
                        "latitude": "45.94568000",
                        "longitude": "8.81863000"
                    },
                    {
                        "id": 138188,
                        "name": "Cumignano sul Naviglio",
                        "latitude": "45.35459000",
                        "longitude": "9.83621000"
                    },
                    {
                        "id": 138189,
                        "name": "Cunardo",
                        "latitude": "45.93428000",
                        "longitude": "8.80773000"
                    },
                    {
                        "id": 138191,
                        "name": "Cunettone-Villa",
                        "latitude": "45.58789000",
                        "longitude": "10.51756000"
                    },
                    {
                        "id": 138198,
                        "name": "Cura Carpignano",
                        "latitude": "45.21247000",
                        "longitude": "9.25565000"
                    },
                    {
                        "id": 138201,
                        "name": "Curiglia",
                        "latitude": "46.06065000",
                        "longitude": "8.80484000"
                    },
                    {
                        "id": 138204,
                        "name": "Curno",
                        "latitude": "45.68876000",
                        "longitude": "9.60872000"
                    },
                    {
                        "id": 138210,
                        "name": "Cusago",
                        "latitude": "45.44997000",
                        "longitude": "9.03744000"
                    },
                    {
                        "id": 138211,
                        "name": "Cusano",
                        "latitude": "45.55187000",
                        "longitude": "9.18373000"
                    },
                    {
                        "id": 138214,
                        "name": "Cusino",
                        "latitude": "46.07489000",
                        "longitude": "9.15264000"
                    },
                    {
                        "id": 138215,
                        "name": "Cusio",
                        "latitude": "45.99089000",
                        "longitude": "9.60175000"
                    },
                    {
                        "id": 138220,
                        "name": "Cuveglio",
                        "latitude": "45.90608000",
                        "longitude": "8.73333000"
                    },
                    {
                        "id": 138221,
                        "name": "Cuvio",
                        "latitude": "45.89618000",
                        "longitude": "8.73413000"
                    },
                    {
                        "id": 138224,
                        "name": "Dairago",
                        "latitude": "45.56580000",
                        "longitude": "8.86265000"
                    },
                    {
                        "id": 138225,
                        "name": "Dalmine",
                        "latitude": "45.64933000",
                        "longitude": "9.60617000"
                    },
                    {
                        "id": 138229,
                        "name": "Darfo Boario Terme",
                        "latitude": "45.89150000",
                        "longitude": "10.18879000"
                    },
                    {
                        "id": 138232,
                        "name": "Daverio",
                        "latitude": "45.77797000",
                        "longitude": "8.77343000"
                    },
                    {
                        "id": 138234,
                        "name": "Dazio",
                        "latitude": "46.16129000",
                        "longitude": "9.60064000"
                    },
                    {
                        "id": 138241,
                        "name": "Delebio",
                        "latitude": "46.13648000",
                        "longitude": "9.46157000"
                    },
                    {
                        "id": 138245,
                        "name": "Dello",
                        "latitude": "45.41916000",
                        "longitude": "10.07621000"
                    },
                    {
                        "id": 138251,
                        "name": "Derovere",
                        "latitude": "45.10997000",
                        "longitude": "10.24798000"
                    },
                    {
                        "id": 138253,
                        "name": "Dervio",
                        "latitude": "46.07696000",
                        "longitude": "9.30659000"
                    },
                    {
                        "id": 138256,
                        "name": "Desenzano del Garda",
                        "latitude": "45.47127000",
                        "longitude": "10.53559000"
                    },
                    {
                        "id": 138257,
                        "name": "Desio",
                        "latitude": "45.61831000",
                        "longitude": "9.20249000"
                    },
                    {
                        "id": 138272,
                        "name": "Dizzasco-Biazzeno",
                        "latitude": "45.94378000",
                        "longitude": "9.09974000"
                    },
                    {
                        "id": 138286,
                        "name": "Dolzago",
                        "latitude": "45.76698000",
                        "longitude": "9.33934000"
                    },
                    {
                        "id": 138288,
                        "name": "Domaso",
                        "latitude": "46.15284000",
                        "longitude": "9.33150000"
                    },
                    {
                        "id": 138298,
                        "name": "Dongo",
                        "latitude": "46.12999000",
                        "longitude": "9.28169000"
                    },
                    {
                        "id": 138308,
                        "name": "Dorio",
                        "latitude": "46.10020000",
                        "longitude": "9.31883000"
                    },
                    {
                        "id": 138310,
                        "name": "Dorno",
                        "latitude": "45.15352000",
                        "longitude": "8.95076000"
                    },
                    {
                        "id": 138313,
                        "name": "Dosimo",
                        "latitude": "45.18469000",
                        "longitude": "10.10362000"
                    },
                    {
                        "id": 138314,
                        "name": "Dosolo",
                        "latitude": "44.95259000",
                        "longitude": "10.63550000"
                    },
                    {
                        "id": 138315,
                        "name": "Dossena",
                        "latitude": "45.88029000",
                        "longitude": "9.69675000"
                    },
                    {
                        "id": 138317,
                        "name": "Dosso del Liro",
                        "latitude": "46.16399000",
                        "longitude": "9.27294000"
                    },
                    {
                        "id": 138318,
                        "name": "Dosso-Ville",
                        "latitude": "45.75251000",
                        "longitude": "10.27397000"
                    },
                    {
                        "id": 138323,
                        "name": "Dovera",
                        "latitude": "45.36428000",
                        "longitude": "9.54445000"
                    },
                    {
                        "id": 138329,
                        "name": "Dresano",
                        "latitude": "45.37297000",
                        "longitude": "9.35785000"
                    },
                    {
                        "id": 138330,
                        "name": "Drizzona",
                        "latitude": "45.14217000",
                        "longitude": "10.35028000"
                    },
                    {
                        "id": 138337,
                        "name": "Dubino",
                        "latitude": "46.16705000",
                        "longitude": "9.43049000"
                    },
                    {
                        "id": 138342,
                        "name": "Dumenza",
                        "latitude": "46.02088000",
                        "longitude": "8.78674000"
                    },
                    {
                        "id": 138343,
                        "name": "Duno",
                        "latitude": "45.91398000",
                        "longitude": "8.73763000"
                    },
                    {
                        "id": 138344,
                        "name": "Duomo",
                        "latitude": "45.53240000",
                        "longitude": "10.02118000"
                    },
                    {
                        "id": 138349,
                        "name": "Edolo",
                        "latitude": "46.17799000",
                        "longitude": "10.33322000"
                    },
                    {
                        "id": 138353,
                        "name": "Ello",
                        "latitude": "45.78568000",
                        "longitude": "9.36534000"
                    },
                    {
                        "id": 138357,
                        "name": "Endine",
                        "latitude": "45.78980000",
                        "longitude": "9.97561000"
                    },
                    {
                        "id": 138362,
                        "name": "Entratico",
                        "latitude": "45.70778000",
                        "longitude": "9.87316000"
                    },
                    {
                        "id": 138365,
                        "name": "Era",
                        "latitude": "46.24422000",
                        "longitude": "9.39515000"
                    },
                    {
                        "id": 138367,
                        "name": "Erba",
                        "latitude": "45.80880000",
                        "longitude": "9.22609000"
                    },
                    {
                        "id": 138369,
                        "name": "Erbusco",
                        "latitude": "45.59868000",
                        "longitude": "9.97186000"
                    },
                    {
                        "id": 138373,
                        "name": "Eremo",
                        "latitude": "45.13119000",
                        "longitude": "10.74271000"
                    },
                    {
                        "id": 138378,
                        "name": "Erve",
                        "latitude": "45.82158000",
                        "longitude": "9.45285000"
                    },
                    {
                        "id": 138382,
                        "name": "Esine",
                        "latitude": "45.92515000",
                        "longitude": "10.25102000"
                    },
                    {
                        "id": 138383,
                        "name": "Esino Lario",
                        "latitude": "45.99437000",
                        "longitude": "9.33399000"
                    },
                    {
                        "id": 138401,
                        "name": "Faedo Valtellino",
                        "latitude": "46.15299000",
                        "longitude": "9.90605000"
                    },
                    {
                        "id": 138406,
                        "name": "Faggeto Lario",
                        "latitude": "45.85878000",
                        "longitude": "9.15894000"
                    },
                    {
                        "id": 138409,
                        "name": "Fagnano Olona-Bergoro",
                        "latitude": "45.66977000",
                        "longitude": "8.85994000"
                    },
                    {
                        "id": 138424,
                        "name": "Faloppio",
                        "latitude": "45.80968000",
                        "longitude": "8.96434000"
                    },
                    {
                        "id": 138435,
                        "name": "Fantasina",
                        "latitude": "45.57325000",
                        "longitude": "10.17790000"
                    },
                    {
                        "id": 138438,
                        "name": "Fara Gera d'Adda",
                        "latitude": "45.55656000",
                        "longitude": "9.53656000"
                    },
                    {
                        "id": 138440,
                        "name": "Fara Olivana",
                        "latitude": "45.49508000",
                        "longitude": "9.74906000"
                    },
                    {
                        "id": 138474,
                        "name": "Felonica",
                        "latitude": "44.97898000",
                        "longitude": "11.35370000"
                    },
                    {
                        "id": 138476,
                        "name": "Fenegrò",
                        "latitude": "45.70157000",
                        "longitude": "8.99964000"
                    },
                    {
                        "id": 138484,
                        "name": "Ferno",
                        "latitude": "45.61496000",
                        "longitude": "8.75695000"
                    },
                    {
                        "id": 138493,
                        "name": "Ferrera di Varese",
                        "latitude": "45.93278000",
                        "longitude": "8.78913000"
                    },
                    {
                        "id": 138492,
                        "name": "Ferrera Erbognone",
                        "latitude": "45.11456000",
                        "longitude": "8.86454000"
                    },
                    {
                        "id": 138510,
                        "name": "Fiesco",
                        "latitude": "45.33737000",
                        "longitude": "9.77786000"
                    },
                    {
                        "id": 138512,
                        "name": "Fiesse",
                        "latitude": "45.23207000",
                        "longitude": "10.32417000"
                    },
                    {
                        "id": 138516,
                        "name": "Figino",
                        "latitude": "45.49261000",
                        "longitude": "9.07779000"
                    },
                    {
                        "id": 138517,
                        "name": "Figino Serenza",
                        "latitude": "45.71048000",
                        "longitude": "9.13114000"
                    },
                    {
                        "id": 138518,
                        "name": "Figliaro",
                        "latitude": "45.77992000",
                        "longitude": "8.94466000"
                    },
                    {
                        "id": 138523,
                        "name": "Filago",
                        "latitude": "45.63758000",
                        "longitude": "9.55635000"
                    },
                    {
                        "id": 138530,
                        "name": "Filighera",
                        "latitude": "45.17496000",
                        "longitude": "9.31646000"
                    },
                    {
                        "id": 138538,
                        "name": "Fino del Monte",
                        "latitude": "45.89269000",
                        "longitude": "9.99406000"
                    },
                    {
                        "id": 138537,
                        "name": "Fino Mornasco",
                        "latitude": "45.74290000",
                        "longitude": "9.04996000"
                    },
                    {
                        "id": 138541,
                        "name": "Fiorano al Serio",
                        "latitude": "45.80018000",
                        "longitude": "9.84276000"
                    },
                    {
                        "id": 138557,
                        "name": "Fizzonasco",
                        "latitude": "45.37241000",
                        "longitude": "9.19066000"
                    },
                    {
                        "id": 138562,
                        "name": "Flero",
                        "latitude": "45.48254000",
                        "longitude": "10.17694000"
                    },
                    {
                        "id": 138585,
                        "name": "Folzano",
                        "latitude": "45.49587000",
                        "longitude": "10.20650000"
                    },
                    {
                        "id": 138586,
                        "name": "Fombio",
                        "latitude": "45.14126000",
                        "longitude": "9.68043000"
                    },
                    {
                        "id": 138596,
                        "name": "Fontane-Zurane-Gresine",
                        "latitude": "45.63336000",
                        "longitude": "10.04720000"
                    },
                    {
                        "id": 138598,
                        "name": "Fontanella",
                        "latitude": "45.46903000",
                        "longitude": "9.80248000"
                    },
                    {
                        "id": 138612,
                        "name": "Fonteno",
                        "latitude": "45.75859000",
                        "longitude": "10.01856000"
                    },
                    {
                        "id": 138616,
                        "name": "Foppolo",
                        "latitude": "46.04297000",
                        "longitude": "9.75775000"
                    },
                    {
                        "id": 138621,
                        "name": "Forcola",
                        "latitude": "46.15859000",
                        "longitude": "9.66034000"
                    },
                    {
                        "id": 138626,
                        "name": "Foresto Sparso",
                        "latitude": "45.69088000",
                        "longitude": "9.92006000"
                    },
                    {
                        "id": 138639,
                        "name": "Formigara",
                        "latitude": "45.22307000",
                        "longitude": "9.77076000"
                    },
                    {
                        "id": 138649,
                        "name": "Fornaci",
                        "latitude": "45.19872000",
                        "longitude": "9.67794000"
                    },
                    {
                        "id": 138659,
                        "name": "Fornovo San Giovanni",
                        "latitude": "45.49742000",
                        "longitude": "9.67739000"
                    },
                    {
                        "id": 138663,
                        "name": "Fortunago",
                        "latitude": "44.92160000",
                        "longitude": "9.18471000"
                    },
                    {
                        "id": 138707,
                        "name": "Frascarolo",
                        "latitude": "45.04666000",
                        "longitude": "8.68204000"
                    },
                    {
                        "id": 138747,
                        "name": "Fuipiano Valle Imagna",
                        "latitude": "45.85428000",
                        "longitude": "9.52845000"
                    },
                    {
                        "id": 138754,
                        "name": "Furato",
                        "latitude": "45.51468000",
                        "longitude": "8.88063000"
                    },
                    {
                        "id": 138762,
                        "name": "Fusine",
                        "latitude": "46.14949000",
                        "longitude": "9.74975000"
                    },
                    {
                        "id": 138767,
                        "name": "Gabbioneta",
                        "latitude": "45.21627000",
                        "longitude": "10.22027000"
                    },
                    {
                        "id": 138772,
                        "name": "Gadesco-Pieve Delmona",
                        "latitude": "45.15767000",
                        "longitude": "10.11567000"
                    },
                    {
                        "id": 138776,
                        "name": "Gaggiano",
                        "latitude": "45.40484000",
                        "longitude": "9.03488000"
                    },
                    {
                        "id": 138777,
                        "name": "Gaggino",
                        "latitude": "45.80787000",
                        "longitude": "8.96427000"
                    },
                    {
                        "id": 138798,
                        "name": "Galbiate",
                        "latitude": "45.81635000",
                        "longitude": "9.37902000"
                    },
                    {
                        "id": 138800,
                        "name": "Galgagnano",
                        "latitude": "45.35797000",
                        "longitude": "9.44535000"
                    },
                    {
                        "id": 138801,
                        "name": "Gallarate",
                        "latitude": "45.66019000",
                        "longitude": "8.79164000"
                    },
                    {
                        "id": 138805,
                        "name": "Galliate Lombardo",
                        "latitude": "45.78487000",
                        "longitude": "8.77043000"
                    },
                    {
                        "id": 138806,
                        "name": "Galliavola",
                        "latitude": "45.09756000",
                        "longitude": "8.81885000"
                    },
                    {
                        "id": 138818,
                        "name": "Gallo-Tre Re-Mezzana Corti",
                        "latitude": "45.12563000",
                        "longitude": "9.12227000"
                    },
                    {
                        "id": 138826,
                        "name": "Gambara",
                        "latitude": "45.25366000",
                        "longitude": "10.29434000"
                    },
                    {
                        "id": 138827,
                        "name": "Gambarana",
                        "latitude": "45.02874000",
                        "longitude": "8.76282000"
                    },
                    {
                        "id": 138834,
                        "name": "Gambolò",
                        "latitude": "45.26209000",
                        "longitude": "8.85820000"
                    },
                    {
                        "id": 138837,
                        "name": "Gandellino",
                        "latitude": "45.99109000",
                        "longitude": "9.94615000"
                    },
                    {
                        "id": 138838,
                        "name": "Gandino",
                        "latitude": "45.81088000",
                        "longitude": "9.89767000"
                    },
                    {
                        "id": 138839,
                        "name": "Gandosso",
                        "latitude": "45.65888000",
                        "longitude": "9.88886000"
                    },
                    {
                        "id": 138841,
                        "name": "Ganna",
                        "latitude": "45.90212000",
                        "longitude": "8.82606000"
                    },
                    {
                        "id": 138846,
                        "name": "Garbagnate",
                        "latitude": "45.77027000",
                        "longitude": "9.29848000"
                    },
                    {
                        "id": 138847,
                        "name": "Garbagnate Milanese",
                        "latitude": "45.57438000",
                        "longitude": "9.07537000"
                    },
                    {
                        "id": 138848,
                        "name": "Garbagnate Monastero",
                        "latitude": "45.77338000",
                        "longitude": "9.30144000"
                    },
                    {
                        "id": 138850,
                        "name": "Gardola",
                        "latitude": "45.74180000",
                        "longitude": "10.71871000"
                    },
                    {
                        "id": 138851,
                        "name": "Gardone Riviera",
                        "latitude": "45.62396000",
                        "longitude": "10.56682000"
                    },
                    {
                        "id": 138852,
                        "name": "Gardone Val Trompia",
                        "latitude": "45.69137000",
                        "longitude": "10.18635000"
                    },
                    {
                        "id": 138856,
                        "name": "Gargnano",
                        "latitude": "45.68586000",
                        "longitude": "10.65869000"
                    },
                    {
                        "id": 138858,
                        "name": "Garlasco",
                        "latitude": "45.19540000",
                        "longitude": "8.92314000"
                    },
                    {
                        "id": 138859,
                        "name": "Garlate",
                        "latitude": "45.81208000",
                        "longitude": "9.39964000"
                    },
                    {
                        "id": 138862,
                        "name": "Garzeno",
                        "latitude": "46.13409000",
                        "longitude": "9.24964000"
                    },
                    {
                        "id": 138870,
                        "name": "Gavardo-Sopraponte",
                        "latitude": "45.58939000",
                        "longitude": "10.44257000"
                    },
                    {
                        "id": 138871,
                        "name": "Gavarno Rinnovata",
                        "latitude": "45.72454000",
                        "longitude": "9.76318000"
                    },
                    {
                        "id": 138872,
                        "name": "Gavarno-Tribulina",
                        "latitude": "45.71734000",
                        "longitude": "9.77512000"
                    },
                    {
                        "id": 138875,
                        "name": "Gaverina Terme",
                        "latitude": "45.75578000",
                        "longitude": "9.88666000"
                    },
                    {
                        "id": 138878,
                        "name": "Gavirate",
                        "latitude": "45.83707000",
                        "longitude": "8.72619000"
                    },
                    {
                        "id": 138881,
                        "name": "Gazoldo degli Ippoliti",
                        "latitude": "45.19999000",
                        "longitude": "10.57839000"
                    },
                    {
                        "id": 138882,
                        "name": "Gazzada Schianno",
                        "latitude": "45.78017000",
                        "longitude": "8.83344000"
                    },
                    {
                        "id": 138883,
                        "name": "Gazzaniga",
                        "latitude": "45.79339000",
                        "longitude": "9.82976000"
                    },
                    {
                        "id": 138885,
                        "name": "Gazzo",
                        "latitude": "45.17968000",
                        "longitude": "10.89706000"
                    },
                    {
                        "id": 138888,
                        "name": "Gazzuolo",
                        "latitude": "45.06238000",
                        "longitude": "10.57161000"
                    },
                    {
                        "id": 138894,
                        "name": "Gemonio",
                        "latitude": "45.87878000",
                        "longitude": "8.67478000"
                    },
                    {
                        "id": 138898,
                        "name": "Genivolta",
                        "latitude": "45.33257000",
                        "longitude": "9.87726000"
                    },
                    {
                        "id": 138905,
                        "name": "Genzone",
                        "latitude": "45.17962000",
                        "longitude": "9.34829000"
                    },
                    {
                        "id": 138906,
                        "name": "Gera Lario",
                        "latitude": "46.17003000",
                        "longitude": "9.36736000"
                    },
                    {
                        "id": 138913,
                        "name": "Gerenzago",
                        "latitude": "45.20633000",
                        "longitude": "9.36137000"
                    },
                    {
                        "id": 138914,
                        "name": "Gerenzano",
                        "latitude": "45.63967000",
                        "longitude": "9.00104000"
                    },
                    {
                        "id": 138918,
                        "name": "Germignaga",
                        "latitude": "45.99128000",
                        "longitude": "8.72403000"
                    },
                    {
                        "id": 138920,
                        "name": "Gerola Alta",
                        "latitude": "46.06003000",
                        "longitude": "9.55025000"
                    },
                    {
                        "id": 138921,
                        "name": "Geromina",
                        "latitude": "45.53645000",
                        "longitude": "9.57540000"
                    },
                    {
                        "id": 138922,
                        "name": "Gerosa",
                        "latitude": "45.84980000",
                        "longitude": "9.57161000"
                    },
                    {
                        "id": 138923,
                        "name": "Gerre de' Caprioli",
                        "latitude": "45.09042000",
                        "longitude": "10.05085000"
                    },
                    {
                        "id": 138925,
                        "name": "Gessate",
                        "latitude": "45.54838000",
                        "longitude": "9.43775000"
                    },
                    {
                        "id": 138929,
                        "name": "Ghedi",
                        "latitude": "45.40204000",
                        "longitude": "10.27681000"
                    },
                    {
                        "id": 138931,
                        "name": "Ghiaie",
                        "latitude": "45.68205000",
                        "longitude": "9.58121000"
                    },
                    {
                        "id": 138935,
                        "name": "Ghisalba",
                        "latitude": "45.59354000",
                        "longitude": "9.75765000"
                    },
                    {
                        "id": 138941,
                        "name": "Gianico",
                        "latitude": "45.86559000",
                        "longitude": "10.17486000"
                    },
                    {
                        "id": 138977,
                        "name": "Giovenzano",
                        "latitude": "45.27322000",
                        "longitude": "9.11605000"
                    },
                    {
                        "id": 138984,
                        "name": "Gironico al Piano",
                        "latitude": "45.80138000",
                        "longitude": "9.00314000"
                    },
                    {
                        "id": 138997,
                        "name": "Giussago",
                        "latitude": "45.28417000",
                        "longitude": "9.13996000"
                    },
                    {
                        "id": 138998,
                        "name": "Giussano",
                        "latitude": "45.70004000",
                        "longitude": "9.20890000"
                    },
                    {
                        "id": 139008,
                        "name": "Godiasco",
                        "latitude": "44.89645000",
                        "longitude": "9.05667000"
                    },
                    {
                        "id": 139011,
                        "name": "Goito",
                        "latitude": "45.25076000",
                        "longitude": "10.66121000"
                    },
                    {
                        "id": 139012,
                        "name": "Golasecca",
                        "latitude": "45.69821000",
                        "longitude": "8.66112000"
                    },
                    {
                        "id": 139013,
                        "name": "Golferenzo",
                        "latitude": "44.96106000",
                        "longitude": "9.30596000"
                    },
                    {
                        "id": 139015,
                        "name": "Gombito",
                        "latitude": "45.26187000",
                        "longitude": "9.72856000"
                    },
                    {
                        "id": 139024,
                        "name": "Gonzaga",
                        "latitude": "44.95193000",
                        "longitude": "10.81913000"
                    },
                    {
                        "id": 139025,
                        "name": "Gordona",
                        "latitude": "46.29176000",
                        "longitude": "9.36700000"
                    },
                    {
                        "id": 139030,
                        "name": "Gorgonzola",
                        "latitude": "45.53069000",
                        "longitude": "9.40531000"
                    },
                    {
                        "id": 139033,
                        "name": "Gorla Maggiore",
                        "latitude": "45.66388000",
                        "longitude": "8.89537000"
                    },
                    {
                        "id": 139034,
                        "name": "Gorla Minore",
                        "latitude": "45.64117000",
                        "longitude": "8.90264000"
                    },
                    {
                        "id": 139035,
                        "name": "Gorlago",
                        "latitude": "45.67408000",
                        "longitude": "9.82296000"
                    },
                    {
                        "id": 139036,
                        "name": "Gorle",
                        "latitude": "45.70127000",
                        "longitude": "9.71382000"
                    },
                    {
                        "id": 139037,
                        "name": "Gornate Olona",
                        "latitude": "45.74157000",
                        "longitude": "8.85994000"
                    },
                    {
                        "id": 139038,
                        "name": "Gorno",
                        "latitude": "45.86249000",
                        "longitude": "9.84155000"
                    },
                    {
                        "id": 139046,
                        "name": "Gottolengo",
                        "latitude": "45.29278000",
                        "longitude": "10.26855000"
                    },
                    {
                        "id": 139053,
                        "name": "Graffignana",
                        "latitude": "45.20647000",
                        "longitude": "9.45436000"
                    },
                    {
                        "id": 139064,
                        "name": "Grandate",
                        "latitude": "45.76715000",
                        "longitude": "9.05349000"
                    },
                    {
                        "id": 139065,
                        "name": "Grandola ed Uniti",
                        "latitude": "46.02488000",
                        "longitude": "9.21274000"
                    },
                    {
                        "id": 139068,
                        "name": "Grantola",
                        "latitude": "45.94918000",
                        "longitude": "8.77433000"
                    },
                    {
                        "id": 139074,
                        "name": "Grassobbio",
                        "latitude": "45.65688000",
                        "longitude": "9.72565000"
                    },
                    {
                        "id": 139075,
                        "name": "Gratacasolo",
                        "latitude": "45.82897000",
                        "longitude": "10.12918000"
                    },
                    {
                        "id": 139078,
                        "name": "Gravedona-San Gregorio",
                        "latitude": "46.14639000",
                        "longitude": "9.30094000"
                    },
                    {
                        "id": 139079,
                        "name": "Gravellona",
                        "latitude": "45.32766000",
                        "longitude": "8.76414000"
                    },
                    {
                        "id": 139093,
                        "name": "Grezzago",
                        "latitude": "45.59108000",
                        "longitude": "9.49725000"
                    },
                    {
                        "id": 139095,
                        "name": "Griante",
                        "latitude": "45.99528000",
                        "longitude": "9.23554000"
                    },
                    {
                        "id": 139097,
                        "name": "Grignano",
                        "latitude": "45.61819000",
                        "longitude": "9.54235000"
                    },
                    {
                        "id": 139108,
                        "name": "Gromlongo",
                        "latitude": "45.72895000",
                        "longitude": "9.54097000"
                    },
                    {
                        "id": 139109,
                        "name": "Gromo",
                        "latitude": "45.96190000",
                        "longitude": "9.92637000"
                    },
                    {
                        "id": 139111,
                        "name": "Grone",
                        "latitude": "45.72722000",
                        "longitude": "9.90885000"
                    },
                    {
                        "id": 139112,
                        "name": "Grontardo",
                        "latitude": "45.20136000",
                        "longitude": "10.15150000"
                    },
                    {
                        "id": 139113,
                        "name": "Gropello Cairoli",
                        "latitude": "45.17707000",
                        "longitude": "8.99353000"
                    },
                    {
                        "id": 139116,
                        "name": "Grosio",
                        "latitude": "46.29970000",
                        "longitude": "10.27572000"
                    },
                    {
                        "id": 139117,
                        "name": "Grosotto",
                        "latitude": "46.28196000",
                        "longitude": "10.25908000"
                    },
                    {
                        "id": 139135,
                        "name": "Grumello Cremonese",
                        "latitude": "45.19415000",
                        "longitude": "9.86443000"
                    },
                    {
                        "id": 139136,
                        "name": "Grumello del Monte",
                        "latitude": "45.63535000",
                        "longitude": "9.87526000"
                    },
                    {
                        "id": 139151,
                        "name": "Guanzate",
                        "latitude": "45.72758000",
                        "longitude": "9.01984000"
                    },
                    {
                        "id": 139155,
                        "name": "Guardamiglio",
                        "latitude": "45.10742000",
                        "longitude": "9.68481000"
                    },
                    {
                        "id": 139174,
                        "name": "Gudo Visconti",
                        "latitude": "45.37407000",
                        "longitude": "9.00014000"
                    },
                    {
                        "id": 139176,
                        "name": "Guidizzolo",
                        "latitude": "45.32056000",
                        "longitude": "10.57801000"
                    },
                    {
                        "id": 139182,
                        "name": "Guinzano",
                        "latitude": "45.25678000",
                        "longitude": "9.15869000"
                    },
                    {
                        "id": 139185,
                        "name": "Gussago",
                        "latitude": "45.58358000",
                        "longitude": "10.15717000"
                    },
                    {
                        "id": 139186,
                        "name": "Gussola",
                        "latitude": "45.01165000",
                        "longitude": "10.34894000"
                    },
                    {
                        "id": 139189,
                        "name": "Idro",
                        "latitude": "45.73609000",
                        "longitude": "10.47337000"
                    },
                    {
                        "id": 139197,
                        "name": "Imbersago",
                        "latitude": "45.70588000",
                        "longitude": "9.44445000"
                    },
                    {
                        "id": 139203,
                        "name": "Inarzo",
                        "latitude": "45.78578000",
                        "longitude": "8.73563000"
                    },
                    {
                        "id": 139206,
                        "name": "Incudine",
                        "latitude": "46.22030000",
                        "longitude": "10.35876000"
                    },
                    {
                        "id": 139207,
                        "name": "Induno Olona",
                        "latitude": "45.84571000",
                        "longitude": "8.84056000"
                    },
                    {
                        "id": 139210,
                        "name": "Introbio",
                        "latitude": "45.97387000",
                        "longitude": "9.44998000"
                    },
                    {
                        "id": 139213,
                        "name": "Introzzo",
                        "latitude": "46.08119000",
                        "longitude": "9.34094000"
                    },
                    {
                        "id": 139214,
                        "name": "Inverigo",
                        "latitude": "45.73795000",
                        "longitude": "9.21836000"
                    },
                    {
                        "id": 139215,
                        "name": "Inverno",
                        "latitude": "45.19859000",
                        "longitude": "9.38429000"
                    },
                    {
                        "id": 139216,
                        "name": "Inverno e Monteleone",
                        "latitude": "45.19787000",
                        "longitude": "9.38526000"
                    },
                    {
                        "id": 139218,
                        "name": "Inveruno",
                        "latitude": "45.51399000",
                        "longitude": "8.84954000"
                    },
                    {
                        "id": 139220,
                        "name": "Inzago",
                        "latitude": "45.53991000",
                        "longitude": "9.48343000"
                    },
                    {
                        "id": 139222,
                        "name": "Irma",
                        "latitude": "45.77129000",
                        "longitude": "10.28457000"
                    },
                    {
                        "id": 139231,
                        "name": "Iseo",
                        "latitude": "45.65883000",
                        "longitude": "10.05024000"
                    },
                    {
                        "id": 139251,
                        "name": "Isola di Fondra",
                        "latitude": "45.97859000",
                        "longitude": "9.74735000"
                    },
                    {
                        "id": 139238,
                        "name": "Isola Dovarese",
                        "latitude": "45.17292000",
                        "longitude": "10.30879000"
                    },
                    {
                        "id": 139254,
                        "name": "Isolaccia",
                        "latitude": "46.48901000",
                        "longitude": "10.29405000"
                    },
                    {
                        "id": 139256,
                        "name": "Isorella",
                        "latitude": "45.30912000",
                        "longitude": "10.32281000"
                    },
                    {
                        "id": 139260,
                        "name": "Ispra",
                        "latitude": "45.81480000",
                        "longitude": "8.61294000"
                    },
                    {
                        "id": 139263,
                        "name": "Isso",
                        "latitude": "45.47678000",
                        "longitude": "9.75866000"
                    },
                    {
                        "id": 139272,
                        "name": "Izano",
                        "latitude": "45.35552000",
                        "longitude": "9.75138000"
                    },
                    {
                        "id": 139276,
                        "name": "Jerago Con Orago",
                        "latitude": "45.70467000",
                        "longitude": "8.79593000"
                    },
                    {
                        "id": 139312,
                        "name": "Lacchiarella",
                        "latitude": "45.32290000",
                        "longitude": "9.13777000"
                    },
                    {
                        "id": 139324,
                        "name": "Laglio",
                        "latitude": "45.88056000",
                        "longitude": "9.13697000"
                    },
                    {
                        "id": 139331,
                        "name": "Lainate",
                        "latitude": "45.57176000",
                        "longitude": "9.02681000"
                    },
                    {
                        "id": 139332,
                        "name": "Laino",
                        "latitude": "45.98448000",
                        "longitude": "9.07544000"
                    },
                    {
                        "id": 139338,
                        "name": "Lallio",
                        "latitude": "45.66283000",
                        "longitude": "9.62887000"
                    },
                    {
                        "id": 139342,
                        "name": "Lambrinia",
                        "latitude": "45.15831000",
                        "longitude": "9.52750000"
                    },
                    {
                        "id": 139343,
                        "name": "Lambrugo",
                        "latitude": "45.75878000",
                        "longitude": "9.23954000"
                    },
                    {
                        "id": 139357,
                        "name": "Landriano",
                        "latitude": "45.31155000",
                        "longitude": "9.26046000"
                    },
                    {
                        "id": 139359,
                        "name": "Langosco",
                        "latitude": "45.21453000",
                        "longitude": "8.56372000"
                    },
                    {
                        "id": 139363,
                        "name": "Lanzada",
                        "latitude": "46.26930000",
                        "longitude": "9.86925000"
                    },
                    {
                        "id": 139366,
                        "name": "Lanzo d'Intelvi",
                        "latitude": "45.97943000",
                        "longitude": "9.02166000"
                    },
                    {
                        "id": 139373,
                        "name": "Lardirago",
                        "latitude": "45.23572000",
                        "longitude": "9.23272000"
                    },
                    {
                        "id": 139382,
                        "name": "Lasnigo",
                        "latitude": "45.88198000",
                        "longitude": "9.26644000"
                    },
                    {
                        "id": 139411,
                        "name": "Lavena Ponte Tresa",
                        "latitude": "45.96710000",
                        "longitude": "8.85725000"
                    },
                    {
                        "id": 139412,
                        "name": "Laveno",
                        "latitude": "45.90888000",
                        "longitude": "8.62036000"
                    },
                    {
                        "id": 139413,
                        "name": "Lavenone",
                        "latitude": "45.73853000",
                        "longitude": "10.43930000"
                    },
                    {
                        "id": 139419,
                        "name": "Laxolo",
                        "latitude": "45.80871000",
                        "longitude": "9.59983000"
                    },
                    {
                        "id": 139422,
                        "name": "Lazzate",
                        "latitude": "45.67207000",
                        "longitude": "9.08424000"
                    },
                    {
                        "id": 139432,
                        "name": "Lecco",
                        "latitude": "45.85589000",
                        "longitude": "9.39704000"
                    },
                    {
                        "id": 139433,
                        "name": "Leffe",
                        "latitude": "45.79793000",
                        "longitude": "9.88426000"
                    },
                    {
                        "id": 139434,
                        "name": "Leggiuno",
                        "latitude": "45.87588000",
                        "longitude": "8.62063000"
                    },
                    {
                        "id": 139436,
                        "name": "Legnano",
                        "latitude": "45.59788000",
                        "longitude": "8.91506000"
                    },
                    {
                        "id": 139442,
                        "name": "Lemna",
                        "latitude": "45.85808000",
                        "longitude": "9.15986000"
                    },
                    {
                        "id": 139445,
                        "name": "Lenna",
                        "latitude": "45.94273000",
                        "longitude": "9.67876000"
                    },
                    {
                        "id": 139446,
                        "name": "Lenno",
                        "latitude": "45.97298000",
                        "longitude": "9.19084000"
                    },
                    {
                        "id": 139447,
                        "name": "Leno",
                        "latitude": "45.36930000",
                        "longitude": "10.21675000"
                    },
                    {
                        "id": 139450,
                        "name": "Lentate sul Seveso",
                        "latitude": "45.67637000",
                        "longitude": "9.11774000"
                    },
                    {
                        "id": 139470,
                        "name": "Lesmo",
                        "latitude": "45.64858000",
                        "longitude": "9.30735000"
                    },
                    {
                        "id": 139484,
                        "name": "Levata",
                        "latitude": "45.12518000",
                        "longitude": "10.76794000"
                    },
                    {
                        "id": 139485,
                        "name": "Levate",
                        "latitude": "45.62518000",
                        "longitude": "9.62415000"
                    },
                    {
                        "id": 139490,
                        "name": "Lezzeno",
                        "latitude": "45.94411000",
                        "longitude": "9.18488000"
                    },
                    {
                        "id": 139509,
                        "name": "Lierna",
                        "latitude": "45.95818000",
                        "longitude": "9.30513000"
                    },
                    {
                        "id": 139518,
                        "name": "Limbiate",
                        "latitude": "45.59951000",
                        "longitude": "9.12509000"
                    },
                    {
                        "id": 139521,
                        "name": "Limido Comasco",
                        "latitude": "45.68917000",
                        "longitude": "8.97984000"
                    },
                    {
                        "id": 139526,
                        "name": "Limone sul Garda",
                        "latitude": "45.81450000",
                        "longitude": "10.79278000"
                    },
                    {
                        "id": 139528,
                        "name": "Linarolo",
                        "latitude": "45.16236000",
                        "longitude": "9.26995000"
                    },
                    {
                        "id": 139529,
                        "name": "Linate",
                        "latitude": "45.44701000",
                        "longitude": "9.27229000"
                    },
                    {
                        "id": 139534,
                        "name": "Lipomo",
                        "latitude": "45.79288000",
                        "longitude": "9.12024000"
                    },
                    {
                        "id": 139535,
                        "name": "Lirio",
                        "latitude": "44.99446000",
                        "longitude": "9.25656000"
                    },
                    {
                        "id": 139536,
                        "name": "Lisanza",
                        "latitude": "45.73926000",
                        "longitude": "8.59852000"
                    },
                    {
                        "id": 139537,
                        "name": "Liscate",
                        "latitude": "45.48316000",
                        "longitude": "9.41030000"
                    },
                    {
                        "id": 139543,
                        "name": "Lissone",
                        "latitude": "45.61236000",
                        "longitude": "9.23985000"
                    },
                    {
                        "id": 139547,
                        "name": "Livigno",
                        "latitude": "46.53630000",
                        "longitude": "10.13348000"
                    },
                    {
                        "id": 139550,
                        "name": "Livo",
                        "latitude": "46.16849000",
                        "longitude": "9.30414000"
                    },
                    {
                        "id": 139553,
                        "name": "Livraga",
                        "latitude": "45.19227000",
                        "longitude": "9.54646000"
                    },
                    {
                        "id": 139562,
                        "name": "Locate di Triulzi",
                        "latitude": "45.35691000",
                        "longitude": "9.22516000"
                    },
                    {
                        "id": 139561,
                        "name": "Locate Varesino",
                        "latitude": "45.68969000",
                        "longitude": "8.92992000"
                    },
                    {
                        "id": 139563,
                        "name": "Locatello",
                        "latitude": "45.83518000",
                        "longitude": "9.53405000"
                    },
                    {
                        "id": 139568,
                        "name": "Lodetto",
                        "latitude": "45.55099000",
                        "longitude": "10.03175000"
                    },
                    {
                        "id": 139569,
                        "name": "Lodi",
                        "latitude": "45.30989000",
                        "longitude": "9.50085000"
                    },
                    {
                        "id": 139570,
                        "name": "Lodi Vecchio",
                        "latitude": "45.30422000",
                        "longitude": "9.41760000"
                    },
                    {
                        "id": 139572,
                        "name": "Lodrino",
                        "latitude": "45.71969000",
                        "longitude": "10.27767000"
                    },
                    {
                        "id": 139575,
                        "name": "Lograto",
                        "latitude": "45.48458000",
                        "longitude": "10.05664000"
                    },
                    {
                        "id": 139578,
                        "name": "Lomagna",
                        "latitude": "45.66640000",
                        "longitude": "9.37654000"
                    },
                    {
                        "id": 139579,
                        "name": "Lomazzo",
                        "latitude": "45.69670000",
                        "longitude": "9.03427000"
                    },
                    {
                        "id": 139582,
                        "name": "Lomello",
                        "latitude": "45.12001000",
                        "longitude": "8.79612000"
                    },
                    {
                        "id": 139584,
                        "name": "Lonate Ceppino",
                        "latitude": "45.70863000",
                        "longitude": "8.87936000"
                    },
                    {
                        "id": 139585,
                        "name": "Lonate Pozzolo",
                        "latitude": "45.59213000",
                        "longitude": "8.75194000"
                    },
                    {
                        "id": 139586,
                        "name": "Lonato",
                        "latitude": "45.46079000",
                        "longitude": "10.47732000"
                    },
                    {
                        "id": 139593,
                        "name": "Longhena",
                        "latitude": "45.43768000",
                        "longitude": "10.05967000"
                    },
                    {
                        "id": 139600,
                        "name": "Longone al Segrino",
                        "latitude": "45.81428000",
                        "longitude": "9.25144000"
                    },
                    {
                        "id": 139617,
                        "name": "Losine",
                        "latitude": "45.98349000",
                        "longitude": "10.31616000"
                    },
                    {
                        "id": 139619,
                        "name": "Lovere",
                        "latitude": "45.81379000",
                        "longitude": "10.06995000"
                    },
                    {
                        "id": 139620,
                        "name": "Lovero",
                        "latitude": "46.23140000",
                        "longitude": "10.22856000"
                    },
                    {
                        "id": 139621,
                        "name": "Lozio",
                        "latitude": "45.98569000",
                        "longitude": "10.26096000"
                    },
                    {
                        "id": 139622,
                        "name": "Lozza",
                        "latitude": "45.77567000",
                        "longitude": "8.85773000"
                    },
                    {
                        "id": 139634,
                        "name": "Lucino",
                        "latitude": "45.78350000",
                        "longitude": "9.04340000"
                    },
                    {
                        "id": 139635,
                        "name": "Lucino-Rodano",
                        "latitude": "45.47607000",
                        "longitude": "9.35315000"
                    },
                    {
                        "id": 139642,
                        "name": "Ludriano",
                        "latitude": "45.44846000",
                        "longitude": "9.93276000"
                    },
                    {
                        "id": 139651,
                        "name": "Luino",
                        "latitude": "46.00185000",
                        "longitude": "8.74512000"
                    },
                    {
                        "id": 139652,
                        "name": "Luisago",
                        "latitude": "45.76288000",
                        "longitude": "9.03544000"
                    },
                    {
                        "id": 139655,
                        "name": "Lumezzane",
                        "latitude": "45.64789000",
                        "longitude": "10.26487000"
                    },
                    {
                        "id": 139659,
                        "name": "Lunetta-Frassino",
                        "latitude": "45.16016000",
                        "longitude": "10.82059000"
                    },
                    {
                        "id": 139660,
                        "name": "Lungavilla",
                        "latitude": "45.04151000",
                        "longitude": "9.07842000"
                    },
                    {
                        "id": 139666,
                        "name": "Lurago d'Erba",
                        "latitude": "45.75097000",
                        "longitude": "9.21817000"
                    },
                    {
                        "id": 139665,
                        "name": "Lurago Marinone",
                        "latitude": "45.70482000",
                        "longitude": "8.98330000"
                    },
                    {
                        "id": 139667,
                        "name": "Lurano",
                        "latitude": "45.56568000",
                        "longitude": "9.64016000"
                    },
                    {
                        "id": 139669,
                        "name": "Lurate Caccivio",
                        "latitude": "45.76701000",
                        "longitude": "8.99897000"
                    },
                    {
                        "id": 139681,
                        "name": "Luvinate",
                        "latitude": "45.83958000",
                        "longitude": "8.77193000"
                    },
                    {
                        "id": 139682,
                        "name": "Luzzana",
                        "latitude": "45.71530000",
                        "longitude": "9.88105000"
                    },
                    {
                        "id": 139687,
                        "name": "Maccagno",
                        "latitude": "46.04357000",
                        "longitude": "8.73413000"
                    },
                    {
                        "id": 139689,
                        "name": "Maccastorna",
                        "latitude": "45.14667000",
                        "longitude": "9.85457000"
                    },
                    {
                        "id": 139700,
                        "name": "Macherio",
                        "latitude": "45.63974000",
                        "longitude": "9.27394000"
                    },
                    {
                        "id": 139702,
                        "name": "Maclodio",
                        "latitude": "45.47778000",
                        "longitude": "10.04217000"
                    },
                    {
                        "id": 139707,
                        "name": "Madignano",
                        "latitude": "45.34515000",
                        "longitude": "9.72271000"
                    },
                    {
                        "id": 139708,
                        "name": "Madone",
                        "latitude": "45.65028000",
                        "longitude": "9.55015000"
                    },
                    {
                        "id": 139716,
                        "name": "Magasa",
                        "latitude": "45.78139000",
                        "longitude": "10.61597000"
                    },
                    {
                        "id": 139717,
                        "name": "Magenta",
                        "latitude": "45.46456000",
                        "longitude": "8.88453000"
                    },
                    {
                        "id": 139719,
                        "name": "Magherno",
                        "latitude": "45.22357000",
                        "longitude": "9.32935000"
                    },
                    {
                        "id": 139735,
                        "name": "Magnacavallo",
                        "latitude": "45.00646000",
                        "longitude": "11.18326000"
                    },
                    {
                        "id": 139736,
                        "name": "Magnago",
                        "latitude": "45.57920000",
                        "longitude": "8.80245000"
                    },
                    {
                        "id": 139739,
                        "name": "Magno",
                        "latitude": "45.70665000",
                        "longitude": "10.19937000"
                    },
                    {
                        "id": 139741,
                        "name": "Magreglio",
                        "latitude": "45.92098000",
                        "longitude": "9.26264000"
                    },
                    {
                        "id": 139750,
                        "name": "Mairago",
                        "latitude": "45.25177000",
                        "longitude": "9.57836000"
                    },
                    {
                        "id": 139751,
                        "name": "Mairano",
                        "latitude": "45.44802000",
                        "longitude": "10.07977000"
                    },
                    {
                        "id": 139754,
                        "name": "Malagnino",
                        "latitude": "45.13477000",
                        "longitude": "10.11477000"
                    },
                    {
                        "id": 139756,
                        "name": "Malavicina",
                        "latitude": "45.29912000",
                        "longitude": "10.78677000"
                    },
                    {
                        "id": 139760,
                        "name": "Malegno",
                        "latitude": "45.95079000",
                        "longitude": "10.27406000"
                    },
                    {
                        "id": 139761,
                        "name": "Maleo",
                        "latitude": "45.16633000",
                        "longitude": "9.76241000"
                    },
                    {
                        "id": 139765,
                        "name": "Malgesso",
                        "latitude": "45.82787000",
                        "longitude": "8.67553000"
                    },
                    {
                        "id": 139766,
                        "name": "Malgrate",
                        "latitude": "45.84891000",
                        "longitude": "9.37630000"
                    },
                    {
                        "id": 139771,
                        "name": "Malnate",
                        "latitude": "45.79377000",
                        "longitude": "8.88104000"
                    },
                    {
                        "id": 139773,
                        "name": "Malonno",
                        "latitude": "46.12168000",
                        "longitude": "10.31841000"
                    },
                    {
                        "id": 139788,
                        "name": "Mandello del Lario",
                        "latitude": "45.92199000",
                        "longitude": "9.31974000"
                    },
                    {
                        "id": 139792,
                        "name": "Manera",
                        "latitude": "45.67346000",
                        "longitude": "9.04058000"
                    },
                    {
                        "id": 139793,
                        "name": "Manerba del Garda",
                        "latitude": "45.54988000",
                        "longitude": "10.55228000"
                    },
                    {
                        "id": 139794,
                        "name": "Manerbio",
                        "latitude": "45.35390000",
                        "longitude": "10.13803000"
                    },
                    {
                        "id": 139806,
                        "name": "Mantegazza",
                        "latitude": "45.50946000",
                        "longitude": "8.97321000"
                    },
                    {
                        "id": 139807,
                        "name": "Mantello",
                        "latitude": "46.15249000",
                        "longitude": "9.48894000"
                    },
                    {
                        "id": 139811,
                        "name": "Mantova",
                        "latitude": "45.16031000",
                        "longitude": "10.79784000"
                    },
                    {
                        "id": 139815,
                        "name": "Mapello",
                        "latitude": "45.71259000",
                        "longitude": "9.55443000"
                    },
                    {
                        "id": 139834,
                        "name": "Marcallo",
                        "latitude": "45.48327000",
                        "longitude": "8.87194000"
                    },
                    {
                        "id": 139835,
                        "name": "Marcaria",
                        "latitude": "45.12225000",
                        "longitude": "10.53278000"
                    },
                    {
                        "id": 139842,
                        "name": "Marcheno",
                        "latitude": "45.70649000",
                        "longitude": "10.21449000"
                    },
                    {
                        "id": 139844,
                        "name": "Marchirolo",
                        "latitude": "45.94788000",
                        "longitude": "8.83343000"
                    },
                    {
                        "id": 139850,
                        "name": "Marcignago",
                        "latitude": "45.25306000",
                        "longitude": "9.07935000"
                    },
                    {
                        "id": 139860,
                        "name": "Maresso",
                        "latitude": "45.68755000",
                        "longitude": "9.35593000"
                    },
                    {
                        "id": 139865,
                        "name": "Margno",
                        "latitude": "46.03099000",
                        "longitude": "9.38164000"
                    },
                    {
                        "id": 139866,
                        "name": "Mariana Mantovana",
                        "latitude": "45.19288000",
                        "longitude": "10.48688000"
                    },
                    {
                        "id": 139867,
                        "name": "Mariano Comense",
                        "latitude": "45.69651000",
                        "longitude": "9.18180000"
                    },
                    {
                        "id": 139905,
                        "name": "Marmentino",
                        "latitude": "45.75499000",
                        "longitude": "10.28467000"
                    },
                    {
                        "id": 139906,
                        "name": "Marmirolo",
                        "latitude": "45.21928000",
                        "longitude": "10.75609000"
                    },
                    {
                        "id": 139908,
                        "name": "Marnate",
                        "latitude": "45.62855000",
                        "longitude": "8.90916000"
                    },
                    {
                        "id": 139911,
                        "name": "Marone",
                        "latitude": "45.73719000",
                        "longitude": "10.09579000"
                    },
                    {
                        "id": 139931,
                        "name": "Martignana di Po",
                        "latitude": "45.01107000",
                        "longitude": "10.37978000"
                    },
                    {
                        "id": 139934,
                        "name": "Martinengo",
                        "latitude": "45.57216000",
                        "longitude": "9.76750000"
                    },
                    {
                        "id": 139941,
                        "name": "Marudo",
                        "latitude": "45.25297000",
                        "longitude": "9.37716000"
                    },
                    {
                        "id": 139945,
                        "name": "Marzano",
                        "latitude": "45.24797000",
                        "longitude": "9.29505000"
                    },
                    {
                        "id": 139949,
                        "name": "Marzio",
                        "latitude": "45.93818000",
                        "longitude": "8.85813000"
                    },
                    {
                        "id": 139951,
                        "name": "Masate",
                        "latitude": "45.56708000",
                        "longitude": "9.46415000"
                    },
                    {
                        "id": 139955,
                        "name": "Masciago Primo",
                        "latitude": "45.91778000",
                        "longitude": "8.78113000"
                    },
                    {
                        "id": 139963,
                        "name": "Maslianico",
                        "latitude": "45.84301000",
                        "longitude": "9.04836000"
                    },
                    {
                        "id": 139978,
                        "name": "Massalengo-Motta Vigana",
                        "latitude": "45.26497000",
                        "longitude": "9.49016000"
                    },
                    {
                        "id": 140005,
                        "name": "Mazzano",
                        "latitude": "45.52008000",
                        "longitude": "10.35387000"
                    },
                    {
                        "id": 140012,
                        "name": "Mazzo di Valtellina",
                        "latitude": "46.25736000",
                        "longitude": "10.25534000"
                    },
                    {
                        "id": 140016,
                        "name": "Meda",
                        "latitude": "45.66121000",
                        "longitude": "9.15337000"
                    },
                    {
                        "id": 140017,
                        "name": "Mede",
                        "latitude": "45.09678000",
                        "longitude": "8.73679000"
                    },
                    {
                        "id": 140021,
                        "name": "Mediglia",
                        "latitude": "45.39537000",
                        "longitude": "9.33165000"
                    },
                    {
                        "id": 140023,
                        "name": "Medolago",
                        "latitude": "45.67129000",
                        "longitude": "9.49807000"
                    },
                    {
                        "id": 140024,
                        "name": "Medole",
                        "latitude": "45.32588000",
                        "longitude": "10.51357000"
                    },
                    {
                        "id": 140040,
                        "name": "Melegnano",
                        "latitude": "45.35781000",
                        "longitude": "9.32360000"
                    },
                    {
                        "id": 140042,
                        "name": "Meleti",
                        "latitude": "45.11967000",
                        "longitude": "9.83568000"
                    },
                    {
                        "id": 140055,
                        "name": "Mello",
                        "latitude": "46.15490000",
                        "longitude": "9.54734000"
                    },
                    {
                        "id": 140058,
                        "name": "Melzo",
                        "latitude": "45.49810000",
                        "longitude": "9.42043000"
                    },
                    {
                        "id": 140059,
                        "name": "Menaggio",
                        "latitude": "46.02075000",
                        "longitude": "9.23907000"
                    },
                    {
                        "id": 140060,
                        "name": "Menarola",
                        "latitude": "46.29929000",
                        "longitude": "9.36124000"
                    },
                    {
                        "id": 140061,
                        "name": "Menconico",
                        "latitude": "44.79656000",
                        "longitude": "9.27946000"
                    },
                    {
                        "id": 140069,
                        "name": "Merate",
                        "latitude": "45.68858000",
                        "longitude": "9.42080000"
                    },
                    {
                        "id": 140070,
                        "name": "Mercallo",
                        "latitude": "45.74791000",
                        "longitude": "8.66998000"
                    },
                    {
                        "id": 140087,
                        "name": "Merlino",
                        "latitude": "45.43337000",
                        "longitude": "9.42985000"
                    },
                    {
                        "id": 140088,
                        "name": "Merone",
                        "latitude": "45.78718000",
                        "longitude": "9.24404000"
                    },
                    {
                        "id": 140092,
                        "name": "Mese",
                        "latitude": "46.30360000",
                        "longitude": "9.37769000"
                    },
                    {
                        "id": 140093,
                        "name": "Mesenzana",
                        "latitude": "45.95158000",
                        "longitude": "8.76453000"
                    },
                    {
                        "id": 140094,
                        "name": "Mesero",
                        "latitude": "45.50227000",
                        "longitude": "8.85544000"
                    },
                    {
                        "id": 137775,
                        "name": "Metropolitan City of Milan",
                        "latitude": "45.45186000",
                        "longitude": "9.14586000"
                    },
                    {
                        "id": 140104,
                        "name": "Mezzago",
                        "latitude": "45.62898000",
                        "longitude": "9.44485000"
                    },
                    {
                        "id": 140106,
                        "name": "Mezzana Bigli",
                        "latitude": "45.05988000",
                        "longitude": "8.84728000"
                    },
                    {
                        "id": 140108,
                        "name": "Mezzana Rabattone",
                        "latitude": "45.09488000",
                        "longitude": "9.03247000"
                    },
                    {
                        "id": 140111,
                        "name": "Mezzanino",
                        "latitude": "45.12489000",
                        "longitude": "9.20497000"
                    },
                    {
                        "id": 140115,
                        "name": "Mezzate",
                        "latitude": "45.44385000",
                        "longitude": "9.29452000"
                    },
                    {
                        "id": 140116,
                        "name": "Mezzegra",
                        "latitude": "45.98168000",
                        "longitude": "9.20514000"
                    },
                    {
                        "id": 140122,
                        "name": "Mezzoldo",
                        "latitude": "46.01259000",
                        "longitude": "9.66555000"
                    },
                    {
                        "id": 140142,
                        "name": "Milan",
                        "latitude": "45.46427000",
                        "longitude": "9.18951000"
                    },
                    {
                        "id": 140151,
                        "name": "Millepini",
                        "latitude": "45.46967000",
                        "longitude": "9.33763000"
                    },
                    {
                        "id": 140154,
                        "name": "Milzano",
                        "latitude": "45.27358000",
                        "longitude": "10.19927000"
                    },
                    {
                        "id": 140172,
                        "name": "Miradolo Terme",
                        "latitude": "45.17094000",
                        "longitude": "9.44442000"
                    },
                    {
                        "id": 140179,
                        "name": "Misano di Gera d'Adda",
                        "latitude": "45.46946000",
                        "longitude": "9.62129000"
                    },
                    {
                        "id": 140181,
                        "name": "Misinto",
                        "latitude": "45.66142000",
                        "longitude": "9.08129000"
                    },
                    {
                        "id": 140182,
                        "name": "Missaglia",
                        "latitude": "45.70656000",
                        "longitude": "9.33471000"
                    },
                    {
                        "id": 140194,
                        "name": "Moggio",
                        "latitude": "45.93239000",
                        "longitude": "9.48623000"
                    },
                    {
                        "id": 140197,
                        "name": "Moglia",
                        "latitude": "44.93561000",
                        "longitude": "10.91463000"
                    },
                    {
                        "id": 140206,
                        "name": "Moio de' Calvi",
                        "latitude": "45.95179000",
                        "longitude": "9.70075000"
                    },
                    {
                        "id": 140218,
                        "name": "Molinetto",
                        "latitude": "45.49409000",
                        "longitude": "10.35888000"
                    },
                    {
                        "id": 140231,
                        "name": "Molteno",
                        "latitude": "45.77819000",
                        "longitude": "9.30386000"
                    },
                    {
                        "id": 140232,
                        "name": "Moltrasio",
                        "latitude": "45.85998000",
                        "longitude": "9.09844000"
                    },
                    {
                        "id": 140239,
                        "name": "Mombelli",
                        "latitude": "44.86866000",
                        "longitude": "9.23436000"
                    },
                    {
                        "id": 140243,
                        "name": "Mombretto",
                        "latitude": "45.42390000",
                        "longitude": "9.36506000"
                    },
                    {
                        "id": 140256,
                        "name": "Monasterolo",
                        "latitude": "45.76327000",
                        "longitude": "9.93138000"
                    },
                    {
                        "id": 140258,
                        "name": "Monasterolo del Castello",
                        "latitude": "45.76319000",
                        "longitude": "9.93166000"
                    },
                    {
                        "id": 140270,
                        "name": "Moncucco",
                        "latitude": "45.31032000",
                        "longitude": "9.03920000"
                    },
                    {
                        "id": 140293,
                        "name": "Moniga del Garda",
                        "latitude": "45.52665000",
                        "longitude": "10.53728000"
                    },
                    {
                        "id": 140295,
                        "name": "Monno",
                        "latitude": "46.21225000",
                        "longitude": "10.34012000"
                    },
                    {
                        "id": 140309,
                        "name": "Montagna in Valtellina",
                        "latitude": "46.17849000",
                        "longitude": "9.90295000"
                    },
                    {
                        "id": 140333,
                        "name": "Montalto Pavese",
                        "latitude": "44.97802000",
                        "longitude": "9.21232000"
                    },
                    {
                        "id": 140338,
                        "name": "Montanara",
                        "latitude": "45.13531000",
                        "longitude": "10.71879000"
                    },
                    {
                        "id": 140340,
                        "name": "Montanaso Lombardo",
                        "latitude": "45.33522000",
                        "longitude": "9.46551000"
                    },
                    {
                        "id": 140342,
                        "name": "Montano",
                        "latitude": "45.79423000",
                        "longitude": "9.02218000"
                    },
                    {
                        "id": 140344,
                        "name": "Montano Lucino",
                        "latitude": "45.78378000",
                        "longitude": "9.04244000"
                    },
                    {
                        "id": 140351,
                        "name": "Monte",
                        "latitude": "45.71489000",
                        "longitude": "8.82222000"
                    },
                    {
                        "id": 140357,
                        "name": "Monte Cremasco",
                        "latitude": "45.37224000",
                        "longitude": "9.57288000"
                    },
                    {
                        "id": 140361,
                        "name": "Monte Marenzo",
                        "latitude": "45.77213000",
                        "longitude": "9.45476000"
                    },
                    {
                        "id": 140386,
                        "name": "Montebello",
                        "latitude": "44.99994000",
                        "longitude": "9.10263000"
                    },
                    {
                        "id": 140397,
                        "name": "Montecalvo Versiggia",
                        "latitude": "44.97206000",
                        "longitude": "9.28536000"
                    },
                    {
                        "id": 140458,
                        "name": "Montegrino Valtravaglia",
                        "latitude": "45.97398000",
                        "longitude": "8.76743000"
                    },
                    {
                        "id": 140477,
                        "name": "Montello",
                        "latitude": "45.67208000",
                        "longitude": "9.80566000"
                    },
                    {
                        "id": 140492,
                        "name": "Montemezzo",
                        "latitude": "46.17879000",
                        "longitude": "9.37094000"
                    },
                    {
                        "id": 140535,
                        "name": "Montescano",
                        "latitude": "45.03196000",
                        "longitude": "9.28366000"
                    },
                    {
                        "id": 140540,
                        "name": "Montesegale",
                        "latitude": "44.90696000",
                        "longitude": "9.12636000"
                    },
                    {
                        "id": 140542,
                        "name": "Montesolaro",
                        "latitude": "45.72100000",
                        "longitude": "9.11760000"
                    },
                    {
                        "id": 140548,
                        "name": "Montevecchia",
                        "latitude": "45.70548000",
                        "longitude": "9.38085000"
                    },
                    {
                        "id": 140559,
                        "name": "Monticelli Brusati",
                        "latitude": "45.63478000",
                        "longitude": "10.10026000"
                    },
                    {
                        "id": 140560,
                        "name": "Monticelli Pavese",
                        "latitude": "45.11107000",
                        "longitude": "9.51276000"
                    },
                    {
                        "id": 140564,
                        "name": "Monticello",
                        "latitude": "45.71244000",
                        "longitude": "9.31481000"
                    },
                    {
                        "id": 140565,
                        "name": "Monticello Brianza",
                        "latitude": "45.70948000",
                        "longitude": "9.31564000"
                    },
                    {
                        "id": 140569,
                        "name": "Montichiari",
                        "latitude": "45.41317000",
                        "longitude": "10.39799000"
                    },
                    {
                        "id": 140575,
                        "name": "Montirone",
                        "latitude": "45.44638000",
                        "longitude": "10.22877000"
                    },
                    {
                        "id": 140577,
                        "name": "Montodine",
                        "latitude": "45.28419000",
                        "longitude": "9.70910000"
                    },
                    {
                        "id": 140582,
                        "name": "Montorfano",
                        "latitude": "45.78638000",
                        "longitude": "9.14374000"
                    },
                    {
                        "id": 140592,
                        "name": "Montù Beccaria",
                        "latitude": "45.03633000",
                        "longitude": "9.31268000"
                    },
                    {
                        "id": 140593,
                        "name": "Monvalle",
                        "latitude": "45.85810000",
                        "longitude": "8.63088000"
                    },
                    {
                        "id": 140594,
                        "name": "Monza",
                        "latitude": "45.58005000",
                        "longitude": "9.27246000"
                    },
                    {
                        "id": 140595,
                        "name": "Monzambano",
                        "latitude": "45.38534000",
                        "longitude": "10.69331000"
                    },
                    {
                        "id": 140601,
                        "name": "Morazzone",
                        "latitude": "45.76447000",
                        "longitude": "8.82813000"
                    },
                    {
                        "id": 140602,
                        "name": "Morbegno",
                        "latitude": "46.13720000",
                        "longitude": "9.57415000"
                    },
                    {
                        "id": 140608,
                        "name": "Morengo",
                        "latitude": "45.53148000",
                        "longitude": "9.70586000"
                    },
                    {
                        "id": 140619,
                        "name": "Morimondo",
                        "latitude": "45.35381000",
                        "longitude": "8.95626000"
                    },
                    {
                        "id": 140624,
                        "name": "Mornago",
                        "latitude": "45.74516000",
                        "longitude": "8.75046000"
                    },
                    {
                        "id": 140626,
                        "name": "Mornico",
                        "latitude": "45.01062000",
                        "longitude": "9.20926000"
                    },
                    {
                        "id": 140628,
                        "name": "Mornico al Serio",
                        "latitude": "45.59138000",
                        "longitude": "9.80926000"
                    },
                    {
                        "id": 140627,
                        "name": "Mornico Losana",
                        "latitude": "45.01016000",
                        "longitude": "9.20616000"
                    },
                    {
                        "id": 140639,
                        "name": "Mortara",
                        "latitude": "45.24940000",
                        "longitude": "8.73302000"
                    },
                    {
                        "id": 140641,
                        "name": "Morterone",
                        "latitude": "45.87480000",
                        "longitude": "9.48233000"
                    },
                    {
                        "id": 140643,
                        "name": "Moscazzano",
                        "latitude": "45.29358000",
                        "longitude": "9.68135000"
                    },
                    {
                        "id": 140656,
                        "name": "Motta Baluffi",
                        "latitude": "45.05569000",
                        "longitude": "10.25855000"
                    },
                    {
                        "id": 140663,
                        "name": "Motta Visconti",
                        "latitude": "45.28774000",
                        "longitude": "8.99254000"
                    },
                    {
                        "id": 140668,
                        "name": "Motteggiana",
                        "latitude": "45.03307000",
                        "longitude": "10.76269000"
                    },
                    {
                        "id": 140669,
                        "name": "Mottella",
                        "latitude": "45.16382000",
                        "longitude": "10.84436000"
                    },
                    {
                        "id": 140672,
                        "name": "Mozzanica",
                        "latitude": "45.47680000",
                        "longitude": "9.68849000"
                    },
                    {
                        "id": 140673,
                        "name": "Mozzate",
                        "latitude": "45.67473000",
                        "longitude": "8.95644000"
                    },
                    {
                        "id": 140675,
                        "name": "Mozzo",
                        "latitude": "45.69868000",
                        "longitude": "9.60865000"
                    },
                    {
                        "id": 140678,
                        "name": "Muggiò",
                        "latitude": "45.58878000",
                        "longitude": "9.22784000"
                    },
                    {
                        "id": 140681,
                        "name": "Mulazzano",
                        "latitude": "45.37237000",
                        "longitude": "9.39765000"
                    },
                    {
                        "id": 140684,
                        "name": "Mura",
                        "latitude": "45.71307000",
                        "longitude": "10.34204000"
                    },
                    {
                        "id": 140698,
                        "name": "Muscoline",
                        "latitude": "45.56249000",
                        "longitude": "10.46187000"
                    },
                    {
                        "id": 140702,
                        "name": "Musso",
                        "latitude": "46.11295000",
                        "longitude": "9.27379000"
                    },
                    {
                        "id": 140706,
                        "name": "Muzza di Cornegliano Laudense",
                        "latitude": "45.28462000",
                        "longitude": "9.47166000"
                    },
                    {
                        "id": 140727,
                        "name": "Nava",
                        "latitude": "45.76219000",
                        "longitude": "9.36308000"
                    },
                    {
                        "id": 140728,
                        "name": "Nave",
                        "latitude": "45.58480000",
                        "longitude": "10.27947000"
                    },
                    {
                        "id": 140730,
                        "name": "Navedano",
                        "latitude": "45.75524000",
                        "longitude": "9.09470000"
                    },
                    {
                        "id": 140736,
                        "name": "Negrone",
                        "latitude": "45.71028000",
                        "longitude": "9.75811000"
                    },
                    {
                        "id": 140739,
                        "name": "Nembro",
                        "latitude": "45.74411000",
                        "longitude": "9.76127000"
                    },
                    {
                        "id": 140749,
                        "name": "Nerviano",
                        "latitude": "45.55343000",
                        "longitude": "8.97920000"
                    },
                    {
                        "id": 140751,
                        "name": "Nesso",
                        "latitude": "45.91238000",
                        "longitude": "9.15674000"
                    },
                    {
                        "id": 140757,
                        "name": "Niardo",
                        "latitude": "45.97599000",
                        "longitude": "10.33326000"
                    },
                    {
                        "id": 140760,
                        "name": "Nibionno",
                        "latitude": "45.74648000",
                        "longitude": "9.26894000"
                    },
                    {
                        "id": 140764,
                        "name": "Nicorvo",
                        "latitude": "45.28566000",
                        "longitude": "8.66794000"
                    },
                    {
                        "id": 140769,
                        "name": "Nigoline-Bonomelli",
                        "latitude": "45.62908000",
                        "longitude": "9.98682000"
                    },
                    {
                        "id": 140778,
                        "name": "Nobile-Monguzzo",
                        "latitude": "45.78018000",
                        "longitude": "9.23024000"
                    },
                    {
                        "id": 140809,
                        "name": "Nosadello",
                        "latitude": "45.40268000",
                        "longitude": "9.53047000"
                    },
                    {
                        "id": 140810,
                        "name": "Nosate",
                        "latitude": "45.55074000",
                        "longitude": "8.72509000"
                    },
                    {
                        "id": 140814,
                        "name": "Nova Milanese",
                        "latitude": "45.58882000",
                        "longitude": "9.19792000"
                    },
                    {
                        "id": 140819,
                        "name": "Novagli",
                        "latitude": "45.38688000",
                        "longitude": "10.43874000"
                    },
                    {
                        "id": 140824,
                        "name": "Novate Mezzola",
                        "latitude": "46.21939000",
                        "longitude": "9.44971000"
                    },
                    {
                        "id": 140825,
                        "name": "Novate Milanese",
                        "latitude": "45.53050000",
                        "longitude": "9.13954000"
                    },
                    {
                        "id": 140827,
                        "name": "Novedrate",
                        "latitude": "45.69808000",
                        "longitude": "9.12074000"
                    },
                    {
                        "id": 140828,
                        "name": "Novegro-Tregarezzo-San Felice",
                        "latitude": "45.46778000",
                        "longitude": "9.28122000"
                    },
                    {
                        "id": 140834,
                        "name": "Noverasco-Sporting Mirasole",
                        "latitude": "45.39544000",
                        "longitude": "9.21427000"
                    },
                    {
                        "id": 140838,
                        "name": "Noviglio",
                        "latitude": "45.35907000",
                        "longitude": "9.05215000"
                    },
                    {
                        "id": 140862,
                        "name": "Nuvolento",
                        "latitude": "45.54599000",
                        "longitude": "10.38809000"
                    },
                    {
                        "id": 140863,
                        "name": "Nuvolera",
                        "latitude": "45.53218000",
                        "longitude": "10.36917000"
                    },
                    {
                        "id": 140865,
                        "name": "Occagno",
                        "latitude": "45.92901000",
                        "longitude": "9.09870000"
                    },
                    {
                        "id": 140873,
                        "name": "Odolo",
                        "latitude": "45.64550000",
                        "longitude": "10.38309000"
                    },
                    {
                        "id": 140876,
                        "name": "Offanengo",
                        "latitude": "45.37887000",
                        "longitude": "9.74236000"
                    },
                    {
                        "id": 140878,
                        "name": "Offlaga",
                        "latitude": "45.38526000",
                        "longitude": "10.11736000"
                    },
                    {
                        "id": 140880,
                        "name": "Oggiona-Santo Stefano",
                        "latitude": "45.70427000",
                        "longitude": "8.81653000"
                    },
                    {
                        "id": 140881,
                        "name": "Oggiono",
                        "latitude": "45.79133000",
                        "longitude": "9.34815000"
                    },
                    {
                        "id": 140890,
                        "name": "Olevano di Lomellina",
                        "latitude": "45.21322000",
                        "longitude": "8.71750000"
                    },
                    {
                        "id": 140892,
                        "name": "Olgiate Comasco",
                        "latitude": "45.78436000",
                        "longitude": "8.96816000"
                    },
                    {
                        "id": 140893,
                        "name": "Olgiate Molgora",
                        "latitude": "45.73028000",
                        "longitude": "9.40335000"
                    },
                    {
                        "id": 140894,
                        "name": "Olgiate Olona",
                        "latitude": "45.63706000",
                        "longitude": "8.88147000"
                    },
                    {
                        "id": 140895,
                        "name": "Olginate",
                        "latitude": "45.79126000",
                        "longitude": "9.41869000"
                    },
                    {
                        "id": 140898,
                        "name": "Oliva Gessi",
                        "latitude": "45.00597000",
                        "longitude": "9.17317000"
                    },
                    {
                        "id": 140909,
                        "name": "Olmeneta",
                        "latitude": "45.23540000",
                        "longitude": "10.02318000"
                    },
                    {
                        "id": 140911,
                        "name": "Olmo al Brembo",
                        "latitude": "45.97006000",
                        "longitude": "9.65034000"
                    },
                    {
                        "id": 140913,
                        "name": "Oltre Il Colle",
                        "latitude": "45.88949000",
                        "longitude": "9.76925000"
                    },
                    {
                        "id": 140914,
                        "name": "Oltressenda Alta",
                        "latitude": "45.91519000",
                        "longitude": "9.94486000"
                    },
                    {
                        "id": 140915,
                        "name": "Oltrona di San Mamette",
                        "latitude": "45.75578000",
                        "longitude": "8.97673000"
                    },
                    {
                        "id": 140917,
                        "name": "Ome",
                        "latitude": "45.62728000",
                        "longitude": "10.12137000"
                    },
                    {
                        "id": 140923,
                        "name": "Oneta",
                        "latitude": "45.87149000",
                        "longitude": "9.81935000"
                    },
                    {
                        "id": 140927,
                        "name": "Ono San Pietro",
                        "latitude": "46.01689000",
                        "longitude": "10.32836000"
                    },
                    {
                        "id": 140928,
                        "name": "Onore",
                        "latitude": "45.89159000",
                        "longitude": "10.01076000"
                    },
                    {
                        "id": 140931,
                        "name": "Opera",
                        "latitude": "45.37355000",
                        "longitude": "9.21084000"
                    },
                    {
                        "id": 140953,
                        "name": "Origgio",
                        "latitude": "45.59676000",
                        "longitude": "9.01645000"
                    },
                    {
                        "id": 140954,
                        "name": "Orino",
                        "latitude": "45.88148000",
                        "longitude": "8.71563000"
                    },
                    {
                        "id": 140957,
                        "name": "Orio al Serio",
                        "latitude": "45.67490000",
                        "longitude": "9.69083000"
                    },
                    {
                        "id": 140956,
                        "name": "Orio Litta",
                        "latitude": "45.16244000",
                        "longitude": "9.55447000"
                    },
                    {
                        "id": 140963,
                        "name": "Ornago",
                        "latitude": "45.59987000",
                        "longitude": "9.42099000"
                    },
                    {
                        "id": 140965,
                        "name": "Ornica",
                        "latitude": "45.98892000",
                        "longitude": "9.57848000"
                    },
                    {
                        "id": 140974,
                        "name": "Orsenigo",
                        "latitude": "45.77839000",
                        "longitude": "9.17963000"
                    },
                    {
                        "id": 140997,
                        "name": "Orzinuovi",
                        "latitude": "45.40191000",
                        "longitude": "9.92319000"
                    },
                    {
                        "id": 140998,
                        "name": "Orzivecchi",
                        "latitude": "45.42058000",
                        "longitude": "9.96326000"
                    },
                    {
                        "id": 141005,
                        "name": "Osigo",
                        "latitude": "45.87532000",
                        "longitude": "9.29559000"
                    },
                    {
                        "id": 141009,
                        "name": "Osio Sopra",
                        "latitude": "45.62908000",
                        "longitude": "9.58465000"
                    },
                    {
                        "id": 141010,
                        "name": "Osio Sotto",
                        "latitude": "45.61608000",
                        "longitude": "9.58905000"
                    },
                    {
                        "id": 141011,
                        "name": "Osmate",
                        "latitude": "45.78867000",
                        "longitude": "8.65523000"
                    },
                    {
                        "id": 141012,
                        "name": "Osnago",
                        "latitude": "45.67548000",
                        "longitude": "9.39192000"
                    },
                    {
                        "id": 141019,
                        "name": "Ospedaletto Lodigiano",
                        "latitude": "45.16877000",
                        "longitude": "9.57866000"
                    },
                    {
                        "id": 141023,
                        "name": "Ospitaletto",
                        "latitude": "45.55221000",
                        "longitude": "10.07562000"
                    },
                    {
                        "id": 141024,
                        "name": "Ossago Lodigiano",
                        "latitude": "45.24210000",
                        "longitude": "9.53720000"
                    },
                    {
                        "id": 141027,
                        "name": "Ossimo Superiore",
                        "latitude": "45.94619000",
                        "longitude": "10.23056000"
                    },
                    {
                        "id": 141028,
                        "name": "Ossona",
                        "latitude": "45.50708000",
                        "longitude": "8.89314000"
                    },
                    {
                        "id": 141029,
                        "name": "Ossuccio",
                        "latitude": "45.96958000",
                        "longitude": "9.17974000"
                    },
                    {
                        "id": 141032,
                        "name": "Osteno",
                        "latitude": "46.00668000",
                        "longitude": "9.08385000"
                    },
                    {
                        "id": 141033,
                        "name": "Osteno-Claino",
                        "latitude": "46.00367000",
                        "longitude": "9.08741000"
                    },
                    {
                        "id": 141040,
                        "name": "Ostiano",
                        "latitude": "45.22260000",
                        "longitude": "10.25450000"
                    },
                    {
                        "id": 141041,
                        "name": "Ostiglia",
                        "latitude": "45.06978000",
                        "longitude": "11.13499000"
                    },
                    {
                        "id": 141052,
                        "name": "Ottobiano",
                        "latitude": "45.15418000",
                        "longitude": "8.83198000"
                    },
                    {
                        "id": 141066,
                        "name": "Ozzero",
                        "latitude": "45.36775000",
                        "longitude": "8.92440000"
                    },
                    {
                        "id": 141073,
                        "name": "Padenghe sul Garda",
                        "latitude": "45.50787000",
                        "longitude": "10.51857000"
                    },
                    {
                        "id": 141081,
                        "name": "Paderno d'Adda",
                        "latitude": "45.67879000",
                        "longitude": "9.44491000"
                    },
                    {
                        "id": 141078,
                        "name": "Paderno Dugnano",
                        "latitude": "45.56899000",
                        "longitude": "9.16483000"
                    },
                    {
                        "id": 141079,
                        "name": "Paderno Franciacorta",
                        "latitude": "45.58687000",
                        "longitude": "10.07975000"
                    },
                    {
                        "id": 141080,
                        "name": "Paderno Ponchielli",
                        "latitude": "45.23797000",
                        "longitude": "9.92876000"
                    },
                    {
                        "id": 58203,
                        "name": "Pagazzano",
                        "latitude": "45.53428000",
                        "longitude": "9.67116000"
                    },
                    {
                        "id": 58212,
                        "name": "Pagnona",
                        "latitude": "46.05969000",
                        "longitude": "9.40274000"
                    },
                    {
                        "id": 58215,
                        "name": "Paisco Loveno",
                        "latitude": "46.07910000",
                        "longitude": "10.29256000"
                    },
                    {
                        "id": 58216,
                        "name": "Paitone",
                        "latitude": "45.55208000",
                        "longitude": "10.40227000"
                    },
                    {
                        "id": 58217,
                        "name": "Paladina",
                        "latitude": "45.73068000",
                        "longitude": "9.60585000"
                    },
                    {
                        "id": 58226,
                        "name": "Palazzago",
                        "latitude": "45.75298000",
                        "longitude": "9.53365000"
                    },
                    {
                        "id": 58230,
                        "name": "Palazzo Pignano",
                        "latitude": "45.39007000",
                        "longitude": "9.56956000"
                    },
                    {
                        "id": 58236,
                        "name": "Palazzolo sull'Oglio",
                        "latitude": "45.59665000",
                        "longitude": "9.88688000"
                    },
                    {
                        "id": 58242,
                        "name": "Palestro",
                        "latitude": "45.30302000",
                        "longitude": "8.53320000"
                    },
                    {
                        "id": 58244,
                        "name": "Palidano",
                        "latitude": "44.97203000",
                        "longitude": "10.77943000"
                    },
                    {
                        "id": 58266,
                        "name": "Palosco",
                        "latitude": "45.58928000",
                        "longitude": "9.83646000"
                    },
                    {
                        "id": 58274,
                        "name": "Pancarana",
                        "latitude": "45.07523000",
                        "longitude": "9.05109000"
                    },
                    {
                        "id": 58276,
                        "name": "Pandino",
                        "latitude": "45.40559000",
                        "longitude": "9.55218000"
                    },
                    {
                        "id": 58285,
                        "name": "Pantigliate",
                        "latitude": "45.43526000",
                        "longitude": "9.35220000"
                    },
                    {
                        "id": 58294,
                        "name": "Parabiago",
                        "latitude": "45.56034000",
                        "longitude": "8.94545000"
                    },
                    {
                        "id": 58296,
                        "name": "Paratico",
                        "latitude": "45.65879000",
                        "longitude": "9.95792000"
                    },
                    {
                        "id": 58320,
                        "name": "Parè",
                        "latitude": "45.81088000",
                        "longitude": "9.00874000"
                    },
                    {
                        "id": 58306,
                        "name": "Parlasco",
                        "latitude": "46.01789000",
                        "longitude": "9.34494000"
                    },
                    {
                        "id": 58308,
                        "name": "Parmezzana Calzana",
                        "latitude": "45.63350000",
                        "longitude": "10.09540000"
                    },
                    {
                        "id": 58313,
                        "name": "Parona",
                        "latitude": "45.28165000",
                        "longitude": "8.75055000"
                    },
                    {
                        "id": 58315,
                        "name": "Parre",
                        "latitude": "45.87459000",
                        "longitude": "9.89086000"
                    },
                    {
                        "id": 58319,
                        "name": "Parzanica",
                        "latitude": "45.73873000",
                        "longitude": "10.03518000"
                    },
                    {
                        "id": 58324,
                        "name": "Paspardo",
                        "latitude": "46.03225000",
                        "longitude": "10.36879000"
                    },
                    {
                        "id": 58329,
                        "name": "Passirana",
                        "latitude": "45.54792000",
                        "longitude": "9.04412000"
                    },
                    {
                        "id": 58330,
                        "name": "Passirano",
                        "latitude": "45.59673000",
                        "longitude": "10.06986000"
                    },
                    {
                        "id": 58342,
                        "name": "Pasturo",
                        "latitude": "45.95168000",
                        "longitude": "9.44414000"
                    },
                    {
                        "id": 58356,
                        "name": "Paullo",
                        "latitude": "45.41834000",
                        "longitude": "9.40042000"
                    },
                    {
                        "id": 58359,
                        "name": "Pavia",
                        "latitude": "45.19205000",
                        "longitude": "9.15917000"
                    },
                    {
                        "id": 58364,
                        "name": "Pavone del Mella",
                        "latitude": "45.30147000",
                        "longitude": "10.20984000"
                    },
                    {
                        "id": 58382,
                        "name": "Pedesina",
                        "latitude": "46.08189000",
                        "longitude": "9.54944000"
                    },
                    {
                        "id": 58384,
                        "name": "Pedrengo",
                        "latitude": "45.69598000",
                        "longitude": "9.73495000"
                    },
                    {
                        "id": 58386,
                        "name": "Peglio",
                        "latitude": "46.16039000",
                        "longitude": "9.29474000"
                    },
                    {
                        "id": 58387,
                        "name": "Pegognaga",
                        "latitude": "44.99456000",
                        "longitude": "10.85967000"
                    },
                    {
                        "id": 58389,
                        "name": "Peia",
                        "latitude": "45.79949000",
                        "longitude": "9.89926000"
                    },
                    {
                        "id": 58396,
                        "name": "Pellio Intelvi",
                        "latitude": "45.97988000",
                        "longitude": "9.05864000"
                    },
                    {
                        "id": 58419,
                        "name": "Perego",
                        "latitude": "45.73758000",
                        "longitude": "9.36295000"
                    },
                    {
                        "id": 58427,
                        "name": "Perledo",
                        "latitude": "46.01529000",
                        "longitude": "9.29560000"
                    },
                    {
                        "id": 58435,
                        "name": "Pero",
                        "latitude": "45.51017000",
                        "longitude": "9.08704000"
                    },
                    {
                        "id": 58439,
                        "name": "Persico Dosimo",
                        "latitude": "45.18587000",
                        "longitude": "10.10517000"
                    },
                    {
                        "id": 58442,
                        "name": "Pertica Alta",
                        "latitude": "45.74239000",
                        "longitude": "10.34417000"
                    },
                    {
                        "id": 58443,
                        "name": "Pertica Bassa",
                        "latitude": "45.75339000",
                        "longitude": "10.37247000"
                    },
                    {
                        "id": 58451,
                        "name": "Pescarolo",
                        "latitude": "45.19387000",
                        "longitude": "10.18647000"
                    },
                    {
                        "id": 58453,
                        "name": "Pescate",
                        "latitude": "45.83348000",
                        "longitude": "9.39395000"
                    },
                    {
                        "id": 58469,
                        "name": "Pessano Con Bornago",
                        "latitude": "45.54937000",
                        "longitude": "9.38145000"
                    },
                    {
                        "id": 58470,
                        "name": "Pessina Cremonese",
                        "latitude": "45.18505000",
                        "longitude": "10.24815000"
                    },
                    {
                        "id": 58499,
                        "name": "Pezzaze",
                        "latitude": "45.77629000",
                        "longitude": "10.23597000"
                    },
                    {
                        "id": 58504,
                        "name": "Piadena",
                        "latitude": "45.12859000",
                        "longitude": "10.37101000"
                    },
                    {
                        "id": 58507,
                        "name": "Piamborno",
                        "latitude": "45.91969000",
                        "longitude": "10.22526000"
                    },
                    {
                        "id": 58508,
                        "name": "Pian Camuno",
                        "latitude": "45.84186000",
                        "longitude": "10.14181000"
                    },
                    {
                        "id": 58516,
                        "name": "Pianazzo",
                        "latitude": "46.42815000",
                        "longitude": "9.34420000"
                    },
                    {
                        "id": 58527,
                        "name": "Pianello del Lario",
                        "latitude": "46.10279000",
                        "longitude": "9.27694000"
                    },
                    {
                        "id": 58528,
                        "name": "Pianengo",
                        "latitude": "45.40217000",
                        "longitude": "9.69476000"
                    },
                    {
                        "id": 58532,
                        "name": "Piangaiano",
                        "latitude": "45.78877000",
                        "longitude": "9.99461000"
                    },
                    {
                        "id": 58534,
                        "name": "Pianico",
                        "latitude": "45.80989000",
                        "longitude": "10.04306000"
                    },
                    {
                        "id": 58552,
                        "name": "Piantedo",
                        "latitude": "46.13663000",
                        "longitude": "9.42770000"
                    },
                    {
                        "id": 58555,
                        "name": "Piario",
                        "latitude": "45.89649000",
                        "longitude": "9.92726000"
                    },
                    {
                        "id": 58557,
                        "name": "Piateda Centro",
                        "latitude": "46.15960000",
                        "longitude": "9.93495000"
                    },
                    {
                        "id": 58561,
                        "name": "Piazza",
                        "latitude": "45.58725000",
                        "longitude": "10.15526000"
                    },
                    {
                        "id": 58566,
                        "name": "Piazza Brembana",
                        "latitude": "45.94769000",
                        "longitude": "9.67330000"
                    },
                    {
                        "id": 58567,
                        "name": "Piazza Caduti",
                        "latitude": "45.70513000",
                        "longitude": "9.50251000"
                    },
                    {
                        "id": 58573,
                        "name": "Piazzatorre",
                        "latitude": "45.99273000",
                        "longitude": "9.68942000"
                    },
                    {
                        "id": 58577,
                        "name": "Piazzolo",
                        "latitude": "45.97979000",
                        "longitude": "9.67055000"
                    },
                    {
                        "id": 58598,
                        "name": "Pieranica",
                        "latitude": "45.42617000",
                        "longitude": "9.61026000"
                    },
                    {
                        "id": 58603,
                        "name": "Pietra de' Giorgi",
                        "latitude": "45.02136000",
                        "longitude": "9.23036000"
                    },
                    {
                        "id": 58630,
                        "name": "Pieve",
                        "latitude": "45.77273000",
                        "longitude": "10.75913000"
                    },
                    {
                        "id": 58632,
                        "name": "Pieve Albignola",
                        "latitude": "45.11316000",
                        "longitude": "8.95999000"
                    },
                    {
                        "id": 58646,
                        "name": "Pieve d'Olmi",
                        "latitude": "45.08957000",
                        "longitude": "10.12368000"
                    },
                    {
                        "id": 58647,
                        "name": "Pieve del Cairo",
                        "latitude": "45.04920000",
                        "longitude": "8.80322000"
                    },
                    {
                        "id": 58651,
                        "name": "Pieve di Coriano",
                        "latitude": "45.03388000",
                        "longitude": "11.10780000"
                    },
                    {
                        "id": 58633,
                        "name": "Pieve Emanuele",
                        "latitude": "45.35052000",
                        "longitude": "9.20268000"
                    },
                    {
                        "id": 58634,
                        "name": "Pieve Fissiraga",
                        "latitude": "45.26327000",
                        "longitude": "9.45836000"
                    },
                    {
                        "id": 58637,
                        "name": "Pieve Porto Morone",
                        "latitude": "45.10979000",
                        "longitude": "9.44019000"
                    },
                    {
                        "id": 58638,
                        "name": "Pieve San Giacomo",
                        "latitude": "45.13204000",
                        "longitude": "10.18775000"
                    },
                    {
                        "id": 58657,
                        "name": "Pievedizio",
                        "latitude": "45.46062000",
                        "longitude": "10.08771000"
                    },
                    {
                        "id": 58665,
                        "name": "Pigra",
                        "latitude": "45.95735000",
                        "longitude": "9.12649000"
                    },
                    {
                        "id": 58672,
                        "name": "Pinarolo Po",
                        "latitude": "45.06986000",
                        "longitude": "9.16725000"
                    },
                    {
                        "id": 58680,
                        "name": "Pino sulla Sponda del Lago Maggiore",
                        "latitude": "46.10078000",
                        "longitude": "8.73873000"
                    },
                    {
                        "id": 58688,
                        "name": "Pioltello",
                        "latitude": "45.50147000",
                        "longitude": "9.33053000"
                    },
                    {
                        "id": 58711,
                        "name": "Pisogne",
                        "latitude": "45.80777000",
                        "longitude": "10.11023000"
                    },
                    {
                        "id": 58719,
                        "name": "Piubega",
                        "latitude": "45.22677000",
                        "longitude": "10.53195000"
                    },
                    {
                        "id": 58721,
                        "name": "Piuro",
                        "latitude": "46.32979000",
                        "longitude": "9.42064000"
                    },
                    {
                        "id": 58723,
                        "name": "Pizzale",
                        "latitude": "45.03856000",
                        "longitude": "9.04995000"
                    },
                    {
                        "id": 58725,
                        "name": "Pizzighettone",
                        "latitude": "45.18690000",
                        "longitude": "9.78781000"
                    },
                    {
                        "id": 58737,
                        "name": "Plesio",
                        "latitude": "46.04742000",
                        "longitude": "9.22882000"
                    },
                    {
                        "id": 58741,
                        "name": "Poasco-Sorigherio",
                        "latitude": "45.40310000",
                        "longitude": "9.23092000"
                    },
                    {
                        "id": 58761,
                        "name": "Poggio Rusco",
                        "latitude": "44.96693000",
                        "longitude": "11.10419000"
                    },
                    {
                        "id": 58772,
                        "name": "Poggiridenti Alto",
                        "latitude": "46.17480000",
                        "longitude": "9.92605000"
                    },
                    {
                        "id": 58773,
                        "name": "Poggiridenti Piano",
                        "latitude": "46.16991000",
                        "longitude": "9.92671000"
                    },
                    {
                        "id": 58774,
                        "name": "Pogliano Milanese",
                        "latitude": "45.53786000",
                        "longitude": "8.99403000"
                    },
                    {
                        "id": 58775,
                        "name": "Pognana Lario",
                        "latitude": "45.88044000",
                        "longitude": "9.15762000"
                    },
                    {
                        "id": 58776,
                        "name": "Pognano",
                        "latitude": "45.58638000",
                        "longitude": "9.63996000"
                    },
                    {
                        "id": 58782,
                        "name": "Polaveno",
                        "latitude": "45.66148000",
                        "longitude": "10.12396000"
                    },
                    {
                        "id": 58804,
                        "name": "Polpenazze del Garda",
                        "latitude": "45.55118000",
                        "longitude": "10.50488000"
                    },
                    {
                        "id": 58814,
                        "name": "Pometo",
                        "latitude": "44.92788000",
                        "longitude": "9.27348000"
                    },
                    {
                        "id": 58819,
                        "name": "Pompiano",
                        "latitude": "45.43116000",
                        "longitude": "9.98910000"
                    },
                    {
                        "id": 58820,
                        "name": "Pomponesco",
                        "latitude": "44.93118000",
                        "longitude": "10.59402000"
                    },
                    {
                        "id": 58822,
                        "name": "Poncarale",
                        "latitude": "45.46089000",
                        "longitude": "10.17976000"
                    },
                    {
                        "id": 58824,
                        "name": "Ponna Superiore",
                        "latitude": "45.98957000",
                        "longitude": "9.09406000"
                    },
                    {
                        "id": 58837,
                        "name": "Ponte Caffaro",
                        "latitude": "45.82078000",
                        "longitude": "10.52707000"
                    },
                    {
                        "id": 58838,
                        "name": "Ponte Cingoli",
                        "latitude": "45.59751000",
                        "longitude": "10.10687000"
                    },
                    {
                        "id": 58856,
                        "name": "Ponte di Legno",
                        "latitude": "46.25896000",
                        "longitude": "10.51048000"
                    },
                    {
                        "id": 58859,
                        "name": "Ponte in Valtellina",
                        "latitude": "46.17500000",
                        "longitude": "9.97785000"
                    },
                    {
                        "id": 58842,
                        "name": "Ponte Lambro",
                        "latitude": "45.82539000",
                        "longitude": "9.22455000"
                    },
                    {
                        "id": 58843,
                        "name": "Ponte Nizza",
                        "latitude": "44.85188000",
                        "longitude": "9.09739000"
                    },
                    {
                        "id": 58844,
                        "name": "Ponte Nossa",
                        "latitude": "45.86611000",
                        "longitude": "9.88364000"
                    },
                    {
                        "id": 58847,
                        "name": "Ponte San Marco",
                        "latitude": "45.47686000",
                        "longitude": "10.41315000"
                    },
                    {
                        "id": 58849,
                        "name": "Ponte San Pietro",
                        "latitude": "45.70596000",
                        "longitude": "9.59050000"
                    },
                    {
                        "id": 58876,
                        "name": "Ponteranica",
                        "latitude": "45.73248000",
                        "longitude": "9.65175000"
                    },
                    {
                        "id": 58880,
                        "name": "Pontevico",
                        "latitude": "45.27315000",
                        "longitude": "10.09248000"
                    },
                    {
                        "id": 58883,
                        "name": "Ponti sul Mincio",
                        "latitude": "45.41208000",
                        "longitude": "10.68508000"
                    },
                    {
                        "id": 58887,
                        "name": "Pontida",
                        "latitude": "45.73129000",
                        "longitude": "9.51141000"
                    },
                    {
                        "id": 58890,
                        "name": "Pontirolo Nuovo",
                        "latitude": "45.56918000",
                        "longitude": "9.56935000"
                    },
                    {
                        "id": 58891,
                        "name": "Pontoglio",
                        "latitude": "45.56938000",
                        "longitude": "9.85346000"
                    },
                    {
                        "id": 58907,
                        "name": "Porlezza",
                        "latitude": "46.03714000",
                        "longitude": "9.12921000"
                    },
                    {
                        "id": 58914,
                        "name": "Portalbera",
                        "latitude": "45.09789000",
                        "longitude": "9.31774000"
                    },
                    {
                        "id": 58924,
                        "name": "Porto Ceresio",
                        "latitude": "45.91285000",
                        "longitude": "8.89684000"
                    },
                    {
                        "id": 58941,
                        "name": "Porto d'Adda",
                        "latitude": "45.66241000",
                        "longitude": "9.47563000"
                    },
                    {
                        "id": 58939,
                        "name": "Porto Valtravaglia",
                        "latitude": "45.96088000",
                        "longitude": "8.68109000"
                    },
                    {
                        "id": 58961,
                        "name": "Postalesio",
                        "latitude": "46.17379000",
                        "longitude": "9.77659000"
                    },
                    {
                        "id": 58976,
                        "name": "Pozzaglio",
                        "latitude": "45.19999000",
                        "longitude": "10.05345000"
                    },
                    {
                        "id": 58977,
                        "name": "Pozzaglio ed Uniti",
                        "latitude": "45.20027000",
                        "longitude": "10.05057000"
                    },
                    {
                        "id": 58982,
                        "name": "Pozzo d'Adda",
                        "latitude": "45.57258000",
                        "longitude": "9.50295000"
                    },
                    {
                        "id": 58984,
                        "name": "Pozzolengo",
                        "latitude": "45.40515000",
                        "longitude": "10.63040000"
                    },
                    {
                        "id": 58991,
                        "name": "Pozzuolo Martesana",
                        "latitude": "45.51398000",
                        "longitude": "9.45625000"
                    },
                    {
                        "id": 58993,
                        "name": "Pradalunga",
                        "latitude": "45.74588000",
                        "longitude": "9.78225000"
                    },
                    {
                        "id": 59000,
                        "name": "Pralboino",
                        "latitude": "45.26720000",
                        "longitude": "10.21839000"
                    },
                    {
                        "id": 59012,
                        "name": "Prata Camportaccio",
                        "latitude": "46.30719000",
                        "longitude": "9.39524000"
                    },
                    {
                        "id": 59013,
                        "name": "Prata Centro",
                        "latitude": "46.30847000",
                        "longitude": "9.39625000"
                    },
                    {
                        "id": 59046,
                        "name": "Predore",
                        "latitude": "45.68085000",
                        "longitude": "10.01271000"
                    },
                    {
                        "id": 59049,
                        "name": "Pregnana Milanese",
                        "latitude": "45.51597000",
                        "longitude": "9.00704000"
                    },
                    {
                        "id": 59050,
                        "name": "Pregola",
                        "latitude": "44.75069000",
                        "longitude": "9.28223000"
                    },
                    {
                        "id": 59052,
                        "name": "Premana",
                        "latitude": "46.05245000",
                        "longitude": "9.42129000"
                    },
                    {
                        "id": 59055,
                        "name": "Premenugo",
                        "latitude": "45.46790000",
                        "longitude": "9.38458000"
                    },
                    {
                        "id": 59058,
                        "name": "Premolo",
                        "latitude": "45.87019000",
                        "longitude": "9.87466000"
                    },
                    {
                        "id": 59064,
                        "name": "Preseglie",
                        "latitude": "45.66829000",
                        "longitude": "10.39677000"
                    },
                    {
                        "id": 59066,
                        "name": "Presezzo",
                        "latitude": "45.69208000",
                        "longitude": "9.57035000"
                    },
                    {
                        "id": 59071,
                        "name": "Prevalle",
                        "latitude": "45.55138000",
                        "longitude": "10.42207000"
                    },
                    {
                        "id": 59078,
                        "name": "Primaluna",
                        "latitude": "45.98379000",
                        "longitude": "9.43764000"
                    },
                    {
                        "id": 59093,
                        "name": "Proserpio",
                        "latitude": "45.82828000",
                        "longitude": "9.24554000"
                    },
                    {
                        "id": 59095,
                        "name": "Prosto",
                        "latitude": "46.32946000",
                        "longitude": "9.42094000"
                    },
                    {
                        "id": 59097,
                        "name": "Provaglio d'Iseo",
                        "latitude": "45.63538000",
                        "longitude": "10.04466000"
                    },
                    {
                        "id": 59096,
                        "name": "Provaglio Val Sabbia",
                        "latitude": "45.68879000",
                        "longitude": "10.43397000"
                    },
                    {
                        "id": 59099,
                        "name": "Provezze",
                        "latitude": "45.63139000",
                        "longitude": "10.07287000"
                    },
                    {
                        "id": 59115,
                        "name": "Provincia di Bergamo",
                        "latitude": "45.83333000",
                        "longitude": "9.80000000"
                    },
                    {
                        "id": 59117,
                        "name": "Provincia di Brescia",
                        "latitude": "45.70648000",
                        "longitude": "10.33562000"
                    },
                    {
                        "id": 59125,
                        "name": "Provincia di Como",
                        "latitude": "45.91249000",
                        "longitude": "9.15744000"
                    },
                    {
                        "id": 59127,
                        "name": "Provincia di Cremona",
                        "latitude": "45.23333000",
                        "longitude": "9.93333000"
                    },
                    {
                        "id": 59142,
                        "name": "Provincia di Lecco",
                        "latitude": "45.85397000",
                        "longitude": "9.39001000"
                    },
                    {
                        "id": 59144,
                        "name": "Provincia di Lodi",
                        "latitude": "45.29638000",
                        "longitude": "9.52858000"
                    },
                    {
                        "id": 59147,
                        "name": "Provincia di Mantova",
                        "latitude": "45.16667000",
                        "longitude": "10.78333000"
                    },
                    {
                        "id": 59151,
                        "name": "Provincia di Monza e della Brianza",
                        "latitude": "45.59674000",
                        "longitude": "9.21616000"
                    },
                    {
                        "id": 59157,
                        "name": "Provincia di Pavia",
                        "latitude": "45.11667000",
                        "longitude": "9.13333000"
                    },
                    {
                        "id": 59177,
                        "name": "Provincia di Sondrio",
                        "latitude": "46.21108000",
                        "longitude": "9.94907000"
                    },
                    {
                        "id": 59184,
                        "name": "Provincia di Varese",
                        "latitude": "45.80000000",
                        "longitude": "8.80000000"
                    },
                    {
                        "id": 59194,
                        "name": "Puegnago sul Garda",
                        "latitude": "45.56679000",
                        "longitude": "10.50977000"
                    },
                    {
                        "id": 59195,
                        "name": "Puginate",
                        "latitude": "45.71095000",
                        "longitude": "9.05772000"
                    },
                    {
                        "id": 59204,
                        "name": "Pumenengo",
                        "latitude": "45.48002000",
                        "longitude": "9.86775000"
                    },
                    {
                        "id": 59207,
                        "name": "Pusiano",
                        "latitude": "45.81478000",
                        "longitude": "9.28217000"
                    },
                    {
                        "id": 59227,
                        "name": "Quartiano",
                        "latitude": "45.35800000",
                        "longitude": "9.41760000"
                    },
                    {
                        "id": 59238,
                        "name": "Quattro Strade",
                        "latitude": "45.69550000",
                        "longitude": "9.37681000"
                    },
                    {
                        "id": 59246,
                        "name": "Quingentole",
                        "latitude": "45.03801000",
                        "longitude": "11.04575000"
                    },
                    {
                        "id": 59247,
                        "name": "Quintano",
                        "latitude": "45.42047000",
                        "longitude": "9.61856000"
                    },
                    {
                        "id": 59251,
                        "name": "Quinzano d'Oglio",
                        "latitude": "45.31430000",
                        "longitude": "10.00785000"
                    },
                    {
                        "id": 59252,
                        "name": "Quistello",
                        "latitude": "45.00794000",
                        "longitude": "10.98377000"
                    },
                    {
                        "id": 59265,
                        "name": "Raffa",
                        "latitude": "45.57047000",
                        "longitude": "10.52962000"
                    },
                    {
                        "id": 59276,
                        "name": "Ramponio Verna",
                        "latitude": "45.99698000",
                        "longitude": "9.06633000"
                    },
                    {
                        "id": 59278,
                        "name": "Rancio Valcuvia",
                        "latitude": "45.91594000",
                        "longitude": "8.77157000"
                    },
                    {
                        "id": 59279,
                        "name": "Ranco",
                        "latitude": "45.79733000",
                        "longitude": "8.57105000"
                    },
                    {
                        "id": 59281,
                        "name": "Ranica",
                        "latitude": "45.72328000",
                        "longitude": "9.71335000"
                    },
                    {
                        "id": 59282,
                        "name": "Ranzanico",
                        "latitude": "45.78839000",
                        "longitude": "9.93506000"
                    },
                    {
                        "id": 59293,
                        "name": "Rasura",
                        "latitude": "46.10059000",
                        "longitude": "9.55274000"
                    },
                    {
                        "id": 59304,
                        "name": "Rea",
                        "latitude": "45.11336000",
                        "longitude": "9.15465000"
                    },
                    {
                        "id": 59314,
                        "name": "Redavalle",
                        "latitude": "45.03796000",
                        "longitude": "9.20225000"
                    },
                    {
                        "id": 59315,
                        "name": "Redondesco",
                        "latitude": "45.16638000",
                        "longitude": "10.51228000"
                    },
                    {
                        "id": 59323,
                        "name": "Regoledo",
                        "latitude": "46.13319000",
                        "longitude": "9.54597000"
                    },
                    {
                        "id": 59328,
                        "name": "Remedello",
                        "latitude": "45.27838000",
                        "longitude": "10.37198000"
                    },
                    {
                        "id": 59329,
                        "name": "Remedello di Sopra",
                        "latitude": "45.27873000",
                        "longitude": "10.37109000"
                    },
                    {
                        "id": 59330,
                        "name": "Renate",
                        "latitude": "45.72438000",
                        "longitude": "9.27994000"
                    },
                    {
                        "id": 59335,
                        "name": "Rescaldina",
                        "latitude": "45.62002000",
                        "longitude": "8.94878000"
                    },
                    {
                        "id": 59338,
                        "name": "Retorbido",
                        "latitude": "44.94980000",
                        "longitude": "9.03680000"
                    },
                    {
                        "id": 59341,
                        "name": "Revere",
                        "latitude": "45.05207000",
                        "longitude": "11.13059000"
                    },
                    {
                        "id": 59346,
                        "name": "Rezzago",
                        "latitude": "45.86673000",
                        "longitude": "9.24863000"
                    },
                    {
                        "id": 59347,
                        "name": "Rezzato",
                        "latitude": "45.51182000",
                        "longitude": "10.31731000"
                    },
                    {
                        "id": 59352,
                        "name": "Rho",
                        "latitude": "45.53245000",
                        "longitude": "9.04020000"
                    },
                    {
                        "id": 59369,
                        "name": "Ricengo",
                        "latitude": "45.40567000",
                        "longitude": "9.72396000"
                    },
                    {
                        "id": 59398,
                        "name": "Riozzo",
                        "latitude": "45.34622000",
                        "longitude": "9.32168000"
                    },
                    {
                        "id": 59404,
                        "name": "Ripalta Arpina",
                        "latitude": "45.30187000",
                        "longitude": "9.72896000"
                    },
                    {
                        "id": 59405,
                        "name": "Ripalta Guerina",
                        "latitude": "45.30607000",
                        "longitude": "9.70396000"
                    },
                    {
                        "id": 59406,
                        "name": "Ripalta Nuova",
                        "latitude": "45.33203000",
                        "longitude": "9.69244000"
                    },
                    {
                        "id": 59420,
                        "name": "Riva di Solto",
                        "latitude": "45.77418000",
                        "longitude": "10.03941000"
                    },
                    {
                        "id": 59426,
                        "name": "Rivanazzano",
                        "latitude": "44.92908000",
                        "longitude": "9.01368000"
                    },
                    {
                        "id": 59430,
                        "name": "Rivarolo del Re",
                        "latitude": "45.03116000",
                        "longitude": "10.47253000"
                    },
                    {
                        "id": 59429,
                        "name": "Rivarolo Mantovano",
                        "latitude": "45.07272000",
                        "longitude": "10.43713000"
                    },
                    {
                        "id": 59443,
                        "name": "Rivolta d'Adda",
                        "latitude": "45.46962000",
                        "longitude": "9.51251000"
                    },
                    {
                        "id": 59455,
                        "name": "Robbiate",
                        "latitude": "45.68829000",
                        "longitude": "9.43712000"
                    },
                    {
                        "id": 59456,
                        "name": "Robbio",
                        "latitude": "45.28901000",
                        "longitude": "8.59289000"
                    },
                    {
                        "id": 59457,
                        "name": "Robecchetto Con Induno",
                        "latitude": "45.52848000",
                        "longitude": "8.77068000"
                    },
                    {
                        "id": 59459,
                        "name": "Robecco d'Oglio",
                        "latitude": "45.25851000",
                        "longitude": "10.07718000"
                    },
                    {
                        "id": 59458,
                        "name": "Robecco Pavese",
                        "latitude": "45.04836000",
                        "longitude": "9.15015000"
                    },
                    {
                        "id": 59460,
                        "name": "Robecco sul Naviglio",
                        "latitude": "45.43662000",
                        "longitude": "8.88573000"
                    },
                    {
                        "id": 59501,
                        "name": "Roccafranca",
                        "latitude": "45.46405000",
                        "longitude": "9.91260000"
                    },
                    {
                        "id": 59551,
                        "name": "Rodengo-Saiano",
                        "latitude": "45.59958000",
                        "longitude": "10.10717000"
                    },
                    {
                        "id": 59552,
                        "name": "Rodero",
                        "latitude": "45.82398000",
                        "longitude": "8.91523000"
                    },
                    {
                        "id": 59554,
                        "name": "Rodigo",
                        "latitude": "45.19912000",
                        "longitude": "10.62527000"
                    },
                    {
                        "id": 59688,
                        "name": "Roè",
                        "latitude": "45.62576000",
                        "longitude": "10.49960000"
                    },
                    {
                        "id": 59689,
                        "name": "Roè Volciano",
                        "latitude": "45.61199000",
                        "longitude": "10.48857000"
                    },
                    {
                        "id": 59557,
                        "name": "Rogeno",
                        "latitude": "45.78238000",
                        "longitude": "9.27404000"
                    },
                    {
                        "id": 59559,
                        "name": "Roggione",
                        "latitude": "45.18378000",
                        "longitude": "9.80739000"
                    },
                    {
                        "id": 59562,
                        "name": "Rognano",
                        "latitude": "45.28847000",
                        "longitude": "9.09025000"
                    },
                    {
                        "id": 59563,
                        "name": "Rogno",
                        "latitude": "45.85659000",
                        "longitude": "10.13216000"
                    },
                    {
                        "id": 59564,
                        "name": "Rogolo",
                        "latitude": "46.13721000",
                        "longitude": "9.48528000"
                    },
                    {
                        "id": 59565,
                        "name": "Rogoredo-Valaperta-Rimoldo",
                        "latitude": "45.67695000",
                        "longitude": "9.33277000"
                    },
                    {
                        "id": 59572,
                        "name": "Romagnese",
                        "latitude": "44.84131000",
                        "longitude": "9.32810000"
                    },
                    {
                        "id": 59575,
                        "name": "Romanengo",
                        "latitude": "45.37815000",
                        "longitude": "9.78777000"
                    },
                    {
                        "id": 59576,
                        "name": "Romano Banco",
                        "latitude": "45.42309000",
                        "longitude": "9.10707000"
                    },
                    {
                        "id": 59579,
                        "name": "Romano di Lombardia",
                        "latitude": "45.52081000",
                        "longitude": "9.75440000"
                    },
                    {
                        "id": 59588,
                        "name": "Ronago",
                        "latitude": "45.83228000",
                        "longitude": "8.98364000"
                    },
                    {
                        "id": 59590,
                        "name": "Roncadelle",
                        "latitude": "45.52718000",
                        "longitude": "10.15407000"
                    },
                    {
                        "id": 59592,
                        "name": "Roncaro",
                        "latitude": "45.22817000",
                        "longitude": "9.27545000"
                    },
                    {
                        "id": 59594,
                        "name": "Roncello",
                        "latitude": "45.60238000",
                        "longitude": "9.45495000"
                    },
                    {
                        "id": 59600,
                        "name": "Ronco",
                        "latitude": "45.52668000",
                        "longitude": "9.35921000"
                    },
                    {
                        "id": 59603,
                        "name": "Ronco Briantino",
                        "latitude": "45.66628000",
                        "longitude": "9.40535000"
                    },
                    {
                        "id": 59606,
                        "name": "Roncobello",
                        "latitude": "45.95569000",
                        "longitude": "9.75235000"
                    },
                    {
                        "id": 59608,
                        "name": "Roncoferraro",
                        "latitude": "45.13812000",
                        "longitude": "10.94210000"
                    },
                    {
                        "id": 59611,
                        "name": "Roncola",
                        "latitude": "45.76868000",
                        "longitude": "9.56065000"
                    },
                    {
                        "id": 59626,
                        "name": "Rosasco",
                        "latitude": "45.25031000",
                        "longitude": "8.57930000"
                    },
                    {
                        "id": 59627,
                        "name": "Rosate",
                        "latitude": "45.34965000",
                        "longitude": "9.01659000"
                    },
                    {
                        "id": 59655,
                        "name": "Rota d'Imagna",
                        "latitude": "45.83088000",
                        "longitude": "9.51225000"
                    },
                    {
                        "id": 59662,
                        "name": "Rotta",
                        "latitude": "45.16242000",
                        "longitude": "9.14564000"
                    },
                    {
                        "id": 59667,
                        "name": "Rovagnate",
                        "latitude": "45.73692000",
                        "longitude": "9.37111000"
                    },
                    {
                        "id": 59669,
                        "name": "Rovato",
                        "latitude": "45.56342000",
                        "longitude": "10.00213000"
                    },
                    {
                        "id": 59672,
                        "name": "Rovellasca",
                        "latitude": "45.66664000",
                        "longitude": "9.04884000"
                    },
                    {
                        "id": 59673,
                        "name": "Rovello Porro",
                        "latitude": "45.65210000",
                        "longitude": "9.03940000"
                    },
                    {
                        "id": 59674,
                        "name": "Roverbella",
                        "latitude": "45.26659000",
                        "longitude": "10.77047000"
                    },
                    {
                        "id": 59682,
                        "name": "Rovescala",
                        "latitude": "45.00696000",
                        "longitude": "9.34586000"
                    },
                    {
                        "id": 59683,
                        "name": "Rovetta",
                        "latitude": "45.89178000",
                        "longitude": "9.98212000"
                    },
                    {
                        "id": 59687,
                        "name": "Rozzano",
                        "latitude": "45.38193000",
                        "longitude": "9.15590000"
                    },
                    {
                        "id": 59694,
                        "name": "Rudiano",
                        "latitude": "45.48952000",
                        "longitude": "9.88606000"
                    },
                    {
                        "id": 59701,
                        "name": "Ruino",
                        "latitude": "44.91145000",
                        "longitude": "9.27553000"
                    },
                    {
                        "id": 59713,
                        "name": "Sabbio Chiese",
                        "latitude": "45.65589000",
                        "longitude": "10.42193000"
                    },
                    {
                        "id": 59715,
                        "name": "Sabbioneta",
                        "latitude": "44.99787000",
                        "longitude": "10.48848000"
                    },
                    {
                        "id": 59716,
                        "name": "Sacca",
                        "latitude": "45.89953000",
                        "longitude": "10.22008000"
                    },
                    {
                        "id": 59736,
                        "name": "Sairano",
                        "latitude": "45.13672000",
                        "longitude": "9.05162000"
                    },
                    {
                        "id": 59745,
                        "name": "Sala al Barro",
                        "latitude": "45.82057000",
                        "longitude": "9.36220000"
                    },
                    {
                        "id": 59742,
                        "name": "Sala Comacina",
                        "latitude": "45.96418000",
                        "longitude": "9.16604000"
                    },
                    {
                        "id": 59755,
                        "name": "Sale Marasino",
                        "latitude": "45.70638000",
                        "longitude": "10.11216000"
                    },
                    {
                        "id": 59761,
                        "name": "Salerano sul Lambro",
                        "latitude": "45.29657000",
                        "longitude": "9.38515000"
                    },
                    {
                        "id": 59768,
                        "name": "Salice Terme",
                        "latitude": "44.91510000",
                        "longitude": "9.02630000"
                    },
                    {
                        "id": 59796,
                        "name": "Salò",
                        "latitude": "45.60685000",
                        "longitude": "10.52050000"
                    },
                    {
                        "id": 59782,
                        "name": "Saltrio",
                        "latitude": "45.87347000",
                        "longitude": "8.92436000"
                    },
                    {
                        "id": 59790,
                        "name": "Salvirola",
                        "latitude": "45.35630000",
                        "longitude": "9.77924000"
                    },
                    {
                        "id": 59798,
                        "name": "Samarate",
                        "latitude": "45.62410000",
                        "longitude": "8.78507000"
                    },
                    {
                        "id": 59812,
                        "name": "Samolaco",
                        "latitude": "46.24249000",
                        "longitude": "9.39404000"
                    },
                    {
                        "id": 59820,
                        "name": "San Bartolomeo Val Cavargna",
                        "latitude": "46.08349000",
                        "longitude": "9.14913000"
                    },
                    {
                        "id": 59825,
                        "name": "San Bassano",
                        "latitude": "45.24378000",
                        "longitude": "9.80954000"
                    },
                    {
                        "id": 59828,
                        "name": "San Benedetto Po",
                        "latitude": "45.04612000",
                        "longitude": "10.93367000"
                    },
                    {
                        "id": 59838,
                        "name": "San Biagio",
                        "latitude": "45.09942000",
                        "longitude": "10.84728000"
                    },
                    {
                        "id": 59847,
                        "name": "San Bovio-San Felice",
                        "latitude": "45.46282000",
                        "longitude": "9.31263000"
                    },
                    {
                        "id": 59860,
                        "name": "San Cassiano",
                        "latitude": "46.27697000",
                        "longitude": "9.39743000"
                    },
                    {
                        "id": 59870,
                        "name": "San Cipriano Po",
                        "latitude": "45.10909000",
                        "longitude": "9.28089000"
                    },
                    {
                        "id": 59877,
                        "name": "San Colombano al Lambro",
                        "latitude": "45.18322000",
                        "longitude": "9.49028000"
                    },
                    {
                        "id": 59886,
                        "name": "San Damiano al Colle",
                        "latitude": "45.02713000",
                        "longitude": "9.34860000"
                    },
                    {
                        "id": 59888,
                        "name": "San Daniele Po",
                        "latitude": "45.06727000",
                        "longitude": "10.17637000"
                    },
                    {
                        "id": 59896,
                        "name": "San Donato Milanese",
                        "latitude": "45.41047000",
                        "longitude": "9.26838000"
                    },
                    {
                        "id": 59902,
                        "name": "San Fedele Intelvi",
                        "latitude": "45.96768000",
                        "longitude": "9.08074000"
                    },
                    {
                        "id": 59903,
                        "name": "San Fedele Superiore",
                        "latitude": "45.96667000",
                        "longitude": "9.06667000"
                    },
                    {
                        "id": 59906,
                        "name": "San Felice",
                        "latitude": "45.14301000",
                        "longitude": "10.07373000"
                    },
                    {
                        "id": 59910,
                        "name": "San Felice del Benaco",
                        "latitude": "45.58276000",
                        "longitude": "10.55380000"
                    },
                    {
                        "id": 59916,
                        "name": "San Fermo della Battaglia",
                        "latitude": "45.80868000",
                        "longitude": "9.04744000"
                    },
                    {
                        "id": 59921,
                        "name": "San Fiorano",
                        "latitude": "45.13815000",
                        "longitude": "9.72063000"
                    },
                    {
                        "id": 59934,
                        "name": "San Genesio ed Uniti",
                        "latitude": "45.23414000",
                        "longitude": "9.17997000"
                    },
                    {
                        "id": 59939,
                        "name": "San Gervasio Bresciano",
                        "latitude": "45.30774000",
                        "longitude": "10.14652000"
                    },
                    {
                        "id": 59942,
                        "name": "San Giacomo",
                        "latitude": "45.59379000",
                        "longitude": "10.47689000"
                    },
                    {
                        "id": 59947,
                        "name": "San Giacomo delle Segnate",
                        "latitude": "44.97418000",
                        "longitude": "11.03434000"
                    },
                    {
                        "id": 59944,
                        "name": "San Giacomo Filippo",
                        "latitude": "46.33769000",
                        "longitude": "9.37124000"
                    },
                    {
                        "id": 59970,
                        "name": "San Giorgio di Lomellina",
                        "latitude": "45.17486000",
                        "longitude": "8.79014000"
                    },
                    {
                        "id": 59962,
                        "name": "San Giorgio Su Legnano",
                        "latitude": "45.57377000",
                        "longitude": "8.91374000"
                    },
                    {
                        "id": 59982,
                        "name": "San Giovanni Bianco",
                        "latitude": "45.87342000",
                        "longitude": "9.65420000"
                    },
                    {
                        "id": 59994,
                        "name": "San Giovanni del Dosso",
                        "latitude": "44.96627000",
                        "longitude": "11.08114000"
                    },
                    {
                        "id": 59996,
                        "name": "San Giovanni in Croce",
                        "latitude": "45.07396000",
                        "longitude": "10.37315000"
                    },
                    {
                        "id": 60004,
                        "name": "San Giuliano Milanese",
                        "latitude": "45.39402000",
                        "longitude": "9.29109000"
                    },
                    {
                        "id": 60046,
                        "name": "San Lorenzo di Rovetta",
                        "latitude": "45.87971000",
                        "longitude": "9.97537000"
                    },
                    {
                        "id": 60053,
                        "name": "San Mamete",
                        "latitude": "46.02505000",
                        "longitude": "9.05364000"
                    },
                    {
                        "id": 60075,
                        "name": "San Martino Dall'Argine",
                        "latitude": "45.09715000",
                        "longitude": "10.51766000"
                    },
                    {
                        "id": 60083,
                        "name": "San Martino del Lago",
                        "latitude": "45.07243000",
                        "longitude": "10.31568000"
                    },
                    {
                        "id": 60084,
                        "name": "San Martino della Battaglia",
                        "latitude": "45.43832000",
                        "longitude": "10.60053000"
                    },
                    {
                        "id": 60095,
                        "name": "San Martino in Strada",
                        "latitude": "45.27497000",
                        "longitude": "9.52636000"
                    },
                    {
                        "id": 60077,
                        "name": "San Martino Siccomario",
                        "latitude": "45.16340000",
                        "longitude": "9.14062000"
                    },
                    {
                        "id": 60126,
                        "name": "San Michele-San Giorgio",
                        "latitude": "45.69594000",
                        "longitude": "9.05856000"
                    },
                    {
                        "id": 60132,
                        "name": "San Nazzaro Val Cavargna",
                        "latitude": "46.08939000",
                        "longitude": "9.12743000"
                    },
                    {
                        "id": 60145,
                        "name": "San Nicolò",
                        "latitude": "46.46299000",
                        "longitude": "10.40998000"
                    },
                    {
                        "id": 60154,
                        "name": "San Paolo",
                        "latitude": "45.37249000",
                        "longitude": "10.02397000"
                    },
                    {
                        "id": 60160,
                        "name": "San Paolo d'Argon",
                        "latitude": "45.68838000",
                        "longitude": "9.80226000"
                    },
                    {
                        "id": 60163,
                        "name": "San Pellegrino Terme",
                        "latitude": "45.83443000",
                        "longitude": "9.66753000"
                    },
                    {
                        "id": 60225,
                        "name": "San Rocco",
                        "latitude": "45.00945000",
                        "longitude": "9.16191000"
                    },
                    {
                        "id": 60226,
                        "name": "San Rocco al Porto",
                        "latitude": "45.08197000",
                        "longitude": "9.69717000"
                    },
                    {
                        "id": 60235,
                        "name": "San Sebastiano",
                        "latitude": "45.65192000",
                        "longitude": "10.25681000"
                    },
                    {
                        "id": 60245,
                        "name": "San Siro",
                        "latitude": "46.06573000",
                        "longitude": "9.26877000"
                    },
                    {
                        "id": 60265,
                        "name": "San Vigilio",
                        "latitude": "45.60808000",
                        "longitude": "10.19442000"
                    },
                    {
                        "id": 60286,
                        "name": "San Vittore",
                        "latitude": "46.30799000",
                        "longitude": "9.38310000"
                    },
                    {
                        "id": 60287,
                        "name": "San Vittore Olona",
                        "latitude": "45.58577000",
                        "longitude": "8.94134000"
                    },
                    {
                        "id": 60291,
                        "name": "San Zeno Naviglio",
                        "latitude": "45.49258000",
                        "longitude": "10.21847000"
                    },
                    {
                        "id": 60294,
                        "name": "San Zenone",
                        "latitude": "45.64169000",
                        "longitude": "10.14685000"
                    },
                    {
                        "id": 60295,
                        "name": "San Zenone al Lambro",
                        "latitude": "45.32681000",
                        "longitude": "9.35598000"
                    },
                    {
                        "id": 60296,
                        "name": "San Zenone al Po",
                        "latitude": "45.10856000",
                        "longitude": "9.36176000"
                    },
                    {
                        "id": 60305,
                        "name": "Sangiano",
                        "latitude": "45.87508000",
                        "longitude": "8.63333000"
                    },
                    {
                        "id": 60309,
                        "name": "Sannazzaro de' Burgondi",
                        "latitude": "45.10226000",
                        "longitude": "8.90635000"
                    },
                    {
                        "id": 60319,
                        "name": "Sant'Agata Martesana",
                        "latitude": "45.52220000",
                        "longitude": "9.38382000"
                    },
                    {
                        "id": 60333,
                        "name": "Sant'Alessio Con Vialone",
                        "latitude": "45.22237000",
                        "longitude": "9.22605000"
                    },
                    {
                        "id": 60358,
                        "name": "Sant'Angelo Lodigiano",
                        "latitude": "45.23526000",
                        "longitude": "9.40651000"
                    },
                    {
                        "id": 60359,
                        "name": "Sant'Angelo Lomellina",
                        "latitude": "45.24663000",
                        "longitude": "8.64317000"
                    },
                    {
                        "id": 60379,
                        "name": "Sant'Antonio",
                        "latitude": "46.46110000",
                        "longitude": "10.41738000"
                    },
                    {
                        "id": 60408,
                        "name": "Sant'Omobono Terme",
                        "latitude": "45.80838000",
                        "longitude": "9.53625000"
                    },
                    {
                        "id": 60413,
                        "name": "Santa Brigida",
                        "latitude": "45.98489000",
                        "longitude": "9.62115000"
                    },
                    {
                        "id": 60419,
                        "name": "Santa Corinna",
                        "latitude": "45.34018000",
                        "longitude": "9.08878000"
                    },
                    {
                        "id": 60421,
                        "name": "Santa Cristina",
                        "latitude": "45.15756000",
                        "longitude": "9.39976000"
                    },
                    {
                        "id": 60438,
                        "name": "Santa Giuletta",
                        "latitude": "45.03397000",
                        "longitude": "9.18126000"
                    },
                    {
                        "id": 60450,
                        "name": "Santa Margherita",
                        "latitude": "45.63391000",
                        "longitude": "9.23013000"
                    },
                    {
                        "id": 60454,
                        "name": "Santa Margherita di Staffora",
                        "latitude": "44.77154000",
                        "longitude": "9.24006000"
                    },
                    {
                        "id": 60472,
                        "name": "Santa Maria dei Sabbioni",
                        "latitude": "45.24386000",
                        "longitude": "9.83927000"
                    },
                    {
                        "id": 60475,
                        "name": "Santa Maria della Versa",
                        "latitude": "44.98757000",
                        "longitude": "9.29976000"
                    },
                    {
                        "id": 60462,
                        "name": "Santa Maria Hoè",
                        "latitude": "45.74428000",
                        "longitude": "9.37445000"
                    },
                    {
                        "id": 60513,
                        "name": "Santo Stefano Lodigiano",
                        "latitude": "45.11857000",
                        "longitude": "9.73527000"
                    },
                    {
                        "id": 60516,
                        "name": "Santo Stefano Ticino",
                        "latitude": "45.48635000",
                        "longitude": "8.91582000"
                    },
                    {
                        "id": 60548,
                        "name": "Sarezzo",
                        "latitude": "45.66067000",
                        "longitude": "10.19690000"
                    },
                    {
                        "id": 60553,
                        "name": "Sarnico",
                        "latitude": "45.67099000",
                        "longitude": "9.96152000"
                    },
                    {
                        "id": 60556,
                        "name": "Saronno",
                        "latitude": "45.62513000",
                        "longitude": "9.03517000"
                    },
                    {
                        "id": 60561,
                        "name": "Sartirana Lomellina",
                        "latitude": "45.11352000",
                        "longitude": "8.66711000"
                    },
                    {
                        "id": 60594,
                        "name": "Saviore",
                        "latitude": "46.08049000",
                        "longitude": "10.39823000"
                    },
                    {
                        "id": 60606,
                        "name": "Scaldasole",
                        "latitude": "45.12495000",
                        "longitude": "8.91029000"
                    },
                    {
                        "id": 60618,
                        "name": "Scandolara Ravara",
                        "latitude": "45.05309000",
                        "longitude": "10.30215000"
                    },
                    {
                        "id": 60619,
                        "name": "Scandolara Ripa d'Oglio",
                        "latitude": "45.22171000",
                        "longitude": "10.15717000"
                    },
                    {
                        "id": 60621,
                        "name": "Scannabue-Cascine Capri",
                        "latitude": "45.39306000",
                        "longitude": "9.59302000"
                    },
                    {
                        "id": 60623,
                        "name": "Scano al Brembo",
                        "latitude": "45.71858000",
                        "longitude": "9.60905000"
                    },
                    {
                        "id": 60627,
                        "name": "Scanzorosciate",
                        "latitude": "45.71078000",
                        "longitude": "9.73505000"
                    },
                    {
                        "id": 60645,
                        "name": "Schignano",
                        "latitude": "45.92978000",
                        "longitude": "9.10214000"
                    },
                    {
                        "id": 60646,
                        "name": "Schilpario",
                        "latitude": "46.00874000",
                        "longitude": "10.15534000"
                    },
                    {
                        "id": 60648,
                        "name": "Schivenoglia",
                        "latitude": "44.99498000",
                        "longitude": "11.07300000"
                    },
                    {
                        "id": 60679,
                        "name": "Secugnago",
                        "latitude": "45.23132000",
                        "longitude": "9.59394000"
                    },
                    {
                        "id": 60684,
                        "name": "Sedriano",
                        "latitude": "45.49105000",
                        "longitude": "8.97161000"
                    },
                    {
                        "id": 60685,
                        "name": "Sedrina",
                        "latitude": "45.78067000",
                        "longitude": "9.62362000"
                    },
                    {
                        "id": 60691,
                        "name": "Segrate",
                        "latitude": "45.49185000",
                        "longitude": "9.29812000"
                    },
                    {
                        "id": 60698,
                        "name": "Selino Basso",
                        "latitude": "45.81029000",
                        "longitude": "9.53495000"
                    },
                    {
                        "id": 60700,
                        "name": "Sellero",
                        "latitude": "46.05145000",
                        "longitude": "10.34764000"
                    },
                    {
                        "id": 60712,
                        "name": "Selvino",
                        "latitude": "45.78525000",
                        "longitude": "9.75292000"
                    },
                    {
                        "id": 60714,
                        "name": "Semiana",
                        "latitude": "45.13737000",
                        "longitude": "8.72973000"
                    },
                    {
                        "id": 60718,
                        "name": "Senago",
                        "latitude": "45.57562000",
                        "longitude": "9.12620000"
                    },
                    {
                        "id": 60723,
                        "name": "Seniga",
                        "latitude": "45.24479000",
                        "longitude": "10.17759000"
                    },
                    {
                        "id": 60727,
                        "name": "Senna Comasco",
                        "latitude": "45.76298000",
                        "longitude": "9.11104000"
                    },
                    {
                        "id": 60728,
                        "name": "Senna Lodigiana",
                        "latitude": "45.15023000",
                        "longitude": "9.59379000"
                    },
                    {
                        "id": 60737,
                        "name": "Seregno",
                        "latitude": "45.65002000",
                        "longitude": "9.20548000"
                    },
                    {
                        "id": 60739,
                        "name": "Sergnano",
                        "latitude": "45.42755000",
                        "longitude": "9.70122000"
                    },
                    {
                        "id": 60740,
                        "name": "Seriate",
                        "latitude": "45.68532000",
                        "longitude": "9.72487000"
                    },
                    {
                        "id": 60741,
                        "name": "Serina",
                        "latitude": "45.87071000",
                        "longitude": "9.73102000"
                    },
                    {
                        "id": 60743,
                        "name": "Serle",
                        "latitude": "45.56137000",
                        "longitude": "10.36821000"
                    },
                    {
                        "id": 60744,
                        "name": "Sermide",
                        "latitude": "45.00349000",
                        "longitude": "11.29290000"
                    },
                    {
                        "id": 60747,
                        "name": "Sernio",
                        "latitude": "46.22420000",
                        "longitude": "10.20526000"
                    },
                    {
                        "id": 60749,
                        "name": "Serone",
                        "latitude": "46.15627000",
                        "longitude": "9.58171000"
                    },
                    {
                        "id": 60776,
                        "name": "Serravalle a Po",
                        "latitude": "45.06638000",
                        "longitude": "11.08180000"
                    },
                    {
                        "id": 60795,
                        "name": "Sesto Calende",
                        "latitude": "45.72608000",
                        "longitude": "8.63397000"
                    },
                    {
                        "id": 60801,
                        "name": "Sesto ed Uniti",
                        "latitude": "45.17647000",
                        "longitude": "9.91407000"
                    },
                    {
                        "id": 60799,
                        "name": "Sesto San Giovanni",
                        "latitude": "45.53329000",
                        "longitude": "9.22585000"
                    },
                    {
                        "id": 60806,
                        "name": "Settala",
                        "latitude": "45.45357000",
                        "longitude": "9.38715000"
                    },
                    {
                        "id": 60812,
                        "name": "Settimo Milanese",
                        "latitude": "45.47771000",
                        "longitude": "9.05574000"
                    },
                    {
                        "id": 60822,
                        "name": "Seveso",
                        "latitude": "45.64670000",
                        "longitude": "9.14296000"
                    },
                    {
                        "id": 60855,
                        "name": "Silvano Pietra",
                        "latitude": "45.03923000",
                        "longitude": "8.94637000"
                    },
                    {
                        "id": 60874,
                        "name": "Sirmione",
                        "latitude": "45.49744000",
                        "longitude": "10.60507000"
                    },
                    {
                        "id": 60876,
                        "name": "Sirone",
                        "latitude": "45.77268000",
                        "longitude": "9.32214000"
                    },
                    {
                        "id": 60878,
                        "name": "Sirta",
                        "latitude": "46.15823000",
                        "longitude": "9.66109000"
                    },
                    {
                        "id": 60879,
                        "name": "Sirtori",
                        "latitude": "45.73658000",
                        "longitude": "9.33085000"
                    },
                    {
                        "id": 60884,
                        "name": "Siviano",
                        "latitude": "45.71487000",
                        "longitude": "10.08026000"
                    },
                    {
                        "id": 60885,
                        "name": "Siziano",
                        "latitude": "45.31606000",
                        "longitude": "9.20357000"
                    },
                    {
                        "id": 60891,
                        "name": "Soave",
                        "latitude": "45.19509000",
                        "longitude": "10.72365000"
                    },
                    {
                        "id": 60899,
                        "name": "Soiano",
                        "latitude": "45.52778000",
                        "longitude": "10.51267000"
                    },
                    {
                        "id": 60904,
                        "name": "Solaro",
                        "latitude": "44.87990000",
                        "longitude": "9.17315000"
                    },
                    {
                        "id": 60906,
                        "name": "Solarolo",
                        "latitude": "45.55047000",
                        "longitude": "10.55489000"
                    },
                    {
                        "id": 60907,
                        "name": "Solarolo Rainerio",
                        "latitude": "45.08126000",
                        "longitude": "10.35711000"
                    },
                    {
                        "id": 60909,
                        "name": "Solbiate",
                        "latitude": "45.78968000",
                        "longitude": "8.93314000"
                    },
                    {
                        "id": 60910,
                        "name": "Solbiate Arno",
                        "latitude": "45.71960000",
                        "longitude": "8.81372000"
                    },
                    {
                        "id": 60911,
                        "name": "Solbiate Olona",
                        "latitude": "45.65028000",
                        "longitude": "8.88198000"
                    },
                    {
                        "id": 60917,
                        "name": "Solferino",
                        "latitude": "45.37236000",
                        "longitude": "10.56648000"
                    },
                    {
                        "id": 60924,
                        "name": "Solto Collina",
                        "latitude": "45.78230000",
                        "longitude": "10.02638000"
                    },
                    {
                        "id": 60925,
                        "name": "Solza",
                        "latitude": "45.67868000",
                        "longitude": "9.49075000"
                    },
                    {
                        "id": 60926,
                        "name": "Somaglia",
                        "latitude": "45.14947000",
                        "longitude": "9.63346000"
                    },
                    {
                        "id": 60928,
                        "name": "Somma Lombardo",
                        "latitude": "45.68213000",
                        "longitude": "8.70759000"
                    },
                    {
                        "id": 60934,
                        "name": "Sommo",
                        "latitude": "45.13316000",
                        "longitude": "9.08655000"
                    },
                    {
                        "id": 60936,
                        "name": "Soncino",
                        "latitude": "45.40033000",
                        "longitude": "9.86845000"
                    },
                    {
                        "id": 60937,
                        "name": "Sondalo",
                        "latitude": "46.32983000",
                        "longitude": "10.32690000"
                    },
                    {
                        "id": 60938,
                        "name": "Sondrio",
                        "latitude": "46.16852000",
                        "longitude": "9.87134000"
                    },
                    {
                        "id": 60939,
                        "name": "Songavazzo",
                        "latitude": "45.87949000",
                        "longitude": "9.98956000"
                    },
                    {
                        "id": 60940,
                        "name": "Sonico",
                        "latitude": "46.16640000",
                        "longitude": "10.35071000"
                    },
                    {
                        "id": 60953,
                        "name": "Sordio",
                        "latitude": "45.34217000",
                        "longitude": "9.36385000"
                    },
                    {
                        "id": 60954,
                        "name": "Soresina",
                        "latitude": "45.28819000",
                        "longitude": "9.85862000"
                    },
                    {
                        "id": 60961,
                        "name": "Sorico",
                        "latitude": "46.17259000",
                        "longitude": "9.38404000"
                    },
                    {
                        "id": 60963,
                        "name": "Sorisole",
                        "latitude": "45.73140000",
                        "longitude": "9.63715000"
                    },
                    {
                        "id": 60964,
                        "name": "Sormano",
                        "latitude": "45.87803000",
                        "longitude": "9.24582000"
                    },
                    {
                        "id": 60969,
                        "name": "Sospiro",
                        "latitude": "45.10762000",
                        "longitude": "10.15853000"
                    },
                    {
                        "id": 60973,
                        "name": "Sotto il Monte Giovanni XXIII",
                        "latitude": "45.70568000",
                        "longitude": "9.50345000"
                    },
                    {
                        "id": 60974,
                        "name": "Sottocastello",
                        "latitude": "45.66720000",
                        "longitude": "10.39416000"
                    },
                    {
                        "id": 60979,
                        "name": "Sovere",
                        "latitude": "45.81188000",
                        "longitude": "10.03438000"
                    },
                    {
                        "id": 60984,
                        "name": "Sovico",
                        "latitude": "45.64598000",
                        "longitude": "9.26275000"
                    },
                    {
                        "id": 61000,
                        "name": "Spessa",
                        "latitude": "45.11356000",
                        "longitude": "9.34856000"
                    },
                    {
                        "id": 61013,
                        "name": "Spinadesco",
                        "latitude": "45.14917000",
                        "longitude": "9.92637000"
                    },
                    {
                        "id": 61016,
                        "name": "Spineda",
                        "latitude": "45.06140000",
                        "longitude": "10.51165000"
                    },
                    {
                        "id": 61022,
                        "name": "Spino d'Adda",
                        "latitude": "45.40086000",
                        "longitude": "9.48674000"
                    },
                    {
                        "id": 61023,
                        "name": "Spinone al Lago",
                        "latitude": "45.76476000",
                        "longitude": "9.92157000"
                    },
                    {
                        "id": 61025,
                        "name": "Spirano",
                        "latitude": "45.58144000",
                        "longitude": "9.66863000"
                    },
                    {
                        "id": 61033,
                        "name": "Spriana",
                        "latitude": "46.22030000",
                        "longitude": "9.86425000"
                    },
                    {
                        "id": 61041,
                        "name": "Stagno Lombardo",
                        "latitude": "45.07459000",
                        "longitude": "10.08890000"
                    },
                    {
                        "id": 61059,
                        "name": "Stazzona",
                        "latitude": "46.13879000",
                        "longitude": "9.27524000"
                    },
                    {
                        "id": 61068,
                        "name": "Stezzano",
                        "latitude": "45.64968000",
                        "longitude": "9.65192000"
                    },
                    {
                        "id": 61086,
                        "name": "Stradella",
                        "latitude": "45.07445000",
                        "longitude": "9.30169000"
                    },
                    {
                        "id": 61090,
                        "name": "Stravignino",
                        "latitude": "45.77469000",
                        "longitude": "10.23838000"
                    },
                    {
                        "id": 61102,
                        "name": "Strozza",
                        "latitude": "45.77294000",
                        "longitude": "9.57886000"
                    },
                    {
                        "id": 61107,
                        "name": "Suardi",
                        "latitude": "45.03247000",
                        "longitude": "8.74127000"
                    },
                    {
                        "id": 61111,
                        "name": "Sueglio",
                        "latitude": "46.08579000",
                        "longitude": "9.33374000"
                    },
                    {
                        "id": 61113,
                        "name": "Suello",
                        "latitude": "45.81678000",
                        "longitude": "9.31154000"
                    },
                    {
                        "id": 61114,
                        "name": "Suisio",
                        "latitude": "45.65708000",
                        "longitude": "9.50225000"
                    },
                    {
                        "id": 61115,
                        "name": "Sulbiate",
                        "latitude": "45.64047000",
                        "longitude": "9.42762000"
                    },
                    {
                        "id": 61117,
                        "name": "Sulzano",
                        "latitude": "45.68732000",
                        "longitude": "10.09988000"
                    },
                    {
                        "id": 61118,
                        "name": "Sumirago",
                        "latitude": "45.73651000",
                        "longitude": "8.78356000"
                    },
                    {
                        "id": 61130,
                        "name": "Susella",
                        "latitude": "44.91267000",
                        "longitude": "9.09651000"
                    },
                    {
                        "id": 61131,
                        "name": "Sustinente",
                        "latitude": "45.07096000",
                        "longitude": "11.02178000"
                    },
                    {
                        "id": 61136,
                        "name": "Suzzara",
                        "latitude": "44.99242000",
                        "longitude": "10.74407000"
                    },
                    {
                        "id": 61137,
                        "name": "Tabiago-Cibrone",
                        "latitude": "45.75639000",
                        "longitude": "9.26684000"
                    },
                    {
                        "id": 61138,
                        "name": "Taceno",
                        "latitude": "46.02253000",
                        "longitude": "9.36400000"
                    },
                    {
                        "id": 61148,
                        "name": "Taino",
                        "latitude": "45.76249000",
                        "longitude": "8.61654000"
                    },
                    {
                        "id": 61152,
                        "name": "Talamona",
                        "latitude": "46.13849000",
                        "longitude": "9.61294000"
                    },
                    {
                        "id": 61154,
                        "name": "Taleggio",
                        "latitude": "45.89339000",
                        "longitude": "9.56485000"
                    },
                    {
                        "id": 61169,
                        "name": "Tartano",
                        "latitude": "46.10554000",
                        "longitude": "9.67864000"
                    },
                    {
                        "id": 61182,
                        "name": "Tavazzano",
                        "latitude": "45.32783000",
                        "longitude": "9.40473000"
                    },
                    {
                        "id": 61190,
                        "name": "Tavernerio",
                        "latitude": "45.80068000",
                        "longitude": "9.14054000"
                    },
                    {
                        "id": 61191,
                        "name": "Tavernola Bergamasca",
                        "latitude": "45.70846000",
                        "longitude": "10.04454000"
                    },
                    {
                        "id": 61192,
                        "name": "Tavernole",
                        "latitude": "45.74618000",
                        "longitude": "10.23952000"
                    },
                    {
                        "id": 61202,
                        "name": "Teglio",
                        "latitude": "46.17235000",
                        "longitude": "10.06399000"
                    },
                    {
                        "id": 61206,
                        "name": "Telgate",
                        "latitude": "45.62792000",
                        "longitude": "9.84912000"
                    },
                    {
                        "id": 61211,
                        "name": "Temù",
                        "latitude": "46.25022000",
                        "longitude": "10.46592000"
                    },
                    {
                        "id": 61230,
                        "name": "Ternate",
                        "latitude": "45.78673000",
                        "longitude": "8.69931000"
                    },
                    {
                        "id": 61233,
                        "name": "Terno d'Isola",
                        "latitude": "45.68548000",
                        "longitude": "9.53095000"
                    },
                    {
                        "id": 61241,
                        "name": "Terranova dei Passerini",
                        "latitude": "45.21527000",
                        "longitude": "9.66186000"
                    },
                    {
                        "id": 61248,
                        "name": "Terraverde-Corte Palasio",
                        "latitude": "45.31552000",
                        "longitude": "9.56162000"
                    },
                    {
                        "id": 61274,
                        "name": "Ticengo",
                        "latitude": "45.36927000",
                        "longitude": "9.82766000"
                    },
                    {
                        "id": 61282,
                        "name": "Tirano",
                        "latitude": "46.21482000",
                        "longitude": "10.16335000"
                    },
                    {
                        "id": 61318,
                        "name": "Torbole Casaglia",
                        "latitude": "45.51279000",
                        "longitude": "10.11700000"
                    },
                    {
                        "id": 61323,
                        "name": "Torchione-Moia",
                        "latitude": "46.15486000",
                        "longitude": "9.85996000"
                    },
                    {
                        "id": 61332,
                        "name": "Torlino Vimercati",
                        "latitude": "45.41747000",
                        "longitude": "9.59476000"
                    },
                    {
                        "id": 61335,
                        "name": "Tornata",
                        "latitude": "45.10437000",
                        "longitude": "10.43078000"
                    },
                    {
                        "id": 61337,
                        "name": "Torno",
                        "latitude": "45.85593000",
                        "longitude": "9.11707000"
                    },
                    {
                        "id": 61343,
                        "name": "Torrazza Coste",
                        "latitude": "44.97820000",
                        "longitude": "9.07613000"
                    },
                    {
                        "id": 61345,
                        "name": "Torrazza dei Mandelli",
                        "latitude": "45.56629000",
                        "longitude": "9.39921000"
                    },
                    {
                        "id": 61348,
                        "name": "Torre Beretti",
                        "latitude": "45.05996000",
                        "longitude": "8.67094000"
                    },
                    {
                        "id": 61349,
                        "name": "Torre Boldone",
                        "latitude": "45.71725000",
                        "longitude": "9.70792000"
                    },
                    {
                        "id": 61364,
                        "name": "Torre d'Arese",
                        "latitude": "45.24277000",
                        "longitude": "9.31735000"
                    },
                    {
                        "id": 61365,
                        "name": "Torre d'Isola",
                        "latitude": "45.21796000",
                        "longitude": "9.07651000"
                    },
                    {
                        "id": 61366,
                        "name": "Torre de' Busi",
                        "latitude": "45.77408000",
                        "longitude": "9.48025000"
                    },
                    {
                        "id": 61367,
                        "name": "Torre de' Negri",
                        "latitude": "45.14966000",
                        "longitude": "9.33456000"
                    },
                    {
                        "id": 61369,
                        "name": "Torre de' Picenardi",
                        "latitude": "45.14317000",
                        "longitude": "10.28803000"
                    },
                    {
                        "id": 61370,
                        "name": "Torre de' Roveri",
                        "latitude": "45.69718000",
                        "longitude": "9.76326000"
                    },
                    {
                        "id": 61373,
                        "name": "Torre del Mangano",
                        "latitude": "45.25208000",
                        "longitude": "9.13042000"
                    },
                    {
                        "id": 61376,
                        "name": "Torre di Santa Maria",
                        "latitude": "46.23356000",
                        "longitude": "9.85228000"
                    },
                    {
                        "id": 61358,
                        "name": "Torre Pallavicina",
                        "latitude": "45.44638000",
                        "longitude": "9.87706000"
                    },
                    {
                        "id": 61393,
                        "name": "Torrevecchia Pia",
                        "latitude": "45.28197000",
                        "longitude": "9.29635000"
                    },
                    {
                        "id": 61403,
                        "name": "Torricella del Pizzo",
                        "latitude": "45.02023000",
                        "longitude": "10.29497000"
                    },
                    {
                        "id": 61402,
                        "name": "Torricella Verzate",
                        "latitude": "45.01996000",
                        "longitude": "9.17356000"
                    },
                    {
                        "id": 61423,
                        "name": "Toscolano Maderno",
                        "latitude": "45.63977000",
                        "longitude": "10.60760000"
                    },
                    {
                        "id": 61426,
                        "name": "Tovo di Sant'Agata",
                        "latitude": "46.24505000",
                        "longitude": "10.24670000"
                    },
                    {
                        "id": 61428,
                        "name": "Tradate",
                        "latitude": "45.70843000",
                        "longitude": "8.90763000"
                    },
                    {
                        "id": 61439,
                        "name": "Traona",
                        "latitude": "46.14737000",
                        "longitude": "9.53256000"
                    },
                    {
                        "id": 61449,
                        "name": "Travacò Siccomario",
                        "latitude": "45.14906000",
                        "longitude": "9.15965000"
                    },
                    {
                        "id": 61450,
                        "name": "Travagliato",
                        "latitude": "45.52391000",
                        "longitude": "10.08013000"
                    },
                    {
                        "id": 61451,
                        "name": "Travedona Monate",
                        "latitude": "45.80427000",
                        "longitude": "8.67143000"
                    },
                    {
                        "id": 61460,
                        "name": "Trebbio",
                        "latitude": "45.71289000",
                        "longitude": "10.46137000"
                    },
                    {
                        "id": 61468,
                        "name": "Trecella",
                        "latitude": "45.51498000",
                        "longitude": "9.47905000"
                    },
                    {
                        "id": 61471,
                        "name": "Tregasio",
                        "latitude": "45.67771000",
                        "longitude": "9.28806000"
                    },
                    {
                        "id": 61477,
                        "name": "Tremenico",
                        "latitude": "46.07592000",
                        "longitude": "9.36602000"
                    },
                    {
                        "id": 61479,
                        "name": "Tremezzo",
                        "latitude": "45.98423000",
                        "longitude": "9.21613000"
                    },
                    {
                        "id": 61485,
                        "name": "Trenzano",
                        "latitude": "45.47728000",
                        "longitude": "10.01066000"
                    },
                    {
                        "id": 61494,
                        "name": "Trescore Balneario",
                        "latitude": "45.69409000",
                        "longitude": "9.84173000"
                    },
                    {
                        "id": 61495,
                        "name": "Trescore Cremasco",
                        "latitude": "45.40298000",
                        "longitude": "9.62278000"
                    },
                    {
                        "id": 61497,
                        "name": "Tresivio",
                        "latitude": "46.17569000",
                        "longitude": "9.94255000"
                    },
                    {
                        "id": 61504,
                        "name": "Treviglio",
                        "latitude": "45.52081000",
                        "longitude": "9.59102000"
                    },
                    {
                        "id": 61508,
                        "name": "Treviolo",
                        "latitude": "45.67368000",
                        "longitude": "9.61195000"
                    },
                    {
                        "id": 61510,
                        "name": "Trezzano Rosa",
                        "latitude": "45.58228000",
                        "longitude": "9.48567000"
                    },
                    {
                        "id": 61511,
                        "name": "Trezzano sul Naviglio",
                        "latitude": "45.42212000",
                        "longitude": "9.06342000"
                    },
                    {
                        "id": 61513,
                        "name": "Trezzo sull'Adda",
                        "latitude": "45.60523000",
                        "longitude": "9.51417000"
                    },
                    {
                        "id": 61514,
                        "name": "Trezzone",
                        "latitude": "46.17159000",
                        "longitude": "9.35184000"
                    },
                    {
                        "id": 61516,
                        "name": "Tribiano",
                        "latitude": "45.41323000",
                        "longitude": "9.37693000"
                    },
                    {
                        "id": 61526,
                        "name": "Triginto",
                        "latitude": "45.40223000",
                        "longitude": "9.32512000"
                    },
                    {
                        "id": 61527,
                        "name": "Trigolo",
                        "latitude": "45.32997000",
                        "longitude": "9.81415000"
                    },
                    {
                        "id": 61538,
                        "name": "Triuggio",
                        "latitude": "45.66144000",
                        "longitude": "9.26691000"
                    },
                    {
                        "id": 61545,
                        "name": "Trivolzio",
                        "latitude": "45.25846000",
                        "longitude": "9.04275000"
                    },
                    {
                        "id": 61551,
                        "name": "Tromello",
                        "latitude": "45.20890000",
                        "longitude": "8.87054000"
                    },
                    {
                        "id": 61554,
                        "name": "Tronzano Lago Maggiore",
                        "latitude": "46.08871000",
                        "longitude": "8.73310000"
                    },
                    {
                        "id": 61558,
                        "name": "Trovo",
                        "latitude": "45.28296000",
                        "longitude": "9.03545000"
                    },
                    {
                        "id": 61559,
                        "name": "Truccazzano",
                        "latitude": "45.48455000",
                        "longitude": "9.46950000"
                    },
                    {
                        "id": 61571,
                        "name": "Turano Lodigiano",
                        "latitude": "45.24785000",
                        "longitude": "9.62221000"
                    },
                    {
                        "id": 61572,
                        "name": "Turate",
                        "latitude": "45.65727000",
                        "longitude": "9.00424000"
                    },
                    {
                        "id": 61573,
                        "name": "Turbigo",
                        "latitude": "45.53076000",
                        "longitude": "8.73671000"
                    },
                    {
                        "id": 61583,
                        "name": "Ubiale",
                        "latitude": "45.78350000",
                        "longitude": "9.61650000"
                    },
                    {
                        "id": 61584,
                        "name": "Ubiale Clanezzo",
                        "latitude": "45.78368000",
                        "longitude": "9.61935000"
                    },
                    {
                        "id": 61585,
                        "name": "Uboldo",
                        "latitude": "45.61527000",
                        "longitude": "9.00394000"
                    },
                    {
                        "id": 61592,
                        "name": "Uggiate Trevano",
                        "latitude": "45.82338000",
                        "longitude": "8.95964000"
                    },
                    {
                        "id": 61599,
                        "name": "Urago d'Oglio",
                        "latitude": "45.51598000",
                        "longitude": "9.86966000"
                    },
                    {
                        "id": 61606,
                        "name": "Urgnano",
                        "latitude": "45.59943000",
                        "longitude": "9.69473000"
                    },
                    {
                        "id": 61613,
                        "name": "Usmate-Velate",
                        "latitude": "45.64798000",
                        "longitude": "9.36245000"
                    },
                    {
                        "id": 61638,
                        "name": "Vaiano Cremasco",
                        "latitude": "45.37133000",
                        "longitude": "9.58793000"
                    },
                    {
                        "id": 61640,
                        "name": "Vailate",
                        "latitude": "45.46231000",
                        "longitude": "9.60326000"
                    },
                    {
                        "id": 61643,
                        "name": "Val Masino",
                        "latitude": "46.21519000",
                        "longitude": "9.63804000"
                    },
                    {
                        "id": 61644,
                        "name": "Val Rezzo",
                        "latitude": "46.07268000",
                        "longitude": "9.11183000"
                    },
                    {
                        "id": 61647,
                        "name": "Valbrona",
                        "latitude": "45.87738000",
                        "longitude": "9.29884000"
                    },
                    {
                        "id": 61656,
                        "name": "Valdisotto",
                        "latitude": "46.43441000",
                        "longitude": "10.35695000"
                    },
                    {
                        "id": 61660,
                        "name": "Valeggio",
                        "latitude": "45.15065000",
                        "longitude": "8.86132000"
                    },
                    {
                        "id": 61667,
                        "name": "Valera Fratta",
                        "latitude": "45.25717000",
                        "longitude": "9.33615000"
                    },
                    {
                        "id": 61671,
                        "name": "Valganna",
                        "latitude": "45.90228000",
                        "longitude": "8.82333000"
                    },
                    {
                        "id": 61674,
                        "name": "Valgoglio",
                        "latitude": "45.97489000",
                        "longitude": "9.91355000"
                    },
                    {
                        "id": 61676,
                        "name": "Valgreghentino",
                        "latitude": "45.77928000",
                        "longitude": "9.41345000"
                    },
                    {
                        "id": 61679,
                        "name": "Vall'Alta",
                        "latitude": "45.76116000",
                        "longitude": "9.82640000"
                    },
                    {
                        "id": 61687,
                        "name": "Valle Lomellina",
                        "latitude": "45.15096000",
                        "longitude": "8.66957000"
                    },
                    {
                        "id": 61690,
                        "name": "Valle Salimbene",
                        "latitude": "45.17196000",
                        "longitude": "9.23445000"
                    },
                    {
                        "id": 61718,
                        "name": "Valleve",
                        "latitude": "46.02819000",
                        "longitude": "9.74375000"
                    },
                    {
                        "id": 61722,
                        "name": "Vallio Terme",
                        "latitude": "45.60979000",
                        "longitude": "10.39737000"
                    },
                    {
                        "id": 61730,
                        "name": "Valmadrera-Caserta",
                        "latitude": "45.84628000",
                        "longitude": "9.35824000"
                    },
                    {
                        "id": 61733,
                        "name": "Valmorea",
                        "latitude": "45.81518000",
                        "longitude": "8.93064000"
                    },
                    {
                        "id": 61734,
                        "name": "Valnegra",
                        "latitude": "45.94909000",
                        "longitude": "9.68935000"
                    },
                    {
                        "id": 61743,
                        "name": "Valtorta",
                        "latitude": "45.97685000",
                        "longitude": "9.53478000"
                    },
                    {
                        "id": 61748,
                        "name": "Valvestino",
                        "latitude": "45.76069000",
                        "longitude": "10.59547000"
                    },
                    {
                        "id": 61753,
                        "name": "Vanzaghello",
                        "latitude": "45.57964000",
                        "longitude": "8.78234000"
                    },
                    {
                        "id": 61754,
                        "name": "Vanzago",
                        "latitude": "45.52566000",
                        "longitude": "8.99097000"
                    },
                    {
                        "id": 61757,
                        "name": "Vaprio d'Adda",
                        "latitude": "45.57640000",
                        "longitude": "9.52407000"
                    },
                    {
                        "id": 61761,
                        "name": "Varano Borghi",
                        "latitude": "45.77407000",
                        "longitude": "8.70403000"
                    },
                    {
                        "id": 61766,
                        "name": "Varedo",
                        "latitude": "45.59761000",
                        "longitude": "9.16323000"
                    },
                    {
                        "id": 61768,
                        "name": "Varenna",
                        "latitude": "46.01078000",
                        "longitude": "9.28465000"
                    },
                    {
                        "id": 61769,
                        "name": "Varese",
                        "latitude": "45.82058000",
                        "longitude": "8.82511000"
                    },
                    {
                        "id": 61775,
                        "name": "Varzi",
                        "latitude": "44.82297000",
                        "longitude": "9.19762000"
                    },
                    {
                        "id": 61780,
                        "name": "Vassena",
                        "latitude": "45.92998000",
                        "longitude": "9.28399000"
                    },
                    {
                        "id": 61789,
                        "name": "Vedano al Lambro",
                        "latitude": "45.60878000",
                        "longitude": "9.26785000"
                    },
                    {
                        "id": 61788,
                        "name": "Vedano Olona",
                        "latitude": "45.77570000",
                        "longitude": "8.88771000"
                    },
                    {
                        "id": 61790,
                        "name": "Veddasca",
                        "latitude": "46.07058000",
                        "longitude": "8.79873000"
                    },
                    {
                        "id": 61792,
                        "name": "Vedeseta",
                        "latitude": "45.89102000",
                        "longitude": "9.53927000"
                    },
                    {
                        "id": 61793,
                        "name": "Veduggio Con Colzano",
                        "latitude": "45.73388000",
                        "longitude": "9.27024000"
                    },
                    {
                        "id": 61799,
                        "name": "Velasca",
                        "latitude": "45.63165000",
                        "longitude": "9.35519000"
                    },
                    {
                        "id": 61800,
                        "name": "Veleso",
                        "latitude": "45.90875000",
                        "longitude": "9.18090000"
                    },
                    {
                        "id": 61801,
                        "name": "Velezzo Lomellina",
                        "latitude": "45.16336000",
                        "longitude": "8.73724000"
                    },
                    {
                        "id": 61803,
                        "name": "Vellezzo Bellini",
                        "latitude": "45.26948000",
                        "longitude": "9.10088000"
                    },
                    {
                        "id": 61814,
                        "name": "Vendrogno",
                        "latitude": "46.03439000",
                        "longitude": "9.32944000"
                    },
                    {
                        "id": 61816,
                        "name": "Venegono Inferiore",
                        "latitude": "45.73569000",
                        "longitude": "8.89545000"
                    },
                    {
                        "id": 61817,
                        "name": "Venegono Superiore",
                        "latitude": "45.75246000",
                        "longitude": "8.89734000"
                    },
                    {
                        "id": 61821,
                        "name": "Veniano",
                        "latitude": "45.71629000",
                        "longitude": "8.98501000"
                    },
                    {
                        "id": 61833,
                        "name": "Verano Brianza",
                        "latitude": "45.68868000",
                        "longitude": "9.22454000"
                    },
                    {
                        "id": 61836,
                        "name": "Vercana",
                        "latitude": "46.15949000",
                        "longitude": "9.33514000"
                    },
                    {
                        "id": 61837,
                        "name": "Verceia",
                        "latitude": "46.19869000",
                        "longitude": "9.45474000"
                    },
                    {
                        "id": 61839,
                        "name": "Vercurago",
                        "latitude": "45.80943000",
                        "longitude": "9.42211000"
                    },
                    {
                        "id": 61840,
                        "name": "Verdellino",
                        "latitude": "45.60108000",
                        "longitude": "9.60805000"
                    },
                    {
                        "id": 61841,
                        "name": "Verdello",
                        "latitude": "45.60372000",
                        "longitude": "9.62852000"
                    },
                    {
                        "id": 61842,
                        "name": "Verderio Inferiore",
                        "latitude": "45.66558000",
                        "longitude": "9.43345000"
                    },
                    {
                        "id": 61843,
                        "name": "Verderio Superiore",
                        "latitude": "45.66778000",
                        "longitude": "9.44035000"
                    },
                    {
                        "id": 61845,
                        "name": "Vergano-Villa",
                        "latitude": "45.79416000",
                        "longitude": "9.37460000"
                    },
                    {
                        "id": 61848,
                        "name": "Vergiate",
                        "latitude": "45.72210000",
                        "longitude": "8.69530000"
                    },
                    {
                        "id": 61851,
                        "name": "Vermezzo",
                        "latitude": "45.39627000",
                        "longitude": "8.97904000"
                    },
                    {
                        "id": 61855,
                        "name": "Vernate",
                        "latitude": "45.31589000",
                        "longitude": "9.06045000"
                    },
                    {
                        "id": 61859,
                        "name": "Verolanuova",
                        "latitude": "45.32834000",
                        "longitude": "10.07857000"
                    },
                    {
                        "id": 61860,
                        "name": "Verolavecchia",
                        "latitude": "45.32862000",
                        "longitude": "10.05493000"
                    },
                    {
                        "id": 61867,
                        "name": "Verretto",
                        "latitude": "45.03976000",
                        "longitude": "9.11315000"
                    },
                    {
                        "id": 61869,
                        "name": "Verrua Po",
                        "latitude": "45.10686000",
                        "longitude": "9.17535000"
                    },
                    {
                        "id": 61871,
                        "name": "Vertemate Con Minoprio",
                        "latitude": "45.72518000",
                        "longitude": "9.07300000"
                    },
                    {
                        "id": 61872,
                        "name": "Vertova",
                        "latitude": "45.81000000",
                        "longitude": "9.84944000"
                    },
                    {
                        "id": 61875,
                        "name": "Vervio",
                        "latitude": "46.25285000",
                        "longitude": "10.24056000"
                    },
                    {
                        "id": 61881,
                        "name": "Vescovato",
                        "latitude": "45.17419000",
                        "longitude": "10.16451000"
                    },
                    {
                        "id": 61887,
                        "name": "Vestone",
                        "latitude": "45.70783000",
                        "longitude": "10.39611000"
                    },
                    {
                        "id": 61888,
                        "name": "Vestreno",
                        "latitude": "46.08329000",
                        "longitude": "9.32484000"
                    },
                    {
                        "id": 61893,
                        "name": "Vezza d'Oglio",
                        "latitude": "46.23867000",
                        "longitude": "10.39825000"
                    },
                    {
                        "id": 61899,
                        "name": "Viadana",
                        "latitude": "44.93553000",
                        "longitude": "10.51898000"
                    },
                    {
                        "id": 61900,
                        "name": "Viadanica",
                        "latitude": "45.68468000",
                        "longitude": "9.96146000"
                    },
                    {
                        "id": 61924,
                        "name": "Vicomoscano",
                        "latitude": "44.97476000",
                        "longitude": "10.45045000"
                    },
                    {
                        "id": 61927,
                        "name": "Vidalengo",
                        "latitude": "45.52235000",
                        "longitude": "9.64128000"
                    },
                    {
                        "id": 61928,
                        "name": "Vidardo",
                        "latitude": "45.25667000",
                        "longitude": "9.40241000"
                    },
                    {
                        "id": 61930,
                        "name": "Vidigulfo",
                        "latitude": "45.29245000",
                        "longitude": "9.23498000"
                    },
                    {
                        "id": 61938,
                        "name": "Viganò",
                        "latitude": "45.72468000",
                        "longitude": "9.32494000"
                    },
                    {
                        "id": 61937,
                        "name": "Vigano San Martino",
                        "latitude": "45.72608000",
                        "longitude": "9.89616000"
                    },
                    {
                        "id": 61944,
                        "name": "Vigevano",
                        "latitude": "45.31407000",
                        "longitude": "8.85437000"
                    },
                    {
                        "id": 61947,
                        "name": "Viggiù",
                        "latitude": "45.87096000",
                        "longitude": "8.90861000"
                    },
                    {
                        "id": 61948,
                        "name": "Vighignolo",
                        "latitude": "45.49542000",
                        "longitude": "9.04308000"
                    },
                    {
                        "id": 61949,
                        "name": "Vighizzolo",
                        "latitude": "45.43524000",
                        "longitude": "10.35507000"
                    },
                    {
                        "id": 61953,
                        "name": "Vigliano-Bettolino",
                        "latitude": "45.43272000",
                        "longitude": "9.34422000"
                    },
                    {
                        "id": 61959,
                        "name": "Vignate",
                        "latitude": "45.49939000",
                        "longitude": "9.37719000"
                    },
                    {
                        "id": 61962,
                        "name": "Vignola",
                        "latitude": "46.08815000",
                        "longitude": "9.27456000"
                    },
                    {
                        "id": 61971,
                        "name": "Vigolo",
                        "latitude": "45.71642000",
                        "longitude": "10.02634000"
                    },
                    {
                        "id": 61978,
                        "name": "Vigonzone",
                        "latitude": "45.27350000",
                        "longitude": "9.30980000"
                    },
                    {
                        "id": 61980,
                        "name": "Vill'Albese",
                        "latitude": "45.79684000",
                        "longitude": "9.18859000"
                    },
                    {
                        "id": 61981,
                        "name": "Villa",
                        "latitude": "46.20390000",
                        "longitude": "10.13385000"
                    },
                    {
                        "id": 61987,
                        "name": "Villa Biscossi",
                        "latitude": "45.09066000",
                        "longitude": "8.78715000"
                    },
                    {
                        "id": 61989,
                        "name": "Villa Carcina",
                        "latitude": "45.63329000",
                        "longitude": "10.19556000"
                    },
                    {
                        "id": 61995,
                        "name": "Villa Cortese",
                        "latitude": "45.56666000",
                        "longitude": "8.88712000"
                    },
                    {
                        "id": 62032,
                        "name": "Villa d'Adda",
                        "latitude": "45.71398000",
                        "longitude": "9.46165000"
                    },
                    {
                        "id": 62034,
                        "name": "Villa d'Almè",
                        "latitude": "45.74843000",
                        "longitude": "9.61702000"
                    },
                    {
                        "id": 62036,
                        "name": "Villa d'Ogna",
                        "latitude": "45.90469000",
                        "longitude": "9.93085000"
                    },
                    {
                        "id": 62037,
                        "name": "Villa d'Oneta",
                        "latitude": "45.87074000",
                        "longitude": "9.81929000"
                    },
                    {
                        "id": 62041,
                        "name": "Villa di Chiavenna",
                        "latitude": "46.33069000",
                        "longitude": "9.48114000"
                    },
                    {
                        "id": 62042,
                        "name": "Villa di Serio",
                        "latitude": "45.72260000",
                        "longitude": "9.73522000"
                    },
                    {
                        "id": 61999,
                        "name": "Villa Fornace",
                        "latitude": "44.97194000",
                        "longitude": "9.25215000"
                    },
                    {
                        "id": 62000,
                        "name": "Villa Guardia",
                        "latitude": "45.77505000",
                        "longitude": "9.02321000"
                    },
                    {
                        "id": 62008,
                        "name": "Villa Pedergnano",
                        "latitude": "45.58528000",
                        "longitude": "9.99381000"
                    },
                    {
                        "id": 62010,
                        "name": "Villa Poma",
                        "latitude": "45.00238000",
                        "longitude": "11.11450000"
                    },
                    {
                        "id": 62013,
                        "name": "Villa Raverio",
                        "latitude": "45.69189000",
                        "longitude": "9.26239000"
                    },
                    {
                        "id": 62049,
                        "name": "Villachiara",
                        "latitude": "45.35445000",
                        "longitude": "9.93081000"
                    },
                    {
                        "id": 62069,
                        "name": "Villaggio del Sole",
                        "latitude": "45.61398000",
                        "longitude": "9.10725000"
                    },
                    {
                        "id": 62067,
                        "name": "Villaggio Residenziale",
                        "latitude": "45.52826000",
                        "longitude": "9.46737000"
                    },
                    {
                        "id": 62094,
                        "name": "Villanova",
                        "latitude": "45.64027000",
                        "longitude": "9.39187000"
                    },
                    {
                        "id": 62106,
                        "name": "Villanova d'Ardenghi",
                        "latitude": "45.17049000",
                        "longitude": "9.04078000"
                    },
                    {
                        "id": 62110,
                        "name": "Villanova del Sillaro",
                        "latitude": "45.23797000",
                        "longitude": "9.48186000"
                    },
                    {
                        "id": 62113,
                        "name": "Villanterio",
                        "latitude": "45.21780000",
                        "longitude": "9.36100000"
                    },
                    {
                        "id": 62114,
                        "name": "Villanuova",
                        "latitude": "45.44245000",
                        "longitude": "9.86690000"
                    },
                    {
                        "id": 62115,
                        "name": "Villanuova sul Clisi",
                        "latitude": "45.59938000",
                        "longitude": "10.45275000"
                    },
                    {
                        "id": 62119,
                        "name": "Villapinta",
                        "latitude": "46.17508000",
                        "longitude": "9.67950000"
                    },
                    {
                        "id": 62134,
                        "name": "Villasanta",
                        "latitude": "45.60634000",
                        "longitude": "9.30797000"
                    },
                    {
                        "id": 62140,
                        "name": "Villassio",
                        "latitude": "45.86313000",
                        "longitude": "9.84466000"
                    },
                    {
                        "id": 62153,
                        "name": "Villimpenta",
                        "latitude": "45.14111000",
                        "longitude": "11.03170000"
                    },
                    {
                        "id": 62154,
                        "name": "Villongo",
                        "latitude": "45.66939000",
                        "longitude": "9.93076000"
                    },
                    {
                        "id": 62156,
                        "name": "Vilminore",
                        "latitude": "45.99795000",
                        "longitude": "10.09531000"
                    },
                    {
                        "id": 62157,
                        "name": "Vilminore di Scalve",
                        "latitude": "45.99819000",
                        "longitude": "10.09376000"
                    },
                    {
                        "id": 62158,
                        "name": "Vimercate",
                        "latitude": "45.61545000",
                        "longitude": "9.36801000"
                    },
                    {
                        "id": 62159,
                        "name": "Vimodrone",
                        "latitude": "45.51461000",
                        "longitude": "9.28772000"
                    },
                    {
                        "id": 62167,
                        "name": "Vione",
                        "latitude": "46.24808000",
                        "longitude": "10.44842000"
                    },
                    {
                        "id": 62170,
                        "name": "Visano",
                        "latitude": "45.31684000",
                        "longitude": "10.37092000"
                    },
                    {
                        "id": 62176,
                        "name": "Vistarino",
                        "latitude": "45.21077000",
                        "longitude": "9.30825000"
                    },
                    {
                        "id": 62187,
                        "name": "Vittuone",
                        "latitude": "45.48792000",
                        "longitude": "8.95141000"
                    },
                    {
                        "id": 62194,
                        "name": "Vizzola Ticino",
                        "latitude": "45.62615000",
                        "longitude": "8.69651000"
                    },
                    {
                        "id": 62195,
                        "name": "Vizzolo Predabissi",
                        "latitude": "45.35587000",
                        "longitude": "9.34815000"
                    },
                    {
                        "id": 62197,
                        "name": "Vobarno",
                        "latitude": "45.64153000",
                        "longitude": "10.49866000"
                    },
                    {
                        "id": 62201,
                        "name": "Voghera",
                        "latitude": "44.99151000",
                        "longitude": "9.01175000"
                    },
                    {
                        "id": 62207,
                        "name": "Volongo",
                        "latitude": "45.21155000",
                        "longitude": "10.30242000"
                    },
                    {
                        "id": 62209,
                        "name": "Volpara",
                        "latitude": "44.95379000",
                        "longitude": "9.29750000"
                    },
                    {
                        "id": 62213,
                        "name": "Volta Mantovana",
                        "latitude": "45.32192000",
                        "longitude": "10.65891000"
                    },
                    {
                        "id": 62219,
                        "name": "Voltido",
                        "latitude": "45.11197000",
                        "longitude": "10.33298000"
                    },
                    {
                        "id": 62234,
                        "name": "Zandobbio",
                        "latitude": "45.68613000",
                        "longitude": "9.85785000"
                    },
                    {
                        "id": 62235,
                        "name": "Zanica",
                        "latitude": "45.64088000",
                        "longitude": "9.68566000"
                    },
                    {
                        "id": 62238,
                        "name": "Zavattarello",
                        "latitude": "44.86766000",
                        "longitude": "9.26662000"
                    },
                    {
                        "id": 62239,
                        "name": "Zeccone",
                        "latitude": "45.25787000",
                        "longitude": "9.20115000"
                    },
                    {
                        "id": 62242,
                        "name": "Zelbio",
                        "latitude": "45.90458000",
                        "longitude": "9.18054000"
                    },
                    {
                        "id": 62243,
                        "name": "Zelo Buon Persico",
                        "latitude": "45.41170000",
                        "longitude": "9.43171000"
                    },
                    {
                        "id": 62244,
                        "name": "Zelo Surrigone",
                        "latitude": "45.38767000",
                        "longitude": "8.98504000"
                    },
                    {
                        "id": 62245,
                        "name": "Zeme",
                        "latitude": "45.19686000",
                        "longitude": "8.66733000"
                    },
                    {
                        "id": 62246,
                        "name": "Zenevredo",
                        "latitude": "45.05391000",
                        "longitude": "9.32667000"
                    },
                    {
                        "id": 62250,
                        "name": "Zerbo",
                        "latitude": "45.11046000",
                        "longitude": "9.39606000"
                    },
                    {
                        "id": 62251,
                        "name": "Zerbolò",
                        "latitude": "45.20676000",
                        "longitude": "9.01441000"
                    },
                    {
                        "id": 62260,
                        "name": "Zibido San Giacomo",
                        "latitude": "45.36041000",
                        "longitude": "9.11119000"
                    },
                    {
                        "id": 62262,
                        "name": "Zinasco Vecchio",
                        "latitude": "45.12836000",
                        "longitude": "9.02975000"
                    },
                    {
                        "id": 62265,
                        "name": "Zoccorino-Vergo",
                        "latitude": "45.69735000",
                        "longitude": "9.25377000"
                    },
                    {
                        "id": 62266,
                        "name": "Zogno",
                        "latitude": "45.79378000",
                        "longitude": "9.65992000"
                    },
                    {
                        "id": 62273,
                        "name": "Zone",
                        "latitude": "45.76339000",
                        "longitude": "10.11586000"
                    },
                    {
                        "id": 62276,
                        "name": "Zorlesco",
                        "latitude": "45.20035000",
                        "longitude": "9.61603000"
                    }
                ]
            },
            {
                "id": 1749,
                "name": "Lucca",
                "iso2": "LU",
                "latitude": "43.83767360",
                "longitude": "10.49505300",
                "type": "province",
                "cities": []
            },
            {
                "id": 1750,
                "name": "Macerata",
                "iso2": "MC",
                "latitude": "43.24593220",
                "longitude": "13.26634790",
                "type": "province",
                "cities": []
            },
            {
                "id": 1758,
                "name": "Mantua",
                "iso2": "MN",
                "latitude": "45.16677280",
                "longitude": "10.77536130",
                "type": "province",
                "cities": []
            },
            {
                "id": 1670,
                "name": "Marche",
                "iso2": "57",
                "latitude": "43.30456200",
                "longitude": "13.71947000",
                "type": "region",
                "cities": [
                    {
                        "id": 135267,
                        "name": "Acqualagna",
                        "latitude": "43.62606000",
                        "longitude": "12.67596000"
                    },
                    {
                        "id": 135274,
                        "name": "Acquasanta Terme",
                        "latitude": "42.77084000",
                        "longitude": "13.41418000"
                    },
                    {
                        "id": 135278,
                        "name": "Acquaviva Picena",
                        "latitude": "42.94037000",
                        "longitude": "13.82227000"
                    },
                    {
                        "id": 135320,
                        "name": "Agugliano",
                        "latitude": "43.54368000",
                        "longitude": "13.38574000"
                    },
                    {
                        "id": 135438,
                        "name": "Altidona",
                        "latitude": "43.10787000",
                        "longitude": "13.79617000"
                    },
                    {
                        "id": 135457,
                        "name": "Amandola",
                        "latitude": "42.97826000",
                        "longitude": "13.35453000"
                    },
                    {
                        "id": 135479,
                        "name": "Ancona",
                        "latitude": "43.59420000",
                        "longitude": "13.50337000"
                    },
                    {
                        "id": 135531,
                        "name": "Apecchio",
                        "latitude": "43.55914000",
                        "longitude": "12.42163000"
                    },
                    {
                        "id": 135533,
                        "name": "Apiro",
                        "latitude": "43.39290000",
                        "longitude": "13.13045000"
                    },
                    {
                        "id": 135536,
                        "name": "Appignano",
                        "latitude": "43.36276000",
                        "longitude": "13.34768000"
                    },
                    {
                        "id": 135537,
                        "name": "Appignano del Tronto",
                        "latitude": "42.89805000",
                        "longitude": "13.66220000"
                    },
                    {
                        "id": 135564,
                        "name": "Arcevia",
                        "latitude": "43.50177000",
                        "longitude": "12.94500000"
                    },
                    {
                        "id": 135631,
                        "name": "Arquata del Tronto",
                        "latitude": "42.77170000",
                        "longitude": "13.29389000"
                    },
                    {
                        "id": 135655,
                        "name": "Ascoli Piceno",
                        "latitude": "42.85351000",
                        "longitude": "13.57395000"
                    },
                    {
                        "id": 135684,
                        "name": "Auditore",
                        "latitude": "43.82124000",
                        "longitude": "12.57165000"
                    },
                    {
                        "id": 135798,
                        "name": "Balzo",
                        "latitude": "42.84199000",
                        "longitude": "13.33234000"
                    },
                    {
                        "id": 135819,
                        "name": "Barbara",
                        "latitude": "43.58036000",
                        "longitude": "13.02736000"
                    },
                    {
                        "id": 135835,
                        "name": "Barchi",
                        "latitude": "43.67280000",
                        "longitude": "12.92823000"
                    },
                    {
                        "id": 135928,
                        "name": "Belforte",
                        "latitude": "43.71676000",
                        "longitude": "12.37575000"
                    },
                    {
                        "id": 135931,
                        "name": "Belforte del Chienti",
                        "latitude": "43.16426000",
                        "longitude": "13.24323000"
                    },
                    {
                        "id": 135946,
                        "name": "Bellocchi",
                        "latitude": "43.79564000",
                        "longitude": "13.00565000"
                    },
                    {
                        "id": 135954,
                        "name": "Belmonte Piceno",
                        "latitude": "43.09175000",
                        "longitude": "13.53938000"
                    },
                    {
                        "id": 135964,
                        "name": "Belvedere Ostrense",
                        "latitude": "43.57896000",
                        "longitude": "13.16724000"
                    },
                    {
                        "id": 136111,
                        "name": "Bolognola",
                        "latitude": "42.99319000",
                        "longitude": "13.22680000"
                    },
                    {
                        "id": 136158,
                        "name": "Borghetto",
                        "latitude": "43.59800000",
                        "longitude": "13.29205000"
                    },
                    {
                        "id": 136175,
                        "name": "Borgo Massano",
                        "latitude": "43.82495000",
                        "longitude": "12.67961000"
                    },
                    {
                        "id": 136177,
                        "name": "Borgo Pace",
                        "latitude": "43.65808000",
                        "longitude": "12.29317000"
                    },
                    {
                        "id": 136188,
                        "name": "Borgo Santa Maria",
                        "latitude": "43.87582000",
                        "longitude": "12.80235000"
                    },
                    {
                        "id": 136190,
                        "name": "Borgo Stazione",
                        "latitude": "43.28461000",
                        "longitude": "13.64420000"
                    },
                    {
                        "id": 136260,
                        "name": "Bottega",
                        "latitude": "43.84523000",
                        "longitude": "12.74999000"
                    },
                    {
                        "id": 136467,
                        "name": "Cagli",
                        "latitude": "43.54771000",
                        "longitude": "12.65229000"
                    },
                    {
                        "id": 136508,
                        "name": "Calcinelli",
                        "latitude": "43.75398000",
                        "longitude": "12.91959000"
                    },
                    {
                        "id": 136512,
                        "name": "Caldarola",
                        "latitude": "43.14282000",
                        "longitude": "13.22367000"
                    },
                    {
                        "id": 136577,
                        "name": "Camerano",
                        "latitude": "43.52774000",
                        "longitude": "13.55257000"
                    },
                    {
                        "id": 136582,
                        "name": "Camerata Picena",
                        "latitude": "43.57758000",
                        "longitude": "13.35196000"
                    },
                    {
                        "id": 136584,
                        "name": "Camerino",
                        "latitude": "43.13866000",
                        "longitude": "13.06785000"
                    },
                    {
                        "id": 136621,
                        "name": "Campiglione",
                        "latitude": "43.17630000",
                        "longitude": "13.67043000"
                    },
                    {
                        "id": 136641,
                        "name": "Campocavallo",
                        "latitude": "43.46120000",
                        "longitude": "13.49679000"
                    },
                    {
                        "id": 136652,
                        "name": "Campofilone",
                        "latitude": "43.08100000",
                        "longitude": "13.82153000"
                    },
                    {
                        "id": 136678,
                        "name": "Camporotondo di Fiastrone",
                        "latitude": "43.13203000",
                        "longitude": "13.26632000"
                    },
                    {
                        "id": 136692,
                        "name": "Canavaccio",
                        "latitude": "43.69376000",
                        "longitude": "12.69863000"
                    },
                    {
                        "id": 136748,
                        "name": "Cantiano",
                        "latitude": "43.47082000",
                        "longitude": "12.62868000"
                    },
                    {
                        "id": 136780,
                        "name": "Capodarco",
                        "latitude": "43.18985000",
                        "longitude": "13.75935000"
                    },
                    {
                        "id": 136796,
                        "name": "Cappone",
                        "latitude": "43.83071000",
                        "longitude": "12.74458000"
                    },
                    {
                        "id": 136837,
                        "name": "Carassai",
                        "latitude": "43.03303000",
                        "longitude": "13.68761000"
                    },
                    {
                        "id": 136909,
                        "name": "Carpegna",
                        "latitude": "43.78110000",
                        "longitude": "12.33543000"
                    },
                    {
                        "id": 136940,
                        "name": "Cartoceto",
                        "latitude": "43.76566000",
                        "longitude": "12.88346000"
                    },
                    {
                        "id": 137050,
                        "name": "Cascinare",
                        "latitude": "43.26434000",
                        "longitude": "13.71181000"
                    },
                    {
                        "id": 137067,
                        "name": "Casette d'Ete",
                        "latitude": "43.25385000",
                        "longitude": "13.68319000"
                    },
                    {
                        "id": 137066,
                        "name": "Casette Verdini",
                        "latitude": "43.25104000",
                        "longitude": "13.40156000"
                    },
                    {
                        "id": 137071,
                        "name": "Casine",
                        "latitude": "43.63165000",
                        "longitude": "13.14425000"
                    },
                    {
                        "id": 137072,
                        "name": "Casinina",
                        "latitude": "43.81667000",
                        "longitude": "12.58333000"
                    },
                    {
                        "id": 137171,
                        "name": "Castel di Lama",
                        "latitude": "42.86435000",
                        "longitude": "13.71929000"
                    },
                    {
                        "id": 137178,
                        "name": "Castelbellino",
                        "latitude": "43.48676000",
                        "longitude": "13.14467000"
                    },
                    {
                        "id": 137192,
                        "name": "Castelfidardo",
                        "latitude": "43.45916000",
                        "longitude": "13.55044000"
                    },
                    {
                        "id": 137227,
                        "name": "Castelleone di Suasa",
                        "latitude": "43.60816000",
                        "longitude": "12.97796000"
                    },
                    {
                        "id": 137308,
                        "name": "Castelplanio",
                        "latitude": "43.49420000",
                        "longitude": "13.08180000"
                    },
                    {
                        "id": 137310,
                        "name": "Castelraimondo",
                        "latitude": "43.20853000",
                        "longitude": "13.05486000"
                    },
                    {
                        "id": 137312,
                        "name": "Castelsantangelo sul Nera",
                        "latitude": "42.89379000",
                        "longitude": "13.15462000"
                    },
                    {
                        "id": 137359,
                        "name": "Castignano",
                        "latitude": "42.93935000",
                        "longitude": "13.62514000"
                    },
                    {
                        "id": 137370,
                        "name": "Castorano",
                        "latitude": "42.89779000",
                        "longitude": "13.72967000"
                    },
                    {
                        "id": 137496,
                        "name": "Centinarola",
                        "latitude": "43.83117000",
                        "longitude": "12.98962000"
                    },
                    {
                        "id": 137498,
                        "name": "Centobuchi",
                        "latitude": "42.89521000",
                        "longitude": "13.84809000"
                    },
                    {
                        "id": 137568,
                        "name": "Cerreto d'Esi",
                        "latitude": "43.31668000",
                        "longitude": "12.98771000"
                    },
                    {
                        "id": 137618,
                        "name": "Cessapalombo",
                        "latitude": "43.10825000",
                        "longitude": "13.25758000"
                    },
                    {
                        "id": 137651,
                        "name": "Chiaravalle",
                        "latitude": "43.60114000",
                        "longitude": "13.32511000"
                    },
                    {
                        "id": 137732,
                        "name": "Cingoli",
                        "latitude": "43.37573000",
                        "longitude": "13.20787000"
                    },
                    {
                        "id": 137790,
                        "name": "Civitanova Alta",
                        "latitude": "43.31619000",
                        "longitude": "13.67978000"
                    },
                    {
                        "id": 137791,
                        "name": "Civitanova Marche",
                        "latitude": "43.30491000",
                        "longitude": "13.72068000"
                    },
                    {
                        "id": 137848,
                        "name": "Colbordolo",
                        "latitude": "43.82006000",
                        "longitude": "12.72105000"
                    },
                    {
                        "id": 137899,
                        "name": "Colli del Tronto",
                        "latitude": "42.87690000",
                        "longitude": "13.74745000"
                    },
                    {
                        "id": 137909,
                        "name": "Colmurano",
                        "latitude": "43.16485000",
                        "longitude": "13.35908000"
                    },
                    {
                        "id": 137951,
                        "name": "Comunanza",
                        "latitude": "42.95719000",
                        "longitude": "13.41341000"
                    },
                    {
                        "id": 138015,
                        "name": "Corinaldo",
                        "latitude": "43.64107000",
                        "longitude": "13.06004000"
                    },
                    {
                        "id": 138043,
                        "name": "Corridonia",
                        "latitude": "43.24677000",
                        "longitude": "13.50690000"
                    },
                    {
                        "id": 138087,
                        "name": "Cossignano",
                        "latitude": "42.98355000",
                        "longitude": "13.69026000"
                    },
                    {
                        "id": 138181,
                        "name": "Cuccurano",
                        "latitude": "43.79311000",
                        "longitude": "12.95927000"
                    },
                    {
                        "id": 138196,
                        "name": "Cupra Marittima",
                        "latitude": "43.01905000",
                        "longitude": "13.86171000"
                    },
                    {
                        "id": 138197,
                        "name": "Cupramontana",
                        "latitude": "43.44975000",
                        "longitude": "13.11312000"
                    },
                    {
                        "id": 138379,
                        "name": "Esanatoglia",
                        "latitude": "43.25248000",
                        "longitude": "12.94930000"
                    },
                    {
                        "id": 138393,
                        "name": "Fabriano",
                        "latitude": "43.33941000",
                        "longitude": "12.90327000"
                    },
                    {
                        "id": 138416,
                        "name": "Falconara Marittima",
                        "latitude": "43.62558000",
                        "longitude": "13.39954000"
                    },
                    {
                        "id": 138421,
                        "name": "Falerone",
                        "latitude": "43.10429000",
                        "longitude": "13.47189000"
                    },
                    {
                        "id": 138430,
                        "name": "Fanano",
                        "latitude": "43.94296000",
                        "longitude": "12.74828000"
                    },
                    {
                        "id": 138433,
                        "name": "Fano",
                        "latitude": "43.84052000",
                        "longitude": "13.01665000"
                    },
                    {
                        "id": 138478,
                        "name": "Fenile",
                        "latitude": "43.84126000",
                        "longitude": "12.96747000"
                    },
                    {
                        "id": 138482,
                        "name": "Fermignano",
                        "latitude": "43.69311000",
                        "longitude": "12.65437000"
                    },
                    {
                        "id": 138483,
                        "name": "Fermo",
                        "latitude": "43.16296000",
                        "longitude": "13.72274000"
                    },
                    {
                        "id": 138533,
                        "name": "Filottrano",
                        "latitude": "43.43553000",
                        "longitude": "13.35141000"
                    },
                    {
                        "id": 138581,
                        "name": "Folignano",
                        "latitude": "42.82070000",
                        "longitude": "13.63273000"
                    },
                    {
                        "id": 138618,
                        "name": "Force",
                        "latitude": "42.96095000",
                        "longitude": "13.48768000"
                    },
                    {
                        "id": 138681,
                        "name": "Fossombrone",
                        "latitude": "43.69017000",
                        "longitude": "12.81173000"
                    },
                    {
                        "id": 138697,
                        "name": "Francavilla d'Ete",
                        "latitude": "43.18837000",
                        "longitude": "13.54033000"
                    },
                    {
                        "id": 138724,
                        "name": "Fratte Rosa",
                        "latitude": "43.63346000",
                        "longitude": "12.90236000"
                    },
                    {
                        "id": 138739,
                        "name": "Frontino",
                        "latitude": "43.76456000",
                        "longitude": "12.37675000"
                    },
                    {
                        "id": 138740,
                        "name": "Frontone",
                        "latitude": "43.51478000",
                        "longitude": "12.73791000"
                    },
                    {
                        "id": 138770,
                        "name": "Gabicce Mare",
                        "latitude": "43.96471000",
                        "longitude": "12.75641000"
                    },
                    {
                        "id": 138785,
                        "name": "Gagliole",
                        "latitude": "43.23812000",
                        "longitude": "13.06782000"
                    },
                    {
                        "id": 138815,
                        "name": "Gallo",
                        "latitude": "43.78636000",
                        "longitude": "12.71334000"
                    },
                    {
                        "id": 138896,
                        "name": "Genga",
                        "latitude": "43.43032000",
                        "longitude": "12.93549000"
                    },
                    {
                        "id": 139049,
                        "name": "Gradara",
                        "latitude": "43.93858000",
                        "longitude": "12.76965000"
                    },
                    {
                        "id": 139123,
                        "name": "Grottammare",
                        "latitude": "42.98182000",
                        "longitude": "13.86765000"
                    },
                    {
                        "id": 139124,
                        "name": "Grottazzolina",
                        "latitude": "43.11880000",
                        "longitude": "13.60691000"
                    },
                    {
                        "id": 139145,
                        "name": "Gualdo",
                        "latitude": "43.06585000",
                        "longitude": "13.34328000"
                    },
                    {
                        "id": 139247,
                        "name": "Isola del Piano",
                        "latitude": "43.73776000",
                        "longitude": "12.78406000"
                    },
                    {
                        "id": 139278,
                        "name": "Jesi",
                        "latitude": "43.52142000",
                        "longitude": "13.24368000"
                    },
                    {
                        "id": 139367,
                        "name": "Lapedona",
                        "latitude": "43.10920000",
                        "longitude": "13.77063000"
                    },
                    {
                        "id": 139428,
                        "name": "Le Grazie di Ancona",
                        "latitude": "43.60081000",
                        "longitude": "13.51529000"
                    },
                    {
                        "id": 139505,
                        "name": "Lido di Fermo",
                        "latitude": "43.20556000",
                        "longitude": "13.78467000"
                    },
                    {
                        "id": 139609,
                        "name": "Loreto",
                        "latitude": "43.43617000",
                        "longitude": "13.61232000"
                    },
                    {
                        "id": 139611,
                        "name": "Loreto Stazione",
                        "latitude": "43.44792000",
                        "longitude": "13.62016000"
                    },
                    {
                        "id": 139614,
                        "name": "Loro Piceno",
                        "latitude": "43.16442000",
                        "longitude": "13.41162000"
                    },
                    {
                        "id": 139640,
                        "name": "Lucrezia",
                        "latitude": "43.77310000",
                        "longitude": "12.93995000"
                    },
                    {
                        "id": 139658,
                        "name": "Lunano",
                        "latitude": "43.73214000",
                        "longitude": "12.44326000"
                    },
                    {
                        "id": 139696,
                        "name": "Macerata",
                        "latitude": "43.29789000",
                        "longitude": "13.45293000"
                    },
                    {
                        "id": 139698,
                        "name": "Macerata Feltria",
                        "latitude": "43.80285000",
                        "longitude": "12.44204000"
                    },
                    {
                        "id": 139701,
                        "name": "Macine-Borgo Loreto",
                        "latitude": "43.48611000",
                        "longitude": "13.08725000"
                    },
                    {
                        "id": 139729,
                        "name": "Magliano di Tenna",
                        "latitude": "43.13795000",
                        "longitude": "13.58718000"
                    },
                    {
                        "id": 139748,
                        "name": "Maiolati Spontini",
                        "latitude": "43.47640000",
                        "longitude": "13.11991000"
                    },
                    {
                        "id": 139775,
                        "name": "Maltignano",
                        "latitude": "42.83225000",
                        "longitude": "13.68799000"
                    },
                    {
                        "id": 139837,
                        "name": "Marcelli",
                        "latitude": "43.49204000",
                        "longitude": "13.62545000"
                    },
                    {
                        "id": 139875,
                        "name": "Marina di Altidona",
                        "latitude": "43.10602000",
                        "longitude": "13.83454000"
                    },
                    {
                        "id": 139890,
                        "name": "Marina di Montemarciano",
                        "latitude": "43.65063000",
                        "longitude": "13.33640000"
                    },
                    {
                        "id": 139914,
                        "name": "Marotta",
                        "latitude": "43.76397000",
                        "longitude": "13.14772000"
                    },
                    {
                        "id": 139921,
                        "name": "Marsia",
                        "latitude": "42.86030000",
                        "longitude": "13.47619000"
                    },
                    {
                        "id": 139967,
                        "name": "Massa",
                        "latitude": "43.18803000",
                        "longitude": "12.93142000"
                    },
                    {
                        "id": 139968,
                        "name": "Massa Fermana",
                        "latitude": "43.14691000",
                        "longitude": "13.47597000"
                    },
                    {
                        "id": 139986,
                        "name": "Massignano",
                        "latitude": "43.05062000",
                        "longitude": "13.79798000"
                    },
                    {
                        "id": 139992,
                        "name": "Matelica",
                        "latitude": "43.25788000",
                        "longitude": "13.00750000"
                    },
                    {
                        "id": 140071,
                        "name": "Mercatale",
                        "latitude": "43.78276000",
                        "longitude": "12.48478000"
                    },
                    {
                        "id": 140074,
                        "name": "Mercatello sul Metauro",
                        "latitude": "43.64677000",
                        "longitude": "12.33619000"
                    },
                    {
                        "id": 140075,
                        "name": "Mercatino Conca",
                        "latitude": "43.87016000",
                        "longitude": "12.49115000"
                    },
                    {
                        "id": 140079,
                        "name": "Mercato Vecchio",
                        "latitude": "43.80421000",
                        "longitude": "12.37653000"
                    },
                    {
                        "id": 140083,
                        "name": "Mergo",
                        "latitude": "43.47350000",
                        "longitude": "13.03509000"
                    },
                    {
                        "id": 140198,
                        "name": "Mogliano",
                        "latitude": "43.18750000",
                        "longitude": "13.49123000"
                    },
                    {
                        "id": 140203,
                        "name": "Moie",
                        "latitude": "43.50366000",
                        "longitude": "13.13275000"
                    },
                    {
                        "id": 140236,
                        "name": "Mombaroccio",
                        "latitude": "43.79506000",
                        "longitude": "12.85476000"
                    },
                    {
                        "id": 140273,
                        "name": "Mondavio",
                        "latitude": "43.67468000",
                        "longitude": "12.96601000"
                    },
                    {
                        "id": 140274,
                        "name": "Mondolfo",
                        "latitude": "43.74529000",
                        "longitude": "13.10229000"
                    },
                    {
                        "id": 140298,
                        "name": "Monsampietro Morico",
                        "latitude": "43.06775000",
                        "longitude": "13.55568000"
                    },
                    {
                        "id": 140299,
                        "name": "Monsampolo del Tronto",
                        "latitude": "42.89749000",
                        "longitude": "13.79349000"
                    },
                    {
                        "id": 140300,
                        "name": "Monsano",
                        "latitude": "43.56221000",
                        "longitude": "13.25186000"
                    },
                    {
                        "id": 140335,
                        "name": "Montalto delle Marche",
                        "latitude": "42.98964000",
                        "longitude": "13.60820000"
                    },
                    {
                        "id": 140345,
                        "name": "Montappone",
                        "latitude": "43.13617000",
                        "longitude": "13.46932000"
                    },
                    {
                        "id": 140355,
                        "name": "Monte Cerignone",
                        "latitude": "43.83983000",
                        "longitude": "12.41427000"
                    },
                    {
                        "id": 140358,
                        "name": "Monte Giberto",
                        "latitude": "43.09092000",
                        "longitude": "13.63133000"
                    },
                    {
                        "id": 140360,
                        "name": "Monte Grimano Terme",
                        "latitude": "43.86766000",
                        "longitude": "12.47125000"
                    },
                    {
                        "id": 140363,
                        "name": "Monte Porzio",
                        "latitude": "43.69116000",
                        "longitude": "13.04686000"
                    },
                    {
                        "id": 140365,
                        "name": "Monte Rinaldo",
                        "latitude": "43.02825000",
                        "longitude": "13.58198000"
                    },
                    {
                        "id": 140366,
                        "name": "Monte Roberto",
                        "latitude": "43.48056000",
                        "longitude": "13.13797000"
                    },
                    {
                        "id": 140373,
                        "name": "Monte San Giusto",
                        "latitude": "43.23565000",
                        "longitude": "13.59316000"
                    },
                    {
                        "id": 140375,
                        "name": "Monte San Martino",
                        "latitude": "43.03219000",
                        "longitude": "13.44033000"
                    },
                    {
                        "id": 140376,
                        "name": "Monte San Pietrangeli",
                        "latitude": "43.18959000",
                        "longitude": "13.57718000"
                    },
                    {
                        "id": 140378,
                        "name": "Monte San Vito",
                        "latitude": "43.60056000",
                        "longitude": "13.26817000"
                    },
                    {
                        "id": 140381,
                        "name": "Monte Urano",
                        "latitude": "43.19039000",
                        "longitude": "13.66180000"
                    },
                    {
                        "id": 140382,
                        "name": "Monte Vidon Combatte",
                        "latitude": "43.04895000",
                        "longitude": "13.63119000"
                    },
                    {
                        "id": 140383,
                        "name": "Monte Vidon Corrado",
                        "latitude": "43.12087000",
                        "longitude": "13.48931000"
                    },
                    {
                        "id": 140398,
                        "name": "Montecalvo in Foglia",
                        "latitude": "43.81099000",
                        "longitude": "12.63161000"
                    },
                    {
                        "id": 140401,
                        "name": "Montecarotto",
                        "latitude": "43.52828000",
                        "longitude": "13.06656000"
                    },
                    {
                        "id": 140402,
                        "name": "Montecassiano",
                        "latitude": "43.36518000",
                        "longitude": "13.43950000"
                    },
                    {
                        "id": 140417,
                        "name": "Monteciccardo",
                        "latitude": "43.82415000",
                        "longitude": "12.80344000"
                    },
                    {
                        "id": 140423,
                        "name": "Montecosaro",
                        "latitude": "43.31619000",
                        "longitude": "13.63762000"
                    },
                    {
                        "id": 140427,
                        "name": "Montedinove",
                        "latitude": "42.97262000",
                        "longitude": "13.58972000"
                    },
                    {
                        "id": 140431,
                        "name": "Montefalcone Appennino",
                        "latitude": "42.99005000",
                        "longitude": "13.45688000"
                    },
                    {
                        "id": 140434,
                        "name": "Montefano",
                        "latitude": "43.40982000",
                        "longitude": "13.43690000"
                    },
                    {
                        "id": 140435,
                        "name": "Montefelcino",
                        "latitude": "43.73476000",
                        "longitude": "12.83396000"
                    },
                    {
                        "id": 140440,
                        "name": "Montefiore dell'Aso",
                        "latitude": "43.05276000",
                        "longitude": "13.75518000"
                    },
                    {
                        "id": 140446,
                        "name": "Montefortino",
                        "latitude": "42.94351000",
                        "longitude": "13.34417000"
                    },
                    {
                        "id": 140455,
                        "name": "Montegiorgio",
                        "latitude": "43.12988000",
                        "longitude": "13.53925000"
                    },
                    {
                        "id": 140456,
                        "name": "Montegranaro",
                        "latitude": "43.23099000",
                        "longitude": "13.63047000"
                    },
                    {
                        "id": 140463,
                        "name": "Montelabbate",
                        "latitude": "43.84732000",
                        "longitude": "12.78763000"
                    },
                    {
                        "id": 140470,
                        "name": "Monteleone di Fermo",
                        "latitude": "43.04785000",
                        "longitude": "13.52948000"
                    },
                    {
                        "id": 140479,
                        "name": "Montelparo",
                        "latitude": "43.01755000",
                        "longitude": "13.53698000"
                    },
                    {
                        "id": 140482,
                        "name": "Montelupone",
                        "latitude": "43.34270000",
                        "longitude": "13.57074000"
                    },
                    {
                        "id": 140484,
                        "name": "Montemaggiore al Metauro",
                        "latitude": "43.73666000",
                        "longitude": "12.94536000"
                    },
                    {
                        "id": 140488,
                        "name": "Montemarciano",
                        "latitude": "43.63847000",
                        "longitude": "13.30801000"
                    },
                    {
                        "id": 140497,
                        "name": "Montemonaco",
                        "latitude": "42.89871000",
                        "longitude": "13.33018000"
                    },
                    {
                        "id": 140509,
                        "name": "Monteprandone",
                        "latitude": "42.92050000",
                        "longitude": "13.83910000"
                    },
                    {
                        "id": 140512,
                        "name": "Monterado",
                        "latitude": "43.69686000",
                        "longitude": "13.09056000"
                    },
                    {
                        "id": 140528,
                        "name": "Monterubbiano",
                        "latitude": "43.08560000",
                        "longitude": "13.71911000"
                    },
                    {
                        "id": 140573,
                        "name": "Montignano-Marzocca",
                        "latitude": "43.67451000",
                        "longitude": "13.29093000"
                    },
                    {
                        "id": 140589,
                        "name": "Montottone",
                        "latitude": "43.06205000",
                        "longitude": "13.59009000"
                    },
                    {
                        "id": 140610,
                        "name": "Moresco",
                        "latitude": "43.08666000",
                        "longitude": "13.73041000"
                    },
                    {
                        "id": 140633,
                        "name": "Morro d'Alba",
                        "latitude": "43.60000000",
                        "longitude": "13.21331000"
                    },
                    {
                        "id": 140636,
                        "name": "Morrovalle",
                        "latitude": "43.31830000",
                        "longitude": "13.59535000"
                    },
                    {
                        "id": 140676,
                        "name": "Muccia",
                        "latitude": "43.08232000",
                        "longitude": "13.04323000"
                    },
                    {
                        "id": 140847,
                        "name": "Numana",
                        "latitude": "43.51136000",
                        "longitude": "13.62118000"
                    },
                    {
                        "id": 140875,
                        "name": "Offagna",
                        "latitude": "43.52588000",
                        "longitude": "13.44076000"
                    },
                    {
                        "id": 140877,
                        "name": "Offida",
                        "latitude": "42.93499000",
                        "longitude": "13.69773000"
                    },
                    {
                        "id": 140944,
                        "name": "Orciano di Pesaro",
                        "latitude": "43.68938000",
                        "longitude": "12.97206000"
                    },
                    {
                        "id": 140984,
                        "name": "Ortezzano",
                        "latitude": "43.03042000",
                        "longitude": "13.60531000"
                    },
                    {
                        "id": 141007,
                        "name": "Osimo",
                        "latitude": "43.48539000",
                        "longitude": "13.48222000"
                    },
                    {
                        "id": 141034,
                        "name": "Osteria",
                        "latitude": "43.54950000",
                        "longitude": "13.02188000"
                    },
                    {
                        "id": 141042,
                        "name": "Ostra",
                        "latitude": "43.61611000",
                        "longitude": "13.15849000"
                    },
                    {
                        "id": 141043,
                        "name": "Ostra Vetere",
                        "latitude": "43.60336000",
                        "longitude": "13.06150000"
                    },
                    {
                        "id": 141083,
                        "name": "Padiglione",
                        "latitude": "43.46900000",
                        "longitude": "13.46261000"
                    },
                    {
                        "id": 58206,
                        "name": "Pagliare",
                        "latitude": "42.86906000",
                        "longitude": "13.76906000"
                    },
                    {
                        "id": 58259,
                        "name": "Palmiano",
                        "latitude": "42.89946000",
                        "longitude": "13.45937000"
                    },
                    {
                        "id": 58333,
                        "name": "Passo di Treia",
                        "latitude": "43.28647000",
                        "longitude": "13.33246000"
                    },
                    {
                        "id": 58331,
                        "name": "Passo Ripe",
                        "latitude": "43.65567000",
                        "longitude": "13.12196000"
                    },
                    {
                        "id": 58376,
                        "name": "Pedaso",
                        "latitude": "43.09839000",
                        "longitude": "13.84083000"
                    },
                    {
                        "id": 58385,
                        "name": "Peglio",
                        "latitude": "43.69646000",
                        "longitude": "12.49785000"
                    },
                    {
                        "id": 58402,
                        "name": "Penna San Giovanni",
                        "latitude": "43.05608000",
                        "longitude": "13.42539000"
                    },
                    {
                        "id": 58424,
                        "name": "Pergola",
                        "latitude": "43.55485000",
                        "longitude": "12.83633000"
                    },
                    {
                        "id": 58447,
                        "name": "Pesaro",
                        "latitude": "43.90921000",
                        "longitude": "12.91640000"
                    },
                    {
                        "id": 58481,
                        "name": "Petriano",
                        "latitude": "43.77935000",
                        "longitude": "12.73214000"
                    },
                    {
                        "id": 58483,
                        "name": "Petriolo",
                        "latitude": "43.22141000",
                        "longitude": "13.46173000"
                    },
                    {
                        "id": 58484,
                        "name": "Petritoli",
                        "latitude": "43.06809000",
                        "longitude": "13.66385000"
                    },
                    {
                        "id": 58505,
                        "name": "Piagge",
                        "latitude": "43.73381000",
                        "longitude": "12.96851000"
                    },
                    {
                        "id": 58518,
                        "name": "Piandimeleto",
                        "latitude": "43.72320000",
                        "longitude": "12.40855000"
                    },
                    {
                        "id": 58519,
                        "name": "Piane",
                        "latitude": "43.09703000",
                        "longitude": "13.49502000"
                    },
                    {
                        "id": 58521,
                        "name": "Piane di Montegiorgio",
                        "latitude": "43.11587000",
                        "longitude": "13.56669000"
                    },
                    {
                        "id": 58522,
                        "name": "Piane di Morro",
                        "latitude": "42.82317000",
                        "longitude": "13.65300000"
                    },
                    {
                        "id": 58524,
                        "name": "Pianello",
                        "latitude": "43.62620000",
                        "longitude": "13.13068000"
                    },
                    {
                        "id": 58526,
                        "name": "Pianello Vallesina",
                        "latitude": "43.48817000",
                        "longitude": "13.16188000"
                    },
                    {
                        "id": 58559,
                        "name": "Piattoni-Villa Sant'Antonio",
                        "latitude": "42.86630000",
                        "longitude": "13.71120000"
                    },
                    {
                        "id": 58584,
                        "name": "Pie' del Colle",
                        "latitude": "43.02984000",
                        "longitude": "13.17535000"
                    },
                    {
                        "id": 58585,
                        "name": "Pie' del Sasso",
                        "latitude": "42.99429000",
                        "longitude": "12.99889000"
                    },
                    {
                        "id": 58594,
                        "name": "Piediripa",
                        "latitude": "43.27751000",
                        "longitude": "13.48712000"
                    },
                    {
                        "id": 58604,
                        "name": "Pietra la Croce",
                        "latitude": "43.60224000",
                        "longitude": "13.53887000"
                    },
                    {
                        "id": 58641,
                        "name": "Pieve Torina",
                        "latitude": "43.04299000",
                        "longitude": "13.04769000"
                    },
                    {
                        "id": 58656,
                        "name": "Pievebovigliana",
                        "latitude": "43.06287000",
                        "longitude": "13.08375000"
                    },
                    {
                        "id": 58681,
                        "name": "Pinocchio di Ancona",
                        "latitude": "43.58986000",
                        "longitude": "13.49413000"
                    },
                    {
                        "id": 58684,
                        "name": "Piobbico",
                        "latitude": "43.58819000",
                        "longitude": "12.50962000"
                    },
                    {
                        "id": 58693,
                        "name": "Pioraco",
                        "latitude": "43.18074000",
                        "longitude": "12.97676000"
                    },
                    {
                        "id": 58763,
                        "name": "Poggio San Marcello",
                        "latitude": "43.51116000",
                        "longitude": "13.07367000"
                    },
                    {
                        "id": 58764,
                        "name": "Poggio San Vicino",
                        "latitude": "43.37466000",
                        "longitude": "13.07964000"
                    },
                    {
                        "id": 58798,
                        "name": "Pollenza",
                        "latitude": "43.26595000",
                        "longitude": "13.34788000"
                    },
                    {
                        "id": 58806,
                        "name": "Polverigi",
                        "latitude": "43.52876000",
                        "longitude": "13.38294000"
                    },
                    {
                        "id": 58898,
                        "name": "Ponzano di Fermo",
                        "latitude": "43.10390000",
                        "longitude": "13.65979000"
                    },
                    {
                        "id": 58932,
                        "name": "Porto Potenza Picena",
                        "latitude": "43.35751000",
                        "longitude": "13.69746000"
                    },
                    {
                        "id": 58933,
                        "name": "Porto Recanati",
                        "latitude": "43.43296000",
                        "longitude": "13.66165000"
                    },
                    {
                        "id": 58934,
                        "name": "Porto San Giorgio",
                        "latitude": "43.17784000",
                        "longitude": "13.79411000"
                    },
                    {
                        "id": 58935,
                        "name": "Porto Sant'Elpidio",
                        "latitude": "43.25297000",
                        "longitude": "13.75970000"
                    },
                    {
                        "id": 58953,
                        "name": "Posatora",
                        "latitude": "43.59917000",
                        "longitude": "13.48984000"
                    },
                    {
                        "id": 58966,
                        "name": "Potenza Picena",
                        "latitude": "43.36635000",
                        "longitude": "13.62249000"
                    },
                    {
                        "id": 59101,
                        "name": "Province of Fermo",
                        "latitude": "43.16537000",
                        "longitude": "13.72424000"
                    },
                    {
                        "id": 59108,
                        "name": "Provincia di Ancona",
                        "latitude": "43.55000000",
                        "longitude": "13.16667000"
                    },
                    {
                        "id": 59109,
                        "name": "Provincia di Ascoli Piceno",
                        "latitude": "42.88443000",
                        "longitude": "13.55306000"
                    },
                    {
                        "id": 59146,
                        "name": "Provincia di Macerata",
                        "latitude": "43.20000000",
                        "longitude": "13.16667000"
                    },
                    {
                        "id": 59159,
                        "name": "Provincia di Pesaro e Urbino",
                        "latitude": "43.66667000",
                        "longitude": "12.63333000"
                    },
                    {
                        "id": 59283,
                        "name": "Rapagnano",
                        "latitude": "43.15985000",
                        "longitude": "13.58873000"
                    },
                    {
                        "id": 59310,
                        "name": "Recanati",
                        "latitude": "43.40381000",
                        "longitude": "13.55379000"
                    },
                    {
                        "id": 59388,
                        "name": "Rio Salso-Case Bernardi",
                        "latitude": "43.83439000",
                        "longitude": "12.69031000"
                    },
                    {
                        "id": 59408,
                        "name": "Ripatransone",
                        "latitude": "43.00015000",
                        "longitude": "13.76203000"
                    },
                    {
                        "id": 59409,
                        "name": "Ripe",
                        "latitude": "43.66906000",
                        "longitude": "13.10586000"
                    },
                    {
                        "id": 59410,
                        "name": "Ripe San Ginesio",
                        "latitude": "43.14202000",
                        "longitude": "13.36724000"
                    },
                    {
                        "id": 59630,
                        "name": "Rosciano",
                        "latitude": "43.81620000",
                        "longitude": "12.99992000"
                    },
                    {
                        "id": 59644,
                        "name": "Rosora",
                        "latitude": "43.48336000",
                        "longitude": "13.06819000"
                    },
                    {
                        "id": 59657,
                        "name": "Rotella",
                        "latitude": "42.95435000",
                        "longitude": "13.55849000"
                    },
                    {
                        "id": 59781,
                        "name": "Saltara",
                        "latitude": "43.75252000",
                        "longitude": "12.89853000"
                    },
                    {
                        "id": 59832,
                        "name": "San Benedetto del Tronto",
                        "latitude": "42.95680000",
                        "longitude": "13.87676000"
                    },
                    {
                        "id": 59840,
                        "name": "San Biagio",
                        "latitude": "43.51597000",
                        "longitude": "13.49643000"
                    },
                    {
                        "id": 59882,
                        "name": "San Costanzo",
                        "latitude": "43.76720000",
                        "longitude": "13.07306000"
                    },
                    {
                        "id": 59950,
                        "name": "San Ginesio",
                        "latitude": "43.10752000",
                        "longitude": "13.32121000"
                    },
                    {
                        "id": 59972,
                        "name": "San Giorgio di Pesaro",
                        "latitude": "43.72248000",
                        "longitude": "12.97969000"
                    },
                    {
                        "id": 60049,
                        "name": "San Lorenzo in Campo",
                        "latitude": "43.60149000",
                        "longitude": "12.94398000"
                    },
                    {
                        "id": 60058,
                        "name": "San Marcello",
                        "latitude": "43.57526000",
                        "longitude": "13.20827000"
                    },
                    {
                        "id": 60115,
                        "name": "San Michele",
                        "latitude": "43.66218000",
                        "longitude": "12.99797000"
                    },
                    {
                        "id": 60162,
                        "name": "San Paolo di Jesi",
                        "latitude": "43.45456000",
                        "longitude": "13.17277000"
                    },
                    {
                        "id": 60243,
                        "name": "San Severino Marche",
                        "latitude": "43.23028000",
                        "longitude": "13.17990000"
                    },
                    {
                        "id": 60256,
                        "name": "San Tommaso Tre Archi",
                        "latitude": "43.22771000",
                        "longitude": "13.77503000"
                    },
                    {
                        "id": 60289,
                        "name": "San Vittoria in Matenano",
                        "latitude": "43.01975000",
                        "longitude": "13.49618000"
                    },
                    {
                        "id": 60368,
                        "name": "Sant'Angelo in Lizzola",
                        "latitude": "43.82696000",
                        "longitude": "12.80076000"
                    },
                    {
                        "id": 60369,
                        "name": "Sant'Angelo in Pontano",
                        "latitude": "43.09780000",
                        "longitude": "13.39690000"
                    },
                    {
                        "id": 60370,
                        "name": "Sant'Angelo in Vado",
                        "latitude": "43.66526000",
                        "longitude": "12.41757000"
                    },
                    {
                        "id": 60399,
                        "name": "Sant'Elpidio a Mare",
                        "latitude": "43.23024000",
                        "longitude": "13.68819000"
                    },
                    {
                        "id": 60406,
                        "name": "Sant'Ippolito",
                        "latitude": "43.67972000",
                        "longitude": "12.87581000"
                    },
                    {
                        "id": 60458,
                        "name": "Santa Maria Apparente",
                        "latitude": "43.29661000",
                        "longitude": "13.69223000"
                    },
                    {
                        "id": 60469,
                        "name": "Santa Maria Nuova",
                        "latitude": "43.49164000",
                        "longitude": "13.32370000"
                    },
                    {
                        "id": 60552,
                        "name": "Sarnano",
                        "latitude": "43.03475000",
                        "longitude": "13.29818000"
                    },
                    {
                        "id": 60574,
                        "name": "Sassocorvaro",
                        "latitude": "43.78266000",
                        "longitude": "12.49910000"
                    },
                    {
                        "id": 60575,
                        "name": "Sassofeltrio",
                        "latitude": "43.89212000",
                        "longitude": "12.50974000"
                    },
                    {
                        "id": 60576,
                        "name": "Sassoferrato",
                        "latitude": "43.43109000",
                        "longitude": "12.85660000"
                    },
                    {
                        "id": 60686,
                        "name": "Sefro",
                        "latitude": "43.14743000",
                        "longitude": "12.94859000"
                    },
                    {
                        "id": 60724,
                        "name": "Senigallia",
                        "latitude": "43.71626000",
                        "longitude": "13.20882000"
                    },
                    {
                        "id": 60756,
                        "name": "Serra de' Conti",
                        "latitude": "43.54196000",
                        "longitude": "13.03566000"
                    },
                    {
                        "id": 60753,
                        "name": "Serra San Quirico",
                        "latitude": "43.44637000",
                        "longitude": "13.02266000"
                    },
                    {
                        "id": 60754,
                        "name": "Serra Sant'Abbondio",
                        "latitude": "43.49155000",
                        "longitude": "12.77409000"
                    },
                    {
                        "id": 60767,
                        "name": "Serrapetrona",
                        "latitude": "43.17671000",
                        "longitude": "13.18981000"
                    },
                    {
                        "id": 60777,
                        "name": "Serravalle di Chienti",
                        "latitude": "43.07185000",
                        "longitude": "12.95217000"
                    },
                    {
                        "id": 60784,
                        "name": "Serrungarina",
                        "latitude": "43.74666000",
                        "longitude": "12.87486000"
                    },
                    {
                        "id": 60786,
                        "name": "Servigliano",
                        "latitude": "43.07993000",
                        "longitude": "13.49268000"
                    },
                    {
                        "id": 60829,
                        "name": "Sforzacosta",
                        "latitude": "43.25676000",
                        "longitude": "13.42284000"
                    },
                    {
                        "id": 60875,
                        "name": "Sirolo",
                        "latitude": "43.52246000",
                        "longitude": "13.61498000"
                    },
                    {
                        "id": 60889,
                        "name": "Smerillo",
                        "latitude": "43.00515000",
                        "longitude": "13.44498000"
                    },
                    {
                        "id": 61019,
                        "name": "Spinetoli",
                        "latitude": "42.88984000",
                        "longitude": "13.76497000"
                    },
                    {
                        "id": 61039,
                        "name": "Staffolo",
                        "latitude": "43.43326000",
                        "longitude": "13.18487000"
                    },
                    {
                        "id": 61051,
                        "name": "Stazione",
                        "latitude": "43.50046000",
                        "longitude": "13.15149000"
                    },
                    {
                        "id": 61061,
                        "name": "Stella",
                        "latitude": "42.88698000",
                        "longitude": "13.80948000"
                    },
                    {
                        "id": 61084,
                        "name": "Strada",
                        "latitude": "43.40337000",
                        "longitude": "13.22077000"
                    },
                    {
                        "id": 61188,
                        "name": "Tavernelle",
                        "latitude": "43.73203000",
                        "longitude": "12.88349000"
                    },
                    {
                        "id": 61196,
                        "name": "Tavoleto",
                        "latitude": "43.84402000",
                        "longitude": "12.59418000"
                    },
                    {
                        "id": 61197,
                        "name": "Tavullia",
                        "latitude": "43.89791000",
                        "longitude": "12.75108000"
                    },
                    {
                        "id": 61298,
                        "name": "Tolentino",
                        "latitude": "43.20918000",
                        "longitude": "13.28524000"
                    },
                    {
                        "id": 61362,
                        "name": "Torre San Patrizio",
                        "latitude": "43.18311000",
                        "longitude": "13.61113000"
                    },
                    {
                        "id": 61459,
                        "name": "Trebbio",
                        "latitude": "43.03685000",
                        "longitude": "13.15394000"
                    },
                    {
                        "id": 61475,
                        "name": "Treia",
                        "latitude": "43.30850000",
                        "longitude": "13.31036000"
                    },
                    {
                        "id": 61547,
                        "name": "Trodica",
                        "latitude": "43.27458000",
                        "longitude": "13.59369000"
                    },
                    {
                        "id": 61557,
                        "name": "Troviggiano",
                        "latitude": "43.37868000",
                        "longitude": "13.25022000"
                    },
                    {
                        "id": 61602,
                        "name": "Urbania",
                        "latitude": "43.66832000",
                        "longitude": "12.52093000"
                    },
                    {
                        "id": 61604,
                        "name": "Urbino",
                        "latitude": "43.72621000",
                        "longitude": "12.63633000"
                    },
                    {
                        "id": 61605,
                        "name": "Urbisaglia",
                        "latitude": "43.19304000",
                        "longitude": "13.37474000"
                    },
                    {
                        "id": 61700,
                        "name": "Valle e Castello",
                        "latitude": "43.03740000",
                        "longitude": "13.08742000"
                    },
                    {
                        "id": 61810,
                        "name": "Venarotta",
                        "latitude": "42.88266000",
                        "longitude": "13.49157000"
                    },
                    {
                        "id": 61991,
                        "name": "Villa Ceccolini",
                        "latitude": "43.86481000",
                        "longitude": "12.83605000"
                    },
                    {
                        "id": 62006,
                        "name": "Villa Musone",
                        "latitude": "43.44624000",
                        "longitude": "13.60312000"
                    },
                    {
                        "id": 62009,
                        "name": "Villa Pigna",
                        "latitude": "42.83324000",
                        "longitude": "13.63446000"
                    },
                    {
                        "id": 62011,
                        "name": "Villa Potenza",
                        "latitude": "43.32149000",
                        "longitude": "13.42649000"
                    },
                    {
                        "id": 62016,
                        "name": "Villa San Filippo",
                        "latitude": "43.25981000",
                        "longitude": "13.59337000"
                    },
                    {
                        "id": 62019,
                        "name": "Villa San Giuseppe",
                        "latitude": "42.86862000",
                        "longitude": "13.74481000"
                    },
                    {
                        "id": 62070,
                        "name": "Villagrande",
                        "latitude": "43.84136000",
                        "longitude": "12.35994000"
                    },
                    {
                        "id": 62092,
                        "name": "Villanova",
                        "latitude": "43.73926000",
                        "longitude": "12.93529000"
                    },
                    {
                        "id": 62175,
                        "name": "Visso",
                        "latitude": "42.93351000",
                        "longitude": "13.08051000"
                    },
                    {
                        "id": 62271,
                        "name": "Zona Industriale",
                        "latitude": "43.26155000",
                        "longitude": "13.48834000"
                    }
                ]
            },
            {
                "id": 1759,
                "name": "Massa and Carrara",
                "iso2": "MS",
                "latitude": "44.22139980",
                "longitude": "10.03596610",
                "type": "province",
                "cities": []
            },
            {
                "id": 1760,
                "name": "Matera",
                "iso2": "MT",
                "latitude": "40.66634960",
                "longitude": "16.60436360",
                "type": "province",
                "cities": []
            },
            {
                "id": 1757,
                "name": "Modena",
                "iso2": "MO",
                "latitude": "44.55137990",
                "longitude": "10.91804800",
                "type": "province",
                "cities": []
            },
            {
                "id": 1695,
                "name": "Molise",
                "iso2": "67",
                "latitude": "41.71613920",
                "longitude": "13.89328530",
                "type": "region",
                "cities": [
                    {
                        "id": 135277,
                        "name": "Acquaviva Collecroce",
                        "latitude": "41.86624000",
                        "longitude": "14.74733000"
                    },
                    {
                        "id": 135280,
                        "name": "Acquaviva d'Isernia",
                        "latitude": "41.67132000",
                        "longitude": "14.14770000"
                    },
                    {
                        "id": 135310,
                        "name": "Agnone",
                        "latitude": "41.81043000",
                        "longitude": "14.37524000"
                    },
                    {
                        "id": 135764,
                        "name": "Bagnoli del Trigno",
                        "latitude": "41.70217000",
                        "longitude": "14.45861000"
                    },
                    {
                        "id": 135811,
                        "name": "Baranello",
                        "latitude": "41.52722000",
                        "longitude": "14.55800000"
                    },
                    {
                        "id": 135955,
                        "name": "Belmonte del Sannio",
                        "latitude": "41.82352000",
                        "longitude": "14.42333000"
                    },
                    {
                        "id": 136099,
                        "name": "Bojano",
                        "latitude": "41.48530000",
                        "longitude": "14.47075000"
                    },
                    {
                        "id": 136135,
                        "name": "Bonefro",
                        "latitude": "41.70507000",
                        "longitude": "14.93439000"
                    },
                    {
                        "id": 136431,
                        "name": "Busso",
                        "latitude": "41.55413000",
                        "longitude": "14.56103000"
                    },
                    {
                        "id": 136638,
                        "name": "Campobasso",
                        "latitude": "41.55947000",
                        "longitude": "14.66737000"
                    },
                    {
                        "id": 136642,
                        "name": "Campochiaro",
                        "latitude": "41.44827000",
                        "longitude": "14.50828000"
                    },
                    {
                        "id": 136647,
                        "name": "Campodipietra",
                        "latitude": "41.55740000",
                        "longitude": "14.74445000"
                    },
                    {
                        "id": 136662,
                        "name": "Campolieto",
                        "latitude": "41.63336000",
                        "longitude": "14.76694000"
                    },
                    {
                        "id": 136668,
                        "name": "Campomarino",
                        "latitude": "41.95692000",
                        "longitude": "15.03546000"
                    },
                    {
                        "id": 136744,
                        "name": "Cantalupo nel Sannio",
                        "latitude": "41.52182000",
                        "longitude": "14.39292000"
                    },
                    {
                        "id": 136797,
                        "name": "Capracotta",
                        "latitude": "41.83326000",
                        "longitude": "14.26581000"
                    },
                    {
                        "id": 136905,
                        "name": "Carovilli",
                        "latitude": "41.71348000",
                        "longitude": "14.29403000"
                    },
                    {
                        "id": 136922,
                        "name": "Carpinone",
                        "latitude": "41.59003000",
                        "longitude": "14.32436000"
                    },
                    {
                        "id": 136953,
                        "name": "Casacalenda",
                        "latitude": "41.73824000",
                        "longitude": "14.84734000"
                    },
                    {
                        "id": 136970,
                        "name": "Casalciprano",
                        "latitude": "41.58037000",
                        "longitude": "14.52835000"
                    },
                    {
                        "id": 137164,
                        "name": "Castel del Giudice",
                        "latitude": "41.85488000",
                        "longitude": "14.23155000"
                    },
                    {
                        "id": 137156,
                        "name": "Castel San Vincenzo",
                        "latitude": "41.65543000",
                        "longitude": "14.06178000"
                    },
                    {
                        "id": 137182,
                        "name": "Castelbottaccio",
                        "latitude": "41.75329000",
                        "longitude": "14.70616000"
                    },
                    {
                        "id": 137249,
                        "name": "Castellino del Biferno",
                        "latitude": "41.70160000",
                        "longitude": "14.73179000"
                    },
                    {
                        "id": 137272,
                        "name": "Castelmauro",
                        "latitude": "41.82846000",
                        "longitude": "14.71066000"
                    },
                    {
                        "id": 137306,
                        "name": "Castelpetroso",
                        "latitude": "41.56027000",
                        "longitude": "14.34637000"
                    },
                    {
                        "id": 137307,
                        "name": "Castelpizzuto",
                        "latitude": "41.52128000",
                        "longitude": "14.29205000"
                    },
                    {
                        "id": 137326,
                        "name": "Castelverrino",
                        "latitude": "41.76713000",
                        "longitude": "14.39756000"
                    },
                    {
                        "id": 137386,
                        "name": "Castropignano",
                        "latitude": "41.61788000",
                        "longitude": "14.55856000"
                    },
                    {
                        "id": 137521,
                        "name": "Cercemaggiore",
                        "latitude": "41.46130000",
                        "longitude": "14.72402000"
                    },
                    {
                        "id": 137523,
                        "name": "Cercepiccola",
                        "latitude": "41.45982000",
                        "longitude": "14.66487000"
                    },
                    {
                        "id": 137576,
                        "name": "Cerro al Volturno",
                        "latitude": "41.65418000",
                        "longitude": "14.10321000"
                    },
                    {
                        "id": 137657,
                        "name": "Chiauci",
                        "latitude": "41.67791000",
                        "longitude": "14.38393000"
                    },
                    {
                        "id": 137788,
                        "name": "Civitacampomarano",
                        "latitude": "41.78032000",
                        "longitude": "14.68919000"
                    },
                    {
                        "id": 137792,
                        "name": "Civitanova del Sannio",
                        "latitude": "41.66829000",
                        "longitude": "14.40285000"
                    },
                    {
                        "id": 137869,
                        "name": "Colle d'Anchise",
                        "latitude": "41.50986000",
                        "longitude": "14.51873000"
                    },
                    {
                        "id": 137895,
                        "name": "Colletorto",
                        "latitude": "41.66165000",
                        "longitude": "14.96773000"
                    },
                    {
                        "id": 137898,
                        "name": "Colli a Volturno",
                        "latitude": "41.60039000",
                        "longitude": "14.10301000"
                    },
                    {
                        "id": 137953,
                        "name": "Conca Casale",
                        "latitude": "41.49512000",
                        "longitude": "14.00682000"
                    },
                    {
                        "id": 138346,
                        "name": "Duronia",
                        "latitude": "41.65786000",
                        "longitude": "14.46015000"
                    },
                    {
                        "id": 138491,
                        "name": "Ferrazzano",
                        "latitude": "41.53033000",
                        "longitude": "14.67223000"
                    },
                    {
                        "id": 138531,
                        "name": "Filignano",
                        "latitude": "41.54578000",
                        "longitude": "14.05757000"
                    },
                    {
                        "id": 138633,
                        "name": "Forlì del Sannio",
                        "latitude": "41.69593000",
                        "longitude": "14.17952000"
                    },
                    {
                        "id": 138652,
                        "name": "Fornelli",
                        "latitude": "41.60678000",
                        "longitude": "14.14041000"
                    },
                    {
                        "id": 138672,
                        "name": "Fossalto",
                        "latitude": "41.67293000",
                        "longitude": "14.54573000"
                    },
                    {
                        "id": 138742,
                        "name": "Frosolone",
                        "latitude": "41.60006000",
                        "longitude": "14.44578000"
                    },
                    {
                        "id": 138830,
                        "name": "Gambatesa",
                        "latitude": "41.50861000",
                        "longitude": "14.91240000"
                    },
                    {
                        "id": 138961,
                        "name": "Gildone",
                        "latitude": "41.50901000",
                        "longitude": "14.74020000"
                    },
                    {
                        "id": 139164,
                        "name": "Guardialfiera",
                        "latitude": "41.80423000",
                        "longitude": "14.79293000"
                    },
                    {
                        "id": 139165,
                        "name": "Guardiaregia",
                        "latitude": "41.43436000",
                        "longitude": "14.54344000"
                    },
                    {
                        "id": 139175,
                        "name": "Guglionesi",
                        "latitude": "41.92093000",
                        "longitude": "14.91600000"
                    },
                    {
                        "id": 139233,
                        "name": "Isernia",
                        "latitude": "41.59603000",
                        "longitude": "14.23399000"
                    },
                    {
                        "id": 139274,
                        "name": "Jelsi",
                        "latitude": "41.51704000",
                        "longitude": "14.79790000"
                    },
                    {
                        "id": 139376,
                        "name": "Larino",
                        "latitude": "41.80449000",
                        "longitude": "14.91843000"
                    },
                    {
                        "id": 139527,
                        "name": "Limosano",
                        "latitude": "41.67554000",
                        "longitude": "14.62230000"
                    },
                    {
                        "id": 139588,
                        "name": "Longano",
                        "latitude": "41.52199000",
                        "longitude": "14.24665000"
                    },
                    {
                        "id": 139636,
                        "name": "Lucito",
                        "latitude": "41.73193000",
                        "longitude": "14.68723000"
                    },
                    {
                        "id": 139664,
                        "name": "Lupara",
                        "latitude": "41.76141000",
                        "longitude": "14.73390000"
                    },
                    {
                        "id": 139692,
                        "name": "Macchia d'Isernia",
                        "latitude": "41.56057000",
                        "longitude": "14.17015000"
                    },
                    {
                        "id": 139691,
                        "name": "Macchia Valfortore",
                        "latitude": "41.59487000",
                        "longitude": "14.91238000"
                    },
                    {
                        "id": 139693,
                        "name": "Macchiagodena",
                        "latitude": "41.55899000",
                        "longitude": "14.41049000"
                    },
                    {
                        "id": 139715,
                        "name": "Mafalda",
                        "latitude": "41.94308000",
                        "longitude": "14.71610000"
                    },
                    {
                        "id": 139998,
                        "name": "Matrice",
                        "latitude": "41.61878000",
                        "longitude": "14.70977000"
                    },
                    {
                        "id": 140155,
                        "name": "Mimosa-Poggio Verde-Nuova Comunità",
                        "latitude": "41.53871000",
                        "longitude": "14.66879000"
                    },
                    {
                        "id": 140171,
                        "name": "Mirabello Sannitico",
                        "latitude": "41.51628000",
                        "longitude": "14.67315000"
                    },
                    {
                        "id": 140173,
                        "name": "Miranda",
                        "latitude": "41.64434000",
                        "longitude": "14.24643000"
                    },
                    {
                        "id": 140227,
                        "name": "Molise",
                        "latitude": "41.63147000",
                        "longitude": "14.49252000"
                    },
                    {
                        "id": 140248,
                        "name": "Monacilioni",
                        "latitude": "41.61077000",
                        "longitude": "14.81000000"
                    },
                    {
                        "id": 140307,
                        "name": "Montagano",
                        "latitude": "41.64538000",
                        "longitude": "14.67405000"
                    },
                    {
                        "id": 140346,
                        "name": "Montaquila",
                        "latitude": "41.56502000",
                        "longitude": "14.11333000"
                    },
                    {
                        "id": 140418,
                        "name": "Montecilfone",
                        "latitude": "41.90163000",
                        "longitude": "14.83680000"
                    },
                    {
                        "id": 140433,
                        "name": "Montefalcone nel Sannio",
                        "latitude": "41.86663000",
                        "longitude": "14.63823000"
                    },
                    {
                        "id": 140478,
                        "name": "Montelongo",
                        "latitude": "41.73705000",
                        "longitude": "14.95034000"
                    },
                    {
                        "id": 140496,
                        "name": "Montemitro",
                        "latitude": "41.88813000",
                        "longitude": "14.64666000"
                    },
                    {
                        "id": 140503,
                        "name": "Montenero di Bisaccia",
                        "latitude": "41.96437000",
                        "longitude": "14.78103000"
                    },
                    {
                        "id": 140502,
                        "name": "Montenero Val Cocchiara",
                        "latitude": "41.71683000",
                        "longitude": "14.06941000"
                    },
                    {
                        "id": 140518,
                        "name": "Monteroduni",
                        "latitude": "41.52240000",
                        "longitude": "14.17641000"
                    },
                    {
                        "id": 140584,
                        "name": "Montorio Nei Frentani",
                        "latitude": "41.75884000",
                        "longitude": "14.93314000"
                    },
                    {
                        "id": 140635,
                        "name": "Morrone del Sannio",
                        "latitude": "41.71107000",
                        "longitude": "14.78087000"
                    },
                    {
                        "id": 140938,
                        "name": "Oratino",
                        "latitude": "41.58598000",
                        "longitude": "14.59463000"
                    },
                    {
                        "id": 58224,
                        "name": "Palata",
                        "latitude": "41.88790000",
                        "longitude": "14.78778000"
                    },
                    {
                        "id": 58454,
                        "name": "Pesche",
                        "latitude": "41.60552000",
                        "longitude": "14.27620000"
                    },
                    {
                        "id": 58462,
                        "name": "Pescolanciano",
                        "latitude": "41.67972000",
                        "longitude": "14.33658000"
                    },
                    {
                        "id": 58464,
                        "name": "Pescopennataro",
                        "latitude": "41.87777000",
                        "longitude": "14.29398000"
                    },
                    {
                        "id": 58473,
                        "name": "Petacciato",
                        "latitude": "42.00827000",
                        "longitude": "14.86026000"
                    },
                    {
                        "id": 58480,
                        "name": "Petrella Tifernina",
                        "latitude": "41.69135000",
                        "longitude": "14.69751000"
                    },
                    {
                        "id": 58492,
                        "name": "Pettoranello del Molise",
                        "latitude": "41.57331000",
                        "longitude": "14.27839000"
                    },
                    {
                        "id": 58605,
                        "name": "Pietrabbondante",
                        "latitude": "41.74527000",
                        "longitude": "14.38480000"
                    },
                    {
                        "id": 58608,
                        "name": "Pietracatella",
                        "latitude": "41.58064000",
                        "longitude": "14.87298000"
                    },
                    {
                        "id": 58609,
                        "name": "Pietracupa",
                        "latitude": "41.68253000",
                        "longitude": "14.51933000"
                    },
                    {
                        "id": 58729,
                        "name": "Pizzone",
                        "latitude": "41.67332000",
                        "longitude": "14.03666000"
                    },
                    {
                        "id": 58765,
                        "name": "Poggio Sannita",
                        "latitude": "41.77939000",
                        "longitude": "14.41485000"
                    },
                    {
                        "id": 58943,
                        "name": "Portocannone",
                        "latitude": "41.91441000",
                        "longitude": "15.00845000"
                    },
                    {
                        "id": 58980,
                        "name": "Pozzilli",
                        "latitude": "41.51142000",
                        "longitude": "14.06252000"
                    },
                    {
                        "id": 59121,
                        "name": "Provincia di Campobasso",
                        "latitude": "41.70070000",
                        "longitude": "14.75848000"
                    },
                    {
                        "id": 59138,
                        "name": "Provincia di Isernia",
                        "latitude": "41.66667000",
                        "longitude": "14.25000000"
                    },
                    {
                        "id": 59191,
                        "name": "Provvidenti",
                        "latitude": "41.71795000",
                        "longitude": "14.82349000"
                    },
                    {
                        "id": 59365,
                        "name": "Riccia",
                        "latitude": "41.48314000",
                        "longitude": "14.83181000"
                    },
                    {
                        "id": 59396,
                        "name": "Rionero Sannitico",
                        "latitude": "41.71219000",
                        "longitude": "14.13917000"
                    },
                    {
                        "id": 59401,
                        "name": "Ripabottoni",
                        "latitude": "41.68996000",
                        "longitude": "14.80866000"
                    },
                    {
                        "id": 59403,
                        "name": "Ripalimosani",
                        "latitude": "41.61064000",
                        "longitude": "14.66306000"
                    },
                    {
                        "id": 59507,
                        "name": "Roccamandolfi",
                        "latitude": "41.49583000",
                        "longitude": "14.35217000"
                    },
                    {
                        "id": 59522,
                        "name": "Roccasicura",
                        "latitude": "41.69676000",
                        "longitude": "14.23065000"
                    },
                    {
                        "id": 59530,
                        "name": "Roccavivara",
                        "latitude": "41.83336000",
                        "longitude": "14.60013000"
                    },
                    {
                        "id": 59543,
                        "name": "Rocchetta a Volturno",
                        "latitude": "41.62582000",
                        "longitude": "14.08902000"
                    },
                    {
                        "id": 59539,
                        "name": "Rocchetta Nuova",
                        "latitude": "41.62375000",
                        "longitude": "14.08574000"
                    },
                    {
                        "id": 59658,
                        "name": "Rotello",
                        "latitude": "41.74776000",
                        "longitude": "15.00608000"
                    },
                    {
                        "id": 59753,
                        "name": "Salcito",
                        "latitude": "41.74640000",
                        "longitude": "14.51085000"
                    },
                    {
                        "id": 59845,
                        "name": "San Biase",
                        "latitude": "41.71526000",
                        "longitude": "14.59049000"
                    },
                    {
                        "id": 59911,
                        "name": "San Felice del Molise",
                        "latitude": "41.89000000",
                        "longitude": "14.70088000"
                    },
                    {
                        "id": 59946,
                        "name": "San Giacomo degli Schiavoni",
                        "latitude": "41.96234000",
                        "longitude": "14.94481000"
                    },
                    {
                        "id": 59998,
                        "name": "San Giovanni in Galdo",
                        "latitude": "41.59110000",
                        "longitude": "14.75202000"
                    },
                    {
                        "id": 60007,
                        "name": "San Giuliano del Sannio",
                        "latitude": "41.45752000",
                        "longitude": "14.64169000"
                    },
                    {
                        "id": 60008,
                        "name": "San Giuliano di Puglia",
                        "latitude": "41.68796000",
                        "longitude": "14.96231000"
                    },
                    {
                        "id": 60093,
                        "name": "San Martino in Pensilis",
                        "latitude": "41.87814000",
                        "longitude": "15.01824000"
                    },
                    {
                        "id": 60101,
                        "name": "San Massimo",
                        "latitude": "41.49292000",
                        "longitude": "14.41023000"
                    },
                    {
                        "id": 60174,
                        "name": "San Pietro Avellana",
                        "latitude": "41.78886000",
                        "longitude": "14.18323000"
                    },
                    {
                        "id": 60208,
                        "name": "San Polomatese",
                        "latitude": "41.45932000",
                        "longitude": "14.49343000"
                    },
                    {
                        "id": 60314,
                        "name": "Sant'Agapito",
                        "latitude": "41.54372000",
                        "longitude": "14.22204000"
                    },
                    {
                        "id": 60364,
                        "name": "Sant'Angelo del Pesco",
                        "latitude": "41.88193000",
                        "longitude": "14.25354000"
                    },
                    {
                        "id": 60357,
                        "name": "Sant'Angelo Limosano",
                        "latitude": "41.69266000",
                        "longitude": "14.60346000"
                    },
                    {
                        "id": 60395,
                        "name": "Sant'Elena Sannita",
                        "latitude": "41.57525000",
                        "longitude": "14.47070000"
                    },
                    {
                        "id": 60398,
                        "name": "Sant'Elia a Pianisi",
                        "latitude": "41.62043000",
                        "longitude": "14.87523000"
                    },
                    {
                        "id": 60429,
                        "name": "Santa Croce di Magliano",
                        "latitude": "41.71223000",
                        "longitude": "14.98732000"
                    },
                    {
                        "id": 60474,
                        "name": "Santa Maria del Molise",
                        "latitude": "41.55285000",
                        "longitude": "14.36762000"
                    },
                    {
                        "id": 60628,
                        "name": "Scapoli",
                        "latitude": "41.61447000",
                        "longitude": "14.05929000"
                    },
                    {
                        "id": 60732,
                        "name": "Sepino",
                        "latitude": "41.40782000",
                        "longitude": "14.61938000"
                    },
                    {
                        "id": 60791,
                        "name": "Sessano del Molise",
                        "latitude": "41.63926000",
                        "longitude": "14.32779000"
                    },
                    {
                        "id": 60796,
                        "name": "Sesto Campano",
                        "latitude": "41.42042000",
                        "longitude": "14.07782000"
                    },
                    {
                        "id": 61017,
                        "name": "Spinete",
                        "latitude": "41.54431000",
                        "longitude": "14.48743000"
                    },
                    {
                        "id": 61183,
                        "name": "Tavenna",
                        "latitude": "41.90898000",
                        "longitude": "14.76176000"
                    },
                    {
                        "id": 61185,
                        "name": "Taverna Ravindola",
                        "latitude": "41.52283000",
                        "longitude": "14.12591000"
                    },
                    {
                        "id": 61229,
                        "name": "Termoli",
                        "latitude": "41.99994000",
                        "longitude": "14.99389000"
                    },
                    {
                        "id": 61325,
                        "name": "Torella del Sannio",
                        "latitude": "41.63878000",
                        "longitude": "14.52031000"
                    },
                    {
                        "id": 61339,
                        "name": "Toro",
                        "latitude": "41.57313000",
                        "longitude": "14.76183000"
                    },
                    {
                        "id": 61539,
                        "name": "Trivento",
                        "latitude": "41.77004000",
                        "longitude": "14.54613000"
                    },
                    {
                        "id": 61562,
                        "name": "Tufara",
                        "latitude": "41.48203000",
                        "longitude": "14.94654000"
                    },
                    {
                        "id": 61608,
                        "name": "Ururi",
                        "latitude": "41.81518000",
                        "longitude": "15.01611000"
                    },
                    {
                        "id": 61782,
                        "name": "Vastogirardi",
                        "latitude": "41.77460000",
                        "longitude": "14.25844000"
                    },
                    {
                        "id": 61808,
                        "name": "Venafro",
                        "latitude": "41.48275000",
                        "longitude": "14.04773000"
                    },
                    {
                        "id": 62161,
                        "name": "Vinchiaturo",
                        "latitude": "41.49282000",
                        "longitude": "14.59200000"
                    }
                ]
            },
            {
                "id": 1769,
                "name": "Monza and Brianza",
                "iso2": "MB",
                "latitude": "45.62359900",
                "longitude": "9.25880150",
                "type": "province",
                "cities": []
            },
            {
                "id": 1774,
                "name": "Novara",
                "iso2": "NO",
                "latitude": "45.54851330",
                "longitude": "8.51507930",
                "type": "province",
                "cities": []
            },
            {
                "id": 1790,
                "name": "Nuoro",
                "iso2": "NU",
                "latitude": "40.32869040",
                "longitude": "9.45615500",
                "type": "province",
                "cities": []
            },
            {
                "id": 1786,
                "name": "Oristano",
                "iso2": "OR",
                "latitude": "40.05990680",
                "longitude": "8.74811670",
                "type": "province",
                "cities": []
            },
            {
                "id": 1665,
                "name": "Padua",
                "iso2": "PD",
                "latitude": "45.36618640",
                "longitude": "11.82091390",
                "type": "province",
                "cities": []
            },
            {
                "id": 1668,
                "name": "Palermo",
                "iso2": "PA",
                "latitude": "38.11569000",
                "longitude": "13.36148680",
                "type": "metropolitan city",
                "cities": []
            },
            {
                "id": 1666,
                "name": "Parma",
                "iso2": "PR",
                "latitude": "44.80153220",
                "longitude": "10.32793540",
                "type": "province",
                "cities": []
            },
            {
                "id": 1676,
                "name": "Pavia",
                "iso2": "PV",
                "latitude": "45.32181660",
                "longitude": "8.84662360",
                "type": "province",
                "cities": []
            },
            {
                "id": 1691,
                "name": "Perugia",
                "iso2": "PG",
                "latitude": "43.10154190",
                "longitude": "11.27192500",
                "type": "province",
                "cities": []
            },
            {
                "id": 1693,
                "name": "Pesaro and Urbino",
                "iso2": "PU",
                "latitude": "43.61301180",
                "longitude": "12.71351210",
                "type": "province",
                "cities": []
            },
            {
                "id": 1694,
                "name": "Pescara",
                "iso2": "PE",
                "latitude": "42.35706550",
                "longitude": "13.96080910",
                "type": "province",
                "cities": []
            },
            {
                "id": 1696,
                "name": "Piacenza",
                "iso2": "PC",
                "latitude": "44.82631120",
                "longitude": "9.52914470",
                "type": "province",
                "cities": []
            },
            {
                "id": 1702,
                "name": "Piedmont",
                "iso2": "21",
                "latitude": "45.05223660",
                "longitude": "7.51538850",
                "type": "region",
                "cities": [
                    {
                        "id": 135248,
                        "name": "Acceglio",
                        "latitude": "44.47463000",
                        "longitude": "6.99092000"
                    },
                    {
                        "id": 135283,
                        "name": "Acqui Terme",
                        "latitude": "44.67552000",
                        "longitude": "8.46934000"
                    },
                    {
                        "id": 135303,
                        "name": "Agliano",
                        "latitude": "44.79164000",
                        "longitude": "8.25124000"
                    },
                    {
                        "id": 135304,
                        "name": "Agliano Terme",
                        "latitude": "44.79025000",
                        "longitude": "8.25044000"
                    },
                    {
                        "id": 135306,
                        "name": "Agliè",
                        "latitude": "45.36800000",
                        "longitude": "7.76800000"
                    },
                    {
                        "id": 135315,
                        "name": "Agrate",
                        "latitude": "45.67540000",
                        "longitude": "8.56065000"
                    },
                    {
                        "id": 135317,
                        "name": "Agrate Conturbia",
                        "latitude": "45.67547000",
                        "longitude": "8.55973000"
                    },
                    {
                        "id": 135331,
                        "name": "Ailoche",
                        "latitude": "45.69812000",
                        "longitude": "8.22133000"
                    },
                    {
                        "id": 135332,
                        "name": "Airali",
                        "latitude": "44.81670000",
                        "longitude": "7.25157000"
                    },
                    {
                        "id": 135333,
                        "name": "Airasca",
                        "latitude": "44.91719000",
                        "longitude": "7.48322000"
                    },
                    {
                        "id": 135337,
                        "name": "Aisone",
                        "latitude": "44.31392000",
                        "longitude": "7.21963000"
                    },
                    {
                        "id": 135339,
                        "name": "Ala di Stura",
                        "latitude": "45.31492000",
                        "longitude": "7.30345000"
                    },
                    {
                        "id": 135341,
                        "name": "Alagna Valsesia",
                        "latitude": "45.85182000",
                        "longitude": "7.93752000"
                    },
                    {
                        "id": 135346,
                        "name": "Alba",
                        "latitude": "44.69990000",
                        "longitude": "8.03470000"
                    },
                    {
                        "id": 135353,
                        "name": "Albano Vercellese",
                        "latitude": "45.42616000",
                        "longitude": "8.38093000"
                    },
                    {
                        "id": 135360,
                        "name": "Albaretto della Torre",
                        "latitude": "44.59624000",
                        "longitude": "8.06464000"
                    },
                    {
                        "id": 135363,
                        "name": "Albera Ligure",
                        "latitude": "44.70159000",
                        "longitude": "9.06720000"
                    },
                    {
                        "id": 135372,
                        "name": "Albiano d'Ivrea",
                        "latitude": "45.43424000",
                        "longitude": "7.94789000"
                    },
                    {
                        "id": 135387,
                        "name": "Albugnano",
                        "latitude": "45.07755000",
                        "longitude": "7.97113000"
                    },
                    {
                        "id": 135394,
                        "name": "Alessandria",
                        "latitude": "44.90924000",
                        "longitude": "8.61007000"
                    },
                    {
                        "id": 135402,
                        "name": "Alfiano Natta",
                        "latitude": "45.04860000",
                        "longitude": "8.20730000"
                    },
                    {
                        "id": 135408,
                        "name": "Alice Bel Colle",
                        "latitude": "44.72605000",
                        "longitude": "8.45074000"
                    },
                    {
                        "id": 135409,
                        "name": "Alice Castello",
                        "latitude": "45.36860000",
                        "longitude": "8.07320000"
                    },
                    {
                        "id": 135410,
                        "name": "Alice Superiore",
                        "latitude": "45.46066000",
                        "longitude": "7.77922000"
                    },
                    {
                        "id": 135422,
                        "name": "Almese-Rivera",
                        "latitude": "45.11915000",
                        "longitude": "7.40111000"
                    },
                    {
                        "id": 135425,
                        "name": "Alpette",
                        "latitude": "45.40917000",
                        "longitude": "7.57795000"
                    },
                    {
                        "id": 135426,
                        "name": "Alpignano",
                        "latitude": "45.09346000",
                        "longitude": "7.52392000"
                    },
                    {
                        "id": 135434,
                        "name": "Altavilla Monferrato",
                        "latitude": "44.99355000",
                        "longitude": "8.37594000"
                    },
                    {
                        "id": 135443,
                        "name": "Alto",
                        "latitude": "44.10863000",
                        "longitude": "8.00215000"
                    },
                    {
                        "id": 135451,
                        "name": "Alzano Scrivia",
                        "latitude": "45.01806000",
                        "longitude": "8.88065000"
                    },
                    {
                        "id": 135470,
                        "name": "Ameno",
                        "latitude": "45.78897000",
                        "longitude": "8.44000000"
                    },
                    {
                        "id": 135483,
                        "name": "Andezeno",
                        "latitude": "45.03376000",
                        "longitude": "7.86607000"
                    },
                    {
                        "id": 135485,
                        "name": "Andorno Cacciorna",
                        "latitude": "45.61054000",
                        "longitude": "8.05589000"
                    },
                    {
                        "id": 135487,
                        "name": "Andrate",
                        "latitude": "45.52633000",
                        "longitude": "7.88145000"
                    },
                    {
                        "id": 135501,
                        "name": "Angrogna",
                        "latitude": "44.84354000",
                        "longitude": "7.22422000"
                    },
                    {
                        "id": 135518,
                        "name": "Antignano",
                        "latitude": "44.84535000",
                        "longitude": "8.13494000"
                    },
                    {
                        "id": 135522,
                        "name": "Antronapiana",
                        "latitude": "46.06091000",
                        "longitude": "8.11519000"
                    },
                    {
                        "id": 135528,
                        "name": "Anzola d'Ossola",
                        "latitude": "45.98897000",
                        "longitude": "8.34531000"
                    },
                    {
                        "id": 135551,
                        "name": "Aramengo",
                        "latitude": "45.10085000",
                        "longitude": "8.00003000"
                    },
                    {
                        "id": 135557,
                        "name": "Arborio",
                        "latitude": "45.49586000",
                        "longitude": "8.38755000"
                    },
                    {
                        "id": 135595,
                        "name": "Arguello",
                        "latitude": "44.58274000",
                        "longitude": "8.11084000"
                    },
                    {
                        "id": 135604,
                        "name": "Arignano",
                        "latitude": "45.03966000",
                        "longitude": "7.90189000"
                    },
                    {
                        "id": 135608,
                        "name": "Arizzano",
                        "latitude": "45.95738000",
                        "longitude": "8.58292000"
                    },
                    {
                        "id": 135613,
                        "name": "Armeno",
                        "latitude": "45.82078000",
                        "longitude": "8.44557000"
                    },
                    {
                        "id": 135622,
                        "name": "Arola",
                        "latitude": "45.80867000",
                        "longitude": "8.35808000"
                    },
                    {
                        "id": 135624,
                        "name": "Arona",
                        "latitude": "45.75890000",
                        "longitude": "8.55715000"
                    },
                    {
                        "id": 135630,
                        "name": "Arquata Scrivia",
                        "latitude": "44.68830000",
                        "longitude": "8.88682000"
                    },
                    {
                        "id": 135660,
                        "name": "Asigliano Vercellese",
                        "latitude": "45.26146000",
                        "longitude": "8.40853000"
                    },
                    {
                        "id": 135670,
                        "name": "Asti",
                        "latitude": "44.90162000",
                        "longitude": "8.20751000"
                    },
                    {
                        "id": 135688,
                        "name": "Aurano",
                        "latitude": "46.00038000",
                        "longitude": "8.58822000"
                    },
                    {
                        "id": 135708,
                        "name": "Avigliana",
                        "latitude": "45.07978000",
                        "longitude": "7.39647000"
                    },
                    {
                        "id": 135714,
                        "name": "Avolasca",
                        "latitude": "44.80315000",
                        "longitude": "8.96545000"
                    },
                    {
                        "id": 135718,
                        "name": "Azeglio",
                        "latitude": "45.42283000",
                        "longitude": "7.99222000"
                    },
                    {
                        "id": 135724,
                        "name": "Azzano d'Asti",
                        "latitude": "44.87345000",
                        "longitude": "8.26684000"
                    },
                    {
                        "id": 135728,
                        "name": "Baceno",
                        "latitude": "46.26062000",
                        "longitude": "8.31874000"
                    },
                    {
                        "id": 135755,
                        "name": "Bagnasco",
                        "latitude": "44.30412000",
                        "longitude": "8.04522000"
                    },
                    {
                        "id": 135769,
                        "name": "Bagnolo Piemonte",
                        "latitude": "44.76034000",
                        "longitude": "7.31392000"
                    },
                    {
                        "id": 135779,
                        "name": "Bairo",
                        "latitude": "45.38606000",
                        "longitude": "7.75532000"
                    },
                    {
                        "id": 135782,
                        "name": "Balangero",
                        "latitude": "45.26988000",
                        "longitude": "7.51884000"
                    },
                    {
                        "id": 135783,
                        "name": "Baldichieri d'Asti",
                        "latitude": "44.90595000",
                        "longitude": "8.09163000"
                    },
                    {
                        "id": 135784,
                        "name": "Baldissero Canavese",
                        "latitude": "45.41026000",
                        "longitude": "7.74422000"
                    },
                    {
                        "id": 135786,
                        "name": "Baldissero d'Alba",
                        "latitude": "44.76184000",
                        "longitude": "7.90863000"
                    },
                    {
                        "id": 135785,
                        "name": "Baldissero Torinese",
                        "latitude": "45.06837000",
                        "longitude": "7.81274000"
                    },
                    {
                        "id": 135792,
                        "name": "Balme",
                        "latitude": "45.30192000",
                        "longitude": "7.21937000"
                    },
                    {
                        "id": 135793,
                        "name": "Balmuccia",
                        "latitude": "45.81878000",
                        "longitude": "8.14080000"
                    },
                    {
                        "id": 135794,
                        "name": "Balocco",
                        "latitude": "45.45589000",
                        "longitude": "8.28068000"
                    },
                    {
                        "id": 135799,
                        "name": "Balzola",
                        "latitude": "45.18358000",
                        "longitude": "8.40277000"
                    },
                    {
                        "id": 135802,
                        "name": "Banchette",
                        "latitude": "45.45356000",
                        "longitude": "7.85632000"
                    },
                    {
                        "id": 135803,
                        "name": "Bandito",
                        "latitude": "44.72282000",
                        "longitude": "7.82403000"
                    },
                    {
                        "id": 135804,
                        "name": "Bannio",
                        "latitude": "45.98397000",
                        "longitude": "8.14611000"
                    },
                    {
                        "id": 135816,
                        "name": "Baratte",
                        "latitude": "45.11160000",
                        "longitude": "7.23643000"
                    },
                    {
                        "id": 135818,
                        "name": "Barbania",
                        "latitude": "45.29143000",
                        "longitude": "7.63450000"
                    },
                    {
                        "id": 135823,
                        "name": "Barbaresco",
                        "latitude": "44.72324000",
                        "longitude": "8.08194000"
                    },
                    {
                        "id": 135843,
                        "name": "Bardonecchia",
                        "latitude": "45.07462000",
                        "longitude": "6.69888000"
                    },
                    {
                        "id": 135845,
                        "name": "Barengo",
                        "latitude": "45.57597000",
                        "longitude": "8.51403000"
                    },
                    {
                        "id": 135851,
                        "name": "Barge",
                        "latitude": "44.72786000",
                        "longitude": "7.32283000"
                    },
                    {
                        "id": 135862,
                        "name": "Barolo",
                        "latitude": "44.61094000",
                        "longitude": "7.94284000"
                    },
                    {
                        "id": 135864,
                        "name": "Barone Canavese",
                        "latitude": "45.32576000",
                        "longitude": "7.87342000"
                    },
                    {
                        "id": 135866,
                        "name": "Barquedo",
                        "latitude": "45.74283000",
                        "longitude": "8.49630000"
                    },
                    {
                        "id": 135878,
                        "name": "Basaluzzo",
                        "latitude": "44.76885000",
                        "longitude": "8.70485000"
                    },
                    {
                        "id": 135896,
                        "name": "Bassignana",
                        "latitude": "45.00110000",
                        "longitude": "8.73291000"
                    },
                    {
                        "id": 135900,
                        "name": "Bastia Mondovì",
                        "latitude": "44.44194000",
                        "longitude": "7.89444000"
                    },
                    {
                        "id": 135908,
                        "name": "Battifollo",
                        "latitude": "44.31983000",
                        "longitude": "8.01094000"
                    },
                    {
                        "id": 135914,
                        "name": "Baveno",
                        "latitude": "45.90818000",
                        "longitude": "8.50033000"
                    },
                    {
                        "id": 135922,
                        "name": "Bee",
                        "latitude": "45.96328000",
                        "longitude": "8.57542000"
                    },
                    {
                        "id": 135924,
                        "name": "Beinasco",
                        "latitude": "45.02472000",
                        "longitude": "7.58564000"
                    },
                    {
                        "id": 135925,
                        "name": "Beinette",
                        "latitude": "44.36394000",
                        "longitude": "7.64464000"
                    },
                    {
                        "id": 135930,
                        "name": "Belforte Monferrato",
                        "latitude": "44.62505000",
                        "longitude": "8.66125000"
                    },
                    {
                        "id": 135933,
                        "name": "Belgirate",
                        "latitude": "45.84123000",
                        "longitude": "8.57064000"
                    },
                    {
                        "id": 135944,
                        "name": "Bellinzago Novarese",
                        "latitude": "45.56877000",
                        "longitude": "8.64323000"
                    },
                    {
                        "id": 135962,
                        "name": "Belvedere Langhe",
                        "latitude": "44.49361000",
                        "longitude": "7.97387000"
                    },
                    {
                        "id": 135967,
                        "name": "Belveglio",
                        "latitude": "44.83012000",
                        "longitude": "8.32864000"
                    },
                    {
                        "id": 135972,
                        "name": "Bene Vagienna",
                        "latitude": "44.54268000",
                        "longitude": "7.82726000"
                    },
                    {
                        "id": 135975,
                        "name": "Benevello",
                        "latitude": "44.62981000",
                        "longitude": "8.10507000"
                    },
                    {
                        "id": 135977,
                        "name": "Benna",
                        "latitude": "45.51528000",
                        "longitude": "8.12409000"
                    },
                    {
                        "id": 135986,
                        "name": "Bergamasco",
                        "latitude": "44.82725000",
                        "longitude": "8.45474000"
                    },
                    {
                        "id": 135990,
                        "name": "Bergolo",
                        "latitude": "44.54784000",
                        "longitude": "8.18314000"
                    },
                    {
                        "id": 135995,
                        "name": "Bernezzo",
                        "latitude": "44.38533000",
                        "longitude": "7.43633000"
                    },
                    {
                        "id": 135998,
                        "name": "Bersezio",
                        "latitude": "44.38031000",
                        "longitude": "6.96885000"
                    },
                    {
                        "id": 136004,
                        "name": "Berzano di San Pietro",
                        "latitude": "45.09418000",
                        "longitude": "7.95352000"
                    },
                    {
                        "id": 136005,
                        "name": "Berzano di Tortona",
                        "latitude": "44.87666000",
                        "longitude": "8.95108000"
                    },
                    {
                        "id": 136023,
                        "name": "Beura",
                        "latitude": "46.07964000",
                        "longitude": "8.29826000"
                    },
                    {
                        "id": 136031,
                        "name": "Biandrate",
                        "latitude": "45.45271000",
                        "longitude": "8.46402000"
                    },
                    {
                        "id": 136035,
                        "name": "Bianzè",
                        "latitude": "45.30751000",
                        "longitude": "8.12202000"
                    },
                    {
                        "id": 136041,
                        "name": "Bibiana",
                        "latitude": "44.79894000",
                        "longitude": "7.28822000"
                    },
                    {
                        "id": 136046,
                        "name": "Biella",
                        "latitude": "45.56304000",
                        "longitude": "8.05796000"
                    },
                    {
                        "id": 136054,
                        "name": "Bioglio-Portula-Andrè",
                        "latitude": "45.61516000",
                        "longitude": "8.13602000"
                    },
                    {
                        "id": 136065,
                        "name": "Bistagno",
                        "latitude": "44.66059000",
                        "longitude": "8.37163000"
                    },
                    {
                        "id": 136086,
                        "name": "Bobbio Pellice",
                        "latitude": "44.80854000",
                        "longitude": "7.11691000"
                    },
                    {
                        "id": 136087,
                        "name": "Boca",
                        "latitude": "45.67897000",
                        "longitude": "8.40873000"
                    },
                    {
                        "id": 136089,
                        "name": "Boccioleto",
                        "latitude": "45.83047000",
                        "longitude": "8.11282000"
                    },
                    {
                        "id": 136097,
                        "name": "Bogogno",
                        "latitude": "45.66307000",
                        "longitude": "8.53473000"
                    },
                    {
                        "id": 136106,
                        "name": "Bollengo",
                        "latitude": "45.47162000",
                        "longitude": "7.94133000"
                    },
                    {
                        "id": 136116,
                        "name": "Bolzano Novarese",
                        "latitude": "45.76266000",
                        "longitude": "8.44248000"
                    },
                    {
                        "id": 136143,
                        "name": "Bonvicino",
                        "latitude": "44.50354000",
                        "longitude": "8.01754000"
                    },
                    {
                        "id": 136155,
                        "name": "Borgaro Torinese",
                        "latitude": "45.15122000",
                        "longitude": "7.65543000"
                    },
                    {
                        "id": 136162,
                        "name": "Borghetto di Borbera",
                        "latitude": "44.72945000",
                        "longitude": "8.94346000"
                    },
                    {
                        "id": 136167,
                        "name": "Borgiallo",
                        "latitude": "45.41758000",
                        "longitude": "7.66984000"
                    },
                    {
                        "id": 136169,
                        "name": "Borgo",
                        "latitude": "44.70887000",
                        "longitude": "7.96222000"
                    },
                    {
                        "id": 136199,
                        "name": "Borgo d'Ale",
                        "latitude": "45.34958000",
                        "longitude": "8.05198000"
                    },
                    {
                        "id": 136176,
                        "name": "Borgo Melano",
                        "latitude": "45.01578000",
                        "longitude": "7.57656000"
                    },
                    {
                        "id": 136181,
                        "name": "Borgo San Dalmazzo",
                        "latitude": "44.33785000",
                        "longitude": "7.49310000"
                    },
                    {
                        "id": 136185,
                        "name": "Borgo San Martino",
                        "latitude": "45.09259000",
                        "longitude": "8.52373000"
                    },
                    {
                        "id": 136191,
                        "name": "Borgo Ticino",
                        "latitude": "45.68931000",
                        "longitude": "8.60448000"
                    },
                    {
                        "id": 136196,
                        "name": "Borgo Vercelli",
                        "latitude": "45.35680000",
                        "longitude": "8.46460000"
                    },
                    {
                        "id": 136203,
                        "name": "Borgofranco d'Ivrea",
                        "latitude": "45.51636000",
                        "longitude": "7.85865000"
                    },
                    {
                        "id": 136205,
                        "name": "Borgolavezzaro",
                        "latitude": "45.31918000",
                        "longitude": "8.69931000"
                    },
                    {
                        "id": 136206,
                        "name": "Borgomale",
                        "latitude": "44.62034000",
                        "longitude": "8.13224000"
                    },
                    {
                        "id": 136207,
                        "name": "Borgomanero",
                        "latitude": "45.69873000",
                        "longitude": "8.46230000"
                    },
                    {
                        "id": 136209,
                        "name": "Borgomasino",
                        "latitude": "45.36205000",
                        "longitude": "7.98811000"
                    },
                    {
                        "id": 136210,
                        "name": "Borgone Susa",
                        "latitude": "45.12334000",
                        "longitude": "7.23641000"
                    },
                    {
                        "id": 136213,
                        "name": "Borgoratto Alessandrino",
                        "latitude": "44.83625000",
                        "longitude": "8.53854000"
                    },
                    {
                        "id": 136218,
                        "name": "Borgosesia",
                        "latitude": "45.72045000",
                        "longitude": "8.27466000"
                    },
                    {
                        "id": 136228,
                        "name": "Borriana",
                        "latitude": "45.50781000",
                        "longitude": "8.03860000"
                    },
                    {
                        "id": 136243,
                        "name": "Bosco Marengo",
                        "latitude": "44.82373000",
                        "longitude": "8.68008000"
                    },
                    {
                        "id": 136246,
                        "name": "Bosconero",
                        "latitude": "45.26630000",
                        "longitude": "7.76578000"
                    },
                    {
                        "id": 136250,
                        "name": "Bosia",
                        "latitude": "44.60244000",
                        "longitude": "8.14734000"
                    },
                    {
                        "id": 136251,
                        "name": "Bosio",
                        "latitude": "44.64975000",
                        "longitude": "8.79285000"
                    },
                    {
                        "id": 136255,
                        "name": "Bossolasco",
                        "latitude": "44.52818000",
                        "longitude": "8.04993000"
                    },
                    {
                        "id": 136269,
                        "name": "Boves",
                        "latitude": "44.32985000",
                        "longitude": "7.54733000"
                    },
                    {
                        "id": 136276,
                        "name": "Bozzole",
                        "latitude": "45.06934000",
                        "longitude": "8.60561000"
                    },
                    {
                        "id": 136278,
                        "name": "Bra",
                        "latitude": "44.69776000",
                        "longitude": "7.85128000"
                    },
                    {
                        "id": 136288,
                        "name": "Brandizzo",
                        "latitude": "45.17706000",
                        "longitude": "7.83581000"
                    },
                    {
                        "id": 136297,
                        "name": "Breia",
                        "latitude": "45.76497000",
                        "longitude": "8.30552000"
                    },
                    {
                        "id": 136312,
                        "name": "Breo",
                        "latitude": "44.39865000",
                        "longitude": "7.81903000"
                    },
                    {
                        "id": 136324,
                        "name": "Briaglia",
                        "latitude": "44.39583000",
                        "longitude": "7.87574000"
                    },
                    {
                        "id": 136326,
                        "name": "Bricco di Neive",
                        "latitude": "44.71159000",
                        "longitude": "8.13409000"
                    },
                    {
                        "id": 136327,
                        "name": "Bricherasio",
                        "latitude": "44.82328000",
                        "longitude": "7.30300000"
                    },
                    {
                        "id": 136330,
                        "name": "Briga Alta",
                        "latitude": "44.08273000",
                        "longitude": "7.74944000"
                    },
                    {
                        "id": 136331,
                        "name": "Briga Novarese",
                        "latitude": "45.72931000",
                        "longitude": "8.45586000"
                    },
                    {
                        "id": 136332,
                        "name": "Brignano",
                        "latitude": "44.81457000",
                        "longitude": "9.04005000"
                    },
                    {
                        "id": 136337,
                        "name": "Briona",
                        "latitude": "45.54247000",
                        "longitude": "8.47973000"
                    },
                    {
                        "id": 136350,
                        "name": "Brondello",
                        "latitude": "44.60073000",
                        "longitude": "7.40592000"
                    },
                    {
                        "id": 136355,
                        "name": "Brossasco",
                        "latitude": "44.56778000",
                        "longitude": "7.36454000"
                    },
                    {
                        "id": 136356,
                        "name": "Brosso",
                        "latitude": "45.49180000",
                        "longitude": "7.80225000"
                    },
                    {
                        "id": 136357,
                        "name": "Brovello",
                        "latitude": "45.84246000",
                        "longitude": "8.53189000"
                    },
                    {
                        "id": 136358,
                        "name": "Brovello-Carpugnino",
                        "latitude": "45.84247000",
                        "longitude": "8.53173000"
                    },
                    {
                        "id": 136359,
                        "name": "Brozolo",
                        "latitude": "45.11695000",
                        "longitude": "8.07193000"
                    },
                    {
                        "id": 136366,
                        "name": "Bruino",
                        "latitude": "45.01506000",
                        "longitude": "7.47754000"
                    },
                    {
                        "id": 136372,
                        "name": "Bruno",
                        "latitude": "44.79262000",
                        "longitude": "8.43973000"
                    },
                    {
                        "id": 136374,
                        "name": "Brusasco",
                        "latitude": "45.15499000",
                        "longitude": "8.06107000"
                    },
                    {
                        "id": 136377,
                        "name": "Brusnengo",
                        "latitude": "45.59011000",
                        "longitude": "8.25219000"
                    },
                    {
                        "id": 136379,
                        "name": "Bruzolo",
                        "latitude": "45.14093000",
                        "longitude": "7.19463000"
                    },
                    {
                        "id": 136383,
                        "name": "Bubbio",
                        "latitude": "44.66344000",
                        "longitude": "8.29514000"
                    },
                    {
                        "id": 136414,
                        "name": "Buriasco",
                        "latitude": "44.87222000",
                        "longitude": "7.41200000"
                    },
                    {
                        "id": 136415,
                        "name": "Burolo",
                        "latitude": "45.48116000",
                        "longitude": "7.93392000"
                    },
                    {
                        "id": 136416,
                        "name": "Buronzo",
                        "latitude": "45.48018000",
                        "longitude": "8.26628000"
                    },
                    {
                        "id": 136420,
                        "name": "Busano",
                        "latitude": "45.33137000",
                        "longitude": "7.65727000"
                    },
                    {
                        "id": 136421,
                        "name": "Busca",
                        "latitude": "44.51625000",
                        "longitude": "7.47662000"
                    },
                    {
                        "id": 136433,
                        "name": "Bussoleno",
                        "latitude": "45.13970000",
                        "longitude": "7.14432000"
                    },
                    {
                        "id": 136439,
                        "name": "Buttigliera Alta",
                        "latitude": "45.06836000",
                        "longitude": "7.43254000"
                    },
                    {
                        "id": 136440,
                        "name": "Buttigliera d'Asti",
                        "latitude": "45.02175000",
                        "longitude": "7.95103000"
                    },
                    {
                        "id": 136448,
                        "name": "Cabella Ligure",
                        "latitude": "44.67491000",
                        "longitude": "9.09607000"
                    },
                    {
                        "id": 136465,
                        "name": "Cafasse",
                        "latitude": "45.24865000",
                        "longitude": "7.51882000"
                    },
                    {
                        "id": 136488,
                        "name": "Calamandrana",
                        "latitude": "44.73767000",
                        "longitude": "8.33726000"
                    },
                    {
                        "id": 136492,
                        "name": "Calasca-Castiglione",
                        "latitude": "46.02081000",
                        "longitude": "8.21451000"
                    },
                    {
                        "id": 136531,
                        "name": "Callabiana - Chiesa",
                        "latitude": "45.63137000",
                        "longitude": "8.09722000"
                    },
                    {
                        "id": 136532,
                        "name": "Calliano",
                        "latitude": "45.00798000",
                        "longitude": "8.25661000"
                    },
                    {
                        "id": 136537,
                        "name": "Calosso",
                        "latitude": "44.73994000",
                        "longitude": "8.22714000"
                    },
                    {
                        "id": 136545,
                        "name": "Caltignaga",
                        "latitude": "45.52088000",
                        "longitude": "8.58616000"
                    },
                    {
                        "id": 136549,
                        "name": "Caluso",
                        "latitude": "45.30466000",
                        "longitude": "7.89101000"
                    },
                    {
                        "id": 136566,
                        "name": "Camagna Monferrato",
                        "latitude": "45.01765000",
                        "longitude": "8.42974000"
                    },
                    {
                        "id": 136570,
                        "name": "Camandona",
                        "latitude": "45.64417000",
                        "longitude": "8.09972000"
                    },
                    {
                        "id": 136573,
                        "name": "Cambiano",
                        "latitude": "44.97113000",
                        "longitude": "7.77447000"
                    },
                    {
                        "id": 136574,
                        "name": "Cambiasca",
                        "latitude": "45.96238000",
                        "longitude": "8.54462000"
                    },
                    {
                        "id": 136575,
                        "name": "Camburzano",
                        "latitude": "45.54393000",
                        "longitude": "8.00226000"
                    },
                    {
                        "id": 136576,
                        "name": "Camerana",
                        "latitude": "44.42404000",
                        "longitude": "8.14144000"
                    },
                    {
                        "id": 136578,
                        "name": "Camerano",
                        "latitude": "44.99118000",
                        "longitude": "8.08965000"
                    },
                    {
                        "id": 136579,
                        "name": "Camerano Casasco",
                        "latitude": "44.99165000",
                        "longitude": "8.09103000"
                    },
                    {
                        "id": 136583,
                        "name": "Cameri",
                        "latitude": "45.50159000",
                        "longitude": "8.66245000"
                    },
                    {
                        "id": 136590,
                        "name": "Camino",
                        "latitude": "45.15723000",
                        "longitude": "8.29376000"
                    },
                    {
                        "id": 136596,
                        "name": "Camo",
                        "latitude": "44.69504000",
                        "longitude": "8.19434000"
                    },
                    {
                        "id": 136613,
                        "name": "Campertogno",
                        "latitude": "45.79877000",
                        "longitude": "8.03212000"
                    },
                    {
                        "id": 136617,
                        "name": "Campiglia Cervo",
                        "latitude": "45.66290000",
                        "longitude": "7.99967000"
                    },
                    {
                        "id": 136620,
                        "name": "Campiglione",
                        "latitude": "44.80284000",
                        "longitude": "7.32422000"
                    },
                    {
                        "id": 136669,
                        "name": "Campomolino",
                        "latitude": "44.40883000",
                        "longitude": "7.21192000"
                    },
                    {
                        "id": 136687,
                        "name": "Canale",
                        "latitude": "44.79532000",
                        "longitude": "7.99373000"
                    },
                    {
                        "id": 136698,
                        "name": "Candelo",
                        "latitude": "45.54093000",
                        "longitude": "8.10659000"
                    },
                    {
                        "id": 136700,
                        "name": "Candia Canavese",
                        "latitude": "45.32734000",
                        "longitude": "7.88429000"
                    },
                    {
                        "id": 136706,
                        "name": "Candiolo",
                        "latitude": "44.95858000",
                        "longitude": "7.59812000"
                    },
                    {
                        "id": 136708,
                        "name": "Canelli",
                        "latitude": "44.72084000",
                        "longitude": "8.29282000"
                    },
                    {
                        "id": 136715,
                        "name": "Canischio",
                        "latitude": "45.37485000",
                        "longitude": "7.59621000"
                    },
                    {
                        "id": 136720,
                        "name": "Cannero Riviera",
                        "latitude": "46.02200000",
                        "longitude": "8.67933000"
                    },
                    {
                        "id": 136726,
                        "name": "Cannobio",
                        "latitude": "46.06233000",
                        "longitude": "8.69628000"
                    },
                    {
                        "id": 136733,
                        "name": "Canosio",
                        "latitude": "44.45583000",
                        "longitude": "7.08272000"
                    },
                    {
                        "id": 136740,
                        "name": "Cantalupa",
                        "latitude": "44.94594000",
                        "longitude": "7.33032000"
                    },
                    {
                        "id": 136742,
                        "name": "Cantalupo Ligure",
                        "latitude": "44.71811000",
                        "longitude": "9.04575000"
                    },
                    {
                        "id": 136745,
                        "name": "Cantarana",
                        "latitude": "44.90245000",
                        "longitude": "8.02753000"
                    },
                    {
                        "id": 136750,
                        "name": "Cantoira",
                        "latitude": "45.34014000",
                        "longitude": "7.38450000"
                    },
                    {
                        "id": 136806,
                        "name": "Caprauna",
                        "latitude": "44.11603000",
                        "longitude": "7.95495000"
                    },
                    {
                        "id": 136808,
                        "name": "Caprezzo",
                        "latitude": "45.98198000",
                        "longitude": "8.56282000"
                    },
                    {
                        "id": 136814,
                        "name": "Capriata d'Orba",
                        "latitude": "44.72785000",
                        "longitude": "8.69085000"
                    },
                    {
                        "id": 136817,
                        "name": "Caprie",
                        "latitude": "45.11944000",
                        "longitude": "7.33294000"
                    },
                    {
                        "id": 136820,
                        "name": "Capriglio",
                        "latitude": "45.00355000",
                        "longitude": "8.00893000"
                    },
                    {
                        "id": 136829,
                        "name": "Caraglio",
                        "latitude": "44.41725000",
                        "longitude": "7.43281000"
                    },
                    {
                        "id": 136830,
                        "name": "Caramagna Piemonte",
                        "latitude": "44.78224000",
                        "longitude": "7.73943000"
                    },
                    {
                        "id": 136842,
                        "name": "Caravino",
                        "latitude": "45.39950000",
                        "longitude": "7.96020000"
                    },
                    {
                        "id": 136845,
                        "name": "Carbonara Scrivia",
                        "latitude": "44.84915000",
                        "longitude": "8.86975000"
                    },
                    {
                        "id": 136856,
                        "name": "Carcoforo",
                        "latitude": "45.90858000",
                        "longitude": "8.04967000"
                    },
                    {
                        "id": 136863,
                        "name": "Cardè",
                        "latitude": "44.74444000",
                        "longitude": "7.47762000"
                    },
                    {
                        "id": 136865,
                        "name": "Carema",
                        "latitude": "45.58401000",
                        "longitude": "7.80879000"
                    },
                    {
                        "id": 136867,
                        "name": "Carentino",
                        "latitude": "44.82885000",
                        "longitude": "8.47134000"
                    },
                    {
                        "id": 136869,
                        "name": "Caresana",
                        "latitude": "45.22142000",
                        "longitude": "8.50480000"
                    },
                    {
                        "id": 136870,
                        "name": "Caresanablot",
                        "latitude": "45.35736000",
                        "longitude": "8.39203000"
                    },
                    {
                        "id": 136871,
                        "name": "Carezzano Maggiore",
                        "latitude": "44.80705000",
                        "longitude": "8.90055000"
                    },
                    {
                        "id": 136877,
                        "name": "Carignano",
                        "latitude": "44.90599000",
                        "longitude": "7.67253000"
                    },
                    {
                        "id": 136882,
                        "name": "Carisio",
                        "latitude": "45.41017000",
                        "longitude": "8.19962000"
                    },
                    {
                        "id": 136890,
                        "name": "Carmagnola",
                        "latitude": "44.84963000",
                        "longitude": "7.72032000"
                    },
                    {
                        "id": 136911,
                        "name": "Carpeneto",
                        "latitude": "44.67835000",
                        "longitude": "8.60555000"
                    },
                    {
                        "id": 136916,
                        "name": "Carpignano Sesia",
                        "latitude": "45.53341000",
                        "longitude": "8.41734000"
                    },
                    {
                        "id": 136927,
                        "name": "Carrega Ligure",
                        "latitude": "44.61879000",
                        "longitude": "9.17564000"
                    },
                    {
                        "id": 136930,
                        "name": "Carrosio",
                        "latitude": "44.65776000",
                        "longitude": "8.83126000"
                    },
                    {
                        "id": 136935,
                        "name": "Carrù",
                        "latitude": "44.47967000",
                        "longitude": "7.87236000"
                    },
                    {
                        "id": 136939,
                        "name": "Cartignano",
                        "latitude": "44.47833000",
                        "longitude": "7.28573000"
                    },
                    {
                        "id": 136941,
                        "name": "Cartosio",
                        "latitude": "44.59024000",
                        "longitude": "8.42065000"
                    },
                    {
                        "id": 136957,
                        "name": "Casal Cermelli",
                        "latitude": "44.83495000",
                        "longitude": "8.62495000"
                    },
                    {
                        "id": 136964,
                        "name": "Casalbeltrame",
                        "latitude": "45.43806000",
                        "longitude": "8.46653000"
                    },
                    {
                        "id": 136967,
                        "name": "Casalborgone",
                        "latitude": "45.13045000",
                        "longitude": "7.94043000"
                    },
                    {
                        "id": 136974,
                        "name": "Casale Corte Cerro",
                        "latitude": "45.91545000",
                        "longitude": "8.41407000"
                    },
                    {
                        "id": 136978,
                        "name": "Casale Monferrato",
                        "latitude": "45.13338000",
                        "longitude": "8.45250000"
                    },
                    {
                        "id": 136982,
                        "name": "Casaleggio Boiro",
                        "latitude": "44.63355000",
                        "longitude": "8.73045000"
                    },
                    {
                        "id": 136983,
                        "name": "Casaleggio Novara",
                        "latitude": "45.48793000",
                        "longitude": "8.49307000"
                    },
                    {
                        "id": 136992,
                        "name": "Casalgrasso",
                        "latitude": "44.81834000",
                        "longitude": "7.62498000"
                    },
                    {
                        "id": 136997,
                        "name": "Casalino",
                        "latitude": "45.35836000",
                        "longitude": "8.52393000"
                    },
                    {
                        "id": 137002,
                        "name": "Casalnoceto",
                        "latitude": "44.91326000",
                        "longitude": "8.98376000"
                    },
                    {
                        "id": 137013,
                        "name": "Casalvolone",
                        "latitude": "45.39966000",
                        "longitude": "8.46472000"
                    },
                    {
                        "id": 137022,
                        "name": "Casanova Elvo",
                        "latitude": "45.40020000",
                        "longitude": "8.29413000"
                    },
                    {
                        "id": 137027,
                        "name": "Casapinta",
                        "latitude": "45.61566000",
                        "longitude": "8.19592000"
                    },
                    {
                        "id": 137036,
                        "name": "Casasco",
                        "latitude": "44.82734000",
                        "longitude": "9.00565000"
                    },
                    {
                        "id": 137052,
                        "name": "Cascinette d'Ivrea",
                        "latitude": "45.48016000",
                        "longitude": "7.90562000"
                    },
                    {
                        "id": 137057,
                        "name": "Caselette",
                        "latitude": "45.10975000",
                        "longitude": "7.48582000"
                    },
                    {
                        "id": 137062,
                        "name": "Caselle Torinese",
                        "latitude": "45.17458000",
                        "longitude": "7.64290000"
                    },
                    {
                        "id": 137090,
                        "name": "Casorzo",
                        "latitude": "45.02165000",
                        "longitude": "8.33843000"
                    },
                    {
                        "id": 137098,
                        "name": "Cassano Spinola",
                        "latitude": "44.76557000",
                        "longitude": "8.86228000"
                    },
                    {
                        "id": 137108,
                        "name": "Cassinasco",
                        "latitude": "44.68977000",
                        "longitude": "8.30345000"
                    },
                    {
                        "id": 137109,
                        "name": "Cassine",
                        "latitude": "44.75166000",
                        "longitude": "8.52872000"
                    },
                    {
                        "id": 137110,
                        "name": "Cassinelle-Concentrico",
                        "latitude": "44.60154000",
                        "longitude": "8.56345000"
                    },
                    {
                        "id": 137118,
                        "name": "Castagneto Po",
                        "latitude": "45.15854000",
                        "longitude": "7.88639000"
                    },
                    {
                        "id": 137119,
                        "name": "Castagnito",
                        "latitude": "44.75472000",
                        "longitude": "8.03195000"
                    },
                    {
                        "id": 137123,
                        "name": "Castagnole delle Lanze",
                        "latitude": "44.74988000",
                        "longitude": "8.14966000"
                    },
                    {
                        "id": 137121,
                        "name": "Castagnole Monferrato",
                        "latitude": "44.95864000",
                        "longitude": "8.30507000"
                    },
                    {
                        "id": 137122,
                        "name": "Castagnole Piemonte",
                        "latitude": "44.89814000",
                        "longitude": "7.56612000"
                    },
                    {
                        "id": 137130,
                        "name": "Castel Boglione",
                        "latitude": "44.72195000",
                        "longitude": "8.37994000"
                    },
                    {
                        "id": 137148,
                        "name": "Castel Rocchero",
                        "latitude": "44.71835000",
                        "longitude": "8.41534000"
                    },
                    {
                        "id": 137184,
                        "name": "Castelceriolo",
                        "latitude": "44.91723000",
                        "longitude": "8.69384000"
                    },
                    {
                        "id": 137190,
                        "name": "Casteldelfino",
                        "latitude": "44.59002000",
                        "longitude": "7.07026000"
                    },
                    {
                        "id": 137206,
                        "name": "Castell'Alfero",
                        "latitude": "44.98505000",
                        "longitude": "8.22309000"
                    },
                    {
                        "id": 137214,
                        "name": "Castellamonte",
                        "latitude": "45.38267000",
                        "longitude": "7.70886000"
                    },
                    {
                        "id": 137218,
                        "name": "Castellania",
                        "latitude": "44.79845000",
                        "longitude": "8.93035000"
                    },
                    {
                        "id": 137220,
                        "name": "Castellar",
                        "latitude": "44.62123000",
                        "longitude": "7.43743000"
                    },
                    {
                        "id": 137221,
                        "name": "Castellar Guidobono",
                        "latitude": "44.90483000",
                        "longitude": "8.94835000"
                    },
                    {
                        "id": 137224,
                        "name": "Castellazzo Bormida",
                        "latitude": "44.84353000",
                        "longitude": "8.57900000"
                    },
                    {
                        "id": 137225,
                        "name": "Castellazzo Novarese",
                        "latitude": "45.51337000",
                        "longitude": "8.48693000"
                    },
                    {
                        "id": 137228,
                        "name": "Castellero",
                        "latitude": "44.92535000",
                        "longitude": "8.07383000"
                    },
                    {
                        "id": 137231,
                        "name": "Castelletto Cervo",
                        "latitude": "45.52136000",
                        "longitude": "8.22542000"
                    },
                    {
                        "id": 137239,
                        "name": "Castelletto d'Erro",
                        "latitude": "44.62597000",
                        "longitude": "8.39442000"
                    },
                    {
                        "id": 137240,
                        "name": "Castelletto d'Orba",
                        "latitude": "44.68455000",
                        "longitude": "8.70395000"
                    },
                    {
                        "id": 137232,
                        "name": "Castelletto Merli",
                        "latitude": "45.07395000",
                        "longitude": "8.24013000"
                    },
                    {
                        "id": 137233,
                        "name": "Castelletto Molina",
                        "latitude": "44.75125000",
                        "longitude": "8.43324000"
                    },
                    {
                        "id": 137234,
                        "name": "Castelletto Monferrato",
                        "latitude": "44.98115000",
                        "longitude": "8.56454000"
                    },
                    {
                        "id": 137236,
                        "name": "Castelletto Sopra Ticino",
                        "latitude": "45.72002000",
                        "longitude": "8.63362000"
                    },
                    {
                        "id": 137237,
                        "name": "Castelletto Stura",
                        "latitude": "44.44383000",
                        "longitude": "7.63923000"
                    },
                    {
                        "id": 137238,
                        "name": "Castelletto Uzzone",
                        "latitude": "44.49527000",
                        "longitude": "8.18772000"
                    },
                    {
                        "id": 137247,
                        "name": "Castellinaldo",
                        "latitude": "44.77484000",
                        "longitude": "8.02974000"
                    },
                    {
                        "id": 137248,
                        "name": "Castellino Tanaro",
                        "latitude": "44.42784000",
                        "longitude": "7.98124000"
                    },
                    {
                        "id": 137259,
                        "name": "Castello di Annone",
                        "latitude": "44.87944000",
                        "longitude": "8.31701000"
                    },
                    {
                        "id": 137282,
                        "name": "Castelnuovo Belbo",
                        "latitude": "44.80110000",
                        "longitude": "8.41236000"
                    },
                    {
                        "id": 137285,
                        "name": "Castelnuovo Bormida",
                        "latitude": "44.74236000",
                        "longitude": "8.55060000"
                    },
                    {
                        "id": 137287,
                        "name": "Castelnuovo Calcea",
                        "latitude": "44.78688000",
                        "longitude": "8.28421000"
                    },
                    {
                        "id": 137299,
                        "name": "Castelnuovo di Ceva",
                        "latitude": "44.35363000",
                        "longitude": "8.12894000"
                    },
                    {
                        "id": 137289,
                        "name": "Castelnuovo Don Bosco",
                        "latitude": "45.04077000",
                        "longitude": "7.96389000"
                    },
                    {
                        "id": 137291,
                        "name": "Castelnuovo Nigra",
                        "latitude": "45.43816000",
                        "longitude": "7.69461000"
                    },
                    {
                        "id": 137294,
                        "name": "Castelnuovo Scrivia",
                        "latitude": "44.97932000",
                        "longitude": "8.88246000"
                    },
                    {
                        "id": 137317,
                        "name": "Castelspina",
                        "latitude": "44.80615000",
                        "longitude": "8.58315000"
                    },
                    {
                        "id": 137341,
                        "name": "Castiglione Falletto",
                        "latitude": "44.62254000",
                        "longitude": "7.97534000"
                    },
                    {
                        "id": 137345,
                        "name": "Castiglione Tinella",
                        "latitude": "44.72534000",
                        "longitude": "8.19014000"
                    },
                    {
                        "id": 137346,
                        "name": "Castiglione Torinese",
                        "latitude": "45.11905000",
                        "longitude": "7.80712000"
                    },
                    {
                        "id": 137361,
                        "name": "Castino",
                        "latitude": "44.61784000",
                        "longitude": "8.18244000"
                    },
                    {
                        "id": 137409,
                        "name": "Cavaglià",
                        "latitude": "45.40602000",
                        "longitude": "8.09163000"
                    },
                    {
                        "id": 137406,
                        "name": "Cavaglietto",
                        "latitude": "45.60217000",
                        "longitude": "8.50213000"
                    },
                    {
                        "id": 137407,
                        "name": "Cavaglio D'Agogna",
                        "latitude": "45.61317000",
                        "longitude": "8.48613000"
                    },
                    {
                        "id": 137408,
                        "name": "Cavaglio-Spoccia",
                        "latitude": "46.07108000",
                        "longitude": "8.63072000"
                    },
                    {
                        "id": 137410,
                        "name": "Cavagnolo",
                        "latitude": "45.15175000",
                        "longitude": "8.04903000"
                    },
                    {
                        "id": 137415,
                        "name": "Cavallerleone",
                        "latitude": "44.74014000",
                        "longitude": "7.66393000"
                    },
                    {
                        "id": 137416,
                        "name": "Cavallermaggiore",
                        "latitude": "44.70639000",
                        "longitude": "7.68693000"
                    },
                    {
                        "id": 137420,
                        "name": "Cavallirio",
                        "latitude": "45.66227000",
                        "longitude": "8.39694000"
                    },
                    {
                        "id": 137427,
                        "name": "Cavatore",
                        "latitude": "44.63099000",
                        "longitude": "8.45276000"
                    },
                    {
                        "id": 137441,
                        "name": "Cavour",
                        "latitude": "44.79286000",
                        "longitude": "7.37438000"
                    },
                    {
                        "id": 137468,
                        "name": "Cella Monte",
                        "latitude": "45.07405000",
                        "longitude": "8.39154000"
                    },
                    {
                        "id": 137471,
                        "name": "Cellarengo",
                        "latitude": "44.86435000",
                        "longitude": "7.94533000"
                    },
                    {
                        "id": 137473,
                        "name": "Celle Enomondo",
                        "latitude": "44.85685000",
                        "longitude": "8.12373000"
                    },
                    {
                        "id": 137481,
                        "name": "Cellio",
                        "latitude": "45.75505000",
                        "longitude": "8.31185000"
                    },
                    {
                        "id": 137495,
                        "name": "Centallo",
                        "latitude": "44.50153000",
                        "longitude": "7.58783000"
                    },
                    {
                        "id": 137509,
                        "name": "Ceppo Morelli",
                        "latitude": "45.97114000",
                        "longitude": "8.06688000"
                    },
                    {
                        "id": 137514,
                        "name": "Cerano",
                        "latitude": "45.40915000",
                        "longitude": "8.78351000"
                    },
                    {
                        "id": 137522,
                        "name": "Cercenasco",
                        "latitude": "44.86204000",
                        "longitude": "7.49822000"
                    },
                    {
                        "id": 137535,
                        "name": "Ceres",
                        "latitude": "45.31336000",
                        "longitude": "7.38961000"
                    },
                    {
                        "id": 137536,
                        "name": "Ceresane-Curanuova",
                        "latitude": "45.52435000",
                        "longitude": "8.00708000"
                    },
                    {
                        "id": 137539,
                        "name": "Cereseto",
                        "latitude": "45.08685000",
                        "longitude": "8.31817000"
                    },
                    {
                        "id": 137540,
                        "name": "Ceresole Alba",
                        "latitude": "44.79974000",
                        "longitude": "7.82243000"
                    },
                    {
                        "id": 137541,
                        "name": "Ceresole Reale",
                        "latitude": "45.43235000",
                        "longitude": "7.23506000"
                    },
                    {
                        "id": 137561,
                        "name": "Cerreto Castello",
                        "latitude": "45.56446000",
                        "longitude": "8.16082000"
                    },
                    {
                        "id": 137567,
                        "name": "Cerreto d'Asti",
                        "latitude": "45.05215000",
                        "longitude": "8.03513000"
                    },
                    {
                        "id": 137562,
                        "name": "Cerreto Grue",
                        "latitude": "44.84255000",
                        "longitude": "8.93035000"
                    },
                    {
                        "id": 137564,
                        "name": "Cerreto Langhe",
                        "latitude": "44.57484000",
                        "longitude": "8.09794000"
                    },
                    {
                        "id": 137570,
                        "name": "Cerrina",
                        "latitude": "45.12135000",
                        "longitude": "8.21383000"
                    },
                    {
                        "id": 137571,
                        "name": "Cerrione",
                        "latitude": "45.46933000",
                        "longitude": "8.06840000"
                    },
                    {
                        "id": 137573,
                        "name": "Cerro Tanaro",
                        "latitude": "44.87335000",
                        "longitude": "8.35874000"
                    },
                    {
                        "id": 137585,
                        "name": "Cervasca",
                        "latitude": "44.38093000",
                        "longitude": "7.47123000"
                    },
                    {
                        "id": 137586,
                        "name": "Cervatto",
                        "latitude": "45.88297000",
                        "longitude": "8.16232000"
                    },
                    {
                        "id": 137588,
                        "name": "Cervere",
                        "latitude": "44.63428000",
                        "longitude": "7.78884000"
                    },
                    {
                        "id": 137603,
                        "name": "Cesana Torinese",
                        "latitude": "44.95340000",
                        "longitude": "6.79199000"
                    },
                    {
                        "id": 137607,
                        "name": "Cesara",
                        "latitude": "45.83379000",
                        "longitude": "8.36777000"
                    },
                    {
                        "id": 137619,
                        "name": "Cessole",
                        "latitude": "44.64877000",
                        "longitude": "8.24438000"
                    },
                    {
                        "id": 137625,
                        "name": "Ceva",
                        "latitude": "44.38505000",
                        "longitude": "8.02769000"
                    },
                    {
                        "id": 137636,
                        "name": "Cherasco",
                        "latitude": "44.64345000",
                        "longitude": "7.85818000"
                    },
                    {
                        "id": 137640,
                        "name": "Chialamberto",
                        "latitude": "45.36295000",
                        "longitude": "7.34363000"
                    },
                    {
                        "id": 137647,
                        "name": "Chianocco",
                        "latitude": "45.14854000",
                        "longitude": "7.16981000"
                    },
                    {
                        "id": 137661,
                        "name": "Chiaverano",
                        "latitude": "45.49886000",
                        "longitude": "7.90262000"
                    },
                    {
                        "id": 137663,
                        "name": "Chieri",
                        "latitude": "45.01054000",
                        "longitude": "7.82133000"
                    },
                    {
                        "id": 137667,
                        "name": "Chiesa di Macra",
                        "latitude": "44.48283000",
                        "longitude": "7.18062000"
                    },
                    {
                        "id": 137669,
                        "name": "Chiesanuova",
                        "latitude": "45.41745000",
                        "longitude": "7.65552000"
                    },
                    {
                        "id": 137678,
                        "name": "Chiomonte",
                        "latitude": "45.11909000",
                        "longitude": "6.98420000"
                    },
                    {
                        "id": 137688,
                        "name": "Chiusa di Pesio",
                        "latitude": "44.32588000",
                        "longitude": "7.67431000"
                    },
                    {
                        "id": 137689,
                        "name": "Chiusa di San Michele",
                        "latitude": "45.10424000",
                        "longitude": "7.32711000"
                    },
                    {
                        "id": 137692,
                        "name": "Chiusano d'Asti",
                        "latitude": "44.98665000",
                        "longitude": "8.11853000"
                    },
                    {
                        "id": 137699,
                        "name": "Chivasso",
                        "latitude": "45.19093000",
                        "longitude": "7.88981000"
                    },
                    {
                        "id": 137714,
                        "name": "Ciconio",
                        "latitude": "45.33025000",
                        "longitude": "7.75852000"
                    },
                    {
                        "id": 137715,
                        "name": "Cigliano",
                        "latitude": "45.30804000",
                        "longitude": "8.02316000"
                    },
                    {
                        "id": 137716,
                        "name": "Cigliè",
                        "latitude": "44.43653000",
                        "longitude": "7.92654000"
                    },
                    {
                        "id": 137729,
                        "name": "Cinaglio",
                        "latitude": "44.97525000",
                        "longitude": "8.10003000"
                    },
                    {
                        "id": 137738,
                        "name": "Cintano",
                        "latitude": "45.42812000",
                        "longitude": "7.68827000"
                    },
                    {
                        "id": 137742,
                        "name": "Cinzano",
                        "latitude": "45.09528000",
                        "longitude": "7.92427000"
                    },
                    {
                        "id": 137749,
                        "name": "Ciriè",
                        "latitude": "45.23486000",
                        "longitude": "7.60125000"
                    },
                    {
                        "id": 137760,
                        "name": "Cissone",
                        "latitude": "44.56314000",
                        "longitude": "8.03044000"
                    },
                    {
                        "id": 137761,
                        "name": "Cisterna d'Asti",
                        "latitude": "44.82525000",
                        "longitude": "8.00076000"
                    },
                    {
                        "id": 137781,
                        "name": "Civiasco",
                        "latitude": "45.80786000",
                        "longitude": "8.29386000"
                    },
                    {
                        "id": 137809,
                        "name": "Clavesana",
                        "latitude": "44.48334000",
                        "longitude": "7.91084000"
                    },
                    {
                        "id": 137810,
                        "name": "Claviere",
                        "latitude": "44.93922000",
                        "longitude": "6.75213000"
                    },
                    {
                        "id": 137818,
                        "name": "Coassolo",
                        "latitude": "45.29838000",
                        "longitude": "7.46136000"
                    },
                    {
                        "id": 137819,
                        "name": "Coassolo Torinese",
                        "latitude": "45.29775000",
                        "longitude": "7.46041000"
                    },
                    {
                        "id": 137820,
                        "name": "Coazze",
                        "latitude": "45.05181000",
                        "longitude": "7.30063000"
                    },
                    {
                        "id": 137821,
                        "name": "Coazzolo",
                        "latitude": "44.72824000",
                        "longitude": "8.14514000"
                    },
                    {
                        "id": 137824,
                        "name": "Cocconato",
                        "latitude": "45.08642000",
                        "longitude": "8.04019000"
                    },
                    {
                        "id": 137839,
                        "name": "Coggiola",
                        "latitude": "45.68640000",
                        "longitude": "8.18252000"
                    },
                    {
                        "id": 137847,
                        "name": "Colazza",
                        "latitude": "45.79257000",
                        "longitude": "8.50033000"
                    },
                    {
                        "id": 137883,
                        "name": "Collegno",
                        "latitude": "45.07873000",
                        "longitude": "7.56735000"
                    },
                    {
                        "id": 137891,
                        "name": "Colleretto Castelnuovo",
                        "latitude": "45.42236000",
                        "longitude": "7.67981000"
                    },
                    {
                        "id": 137892,
                        "name": "Colleretto Giacosa",
                        "latitude": "45.43286000",
                        "longitude": "7.79852000"
                    },
                    {
                        "id": 137905,
                        "name": "Collobiano",
                        "latitude": "45.39665000",
                        "longitude": "8.34750000"
                    },
                    {
                        "id": 137940,
                        "name": "Comignago",
                        "latitude": "45.71487000",
                        "longitude": "8.56403000"
                    },
                    {
                        "id": 137964,
                        "name": "Condove",
                        "latitude": "45.11591000",
                        "longitude": "7.30859000"
                    },
                    {
                        "id": 137970,
                        "name": "Coniolo Bricco",
                        "latitude": "45.14816000",
                        "longitude": "8.37093000"
                    },
                    {
                        "id": 137984,
                        "name": "Conzano",
                        "latitude": "45.02009000",
                        "longitude": "8.45554000"
                    },
                    {
                        "id": 138016,
                        "name": "Corio",
                        "latitude": "45.31222000",
                        "longitude": "7.53351000"
                    },
                    {
                        "id": 138030,
                        "name": "Corneliano d'Alba",
                        "latitude": "44.73614000",
                        "longitude": "7.95723000"
                    },
                    {
                        "id": 138049,
                        "name": "Corsione",
                        "latitude": "45.00095000",
                        "longitude": "8.14523000"
                    },
                    {
                        "id": 138052,
                        "name": "Cortandone",
                        "latitude": "44.95915000",
                        "longitude": "8.05843000"
                    },
                    {
                        "id": 138053,
                        "name": "Cortanze",
                        "latitude": "45.01404000",
                        "longitude": "8.08879000"
                    },
                    {
                        "id": 138054,
                        "name": "Cortazzone",
                        "latitude": "44.97915000",
                        "longitude": "8.06123000"
                    },
                    {
                        "id": 138061,
                        "name": "Cortemilia",
                        "latitude": "44.58044000",
                        "longitude": "8.19367000"
                    },
                    {
                        "id": 138066,
                        "name": "Cortiglione",
                        "latitude": "44.82225000",
                        "longitude": "8.35796000"
                    },
                    {
                        "id": 138083,
                        "name": "Cossano Belbo",
                        "latitude": "44.66884000",
                        "longitude": "8.19864000"
                    },
                    {
                        "id": 138084,
                        "name": "Cossano Canavese",
                        "latitude": "45.38776000",
                        "longitude": "7.99152000"
                    },
                    {
                        "id": 138085,
                        "name": "Cossato",
                        "latitude": "45.57032000",
                        "longitude": "8.18471000"
                    },
                    {
                        "id": 138088,
                        "name": "Cossogno",
                        "latitude": "45.96408000",
                        "longitude": "8.50962000"
                    },
                    {
                        "id": 138090,
                        "name": "Cossombrato",
                        "latitude": "44.98976000",
                        "longitude": "8.13897000"
                    },
                    {
                        "id": 138095,
                        "name": "Costa Vescovato",
                        "latitude": "44.81615000",
                        "longitude": "8.92695000"
                    },
                    {
                        "id": 138105,
                        "name": "Costanzana",
                        "latitude": "45.23742000",
                        "longitude": "8.36943000"
                    },
                    {
                        "id": 138109,
                        "name": "Costigliole d'Asti",
                        "latitude": "44.78517000",
                        "longitude": "8.18405000"
                    },
                    {
                        "id": 138110,
                        "name": "Costiglione Saluzzo",
                        "latitude": "44.56453000",
                        "longitude": "7.48543000"
                    },
                    {
                        "id": 138124,
                        "name": "Crava",
                        "latitude": "44.43001000",
                        "longitude": "7.74493000"
                    },
                    {
                        "id": 138125,
                        "name": "Cravagliana",
                        "latitude": "45.84827000",
                        "longitude": "8.20182000"
                    },
                    {
                        "id": 138126,
                        "name": "Cravanzana",
                        "latitude": "44.57448000",
                        "longitude": "8.12731000"
                    },
                    {
                        "id": 138127,
                        "name": "Craveggia",
                        "latitude": "46.14124000",
                        "longitude": "8.48907000"
                    },
                    {
                        "id": 138137,
                        "name": "Cremolino",
                        "latitude": "44.63674000",
                        "longitude": "8.58584000"
                    },
                    {
                        "id": 138141,
                        "name": "Crescentino",
                        "latitude": "45.19941000",
                        "longitude": "8.08635000"
                    },
                    {
                        "id": 138148,
                        "name": "Cressa",
                        "latitude": "45.64762000",
                        "longitude": "8.50942000"
                    },
                    {
                        "id": 138151,
                        "name": "Crevacuore",
                        "latitude": "45.68548000",
                        "longitude": "8.24404000"
                    },
                    {
                        "id": 138153,
                        "name": "Crevoladossola",
                        "latitude": "46.14858000",
                        "longitude": "8.29742000"
                    },
                    {
                        "id": 138158,
                        "name": "Crissolo",
                        "latitude": "44.69953000",
                        "longitude": "7.15602000"
                    },
                    {
                        "id": 138162,
                        "name": "Crodo",
                        "latitude": "46.21726000",
                        "longitude": "8.32238000"
                    },
                    {
                        "id": 138172,
                        "name": "Crova",
                        "latitude": "45.33066000",
                        "longitude": "8.21083000"
                    },
                    {
                        "id": 138178,
                        "name": "Cuccaro Monferrato",
                        "latitude": "44.99365000",
                        "longitude": "8.45754000"
                    },
                    {
                        "id": 138182,
                        "name": "Cuceglio",
                        "latitude": "45.35853000",
                        "longitude": "7.81588000"
                    },
                    {
                        "id": 138187,
                        "name": "Cumiana",
                        "latitude": "44.97629000",
                        "longitude": "7.37761000"
                    },
                    {
                        "id": 138190,
                        "name": "Cuneo",
                        "latitude": "44.39071000",
                        "longitude": "7.54828000"
                    },
                    {
                        "id": 138193,
                        "name": "Cunico",
                        "latitude": "45.04050000",
                        "longitude": "8.09554000"
                    },
                    {
                        "id": 138194,
                        "name": "Cuorgnè",
                        "latitude": "45.39341000",
                        "longitude": "7.65015000"
                    },
                    {
                        "id": 138200,
                        "name": "Cureggio",
                        "latitude": "45.67487000",
                        "longitude": "8.45973000"
                    },
                    {
                        "id": 138203,
                        "name": "Curino",
                        "latitude": "45.62717000",
                        "longitude": "8.23622000"
                    },
                    {
                        "id": 138207,
                        "name": "Cursolo",
                        "latitude": "46.09858000",
                        "longitude": "8.56822000"
                    },
                    {
                        "id": 138246,
                        "name": "Demonte",
                        "latitude": "44.31646000",
                        "longitude": "7.29808000"
                    },
                    {
                        "id": 138247,
                        "name": "Denice",
                        "latitude": "44.59884000",
                        "longitude": "8.33315000"
                    },
                    {
                        "id": 138250,
                        "name": "Dernice",
                        "latitude": "44.76660000",
                        "longitude": "9.05001000"
                    },
                    {
                        "id": 138254,
                        "name": "Desana",
                        "latitude": "45.26915000",
                        "longitude": "8.35777000"
                    },
                    {
                        "id": 138264,
                        "name": "Diano d'Alba",
                        "latitude": "44.65294000",
                        "longitude": "8.02704000"
                    },
                    {
                        "id": 138271,
                        "name": "Divignano",
                        "latitude": "45.66247000",
                        "longitude": "8.59987000"
                    },
                    {
                        "id": 138276,
                        "name": "Dogliani",
                        "latitude": "44.53326000",
                        "longitude": "7.94510000"
                    },
                    {
                        "id": 138292,
                        "name": "Domodossola",
                        "latitude": "46.11650000",
                        "longitude": "8.29313000"
                    },
                    {
                        "id": 138297,
                        "name": "Donato",
                        "latitude": "45.52626000",
                        "longitude": "7.90962000"
                    },
                    {
                        "id": 138309,
                        "name": "Dormelletto",
                        "latitude": "45.73627000",
                        "longitude": "8.56663000"
                    },
                    {
                        "id": 138312,
                        "name": "Dorzano",
                        "latitude": "45.42606000",
                        "longitude": "8.09852000"
                    },
                    {
                        "id": 138332,
                        "name": "Dronero",
                        "latitude": "44.46476000",
                        "longitude": "7.36242000"
                    },
                    {
                        "id": 138333,
                        "name": "Drubiaglio-Grangia",
                        "latitude": "45.09552000",
                        "longitude": "7.41940000"
                    },
                    {
                        "id": 138334,
                        "name": "Druento",
                        "latitude": "45.13306000",
                        "longitude": "7.57512000"
                    },
                    {
                        "id": 138335,
                        "name": "Druogno",
                        "latitude": "46.13421000",
                        "longitude": "8.43276000"
                    },
                    {
                        "id": 138347,
                        "name": "Dusino",
                        "latitude": "44.92566000",
                        "longitude": "7.97165000"
                    },
                    {
                        "id": 138361,
                        "name": "Entracque",
                        "latitude": "44.24028000",
                        "longitude": "7.39847000"
                    },
                    {
                        "id": 138363,
                        "name": "Envie",
                        "latitude": "44.68210000",
                        "longitude": "7.37206000"
                    },
                    {
                        "id": 138390,
                        "name": "Exilles",
                        "latitude": "45.09754000",
                        "longitude": "6.92920000"
                    },
                    {
                        "id": 138423,
                        "name": "Falmenta",
                        "latitude": "46.07309000",
                        "longitude": "8.58944000"
                    },
                    {
                        "id": 138439,
                        "name": "Fara Novarese",
                        "latitude": "45.55440000",
                        "longitude": "8.45664000"
                    },
                    {
                        "id": 138446,
                        "name": "Farigliano",
                        "latitude": "44.51204000",
                        "longitude": "7.91424000"
                    },
                    {
                        "id": 138457,
                        "name": "Faule",
                        "latitude": "44.80624000",
                        "longitude": "7.58512000"
                    },
                    {
                        "id": 138460,
                        "name": "Favari-Avatanei",
                        "latitude": "44.91235000",
                        "longitude": "7.79950000"
                    },
                    {
                        "id": 138463,
                        "name": "Favria",
                        "latitude": "45.33099000",
                        "longitude": "7.68834000"
                    },
                    {
                        "id": 138465,
                        "name": "Feisoglio",
                        "latitude": "44.54374000",
                        "longitude": "8.10494000"
                    },
                    {
                        "id": 138467,
                        "name": "Feletto",
                        "latitude": "45.30336000",
                        "longitude": "7.74481000"
                    },
                    {
                        "id": 138471,
                        "name": "Felizzano",
                        "latitude": "44.89935000",
                        "longitude": "8.43584000"
                    },
                    {
                        "id": 138477,
                        "name": "Fenestrelle",
                        "latitude": "45.03594000",
                        "longitude": "7.04941000"
                    },
                    {
                        "id": 138494,
                        "name": "Ferrere",
                        "latitude": "44.87605000",
                        "longitude": "7.99421000"
                    },
                    {
                        "id": 138495,
                        "name": "Ferriera",
                        "latitude": "45.08382000",
                        "longitude": "7.43017000"
                    },
                    {
                        "id": 138500,
                        "name": "Fiano",
                        "latitude": "45.21631000",
                        "longitude": "7.52603000"
                    },
                    {
                        "id": 138540,
                        "name": "Fiorano Canavese",
                        "latitude": "45.46776000",
                        "longitude": "7.83372000"
                    },
                    {
                        "id": 138561,
                        "name": "Fleccia-Chianavasso",
                        "latitude": "44.94670000",
                        "longitude": "7.21474000"
                    },
                    {
                        "id": 138570,
                        "name": "Fobello",
                        "latitude": "45.89002000",
                        "longitude": "8.15799000"
                    },
                    {
                        "id": 138576,
                        "name": "Foglizzo",
                        "latitude": "45.27361000",
                        "longitude": "7.82087000"
                    },
                    {
                        "id": 138599,
                        "name": "Fontanella-Ozino",
                        "latitude": "45.61963000",
                        "longitude": "8.16927000"
                    },
                    {
                        "id": 138602,
                        "name": "Fontaneto D'Agogna",
                        "latitude": "45.64347000",
                        "longitude": "8.47879000"
                    },
                    {
                        "id": 138603,
                        "name": "Fontanetto Po",
                        "latitude": "45.19436000",
                        "longitude": "8.19206000"
                    },
                    {
                        "id": 138605,
                        "name": "Fontanile",
                        "latitude": "44.75295000",
                        "longitude": "8.42134000"
                    },
                    {
                        "id": 138634,
                        "name": "Formazza",
                        "latitude": "46.37689000",
                        "longitude": "8.42571000"
                    },
                    {
                        "id": 138641,
                        "name": "Formigliana",
                        "latitude": "45.42926000",
                        "longitude": "8.29193000"
                    },
                    {
                        "id": 138648,
                        "name": "Fornaci",
                        "latitude": "45.02816000",
                        "longitude": "7.59869000"
                    },
                    {
                        "id": 138656,
                        "name": "Forno Canavese",
                        "latitude": "45.34287000",
                        "longitude": "7.58951000"
                    },
                    {
                        "id": 138674,
                        "name": "Fossano",
                        "latitude": "44.55077000",
                        "longitude": "7.71922000"
                    },
                    {
                        "id": 138684,
                        "name": "Frabosa Soprana",
                        "latitude": "44.29094000",
                        "longitude": "7.80353000"
                    },
                    {
                        "id": 138685,
                        "name": "Frabosa Sottana",
                        "latitude": "44.30233000",
                        "longitude": "7.79754000"
                    },
                    {
                        "id": 138686,
                        "name": "Fraconalto",
                        "latitude": "44.59105000",
                        "longitude": "8.87846000"
                    },
                    {
                        "id": 138693,
                        "name": "Francavilla Bisio",
                        "latitude": "44.73465000",
                        "longitude": "8.73125000"
                    },
                    {
                        "id": 138706,
                        "name": "Frascaro",
                        "latitude": "44.82575000",
                        "longitude": "8.53127000"
                    },
                    {
                        "id": 138712,
                        "name": "Frassinello Monferrato",
                        "latitude": "45.03322000",
                        "longitude": "8.38666000"
                    },
                    {
                        "id": 138713,
                        "name": "Frassineto Po",
                        "latitude": "45.13271000",
                        "longitude": "8.53525000"
                    },
                    {
                        "id": 138714,
                        "name": "Frassinetto",
                        "latitude": "45.43834000",
                        "longitude": "7.60886000"
                    },
                    {
                        "id": 138715,
                        "name": "Frassino",
                        "latitude": "44.57211000",
                        "longitude": "7.27536000"
                    },
                    {
                        "id": 138726,
                        "name": "Frazione Chiesa",
                        "latitude": "45.69405000",
                        "longitude": "8.21228000"
                    },
                    {
                        "id": 138732,
                        "name": "Fresonara",
                        "latitude": "44.78295000",
                        "longitude": "8.68615000"
                    },
                    {
                        "id": 138735,
                        "name": "Frinco",
                        "latitude": "45.00405000",
                        "longitude": "8.17193000"
                    },
                    {
                        "id": 138738,
                        "name": "Front",
                        "latitude": "45.27941000",
                        "longitude": "7.66425000"
                    },
                    {
                        "id": 138743,
                        "name": "Frossasco",
                        "latitude": "44.92176000",
                        "longitude": "7.37125000"
                    },
                    {
                        "id": 138744,
                        "name": "Frugarolo",
                        "latitude": "44.83924000",
                        "longitude": "8.68165000"
                    },
                    {
                        "id": 138745,
                        "name": "Fubine",
                        "latitude": "44.96305000",
                        "longitude": "8.42814000"
                    },
                    {
                        "id": 138766,
                        "name": "Gabbio-Cereda-Ramate",
                        "latitude": "45.90959000",
                        "longitude": "8.42113000"
                    },
                    {
                        "id": 138769,
                        "name": "Gabiano",
                        "latitude": "45.15714000",
                        "longitude": "8.19469000"
                    },
                    {
                        "id": 138780,
                        "name": "Gaglianico",
                        "latitude": "45.53718000",
                        "longitude": "8.07839000"
                    },
                    {
                        "id": 138790,
                        "name": "Gaiola",
                        "latitude": "44.33554000",
                        "longitude": "7.40896000"
                    },
                    {
                        "id": 138804,
                        "name": "Galliate",
                        "latitude": "45.47942000",
                        "longitude": "8.69815000"
                    },
                    {
                        "id": 138825,
                        "name": "Gamalero",
                        "latitude": "44.80850000",
                        "longitude": "8.54116000"
                    },
                    {
                        "id": 138828,
                        "name": "Gambasca",
                        "latitude": "44.62950000",
                        "longitude": "7.34686000"
                    },
                    {
                        "id": 138842,
                        "name": "Garadassi",
                        "latitude": "44.75429000",
                        "longitude": "9.15393000"
                    },
                    {
                        "id": 138844,
                        "name": "Garbagna",
                        "latitude": "44.78045000",
                        "longitude": "8.99786000"
                    },
                    {
                        "id": 138845,
                        "name": "Garbagna Novarese",
                        "latitude": "45.38876000",
                        "longitude": "8.66124000"
                    },
                    {
                        "id": 138853,
                        "name": "Garessio",
                        "latitude": "44.20705000",
                        "longitude": "8.01778000"
                    },
                    {
                        "id": 138854,
                        "name": "Gargallo",
                        "latitude": "45.72877000",
                        "longitude": "8.42533000"
                    },
                    {
                        "id": 138857,
                        "name": "Garino",
                        "latitude": "44.97325000",
                        "longitude": "7.61728000"
                    },
                    {
                        "id": 138863,
                        "name": "Garzigliana",
                        "latitude": "44.83724000",
                        "longitude": "7.37442000"
                    },
                    {
                        "id": 138865,
                        "name": "Gassino Torinese",
                        "latitude": "45.12907000",
                        "longitude": "7.82934000"
                    },
                    {
                        "id": 138868,
                        "name": "Gattico",
                        "latitude": "45.70717000",
                        "longitude": "8.52003000"
                    },
                    {
                        "id": 138869,
                        "name": "Gattinara",
                        "latitude": "45.61309000",
                        "longitude": "8.36463000"
                    },
                    {
                        "id": 138873,
                        "name": "Gavazzana",
                        "latitude": "44.77585000",
                        "longitude": "8.88595000"
                    },
                    {
                        "id": 138876,
                        "name": "Gavi",
                        "latitude": "44.68627000",
                        "longitude": "8.80717000"
                    },
                    {
                        "id": 138900,
                        "name": "Genola",
                        "latitude": "44.59053000",
                        "longitude": "7.66114000"
                    },
                    {
                        "id": 138910,
                        "name": "Gerbido",
                        "latitude": "45.04449000",
                        "longitude": "7.61408000"
                    },
                    {
                        "id": 138911,
                        "name": "Gerbole",
                        "latitude": "45.00115000",
                        "longitude": "7.50670000"
                    },
                    {
                        "id": 138912,
                        "name": "Gerbole-Zucche",
                        "latitude": "44.98605000",
                        "longitude": "7.51671000"
                    },
                    {
                        "id": 138916,
                        "name": "Germagnano",
                        "latitude": "45.26317000",
                        "longitude": "7.46886000"
                    },
                    {
                        "id": 138917,
                        "name": "Germagno",
                        "latitude": "45.89257000",
                        "longitude": "8.38772000"
                    },
                    {
                        "id": 138930,
                        "name": "Ghemme",
                        "latitude": "45.59863000",
                        "longitude": "8.42013000"
                    },
                    {
                        "id": 138932,
                        "name": "Ghiare-Madonna",
                        "latitude": "44.80770000",
                        "longitude": "8.37404000"
                    },
                    {
                        "id": 138933,
                        "name": "Ghiffa",
                        "latitude": "45.95298000",
                        "longitude": "8.60430000"
                    },
                    {
                        "id": 138936,
                        "name": "Ghislarengo",
                        "latitude": "45.52856000",
                        "longitude": "8.38514000"
                    },
                    {
                        "id": 138939,
                        "name": "Giaglione",
                        "latitude": "45.13919000",
                        "longitude": "7.01534000"
                    },
                    {
                        "id": 138947,
                        "name": "Giarole",
                        "latitude": "45.06148000",
                        "longitude": "8.56730000"
                    },
                    {
                        "id": 138952,
                        "name": "Giaveno",
                        "latitude": "45.04435000",
                        "longitude": "7.34722000"
                    },
                    {
                        "id": 138955,
                        "name": "Gifflenga",
                        "latitude": "45.49306000",
                        "longitude": "8.23223000"
                    },
                    {
                        "id": 138959,
                        "name": "Gignese",
                        "latitude": "45.86396000",
                        "longitude": "8.50943000"
                    },
                    {
                        "id": 139002,
                        "name": "Givoletto",
                        "latitude": "45.16225000",
                        "longitude": "7.49642000"
                    },
                    {
                        "id": 139023,
                        "name": "Gonte",
                        "latitude": "45.99519000",
                        "longitude": "8.64982000"
                    },
                    {
                        "id": 139042,
                        "name": "Gorzegno",
                        "latitude": "44.51236000",
                        "longitude": "8.13480000"
                    },
                    {
                        "id": 139045,
                        "name": "Gottasecca",
                        "latitude": "44.46014000",
                        "longitude": "8.16754000"
                    },
                    {
                        "id": 139047,
                        "name": "Govone",
                        "latitude": "44.80445000",
                        "longitude": "8.09404000"
                    },
                    {
                        "id": 139048,
                        "name": "Gozzano",
                        "latitude": "45.74273000",
                        "longitude": "8.43659000"
                    },
                    {
                        "id": 139055,
                        "name": "Graglia",
                        "latitude": "45.55800000",
                        "longitude": "7.97899000"
                    },
                    {
                        "id": 139059,
                        "name": "Grana",
                        "latitude": "44.99835000",
                        "longitude": "8.29944000"
                    },
                    {
                        "id": 139067,
                        "name": "Granozzo con Monticello",
                        "latitude": "45.36016000",
                        "longitude": "8.57334000"
                    },
                    {
                        "id": 139080,
                        "name": "Gravellona Toce",
                        "latitude": "45.92859000",
                        "longitude": "8.43209000"
                    },
                    {
                        "id": 139081,
                        "name": "Gravere",
                        "latitude": "45.12534000",
                        "longitude": "7.01751000"
                    },
                    {
                        "id": 139085,
                        "name": "Grazzano Badoglio",
                        "latitude": "45.03996000",
                        "longitude": "8.31105000"
                    },
                    {
                        "id": 139087,
                        "name": "Greggio",
                        "latitude": "45.45148000",
                        "longitude": "8.38494000"
                    },
                    {
                        "id": 139088,
                        "name": "Gremiasco",
                        "latitude": "44.79625000",
                        "longitude": "9.10686000"
                    },
                    {
                        "id": 139099,
                        "name": "Grignasco",
                        "latitude": "45.67982000",
                        "longitude": "8.34442000"
                    },
                    {
                        "id": 139102,
                        "name": "Grinzane Cavour",
                        "latitude": "44.65334000",
                        "longitude": "7.99504000"
                    },
                    {
                        "id": 139107,
                        "name": "Grognardo",
                        "latitude": "44.63034000",
                        "longitude": "8.49265000"
                    },
                    {
                        "id": 139110,
                        "name": "Grondona",
                        "latitude": "44.69645000",
                        "longitude": "8.96546000"
                    },
                    {
                        "id": 139115,
                        "name": "Groscavallo",
                        "latitude": "45.36805000",
                        "longitude": "7.25801000"
                    },
                    {
                        "id": 139119,
                        "name": "Grosso",
                        "latitude": "45.25645000",
                        "longitude": "7.55732000"
                    },
                    {
                        "id": 139134,
                        "name": "Grugliasco",
                        "latitude": "45.06516000",
                        "longitude": "7.57954000"
                    },
                    {
                        "id": 139154,
                        "name": "Guardabosone",
                        "latitude": "45.70187000",
                        "longitude": "8.24932000"
                    },
                    {
                        "id": 139167,
                        "name": "Guarene",
                        "latitude": "44.74004000",
                        "longitude": "8.03514000"
                    },
                    {
                        "id": 139172,
                        "name": "Guazzora",
                        "latitude": "45.01392000",
                        "longitude": "8.84822000"
                    },
                    {
                        "id": 139183,
                        "name": "Gurro",
                        "latitude": "46.08498000",
                        "longitude": "8.56772000"
                    },
                    {
                        "id": 139192,
                        "name": "Igliano",
                        "latitude": "44.44294000",
                        "longitude": "8.01334000"
                    },
                    {
                        "id": 139204,
                        "name": "Incisa Scapaccino",
                        "latitude": "44.80805000",
                        "longitude": "8.37584000"
                    },
                    {
                        "id": 139208,
                        "name": "Ingria",
                        "latitude": "45.46650000",
                        "longitude": "7.57119000"
                    },
                    {
                        "id": 139209,
                        "name": "Intragna",
                        "latitude": "45.99468000",
                        "longitude": "8.57392000"
                    },
                    {
                        "id": 139217,
                        "name": "Inverso Pinasca",
                        "latitude": "44.94564000",
                        "longitude": "7.21841000"
                    },
                    {
                        "id": 139219,
                        "name": "Invorio",
                        "latitude": "45.75679000",
                        "longitude": "8.48741000"
                    },
                    {
                        "id": 139224,
                        "name": "Isasca",
                        "latitude": "44.58763000",
                        "longitude": "7.38162000"
                    },
                    {
                        "id": 139242,
                        "name": "Isola d'Asti",
                        "latitude": "44.83315000",
                        "longitude": "8.18024000"
                    },
                    {
                        "id": 139240,
                        "name": "Isola Sant'Antonio",
                        "latitude": "45.03019000",
                        "longitude": "8.84928000"
                    },
                    {
                        "id": 139252,
                        "name": "Isolabella",
                        "latitude": "44.90645000",
                        "longitude": "7.90903000"
                    },
                    {
                        "id": 139261,
                        "name": "Issiglio",
                        "latitude": "45.44626000",
                        "longitude": "7.75322000"
                    },
                    {
                        "id": 139271,
                        "name": "Ivrea",
                        "latitude": "45.46723000",
                        "longitude": "7.87617000"
                    },
                    {
                        "id": 139289,
                        "name": "La Cassa",
                        "latitude": "45.18035000",
                        "longitude": "7.51632000"
                    },
                    {
                        "id": 139292,
                        "name": "La Loggia",
                        "latitude": "44.95495000",
                        "longitude": "7.66864000"
                    },
                    {
                        "id": 139297,
                        "name": "La Morra",
                        "latitude": "44.63790000",
                        "longitude": "7.93078000"
                    },
                    {
                        "id": 139309,
                        "name": "La Villa",
                        "latitude": "45.26713000",
                        "longitude": "7.43109000"
                    },
                    {
                        "id": 139325,
                        "name": "Lagnasco",
                        "latitude": "44.62504000",
                        "longitude": "7.55483000"
                    },
                    {
                        "id": 139351,
                        "name": "Lamporo",
                        "latitude": "45.23092000",
                        "longitude": "8.09846000"
                    },
                    {
                        "id": 139356,
                        "name": "Landiona",
                        "latitude": "45.49703000",
                        "longitude": "8.42224000"
                    },
                    {
                        "id": 139362,
                        "name": "Lanvario",
                        "latitude": "45.63970000",
                        "longitude": "8.19856000"
                    },
                    {
                        "id": 139365,
                        "name": "Lanzo Torinese",
                        "latitude": "45.27657000",
                        "longitude": "7.48235000"
                    },
                    {
                        "id": 139402,
                        "name": "Lauriano",
                        "latitude": "45.15989000",
                        "longitude": "7.99474000"
                    },
                    {
                        "id": 139439,
                        "name": "Leini",
                        "latitude": "45.18275000",
                        "longitude": "7.71422000"
                    },
                    {
                        "id": 139441,
                        "name": "Lemie",
                        "latitude": "45.22866000",
                        "longitude": "7.29248000"
                    },
                    {
                        "id": 139449,
                        "name": "Lenta",
                        "latitude": "45.55691000",
                        "longitude": "8.38402000"
                    },
                    {
                        "id": 139461,
                        "name": "Lequio Berria",
                        "latitude": "44.60584000",
                        "longitude": "8.09814000"
                    },
                    {
                        "id": 139462,
                        "name": "Lequio Tanaro",
                        "latitude": "44.55994000",
                        "longitude": "7.88214000"
                    },
                    {
                        "id": 139465,
                        "name": "Lerma",
                        "latitude": "44.63577000",
                        "longitude": "8.71323000"
                    },
                    {
                        "id": 139466,
                        "name": "Lesa",
                        "latitude": "45.82066000",
                        "longitude": "8.55964000"
                    },
                    {
                        "id": 139467,
                        "name": "Lesegno",
                        "latitude": "44.40110000",
                        "longitude": "7.96943000"
                    },
                    {
                        "id": 139471,
                        "name": "Lesna",
                        "latitude": "45.05418000",
                        "longitude": "7.62031000"
                    },
                    {
                        "id": 139472,
                        "name": "Lessolo",
                        "latitude": "45.47794000",
                        "longitude": "7.81576000"
                    },
                    {
                        "id": 139473,
                        "name": "Lessona",
                        "latitude": "45.58693000",
                        "longitude": "8.19433000"
                    },
                    {
                        "id": 139487,
                        "name": "Levice",
                        "latitude": "44.53824000",
                        "longitude": "8.15504000"
                    },
                    {
                        "id": 139489,
                        "name": "Levone",
                        "latitude": "45.31665000",
                        "longitude": "7.60632000"
                    },
                    {
                        "id": 139510,
                        "name": "Lignana",
                        "latitude": "45.28606000",
                        "longitude": "8.34393000"
                    },
                    {
                        "id": 139525,
                        "name": "Limone Piemonte",
                        "latitude": "44.20091000",
                        "longitude": "7.57861000"
                    },
                    {
                        "id": 139542,
                        "name": "Lisio",
                        "latitude": "44.30713000",
                        "longitude": "7.97874000"
                    },
                    {
                        "id": 139544,
                        "name": "Litta Parodi-Cascinagrossa",
                        "latitude": "44.87336000",
                        "longitude": "8.71246000"
                    },
                    {
                        "id": 139545,
                        "name": "Livera",
                        "latitude": "45.61239000",
                        "longitude": "8.10571000"
                    },
                    {
                        "id": 139552,
                        "name": "Livorno Ferraris",
                        "latitude": "45.28271000",
                        "longitude": "8.07780000"
                    },
                    {
                        "id": 139558,
                        "name": "Loazzolo",
                        "latitude": "44.66904000",
                        "longitude": "8.25844000"
                    },
                    {
                        "id": 139559,
                        "name": "Locana",
                        "latitude": "45.41419000",
                        "longitude": "7.45712000"
                    },
                    {
                        "id": 139580,
                        "name": "Lombardore",
                        "latitude": "45.23580000",
                        "longitude": "7.73703000"
                    },
                    {
                        "id": 139581,
                        "name": "Lombriasco",
                        "latitude": "44.84094000",
                        "longitude": "7.63593000"
                    },
                    {
                        "id": 139602,
                        "name": "Loranzè",
                        "latitude": "45.44269000",
                        "longitude": "7.81328000"
                    },
                    {
                        "id": 139605,
                        "name": "Loreglia",
                        "latitude": "45.90687000",
                        "longitude": "8.37132000"
                    },
                    {
                        "id": 139625,
                        "name": "Lozzolo",
                        "latitude": "45.61894000",
                        "longitude": "8.32284000"
                    },
                    {
                        "id": 139626,
                        "name": "Lu",
                        "latitude": "45.00184000",
                        "longitude": "8.48561000"
                    },
                    {
                        "id": 139646,
                        "name": "Lugnacco",
                        "latitude": "45.44506000",
                        "longitude": "7.78212000"
                    },
                    {
                        "id": 139654,
                        "name": "Lumellogno",
                        "latitude": "45.40801000",
                        "longitude": "8.58787000"
                    },
                    {
                        "id": 139672,
                        "name": "Luserna",
                        "latitude": "44.80745000",
                        "longitude": "7.24579000"
                    },
                    {
                        "id": 139673,
                        "name": "Lusernetta",
                        "latitude": "44.80314000",
                        "longitude": "7.24672000"
                    },
                    {
                        "id": 139677,
                        "name": "Lusigliè",
                        "latitude": "45.31845000",
                        "longitude": "7.76462000"
                    },
                    {
                        "id": 139695,
                        "name": "Macello",
                        "latitude": "44.85114000",
                        "longitude": "7.39802000"
                    },
                    {
                        "id": 139704,
                        "name": "Macra",
                        "latitude": "44.50013000",
                        "longitude": "7.17952000"
                    },
                    {
                        "id": 139705,
                        "name": "Macugnaga",
                        "latitude": "45.96929000",
                        "longitude": "7.96783000"
                    },
                    {
                        "id": 139710,
                        "name": "Madonna del Sasso",
                        "latitude": "45.79217000",
                        "longitude": "8.36952000"
                    },
                    {
                        "id": 139718,
                        "name": "Maggiora",
                        "latitude": "45.68937000",
                        "longitude": "8.42233000"
                    },
                    {
                        "id": 139723,
                        "name": "Magliano Alfieri",
                        "latitude": "44.76924000",
                        "longitude": "8.07014000"
                    },
                    {
                        "id": 139724,
                        "name": "Magliano Alpi",
                        "latitude": "44.45808000",
                        "longitude": "7.81926000"
                    },
                    {
                        "id": 139733,
                        "name": "Maglione",
                        "latitude": "45.34666000",
                        "longitude": "8.01332000"
                    },
                    {
                        "id": 139734,
                        "name": "Maglione-Crosa",
                        "latitude": "45.60297000",
                        "longitude": "8.14937000"
                    },
                    {
                        "id": 139737,
                        "name": "Magnano",
                        "latitude": "45.46336000",
                        "longitude": "8.00302000"
                    },
                    {
                        "id": 139762,
                        "name": "Malesco",
                        "latitude": "46.12800000",
                        "longitude": "8.49801000"
                    },
                    {
                        "id": 139777,
                        "name": "Malvicino",
                        "latitude": "44.55934000",
                        "longitude": "8.41315000"
                    },
                    {
                        "id": 139787,
                        "name": "Mandello Vitta",
                        "latitude": "45.49567000",
                        "longitude": "8.45983000"
                    },
                    {
                        "id": 139790,
                        "name": "Mandrogne",
                        "latitude": "44.86308000",
                        "longitude": "8.74676000"
                    },
                    {
                        "id": 139797,
                        "name": "Mango",
                        "latitude": "44.68812000",
                        "longitude": "8.14922000"
                    },
                    {
                        "id": 139805,
                        "name": "Manta",
                        "latitude": "44.61583000",
                        "longitude": "7.48703000"
                    },
                    {
                        "id": 139816,
                        "name": "Mappano",
                        "latitude": "45.14833000",
                        "longitude": "7.70778000"
                    },
                    {
                        "id": 139825,
                        "name": "Marano Ticino",
                        "latitude": "45.62783000",
                        "longitude": "8.63155000"
                    },
                    {
                        "id": 139831,
                        "name": "Maranzana",
                        "latitude": "44.76035000",
                        "longitude": "8.47845000"
                    },
                    {
                        "id": 139857,
                        "name": "Marene",
                        "latitude": "44.66113000",
                        "longitude": "7.73436000"
                    },
                    {
                        "id": 139859,
                        "name": "Marentino",
                        "latitude": "45.05368000",
                        "longitude": "7.87609000"
                    },
                    {
                        "id": 139861,
                        "name": "Maretto",
                        "latitude": "44.94485000",
                        "longitude": "8.03413000"
                    },
                    {
                        "id": 139862,
                        "name": "Margarita",
                        "latitude": "44.40343000",
                        "longitude": "7.68493000"
                    },
                    {
                        "id": 139907,
                        "name": "Marmora",
                        "latitude": "44.45833000",
                        "longitude": "7.09402000"
                    },
                    {
                        "id": 139909,
                        "name": "Marocchi",
                        "latitude": "44.94201000",
                        "longitude": "7.81888000"
                    },
                    {
                        "id": 139918,
                        "name": "Marsaglia",
                        "latitude": "44.45284000",
                        "longitude": "7.97994000"
                    },
                    {
                        "id": 139935,
                        "name": "Martiniana Po",
                        "latitude": "44.62723000",
                        "longitude": "7.36282000"
                    },
                    {
                        "id": 139957,
                        "name": "Masera",
                        "latitude": "46.13888000",
                        "longitude": "8.32526000"
                    },
                    {
                        "id": 139962,
                        "name": "Masio",
                        "latitude": "44.86965000",
                        "longitude": "8.40774000"
                    },
                    {
                        "id": 139981,
                        "name": "Massazza",
                        "latitude": "45.49183000",
                        "longitude": "8.16495000"
                    },
                    {
                        "id": 139982,
                        "name": "Massello",
                        "latitude": "44.95874000",
                        "longitude": "7.05671000"
                    },
                    {
                        "id": 139984,
                        "name": "Masserano",
                        "latitude": "45.59536000",
                        "longitude": "8.22197000"
                    },
                    {
                        "id": 139989,
                        "name": "Massino Visconti",
                        "latitude": "45.82417000",
                        "longitude": "8.54133000"
                    },
                    {
                        "id": 139990,
                        "name": "Massiola",
                        "latitude": "45.91247000",
                        "longitude": "8.32012000"
                    },
                    {
                        "id": 139995,
                        "name": "Mathi",
                        "latitude": "45.25515000",
                        "longitude": "7.54202000"
                    },
                    {
                        "id": 140000,
                        "name": "Mattie",
                        "latitude": "45.11814000",
                        "longitude": "7.11511000"
                    },
                    {
                        "id": 140010,
                        "name": "Mazze",
                        "latitude": "45.30025000",
                        "longitude": "7.93272000"
                    },
                    {
                        "id": 140014,
                        "name": "Meana di Susa",
                        "latitude": "45.12204000",
                        "longitude": "7.06471000"
                    },
                    {
                        "id": 140032,
                        "name": "Meina",
                        "latitude": "45.79123000",
                        "longitude": "8.53761000"
                    },
                    {
                        "id": 140036,
                        "name": "Melazzo",
                        "latitude": "44.64394000",
                        "longitude": "8.42495000"
                    },
                    {
                        "id": 140054,
                        "name": "Melle",
                        "latitude": "44.56197000",
                        "longitude": "7.31948000"
                    },
                    {
                        "id": 140067,
                        "name": "Merana",
                        "latitude": "44.51884000",
                        "longitude": "8.29824000"
                    },
                    {
                        "id": 140080,
                        "name": "Mercenasco",
                        "latitude": "45.36002000",
                        "longitude": "7.88013000"
                    },
                    {
                        "id": 140084,
                        "name": "Mergozzo",
                        "latitude": "45.96229000",
                        "longitude": "8.45403000"
                    },
                    {
                        "id": 140103,
                        "name": "Meugliano",
                        "latitude": "45.49026000",
                        "longitude": "7.77942000"
                    },
                    {
                        "id": 140107,
                        "name": "Mezzana Mortigliengo",
                        "latitude": "45.62657000",
                        "longitude": "8.18952000"
                    },
                    {
                        "id": 140117,
                        "name": "Mezzenile",
                        "latitude": "45.29485000",
                        "longitude": "7.39561000"
                    },
                    {
                        "id": 140124,
                        "name": "Mezzomerico",
                        "latitude": "45.61991000",
                        "longitude": "8.60616000"
                    },
                    {
                        "id": 140125,
                        "name": "Miagliano",
                        "latitude": "45.61346000",
                        "longitude": "8.04472000"
                    },
                    {
                        "id": 140128,
                        "name": "Miasino",
                        "latitude": "45.80197000",
                        "longitude": "8.42972000"
                    },
                    {
                        "id": 140129,
                        "name": "Miazzina",
                        "latitude": "45.97566000",
                        "longitude": "8.52308000"
                    },
                    {
                        "id": 140143,
                        "name": "Milanere",
                        "latitude": "45.10436000",
                        "longitude": "7.43373000"
                    },
                    {
                        "id": 140170,
                        "name": "Mirabello Monferrato",
                        "latitude": "45.03496000",
                        "longitude": "8.52385000"
                    },
                    {
                        "id": 140186,
                        "name": "Moasca",
                        "latitude": "44.76355000",
                        "longitude": "8.27834000"
                    },
                    {
                        "id": 140208,
                        "name": "Moiola",
                        "latitude": "44.32113000",
                        "longitude": "7.38973000"
                    },
                    {
                        "id": 140210,
                        "name": "Molare",
                        "latitude": "44.61807000",
                        "longitude": "8.59960000"
                    },
                    {
                        "id": 140222,
                        "name": "Molino dei Torti",
                        "latitude": "45.02426000",
                        "longitude": "8.89365000"
                    },
                    {
                        "id": 140229,
                        "name": "Mollia",
                        "latitude": "45.81667000",
                        "longitude": "8.03031000"
                    },
                    {
                        "id": 140234,
                        "name": "Mombaldone",
                        "latitude": "44.57025000",
                        "longitude": "8.33302000"
                    },
                    {
                        "id": 140235,
                        "name": "Mombarcaro",
                        "latitude": "44.46764000",
                        "longitude": "8.08824000"
                    },
                    {
                        "id": 140237,
                        "name": "Mombaruzzo",
                        "latitude": "44.77145000",
                        "longitude": "8.44824000"
                    },
                    {
                        "id": 140238,
                        "name": "Mombasiglio",
                        "latitude": "44.36663000",
                        "longitude": "7.96794000"
                    },
                    {
                        "id": 140241,
                        "name": "Mombello di Torino",
                        "latitude": "45.04575000",
                        "longitude": "7.92083000"
                    },
                    {
                        "id": 140240,
                        "name": "Mombello Monferrato",
                        "latitude": "45.13285000",
                        "longitude": "8.25033000"
                    },
                    {
                        "id": 140242,
                        "name": "Mombercelli",
                        "latitude": "44.81785000",
                        "longitude": "8.29474000"
                    },
                    {
                        "id": 140244,
                        "name": "Momo",
                        "latitude": "45.57424000",
                        "longitude": "8.55390000"
                    },
                    {
                        "id": 140245,
                        "name": "Mompantero",
                        "latitude": "45.14744000",
                        "longitude": "7.04301000"
                    },
                    {
                        "id": 140247,
                        "name": "Momperone",
                        "latitude": "44.83845000",
                        "longitude": "9.03425000"
                    },
                    {
                        "id": 140249,
                        "name": "Monale",
                        "latitude": "44.93755000",
                        "longitude": "8.07243000"
                    },
                    {
                        "id": 140252,
                        "name": "Monastero Bormida",
                        "latitude": "44.64854000",
                        "longitude": "8.32664000"
                    },
                    {
                        "id": 140253,
                        "name": "Monastero di Lanzo",
                        "latitude": "45.30185000",
                        "longitude": "7.43971000"
                    },
                    {
                        "id": 140254,
                        "name": "Monastero di Vasco",
                        "latitude": "44.34033000",
                        "longitude": "7.82264000"
                    },
                    {
                        "id": 140255,
                        "name": "Monasterolo",
                        "latitude": "45.23549000",
                        "longitude": "7.50821000"
                    },
                    {
                        "id": 140257,
                        "name": "Monasterolo Casotto",
                        "latitude": "44.32823000",
                        "longitude": "7.94324000"
                    },
                    {
                        "id": 140259,
                        "name": "Monasterolo di Savigliano",
                        "latitude": "44.68634000",
                        "longitude": "7.61953000"
                    },
                    {
                        "id": 140262,
                        "name": "Moncalieri",
                        "latitude": "44.99940000",
                        "longitude": "7.68236000"
                    },
                    {
                        "id": 140263,
                        "name": "Moncalvo",
                        "latitude": "45.05057000",
                        "longitude": "8.26277000"
                    },
                    {
                        "id": 140264,
                        "name": "Moncenisio",
                        "latitude": "45.20404000",
                        "longitude": "6.98461000"
                    },
                    {
                        "id": 140265,
                        "name": "Moncestino",
                        "latitude": "45.15465000",
                        "longitude": "8.16143000"
                    },
                    {
                        "id": 140266,
                        "name": "Monchiero Borgonuovo",
                        "latitude": "44.57054000",
                        "longitude": "7.92024000"
                    },
                    {
                        "id": 140269,
                        "name": "Moncrivello",
                        "latitude": "45.33236000",
                        "longitude": "7.99552000"
                    },
                    {
                        "id": 140271,
                        "name": "Moncucco Torinese",
                        "latitude": "45.06738000",
                        "longitude": "7.93246000"
                    },
                    {
                        "id": 140275,
                        "name": "Mondovì",
                        "latitude": "44.39603000",
                        "longitude": "7.81764000"
                    },
                    {
                        "id": 140278,
                        "name": "Monesiglio",
                        "latitude": "44.46550000",
                        "longitude": "8.11915000"
                    },
                    {
                        "id": 140281,
                        "name": "Monforte d'Alba",
                        "latitude": "44.58271000",
                        "longitude": "7.96793000"
                    },
                    {
                        "id": 140283,
                        "name": "Mongardino",
                        "latitude": "44.84915000",
                        "longitude": "8.21906000"
                    },
                    {
                        "id": 140286,
                        "name": "Mongiardino Ligure",
                        "latitude": "44.63443000",
                        "longitude": "9.06462000"
                    },
                    {
                        "id": 140289,
                        "name": "Mongrando",
                        "latitude": "45.52826000",
                        "longitude": "8.00712000"
                    },
                    {
                        "id": 140294,
                        "name": "Monleale",
                        "latitude": "44.88435000",
                        "longitude": "8.97395000"
                    },
                    {
                        "id": 140591,
                        "name": "Montà",
                        "latitude": "44.81474000",
                        "longitude": "7.95477000"
                    },
                    {
                        "id": 140304,
                        "name": "Montabone",
                        "latitude": "44.69875000",
                        "longitude": "8.39064000"
                    },
                    {
                        "id": 140305,
                        "name": "Montacuto",
                        "latitude": "44.76645000",
                        "longitude": "9.10496000"
                    },
                    {
                        "id": 140306,
                        "name": "Montafia",
                        "latitude": "44.98925000",
                        "longitude": "8.02463000"
                    },
                    {
                        "id": 140320,
                        "name": "Montaldeo",
                        "latitude": "44.66715000",
                        "longitude": "8.73015000"
                    },
                    {
                        "id": 140321,
                        "name": "Montaldo Bormida",
                        "latitude": "44.68265000",
                        "longitude": "8.58785000"
                    },
                    {
                        "id": 140325,
                        "name": "Montaldo di Mondovì",
                        "latitude": "44.32173000",
                        "longitude": "7.86714000"
                    },
                    {
                        "id": 140322,
                        "name": "Montaldo Roero",
                        "latitude": "44.76834000",
                        "longitude": "7.92483000"
                    },
                    {
                        "id": 140323,
                        "name": "Montaldo Scarampi",
                        "latitude": "44.83035000",
                        "longitude": "8.25904000"
                    },
                    {
                        "id": 140324,
                        "name": "Montaldo Torinese",
                        "latitude": "45.06535000",
                        "longitude": "7.85023000"
                    },
                    {
                        "id": 140328,
                        "name": "Montalenghe",
                        "latitude": "45.33666000",
                        "longitude": "7.83794000"
                    },
                    {
                        "id": 140331,
                        "name": "Montalto Dora",
                        "latitude": "45.48993000",
                        "longitude": "7.86253000"
                    },
                    {
                        "id": 140339,
                        "name": "Montanaro",
                        "latitude": "45.23274000",
                        "longitude": "7.85492000"
                    },
                    {
                        "id": 140341,
                        "name": "Montanera",
                        "latitude": "44.46223000",
                        "longitude": "7.66563000"
                    },
                    {
                        "id": 140347,
                        "name": "Montariolo",
                        "latitude": "44.99575000",
                        "longitude": "8.77539000"
                    },
                    {
                        "id": 140403,
                        "name": "Montecastello",
                        "latitude": "44.94945000",
                        "longitude": "8.68575000"
                    },
                    {
                        "id": 140414,
                        "name": "Montechiaro d'Acqui",
                        "latitude": "44.59444000",
                        "longitude": "8.37865000"
                    },
                    {
                        "id": 140415,
                        "name": "Montechiaro d'Asti",
                        "latitude": "45.00701000",
                        "longitude": "8.11286000"
                    },
                    {
                        "id": 140424,
                        "name": "Montecrestese",
                        "latitude": "46.16448000",
                        "longitude": "8.32621000"
                    },
                    {
                        "id": 140453,
                        "name": "Montegioco",
                        "latitude": "44.84205000",
                        "longitude": "8.96275000"
                    },
                    {
                        "id": 140459,
                        "name": "Montegrosso",
                        "latitude": "44.82065000",
                        "longitude": "8.23754000"
                    },
                    {
                        "id": 140474,
                        "name": "Montelera",
                        "latitude": "45.15429000",
                        "longitude": "7.44290000"
                    },
                    {
                        "id": 140480,
                        "name": "Montelupo Albese",
                        "latitude": "44.62151000",
                        "longitude": "8.04720000"
                    },
                    {
                        "id": 140485,
                        "name": "Montemagno",
                        "latitude": "44.98305000",
                        "longitude": "8.32534000"
                    },
                    {
                        "id": 140486,
                        "name": "Montemale di Cuneo",
                        "latitude": "44.43743000",
                        "longitude": "7.37533000"
                    },
                    {
                        "id": 140489,
                        "name": "Montemarzino",
                        "latitude": "44.84835000",
                        "longitude": "8.99365000"
                    },
                    {
                        "id": 140524,
                        "name": "Monterosso Grana",
                        "latitude": "44.40823000",
                        "longitude": "7.32293000"
                    },
                    {
                        "id": 140536,
                        "name": "Montescheno",
                        "latitude": "46.06658000",
                        "longitude": "8.23192000"
                    },
                    {
                        "id": 140545,
                        "name": "Monteu da Po",
                        "latitude": "45.15031000",
                        "longitude": "8.01428000"
                    },
                    {
                        "id": 140544,
                        "name": "Monteu Roero",
                        "latitude": "44.78059000",
                        "longitude": "7.93383000"
                    },
                    {
                        "id": 140552,
                        "name": "Montezemolo",
                        "latitude": "44.37703000",
                        "longitude": "8.14114000"
                    },
                    {
                        "id": 140567,
                        "name": "Monticello d'Alba",
                        "latitude": "44.71894000",
                        "longitude": "7.94263000"
                    },
                    {
                        "id": 140572,
                        "name": "Montiglio",
                        "latitude": "45.06462000",
                        "longitude": "8.09878000"
                    },
                    {
                        "id": 140598,
                        "name": "Morano sul Po",
                        "latitude": "45.16621000",
                        "longitude": "8.36674000"
                    },
                    {
                        "id": 140599,
                        "name": "Moransengo",
                        "latitude": "45.11485000",
                        "longitude": "8.02523000"
                    },
                    {
                        "id": 140603,
                        "name": "Morbello",
                        "latitude": "44.60504000",
                        "longitude": "8.51075000"
                    },
                    {
                        "id": 140611,
                        "name": "Moretta",
                        "latitude": "44.76137000",
                        "longitude": "7.53632000"
                    },
                    {
                        "id": 140621,
                        "name": "Moriondo Torinese",
                        "latitude": "45.03853000",
                        "longitude": "7.94086000"
                    },
                    {
                        "id": 140625,
                        "name": "Mornese",
                        "latitude": "44.63925000",
                        "longitude": "8.75615000"
                    },
                    {
                        "id": 140630,
                        "name": "Morozzo",
                        "latitude": "44.42277000",
                        "longitude": "7.71006000"
                    },
                    {
                        "id": 140638,
                        "name": "Morsasco",
                        "latitude": "44.66535000",
                        "longitude": "8.55085000"
                    },
                    {
                        "id": 140653,
                        "name": "Mosso",
                        "latitude": "45.65007000",
                        "longitude": "8.13762000"
                    },
                    {
                        "id": 140654,
                        "name": "Mosso Santa Maria",
                        "latitude": "45.64958000",
                        "longitude": "8.13682000"
                    },
                    {
                        "id": 140658,
                        "name": "Motta Dè Conti",
                        "latitude": "45.19356000",
                        "longitude": "8.52094000"
                    },
                    {
                        "id": 140667,
                        "name": "Mottalciata",
                        "latitude": "45.50019000",
                        "longitude": "8.21065000"
                    },
                    {
                        "id": 140687,
                        "name": "Murazzano",
                        "latitude": "44.47334000",
                        "longitude": "8.01938000"
                    },
                    {
                        "id": 140689,
                        "name": "Murello",
                        "latitude": "44.75214000",
                        "longitude": "7.60093000"
                    },
                    {
                        "id": 140691,
                        "name": "Murisengo",
                        "latitude": "45.08165000",
                        "longitude": "8.13554000"
                    },
                    {
                        "id": 140705,
                        "name": "Mussotto",
                        "latitude": "44.71766000",
                        "longitude": "8.03404000"
                    },
                    {
                        "id": 140708,
                        "name": "Muzzano",
                        "latitude": "45.56076000",
                        "longitude": "7.98892000"
                    },
                    {
                        "id": 140722,
                        "name": "Narzole",
                        "latitude": "44.59441000",
                        "longitude": "7.86765000"
                    },
                    {
                        "id": 140734,
                        "name": "Nebbiuno",
                        "latitude": "45.80774000",
                        "longitude": "8.52593000"
                    },
                    {
                        "id": 140738,
                        "name": "Neive-Borgonovo",
                        "latitude": "44.72397000",
                        "longitude": "8.11780000"
                    },
                    {
                        "id": 140752,
                        "name": "Netro",
                        "latitude": "45.54004000",
                        "longitude": "7.94695000"
                    },
                    {
                        "id": 140756,
                        "name": "Neviglie",
                        "latitude": "44.69194000",
                        "longitude": "8.11684000"
                    },
                    {
                        "id": 140759,
                        "name": "Nibbiola",
                        "latitude": "45.37236000",
                        "longitude": "8.65674000"
                    },
                    {
                        "id": 140762,
                        "name": "Nichelino",
                        "latitude": "45.00031000",
                        "longitude": "7.65305000"
                    },
                    {
                        "id": 140767,
                        "name": "Niella Belbo",
                        "latitude": "44.51275000",
                        "longitude": "8.08036000"
                    },
                    {
                        "id": 140768,
                        "name": "Niella Tanaro",
                        "latitude": "44.40573000",
                        "longitude": "7.92794000"
                    },
                    {
                        "id": 140774,
                        "name": "Nizza Monferrato",
                        "latitude": "44.77416000",
                        "longitude": "8.35784000"
                    },
                    {
                        "id": 140777,
                        "name": "Noasca",
                        "latitude": "45.45332000",
                        "longitude": "7.31494000"
                    },
                    {
                        "id": 140798,
                        "name": "Nole",
                        "latitude": "45.24159000",
                        "longitude": "7.56983000"
                    },
                    {
                        "id": 140800,
                        "name": "Nomaglio",
                        "latitude": "45.53616000",
                        "longitude": "7.86032000"
                    },
                    {
                        "id": 140803,
                        "name": "None",
                        "latitude": "44.93645000",
                        "longitude": "7.54015000"
                    },
                    {
                        "id": 140804,
                        "name": "Nonio",
                        "latitude": "45.84577000",
                        "longitude": "8.37752000"
                    },
                    {
                        "id": 140821,
                        "name": "Novalesa",
                        "latitude": "45.19065000",
                        "longitude": "7.01416000"
                    },
                    {
                        "id": 140822,
                        "name": "Novara",
                        "latitude": "45.44694000",
                        "longitude": "8.62118000"
                    },
                    {
                        "id": 140830,
                        "name": "Novello",
                        "latitude": "44.58882000",
                        "longitude": "7.92587000"
                    },
                    {
                        "id": 140835,
                        "name": "Novi Ligure",
                        "latitude": "44.76246000",
                        "longitude": "8.78700000"
                    },
                    {
                        "id": 140841,
                        "name": "Nucetto",
                        "latitude": "44.33963000",
                        "longitude": "8.05960000"
                    },
                    {
                        "id": 140866,
                        "name": "Occhieppo Inferiore",
                        "latitude": "45.55006000",
                        "longitude": "8.02102000"
                    },
                    {
                        "id": 140867,
                        "name": "Occhieppo Superiore",
                        "latitude": "45.56400000",
                        "longitude": "8.00618000"
                    },
                    {
                        "id": 140869,
                        "name": "Occimiano",
                        "latitude": "45.05991000",
                        "longitude": "8.50666000"
                    },
                    {
                        "id": 140870,
                        "name": "Odalengo Grande",
                        "latitude": "45.10922000",
                        "longitude": "8.16748000"
                    },
                    {
                        "id": 140871,
                        "name": "Odalengo Piccolo",
                        "latitude": "45.07165000",
                        "longitude": "8.20603000"
                    },
                    {
                        "id": 140879,
                        "name": "Oggebbio",
                        "latitude": "45.99088000",
                        "longitude": "8.64663000"
                    },
                    {
                        "id": 140882,
                        "name": "Oglianico",
                        "latitude": "45.34154000",
                        "longitude": "7.69196000"
                    },
                    {
                        "id": 140885,
                        "name": "Olcenengo",
                        "latitude": "45.36346000",
                        "longitude": "8.30983000"
                    },
                    {
                        "id": 140886,
                        "name": "Oldenico",
                        "latitude": "45.40276000",
                        "longitude": "8.38103000"
                    },
                    {
                        "id": 140887,
                        "name": "Oleggio",
                        "latitude": "45.59674000",
                        "longitude": "8.64213000"
                    },
                    {
                        "id": 140888,
                        "name": "Oleggio Castello",
                        "latitude": "45.74887000",
                        "longitude": "8.52713000"
                    },
                    {
                        "id": 140904,
                        "name": "Olivola",
                        "latitude": "45.03725000",
                        "longitude": "8.36784000"
                    },
                    {
                        "id": 140910,
                        "name": "Olmo Gentile",
                        "latitude": "44.58574000",
                        "longitude": "8.24694000"
                    },
                    {
                        "id": 140918,
                        "name": "Omegna",
                        "latitude": "45.88002000",
                        "longitude": "8.40665000"
                    },
                    {
                        "id": 140922,
                        "name": "Oncino",
                        "latitude": "44.67683000",
                        "longitude": "7.19032000"
                    },
                    {
                        "id": 140939,
                        "name": "Orbassano",
                        "latitude": "45.00547000",
                        "longitude": "7.53813000"
                    },
                    {
                        "id": 140955,
                        "name": "Orio Canavese",
                        "latitude": "45.32883000",
                        "longitude": "7.85991000"
                    },
                    {
                        "id": 140961,
                        "name": "Ormea",
                        "latitude": "44.15586000",
                        "longitude": "7.92811000"
                    },
                    {
                        "id": 140964,
                        "name": "Ornavasso",
                        "latitude": "45.96795000",
                        "longitude": "8.41584000"
                    },
                    {
                        "id": 140971,
                        "name": "Orsara Bormida",
                        "latitude": "44.69015000",
                        "longitude": "8.56275000"
                    },
                    {
                        "id": 140978,
                        "name": "Orta San Giulio",
                        "latitude": "45.79727000",
                        "longitude": "8.41437000"
                    },
                    {
                        "id": 140999,
                        "name": "Osasco",
                        "latitude": "44.84944000",
                        "longitude": "7.34302000"
                    },
                    {
                        "id": 141000,
                        "name": "Osasio",
                        "latitude": "44.87144000",
                        "longitude": "7.60802000"
                    },
                    {
                        "id": 141030,
                        "name": "Ostana",
                        "latitude": "44.69263000",
                        "longitude": "7.18942000"
                    },
                    {
                        "id": 141051,
                        "name": "Ottiglio",
                        "latitude": "45.05426000",
                        "longitude": "8.33980000"
                    },
                    {
                        "id": 141054,
                        "name": "Oulx",
                        "latitude": "45.03641000",
                        "longitude": "6.83372000"
                    },
                    {
                        "id": 141055,
                        "name": "Ovada",
                        "latitude": "44.63727000",
                        "longitude": "8.64196000"
                    },
                    {
                        "id": 141057,
                        "name": "Oviglio",
                        "latitude": "44.86125000",
                        "longitude": "8.48774000"
                    },
                    {
                        "id": 141061,
                        "name": "Ozegna",
                        "latitude": "45.34801000",
                        "longitude": "7.74503000"
                    },
                    {
                        "id": 141063,
                        "name": "Ozzano Monferrato",
                        "latitude": "45.10592000",
                        "longitude": "8.37238000"
                    },
                    {
                        "id": 141075,
                        "name": "Paderna",
                        "latitude": "44.82148000",
                        "longitude": "8.89088000"
                    },
                    {
                        "id": 141092,
                        "name": "Paesana",
                        "latitude": "44.68332000",
                        "longitude": "7.27571000"
                    },
                    {
                        "id": 58211,
                        "name": "Pagno",
                        "latitude": "44.61173000",
                        "longitude": "7.42572000"
                    },
                    {
                        "id": 58229,
                        "name": "Palazzo Canavese",
                        "latitude": "45.45962000",
                        "longitude": "7.97776000"
                    },
                    {
                        "id": 58234,
                        "name": "Palazzolo Vercellese",
                        "latitude": "45.18554000",
                        "longitude": "8.23302000"
                    },
                    {
                        "id": 58249,
                        "name": "Pallanza-Intra-Suna",
                        "latitude": "45.93778000",
                        "longitude": "8.57088000"
                    },
                    {
                        "id": 58250,
                        "name": "Pallanzeno",
                        "latitude": "46.04202000",
                        "longitude": "8.25949000"
                    },
                    {
                        "id": 58272,
                        "name": "Pamparato",
                        "latitude": "44.27666000",
                        "longitude": "7.91432000"
                    },
                    {
                        "id": 58273,
                        "name": "Pancalieri",
                        "latitude": "44.83344000",
                        "longitude": "7.58592000"
                    },
                    {
                        "id": 58301,
                        "name": "Parella",
                        "latitude": "45.43018000",
                        "longitude": "7.79128000"
                    },
                    {
                        "id": 58304,
                        "name": "Pareto",
                        "latitude": "44.51644000",
                        "longitude": "8.38185000"
                    },
                    {
                        "id": 58309,
                        "name": "Parodi Ligure",
                        "latitude": "44.66975000",
                        "longitude": "8.75865000"
                    },
                    {
                        "id": 58310,
                        "name": "Paroldo",
                        "latitude": "44.43204000",
                        "longitude": "8.07244000"
                    },
                    {
                        "id": 58318,
                        "name": "Paruzzaro",
                        "latitude": "45.74818000",
                        "longitude": "8.51486000"
                    },
                    {
                        "id": 58327,
                        "name": "Passerano Marmorito",
                        "latitude": "45.05585000",
                        "longitude": "8.01873000"
                    },
                    {
                        "id": 58336,
                        "name": "Pasta",
                        "latitude": "45.01131000",
                        "longitude": "7.55243000"
                    },
                    {
                        "id": 58341,
                        "name": "Pasturana",
                        "latitude": "44.75085000",
                        "longitude": "8.74925000"
                    },
                    {
                        "id": 58358,
                        "name": "Pavarolo",
                        "latitude": "45.06665000",
                        "longitude": "7.83943000"
                    },
                    {
                        "id": 58363,
                        "name": "Pavone Canavese",
                        "latitude": "45.44193000",
                        "longitude": "7.85294000"
                    },
                    {
                        "id": 58368,
                        "name": "Pecco",
                        "latitude": "45.45206000",
                        "longitude": "7.77742000"
                    },
                    {
                        "id": 58369,
                        "name": "Pecetto",
                        "latitude": "45.01760000",
                        "longitude": "7.75107000"
                    },
                    {
                        "id": 58370,
                        "name": "Pecetto di Valenza",
                        "latitude": "44.98904000",
                        "longitude": "8.66996000"
                    },
                    {
                        "id": 58391,
                        "name": "Pella",
                        "latitude": "45.79722000",
                        "longitude": "8.38444000"
                    },
                    {
                        "id": 58399,
                        "name": "Penango",
                        "latitude": "45.03295000",
                        "longitude": "8.25174000"
                    },
                    {
                        "id": 58428,
                        "name": "Perletto",
                        "latitude": "44.59934000",
                        "longitude": "8.21304000"
                    },
                    {
                        "id": 58429,
                        "name": "Perlo",
                        "latitude": "44.33183000",
                        "longitude": "8.08554000"
                    },
                    {
                        "id": 58431,
                        "name": "Pernate",
                        "latitude": "45.45958000",
                        "longitude": "8.67845000"
                    },
                    {
                        "id": 58436,
                        "name": "Perosa Argentina",
                        "latitude": "44.95909000",
                        "longitude": "7.19167000"
                    },
                    {
                        "id": 58437,
                        "name": "Perosa Canavese",
                        "latitude": "45.39706000",
                        "longitude": "7.83082000"
                    },
                    {
                        "id": 58438,
                        "name": "Perrero",
                        "latitude": "44.93849000",
                        "longitude": "7.11263000"
                    },
                    {
                        "id": 58441,
                        "name": "Pertengo",
                        "latitude": "45.23606000",
                        "longitude": "8.41651000"
                    },
                    {
                        "id": 58445,
                        "name": "Pertusio",
                        "latitude": "45.35565000",
                        "longitude": "7.64152000"
                    },
                    {
                        "id": 58471,
                        "name": "Pessinetto",
                        "latitude": "45.28675000",
                        "longitude": "7.41531000"
                    },
                    {
                        "id": 58472,
                        "name": "Pessione",
                        "latitude": "44.96504000",
                        "longitude": "7.84115000"
                    },
                    {
                        "id": 58489,
                        "name": "Pettenasco",
                        "latitude": "45.81657000",
                        "longitude": "8.40702000"
                    },
                    {
                        "id": 58490,
                        "name": "Pettinengo",
                        "latitude": "45.61306000",
                        "longitude": "8.10422000"
                    },
                    {
                        "id": 58495,
                        "name": "Peveragno",
                        "latitude": "44.32060000",
                        "longitude": "7.61859000"
                    },
                    {
                        "id": 58497,
                        "name": "Pezzana",
                        "latitude": "45.26152000",
                        "longitude": "8.48396000"
                    },
                    {
                        "id": 58501,
                        "name": "Pezzolo Valle Uzzone",
                        "latitude": "44.53874000",
                        "longitude": "8.19394000"
                    },
                    {
                        "id": 58513,
                        "name": "Piana San Raffaele",
                        "latitude": "45.15290000",
                        "longitude": "7.85013000"
                    },
                    {
                        "id": 58529,
                        "name": "Pianezza",
                        "latitude": "45.10420000",
                        "longitude": "7.55003000"
                    },
                    {
                        "id": 58531,
                        "name": "Pianfei",
                        "latitude": "44.37203000",
                        "longitude": "7.71143000"
                    },
                    {
                        "id": 58546,
                        "name": "Piano-Molini d'Isola",
                        "latitude": "44.83194000",
                        "longitude": "8.18073000"
                    },
                    {
                        "id": 58556,
                        "name": "Piasco",
                        "latitude": "44.56106000",
                        "longitude": "7.44420000"
                    },
                    {
                        "id": 58558,
                        "name": "Piatto",
                        "latitude": "45.58986000",
                        "longitude": "8.13532000"
                    },
                    {
                        "id": 58564,
                        "name": "Piazza",
                        "latitude": "44.38597000",
                        "longitude": "7.83163000"
                    },
                    {
                        "id": 58586,
                        "name": "Piea",
                        "latitude": "45.02706000",
                        "longitude": "8.07146000"
                    },
                    {
                        "id": 58587,
                        "name": "Piedicavallo",
                        "latitude": "45.68986000",
                        "longitude": "7.95482000"
                    },
                    {
                        "id": 58593,
                        "name": "Piedimulera",
                        "latitude": "46.02408000",
                        "longitude": "8.25897000"
                    },
                    {
                        "id": 58602,
                        "name": "Pietra Marazzi",
                        "latitude": "44.94265000",
                        "longitude": "8.66854000"
                    },
                    {
                        "id": 58623,
                        "name": "Pietraporzio",
                        "latitude": "44.34352000",
                        "longitude": "7.03433000"
                    },
                    {
                        "id": 58642,
                        "name": "Pieve Vergonte",
                        "latitude": "46.01298000",
                        "longitude": "8.26082000"
                    },
                    {
                        "id": 58667,
                        "name": "Pila",
                        "latitude": "45.76997000",
                        "longitude": "8.08122000"
                    },
                    {
                        "id": 58673,
                        "name": "Pinasca-Dubbione",
                        "latitude": "44.94264000",
                        "longitude": "7.22912000"
                    },
                    {
                        "id": 58675,
                        "name": "Pinerolo",
                        "latitude": "44.88534000",
                        "longitude": "7.33135000"
                    },
                    {
                        "id": 58679,
                        "name": "Pino d'Asti",
                        "latitude": "45.05745000",
                        "longitude": "7.98623000"
                    },
                    {
                        "id": 58678,
                        "name": "Pino Torinese",
                        "latitude": "45.03955000",
                        "longitude": "7.77712000"
                    },
                    {
                        "id": 58686,
                        "name": "Piobesi d'Alba",
                        "latitude": "44.73444000",
                        "longitude": "7.97937000"
                    },
                    {
                        "id": 58685,
                        "name": "Piobesi Torinese",
                        "latitude": "44.76667000",
                        "longitude": "7.61667000"
                    },
                    {
                        "id": 58687,
                        "name": "Piode",
                        "latitude": "45.77059000",
                        "longitude": "8.05265000"
                    },
                    {
                        "id": 58694,
                        "name": "Piossasco",
                        "latitude": "44.98802000",
                        "longitude": "7.46010000"
                    },
                    {
                        "id": 58698,
                        "name": "Piovà Massaia",
                        "latitude": "45.05515000",
                        "longitude": "8.05013000"
                    },
                    {
                        "id": 58697,
                        "name": "Piovera",
                        "latitude": "44.95845000",
                        "longitude": "8.73595000"
                    },
                    {
                        "id": 58700,
                        "name": "Piozzo",
                        "latitude": "44.51384000",
                        "longitude": "7.89254000"
                    },
                    {
                        "id": 58703,
                        "name": "Pisano",
                        "latitude": "45.79567000",
                        "longitude": "8.51487000"
                    },
                    {
                        "id": 58704,
                        "name": "Piscina",
                        "latitude": "44.91874000",
                        "longitude": "7.42532000"
                    },
                    {
                        "id": 58722,
                        "name": "Piverone",
                        "latitude": "45.44557000",
                        "longitude": "8.00745000"
                    },
                    {
                        "id": 58738,
                        "name": "Pleyne",
                        "latitude": "44.58063000",
                        "longitude": "7.01712000"
                    },
                    {
                        "id": 58742,
                        "name": "Pocapaglia",
                        "latitude": "44.71524000",
                        "longitude": "7.88293000"
                    },
                    {
                        "id": 58777,
                        "name": "Pogno",
                        "latitude": "45.75806000",
                        "longitude": "8.38559000"
                    },
                    {
                        "id": 58781,
                        "name": "Poirino",
                        "latitude": "44.92047000",
                        "longitude": "7.84465000"
                    },
                    {
                        "id": 58801,
                        "name": "Pollone",
                        "latitude": "45.57976000",
                        "longitude": "8.00592000"
                    },
                    {
                        "id": 58803,
                        "name": "Polonghera",
                        "latitude": "44.80234000",
                        "longitude": "7.59572000"
                    },
                    {
                        "id": 58809,
                        "name": "Pomaretto",
                        "latitude": "45.15194000",
                        "longitude": "8.04661000"
                    },
                    {
                        "id": 58811,
                        "name": "Pomaro Monferrato",
                        "latitude": "45.06246000",
                        "longitude": "8.59604000"
                    },
                    {
                        "id": 58813,
                        "name": "Pombia",
                        "latitude": "45.65550000",
                        "longitude": "8.62846000"
                    },
                    {
                        "id": 58823,
                        "name": "Ponderano",
                        "latitude": "45.53846000",
                        "longitude": "8.05592000"
                    },
                    {
                        "id": 58828,
                        "name": "Pont-Canavese",
                        "latitude": "45.42138000",
                        "longitude": "7.60024000"
                    },
                    {
                        "id": 58865,
                        "name": "Pontechianale",
                        "latitude": "44.62123000",
                        "longitude": "7.03002000"
                    },
                    {
                        "id": 58867,
                        "name": "Pontecurone",
                        "latitude": "44.95880000",
                        "longitude": "8.93289000"
                    },
                    {
                        "id": 58879,
                        "name": "Pontestura",
                        "latitude": "45.14245000",
                        "longitude": "8.33324000"
                    },
                    {
                        "id": 58882,
                        "name": "Ponti",
                        "latitude": "44.62847000",
                        "longitude": "8.36461000"
                    },
                    {
                        "id": 58896,
                        "name": "Ponzano Monferrato",
                        "latitude": "45.08485000",
                        "longitude": "8.26553000"
                    },
                    {
                        "id": 58899,
                        "name": "Ponzone",
                        "latitude": "44.58814000",
                        "longitude": "8.45935000"
                    },
                    {
                        "id": 58913,
                        "name": "Portacomaro",
                        "latitude": "44.95665000",
                        "longitude": "8.25804000"
                    },
                    {
                        "id": 58915,
                        "name": "Porte",
                        "latitude": "44.88714000",
                        "longitude": "7.26982000"
                    },
                    {
                        "id": 58951,
                        "name": "Portula",
                        "latitude": "45.67512000",
                        "longitude": "8.17244000"
                    },
                    {
                        "id": 58964,
                        "name": "Postua",
                        "latitude": "45.71355000",
                        "longitude": "8.22853000"
                    },
                    {
                        "id": 58983,
                        "name": "Pozzol Groppo",
                        "latitude": "44.87806000",
                        "longitude": "9.02985000"
                    },
                    {
                        "id": 58986,
                        "name": "Pozzolo Formigaro",
                        "latitude": "44.79925000",
                        "longitude": "8.78364000"
                    },
                    {
                        "id": 58996,
                        "name": "Pradleves",
                        "latitude": "44.41786000",
                        "longitude": "7.28146000"
                    },
                    {
                        "id": 58997,
                        "name": "Pragelato-Ruà",
                        "latitude": "45.01364000",
                        "longitude": "6.94161000"
                    },
                    {
                        "id": 59001,
                        "name": "Prali",
                        "latitude": "44.88944000",
                        "longitude": "7.05131000"
                    },
                    {
                        "id": 59002,
                        "name": "Pralormo",
                        "latitude": "44.85976000",
                        "longitude": "7.90440000"
                    },
                    {
                        "id": 59003,
                        "name": "Pralungo",
                        "latitude": "45.58999000",
                        "longitude": "8.03976000"
                    },
                    {
                        "id": 59006,
                        "name": "Pramollo",
                        "latitude": "44.90814000",
                        "longitude": "7.19071000"
                    },
                    {
                        "id": 59007,
                        "name": "Prarolo",
                        "latitude": "45.28149000",
                        "longitude": "8.47784000"
                    },
                    {
                        "id": 59008,
                        "name": "Prarostino",
                        "latitude": "44.86634000",
                        "longitude": "7.26762000"
                    },
                    {
                        "id": 59009,
                        "name": "Prasco",
                        "latitude": "44.63938000",
                        "longitude": "8.55167000"
                    },
                    {
                        "id": 59010,
                        "name": "Prascorsano",
                        "latitude": "45.36721000",
                        "longitude": "7.61727000"
                    },
                    {
                        "id": 59023,
                        "name": "Pratiglione",
                        "latitude": "45.35275000",
                        "longitude": "7.59602000"
                    },
                    {
                        "id": 59031,
                        "name": "Prato Sesia",
                        "latitude": "45.65067000",
                        "longitude": "8.37293000"
                    },
                    {
                        "id": 59038,
                        "name": "Pray",
                        "latitude": "45.67508000",
                        "longitude": "8.20951000"
                    },
                    {
                        "id": 59039,
                        "name": "Prazzo Superiore",
                        "latitude": "44.48297000",
                        "longitude": "7.05468000"
                    },
                    {
                        "id": 59047,
                        "name": "Predosa",
                        "latitude": "44.75049000",
                        "longitude": "8.65568000"
                    },
                    {
                        "id": 59054,
                        "name": "Premeno",
                        "latitude": "45.97818000",
                        "longitude": "8.59587000"
                    },
                    {
                        "id": 59056,
                        "name": "Premia",
                        "latitude": "46.26807000",
                        "longitude": "8.33830000"
                    },
                    {
                        "id": 59059,
                        "name": "Premosello-Chiovenda",
                        "latitude": "46.00380000",
                        "longitude": "8.32973000"
                    },
                    {
                        "id": 59074,
                        "name": "Priero",
                        "latitude": "44.37604000",
                        "longitude": "8.09334000"
                    },
                    {
                        "id": 59079,
                        "name": "Priocca",
                        "latitude": "44.78624000",
                        "longitude": "8.06424000"
                    },
                    {
                        "id": 59080,
                        "name": "Priola",
                        "latitude": "44.24478000",
                        "longitude": "8.02149000"
                    },
                    {
                        "id": 59107,
                        "name": "Provincia di Alessandria",
                        "latitude": "44.81667000",
                        "longitude": "8.70000000"
                    },
                    {
                        "id": 59110,
                        "name": "Provincia di Asti",
                        "latitude": "44.91667000",
                        "longitude": "8.16667000"
                    },
                    {
                        "id": 59116,
                        "name": "Provincia di Biella",
                        "latitude": "45.58713000",
                        "longitude": "8.08594000"
                    },
                    {
                        "id": 59129,
                        "name": "Provincia di Cuneo",
                        "latitude": "44.51667000",
                        "longitude": "7.56667000"
                    },
                    {
                        "id": 59152,
                        "name": "Provincia di Novara",
                        "latitude": "45.58533000",
                        "longitude": "8.57781000"
                    },
                    {
                        "id": 59186,
                        "name": "Provincia di Vercelli",
                        "latitude": "45.33188000",
                        "longitude": "8.41415000"
                    },
                    {
                        "id": 59104,
                        "name": "Provincia Verbano-Cusio-Ossola",
                        "latitude": "45.93333000",
                        "longitude": "8.55000000"
                    },
                    {
                        "id": 59192,
                        "name": "Prunetto",
                        "latitude": "44.48894000",
                        "longitude": "8.14374000"
                    },
                    {
                        "id": 59214,
                        "name": "Quagliuzzo",
                        "latitude": "45.42654000",
                        "longitude": "7.78101000"
                    },
                    {
                        "id": 59216,
                        "name": "Quaranti",
                        "latitude": "44.75095000",
                        "longitude": "8.44914000"
                    },
                    {
                        "id": 59219,
                        "name": "Quaregna",
                        "latitude": "45.58116000",
                        "longitude": "8.16372000"
                    },
                    {
                        "id": 59220,
                        "name": "Quargnento",
                        "latitude": "44.94566000",
                        "longitude": "8.48821000"
                    },
                    {
                        "id": 59221,
                        "name": "Quarna Sopra",
                        "latitude": "45.87307000",
                        "longitude": "8.37355000"
                    },
                    {
                        "id": 59222,
                        "name": "Quarna Sotto",
                        "latitude": "45.86917000",
                        "longitude": "8.36332000"
                    },
                    {
                        "id": 59223,
                        "name": "Quarona",
                        "latitude": "45.76044000",
                        "longitude": "8.26749000"
                    },
                    {
                        "id": 59234,
                        "name": "Quassolo",
                        "latitude": "45.52294000",
                        "longitude": "7.83305000"
                    },
                    {
                        "id": 59235,
                        "name": "Quattordio",
                        "latitude": "44.89877000",
                        "longitude": "8.40495000"
                    },
                    {
                        "id": 59243,
                        "name": "Quincinetto",
                        "latitude": "45.56157000",
                        "longitude": "7.80834000"
                    },
                    {
                        "id": 59248,
                        "name": "Quinto Vercellese",
                        "latitude": "45.37920000",
                        "longitude": "8.36210000"
                    },
                    {
                        "id": 59257,
                        "name": "Racconigi",
                        "latitude": "44.76598000",
                        "longitude": "7.67893000"
                    },
                    {
                        "id": 59289,
                        "name": "Rassa",
                        "latitude": "45.76821000",
                        "longitude": "8.01208000"
                    },
                    {
                        "id": 59303,
                        "name": "Re",
                        "latitude": "46.13148000",
                        "longitude": "8.54569000"
                    },
                    {
                        "id": 59308,
                        "name": "Reano",
                        "latitude": "45.05217000",
                        "longitude": "7.42779000"
                    },
                    {
                        "id": 59312,
                        "name": "Recetto",
                        "latitude": "45.45965000",
                        "longitude": "8.43503000"
                    },
                    {
                        "id": 59316,
                        "name": "Refrancore",
                        "latitude": "44.93635000",
                        "longitude": "8.34084000"
                    },
                    {
                        "id": 59340,
                        "name": "Revello",
                        "latitude": "44.65451000",
                        "longitude": "7.39026000"
                    },
                    {
                        "id": 59342,
                        "name": "Revigliasco",
                        "latitude": "45.01589000",
                        "longitude": "7.73306000"
                    },
                    {
                        "id": 59343,
                        "name": "Revigliasco d'Asti",
                        "latitude": "44.85755000",
                        "longitude": "8.16044000"
                    },
                    {
                        "id": 59361,
                        "name": "Ribordone",
                        "latitude": "45.43255000",
                        "longitude": "7.50231000"
                    },
                    {
                        "id": 59363,
                        "name": "Ricaldone",
                        "latitude": "44.73235000",
                        "longitude": "8.46814000"
                    },
                    {
                        "id": 59364,
                        "name": "Ricca",
                        "latitude": "44.66127000",
                        "longitude": "8.04527000"
                    },
                    {
                        "id": 59376,
                        "name": "Rifreddo",
                        "latitude": "44.65073000",
                        "longitude": "7.34642000"
                    },
                    {
                        "id": 59382,
                        "name": "Rima",
                        "latitude": "45.88542000",
                        "longitude": "7.99864000"
                    },
                    {
                        "id": 59383,
                        "name": "Rimasco",
                        "latitude": "45.86025000",
                        "longitude": "8.06412000"
                    },
                    {
                        "id": 59384,
                        "name": "Rimella",
                        "latitude": "45.90807000",
                        "longitude": "8.18222000"
                    },
                    {
                        "id": 59414,
                        "name": "Rittana",
                        "latitude": "44.35103000",
                        "longitude": "7.39843000"
                    },
                    {
                        "id": 59415,
                        "name": "Riva",
                        "latitude": "44.89252000",
                        "longitude": "7.38189000"
                    },
                    {
                        "id": 59417,
                        "name": "Riva Presso Chieri",
                        "latitude": "44.98338000",
                        "longitude": "7.87313000"
                    },
                    {
                        "id": 59418,
                        "name": "Riva Valdobbia",
                        "latitude": "45.83097000",
                        "longitude": "7.95661000"
                    },
                    {
                        "id": 59421,
                        "name": "Rivalba",
                        "latitude": "45.11669000",
                        "longitude": "7.88811000"
                    },
                    {
                        "id": 59423,
                        "name": "Rivalta Bormida",
                        "latitude": "44.70975000",
                        "longitude": "8.55175000"
                    },
                    {
                        "id": 59424,
                        "name": "Rivalta di Torino",
                        "latitude": "45.03268000",
                        "longitude": "7.52042000"
                    },
                    {
                        "id": 59427,
                        "name": "Rivara",
                        "latitude": "45.33042000",
                        "longitude": "7.64900000"
                    },
                    {
                        "id": 59428,
                        "name": "Rivarolo Canavese",
                        "latitude": "45.32829000",
                        "longitude": "7.72110000"
                    },
                    {
                        "id": 59431,
                        "name": "Rivarone",
                        "latitude": "44.97686000",
                        "longitude": "8.71565000"
                    },
                    {
                        "id": 59432,
                        "name": "Rivarossa",
                        "latitude": "45.24954000",
                        "longitude": "7.71953000"
                    },
                    {
                        "id": 59434,
                        "name": "Rive",
                        "latitude": "45.21364000",
                        "longitude": "8.41701000"
                    },
                    {
                        "id": 59441,
                        "name": "Rivoli",
                        "latitude": "45.07073000",
                        "longitude": "7.51465000"
                    },
                    {
                        "id": 59448,
                        "name": "Roapiana",
                        "latitude": "44.34079000",
                        "longitude": "7.82329000"
                    },
                    {
                        "id": 59449,
                        "name": "Roaschia",
                        "latitude": "44.27023000",
                        "longitude": "7.45573000"
                    },
                    {
                        "id": 59450,
                        "name": "Roascio",
                        "latitude": "44.41714000",
                        "longitude": "8.02234000"
                    },
                    {
                        "id": 59451,
                        "name": "Roasio",
                        "latitude": "45.60457000",
                        "longitude": "8.28482000"
                    },
                    {
                        "id": 59452,
                        "name": "Roata Rossi",
                        "latitude": "44.44383000",
                        "longitude": "7.52572000"
                    },
                    {
                        "id": 59453,
                        "name": "Roatto",
                        "latitude": "44.95205000",
                        "longitude": "8.02693000"
                    },
                    {
                        "id": 59454,
                        "name": "Robassomero",
                        "latitude": "45.19841000",
                        "longitude": "7.56754000"
                    },
                    {
                        "id": 59462,
                        "name": "Robella",
                        "latitude": "45.10165000",
                        "longitude": "8.10193000"
                    },
                    {
                        "id": 59463,
                        "name": "Robilante",
                        "latitude": "44.29288000",
                        "longitude": "7.51367000"
                    },
                    {
                        "id": 59464,
                        "name": "Roburent",
                        "latitude": "44.30633000",
                        "longitude": "7.89224000"
                    },
                    {
                        "id": 59465,
                        "name": "Rocca Canavese",
                        "latitude": "45.30870000",
                        "longitude": "7.57875000"
                    },
                    {
                        "id": 59467,
                        "name": "Rocca Cigliè",
                        "latitude": "44.44523000",
                        "longitude": "7.95094000"
                    },
                    {
                        "id": 59481,
                        "name": "Rocca d'Arazzo",
                        "latitude": "44.87205000",
                        "longitude": "8.28464000"
                    },
                    {
                        "id": 59468,
                        "name": "Rocca De' Baldi",
                        "latitude": "44.42363000",
                        "longitude": "7.76114000"
                    },
                    {
                        "id": 59469,
                        "name": "Rocca Grimalda",
                        "latitude": "44.67145000",
                        "longitude": "8.64845000"
                    },
                    {
                        "id": 59493,
                        "name": "Roccabruna",
                        "latitude": "44.47453000",
                        "longitude": "7.34373000"
                    },
                    {
                        "id": 59497,
                        "name": "Roccaforte Ligure",
                        "latitude": "44.67780000",
                        "longitude": "9.02800000"
                    },
                    {
                        "id": 59498,
                        "name": "Roccaforte Mondovì",
                        "latitude": "44.31721000",
                        "longitude": "7.74426000"
                    },
                    {
                        "id": 59523,
                        "name": "Roccasparvera",
                        "latitude": "44.34213000",
                        "longitude": "7.44153000"
                    },
                    {
                        "id": 59527,
                        "name": "Roccaverano",
                        "latitude": "44.59224000",
                        "longitude": "8.27214000"
                    },
                    {
                        "id": 59529,
                        "name": "Roccavione",
                        "latitude": "44.31355000",
                        "longitude": "7.47845000"
                    },
                    {
                        "id": 59536,
                        "name": "Rocchetta Belbo",
                        "latitude": "44.63604000",
                        "longitude": "8.17534000"
                    },
                    {
                        "id": 59537,
                        "name": "Rocchetta Ligure",
                        "latitude": "44.70655000",
                        "longitude": "9.05046000"
                    },
                    {
                        "id": 59540,
                        "name": "Rocchetta Palafea",
                        "latitude": "44.70744000",
                        "longitude": "8.34534000"
                    },
                    {
                        "id": 59542,
                        "name": "Rocchetta Tanaro",
                        "latitude": "44.85865000",
                        "longitude": "8.34564000"
                    },
                    {
                        "id": 59545,
                        "name": "Roddi",
                        "latitude": "44.67964000",
                        "longitude": "7.97544000"
                    },
                    {
                        "id": 59546,
                        "name": "Roddino",
                        "latitude": "44.57384000",
                        "longitude": "8.01914000"
                    },
                    {
                        "id": 59548,
                        "name": "Rodello",
                        "latitude": "44.62854000",
                        "longitude": "8.05684000"
                    },
                    {
                        "id": 59568,
                        "name": "Roletto",
                        "latitude": "44.92444000",
                        "longitude": "7.33232000"
                    },
                    {
                        "id": 59571,
                        "name": "Romagnano Sesia",
                        "latitude": "45.63279000",
                        "longitude": "8.38697000"
                    },
                    {
                        "id": 59577,
                        "name": "Romano Canavese",
                        "latitude": "45.39925000",
                        "longitude": "7.86885000"
                    },
                    {
                        "id": 59584,
                        "name": "Romentino",
                        "latitude": "45.46296000",
                        "longitude": "8.71811000"
                    },
                    {
                        "id": 59602,
                        "name": "Ronco Biellese",
                        "latitude": "45.57846000",
                        "longitude": "8.09072000"
                    },
                    {
                        "id": 59604,
                        "name": "Ronco Canavese",
                        "latitude": "45.50081000",
                        "longitude": "7.54702000"
                    },
                    {
                        "id": 59615,
                        "name": "Rondissone",
                        "latitude": "45.24630000",
                        "longitude": "7.96426000"
                    },
                    {
                        "id": 59616,
                        "name": "Ronsecco",
                        "latitude": "45.25284000",
                        "longitude": "8.27749000"
                    },
                    {
                        "id": 59620,
                        "name": "Roppolo",
                        "latitude": "45.42056000",
                        "longitude": "8.06972000"
                    },
                    {
                        "id": 59622,
                        "name": "Rorà",
                        "latitude": "44.79214000",
                        "longitude": "7.19902000"
                    },
                    {
                        "id": 59621,
                        "name": "Roreto",
                        "latitude": "44.66932000",
                        "longitude": "7.83423000"
                    },
                    {
                        "id": 59628,
                        "name": "Rosazza",
                        "latitude": "45.67576000",
                        "longitude": "7.97712000"
                    },
                    {
                        "id": 59640,
                        "name": "Rosignano Monferrato",
                        "latitude": "45.08055000",
                        "longitude": "8.39974000"
                    },
                    {
                        "id": 59645,
                        "name": "Rossa",
                        "latitude": "45.83327000",
                        "longitude": "8.12432000"
                    },
                    {
                        "id": 59646,
                        "name": "Rossana",
                        "latitude": "44.54470000",
                        "longitude": "7.43193000"
                    },
                    {
                        "id": 59652,
                        "name": "Rosta",
                        "latitude": "45.06795000",
                        "longitude": "7.46512000"
                    },
                    {
                        "id": 59666,
                        "name": "Roure",
                        "latitude": "45.00214000",
                        "longitude": "7.13161000"
                    },
                    {
                        "id": 59668,
                        "name": "Rovasenda",
                        "latitude": "45.53866000",
                        "longitude": "8.31592000"
                    },
                    {
                        "id": 59691,
                        "name": "Rubiana",
                        "latitude": "45.13622000",
                        "longitude": "7.38439000"
                    },
                    {
                        "id": 59695,
                        "name": "Rueglio",
                        "latitude": "45.46826000",
                        "longitude": "7.75462000"
                    },
                    {
                        "id": 59697,
                        "name": "Ruffia",
                        "latitude": "44.70598000",
                        "longitude": "7.60391000"
                    },
                    {
                        "id": 59712,
                        "name": "Sabbia",
                        "latitude": "45.85720000",
                        "longitude": "8.23580000"
                    },
                    {
                        "id": 59724,
                        "name": "Sagliano Micca",
                        "latitude": "45.62576000",
                        "longitude": "8.04332000"
                    },
                    {
                        "id": 59740,
                        "name": "Sala Biellese",
                        "latitude": "45.50856000",
                        "longitude": "7.95800000"
                    },
                    {
                        "id": 59744,
                        "name": "Sala Monferrato",
                        "latitude": "45.07546000",
                        "longitude": "8.36119000"
                    },
                    {
                        "id": 59749,
                        "name": "Salasco",
                        "latitude": "45.32556000",
                        "longitude": "8.26423000"
                    },
                    {
                        "id": 59750,
                        "name": "Salassa",
                        "latitude": "45.36175000",
                        "longitude": "7.68297000"
                    },
                    {
                        "id": 59751,
                        "name": "Salbertrand",
                        "latitude": "45.07350000",
                        "longitude": "6.88744000"
                    },
                    {
                        "id": 59754,
                        "name": "Sale",
                        "latitude": "44.97932000",
                        "longitude": "8.80963000"
                    },
                    {
                        "id": 59757,
                        "name": "Sale delle Langhe",
                        "latitude": "44.39523000",
                        "longitude": "8.08014000"
                    },
                    {
                        "id": 59756,
                        "name": "Sale San Giovanni",
                        "latitude": "44.39914000",
                        "longitude": "8.07794000"
                    },
                    {
                        "id": 59760,
                        "name": "Salerano Canavese",
                        "latitude": "45.45806000",
                        "longitude": "7.85112000"
                    },
                    {
                        "id": 59766,
                        "name": "Sali Vercellese",
                        "latitude": "45.30986000",
                        "longitude": "8.32893000"
                    },
                    {
                        "id": 59769,
                        "name": "Saliceto",
                        "latitude": "44.41334000",
                        "longitude": "8.16864000"
                    },
                    {
                        "id": 59778,
                        "name": "Salmour",
                        "latitude": "44.57556000",
                        "longitude": "7.79148000"
                    },
                    {
                        "id": 59784,
                        "name": "Saluggia",
                        "latitude": "45.23687000",
                        "longitude": "8.01460000"
                    },
                    {
                        "id": 59785,
                        "name": "Salussola",
                        "latitude": "45.44666000",
                        "longitude": "8.11100000"
                    },
                    {
                        "id": 59786,
                        "name": "Saluzzo",
                        "latitude": "44.64671000",
                        "longitude": "7.49309000"
                    },
                    {
                        "id": 59794,
                        "name": "Salza di Pinerolo",
                        "latitude": "44.94004000",
                        "longitude": "7.05241000"
                    },
                    {
                        "id": 59808,
                        "name": "Sambuco",
                        "latitude": "44.33510000",
                        "longitude": "7.07878000"
                    },
                    {
                        "id": 59813,
                        "name": "Samone",
                        "latitude": "45.44914000",
                        "longitude": "7.84198000"
                    },
                    {
                        "id": 59815,
                        "name": "Sampeyre",
                        "latitude": "44.57846000",
                        "longitude": "7.19039000"
                    },
                    {
                        "id": 59827,
                        "name": "San Benedetto Belbo",
                        "latitude": "44.49014000",
                        "longitude": "8.05784000"
                    },
                    {
                        "id": 59834,
                        "name": "San Benigno Canavese",
                        "latitude": "45.22617000",
                        "longitude": "7.78427000"
                    },
                    {
                        "id": 59835,
                        "name": "San Bernardino Verbano",
                        "latitude": "45.95638000",
                        "longitude": "8.51922000"
                    },
                    {
                        "id": 59855,
                        "name": "San Carlo Canavese",
                        "latitude": "45.24455000",
                        "longitude": "7.60572000"
                    },
                    {
                        "id": 59876,
                        "name": "San Colombano Belmonte",
                        "latitude": "45.38225000",
                        "longitude": "7.62101000"
                    },
                    {
                        "id": 59883,
                        "name": "San Cristoforo",
                        "latitude": "44.69304000",
                        "longitude": "8.74939000"
                    },
                    {
                        "id": 59887,
                        "name": "San Damiano d'Asti",
                        "latitude": "44.83344000",
                        "longitude": "8.06353000"
                    },
                    {
                        "id": 59885,
                        "name": "San Damiano Macra",
                        "latitude": "44.48848000",
                        "longitude": "7.25606000"
                    },
                    {
                        "id": 59890,
                        "name": "San Defendente",
                        "latitude": "44.39088000",
                        "longitude": "7.49091000"
                    },
                    {
                        "id": 59893,
                        "name": "San Didero",
                        "latitude": "45.13544000",
                        "longitude": "7.21301000"
                    },
                    {
                        "id": 59927,
                        "name": "San Francesco al Campo",
                        "latitude": "45.22732000",
                        "longitude": "7.65479000"
                    },
                    {
                        "id": 59936,
                        "name": "San Germano Chisone",
                        "latitude": "44.90204000",
                        "longitude": "7.23662000"
                    },
                    {
                        "id": 59937,
                        "name": "San Germano Vercellese",
                        "latitude": "45.35090000",
                        "longitude": "8.24717000"
                    },
                    {
                        "id": 59945,
                        "name": "San Giacomo Vercellese",
                        "latitude": "45.49816000",
                        "longitude": "8.32673000"
                    },
                    {
                        "id": 59948,
                        "name": "San Gillio",
                        "latitude": "45.14050000",
                        "longitude": "7.53285000"
                    },
                    {
                        "id": 59953,
                        "name": "San Giorgio",
                        "latitude": "45.10778000",
                        "longitude": "8.41421000"
                    },
                    {
                        "id": 59955,
                        "name": "San Giorgio Canavese",
                        "latitude": "45.33557000",
                        "longitude": "7.79823000"
                    },
                    {
                        "id": 59958,
                        "name": "San Giorgio Monferrato",
                        "latitude": "45.10735000",
                        "longitude": "8.41614000"
                    },
                    {
                        "id": 59961,
                        "name": "San Giorgio Scarampi",
                        "latitude": "44.61094000",
                        "longitude": "8.24244000"
                    },
                    {
                        "id": 59977,
                        "name": "San Giorio",
                        "latitude": "45.12752000",
                        "longitude": "7.17683000"
                    },
                    {
                        "id": 60006,
                        "name": "San Giuliano Vecchio",
                        "latitude": "44.88902000",
                        "longitude": "8.76057000"
                    },
                    {
                        "id": 60010,
                        "name": "San Giuseppe",
                        "latitude": "45.14701000",
                        "longitude": "7.04271000"
                    },
                    {
                        "id": 60017,
                        "name": "San Giusto Canavese",
                        "latitude": "45.31535000",
                        "longitude": "7.81001000"
                    },
                    {
                        "id": 60037,
                        "name": "San Lorenzo",
                        "latitude": "46.12720000",
                        "longitude": "8.20065000"
                    },
                    {
                        "id": 60071,
                        "name": "San Martino Alfieri",
                        "latitude": "44.81795000",
                        "longitude": "8.10994000"
                    },
                    {
                        "id": 60074,
                        "name": "San Martino Canavese",
                        "latitude": "45.39453000",
                        "longitude": "7.81622000"
                    },
                    {
                        "id": 60098,
                        "name": "San Marzano Oliveto",
                        "latitude": "44.75445000",
                        "longitude": "8.29534000"
                    },
                    {
                        "id": 60102,
                        "name": "San Maurizio",
                        "latitude": "45.21705000",
                        "longitude": "7.63052000"
                    },
                    {
                        "id": 60103,
                        "name": "San Maurizio D'Opaglio",
                        "latitude": "45.77299000",
                        "longitude": "8.39599000"
                    },
                    {
                        "id": 60110,
                        "name": "San Mauro Torinese",
                        "latitude": "45.10359000",
                        "longitude": "7.76803000"
                    },
                    {
                        "id": 60118,
                        "name": "San Michele Mondovì",
                        "latitude": "44.37595000",
                        "longitude": "7.90829000"
                    },
                    {
                        "id": 60131,
                        "name": "San Nazzaro Sesia",
                        "latitude": "45.43804000",
                        "longitude": "8.42498000"
                    },
                    {
                        "id": 60159,
                        "name": "San Paolo Solbrito",
                        "latitude": "44.95065000",
                        "longitude": "7.97073000"
                    },
                    {
                        "id": 60180,
                        "name": "San Pietro Mosezzo",
                        "latitude": "45.45455000",
                        "longitude": "8.54450000"
                    },
                    {
                        "id": 60182,
                        "name": "San Pietro Val Lemina",
                        "latitude": "44.90654000",
                        "longitude": "7.31092000"
                    },
                    {
                        "id": 60209,
                        "name": "San Ponso",
                        "latitude": "45.35101000",
                        "longitude": "7.67111000"
                    },
                    {
                        "id": 60219,
                        "name": "San Raffaele Cimena",
                        "latitude": "45.14665000",
                        "longitude": "7.84932000"
                    },
                    {
                        "id": 60223,
                        "name": "San Rocco",
                        "latitude": "44.39653000",
                        "longitude": "7.47230000"
                    },
                    {
                        "id": 60231,
                        "name": "San Salvatore Monferrato",
                        "latitude": "44.99489000",
                        "longitude": "8.56639000"
                    },
                    {
                        "id": 60236,
                        "name": "San Sebastiano Curone",
                        "latitude": "44.78633000",
                        "longitude": "9.06446000"
                    },
                    {
                        "id": 60238,
                        "name": "San Sebastiano da Po",
                        "latitude": "45.16755000",
                        "longitude": "7.95723000"
                    },
                    {
                        "id": 60241,
                        "name": "San Secondo di Pinerolo",
                        "latitude": "44.86644000",
                        "longitude": "7.29842000"
                    },
                    {
                        "id": 60299,
                        "name": "Sandigliano",
                        "latitude": "45.52204000",
                        "longitude": "8.07660000"
                    },
                    {
                        "id": 60303,
                        "name": "Sanfrè",
                        "latitude": "44.75180000",
                        "longitude": "7.80289000"
                    },
                    {
                        "id": 60302,
                        "name": "Sanfront",
                        "latitude": "44.64698000",
                        "longitude": "7.32243000"
                    },
                    {
                        "id": 60304,
                        "name": "Sangano",
                        "latitude": "45.02508000",
                        "longitude": "7.44987000"
                    },
                    {
                        "id": 60317,
                        "name": "Sant'Agata Fossili",
                        "latitude": "44.78475000",
                        "longitude": "8.92115000"
                    },
                    {
                        "id": 60329,
                        "name": "Sant'Albano Stura",
                        "latitude": "44.50759000",
                        "longitude": "7.72282000"
                    },
                    {
                        "id": 60337,
                        "name": "Sant'Ambrogio di Torino",
                        "latitude": "45.09622000",
                        "longitude": "7.36600000"
                    },
                    {
                        "id": 60378,
                        "name": "Sant'Antonino di Susa",
                        "latitude": "45.10763000",
                        "longitude": "7.27333000"
                    },
                    {
                        "id": 60381,
                        "name": "Sant'Antonio",
                        "latitude": "44.75887000",
                        "longitude": "8.06996000"
                    },
                    {
                        "id": 60466,
                        "name": "Santa Maria Maggiore",
                        "latitude": "46.13683000",
                        "longitude": "8.46108000"
                    },
                    {
                        "id": 60500,
                        "name": "Santa Vittoria d'Alba",
                        "latitude": "44.69864000",
                        "longitude": "7.93733000"
                    },
                    {
                        "id": 60505,
                        "name": "Santena",
                        "latitude": "44.94624000",
                        "longitude": "7.77303000"
                    },
                    {
                        "id": 60508,
                        "name": "Santhià",
                        "latitude": "45.36795000",
                        "longitude": "8.17012000"
                    },
                    {
                        "id": 60510,
                        "name": "Santino",
                        "latitude": "45.95606000",
                        "longitude": "8.51914000"
                    },
                    {
                        "id": 60512,
                        "name": "Santo Stefano Belbo",
                        "latitude": "44.71023000",
                        "longitude": "8.23269000"
                    },
                    {
                        "id": 60515,
                        "name": "Santo Stefano Roero",
                        "latitude": "44.78844000",
                        "longitude": "7.94093000"
                    },
                    {
                        "id": 60544,
                        "name": "Sardigliano",
                        "latitude": "44.75240000",
                        "longitude": "8.89575000"
                    },
                    {
                        "id": 60547,
                        "name": "Sarezzano",
                        "latitude": "44.86878000",
                        "longitude": "8.91237000"
                    },
                    {
                        "id": 60581,
                        "name": "Sauze d'Oulx",
                        "latitude": "45.02659000",
                        "longitude": "6.86074000"
                    },
                    {
                        "id": 60582,
                        "name": "Sauze di Cesana",
                        "latitude": "44.94058000",
                        "longitude": "6.85988000"
                    },
                    {
                        "id": 60587,
                        "name": "Savigliano",
                        "latitude": "44.64808000",
                        "longitude": "7.65677000"
                    },
                    {
                        "id": 60600,
                        "name": "Savonera",
                        "latitude": "45.11368000",
                        "longitude": "7.61506000"
                    },
                    {
                        "id": 60603,
                        "name": "Scagnello",
                        "latitude": "44.33333000",
                        "longitude": "7.98644000"
                    },
                    {
                        "id": 60608,
                        "name": "Scalenghe",
                        "latitude": "44.88990000",
                        "longitude": "7.49423000"
                    },
                    {
                        "id": 60634,
                        "name": "Scarmagno",
                        "latitude": "45.38492000",
                        "longitude": "7.84110000"
                    },
                    {
                        "id": 60635,
                        "name": "Scarnafigi",
                        "latitude": "44.67944000",
                        "longitude": "7.56513000"
                    },
                    {
                        "id": 60657,
                        "name": "Sciolze",
                        "latitude": "45.09453000",
                        "longitude": "7.87818000"
                    },
                    {
                        "id": 60663,
                        "name": "Scopa",
                        "latitude": "45.79297000",
                        "longitude": "8.11402000"
                    },
                    {
                        "id": 60664,
                        "name": "Scopello",
                        "latitude": "45.77369000",
                        "longitude": "8.09435000"
                    },
                    {
                        "id": 60672,
                        "name": "Scurzolengo",
                        "latitude": "44.96485000",
                        "longitude": "8.27914000"
                    },
                    {
                        "id": 60711,
                        "name": "Selve Marcone",
                        "latitude": "45.61976000",
                        "longitude": "8.08742000"
                    },
                    {
                        "id": 60733,
                        "name": "Seppiana",
                        "latitude": "46.05828000",
                        "longitude": "8.21661000"
                    },
                    {
                        "id": 60748,
                        "name": "Serole",
                        "latitude": "44.55404000",
                        "longitude": "8.25974000"
                    },
                    {
                        "id": 60760,
                        "name": "Serralunga d'Alba",
                        "latitude": "44.61004000",
                        "longitude": "7.99944000"
                    },
                    {
                        "id": 60761,
                        "name": "Serralunga di Crea",
                        "latitude": "45.10110000",
                        "longitude": "8.28069000"
                    },
                    {
                        "id": 60772,
                        "name": "Serravalle Langhe",
                        "latitude": "44.55995000",
                        "longitude": "8.05944000"
                    },
                    {
                        "id": 60774,
                        "name": "Serravalle Scrivia",
                        "latitude": "44.72277000",
                        "longitude": "8.85635000"
                    },
                    {
                        "id": 60775,
                        "name": "Serravalle Sesia",
                        "latitude": "45.68485000",
                        "longitude": "8.30850000"
                    },
                    {
                        "id": 60779,
                        "name": "Serre",
                        "latitude": "44.54033000",
                        "longitude": "7.09032000"
                    },
                    {
                        "id": 60790,
                        "name": "Sessame",
                        "latitude": "44.67064000",
                        "longitude": "8.33684000"
                    },
                    {
                        "id": 60804,
                        "name": "Sestriere",
                        "latitude": "44.95864000",
                        "longitude": "6.87751000"
                    },
                    {
                        "id": 60809,
                        "name": "Settime",
                        "latitude": "44.96175000",
                        "longitude": "8.11433000"
                    },
                    {
                        "id": 60813,
                        "name": "Settimo Rottaro",
                        "latitude": "45.40776000",
                        "longitude": "7.99352000"
                    },
                    {
                        "id": 60815,
                        "name": "Settimo Torinese",
                        "latitude": "45.13925000",
                        "longitude": "7.77008000"
                    },
                    {
                        "id": 60816,
                        "name": "Settimo Vittone",
                        "latitude": "45.54929000",
                        "longitude": "7.83328000"
                    },
                    {
                        "id": 60823,
                        "name": "Sezzadio",
                        "latitude": "44.78485000",
                        "longitude": "8.57255000"
                    },
                    {
                        "id": 60854,
                        "name": "Sillavengo",
                        "latitude": "45.52067000",
                        "longitude": "8.44103000"
                    },
                    {
                        "id": 60856,
                        "name": "Silvano d'Orba",
                        "latitude": "44.68580000",
                        "longitude": "8.67182000"
                    },
                    {
                        "id": 60867,
                        "name": "Sinio",
                        "latitude": "44.60034000",
                        "longitude": "8.01994000"
                    },
                    {
                        "id": 60886,
                        "name": "Sizzano",
                        "latitude": "45.57663000",
                        "longitude": "8.43613000"
                    },
                    {
                        "id": 60898,
                        "name": "Soglio",
                        "latitude": "44.99625000",
                        "longitude": "8.07843000"
                    },
                    {
                        "id": 60914,
                        "name": "Solero",
                        "latitude": "44.91835000",
                        "longitude": "8.50754000"
                    },
                    {
                        "id": 60922,
                        "name": "Solonghello",
                        "latitude": "45.12905000",
                        "longitude": "8.28323000"
                    },
                    {
                        "id": 60927,
                        "name": "Somano",
                        "latitude": "44.53534000",
                        "longitude": "8.00784000"
                    },
                    {
                        "id": 60932,
                        "name": "Sommariva del Bosco",
                        "latitude": "44.77257000",
                        "longitude": "7.78177000"
                    },
                    {
                        "id": 60931,
                        "name": "Sommariva Perno",
                        "latitude": "44.74564000",
                        "longitude": "7.90063000"
                    },
                    {
                        "id": 60943,
                        "name": "Soprana",
                        "latitude": "45.63947000",
                        "longitude": "8.19892000"
                    },
                    {
                        "id": 60952,
                        "name": "Sordevolo",
                        "latitude": "45.57346000",
                        "longitude": "7.97342000"
                    },
                    {
                        "id": 60962,
                        "name": "Soriso",
                        "latitude": "45.74037000",
                        "longitude": "8.40953000"
                    },
                    {
                        "id": 60972,
                        "name": "Sostegno",
                        "latitude": "45.65287000",
                        "longitude": "8.26982000"
                    },
                    {
                        "id": 60987,
                        "name": "Sozzago",
                        "latitude": "45.39832000",
                        "longitude": "8.72271000"
                    },
                    {
                        "id": 60991,
                        "name": "Sparone",
                        "latitude": "45.41442000",
                        "longitude": "7.54516000"
                    },
                    {
                        "id": 61007,
                        "name": "Spigno Monferrato",
                        "latitude": "44.54314000",
                        "longitude": "8.33395000"
                    },
                    {
                        "id": 61018,
                        "name": "Spineto Scrivia",
                        "latitude": "44.83735000",
                        "longitude": "8.87375000"
                    },
                    {
                        "id": 61020,
                        "name": "Spinetta Marengo",
                        "latitude": "44.88554000",
                        "longitude": "8.67750000"
                    },
                    {
                        "id": 61038,
                        "name": "Staffa",
                        "latitude": "45.96855000",
                        "longitude": "7.96708000"
                    },
                    {
                        "id": 61058,
                        "name": "Stazzano",
                        "latitude": "44.72728000",
                        "longitude": "8.86846000"
                    },
                    {
                        "id": 61087,
                        "name": "Strambinello",
                        "latitude": "45.42306000",
                        "longitude": "7.76992000"
                    },
                    {
                        "id": 61088,
                        "name": "Strambino",
                        "latitude": "45.37990000",
                        "longitude": "7.88967000"
                    },
                    {
                        "id": 61093,
                        "name": "Stresa",
                        "latitude": "45.88158000",
                        "longitude": "8.53834000"
                    },
                    {
                        "id": 61095,
                        "name": "Strevi",
                        "latitude": "44.69985000",
                        "longitude": "8.52470000"
                    },
                    {
                        "id": 61100,
                        "name": "Stroppiana",
                        "latitude": "45.23037000",
                        "longitude": "8.45461000"
                    },
                    {
                        "id": 61101,
                        "name": "Stroppo",
                        "latitude": "44.50653000",
                        "longitude": "7.12652000"
                    },
                    {
                        "id": 61122,
                        "name": "Suno",
                        "latitude": "45.63137000",
                        "longitude": "8.54437000"
                    },
                    {
                        "id": 61128,
                        "name": "Susa",
                        "latitude": "45.13677000",
                        "longitude": "7.05809000"
                    },
                    {
                        "id": 61143,
                        "name": "Tagliaferro",
                        "latitude": "44.97850000",
                        "longitude": "7.66430000"
                    },
                    {
                        "id": 61146,
                        "name": "Tagliolo Monferrato",
                        "latitude": "44.63835000",
                        "longitude": "8.66585000"
                    },
                    {
                        "id": 61164,
                        "name": "Tarantasca",
                        "latitude": "44.49322000",
                        "longitude": "7.54459000"
                    },
                    {
                        "id": 61172,
                        "name": "Tassarolo",
                        "latitude": "44.72811000",
                        "longitude": "8.77164000"
                    },
                    {
                        "id": 61179,
                        "name": "Tavagnasco",
                        "latitude": "45.54448000",
                        "longitude": "7.82293000"
                    },
                    {
                        "id": 61194,
                        "name": "Tavigliano",
                        "latitude": "45.62206000",
                        "longitude": "8.05172000"
                    },
                    {
                        "id": 61218,
                        "name": "Terdobbiate",
                        "latitude": "45.37588000",
                        "longitude": "8.69458000"
                    },
                    {
                        "id": 61231,
                        "name": "Ternengo",
                        "latitude": "45.58896000",
                        "longitude": "8.11372000"
                    },
                    {
                        "id": 61253,
                        "name": "Terruggia",
                        "latitude": "45.08199000",
                        "longitude": "8.44428000"
                    },
                    {
                        "id": 61256,
                        "name": "Terzo",
                        "latitude": "44.67045000",
                        "longitude": "8.42164000"
                    },
                    {
                        "id": 61266,
                        "name": "Tetti Neirotti",
                        "latitude": "45.05338000",
                        "longitude": "7.54077000"
                    },
                    {
                        "id": 61267,
                        "name": "Tettorosso",
                        "latitude": "44.47284000",
                        "longitude": "7.34291000"
                    },
                    {
                        "id": 61275,
                        "name": "Ticineto",
                        "latitude": "45.09627000",
                        "longitude": "8.55315000"
                    },
                    {
                        "id": 61278,
                        "name": "Tigliole",
                        "latitude": "44.88625000",
                        "longitude": "8.07663000"
                    },
                    {
                        "id": 61294,
                        "name": "Toceno",
                        "latitude": "46.14468000",
                        "longitude": "8.46902000"
                    },
                    {
                        "id": 61300,
                        "name": "Tollegno",
                        "latitude": "45.59077000",
                        "longitude": "8.05089000"
                    },
                    {
                        "id": 61308,
                        "name": "Tonco",
                        "latitude": "45.02344000",
                        "longitude": "8.18942000"
                    },
                    {
                        "id": 61309,
                        "name": "Tonengo",
                        "latitude": "45.11765000",
                        "longitude": "8.00213000"
                    },
                    {
                        "id": 61310,
                        "name": "Tonengo-Casale",
                        "latitude": "45.28609000",
                        "longitude": "7.93964000"
                    },
                    {
                        "id": 61329,
                        "name": "Torino",
                        "latitude": "45.13333000",
                        "longitude": "7.36667000"
                    },
                    {
                        "id": 61333,
                        "name": "Tornaco",
                        "latitude": "45.35651000",
                        "longitude": "8.71745000"
                    },
                    {
                        "id": 61344,
                        "name": "Torrazza Piemonte",
                        "latitude": "45.21535000",
                        "longitude": "7.97673000"
                    },
                    {
                        "id": 61346,
                        "name": "Torrazzo",
                        "latitude": "45.49874000",
                        "longitude": "7.95428000"
                    },
                    {
                        "id": 61350,
                        "name": "Torre Bormida",
                        "latitude": "44.56274000",
                        "longitude": "8.15444000"
                    },
                    {
                        "id": 61352,
                        "name": "Torre Canavese",
                        "latitude": "45.39206000",
                        "longitude": "7.75982000"
                    },
                    {
                        "id": 61356,
                        "name": "Torre Mondovì",
                        "latitude": "44.35283000",
                        "longitude": "7.89964000"
                    },
                    {
                        "id": 61359,
                        "name": "Torre Pellice",
                        "latitude": "44.82102000",
                        "longitude": "7.21672000"
                    },
                    {
                        "id": 61360,
                        "name": "Torre San Giorgio",
                        "latitude": "44.73574000",
                        "longitude": "7.52813000"
                    },
                    {
                        "id": 61388,
                        "name": "Torresina",
                        "latitude": "44.43364000",
                        "longitude": "8.03674000"
                    },
                    {
                        "id": 61407,
                        "name": "Torrion Quartara",
                        "latitude": "45.41819000",
                        "longitude": "8.61472000"
                    },
                    {
                        "id": 61412,
                        "name": "Tortona",
                        "latitude": "44.89784000",
                        "longitude": "8.86374000"
                    },
                    {
                        "id": 61436,
                        "name": "Trana",
                        "latitude": "45.03862000",
                        "longitude": "7.42100000"
                    },
                    {
                        "id": 61442,
                        "name": "Trarego",
                        "latitude": "46.03435000",
                        "longitude": "8.66998000"
                    },
                    {
                        "id": 61446,
                        "name": "Trasquera",
                        "latitude": "46.21338000",
                        "longitude": "8.21271000"
                    },
                    {
                        "id": 61448,
                        "name": "Trausella",
                        "latitude": "45.48996000",
                        "longitude": "7.76312000"
                    },
                    {
                        "id": 61452,
                        "name": "Traversella",
                        "latitude": "45.50907000",
                        "longitude": "7.74938000"
                    },
                    {
                        "id": 61454,
                        "name": "Traves",
                        "latitude": "45.26795000",
                        "longitude": "7.43081000"
                    },
                    {
                        "id": 61466,
                        "name": "Trecate",
                        "latitude": "45.43399000",
                        "longitude": "8.73640000"
                    },
                    {
                        "id": 61476,
                        "name": "Treiso",
                        "latitude": "44.68974000",
                        "longitude": "8.08814000"
                    },
                    {
                        "id": 61507,
                        "name": "Treville",
                        "latitude": "45.09685000",
                        "longitude": "8.35954000"
                    },
                    {
                        "id": 61512,
                        "name": "Trezzo Tinella",
                        "latitude": "44.67704000",
                        "longitude": "8.10754000"
                    },
                    {
                        "id": 61520,
                        "name": "Tricerro",
                        "latitude": "45.23570000",
                        "longitude": "8.32746000"
                    },
                    {
                        "id": 61529,
                        "name": "Trinità",
                        "latitude": "44.50730000",
                        "longitude": "7.75637000"
                    },
                    {
                        "id": 61532,
                        "name": "Trino",
                        "latitude": "45.19538000",
                        "longitude": "8.29621000"
                    },
                    {
                        "id": 61536,
                        "name": "Trisobbio",
                        "latitude": "44.66063000",
                        "longitude": "8.58621000"
                    },
                    {
                        "id": 61540,
                        "name": "Trivero-Prativero-Ponzone",
                        "latitude": "45.66047000",
                        "longitude": "8.17402000"
                    },
                    {
                        "id": 61548,
                        "name": "Trofarello",
                        "latitude": "44.98238000",
                        "longitude": "7.74688000"
                    },
                    {
                        "id": 61553,
                        "name": "Trontano",
                        "latitude": "46.12248000",
                        "longitude": "8.33322000"
                    },
                    {
                        "id": 61555,
                        "name": "Tronzano Vercellese",
                        "latitude": "45.34226000",
                        "longitude": "8.17368000"
                    },
                    {
                        "id": 61575,
                        "name": "Turin",
                        "latitude": "45.07049000",
                        "longitude": "7.68682000"
                    },
                    {
                        "id": 61617,
                        "name": "Usseaux",
                        "latitude": "45.04894000",
                        "longitude": "7.02851000"
                    },
                    {
                        "id": 61618,
                        "name": "Usseglio",
                        "latitude": "45.23274000",
                        "longitude": "7.21993000"
                    },
                    {
                        "id": 61624,
                        "name": "Vaccheria",
                        "latitude": "44.72700000",
                        "longitude": "8.04295000"
                    },
                    {
                        "id": 61635,
                        "name": "Vaglio Serra",
                        "latitude": "44.79635000",
                        "longitude": "8.33894000"
                    },
                    {
                        "id": 61639,
                        "name": "Vaie",
                        "latitude": "45.10234000",
                        "longitude": "7.28941000"
                    },
                    {
                        "id": 61645,
                        "name": "Val della Torre",
                        "latitude": "45.15515000",
                        "longitude": "7.44501000"
                    },
                    {
                        "id": 61652,
                        "name": "Valdengo",
                        "latitude": "45.56706000",
                        "longitude": "8.13832000"
                    },
                    {
                        "id": 61654,
                        "name": "Valdieri",
                        "latitude": "44.27763000",
                        "longitude": "7.39763000"
                    },
                    {
                        "id": 61659,
                        "name": "Valduggia",
                        "latitude": "45.72722000",
                        "longitude": "8.32730000"
                    },
                    {
                        "id": 61663,
                        "name": "Valentino",
                        "latitude": "45.15558000",
                        "longitude": "8.09391000"
                    },
                    {
                        "id": 61664,
                        "name": "Valenza",
                        "latitude": "45.01242000",
                        "longitude": "8.64379000"
                    },
                    {
                        "id": 61669,
                        "name": "Valfenera",
                        "latitude": "44.90175000",
                        "longitude": "7.96433000"
                    },
                    {
                        "id": 61673,
                        "name": "Valgioie",
                        "latitude": "45.06400000",
                        "longitude": "7.34927000"
                    },
                    {
                        "id": 61675,
                        "name": "Valgrana",
                        "latitude": "44.41181000",
                        "longitude": "7.38068000"
                    },
                    {
                        "id": 61681,
                        "name": "Vallanzengo",
                        "latitude": "45.60327000",
                        "longitude": "8.15042000"
                    },
                    {
                        "id": 61689,
                        "name": "Valle Mosso",
                        "latitude": "45.63069000",
                        "longitude": "8.14764000"
                    },
                    {
                        "id": 61691,
                        "name": "Valle San Bartolomeo",
                        "latitude": "44.95017000",
                        "longitude": "8.64040000"
                    },
                    {
                        "id": 61692,
                        "name": "Valle San Nicolao",
                        "latitude": "45.60706000",
                        "longitude": "8.14102000"
                    },
                    {
                        "id": 61723,
                        "name": "Vallo Torinese",
                        "latitude": "45.22355000",
                        "longitude": "7.49632000"
                    },
                    {
                        "id": 61726,
                        "name": "Valloriate",
                        "latitude": "44.33763000",
                        "longitude": "7.37393000"
                    },
                    {
                        "id": 61728,
                        "name": "Valmacca",
                        "latitude": "45.10101000",
                        "longitude": "8.58382000"
                    },
                    {
                        "id": 61729,
                        "name": "Valmadonna",
                        "latitude": "44.97444000",
                        "longitude": "8.61146000"
                    },
                    {
                        "id": 61731,
                        "name": "Valmala",
                        "latitude": "44.54423000",
                        "longitude": "7.34603000"
                    },
                    {
                        "id": 61736,
                        "name": "Valperga",
                        "latitude": "45.37004000",
                        "longitude": "7.66124000"
                    },
                    {
                        "id": 61737,
                        "name": "Valprato Soana",
                        "latitude": "45.52166000",
                        "longitude": "7.54948000"
                    },
                    {
                        "id": 61741,
                        "name": "Valstrona",
                        "latitude": "45.90767000",
                        "longitude": "8.34322000"
                    },
                    {
                        "id": 61755,
                        "name": "Vanzone",
                        "latitude": "45.97785000",
                        "longitude": "8.10826000"
                    },
                    {
                        "id": 61756,
                        "name": "Vaprio D'Agogna",
                        "latitude": "45.60322000",
                        "longitude": "8.55402000"
                    },
                    {
                        "id": 61759,
                        "name": "Varallo",
                        "latitude": "45.81383000",
                        "longitude": "8.25814000"
                    },
                    {
                        "id": 61760,
                        "name": "Varallo Pombia",
                        "latitude": "45.66784000",
                        "longitude": "8.62850000"
                    },
                    {
                        "id": 61771,
                        "name": "Varisella",
                        "latitude": "45.20835000",
                        "longitude": "7.48381000"
                    },
                    {
                        "id": 61776,
                        "name": "Varzo",
                        "latitude": "46.20736000",
                        "longitude": "8.25267000"
                    },
                    {
                        "id": 61784,
                        "name": "Vauda Canavese Superiore",
                        "latitude": "45.27947000",
                        "longitude": "7.61945000"
                    },
                    {
                        "id": 61797,
                        "name": "Veglio",
                        "latitude": "45.64057000",
                        "longitude": "8.11412000"
                    },
                    {
                        "id": 61809,
                        "name": "Venaria Reale",
                        "latitude": "45.12597000",
                        "longitude": "7.63136000"
                    },
                    {
                        "id": 61811,
                        "name": "Venasca",
                        "latitude": "44.56134000",
                        "longitude": "7.39698000"
                    },
                    {
                        "id": 61812,
                        "name": "Venaus",
                        "latitude": "45.15710000",
                        "longitude": "7.01070000"
                    },
                    {
                        "id": 61834,
                        "name": "Verbania",
                        "latitude": "45.92136000",
                        "longitude": "8.55183000"
                    },
                    {
                        "id": 61838,
                        "name": "Vercelli",
                        "latitude": "45.32163000",
                        "longitude": "8.41989000"
                    },
                    {
                        "id": 61844,
                        "name": "Verduno",
                        "latitude": "44.66614000",
                        "longitude": "7.93074000"
                    },
                    {
                        "id": 61849,
                        "name": "Vergnasco",
                        "latitude": "45.48803000",
                        "longitude": "8.08553000"
                    },
                    {
                        "id": 61853,
                        "name": "Vernante",
                        "latitude": "44.24447000",
                        "longitude": "7.53455000"
                    },
                    {
                        "id": 61861,
                        "name": "Verolengo",
                        "latitude": "45.19040000",
                        "longitude": "7.97126000"
                    },
                    {
                        "id": 61868,
                        "name": "Verrone",
                        "latitude": "45.50824000",
                        "longitude": "8.11514000"
                    },
                    {
                        "id": 61870,
                        "name": "Verrua Savoia",
                        "latitude": "45.15675000",
                        "longitude": "8.09223000"
                    },
                    {
                        "id": 61874,
                        "name": "Veruno",
                        "latitude": "45.68887000",
                        "longitude": "8.52863000"
                    },
                    {
                        "id": 61878,
                        "name": "Verzuolo",
                        "latitude": "44.59279000",
                        "longitude": "7.48164000"
                    },
                    {
                        "id": 61882,
                        "name": "Vesime",
                        "latitude": "44.63535000",
                        "longitude": "8.22683000"
                    },
                    {
                        "id": 61883,
                        "name": "Vespolate",
                        "latitude": "45.34953000",
                        "longitude": "8.66878000"
                    },
                    {
                        "id": 61886,
                        "name": "Vestignè",
                        "latitude": "45.38655000",
                        "longitude": "7.95336000"
                    },
                    {
                        "id": 61892,
                        "name": "Vezza d'Alba",
                        "latitude": "44.76274000",
                        "longitude": "8.00793000"
                    },
                    {
                        "id": 61902,
                        "name": "Viale",
                        "latitude": "45.00015000",
                        "longitude": "8.04993000"
                    },
                    {
                        "id": 61903,
                        "name": "Vialfrè",
                        "latitude": "45.38076000",
                        "longitude": "7.81822000"
                    },
                    {
                        "id": 61906,
                        "name": "Viarigi",
                        "latitude": "44.98055000",
                        "longitude": "8.35714000"
                    },
                    {
                        "id": 61916,
                        "name": "Vico Canavese",
                        "latitude": "45.49342000",
                        "longitude": "7.77887000"
                    },
                    {
                        "id": 61921,
                        "name": "Vicoforte",
                        "latitude": "44.36393000",
                        "longitude": "7.86264000"
                    },
                    {
                        "id": 61923,
                        "name": "Vicolungo",
                        "latitude": "45.47522000",
                        "longitude": "8.46124000"
                    },
                    {
                        "id": 61932,
                        "name": "Vidracco",
                        "latitude": "45.43066000",
                        "longitude": "7.75742000"
                    },
                    {
                        "id": 61936,
                        "name": "Viganella",
                        "latitude": "46.05173000",
                        "longitude": "8.19374000"
                    },
                    {
                        "id": 61951,
                        "name": "Vigliano Biellese",
                        "latitude": "45.56317000",
                        "longitude": "8.10509000"
                    },
                    {
                        "id": 61952,
                        "name": "Vigliano d'Asti",
                        "latitude": "44.83405000",
                        "longitude": "8.22914000"
                    },
                    {
                        "id": 61956,
                        "name": "Vignale Monferrato",
                        "latitude": "45.00996000",
                        "longitude": "8.39703000"
                    },
                    {
                        "id": 61963,
                        "name": "Vignole Borbera",
                        "latitude": "44.70819000",
                        "longitude": "8.89026000"
                    },
                    {
                        "id": 61965,
                        "name": "Vignolo",
                        "latitude": "44.36364000",
                        "longitude": "7.47208000"
                    },
                    {
                        "id": 61966,
                        "name": "Vignone",
                        "latitude": "45.96118000",
                        "longitude": "8.56372000"
                    },
                    {
                        "id": 61974,
                        "name": "Vigone",
                        "latitude": "44.84236000",
                        "longitude": "7.49774000"
                    },
                    {
                        "id": 61979,
                        "name": "Viguzzolo",
                        "latitude": "44.90567000",
                        "longitude": "8.91968000"
                    },
                    {
                        "id": 61982,
                        "name": "Villa",
                        "latitude": "44.74606000",
                        "longitude": "7.90066000"
                    },
                    {
                        "id": 62038,
                        "name": "Villa del Bosco",
                        "latitude": "45.61669000",
                        "longitude": "8.27776000"
                    },
                    {
                        "id": 62021,
                        "name": "Villa San Secondo",
                        "latitude": "45.00513000",
                        "longitude": "8.13462000"
                    },
                    {
                        "id": 62044,
                        "name": "Villa-Borgo",
                        "latitude": "44.69865000",
                        "longitude": "7.93486000"
                    },
                    {
                        "id": 62051,
                        "name": "Villadeati",
                        "latitude": "45.07225000",
                        "longitude": "8.16793000"
                    },
                    {
                        "id": 62053,
                        "name": "Villadossola",
                        "latitude": "46.07080000",
                        "longitude": "8.26709000"
                    },
                    {
                        "id": 62054,
                        "name": "Villafalletto",
                        "latitude": "44.54624000",
                        "longitude": "7.54069000"
                    },
                    {
                        "id": 62060,
                        "name": "Villafranca d'Asti",
                        "latitude": "44.91539000",
                        "longitude": "8.02658000"
                    },
                    {
                        "id": 62057,
                        "name": "Villafranca Piemonte",
                        "latitude": "44.78824000",
                        "longitude": "7.50788000"
                    },
                    {
                        "id": 62079,
                        "name": "Villalvernia",
                        "latitude": "44.81387000",
                        "longitude": "8.85532000"
                    },
                    {
                        "id": 62085,
                        "name": "Villamiroglio",
                        "latitude": "45.13455000",
                        "longitude": "8.17103000"
                    },
                    {
                        "id": 62096,
                        "name": "Villanova Biellese",
                        "latitude": "45.48156000",
                        "longitude": "8.19432000"
                    },
                    {
                        "id": 62097,
                        "name": "Villanova Canavese",
                        "latitude": "45.24355000",
                        "longitude": "7.55212000"
                    },
                    {
                        "id": 62107,
                        "name": "Villanova d'Asti",
                        "latitude": "44.94299000",
                        "longitude": "7.93671000"
                    },
                    {
                        "id": 62099,
                        "name": "Villanova Mondovì",
                        "latitude": "44.34804000",
                        "longitude": "7.76752000"
                    },
                    {
                        "id": 62100,
                        "name": "Villanova Monferrato",
                        "latitude": "45.18111000",
                        "longitude": "8.47813000"
                    },
                    {
                        "id": 62102,
                        "name": "Villanova Solaro",
                        "latitude": "44.72994000",
                        "longitude": "7.57443000"
                    },
                    {
                        "id": 62121,
                        "name": "Villar Dora",
                        "latitude": "45.11465000",
                        "longitude": "7.38352000"
                    },
                    {
                        "id": 62122,
                        "name": "Villar Focchiardo",
                        "latitude": "45.11244000",
                        "longitude": "7.23841000"
                    },
                    {
                        "id": 62123,
                        "name": "Villar Pellice",
                        "latitude": "44.80893000",
                        "longitude": "7.15978000"
                    },
                    {
                        "id": 62124,
                        "name": "Villar Perosa",
                        "latitude": "44.91849000",
                        "longitude": "7.24821000"
                    },
                    {
                        "id": 62125,
                        "name": "Villar San Costanzo",
                        "latitude": "44.48473000",
                        "longitude": "7.38223000"
                    },
                    {
                        "id": 62126,
                        "name": "Villarbasse",
                        "latitude": "45.04514000",
                        "longitude": "7.46842000"
                    },
                    {
                        "id": 62127,
                        "name": "Villarboit",
                        "latitude": "45.43775000",
                        "longitude": "8.33694000"
                    },
                    {
                        "id": 62128,
                        "name": "Villareggia",
                        "latitude": "45.30885000",
                        "longitude": "7.97724000"
                    },
                    {
                        "id": 62130,
                        "name": "Villaromagnano",
                        "latitude": "44.84965000",
                        "longitude": "8.88775000"
                    },
                    {
                        "id": 62141,
                        "name": "Villastellone",
                        "latitude": "44.92201000",
                        "longitude": "7.74360000"
                    },
                    {
                        "id": 62142,
                        "name": "Villata",
                        "latitude": "45.38650000",
                        "longitude": "8.43279000"
                    },
                    {
                        "id": 62152,
                        "name": "Villette",
                        "latitude": "46.13188000",
                        "longitude": "8.53422000"
                    },
                    {
                        "id": 62160,
                        "name": "Vinadio",
                        "latitude": "44.30759000",
                        "longitude": "7.17628000"
                    },
                    {
                        "id": 62162,
                        "name": "Vinchio",
                        "latitude": "44.81095000",
                        "longitude": "8.32094000"
                    },
                    {
                        "id": 62164,
                        "name": "Vinovo",
                        "latitude": "44.94674000",
                        "longitude": "7.63252000"
                    },
                    {
                        "id": 62165,
                        "name": "Vinzaglio",
                        "latitude": "45.32309000",
                        "longitude": "8.51979000"
                    },
                    {
                        "id": 62166,
                        "name": "Viola",
                        "latitude": "44.29081000",
                        "longitude": "7.96491000"
                    },
                    {
                        "id": 62169,
                        "name": "Virle Piemonte",
                        "latitude": "44.86369000",
                        "longitude": "7.57033000"
                    },
                    {
                        "id": 62171,
                        "name": "Vische",
                        "latitude": "45.33566000",
                        "longitude": "7.94482000"
                    },
                    {
                        "id": 62174,
                        "name": "Visone",
                        "latitude": "44.66184000",
                        "longitude": "8.50075000"
                    },
                    {
                        "id": 62177,
                        "name": "Vistrorio",
                        "latitude": "45.44147000",
                        "longitude": "7.76781000"
                    },
                    {
                        "id": 62196,
                        "name": "Viù",
                        "latitude": "45.23785000",
                        "longitude": "7.37333000"
                    },
                    {
                        "id": 62192,
                        "name": "Viverone",
                        "latitude": "45.42726000",
                        "longitude": "8.04942000"
                    },
                    {
                        "id": 62199,
                        "name": "Vocca",
                        "latitude": "45.83269000",
                        "longitude": "8.19580000"
                    },
                    {
                        "id": 62203,
                        "name": "Vogogna",
                        "latitude": "46.01002000",
                        "longitude": "8.29137000"
                    },
                    {
                        "id": 62210,
                        "name": "Volpedo",
                        "latitude": "44.88887000",
                        "longitude": "8.98615000"
                    },
                    {
                        "id": 62211,
                        "name": "Volpeglino",
                        "latitude": "44.89296000",
                        "longitude": "8.95945000"
                    },
                    {
                        "id": 62212,
                        "name": "Volpiano",
                        "latitude": "45.19940000",
                        "longitude": "7.77546000"
                    },
                    {
                        "id": 62214,
                        "name": "Voltaggio",
                        "latitude": "44.62095000",
                        "longitude": "8.84274000"
                    },
                    {
                        "id": 62223,
                        "name": "Volvera",
                        "latitude": "44.95484000",
                        "longitude": "7.51142000"
                    },
                    {
                        "id": 62225,
                        "name": "Vottignasco",
                        "latitude": "44.56413000",
                        "longitude": "7.57913000"
                    },
                    {
                        "id": 62261,
                        "name": "Zimone",
                        "latitude": "45.44912000",
                        "longitude": "8.03734000"
                    },
                    {
                        "id": 62278,
                        "name": "Zubiena",
                        "latitude": "45.49266000",
                        "longitude": "7.99552000"
                    },
                    {
                        "id": 62284,
                        "name": "Zumaglia",
                        "latitude": "45.59386000",
                        "longitude": "8.08942000"
                    }
                ]
            },
            {
                "id": 1685,
                "name": "Pisa",
                "iso2": "PI",
                "latitude": "43.72283150",
                "longitude": "10.40171940",
                "type": "province",
                "cities": []
            },
            {
                "id": 1687,
                "name": "Pistoia",
                "iso2": "PT",
                "latitude": "43.95437330",
                "longitude": "10.89030990",
                "type": "province",
                "cities": []
            },
            {
                "id": 1690,
                "name": "Pordenone",
                "iso2": "PN",
                "latitude": "46.03788620",
                "longitude": "12.71083500",
                "type": "decentralized regional entity",
                "cities": []
            },
            {
                "id": 1697,
                "name": "Potenza",
                "iso2": "PZ",
                "latitude": "40.41821940",
                "longitude": "15.87600400",
                "type": "province",
                "cities": []
            },
            {
                "id": 1700,
                "name": "Prato",
                "iso2": "PO",
                "latitude": "44.04539000",
                "longitude": "11.11644520",
                "type": "province",
                "cities": []
            },
            {
                "id": 1729,
                "name": "Ragusa",
                "iso2": "RG",
                "latitude": "36.92692730",
                "longitude": "14.72551290",
                "type": "free municipal consortium",
                "cities": []
            },
            {
                "id": 1707,
                "name": "Ravenna",
                "iso2": "RA",
                "latitude": "44.41844430",
                "longitude": "12.20359980",
                "type": "province",
                "cities": [
                    {
                        "id": 135403,
                        "name": "Alfonsine",
                        "latitude": "44.50768000",
                        "longitude": "12.03743000"
                    },
                    {
                        "id": 135748,
                        "name": "Bagnacavallo",
                        "latitude": "44.41402000",
                        "longitude": "11.97813000"
                    },
                    {
                        "id": 135750,
                        "name": "Bagnara di Romagna",
                        "latitude": "44.38930000",
                        "longitude": "11.82726000"
                    },
                    {
                        "id": 136341,
                        "name": "Brisighella",
                        "latitude": "44.22228000",
                        "longitude": "11.77358000"
                    },
                    {
                        "id": 137078,
                        "name": "Casola Valsenio",
                        "latitude": "44.22443000",
                        "longitude": "11.62487000"
                    },
                    {
                        "id": 137131,
                        "name": "Castel Bolognese",
                        "latitude": "44.31981000",
                        "longitude": "11.79903000"
                    },
                    {
                        "id": 137591,
                        "name": "Cervia",
                        "latitude": "44.26204000",
                        "longitude": "12.34812000"
                    },
                    {
                        "id": 137974,
                        "name": "Conselice",
                        "latitude": "44.51163000",
                        "longitude": "11.82848000"
                    },
                    {
                        "id": 138111,
                        "name": "Cotignola",
                        "latitude": "44.38572000",
                        "longitude": "11.93852000"
                    },
                    {
                        "id": 138403,
                        "name": "Faenza",
                        "latitude": "44.29007000",
                        "longitude": "11.87948000"
                    },
                    {
                        "id": 138761,
                        "name": "Fusignano",
                        "latitude": "44.46656000",
                        "longitude": "11.95636000"
                    },
                    {
                        "id": 139648,
                        "name": "Lugo",
                        "latitude": "44.42137000",
                        "longitude": "11.91094000"
                    },
                    {
                        "id": 139971,
                        "name": "Massa Lombarda",
                        "latitude": "44.44703000",
                        "longitude": "11.82095000"
                    },
                    {
                        "id": 59299,
                        "name": "Ravenna",
                        "latitude": "44.41344000",
                        "longitude": "12.20121000"
                    },
                    {
                        "id": 59393,
                        "name": "Riolo Terme",
                        "latitude": "44.27609000",
                        "longitude": "11.72722000"
                    },
                    {
                        "id": 59704,
                        "name": "Russi",
                        "latitude": "44.37645000",
                        "longitude": "12.03335000"
                    },
                    {
                        "id": 60326,
                        "name": "Sant'Agata sul Santerno",
                        "latitude": "44.44351000",
                        "longitude": "11.86112000"
                    },
                    {
                        "id": 60905,
                        "name": "Solarolo",
                        "latitude": "44.35892000",
                        "longitude": "11.84661000"
                    }
                ]
            },
            {
                "id": 1708,
                "name": "Reggio Emilia",
                "iso2": "RE",
                "latitude": "44.58565800",
                "longitude": "10.55647360",
                "type": "province",
                "cities": []
            },
            {
                "id": 1712,
                "name": "Rieti",
                "iso2": "RI",
                "latitude": "42.36744050",
                "longitude": "12.89750980",
                "type": "province",
                "cities": []
            },
            {
                "id": 1713,
                "name": "Rimini",
                "iso2": "RN",
                "latitude": "44.06782880",
                "longitude": "12.56951580",
                "type": "province",
                "cities": []
            },
            {
                "id": 1719,
                "name": "Rovigo",
                "iso2": "RO",
                "latitude": "45.02418180",
                "longitude": "11.82381620",
                "type": "province",
                "cities": []
            },
            {
                "id": 1720,
                "name": "Salerno",
                "iso2": "SA",
                "latitude": "40.42878320",
                "longitude": "15.21948080",
                "type": "province",
                "cities": []
            },
            {
                "id": 1715,
                "name": "Sardinia",
                "iso2": "88",
                "latitude": "40.12087520",
                "longitude": "9.01289260",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 135239,
                        "name": "Abbasanta",
                        "latitude": "40.12812000",
                        "longitude": "8.81760000"
                    },
                    {
                        "id": 135299,
                        "name": "Aggius",
                        "latitude": "40.92995000",
                        "longitude": "9.06517000"
                    },
                    {
                        "id": 135305,
                        "name": "Aglientu",
                        "latitude": "41.07906000",
                        "longitude": "9.11267000"
                    },
                    {
                        "id": 135323,
                        "name": "Aidomaggiore",
                        "latitude": "40.17147000",
                        "longitude": "8.85679000"
                    },
                    {
                        "id": 135453,
                        "name": "Alà dei Sardi",
                        "latitude": "40.65007000",
                        "longitude": "9.32783000"
                    },
                    {
                        "id": 135348,
                        "name": "Albagiara",
                        "latitude": "39.78724000",
                        "longitude": "8.86184000"
                    },
                    {
                        "id": 135393,
                        "name": "Ales",
                        "latitude": "39.76830000",
                        "longitude": "8.81520000"
                    },
                    {
                        "id": 135404,
                        "name": "Alghero",
                        "latitude": "40.55969000",
                        "longitude": "8.31953000"
                    },
                    {
                        "id": 135414,
                        "name": "Allai",
                        "latitude": "39.95701000",
                        "longitude": "8.86354000"
                    },
                    {
                        "id": 135494,
                        "name": "Anela",
                        "latitude": "40.44176000",
                        "longitude": "9.05743000"
                    },
                    {
                        "id": 135553,
                        "name": "Arbatax",
                        "latitude": "39.93444000",
                        "longitude": "9.70556000"
                    },
                    {
                        "id": 135556,
                        "name": "Arborea",
                        "latitude": "39.77276000",
                        "longitude": "8.58129000"
                    },
                    {
                        "id": 135558,
                        "name": "Arbus",
                        "latitude": "39.52616000",
                        "longitude": "8.59970000"
                    },
                    {
                        "id": 135576,
                        "name": "Ardara",
                        "latitude": "40.62140000",
                        "longitude": "8.80987000"
                    },
                    {
                        "id": 135577,
                        "name": "Ardauli",
                        "latitude": "40.08436000",
                        "longitude": "8.91228000"
                    },
                    {
                        "id": 135607,
                        "name": "Aritzo",
                        "latitude": "39.95903000",
                        "longitude": "9.19265000"
                    },
                    {
                        "id": 135617,
                        "name": "Armungia",
                        "latitude": "39.52154000",
                        "longitude": "9.38066000"
                    },
                    {
                        "id": 135646,
                        "name": "Arzachena",
                        "latitude": "41.07620000",
                        "longitude": "9.39055000"
                    },
                    {
                        "id": 135648,
                        "name": "Arzana",
                        "latitude": "39.91742000",
                        "longitude": "9.52766000"
                    },
                    {
                        "id": 135665,
                        "name": "Assemini",
                        "latitude": "39.29123000",
                        "longitude": "8.99879000"
                    },
                    {
                        "id": 135668,
                        "name": "Assolo",
                        "latitude": "39.80915000",
                        "longitude": "8.91932000"
                    },
                    {
                        "id": 135671,
                        "name": "Asuni",
                        "latitude": "39.87101000",
                        "longitude": "8.94603000"
                    },
                    {
                        "id": 135683,
                        "name": "Atzara",
                        "latitude": "39.99249000",
                        "longitude": "9.07616000"
                    },
                    {
                        "id": 135695,
                        "name": "Austis",
                        "latitude": "40.07122000",
                        "longitude": "9.08878000"
                    },
                    {
                        "id": 135730,
                        "name": "Bacu Abis",
                        "latitude": "39.24301000",
                        "longitude": "8.46491000"
                    },
                    {
                        "id": 135733,
                        "name": "Badesi",
                        "latitude": "40.96460000",
                        "longitude": "8.88235000"
                    },
                    {
                        "id": 135790,
                        "name": "Ballao",
                        "latitude": "39.54919000",
                        "longitude": "9.36178000"
                    },
                    {
                        "id": 135800,
                        "name": "Banari",
                        "latitude": "40.57056000",
                        "longitude": "8.70052000"
                    },
                    {
                        "id": 135801,
                        "name": "Bancali",
                        "latitude": "40.73549000",
                        "longitude": "8.46328000"
                    },
                    {
                        "id": 135808,
                        "name": "Baradili",
                        "latitude": "39.72189000",
                        "longitude": "8.89731000"
                    },
                    {
                        "id": 135815,
                        "name": "Baratili San Pietro",
                        "latitude": "39.99220000",
                        "longitude": "8.55586000"
                    },
                    {
                        "id": 135846,
                        "name": "Baressa",
                        "latitude": "39.71308000",
                        "longitude": "8.87459000"
                    },
                    {
                        "id": 135854,
                        "name": "Bari Sardo",
                        "latitude": "39.84135000",
                        "longitude": "9.64606000"
                    },
                    {
                        "id": 135869,
                        "name": "Barrali",
                        "latitude": "39.47532000",
                        "longitude": "9.10204000"
                    },
                    {
                        "id": 135872,
                        "name": "Barumini",
                        "latitude": "39.70215000",
                        "longitude": "9.00338000"
                    },
                    {
                        "id": 135912,
                        "name": "Bauladu",
                        "latitude": "40.02055000",
                        "longitude": "8.67192000"
                    },
                    {
                        "id": 135913,
                        "name": "Baunei",
                        "latitude": "40.03132000",
                        "longitude": "9.66374000"
                    },
                    {
                        "id": 135969,
                        "name": "Belvì",
                        "latitude": "39.96181000",
                        "longitude": "9.18419000"
                    },
                    {
                        "id": 135974,
                        "name": "Benetutti",
                        "latitude": "40.45689000",
                        "longitude": "9.16754000"
                    },
                    {
                        "id": 135982,
                        "name": "Berchidda",
                        "latitude": "40.78476000",
                        "longitude": "9.16510000"
                    },
                    {
                        "id": 136017,
                        "name": "Bessude",
                        "latitude": "40.55449000",
                        "longitude": "8.72753000"
                    },
                    {
                        "id": 136045,
                        "name": "Bidonì",
                        "latitude": "40.11305000",
                        "longitude": "8.93643000"
                    },
                    {
                        "id": 136057,
                        "name": "Birori",
                        "latitude": "40.26593000",
                        "longitude": "8.81570000"
                    },
                    {
                        "id": 136070,
                        "name": "Bitti",
                        "latitude": "40.47956000",
                        "longitude": "9.38403000"
                    },
                    {
                        "id": 136112,
                        "name": "Bolotana",
                        "latitude": "40.32440000",
                        "longitude": "8.96109000"
                    },
                    {
                        "id": 136123,
                        "name": "Bonarcado",
                        "latitude": "40.09836000",
                        "longitude": "8.65534000"
                    },
                    {
                        "id": 136140,
                        "name": "Bonnanaro",
                        "latitude": "40.53265000",
                        "longitude": "8.76389000"
                    },
                    {
                        "id": 136141,
                        "name": "Bono",
                        "latitude": "40.41387000",
                        "longitude": "9.03187000"
                    },
                    {
                        "id": 136142,
                        "name": "Bonorva",
                        "latitude": "40.41839000",
                        "longitude": "8.76831000"
                    },
                    {
                        "id": 136225,
                        "name": "Boroneddu",
                        "latitude": "40.11262000",
                        "longitude": "8.87023000"
                    },
                    {
                        "id": 136226,
                        "name": "Borore",
                        "latitude": "40.21576000",
                        "longitude": "8.80365000"
                    },
                    {
                        "id": 136230,
                        "name": "Bortigali",
                        "latitude": "40.28268000",
                        "longitude": "8.83946000"
                    },
                    {
                        "id": 136231,
                        "name": "Bortigiadas",
                        "latitude": "40.89167000",
                        "longitude": "9.04352000"
                    },
                    {
                        "id": 136233,
                        "name": "Borutta",
                        "latitude": "40.52236000",
                        "longitude": "8.74352000"
                    },
                    {
                        "id": 136236,
                        "name": "Bosa",
                        "latitude": "40.29927000",
                        "longitude": "8.49827000"
                    },
                    {
                        "id": 136262,
                        "name": "Bottidda",
                        "latitude": "40.39242000",
                        "longitude": "9.01039000"
                    },
                    {
                        "id": 136390,
                        "name": "Buddusò",
                        "latitude": "40.57723000",
                        "longitude": "9.25839000"
                    },
                    {
                        "id": 136392,
                        "name": "Budoni",
                        "latitude": "40.70467000",
                        "longitude": "9.70384000"
                    },
                    {
                        "id": 136395,
                        "name": "Buggerru",
                        "latitude": "39.39831000",
                        "longitude": "8.40186000"
                    },
                    {
                        "id": 136403,
                        "name": "Bultei",
                        "latitude": "40.45720000",
                        "longitude": "9.06367000"
                    },
                    {
                        "id": 136404,
                        "name": "Bulzi",
                        "latitude": "40.84666000",
                        "longitude": "8.83026000"
                    },
                    {
                        "id": 136411,
                        "name": "Burcei",
                        "latitude": "39.34379000",
                        "longitude": "9.36027000"
                    },
                    {
                        "id": 136413,
                        "name": "Burgos",
                        "latitude": "40.39081000",
                        "longitude": "8.99558000"
                    },
                    {
                        "id": 136417,
                        "name": "Busachi",
                        "latitude": "40.03422000",
                        "longitude": "8.88848000"
                    },
                    {
                        "id": 136450,
                        "name": "Cabras",
                        "latitude": "39.92871000",
                        "longitude": "8.53242000"
                    },
                    {
                        "id": 136468,
                        "name": "Cagliari",
                        "latitude": "39.23054000",
                        "longitude": "9.11917000"
                    },
                    {
                        "id": 136485,
                        "name": "Cala Gonone",
                        "latitude": "40.28086000",
                        "longitude": "9.62971000"
                    },
                    {
                        "id": 136490,
                        "name": "Calangianus",
                        "latitude": "40.92027000",
                        "longitude": "9.19343000"
                    },
                    {
                        "id": 136495,
                        "name": "Calasetta",
                        "latitude": "39.10697000",
                        "longitude": "8.36803000"
                    },
                    {
                        "id": 136788,
                        "name": "Capoterra",
                        "latitude": "39.17520000",
                        "longitude": "8.97199000"
                    },
                    {
                        "id": 136852,
                        "name": "Carbonia",
                        "latitude": "39.16465000",
                        "longitude": "8.52130000"
                    },
                    {
                        "id": 136859,
                        "name": "Cardedu",
                        "latitude": "39.79714000",
                        "longitude": "9.62652000"
                    },
                    {
                        "id": 136873,
                        "name": "Cargeghe",
                        "latitude": "40.66894000",
                        "longitude": "8.61521000"
                    },
                    {
                        "id": 136888,
                        "name": "Carloforte",
                        "latitude": "39.14081000",
                        "longitude": "8.30390000"
                    },
                    {
                        "id": 137314,
                        "name": "Castelsardo",
                        "latitude": "40.91256000",
                        "longitude": "8.71453000"
                    },
                    {
                        "id": 137335,
                        "name": "Castiadas",
                        "latitude": "39.23704000",
                        "longitude": "9.49975000"
                    },
                    {
                        "id": 137637,
                        "name": "Cheremule",
                        "latitude": "40.50455000",
                        "longitude": "8.72582000"
                    },
                    {
                        "id": 137649,
                        "name": "Chiaramonti",
                        "latitude": "40.74829000",
                        "longitude": "8.82114000"
                    },
                    {
                        "id": 137827,
                        "name": "Codaruina",
                        "latitude": "40.92847000",
                        "longitude": "8.82398000"
                    },
                    {
                        "id": 137838,
                        "name": "Codrongianos",
                        "latitude": "40.65603000",
                        "longitude": "8.68140000"
                    },
                    {
                        "id": 137903,
                        "name": "Collinas",
                        "latitude": "39.64059000",
                        "longitude": "8.83955000"
                    },
                    {
                        "id": 138070,
                        "name": "Cortoghiana",
                        "latitude": "39.21177000",
                        "longitude": "8.46548000"
                    },
                    {
                        "id": 138089,
                        "name": "Cossoine",
                        "latitude": "40.43068000",
                        "longitude": "8.71578000"
                    },
                    {
                        "id": 138185,
                        "name": "Cuglieri",
                        "latitude": "40.18804000",
                        "longitude": "8.56806000"
                    },
                    {
                        "id": 138199,
                        "name": "Curcuris",
                        "latitude": "39.74625000",
                        "longitude": "8.83154000"
                    },
                    {
                        "id": 138236,
                        "name": "Decimomannu",
                        "latitude": "39.31033000",
                        "longitude": "8.96964000"
                    },
                    {
                        "id": 138237,
                        "name": "Decimoputzu",
                        "latitude": "39.33522000",
                        "longitude": "8.91440000"
                    },
                    {
                        "id": 138258,
                        "name": "Desulo",
                        "latitude": "40.01462000",
                        "longitude": "9.23061000"
                    },
                    {
                        "id": 138283,
                        "name": "Dolianova",
                        "latitude": "39.37791000",
                        "longitude": "9.17697000"
                    },
                    {
                        "id": 138293,
                        "name": "Domus de Maria",
                        "latitude": "38.94451000",
                        "longitude": "8.86250000"
                    },
                    {
                        "id": 138294,
                        "name": "Domusnovas",
                        "latitude": "39.32404000",
                        "longitude": "8.64921000"
                    },
                    {
                        "id": 138299,
                        "name": "Donigala Fenugheddu",
                        "latitude": "39.93501000",
                        "longitude": "8.57311000"
                    },
                    {
                        "id": 138304,
                        "name": "Donorì",
                        "latitude": "39.43182000",
                        "longitude": "9.12674000"
                    },
                    {
                        "id": 138306,
                        "name": "Dorgali",
                        "latitude": "40.29221000",
                        "longitude": "9.58702000"
                    },
                    {
                        "id": 138336,
                        "name": "Dualchi",
                        "latitude": "40.22935000",
                        "longitude": "8.89723000"
                    },
                    {
                        "id": 138352,
                        "name": "Elini",
                        "latitude": "39.89952000",
                        "longitude": "9.53198000"
                    },
                    {
                        "id": 138354,
                        "name": "Elmas",
                        "latitude": "39.26878000",
                        "longitude": "9.05021000"
                    },
                    {
                        "id": 138377,
                        "name": "Erula",
                        "latitude": "40.79244000",
                        "longitude": "8.94418000"
                    },
                    {
                        "id": 138380,
                        "name": "Escalaplano",
                        "latitude": "39.62574000",
                        "longitude": "9.35350000"
                    },
                    {
                        "id": 138381,
                        "name": "Escolca",
                        "latitude": "39.69861000",
                        "longitude": "9.12139000"
                    },
                    {
                        "id": 138385,
                        "name": "Esporlatu",
                        "latitude": "40.38456000",
                        "longitude": "8.98983000"
                    },
                    {
                        "id": 138387,
                        "name": "Esterzili",
                        "latitude": "39.78041000",
                        "longitude": "9.28357000"
                    },
                    {
                        "id": 138566,
                        "name": "Florinas",
                        "latitude": "40.64900000",
                        "longitude": "8.66548000"
                    },
                    {
                        "id": 138568,
                        "name": "Fluminimaggiore",
                        "latitude": "39.43878000",
                        "longitude": "8.49758000"
                    },
                    {
                        "id": 138569,
                        "name": "Flussio",
                        "latitude": "40.26545000",
                        "longitude": "8.53810000"
                    },
                    {
                        "id": 138590,
                        "name": "Fonni",
                        "latitude": "40.11932000",
                        "longitude": "9.25347000"
                    },
                    {
                        "id": 138623,
                        "name": "Fordongianus",
                        "latitude": "39.99436000",
                        "longitude": "8.81019000"
                    },
                    {
                        "id": 138759,
                        "name": "Furtei",
                        "latitude": "39.56253000",
                        "longitude": "8.94773000"
                    },
                    {
                        "id": 138773,
                        "name": "Gadoni",
                        "latitude": "39.91388000",
                        "longitude": "9.18560000"
                    },
                    {
                        "id": 138792,
                        "name": "Gairo Sant'Elena",
                        "latitude": "39.84972000",
                        "longitude": "9.50472000"
                    },
                    {
                        "id": 138822,
                        "name": "Galtellì",
                        "latitude": "40.38451000",
                        "longitude": "9.61241000"
                    },
                    {
                        "id": 138879,
                        "name": "Gavoi",
                        "latitude": "40.16130000",
                        "longitude": "9.19462000"
                    },
                    {
                        "id": 138901,
                        "name": "Genoni",
                        "latitude": "39.79361000",
                        "longitude": "9.00797000"
                    },
                    {
                        "id": 138902,
                        "name": "Genuri",
                        "latitude": "39.74327000",
                        "longitude": "8.92407000"
                    },
                    {
                        "id": 138915,
                        "name": "Gergei",
                        "latitude": "39.69878000",
                        "longitude": "9.09965000"
                    },
                    {
                        "id": 138924,
                        "name": "Gesico",
                        "latitude": "39.61636000",
                        "longitude": "9.10665000"
                    },
                    {
                        "id": 138927,
                        "name": "Gesturi",
                        "latitude": "39.73237000",
                        "longitude": "9.02077000"
                    },
                    {
                        "id": 138934,
                        "name": "Ghilarza",
                        "latitude": "40.12119000",
                        "longitude": "8.83612000"
                    },
                    {
                        "id": 138950,
                        "name": "Giave",
                        "latitude": "40.45224000",
                        "longitude": "8.75175000"
                    },
                    {
                        "id": 138954,
                        "name": "Giba",
                        "latitude": "39.07151000",
                        "longitude": "8.63580000"
                    },
                    {
                        "id": 138982,
                        "name": "Girasole",
                        "latitude": "39.95205000",
                        "longitude": "9.66098000"
                    },
                    {
                        "id": 139014,
                        "name": "Golfo Aranci",
                        "latitude": "40.98333000",
                        "longitude": "9.63333000"
                    },
                    {
                        "id": 139017,
                        "name": "Goni",
                        "latitude": "39.57906000",
                        "longitude": "9.28519000"
                    },
                    {
                        "id": 139018,
                        "name": "Gonnesa",
                        "latitude": "39.26535000",
                        "longitude": "8.47038000"
                    },
                    {
                        "id": 139019,
                        "name": "Gonnoscodina",
                        "latitude": "39.69962000",
                        "longitude": "8.83598000"
                    },
                    {
                        "id": 139020,
                        "name": "Gonnosfanadiga",
                        "latitude": "39.49426000",
                        "longitude": "8.66200000"
                    },
                    {
                        "id": 139021,
                        "name": "Gonnosnò",
                        "latitude": "39.76104000",
                        "longitude": "8.87135000"
                    },
                    {
                        "id": 139022,
                        "name": "Gonnostramatza",
                        "latitude": "39.68306000",
                        "longitude": "8.83283000"
                    },
                    {
                        "id": 139150,
                        "name": "Guamaggiore",
                        "latitude": "39.56849000",
                        "longitude": "9.07391000"
                    },
                    {
                        "id": 139168,
                        "name": "Guasila",
                        "latitude": "39.55980000",
                        "longitude": "9.04404000"
                    },
                    {
                        "id": 139184,
                        "name": "Guspini",
                        "latitude": "39.53954000",
                        "longitude": "8.63502000"
                    },
                    {
                        "id": 139191,
                        "name": "Iglesias",
                        "latitude": "39.30920000",
                        "longitude": "8.53720000"
                    },
                    {
                        "id": 139194,
                        "name": "Ilbono",
                        "latitude": "39.89258000",
                        "longitude": "9.54582000"
                    },
                    {
                        "id": 139196,
                        "name": "Illorai",
                        "latitude": "40.35271000",
                        "longitude": "9.00170000"
                    },
                    {
                        "id": 139221,
                        "name": "Irgoli",
                        "latitude": "40.40999000",
                        "longitude": "9.63135000"
                    },
                    {
                        "id": 139234,
                        "name": "Isili",
                        "latitude": "39.73952000",
                        "longitude": "9.11114000"
                    },
                    {
                        "id": 139269,
                        "name": "Ittireddu",
                        "latitude": "40.54398000",
                        "longitude": "8.90118000"
                    },
                    {
                        "id": 139270,
                        "name": "Ittiri",
                        "latitude": "40.59151000",
                        "longitude": "8.56976000"
                    },
                    {
                        "id": 139277,
                        "name": "Jerzu",
                        "latitude": "39.79289000",
                        "longitude": "9.51785000"
                    },
                    {
                        "id": 139287,
                        "name": "La Caletta",
                        "latitude": "40.60988000",
                        "longitude": "9.75062000"
                    },
                    {
                        "id": 139293,
                        "name": "La Maddalena",
                        "latitude": "39.14429000",
                        "longitude": "9.01223000"
                    },
                    {
                        "id": 139316,
                        "name": "Laconi",
                        "latitude": "39.85325000",
                        "longitude": "9.05196000"
                    },
                    {
                        "id": 139319,
                        "name": "Laerru",
                        "latitude": "40.81705000",
                        "longitude": "8.83650000"
                    },
                    {
                        "id": 139360,
                        "name": "Lanusei",
                        "latitude": "39.87927000",
                        "longitude": "9.54022000"
                    },
                    {
                        "id": 139377,
                        "name": "Las Plassas",
                        "latitude": "39.67979000",
                        "longitude": "8.98442000"
                    },
                    {
                        "id": 139438,
                        "name": "Lei",
                        "latitude": "40.30641000",
                        "longitude": "8.91858000"
                    },
                    {
                        "id": 139491,
                        "name": "Li Punti-San Giovanni",
                        "latitude": "40.76338000",
                        "longitude": "8.48900000"
                    },
                    {
                        "id": 139564,
                        "name": "Loceri",
                        "latitude": "39.85816000",
                        "longitude": "9.58368000"
                    },
                    {
                        "id": 139567,
                        "name": "Loculi",
                        "latitude": "40.40696000",
                        "longitude": "9.61056000"
                    },
                    {
                        "id": 139574,
                        "name": "Lodè",
                        "latitude": "40.59137000",
                        "longitude": "9.53873000"
                    },
                    {
                        "id": 139571,
                        "name": "Lodine",
                        "latitude": "40.14926000",
                        "longitude": "9.21873000"
                    },
                    {
                        "id": 139577,
                        "name": "Loiri Porto San Paolo",
                        "latitude": "40.84262000",
                        "longitude": "9.49820000"
                    },
                    {
                        "id": 139618,
                        "name": "Lotzorai",
                        "latitude": "39.96940000",
                        "longitude": "9.66350000"
                    },
                    {
                        "id": 139627,
                        "name": "Lu Bagnu",
                        "latitude": "40.90184000",
                        "longitude": "8.68555000"
                    },
                    {
                        "id": 139653,
                        "name": "Lula",
                        "latitude": "40.47048000",
                        "longitude": "9.48684000"
                    },
                    {
                        "id": 139657,
                        "name": "Lunamatrona",
                        "latitude": "39.64943000",
                        "longitude": "8.89966000"
                    },
                    {
                        "id": 139663,
                        "name": "Luogosanto",
                        "latitude": "41.04681000",
                        "longitude": "9.20553000"
                    },
                    {
                        "id": 139668,
                        "name": "Luras",
                        "latitude": "40.93643000",
                        "longitude": "9.17480000"
                    },
                    {
                        "id": 139703,
                        "name": "Macomer",
                        "latitude": "40.26233000",
                        "longitude": "8.76733000"
                    },
                    {
                        "id": 139740,
                        "name": "Magomadas",
                        "latitude": "40.26321000",
                        "longitude": "8.52327000"
                    },
                    {
                        "id": 139781,
                        "name": "Mamoiada",
                        "latitude": "40.21487000",
                        "longitude": "9.28189000"
                    },
                    {
                        "id": 139784,
                        "name": "Mandas",
                        "latitude": "39.65514000",
                        "longitude": "9.12955000"
                    },
                    {
                        "id": 139817,
                        "name": "Mara",
                        "latitude": "40.41019000",
                        "longitude": "8.63664000"
                    },
                    {
                        "id": 139818,
                        "name": "Maracalagonis",
                        "latitude": "39.28574000",
                        "longitude": "9.22874000"
                    },
                    {
                        "id": 139916,
                        "name": "Marrubiu",
                        "latitude": "39.75124000",
                        "longitude": "8.63766000"
                    },
                    {
                        "id": 139939,
                        "name": "Martis",
                        "latitude": "40.77804000",
                        "longitude": "8.80897000"
                    },
                    {
                        "id": 139950,
                        "name": "Masainas",
                        "latitude": "39.04993000",
                        "longitude": "8.62924000"
                    },
                    {
                        "id": 139991,
                        "name": "Masullas",
                        "latitude": "39.70044000",
                        "longitude": "8.78371000"
                    },
                    {
                        "id": 140013,
                        "name": "Meana Sardo",
                        "latitude": "39.94467000",
                        "longitude": "9.07355000"
                    },
                    {
                        "id": 140148,
                        "name": "Milis",
                        "latitude": "40.05045000",
                        "longitude": "8.63702000"
                    },
                    {
                        "id": 140191,
                        "name": "Modolo",
                        "latitude": "40.27535000",
                        "longitude": "8.53002000"
                    },
                    {
                        "id": 140200,
                        "name": "Mogorella",
                        "latitude": "39.86447000",
                        "longitude": "8.85913000"
                    },
                    {
                        "id": 140201,
                        "name": "Mogoro",
                        "latitude": "39.68415000",
                        "longitude": "8.77661000"
                    },
                    {
                        "id": 140261,
                        "name": "Monastir",
                        "latitude": "39.38360000",
                        "longitude": "9.04445000"
                    },
                    {
                        "id": 140302,
                        "name": "Monserrato",
                        "latitude": "39.25642000",
                        "longitude": "9.14440000"
                    },
                    {
                        "id": 140467,
                        "name": "Monteleone Rocca Doria",
                        "latitude": "40.47206000",
                        "longitude": "8.56071000"
                    },
                    {
                        "id": 140553,
                        "name": "Monti",
                        "latitude": "40.80715000",
                        "longitude": "9.32553000"
                    },
                    {
                        "id": 140590,
                        "name": "Montresta",
                        "latitude": "40.37365000",
                        "longitude": "8.49962000"
                    },
                    {
                        "id": 140609,
                        "name": "Mores",
                        "latitude": "40.54745000",
                        "longitude": "8.83302000"
                    },
                    {
                        "id": 140614,
                        "name": "Morgongiori",
                        "latitude": "39.74630000",
                        "longitude": "8.77041000"
                    },
                    {
                        "id": 140686,
                        "name": "Muravera",
                        "latitude": "39.41972000",
                        "longitude": "9.57471000"
                    },
                    {
                        "id": 140695,
                        "name": "Muros",
                        "latitude": "40.67902000",
                        "longitude": "8.61780000"
                    },
                    {
                        "id": 140699,
                        "name": "Musei",
                        "latitude": "39.30232000",
                        "longitude": "8.66613000"
                    },
                    {
                        "id": 140715,
                        "name": "Narbolia",
                        "latitude": "40.04784000",
                        "longitude": "8.57552000"
                    },
                    {
                        "id": 140716,
                        "name": "Narcao",
                        "latitude": "39.16750000",
                        "longitude": "8.67500000"
                    },
                    {
                        "id": 140742,
                        "name": "Neoneli",
                        "latitude": "40.06475000",
                        "longitude": "8.94673000"
                    },
                    {
                        "id": 140805,
                        "name": "Noragugume",
                        "latitude": "40.22443000",
                        "longitude": "8.92012000"
                    },
                    {
                        "id": 140806,
                        "name": "Norbello",
                        "latitude": "40.13475000",
                        "longitude": "8.83203000"
                    },
                    {
                        "id": 140843,
                        "name": "Nughedu San Nicolò",
                        "latitude": "40.55736000",
                        "longitude": "9.02142000"
                    },
                    {
                        "id": 140844,
                        "name": "Nughedu Santa Vittoria",
                        "latitude": "40.10135000",
                        "longitude": "8.95247000"
                    },
                    {
                        "id": 140845,
                        "name": "Nule",
                        "latitude": "40.46266000",
                        "longitude": "9.19076000"
                    },
                    {
                        "id": 140846,
                        "name": "Nulvi",
                        "latitude": "40.78447000",
                        "longitude": "8.74358000"
                    },
                    {
                        "id": 140849,
                        "name": "Nuoro",
                        "latitude": "40.31991000",
                        "longitude": "9.32568000"
                    },
                    {
                        "id": 140853,
                        "name": "Nurachi",
                        "latitude": "39.97451000",
                        "longitude": "8.53965000"
                    },
                    {
                        "id": 140854,
                        "name": "Nuragus",
                        "latitude": "39.77771000",
                        "longitude": "9.03724000"
                    },
                    {
                        "id": 140855,
                        "name": "Nurallao",
                        "latitude": "39.78908000",
                        "longitude": "9.07802000"
                    },
                    {
                        "id": 140856,
                        "name": "Nuraminis",
                        "latitude": "39.44258000",
                        "longitude": "9.01395000"
                    },
                    {
                        "id": 140857,
                        "name": "Nuraxinieddu",
                        "latitude": "39.93843000",
                        "longitude": "8.59910000"
                    },
                    {
                        "id": 140858,
                        "name": "Nureci",
                        "latitude": "39.82329000",
                        "longitude": "8.97484000"
                    },
                    {
                        "id": 140859,
                        "name": "Nurri",
                        "latitude": "39.71122000",
                        "longitude": "9.22990000"
                    },
                    {
                        "id": 140864,
                        "name": "Nuxis",
                        "latitude": "39.15456000",
                        "longitude": "8.73953000"
                    },
                    {
                        "id": 140884,
                        "name": "Olbia",
                        "latitude": "40.92337000",
                        "longitude": "9.49802000"
                    },
                    {
                        "id": 140896,
                        "name": "Olia Speciosa",
                        "latitude": "39.27806000",
                        "longitude": "9.52500000"
                    },
                    {
                        "id": 140897,
                        "name": "Oliena",
                        "latitude": "40.27617000",
                        "longitude": "9.40193000"
                    },
                    {
                        "id": 140905,
                        "name": "Ollastra",
                        "latitude": "39.95095000",
                        "longitude": "8.73423000"
                    },
                    {
                        "id": 140906,
                        "name": "Ollolai",
                        "latitude": "40.16805000",
                        "longitude": "9.17776000"
                    },
                    {
                        "id": 140908,
                        "name": "Olmedo",
                        "latitude": "40.65156000",
                        "longitude": "8.38021000"
                    },
                    {
                        "id": 140916,
                        "name": "Olzai",
                        "latitude": "40.18238000",
                        "longitude": "9.14679000"
                    },
                    {
                        "id": 140921,
                        "name": "Onanì",
                        "latitude": "40.48536000",
                        "longitude": "9.44324000"
                    },
                    {
                        "id": 140924,
                        "name": "Onifai",
                        "latitude": "40.40694000",
                        "longitude": "9.65005000"
                    },
                    {
                        "id": 140925,
                        "name": "Oniferi",
                        "latitude": "40.27196000",
                        "longitude": "9.17033000"
                    },
                    {
                        "id": 140937,
                        "name": "Orani",
                        "latitude": "40.25200000",
                        "longitude": "9.18149000"
                    },
                    {
                        "id": 140950,
                        "name": "Orgosolo",
                        "latitude": "40.20530000",
                        "longitude": "9.35445000"
                    },
                    {
                        "id": 140960,
                        "name": "Oristano",
                        "latitude": "39.90360000",
                        "longitude": "8.59257000"
                    },
                    {
                        "id": 140966,
                        "name": "Orosei",
                        "latitude": "40.37826000",
                        "longitude": "9.69248000"
                    },
                    {
                        "id": 140967,
                        "name": "Orotelli",
                        "latitude": "40.30663000",
                        "longitude": "9.12150000"
                    },
                    {
                        "id": 140969,
                        "name": "Orroli",
                        "latitude": "39.69237000",
                        "longitude": "9.24995000"
                    },
                    {
                        "id": 140980,
                        "name": "Ortacesus",
                        "latitude": "39.53904000",
                        "longitude": "9.08695000"
                    },
                    {
                        "id": 140991,
                        "name": "Ortueri",
                        "latitude": "40.03545000",
                        "longitude": "8.98591000"
                    },
                    {
                        "id": 140992,
                        "name": "Orune",
                        "latitude": "40.40786000",
                        "longitude": "9.36963000"
                    },
                    {
                        "id": 141002,
                        "name": "Oschiri",
                        "latitude": "40.71977000",
                        "longitude": "9.10102000"
                    },
                    {
                        "id": 141003,
                        "name": "Osidda",
                        "latitude": "40.52368000",
                        "longitude": "9.22053000"
                    },
                    {
                        "id": 141006,
                        "name": "Osilo",
                        "latitude": "40.74349000",
                        "longitude": "8.67113000"
                    },
                    {
                        "id": 141008,
                        "name": "Osini",
                        "latitude": "39.82257000",
                        "longitude": "9.49640000"
                    },
                    {
                        "id": 141026,
                        "name": "Ossi",
                        "latitude": "40.67483000",
                        "longitude": "8.59254000"
                    },
                    {
                        "id": 141047,
                        "name": "Ottana",
                        "latitude": "40.23402000",
                        "longitude": "9.04459000"
                    },
                    {
                        "id": 141049,
                        "name": "Ottava",
                        "latitude": "40.78525000",
                        "longitude": "8.47543000"
                    },
                    {
                        "id": 141059,
                        "name": "Ovodda",
                        "latitude": "40.09525000",
                        "longitude": "9.16103000"
                    },
                    {
                        "id": 141062,
                        "name": "Ozieri",
                        "latitude": "40.58630000",
                        "longitude": "9.00340000"
                    },
                    {
                        "id": 141067,
                        "name": "Pabillonis",
                        "latitude": "39.59228000",
                        "longitude": "8.72143000"
                    },
                    {
                        "id": 141086,
                        "name": "Padria",
                        "latitude": "40.39635000",
                        "longitude": "8.62992000"
                    },
                    {
                        "id": 141087,
                        "name": "Padru",
                        "latitude": "40.76619000",
                        "longitude": "9.52100000"
                    },
                    {
                        "id": 58225,
                        "name": "Palau",
                        "latitude": "41.17936000",
                        "longitude": "9.38190000"
                    },
                    {
                        "id": 58257,
                        "name": "Palmas Arborea",
                        "latitude": "39.87670000",
                        "longitude": "8.64391000"
                    },
                    {
                        "id": 58349,
                        "name": "Pattada",
                        "latitude": "40.58067000",
                        "longitude": "9.11129000"
                    },
                    {
                        "id": 58352,
                        "name": "Pau",
                        "latitude": "39.79167000",
                        "longitude": "8.80222000"
                    },
                    {
                        "id": 58354,
                        "name": "Pauli Arbarei",
                        "latitude": "39.66183000",
                        "longitude": "8.92212000"
                    },
                    {
                        "id": 58355,
                        "name": "Paulilatino",
                        "latitude": "40.08470000",
                        "longitude": "8.76449000"
                    },
                    {
                        "id": 58416,
                        "name": "Perdasdefogu",
                        "latitude": "39.67959000",
                        "longitude": "9.44082000"
                    },
                    {
                        "id": 58417,
                        "name": "Perdaxius",
                        "latitude": "39.16028000",
                        "longitude": "8.61083000"
                    },
                    {
                        "id": 58421,
                        "name": "Perfugas",
                        "latitude": "40.83231000",
                        "longitude": "8.88354000"
                    },
                    {
                        "id": 58669,
                        "name": "Pimentel",
                        "latitude": "39.48718000",
                        "longitude": "9.06516000"
                    },
                    {
                        "id": 58705,
                        "name": "Piscinas",
                        "latitude": "39.07435000",
                        "longitude": "8.66634000"
                    },
                    {
                        "id": 58739,
                        "name": "Ploaghe",
                        "latitude": "40.67068000",
                        "longitude": "8.74962000"
                    },
                    {
                        "id": 58766,
                        "name": "Poggio dei Pini",
                        "latitude": "39.14717000",
                        "longitude": "8.97139000"
                    },
                    {
                        "id": 58821,
                        "name": "Pompu",
                        "latitude": "39.72518000",
                        "longitude": "8.79640000"
                    },
                    {
                        "id": 58925,
                        "name": "Porto Cervo",
                        "latitude": "41.14063000",
                        "longitude": "9.53267000"
                    },
                    {
                        "id": 58938,
                        "name": "Porto Torres",
                        "latitude": "40.83375000",
                        "longitude": "8.40531000"
                    },
                    {
                        "id": 58949,
                        "name": "Portoscuso",
                        "latitude": "39.20739000",
                        "longitude": "8.38086000"
                    },
                    {
                        "id": 58952,
                        "name": "Posada",
                        "latitude": "40.63203000",
                        "longitude": "9.71904000"
                    },
                    {
                        "id": 58987,
                        "name": "Pozzomaggiore",
                        "latitude": "40.39767000",
                        "longitude": "8.65931000"
                    },
                    {
                        "id": 59119,
                        "name": "Provincia di Cagliari",
                        "latitude": "39.24502000",
                        "longitude": "9.09119000"
                    },
                    {
                        "id": 59153,
                        "name": "Provincia di Nuoro",
                        "latitude": "40.21397000",
                        "longitude": "9.37095000"
                    },
                    {
                        "id": 59154,
                        "name": "Provincia di Oristano",
                        "latitude": "40.01682000",
                        "longitude": "8.73131000"
                    },
                    {
                        "id": 59173,
                        "name": "Provincia di Sassari",
                        "latitude": "40.77014000",
                        "longitude": "8.75885000"
                    },
                    {
                        "id": 59200,
                        "name": "Pula",
                        "latitude": "39.00727000",
                        "longitude": "9.00223000"
                    },
                    {
                        "id": 59208,
                        "name": "Putifigari",
                        "latitude": "40.56145000",
                        "longitude": "8.46063000"
                    },
                    {
                        "id": 59231,
                        "name": "Quartu Sant'Elena",
                        "latitude": "39.22935000",
                        "longitude": "9.25004000"
                    },
                    {
                        "id": 59232,
                        "name": "Quartucciu",
                        "latitude": "39.25262000",
                        "longitude": "9.17764000"
                    },
                    {
                        "id": 59392,
                        "name": "Riola Sardo",
                        "latitude": "39.99361000",
                        "longitude": "8.54127000"
                    },
                    {
                        "id": 59574,
                        "name": "Romana",
                        "latitude": "40.48439000",
                        "longitude": "8.58571000"
                    },
                    {
                        "id": 59700,
                        "name": "Ruinas",
                        "latitude": "39.90631000",
                        "longitude": "8.89705000"
                    },
                    {
                        "id": 59722,
                        "name": "Sadali",
                        "latitude": "39.81456000",
                        "longitude": "9.27246000"
                    },
                    {
                        "id": 59723,
                        "name": "Sagama",
                        "latitude": "40.26155000",
                        "longitude": "8.57752000"
                    },
                    {
                        "id": 59799,
                        "name": "Samassi",
                        "latitude": "39.48208000",
                        "longitude": "8.90538000"
                    },
                    {
                        "id": 59800,
                        "name": "Samatzai",
                        "latitude": "39.48297000",
                        "longitude": "9.03466000"
                    },
                    {
                        "id": 59816,
                        "name": "Samugheo",
                        "latitude": "39.94854000",
                        "longitude": "8.94152000"
                    },
                    {
                        "id": 59824,
                        "name": "San Basilio",
                        "latitude": "39.53785000",
                        "longitude": "9.19753000"
                    },
                    {
                        "id": 59930,
                        "name": "San Gavino Monreale",
                        "latitude": "39.55008000",
                        "longitude": "8.79065000"
                    },
                    {
                        "id": 59989,
                        "name": "San Giovanni Suergiu",
                        "latitude": "39.10955000",
                        "longitude": "8.52039000"
                    },
                    {
                        "id": 60135,
                        "name": "San Nicola",
                        "latitude": "40.61055000",
                        "longitude": "8.98841000"
                    },
                    {
                        "id": 60149,
                        "name": "San Nicolò d'Arcidano",
                        "latitude": "39.68417000",
                        "longitude": "8.64361000"
                    },
                    {
                        "id": 60143,
                        "name": "San Nicolo'Gerrei",
                        "latitude": "39.49833000",
                        "longitude": "9.30611000"
                    },
                    {
                        "id": 60249,
                        "name": "San Sperate",
                        "latitude": "39.35758000",
                        "longitude": "9.00814000"
                    },
                    {
                        "id": 60253,
                        "name": "San Teodoro",
                        "latitude": "40.77354000",
                        "longitude": "9.66929000"
                    },
                    {
                        "id": 60264,
                        "name": "San Vero Milis",
                        "latitude": "40.01377000",
                        "longitude": "8.59833000"
                    },
                    {
                        "id": 60272,
                        "name": "San Vito",
                        "latitude": "39.44142000",
                        "longitude": "9.54065000"
                    },
                    {
                        "id": 60308,
                        "name": "Sanluri",
                        "latitude": "39.56176000",
                        "longitude": "8.89969000"
                    },
                    {
                        "id": 60345,
                        "name": "Sant'Andrea Frius",
                        "latitude": "39.47917000",
                        "longitude": "9.17000000"
                    },
                    {
                        "id": 60374,
                        "name": "Sant'Anna Arresi",
                        "latitude": "39.00618000",
                        "longitude": "8.64236000"
                    },
                    {
                        "id": 60377,
                        "name": "Sant'Antioco",
                        "latitude": "39.07017000",
                        "longitude": "8.45243000"
                    },
                    {
                        "id": 60384,
                        "name": "Sant'Antonio di Gallura",
                        "latitude": "40.99146000",
                        "longitude": "9.30153000"
                    },
                    {
                        "id": 60439,
                        "name": "Santa Giusta",
                        "latitude": "39.88070000",
                        "longitude": "8.60916000"
                    },
                    {
                        "id": 60461,
                        "name": "Santa Maria Coghinas",
                        "latitude": "40.90423000",
                        "longitude": "8.86383000"
                    },
                    {
                        "id": 60467,
                        "name": "Santa Maria Navarrese",
                        "latitude": "39.99029000",
                        "longitude": "9.68398000"
                    },
                    {
                        "id": 60495,
                        "name": "Santa Teresa Gallura",
                        "latitude": "41.23859000",
                        "longitude": "9.18873000"
                    },
                    {
                        "id": 60501,
                        "name": "Santadi",
                        "latitude": "39.09356000",
                        "longitude": "8.71259000"
                    },
                    {
                        "id": 60531,
                        "name": "Santu Lussurgiu",
                        "latitude": "40.14110000",
                        "longitude": "8.65539000"
                    },
                    {
                        "id": 60543,
                        "name": "Sardara",
                        "latitude": "39.61465000",
                        "longitude": "8.82088000"
                    },
                    {
                        "id": 60557,
                        "name": "Sarroch",
                        "latitude": "39.06577000",
                        "longitude": "9.00937000"
                    },
                    {
                        "id": 60562,
                        "name": "Sarule",
                        "latitude": "40.22796000",
                        "longitude": "9.16644000"
                    },
                    {
                        "id": 60568,
                        "name": "Sassari",
                        "latitude": "40.72586000",
                        "longitude": "8.55552000"
                    },
                    {
                        "id": 60624,
                        "name": "Scano di Montiferro",
                        "latitude": "40.21525000",
                        "longitude": "8.58692000"
                    },
                    {
                        "id": 60682,
                        "name": "Sedilo",
                        "latitude": "40.17292000",
                        "longitude": "8.91993000"
                    },
                    {
                        "id": 60683,
                        "name": "Sedini",
                        "latitude": "40.85277000",
                        "longitude": "8.81670000"
                    },
                    {
                        "id": 60687,
                        "name": "Segariu",
                        "latitude": "39.56403000",
                        "longitude": "8.98163000"
                    },
                    {
                        "id": 60693,
                        "name": "Selargius",
                        "latitude": "39.25779000",
                        "longitude": "9.16323000"
                    },
                    {
                        "id": 60697,
                        "name": "Selegas",
                        "latitude": "39.56780000",
                        "longitude": "9.10348000"
                    },
                    {
                        "id": 60713,
                        "name": "Semestene",
                        "latitude": "40.39846000",
                        "longitude": "8.72542000"
                    },
                    {
                        "id": 60721,
                        "name": "Seneghe",
                        "latitude": "40.08128000",
                        "longitude": "8.61353000"
                    },
                    {
                        "id": 60725,
                        "name": "Senis",
                        "latitude": "39.82318000",
                        "longitude": "8.93916000"
                    },
                    {
                        "id": 60729,
                        "name": "Sennariolo",
                        "latitude": "40.21235000",
                        "longitude": "8.55572000"
                    },
                    {
                        "id": 60730,
                        "name": "Sennori",
                        "latitude": "40.78780000",
                        "longitude": "8.59285000"
                    },
                    {
                        "id": 60731,
                        "name": "Senorbì",
                        "latitude": "39.53341000",
                        "longitude": "9.13168000"
                    },
                    {
                        "id": 60736,
                        "name": "Serdiana",
                        "latitude": "39.37457000",
                        "longitude": "9.15851000"
                    },
                    {
                        "id": 60762,
                        "name": "Serramanna",
                        "latitude": "39.42335000",
                        "longitude": "8.92243000"
                    },
                    {
                        "id": 60781,
                        "name": "Serrenti",
                        "latitude": "39.49277000",
                        "longitude": "8.97659000"
                    },
                    {
                        "id": 60782,
                        "name": "Serri",
                        "latitude": "39.70150000",
                        "longitude": "9.14490000"
                    },
                    {
                        "id": 60805,
                        "name": "Sestu",
                        "latitude": "39.29846000",
                        "longitude": "9.09248000"
                    },
                    {
                        "id": 60814,
                        "name": "Settimo San Pietro",
                        "latitude": "39.29110000",
                        "longitude": "9.18570000"
                    },
                    {
                        "id": 60818,
                        "name": "Setzu",
                        "latitude": "39.72306000",
                        "longitude": "8.93972000"
                    },
                    {
                        "id": 60819,
                        "name": "Seui",
                        "latitude": "39.83908000",
                        "longitude": "9.32347000"
                    },
                    {
                        "id": 60820,
                        "name": "Seulo",
                        "latitude": "39.86955000",
                        "longitude": "9.23606000"
                    },
                    {
                        "id": 60833,
                        "name": "Siamaggiore",
                        "latitude": "39.94966000",
                        "longitude": "8.63461000"
                    },
                    {
                        "id": 60834,
                        "name": "Siamanna",
                        "latitude": "39.91936000",
                        "longitude": "8.76185000"
                    },
                    {
                        "id": 60837,
                        "name": "Siapiccia",
                        "latitude": "39.92765000",
                        "longitude": "8.76270000"
                    },
                    {
                        "id": 60841,
                        "name": "Siddi",
                        "latitude": "39.67255000",
                        "longitude": "8.88815000"
                    },
                    {
                        "id": 60848,
                        "name": "Silanus",
                        "latitude": "40.28709000",
                        "longitude": "8.89199000"
                    },
                    {
                        "id": 60858,
                        "name": "Silì",
                        "latitude": "39.91789000",
                        "longitude": "8.62194000"
                    },
                    {
                        "id": 60850,
                        "name": "Siligo",
                        "latitude": "40.57483000",
                        "longitude": "8.72835000"
                    },
                    {
                        "id": 60851,
                        "name": "Siliqua",
                        "latitude": "39.30100000",
                        "longitude": "8.80584000"
                    },
                    {
                        "id": 60852,
                        "name": "Silius",
                        "latitude": "39.51695000",
                        "longitude": "9.29360000"
                    },
                    {
                        "id": 60859,
                        "name": "Simala",
                        "latitude": "39.72099000",
                        "longitude": "8.82802000"
                    },
                    {
                        "id": 60860,
                        "name": "Simaxis",
                        "latitude": "39.92995000",
                        "longitude": "8.68979000"
                    },
                    {
                        "id": 60864,
                        "name": "Sindia",
                        "latitude": "40.29518000",
                        "longitude": "8.65707000"
                    },
                    {
                        "id": 60865,
                        "name": "Sini",
                        "latitude": "39.75353000",
                        "longitude": "8.90486000"
                    },
                    {
                        "id": 60868,
                        "name": "Siniscola",
                        "latitude": "40.57344000",
                        "longitude": "9.69695000"
                    },
                    {
                        "id": 60869,
                        "name": "Sinnai",
                        "latitude": "39.30286000",
                        "longitude": "9.20283000"
                    },
                    {
                        "id": 60873,
                        "name": "Siris",
                        "latitude": "39.71228000",
                        "longitude": "8.77507000"
                    },
                    {
                        "id": 60882,
                        "name": "Siurgus Donigala",
                        "latitude": "39.59961000",
                        "longitude": "9.18746000"
                    },
                    {
                        "id": 60895,
                        "name": "Soddì",
                        "latitude": "40.12991000",
                        "longitude": "8.87798000"
                    },
                    {
                        "id": 60901,
                        "name": "Solanas",
                        "latitude": "39.93031000",
                        "longitude": "8.55340000"
                    },
                    {
                        "id": 60908,
                        "name": "Solarussa",
                        "latitude": "39.95499000",
                        "longitude": "8.67393000"
                    },
                    {
                        "id": 60913,
                        "name": "Soleminis",
                        "latitude": "39.34760000",
                        "longitude": "9.18127000"
                    },
                    {
                        "id": 60955,
                        "name": "Sorgono",
                        "latitude": "40.02595000",
                        "longitude": "9.10203000"
                    },
                    {
                        "id": 60965,
                        "name": "Sorradile",
                        "latitude": "40.10634000",
                        "longitude": "8.93236000"
                    },
                    {
                        "id": 60967,
                        "name": "Sorso",
                        "latitude": "40.79949000",
                        "longitude": "8.57570000"
                    },
                    {
                        "id": 61077,
                        "name": "Stintino",
                        "latitude": "40.95201000",
                        "longitude": "8.21978000"
                    },
                    {
                        "id": 61106,
                        "name": "Su Planu",
                        "latitude": "39.25487000",
                        "longitude": "9.10660000"
                    },
                    {
                        "id": 61112,
                        "name": "Suelli",
                        "latitude": "39.56257000",
                        "longitude": "9.13245000"
                    },
                    {
                        "id": 61121,
                        "name": "Suni",
                        "latitude": "40.28085000",
                        "longitude": "8.54942000"
                    },
                    {
                        "id": 61139,
                        "name": "Tadasuni",
                        "latitude": "40.10995000",
                        "longitude": "8.88353000"
                    },
                    {
                        "id": 61153,
                        "name": "Talana",
                        "latitude": "40.04157000",
                        "longitude": "9.49554000"
                    },
                    {
                        "id": 61207,
                        "name": "Telti",
                        "latitude": "40.87575000",
                        "longitude": "9.35328000"
                    },
                    {
                        "id": 61210,
                        "name": "Tempio Pausania",
                        "latitude": "40.90068000",
                        "longitude": "9.10456000"
                    },
                    {
                        "id": 61222,
                        "name": "Tergu",
                        "latitude": "40.86652000",
                        "longitude": "8.71467000"
                    },
                    {
                        "id": 61238,
                        "name": "Terralba",
                        "latitude": "39.72056000",
                        "longitude": "8.63504000"
                    },
                    {
                        "id": 61254,
                        "name": "Tertenia",
                        "latitude": "39.69518000",
                        "longitude": "9.57878000"
                    },
                    {
                        "id": 61265,
                        "name": "Teti",
                        "latitude": "40.09737000",
                        "longitude": "9.11923000"
                    },
                    {
                        "id": 61268,
                        "name": "Teulada",
                        "latitude": "38.96658000",
                        "longitude": "8.77149000"
                    },
                    {
                        "id": 61272,
                        "name": "Thiesi",
                        "latitude": "40.52398000",
                        "longitude": "8.72001000"
                    },
                    {
                        "id": 61273,
                        "name": "Tiana",
                        "latitude": "40.06746000",
                        "longitude": "9.14817000"
                    },
                    {
                        "id": 61279,
                        "name": "Tinnura",
                        "latitude": "40.26916000",
                        "longitude": "8.54815000"
                    },
                    {
                        "id": 61286,
                        "name": "Tissi",
                        "latitude": "40.67832000",
                        "longitude": "8.56127000"
                    },
                    {
                        "id": 61307,
                        "name": "Tonara",
                        "latitude": "40.02465000",
                        "longitude": "9.17204000"
                    },
                    {
                        "id": 61340,
                        "name": "Torpè",
                        "latitude": "40.62780000",
                        "longitude": "9.67916000"
                    },
                    {
                        "id": 61342,
                        "name": "Torralba",
                        "latitude": "40.51296000",
                        "longitude": "8.76532000"
                    },
                    {
                        "id": 61411,
                        "name": "Tortolì",
                        "latitude": "39.92626000",
                        "longitude": "9.65569000"
                    },
                    {
                        "id": 61430,
                        "name": "Tramatza",
                        "latitude": "40.00292000",
                        "longitude": "8.64944000"
                    },
                    {
                        "id": 61447,
                        "name": "Tratalias",
                        "latitude": "39.10347000",
                        "longitude": "8.57858000"
                    },
                    {
                        "id": 61498,
                        "name": "Tresnuraghes",
                        "latitude": "40.25235000",
                        "longitude": "8.52092000"
                    },
                    {
                        "id": 61523,
                        "name": "Triei",
                        "latitude": "40.03498000",
                        "longitude": "9.63995000"
                    },
                    {
                        "id": 61530,
                        "name": "Trinità d'Agultu",
                        "latitude": "40.98589000",
                        "longitude": "8.91377000"
                    },
                    {
                        "id": 61531,
                        "name": "Trinità d'Agultu e Vignola",
                        "latitude": "40.98377000",
                        "longitude": "8.91562000"
                    },
                    {
                        "id": 61567,
                        "name": "Tuili",
                        "latitude": "39.71477000",
                        "longitude": "8.96020000"
                    },
                    {
                        "id": 61568,
                        "name": "Tula",
                        "latitude": "40.73246000",
                        "longitude": "8.98392000"
                    },
                    {
                        "id": 61576,
                        "name": "Turri",
                        "latitude": "39.70476000",
                        "longitude": "8.91656000"
                    },
                    {
                        "id": 61596,
                        "name": "Ulà Tirso",
                        "latitude": "40.04570000",
                        "longitude": "8.90326000"
                    },
                    {
                        "id": 61593,
                        "name": "Ulassai",
                        "latitude": "39.81033000",
                        "longitude": "9.49962000"
                    },
                    {
                        "id": 61600,
                        "name": "Uras",
                        "latitude": "39.69799000",
                        "longitude": "8.70143000"
                    },
                    {
                        "id": 61607,
                        "name": "Uri",
                        "latitude": "40.63841000",
                        "longitude": "8.48881000"
                    },
                    {
                        "id": 61609,
                        "name": "Urzulei",
                        "latitude": "40.09284000",
                        "longitude": "9.50800000"
                    },
                    {
                        "id": 61611,
                        "name": "Usellus",
                        "latitude": "39.80833000",
                        "longitude": "8.85167000"
                    },
                    {
                        "id": 61612,
                        "name": "Usini",
                        "latitude": "40.66416000",
                        "longitude": "8.53919000"
                    },
                    {
                        "id": 61614,
                        "name": "Ussana",
                        "latitude": "39.39374000",
                        "longitude": "9.07496000"
                    },
                    {
                        "id": 61615,
                        "name": "Ussaramanna",
                        "latitude": "39.69250000",
                        "longitude": "8.90850000"
                    },
                    {
                        "id": 61616,
                        "name": "Ussassai",
                        "latitude": "39.80998000",
                        "longitude": "9.39508000"
                    },
                    {
                        "id": 61620,
                        "name": "Uta",
                        "latitude": "39.29186000",
                        "longitude": "8.95234000"
                    },
                    {
                        "id": 61706,
                        "name": "Valledoria",
                        "latitude": "40.92867000",
                        "longitude": "8.82321000"
                    },
                    {
                        "id": 61714,
                        "name": "Vallermosa",
                        "latitude": "39.36389000",
                        "longitude": "8.79556000"
                    },
                    {
                        "id": 61929,
                        "name": "Viddalba",
                        "latitude": "40.91259000",
                        "longitude": "8.89009000"
                    },
                    {
                        "id": 62020,
                        "name": "Villa San Pietro",
                        "latitude": "39.03554000",
                        "longitude": "8.99695000"
                    },
                    {
                        "id": 62023,
                        "name": "Villa Sant'Antonio",
                        "latitude": "39.85915000",
                        "longitude": "8.90153000"
                    },
                    {
                        "id": 62029,
                        "name": "Villa Verde",
                        "latitude": "39.79551000",
                        "longitude": "8.82114000"
                    },
                    {
                        "id": 62050,
                        "name": "Villacidro",
                        "latitude": "39.45734000",
                        "longitude": "8.74105000"
                    },
                    {
                        "id": 62072,
                        "name": "Villagrande Strisaili",
                        "latitude": "39.95929000",
                        "longitude": "9.50943000"
                    },
                    {
                        "id": 62082,
                        "name": "Villamar",
                        "latitude": "39.61884000",
                        "longitude": "8.95877000"
                    },
                    {
                        "id": 62084,
                        "name": "Villamassargia",
                        "latitude": "39.27484000",
                        "longitude": "8.64110000"
                    },
                    {
                        "id": 62101,
                        "name": "Villanova Monteleone",
                        "latitude": "40.50264000",
                        "longitude": "8.47115000"
                    },
                    {
                        "id": 62103,
                        "name": "Villanova Truschedu",
                        "latitude": "39.98842000",
                        "longitude": "8.75177000"
                    },
                    {
                        "id": 62104,
                        "name": "Villanova Tulo",
                        "latitude": "39.77995000",
                        "longitude": "9.21424000"
                    },
                    {
                        "id": 62111,
                        "name": "Villanovaforru",
                        "latitude": "39.63196000",
                        "longitude": "8.86979000"
                    },
                    {
                        "id": 62112,
                        "name": "Villanovafranca",
                        "latitude": "39.64442000",
                        "longitude": "9.00244000"
                    },
                    {
                        "id": 62116,
                        "name": "Villaperuccio",
                        "latitude": "39.11183000",
                        "longitude": "8.67004000"
                    },
                    {
                        "id": 62120,
                        "name": "Villaputzu",
                        "latitude": "39.44058000",
                        "longitude": "9.57564000"
                    },
                    {
                        "id": 62133,
                        "name": "Villasalto",
                        "latitude": "39.49209000",
                        "longitude": "9.39023000"
                    },
                    {
                        "id": 62136,
                        "name": "Villasimius",
                        "latitude": "39.14481000",
                        "longitude": "9.51823000"
                    },
                    {
                        "id": 62138,
                        "name": "Villasor",
                        "latitude": "39.38130000",
                        "longitude": "8.94270000"
                    },
                    {
                        "id": 62139,
                        "name": "Villaspeciosa",
                        "latitude": "39.31142000",
                        "longitude": "8.92584000"
                    },
                    {
                        "id": 62144,
                        "name": "Villaurbana",
                        "latitude": "39.88505000",
                        "longitude": "8.77831000"
                    },
                    {
                        "id": 62240,
                        "name": "Zeddiani",
                        "latitude": "39.98898000",
                        "longitude": "8.59580000"
                    },
                    {
                        "id": 62252,
                        "name": "Zerfaliu",
                        "latitude": "39.96088000",
                        "longitude": "8.70971000"
                    }
                ]
            },
            {
                "id": 1722,
                "name": "Sassari",
                "iso2": "SS",
                "latitude": "40.79679070",
                "longitude": "8.57504070",
                "type": "province",
                "cities": []
            },
            {
                "id": 1732,
                "name": "Savona",
                "iso2": "SV",
                "latitude": "44.28879950",
                "longitude": "8.26505800",
                "type": "province",
                "cities": []
            },
            {
                "id": 1709,
                "name": "Sicily",
                "iso2": "82",
                "latitude": "37.59999380",
                "longitude": "14.01535570",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 135246,
                        "name": "Acate",
                        "latitude": "37.02318000",
                        "longitude": "14.49302000"
                    },
                    {
                        "id": 135256,
                        "name": "Aci Bonaccorsi",
                        "latitude": "37.59640000",
                        "longitude": "15.10724000"
                    },
                    {
                        "id": 135257,
                        "name": "Aci Castello",
                        "latitude": "37.55564000",
                        "longitude": "15.14535000"
                    },
                    {
                        "id": 135258,
                        "name": "Aci Catena",
                        "latitude": "37.60614000",
                        "longitude": "15.14165000"
                    },
                    {
                        "id": 135259,
                        "name": "Aci Sant'Antonio",
                        "latitude": "37.60499000",
                        "longitude": "15.12294000"
                    },
                    {
                        "id": 135260,
                        "name": "Aci Trezza",
                        "latitude": "37.56385000",
                        "longitude": "15.16136000"
                    },
                    {
                        "id": 135262,
                        "name": "Acireale",
                        "latitude": "37.60886000",
                        "longitude": "15.16577000"
                    },
                    {
                        "id": 135263,
                        "name": "Acitrezza",
                        "latitude": "37.55960000",
                        "longitude": "15.15990000"
                    },
                    {
                        "id": 135279,
                        "name": "Acquaviva Platani",
                        "latitude": "37.57174000",
                        "longitude": "13.70156000"
                    },
                    {
                        "id": 135282,
                        "name": "Acquedolci",
                        "latitude": "38.05708000",
                        "longitude": "14.58550000"
                    },
                    {
                        "id": 135287,
                        "name": "Adrano",
                        "latitude": "37.66358000",
                        "longitude": "14.83283000"
                    },
                    {
                        "id": 135300,
                        "name": "Agira",
                        "latitude": "37.65580000",
                        "longitude": "14.51972000"
                    },
                    {
                        "id": 135302,
                        "name": "Agliandroni-Paternella",
                        "latitude": "38.13280000",
                        "longitude": "13.06884000"
                    },
                    {
                        "id": 135318,
                        "name": "Agrigento",
                        "latitude": "37.45000000",
                        "longitude": "13.50000000"
                    },
                    {
                        "id": 135324,
                        "name": "Aidone",
                        "latitude": "37.41468000",
                        "longitude": "14.44542000"
                    },
                    {
                        "id": 135389,
                        "name": "Alcamo",
                        "latitude": "37.97790000",
                        "longitude": "12.96473000"
                    },
                    {
                        "id": 135390,
                        "name": "Alcara Li Fusi",
                        "latitude": "38.02143000",
                        "longitude": "14.70142000"
                    },
                    {
                        "id": 135396,
                        "name": "Alessandria della Rocca",
                        "latitude": "37.56767000",
                        "longitude": "13.45343000"
                    },
                    {
                        "id": 135454,
                        "name": "Alì",
                        "latitude": "38.02678000",
                        "longitude": "15.41910000"
                    },
                    {
                        "id": 135455,
                        "name": "Alì Terme",
                        "latitude": "38.00506000",
                        "longitude": "15.42269000"
                    },
                    {
                        "id": 135406,
                        "name": "Alia",
                        "latitude": "37.77867000",
                        "longitude": "13.71391000"
                    },
                    {
                        "id": 135412,
                        "name": "Alimena",
                        "latitude": "37.69310000",
                        "longitude": "14.11369000"
                    },
                    {
                        "id": 135413,
                        "name": "Aliminusa",
                        "latitude": "37.86395000",
                        "longitude": "13.78126000"
                    },
                    {
                        "id": 135433,
                        "name": "Altavilla Milicia",
                        "latitude": "38.03800000",
                        "longitude": "13.54947000"
                    },
                    {
                        "id": 135444,
                        "name": "Altofonte",
                        "latitude": "38.04298000",
                        "longitude": "13.29434000"
                    },
                    {
                        "id": 135519,
                        "name": "Antillo",
                        "latitude": "37.97937000",
                        "longitude": "15.24029000"
                    },
                    {
                        "id": 135550,
                        "name": "Aragona",
                        "latitude": "37.39904000",
                        "longitude": "13.61974000"
                    },
                    {
                        "id": 135669,
                        "name": "Assoro",
                        "latitude": "37.62210000",
                        "longitude": "14.41810000"
                    },
                    {
                        "id": 135685,
                        "name": "Augusta",
                        "latitude": "37.24065000",
                        "longitude": "15.22121000"
                    },
                    {
                        "id": 135713,
                        "name": "Avola",
                        "latitude": "36.90840000",
                        "longitude": "15.13937000"
                    },
                    {
                        "id": 135747,
                        "name": "Bagheria",
                        "latitude": "38.07892000",
                        "longitude": "13.51237000"
                    },
                    {
                        "id": 135787,
                        "name": "Balestrate",
                        "latitude": "38.05125000",
                        "longitude": "13.00724000"
                    },
                    {
                        "id": 135834,
                        "name": "Barcellona Pozzo di Gotto",
                        "latitude": "38.14772000",
                        "longitude": "15.21469000"
                    },
                    {
                        "id": 135868,
                        "name": "Barrafranca",
                        "latitude": "37.37850000",
                        "longitude": "14.20270000"
                    },
                    {
                        "id": 135885,
                        "name": "Basicò",
                        "latitude": "38.06077000",
                        "longitude": "15.06263000"
                    },
                    {
                        "id": 135911,
                        "name": "Baucina",
                        "latitude": "37.92521000",
                        "longitude": "13.53636000"
                    },
                    {
                        "id": 135953,
                        "name": "Belmonte Mezzagno",
                        "latitude": "38.04653000",
                        "longitude": "13.39207000"
                    },
                    {
                        "id": 135957,
                        "name": "Belpasso",
                        "latitude": "37.59192000",
                        "longitude": "14.97985000"
                    },
                    {
                        "id": 135960,
                        "name": "Belvedere",
                        "latitude": "37.08839000",
                        "longitude": "15.21314000"
                    },
                    {
                        "id": 135966,
                        "name": "Belvedere-Piano Tavola",
                        "latitude": "37.52955000",
                        "longitude": "14.98786000"
                    },
                    {
                        "id": 136028,
                        "name": "Biancavilla",
                        "latitude": "37.64442000",
                        "longitude": "14.86685000"
                    },
                    {
                        "id": 136060,
                        "name": "Bisacquino",
                        "latitude": "37.70352000",
                        "longitude": "13.26051000"
                    },
                    {
                        "id": 136075,
                        "name": "Bivona",
                        "latitude": "37.61797000",
                        "longitude": "13.43895000"
                    },
                    {
                        "id": 136083,
                        "name": "Blufi",
                        "latitude": "37.75205000",
                        "longitude": "14.07296000"
                    },
                    {
                        "id": 136110,
                        "name": "Bolognetta",
                        "latitude": "37.97120000",
                        "longitude": "13.45627000"
                    },
                    {
                        "id": 136120,
                        "name": "Bompensiere",
                        "latitude": "37.47240000",
                        "longitude": "13.78140000"
                    },
                    {
                        "id": 136121,
                        "name": "Bompietro",
                        "latitude": "37.74394000",
                        "longitude": "14.09470000"
                    },
                    {
                        "id": 136157,
                        "name": "Borgetto",
                        "latitude": "38.04664000",
                        "longitude": "13.14071000"
                    },
                    {
                        "id": 136349,
                        "name": "Brolo",
                        "latitude": "38.15623000",
                        "longitude": "14.82799000"
                    },
                    {
                        "id": 136353,
                        "name": "Bronte",
                        "latitude": "37.78863000",
                        "longitude": "14.83377000"
                    },
                    {
                        "id": 136361,
                        "name": "Brucoli",
                        "latitude": "37.28191000",
                        "longitude": "15.18836000"
                    },
                    {
                        "id": 136384,
                        "name": "Buccheri",
                        "latitude": "37.12494000",
                        "longitude": "14.85222000"
                    },
                    {
                        "id": 136412,
                        "name": "Burgio",
                        "latitude": "37.60094000",
                        "longitude": "13.28826000"
                    },
                    {
                        "id": 136423,
                        "name": "Buscemi",
                        "latitude": "37.08604000",
                        "longitude": "14.88499000"
                    },
                    {
                        "id": 136425,
                        "name": "Buseto Palizzolo",
                        "latitude": "38.00339000",
                        "longitude": "12.70911000"
                    },
                    {
                        "id": 136436,
                        "name": "Butera",
                        "latitude": "37.19100000",
                        "longitude": "14.18232000"
                    },
                    {
                        "id": 136451,
                        "name": "Caccamo",
                        "latitude": "37.93357000",
                        "longitude": "13.66808000"
                    },
                    {
                        "id": 136489,
                        "name": "Calamonaci",
                        "latitude": "37.52566000",
                        "longitude": "13.29053000"
                    },
                    {
                        "id": 136493,
                        "name": "Calascibetta",
                        "latitude": "37.59024000",
                        "longitude": "14.27180000"
                    },
                    {
                        "id": 136496,
                        "name": "Calatabiano",
                        "latitude": "37.82049000",
                        "longitude": "15.23069000"
                    },
                    {
                        "id": 136497,
                        "name": "Calatafimi",
                        "latitude": "37.91440000",
                        "longitude": "12.86364000"
                    },
                    {
                        "id": 136540,
                        "name": "Caltabellotta",
                        "latitude": "37.57543000",
                        "longitude": "13.21632000"
                    },
                    {
                        "id": 136541,
                        "name": "Caltagirone",
                        "latitude": "37.23785000",
                        "longitude": "14.51551000"
                    },
                    {
                        "id": 136543,
                        "name": "Caltanissetta",
                        "latitude": "37.49025000",
                        "longitude": "14.06216000"
                    },
                    {
                        "id": 136544,
                        "name": "Caltavuturo",
                        "latitude": "37.82040000",
                        "longitude": "13.89158000"
                    },
                    {
                        "id": 136571,
                        "name": "Camastra",
                        "latitude": "37.25380000",
                        "longitude": "13.79211000"
                    },
                    {
                        "id": 136594,
                        "name": "Cammarata",
                        "latitude": "37.63361000",
                        "longitude": "13.62722000"
                    },
                    {
                        "id": 136609,
                        "name": "Campanella-Gianforma",
                        "latitude": "36.92630000",
                        "longitude": "14.83360000"
                    },
                    {
                        "id": 136639,
                        "name": "Campobello di Licata",
                        "latitude": "37.25759000",
                        "longitude": "13.91811000"
                    },
                    {
                        "id": 136640,
                        "name": "Campobello di Mazara",
                        "latitude": "37.63464000",
                        "longitude": "12.74946000"
                    },
                    {
                        "id": 136650,
                        "name": "Campofelice di Fitalia",
                        "latitude": "37.82686000",
                        "longitude": "13.48572000"
                    },
                    {
                        "id": 136651,
                        "name": "Campofelice di Roccella",
                        "latitude": "37.99270000",
                        "longitude": "13.87648000"
                    },
                    {
                        "id": 136654,
                        "name": "Campofiorito",
                        "latitude": "37.75374000",
                        "longitude": "13.26875000"
                    },
                    {
                        "id": 136656,
                        "name": "Campofranco",
                        "latitude": "37.51208000",
                        "longitude": "13.71213000"
                    },
                    {
                        "id": 136674,
                        "name": "Camporeale",
                        "latitude": "37.88612000",
                        "longitude": "13.10107000"
                    },
                    {
                        "id": 136677,
                        "name": "Camporotondo Etneo",
                        "latitude": "37.56565000",
                        "longitude": "15.00319000"
                    },
                    {
                        "id": 136690,
                        "name": "Canalicchio",
                        "latitude": "37.54097000",
                        "longitude": "15.09645000"
                    },
                    {
                        "id": 136712,
                        "name": "Canicattì",
                        "latitude": "37.35842000",
                        "longitude": "13.84786000"
                    },
                    {
                        "id": 136711,
                        "name": "Canicattini Bagni",
                        "latitude": "37.03171000",
                        "longitude": "15.06388000"
                    },
                    {
                        "id": 136721,
                        "name": "Canneto",
                        "latitude": "38.49505000",
                        "longitude": "14.96037000"
                    },
                    {
                        "id": 136725,
                        "name": "Cannizzaro-Favara",
                        "latitude": "38.06163000",
                        "longitude": "13.27167000"
                    },
                    {
                        "id": 136758,
                        "name": "Capaci",
                        "latitude": "38.17107000",
                        "longitude": "13.23930000"
                    },
                    {
                        "id": 136776,
                        "name": "Capizzi",
                        "latitude": "37.84788000",
                        "longitude": "14.47976000"
                    },
                    {
                        "id": 136778,
                        "name": "Capo d'Orlando",
                        "latitude": "38.14262000",
                        "longitude": "14.73292000"
                    },
                    {
                        "id": 136810,
                        "name": "Capri Leone",
                        "latitude": "38.08682000",
                        "longitude": "14.72959000"
                    },
                    {
                        "id": 136880,
                        "name": "Carini",
                        "latitude": "38.13240000",
                        "longitude": "13.18274000"
                    },
                    {
                        "id": 136886,
                        "name": "Carlentini",
                        "latitude": "37.28071000",
                        "longitude": "15.01020000"
                    },
                    {
                        "id": 136900,
                        "name": "Caronia",
                        "latitude": "38.02381000",
                        "longitude": "14.44142000"
                    },
                    {
                        "id": 136931,
                        "name": "Carrozziere",
                        "latitude": "37.03760000",
                        "longitude": "15.27195000"
                    },
                    {
                        "id": 136932,
                        "name": "Carruba",
                        "latitude": "37.69062000",
                        "longitude": "15.18815000"
                    },
                    {
                        "id": 136933,
                        "name": "Carrubazza-Motta",
                        "latitude": "37.55323000",
                        "longitude": "15.10819000"
                    },
                    {
                        "id": 136950,
                        "name": "Casa Santa",
                        "latitude": "38.02514000",
                        "longitude": "12.54840000"
                    },
                    {
                        "id": 137010,
                        "name": "Casalvecchio Siculo",
                        "latitude": "37.95850000",
                        "longitude": "15.32371000"
                    },
                    {
                        "id": 137102,
                        "name": "Cassaro",
                        "latitude": "37.10571000",
                        "longitude": "14.94697000"
                    },
                    {
                        "id": 137103,
                        "name": "Cassibile",
                        "latitude": "36.97862000",
                        "longitude": "15.20061000"
                    },
                    {
                        "id": 137125,
                        "name": "Castanea delle Furie",
                        "latitude": "38.26165000",
                        "longitude": "15.52178000"
                    },
                    {
                        "id": 137170,
                        "name": "Castel di Judica",
                        "latitude": "37.49475000",
                        "longitude": "14.64744000"
                    },
                    {
                        "id": 137172,
                        "name": "Castel di Lucio",
                        "latitude": "37.88698000",
                        "longitude": "14.31116000"
                    },
                    {
                        "id": 137183,
                        "name": "Castelbuono",
                        "latitude": "37.92530000",
                        "longitude": "14.08665000"
                    },
                    {
                        "id": 137188,
                        "name": "Casteldaccia",
                        "latitude": "38.05121000",
                        "longitude": "13.53041000"
                    },
                    {
                        "id": 137209,
                        "name": "Castell'Umberto",
                        "latitude": "38.08626000",
                        "longitude": "14.80686000"
                    },
                    {
                        "id": 137212,
                        "name": "Castellammare del Golfo",
                        "latitude": "38.02653000",
                        "longitude": "12.88183000"
                    },
                    {
                        "id": 137216,
                        "name": "Castellana Sicula",
                        "latitude": "37.78686000",
                        "longitude": "14.03906000"
                    },
                    {
                        "id": 137268,
                        "name": "Castelluzzo",
                        "latitude": "38.10096000",
                        "longitude": "12.73599000"
                    },
                    {
                        "id": 137275,
                        "name": "Castelmola",
                        "latitude": "37.85829000",
                        "longitude": "15.27713000"
                    },
                    {
                        "id": 137318,
                        "name": "Casteltermini",
                        "latitude": "37.53874000",
                        "longitude": "13.64601000"
                    },
                    {
                        "id": 137329,
                        "name": "Castelvetrano",
                        "latitude": "37.68081000",
                        "longitude": "12.79194000"
                    },
                    {
                        "id": 137357,
                        "name": "Castiglione di Sicilia",
                        "latitude": "37.88150000",
                        "longitude": "15.12156000"
                    },
                    {
                        "id": 137380,
                        "name": "Castrofilippo",
                        "latitude": "37.35046000",
                        "longitude": "13.75001000"
                    },
                    {
                        "id": 137385,
                        "name": "Castronuovo di Sicilia",
                        "latitude": "37.67894000",
                        "longitude": "13.60346000"
                    },
                    {
                        "id": 137387,
                        "name": "Castroreale",
                        "latitude": "38.09857000",
                        "longitude": "15.21012000"
                    },
                    {
                        "id": 137391,
                        "name": "Catania",
                        "latitude": "37.47169000",
                        "longitude": "14.84731000"
                    },
                    {
                        "id": 137394,
                        "name": "Catenanuova",
                        "latitude": "37.56876000",
                        "longitude": "14.69076000"
                    },
                    {
                        "id": 137397,
                        "name": "Cattolica Eraclea",
                        "latitude": "37.44069000",
                        "longitude": "13.39265000"
                    },
                    {
                        "id": 137403,
                        "name": "Cava d'Aliga",
                        "latitude": "36.72964000",
                        "longitude": "14.69031000"
                    },
                    {
                        "id": 137458,
                        "name": "Cefalà Diana",
                        "latitude": "37.91565000",
                        "longitude": "13.46325000"
                    },
                    {
                        "id": 137459,
                        "name": "Cefalù",
                        "latitude": "38.03856000",
                        "longitude": "14.02285000"
                    },
                    {
                        "id": 137504,
                        "name": "Centuripe",
                        "latitude": "37.62336000",
                        "longitude": "14.74049000"
                    },
                    {
                        "id": 137511,
                        "name": "Cerami",
                        "latitude": "37.80953000",
                        "longitude": "14.50660000"
                    },
                    {
                        "id": 137529,
                        "name": "Cerda",
                        "latitude": "37.90578000",
                        "longitude": "13.81496000"
                    },
                    {
                        "id": 137598,
                        "name": "Cerza",
                        "latitude": "37.54297000",
                        "longitude": "15.10510000"
                    },
                    {
                        "id": 137609,
                        "name": "Cesarò",
                        "latitude": "37.84476000",
                        "longitude": "14.71308000"
                    },
                    {
                        "id": 137643,
                        "name": "Chianchitta-Pallio",
                        "latitude": "37.82108000",
                        "longitude": "15.25317000"
                    },
                    {
                        "id": 137644,
                        "name": "Chianchitta-Trappitello",
                        "latitude": "37.82984000",
                        "longitude": "15.25077000"
                    },
                    {
                        "id": 137648,
                        "name": "Chiaramonte Gulfi",
                        "latitude": "37.03050000",
                        "longitude": "14.70302000"
                    },
                    {
                        "id": 137687,
                        "name": "Chiusa Sclafani",
                        "latitude": "37.67692000",
                        "longitude": "13.27074000"
                    },
                    {
                        "id": 137700,
                        "name": "Ciaculli",
                        "latitude": "38.07530000",
                        "longitude": "13.40719000"
                    },
                    {
                        "id": 137702,
                        "name": "Cianciana",
                        "latitude": "37.51896000",
                        "longitude": "13.43349000"
                    },
                    {
                        "id": 137705,
                        "name": "Ciavolo",
                        "latitude": "37.77943000",
                        "longitude": "12.53774000"
                    },
                    {
                        "id": 137724,
                        "name": "Ciminna",
                        "latitude": "37.89765000",
                        "longitude": "13.55966000"
                    },
                    {
                        "id": 137735,
                        "name": "Cinisi",
                        "latitude": "38.16082000",
                        "longitude": "13.10099000"
                    },
                    {
                        "id": 137771,
                        "name": "Città Giardino",
                        "latitude": "37.10444000",
                        "longitude": "15.21172000"
                    },
                    {
                        "id": 137894,
                        "name": "Collesano",
                        "latitude": "37.91809000",
                        "longitude": "13.93702000"
                    },
                    {
                        "id": 137942,
                        "name": "Comiso",
                        "latitude": "36.94893000",
                        "longitude": "14.60731000"
                    },
                    {
                        "id": 137943,
                        "name": "Comitini",
                        "latitude": "37.40735000",
                        "longitude": "13.64530000"
                    },
                    {
                        "id": 137965,
                        "name": "Condrò",
                        "latitude": "38.17375000",
                        "longitude": "15.32660000"
                    },
                    {
                        "id": 137977,
                        "name": "Contessa Entellina",
                        "latitude": "37.73005000",
                        "longitude": "13.18425000"
                    },
                    {
                        "id": 138017,
                        "name": "Corleone",
                        "latitude": "37.81338000",
                        "longitude": "13.30170000"
                    },
                    {
                        "id": 138216,
                        "name": "Custonaci",
                        "latitude": "38.07931000",
                        "longitude": "12.68571000"
                    },
                    {
                        "id": 138242,
                        "name": "Delia",
                        "latitude": "37.35796000",
                        "longitude": "13.92867000"
                    },
                    {
                        "id": 138300,
                        "name": "Donnalucata",
                        "latitude": "36.76117000",
                        "longitude": "14.64022000"
                    },
                    {
                        "id": 138360,
                        "name": "Enna",
                        "latitude": "37.58333000",
                        "longitude": "14.43333000"
                    },
                    {
                        "id": 138374,
                        "name": "Erice",
                        "latitude": "38.03785000",
                        "longitude": "12.58778000"
                    },
                    {
                        "id": 138389,
                        "name": "Evangelisti-Rubino",
                        "latitude": "37.98412000",
                        "longitude": "15.17324000"
                    },
                    {
                        "id": 138417,
                        "name": "Falcone",
                        "latitude": "38.11698000",
                        "longitude": "15.07965000"
                    },
                    {
                        "id": 138450,
                        "name": "Faro Superiore",
                        "latitude": "38.26794000",
                        "longitude": "15.58268000"
                    },
                    {
                        "id": 138459,
                        "name": "Favara",
                        "latitude": "37.31754000",
                        "longitude": "13.66226000"
                    },
                    {
                        "id": 138462,
                        "name": "Favignana",
                        "latitude": "37.92951000",
                        "longitude": "12.32958000"
                    },
                    {
                        "id": 138481,
                        "name": "Ferla",
                        "latitude": "37.11978000",
                        "longitude": "14.93881000"
                    },
                    {
                        "id": 138503,
                        "name": "Ficarazzi",
                        "latitude": "38.09229000",
                        "longitude": "13.46390000"
                    },
                    {
                        "id": 138505,
                        "name": "Ficarra",
                        "latitude": "38.10849000",
                        "longitude": "14.82990000"
                    },
                    {
                        "id": 138534,
                        "name": "Finale",
                        "latitude": "38.01891000",
                        "longitude": "14.16151000"
                    },
                    {
                        "id": 138551,
                        "name": "Fiumedinisi",
                        "latitude": "38.02596000",
                        "longitude": "15.38099000"
                    },
                    {
                        "id": 138553,
                        "name": "Fiumefreddo Sicilia",
                        "latitude": "37.79146000",
                        "longitude": "15.20919000"
                    },
                    {
                        "id": 138564,
                        "name": "Floresta",
                        "latitude": "37.98779000",
                        "longitude": "14.91096000"
                    },
                    {
                        "id": 138565,
                        "name": "Floridia",
                        "latitude": "37.08343000",
                        "longitude": "15.15332000"
                    },
                    {
                        "id": 138587,
                        "name": "Fondachelli-Fantina",
                        "latitude": "37.98476000",
                        "longitude": "15.17519000"
                    },
                    {
                        "id": 138664,
                        "name": "Forza d'Agrò",
                        "latitude": "37.91539000",
                        "longitude": "15.33409000"
                    },
                    {
                        "id": 138698,
                        "name": "Francavilla di Sicilia",
                        "latitude": "37.90197000",
                        "longitude": "15.13821000"
                    },
                    {
                        "id": 138703,
                        "name": "Francofonte",
                        "latitude": "37.22477000",
                        "longitude": "14.87488000"
                    },
                    {
                        "id": 138727,
                        "name": "Frazzanò",
                        "latitude": "38.07202000",
                        "longitude": "14.74407000"
                    },
                    {
                        "id": 138748,
                        "name": "Fulgatore-Torretta",
                        "latitude": "37.94977000",
                        "longitude": "12.69303000"
                    },
                    {
                        "id": 138756,
                        "name": "Furci Siculo",
                        "latitude": "37.96159000",
                        "longitude": "15.37763000"
                    },
                    {
                        "id": 138757,
                        "name": "Furnari",
                        "latitude": "38.10436000",
                        "longitude": "15.12358000"
                    },
                    {
                        "id": 138775,
                        "name": "Gaggi",
                        "latitude": "37.85995000",
                        "longitude": "15.22126000"
                    },
                    {
                        "id": 138782,
                        "name": "Gagliano Castelferrato",
                        "latitude": "37.70967000",
                        "longitude": "14.53524000"
                    },
                    {
                        "id": 138794,
                        "name": "Galati Mamertino",
                        "latitude": "38.03176000",
                        "longitude": "14.77145000"
                    },
                    {
                        "id": 138819,
                        "name": "Gallodoro",
                        "latitude": "37.90206000",
                        "longitude": "15.29359000"
                    },
                    {
                        "id": 138840,
                        "name": "Gangi",
                        "latitude": "37.79565000",
                        "longitude": "14.20437000"
                    },
                    {
                        "id": 138889,
                        "name": "Gela",
                        "latitude": "37.07381000",
                        "longitude": "14.24038000"
                    },
                    {
                        "id": 138908,
                        "name": "Geraci Siculo",
                        "latitude": "37.85901000",
                        "longitude": "14.15333000"
                    },
                    {
                        "id": 138937,
                        "name": "Giacalone",
                        "latitude": "38.03276000",
                        "longitude": "13.23695000"
                    },
                    {
                        "id": 138940,
                        "name": "Giammoro",
                        "latitude": "38.20372000",
                        "longitude": "15.30666000"
                    },
                    {
                        "id": 138944,
                        "name": "Giardina Gallotti",
                        "latitude": "37.35073000",
                        "longitude": "13.52272000"
                    },
                    {
                        "id": 138945,
                        "name": "Giardinello",
                        "latitude": "38.08706000",
                        "longitude": "13.15648000"
                    },
                    {
                        "id": 138946,
                        "name": "Giardini-Naxos",
                        "latitude": "37.82755000",
                        "longitude": "15.26713000"
                    },
                    {
                        "id": 138948,
                        "name": "Giarratana",
                        "latitude": "37.04741000",
                        "longitude": "14.79454000"
                    },
                    {
                        "id": 138949,
                        "name": "Giarre",
                        "latitude": "37.72440000",
                        "longitude": "15.18165000"
                    },
                    {
                        "id": 138973,
                        "name": "Gioiosa Marea",
                        "latitude": "38.17373000",
                        "longitude": "14.89932000"
                    },
                    {
                        "id": 138989,
                        "name": "Giuliana",
                        "latitude": "37.67280000",
                        "longitude": "13.23737000"
                    },
                    {
                        "id": 139004,
                        "name": "Gliaca",
                        "latitude": "38.16317000",
                        "longitude": "14.84768000"
                    },
                    {
                        "id": 139010,
                        "name": "Godrano",
                        "latitude": "37.90310000",
                        "longitude": "13.42823000"
                    },
                    {
                        "id": 139058,
                        "name": "Grammichele",
                        "latitude": "37.21326000",
                        "longitude": "14.63311000"
                    },
                    {
                        "id": 139066,
                        "name": "Graniti",
                        "latitude": "37.88986000",
                        "longitude": "15.22459000"
                    },
                    {
                        "id": 139076,
                        "name": "Gratteri",
                        "latitude": "37.96607000",
                        "longitude": "13.97314000"
                    },
                    {
                        "id": 139082,
                        "name": "Gravina di Catania",
                        "latitude": "37.56085000",
                        "longitude": "15.06292000"
                    },
                    {
                        "id": 139125,
                        "name": "Grotte",
                        "latitude": "37.40346000",
                        "longitude": "13.69889000"
                    },
                    {
                        "id": 139149,
                        "name": "Gualtieri Sicaminò",
                        "latitude": "38.16267000",
                        "longitude": "15.31699000"
                    },
                    {
                        "id": 139177,
                        "name": "Guidomandri Marina",
                        "latitude": "38.04528000",
                        "longitude": "15.46303000"
                    },
                    {
                        "id": 139235,
                        "name": "Isnello",
                        "latitude": "37.94324000",
                        "longitude": "14.00724000"
                    },
                    {
                        "id": 139249,
                        "name": "Isola delle Femmine",
                        "latitude": "38.19123000",
                        "longitude": "13.24691000"
                    },
                    {
                        "id": 139259,
                        "name": "Ispica",
                        "latitude": "36.78622000",
                        "longitude": "14.90530000"
                    },
                    {
                        "id": 139267,
                        "name": "Itala",
                        "latitude": "38.05144000",
                        "longitude": "15.43706000"
                    },
                    {
                        "id": 139282,
                        "name": "Joppolo Giancaxio",
                        "latitude": "37.38681000",
                        "longitude": "13.55586000"
                    },
                    {
                        "id": 139284,
                        "name": "Kamma",
                        "latitude": "36.79701000",
                        "longitude": "12.03617000"
                    },
                    {
                        "id": 139349,
                        "name": "Lampedusa",
                        "latitude": "35.50142000",
                        "longitude": "12.60964000"
                    },
                    {
                        "id": 139372,
                        "name": "Larderia",
                        "latitude": "38.14101000",
                        "longitude": "15.50287000"
                    },
                    {
                        "id": 139379,
                        "name": "Lascari",
                        "latitude": "38.00067000",
                        "longitude": "13.94053000"
                    },
                    {
                        "id": 139416,
                        "name": "Lavinaio-Monterosso",
                        "latitude": "37.64097000",
                        "longitude": "15.10462000"
                    },
                    {
                        "id": 139444,
                        "name": "Leni",
                        "latitude": "38.55534000",
                        "longitude": "14.82497000"
                    },
                    {
                        "id": 139454,
                        "name": "Lentini",
                        "latitude": "37.28556000",
                        "longitude": "14.99737000"
                    },
                    {
                        "id": 139457,
                        "name": "Leonforte",
                        "latitude": "37.64197000",
                        "longitude": "14.39766000"
                    },
                    {
                        "id": 139463,
                        "name": "Lercara Friddi",
                        "latitude": "37.74657000",
                        "longitude": "13.60391000"
                    },
                    {
                        "id": 139477,
                        "name": "Letojanni",
                        "latitude": "37.88050000",
                        "longitude": "15.30735000"
                    },
                    {
                        "id": 139493,
                        "name": "Librizzi",
                        "latitude": "38.09719000",
                        "longitude": "14.95909000"
                    },
                    {
                        "id": 139494,
                        "name": "Licata",
                        "latitude": "37.10267000",
                        "longitude": "13.93972000"
                    },
                    {
                        "id": 139498,
                        "name": "Licodia Eubea",
                        "latitude": "37.15674000",
                        "longitude": "14.70555000"
                    },
                    {
                        "id": 139522,
                        "name": "Limina",
                        "latitude": "37.94076000",
                        "longitude": "15.27119000"
                    },
                    {
                        "id": 139530,
                        "name": "Linera",
                        "latitude": "37.66380000",
                        "longitude": "15.13653000"
                    },
                    {
                        "id": 139531,
                        "name": "Linguaglossa",
                        "latitude": "37.84243000",
                        "longitude": "15.13774000"
                    },
                    {
                        "id": 139533,
                        "name": "Lipari",
                        "latitude": "38.46743000",
                        "longitude": "14.95398000"
                    },
                    {
                        "id": 139595,
                        "name": "Longi",
                        "latitude": "38.02617000",
                        "longitude": "14.75306000"
                    },
                    {
                        "id": 139630,
                        "name": "Lucca Sicula",
                        "latitude": "37.57783000",
                        "longitude": "13.30579000"
                    },
                    {
                        "id": 139763,
                        "name": "Maletto",
                        "latitude": "37.82914000",
                        "longitude": "14.86403000"
                    },
                    {
                        "id": 139764,
                        "name": "Malfa",
                        "latitude": "38.57730000",
                        "longitude": "14.83598000"
                    },
                    {
                        "id": 139776,
                        "name": "Malvagna",
                        "latitude": "37.91752000",
                        "longitude": "15.05548000"
                    },
                    {
                        "id": 139783,
                        "name": "Mandanici",
                        "latitude": "38.00356000",
                        "longitude": "15.31669000"
                    },
                    {
                        "id": 139799,
                        "name": "Maniace",
                        "latitude": "37.88306000",
                        "longitude": "14.79808000"
                    },
                    {
                        "id": 139833,
                        "name": "Marausa",
                        "latitude": "37.94166000",
                        "longitude": "12.50948000"
                    },
                    {
                        "id": 139869,
                        "name": "Marianopoli",
                        "latitude": "37.59840000",
                        "longitude": "13.91520000"
                    },
                    {
                        "id": 139880,
                        "name": "Marina di Caronia",
                        "latitude": "38.03545000",
                        "longitude": "14.44182000"
                    },
                    {
                        "id": 139893,
                        "name": "Marina di Ragusa",
                        "latitude": "36.78575000",
                        "longitude": "14.55474000"
                    },
                    {
                        "id": 139898,
                        "name": "Marinella",
                        "latitude": "37.59475000",
                        "longitude": "12.84434000"
                    },
                    {
                        "id": 139899,
                        "name": "Marineo",
                        "latitude": "37.95185000",
                        "longitude": "13.41781000"
                    },
                    {
                        "id": 139919,
                        "name": "Marsala",
                        "latitude": "37.79920000",
                        "longitude": "12.43670000"
                    },
                    {
                        "id": 139952,
                        "name": "Mascali",
                        "latitude": "37.75794000",
                        "longitude": "15.19662000"
                    },
                    {
                        "id": 139953,
                        "name": "Mascalucia",
                        "latitude": "37.57465000",
                        "longitude": "15.04964000"
                    },
                    {
                        "id": 140002,
                        "name": "Maugeri",
                        "latitude": "37.58608000",
                        "longitude": "15.11785000"
                    },
                    {
                        "id": 140004,
                        "name": "Mazara del Vallo",
                        "latitude": "37.65535000",
                        "longitude": "12.58986000"
                    },
                    {
                        "id": 140003,
                        "name": "Mazara II",
                        "latitude": "37.68146000",
                        "longitude": "12.60074000"
                    },
                    {
                        "id": 140007,
                        "name": "Mazzarino",
                        "latitude": "37.30188000",
                        "longitude": "14.20959000"
                    },
                    {
                        "id": 140009,
                        "name": "Mazzarrà Sant'Andrea",
                        "latitude": "38.08969000",
                        "longitude": "15.13535000"
                    },
                    {
                        "id": 140008,
                        "name": "Mazzarrone",
                        "latitude": "37.08834000",
                        "longitude": "14.56128000"
                    },
                    {
                        "id": 140044,
                        "name": "Melia",
                        "latitude": "37.90384000",
                        "longitude": "15.27499000"
                    },
                    {
                        "id": 140047,
                        "name": "Melilli",
                        "latitude": "37.17821000",
                        "longitude": "15.13020000"
                    },
                    {
                        "id": 140064,
                        "name": "Menfi",
                        "latitude": "37.60409000",
                        "longitude": "12.96889000"
                    },
                    {
                        "id": 140090,
                        "name": "Merì",
                        "latitude": "38.16630000",
                        "longitude": "15.24970000"
                    },
                    {
                        "id": 140098,
                        "name": "Messina",
                        "latitude": "38.05000000",
                        "longitude": "14.86667000"
                    },
                    {
                        "id": 140120,
                        "name": "Mezzojuso",
                        "latitude": "37.86509000",
                        "longitude": "13.46509000"
                    },
                    {
                        "id": 140145,
                        "name": "Milazzo",
                        "latitude": "38.22008000",
                        "longitude": "15.24023000"
                    },
                    {
                        "id": 140146,
                        "name": "Milena",
                        "latitude": "37.47133000",
                        "longitude": "13.73613000"
                    },
                    {
                        "id": 140150,
                        "name": "Militello in Val di Catania",
                        "latitude": "37.27594000",
                        "longitude": "14.79342000"
                    },
                    {
                        "id": 140149,
                        "name": "Militello Rosmarino",
                        "latitude": "38.04575000",
                        "longitude": "14.67584000"
                    },
                    {
                        "id": 140153,
                        "name": "Milo",
                        "latitude": "37.72450000",
                        "longitude": "15.11554000"
                    },
                    {
                        "id": 140156,
                        "name": "Mineo",
                        "latitude": "37.26494000",
                        "longitude": "14.69381000"
                    },
                    {
                        "id": 140168,
                        "name": "Mirabella Imbaccari",
                        "latitude": "37.32702000",
                        "longitude": "14.44605000"
                    },
                    {
                        "id": 140177,
                        "name": "Mirto",
                        "latitude": "38.08439000",
                        "longitude": "14.74609000"
                    },
                    {
                        "id": 140180,
                        "name": "Misilmeri",
                        "latitude": "38.03183000",
                        "longitude": "13.44795000"
                    },
                    {
                        "id": 140184,
                        "name": "Misterbianco",
                        "latitude": "37.51803000",
                        "longitude": "15.00913000"
                    },
                    {
                        "id": 140185,
                        "name": "Mistretta",
                        "latitude": "37.92823000",
                        "longitude": "14.35780000"
                    },
                    {
                        "id": 140189,
                        "name": "Modica",
                        "latitude": "36.85868000",
                        "longitude": "14.75966000"
                    },
                    {
                        "id": 140205,
                        "name": "Moio Alcantara",
                        "latitude": "37.90056000",
                        "longitude": "15.05072000"
                    },
                    {
                        "id": 140280,
                        "name": "Monforte San Giorgio",
                        "latitude": "38.15733000",
                        "longitude": "15.38132000"
                    },
                    {
                        "id": 140287,
                        "name": "Mongiuffi Melia",
                        "latitude": "37.90336000",
                        "longitude": "15.27539000"
                    },
                    {
                        "id": 140297,
                        "name": "Monreale",
                        "latitude": "38.08125000",
                        "longitude": "13.28947000"
                    },
                    {
                        "id": 140311,
                        "name": "Montagnareale",
                        "latitude": "38.13216000",
                        "longitude": "14.94658000"
                    },
                    {
                        "id": 140317,
                        "name": "Montalbano Elicona",
                        "latitude": "38.02360000",
                        "longitude": "15.01393000"
                    },
                    {
                        "id": 140329,
                        "name": "Montallegro",
                        "latitude": "37.39121000",
                        "longitude": "13.35179000"
                    },
                    {
                        "id": 140428,
                        "name": "Montedoro",
                        "latitude": "37.45431000",
                        "longitude": "13.81684000"
                    },
                    {
                        "id": 140473,
                        "name": "Montelepre",
                        "latitude": "38.09026000",
                        "longitude": "13.17518000"
                    },
                    {
                        "id": 140483,
                        "name": "Montemaggiore Belsito",
                        "latitude": "37.84818000",
                        "longitude": "13.76206000"
                    },
                    {
                        "id": 140522,
                        "name": "Monterosso Almo",
                        "latitude": "37.08884000",
                        "longitude": "14.76498000"
                    },
                    {
                        "id": 140546,
                        "name": "Montevago",
                        "latitude": "37.70224000",
                        "longitude": "12.98584000"
                    },
                    {
                        "id": 140657,
                        "name": "Motta Camastra",
                        "latitude": "37.89431000",
                        "longitude": "15.17008000"
                    },
                    {
                        "id": 140664,
                        "name": "Motta d'Affermo",
                        "latitude": "37.98096000",
                        "longitude": "14.30337000"
                    },
                    {
                        "id": 140661,
                        "name": "Motta Sant'Anastasia",
                        "latitude": "37.51205000",
                        "longitude": "14.96628000"
                    },
                    {
                        "id": 140704,
                        "name": "Mussomeli",
                        "latitude": "37.58067000",
                        "longitude": "13.75214000"
                    },
                    {
                        "id": 140721,
                        "name": "Naro",
                        "latitude": "37.29248000",
                        "longitude": "13.79337000"
                    },
                    {
                        "id": 140724,
                        "name": "Naso",
                        "latitude": "38.12215000",
                        "longitude": "14.78702000"
                    },
                    {
                        "id": 140763,
                        "name": "Nicolosi",
                        "latitude": "37.62148000",
                        "longitude": "15.02785000"
                    },
                    {
                        "id": 140765,
                        "name": "Nicosia",
                        "latitude": "37.74747000",
                        "longitude": "14.39218000"
                    },
                    {
                        "id": 140771,
                        "name": "Niscemi",
                        "latitude": "37.14649000",
                        "longitude": "14.39381000"
                    },
                    {
                        "id": 140772,
                        "name": "Nissoria",
                        "latitude": "37.65410000",
                        "longitude": "14.44810000"
                    },
                    {
                        "id": 140775,
                        "name": "Nizza di Sicilia",
                        "latitude": "37.99081000",
                        "longitude": "15.40956000"
                    },
                    {
                        "id": 140812,
                        "name": "Noto",
                        "latitude": "36.89244000",
                        "longitude": "15.06977000"
                    },
                    {
                        "id": 140823,
                        "name": "Novara di Sicilia",
                        "latitude": "38.01538000",
                        "longitude": "15.13134000"
                    },
                    {
                        "id": 140848,
                        "name": "Nunziata",
                        "latitude": "37.75858000",
                        "longitude": "15.17058000"
                    },
                    {
                        "id": 140851,
                        "name": "Nuova Gibellina",
                        "latitude": "37.80704000",
                        "longitude": "12.86954000"
                    },
                    {
                        "id": 140852,
                        "name": "Nuovo Centro Urbano Poggioreale",
                        "latitude": "37.76404000",
                        "longitude": "13.03594000"
                    },
                    {
                        "id": 140900,
                        "name": "Oliveri",
                        "latitude": "38.12515000",
                        "longitude": "15.06068000"
                    },
                    {
                        "id": 141068,
                        "name": "Pace del Mela",
                        "latitude": "38.17997000",
                        "longitude": "15.30629000"
                    },
                    {
                        "id": 141069,
                        "name": "Paceco",
                        "latitude": "37.98026000",
                        "longitude": "12.55766000"
                    },
                    {
                        "id": 141071,
                        "name": "Pachino",
                        "latitude": "36.71522000",
                        "longitude": "15.09019000"
                    },
                    {
                        "id": 58204,
                        "name": "Pagliara",
                        "latitude": "37.98546000",
                        "longitude": "15.35969000"
                    },
                    {
                        "id": 58221,
                        "name": "Palagonia",
                        "latitude": "37.32955000",
                        "longitude": "14.74474000"
                    },
                    {
                        "id": 58228,
                        "name": "Palazzo Adriano",
                        "latitude": "37.68066000",
                        "longitude": "13.37941000"
                    },
                    {
                        "id": 58232,
                        "name": "Palazzolo",
                        "latitude": "37.56224000",
                        "longitude": "14.92987000"
                    },
                    {
                        "id": 58233,
                        "name": "Palazzolo Acreide",
                        "latitude": "37.06261000",
                        "longitude": "14.90593000"
                    },
                    {
                        "id": 58240,
                        "name": "Palermo",
                        "latitude": "37.81667000",
                        "longitude": "13.58333000"
                    },
                    {
                        "id": 58254,
                        "name": "Palma di Montechiaro",
                        "latitude": "37.19066000",
                        "longitude": "13.76603000"
                    },
                    {
                        "id": 58284,
                        "name": "Pantelleria",
                        "latitude": "36.82836000",
                        "longitude": "11.94611000"
                    },
                    {
                        "id": 58316,
                        "name": "Partanna",
                        "latitude": "37.72680000",
                        "longitude": "12.88917000"
                    },
                    {
                        "id": 58317,
                        "name": "Partinico",
                        "latitude": "38.04657000",
                        "longitude": "13.11785000"
                    },
                    {
                        "id": 58338,
                        "name": "Pasteria-Lapide",
                        "latitude": "37.81012000",
                        "longitude": "15.22818000"
                    },
                    {
                        "id": 58346,
                        "name": "Paternò",
                        "latitude": "37.56675000",
                        "longitude": "14.90254000"
                    },
                    {
                        "id": 58350,
                        "name": "Patti",
                        "latitude": "38.14736000",
                        "longitude": "14.96409000"
                    },
                    {
                        "id": 58373,
                        "name": "Pedagaggi",
                        "latitude": "37.19182000",
                        "longitude": "14.93654000"
                    },
                    {
                        "id": 58374,
                        "name": "Pedalino",
                        "latitude": "37.02320000",
                        "longitude": "14.58116000"
                    },
                    {
                        "id": 58375,
                        "name": "Pedara",
                        "latitude": "37.62386000",
                        "longitude": "15.05672000"
                    },
                    {
                        "id": 58409,
                        "name": "Pennisi",
                        "latitude": "37.64945000",
                        "longitude": "15.12385000"
                    },
                    {
                        "id": 58477,
                        "name": "Petralia Soprana",
                        "latitude": "37.80064000",
                        "longitude": "14.10813000"
                    },
                    {
                        "id": 58478,
                        "name": "Petralia Sottana",
                        "latitude": "37.80919000",
                        "longitude": "14.09293000"
                    },
                    {
                        "id": 58487,
                        "name": "Petrosino",
                        "latitude": "37.71271000",
                        "longitude": "12.49964000"
                    },
                    {
                        "id": 58491,
                        "name": "Pettineo",
                        "latitude": "37.96793000",
                        "longitude": "14.29118000"
                    },
                    {
                        "id": 58514,
                        "name": "Piana degli Albanesi",
                        "latitude": "37.99372000",
                        "longitude": "13.28464000"
                    },
                    {
                        "id": 58540,
                        "name": "Piano dei Geli",
                        "latitude": "38.09919000",
                        "longitude": "13.27478000"
                    },
                    {
                        "id": 58539,
                        "name": "Piano Maglio-Blandino",
                        "latitude": "38.05793000",
                        "longitude": "13.30909000"
                    },
                    {
                        "id": 58547,
                        "name": "Pianoconte",
                        "latitude": "38.47432000",
                        "longitude": "14.92857000"
                    },
                    {
                        "id": 58565,
                        "name": "Piazza Armerina",
                        "latitude": "37.38417000",
                        "longitude": "14.36921000"
                    },
                    {
                        "id": 58589,
                        "name": "Piedimonte Etneo",
                        "latitude": "37.80677000",
                        "longitude": "15.17516000"
                    },
                    {
                        "id": 58622,
                        "name": "Pietraperzia",
                        "latitude": "37.41852000",
                        "longitude": "14.13739000"
                    },
                    {
                        "id": 58692,
                        "name": "Pioppo",
                        "latitude": "38.05000000",
                        "longitude": "13.23333000"
                    },
                    {
                        "id": 58701,
                        "name": "Piraino",
                        "latitude": "38.16127000",
                        "longitude": "14.86100000"
                    },
                    {
                        "id": 58794,
                        "name": "Polizzi Generosa",
                        "latitude": "37.81159000",
                        "longitude": "14.00268000"
                    },
                    {
                        "id": 58800,
                        "name": "Pollina",
                        "latitude": "37.99309000",
                        "longitude": "14.14586000"
                    },
                    {
                        "id": 58916,
                        "name": "Portella di Mare",
                        "latitude": "38.07304000",
                        "longitude": "13.46199000"
                    },
                    {
                        "id": 58928,
                        "name": "Porto Empedocle",
                        "latitude": "37.28942000",
                        "longitude": "13.52494000"
                    },
                    {
                        "id": 58948,
                        "name": "Portopalo di Capo Passero",
                        "latitude": "36.68219000",
                        "longitude": "15.13378000"
                    },
                    {
                        "id": 58979,
                        "name": "Pozzallo",
                        "latitude": "36.73028000",
                        "longitude": "14.84672000"
                    },
                    {
                        "id": 59081,
                        "name": "Priolo Gargallo",
                        "latitude": "37.15512000",
                        "longitude": "15.18248000"
                    },
                    {
                        "id": 59084,
                        "name": "Prizzi",
                        "latitude": "37.72088000",
                        "longitude": "13.43435000"
                    },
                    {
                        "id": 59120,
                        "name": "Provincia di Caltanissetta",
                        "latitude": "37.37448000",
                        "longitude": "14.06421000"
                    },
                    {
                        "id": 59176,
                        "name": "Provincia di Siracusa",
                        "latitude": "37.08805000",
                        "longitude": "15.27924000"
                    },
                    {
                        "id": 59256,
                        "name": "Racalmuto",
                        "latitude": "37.40498000",
                        "longitude": "13.72995000"
                    },
                    {
                        "id": 59258,
                        "name": "Raccuja",
                        "latitude": "38.05583000",
                        "longitude": "14.91044000"
                    },
                    {
                        "id": 59262,
                        "name": "Raddusa",
                        "latitude": "37.47529000",
                        "longitude": "14.53521000"
                    },
                    {
                        "id": 59266,
                        "name": "Raffadali",
                        "latitude": "37.40214000",
                        "longitude": "13.53175000"
                    },
                    {
                        "id": 59267,
                        "name": "Ragalna",
                        "latitude": "37.63455000",
                        "longitude": "14.94698000"
                    },
                    {
                        "id": 59269,
                        "name": "Ragusa",
                        "latitude": "36.91667000",
                        "longitude": "14.60000000"
                    },
                    {
                        "id": 59272,
                        "name": "Ramacca",
                        "latitude": "37.38616000",
                        "longitude": "14.69241000"
                    },
                    {
                        "id": 59280,
                        "name": "Randazzo",
                        "latitude": "37.87736000",
                        "longitude": "14.95012000"
                    },
                    {
                        "id": 59295,
                        "name": "Ravanusa",
                        "latitude": "37.26659000",
                        "longitude": "13.96834000"
                    },
                    {
                        "id": 59305,
                        "name": "Realmonte",
                        "latitude": "37.30847000",
                        "longitude": "13.46429000"
                    },
                    {
                        "id": 59318,
                        "name": "Regalbuto",
                        "latitude": "37.65195000",
                        "longitude": "14.63915000"
                    },
                    {
                        "id": 59326,
                        "name": "Reitano",
                        "latitude": "37.97198000",
                        "longitude": "14.34418000"
                    },
                    {
                        "id": 59337,
                        "name": "Resuttano",
                        "latitude": "37.67865000",
                        "longitude": "14.02946000"
                    },
                    {
                        "id": 59359,
                        "name": "Ribera",
                        "latitude": "37.49773000",
                        "longitude": "13.26676000"
                    },
                    {
                        "id": 59373,
                        "name": "Riesi",
                        "latitude": "37.28079000",
                        "longitude": "14.08317000"
                    },
                    {
                        "id": 59381,
                        "name": "Rilievo",
                        "latitude": "37.91638000",
                        "longitude": "12.54058000"
                    },
                    {
                        "id": 59412,
                        "name": "Riposto",
                        "latitude": "37.73183000",
                        "longitude": "15.20576000"
                    },
                    {
                        "id": 59485,
                        "name": "Rocca di Capri Leone",
                        "latitude": "38.10677000",
                        "longitude": "14.71032000"
                    },
                    {
                        "id": 59496,
                        "name": "Roccafiorita",
                        "latitude": "37.93086000",
                        "longitude": "15.26739000"
                    },
                    {
                        "id": 59506,
                        "name": "Roccalumera",
                        "latitude": "37.97554000",
                        "longitude": "15.39439000"
                    },
                    {
                        "id": 59508,
                        "name": "Roccamena",
                        "latitude": "37.83824000",
                        "longitude": "13.15513000"
                    },
                    {
                        "id": 59513,
                        "name": "Roccapalumba",
                        "latitude": "37.80825000",
                        "longitude": "13.63671000"
                    },
                    {
                        "id": 59526,
                        "name": "Roccavaldina",
                        "latitude": "38.18296000",
                        "longitude": "15.37402000"
                    },
                    {
                        "id": 59533,
                        "name": "Roccella Valdemone",
                        "latitude": "37.93289000",
                        "longitude": "15.00997000"
                    },
                    {
                        "id": 59555,
                        "name": "Rodì",
                        "latitude": "38.10823000",
                        "longitude": "15.16933000"
                    },
                    {
                        "id": 59585,
                        "name": "Rometta",
                        "latitude": "38.17007000",
                        "longitude": "15.41429000"
                    },
                    {
                        "id": 59586,
                        "name": "Rometta Marea",
                        "latitude": "38.23264000",
                        "longitude": "15.40955000"
                    },
                    {
                        "id": 59643,
                        "name": "Rosolini",
                        "latitude": "36.82145000",
                        "longitude": "14.95132000"
                    },
                    {
                        "id": 59747,
                        "name": "Salaparuta",
                        "latitude": "37.75694000",
                        "longitude": "13.00981000"
                    },
                    {
                        "id": 59758,
                        "name": "Salemi",
                        "latitude": "37.82199000",
                        "longitude": "12.80506000"
                    },
                    {
                        "id": 59805,
                        "name": "Sambuca di Sicilia",
                        "latitude": "37.65294000",
                        "longitude": "13.11462000"
                    },
                    {
                        "id": 59841,
                        "name": "San Biagio Platani",
                        "latitude": "37.50927000",
                        "longitude": "13.52844000"
                    },
                    {
                        "id": 59862,
                        "name": "San Cataldo",
                        "latitude": "37.48412000",
                        "longitude": "13.98542000"
                    },
                    {
                        "id": 59868,
                        "name": "San Cipirello",
                        "latitude": "37.96067000",
                        "longitude": "13.17732000"
                    },
                    {
                        "id": 59873,
                        "name": "San Ciro-Ulmi-Filci",
                        "latitude": "37.83328000",
                        "longitude": "12.78229000"
                    },
                    {
                        "id": 59878,
                        "name": "San Cono",
                        "latitude": "37.28992000",
                        "longitude": "14.36709000"
                    },
                    {
                        "id": 59919,
                        "name": "San Filippo del Mela",
                        "latitude": "38.17007000",
                        "longitude": "15.27338000"
                    },
                    {
                        "id": 59928,
                        "name": "San Fratello",
                        "latitude": "38.01556000",
                        "longitude": "14.59818000"
                    },
                    {
                        "id": 59951,
                        "name": "San Giorgio",
                        "latitude": "38.16834000",
                        "longitude": "14.94825000"
                    },
                    {
                        "id": 59979,
                        "name": "San Giovanni",
                        "latitude": "37.73538000",
                        "longitude": "15.15887000"
                    },
                    {
                        "id": 59983,
                        "name": "San Giovanni Gemini",
                        "latitude": "37.62785000",
                        "longitude": "13.64357000"
                    },
                    {
                        "id": 60001,
                        "name": "San Giovanni la Punta",
                        "latitude": "37.57690000",
                        "longitude": "15.09371000"
                    },
                    {
                        "id": 60012,
                        "name": "San Giuseppe Jato",
                        "latitude": "37.97331000",
                        "longitude": "13.18889000"
                    },
                    {
                        "id": 60024,
                        "name": "San Gregorio di Catania",
                        "latitude": "37.56764000",
                        "longitude": "15.11120000"
                    },
                    {
                        "id": 60032,
                        "name": "San Leone Mosè",
                        "latitude": "37.26497000",
                        "longitude": "13.58434000"
                    },
                    {
                        "id": 60063,
                        "name": "San Marco d'Alunzio",
                        "latitude": "38.07261000",
                        "longitude": "14.70093000"
                    },
                    {
                        "id": 60105,
                        "name": "San Mauro Castelverde",
                        "latitude": "37.91478000",
                        "longitude": "14.18961000"
                    },
                    {
                        "id": 60123,
                        "name": "San Michele di Ganzaria",
                        "latitude": "37.28042000",
                        "longitude": "14.42633000"
                    },
                    {
                        "id": 60164,
                        "name": "San Pier Niceto",
                        "latitude": "38.16050000",
                        "longitude": "15.34982000"
                    },
                    {
                        "id": 60167,
                        "name": "San Piero Patti",
                        "latitude": "38.05214000",
                        "longitude": "14.96816000"
                    },
                    {
                        "id": 60177,
                        "name": "San Pietro Clarenza",
                        "latitude": "37.56885000",
                        "longitude": "15.02289000"
                    },
                    {
                        "id": 60233,
                        "name": "San Salvatore di Fitalia",
                        "latitude": "38.06841000",
                        "longitude": "14.77799000"
                    },
                    {
                        "id": 60252,
                        "name": "San Teodoro",
                        "latitude": "37.84797000",
                        "longitude": "14.69878000"
                    },
                    {
                        "id": 60276,
                        "name": "San Vito Lo Capo",
                        "latitude": "38.17395000",
                        "longitude": "12.73599000"
                    },
                    {
                        "id": 60323,
                        "name": "Sant'Agata di Militello",
                        "latitude": "38.06838000",
                        "longitude": "14.63600000"
                    },
                    {
                        "id": 60318,
                        "name": "Sant'Agata Li Battiati",
                        "latitude": "37.55745000",
                        "longitude": "15.07999000"
                    },
                    {
                        "id": 60334,
                        "name": "Sant'Alessio Siculo",
                        "latitude": "37.92516000",
                        "longitude": "15.34968000"
                    },
                    {
                        "id": 60336,
                        "name": "Sant'Alfio",
                        "latitude": "37.74393000",
                        "longitude": "15.13952000"
                    },
                    {
                        "id": 60365,
                        "name": "Sant'Angelo di Brolo",
                        "latitude": "38.11518000",
                        "longitude": "14.88403000"
                    },
                    {
                        "id": 60360,
                        "name": "Sant'Angelo Muxaro",
                        "latitude": "37.48014000",
                        "longitude": "13.54554000"
                    },
                    {
                        "id": 60415,
                        "name": "Santa Caterina Villarmosa",
                        "latitude": "37.59034000",
                        "longitude": "14.03554000"
                    },
                    {
                        "id": 60422,
                        "name": "Santa Cristina Gela",
                        "latitude": "37.98514000",
                        "longitude": "13.32747000"
                    },
                    {
                        "id": 60426,
                        "name": "Santa Croce Camerina",
                        "latitude": "36.82842000",
                        "longitude": "14.52538000"
                    },
                    {
                        "id": 60433,
                        "name": "Santa Domenica Vittoria",
                        "latitude": "37.91624000",
                        "longitude": "14.96288000"
                    },
                    {
                        "id": 60434,
                        "name": "Santa Elisabetta",
                        "latitude": "37.43171000",
                        "longitude": "13.55386000"
                    },
                    {
                        "id": 60437,
                        "name": "Santa Flavia",
                        "latitude": "38.10448000",
                        "longitude": "13.53340000"
                    },
                    {
                        "id": 60447,
                        "name": "Santa Lucia del Mela",
                        "latitude": "38.14408000",
                        "longitude": "15.28055000"
                    },
                    {
                        "id": 60453,
                        "name": "Santa Margherita di Belice",
                        "latitude": "37.69281000",
                        "longitude": "13.01584000"
                    },
                    {
                        "id": 60476,
                        "name": "Santa Maria di Licodia",
                        "latitude": "37.61684000",
                        "longitude": "14.89337000"
                    },
                    {
                        "id": 60481,
                        "name": "Santa Maria la Stella",
                        "latitude": "37.62349000",
                        "longitude": "15.12071000"
                    },
                    {
                        "id": 60483,
                        "name": "Santa Marina Salina",
                        "latitude": "38.56117000",
                        "longitude": "14.87077000"
                    },
                    {
                        "id": 60487,
                        "name": "Santa Ninfa",
                        "latitude": "37.77042000",
                        "longitude": "12.87744000"
                    },
                    {
                        "id": 60496,
                        "name": "Santa Teresa di Riva",
                        "latitude": "37.94635000",
                        "longitude": "15.36671000"
                    },
                    {
                        "id": 60498,
                        "name": "Santa Venerina",
                        "latitude": "37.69103000",
                        "longitude": "15.13880000"
                    },
                    {
                        "id": 60521,
                        "name": "Santo Stefano di Camastra",
                        "latitude": "38.01295000",
                        "longitude": "14.35142000"
                    },
                    {
                        "id": 60514,
                        "name": "Santo Stefano Quisquina",
                        "latitude": "37.62606000",
                        "longitude": "13.48976000"
                    },
                    {
                        "id": 60535,
                        "name": "Saponara",
                        "latitude": "38.19241000",
                        "longitude": "15.43442000"
                    },
                    {
                        "id": 60536,
                        "name": "Saponara Marittima",
                        "latitude": "38.23121000",
                        "longitude": "15.42621000"
                    },
                    {
                        "id": 60564,
                        "name": "Sasi",
                        "latitude": "37.90217000",
                        "longitude": "12.88788000"
                    },
                    {
                        "id": 60595,
                        "name": "Savoca",
                        "latitude": "37.95326000",
                        "longitude": "15.34009000"
                    },
                    {
                        "id": 60609,
                        "name": "Scaletta Zanclea",
                        "latitude": "38.04796000",
                        "longitude": "15.46769000"
                    },
                    {
                        "id": 60649,
                        "name": "Sciacca",
                        "latitude": "37.50693000",
                        "longitude": "13.08399000"
                    },
                    {
                        "id": 60650,
                        "name": "Sciara",
                        "latitude": "37.91511000",
                        "longitude": "13.76177000"
                    },
                    {
                        "id": 60653,
                        "name": "Scicli",
                        "latitude": "36.79014000",
                        "longitude": "14.70280000"
                    },
                    {
                        "id": 60656,
                        "name": "Scillato",
                        "latitude": "37.85778000",
                        "longitude": "13.90632000"
                    },
                    {
                        "id": 60659,
                        "name": "Sclafani Bagni",
                        "latitude": "37.82175000",
                        "longitude": "13.85476000"
                    },
                    {
                        "id": 60660,
                        "name": "Scoglitti",
                        "latitude": "36.89424000",
                        "longitude": "14.43355000"
                    },
                    {
                        "id": 60666,
                        "name": "Scordia",
                        "latitude": "37.29548000",
                        "longitude": "14.84058000"
                    },
                    {
                        "id": 60759,
                        "name": "Serradifalco",
                        "latitude": "37.45384000",
                        "longitude": "13.88046000"
                    },
                    {
                        "id": 60826,
                        "name": "Sfaranda",
                        "latitude": "38.05815000",
                        "longitude": "14.83147000"
                    },
                    {
                        "id": 60827,
                        "name": "Sferracavallo",
                        "latitude": "38.20000000",
                        "longitude": "13.28333000"
                    },
                    {
                        "id": 60840,
                        "name": "Siculiana",
                        "latitude": "37.33515000",
                        "longitude": "13.42432000"
                    },
                    {
                        "id": 60862,
                        "name": "Sinagra",
                        "latitude": "38.08191000",
                        "longitude": "14.85009000"
                    },
                    {
                        "id": 60871,
                        "name": "Siracusa",
                        "latitude": "37.07542000",
                        "longitude": "15.28664000"
                    },
                    {
                        "id": 60903,
                        "name": "Solarino",
                        "latitude": "37.10136000",
                        "longitude": "15.11988000"
                    },
                    {
                        "id": 60933,
                        "name": "Sommatino",
                        "latitude": "37.33471000",
                        "longitude": "13.99739000"
                    },
                    {
                        "id": 60968,
                        "name": "Sortino",
                        "latitude": "37.15881000",
                        "longitude": "15.02998000"
                    },
                    {
                        "id": 60988,
                        "name": "Spadafora",
                        "latitude": "38.22349000",
                        "longitude": "15.38178000"
                    },
                    {
                        "id": 60992,
                        "name": "Sparta'",
                        "latitude": "38.29371000",
                        "longitude": "15.53503000"
                    },
                    {
                        "id": 60997,
                        "name": "Sperlinga",
                        "latitude": "37.76653000",
                        "longitude": "14.35075000"
                    },
                    {
                        "id": 61132,
                        "name": "Sutera",
                        "latitude": "37.52493000",
                        "longitude": "13.73274000"
                    },
                    {
                        "id": 61161,
                        "name": "Taormina",
                        "latitude": "37.85358000",
                        "longitude": "15.28851000"
                    },
                    {
                        "id": 61226,
                        "name": "Terme",
                        "latitude": "38.13586000",
                        "longitude": "15.15658000"
                    },
                    {
                        "id": 61228,
                        "name": "Termini Imerese",
                        "latitude": "37.98225000",
                        "longitude": "13.69729000"
                    },
                    {
                        "id": 61245,
                        "name": "Terrasini",
                        "latitude": "38.14621000",
                        "longitude": "13.08319000"
                    },
                    {
                        "id": 61312,
                        "name": "Tonnara di Bonagia",
                        "latitude": "38.06309000",
                        "longitude": "12.59434000"
                    },
                    {
                        "id": 61313,
                        "name": "Tonnarella",
                        "latitude": "38.12539000",
                        "longitude": "15.11348000"
                    },
                    {
                        "id": 61354,
                        "name": "Torre Colonna-Sperone",
                        "latitude": "38.02986000",
                        "longitude": "13.57377000"
                    },
                    {
                        "id": 61383,
                        "name": "Torregrotta",
                        "latitude": "38.20262000",
                        "longitude": "15.35010000"
                    },
                    {
                        "id": 61386,
                        "name": "Torrenova",
                        "latitude": "38.09246000",
                        "longitude": "14.67917000"
                    },
                    {
                        "id": 61389,
                        "name": "Torretta",
                        "latitude": "38.13036000",
                        "longitude": "13.23549000"
                    },
                    {
                        "id": 61418,
                        "name": "Tortorici",
                        "latitude": "38.02973000",
                        "longitude": "14.82212000"
                    },
                    {
                        "id": 61427,
                        "name": "Trabia",
                        "latitude": "38.00420000",
                        "longitude": "13.63393000"
                    },
                    {
                        "id": 61440,
                        "name": "Trapani",
                        "latitude": "37.83333000",
                        "longitude": "12.66667000"
                    },
                    {
                        "id": 61441,
                        "name": "Trappeto",
                        "latitude": "38.06875000",
                        "longitude": "13.03794000"
                    },
                    {
                        "id": 61457,
                        "name": "Tre Fontane",
                        "latitude": "37.56989000",
                        "longitude": "12.72423000"
                    },
                    {
                        "id": 61465,
                        "name": "Trecastagni",
                        "latitude": "37.61543000",
                        "longitude": "15.07796000"
                    },
                    {
                        "id": 61478,
                        "name": "Tremestieri Etneo",
                        "latitude": "37.56494000",
                        "longitude": "15.07863000"
                    },
                    {
                        "id": 61534,
                        "name": "Tripi",
                        "latitude": "38.04673000",
                        "longitude": "15.09670000"
                    },
                    {
                        "id": 61535,
                        "name": "Triscina",
                        "latitude": "37.58717000",
                        "longitude": "12.78912000"
                    },
                    {
                        "id": 61550,
                        "name": "Troina",
                        "latitude": "37.78437000",
                        "longitude": "14.59605000"
                    },
                    {
                        "id": 61580,
                        "name": "Tusa",
                        "latitude": "37.98385000",
                        "longitude": "14.23606000"
                    },
                    {
                        "id": 61586,
                        "name": "Ucria",
                        "latitude": "38.04624000",
                        "longitude": "14.88087000"
                    },
                    {
                        "id": 61619,
                        "name": "Ustica",
                        "latitude": "38.70985000",
                        "longitude": "13.19293000"
                    },
                    {
                        "id": 61653,
                        "name": "Valderice",
                        "latitude": "38.04005000",
                        "longitude": "12.61505000"
                    },
                    {
                        "id": 61655,
                        "name": "Valdina",
                        "latitude": "38.19351000",
                        "longitude": "15.36980000"
                    },
                    {
                        "id": 61678,
                        "name": "Valguarnera Caropepe",
                        "latitude": "37.49527000",
                        "longitude": "14.39025000"
                    },
                    {
                        "id": 61705,
                        "name": "Valledolmo",
                        "latitude": "37.74703000",
                        "longitude": "13.82811000"
                    },
                    {
                        "id": 61710,
                        "name": "Vallelunga Pratameno",
                        "latitude": "37.68205000",
                        "longitude": "13.83156000"
                    },
                    {
                        "id": 61747,
                        "name": "Valverde",
                        "latitude": "37.57695000",
                        "longitude": "15.12419000"
                    },
                    {
                        "id": 61750,
                        "name": "Vambolieri",
                        "latitude": "37.57417000",
                        "longitude": "15.16019000"
                    },
                    {
                        "id": 61818,
                        "name": "Venetico Marina",
                        "latitude": "38.21928000",
                        "longitude": "15.36648000"
                    },
                    {
                        "id": 61819,
                        "name": "Venetico Superiore",
                        "latitude": "38.19307000",
                        "longitude": "15.38119000"
                    },
                    {
                        "id": 61826,
                        "name": "Ventimiglia di Sicilia",
                        "latitude": "37.92361000",
                        "longitude": "13.56768000"
                    },
                    {
                        "id": 61901,
                        "name": "Viagrande",
                        "latitude": "37.61032000",
                        "longitude": "15.09794000"
                    },
                    {
                        "id": 61911,
                        "name": "Vicari",
                        "latitude": "37.82371000",
                        "longitude": "13.56889000"
                    },
                    {
                        "id": 61954,
                        "name": "Vigliatore 2",
                        "latitude": "38.12221000",
                        "longitude": "15.13066000"
                    },
                    {
                        "id": 61993,
                        "name": "Villa Ciambra",
                        "latitude": "38.06129000",
                        "longitude": "13.32000000"
                    },
                    {
                        "id": 62047,
                        "name": "Villabate",
                        "latitude": "38.07789000",
                        "longitude": "13.44275000"
                    },
                    {
                        "id": 62058,
                        "name": "Villafranca Sicula",
                        "latitude": "37.58761000",
                        "longitude": "13.29048000"
                    },
                    {
                        "id": 62059,
                        "name": "Villafranca Tirrena",
                        "latitude": "38.23952000",
                        "longitude": "15.43885000"
                    },
                    {
                        "id": 62063,
                        "name": "Villafrati",
                        "latitude": "37.90646000",
                        "longitude": "13.48486000"
                    },
                    {
                        "id": 62068,
                        "name": "Villaggio del Pino-Le Ginestre",
                        "latitude": "37.58292000",
                        "longitude": "15.00377000"
                    },
                    {
                        "id": 62076,
                        "name": "Villalba",
                        "latitude": "37.65457000",
                        "longitude": "13.84452000"
                    },
                    {
                        "id": 62131,
                        "name": "Villarosa",
                        "latitude": "37.58753000",
                        "longitude": "14.17089000"
                    },
                    {
                        "id": 62135,
                        "name": "Villaseta",
                        "latitude": "37.29877000",
                        "longitude": "13.55919000"
                    },
                    {
                        "id": 62137,
                        "name": "Villasmundo",
                        "latitude": "37.25132000",
                        "longitude": "15.09087000"
                    },
                    {
                        "id": 62178,
                        "name": "Vita",
                        "latitude": "37.86886000",
                        "longitude": "12.82755000"
                    },
                    {
                        "id": 62184,
                        "name": "Vittoria",
                        "latitude": "36.95151000",
                        "longitude": "14.52788000"
                    },
                    {
                        "id": 62193,
                        "name": "Vizzini",
                        "latitude": "37.16188000",
                        "longitude": "14.75712000"
                    },
                    {
                        "id": 62229,
                        "name": "Zafferana Etnea",
                        "latitude": "37.67895000",
                        "longitude": "15.10432000"
                    }
                ]
            },
            {
                "id": 1734,
                "name": "Siena",
                "iso2": "SI",
                "latitude": "43.29377320",
                "longitude": "11.43391480",
                "type": "province",
                "cities": []
            },
            {
                "id": 1667,
                "name": "Siracusa",
                "iso2": "SR",
                "latitude": "37.06569240",
                "longitude": "15.28571090",
                "type": "free municipal consortium",
                "cities": []
            },
            {
                "id": 1741,
                "name": "Sondrio",
                "iso2": "SO",
                "latitude": "46.17276360",
                "longitude": "9.79949170",
                "type": "province",
                "cities": []
            },
            {
                "id": 1730,
                "name": "South Sardinia",
                "iso2": "SU",
                "latitude": "39.38935350",
                "longitude": "8.93970000",
                "type": "province",
                "cities": []
            },
            {
                "id": 1743,
                "name": "Taranto",
                "iso2": "TA",
                "latitude": "40.57409010",
                "longitude": "17.24299760",
                "type": "province",
                "cities": []
            },
            {
                "id": 1752,
                "name": "Teramo",
                "iso2": "TE",
                "latitude": "42.58956080",
                "longitude": "13.63627150",
                "type": "province",
                "cities": []
            },
            {
                "id": 1755,
                "name": "Terni",
                "iso2": "TR",
                "latitude": "42.56345340",
                "longitude": "12.52980280",
                "type": "province",
                "cities": []
            },
            {
                "id": 1733,
                "name": "Trapani",
                "iso2": "TP",
                "latitude": "38.01831160",
                "longitude": "12.51482650",
                "type": "free municipal consortium",
                "cities": []
            },
            {
                "id": 1725,
                "name": "Trentino-South Tyrol",
                "iso2": "32",
                "latitude": "46.43366620",
                "longitude": "11.16932960",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 135338,
                        "name": "Ala",
                        "latitude": "45.76072000",
                        "longitude": "11.00458000"
                    },
                    {
                        "id": 135370,
                        "name": "Albiano",
                        "latitude": "46.14451000",
                        "longitude": "11.19459000"
                    },
                    {
                        "id": 135391,
                        "name": "Aldeno",
                        "latitude": "45.97758000",
                        "longitude": "11.09276000"
                    },
                    {
                        "id": 135392,
                        "name": "Aldino",
                        "latitude": "46.36581000",
                        "longitude": "11.35508000"
                    },
                    {
                        "id": 135465,
                        "name": "Amblar",
                        "latitude": "46.39541000",
                        "longitude": "11.14677000"
                    },
                    {
                        "id": 135481,
                        "name": "Andalo",
                        "latitude": "46.16649000",
                        "longitude": "11.00432000"
                    },
                    {
                        "id": 135492,
                        "name": "Andriano",
                        "latitude": "46.51762000",
                        "longitude": "11.23137000"
                    },
                    {
                        "id": 135514,
                        "name": "Anterivo",
                        "latitude": "46.27810000",
                        "longitude": "11.36665000"
                    },
                    {
                        "id": 135570,
                        "name": "Arco",
                        "latitude": "45.91772000",
                        "longitude": "10.88672000"
                    },
                    {
                        "id": 135698,
                        "name": "Avelengo",
                        "latitude": "46.64557000",
                        "longitude": "11.22419000"
                    },
                    {
                        "id": 135711,
                        "name": "Avio",
                        "latitude": "45.73396000",
                        "longitude": "10.93938000"
                    },
                    {
                        "id": 135734,
                        "name": "Badia",
                        "latitude": "46.60816000",
                        "longitude": "11.89630000"
                    },
                    {
                        "id": 135831,
                        "name": "Barbiano - Barbian",
                        "latitude": "46.60332000",
                        "longitude": "11.52138000"
                    },
                    {
                        "id": 135882,
                        "name": "Baselga di Pinè",
                        "latitude": "46.13250000",
                        "longitude": "11.24648000"
                    },
                    {
                        "id": 135999,
                        "name": "Bersone",
                        "latitude": "45.94440000",
                        "longitude": "10.63317000"
                    },
                    {
                        "id": 136013,
                        "name": "Besenello",
                        "latitude": "45.94356000",
                        "longitude": "11.10908000"
                    },
                    {
                        "id": 136048,
                        "name": "Bieno",
                        "latitude": "46.08151000",
                        "longitude": "11.55609000"
                    },
                    {
                        "id": 136078,
                        "name": "Bleggio Superiore",
                        "latitude": "46.02480000",
                        "longitude": "10.83837000"
                    },
                    {
                        "id": 136091,
                        "name": "Bocenago",
                        "latitude": "46.11858000",
                        "longitude": "10.75884000"
                    },
                    {
                        "id": 136102,
                        "name": "Bolbeno",
                        "latitude": "46.03260000",
                        "longitude": "10.73787000"
                    },
                    {
                        "id": 136109,
                        "name": "Bolognano-Vignole",
                        "latitude": "45.91196000",
                        "longitude": "10.90497000"
                    },
                    {
                        "id": 136115,
                        "name": "Bolzano",
                        "latitude": "46.71667000",
                        "longitude": "11.50000000"
                    },
                    {
                        "id": 136132,
                        "name": "Bondo",
                        "latitude": "46.00030000",
                        "longitude": "10.69197000"
                    },
                    {
                        "id": 136133,
                        "name": "Bondone",
                        "latitude": "45.80649000",
                        "longitude": "10.55027000"
                    },
                    {
                        "id": 136194,
                        "name": "Borgo Valsugana",
                        "latitude": "46.05119000",
                        "longitude": "11.45756000"
                    },
                    {
                        "id": 136249,
                        "name": "Bosentino-Migazzone",
                        "latitude": "46.00180000",
                        "longitude": "11.22318000"
                    },
                    {
                        "id": 136284,
                        "name": "Braies",
                        "latitude": "46.72023000",
                        "longitude": "12.13339000"
                    },
                    {
                        "id": 136296,
                        "name": "Breguzzo",
                        "latitude": "46.00679000",
                        "longitude": "10.69761000"
                    },
                    {
                        "id": 136305,
                        "name": "Brennero - Brenner",
                        "latitude": "46.93813000",
                        "longitude": "11.44247000"
                    },
                    {
                        "id": 136310,
                        "name": "Brentonico",
                        "latitude": "45.81910000",
                        "longitude": "10.95508000"
                    },
                    {
                        "id": 136315,
                        "name": "Bresimo",
                        "latitude": "46.41181000",
                        "longitude": "10.96817000"
                    },
                    {
                        "id": 136318,
                        "name": "Bressanone",
                        "latitude": "46.71503000",
                        "longitude": "11.65598000"
                    },
                    {
                        "id": 136321,
                        "name": "Brez",
                        "latitude": "46.43220000",
                        "longitude": "11.10578000"
                    },
                    {
                        "id": 136339,
                        "name": "Brione",
                        "latitude": "45.89488000",
                        "longitude": "10.58975000"
                    },
                    {
                        "id": 136354,
                        "name": "Bronzolo",
                        "latitude": "46.40346000",
                        "longitude": "11.32078000"
                    },
                    {
                        "id": 136371,
                        "name": "Brunico",
                        "latitude": "46.79942000",
                        "longitude": "11.93429000"
                    },
                    {
                        "id": 136457,
                        "name": "Caderzone Terme",
                        "latitude": "46.12945000",
                        "longitude": "10.75619000"
                    },
                    {
                        "id": 136458,
                        "name": "Cadine",
                        "latitude": "46.08960000",
                        "longitude": "11.06847000"
                    },
                    {
                        "id": 136459,
                        "name": "Cadipietra",
                        "latitude": "46.99576000",
                        "longitude": "11.98026000"
                    },
                    {
                        "id": 136473,
                        "name": "Cagnò",
                        "latitude": "46.39431000",
                        "longitude": "11.04117000"
                    },
                    {
                        "id": 136476,
                        "name": "Caines",
                        "latitude": "46.69794000",
                        "longitude": "11.17122000"
                    },
                    {
                        "id": 136477,
                        "name": "Caines - Kuens",
                        "latitude": "46.70002000",
                        "longitude": "11.16987000"
                    },
                    {
                        "id": 136498,
                        "name": "Calavino",
                        "latitude": "46.04606000",
                        "longitude": "10.98402000"
                    },
                    {
                        "id": 136501,
                        "name": "Calceranica al Lago",
                        "latitude": "46.00460000",
                        "longitude": "11.24368000"
                    },
                    {
                        "id": 136511,
                        "name": "Caldaro sulla Strada del Vino",
                        "latitude": "46.41326000",
                        "longitude": "11.24616000"
                    },
                    {
                        "id": 136515,
                        "name": "Caldes",
                        "latitude": "46.36686000",
                        "longitude": "10.94037000"
                    },
                    {
                        "id": 136520,
                        "name": "Caldonazzo",
                        "latitude": "45.99367000",
                        "longitude": "11.26426000"
                    },
                    {
                        "id": 136533,
                        "name": "Calliano",
                        "latitude": "45.93299000",
                        "longitude": "11.09503000"
                    },
                    {
                        "id": 136624,
                        "name": "Campitello di Fassa",
                        "latitude": "46.47579000",
                        "longitude": "11.74110000"
                    },
                    {
                        "id": 136636,
                        "name": "Campo di Trens",
                        "latitude": "46.87412000",
                        "longitude": "11.48605000"
                    },
                    {
                        "id": 136633,
                        "name": "Campo Tures",
                        "latitude": "46.90844000",
                        "longitude": "11.96036000"
                    },
                    {
                        "id": 136645,
                        "name": "Campodenno",
                        "latitude": "46.25791000",
                        "longitude": "11.03317000"
                    },
                    {
                        "id": 136686,
                        "name": "Canal San Bovo",
                        "latitude": "46.15667000",
                        "longitude": "11.72998000"
                    },
                    {
                        "id": 136693,
                        "name": "Canazei",
                        "latitude": "46.47627000",
                        "longitude": "11.76929000"
                    },
                    {
                        "id": 136811,
                        "name": "Capriana",
                        "latitude": "46.26281000",
                        "longitude": "11.33801000"
                    },
                    {
                        "id": 136833,
                        "name": "Carano",
                        "latitude": "46.29151000",
                        "longitude": "11.43978000"
                    },
                    {
                        "id": 136857,
                        "name": "Cardano",
                        "latitude": "46.49336000",
                        "longitude": "11.39295000"
                    },
                    {
                        "id": 136883,
                        "name": "Carisolo",
                        "latitude": "46.16880000",
                        "longitude": "10.75887000"
                    },
                    {
                        "id": 136948,
                        "name": "Carzano",
                        "latitude": "46.07091000",
                        "longitude": "11.49379000"
                    },
                    {
                        "id": 137135,
                        "name": "Castel Condino",
                        "latitude": "45.91439000",
                        "longitude": "10.60277000"
                    },
                    {
                        "id": 137179,
                        "name": "Castelbello",
                        "latitude": "46.62885000",
                        "longitude": "10.90719000"
                    },
                    {
                        "id": 137180,
                        "name": "Castelbello-Ciardes - Kastelbell-Tschars",
                        "latitude": "46.62832000",
                        "longitude": "10.90666000"
                    },
                    {
                        "id": 137194,
                        "name": "Castelfondo",
                        "latitude": "46.45623000",
                        "longitude": "11.11785000"
                    },
                    {
                        "id": 137253,
                        "name": "Castello Molina di Fiemme",
                        "latitude": "46.28241000",
                        "longitude": "11.43348000"
                    },
                    {
                        "id": 137254,
                        "name": "Castello Tesino",
                        "latitude": "46.06302000",
                        "longitude": "11.63247000"
                    },
                    {
                        "id": 137281,
                        "name": "Castelnuovo",
                        "latitude": "46.05412000",
                        "longitude": "11.48916000"
                    },
                    {
                        "id": 137311,
                        "name": "Castelrotto",
                        "latitude": "46.56662000",
                        "longitude": "11.56098000"
                    },
                    {
                        "id": 137413,
                        "name": "Cavalese",
                        "latitude": "46.29048000",
                        "longitude": "11.45862000"
                    },
                    {
                        "id": 137421,
                        "name": "Cavareno",
                        "latitude": "46.40780000",
                        "longitude": "11.13934000"
                    },
                    {
                        "id": 137431,
                        "name": "Cavedago",
                        "latitude": "46.18486000",
                        "longitude": "11.03277000"
                    },
                    {
                        "id": 137432,
                        "name": "Cavedine",
                        "latitude": "45.99520000",
                        "longitude": "10.97358000"
                    },
                    {
                        "id": 137438,
                        "name": "Cavizzana",
                        "latitude": "46.36721000",
                        "longitude": "10.95817000"
                    },
                    {
                        "id": 137484,
                        "name": "Cembra",
                        "latitude": "46.17489000",
                        "longitude": "11.22174000"
                    },
                    {
                        "id": 137494,
                        "name": "Centa San Nicolò",
                        "latitude": "45.96930000",
                        "longitude": "11.23238000"
                    },
                    {
                        "id": 137502,
                        "name": "Centrale",
                        "latitude": "46.16118000",
                        "longitude": "11.30293000"
                    },
                    {
                        "id": 137554,
                        "name": "Cermes",
                        "latitude": "46.63277000",
                        "longitude": "11.14696000"
                    },
                    {
                        "id": 137579,
                        "name": "Certosa",
                        "latitude": "46.70450000",
                        "longitude": "10.91088000"
                    },
                    {
                        "id": 137662,
                        "name": "Chienes",
                        "latitude": "46.80680000",
                        "longitude": "11.84002000"
                    },
                    {
                        "id": 137686,
                        "name": "Chiusa",
                        "latitude": "46.64001000",
                        "longitude": "11.56573000"
                    },
                    {
                        "id": 137723,
                        "name": "Cimego",
                        "latitude": "45.91190000",
                        "longitude": "10.61337000"
                    },
                    {
                        "id": 137728,
                        "name": "Cimoneri",
                        "latitude": "45.98426000",
                        "longitude": "11.07155000"
                    },
                    {
                        "id": 137739,
                        "name": "Cinte Tesino",
                        "latitude": "46.05726000",
                        "longitude": "11.61435000"
                    },
                    {
                        "id": 137752,
                        "name": "Cis",
                        "latitude": "46.39841000",
                        "longitude": "11.00327000"
                    },
                    {
                        "id": 137780,
                        "name": "Civezzano",
                        "latitude": "46.09133000",
                        "longitude": "11.18468000"
                    },
                    {
                        "id": 137811,
                        "name": "Cles",
                        "latitude": "46.36294000",
                        "longitude": "11.03276000"
                    },
                    {
                        "id": 137815,
                        "name": "Cloz",
                        "latitude": "46.41620000",
                        "longitude": "11.08589000"
                    },
                    {
                        "id": 137844,
                        "name": "Cogolo",
                        "latitude": "46.35252000",
                        "longitude": "10.69282000"
                    },
                    {
                        "id": 137855,
                        "name": "Collalbo",
                        "latitude": "46.53988000",
                        "longitude": "11.45933000"
                    },
                    {
                        "id": 137861,
                        "name": "Colle Isarco",
                        "latitude": "46.93857000",
                        "longitude": "11.44245000"
                    },
                    {
                        "id": 137946,
                        "name": "Commezzadura",
                        "latitude": "46.32171000",
                        "longitude": "10.83957000"
                    },
                    {
                        "id": 137962,
                        "name": "Condino",
                        "latitude": "45.88167000",
                        "longitude": "10.59366000"
                    },
                    {
                        "id": 138004,
                        "name": "Coredo",
                        "latitude": "46.34906000",
                        "longitude": "11.09001000"
                    },
                    {
                        "id": 138023,
                        "name": "Cornaiano",
                        "latitude": "46.46329000",
                        "longitude": "11.28115000"
                    },
                    {
                        "id": 138028,
                        "name": "Cornedo All'Isarco",
                        "latitude": "46.48990000",
                        "longitude": "11.40647000"
                    },
                    {
                        "id": 138050,
                        "name": "Cortaccia sulla Strada del Vino",
                        "latitude": "46.31401000",
                        "longitude": "11.22388000"
                    },
                    {
                        "id": 138068,
                        "name": "Cortina sulla Strada del Vino",
                        "latitude": "46.26941000",
                        "longitude": "11.22188000"
                    },
                    {
                        "id": 138073,
                        "name": "Corvara in Badia",
                        "latitude": "46.55037000",
                        "longitude": "11.87342000"
                    },
                    {
                        "id": 138116,
                        "name": "Covelo",
                        "latitude": "45.97919000",
                        "longitude": "11.06971000"
                    },
                    {
                        "id": 138149,
                        "name": "Creto",
                        "latitude": "45.94110000",
                        "longitude": "10.64027000"
                    },
                    {
                        "id": 138173,
                        "name": "Croviana",
                        "latitude": "46.34480000",
                        "longitude": "10.90313000"
                    },
                    {
                        "id": 138192,
                        "name": "Cunevo",
                        "latitude": "46.28641000",
                        "longitude": "11.03457000"
                    },
                    {
                        "id": 138205,
                        "name": "Curon Venosta",
                        "latitude": "46.80832000",
                        "longitude": "10.54265000"
                    },
                    {
                        "id": 138223,
                        "name": "Daiano",
                        "latitude": "46.30161000",
                        "longitude": "11.44908000"
                    },
                    {
                        "id": 138226,
                        "name": "Dambel",
                        "latitude": "46.40471000",
                        "longitude": "11.09307000"
                    },
                    {
                        "id": 138228,
                        "name": "Daone",
                        "latitude": "45.94720000",
                        "longitude": "10.62107000"
                    },
                    {
                        "id": 138248,
                        "name": "Denno",
                        "latitude": "46.27424000",
                        "longitude": "11.04913000"
                    },
                    {
                        "id": 138267,
                        "name": "Dimaro",
                        "latitude": "46.32573000",
                        "longitude": "10.87342000"
                    },
                    {
                        "id": 138273,
                        "name": "Dobbiaco",
                        "latitude": "46.72878000",
                        "longitude": "12.22225000"
                    },
                    {
                        "id": 138295,
                        "name": "Don",
                        "latitude": "46.38931000",
                        "longitude": "11.13647000"
                    },
                    {
                        "id": 138311,
                        "name": "Dorsino",
                        "latitude": "46.07270000",
                        "longitude": "10.89737000"
                    },
                    {
                        "id": 138328,
                        "name": "Drena",
                        "latitude": "45.96926000",
                        "longitude": "10.94540000"
                    },
                    {
                        "id": 138331,
                        "name": "Dro",
                        "latitude": "45.96121000",
                        "longitude": "10.91201000"
                    },
                    {
                        "id": 138350,
                        "name": "Egna",
                        "latitude": "46.31777000",
                        "longitude": "11.27337000"
                    },
                    {
                        "id": 138400,
                        "name": "Faedo",
                        "latitude": "46.19241000",
                        "longitude": "11.16128000"
                    },
                    {
                        "id": 138410,
                        "name": "Fai della Paganella",
                        "latitude": "46.17801000",
                        "longitude": "11.06950000"
                    },
                    {
                        "id": 138426,
                        "name": "Falzes",
                        "latitude": "46.81359000",
                        "longitude": "11.88308000"
                    },
                    {
                        "id": 138461,
                        "name": "Faver",
                        "latitude": "46.18131000",
                        "longitude": "11.23728000"
                    },
                    {
                        "id": 138502,
                        "name": "Fiavè",
                        "latitude": "46.00457000",
                        "longitude": "10.84225000"
                    },
                    {
                        "id": 138558,
                        "name": "Fiè Allo Sciliar",
                        "latitude": "46.51672000",
                        "longitude": "11.50128000"
                    },
                    {
                        "id": 138508,
                        "name": "Fiera di Primiero",
                        "latitude": "46.17621000",
                        "longitude": "11.82879000"
                    },
                    {
                        "id": 138509,
                        "name": "Fierozzo",
                        "latitude": "46.11131000",
                        "longitude": "11.31848000"
                    },
                    {
                        "id": 138560,
                        "name": "Flavon",
                        "latitude": "46.29809000",
                        "longitude": "11.02993000"
                    },
                    {
                        "id": 138580,
                        "name": "Folgaria",
                        "latitude": "45.91543000",
                        "longitude": "11.16820000"
                    },
                    {
                        "id": 138589,
                        "name": "Fondo",
                        "latitude": "46.43880000",
                        "longitude": "11.13723000"
                    },
                    {
                        "id": 138592,
                        "name": "Fontana Nuova-Bevia",
                        "latitude": "46.41159000",
                        "longitude": "10.96843000"
                    },
                    {
                        "id": 138643,
                        "name": "Fornace",
                        "latitude": "46.11805000",
                        "longitude": "11.20751000"
                    },
                    {
                        "id": 138662,
                        "name": "Fortezza",
                        "latitude": "46.78963000",
                        "longitude": "11.60998000"
                    },
                    {
                        "id": 138710,
                        "name": "Frassilongo",
                        "latitude": "46.08991000",
                        "longitude": "11.29718000"
                    },
                    {
                        "id": 138725,
                        "name": "Fraviano",
                        "latitude": "46.29691000",
                        "longitude": "10.69197000"
                    },
                    {
                        "id": 138751,
                        "name": "Funes - Villnoess",
                        "latitude": "46.64282000",
                        "longitude": "11.67828000"
                    },
                    {
                        "id": 138793,
                        "name": "Gais",
                        "latitude": "46.83658000",
                        "longitude": "11.94931000"
                    },
                    {
                        "id": 138836,
                        "name": "Ganda",
                        "latitude": "46.55459000",
                        "longitude": "10.78042000"
                    },
                    {
                        "id": 138855,
                        "name": "Gargazzone",
                        "latitude": "46.58456000",
                        "longitude": "11.20156000"
                    },
                    {
                        "id": 138861,
                        "name": "Garniga Nuova",
                        "latitude": "46.00310000",
                        "longitude": "11.08738000"
                    },
                    {
                        "id": 138974,
                        "name": "Gionghi-Cappella",
                        "latitude": "45.93680000",
                        "longitude": "11.27478000"
                    },
                    {
                        "id": 138980,
                        "name": "Giovo",
                        "latitude": "46.15581000",
                        "longitude": "11.15278000"
                    },
                    {
                        "id": 139000,
                        "name": "Giustino",
                        "latitude": "46.15130000",
                        "longitude": "10.76777000"
                    },
                    {
                        "id": 139005,
                        "name": "Glorenza",
                        "latitude": "46.67105000",
                        "longitude": "10.55684000"
                    },
                    {
                        "id": 139077,
                        "name": "Grauno",
                        "latitude": "46.23032000",
                        "longitude": "11.29847000"
                    },
                    {
                        "id": 139100,
                        "name": "Grigno",
                        "latitude": "46.01569000",
                        "longitude": "11.63563000"
                    },
                    {
                        "id": 139138,
                        "name": "Grumes",
                        "latitude": "46.22117000",
                        "longitude": "11.29346000"
                    },
                    {
                        "id": 139198,
                        "name": "Imer",
                        "latitude": "46.14931000",
                        "longitude": "11.78919000"
                    },
                    {
                        "id": 139232,
                        "name": "Isera",
                        "latitude": "45.88760000",
                        "longitude": "11.00918000"
                    },
                    {
                        "id": 139307,
                        "name": "La Valle - Wengen",
                        "latitude": "46.65763000",
                        "longitude": "11.92399000"
                    },
                    {
                        "id": 139315,
                        "name": "Laces",
                        "latitude": "46.61641000",
                        "longitude": "10.85726000"
                    },
                    {
                        "id": 139321,
                        "name": "Laghetti",
                        "latitude": "46.27473000",
                        "longitude": "11.24011000"
                    },
                    {
                        "id": 139329,
                        "name": "Lagundo",
                        "latitude": "46.68113000",
                        "longitude": "11.12572000"
                    },
                    {
                        "id": 139335,
                        "name": "Laion",
                        "latitude": "46.60809000",
                        "longitude": "11.56559000"
                    },
                    {
                        "id": 139336,
                        "name": "Laives",
                        "latitude": "46.42679000",
                        "longitude": "11.33841000"
                    },
                    {
                        "id": 139352,
                        "name": "Lana",
                        "latitude": "46.61209000",
                        "longitude": "11.15653000"
                    },
                    {
                        "id": 139371,
                        "name": "Lardaro",
                        "latitude": "45.96946000",
                        "longitude": "10.66126000"
                    },
                    {
                        "id": 139378,
                        "name": "Lasa",
                        "latitude": "46.61783000",
                        "longitude": "10.69777000"
                    },
                    {
                        "id": 139380,
                        "name": "Lases",
                        "latitude": "46.14560000",
                        "longitude": "11.21932000"
                    },
                    {
                        "id": 139381,
                        "name": "Lasino",
                        "latitude": "46.02420000",
                        "longitude": "10.98357000"
                    },
                    {
                        "id": 139399,
                        "name": "Lauregno",
                        "latitude": "46.45431000",
                        "longitude": "11.06177000"
                    },
                    {
                        "id": 139418,
                        "name": "Lavis",
                        "latitude": "46.14131000",
                        "longitude": "11.10931000"
                    },
                    {
                        "id": 139455,
                        "name": "Leone-Santa Elisabetta",
                        "latitude": "46.73166000",
                        "longitude": "11.64944000"
                    },
                    {
                        "id": 139488,
                        "name": "Levico Terme",
                        "latitude": "46.01217000",
                        "longitude": "11.30427000"
                    },
                    {
                        "id": 139541,
                        "name": "Lisignago",
                        "latitude": "46.16061000",
                        "longitude": "11.18768000"
                    },
                    {
                        "id": 139549,
                        "name": "Livo",
                        "latitude": "46.40471000",
                        "longitude": "11.01927000"
                    },
                    {
                        "id": 139573,
                        "name": "Lodrone-Darzo",
                        "latitude": "45.82962000",
                        "longitude": "10.53560000"
                    },
                    {
                        "id": 139583,
                        "name": "Lona-Lases",
                        "latitude": "46.14421000",
                        "longitude": "11.21958000"
                    },
                    {
                        "id": 139671,
                        "name": "Luserna",
                        "latitude": "45.92260000",
                        "longitude": "11.32289000"
                    },
                    {
                        "id": 139678,
                        "name": "Luson - Luesen",
                        "latitude": "46.74623000",
                        "longitude": "11.76098000"
                    },
                    {
                        "id": 139712,
                        "name": "Madrano-Canzolino",
                        "latitude": "46.08440000",
                        "longitude": "11.21736000"
                    },
                    {
                        "id": 139743,
                        "name": "Magrè sulla Strada del Vino",
                        "latitude": "46.28791000",
                        "longitude": "11.21068000"
                    },
                    {
                        "id": 139779,
                        "name": "Malè",
                        "latitude": "46.35356000",
                        "longitude": "10.91246000"
                    },
                    {
                        "id": 139769,
                        "name": "Malles Venosta",
                        "latitude": "46.68791000",
                        "longitude": "10.54655000"
                    },
                    {
                        "id": 139774,
                        "name": "Malosco",
                        "latitude": "46.43611000",
                        "longitude": "11.14627000"
                    },
                    {
                        "id": 139852,
                        "name": "Marco",
                        "latitude": "45.84258000",
                        "longitude": "11.00925000"
                    },
                    {
                        "id": 139903,
                        "name": "Marlengo",
                        "latitude": "46.65262000",
                        "longitude": "11.14546000"
                    },
                    {
                        "id": 139987,
                        "name": "Massimeno",
                        "latitude": "46.14070000",
                        "longitude": "10.77317000"
                    },
                    {
                        "id": 139999,
                        "name": "Mattarello",
                        "latitude": "46.00865000",
                        "longitude": "11.12984000"
                    },
                    {
                        "id": 140011,
                        "name": "Mazzin",
                        "latitude": "46.45742000",
                        "longitude": "11.70018000"
                    },
                    {
                        "id": 140015,
                        "name": "Meano",
                        "latitude": "46.12457000",
                        "longitude": "11.11761000"
                    },
                    {
                        "id": 140031,
                        "name": "Meiern",
                        "latitude": "46.56503000",
                        "longitude": "10.78270000"
                    },
                    {
                        "id": 140057,
                        "name": "Meltina",
                        "latitude": "46.58744000",
                        "longitude": "11.25487000"
                    },
                    {
                        "id": 140068,
                        "name": "Merano",
                        "latitude": "46.66817000",
                        "longitude": "11.15953000"
                    },
                    {
                        "id": 140105,
                        "name": "Mezzana",
                        "latitude": "46.31671000",
                        "longitude": "10.80007000"
                    },
                    {
                        "id": 140113,
                        "name": "Mezzano",
                        "latitude": "46.15393000",
                        "longitude": "11.80876000"
                    },
                    {
                        "id": 140118,
                        "name": "Mezzocorona",
                        "latitude": "46.21159000",
                        "longitude": "11.12253000"
                    },
                    {
                        "id": 140123,
                        "name": "Mezzolombardo",
                        "latitude": "46.20774000",
                        "longitude": "11.09636000"
                    },
                    {
                        "id": 140165,
                        "name": "Miola di Pinè",
                        "latitude": "46.12668000",
                        "longitude": "11.24850000"
                    },
                    {
                        "id": 140193,
                        "name": "Moena",
                        "latitude": "46.37655000",
                        "longitude": "11.65941000"
                    },
                    {
                        "id": 140215,
                        "name": "Molina di Ledro",
                        "latitude": "45.87095000",
                        "longitude": "10.77408000"
                    },
                    {
                        "id": 140233,
                        "name": "Molveno",
                        "latitude": "46.14238000",
                        "longitude": "10.96300000"
                    },
                    {
                        "id": 140268,
                        "name": "Monclassico",
                        "latitude": "46.33410000",
                        "longitude": "10.88604000"
                    },
                    {
                        "id": 140291,
                        "name": "Monguelfo",
                        "latitude": "46.75774000",
                        "longitude": "12.10556000"
                    },
                    {
                        "id": 140308,
                        "name": "Montagna",
                        "latitude": "46.33033000",
                        "longitude": "11.30027000"
                    },
                    {
                        "id": 140312,
                        "name": "Montagne",
                        "latitude": "46.05850000",
                        "longitude": "10.75127000"
                    },
                    {
                        "id": 140615,
                        "name": "Mori",
                        "latitude": "45.85187000",
                        "longitude": "10.98052000"
                    },
                    {
                        "id": 140644,
                        "name": "Moscheri",
                        "latitude": "45.86875000",
                        "longitude": "11.07383000"
                    },
                    {
                        "id": 140649,
                        "name": "Moso in Passiria",
                        "latitude": "46.83154000",
                        "longitude": "11.16708000"
                    },
                    {
                        "id": 140709,
                        "name": "Mühlen in Taufers",
                        "latitude": "46.89926000",
                        "longitude": "11.94317000"
                    },
                    {
                        "id": 140710,
                        "name": "Nago-Torbole",
                        "latitude": "45.87594000",
                        "longitude": "10.89106000"
                    },
                    {
                        "id": 140711,
                        "name": "Nalles",
                        "latitude": "46.54341000",
                        "longitude": "11.20625000"
                    },
                    {
                        "id": 140712,
                        "name": "Nanno",
                        "latitude": "46.31481000",
                        "longitude": "11.04747000"
                    },
                    {
                        "id": 140726,
                        "name": "Naturno",
                        "latitude": "46.64801000",
                        "longitude": "11.00129000"
                    },
                    {
                        "id": 140729,
                        "name": "Nave San Rocco",
                        "latitude": "46.16771000",
                        "longitude": "11.10508000"
                    },
                    {
                        "id": 140732,
                        "name": "Naz-Sciaves - Natz-Schabs",
                        "latitude": "46.76883000",
                        "longitude": "11.66558000"
                    },
                    {
                        "id": 140792,
                        "name": "Nogaredo",
                        "latitude": "45.91300000",
                        "longitude": "11.02388000"
                    },
                    {
                        "id": 140801,
                        "name": "Nomi",
                        "latitude": "45.92923000",
                        "longitude": "11.07198000"
                    },
                    {
                        "id": 140813,
                        "name": "Nova Levante",
                        "latitude": "46.42899000",
                        "longitude": "11.53942000"
                    },
                    {
                        "id": 140815,
                        "name": "Nova Ponente",
                        "latitude": "46.41404000",
                        "longitude": "11.42523000"
                    },
                    {
                        "id": 140820,
                        "name": "Novaledo",
                        "latitude": "46.02340000",
                        "longitude": "11.36607000"
                    },
                    {
                        "id": 140936,
                        "name": "Ora",
                        "latitude": "46.34687000",
                        "longitude": "11.29747000"
                    },
                    {
                        "id": 140986,
                        "name": "Ortisei",
                        "latitude": "46.57603000",
                        "longitude": "11.67176000"
                    },
                    {
                        "id": 141015,
                        "name": "Ospedaletto",
                        "latitude": "46.04286000",
                        "longitude": "11.55439000"
                    },
                    {
                        "id": 141025,
                        "name": "Ossana",
                        "latitude": "46.30651000",
                        "longitude": "10.73757000"
                    },
                    {
                        "id": 141074,
                        "name": "Padergnone",
                        "latitude": "46.05982000",
                        "longitude": "10.98478000"
                    },
                    {
                        "id": 58271,
                        "name": "Palù del Fersina",
                        "latitude": "46.12951000",
                        "longitude": "11.35088000"
                    },
                    {
                        "id": 58275,
                        "name": "Panchià",
                        "latitude": "46.28648000",
                        "longitude": "11.54061000"
                    },
                    {
                        "id": 58298,
                        "name": "Parcines",
                        "latitude": "46.68422000",
                        "longitude": "11.07337000"
                    },
                    {
                        "id": 58397,
                        "name": "Pellizzano",
                        "latitude": "46.30980000",
                        "longitude": "10.75790000"
                    },
                    {
                        "id": 58398,
                        "name": "Pelugo",
                        "latitude": "46.08850000",
                        "longitude": "10.72387000"
                    },
                    {
                        "id": 58413,
                        "name": "Perca",
                        "latitude": "46.79343000",
                        "longitude": "11.98339000"
                    },
                    {
                        "id": 58423,
                        "name": "Pergine Valsugana",
                        "latitude": "46.06434000",
                        "longitude": "11.23758000"
                    },
                    {
                        "id": 58563,
                        "name": "Piazza",
                        "latitude": "45.87705000",
                        "longitude": "11.15809000"
                    },
                    {
                        "id": 58618,
                        "name": "Pietramurata",
                        "latitude": "46.02033000",
                        "longitude": "10.94316000"
                    },
                    {
                        "id": 58648,
                        "name": "Pieve di Bono",
                        "latitude": "45.94220000",
                        "longitude": "10.64027000"
                    },
                    {
                        "id": 58652,
                        "name": "Pieve di Ledro",
                        "latitude": "45.88848000",
                        "longitude": "10.73124000"
                    },
                    {
                        "id": 58640,
                        "name": "Pieve Tesino",
                        "latitude": "46.06820000",
                        "longitude": "11.61122000"
                    },
                    {
                        "id": 58676,
                        "name": "Pineta",
                        "latitude": "46.43994000",
                        "longitude": "11.34727000"
                    },
                    {
                        "id": 58683,
                        "name": "Pinzolo",
                        "latitude": "46.15976000",
                        "longitude": "10.76376000"
                    },
                    {
                        "id": 58736,
                        "name": "Plaus",
                        "latitude": "46.65623000",
                        "longitude": "11.04178000"
                    },
                    {
                        "id": 58812,
                        "name": "Pomarolo",
                        "latitude": "45.92810000",
                        "longitude": "11.04308000"
                    },
                    {
                        "id": 58835,
                        "name": "Ponte Arche",
                        "latitude": "46.03526000",
                        "longitude": "10.87320000"
                    },
                    {
                        "id": 58841,
                        "name": "Ponte Gardena",
                        "latitude": "46.59712000",
                        "longitude": "11.53088000"
                    },
                    {
                        "id": 58960,
                        "name": "Postal",
                        "latitude": "46.60949000",
                        "longitude": "11.19313000"
                    },
                    {
                        "id": 58971,
                        "name": "Povo",
                        "latitude": "46.06698000",
                        "longitude": "11.15503000"
                    },
                    {
                        "id": 58974,
                        "name": "Pozza di Fassa",
                        "latitude": "46.42806000",
                        "longitude": "11.68711000"
                    },
                    {
                        "id": 59011,
                        "name": "Praso",
                        "latitude": "45.95000000",
                        "longitude": "10.63627000"
                    },
                    {
                        "id": 59020,
                        "name": "Prati",
                        "latitude": "46.90003000",
                        "longitude": "11.46507000"
                    },
                    {
                        "id": 59028,
                        "name": "Prato Allo Stelvio",
                        "latitude": "46.61901000",
                        "longitude": "10.59136000"
                    },
                    {
                        "id": 59044,
                        "name": "Predazzo",
                        "latitude": "46.31140000",
                        "longitude": "11.59960000"
                    },
                    {
                        "id": 59045,
                        "name": "Predoi",
                        "latitude": "47.04031000",
                        "longitude": "12.10663000"
                    },
                    {
                        "id": 59061,
                        "name": "Preore",
                        "latitude": "46.04663000",
                        "longitude": "10.75969000"
                    },
                    {
                        "id": 59073,
                        "name": "Prezzo",
                        "latitude": "45.93470000",
                        "longitude": "10.63297000"
                    },
                    {
                        "id": 59098,
                        "name": "Proves - Proveis",
                        "latitude": "46.47661000",
                        "longitude": "11.02247000"
                    },
                    {
                        "id": 59105,
                        "name": "Provincia autonoma di Trento",
                        "latitude": "46.06966000",
                        "longitude": "11.12177000"
                    },
                    {
                        "id": 59253,
                        "name": "Rabbi Fonti",
                        "latitude": "46.39886000",
                        "longitude": "10.84951000"
                    },
                    {
                        "id": 59254,
                        "name": "Rablà",
                        "latitude": "46.67044000",
                        "longitude": "11.06458000"
                    },
                    {
                        "id": 59259,
                        "name": "Racines",
                        "latitude": "46.86667000",
                        "longitude": "11.30000000"
                    },
                    {
                        "id": 59260,
                        "name": "Racines - Ratschings",
                        "latitude": "46.88183000",
                        "longitude": "11.37827000"
                    },
                    {
                        "id": 59268,
                        "name": "Ragoli",
                        "latitude": "46.05423000",
                        "longitude": "10.77855000"
                    },
                    {
                        "id": 59292,
                        "name": "Rasun Anterselva - Rasen-Antholz",
                        "latitude": "46.77853000",
                        "longitude": "12.04729000"
                    },
                    {
                        "id": 59301,
                        "name": "Ravina",
                        "latitude": "46.03944000",
                        "longitude": "11.11215000"
                    },
                    {
                        "id": 59333,
                        "name": "Renon - Ritten",
                        "latitude": "46.54152000",
                        "longitude": "11.45728000"
                    },
                    {
                        "id": 59345,
                        "name": "Revò",
                        "latitude": "46.39226000",
                        "longitude": "11.05808000"
                    },
                    {
                        "id": 59371,
                        "name": "Ried",
                        "latitude": "46.92993000",
                        "longitude": "11.52414000"
                    },
                    {
                        "id": 59375,
                        "name": "Rifiano",
                        "latitude": "46.70287000",
                        "longitude": "11.18057000"
                    },
                    {
                        "id": 59389,
                        "name": "Rio di Pusteria",
                        "latitude": "46.79658000",
                        "longitude": "11.66754000"
                    },
                    {
                        "id": 59413,
                        "name": "Riscone",
                        "latitude": "46.77685000",
                        "longitude": "11.95149000"
                    },
                    {
                        "id": 59419,
                        "name": "Riva del Garda",
                        "latitude": "45.88577000",
                        "longitude": "10.84117000"
                    },
                    {
                        "id": 59549,
                        "name": "Rodengo",
                        "latitude": "46.80000000",
                        "longitude": "11.70000000"
                    },
                    {
                        "id": 59550,
                        "name": "Rodengo - Rodeneck",
                        "latitude": "46.77953000",
                        "longitude": "11.69048000"
                    },
                    {
                        "id": 59570,
                        "name": "Romagnano",
                        "latitude": "46.01807000",
                        "longitude": "11.10563000"
                    },
                    {
                        "id": 59573,
                        "name": "Romallo",
                        "latitude": "46.39721000",
                        "longitude": "11.06617000"
                    },
                    {
                        "id": 59583,
                        "name": "Romeno",
                        "latitude": "46.39452000",
                        "longitude": "11.11920000"
                    },
                    {
                        "id": 59593,
                        "name": "Roncegno",
                        "latitude": "46.04934000",
                        "longitude": "11.40824000"
                    },
                    {
                        "id": 59595,
                        "name": "Ronchi Valsugana",
                        "latitude": "46.06841000",
                        "longitude": "11.43519000"
                    },
                    {
                        "id": 59612,
                        "name": "Roncone",
                        "latitude": "45.98270000",
                        "longitude": "10.66817000"
                    },
                    {
                        "id": 59618,
                        "name": "Ronzo-Chienis",
                        "latitude": "45.88960000",
                        "longitude": "10.95008000"
                    },
                    {
                        "id": 59619,
                        "name": "Ronzone",
                        "latitude": "46.42437000",
                        "longitude": "11.15275000"
                    },
                    {
                        "id": 59681,
                        "name": "Roverè della Luna",
                        "latitude": "46.25008000",
                        "longitude": "11.17233000"
                    },
                    {
                        "id": 59679,
                        "name": "Rovereto",
                        "latitude": "45.89040000",
                        "longitude": "11.04053000"
                    },
                    {
                        "id": 59698,
                        "name": "Ruffrè",
                        "latitude": "46.41481000",
                        "longitude": "11.17777000"
                    },
                    {
                        "id": 59702,
                        "name": "Rumo",
                        "latitude": "46.44141000",
                        "longitude": "11.01857000"
                    },
                    {
                        "id": 59714,
                        "name": "Sabbionara",
                        "latitude": "45.74152000",
                        "longitude": "10.95740000"
                    },
                    {
                        "id": 59726,
                        "name": "Sagron Mis",
                        "latitude": "46.19471000",
                        "longitude": "11.94320000"
                    },
                    {
                        "id": 59779,
                        "name": "Salorno",
                        "latitude": "46.24062000",
                        "longitude": "11.21192000"
                    },
                    {
                        "id": 59814,
                        "name": "Samone",
                        "latitude": "46.08161000",
                        "longitude": "11.52259000"
                    },
                    {
                        "id": 59836,
                        "name": "San Bernardo",
                        "latitude": "46.40088000",
                        "longitude": "10.84445000"
                    },
                    {
                        "id": 59851,
                        "name": "San Candido",
                        "latitude": "46.73240000",
                        "longitude": "12.27855000"
                    },
                    {
                        "id": 59907,
                        "name": "San Felice",
                        "latitude": "46.49429000",
                        "longitude": "11.13022000"
                    },
                    {
                        "id": 59932,
                        "name": "San Genesio",
                        "latitude": "46.65800000",
                        "longitude": "11.92456000"
                    },
                    {
                        "id": 59933,
                        "name": "San Genesio Atesino",
                        "latitude": "46.53460000",
                        "longitude": "11.32971000"
                    },
                    {
                        "id": 59943,
                        "name": "San Giacomo",
                        "latitude": "46.45624000",
                        "longitude": "11.33365000"
                    },
                    {
                        "id": 60031,
                        "name": "San Leonardo in Passiria",
                        "latitude": "46.81282000",
                        "longitude": "11.24577000"
                    },
                    {
                        "id": 60047,
                        "name": "San Lorenzo di Sebato",
                        "latitude": "46.78514000",
                        "longitude": "11.90812000"
                    },
                    {
                        "id": 60048,
                        "name": "San Lorenzo in Banale",
                        "latitude": "46.07660000",
                        "longitude": "10.90847000"
                    },
                    {
                        "id": 60069,
                        "name": "San Martino",
                        "latitude": "46.81097000",
                        "longitude": "12.22684000"
                    },
                    {
                        "id": 60089,
                        "name": "San Martino in Badia",
                        "latitude": "46.68153000",
                        "longitude": "11.89809000"
                    },
                    {
                        "id": 60092,
                        "name": "San Martino in Passiria",
                        "latitude": "46.78392000",
                        "longitude": "11.22727000"
                    },
                    {
                        "id": 60114,
                        "name": "San Michele",
                        "latitude": "46.45472000",
                        "longitude": "11.26178000"
                    },
                    {
                        "id": 60117,
                        "name": "San Michele All'Adige",
                        "latitude": "46.18967000",
                        "longitude": "11.13212000"
                    },
                    {
                        "id": 60151,
                        "name": "San Pancrazio",
                        "latitude": "46.58600000",
                        "longitude": "11.08571000"
                    },
                    {
                        "id": 60155,
                        "name": "San Paolo",
                        "latitude": "46.47207000",
                        "longitude": "11.26021000"
                    },
                    {
                        "id": 60170,
                        "name": "San Pietro",
                        "latitude": "46.64133000",
                        "longitude": "11.68277000"
                    },
                    {
                        "id": 60266,
                        "name": "San Vigilio",
                        "latitude": "46.69884000",
                        "longitude": "11.93104000"
                    },
                    {
                        "id": 60411,
                        "name": "Sant'Orsola",
                        "latitude": "46.10901000",
                        "longitude": "11.30201000"
                    },
                    {
                        "id": 60412,
                        "name": "Sant'Orsola Terme",
                        "latitude": "46.10881000",
                        "longitude": "11.30238000"
                    },
                    {
                        "id": 60423,
                        "name": "Santa Cristina Valgardena",
                        "latitude": "46.56299000",
                        "longitude": "11.73216000"
                    },
                    {
                        "id": 60497,
                        "name": "Santa Valburga",
                        "latitude": "46.55000000",
                        "longitude": "11.00000000"
                    },
                    {
                        "id": 60533,
                        "name": "Sanzeno",
                        "latitude": "46.36614000",
                        "longitude": "11.07559000"
                    },
                    {
                        "id": 60546,
                        "name": "Sarentino",
                        "latitude": "46.64121000",
                        "longitude": "11.35411000"
                    },
                    {
                        "id": 60555,
                        "name": "Sarnonico",
                        "latitude": "46.41941000",
                        "longitude": "11.14177000"
                    },
                    {
                        "id": 60637,
                        "name": "Scena",
                        "latitude": "46.68840000",
                        "longitude": "11.18855000"
                    },
                    {
                        "id": 60638,
                        "name": "Scena - Schenna",
                        "latitude": "46.69012000",
                        "longitude": "11.18627000"
                    },
                    {
                        "id": 60652,
                        "name": "Sciaves",
                        "latitude": "46.76859000",
                        "longitude": "11.66607000"
                    },
                    {
                        "id": 60671,
                        "name": "Scurelle",
                        "latitude": "46.06451000",
                        "longitude": "11.50569000"
                    },
                    {
                        "id": 60690,
                        "name": "Segonzano",
                        "latitude": "46.19021000",
                        "longitude": "11.25988000"
                    },
                    {
                        "id": 60703,
                        "name": "Selva",
                        "latitude": "46.55472000",
                        "longitude": "11.76038000"
                    },
                    {
                        "id": 60705,
                        "name": "Selva dei Molini",
                        "latitude": "46.89031000",
                        "longitude": "11.85832000"
                    },
                    {
                        "id": 60719,
                        "name": "Senale",
                        "latitude": "46.51077000",
                        "longitude": "11.11012000"
                    },
                    {
                        "id": 60720,
                        "name": "Senales",
                        "latitude": "46.70602000",
                        "longitude": "10.90846000"
                    },
                    {
                        "id": 60794,
                        "name": "Sesto",
                        "latitude": "46.70216000",
                        "longitude": "12.34962000"
                    },
                    {
                        "id": 60830,
                        "name": "Sfruz",
                        "latitude": "46.33961000",
                        "longitude": "11.12377000"
                    },
                    {
                        "id": 60847,
                        "name": "Silandro",
                        "latitude": "46.62831000",
                        "longitude": "10.76809000"
                    },
                    {
                        "id": 60866,
                        "name": "Sinigo",
                        "latitude": "46.63488000",
                        "longitude": "11.17926000"
                    },
                    {
                        "id": 60877,
                        "name": "Siror",
                        "latitude": "46.18784000",
                        "longitude": "11.83116000"
                    },
                    {
                        "id": 60883,
                        "name": "Siusi",
                        "latitude": "46.54133000",
                        "longitude": "11.55868000"
                    },
                    {
                        "id": 60887,
                        "name": "Sluderno",
                        "latitude": "46.66524000",
                        "longitude": "10.58345000"
                    },
                    {
                        "id": 60888,
                        "name": "Smarano",
                        "latitude": "46.34311000",
                        "longitude": "11.10977000"
                    },
                    {
                        "id": 60942,
                        "name": "Soprabolzano",
                        "latitude": "46.52899000",
                        "longitude": "11.40408000"
                    },
                    {
                        "id": 60945,
                        "name": "Soraga",
                        "latitude": "46.39462000",
                        "longitude": "11.66619000"
                    },
                    {
                        "id": 60976,
                        "name": "Sover",
                        "latitude": "46.22171000",
                        "longitude": "11.31568000"
                    },
                    {
                        "id": 60996,
                        "name": "Spera",
                        "latitude": "46.07031000",
                        "longitude": "11.50899000"
                    },
                    {
                        "id": 61005,
                        "name": "Spiazzo",
                        "latitude": "46.10360000",
                        "longitude": "10.73937000"
                    },
                    {
                        "id": 61029,
                        "name": "Spormaggiore",
                        "latitude": "46.21853000",
                        "longitude": "11.04805000"
                    },
                    {
                        "id": 61030,
                        "name": "Sporminore",
                        "latitude": "46.23692000",
                        "longitude": "11.02919000"
                    },
                    {
                        "id": 61045,
                        "name": "Stanghe",
                        "latitude": "46.88219000",
                        "longitude": "11.37764000"
                    },
                    {
                        "id": 61065,
                        "name": "Stelvio",
                        "latitude": "46.59767000",
                        "longitude": "10.54580000"
                    },
                    {
                        "id": 61066,
                        "name": "Stenico",
                        "latitude": "46.05124000",
                        "longitude": "10.85562000"
                    },
                    {
                        "id": 61081,
                        "name": "Storo",
                        "latitude": "45.84925000",
                        "longitude": "10.58022000"
                    },
                    {
                        "id": 61092,
                        "name": "Strembo",
                        "latitude": "46.12030000",
                        "longitude": "10.75087000"
                    },
                    {
                        "id": 61097,
                        "name": "Strigno",
                        "latitude": "46.06690000",
                        "longitude": "11.52224000"
                    },
                    {
                        "id": 61149,
                        "name": "Taio",
                        "latitude": "46.32139000",
                        "longitude": "11.06624000"
                    },
                    {
                        "id": 61173,
                        "name": "Tassullo",
                        "latitude": "46.34298000",
                        "longitude": "11.04539000"
                    },
                    {
                        "id": 61208,
                        "name": "Telve",
                        "latitude": "46.07011000",
                        "longitude": "11.48022000"
                    },
                    {
                        "id": 61209,
                        "name": "Telve di Sopra",
                        "latitude": "46.07131000",
                        "longitude": "11.47179000"
                    },
                    {
                        "id": 61213,
                        "name": "Tenna",
                        "latitude": "46.01570000",
                        "longitude": "11.26428000"
                    },
                    {
                        "id": 61214,
                        "name": "Tenno",
                        "latitude": "45.91937000",
                        "longitude": "10.83160000"
                    },
                    {
                        "id": 61220,
                        "name": "Terento",
                        "latitude": "46.82992000",
                        "longitude": "11.78288000"
                    },
                    {
                        "id": 61223,
                        "name": "Terlago",
                        "latitude": "46.09737000",
                        "longitude": "11.04505000"
                    },
                    {
                        "id": 61224,
                        "name": "Terlano",
                        "latitude": "46.53216000",
                        "longitude": "11.24689000"
                    },
                    {
                        "id": 61227,
                        "name": "Termeno",
                        "latitude": "46.34151000",
                        "longitude": "11.24228000"
                    },
                    {
                        "id": 61237,
                        "name": "Terragnolo",
                        "latitude": "45.87830000",
                        "longitude": "11.15468000"
                    },
                    {
                        "id": 61250,
                        "name": "Terres",
                        "latitude": "46.30991000",
                        "longitude": "11.02307000"
                    },
                    {
                        "id": 61258,
                        "name": "Terzolas",
                        "latitude": "46.36111000",
                        "longitude": "10.92587000"
                    },
                    {
                        "id": 61260,
                        "name": "Tesero",
                        "latitude": "46.29184000",
                        "longitude": "11.50946000"
                    },
                    {
                        "id": 61261,
                        "name": "Tesimo",
                        "latitude": "46.56542000",
                        "longitude": "11.16937000"
                    },
                    {
                        "id": 61281,
                        "name": "Tione di Trento",
                        "latitude": "46.03550000",
                        "longitude": "10.72679000"
                    },
                    {
                        "id": 61283,
                        "name": "Tires",
                        "latitude": "46.46817000",
                        "longitude": "11.52704000"
                    },
                    {
                        "id": 61285,
                        "name": "Tirolo",
                        "latitude": "46.69102000",
                        "longitude": "11.15427000"
                    },
                    {
                        "id": 61306,
                        "name": "Tonadico",
                        "latitude": "46.18111000",
                        "longitude": "11.83939000"
                    },
                    {
                        "id": 61319,
                        "name": "Torcegno",
                        "latitude": "46.07431000",
                        "longitude": "11.44979000"
                    },
                    {
                        "id": 61431,
                        "name": "Trambileno",
                        "latitude": "45.86890000",
                        "longitude": "11.07338000"
                    },
                    {
                        "id": 61438,
                        "name": "Transacqua",
                        "latitude": "46.17367000",
                        "longitude": "11.83279000"
                    },
                    {
                        "id": 61483,
                        "name": "Trento",
                        "latitude": "46.06787000",
                        "longitude": "11.12108000"
                    },
                    {
                        "id": 61491,
                        "name": "Tres",
                        "latitude": "46.32179000",
                        "longitude": "11.09654000"
                    },
                    {
                        "id": 61546,
                        "name": "Trodena",
                        "latitude": "46.32181000",
                        "longitude": "11.34982000"
                    },
                    {
                        "id": 61560,
                        "name": "Tubre",
                        "latitude": "46.64403000",
                        "longitude": "10.46328000"
                    },
                    {
                        "id": 61561,
                        "name": "Tuenno",
                        "latitude": "46.32844000",
                        "longitude": "11.02306000"
                    },
                    {
                        "id": 61595,
                        "name": "Ultimo - Ulten",
                        "latitude": "46.54832000",
                        "longitude": "11.00417000"
                    },
                    {
                        "id": 61628,
                        "name": "Vadena",
                        "latitude": "46.41361000",
                        "longitude": "11.30498000"
                    },
                    {
                        "id": 61649,
                        "name": "Valda",
                        "latitude": "46.20721000",
                        "longitude": "11.26488000"
                    },
                    {
                        "id": 61651,
                        "name": "Valdaora di Mezzo",
                        "latitude": "46.76027000",
                        "longitude": "12.02951000"
                    },
                    {
                        "id": 61670,
                        "name": "Valfloriana",
                        "latitude": "46.24971000",
                        "longitude": "11.34308000"
                    },
                    {
                        "id": 61682,
                        "name": "Vallarsa",
                        "latitude": "45.78280000",
                        "longitude": "11.11788000"
                    },
                    {
                        "id": 61685,
                        "name": "Valle Aurina - Ahrntal",
                        "latitude": "46.99623000",
                        "longitude": "11.97988000"
                    },
                    {
                        "id": 61697,
                        "name": "Valle di Casies - Gsies",
                        "latitude": "46.76833000",
                        "longitude": "12.17939000"
                    },
                    {
                        "id": 61751,
                        "name": "Vandoies - Vintl",
                        "latitude": "46.81513000",
                        "longitude": "11.72068000"
                    },
                    {
                        "id": 61752,
                        "name": "Vandoies di Sotto",
                        "latitude": "46.81600000",
                        "longitude": "11.72183000"
                    },
                    {
                        "id": 61767,
                        "name": "Varena",
                        "latitude": "46.30671000",
                        "longitude": "11.45828000"
                    },
                    {
                        "id": 61773,
                        "name": "Varna",
                        "latitude": "46.73901000",
                        "longitude": "11.63749000"
                    },
                    {
                        "id": 61783,
                        "name": "Vattaro",
                        "latitude": "45.99388000",
                        "longitude": "11.21792000"
                    },
                    {
                        "id": 61807,
                        "name": "Velturno",
                        "latitude": "46.66705000",
                        "longitude": "11.59712000"
                    },
                    {
                        "id": 61831,
                        "name": "Verano",
                        "latitude": "46.60442000",
                        "longitude": "11.22565000"
                    },
                    {
                        "id": 61832,
                        "name": "Verano - Voeran",
                        "latitude": "46.60472000",
                        "longitude": "11.22607000"
                    },
                    {
                        "id": 61850,
                        "name": "Verla",
                        "latitude": "46.15793000",
                        "longitude": "11.15331000"
                    },
                    {
                        "id": 61852,
                        "name": "Vermiglio",
                        "latitude": "46.29691000",
                        "longitude": "10.69136000"
                    },
                    {
                        "id": 61876,
                        "name": "Vervò",
                        "latitude": "46.30989000",
                        "longitude": "11.11972000"
                    },
                    {
                        "id": 61894,
                        "name": "Vezzano",
                        "latitude": "46.07867000",
                        "longitude": "10.99735000"
                    },
                    {
                        "id": 61960,
                        "name": "Vignola",
                        "latitude": "46.04436000",
                        "longitude": "11.27738000"
                    },
                    {
                        "id": 61968,
                        "name": "Vigo di Fassa",
                        "latitude": "46.41898000",
                        "longitude": "11.67418000"
                    },
                    {
                        "id": 61969,
                        "name": "Vigo di Ton",
                        "latitude": "46.26531000",
                        "longitude": "11.08798000"
                    },
                    {
                        "id": 61972,
                        "name": "Vigolo Vattaro",
                        "latitude": "46.00523000",
                        "longitude": "11.19790000"
                    },
                    {
                        "id": 61983,
                        "name": "Villa",
                        "latitude": "46.74591000",
                        "longitude": "11.76243000"
                    },
                    {
                        "id": 62001,
                        "name": "Villa Lagarina",
                        "latitude": "45.91843000",
                        "longitude": "11.03303000"
                    },
                    {
                        "id": 62014,
                        "name": "Villa Rendena",
                        "latitude": "46.06270000",
                        "longitude": "10.71250000"
                    },
                    {
                        "id": 62043,
                        "name": "Villa-Agnedo",
                        "latitude": "46.05421000",
                        "longitude": "11.52839000"
                    },
                    {
                        "id": 62046,
                        "name": "Villabassa",
                        "latitude": "46.73781000",
                        "longitude": "12.17266000"
                    },
                    {
                        "id": 62087,
                        "name": "Villandro",
                        "latitude": "46.63086000",
                        "longitude": "11.53808000"
                    },
                    {
                        "id": 62088,
                        "name": "Villandro - Villanders",
                        "latitude": "46.63082000",
                        "longitude": "11.53708000"
                    },
                    {
                        "id": 62168,
                        "name": "Vipiteno",
                        "latitude": "46.89313000",
                        "longitude": "11.42961000"
                    },
                    {
                        "id": 62204,
                        "name": "Volano",
                        "latitude": "45.91718000",
                        "longitude": "11.06351000"
                    },
                    {
                        "id": 62232,
                        "name": "Zambana",
                        "latitude": "46.15170000",
                        "longitude": "11.09618000"
                    },
                    {
                        "id": 62258,
                        "name": "Ziano di Fiemme",
                        "latitude": "46.28572000",
                        "longitude": "11.56496000"
                    },
                    {
                        "id": 62280,
                        "name": "Zuclo",
                        "latitude": "46.03430000",
                        "longitude": "10.75107000"
                    }
                ]
            },
            {
                "id": 1762,
                "name": "Treviso",
                "iso2": "TV",
                "latitude": "45.66685170",
                "longitude": "12.24306170",
                "type": "province",
                "cities": []
            },
            {
                "id": 1763,
                "name": "Trieste",
                "iso2": "TS",
                "latitude": "45.68948230",
                "longitude": "13.78330720",
                "type": "decentralized regional entity",
                "cities": []
            },
            {
                "id": 1664,
                "name": "Tuscany",
                "iso2": "52",
                "latitude": "43.77105130",
                "longitude": "11.24862080",
                "type": "region",
                "cities": [
                    {
                        "id": 135238,
                        "name": "Abbadia San Salvatore",
                        "latitude": "42.88120000",
                        "longitude": "11.67220000"
                    },
                    {
                        "id": 135244,
                        "name": "Abetone",
                        "latitude": "44.14595000",
                        "longitude": "10.66407000"
                    },
                    {
                        "id": 135276,
                        "name": "Acquaviva",
                        "latitude": "43.11566000",
                        "longitude": "11.86249000"
                    },
                    {
                        "id": 135301,
                        "name": "Agliana",
                        "latitude": "43.90246000",
                        "longitude": "11.00531000"
                    },
                    {
                        "id": 135371,
                        "name": "Albiano Magra",
                        "latitude": "44.17574000",
                        "longitude": "9.91619000"
                    },
                    {
                        "id": 135378,
                        "name": "Albinia",
                        "latitude": "42.50278000",
                        "longitude": "11.21027000"
                    },
                    {
                        "id": 135446,
                        "name": "Altopascio",
                        "latitude": "43.81618000",
                        "longitude": "10.67668000"
                    },
                    {
                        "id": 135466,
                        "name": "Ambra",
                        "latitude": "43.41465000",
                        "longitude": "11.60291000"
                    },
                    {
                        "id": 135478,
                        "name": "Anchione",
                        "latitude": "43.82612000",
                        "longitude": "10.75844000"
                    },
                    {
                        "id": 135497,
                        "name": "Anghiari",
                        "latitude": "43.54104000",
                        "longitude": "12.05832000"
                    },
                    {
                        "id": 135513,
                        "name": "Antella",
                        "latitude": "43.72774000",
                        "longitude": "11.32233000"
                    },
                    {
                        "id": 135554,
                        "name": "Arbia",
                        "latitude": "43.29342000",
                        "longitude": "11.40978000"
                    },
                    {
                        "id": 135567,
                        "name": "Arcidosso",
                        "latitude": "42.87162000",
                        "longitude": "11.53599000"
                    },
                    {
                        "id": 135590,
                        "name": "Arezzo",
                        "latitude": "43.46276000",
                        "longitude": "11.88068000"
                    },
                    {
                        "id": 135654,
                        "name": "Asciano",
                        "latitude": "43.23232000",
                        "longitude": "11.56655000"
                    },
                    {
                        "id": 135687,
                        "name": "Aulla",
                        "latitude": "44.20632000",
                        "longitude": "9.97853000"
                    },
                    {
                        "id": 135696,
                        "name": "Avane",
                        "latitude": "43.79049000",
                        "longitude": "10.40982000"
                    },
                    {
                        "id": 135739,
                        "name": "Badia al Pino",
                        "latitude": "43.40424000",
                        "longitude": "11.77228000"
                    },
                    {
                        "id": 135738,
                        "name": "Badia Tedalda",
                        "latitude": "43.70887000",
                        "longitude": "12.18425000"
                    },
                    {
                        "id": 135757,
                        "name": "Bagni di Lucca",
                        "latitude": "44.00513000",
                        "longitude": "10.55310000"
                    },
                    {
                        "id": 135761,
                        "name": "Bagno a Ripoli",
                        "latitude": "43.75115000",
                        "longitude": "11.32252000"
                    },
                    {
                        "id": 135760,
                        "name": "Bagno Roselle",
                        "latitude": "42.81114000",
                        "longitude": "11.13859000"
                    },
                    {
                        "id": 135774,
                        "name": "Bagnone",
                        "latitude": "44.31494000",
                        "longitude": "9.99507000"
                    },
                    {
                        "id": 135817,
                        "name": "Barba",
                        "latitude": "43.88291000",
                        "longitude": "10.97608000"
                    },
                    {
                        "id": 135822,
                        "name": "Barbarasco",
                        "latitude": "44.24150000",
                        "longitude": "9.94571000"
                    },
                    {
                        "id": 135828,
                        "name": "Barberino di Mugello",
                        "latitude": "43.99930000",
                        "longitude": "11.23676000"
                    },
                    {
                        "id": 135827,
                        "name": "Barberino Val d'Elsa",
                        "latitude": "43.53987000",
                        "longitude": "11.17178000"
                    },
                    {
                        "id": 135848,
                        "name": "Barga",
                        "latitude": "44.07310000",
                        "longitude": "10.47789000"
                    },
                    {
                        "id": 135907,
                        "name": "Battifolle-Ruscello-Poggiola",
                        "latitude": "43.45000000",
                        "longitude": "11.80000000"
                    },
                    {
                        "id": 135941,
                        "name": "Bellavista",
                        "latitude": "43.44197000",
                        "longitude": "11.16051000"
                    },
                    {
                        "id": 135968,
                        "name": "Belverde",
                        "latitude": "43.34820000",
                        "longitude": "11.30763000"
                    },
                    {
                        "id": 136021,
                        "name": "Bettolle",
                        "latitude": "43.20676000",
                        "longitude": "11.80365000"
                    },
                    {
                        "id": 136039,
                        "name": "Bibbiena",
                        "latitude": "43.69876000",
                        "longitude": "11.81474000"
                    },
                    {
                        "id": 136040,
                        "name": "Bibbona",
                        "latitude": "43.26822000",
                        "longitude": "10.59510000"
                    },
                    {
                        "id": 136049,
                        "name": "Bientina",
                        "latitude": "43.70826000",
                        "longitude": "10.62116000"
                    },
                    {
                        "id": 136164,
                        "name": "Borghetto-Melara",
                        "latitude": "44.09852000",
                        "longitude": "9.99073000"
                    },
                    {
                        "id": 136197,
                        "name": "Borgo a Buggiano",
                        "latitude": "43.87522000",
                        "longitude": "10.73482000"
                    },
                    {
                        "id": 136198,
                        "name": "Borgo a Mozzano",
                        "latitude": "43.97946000",
                        "longitude": "10.54489000"
                    },
                    {
                        "id": 136184,
                        "name": "Borgo San Lorenzo",
                        "latitude": "43.95548000",
                        "longitude": "11.38561000"
                    },
                    {
                        "id": 136280,
                        "name": "Braccagni",
                        "latitude": "42.87285000",
                        "longitude": "11.07266000"
                    },
                    {
                        "id": 136389,
                        "name": "Bucine",
                        "latitude": "43.47685000",
                        "longitude": "11.61399000"
                    },
                    {
                        "id": 136407,
                        "name": "Buonconvento",
                        "latitude": "43.13314000",
                        "longitude": "11.48363000"
                    },
                    {
                        "id": 136437,
                        "name": "Buti",
                        "latitude": "43.72857000",
                        "longitude": "10.58450000"
                    },
                    {
                        "id": 136503,
                        "name": "Calci",
                        "latitude": "43.72597000",
                        "longitude": "10.51791000"
                    },
                    {
                        "id": 136505,
                        "name": "Calcinaia",
                        "latitude": "43.68352000",
                        "longitude": "10.61653000"
                    },
                    {
                        "id": 136518,
                        "name": "Caldine",
                        "latitude": "43.82834000",
                        "longitude": "11.30442000"
                    },
                    {
                        "id": 136522,
                        "name": "Calenzano",
                        "latitude": "43.85447000",
                        "longitude": "11.16608000"
                    },
                    {
                        "id": 136567,
                        "name": "Camaiore",
                        "latitude": "43.94265000",
                        "longitude": "10.29754000"
                    },
                    {
                        "id": 136602,
                        "name": "Campagnatico",
                        "latitude": "42.88283000",
                        "longitude": "11.27394000"
                    },
                    {
                        "id": 136615,
                        "name": "Campi Bisenzio",
                        "latitude": "43.82450000",
                        "longitude": "11.13027000"
                    },
                    {
                        "id": 136618,
                        "name": "Campiglia Marittima",
                        "latitude": "43.06001000",
                        "longitude": "10.61453000"
                    },
                    {
                        "id": 136626,
                        "name": "Campo",
                        "latitude": "43.70811000",
                        "longitude": "10.47703000"
                    },
                    {
                        "id": 136637,
                        "name": "Campo nell'Elba",
                        "latitude": "42.74802000",
                        "longitude": "10.23332000"
                    },
                    {
                        "id": 136632,
                        "name": "Campo Tizzoro",
                        "latitude": "44.03994000",
                        "longitude": "10.85237000"
                    },
                    {
                        "id": 136675,
                        "name": "Camporgiano",
                        "latitude": "44.15927000",
                        "longitude": "10.33300000"
                    },
                    {
                        "id": 136684,
                        "name": "Camucia-Monsigliolo",
                        "latitude": "43.25926000",
                        "longitude": "11.97114000"
                    },
                    {
                        "id": 136737,
                        "name": "Cantagallo",
                        "latitude": "44.02205000",
                        "longitude": "11.07971000"
                    },
                    {
                        "id": 136738,
                        "name": "Cantagrillo-Casalguidi",
                        "latitude": "43.86937000",
                        "longitude": "10.91386000"
                    },
                    {
                        "id": 136759,
                        "name": "Capalbio",
                        "latitude": "42.45342000",
                        "longitude": "11.42175000"
                    },
                    {
                        "id": 136760,
                        "name": "Capanne-Prato-Cinquale",
                        "latitude": "43.99720000",
                        "longitude": "10.15636000"
                    },
                    {
                        "id": 136761,
                        "name": "Capannoli",
                        "latitude": "43.58856000",
                        "longitude": "10.67328000"
                    },
                    {
                        "id": 136762,
                        "name": "Capannori",
                        "latitude": "43.84171000",
                        "longitude": "10.57271000"
                    },
                    {
                        "id": 136783,
                        "name": "Capoliveri",
                        "latitude": "42.74569000",
                        "longitude": "10.37753000"
                    },
                    {
                        "id": 136784,
                        "name": "Capolona",
                        "latitude": "43.56685000",
                        "longitude": "11.86374000"
                    },
                    {
                        "id": 136799,
                        "name": "Capraia e Limite",
                        "latitude": "43.74535000",
                        "longitude": "10.98342000"
                    },
                    {
                        "id": 136798,
                        "name": "Capraia Isola",
                        "latitude": "43.05064000",
                        "longitude": "9.84298000"
                    },
                    {
                        "id": 136807,
                        "name": "Caprese Michelangelo",
                        "latitude": "43.64031000",
                        "longitude": "11.98546000"
                    },
                    {
                        "id": 136864,
                        "name": "Careggine",
                        "latitude": "44.11995000",
                        "longitude": "10.32540000"
                    },
                    {
                        "id": 136892,
                        "name": "Carmignano",
                        "latitude": "43.81027000",
                        "longitude": "11.01494000"
                    },
                    {
                        "id": 136923,
                        "name": "Carraia",
                        "latitude": "43.89534000",
                        "longitude": "11.18190000"
                    },
                    {
                        "id": 136924,
                        "name": "Carrara",
                        "latitude": "44.07926000",
                        "longitude": "10.09789000"
                    },
                    {
                        "id": 136977,
                        "name": "Casale Marittimo",
                        "latitude": "43.29727000",
                        "longitude": "10.61658000"
                    },
                    {
                        "id": 137047,
                        "name": "Casciana Terme",
                        "latitude": "43.52668000",
                        "longitude": "10.61812000"
                    },
                    {
                        "id": 137048,
                        "name": "Cascina",
                        "latitude": "43.67557000",
                        "longitude": "10.55494000"
                    },
                    {
                        "id": 137051,
                        "name": "Cascine-La Croce",
                        "latitude": "43.72885000",
                        "longitude": "10.61471000"
                    },
                    {
                        "id": 137080,
                        "name": "Casola in Lunigiana",
                        "latitude": "44.20045000",
                        "longitude": "10.17679000"
                    },
                    {
                        "id": 137082,
                        "name": "Casole d'Elsa",
                        "latitude": "43.34115000",
                        "longitude": "11.04794000"
                    },
                    {
                        "id": 137117,
                        "name": "Castagneto Carducci",
                        "latitude": "43.16073000",
                        "longitude": "10.61092000"
                    },
                    {
                        "id": 137166,
                        "name": "Castel del Piano",
                        "latitude": "42.89228000",
                        "longitude": "11.53903000"
                    },
                    {
                        "id": 137153,
                        "name": "Castel San Niccolò",
                        "latitude": "43.74445000",
                        "longitude": "11.70913000"
                    },
                    {
                        "id": 137193,
                        "name": "Castelfiorentino",
                        "latitude": "43.60963000",
                        "longitude": "10.96772000"
                    },
                    {
                        "id": 137199,
                        "name": "Castelfranco di Sopra",
                        "latitude": "43.62156000",
                        "longitude": "11.55885000"
                    },
                    {
                        "id": 137200,
                        "name": "Castelfranco di Sotto",
                        "latitude": "43.70368000",
                        "longitude": "10.74630000"
                    },
                    {
                        "id": 137208,
                        "name": "Castell'Azzara",
                        "latitude": "42.77275000",
                        "longitude": "11.69794000"
                    },
                    {
                        "id": 137246,
                        "name": "Castellina in Chianti",
                        "latitude": "43.46438000",
                        "longitude": "11.28950000"
                    },
                    {
                        "id": 137244,
                        "name": "Castellina Marittima",
                        "latitude": "43.41301000",
                        "longitude": "10.57594000"
                    },
                    {
                        "id": 137245,
                        "name": "Castellina Scalo",
                        "latitude": "43.40476000",
                        "longitude": "11.20908000"
                    },
                    {
                        "id": 137283,
                        "name": "Castelnuovo Berardenga",
                        "latitude": "43.34548000",
                        "longitude": "11.50039000"
                    },
                    {
                        "id": 137296,
                        "name": "Castelnuovo dei Sabbioni",
                        "latitude": "43.54093000",
                        "longitude": "11.45234000"
                    },
                    {
                        "id": 137302,
                        "name": "Castelnuovo di Garfagnana",
                        "latitude": "44.11260000",
                        "longitude": "10.40518000"
                    },
                    {
                        "id": 137304,
                        "name": "Castelnuovo di Val di Cecina",
                        "latitude": "43.21148000",
                        "longitude": "10.90413000"
                    },
                    {
                        "id": 137336,
                        "name": "Castiglion Fibocchi",
                        "latitude": "43.52742000",
                        "longitude": "11.76151000"
                    },
                    {
                        "id": 137337,
                        "name": "Castiglion Fiorentino",
                        "latitude": "43.34308000",
                        "longitude": "11.91995000"
                    },
                    {
                        "id": 137350,
                        "name": "Castiglione d'Orcia",
                        "latitude": "43.00460000",
                        "longitude": "11.61451000"
                    },
                    {
                        "id": 137354,
                        "name": "Castiglione della Pescaia",
                        "latitude": "42.76854000",
                        "longitude": "10.87746000"
                    },
                    {
                        "id": 137356,
                        "name": "Castiglione di Garfagnana",
                        "latitude": "44.15248000",
                        "longitude": "10.41212000"
                    },
                    {
                        "id": 137393,
                        "name": "Catena",
                        "latitude": "43.84254000",
                        "longitude": "11.01658000"
                    },
                    {
                        "id": 137417,
                        "name": "Cavallina",
                        "latitude": "43.98353000",
                        "longitude": "11.23147000"
                    },
                    {
                        "id": 137444,
                        "name": "Cavriglia-Monastero",
                        "latitude": "43.52025000",
                        "longitude": "11.48693000"
                    },
                    {
                        "id": 137454,
                        "name": "Cecina",
                        "latitude": "43.30621000",
                        "longitude": "10.51729000"
                    },
                    {
                        "id": 137486,
                        "name": "Cenaia",
                        "latitude": "43.60637000",
                        "longitude": "10.53571000"
                    },
                    {
                        "id": 137519,
                        "name": "Cerbaia",
                        "latitude": "43.68519000",
                        "longitude": "11.12889000"
                    },
                    {
                        "id": 137563,
                        "name": "Cerreto Guidi",
                        "latitude": "43.75851000",
                        "longitude": "10.88191000"
                    },
                    {
                        "id": 137578,
                        "name": "Certaldo",
                        "latitude": "43.54768000",
                        "longitude": "11.03924000"
                    },
                    {
                        "id": 137601,
                        "name": "Cesa",
                        "latitude": "43.31624000",
                        "longitude": "11.81262000"
                    },
                    {
                        "id": 137622,
                        "name": "Cetona",
                        "latitude": "42.96655000",
                        "longitude": "11.90268000"
                    },
                    {
                        "id": 137645,
                        "name": "Chianciano Terme",
                        "latitude": "43.04181000",
                        "longitude": "11.81205000"
                    },
                    {
                        "id": 137646,
                        "name": "Chianni",
                        "latitude": "43.48153000",
                        "longitude": "10.64133000"
                    },
                    {
                        "id": 137656,
                        "name": "Chiassa-Tregozzano",
                        "latitude": "43.51251000",
                        "longitude": "11.89134000"
                    },
                    {
                        "id": 137670,
                        "name": "Chiesina Uzzanese",
                        "latitude": "43.83891000",
                        "longitude": "10.72044000"
                    },
                    {
                        "id": 137671,
                        "name": "Chiesino-Collodi",
                        "latitude": "43.67954000",
                        "longitude": "10.61106000"
                    },
                    {
                        "id": 137681,
                        "name": "Chitignano",
                        "latitude": "43.66163000",
                        "longitude": "11.88135000"
                    },
                    {
                        "id": 137695,
                        "name": "Chiusdino",
                        "latitude": "43.15454000",
                        "longitude": "11.08310000"
                    },
                    {
                        "id": 137696,
                        "name": "Chiusi",
                        "latitude": "43.01418000",
                        "longitude": "11.94791000"
                    },
                    {
                        "id": 137698,
                        "name": "Chiusi della Verna",
                        "latitude": "43.69745000",
                        "longitude": "11.93504000"
                    },
                    {
                        "id": 137697,
                        "name": "Chiusi Scalo",
                        "latitude": "42.99613000",
                        "longitude": "11.95412000"
                    },
                    {
                        "id": 137733,
                        "name": "Cinigiano",
                        "latitude": "42.89059000",
                        "longitude": "11.39196000"
                    },
                    {
                        "id": 137741,
                        "name": "Cintolese",
                        "latitude": "43.84606000",
                        "longitude": "10.82644000"
                    },
                    {
                        "id": 137804,
                        "name": "Civitella in Val di Chiana",
                        "latitude": "43.41731000",
                        "longitude": "11.72290000"
                    },
                    {
                        "id": 137797,
                        "name": "Civitella Marittima",
                        "latitude": "42.99408000",
                        "longitude": "11.28116000"
                    },
                    {
                        "id": 137873,
                        "name": "Colle di Val d'Elsa",
                        "latitude": "43.42107000",
                        "longitude": "11.12739000"
                    },
                    {
                        "id": 137893,
                        "name": "Collesalvetti",
                        "latitude": "43.59073000",
                        "longitude": "10.47523000"
                    },
                    {
                        "id": 137935,
                        "name": "Comano",
                        "latitude": "44.29335000",
                        "longitude": "10.13109000"
                    },
                    {
                        "id": 137937,
                        "name": "Comeana",
                        "latitude": "43.79334000",
                        "longitude": "11.05825000"
                    },
                    {
                        "id": 137949,
                        "name": "Compiobbi",
                        "latitude": "43.78485000",
                        "longitude": "11.35909000"
                    },
                    {
                        "id": 138005,
                        "name": "Coreglia Antelminelli",
                        "latitude": "44.06278000",
                        "longitude": "10.52426000"
                    },
                    {
                        "id": 138046,
                        "name": "Corsanico-Bargecchia",
                        "latitude": "43.90828000",
                        "longitude": "10.30621000"
                    },
                    {
                        "id": 138071,
                        "name": "Cortona",
                        "latitude": "43.27467000",
                        "longitude": "11.98533000"
                    },
                    {
                        "id": 138146,
                        "name": "Crespina",
                        "latitude": "43.57304000",
                        "longitude": "10.56431000"
                    },
                    {
                        "id": 138217,
                        "name": "Cutigliano",
                        "latitude": "44.10059000",
                        "longitude": "10.75617000"
                    },
                    {
                        "id": 138265,
                        "name": "Dicomano",
                        "latitude": "43.89267000",
                        "longitude": "11.52182000"
                    },
                    {
                        "id": 138303,
                        "name": "Donoratico",
                        "latitude": "43.16927000",
                        "longitude": "10.56744000"
                    },
                    {
                        "id": 138356,
                        "name": "Empoli",
                        "latitude": "43.71795000",
                        "longitude": "10.94758000"
                    },
                    {
                        "id": 138391,
                        "name": "Fabbriche di Vallico",
                        "latitude": "43.99765000",
                        "longitude": "10.42790000"
                    },
                    {
                        "id": 138402,
                        "name": "Faella",
                        "latitude": "43.62652000",
                        "longitude": "11.51844000"
                    },
                    {
                        "id": 138456,
                        "name": "Fauglia",
                        "latitude": "43.57110000",
                        "longitude": "10.51383000"
                    },
                    {
                        "id": 138511,
                        "name": "Fiesole",
                        "latitude": "43.80455000",
                        "longitude": "11.29487000"
                    },
                    {
                        "id": 138519,
                        "name": "Figline Valdarno",
                        "latitude": "43.61995000",
                        "longitude": "11.47191000"
                    },
                    {
                        "id": 138525,
                        "name": "Filattiera",
                        "latitude": "44.33005000",
                        "longitude": "9.93308000"
                    },
                    {
                        "id": 138528,
                        "name": "Filettole",
                        "latitude": "43.81307000",
                        "longitude": "10.40239000"
                    },
                    {
                        "id": 138543,
                        "name": "Firenzuola",
                        "latitude": "44.11968000",
                        "longitude": "11.38185000"
                    },
                    {
                        "id": 138556,
                        "name": "Fivizzano",
                        "latitude": "44.23784000",
                        "longitude": "10.12650000"
                    },
                    {
                        "id": 138563,
                        "name": "Florence",
                        "latitude": "43.77925000",
                        "longitude": "11.24626000"
                    },
                    {
                        "id": 138578,
                        "name": "Foiano della Chiana",
                        "latitude": "43.25318000",
                        "longitude": "11.81647000"
                    },
                    {
                        "id": 138584,
                        "name": "Follonica",
                        "latitude": "42.92779000",
                        "longitude": "10.76451000"
                    },
                    {
                        "id": 138593,
                        "name": "Fontana delle Monache",
                        "latitude": "44.11386000",
                        "longitude": "10.27943000"
                    },
                    {
                        "id": 138608,
                        "name": "Fonteblanda",
                        "latitude": "42.56463000",
                        "longitude": "11.17325000"
                    },
                    {
                        "id": 138622,
                        "name": "Forcoli",
                        "latitude": "43.60374000",
                        "longitude": "10.70514000"
                    },
                    {
                        "id": 138645,
                        "name": "Fornacelle",
                        "latitude": "43.92377000",
                        "longitude": "11.03525000"
                    },
                    {
                        "id": 138646,
                        "name": "Fornacette",
                        "latitude": "43.67023000",
                        "longitude": "10.58512000"
                    },
                    {
                        "id": 138650,
                        "name": "Fornaci di Barga",
                        "latitude": "44.04899000",
                        "longitude": "10.47111000"
                    },
                    {
                        "id": 138661,
                        "name": "Forte dei Marmi",
                        "latitude": "43.96388000",
                        "longitude": "10.17478000"
                    },
                    {
                        "id": 138665,
                        "name": "Fosciandora",
                        "latitude": "44.11495000",
                        "longitude": "10.45850000"
                    },
                    {
                        "id": 138666,
                        "name": "Fosdinovo",
                        "latitude": "44.13320000",
                        "longitude": "10.01778000"
                    },
                    {
                        "id": 138746,
                        "name": "Fucecchio",
                        "latitude": "43.73292000",
                        "longitude": "10.79749000"
                    },
                    {
                        "id": 138768,
                        "name": "Gabella",
                        "latitude": "43.72360000",
                        "longitude": "10.49726000"
                    },
                    {
                        "id": 138791,
                        "name": "Gaiole in Chianti",
                        "latitude": "43.46697000",
                        "longitude": "11.43386000"
                    },
                    {
                        "id": 138803,
                        "name": "Galliano",
                        "latitude": "44.01725000",
                        "longitude": "11.29353000"
                    },
                    {
                        "id": 138807,
                        "name": "Gallicano",
                        "latitude": "44.05833000",
                        "longitude": "10.44209000"
                    },
                    {
                        "id": 138829,
                        "name": "Gambassi Terme",
                        "latitude": "43.53576000",
                        "longitude": "10.95161000"
                    },
                    {
                        "id": 138880,
                        "name": "Gavorrano",
                        "latitude": "42.92526000",
                        "longitude": "10.90681000"
                    },
                    {
                        "id": 138890,
                        "name": "Gello",
                        "latitude": "43.75402000",
                        "longitude": "10.42386000"
                    },
                    {
                        "id": 138958,
                        "name": "Giglio Castello",
                        "latitude": "42.36486000",
                        "longitude": "10.90140000"
                    },
                    {
                        "id": 138964,
                        "name": "Ginestra Fiorentina",
                        "latitude": "43.70939000",
                        "longitude": "11.07384000"
                    },
                    {
                        "id": 138978,
                        "name": "Giovi-Ponte alla Chiassa",
                        "latitude": "43.52634000",
                        "longitude": "11.86558000"
                    },
                    {
                        "id": 138994,
                        "name": "Giuncugnano",
                        "latitude": "44.21055000",
                        "longitude": "10.24719000"
                    },
                    {
                        "id": 139073,
                        "name": "Grassina Ponte a Ema",
                        "latitude": "43.73333000",
                        "longitude": "11.30000000"
                    },
                    {
                        "id": 139092,
                        "name": "Greve in Chianti",
                        "latitude": "43.58514000",
                        "longitude": "11.31712000"
                    },
                    {
                        "id": 139118,
                        "name": "Grosseto",
                        "latitude": "42.76296000",
                        "longitude": "11.10941000"
                    },
                    {
                        "id": 139166,
                        "name": "Guardistallo",
                        "latitude": "43.31408000",
                        "longitude": "10.62944000"
                    },
                    {
                        "id": 139170,
                        "name": "Guasticce",
                        "latitude": "43.59805000",
                        "longitude": "10.40865000"
                    },
                    {
                        "id": 139171,
                        "name": "Guazzino",
                        "latitude": "43.21276000",
                        "longitude": "11.78209000"
                    },
                    {
                        "id": 139193,
                        "name": "Il Romito",
                        "latitude": "43.64908000",
                        "longitude": "10.64538000"
                    },
                    {
                        "id": 139202,
                        "name": "Impruneta",
                        "latitude": "43.68453000",
                        "longitude": "11.25434000"
                    },
                    {
                        "id": 139205,
                        "name": "Incisa in Val d'Arno",
                        "latitude": "43.65480000",
                        "longitude": "11.44901000"
                    },
                    {
                        "id": 139237,
                        "name": "Isola D'Arbia",
                        "latitude": "43.25864000",
                        "longitude": "11.37866000"
                    },
                    {
                        "id": 139244,
                        "name": "Isola del Giglio",
                        "latitude": "42.35791000",
                        "longitude": "10.90724000"
                    },
                    {
                        "id": 139265,
                        "name": "Istia D'Ombrone-Le Stiacciole",
                        "latitude": "42.78243000",
                        "longitude": "11.18820000"
                    },
                    {
                        "id": 139288,
                        "name": "La California",
                        "latitude": "43.26938000",
                        "longitude": "10.54313000"
                    },
                    {
                        "id": 139298,
                        "name": "La Pieve-Molino",
                        "latitude": "43.73725000",
                        "longitude": "11.62033000"
                    },
                    {
                        "id": 139301,
                        "name": "La Rotta",
                        "latitude": "43.65850000",
                        "longitude": "10.67837000"
                    },
                    {
                        "id": 139337,
                        "name": "Lajatico",
                        "latitude": "43.47457000",
                        "longitude": "10.72844000"
                    },
                    {
                        "id": 139350,
                        "name": "Lamporecchio",
                        "latitude": "43.80742000",
                        "longitude": "10.87733000"
                    },
                    {
                        "id": 139370,
                        "name": "Larciano",
                        "latitude": "43.83365000",
                        "longitude": "10.89001000"
                    },
                    {
                        "id": 139374,
                        "name": "Lari",
                        "latitude": "43.56606000",
                        "longitude": "10.59211000"
                    },
                    {
                        "id": 139385,
                        "name": "Lastra a Signa",
                        "latitude": "43.76998000",
                        "longitude": "11.11271000"
                    },
                    {
                        "id": 139387,
                        "name": "Laterina",
                        "latitude": "43.50193000",
                        "longitude": "11.71737000"
                    },
                    {
                        "id": 139423,
                        "name": "Lazzeretto",
                        "latitude": "43.78305000",
                        "longitude": "10.86054000"
                    },
                    {
                        "id": 139424,
                        "name": "Le Casine-Perignano-Spinelli",
                        "latitude": "43.60000000",
                        "longitude": "10.58333000"
                    },
                    {
                        "id": 139495,
                        "name": "Licciana Nardi",
                        "latitude": "44.26472000",
                        "longitude": "10.03725000"
                    },
                    {
                        "id": 139523,
                        "name": "Limite",
                        "latitude": "43.74450000",
                        "longitude": "10.97996000"
                    },
                    {
                        "id": 139551,
                        "name": "Livorno",
                        "latitude": "43.54427000",
                        "longitude": "10.32615000"
                    },
                    {
                        "id": 139587,
                        "name": "Londa",
                        "latitude": "43.86344000",
                        "longitude": "11.56425000"
                    },
                    {
                        "id": 139607,
                        "name": "Lorenzana",
                        "latitude": "43.53533000",
                        "longitude": "10.53477000"
                    },
                    {
                        "id": 139613,
                        "name": "Loro Ciuffenna",
                        "latitude": "43.58827000",
                        "longitude": "11.62885000"
                    },
                    {
                        "id": 139629,
                        "name": "Lucca",
                        "latitude": "43.84369000",
                        "longitude": "10.50447000"
                    },
                    {
                        "id": 139632,
                        "name": "Lucignano",
                        "latitude": "43.27259000",
                        "longitude": "11.74599000"
                    },
                    {
                        "id": 139637,
                        "name": "Luco Mugello",
                        "latitude": "44.00032000",
                        "longitude": "11.39611000"
                    },
                    {
                        "id": 139711,
                        "name": "Madonna dell'Acqua",
                        "latitude": "43.74264000",
                        "longitude": "10.37513000"
                    },
                    {
                        "id": 139730,
                        "name": "Magliano in Toscana",
                        "latitude": "42.59802000",
                        "longitude": "11.29234000"
                    },
                    {
                        "id": 139770,
                        "name": "Malmantile",
                        "latitude": "43.74717000",
                        "longitude": "11.07285000"
                    },
                    {
                        "id": 139782,
                        "name": "Manciano",
                        "latitude": "42.58875000",
                        "longitude": "11.51806000"
                    },
                    {
                        "id": 139810,
                        "name": "Mantignano-Ugnano",
                        "latitude": "43.78200000",
                        "longitude": "11.16958000"
                    },
                    {
                        "id": 139845,
                        "name": "Marciana",
                        "latitude": "42.79301000",
                        "longitude": "10.16870000"
                    },
                    {
                        "id": 139846,
                        "name": "Marciana Marina",
                        "latitude": "42.80256000",
                        "longitude": "10.19488000"
                    },
                    {
                        "id": 139848,
                        "name": "Marciano",
                        "latitude": "43.30651000",
                        "longitude": "11.79171000"
                    },
                    {
                        "id": 139849,
                        "name": "Marciano della Chiana",
                        "latitude": "43.30494000",
                        "longitude": "11.78644000"
                    },
                    {
                        "id": 139851,
                        "name": "Marcignana",
                        "latitude": "43.71830000",
                        "longitude": "10.88436000"
                    },
                    {
                        "id": 139864,
                        "name": "Margine Coperta-Traversagna",
                        "latitude": "43.87977000",
                        "longitude": "10.75733000"
                    },
                    {
                        "id": 139879,
                        "name": "Marina di Campo",
                        "latitude": "42.74260000",
                        "longitude": "10.23428000"
                    },
                    {
                        "id": 139881,
                        "name": "Marina di Carrara",
                        "latitude": "44.03837000",
                        "longitude": "10.04142000"
                    },
                    {
                        "id": 139888,
                        "name": "Marina di Grosseto",
                        "latitude": "42.71908000",
                        "longitude": "10.98138000"
                    },
                    {
                        "id": 139889,
                        "name": "Marina di Massa",
                        "latitude": "44.00380000",
                        "longitude": "10.10674000"
                    },
                    {
                        "id": 139891,
                        "name": "Marina di Pisa",
                        "latitude": "43.66667000",
                        "longitude": "10.26667000"
                    },
                    {
                        "id": 139892,
                        "name": "Marina di Pisa-Tirrenia-Calambrone",
                        "latitude": "43.62719000",
                        "longitude": "10.29204000"
                    },
                    {
                        "id": 139904,
                        "name": "Marliana",
                        "latitude": "43.93385000",
                        "longitude": "10.77021000"
                    },
                    {
                        "id": 139915,
                        "name": "Marradi",
                        "latitude": "44.07353000",
                        "longitude": "11.61092000"
                    },
                    {
                        "id": 139929,
                        "name": "Marti",
                        "latitude": "43.65453000",
                        "longitude": "10.74058000"
                    },
                    {
                        "id": 139966,
                        "name": "Massa",
                        "latitude": "43.90925000",
                        "longitude": "10.74441000"
                    },
                    {
                        "id": 139973,
                        "name": "Massa Marittima",
                        "latitude": "43.04779000",
                        "longitude": "10.89293000"
                    },
                    {
                        "id": 139980,
                        "name": "Massarosa",
                        "latitude": "43.86638000",
                        "longitude": "10.34458000"
                    },
                    {
                        "id": 140072,
                        "name": "Mercatale",
                        "latitude": "43.63677000",
                        "longitude": "11.22790000"
                    },
                    {
                        "id": 140073,
                        "name": "Mercatale-San Quirico",
                        "latitude": "44.04426000",
                        "longitude": "11.15163000"
                    },
                    {
                        "id": 140102,
                        "name": "Metato",
                        "latitude": "43.77352000",
                        "longitude": "10.37106000"
                    },
                    {
                        "id": 140134,
                        "name": "Migliarino",
                        "latitude": "43.76589000",
                        "longitude": "10.33951000"
                    },
                    {
                        "id": 140163,
                        "name": "Minucciano",
                        "latitude": "44.17000000",
                        "longitude": "10.20807000"
                    },
                    {
                        "id": 140211,
                        "name": "Molazzana",
                        "latitude": "44.07175000",
                        "longitude": "10.41780000"
                    },
                    {
                        "id": 140224,
                        "name": "Molino del Piano",
                        "latitude": "43.81098000",
                        "longitude": "11.39992000"
                    },
                    {
                        "id": 140303,
                        "name": "Monsummano Terme",
                        "latitude": "43.86720000",
                        "longitude": "10.81295000"
                    },
                    {
                        "id": 140314,
                        "name": "Montaione",
                        "latitude": "43.55144000",
                        "longitude": "10.91371000"
                    },
                    {
                        "id": 140319,
                        "name": "Montalcino",
                        "latitude": "43.05397000",
                        "longitude": "11.48853000"
                    },
                    {
                        "id": 140326,
                        "name": "Montale",
                        "latitude": "43.93486000",
                        "longitude": "11.01655000"
                    },
                    {
                        "id": 140330,
                        "name": "Montalto",
                        "latitude": "43.49912000",
                        "longitude": "11.66380000"
                    },
                    {
                        "id": 140352,
                        "name": "Monte Argentario",
                        "latitude": "42.43452000",
                        "longitude": "11.11954000"
                    },
                    {
                        "id": 140377,
                        "name": "Monte San Savino",
                        "latitude": "43.33213000",
                        "longitude": "11.72663000"
                    },
                    {
                        "id": 140392,
                        "name": "Montebonello",
                        "latitude": "43.83027000",
                        "longitude": "11.48655000"
                    },
                    {
                        "id": 140399,
                        "name": "Montecalvoli",
                        "latitude": "43.68576000",
                        "longitude": "10.66508000"
                    },
                    {
                        "id": 140400,
                        "name": "Montecarlo",
                        "latitude": "43.85218000",
                        "longitude": "10.66742000"
                    },
                    {
                        "id": 140405,
                        "name": "Montecatini Val di Cecina",
                        "latitude": "43.39234000",
                        "longitude": "10.74904000"
                    },
                    {
                        "id": 140406,
                        "name": "Montecatini-Terme",
                        "latitude": "43.88153000",
                        "longitude": "10.77230000"
                    },
                    {
                        "id": 140481,
                        "name": "Montelupo Fiorentino",
                        "latitude": "43.72958000",
                        "longitude": "11.00997000"
                    },
                    {
                        "id": 140493,
                        "name": "Montemignaio",
                        "latitude": "43.73985000",
                        "longitude": "11.61883000"
                    },
                    {
                        "id": 140498,
                        "name": "Montemurlo",
                        "latitude": "43.92686000",
                        "longitude": "11.03718000"
                    },
                    {
                        "id": 140510,
                        "name": "Montepulciano",
                        "latitude": "43.09998000",
                        "longitude": "11.78704000"
                    },
                    {
                        "id": 140511,
                        "name": "Montepulciano Stazione",
                        "latitude": "43.13520000",
                        "longitude": "11.85545000"
                    },
                    {
                        "id": 140513,
                        "name": "Monterchi",
                        "latitude": "43.48733000",
                        "longitude": "12.11054000"
                    },
                    {
                        "id": 140517,
                        "name": "Monteriggioni",
                        "latitude": "43.38994000",
                        "longitude": "11.22323000"
                    },
                    {
                        "id": 140519,
                        "name": "Monteroni d'Arbia",
                        "latitude": "43.22968000",
                        "longitude": "11.42228000"
                    },
                    {
                        "id": 140527,
                        "name": "Monterotondo Marittimo",
                        "latitude": "43.14556000",
                        "longitude": "10.85591000"
                    },
                    {
                        "id": 140537,
                        "name": "Montescudaio",
                        "latitude": "43.32603000",
                        "longitude": "10.62602000"
                    },
                    {
                        "id": 140543,
                        "name": "Montespertoli",
                        "latitude": "43.64260000",
                        "longitude": "11.07331000"
                    },
                    {
                        "id": 140547,
                        "name": "Montevarchi",
                        "latitude": "43.52520000",
                        "longitude": "11.57238000"
                    },
                    {
                        "id": 140550,
                        "name": "Monteverdi Marittimo",
                        "latitude": "43.17787000",
                        "longitude": "10.71133000"
                    },
                    {
                        "id": 140554,
                        "name": "Monti",
                        "latitude": "44.24864000",
                        "longitude": "10.00854000"
                    },
                    {
                        "id": 140570,
                        "name": "Monticiano",
                        "latitude": "43.13965000",
                        "longitude": "11.17710000"
                    },
                    {
                        "id": 140571,
                        "name": "Montieri",
                        "latitude": "43.13113000",
                        "longitude": "11.01663000"
                    },
                    {
                        "id": 140574,
                        "name": "Montignoso",
                        "latitude": "44.02405000",
                        "longitude": "10.17259000"
                    },
                    {
                        "id": 140580,
                        "name": "Montopoli",
                        "latitude": "43.67354000",
                        "longitude": "10.74951000"
                    },
                    {
                        "id": 140682,
                        "name": "Mulazzo",
                        "latitude": "44.31564000",
                        "longitude": "9.89101000"
                    },
                    {
                        "id": 140692,
                        "name": "Murlo",
                        "latitude": "43.16114000",
                        "longitude": "11.38794000"
                    },
                    {
                        "id": 140940,
                        "name": "Orbetello",
                        "latitude": "42.44158000",
                        "longitude": "11.22140000"
                    },
                    {
                        "id": 140941,
                        "name": "Orbetello Scalo",
                        "latitude": "42.44866000",
                        "longitude": "11.24936000"
                    },
                    {
                        "id": 140943,
                        "name": "Orciano Pisano",
                        "latitude": "43.49444000",
                        "longitude": "10.51151000"
                    },
                    {
                        "id": 140947,
                        "name": "Orentano",
                        "latitude": "43.77907000",
                        "longitude": "10.65939000"
                    },
                    {
                        "id": 140985,
                        "name": "Ortignano Raggiolo",
                        "latitude": "43.67995000",
                        "longitude": "11.74883000"
                    },
                    {
                        "id": 140996,
                        "name": "Orzignano",
                        "latitude": "43.77408000",
                        "longitude": "10.42382000"
                    },
                    {
                        "id": 58222,
                        "name": "Palaia",
                        "latitude": "43.60567000",
                        "longitude": "10.77020000"
                    },
                    {
                        "id": 58237,
                        "name": "Palazzuolo sul Senio",
                        "latitude": "44.11298000",
                        "longitude": "11.54270000"
                    },
                    {
                        "id": 58252,
                        "name": "Pallerone",
                        "latitude": "44.20485000",
                        "longitude": "10.00279000"
                    },
                    {
                        "id": 58286,
                        "name": "Panzano in Chianti",
                        "latitude": "43.54422000",
                        "longitude": "11.31438000"
                    },
                    {
                        "id": 58347,
                        "name": "Patigno",
                        "latitude": "44.35316000",
                        "longitude": "9.76297000"
                    },
                    {
                        "id": 58367,
                        "name": "Peccioli",
                        "latitude": "43.54963000",
                        "longitude": "10.71720000"
                    },
                    {
                        "id": 58390,
                        "name": "Pelago",
                        "latitude": "43.77255000",
                        "longitude": "11.50148000"
                    },
                    {
                        "id": 58422,
                        "name": "Pergine Valdarno",
                        "latitude": "43.47028000",
                        "longitude": "11.68552000"
                    },
                    {
                        "id": 58448,
                        "name": "Pescaglia",
                        "latitude": "43.96517000",
                        "longitude": "10.41292000"
                    },
                    {
                        "id": 58457,
                        "name": "Pescia",
                        "latitude": "43.88710000",
                        "longitude": "10.68849000"
                    },
                    {
                        "id": 58509,
                        "name": "Pian di Mugnone",
                        "latitude": "43.81810000",
                        "longitude": "11.29585000"
                    },
                    {
                        "id": 58510,
                        "name": "Pian di Scò",
                        "latitude": "43.64195000",
                        "longitude": "11.54523000"
                    },
                    {
                        "id": 58517,
                        "name": "Piancastagnaio",
                        "latitude": "42.85067000",
                        "longitude": "11.69014000"
                    },
                    {
                        "id": 58541,
                        "name": "Piano di Conca",
                        "latitude": "43.89413000",
                        "longitude": "10.29493000"
                    },
                    {
                        "id": 58542,
                        "name": "Piano di Coreglia-Ghivizzano",
                        "latitude": "44.03333000",
                        "longitude": "10.51667000"
                    },
                    {
                        "id": 58544,
                        "name": "Piano di Mommio",
                        "latitude": "43.90954000",
                        "longitude": "10.27435000"
                    },
                    {
                        "id": 58569,
                        "name": "Piazza al Serchio-San Michele",
                        "latitude": "44.18455000",
                        "longitude": "10.29689000"
                    },
                    {
                        "id": 58597,
                        "name": "Pienza",
                        "latitude": "43.07873000",
                        "longitude": "11.67671000"
                    },
                    {
                        "id": 58625,
                        "name": "Pietrasanta",
                        "latitude": "43.95952000",
                        "longitude": "10.22784000"
                    },
                    {
                        "id": 58643,
                        "name": "Pieve a Nievole",
                        "latitude": "43.88119000",
                        "longitude": "10.79990000"
                    },
                    {
                        "id": 58644,
                        "name": "Pieve al Toppo",
                        "latitude": "43.40761000",
                        "longitude": "11.79686000"
                    },
                    {
                        "id": 58635,
                        "name": "Pieve Fosciana",
                        "latitude": "44.13067000",
                        "longitude": "10.40952000"
                    },
                    {
                        "id": 58639,
                        "name": "Pieve Santo Stefano",
                        "latitude": "43.67145000",
                        "longitude": "12.04124000"
                    },
                    {
                        "id": 58689,
                        "name": "Piombino",
                        "latitude": "42.92554000",
                        "longitude": "10.52585000"
                    },
                    {
                        "id": 58702,
                        "name": "Pisa",
                        "latitude": "43.70853000",
                        "longitude": "10.40360000"
                    },
                    {
                        "id": 58714,
                        "name": "Pistoia",
                        "latitude": "43.93064000",
                        "longitude": "10.92365000"
                    },
                    {
                        "id": 58716,
                        "name": "Piteglio",
                        "latitude": "44.02790000",
                        "longitude": "10.76571000"
                    },
                    {
                        "id": 58718,
                        "name": "Pitigliano",
                        "latitude": "42.63582000",
                        "longitude": "11.67462000"
                    },
                    {
                        "id": 58744,
                        "name": "Podenzana",
                        "latitude": "44.20625000",
                        "longitude": "9.94199000"
                    },
                    {
                        "id": 58747,
                        "name": "Poggetto",
                        "latitude": "43.82790000",
                        "longitude": "11.03847000"
                    },
                    {
                        "id": 58749,
                        "name": "Poggibonsi",
                        "latitude": "43.47064000",
                        "longitude": "11.14804000"
                    },
                    {
                        "id": 58750,
                        "name": "Poggio A Caiano",
                        "latitude": "43.81378000",
                        "longitude": "11.05186000"
                    },
                    {
                        "id": 58808,
                        "name": "Pomarance",
                        "latitude": "43.29592000",
                        "longitude": "10.87223000"
                    },
                    {
                        "id": 58825,
                        "name": "Ponsacco",
                        "latitude": "43.62307000",
                        "longitude": "10.62661000"
                    },
                    {
                        "id": 58830,
                        "name": "Pontasserchio",
                        "latitude": "43.77953000",
                        "longitude": "10.41673000"
                    },
                    {
                        "id": 58831,
                        "name": "Pontassieve",
                        "latitude": "43.77477000",
                        "longitude": "11.43109000"
                    },
                    {
                        "id": 58833,
                        "name": "Ponte A Elsa",
                        "latitude": "43.68907000",
                        "longitude": "10.89281000"
                    },
                    {
                        "id": 58851,
                        "name": "Ponte a Poppi",
                        "latitude": "43.73171000",
                        "longitude": "11.76663000"
                    },
                    {
                        "id": 58834,
                        "name": "Ponte A Tressa",
                        "latitude": "43.25158000",
                        "longitude": "11.39514000"
                    },
                    {
                        "id": 58836,
                        "name": "Ponte Buggianese",
                        "latitude": "43.84599000",
                        "longitude": "10.74789000"
                    },
                    {
                        "id": 58869,
                        "name": "Pontedera",
                        "latitude": "43.66141000",
                        "longitude": "10.63067000"
                    },
                    {
                        "id": 58878,
                        "name": "Pontestazzemese",
                        "latitude": "43.99665000",
                        "longitude": "10.29439000"
                    },
                    {
                        "id": 58886,
                        "name": "Ponticino",
                        "latitude": "43.48012000",
                        "longitude": "11.71622000"
                    },
                    {
                        "id": 58893,
                        "name": "Pontremoli",
                        "latitude": "44.37515000",
                        "longitude": "9.87888000"
                    },
                    {
                        "id": 58901,
                        "name": "Poppi",
                        "latitude": "43.72123000",
                        "longitude": "11.76642000"
                    },
                    {
                        "id": 58903,
                        "name": "Porcari",
                        "latitude": "43.84152000",
                        "longitude": "10.61632000"
                    },
                    {
                        "id": 58923,
                        "name": "Porto Azzurro",
                        "latitude": "42.76754000",
                        "longitude": "10.39723000"
                    },
                    {
                        "id": 58929,
                        "name": "Porto Ercole",
                        "latitude": "42.40171000",
                        "longitude": "11.20523000"
                    },
                    {
                        "id": 58936,
                        "name": "Porto Santo Stefano",
                        "latitude": "42.43825000",
                        "longitude": "11.11542000"
                    },
                    {
                        "id": 58944,
                        "name": "Portoferraio",
                        "latitude": "42.81233000",
                        "longitude": "10.31297000"
                    },
                    {
                        "id": 58978,
                        "name": "Pozzale-Case Nuove",
                        "latitude": "43.69584000",
                        "longitude": "10.95651000"
                    },
                    {
                        "id": 59018,
                        "name": "Pratantico-Indicatore",
                        "latitude": "43.48071000",
                        "longitude": "11.80531000"
                    },
                    {
                        "id": 59026,
                        "name": "Prato",
                        "latitude": "43.88050000",
                        "longitude": "11.09699000"
                    },
                    {
                        "id": 59036,
                        "name": "Pratovecchio",
                        "latitude": "43.78685000",
                        "longitude": "11.72353000"
                    },
                    {
                        "id": 59100,
                        "name": "Province of Arezzo",
                        "latitude": "43.53333000",
                        "longitude": "11.83333000"
                    },
                    {
                        "id": 59102,
                        "name": "Province of Florence",
                        "latitude": "43.83333000",
                        "longitude": "11.33333000"
                    },
                    {
                        "id": 59103,
                        "name": "Province of Pisa",
                        "latitude": "43.41667000",
                        "longitude": "10.71667000"
                    },
                    {
                        "id": 59136,
                        "name": "Provincia di Grosseto",
                        "latitude": "42.83333000",
                        "longitude": "11.25000000"
                    },
                    {
                        "id": 59143,
                        "name": "Provincia di Livorno",
                        "latitude": "43.23333000",
                        "longitude": "10.58333000"
                    },
                    {
                        "id": 59145,
                        "name": "Provincia di Lucca",
                        "latitude": "44.03333000",
                        "longitude": "10.45000000"
                    },
                    {
                        "id": 59148,
                        "name": "Provincia di Massa-Carrara",
                        "latitude": "44.25000000",
                        "longitude": "10.05000000"
                    },
                    {
                        "id": 59162,
                        "name": "Provincia di Pistoia",
                        "latitude": "43.96667000",
                        "longitude": "10.83333000"
                    },
                    {
                        "id": 59165,
                        "name": "Provincia di Prato",
                        "latitude": "43.88046000",
                        "longitude": "11.09686000"
                    },
                    {
                        "id": 59175,
                        "name": "Provincia di Siena",
                        "latitude": "43.21667000",
                        "longitude": "11.40000000"
                    },
                    {
                        "id": 59218,
                        "name": "Quarata",
                        "latitude": "43.49859000",
                        "longitude": "11.82742000"
                    },
                    {
                        "id": 59224,
                        "name": "Quarrata",
                        "latitude": "43.84837000",
                        "longitude": "10.97888000"
                    },
                    {
                        "id": 59237,
                        "name": "Quattro Strade",
                        "latitude": "43.74148000",
                        "longitude": "11.08070000"
                    },
                    {
                        "id": 59240,
                        "name": "Quercianella",
                        "latitude": "43.45959000",
                        "longitude": "10.36757000"
                    },
                    {
                        "id": 59261,
                        "name": "Radda in Chianti",
                        "latitude": "43.48540000",
                        "longitude": "11.37437000"
                    },
                    {
                        "id": 59263,
                        "name": "Radicofani",
                        "latitude": "42.89618000",
                        "longitude": "11.76839000"
                    },
                    {
                        "id": 59264,
                        "name": "Radicondoli",
                        "latitude": "43.26047000",
                        "longitude": "11.04582000"
                    },
                    {
                        "id": 59286,
                        "name": "Rapolano Terme",
                        "latitude": "43.29498000",
                        "longitude": "11.60264000"
                    },
                    {
                        "id": 59290,
                        "name": "Rassina",
                        "latitude": "43.64737000",
                        "longitude": "11.83632000"
                    },
                    {
                        "id": 59319,
                        "name": "Reggello",
                        "latitude": "43.67967000",
                        "longitude": "11.52976000"
                    },
                    {
                        "id": 59360,
                        "name": "Ribolla",
                        "latitude": "42.97087000",
                        "longitude": "11.03555000"
                    },
                    {
                        "id": 59379,
                        "name": "Rignano sull'Arno",
                        "latitude": "43.72145000",
                        "longitude": "11.45183000"
                    },
                    {
                        "id": 59386,
                        "name": "Rio Marina",
                        "latitude": "42.81395000",
                        "longitude": "10.42600000"
                    },
                    {
                        "id": 59390,
                        "name": "Rio nell'Elba",
                        "latitude": "42.81169000",
                        "longitude": "10.40085000"
                    },
                    {
                        "id": 59400,
                        "name": "Ripa-Pozzi-Querceta-Ponterosso",
                        "latitude": "43.97806000",
                        "longitude": "10.20372000"
                    },
                    {
                        "id": 59407,
                        "name": "Riparbella",
                        "latitude": "43.36417000",
                        "longitude": "10.59799000"
                    },
                    {
                        "id": 59505,
                        "name": "Roccalbegna",
                        "latitude": "42.78630000",
                        "longitude": "11.50788000"
                    },
                    {
                        "id": 59525,
                        "name": "Roccastrada",
                        "latitude": "43.00888000",
                        "longitude": "11.16762000"
                    },
                    {
                        "id": 59617,
                        "name": "Ronta",
                        "latitude": "44.00310000",
                        "longitude": "11.42894000"
                    },
                    {
                        "id": 59638,
                        "name": "Rosia",
                        "latitude": "43.24611000",
                        "longitude": "11.22176000"
                    },
                    {
                        "id": 59639,
                        "name": "Rosignano Marittimo",
                        "latitude": "43.40686000",
                        "longitude": "10.47231000"
                    },
                    {
                        "id": 59641,
                        "name": "Rosignano Solvay-Castiglioncello",
                        "latitude": "43.38946000",
                        "longitude": "10.43615000"
                    },
                    {
                        "id": 59699,
                        "name": "Rufina",
                        "latitude": "43.82396000",
                        "longitude": "11.48673000"
                    },
                    {
                        "id": 59710,
                        "name": "S.P. in Palazzi",
                        "latitude": "43.32776000",
                        "longitude": "10.50881000"
                    },
                    {
                        "id": 59770,
                        "name": "Saline",
                        "latitude": "43.36185000",
                        "longitude": "10.81354000"
                    },
                    {
                        "id": 59803,
                        "name": "Sambuca",
                        "latitude": "43.57344000",
                        "longitude": "11.21407000"
                    },
                    {
                        "id": 59804,
                        "name": "Sambuca Pistoiese",
                        "latitude": "44.10435000",
                        "longitude": "10.99961000"
                    },
                    {
                        "id": 59857,
                        "name": "San Casciano dei Bagni",
                        "latitude": "42.87008000",
                        "longitude": "11.87656000"
                    },
                    {
                        "id": 59858,
                        "name": "San Casciano in Val di Pesa",
                        "latitude": "43.65975000",
                        "longitude": "11.18494000"
                    },
                    {
                        "id": 59872,
                        "name": "San Cipriano-S.Barbara-Centinale",
                        "latitude": "43.56863000",
                        "longitude": "11.48467000"
                    },
                    {
                        "id": 59895,
                        "name": "San Donato",
                        "latitude": "43.70298000",
                        "longitude": "10.78754000"
                    },
                    {
                        "id": 59900,
                        "name": "San Donnino",
                        "latitude": "43.79547000",
                        "longitude": "11.14654000"
                    },
                    {
                        "id": 59926,
                        "name": "San Francesco",
                        "latitude": "43.77483000",
                        "longitude": "11.44842000"
                    },
                    {
                        "id": 59949,
                        "name": "San Gimignano",
                        "latitude": "43.47380000",
                        "longitude": "11.02975000"
                    },
                    {
                        "id": 59993,
                        "name": "San Giovanni d'Asso",
                        "latitude": "43.15334000",
                        "longitude": "11.58938000"
                    },
                    {
                        "id": 59990,
                        "name": "San Giovanni Valdarno",
                        "latitude": "43.56757000",
                        "longitude": "11.52987000"
                    },
                    {
                        "id": 60005,
                        "name": "San Giuliano Terme",
                        "latitude": "43.76372000",
                        "longitude": "10.43856000"
                    },
                    {
                        "id": 60016,
                        "name": "San Giustino Valdarno",
                        "latitude": "43.55269000",
                        "longitude": "11.70497000"
                    },
                    {
                        "id": 60018,
                        "name": "San Godenzo",
                        "latitude": "43.92504000",
                        "longitude": "11.61982000"
                    },
                    {
                        "id": 60026,
                        "name": "San Jacopo al Girone",
                        "latitude": "43.76956000",
                        "longitude": "11.34032000"
                    },
                    {
                        "id": 60059,
                        "name": "San Marcello Pistoiese",
                        "latitude": "44.05583000",
                        "longitude": "10.79366000"
                    },
                    {
                        "id": 60091,
                        "name": "San Martino in Freddana-Monsagrati",
                        "latitude": "43.90921000",
                        "longitude": "10.43778000"
                    },
                    {
                        "id": 60104,
                        "name": "San Mauro",
                        "latitude": "43.79418000",
                        "longitude": "11.12499000"
                    },
                    {
                        "id": 60127,
                        "name": "San Miniato",
                        "latitude": "43.67954000",
                        "longitude": "10.84975000"
                    },
                    {
                        "id": 60128,
                        "name": "San Miniato Basso",
                        "latitude": "43.69332000",
                        "longitude": "10.84119000"
                    },
                    {
                        "id": 60166,
                        "name": "San Pierino",
                        "latitude": "43.71423000",
                        "longitude": "10.81374000"
                    },
                    {
                        "id": 60168,
                        "name": "San Piero a Sieve",
                        "latitude": "43.96251000",
                        "longitude": "11.32426000"
                    },
                    {
                        "id": 60175,
                        "name": "San Pietro Belvedere",
                        "latitude": "43.57011000",
                        "longitude": "10.66604000"
                    },
                    {
                        "id": 60217,
                        "name": "San Quirico d'Orcia",
                        "latitude": "43.05782000",
                        "longitude": "11.60525000"
                    },
                    {
                        "id": 60224,
                        "name": "San Rocco",
                        "latitude": "43.82316000",
                        "longitude": "10.86121000"
                    },
                    {
                        "id": 60227,
                        "name": "San Romano",
                        "latitude": "43.68922000",
                        "longitude": "10.76900000"
                    },
                    {
                        "id": 60228,
                        "name": "San Romano in Garfagnana",
                        "latitude": "44.16945000",
                        "longitude": "10.34690000"
                    },
                    {
                        "id": 60267,
                        "name": "San Vincenzo",
                        "latitude": "43.09061000",
                        "longitude": "10.54246000"
                    },
                    {
                        "id": 60285,
                        "name": "San Vito-Cerreto",
                        "latitude": "44.02300000",
                        "longitude": "10.17212000"
                    },
                    {
                        "id": 60313,
                        "name": "Sansepolcro",
                        "latitude": "43.57258000",
                        "longitude": "12.13858000"
                    },
                    {
                        "id": 60332,
                        "name": "Sant'Albino",
                        "latitude": "43.07098000",
                        "longitude": "11.80684000"
                    },
                    {
                        "id": 60430,
                        "name": "Santa Croce sull'Arno",
                        "latitude": "43.71709000",
                        "longitude": "10.77242000"
                    },
                    {
                        "id": 60436,
                        "name": "Santa Fiora",
                        "latitude": "42.83129000",
                        "longitude": "11.58474000"
                    },
                    {
                        "id": 60443,
                        "name": "Santa Luce",
                        "latitude": "43.47143000",
                        "longitude": "10.56269000"
                    },
                    {
                        "id": 60444,
                        "name": "Santa Lucia",
                        "latitude": "43.88296000",
                        "longitude": "10.70307000"
                    },
                    {
                        "id": 60470,
                        "name": "Santa Maria a Monte",
                        "latitude": "43.70793000",
                        "longitude": "10.69196000"
                    },
                    {
                        "id": 60560,
                        "name": "Sarteano",
                        "latitude": "42.99193000",
                        "longitude": "11.86472000"
                    },
                    {
                        "id": 60570,
                        "name": "Sassetta",
                        "latitude": "43.12874000",
                        "longitude": "10.64359000"
                    },
                    {
                        "id": 60617,
                        "name": "Scandicci",
                        "latitude": "43.75423000",
                        "longitude": "11.18794000"
                    },
                    {
                        "id": 60625,
                        "name": "Scansano",
                        "latitude": "42.68779000",
                        "longitude": "11.32975000"
                    },
                    {
                        "id": 60632,
                        "name": "Scarlino",
                        "latitude": "42.90799000",
                        "longitude": "10.85148000"
                    },
                    {
                        "id": 60633,
                        "name": "Scarlino Scalo",
                        "latitude": "42.93992000",
                        "longitude": "10.83766000"
                    },
                    {
                        "id": 60636,
                        "name": "Scarperia",
                        "latitude": "43.99357000",
                        "longitude": "11.35415000"
                    },
                    {
                        "id": 60673,
                        "name": "Seano",
                        "latitude": "43.83035000",
                        "longitude": "11.02122000"
                    },
                    {
                        "id": 60688,
                        "name": "Seggiano",
                        "latitude": "42.92897000",
                        "longitude": "11.55736000"
                    },
                    {
                        "id": 60709,
                        "name": "Selvatelle",
                        "latitude": "43.56281000",
                        "longitude": "10.69091000"
                    },
                    {
                        "id": 60717,
                        "name": "Semproniano",
                        "latitude": "42.72923000",
                        "longitude": "11.54134000"
                    },
                    {
                        "id": 60735,
                        "name": "Seravezza",
                        "latitude": "43.99471000",
                        "longitude": "10.22720000"
                    },
                    {
                        "id": 60773,
                        "name": "Serravalle Pistoiese",
                        "latitude": "43.90605000",
                        "longitude": "10.83271000"
                    },
                    {
                        "id": 60780,
                        "name": "Serre di Rapolano",
                        "latitude": "43.25658000",
                        "longitude": "11.61655000"
                    },
                    {
                        "id": 60793,
                        "name": "Sestino",
                        "latitude": "43.70966000",
                        "longitude": "12.29785000"
                    },
                    {
                        "id": 60797,
                        "name": "Sesto Fiorentino",
                        "latitude": "43.83193000",
                        "longitude": "11.19924000"
                    },
                    {
                        "id": 60843,
                        "name": "Sieci",
                        "latitude": "43.78847000",
                        "longitude": "11.39445000"
                    },
                    {
                        "id": 60844,
                        "name": "Siena",
                        "latitude": "43.31822000",
                        "longitude": "11.33064000"
                    },
                    {
                        "id": 60846,
                        "name": "Signa",
                        "latitude": "43.79420000",
                        "longitude": "11.10360000"
                    },
                    {
                        "id": 60853,
                        "name": "Sillano",
                        "latitude": "44.22298000",
                        "longitude": "10.30235000"
                    },
                    {
                        "id": 60863,
                        "name": "Sinalunga",
                        "latitude": "43.21492000",
                        "longitude": "11.74507000"
                    },
                    {
                        "id": 60894,
                        "name": "Soci",
                        "latitude": "43.72821000",
                        "longitude": "11.81096000"
                    },
                    {
                        "id": 60947,
                        "name": "Sorano",
                        "latitude": "42.68118000",
                        "longitude": "11.71943000"
                    },
                    {
                        "id": 60983,
                        "name": "Sovicille",
                        "latitude": "43.28033000",
                        "longitude": "11.22828000"
                    },
                    {
                        "id": 61004,
                        "name": "Spianate",
                        "latitude": "43.81075000",
                        "longitude": "10.71510000"
                    },
                    {
                        "id": 61006,
                        "name": "Spicchio-Sovigliana",
                        "latitude": "43.73016000",
                        "longitude": "10.93921000"
                    },
                    {
                        "id": 61037,
                        "name": "Stabbia",
                        "latitude": "43.78266000",
                        "longitude": "10.83475000"
                    },
                    {
                        "id": 61040,
                        "name": "Staggia",
                        "latitude": "43.42182000",
                        "longitude": "11.18364000"
                    },
                    {
                        "id": 61050,
                        "name": "Stazione",
                        "latitude": "43.91460000",
                        "longitude": "11.01414000"
                    },
                    {
                        "id": 61052,
                        "name": "Stazione Masotti",
                        "latitude": "43.90984000",
                        "longitude": "10.85386000"
                    },
                    {
                        "id": 61069,
                        "name": "Stia",
                        "latitude": "43.79877000",
                        "longitude": "11.70894000"
                    },
                    {
                        "id": 61070,
                        "name": "Stiava",
                        "latitude": "43.89720000",
                        "longitude": "10.31798000"
                    },
                    {
                        "id": 61083,
                        "name": "Strada",
                        "latitude": "43.74452000",
                        "longitude": "11.71007000"
                    },
                    {
                        "id": 61085,
                        "name": "Strada in Chianti",
                        "latitude": "43.65874000",
                        "longitude": "11.29678000"
                    },
                    {
                        "id": 61094,
                        "name": "Strettoia",
                        "latitude": "43.98987000",
                        "longitude": "10.19357000"
                    },
                    {
                        "id": 61108,
                        "name": "Subbiano",
                        "latitude": "43.57815000",
                        "longitude": "11.87140000"
                    },
                    {
                        "id": 61135,
                        "name": "Suvereto",
                        "latitude": "43.07669000",
                        "longitude": "10.67740000"
                    },
                    {
                        "id": 61155,
                        "name": "Talla",
                        "latitude": "43.60185000",
                        "longitude": "11.78714000"
                    },
                    {
                        "id": 61180,
                        "name": "Tavarnelle Val di Pesa",
                        "latitude": "43.56184000",
                        "longitude": "11.17152000"
                    },
                    {
                        "id": 61181,
                        "name": "Tavarnuzze",
                        "latitude": "43.71019000",
                        "longitude": "11.21721000"
                    },
                    {
                        "id": 61186,
                        "name": "Taverne D'Arbia",
                        "latitude": "43.29490000",
                        "longitude": "11.39483000"
                    },
                    {
                        "id": 61204,
                        "name": "Tegoleto",
                        "latitude": "43.39458000",
                        "longitude": "11.78530000"
                    },
                    {
                        "id": 61234,
                        "name": "Terontola",
                        "latitude": "43.21009000",
                        "longitude": "12.01113000"
                    },
                    {
                        "id": 61243,
                        "name": "Terranuova Bracciolini",
                        "latitude": "43.55081000",
                        "longitude": "11.58075000"
                    },
                    {
                        "id": 61244,
                        "name": "Terrarossa",
                        "latitude": "44.23362000",
                        "longitude": "9.96110000"
                    },
                    {
                        "id": 61251,
                        "name": "Terricciola",
                        "latitude": "43.52505000",
                        "longitude": "10.67961000"
                    },
                    {
                        "id": 61372,
                        "name": "Torre del Lago Puccini",
                        "latitude": "43.82887000",
                        "longitude": "10.28912000"
                    },
                    {
                        "id": 61385,
                        "name": "Torrenieri",
                        "latitude": "43.08566000",
                        "longitude": "11.54839000"
                    },
                    {
                        "id": 61410,
                        "name": "Torrita di Siena",
                        "latitude": "43.17245000",
                        "longitude": "11.78376000"
                    },
                    {
                        "id": 61472,
                        "name": "Treggiaia",
                        "latitude": "43.62305000",
                        "longitude": "10.67325000"
                    },
                    {
                        "id": 61490,
                        "name": "Trequanda",
                        "latitude": "43.18749000",
                        "longitude": "11.66818000"
                    },
                    {
                        "id": 61492,
                        "name": "Tresana",
                        "latitude": "44.25425000",
                        "longitude": "9.91288000"
                    },
                    {
                        "id": 61589,
                        "name": "Uggia-Pazzera-Bizzarrino",
                        "latitude": "43.83434000",
                        "longitude": "10.83154000"
                    },
                    {
                        "id": 61594,
                        "name": "Uliveto Terme",
                        "latitude": "43.69609000",
                        "longitude": "10.51728000"
                    },
                    {
                        "id": 61621,
                        "name": "Uzzano",
                        "latitude": "43.89728000",
                        "longitude": "10.70403000"
                    },
                    {
                        "id": 61623,
                        "name": "Vacchereccia",
                        "latitude": "43.56099000",
                        "longitude": "11.50131000"
                    },
                    {
                        "id": 61627,
                        "name": "Vada",
                        "latitude": "43.35264000",
                        "longitude": "10.45564000"
                    },
                    {
                        "id": 61633,
                        "name": "Vaglia",
                        "latitude": "43.91070000",
                        "longitude": "11.27997000"
                    },
                    {
                        "id": 61637,
                        "name": "Vaiano",
                        "latitude": "43.96792000",
                        "longitude": "11.12374000"
                    },
                    {
                        "id": 61646,
                        "name": "Val di Cava",
                        "latitude": "43.63832000",
                        "longitude": "10.64896000"
                    },
                    {
                        "id": 61658,
                        "name": "Valdottavo",
                        "latitude": "43.94187000",
                        "longitude": "10.48115000"
                    },
                    {
                        "id": 61666,
                        "name": "Valenzatico",
                        "latitude": "43.86680000",
                        "longitude": "10.96497000"
                    },
                    {
                        "id": 61787,
                        "name": "Vecchiano-Nodica",
                        "latitude": "43.78334000",
                        "longitude": "10.38440000"
                    },
                    {
                        "id": 61829,
                        "name": "Venturina",
                        "latitude": "43.02883000",
                        "longitude": "10.60147000"
                    },
                    {
                        "id": 61857,
                        "name": "Vernio",
                        "latitude": "44.04755000",
                        "longitude": "11.15052000"
                    },
                    {
                        "id": 61879,
                        "name": "Vescovado",
                        "latitude": "43.16953000",
                        "longitude": "11.39198000"
                    },
                    {
                        "id": 61905,
                        "name": "Viareggio",
                        "latitude": "43.86693000",
                        "longitude": "10.25020000"
                    },
                    {
                        "id": 61910,
                        "name": "Vicarello",
                        "latitude": "43.61238000",
                        "longitude": "10.46515000"
                    },
                    {
                        "id": 61913,
                        "name": "Vicchio",
                        "latitude": "43.93413000",
                        "longitude": "11.46004000"
                    },
                    {
                        "id": 61915,
                        "name": "Viciomaggio",
                        "latitude": "43.43218000",
                        "longitude": "11.77323000"
                    },
                    {
                        "id": 61925,
                        "name": "Vicopisano",
                        "latitude": "43.69305000",
                        "longitude": "10.58359000"
                    },
                    {
                        "id": 61957,
                        "name": "Vignale Riotorto",
                        "latitude": "42.97998000",
                        "longitude": "10.68471000"
                    },
                    {
                        "id": 61964,
                        "name": "Vignole-Olmi",
                        "latitude": "43.86696000",
                        "longitude": "10.99045000"
                    },
                    {
                        "id": 61986,
                        "name": "Villa Basilica",
                        "latitude": "43.92572000",
                        "longitude": "10.64518000"
                    },
                    {
                        "id": 61994,
                        "name": "Villa Collemandina",
                        "latitude": "44.15855000",
                        "longitude": "10.39760000"
                    },
                    {
                        "id": 62062,
                        "name": "Villafranca in Lunigiana",
                        "latitude": "44.29844000",
                        "longitude": "9.95347000"
                    },
                    {
                        "id": 62163,
                        "name": "Vinci",
                        "latitude": "43.78133000",
                        "longitude": "10.92365000"
                    },
                    {
                        "id": 62218,
                        "name": "Volterra",
                        "latitude": "43.40251000",
                        "longitude": "10.86152000"
                    },
                    {
                        "id": 62253,
                        "name": "Zeri",
                        "latitude": "44.35375000",
                        "longitude": "9.76318000"
                    }
                ]
            },
            {
                "id": 1764,
                "name": "Udine",
                "iso2": "UD",
                "latitude": "46.14079720",
                "longitude": "13.16628960",
                "type": "decentralized regional entity",
                "cities": []
            },
            {
                "id": 1683,
                "name": "Umbria",
                "iso2": "55",
                "latitude": "42.98519170",
                "longitude": "11.26169080",
                "type": "region",
                "cities": [
                    {
                        "id": 135275,
                        "name": "Acquasparta",
                        "latitude": "42.68915000",
                        "longitude": "12.54275000"
                    },
                    {
                        "id": 135417,
                        "name": "Allerona",
                        "latitude": "42.81174000",
                        "longitude": "11.97451000"
                    },
                    {
                        "id": 135447,
                        "name": "Alviano",
                        "latitude": "42.59084000",
                        "longitude": "12.29775000"
                    },
                    {
                        "id": 135468,
                        "name": "Amelia",
                        "latitude": "42.55177000",
                        "longitude": "12.42076000"
                    },
                    {
                        "id": 135635,
                        "name": "Arrone",
                        "latitude": "42.58266000",
                        "longitude": "12.76714000"
                    },
                    {
                        "id": 135666,
                        "name": "Assisi",
                        "latitude": "43.06671000",
                        "longitude": "12.62109000"
                    },
                    {
                        "id": 135681,
                        "name": "Attigliano",
                        "latitude": "42.51505000",
                        "longitude": "12.29455000"
                    },
                    {
                        "id": 135710,
                        "name": "Avigliano Umbro",
                        "latitude": "42.65303000",
                        "longitude": "12.42571000"
                    },
                    {
                        "id": 135880,
                        "name": "Baschi",
                        "latitude": "42.67324000",
                        "longitude": "12.21762000"
                    },
                    {
                        "id": 135898,
                        "name": "Bastardo",
                        "latitude": "42.87144000",
                        "longitude": "12.55943000"
                    },
                    {
                        "id": 135901,
                        "name": "Bastia umbra",
                        "latitude": "43.06425000",
                        "longitude": "12.54612000"
                    },
                    {
                        "id": 136022,
                        "name": "Bettona",
                        "latitude": "43.01124000",
                        "longitude": "12.48698000"
                    },
                    {
                        "id": 136024,
                        "name": "Bevagna",
                        "latitude": "42.93748000",
                        "longitude": "12.61488000"
                    },
                    {
                        "id": 136368,
                        "name": "Bruna",
                        "latitude": "42.82071000",
                        "longitude": "12.68851000"
                    },
                    {
                        "id": 136559,
                        "name": "Calvi dell'Umbria",
                        "latitude": "42.40421000",
                        "longitude": "12.56771000"
                    },
                    {
                        "id": 136612,
                        "name": "Campello sul Clitunno",
                        "latitude": "42.82685000",
                        "longitude": "12.76931000"
                    },
                    {
                        "id": 136719,
                        "name": "Cannara",
                        "latitude": "42.99540000",
                        "longitude": "12.58202000"
                    },
                    {
                        "id": 136772,
                        "name": "Capitan Loreto",
                        "latitude": "43.01731000",
                        "longitude": "12.64750000"
                    },
                    {
                        "id": 136951,
                        "name": "Casa del Diavolo",
                        "latitude": "43.18762000",
                        "longitude": "12.44923000"
                    },
                    {
                        "id": 137045,
                        "name": "Cascia",
                        "latitude": "42.71790000",
                        "longitude": "13.01697000"
                    },
                    {
                        "id": 137140,
                        "name": "Castel Giorgio",
                        "latitude": "42.70697000",
                        "longitude": "11.97717000"
                    },
                    {
                        "id": 137147,
                        "name": "Castel Ritaldi",
                        "latitude": "42.82247000",
                        "longitude": "12.67420000"
                    },
                    {
                        "id": 137159,
                        "name": "Castel Viscardo",
                        "latitude": "42.75359000",
                        "longitude": "12.00072000"
                    },
                    {
                        "id": 137319,
                        "name": "Casteltodino",
                        "latitude": "42.66667000",
                        "longitude": "12.50000000"
                    },
                    {
                        "id": 137353,
                        "name": "Castiglione del Lago",
                        "latitude": "43.12457000",
                        "longitude": "12.03982000"
                    },
                    {
                        "id": 137520,
                        "name": "Cerbara",
                        "latitude": "43.49913000",
                        "longitude": "12.21113000"
                    },
                    {
                        "id": 137569,
                        "name": "Cerreto di Spoleto",
                        "latitude": "42.82188000",
                        "longitude": "12.92032000"
                    },
                    {
                        "id": 137683,
                        "name": "Chiugiana-La Commenda",
                        "latitude": "43.09823000",
                        "longitude": "12.30818000"
                    },
                    {
                        "id": 137713,
                        "name": "Ciconia",
                        "latitude": "42.73356000",
                        "longitude": "12.13400000"
                    },
                    {
                        "id": 137744,
                        "name": "Cipolleto",
                        "latitude": "43.32393000",
                        "longitude": "12.57688000"
                    },
                    {
                        "id": 137764,
                        "name": "Citerna",
                        "latitude": "43.49882000",
                        "longitude": "12.11376000"
                    },
                    {
                        "id": 137773,
                        "name": "Città della Pieve",
                        "latitude": "42.95934000",
                        "longitude": "12.00696000"
                    },
                    {
                        "id": 137774,
                        "name": "Città di Castello",
                        "latitude": "43.46556000",
                        "longitude": "12.23750000"
                    },
                    {
                        "id": 137858,
                        "name": "Collazzone",
                        "latitude": "42.90147000",
                        "longitude": "12.43582000"
                    },
                    {
                        "id": 137888,
                        "name": "Collepepe",
                        "latitude": "42.91548000",
                        "longitude": "12.39486000"
                    },
                    {
                        "id": 137920,
                        "name": "Colombella",
                        "latitude": "43.15262000",
                        "longitude": "12.48239000"
                    },
                    {
                        "id": 137999,
                        "name": "Corciano",
                        "latitude": "43.12821000",
                        "longitude": "12.28684000"
                    },
                    {
                        "id": 138103,
                        "name": "Costacciaro",
                        "latitude": "43.35866000",
                        "longitude": "12.71262000"
                    },
                    {
                        "id": 138104,
                        "name": "Costano",
                        "latitude": "43.04420000",
                        "longitude": "12.53410000"
                    },
                    {
                        "id": 138252,
                        "name": "Deruta",
                        "latitude": "42.98465000",
                        "longitude": "12.41760000"
                    },
                    {
                        "id": 138397,
                        "name": "Fabro",
                        "latitude": "42.87267000",
                        "longitude": "12.01540000"
                    },
                    {
                        "id": 138398,
                        "name": "Fabro Scalo",
                        "latitude": "42.87605000",
                        "longitude": "12.04624000"
                    },
                    {
                        "id": 138479,
                        "name": "Ferentillo",
                        "latitude": "42.62027000",
                        "longitude": "12.78726000"
                    },
                    {
                        "id": 138506,
                        "name": "Ficulle",
                        "latitude": "42.83194000",
                        "longitude": "12.06801000"
                    },
                    {
                        "id": 138582,
                        "name": "Foligno",
                        "latitude": "42.95488000",
                        "longitude": "12.70268000"
                    },
                    {
                        "id": 138614,
                        "name": "Fontignano",
                        "latitude": "43.02436000",
                        "longitude": "12.19190000"
                    },
                    {
                        "id": 138658,
                        "name": "Fornole",
                        "latitude": "42.54218000",
                        "longitude": "12.45576000"
                    },
                    {
                        "id": 138677,
                        "name": "Fossato di Vico",
                        "latitude": "43.29644000",
                        "longitude": "12.76121000"
                    },
                    {
                        "id": 138721,
                        "name": "Fratta Todina",
                        "latitude": "42.85684000",
                        "longitude": "12.36366000"
                    },
                    {
                        "id": 138943,
                        "name": "Giano dell'Umbria",
                        "latitude": "42.83384000",
                        "longitude": "12.57777000"
                    },
                    {
                        "id": 138976,
                        "name": "Giove",
                        "latitude": "42.50988000",
                        "longitude": "12.33015000"
                    },
                    {
                        "id": 139146,
                        "name": "Gualdo Cattaneo",
                        "latitude": "42.91228000",
                        "longitude": "12.55666000"
                    },
                    {
                        "id": 139147,
                        "name": "Gualdo Tadino",
                        "latitude": "43.22941000",
                        "longitude": "12.77862000"
                    },
                    {
                        "id": 139158,
                        "name": "Guardea",
                        "latitude": "42.62370000",
                        "longitude": "12.29928000"
                    },
                    {
                        "id": 139173,
                        "name": "Gubbio",
                        "latitude": "43.34996000",
                        "longitude": "12.57309000"
                    },
                    {
                        "id": 139317,
                        "name": "Lacugnano",
                        "latitude": "43.09475000",
                        "longitude": "12.33150000"
                    },
                    {
                        "id": 139539,
                        "name": "Lisciano Niccone",
                        "latitude": "43.24684000",
                        "longitude": "12.14305000"
                    },
                    {
                        "id": 139647,
                        "name": "Lugnano in Teverina",
                        "latitude": "42.57592000",
                        "longitude": "12.33336000"
                    },
                    {
                        "id": 139720,
                        "name": "Magione",
                        "latitude": "43.14179000",
                        "longitude": "12.21169000"
                    },
                    {
                        "id": 139809,
                        "name": "Mantignana",
                        "latitude": "43.15992000",
                        "longitude": "12.28855000"
                    },
                    {
                        "id": 139920,
                        "name": "Marsciano",
                        "latitude": "42.92093000",
                        "longitude": "12.35066000"
                    },
                    {
                        "id": 139974,
                        "name": "Massa Martana",
                        "latitude": "42.77312000",
                        "longitude": "12.52579000"
                    },
                    {
                        "id": 140028,
                        "name": "Meggiano",
                        "latitude": "42.75474000",
                        "longitude": "12.86379000"
                    },
                    {
                        "id": 140354,
                        "name": "Monte Castello di Vibio",
                        "latitude": "42.84040000",
                        "longitude": "12.35240000"
                    },
                    {
                        "id": 140359,
                        "name": "Monte Grimano",
                        "latitude": "43.46667000",
                        "longitude": "12.46667000"
                    },
                    {
                        "id": 140380,
                        "name": "Monte Santa Maria Tiberina",
                        "latitude": "43.43688000",
                        "longitude": "12.16220000"
                    },
                    {
                        "id": 140404,
                        "name": "Montecastrilli",
                        "latitude": "42.65087000",
                        "longitude": "12.48811000"
                    },
                    {
                        "id": 140409,
                        "name": "Montecchio",
                        "latitude": "42.66234000",
                        "longitude": "12.28803000"
                    },
                    {
                        "id": 140430,
                        "name": "Montefalco",
                        "latitude": "42.89084000",
                        "longitude": "12.64827000"
                    },
                    {
                        "id": 140447,
                        "name": "Montefranco",
                        "latitude": "42.59835000",
                        "longitude": "12.76376000"
                    },
                    {
                        "id": 140450,
                        "name": "Montegabbione",
                        "latitude": "42.91973000",
                        "longitude": "12.09212000"
                    },
                    {
                        "id": 140469,
                        "name": "Monteleone d'Orvieto",
                        "latitude": "42.92171000",
                        "longitude": "12.05347000"
                    },
                    {
                        "id": 140472,
                        "name": "Monteleone di Spoleto",
                        "latitude": "42.65046000",
                        "longitude": "12.95158000"
                    },
                    {
                        "id": 140579,
                        "name": "Montone",
                        "latitude": "43.36078000",
                        "longitude": "12.32346000"
                    },
                    {
                        "id": 140719,
                        "name": "Narni",
                        "latitude": "42.51956000",
                        "longitude": "12.52758000"
                    },
                    {
                        "id": 140720,
                        "name": "Narni Scalo",
                        "latitude": "42.53620000",
                        "longitude": "12.51680000"
                    },
                    {
                        "id": 140786,
                        "name": "Nocera Umbra",
                        "latitude": "43.11400000",
                        "longitude": "12.78925000"
                    },
                    {
                        "id": 140807,
                        "name": "Norcia",
                        "latitude": "42.79105000",
                        "longitude": "13.09600000"
                    },
                    {
                        "id": 140993,
                        "name": "Orvieto",
                        "latitude": "42.71924000",
                        "longitude": "12.11249000"
                    },
                    {
                        "id": 140994,
                        "name": "Orvieto Scalo",
                        "latitude": "42.72088000",
                        "longitude": "12.13402000"
                    },
                    {
                        "id": 141001,
                        "name": "Oscano",
                        "latitude": "43.15863000",
                        "longitude": "12.33776000"
                    },
                    {
                        "id": 141021,
                        "name": "Ospedalicchio",
                        "latitude": "43.07812000",
                        "longitude": "12.50074000"
                    },
                    {
                        "id": 141039,
                        "name": "Osteria del Gatto",
                        "latitude": "43.28504000",
                        "longitude": "12.74504000"
                    },
                    {
                        "id": 141046,
                        "name": "Otricoli",
                        "latitude": "42.42079000",
                        "longitude": "12.47737000"
                    },
                    {
                        "id": 141072,
                        "name": "Paciano",
                        "latitude": "43.02288000",
                        "longitude": "12.06788000"
                    },
                    {
                        "id": 141089,
                        "name": "Padule-San Marco",
                        "latitude": "43.32880000",
                        "longitude": "12.60942000"
                    },
                    {
                        "id": 58227,
                        "name": "Palazzo",
                        "latitude": "43.09708000",
                        "longitude": "12.56436000"
                    },
                    {
                        "id": 58278,
                        "name": "Panicale",
                        "latitude": "43.02830000",
                        "longitude": "12.09993000"
                    },
                    {
                        "id": 58283,
                        "name": "Pantalla",
                        "latitude": "42.87287000",
                        "longitude": "12.39861000"
                    },
                    {
                        "id": 58314,
                        "name": "Parrano",
                        "latitude": "42.86624000",
                        "longitude": "12.11026000"
                    },
                    {
                        "id": 58325,
                        "name": "Passaggio",
                        "latitude": "43.02239000",
                        "longitude": "12.50781000"
                    },
                    {
                        "id": 58328,
                        "name": "Passignano sul Trasimeno",
                        "latitude": "43.19043000",
                        "longitude": "12.13535000"
                    },
                    {
                        "id": 58404,
                        "name": "Penna in Teverina",
                        "latitude": "42.49342000",
                        "longitude": "12.35845000"
                    },
                    {
                        "id": 58446,
                        "name": "Perugia",
                        "latitude": "43.11220000",
                        "longitude": "12.38878000"
                    },
                    {
                        "id": 58482,
                        "name": "Petrignano",
                        "latitude": "43.10269000",
                        "longitude": "12.53239000"
                    },
                    {
                        "id": 58595,
                        "name": "Piegaro",
                        "latitude": "42.96596000",
                        "longitude": "12.08409000"
                    },
                    {
                        "id": 58615,
                        "name": "Pietralunga",
                        "latitude": "43.43609000",
                        "longitude": "12.42921000"
                    },
                    {
                        "id": 58666,
                        "name": "Pila",
                        "latitude": "43.05329000",
                        "longitude": "12.32857000"
                    },
                    {
                        "id": 58715,
                        "name": "Pistrino",
                        "latitude": "43.50966000",
                        "longitude": "12.15181000"
                    },
                    {
                        "id": 58767,
                        "name": "Poggiodomo",
                        "latitude": "42.71237000",
                        "longitude": "12.93251000"
                    },
                    {
                        "id": 58792,
                        "name": "Polino",
                        "latitude": "42.58423000",
                        "longitude": "12.84437000"
                    },
                    {
                        "id": 58839,
                        "name": "Ponte Felcino",
                        "latitude": "43.13049000",
                        "longitude": "12.44914000"
                    },
                    {
                        "id": 58845,
                        "name": "Ponte Pattoli",
                        "latitude": "43.17807000",
                        "longitude": "12.42842000"
                    },
                    {
                        "id": 58877,
                        "name": "Ponterio-Pian di Porto",
                        "latitude": "42.80769000",
                        "longitude": "12.41024000"
                    },
                    {
                        "id": 58902,
                        "name": "Porano",
                        "latitude": "42.68099000",
                        "longitude": "12.10331000"
                    },
                    {
                        "id": 58990,
                        "name": "Pozzuolo",
                        "latitude": "43.12165000",
                        "longitude": "11.95599000"
                    },
                    {
                        "id": 59042,
                        "name": "Preci",
                        "latitude": "42.88069000",
                        "longitude": "13.03747000"
                    },
                    {
                        "id": 59158,
                        "name": "Provincia di Perugia",
                        "latitude": "43.05000000",
                        "longitude": "12.55000000"
                    },
                    {
                        "id": 59180,
                        "name": "Provincia di Terni",
                        "latitude": "42.68333000",
                        "longitude": "12.31667000"
                    },
                    {
                        "id": 59444,
                        "name": "Rivotorto",
                        "latitude": "43.04406000",
                        "longitude": "12.62069000"
                    },
                    {
                        "id": 59931,
                        "name": "San Gemini",
                        "latitude": "42.61378000",
                        "longitude": "12.54528000"
                    },
                    {
                        "id": 59940,
                        "name": "San Giacomo",
                        "latitude": "42.79387000",
                        "longitude": "12.75243000"
                    },
                    {
                        "id": 60015,
                        "name": "San Giustino",
                        "latitude": "43.54660000",
                        "longitude": "12.17528000"
                    },
                    {
                        "id": 60090,
                        "name": "San Martino in Campo",
                        "latitude": "43.03608000",
                        "longitude": "12.40265000"
                    },
                    {
                        "id": 60096,
                        "name": "San Martino in Trignano",
                        "latitude": "42.74125000",
                        "longitude": "12.66836000"
                    },
                    {
                        "id": 60133,
                        "name": "San Niccolò di Celle",
                        "latitude": "43.01667000",
                        "longitude": "12.38333000"
                    },
                    {
                        "id": 60239,
                        "name": "San Secondo",
                        "latitude": "43.40468000",
                        "longitude": "12.23389000"
                    },
                    {
                        "id": 60254,
                        "name": "San Terenziano",
                        "latitude": "42.86731000",
                        "longitude": "12.47319000"
                    },
                    {
                        "id": 60261,
                        "name": "San Venanzo",
                        "latitude": "42.86886000",
                        "longitude": "12.26853000"
                    },
                    {
                        "id": 60341,
                        "name": "Sant'Anatolia di Narco",
                        "latitude": "42.73319000",
                        "longitude": "12.83576000"
                    },
                    {
                        "id": 60471,
                        "name": "Santa Maria degli Angeli",
                        "latitude": "43.05691000",
                        "longitude": "12.57497000"
                    },
                    {
                        "id": 60641,
                        "name": "Scheggia",
                        "latitude": "43.40364000",
                        "longitude": "12.66584000"
                    },
                    {
                        "id": 60642,
                        "name": "Scheggino",
                        "latitude": "42.71304000",
                        "longitude": "12.83007000"
                    },
                    {
                        "id": 60696,
                        "name": "Selci-Lama",
                        "latitude": "43.51719000",
                        "longitude": "12.21293000"
                    },
                    {
                        "id": 60699,
                        "name": "Sellano",
                        "latitude": "42.88735000",
                        "longitude": "12.92311000"
                    },
                    {
                        "id": 60716,
                        "name": "Semonte-Casamorcia",
                        "latitude": "43.36826000",
                        "longitude": "12.53064000"
                    },
                    {
                        "id": 60828,
                        "name": "Sferracavallo",
                        "latitude": "42.72631000",
                        "longitude": "12.09569000"
                    },
                    {
                        "id": 60845,
                        "name": "Sigillo",
                        "latitude": "43.33111000",
                        "longitude": "12.74059000"
                    },
                    {
                        "id": 60995,
                        "name": "Spello",
                        "latitude": "42.99231000",
                        "longitude": "12.66632000"
                    },
                    {
                        "id": 61026,
                        "name": "Spoleto",
                        "latitude": "42.74071000",
                        "longitude": "12.73899000"
                    },
                    {
                        "id": 61055,
                        "name": "Stazione di Allerona",
                        "latitude": "42.78550000",
                        "longitude": "12.03726000"
                    },
                    {
                        "id": 61056,
                        "name": "Stazione di Padule",
                        "latitude": "43.30766000",
                        "longitude": "12.61557000"
                    },
                    {
                        "id": 61098,
                        "name": "Stroncone",
                        "latitude": "42.51196000",
                        "longitude": "12.64770000"
                    },
                    {
                        "id": 61187,
                        "name": "Tavernelle",
                        "latitude": "43.00333000",
                        "longitude": "12.14520000"
                    },
                    {
                        "id": 61232,
                        "name": "Terni",
                        "latitude": "42.56335000",
                        "longitude": "12.64329000"
                    },
                    {
                        "id": 61295,
                        "name": "Todi",
                        "latitude": "42.77881000",
                        "longitude": "12.41202000"
                    },
                    {
                        "id": 61327,
                        "name": "Torgiano",
                        "latitude": "43.02761000",
                        "longitude": "12.44015000"
                    },
                    {
                        "id": 61499,
                        "name": "Trestina",
                        "latitude": "43.36597000",
                        "longitude": "12.23701000"
                    },
                    {
                        "id": 61501,
                        "name": "Trevi",
                        "latitude": "42.87769000",
                        "longitude": "12.74938000"
                    },
                    {
                        "id": 61569,
                        "name": "Tuoro sul Trasimeno",
                        "latitude": "43.20654000",
                        "longitude": "12.07465000"
                    },
                    {
                        "id": 61597,
                        "name": "Umbertide",
                        "latitude": "43.30341000",
                        "longitude": "12.33749000"
                    },
                    {
                        "id": 61668,
                        "name": "Valfabbrica",
                        "latitude": "43.15784000",
                        "longitude": "12.60202000"
                    },
                    {
                        "id": 61742,
                        "name": "Valtopina",
                        "latitude": "43.05674000",
                        "longitude": "12.75307000"
                    },
                    {
                        "id": 61898,
                        "name": "Via Lippia",
                        "latitude": "43.08611000",
                        "longitude": "12.48106000"
                    }
                ]
            },
            {
                "id": 1765,
                "name": "Varese",
                "iso2": "VA",
                "latitude": "45.79902600",
                "longitude": "8.73009450",
                "type": "province",
                "cities": []
            },
            {
                "id": 1753,
                "name": "Veneto",
                "iso2": "34",
                "latitude": "45.44146620",
                "longitude": "12.31525950",
                "type": "region",
                "cities": [
                    {
                        "id": 135235,
                        "name": "Abano Terme",
                        "latitude": "45.35753000",
                        "longitude": "11.78725000"
                    },
                    {
                        "id": 135242,
                        "name": "Abbazia Pisani",
                        "latitude": "45.61270000",
                        "longitude": "11.85429000"
                    },
                    {
                        "id": 135290,
                        "name": "Adria",
                        "latitude": "45.05445000",
                        "longitude": "12.05599000"
                    },
                    {
                        "id": 135292,
                        "name": "Affi",
                        "latitude": "45.55297000",
                        "longitude": "10.78640000"
                    },
                    {
                        "id": 135307,
                        "name": "Agna",
                        "latitude": "45.17051000",
                        "longitude": "11.95625000"
                    },
                    {
                        "id": 135312,
                        "name": "Agordo",
                        "latitude": "46.28201000",
                        "longitude": "12.03608000"
                    },
                    {
                        "id": 135321,
                        "name": "Agugliaro",
                        "latitude": "45.32510000",
                        "longitude": "11.58496000"
                    },
                    {
                        "id": 135343,
                        "name": "Alano di Piave",
                        "latitude": "45.90681000",
                        "longitude": "11.90840000"
                    },
                    {
                        "id": 135355,
                        "name": "Albaredo",
                        "latitude": "45.66725000",
                        "longitude": "12.01095000"
                    },
                    {
                        "id": 135358,
                        "name": "Albaredo d'Adige",
                        "latitude": "45.31859000",
                        "longitude": "11.27843000"
                    },
                    {
                        "id": 135368,
                        "name": "Albettone",
                        "latitude": "45.35811000",
                        "longitude": "11.58430000"
                    },
                    {
                        "id": 135376,
                        "name": "Albignasego",
                        "latitude": "45.34705000",
                        "longitude": "11.86781000"
                    },
                    {
                        "id": 135415,
                        "name": "Alleghe",
                        "latitude": "46.40718000",
                        "longitude": "12.02336000"
                    },
                    {
                        "id": 135424,
                        "name": "Alonte",
                        "latitude": "45.36589000",
                        "longitude": "11.42710000"
                    },
                    {
                        "id": 135427,
                        "name": "Alpo",
                        "latitude": "45.37687000",
                        "longitude": "10.91979000"
                    },
                    {
                        "id": 135436,
                        "name": "Altavilla Vicentina",
                        "latitude": "45.51329000",
                        "longitude": "11.46877000"
                    },
                    {
                        "id": 135441,
                        "name": "Altissimo",
                        "latitude": "45.61429000",
                        "longitude": "11.25189000"
                    },
                    {
                        "id": 135442,
                        "name": "Altivole",
                        "latitude": "45.75370000",
                        "longitude": "11.95620000"
                    },
                    {
                        "id": 135498,
                        "name": "Angiari",
                        "latitude": "45.22318000",
                        "longitude": "11.27680000"
                    },
                    {
                        "id": 135503,
                        "name": "Anguillara Veneta",
                        "latitude": "45.14249000",
                        "longitude": "11.88461000"
                    },
                    {
                        "id": 135506,
                        "name": "Annone Veneto",
                        "latitude": "45.78965000",
                        "longitude": "12.68646000"
                    },
                    {
                        "id": 135555,
                        "name": "Arbizzano-Santa Maria",
                        "latitude": "45.49489000",
                        "longitude": "10.93831000"
                    },
                    {
                        "id": 135559,
                        "name": "Arcade",
                        "latitude": "45.78428000",
                        "longitude": "12.21972000"
                    },
                    {
                        "id": 135572,
                        "name": "Arcole",
                        "latitude": "45.36125000",
                        "longitude": "11.28750000"
                    },
                    {
                        "id": 135575,
                        "name": "Arcugnano-Torri",
                        "latitude": "45.49579000",
                        "longitude": "11.54770000"
                    },
                    {
                        "id": 135598,
                        "name": "Ariano",
                        "latitude": "44.94604000",
                        "longitude": "12.12448000"
                    },
                    {
                        "id": 135605,
                        "name": "Arino",
                        "latitude": "45.43854000",
                        "longitude": "12.05443000"
                    },
                    {
                        "id": 135611,
                        "name": "Arlesega",
                        "latitude": "45.46126000",
                        "longitude": "11.71942000"
                    },
                    {
                        "id": 135632,
                        "name": "Arquà Petrarca",
                        "latitude": "45.26911000",
                        "longitude": "11.72045000"
                    },
                    {
                        "id": 135633,
                        "name": "Arquà Polesine",
                        "latitude": "45.01008000",
                        "longitude": "11.73981000"
                    },
                    {
                        "id": 135634,
                        "name": "Arre",
                        "latitude": "45.21748000",
                        "longitude": "11.92858000"
                    },
                    {
                        "id": 135639,
                        "name": "Arsiè",
                        "latitude": "45.98211000",
                        "longitude": "11.75794000"
                    },
                    {
                        "id": 135637,
                        "name": "Arsiero",
                        "latitude": "45.80422000",
                        "longitude": "11.35582000"
                    },
                    {
                        "id": 135651,
                        "name": "Arzergrande",
                        "latitude": "45.27278000",
                        "longitude": "12.04840000"
                    },
                    {
                        "id": 135652,
                        "name": "Arzignano",
                        "latitude": "45.52027000",
                        "longitude": "11.33446000"
                    },
                    {
                        "id": 135658,
                        "name": "Asiago",
                        "latitude": "45.87588000",
                        "longitude": "11.51223000"
                    },
                    {
                        "id": 135659,
                        "name": "Asigliano Veneto",
                        "latitude": "45.30469000",
                        "longitude": "11.44640000"
                    },
                    {
                        "id": 135662,
                        "name": "Asolo",
                        "latitude": "45.78854000",
                        "longitude": "11.91701000"
                    },
                    {
                        "id": 135663,
                        "name": "Asparetto",
                        "latitude": "45.21991000",
                        "longitude": "11.18263000"
                    },
                    {
                        "id": 135693,
                        "name": "Auronzo",
                        "latitude": "46.55920000",
                        "longitude": "12.42456000"
                    },
                    {
                        "id": 135735,
                        "name": "Badia Calavena",
                        "latitude": "45.56463000",
                        "longitude": "11.15197000"
                    },
                    {
                        "id": 135737,
                        "name": "Badia Polesine",
                        "latitude": "45.09508000",
                        "longitude": "11.49443000"
                    },
                    {
                        "id": 135741,
                        "name": "Badoere",
                        "latitude": "45.63420000",
                        "longitude": "12.08518000"
                    },
                    {
                        "id": 135765,
                        "name": "Bagnoli di Sopra",
                        "latitude": "45.18667000",
                        "longitude": "11.88433000"
                    },
                    {
                        "id": 135766,
                        "name": "Bagnolo",
                        "latitude": "45.27238000",
                        "longitude": "10.89081000"
                    },
                    {
                        "id": 135772,
                        "name": "Bagnolo di Po",
                        "latitude": "45.01548000",
                        "longitude": "11.50091000"
                    },
                    {
                        "id": 135791,
                        "name": "Ballò",
                        "latitude": "45.45581000",
                        "longitude": "12.07124000"
                    },
                    {
                        "id": 135807,
                        "name": "Baone",
                        "latitude": "45.24174000",
                        "longitude": "11.68463000"
                    },
                    {
                        "id": 135821,
                        "name": "Barbarano Vicentino",
                        "latitude": "45.40912000",
                        "longitude": "11.54342000"
                    },
                    {
                        "id": 135832,
                        "name": "Barbisano",
                        "latitude": "45.88224000",
                        "longitude": "12.18632000"
                    },
                    {
                        "id": 135833,
                        "name": "Barbona",
                        "latitude": "45.10339000",
                        "longitude": "11.70486000"
                    },
                    {
                        "id": 135842,
                        "name": "Bardolino",
                        "latitude": "45.54114000",
                        "longitude": "10.73298000"
                    },
                    {
                        "id": 135871,
                        "name": "Baruchella",
                        "latitude": "45.06601000",
                        "longitude": "11.45208000"
                    },
                    {
                        "id": 135893,
                        "name": "Bassano del Grappa",
                        "latitude": "45.76656000",
                        "longitude": "11.72739000"
                    },
                    {
                        "id": 135897,
                        "name": "Bassone",
                        "latitude": "45.45110000",
                        "longitude": "10.89449000"
                    },
                    {
                        "id": 135899,
                        "name": "Bastia",
                        "latitude": "45.38609000",
                        "longitude": "11.65196000"
                    },
                    {
                        "id": 135905,
                        "name": "Battaglia Terme",
                        "latitude": "45.28531000",
                        "longitude": "11.78375000"
                    },
                    {
                        "id": 135916,
                        "name": "Beccacivetta-Azzano",
                        "latitude": "45.37435000",
                        "longitude": "10.96133000"
                    },
                    {
                        "id": 135927,
                        "name": "Belfiore",
                        "latitude": "45.38189000",
                        "longitude": "11.21085000"
                    },
                    {
                        "id": 135949,
                        "name": "Belluno",
                        "latitude": "46.14262000",
                        "longitude": "12.21560000"
                    },
                    {
                        "id": 135961,
                        "name": "Belvedere",
                        "latitude": "45.69001000",
                        "longitude": "11.77180000"
                    },
                    {
                        "id": 135988,
                        "name": "Bergantino",
                        "latitude": "45.06145000",
                        "longitude": "11.25237000"
                    },
                    {
                        "id": 136002,
                        "name": "Bertipaglia",
                        "latitude": "45.31594000",
                        "longitude": "11.88547000"
                    },
                    {
                        "id": 136026,
                        "name": "Bevilacqua",
                        "latitude": "45.23249000",
                        "longitude": "11.39496000"
                    },
                    {
                        "id": 136027,
                        "name": "Biancade",
                        "latitude": "45.64867000",
                        "longitude": "12.35753000"
                    },
                    {
                        "id": 136037,
                        "name": "Bibano",
                        "latitude": "45.90751000",
                        "longitude": "12.43266000"
                    },
                    {
                        "id": 136042,
                        "name": "Bibione",
                        "latitude": "45.63565000",
                        "longitude": "13.03616000"
                    },
                    {
                        "id": 136050,
                        "name": "Bigolino",
                        "latitude": "45.86669000",
                        "longitude": "12.01693000"
                    },
                    {
                        "id": 136084,
                        "name": "Boara Pisani",
                        "latitude": "45.10809000",
                        "longitude": "11.78271000"
                    },
                    {
                        "id": 136100,
                        "name": "Bojon-Lova",
                        "latitude": "45.33981000",
                        "longitude": "12.08282000"
                    },
                    {
                        "id": 136117,
                        "name": "Bolzano Vicentino",
                        "latitude": "45.60221000",
                        "longitude": "11.62198000"
                    },
                    {
                        "id": 136127,
                        "name": "Bonavicina",
                        "latitude": "45.24426000",
                        "longitude": "11.18419000"
                    },
                    {
                        "id": 136128,
                        "name": "Bonavigo",
                        "latitude": "45.25831000",
                        "longitude": "11.27944000"
                    },
                    {
                        "id": 136137,
                        "name": "Bonferraro",
                        "latitude": "45.18380000",
                        "longitude": "11.01201000"
                    },
                    {
                        "id": 136146,
                        "name": "Borca",
                        "latitude": "46.43452000",
                        "longitude": "12.22230000"
                    },
                    {
                        "id": 136215,
                        "name": "Borgoricco-San Michele delle Badesse-Sant'Eufemia",
                        "latitude": "45.53520000",
                        "longitude": "11.94111000"
                    },
                    {
                        "id": 136229,
                        "name": "Borso del Grappa",
                        "latitude": "45.81025000",
                        "longitude": "11.77367000"
                    },
                    {
                        "id": 136232,
                        "name": "Bortolot",
                        "latitude": "46.38608000",
                        "longitude": "12.17371000"
                    },
                    {
                        "id": 136237,
                        "name": "Bosaro",
                        "latitude": "44.99878000",
                        "longitude": "11.76471000"
                    },
                    {
                        "id": 136239,
                        "name": "Boschi Sant'Anna",
                        "latitude": "45.21768000",
                        "longitude": "11.35620000"
                    },
                    {
                        "id": 136240,
                        "name": "Bosco",
                        "latitude": "45.44337000",
                        "longitude": "11.79530000"
                    },
                    {
                        "id": 136241,
                        "name": "Bosco Chiesanuova",
                        "latitude": "45.62103000",
                        "longitude": "11.03224000"
                    },
                    {
                        "id": 136245,
                        "name": "Boscochiaro",
                        "latitude": "45.13658000",
                        "longitude": "12.12182000"
                    },
                    {
                        "id": 136263,
                        "name": "Bottrighe",
                        "latitude": "45.02552000",
                        "longitude": "12.08236000"
                    },
                    {
                        "id": 136274,
                        "name": "Bovolenta",
                        "latitude": "45.26892000",
                        "longitude": "11.93576000"
                    },
                    {
                        "id": 136275,
                        "name": "Bovolone",
                        "latitude": "45.26142000",
                        "longitude": "11.11786000"
                    },
                    {
                        "id": 136283,
                        "name": "Braglia",
                        "latitude": "44.98446000",
                        "longitude": "12.03377000"
                    },
                    {
                        "id": 136292,
                        "name": "Breda",
                        "latitude": "45.72250000",
                        "longitude": "12.33083000"
                    },
                    {
                        "id": 136294,
                        "name": "Breganze",
                        "latitude": "45.70489000",
                        "longitude": "11.56074000"
                    },
                    {
                        "id": 136303,
                        "name": "Brendola",
                        "latitude": "45.47849000",
                        "longitude": "11.43947000"
                    },
                    {
                        "id": 136309,
                        "name": "Brentino Belluno",
                        "latitude": "45.65689000",
                        "longitude": "10.89368000"
                    },
                    {
                        "id": 136311,
                        "name": "Brenzone",
                        "latitude": "45.69989000",
                        "longitude": "10.76058000"
                    },
                    {
                        "id": 136319,
                        "name": "Bressanvido",
                        "latitude": "45.64651000",
                        "longitude": "11.63437000"
                    },
                    {
                        "id": 136346,
                        "name": "Brogliano",
                        "latitude": "45.58919000",
                        "longitude": "11.36549000"
                    },
                    {
                        "id": 136348,
                        "name": "Brognoligo-Costalunga",
                        "latitude": "45.44869000",
                        "longitude": "11.29379000"
                    },
                    {
                        "id": 136363,
                        "name": "Brugine",
                        "latitude": "45.29696000",
                        "longitude": "11.99200000"
                    },
                    {
                        "id": 136410,
                        "name": "Burano",
                        "latitude": "45.48548000",
                        "longitude": "12.41696000"
                    },
                    {
                        "id": 136427,
                        "name": "Buso",
                        "latitude": "45.06491000",
                        "longitude": "11.84772000"
                    },
                    {
                        "id": 136432,
                        "name": "Bussolengo",
                        "latitude": "45.46903000",
                        "longitude": "10.85371000"
                    },
                    {
                        "id": 136438,
                        "name": "Buttapietra",
                        "latitude": "45.34110000",
                        "longitude": "10.99915000"
                    },
                    {
                        "id": 136446,
                        "name": "Ca' degli Oppi",
                        "latitude": "45.29550000",
                        "longitude": "11.13029000"
                    },
                    {
                        "id": 136442,
                        "name": "Ca' Rainati",
                        "latitude": "45.75764000",
                        "longitude": "11.85113000"
                    },
                    {
                        "id": 136443,
                        "name": "Ca' Savio",
                        "latitude": "45.45375000",
                        "longitude": "12.45729000"
                    },
                    {
                        "id": 136444,
                        "name": "Ca' Tiepolo",
                        "latitude": "44.94861000",
                        "longitude": "12.33917000"
                    },
                    {
                        "id": 136460,
                        "name": "Cadoneghe",
                        "latitude": "45.44282000",
                        "longitude": "11.92749000"
                    },
                    {
                        "id": 136464,
                        "name": "Caerano di San Marco",
                        "latitude": "45.78160000",
                        "longitude": "11.99851000"
                    },
                    {
                        "id": 136487,
                        "name": "Calalzo di Cadore",
                        "latitude": "46.44643000",
                        "longitude": "12.38176000"
                    },
                    {
                        "id": 136516,
                        "name": "Caldierino-Rota",
                        "latitude": "45.41616000",
                        "longitude": "11.15696000"
                    },
                    {
                        "id": 136517,
                        "name": "Caldiero",
                        "latitude": "45.41439000",
                        "longitude": "11.17739000"
                    },
                    {
                        "id": 136519,
                        "name": "Caldogno-Rettorgole-Cresole",
                        "latitude": "45.60780000",
                        "longitude": "11.50280000"
                    },
                    {
                        "id": 136534,
                        "name": "Calmasino",
                        "latitude": "45.52099000",
                        "longitude": "10.75206000"
                    },
                    {
                        "id": 136542,
                        "name": "Caltana",
                        "latitude": "45.48278000",
                        "longitude": "12.03002000"
                    },
                    {
                        "id": 136546,
                        "name": "Calto",
                        "latitude": "44.99072000",
                        "longitude": "11.35854000"
                    },
                    {
                        "id": 136547,
                        "name": "Caltrano",
                        "latitude": "45.77346000",
                        "longitude": "11.45570000"
                    },
                    {
                        "id": 136554,
                        "name": "Calvene",
                        "latitude": "45.76615000",
                        "longitude": "11.51146000"
                    },
                    {
                        "id": 136569,
                        "name": "Camalò",
                        "latitude": "45.75324000",
                        "longitude": "12.17165000"
                    },
                    {
                        "id": 136593,
                        "name": "Camisano Vicentino",
                        "latitude": "45.52156000",
                        "longitude": "11.70817000"
                    },
                    {
                        "id": 136600,
                        "name": "Campagna Lupia",
                        "latitude": "45.35381000",
                        "longitude": "12.09727000"
                    },
                    {
                        "id": 136603,
                        "name": "Campagnola",
                        "latitude": "45.27866000",
                        "longitude": "11.99902000"
                    },
                    {
                        "id": 136606,
                        "name": "Campalto",
                        "latitude": "45.48062000",
                        "longitude": "12.28747000"
                    },
                    {
                        "id": 136614,
                        "name": "Campese",
                        "latitude": "45.80580000",
                        "longitude": "11.71289000"
                    },
                    {
                        "id": 136619,
                        "name": "Campiglia dei Berici",
                        "latitude": "45.33546000",
                        "longitude": "11.54210000"
                    },
                    {
                        "id": 136631,
                        "name": "Campo San Martino",
                        "latitude": "45.54868000",
                        "longitude": "11.82809000"
                    },
                    {
                        "id": 136644,
                        "name": "Campodarsego",
                        "latitude": "45.49815000",
                        "longitude": "11.92194000"
                    },
                    {
                        "id": 136649,
                        "name": "Campodoro",
                        "latitude": "45.48947000",
                        "longitude": "11.75268000"
                    },
                    {
                        "id": 136663,
                        "name": "Campolongo Maggiore Liettoli",
                        "latitude": "45.33944000",
                        "longitude": "12.02417000"
                    },
                    {
                        "id": 136666,
                        "name": "Campolongo sul Brenta",
                        "latitude": "45.82710000",
                        "longitude": "11.70080000"
                    },
                    {
                        "id": 136671,
                        "name": "Camponogara",
                        "latitude": "45.37954000",
                        "longitude": "12.08638000"
                    },
                    {
                        "id": 136679,
                        "name": "Camposampiero",
                        "latitude": "45.56368000",
                        "longitude": "11.93534000"
                    },
                    {
                        "id": 136689,
                        "name": "Canale d'Agordo",
                        "latitude": "46.35693000",
                        "longitude": "11.91429000"
                    },
                    {
                        "id": 136691,
                        "name": "Canaro",
                        "latitude": "44.93394000",
                        "longitude": "11.67541000"
                    },
                    {
                        "id": 136696,
                        "name": "Canda",
                        "latitude": "45.03608000",
                        "longitude": "11.50331000"
                    },
                    {
                        "id": 136699,
                        "name": "Candelù",
                        "latitude": "45.73499000",
                        "longitude": "12.37224000"
                    },
                    {
                        "id": 136702,
                        "name": "Candiana",
                        "latitude": "45.22184000",
                        "longitude": "11.99256000"
                    },
                    {
                        "id": 136704,
                        "name": "Candide",
                        "latitude": "46.58913000",
                        "longitude": "12.51476000"
                    },
                    {
                        "id": 136713,
                        "name": "Caniezza",
                        "latitude": "45.85274000",
                        "longitude": "11.89900000"
                    },
                    {
                        "id": 136735,
                        "name": "Canove di Roana",
                        "latitude": "45.86350000",
                        "longitude": "11.47350000"
                    },
                    {
                        "id": 136754,
                        "name": "Caorle",
                        "latitude": "45.59656000",
                        "longitude": "12.87580000"
                    },
                    {
                        "id": 136773,
                        "name": "Capitello",
                        "latitude": "45.20792000",
                        "longitude": "11.14014000"
                    },
                    {
                        "id": 136792,
                        "name": "Cappella Maggiore",
                        "latitude": "45.97222000",
                        "longitude": "12.35855000"
                    },
                    {
                        "id": 136822,
                        "name": "Caprino Veronese",
                        "latitude": "45.60489000",
                        "longitude": "10.79518000"
                    },
                    {
                        "id": 136851,
                        "name": "Carbonera",
                        "latitude": "45.69182000",
                        "longitude": "12.28255000"
                    },
                    {
                        "id": 136854,
                        "name": "Carceri",
                        "latitude": "45.19508000",
                        "longitude": "11.62115000"
                    },
                    {
                        "id": 136893,
                        "name": "Carmignano di Brenta",
                        "latitude": "45.62578000",
                        "longitude": "11.70599000"
                    },
                    {
                        "id": 136912,
                        "name": "Carpesica",
                        "latitude": "45.95335000",
                        "longitude": "12.29126000"
                    },
                    {
                        "id": 136925,
                        "name": "Carrara San Giorgio",
                        "latitude": "45.29259000",
                        "longitude": "11.81841000"
                    },
                    {
                        "id": 136934,
                        "name": "Carrè",
                        "latitude": "45.74880000",
                        "longitude": "11.45779000"
                    },
                    {
                        "id": 136938,
                        "name": "Cartigliano",
                        "latitude": "45.71300000",
                        "longitude": "11.69560000"
                    },
                    {
                        "id": 136942,
                        "name": "Cartura",
                        "latitude": "45.26839000",
                        "longitude": "11.85681000"
                    },
                    {
                        "id": 136955,
                        "name": "Casacorba",
                        "latitude": "45.65944000",
                        "longitude": "12.03889000"
                    },
                    {
                        "id": 136979,
                        "name": "Casale di Scodosia",
                        "latitude": "45.19225000",
                        "longitude": "11.47442000"
                    },
                    {
                        "id": 136980,
                        "name": "Casale sul Sile",
                        "latitude": "45.59638000",
                        "longitude": "12.32655000"
                    },
                    {
                        "id": 136984,
                        "name": "Casaleone",
                        "latitude": "45.16821000",
                        "longitude": "11.19401000"
                    },
                    {
                        "id": 137008,
                        "name": "Casalserugo",
                        "latitude": "45.31549000",
                        "longitude": "11.91232000"
                    },
                    {
                        "id": 137059,
                        "name": "Caselle",
                        "latitude": "45.74965000",
                        "longitude": "11.98004000"
                    },
                    {
                        "id": 137068,
                        "name": "Casier",
                        "latitude": "45.64229000",
                        "longitude": "12.29328000"
                    },
                    {
                        "id": 137085,
                        "name": "Casoni",
                        "latitude": "45.75943000",
                        "longitude": "11.81045000"
                    },
                    {
                        "id": 137114,
                        "name": "Cassola",
                        "latitude": "45.73360000",
                        "longitude": "11.79940000"
                    },
                    {
                        "id": 137116,
                        "name": "Castagnaro",
                        "latitude": "45.11795000",
                        "longitude": "11.40911000"
                    },
                    {
                        "id": 137120,
                        "name": "Castagnole",
                        "latitude": "45.68852000",
                        "longitude": "12.18260000"
                    },
                    {
                        "id": 137176,
                        "name": "Castelbaldo",
                        "latitude": "45.12226000",
                        "longitude": "11.45517000"
                    },
                    {
                        "id": 137187,
                        "name": "Castelcucco",
                        "latitude": "45.83024000",
                        "longitude": "11.88296000"
                    },
                    {
                        "id": 137198,
                        "name": "Castelfranco Veneto",
                        "latitude": "45.67146000",
                        "longitude": "11.92755000"
                    },
                    {
                        "id": 137202,
                        "name": "Castelgomberto",
                        "latitude": "45.58267000",
                        "longitude": "11.39007000"
                    },
                    {
                        "id": 137204,
                        "name": "Castelguglielmo",
                        "latitude": "45.02539000",
                        "longitude": "11.53690000"
                    },
                    {
                        "id": 137262,
                        "name": "Castello di Godego",
                        "latitude": "45.69270000",
                        "longitude": "11.87998000"
                    },
                    {
                        "id": 137270,
                        "name": "Castelmassa",
                        "latitude": "45.01826000",
                        "longitude": "11.31505000"
                    },
                    {
                        "id": 137274,
                        "name": "Castelminio",
                        "latitude": "45.64493000",
                        "longitude": "11.98734000"
                    },
                    {
                        "id": 137277,
                        "name": "Castelnovo",
                        "latitude": "45.61557000",
                        "longitude": "11.45938000"
                    },
                    {
                        "id": 137278,
                        "name": "Castelnovo Bariano",
                        "latitude": "45.02738000",
                        "longitude": "11.28760000"
                    },
                    {
                        "id": 137297,
                        "name": "Castelnuovo del Garda",
                        "latitude": "45.43878000",
                        "longitude": "10.75978000"
                    },
                    {
                        "id": 137362,
                        "name": "Castion",
                        "latitude": "46.12147000",
                        "longitude": "12.23507000"
                    },
                    {
                        "id": 137411,
                        "name": "Cavajon Veronese",
                        "latitude": "45.54009000",
                        "longitude": "10.77048000"
                    },
                    {
                        "id": 137412,
                        "name": "Cavalcaselle",
                        "latitude": "45.43695000",
                        "longitude": "10.72652000"
                    },
                    {
                        "id": 137419,
                        "name": "Cavallino",
                        "latitude": "45.47456000",
                        "longitude": "12.54855000"
                    },
                    {
                        "id": 137424,
                        "name": "Cavarzere",
                        "latitude": "45.13518000",
                        "longitude": "12.08453000"
                    },
                    {
                        "id": 137425,
                        "name": "Cavaso del Tomba",
                        "latitude": "45.86071000",
                        "longitude": "11.89840000"
                    },
                    {
                        "id": 137437,
                        "name": "Cavino",
                        "latitude": "45.51709000",
                        "longitude": "11.88466000"
                    },
                    {
                        "id": 137447,
                        "name": "Cazzago-Ex Polo",
                        "latitude": "45.44159000",
                        "longitude": "12.07406000"
                    },
                    {
                        "id": 137449,
                        "name": "Cazzano di Tramigna",
                        "latitude": "45.47309000",
                        "longitude": "11.20289000"
                    },
                    {
                        "id": 137460,
                        "name": "Ceggia",
                        "latitude": "45.68700000",
                        "longitude": "12.64228000"
                    },
                    {
                        "id": 137463,
                        "name": "Celat-San Tomaso Agordino",
                        "latitude": "46.38072000",
                        "longitude": "11.97439000"
                    },
                    {
                        "id": 137483,
                        "name": "Cellore",
                        "latitude": "45.48646000",
                        "longitude": "11.17831000"
                    },
                    {
                        "id": 137489,
                        "name": "Cencenighe Agordino",
                        "latitude": "46.35184000",
                        "longitude": "11.96823000"
                    },
                    {
                        "id": 137490,
                        "name": "Cendon",
                        "latitude": "45.63804000",
                        "longitude": "12.32505000"
                    },
                    {
                        "id": 137492,
                        "name": "Ceneselli",
                        "latitude": "45.01377000",
                        "longitude": "11.36936000"
                    },
                    {
                        "id": 137501,
                        "name": "Centrale",
                        "latitude": "45.72737000",
                        "longitude": "11.48031000"
                    },
                    {
                        "id": 137530,
                        "name": "Cerea",
                        "latitude": "45.18936000",
                        "longitude": "11.21661000"
                    },
                    {
                        "id": 137531,
                        "name": "Cereda-Cozza Cornedo",
                        "latitude": "45.60181000",
                        "longitude": "11.36740000"
                    },
                    {
                        "id": 137532,
                        "name": "Ceregnano",
                        "latitude": "45.04811000",
                        "longitude": "11.86792000"
                    },
                    {
                        "id": 137574,
                        "name": "Cerro Veronese",
                        "latitude": "45.57449000",
                        "longitude": "11.04159000"
                    },
                    {
                        "id": 137583,
                        "name": "Cervarese Santa Croce",
                        "latitude": "45.42439000",
                        "longitude": "11.68790000"
                    },
                    {
                        "id": 137608,
                        "name": "Cesarolo",
                        "latitude": "45.71884000",
                        "longitude": "13.01555000"
                    },
                    {
                        "id": 137615,
                        "name": "Cesiomaggiore",
                        "latitude": "46.08675000",
                        "longitude": "11.98539000"
                    },
                    {
                        "id": 137616,
                        "name": "Cessalto",
                        "latitude": "45.71356000",
                        "longitude": "12.61302000"
                    },
                    {
                        "id": 137641,
                        "name": "Chiampo",
                        "latitude": "45.54746000",
                        "longitude": "11.28285000"
                    },
                    {
                        "id": 137650,
                        "name": "Chiarano",
                        "latitude": "45.72959000",
                        "longitude": "12.57166000"
                    },
                    {
                        "id": 137677,
                        "name": "Chioggia",
                        "latitude": "45.21857000",
                        "longitude": "12.27774000"
                    },
                    {
                        "id": 137684,
                        "name": "Chiuppano",
                        "latitude": "45.76300000",
                        "longitude": "11.45777000"
                    },
                    {
                        "id": 137703,
                        "name": "Ciano",
                        "latitude": "45.82389000",
                        "longitude": "12.05417000"
                    },
                    {
                        "id": 137706,
                        "name": "Cibiana",
                        "latitude": "46.38856000",
                        "longitude": "12.28658000"
                    },
                    {
                        "id": 137720,
                        "name": "Cimadolmo",
                        "latitude": "45.78524000",
                        "longitude": "12.36510000"
                    },
                    {
                        "id": 137740,
                        "name": "Cinto Caomaggiore",
                        "latitude": "45.82758000",
                        "longitude": "12.78126000"
                    },
                    {
                        "id": 137758,
                        "name": "Cismon del Grappa",
                        "latitude": "45.92026000",
                        "longitude": "11.72816000"
                    },
                    {
                        "id": 137759,
                        "name": "Cison di Valmarino",
                        "latitude": "45.96694000",
                        "longitude": "12.14267000"
                    },
                    {
                        "id": 137765,
                        "name": "Cittadella",
                        "latitude": "45.64523000",
                        "longitude": "11.78453000"
                    },
                    {
                        "id": 137829,
                        "name": "Codevigo",
                        "latitude": "45.26628000",
                        "longitude": "12.09961000"
                    },
                    {
                        "id": 137833,
                        "name": "Codiverno",
                        "latitude": "45.47583000",
                        "longitude": "11.94556000"
                    },
                    {
                        "id": 137836,
                        "name": "Codognè",
                        "latitude": "45.86047000",
                        "longitude": "12.41284000"
                    },
                    {
                        "id": 137843,
                        "name": "Cogollo del Cengio",
                        "latitude": "45.78397000",
                        "longitude": "11.42527000"
                    },
                    {
                        "id": 137846,
                        "name": "Col San Martino",
                        "latitude": "45.90020000",
                        "longitude": "12.11575000"
                    },
                    {
                        "id": 137932,
                        "name": "Colà",
                        "latitude": "45.47428000",
                        "longitude": "10.74257000"
                    },
                    {
                        "id": 137865,
                        "name": "Colle Santa Lucia",
                        "latitude": "46.44852000",
                        "longitude": "12.01399000"
                    },
                    {
                        "id": 137867,
                        "name": "Colle Umberto",
                        "latitude": "45.94238000",
                        "longitude": "12.34228000"
                    },
                    {
                        "id": 137912,
                        "name": "Cologna Veneta",
                        "latitude": "45.30777000",
                        "longitude": "11.38032000"
                    },
                    {
                        "id": 137917,
                        "name": "Colognola ai Colli",
                        "latitude": "45.43369000",
                        "longitude": "11.18429000"
                    },
                    {
                        "id": 137958,
                        "name": "Conco",
                        "latitude": "45.80043000",
                        "longitude": "11.60962000"
                    },
                    {
                        "id": 137959,
                        "name": "Concordia Sagittaria",
                        "latitude": "45.76118000",
                        "longitude": "12.82362000"
                    },
                    {
                        "id": 137966,
                        "name": "Conegliano",
                        "latitude": "45.88805000",
                        "longitude": "12.30201000"
                    },
                    {
                        "id": 137973,
                        "name": "Conscio",
                        "latitude": "45.61701000",
                        "longitude": "12.28219000"
                    },
                    {
                        "id": 137975,
                        "name": "Conselve",
                        "latitude": "45.23154000",
                        "longitude": "11.87498000"
                    },
                    {
                        "id": 137992,
                        "name": "Corbanese",
                        "latitude": "45.94570000",
                        "longitude": "12.24027000"
                    },
                    {
                        "id": 137995,
                        "name": "Corbola",
                        "latitude": "45.00272000",
                        "longitude": "12.08567000"
                    },
                    {
                        "id": 137996,
                        "name": "Corbolone",
                        "latitude": "45.74962000",
                        "longitude": "12.66969000"
                    },
                    {
                        "id": 138002,
                        "name": "Cordignano",
                        "latitude": "45.94936000",
                        "longitude": "12.41567000"
                    },
                    {
                        "id": 138029,
                        "name": "Cornedo Vicentino",
                        "latitude": "45.61626000",
                        "longitude": "11.33225000"
                    },
                    {
                        "id": 138036,
                        "name": "Cornuda",
                        "latitude": "45.83152000",
                        "longitude": "12.00598000"
                    },
                    {
                        "id": 138041,
                        "name": "Correzzola",
                        "latitude": "45.23548000",
                        "longitude": "12.06739000"
                    },
                    {
                        "id": 138045,
                        "name": "Corrubbio",
                        "latitude": "45.48685000",
                        "longitude": "10.90359000"
                    },
                    {
                        "id": 138055,
                        "name": "Corte",
                        "latitude": "45.30835000",
                        "longitude": "12.07174000"
                    },
                    {
                        "id": 138067,
                        "name": "Cortina d'Ampezzo",
                        "latitude": "46.53690000",
                        "longitude": "12.13903000"
                    },
                    {
                        "id": 138081,
                        "name": "Cosniga-Zoppè",
                        "latitude": "45.88750000",
                        "longitude": "12.36028000"
                    },
                    {
                        "id": 138099,
                        "name": "Costa di Rovigo",
                        "latitude": "45.05181000",
                        "longitude": "11.69560000"
                    },
                    {
                        "id": 138102,
                        "name": "Costabissara",
                        "latitude": "45.58252000",
                        "longitude": "11.48529000"
                    },
                    {
                        "id": 138108,
                        "name": "Costermano",
                        "latitude": "45.58606000",
                        "longitude": "10.73900000"
                    },
                    {
                        "id": 138118,
                        "name": "Covolo-Levada",
                        "latitude": "45.84828000",
                        "longitude": "12.00515000"
                    },
                    {
                        "id": 138128,
                        "name": "Creazzo",
                        "latitude": "45.53154000",
                        "longitude": "11.47789000"
                    },
                    {
                        "id": 138140,
                        "name": "Crepaldo",
                        "latitude": "45.59495000",
                        "longitude": "12.69655000"
                    },
                    {
                        "id": 138142,
                        "name": "Crespadoro",
                        "latitude": "45.62019000",
                        "longitude": "11.22589000"
                    },
                    {
                        "id": 138143,
                        "name": "Crespano del Grappa",
                        "latitude": "45.82793000",
                        "longitude": "11.83358000"
                    },
                    {
                        "id": 138147,
                        "name": "Crespino",
                        "latitude": "44.98527000",
                        "longitude": "11.88958000"
                    },
                    {
                        "id": 138156,
                        "name": "Crispi Cavour",
                        "latitude": "45.58190000",
                        "longitude": "11.50113000"
                    },
                    {
                        "id": 138160,
                        "name": "Crocetta del Montello",
                        "latitude": "45.83667000",
                        "longitude": "12.03361000"
                    },
                    {
                        "id": 138161,
                        "name": "Crocetta-Nogarè",
                        "latitude": "45.82707000",
                        "longitude": "12.03013000"
                    },
                    {
                        "id": 138208,
                        "name": "Curtarolo",
                        "latitude": "45.52366000",
                        "longitude": "11.83691000"
                    },
                    {
                        "id": 138227,
                        "name": "Danta",
                        "latitude": "46.56700000",
                        "longitude": "12.52055000"
                    },
                    {
                        "id": 138255,
                        "name": "Dese",
                        "latitude": "45.52962000",
                        "longitude": "12.30363000"
                    },
                    {
                        "id": 138281,
                        "name": "Dolcè",
                        "latitude": "45.60069000",
                        "longitude": "10.85248000"
                    },
                    {
                        "id": 138285,
                        "name": "Dolo",
                        "latitude": "45.42528000",
                        "longitude": "12.08429000"
                    },
                    {
                        "id": 138289,
                        "name": "Domegge di Cadore",
                        "latitude": "46.45666000",
                        "longitude": "12.40724000"
                    },
                    {
                        "id": 138296,
                        "name": "Don",
                        "latitude": "46.22144000",
                        "longitude": "11.95598000"
                    },
                    {
                        "id": 138305,
                        "name": "Donzella",
                        "latitude": "44.93047000",
                        "longitude": "12.33119000"
                    },
                    {
                        "id": 138319,
                        "name": "Dossobuono",
                        "latitude": "45.39333000",
                        "longitude": "10.91054000"
                    },
                    {
                        "id": 138320,
                        "name": "Dosson",
                        "latitude": "45.63605000",
                        "longitude": "12.25409000"
                    },
                    {
                        "id": 138338,
                        "name": "Due Carrare",
                        "latitude": "45.29151000",
                        "longitude": "11.82402000"
                    },
                    {
                        "id": 138339,
                        "name": "Dueville",
                        "latitude": "45.63556000",
                        "longitude": "11.55135000"
                    },
                    {
                        "id": 138358,
                        "name": "Enego",
                        "latitude": "45.94161000",
                        "longitude": "11.70550000"
                    },
                    {
                        "id": 138366,
                        "name": "Eraclea",
                        "latitude": "45.57766000",
                        "longitude": "12.67320000"
                    },
                    {
                        "id": 138370,
                        "name": "Erbè",
                        "latitude": "45.24231000",
                        "longitude": "10.97135000"
                    },
                    {
                        "id": 138368,
                        "name": "Erbezzo",
                        "latitude": "45.63960000",
                        "longitude": "11.00057000"
                    },
                    {
                        "id": 138386,
                        "name": "Este",
                        "latitude": "45.22338000",
                        "longitude": "11.66379000"
                    },
                    {
                        "id": 138413,
                        "name": "Falcade Alto",
                        "latitude": "46.35549000",
                        "longitude": "11.85712000"
                    },
                    {
                        "id": 138427,
                        "name": "Falzè di Piave",
                        "latitude": "45.86796000",
                        "longitude": "12.17891000"
                    },
                    {
                        "id": 138428,
                        "name": "Falzè-Signoressa",
                        "latitude": "45.75028000",
                        "longitude": "12.10722000"
                    },
                    {
                        "id": 138431,
                        "name": "Fane",
                        "latitude": "45.57904000",
                        "longitude": "10.96425000"
                    },
                    {
                        "id": 138436,
                        "name": "Fanzolo",
                        "latitude": "45.71218000",
                        "longitude": "11.99023000"
                    },
                    {
                        "id": 138442,
                        "name": "Fara Vicentino",
                        "latitude": "45.74369000",
                        "longitude": "11.54529000"
                    },
                    {
                        "id": 138451,
                        "name": "Farra d'Alpago",
                        "latitude": "46.12079000",
                        "longitude": "12.35876000"
                    },
                    {
                        "id": 138453,
                        "name": "Farra di Soligo",
                        "latitude": "45.90528000",
                        "longitude": "12.12444000"
                    },
                    {
                        "id": 138475,
                        "name": "Feltre",
                        "latitude": "46.02085000",
                        "longitude": "11.90031000"
                    },
                    {
                        "id": 138490,
                        "name": "Ferrara di Monte Baldo",
                        "latitude": "45.67408000",
                        "longitude": "10.85911000"
                    },
                    {
                        "id": 138504,
                        "name": "Ficarolo",
                        "latitude": "44.95425000",
                        "longitude": "11.43662000"
                    },
                    {
                        "id": 138513,
                        "name": "Fiesso",
                        "latitude": "45.41954000",
                        "longitude": "12.03378000"
                    },
                    {
                        "id": 138515,
                        "name": "Fiesso d'Artico",
                        "latitude": "45.42139000",
                        "longitude": "12.02944000"
                    },
                    {
                        "id": 138514,
                        "name": "Fiesso Umbertiano",
                        "latitude": "44.96072000",
                        "longitude": "11.60576000"
                    },
                    {
                        "id": 138583,
                        "name": "Follina",
                        "latitude": "45.95352000",
                        "longitude": "12.11985000"
                    },
                    {
                        "id": 138594,
                        "name": "Fontanafredda",
                        "latitude": "45.29159000",
                        "longitude": "11.66172000"
                    },
                    {
                        "id": 138601,
                        "name": "Fontanelle",
                        "latitude": "45.83345000",
                        "longitude": "12.46625000"
                    },
                    {
                        "id": 138606,
                        "name": "Fontaniva",
                        "latitude": "45.63516000",
                        "longitude": "11.75381000"
                    },
                    {
                        "id": 138615,
                        "name": "Fonzaso",
                        "latitude": "46.01640000",
                        "longitude": "11.79897000"
                    },
                    {
                        "id": 138627,
                        "name": "Forette",
                        "latitude": "45.34221000",
                        "longitude": "10.94460000"
                    },
                    {
                        "id": 138647,
                        "name": "Fornaci",
                        "latitude": "45.65170000",
                        "longitude": "12.43738000"
                    },
                    {
                        "id": 138651,
                        "name": "Fornase",
                        "latitude": "45.47586000",
                        "longitude": "12.16273000"
                    },
                    {
                        "id": 138657,
                        "name": "Forno di Zoldo",
                        "latitude": "46.35010000",
                        "longitude": "12.17913000"
                    },
                    {
                        "id": 138670,
                        "name": "Fossalta di Piave",
                        "latitude": "45.64497000",
                        "longitude": "12.50902000"
                    },
                    {
                        "id": 138671,
                        "name": "Fossalta di Portogruaro",
                        "latitude": "45.79329000",
                        "longitude": "12.90998000"
                    },
                    {
                        "id": 138673,
                        "name": "Fossalunga",
                        "latitude": "45.69160000",
                        "longitude": "12.05320000"
                    },
                    {
                        "id": 138682,
                        "name": "Fossò",
                        "latitude": "45.38580000",
                        "longitude": "12.04627000"
                    },
                    {
                        "id": 138683,
                        "name": "Foza",
                        "latitude": "45.89703000",
                        "longitude": "11.63053000"
                    },
                    {
                        "id": 138700,
                        "name": "Francenigo",
                        "latitude": "45.90799000",
                        "longitude": "12.50347000"
                    },
                    {
                        "id": 138711,
                        "name": "Frassinelle Polesine",
                        "latitude": "44.99518000",
                        "longitude": "11.69881000"
                    },
                    {
                        "id": 138719,
                        "name": "Fratta Polesine",
                        "latitude": "45.02819000",
                        "longitude": "11.64265000"
                    },
                    {
                        "id": 138729,
                        "name": "Fregona",
                        "latitude": "46.00795000",
                        "longitude": "12.33864000"
                    },
                    {
                        "id": 138731,
                        "name": "Frescada",
                        "latitude": "45.62878000",
                        "longitude": "12.23671000"
                    },
                    {
                        "id": 138749,
                        "name": "Fumane",
                        "latitude": "45.54160000",
                        "longitude": "10.88548000"
                    },
                    {
                        "id": 138763,
                        "name": "Fusine",
                        "latitude": "46.37589000",
                        "longitude": "12.12547000"
                    },
                    {
                        "id": 138787,
                        "name": "Gaiarine",
                        "latitude": "45.88083000",
                        "longitude": "12.48142000"
                    },
                    {
                        "id": 138788,
                        "name": "Gaiba",
                        "latitude": "44.94573000",
                        "longitude": "11.48087000"
                    },
                    {
                        "id": 138810,
                        "name": "Galliera Veneta",
                        "latitude": "45.66750000",
                        "longitude": "11.82217000"
                    },
                    {
                        "id": 138812,
                        "name": "Gallio",
                        "latitude": "45.88506000",
                        "longitude": "11.53417000"
                    },
                    {
                        "id": 138821,
                        "name": "Galta",
                        "latitude": "45.39095000",
                        "longitude": "12.02340000"
                    },
                    {
                        "id": 138824,
                        "name": "Galzignano",
                        "latitude": "45.30798000",
                        "longitude": "11.73134000"
                    },
                    {
                        "id": 138831,
                        "name": "Gambellara",
                        "latitude": "45.45979000",
                        "longitude": "11.34009000"
                    },
                    {
                        "id": 138835,
                        "name": "Gambugliano",
                        "latitude": "45.58799000",
                        "longitude": "11.43859000"
                    },
                    {
                        "id": 138849,
                        "name": "Garda",
                        "latitude": "45.57889000",
                        "longitude": "10.71763000"
                    },
                    {
                        "id": 138874,
                        "name": "Gavello",
                        "latitude": "45.02469000",
                        "longitude": "11.91368000"
                    },
                    {
                        "id": 138884,
                        "name": "Gazzo",
                        "latitude": "45.58241000",
                        "longitude": "11.70724000"
                    },
                    {
                        "id": 138887,
                        "name": "Gazzolo-Volpino",
                        "latitude": "45.37536000",
                        "longitude": "11.31319000"
                    },
                    {
                        "id": 138938,
                        "name": "Giacciano con Baruchella",
                        "latitude": "45.06718000",
                        "longitude": "11.45040000"
                    },
                    {
                        "id": 138951,
                        "name": "Giavenale",
                        "latitude": "45.70006000",
                        "longitude": "11.40002000"
                    },
                    {
                        "id": 138953,
                        "name": "Giavera del Montello",
                        "latitude": "45.79374000",
                        "longitude": "12.16667000"
                    },
                    {
                        "id": 138986,
                        "name": "Giudecca",
                        "latitude": "45.42477000",
                        "longitude": "12.32906000"
                    },
                    {
                        "id": 139007,
                        "name": "Godega",
                        "latitude": "45.92859000",
                        "longitude": "12.39687000"
                    },
                    {
                        "id": 139027,
                        "name": "Gorgo al Monticano",
                        "latitude": "45.79139000",
                        "longitude": "12.55000000"
                    },
                    {
                        "id": 139028,
                        "name": "Gorgo della Chiesa",
                        "latitude": "45.78747000",
                        "longitude": "12.56270000"
                    },
                    {
                        "id": 139043,
                        "name": "Gosaldo",
                        "latitude": "46.22142000",
                        "longitude": "11.95570000"
                    },
                    {
                        "id": 139062,
                        "name": "Grancona",
                        "latitude": "45.42189000",
                        "longitude": "11.45160000"
                    },
                    {
                        "id": 139069,
                        "name": "Grantorto",
                        "latitude": "45.60268000",
                        "longitude": "11.73175000"
                    },
                    {
                        "id": 139071,
                        "name": "Granze",
                        "latitude": "45.15649000",
                        "longitude": "11.71471000"
                    },
                    {
                        "id": 139094,
                        "name": "Grezzana",
                        "latitude": "45.52272000",
                        "longitude": "11.01743000"
                    },
                    {
                        "id": 139098,
                        "name": "Grignano Polesine",
                        "latitude": "45.04350000",
                        "longitude": "11.74682000"
                    },
                    {
                        "id": 139103,
                        "name": "Grisignano di Zocco",
                        "latitude": "45.48681000",
                        "longitude": "11.70794000"
                    },
                    {
                        "id": 139132,
                        "name": "Gruaro",
                        "latitude": "45.83472000",
                        "longitude": "12.84111000"
                    },
                    {
                        "id": 139133,
                        "name": "Gruaro-Bagnara",
                        "latitude": "45.84167000",
                        "longitude": "12.85111000"
                    },
                    {
                        "id": 139142,
                        "name": "Grumolo delle Abbadesse",
                        "latitude": "45.51692000",
                        "longitude": "11.67198000"
                    },
                    {
                        "id": 139141,
                        "name": "Grumolo Pedemonte",
                        "latitude": "45.72430000",
                        "longitude": "11.49236000"
                    },
                    {
                        "id": 139153,
                        "name": "Guarda Veneta",
                        "latitude": "44.98188000",
                        "longitude": "11.80178000"
                    },
                    {
                        "id": 139190,
                        "name": "Iesolo",
                        "latitude": "45.53311000",
                        "longitude": "12.64475000"
                    },
                    {
                        "id": 139195,
                        "name": "Illasi",
                        "latitude": "45.46663000",
                        "longitude": "11.18165000"
                    },
                    {
                        "id": 139248,
                        "name": "Isola della Scala",
                        "latitude": "45.26943000",
                        "longitude": "11.00824000"
                    },
                    {
                        "id": 139239,
                        "name": "Isola Rizza",
                        "latitude": "45.29228000",
                        "longitude": "11.19900000"
                    },
                    {
                        "id": 139241,
                        "name": "Isola Vicentina",
                        "latitude": "45.62930000",
                        "longitude": "11.44608000"
                    },
                    {
                        "id": 139266,
                        "name": "Istrana",
                        "latitude": "45.67691000",
                        "longitude": "12.10119000"
                    },
                    {
                        "id": 139304,
                        "name": "La Salute di Livenza",
                        "latitude": "45.65366000",
                        "longitude": "12.80131000"
                    },
                    {
                        "id": 139308,
                        "name": "La Valle Agordina",
                        "latitude": "46.28198000",
                        "longitude": "12.06844000"
                    },
                    {
                        "id": 139323,
                        "name": "Laghi",
                        "latitude": "45.82450000",
                        "longitude": "11.27249000"
                    },
                    {
                        "id": 139340,
                        "name": "Lama Pezzoli",
                        "latitude": "45.04357000",
                        "longitude": "11.90942000"
                    },
                    {
                        "id": 139347,
                        "name": "Lamon",
                        "latitude": "46.04717000",
                        "longitude": "11.74991000"
                    },
                    {
                        "id": 139348,
                        "name": "Lamosano",
                        "latitude": "46.17276000",
                        "longitude": "12.38691000"
                    },
                    {
                        "id": 139353,
                        "name": "Lancenigo-Villorba",
                        "latitude": "45.71289000",
                        "longitude": "12.25697000"
                    },
                    {
                        "id": 139384,
                        "name": "Lastebasse",
                        "latitude": "45.91510000",
                        "longitude": "11.27389000"
                    },
                    {
                        "id": 139409,
                        "name": "Lavagno",
                        "latitude": "45.43869000",
                        "longitude": "11.13409000"
                    },
                    {
                        "id": 139420,
                        "name": "Lazise",
                        "latitude": "45.50499000",
                        "longitude": "10.73923000"
                    },
                    {
                        "id": 139435,
                        "name": "Legnago",
                        "latitude": "45.19365000",
                        "longitude": "11.30227000"
                    },
                    {
                        "id": 139437,
                        "name": "Legnaro",
                        "latitude": "45.34238000",
                        "longitude": "11.96482000"
                    },
                    {
                        "id": 139443,
                        "name": "Lendinara",
                        "latitude": "45.08301000",
                        "longitude": "11.60318000"
                    },
                    {
                        "id": 139452,
                        "name": "Lentiai",
                        "latitude": "46.04504000",
                        "longitude": "12.02053000"
                    },
                    {
                        "id": 139482,
                        "name": "Levada",
                        "latitude": "45.73442000",
                        "longitude": "12.47128000"
                    },
                    {
                        "id": 139500,
                        "name": "Lido",
                        "latitude": "45.41050000",
                        "longitude": "12.36649000"
                    },
                    {
                        "id": 139506,
                        "name": "Lido di Jesolo",
                        "latitude": "45.50694000",
                        "longitude": "12.64694000"
                    },
                    {
                        "id": 139515,
                        "name": "Limana",
                        "latitude": "46.10039000",
                        "longitude": "12.18552000"
                    },
                    {
                        "id": 139519,
                        "name": "Limena",
                        "latitude": "45.46948000",
                        "longitude": "11.84574000"
                    },
                    {
                        "id": 139540,
                        "name": "Lisiera",
                        "latitude": "45.57848000",
                        "longitude": "11.61178000"
                    },
                    {
                        "id": 139548,
                        "name": "Livinallongo del Col di Lana",
                        "latitude": "46.48162000",
                        "longitude": "11.95399000"
                    },
                    {
                        "id": 139560,
                        "name": "Locara",
                        "latitude": "45.41207000",
                        "longitude": "11.33262000"
                    },
                    {
                        "id": 139590,
                        "name": "Longare",
                        "latitude": "45.47726000",
                        "longitude": "11.60696000"
                    },
                    {
                        "id": 139591,
                        "name": "Longarone",
                        "latitude": "46.26579000",
                        "longitude": "12.29992000"
                    },
                    {
                        "id": 139594,
                        "name": "Longhi",
                        "latitude": "45.90744000",
                        "longitude": "11.31132000"
                    },
                    {
                        "id": 139601,
                        "name": "Lonigo",
                        "latitude": "45.38576000",
                        "longitude": "11.38402000"
                    },
                    {
                        "id": 139603,
                        "name": "Loreggia",
                        "latitude": "45.59733000",
                        "longitude": "11.94769000"
                    },
                    {
                        "id": 139604,
                        "name": "Loreggiola",
                        "latitude": "45.60892000",
                        "longitude": "11.91899000"
                    },
                    {
                        "id": 139606,
                        "name": "Lorenzago di Cadore",
                        "latitude": "46.47954000",
                        "longitude": "12.45984000"
                    },
                    {
                        "id": 139608,
                        "name": "Loreo",
                        "latitude": "45.06213000",
                        "longitude": "12.18812000"
                    },
                    {
                        "id": 139612,
                        "name": "Loria Bessica",
                        "latitude": "45.73000000",
                        "longitude": "11.86540000"
                    },
                    {
                        "id": 139623,
                        "name": "Lozzo Atestino",
                        "latitude": "45.29384000",
                        "longitude": "11.60495000"
                    },
                    {
                        "id": 139624,
                        "name": "Lozzo di Cadore",
                        "latitude": "46.48644000",
                        "longitude": "12.44493000"
                    },
                    {
                        "id": 139643,
                        "name": "Lugagnano",
                        "latitude": "45.43327000",
                        "longitude": "10.88402000"
                    },
                    {
                        "id": 139645,
                        "name": "Lughignano",
                        "latitude": "45.62533000",
                        "longitude": "12.32478000"
                    },
                    {
                        "id": 139649,
                        "name": "Lugo di Vicenza",
                        "latitude": "45.74550000",
                        "longitude": "11.52869000"
                    },
                    {
                        "id": 139650,
                        "name": "Lugugnana",
                        "latitude": "45.73277000",
                        "longitude": "12.95958000"
                    },
                    {
                        "id": 139656,
                        "name": "Lumignano",
                        "latitude": "45.45968000",
                        "longitude": "11.58786000"
                    },
                    {
                        "id": 139675,
                        "name": "Lusia",
                        "latitude": "45.09848000",
                        "longitude": "11.66511000"
                    },
                    {
                        "id": 139676,
                        "name": "Lusiana",
                        "latitude": "45.78428000",
                        "longitude": "11.57478000"
                    },
                    {
                        "id": 139680,
                        "name": "Lutrano",
                        "latitude": "45.81415000",
                        "longitude": "12.47316000"
                    },
                    {
                        "id": 139686,
                        "name": "Maccacari",
                        "latitude": "45.14276000",
                        "longitude": "11.13499000"
                    },
                    {
                        "id": 139714,
                        "name": "Maerne",
                        "latitude": "45.52313000",
                        "longitude": "12.15477000"
                    },
                    {
                        "id": 139744,
                        "name": "Magugnano",
                        "latitude": "45.70084000",
                        "longitude": "10.76229000"
                    },
                    {
                        "id": 139758,
                        "name": "Malcesine",
                        "latitude": "45.76140000",
                        "longitude": "10.80863000"
                    },
                    {
                        "id": 139772,
                        "name": "Malo",
                        "latitude": "45.65910000",
                        "longitude": "11.41601000"
                    },
                    {
                        "id": 139789,
                        "name": "Mandriola-Sant'Agostino",
                        "latitude": "45.36926000",
                        "longitude": "11.85101000"
                    },
                    {
                        "id": 139804,
                        "name": "Mansuè",
                        "latitude": "45.82118000",
                        "longitude": "12.53510000"
                    },
                    {
                        "id": 139820,
                        "name": "Marano",
                        "latitude": "45.46345000",
                        "longitude": "12.11715000"
                    },
                    {
                        "id": 139828,
                        "name": "Marano di Valpolicella",
                        "latitude": "45.55637000",
                        "longitude": "10.91622000"
                    },
                    {
                        "id": 139826,
                        "name": "Marano Vicentino",
                        "latitude": "45.69600000",
                        "longitude": "11.43237000"
                    },
                    {
                        "id": 139843,
                        "name": "Marchesino-Bovo",
                        "latitude": "45.36667000",
                        "longitude": "11.00000000"
                    },
                    {
                        "id": 139854,
                        "name": "Marcon-Gaggio-Colmello",
                        "latitude": "45.56444000",
                        "longitude": "12.29889000"
                    },
                    {
                        "id": 139856,
                        "name": "Mardimago",
                        "latitude": "45.10703000",
                        "longitude": "11.83744000"
                    },
                    {
                        "id": 139858,
                        "name": "Mareno di Piave",
                        "latitude": "45.84572000",
                        "longitude": "12.33703000"
                    },
                    {
                        "id": 139910,
                        "name": "Marola",
                        "latitude": "45.53994000",
                        "longitude": "11.62593000"
                    },
                    {
                        "id": 139913,
                        "name": "Marostica",
                        "latitude": "45.74541000",
                        "longitude": "11.66237000"
                    },
                    {
                        "id": 139927,
                        "name": "Martellago",
                        "latitude": "45.54383000",
                        "longitude": "12.16363000"
                    },
                    {
                        "id": 139956,
                        "name": "Maser",
                        "latitude": "45.80740000",
                        "longitude": "11.97500000"
                    },
                    {
                        "id": 139959,
                        "name": "Maserà di Padova",
                        "latitude": "45.31827000",
                        "longitude": "11.86543000"
                    },
                    {
                        "id": 139958,
                        "name": "Maserada sul Piave",
                        "latitude": "45.75195000",
                        "longitude": "12.31773000"
                    },
                    {
                        "id": 139960,
                        "name": "Masi",
                        "latitude": "45.10888000",
                        "longitude": "11.48921000"
                    },
                    {
                        "id": 139964,
                        "name": "Mason Vicentino",
                        "latitude": "45.71860000",
                        "longitude": "11.60680000"
                    },
                    {
                        "id": 139979,
                        "name": "Massanzago-Ca' Baglioni-San Dono",
                        "latitude": "45.55630000",
                        "longitude": "12.00731000"
                    },
                    {
                        "id": 140026,
                        "name": "Meduna di Livenza",
                        "latitude": "45.81720000",
                        "longitude": "12.62828000"
                    },
                    {
                        "id": 140029,
                        "name": "Megliadino San Fidenzio",
                        "latitude": "45.21739000",
                        "longitude": "11.51600000"
                    },
                    {
                        "id": 140030,
                        "name": "Megliadino San Vitale",
                        "latitude": "45.19577000",
                        "longitude": "11.52402000"
                    },
                    {
                        "id": 140033,
                        "name": "Mejaniga",
                        "latitude": "45.45768000",
                        "longitude": "11.90644000"
                    },
                    {
                        "id": 140034,
                        "name": "Mel",
                        "latitude": "46.06379000",
                        "longitude": "12.09000000"
                    },
                    {
                        "id": 140035,
                        "name": "Melara",
                        "latitude": "45.06421000",
                        "longitude": "11.20117000"
                    },
                    {
                        "id": 140039,
                        "name": "Meledo",
                        "latitude": "45.43821000",
                        "longitude": "11.41560000"
                    },
                    {
                        "id": 140066,
                        "name": "Meolo",
                        "latitude": "45.61970000",
                        "longitude": "12.45236000"
                    },
                    {
                        "id": 140086,
                        "name": "Merlara",
                        "latitude": "45.16700000",
                        "longitude": "11.44504000"
                    },
                    {
                        "id": 140099,
                        "name": "Mestre",
                        "latitude": "45.49167000",
                        "longitude": "12.24538000"
                    },
                    {
                        "id": 140100,
                        "name": "Mestrino",
                        "latitude": "45.44139000",
                        "longitude": "11.75931000"
                    },
                    {
                        "id": 140109,
                        "name": "Mezzane di Sotto",
                        "latitude": "45.48199000",
                        "longitude": "11.12729000"
                    },
                    {
                        "id": 140126,
                        "name": "Miane",
                        "latitude": "45.94341000",
                        "longitude": "12.09246000"
                    },
                    {
                        "id": 140139,
                        "name": "Mignagola",
                        "latitude": "45.68868000",
                        "longitude": "12.32154000"
                    },
                    {
                        "id": 140157,
                        "name": "Minerbe",
                        "latitude": "45.23198000",
                        "longitude": "11.35249000"
                    },
                    {
                        "id": 140166,
                        "name": "Mira Taglio",
                        "latitude": "45.43460000",
                        "longitude": "12.12942000"
                    },
                    {
                        "id": 140175,
                        "name": "Mirano",
                        "latitude": "45.49458000",
                        "longitude": "12.10775000"
                    },
                    {
                        "id": 140199,
                        "name": "Mogliano Veneto",
                        "latitude": "45.55594000",
                        "longitude": "12.24294000"
                    },
                    {
                        "id": 140225,
                        "name": "Molino-Mozzi-Bittarelli",
                        "latitude": "45.61254000",
                        "longitude": "11.23500000"
                    },
                    {
                        "id": 140260,
                        "name": "Monastier di Treviso",
                        "latitude": "45.65778000",
                        "longitude": "12.41750000"
                    },
                    {
                        "id": 140282,
                        "name": "Monfumo",
                        "latitude": "45.83080000",
                        "longitude": "11.92030000"
                    },
                    {
                        "id": 140292,
                        "name": "Moniego",
                        "latitude": "45.56126000",
                        "longitude": "12.08705000"
                    },
                    {
                        "id": 140301,
                        "name": "Monselice",
                        "latitude": "45.23900000",
                        "longitude": "11.74984000"
                    },
                    {
                        "id": 140310,
                        "name": "Montagnana",
                        "latitude": "45.23229000",
                        "longitude": "11.46483000"
                    },
                    {
                        "id": 140384,
                        "name": "Monte di Malo",
                        "latitude": "45.66011000",
                        "longitude": "11.36127000"
                    },
                    {
                        "id": 140388,
                        "name": "Montebello Vicentino",
                        "latitude": "45.45919000",
                        "longitude": "11.38272000"
                    },
                    {
                        "id": 140391,
                        "name": "Montebelluna",
                        "latitude": "45.77504000",
                        "longitude": "12.04904000"
                    },
                    {
                        "id": 140408,
                        "name": "Montecchia di Crosara",
                        "latitude": "45.48190000",
                        "longitude": "11.25438000"
                    },
                    {
                        "id": 140411,
                        "name": "Montecchio Maggiore-Alte Ceccato",
                        "latitude": "45.50369000",
                        "longitude": "11.41200000"
                    },
                    {
                        "id": 140412,
                        "name": "Montecchio Precalcino",
                        "latitude": "45.66570000",
                        "longitude": "11.56360000"
                    },
                    {
                        "id": 140445,
                        "name": "Monteforte d'Alpone",
                        "latitude": "45.42013000",
                        "longitude": "11.28446000"
                    },
                    {
                        "id": 140451,
                        "name": "Montegalda",
                        "latitude": "45.44609000",
                        "longitude": "11.67500000"
                    },
                    {
                        "id": 140452,
                        "name": "Montegaldella",
                        "latitude": "45.43717000",
                        "longitude": "11.67022000"
                    },
                    {
                        "id": 140461,
                        "name": "Montegrotto Terme",
                        "latitude": "45.33119000",
                        "longitude": "11.78634000"
                    },
                    {
                        "id": 140490,
                        "name": "Montemerlo",
                        "latitude": "45.38033000",
                        "longitude": "11.70815000"
                    },
                    {
                        "id": 140551,
                        "name": "Monteviale",
                        "latitude": "45.55920000",
                        "longitude": "11.45715000"
                    },
                    {
                        "id": 140563,
                        "name": "Monticelli-Fontana",
                        "latitude": "45.42965000",
                        "longitude": "11.13729000"
                    },
                    {
                        "id": 140566,
                        "name": "Monticello Conte Otto",
                        "latitude": "45.59784000",
                        "longitude": "11.57234000"
                    },
                    {
                        "id": 140568,
                        "name": "Monticello di Fara",
                        "latitude": "45.42896000",
                        "longitude": "11.39042000"
                    },
                    {
                        "id": 140583,
                        "name": "Montorio",
                        "latitude": "45.45826000",
                        "longitude": "11.06589000"
                    },
                    {
                        "id": 140588,
                        "name": "Montorso Vicentino",
                        "latitude": "45.49089000",
                        "longitude": "11.36019000"
                    },
                    {
                        "id": 140616,
                        "name": "Moriago della Battaglia",
                        "latitude": "45.86589000",
                        "longitude": "12.10077000"
                    },
                    {
                        "id": 140648,
                        "name": "Mosnigo",
                        "latitude": "45.86303000",
                        "longitude": "12.07852000"
                    },
                    {
                        "id": 140652,
                        "name": "Mossano",
                        "latitude": "45.41951000",
                        "longitude": "11.55382000"
                    },
                    {
                        "id": 140655,
                        "name": "Motta",
                        "latitude": "45.59540000",
                        "longitude": "11.49798000"
                    },
                    {
                        "id": 140665,
                        "name": "Motta di Livenza",
                        "latitude": "45.77552000",
                        "longitude": "12.60411000"
                    },
                    {
                        "id": 140674,
                        "name": "Mozzecane",
                        "latitude": "45.30763000",
                        "longitude": "10.81554000"
                    },
                    {
                        "id": 140685,
                        "name": "Murano",
                        "latitude": "45.45857000",
                        "longitude": "12.35683000"
                    },
                    {
                        "id": 140688,
                        "name": "Mure",
                        "latitude": "45.73419000",
                        "longitude": "11.61065000"
                    },
                    {
                        "id": 140696,
                        "name": "Musano",
                        "latitude": "45.72646000",
                        "longitude": "12.11785000"
                    },
                    {
                        "id": 140700,
                        "name": "Musestre",
                        "latitude": "45.58864000",
                        "longitude": "12.37249000"
                    },
                    {
                        "id": 140701,
                        "name": "Musile di Piave",
                        "latitude": "45.62057000",
                        "longitude": "12.54177000"
                    },
                    {
                        "id": 140703,
                        "name": "Mussolente",
                        "latitude": "45.77920000",
                        "longitude": "11.80620000"
                    },
                    {
                        "id": 140735,
                        "name": "Negrar",
                        "latitude": "45.52918000",
                        "longitude": "10.93899000"
                    },
                    {
                        "id": 140748,
                        "name": "Nervesa della Battaglia",
                        "latitude": "45.81232000",
                        "longitude": "12.19837000"
                    },
                    {
                        "id": 140776,
                        "name": "Noale",
                        "latitude": "45.54596000",
                        "longitude": "12.06445000"
                    },
                    {
                        "id": 140791,
                        "name": "Nogara",
                        "latitude": "45.18109000",
                        "longitude": "11.06008000"
                    },
                    {
                        "id": 140793,
                        "name": "Nogarole Rocca",
                        "latitude": "45.29027000",
                        "longitude": "10.88342000"
                    },
                    {
                        "id": 140794,
                        "name": "Nogarole Vicentino",
                        "latitude": "45.56019000",
                        "longitude": "11.28829000"
                    },
                    {
                        "id": 140826,
                        "name": "Nove",
                        "latitude": "45.72159000",
                        "longitude": "11.67833000"
                    },
                    {
                        "id": 140831,
                        "name": "Noventa",
                        "latitude": "45.41429000",
                        "longitude": "11.95101000"
                    },
                    {
                        "id": 140833,
                        "name": "Noventa di Piave",
                        "latitude": "45.65981000",
                        "longitude": "12.53322000"
                    },
                    {
                        "id": 140832,
                        "name": "Noventa Vicentina",
                        "latitude": "45.29438000",
                        "longitude": "11.54843000"
                    },
                    {
                        "id": 140839,
                        "name": "Novoledo",
                        "latitude": "45.64647000",
                        "longitude": "11.50952000"
                    },
                    {
                        "id": 140868,
                        "name": "Occhiobello",
                        "latitude": "44.92240000",
                        "longitude": "11.58139000"
                    },
                    {
                        "id": 140872,
                        "name": "Oderzo",
                        "latitude": "45.78114000",
                        "longitude": "12.49442000"
                    },
                    {
                        "id": 140912,
                        "name": "Oltre Brenta",
                        "latitude": "45.41207000",
                        "longitude": "11.99803000"
                    },
                    {
                        "id": 140930,
                        "name": "Onè",
                        "latitude": "45.78374000",
                        "longitude": "11.87404000"
                    },
                    {
                        "id": 140926,
                        "name": "Onigo",
                        "latitude": "45.85701000",
                        "longitude": "11.99073000"
                    },
                    {
                        "id": 140933,
                        "name": "Oppeano",
                        "latitude": "45.30331000",
                        "longitude": "11.18005000"
                    },
                    {
                        "id": 140949,
                        "name": "Orgiano",
                        "latitude": "45.33366000",
                        "longitude": "11.45953000"
                    },
                    {
                        "id": 140962,
                        "name": "Ormelle",
                        "latitude": "45.77780000",
                        "longitude": "12.42429000"
                    },
                    {
                        "id": 140970,
                        "name": "Orsago",
                        "latitude": "45.92965000",
                        "longitude": "12.42712000"
                    },
                    {
                        "id": 141016,
                        "name": "Ospedaletto",
                        "latitude": "45.66194000",
                        "longitude": "12.07884000"
                    },
                    {
                        "id": 141018,
                        "name": "Ospedaletto Euganeo",
                        "latitude": "45.21842000",
                        "longitude": "11.60345000"
                    },
                    {
                        "id": 141022,
                        "name": "Ospitale di Cadore",
                        "latitude": "46.32808000",
                        "longitude": "12.32263000"
                    },
                    {
                        "id": 141076,
                        "name": "Padernello",
                        "latitude": "45.68152000",
                        "longitude": "12.12685000"
                    },
                    {
                        "id": 141077,
                        "name": "Paderno",
                        "latitude": "45.82791000",
                        "longitude": "11.85605000"
                    },
                    {
                        "id": 141082,
                        "name": "Paderno del Grappa",
                        "latitude": "45.82860000",
                        "longitude": "11.85770000"
                    },
                    {
                        "id": 141085,
                        "name": "Padova",
                        "latitude": "45.40797000",
                        "longitude": "11.88586000"
                    },
                    {
                        "id": 141093,
                        "name": "Paese",
                        "latitude": "45.67417000",
                        "longitude": "12.16389000"
                    },
                    {
                        "id": 58270,
                        "name": "Palù",
                        "latitude": "45.32473000",
                        "longitude": "11.15635000"
                    },
                    {
                        "id": 58292,
                        "name": "Papozze",
                        "latitude": "44.98578000",
                        "longitude": "12.03092000"
                    },
                    {
                        "id": 58312,
                        "name": "Parona",
                        "latitude": "45.47882000",
                        "longitude": "10.94414000"
                    },
                    {
                        "id": 58326,
                        "name": "Passarella",
                        "latitude": "45.59436000",
                        "longitude": "12.60537000"
                    },
                    {
                        "id": 58340,
                        "name": "Pastrengo",
                        "latitude": "45.49588000",
                        "longitude": "10.79897000"
                    },
                    {
                        "id": 58377,
                        "name": "Pedavena",
                        "latitude": "46.03951000",
                        "longitude": "11.88310000"
                    },
                    {
                        "id": 58378,
                        "name": "Pedemonte",
                        "latitude": "45.90840000",
                        "longitude": "11.30859000"
                    },
                    {
                        "id": 58380,
                        "name": "Pederiva",
                        "latitude": "45.42254000",
                        "longitude": "11.46568000"
                    },
                    {
                        "id": 58381,
                        "name": "Pederobba",
                        "latitude": "45.87567000",
                        "longitude": "11.94977000"
                    },
                    {
                        "id": 58388,
                        "name": "Pegolotte",
                        "latitude": "45.19178000",
                        "longitude": "12.03791000"
                    },
                    {
                        "id": 58394,
                        "name": "Pellestrina",
                        "latitude": "45.27716000",
                        "longitude": "12.30238000"
                    },
                    {
                        "id": 58412,
                        "name": "Perarolo di Cadore",
                        "latitude": "46.39383000",
                        "longitude": "12.35636000"
                    },
                    {
                        "id": 58433,
                        "name": "Pernumia",
                        "latitude": "45.25899000",
                        "longitude": "11.78721000"
                    },
                    {
                        "id": 58434,
                        "name": "Pero",
                        "latitude": "45.70635000",
                        "longitude": "12.34867000"
                    },
                    {
                        "id": 58449,
                        "name": "Pescantina",
                        "latitude": "45.48548000",
                        "longitude": "10.86796000"
                    },
                    {
                        "id": 58456,
                        "name": "Peschiera del Garda",
                        "latitude": "45.43912000",
                        "longitude": "10.68614000"
                    },
                    {
                        "id": 58468,
                        "name": "Peseggia-Gardigiano",
                        "latitude": "45.56167000",
                        "longitude": "12.17944000"
                    },
                    {
                        "id": 58494,
                        "name": "Pettorazza Grimani",
                        "latitude": "45.13585000",
                        "longitude": "11.98779000"
                    },
                    {
                        "id": 58496,
                        "name": "Pezzan",
                        "latitude": "45.69341000",
                        "longitude": "12.09616000"
                    },
                    {
                        "id": 58503,
                        "name": "Piacenza d'Adige",
                        "latitude": "45.12749000",
                        "longitude": "11.54333000"
                    },
                    {
                        "id": 58530,
                        "name": "Pianezze",
                        "latitude": "45.74141000",
                        "longitude": "11.62700000"
                    },
                    {
                        "id": 58535,
                        "name": "Pianiga",
                        "latitude": "45.45708000",
                        "longitude": "12.00762000"
                    },
                    {
                        "id": 58560,
                        "name": "Piavon",
                        "latitude": "45.76429000",
                        "longitude": "12.52673000"
                    },
                    {
                        "id": 58562,
                        "name": "Piazza",
                        "latitude": "45.21585000",
                        "longitude": "11.14244000"
                    },
                    {
                        "id": 58575,
                        "name": "Piazzola sul Brenta",
                        "latitude": "45.53845000",
                        "longitude": "11.78437000"
                    },
                    {
                        "id": 58583,
                        "name": "Pie' Falcade",
                        "latitude": "46.35660000",
                        "longitude": "11.87207000"
                    },
                    {
                        "id": 58631,
                        "name": "Pieve",
                        "latitude": "45.53924000",
                        "longitude": "11.82930000"
                    },
                    {
                        "id": 58645,
                        "name": "Pieve d'Alpago",
                        "latitude": "46.16658000",
                        "longitude": "12.35344000"
                    },
                    {
                        "id": 58649,
                        "name": "Pieve di Cadore",
                        "latitude": "46.42466000",
                        "longitude": "12.36416000"
                    },
                    {
                        "id": 58653,
                        "name": "Pieve di Soligo",
                        "latitude": "45.89836000",
                        "longitude": "12.17128000"
                    },
                    {
                        "id": 58674,
                        "name": "Pincara",
                        "latitude": "45.00064000",
                        "longitude": "11.62101000"
                    },
                    {
                        "id": 58690,
                        "name": "Piombino Dese",
                        "latitude": "45.60964000",
                        "longitude": "11.99416000"
                    },
                    {
                        "id": 58691,
                        "name": "Pionca",
                        "latitude": "45.46591000",
                        "longitude": "11.96232000"
                    },
                    {
                        "id": 58695,
                        "name": "Piove di Sacco-Piovega",
                        "latitude": "45.29665000",
                        "longitude": "12.03683000"
                    },
                    {
                        "id": 58696,
                        "name": "Piovene Rocchette",
                        "latitude": "45.75601000",
                        "longitude": "11.43273000"
                    },
                    {
                        "id": 58778,
                        "name": "Poiana Maggiore",
                        "latitude": "45.29039000",
                        "longitude": "11.50250000"
                    },
                    {
                        "id": 58779,
                        "name": "Poianella",
                        "latitude": "45.63041000",
                        "longitude": "11.62853000"
                    },
                    {
                        "id": 58780,
                        "name": "Poiano",
                        "latitude": "45.47029000",
                        "longitude": "11.01875000"
                    },
                    {
                        "id": 58784,
                        "name": "Polesella",
                        "latitude": "44.96457000",
                        "longitude": "11.74887000"
                    },
                    {
                        "id": 58805,
                        "name": "Polverara",
                        "latitude": "45.30945000",
                        "longitude": "11.95474000"
                    },
                    {
                        "id": 58826,
                        "name": "Ponso",
                        "latitude": "45.18232000",
                        "longitude": "11.57933000"
                    },
                    {
                        "id": 58854,
                        "name": "Ponte di Barbarano",
                        "latitude": "45.39206000",
                        "longitude": "11.57847000"
                    },
                    {
                        "id": 58855,
                        "name": "Ponte di Castegnero",
                        "latitude": "45.43672000",
                        "longitude": "11.60069000"
                    },
                    {
                        "id": 58857,
                        "name": "Ponte di Nanto",
                        "latitude": "45.42427000",
                        "longitude": "11.59400000"
                    },
                    {
                        "id": 58858,
                        "name": "Ponte di Piave",
                        "latitude": "45.71904000",
                        "longitude": "12.46186000"
                    },
                    {
                        "id": 58860,
                        "name": "Ponte nelle Alpi",
                        "latitude": "46.18083000",
                        "longitude": "12.28333000"
                    },
                    {
                        "id": 58861,
                        "name": "Ponte nelle Alpi-Polpet",
                        "latitude": "46.18833000",
                        "longitude": "12.27833000"
                    },
                    {
                        "id": 58848,
                        "name": "Ponte San Nicolò",
                        "latitude": "45.36718000",
                        "longitude": "11.92341000"
                    },
                    {
                        "id": 58864,
                        "name": "Pontecchio Polesine",
                        "latitude": "45.02020000",
                        "longitude": "11.81321000"
                    },
                    {
                        "id": 58874,
                        "name": "Pontelongo",
                        "latitude": "45.24590000",
                        "longitude": "12.02582000"
                    },
                    {
                        "id": 58895,
                        "name": "Ponzano",
                        "latitude": "45.71541000",
                        "longitude": "12.20444000"
                    },
                    {
                        "id": 58904,
                        "name": "Porcellengo",
                        "latitude": "45.70613000",
                        "longitude": "12.14225000"
                    },
                    {
                        "id": 58937,
                        "name": "Porto Tolle",
                        "latitude": "44.94969000",
                        "longitude": "12.32453000"
                    },
                    {
                        "id": 58940,
                        "name": "Porto Viro",
                        "latitude": "45.02678000",
                        "longitude": "12.21754000"
                    },
                    {
                        "id": 58942,
                        "name": "Portobuffolè",
                        "latitude": "45.85665000",
                        "longitude": "12.53761000"
                    },
                    {
                        "id": 58946,
                        "name": "Portogruaro",
                        "latitude": "45.78071000",
                        "longitude": "12.84052000"
                    },
                    {
                        "id": 58955,
                        "name": "Posina",
                        "latitude": "45.79106000",
                        "longitude": "11.26244000"
                    },
                    {
                        "id": 58957,
                        "name": "Possagno",
                        "latitude": "45.84795000",
                        "longitude": "11.88467000"
                    },
                    {
                        "id": 58963,
                        "name": "Postioma",
                        "latitude": "45.71753000",
                        "longitude": "12.15218000"
                    },
                    {
                        "id": 58967,
                        "name": "Pove del Grappa",
                        "latitude": "45.79820000",
                        "longitude": "11.72990000"
                    },
                    {
                        "id": 58968,
                        "name": "Povegliano",
                        "latitude": "45.75947000",
                        "longitude": "12.20944000"
                    },
                    {
                        "id": 58969,
                        "name": "Povegliano Veronese",
                        "latitude": "45.34730000",
                        "longitude": "10.88056000"
                    },
                    {
                        "id": 58985,
                        "name": "Pozzoleone",
                        "latitude": "45.64965000",
                        "longitude": "11.67098000"
                    },
                    {
                        "id": 58988,
                        "name": "Pozzonovo",
                        "latitude": "45.19629000",
                        "longitude": "11.79171000"
                    },
                    {
                        "id": 58995,
                        "name": "Pradelle",
                        "latitude": "45.28315000",
                        "longitude": "10.87083000"
                    },
                    {
                        "id": 59004,
                        "name": "Pramaggiore",
                        "latitude": "45.81500000",
                        "longitude": "12.73889000"
                    },
                    {
                        "id": 59005,
                        "name": "Pramaggiore Blessaglia",
                        "latitude": "45.80528000",
                        "longitude": "12.72500000"
                    },
                    {
                        "id": 59040,
                        "name": "Preara-Moraro-Levà Nord",
                        "latitude": "45.67996000",
                        "longitude": "11.54286000"
                    },
                    {
                        "id": 59048,
                        "name": "Preganziol",
                        "latitude": "45.60139000",
                        "longitude": "12.23722000"
                    },
                    {
                        "id": 59068,
                        "name": "Pressana",
                        "latitude": "45.28258000",
                        "longitude": "11.40724000"
                    },
                    {
                        "id": 59082,
                        "name": "Priula-Colfosco",
                        "latitude": "45.81998000",
                        "longitude": "12.25847000"
                    },
                    {
                        "id": 59113,
                        "name": "Provincia di Belluno",
                        "latitude": "46.25000000",
                        "longitude": "12.13333000"
                    },
                    {
                        "id": 59155,
                        "name": "Provincia di Padova",
                        "latitude": "45.35000000",
                        "longitude": "11.81667000"
                    },
                    {
                        "id": 59171,
                        "name": "Provincia di Rovigo",
                        "latitude": "45.03333000",
                        "longitude": "11.83333000"
                    },
                    {
                        "id": 59181,
                        "name": "Provincia di Treviso",
                        "latitude": "45.83333000",
                        "longitude": "12.21667000"
                    },
                    {
                        "id": 59185,
                        "name": "Provincia di Venezia",
                        "latitude": "45.44045000",
                        "longitude": "12.32632000"
                    },
                    {
                        "id": 59187,
                        "name": "Provincia di Verona",
                        "latitude": "45.41667000",
                        "longitude": "11.03333000"
                    },
                    {
                        "id": 59189,
                        "name": "Provincia di Vicenza",
                        "latitude": "45.66667000",
                        "longitude": "11.45000000"
                    },
                    {
                        "id": 59206,
                        "name": "Puos d'Alpago",
                        "latitude": "46.14154000",
                        "longitude": "12.36176000"
                    },
                    {
                        "id": 59210,
                        "name": "Quaderni",
                        "latitude": "45.32915000",
                        "longitude": "10.78951000"
                    },
                    {
                        "id": 59230,
                        "name": "Quarto d'Altino",
                        "latitude": "45.57944000",
                        "longitude": "12.37333000"
                    },
                    {
                        "id": 59241,
                        "name": "Quero",
                        "latitude": "45.92094000",
                        "longitude": "11.93151000"
                    },
                    {
                        "id": 59250,
                        "name": "Quinto di Treviso",
                        "latitude": "45.64351000",
                        "longitude": "12.16509000"
                    },
                    {
                        "id": 59249,
                        "name": "Quinto Vicentino",
                        "latitude": "45.57534000",
                        "longitude": "11.62815000"
                    },
                    {
                        "id": 59271,
                        "name": "Raldon",
                        "latitude": "45.34921000",
                        "longitude": "11.03786000"
                    },
                    {
                        "id": 59275,
                        "name": "Ramon",
                        "latitude": "45.71386000",
                        "longitude": "11.86828000"
                    },
                    {
                        "id": 59313,
                        "name": "Recoaro Terme",
                        "latitude": "45.70373000",
                        "longitude": "11.22216000"
                    },
                    {
                        "id": 59317,
                        "name": "Refrontolo",
                        "latitude": "45.92305000",
                        "longitude": "12.20865000"
                    },
                    {
                        "id": 59334,
                        "name": "Resana",
                        "latitude": "45.63535000",
                        "longitude": "11.95472000"
                    },
                    {
                        "id": 59344,
                        "name": "Revine",
                        "latitude": "45.99935000",
                        "longitude": "12.25561000"
                    },
                    {
                        "id": 59372,
                        "name": "Riese Pio X",
                        "latitude": "45.72858000",
                        "longitude": "11.91801000"
                    },
                    {
                        "id": 59422,
                        "name": "Rivalta",
                        "latitude": "45.65714000",
                        "longitude": "10.89336000"
                    },
                    {
                        "id": 59425,
                        "name": "Rivamonte Agordino",
                        "latitude": "46.25226000",
                        "longitude": "12.02303000"
                    },
                    {
                        "id": 59442,
                        "name": "Rivoli Veronese",
                        "latitude": "45.57249000",
                        "longitude": "10.81178000"
                    },
                    {
                        "id": 59447,
                        "name": "Roana",
                        "latitude": "45.87696000",
                        "longitude": "11.45274000"
                    },
                    {
                        "id": 59461,
                        "name": "Robegano",
                        "latitude": "45.54253000",
                        "longitude": "12.11924000"
                    },
                    {
                        "id": 59474,
                        "name": "Rocca Pietore",
                        "latitude": "46.43392000",
                        "longitude": "11.97679000"
                    },
                    {
                        "id": 59578,
                        "name": "Romano d'Ezzelino",
                        "latitude": "45.77902000",
                        "longitude": "11.76657000"
                    },
                    {
                        "id": 59613,
                        "name": "Roncà",
                        "latitude": "45.47987000",
                        "longitude": "11.29323000"
                    },
                    {
                        "id": 59589,
                        "name": "Roncade",
                        "latitude": "45.62165000",
                        "longitude": "12.37643000"
                    },
                    {
                        "id": 59591,
                        "name": "Roncanova",
                        "latitude": "45.14318000",
                        "longitude": "11.10349000"
                    },
                    {
                        "id": 59597,
                        "name": "Ronchi di Campanile",
                        "latitude": "45.45790000",
                        "longitude": "11.77483000"
                    },
                    {
                        "id": 59601,
                        "name": "Ronco All'Adige",
                        "latitude": "45.33647000",
                        "longitude": "11.23658000"
                    },
                    {
                        "id": 59653,
                        "name": "Rosà",
                        "latitude": "45.70198000",
                        "longitude": "11.76141000"
                    },
                    {
                        "id": 59633,
                        "name": "Rosegaferro",
                        "latitude": "45.34361000",
                        "longitude": "10.80854000"
                    },
                    {
                        "id": 59642,
                        "name": "Rosolina",
                        "latitude": "45.07674000",
                        "longitude": "12.22977000"
                    },
                    {
                        "id": 59649,
                        "name": "Rossano Veneto",
                        "latitude": "45.70308000",
                        "longitude": "11.80369000"
                    },
                    {
                        "id": 59663,
                        "name": "Rottanova",
                        "latitude": "45.14361000",
                        "longitude": "12.01849000"
                    },
                    {
                        "id": 59665,
                        "name": "Rotzo",
                        "latitude": "45.86190000",
                        "longitude": "11.39619000"
                    },
                    {
                        "id": 59675,
                        "name": "Roverchiara",
                        "latitude": "45.26799000",
                        "longitude": "11.24510000"
                    },
                    {
                        "id": 59680,
                        "name": "Roverè Veronese",
                        "latitude": "45.59329000",
                        "longitude": "11.06999000"
                    },
                    {
                        "id": 59676,
                        "name": "Roveredo di Guà",
                        "latitude": "45.27309000",
                        "longitude": "11.44420000"
                    },
                    {
                        "id": 59685,
                        "name": "Rovigo",
                        "latitude": "45.06982000",
                        "longitude": "11.79022000"
                    },
                    {
                        "id": 59690,
                        "name": "Rubano",
                        "latitude": "45.42514000",
                        "longitude": "11.79146000"
                    },
                    {
                        "id": 59718,
                        "name": "Saccolongo",
                        "latitude": "45.40152000",
                        "longitude": "11.74863000"
                    },
                    {
                        "id": 59719,
                        "name": "Sachet",
                        "latitude": "46.36982000",
                        "longitude": "11.93129000"
                    },
                    {
                        "id": 59748,
                        "name": "Salara",
                        "latitude": "44.98586000",
                        "longitude": "11.42655000"
                    },
                    {
                        "id": 59752,
                        "name": "Salcedo",
                        "latitude": "45.75783000",
                        "longitude": "11.56621000"
                    },
                    {
                        "id": 59763,
                        "name": "Saletto",
                        "latitude": "45.22889000",
                        "longitude": "11.53780000"
                    },
                    {
                        "id": 59764,
                        "name": "Saletto-San Bartolomeo",
                        "latitude": "45.72639000",
                        "longitude": "12.39556000"
                    },
                    {
                        "id": 59765,
                        "name": "Salgareda",
                        "latitude": "45.70500000",
                        "longitude": "12.48833000"
                    },
                    {
                        "id": 59773,
                        "name": "Salionze",
                        "latitude": "45.40493000",
                        "longitude": "10.72259000"
                    },
                    {
                        "id": 59776,
                        "name": "Salizzole",
                        "latitude": "45.24004000",
                        "longitude": "11.09540000"
                    },
                    {
                        "id": 59788,
                        "name": "Salvatronda",
                        "latitude": "45.67425000",
                        "longitude": "11.97709000"
                    },
                    {
                        "id": 59795,
                        "name": "Salzano",
                        "latitude": "45.52221000",
                        "longitude": "12.10151000"
                    },
                    {
                        "id": 59802,
                        "name": "Sambruson",
                        "latitude": "45.41039000",
                        "longitude": "12.10311000"
                    },
                    {
                        "id": 59809,
                        "name": "Sambughe",
                        "latitude": "45.59401000",
                        "longitude": "12.21824000"
                    },
                    {
                        "id": 59826,
                        "name": "San Bellino",
                        "latitude": "45.02943000",
                        "longitude": "11.59222000"
                    },
                    {
                        "id": 59839,
                        "name": "San Biagio",
                        "latitude": "45.37518000",
                        "longitude": "11.73713000"
                    },
                    {
                        "id": 59844,
                        "name": "San Biagio di Callalta",
                        "latitude": "45.68361000",
                        "longitude": "12.37722000"
                    },
                    {
                        "id": 59846,
                        "name": "San Bonifacio",
                        "latitude": "45.39595000",
                        "longitude": "11.27352000"
                    },
                    {
                        "id": 59901,
                        "name": "San Donà di Piave",
                        "latitude": "45.63019000",
                        "longitude": "12.56810000"
                    },
                    {
                        "id": 59917,
                        "name": "San Fidenzio",
                        "latitude": "45.21622000",
                        "longitude": "11.51802000"
                    },
                    {
                        "id": 59920,
                        "name": "San Fior di Sopra",
                        "latitude": "45.92219000",
                        "longitude": "12.36137000"
                    },
                    {
                        "id": 59922,
                        "name": "San Floriano",
                        "latitude": "45.51796000",
                        "longitude": "10.90817000"
                    },
                    {
                        "id": 59924,
                        "name": "San Floriano-Olmi",
                        "latitude": "45.67349000",
                        "longitude": "12.33039000"
                    },
                    {
                        "id": 59938,
                        "name": "San Germano dei Berici",
                        "latitude": "45.40179000",
                        "longitude": "11.47130000"
                    },
                    {
                        "id": 59965,
                        "name": "San Giorgio al Tagliamento-Pozzi",
                        "latitude": "45.79639000",
                        "longitude": "12.96361000"
                    },
                    {
                        "id": 59968,
                        "name": "San Giorgio delle Pertiche",
                        "latitude": "45.54100000",
                        "longitude": "11.89401000"
                    },
                    {
                        "id": 59969,
                        "name": "San Giorgio di Livenza",
                        "latitude": "45.65330000",
                        "longitude": "12.79692000"
                    },
                    {
                        "id": 59974,
                        "name": "San Giorgio in Bosco",
                        "latitude": "45.58863000",
                        "longitude": "11.80736000"
                    },
                    {
                        "id": 59975,
                        "name": "San Giorgio in Salici",
                        "latitude": "45.42676000",
                        "longitude": "10.78906000"
                    },
                    {
                        "id": 59984,
                        "name": "San Giovanni Ilarione",
                        "latitude": "45.51927000",
                        "longitude": "11.23707000"
                    },
                    {
                        "id": 59987,
                        "name": "San Giovanni Lupatoto",
                        "latitude": "45.38193000",
                        "longitude": "11.04474000"
                    },
                    {
                        "id": 60019,
                        "name": "San Gregorio",
                        "latitude": "45.34286000",
                        "longitude": "11.29933000"
                    },
                    {
                        "id": 60025,
                        "name": "San Gregorio nelle Alpi",
                        "latitude": "46.10391000",
                        "longitude": "12.02670000"
                    },
                    {
                        "id": 60034,
                        "name": "San Liberale",
                        "latitude": "45.54778000",
                        "longitude": "12.34139000"
                    },
                    {
                        "id": 60070,
                        "name": "San Martino",
                        "latitude": "45.90807000",
                        "longitude": "12.34132000"
                    },
                    {
                        "id": 60073,
                        "name": "San Martino Buon Albergo",
                        "latitude": "45.42083000",
                        "longitude": "11.09562000"
                    },
                    {
                        "id": 60086,
                        "name": "San Martino di Lupari",
                        "latitude": "45.65128000",
                        "longitude": "11.86004000"
                    },
                    {
                        "id": 60087,
                        "name": "San Martino di Venezze",
                        "latitude": "45.12532000",
                        "longitude": "11.87018000"
                    },
                    {
                        "id": 60112,
                        "name": "San Mauro di Saline",
                        "latitude": "45.56452000",
                        "longitude": "11.11234000"
                    },
                    {
                        "id": 60121,
                        "name": "San Michele al Tagliamento",
                        "latitude": "45.76435000",
                        "longitude": "12.99494000"
                    },
                    {
                        "id": 60124,
                        "name": "San Michele di Piave",
                        "latitude": "45.79667000",
                        "longitude": "12.34634000"
                    },
                    {
                        "id": 60129,
                        "name": "San Nazario",
                        "latitude": "45.83982000",
                        "longitude": "11.68893000"
                    },
                    {
                        "id": 60147,
                        "name": "San Nicolò Comelico",
                        "latitude": "46.58253000",
                        "longitude": "12.52730000"
                    },
                    {
                        "id": 60171,
                        "name": "San Pietro",
                        "latitude": "45.44209000",
                        "longitude": "11.12968000"
                    },
                    {
                        "id": 60191,
                        "name": "San Pietro di Cadore",
                        "latitude": "46.57190000",
                        "longitude": "12.58690000"
                    },
                    {
                        "id": 60193,
                        "name": "San Pietro di Feletto",
                        "latitude": "45.91391000",
                        "longitude": "12.25101000"
                    },
                    {
                        "id": 60194,
                        "name": "San Pietro di Morubio",
                        "latitude": "45.24248000",
                        "longitude": "11.22700000"
                    },
                    {
                        "id": 60196,
                        "name": "San Pietro in Cariano",
                        "latitude": "45.51751000",
                        "longitude": "10.88624000"
                    },
                    {
                        "id": 60199,
                        "name": "San Pietro in Gu",
                        "latitude": "45.60879000",
                        "longitude": "11.67355000"
                    },
                    {
                        "id": 60202,
                        "name": "San Pietro in Volta",
                        "latitude": "45.31542000",
                        "longitude": "12.31518000"
                    },
                    {
                        "id": 60181,
                        "name": "San Pietro Mussolino",
                        "latitude": "45.58359000",
                        "longitude": "11.25930000"
                    },
                    {
                        "id": 60183,
                        "name": "San Pietro Valdastico",
                        "latitude": "45.88670000",
                        "longitude": "11.36159000"
                    },
                    {
                        "id": 60185,
                        "name": "San Pietro Viminario",
                        "latitude": "45.24501000",
                        "longitude": "11.82049000"
                    },
                    {
                        "id": 60207,
                        "name": "San Polo di Piave",
                        "latitude": "45.78969000",
                        "longitude": "12.39287000"
                    },
                    {
                        "id": 60216,
                        "name": "San Quirico",
                        "latitude": "45.67685000",
                        "longitude": "11.27260000"
                    },
                    {
                        "id": 60250,
                        "name": "San Stino di Livenza",
                        "latitude": "45.72559000",
                        "longitude": "12.68971000"
                    },
                    {
                        "id": 60262,
                        "name": "San Vendemiano",
                        "latitude": "45.88732000",
                        "longitude": "12.35164000"
                    },
                    {
                        "id": 60263,
                        "name": "San Vendemiano-Fossamerlo",
                        "latitude": "45.89180000",
                        "longitude": "12.32992000"
                    },
                    {
                        "id": 60273,
                        "name": "San Vito",
                        "latitude": "45.75514000",
                        "longitude": "11.91553000"
                    },
                    {
                        "id": 60279,
                        "name": "San Vito al Mantico",
                        "latitude": "45.47163000",
                        "longitude": "10.89243000"
                    },
                    {
                        "id": 60284,
                        "name": "San Vito di Leguzzano",
                        "latitude": "45.68494000",
                        "longitude": "11.38872000"
                    },
                    {
                        "id": 60290,
                        "name": "San Zeno",
                        "latitude": "45.63381000",
                        "longitude": "10.73046000"
                    },
                    {
                        "id": 60292,
                        "name": "San Zeno di Montagna",
                        "latitude": "45.63749000",
                        "longitude": "10.73218000"
                    },
                    {
                        "id": 60293,
                        "name": "San Zeno-San Giuseppe",
                        "latitude": "45.75727000",
                        "longitude": "11.76208000"
                    },
                    {
                        "id": 60297,
                        "name": "San Zenone degli Ezzelini",
                        "latitude": "45.78040000",
                        "longitude": "11.83720000"
                    },
                    {
                        "id": 60301,
                        "name": "Sandrà",
                        "latitude": "45.46067000",
                        "longitude": "10.78686000"
                    },
                    {
                        "id": 60300,
                        "name": "Sandrigo",
                        "latitude": "45.66083000",
                        "longitude": "11.58921000"
                    },
                    {
                        "id": 60307,
                        "name": "Sanguinetto",
                        "latitude": "45.18567000",
                        "longitude": "11.14412000"
                    },
                    {
                        "id": 60331,
                        "name": "Sant'Alberto",
                        "latitude": "45.61306000",
                        "longitude": "12.13472000"
                    },
                    {
                        "id": 60338,
                        "name": "Sant'Ambrogio di Valpollicella",
                        "latitude": "45.52089000",
                        "longitude": "10.83618000"
                    },
                    {
                        "id": 60343,
                        "name": "Sant'Andrea",
                        "latitude": "45.64664000",
                        "longitude": "11.89639000"
                    },
                    {
                        "id": 60351,
                        "name": "Sant'Angelo",
                        "latitude": "45.52031000",
                        "longitude": "12.01862000"
                    },
                    {
                        "id": 60366,
                        "name": "Sant'Angelo di Piove di Sacco",
                        "latitude": "45.31735000",
                        "longitude": "12.00941000"
                    },
                    {
                        "id": 60373,
                        "name": "Sant'Anna",
                        "latitude": "45.16610000",
                        "longitude": "12.27355000"
                    },
                    {
                        "id": 60375,
                        "name": "Sant'Anna d'Alfaedo",
                        "latitude": "45.62719000",
                        "longitude": "10.95168000"
                    },
                    {
                        "id": 60386,
                        "name": "Sant'Apollinare",
                        "latitude": "45.04115000",
                        "longitude": "11.82533000"
                    },
                    {
                        "id": 60393,
                        "name": "Sant'Elena",
                        "latitude": "45.18744000",
                        "longitude": "11.71169000"
                    },
                    {
                        "id": 60420,
                        "name": "Santa Cristina",
                        "latitude": "45.64350000",
                        "longitude": "12.13903000"
                    },
                    {
                        "id": 60440,
                        "name": "Santa Giustina",
                        "latitude": "46.08118000",
                        "longitude": "12.03822000"
                    },
                    {
                        "id": 60442,
                        "name": "Santa Giustina in Colle",
                        "latitude": "45.57506000",
                        "longitude": "11.90039000"
                    },
                    {
                        "id": 60448,
                        "name": "Santa Lucia di Piave",
                        "latitude": "45.86159000",
                        "longitude": "12.29390000"
                    },
                    {
                        "id": 60452,
                        "name": "Santa Margherita d'Adige",
                        "latitude": "45.21210000",
                        "longitude": "11.55759000"
                    },
                    {
                        "id": 60456,
                        "name": "Santa Maria",
                        "latitude": "45.99115000",
                        "longitude": "12.22992000"
                    },
                    {
                        "id": 60477,
                        "name": "Santa Maria di Non",
                        "latitude": "45.51322000",
                        "longitude": "11.85364000"
                    },
                    {
                        "id": 60478,
                        "name": "Santa Maria di Sala",
                        "latitude": "45.50699000",
                        "longitude": "12.03565000"
                    },
                    {
                        "id": 60465,
                        "name": "Santa Maria Maddalena",
                        "latitude": "44.90231000",
                        "longitude": "11.60663000"
                    },
                    {
                        "id": 60502,
                        "name": "Santandrà",
                        "latitude": "45.74778000",
                        "longitude": "12.20111000"
                    },
                    {
                        "id": 60520,
                        "name": "Santo Stefano di Cadore",
                        "latitude": "46.55827000",
                        "longitude": "12.54956000"
                    },
                    {
                        "id": 60526,
                        "name": "Santo Stefano-Bonaldo",
                        "latitude": "45.36718000",
                        "longitude": "11.33199000"
                    },
                    {
                        "id": 60530,
                        "name": "Santorso",
                        "latitude": "45.73383000",
                        "longitude": "11.38785000"
                    },
                    {
                        "id": 60534,
                        "name": "Saonara",
                        "latitude": "45.36529000",
                        "longitude": "11.98481000"
                    },
                    {
                        "id": 60541,
                        "name": "Sarcedo",
                        "latitude": "45.70134000",
                        "longitude": "11.52963000"
                    },
                    {
                        "id": 60545,
                        "name": "Sarego",
                        "latitude": "45.40769000",
                        "longitude": "11.40190000"
                    },
                    {
                        "id": 60550,
                        "name": "Sarmede",
                        "latitude": "45.97625000",
                        "longitude": "12.38581000"
                    },
                    {
                        "id": 60551,
                        "name": "Sarmeola",
                        "latitude": "45.42400000",
                        "longitude": "11.81674000"
                    },
                    {
                        "id": 60612,
                        "name": "Scaltenigo",
                        "latitude": "45.47120000",
                        "longitude": "12.08106000"
                    },
                    {
                        "id": 60630,
                        "name": "Scardovari",
                        "latitude": "44.89765000",
                        "longitude": "12.45462000"
                    },
                    {
                        "id": 60644,
                        "name": "Schiavon",
                        "latitude": "45.69654000",
                        "longitude": "11.64573000"
                    },
                    {
                        "id": 60647,
                        "name": "Schio",
                        "latitude": "45.71262000",
                        "longitude": "11.35671000"
                    },
                    {
                        "id": 60661,
                        "name": "Scomigo",
                        "latitude": "45.94255000",
                        "longitude": "12.32014000"
                    },
                    {
                        "id": 60669,
                        "name": "Scorzè",
                        "latitude": "45.57405000",
                        "longitude": "12.11156000"
                    },
                    {
                        "id": 60681,
                        "name": "Sedico",
                        "latitude": "46.10563000",
                        "longitude": "12.09330000"
                    },
                    {
                        "id": 60692,
                        "name": "Segusino",
                        "latitude": "45.91701000",
                        "longitude": "11.95560000"
                    },
                    {
                        "id": 60706,
                        "name": "Selva del Montello",
                        "latitude": "45.78835000",
                        "longitude": "12.14350000"
                    },
                    {
                        "id": 60707,
                        "name": "Selva di Cadore",
                        "latitude": "46.45028000",
                        "longitude": "12.05694000"
                    },
                    {
                        "id": 60708,
                        "name": "Selva di Progno",
                        "latitude": "45.61139000",
                        "longitude": "11.13799000"
                    },
                    {
                        "id": 60710,
                        "name": "Selvazzano Dentro",
                        "latitude": "45.38764000",
                        "longitude": "11.79232000"
                    },
                    {
                        "id": 60738,
                        "name": "Seren del Grappa",
                        "latitude": "45.99594000",
                        "longitude": "11.85624000"
                    },
                    {
                        "id": 60746,
                        "name": "Sernaglia della Battaglia",
                        "latitude": "45.87147000",
                        "longitude": "12.13302000"
                    },
                    {
                        "id": 60787,
                        "name": "Servo",
                        "latitude": "46.05844000",
                        "longitude": "11.78657000"
                    },
                    {
                        "id": 60810,
                        "name": "Settimo",
                        "latitude": "45.47929000",
                        "longitude": "10.90910000"
                    },
                    {
                        "id": 60849,
                        "name": "Silea",
                        "latitude": "45.65444000",
                        "longitude": "12.29701000"
                    },
                    {
                        "id": 60890,
                        "name": "Soave",
                        "latitude": "45.41955000",
                        "longitude": "11.24594000"
                    },
                    {
                        "id": 60893,
                        "name": "Soccher-Paiane-Casan-Arsie",
                        "latitude": "46.18120000",
                        "longitude": "12.31001000"
                    },
                    {
                        "id": 60900,
                        "name": "Solagna",
                        "latitude": "45.81951000",
                        "longitude": "11.71787000"
                    },
                    {
                        "id": 60915,
                        "name": "Solesino",
                        "latitude": "45.17922000",
                        "longitude": "11.74647000"
                    },
                    {
                        "id": 60930,
                        "name": "Sommacampagna",
                        "latitude": "45.40528000",
                        "longitude": "10.84382000"
                    },
                    {
                        "id": 60935,
                        "name": "Sona",
                        "latitude": "45.43271000",
                        "longitude": "10.83990000"
                    },
                    {
                        "id": 60956,
                        "name": "Sorgà",
                        "latitude": "45.21328000",
                        "longitude": "10.97989000"
                    },
                    {
                        "id": 60970,
                        "name": "Sospirolo",
                        "latitude": "46.14134000",
                        "longitude": "12.07365000"
                    },
                    {
                        "id": 60971,
                        "name": "Sossano",
                        "latitude": "45.35754000",
                        "longitude": "11.50819000"
                    },
                    {
                        "id": 60982,
                        "name": "Soverzene",
                        "latitude": "46.20331000",
                        "longitude": "12.30301000"
                    },
                    {
                        "id": 60985,
                        "name": "Sovizzo",
                        "latitude": "45.52669000",
                        "longitude": "11.44610000"
                    },
                    {
                        "id": 60986,
                        "name": "Sovramonte",
                        "latitude": "46.05861000",
                        "longitude": "11.78660000"
                    },
                    {
                        "id": 61015,
                        "name": "Spinea-Orgnano",
                        "latitude": "45.49107000",
                        "longitude": "12.15500000"
                    },
                    {
                        "id": 61021,
                        "name": "Spinimbecco",
                        "latitude": "45.14398000",
                        "longitude": "11.37202000"
                    },
                    {
                        "id": 61032,
                        "name": "Spresiano",
                        "latitude": "45.77908000",
                        "longitude": "12.25628000"
                    },
                    {
                        "id": 61044,
                        "name": "Stallavena-Lugo",
                        "latitude": "45.56289000",
                        "longitude": "10.99669000"
                    },
                    {
                        "id": 61046,
                        "name": "Stanghella",
                        "latitude": "45.13509000",
                        "longitude": "11.75741000"
                    },
                    {
                        "id": 61071,
                        "name": "Stienta",
                        "latitude": "44.93970000",
                        "longitude": "11.54375000"
                    },
                    {
                        "id": 61073,
                        "name": "Stigliano",
                        "latitude": "45.52362000",
                        "longitude": "12.04377000"
                    },
                    {
                        "id": 61082,
                        "name": "Stra",
                        "latitude": "45.41123000",
                        "longitude": "12.01418000"
                    },
                    {
                        "id": 61104,
                        "name": "Strà-Montanara-Pieve",
                        "latitude": "45.42367000",
                        "longitude": "11.15749000"
                    },
                    {
                        "id": 61119,
                        "name": "Summaga",
                        "latitude": "45.77406000",
                        "longitude": "12.79792000"
                    },
                    {
                        "id": 61129,
                        "name": "Susegana",
                        "latitude": "45.85604000",
                        "longitude": "12.25741000"
                    },
                    {
                        "id": 61141,
                        "name": "Taggì",
                        "latitude": "45.46070000",
                        "longitude": "11.81865000"
                    },
                    {
                        "id": 61144,
                        "name": "Taglio",
                        "latitude": "45.02222000",
                        "longitude": "12.21083000"
                    },
                    {
                        "id": 61145,
                        "name": "Taglio di Po",
                        "latitude": "45.00189000",
                        "longitude": "12.21386000"
                    },
                    {
                        "id": 61147,
                        "name": "Taibon Agordino",
                        "latitude": "46.29838000",
                        "longitude": "12.01312000"
                    },
                    {
                        "id": 61157,
                        "name": "Talponada",
                        "latitude": "45.70351000",
                        "longitude": "12.49053000"
                    },
                    {
                        "id": 61159,
                        "name": "Tambre",
                        "latitude": "46.12632000",
                        "longitude": "12.41941000"
                    },
                    {
                        "id": 61171,
                        "name": "Tarzo",
                        "latitude": "45.97711000",
                        "longitude": "12.22917000"
                    },
                    {
                        "id": 61189,
                        "name": "Tavernelle",
                        "latitude": "45.51498000",
                        "longitude": "11.44860000"
                    },
                    {
                        "id": 61195,
                        "name": "Tavo",
                        "latitude": "45.50066000",
                        "longitude": "11.86079000"
                    },
                    {
                        "id": 61203,
                        "name": "Teglio Veneto",
                        "latitude": "45.81637000",
                        "longitude": "12.88414000"
                    },
                    {
                        "id": 61212,
                        "name": "Tencarola",
                        "latitude": "45.39490000",
                        "longitude": "11.80919000"
                    },
                    {
                        "id": 61236,
                        "name": "Terradura",
                        "latitude": "45.32290000",
                        "longitude": "11.82425000"
                    },
                    {
                        "id": 61246,
                        "name": "Terrassa Padovana",
                        "latitude": "45.24409000",
                        "longitude": "11.90271000"
                    },
                    {
                        "id": 61249,
                        "name": "Terrazzo",
                        "latitude": "45.17260000",
                        "longitude": "11.39485000"
                    },
                    {
                        "id": 61252,
                        "name": "Terrossa",
                        "latitude": "45.46340000",
                        "longitude": "11.31860000"
                    },
                    {
                        "id": 61263,
                        "name": "Tessera",
                        "latitude": "45.50241000",
                        "longitude": "12.32632000"
                    },
                    {
                        "id": 61270,
                        "name": "Tezze",
                        "latitude": "45.69011000",
                        "longitude": "11.70672000"
                    },
                    {
                        "id": 61271,
                        "name": "Thiene",
                        "latitude": "45.70880000",
                        "longitude": "11.47959000"
                    },
                    {
                        "id": 61304,
                        "name": "Tombelle",
                        "latitude": "45.39845000",
                        "longitude": "11.98213000"
                    },
                    {
                        "id": 61305,
                        "name": "Tombolo",
                        "latitude": "45.63916000",
                        "longitude": "11.82435000"
                    },
                    {
                        "id": 61311,
                        "name": "Tonezza del Cimone",
                        "latitude": "45.85889000",
                        "longitude": "11.34592000"
                    },
                    {
                        "id": 61374,
                        "name": "Torre di Mosto",
                        "latitude": "45.68629000",
                        "longitude": "12.70027000"
                    },
                    {
                        "id": 61379,
                        "name": "Torrebelvicino",
                        "latitude": "45.71583000",
                        "longitude": "11.31869000"
                    },
                    {
                        "id": 61382,
                        "name": "Torreglia",
                        "latitude": "45.33617000",
                        "longitude": "11.73608000"
                    },
                    {
                        "id": 61387,
                        "name": "Torreselle",
                        "latitude": "45.63026000",
                        "longitude": "12.02250000"
                    },
                    {
                        "id": 61394,
                        "name": "Torri del Benaco",
                        "latitude": "45.61013000",
                        "longitude": "10.68669000"
                    },
                    {
                        "id": 61395,
                        "name": "Torri di Quartesolo",
                        "latitude": "45.51901000",
                        "longitude": "11.62469000"
                    },
                    {
                        "id": 61458,
                        "name": "Trebaseleghe",
                        "latitude": "45.59295000",
                        "longitude": "12.04392000"
                    },
                    {
                        "id": 61469,
                        "name": "Trecenta",
                        "latitude": "45.02937000",
                        "longitude": "11.45931000"
                    },
                    {
                        "id": 61474,
                        "name": "Tregnago",
                        "latitude": "45.51397000",
                        "longitude": "11.16421000"
                    },
                    {
                        "id": 61480,
                        "name": "Tremignon",
                        "latitude": "45.52076000",
                        "longitude": "11.80577000"
                    },
                    {
                        "id": 61486,
                        "name": "Treponti",
                        "latitude": "45.36727000",
                        "longitude": "11.70905000"
                    },
                    {
                        "id": 61500,
                        "name": "Trevenzuolo",
                        "latitude": "45.26974000",
                        "longitude": "10.93386000"
                    },
                    {
                        "id": 61505,
                        "name": "Trevignano",
                        "latitude": "45.73670000",
                        "longitude": "12.06719000"
                    },
                    {
                        "id": 61509,
                        "name": "Treviso",
                        "latitude": "45.66673000",
                        "longitude": "12.24160000"
                    },
                    {
                        "id": 61515,
                        "name": "Tribano",
                        "latitude": "45.20912000",
                        "longitude": "11.83639000"
                    },
                    {
                        "id": 61522,
                        "name": "Trichiana",
                        "latitude": "46.08130000",
                        "longitude": "12.14091000"
                    },
                    {
                        "id": 61537,
                        "name": "Trissino",
                        "latitude": "45.55994000",
                        "longitude": "11.37678000"
                    },
                    {
                        "id": 61542,
                        "name": "Trivignano",
                        "latitude": "45.53197000",
                        "longitude": "12.18687000"
                    },
                    {
                        "id": 61601,
                        "name": "Urbana",
                        "latitude": "45.19278000",
                        "longitude": "11.44490000"
                    },
                    {
                        "id": 61636,
                        "name": "Vago",
                        "latitude": "45.41986000",
                        "longitude": "11.13020000"
                    },
                    {
                        "id": 61650,
                        "name": "Valdagno",
                        "latitude": "45.64498000",
                        "longitude": "11.29886000"
                    },
                    {
                        "id": 61657,
                        "name": "Valdobbiadene",
                        "latitude": "45.89689000",
                        "longitude": "11.98245000"
                    },
                    {
                        "id": 61661,
                        "name": "Valeggio sul Mincio",
                        "latitude": "45.35333000",
                        "longitude": "10.73635000"
                    },
                    {
                        "id": 61672,
                        "name": "Valgatara",
                        "latitude": "45.53467000",
                        "longitude": "10.91191000"
                    },
                    {
                        "id": 61727,
                        "name": "Vallà",
                        "latitude": "45.70711000",
                        "longitude": "11.93271000"
                    },
                    {
                        "id": 61680,
                        "name": "Vallada Agordina",
                        "latitude": "46.36442000",
                        "longitude": "11.93399000"
                    },
                    {
                        "id": 61696,
                        "name": "Valle di Cadore",
                        "latitude": "46.41806000",
                        "longitude": "12.33431000"
                    },
                    {
                        "id": 61717,
                        "name": "Vallese",
                        "latitude": "45.32827000",
                        "longitude": "11.08608000"
                    },
                    {
                        "id": 61719,
                        "name": "Valli",
                        "latitude": "45.22342000",
                        "longitude": "12.18990000"
                    },
                    {
                        "id": 61720,
                        "name": "Valli del Pasubio",
                        "latitude": "45.74030000",
                        "longitude": "11.26354000"
                    },
                    {
                        "id": 61725,
                        "name": "Vallonga",
                        "latitude": "45.27248000",
                        "longitude": "12.07860000"
                    },
                    {
                        "id": 61740,
                        "name": "Valstagna",
                        "latitude": "45.85108000",
                        "longitude": "11.66642000"
                    },
                    {
                        "id": 61758,
                        "name": "Varago",
                        "latitude": "45.73726000",
                        "longitude": "12.31083000"
                    },
                    {
                        "id": 61777,
                        "name": "Vas",
                        "latitude": "45.93804000",
                        "longitude": "11.93579000"
                    },
                    {
                        "id": 61786,
                        "name": "Vazzola",
                        "latitude": "45.83511000",
                        "longitude": "12.40851000"
                    },
                    {
                        "id": 61791,
                        "name": "Vedelago",
                        "latitude": "45.68722000",
                        "longitude": "12.01853000"
                    },
                    {
                        "id": 61795,
                        "name": "Veggiano",
                        "latitude": "45.44719000",
                        "longitude": "11.71280000"
                    },
                    {
                        "id": 61804,
                        "name": "Velo",
                        "latitude": "45.78983000",
                        "longitude": "11.36725000"
                    },
                    {
                        "id": 61806,
                        "name": "Velo d'Astico",
                        "latitude": "45.78840000",
                        "longitude": "11.36769000"
                    },
                    {
                        "id": 61805,
                        "name": "Velo Veronese",
                        "latitude": "45.60669000",
                        "longitude": "11.09519000"
                    },
                    {
                        "id": 61815,
                        "name": "Venegazzù",
                        "latitude": "45.77934000",
                        "longitude": "12.09148000"
                    },
                    {
                        "id": 61822,
                        "name": "Venice",
                        "latitude": "45.43713000",
                        "longitude": "12.33265000"
                    },
                    {
                        "id": 61863,
                        "name": "Verona",
                        "latitude": "45.42990000",
                        "longitude": "10.98444000"
                    },
                    {
                        "id": 61864,
                        "name": "Veronella",
                        "latitude": "45.32378000",
                        "longitude": "11.32582000"
                    },
                    {
                        "id": 61880,
                        "name": "Vescovana",
                        "latitude": "45.13422000",
                        "longitude": "11.71261000"
                    },
                    {
                        "id": 61885,
                        "name": "Vestenanova",
                        "latitude": "45.57421000",
                        "longitude": "11.22868000"
                    },
                    {
                        "id": 61889,
                        "name": "Veternigo",
                        "latitude": "45.51765000",
                        "longitude": "12.05793000"
                    },
                    {
                        "id": 61914,
                        "name": "Vicenza",
                        "latitude": "45.54672000",
                        "longitude": "11.54750000"
                    },
                    {
                        "id": 61931,
                        "name": "Vidor",
                        "latitude": "45.86659000",
                        "longitude": "12.04517000"
                    },
                    {
                        "id": 61941,
                        "name": "Vigardolo",
                        "latitude": "45.60599000",
                        "longitude": "11.58856000"
                    },
                    {
                        "id": 61942,
                        "name": "Vigasio",
                        "latitude": "45.31780000",
                        "longitude": "10.94371000"
                    },
                    {
                        "id": 61950,
                        "name": "Vighizzolo d'Este",
                        "latitude": "45.17629000",
                        "longitude": "11.62471000"
                    },
                    {
                        "id": 61967,
                        "name": "Vigo di Cadore",
                        "latitude": "46.49904000",
                        "longitude": "12.47111000"
                    },
                    {
                        "id": 61970,
                        "name": "Vigodarzere",
                        "latitude": "45.45751000",
                        "longitude": "11.88555000"
                    },
                    {
                        "id": 61975,
                        "name": "Vigonovo",
                        "latitude": "45.38691000",
                        "longitude": "12.00642000"
                    },
                    {
                        "id": 61977,
                        "name": "Vigonza",
                        "latitude": "45.43484000",
                        "longitude": "11.97465000"
                    },
                    {
                        "id": 61985,
                        "name": "Villa Bartolomea",
                        "latitude": "45.15461000",
                        "longitude": "11.35380000"
                    },
                    {
                        "id": 62035,
                        "name": "Villa d'Asolo",
                        "latitude": "45.77193000",
                        "longitude": "11.89981000"
                    },
                    {
                        "id": 62039,
                        "name": "Villa del Conte",
                        "latitude": "45.58475000",
                        "longitude": "11.85942000"
                    },
                    {
                        "id": 61996,
                        "name": "Villa Estense",
                        "latitude": "45.17465000",
                        "longitude": "11.67022000"
                    },
                    {
                        "id": 62048,
                        "name": "Villabruna-Umin",
                        "latitude": "46.05675000",
                        "longitude": "11.92700000"
                    },
                    {
                        "id": 62052,
                        "name": "Villadose",
                        "latitude": "45.07219000",
                        "longitude": "11.89899000"
                    },
                    {
                        "id": 62061,
                        "name": "Villafranca di Verona",
                        "latitude": "45.35405000",
                        "longitude": "10.84462000"
                    },
                    {
                        "id": 62056,
                        "name": "Villafranca Padovana",
                        "latitude": "45.49189000",
                        "longitude": "11.79350000"
                    },
                    {
                        "id": 62064,
                        "name": "Villaga",
                        "latitude": "45.40273000",
                        "longitude": "11.53468000"
                    },
                    {
                        "id": 62065,
                        "name": "Villaganzerla",
                        "latitude": "45.43612000",
                        "longitude": "11.61859000"
                    },
                    {
                        "id": 62066,
                        "name": "Villaggio Montegrappa",
                        "latitude": "45.54643000",
                        "longitude": "11.61428000"
                    },
                    {
                        "id": 62073,
                        "name": "Villaguattera",
                        "latitude": "45.44409000",
                        "longitude": "11.81767000"
                    },
                    {
                        "id": 62083,
                        "name": "Villamarzana",
                        "latitude": "45.01457000",
                        "longitude": "11.69225000"
                    },
                    {
                        "id": 62091,
                        "name": "Villanova",
                        "latitude": "45.48890000",
                        "longitude": "11.97471000"
                    },
                    {
                        "id": 62109,
                        "name": "Villanova del Ghebbo Canton",
                        "latitude": "45.05933000",
                        "longitude": "11.64314000"
                    },
                    {
                        "id": 62098,
                        "name": "Villanova Marchesana",
                        "latitude": "44.99231000",
                        "longitude": "11.96675000"
                    },
                    {
                        "id": 62143,
                        "name": "Villatora",
                        "latitude": "45.38768000",
                        "longitude": "11.96736000"
                    },
                    {
                        "id": 62146,
                        "name": "Villaverla",
                        "latitude": "45.64939000",
                        "longitude": "11.49176000"
                    },
                    {
                        "id": 62185,
                        "name": "Vittorio Veneto",
                        "latitude": "45.98026000",
                        "longitude": "12.30065000"
                    },
                    {
                        "id": 62226,
                        "name": "Vò",
                        "latitude": "45.32829000",
                        "longitude": "11.64150000"
                    },
                    {
                        "id": 62200,
                        "name": "Vodo",
                        "latitude": "46.41921000",
                        "longitude": "12.24557000"
                    },
                    {
                        "id": 62205,
                        "name": "Volargne",
                        "latitude": "45.53684000",
                        "longitude": "10.81820000"
                    },
                    {
                        "id": 62208,
                        "name": "Volpago del Montello",
                        "latitude": "45.77770000",
                        "longitude": "12.11857000"
                    },
                    {
                        "id": 62215,
                        "name": "Voltago",
                        "latitude": "46.27252000",
                        "longitude": "12.00640000"
                    },
                    {
                        "id": 62216,
                        "name": "Voltago Agordino",
                        "latitude": "46.27139000",
                        "longitude": "12.00574000"
                    },
                    {
                        "id": 62236,
                        "name": "Zanè",
                        "latitude": "45.72200000",
                        "longitude": "11.44932000"
                    },
                    {
                        "id": 62241,
                        "name": "Zelarino",
                        "latitude": "45.51508000",
                        "longitude": "12.20790000"
                    },
                    {
                        "id": 62247,
                        "name": "Zenson di Piave",
                        "latitude": "45.67971000",
                        "longitude": "12.48913000"
                    },
                    {
                        "id": 62254,
                        "name": "Zermeghedo",
                        "latitude": "45.47585000",
                        "longitude": "11.37438000"
                    },
                    {
                        "id": 62255,
                        "name": "Zero Branco",
                        "latitude": "45.59952000",
                        "longitude": "12.16381000"
                    },
                    {
                        "id": 62256,
                        "name": "Zevio",
                        "latitude": "45.37209000",
                        "longitude": "11.12929000"
                    },
                    {
                        "id": 62275,
                        "name": "Zoppè di Cadore",
                        "latitude": "46.38583000",
                        "longitude": "12.17368000"
                    },
                    {
                        "id": 62277,
                        "name": "Zovencedo",
                        "latitude": "45.42893000",
                        "longitude": "11.50387000"
                    },
                    {
                        "id": 62281,
                        "name": "Zugliano",
                        "latitude": "45.72980000",
                        "longitude": "11.52399000"
                    }
                ]
            },
            {
                "id": 1726,
                "name": "Verbano-Cusio-Ossola",
                "iso2": "VB",
                "latitude": "46.13996880",
                "longitude": "8.27246490",
                "type": "province",
                "cities": []
            },
            {
                "id": 1785,
                "name": "Vercelli",
                "iso2": "VC",
                "latitude": "45.32022040",
                "longitude": "8.41850800",
                "type": "province",
                "cities": []
            },
            {
                "id": 1736,
                "name": "Verona",
                "iso2": "VR",
                "latitude": "45.44184980",
                "longitude": "11.07353160",
                "type": "province",
                "cities": []
            },
            {
                "id": 1737,
                "name": "Vibo Valentia",
                "iso2": "VV",
                "latitude": "38.63785650",
                "longitude": "16.20514840",
                "type": "province",
                "cities": []
            },
            {
                "id": 1738,
                "name": "Vicenza",
                "iso2": "VI",
                "latitude": "45.69839950",
                "longitude": "11.56614650",
                "type": "province",
                "cities": []
            },
            {
                "id": 1735,
                "name": "Viterbo",
                "iso2": "VT",
                "latitude": "42.40024200",
                "longitude": "11.88917210",
                "type": "province",
                "cities": []
            }
        ]
    },
    {
        "id": 108,
        "name": "Jamaica",
        "iso3": "JAM",
        "iso2": "JM",
        "numeric_code": "388",
        "phonecode": "1",
        "capital": "Kingston",
        "currency": "JMD",
        "currency_name": "Jamaican dollar",
        "currency_symbol": "J$",
        "tld": ".jm",
        "native": "Jamaica",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Jamaican",
        "timezones": [
            {
                "zoneName": "America\/Jamaica",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Jamaika",
            "ko": "자메이카",
            "pt-BR": "Jamaica",
            "pt": "Jamaica",
            "nl": "Jamaica",
            "hr": "Jamajka",
            "fa": "جامائیکا",
            "de": "Jamaika",
            "es": "Jamaica",
            "fr": "Jamaïque",
            "ja": "ジャマイカ",
            "it": "Giamaica",
            "zh-CN": "牙买加",
            "tr": "Jamaika",
            "ru": "Ямайка",
            "uk": "Ямайка",
            "pl": "Jamajka"
        },
        "latitude": "18.25000000",
        "longitude": "-77.50000000",
        "emoji": "🇯🇲",
        "emojiU": "U+1F1EF U+1F1F2",
        "states": [
            {
                "id": 3753,
                "name": "Clarendon",
                "iso2": "13",
                "latitude": "17.95571830",
                "longitude": "-77.24051530",
                "type": "parish",
                "cities": [
                    {
                        "id": 62295,
                        "name": "Aenon Town",
                        "latitude": "18.21027000",
                        "longitude": "-77.39851000"
                    },
                    {
                        "id": 62302,
                        "name": "Alley",
                        "latitude": "17.79036000",
                        "longitude": "-77.27085000"
                    },
                    {
                        "id": 62307,
                        "name": "Alston",
                        "latitude": "18.17639000",
                        "longitude": "-77.43468000"
                    },
                    {
                        "id": 62319,
                        "name": "Ashley",
                        "latitude": "18.01440000",
                        "longitude": "-77.34019000"
                    },
                    {
                        "id": 62331,
                        "name": "Banks",
                        "latitude": "17.83222000",
                        "longitude": "-77.30731000"
                    },
                    {
                        "id": 62344,
                        "name": "Beckford Kraal",
                        "latitude": "18.08545000",
                        "longitude": "-77.32399000"
                    },
                    {
                        "id": 62387,
                        "name": "Brandon Hill",
                        "latitude": "18.15110000",
                        "longitude": "-77.23663000"
                    },
                    {
                        "id": 62391,
                        "name": "Brixton Hill",
                        "latitude": "18.02039000",
                        "longitude": "-77.31744000"
                    },
                    {
                        "id": 62397,
                        "name": "Bucknor",
                        "latitude": "18.00619000",
                        "longitude": "-77.23749000"
                    },
                    {
                        "id": 62398,
                        "name": "Bucks Common",
                        "latitude": "17.98228000",
                        "longitude": "-77.23846000"
                    },
                    {
                        "id": 62406,
                        "name": "Bushy Park",
                        "latitude": "17.98243000",
                        "longitude": "-77.25135000"
                    },
                    {
                        "id": 62446,
                        "name": "Chapelton",
                        "latitude": "18.08333000",
                        "longitude": "-77.26667000"
                    },
                    {
                        "id": 62449,
                        "name": "Chateau",
                        "latitude": "17.98972000",
                        "longitude": "-77.18737000"
                    },
                    {
                        "id": 62462,
                        "name": "Cockpit",
                        "latitude": "17.88872000",
                        "longitude": "-77.15835000"
                    },
                    {
                        "id": 62463,
                        "name": "Coffee Piece",
                        "latitude": "18.13835000",
                        "longitude": "-77.40648000"
                    },
                    {
                        "id": 62466,
                        "name": "Colonels Ridge",
                        "latitude": "18.13525000",
                        "longitude": "-77.25550000"
                    },
                    {
                        "id": 62485,
                        "name": "Coxswain",
                        "latitude": "18.10272000",
                        "longitude": "-77.23444000"
                    },
                    {
                        "id": 62489,
                        "name": "Crofts Hill",
                        "latitude": "18.13268000",
                        "longitude": "-77.20507000"
                    },
                    {
                        "id": 62491,
                        "name": "Crooked River",
                        "latitude": "18.14289000",
                        "longitude": "-77.30000000"
                    },
                    {
                        "id": 62496,
                        "name": "Cumberland",
                        "latitude": "18.10522000",
                        "longitude": "-77.41617000"
                    },
                    {
                        "id": 62497,
                        "name": "Curatoe Hill",
                        "latitude": "17.93982000",
                        "longitude": "-77.24836000"
                    },
                    {
                        "id": 62504,
                        "name": "Dawkins",
                        "latitude": "18.05540000",
                        "longitude": "-77.33303000"
                    },
                    {
                        "id": 62533,
                        "name": "Effortville",
                        "latitude": "17.99270000",
                        "longitude": "-77.21860000"
                    },
                    {
                        "id": 62565,
                        "name": "Four Paths",
                        "latitude": "17.97089000",
                        "longitude": "-77.29599000"
                    },
                    {
                        "id": 62566,
                        "name": "Frankfield",
                        "latitude": "18.14971000",
                        "longitude": "-77.36498000"
                    },
                    {
                        "id": 62570,
                        "name": "Freetown",
                        "latitude": "17.92192000",
                        "longitude": "-77.14781000"
                    },
                    {
                        "id": 62585,
                        "name": "Gimme-me-bit",
                        "latitude": "17.88946000",
                        "longitude": "-77.28469000"
                    },
                    {
                        "id": 62590,
                        "name": "Glenmuir",
                        "latitude": "17.96801000",
                        "longitude": "-77.25394000"
                    },
                    {
                        "id": 62602,
                        "name": "Grantham",
                        "latitude": "18.15839000",
                        "longitude": "-77.39643000"
                    },
                    {
                        "id": 62606,
                        "name": "Gravel Hill",
                        "latitude": "17.90968000",
                        "longitude": "-77.33354000"
                    },
                    {
                        "id": 62638,
                        "name": "Hayes",
                        "latitude": "17.87569000",
                        "longitude": "-77.23711000"
                    },
                    {
                        "id": 62640,
                        "name": "Hazard",
                        "latitude": "17.95382000",
                        "longitude": "-77.23147000"
                    },
                    {
                        "id": 62661,
                        "name": "Inverness",
                        "latitude": "17.91195000",
                        "longitude": "-77.19032000"
                    },
                    {
                        "id": 62670,
                        "name": "James Hill",
                        "latitude": "18.18750000",
                        "longitude": "-77.33700000"
                    },
                    {
                        "id": 62676,
                        "name": "Johns Hall",
                        "latitude": "18.18876000",
                        "longitude": "-77.38063000"
                    },
                    {
                        "id": 62683,
                        "name": "Kellits",
                        "latitude": "18.16184000",
                        "longitude": "-77.27049000"
                    },
                    {
                        "id": 62712,
                        "name": "Limit",
                        "latitude": "18.15287000",
                        "longitude": "-77.47121000"
                    },
                    {
                        "id": 62715,
                        "name": "Lionel Town",
                        "latitude": "17.81007000",
                        "longitude": "-77.24061000"
                    },
                    {
                        "id": 62727,
                        "name": "Longville Park",
                        "latitude": "17.91188000",
                        "longitude": "-77.15983000"
                    },
                    {
                        "id": 62728,
                        "name": "Longwood",
                        "latitude": "17.80754000",
                        "longitude": "-77.28728000"
                    },
                    {
                        "id": 62764,
                        "name": "May Pen",
                        "latitude": "17.96454000",
                        "longitude": "-77.24515000"
                    },
                    {
                        "id": 62765,
                        "name": "May Pen Proper",
                        "latitude": "17.97034000",
                        "longitude": "-77.23911000"
                    },
                    {
                        "id": 62776,
                        "name": "Milk River",
                        "latitude": "17.87560000",
                        "longitude": "-77.35139000"
                    },
                    {
                        "id": 62777,
                        "name": "Mineral Heights",
                        "latitude": "17.94183000",
                        "longitude": "-77.23276000"
                    },
                    {
                        "id": 62778,
                        "name": "Mitchell Town",
                        "latitude": "17.81281000",
                        "longitude": "-77.20531000"
                    },
                    {
                        "id": 62788,
                        "name": "Moores",
                        "latitude": "18.02926000",
                        "longitude": "-77.18540000"
                    },
                    {
                        "id": 62790,
                        "name": "Morgans Forest",
                        "latitude": "18.19088000",
                        "longitude": "-77.41021000"
                    },
                    {
                        "id": 62791,
                        "name": "Morgans Pass",
                        "latitude": "18.12123000",
                        "longitude": "-77.27493000"
                    },
                    {
                        "id": 62793,
                        "name": "Mount Airy",
                        "latitude": "18.01843000",
                        "longitude": "-77.36357000"
                    },
                    {
                        "id": 62812,
                        "name": "New Denbigh",
                        "latitude": "17.98563000",
                        "longitude": "-77.27104000"
                    },
                    {
                        "id": 62817,
                        "name": "New Longsville",
                        "latitude": "18.03072000",
                        "longitude": "-77.23048000"
                    },
                    {
                        "id": 62836,
                        "name": "Old Denbigh",
                        "latitude": "17.96116000",
                        "longitude": "-77.26701000"
                    },
                    {
                        "id": 62846,
                        "name": "Orange Hill",
                        "latitude": "18.11788000",
                        "longitude": "-77.35942000"
                    },
                    {
                        "id": 62847,
                        "name": "Osbourne Store",
                        "latitude": "17.95892000",
                        "longitude": "-77.32827000"
                    },
                    {
                        "id": 62848,
                        "name": "Paisley",
                        "latitude": "17.96293000",
                        "longitude": "-77.22368000"
                    },
                    {
                        "id": 62849,
                        "name": "Palmers Cross",
                        "latitude": "17.95000000",
                        "longitude": "-77.20338000"
                    },
                    {
                        "id": 62858,
                        "name": "Part of Banana Ground",
                        "latitude": "18.08022000",
                        "longitude": "-77.40971000"
                    },
                    {
                        "id": 62859,
                        "name": "Part of Douglas Castle",
                        "latitude": "18.18703000",
                        "longitude": "-77.27538000"
                    },
                    {
                        "id": 62861,
                        "name": "Part of Kellits",
                        "latitude": "18.17159000",
                        "longitude": "-77.25120000"
                    },
                    {
                        "id": 62871,
                        "name": "Peckham",
                        "latitude": "18.17147000",
                        "longitude": "-77.39766000"
                    },
                    {
                        "id": 62875,
                        "name": "Pennants",
                        "latitude": "18.11025000",
                        "longitude": "-77.31306000"
                    },
                    {
                        "id": 62886,
                        "name": "Pleasant Valley",
                        "latitude": "18.01101000",
                        "longitude": "-77.29027000"
                    },
                    {
                        "id": 62897,
                        "name": "Portland Cottage",
                        "latitude": "17.74620000",
                        "longitude": "-77.18772000"
                    },
                    {
                        "id": 62901,
                        "name": "Porus",
                        "latitude": "18.05202000",
                        "longitude": "-77.40007000"
                    },
                    {
                        "id": 62910,
                        "name": "Race Course",
                        "latitude": "17.84019000",
                        "longitude": "-77.28223000"
                    },
                    {
                        "id": 62930,
                        "name": "Richmond Park",
                        "latitude": "18.05172000",
                        "longitude": "-77.37642000"
                    },
                    {
                        "id": 62934,
                        "name": "Ritchies",
                        "latitude": "18.13904000",
                        "longitude": "-77.42893000"
                    },
                    {
                        "id": 62942,
                        "name": "Rock",
                        "latitude": "17.99122000",
                        "longitude": "-77.33702000"
                    },
                    {
                        "id": 62944,
                        "name": "Rock River",
                        "latitude": "18.06548000",
                        "longitude": "-77.19707000"
                    },
                    {
                        "id": 62946,
                        "name": "Rocky Point",
                        "latitude": "17.77695000",
                        "longitude": "-77.24816000"
                    },
                    {
                        "id": 62964,
                        "name": "Salt River",
                        "latitude": "17.84143000",
                        "longitude": "-77.17413000"
                    },
                    {
                        "id": 62969,
                        "name": "Sandy Bay",
                        "latitude": "17.95105000",
                        "longitude": "-77.16225000"
                    },
                    {
                        "id": 62970,
                        "name": "Sanguinetti",
                        "latitude": "18.15585000",
                        "longitude": "-77.42938000"
                    },
                    {
                        "id": 62984,
                        "name": "Sedgepond",
                        "latitude": "17.84753000",
                        "longitude": "-77.32638000"
                    },
                    {
                        "id": 62992,
                        "name": "Silent Hill",
                        "latitude": "18.19152000",
                        "longitude": "-77.45918000"
                    },
                    {
                        "id": 62998,
                        "name": "Smithville",
                        "latitude": "18.11977000",
                        "longitude": "-77.38561000"
                    },
                    {
                        "id": 63006,
                        "name": "Spaldings",
                        "latitude": "18.16875000",
                        "longitude": "-77.45798000"
                    },
                    {
                        "id": 63040,
                        "name": "Summerfield",
                        "latitude": "18.09433000",
                        "longitude": "-77.28429000"
                    },
                    {
                        "id": 63048,
                        "name": "Thompson Town",
                        "latitude": "18.08968000",
                        "longitude": "-77.37186000"
                    },
                    {
                        "id": 63053,
                        "name": "Tollgate",
                        "latitude": "17.97195000",
                        "longitude": "-77.36566000"
                    },
                    {
                        "id": 63061,
                        "name": "Treadlight",
                        "latitude": "17.99264000",
                        "longitude": "-77.25531000"
                    },
                    {
                        "id": 63067,
                        "name": "Trout Hall",
                        "latitude": "18.13779000",
                        "longitude": "-77.33299000"
                    },
                    {
                        "id": 63071,
                        "name": "Turners",
                        "latitude": "18.06647000",
                        "longitude": "-77.23523000"
                    },
                    {
                        "id": 63087,
                        "name": "Water Lane",
                        "latitude": "17.82452000",
                        "longitude": "-77.25946000"
                    },
                    {
                        "id": 63119,
                        "name": "Woodhall",
                        "latitude": "18.04757000",
                        "longitude": "-77.27575000"
                    },
                    {
                        "id": 63127,
                        "name": "York Town",
                        "latitude": "17.92515000",
                        "longitude": "-77.30002000"
                    }
                ]
            },
            {
                "id": 3749,
                "name": "Hanover",
                "iso2": "09",
                "latitude": "18.40977070",
                "longitude": "-78.13363800",
                "type": "parish",
                "cities": [
                    {
                        "id": 62322,
                        "name": "Askenish",
                        "latitude": "18.38492000",
                        "longitude": "-78.14910000"
                    },
                    {
                        "id": 62409,
                        "name": "Cacoon",
                        "latitude": "18.41642000",
                        "longitude": "-78.20730000"
                    },
                    {
                        "id": 62410,
                        "name": "Cacoon Castle",
                        "latitude": "18.40247000",
                        "longitude": "-78.01336000"
                    },
                    {
                        "id": 62422,
                        "name": "Cascade",
                        "latitude": "18.39747000",
                        "longitude": "-78.10337000"
                    },
                    {
                        "id": 62425,
                        "name": "Cash Hill",
                        "latitude": "18.36920000",
                        "longitude": "-78.10938000"
                    },
                    {
                        "id": 62432,
                        "name": "Cauldwell",
                        "latitude": "18.38583000",
                        "longitude": "-78.24110000"
                    },
                    {
                        "id": 62443,
                        "name": "Chambers Pen",
                        "latitude": "18.40520000",
                        "longitude": "-78.15975000"
                    },
                    {
                        "id": 62452,
                        "name": "Chester Castle",
                        "latitude": "18.33822000",
                        "longitude": "-77.94722000"
                    },
                    {
                        "id": 62479,
                        "name": "Copse",
                        "latitude": "18.39466000",
                        "longitude": "-77.97678000"
                    },
                    {
                        "id": 62484,
                        "name": "Cousins Cove",
                        "latitude": "18.42425000",
                        "longitude": "-78.23752000"
                    },
                    {
                        "id": 62512,
                        "name": "Dias",
                        "latitude": "18.39379000",
                        "longitude": "-78.18562000"
                    },
                    {
                        "id": 62608,
                        "name": "Great Valley",
                        "latitude": "18.41169000",
                        "longitude": "-78.05023000"
                    },
                    {
                        "id": 62610,
                        "name": "Green Island",
                        "latitude": "18.38399000",
                        "longitude": "-78.27015000"
                    },
                    {
                        "id": 62620,
                        "name": "Haddington",
                        "latitude": "18.42043000",
                        "longitude": "-78.00383000"
                    },
                    {
                        "id": 62657,
                        "name": "Hopewell",
                        "latitude": "18.44321000",
                        "longitude": "-78.02636000"
                    },
                    {
                        "id": 62672,
                        "name": "Jericho",
                        "latitude": "18.43744000",
                        "longitude": "-78.13028000"
                    },
                    {
                        "id": 62685,
                        "name": "Kendal",
                        "latitude": "18.36287000",
                        "longitude": "-78.22720000"
                    },
                    {
                        "id": 62693,
                        "name": "Kingsvale",
                        "latitude": "18.38087000",
                        "longitude": "-78.20523000"
                    },
                    {
                        "id": 62702,
                        "name": "Lances Bay",
                        "latitude": "18.43819000",
                        "longitude": "-78.21442000"
                    },
                    {
                        "id": 62723,
                        "name": "Logwood",
                        "latitude": "18.34878000",
                        "longitude": "-78.29620000"
                    },
                    {
                        "id": 62731,
                        "name": "Lucea",
                        "latitude": "18.45095000",
                        "longitude": "-78.17356000"
                    },
                    {
                        "id": 62732,
                        "name": "Lucea East",
                        "latitude": "18.42198000",
                        "longitude": "-78.16675000"
                    },
                    {
                        "id": 62733,
                        "name": "Lucea West",
                        "latitude": "18.44238000",
                        "longitude": "-78.18663000"
                    },
                    {
                        "id": 62752,
                        "name": "March Town",
                        "latitude": "18.32951000",
                        "longitude": "-78.27656000"
                    },
                    {
                        "id": 62758,
                        "name": "Maryland",
                        "latitude": "18.38679000",
                        "longitude": "-78.12825000"
                    },
                    {
                        "id": 62799,
                        "name": "Mount Peto",
                        "latitude": "18.35747000",
                        "longitude": "-78.02289000"
                    },
                    {
                        "id": 62844,
                        "name": "Orange Bay",
                        "latitude": "18.34266000",
                        "longitude": "-78.32005000"
                    },
                    {
                        "id": 62873,
                        "name": "Pell River",
                        "latitude": "18.37886000",
                        "longitude": "-78.21904000"
                    },
                    {
                        "id": 62890,
                        "name": "Pondside",
                        "latitude": "18.40222000",
                        "longitude": "-78.07344000"
                    },
                    {
                        "id": 62913,
                        "name": "Ramble",
                        "latitude": "18.34674000",
                        "longitude": "-77.98802000"
                    },
                    {
                        "id": 62945,
                        "name": "Rock Spring",
                        "latitude": "18.34797000",
                        "longitude": "-78.24392000"
                    },
                    {
                        "id": 62968,
                        "name": "Sandy Bay",
                        "latitude": "18.43750000",
                        "longitude": "-78.08383000"
                    },
                    {
                        "id": 62972,
                        "name": "Santoy",
                        "latitude": "18.35875000",
                        "longitude": "-78.28386000"
                    },
                    {
                        "id": 63038,
                        "name": "Success",
                        "latitude": "18.37729000",
                        "longitude": "-78.05105000"
                    },
                    {
                        "id": 63120,
                        "name": "Woodlands",
                        "latitude": "18.44555000",
                        "longitude": "-77.99963000"
                    },
                    {
                        "id": 63123,
                        "name": "Woodsville",
                        "latitude": "18.36950000",
                        "longitude": "-78.07217000"
                    }
                ]
            },
            {
                "id": 3748,
                "name": "Kingston",
                "iso2": "01",
                "latitude": "17.96832710",
                "longitude": "-76.78270200",
                "type": "parish",
                "cities": [
                    {
                        "id": 62305,
                        "name": "Allman Town",
                        "latitude": "17.98297000",
                        "longitude": "-76.78685000"
                    },
                    {
                        "id": 62380,
                        "name": "Bournemouth Gardens",
                        "latitude": "17.97009000",
                        "longitude": "-76.76266000"
                    },
                    {
                        "id": 62416,
                        "name": "Campbell Town",
                        "latitude": "17.97914000",
                        "longitude": "-76.78134000"
                    },
                    {
                        "id": 62439,
                        "name": "Central Down Town",
                        "latitude": "17.96958000",
                        "longitude": "-76.79264000"
                    },
                    {
                        "id": 62498,
                        "name": "D'Aguilar Town\/ Rennock Lodge",
                        "latitude": "17.97001000",
                        "longitude": "-76.73701000"
                    },
                    {
                        "id": 62509,
                        "name": "Denham Town",
                        "latitude": "17.97812000",
                        "longitude": "-76.79984000"
                    },
                    {
                        "id": 62530,
                        "name": "East Down Town",
                        "latitude": "17.97197000",
                        "longitude": "-76.78471000"
                    },
                    {
                        "id": 62558,
                        "name": "Fletchers Land",
                        "latitude": "17.97968000",
                        "longitude": "-76.79100000"
                    },
                    {
                        "id": 62567,
                        "name": "Franklyn Town",
                        "latitude": "17.97787000",
                        "longitude": "-76.77339000"
                    },
                    {
                        "id": 62629,
                        "name": "Hannah Town\/ Craig Town",
                        "latitude": "17.97998000",
                        "longitude": "-76.79430000"
                    },
                    {
                        "id": 62679,
                        "name": "Johnson Town",
                        "latitude": "17.97771000",
                        "longitude": "-76.75593000"
                    },
                    {
                        "id": 62691,
                        "name": "Kingston",
                        "latitude": "17.99702000",
                        "longitude": "-76.79358000"
                    },
                    {
                        "id": 62692,
                        "name": "Kingston Gardens",
                        "latitude": "17.97836000",
                        "longitude": "-76.78681000"
                    },
                    {
                        "id": 62748,
                        "name": "Manley Meadows",
                        "latitude": "17.96907000",
                        "longitude": "-76.77116000"
                    },
                    {
                        "id": 62825,
                        "name": "Newport East",
                        "latitude": "17.97421000",
                        "longitude": "-76.80663000"
                    },
                    {
                        "id": 62827,
                        "name": "Newton Square",
                        "latitude": "17.97352000",
                        "longitude": "-76.77207000"
                    },
                    {
                        "id": 62831,
                        "name": "Norman Gardens",
                        "latitude": "17.97803000",
                        "longitude": "-76.75940000"
                    },
                    {
                        "id": 62866,
                        "name": "Passmore Town",
                        "latitude": "17.97301000",
                        "longitude": "-76.77650000"
                    },
                    {
                        "id": 62895,
                        "name": "Port Royal",
                        "latitude": "17.93738000",
                        "longitude": "-76.84062000"
                    },
                    {
                        "id": 62911,
                        "name": "Rae Town",
                        "latitude": "17.96773000",
                        "longitude": "-76.77965000"
                    },
                    {
                        "id": 62949,
                        "name": "Rollington Town",
                        "latitude": "17.97687000",
                        "longitude": "-76.76523000"
                    },
                    {
                        "id": 63005,
                        "name": "Southside",
                        "latitude": "17.96569000",
                        "longitude": "-76.78624000"
                    },
                    {
                        "id": 63016,
                        "name": "Springfield",
                        "latitude": "17.97117000",
                        "longitude": "-76.75607000"
                    },
                    {
                        "id": 63052,
                        "name": "Tivoli Gardens",
                        "latitude": "17.97326000",
                        "longitude": "-76.80090000"
                    },
                    {
                        "id": 63096,
                        "name": "West Down Town",
                        "latitude": "17.97294000",
                        "longitude": "-76.79704000"
                    }
                ]
            },
            {
                "id": 3754,
                "name": "Manchester",
                "iso2": "12",
                "latitude": "18.06696540",
                "longitude": "-77.51607880",
                "type": "parish",
                "cities": [
                    {
                        "id": 62304,
                        "name": "Alligator Pond",
                        "latitude": "17.88369000",
                        "longitude": "-77.56068000"
                    },
                    {
                        "id": 62321,
                        "name": "Asia\/Pratville",
                        "latitude": "17.91584000",
                        "longitude": "-77.41563000"
                    },
                    {
                        "id": 62323,
                        "name": "Auchtembeddie",
                        "latitude": "18.22543000",
                        "longitude": "-77.60361000"
                    },
                    {
                        "id": 62349,
                        "name": "Bellefield",
                        "latitude": "18.09266000",
                        "longitude": "-77.44004000"
                    },
                    {
                        "id": 62354,
                        "name": "Bethany",
                        "latitude": "18.15373000",
                        "longitude": "-77.55032000"
                    },
                    {
                        "id": 62366,
                        "name": "Blue Mountain",
                        "latitude": "18.07095000",
                        "longitude": "-77.42840000"
                    },
                    {
                        "id": 62374,
                        "name": "Bombay",
                        "latitude": "18.11780000",
                        "longitude": "-77.44940000"
                    },
                    {
                        "id": 62407,
                        "name": "Butt-Up",
                        "latitude": "17.97313000",
                        "longitude": "-77.57777000"
                    },
                    {
                        "id": 62437,
                        "name": "Cedar Grove",
                        "latitude": "18.01225000",
                        "longitude": "-77.49630000"
                    },
                    {
                        "id": 62444,
                        "name": "Chantilly",
                        "latitude": "18.10447000",
                        "longitude": "-77.46625000"
                    },
                    {
                        "id": 62453,
                        "name": "Christiana",
                        "latitude": "18.18015000",
                        "longitude": "-77.49045000"
                    },
                    {
                        "id": 62454,
                        "name": "Chudleigh",
                        "latitude": "18.15148000",
                        "longitude": "-77.50707000"
                    },
                    {
                        "id": 62460,
                        "name": "Cobbla",
                        "latitude": "18.14060000",
                        "longitude": "-77.46998000"
                    },
                    {
                        "id": 62465,
                        "name": "Coleyville",
                        "latitude": "18.19993000",
                        "longitude": "-77.51924000"
                    },
                    {
                        "id": 62467,
                        "name": "Comfort",
                        "latitude": "18.05390000",
                        "longitude": "-77.42477000"
                    },
                    {
                        "id": 62470,
                        "name": "Comfort Hall",
                        "latitude": "18.18789000",
                        "longitude": "-77.61041000"
                    },
                    {
                        "id": 62474,
                        "name": "Content",
                        "latitude": "18.07444000",
                        "longitude": "-77.45116000"
                    },
                    {
                        "id": 62486,
                        "name": "Craig Head",
                        "latitude": "18.23658000",
                        "longitude": "-77.56295000"
                    },
                    {
                        "id": 62492,
                        "name": "Cross Keys",
                        "latitude": "17.90727000",
                        "longitude": "-77.50111000"
                    },
                    {
                        "id": 62510,
                        "name": "Devon",
                        "latitude": "18.16595000",
                        "longitude": "-77.52507000"
                    },
                    {
                        "id": 62517,
                        "name": "Downs",
                        "latitude": "17.95004000",
                        "longitude": "-77.57313000"
                    },
                    {
                        "id": 62536,
                        "name": "Ellen Street",
                        "latitude": "17.96796000",
                        "longitude": "-77.43931000"
                    },
                    {
                        "id": 62543,
                        "name": "Evergreen",
                        "latitude": "18.15096000",
                        "longitude": "-77.59965000"
                    },
                    {
                        "id": 62547,
                        "name": "Fairfield",
                        "latitude": "18.03117000",
                        "longitude": "-77.57535000"
                    },
                    {
                        "id": 62571,
                        "name": "French Park",
                        "latitude": "17.95572000",
                        "longitude": "-77.54471000"
                    },
                    {
                        "id": 62581,
                        "name": "George's Valley",
                        "latitude": "18.03172000",
                        "longitude": "-77.48081000"
                    },
                    {
                        "id": 62595,
                        "name": "Good Intent",
                        "latitude": "18.20806000",
                        "longitude": "-77.57086000"
                    },
                    {
                        "id": 62613,
                        "name": "Greenvale",
                        "latitude": "18.03928000",
                        "longitude": "-77.53239000"
                    },
                    {
                        "id": 62617,
                        "name": "Grove Place",
                        "latitude": "18.10467000",
                        "longitude": "-77.52923000"
                    },
                    {
                        "id": 62618,
                        "name": "Grove Town",
                        "latitude": "17.88606000",
                        "longitude": "-77.45882000"
                    },
                    {
                        "id": 62633,
                        "name": "Harmons",
                        "latitude": "17.98171000",
                        "longitude": "-77.41208000"
                    },
                    {
                        "id": 62635,
                        "name": "Harry Watch",
                        "latitude": "18.17314000",
                        "longitude": "-77.57611000"
                    },
                    {
                        "id": 62636,
                        "name": "Hatfield",
                        "latitude": "18.01557000",
                        "longitude": "-77.54009000"
                    },
                    {
                        "id": 62641,
                        "name": "Heartease",
                        "latitude": "18.04878000",
                        "longitude": "-77.48238000"
                    },
                    {
                        "id": 62646,
                        "name": "Hibernia",
                        "latitude": "18.17575000",
                        "longitude": "-77.54830000"
                    },
                    {
                        "id": 62659,
                        "name": "Huntley",
                        "latitude": "18.06647000",
                        "longitude": "-77.58171000"
                    },
                    {
                        "id": 62686,
                        "name": "Kendal",
                        "latitude": "18.08318000",
                        "longitude": "-77.50320000"
                    },
                    {
                        "id": 62697,
                        "name": "Knockpatrick",
                        "latitude": "17.99027000",
                        "longitude": "-77.49270000"
                    },
                    {
                        "id": 62701,
                        "name": "Lancaster",
                        "latitude": "17.93603000",
                        "longitude": "-77.46134000"
                    },
                    {
                        "id": 62716,
                        "name": "Litchfield",
                        "latitude": "18.13502000",
                        "longitude": "-77.52448000"
                    },
                    {
                        "id": 62740,
                        "name": "Maidstone",
                        "latitude": "18.10165000",
                        "longitude": "-77.57284000"
                    },
                    {
                        "id": 62745,
                        "name": "Mandeville",
                        "latitude": "18.04168000",
                        "longitude": "-77.50714000"
                    },
                    {
                        "id": 62746,
                        "name": "Mandeville Proper",
                        "latitude": "18.04453000",
                        "longitude": "-77.50574000"
                    },
                    {
                        "id": 62753,
                        "name": "Marlie Hill",
                        "latitude": "17.86692000",
                        "longitude": "-77.50835000"
                    },
                    {
                        "id": 62763,
                        "name": "May Day",
                        "latitude": "18.00951000",
                        "longitude": "-77.47606000"
                    },
                    {
                        "id": 62769,
                        "name": "Medina",
                        "latitude": "18.12236000",
                        "longitude": "-77.59643000"
                    },
                    {
                        "id": 62773,
                        "name": "Mike Town",
                        "latitude": "18.04253000",
                        "longitude": "-77.55490000"
                    },
                    {
                        "id": 62775,
                        "name": "Mile Gully",
                        "latitude": "18.13395000",
                        "longitude": "-77.56556000"
                    },
                    {
                        "id": 62813,
                        "name": "New Forest",
                        "latitude": "17.92010000",
                        "longitude": "-77.55867000"
                    },
                    {
                        "id": 62814,
                        "name": "New Green",
                        "latitude": "18.07663000",
                        "longitude": "-77.52569000"
                    },
                    {
                        "id": 62824,
                        "name": "Newport",
                        "latitude": "17.96293000",
                        "longitude": "-77.50486000"
                    },
                    {
                        "id": 62837,
                        "name": "Old England",
                        "latitude": "17.98503000",
                        "longitude": "-77.46017000"
                    },
                    {
                        "id": 62856,
                        "name": "Part Of Banana Ground",
                        "latitude": "18.07912000",
                        "longitude": "-77.42134000"
                    },
                    {
                        "id": 62857,
                        "name": "Part Of Gutters",
                        "latitude": "18.00642000",
                        "longitude": "-77.57903000"
                    },
                    {
                        "id": 62864,
                        "name": "Part of Spaldings",
                        "latitude": "18.15819000",
                        "longitude": "-77.46627000"
                    },
                    {
                        "id": 62882,
                        "name": "Pike",
                        "latitude": "18.23229000",
                        "longitude": "-77.53790000"
                    },
                    {
                        "id": 62887,
                        "name": "Plowden",
                        "latitude": "17.89178000",
                        "longitude": "-77.53846000"
                    },
                    {
                        "id": 62900,
                        "name": "Porus",
                        "latitude": "18.03535000",
                        "longitude": "-77.41166000"
                    },
                    {
                        "id": 62905,
                        "name": "Prospect",
                        "latitude": "17.98244000",
                        "longitude": "-77.56775000"
                    },
                    {
                        "id": 62929,
                        "name": "Richmond",
                        "latitude": "18.02560000",
                        "longitude": "-77.46337000"
                    },
                    {
                        "id": 62941,
                        "name": "Robins Hall",
                        "latitude": "18.20405000",
                        "longitude": "-77.55007000"
                    },
                    {
                        "id": 62953,
                        "name": "Rose Hill",
                        "latitude": "17.92471000",
                        "longitude": "-77.52340000"
                    },
                    {
                        "id": 62958,
                        "name": "Royal Flat",
                        "latitude": "18.04965000",
                        "longitude": "-77.46830000"
                    },
                    {
                        "id": 62978,
                        "name": "Scotts Pass",
                        "latitude": "17.99920000",
                        "longitude": "-77.39820000"
                    },
                    {
                        "id": 63000,
                        "name": "Snowdon",
                        "latitude": "17.94198000",
                        "longitude": "-77.49137000"
                    },
                    {
                        "id": 63002,
                        "name": "Somerset",
                        "latitude": "18.08036000",
                        "longitude": "-77.54306000"
                    },
                    {
                        "id": 63014,
                        "name": "Spring Ground",
                        "latitude": "18.16233000",
                        "longitude": "-77.47977000"
                    },
                    {
                        "id": 63018,
                        "name": "Spur Tree",
                        "latitude": "18.00650000",
                        "longitude": "-77.55664000"
                    },
                    {
                        "id": 63025,
                        "name": "St. Paul's",
                        "latitude": "18.13144000",
                        "longitude": "-77.61200000"
                    },
                    {
                        "id": 63043,
                        "name": "Swaby's Hope",
                        "latitude": "17.98608000",
                        "longitude": "-77.53326000"
                    },
                    {
                        "id": 63055,
                        "name": "Top Hill",
                        "latitude": "18.11622000",
                        "longitude": "-77.50344000"
                    },
                    {
                        "id": 63076,
                        "name": "Victoria Town",
                        "latitude": "17.90472000",
                        "longitude": "-77.37795000"
                    },
                    {
                        "id": 63080,
                        "name": "Walderston",
                        "latitude": "18.11637000",
                        "longitude": "-77.48614000"
                    },
                    {
                        "id": 63092,
                        "name": "Watham",
                        "latitude": "18.00675000",
                        "longitude": "-77.51873000"
                    },
                    {
                        "id": 63107,
                        "name": "Williamsfield",
                        "latitude": "18.06664000",
                        "longitude": "-77.46582000"
                    }
                ]
            },
            {
                "id": 3752,
                "name": "Portland",
                "iso2": "04",
                "latitude": "18.08442740",
                "longitude": "-76.41002670",
                "type": "parish",
                "cities": [
                    {
                        "id": 62327,
                        "name": "Balcarres",
                        "latitude": "18.16735000",
                        "longitude": "-76.72061000"
                    },
                    {
                        "id": 62330,
                        "name": "Bangor Ridge",
                        "latitude": "18.13637000",
                        "longitude": "-76.68903000"
                    },
                    {
                        "id": 62351,
                        "name": "Belvedere",
                        "latitude": "18.20772000",
                        "longitude": "-76.69671000"
                    },
                    {
                        "id": 62362,
                        "name": "Black Hill",
                        "latitude": "18.21786000",
                        "longitude": "-76.59758000"
                    },
                    {
                        "id": 62378,
                        "name": "Boundbrook",
                        "latitude": "18.17573000",
                        "longitude": "-76.47079000"
                    },
                    {
                        "id": 62388,
                        "name": "Breastworks",
                        "latitude": "18.16000000",
                        "longitude": "-76.46612000"
                    },
                    {
                        "id": 62399,
                        "name": "Buff Bay",
                        "latitude": "18.23287000",
                        "longitude": "-76.66118000"
                    },
                    {
                        "id": 62408,
                        "name": "Bybrook",
                        "latitude": "18.14641000",
                        "longitude": "-76.65726000"
                    },
                    {
                        "id": 62423,
                        "name": "Cascade",
                        "latitude": "18.09377000",
                        "longitude": "-76.71223000"
                    },
                    {
                        "id": 62427,
                        "name": "Castle Comfort",
                        "latitude": "18.14217000",
                        "longitude": "-76.34634000"
                    },
                    {
                        "id": 62440,
                        "name": "Central Port Antonio",
                        "latitude": "18.18763000",
                        "longitude": "-76.45343000"
                    },
                    {
                        "id": 62447,
                        "name": "Charles Town",
                        "latitude": "18.20526000",
                        "longitude": "-76.66390000"
                    },
                    {
                        "id": 62458,
                        "name": "Claverty Cottage",
                        "latitude": "18.14876000",
                        "longitude": "-76.63923000"
                    },
                    {
                        "id": 62468,
                        "name": "Comfort Castle",
                        "latitude": "18.04833000",
                        "longitude": "-76.41614000"
                    },
                    {
                        "id": 62518,
                        "name": "Drapers",
                        "latitude": "18.17121000",
                        "longitude": "-76.40612000"
                    },
                    {
                        "id": 62528,
                        "name": "Durham",
                        "latitude": "18.08566000",
                        "longitude": "-76.51562000"
                    },
                    {
                        "id": 62548,
                        "name": "Fairy Hill",
                        "latitude": "18.16508000",
                        "longitude": "-76.36595000"
                    },
                    {
                        "id": 62552,
                        "name": "Fellowship",
                        "latitude": "18.12783000",
                        "longitude": "-76.47202000"
                    },
                    {
                        "id": 62575,
                        "name": "Fruitfulvale",
                        "latitude": "18.10891000",
                        "longitude": "-76.58617000"
                    },
                    {
                        "id": 62642,
                        "name": "Hectors River",
                        "latitude": "18.00089000",
                        "longitude": "-76.27055000"
                    },
                    {
                        "id": 62652,
                        "name": "Hope Bay",
                        "latitude": "18.18754000",
                        "longitude": "-76.57579000"
                    },
                    {
                        "id": 62687,
                        "name": "Kensington",
                        "latitude": "18.06765000",
                        "longitude": "-76.30053000"
                    },
                    {
                        "id": 62724,
                        "name": "Long Bay",
                        "latitude": "18.08581000",
                        "longitude": "-76.32515000"
                    },
                    {
                        "id": 62726,
                        "name": "Long Road",
                        "latitude": "18.00864000",
                        "longitude": "-76.29482000"
                    },
                    {
                        "id": 62744,
                        "name": "Manchioneal",
                        "latitude": "18.04444000",
                        "longitude": "-76.27735000"
                    },
                    {
                        "id": 62787,
                        "name": "Moore Town",
                        "latitude": "18.07767000",
                        "longitude": "-76.42577000"
                    },
                    {
                        "id": 62800,
                        "name": "Mount Pleasant",
                        "latitude": "18.16325000",
                        "longitude": "-76.50472000"
                    },
                    {
                        "id": 62829,
                        "name": "Nonsuch",
                        "latitude": "18.13819000",
                        "longitude": "-76.40467000"
                    },
                    {
                        "id": 62832,
                        "name": "Norwich",
                        "latitude": "18.18819000",
                        "longitude": "-76.47705000"
                    },
                    {
                        "id": 62843,
                        "name": "Orange Bay",
                        "latitude": "18.20306000",
                        "longitude": "-76.62250000"
                    },
                    {
                        "id": 62892,
                        "name": "Port Antonio",
                        "latitude": "18.17615000",
                        "longitude": "-76.45090000"
                    },
                    {
                        "id": 62904,
                        "name": "Prospect",
                        "latitude": "18.17481000",
                        "longitude": "-76.43550000"
                    },
                    {
                        "id": 62943,
                        "name": "Rock Hall",
                        "latitude": "18.16170000",
                        "longitude": "-76.53050000"
                    },
                    {
                        "id": 62989,
                        "name": "Sherwood Forest",
                        "latitude": "18.15428000",
                        "longitude": "-76.37821000"
                    },
                    {
                        "id": 62990,
                        "name": "Shirley Castle",
                        "latitude": "18.15657000",
                        "longitude": "-76.61112000"
                    },
                    {
                        "id": 62994,
                        "name": "Skibo",
                        "latitude": "18.17318000",
                        "longitude": "-76.62752000"
                    },
                    {
                        "id": 62999,
                        "name": "Snow Hill",
                        "latitude": "18.19474000",
                        "longitude": "-76.49350000"
                    },
                    {
                        "id": 63015,
                        "name": "Spring Hill",
                        "latitude": "18.12591000",
                        "longitude": "-76.72909000"
                    },
                    {
                        "id": 63024,
                        "name": "St. Margaret's Bay",
                        "latitude": "18.19084000",
                        "longitude": "-76.52888000"
                    },
                    {
                        "id": 63045,
                        "name": "Swift River",
                        "latitude": "18.15770000",
                        "longitude": "-76.57869000"
                    },
                    {
                        "id": 63060,
                        "name": "Tranquility",
                        "latitude": "18.18028000",
                        "longitude": "-76.68150000"
                    },
                    {
                        "id": 63113,
                        "name": "Windsor",
                        "latitude": "18.10673000",
                        "longitude": "-76.44631000"
                    },
                    {
                        "id": 63114,
                        "name": "Windsor Castle",
                        "latitude": "18.24888000",
                        "longitude": "-76.69029000"
                    },
                    {
                        "id": 63115,
                        "name": "Windsor Forest",
                        "latitude": "18.12057000",
                        "longitude": "-76.33876000"
                    }
                ]
            },
            {
                "id": 3751,
                "name": "Saint Andrew",
                "iso2": "02",
                "latitude": "37.22451030",
                "longitude": "-95.70211890",
                "type": "parish",
                "cities": [
                    {
                        "id": 62316,
                        "name": "Arcadia",
                        "latitude": "18.03737000",
                        "longitude": "-76.78201000"
                    },
                    {
                        "id": 62317,
                        "name": "Arlene Gardens",
                        "latitude": "18.03713000",
                        "longitude": "-76.81791000"
                    },
                    {
                        "id": 62318,
                        "name": "Arnett Gardens",
                        "latitude": "17.99150000",
                        "longitude": "-76.79829000"
                    },
                    {
                        "id": 62324,
                        "name": "August Town",
                        "latitude": "17.99556000",
                        "longitude": "-76.73673000"
                    },
                    {
                        "id": 62334,
                        "name": "Barbican",
                        "latitude": "18.03549000",
                        "longitude": "-76.76987000"
                    },
                    {
                        "id": 62357,
                        "name": "Beverley Hills",
                        "latitude": "18.00833000",
                        "longitude": "-76.76208000"
                    },
                    {
                        "id": 62361,
                        "name": "Bito",
                        "latitude": "17.97363000",
                        "longitude": "-76.66625000"
                    },
                    {
                        "id": 62365,
                        "name": "Bloxborough",
                        "latitude": "17.99581000",
                        "longitude": "-76.64767000"
                    },
                    {
                        "id": 62377,
                        "name": "Boucher Park",
                        "latitude": "18.00344000",
                        "longitude": "-76.81257000"
                    },
                    {
                        "id": 62385,
                        "name": "Brandon Hill",
                        "latitude": "18.14822000",
                        "longitude": "-76.80513000"
                    },
                    {
                        "id": 62400,
                        "name": "Bull Bay\/ Seven Mile",
                        "latitude": "17.95247000",
                        "longitude": "-76.68404000"
                    },
                    {
                        "id": 62417,
                        "name": "Cane River",
                        "latitude": "17.98098000",
                        "longitude": "-76.68624000"
                    },
                    {
                        "id": 62426,
                        "name": "Cassia Park",
                        "latitude": "18.02047000",
                        "longitude": "-76.80665000"
                    },
                    {
                        "id": 62433,
                        "name": "Cavaliers",
                        "latitude": "18.09677000",
                        "longitude": "-76.84321000"
                    },
                    {
                        "id": 62450,
                        "name": "Cherry Gardens",
                        "latitude": "18.04963000",
                        "longitude": "-76.77867000"
                    },
                    {
                        "id": 62461,
                        "name": "Cockburn Gardens",
                        "latitude": "18.00357000",
                        "longitude": "-76.82435000"
                    },
                    {
                        "id": 62471,
                        "name": "Constant Spring",
                        "latitude": "18.05078000",
                        "longitude": "-76.79372000"
                    },
                    {
                        "id": 62472,
                        "name": "Constant Spring Gardens",
                        "latitude": "18.02942000",
                        "longitude": "-76.79956000"
                    },
                    {
                        "id": 62473,
                        "name": "Constitution Hill",
                        "latitude": "18.01488000",
                        "longitude": "-76.70515000"
                    },
                    {
                        "id": 62476,
                        "name": "Content Gap",
                        "latitude": "18.04082000",
                        "longitude": "-76.69070000"
                    },
                    {
                        "id": 62478,
                        "name": "Cooreville Gardens",
                        "latitude": "18.02244000",
                        "longitude": "-76.84852000"
                    },
                    {
                        "id": 62493,
                        "name": "Cross Roads",
                        "latitude": "17.99454000",
                        "longitude": "-76.78810000"
                    },
                    {
                        "id": 62499,
                        "name": "Dallas",
                        "latitude": "17.98463000",
                        "longitude": "-76.71256000"
                    },
                    {
                        "id": 62506,
                        "name": "Delacree Park\/ Union Gardens",
                        "latitude": "17.99210000",
                        "longitude": "-76.82240000"
                    },
                    {
                        "id": 62507,
                        "name": "Delacree Pen",
                        "latitude": "17.99579000",
                        "longitude": "-76.81709000"
                    },
                    {
                        "id": 62519,
                        "name": "Drewsland",
                        "latitude": "18.02381000",
                        "longitude": "-76.82626000"
                    },
                    {
                        "id": 62520,
                        "name": "Drumblair",
                        "latitude": "18.02354000",
                        "longitude": "-76.78759000"
                    },
                    {
                        "id": 62523,
                        "name": "Duhaney Park",
                        "latitude": "18.03086000",
                        "longitude": "-76.84617000"
                    },
                    {
                        "id": 62531,
                        "name": "Eastwood Park Gardens",
                        "latitude": "18.01891000",
                        "longitude": "-76.80072000"
                    },
                    {
                        "id": 62537,
                        "name": "Elleston Flats\/ Mona Commons",
                        "latitude": "18.00945000",
                        "longitude": "-76.74034000"
                    },
                    {
                        "id": 62554,
                        "name": "Ferry",
                        "latitude": "18.02771000",
                        "longitude": "-76.86720000"
                    },
                    {
                        "id": 62562,
                        "name": "Forest Hills Gardens",
                        "latitude": "18.03848000",
                        "longitude": "-76.82868000"
                    },
                    {
                        "id": 62563,
                        "name": "Forest Hills\/ Plantation Height",
                        "latitude": "18.04300000",
                        "longitude": "-76.85140000"
                    },
                    {
                        "id": 62594,
                        "name": "Golden Spring",
                        "latitude": "18.09446000",
                        "longitude": "-76.79727000"
                    },
                    {
                        "id": 62598,
                        "name": "Gordon Town",
                        "latitude": "18.03762000",
                        "longitude": "-76.72353000"
                    },
                    {
                        "id": 62603,
                        "name": "Grants Pen",
                        "latitude": "18.03258000",
                        "longitude": "-76.78887000"
                    },
                    {
                        "id": 62614,
                        "name": "Greenwich Town\/ Newport West",
                        "latitude": "17.98438000",
                        "longitude": "-76.82559000"
                    },
                    {
                        "id": 62623,
                        "name": "Half Way Tree",
                        "latitude": "18.01248000",
                        "longitude": "-76.79928000"
                    },
                    {
                        "id": 62624,
                        "name": "Half-Way-Tree",
                        "latitude": "18.01259000",
                        "longitude": "-76.79582000"
                    },
                    {
                        "id": 62630,
                        "name": "Harbour View",
                        "latitude": "17.95146000",
                        "longitude": "-76.71662000"
                    },
                    {
                        "id": 62637,
                        "name": "Havendale",
                        "latitude": "18.05429000",
                        "longitude": "-76.80870000"
                    },
                    {
                        "id": 62644,
                        "name": "Hermitage",
                        "latitude": "17.98351000",
                        "longitude": "-76.74102000"
                    },
                    {
                        "id": 62653,
                        "name": "Hope Pastures\/ UTECH",
                        "latitude": "18.02306000",
                        "longitude": "-76.74987000"
                    },
                    {
                        "id": 62654,
                        "name": "Hope Tavern",
                        "latitude": "18.01233000",
                        "longitude": "-76.73202000"
                    },
                    {
                        "id": 62658,
                        "name": "Hughenden",
                        "latitude": "18.03037000",
                        "longitude": "-76.81728000"
                    },
                    {
                        "id": 62663,
                        "name": "Irish Town",
                        "latitude": "18.06234000",
                        "longitude": "-76.70262000"
                    },
                    {
                        "id": 62667,
                        "name": "Jacks Hill",
                        "latitude": "18.03872000",
                        "longitude": "-76.74892000"
                    },
                    {
                        "id": 62681,
                        "name": "Jones Town",
                        "latitude": "17.98422000",
                        "longitude": "-76.79691000"
                    },
                    {
                        "id": 62684,
                        "name": "Kencot",
                        "latitude": "18.00041000",
                        "longitude": "-76.79835000"
                    },
                    {
                        "id": 62695,
                        "name": "Kintyre",
                        "latitude": "18.02133000",
                        "longitude": "-76.72688000"
                    },
                    {
                        "id": 62703,
                        "name": "Lawrence Tavern",
                        "latitude": "18.13742000",
                        "longitude": "-76.84736000"
                    },
                    {
                        "id": 62708,
                        "name": "Liguanea",
                        "latitude": "18.02097000",
                        "longitude": "-76.76827000"
                    },
                    {
                        "id": 62741,
                        "name": "Majestic Gardens",
                        "latitude": "18.00023000",
                        "longitude": "-76.83295000"
                    },
                    {
                        "id": 62749,
                        "name": "Mannings Hill",
                        "latitude": "18.07052000",
                        "longitude": "-76.81288000"
                    },
                    {
                        "id": 62750,
                        "name": "Mannings Hill (Rural)",
                        "latitude": "18.08169000",
                        "longitude": "-76.82328000"
                    },
                    {
                        "id": 62757,
                        "name": "Marverley",
                        "latitude": "18.02676000",
                        "longitude": "-76.82652000"
                    },
                    {
                        "id": 62759,
                        "name": "Maryland",
                        "latitude": "18.05166000",
                        "longitude": "-76.74320000"
                    },
                    {
                        "id": 62761,
                        "name": "Mavis Bank",
                        "latitude": "18.03333000",
                        "longitude": "-76.66667000"
                    },
                    {
                        "id": 62762,
                        "name": "Maxfield Park",
                        "latitude": "17.99937000",
                        "longitude": "-76.80800000"
                    },
                    {
                        "id": 62766,
                        "name": "Meadowbrook",
                        "latitude": "18.04708000",
                        "longitude": "-76.81553000"
                    },
                    {
                        "id": 62767,
                        "name": "Meadowbrook Estate",
                        "latitude": "18.03738000",
                        "longitude": "-76.82964000"
                    },
                    {
                        "id": 62780,
                        "name": "Molynes Four Roads",
                        "latitude": "18.01035000",
                        "longitude": "-76.81112000"
                    },
                    {
                        "id": 62781,
                        "name": "Molynes Gardens",
                        "latitude": "18.01980000",
                        "longitude": "-76.81621000"
                    },
                    {
                        "id": 62782,
                        "name": "Mona Heights",
                        "latitude": "18.01331000",
                        "longitude": "-76.75086000"
                    },
                    {
                        "id": 62796,
                        "name": "Mount James",
                        "latitude": "18.12069000",
                        "longitude": "-76.77394000"
                    },
                    {
                        "id": 62804,
                        "name": "Mountain View Gardens",
                        "latitude": "17.99186000",
                        "longitude": "-76.76070000"
                    },
                    {
                        "id": 62810,
                        "name": "Nannyville",
                        "latitude": "17.99677000",
                        "longitude": "-76.76949000"
                    },
                    {
                        "id": 62815,
                        "name": "New Haven",
                        "latitude": "18.02953000",
                        "longitude": "-76.85425000"
                    },
                    {
                        "id": 62816,
                        "name": "New Kingston",
                        "latitude": "18.00747000",
                        "longitude": "-76.78319000"
                    },
                    {
                        "id": 62830,
                        "name": "Norbrook",
                        "latitude": "18.05483000",
                        "longitude": "-76.78498000"
                    },
                    {
                        "id": 62834,
                        "name": "Oaklands",
                        "latitude": "18.03558000",
                        "longitude": "-76.79563000"
                    },
                    {
                        "id": 62851,
                        "name": "Papine",
                        "latitude": "18.01536000",
                        "longitude": "-76.73868000"
                    },
                    {
                        "id": 62853,
                        "name": "Parks Road",
                        "latitude": "18.09802000",
                        "longitude": "-76.85941000"
                    },
                    {
                        "id": 62867,
                        "name": "Patrick City",
                        "latitude": "18.03185000",
                        "longitude": "-76.83774000"
                    },
                    {
                        "id": 62874,
                        "name": "Pembroke Hall",
                        "latitude": "18.03113000",
                        "longitude": "-76.83003000"
                    },
                    {
                        "id": 62876,
                        "name": "Penwood",
                        "latitude": "18.01952000",
                        "longitude": "-76.83094000"
                    },
                    {
                        "id": 62908,
                        "name": "Queensborough\/ Tunbridge",
                        "latitude": "18.04289000",
                        "longitude": "-76.82119000"
                    },
                    {
                        "id": 62917,
                        "name": "Red Hills (Rural)",
                        "latitude": "18.06777000",
                        "longitude": "-76.86093000"
                    },
                    {
                        "id": 62918,
                        "name": "Red Hills Gardens",
                        "latitude": "18.03000000",
                        "longitude": "-76.80994000"
                    },
                    {
                        "id": 62919,
                        "name": "Red Hills\/ Sterling Castle",
                        "latitude": "18.05946000",
                        "longitude": "-76.84028000"
                    },
                    {
                        "id": 62931,
                        "name": "Richmond Park",
                        "latitude": "18.00560000",
                        "longitude": "-76.80464000"
                    },
                    {
                        "id": 62938,
                        "name": "Riverton City",
                        "latitude": "18.01443000",
                        "longitude": "-76.84897000"
                    },
                    {
                        "id": 62947,
                        "name": "Roehampton",
                        "latitude": "18.04320000",
                        "longitude": "-76.80841000"
                    },
                    {
                        "id": 62955,
                        "name": "Rose Town",
                        "latitude": "17.98697000",
                        "longitude": "-76.80726000"
                    },
                    {
                        "id": 62982,
                        "name": "Seaview Gardens",
                        "latitude": "18.00619000",
                        "longitude": "-76.84106000"
                    },
                    {
                        "id": 62983,
                        "name": "Seaward Pen",
                        "latitude": "18.01900000",
                        "longitude": "-76.82368000"
                    },
                    {
                        "id": 62986,
                        "name": "Seymour Lands",
                        "latitude": "18.01291000",
                        "longitude": "-76.77706000"
                    },
                    {
                        "id": 63026,
                        "name": "St. Peter's",
                        "latitude": "18.07881000",
                        "longitude": "-76.67202000"
                    },
                    {
                        "id": 63028,
                        "name": "Stadium Gardens",
                        "latitude": "17.99501000",
                        "longitude": "-76.77644000"
                    },
                    {
                        "id": 63033,
                        "name": "Stony Hill",
                        "latitude": "18.07916000",
                        "longitude": "-76.78473000"
                    },
                    {
                        "id": 63044,
                        "name": "Swallowfield",
                        "latitude": "18.00486000",
                        "longitude": "-76.77439000"
                    },
                    {
                        "id": 63047,
                        "name": "Temple Hall",
                        "latitude": "18.10471000",
                        "longitude": "-76.81818000"
                    },
                    {
                        "id": 63051,
                        "name": "Three Oaks\/ Glendale",
                        "latitude": "18.03128000",
                        "longitude": "-76.82447000"
                    },
                    {
                        "id": 63056,
                        "name": "Tower Hill",
                        "latitude": "18.01183000",
                        "longitude": "-76.82807000"
                    },
                    {
                        "id": 63059,
                        "name": "Trafalgar Park",
                        "latitude": "18.01280000",
                        "longitude": "-76.78465000"
                    },
                    {
                        "id": 63063,
                        "name": "Trench Town",
                        "latitude": "17.98743000",
                        "longitude": "-76.80118000"
                    },
                    {
                        "id": 63074,
                        "name": "University",
                        "latitude": "18.00094000",
                        "longitude": "-76.74769000"
                    },
                    {
                        "id": 63077,
                        "name": "Vineyard Town",
                        "latitude": "17.98690000",
                        "longitude": "-76.77059000"
                    },
                    {
                        "id": 63082,
                        "name": "Waltham Gardens",
                        "latitude": "18.01085000",
                        "longitude": "-76.82049000"
                    },
                    {
                        "id": 63085,
                        "name": "Washington Gardens",
                        "latitude": "18.02174000",
                        "longitude": "-76.84020000"
                    },
                    {
                        "id": 63090,
                        "name": "Waterhouse",
                        "latitude": "18.01231000",
                        "longitude": "-76.83505000"
                    },
                    {
                        "id": 63102,
                        "name": "Whitehall",
                        "latitude": "18.03838000",
                        "longitude": "-76.80583000"
                    },
                    {
                        "id": 63104,
                        "name": "Whitfield Town",
                        "latitude": "17.99212000",
                        "longitude": "-76.80910000"
                    },
                    {
                        "id": 63111,
                        "name": "Wilton Gardens\/ Rema",
                        "latitude": "17.98287000",
                        "longitude": "-76.80422000"
                    },
                    {
                        "id": 63117,
                        "name": "Woodford",
                        "latitude": "18.07362000",
                        "longitude": "-76.74632000"
                    },
                    {
                        "id": 63118,
                        "name": "Woodford Park",
                        "latitude": "17.98712000",
                        "longitude": "-76.78117000"
                    },
                    {
                        "id": 63128,
                        "name": "Zaidie Gardens",
                        "latitude": "18.02566000",
                        "longitude": "-76.80978000"
                    }
                ]
            },
            {
                "id": 3744,
                "name": "Saint Ann",
                "iso2": "06",
                "latitude": "37.28714520",
                "longitude": "-77.41035330",
                "type": "parish",
                "cities": [
                    {
                        "id": 62291,
                        "name": "Aboukir",
                        "latitude": "18.25090000",
                        "longitude": "-77.34327000"
                    },
                    {
                        "id": 62300,
                        "name": "Alderton",
                        "latitude": "18.28706000",
                        "longitude": "-77.20832000"
                    },
                    {
                        "id": 62301,
                        "name": "Alexandria",
                        "latitude": "18.30411000",
                        "longitude": "-77.35311000"
                    },
                    {
                        "id": 62308,
                        "name": "Alva",
                        "latitude": "18.29679000",
                        "longitude": "-77.31717000"
                    },
                    {
                        "id": 62329,
                        "name": "Bamboo",
                        "latitude": "18.39216000",
                        "longitude": "-77.26429000"
                    },
                    {
                        "id": 62345,
                        "name": "Beecher Town",
                        "latitude": "18.38465000",
                        "longitude": "-77.11617000"
                    },
                    {
                        "id": 62352,
                        "name": "Bensonton",
                        "latitude": "18.22315000",
                        "longitude": "-77.20861000"
                    },
                    {
                        "id": 62364,
                        "name": "Blackstonedge",
                        "latitude": "18.27357000",
                        "longitude": "-77.04254000"
                    },
                    {
                        "id": 62373,
                        "name": "Bohemia",
                        "latitude": "18.21239000",
                        "longitude": "-77.46954000"
                    },
                    {
                        "id": 62376,
                        "name": "Borobridge",
                        "latitude": "18.19779000",
                        "longitude": "-77.42755000"
                    },
                    {
                        "id": 62396,
                        "name": "Browns Town",
                        "latitude": "18.38464000",
                        "longitude": "-77.35286000"
                    },
                    {
                        "id": 62412,
                        "name": "Calderwood",
                        "latitude": "18.25641000",
                        "longitude": "-77.27144000"
                    },
                    {
                        "id": 62424,
                        "name": "Cascade",
                        "latitude": "18.23209000",
                        "longitude": "-77.46255000"
                    },
                    {
                        "id": 62435,
                        "name": "Cave Valley",
                        "latitude": "18.23268000",
                        "longitude": "-77.36337000"
                    },
                    {
                        "id": 62442,
                        "name": "Chalky Hill",
                        "latitude": "18.37964000",
                        "longitude": "-77.17520000"
                    },
                    {
                        "id": 62451,
                        "name": "Chester",
                        "latitude": "18.44786000",
                        "longitude": "-77.26503000"
                    },
                    {
                        "id": 62456,
                        "name": "Claremont",
                        "latitude": "18.32556000",
                        "longitude": "-77.20643000"
                    },
                    {
                        "id": 62464,
                        "name": "Cole Gate",
                        "latitude": "18.37967000",
                        "longitude": "-77.08518000"
                    },
                    {
                        "id": 62477,
                        "name": "Content Garden",
                        "latitude": "18.40977000",
                        "longitude": "-77.07540000"
                    },
                    {
                        "id": 62494,
                        "name": "Cuffie Ridge",
                        "latitude": "18.22793000",
                        "longitude": "-77.42054000"
                    },
                    {
                        "id": 62514,
                        "name": "Discovery Bay",
                        "latitude": "18.43725000",
                        "longitude": "-77.41815000"
                    },
                    {
                        "id": 62542,
                        "name": "Epworth",
                        "latitude": "18.36083000",
                        "longitude": "-77.13342000"
                    },
                    {
                        "id": 62545,
                        "name": "Exchange",
                        "latitude": "18.37265000",
                        "longitude": "-77.06572000"
                    },
                    {
                        "id": 62549,
                        "name": "Faith's Pen",
                        "latitude": "18.22963000",
                        "longitude": "-77.08804000"
                    },
                    {
                        "id": 62583,
                        "name": "Gibraltar",
                        "latitude": "18.35079000",
                        "longitude": "-77.42142000"
                    },
                    {
                        "id": 62593,
                        "name": "Golden Grove",
                        "latitude": "18.32956000",
                        "longitude": "-77.12256000"
                    },
                    {
                        "id": 62607,
                        "name": "Great Pond",
                        "latitude": "18.40227000",
                        "longitude": "-77.08511000"
                    },
                    {
                        "id": 62647,
                        "name": "Higgin Land",
                        "latitude": "18.34119000",
                        "longitude": "-77.27072000"
                    },
                    {
                        "id": 62650,
                        "name": "Hinds Town",
                        "latitude": "18.35425000",
                        "longitude": "-77.09812000"
                    },
                    {
                        "id": 62662,
                        "name": "Inverness",
                        "latitude": "18.27531000",
                        "longitude": "-77.36862000"
                    },
                    {
                        "id": 62710,
                        "name": "Lime Hall",
                        "latitude": "18.39742000",
                        "longitude": "-77.21051000"
                    },
                    {
                        "id": 62711,
                        "name": "Lime Tree Gardens",
                        "latitude": "18.34545000",
                        "longitude": "-77.38645000"
                    },
                    {
                        "id": 62714,
                        "name": "Linton Park",
                        "latitude": "18.26081000",
                        "longitude": "-77.42221000"
                    },
                    {
                        "id": 62737,
                        "name": "Macknie",
                        "latitude": "18.21191000",
                        "longitude": "-77.28016000"
                    },
                    {
                        "id": 62738,
                        "name": "Madras",
                        "latitude": "18.29112000",
                        "longitude": "-77.44875000"
                    },
                    {
                        "id": 62751,
                        "name": "Mansfield",
                        "latitude": "18.40265000",
                        "longitude": "-77.09488000"
                    },
                    {
                        "id": 62783,
                        "name": "Moneague",
                        "latitude": "18.28307000",
                        "longitude": "-77.13855000"
                    },
                    {
                        "id": 62798,
                        "name": "Mount Moriah",
                        "latitude": "18.20617000",
                        "longitude": "-77.44094000"
                    },
                    {
                        "id": 62803,
                        "name": "Mount Zion",
                        "latitude": "18.43377000",
                        "longitude": "-77.28028000"
                    },
                    {
                        "id": 62835,
                        "name": "Ocho Rios",
                        "latitude": "18.40760000",
                        "longitude": "-77.10312000"
                    },
                    {
                        "id": 62855,
                        "name": "Parry Town",
                        "latitude": "18.38359000",
                        "longitude": "-77.10345000"
                    },
                    {
                        "id": 62881,
                        "name": "Philadelphia",
                        "latitude": "18.40005000",
                        "longitude": "-77.32735000"
                    },
                    {
                        "id": 62883,
                        "name": "Pimento Walk",
                        "latitude": "18.39578000",
                        "longitude": "-77.11383000"
                    },
                    {
                        "id": 62903,
                        "name": "Priory",
                        "latitude": "18.43660000",
                        "longitude": "-77.24551000"
                    },
                    {
                        "id": 62935,
                        "name": "River Head",
                        "latitude": "18.26030000",
                        "longitude": "-77.07782000"
                    },
                    {
                        "id": 62959,
                        "name": "Runaway Bay",
                        "latitude": "18.45962000",
                        "longitude": "-77.33570000"
                    },
                    {
                        "id": 62962,
                        "name": "Saint Ann’s Bay",
                        "latitude": "18.43581000",
                        "longitude": "-77.20098000"
                    },
                    {
                        "id": 63019,
                        "name": "St. Ann's Bay",
                        "latitude": "18.42989000",
                        "longitude": "-77.20775000"
                    },
                    {
                        "id": 63020,
                        "name": "St. D'Acre",
                        "latitude": "18.33300000",
                        "longitude": "-77.36297000"
                    },
                    {
                        "id": 63029,
                        "name": "Steer Town",
                        "latitude": "18.42852000",
                        "longitude": "-77.17101000"
                    },
                    {
                        "id": 63037,
                        "name": "Sturge Town",
                        "latitude": "18.41631000",
                        "longitude": "-77.31988000"
                    },
                    {
                        "id": 63081,
                        "name": "Walkers Wood",
                        "latitude": "18.31939000",
                        "longitude": "-77.07082000"
                    },
                    {
                        "id": 63093,
                        "name": "Watt Town",
                        "latitude": "18.29427000",
                        "longitude": "-77.41466000"
                    },
                    {
                        "id": 63126,
                        "name": "York Castle",
                        "latitude": "18.27515000",
                        "longitude": "-77.22923000"
                    }
                ]
            },
            {
                "id": 3746,
                "name": "Saint Catherine",
                "iso2": "14",
                "latitude": "18.03641340",
                "longitude": "-77.05644640",
                "type": "parish",
                "cities": [
                    {
                        "id": 62292,
                        "name": "Above Rocks",
                        "latitude": "18.11432000",
                        "longitude": "-76.87590000"
                    },
                    {
                        "id": 62338,
                        "name": "Bartons",
                        "latitude": "18.02895000",
                        "longitude": "-77.13322000"
                    },
                    {
                        "id": 62348,
                        "name": "Bellas Gate",
                        "latitude": "18.04715000",
                        "longitude": "-77.14906000"
                    },
                    {
                        "id": 62369,
                        "name": "Bog Walk",
                        "latitude": "18.10205000",
                        "longitude": "-77.00541000"
                    },
                    {
                        "id": 62372,
                        "name": "Bogwalk",
                        "latitude": "18.10468000",
                        "longitude": "-76.98792000"
                    },
                    {
                        "id": 62382,
                        "name": "Braeton",
                        "latitude": "17.94174000",
                        "longitude": "-76.88635000"
                    },
                    {
                        "id": 62389,
                        "name": "Bridgeport",
                        "latitude": "17.96264000",
                        "longitude": "-76.87809000"
                    },
                    {
                        "id": 62395,
                        "name": "Browns Hill",
                        "latitude": "18.05358000",
                        "longitude": "-77.11855000"
                    },
                    {
                        "id": 62436,
                        "name": "Caymanas",
                        "latitude": "18.03824000",
                        "longitude": "-76.89833000"
                    },
                    {
                        "id": 62441,
                        "name": "Central Village",
                        "latitude": "17.99992000",
                        "longitude": "-76.92393000"
                    },
                    {
                        "id": 62488,
                        "name": "Crescent",
                        "latitude": "18.03621000",
                        "longitude": "-76.97626000"
                    },
                    {
                        "id": 62490,
                        "name": "Cromarty",
                        "latitude": "17.95840000",
                        "longitude": "-76.98457000"
                    },
                    {
                        "id": 62495,
                        "name": "Cumberland",
                        "latitude": "17.97650000",
                        "longitude": "-76.88208000"
                    },
                    {
                        "id": 62532,
                        "name": "Edgewater",
                        "latitude": "17.96448000",
                        "longitude": "-76.86547000"
                    },
                    {
                        "id": 62540,
                        "name": "Ensom",
                        "latitude": "18.01778000",
                        "longitude": "-76.96221000"
                    },
                    {
                        "id": 62544,
                        "name": "Ewarton",
                        "latitude": "18.18333000",
                        "longitude": "-77.08536000"
                    },
                    {
                        "id": 62587,
                        "name": "Ginger Ridge",
                        "latitude": "18.07688000",
                        "longitude": "-77.16865000"
                    },
                    {
                        "id": 62589,
                        "name": "Glengoffe",
                        "latitude": "18.15214000",
                        "longitude": "-76.89057000"
                    },
                    {
                        "id": 62591,
                        "name": "Golden Acres",
                        "latitude": "18.01950000",
                        "longitude": "-76.98040000"
                    },
                    {
                        "id": 62609,
                        "name": "Greater Portmore",
                        "latitude": "17.95228000",
                        "longitude": "-76.91133000"
                    },
                    {
                        "id": 62612,
                        "name": "Greendale",
                        "latitude": "18.01251000",
                        "longitude": "-76.94831000"
                    },
                    {
                        "id": 62616,
                        "name": "Gregory Park",
                        "latitude": "17.99490000",
                        "longitude": "-76.88302000"
                    },
                    {
                        "id": 62628,
                        "name": "Hampton Green",
                        "latitude": "18.00544000",
                        "longitude": "-76.96818000"
                    },
                    {
                        "id": 62631,
                        "name": "Harewood",
                        "latitude": "18.17277000",
                        "longitude": "-76.94395000"
                    },
                    {
                        "id": 62632,
                        "name": "Harkers Hall",
                        "latitude": "18.13149000",
                        "longitude": "-76.91350000"
                    },
                    {
                        "id": 62643,
                        "name": "Hellshire",
                        "latitude": "17.89669000",
                        "longitude": "-76.96187000"
                    },
                    {
                        "id": 62660,
                        "name": "Independence City",
                        "latitude": "17.97783000",
                        "longitude": "-76.87498000"
                    },
                    {
                        "id": 62689,
                        "name": "Keystone",
                        "latitude": "18.01652000",
                        "longitude": "-76.93525000"
                    },
                    {
                        "id": 62696,
                        "name": "Kitson Town",
                        "latitude": "18.03487000",
                        "longitude": "-77.04028000"
                    },
                    {
                        "id": 62713,
                        "name": "Linstead",
                        "latitude": "18.13683000",
                        "longitude": "-77.03171000"
                    },
                    {
                        "id": 62722,
                        "name": "Lluidas Vale",
                        "latitude": "18.14977000",
                        "longitude": "-77.16853000"
                    },
                    {
                        "id": 62808,
                        "name": "Naggo Head",
                        "latitude": "17.96415000",
                        "longitude": "-76.88820000"
                    },
                    {
                        "id": 62838,
                        "name": "Old Harbour",
                        "latitude": "17.94144000",
                        "longitude": "-77.10898000"
                    },
                    {
                        "id": 62839,
                        "name": "Old Harbour Bay",
                        "latitude": "17.90918000",
                        "longitude": "-77.09718000"
                    },
                    {
                        "id": 62840,
                        "name": "Old Harbour Road",
                        "latitude": "17.95797000",
                        "longitude": "-77.02730000"
                    },
                    {
                        "id": 62860,
                        "name": "Part of Guys Hill",
                        "latitude": "18.24525000",
                        "longitude": "-76.99081000"
                    },
                    {
                        "id": 62862,
                        "name": "Part of Keystone",
                        "latitude": "18.03965000",
                        "longitude": "-76.95113000"
                    },
                    {
                        "id": 62863,
                        "name": "Part of Rock Hall",
                        "latitude": "18.09119000",
                        "longitude": "-76.88804000"
                    },
                    {
                        "id": 62865,
                        "name": "Passage Fort",
                        "latitude": "17.97788000",
                        "longitude": "-76.86793000"
                    },
                    {
                        "id": 62870,
                        "name": "Pear Tree Grove",
                        "latitude": "18.22515000",
                        "longitude": "-76.95293000"
                    },
                    {
                        "id": 62888,
                        "name": "Point Hill",
                        "latitude": "18.09361000",
                        "longitude": "-77.10480000"
                    },
                    {
                        "id": 62898,
                        "name": "Portmore",
                        "latitude": "17.95032000",
                        "longitude": "-76.88215000"
                    },
                    {
                        "id": 62920,
                        "name": "Redwood",
                        "latitude": "18.21026000",
                        "longitude": "-76.98536000"
                    },
                    {
                        "id": 62937,
                        "name": "Riversdale",
                        "latitude": "18.17802000",
                        "longitude": "-76.96636000"
                    },
                    {
                        "id": 62995,
                        "name": "Sligoville",
                        "latitude": "18.08203000",
                        "longitude": "-76.93991000"
                    },
                    {
                        "id": 63007,
                        "name": "Spanish Town",
                        "latitude": "17.99107000",
                        "longitude": "-76.95742000"
                    },
                    {
                        "id": 63008,
                        "name": "Spanish Town Central",
                        "latitude": "17.98014000",
                        "longitude": "-76.92294000"
                    },
                    {
                        "id": 63021,
                        "name": "St. John's East",
                        "latitude": "18.00090000",
                        "longitude": "-76.97466000"
                    },
                    {
                        "id": 63022,
                        "name": "St. John's West",
                        "latitude": "18.00539000",
                        "longitude": "-77.00755000"
                    },
                    {
                        "id": 63066,
                        "name": "Troja",
                        "latitude": "18.20485000",
                        "longitude": "-76.93196000"
                    },
                    {
                        "id": 63089,
                        "name": "Waterford",
                        "latitude": "17.99340000",
                        "longitude": "-76.86090000"
                    },
                    {
                        "id": 63091,
                        "name": "Watermount",
                        "latitude": "18.06686000",
                        "longitude": "-77.09112000"
                    },
                    {
                        "id": 63095,
                        "name": "West Cumberland",
                        "latitude": "17.97890000",
                        "longitude": "-76.88662000"
                    },
                    {
                        "id": 63108,
                        "name": "Willowdene",
                        "latitude": "17.99189000",
                        "longitude": "-76.98199000"
                    }
                ]
            },
            {
                "id": 3743,
                "name": "Saint Elizabeth",
                "iso2": "11",
                "latitude": "38.99253080",
                "longitude": "-94.58992000",
                "type": "parish",
                "cities": [
                    {
                        "id": 62290,
                        "name": "Aberdeen",
                        "latitude": "18.20508000",
                        "longitude": "-77.67932000"
                    },
                    {
                        "id": 62293,
                        "name": "Accompong",
                        "latitude": "18.22985000",
                        "longitude": "-77.74816000"
                    },
                    {
                        "id": 62303,
                        "name": "Alligator Pond",
                        "latitude": "17.86932000",
                        "longitude": "-77.56769000"
                    },
                    {
                        "id": 62326,
                        "name": "Balaclava",
                        "latitude": "18.17228000",
                        "longitude": "-77.64375000"
                    },
                    {
                        "id": 62328,
                        "name": "Ballards  Valley",
                        "latitude": "17.87949000",
                        "longitude": "-77.63086000"
                    },
                    {
                        "id": 62333,
                        "name": "Barbary Hall",
                        "latitude": "17.96800000",
                        "longitude": "-77.77961000"
                    },
                    {
                        "id": 62360,
                        "name": "Bigwoods",
                        "latitude": "17.93338000",
                        "longitude": "-77.71897000"
                    },
                    {
                        "id": 62363,
                        "name": "Black River",
                        "latitude": "18.02636000",
                        "longitude": "-77.84873000"
                    },
                    {
                        "id": 62371,
                        "name": "Bogue",
                        "latitude": "18.13619000",
                        "longitude": "-77.66970000"
                    },
                    {
                        "id": 62381,
                        "name": "Braes River",
                        "latitude": "18.09351000",
                        "longitude": "-77.66487000"
                    },
                    {
                        "id": 62390,
                        "name": "Brighton",
                        "latitude": "18.14836000",
                        "longitude": "-77.85604000"
                    },
                    {
                        "id": 62393,
                        "name": "Brompton",
                        "latitude": "18.06795000",
                        "longitude": "-77.88821000"
                    },
                    {
                        "id": 62401,
                        "name": "Bull Savanna",
                        "latitude": "17.88678000",
                        "longitude": "-77.59022000"
                    },
                    {
                        "id": 62402,
                        "name": "Bull Savannah",
                        "latitude": "17.88056000",
                        "longitude": "-77.59000000"
                    },
                    {
                        "id": 62405,
                        "name": "Burnt Savannah",
                        "latitude": "18.03177000",
                        "longitude": "-77.74936000"
                    },
                    {
                        "id": 62419,
                        "name": "Carisbrook",
                        "latitude": "18.14742000",
                        "longitude": "-77.77367000"
                    },
                    {
                        "id": 62483,
                        "name": "Cotterwood",
                        "latitude": "18.09492000",
                        "longitude": "-77.91553000"
                    },
                    {
                        "id": 62487,
                        "name": "Crawford",
                        "latitude": "18.05060000",
                        "longitude": "-77.91596000"
                    },
                    {
                        "id": 62534,
                        "name": "Elderslie",
                        "latitude": "18.22416000",
                        "longitude": "-77.79381000"
                    },
                    {
                        "id": 62577,
                        "name": "Fullerswood",
                        "latitude": "18.01527000",
                        "longitude": "-77.77572000"
                    },
                    {
                        "id": 62584,
                        "name": "Giddy Hall",
                        "latitude": "18.09702000",
                        "longitude": "-77.86764000"
                    },
                    {
                        "id": 62586,
                        "name": "Ginger Hill",
                        "latitude": "18.19180000",
                        "longitude": "-77.84867000"
                    },
                    {
                        "id": 62599,
                        "name": "Goshen",
                        "latitude": "18.04964000",
                        "longitude": "-77.64136000"
                    },
                    {
                        "id": 62651,
                        "name": "Holland",
                        "latitude": "18.10358000",
                        "longitude": "-77.80164000"
                    },
                    {
                        "id": 62655,
                        "name": "Hopeton",
                        "latitude": "17.95626000",
                        "longitude": "-77.66239000"
                    },
                    {
                        "id": 62682,
                        "name": "Junction",
                        "latitude": "17.91467000",
                        "longitude": "-77.59894000"
                    },
                    {
                        "id": 62699,
                        "name": "Lacovia",
                        "latitude": "18.08844000",
                        "longitude": "-77.75350000"
                    },
                    {
                        "id": 62705,
                        "name": "Leeds",
                        "latitude": "18.01399000",
                        "longitude": "-77.68374000"
                    },
                    {
                        "id": 62717,
                        "name": "Lititz",
                        "latitude": "17.94033000",
                        "longitude": "-77.59511000"
                    },
                    {
                        "id": 62739,
                        "name": "Maggotty",
                        "latitude": "18.17343000",
                        "longitude": "-77.76681000"
                    },
                    {
                        "id": 62743,
                        "name": "Malvern",
                        "latitude": "17.96667000",
                        "longitude": "-77.70000000"
                    },
                    {
                        "id": 62770,
                        "name": "Merrywood",
                        "latitude": "18.21793000",
                        "longitude": "-77.83773000"
                    },
                    {
                        "id": 62771,
                        "name": "Middle Quarters",
                        "latitude": "18.11455000",
                        "longitude": "-77.83808000"
                    },
                    {
                        "id": 62805,
                        "name": "Mountainside",
                        "latitude": "17.98077000",
                        "longitude": "-77.74786000"
                    },
                    {
                        "id": 62806,
                        "name": "Mulgrave",
                        "latitude": "18.21164000",
                        "longitude": "-77.82018000"
                    },
                    {
                        "id": 62807,
                        "name": "Myersville",
                        "latitude": "17.99699000",
                        "longitude": "-77.62425000"
                    },
                    {
                        "id": 62809,
                        "name": "Nain",
                        "latitude": "17.96526000",
                        "longitude": "-77.60528000"
                    },
                    {
                        "id": 62818,
                        "name": "New Market",
                        "latitude": "18.15362000",
                        "longitude": "-77.90962000"
                    },
                    {
                        "id": 62823,
                        "name": "Newell",
                        "latitude": "17.92103000",
                        "longitude": "-77.74653000"
                    },
                    {
                        "id": 62826,
                        "name": "Newton",
                        "latitude": "18.11095000",
                        "longitude": "-77.72352000"
                    },
                    {
                        "id": 62854,
                        "name": "Parottee",
                        "latitude": "17.96174000",
                        "longitude": "-77.81774000"
                    },
                    {
                        "id": 62872,
                        "name": "Pedro Plains",
                        "latitude": "17.88569000",
                        "longitude": "-77.71337000"
                    },
                    {
                        "id": 62877,
                        "name": "Pepper",
                        "latitude": "18.02105000",
                        "longitude": "-77.61284000"
                    },
                    {
                        "id": 62884,
                        "name": "Pisgah",
                        "latitude": "18.19605000",
                        "longitude": "-77.88671000"
                    },
                    {
                        "id": 62889,
                        "name": "Pondside",
                        "latitude": "17.98153000",
                        "longitude": "-77.79450000"
                    },
                    {
                        "id": 62902,
                        "name": "Potsdam",
                        "latitude": "17.91872000",
                        "longitude": "-77.66869000"
                    },
                    {
                        "id": 62909,
                        "name": "Quick Step",
                        "latitude": "18.23281000",
                        "longitude": "-77.67831000"
                    },
                    {
                        "id": 62915,
                        "name": "Red Bank",
                        "latitude": "17.93776000",
                        "longitude": "-77.62585000"
                    },
                    {
                        "id": 62923,
                        "name": "Retirement",
                        "latitude": "18.20740000",
                        "longitude": "-77.76698000"
                    },
                    {
                        "id": 62951,
                        "name": "Rose Hall",
                        "latitude": "17.92654000",
                        "longitude": "-77.64153000"
                    },
                    {
                        "id": 62960,
                        "name": "Russels",
                        "latitude": "17.98638000",
                        "longitude": "-77.65065000"
                    },
                    {
                        "id": 62971,
                        "name": "Santa Cruz",
                        "latitude": "18.05336000",
                        "longitude": "-77.69836000"
                    },
                    {
                        "id": 62976,
                        "name": "Scholefield",
                        "latitude": "18.02375000",
                        "longitude": "-77.71884000"
                    },
                    {
                        "id": 62993,
                        "name": "Siloah",
                        "latitude": "18.16334000",
                        "longitude": "-77.71061000"
                    },
                    {
                        "id": 62996,
                        "name": "Slipe",
                        "latitude": "18.05740000",
                        "longitude": "-77.79687000"
                    },
                    {
                        "id": 63004,
                        "name": "Southfield",
                        "latitude": "17.88212000",
                        "longitude": "-77.66988000"
                    },
                    {
                        "id": 63017,
                        "name": "Springfield",
                        "latitude": "18.17662000",
                        "longitude": "-77.87392000"
                    },
                    {
                        "id": 63049,
                        "name": "Thornton",
                        "latitude": "18.19564000",
                        "longitude": "-77.72246000"
                    },
                    {
                        "id": 63054,
                        "name": "Top Hill",
                        "latitude": "17.89317000",
                        "longitude": "-77.63793000"
                    },
                    {
                        "id": 63062,
                        "name": "Treasure Beach",
                        "latitude": "17.89550000",
                        "longitude": "-77.76051000"
                    },
                    {
                        "id": 63083,
                        "name": "Warminister",
                        "latitude": "17.96238000",
                        "longitude": "-77.63956000"
                    },
                    {
                        "id": 63086,
                        "name": "Watchwell",
                        "latitude": "17.93876000",
                        "longitude": "-77.77250000"
                    },
                    {
                        "id": 63100,
                        "name": "White Hill",
                        "latitude": "18.15646000",
                        "longitude": "-77.81067000"
                    }
                ]
            },
            {
                "id": 3745,
                "name": "Saint James",
                "iso2": "08",
                "latitude": "30.01792920",
                "longitude": "-90.79132270",
                "type": "parish",
                "cities": [
                    {
                        "id": 62294,
                        "name": "Adelphi",
                        "latitude": "18.45060000",
                        "longitude": "-77.78590000"
                    },
                    {
                        "id": 62298,
                        "name": "Albion",
                        "latitude": "18.48471000",
                        "longitude": "-77.91408000"
                    },
                    {
                        "id": 62312,
                        "name": "Anchovy",
                        "latitude": "18.41030000",
                        "longitude": "-77.93166000"
                    },
                    {
                        "id": 62315,
                        "name": "Arcadia",
                        "latitude": "18.24993000",
                        "longitude": "-77.79228000"
                    },
                    {
                        "id": 62337,
                        "name": "Barrett Town",
                        "latitude": "18.50871000",
                        "longitude": "-77.79625000"
                    },
                    {
                        "id": 62358,
                        "name": "Bickersteth",
                        "latitude": "18.36335000",
                        "longitude": "-77.93651000"
                    },
                    {
                        "id": 62370,
                        "name": "Bogue",
                        "latitude": "18.43722000",
                        "longitude": "-77.92022000"
                    },
                    {
                        "id": 62386,
                        "name": "Brandon Hill",
                        "latitude": "18.47767000",
                        "longitude": "-77.91117000"
                    },
                    {
                        "id": 62415,
                        "name": "Cambridge",
                        "latitude": "18.31308000",
                        "longitude": "-77.89546000"
                    },
                    {
                        "id": 62418,
                        "name": "Canterbury",
                        "latitude": "18.47919000",
                        "longitude": "-77.91655000"
                    },
                    {
                        "id": 62429,
                        "name": "Catadupa",
                        "latitude": "18.28052000",
                        "longitude": "-77.86579000"
                    },
                    {
                        "id": 62430,
                        "name": "Catherine Hall",
                        "latitude": "18.46258000",
                        "longitude": "-77.92286000"
                    },
                    {
                        "id": 62431,
                        "name": "Catherine Mount",
                        "latitude": "18.45672000",
                        "longitude": "-77.89691000"
                    },
                    {
                        "id": 62469,
                        "name": "Comfort Hall",
                        "latitude": "18.41270000",
                        "longitude": "-77.91814000"
                    },
                    {
                        "id": 62480,
                        "name": "Coral Gardens",
                        "latitude": "18.50791000",
                        "longitude": "-77.88034000"
                    },
                    {
                        "id": 62481,
                        "name": "Cornwall",
                        "latitude": "18.48930000",
                        "longitude": "-77.81016000"
                    },
                    {
                        "id": 62516,
                        "name": "Down Town Montego Bay",
                        "latitude": "18.47726000",
                        "longitude": "-77.92031000"
                    },
                    {
                        "id": 62525,
                        "name": "Dumfries",
                        "latitude": "18.42973000",
                        "longitude": "-77.75593000"
                    },
                    {
                        "id": 62546,
                        "name": "Fairfield",
                        "latitude": "18.45079000",
                        "longitude": "-77.91235000"
                    },
                    {
                        "id": 62551,
                        "name": "Farm Heights",
                        "latitude": "18.46869000",
                        "longitude": "-77.87760000"
                    },
                    {
                        "id": 62555,
                        "name": "Flagstaff",
                        "latitude": "18.35412000",
                        "longitude": "-77.77132000"
                    },
                    {
                        "id": 62556,
                        "name": "Flamstead",
                        "latitude": "18.31409000",
                        "longitude": "-77.81316000"
                    },
                    {
                        "id": 62557,
                        "name": "Flankers",
                        "latitude": "18.50265000",
                        "longitude": "-77.90831000"
                    },
                    {
                        "id": 62560,
                        "name": "Flower Hill",
                        "latitude": "18.48426000",
                        "longitude": "-77.83913000"
                    },
                    {
                        "id": 62572,
                        "name": "Friendship",
                        "latitude": "18.44590000",
                        "longitude": "-77.86242000"
                    },
                    {
                        "id": 62579,
                        "name": "Garlands",
                        "latitude": "18.27811000",
                        "longitude": "-77.78908000"
                    },
                    {
                        "id": 62588,
                        "name": "Glendevon",
                        "latitude": "18.48488000",
                        "longitude": "-77.89710000"
                    },
                    {
                        "id": 62597,
                        "name": "Goodwill",
                        "latitude": "18.46950000",
                        "longitude": "-77.75646000"
                    },
                    {
                        "id": 62604,
                        "name": "Granville",
                        "latitude": "18.44191000",
                        "longitude": "-77.89402000"
                    },
                    {
                        "id": 62611,
                        "name": "Green Pond",
                        "latitude": "18.47361000",
                        "longitude": "-77.87779000"
                    },
                    {
                        "id": 62615,
                        "name": "Greenwood",
                        "latitude": "18.49768000",
                        "longitude": "-77.75243000"
                    },
                    {
                        "id": 62656,
                        "name": "Hopeton",
                        "latitude": "18.39858000",
                        "longitude": "-77.86826000"
                    },
                    {
                        "id": 62664,
                        "name": "Ironshore",
                        "latitude": "18.51323000",
                        "longitude": "-77.85108000"
                    },
                    {
                        "id": 62665,
                        "name": "Irwin",
                        "latitude": "18.44949000",
                        "longitude": "-77.87722000"
                    },
                    {
                        "id": 62675,
                        "name": "John's Hall",
                        "latitude": "18.42849000",
                        "longitude": "-77.85010000"
                    },
                    {
                        "id": 62709,
                        "name": "Lilliput",
                        "latitude": "18.50591000",
                        "longitude": "-77.77686000"
                    },
                    {
                        "id": 62730,
                        "name": "Lottery",
                        "latitude": "18.41499000",
                        "longitude": "-77.80696000"
                    },
                    {
                        "id": 62742,
                        "name": "Maldon",
                        "latitude": "18.33831000",
                        "longitude": "-77.80998000"
                    },
                    {
                        "id": 62754,
                        "name": "Maroon Town",
                        "latitude": "18.34464000",
                        "longitude": "-77.79544000"
                    },
                    {
                        "id": 62779,
                        "name": "Mocho",
                        "latitude": "18.29135000",
                        "longitude": "-77.82580000"
                    },
                    {
                        "id": 62784,
                        "name": "Montego Bay",
                        "latitude": "18.47116000",
                        "longitude": "-77.91883000"
                    },
                    {
                        "id": 62785,
                        "name": "Montego Hill",
                        "latitude": "18.48038000",
                        "longitude": "-77.88150000"
                    },
                    {
                        "id": 62786,
                        "name": "Montpelier",
                        "latitude": "18.37612000",
                        "longitude": "-77.91357000"
                    },
                    {
                        "id": 62794,
                        "name": "Mount Carey",
                        "latitude": "18.38888000",
                        "longitude": "-77.94374000"
                    },
                    {
                        "id": 62795,
                        "name": "Mount Horeb",
                        "latitude": "18.33322000",
                        "longitude": "-77.86675000"
                    },
                    {
                        "id": 62801,
                        "name": "Mount Salem",
                        "latitude": "18.46601000",
                        "longitude": "-77.90793000"
                    },
                    {
                        "id": 62828,
                        "name": "Niagara",
                        "latitude": "18.26534000",
                        "longitude": "-77.81879000"
                    },
                    {
                        "id": 62833,
                        "name": "Norwood",
                        "latitude": "18.49217000",
                        "longitude": "-77.88634000"
                    },
                    {
                        "id": 62842,
                        "name": "Orange",
                        "latitude": "18.45395000",
                        "longitude": "-77.82779000"
                    },
                    {
                        "id": 62852,
                        "name": "Paradise",
                        "latitude": "18.49401000",
                        "longitude": "-77.90982000"
                    },
                    {
                        "id": 62885,
                        "name": "Pitfour",
                        "latitude": "18.43206000",
                        "longitude": "-77.89007000"
                    },
                    {
                        "id": 62899,
                        "name": "Porto Bello",
                        "latitude": "18.46607000",
                        "longitude": "-77.86989000"
                    },
                    {
                        "id": 62914,
                        "name": "Reading",
                        "latitude": "18.43723000",
                        "longitude": "-77.94730000"
                    },
                    {
                        "id": 62922,
                        "name": "Retirement",
                        "latitude": "18.43742000",
                        "longitude": "-77.88004000"
                    },
                    {
                        "id": 62926,
                        "name": "Retrieve",
                        "latitude": "18.28901000",
                        "longitude": "-77.90081000"
                    },
                    {
                        "id": 62948,
                        "name": "Roehampton",
                        "latitude": "18.39897000",
                        "longitude": "-77.89926000"
                    },
                    {
                        "id": 62950,
                        "name": "Rose Hall",
                        "latitude": "18.51228000",
                        "longitude": "-77.81833000"
                    },
                    {
                        "id": 62952,
                        "name": "Rose Heights",
                        "latitude": "18.46945000",
                        "longitude": "-77.89533000"
                    },
                    {
                        "id": 62954,
                        "name": "Rose Mount Garden",
                        "latitude": "18.46394000",
                        "longitude": "-77.89397000"
                    },
                    {
                        "id": 62956,
                        "name": "Rosemount",
                        "latitude": "18.47484000",
                        "longitude": "-77.89216000"
                    },
                    {
                        "id": 62965,
                        "name": "Salt Spring",
                        "latitude": "18.48687000",
                        "longitude": "-77.86554000"
                    },
                    {
                        "id": 62985,
                        "name": "Seven Rivers",
                        "latitude": "18.34702000",
                        "longitude": "-77.91378000"
                    },
                    {
                        "id": 63003,
                        "name": "Somerton",
                        "latitude": "18.40496000",
                        "longitude": "-77.77071000"
                    },
                    {
                        "id": 63010,
                        "name": "Spot Valley",
                        "latitude": "18.47869000",
                        "longitude": "-77.79106000"
                    },
                    {
                        "id": 63032,
                        "name": "Stonehenge",
                        "latitude": "18.24231000",
                        "longitude": "-77.85042000"
                    },
                    {
                        "id": 63039,
                        "name": "Summer Hill",
                        "latitude": "18.37360000",
                        "longitude": "-77.79350000"
                    },
                    {
                        "id": 63041,
                        "name": "Sunderland",
                        "latitude": "18.39794000",
                        "longitude": "-77.82734000"
                    },
                    {
                        "id": 63046,
                        "name": "Tangle River",
                        "latitude": "18.34337000",
                        "longitude": "-77.83621000"
                    },
                    {
                        "id": 63057,
                        "name": "Tower Hill\/Moy Hall",
                        "latitude": "18.44044000",
                        "longitude": "-77.96022000"
                    },
                    {
                        "id": 63070,
                        "name": "Tucker",
                        "latitude": "18.44900000",
                        "longitude": "-77.89438000"
                    },
                    {
                        "id": 63073,
                        "name": "Unity Hall",
                        "latitude": "18.43304000",
                        "longitude": "-77.97684000"
                    },
                    {
                        "id": 63075,
                        "name": "Vaughnsfield",
                        "latitude": "18.32135000",
                        "longitude": "-77.78051000"
                    },
                    {
                        "id": 63094,
                        "name": "Welcome Hall",
                        "latitude": "18.36898000",
                        "longitude": "-77.83673000"
                    },
                    {
                        "id": 63097,
                        "name": "West Green",
                        "latitude": "18.46244000",
                        "longitude": "-77.91757000"
                    }
                ]
            },
            {
                "id": 3747,
                "name": "Saint Mary",
                "iso2": "05",
                "latitude": "36.09252200",
                "longitude": "-95.97384400",
                "type": "parish",
                "cities": [
                    {
                        "id": 62309,
                        "name": "Amiel Town",
                        "latitude": "18.34027000",
                        "longitude": "-76.97612000"
                    },
                    {
                        "id": 62313,
                        "name": "Annotto Bay",
                        "latitude": "18.27170000",
                        "longitude": "-76.76523000"
                    },
                    {
                        "id": 62325,
                        "name": "Baileys Vale",
                        "latitude": "18.34527000",
                        "longitude": "-76.92593000"
                    },
                    {
                        "id": 62342,
                        "name": "Baxter Mountain",
                        "latitude": "18.20405000",
                        "longitude": "-76.77198000"
                    },
                    {
                        "id": 62347,
                        "name": "Belfield",
                        "latitude": "18.27347000",
                        "longitude": "-76.83574000"
                    },
                    {
                        "id": 62375,
                        "name": "Bonnygate",
                        "latitude": "18.32869000",
                        "longitude": "-76.94606000"
                    },
                    {
                        "id": 62383,
                        "name": "Brainerd",
                        "latitude": "18.16988000",
                        "longitude": "-76.86890000"
                    },
                    {
                        "id": 62392,
                        "name": "Broadgate",
                        "latitude": "18.22847000",
                        "longitude": "-76.80788000"
                    },
                    {
                        "id": 62414,
                        "name": "Camberwell",
                        "latitude": "18.23930000",
                        "longitude": "-76.78088000"
                    },
                    {
                        "id": 62421,
                        "name": "Carron Hall",
                        "latitude": "18.27797000",
                        "longitude": "-76.95246000"
                    },
                    {
                        "id": 62428,
                        "name": "Castleton",
                        "latitude": "18.17618000",
                        "longitude": "-76.78340000"
                    },
                    {
                        "id": 62448,
                        "name": "Charles Town",
                        "latitude": "18.38918000",
                        "longitude": "-77.03978000"
                    },
                    {
                        "id": 62459,
                        "name": "Clonmel",
                        "latitude": "18.24281000",
                        "longitude": "-76.83137000"
                    },
                    {
                        "id": 62511,
                        "name": "Devon Pen",
                        "latitude": "18.21561000",
                        "longitude": "-76.82440000"
                    },
                    {
                        "id": 62515,
                        "name": "Dover",
                        "latitude": "18.25534000",
                        "longitude": "-76.70811000"
                    },
                    {
                        "id": 62539,
                        "name": "Enfield",
                        "latitude": "18.22036000",
                        "longitude": "-76.73745000"
                    },
                    {
                        "id": 62541,
                        "name": "Epson",
                        "latitude": "18.25220000",
                        "longitude": "-76.72641000"
                    },
                    {
                        "id": 62559,
                        "name": "Flint River",
                        "latitude": "18.23790000",
                        "longitude": "-76.92173000"
                    },
                    {
                        "id": 62568,
                        "name": "Free Hill",
                        "latitude": "18.35439000",
                        "longitude": "-76.94317000"
                    },
                    {
                        "id": 62573,
                        "name": "Friendship Gap",
                        "latitude": "18.19719000",
                        "longitude": "-76.81960000"
                    },
                    {
                        "id": 62578,
                        "name": "Galina",
                        "latitude": "18.40265000",
                        "longitude": "-76.90041000"
                    },
                    {
                        "id": 62580,
                        "name": "Gayle",
                        "latitude": "18.34278000",
                        "longitude": "-77.00211000"
                    },
                    {
                        "id": 62619,
                        "name": "Guys Hill",
                        "latitude": "18.26243000",
                        "longitude": "-76.99561000"
                    },
                    {
                        "id": 62626,
                        "name": "Hampstead",
                        "latitude": "18.32051000",
                        "longitude": "-76.90477000"
                    },
                    {
                        "id": 62648,
                        "name": "Highgate",
                        "latitude": "18.27739000",
                        "longitude": "-76.89554000"
                    },
                    {
                        "id": 62666,
                        "name": "Islington",
                        "latitude": "18.32160000",
                        "longitude": "-76.84102000"
                    },
                    {
                        "id": 62668,
                        "name": "Jacks River",
                        "latitude": "18.37220000",
                        "longitude": "-76.94101000"
                    },
                    {
                        "id": 62671,
                        "name": "Jeffery Town",
                        "latitude": "18.28956000",
                        "longitude": "-77.00343000"
                    },
                    {
                        "id": 62698,
                        "name": "Labyrinth",
                        "latitude": "18.34419000",
                        "longitude": "-77.03227000"
                    },
                    {
                        "id": 62725,
                        "name": "Long Road",
                        "latitude": "18.21337000",
                        "longitude": "-76.75009000"
                    },
                    {
                        "id": 62734,
                        "name": "Lucky Hill",
                        "latitude": "18.30252000",
                        "longitude": "-77.01678000"
                    },
                    {
                        "id": 62747,
                        "name": "Mango Valley",
                        "latitude": "18.37481000",
                        "longitude": "-76.97694000"
                    },
                    {
                        "id": 62756,
                        "name": "Martin",
                        "latitude": "18.30118000",
                        "longitude": "-76.87257000"
                    },
                    {
                        "id": 62760,
                        "name": "Mason Hall",
                        "latitude": "18.39662000",
                        "longitude": "-76.92063000"
                    },
                    {
                        "id": 62774,
                        "name": "Mile Gully",
                        "latitude": "18.31801000",
                        "longitude": "-76.96051000"
                    },
                    {
                        "id": 62841,
                        "name": "Oracabessa",
                        "latitude": "18.40319000",
                        "longitude": "-76.94641000"
                    },
                    {
                        "id": 62893,
                        "name": "Port Maria",
                        "latitude": "18.36849000",
                        "longitude": "-76.88946000"
                    },
                    {
                        "id": 62906,
                        "name": "Prospect",
                        "latitude": "18.41273000",
                        "longitude": "-77.04119000"
                    },
                    {
                        "id": 62924,
                        "name": "Retreat",
                        "latitude": "18.37865000",
                        "longitude": "-77.01590000"
                    },
                    {
                        "id": 62928,
                        "name": "Richmond",
                        "latitude": "18.21113000",
                        "longitude": "-76.88301000"
                    },
                    {
                        "id": 62940,
                        "name": "Robins Bay",
                        "latitude": "18.31236000",
                        "longitude": "-76.81783000"
                    },
                    {
                        "id": 62967,
                        "name": "Sandside",
                        "latitude": "18.33888000",
                        "longitude": "-76.89551000"
                    },
                    {
                        "id": 62977,
                        "name": "Scotts Hall",
                        "latitude": "18.19083000",
                        "longitude": "-76.83942000"
                    },
                    {
                        "id": 63121,
                        "name": "Woodpark",
                        "latitude": "18.29734000",
                        "longitude": "-76.98114000"
                    },
                    {
                        "id": 63122,
                        "name": "Woodside",
                        "latitude": "18.25258000",
                        "longitude": "-76.92679000"
                    }
                ]
            },
            {
                "id": 3750,
                "name": "Saint Thomas",
                "iso2": "03",
                "latitude": "41.44253890",
                "longitude": "-81.74022180",
                "type": "parish",
                "cities": [
                    {
                        "id": 62296,
                        "name": "Airy Castle",
                        "latitude": "17.92506000",
                        "longitude": "-76.34216000"
                    },
                    {
                        "id": 62299,
                        "name": "Albion",
                        "latitude": "17.90119000",
                        "longitude": "-76.60761000"
                    },
                    {
                        "id": 62311,
                        "name": "Amity Hall",
                        "latitude": "17.96759000",
                        "longitude": "-76.25698000"
                    },
                    {
                        "id": 62314,
                        "name": "Arcadia",
                        "latitude": "17.92230000",
                        "longitude": "-76.30030000"
                    },
                    {
                        "id": 62332,
                        "name": "Baptist",
                        "latitude": "17.87666000",
                        "longitude": "-76.57837000"
                    },
                    {
                        "id": 62335,
                        "name": "Barking Lodge",
                        "latitude": "17.89279000",
                        "longitude": "-76.28922000"
                    },
                    {
                        "id": 62339,
                        "name": "Bath",
                        "latitude": "17.94820000",
                        "longitude": "-76.34916000"
                    },
                    {
                        "id": 62355,
                        "name": "Bethel",
                        "latitude": "17.98527000",
                        "longitude": "-76.58050000"
                    },
                    {
                        "id": 62438,
                        "name": "Cedar Valley",
                        "latitude": "18.02815000",
                        "longitude": "-76.59556000"
                    },
                    {
                        "id": 62455,
                        "name": "Church Corner",
                        "latitude": "17.88718000",
                        "longitude": "-76.41898000"
                    },
                    {
                        "id": 62500,
                        "name": "Dalvey",
                        "latitude": "17.90241000",
                        "longitude": "-76.25001000"
                    },
                    {
                        "id": 62502,
                        "name": "Danvers Pen",
                        "latitude": "17.92880000",
                        "longitude": "-76.47586000"
                    },
                    {
                        "id": 62522,
                        "name": "Duckenfield",
                        "latitude": "17.92205000",
                        "longitude": "-76.22657000"
                    },
                    {
                        "id": 62524,
                        "name": "Duhaney Pen",
                        "latitude": "17.89402000",
                        "longitude": "-76.43193000"
                    },
                    {
                        "id": 62529,
                        "name": "Easington",
                        "latitude": "17.92397000",
                        "longitude": "-76.58824000"
                    },
                    {
                        "id": 62535,
                        "name": "Eleven Miles",
                        "latitude": "17.93745000",
                        "longitude": "-76.64337000"
                    },
                    {
                        "id": 62561,
                        "name": "Font Hill",
                        "latitude": "17.94055000",
                        "longitude": "-76.51169000"
                    },
                    {
                        "id": 62592,
                        "name": "Golden Grove",
                        "latitude": "17.93361000",
                        "longitude": "-76.27254000"
                    },
                    {
                        "id": 62622,
                        "name": "Hagley Gap",
                        "latitude": "18.04845000",
                        "longitude": "-76.62777000"
                    },
                    {
                        "id": 62627,
                        "name": "Hampton Court",
                        "latitude": "17.91782000",
                        "longitude": "-76.26131000"
                    },
                    {
                        "id": 62639,
                        "name": "Hayfield",
                        "latitude": "17.98199000",
                        "longitude": "-76.36841000"
                    },
                    {
                        "id": 62649,
                        "name": "Hillside",
                        "latitude": "17.99619000",
                        "longitude": "-76.49082000"
                    },
                    {
                        "id": 62677,
                        "name": "Johns Town",
                        "latitude": "17.89659000",
                        "longitude": "-76.36136000"
                    },
                    {
                        "id": 62678,
                        "name": "Johnson Mountain",
                        "latitude": "17.98091000",
                        "longitude": "-76.31986000"
                    },
                    {
                        "id": 62680,
                        "name": "Jones Pen",
                        "latitude": "17.95068000",
                        "longitude": "-76.54775000"
                    },
                    {
                        "id": 62706,
                        "name": "Leith Hall",
                        "latitude": "17.87973000",
                        "longitude": "-76.34331000"
                    },
                    {
                        "id": 62719,
                        "name": "Llandewey",
                        "latitude": "17.94477000",
                        "longitude": "-76.62245000"
                    },
                    {
                        "id": 62721,
                        "name": "Lloyds",
                        "latitude": "17.91504000",
                        "longitude": "-76.54085000"
                    },
                    {
                        "id": 62735,
                        "name": "Lyssons",
                        "latitude": "17.88708000",
                        "longitude": "-76.37961000"
                    },
                    {
                        "id": 62772,
                        "name": "Middleton",
                        "latitude": "17.93971000",
                        "longitude": "-76.43558000"
                    },
                    {
                        "id": 62789,
                        "name": "Morant Bay",
                        "latitude": "17.88145000",
                        "longitude": "-76.40927000"
                    },
                    {
                        "id": 62797,
                        "name": "Mount Lebanus",
                        "latitude": "17.97544000",
                        "longitude": "-76.53891000"
                    },
                    {
                        "id": 62820,
                        "name": "New Monkland",
                        "latitude": "17.99158000",
                        "longitude": "-76.57333000"
                    },
                    {
                        "id": 62850,
                        "name": "Pamphret",
                        "latitude": "17.87570000",
                        "longitude": "-76.51736000"
                    },
                    {
                        "id": 62869,
                        "name": "Pear Tree",
                        "latitude": "17.91162000",
                        "longitude": "-76.31676000"
                    },
                    {
                        "id": 62891,
                        "name": "Poormans Corner",
                        "latitude": "17.89152000",
                        "longitude": "-76.58351000"
                    },
                    {
                        "id": 62894,
                        "name": "Port Morant",
                        "latitude": "17.89947000",
                        "longitude": "-76.34286000"
                    },
                    {
                        "id": 62907,
                        "name": "Prospect",
                        "latitude": "17.87404000",
                        "longitude": "-76.34956000"
                    },
                    {
                        "id": 62912,
                        "name": "Ramble",
                        "latitude": "17.96791000",
                        "longitude": "-76.62630000"
                    },
                    {
                        "id": 62925,
                        "name": "Retreat",
                        "latitude": "17.87760000",
                        "longitude": "-76.36795000"
                    },
                    {
                        "id": 62932,
                        "name": "Richmond Vale",
                        "latitude": "17.97435000",
                        "longitude": "-76.59044000"
                    },
                    {
                        "id": 62936,
                        "name": "River Head",
                        "latitude": "17.99237000",
                        "longitude": "-76.61082000"
                    },
                    {
                        "id": 62957,
                        "name": "Rowlandsfield",
                        "latitude": "17.97355000",
                        "longitude": "-76.28781000"
                    },
                    {
                        "id": 62980,
                        "name": "Seaforth",
                        "latitude": "17.94421000",
                        "longitude": "-76.45661000"
                    },
                    {
                        "id": 63001,
                        "name": "Somerset",
                        "latitude": "18.00976000",
                        "longitude": "-76.54595000"
                    },
                    {
                        "id": 63011,
                        "name": "Spring Bank",
                        "latitude": "17.95995000",
                        "longitude": "-76.32596000"
                    },
                    {
                        "id": 63012,
                        "name": "Spring Garden",
                        "latitude": "17.91749000",
                        "longitude": "-76.42978000"
                    },
                    {
                        "id": 63042,
                        "name": "Sunning Hill",
                        "latitude": "17.95612000",
                        "longitude": "-76.40931000"
                    },
                    {
                        "id": 63064,
                        "name": "Trinity Ville",
                        "latitude": "17.96076000",
                        "longitude": "-76.51427000"
                    },
                    {
                        "id": 63065,
                        "name": "Trinityville",
                        "latitude": "17.95720000",
                        "longitude": "-76.49420000"
                    },
                    {
                        "id": 63098,
                        "name": "Wheelerfield",
                        "latitude": "17.95874000",
                        "longitude": "-76.29623000"
                    },
                    {
                        "id": 63099,
                        "name": "White Hall",
                        "latitude": "17.99805000",
                        "longitude": "-76.43105000"
                    },
                    {
                        "id": 63101,
                        "name": "White Horses",
                        "latitude": "17.89620000",
                        "longitude": "-76.47076000"
                    },
                    {
                        "id": 63109,
                        "name": "Wilmington",
                        "latitude": "17.92856000",
                        "longitude": "-76.38962000"
                    },
                    {
                        "id": 63112,
                        "name": "Winchester",
                        "latitude": "17.94177000",
                        "longitude": "-76.29823000"
                    },
                    {
                        "id": 63124,
                        "name": "Yallahs",
                        "latitude": "17.87480000",
                        "longitude": "-76.56245000"
                    },
                    {
                        "id": 63125,
                        "name": "York",
                        "latitude": "17.92849000",
                        "longitude": "-76.43983000"
                    }
                ]
            },
            {
                "id": 3755,
                "name": "Trelawny",
                "iso2": "07",
                "latitude": "18.35261430",
                "longitude": "-77.60778650",
                "type": "parish",
                "cities": [
                    {
                        "id": 62297,
                        "name": "Albert Town",
                        "latitude": "18.29434000",
                        "longitude": "-77.54239000"
                    },
                    {
                        "id": 62306,
                        "name": "Alps",
                        "latitude": "18.35498000",
                        "longitude": "-77.50897000"
                    },
                    {
                        "id": 62379,
                        "name": "Bounty Hall",
                        "latitude": "18.45801000",
                        "longitude": "-77.71663000"
                    },
                    {
                        "id": 62384,
                        "name": "Brampton",
                        "latitude": "18.44262000",
                        "longitude": "-77.46424000"
                    },
                    {
                        "id": 62403,
                        "name": "Bunkers Hill",
                        "latitude": "18.36198000",
                        "longitude": "-77.68612000"
                    },
                    {
                        "id": 62457,
                        "name": "Clarks Town",
                        "latitude": "18.42244000",
                        "longitude": "-77.53328000"
                    },
                    {
                        "id": 62501,
                        "name": "Daniel Town",
                        "latitude": "18.46395000",
                        "longitude": "-77.61592000"
                    },
                    {
                        "id": 62505,
                        "name": "Deeside",
                        "latitude": "18.35976000",
                        "longitude": "-77.73721000"
                    },
                    {
                        "id": 62521,
                        "name": "Duanvale",
                        "latitude": "18.40267000",
                        "longitude": "-77.59615000"
                    },
                    {
                        "id": 62526,
                        "name": "Duncans",
                        "latitude": "18.46800000",
                        "longitude": "-77.53633000"
                    },
                    {
                        "id": 62550,
                        "name": "Falmouth",
                        "latitude": "18.49358000",
                        "longitude": "-77.65587000"
                    },
                    {
                        "id": 62569,
                        "name": "Freemans Hall",
                        "latitude": "18.28384000",
                        "longitude": "-77.50180000"
                    },
                    {
                        "id": 62605,
                        "name": "Granville",
                        "latitude": "18.45053000",
                        "longitude": "-77.68847000"
                    },
                    {
                        "id": 62625,
                        "name": "Hampden",
                        "latitude": "18.44217000",
                        "longitude": "-77.73203000"
                    },
                    {
                        "id": 62669,
                        "name": "Jackson Town",
                        "latitude": "18.41781000",
                        "longitude": "-77.48458000"
                    },
                    {
                        "id": 62674,
                        "name": "Joe Hut",
                        "latitude": "18.26742000",
                        "longitude": "-77.49616000"
                    },
                    {
                        "id": 62694,
                        "name": "Kinloss",
                        "latitude": "18.39641000",
                        "longitude": "-77.56968000"
                    },
                    {
                        "id": 62729,
                        "name": "Lorrimers",
                        "latitude": "18.23026000",
                        "longitude": "-77.49207000"
                    },
                    {
                        "id": 62755,
                        "name": "Martha Brae",
                        "latitude": "18.46960000",
                        "longitude": "-77.65909000"
                    },
                    {
                        "id": 62878,
                        "name": "Perth Town",
                        "latitude": "18.43106000",
                        "longitude": "-77.62583000"
                    },
                    {
                        "id": 62921,
                        "name": "Refuge",
                        "latitude": "18.45101000",
                        "longitude": "-77.57751000"
                    },
                    {
                        "id": 62933,
                        "name": "Rio Bueno",
                        "latitude": "18.46406000",
                        "longitude": "-77.48042000"
                    },
                    {
                        "id": 62963,
                        "name": "Salt Marsh",
                        "latitude": "18.48423000",
                        "longitude": "-77.71184000"
                    },
                    {
                        "id": 62966,
                        "name": "Samuels Prospect",
                        "latitude": "18.45103000",
                        "longitude": "-77.51440000"
                    },
                    {
                        "id": 62975,
                        "name": "Sawyers",
                        "latitude": "18.37880000",
                        "longitude": "-77.49689000"
                    },
                    {
                        "id": 62988,
                        "name": "Sherwood Content",
                        "latitude": "18.38227000",
                        "longitude": "-77.63643000"
                    },
                    {
                        "id": 63009,
                        "name": "Spicy Hill",
                        "latitude": "18.45763000",
                        "longitude": "-77.54751000"
                    },
                    {
                        "id": 63013,
                        "name": "Spring Garden",
                        "latitude": "18.29368000",
                        "longitude": "-77.56698000"
                    },
                    {
                        "id": 63027,
                        "name": "St. Vincent",
                        "latitude": "18.33424000",
                        "longitude": "-77.54790000"
                    },
                    {
                        "id": 63030,
                        "name": "Stettin",
                        "latitude": "18.28224000",
                        "longitude": "-77.54095000"
                    },
                    {
                        "id": 63031,
                        "name": "Stewart Town",
                        "latitude": "18.39887000",
                        "longitude": "-77.45187000"
                    },
                    {
                        "id": 63068,
                        "name": "Troy",
                        "latitude": "18.24924000",
                        "longitude": "-77.60978000"
                    },
                    {
                        "id": 63072,
                        "name": "Ulster Spring",
                        "latitude": "18.32113000",
                        "longitude": "-77.49681000"
                    },
                    {
                        "id": 63078,
                        "name": "Wait-A-Bit",
                        "latitude": "18.25332000",
                        "longitude": "-77.50837000"
                    },
                    {
                        "id": 63079,
                        "name": "Wakefield",
                        "latitude": "18.41460000",
                        "longitude": "-77.70908000"
                    },
                    {
                        "id": 63084,
                        "name": "Warsop",
                        "latitude": "18.26178000",
                        "longitude": "-77.56774000"
                    },
                    {
                        "id": 63110,
                        "name": "Wilson's Run",
                        "latitude": "18.28468000",
                        "longitude": "-77.69323000"
                    },
                    {
                        "id": 63116,
                        "name": "Wirefence",
                        "latitude": "18.25310000",
                        "longitude": "-77.53276000"
                    }
                ]
            },
            {
                "id": 3742,
                "name": "Westmoreland",
                "iso2": "10",
                "latitude": "18.29443780",
                "longitude": "-78.15644320",
                "type": "parish",
                "cities": [
                    {
                        "id": 62289,
                        "name": "12th Street",
                        "latitude": "18.21097000",
                        "longitude": "-78.13603000"
                    },
                    {
                        "id": 62310,
                        "name": "Amity",
                        "latitude": "18.27361000",
                        "longitude": "-77.89805000"
                    },
                    {
                        "id": 62320,
                        "name": "Ashton",
                        "latitude": "18.23139000",
                        "longitude": "-77.92074000"
                    },
                    {
                        "id": 62336,
                        "name": "Barneyside",
                        "latitude": "18.27670000",
                        "longitude": "-77.96964000"
                    },
                    {
                        "id": 62340,
                        "name": "Bath",
                        "latitude": "18.25734000",
                        "longitude": "-78.11751000"
                    },
                    {
                        "id": 62341,
                        "name": "Bath Mountain",
                        "latitude": "18.34428000",
                        "longitude": "-78.09928000"
                    },
                    {
                        "id": 62343,
                        "name": "Beaufort",
                        "latitude": "18.23417000",
                        "longitude": "-77.95007000"
                    },
                    {
                        "id": 62346,
                        "name": "Beeston Spring",
                        "latitude": "18.16012000",
                        "longitude": "-77.97545000"
                    },
                    {
                        "id": 62350,
                        "name": "Belvedere",
                        "latitude": "18.25219000",
                        "longitude": "-77.93208000"
                    },
                    {
                        "id": 62353,
                        "name": "Berkshire",
                        "latitude": "18.21293000",
                        "longitude": "-77.90373000"
                    },
                    {
                        "id": 62356,
                        "name": "Bethel Town",
                        "latitude": "18.29503000",
                        "longitude": "-77.95112000"
                    },
                    {
                        "id": 62359,
                        "name": "Big Bridge",
                        "latitude": "18.23318000",
                        "longitude": "-78.16717000"
                    },
                    {
                        "id": 62367,
                        "name": "Bluefields",
                        "latitude": "18.16602000",
                        "longitude": "-78.02702000"
                    },
                    {
                        "id": 62368,
                        "name": "Bog",
                        "latitude": "18.15631000",
                        "longitude": "-77.94364000"
                    },
                    {
                        "id": 62394,
                        "name": "Broughton",
                        "latitude": "18.21747000",
                        "longitude": "-78.22894000"
                    },
                    {
                        "id": 62404,
                        "name": "Burnt Savannah",
                        "latitude": "18.31676000",
                        "longitude": "-78.12628000"
                    },
                    {
                        "id": 62411,
                        "name": "Cairn Curran",
                        "latitude": "18.22840000",
                        "longitude": "-78.01130000"
                    },
                    {
                        "id": 62413,
                        "name": "Caledonia",
                        "latitude": "18.25866000",
                        "longitude": "-78.01173000"
                    },
                    {
                        "id": 62420,
                        "name": "Carmel",
                        "latitude": "18.17326000",
                        "longitude": "-77.93929000"
                    },
                    {
                        "id": 62434,
                        "name": "Cave",
                        "latitude": "18.21019000",
                        "longitude": "-78.04070000"
                    },
                    {
                        "id": 62445,
                        "name": "Chantilly",
                        "latitude": "18.23059000",
                        "longitude": "-78.12462000"
                    },
                    {
                        "id": 62475,
                        "name": "Content",
                        "latitude": "18.18288000",
                        "longitude": "-77.99915000"
                    },
                    {
                        "id": 62482,
                        "name": "Cornwall Mountian",
                        "latitude": "18.28722000",
                        "longitude": "-77.98674000"
                    },
                    {
                        "id": 62503,
                        "name": "Darliston",
                        "latitude": "18.23731000",
                        "longitude": "-77.97626000"
                    },
                    {
                        "id": 62508,
                        "name": "Delveland",
                        "latitude": "18.29709000",
                        "longitude": "-78.23962000"
                    },
                    {
                        "id": 62513,
                        "name": "Dillion Bigwoods",
                        "latitude": "18.20944000",
                        "longitude": "-77.99078000"
                    },
                    {
                        "id": 62527,
                        "name": "Dundee",
                        "latitude": "18.23679000",
                        "longitude": "-77.88698000"
                    },
                    {
                        "id": 62538,
                        "name": "Enfield",
                        "latitude": "18.21404000",
                        "longitude": "-77.95270000"
                    },
                    {
                        "id": 62553,
                        "name": "Ferris",
                        "latitude": "18.22265000",
                        "longitude": "-78.05588000"
                    },
                    {
                        "id": 62564,
                        "name": "Fort Williams",
                        "latitude": "18.29834000",
                        "longitude": "-78.06331000"
                    },
                    {
                        "id": 62574,
                        "name": "Frome",
                        "latitude": "18.27974000",
                        "longitude": "-78.14903000"
                    },
                    {
                        "id": 62576,
                        "name": "Fullersfield",
                        "latitude": "18.29890000",
                        "longitude": "-78.19976000"
                    },
                    {
                        "id": 62582,
                        "name": "Georges Plain",
                        "latitude": "18.27650000",
                        "longitude": "-78.13118000"
                    },
                    {
                        "id": 62596,
                        "name": "Gooden's River",
                        "latitude": "18.24223000",
                        "longitude": "-78.12840000"
                    },
                    {
                        "id": 62600,
                        "name": "Grange",
                        "latitude": "18.33161000",
                        "longitude": "-78.08036000"
                    },
                    {
                        "id": 62601,
                        "name": "Grange Hill",
                        "latitude": "18.33083000",
                        "longitude": "-78.18398000"
                    },
                    {
                        "id": 62621,
                        "name": "Haddo",
                        "latitude": "18.28606000",
                        "longitude": "-78.01893000"
                    },
                    {
                        "id": 62634,
                        "name": "Harmony Town",
                        "latitude": "18.21987000",
                        "longitude": "-78.13687000"
                    },
                    {
                        "id": 62645,
                        "name": "Hertford",
                        "latitude": "18.27181000",
                        "longitude": "-78.09078000"
                    },
                    {
                        "id": 62673,
                        "name": "Jerusalem",
                        "latitude": "18.32458000",
                        "longitude": "-78.21563000"
                    },
                    {
                        "id": 62688,
                        "name": "Kentucky",
                        "latitude": "18.19931000",
                        "longitude": "-78.01767000"
                    },
                    {
                        "id": 62690,
                        "name": "Kilmarnoch",
                        "latitude": "18.12407000",
                        "longitude": "-77.92774000"
                    },
                    {
                        "id": 62700,
                        "name": "Lambs River",
                        "latitude": "18.26823000",
                        "longitude": "-77.91414000"
                    },
                    {
                        "id": 62704,
                        "name": "Leamington",
                        "latitude": "18.21352000",
                        "longitude": "-77.92743000"
                    },
                    {
                        "id": 62707,
                        "name": "Lenox Bigwoods",
                        "latitude": "18.21392000",
                        "longitude": "-77.97214000"
                    },
                    {
                        "id": 62718,
                        "name": "Little London",
                        "latitude": "18.24523000",
                        "longitude": "-78.22653000"
                    },
                    {
                        "id": 62720,
                        "name": "Llandilo",
                        "latitude": "18.23439000",
                        "longitude": "-78.13895000"
                    },
                    {
                        "id": 62736,
                        "name": "Mackfield",
                        "latitude": "18.31163000",
                        "longitude": "-78.02471000"
                    },
                    {
                        "id": 62768,
                        "name": "Mearnsville",
                        "latitude": "18.18856000",
                        "longitude": "-78.02870000"
                    },
                    {
                        "id": 62792,
                        "name": "Mount Airy",
                        "latitude": "18.24738000",
                        "longitude": "-78.32279000"
                    },
                    {
                        "id": 62802,
                        "name": "Mount Stewart",
                        "latitude": "18.30411000",
                        "longitude": "-77.99274000"
                    },
                    {
                        "id": 62811,
                        "name": "Negril",
                        "latitude": "18.26844000",
                        "longitude": "-78.34810000"
                    },
                    {
                        "id": 62819,
                        "name": "New Market Oval",
                        "latitude": "18.21370000",
                        "longitude": "-78.13813000"
                    },
                    {
                        "id": 62821,
                        "name": "New Roads",
                        "latitude": "18.19124000",
                        "longitude": "-77.93608000"
                    },
                    {
                        "id": 62822,
                        "name": "New Works",
                        "latitude": "18.17248000",
                        "longitude": "-77.96645000"
                    },
                    {
                        "id": 62845,
                        "name": "Orange Hill",
                        "latitude": "18.23418000",
                        "longitude": "-78.30277000"
                    },
                    {
                        "id": 62868,
                        "name": "Paul Island",
                        "latitude": "18.27200000",
                        "longitude": "-78.18614000"
                    },
                    {
                        "id": 62879,
                        "name": "Petersfield",
                        "latitude": "18.26588000",
                        "longitude": "-78.05755000"
                    },
                    {
                        "id": 62880,
                        "name": "Petersville",
                        "latitude": "18.13700000",
                        "longitude": "-77.95046000"
                    },
                    {
                        "id": 62896,
                        "name": "Porters Mountain",
                        "latitude": "18.32909000",
                        "longitude": "-78.04910000"
                    },
                    {
                        "id": 62916,
                        "name": "Red Hills",
                        "latitude": "18.30550000",
                        "longitude": "-78.11280000"
                    },
                    {
                        "id": 62927,
                        "name": "Revival",
                        "latitude": "18.24255000",
                        "longitude": "-78.28437000"
                    },
                    {
                        "id": 62939,
                        "name": "Roaring River",
                        "latitude": "18.30118000",
                        "longitude": "-78.04324000"
                    },
                    {
                        "id": 62961,
                        "name": "Russia",
                        "latitude": "18.21649000",
                        "longitude": "-78.12361000"
                    },
                    {
                        "id": 62973,
                        "name": "Savanna-la-Mar",
                        "latitude": "18.21895000",
                        "longitude": "-78.13320000"
                    },
                    {
                        "id": 62974,
                        "name": "Savannah-la-mar Business Dist.",
                        "latitude": "18.21962000",
                        "longitude": "-78.13034000"
                    },
                    {
                        "id": 62979,
                        "name": "Seaford Town",
                        "latitude": "18.24339000",
                        "longitude": "-77.90504000"
                    },
                    {
                        "id": 62981,
                        "name": "Seaton Crescent",
                        "latitude": "18.21675000",
                        "longitude": "-78.13603000"
                    },
                    {
                        "id": 62987,
                        "name": "Shefield",
                        "latitude": "18.28412000",
                        "longitude": "-78.29169000"
                    },
                    {
                        "id": 62991,
                        "name": "Shoalin Grotto",
                        "latitude": "18.22059000",
                        "longitude": "-78.14019000"
                    },
                    {
                        "id": 62997,
                        "name": "Smithfield",
                        "latitude": "18.22275000",
                        "longitude": "-78.08785000"
                    },
                    {
                        "id": 63023,
                        "name": "St. Leonards",
                        "latitude": "18.25533000",
                        "longitude": "-77.88889000"
                    },
                    {
                        "id": 63034,
                        "name": "Strathbogie",
                        "latitude": "18.23855000",
                        "longitude": "-78.11714000"
                    },
                    {
                        "id": 63035,
                        "name": "Strawberry",
                        "latitude": "18.30676000",
                        "longitude": "-78.08945000"
                    },
                    {
                        "id": 63036,
                        "name": "Struie",
                        "latitude": "18.25317000",
                        "longitude": "-77.95656000"
                    },
                    {
                        "id": 63050,
                        "name": "Three Mile River",
                        "latitude": "18.25706000",
                        "longitude": "-78.14275000"
                    },
                    {
                        "id": 63058,
                        "name": "Town Head",
                        "latitude": "18.33898000",
                        "longitude": "-78.13569000"
                    },
                    {
                        "id": 63069,
                        "name": "Truro",
                        "latitude": "18.31301000",
                        "longitude": "-78.15489000"
                    },
                    {
                        "id": 63088,
                        "name": "Water Works",
                        "latitude": "18.23319000",
                        "longitude": "-78.04296000"
                    },
                    {
                        "id": 63103,
                        "name": "Whitehouse",
                        "latitude": "18.10275000",
                        "longitude": "-77.95697000"
                    },
                    {
                        "id": 63105,
                        "name": "Whithorn",
                        "latitude": "18.27111000",
                        "longitude": "-78.03811000"
                    },
                    {
                        "id": 63106,
                        "name": "Williamsfield",
                        "latitude": "18.33393000",
                        "longitude": "-78.06957000"
                    }
                ]
            }
        ]
    },
    {
        "id": 109,
        "name": "Japan",
        "iso3": "JPN",
        "iso2": "JP",
        "numeric_code": "392",
        "phonecode": "81",
        "capital": "Tokyo",
        "currency": "JPY",
        "currency_name": "Japanese yen",
        "currency_symbol": "¥",
        "tld": ".jp",
        "native": "日本",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Eastern Asia",
        "subregion_id": 12,
        "nationality": "Japanese",
        "timezones": [
            {
                "zoneName": "Asia\/Tokyo",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "JST",
                "tzName": "Japan Standard Time"
            }
        ],
        "translations": {
            "br": "Japan",
            "ko": "일본",
            "pt-BR": "Japão",
            "pt": "Japão",
            "nl": "Japan",
            "hr": "Japan",
            "fa": "ژاپن",
            "de": "Japan",
            "es": "Japón",
            "fr": "Japon",
            "ja": "日本",
            "it": "Giappone",
            "zh-CN": "日本",
            "tr": "Japonya",
            "ru": "Япония",
            "uk": "Японія",
            "pl": "Japonia"
        },
        "latitude": "36.00000000",
        "longitude": "138.00000000",
        "emoji": "🇯🇵",
        "emojiU": "U+1F1EF U+1F1F5",
        "states": [
            {
                "id": 827,
                "name": "Aichi",
                "iso2": "23",
                "latitude": "35.01825050",
                "longitude": "137.29238930",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63223,
                        "name": "Aisai-shi",
                        "latitude": "35.17234000",
                        "longitude": "136.69478000"
                    },
                    {
                        "id": 63237,
                        "name": "Ama-gun",
                        "latitude": "35.17174000",
                        "longitude": "136.82308000"
                    },
                    {
                        "id": 63246,
                        "name": "Anjō-shi",
                        "latitude": "34.94341000",
                        "longitude": "137.07165000"
                    },
                    {
                        "id": 63305,
                        "name": "Chiryū",
                        "latitude": "35.00000000",
                        "longitude": "137.03333000"
                    },
                    {
                        "id": 63306,
                        "name": "Chiryū-shi",
                        "latitude": "34.99862000",
                        "longitude": "137.05000000"
                    },
                    {
                        "id": 63307,
                        "name": "Chita",
                        "latitude": "35.00267000",
                        "longitude": "136.86420000"
                    },
                    {
                        "id": 63308,
                        "name": "Chita-shi",
                        "latitude": "34.97048000",
                        "longitude": "136.86490000"
                    },
                    {
                        "id": 63382,
                        "name": "Gamagōri",
                        "latitude": "34.83333000",
                        "longitude": "137.23333000"
                    },
                    {
                        "id": 63383,
                        "name": "Gamagōri-shi",
                        "latitude": "34.82759000",
                        "longitude": "137.22752000"
                    },
                    {
                        "id": 63433,
                        "name": "Handa",
                        "latitude": "34.88333000",
                        "longitude": "136.93333000"
                    },
                    {
                        "id": 63434,
                        "name": "Handa-shi",
                        "latitude": "34.89903000",
                        "longitude": "136.92660000"
                    },
                    {
                        "id": 63453,
                        "name": "Hekinan",
                        "latitude": "34.88333000",
                        "longitude": "136.98333000"
                    },
                    {
                        "id": 63454,
                        "name": "Hekinan-shi",
                        "latitude": "34.87955000",
                        "longitude": "136.99155000"
                    },
                    {
                        "id": 63542,
                        "name": "Ichinomiya",
                        "latitude": "35.30000000",
                        "longitude": "136.80000000"
                    },
                    {
                        "id": 63543,
                        "name": "Ichinomiya-shi",
                        "latitude": "35.31037000",
                        "longitude": "136.79237000"
                    },
                    {
                        "id": 63573,
                        "name": "Inazawa",
                        "latitude": "35.25000000",
                        "longitude": "136.78333000"
                    },
                    {
                        "id": 63574,
                        "name": "Inazawa-shi",
                        "latitude": "35.24814000",
                        "longitude": "136.77979000"
                    },
                    {
                        "id": 63576,
                        "name": "Inuyama",
                        "latitude": "35.37995000",
                        "longitude": "136.94295000"
                    },
                    {
                        "id": 63577,
                        "name": "Inuyama-shi",
                        "latitude": "35.36232000",
                        "longitude": "136.98072000"
                    },
                    {
                        "id": 63598,
                        "name": "Ishiki",
                        "latitude": "34.80000000",
                        "longitude": "137.01667000"
                    },
                    {
                        "id": 63624,
                        "name": "Iwakura",
                        "latitude": "35.28333000",
                        "longitude": "136.86667000"
                    },
                    {
                        "id": 63625,
                        "name": "Iwakura-shi",
                        "latitude": "35.27927000",
                        "longitude": "136.86885000"
                    },
                    {
                        "id": 63711,
                        "name": "Kanie",
                        "latitude": "35.13333000",
                        "longitude": "136.80000000"
                    },
                    {
                        "id": 63723,
                        "name": "Kariya",
                        "latitude": "34.98333000",
                        "longitude": "136.98333000"
                    },
                    {
                        "id": 63725,
                        "name": "Kariya-shi",
                        "latitude": "35.01098000",
                        "longitude": "137.00166000"
                    },
                    {
                        "id": 63745,
                        "name": "Kasugai",
                        "latitude": "35.24762000",
                        "longitude": "136.97229000"
                    },
                    {
                        "id": 63746,
                        "name": "Kasugai-shi",
                        "latitude": "35.24762000",
                        "longitude": "136.97226000"
                    },
                    {
                        "id": 63811,
                        "name": "Kitanagoya",
                        "latitude": "35.24702000",
                        "longitude": "136.87832000"
                    },
                    {
                        "id": 63812,
                        "name": "Kitanagoya-shi",
                        "latitude": "35.24640000",
                        "longitude": "136.87293000"
                    },
                    {
                        "id": 63816,
                        "name": "Kiyosu-shi",
                        "latitude": "35.21325000",
                        "longitude": "136.84771000"
                    },
                    {
                        "id": 63835,
                        "name": "Komaki",
                        "latitude": "35.28333000",
                        "longitude": "136.91667000"
                    },
                    {
                        "id": 63836,
                        "name": "Komaki-shi",
                        "latitude": "35.29103000",
                        "longitude": "136.91196000"
                    },
                    {
                        "id": 63896,
                        "name": "Kōnan",
                        "latitude": "35.33165000",
                        "longitude": "136.87042000"
                    },
                    {
                        "id": 63897,
                        "name": "Kōnan-shi",
                        "latitude": "35.33137000",
                        "longitude": "136.87077000"
                    },
                    {
                        "id": 63850,
                        "name": "Kozakai-chō",
                        "latitude": "34.80000000",
                        "longitude": "137.35889000"
                    },
                    {
                        "id": 63875,
                        "name": "Kuroda",
                        "latitude": "35.35000000",
                        "longitude": "136.78333000"
                    },
                    {
                        "id": 64017,
                        "name": "Miyoshi-shi",
                        "latitude": "35.09480000",
                        "longitude": "137.08870000"
                    },
                    {
                        "id": 64063,
                        "name": "Nagakute-shi",
                        "latitude": "35.18335000",
                        "longitude": "137.04895000"
                    },
                    {
                        "id": 64078,
                        "name": "Nagoya",
                        "latitude": "35.18147000",
                        "longitude": "136.90641000"
                    },
                    {
                        "id": 64152,
                        "name": "Nishio",
                        "latitude": "34.86667000",
                        "longitude": "137.05000000"
                    },
                    {
                        "id": 64153,
                        "name": "Nishio-shi",
                        "latitude": "34.86223000",
                        "longitude": "137.05433000"
                    },
                    {
                        "id": 64158,
                        "name": "Nisshin-shi",
                        "latitude": "35.13114000",
                        "longitude": "137.03934000"
                    },
                    {
                        "id": 64715,
                        "name": "Ōbu",
                        "latitude": "35.01756000",
                        "longitude": "136.94947000"
                    },
                    {
                        "id": 64716,
                        "name": "Ōbu-shi",
                        "latitude": "35.01920000",
                        "longitude": "136.95424000"
                    },
                    {
                        "id": 64197,
                        "name": "Okazaki-shi",
                        "latitude": "34.95245000",
                        "longitude": "137.25783000"
                    },
                    {
                        "id": 64218,
                        "name": "Owariasahi-shi",
                        "latitude": "35.21652000",
                        "longitude": "137.03542000"
                    },
                    {
                        "id": 64304,
                        "name": "Seto",
                        "latitude": "35.23333000",
                        "longitude": "137.10000000"
                    },
                    {
                        "id": 64305,
                        "name": "Seto-shi",
                        "latitude": "35.22340000",
                        "longitude": "137.08414000"
                    },
                    {
                        "id": 64345,
                        "name": "Shinshiro",
                        "latitude": "34.90000000",
                        "longitude": "137.50000000"
                    },
                    {
                        "id": 64346,
                        "name": "Shinshiro-shi",
                        "latitude": "34.96073000",
                        "longitude": "137.54360000"
                    },
                    {
                        "id": 64372,
                        "name": "Sobue",
                        "latitude": "35.25000000",
                        "longitude": "136.71667000"
                    },
                    {
                        "id": 64410,
                        "name": "Tahara",
                        "latitude": "34.66667000",
                        "longitude": "137.26667000"
                    },
                    {
                        "id": 64411,
                        "name": "Tahara-shi",
                        "latitude": "34.64140000",
                        "longitude": "137.18314000"
                    },
                    {
                        "id": 64420,
                        "name": "Takahama",
                        "latitude": "34.91667000",
                        "longitude": "136.98333000"
                    },
                    {
                        "id": 64421,
                        "name": "Takahama-shi",
                        "latitude": "34.93337000",
                        "longitude": "136.99490000"
                    },
                    {
                        "id": 64450,
                        "name": "Taketoyo",
                        "latitude": "34.85000000",
                        "longitude": "136.91667000"
                    },
                    {
                        "id": 64568,
                        "name": "Tōkai-shi",
                        "latitude": "35.02676000",
                        "longitude": "136.89846000"
                    },
                    {
                        "id": 64493,
                        "name": "Tokoname",
                        "latitude": "34.88333000",
                        "longitude": "136.85000000"
                    },
                    {
                        "id": 64494,
                        "name": "Tokoname-shi",
                        "latitude": "34.88929000",
                        "longitude": "136.85299000"
                    },
                    {
                        "id": 64522,
                        "name": "Toyoake",
                        "latitude": "35.03800000",
                        "longitude": "136.99931000"
                    },
                    {
                        "id": 64523,
                        "name": "Toyoake-shi",
                        "latitude": "35.06248000",
                        "longitude": "137.00887000"
                    },
                    {
                        "id": 64524,
                        "name": "Toyohama",
                        "latitude": "34.70933000",
                        "longitude": "136.93425000"
                    },
                    {
                        "id": 64525,
                        "name": "Toyohashi",
                        "latitude": "34.76667000",
                        "longitude": "137.38333000"
                    },
                    {
                        "id": 64526,
                        "name": "Toyohashi-shi",
                        "latitude": "34.74050000",
                        "longitude": "137.40714000"
                    },
                    {
                        "id": 64527,
                        "name": "Toyokawa",
                        "latitude": "34.81667000",
                        "longitude": "137.40000000"
                    },
                    {
                        "id": 64528,
                        "name": "Toyokawa-shi",
                        "latitude": "34.85032000",
                        "longitude": "137.36175000"
                    },
                    {
                        "id": 64534,
                        "name": "Toyota-shi",
                        "latitude": "35.08700000",
                        "longitude": "137.15000000"
                    },
                    {
                        "id": 64560,
                        "name": "Tsushima",
                        "latitude": "35.16667000",
                        "longitude": "136.71667000"
                    },
                    {
                        "id": 64562,
                        "name": "Tsushima-shi",
                        "latitude": "35.17718000",
                        "longitude": "136.74168000"
                    },
                    {
                        "id": 64662,
                        "name": "Yatomi-shi",
                        "latitude": "35.10938000",
                        "longitude": "136.72451000"
                    }
                ]
            },
            {
                "id": 829,
                "name": "Akita",
                "iso2": "05",
                "latitude": "40.13762930",
                "longitude": "140.33434100",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63233,
                        "name": "Akita",
                        "latitude": "39.71667000",
                        "longitude": "140.11667000"
                    },
                    {
                        "id": 63234,
                        "name": "Akita Shi",
                        "latitude": "39.71043000",
                        "longitude": "140.23207000"
                    },
                    {
                        "id": 63318,
                        "name": "Daisen",
                        "latitude": "39.44116000",
                        "longitude": "140.48961000"
                    },
                    {
                        "id": 63319,
                        "name": "Daisen-shi",
                        "latitude": "39.53710000",
                        "longitude": "140.44139000"
                    },
                    {
                        "id": 63432,
                        "name": "Hanawa",
                        "latitude": "40.18361000",
                        "longitude": "140.78722000"
                    },
                    {
                        "id": 63675,
                        "name": "Kakunodatemachi",
                        "latitude": "39.58926000",
                        "longitude": "140.56724000"
                    },
                    {
                        "id": 63751,
                        "name": "Katagami",
                        "latitude": "39.87869000",
                        "longitude": "139.99767000"
                    },
                    {
                        "id": 63752,
                        "name": "Katagami-shi",
                        "latitude": "39.87209000",
                        "longitude": "140.04910000"
                    },
                    {
                        "id": 63780,
                        "name": "Kazuno Shi",
                        "latitude": "40.21035000",
                        "longitude": "140.83030000"
                    },
                    {
                        "id": 63798,
                        "name": "Kitaakita-shi",
                        "latitude": "40.23446000",
                        "longitude": "140.39978000"
                    },
                    {
                        "id": 64137,
                        "name": "Nikaho-shi",
                        "latitude": "39.19677000",
                        "longitude": "139.97305000"
                    },
                    {
                        "id": 64168,
                        "name": "Noshiro",
                        "latitude": "40.20838000",
                        "longitude": "140.02740000"
                    },
                    {
                        "id": 64169,
                        "name": "Noshiro Shi",
                        "latitude": "40.20289000",
                        "longitude": "140.14486000"
                    },
                    {
                        "id": 64719,
                        "name": "Ōdate",
                        "latitude": "40.27178000",
                        "longitude": "140.55756000"
                    },
                    {
                        "id": 64720,
                        "name": "Ōdate-shi",
                        "latitude": "40.30000000",
                        "longitude": "140.55000000"
                    },
                    {
                        "id": 64185,
                        "name": "Oga",
                        "latitude": "39.87100000",
                        "longitude": "139.84926000"
                    },
                    {
                        "id": 64186,
                        "name": "Oga-shi",
                        "latitude": "39.93793000",
                        "longitude": "139.83611000"
                    },
                    {
                        "id": 64736,
                        "name": "Ōmagari",
                        "latitude": "39.45000000",
                        "longitude": "140.48333000"
                    },
                    {
                        "id": 64299,
                        "name": "Semboku-shi",
                        "latitude": "39.75709000",
                        "longitude": "140.66998000"
                    },
                    {
                        "id": 64430,
                        "name": "Takanosu",
                        "latitude": "40.22268000",
                        "longitude": "140.36611000"
                    },
                    {
                        "id": 64482,
                        "name": "Tennō",
                        "latitude": "39.90000000",
                        "longitude": "139.96667000"
                    },
                    {
                        "id": 64674,
                        "name": "Yokote",
                        "latitude": "39.31691000",
                        "longitude": "140.55034000"
                    },
                    {
                        "id": 64675,
                        "name": "Yokote-shi",
                        "latitude": "39.28369000",
                        "longitude": "140.54432000"
                    },
                    {
                        "id": 64698,
                        "name": "Yurihonjō",
                        "latitude": "39.38950000",
                        "longitude": "140.05813000"
                    },
                    {
                        "id": 64699,
                        "name": "Yurihonjō-shi",
                        "latitude": "39.29336000",
                        "longitude": "140.16498000"
                    },
                    {
                        "id": 64701,
                        "name": "Yuzawa",
                        "latitude": "39.16667000",
                        "longitude": "140.50000000"
                    },
                    {
                        "id": 64702,
                        "name": "Yuzawa-shi",
                        "latitude": "39.03658000",
                        "longitude": "140.54267000"
                    }
                ]
            },
            {
                "id": 839,
                "name": "Aomori",
                "iso2": "02",
                "latitude": "40.76570770",
                "longitude": "140.91758790",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63249,
                        "name": "Aomori",
                        "latitude": "40.81667000",
                        "longitude": "140.73333000"
                    },
                    {
                        "id": 63250,
                        "name": "Aomori Shi",
                        "latitude": "40.77001000",
                        "longitude": "140.75423000"
                    },
                    {
                        "id": 63394,
                        "name": "Goshogawara",
                        "latitude": "40.80444000",
                        "longitude": "140.44139000"
                    },
                    {
                        "id": 63395,
                        "name": "Goshogawara Shi",
                        "latitude": "40.91657000",
                        "longitude": "140.46998000"
                    },
                    {
                        "id": 63408,
                        "name": "Hachinohe",
                        "latitude": "40.50000000",
                        "longitude": "141.50000000"
                    },
                    {
                        "id": 63409,
                        "name": "Hachinohe Shi",
                        "latitude": "40.47389000",
                        "longitude": "141.48125000"
                    },
                    {
                        "id": 63491,
                        "name": "Hirakawa",
                        "latitude": "40.58728000",
                        "longitude": "140.57107000"
                    },
                    {
                        "id": 63492,
                        "name": "Hirakawa Shi",
                        "latitude": "40.51832000",
                        "longitude": "140.70048000"
                    },
                    {
                        "id": 63497,
                        "name": "Hirosaki",
                        "latitude": "40.59306000",
                        "longitude": "140.47250000"
                    },
                    {
                        "id": 63498,
                        "name": "Hirosaki Shi",
                        "latitude": "40.60512000",
                        "longitude": "140.38460000"
                    },
                    {
                        "id": 63876,
                        "name": "Kuroishi",
                        "latitude": "40.64581000",
                        "longitude": "140.58354000"
                    },
                    {
                        "id": 63877,
                        "name": "Kuroishi Shi",
                        "latitude": "40.61709000",
                        "longitude": "140.70467000"
                    },
                    {
                        "id": 63983,
                        "name": "Misawa",
                        "latitude": "40.68682000",
                        "longitude": "141.38969000"
                    },
                    {
                        "id": 63984,
                        "name": "Misawa Shi",
                        "latitude": "40.74647000",
                        "longitude": "141.38124000"
                    },
                    {
                        "id": 64054,
                        "name": "Mutsu",
                        "latitude": "41.28944000",
                        "longitude": "141.21694000"
                    },
                    {
                        "id": 64055,
                        "name": "Mutsu-shi",
                        "latitude": "41.29090000",
                        "longitude": "141.03327000"
                    },
                    {
                        "id": 64098,
                        "name": "Namioka",
                        "latitude": "40.71069000",
                        "longitude": "140.59048000"
                    },
                    {
                        "id": 64333,
                        "name": "Shimokizukuri",
                        "latitude": "40.81609000",
                        "longitude": "140.37539000"
                    },
                    {
                        "id": 64520,
                        "name": "Towada Shi",
                        "latitude": "40.56736000",
                        "longitude": "141.05794000"
                    },
                    {
                        "id": 64541,
                        "name": "Tsugaru",
                        "latitude": "40.80357000",
                        "longitude": "140.40299000"
                    },
                    {
                        "id": 64542,
                        "name": "Tsugaru Shi",
                        "latitude": "40.86988000",
                        "longitude": "140.34963000"
                    }
                ]
            },
            {
                "id": 821,
                "name": "Chiba",
                "iso2": "12",
                "latitude": "35.33541550",
                "longitude": "140.18325160",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63213,
                        "name": "Abiko",
                        "latitude": "35.86667000",
                        "longitude": "140.01667000"
                    },
                    {
                        "id": 63214,
                        "name": "Abiko-shi",
                        "latitude": "35.86947000",
                        "longitude": "140.06510000"
                    },
                    {
                        "id": 63258,
                        "name": "Asahi-shi",
                        "latitude": "35.73443000",
                        "longitude": "140.65549000"
                    },
                    {
                        "id": 63293,
                        "name": "Chiba",
                        "latitude": "35.60000000",
                        "longitude": "140.11667000"
                    },
                    {
                        "id": 63314,
                        "name": "Chōshi-shi",
                        "latitude": "35.74303000",
                        "longitude": "140.77552000"
                    },
                    {
                        "id": 63375,
                        "name": "Funabashi-shi",
                        "latitude": "35.69455000",
                        "longitude": "139.98255000"
                    },
                    {
                        "id": 63381,
                        "name": "Futtsu",
                        "latitude": "35.31080000",
                        "longitude": "139.81877000"
                    },
                    {
                        "id": 63441,
                        "name": "Hasaki",
                        "latitude": "35.73333000",
                        "longitude": "140.83333000"
                    },
                    {
                        "id": 63520,
                        "name": "Honchō",
                        "latitude": "35.70129000",
                        "longitude": "139.98648000"
                    },
                    {
                        "id": 63537,
                        "name": "Ichihara",
                        "latitude": "35.51667000",
                        "longitude": "140.08333000"
                    },
                    {
                        "id": 63538,
                        "name": "Ichihara Shi",
                        "latitude": "35.42484000",
                        "longitude": "140.13725000"
                    },
                    {
                        "id": 63539,
                        "name": "Ichikawa Shi",
                        "latitude": "35.71865000",
                        "longitude": "139.93294000"
                    },
                    {
                        "id": 63578,
                        "name": "Inzai-shi",
                        "latitude": "35.81207000",
                        "longitude": "140.14098000"
                    },
                    {
                        "id": 63603,
                        "name": "Isumi",
                        "latitude": "35.23005000",
                        "longitude": "140.40492000"
                    },
                    {
                        "id": 63604,
                        "name": "Isumi Shi",
                        "latitude": "35.27777000",
                        "longitude": "140.34335000"
                    },
                    {
                        "id": 63677,
                        "name": "Kamagaya Shi",
                        "latitude": "35.77289000",
                        "longitude": "139.99883000"
                    },
                    {
                        "id": 63702,
                        "name": "Kamogawa",
                        "latitude": "35.09690000",
                        "longitude": "140.10030000"
                    },
                    {
                        "id": 63703,
                        "name": "Kamogawa-shi",
                        "latitude": "35.10000000",
                        "longitude": "140.10000000"
                    },
                    {
                        "id": 63739,
                        "name": "Kashiwa",
                        "latitude": "35.86224000",
                        "longitude": "139.97732000"
                    },
                    {
                        "id": 63740,
                        "name": "Kashiwa Shi",
                        "latitude": "35.86017000",
                        "longitude": "139.99386000"
                    },
                    {
                        "id": 63754,
                        "name": "Katori-shi",
                        "latitude": "35.88333000",
                        "longitude": "140.51667000"
                    },
                    {
                        "id": 63760,
                        "name": "Katsuura",
                        "latitude": "35.14621000",
                        "longitude": "140.31507000"
                    },
                    {
                        "id": 63762,
                        "name": "Katsuura-shi",
                        "latitude": "35.17535000",
                        "longitude": "140.26760000"
                    },
                    {
                        "id": 63787,
                        "name": "Kimitsu",
                        "latitude": "35.35043000",
                        "longitude": "139.87029000"
                    },
                    {
                        "id": 63793,
                        "name": "Kisarazu",
                        "latitude": "35.38329000",
                        "longitude": "139.93254000"
                    },
                    {
                        "id": 63794,
                        "name": "Kisarazu Shi",
                        "latitude": "35.36981000",
                        "longitude": "139.98749000"
                    },
                    {
                        "id": 63932,
                        "name": "Matsudo Shi",
                        "latitude": "35.79574000",
                        "longitude": "139.92908000"
                    },
                    {
                        "id": 63966,
                        "name": "Minamibōsō Shi",
                        "latitude": "35.03657000",
                        "longitude": "139.92847000"
                    },
                    {
                        "id": 64022,
                        "name": "Mobara",
                        "latitude": "35.42583000",
                        "longitude": "140.29608000"
                    },
                    {
                        "id": 64023,
                        "name": "Mobara Shi",
                        "latitude": "35.44981000",
                        "longitude": "140.30163000"
                    },
                    {
                        "id": 64069,
                        "name": "Nagareyama",
                        "latitude": "35.85630000",
                        "longitude": "139.90266000"
                    },
                    {
                        "id": 64070,
                        "name": "Nagareyama-shi",
                        "latitude": "35.85631000",
                        "longitude": "139.90266000"
                    },
                    {
                        "id": 64107,
                        "name": "Narashino-shi",
                        "latitude": "35.68091000",
                        "longitude": "140.03418000"
                    },
                    {
                        "id": 64108,
                        "name": "Narita",
                        "latitude": "35.78333000",
                        "longitude": "140.31667000"
                    },
                    {
                        "id": 64109,
                        "name": "Narita-shi",
                        "latitude": "35.81547000",
                        "longitude": "140.35757000"
                    },
                    {
                        "id": 64112,
                        "name": "Narutō",
                        "latitude": "35.60000000",
                        "longitude": "140.41667000"
                    },
                    {
                        "id": 64163,
                        "name": "Noda",
                        "latitude": "35.94897000",
                        "longitude": "139.86793000"
                    },
                    {
                        "id": 64164,
                        "name": "Noda-shi",
                        "latitude": "35.98516000",
                        "longitude": "139.86215000"
                    },
                    {
                        "id": 64712,
                        "name": "Ōami",
                        "latitude": "35.51667000",
                        "longitude": "140.31667000"
                    },
                    {
                        "id": 64713,
                        "name": "Ōamishirasato-shi",
                        "latitude": "35.51279000",
                        "longitude": "140.34295000"
                    },
                    {
                        "id": 64724,
                        "name": "Ōhara",
                        "latitude": "35.24761000",
                        "longitude": "140.39289000"
                    },
                    {
                        "id": 64204,
                        "name": "Omigawa",
                        "latitude": "35.85000000",
                        "longitude": "140.61667000"
                    },
                    {
                        "id": 64268,
                        "name": "Sakura",
                        "latitude": "35.71667000",
                        "longitude": "140.23333000"
                    },
                    {
                        "id": 64269,
                        "name": "Sakura-shi",
                        "latitude": "35.70619000",
                        "longitude": "140.21326000"
                    },
                    {
                        "id": 64275,
                        "name": "Sambu-gun",
                        "latitude": "35.68843000",
                        "longitude": "140.45346000"
                    },
                    {
                        "id": 64279,
                        "name": "Sanmu",
                        "latitude": "35.62756000",
                        "longitude": "140.41762000"
                    },
                    {
                        "id": 64280,
                        "name": "Sanmu-shi",
                        "latitude": "35.62397000",
                        "longitude": "140.42079000"
                    },
                    {
                        "id": 64295,
                        "name": "Sawara",
                        "latitude": "35.88333000",
                        "longitude": "140.50000000"
                    },
                    {
                        "id": 64357,
                        "name": "Shiroi",
                        "latitude": "35.80000000",
                        "longitude": "140.06667000"
                    },
                    {
                        "id": 64358,
                        "name": "Shiroi-shi",
                        "latitude": "35.80164000",
                        "longitude": "140.06005000"
                    },
                    {
                        "id": 64362,
                        "name": "Shisui",
                        "latitude": "35.71667000",
                        "longitude": "140.26667000"
                    },
                    {
                        "id": 64373,
                        "name": "Sodegaura-shi",
                        "latitude": "35.41642000",
                        "longitude": "140.01771000"
                    },
                    {
                        "id": 64404,
                        "name": "Sōsa-shi",
                        "latitude": "35.69983000",
                        "longitude": "140.55366000"
                    },
                    {
                        "id": 64474,
                        "name": "Tateyama",
                        "latitude": "34.98333000",
                        "longitude": "139.86667000"
                    },
                    {
                        "id": 64475,
                        "name": "Tateyama-shi",
                        "latitude": "34.97156000",
                        "longitude": "139.86163000"
                    },
                    {
                        "id": 64566,
                        "name": "Tōgane",
                        "latitude": "35.55000000",
                        "longitude": "140.36667000"
                    },
                    {
                        "id": 64567,
                        "name": "Tōgane-shi",
                        "latitude": "35.56517000",
                        "longitude": "140.36707000"
                    },
                    {
                        "id": 64508,
                        "name": "Tomisato-shi",
                        "latitude": "35.72024000",
                        "longitude": "140.34080000"
                    },
                    {
                        "id": 64598,
                        "name": "Urayasu-shi",
                        "latitude": "35.64250000",
                        "longitude": "139.90192000"
                    },
                    {
                        "id": 64629,
                        "name": "Yachimata",
                        "latitude": "35.65000000",
                        "longitude": "140.31667000"
                    },
                    {
                        "id": 64630,
                        "name": "Yachimata-shi",
                        "latitude": "35.64241000",
                        "longitude": "140.29686000"
                    },
                    {
                        "id": 64631,
                        "name": "Yachiyo-shi",
                        "latitude": "35.73921000",
                        "longitude": "140.10502000"
                    },
                    {
                        "id": 64703,
                        "name": "Yōkaichiba",
                        "latitude": "35.70000000",
                        "longitude": "140.55000000"
                    },
                    {
                        "id": 64690,
                        "name": "Yotsukaidō",
                        "latitude": "35.65000000",
                        "longitude": "140.16667000"
                    },
                    {
                        "id": 64691,
                        "name": "Yotsukaidō-shi",
                        "latitude": "35.67167000",
                        "longitude": "140.17912000"
                    }
                ]
            },
            {
                "id": 865,
                "name": "Ehime",
                "iso2": "38",
                "latitude": "33.60253060",
                "longitude": "132.78575830",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63529,
                        "name": "Hōjō",
                        "latitude": "33.97661000",
                        "longitude": "132.77767000"
                    },
                    {
                        "id": 63560,
                        "name": "Imabari-shi",
                        "latitude": "34.06667000",
                        "longitude": "132.99791000"
                    },
                    {
                        "id": 63636,
                        "name": "Iyo",
                        "latitude": "33.75139000",
                        "longitude": "132.70139000"
                    },
                    {
                        "id": 63637,
                        "name": "Iyo-shi",
                        "latitude": "33.68493000",
                        "longitude": "132.68909000"
                    },
                    {
                        "id": 63774,
                        "name": "Kawanoechō",
                        "latitude": "34.01654000",
                        "longitude": "133.57844000"
                    },
                    {
                        "id": 63783,
                        "name": "Kihoku-chō",
                        "latitude": "33.25592000",
                        "longitude": "132.68343000"
                    },
                    {
                        "id": 63925,
                        "name": "Masaki-chō",
                        "latitude": "33.78757000",
                        "longitude": "132.71124000"
                    },
                    {
                        "id": 63941,
                        "name": "Matsuyama-shi",
                        "latitude": "33.83568000",
                        "longitude": "132.76224000"
                    },
                    {
                        "id": 64131,
                        "name": "Niihama",
                        "latitude": "33.96047000",
                        "longitude": "133.30522000"
                    },
                    {
                        "id": 64132,
                        "name": "Niihama-shi",
                        "latitude": "33.90670000",
                        "longitude": "133.33250000"
                    },
                    {
                        "id": 64770,
                        "name": "Ōzu",
                        "latitude": "33.50000000",
                        "longitude": "132.55000000"
                    },
                    {
                        "id": 64771,
                        "name": "Ōzu-shi",
                        "latitude": "33.50619000",
                        "longitude": "132.54430000"
                    },
                    {
                        "id": 64245,
                        "name": "Saijō",
                        "latitude": "33.91667000",
                        "longitude": "133.18333000"
                    },
                    {
                        "id": 64246,
                        "name": "Saijō-shi",
                        "latitude": "33.86100000",
                        "longitude": "133.10832000"
                    },
                    {
                        "id": 64297,
                        "name": "Seiyo-shi",
                        "latitude": "33.39408000",
                        "longitude": "132.63262000"
                    },
                    {
                        "id": 64322,
                        "name": "Shikoku-chūō Shi",
                        "latitude": "33.93538000",
                        "longitude": "133.53622000"
                    },
                    {
                        "id": 64575,
                        "name": "Tōon-shi",
                        "latitude": "33.79099000",
                        "longitude": "132.87234000"
                    },
                    {
                        "id": 64613,
                        "name": "Uwajima",
                        "latitude": "33.22375000",
                        "longitude": "132.56001000"
                    },
                    {
                        "id": 64614,
                        "name": "Uwajima-shi",
                        "latitude": "33.22325000",
                        "longitude": "132.56069000"
                    },
                    {
                        "id": 64667,
                        "name": "Yawatahama-shi",
                        "latitude": "33.46302000",
                        "longitude": "132.42336000"
                    }
                ]
            },
            {
                "id": 848,
                "name": "Fukui",
                "iso2": "18",
                "latitude": "35.89622700",
                "longitude": "136.21115790",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63257,
                        "name": "Asahi",
                        "latitude": "35.97259000",
                        "longitude": "136.12455000"
                    },
                    {
                        "id": 63276,
                        "name": "Awara-shi",
                        "latitude": "36.22777000",
                        "longitude": "136.25154000"
                    },
                    {
                        "id": 63329,
                        "name": "Echizen-shi",
                        "latitude": "35.88946000",
                        "longitude": "136.17723000"
                    },
                    {
                        "id": 63363,
                        "name": "Fukui-shi",
                        "latitude": "36.06667000",
                        "longitude": "136.21667000"
                    },
                    {
                        "id": 63763,
                        "name": "Katsuyama",
                        "latitude": "36.06173000",
                        "longitude": "136.50101000"
                    },
                    {
                        "id": 63764,
                        "name": "Katsuyama Shi",
                        "latitude": "36.08440000",
                        "longitude": "136.52178000"
                    },
                    {
                        "id": 63924,
                        "name": "Maruoka",
                        "latitude": "36.15340000",
                        "longitude": "136.27029000"
                    },
                    {
                        "id": 63955,
                        "name": "Mikuni",
                        "latitude": "36.21706000",
                        "longitude": "136.15185000"
                    },
                    {
                        "id": 64176,
                        "name": "Obama",
                        "latitude": "35.49576000",
                        "longitude": "135.74604000"
                    },
                    {
                        "id": 64177,
                        "name": "Obama-shi",
                        "latitude": "35.45000000",
                        "longitude": "135.70000000"
                    },
                    {
                        "id": 64726,
                        "name": "Ōi-gun",
                        "latitude": "35.49238000",
                        "longitude": "135.49311000"
                    },
                    {
                        "id": 64209,
                        "name": "Ono",
                        "latitude": "35.98106000",
                        "longitude": "136.48727000"
                    },
                    {
                        "id": 64748,
                        "name": "Ōno-shi",
                        "latitude": "35.90837000",
                        "longitude": "136.61696000"
                    },
                    {
                        "id": 64236,
                        "name": "Sabae",
                        "latitude": "35.94647000",
                        "longitude": "136.18498000"
                    },
                    {
                        "id": 64237,
                        "name": "Sabae-shi",
                        "latitude": "35.95932000",
                        "longitude": "136.21835000"
                    },
                    {
                        "id": 64259,
                        "name": "Sakai-shi",
                        "latitude": "36.16406000",
                        "longitude": "136.25544000"
                    },
                    {
                        "id": 64444,
                        "name": "Takefu",
                        "latitude": "35.90393000",
                        "longitude": "136.16687000"
                    },
                    {
                        "id": 64553,
                        "name": "Tsuruga",
                        "latitude": "35.64547000",
                        "longitude": "136.05580000"
                    },
                    {
                        "id": 64554,
                        "name": "Tsuruga-shi",
                        "latitude": "35.63730000",
                        "longitude": "136.08068000"
                    }
                ]
            },
            {
                "id": 861,
                "name": "Fukuoka",
                "iso2": "40",
                "latitude": "33.56625590",
                "longitude": "130.71585700",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63239,
                        "name": "Amagi",
                        "latitude": "33.41804000",
                        "longitude": "130.65413000"
                    },
                    {
                        "id": 63263,
                        "name": "Asakura Shi",
                        "latitude": "33.41684000",
                        "longitude": "130.74167000"
                    },
                    {
                        "id": 63290,
                        "name": "Buzen",
                        "latitude": "33.61153000",
                        "longitude": "131.13002000"
                    },
                    {
                        "id": 63291,
                        "name": "Buzen-shi",
                        "latitude": "33.56743000",
                        "longitude": "131.08578000"
                    },
                    {
                        "id": 63298,
                        "name": "Chikugo Shi",
                        "latitude": "33.20748000",
                        "longitude": "130.49122000"
                    },
                    {
                        "id": 63302,
                        "name": "Chikushino-shi",
                        "latitude": "33.49631000",
                        "longitude": "130.51560000"
                    },
                    {
                        "id": 63325,
                        "name": "Dazaifu-shi",
                        "latitude": "33.50000000",
                        "longitude": "130.53333000"
                    },
                    {
                        "id": 63365,
                        "name": "Fukuoka",
                        "latitude": "33.60000000",
                        "longitude": "130.41667000"
                    },
                    {
                        "id": 63366,
                        "name": "Fukuoka-shi",
                        "latitude": "33.56894000",
                        "longitude": "130.35764000"
                    },
                    {
                        "id": 63372,
                        "name": "Fukutsu Shi",
                        "latitude": "33.77982000",
                        "longitude": "130.49804000"
                    },
                    {
                        "id": 63551,
                        "name": "Iizuka",
                        "latitude": "33.63654000",
                        "longitude": "130.68678000"
                    },
                    {
                        "id": 63552,
                        "name": "Iizuka Shi",
                        "latitude": "33.61353000",
                        "longitude": "130.66098000"
                    },
                    {
                        "id": 63614,
                        "name": "Itoshima-shi",
                        "latitude": "33.53317000",
                        "longitude": "130.17975000"
                    },
                    {
                        "id": 63676,
                        "name": "Kama Shi",
                        "latitude": "33.53663000",
                        "longitude": "130.74028000"
                    },
                    {
                        "id": 63708,
                        "name": "Kanda",
                        "latitude": "33.78333000",
                        "longitude": "130.98333000"
                    },
                    {
                        "id": 63744,
                        "name": "Kasuga Shi",
                        "latitude": "33.52404000",
                        "longitude": "130.45641000"
                    },
                    {
                        "id": 63776,
                        "name": "Kawasaki",
                        "latitude": "33.59993000",
                        "longitude": "130.81495000"
                    },
                    {
                        "id": 63808,
                        "name": "Kitakyushu",
                        "latitude": "33.85181000",
                        "longitude": "130.85034000"
                    },
                    {
                        "id": 63823,
                        "name": "Koga",
                        "latitude": "33.73333000",
                        "longitude": "130.46667000"
                    },
                    {
                        "id": 63825,
                        "name": "Koga-shi",
                        "latitude": "33.72139000",
                        "longitude": "130.49947000"
                    },
                    {
                        "id": 63879,
                        "name": "Kurume",
                        "latitude": "33.31667000",
                        "longitude": "130.51667000"
                    },
                    {
                        "id": 63880,
                        "name": "Kurume Shi",
                        "latitude": "33.30358000",
                        "longitude": "130.56549000"
                    },
                    {
                        "id": 63907,
                        "name": "Maebaru-chūō",
                        "latitude": "33.55916000",
                        "longitude": "130.20148000"
                    },
                    {
                        "id": 64005,
                        "name": "Miyama Shi",
                        "latitude": "33.12369000",
                        "longitude": "130.49540000"
                    },
                    {
                        "id": 64007,
                        "name": "Miyata",
                        "latitude": "33.70811000",
                        "longitude": "130.65297000"
                    },
                    {
                        "id": 64008,
                        "name": "Miyawaka Shi",
                        "latitude": "33.71559000",
                        "longitude": "130.61506000"
                    },
                    {
                        "id": 64044,
                        "name": "Munakata-shi",
                        "latitude": "33.80000000",
                        "longitude": "130.55000000"
                    },
                    {
                        "id": 64084,
                        "name": "Nakama",
                        "latitude": "33.81688000",
                        "longitude": "130.70962000"
                    },
                    {
                        "id": 64085,
                        "name": "Nakama Shi",
                        "latitude": "33.82081000",
                        "longitude": "130.70862000"
                    },
                    {
                        "id": 64147,
                        "name": "Nishifukuma",
                        "latitude": "33.76627000",
                        "longitude": "130.47461000"
                    },
                    {
                        "id": 64174,
                        "name": "Nōgata",
                        "latitude": "33.74051000",
                        "longitude": "130.72263000"
                    },
                    {
                        "id": 64175,
                        "name": "Nōgata Shi",
                        "latitude": "33.75116000",
                        "longitude": "130.74592000"
                    },
                    {
                        "id": 64189,
                        "name": "Ogōri-shi",
                        "latitude": "33.38333000",
                        "longitude": "130.56667000"
                    },
                    {
                        "id": 64730,
                        "name": "Ōkawa",
                        "latitude": "33.20566000",
                        "longitude": "130.37527000"
                    },
                    {
                        "id": 64731,
                        "name": "Ōkawa-shi",
                        "latitude": "33.20736000",
                        "longitude": "130.38253000"
                    },
                    {
                        "id": 64745,
                        "name": "Ōmuta",
                        "latitude": "33.03333000",
                        "longitude": "130.45000000"
                    },
                    {
                        "id": 64746,
                        "name": "Ōmuta Shi",
                        "latitude": "33.04616000",
                        "longitude": "130.46912000"
                    },
                    {
                        "id": 64207,
                        "name": "Onga-gun",
                        "latitude": "33.85699000",
                        "longitude": "130.63626000"
                    },
                    {
                        "id": 64749,
                        "name": "Ōnojō",
                        "latitude": "33.53567000",
                        "longitude": "130.47861000"
                    },
                    {
                        "id": 64750,
                        "name": "Ōnojō Shi",
                        "latitude": "33.51302000",
                        "longitude": "130.47925000"
                    },
                    {
                        "id": 64287,
                        "name": "Sasaguri",
                        "latitude": "33.61561000",
                        "longitude": "130.55105000"
                    },
                    {
                        "id": 64303,
                        "name": "Setakamachi-takayanagi",
                        "latitude": "33.14858000",
                        "longitude": "130.46548000"
                    },
                    {
                        "id": 64318,
                        "name": "Shiida",
                        "latitude": "33.65341000",
                        "longitude": "131.05797000"
                    },
                    {
                        "id": 64340,
                        "name": "Shingū",
                        "latitude": "33.71399000",
                        "longitude": "130.43130000"
                    },
                    {
                        "id": 64408,
                        "name": "Tagawa",
                        "latitude": "33.63333000",
                        "longitude": "130.80000000"
                    },
                    {
                        "id": 64409,
                        "name": "Tagawa Shi",
                        "latitude": "33.63159000",
                        "longitude": "130.79966000"
                    },
                    {
                        "id": 64468,
                        "name": "Tanushimarumachi-toyoki",
                        "latitude": "33.35000000",
                        "longitude": "130.68333000"
                    },
                    {
                        "id": 64543,
                        "name": "Tsuiki",
                        "latitude": "33.67307000",
                        "longitude": "131.03776000"
                    },
                    {
                        "id": 64588,
                        "name": "Ukiha Shi",
                        "latitude": "33.31184000",
                        "longitude": "130.79325000"
                    },
                    {
                        "id": 64589,
                        "name": "Umi",
                        "latitude": "33.56826000",
                        "longitude": "130.51009000"
                    },
                    {
                        "id": 64648,
                        "name": "Yame Shi",
                        "latitude": "33.23302000",
                        "longitude": "130.62775000"
                    },
                    {
                        "id": 64650,
                        "name": "Yanagawa",
                        "latitude": "33.16667000",
                        "longitude": "130.40000000"
                    },
                    {
                        "id": 64651,
                        "name": "Yanagawa Shi",
                        "latitude": "33.14932000",
                        "longitude": "130.40725000"
                    },
                    {
                        "id": 64689,
                        "name": "Yoshitomi",
                        "latitude": "33.60247000",
                        "longitude": "131.17599000"
                    },
                    {
                        "id": 64696,
                        "name": "Yukuhashi",
                        "latitude": "33.72873000",
                        "longitude": "130.98300000"
                    },
                    {
                        "id": 64697,
                        "name": "Yukuhashi Shi",
                        "latitude": "33.71404000",
                        "longitude": "130.97108000"
                    }
                ]
            },
            {
                "id": 847,
                "name": "Fukushima",
                "iso2": "07",
                "latitude": "37.38343730",
                "longitude": "140.18325160",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63224,
                        "name": "Aizu-wakamatsu Shi",
                        "latitude": "37.45071000",
                        "longitude": "139.96814000"
                    },
                    {
                        "id": 63323,
                        "name": "Date-shi",
                        "latitude": "37.81667000",
                        "longitude": "140.51667000"
                    },
                    {
                        "id": 63370,
                        "name": "Fukushima",
                        "latitude": "37.75000000",
                        "longitude": "140.46667000"
                    },
                    {
                        "id": 63371,
                        "name": "Fukushima Shi",
                        "latitude": "37.78643000",
                        "longitude": "140.38849000"
                    },
                    {
                        "id": 63377,
                        "name": "Funehikimachi-funehiki",
                        "latitude": "37.44722000",
                        "longitude": "140.57710000"
                    },
                    {
                        "id": 63513,
                        "name": "Hobaramachi",
                        "latitude": "37.81667000",
                        "longitude": "140.55000000"
                    },
                    {
                        "id": 63572,
                        "name": "Inawashiro",
                        "latitude": "37.56667000",
                        "longitude": "140.11667000"
                    },
                    {
                        "id": 63597,
                        "name": "Ishikawa",
                        "latitude": "37.15000000",
                        "longitude": "140.45000000"
                    },
                    {
                        "id": 63621,
                        "name": "Iwaki",
                        "latitude": "37.05000000",
                        "longitude": "140.88333000"
                    },
                    {
                        "id": 63622,
                        "name": "Iwaki-shi",
                        "latitude": "37.08333000",
                        "longitude": "140.83333000"
                    },
                    {
                        "id": 63806,
                        "name": "Kitakata",
                        "latitude": "37.65000000",
                        "longitude": "139.86667000"
                    },
                    {
                        "id": 63807,
                        "name": "Kitakata-shi",
                        "latitude": "37.68333000",
                        "longitude": "139.90000000"
                    },
                    {
                        "id": 63899,
                        "name": "Kōriyama",
                        "latitude": "37.40000000",
                        "longitude": "140.38333000"
                    },
                    {
                        "id": 63900,
                        "name": "Kōriyama Shi",
                        "latitude": "37.41277000",
                        "longitude": "140.29507000"
                    },
                    {
                        "id": 63950,
                        "name": "Miharu",
                        "latitude": "37.43333000",
                        "longitude": "140.48333000"
                    },
                    {
                        "id": 63962,
                        "name": "Minami-Sōma",
                        "latitude": "37.62908000",
                        "longitude": "140.97868000"
                    },
                    {
                        "id": 63971,
                        "name": "Minamisōma Shi",
                        "latitude": "37.63108000",
                        "longitude": "140.92852000"
                    },
                    {
                        "id": 64039,
                        "name": "Motomiya",
                        "latitude": "37.51391000",
                        "longitude": "140.40063000"
                    },
                    {
                        "id": 64040,
                        "name": "Motomiya-shi",
                        "latitude": "37.51218000",
                        "longitude": "140.39841000"
                    },
                    {
                        "id": 64097,
                        "name": "Namie",
                        "latitude": "37.48333000",
                        "longitude": "141.00000000"
                    },
                    {
                        "id": 64127,
                        "name": "Nihommatsu",
                        "latitude": "37.58333000",
                        "longitude": "140.43333000"
                    },
                    {
                        "id": 64128,
                        "name": "Nihonmatsu Shi",
                        "latitude": "37.58402000",
                        "longitude": "140.49543000"
                    },
                    {
                        "id": 64353,
                        "name": "Shirakawa Shi",
                        "latitude": "37.12225000",
                        "longitude": "140.24963000"
                    },
                    {
                        "id": 64402,
                        "name": "Sōma",
                        "latitude": "37.79283000",
                        "longitude": "140.92941000"
                    },
                    {
                        "id": 64403,
                        "name": "Sōma Shi",
                        "latitude": "37.78193000",
                        "longitude": "140.87321000"
                    },
                    {
                        "id": 64381,
                        "name": "Sukagawa",
                        "latitude": "37.28333000",
                        "longitude": "140.38333000"
                    },
                    {
                        "id": 64382,
                        "name": "Sukagawa Shi",
                        "latitude": "37.29342000",
                        "longitude": "140.31691000"
                    },
                    {
                        "id": 64461,
                        "name": "Tamura",
                        "latitude": "37.43055000",
                        "longitude": "140.60335000"
                    },
                    {
                        "id": 64462,
                        "name": "Tamura-shi",
                        "latitude": "37.43793000",
                        "longitude": "140.57384000"
                    },
                    {
                        "id": 64652,
                        "name": "Yanagawamachi-saiwaichō",
                        "latitude": "37.85000000",
                        "longitude": "140.60000000"
                    }
                ]
            },
            {
                "id": 858,
                "name": "Gifu",
                "iso2": "21",
                "latitude": "35.74374910",
                "longitude": "136.98051030",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63332,
                        "name": "Ena-shi",
                        "latitude": "35.44722000",
                        "longitude": "137.41810000"
                    },
                    {
                        "id": 63384,
                        "name": "Gero",
                        "latitude": "35.80000000",
                        "longitude": "137.23333000"
                    },
                    {
                        "id": 63385,
                        "name": "Gero-shi",
                        "latitude": "35.75000000",
                        "longitude": "137.25000000"
                    },
                    {
                        "id": 63386,
                        "name": "Gifu-shi",
                        "latitude": "35.44826000",
                        "longitude": "136.76470000"
                    },
                    {
                        "id": 63402,
                        "name": "Gōdo",
                        "latitude": "35.41667000",
                        "longitude": "136.60000000"
                    },
                    {
                        "id": 63398,
                        "name": "Gujō",
                        "latitude": "35.73691000",
                        "longitude": "136.95852000"
                    },
                    {
                        "id": 63399,
                        "name": "Gujō-shi",
                        "latitude": "35.83298000",
                        "longitude": "136.94561000"
                    },
                    {
                        "id": 63442,
                        "name": "Hashima",
                        "latitude": "35.32900000",
                        "longitude": "136.68051000"
                    },
                    {
                        "id": 63443,
                        "name": "Hashima-shi",
                        "latitude": "35.30740000",
                        "longitude": "136.70161000"
                    },
                    {
                        "id": 63455,
                        "name": "Hida",
                        "latitude": "36.24483000",
                        "longitude": "137.17323000"
                    },
                    {
                        "id": 63456,
                        "name": "Hida Shi",
                        "latitude": "36.33272000",
                        "longitude": "137.20568000"
                    },
                    {
                        "id": 63664,
                        "name": "Kaizu-shi",
                        "latitude": "35.21381000",
                        "longitude": "136.62443000"
                    },
                    {
                        "id": 63668,
                        "name": "Kakamigahara-shi",
                        "latitude": "35.40283000",
                        "longitude": "136.87829000"
                    },
                    {
                        "id": 63710,
                        "name": "Kani-shi",
                        "latitude": "35.40589000",
                        "longitude": "137.06602000"
                    },
                    {
                        "id": 63729,
                        "name": "Kasamatsuchō",
                        "latitude": "35.36667000",
                        "longitude": "136.76667000"
                    },
                    {
                        "id": 63977,
                        "name": "Mino",
                        "latitude": "35.53333000",
                        "longitude": "136.91667000"
                    },
                    {
                        "id": 63978,
                        "name": "Mino-shi",
                        "latitude": "35.57892000",
                        "longitude": "136.90120000"
                    },
                    {
                        "id": 63979,
                        "name": "Minokamo",
                        "latitude": "35.48199000",
                        "longitude": "137.02166000"
                    },
                    {
                        "id": 63980,
                        "name": "Minokamo-shi",
                        "latitude": "35.48386000",
                        "longitude": "137.02658000"
                    },
                    {
                        "id": 63989,
                        "name": "Mitake",
                        "latitude": "35.41667000",
                        "longitude": "137.13333000"
                    },
                    {
                        "id": 64018,
                        "name": "Mizuho-shi",
                        "latitude": "35.39663000",
                        "longitude": "136.67022000"
                    },
                    {
                        "id": 64019,
                        "name": "Mizunami",
                        "latitude": "35.36667000",
                        "longitude": "137.25000000"
                    },
                    {
                        "id": 64020,
                        "name": "Mizunami-shi",
                        "latitude": "35.38935000",
                        "longitude": "137.27360000"
                    },
                    {
                        "id": 64041,
                        "name": "Motosu-shi",
                        "latitude": "35.65553000",
                        "longitude": "136.61991000"
                    },
                    {
                        "id": 64091,
                        "name": "Nakatsugawa",
                        "latitude": "35.48333000",
                        "longitude": "137.50000000"
                    },
                    {
                        "id": 64092,
                        "name": "Nakatsugawa-shi",
                        "latitude": "35.56656000",
                        "longitude": "137.47433000"
                    },
                    {
                        "id": 64723,
                        "name": "Ōgaki-shi",
                        "latitude": "35.36485000",
                        "longitude": "136.60189000"
                    },
                    {
                        "id": 64298,
                        "name": "Seki-shi",
                        "latitude": "35.48333000",
                        "longitude": "136.91667000"
                    },
                    {
                        "id": 64415,
                        "name": "Tajimi",
                        "latitude": "35.31667000",
                        "longitude": "137.13333000"
                    },
                    {
                        "id": 64416,
                        "name": "Tajimi-shi",
                        "latitude": "35.33401000",
                        "longitude": "137.11258000"
                    },
                    {
                        "id": 64442,
                        "name": "Takayama Shi",
                        "latitude": "36.13181000",
                        "longitude": "137.28585000"
                    },
                    {
                        "id": 64469,
                        "name": "Tarui",
                        "latitude": "35.36667000",
                        "longitude": "136.53333000"
                    },
                    {
                        "id": 64491,
                        "name": "Toki",
                        "latitude": "35.35000000",
                        "longitude": "137.18333000"
                    },
                    {
                        "id": 64492,
                        "name": "Toki-shi",
                        "latitude": "35.32418000",
                        "longitude": "137.20748000"
                    },
                    {
                        "id": 64640,
                        "name": "Yamagata-shi",
                        "latitude": "35.59892000",
                        "longitude": "136.74311000"
                    }
                ]
            },
            {
                "id": 862,
                "name": "Gunma",
                "iso2": "10",
                "latitude": "36.56053880",
                "longitude": "138.87999720",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63217,
                        "name": "Agatsuma-gun",
                        "latitude": "36.57368000",
                        "longitude": "138.67243000"
                    },
                    {
                        "id": 63247,
                        "name": "Annaka",
                        "latitude": "36.33011000",
                        "longitude": "138.89585000"
                    },
                    {
                        "id": 63248,
                        "name": "Annaka Shi",
                        "latitude": "36.34079000",
                        "longitude": "138.77647000"
                    },
                    {
                        "id": 63350,
                        "name": "Fujioka",
                        "latitude": "36.24624000",
                        "longitude": "139.07204000"
                    },
                    {
                        "id": 63351,
                        "name": "Fujioka Shi",
                        "latitude": "36.19213000",
                        "longitude": "138.99918000"
                    },
                    {
                        "id": 63588,
                        "name": "Isesaki",
                        "latitude": "36.31667000",
                        "longitude": "139.20000000"
                    },
                    {
                        "id": 63589,
                        "name": "Isesaki Shi",
                        "latitude": "36.32126000",
                        "longitude": "139.21823000"
                    },
                    {
                        "id": 63709,
                        "name": "Kanekomachi",
                        "latitude": "36.41097000",
                        "longitude": "138.99621000"
                    },
                    {
                        "id": 63790,
                        "name": "Kiryū",
                        "latitude": "36.40000000",
                        "longitude": "139.33333000"
                    },
                    {
                        "id": 63791,
                        "name": "Kiryū Shi",
                        "latitude": "36.45702000",
                        "longitude": "139.30962000"
                    },
                    {
                        "id": 63908,
                        "name": "Maebashi",
                        "latitude": "36.40000000",
                        "longitude": "139.08333000"
                    },
                    {
                        "id": 63909,
                        "name": "Maebashi Shi",
                        "latitude": "36.41432000",
                        "longitude": "139.13110000"
                    },
                    {
                        "id": 63946,
                        "name": "Midori",
                        "latitude": "36.44492000",
                        "longitude": "139.28448000"
                    },
                    {
                        "id": 63947,
                        "name": "Midori Shi",
                        "latitude": "36.53044000",
                        "longitude": "139.34728000"
                    },
                    {
                        "id": 64088,
                        "name": "Nakanojōmachi",
                        "latitude": "36.58717000",
                        "longitude": "138.84083000"
                    },
                    {
                        "id": 64170,
                        "name": "Numata",
                        "latitude": "36.63333000",
                        "longitude": "139.05000000"
                    },
                    {
                        "id": 64171,
                        "name": "Numata Shi",
                        "latitude": "36.67371000",
                        "longitude": "139.18353000"
                    },
                    {
                        "id": 64737,
                        "name": "Ōmamachō-ōmama",
                        "latitude": "36.43181000",
                        "longitude": "139.27534000"
                    },
                    {
                        "id": 64757,
                        "name": "Ōta",
                        "latitude": "36.30000000",
                        "longitude": "139.36667000"
                    },
                    {
                        "id": 64759,
                        "name": "Ōta-shi",
                        "latitude": "36.30000000",
                        "longitude": "139.36667000"
                    },
                    {
                        "id": 64258,
                        "name": "Sakai-nakajima",
                        "latitude": "36.26667000",
                        "longitude": "139.25000000"
                    },
                    {
                        "id": 64312,
                        "name": "Shibukawa",
                        "latitude": "36.48333000",
                        "longitude": "139.00000000"
                    },
                    {
                        "id": 64313,
                        "name": "Shibukawa-shi",
                        "latitude": "36.50000000",
                        "longitude": "138.98333000"
                    },
                    {
                        "id": 64436,
                        "name": "Takasaki",
                        "latitude": "36.33333000",
                        "longitude": "139.01667000"
                    },
                    {
                        "id": 64437,
                        "name": "Takasaki Shi",
                        "latitude": "36.40538000",
                        "longitude": "138.89227000"
                    },
                    {
                        "id": 64456,
                        "name": "Tamamura",
                        "latitude": "36.30000000",
                        "longitude": "139.11667000"
                    },
                    {
                        "id": 64472,
                        "name": "Tatebayashi",
                        "latitude": "36.25000000",
                        "longitude": "139.53333000"
                    },
                    {
                        "id": 64473,
                        "name": "Tatebayashi-shi",
                        "latitude": "36.24597000",
                        "longitude": "139.53533000"
                    },
                    {
                        "id": 64506,
                        "name": "Tomioka",
                        "latitude": "36.25411000",
                        "longitude": "138.89813000"
                    },
                    {
                        "id": 64507,
                        "name": "Tomioka-shi",
                        "latitude": "36.25000000",
                        "longitude": "138.88333000"
                    },
                    {
                        "id": 64684,
                        "name": "Yoshii",
                        "latitude": "36.25000000",
                        "longitude": "138.98333000"
                    }
                ]
            },
            {
                "id": 828,
                "name": "Hiroshima",
                "iso2": "34",
                "latitude": "34.88234080",
                "longitude": "133.01948970",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63230,
                        "name": "Aki-takata Shi",
                        "latitude": "34.70248000",
                        "longitude": "132.67770000"
                    },
                    {
                        "id": 63335,
                        "name": "Etajima-shi",
                        "latitude": "34.21989000",
                        "longitude": "132.44345000"
                    },
                    {
                        "id": 63337,
                        "name": "Fuchū-shi",
                        "latitude": "34.56667000",
                        "longitude": "133.23333000"
                    },
                    {
                        "id": 63338,
                        "name": "Fuchūchō",
                        "latitude": "34.57350000",
                        "longitude": "133.23513000"
                    },
                    {
                        "id": 63373,
                        "name": "Fukuyama",
                        "latitude": "34.48333000",
                        "longitude": "133.36667000"
                    },
                    {
                        "id": 63374,
                        "name": "Fukuyama Shi",
                        "latitude": "34.52342000",
                        "longitude": "133.33779000"
                    },
                    {
                        "id": 63449,
                        "name": "Hatsukaichi",
                        "latitude": "34.35000000",
                        "longitude": "132.33333000"
                    },
                    {
                        "id": 63450,
                        "name": "Hatsukaichi-shi",
                        "latitude": "34.35000000",
                        "longitude": "132.30000000"
                    },
                    {
                        "id": 63459,
                        "name": "Higashihiroshima Shi",
                        "latitude": "34.44755000",
                        "longitude": "132.76116000"
                    },
                    {
                        "id": 63499,
                        "name": "Hiroshima",
                        "latitude": "34.40000000",
                        "longitude": "132.45000000"
                    },
                    {
                        "id": 63500,
                        "name": "Hiroshima-shi",
                        "latitude": "34.47942000",
                        "longitude": "132.45312000"
                    },
                    {
                        "id": 63575,
                        "name": "Innoshima",
                        "latitude": "34.28333000",
                        "longitude": "133.18333000"
                    },
                    {
                        "id": 63712,
                        "name": "Kannabechō-yahiro",
                        "latitude": "34.55808000",
                        "longitude": "133.41796000"
                    },
                    {
                        "id": 63868,
                        "name": "Kure",
                        "latitude": "34.23222000",
                        "longitude": "132.56658000"
                    },
                    {
                        "id": 63869,
                        "name": "Kure-shi",
                        "latitude": "34.22448000",
                        "longitude": "132.62914000"
                    },
                    {
                        "id": 63948,
                        "name": "Mihara",
                        "latitude": "34.40000000",
                        "longitude": "133.08333000"
                    },
                    {
                        "id": 63949,
                        "name": "Mihara Shi",
                        "latitude": "34.45817000",
                        "longitude": "133.00395000"
                    },
                    {
                        "id": 63998,
                        "name": "Miyajima",
                        "latitude": "34.29907000",
                        "longitude": "132.32186000"
                    },
                    {
                        "id": 64013,
                        "name": "Miyoshi",
                        "latitude": "34.80000000",
                        "longitude": "132.85000000"
                    },
                    {
                        "id": 64014,
                        "name": "Miyoshi Shi",
                        "latitude": "34.79201000",
                        "longitude": "132.86435000"
                    },
                    {
                        "id": 64747,
                        "name": "Ōno-hara",
                        "latitude": "34.28333000",
                        "longitude": "132.26667000"
                    },
                    {
                        "id": 64212,
                        "name": "Onomichi",
                        "latitude": "34.41667000",
                        "longitude": "133.20000000"
                    },
                    {
                        "id": 64213,
                        "name": "Onomichi-shi",
                        "latitude": "34.42630000",
                        "longitude": "133.16329000"
                    },
                    {
                        "id": 64760,
                        "name": "Ōtake",
                        "latitude": "34.20754000",
                        "longitude": "132.22063000"
                    },
                    {
                        "id": 64761,
                        "name": "Ōtake-shi",
                        "latitude": "34.25787000",
                        "longitude": "132.18756000"
                    },
                    {
                        "id": 64347,
                        "name": "Shin’ichi",
                        "latitude": "34.55543000",
                        "longitude": "133.27297000"
                    },
                    {
                        "id": 64368,
                        "name": "Shōbara",
                        "latitude": "34.85000000",
                        "longitude": "133.01667000"
                    },
                    {
                        "id": 64369,
                        "name": "Shōbara-shi",
                        "latitude": "34.94831000",
                        "longitude": "133.06769000"
                    },
                    {
                        "id": 64445,
                        "name": "Takehara",
                        "latitude": "34.33833000",
                        "longitude": "132.91667000"
                    },
                    {
                        "id": 64446,
                        "name": "Takehara-shi",
                        "latitude": "34.35000000",
                        "longitude": "132.90000000"
                    }
                ]
            },
            {
                "id": 832,
                "name": "Hokkaidō",
                "iso2": "01",
                "latitude": "43.22032660",
                "longitude": "142.86347370",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63211,
                        "name": "Abashiri",
                        "latitude": "44.02127000",
                        "longitude": "144.26971000"
                    },
                    {
                        "id": 63212,
                        "name": "Abashiri Shi",
                        "latitude": "43.98565000",
                        "longitude": "144.21051000"
                    },
                    {
                        "id": 63225,
                        "name": "Akabira",
                        "latitude": "43.55139000",
                        "longitude": "142.05306000"
                    },
                    {
                        "id": 63226,
                        "name": "Akabira-shi",
                        "latitude": "43.56790000",
                        "longitude": "142.06281000"
                    },
                    {
                        "id": 63259,
                        "name": "Asahikawa",
                        "latitude": "43.77063000",
                        "longitude": "142.36489000"
                    },
                    {
                        "id": 63264,
                        "name": "Ashibetsu",
                        "latitude": "43.50972000",
                        "longitude": "142.18556000"
                    },
                    {
                        "id": 63265,
                        "name": "Ashibetsu-shi",
                        "latitude": "43.42542000",
                        "longitude": "142.20161000"
                    },
                    {
                        "id": 63285,
                        "name": "Bibai",
                        "latitude": "43.32472000",
                        "longitude": "141.85861000"
                    },
                    {
                        "id": 63309,
                        "name": "Chitose",
                        "latitude": "42.81944000",
                        "longitude": "141.65222000"
                    },
                    {
                        "id": 63310,
                        "name": "Chitose Shi",
                        "latitude": "42.80048000",
                        "longitude": "141.50951000"
                    },
                    {
                        "id": 63322,
                        "name": "Date",
                        "latitude": "42.46806000",
                        "longitude": "140.86806000"
                    },
                    {
                        "id": 63324,
                        "name": "Date-shi",
                        "latitude": "42.49337000",
                        "longitude": "140.89142000"
                    },
                    {
                        "id": 63326,
                        "name": "Ebetsu",
                        "latitude": "43.10806000",
                        "longitude": "141.55056000"
                    },
                    {
                        "id": 63333,
                        "name": "Eniwa-shi",
                        "latitude": "42.88333000",
                        "longitude": "141.56667000"
                    },
                    {
                        "id": 63356,
                        "name": "Fukagawa",
                        "latitude": "43.70806000",
                        "longitude": "142.03917000"
                    },
                    {
                        "id": 63357,
                        "name": "Fukagawa-shi",
                        "latitude": "43.79334000",
                        "longitude": "142.09923000"
                    },
                    {
                        "id": 63378,
                        "name": "Furano-shi",
                        "latitude": "43.28182000",
                        "longitude": "142.47349000"
                    },
                    {
                        "id": 63416,
                        "name": "Hakodate",
                        "latitude": "41.77583000",
                        "longitude": "140.73667000"
                    },
                    {
                        "id": 63417,
                        "name": "Hakodate Shi",
                        "latitude": "41.83754000",
                        "longitude": "140.92597000"
                    },
                    {
                        "id": 63516,
                        "name": "Hokuto",
                        "latitude": "41.81626000",
                        "longitude": "140.63472000"
                    },
                    {
                        "id": 63519,
                        "name": "Hokuto-shi",
                        "latitude": "41.86411000",
                        "longitude": "140.55424000"
                    },
                    {
                        "id": 63521,
                        "name": "Honchō",
                        "latitude": "41.89440000",
                        "longitude": "140.69386000"
                    },
                    {
                        "id": 63594,
                        "name": "Ishikari",
                        "latitude": "43.23972000",
                        "longitude": "141.35389000"
                    },
                    {
                        "id": 63595,
                        "name": "Ishikari-shi",
                        "latitude": "43.46596000",
                        "longitude": "141.44298000"
                    },
                    {
                        "id": 63626,
                        "name": "Iwamizawa",
                        "latitude": "43.20028000",
                        "longitude": "141.75972000"
                    },
                    {
                        "id": 63627,
                        "name": "Iwamizawa-shi",
                        "latitude": "43.18086000",
                        "longitude": "141.79744000"
                    },
                    {
                        "id": 63628,
                        "name": "Iwanai",
                        "latitude": "42.97444000",
                        "longitude": "140.50889000"
                    },
                    {
                        "id": 63691,
                        "name": "Kamiiso",
                        "latitude": "41.82013000",
                        "longitude": "140.64482000"
                    },
                    {
                        "id": 63692,
                        "name": "Kamikawa",
                        "latitude": "43.84000000",
                        "longitude": "142.77111000"
                    },
                    {
                        "id": 63800,
                        "name": "Kitahiroshima",
                        "latitude": "42.97583000",
                        "longitude": "141.56722000"
                    },
                    {
                        "id": 63801,
                        "name": "Kitahiroshima-shi",
                        "latitude": "42.98581000",
                        "longitude": "141.55678000"
                    },
                    {
                        "id": 63809,
                        "name": "Kitami",
                        "latitude": "43.80306000",
                        "longitude": "143.89083000"
                    },
                    {
                        "id": 63851,
                        "name": "Ktiami Shi",
                        "latitude": "43.85160000",
                        "longitude": "143.71520000"
                    },
                    {
                        "id": 63886,
                        "name": "Kushiro",
                        "latitude": "42.97500000",
                        "longitude": "144.37472000"
                    },
                    {
                        "id": 63887,
                        "name": "Kushiro Shi",
                        "latitude": "43.15910000",
                        "longitude": "144.06647000"
                    },
                    {
                        "id": 63917,
                        "name": "Makubetsu",
                        "latitude": "45.37139000",
                        "longitude": "141.82111000"
                    },
                    {
                        "id": 63951,
                        "name": "Mikasa",
                        "latitude": "43.25581000",
                        "longitude": "141.88818000"
                    },
                    {
                        "id": 63952,
                        "name": "Mikasa-shi",
                        "latitude": "43.23976000",
                        "longitude": "141.99273000"
                    },
                    {
                        "id": 64024,
                        "name": "Mombetsu",
                        "latitude": "44.35250000",
                        "longitude": "143.35250000"
                    },
                    {
                        "id": 64025,
                        "name": "Monbetsu Shi",
                        "latitude": "44.20323000",
                        "longitude": "143.29293000"
                    },
                    {
                        "id": 64038,
                        "name": "Motomachi",
                        "latitude": "43.82634000",
                        "longitude": "144.09638000"
                    },
                    {
                        "id": 64049,
                        "name": "Muroran",
                        "latitude": "42.31722000",
                        "longitude": "140.98806000"
                    },
                    {
                        "id": 64050,
                        "name": "Muroran-shi",
                        "latitude": "42.36659000",
                        "longitude": "140.98845000"
                    },
                    {
                        "id": 64117,
                        "name": "Nayoro",
                        "latitude": "44.35056000",
                        "longitude": "142.45778000"
                    },
                    {
                        "id": 64118,
                        "name": "Nayoro Shi",
                        "latitude": "44.33951000",
                        "longitude": "142.45932000"
                    },
                    {
                        "id": 64120,
                        "name": "Nemuro",
                        "latitude": "43.32361000",
                        "longitude": "145.57500000"
                    },
                    {
                        "id": 64121,
                        "name": "Nemuro-shi",
                        "latitude": "43.33333000",
                        "longitude": "145.61667000"
                    },
                    {
                        "id": 64145,
                        "name": "Niseko Town",
                        "latitude": "42.77871000",
                        "longitude": "140.66903000"
                    },
                    {
                        "id": 64161,
                        "name": "Noboribetsu",
                        "latitude": "42.45215000",
                        "longitude": "141.17914000"
                    },
                    {
                        "id": 64162,
                        "name": "Noboribetsu-shi",
                        "latitude": "42.46565000",
                        "longitude": "141.07578000"
                    },
                    {
                        "id": 64180,
                        "name": "Obihiro",
                        "latitude": "42.91722000",
                        "longitude": "143.20444000"
                    },
                    {
                        "id": 64181,
                        "name": "Obihiro Shi",
                        "latitude": "42.75736000",
                        "longitude": "143.03061000"
                    },
                    {
                        "id": 64215,
                        "name": "Otaru",
                        "latitude": "43.18944000",
                        "longitude": "141.00222000"
                    },
                    {
                        "id": 64216,
                        "name": "Otaru-shi",
                        "latitude": "43.15628000",
                        "longitude": "141.02572000"
                    },
                    {
                        "id": 64217,
                        "name": "Otofuke",
                        "latitude": "42.99167000",
                        "longitude": "143.20028000"
                    },
                    {
                        "id": 64224,
                        "name": "Rebun Gun",
                        "latitude": "45.38263000",
                        "longitude": "141.02839000"
                    },
                    {
                        "id": 64227,
                        "name": "Rishiri Gun",
                        "latitude": "45.18244000",
                        "longitude": "141.22859000"
                    },
                    {
                        "id": 64228,
                        "name": "Rishiri Town",
                        "latitude": "45.15928000",
                        "longitude": "141.19629000"
                    },
                    {
                        "id": 64230,
                        "name": "Rumoi",
                        "latitude": "43.93444000",
                        "longitude": "141.64278000"
                    },
                    {
                        "id": 64231,
                        "name": "Rumoi-shi",
                        "latitude": "43.88560000",
                        "longitude": "141.75567000"
                    },
                    {
                        "id": 64285,
                        "name": "Sapporo",
                        "latitude": "43.06667000",
                        "longitude": "141.35000000"
                    },
                    {
                        "id": 64286,
                        "name": "Sapporo-shi",
                        "latitude": "43.06667000",
                        "longitude": "141.35000000"
                    },
                    {
                        "id": 64310,
                        "name": "Shibetsu",
                        "latitude": "43.65899000",
                        "longitude": "145.13197000"
                    },
                    {
                        "id": 64311,
                        "name": "Shibetsu Shi",
                        "latitude": "44.11522000",
                        "longitude": "142.54054000"
                    },
                    {
                        "id": 64329,
                        "name": "Shimo-furano",
                        "latitude": "43.35000000",
                        "longitude": "142.38333000"
                    },
                    {
                        "id": 64354,
                        "name": "Shiraoi",
                        "latitude": "42.55000000",
                        "longitude": "141.35000000"
                    },
                    {
                        "id": 64365,
                        "name": "Shizunai-furukawachō",
                        "latitude": "42.33389000",
                        "longitude": "142.36694000"
                    },
                    {
                        "id": 64386,
                        "name": "Sunagawa",
                        "latitude": "43.48639000",
                        "longitude": "141.90556000"
                    },
                    {
                        "id": 64387,
                        "name": "Sunagawa-shi",
                        "latitude": "43.50328000",
                        "longitude": "141.93274000"
                    },
                    {
                        "id": 64451,
                        "name": "Takikawa",
                        "latitude": "43.55278000",
                        "longitude": "141.90639000"
                    },
                    {
                        "id": 64452,
                        "name": "Takikawa-shi",
                        "latitude": "43.60837000",
                        "longitude": "141.94988000"
                    },
                    {
                        "id": 64565,
                        "name": "Tōbetsu",
                        "latitude": "43.21694000",
                        "longitude": "141.51694000"
                    },
                    {
                        "id": 64501,
                        "name": "Tomakomai",
                        "latitude": "42.63694000",
                        "longitude": "141.60333000"
                    },
                    {
                        "id": 64502,
                        "name": "Tomakomai Shi",
                        "latitude": "42.68226000",
                        "longitude": "141.57948000"
                    },
                    {
                        "id": 64607,
                        "name": "Utashinai",
                        "latitude": "43.51667000",
                        "longitude": "142.05000000"
                    },
                    {
                        "id": 64608,
                        "name": "Utashinai-shi",
                        "latitude": "43.49366000",
                        "longitude": "142.03878000"
                    },
                    {
                        "id": 64619,
                        "name": "Wakkanai",
                        "latitude": "45.40944000",
                        "longitude": "141.67389000"
                    },
                    {
                        "id": 64620,
                        "name": "Wakkanai Shi",
                        "latitude": "45.33243000",
                        "longitude": "141.82831000"
                    },
                    {
                        "id": 64668,
                        "name": "Yoichi",
                        "latitude": "43.20389000",
                        "longitude": "140.77028000"
                    },
                    {
                        "id": 64704,
                        "name": "Yūbari",
                        "latitude": "43.03778000",
                        "longitude": "141.95778000"
                    },
                    {
                        "id": 64705,
                        "name": "Yūbari-shi",
                        "latitude": "43.04336000",
                        "longitude": "142.11065000"
                    }
                ]
            },
            {
                "id": 831,
                "name": "Hyōgo",
                "iso2": "28",
                "latitude": "34.85795180",
                "longitude": "134.54537870",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63220,
                        "name": "Aioi",
                        "latitude": "34.80361000",
                        "longitude": "134.46806000"
                    },
                    {
                        "id": 63221,
                        "name": "Aioi Shi",
                        "latitude": "34.82719000",
                        "longitude": "134.46699000"
                    },
                    {
                        "id": 63228,
                        "name": "Akashi",
                        "latitude": "34.65524000",
                        "longitude": "135.00687000"
                    },
                    {
                        "id": 63229,
                        "name": "Akashi Shi",
                        "latitude": "34.68277000",
                        "longitude": "134.94029000"
                    },
                    {
                        "id": 63238,
                        "name": "Amagasaki Shi",
                        "latitude": "34.73544000",
                        "longitude": "135.41181000"
                    },
                    {
                        "id": 63256,
                        "name": "Asago-shi",
                        "latitude": "35.26249000",
                        "longitude": "134.82527000"
                    },
                    {
                        "id": 63267,
                        "name": "Ashiya",
                        "latitude": "34.72807000",
                        "longitude": "135.30264000"
                    },
                    {
                        "id": 63268,
                        "name": "Ashiya Shi",
                        "latitude": "34.74853000",
                        "longitude": "135.29759000"
                    },
                    {
                        "id": 63275,
                        "name": "Awaji Shi",
                        "latitude": "34.49749000",
                        "longitude": "134.91331000"
                    },
                    {
                        "id": 63367,
                        "name": "Fukura",
                        "latitude": "34.25765000",
                        "longitude": "134.71535000"
                    },
                    {
                        "id": 63478,
                        "name": "Himeji",
                        "latitude": "34.81667000",
                        "longitude": "134.70000000"
                    },
                    {
                        "id": 63479,
                        "name": "Himeji Shi",
                        "latitude": "34.90134000",
                        "longitude": "134.66316000"
                    },
                    {
                        "id": 63608,
                        "name": "Itami",
                        "latitude": "34.78427000",
                        "longitude": "135.40126000"
                    },
                    {
                        "id": 63609,
                        "name": "Itami Shi",
                        "latitude": "34.78675000",
                        "longitude": "135.40562000"
                    },
                    {
                        "id": 63671,
                        "name": "Kakogawa Shi",
                        "latitude": "34.78472000",
                        "longitude": "134.84897000"
                    },
                    {
                        "id": 63672,
                        "name": "Kakogawachō-honmachi",
                        "latitude": "34.76943000",
                        "longitude": "134.82905000"
                    },
                    {
                        "id": 63724,
                        "name": "Kariya",
                        "latitude": "34.75136000",
                        "longitude": "134.38734000"
                    },
                    {
                        "id": 63726,
                        "name": "Kasai Shi",
                        "latitude": "34.92476000",
                        "longitude": "134.85359000"
                    },
                    {
                        "id": 63765,
                        "name": "Katō Shi",
                        "latitude": "34.92714000",
                        "longitude": "135.02134000"
                    },
                    {
                        "id": 63772,
                        "name": "Kawanishi",
                        "latitude": "34.81667000",
                        "longitude": "135.41667000"
                    },
                    {
                        "id": 63773,
                        "name": "Kawanishi Shi",
                        "latitude": "34.87955000",
                        "longitude": "135.40919000"
                    },
                    {
                        "id": 63820,
                        "name": "Kobe",
                        "latitude": "34.69130000",
                        "longitude": "135.18300000"
                    },
                    {
                        "id": 63953,
                        "name": "Miki",
                        "latitude": "34.80000000",
                        "longitude": "134.98333000"
                    },
                    {
                        "id": 63954,
                        "name": "Miki Shi",
                        "latitude": "34.83553000",
                        "longitude": "135.05822000"
                    },
                    {
                        "id": 63965,
                        "name": "Minamiawaji Shi",
                        "latitude": "34.27530000",
                        "longitude": "134.76465000"
                    },
                    {
                        "id": 64148,
                        "name": "Nishinomiya Shi",
                        "latitude": "34.78194000",
                        "longitude": "135.30247000"
                    },
                    {
                        "id": 64149,
                        "name": "Nishinomiya-hama",
                        "latitude": "34.71562000",
                        "longitude": "135.33199000"
                    },
                    {
                        "id": 64156,
                        "name": "Nishiwaki",
                        "latitude": "34.98419000",
                        "longitude": "134.97407000"
                    },
                    {
                        "id": 64157,
                        "name": "Nishiwaki-shi",
                        "latitude": "35.01098000",
                        "longitude": "134.99650000"
                    },
                    {
                        "id": 64208,
                        "name": "Ono",
                        "latitude": "34.85000000",
                        "longitude": "134.93333000"
                    },
                    {
                        "id": 64210,
                        "name": "Ono Shi",
                        "latitude": "34.85750000",
                        "longitude": "134.95129000"
                    },
                    {
                        "id": 64276,
                        "name": "Sanda Shi",
                        "latitude": "34.95506000",
                        "longitude": "135.21660000"
                    },
                    {
                        "id": 64277,
                        "name": "Sandachō",
                        "latitude": "34.88444000",
                        "longitude": "135.22694000"
                    },
                    {
                        "id": 64288,
                        "name": "Sasayama",
                        "latitude": "35.06667000",
                        "longitude": "135.21667000"
                    },
                    {
                        "id": 64289,
                        "name": "Sasayama-shi",
                        "latitude": "35.07523000",
                        "longitude": "135.23087000"
                    },
                    {
                        "id": 64352,
                        "name": "Shirahamachō-usazakiminami",
                        "latitude": "34.78333000",
                        "longitude": "134.71667000"
                    },
                    {
                        "id": 64363,
                        "name": "Shisō-shi",
                        "latitude": "35.15466000",
                        "longitude": "134.54337000"
                    },
                    {
                        "id": 64384,
                        "name": "Sumoto",
                        "latitude": "34.34322000",
                        "longitude": "134.88911000"
                    },
                    {
                        "id": 64385,
                        "name": "Sumoto Shi",
                        "latitude": "34.34533000",
                        "longitude": "134.85858000"
                    },
                    {
                        "id": 64418,
                        "name": "Taka-gun",
                        "latitude": "35.08473000",
                        "longitude": "134.90474000"
                    },
                    {
                        "id": 64433,
                        "name": "Takarazuka",
                        "latitude": "34.79936000",
                        "longitude": "135.35697000"
                    },
                    {
                        "id": 64434,
                        "name": "Takarazuka Shi",
                        "latitude": "34.86008000",
                        "longitude": "135.33197000"
                    },
                    {
                        "id": 64435,
                        "name": "Takasago Shi",
                        "latitude": "34.77796000",
                        "longitude": "134.78665000"
                    },
                    {
                        "id": 64466,
                        "name": "Tanba-shi",
                        "latitude": "35.17715000",
                        "longitude": "135.04972000"
                    },
                    {
                        "id": 64477,
                        "name": "Tatsuno-shi",
                        "latitude": "34.88804000",
                        "longitude": "134.51910000"
                    },
                    {
                        "id": 64478,
                        "name": "Tatsunochō-tominaga",
                        "latitude": "34.86437000",
                        "longitude": "134.55200000"
                    },
                    {
                        "id": 64531,
                        "name": "Toyooka",
                        "latitude": "35.54008000",
                        "longitude": "134.82038000"
                    },
                    {
                        "id": 64532,
                        "name": "Toyooka-shi",
                        "latitude": "35.51384000",
                        "longitude": "134.82724000"
                    },
                    {
                        "id": 64627,
                        "name": "Yabu",
                        "latitude": "35.40304000",
                        "longitude": "134.77118000"
                    },
                    {
                        "id": 64628,
                        "name": "Yabu-shi",
                        "latitude": "35.38333000",
                        "longitude": "134.81667000"
                    },
                    {
                        "id": 64647,
                        "name": "Yamazakichō-nakabirose",
                        "latitude": "35.00000000",
                        "longitude": "134.55000000"
                    },
                    {
                        "id": 64658,
                        "name": "Yashiro",
                        "latitude": "34.91667000",
                        "longitude": "134.96667000"
                    },
                    {
                        "id": 64678,
                        "name": "Yonedacho Sendo",
                        "latitude": "34.77560000",
                        "longitude": "134.82551000"
                    }
                ]
            },
            {
                "id": 851,
                "name": "Ibaraki",
                "iso2": "08",
                "latitude": "36.21935710",
                "longitude": "140.18325160",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63244,
                        "name": "Ami",
                        "latitude": "36.03333000",
                        "longitude": "140.20000000"
                    },
                    {
                        "id": 63281,
                        "name": "Bandō",
                        "latitude": "36.06997000",
                        "longitude": "139.86705000"
                    },
                    {
                        "id": 63282,
                        "name": "Bandō-shi",
                        "latitude": "36.06384000",
                        "longitude": "139.88787000"
                    },
                    {
                        "id": 63300,
                        "name": "Chikusei",
                        "latitude": "36.31600000",
                        "longitude": "139.98238000"
                    },
                    {
                        "id": 63301,
                        "name": "Chikusei-shi",
                        "latitude": "36.28938000",
                        "longitude": "139.98692000"
                    },
                    {
                        "id": 63317,
                        "name": "Daigo",
                        "latitude": "36.76667000",
                        "longitude": "140.35000000"
                    },
                    {
                        "id": 63331,
                        "name": "Edosaki",
                        "latitude": "35.95000000",
                        "longitude": "140.31667000"
                    },
                    {
                        "id": 63354,
                        "name": "Fujishiro",
                        "latitude": "35.91667000",
                        "longitude": "140.11667000"
                    },
                    {
                        "id": 63376,
                        "name": "Funaishikawa",
                        "latitude": "36.46667000",
                        "longitude": "140.56667000"
                    },
                    {
                        "id": 63504,
                        "name": "Hitachi",
                        "latitude": "36.60000000",
                        "longitude": "140.65000000"
                    },
                    {
                        "id": 63505,
                        "name": "Hitachi-Naka",
                        "latitude": "36.39659000",
                        "longitude": "140.53479000"
                    },
                    {
                        "id": 63506,
                        "name": "Hitachi-ota",
                        "latitude": "36.55130000",
                        "longitude": "140.52821000"
                    },
                    {
                        "id": 63507,
                        "name": "Hitachi-shi",
                        "latitude": "36.62492000",
                        "longitude": "140.61876000"
                    },
                    {
                        "id": 63508,
                        "name": "Hitachinaka-shi",
                        "latitude": "36.39596000",
                        "longitude": "140.55789000"
                    },
                    {
                        "id": 63509,
                        "name": "Hitachiōmiya-shi",
                        "latitude": "36.61371000",
                        "longitude": "140.33990000"
                    },
                    {
                        "id": 63510,
                        "name": "Hitachiōta-shi",
                        "latitude": "36.64836000",
                        "longitude": "140.50536000"
                    },
                    {
                        "id": 63515,
                        "name": "Hokota-shi",
                        "latitude": "36.17337000",
                        "longitude": "140.51993000"
                    },
                    {
                        "id": 63570,
                        "name": "Inashiki",
                        "latitude": "35.95633000",
                        "longitude": "140.32356000"
                    },
                    {
                        "id": 63571,
                        "name": "Inashiki-shi",
                        "latitude": "35.94563000",
                        "longitude": "140.36889000"
                    },
                    {
                        "id": 63592,
                        "name": "Ishige",
                        "latitude": "36.11667000",
                        "longitude": "139.96667000"
                    },
                    {
                        "id": 63601,
                        "name": "Ishioka",
                        "latitude": "36.18333000",
                        "longitude": "140.26667000"
                    },
                    {
                        "id": 63602,
                        "name": "Ishioka-shi",
                        "latitude": "36.22776000",
                        "longitude": "140.21786000"
                    },
                    {
                        "id": 63606,
                        "name": "Itako",
                        "latitude": "35.93333000",
                        "longitude": "140.55000000"
                    },
                    {
                        "id": 63607,
                        "name": "Itako-shi",
                        "latitude": "35.96100000",
                        "longitude": "140.56210000"
                    },
                    {
                        "id": 63620,
                        "name": "Iwai",
                        "latitude": "36.05000000",
                        "longitude": "139.90000000"
                    },
                    {
                        "id": 63631,
                        "name": "Iwase",
                        "latitude": "36.35000000",
                        "longitude": "140.10000000"
                    },
                    {
                        "id": 63653,
                        "name": "Jōsō-shi",
                        "latitude": "36.06409000",
                        "longitude": "139.96397000"
                    },
                    {
                        "id": 63698,
                        "name": "Kamisu-shi",
                        "latitude": "35.85126000",
                        "longitude": "140.71171000"
                    },
                    {
                        "id": 63727,
                        "name": "Kasama",
                        "latitude": "36.38333000",
                        "longitude": "140.26667000"
                    },
                    {
                        "id": 63728,
                        "name": "Kasama-shi",
                        "latitude": "36.35651000",
                        "longitude": "140.26935000"
                    },
                    {
                        "id": 63738,
                        "name": "Kashima-shi",
                        "latitude": "35.96536000",
                        "longitude": "140.64474000"
                    },
                    {
                        "id": 63749,
                        "name": "Kasumigaura",
                        "latitude": "36.15326000",
                        "longitude": "140.24635000"
                    },
                    {
                        "id": 63750,
                        "name": "Kasumigaura-shi",
                        "latitude": "36.10937000",
                        "longitude": "140.30205000"
                    },
                    {
                        "id": 63759,
                        "name": "Katsuta",
                        "latitude": "36.38333000",
                        "longitude": "140.53333000"
                    },
                    {
                        "id": 63802,
                        "name": "Kitaibaraki",
                        "latitude": "36.78671000",
                        "longitude": "140.74901000"
                    },
                    {
                        "id": 63803,
                        "name": "Kitaibaraki-shi",
                        "latitude": "36.83987000",
                        "longitude": "140.68736000"
                    },
                    {
                        "id": 63824,
                        "name": "Koga",
                        "latitude": "36.18333000",
                        "longitude": "139.71667000"
                    },
                    {
                        "id": 63826,
                        "name": "Koga-shi",
                        "latitude": "36.17975000",
                        "longitude": "139.77534000"
                    },
                    {
                        "id": 63914,
                        "name": "Makabe",
                        "latitude": "36.26667000",
                        "longitude": "140.10000000"
                    },
                    {
                        "id": 63990,
                        "name": "Mito",
                        "latitude": "36.35000000",
                        "longitude": "140.45000000"
                    },
                    {
                        "id": 63991,
                        "name": "Mito-shi",
                        "latitude": "36.37053000",
                        "longitude": "140.43559000"
                    },
                    {
                        "id": 63993,
                        "name": "Mitsukaidō",
                        "latitude": "36.01667000",
                        "longitude": "139.98333000"
                    },
                    {
                        "id": 64032,
                        "name": "Moriya",
                        "latitude": "35.93333000",
                        "longitude": "140.00000000"
                    },
                    {
                        "id": 64033,
                        "name": "Moriya-shi",
                        "latitude": "35.95140000",
                        "longitude": "139.97539000"
                    },
                    {
                        "id": 64081,
                        "name": "Naka",
                        "latitude": "36.05000000",
                        "longitude": "140.16667000"
                    },
                    {
                        "id": 64082,
                        "name": "Naka-gun",
                        "latitude": "36.46934000",
                        "longitude": "140.47943000"
                    },
                    {
                        "id": 64093,
                        "name": "Namegata",
                        "latitude": "36.00705000",
                        "longitude": "140.49623000"
                    },
                    {
                        "id": 64094,
                        "name": "Namegata-shi",
                        "latitude": "36.06526000",
                        "longitude": "140.47173000"
                    },
                    {
                        "id": 64714,
                        "name": "Ōarai",
                        "latitude": "36.31409000",
                        "longitude": "140.58389000"
                    },
                    {
                        "id": 64202,
                        "name": "Okunoya",
                        "latitude": "36.28333000",
                        "longitude": "140.41667000"
                    },
                    {
                        "id": 64205,
                        "name": "Omitama-shi",
                        "latitude": "36.20403000",
                        "longitude": "140.35980000"
                    },
                    {
                        "id": 64742,
                        "name": "Ōmiya",
                        "latitude": "36.55000000",
                        "longitude": "140.41667000"
                    },
                    {
                        "id": 64233,
                        "name": "Ryūgasaki",
                        "latitude": "35.90000000",
                        "longitude": "140.18333000"
                    },
                    {
                        "id": 64234,
                        "name": "Ryūgasaki-shi",
                        "latitude": "35.92249000",
                        "longitude": "140.18527000"
                    },
                    {
                        "id": 64255,
                        "name": "Sakai",
                        "latitude": "36.10000000",
                        "longitude": "139.80000000"
                    },
                    {
                        "id": 64271,
                        "name": "Sakuragawa",
                        "latitude": "36.25052000",
                        "longitude": "140.11565000"
                    },
                    {
                        "id": 64272,
                        "name": "Sakuragawa-shi",
                        "latitude": "36.32746000",
                        "longitude": "140.10792000"
                    },
                    {
                        "id": 64332,
                        "name": "Shimodate",
                        "latitude": "36.30000000",
                        "longitude": "139.98333000"
                    },
                    {
                        "id": 64337,
                        "name": "Shimotsuma-shi",
                        "latitude": "36.18743000",
                        "longitude": "139.96642000"
                    },
                    {
                        "id": 64419,
                        "name": "Takahagi",
                        "latitude": "36.71667000",
                        "longitude": "140.71667000"
                    },
                    {
                        "id": 64510,
                        "name": "Tomobe",
                        "latitude": "36.35000000",
                        "longitude": "140.30000000"
                    },
                    {
                        "id": 64515,
                        "name": "Toride",
                        "latitude": "35.90000000",
                        "longitude": "140.08333000"
                    },
                    {
                        "id": 64516,
                        "name": "Toride-shi",
                        "latitude": "35.91286000",
                        "longitude": "140.08009000"
                    },
                    {
                        "id": 64540,
                        "name": "Tsuchiura-shi",
                        "latitude": "36.08333000",
                        "longitude": "140.20000000"
                    },
                    {
                        "id": 64545,
                        "name": "Tsukuba",
                        "latitude": "36.20000000",
                        "longitude": "140.10000000"
                    },
                    {
                        "id": 64546,
                        "name": "Tsukuba-shi",
                        "latitude": "36.10532000",
                        "longitude": "140.08174000"
                    },
                    {
                        "id": 64547,
                        "name": "Tsukubamirai",
                        "latitude": "35.98411000",
                        "longitude": "140.00929000"
                    },
                    {
                        "id": 64548,
                        "name": "Tsukubamirai-shi",
                        "latitude": "35.98201000",
                        "longitude": "140.03812000"
                    },
                    {
                        "id": 64603,
                        "name": "Ushiku",
                        "latitude": "35.96667000",
                        "longitude": "140.13333000"
                    },
                    {
                        "id": 64604,
                        "name": "Ushiku-shi",
                        "latitude": "35.97175000",
                        "longitude": "140.18578000"
                    },
                    {
                        "id": 64706,
                        "name": "Yūki",
                        "latitude": "36.30000000",
                        "longitude": "139.88333000"
                    },
                    {
                        "id": 64707,
                        "name": "Yūki-shi",
                        "latitude": "36.26127000",
                        "longitude": "139.86403000"
                    }
                ]
            },
            {
                "id": 830,
                "name": "Ishikawa",
                "iso2": "17",
                "latitude": "36.32603170",
                "longitude": "136.52896530",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63420,
                        "name": "Hakui",
                        "latitude": "36.88333000",
                        "longitude": "136.78333000"
                    },
                    {
                        "id": 63421,
                        "name": "Hakui Shi",
                        "latitude": "36.91136000",
                        "longitude": "136.81626000"
                    },
                    {
                        "id": 63422,
                        "name": "Hakusan Shi",
                        "latitude": "36.27558000",
                        "longitude": "136.66966000"
                    },
                    {
                        "id": 63657,
                        "name": "Kaga Shi",
                        "latitude": "36.25503000",
                        "longitude": "136.37963000"
                    },
                    {
                        "id": 63660,
                        "name": "Kahoku Shi",
                        "latitude": "36.74365000",
                        "longitude": "136.73273000"
                    },
                    {
                        "id": 63706,
                        "name": "Kanazawa",
                        "latitude": "36.60000000",
                        "longitude": "136.61667000"
                    },
                    {
                        "id": 63707,
                        "name": "Kanazawa-shi",
                        "latitude": "36.51919000",
                        "longitude": "136.70836000"
                    },
                    {
                        "id": 63837,
                        "name": "Komatsu",
                        "latitude": "36.40263000",
                        "longitude": "136.45088000"
                    },
                    {
                        "id": 63938,
                        "name": "Matsutō",
                        "latitude": "36.51667000",
                        "longitude": "136.56667000"
                    },
                    {
                        "id": 64099,
                        "name": "Nanao Shi",
                        "latitude": "37.07844000",
                        "longitude": "136.92860000"
                    },
                    {
                        "id": 64165,
                        "name": "Nomi Shi",
                        "latitude": "36.43593000",
                        "longitude": "136.54456000"
                    },
                    {
                        "id": 64166,
                        "name": "Nonoichi",
                        "latitude": "36.53333000",
                        "longitude": "136.61667000"
                    },
                    {
                        "id": 64167,
                        "name": "Nonoichi-shi",
                        "latitude": "36.52288000",
                        "longitude": "136.60589000"
                    },
                    {
                        "id": 64394,
                        "name": "Suzu",
                        "latitude": "37.43459000",
                        "longitude": "137.26009000"
                    },
                    {
                        "id": 64395,
                        "name": "Suzu Shi",
                        "latitude": "37.45533000",
                        "longitude": "137.22587000"
                    },
                    {
                        "id": 64539,
                        "name": "Tsubata",
                        "latitude": "36.67012000",
                        "longitude": "136.74030000"
                    },
                    {
                        "id": 64556,
                        "name": "Tsurugi-asahimachi",
                        "latitude": "36.45000000",
                        "longitude": "136.63333000"
                    },
                    {
                        "id": 64615,
                        "name": "Wajima Shi",
                        "latitude": "37.33753000",
                        "longitude": "136.88757000"
                    }
                ]
            },
            {
                "id": 856,
                "name": "Iwate",
                "iso2": "03",
                "latitude": "39.58329890",
                "longitude": "141.25345740",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63406,
                        "name": "Hachimantai",
                        "latitude": "39.89979000",
                        "longitude": "141.12989000"
                    },
                    {
                        "id": 63407,
                        "name": "Hachimantai Shi",
                        "latitude": "40.02390000",
                        "longitude": "140.99113000"
                    },
                    {
                        "id": 63430,
                        "name": "Hanamaki",
                        "latitude": "39.38333000",
                        "longitude": "141.11667000"
                    },
                    {
                        "id": 63431,
                        "name": "Hanamaki Shi",
                        "latitude": "39.44187000",
                        "longitude": "141.16751000"
                    },
                    {
                        "id": 63541,
                        "name": "Ichinohe",
                        "latitude": "40.21965000",
                        "longitude": "141.28986000"
                    },
                    {
                        "id": 63544,
                        "name": "Ichinoseki",
                        "latitude": "38.91667000",
                        "longitude": "141.13333000"
                    },
                    {
                        "id": 63545,
                        "name": "Ichinoseki-shi",
                        "latitude": "38.91667000",
                        "longitude": "141.13333000"
                    },
                    {
                        "id": 63634,
                        "name": "Iwate-gun",
                        "latitude": "39.97238000",
                        "longitude": "141.22719000"
                    },
                    {
                        "id": 63678,
                        "name": "Kamaishi",
                        "latitude": "39.27694000",
                        "longitude": "141.86801000"
                    },
                    {
                        "id": 63679,
                        "name": "Kamaishi-shi",
                        "latitude": "39.28748000",
                        "longitude": "141.79854000"
                    },
                    {
                        "id": 63804,
                        "name": "Kitakami",
                        "latitude": "39.28333000",
                        "longitude": "141.11667000"
                    },
                    {
                        "id": 63805,
                        "name": "Kitakami-shi",
                        "latitude": "39.30765000",
                        "longitude": "141.00795000"
                    },
                    {
                        "id": 63854,
                        "name": "Kuji",
                        "latitude": "40.18778000",
                        "longitude": "141.76889000"
                    },
                    {
                        "id": 63855,
                        "name": "Kuji-shi",
                        "latitude": "40.14364000",
                        "longitude": "141.65918000"
                    },
                    {
                        "id": 64000,
                        "name": "Miyako",
                        "latitude": "39.64691000",
                        "longitude": "141.94057000"
                    },
                    {
                        "id": 64001,
                        "name": "Miyako-shi",
                        "latitude": "39.65724000",
                        "longitude": "141.85144000"
                    },
                    {
                        "id": 64021,
                        "name": "Mizusawa",
                        "latitude": "39.13333000",
                        "longitude": "141.13333000"
                    },
                    {
                        "id": 64030,
                        "name": "Morioka",
                        "latitude": "39.70000000",
                        "longitude": "141.15000000"
                    },
                    {
                        "id": 64031,
                        "name": "Morioka-shi",
                        "latitude": "39.74546000",
                        "longitude": "141.26915000"
                    },
                    {
                        "id": 64140,
                        "name": "Ninohe",
                        "latitude": "40.29081000",
                        "longitude": "141.31334000"
                    },
                    {
                        "id": 64141,
                        "name": "Ninohe Shi",
                        "latitude": "40.23798000",
                        "longitude": "141.19576000"
                    },
                    {
                        "id": 64721,
                        "name": "Ōfunato",
                        "latitude": "39.07167000",
                        "longitude": "141.71667000"
                    },
                    {
                        "id": 64722,
                        "name": "Ōfunato-shi",
                        "latitude": "39.06667000",
                        "longitude": "141.71667000"
                    },
                    {
                        "id": 64755,
                        "name": "Ōshū",
                        "latitude": "39.13927000",
                        "longitude": "141.16850000"
                    },
                    {
                        "id": 64756,
                        "name": "Ōshū-shi",
                        "latitude": "39.12962000",
                        "longitude": "141.09479000"
                    },
                    {
                        "id": 64765,
                        "name": "Ōtsuchi",
                        "latitude": "39.36667000",
                        "longitude": "141.90000000"
                    },
                    {
                        "id": 64226,
                        "name": "Rikuzentakata-shi",
                        "latitude": "39.04082000",
                        "longitude": "141.57703000"
                    },
                    {
                        "id": 64364,
                        "name": "Shizukuishi",
                        "latitude": "39.69414000",
                        "longitude": "140.98442000"
                    },
                    {
                        "id": 64453,
                        "name": "Takizawa-shi",
                        "latitude": "39.80000000",
                        "longitude": "141.06667000"
                    },
                    {
                        "id": 64573,
                        "name": "Tōno",
                        "latitude": "39.31667000",
                        "longitude": "141.53333000"
                    },
                    {
                        "id": 64574,
                        "name": "Tōno-shi",
                        "latitude": "39.36479000",
                        "longitude": "141.50922000"
                    },
                    {
                        "id": 64636,
                        "name": "Yamada",
                        "latitude": "39.46667000",
                        "longitude": "141.95000000"
                    }
                ]
            },
            {
                "id": 864,
                "name": "Kagawa",
                "iso2": "37",
                "latitude": "34.22259150",
                "longitude": "134.01991520",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63460,
                        "name": "Higashikagawa Shi",
                        "latitude": "34.21158000",
                        "longitude": "134.33350000"
                    },
                    {
                        "id": 63718,
                        "name": "Kan’onji Shi",
                        "latitude": "34.08457000",
                        "longitude": "133.67448000"
                    },
                    {
                        "id": 63719,
                        "name": "Kan’onjichō",
                        "latitude": "34.12760000",
                        "longitude": "133.64598000"
                    },
                    {
                        "id": 63921,
                        "name": "Marugame",
                        "latitude": "34.28333000",
                        "longitude": "133.78333000"
                    },
                    {
                        "id": 63922,
                        "name": "Marugame Shi",
                        "latitude": "34.28560000",
                        "longitude": "133.81535000"
                    },
                    {
                        "id": 63992,
                        "name": "Mitoyo Shi",
                        "latitude": "34.16176000",
                        "longitude": "133.72282000"
                    },
                    {
                        "id": 64260,
                        "name": "Sakaide Shi",
                        "latitude": "34.32403000",
                        "longitude": "133.89222000"
                    },
                    {
                        "id": 64261,
                        "name": "Sakaidechō",
                        "latitude": "34.32278000",
                        "longitude": "133.83560000"
                    },
                    {
                        "id": 64283,
                        "name": "Sanuki-shi",
                        "latitude": "34.26615000",
                        "longitude": "134.20941000"
                    },
                    {
                        "id": 64317,
                        "name": "Shido",
                        "latitude": "34.32333000",
                        "longitude": "134.17333000"
                    },
                    {
                        "id": 64406,
                        "name": "Tadotsu",
                        "latitude": "34.27500000",
                        "longitude": "133.75000000"
                    },
                    {
                        "id": 64427,
                        "name": "Takamatsu",
                        "latitude": "34.33333000",
                        "longitude": "134.05000000"
                    },
                    {
                        "id": 64428,
                        "name": "Takamatsu Shi",
                        "latitude": "34.26852000",
                        "longitude": "134.05450000"
                    },
                    {
                        "id": 64514,
                        "name": "Tonoshō",
                        "latitude": "34.48047000",
                        "longitude": "134.17017000"
                    },
                    {
                        "id": 64710,
                        "name": "Zentsūji Shi",
                        "latitude": "34.22581000",
                        "longitude": "133.77692000"
                    }
                ]
            },
            {
                "id": 840,
                "name": "Kagoshima",
                "iso2": "46",
                "latitude": "31.39119580",
                "longitude": "130.87785860",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63222,
                        "name": "Aira Shi",
                        "latitude": "31.78460000",
                        "longitude": "130.60668000"
                    },
                    {
                        "id": 63235,
                        "name": "Akune",
                        "latitude": "32.01667000",
                        "longitude": "130.20000000"
                    },
                    {
                        "id": 63236,
                        "name": "Akune Shi",
                        "latitude": "32.02516000",
                        "longitude": "130.19768000"
                    },
                    {
                        "id": 63242,
                        "name": "Amami",
                        "latitude": "28.37690000",
                        "longitude": "129.49379000"
                    },
                    {
                        "id": 63243,
                        "name": "Amami Shi",
                        "latitude": "28.34542000",
                        "longitude": "129.50221000"
                    },
                    {
                        "id": 63428,
                        "name": "Hamanoichi",
                        "latitude": "31.71667000",
                        "longitude": "130.73333000"
                    },
                    {
                        "id": 63485,
                        "name": "Hioki",
                        "latitude": "31.58333000",
                        "longitude": "130.35000000"
                    },
                    {
                        "id": 63486,
                        "name": "Hioki Shi",
                        "latitude": "31.59929000",
                        "longitude": "130.38208000"
                    },
                    {
                        "id": 63535,
                        "name": "Ibusuki",
                        "latitude": "31.23333000",
                        "longitude": "130.65000000"
                    },
                    {
                        "id": 63536,
                        "name": "Ibusuki Shi",
                        "latitude": "31.22962000",
                        "longitude": "130.58060000"
                    },
                    {
                        "id": 63540,
                        "name": "Ichikikushikino Shi",
                        "latitude": "31.73281000",
                        "longitude": "130.28893000"
                    },
                    {
                        "id": 63553,
                        "name": "Ijūin",
                        "latitude": "31.61667000",
                        "longitude": "130.40000000"
                    },
                    {
                        "id": 63580,
                        "name": "Isa Shi",
                        "latitude": "32.05835000",
                        "longitude": "130.60104000"
                    },
                    {
                        "id": 63641,
                        "name": "Izumi",
                        "latitude": "32.08333000",
                        "longitude": "130.36667000"
                    },
                    {
                        "id": 63642,
                        "name": "Izumi Shi",
                        "latitude": "32.06412000",
                        "longitude": "130.36097000"
                    },
                    {
                        "id": 63658,
                        "name": "Kagoshima",
                        "latitude": "31.56667000",
                        "longitude": "130.55000000"
                    },
                    {
                        "id": 63659,
                        "name": "Kagoshima Shi",
                        "latitude": "31.58003000",
                        "longitude": "130.52806000"
                    },
                    {
                        "id": 63667,
                        "name": "Kajiki",
                        "latitude": "31.73333000",
                        "longitude": "130.66667000"
                    },
                    {
                        "id": 63713,
                        "name": "Kanoya",
                        "latitude": "31.38333000",
                        "longitude": "130.85000000"
                    },
                    {
                        "id": 63714,
                        "name": "Kanoya Shi",
                        "latitude": "31.42664000",
                        "longitude": "130.86735000"
                    },
                    {
                        "id": 63732,
                        "name": "Kaseda-shirakame",
                        "latitude": "31.41667000",
                        "longitude": "130.31667000"
                    },
                    {
                        "id": 63789,
                        "name": "Kirishima Shi",
                        "latitude": "31.80558000",
                        "longitude": "130.78164000"
                    },
                    {
                        "id": 63829,
                        "name": "Kokubu-matsuki",
                        "latitude": "31.73333000",
                        "longitude": "130.76667000"
                    },
                    {
                        "id": 63847,
                        "name": "Koseda",
                        "latitude": "30.38796000",
                        "longitude": "130.64924000"
                    },
                    {
                        "id": 63849,
                        "name": "Koshima",
                        "latitude": "30.23461000",
                        "longitude": "130.53517000"
                    },
                    {
                        "id": 63873,
                        "name": "Kurio",
                        "latitude": "30.27123000",
                        "longitude": "130.42360000"
                    },
                    {
                        "id": 63883,
                        "name": "Kushikino",
                        "latitude": "31.71667000",
                        "longitude": "130.26667000"
                    },
                    {
                        "id": 63918,
                        "name": "Makurazaki",
                        "latitude": "31.26667000",
                        "longitude": "130.31667000"
                    },
                    {
                        "id": 63919,
                        "name": "Makurazaki Shi",
                        "latitude": "31.29139000",
                        "longitude": "130.30681000"
                    },
                    {
                        "id": 63967,
                        "name": "Minamikyushu Shi",
                        "latitude": "31.34038000",
                        "longitude": "130.43677000"
                    },
                    {
                        "id": 63969,
                        "name": "Minamisatsuma Shi",
                        "latitude": "31.38793000",
                        "longitude": "130.26961000"
                    },
                    {
                        "id": 64006,
                        "name": "Miyanoura",
                        "latitude": "30.42690000",
                        "longitude": "130.57151000"
                    },
                    {
                        "id": 64073,
                        "name": "Nagata",
                        "latitude": "30.39516000",
                        "longitude": "130.42548000"
                    },
                    {
                        "id": 64119,
                        "name": "Naze",
                        "latitude": "28.36667000",
                        "longitude": "129.48333000"
                    },
                    {
                        "id": 64150,
                        "name": "Nishinoomote",
                        "latitude": "30.73333000",
                        "longitude": "131.00000000"
                    },
                    {
                        "id": 64151,
                        "name": "Nishinoomote Shi",
                        "latitude": "30.70536000",
                        "longitude": "131.01521000"
                    },
                    {
                        "id": 64733,
                        "name": "Ōkuchi-shinohara",
                        "latitude": "32.06779000",
                        "longitude": "130.62439000"
                    },
                    {
                        "id": 64291,
                        "name": "Satsumasendai",
                        "latitude": "31.81667000",
                        "longitude": "130.30000000"
                    },
                    {
                        "id": 64292,
                        "name": "Satsumasendai Shi",
                        "latitude": "31.82376000",
                        "longitude": "130.25899000"
                    },
                    {
                        "id": 64314,
                        "name": "Shibushi",
                        "latitude": "31.47600000",
                        "longitude": "131.10114000"
                    },
                    {
                        "id": 64315,
                        "name": "Shibushi-shi",
                        "latitude": "31.48333000",
                        "longitude": "131.10000000"
                    },
                    {
                        "id": 64374,
                        "name": "Soo Shi",
                        "latitude": "31.65615000",
                        "longitude": "130.97470000"
                    },
                    {
                        "id": 64375,
                        "name": "Sueyoshichō-ninokata",
                        "latitude": "31.65000000",
                        "longitude": "131.01667000"
                    },
                    {
                        "id": 64470,
                        "name": "Tarumizu",
                        "latitude": "31.48333000",
                        "longitude": "130.70000000"
                    },
                    {
                        "id": 64471,
                        "name": "Tarumizu Shi",
                        "latitude": "31.51583000",
                        "longitude": "130.76046000"
                    },
                    {
                        "id": 64693,
                        "name": "Yudomari",
                        "latitude": "30.23470000",
                        "longitude": "130.47942000"
                    }
                ]
            },
            {
                "id": 842,
                "name": "Kanagawa",
                "iso2": "14",
                "latitude": "35.49135350",
                "longitude": "139.28414300",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63272,
                        "name": "Atsugi",
                        "latitude": "35.44272000",
                        "longitude": "139.36931000"
                    },
                    {
                        "id": 63273,
                        "name": "Atsugi Shi",
                        "latitude": "35.46513000",
                        "longitude": "139.32707000"
                    },
                    {
                        "id": 63279,
                        "name": "Ayase Shi",
                        "latitude": "35.43995000",
                        "longitude": "139.43089000"
                    },
                    {
                        "id": 63296,
                        "name": "Chigasaki",
                        "latitude": "35.33638000",
                        "longitude": "139.40434000"
                    },
                    {
                        "id": 63297,
                        "name": "Chigasaki Shi",
                        "latitude": "35.34429000",
                        "longitude": "139.40958000"
                    },
                    {
                        "id": 63327,
                        "name": "Ebina Shi",
                        "latitude": "35.43762000",
                        "longitude": "139.39307000"
                    },
                    {
                        "id": 63352,
                        "name": "Fujisawa",
                        "latitude": "35.34926000",
                        "longitude": "139.47666000"
                    },
                    {
                        "id": 63353,
                        "name": "Fujisawa Shi",
                        "latitude": "35.36814000",
                        "longitude": "139.45899000"
                    },
                    {
                        "id": 63411,
                        "name": "Hadano",
                        "latitude": "35.37111000",
                        "longitude": "139.22361000"
                    },
                    {
                        "id": 63412,
                        "name": "Hadano-shi",
                        "latitude": "35.40000000",
                        "longitude": "139.20000000"
                    },
                    {
                        "id": 63418,
                        "name": "Hakone",
                        "latitude": "35.18945000",
                        "longitude": "139.02649000"
                    },
                    {
                        "id": 63451,
                        "name": "Hayama",
                        "latitude": "35.27651000",
                        "longitude": "139.57733000"
                    },
                    {
                        "id": 63495,
                        "name": "Hiratsuka",
                        "latitude": "35.32785000",
                        "longitude": "139.33735000"
                    },
                    {
                        "id": 63496,
                        "name": "Hiratsuka Shi",
                        "latitude": "35.35099000",
                        "longitude": "139.32013000"
                    },
                    {
                        "id": 63586,
                        "name": "Isehara",
                        "latitude": "35.39932000",
                        "longitude": "139.31019000"
                    },
                    {
                        "id": 63587,
                        "name": "Isehara Shi",
                        "latitude": "35.41011000",
                        "longitude": "139.29203000"
                    },
                    {
                        "id": 63680,
                        "name": "Kamakura",
                        "latitude": "35.30889000",
                        "longitude": "139.55028000"
                    },
                    {
                        "id": 63681,
                        "name": "Kamakura Shi",
                        "latitude": "35.33000000",
                        "longitude": "139.53798000"
                    },
                    {
                        "id": 63775,
                        "name": "Kawasaki",
                        "latitude": "35.52056000",
                        "longitude": "139.71722000"
                    },
                    {
                        "id": 63777,
                        "name": "Kawasaki-shi",
                        "latitude": "35.56996000",
                        "longitude": "139.62854000"
                    },
                    {
                        "id": 63963,
                        "name": "Minamiashigara",
                        "latitude": "35.31947000",
                        "longitude": "139.10960000"
                    },
                    {
                        "id": 63964,
                        "name": "Minamiashigara Shi",
                        "latitude": "35.30991000",
                        "longitude": "139.07016000"
                    },
                    {
                        "id": 63968,
                        "name": "Minamirinkan",
                        "latitude": "35.49527000",
                        "longitude": "139.44279000"
                    },
                    {
                        "id": 63996,
                        "name": "Miura",
                        "latitude": "35.14000000",
                        "longitude": "139.61917000"
                    },
                    {
                        "id": 63997,
                        "name": "Miura Shi",
                        "latitude": "35.16754000",
                        "longitude": "139.64104000"
                    },
                    {
                        "id": 64142,
                        "name": "Ninomiya",
                        "latitude": "35.30150000",
                        "longitude": "139.25581000"
                    },
                    {
                        "id": 64183,
                        "name": "Odawara",
                        "latitude": "35.25556000",
                        "longitude": "139.15972000"
                    },
                    {
                        "id": 64184,
                        "name": "Odawara-shi",
                        "latitude": "35.25000000",
                        "longitude": "139.13333000"
                    },
                    {
                        "id": 64727,
                        "name": "Ōiso",
                        "latitude": "35.31558000",
                        "longitude": "139.31625000"
                    },
                    {
                        "id": 64243,
                        "name": "Sagamihara-shi",
                        "latitude": "35.55000000",
                        "longitude": "139.35000000"
                    },
                    {
                        "id": 64642,
                        "name": "Yamakita",
                        "latitude": "35.36344000",
                        "longitude": "139.07975000"
                    },
                    {
                        "id": 64644,
                        "name": "Yamato-shi",
                        "latitude": "35.46934000",
                        "longitude": "139.46165000"
                    },
                    {
                        "id": 64670,
                        "name": "Yokohama",
                        "latitude": "35.43333000",
                        "longitude": "139.65000000"
                    },
                    {
                        "id": 64671,
                        "name": "Yokohama Shi",
                        "latitude": "35.46225000",
                        "longitude": "139.57645000"
                    },
                    {
                        "id": 64672,
                        "name": "Yokosuka",
                        "latitude": "35.28361000",
                        "longitude": "139.66722000"
                    },
                    {
                        "id": 64673,
                        "name": "Yokosuka Shi",
                        "latitude": "35.24985000",
                        "longitude": "139.66033000"
                    },
                    {
                        "id": 64695,
                        "name": "Yugawara",
                        "latitude": "35.15000000",
                        "longitude": "139.06667000"
                    },
                    {
                        "id": 64708,
                        "name": "Zama",
                        "latitude": "35.48790000",
                        "longitude": "139.39101000"
                    },
                    {
                        "id": 64709,
                        "name": "Zama Shi",
                        "latitude": "35.48752000",
                        "longitude": "139.40925000"
                    },
                    {
                        "id": 64711,
                        "name": "Zushi Shi",
                        "latitude": "35.29900000",
                        "longitude": "139.59125000"
                    }
                ]
            },
            {
                "id": 4924,
                "name": "Kōchi",
                "iso2": "39",
                "latitude": "33.28791610",
                "longitude": "132.27592620",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 148287,
                        "name": "Achi",
                        "latitude": "35.44388889",
                        "longitude": "137.74750000"
                    },
                    {
                        "id": 148214,
                        "name": "Agematsu",
                        "latitude": "35.78388889",
                        "longitude": "137.69416667"
                    },
                    {
                        "id": 148213,
                        "name": "Aki",
                        "latitude": "33.50250000",
                        "longitude": "133.90722222"
                    },
                    {
                        "id": 148279,
                        "name": "Anan",
                        "latitude": "35.32361111",
                        "longitude": "137.81611111"
                    },
                    {
                        "id": 148259,
                        "name": "Aoki",
                        "latitude": "36.37000000",
                        "longitude": "138.12861111"
                    },
                    {
                        "id": 148261,
                        "name": "Asahi",
                        "latitude": "36.12361111",
                        "longitude": "137.86638889"
                    },
                    {
                        "id": 148299,
                        "name": "Azumino",
                        "latitude": "36.30388889",
                        "longitude": "137.90555556"
                    },
                    {
                        "id": 148293,
                        "name": "Chikuhoku",
                        "latitude": "36.42120000",
                        "longitude": "138.04011000"
                    },
                    {
                        "id": 148298,
                        "name": "Chikuma",
                        "latitude": "36.50624000",
                        "longitude": "138.12352000"
                    },
                    {
                        "id": 148304,
                        "name": "Chino",
                        "latitude": "35.99555556",
                        "longitude": "138.15888889"
                    },
                    {
                        "id": 148225,
                        "name": "Fujimi",
                        "latitude": "35.91472222",
                        "longitude": "138.24083333"
                    },
                    {
                        "id": 148257,
                        "name": "Geisei",
                        "latitude": "33.52694444",
                        "longitude": "133.80916667"
                    },
                    {
                        "id": 148269,
                        "name": "Hakuba",
                        "latitude": "36.70000000",
                        "longitude": "137.86666667"
                    },
                    {
                        "id": 148274,
                        "name": "Hara",
                        "latitude": "35.96444444",
                        "longitude": "138.21750000"
                    },
                    {
                        "id": 148276,
                        "name": "Hidaka",
                        "latitude": "33.53472222",
                        "longitude": "133.37333333"
                    },
                    {
                        "id": 148286,
                        "name": "Hiraya",
                        "latitude": "35.32333333",
                        "longitude": "137.63027778"
                    },
                    {
                        "id": 148315,
                        "name": "Iida",
                        "latitude": "35.51472222",
                        "longitude": "137.82194444"
                    },
                    {
                        "id": 148236,
                        "name": "Iijima",
                        "latitude": "35.67638889",
                        "longitude": "137.91944444"
                    },
                    {
                        "id": 148312,
                        "name": "Iiyama",
                        "latitude": "36.85166667",
                        "longitude": "138.36555556"
                    },
                    {
                        "id": 148290,
                        "name": "Iizuna",
                        "latitude": "36.75500000",
                        "longitude": "138.23555556"
                    },
                    {
                        "id": 148284,
                        "name": "Ikeda",
                        "latitude": "36.42138889",
                        "longitude": "137.87472222"
                    },
                    {
                        "id": 148267,
                        "name": "Ikusaka",
                        "latitude": "36.42527778",
                        "longitude": "137.92750000"
                    },
                    {
                        "id": 148313,
                        "name": "Ina",
                        "latitude": "35.82750000",
                        "longitude": "137.95388889"
                    },
                    {
                        "id": 148305,
                        "name": "Ino",
                        "latitude": "33.55000000",
                        "longitude": "133.43333333"
                    },
                    {
                        "id": 148237,
                        "name": "Karuizawa",
                        "latitude": "36.34833333",
                        "longitude": "138.59694444"
                    },
                    {
                        "id": 148288,
                        "name": "Kawakami",
                        "latitude": "35.97555556",
                        "longitude": "138.57833333"
                    },
                    {
                        "id": 148264,
                        "name": "Kijimadaira",
                        "latitude": "36.85861111",
                        "longitude": "138.40666667"
                    },
                    {
                        "id": 148217,
                        "name": "Kiso",
                        "latitude": "35.93638889",
                        "longitude": "137.78305556"
                    },
                    {
                        "id": 148281,
                        "name": "Kitaaiki",
                        "latitude": "36.05916667",
                        "longitude": "138.55111111"
                    },
                    {
                        "id": 148289,
                        "name": "Kitagawa",
                        "latitude": "33.44777778",
                        "longitude": "134.04222222"
                    },
                    {
                        "id": 148317,
                        "name": "Kōchi",
                        "latitude": "33.55888889",
                        "longitude": "133.53138889"
                    },
                    {
                        "id": 148306,
                        "name": "Komoro",
                        "latitude": "36.32750000",
                        "longitude": "138.42583333"
                    },
                    {
                        "id": 148300,
                        "name": "Kōnan",
                        "latitude": "33.56416667",
                        "longitude": "133.70055556"
                    },
                    {
                        "id": 148280,
                        "name": "Kuroshio",
                        "latitude": "33.02500000",
                        "longitude": "133.01083333"
                    },
                    {
                        "id": 148252,
                        "name": "Matsukawa",
                        "latitude": "35.59722222",
                        "longitude": "137.90972222"
                    },
                    {
                        "id": 148292,
                        "name": "Matsumoto",
                        "latitude": "36.23805556",
                        "longitude": "137.97194444"
                    },
                    {
                        "id": 148227,
                        "name": "Mihara",
                        "latitude": "32.90611111",
                        "longitude": "132.84722222"
                    },
                    {
                        "id": 148256,
                        "name": "Minamiaiki",
                        "latitude": "36.03611111",
                        "longitude": "138.54694444"
                    },
                    {
                        "id": 148228,
                        "name": "Minamimaki",
                        "latitude": "36.02083333",
                        "longitude": "138.49222222"
                    },
                    {
                        "id": 148235,
                        "name": "Minamiminowa",
                        "latitude": "35.87277778",
                        "longitude": "137.97527778"
                    },
                    {
                        "id": 148254,
                        "name": "Minowa",
                        "latitude": "35.91500000",
                        "longitude": "137.98194444"
                    },
                    {
                        "id": 148247,
                        "name": "Mitsushima",
                        "latitude": "35.27525100",
                        "longitude": "137.85213700"
                    },
                    {
                        "id": 148265,
                        "name": "Miyada",
                        "latitude": "35.76888889",
                        "longitude": "137.94422222"
                    },
                    {
                        "id": 148291,
                        "name": "Miyota",
                        "latitude": "36.32138889",
                        "longitude": "138.50888889"
                    },
                    {
                        "id": 148215,
                        "name": "Motoyama",
                        "latitude": "35.16402778",
                        "longitude": "136.96361111"
                    },
                    {
                        "id": 148314,
                        "name": "Muroto",
                        "latitude": "33.29000000",
                        "longitude": "134.15194444"
                    },
                    {
                        "id": 148310,
                        "name": "Nagano",
                        "latitude": "36.64861111",
                        "longitude": "138.19277778"
                    },
                    {
                        "id": 148238,
                        "name": "Nagawa",
                        "latitude": "36.25611111",
                        "longitude": "138.26777778"
                    },
                    {
                        "id": 148263,
                        "name": "Nagiso",
                        "latitude": "35.60361111",
                        "longitude": "137.60888889"
                    },
                    {
                        "id": 148270,
                        "name": "Nahari",
                        "latitude": "33.42416667",
                        "longitude": "134.02111111"
                    },
                    {
                        "id": 148224,
                        "name": "Nakagawa",
                        "latitude": "35.63444444",
                        "longitude": "137.94611111"
                    },
                    {
                        "id": 148243,
                        "name": "Nakajō",
                        "latitude": "36.61222222",
                        "longitude": "138.03652778"
                    },
                    {
                        "id": 148245,
                        "name": "Nakamura",
                        "latitude": "32.99138889",
                        "longitude": "132.93375000"
                    },
                    {
                        "id": 148249,
                        "name": "Nakano",
                        "latitude": "36.74194444",
                        "longitude": "138.36944444"
                    },
                    {
                        "id": 148231,
                        "name": "Nakatosa",
                        "latitude": "33.32750000",
                        "longitude": "133.22833333"
                    },
                    {
                        "id": 148302,
                        "name": "Nankoku",
                        "latitude": "33.57555556",
                        "longitude": "133.64138889"
                    },
                    {
                        "id": 148297,
                        "name": "Neba",
                        "latitude": "35.25305556",
                        "longitude": "137.58111111"
                    },
                    {
                        "id": 148271,
                        "name": "Niyodogawa",
                        "latitude": "33.57527778",
                        "longitude": "133.16833333"
                    },
                    {
                        "id": 148240,
                        "name": "Nozawaonsen",
                        "latitude": "36.92277778",
                        "longitude": "138.44055556"
                    },
                    {
                        "id": 148233,
                        "name": "Obuse",
                        "latitude": "36.69777778",
                        "longitude": "138.31222222"
                    },
                    {
                        "id": 148266,
                        "name": "Ochi",
                        "latitude": "33.53277778",
                        "longitude": "133.25194444"
                    },
                    {
                        "id": 148303,
                        "name": "Ogawa",
                        "latitude": "36.61694444",
                        "longitude": "137.97444444"
                    },
                    {
                        "id": 148262,
                        "name": "Ōkawa",
                        "latitude": "33.78361111",
                        "longitude": "133.46666667"
                    },
                    {
                        "id": 148307,
                        "name": "Okaya",
                        "latitude": "36.06694444",
                        "longitude": "138.04944444"
                    },
                    {
                        "id": 148251,
                        "name": "Ōkuwa",
                        "latitude": "35.68277778",
                        "longitude": "137.66500000"
                    },
                    {
                        "id": 148321,
                        "name": "Ōmachi",
                        "latitude": "36.50000000",
                        "longitude": "137.85000000"
                    },
                    {
                        "id": 148241,
                        "name": "Omi",
                        "latitude": "36.45611111",
                        "longitude": "138.04527778"
                    },
                    {
                        "id": 148260,
                        "name": "Ōshika",
                        "latitude": "35.57833333",
                        "longitude": "138.03416667"
                    },
                    {
                        "id": 148250,
                        "name": "Ōtaki",
                        "latitude": "35.80944444",
                        "longitude": "137.55111111"
                    },
                    {
                        "id": 148242,
                        "name": "Otari",
                        "latitude": "36.77916667",
                        "longitude": "137.90833333"
                    },
                    {
                        "id": 148218,
                        "name": "Ōtoyo",
                        "latitude": "33.76416667",
                        "longitude": "133.66416667"
                    },
                    {
                        "id": 148223,
                        "name": "Ōtsuki",
                        "latitude": "32.84138889",
                        "longitude": "132.70694444"
                    },
                    {
                        "id": 148275,
                        "name": "Sakae",
                        "latitude": "36.98750000",
                        "longitude": "138.57750000"
                    },
                    {
                        "id": 148216,
                        "name": "Sakaki",
                        "latitude": "36.46194444",
                        "longitude": "138.18027778"
                    },
                    {
                        "id": 148255,
                        "name": "Sakawa",
                        "latitude": "33.50083333",
                        "longitude": "133.28666667"
                    },
                    {
                        "id": 148316,
                        "name": "Saku",
                        "latitude": "36.24888889",
                        "longitude": "138.47694444"
                    },
                    {
                        "id": 148239,
                        "name": "Sakuho",
                        "latitude": "36.16111111",
                        "longitude": "138.48333333"
                    },
                    {
                        "id": 148294,
                        "name": "Sanada",
                        "latitude": "36.44088889",
                        "longitude": "138.30361111"
                    },
                    {
                        "id": 148273,
                        "name": "Shimanto",
                        "latitude": "33.20833333",
                        "longitude": "133.13555556"
                    },
                    {
                        "id": 148277,
                        "name": "Shimojō",
                        "latitude": "35.39750000",
                        "longitude": "137.78611111"
                    },
                    {
                        "id": 148272,
                        "name": "Shimosuwa",
                        "latitude": "36.06972222",
                        "longitude": "138.08027778"
                    },
                    {
                        "id": 148278,
                        "name": "Shinano",
                        "latitude": "36.80638889",
                        "longitude": "138.20694444"
                    },
                    {
                        "id": 148301,
                        "name": "Shiojiri",
                        "latitude": "36.11666667",
                        "longitude": "137.95000000"
                    },
                    {
                        "id": 148308,
                        "name": "Sukumo",
                        "latitude": "32.93888889",
                        "longitude": "132.72611111"
                    },
                    {
                        "id": 148318,
                        "name": "Susaki",
                        "latitude": "33.40083333",
                        "longitude": "133.28305556"
                    },
                    {
                        "id": 148309,
                        "name": "Suwa",
                        "latitude": "36.03916667",
                        "longitude": "138.11416667"
                    },
                    {
                        "id": 148311,
                        "name": "Suzaka",
                        "latitude": "36.65000000",
                        "longitude": "138.31667000"
                    },
                    {
                        "id": 148226,
                        "name": "Takagi",
                        "latitude": "35.51388889",
                        "longitude": "137.87388889"
                    },
                    {
                        "id": 148222,
                        "name": "Takamori",
                        "latitude": "35.55138889",
                        "longitude": "137.87861111"
                    },
                    {
                        "id": 148283,
                        "name": "Takayama",
                        "latitude": "36.67972222",
                        "longitude": "138.36305556"
                    },
                    {
                        "id": 148232,
                        "name": "Tano",
                        "latitude": "33.42777778",
                        "longitude": "134.00833333"
                    },
                    {
                        "id": 148285,
                        "name": "Tateshina",
                        "latitude": "36.27194444",
                        "longitude": "138.31611111"
                    },
                    {
                        "id": 148295,
                        "name": "Tatsuno",
                        "latitude": "35.98250000",
                        "longitude": "137.98750000"
                    },
                    {
                        "id": 148244,
                        "name": "Togari",
                        "latitude": "36.91666667",
                        "longitude": "138.38333333"
                    },
                    {
                        "id": 148212,
                        "name": "Tōmi",
                        "latitude": "36.35944444",
                        "longitude": "138.33055556"
                    },
                    {
                        "id": 148320,
                        "name": "Tosa",
                        "latitude": "33.49611111",
                        "longitude": "133.42527778"
                    },
                    {
                        "id": 148319,
                        "name": "Tosashimizu",
                        "latitude": "32.78138889",
                        "longitude": "132.95500000"
                    },
                    {
                        "id": 148296,
                        "name": "Tōyō",
                        "latitude": "33.52805556",
                        "longitude": "134.28000000"
                    },
                    {
                        "id": 148268,
                        "name": "Toyooka",
                        "latitude": "35.55138889",
                        "longitude": "137.89583333"
                    },
                    {
                        "id": 148221,
                        "name": "Tsuno",
                        "latitude": "33.44666667",
                        "longitude": "133.19944444"
                    },
                    {
                        "id": 148246,
                        "name": "Ueda",
                        "latitude": "36.40194444",
                        "longitude": "138.24916667"
                    },
                    {
                        "id": 148258,
                        "name": "Umaji",
                        "latitude": "33.55527778",
                        "longitude": "134.04805556"
                    },
                    {
                        "id": 148220,
                        "name": "Urugi",
                        "latitude": "35.27111111",
                        "longitude": "137.71111111"
                    },
                    {
                        "id": 148248,
                        "name": "Usa",
                        "latitude": "33.44936111",
                        "longitude": "133.43711111"
                    },
                    {
                        "id": 148219,
                        "name": "Yamagata",
                        "latitude": "36.16805556",
                        "longitude": "137.87888889"
                    },
                    {
                        "id": 148234,
                        "name": "Yamanouchi",
                        "latitude": "36.74472222",
                        "longitude": "138.41250000"
                    },
                    {
                        "id": 148282,
                        "name": "Yasuda",
                        "latitude": "33.43833333",
                        "longitude": "133.98111111"
                    },
                    {
                        "id": 148229,
                        "name": "Yasuoka",
                        "latitude": "35.37722222",
                        "longitude": "137.84583333"
                    },
                    {
                        "id": 148253,
                        "name": "Yawata",
                        "latitude": "36.51666667",
                        "longitude": "138.10000000"
                    },
                    {
                        "id": 148230,
                        "name": "Yusuhara",
                        "latitude": "33.39194444",
                        "longitude": "132.92694444"
                    }
                ]
            },
            {
                "id": 846,
                "name": "Kumamoto",
                "iso2": "43",
                "latitude": "32.85944270",
                "longitude": "130.79691490",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63240,
                        "name": "Amakusa Gun",
                        "latitude": "32.48513000",
                        "longitude": "130.07240000"
                    },
                    {
                        "id": 63241,
                        "name": "Amakusa Shi",
                        "latitude": "32.38515000",
                        "longitude": "130.15014000"
                    },
                    {
                        "id": 63253,
                        "name": "Arao Shi",
                        "latitude": "32.97619000",
                        "longitude": "130.47562000"
                    },
                    {
                        "id": 63269,
                        "name": "Aso-shi",
                        "latitude": "32.95608000",
                        "longitude": "131.09458000"
                    },
                    {
                        "id": 63511,
                        "name": "Hitoyoshi",
                        "latitude": "32.21667000",
                        "longitude": "130.75000000"
                    },
                    {
                        "id": 63512,
                        "name": "Hitoyoshi Shi",
                        "latitude": "32.17298000",
                        "longitude": "130.74013000"
                    },
                    {
                        "id": 63522,
                        "name": "Hondomachi-hondo",
                        "latitude": "32.45993000",
                        "longitude": "130.16713000"
                    },
                    {
                        "id": 63525,
                        "name": "Honmachi",
                        "latitude": "32.50439000",
                        "longitude": "130.59952000"
                    },
                    {
                        "id": 63687,
                        "name": "Kamiamakusa Shi",
                        "latitude": "32.49550000",
                        "longitude": "130.40816000"
                    },
                    {
                        "id": 63784,
                        "name": "Kikuchi",
                        "latitude": "32.98333000",
                        "longitude": "130.81667000"
                    },
                    {
                        "id": 63785,
                        "name": "Kikuchi Shi",
                        "latitude": "32.99107000",
                        "longitude": "130.85523000"
                    },
                    {
                        "id": 63901,
                        "name": "Kōshi Shi",
                        "latitude": "32.89305000",
                        "longitude": "130.76867000"
                    },
                    {
                        "id": 63859,
                        "name": "Kumamoto",
                        "latitude": "32.80589000",
                        "longitude": "130.69181000"
                    },
                    {
                        "id": 63860,
                        "name": "Kumamoto Shi",
                        "latitude": "32.79733000",
                        "longitude": "130.69171000"
                    },
                    {
                        "id": 63931,
                        "name": "Matsubase",
                        "latitude": "32.65000000",
                        "longitude": "130.66667000"
                    },
                    {
                        "id": 63959,
                        "name": "Minamata",
                        "latitude": "32.21667000",
                        "longitude": "130.40000000"
                    },
                    {
                        "id": 63960,
                        "name": "Minamata Shi",
                        "latitude": "32.17055000",
                        "longitude": "130.46211000"
                    },
                    {
                        "id": 64769,
                        "name": "Ōzu",
                        "latitude": "32.88040000",
                        "longitude": "130.87161000"
                    },
                    {
                        "id": 64457,
                        "name": "Tamana",
                        "latitude": "32.94716000",
                        "longitude": "130.57446000"
                    },
                    {
                        "id": 64458,
                        "name": "Tamana Shi",
                        "latitude": "32.91550000",
                        "longitude": "130.56018000"
                    },
                    {
                        "id": 64580,
                        "name": "Uekimachi-mōno",
                        "latitude": "32.89964000",
                        "longitude": "130.68898000"
                    },
                    {
                        "id": 64587,
                        "name": "Uki Shi",
                        "latitude": "32.62669000",
                        "longitude": "130.65491000"
                    },
                    {
                        "id": 64602,
                        "name": "Ushibukamachi",
                        "latitude": "32.20142000",
                        "longitude": "130.02171000"
                    },
                    {
                        "id": 64609,
                        "name": "Uto",
                        "latitude": "32.68333000",
                        "longitude": "130.66667000"
                    },
                    {
                        "id": 64610,
                        "name": "Uto Shi",
                        "latitude": "32.68092000",
                        "longitude": "130.61308000"
                    },
                    {
                        "id": 64637,
                        "name": "Yamaga Shi",
                        "latitude": "33.05587000",
                        "longitude": "130.72309000"
                    },
                    {
                        "id": 64664,
                        "name": "Yatsushiro Shi",
                        "latitude": "32.49063000",
                        "longitude": "130.74972000"
                    }
                ]
            },
            {
                "id": 834,
                "name": "Kyōto",
                "iso2": "26",
                "latitude": "35.15666090",
                "longitude": "135.52519820",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63254,
                        "name": "Arashiyama",
                        "latitude": "35.01481000",
                        "longitude": "135.67755000"
                    },
                    {
                        "id": 63277,
                        "name": "Ayabe",
                        "latitude": "35.30000000",
                        "longitude": "135.25000000"
                    },
                    {
                        "id": 63278,
                        "name": "Ayabe-shi",
                        "latitude": "35.35263000",
                        "longitude": "135.34465000"
                    },
                    {
                        "id": 63361,
                        "name": "Fukuchiyama-shi",
                        "latitude": "35.32404000",
                        "longitude": "135.11332000"
                    },
                    {
                        "id": 63654,
                        "name": "Jōyō Shi",
                        "latitude": "34.84566000",
                        "longitude": "135.79760000"
                    },
                    {
                        "id": 63683,
                        "name": "Kameoka",
                        "latitude": "35.00000000",
                        "longitude": "135.58333000"
                    },
                    {
                        "id": 63684,
                        "name": "Kameoka-shi",
                        "latitude": "35.01021000",
                        "longitude": "135.53900000"
                    },
                    {
                        "id": 63689,
                        "name": "Kamigyō-ku",
                        "latitude": "35.02954000",
                        "longitude": "135.75666000"
                    },
                    {
                        "id": 63817,
                        "name": "Kizugawa-shi",
                        "latitude": "34.73781000",
                        "longitude": "135.82128000"
                    },
                    {
                        "id": 63891,
                        "name": "Kyōtanabe Shi",
                        "latitude": "34.80779000",
                        "longitude": "135.76300000"
                    },
                    {
                        "id": 63892,
                        "name": "Kyōtango-shi",
                        "latitude": "35.63089000",
                        "longitude": "135.04785000"
                    },
                    {
                        "id": 63890,
                        "name": "Kyoto",
                        "latitude": "35.02107000",
                        "longitude": "135.75385000"
                    },
                    {
                        "id": 63912,
                        "name": "Maizuru",
                        "latitude": "35.45000000",
                        "longitude": "135.33333000"
                    },
                    {
                        "id": 63913,
                        "name": "Maizuru-shi",
                        "latitude": "35.47009000",
                        "longitude": "135.34003000"
                    },
                    {
                        "id": 64011,
                        "name": "Miyazu",
                        "latitude": "35.53333000",
                        "longitude": "135.18333000"
                    },
                    {
                        "id": 64012,
                        "name": "Miyazu-shi",
                        "latitude": "35.55596000",
                        "longitude": "135.17662000"
                    },
                    {
                        "id": 64043,
                        "name": "Mukō Shi",
                        "latitude": "34.94975000",
                        "longitude": "135.70269000"
                    },
                    {
                        "id": 64068,
                        "name": "Nagaokakyō Shi",
                        "latitude": "34.92840000",
                        "longitude": "135.67881000"
                    },
                    {
                        "id": 64102,
                        "name": "Nantan-shi",
                        "latitude": "35.22740000",
                        "longitude": "135.55939000"
                    },
                    {
                        "id": 64463,
                        "name": "Tanabe",
                        "latitude": "34.82242000",
                        "longitude": "135.76604000"
                    },
                    {
                        "id": 64584,
                        "name": "Uji",
                        "latitude": "34.89044000",
                        "longitude": "135.80325000"
                    },
                    {
                        "id": 64585,
                        "name": "Uji Shi",
                        "latitude": "34.90296000",
                        "longitude": "135.82039000"
                    },
                    {
                        "id": 64665,
                        "name": "Yawata",
                        "latitude": "34.87009000",
                        "longitude": "135.70270000"
                    },
                    {
                        "id": 64666,
                        "name": "Yawata Shi",
                        "latitude": "34.86662000",
                        "longitude": "135.71470000"
                    }
                ]
            },
            {
                "id": 833,
                "name": "Mie",
                "iso2": "24",
                "latitude": "33.81439010",
                "longitude": "136.04870470",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63501,
                        "name": "Hisai-motomachi",
                        "latitude": "34.66667000",
                        "longitude": "136.46667000"
                    },
                    {
                        "id": 63546,
                        "name": "Iga-shi",
                        "latitude": "34.76855000",
                        "longitude": "136.13013000"
                    },
                    {
                        "id": 63567,
                        "name": "Inabe",
                        "latitude": "35.11344000",
                        "longitude": "136.57205000"
                    },
                    {
                        "id": 63568,
                        "name": "Inabe-shi",
                        "latitude": "35.16061000",
                        "longitude": "136.50788000"
                    },
                    {
                        "id": 63584,
                        "name": "Ise",
                        "latitude": "34.48333000",
                        "longitude": "136.70000000"
                    },
                    {
                        "id": 63585,
                        "name": "Ise-shi",
                        "latitude": "34.46740000",
                        "longitude": "136.71585000"
                    },
                    {
                        "id": 63685,
                        "name": "Kameyama",
                        "latitude": "34.85000000",
                        "longitude": "136.45000000"
                    },
                    {
                        "id": 63686,
                        "name": "Kameyama Shi",
                        "latitude": "34.86866000",
                        "longitude": "136.39345000"
                    },
                    {
                        "id": 63767,
                        "name": "Kawage",
                        "latitude": "34.80447000",
                        "longitude": "136.54645000"
                    },
                    {
                        "id": 63840,
                        "name": "Komono",
                        "latitude": "35.00000000",
                        "longitude": "136.51667000"
                    },
                    {
                        "id": 63861,
                        "name": "Kumano",
                        "latitude": "33.90389000",
                        "longitude": "136.12214000"
                    },
                    {
                        "id": 63862,
                        "name": "Kumano-shi",
                        "latitude": "33.92290000",
                        "longitude": "136.02646000"
                    },
                    {
                        "id": 63888,
                        "name": "Kuwana",
                        "latitude": "35.05192000",
                        "longitude": "136.66958000"
                    },
                    {
                        "id": 63889,
                        "name": "Kuwana-shi",
                        "latitude": "35.06176000",
                        "longitude": "136.68348000"
                    },
                    {
                        "id": 63942,
                        "name": "Matsuzaka-shi",
                        "latitude": "34.56667000",
                        "longitude": "136.53333000"
                    },
                    {
                        "id": 64057,
                        "name": "Nabari",
                        "latitude": "34.61667000",
                        "longitude": "136.08333000"
                    },
                    {
                        "id": 64058,
                        "name": "Nabari-shi",
                        "latitude": "34.62643000",
                        "longitude": "136.10825000"
                    },
                    {
                        "id": 64219,
                        "name": "Owase",
                        "latitude": "34.06667000",
                        "longitude": "136.20000000"
                    },
                    {
                        "id": 64323,
                        "name": "Shima",
                        "latitude": "34.33333000",
                        "longitude": "136.83333000"
                    },
                    {
                        "id": 64324,
                        "name": "Shima-shi",
                        "latitude": "34.33795000",
                        "longitude": "136.81336000"
                    },
                    {
                        "id": 64396,
                        "name": "Suzuka",
                        "latitude": "34.88333000",
                        "longitude": "136.58333000"
                    },
                    {
                        "id": 64397,
                        "name": "Suzuka-shi",
                        "latitude": "34.88114000",
                        "longitude": "136.58443000"
                    },
                    {
                        "id": 64485,
                        "name": "Toba",
                        "latitude": "34.48330000",
                        "longitude": "136.84186000"
                    },
                    {
                        "id": 64486,
                        "name": "Toba-shi",
                        "latitude": "34.48333000",
                        "longitude": "136.83333000"
                    },
                    {
                        "id": 64535,
                        "name": "Tsu",
                        "latitude": "34.73333000",
                        "longitude": "136.51667000"
                    },
                    {
                        "id": 64536,
                        "name": "Tsu-shi",
                        "latitude": "34.71706000",
                        "longitude": "136.50616000"
                    },
                    {
                        "id": 64581,
                        "name": "Ueno-ebisumachi",
                        "latitude": "34.75856000",
                        "longitude": "136.13108000"
                    },
                    {
                        "id": 64669,
                        "name": "Yokkaichi-shi",
                        "latitude": "34.96475000",
                        "longitude": "136.62443000"
                    }
                ]
            },
            {
                "id": 857,
                "name": "Miyagi",
                "iso2": "04",
                "latitude": "38.63061200",
                "longitude": "141.11930480",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63379,
                        "name": "Furukawa",
                        "latitude": "38.57167000",
                        "longitude": "140.95556000"
                    },
                    {
                        "id": 63462,
                        "name": "Higashimatshushima Shi",
                        "latitude": "38.41089000",
                        "longitude": "141.17717000"
                    },
                    {
                        "id": 63463,
                        "name": "Higashimatsushima",
                        "latitude": "38.40886000",
                        "longitude": "141.17901000"
                    },
                    {
                        "id": 63599,
                        "name": "Ishinomaki",
                        "latitude": "38.41667000",
                        "longitude": "141.30000000"
                    },
                    {
                        "id": 63600,
                        "name": "Ishinomaki Shi",
                        "latitude": "38.47918000",
                        "longitude": "141.37226000"
                    },
                    {
                        "id": 63629,
                        "name": "Iwanuma",
                        "latitude": "38.10472000",
                        "longitude": "140.85944000"
                    },
                    {
                        "id": 63630,
                        "name": "Iwanuma-shi",
                        "latitude": "38.11667000",
                        "longitude": "140.88333000"
                    },
                    {
                        "id": 63673,
                        "name": "Kakuda",
                        "latitude": "37.97451000",
                        "longitude": "140.77202000"
                    },
                    {
                        "id": 63674,
                        "name": "Kakuda Shi",
                        "latitude": "37.98828000",
                        "longitude": "140.77903000"
                    },
                    {
                        "id": 63781,
                        "name": "Kesennuma",
                        "latitude": "38.90112000",
                        "longitude": "141.57746000"
                    },
                    {
                        "id": 63782,
                        "name": "Kesennuma Shi",
                        "latitude": "38.91377000",
                        "longitude": "141.55711000"
                    },
                    {
                        "id": 63828,
                        "name": "Kogota",
                        "latitude": "38.55000000",
                        "longitude": "141.05000000"
                    },
                    {
                        "id": 63870,
                        "name": "Kurihara",
                        "latitude": "38.75000000",
                        "longitude": "141.00000000"
                    },
                    {
                        "id": 63871,
                        "name": "Kurihara Shi",
                        "latitude": "38.80895000",
                        "longitude": "140.94034000"
                    },
                    {
                        "id": 63923,
                        "name": "Marumori",
                        "latitude": "37.91667000",
                        "longitude": "140.76667000"
                    },
                    {
                        "id": 63937,
                        "name": "Matsushima",
                        "latitude": "38.37357000",
                        "longitude": "141.06105000"
                    },
                    {
                        "id": 64116,
                        "name": "Natori Shi",
                        "latitude": "38.16729000",
                        "longitude": "140.86666000"
                    },
                    {
                        "id": 64732,
                        "name": "Ōkawara",
                        "latitude": "38.05000000",
                        "longitude": "140.73361000"
                    },
                    {
                        "id": 64206,
                        "name": "Onagawa Chō",
                        "latitude": "38.44660000",
                        "longitude": "141.44794000"
                    },
                    {
                        "id": 64752,
                        "name": "Ōsaki",
                        "latitude": "38.58866000",
                        "longitude": "140.97300000"
                    },
                    {
                        "id": 64753,
                        "name": "Ōsaki Shi",
                        "latitude": "38.68005000",
                        "longitude": "140.84669000"
                    },
                    {
                        "id": 64225,
                        "name": "Rifu",
                        "latitude": "38.33092000",
                        "longitude": "140.97691000"
                    },
                    {
                        "id": 64300,
                        "name": "Sendai",
                        "latitude": "38.26667000",
                        "longitude": "140.86667000"
                    },
                    {
                        "id": 64348,
                        "name": "Shiogama",
                        "latitude": "38.31667000",
                        "longitude": "141.03333000"
                    },
                    {
                        "id": 64359,
                        "name": "Shiroishi",
                        "latitude": "38.00333000",
                        "longitude": "140.61833000"
                    },
                    {
                        "id": 64360,
                        "name": "Shiroishi Shi",
                        "latitude": "37.99691000",
                        "longitude": "140.57944000"
                    },
                    {
                        "id": 64407,
                        "name": "Tagajō Shi",
                        "latitude": "38.29535000",
                        "longitude": "140.99910000"
                    },
                    {
                        "id": 64503,
                        "name": "Tome Shi",
                        "latitude": "38.68583000",
                        "longitude": "141.25745000"
                    },
                    {
                        "id": 64509,
                        "name": "Tomiya",
                        "latitude": "38.39306000",
                        "longitude": "140.88611000"
                    },
                    {
                        "id": 64622,
                        "name": "Wakuya",
                        "latitude": "38.54465000",
                        "longitude": "141.13461000"
                    },
                    {
                        "id": 64625,
                        "name": "Watari",
                        "latitude": "38.03500000",
                        "longitude": "140.85111000"
                    },
                    {
                        "id": 64626,
                        "name": "Watari-gun",
                        "latitude": "37.99640000",
                        "longitude": "140.87909000"
                    },
                    {
                        "id": 64649,
                        "name": "Yamoto",
                        "latitude": "38.42738000",
                        "longitude": "141.21487000"
                    }
                ]
            },
            {
                "id": 855,
                "name": "Miyazaki",
                "iso2": "45",
                "latitude": "32.60360220",
                "longitude": "131.44125100",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63328,
                        "name": "Ebino-shi",
                        "latitude": "32.01667000",
                        "longitude": "130.80000000"
                    },
                    {
                        "id": 63527,
                        "name": "Hyūga-shi",
                        "latitude": "32.37710000",
                        "longitude": "131.52275000"
                    },
                    {
                        "id": 63818,
                        "name": "Kobayashi",
                        "latitude": "31.98333000",
                        "longitude": "130.98333000"
                    },
                    {
                        "id": 63819,
                        "name": "Kobayashi Shi",
                        "latitude": "32.04556000",
                        "longitude": "131.02762000"
                    },
                    {
                        "id": 63884,
                        "name": "Kushima",
                        "latitude": "31.48621000",
                        "longitude": "131.24210000"
                    },
                    {
                        "id": 63885,
                        "name": "Kushima Shi",
                        "latitude": "31.48571000",
                        "longitude": "131.26485000"
                    },
                    {
                        "id": 64003,
                        "name": "Miyakonojō",
                        "latitude": "31.73333000",
                        "longitude": "131.06667000"
                    },
                    {
                        "id": 64004,
                        "name": "Miyakonojō Shi",
                        "latitude": "31.80920000",
                        "longitude": "131.07904000"
                    },
                    {
                        "id": 64009,
                        "name": "Miyazaki",
                        "latitude": "31.91667000",
                        "longitude": "131.41667000"
                    },
                    {
                        "id": 64010,
                        "name": "Miyazaki-shi",
                        "latitude": "31.96192000",
                        "longitude": "131.38455000"
                    },
                    {
                        "id": 64125,
                        "name": "Nichinan",
                        "latitude": "31.60000000",
                        "longitude": "131.36667000"
                    },
                    {
                        "id": 64126,
                        "name": "Nichinan Shi",
                        "latitude": "31.63737000",
                        "longitude": "131.33409000"
                    },
                    {
                        "id": 64159,
                        "name": "Nobeoka",
                        "latitude": "32.58333000",
                        "longitude": "131.66667000"
                    },
                    {
                        "id": 64160,
                        "name": "Nobeoka-shi",
                        "latitude": "32.67238000",
                        "longitude": "131.64311000"
                    },
                    {
                        "id": 64252,
                        "name": "Saito-shi",
                        "latitude": "32.17288000",
                        "longitude": "131.31543000"
                    },
                    {
                        "id": 64429,
                        "name": "Takanabe",
                        "latitude": "32.13333000",
                        "longitude": "131.50000000"
                    },
                    {
                        "id": 64551,
                        "name": "Tsuma",
                        "latitude": "32.10000000",
                        "longitude": "131.40000000"
                    }
                ]
            },
            {
                "id": 843,
                "name": "Nagano",
                "iso2": "20",
                "latitude": "36.15439410",
                "longitude": "137.92182040",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63280,
                        "name": "Azumino-Shi",
                        "latitude": "36.32716000",
                        "longitude": "137.83988000"
                    },
                    {
                        "id": 63299,
                        "name": "Chikuma Shi",
                        "latitude": "36.50624000",
                        "longitude": "138.12352000"
                    },
                    {
                        "id": 63303,
                        "name": "Chino",
                        "latitude": "35.99440000",
                        "longitude": "138.15428000"
                    },
                    {
                        "id": 63304,
                        "name": "Chino Shi",
                        "latitude": "36.02522000",
                        "longitude": "138.24668000"
                    },
                    {
                        "id": 63419,
                        "name": "Hakuba",
                        "latitude": "36.69818000",
                        "longitude": "137.86185000"
                    },
                    {
                        "id": 63526,
                        "name": "Hotaka",
                        "latitude": "36.33960000",
                        "longitude": "137.88254000"
                    },
                    {
                        "id": 63547,
                        "name": "Iida",
                        "latitude": "35.51965000",
                        "longitude": "137.82074000"
                    },
                    {
                        "id": 63548,
                        "name": "Iida-shi",
                        "latitude": "35.42287000",
                        "longitude": "137.89381000"
                    },
                    {
                        "id": 63549,
                        "name": "Iiyama",
                        "latitude": "36.85000000",
                        "longitude": "138.36667000"
                    },
                    {
                        "id": 63550,
                        "name": "Iiyama Shi",
                        "latitude": "36.91249000",
                        "longitude": "138.38345000"
                    },
                    {
                        "id": 63565,
                        "name": "Ina",
                        "latitude": "35.82756000",
                        "longitude": "137.95378000"
                    },
                    {
                        "id": 63566,
                        "name": "Ina-shi",
                        "latitude": "35.79079000",
                        "longitude": "138.07402000"
                    },
                    {
                        "id": 63693,
                        "name": "Kamimaruko",
                        "latitude": "36.31865000",
                        "longitude": "138.27329000"
                    },
                    {
                        "id": 63833,
                        "name": "Komagane",
                        "latitude": "35.71657000",
                        "longitude": "137.93745000"
                    },
                    {
                        "id": 63834,
                        "name": "Komagane-shi",
                        "latitude": "35.72770000",
                        "longitude": "137.94783000"
                    },
                    {
                        "id": 63841,
                        "name": "Komoro",
                        "latitude": "36.31667000",
                        "longitude": "138.43333000"
                    },
                    {
                        "id": 63842,
                        "name": "Komoro Shi",
                        "latitude": "36.33905000",
                        "longitude": "138.43503000"
                    },
                    {
                        "id": 63935,
                        "name": "Matsumoto",
                        "latitude": "36.23333000",
                        "longitude": "137.96667000"
                    },
                    {
                        "id": 63936,
                        "name": "Matsumoto Shi",
                        "latitude": "36.20418000",
                        "longitude": "137.81419000"
                    },
                    {
                        "id": 64064,
                        "name": "Nagano",
                        "latitude": "36.65000000",
                        "longitude": "138.18333000"
                    },
                    {
                        "id": 64065,
                        "name": "Nagano Shi",
                        "latitude": "36.65257000",
                        "longitude": "138.11694000"
                    },
                    {
                        "id": 64086,
                        "name": "Nakano Shi",
                        "latitude": "36.76940000",
                        "longitude": "138.34717000"
                    },
                    {
                        "id": 64193,
                        "name": "Okaya",
                        "latitude": "36.05659000",
                        "longitude": "138.04510000"
                    },
                    {
                        "id": 64194,
                        "name": "Okaya Shi",
                        "latitude": "36.07917000",
                        "longitude": "138.04805000"
                    },
                    {
                        "id": 64734,
                        "name": "Ōmachi",
                        "latitude": "36.50000000",
                        "longitude": "137.86667000"
                    },
                    {
                        "id": 64735,
                        "name": "Ōmachi-shi",
                        "latitude": "36.55000000",
                        "longitude": "137.75000000"
                    },
                    {
                        "id": 64266,
                        "name": "Saku",
                        "latitude": "36.21667000",
                        "longitude": "138.48333000"
                    },
                    {
                        "id": 64267,
                        "name": "Saku Shi",
                        "latitude": "36.21577000",
                        "longitude": "138.44529000"
                    },
                    {
                        "id": 64349,
                        "name": "Shiojiri",
                        "latitude": "36.10000000",
                        "longitude": "137.96667000"
                    },
                    {
                        "id": 64350,
                        "name": "Shiojiri-shi",
                        "latitude": "36.08333000",
                        "longitude": "137.93333000"
                    },
                    {
                        "id": 64390,
                        "name": "Suwa",
                        "latitude": "36.03799000",
                        "longitude": "138.11308000"
                    },
                    {
                        "id": 64391,
                        "name": "Suwa Shi",
                        "latitude": "36.02899000",
                        "longitude": "138.11357000"
                    },
                    {
                        "id": 64392,
                        "name": "Suzaka",
                        "latitude": "36.65000000",
                        "longitude": "138.31667000"
                    },
                    {
                        "id": 64393,
                        "name": "Suzaka-shi",
                        "latitude": "36.65000000",
                        "longitude": "138.31667000"
                    },
                    {
                        "id": 64476,
                        "name": "Tatsuno",
                        "latitude": "35.98426000",
                        "longitude": "137.99721000"
                    },
                    {
                        "id": 64571,
                        "name": "Tōmi",
                        "latitude": "36.35582000",
                        "longitude": "138.36093000"
                    },
                    {
                        "id": 64572,
                        "name": "Tōmi Shi",
                        "latitude": "36.37387000",
                        "longitude": "138.36866000"
                    },
                    {
                        "id": 64533,
                        "name": "Toyoshina",
                        "latitude": "36.29991000",
                        "longitude": "137.90108000"
                    },
                    {
                        "id": 64578,
                        "name": "Ueda",
                        "latitude": "36.40265000",
                        "longitude": "138.28161000"
                    },
                    {
                        "id": 64579,
                        "name": "Ueda Shi",
                        "latitude": "36.38352000",
                        "longitude": "138.24186000"
                    }
                ]
            },
            {
                "id": 849,
                "name": "Nagasaki",
                "iso2": "42",
                "latitude": "33.24885250",
                "longitude": "129.69309120",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63362,
                        "name": "Fukuechō",
                        "latitude": "32.69732000",
                        "longitude": "128.84561000"
                    },
                    {
                        "id": 63397,
                        "name": "Gotō Shi",
                        "latitude": "32.69892000",
                        "longitude": "128.76871000"
                    },
                    {
                        "id": 63487,
                        "name": "Hirado",
                        "latitude": "33.36853000",
                        "longitude": "129.55247000"
                    },
                    {
                        "id": 63488,
                        "name": "Hirado Shi",
                        "latitude": "33.31596000",
                        "longitude": "129.48688000"
                    },
                    {
                        "id": 63557,
                        "name": "Iki Shi",
                        "latitude": "33.78554000",
                        "longitude": "129.71670000"
                    },
                    {
                        "id": 63581,
                        "name": "Isahaya",
                        "latitude": "32.84111000",
                        "longitude": "130.04306000"
                    },
                    {
                        "id": 63582,
                        "name": "Isahaya-shi",
                        "latitude": "32.86912000",
                        "longitude": "130.06369000"
                    },
                    {
                        "id": 63939,
                        "name": "Matsuura",
                        "latitude": "33.34058000",
                        "longitude": "129.69504000"
                    },
                    {
                        "id": 63940,
                        "name": "Matsuura Shi",
                        "latitude": "33.35334000",
                        "longitude": "129.73504000"
                    },
                    {
                        "id": 63970,
                        "name": "Minamishimabara-shi",
                        "latitude": "32.67565000",
                        "longitude": "130.25695000"
                    },
                    {
                        "id": 64071,
                        "name": "Nagasaki",
                        "latitude": "32.75000000",
                        "longitude": "129.88333000"
                    },
                    {
                        "id": 64072,
                        "name": "Nagasaki-shi",
                        "latitude": "32.78206000",
                        "longitude": "129.82715000"
                    },
                    {
                        "id": 64182,
                        "name": "Obita",
                        "latitude": "32.81667000",
                        "longitude": "129.88333000"
                    },
                    {
                        "id": 64743,
                        "name": "Ōmura",
                        "latitude": "32.92139000",
                        "longitude": "129.95389000"
                    },
                    {
                        "id": 64744,
                        "name": "Ōmura-shi",
                        "latitude": "32.93978000",
                        "longitude": "129.99297000"
                    },
                    {
                        "id": 64247,
                        "name": "Saikai-shi",
                        "latitude": "32.99259000",
                        "longitude": "129.68200000"
                    },
                    {
                        "id": 64290,
                        "name": "Sasebo Shi",
                        "latitude": "33.18992000",
                        "longitude": "129.68960000"
                    },
                    {
                        "id": 64325,
                        "name": "Shimabara",
                        "latitude": "32.78333000",
                        "longitude": "130.36667000"
                    },
                    {
                        "id": 64326,
                        "name": "Shimabara-shi",
                        "latitude": "32.79429000",
                        "longitude": "130.32925000"
                    },
                    {
                        "id": 64490,
                        "name": "Togitsu",
                        "latitude": "32.83333000",
                        "longitude": "129.85000000"
                    },
                    {
                        "id": 64561,
                        "name": "Tsushima Shi",
                        "latitude": "34.40845000",
                        "longitude": "129.32599000"
                    },
                    {
                        "id": 64591,
                        "name": "Unzen-shi",
                        "latitude": "32.78390000",
                        "longitude": "130.22828000"
                    }
                ]
            },
            {
                "id": 824,
                "name": "Nara",
                "iso2": "29",
                "latitude": "34.29755280",
                "longitude": "135.82797340",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63389,
                        "name": "Gojō",
                        "latitude": "34.35000000",
                        "longitude": "135.70000000"
                    },
                    {
                        "id": 63390,
                        "name": "Gojō-shi",
                        "latitude": "34.35081000",
                        "longitude": "135.69489000"
                    },
                    {
                        "id": 63391,
                        "name": "Gose",
                        "latitude": "34.45000000",
                        "longitude": "135.73333000"
                    },
                    {
                        "id": 63415,
                        "name": "Haibara-akanedai",
                        "latitude": "34.53333000",
                        "longitude": "135.95000000"
                    },
                    {
                        "id": 63530,
                        "name": "Hōryūji",
                        "latitude": "34.61234000",
                        "longitude": "135.73754000"
                    },
                    {
                        "id": 63558,
                        "name": "Ikoma",
                        "latitude": "34.68333000",
                        "longitude": "135.70000000"
                    },
                    {
                        "id": 63559,
                        "name": "Ikoma-shi",
                        "latitude": "34.69187000",
                        "longitude": "135.70057000"
                    },
                    {
                        "id": 63733,
                        "name": "Kashiba-shi",
                        "latitude": "34.54107000",
                        "longitude": "135.69918000"
                    },
                    {
                        "id": 63735,
                        "name": "Kashihara-shi",
                        "latitude": "34.50352000",
                        "longitude": "135.78986000"
                    },
                    {
                        "id": 63755,
                        "name": "Katsuragi",
                        "latitude": "34.48562000",
                        "longitude": "135.69698000"
                    },
                    {
                        "id": 63756,
                        "name": "Katsuragi Shi",
                        "latitude": "34.49682000",
                        "longitude": "135.70464000"
                    },
                    {
                        "id": 64106,
                        "name": "Nara-shi",
                        "latitude": "34.68506000",
                        "longitude": "135.80485000"
                    },
                    {
                        "id": 64273,
                        "name": "Sakurai",
                        "latitude": "34.50000000",
                        "longitude": "135.85000000"
                    },
                    {
                        "id": 64274,
                        "name": "Sakurai-shi",
                        "latitude": "34.51816000",
                        "longitude": "135.84320000"
                    },
                    {
                        "id": 64479,
                        "name": "Tawaramoto",
                        "latitude": "34.55420000",
                        "longitude": "135.79297000"
                    },
                    {
                        "id": 64483,
                        "name": "Tenri",
                        "latitude": "34.58333000",
                        "longitude": "135.83333000"
                    },
                    {
                        "id": 64484,
                        "name": "Tenri-shi",
                        "latitude": "34.59619000",
                        "longitude": "135.83736000"
                    },
                    {
                        "id": 64577,
                        "name": "Uda Shi",
                        "latitude": "34.52035000",
                        "longitude": "135.99787000"
                    },
                    {
                        "id": 64645,
                        "name": "Yamatokōriyama-shi",
                        "latitude": "34.64917000",
                        "longitude": "135.78278000"
                    },
                    {
                        "id": 64646,
                        "name": "Yamatotakada-shi",
                        "latitude": "34.51490000",
                        "longitude": "135.73660000"
                    },
                    {
                        "id": 64687,
                        "name": "Yoshino-chō",
                        "latitude": "34.39611000",
                        "longitude": "135.85768000"
                    }
                ]
            },
            {
                "id": 841,
                "name": "Niigata",
                "iso2": "15",
                "latitude": "37.51783860",
                "longitude": "138.92697940",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63216,
                        "name": "Agano Shi",
                        "latitude": "37.81420000",
                        "longitude": "139.25914000"
                    },
                    {
                        "id": 63251,
                        "name": "Arai",
                        "latitude": "37.00059000",
                        "longitude": "138.22590000"
                    },
                    {
                        "id": 63392,
                        "name": "Gosen",
                        "latitude": "37.73333000",
                        "longitude": "139.16667000"
                    },
                    {
                        "id": 63393,
                        "name": "Gosen Shi",
                        "latitude": "37.65643000",
                        "longitude": "139.22634000"
                    },
                    {
                        "id": 63610,
                        "name": "Itoigawa",
                        "latitude": "37.03333000",
                        "longitude": "137.85000000"
                    },
                    {
                        "id": 63611,
                        "name": "Itoigawa Shi",
                        "latitude": "36.96626000",
                        "longitude": "137.89402000"
                    },
                    {
                        "id": 63651,
                        "name": "Jōetsu",
                        "latitude": "37.14828000",
                        "longitude": "138.23642000"
                    },
                    {
                        "id": 63652,
                        "name": "Jōetsu Shi",
                        "latitude": "37.12010000",
                        "longitude": "138.33752000"
                    },
                    {
                        "id": 63682,
                        "name": "Kameda-honchō",
                        "latitude": "37.87214000",
                        "longitude": "139.10990000"
                    },
                    {
                        "id": 63699,
                        "name": "Kamo",
                        "latitude": "37.66442000",
                        "longitude": "139.03502000"
                    },
                    {
                        "id": 63700,
                        "name": "Kamo Shi",
                        "latitude": "37.62209000",
                        "longitude": "139.11068000"
                    },
                    {
                        "id": 63742,
                        "name": "Kashiwazaki",
                        "latitude": "37.36667000",
                        "longitude": "138.55000000"
                    },
                    {
                        "id": 63743,
                        "name": "Kashiwazaki Shi",
                        "latitude": "37.29913000",
                        "longitude": "138.58654000"
                    },
                    {
                        "id": 63915,
                        "name": "Maki",
                        "latitude": "37.75000000",
                        "longitude": "138.88333000"
                    },
                    {
                        "id": 63972,
                        "name": "Minamiuonuma Shi",
                        "latitude": "37.05587000",
                        "longitude": "138.93735000"
                    },
                    {
                        "id": 63994,
                        "name": "Mitsuke",
                        "latitude": "37.53333000",
                        "longitude": "138.93333000"
                    },
                    {
                        "id": 63995,
                        "name": "Mitsuke Shi",
                        "latitude": "37.52465000",
                        "longitude": "138.93711000"
                    },
                    {
                        "id": 64042,
                        "name": "Muikamachi",
                        "latitude": "37.06667000",
                        "longitude": "138.88333000"
                    },
                    {
                        "id": 64045,
                        "name": "Murakami Shi",
                        "latitude": "38.31023000",
                        "longitude": "139.61733000"
                    },
                    {
                        "id": 64046,
                        "name": "Muramatsu",
                        "latitude": "37.69257000",
                        "longitude": "139.17127000"
                    },
                    {
                        "id": 64056,
                        "name": "Myoko-shi",
                        "latitude": "37.00000000",
                        "longitude": "138.25000000"
                    },
                    {
                        "id": 64066,
                        "name": "Nagaoka",
                        "latitude": "37.45000000",
                        "longitude": "138.85000000"
                    },
                    {
                        "id": 64067,
                        "name": "Nagaoka Shi",
                        "latitude": "37.44516000",
                        "longitude": "138.85678000"
                    },
                    {
                        "id": 64129,
                        "name": "Niigata",
                        "latitude": "37.88637000",
                        "longitude": "139.00589000"
                    },
                    {
                        "id": 64130,
                        "name": "Niigata Shi",
                        "latitude": "37.82738000",
                        "longitude": "139.03303000"
                    },
                    {
                        "id": 64135,
                        "name": "Niitsu-honchō",
                        "latitude": "37.80024000",
                        "longitude": "139.12240000"
                    },
                    {
                        "id": 64191,
                        "name": "Ojiya",
                        "latitude": "37.30000000",
                        "longitude": "138.80000000"
                    },
                    {
                        "id": 64192,
                        "name": "Ojiya-shi",
                        "latitude": "37.30000000",
                        "longitude": "138.80000000"
                    },
                    {
                        "id": 64232,
                        "name": "Ryōtsu-minato",
                        "latitude": "38.07817000",
                        "longitude": "138.43939000"
                    },
                    {
                        "id": 64238,
                        "name": "Sado Shi",
                        "latitude": "38.04439000",
                        "longitude": "138.38984000"
                    },
                    {
                        "id": 64278,
                        "name": "Sanjō Shi",
                        "latitude": "37.54068000",
                        "longitude": "139.08983000"
                    },
                    {
                        "id": 64308,
                        "name": "Shibata",
                        "latitude": "37.95000000",
                        "longitude": "139.33333000"
                    },
                    {
                        "id": 64309,
                        "name": "Shibata Shi",
                        "latitude": "37.90732000",
                        "longitude": "139.42786000"
                    },
                    {
                        "id": 64351,
                        "name": "Shiozawa",
                        "latitude": "37.03757000",
                        "longitude": "138.84867000"
                    },
                    {
                        "id": 64361,
                        "name": "Shirone",
                        "latitude": "37.76354000",
                        "longitude": "139.02199000"
                    },
                    {
                        "id": 64378,
                        "name": "Suibara",
                        "latitude": "37.84608000",
                        "longitude": "139.23039000"
                    },
                    {
                        "id": 64412,
                        "name": "Tainai",
                        "latitude": "38.06646000",
                        "longitude": "139.37436000"
                    },
                    {
                        "id": 64413,
                        "name": "Tainai Shi",
                        "latitude": "38.00587000",
                        "longitude": "139.48053000"
                    },
                    {
                        "id": 64488,
                        "name": "Tochio-honchō",
                        "latitude": "37.47642000",
                        "longitude": "138.99513000"
                    },
                    {
                        "id": 64569,
                        "name": "Tōkamachi",
                        "latitude": "37.13333000",
                        "longitude": "138.76667000"
                    },
                    {
                        "id": 64570,
                        "name": "Tōkamachi-shi",
                        "latitude": "37.13333000",
                        "longitude": "138.76667000"
                    },
                    {
                        "id": 64537,
                        "name": "Tsubame",
                        "latitude": "37.66450000",
                        "longitude": "138.92518000"
                    },
                    {
                        "id": 64538,
                        "name": "Tsubame Shi",
                        "latitude": "37.66541000",
                        "longitude": "138.88619000"
                    },
                    {
                        "id": 64592,
                        "name": "Uonuma",
                        "latitude": "37.24488000",
                        "longitude": "138.96234000"
                    },
                    {
                        "id": 64593,
                        "name": "Uonuma Shi",
                        "latitude": "37.22088000",
                        "longitude": "139.09795000"
                    },
                    {
                        "id": 64683,
                        "name": "Yoshida-kasugachō",
                        "latitude": "37.68333000",
                        "longitude": "138.88333000"
                    }
                ]
            },
            {
                "id": 822,
                "name": "Ōita",
                "iso2": "44",
                "latitude": "33.15892990",
                "longitude": "131.36111210",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63283,
                        "name": "Beppu",
                        "latitude": "33.27945000",
                        "longitude": "131.49751000"
                    },
                    {
                        "id": 63284,
                        "name": "Beppu Shi",
                        "latitude": "33.28573000",
                        "longitude": "131.45280000"
                    },
                    {
                        "id": 63288,
                        "name": "Bungo-ōno Shi",
                        "latitude": "32.97249000",
                        "longitude": "131.51210000"
                    },
                    {
                        "id": 63287,
                        "name": "Bungo-Takada-shi",
                        "latitude": "33.55670000",
                        "longitude": "131.44506000"
                    },
                    {
                        "id": 63472,
                        "name": "Hiji",
                        "latitude": "33.37081000",
                        "longitude": "131.53025000"
                    },
                    {
                        "id": 63502,
                        "name": "Hita",
                        "latitude": "33.32130000",
                        "longitude": "130.94098000"
                    },
                    {
                        "id": 63503,
                        "name": "Hita Shi",
                        "latitude": "33.24452000",
                        "longitude": "130.95063000"
                    },
                    {
                        "id": 63813,
                        "name": "Kitsuki",
                        "latitude": "33.41998000",
                        "longitude": "131.61837000"
                    },
                    {
                        "id": 63814,
                        "name": "Kitsuki Shi",
                        "latitude": "33.44729000",
                        "longitude": "131.53670000"
                    },
                    {
                        "id": 63863,
                        "name": "Kunisaki-shi",
                        "latitude": "33.56543000",
                        "longitude": "131.73157000"
                    },
                    {
                        "id": 64089,
                        "name": "Nakatsu",
                        "latitude": "33.59811000",
                        "longitude": "131.18830000"
                    },
                    {
                        "id": 64090,
                        "name": "Nakatsu Shi",
                        "latitude": "33.46458000",
                        "longitude": "131.12642000"
                    },
                    {
                        "id": 64728,
                        "name": "Ōita",
                        "latitude": "33.23333000",
                        "longitude": "131.60000000"
                    },
                    {
                        "id": 64729,
                        "name": "Ōita-shi",
                        "latitude": "33.17980000",
                        "longitude": "131.64085000"
                    },
                    {
                        "id": 64248,
                        "name": "Saiki",
                        "latitude": "32.95000000",
                        "longitude": "131.90000000"
                    },
                    {
                        "id": 64249,
                        "name": "Saiki-shi",
                        "latitude": "32.88598000",
                        "longitude": "131.77600000"
                    },
                    {
                        "id": 64443,
                        "name": "Takedamachi",
                        "latitude": "32.96667000",
                        "longitude": "131.40000000"
                    },
                    {
                        "id": 64449,
                        "name": "Taketa-shi",
                        "latitude": "32.99774000",
                        "longitude": "131.32724000"
                    },
                    {
                        "id": 64544,
                        "name": "Tsukawaki",
                        "latitude": "33.27668000",
                        "longitude": "131.15628000"
                    },
                    {
                        "id": 64549,
                        "name": "Tsukumi-shi",
                        "latitude": "33.06667000",
                        "longitude": "131.86667000"
                    },
                    {
                        "id": 64550,
                        "name": "Tsukumiura",
                        "latitude": "33.07539000",
                        "longitude": "131.86907000"
                    },
                    {
                        "id": 64559,
                        "name": "Tsurusaki",
                        "latitude": "33.24528000",
                        "longitude": "131.69165000"
                    },
                    {
                        "id": 64601,
                        "name": "Usa Shi",
                        "latitude": "33.44996000",
                        "longitude": "131.33662000"
                    },
                    {
                        "id": 64605,
                        "name": "Usuki",
                        "latitude": "33.12342000",
                        "longitude": "131.80401000"
                    },
                    {
                        "id": 64606,
                        "name": "Usuki Shi",
                        "latitude": "33.07223000",
                        "longitude": "131.74457000"
                    },
                    {
                        "id": 64694,
                        "name": "Yufu-shi",
                        "latitude": "33.17923000",
                        "longitude": "131.43219000"
                    }
                ]
            },
            {
                "id": 820,
                "name": "Okayama",
                "iso2": "33",
                "latitude": "34.89634070",
                "longitude": "133.63753140",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63227,
                        "name": "Akaiwa Shi",
                        "latitude": "34.83767000",
                        "longitude": "134.01792000"
                    },
                    {
                        "id": 63262,
                        "name": "Asakuchi Shi",
                        "latitude": "34.53607000",
                        "longitude": "133.59456000"
                    },
                    {
                        "id": 63286,
                        "name": "Bizen Shi",
                        "latitude": "34.79504000",
                        "longitude": "134.23510000"
                    },
                    {
                        "id": 63531,
                        "name": "Ibara",
                        "latitude": "34.60000000",
                        "longitude": "133.46667000"
                    },
                    {
                        "id": 63532,
                        "name": "Ibara Shi",
                        "latitude": "34.65033000",
                        "longitude": "133.47371000"
                    },
                    {
                        "id": 63701,
                        "name": "Kamogatachō-kamogata",
                        "latitude": "34.53745000",
                        "longitude": "133.58967000"
                    },
                    {
                        "id": 63730,
                        "name": "Kasaoka",
                        "latitude": "34.50597000",
                        "longitude": "133.50391000"
                    },
                    {
                        "id": 63731,
                        "name": "Kasaoka Shi",
                        "latitude": "34.51520000",
                        "longitude": "133.50618000"
                    },
                    {
                        "id": 63865,
                        "name": "Kurashiki",
                        "latitude": "34.58333000",
                        "longitude": "133.76667000"
                    },
                    {
                        "id": 63866,
                        "name": "Kurashiki Shi",
                        "latitude": "34.55466000",
                        "longitude": "133.74826000"
                    },
                    {
                        "id": 63920,
                        "name": "Maniwa-shi",
                        "latitude": "35.13549000",
                        "longitude": "133.69358000"
                    },
                    {
                        "id": 63957,
                        "name": "Mimasaka-shi",
                        "latitude": "35.04419000",
                        "longitude": "134.23052000"
                    },
                    {
                        "id": 64133,
                        "name": "Niimi",
                        "latitude": "34.98333000",
                        "longitude": "133.46667000"
                    },
                    {
                        "id": 64134,
                        "name": "Niimi Shi",
                        "latitude": "35.01571000",
                        "longitude": "133.44900000"
                    },
                    {
                        "id": 64195,
                        "name": "Okayama",
                        "latitude": "34.65000000",
                        "longitude": "133.93333000"
                    },
                    {
                        "id": 64196,
                        "name": "Okayama Shi",
                        "latitude": "34.71251000",
                        "longitude": "133.92329000"
                    },
                    {
                        "id": 64306,
                        "name": "Setouchi Shi",
                        "latitude": "34.66539000",
                        "longitude": "134.14161000"
                    },
                    {
                        "id": 64398,
                        "name": "Sōja",
                        "latitude": "34.67534000",
                        "longitude": "133.75091000"
                    },
                    {
                        "id": 64399,
                        "name": "Sōja Shi",
                        "latitude": "34.70269000",
                        "longitude": "133.70218000"
                    },
                    {
                        "id": 64422,
                        "name": "Takahashi",
                        "latitude": "34.78333000",
                        "longitude": "133.61667000"
                    },
                    {
                        "id": 64423,
                        "name": "Takahashi Shi",
                        "latitude": "34.82103000",
                        "longitude": "133.52435000"
                    },
                    {
                        "id": 64459,
                        "name": "Tamano",
                        "latitude": "34.51745000",
                        "longitude": "133.94574000"
                    },
                    {
                        "id": 64460,
                        "name": "Tamano Shi",
                        "latitude": "34.52507000",
                        "longitude": "133.93769000"
                    },
                    {
                        "id": 64563,
                        "name": "Tsuyama",
                        "latitude": "35.05215000",
                        "longitude": "133.99885000"
                    },
                    {
                        "id": 64564,
                        "name": "Tsuyama-shi",
                        "latitude": "35.14048000",
                        "longitude": "134.03181000"
                    }
                ]
            },
            {
                "id": 853,
                "name": "Okinawa",
                "iso2": "47",
                "latitude": "26.12019110",
                "longitude": "127.70250120",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63292,
                        "name": "Chatan",
                        "latitude": "26.30948000",
                        "longitude": "127.77024000"
                    },
                    {
                        "id": 63387,
                        "name": "Ginowan Shi",
                        "latitude": "26.27620000",
                        "longitude": "127.75742000"
                    },
                    {
                        "id": 63400,
                        "name": "Gushikawa",
                        "latitude": "26.35937000",
                        "longitude": "127.86735000"
                    },
                    {
                        "id": 63493,
                        "name": "Hirara",
                        "latitude": "24.80379000",
                        "longitude": "125.30222000"
                    },
                    {
                        "id": 63590,
                        "name": "Ishigaki",
                        "latitude": "24.34478000",
                        "longitude": "124.15717000"
                    },
                    {
                        "id": 63591,
                        "name": "Ishigaki-shi",
                        "latitude": "24.39401000",
                        "longitude": "124.20113000"
                    },
                    {
                        "id": 63596,
                        "name": "Ishikawa",
                        "latitude": "26.42333000",
                        "longitude": "127.82139000"
                    },
                    {
                        "id": 63612,
                        "name": "Itoman",
                        "latitude": "26.12647000",
                        "longitude": "127.66918000"
                    },
                    {
                        "id": 63613,
                        "name": "Itoman Shi",
                        "latitude": "26.11795000",
                        "longitude": "127.68710000"
                    },
                    {
                        "id": 63757,
                        "name": "Katsuren-haebaru",
                        "latitude": "26.33294000",
                        "longitude": "127.87403000"
                    },
                    {
                        "id": 64002,
                        "name": "Miyakojima Shi",
                        "latitude": "24.78574000",
                        "longitude": "125.30132000"
                    },
                    {
                        "id": 64076,
                        "name": "Nago",
                        "latitude": "26.61502000",
                        "longitude": "127.98543000"
                    },
                    {
                        "id": 64077,
                        "name": "Nago Shi",
                        "latitude": "26.58507000",
                        "longitude": "128.02466000"
                    },
                    {
                        "id": 64079,
                        "name": "Naha",
                        "latitude": "26.21667000",
                        "longitude": "127.68333000"
                    },
                    {
                        "id": 64080,
                        "name": "Naha Shi",
                        "latitude": "26.21077000",
                        "longitude": "127.68645000"
                    },
                    {
                        "id": 64083,
                        "name": "Nakagami-gun",
                        "latitude": "26.30917000",
                        "longitude": "127.77722000"
                    },
                    {
                        "id": 64100,
                        "name": "Nanjō",
                        "latitude": "26.14447000",
                        "longitude": "127.76697000"
                    },
                    {
                        "id": 64101,
                        "name": "Nanjō Shi",
                        "latitude": "26.16371000",
                        "longitude": "127.77874000"
                    },
                    {
                        "id": 64200,
                        "name": "Okinawa",
                        "latitude": "26.33583000",
                        "longitude": "127.80139000"
                    },
                    {
                        "id": 64201,
                        "name": "Okinawa Shi",
                        "latitude": "26.35313000",
                        "longitude": "127.80754000"
                    },
                    {
                        "id": 64504,
                        "name": "Tomigusuku",
                        "latitude": "26.18583000",
                        "longitude": "127.68192000"
                    },
                    {
                        "id": 64505,
                        "name": "Tomigusuku-shi",
                        "latitude": "26.16667000",
                        "longitude": "127.66667000"
                    },
                    {
                        "id": 64596,
                        "name": "Urasoe Shi",
                        "latitude": "26.25106000",
                        "longitude": "127.71512000"
                    },
                    {
                        "id": 64600,
                        "name": "Uruma Shi",
                        "latitude": "26.36777000",
                        "longitude": "127.87373000"
                    },
                    {
                        "id": 64677,
                        "name": "Yonakuni",
                        "latitude": "24.46667000",
                        "longitude": "123.00000000"
                    }
                ]
            },
            {
                "id": 859,
                "name": "Ōsaka",
                "iso2": "27",
                "latitude": "34.64133150",
                "longitude": "135.56293940",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63320,
                        "name": "Daitō Shi",
                        "latitude": "34.71284000",
                        "longitude": "135.63576000"
                    },
                    {
                        "id": 63321,
                        "name": "Daitōchō",
                        "latitude": "34.71378000",
                        "longitude": "135.62033000"
                    },
                    {
                        "id": 63343,
                        "name": "Fujiidera-shi",
                        "latitude": "34.57422000",
                        "longitude": "135.59730000"
                    },
                    {
                        "id": 63405,
                        "name": "Habikino-shi",
                        "latitude": "34.55775000",
                        "longitude": "135.60631000"
                    },
                    {
                        "id": 63435,
                        "name": "Hannan",
                        "latitude": "34.33333000",
                        "longitude": "135.25000000"
                    },
                    {
                        "id": 63436,
                        "name": "Hannan Shi",
                        "latitude": "34.33115000",
                        "longitude": "135.23521000"
                    },
                    {
                        "id": 63471,
                        "name": "Higashiōsaka Shi",
                        "latitude": "34.67112000",
                        "longitude": "135.61760000"
                    },
                    {
                        "id": 63489,
                        "name": "Hirakata",
                        "latitude": "34.81352000",
                        "longitude": "135.64914000"
                    },
                    {
                        "id": 63490,
                        "name": "Hirakata Shi",
                        "latitude": "34.81762000",
                        "longitude": "135.68171000"
                    },
                    {
                        "id": 63533,
                        "name": "Ibaraki",
                        "latitude": "34.81641000",
                        "longitude": "135.56828000"
                    },
                    {
                        "id": 63534,
                        "name": "Ibaraki Shi",
                        "latitude": "34.85588000",
                        "longitude": "135.54998000"
                    },
                    {
                        "id": 63554,
                        "name": "Ikeda",
                        "latitude": "34.82208000",
                        "longitude": "135.42980000"
                    },
                    {
                        "id": 63555,
                        "name": "Ikeda Shi",
                        "latitude": "34.83443000",
                        "longitude": "135.43825000"
                    },
                    {
                        "id": 63640,
                        "name": "Izumi",
                        "latitude": "34.48333000",
                        "longitude": "135.43333000"
                    },
                    {
                        "id": 63643,
                        "name": "Izumi Shi",
                        "latitude": "34.43135000",
                        "longitude": "135.47164000"
                    },
                    {
                        "id": 63646,
                        "name": "Izumiōtsu",
                        "latitude": "34.50000000",
                        "longitude": "135.40000000"
                    },
                    {
                        "id": 63647,
                        "name": "Izumiōtsu Shi",
                        "latitude": "34.50647000",
                        "longitude": "135.40462000"
                    },
                    {
                        "id": 63644,
                        "name": "Izumisano",
                        "latitude": "34.41667000",
                        "longitude": "135.31667000"
                    },
                    {
                        "id": 63645,
                        "name": "Izumisano Shi",
                        "latitude": "34.37398000",
                        "longitude": "135.33682000"
                    },
                    {
                        "id": 63655,
                        "name": "Kadoma",
                        "latitude": "34.73810000",
                        "longitude": "135.57442000"
                    },
                    {
                        "id": 63656,
                        "name": "Kadoma Shi",
                        "latitude": "34.73215000",
                        "longitude": "135.59935000"
                    },
                    {
                        "id": 63665,
                        "name": "Kaizuka",
                        "latitude": "34.45000000",
                        "longitude": "135.35000000"
                    },
                    {
                        "id": 63666,
                        "name": "Kaizuka Shi",
                        "latitude": "34.40105000",
                        "longitude": "135.38510000"
                    },
                    {
                        "id": 63734,
                        "name": "Kashihara",
                        "latitude": "34.58333000",
                        "longitude": "135.61667000"
                    },
                    {
                        "id": 63741,
                        "name": "Kashiwara-shi",
                        "latitude": "34.57920000",
                        "longitude": "135.62867000"
                    },
                    {
                        "id": 63753,
                        "name": "Katano Shi",
                        "latitude": "34.77215000",
                        "longitude": "135.68693000"
                    },
                    {
                        "id": 63766,
                        "name": "Kawachi-nagano Shi",
                        "latitude": "34.40547000",
                        "longitude": "135.56692000"
                    },
                    {
                        "id": 63795,
                        "name": "Kishiwada",
                        "latitude": "34.46667000",
                        "longitude": "135.36667000"
                    },
                    {
                        "id": 63796,
                        "name": "Kishiwada Shi",
                        "latitude": "34.42747000",
                        "longitude": "135.41605000"
                    },
                    {
                        "id": 63929,
                        "name": "Matsubara",
                        "latitude": "34.56667000",
                        "longitude": "135.55000000"
                    },
                    {
                        "id": 63930,
                        "name": "Matsubara-shi",
                        "latitude": "34.57726000",
                        "longitude": "135.55206000"
                    },
                    {
                        "id": 63976,
                        "name": "Mino",
                        "latitude": "34.82691000",
                        "longitude": "135.47057000"
                    },
                    {
                        "id": 63981,
                        "name": "Minoo Shi",
                        "latitude": "34.85590000",
                        "longitude": "135.47926000"
                    },
                    {
                        "id": 63987,
                        "name": "Mishima-gun",
                        "latitude": "34.89887000",
                        "longitude": "135.65325000"
                    },
                    {
                        "id": 64029,
                        "name": "Moriguchi",
                        "latitude": "34.73333000",
                        "longitude": "135.56667000"
                    },
                    {
                        "id": 64123,
                        "name": "Neyagawa",
                        "latitude": "34.76615000",
                        "longitude": "135.62759000"
                    },
                    {
                        "id": 64124,
                        "name": "Neyagawa Shi",
                        "latitude": "34.76539000",
                        "longitude": "135.62696000"
                    },
                    {
                        "id": 64214,
                        "name": "Osaka",
                        "latitude": "34.69374000",
                        "longitude": "135.50218000"
                    },
                    {
                        "id": 64751,
                        "name": "Ōsaka-sayama Shi",
                        "latitude": "34.49645000",
                        "longitude": "135.54894000"
                    },
                    {
                        "id": 64256,
                        "name": "Sakai",
                        "latitude": "34.58333000",
                        "longitude": "135.46667000"
                    },
                    {
                        "id": 64257,
                        "name": "Sakai Shi",
                        "latitude": "34.53166000",
                        "longitude": "135.49460000"
                    },
                    {
                        "id": 64301,
                        "name": "Sennan Shi",
                        "latitude": "34.35164000",
                        "longitude": "135.29176000"
                    },
                    {
                        "id": 64307,
                        "name": "Settsu Shi",
                        "latitude": "34.77220000",
                        "longitude": "135.56824000"
                    },
                    {
                        "id": 64319,
                        "name": "Shijonawate Shi",
                        "latitude": "34.73242000",
                        "longitude": "135.66784000"
                    },
                    {
                        "id": 64379,
                        "name": "Suita",
                        "latitude": "34.76143000",
                        "longitude": "135.51567000"
                    },
                    {
                        "id": 64380,
                        "name": "Suita Shi",
                        "latitude": "34.78556000",
                        "longitude": "135.51909000"
                    },
                    {
                        "id": 64417,
                        "name": "Tajiri",
                        "latitude": "34.42695000",
                        "longitude": "135.24552000"
                    },
                    {
                        "id": 64425,
                        "name": "Takaishi",
                        "latitude": "34.51667000",
                        "longitude": "135.43333000"
                    },
                    {
                        "id": 64426,
                        "name": "Takaishi Shi",
                        "latitude": "34.52868000",
                        "longitude": "135.42958000"
                    },
                    {
                        "id": 64440,
                        "name": "Takatsuki",
                        "latitude": "34.84833000",
                        "longitude": "135.61678000"
                    },
                    {
                        "id": 64441,
                        "name": "Takatsuki Shi",
                        "latitude": "34.88079000",
                        "longitude": "135.60792000"
                    },
                    {
                        "id": 64512,
                        "name": "Tondabayashi Shi",
                        "latitude": "34.48882000",
                        "longitude": "135.59431000"
                    },
                    {
                        "id": 64513,
                        "name": "Tondabayashichō",
                        "latitude": "34.50065000",
                        "longitude": "135.60211000"
                    },
                    {
                        "id": 64529,
                        "name": "Toyonaka",
                        "latitude": "34.78244000",
                        "longitude": "135.46932000"
                    },
                    {
                        "id": 64530,
                        "name": "Toyonaka Shi",
                        "latitude": "34.78191000",
                        "longitude": "135.47276000"
                    },
                    {
                        "id": 64654,
                        "name": "Yao",
                        "latitude": "34.61667000",
                        "longitude": "135.60000000"
                    },
                    {
                        "id": 64655,
                        "name": "Yao-shi",
                        "latitude": "34.62629000",
                        "longitude": "135.60099000"
                    }
                ]
            },
            {
                "id": 863,
                "name": "Saga",
                "iso2": "41",
                "latitude": "33.30783710",
                "longitude": "130.22712430",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63562,
                        "name": "Imari Shi",
                        "latitude": "33.30409000",
                        "longitude": "129.88598000"
                    },
                    {
                        "id": 63563,
                        "name": "Imarichō-kō",
                        "latitude": "33.27362000",
                        "longitude": "129.87877000"
                    },
                    {
                        "id": 63717,
                        "name": "Kanzaki Shi",
                        "latitude": "33.34446000",
                        "longitude": "130.35883000"
                    },
                    {
                        "id": 63721,
                        "name": "Karatsu",
                        "latitude": "33.44250000",
                        "longitude": "129.96972000"
                    },
                    {
                        "id": 63722,
                        "name": "Karatsu Shi",
                        "latitude": "33.41802000",
                        "longitude": "129.99775000"
                    },
                    {
                        "id": 63736,
                        "name": "Kashima",
                        "latitude": "33.10611000",
                        "longitude": "130.09056000"
                    },
                    {
                        "id": 63737,
                        "name": "Kashima Shi",
                        "latitude": "33.06203000",
                        "longitude": "130.09396000"
                    },
                    {
                        "id": 63999,
                        "name": "Miyaki-gun",
                        "latitude": "33.35298000",
                        "longitude": "130.45711000"
                    },
                    {
                        "id": 64188,
                        "name": "Ogi-shi",
                        "latitude": "33.26667000",
                        "longitude": "130.20000000"
                    },
                    {
                        "id": 64239,
                        "name": "Saga",
                        "latitude": "33.23333000",
                        "longitude": "130.30000000"
                    },
                    {
                        "id": 64240,
                        "name": "Saga Shi",
                        "latitude": "33.32558000",
                        "longitude": "130.26430000"
                    },
                    {
                        "id": 64447,
                        "name": "Takeo Shi",
                        "latitude": "33.20413000",
                        "longitude": "129.99775000"
                    },
                    {
                        "id": 64448,
                        "name": "Takeochō-takeo",
                        "latitude": "33.19009000",
                        "longitude": "130.02084000"
                    },
                    {
                        "id": 64454,
                        "name": "Taku Shi",
                        "latitude": "33.27829000",
                        "longitude": "130.10523000"
                    },
                    {
                        "id": 64518,
                        "name": "Tosu Shi",
                        "latitude": "33.37825000",
                        "longitude": "130.49001000"
                    },
                    {
                        "id": 64599,
                        "name": "Ureshino Shi",
                        "latitude": "33.09558000",
                        "longitude": "130.01495000"
                    }
                ]
            },
            {
                "id": 860,
                "name": "Saitama",
                "iso2": "11",
                "latitude": "35.99625130",
                "longitude": "139.44660050",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63218,
                        "name": "Ageo Shi",
                        "latitude": "35.97043000",
                        "longitude": "139.58159000"
                    },
                    {
                        "id": 63219,
                        "name": "Ageoshimo",
                        "latitude": "35.97145000",
                        "longitude": "139.61382000"
                    },
                    {
                        "id": 63260,
                        "name": "Asaka",
                        "latitude": "35.80472000",
                        "longitude": "139.60194000"
                    },
                    {
                        "id": 63261,
                        "name": "Asaka-shi",
                        "latitude": "35.80000000",
                        "longitude": "139.60000000"
                    },
                    {
                        "id": 63294,
                        "name": "Chichibu",
                        "latitude": "35.99028000",
                        "longitude": "139.07639000"
                    },
                    {
                        "id": 63295,
                        "name": "Chichibu-shi",
                        "latitude": "35.95966000",
                        "longitude": "138.93347000"
                    },
                    {
                        "id": 63345,
                        "name": "Fujimi-shi",
                        "latitude": "35.85393000",
                        "longitude": "139.55478000"
                    },
                    {
                        "id": 63346,
                        "name": "Fujimino Shi",
                        "latitude": "35.86505000",
                        "longitude": "139.51524000"
                    },
                    {
                        "id": 63358,
                        "name": "Fukaya-shi",
                        "latitude": "36.20000000",
                        "longitude": "139.28333000"
                    },
                    {
                        "id": 63359,
                        "name": "Fukayachō",
                        "latitude": "36.20000000",
                        "longitude": "139.28333000"
                    },
                    {
                        "id": 63360,
                        "name": "Fukiage-fujimi",
                        "latitude": "36.10000000",
                        "longitude": "139.45000000"
                    },
                    {
                        "id": 63401,
                        "name": "Gyōda",
                        "latitude": "36.14074000",
                        "longitude": "139.46011000"
                    },
                    {
                        "id": 63437,
                        "name": "Hannō",
                        "latitude": "35.85194000",
                        "longitude": "139.31806000"
                    },
                    {
                        "id": 63438,
                        "name": "Hannō-shi",
                        "latitude": "35.85567000",
                        "longitude": "139.32777000"
                    },
                    {
                        "id": 63439,
                        "name": "Hanyū",
                        "latitude": "36.16667000",
                        "longitude": "139.53333000"
                    },
                    {
                        "id": 63440,
                        "name": "Hanyū-shi",
                        "latitude": "36.17251000",
                        "longitude": "139.55338000"
                    },
                    {
                        "id": 63446,
                        "name": "Hasuda",
                        "latitude": "35.97113000",
                        "longitude": "139.64910000"
                    },
                    {
                        "id": 63447,
                        "name": "Hasuda-shi",
                        "latitude": "36.00147000",
                        "longitude": "139.64981000"
                    },
                    {
                        "id": 63448,
                        "name": "Hatogaya-honchō",
                        "latitude": "35.83314000",
                        "longitude": "139.74250000"
                    },
                    {
                        "id": 63457,
                        "name": "Hidaka-shi",
                        "latitude": "35.90859000",
                        "longitude": "139.34346000"
                    },
                    {
                        "id": 63464,
                        "name": "Higashimatsuyama Shi",
                        "latitude": "36.03183000",
                        "longitude": "139.39138000"
                    },
                    {
                        "id": 63475,
                        "name": "Hiki-gun",
                        "latitude": "36.02757000",
                        "longitude": "139.33415000"
                    },
                    {
                        "id": 63523,
                        "name": "Honjō",
                        "latitude": "36.23780000",
                        "longitude": "139.19023000"
                    },
                    {
                        "id": 63524,
                        "name": "Honjō Shi",
                        "latitude": "36.19925000",
                        "longitude": "139.14627000"
                    },
                    {
                        "id": 63579,
                        "name": "Iruma-shi",
                        "latitude": "35.81802000",
                        "longitude": "139.36754000"
                    },
                    {
                        "id": 63635,
                        "name": "Iwatsuki",
                        "latitude": "35.96474000",
                        "longitude": "139.69644000"
                    },
                    {
                        "id": 63688,
                        "name": "Kamifukuoka",
                        "latitude": "35.87266000",
                        "longitude": "139.51369000"
                    },
                    {
                        "id": 63747,
                        "name": "Kasukabe",
                        "latitude": "35.98308000",
                        "longitude": "139.74966000"
                    },
                    {
                        "id": 63748,
                        "name": "Kasukabe Shi",
                        "latitude": "35.98270000",
                        "longitude": "139.77574000"
                    },
                    {
                        "id": 63768,
                        "name": "Kawagoe",
                        "latitude": "35.90861000",
                        "longitude": "139.48528000"
                    },
                    {
                        "id": 63769,
                        "name": "Kawagoe-shi",
                        "latitude": "35.91149000",
                        "longitude": "139.47924000"
                    },
                    {
                        "id": 63770,
                        "name": "Kawaguchi",
                        "latitude": "35.80521000",
                        "longitude": "139.71072000"
                    },
                    {
                        "id": 63771,
                        "name": "Kawaguchi-shi",
                        "latitude": "35.83389000",
                        "longitude": "139.73252000"
                    },
                    {
                        "id": 63778,
                        "name": "Kazo",
                        "latitude": "36.11667000",
                        "longitude": "139.60000000"
                    },
                    {
                        "id": 63779,
                        "name": "Kazo-shi",
                        "latitude": "36.13670000",
                        "longitude": "139.61992000"
                    },
                    {
                        "id": 63792,
                        "name": "Kisai",
                        "latitude": "36.10000000",
                        "longitude": "139.58333000"
                    },
                    {
                        "id": 63810,
                        "name": "Kitamoto Shi",
                        "latitude": "36.02615000",
                        "longitude": "139.53043000"
                    },
                    {
                        "id": 63822,
                        "name": "Kodamachō-kodamaminami",
                        "latitude": "36.18497000",
                        "longitude": "139.13191000"
                    },
                    {
                        "id": 63898,
                        "name": "Kōnosu",
                        "latitude": "36.06868000",
                        "longitude": "139.51684000"
                    },
                    {
                        "id": 63844,
                        "name": "Konosu-Shi",
                        "latitude": "36.06634000",
                        "longitude": "139.52010000"
                    },
                    {
                        "id": 63848,
                        "name": "Koshigaya Shi",
                        "latitude": "35.90108000",
                        "longitude": "139.79023000"
                    },
                    {
                        "id": 63856,
                        "name": "Kuki-shi",
                        "latitude": "36.07664000",
                        "longitude": "139.64941000"
                    },
                    {
                        "id": 63857,
                        "name": "Kukichūō",
                        "latitude": "36.06739000",
                        "longitude": "139.67498000"
                    },
                    {
                        "id": 63858,
                        "name": "Kumagaya Shi",
                        "latitude": "36.16028000",
                        "longitude": "139.37256000"
                    },
                    {
                        "id": 63872,
                        "name": "Kurihashi",
                        "latitude": "36.13333000",
                        "longitude": "139.70000000"
                    },
                    {
                        "id": 63944,
                        "name": "Menuma",
                        "latitude": "36.22245000",
                        "longitude": "139.38205000"
                    },
                    {
                        "id": 63982,
                        "name": "Misato Shi",
                        "latitude": "35.83221000",
                        "longitude": "139.87185000"
                    },
                    {
                        "id": 64036,
                        "name": "Morohongō",
                        "latitude": "35.93556000",
                        "longitude": "139.30444000"
                    },
                    {
                        "id": 64136,
                        "name": "Niiza-shi",
                        "latitude": "35.79345000",
                        "longitude": "139.56559000"
                    },
                    {
                        "id": 64187,
                        "name": "Ogawa",
                        "latitude": "36.05342000",
                        "longitude": "139.26612000"
                    },
                    {
                        "id": 64725,
                        "name": "Ōi",
                        "latitude": "35.85091000",
                        "longitude": "139.51998000"
                    },
                    {
                        "id": 64198,
                        "name": "Okegawa",
                        "latitude": "36.00000000",
                        "longitude": "139.55722000"
                    },
                    {
                        "id": 64199,
                        "name": "Okegawa-shi",
                        "latitude": "36.00000000",
                        "longitude": "139.55000000"
                    },
                    {
                        "id": 64754,
                        "name": "Ōsato-gun",
                        "latitude": "36.11132000",
                        "longitude": "139.20281000"
                    },
                    {
                        "id": 64250,
                        "name": "Saitama",
                        "latitude": "35.90807000",
                        "longitude": "139.65657000"
                    },
                    {
                        "id": 64251,
                        "name": "Saitama-shi",
                        "latitude": "35.86100000",
                        "longitude": "139.64554000"
                    },
                    {
                        "id": 64253,
                        "name": "Sakado",
                        "latitude": "35.95694000",
                        "longitude": "139.38889000"
                    },
                    {
                        "id": 64254,
                        "name": "Sakado-shi",
                        "latitude": "35.96776000",
                        "longitude": "139.40595000"
                    },
                    {
                        "id": 64293,
                        "name": "Satte",
                        "latitude": "36.07254000",
                        "longitude": "139.72615000"
                    },
                    {
                        "id": 64294,
                        "name": "Satte Shi",
                        "latitude": "36.07081000",
                        "longitude": "139.74022000"
                    },
                    {
                        "id": 64296,
                        "name": "Sayama",
                        "latitude": "35.85295000",
                        "longitude": "139.41212000"
                    },
                    {
                        "id": 64320,
                        "name": "Shiki",
                        "latitude": "35.83333000",
                        "longitude": "139.58333000"
                    },
                    {
                        "id": 64321,
                        "name": "Shiki Shi",
                        "latitude": "35.83698000",
                        "longitude": "139.58347000"
                    },
                    {
                        "id": 64335,
                        "name": "Shimotoda",
                        "latitude": "35.81500000",
                        "longitude": "139.68530000"
                    },
                    {
                        "id": 64355,
                        "name": "Shiraoka",
                        "latitude": "36.01839000",
                        "longitude": "139.66034000"
                    },
                    {
                        "id": 64356,
                        "name": "Shiraoka-shi",
                        "latitude": "36.01667000",
                        "longitude": "139.66667000"
                    },
                    {
                        "id": 64370,
                        "name": "Shōbu",
                        "latitude": "36.06667000",
                        "longitude": "139.60000000"
                    },
                    {
                        "id": 64400,
                        "name": "Sōka",
                        "latitude": "35.83643000",
                        "longitude": "139.79957000"
                    },
                    {
                        "id": 64401,
                        "name": "Sōka Shi",
                        "latitude": "35.83868000",
                        "longitude": "139.80216000"
                    },
                    {
                        "id": 64377,
                        "name": "Sugito",
                        "latitude": "36.03107000",
                        "longitude": "139.72636000"
                    },
                    {
                        "id": 64489,
                        "name": "Toda-shi",
                        "latitude": "35.81477000",
                        "longitude": "139.65699000"
                    },
                    {
                        "id": 64495,
                        "name": "Tokorozawa",
                        "latitude": "35.79916000",
                        "longitude": "139.46903000"
                    },
                    {
                        "id": 64496,
                        "name": "Tokorozawa-shi",
                        "latitude": "35.79968000",
                        "longitude": "139.45817000"
                    },
                    {
                        "id": 64555,
                        "name": "Tsurugashima-shi",
                        "latitude": "35.93571000",
                        "longitude": "139.39456000"
                    },
                    {
                        "id": 64621,
                        "name": "Wako",
                        "latitude": "35.78944000",
                        "longitude": "139.62333000"
                    },
                    {
                        "id": 64623,
                        "name": "Wakō-shi",
                        "latitude": "35.78934000",
                        "longitude": "139.61988000"
                    },
                    {
                        "id": 64624,
                        "name": "Warabi-shi",
                        "latitude": "35.82526000",
                        "longitude": "139.68550000"
                    },
                    {
                        "id": 64656,
                        "name": "Yashio",
                        "latitude": "35.82255000",
                        "longitude": "139.83905000"
                    },
                    {
                        "id": 64657,
                        "name": "Yashio-shi",
                        "latitude": "35.80918000",
                        "longitude": "139.84669000"
                    },
                    {
                        "id": 64681,
                        "name": "Yono",
                        "latitude": "35.88333000",
                        "longitude": "139.63333000"
                    },
                    {
                        "id": 64682,
                        "name": "Yorii",
                        "latitude": "36.11567000",
                        "longitude": "139.19429000"
                    },
                    {
                        "id": 64685,
                        "name": "Yoshikawa",
                        "latitude": "35.89232000",
                        "longitude": "139.84184000"
                    },
                    {
                        "id": 64686,
                        "name": "Yoshikawa Shi",
                        "latitude": "35.89512000",
                        "longitude": "139.86090000"
                    }
                ]
            },
            {
                "id": 845,
                "name": "Shiga",
                "iso2": "25",
                "latitude": "35.32920140",
                "longitude": "136.05632120",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63470,
                        "name": "Higashiōmi-shi",
                        "latitude": "35.10890000",
                        "longitude": "136.17920000"
                    },
                    {
                        "id": 63476,
                        "name": "Hikone",
                        "latitude": "35.25000000",
                        "longitude": "136.25000000"
                    },
                    {
                        "id": 63477,
                        "name": "Hikone-shi",
                        "latitude": "35.23036000",
                        "longitude": "136.20760000"
                    },
                    {
                        "id": 63482,
                        "name": "Hino",
                        "latitude": "35.00000000",
                        "longitude": "136.25000000"
                    },
                    {
                        "id": 63799,
                        "name": "Kitahama",
                        "latitude": "35.16667000",
                        "longitude": "135.91667000"
                    },
                    {
                        "id": 63895,
                        "name": "Kōka-shi",
                        "latitude": "34.91667000",
                        "longitude": "136.16667000"
                    },
                    {
                        "id": 63843,
                        "name": "Konan-shi",
                        "latitude": "35.01667000",
                        "longitude": "136.08333000"
                    },
                    {
                        "id": 63881,
                        "name": "Kusatsu",
                        "latitude": "35.01667000",
                        "longitude": "135.96667000"
                    },
                    {
                        "id": 63882,
                        "name": "Kusatsu-shi",
                        "latitude": "35.02758000",
                        "longitude": "135.93840000"
                    },
                    {
                        "id": 63910,
                        "name": "Maibara",
                        "latitude": "35.31667000",
                        "longitude": "136.28333000"
                    },
                    {
                        "id": 63911,
                        "name": "Maibara-shi",
                        "latitude": "35.38457000",
                        "longitude": "136.37741000"
                    },
                    {
                        "id": 63958,
                        "name": "Minakuchichō-matoba",
                        "latitude": "34.96667000",
                        "longitude": "136.16667000"
                    },
                    {
                        "id": 64034,
                        "name": "Moriyama",
                        "latitude": "35.06667000",
                        "longitude": "135.98333000"
                    },
                    {
                        "id": 64035,
                        "name": "Moriyama-shi",
                        "latitude": "35.08815000",
                        "longitude": "135.96869000"
                    },
                    {
                        "id": 64059,
                        "name": "Nagahama",
                        "latitude": "35.38333000",
                        "longitude": "136.26667000"
                    },
                    {
                        "id": 64060,
                        "name": "Nagahama-shi",
                        "latitude": "35.42256000",
                        "longitude": "136.26272000"
                    },
                    {
                        "id": 64740,
                        "name": "Ōmihachiman",
                        "latitude": "35.12861000",
                        "longitude": "136.09760000"
                    },
                    {
                        "id": 64741,
                        "name": "Ōmihachiman-shi",
                        "latitude": "35.15251000",
                        "longitude": "136.06964000"
                    },
                    {
                        "id": 64764,
                        "name": "Ōtsu-shi",
                        "latitude": "35.10203000",
                        "longitude": "135.92452000"
                    },
                    {
                        "id": 64229,
                        "name": "Rittō-shi",
                        "latitude": "34.99603000",
                        "longitude": "136.01412000"
                    },
                    {
                        "id": 64438,
                        "name": "Takashima",
                        "latitude": "35.41347000",
                        "longitude": "136.01612000"
                    },
                    {
                        "id": 64439,
                        "name": "Takashima-shi",
                        "latitude": "35.35448000",
                        "longitude": "136.02859000"
                    },
                    {
                        "id": 64659,
                        "name": "Yasu-shi",
                        "latitude": "35.06801000",
                        "longitude": "136.02327000"
                    },
                    {
                        "id": 64692,
                        "name": "Youkaichi",
                        "latitude": "35.11626000",
                        "longitude": "136.19768000"
                    }
                ]
            },
            {
                "id": 826,
                "name": "Shimane",
                "iso2": "32",
                "latitude": "35.12440940",
                "longitude": "132.62934460",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63403,
                        "name": "Gōtsu Shi",
                        "latitude": "34.98095000",
                        "longitude": "132.29488000"
                    },
                    {
                        "id": 63404,
                        "name": "Gōtsuchō",
                        "latitude": "35.00856000",
                        "longitude": "132.22570000"
                    },
                    {
                        "id": 63423,
                        "name": "Hamada",
                        "latitude": "34.88333000",
                        "longitude": "132.08333000"
                    },
                    {
                        "id": 63424,
                        "name": "Hamada Shi",
                        "latitude": "34.82809000",
                        "longitude": "132.13914000"
                    },
                    {
                        "id": 63494,
                        "name": "Hiratachō",
                        "latitude": "35.43333000",
                        "longitude": "132.81667000"
                    },
                    {
                        "id": 63648,
                        "name": "Izumo",
                        "latitude": "35.36667000",
                        "longitude": "132.76667000"
                    },
                    {
                        "id": 63649,
                        "name": "Izumo Shi",
                        "latitude": "35.33858000",
                        "longitude": "132.73903000"
                    },
                    {
                        "id": 63927,
                        "name": "Masuda",
                        "latitude": "34.66667000",
                        "longitude": "131.85000000"
                    },
                    {
                        "id": 63928,
                        "name": "Masuda Shi",
                        "latitude": "34.62909000",
                        "longitude": "131.94590000"
                    },
                    {
                        "id": 63933,
                        "name": "Matsue",
                        "latitude": "35.48333000",
                        "longitude": "133.05000000"
                    },
                    {
                        "id": 63934,
                        "name": "Matsue Shi",
                        "latitude": "35.47702000",
                        "longitude": "133.05917000"
                    },
                    {
                        "id": 64717,
                        "name": "Ōda Shi",
                        "latitude": "35.13958000",
                        "longitude": "132.48811000"
                    },
                    {
                        "id": 64718,
                        "name": "Ōdachō-ōda",
                        "latitude": "35.19025000",
                        "longitude": "132.50846000"
                    },
                    {
                        "id": 64590,
                        "name": "Unnan Shi",
                        "latitude": "35.24918000",
                        "longitude": "132.89478000"
                    },
                    {
                        "id": 64660,
                        "name": "Yasugi Shi",
                        "latitude": "35.33570000",
                        "longitude": "133.19761000"
                    },
                    {
                        "id": 64661,
                        "name": "Yasugichō",
                        "latitude": "35.42146000",
                        "longitude": "133.24224000"
                    }
                ]
            },
            {
                "id": 825,
                "name": "Shizuoka",
                "iso2": "22",
                "latitude": "35.09293970",
                "longitude": "138.31902760",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63270,
                        "name": "Atami",
                        "latitude": "35.08834000",
                        "longitude": "139.05325000"
                    },
                    {
                        "id": 63271,
                        "name": "Atami-shi",
                        "latitude": "35.08957000",
                        "longitude": "139.06357000"
                    },
                    {
                        "id": 63340,
                        "name": "Fuji Shi",
                        "latitude": "35.20106000",
                        "longitude": "138.69905000"
                    },
                    {
                        "id": 63342,
                        "name": "Fujieda Shi",
                        "latitude": "34.91956000",
                        "longitude": "138.23379000"
                    },
                    {
                        "id": 63347,
                        "name": "Fujinomiya",
                        "latitude": "35.21667000",
                        "longitude": "138.61667000"
                    },
                    {
                        "id": 63348,
                        "name": "Fujinomiya Shi",
                        "latitude": "35.31753000",
                        "longitude": "138.62375000"
                    },
                    {
                        "id": 63368,
                        "name": "Fukuroi",
                        "latitude": "34.75000000",
                        "longitude": "137.91667000"
                    },
                    {
                        "id": 63369,
                        "name": "Fukuroi-shi",
                        "latitude": "34.74175000",
                        "longitude": "137.92805000"
                    },
                    {
                        "id": 63396,
                        "name": "Gotenba Shi",
                        "latitude": "35.29893000",
                        "longitude": "138.87902000"
                    },
                    {
                        "id": 63425,
                        "name": "Hamakita",
                        "latitude": "34.80000000",
                        "longitude": "137.78333000"
                    },
                    {
                        "id": 63426,
                        "name": "Hamamatsu",
                        "latitude": "34.70000000",
                        "longitude": "137.73333000"
                    },
                    {
                        "id": 63427,
                        "name": "Hamamatsu-shi",
                        "latitude": "34.95375000",
                        "longitude": "137.80733000"
                    },
                    {
                        "id": 63452,
                        "name": "Heda",
                        "latitude": "34.96277000",
                        "longitude": "138.78543000"
                    },
                    {
                        "id": 63616,
                        "name": "Itō",
                        "latitude": "34.96667000",
                        "longitude": "139.08333000"
                    },
                    {
                        "id": 63617,
                        "name": "Itō Shi",
                        "latitude": "34.93563000",
                        "longitude": "139.08725000"
                    },
                    {
                        "id": 63632,
                        "name": "Iwata",
                        "latitude": "34.70000000",
                        "longitude": "137.85000000"
                    },
                    {
                        "id": 63633,
                        "name": "Iwata-shi",
                        "latitude": "34.74451000",
                        "longitude": "137.85043000"
                    },
                    {
                        "id": 63638,
                        "name": "Izu",
                        "latitude": "34.97159000",
                        "longitude": "138.94643000"
                    },
                    {
                        "id": 63639,
                        "name": "Izu-shi",
                        "latitude": "34.92201000",
                        "longitude": "138.92585000"
                    },
                    {
                        "id": 63650,
                        "name": "Izunokuni-shi",
                        "latitude": "35.03799000",
                        "longitude": "138.97295000"
                    },
                    {
                        "id": 63669,
                        "name": "Kakegawa",
                        "latitude": "34.76667000",
                        "longitude": "138.01667000"
                    },
                    {
                        "id": 63670,
                        "name": "Kakegawa Shi",
                        "latitude": "34.77993000",
                        "longitude": "138.01897000"
                    },
                    {
                        "id": 63705,
                        "name": "Kanaya",
                        "latitude": "34.82022000",
                        "longitude": "138.12775000"
                    },
                    {
                        "id": 63786,
                        "name": "Kikugawa-shi",
                        "latitude": "34.75000000",
                        "longitude": "138.10000000"
                    },
                    {
                        "id": 63845,
                        "name": "Kosai",
                        "latitude": "34.70053000",
                        "longitude": "137.52253000"
                    },
                    {
                        "id": 63846,
                        "name": "Kosai-shi",
                        "latitude": "34.73092000",
                        "longitude": "137.51643000"
                    },
                    {
                        "id": 63916,
                        "name": "Makinohara Shi",
                        "latitude": "34.73226000",
                        "longitude": "138.18567000"
                    },
                    {
                        "id": 63985,
                        "name": "Mishima",
                        "latitude": "35.11667000",
                        "longitude": "138.91667000"
                    },
                    {
                        "id": 63986,
                        "name": "Mishima Shi",
                        "latitude": "35.13940000",
                        "longitude": "138.94882000"
                    },
                    {
                        "id": 64028,
                        "name": "Mori",
                        "latitude": "34.83333000",
                        "longitude": "137.93333000"
                    },
                    {
                        "id": 64172,
                        "name": "Numazu-shi",
                        "latitude": "35.09491000",
                        "longitude": "138.86667000"
                    },
                    {
                        "id": 64203,
                        "name": "Omaezaki-shi",
                        "latitude": "34.60000000",
                        "longitude": "138.21667000"
                    },
                    {
                        "id": 64768,
                        "name": "Ōyama",
                        "latitude": "34.60359000",
                        "longitude": "138.21719000"
                    },
                    {
                        "id": 64244,
                        "name": "Sagara",
                        "latitude": "34.68503000",
                        "longitude": "138.20461000"
                    },
                    {
                        "id": 64327,
                        "name": "Shimada",
                        "latitude": "34.81667000",
                        "longitude": "138.18333000"
                    },
                    {
                        "id": 64328,
                        "name": "Shimada-shi",
                        "latitude": "34.91220000",
                        "longitude": "138.12662000"
                    },
                    {
                        "id": 64330,
                        "name": "Shimoda",
                        "latitude": "34.67652000",
                        "longitude": "138.94456000"
                    },
                    {
                        "id": 64331,
                        "name": "Shimoda-shi",
                        "latitude": "34.70879000",
                        "longitude": "138.92148000"
                    },
                    {
                        "id": 64366,
                        "name": "Shizuoka",
                        "latitude": "34.98333000",
                        "longitude": "138.38333000"
                    },
                    {
                        "id": 64367,
                        "name": "Shizuoka-shi",
                        "latitude": "35.20164000",
                        "longitude": "138.31426000"
                    },
                    {
                        "id": 64388,
                        "name": "Susono",
                        "latitude": "35.17388000",
                        "longitude": "138.90691000"
                    },
                    {
                        "id": 64389,
                        "name": "Susono Shi",
                        "latitude": "35.22551000",
                        "longitude": "138.87734000"
                    },
                    {
                        "id": 64634,
                        "name": "Yaizu",
                        "latitude": "34.86877000",
                        "longitude": "138.31952000"
                    },
                    {
                        "id": 64635,
                        "name": "Yaizu Shi",
                        "latitude": "34.84008000",
                        "longitude": "138.30127000"
                    }
                ]
            },
            {
                "id": 854,
                "name": "Tochigi",
                "iso2": "09",
                "latitude": "36.67147390",
                "longitude": "139.85472660",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63266,
                        "name": "Ashikaga",
                        "latitude": "36.33333000",
                        "longitude": "139.45000000"
                    },
                    {
                        "id": 63349,
                        "name": "Fujioka",
                        "latitude": "36.25000000",
                        "longitude": "139.65000000"
                    },
                    {
                        "id": 63561,
                        "name": "Imaichi",
                        "latitude": "36.71667000",
                        "longitude": "139.68333000"
                    },
                    {
                        "id": 63694,
                        "name": "Kaminokawa",
                        "latitude": "36.43333000",
                        "longitude": "139.91667000"
                    },
                    {
                        "id": 63715,
                        "name": "Kanuma",
                        "latitude": "36.55000000",
                        "longitude": "139.73333000"
                    },
                    {
                        "id": 63716,
                        "name": "Kanuma-shi",
                        "latitude": "36.57550000",
                        "longitude": "139.64149000"
                    },
                    {
                        "id": 63720,
                        "name": "Karasuyama",
                        "latitude": "36.65000000",
                        "longitude": "140.15000000"
                    },
                    {
                        "id": 63878,
                        "name": "Kuroiso",
                        "latitude": "36.96667000",
                        "longitude": "140.05000000"
                    },
                    {
                        "id": 63926,
                        "name": "Mashiko",
                        "latitude": "36.46667000",
                        "longitude": "140.10000000"
                    },
                    {
                        "id": 63945,
                        "name": "Mibu",
                        "latitude": "36.41667000",
                        "longitude": "139.80000000"
                    },
                    {
                        "id": 64026,
                        "name": "Mooka",
                        "latitude": "36.43333000",
                        "longitude": "140.01667000"
                    },
                    {
                        "id": 64027,
                        "name": "Mooka-shi",
                        "latitude": "36.45000000",
                        "longitude": "140.05000000"
                    },
                    {
                        "id": 64037,
                        "name": "Motegi",
                        "latitude": "36.51667000",
                        "longitude": "140.18333000"
                    },
                    {
                        "id": 64113,
                        "name": "Nasukarasuyama",
                        "latitude": "36.65233000",
                        "longitude": "140.16084000"
                    },
                    {
                        "id": 64114,
                        "name": "Nasukarasuyama-shi",
                        "latitude": "36.66270000",
                        "longitude": "140.13405000"
                    },
                    {
                        "id": 64115,
                        "name": "Nasushiobara-shi",
                        "latitude": "36.99085000",
                        "longitude": "139.91052000"
                    },
                    {
                        "id": 64139,
                        "name": "Nikkō",
                        "latitude": "36.75000000",
                        "longitude": "139.61667000"
                    },
                    {
                        "id": 64138,
                        "name": "Nikko-shi",
                        "latitude": "36.75000000",
                        "longitude": "139.70000000"
                    },
                    {
                        "id": 64762,
                        "name": "Ōtawara",
                        "latitude": "36.86667000",
                        "longitude": "140.03333000"
                    },
                    {
                        "id": 64763,
                        "name": "Ōtawara-shi",
                        "latitude": "36.86129000",
                        "longitude": "140.11915000"
                    },
                    {
                        "id": 64222,
                        "name": "Oyama",
                        "latitude": "36.30000000",
                        "longitude": "139.80000000"
                    },
                    {
                        "id": 64223,
                        "name": "Oyama-shi",
                        "latitude": "36.30800000",
                        "longitude": "139.80195000"
                    },
                    {
                        "id": 64270,
                        "name": "Sakura-shi",
                        "latitude": "36.72362000",
                        "longitude": "140.00289000"
                    },
                    {
                        "id": 64281,
                        "name": "Sano",
                        "latitude": "36.31667000",
                        "longitude": "139.58333000"
                    },
                    {
                        "id": 64282,
                        "name": "Sano-shi",
                        "latitude": "36.42406000",
                        "longitude": "139.53578000"
                    },
                    {
                        "id": 64336,
                        "name": "Shimotsuke-shi",
                        "latitude": "36.40291000",
                        "longitude": "139.86111000"
                    },
                    {
                        "id": 64467,
                        "name": "Tanuma",
                        "latitude": "36.36667000",
                        "longitude": "139.58333000"
                    },
                    {
                        "id": 64487,
                        "name": "Tochigi-shi",
                        "latitude": "36.41128000",
                        "longitude": "139.69357000"
                    },
                    {
                        "id": 64586,
                        "name": "Ujiie",
                        "latitude": "36.68333000",
                        "longitude": "139.96667000"
                    },
                    {
                        "id": 64611,
                        "name": "Utsunomiya",
                        "latitude": "36.56667000",
                        "longitude": "139.88333000"
                    },
                    {
                        "id": 64612,
                        "name": "Utsunomiya-shi",
                        "latitude": "36.59688000",
                        "longitude": "139.88657000"
                    },
                    {
                        "id": 64632,
                        "name": "Yaita",
                        "latitude": "36.80000000",
                        "longitude": "139.93333000"
                    },
                    {
                        "id": 64633,
                        "name": "Yaita-shi",
                        "latitude": "36.82746000",
                        "longitude": "139.89809000"
                    }
                ]
            },
            {
                "id": 836,
                "name": "Tokushima",
                "iso2": "36",
                "latitude": "33.94196550",
                "longitude": "134.32365570",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63245,
                        "name": "Anan Shi",
                        "latitude": "33.87716000",
                        "longitude": "134.60644000"
                    },
                    {
                        "id": 63274,
                        "name": "Awa-shi",
                        "latitude": "34.10000000",
                        "longitude": "134.25000000"
                    },
                    {
                        "id": 63556,
                        "name": "Ikedachō",
                        "latitude": "34.02849000",
                        "longitude": "133.80616000"
                    },
                    {
                        "id": 63593,
                        "name": "Ishii",
                        "latitude": "34.06752000",
                        "longitude": "134.44208000"
                    },
                    {
                        "id": 63704,
                        "name": "Kamojimachō-jōgejima",
                        "latitude": "34.06803000",
                        "longitude": "134.35033000"
                    },
                    {
                        "id": 63761,
                        "name": "Katsuura Gun",
                        "latitude": "33.91380000",
                        "longitude": "134.42641000"
                    },
                    {
                        "id": 63838,
                        "name": "Komatsushima Shi",
                        "latitude": "33.98071000",
                        "longitude": "134.59529000"
                    },
                    {
                        "id": 63839,
                        "name": "Komatsushimachō",
                        "latitude": "34.00000000",
                        "longitude": "134.58333000"
                    },
                    {
                        "id": 63956,
                        "name": "Mima Shi",
                        "latitude": "34.01889000",
                        "longitude": "134.14333000"
                    },
                    {
                        "id": 64015,
                        "name": "Miyoshi Shi",
                        "latitude": "33.93349000",
                        "longitude": "133.85184000"
                    },
                    {
                        "id": 64016,
                        "name": "Miyoshi-gun",
                        "latitude": "34.03647000",
                        "longitude": "133.91818000"
                    },
                    {
                        "id": 64110,
                        "name": "Naruto-shi",
                        "latitude": "34.17881000",
                        "longitude": "134.61357000"
                    },
                    {
                        "id": 64111,
                        "name": "Narutochō-mitsuishi",
                        "latitude": "34.19933000",
                        "longitude": "134.60932000"
                    },
                    {
                        "id": 64497,
                        "name": "Tokushima",
                        "latitude": "34.06667000",
                        "longitude": "134.56667000"
                    },
                    {
                        "id": 64498,
                        "name": "Tokushima Shi",
                        "latitude": "34.04922000",
                        "longitude": "134.52359000"
                    },
                    {
                        "id": 64618,
                        "name": "Wakimachi",
                        "latitude": "34.06667000",
                        "longitude": "134.15000000"
                    },
                    {
                        "id": 64688,
                        "name": "Yoshinogawa Shi",
                        "latitude": "34.03705000",
                        "longitude": "134.28354000"
                    }
                ]
            },
            {
                "id": 823,
                "name": "Tokyo",
                "iso2": "13",
                "latitude": "35.67619190",
                "longitude": "139.65031060",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63215,
                        "name": "Adachi Ku",
                        "latitude": "35.77880000",
                        "longitude": "139.79509000"
                    },
                    {
                        "id": 63231,
                        "name": "Akiruno-shi",
                        "latitude": "35.73285000",
                        "longitude": "139.22525000"
                    },
                    {
                        "id": 63232,
                        "name": "Akishima-shi",
                        "latitude": "35.70782000",
                        "longitude": "139.36418000"
                    },
                    {
                        "id": 63252,
                        "name": "Arakawa Ku",
                        "latitude": "35.73993000",
                        "longitude": "139.78130000"
                    },
                    {
                        "id": 63289,
                        "name": "Bunkyō-ku",
                        "latitude": "35.71745000",
                        "longitude": "139.74729000"
                    },
                    {
                        "id": 63311,
                        "name": "Chiyoda-ku",
                        "latitude": "35.69402000",
                        "longitude": "139.75363000"
                    },
                    {
                        "id": 63312,
                        "name": "Chōfu",
                        "latitude": "35.65924000",
                        "longitude": "139.54837000"
                    },
                    {
                        "id": 63313,
                        "name": "Chōfu-shi",
                        "latitude": "35.65000000",
                        "longitude": "139.55000000"
                    },
                    {
                        "id": 63315,
                        "name": "Chūō Ku",
                        "latitude": "35.66993000",
                        "longitude": "139.77705000"
                    },
                    {
                        "id": 63330,
                        "name": "Edogawa Ku",
                        "latitude": "35.69242000",
                        "longitude": "139.87567000"
                    },
                    {
                        "id": 63336,
                        "name": "Fuchū-shi",
                        "latitude": "35.66667000",
                        "longitude": "139.50000000"
                    },
                    {
                        "id": 63380,
                        "name": "Fussa",
                        "latitude": "35.73667000",
                        "longitude": "139.32361000"
                    },
                    {
                        "id": 63410,
                        "name": "Hachiōji",
                        "latitude": "35.65583000",
                        "longitude": "139.32389000"
                    },
                    {
                        "id": 63429,
                        "name": "Hamura-shi",
                        "latitude": "35.76351000",
                        "longitude": "139.31411000"
                    },
                    {
                        "id": 63458,
                        "name": "Higashi-murayama-shi",
                        "latitude": "35.75529000",
                        "longitude": "139.46972000"
                    },
                    {
                        "id": 63461,
                        "name": "Higashikurume-shi",
                        "latitude": "35.75821000",
                        "longitude": "139.52954000"
                    },
                    {
                        "id": 63465,
                        "name": "Higashimurayama",
                        "latitude": "35.75459000",
                        "longitude": "139.46852000"
                    },
                    {
                        "id": 63468,
                        "name": "Higashiyamato",
                        "latitude": "35.76298000",
                        "longitude": "139.44575000"
                    },
                    {
                        "id": 63469,
                        "name": "Higashiyamato-shi",
                        "latitude": "35.75031000",
                        "longitude": "139.42660000"
                    },
                    {
                        "id": 63483,
                        "name": "Hino",
                        "latitude": "35.67306000",
                        "longitude": "139.40028000"
                    },
                    {
                        "id": 63484,
                        "name": "Hino-shi",
                        "latitude": "35.66333000",
                        "longitude": "139.39865000"
                    },
                    {
                        "id": 63569,
                        "name": "Inagi-shi",
                        "latitude": "35.63290000",
                        "longitude": "139.49291000"
                    },
                    {
                        "id": 63605,
                        "name": "Itabashi-ku",
                        "latitude": "35.75118000",
                        "longitude": "139.70927000"
                    },
                    {
                        "id": 63615,
                        "name": "Itsukaichi",
                        "latitude": "35.72528000",
                        "longitude": "139.21778000"
                    },
                    {
                        "id": 63697,
                        "name": "Kamirenjaku",
                        "latitude": "35.69423000",
                        "longitude": "139.55495000"
                    },
                    {
                        "id": 63758,
                        "name": "Katsushika Ku",
                        "latitude": "35.75324000",
                        "longitude": "139.85567000"
                    },
                    {
                        "id": 63797,
                        "name": "Kita-ku",
                        "latitude": "35.75264000",
                        "longitude": "139.73348000"
                    },
                    {
                        "id": 63815,
                        "name": "Kiyose-shi",
                        "latitude": "35.78551000",
                        "longitude": "139.52628000"
                    },
                    {
                        "id": 63821,
                        "name": "Kodaira-shi",
                        "latitude": "35.72738000",
                        "longitude": "139.48173000"
                    },
                    {
                        "id": 63827,
                        "name": "Koganei-shi",
                        "latitude": "35.70108000",
                        "longitude": "139.51104000"
                    },
                    {
                        "id": 63830,
                        "name": "Kokubunji",
                        "latitude": "35.70222000",
                        "longitude": "139.47556000"
                    },
                    {
                        "id": 63831,
                        "name": "Kokubunji-shi",
                        "latitude": "35.70552000",
                        "longitude": "139.46125000"
                    },
                    {
                        "id": 63832,
                        "name": "Komae-shi",
                        "latitude": "35.63487000",
                        "longitude": "139.57723000"
                    },
                    {
                        "id": 63903,
                        "name": "Kōtō-ku",
                        "latitude": "35.66667000",
                        "longitude": "139.81667000"
                    },
                    {
                        "id": 63864,
                        "name": "Kunitachi-shi",
                        "latitude": "35.68634000",
                        "longitude": "139.43878000"
                    },
                    {
                        "id": 63905,
                        "name": "Machida",
                        "latitude": "35.54028000",
                        "longitude": "139.45083000"
                    },
                    {
                        "id": 63906,
                        "name": "Machida-shi",
                        "latitude": "35.57626000",
                        "longitude": "139.42998000"
                    },
                    {
                        "id": 63943,
                        "name": "Meguro-ku",
                        "latitude": "35.64146000",
                        "longitude": "139.69817000"
                    },
                    {
                        "id": 63974,
                        "name": "Minato-ku",
                        "latitude": "35.65000000",
                        "longitude": "139.73333000"
                    },
                    {
                        "id": 63988,
                        "name": "Mitaka-shi",
                        "latitude": "35.68351000",
                        "longitude": "139.55963000"
                    },
                    {
                        "id": 64051,
                        "name": "Musashimurayama-shi",
                        "latitude": "35.75037000",
                        "longitude": "139.38391000"
                    },
                    {
                        "id": 64052,
                        "name": "Musashino",
                        "latitude": "35.70611000",
                        "longitude": "139.55944000"
                    },
                    {
                        "id": 64053,
                        "name": "Musashino-shi",
                        "latitude": "35.71771000",
                        "longitude": "139.56600000"
                    },
                    {
                        "id": 64087,
                        "name": "Nakano-ku",
                        "latitude": "35.71091000",
                        "longitude": "139.66248000"
                    },
                    {
                        "id": 64122,
                        "name": "Nerima-ku",
                        "latitude": "35.73551000",
                        "longitude": "139.65168000"
                    },
                    {
                        "id": 64146,
                        "name": "Nishi-Tokyo-shi",
                        "latitude": "35.72526000",
                        "longitude": "139.53830000"
                    },
                    {
                        "id": 64155,
                        "name": "Nishitōkyō-shi",
                        "latitude": "35.73485000",
                        "longitude": "139.54624000"
                    },
                    {
                        "id": 64738,
                        "name": "Ōme",
                        "latitude": "35.78389000",
                        "longitude": "139.24306000"
                    },
                    {
                        "id": 64739,
                        "name": "Ōme-shi",
                        "latitude": "35.78814000",
                        "longitude": "139.27501000"
                    },
                    {
                        "id": 64758,
                        "name": "Ōta-ku",
                        "latitude": "35.56126000",
                        "longitude": "139.71605000"
                    },
                    {
                        "id": 64302,
                        "name": "Setagaya-ku",
                        "latitude": "35.64657000",
                        "longitude": "139.65325000"
                    },
                    {
                        "id": 64316,
                        "name": "Shibuya-ku",
                        "latitude": "35.66404000",
                        "longitude": "139.69821000"
                    },
                    {
                        "id": 64338,
                        "name": "Shinagawa-ku",
                        "latitude": "35.60902000",
                        "longitude": "139.73017000"
                    },
                    {
                        "id": 64342,
                        "name": "Shinjuku-ku",
                        "latitude": "35.69384000",
                        "longitude": "139.70355000"
                    },
                    {
                        "id": 64376,
                        "name": "Suginami-ku",
                        "latitude": "35.69951000",
                        "longitude": "139.63641000"
                    },
                    {
                        "id": 64383,
                        "name": "Sumida-ku",
                        "latitude": "35.71072000",
                        "longitude": "139.80150000"
                    },
                    {
                        "id": 64405,
                        "name": "Tachikawa-shi",
                        "latitude": "35.71447000",
                        "longitude": "139.40453000"
                    },
                    {
                        "id": 64414,
                        "name": "Taitō-ku",
                        "latitude": "35.71261000",
                        "longitude": "139.78000000"
                    },
                    {
                        "id": 64455,
                        "name": "Tama-shi",
                        "latitude": "35.63054000",
                        "longitude": "139.43976000"
                    },
                    {
                        "id": 64465,
                        "name": "Tanashichō",
                        "latitude": "35.72922000",
                        "longitude": "139.53813000"
                    },
                    {
                        "id": 64500,
                        "name": "Tokyo",
                        "latitude": "35.68950000",
                        "longitude": "139.69171000"
                    },
                    {
                        "id": 64517,
                        "name": "Toshima-ku",
                        "latitude": "35.73246000",
                        "longitude": "139.71540000"
                    },
                    {
                        "id": 64597,
                        "name": "Urayasu",
                        "latitude": "35.67056000",
                        "longitude": "139.88861000"
                    }
                ]
            },
            {
                "id": 850,
                "name": "Tottori",
                "iso2": "31",
                "latitude": "35.35731610",
                "longitude": "133.40666180",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63867,
                        "name": "Kurayoshi-shi",
                        "latitude": "35.39110000",
                        "longitude": "133.74577000"
                    },
                    {
                        "id": 64262,
                        "name": "Sakaiminato",
                        "latitude": "35.53774000",
                        "longitude": "133.23094000"
                    },
                    {
                        "id": 64263,
                        "name": "Sakaiminato Shi",
                        "latitude": "35.52034000",
                        "longitude": "133.22704000"
                    },
                    {
                        "id": 64519,
                        "name": "Tottori-shi",
                        "latitude": "35.43255000",
                        "longitude": "134.15576000"
                    },
                    {
                        "id": 64676,
                        "name": "Yonago Shi",
                        "latitude": "35.43486000",
                        "longitude": "133.35873000"
                    }
                ]
            },
            {
                "id": 838,
                "name": "Toyama",
                "iso2": "16",
                "latitude": "36.69582660",
                "longitude": "137.21370710",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63364,
                        "name": "Fukumitsu",
                        "latitude": "36.55751000",
                        "longitude": "136.86945000"
                    },
                    {
                        "id": 63480,
                        "name": "Himi Shi",
                        "latitude": "36.87218000",
                        "longitude": "136.94066000"
                    },
                    {
                        "id": 63481,
                        "name": "Himimachi",
                        "latitude": "36.85609000",
                        "longitude": "136.98850000"
                    },
                    {
                        "id": 63564,
                        "name": "Imizu Shi",
                        "latitude": "36.72939000",
                        "longitude": "137.08784000"
                    },
                    {
                        "id": 63690,
                        "name": "Kamiichi",
                        "latitude": "36.70000000",
                        "longitude": "137.36667000"
                    },
                    {
                        "id": 63874,
                        "name": "Kurobe-shi",
                        "latitude": "36.90123000",
                        "longitude": "137.44955000"
                    },
                    {
                        "id": 64095,
                        "name": "Namerikawa",
                        "latitude": "36.75965000",
                        "longitude": "137.36215000"
                    },
                    {
                        "id": 64096,
                        "name": "Namerikawa-shi",
                        "latitude": "36.74934000",
                        "longitude": "137.38129000"
                    },
                    {
                        "id": 64103,
                        "name": "Nanto Shi",
                        "latitude": "36.45260000",
                        "longitude": "136.91430000"
                    },
                    {
                        "id": 64104,
                        "name": "Nanto-shi",
                        "latitude": "36.56922000",
                        "longitude": "136.91162000"
                    },
                    {
                        "id": 64154,
                        "name": "Nishishinminato",
                        "latitude": "36.77957000",
                        "longitude": "137.07576000"
                    },
                    {
                        "id": 64173,
                        "name": "Nyūzen",
                        "latitude": "36.93744000",
                        "longitude": "137.50059000"
                    },
                    {
                        "id": 64220,
                        "name": "Oyabe",
                        "latitude": "36.66667000",
                        "longitude": "136.85000000"
                    },
                    {
                        "id": 64221,
                        "name": "Oyabe Shi",
                        "latitude": "36.66349000",
                        "longitude": "136.85499000"
                    },
                    {
                        "id": 64431,
                        "name": "Takaoka",
                        "latitude": "36.75000000",
                        "longitude": "137.01667000"
                    },
                    {
                        "id": 64432,
                        "name": "Takaoka Shi",
                        "latitude": "36.74257000",
                        "longitude": "136.96263000"
                    },
                    {
                        "id": 64511,
                        "name": "Tonami Shi",
                        "latitude": "36.62395000",
                        "longitude": "136.98899000"
                    },
                    {
                        "id": 64521,
                        "name": "Toyama Shi",
                        "latitude": "36.55146000",
                        "longitude": "137.29872000"
                    },
                    {
                        "id": 64594,
                        "name": "Uozu",
                        "latitude": "36.80000000",
                        "longitude": "137.40000000"
                    },
                    {
                        "id": 64595,
                        "name": "Uozu Shi",
                        "latitude": "36.76234000",
                        "longitude": "137.48984000"
                    },
                    {
                        "id": 64663,
                        "name": "Yatsuomachi-higashikumisaka",
                        "latitude": "36.56667000",
                        "longitude": "137.13333000"
                    }
                ]
            },
            {
                "id": 844,
                "name": "Wakayama",
                "iso2": "30",
                "latitude": "33.94809140",
                "longitude": "135.37453580",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63255,
                        "name": "Arida Shi",
                        "latitude": "34.07937000",
                        "longitude": "135.14230000"
                    },
                    {
                        "id": 63388,
                        "name": "Gobō",
                        "latitude": "33.88153000",
                        "longitude": "135.16960000"
                    },
                    {
                        "id": 63444,
                        "name": "Hashimoto",
                        "latitude": "34.31667000",
                        "longitude": "135.61667000"
                    },
                    {
                        "id": 63445,
                        "name": "Hashimoto Shi",
                        "latitude": "34.32417000",
                        "longitude": "135.61045000"
                    },
                    {
                        "id": 63618,
                        "name": "Iwade",
                        "latitude": "34.25000000",
                        "longitude": "135.31667000"
                    },
                    {
                        "id": 63619,
                        "name": "Iwade Shi",
                        "latitude": "34.28089000",
                        "longitude": "135.30560000"
                    },
                    {
                        "id": 63662,
                        "name": "Kainan",
                        "latitude": "34.15166000",
                        "longitude": "135.21398000"
                    },
                    {
                        "id": 63663,
                        "name": "Kainan Shi",
                        "latitude": "34.14182000",
                        "longitude": "135.22400000"
                    },
                    {
                        "id": 63788,
                        "name": "Kinokawa Shi",
                        "latitude": "34.25400000",
                        "longitude": "135.39412000"
                    },
                    {
                        "id": 63904,
                        "name": "Kōya",
                        "latitude": "34.21294000",
                        "longitude": "135.62244000"
                    },
                    {
                        "id": 63973,
                        "name": "Minato",
                        "latitude": "34.21520000",
                        "longitude": "135.15010000"
                    },
                    {
                        "id": 64339,
                        "name": "Shingū",
                        "latitude": "33.73333000",
                        "longitude": "135.98333000"
                    },
                    {
                        "id": 64341,
                        "name": "Shingū-shi",
                        "latitude": "33.76663000",
                        "longitude": "135.85863000"
                    },
                    {
                        "id": 64464,
                        "name": "Tanabe-shi",
                        "latitude": "33.82731000",
                        "longitude": "135.57786000"
                    },
                    {
                        "id": 64616,
                        "name": "Wakayama",
                        "latitude": "34.23333000",
                        "longitude": "135.16667000"
                    },
                    {
                        "id": 64617,
                        "name": "Wakayama Shi",
                        "latitude": "34.24252000",
                        "longitude": "135.19595000"
                    }
                ]
            },
            {
                "id": 837,
                "name": "Yamagata",
                "iso2": "06",
                "latitude": "38.53705640",
                "longitude": "140.14351980",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63466,
                        "name": "Higashine",
                        "latitude": "38.43889000",
                        "longitude": "140.40056000"
                    },
                    {
                        "id": 63467,
                        "name": "Higashine Shi",
                        "latitude": "38.42559000",
                        "longitude": "140.46670000"
                    },
                    {
                        "id": 63695,
                        "name": "Kaminoyama",
                        "latitude": "38.15389000",
                        "longitude": "140.27361000"
                    },
                    {
                        "id": 63696,
                        "name": "Kaminoyama-shi",
                        "latitude": "38.13333000",
                        "longitude": "140.33333000"
                    },
                    {
                        "id": 64047,
                        "name": "Murayama",
                        "latitude": "38.46972000",
                        "longitude": "140.41441000"
                    },
                    {
                        "id": 64048,
                        "name": "Murayama Shi",
                        "latitude": "38.51671000",
                        "longitude": "140.33518000"
                    },
                    {
                        "id": 64061,
                        "name": "Nagai",
                        "latitude": "38.10361000",
                        "longitude": "140.03500000"
                    },
                    {
                        "id": 64062,
                        "name": "Nagai-shi",
                        "latitude": "38.16667000",
                        "longitude": "140.00000000"
                    },
                    {
                        "id": 64105,
                        "name": "Nanyō Shi",
                        "latitude": "38.10319000",
                        "longitude": "140.15609000"
                    },
                    {
                        "id": 64178,
                        "name": "Obanazawa",
                        "latitude": "38.60333000",
                        "longitude": "140.40194000"
                    },
                    {
                        "id": 64179,
                        "name": "Obanazawa Shi",
                        "latitude": "38.59362000",
                        "longitude": "140.47681000"
                    },
                    {
                        "id": 64241,
                        "name": "Sagae",
                        "latitude": "38.37250000",
                        "longitude": "140.27250000"
                    },
                    {
                        "id": 64242,
                        "name": "Sagae-shi",
                        "latitude": "38.45000000",
                        "longitude": "140.23333000"
                    },
                    {
                        "id": 64264,
                        "name": "Sakata",
                        "latitude": "38.91667000",
                        "longitude": "139.85500000"
                    },
                    {
                        "id": 64265,
                        "name": "Sakata Shi",
                        "latitude": "38.92490000",
                        "longitude": "139.98427000"
                    },
                    {
                        "id": 64343,
                        "name": "Shinjō",
                        "latitude": "38.75861000",
                        "longitude": "140.30083000"
                    },
                    {
                        "id": 64344,
                        "name": "Shinjō Shi",
                        "latitude": "38.78819000",
                        "longitude": "140.33989000"
                    },
                    {
                        "id": 64424,
                        "name": "Takahata",
                        "latitude": "38.00250000",
                        "longitude": "140.19111000"
                    },
                    {
                        "id": 64480,
                        "name": "Tendō",
                        "latitude": "38.35361000",
                        "longitude": "140.36972000"
                    },
                    {
                        "id": 64481,
                        "name": "Tendō Shi",
                        "latitude": "38.35819000",
                        "longitude": "140.39652000"
                    },
                    {
                        "id": 64557,
                        "name": "Tsuruoka",
                        "latitude": "38.72167000",
                        "longitude": "139.82167000"
                    },
                    {
                        "id": 64558,
                        "name": "Tsuruoka Shi",
                        "latitude": "38.58507000",
                        "longitude": "139.80839000"
                    },
                    {
                        "id": 64638,
                        "name": "Yamagata",
                        "latitude": "38.23333000",
                        "longitude": "140.36667000"
                    },
                    {
                        "id": 64639,
                        "name": "Yamagata Shi",
                        "latitude": "38.24907000",
                        "longitude": "140.37272000"
                    },
                    {
                        "id": 64679,
                        "name": "Yonezawa",
                        "latitude": "37.91000000",
                        "longitude": "140.11667000"
                    },
                    {
                        "id": 64680,
                        "name": "Yonezawa Shi",
                        "latitude": "37.84998000",
                        "longitude": "140.12160000"
                    },
                    {
                        "id": 64700,
                        "name": "Yuza",
                        "latitude": "39.01573000",
                        "longitude": "139.92909000"
                    }
                ]
            },
            {
                "id": 835,
                "name": "Yamaguchi",
                "iso2": "35",
                "latitude": "34.27967690",
                "longitude": "131.52127420",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63413,
                        "name": "Hagi",
                        "latitude": "34.40000000",
                        "longitude": "131.41667000"
                    },
                    {
                        "id": 63414,
                        "name": "Hagi Shi",
                        "latitude": "34.43206000",
                        "longitude": "131.50623000"
                    },
                    {
                        "id": 63473,
                        "name": "Hikari",
                        "latitude": "33.95500000",
                        "longitude": "131.95000000"
                    },
                    {
                        "id": 63474,
                        "name": "Hikari Shi",
                        "latitude": "33.98247000",
                        "longitude": "131.97485000"
                    },
                    {
                        "id": 63528,
                        "name": "Hōfu",
                        "latitude": "34.05000000",
                        "longitude": "131.56667000"
                    },
                    {
                        "id": 63514,
                        "name": "Hofu Shi",
                        "latitude": "34.07287000",
                        "longitude": "131.56808000"
                    },
                    {
                        "id": 63623,
                        "name": "Iwakuni Shi",
                        "latitude": "34.20608000",
                        "longitude": "132.06286000"
                    },
                    {
                        "id": 63852,
                        "name": "Kudamatsu",
                        "latitude": "34.00000000",
                        "longitude": "131.86667000"
                    },
                    {
                        "id": 63853,
                        "name": "Kudamatsu Shi",
                        "latitude": "34.03243000",
                        "longitude": "131.88683000"
                    },
                    {
                        "id": 63975,
                        "name": "Mine Shi",
                        "latitude": "34.21083000",
                        "longitude": "131.25170000"
                    },
                    {
                        "id": 64074,
                        "name": "Nagato",
                        "latitude": "34.38333000",
                        "longitude": "131.20000000"
                    },
                    {
                        "id": 64075,
                        "name": "Nagato Shi",
                        "latitude": "34.34880000",
                        "longitude": "131.14703000"
                    },
                    {
                        "id": 64190,
                        "name": "Ogōri-shimogō",
                        "latitude": "34.10000000",
                        "longitude": "131.40000000"
                    },
                    {
                        "id": 64211,
                        "name": "Onoda",
                        "latitude": "34.00139000",
                        "longitude": "131.18361000"
                    },
                    {
                        "id": 64284,
                        "name": "Sanyōonoda Shi",
                        "latitude": "34.03956000",
                        "longitude": "131.15417000"
                    },
                    {
                        "id": 64334,
                        "name": "Shimonoseki Shi",
                        "latitude": "34.17277000",
                        "longitude": "130.98766000"
                    },
                    {
                        "id": 64371,
                        "name": "Shūnan Shi",
                        "latitude": "34.15136000",
                        "longitude": "131.82498000"
                    },
                    {
                        "id": 64499,
                        "name": "Tokuyama",
                        "latitude": "34.05000000",
                        "longitude": "131.81667000"
                    },
                    {
                        "id": 64576,
                        "name": "Ube",
                        "latitude": "33.94306000",
                        "longitude": "131.25111000"
                    },
                    {
                        "id": 64641,
                        "name": "Yamaguchi Shi",
                        "latitude": "34.17753000",
                        "longitude": "131.54667000"
                    },
                    {
                        "id": 64653,
                        "name": "Yanai Shi",
                        "latitude": "33.96243000",
                        "longitude": "132.13111000"
                    }
                ]
            },
            {
                "id": 852,
                "name": "Yamanashi",
                "iso2": "19",
                "latitude": "35.66351130",
                "longitude": "138.63888790",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 63316,
                        "name": "Chūō-shi",
                        "latitude": "35.58418000",
                        "longitude": "138.54110000"
                    },
                    {
                        "id": 63334,
                        "name": "Enzan",
                        "latitude": "35.70000000",
                        "longitude": "138.73333000"
                    },
                    {
                        "id": 63339,
                        "name": "Fuefuki-shi",
                        "latitude": "35.59955000",
                        "longitude": "138.68067000"
                    },
                    {
                        "id": 63341,
                        "name": "Fuji-yoshida Shi",
                        "latitude": "35.43915000",
                        "longitude": "138.79368000"
                    },
                    {
                        "id": 63344,
                        "name": "Fujikawaguchiko",
                        "latitude": "35.48933000",
                        "longitude": "138.68832000"
                    },
                    {
                        "id": 63355,
                        "name": "Fujiyoshida",
                        "latitude": "35.44032000",
                        "longitude": "138.79586000"
                    },
                    {
                        "id": 63517,
                        "name": "Hokuto",
                        "latitude": "35.83458000",
                        "longitude": "138.39606000"
                    },
                    {
                        "id": 63518,
                        "name": "Hokuto-shi",
                        "latitude": "35.83717000",
                        "longitude": "138.39375000"
                    },
                    {
                        "id": 63583,
                        "name": "Isawa",
                        "latitude": "35.65000000",
                        "longitude": "138.63333000"
                    },
                    {
                        "id": 63661,
                        "name": "Kai-shi",
                        "latitude": "35.71627000",
                        "longitude": "138.51871000"
                    },
                    {
                        "id": 63893,
                        "name": "Kōfu",
                        "latitude": "35.66667000",
                        "longitude": "138.56667000"
                    },
                    {
                        "id": 63894,
                        "name": "Kōfu-shi",
                        "latitude": "35.69606000",
                        "longitude": "138.61261000"
                    },
                    {
                        "id": 63902,
                        "name": "Kōshū-shi",
                        "latitude": "35.72649000",
                        "longitude": "138.79178000"
                    },
                    {
                        "id": 63961,
                        "name": "Minami Alps-shi",
                        "latitude": "35.65065000",
                        "longitude": "138.35413000"
                    },
                    {
                        "id": 64143,
                        "name": "Nirasaki",
                        "latitude": "35.70000000",
                        "longitude": "138.45000000"
                    },
                    {
                        "id": 64144,
                        "name": "Nirasaki-shi",
                        "latitude": "35.71772000",
                        "longitude": "138.41200000"
                    },
                    {
                        "id": 64766,
                        "name": "Ōtsuki",
                        "latitude": "35.61851000",
                        "longitude": "138.97396000"
                    },
                    {
                        "id": 64767,
                        "name": "Ōtsuki-shi",
                        "latitude": "35.64285000",
                        "longitude": "138.91993000"
                    },
                    {
                        "id": 64235,
                        "name": "Ryūō",
                        "latitude": "35.65000000",
                        "longitude": "138.50000000"
                    },
                    {
                        "id": 64552,
                        "name": "Tsuru-shi",
                        "latitude": "35.53660000",
                        "longitude": "138.91489000"
                    },
                    {
                        "id": 64582,
                        "name": "Uenohara",
                        "latitude": "35.61667000",
                        "longitude": "139.11667000"
                    },
                    {
                        "id": 64583,
                        "name": "Uenohara-shi",
                        "latitude": "35.65000000",
                        "longitude": "139.05000000"
                    },
                    {
                        "id": 64643,
                        "name": "Yamanashi-shi",
                        "latitude": "35.79691000",
                        "longitude": "138.69743000"
                    }
                ]
            }
        ]
    },
    {
        "id": 110,
        "name": "Jersey",
        "iso3": "JEY",
        "iso2": "JE",
        "numeric_code": "832",
        "phonecode": "44",
        "capital": "Saint Helier",
        "currency": "GBP",
        "currency_name": "British pound",
        "currency_symbol": "£",
        "tld": ".je",
        "native": "Jersey",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Channel Island",
        "timezones": [
            {
                "zoneName": "Europe\/Jersey",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Jerzenez",
            "ko": "저지 섬",
            "pt-BR": "Jersey",
            "pt": "Jersey",
            "nl": "Jersey",
            "hr": "Jersey",
            "fa": "جرزی",
            "de": "Jersey",
            "es": "Jersey",
            "fr": "Jersey",
            "ja": "ジャージー",
            "it": "Isola di Jersey",
            "zh-CN": "泽西岛",
            "tr": "Jersey",
            "ru": "Джерси",
            "uk": "Джерсі",
            "pl": "Jersey"
        },
        "latitude": "49.25000000",
        "longitude": "-2.16666666",
        "emoji": "🇯🇪",
        "emojiU": "U+1F1EF U+1F1EA",
        "states": [
            {
                "id": 5309,
                "name": "Grouville",
                "iso2": "01",
                "latitude": "49.18212570",
                "longitude": "-2.09419810",
                "type": "parish",
                "cities": [
                    {
                        "id": 154101,
                        "name": "Vingtaine de la Rocque",
                        "latitude": "49.16708180",
                        "longitude": "-2.05058070"
                    },
                    {
                        "id": 154099,
                        "name": "Vingtaine de la Rue",
                        "latitude": "49.18661230",
                        "longitude": "-2.05316130"
                    },
                    {
                        "id": 154100,
                        "name": "Vingtaine de Longueville",
                        "latitude": "49.19001830",
                        "longitude": "-2.04917800"
                    },
                    {
                        "id": 154098,
                        "name": "Vingtaine des Marais",
                        "latitude": "49.18556300",
                        "longitude": "-2.05042200"
                    }
                ]
            },
            {
                "id": 5310,
                "name": "St Brelade",
                "iso2": "02",
                "latitude": "49.18488000",
                "longitude": "-2.24685080",
                "type": "parish",
                "cities": [
                    {
                        "id": 154105,
                        "name": "Vingtaine de la Moye",
                        "latitude": "49.18445480",
                        "longitude": "-2.23950470"
                    },
                    {
                        "id": 154102,
                        "name": "Vingtaine de Noirmont",
                        "latitude": "49.17269850",
                        "longitude": "-2.22550510"
                    },
                    {
                        "id": 154104,
                        "name": "Vingtaine des Quennevais",
                        "latitude": "49.19704320",
                        "longitude": "-2.21618080"
                    },
                    {
                        "id": 154103,
                        "name": "Vingtaine du Coin",
                        "latitude": "49.18753960",
                        "longitude": "-2.18473710"
                    }
                ]
            },
            {
                "id": 5311,
                "name": "St Clement",
                "iso2": "03",
                "latitude": "49.16965790",
                "longitude": "-2.08839340",
                "type": "parish",
                "cities": [
                    {
                        "id": 154106,
                        "name": "Grande Vingtaine",
                        "latitude": "49.17207130",
                        "longitude": "-2.06199370"
                    },
                    {
                        "id": 154108,
                        "name": "Vingtaine de Samarès",
                        "latitude": "49.16497580",
                        "longitude": "-2.09880290"
                    },
                    {
                        "id": 154107,
                        "name": "Vingtaine du Rocquier",
                        "latitude": "49.16708180",
                        "longitude": "-2.05058070"
                    }
                ]
            },
            {
                "id": 5312,
                "name": "St Helier",
                "iso2": "04",
                "latitude": "49.18115230",
                "longitude": "-2.12574260",
                "type": "parish",
                "cities": [
                    {
                        "id": 154111,
                        "name": "Vingtaine de Bas du Mont au Prêtre",
                        "latitude": "49.19939590",
                        "longitude": "-2.11964080"
                    },
                    {
                        "id": 154112,
                        "name": "Vingtaine de Haut du Mont au Prêtre",
                        "latitude": "49.18050190",
                        "longitude": "-2.10323300"
                    },
                    {
                        "id": 154109,
                        "name": "Vingtaine de la Ville",
                        "latitude": "49.18050190",
                        "longitude": "-2.10323300"
                    },
                    {
                        "id": 154113,
                        "name": "Vingtaine du Mont à l'Abbé",
                        "latitude": "49.20036330",
                        "longitude": "-2.13384390"
                    },
                    {
                        "id": 154114,
                        "name": "Vingtaine du Mont Cochon",
                        "latitude": "49.19975370",
                        "longitude": "-2.14757550"
                    },
                    {
                        "id": 154110,
                        "name": "Vingtaine du Rouge Bouillon",
                        "latitude": "49.19291200",
                        "longitude": "-2.10935300"
                    }
                ]
            },
            {
                "id": 5313,
                "name": "St John",
                "iso2": "05",
                "latitude": "49.23912570",
                "longitude": "-2.18026840",
                "type": "parish",
                "cities": [
                    {
                        "id": 154116,
                        "name": "Vingtaine de Hérupe",
                        "latitude": "49.23330120",
                        "longitude": "-2.12357080"
                    },
                    {
                        "id": 154117,
                        "name": "Vingtaine du Douet",
                        "latitude": "49.23459620",
                        "longitude": "-2.17227710"
                    },
                    {
                        "id": 154115,
                        "name": "Vingtaine du Nord",
                        "latitude": "49.23938780",
                        "longitude": "-2.12069720"
                    }
                ]
            },
            {
                "id": 5314,
                "name": "St Lawrence",
                "iso2": "06",
                "latitude": "49.21527480",
                "longitude": "-2.18207700",
                "type": "parish",
                "cities": [
                    {
                        "id": 154119,
                        "name": "Vingtaine Bas de la Vallée",
                        "latitude": "49.21873100",
                        "longitude": "-2.14180450"
                    },
                    {
                        "id": 154120,
                        "name": "Vingtaine du Coin Hatain",
                        "latitude": "49.21873100",
                        "longitude": "-2.14180450"
                    },
                    {
                        "id": 154121,
                        "name": "Vingtaine du Coin Motier",
                        "latitude": "49.21873100",
                        "longitude": "-2.14180450"
                    },
                    {
                        "id": 154122,
                        "name": "Vingtaine du Coin Tourgis Nord",
                        "latitude": "49.21873100",
                        "longitude": "-2.14180450"
                    },
                    {
                        "id": 154123,
                        "name": "Vingtaine du Coin Tourgis Sud",
                        "latitude": "49.21873100",
                        "longitude": "-2.14180450"
                    },
                    {
                        "id": 154118,
                        "name": "Vingtaine Haut de la Vallée",
                        "latitude": "49.21873100",
                        "longitude": "-2.14180450"
                    }
                ]
            },
            {
                "id": 5315,
                "name": "St Martin",
                "iso2": "07",
                "latitude": "49.21641490",
                "longitude": "-2.08133390",
                "type": "parish",
                "cities": [
                    {
                        "id": 154125,
                        "name": "Vingtaine de Faldouet",
                        "latitude": "49.20322040",
                        "longitude": "-2.05269720"
                    },
                    {
                        "id": 154127,
                        "name": "Vingtaine de l'Église",
                        "latitude": "0.00000000",
                        "longitude": "0.00000000"
                    },
                    {
                        "id": 154126,
                        "name": "Vingtaine de la Quéruée",
                        "latitude": "49.22056780",
                        "longitude": "-2.04008200"
                    },
                    {
                        "id": 154124,
                        "name": "Vingtaine de Rozel",
                        "latitude": "49.23569500",
                        "longitude": "-2.05048470"
                    },
                    {
                        "id": 154128,
                        "name": "Vingtaine du Fief de la Reine",
                        "latitude": "49.22056780",
                        "longitude": "-2.04008200"
                    }
                ]
            },
            {
                "id": 5316,
                "name": "St Mary",
                "iso2": "08",
                "latitude": "49.23781810",
                "longitude": "-2.19522130",
                "type": "parish",
                "cities": [
                    {
                        "id": 154130,
                        "name": "Vingtaine du Nord",
                        "latitude": "49.24102700",
                        "longitude": "-2.16900950"
                    },
                    {
                        "id": 154129,
                        "name": "Vingtaine du Sud",
                        "latitude": "49.24102700",
                        "longitude": "-2.16900950"
                    }
                ]
            },
            {
                "id": 5317,
                "name": "St Ouen",
                "iso2": "09",
                "latitude": "49.23680760",
                "longitude": "-2.25835970",
                "type": "parish",
                "cities": [
                    {
                        "id": 154133,
                        "name": "Cueillette de Grantez",
                        "latitude": "49.23123970",
                        "longitude": "-2.22339030"
                    },
                    {
                        "id": 154136,
                        "name": "Cueillette de Léoville",
                        "latitude": "49.23803240",
                        "longitude": "-2.22634870"
                    },
                    {
                        "id": 154134,
                        "name": "Cueillette de Millais",
                        "latitude": "49.24085370",
                        "longitude": "-2.24330420"
                    },
                    {
                        "id": 154135,
                        "name": "Cueillette de Vinchelez",
                        "latitude": "49.24447800",
                        "longitude": "-2.23905430"
                    },
                    {
                        "id": 154132,
                        "name": "Grande Cueillette",
                        "latitude": "49.23747580",
                        "longitude": "-2.22264800"
                    },
                    {
                        "id": 154131,
                        "name": "Petite Cueillette",
                        "latitude": "49.23747580",
                        "longitude": "-2.22264800"
                    }
                ]
            },
            {
                "id": 5318,
                "name": "St Peter",
                "iso2": "10",
                "latitude": "49.21442780",
                "longitude": "-2.23234310",
                "type": "parish",
                "cities": [
                    {
                        "id": 154138,
                        "name": "Grande Vingtaine",
                        "latitude": "49.21065500",
                        "longitude": "-2.19606360"
                    },
                    {
                        "id": 154139,
                        "name": "Vingtaine des Augerez",
                        "latitude": "49.20776790",
                        "longitude": "-2.18629780"
                    },
                    {
                        "id": 154140,
                        "name": "Vingtaine du Coin Varin",
                        "latitude": "49.21451950",
                        "longitude": "-2.18722550"
                    },
                    {
                        "id": 154137,
                        "name": "Vingtaine du Douet",
                        "latitude": "0.00000000",
                        "longitude": "0.00000000"
                    }
                ]
            },
            {
                "id": 5319,
                "name": "St Saviour",
                "iso2": "11",
                "latitude": "49.20119890",
                "longitude": "-2.11257390",
                "type": "parish",
                "cities": [
                    {
                        "id": 154146,
                        "name": "Vingtaine de la Grande Longueville",
                        "latitude": "49.18342350",
                        "longitude": "-2.07844940"
                    },
                    {
                        "id": 154141,
                        "name": "Vingtaine de la Petite Longueville",
                        "latitude": "49.18342350",
                        "longitude": "-2.07844940"
                    },
                    {
                        "id": 154143,
                        "name": "Vingtaine de Maufant",
                        "latitude": "49.20822960",
                        "longitude": "-2.10060600"
                    },
                    {
                        "id": 154142,
                        "name": "Vingtaine de Sous l'Église",
                        "latitude": "0.00000000",
                        "longitude": "0.00000000"
                    },
                    {
                        "id": 154144,
                        "name": "Vingtaine de Sous la Hougue",
                        "latitude": "49.21377110",
                        "longitude": "-2.13576620"
                    },
                    {
                        "id": 154145,
                        "name": "Vingtaine des Pigneaux",
                        "latitude": "49.20262700",
                        "longitude": "-2.07080670"
                    }
                ]
            },
            {
                "id": 5320,
                "name": "Trinity",
                "iso2": "12",
                "latitude": "49.23059000",
                "longitude": "-2.11999360",
                "type": "parish",
                "cities": [
                    {
                        "id": 154151,
                        "name": "Vingtaine de la Croiserie",
                        "latitude": "49.22988270",
                        "longitude": "-2.08601240"
                    },
                    {
                        "id": 154147,
                        "name": "Vingtaine de la Ville-à-l'Évêque",
                        "latitude": "49.23176480",
                        "longitude": "-2.12236840"
                    },
                    {
                        "id": 154148,
                        "name": "Vingtaine de Rozel",
                        "latitude": "49.23842870",
                        "longitude": "-2.06704060"
                    },
                    {
                        "id": 154150,
                        "name": "Vingtaine des Augrès",
                        "latitude": "49.22857290",
                        "longitude": "-2.08235050"
                    },
                    {
                        "id": 154149,
                        "name": "Vingtaine du Rondin",
                        "latitude": "49.22988270",
                        "longitude": "-2.08601240"
                    }
                ]
            }
        ]
    },
    {
        "id": 111,
        "name": "Jordan",
        "iso3": "JOR",
        "iso2": "JO",
        "numeric_code": "400",
        "phonecode": "962",
        "capital": "Amman",
        "currency": "JOD",
        "currency_name": "Jordanian dinar",
        "currency_symbol": "ا.د",
        "tld": ".jo",
        "native": "الأردن",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Jordanian",
        "timezones": [
            {
                "zoneName": "Asia\/Amman",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Jordania",
            "ko": "요르단",
            "pt-BR": "Jordânia",
            "pt": "Jordânia",
            "nl": "Jordanië",
            "hr": "Jordan",
            "fa": "اردن",
            "de": "Jordanien",
            "es": "Jordania",
            "fr": "Jordanie",
            "ja": "ヨルダン",
            "it": "Giordania",
            "zh-CN": "约旦",
            "tr": "Ürdün",
            "ru": "Джордан",
            "uk": "Йорданія",
            "pl": "Jordan"
        },
        "latitude": "31.00000000",
        "longitude": "36.00000000",
        "emoji": "🇯🇴",
        "emojiU": "U+1F1EF U+1F1F4",
        "states": [
            {
                "id": 963,
                "name": "Ajloun",
                "iso2": "AJ",
                "latitude": "32.33255840",
                "longitude": "35.75168440",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63206,
                        "name": "‘Ajlūn",
                        "latitude": "32.33326000",
                        "longitude": "35.75279000"
                    },
                    {
                        "id": 63207,
                        "name": "‘Anjarah",
                        "latitude": "32.30630000",
                        "longitude": "35.75653000"
                    },
                    {
                        "id": 63208,
                        "name": "‘Ayn Jannah",
                        "latitude": "32.33466000",
                        "longitude": "35.76370000"
                    },
                    {
                        "id": 63202,
                        "name": "Ḩalāwah",
                        "latitude": "32.38433000",
                        "longitude": "35.66167000"
                    },
                    {
                        "id": 63199,
                        "name": "Şakhrah",
                        "latitude": "32.37087000",
                        "longitude": "35.84267000"
                    }
                ]
            },
            {
                "id": 965,
                "name": "Amman",
                "iso2": "AM",
                "latitude": "31.94536330",
                "longitude": "35.92838950",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63133,
                        "name": "Al Jīzah",
                        "latitude": "31.69893000",
                        "longitude": "35.95530000"
                    },
                    {
                        "id": 63132,
                        "name": "Al Jubayhah",
                        "latitude": "32.01071000",
                        "longitude": "35.89802000"
                    },
                    {
                        "id": 63141,
                        "name": "Amman",
                        "latitude": "31.95522000",
                        "longitude": "35.94503000"
                    },
                    {
                        "id": 63203,
                        "name": "Ḩayy al Bunayyāt",
                        "latitude": "31.89603000",
                        "longitude": "35.88465000"
                    },
                    {
                        "id": 63204,
                        "name": "Ḩayy al Quwaysimah",
                        "latitude": "31.91037000",
                        "longitude": "35.94975000"
                    },
                    {
                        "id": 63162,
                        "name": "Jāwā",
                        "latitude": "31.85247000",
                        "longitude": "35.93928000"
                    },
                    {
                        "id": 63185,
                        "name": "Saḩāb",
                        "latitude": "31.87032000",
                        "longitude": "36.00479000"
                    },
                    {
                        "id": 63192,
                        "name": "Umm as Summāq",
                        "latitude": "31.88542000",
                        "longitude": "35.85430000"
                    },
                    {
                        "id": 63194,
                        "name": "Wādī as Sīr",
                        "latitude": "31.95450000",
                        "longitude": "35.81831000"
                    }
                ]
            },
            {
                "id": 959,
                "name": "Aqaba",
                "iso2": "AQ",
                "latitude": "29.53208600",
                "longitude": "35.00628210",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63142,
                        "name": "Aqaba",
                        "latitude": "29.52667000",
                        "longitude": "35.00778000"
                    },
                    {
                        "id": 63188,
                        "name": "Tala Bay",
                        "latitude": "29.40842000",
                        "longitude": "34.97918000"
                    }
                ]
            },
            {
                "id": 961,
                "name": "Balqa",
                "iso2": "BA",
                "latitude": "32.03668060",
                "longitude": "35.72884800",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63134,
                        "name": "Al Karāmah",
                        "latitude": "31.95439000",
                        "longitude": "35.58033000"
                    },
                    {
                        "id": 63145,
                        "name": "As Salţ",
                        "latitude": "32.03917000",
                        "longitude": "35.72722000"
                    },
                    {
                        "id": 63195,
                        "name": "Yarqā",
                        "latitude": "31.97583000",
                        "longitude": "35.69638000"
                    }
                ]
            },
            {
                "id": 960,
                "name": "Irbid",
                "iso2": "IR",
                "latitude": "32.55696360",
                "longitude": "35.84789650",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63144,
                        "name": "Ar Ramthā",
                        "latitude": "32.55873000",
                        "longitude": "36.00816000"
                    },
                    {
                        "id": 63146,
                        "name": "Ash Shajarah",
                        "latitude": "32.64391000",
                        "longitude": "35.94175000"
                    },
                    {
                        "id": 63151,
                        "name": "Aţ Ţayyibah",
                        "latitude": "32.54304000",
                        "longitude": "35.71756000"
                    },
                    {
                        "id": 63152,
                        "name": "Aţ Ţurrah",
                        "latitude": "32.63979000",
                        "longitude": "35.98943000"
                    },
                    {
                        "id": 63148,
                        "name": "Aydūn",
                        "latitude": "32.50528000",
                        "longitude": "35.85809000"
                    },
                    {
                        "id": 63155,
                        "name": "Bayt Īdis",
                        "latitude": "32.43775000",
                        "longitude": "35.69765000"
                    },
                    {
                        "id": 63154,
                        "name": "Bayt Yāfā",
                        "latitude": "32.52253000",
                        "longitude": "35.78618000"
                    },
                    {
                        "id": 63158,
                        "name": "Dayr Yūsuf",
                        "latitude": "32.48701000",
                        "longitude": "35.79635000"
                    },
                    {
                        "id": 63201,
                        "name": "Ḩakamā",
                        "latitude": "32.59354000",
                        "longitude": "35.88320000"
                    },
                    {
                        "id": 63205,
                        "name": "Ḩātim",
                        "latitude": "32.64492000",
                        "longitude": "35.77771000"
                    },
                    {
                        "id": 63159,
                        "name": "Irbid",
                        "latitude": "32.55556000",
                        "longitude": "35.85000000"
                    },
                    {
                        "id": 63161,
                        "name": "Judita",
                        "latitude": "32.40792000",
                        "longitude": "35.70802000"
                    },
                    {
                        "id": 63163,
                        "name": "Kafr Abīl",
                        "latitude": "32.41752000",
                        "longitude": "35.66305000"
                    },
                    {
                        "id": 63164,
                        "name": "Kafr Asad",
                        "latitude": "32.59800000",
                        "longitude": "35.71266000"
                    },
                    {
                        "id": 63165,
                        "name": "Kafr Sawm",
                        "latitude": "32.68527000",
                        "longitude": "35.80102000"
                    },
                    {
                        "id": 63167,
                        "name": "Kharjā",
                        "latitude": "32.65988000",
                        "longitude": "35.88782000"
                    },
                    {
                        "id": 63168,
                        "name": "Kitim",
                        "latitude": "32.43834000",
                        "longitude": "35.89677000"
                    },
                    {
                        "id": 63169,
                        "name": "Kurayyimah",
                        "latitude": "32.27639000",
                        "longitude": "35.59938000"
                    },
                    {
                        "id": 63172,
                        "name": "Malkā",
                        "latitude": "32.67645000",
                        "longitude": "35.74851000"
                    },
                    {
                        "id": 63176,
                        "name": "Qumaym",
                        "latitude": "32.57174000",
                        "longitude": "35.73452000"
                    },
                    {
                        "id": 63184,
                        "name": "Saḩam al Kaffārāt",
                        "latitude": "32.69848000",
                        "longitude": "35.77438000"
                    },
                    {
                        "id": 63186,
                        "name": "Sāl",
                        "latitude": "32.56897000",
                        "longitude": "35.91185000"
                    },
                    {
                        "id": 63200,
                        "name": "Şammā",
                        "latitude": "32.57102000",
                        "longitude": "35.68984000"
                    },
                    {
                        "id": 63189,
                        "name": "Tibnah",
                        "latitude": "32.47521000",
                        "longitude": "35.73056000"
                    },
                    {
                        "id": 63190,
                        "name": "Umm Qays",
                        "latitude": "32.65348000",
                        "longitude": "35.68457000"
                    },
                    {
                        "id": 63193,
                        "name": "Waqqāş",
                        "latitude": "32.54214000",
                        "longitude": "35.60508000"
                    },
                    {
                        "id": 63197,
                        "name": "Zaḩar",
                        "latitude": "32.56670000",
                        "longitude": "35.77811000"
                    }
                ]
            },
            {
                "id": 966,
                "name": "Jerash",
                "iso2": "JA",
                "latitude": "32.27472370",
                "longitude": "35.89609540",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63136,
                        "name": "Al Kittah",
                        "latitude": "32.27685000",
                        "longitude": "35.84114000"
                    },
                    {
                        "id": 63153,
                        "name": "Balīlā",
                        "latitude": "32.39109000",
                        "longitude": "35.93832000"
                    },
                    {
                        "id": 63156,
                        "name": "Burmā",
                        "latitude": "32.21930000",
                        "longitude": "35.78507000"
                    },
                    {
                        "id": 63160,
                        "name": "Jarash",
                        "latitude": "32.28082000",
                        "longitude": "35.89929000"
                    },
                    {
                        "id": 63175,
                        "name": "Qafqafā",
                        "latitude": "32.34851000",
                        "longitude": "35.93864000"
                    },
                    {
                        "id": 63178,
                        "name": "Raymūn",
                        "latitude": "32.28202000",
                        "longitude": "35.82779000"
                    },
                    {
                        "id": 63183,
                        "name": "Sakib",
                        "latitude": "32.28431000",
                        "longitude": "35.80909000"
                    },
                    {
                        "id": 63187,
                        "name": "Sūf",
                        "latitude": "32.31372000",
                        "longitude": "35.83713000"
                    }
                ]
            },
            {
                "id": 956,
                "name": "Karak",
                "iso2": "KA",
                "latitude": "31.18535270",
                "longitude": "35.70476820",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63209,
                        "name": "‘Ayy",
                        "latitude": "31.13371000",
                        "longitude": "35.64375000"
                    },
                    {
                        "id": 63210,
                        "name": "‘Izrā",
                        "latitude": "31.15889000",
                        "longitude": "35.69278000"
                    },
                    {
                        "id": 63129,
                        "name": "Adir",
                        "latitude": "31.20217000",
                        "longitude": "35.76155000"
                    },
                    {
                        "id": 63135,
                        "name": "Al Khinzīrah",
                        "latitude": "31.05056000",
                        "longitude": "35.60606000"
                    },
                    {
                        "id": 63137,
                        "name": "Al Mazār al Janūbī",
                        "latitude": "31.06722000",
                        "longitude": "35.69486000"
                    },
                    {
                        "id": 63138,
                        "name": "Al Qaşr",
                        "latitude": "31.31407000",
                        "longitude": "35.74393000"
                    },
                    {
                        "id": 63143,
                        "name": "Ar Rabbah",
                        "latitude": "31.26923000",
                        "longitude": "35.73829000"
                    },
                    {
                        "id": 63166,
                        "name": "Karak City",
                        "latitude": "31.16368000",
                        "longitude": "35.76204000"
                    },
                    {
                        "id": 63182,
                        "name": "Safi",
                        "latitude": "31.03608000",
                        "longitude": "35.46544000"
                    }
                ]
            },
            {
                "id": 964,
                "name": "Ma'an",
                "iso2": "MN",
                "latitude": "30.19267890",
                "longitude": "35.72493190",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63131,
                        "name": "Al Jafr",
                        "latitude": "30.31840000",
                        "longitude": "36.17775000"
                    },
                    {
                        "id": 63139,
                        "name": "Al Quwayrah",
                        "latitude": "29.80045000",
                        "longitude": "35.31160000"
                    },
                    {
                        "id": 63147,
                        "name": "Ash Shawbak",
                        "latitude": "30.52134000",
                        "longitude": "35.57135000"
                    },
                    {
                        "id": 63150,
                        "name": "Aţ Ţayyibah",
                        "latitude": "30.25125000",
                        "longitude": "35.46570000"
                    },
                    {
                        "id": 63170,
                        "name": "Ma'an",
                        "latitude": "30.19624000",
                        "longitude": "35.73405000"
                    },
                    {
                        "id": 63174,
                        "name": "Petra",
                        "latitude": "30.32096000",
                        "longitude": "35.47895000"
                    },
                    {
                        "id": 63177,
                        "name": "Qīr Moāv",
                        "latitude": "31.18248000",
                        "longitude": "35.69999000"
                    }
                ]
            },
            {
                "id": 958,
                "name": "Madaba",
                "iso2": "MD",
                "latitude": "31.71960970",
                "longitude": "35.79327540",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63173,
                        "name": "Mādabā",
                        "latitude": "31.71599000",
                        "longitude": "35.79392000"
                    }
                ]
            },
            {
                "id": 962,
                "name": "Mafraq",
                "iso2": "MA",
                "latitude": "32.34169230",
                "longitude": "36.20201750",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63140,
                        "name": "Al Ḩamrā’",
                        "latitude": "32.44017000",
                        "longitude": "36.15265000"
                    },
                    {
                        "id": 63171,
                        "name": "Mafraq",
                        "latitude": "32.34289000",
                        "longitude": "36.20804000"
                    },
                    {
                        "id": 63179,
                        "name": "Rehab",
                        "latitude": "32.32341000",
                        "longitude": "36.09087000"
                    },
                    {
                        "id": 63180,
                        "name": "Rukban",
                        "latitude": "33.31405000",
                        "longitude": "38.70342000"
                    },
                    {
                        "id": 63198,
                        "name": "Şabḩā",
                        "latitude": "32.32696000",
                        "longitude": "36.50159000"
                    },
                    {
                        "id": 63191,
                        "name": "Umm al Qiţţayn",
                        "latitude": "32.31449000",
                        "longitude": "36.62826000"
                    }
                ]
            },
            {
                "id": 957,
                "name": "Tafilah",
                "iso2": "AT",
                "latitude": "30.83380630",
                "longitude": "35.61605130",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63149,
                        "name": "Aţ Ţafīlah",
                        "latitude": "30.83752000",
                        "longitude": "35.60442000"
                    },
                    {
                        "id": 63157,
                        "name": "Buşayrā",
                        "latitude": "30.73256000",
                        "longitude": "35.60943000"
                    }
                ]
            },
            {
                "id": 967,
                "name": "Zarqa",
                "iso2": "AZ",
                "latitude": "32.06085050",
                "longitude": "36.09421210",
                "type": "governorate",
                "cities": [
                    {
                        "id": 63130,
                        "name": "Al Azraq ash Shamālī",
                        "latitude": "31.88209000",
                        "longitude": "36.83017000"
                    },
                    {
                        "id": 63181,
                        "name": "Russeifa",
                        "latitude": "32.01778000",
                        "longitude": "36.04639000"
                    },
                    {
                        "id": 63196,
                        "name": "Zarqa",
                        "latitude": "32.07275000",
                        "longitude": "36.08796000"
                    }
                ]
            }
        ]
    },
    {
        "id": 112,
        "name": "Kazakhstan",
        "iso3": "KAZ",
        "iso2": "KZ",
        "numeric_code": "398",
        "phonecode": "7",
        "capital": "Astana",
        "currency": "KZT",
        "currency_name": "Kazakhstani tenge",
        "currency_symbol": "лв",
        "tld": ".kz",
        "native": "Қазақстан",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Central Asia",
        "subregion_id": 10,
        "nationality": "Kazakhstani, Kazakh",
        "timezones": [
            {
                "zoneName": "Asia\/Almaty",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "ALMT",
                "tzName": "Alma-Ata Time[1"
            },
            {
                "zoneName": "Asia\/Aqtau",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "AQTT",
                "tzName": "Aqtobe Time"
            },
            {
                "zoneName": "Asia\/Aqtobe",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "AQTT",
                "tzName": "Aqtobe Time"
            },
            {
                "zoneName": "Asia\/Atyrau",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "MSD+1",
                "tzName": "Moscow Daylight Time+1"
            },
            {
                "zoneName": "Asia\/Oral",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "ORAT",
                "tzName": "Oral Time"
            },
            {
                "zoneName": "Asia\/Qostanay",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "QYZST",
                "tzName": "Qyzylorda Summer Time"
            },
            {
                "zoneName": "Asia\/Qyzylorda",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "QYZT",
                "tzName": "Qyzylorda Summer Time"
            }
        ],
        "translations": {
            "br": "Kazakstan",
            "ko": "카자흐스탄",
            "pt-BR": "Cazaquistão",
            "pt": "Cazaquistão",
            "nl": "Kazachstan",
            "hr": "Kazahstan",
            "fa": "قزاقستان",
            "de": "Kasachstan",
            "es": "Kazajistán",
            "fr": "Kazakhstan",
            "ja": "カザフスタン",
            "it": "Kazakistan",
            "zh-CN": "哈萨克斯坦",
            "tr": "Kazakistan",
            "ru": "Казахстан",
            "uk": "Казахстан",
            "pl": "Kazachstan"
        },
        "latitude": "48.00000000",
        "longitude": "68.00000000",
        "emoji": "🇰🇿",
        "emojiU": "U+1F1F0 U+1F1FF",
        "states": [
            {
                "id": 145,
                "name": "Akmola",
                "iso2": "AKM",
                "latitude": "51.91653200",
                "longitude": "69.41104940",
                "type": "region",
                "cities": [
                    {
                        "id": 65596,
                        "name": "Akkol",
                        "latitude": "51.99374000",
                        "longitude": "70.94704000"
                    },
                    {
                        "id": 65597,
                        "name": "Akkol’",
                        "latitude": "53.29617000",
                        "longitude": "69.59997000"
                    },
                    {
                        "id": 65600,
                        "name": "Aksu",
                        "latitude": "52.44422000",
                        "longitude": "71.95761000"
                    },
                    {
                        "id": 65619,
                        "name": "Astrakhan",
                        "latitude": "51.53092000",
                        "longitude": "69.79684000"
                    },
                    {
                        "id": 65624,
                        "name": "Atbasar",
                        "latitude": "51.80652000",
                        "longitude": "68.35996000"
                    },
                    {
                        "id": 65632,
                        "name": "Balkashino",
                        "latitude": "52.51779000",
                        "longitude": "68.75160000"
                    },
                    {
                        "id": 65647,
                        "name": "Bestobe",
                        "latitude": "52.49795000",
                        "longitude": "73.09592000"
                    },
                    {
                        "id": 65665,
                        "name": "Derzhavīnsk",
                        "latitude": "51.09922000",
                        "longitude": "66.31557000"
                    },
                    {
                        "id": 65672,
                        "name": "Egindiköl",
                        "latitude": "51.05412000",
                        "longitude": "69.47928000"
                    },
                    {
                        "id": 65676,
                        "name": "Esil",
                        "latitude": "51.95495000",
                        "longitude": "66.40841000"
                    },
                    {
                        "id": 65698,
                        "name": "Kokshetau",
                        "latitude": "53.28333000",
                        "longitude": "69.40000000"
                    },
                    {
                        "id": 65703,
                        "name": "Krasnogorskiy",
                        "latitude": "52.24560000",
                        "longitude": "66.52081000"
                    },
                    {
                        "id": 65720,
                        "name": "Makinsk",
                        "latitude": "52.63290000",
                        "longitude": "70.41911000"
                    },
                    {
                        "id": 65781,
                        "name": "Shantobe",
                        "latitude": "52.45376000",
                        "longitude": "68.17475000"
                    },
                    {
                        "id": 65784,
                        "name": "Shchuchinsk",
                        "latitude": "52.93592000",
                        "longitude": "70.18895000"
                    },
                    {
                        "id": 65787,
                        "name": "Shortandy",
                        "latitude": "51.69946000",
                        "longitude": "70.99457000"
                    },
                    {
                        "id": 65796,
                        "name": "Stepnogorsk",
                        "latitude": "52.35062000",
                        "longitude": "71.88161000"
                    },
                    {
                        "id": 65797,
                        "name": "Stepnyak",
                        "latitude": "52.83489000",
                        "longitude": "70.78861000"
                    },
                    {
                        "id": 65830,
                        "name": "Yermentau",
                        "latitude": "51.62364000",
                        "longitude": "73.10265000"
                    },
                    {
                        "id": 65832,
                        "name": "Zavodskoy",
                        "latitude": "52.47031000",
                        "longitude": "72.01514000"
                    },
                    {
                        "id": 65840,
                        "name": "Zhaqsy",
                        "latitude": "51.91058000",
                        "longitude": "67.31665000"
                    },
                    {
                        "id": 65847,
                        "name": "Zholymbet",
                        "latitude": "51.74211000",
                        "longitude": "71.71245000"
                    }
                ]
            },
            {
                "id": 151,
                "name": "Aktobe",
                "iso2": "AKT",
                "latitude": "48.77970780",
                "longitude": "57.99743780",
                "type": "region",
                "cities": [
                    {
                        "id": 65605,
                        "name": "Aktobe",
                        "latitude": "50.27969000",
                        "longitude": "57.20718000"
                    },
                    {
                        "id": 65636,
                        "name": "Batamshinskiy",
                        "latitude": "50.56022000",
                        "longitude": "58.27715000"
                    },
                    {
                        "id": 65638,
                        "name": "Bayganin",
                        "latitude": "48.68975000",
                        "longitude": "55.87512000"
                    },
                    {
                        "id": 65674,
                        "name": "Embi",
                        "latitude": "48.82981000",
                        "longitude": "58.15042000"
                    },
                    {
                        "id": 65687,
                        "name": "Kandyagash",
                        "latitude": "49.46912000",
                        "longitude": "57.41914000"
                    },
                    {
                        "id": 65697,
                        "name": "Khromtau",
                        "latitude": "50.25117000",
                        "longitude": "58.44003000"
                    },
                    {
                        "id": 65725,
                        "name": "Martuk",
                        "latitude": "50.74746000",
                        "longitude": "56.50611000"
                    },
                    {
                        "id": 65779,
                        "name": "Shalqar",
                        "latitude": "47.83333000",
                        "longitude": "59.60000000"
                    },
                    {
                        "id": 65788,
                        "name": "Shubarkuduk",
                        "latitude": "49.14391000",
                        "longitude": "56.48196000"
                    },
                    {
                        "id": 65790,
                        "name": "Shubarshi",
                        "latitude": "48.58022000",
                        "longitude": "57.18289000"
                    },
                    {
                        "id": 65808,
                        "name": "Temir",
                        "latitude": "49.14132000",
                        "longitude": "57.12855000"
                    },
                    {
                        "id": 65831,
                        "name": "Yrghyz",
                        "latitude": "48.61667000",
                        "longitude": "61.26667000"
                    }
                ]
            },
            {
                "id": 143,
                "name": "Almaty",
                "iso2": "ALM",
                "latitude": "45.01192270",
                "longitude": "78.42293920",
                "type": "region",
                "cities": [
                    {
                        "id": 65631,
                        "name": "Bakanas",
                        "latitude": "44.80838000",
                        "longitude": "76.27214000"
                    },
                    {
                        "id": 65633,
                        "name": "Balpyk Bī",
                        "latitude": "44.90225000",
                        "longitude": "78.23157000"
                    },
                    {
                        "id": 65656,
                        "name": "Burunday",
                        "latitude": "43.35567000",
                        "longitude": "76.85477000"
                    },
                    {
                        "id": 65661,
                        "name": "Chemolgan",
                        "latitude": "43.37633000",
                        "longitude": "76.62456000"
                    },
                    {
                        "id": 65668,
                        "name": "Druzhba",
                        "latitude": "45.25332000",
                        "longitude": "82.48044000"
                    },
                    {
                        "id": 65675,
                        "name": "Esik",
                        "latitude": "43.35520000",
                        "longitude": "77.45245000"
                    },
                    {
                        "id": 65689,
                        "name": "Kapshagay",
                        "latitude": "43.86681000",
                        "longitude": "77.06304000"
                    },
                    {
                        "id": 65694,
                        "name": "Kegen",
                        "latitude": "43.02143000",
                        "longitude": "79.22055000"
                    },
                    {
                        "id": 65715,
                        "name": "Lepsy",
                        "latitude": "46.23500000",
                        "longitude": "78.94556000"
                    },
                    {
                        "id": 65726,
                        "name": "Matay",
                        "latitude": "45.89500000",
                        "longitude": "78.71806000"
                    },
                    {
                        "id": 65742,
                        "name": "Otegen Batyra",
                        "latitude": "43.41949000",
                        "longitude": "77.02020000"
                    },
                    {
                        "id": 65746,
                        "name": "Pervomayka",
                        "latitude": "43.37361000",
                        "longitude": "76.94000000"
                    },
                    {
                        "id": 65763,
                        "name": "Sarkand",
                        "latitude": "45.41126000",
                        "longitude": "79.91545000"
                    },
                    {
                        "id": 65767,
                        "name": "Saryozek",
                        "latitude": "44.36178000",
                        "longitude": "77.97279000"
                    },
                    {
                        "id": 65800,
                        "name": "Taldykorgan",
                        "latitude": "45.01556000",
                        "longitude": "78.37389000"
                    },
                    {
                        "id": 65801,
                        "name": "Talghar",
                        "latitude": "43.30348000",
                        "longitude": "77.24085000"
                    },
                    {
                        "id": 65807,
                        "name": "Tekeli",
                        "latitude": "44.83322000",
                        "longitude": "78.83089000"
                    },
                    {
                        "id": 65818,
                        "name": "Turgen",
                        "latitude": "43.40056000",
                        "longitude": "77.59333000"
                    },
                    {
                        "id": 65852,
                        "name": "Ülken",
                        "latitude": "45.21194000",
                        "longitude": "73.97861000"
                    },
                    {
                        "id": 65823,
                        "name": "Ush-Tyube",
                        "latitude": "45.25201000",
                        "longitude": "77.98007000"
                    },
                    {
                        "id": 65841,
                        "name": "Zharkent",
                        "latitude": "44.16660000",
                        "longitude": "80.00655000"
                    }
                ]
            },
            {
                "id": 152,
                "name": "Almaty",
                "iso2": "ALA",
                "latitude": "43.22201460",
                "longitude": "76.85124850",
                "type": "city",
                "cities": [
                    {
                        "id": 65607,
                        "name": "Almaty",
                        "latitude": "43.25667000",
                        "longitude": "76.92861000"
                    }
                ]
            },
            {
                "id": 156,
                "name": "Astana",
                "iso2": "AST",
                "latitude": "51.16052270",
                "longitude": "71.47035580",
                "type": "city",
                "cities": [
                    {
                        "id": 65737,
                        "name": "Nur-Sultan",
                        "latitude": "51.18010000",
                        "longitude": "71.44598000"
                    }
                ]
            },
            {
                "id": 153,
                "name": "Atyrau",
                "iso2": "ATY",
                "latitude": "47.10761880",
                "longitude": "51.91413300",
                "type": "region",
                "cities": [
                    {
                        "id": 65598,
                        "name": "Akkol’",
                        "latitude": "48.77177000",
                        "longitude": "53.18580000"
                    },
                    {
                        "id": 65625,
                        "name": "Atyrau",
                        "latitude": "47.11667000",
                        "longitude": "51.88333000"
                    },
                    {
                        "id": 65635,
                        "name": "Balykshi",
                        "latitude": "47.06667000",
                        "longitude": "51.86667000"
                    },
                    {
                        "id": 65639,
                        "name": "Bayshonas",
                        "latitude": "47.24139000",
                        "longitude": "52.94111000"
                    },
                    {
                        "id": 65667,
                        "name": "Dossor",
                        "latitude": "47.52722000",
                        "longitude": "52.98111000"
                    },
                    {
                        "id": 65684,
                        "name": "Inderbor",
                        "latitude": "48.55000000",
                        "longitude": "51.78333000"
                    },
                    {
                        "id": 65719,
                        "name": "Makhambet",
                        "latitude": "47.66667000",
                        "longitude": "51.58333000"
                    },
                    {
                        "id": 65722,
                        "name": "Maloye Ganyushkino",
                        "latitude": "46.60000000",
                        "longitude": "49.26667000"
                    },
                    {
                        "id": 65723,
                        "name": "Maqat",
                        "latitude": "47.65000000",
                        "longitude": "53.31667000"
                    },
                    {
                        "id": 65729,
                        "name": "Miyaly",
                        "latitude": "48.88504000",
                        "longitude": "53.79194000"
                    },
                    {
                        "id": 65751,
                        "name": "Qaraton",
                        "latitude": "46.43528000",
                        "longitude": "53.48639000"
                    },
                    {
                        "id": 65759,
                        "name": "Qulsary",
                        "latitude": "46.95307000",
                        "longitude": "54.01978000"
                    },
                    {
                        "id": 65778,
                        "name": "Shalkar",
                        "latitude": "48.03333000",
                        "longitude": "48.90000000"
                    }
                ]
            },
            {
                "id": 155,
                "name": "Baikonur",
                "iso2": "BAY",
                "latitude": "45.96458510",
                "longitude": "63.30524280",
                "type": "region",
                "cities": [
                    {
                        "id": 65630,
                        "name": "Baikonur",
                        "latitude": "45.61667000",
                        "longitude": "63.31667000"
                    }
                ]
            },
            {
                "id": 154,
                "name": "East Kazakhstan",
                "iso2": "VOS",
                "latitude": "48.70626870",
                "longitude": "80.79225340",
                "type": "region",
                "cities": [
                    {
                        "id": 65608,
                        "name": "Altayskiy",
                        "latitude": "50.24593000",
                        "longitude": "82.36252000"
                    },
                    {
                        "id": 65613,
                        "name": "Aqtoghay",
                        "latitude": "46.95000000",
                        "longitude": "79.66667000"
                    },
                    {
                        "id": 65621,
                        "name": "Asūbulaq",
                        "latitude": "49.55688000",
                        "longitude": "83.06355000"
                    },
                    {
                        "id": 65626,
                        "name": "Auezov",
                        "latitude": "49.71003000",
                        "longitude": "81.58018000"
                    },
                    {
                        "id": 65627,
                        "name": "Ayagoz",
                        "latitude": "47.96447000",
                        "longitude": "80.43437000"
                    },
                    {
                        "id": 65643,
                        "name": "Belogorskīy",
                        "latitude": "49.47698000",
                        "longitude": "83.14803000"
                    },
                    {
                        "id": 65645,
                        "name": "Belousovka",
                        "latitude": "50.13287000",
                        "longitude": "82.52481000"
                    },
                    {
                        "id": 65651,
                        "name": "Borodulikha",
                        "latitude": "50.71841000",
                        "longitude": "80.92950000"
                    },
                    {
                        "id": 65681,
                        "name": "Georgīevka",
                        "latitude": "49.32671000",
                        "longitude": "81.57373000"
                    },
                    {
                        "id": 65682,
                        "name": "Glubokoye",
                        "latitude": "50.13887000",
                        "longitude": "82.31114000"
                    },
                    {
                        "id": 65705,
                        "name": "Kurchatov",
                        "latitude": "50.75617000",
                        "longitude": "78.54188000"
                    },
                    {
                        "id": 65706,
                        "name": "Kurchum",
                        "latitude": "48.56603000",
                        "longitude": "83.66146000"
                    },
                    {
                        "id": 65721,
                        "name": "Maleyevsk",
                        "latitude": "49.81441000",
                        "longitude": "84.29102000"
                    },
                    {
                        "id": 65738,
                        "name": "Ognevka",
                        "latitude": "49.68351000",
                        "longitude": "83.01674000"
                    },
                    {
                        "id": 65749,
                        "name": "Priisk Boko",
                        "latitude": "49.06028000",
                        "longitude": "81.64528000"
                    },
                    {
                        "id": 65753,
                        "name": "Qaraūyl",
                        "latitude": "48.94509000",
                        "longitude": "79.25502000"
                    },
                    {
                        "id": 65761,
                        "name": "Ridder",
                        "latitude": "50.34413000",
                        "longitude": "83.51287000"
                    },
                    {
                        "id": 65774,
                        "name": "Semey",
                        "latitude": "50.42675000",
                        "longitude": "80.26669000"
                    },
                    {
                        "id": 65782,
                        "name": "Shar",
                        "latitude": "49.58720000",
                        "longitude": "81.04883000"
                    },
                    {
                        "id": 65785,
                        "name": "Shemonaīkha",
                        "latitude": "50.62811000",
                        "longitude": "81.91213000"
                    },
                    {
                        "id": 65798,
                        "name": "Suykbulak",
                        "latitude": "49.70837000",
                        "longitude": "81.04854000"
                    },
                    {
                        "id": 65821,
                        "name": "Tūghyl",
                        "latitude": "47.72521000",
                        "longitude": "84.20629000"
                    },
                    {
                        "id": 65822,
                        "name": "Urzhar",
                        "latitude": "47.09302000",
                        "longitude": "81.62939000"
                    },
                    {
                        "id": 65824,
                        "name": "Ust-Kamenogorsk",
                        "latitude": "49.97143000",
                        "longitude": "82.60586000"
                    },
                    {
                        "id": 65853,
                        "name": "Ūst’-Talovka",
                        "latitude": "50.54927000",
                        "longitude": "81.84997000"
                    },
                    {
                        "id": 65833,
                        "name": "Zaysan",
                        "latitude": "47.46657000",
                        "longitude": "84.87144000"
                    },
                    {
                        "id": 65835,
                        "name": "Zhalghyztobe",
                        "latitude": "49.21094000",
                        "longitude": "81.21596000"
                    },
                    {
                        "id": 65838,
                        "name": "Zhanga Buqtyrma",
                        "latitude": "49.62950000",
                        "longitude": "83.52475000"
                    },
                    {
                        "id": 65845,
                        "name": "Zhezkent",
                        "latitude": "50.93112000",
                        "longitude": "81.36150000"
                    },
                    {
                        "id": 65850,
                        "name": "Zyryanovsk",
                        "latitude": "49.72654000",
                        "longitude": "84.27318000"
                    }
                ]
            },
            {
                "id": 147,
                "name": "Jambyl",
                "iso2": "ZHA",
                "latitude": "44.22203080",
                "longitude": "72.36579670",
                "type": "region",
                "cities": [
                    {
                        "id": 65610,
                        "name": "Aqbaqay",
                        "latitude": "45.00000000",
                        "longitude": "72.78333000"
                    },
                    {
                        "id": 65663,
                        "name": "Chu",
                        "latitude": "43.60334000",
                        "longitude": "73.75919000"
                    },
                    {
                        "id": 65680,
                        "name": "Georgiyevka",
                        "latitude": "43.03882000",
                        "longitude": "74.71287000"
                    },
                    {
                        "id": 65683,
                        "name": "Granitogorsk",
                        "latitude": "42.74400000",
                        "longitude": "73.46848000"
                    },
                    {
                        "id": 65692,
                        "name": "Karatau",
                        "latitude": "43.17869000",
                        "longitude": "70.46768000"
                    },
                    {
                        "id": 65696,
                        "name": "Khantaū",
                        "latitude": "44.22744000",
                        "longitude": "73.79555000"
                    },
                    {
                        "id": 65717,
                        "name": "Lugovoy",
                        "latitude": "42.94197000",
                        "longitude": "72.76098000"
                    },
                    {
                        "id": 65718,
                        "name": "Lugovoye",
                        "latitude": "42.91010000",
                        "longitude": "72.72066000"
                    },
                    {
                        "id": 65728,
                        "name": "Merke",
                        "latitude": "42.86976000",
                        "longitude": "73.18463000"
                    },
                    {
                        "id": 65730,
                        "name": "Moyynkum",
                        "latitude": "44.28461000",
                        "longitude": "72.93920000"
                    },
                    {
                        "id": 65733,
                        "name": "Mynaral",
                        "latitude": "45.41611000",
                        "longitude": "73.68444000"
                    },
                    {
                        "id": 65743,
                        "name": "Oytal",
                        "latitude": "42.90573000",
                        "longitude": "73.26972000"
                    },
                    {
                        "id": 65766,
                        "name": "Sarykemer",
                        "latitude": "43.00000000",
                        "longitude": "71.50000000"
                    },
                    {
                        "id": 65791,
                        "name": "Shyghanaq",
                        "latitude": "44.83056000",
                        "longitude": "70.00194000"
                    },
                    {
                        "id": 65803,
                        "name": "Taraz",
                        "latitude": "42.90000000",
                        "longitude": "71.36667000"
                    },
                    {
                        "id": 65839,
                        "name": "Zhangatas",
                        "latitude": "43.56222000",
                        "longitude": "69.73428000"
                    }
                ]
            },
            {
                "id": 150,
                "name": "Karaganda",
                "iso2": "KAR",
                "latitude": "47.90221820",
                "longitude": "71.77068070",
                "type": "region",
                "cities": [
                    {
                        "id": 65594,
                        "name": "Abay",
                        "latitude": "49.63575000",
                        "longitude": "72.86164000"
                    },
                    {
                        "id": 65595,
                        "name": "Abay Qalasy",
                        "latitude": "49.63333000",
                        "longitude": "72.88333000"
                    },
                    {
                        "id": 65601,
                        "name": "Aksu-Ayuly",
                        "latitude": "48.76788000",
                        "longitude": "73.67272000"
                    },
                    {
                        "id": 65602,
                        "name": "Aktas",
                        "latitude": "49.77952000",
                        "longitude": "72.96128000"
                    },
                    {
                        "id": 65603,
                        "name": "Aktau",
                        "latitude": "48.03333000",
                        "longitude": "72.83333000"
                    },
                    {
                        "id": 65606,
                        "name": "Aktogay",
                        "latitude": "48.16667000",
                        "longitude": "75.30000000"
                    },
                    {
                        "id": 65609,
                        "name": "Aqadyr",
                        "latitude": "48.26014000",
                        "longitude": "72.85851000"
                    },
                    {
                        "id": 65612,
                        "name": "Aqshataū",
                        "latitude": "47.98917000",
                        "longitude": "74.05750000"
                    },
                    {
                        "id": 65614,
                        "name": "Aqtoghay Aūdany",
                        "latitude": "48.50000000",
                        "longitude": "74.75000000"
                    },
                    {
                        "id": 65623,
                        "name": "Atasū",
                        "latitude": "48.68659000",
                        "longitude": "71.64469000"
                    },
                    {
                        "id": 65634,
                        "name": "Balqash",
                        "latitude": "46.84806000",
                        "longitude": "74.99500000"
                    },
                    {
                        "id": 65653,
                        "name": "Bukhar-Zhyrau",
                        "latitude": "49.85658000",
                        "longitude": "73.68118000"
                    },
                    {
                        "id": 65666,
                        "name": "Dolinka",
                        "latitude": "49.67685000",
                        "longitude": "72.67822000"
                    },
                    {
                        "id": 65690,
                        "name": "Karagandy",
                        "latitude": "49.80187000",
                        "longitude": "73.10211000"
                    },
                    {
                        "id": 65711,
                        "name": "Kīevka",
                        "latitude": "50.26212000",
                        "longitude": "71.54839000"
                    },
                    {
                        "id": 65699,
                        "name": "Koktal",
                        "latitude": "49.65000000",
                        "longitude": "73.51667000"
                    },
                    {
                        "id": 65707,
                        "name": "Kushoky",
                        "latitude": "50.23091000",
                        "longitude": "73.40146000"
                    },
                    {
                        "id": 65709,
                        "name": "Kyzylzhar",
                        "latitude": "49.98197000",
                        "longitude": "72.60761000"
                    },
                    {
                        "id": 65731,
                        "name": "Moyynty",
                        "latitude": "47.22111000",
                        "longitude": "73.36694000"
                    },
                    {
                        "id": 65735,
                        "name": "Novodolinskiy",
                        "latitude": "49.70650000",
                        "longitude": "72.70807000"
                    },
                    {
                        "id": 65741,
                        "name": "Osakarovka",
                        "latitude": "50.56219000",
                        "longitude": "72.57089000"
                    },
                    {
                        "id": 65748,
                        "name": "Prigorodnoye",
                        "latitude": "49.69244000",
                        "longitude": "75.58438000"
                    },
                    {
                        "id": 65750,
                        "name": "Priozersk",
                        "latitude": "46.03106000",
                        "longitude": "73.70247000"
                    },
                    {
                        "id": 65752,
                        "name": "Qarazhal",
                        "latitude": "48.00627000",
                        "longitude": "70.79607000"
                    },
                    {
                        "id": 65754,
                        "name": "Qarqaraly",
                        "latitude": "49.41287000",
                        "longitude": "75.47286000"
                    },
                    {
                        "id": 65768,
                        "name": "Saryshaghan",
                        "latitude": "46.11917000",
                        "longitude": "73.61917000"
                    },
                    {
                        "id": 65770,
                        "name": "Sayaq",
                        "latitude": "47.00000000",
                        "longitude": "77.26667000"
                    },
                    {
                        "id": 65776,
                        "name": "Shakhan",
                        "latitude": "49.81958000",
                        "longitude": "72.65407000"
                    },
                    {
                        "id": 65777,
                        "name": "Shakhtinsk",
                        "latitude": "49.70885000",
                        "longitude": "72.59212000"
                    },
                    {
                        "id": 65783,
                        "name": "Shashūbay",
                        "latitude": "46.81694000",
                        "longitude": "75.04028000"
                    },
                    {
                        "id": 65789,
                        "name": "Shubarköl",
                        "latitude": "48.88222000",
                        "longitude": "68.80722000"
                    },
                    {
                        "id": 65794,
                        "name": "Soran",
                        "latitude": "49.79080000",
                        "longitude": "72.83744000"
                    },
                    {
                        "id": 65810,
                        "name": "Temirtau",
                        "latitude": "50.05494000",
                        "longitude": "72.96464000"
                    },
                    {
                        "id": 65814,
                        "name": "Tokarevka",
                        "latitude": "50.11573000",
                        "longitude": "73.16034000"
                    },
                    {
                        "id": 65825,
                        "name": "Verkhniye Kayrakty",
                        "latitude": "48.68333000",
                        "longitude": "73.28333000"
                    },
                    {
                        "id": 65836,
                        "name": "Zhambyl",
                        "latitude": "47.20694000",
                        "longitude": "71.39694000"
                    },
                    {
                        "id": 65842,
                        "name": "Zharyk",
                        "latitude": "48.85692000",
                        "longitude": "72.83598000"
                    },
                    {
                        "id": 65846,
                        "name": "Zhezqazghan",
                        "latitude": "47.78333000",
                        "longitude": "67.76667000"
                    }
                ]
            },
            {
                "id": 157,
                "name": "Kostanay",
                "iso2": "KUS",
                "latitude": "51.50770960",
                "longitude": "64.04790730",
                "type": "region",
                "cities": [
                    {
                        "id": 65616,
                        "name": "Arkalyk",
                        "latitude": "50.24915000",
                        "longitude": "66.92027000"
                    },
                    {
                        "id": 65628,
                        "name": "Ayat",
                        "latitude": "52.83554000",
                        "longitude": "62.52078000"
                    },
                    {
                        "id": 65652,
                        "name": "Borovskoy",
                        "latitude": "53.79270000",
                        "longitude": "64.18268000"
                    },
                    {
                        "id": 65671,
                        "name": "Dzhetygara",
                        "latitude": "52.19019000",
                        "longitude": "61.19894000"
                    },
                    {
                        "id": 65679,
                        "name": "Fyodorovka",
                        "latitude": "53.63809000",
                        "longitude": "62.69653000"
                    },
                    {
                        "id": 65691,
                        "name": "Karasu",
                        "latitude": "52.65995000",
                        "longitude": "65.48421000"
                    },
                    {
                        "id": 65701,
                        "name": "Komsomolets",
                        "latitude": "53.75019000",
                        "longitude": "62.05840000"
                    },
                    {
                        "id": 65702,
                        "name": "Kostanay",
                        "latitude": "53.21435000",
                        "longitude": "63.62463000"
                    },
                    {
                        "id": 65716,
                        "name": "Lisakovsk",
                        "latitude": "52.54707000",
                        "longitude": "62.49987000"
                    },
                    {
                        "id": 65740,
                        "name": "Ordzhonikidze",
                        "latitude": "52.44772000",
                        "longitude": "61.74942000"
                    },
                    {
                        "id": 65755,
                        "name": "Qashar",
                        "latitude": "53.36799000",
                        "longitude": "62.86839000"
                    },
                    {
                        "id": 65760,
                        "name": "Qusmuryn",
                        "latitude": "52.45107000",
                        "longitude": "64.61977000"
                    },
                    {
                        "id": 65762,
                        "name": "Rudnyy",
                        "latitude": "52.97290000",
                        "longitude": "63.11677000"
                    },
                    {
                        "id": 65813,
                        "name": "Tobol",
                        "latitude": "52.69366000",
                        "longitude": "62.59140000"
                    },
                    {
                        "id": 65815,
                        "name": "Torghay",
                        "latitude": "49.63389000",
                        "longitude": "63.49806000"
                    },
                    {
                        "id": 65816,
                        "name": "Troyebratskiy",
                        "latitude": "54.44306000",
                        "longitude": "66.07982000"
                    }
                ]
            },
            {
                "id": 142,
                "name": "Kyzylorda",
                "iso2": "KZY",
                "latitude": "44.69226130",
                "longitude": "62.65718850",
                "type": "region",
                "cities": [
                    {
                        "id": 65615,
                        "name": "Aral",
                        "latitude": "46.80000000",
                        "longitude": "61.66667000"
                    },
                    {
                        "id": 65629,
                        "name": "Ayteke Bi",
                        "latitude": "45.84607000",
                        "longitude": "62.15264000"
                    },
                    {
                        "id": 65642,
                        "name": "Belköl",
                        "latitude": "44.81162000",
                        "longitude": "65.58796000"
                    },
                    {
                        "id": 65669,
                        "name": "Dzhalagash",
                        "latitude": "45.08333000",
                        "longitude": "64.66667000"
                    },
                    {
                        "id": 65708,
                        "name": "Kyzylorda",
                        "latitude": "44.85278000",
                        "longitude": "65.50917000"
                    },
                    {
                        "id": 65757,
                        "name": "Qazaly",
                        "latitude": "45.76278000",
                        "longitude": "62.10750000"
                    },
                    {
                        "id": 65773,
                        "name": "Sekseūil",
                        "latitude": "47.09000000",
                        "longitude": "61.15194000"
                    },
                    {
                        "id": 65780,
                        "name": "Shalqīya",
                        "latitude": "44.00947000",
                        "longitude": "67.41062000"
                    },
                    {
                        "id": 65792,
                        "name": "Shīeli",
                        "latitude": "44.16882000",
                        "longitude": "66.73887000"
                    },
                    {
                        "id": 65804,
                        "name": "Tasböget",
                        "latitude": "44.77384000",
                        "longitude": "65.55227000"
                    },
                    {
                        "id": 65811,
                        "name": "Terenozek",
                        "latitude": "45.05053000",
                        "longitude": "64.98395000"
                    },
                    {
                        "id": 65827,
                        "name": "Yanykurgan",
                        "latitude": "43.90652000",
                        "longitude": "67.24637000"
                    },
                    {
                        "id": 65848,
                        "name": "Zhosaly",
                        "latitude": "45.48778000",
                        "longitude": "64.07806000"
                    }
                ]
            },
            {
                "id": 141,
                "name": "Mangystau",
                "iso2": "MAN",
                "latitude": "44.59080200",
                "longitude": "53.84995080",
                "type": "region",
                "cities": [
                    {
                        "id": 65604,
                        "name": "Aktau",
                        "latitude": "43.65000000",
                        "longitude": "51.16667000"
                    },
                    {
                        "id": 65641,
                        "name": "Baūtīno",
                        "latitude": "44.54479000",
                        "longitude": "50.24629000"
                    },
                    {
                        "id": 65648,
                        "name": "Beyneu",
                        "latitude": "45.31667000",
                        "longitude": "55.20000000"
                    },
                    {
                        "id": 65678,
                        "name": "Fort-Shevchenko",
                        "latitude": "44.50654000",
                        "longitude": "50.26388000"
                    },
                    {
                        "id": 65732,
                        "name": "Munayshy",
                        "latitude": "43.49111000",
                        "longitude": "52.10861000"
                    },
                    {
                        "id": 65851,
                        "name": "Ömirzaq",
                        "latitude": "43.59786000",
                        "longitude": "51.24171000"
                    },
                    {
                        "id": 65772,
                        "name": "Sayötesh",
                        "latitude": "44.32781000",
                        "longitude": "53.53246000"
                    },
                    {
                        "id": 65786,
                        "name": "Shetpe",
                        "latitude": "44.16667000",
                        "longitude": "52.11667000"
                    },
                    {
                        "id": 65806,
                        "name": "Taūshyq",
                        "latitude": "44.34678000",
                        "longitude": "51.34932000"
                    },
                    {
                        "id": 65829,
                        "name": "Yeraliyev",
                        "latitude": "43.18032000",
                        "longitude": "51.68116000"
                    },
                    {
                        "id": 65837,
                        "name": "Zhanaozen",
                        "latitude": "43.34116000",
                        "longitude": "52.86192000"
                    },
                    {
                        "id": 65844,
                        "name": "Zhetibay",
                        "latitude": "43.59417000",
                        "longitude": "52.07889000"
                    }
                ]
            },
            {
                "id": 144,
                "name": "North Kazakhstan",
                "iso2": "SEV",
                "latitude": "54.16220660",
                "longitude": "69.93870710",
                "type": "region",
                "cities": [
                    {
                        "id": 65649,
                        "name": "Birlestik",
                        "latitude": "53.58414000",
                        "longitude": "68.35382000"
                    },
                    {
                        "id": 65650,
                        "name": "Bishkul",
                        "latitude": "54.77763000",
                        "longitude": "69.09951000"
                    },
                    {
                        "id": 65654,
                        "name": "Bulayevo",
                        "latitude": "54.90596000",
                        "longitude": "70.44155000"
                    },
                    {
                        "id": 65657,
                        "name": "Būrabay",
                        "latitude": "53.08382000",
                        "longitude": "70.31379000"
                    },
                    {
                        "id": 65710,
                        "name": "Kzyltu",
                        "latitude": "53.63589000",
                        "longitude": "72.34079000"
                    },
                    {
                        "id": 65736,
                        "name": "Novoishimskiy",
                        "latitude": "53.19806000",
                        "longitude": "66.76944000"
                    },
                    {
                        "id": 65747,
                        "name": "Petropavl",
                        "latitude": "54.86667000",
                        "longitude": "69.15000000"
                    },
                    {
                        "id": 65775,
                        "name": "Sergeyevka",
                        "latitude": "53.88139000",
                        "longitude": "67.40882000"
                    },
                    {
                        "id": 65793,
                        "name": "Smirnovo",
                        "latitude": "54.51480000",
                        "longitude": "69.42732000"
                    },
                    {
                        "id": 65799,
                        "name": "Taiynsha",
                        "latitude": "53.84796000",
                        "longitude": "69.76773000"
                    },
                    {
                        "id": 65802,
                        "name": "Talshik",
                        "latitude": "53.63736000",
                        "longitude": "71.87404000"
                    },
                    {
                        "id": 65812,
                        "name": "Timiryazevo",
                        "latitude": "53.74947000",
                        "longitude": "66.48852000"
                    },
                    {
                        "id": 65826,
                        "name": "Volodarskoye",
                        "latitude": "53.29270000",
                        "longitude": "68.10500000"
                    },
                    {
                        "id": 65828,
                        "name": "Yavlenka",
                        "latitude": "54.34525000",
                        "longitude": "68.45740000"
                    }
                ]
            },
            {
                "id": 146,
                "name": "Pavlodar",
                "iso2": "PAV",
                "latitude": "52.28784440",
                "longitude": "76.97334530",
                "type": "region",
                "cities": [
                    {
                        "id": 65599,
                        "name": "Aksu",
                        "latitude": "52.04023000",
                        "longitude": "76.92748000"
                    },
                    {
                        "id": 65637,
                        "name": "Bayanaul",
                        "latitude": "50.79304000",
                        "longitude": "75.70123000"
                    },
                    {
                        "id": 65644,
                        "name": "Belogor’ye",
                        "latitude": "51.52983000",
                        "longitude": "77.47146000"
                    },
                    {
                        "id": 65673,
                        "name": "Ekibastuz",
                        "latitude": "51.72371000",
                        "longitude": "75.32287000"
                    },
                    {
                        "id": 65685,
                        "name": "Irtyshsk",
                        "latitude": "53.33365000",
                        "longitude": "75.45775000"
                    },
                    {
                        "id": 65686,
                        "name": "Kalkaman",
                        "latitude": "51.95349000",
                        "longitude": "76.02723000"
                    },
                    {
                        "id": 65713,
                        "name": "Leninskiy",
                        "latitude": "52.25346000",
                        "longitude": "76.78211000"
                    },
                    {
                        "id": 65727,
                        "name": "Mayqayyng",
                        "latitude": "51.45981000",
                        "longitude": "75.80232000"
                    },
                    {
                        "id": 65744,
                        "name": "Pavlodar",
                        "latitude": "52.28333000",
                        "longitude": "76.96667000"
                    },
                    {
                        "id": 65756,
                        "name": "Qashyr",
                        "latitude": "53.06649000",
                        "longitude": "76.10489000"
                    },
                    {
                        "id": 65843,
                        "name": "Zhelezinka",
                        "latitude": "53.53880000",
                        "longitude": "75.31326000"
                    }
                ]
            },
            {
                "id": 149,
                "name": "Turkistan",
                "iso2": "YUZ",
                "latitude": "43.36669580",
                "longitude": "68.40944050",
                "type": "region",
                "cities": [
                    {
                        "id": 65617,
                        "name": "Arys",
                        "latitude": "42.43015000",
                        "longitude": "68.80870000"
                    },
                    {
                        "id": 65618,
                        "name": "Ashchysay",
                        "latitude": "43.55370000",
                        "longitude": "68.89792000"
                    },
                    {
                        "id": 65620,
                        "name": "Asyqata",
                        "latitude": "40.89460000",
                        "longitude": "68.36430000"
                    },
                    {
                        "id": 65622,
                        "name": "Atakent",
                        "latitude": "40.84782000",
                        "longitude": "68.50643000"
                    },
                    {
                        "id": 65640,
                        "name": "Bayzhansay",
                        "latitude": "43.16708000",
                        "longitude": "69.91459000"
                    },
                    {
                        "id": 65646,
                        "name": "Belyye Vody",
                        "latitude": "42.42193000",
                        "longitude": "69.82709000"
                    },
                    {
                        "id": 65659,
                        "name": "Chardara",
                        "latitude": "41.25832000",
                        "longitude": "67.96991000"
                    },
                    {
                        "id": 65660,
                        "name": "Chayan",
                        "latitude": "43.03399000",
                        "longitude": "69.38048000"
                    },
                    {
                        "id": 65664,
                        "name": "Chulakkurgan",
                        "latitude": "43.76453000",
                        "longitude": "69.17856000"
                    },
                    {
                        "id": 65688,
                        "name": "Kantagi",
                        "latitude": "43.52786000",
                        "longitude": "68.58287000"
                    },
                    {
                        "id": 65695,
                        "name": "Kentau",
                        "latitude": "43.51672000",
                        "longitude": "68.50463000"
                    },
                    {
                        "id": 65700,
                        "name": "Kokterek",
                        "latitude": "42.49442000",
                        "longitude": "70.25478000"
                    },
                    {
                        "id": 65712,
                        "name": "Lenger",
                        "latitude": "42.18152000",
                        "longitude": "69.88582000"
                    },
                    {
                        "id": 65714,
                        "name": "Leninskoye",
                        "latitude": "41.75640000",
                        "longitude": "69.38390000"
                    },
                    {
                        "id": 65724,
                        "name": "Maqtaaral Aūdany",
                        "latitude": "40.75000000",
                        "longitude": "68.58333000"
                    },
                    {
                        "id": 65734,
                        "name": "Myrzakent",
                        "latitude": "40.66338000",
                        "longitude": "68.54510000"
                    },
                    {
                        "id": 65758,
                        "name": "Qogham",
                        "latitude": "42.82774000",
                        "longitude": "68.28074000"
                    },
                    {
                        "id": 65764,
                        "name": "Saryaghash",
                        "latitude": "41.46042000",
                        "longitude": "69.16791000"
                    },
                    {
                        "id": 65765,
                        "name": "Saryaghash Aūdany",
                        "latitude": "41.66667000",
                        "longitude": "68.83333000"
                    },
                    {
                        "id": 65769,
                        "name": "Sastobe",
                        "latitude": "42.55330000",
                        "longitude": "69.99835000"
                    },
                    {
                        "id": 65795,
                        "name": "Sozaq Aūdany",
                        "latitude": "44.83333000",
                        "longitude": "68.50000000"
                    },
                    {
                        "id": 65809,
                        "name": "Temirlanovka",
                        "latitude": "42.59998000",
                        "longitude": "69.25836000"
                    },
                    {
                        "id": 65817,
                        "name": "Turar Ryskulov",
                        "latitude": "42.53340000",
                        "longitude": "70.34960000"
                    },
                    {
                        "id": 65819,
                        "name": "Turkestan",
                        "latitude": "43.29733000",
                        "longitude": "68.25175000"
                    },
                    {
                        "id": 65820,
                        "name": "Tyul’kubas",
                        "latitude": "42.48578000",
                        "longitude": "70.29601000"
                    },
                    {
                        "id": 65834,
                        "name": "Zhabagly",
                        "latitude": "42.43781000",
                        "longitude": "70.47841000"
                    }
                ]
            },
            {
                "id": 148,
                "name": "West Kazakhstan",
                "iso2": "ZAP",
                "latitude": "49.56797270",
                "longitude": "50.80666160",
                "type": "region",
                "cities": [
                    {
                        "id": 65611,
                        "name": "Aqsay",
                        "latitude": "51.16810000",
                        "longitude": "52.99782000"
                    },
                    {
                        "id": 65655,
                        "name": "Burlin",
                        "latitude": "51.42724000",
                        "longitude": "52.71392000"
                    },
                    {
                        "id": 65658,
                        "name": "Chapaev",
                        "latitude": "50.20000000",
                        "longitude": "51.16667000"
                    },
                    {
                        "id": 65662,
                        "name": "Chingirlau",
                        "latitude": "51.09878000",
                        "longitude": "54.08426000"
                    },
                    {
                        "id": 65670,
                        "name": "Dzhambeyty",
                        "latitude": "50.25676000",
                        "longitude": "52.59895000"
                    },
                    {
                        "id": 65677,
                        "name": "Fedorovka",
                        "latitude": "51.22102000",
                        "longitude": "51.95723000"
                    },
                    {
                        "id": 65693,
                        "name": "Kaztalovka",
                        "latitude": "49.76612000",
                        "longitude": "48.68903000"
                    },
                    {
                        "id": 65704,
                        "name": "Krūgloozernoe",
                        "latitude": "51.07854000",
                        "longitude": "51.28992000"
                    },
                    {
                        "id": 65739,
                        "name": "Oral",
                        "latitude": "51.23333000",
                        "longitude": "51.36667000"
                    },
                    {
                        "id": 65745,
                        "name": "Peremetnoe",
                        "latitude": "51.19925000",
                        "longitude": "50.85544000"
                    },
                    {
                        "id": 65771,
                        "name": "Saykhin",
                        "latitude": "48.85611000",
                        "longitude": "46.83361000"
                    },
                    {
                        "id": 65805,
                        "name": "Tasqala",
                        "latitude": "51.11073000",
                        "longitude": "50.29454000"
                    },
                    {
                        "id": 65849,
                        "name": "Zhänibek",
                        "latitude": "49.42207000",
                        "longitude": "46.84705000"
                    }
                ]
            }
        ]
    },
    {
        "id": 113,
        "name": "Kenya",
        "iso3": "KEN",
        "iso2": "KE",
        "numeric_code": "404",
        "phonecode": "254",
        "capital": "Nairobi",
        "currency": "KES",
        "currency_name": "Kenyan shilling",
        "currency_symbol": "KSh",
        "tld": ".ke",
        "native": "Kenya",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Kenyan",
        "timezones": [
            {
                "zoneName": "Africa\/Nairobi",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Kenya",
            "ko": "케냐",
            "pt-BR": "Quênia",
            "pt": "Quénia",
            "nl": "Kenia",
            "hr": "Kenija",
            "fa": "کنیا",
            "de": "Kenia",
            "es": "Kenia",
            "fr": "Kenya",
            "ja": "ケニア",
            "it": "Kenya",
            "zh-CN": "肯尼亚",
            "tr": "Kenya",
            "ru": "Кения",
            "uk": "Кенія",
            "pl": "Kenia"
        },
        "latitude": "1.00000000",
        "longitude": "38.00000000",
        "emoji": "🇰🇪",
        "emojiU": "U+1F1F0 U+1F1EA",
        "states": [
            {
                "id": 181,
                "name": "Baringo",
                "iso2": "01",
                "latitude": "0.85549880",
                "longitude": "36.08934060",
                "type": "county",
                "cities": [
                    {
                        "id": 64774,
                        "name": "Baringo",
                        "latitude": "0.46667000",
                        "longitude": "35.96667000"
                    },
                    {
                        "id": 64781,
                        "name": "Eldama Ravine",
                        "latitude": "0.05196000",
                        "longitude": "35.72734000"
                    },
                    {
                        "id": 64790,
                        "name": "Kabarnet",
                        "latitude": "0.49194000",
                        "longitude": "35.74303000"
                    }
                ]
            },
            {
                "id": 210,
                "name": "Bomet",
                "iso2": "02",
                "latitude": "-0.80150090",
                "longitude": "35.30272260",
                "type": "county",
                "cities": [
                    {
                        "id": 64870,
                        "name": "Sotik",
                        "latitude": "-0.69069000",
                        "longitude": "35.11102000"
                    },
                    {
                        "id": 64871,
                        "name": "Sotik Post",
                        "latitude": "-0.78129000",
                        "longitude": "35.34156000"
                    }
                ]
            },
            {
                "id": 168,
                "name": "Bungoma",
                "iso2": "03",
                "latitude": "0.56952520",
                "longitude": "34.55837660",
                "type": "county",
                "cities": [
                    {
                        "id": 64776,
                        "name": "Bungoma",
                        "latitude": "0.56350000",
                        "longitude": "34.56055000"
                    },
                    {
                        "id": 64827,
                        "name": "Malikisi",
                        "latitude": "0.67694000",
                        "longitude": "34.42167000"
                    },
                    {
                        "id": 64877,
                        "name": "Webuye",
                        "latitude": "0.60040000",
                        "longitude": "34.77119000"
                    }
                ]
            },
            {
                "id": 161,
                "name": "Busia",
                "iso2": "04",
                "latitude": "0.43465060",
                "longitude": "34.24215970",
                "type": "county",
                "cities": [
                    {
                        "id": 64777,
                        "name": "Busia",
                        "latitude": "0.46005000",
                        "longitude": "34.11169000"
                    },
                    {
                        "id": 64821,
                        "name": "Luanda",
                        "latitude": "0.31354000",
                        "longitude": "34.07146000"
                    },
                    {
                        "id": 64822,
                        "name": "Lugulu",
                        "latitude": "0.39337000",
                        "longitude": "34.30399000"
                    },
                    {
                        "id": 64826,
                        "name": "Malaba",
                        "latitude": "0.63513000",
                        "longitude": "34.28165000"
                    },
                    {
                        "id": 64848,
                        "name": "Nambare",
                        "latitude": "0.45813000",
                        "longitude": "34.25353000"
                    },
                    {
                        "id": 64861,
                        "name": "Port Victoria",
                        "latitude": "0.09809000",
                        "longitude": "33.97248000"
                    }
                ]
            },
            {
                "id": 201,
                "name": "Elgeyo-Marakwet",
                "iso2": "05",
                "latitude": "1.04982370",
                "longitude": "35.47819260",
                "type": "county",
                "cities": [
                    {
                        "id": 154645,
                        "name": "Chebiemit",
                        "latitude": "1.05000000",
                        "longitude": "35.40000000"
                    },
                    {
                        "id": 154648,
                        "name": "Chepkorio",
                        "latitude": "0.38330000",
                        "longitude": "35.45000000"
                    },
                    {
                        "id": 154649,
                        "name": "Chesoi",
                        "latitude": "1.15000000",
                        "longitude": "35.65000000"
                    },
                    {
                        "id": 154650,
                        "name": "Chesongoch",
                        "latitude": "1.08330000",
                        "longitude": "35.65000000"
                    },
                    {
                        "id": 154656,
                        "name": "Flax",
                        "latitude": "0.45000000",
                        "longitude": "35.40000000"
                    },
                    {
                        "id": 154642,
                        "name": "Iten",
                        "latitude": "0.67080000",
                        "longitude": "35.50830000"
                    },
                    {
                        "id": 154646,
                        "name": "Kapcherop",
                        "latitude": "1.23330000",
                        "longitude": "35.38330000"
                    },
                    {
                        "id": 154651,
                        "name": "Kapsait",
                        "latitude": "1.21670000",
                        "longitude": "35.30000000"
                    },
                    {
                        "id": 154643,
                        "name": "Kapsowar",
                        "latitude": "1.01500000",
                        "longitude": "35.52250000"
                    },
                    {
                        "id": 154652,
                        "name": "Kaptalamwa",
                        "latitude": "1.20000000",
                        "longitude": "35.45000000"
                    },
                    {
                        "id": 154647,
                        "name": "Kaptarakwa",
                        "latitude": "0.43330000",
                        "longitude": "35.58330000"
                    },
                    {
                        "id": 154653,
                        "name": "Kapyego",
                        "latitude": "1.23330000",
                        "longitude": "35.66670000"
                    },
                    {
                        "id": 154654,
                        "name": "Kipmwarer",
                        "latitude": "0.91670000",
                        "longitude": "35.53330000"
                    },
                    {
                        "id": 154655,
                        "name": "Kocholwo",
                        "latitude": "0.41670000",
                        "longitude": "35.56670000"
                    },
                    {
                        "id": 154644,
                        "name": "Tambach",
                        "latitude": "0.73330000",
                        "longitude": "35.58330000"
                    }
                ]
            },
            {
                "id": 163,
                "name": "Embu",
                "iso2": "06",
                "latitude": "-0.65604770",
                "longitude": "37.72376780",
                "type": "county",
                "cities": [
                    {
                        "id": 64783,
                        "name": "Embu",
                        "latitude": "-0.53987000",
                        "longitude": "37.45743000"
                    }
                ]
            },
            {
                "id": 196,
                "name": "Garissa",
                "iso2": "07",
                "latitude": "-0.45322930",
                "longitude": "39.64609880",
                "type": "county",
                "cities": [
                    {
                        "id": 64784,
                        "name": "Garissa",
                        "latitude": "-0.45275000",
                        "longitude": "39.64601000"
                    }
                ]
            },
            {
                "id": 195,
                "name": "Homa Bay",
                "iso2": "08",
                "latitude": "-0.62206550",
                "longitude": "34.33103640",
                "type": "county",
                "cities": [
                    {
                        "id": 64787,
                        "name": "Homa Bay",
                        "latitude": "-0.52731000",
                        "longitude": "34.45714000"
                    },
                    {
                        "id": 64860,
                        "name": "Oyugis",
                        "latitude": "-0.50974000",
                        "longitude": "34.73067000"
                    },
                    {
                        "id": 64863,
                        "name": "Rachuonyo District",
                        "latitude": "-0.44000000",
                        "longitude": "34.73900000"
                    }
                ]
            },
            {
                "id": 170,
                "name": "Isiolo",
                "iso2": "09",
                "latitude": "0.35243520",
                "longitude": "38.48499230",
                "type": "county",
                "cities": [
                    {
                        "id": 64788,
                        "name": "Isiolo",
                        "latitude": "0.35462000",
                        "longitude": "37.58218000"
                    }
                ]
            },
            {
                "id": 197,
                "name": "Kajiado",
                "iso2": "10",
                "latitude": "-2.09807510",
                "longitude": "36.78195050",
                "type": "county",
                "cities": [
                    {
                        "id": 64791,
                        "name": "Kajiado",
                        "latitude": "-1.85238000",
                        "longitude": "36.77683000"
                    },
                    {
                        "id": 64824,
                        "name": "Magadi",
                        "latitude": "-1.90122000",
                        "longitude": "36.28700000"
                    },
                    {
                        "id": 64853,
                        "name": "Ngong",
                        "latitude": "-1.35270000",
                        "longitude": "36.66990000"
                    }
                ]
            },
            {
                "id": 158,
                "name": "Kakamega",
                "iso2": "11",
                "latitude": "0.30789400",
                "longitude": "34.77407930",
                "type": "county",
                "cities": [
                    {
                        "id": 64778,
                        "name": "Butere",
                        "latitude": "0.20694000",
                        "longitude": "34.49006000"
                    },
                    {
                        "id": 64792,
                        "name": "Kakamega",
                        "latitude": "0.28422000",
                        "longitude": "34.75229000"
                    },
                    {
                        "id": 64842,
                        "name": "Mumias",
                        "latitude": "0.33474000",
                        "longitude": "34.48796000"
                    }
                ]
            },
            {
                "id": 193,
                "name": "Kericho",
                "iso2": "12",
                "latitude": "-0.18279130",
                "longitude": "35.47819260",
                "type": "county",
                "cities": [
                    {
                        "id": 64799,
                        "name": "Kericho",
                        "latitude": "-0.36774000",
                        "longitude": "35.28314000"
                    },
                    {
                        "id": 64809,
                        "name": "Kipkelion",
                        "latitude": "-0.19982000",
                        "longitude": "35.46735000"
                    },
                    {
                        "id": 64818,
                        "name": "Litein",
                        "latitude": "-0.58249000",
                        "longitude": "35.18969000"
                    },
                    {
                        "id": 64820,
                        "name": "Londiani",
                        "latitude": "-0.16552000",
                        "longitude": "35.59359000"
                    }
                ]
            },
            {
                "id": 199,
                "name": "Kiambu",
                "iso2": "13",
                "latitude": "-1.03137010",
                "longitude": "36.86807910",
                "type": "county",
                "cities": [
                    {
                        "id": 64802,
                        "name": "Kiambu",
                        "latitude": "-1.17139000",
                        "longitude": "36.83556000"
                    },
                    {
                        "id": 64805,
                        "name": "Kikuyu",
                        "latitude": "-1.24627000",
                        "longitude": "36.66291000"
                    },
                    {
                        "id": 64817,
                        "name": "Limuru",
                        "latitude": "-1.11360000",
                        "longitude": "36.64205000"
                    },
                    {
                        "id": 64874,
                        "name": "Thika",
                        "latitude": "-1.03326000",
                        "longitude": "37.06933000"
                    }
                ]
            },
            {
                "id": 174,
                "name": "Kilifi",
                "iso2": "14",
                "latitude": "-3.51065080",
                "longitude": "39.90932690",
                "type": "county",
                "cities": [
                    {
                        "id": 64789,
                        "name": "Iten",
                        "latitude": "0.67028000",
                        "longitude": "35.50806000"
                    },
                    {
                        "id": 64797,
                        "name": "Kapsowar",
                        "latitude": "0.97890000",
                        "longitude": "35.55854000"
                    },
                    {
                        "id": 64806,
                        "name": "Kilifi",
                        "latitude": "-3.63045000",
                        "longitude": "39.84992000"
                    },
                    {
                        "id": 64828,
                        "name": "Malindi",
                        "latitude": "-3.21799000",
                        "longitude": "40.11692000"
                    },
                    {
                        "id": 64832,
                        "name": "Mariakani",
                        "latitude": "-3.86261000",
                        "longitude": "39.47458000"
                    },
                    {
                        "id": 64872,
                        "name": "Takaungu",
                        "latitude": "-3.68350000",
                        "longitude": "39.85687000"
                    }
                ]
            },
            {
                "id": 167,
                "name": "Kirinyaga",
                "iso2": "15",
                "latitude": "-0.65905650",
                "longitude": "37.38272340",
                "type": "county",
                "cities": [
                    {
                        "id": 64801,
                        "name": "Kerugoya",
                        "latitude": "-0.49887000",
                        "longitude": "37.28031000"
                    },
                    {
                        "id": 64866,
                        "name": "Sagana",
                        "latitude": "-0.66806000",
                        "longitude": "37.20875000"
                    }
                ]
            },
            {
                "id": 159,
                "name": "Kisii",
                "iso2": "16",
                "latitude": "-0.67733400",
                "longitude": "34.77960300",
                "type": "county",
                "cities": [
                    {
                        "id": 64810,
                        "name": "Kisii",
                        "latitude": "-0.68174000",
                        "longitude": "34.76666000"
                    },
                    {
                        "id": 64857,
                        "name": "Ogembo",
                        "latitude": "-0.80116000",
                        "longitude": "34.72579000"
                    }
                ]
            },
            {
                "id": 171,
                "name": "Kisumu",
                "iso2": "17",
                "latitude": "-0.09170160",
                "longitude": "34.76795680",
                "type": "county",
                "cities": [
                    {
                        "id": 64772,
                        "name": "Ahero",
                        "latitude": "-0.17359000",
                        "longitude": "34.91890000"
                    },
                    {
                        "id": 64811,
                        "name": "Kisumu",
                        "latitude": "-0.10221000",
                        "longitude": "34.76171000"
                    },
                    {
                        "id": 64841,
                        "name": "Muhoroni",
                        "latitude": "-0.15816000",
                        "longitude": "35.19645000"
                    }
                ]
            },
            {
                "id": 211,
                "name": "Kitui",
                "iso2": "18",
                "latitude": "-1.68328220",
                "longitude": "38.31657250",
                "type": "county",
                "cities": [
                    {
                        "id": 64813,
                        "name": "Kitui",
                        "latitude": "-1.36696000",
                        "longitude": "38.01055000"
                    },
                    {
                        "id": 64844,
                        "name": "Mwingi",
                        "latitude": "-0.93605000",
                        "longitude": "38.05955000"
                    }
                ]
            },
            {
                "id": 173,
                "name": "Kwale",
                "iso2": "19",
                "latitude": "-4.18161150",
                "longitude": "39.46056120",
                "type": "county",
                "cities": [
                    {
                        "id": 64785,
                        "name": "Gazi",
                        "latitude": "-4.42402000",
                        "longitude": "39.50588000"
                    },
                    {
                        "id": 64807,
                        "name": "Kinango",
                        "latitude": "-4.13723000",
                        "longitude": "39.31528000"
                    },
                    {
                        "id": 64815,
                        "name": "Kwale",
                        "latitude": "-4.17375000",
                        "longitude": "39.45206000"
                    },
                    {
                        "id": 64867,
                        "name": "Sawa Sawa",
                        "latitude": "-4.47166000",
                        "longitude": "39.48463000"
                    },
                    {
                        "id": 64868,
                        "name": "Shimoni",
                        "latitude": "-4.64756000",
                        "longitude": "39.38175000"
                    }
                ]
            },
            {
                "id": 164,
                "name": "Laikipia",
                "iso2": "20",
                "latitude": "0.36060630",
                "longitude": "36.78195050",
                "type": "county",
                "cities": [
                    {
                        "id": 64850,
                        "name": "Nanyuki",
                        "latitude": "0.00624000",
                        "longitude": "37.07398000"
                    },
                    {
                        "id": 64854,
                        "name": "Nyahururu",
                        "latitude": "0.03813000",
                        "longitude": "36.36339000"
                    },
                    {
                        "id": 64865,
                        "name": "Rumuruti",
                        "latitude": "0.27250000",
                        "longitude": "36.53806000"
                    }
                ]
            },
            {
                "id": 166,
                "name": "Lamu",
                "iso2": "21",
                "latitude": "-2.23550580",
                "longitude": "40.47200040",
                "type": "county",
                "cities": [
                    {
                        "id": 64816,
                        "name": "Lamu",
                        "latitude": "-2.27169000",
                        "longitude": "40.90201000"
                    },
                    {
                        "id": 64878,
                        "name": "Witu",
                        "latitude": "-2.38892000",
                        "longitude": "40.43827000"
                    }
                ]
            },
            {
                "id": 184,
                "name": "Machakos",
                "iso2": "22",
                "latitude": "-1.51768370",
                "longitude": "37.26341460",
                "type": "county",
                "cities": [
                    {
                        "id": 64773,
                        "name": "Athi River",
                        "latitude": "-1.45630000",
                        "longitude": "36.97826000"
                    },
                    {
                        "id": 64794,
                        "name": "Kangundo",
                        "latitude": "-1.30342000",
                        "longitude": "37.34813000"
                    },
                    {
                        "id": 64814,
                        "name": "Konza",
                        "latitude": "-1.73947000",
                        "longitude": "37.13195000"
                    },
                    {
                        "id": 64823,
                        "name": "Machakos",
                        "latitude": "-1.52233000",
                        "longitude": "37.26521000"
                    }
                ]
            },
            {
                "id": 188,
                "name": "Makueni",
                "iso2": "23",
                "latitude": "-2.25587340",
                "longitude": "37.89366630",
                "type": "county",
                "cities": [
                    {
                        "id": 64825,
                        "name": "Makueni Boma",
                        "latitude": "-1.80388000",
                        "longitude": "37.62405000"
                    },
                    {
                        "id": 64840,
                        "name": "Mtito Andei",
                        "latitude": "-2.68987000",
                        "longitude": "38.16687000"
                    },
                    {
                        "id": 64879,
                        "name": "Wote",
                        "latitude": "-1.78079000",
                        "longitude": "37.62882000"
                    }
                ]
            },
            {
                "id": 187,
                "name": "Mandera",
                "iso2": "24",
                "latitude": "3.57379910",
                "longitude": "40.95868800",
                "type": "county",
                "cities": [
                    {
                        "id": 64829,
                        "name": "Mandera",
                        "latitude": "3.93726000",
                        "longitude": "41.85688000"
                    }
                ]
            },
            {
                "id": 194,
                "name": "Marsabit",
                "iso2": "25",
                "latitude": "2.44264030",
                "longitude": "37.97845850",
                "type": "county",
                "cities": [
                    {
                        "id": 64833,
                        "name": "Marsabit",
                        "latitude": "2.33468000",
                        "longitude": "37.99086000"
                    },
                    {
                        "id": 64839,
                        "name": "Moyale",
                        "latitude": "3.52661000",
                        "longitude": "39.05610000"
                    }
                ]
            },
            {
                "id": 198,
                "name": "Meru",
                "iso2": "26",
                "latitude": "0.35571740",
                "longitude": "37.80876930",
                "type": "county",
                "cities": [
                    {
                        "id": 64834,
                        "name": "Maua",
                        "latitude": "0.23320000",
                        "longitude": "37.94086000"
                    },
                    {
                        "id": 64835,
                        "name": "Meru",
                        "latitude": "0.04626000",
                        "longitude": "37.65587000"
                    }
                ]
            },
            {
                "id": 190,
                "name": "Migori",
                "iso2": "27",
                "latitude": "-0.93657020",
                "longitude": "34.41982430",
                "type": "county",
                "cities": [
                    {
                        "id": 64803,
                        "name": "Kihancha",
                        "latitude": "-1.19347000",
                        "longitude": "34.61967000"
                    },
                    {
                        "id": 64836,
                        "name": "Migori",
                        "latitude": "-1.06343000",
                        "longitude": "34.47313000"
                    }
                ]
            },
            {
                "id": 200,
                "name": "Mombasa",
                "iso2": "28",
                "latitude": "-3.97682910",
                "longitude": "39.71371810",
                "type": "county",
                "cities": [
                    {
                        "id": 64838,
                        "name": "Mombasa",
                        "latitude": "-4.05466000",
                        "longitude": "39.66359000"
                    }
                ]
            },
            {
                "id": 178,
                "name": "Murang'a",
                "iso2": "29",
                "latitude": "-0.78392810",
                "longitude": "37.04003390",
                "type": "county",
                "cities": [
                    {
                        "id": 64793,
                        "name": "Kangema",
                        "latitude": "-0.68553000",
                        "longitude": "36.96463000"
                    },
                    {
                        "id": 64798,
                        "name": "Karuri",
                        "latitude": "-0.70000000",
                        "longitude": "37.18333000"
                    },
                    {
                        "id": 64830,
                        "name": "Maragua",
                        "latitude": "-0.79602000",
                        "longitude": "37.13292000"
                    },
                    {
                        "id": 64843,
                        "name": "Murang’a",
                        "latitude": "-0.72104000",
                        "longitude": "37.15259000"
                    }
                ]
            },
            {
                "id": 191,
                "name": "Nairobi City",
                "iso2": "30",
                "latitude": "-1.29206590",
                "longitude": "36.82194620",
                "type": "county",
                "cities": [
                    {
                        "id": 64845,
                        "name": "Nairobi",
                        "latitude": "-1.28333000",
                        "longitude": "36.81667000"
                    },
                    {
                        "id": 64862,
                        "name": "Pumwani",
                        "latitude": "-1.28333000",
                        "longitude": "36.85000000"
                    }
                ]
            },
            {
                "id": 203,
                "name": "Nakuru",
                "iso2": "31",
                "latitude": "-0.30309880",
                "longitude": "36.08002600",
                "type": "county",
                "cities": [
                    {
                        "id": 64804,
                        "name": "Kijabe",
                        "latitude": "-0.93334000",
                        "longitude": "36.57233000"
                    },
                    {
                        "id": 64837,
                        "name": "Molo",
                        "latitude": "-0.24849000",
                        "longitude": "35.73194000"
                    },
                    {
                        "id": 64846,
                        "name": "Naivasha",
                        "latitude": "-0.71383000",
                        "longitude": "36.43261000"
                    },
                    {
                        "id": 64847,
                        "name": "Nakuru",
                        "latitude": "-0.30719000",
                        "longitude": "36.07225000"
                    },
                    {
                        "id": 64864,
                        "name": "Rongai",
                        "latitude": "-0.17344000",
                        "longitude": "35.86313000"
                    }
                ]
            },
            {
                "id": 165,
                "name": "Nandi",
                "iso2": "32",
                "latitude": "0.18358670",
                "longitude": "35.12687810",
                "type": "county",
                "cities": [
                    {
                        "id": 64796,
                        "name": "Kapsabet",
                        "latitude": "0.20387000",
                        "longitude": "35.10500000"
                    },
                    {
                        "id": 64849,
                        "name": "Nandi Hills",
                        "latitude": "0.10366000",
                        "longitude": "35.18426000"
                    }
                ]
            },
            {
                "id": 175,
                "name": "Narok",
                "iso2": "33",
                "latitude": "-1.10411100",
                "longitude": "36.08934060",
                "type": "county",
                "cities": [
                    {
                        "id": 64852,
                        "name": "Narok",
                        "latitude": "-1.08083000",
                        "longitude": "35.87111000"
                    }
                ]
            },
            {
                "id": 209,
                "name": "Nyamira",
                "iso2": "34",
                "latitude": "-0.56694050",
                "longitude": "34.93412340",
                "type": "county",
                "cities": [
                    {
                        "id": 64800,
                        "name": "Keroka",
                        "latitude": "-0.77612000",
                        "longitude": "34.94678000"
                    },
                    {
                        "id": 64855,
                        "name": "Nyamira",
                        "latitude": "-0.56333000",
                        "longitude": "34.93583000"
                    }
                ]
            },
            {
                "id": 192,
                "name": "Nyandarua",
                "iso2": "35",
                "latitude": "-0.18038550",
                "longitude": "36.52296410",
                "type": "county",
                "cities": [
                    {
                        "id": 64858,
                        "name": "Ol Kalou",
                        "latitude": "-0.27088000",
                        "longitude": "36.37917000"
                    }
                ]
            },
            {
                "id": 180,
                "name": "Nyeri",
                "iso2": "36",
                "latitude": "-0.41969150",
                "longitude": "37.04003390",
                "type": "county",
                "cities": [
                    {
                        "id": 64851,
                        "name": "Naro Moru",
                        "latitude": "-0.16357000",
                        "longitude": "37.01773000"
                    },
                    {
                        "id": 64856,
                        "name": "Nyeri",
                        "latitude": "-0.42013000",
                        "longitude": "36.94759000"
                    },
                    {
                        "id": 64859,
                        "name": "Othaya",
                        "latitude": "-0.54655000",
                        "longitude": "36.93178000"
                    }
                ]
            },
            {
                "id": 207,
                "name": "Samburu",
                "iso2": "37",
                "latitude": "1.21545060",
                "longitude": "36.95410700",
                "type": "county",
                "cities": [
                    {
                        "id": 64831,
                        "name": "Maralal",
                        "latitude": "1.09667000",
                        "longitude": "36.69806000"
                    }
                ]
            },
            {
                "id": 186,
                "name": "Siaya",
                "iso2": "38",
                "latitude": "-0.06173280",
                "longitude": "34.24215970",
                "type": "county",
                "cities": [
                    {
                        "id": 64775,
                        "name": "Bondo",
                        "latitude": "0.23522000",
                        "longitude": "34.28086000"
                    },
                    {
                        "id": 64869,
                        "name": "Siaya",
                        "latitude": "0.06070000",
                        "longitude": "34.28806000"
                    },
                    {
                        "id": 64881,
                        "name": "Yala",
                        "latitude": "0.09438000",
                        "longitude": "34.53602000"
                    }
                ]
            },
            {
                "id": 176,
                "name": "Taita–Taveta",
                "iso2": "39",
                "latitude": "-3.31606870",
                "longitude": "38.48499230",
                "type": "county",
                "cities": [
                    {
                        "id": 154626,
                        "name": "Bura",
                        "latitude": "-3.50000000",
                        "longitude": "38.30000000"
                    },
                    {
                        "id": 154631,
                        "name": "Chala",
                        "latitude": "-3.38330000",
                        "longitude": "37.68330000"
                    },
                    {
                        "id": 154627,
                        "name": "Maktau",
                        "latitude": "-3.40000000",
                        "longitude": "38.13330000"
                    },
                    {
                        "id": 154588,
                        "name": "Mgange",
                        "latitude": "-3.40000000",
                        "longitude": "38.31670000"
                    },
                    {
                        "id": 154589,
                        "name": "Mwanda",
                        "latitude": "-3.40000000",
                        "longitude": "38.28330000"
                    },
                    {
                        "id": 154583,
                        "name": "Mwatate",
                        "latitude": "-3.50330000",
                        "longitude": "38.38120000"
                    },
                    {
                        "id": 154582,
                        "name": "Taveta",
                        "latitude": "-3.39880000",
                        "longitude": "37.68340000"
                    },
                    {
                        "id": 154622,
                        "name": "Voi",
                        "latitude": "-3.39610000",
                        "longitude": "38.55630000"
                    },
                    {
                        "id": 154628,
                        "name": "Wesu",
                        "latitude": "-3.40000000",
                        "longitude": "38.35000000"
                    },
                    {
                        "id": 154625,
                        "name": "Wundanyi",
                        "latitude": "-3.40850000",
                        "longitude": "38.36510000"
                    }
                ]
            },
            {
                "id": 205,
                "name": "Tana River",
                "iso2": "40",
                "latitude": "-1.65184680",
                "longitude": "39.65181650",
                "type": "county",
                "cities": [
                    {
                        "id": 64786,
                        "name": "Hola",
                        "latitude": "-1.48256000",
                        "longitude": "40.03341000"
                    },
                    {
                        "id": 64808,
                        "name": "Kipini",
                        "latitude": "-2.52565000",
                        "longitude": "40.52620000"
                    }
                ]
            },
            {
                "id": 185,
                "name": "Tharaka-Nithi",
                "iso2": "41",
                "latitude": "-0.29648510",
                "longitude": "37.72376780",
                "type": "county",
                "cities": [
                    {
                        "id": 64780,
                        "name": "Chuka",
                        "latitude": "-0.33316000",
                        "longitude": "37.64587000"
                    }
                ]
            },
            {
                "id": 183,
                "name": "Trans Nzoia",
                "iso2": "42",
                "latitude": "1.05666670",
                "longitude": "34.95066250",
                "type": "county",
                "cities": [
                    {
                        "id": 64812,
                        "name": "Kitale",
                        "latitude": "1.01572000",
                        "longitude": "35.00622000"
                    }
                ]
            },
            {
                "id": 206,
                "name": "Turkana",
                "iso2": "43",
                "latitude": "3.31224770",
                "longitude": "35.56578620",
                "type": "county",
                "cities": [
                    {
                        "id": 64819,
                        "name": "Lodwar",
                        "latitude": "3.11988000",
                        "longitude": "35.59642000"
                    }
                ]
            },
            {
                "id": 169,
                "name": "Uasin Gishu",
                "iso2": "44",
                "latitude": "0.55276380",
                "longitude": "35.30272260",
                "type": "county",
                "cities": [
                    {
                        "id": 64782,
                        "name": "Eldoret",
                        "latitude": "0.52036000",
                        "longitude": "35.26993000"
                    }
                ]
            },
            {
                "id": 202,
                "name": "Vihiga",
                "iso2": "45",
                "latitude": "0.07675530",
                "longitude": "34.70776650",
                "type": "county",
                "cities": [
                    {
                        "id": 154634,
                        "name": "Chavakali",
                        "latitude": "0.11670000",
                        "longitude": "34.70000000"
                    },
                    {
                        "id": 154641,
                        "name": "Esabalu",
                        "latitude": "0.01670000",
                        "longitude": "34.61670000"
                    },
                    {
                        "id": 154640,
                        "name": "Gambogi",
                        "latitude": "0.08330000",
                        "longitude": "34.80000000"
                    },
                    {
                        "id": 154639,
                        "name": "Kilingili",
                        "latitude": "0.08330000",
                        "longitude": "34.66670000"
                    },
                    {
                        "id": 154633,
                        "name": "Luanda",
                        "latitude": "0.00430000",
                        "longitude": "34.59700000"
                    },
                    {
                        "id": 154635,
                        "name": "Majengo",
                        "latitude": "0.10000000",
                        "longitude": "34.61670000"
                    },
                    {
                        "id": 154636,
                        "name": "Maseno",
                        "latitude": "0.00000000",
                        "longitude": "34.60000000"
                    },
                    {
                        "id": 154632,
                        "name": "Mbale",
                        "latitude": "0.07080000",
                        "longitude": "34.72420000"
                    },
                    {
                        "id": 154637,
                        "name": "Mudete",
                        "latitude": "0.13330000",
                        "longitude": "34.75000000"
                    },
                    {
                        "id": 154638,
                        "name": "Serem",
                        "latitude": "0.08330000",
                        "longitude": "34.88330000"
                    }
                ]
            },
            {
                "id": 182,
                "name": "Wajir",
                "iso2": "46",
                "latitude": "1.63604750",
                "longitude": "40.30886260",
                "type": "county",
                "cities": [
                    {
                        "id": 64876,
                        "name": "Wajir",
                        "latitude": "1.74710000",
                        "longitude": "40.05732000"
                    }
                ]
            },
            {
                "id": 208,
                "name": "West Pokot",
                "iso2": "47",
                "latitude": "1.62100760",
                "longitude": "35.39050460",
                "type": "county",
                "cities": [
                    {
                        "id": 64779,
                        "name": "Chepareria",
                        "latitude": "1.30583000",
                        "longitude": "35.20365000"
                    },
                    {
                        "id": 64795,
                        "name": "Kapenguria",
                        "latitude": "1.23889000",
                        "longitude": "35.11194000"
                    },
                    {
                        "id": 64873,
                        "name": "Taveta",
                        "latitude": "-3.39879000",
                        "longitude": "37.68336000"
                    },
                    {
                        "id": 64875,
                        "name": "Voi",
                        "latitude": "-3.39605000",
                        "longitude": "38.55609000"
                    },
                    {
                        "id": 64880,
                        "name": "Wundanyi",
                        "latitude": "-3.39642000",
                        "longitude": "38.35729000"
                    }
                ]
            }
        ]
    },
    {
        "id": 114,
        "name": "Kiribati",
        "iso3": "KIR",
        "iso2": "KI",
        "numeric_code": "296",
        "phonecode": "686",
        "capital": "Tarawa",
        "currency": "AUD",
        "currency_name": "Australian dollar",
        "currency_symbol": "$",
        "tld": ".ki",
        "native": "Kiribati",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Micronesia",
        "subregion_id": 21,
        "nationality": "I-Kiribati",
        "timezones": [
            {
                "zoneName": "Pacific\/Enderbury",
                "gmtOffset": 46800,
                "gmtOffsetName": "UTC+13:00",
                "abbreviation": "PHOT",
                "tzName": "Phoenix Island Time"
            },
            {
                "zoneName": "Pacific\/Kiritimati",
                "gmtOffset": 50400,
                "gmtOffsetName": "UTC+14:00",
                "abbreviation": "LINT",
                "tzName": "Line Islands Time"
            },
            {
                "zoneName": "Pacific\/Tarawa",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "GILT",
                "tzName": "Gilbert Island Time"
            }
        ],
        "translations": {
            "br": "Kiribati",
            "ko": "키리바시",
            "pt-BR": "Kiribati",
            "pt": "Quiribáti",
            "nl": "Kiribati",
            "hr": "Kiribati",
            "fa": "کیریباتی",
            "de": "Kiribati",
            "es": "Kiribati",
            "fr": "Kiribati",
            "ja": "キリバス",
            "it": "Kiribati",
            "zh-CN": "基里巴斯",
            "tr": "Kiribati",
            "ru": "Кирибати",
            "uk": "Кірібаті",
            "pl": "Kiribati"
        },
        "latitude": "1.41666666",
        "longitude": "173.00000000",
        "emoji": "🇰🇮",
        "emojiU": "U+1F1F0 U+1F1EE",
        "states": [
            {
                "id": 1831,
                "name": "Gilbert",
                "iso2": "G",
                "latitude": "0.35242620",
                "longitude": "174.75526340",
                "type": "island",
                "cities": [
                    {
                        "id": 65041,
                        "name": "Abaiang",
                        "latitude": "1.85293000",
                        "longitude": "172.94369000"
                    },
                    {
                        "id": 65042,
                        "name": "Abemama",
                        "latitude": "0.40000000",
                        "longitude": "173.86667000"
                    },
                    {
                        "id": 65043,
                        "name": "Ambo Village",
                        "latitude": "1.35317000",
                        "longitude": "173.04259000"
                    },
                    {
                        "id": 65044,
                        "name": "Aranuka",
                        "latitude": "0.16428000",
                        "longitude": "173.60579000"
                    },
                    {
                        "id": 65045,
                        "name": "Arorae",
                        "latitude": "-2.63493000",
                        "longitude": "176.82229000"
                    },
                    {
                        "id": 65046,
                        "name": "Bairiki Village",
                        "latitude": "1.32924000",
                        "longitude": "172.97522000"
                    },
                    {
                        "id": 65047,
                        "name": "Banaba",
                        "latitude": "-0.85500000",
                        "longitude": "169.53800000"
                    },
                    {
                        "id": 65049,
                        "name": "Banraeaba Village",
                        "latitude": "1.34540000",
                        "longitude": "173.03464000"
                    },
                    {
                        "id": 65050,
                        "name": "Beru",
                        "latitude": "-1.32957000",
                        "longitude": "175.98072000"
                    },
                    {
                        "id": 65051,
                        "name": "Betio Village",
                        "latitude": "1.35797000",
                        "longitude": "172.92105000"
                    },
                    {
                        "id": 65052,
                        "name": "Bikenibeu Village",
                        "latitude": "1.36730000",
                        "longitude": "173.12415000"
                    },
                    {
                        "id": 65053,
                        "name": "Bonriki Village",
                        "latitude": "1.38081000",
                        "longitude": "173.13887000"
                    },
                    {
                        "id": 65054,
                        "name": "Buota Village",
                        "latitude": "1.39078000",
                        "longitude": "173.13082000"
                    },
                    {
                        "id": 65055,
                        "name": "Butaritari",
                        "latitude": "3.17205000",
                        "longitude": "172.79675000"
                    },
                    {
                        "id": 65056,
                        "name": "Eita Village",
                        "latitude": "1.36154000",
                        "longitude": "173.08113000"
                    },
                    {
                        "id": 65059,
                        "name": "Kuria",
                        "latitude": "0.26522000",
                        "longitude": "173.38881000"
                    },
                    {
                        "id": 65061,
                        "name": "Maiana",
                        "latitude": "0.91869000",
                        "longitude": "172.99759000"
                    },
                    {
                        "id": 65062,
                        "name": "Makin",
                        "latitude": "3.38816000",
                        "longitude": "172.99656000"
                    },
                    {
                        "id": 65063,
                        "name": "Makin Village",
                        "latitude": "3.36440000",
                        "longitude": "172.98352000"
                    },
                    {
                        "id": 65064,
                        "name": "Marakei",
                        "latitude": "2.01077000",
                        "longitude": "173.27637000"
                    },
                    {
                        "id": 65066,
                        "name": "Nawerewere Village",
                        "latitude": "1.36362000",
                        "longitude": "173.13935000"
                    },
                    {
                        "id": 65067,
                        "name": "Nikunau",
                        "latitude": "-1.36567000",
                        "longitude": "176.46412000"
                    },
                    {
                        "id": 65068,
                        "name": "Nonouti",
                        "latitude": "-0.66667000",
                        "longitude": "174.35000000"
                    },
                    {
                        "id": 65069,
                        "name": "Onotoa",
                        "latitude": "-1.88587000",
                        "longitude": "175.56393000"
                    },
                    {
                        "id": 65070,
                        "name": "Rawannawi Village",
                        "latitude": "2.05379000",
                        "longitude": "173.26354000"
                    },
                    {
                        "id": 65071,
                        "name": "Tabiteuea",
                        "latitude": "-1.42241000",
                        "longitude": "174.89805000"
                    },
                    {
                        "id": 65074,
                        "name": "Tamana",
                        "latitude": "-2.50113000",
                        "longitude": "175.98621000"
                    },
                    {
                        "id": 65075,
                        "name": "Tarawa",
                        "latitude": "1.32780000",
                        "longitude": "172.97696000"
                    },
                    {
                        "id": 65076,
                        "name": "Teaoraereke Village",
                        "latitude": "1.33309000",
                        "longitude": "173.01162000"
                    },
                    {
                        "id": 65077,
                        "name": "Temaiku Village",
                        "latitude": "1.36292000",
                        "longitude": "173.16226000"
                    }
                ]
            },
            {
                "id": 1832,
                "name": "Line",
                "iso2": "L",
                "latitude": "1.74294390",
                "longitude": "-157.21328260",
                "type": "island",
                "cities": [
                    {
                        "id": 65048,
                        "name": "Banana Village",
                        "latitude": "1.98329000",
                        "longitude": "-157.36526000"
                    },
                    {
                        "id": 65058,
                        "name": "Kiritimati",
                        "latitude": "1.94000000",
                        "longitude": "-157.47500000"
                    },
                    {
                        "id": 65060,
                        "name": "London Village",
                        "latitude": "1.98487000",
                        "longitude": "-157.47502000"
                    },
                    {
                        "id": 65065,
                        "name": "Napari Village",
                        "latitude": "3.90806000",
                        "longitude": "-159.38832000"
                    },
                    {
                        "id": 65072,
                        "name": "Tabuaeran",
                        "latitude": "3.86667000",
                        "longitude": "-159.33333000"
                    },
                    {
                        "id": 65073,
                        "name": "Tabwakea Village",
                        "latitude": "2.01643000",
                        "longitude": "-157.48773000"
                    },
                    {
                        "id": 65078,
                        "name": "Teraina",
                        "latitude": "4.68764000",
                        "longitude": "-160.38803000"
                    }
                ]
            },
            {
                "id": 1830,
                "name": "Phoenix",
                "iso2": "P",
                "latitude": "33.32843690",
                "longitude": "-111.98247740",
                "type": "island",
                "cities": [
                    {
                        "id": 65057,
                        "name": "Kanton",
                        "latitude": "-2.81000000",
                        "longitude": "-171.67800000"
                    }
                ]
            }
        ]
    },
    {
        "id": 248,
        "name": "Kosovo",
        "iso3": "XKX",
        "iso2": "XK",
        "numeric_code": "926",
        "phonecode": "383",
        "capital": "Pristina",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".xk",
        "native": "Republika e Kosovës",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Kosovar, Kosovan",
        "timezones": [
            {
                "zoneName": "Europe\/Belgrade",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Kosovo",
            "ko": "코소보",
            "zh-CN": "科索沃",
            "tr": "Kosova",
            "ru": "Косово",
            "uk": "Косово",
            "pl": "Kosowo"
        },
        "latitude": "42.56129090",
        "longitude": "20.34030350",
        "emoji": "🇽🇰",
        "emojiU": "U+1F1FD U+1F1F0",
        "states": [
            {
                "id": 4874,
                "name": "Ferizaj",
                "iso2": "XUF",
                "latitude": "42.37018440",
                "longitude": "21.14832810",
                "type": "district",
                "cities": []
            },
            {
                "id": 4876,
                "name": "Gjakove",
                "iso2": "XDG",
                "latitude": "42.43757560",
                "longitude": "20.37854380",
                "type": "district",
                "cities": []
            },
            {
                "id": 4877,
                "name": "Gjilan",
                "iso2": "XGJ",
                "latitude": "42.46352060",
                "longitude": "21.46940110",
                "type": "district",
                "cities": []
            },
            {
                "id": 4878,
                "name": "Mitrovica",
                "iso2": "XKM",
                "latitude": "42.89139090",
                "longitude": "20.86599950",
                "type": "district",
                "cities": []
            },
            {
                "id": 5321,
                "name": "Peja",
                "iso2": "PEJ",
                "latitude": "42.70317090",
                "longitude": "20.06168550",
                "type": "district",
                "cities": []
            },
            {
                "id": 4879,
                "name": "Pristina",
                "iso2": "XPI",
                "latitude": "42.66291380",
                "longitude": "21.16550280",
                "type": "district",
                "cities": []
            },
            {
                "id": 5322,
                "name": "Prizren",
                "iso2": "PRI",
                "latitude": "42.23245650",
                "longitude": "20.40393660",
                "type": "district",
                "cities": []
            }
        ]
    },
    {
        "id": 117,
        "name": "Kuwait",
        "iso3": "KWT",
        "iso2": "KW",
        "numeric_code": "414",
        "phonecode": "965",
        "capital": "Kuwait City",
        "currency": "KWD",
        "currency_name": "Kuwaiti dinar",
        "currency_symbol": "ك.د",
        "tld": ".kw",
        "native": "الكويت",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Kuwaiti",
        "timezones": [
            {
                "zoneName": "Asia\/Kuwait",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "br": "Koweit",
            "ko": "쿠웨이트",
            "pt-BR": "Kuwait",
            "pt": "Kuwait",
            "nl": "Koeweit",
            "hr": "Kuvajt",
            "fa": "کویت",
            "de": "Kuwait",
            "es": "Kuwait",
            "fr": "Koweït",
            "ja": "クウェート",
            "it": "Kuwait",
            "zh-CN": "科威特",
            "tr": "Kuveyt",
            "ru": "Кувейт",
            "uk": "Кувейт",
            "pl": "Kuwejt"
        },
        "latitude": "29.50000000",
        "longitude": "45.75000000",
        "emoji": "🇰🇼",
        "emojiU": "U+1F1F0 U+1F1FC",
        "states": [
            {
                "id": 977,
                "name": "Al Ahmadi",
                "iso2": "AH",
                "latitude": "28.57451250",
                "longitude": "48.10247430",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65572,
                        "name": "Al Aḩmadī",
                        "latitude": "29.07694000",
                        "longitude": "48.08389000"
                    },
                    {
                        "id": 65574,
                        "name": "Al Faḩāḩīl",
                        "latitude": "29.08250000",
                        "longitude": "48.13028000"
                    },
                    {
                        "id": 65575,
                        "name": "Al Finţās",
                        "latitude": "29.17389000",
                        "longitude": "48.12111000"
                    },
                    {
                        "id": 65578,
                        "name": "Al Mahbūlah",
                        "latitude": "29.14500000",
                        "longitude": "48.13028000"
                    },
                    {
                        "id": 65579,
                        "name": "Al Manqaf",
                        "latitude": "29.09611000",
                        "longitude": "48.13278000"
                    },
                    {
                        "id": 65580,
                        "name": "Al Wafrah",
                        "latitude": "28.63917000",
                        "longitude": "47.93056000"
                    },
                    {
                        "id": 65582,
                        "name": "Ar Riqqah",
                        "latitude": "29.14583000",
                        "longitude": "48.09472000"
                    }
                ]
            },
            {
                "id": 976,
                "name": "Al Asimah",
                "iso2": "KU",
                "latitude": "26.22851610",
                "longitude": "50.58604970",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65571,
                        "name": "Ad Dasmah",
                        "latitude": "29.36500000",
                        "longitude": "48.00139000"
                    },
                    {
                        "id": 65584,
                        "name": "Ar Rābiyah",
                        "latitude": "29.29500000",
                        "longitude": "47.93306000"
                    },
                    {
                        "id": 65586,
                        "name": "Ash Shāmīyah",
                        "latitude": "29.34722000",
                        "longitude": "47.96167000"
                    },
                    {
                        "id": 65587,
                        "name": "Az Zawr",
                        "latitude": "29.44250000",
                        "longitude": "48.27472000"
                    },
                    {
                        "id": 65590,
                        "name": "Kuwait City",
                        "latitude": "29.36972000",
                        "longitude": "47.97833000"
                    }
                ]
            },
            {
                "id": 975,
                "name": "Al Farwaniyah",
                "iso2": "FA",
                "latitude": "29.27335700",
                "longitude": "47.94001540",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65573,
                        "name": "Al Farwānīyah",
                        "latitude": "29.27750000",
                        "longitude": "47.95861000"
                    },
                    {
                        "id": 65589,
                        "name": "Janūb as Surrah",
                        "latitude": "29.26917000",
                        "longitude": "47.97806000"
                    }
                ]
            },
            {
                "id": 972,
                "name": "Al Jahra",
                "iso2": "JA",
                "latitude": "29.99318310",
                "longitude": "47.76347310",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65577,
                        "name": "Al Jahrā’",
                        "latitude": "29.33750000",
                        "longitude": "47.65806000"
                    }
                ]
            },
            {
                "id": 973,
                "name": "Hawalli",
                "iso2": "HA",
                "latitude": "29.30567160",
                "longitude": "48.03076130",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65583,
                        "name": "Ar Rumaythīyah",
                        "latitude": "29.31167000",
                        "longitude": "48.07417000"
                    },
                    {
                        "id": 65585,
                        "name": "As Sālimīyah",
                        "latitude": "29.33389000",
                        "longitude": "48.07611000"
                    },
                    {
                        "id": 65588,
                        "name": "Bayān",
                        "latitude": "29.30320000",
                        "longitude": "48.04881000"
                    },
                    {
                        "id": 65593,
                        "name": "Ḩawallī",
                        "latitude": "29.33278000",
                        "longitude": "48.02861000"
                    },
                    {
                        "id": 65591,
                        "name": "Salwá",
                        "latitude": "29.29583000",
                        "longitude": "48.07861000"
                    }
                ]
            },
            {
                "id": 974,
                "name": "Mubarak Al-Kabeer",
                "iso2": "MU",
                "latitude": "29.21224000",
                "longitude": "48.06051080",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65569,
                        "name": "Abu Al Hasaniya",
                        "latitude": "29.19076000",
                        "longitude": "48.11355000"
                    },
                    {
                        "id": 65570,
                        "name": "Abu Fatira",
                        "latitude": "29.19746000",
                        "longitude": "48.10278000"
                    },
                    {
                        "id": 65576,
                        "name": "Al Funayţīs",
                        "latitude": "29.22528000",
                        "longitude": "48.10167000"
                    },
                    {
                        "id": 65581,
                        "name": "Al-Masayel",
                        "latitude": "29.23930000",
                        "longitude": "48.08862000"
                    },
                    {
                        "id": 65592,
                        "name": "Şabāḩ as Sālim",
                        "latitude": "29.25722000",
                        "longitude": "48.05722000"
                    }
                ]
            }
        ]
    },
    {
        "id": 118,
        "name": "Kyrgyzstan",
        "iso3": "KGZ",
        "iso2": "KG",
        "numeric_code": "417",
        "phonecode": "996",
        "capital": "Bishkek",
        "currency": "KGS",
        "currency_name": "Kyrgyzstani som",
        "currency_symbol": "лв",
        "tld": ".kg",
        "native": "Кыргызстан",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Central Asia",
        "subregion_id": 10,
        "nationality": "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz",
        "timezones": [
            {
                "zoneName": "Asia\/Bishkek",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "KGT",
                "tzName": "Kyrgyzstan Time"
            }
        ],
        "translations": {
            "br": "Kirgizstan",
            "ko": "키르기스스탄",
            "pt-BR": "Quirguistão",
            "pt": "Quirguizistão",
            "nl": "Kirgizië",
            "hr": "Kirgistan",
            "fa": "قرقیزستان",
            "de": "Kirgisistan",
            "es": "Kirguizistán",
            "fr": "Kirghizistan",
            "ja": "キルギス",
            "it": "Kirghizistan",
            "zh-CN": "吉尔吉斯斯坦",
            "tr": "Kirgizistan",
            "ru": "Кыргызстан",
            "uk": "Киргизстан",
            "pl": "Kirgistan"
        },
        "latitude": "41.00000000",
        "longitude": "75.00000000",
        "emoji": "🇰🇬",
        "emojiU": "U+1F1F0 U+1F1EC",
        "states": [
            {
                "id": 998,
                "name": "Batken",
                "iso2": "B",
                "latitude": "39.97214250",
                "longitude": "69.85974060",
                "type": "region",
                "cities": [
                    {
                        "id": 64886,
                        "name": "Aydarken",
                        "latitude": "39.94319000",
                        "longitude": "71.34184000"
                    },
                    {
                        "id": 64888,
                        "name": "Batken",
                        "latitude": "40.06259000",
                        "longitude": "70.81939000"
                    },
                    {
                        "id": 64896,
                        "name": "Iradan",
                        "latitude": "40.26667000",
                        "longitude": "72.10000000"
                    },
                    {
                        "id": 64897,
                        "name": "Isfana",
                        "latitude": "39.83895000",
                        "longitude": "69.52760000"
                    },
                    {
                        "id": 64909,
                        "name": "Karavan",
                        "latitude": "40.29513000",
                        "longitude": "72.18627000"
                    },
                    {
                        "id": 64915,
                        "name": "Kyzyl-Kyya",
                        "latitude": "40.25684000",
                        "longitude": "72.12793000"
                    },
                    {
                        "id": 64923,
                        "name": "Suluktu",
                        "latitude": "39.93652000",
                        "longitude": "69.56779000"
                    }
                ]
            },
            {
                "id": 1001,
                "name": "Bishkek",
                "iso2": "GB",
                "latitude": "42.87462120",
                "longitude": "74.56976170",
                "type": "city",
                "cities": [
                    {
                        "id": 64891,
                        "name": "Bishkek",
                        "latitude": "42.87000000",
                        "longitude": "74.59000000"
                    }
                ]
            },
            {
                "id": 1004,
                "name": "Chuy",
                "iso2": "C",
                "latitude": "42.56550000",
                "longitude": "74.40566120",
                "type": "region",
                "cities": [
                    {
                        "id": 64884,
                        "name": "Alamudunskiy Rayon",
                        "latitude": "42.81985000",
                        "longitude": "74.59398000"
                    },
                    {
                        "id": 64890,
                        "name": "Belovodskoye",
                        "latitude": "42.82944000",
                        "longitude": "74.10830000"
                    },
                    {
                        "id": 64894,
                        "name": "Chuyskiy Rayon",
                        "latitude": "42.66667000",
                        "longitude": "75.33333000"
                    },
                    {
                        "id": 64898,
                        "name": "Ivanovka",
                        "latitude": "42.88778000",
                        "longitude": "75.08500000"
                    },
                    {
                        "id": 64902,
                        "name": "Kaindy",
                        "latitude": "42.82469000",
                        "longitude": "73.67585000"
                    },
                    {
                        "id": 64903,
                        "name": "Kant",
                        "latitude": "42.89106000",
                        "longitude": "74.85077000"
                    },
                    {
                        "id": 64906,
                        "name": "Kara-Balta",
                        "latitude": "42.81423000",
                        "longitude": "73.84813000"
                    },
                    {
                        "id": 64911,
                        "name": "Kemin",
                        "latitude": "42.78611000",
                        "longitude": "75.69167000"
                    },
                    {
                        "id": 64917,
                        "name": "Lebedinovka",
                        "latitude": "42.88454000",
                        "longitude": "74.67819000"
                    },
                    {
                        "id": 64921,
                        "name": "Sokulukskiy Rayon",
                        "latitude": "42.83333000",
                        "longitude": "74.33333000"
                    },
                    {
                        "id": 64922,
                        "name": "Sosnovka",
                        "latitude": "42.63707000",
                        "longitude": "73.89608000"
                    },
                    {
                        "id": 64928,
                        "name": "Tokmok",
                        "latitude": "42.84194000",
                        "longitude": "75.30149000"
                    },
                    {
                        "id": 64934,
                        "name": "Ysyk-Ata",
                        "latitude": "42.72665000",
                        "longitude": "75.07444000"
                    }
                ]
            },
            {
                "id": 1002,
                "name": "Issyk-Kul",
                "iso2": "Y",
                "latitude": "42.18594280",
                "longitude": "77.56194190",
                "type": "region",
                "cities": [
                    {
                        "id": 64882,
                        "name": "Ak-Suu",
                        "latitude": "42.49948000",
                        "longitude": "78.52702000"
                    },
                    {
                        "id": 64887,
                        "name": "Balykchy",
                        "latitude": "42.46017000",
                        "longitude": "76.18709000"
                    },
                    {
                        "id": 64892,
                        "name": "Cholpon-Ata",
                        "latitude": "42.64944000",
                        "longitude": "77.08225000"
                    },
                    {
                        "id": 64901,
                        "name": "Kadzhi-Say",
                        "latitude": "42.14107000",
                        "longitude": "77.17848000"
                    },
                    {
                        "id": 64908,
                        "name": "Karakol",
                        "latitude": "42.49068000",
                        "longitude": "78.39362000"
                    },
                    {
                        "id": 64916,
                        "name": "Kyzyl-Suu",
                        "latitude": "42.34211000",
                        "longitude": "78.00644000"
                    },
                    {
                        "id": 64931,
                        "name": "Tyup",
                        "latitude": "42.72760000",
                        "longitude": "78.36476000"
                    }
                ]
            },
            {
                "id": 1000,
                "name": "Jalal-Abad",
                "iso2": "J",
                "latitude": "41.10680800",
                "longitude": "72.89880690",
                "type": "region",
                "cities": [
                    {
                        "id": 64883,
                        "name": "Ala-Buka",
                        "latitude": "41.40806000",
                        "longitude": "71.46306000"
                    },
                    {
                        "id": 64889,
                        "name": "Bazar-Korgon",
                        "latitude": "41.03760000",
                        "longitude": "72.74586000"
                    },
                    {
                        "id": 64899,
                        "name": "Jalal-Abad",
                        "latitude": "40.93333000",
                        "longitude": "73.00000000"
                    },
                    {
                        "id": 64910,
                        "name": "Kazarman",
                        "latitude": "41.40500000",
                        "longitude": "74.03700000"
                    },
                    {
                        "id": 64912,
                        "name": "Kerben",
                        "latitude": "41.49399000",
                        "longitude": "71.75826000"
                    },
                    {
                        "id": 64913,
                        "name": "Kochkor-Ata",
                        "latitude": "41.03709000",
                        "longitude": "72.48320000"
                    },
                    {
                        "id": 64924,
                        "name": "Suzak",
                        "latitude": "40.89820000",
                        "longitude": "72.90481000"
                    },
                    {
                        "id": 64927,
                        "name": "Tash-Kumyr",
                        "latitude": "41.34612000",
                        "longitude": "72.21707000"
                    },
                    {
                        "id": 64929,
                        "name": "Toktogul",
                        "latitude": "41.87442000",
                        "longitude": "72.94192000"
                    },
                    {
                        "id": 64930,
                        "name": "Toktogul District",
                        "latitude": "41.75000000",
                        "longitude": "73.00000000"
                    }
                ]
            },
            {
                "id": 999,
                "name": "Naryn",
                "iso2": "N",
                "latitude": "41.29432270",
                "longitude": "75.34121790",
                "type": "region",
                "cities": [
                    {
                        "id": 64885,
                        "name": "At-Bashi",
                        "latitude": "41.16951000",
                        "longitude": "75.80099000"
                    },
                    {
                        "id": 64900,
                        "name": "Jumgal",
                        "latitude": "41.94924000",
                        "longitude": "74.40566000"
                    },
                    {
                        "id": 64918,
                        "name": "Naryn",
                        "latitude": "41.42866000",
                        "longitude": "75.99111000"
                    }
                ]
            },
            {
                "id": 1003,
                "name": "Osh",
                "iso2": "GO",
                "latitude": "36.06313990",
                "longitude": "-95.91828950",
                "type": "city",
                "cities": []
            },
            {
                "id": 1005,
                "name": "Osh",
                "iso2": "O",
                "latitude": "39.84073660",
                "longitude": "72.89880690",
                "type": "region",
                "cities": [
                    {
                        "id": 64893,
                        "name": "Chong-Alay District",
                        "latitude": "39.47614000",
                        "longitude": "72.33017000"
                    },
                    {
                        "id": 64895,
                        "name": "Daroot-Korgon",
                        "latitude": "39.55274000",
                        "longitude": "72.20518000"
                    },
                    {
                        "id": 64904,
                        "name": "Kara Kulja",
                        "latitude": "40.64095000",
                        "longitude": "73.49411000"
                    },
                    {
                        "id": 64905,
                        "name": "Kara Suu",
                        "latitude": "40.70460000",
                        "longitude": "72.86666000"
                    },
                    {
                        "id": 64914,
                        "name": "Kyzyl-Eshme",
                        "latitude": "39.56559000",
                        "longitude": "72.27153000"
                    },
                    {
                        "id": 64919,
                        "name": "Nookat",
                        "latitude": "40.26597000",
                        "longitude": "72.61834000"
                    },
                    {
                        "id": 64920,
                        "name": "Osh",
                        "latitude": "40.52828000",
                        "longitude": "72.79850000"
                    },
                    {
                        "id": 64932,
                        "name": "Uzgen",
                        "latitude": "40.76994000",
                        "longitude": "73.30068000"
                    },
                    {
                        "id": 64933,
                        "name": "Uzgen District",
                        "latitude": "40.55000000",
                        "longitude": "73.30000000"
                    }
                ]
            },
            {
                "id": 997,
                "name": "Talas",
                "iso2": "T",
                "latitude": "42.28673390",
                "longitude": "72.52048270",
                "type": "region",
                "cities": [
                    {
                        "id": 64907,
                        "name": "Kara-Buurinskiy Rayon",
                        "latitude": "42.50000000",
                        "longitude": "71.41667000"
                    },
                    {
                        "id": 64925,
                        "name": "Talas",
                        "latitude": "42.52277000",
                        "longitude": "72.24274000"
                    },
                    {
                        "id": 64926,
                        "name": "Talasskiy Rayon",
                        "latitude": "42.18647000",
                        "longitude": "72.69408000"
                    }
                ]
            }
        ]
    },
    {
        "id": 119,
        "name": "Laos",
        "iso3": "LAO",
        "iso2": "LA",
        "numeric_code": "418",
        "phonecode": "856",
        "capital": "Vientiane",
        "currency": "LAK",
        "currency_name": "Lao kip",
        "currency_symbol": "₭",
        "tld": ".la",
        "native": "ສປປລາວ",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Lao, Laotian",
        "timezones": [
            {
                "zoneName": "Asia\/Vientiane",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "ICT",
                "tzName": "Indochina Time"
            }
        ],
        "translations": {
            "br": "Laos",
            "ko": "라오스",
            "pt-BR": "Laos",
            "pt": "Laos",
            "nl": "Laos",
            "hr": "Laos",
            "fa": "لائوس",
            "de": "Laos",
            "es": "Laos",
            "fr": "Laos",
            "ja": "ラオス人民民主共和国",
            "it": "Laos",
            "zh-CN": "寮人民民主共和国",
            "tr": "Laos",
            "ru": "Лаос",
            "uk": "Лаос",
            "pl": "Laos"
        },
        "latitude": "18.00000000",
        "longitude": "105.00000000",
        "emoji": "🇱🇦",
        "emojiU": "U+1F1F1 U+1F1E6",
        "states": [
            {
                "id": 982,
                "name": "Attapeu",
                "iso2": "AT",
                "latitude": "14.93634000",
                "longitude": "107.10119310",
                "type": "province",
                "cities": [
                    {
                        "id": 65855,
                        "name": "Attapeu",
                        "latitude": "14.81071000",
                        "longitude": "106.83184000"
                    },
                    {
                        "id": 65891,
                        "name": "Muang Phouvong",
                        "latitude": "14.56821000",
                        "longitude": "107.01087000"
                    },
                    {
                        "id": 65895,
                        "name": "Muang Samakhixai",
                        "latitude": "14.80539000",
                        "longitude": "106.78164000"
                    },
                    {
                        "id": 65897,
                        "name": "Muang Sanamxai",
                        "latitude": "14.73807000",
                        "longitude": "106.41328000"
                    },
                    {
                        "id": 65898,
                        "name": "Muang Sanxai",
                        "latitude": "15.02944000",
                        "longitude": "107.23158000"
                    },
                    {
                        "id": 65912,
                        "name": "Muang Xaiséttha",
                        "latitude": "14.90594000",
                        "longitude": "106.97894000"
                    }
                ]
            },
            {
                "id": 991,
                "name": "Bokeo",
                "iso2": "BK",
                "latitude": "20.28726620",
                "longitude": "100.70978670",
                "type": "province",
                "cities": [
                    {
                        "id": 65856,
                        "name": "Ban Houakhoua",
                        "latitude": "20.24670000",
                        "longitude": "100.45401000"
                    },
                    {
                        "id": 65857,
                        "name": "Ban Houayxay",
                        "latitude": "20.27000000",
                        "longitude": "100.41780000"
                    },
                    {
                        "id": 65872,
                        "name": "Muang Houayxay",
                        "latitude": "20.38763000",
                        "longitude": "100.62687000"
                    },
                    {
                        "id": 65881,
                        "name": "Muang Meung",
                        "latitude": "20.67585000",
                        "longitude": "100.52639000"
                    },
                    {
                        "id": 65885,
                        "name": "Muang Paktha",
                        "latitude": "20.09108000",
                        "longitude": "100.59940000"
                    },
                    {
                        "id": 65889,
                        "name": "Muang Pha Oudôm",
                        "latitude": "20.18744000",
                        "longitude": "100.92600000"
                    },
                    {
                        "id": 65908,
                        "name": "Muang Tônpheung",
                        "latitude": "20.53465000",
                        "longitude": "100.29624000"
                    }
                ]
            },
            {
                "id": 985,
                "name": "Bolikhamsai",
                "iso2": "BL",
                "latitude": "18.49296080",
                "longitude": "102.72431790",
                "type": "province",
                "cities": [
                    {
                        "id": 65858,
                        "name": "Ban Nahin",
                        "latitude": "18.24253000",
                        "longitude": "104.21281000"
                    },
                    {
                        "id": 65918,
                        "name": "Pakxan",
                        "latitude": "18.39420000",
                        "longitude": "103.66110000"
                    }
                ]
            },
            {
                "id": 996,
                "name": "Champasak",
                "iso2": "CH",
                "latitude": "14.65786640",
                "longitude": "105.96998780",
                "type": "province",
                "cities": [
                    {
                        "id": 65860,
                        "name": "Champasak",
                        "latitude": "14.89204000",
                        "longitude": "105.87787000"
                    },
                    {
                        "id": 65868,
                        "name": "Muang Bachiangchaleunsook",
                        "latitude": "15.24426000",
                        "longitude": "105.96716000"
                    },
                    {
                        "id": 65869,
                        "name": "Muang Champasak",
                        "latitude": "14.85704000",
                        "longitude": "105.75334000"
                    },
                    {
                        "id": 65874,
                        "name": "Muang Không",
                        "latitude": "14.14696000",
                        "longitude": "105.95938000"
                    },
                    {
                        "id": 65882,
                        "name": "Muang Mounlapamôk",
                        "latitude": "14.28922000",
                        "longitude": "105.56832000"
                    },
                    {
                        "id": 65887,
                        "name": "Muang Pakxé",
                        "latitude": "15.13139000",
                        "longitude": "105.81612000"
                    },
                    {
                        "id": 65886,
                        "name": "Muang Pakxong",
                        "latitude": "15.09810000",
                        "longitude": "106.43398000"
                    },
                    {
                        "id": 65888,
                        "name": "Muang Pathoumphon",
                        "latitude": "14.68453000",
                        "longitude": "106.06357000"
                    },
                    {
                        "id": 65894,
                        "name": "Muang Phônthong",
                        "latitude": "15.10669000",
                        "longitude": "105.64890000"
                    },
                    {
                        "id": 65901,
                        "name": "Muang Soukhouma",
                        "latitude": "14.62560000",
                        "longitude": "105.67520000"
                    },
                    {
                        "id": 65913,
                        "name": "Muang Xanasômboun",
                        "latitude": "15.34107000",
                        "longitude": "105.73703000"
                    },
                    {
                        "id": 65917,
                        "name": "Pakse",
                        "latitude": "15.12022000",
                        "longitude": "105.79898000"
                    },
                    {
                        "id": 65919,
                        "name": "Pakxong",
                        "latitude": "15.18154000",
                        "longitude": "106.23038000"
                    }
                ]
            },
            {
                "id": 989,
                "name": "Houaphanh",
                "iso2": "HO",
                "latitude": "20.32541750",
                "longitude": "104.10013260",
                "type": "province",
                "cities": [
                    {
                        "id": 65928,
                        "name": "Xam Neua",
                        "latitude": "20.40764000",
                        "longitude": "104.06560000"
                    },
                    {
                        "id": 65929,
                        "name": "Xam Nua",
                        "latitude": "20.41640000",
                        "longitude": "104.04500000"
                    }
                ]
            },
            {
                "id": 986,
                "name": "Khammouane",
                "iso2": "KH",
                "latitude": "17.63840660",
                "longitude": "105.21948080",
                "type": "province",
                "cities": [
                    {
                        "id": 65903,
                        "name": "Muang Thakhèk",
                        "latitude": "17.40880000",
                        "longitude": "104.82639000"
                    },
                    {
                        "id": 65924,
                        "name": "Thakhèk",
                        "latitude": "17.41027000",
                        "longitude": "104.83068000"
                    }
                ]
            },
            {
                "id": 992,
                "name": "Luang Namtha",
                "iso2": "LM",
                "latitude": "20.91701870",
                "longitude": "101.16173560",
                "type": "province",
                "cities": [
                    {
                        "id": 65864,
                        "name": "Luang Namtha",
                        "latitude": "20.94860000",
                        "longitude": "101.40188000"
                    },
                    {
                        "id": 65880,
                        "name": "Muang Louang Namtha",
                        "latitude": "21.00424000",
                        "longitude": "101.44785000"
                    }
                ]
            },
            {
                "id": 978,
                "name": "Luang Prabang",
                "iso2": "LP",
                "latitude": "20.06562290",
                "longitude": "102.62162110",
                "type": "province",
                "cities": [
                    {
                        "id": 65865,
                        "name": "Luang Prabang",
                        "latitude": "19.88601000",
                        "longitude": "102.13503000"
                    }
                ]
            },
            {
                "id": 988,
                "name": "Oudomxay",
                "iso2": "OU",
                "latitude": "20.49219290",
                "longitude": "101.88917210",
                "type": "province",
                "cities": [
                    {
                        "id": 65914,
                        "name": "Muang Xay",
                        "latitude": "20.69229000",
                        "longitude": "101.98368000"
                    }
                ]
            },
            {
                "id": 987,
                "name": "Phongsaly",
                "iso2": "PH",
                "latitude": "21.59193770",
                "longitude": "102.25479190",
                "type": "province",
                "cities": [
                    {
                        "id": 65920,
                        "name": "Phôngsali",
                        "latitude": "21.68080000",
                        "longitude": "102.10030000"
                    }
                ]
            },
            {
                "id": 993,
                "name": "Sainyabuli",
                "iso2": "XA",
                "latitude": "19.39078860",
                "longitude": "101.52480550",
                "type": "province",
                "cities": [
                    {
                        "id": 65921,
                        "name": "Sainyabuli",
                        "latitude": "19.25756000",
                        "longitude": "101.71032000"
                    }
                ]
            },
            {
                "id": 981,
                "name": "Salavan",
                "iso2": "SL",
                "latitude": "15.81710730",
                "longitude": "106.25221430",
                "type": "province",
                "cities": [
                    {
                        "id": 65875,
                        "name": "Muang Khôngxédôn",
                        "latitude": "15.54626000",
                        "longitude": "105.77051000"
                    },
                    {
                        "id": 65876,
                        "name": "Muang Lakhonphéng",
                        "latitude": "15.83308000",
                        "longitude": "105.59745000"
                    },
                    {
                        "id": 65878,
                        "name": "Muang Laongam",
                        "latitude": "15.47745000",
                        "longitude": "106.14111000"
                    },
                    {
                        "id": 65896,
                        "name": "Muang Samouay",
                        "latitude": "16.35868000",
                        "longitude": "106.87480000"
                    },
                    {
                        "id": 65899,
                        "name": "Muang Saravan",
                        "latitude": "15.71587000",
                        "longitude": "106.36158000"
                    },
                    {
                        "id": 65902,
                        "name": "Muang Ta-Ôy",
                        "latitude": "16.07765000",
                        "longitude": "106.70304000"
                    },
                    {
                        "id": 65907,
                        "name": "Muang Toumlan",
                        "latitude": "16.02236000",
                        "longitude": "106.23837000"
                    },
                    {
                        "id": 65909,
                        "name": "Muang Vapi",
                        "latitude": "15.75005000",
                        "longitude": "105.95529000"
                    },
                    {
                        "id": 65922,
                        "name": "Salavan",
                        "latitude": "15.71652000",
                        "longitude": "106.41744000"
                    }
                ]
            },
            {
                "id": 990,
                "name": "Savannakhet",
                "iso2": "SV",
                "latitude": "16.50653810",
                "longitude": "105.59433880",
                "type": "province",
                "cities": [
                    {
                        "id": 65861,
                        "name": "Kaysone Phomvihane",
                        "latitude": "16.54943000",
                        "longitude": "104.82339000"
                    },
                    {
                        "id": 65866,
                        "name": "Muang Alsaphangthong",
                        "latitude": "16.72645000",
                        "longitude": "105.39326000"
                    },
                    {
                        "id": 65867,
                        "name": "Muang Atsaphan",
                        "latitude": "16.94740000",
                        "longitude": "105.40290000"
                    },
                    {
                        "id": 65870,
                        "name": "Muang Champhon",
                        "latitude": "16.49363000",
                        "longitude": "105.22020000"
                    },
                    {
                        "id": 65883,
                        "name": "Muang Nong",
                        "latitude": "16.38458000",
                        "longitude": "106.50419000"
                    },
                    {
                        "id": 65884,
                        "name": "Muang Outhoumphon",
                        "latitude": "16.66667000",
                        "longitude": "105.05000000"
                    },
                    {
                        "id": 65890,
                        "name": "Muang Phin",
                        "latitude": "16.44316000",
                        "longitude": "106.03019000"
                    },
                    {
                        "id": 65900,
                        "name": "Muang Songkhon",
                        "latitude": "16.17116000",
                        "longitude": "105.30729000"
                    },
                    {
                        "id": 65904,
                        "name": "Muang Thapangthong",
                        "latitude": "16.09132000",
                        "longitude": "105.81038000"
                    },
                    {
                        "id": 65910,
                        "name": "Muang Vilabouli",
                        "latitude": "16.94067000",
                        "longitude": "105.93677000"
                    },
                    {
                        "id": 65911,
                        "name": "Muang Xaibouli",
                        "latitude": "16.94432000",
                        "longitude": "104.92312000"
                    },
                    {
                        "id": 65915,
                        "name": "Muang Xayphoothong",
                        "latitude": "16.37370000",
                        "longitude": "105.02165000"
                    },
                    {
                        "id": 65916,
                        "name": "Muang Xônbouli",
                        "latitude": "16.40036000",
                        "longitude": "105.57388000"
                    },
                    {
                        "id": 65923,
                        "name": "Savannakhet",
                        "latitude": "16.57030000",
                        "longitude": "104.76220000"
                    },
                    {
                        "id": 65925,
                        "name": "Thaphalanxay",
                        "latitude": "16.70000000",
                        "longitude": "105.60000000"
                    }
                ]
            },
            {
                "id": 984,
                "name": "Sekong",
                "iso2": "XE",
                "latitude": "15.57674460",
                "longitude": "107.00670310",
                "type": "province",
                "cities": [
                    {
                        "id": 65859,
                        "name": "Ban Thatèng",
                        "latitude": "15.43317000",
                        "longitude": "106.38272000"
                    },
                    {
                        "id": 65862,
                        "name": "Lamam",
                        "latitude": "15.41705000",
                        "longitude": "106.69461000"
                    },
                    {
                        "id": 65871,
                        "name": "Muang Dakchung",
                        "latitude": "15.38199000",
                        "longitude": "107.31847000"
                    },
                    {
                        "id": 65873,
                        "name": "Muang Khaleum",
                        "latitude": "15.79886000",
                        "longitude": "107.04529000"
                    },
                    {
                        "id": 65877,
                        "name": "Muang Laman",
                        "latitude": "15.41273000",
                        "longitude": "106.81706000"
                    },
                    {
                        "id": 65906,
                        "name": "Muang Thatèng",
                        "latitude": "15.42745000",
                        "longitude": "106.48149000"
                    }
                ]
            },
            {
                "id": 980,
                "name": "Vientiane",
                "iso2": "VI",
                "latitude": "18.57050630",
                "longitude": "102.62162110",
                "type": "province",
                "cities": [
                    {
                        "id": 65892,
                        "name": "Muang Phôn-Hông",
                        "latitude": "18.49530000",
                        "longitude": "102.41530000"
                    },
                    {
                        "id": 65926,
                        "name": "Vangviang",
                        "latitude": "18.92350000",
                        "longitude": "102.44784000"
                    }
                ]
            },
            {
                "id": 979,
                "name": "Vientiane",
                "iso2": "VT",
                "latitude": "18.11054100",
                "longitude": "102.52980280",
                "type": "prefecture",
                "cities": [
                    {
                        "id": 65927,
                        "name": "Vientiane",
                        "latitude": "17.96667000",
                        "longitude": "102.60000000"
                    }
                ]
            },
            {
                "id": 983,
                "name": "Xaisomboun",
                "iso2": "XS",
                "latitude": "18.86650980",
                "longitude": "101.88354890",
                "type": "province",
                "cities": [
                    {
                        "id": 65854,
                        "name": "Anouvong district",
                        "latitude": "18.89731000",
                        "longitude": "103.09274000"
                    },
                    {
                        "id": 65863,
                        "name": "Longchaeng",
                        "latitude": "18.89394000",
                        "longitude": "103.14274000"
                    },
                    {
                        "id": 65879,
                        "name": "Muang Longxan",
                        "latitude": "18.61782000",
                        "longitude": "102.88079000"
                    },
                    {
                        "id": 65905,
                        "name": "Muang Thathôm",
                        "latitude": "19.00130000",
                        "longitude": "103.61572000"
                    }
                ]
            },
            {
                "id": 995,
                "name": "Xiangkhouang",
                "iso2": "XI",
                "latitude": "19.60930030",
                "longitude": "103.72891670",
                "type": "province",
                "cities": [
                    {
                        "id": 65893,
                        "name": "Muang Phônsavan",
                        "latitude": "19.44940000",
                        "longitude": "103.19170000"
                    }
                ]
            }
        ]
    },
    {
        "id": 120,
        "name": "Latvia",
        "iso3": "LVA",
        "iso2": "LV",
        "numeric_code": "428",
        "phonecode": "371",
        "capital": "Riga",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".lv",
        "native": "Latvija",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Latvian",
        "timezones": [
            {
                "zoneName": "Europe\/Riga",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Latvia",
            "ko": "라트비아",
            "pt-BR": "Letônia",
            "pt": "Letónia",
            "nl": "Letland",
            "hr": "Latvija",
            "fa": "لتونی",
            "de": "Lettland",
            "es": "Letonia",
            "fr": "Lettonie",
            "ja": "ラトビア",
            "it": "Lettonia",
            "zh-CN": "拉脱维亚",
            "tr": "Letonya",
            "ru": "Латвия",
            "uk": "Латвія",
            "pl": "Łotwa"
        },
        "latitude": "57.00000000",
        "longitude": "25.00000000",
        "emoji": "🇱🇻",
        "emojiU": "U+1F1F1 U+1F1FB",
        "states": [
            {
                "id": 4454,
                "name": "Ādaži",
                "iso2": "011",
                "latitude": "57.11124560",
                "longitude": "24.14823110",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66885,
                        "name": "Carnikava",
                        "latitude": "57.12935000",
                        "longitude": "24.28423000"
                    }
                ]
            },
            {
                "id": 4472,
                "name": "Aizkraukle",
                "iso2": "002",
                "latitude": "56.64610800",
                "longitude": "25.23708540",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66870,
                        "name": "Aizkraukle",
                        "latitude": "56.60477000",
                        "longitude": "25.25534000"
                    },
                    {
                        "id": 66904,
                        "name": "Jaunjelgava",
                        "latitude": "56.61319000",
                        "longitude": "25.08316000"
                    },
                    {
                        "id": 66913,
                        "name": "Koknese",
                        "latitude": "56.65163000",
                        "longitude": "25.43637000"
                    },
                    {
                        "id": 66933,
                        "name": "Nereta",
                        "latitude": "56.20279000",
                        "longitude": "25.30752000"
                    },
                    {
                        "id": 66945,
                        "name": "Pļaviņas",
                        "latitude": "56.61780000",
                        "longitude": "25.72552000"
                    },
                    {
                        "id": 66963,
                        "name": "Skrīveri",
                        "latitude": "56.64500000",
                        "longitude": "25.12058000"
                    }
                ]
            },
            {
                "id": 4487,
                "name": "Alūksne",
                "iso2": "007",
                "latitude": "57.42544850",
                "longitude": "27.04249680",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66875,
                        "name": "Alūksne",
                        "latitude": "57.42162000",
                        "longitude": "27.04662000"
                    }
                ]
            },
            {
                "id": 4492,
                "name": "Augšdaugava",
                "iso2": "111",
                "latitude": "55.93969780",
                "longitude": "25.74317090",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66891,
                        "name": "Daugavpils",
                        "latitude": "55.88333000",
                        "longitude": "26.53333000"
                    },
                    {
                        "id": 66900,
                        "name": "Ilūkste",
                        "latitude": "55.97754000",
                        "longitude": "26.29655000"
                    }
                ]
            },
            {
                "id": 4505,
                "name": "Balvi",
                "iso2": "015",
                "latitude": "57.13262400",
                "longitude": "27.26466850",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66880,
                        "name": "Baltinava",
                        "latitude": "56.94394000",
                        "longitude": "27.64401000"
                    },
                    {
                        "id": 66881,
                        "name": "Balvi",
                        "latitude": "57.13130000",
                        "longitude": "27.26583000"
                    },
                    {
                        "id": 66952,
                        "name": "Rugāji",
                        "latitude": "57.00325000",
                        "longitude": "27.13371000"
                    },
                    {
                        "id": 66986,
                        "name": "Viļaka",
                        "latitude": "57.18458000",
                        "longitude": "27.67220000"
                    }
                ]
            },
            {
                "id": 4465,
                "name": "Bauska",
                "iso2": "016",
                "latitude": "56.41018680",
                "longitude": "24.20006890",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66882,
                        "name": "Bauska",
                        "latitude": "56.40794000",
                        "longitude": "24.19443000"
                    },
                    {
                        "id": 66898,
                        "name": "Iecava",
                        "latitude": "56.59766000",
                        "longitude": "24.20763000"
                    },
                    {
                        "id": 66938,
                        "name": "Pilsrundāle",
                        "latitude": "56.41812000",
                        "longitude": "24.01625000"
                    },
                    {
                        "id": 66982,
                        "name": "Vecumnieki",
                        "latitude": "56.60608000",
                        "longitude": "24.52232000"
                    }
                ]
            },
            {
                "id": 4469,
                "name": "Cēsis",
                "iso2": "022",
                "latitude": "57.31028970",
                "longitude": "25.26761250",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66888,
                        "name": "Cēsis",
                        "latitude": "57.31188000",
                        "longitude": "25.27456000"
                    },
                    {
                        "id": 66924,
                        "name": "Līgatne",
                        "latitude": "57.23429000",
                        "longitude": "25.04059000"
                    },
                    {
                        "id": 66943,
                        "name": "Priekuļi",
                        "latitude": "57.31500000",
                        "longitude": "25.36147000"
                    },
                    {
                        "id": 66967,
                        "name": "Stalbe",
                        "latitude": "57.37065000",
                        "longitude": "25.03106000"
                    },
                    {
                        "id": 66981,
                        "name": "Vecpiebalga",
                        "latitude": "57.06090000",
                        "longitude": "25.81624000"
                    }
                ]
            },
            {
                "id": 4463,
                "name": "Daugavpils",
                "iso2": "DGV",
                "latitude": "55.87473600",
                "longitude": "26.53617900",
                "type": "state city",
                "cities": []
            },
            {
                "id": 4508,
                "name": "Dienvidkurzemes",
                "iso2": "112",
                "latitude": "56.52063120",
                "longitude": "20.83211760",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66871,
                        "name": "Aizpute",
                        "latitude": "56.72108000",
                        "longitude": "21.60156000"
                    },
                    {
                        "id": 66896,
                        "name": "Grobiņa",
                        "latitude": "56.53521000",
                        "longitude": "21.16782000"
                    },
                    {
                        "id": 66920,
                        "name": "Lieģi",
                        "latitude": "56.58173000",
                        "longitude": "21.33399000"
                    },
                    {
                        "id": 66934,
                        "name": "Nīca",
                        "latitude": "56.34601000",
                        "longitude": "21.06401000"
                    },
                    {
                        "id": 66944,
                        "name": "Pāvilosta",
                        "latitude": "56.88791000",
                        "longitude": "21.18593000"
                    },
                    {
                        "id": 66942,
                        "name": "Priekule",
                        "latitude": "56.44679000",
                        "longitude": "21.58968000"
                    },
                    {
                        "id": 66951,
                        "name": "Rucava",
                        "latitude": "56.16314000",
                        "longitude": "21.16156000"
                    },
                    {
                        "id": 66975,
                        "name": "Vaiņode",
                        "latitude": "56.41848000",
                        "longitude": "21.85405000"
                    }
                ]
            },
            {
                "id": 4437,
                "name": "Dobele",
                "iso2": "026",
                "latitude": "56.62630500",
                "longitude": "23.28090660",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66877,
                        "name": "Auce",
                        "latitude": "56.45981000",
                        "longitude": "22.90169000"
                    },
                    {
                        "id": 66892,
                        "name": "Dobele",
                        "latitude": "56.62372000",
                        "longitude": "23.27510000"
                    },
                    {
                        "id": 66972,
                        "name": "Tērvete",
                        "latitude": "56.47989000",
                        "longitude": "23.38895000"
                    },
                    {
                        "id": 66988,
                        "name": "Zelmeņi",
                        "latitude": "56.45167000",
                        "longitude": "23.35194000"
                    }
                ]
            },
            {
                "id": 4400,
                "name": "Gulbene",
                "iso2": "033",
                "latitude": "57.21556450",
                "longitude": "26.64529550",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66897,
                        "name": "Gulbene",
                        "latitude": "57.17767000",
                        "longitude": "26.75291000"
                    }
                ]
            },
            {
                "id": 4438,
                "name": "Jēkabpils",
                "iso2": "042",
                "latitude": "56.29193200",
                "longitude": "25.98120170",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66872,
                        "name": "Aknīste",
                        "latitude": "56.16152000",
                        "longitude": "25.74783000"
                    },
                    {
                        "id": 66908,
                        "name": "Jēkabpils",
                        "latitude": "56.49903000",
                        "longitude": "25.85735000"
                    },
                    {
                        "id": 66914,
                        "name": "Krustpils",
                        "latitude": "56.51068000",
                        "longitude": "25.86117000"
                    },
                    {
                        "id": 66985,
                        "name": "Viesīte",
                        "latitude": "56.34751000",
                        "longitude": "25.55514000"
                    }
                ]
            },
            {
                "id": 4424,
                "name": "Jelgava",
                "iso2": "041",
                "latitude": "56.58956890",
                "longitude": "23.66104810",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66937,
                        "name": "Ozolnieki",
                        "latitude": "56.68986000",
                        "longitude": "23.77610000"
                    },
                    {
                        "id": 66973,
                        "name": "Tīreļi",
                        "latitude": "56.83991000",
                        "longitude": "23.58902000"
                    }
                ]
            },
            {
                "id": 4500,
                "name": "Jelgava",
                "iso2": "JEL",
                "latitude": "56.65110910",
                "longitude": "23.72135410",
                "type": "state city",
                "cities": [
                    {
                        "id": 66906,
                        "name": "Jelgava",
                        "latitude": "56.65000000",
                        "longitude": "23.71278000"
                    }
                ]
            },
            {
                "id": 4446,
                "name": "Jūrmala",
                "iso2": "JUR",
                "latitude": "56.94707900",
                "longitude": "23.61684850",
                "type": "state city",
                "cities": [
                    {
                        "id": 66909,
                        "name": "Jūrmala",
                        "latitude": "56.96800000",
                        "longitude": "23.77038000"
                    }
                ]
            },
            {
                "id": 4435,
                "name": "Ķekava",
                "iso2": "052",
                "latitude": "56.80643510",
                "longitude": "24.19394930",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66878,
                        "name": "Baldone",
                        "latitude": "56.74451000",
                        "longitude": "24.40078000"
                    },
                    {
                        "id": 66879,
                        "name": "Baloži",
                        "latitude": "56.87643000",
                        "longitude": "24.11825000"
                    },
                    {
                        "id": 66992,
                        "name": "Ķekava",
                        "latitude": "56.82662000",
                        "longitude": "24.23000000"
                    }
                ]
            },
            {
                "id": 4474,
                "name": "Krāslava",
                "iso2": "047",
                "latitude": "55.89514640",
                "longitude": "27.18145770",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66889,
                        "name": "Dagda",
                        "latitude": "56.09512000",
                        "longitude": "27.53723000"
                    },
                    {
                        "id": 66915,
                        "name": "Krāslava",
                        "latitude": "55.89514000",
                        "longitude": "27.16799000"
                    }
                ]
            },
            {
                "id": 4490,
                "name": "Kuldīga",
                "iso2": "050",
                "latitude": "56.96872570",
                "longitude": "21.96137390",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66874,
                        "name": "Alsunga",
                        "latitude": "56.98194000",
                        "longitude": "21.55938000"
                    },
                    {
                        "id": 66916,
                        "name": "Kuldīga",
                        "latitude": "56.97399000",
                        "longitude": "21.95721000"
                    },
                    {
                        "id": 66962,
                        "name": "Skrunda",
                        "latitude": "56.67749000",
                        "longitude": "22.01649000"
                    }
                ]
            },
            {
                "id": 4460,
                "name": "Liepāja",
                "iso2": "LPX",
                "latitude": "56.50466780",
                "longitude": "21.01080600",
                "type": "state city",
                "cities": [
                    {
                        "id": 66911,
                        "name": "Karosta",
                        "latitude": "56.55128000",
                        "longitude": "21.01287000"
                    },
                    {
                        "id": 66919,
                        "name": "Liepāja",
                        "latitude": "56.50474000",
                        "longitude": "21.01085000"
                    }
                ]
            },
            {
                "id": 4418,
                "name": "Limbaži",
                "iso2": "054",
                "latitude": "57.54032270",
                "longitude": "24.71344510",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66869,
                        "name": "Ainaži",
                        "latitude": "57.86348000",
                        "longitude": "24.35853000"
                    },
                    {
                        "id": 66873,
                        "name": "Aloja",
                        "latitude": "57.76723000",
                        "longitude": "24.87743000"
                    },
                    {
                        "id": 66921,
                        "name": "Limbaži",
                        "latitude": "57.51287000",
                        "longitude": "24.71941000"
                    },
                    {
                        "id": 66956,
                        "name": "Salacgrīva",
                        "latitude": "57.75312000",
                        "longitude": "24.35895000"
                    },
                    {
                        "id": 66966,
                        "name": "Staicele",
                        "latitude": "57.83579000",
                        "longitude": "24.74706000"
                    }
                ]
            },
            {
                "id": 4401,
                "name": "Līvāni",
                "iso2": "056",
                "latitude": "56.35509420",
                "longitude": "26.17251900",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66925,
                        "name": "Līvāni",
                        "latitude": "56.35431000",
                        "longitude": "26.17579000"
                    }
                ]
            },
            {
                "id": 4501,
                "name": "Ludza",
                "iso2": "058",
                "latitude": "56.54595900",
                "longitude": "27.71431990",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66887,
                        "name": "Cibla",
                        "latitude": "56.54980000",
                        "longitude": "27.88370000"
                    },
                    {
                        "id": 66917,
                        "name": "Kārsava",
                        "latitude": "56.78405000",
                        "longitude": "27.68829000"
                    },
                    {
                        "id": 66923,
                        "name": "Ludza",
                        "latitude": "56.53958000",
                        "longitude": "27.71891000"
                    },
                    {
                        "id": 66989,
                        "name": "Zilupe",
                        "latitude": "56.38616000",
                        "longitude": "28.12165000"
                    }
                ]
            },
            {
                "id": 4433,
                "name": "Madona",
                "iso2": "059",
                "latitude": "56.85989230",
                "longitude": "26.22762010",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66886,
                        "name": "Cesvaine",
                        "latitude": "56.96754000",
                        "longitude": "26.30764000"
                    },
                    {
                        "id": 66990,
                        "name": "Ērgļi",
                        "latitude": "56.89752000",
                        "longitude": "25.63668000"
                    },
                    {
                        "id": 66922,
                        "name": "Lubāna",
                        "latitude": "56.90425000",
                        "longitude": "26.71606000"
                    },
                    {
                        "id": 66926,
                        "name": "Madona",
                        "latitude": "56.85329000",
                        "longitude": "26.21698000"
                    }
                ]
            },
            {
                "id": 4450,
                "name": "Mārupe",
                "iso2": "062",
                "latitude": "56.89657170",
                "longitude": "24.04600490",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66930,
                        "name": "Mārupe",
                        "latitude": "56.90544000",
                        "longitude": "24.05113000"
                    },
                    {
                        "id": 66940,
                        "name": "Piņķi",
                        "latitude": "56.94189000",
                        "longitude": "23.91365000"
                    }
                ]
            },
            {
                "id": 4416,
                "name": "Ogre",
                "iso2": "067",
                "latitude": "56.81473550",
                "longitude": "24.60445550",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66899,
                        "name": "Ikšķile",
                        "latitude": "56.83399000",
                        "longitude": "24.49679000"
                    },
                    {
                        "id": 66907,
                        "name": "Jumprava",
                        "latitude": "56.67613000",
                        "longitude": "24.97210000"
                    },
                    {
                        "id": 66991,
                        "name": "Ķegums",
                        "latitude": "56.74510000",
                        "longitude": "24.72439000"
                    },
                    {
                        "id": 66918,
                        "name": "Lielvārde",
                        "latitude": "56.72066000",
                        "longitude": "24.80743000"
                    },
                    {
                        "id": 66935,
                        "name": "Ogre",
                        "latitude": "56.81620000",
                        "longitude": "24.61401000"
                    }
                ]
            },
            {
                "id": 4417,
                "name": "Olaine",
                "iso2": "068",
                "latitude": "56.79523530",
                "longitude": "24.01535890",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66936,
                        "name": "Olaine",
                        "latitude": "56.79472000",
                        "longitude": "23.93580000"
                    }
                ]
            },
            {
                "id": 4483,
                "name": "Preiļi",
                "iso2": "073",
                "latitude": "56.15111570",
                "longitude": "26.74397670",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66868,
                        "name": "Aglona",
                        "latitude": "56.13274000",
                        "longitude": "27.00682000"
                    },
                    {
                        "id": 66902,
                        "name": "Jaunaglona",
                        "latitude": "56.16066000",
                        "longitude": "27.00714000"
                    },
                    {
                        "id": 66941,
                        "name": "Preiļi",
                        "latitude": "56.29444000",
                        "longitude": "26.72459000"
                    },
                    {
                        "id": 66947,
                        "name": "Riebiņi",
                        "latitude": "56.34280000",
                        "longitude": "26.79995000"
                    },
                    {
                        "id": 66983,
                        "name": "Vecvārkava",
                        "latitude": "56.19838000",
                        "longitude": "26.50811000"
                    }
                ]
            },
            {
                "id": 4509,
                "name": "Rēzekne",
                "iso2": "REZ",
                "latitude": "56.50992230",
                "longitude": "27.33313570",
                "type": "state city",
                "cities": [
                    {
                        "id": 66953,
                        "name": "Rēzekne",
                        "latitude": "56.51028000",
                        "longitude": "27.34000000"
                    }
                ]
            },
            {
                "id": 4455,
                "name": "Rēzekne",
                "iso2": "077",
                "latitude": "56.32736380",
                "longitude": "27.32843310",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66987,
                        "name": "Viļāni",
                        "latitude": "56.55253000",
                        "longitude": "26.92449000"
                    }
                ]
            },
            {
                "id": 4491,
                "name": "Riga",
                "iso2": "RIX",
                "latitude": "56.94964870",
                "longitude": "24.10518650",
                "type": "state city",
                "cities": [
                    {
                        "id": 66883,
                        "name": "Bolderaja",
                        "latitude": "57.03132000",
                        "longitude": "24.05571000"
                    },
                    {
                        "id": 66890,
                        "name": "Daugavgrīva",
                        "latitude": "57.04315000",
                        "longitude": "24.03613000"
                    },
                    {
                        "id": 66903,
                        "name": "Jaunciems",
                        "latitude": "57.03910000",
                        "longitude": "24.17413000"
                    },
                    {
                        "id": 66928,
                        "name": "Mežaparks",
                        "latitude": "57.00008000",
                        "longitude": "24.15997000"
                    },
                    {
                        "id": 66948,
                        "name": "Riga",
                        "latitude": "56.94600000",
                        "longitude": "24.10589000"
                    }
                ]
            },
            {
                "id": 4493,
                "name": "Ropaži",
                "iso2": "080",
                "latitude": "56.96157860",
                "longitude": "24.60104760",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66895,
                        "name": "Garkalne",
                        "latitude": "57.04486000",
                        "longitude": "24.41951000"
                    },
                    {
                        "id": 66950,
                        "name": "Ropaži",
                        "latitude": "56.97470000",
                        "longitude": "24.63295000"
                    },
                    {
                        "id": 66974,
                        "name": "Ulbroka",
                        "latitude": "56.93630000",
                        "longitude": "24.30387000"
                    },
                    {
                        "id": 66979,
                        "name": "Vangaži",
                        "latitude": "57.09358000",
                        "longitude": "24.54468000"
                    }
                ]
            },
            {
                "id": 4402,
                "name": "Salaspils",
                "iso2": "087",
                "latitude": "56.86081520",
                "longitude": "24.34978810",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66957,
                        "name": "Salaspils",
                        "latitude": "56.86014000",
                        "longitude": "24.36544000"
                    }
                ]
            },
            {
                "id": 4439,
                "name": "Saldus",
                "iso2": "088",
                "latitude": "56.66650880",
                "longitude": "22.49354930",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66884,
                        "name": "Brocēni",
                        "latitude": "56.67890000",
                        "longitude": "22.56945000"
                    },
                    {
                        "id": 66958,
                        "name": "Saldus",
                        "latitude": "56.66363000",
                        "longitude": "22.48807000"
                    }
                ]
            },
            {
                "id": 4443,
                "name": "Saulkrasti",
                "iso2": "089",
                "latitude": "57.25794180",
                "longitude": "24.41831460",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66959,
                        "name": "Saulkrasti",
                        "latitude": "57.26224000",
                        "longitude": "24.41471000"
                    }
                ]
            },
            {
                "id": 4476,
                "name": "Sigulda",
                "iso2": "091",
                "latitude": "57.10550920",
                "longitude": "24.83142590",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66901,
                        "name": "Inčukalns",
                        "latitude": "57.09867000",
                        "longitude": "24.68630000"
                    },
                    {
                        "id": 66929,
                        "name": "Mālpils",
                        "latitude": "57.01010000",
                        "longitude": "24.95783000"
                    },
                    {
                        "id": 66961,
                        "name": "Sigulda",
                        "latitude": "57.15375000",
                        "longitude": "24.85953000"
                    }
                ]
            },
            {
                "id": 4462,
                "name": "Smiltene",
                "iso2": "094",
                "latitude": "57.42303320",
                "longitude": "25.90027800",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66876,
                        "name": "Ape",
                        "latitude": "57.53928000",
                        "longitude": "26.69291000"
                    },
                    {
                        "id": 66946,
                        "name": "Rauna",
                        "latitude": "57.33173000",
                        "longitude": "25.60947000"
                    },
                    {
                        "id": 66964,
                        "name": "Smiltene",
                        "latitude": "57.42444000",
                        "longitude": "25.90164000"
                    }
                ]
            },
            {
                "id": 4459,
                "name": "Talsi",
                "iso2": "097",
                "latitude": "57.34152080",
                "longitude": "22.57131250",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66893,
                        "name": "Dundaga",
                        "latitude": "57.50498000",
                        "longitude": "22.35041000"
                    },
                    {
                        "id": 66949,
                        "name": "Roja",
                        "latitude": "57.50146000",
                        "longitude": "22.80881000"
                    },
                    {
                        "id": 66955,
                        "name": "Sabile",
                        "latitude": "57.04577000",
                        "longitude": "22.57261000"
                    },
                    {
                        "id": 66968,
                        "name": "Stende",
                        "latitude": "57.14497000",
                        "longitude": "22.53482000"
                    },
                    {
                        "id": 66970,
                        "name": "Talsi",
                        "latitude": "57.24562000",
                        "longitude": "22.58137000"
                    },
                    {
                        "id": 66976,
                        "name": "Valdemārpils",
                        "latitude": "57.37068000",
                        "longitude": "22.59188000"
                    }
                ]
            },
            {
                "id": 4409,
                "name": "Tukums",
                "iso2": "099",
                "latitude": "56.96728680",
                "longitude": "23.15243790",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66894,
                        "name": "Engure",
                        "latitude": "57.16061000",
                        "longitude": "23.22527000"
                    },
                    {
                        "id": 66905,
                        "name": "Jaunpils",
                        "latitude": "56.73137000",
                        "longitude": "23.01247000"
                    },
                    {
                        "id": 66910,
                        "name": "Kandava",
                        "latitude": "57.04087000",
                        "longitude": "22.77466000"
                    },
                    {
                        "id": 66965,
                        "name": "Smārde",
                        "latitude": "56.95420000",
                        "longitude": "23.33736000"
                    },
                    {
                        "id": 66971,
                        "name": "Tukums",
                        "latitude": "56.96764000",
                        "longitude": "23.15554000"
                    }
                ]
            },
            {
                "id": 4425,
                "name": "Valka",
                "iso2": "101",
                "latitude": "57.77439000",
                "longitude": "26.01700500",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66977,
                        "name": "Valka",
                        "latitude": "57.77520000",
                        "longitude": "26.01013000"
                    }
                ]
            },
            {
                "id": 4473,
                "name": "Valmiera",
                "iso2": "113",
                "latitude": "57.53846590",
                "longitude": "25.42636180",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66912,
                        "name": "Kocēni",
                        "latitude": "57.52057000",
                        "longitude": "25.33821000"
                    },
                    {
                        "id": 66927,
                        "name": "Mazsalaca",
                        "latitude": "57.86329000",
                        "longitude": "25.05475000"
                    },
                    {
                        "id": 66931,
                        "name": "Mūrmuiža",
                        "latitude": "57.47312000",
                        "longitude": "25.49174000"
                    },
                    {
                        "id": 66932,
                        "name": "Naukšēni",
                        "latitude": "57.88349000",
                        "longitude": "25.45609000"
                    },
                    {
                        "id": 66954,
                        "name": "Rūjiena",
                        "latitude": "57.89752000",
                        "longitude": "25.33155000"
                    },
                    {
                        "id": 66960,
                        "name": "Seda",
                        "latitude": "57.65042000",
                        "longitude": "25.75089000"
                    },
                    {
                        "id": 66969,
                        "name": "Strenči",
                        "latitude": "57.62574000",
                        "longitude": "25.68535000"
                    },
                    {
                        "id": 66978,
                        "name": "Valmiera",
                        "latitude": "57.54108000",
                        "longitude": "25.42751000"
                    }
                ]
            },
            {
                "id": 4431,
                "name": "Varakļāni",
                "iso2": "102",
                "latitude": "56.66880060",
                "longitude": "26.56364140",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66980,
                        "name": "Varakļāni",
                        "latitude": "56.60826000",
                        "longitude": "26.75377000"
                    }
                ]
            },
            {
                "id": 4421,
                "name": "Ventspils",
                "iso2": "VEN",
                "latitude": "57.39372160",
                "longitude": "21.56470660",
                "type": "state city",
                "cities": [
                    {
                        "id": 66984,
                        "name": "Ventspils",
                        "latitude": "57.38988000",
                        "longitude": "21.57288000"
                    }
                ]
            },
            {
                "id": 4403,
                "name": "Ventspils",
                "iso2": "106",
                "latitude": "57.28336820",
                "longitude": "21.85875580",
                "type": "municipality",
                "cities": [
                    {
                        "id": 66939,
                        "name": "Piltene",
                        "latitude": "57.22426000",
                        "longitude": "21.67439000"
                    }
                ]
            }
        ]
    },
    {
        "id": 121,
        "name": "Lebanon",
        "iso3": "LBN",
        "iso2": "LB",
        "numeric_code": "422",
        "phonecode": "961",
        "capital": "Beirut",
        "currency": "LBP",
        "currency_name": "Lebanese pound",
        "currency_symbol": "£",
        "tld": ".lb",
        "native": "لبنان",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Lebanese",
        "timezones": [
            {
                "zoneName": "Asia\/Beirut",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Liban",
            "ko": "레바논",
            "pt-BR": "Líbano",
            "pt": "Líbano",
            "nl": "Libanon",
            "hr": "Libanon",
            "fa": "لبنان",
            "de": "Libanon",
            "es": "Líbano",
            "fr": "Liban",
            "ja": "レバノン",
            "it": "Libano",
            "zh-CN": "黎巴嫩",
            "tr": "Lübnan",
            "ru": "Ливан",
            "uk": "Ліван",
            "pl": "Liban"
        },
        "latitude": "33.83333333",
        "longitude": "35.83333333",
        "emoji": "🇱🇧",
        "emojiU": "U+1F1F1 U+1F1E7",
        "states": [
            {
                "id": 2285,
                "name": "Akkar",
                "iso2": "AK",
                "latitude": "34.53287630",
                "longitude": "36.13281320",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65939,
                        "name": "Caza de Aakkar",
                        "latitude": "34.53333000",
                        "longitude": "36.16667000"
                    }
                ]
            },
            {
                "id": 2283,
                "name": "Baalbek-Hermel",
                "iso2": "BH",
                "latitude": "34.26585560",
                "longitude": "36.34980970",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65933,
                        "name": "Baalbek",
                        "latitude": "34.00583000",
                        "longitude": "36.21806000"
                    },
                    {
                        "id": 65941,
                        "name": "Caza de Baalbek",
                        "latitude": "34.09822000",
                        "longitude": "36.27157000"
                    }
                ]
            },
            {
                "id": 2286,
                "name": "Beirut",
                "iso2": "BA",
                "latitude": "33.88861060",
                "longitude": "35.49547720",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65936,
                        "name": "Beirut",
                        "latitude": "33.89332000",
                        "longitude": "35.50157000"
                    },
                    {
                        "id": 65951,
                        "name": "Ra’s Bayrūt",
                        "latitude": "33.90000000",
                        "longitude": "35.48333000"
                    }
                ]
            },
            {
                "id": 2287,
                "name": "Beqaa",
                "iso2": "BI",
                "latitude": "33.84626620",
                "longitude": "35.90194890",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65930,
                        "name": "Aanjar",
                        "latitude": "33.72778000",
                        "longitude": "35.93111000"
                    },
                    {
                        "id": 65955,
                        "name": "Zahlé",
                        "latitude": "33.84675000",
                        "longitude": "35.90203000"
                    }
                ]
            },
            {
                "id": 2282,
                "name": "Mount Lebanon",
                "iso2": "JL",
                "latitude": "33.81008580",
                "longitude": "35.59731390",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65932,
                        "name": "Baabda",
                        "latitude": "33.83389000",
                        "longitude": "35.54417000"
                    },
                    {
                        "id": 65937,
                        "name": "Bhamdoun",
                        "latitude": "33.79500000",
                        "longitude": "35.65111000"
                    },
                    {
                        "id": 65938,
                        "name": "Bhamdoûn el Mhatta",
                        "latitude": "33.80861000",
                        "longitude": "35.65972000"
                    },
                    {
                        "id": 65940,
                        "name": "Caza de Baabda",
                        "latitude": "33.84592000",
                        "longitude": "35.66791000"
                    },
                    {
                        "id": 65947,
                        "name": "Jbaïl",
                        "latitude": "34.12111000",
                        "longitude": "35.64806000"
                    },
                    {
                        "id": 65948,
                        "name": "Jounieh",
                        "latitude": "33.98083000",
                        "longitude": "35.61778000"
                    }
                ]
            },
            {
                "id": 2288,
                "name": "Nabatieh",
                "iso2": "NA",
                "latitude": "33.37716930",
                "longitude": "35.48382930",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65931,
                        "name": "Ain Ebel",
                        "latitude": "33.11023000",
                        "longitude": "35.40251000"
                    },
                    {
                        "id": 65942,
                        "name": "Caza de Bent Jbaïl",
                        "latitude": "33.15964000",
                        "longitude": "35.41137000"
                    },
                    {
                        "id": 65943,
                        "name": "Caza de Nabatîyé",
                        "latitude": "33.39435000",
                        "longitude": "35.44483000"
                    },
                    {
                        "id": 65946,
                        "name": "Habboûch",
                        "latitude": "33.40729000",
                        "longitude": "35.48169000"
                    },
                    {
                        "id": 65949,
                        "name": "Marjayoûn",
                        "latitude": "33.36028000",
                        "longitude": "35.59111000"
                    },
                    {
                        "id": 65950,
                        "name": "Nabatîyé et Tahta",
                        "latitude": "33.37889000",
                        "longitude": "35.48389000"
                    }
                ]
            },
            {
                "id": 2284,
                "name": "North",
                "iso2": "AS",
                "latitude": "34.43806250",
                "longitude": "35.83082330",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65934,
                        "name": "Batroûn",
                        "latitude": "34.25528000",
                        "longitude": "35.65806000"
                    },
                    {
                        "id": 65935,
                        "name": "Bcharré",
                        "latitude": "34.25083000",
                        "longitude": "36.01056000"
                    },
                    {
                        "id": 65953,
                        "name": "Tripoli",
                        "latitude": "34.43352000",
                        "longitude": "35.84415000"
                    }
                ]
            },
            {
                "id": 2281,
                "name": "South",
                "iso2": "JA",
                "latitude": "33.27214790",
                "longitude": "35.20327780",
                "type": "governorate",
                "cities": [
                    {
                        "id": 65944,
                        "name": "En Nâqoûra",
                        "latitude": "33.11806000",
                        "longitude": "35.13972000"
                    },
                    {
                        "id": 65945,
                        "name": "Ghazieh",
                        "latitude": "33.51750000",
                        "longitude": "35.36889000"
                    },
                    {
                        "id": 65952,
                        "name": "Sidon",
                        "latitude": "33.55751000",
                        "longitude": "35.37148000"
                    },
                    {
                        "id": 65954,
                        "name": "Tyre",
                        "latitude": "33.27333000",
                        "longitude": "35.19389000"
                    }
                ]
            }
        ]
    },
    {
        "id": 122,
        "name": "Lesotho",
        "iso3": "LSO",
        "iso2": "LS",
        "numeric_code": "426",
        "phonecode": "266",
        "capital": "Maseru",
        "currency": "LSL",
        "currency_name": "Lesotho loti",
        "currency_symbol": "L",
        "tld": ".ls",
        "native": "Lesotho",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Southern Africa",
        "subregion_id": 5,
        "nationality": "Basotho",
        "timezones": [
            {
                "zoneName": "Africa\/Maseru",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "SAST",
                "tzName": "South African Standard Time"
            }
        ],
        "translations": {
            "br": "Lesotho",
            "ko": "레소토",
            "pt-BR": "Lesoto",
            "pt": "Lesoto",
            "nl": "Lesotho",
            "hr": "Lesoto",
            "fa": "لسوتو",
            "de": "Lesotho",
            "es": "Lesotho",
            "fr": "Lesotho",
            "ja": "レソト",
            "it": "Lesotho",
            "zh-CN": "莱索托",
            "tr": "Lesotho",
            "ru": "Лесото",
            "uk": "Лесото",
            "pl": "Lesotho"
        },
        "latitude": "-29.50000000",
        "longitude": "28.50000000",
        "emoji": "🇱🇸",
        "emojiU": "U+1F1F1 U+1F1F8",
        "states": [
            {
                "id": 3030,
                "name": "Berea",
                "iso2": "D",
                "latitude": "41.36616140",
                "longitude": "-81.85430260",
                "type": "district",
                "cities": [
                    {
                        "id": 66574,
                        "name": "Teyateyaneng",
                        "latitude": "-29.14719000",
                        "longitude": "27.74895000"
                    }
                ]
            },
            {
                "id": 3029,
                "name": "Butha-Buthe",
                "iso2": "B",
                "latitude": "-28.76537540",
                "longitude": "28.24681480",
                "type": "district",
                "cities": [
                    {
                        "id": 66564,
                        "name": "Butha-Buthe",
                        "latitude": "-28.76659000",
                        "longitude": "28.24937000"
                    }
                ]
            },
            {
                "id": 3026,
                "name": "Leribe",
                "iso2": "C",
                "latitude": "-28.86380650",
                "longitude": "28.04788260",
                "type": "district",
                "cities": [
                    {
                        "id": 66565,
                        "name": "Leribe",
                        "latitude": "-28.87185000",
                        "longitude": "28.04501000"
                    },
                    {
                        "id": 66567,
                        "name": "Maputsoe",
                        "latitude": "-28.88660000",
                        "longitude": "27.89915000"
                    }
                ]
            },
            {
                "id": 3022,
                "name": "Mafeteng",
                "iso2": "E",
                "latitude": "-29.80410080",
                "longitude": "27.50261740",
                "type": "district",
                "cities": [
                    {
                        "id": 66566,
                        "name": "Mafeteng",
                        "latitude": "-29.82299000",
                        "longitude": "27.23744000"
                    }
                ]
            },
            {
                "id": 3028,
                "name": "Maseru",
                "iso2": "A",
                "latitude": "-29.51656500",
                "longitude": "27.83114280",
                "type": "district",
                "cities": [
                    {
                        "id": 66568,
                        "name": "Maseru",
                        "latitude": "-29.31667000",
                        "longitude": "27.48333000"
                    },
                    {
                        "id": 66571,
                        "name": "Nako",
                        "latitude": "-29.61667000",
                        "longitude": "27.76667000"
                    }
                ]
            },
            {
                "id": 3023,
                "name": "Mohale's Hoek",
                "iso2": "F",
                "latitude": "-30.14259170",
                "longitude": "27.46738450",
                "type": "district",
                "cities": [
                    {
                        "id": 66569,
                        "name": "Mohale’s Hoek",
                        "latitude": "-30.15137000",
                        "longitude": "27.47691000"
                    }
                ]
            },
            {
                "id": 3024,
                "name": "Mokhotlong",
                "iso2": "J",
                "latitude": "-29.25731930",
                "longitude": "28.95286450",
                "type": "district",
                "cities": [
                    {
                        "id": 66570,
                        "name": "Mokhotlong",
                        "latitude": "-29.28939000",
                        "longitude": "29.06751000"
                    }
                ]
            },
            {
                "id": 3025,
                "name": "Qacha's Nek",
                "iso2": "H",
                "latitude": "-30.11145650",
                "longitude": "28.67897900",
                "type": "district",
                "cities": [
                    {
                        "id": 66572,
                        "name": "Qacha’s Nek",
                        "latitude": "-30.11537000",
                        "longitude": "28.68936000"
                    }
                ]
            },
            {
                "id": 3027,
                "name": "Quthing",
                "iso2": "G",
                "latitude": "-30.40156870",
                "longitude": "27.70801330",
                "type": "district",
                "cities": [
                    {
                        "id": 66573,
                        "name": "Quthing",
                        "latitude": "-30.40001000",
                        "longitude": "27.70027000"
                    }
                ]
            },
            {
                "id": 3031,
                "name": "Thaba-Tseka",
                "iso2": "K",
                "latitude": "-29.52389750",
                "longitude": "28.60897520",
                "type": "district",
                "cities": [
                    {
                        "id": 66575,
                        "name": "Thaba-Tseka",
                        "latitude": "-29.52204000",
                        "longitude": "28.60840000"
                    }
                ]
            }
        ]
    },
    {
        "id": 123,
        "name": "Liberia",
        "iso3": "LBR",
        "iso2": "LR",
        "numeric_code": "430",
        "phonecode": "231",
        "capital": "Monrovia",
        "currency": "LRD",
        "currency_name": "Liberian dollar",
        "currency_symbol": "$",
        "tld": ".lr",
        "native": "Liberia",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Liberian",
        "timezones": [
            {
                "zoneName": "Africa\/Monrovia",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Liberia",
            "ko": "라이베리아",
            "pt-BR": "Libéria",
            "pt": "Libéria",
            "nl": "Liberia",
            "hr": "Liberija",
            "fa": "لیبریا",
            "de": "Liberia",
            "es": "Liberia",
            "fr": "Liberia",
            "ja": "リベリア",
            "it": "Liberia",
            "zh-CN": "利比里亚",
            "tr": "Liberya",
            "ru": "Либерия",
            "uk": "Ліберія",
            "pl": "Liberia"
        },
        "latitude": "6.50000000",
        "longitude": "-9.50000000",
        "emoji": "🇱🇷",
        "emojiU": "U+1F1F1 U+1F1F7",
        "states": [
            {
                "id": 3041,
                "name": "Bomi",
                "iso2": "BM",
                "latitude": "6.75629260",
                "longitude": "-10.84514670",
                "type": "county",
                "cities": [
                    {
                        "id": 66561,
                        "name": "Tubmanburg",
                        "latitude": "6.87064000",
                        "longitude": "-10.82110000"
                    }
                ]
            },
            {
                "id": 3034,
                "name": "Bong",
                "iso2": "BG",
                "latitude": "6.82950190",
                "longitude": "-9.36730840",
                "type": "county",
                "cities": [
                    {
                        "id": 66553,
                        "name": "Gbarnga",
                        "latitude": "6.99543000",
                        "longitude": "-9.47122000"
                    }
                ]
            },
            {
                "id": 3044,
                "name": "Gbarpolu",
                "iso2": "GP",
                "latitude": "7.49526370",
                "longitude": "-10.08072980",
                "type": "county",
                "cities": [
                    {
                        "id": 66548,
                        "name": "Bopolu",
                        "latitude": "7.06667000",
                        "longitude": "-10.48750000"
                    }
                ]
            },
            {
                "id": 3040,
                "name": "Grand Bassa",
                "iso2": "GB",
                "latitude": "6.23084520",
                "longitude": "-9.81249350",
                "type": "county",
                "cities": [
                    {
                        "id": 66549,
                        "name": "Buchanan",
                        "latitude": "5.87693000",
                        "longitude": "-10.04964000"
                    }
                ]
            },
            {
                "id": 3036,
                "name": "Grand Cape Mount",
                "iso2": "CM",
                "latitude": "7.04677580",
                "longitude": "-11.07117580",
                "type": "county",
                "cities": [
                    {
                        "id": 66559,
                        "name": "Robertsport",
                        "latitude": "6.75329000",
                        "longitude": "-11.36710000"
                    }
                ]
            },
            {
                "id": 3039,
                "name": "Grand Gedeh",
                "iso2": "GG",
                "latitude": "5.92220780",
                "longitude": "-8.22129790",
                "type": "county",
                "cities": [
                    {
                        "id": 66563,
                        "name": "Zwedru",
                        "latitude": "6.06846000",
                        "longitude": "-8.13559000"
                    }
                ]
            },
            {
                "id": 3045,
                "name": "Grand Kru",
                "iso2": "GK",
                "latitude": "4.76138620",
                "longitude": "-8.22129790",
                "type": "county",
                "cities": [
                    {
                        "id": 66546,
                        "name": "Barclayville",
                        "latitude": "4.67443000",
                        "longitude": "-8.23306000"
                    }
                ]
            },
            {
                "id": 3037,
                "name": "Lofa",
                "iso2": "LO",
                "latitude": "8.19111840",
                "longitude": "-9.72326730",
                "type": "county",
                "cities": [
                    {
                        "id": 66562,
                        "name": "Voinjama",
                        "latitude": "8.42194000",
                        "longitude": "-9.74778000"
                    }
                ]
            },
            {
                "id": 3043,
                "name": "Margibi",
                "iso2": "MG",
                "latitude": "6.51518750",
                "longitude": "-10.30488970",
                "type": "county",
                "cities": [
                    {
                        "id": 66556,
                        "name": "Kakata",
                        "latitude": "6.53104000",
                        "longitude": "-10.35368000"
                    }
                ]
            },
            {
                "id": 3042,
                "name": "Maryland",
                "iso2": "MY",
                "latitude": "4.74882990",
                "longitude": "-8.13911270",
                "type": "county",
                "cities": [
                    {
                        "id": 66555,
                        "name": "Harper",
                        "latitude": "4.37820000",
                        "longitude": "-7.71081000"
                    }
                ]
            },
            {
                "id": 3032,
                "name": "Montserrado",
                "iso2": "MO",
                "latitude": "6.55258150",
                "longitude": "-10.52961150",
                "type": "county",
                "cities": [
                    {
                        "id": 66547,
                        "name": "Bensonville",
                        "latitude": "6.44716000",
                        "longitude": "-10.61283000"
                    },
                    {
                        "id": 66557,
                        "name": "Monrovia",
                        "latitude": "6.30054000",
                        "longitude": "-10.79690000"
                    }
                ]
            },
            {
                "id": 3046,
                "name": "Nimba",
                "iso2": "NI",
                "latitude": "7.61666670",
                "longitude": "-8.41666670",
                "type": "county",
                "cities": [
                    {
                        "id": 66552,
                        "name": "Ganta",
                        "latitude": "7.30222000",
                        "longitude": "-8.53083000"
                    },
                    {
                        "id": 66558,
                        "name": "New Yekepa",
                        "latitude": "7.57944000",
                        "longitude": "-8.53778000"
                    },
                    {
                        "id": 66560,
                        "name": "Sanniquellie",
                        "latitude": "7.36215000",
                        "longitude": "-8.71326000"
                    }
                ]
            },
            {
                "id": 3033,
                "name": "River Cess",
                "iso2": "RI",
                "latitude": "5.90253280",
                "longitude": "-9.45615500",
                "type": "county",
                "cities": [
                    {
                        "id": 66550,
                        "name": "Cestos City",
                        "latitude": "5.45683000",
                        "longitude": "-9.58167000"
                    }
                ]
            },
            {
                "id": 3038,
                "name": "River Gee",
                "iso2": "RG",
                "latitude": "5.26048940",
                "longitude": "-7.87216000",
                "type": "county",
                "cities": [
                    {
                        "id": 66551,
                        "name": "Fish Town",
                        "latitude": "5.19739000",
                        "longitude": "-7.87579000"
                    }
                ]
            },
            {
                "id": 3035,
                "name": "Sinoe",
                "iso2": "SI",
                "latitude": "5.49871000",
                "longitude": "-8.66005860",
                "type": "county",
                "cities": [
                    {
                        "id": 66554,
                        "name": "Greenville",
                        "latitude": "5.01133000",
                        "longitude": "-9.03880000"
                    }
                ]
            }
        ]
    },
    {
        "id": 124,
        "name": "Libya",
        "iso3": "LBY",
        "iso2": "LY",
        "numeric_code": "434",
        "phonecode": "218",
        "capital": "Tripolis",
        "currency": "LYD",
        "currency_name": "Libyan dinar",
        "currency_symbol": "د.ل",
        "tld": ".ly",
        "native": "‏ليبيا",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Northern Africa",
        "subregion_id": 1,
        "nationality": "Libyan",
        "timezones": [
            {
                "zoneName": "Africa\/Tripoli",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Libia",
            "ko": "리비아",
            "pt-BR": "Líbia",
            "pt": "Líbia",
            "nl": "Libië",
            "hr": "Libija",
            "fa": "لیبی",
            "de": "Libyen",
            "es": "Libia",
            "fr": "Libye",
            "ja": "リビア",
            "it": "Libia",
            "zh-CN": "利比亚",
            "tr": "Libya",
            "ru": "Ливия",
            "uk": "Лівія",
            "pl": "Libia"
        },
        "latitude": "25.00000000",
        "longitude": "17.00000000",
        "emoji": "🇱🇾",
        "emojiU": "U+1F1F1 U+1F1FE",
        "states": [
            {
                "id": 2964,
                "name": "Al Wahat",
                "iso2": "WA",
                "latitude": "29.04668080",
                "longitude": "21.85685860",
                "type": "popularate",
                "cities": [
                    {
                        "id": 66993,
                        "name": "Ajdabiya",
                        "latitude": "30.75545000",
                        "longitude": "20.22625000"
                    },
                    {
                        "id": 66997,
                        "name": "Al Burayqah",
                        "latitude": "30.40624000",
                        "longitude": "19.57386000"
                    },
                    {
                        "id": 67006,
                        "name": "Awjilah",
                        "latitude": "29.10806000",
                        "longitude": "21.28694000"
                    },
                    {
                        "id": 67007,
                        "name": "Az Zuwaytīnah",
                        "latitude": "30.95220000",
                        "longitude": "20.12022000"
                    },
                    {
                        "id": 67017,
                        "name": "Gialo",
                        "latitude": "29.03333000",
                        "longitude": "21.55000000"
                    },
                    {
                        "id": 67020,
                        "name": "Marādah",
                        "latitude": "29.22054000",
                        "longitude": "19.20454000"
                    }
                ]
            },
            {
                "id": 2981,
                "name": "Benghazi",
                "iso2": "BA",
                "latitude": "32.11942420",
                "longitude": "20.08679090",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67010,
                        "name": "Benghazi",
                        "latitude": "32.11486000",
                        "longitude": "20.06859000"
                    },
                    {
                        "id": 67026,
                        "name": "Qaryat Sulūq",
                        "latitude": "31.66818000",
                        "longitude": "20.25205000"
                    }
                ]
            },
            {
                "id": 2966,
                "name": "Derna",
                "iso2": "DR",
                "latitude": "32.75561300",
                "longitude": "22.63774320",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67003,
                        "name": "Al Qubbah",
                        "latitude": "32.75684000",
                        "longitude": "22.24106000"
                    },
                    {
                        "id": 67012,
                        "name": "Darnah",
                        "latitude": "32.76704000",
                        "longitude": "22.63669000"
                    }
                ]
            },
            {
                "id": 2969,
                "name": "Ghat",
                "iso2": "GT",
                "latitude": "24.96403710",
                "longitude": "10.17592850",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67015,
                        "name": "Ghat",
                        "latitude": "24.96334000",
                        "longitude": "10.18003000"
                    }
                ]
            },
            {
                "id": 2980,
                "name": "Jabal al Akhdar",
                "iso2": "JA",
                "latitude": "23.18560810",
                "longitude": "57.37138790",
                "type": "popularate",
                "cities": [
                    {
                        "id": 66996,
                        "name": "Al Bayḑā’",
                        "latitude": "32.76272000",
                        "longitude": "21.75506000"
                    }
                ]
            },
            {
                "id": 2974,
                "name": "Jabal al Gharbi",
                "iso2": "JG",
                "latitude": "30.26380320",
                "longitude": "12.80547530",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67014,
                        "name": "Gharyan",
                        "latitude": "32.17222000",
                        "longitude": "13.02028000"
                    },
                    {
                        "id": 67016,
                        "name": "Giado",
                        "latitude": "31.95506000",
                        "longitude": "12.02901000"
                    },
                    {
                        "id": 67022,
                        "name": "Mizdah",
                        "latitude": "31.44934000",
                        "longitude": "12.98530000"
                    },
                    {
                        "id": 67036,
                        "name": "Yafran",
                        "latitude": "32.06329000",
                        "longitude": "12.52859000"
                    },
                    {
                        "id": 67039,
                        "name": "Zintan",
                        "latitude": "31.93155000",
                        "longitude": "12.25291000"
                    }
                ]
            },
            {
                "id": 2979,
                "name": "Jafara",
                "iso2": "JI",
                "latitude": "32.45259040",
                "longitude": "12.94355360",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67004,
                        "name": "Al ‘Azīzīyah",
                        "latitude": "32.53194000",
                        "longitude": "13.01750000"
                    }
                ]
            },
            {
                "id": 2970,
                "name": "Jufra",
                "iso2": "JU",
                "latitude": "27.98351350",
                "longitude": "16.91225100",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67018,
                        "name": "Hūn",
                        "latitude": "29.12684000",
                        "longitude": "15.94772000"
                    },
                    {
                        "id": 67035,
                        "name": "Waddān",
                        "latitude": "29.16140000",
                        "longitude": "16.13904000"
                    }
                ]
            },
            {
                "id": 2972,
                "name": "Kufra",
                "iso2": "KF",
                "latitude": "23.31123890",
                "longitude": "21.85685860",
                "type": "popularate",
                "cities": [
                    {
                        "id": 66999,
                        "name": "Al Jawf",
                        "latitude": "24.19890000",
                        "longitude": "23.29093000"
                    },
                    {
                        "id": 67005,
                        "name": "At Tāj",
                        "latitude": "24.20487000",
                        "longitude": "23.28570000"
                    }
                ]
            },
            {
                "id": 2968,
                "name": "Marj",
                "iso2": "MJ",
                "latitude": "32.05503630",
                "longitude": "21.18911510",
                "type": "popularate",
                "cities": [
                    {
                        "id": 66994,
                        "name": "Al Abyār",
                        "latitude": "32.19000000",
                        "longitude": "20.59653000"
                    },
                    {
                        "id": 67001,
                        "name": "Al Marj",
                        "latitude": "32.49257000",
                        "longitude": "20.82909000"
                    },
                    {
                        "id": 67033,
                        "name": "Tūkrah",
                        "latitude": "32.53414000",
                        "longitude": "20.57911000"
                    }
                ]
            },
            {
                "id": 2978,
                "name": "Misrata",
                "iso2": "MI",
                "latitude": "32.32558840",
                "longitude": "15.09925560",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67009,
                        "name": "Bani Walid",
                        "latitude": "31.74554000",
                        "longitude": "13.98354000"
                    },
                    {
                        "id": 67023,
                        "name": "Mişrātah",
                        "latitude": "32.37535000",
                        "longitude": "15.09254000"
                    },
                    {
                        "id": 67040,
                        "name": "Zliten",
                        "latitude": "32.46739000",
                        "longitude": "14.56874000"
                    }
                ]
            },
            {
                "id": 2961,
                "name": "Murqub",
                "iso2": "MB",
                "latitude": "32.45996770",
                "longitude": "14.10013260",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67000,
                        "name": "Al Khums",
                        "latitude": "32.64861000",
                        "longitude": "14.26191000"
                    },
                    {
                        "id": 67021,
                        "name": "Masallātah",
                        "latitude": "32.61667000",
                        "longitude": "14.00000000"
                    },
                    {
                        "id": 67031,
                        "name": "Tarhuna",
                        "latitude": "32.43501000",
                        "longitude": "13.63320000"
                    }
                ]
            },
            {
                "id": 2967,
                "name": "Murzuq",
                "iso2": "MQ",
                "latitude": "25.91822620",
                "longitude": "13.92600010",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67002,
                        "name": "Al Qaţrūn",
                        "latitude": "24.95139000",
                        "longitude": "14.64861000"
                    },
                    {
                        "id": 67024,
                        "name": "Murzuq",
                        "latitude": "25.91552000",
                        "longitude": "13.91839000"
                    }
                ]
            },
            {
                "id": 2976,
                "name": "Nalut",
                "iso2": "NL",
                "latitude": "31.87423480",
                "longitude": "10.97504840",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67013,
                        "name": "Ghadāmis",
                        "latitude": "30.13366000",
                        "longitude": "9.50072000"
                    },
                    {
                        "id": 67025,
                        "name": "Nālūt",
                        "latitude": "31.86848000",
                        "longitude": "10.98120000"
                    }
                ]
            },
            {
                "id": 2962,
                "name": "Nuqat al Khams",
                "iso2": "NQ",
                "latitude": "32.69149090",
                "longitude": "11.88917210",
                "type": "popularate",
                "cities": [
                    {
                        "id": 66995,
                        "name": "Al Ajaylat",
                        "latitude": "32.75718000",
                        "longitude": "12.37633000"
                    },
                    {
                        "id": 67037,
                        "name": "Zalţan",
                        "latitude": "32.94699000",
                        "longitude": "11.86668000"
                    },
                    {
                        "id": 67041,
                        "name": "Zuwārah",
                        "latitude": "32.93120000",
                        "longitude": "12.08199000"
                    }
                ]
            },
            {
                "id": 2965,
                "name": "Sabha",
                "iso2": "SB",
                "latitude": "27.03654060",
                "longitude": "14.42902360",
                "type": "popularate",
                "cities": [
                    {
                        "id": 66998,
                        "name": "Al Jadīd",
                        "latitude": "27.05000000",
                        "longitude": "14.40000000"
                    },
                    {
                        "id": 67028,
                        "name": "Sabhā",
                        "latitude": "27.03766000",
                        "longitude": "14.42832000"
                    }
                ]
            },
            {
                "id": 2977,
                "name": "Sirte",
                "iso2": "SR",
                "latitude": "31.18968900",
                "longitude": "16.57019270",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67027,
                        "name": "Qasr Abu Hadi",
                        "latitude": "31.05926000",
                        "longitude": "16.65905000"
                    },
                    {
                        "id": 67029,
                        "name": "Sirte",
                        "latitude": "31.20892000",
                        "longitude": "16.58866000"
                    }
                ]
            },
            {
                "id": 2971,
                "name": "Tripoli",
                "iso2": "TB",
                "latitude": "32.64080210",
                "longitude": "13.26634790",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67030,
                        "name": "Tagiura",
                        "latitude": "32.88167000",
                        "longitude": "13.35056000"
                    },
                    {
                        "id": 67032,
                        "name": "Tripoli",
                        "latitude": "32.88743000",
                        "longitude": "13.18733000"
                    }
                ]
            },
            {
                "id": 2973,
                "name": "Wadi al Hayaa",
                "iso2": "WD",
                "latitude": "26.42259260",
                "longitude": "12.62162110",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67034,
                        "name": "Ubari",
                        "latitude": "26.59034000",
                        "longitude": "12.77511000"
                    }
                ]
            },
            {
                "id": 2975,
                "name": "Wadi al Shatii",
                "iso2": "WS",
                "latitude": "27.73514680",
                "longitude": "12.43805810",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67011,
                        "name": "Brak",
                        "latitude": "27.54956000",
                        "longitude": "14.27139000"
                    },
                    {
                        "id": 67019,
                        "name": "Idrī",
                        "latitude": "27.44707000",
                        "longitude": "13.05173000"
                    }
                ]
            },
            {
                "id": 2963,
                "name": "Zawiya",
                "iso2": "ZA",
                "latitude": "32.76302820",
                "longitude": "12.73649620",
                "type": "popularate",
                "cities": [
                    {
                        "id": 67008,
                        "name": "Az Zāwīyah",
                        "latitude": "32.75710000",
                        "longitude": "12.72764000"
                    },
                    {
                        "id": 67042,
                        "name": "Şabrātah",
                        "latitude": "32.79335000",
                        "longitude": "12.48845000"
                    },
                    {
                        "id": 67043,
                        "name": "Şurmān",
                        "latitude": "32.75668000",
                        "longitude": "12.57159000"
                    },
                    {
                        "id": 67038,
                        "name": "Zawiya",
                        "latitude": "32.75222000",
                        "longitude": "12.72778000"
                    }
                ]
            }
        ]
    },
    {
        "id": 125,
        "name": "Liechtenstein",
        "iso3": "LIE",
        "iso2": "LI",
        "numeric_code": "438",
        "phonecode": "423",
        "capital": "Vaduz",
        "currency": "CHF",
        "currency_name": "Swiss franc",
        "currency_symbol": "CHf",
        "tld": ".li",
        "native": "Liechtenstein",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Western Europe",
        "subregion_id": 17,
        "nationality": "Liechtenstein",
        "timezones": [
            {
                "zoneName": "Europe\/Vaduz",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Liechtenstein",
            "ko": "리히텐슈타인",
            "pt-BR": "Liechtenstein",
            "pt": "Listenstaine",
            "nl": "Liechtenstein",
            "hr": "Lihtenštajn",
            "fa": "لیختن‌اشتاین",
            "de": "Liechtenstein",
            "es": "Liechtenstein",
            "fr": "Liechtenstein",
            "ja": "リヒテンシュタイン",
            "it": "Liechtenstein",
            "zh-CN": "列支敦士登",
            "tr": "Lihtenştayn",
            "ru": "Лихтенштейн",
            "uk": "Ліхтенштейн",
            "pl": "Liechtenstein"
        },
        "latitude": "47.26666666",
        "longitude": "9.53333333",
        "emoji": "🇱🇮",
        "emojiU": "U+1F1F1 U+1F1EE",
        "states": [
            {
                "id": 458,
                "name": "Balzers",
                "iso2": "01",
                "latitude": "42.05283570",
                "longitude": "-88.03668480",
                "type": "commune",
                "cities": [
                    {
                        "id": 66437,
                        "name": "Balzers",
                        "latitude": "47.06665000",
                        "longitude": "9.50251000"
                    }
                ]
            },
            {
                "id": 451,
                "name": "Eschen",
                "iso2": "02",
                "latitude": "40.76695740",
                "longitude": "-73.95228210",
                "type": "commune",
                "cities": [
                    {
                        "id": 66438,
                        "name": "Eschen",
                        "latitude": "47.21071000",
                        "longitude": "9.52223000"
                    }
                ]
            },
            {
                "id": 457,
                "name": "Gamprin",
                "iso2": "03",
                "latitude": "47.21324900",
                "longitude": "9.50251950",
                "type": "commune",
                "cities": [
                    {
                        "id": 66439,
                        "name": "Gamprin",
                        "latitude": "47.22038000",
                        "longitude": "9.50935000"
                    }
                ]
            },
            {
                "id": 455,
                "name": "Mauren",
                "iso2": "04",
                "latitude": "47.21892850",
                "longitude": "9.54173500",
                "type": "commune",
                "cities": [
                    {
                        "id": 66440,
                        "name": "Mauren",
                        "latitude": "47.21805000",
                        "longitude": "9.54420000"
                    }
                ]
            },
            {
                "id": 454,
                "name": "Planken",
                "iso2": "05",
                "latitude": "40.66505760",
                "longitude": "-73.50479800",
                "type": "commune",
                "cities": [
                    {
                        "id": 66441,
                        "name": "Planken",
                        "latitude": "47.18516000",
                        "longitude": "9.54437000"
                    }
                ]
            },
            {
                "id": 453,
                "name": "Ruggell",
                "iso2": "06",
                "latitude": "47.25292220",
                "longitude": "9.54021270",
                "type": "commune",
                "cities": [
                    {
                        "id": 66442,
                        "name": "Ruggell",
                        "latitude": "47.23799000",
                        "longitude": "9.52540000"
                    }
                ]
            },
            {
                "id": 450,
                "name": "Schaan",
                "iso2": "07",
                "latitude": "47.12043400",
                "longitude": "9.59416020",
                "type": "commune",
                "cities": [
                    {
                        "id": 66443,
                        "name": "Schaan",
                        "latitude": "47.16498000",
                        "longitude": "9.50867000"
                    }
                ]
            },
            {
                "id": 449,
                "name": "Schellenberg",
                "iso2": "08",
                "latitude": "47.23096600",
                "longitude": "9.54678430",
                "type": "commune",
                "cities": [
                    {
                        "id": 66444,
                        "name": "Schellenberg",
                        "latitude": "47.23123000",
                        "longitude": "9.54678000"
                    }
                ]
            },
            {
                "id": 459,
                "name": "Triesen",
                "iso2": "09",
                "latitude": "47.10979880",
                "longitude": "9.52482960",
                "type": "commune",
                "cities": [
                    {
                        "id": 66445,
                        "name": "Triesen",
                        "latitude": "47.10752000",
                        "longitude": "9.52815000"
                    }
                ]
            },
            {
                "id": 456,
                "name": "Triesenberg",
                "iso2": "10",
                "latitude": "47.12245110",
                "longitude": "9.57019850",
                "type": "commune",
                "cities": [
                    {
                        "id": 66446,
                        "name": "Triesenberg",
                        "latitude": "47.11815000",
                        "longitude": "9.54197000"
                    }
                ]
            },
            {
                "id": 452,
                "name": "Vaduz",
                "iso2": "11",
                "latitude": "47.14103030",
                "longitude": "9.52092770",
                "type": "commune",
                "cities": [
                    {
                        "id": 66447,
                        "name": "Vaduz",
                        "latitude": "47.14151000",
                        "longitude": "9.52154000"
                    }
                ]
            }
        ]
    },
    {
        "id": 126,
        "name": "Lithuania",
        "iso3": "LTU",
        "iso2": "LT",
        "numeric_code": "440",
        "phonecode": "370",
        "capital": "Vilnius",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".lt",
        "native": "Lietuva",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Lithuanian",
        "timezones": [
            {
                "zoneName": "Europe\/Vilnius",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Lituania",
            "ko": "리투아니아",
            "pt-BR": "Lituânia",
            "pt": "Lituânia",
            "nl": "Litouwen",
            "hr": "Litva",
            "fa": "لیتوانی",
            "de": "Litauen",
            "es": "Lituania",
            "fr": "Lituanie",
            "ja": "リトアニア",
            "it": "Lituania",
            "zh-CN": "立陶宛",
            "tr": "Litvanya",
            "ru": "Литва",
            "uk": "Литва",
            "pl": "Litwa"
        },
        "latitude": "56.00000000",
        "longitude": "24.00000000",
        "emoji": "🇱🇹",
        "emojiU": "U+1F1F1 U+1F1F9",
        "states": [
            {
                "id": 1561,
                "name": "Akmenė",
                "iso2": "01",
                "latitude": "56.24550290",
                "longitude": "22.74711690",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1605,
                "name": "Alytus",
                "iso2": "02",
                "latitude": "54.39629380",
                "longitude": "24.04587610",
                "type": "district municipality",
                "cities": [
                    {
                        "id": 66581,
                        "name": "Alytus",
                        "latitude": "54.39635000",
                        "longitude": "24.04142000"
                    },
                    {
                        "id": 66592,
                        "name": "Daugai",
                        "latitude": "54.36667000",
                        "longitude": "24.33333000"
                    },
                    {
                        "id": 66593,
                        "name": "Druskininkai",
                        "latitude": "54.01573000",
                        "longitude": "23.98703000"
                    },
                    {
                        "id": 66630,
                        "name": "Lazdijai",
                        "latitude": "54.23333000",
                        "longitude": "23.51667000"
                    },
                    {
                        "id": 66678,
                        "name": "Simnas",
                        "latitude": "54.38200000",
                        "longitude": "23.64600000"
                    },
                    {
                        "id": 66694,
                        "name": "Varėna",
                        "latitude": "54.21667000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 66695,
                        "name": "Veisiejai",
                        "latitude": "54.10110000",
                        "longitude": "23.69614000"
                    }
                ]
            },
            {
                "id": 1574,
                "name": "Alytus",
                "iso2": "AL",
                "latitude": "54.20002140",
                "longitude": "24.15126340",
                "type": "county",
                "cities": []
            },
            {
                "id": 5346,
                "name": "Anykščiai",
                "iso2": "04",
                "latitude": "55.54755510",
                "longitude": "24.73181660",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1603,
                "name": "Birštonas",
                "iso2": "05",
                "latitude": "54.56696640",
                "longitude": "24.00930980",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 1566,
                "name": "Biržai",
                "iso2": "06",
                "latitude": "56.20177190",
                "longitude": "24.75601180",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1579,
                "name": "Druskininkai",
                "iso2": "07",
                "latitude": "53.99336850",
                "longitude": "24.03424380",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 1559,
                "name": "Elektrėnai",
                "iso2": "08",
                "latitude": "54.76539340",
                "longitude": "24.77405830",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 1562,
                "name": "Ignalina",
                "iso2": "09",
                "latitude": "55.40903420",
                "longitude": "26.32848930",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1567,
                "name": "Jonava",
                "iso2": "10",
                "latitude": "55.07272420",
                "longitude": "24.27933370",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1581,
                "name": "Joniškis",
                "iso2": "11",
                "latitude": "56.23607300",
                "longitude": "23.61365790",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1555,
                "name": "Jurbarkas",
                "iso2": "12",
                "latitude": "55.07740700",
                "longitude": "22.74195690",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1583,
                "name": "Kaišiadorys",
                "iso2": "13",
                "latitude": "54.85886690",
                "longitude": "24.42779290",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1591,
                "name": "Kalvarija",
                "iso2": "14",
                "latitude": "54.37616740",
                "longitude": "23.19203210",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 1580,
                "name": "Kaunas",
                "iso2": "15",
                "latitude": "54.91453260",
                "longitude": "23.90535180",
                "type": "district municipality",
                "cities": [
                    {
                        "id": 66576,
                        "name": "Akademija (Kaunas)",
                        "latitude": "54.89640000",
                        "longitude": "23.82411000"
                    },
                    {
                        "id": 66579,
                        "name": "Aleksotas",
                        "latitude": "54.88037000",
                        "longitude": "23.90842000"
                    },
                    {
                        "id": 66584,
                        "name": "Ariogala",
                        "latitude": "55.26200000",
                        "longitude": "23.47700000"
                    },
                    {
                        "id": 66588,
                        "name": "Birštonas",
                        "latitude": "54.61667000",
                        "longitude": "24.03333000"
                    },
                    {
                        "id": 66591,
                        "name": "Dainava (Kaunas)",
                        "latitude": "54.91525000",
                        "longitude": "23.96831000"
                    },
                    {
                        "id": 66595,
                        "name": "Eiguliai",
                        "latitude": "54.93133000",
                        "longitude": "23.93243000"
                    },
                    {
                        "id": 66598,
                        "name": "Ežerėlis",
                        "latitude": "54.88315000",
                        "longitude": "23.60396000"
                    },
                    {
                        "id": 66601,
                        "name": "Garliava",
                        "latitude": "54.82139000",
                        "longitude": "23.87130000"
                    },
                    {
                        "id": 66605,
                        "name": "Jieznas",
                        "latitude": "54.59937000",
                        "longitude": "24.17593000"
                    },
                    {
                        "id": 66606,
                        "name": "Jonava",
                        "latitude": "55.08333000",
                        "longitude": "24.28333000"
                    },
                    {
                        "id": 66611,
                        "name": "Kaišiadorys",
                        "latitude": "54.86667000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 66614,
                        "name": "Karmėlava",
                        "latitude": "54.97055000",
                        "longitude": "24.06182000"
                    },
                    {
                        "id": 66615,
                        "name": "Kaunas",
                        "latitude": "54.90272000",
                        "longitude": "23.90961000"
                    },
                    {
                        "id": 66629,
                        "name": "Kėdainiai",
                        "latitude": "55.28333000",
                        "longitude": "23.96667000"
                    },
                    {
                        "id": 66624,
                        "name": "Kulautuva",
                        "latitude": "54.94212000",
                        "longitude": "23.64218000"
                    },
                    {
                        "id": 66636,
                        "name": "Mastaiciai",
                        "latitude": "54.81998000",
                        "longitude": "23.84462000"
                    },
                    {
                        "id": 66661,
                        "name": "Prienai",
                        "latitude": "54.63333000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 66664,
                        "name": "Ramučiai",
                        "latitude": "54.94830000",
                        "longitude": "24.03050000"
                    },
                    {
                        "id": 66666,
                        "name": "Raseiniai",
                        "latitude": "55.36667000",
                        "longitude": "23.11667000"
                    },
                    {
                        "id": 66674,
                        "name": "Sargėnai",
                        "latitude": "54.94933000",
                        "longitude": "23.88316000"
                    },
                    {
                        "id": 66714,
                        "name": "Šilainiai",
                        "latitude": "54.92911000",
                        "longitude": "23.88599000"
                    },
                    {
                        "id": 66701,
                        "name": "Vilkija",
                        "latitude": "55.04609000",
                        "longitude": "23.58552000"
                    },
                    {
                        "id": 66723,
                        "name": "Žiežmariai",
                        "latitude": "54.80725000",
                        "longitude": "24.44073000"
                    }
                ]
            },
            {
                "id": 1556,
                "name": "Kaunas",
                "iso2": "KU",
                "latitude": "54.98728630",
                "longitude": "23.95257360",
                "type": "county",
                "cities": []
            },
            {
                "id": 1575,
                "name": "Kazlų Rūda",
                "iso2": "17",
                "latitude": "54.78075260",
                "longitude": "23.48402430",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 1584,
                "name": "Kėdainiai",
                "iso2": "18",
                "latitude": "55.35609470",
                "longitude": "23.98326830",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1618,
                "name": "Kelmė",
                "iso2": "19",
                "latitude": "55.62663520",
                "longitude": "22.87817200",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1600,
                "name": "Klaipėda",
                "iso2": "KL",
                "latitude": "55.65197440",
                "longitude": "21.37439560",
                "type": "county",
                "cities": []
            },
            {
                "id": 1604,
                "name": "Klaipėda",
                "iso2": "21",
                "latitude": "55.68416150",
                "longitude": "21.44164640",
                "type": "district municipality",
                "cities": [
                    {
                        "id": 66600,
                        "name": "Gargždai",
                        "latitude": "55.70951000",
                        "longitude": "21.39441000"
                    },
                    {
                        "id": 66620,
                        "name": "Klaipėda",
                        "latitude": "55.71667000",
                        "longitude": "21.11667000"
                    },
                    {
                        "id": 66622,
                        "name": "Kretinga",
                        "latitude": "55.88880000",
                        "longitude": "21.24448000"
                    },
                    {
                        "id": 66644,
                        "name": "Neringa",
                        "latitude": "55.36667000",
                        "longitude": "21.06667000"
                    },
                    {
                        "id": 66645,
                        "name": "Nida",
                        "latitude": "55.30860000",
                        "longitude": "20.99651000"
                    },
                    {
                        "id": 66650,
                        "name": "Palanga",
                        "latitude": "55.91750000",
                        "longitude": "21.06861000"
                    },
                    {
                        "id": 66660,
                        "name": "Priekulė",
                        "latitude": "55.55427000",
                        "longitude": "21.31903000"
                    },
                    {
                        "id": 66670,
                        "name": "Rusnė",
                        "latitude": "55.29820000",
                        "longitude": "21.37120000"
                    },
                    {
                        "id": 66673,
                        "name": "Salantai",
                        "latitude": "56.05650000",
                        "longitude": "21.56890000"
                    },
                    {
                        "id": 66677,
                        "name": "Silute",
                        "latitude": "55.34889000",
                        "longitude": "21.48306000"
                    },
                    {
                        "id": 66681,
                        "name": "Skuodas",
                        "latitude": "56.26667000",
                        "longitude": "21.53333000"
                    },
                    {
                        "id": 66718,
                        "name": "Šventoji",
                        "latitude": "56.02610000",
                        "longitude": "21.08411000"
                    },
                    {
                        "id": 66722,
                        "name": "Žemaičių Naumiestis",
                        "latitude": "55.35941000",
                        "longitude": "21.70364000"
                    }
                ]
            },
            {
                "id": 1571,
                "name": "Kretinga",
                "iso2": "22",
                "latitude": "55.88384200",
                "longitude": "21.23509190",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1585,
                "name": "Kupiškis",
                "iso2": "23",
                "latitude": "55.84287410",
                "longitude": "25.02958160",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1611,
                "name": "Lazdijai",
                "iso2": "24",
                "latitude": "54.23432670",
                "longitude": "23.51565050",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1610,
                "name": "Marijampolė",
                "iso2": "25",
                "latitude": "54.57110940",
                "longitude": "23.48593710",
                "type": "district municipality",
                "cities": [
                    {
                        "id": 66602,
                        "name": "Gelgaudiškis",
                        "latitude": "55.07688000",
                        "longitude": "22.97699000"
                    },
                    {
                        "id": 66612,
                        "name": "Kalvarija",
                        "latitude": "54.41700000",
                        "longitude": "23.22300000"
                    },
                    {
                        "id": 66613,
                        "name": "Kalvarija Municipality",
                        "latitude": "54.41468000",
                        "longitude": "23.22484000"
                    },
                    {
                        "id": 66617,
                        "name": "Kazlų Rūda",
                        "latitude": "54.74900000",
                        "longitude": "23.49000000"
                    },
                    {
                        "id": 66618,
                        "name": "Kazlų Rūda Municipality",
                        "latitude": "54.74751000",
                        "longitude": "23.49272000"
                    },
                    {
                        "id": 66623,
                        "name": "Kudirkos Naumiestis",
                        "latitude": "54.77353000",
                        "longitude": "22.86138000"
                    },
                    {
                        "id": 66628,
                        "name": "Kybartai",
                        "latitude": "54.63858000",
                        "longitude": "22.76316000"
                    },
                    {
                        "id": 66634,
                        "name": "Marijampolė",
                        "latitude": "54.55991000",
                        "longitude": "23.35412000"
                    },
                    {
                        "id": 66635,
                        "name": "Marijampolė Municipality",
                        "latitude": "54.56667000",
                        "longitude": "23.35000000"
                    },
                    {
                        "id": 66672,
                        "name": "Sakiai",
                        "latitude": "54.95000000",
                        "longitude": "23.05000000"
                    },
                    {
                        "id": 66699,
                        "name": "Vilkaviskis",
                        "latitude": "54.65167000",
                        "longitude": "23.03222000"
                    },
                    {
                        "id": 66700,
                        "name": "Vilkaviškis District Municipality",
                        "latitude": "54.65000000",
                        "longitude": "23.03333000"
                    },
                    {
                        "id": 66705,
                        "name": "Virbalis",
                        "latitude": "54.62858000",
                        "longitude": "22.82272000"
                    }
                ]
            },
            {
                "id": 1570,
                "name": "Marijampolė",
                "iso2": "MR",
                "latitude": "54.78199710",
                "longitude": "23.13413650",
                "type": "county",
                "cities": []
            },
            {
                "id": 1557,
                "name": "Mažeikiai",
                "iso2": "26",
                "latitude": "56.30924390",
                "longitude": "22.34146800",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1582,
                "name": "Molėtai",
                "iso2": "27",
                "latitude": "55.22653090",
                "longitude": "25.41800110",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1563,
                "name": "Neringa",
                "iso2": "28",
                "latitude": "55.45724030",
                "longitude": "21.08390050",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 1612,
                "name": "Pagėgiai",
                "iso2": "29",
                "latitude": "55.17213200",
                "longitude": "21.96836140",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 1595,
                "name": "Pakruojis",
                "iso2": "30",
                "latitude": "56.07326050",
                "longitude": "23.93899060",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1588,
                "name": "Palanga",
                "iso2": "31",
                "latitude": "55.92019800",
                "longitude": "21.06776140",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1558,
                "name": "Panevėžys",
                "iso2": "PN",
                "latitude": "55.97480490",
                "longitude": "25.07947670",
                "type": "county",
                "cities": []
            },
            {
                "id": 1614,
                "name": "Panevėžys",
                "iso2": "33",
                "latitude": "55.61667280",
                "longitude": "24.31422830",
                "type": "district municipality",
                "cities": [
                    {
                        "id": 66587,
                        "name": "Birzai",
                        "latitude": "56.20000000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 66608,
                        "name": "Juodupė",
                        "latitude": "56.08700000",
                        "longitude": "25.60700000"
                    },
                    {
                        "id": 66625,
                        "name": "Kupiskis",
                        "latitude": "55.84027000",
                        "longitude": "24.97976000"
                    },
                    {
                        "id": 66646,
                        "name": "Obeliai",
                        "latitude": "55.96895000",
                        "longitude": "25.15648000"
                    },
                    {
                        "id": 66651,
                        "name": "Panevėžys",
                        "latitude": "55.73333000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 66652,
                        "name": "Panevėžys City",
                        "latitude": "55.73600000",
                        "longitude": "24.34347000"
                    },
                    {
                        "id": 66653,
                        "name": "Panevėžys District Municipality",
                        "latitude": "55.73301000",
                        "longitude": "24.37609000"
                    },
                    {
                        "id": 66654,
                        "name": "Pasvalys",
                        "latitude": "56.06667000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 66665,
                        "name": "Ramygala",
                        "latitude": "55.51400000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 66669,
                        "name": "Rokiškis",
                        "latitude": "55.96667000",
                        "longitude": "25.58333000"
                    },
                    {
                        "id": 66692,
                        "name": "Vabalninkas",
                        "latitude": "55.98151000",
                        "longitude": "24.74828000"
                    }
                ]
            },
            {
                "id": 1616,
                "name": "Pasvalys",
                "iso2": "34",
                "latitude": "56.06046190",
                "longitude": "24.39629100",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1553,
                "name": "Plungė",
                "iso2": "35",
                "latitude": "55.91078400",
                "longitude": "21.84540690",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1578,
                "name": "Prienai",
                "iso2": "36",
                "latitude": "54.63835800",
                "longitude": "23.94680090",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1568,
                "name": "Radviliškis",
                "iso2": "37",
                "latitude": "55.81083990",
                "longitude": "23.54648700",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1587,
                "name": "Raseiniai",
                "iso2": "38",
                "latitude": "55.38194990",
                "longitude": "23.11561290",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1590,
                "name": "Rietavas",
                "iso2": "39",
                "latitude": "55.70217190",
                "longitude": "21.99865640",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 1615,
                "name": "Rokiškis",
                "iso2": "40",
                "latitude": "55.95550390",
                "longitude": "25.58592490",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1576,
                "name": "Šakiai",
                "iso2": "41",
                "latitude": "54.95267100",
                "longitude": "23.04801990",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1577,
                "name": "Šalčininkai",
                "iso2": "42",
                "latitude": "54.30976700",
                "longitude": "25.38756400",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1586,
                "name": "Šiauliai",
                "iso2": "SA",
                "latitude": "55.99857510",
                "longitude": "23.13800510",
                "type": "county",
                "cities": []
            },
            {
                "id": 1609,
                "name": "Šiauliai",
                "iso2": "43",
                "latitude": "55.93490850",
                "longitude": "23.31368230",
                "type": "district municipality",
                "cities": [
                    {
                        "id": 66577,
                        "name": "Akmenė",
                        "latitude": "56.25000000",
                        "longitude": "22.75000000"
                    },
                    {
                        "id": 66607,
                        "name": "Joniškis",
                        "latitude": "56.23333000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 66619,
                        "name": "Kelmė",
                        "latitude": "55.63333000",
                        "longitude": "22.93333000"
                    },
                    {
                        "id": 66627,
                        "name": "Kuršėnai",
                        "latitude": "56.00318000",
                        "longitude": "22.93662000"
                    },
                    {
                        "id": 66633,
                        "name": "Linkuva",
                        "latitude": "56.08596000",
                        "longitude": "23.97061000"
                    },
                    {
                        "id": 66642,
                        "name": "Naujoji Akmene",
                        "latitude": "56.31667000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 66649,
                        "name": "Pakruojis",
                        "latitude": "55.96667000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 66662,
                        "name": "Radviliskis",
                        "latitude": "55.81667000",
                        "longitude": "23.53333000"
                    },
                    {
                        "id": 66710,
                        "name": "Šeduva",
                        "latitude": "55.74930000",
                        "longitude": "23.75610000"
                    },
                    {
                        "id": 66712,
                        "name": "Šiauliai",
                        "latitude": "55.93333000",
                        "longitude": "23.31667000"
                    },
                    {
                        "id": 66688,
                        "name": "Tytuvėnėliai",
                        "latitude": "55.62345000",
                        "longitude": "23.17162000"
                    },
                    {
                        "id": 66696,
                        "name": "Venta",
                        "latitude": "56.19162000",
                        "longitude": "22.69528000"
                    },
                    {
                        "id": 66721,
                        "name": "Žagarė",
                        "latitude": "56.36149000",
                        "longitude": "23.25094000"
                    }
                ]
            },
            {
                "id": 1613,
                "name": "Šilalė ",
                "iso2": "45",
                "latitude": "55.49268000",
                "longitude": "22.18455590",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1607,
                "name": "Šilutė",
                "iso2": "46",
                "latitude": "55.35041400",
                "longitude": "21.46598590",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1594,
                "name": "Širvintos",
                "iso2": "47",
                "latitude": "55.04310200",
                "longitude": "24.95698100",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1617,
                "name": "Skuodas",
                "iso2": "48",
                "latitude": "56.27021690",
                "longitude": "21.52143310",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1560,
                "name": "Švenčionys",
                "iso2": "49",
                "latitude": "55.10280980",
                "longitude": "26.00718550",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1573,
                "name": "Tauragė",
                "iso2": "TA",
                "latitude": "55.30725860",
                "longitude": "22.35729390",
                "type": "county",
                "cities": [
                    {
                        "id": 66590,
                        "name": "Būgai",
                        "latitude": "55.41387000",
                        "longitude": "22.60894000"
                    },
                    {
                        "id": 66609,
                        "name": "Jurbarkas",
                        "latitude": "55.10859000",
                        "longitude": "22.79885000"
                    },
                    {
                        "id": 66648,
                        "name": "Pagėgiai",
                        "latitude": "55.13400000",
                        "longitude": "21.90446000"
                    },
                    {
                        "id": 66715,
                        "name": "Šilalė",
                        "latitude": "55.46667000",
                        "longitude": "22.20000000"
                    },
                    {
                        "id": 66683,
                        "name": "Taurage",
                        "latitude": "55.25222000",
                        "longitude": "22.28972000"
                    }
                ]
            },
            {
                "id": 1572,
                "name": "Tauragė",
                "iso2": "50",
                "latitude": "55.25036600",
                "longitude": "22.29095000",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1608,
                "name": "Telšiai",
                "iso2": "51",
                "latitude": "55.91752150",
                "longitude": "22.34518400",
                "type": "district municipality",
                "cities": [
                    {
                        "id": 66637,
                        "name": "Mazeikiai",
                        "latitude": "56.31667000",
                        "longitude": "22.33333000"
                    },
                    {
                        "id": 66657,
                        "name": "Plateliai",
                        "latitude": "56.04657000",
                        "longitude": "21.81615000"
                    },
                    {
                        "id": 66658,
                        "name": "Plunge",
                        "latitude": "55.91139000",
                        "longitude": "21.84417000"
                    },
                    {
                        "id": 66668,
                        "name": "Rietavas",
                        "latitude": "55.72375000",
                        "longitude": "21.93266000"
                    },
                    {
                        "id": 66675,
                        "name": "Seda",
                        "latitude": "56.16854000",
                        "longitude": "22.09071000"
                    },
                    {
                        "id": 66685,
                        "name": "Telsiai",
                        "latitude": "55.98139000",
                        "longitude": "22.24722000"
                    },
                    {
                        "id": 66693,
                        "name": "Varniai",
                        "latitude": "55.74435000",
                        "longitude": "22.37251000"
                    },
                    {
                        "id": 66697,
                        "name": "Viekšniai",
                        "latitude": "56.23598000",
                        "longitude": "22.51667000"
                    }
                ]
            },
            {
                "id": 1569,
                "name": "Telšiai",
                "iso2": "TE",
                "latitude": "56.10266160",
                "longitude": "22.11139150",
                "type": "county",
                "cities": []
            },
            {
                "id": 1593,
                "name": "Trakai",
                "iso2": "52",
                "latitude": "54.63791130",
                "longitude": "24.93468940",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1596,
                "name": "Ukmergė",
                "iso2": "53",
                "latitude": "55.24526500",
                "longitude": "24.77607490",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1598,
                "name": "Utena",
                "iso2": "54",
                "latitude": "55.50846140",
                "longitude": "25.68326420",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1621,
                "name": "Utena",
                "iso2": "UT",
                "latitude": "55.53189690",
                "longitude": "25.79046990",
                "type": "county",
                "cities": [
                    {
                        "id": 66582,
                        "name": "Anyksciai",
                        "latitude": "55.52557000",
                        "longitude": "25.10264000"
                    },
                    {
                        "id": 66594,
                        "name": "Dūkštas",
                        "latitude": "55.52200000",
                        "longitude": "26.32100000"
                    },
                    {
                        "id": 66604,
                        "name": "Ignalina",
                        "latitude": "55.35000000",
                        "longitude": "26.16667000"
                    },
                    {
                        "id": 66639,
                        "name": "Moletai",
                        "latitude": "55.23333000",
                        "longitude": "25.41667000"
                    },
                    {
                        "id": 66691,
                        "name": "Utena",
                        "latitude": "55.49764000",
                        "longitude": "25.59918000"
                    },
                    {
                        "id": 66706,
                        "name": "Visaginas",
                        "latitude": "55.60000000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 66707,
                        "name": "Zarasai",
                        "latitude": "55.73333000",
                        "longitude": "26.25000000"
                    }
                ]
            },
            {
                "id": 1602,
                "name": "Varėna",
                "iso2": "55",
                "latitude": "54.22033300",
                "longitude": "24.57899700",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1620,
                "name": "Vilkaviškis",
                "iso2": "56",
                "latitude": "54.65194500",
                "longitude": "23.03515500",
                "type": "district municipality",
                "cities": []
            },
            {
                "id": 1606,
                "name": "Vilnius",
                "iso2": "57",
                "latitude": "54.67107610",
                "longitude": "25.28787210",
                "type": "district municipality",
                "cities": [
                    {
                        "id": 66585,
                        "name": "Aukstadvaris",
                        "latitude": "54.57946000",
                        "longitude": "24.52683000"
                    },
                    {
                        "id": 66586,
                        "name": "Baltoji Vokė",
                        "latitude": "54.60002000",
                        "longitude": "25.19318000"
                    },
                    {
                        "id": 66596,
                        "name": "Eišiškės",
                        "latitude": "54.17414000",
                        "longitude": "24.99917000"
                    },
                    {
                        "id": 66597,
                        "name": "Elektrėnai",
                        "latitude": "54.78544000",
                        "longitude": "24.66302000"
                    },
                    {
                        "id": 66599,
                        "name": "Fabijoniškės",
                        "latitude": "54.73333000",
                        "longitude": "25.24167000"
                    },
                    {
                        "id": 66603,
                        "name": "Grigiškės",
                        "latitude": "54.68333000",
                        "longitude": "25.08333000"
                    },
                    {
                        "id": 66610,
                        "name": "Justiniškės",
                        "latitude": "54.71664000",
                        "longitude": "25.21740000"
                    },
                    {
                        "id": 66631,
                        "name": "Lazdynai",
                        "latitude": "54.66815000",
                        "longitude": "25.20684000"
                    },
                    {
                        "id": 66632,
                        "name": "Lentvaris",
                        "latitude": "54.64364000",
                        "longitude": "25.05162000"
                    },
                    {
                        "id": 66641,
                        "name": "Naujamiestis",
                        "latitude": "54.67951000",
                        "longitude": "25.26855000"
                    },
                    {
                        "id": 66643,
                        "name": "Nemenčinė",
                        "latitude": "54.84776000",
                        "longitude": "25.46992000"
                    },
                    {
                        "id": 66647,
                        "name": "Pabradė",
                        "latitude": "54.98100000",
                        "longitude": "25.76100000"
                    },
                    {
                        "id": 66655,
                        "name": "Pašilaičiai",
                        "latitude": "54.73429000",
                        "longitude": "25.21912000"
                    },
                    {
                        "id": 66656,
                        "name": "Pilaitė",
                        "latitude": "54.69981000",
                        "longitude": "25.18393000"
                    },
                    {
                        "id": 66667,
                        "name": "Rasos",
                        "latitude": "54.67877000",
                        "longitude": "25.31173000"
                    },
                    {
                        "id": 66671,
                        "name": "Rūdiškės",
                        "latitude": "54.51609000",
                        "longitude": "24.83084000"
                    },
                    {
                        "id": 66709,
                        "name": "Šalčininkai",
                        "latitude": "54.30000000",
                        "longitude": "25.38333000"
                    },
                    {
                        "id": 66676,
                        "name": "Senieji Trakai",
                        "latitude": "54.60900000",
                        "longitude": "24.98000000"
                    },
                    {
                        "id": 66711,
                        "name": "Šeškinė",
                        "latitude": "54.70972000",
                        "longitude": "25.25053000"
                    },
                    {
                        "id": 66679,
                        "name": "Sirvintos",
                        "latitude": "55.05000000",
                        "longitude": "24.95000000"
                    },
                    {
                        "id": 66680,
                        "name": "Skaidiškės",
                        "latitude": "54.61398000",
                        "longitude": "25.39573000"
                    },
                    {
                        "id": 66720,
                        "name": "Švenčionėliai",
                        "latitude": "55.16163000",
                        "longitude": "26.00177000"
                    },
                    {
                        "id": 66682,
                        "name": "Svencionys",
                        "latitude": "55.15000000",
                        "longitude": "26.16667000"
                    },
                    {
                        "id": 66687,
                        "name": "Trakai",
                        "latitude": "54.63783000",
                        "longitude": "24.93433000"
                    },
                    {
                        "id": 66689,
                        "name": "Ukmerge",
                        "latitude": "55.25000000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 66698,
                        "name": "Vievis",
                        "latitude": "54.76667000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 66702,
                        "name": "Vilkpėdė",
                        "latitude": "54.66969000",
                        "longitude": "25.24770000"
                    },
                    {
                        "id": 66703,
                        "name": "Vilnius",
                        "latitude": "54.68916000",
                        "longitude": "25.27980000"
                    },
                    {
                        "id": 66704,
                        "name": "Vilnius District Municipality",
                        "latitude": "54.73333000",
                        "longitude": "25.38333000"
                    }
                ]
            },
            {
                "id": 1601,
                "name": "Vilnius",
                "iso2": "VL",
                "latitude": "54.80865020",
                "longitude": "25.21821390",
                "type": "county",
                "cities": []
            },
            {
                "id": 1564,
                "name": "Visaginas",
                "iso2": "59",
                "latitude": "55.59411800",
                "longitude": "26.43079540",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 1619,
                "name": "Zarasai",
                "iso2": "60",
                "latitude": "55.73096090",
                "longitude": "26.24529500",
                "type": "district municipality",
                "cities": []
            }
        ]
    },
    {
        "id": 127,
        "name": "Luxembourg",
        "iso3": "LUX",
        "iso2": "LU",
        "numeric_code": "442",
        "phonecode": "352",
        "capital": "Luxembourg",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".lu",
        "native": "Luxembourg",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Western Europe",
        "subregion_id": 17,
        "nationality": "Luxembourg, Luxembourgish",
        "timezones": [
            {
                "zoneName": "Europe\/Luxembourg",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Luksembourg",
            "ko": "룩셈부르크",
            "pt-BR": "Luxemburgo",
            "pt": "Luxemburgo",
            "nl": "Luxemburg",
            "hr": "Luksemburg",
            "fa": "لوکزامبورگ",
            "de": "Luxemburg",
            "es": "Luxemburgo",
            "fr": "Luxembourg",
            "ja": "ルクセンブルク",
            "it": "Lussemburgo",
            "zh-CN": "卢森堡",
            "tr": "Lüksemburg",
            "ru": "Люксембург",
            "uk": "Люксембург",
            "pl": "Luksemburg"
        },
        "latitude": "49.75000000",
        "longitude": "6.16666666",
        "emoji": "🇱🇺",
        "emojiU": "U+1F1F1 U+1F1FA",
        "states": [
            {
                "id": 1518,
                "name": "Capellen",
                "iso2": "CA",
                "latitude": "49.64039310",
                "longitude": "5.95538460",
                "type": "canton",
                "cities": [
                    {
                        "id": 66726,
                        "name": "Bascharage",
                        "latitude": "49.56727000",
                        "longitude": "5.90730000"
                    },
                    {
                        "id": 66745,
                        "name": "Bridel",
                        "latitude": "49.65579000",
                        "longitude": "6.07999000"
                    },
                    {
                        "id": 66747,
                        "name": "Capellen",
                        "latitude": "49.64500000",
                        "longitude": "5.99083000"
                    },
                    {
                        "id": 66748,
                        "name": "Clemency",
                        "latitude": "49.59667000",
                        "longitude": "5.87583000"
                    },
                    {
                        "id": 66759,
                        "name": "Dippach",
                        "latitude": "49.58701000",
                        "longitude": "5.98330000"
                    },
                    {
                        "id": 66762,
                        "name": "Eischen",
                        "latitude": "49.68556000",
                        "longitude": "5.87861000"
                    },
                    {
                        "id": 66773,
                        "name": "Garnich",
                        "latitude": "49.61667000",
                        "longitude": "5.95250000"
                    },
                    {
                        "id": 66778,
                        "name": "Hautcharage",
                        "latitude": "49.57499000",
                        "longitude": "5.90970000"
                    },
                    {
                        "id": 66783,
                        "name": "Hobscheid",
                        "latitude": "49.68861000",
                        "longitude": "5.91472000"
                    },
                    {
                        "id": 66793,
                        "name": "Käerjeng",
                        "latitude": "49.58311000",
                        "longitude": "5.89892000"
                    },
                    {
                        "id": 66788,
                        "name": "Kehlen",
                        "latitude": "49.66833000",
                        "longitude": "6.03583000"
                    },
                    {
                        "id": 66791,
                        "name": "Koerich",
                        "latitude": "49.67000000",
                        "longitude": "5.95000000"
                    },
                    {
                        "id": 66792,
                        "name": "Kopstal",
                        "latitude": "49.66444000",
                        "longitude": "6.07306000"
                    },
                    {
                        "id": 66802,
                        "name": "Mamer",
                        "latitude": "49.62750000",
                        "longitude": "6.02333000"
                    },
                    {
                        "id": 66839,
                        "name": "Schouweiler",
                        "latitude": "49.58250000",
                        "longitude": "5.95639000"
                    },
                    {
                        "id": 66842,
                        "name": "Septfontaines",
                        "latitude": "49.70111000",
                        "longitude": "5.96722000"
                    },
                    {
                        "id": 66845,
                        "name": "Steinfort",
                        "latitude": "49.66139000",
                        "longitude": "5.91917000"
                    }
                ]
            },
            {
                "id": 1521,
                "name": "Clervaux",
                "iso2": "CL",
                "latitude": "50.05463130",
                "longitude": "6.02858750",
                "type": "canton",
                "cities": [
                    {
                        "id": 66749,
                        "name": "Clervaux",
                        "latitude": "50.05472000",
                        "longitude": "6.03139000"
                    },
                    {
                        "id": 66784,
                        "name": "Hosingen",
                        "latitude": "50.01218000",
                        "longitude": "6.09089000"
                    },
                    {
                        "id": 66819,
                        "name": "Parc Hosingen",
                        "latitude": "49.99744000",
                        "longitude": "6.09067000"
                    },
                    {
                        "id": 66849,
                        "name": "Troisvierges",
                        "latitude": "50.12111000",
                        "longitude": "6.00028000"
                    },
                    {
                        "id": 66862,
                        "name": "Weiswampach",
                        "latitude": "50.13722000",
                        "longitude": "6.07500000"
                    },
                    {
                        "id": 66865,
                        "name": "Wincrange",
                        "latitude": "50.05333000",
                        "longitude": "5.91917000"
                    }
                ]
            },
            {
                "id": 1513,
                "name": "Diekirch",
                "iso2": "DI",
                "latitude": "49.86717840",
                "longitude": "6.15956330",
                "type": "canton",
                "cities": [
                    {
                        "id": 66737,
                        "name": "Bettendorf",
                        "latitude": "49.87667000",
                        "longitude": "6.21806000"
                    },
                    {
                        "id": 66743,
                        "name": "Bourscheid",
                        "latitude": "49.90862000",
                        "longitude": "6.06750000"
                    },
                    {
                        "id": 66752,
                        "name": "Commune de la Vallée de l’Ernz",
                        "latitude": "49.82149000",
                        "longitude": "6.21746000"
                    },
                    {
                        "id": 66757,
                        "name": "Diekirch",
                        "latitude": "49.86778000",
                        "longitude": "6.15583000"
                    },
                    {
                        "id": 66764,
                        "name": "Erpeldange",
                        "latitude": "49.86472000",
                        "longitude": "6.11472000"
                    },
                    {
                        "id": 66767,
                        "name": "Ettelbruck",
                        "latitude": "49.84750000",
                        "longitude": "6.10417000"
                    },
                    {
                        "id": 66769,
                        "name": "Feulen",
                        "latitude": "49.85000000",
                        "longitude": "6.01667000"
                    },
                    {
                        "id": 66804,
                        "name": "Medernach",
                        "latitude": "49.80955000",
                        "longitude": "6.21521000"
                    },
                    {
                        "id": 66807,
                        "name": "Mertzig",
                        "latitude": "49.83389000",
                        "longitude": "6.00750000"
                    },
                    {
                        "id": 66815,
                        "name": "Niederfeulen",
                        "latitude": "49.85556000",
                        "longitude": "6.04722000"
                    },
                    {
                        "id": 66826,
                        "name": "Reisdorf",
                        "latitude": "49.86861000",
                        "longitude": "6.26778000"
                    },
                    {
                        "id": 66837,
                        "name": "Schieren",
                        "latitude": "49.83056000",
                        "longitude": "6.09861000"
                    },
                    {
                        "id": 66859,
                        "name": "Warken",
                        "latitude": "49.85918000",
                        "longitude": "6.08415000"
                    }
                ]
            },
            {
                "id": 1515,
                "name": "Echternach",
                "iso2": "EC",
                "latitude": "49.81141330",
                "longitude": "6.41756350",
                "type": "canton",
                "cities": [
                    {
                        "id": 66728,
                        "name": "Beaufort",
                        "latitude": "49.83583000",
                        "longitude": "6.29167000"
                    },
                    {
                        "id": 66729,
                        "name": "Bech",
                        "latitude": "49.75260000",
                        "longitude": "6.36379000"
                    },
                    {
                        "id": 66732,
                        "name": "Berdorf",
                        "latitude": "49.82051000",
                        "longitude": "6.34945000"
                    },
                    {
                        "id": 66753,
                        "name": "Consdorf",
                        "latitude": "49.78018000",
                        "longitude": "6.33950000"
                    },
                    {
                        "id": 66761,
                        "name": "Echternach",
                        "latitude": "49.81212000",
                        "longitude": "6.41846000"
                    },
                    {
                        "id": 66808,
                        "name": "Mompach",
                        "latitude": "49.74611000",
                        "longitude": "6.46500000"
                    },
                    {
                        "id": 66831,
                        "name": "Rosport",
                        "latitude": "49.80470000",
                        "longitude": "6.50532000"
                    },
                    {
                        "id": 66856,
                        "name": "Waldbillig",
                        "latitude": "49.79636000",
                        "longitude": "6.28431000"
                    }
                ]
            },
            {
                "id": 1517,
                "name": "Esch-sur-Alzette",
                "iso2": "ES",
                "latitude": "49.50088050",
                "longitude": "5.98609250",
                "type": "canton",
                "cities": [
                    {
                        "id": 66725,
                        "name": "Aspelt",
                        "latitude": "49.52278000",
                        "longitude": "6.22472000"
                    },
                    {
                        "id": 66731,
                        "name": "Belvaux",
                        "latitude": "49.51014000",
                        "longitude": "5.92414000"
                    },
                    {
                        "id": 66733,
                        "name": "Bergem",
                        "latitude": "49.52500000",
                        "longitude": "6.04222000"
                    },
                    {
                        "id": 66736,
                        "name": "Bettembourg",
                        "latitude": "49.51861000",
                        "longitude": "6.10278000"
                    },
                    {
                        "id": 66755,
                        "name": "Crauthem",
                        "latitude": "49.53556000",
                        "longitude": "6.14694000"
                    },
                    {
                        "id": 66758,
                        "name": "Differdange",
                        "latitude": "49.52417000",
                        "longitude": "5.89139000"
                    },
                    {
                        "id": 66760,
                        "name": "Dudelange",
                        "latitude": "49.48056000",
                        "longitude": "6.08750000"
                    },
                    {
                        "id": 66765,
                        "name": "Esch-sur-Alzette",
                        "latitude": "49.49583000",
                        "longitude": "5.98056000"
                    },
                    {
                        "id": 66772,
                        "name": "Frisange",
                        "latitude": "49.51616000",
                        "longitude": "6.18858000"
                    },
                    {
                        "id": 66787,
                        "name": "Kayl",
                        "latitude": "49.48917000",
                        "longitude": "6.03972000"
                    },
                    {
                        "id": 66795,
                        "name": "Lamadelaine",
                        "latitude": "49.54639000",
                        "longitude": "5.85639000"
                    },
                    {
                        "id": 66798,
                        "name": "Leudelange",
                        "latitude": "49.56833000",
                        "longitude": "6.06528000"
                    },
                    {
                        "id": 66809,
                        "name": "Mondercange",
                        "latitude": "49.53306000",
                        "longitude": "5.98833000"
                    },
                    {
                        "id": 66814,
                        "name": "Niedercorn",
                        "latitude": "49.53611000",
                        "longitude": "5.89306000"
                    },
                    {
                        "id": 66817,
                        "name": "Obercorn",
                        "latitude": "49.51361000",
                        "longitude": "5.89611000"
                    },
                    {
                        "id": 66822,
                        "name": "Pétange",
                        "latitude": "49.55833000",
                        "longitude": "5.88056000"
                    },
                    {
                        "id": 66820,
                        "name": "Pontpierre",
                        "latitude": "49.53639000",
                        "longitude": "6.02944000"
                    },
                    {
                        "id": 66824,
                        "name": "Reckange-sur-Mess",
                        "latitude": "49.56250000",
                        "longitude": "6.00889000"
                    },
                    {
                        "id": 66828,
                        "name": "Rodange",
                        "latitude": "49.54639000",
                        "longitude": "5.84083000"
                    },
                    {
                        "id": 66829,
                        "name": "Roeser",
                        "latitude": "49.53721000",
                        "longitude": "6.14629000"
                    },
                    {
                        "id": 66832,
                        "name": "Rumelange",
                        "latitude": "49.45964000",
                        "longitude": "6.03089000"
                    },
                    {
                        "id": 66835,
                        "name": "Sanem",
                        "latitude": "49.54806000",
                        "longitude": "5.92889000"
                    },
                    {
                        "id": 66838,
                        "name": "Schifflange",
                        "latitude": "49.50639000",
                        "longitude": "6.01278000"
                    },
                    {
                        "id": 66843,
                        "name": "Soleuvre",
                        "latitude": "49.52148000",
                        "longitude": "5.93781000"
                    },
                    {
                        "id": 66851,
                        "name": "Tétange",
                        "latitude": "49.47583000",
                        "longitude": "6.04222000"
                    }
                ]
            },
            {
                "id": 1520,
                "name": "Grevenmacher",
                "iso2": "G",
                "latitude": "49.68085100",
                "longitude": "6.44075240",
                "type": "canton",
                "cities": [
                    {
                        "id": 66738,
                        "name": "Betzdorf",
                        "latitude": "49.68333000",
                        "longitude": "6.35000000"
                    },
                    {
                        "id": 66740,
                        "name": "Biwer",
                        "latitude": "49.70605000",
                        "longitude": "6.37201000"
                    },
                    {
                        "id": 66771,
                        "name": "Flaxweiler",
                        "latitude": "49.66602000",
                        "longitude": "6.34321000"
                    },
                    {
                        "id": 66775,
                        "name": "Gonderange",
                        "latitude": "49.69537000",
                        "longitude": "6.24577000"
                    },
                    {
                        "id": 66776,
                        "name": "Grevenmacher",
                        "latitude": "49.67751000",
                        "longitude": "6.44022000"
                    },
                    {
                        "id": 66786,
                        "name": "Junglinster",
                        "latitude": "49.70722000",
                        "longitude": "6.25306000"
                    },
                    {
                        "id": 66803,
                        "name": "Manternach",
                        "latitude": "49.70278000",
                        "longitude": "6.42639000"
                    },
                    {
                        "id": 66806,
                        "name": "Mertert",
                        "latitude": "49.70261000",
                        "longitude": "6.47966000"
                    },
                    {
                        "id": 66860,
                        "name": "Wasserbillig",
                        "latitude": "49.71534000",
                        "longitude": "6.49861000"
                    },
                    {
                        "id": 66867,
                        "name": "Wormeldange",
                        "latitude": "49.61114000",
                        "longitude": "6.40546000"
                    }
                ]
            },
            {
                "id": 1514,
                "name": "Luxembourg ",
                "iso2": "L",
                "latitude": "49.59537060",
                "longitude": "6.13331780",
                "type": "canton",
                "cities": [
                    {
                        "id": 66724,
                        "name": "Alzingen",
                        "latitude": "49.56500000",
                        "longitude": "6.16361000"
                    },
                    {
                        "id": 66746,
                        "name": "Béreldange",
                        "latitude": "49.65507000",
                        "longitude": "6.11874000"
                    },
                    {
                        "id": 66734,
                        "name": "Bertrange",
                        "latitude": "49.61111000",
                        "longitude": "6.05000000"
                    },
                    {
                        "id": 66754,
                        "name": "Contern",
                        "latitude": "49.58194000",
                        "longitude": "6.22667000"
                    },
                    {
                        "id": 66768,
                        "name": "Fentange",
                        "latitude": "49.56278000",
                        "longitude": "6.15389000"
                    },
                    {
                        "id": 66780,
                        "name": "Heisdorf",
                        "latitude": "49.67207000",
                        "longitude": "6.14202000"
                    },
                    {
                        "id": 66781,
                        "name": "Helmsange",
                        "latitude": "49.65278000",
                        "longitude": "6.14139000"
                    },
                    {
                        "id": 66782,
                        "name": "Hesperange",
                        "latitude": "49.56806000",
                        "longitude": "6.15139000"
                    },
                    {
                        "id": 66785,
                        "name": "Itzig",
                        "latitude": "49.58769000",
                        "longitude": "6.17065000"
                    },
                    {
                        "id": 66790,
                        "name": "Kirchberg",
                        "latitude": "49.62389000",
                        "longitude": "6.14944000"
                    },
                    {
                        "id": 66801,
                        "name": "Luxembourg",
                        "latitude": "49.61167000",
                        "longitude": "6.13000000"
                    },
                    {
                        "id": 66811,
                        "name": "Moutfort",
                        "latitude": "49.58528000",
                        "longitude": "6.25556000"
                    },
                    {
                        "id": 66812,
                        "name": "Müllendorf",
                        "latitude": "49.68028000",
                        "longitude": "6.13000000"
                    },
                    {
                        "id": 66813,
                        "name": "Niederanven",
                        "latitude": "49.65196000",
                        "longitude": "6.26199000"
                    },
                    {
                        "id": 66818,
                        "name": "Olm",
                        "latitude": "49.65722000",
                        "longitude": "6.00028000"
                    },
                    {
                        "id": 66834,
                        "name": "Sandweiler",
                        "latitude": "49.61471000",
                        "longitude": "6.22221000"
                    },
                    {
                        "id": 66840,
                        "name": "Schrassig",
                        "latitude": "49.61014000",
                        "longitude": "6.25903000"
                    },
                    {
                        "id": 66841,
                        "name": "Schuttrange",
                        "latitude": "49.62056000",
                        "longitude": "6.26861000"
                    },
                    {
                        "id": 66846,
                        "name": "Steinsel",
                        "latitude": "49.67694000",
                        "longitude": "6.12389000"
                    },
                    {
                        "id": 66847,
                        "name": "Strassen",
                        "latitude": "49.62056000",
                        "longitude": "6.07333000"
                    },
                    {
                        "id": 66858,
                        "name": "Walferdange",
                        "latitude": "49.66321000",
                        "longitude": "6.13224000"
                    },
                    {
                        "id": 66861,
                        "name": "Weiler-la-Tour",
                        "latitude": "49.54083000",
                        "longitude": "6.20083000"
                    }
                ]
            },
            {
                "id": 1522,
                "name": "Mersch",
                "iso2": "ME",
                "latitude": "49.75429060",
                "longitude": "6.12921850",
                "type": "canton",
                "cities": [
                    {
                        "id": 66739,
                        "name": "Bissen",
                        "latitude": "49.78733000",
                        "longitude": "6.06540000"
                    },
                    {
                        "id": 66741,
                        "name": "Boevange-sur-Attert",
                        "latitude": "49.77256000",
                        "longitude": "6.01532000"
                    },
                    {
                        "id": 66750,
                        "name": "Colmar",
                        "latitude": "49.81028000",
                        "longitude": "6.09722000"
                    },
                    {
                        "id": 66770,
                        "name": "Fischbach",
                        "latitude": "49.74600000",
                        "longitude": "6.18702000"
                    },
                    {
                        "id": 66779,
                        "name": "Heffingen",
                        "latitude": "49.76907000",
                        "longitude": "6.24049000"
                    },
                    {
                        "id": 66796,
                        "name": "Larochette",
                        "latitude": "49.78362000",
                        "longitude": "6.21891000"
                    },
                    {
                        "id": 66799,
                        "name": "Lintgen",
                        "latitude": "49.72243000",
                        "longitude": "6.13016000"
                    },
                    {
                        "id": 66800,
                        "name": "Lorentzweiler",
                        "latitude": "49.70131000",
                        "longitude": "6.14234000"
                    },
                    {
                        "id": 66805,
                        "name": "Mersch",
                        "latitude": "49.74889000",
                        "longitude": "6.10611000"
                    },
                    {
                        "id": 66816,
                        "name": "Nommern",
                        "latitude": "49.78694000",
                        "longitude": "6.17472000"
                    },
                    {
                        "id": 66830,
                        "name": "Rollingen",
                        "latitude": "49.74167000",
                        "longitude": "6.11444000"
                    },
                    {
                        "id": 66850,
                        "name": "Tuntange",
                        "latitude": "49.71778000",
                        "longitude": "6.01028000"
                    }
                ]
            },
            {
                "id": 1516,
                "name": "Redange",
                "iso2": "RD",
                "latitude": "49.76455000",
                "longitude": "5.88948000",
                "type": "canton",
                "cities": [
                    {
                        "id": 66730,
                        "name": "Beckerich",
                        "latitude": "49.73056000",
                        "longitude": "5.88722000"
                    },
                    {
                        "id": 66735,
                        "name": "Bettborn",
                        "latitude": "49.79528000",
                        "longitude": "5.94111000"
                    },
                    {
                        "id": 66751,
                        "name": "Commune de Préizerdaul",
                        "latitude": "49.80114000",
                        "longitude": "5.93299000"
                    },
                    {
                        "id": 66763,
                        "name": "Ell",
                        "latitude": "49.76389000",
                        "longitude": "5.85722000"
                    },
                    {
                        "id": 66777,
                        "name": "Grosbous",
                        "latitude": "49.82778000",
                        "longitude": "5.96722000"
                    },
                    {
                        "id": 66823,
                        "name": "Rambrouch",
                        "latitude": "49.83083000",
                        "longitude": "5.84500000"
                    },
                    {
                        "id": 66825,
                        "name": "Redange-sur-Attert",
                        "latitude": "49.76437000",
                        "longitude": "5.88997000"
                    },
                    {
                        "id": 66833,
                        "name": "Saeul",
                        "latitude": "49.72722000",
                        "longitude": "5.98639000"
                    },
                    {
                        "id": 66852,
                        "name": "Useldange",
                        "latitude": "49.76972000",
                        "longitude": "5.98222000"
                    },
                    {
                        "id": 66854,
                        "name": "Vichten",
                        "latitude": "49.80306000",
                        "longitude": "6.00000000"
                    },
                    {
                        "id": 66855,
                        "name": "Wahl",
                        "latitude": "49.83667000",
                        "longitude": "5.90639000"
                    }
                ]
            },
            {
                "id": 1519,
                "name": "Remich",
                "iso2": "RM",
                "latitude": "49.54501700",
                "longitude": "6.36742220",
                "type": "canton",
                "cities": [
                    {
                        "id": 66744,
                        "name": "Bous",
                        "latitude": "49.55389000",
                        "longitude": "6.32917000"
                    },
                    {
                        "id": 66756,
                        "name": "Dalheim",
                        "latitude": "49.54083000",
                        "longitude": "6.25972000"
                    },
                    {
                        "id": 66797,
                        "name": "Lenningen",
                        "latitude": "49.59861000",
                        "longitude": "6.36806000"
                    },
                    {
                        "id": 66810,
                        "name": "Mondorf-les-Bains",
                        "latitude": "49.50500000",
                        "longitude": "6.28111000"
                    },
                    {
                        "id": 66827,
                        "name": "Remich",
                        "latitude": "49.54500000",
                        "longitude": "6.36694000"
                    },
                    {
                        "id": 66836,
                        "name": "Schengen",
                        "latitude": "49.47000000",
                        "longitude": "6.36200000"
                    },
                    {
                        "id": 66844,
                        "name": "Stadtbredimus",
                        "latitude": "49.56278000",
                        "longitude": "6.36444000"
                    },
                    {
                        "id": 66857,
                        "name": "Waldbredimus",
                        "latitude": "49.55676000",
                        "longitude": "6.28789000"
                    }
                ]
            },
            {
                "id": 1523,
                "name": "Vianden",
                "iso2": "VD",
                "latitude": "49.93419240",
                "longitude": "6.20199170",
                "type": "canton",
                "cities": [
                    {
                        "id": 66821,
                        "name": "Putscheid",
                        "latitude": "49.96083000",
                        "longitude": "6.14306000"
                    },
                    {
                        "id": 66848,
                        "name": "Tandel",
                        "latitude": "49.89750000",
                        "longitude": "6.18333000"
                    },
                    {
                        "id": 66853,
                        "name": "Vianden",
                        "latitude": "49.93500000",
                        "longitude": "6.20889000"
                    }
                ]
            },
            {
                "id": 1526,
                "name": "Wiltz",
                "iso2": "WI",
                "latitude": "49.96622000",
                "longitude": "5.93243060",
                "type": "canton",
                "cities": [
                    {
                        "id": 66727,
                        "name": "Bavigne",
                        "latitude": "49.92194000",
                        "longitude": "5.84944000"
                    },
                    {
                        "id": 66742,
                        "name": "Boulaide",
                        "latitude": "49.88778000",
                        "longitude": "5.81639000"
                    },
                    {
                        "id": 66766,
                        "name": "Esch-sur-Sûre",
                        "latitude": "49.91139000",
                        "longitude": "5.93639000"
                    },
                    {
                        "id": 66774,
                        "name": "Goesdorf",
                        "latitude": "49.92131000",
                        "longitude": "5.96601000"
                    },
                    {
                        "id": 66789,
                        "name": "Kiischpelt",
                        "latitude": "49.97835000",
                        "longitude": "6.00760000"
                    },
                    {
                        "id": 66794,
                        "name": "Lac de la Haute-Sûre",
                        "latitude": "49.91667000",
                        "longitude": "5.83333000"
                    },
                    {
                        "id": 66863,
                        "name": "Wiltz",
                        "latitude": "49.96547000",
                        "longitude": "5.93390000"
                    },
                    {
                        "id": 66864,
                        "name": "Wilwerwiltz",
                        "latitude": "49.98889000",
                        "longitude": "5.99917000"
                    },
                    {
                        "id": 66866,
                        "name": "Winseler",
                        "latitude": "49.96778000",
                        "longitude": "5.89028000"
                    }
                ]
            }
        ]
    },
    {
        "id": 128,
        "name": "Macau S.A.R.",
        "iso3": "MAC",
        "iso2": "MO",
        "numeric_code": "446",
        "phonecode": "853",
        "capital": "Macao",
        "currency": "MOP",
        "currency_name": "Macanese pataca",
        "currency_symbol": "$",
        "tld": ".mo",
        "native": "澳門",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Eastern Asia",
        "subregion_id": 12,
        "nationality": "Macanese, Chinese",
        "timezones": [
            {
                "zoneName": "Asia\/Macau",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "CST",
                "tzName": "China Standard Time"
            }
        ],
        "translations": {
            "br": "Makao",
            "ko": "마카오",
            "pt-BR": "Macau",
            "pt": "Macau",
            "nl": "Macao",
            "hr": "Makao",
            "fa": "مکائو",
            "de": "Macao",
            "es": "Macao",
            "fr": "Macao",
            "ja": "マカオ",
            "it": "Macao",
            "zh-CN": "中国澳门",
            "tr": "Makao",
            "ru": "Макао С.А.Р.",
            "uk": "САР Макао.",
            "pl": "Macau S.A.R."
        },
        "latitude": "22.16666666",
        "longitude": "113.55000000",
        "emoji": "🇲🇴",
        "emojiU": "U+1F1F2 U+1F1F4",
        "states": []
    },
    {
        "id": 130,
        "name": "Madagascar",
        "iso3": "MDG",
        "iso2": "MG",
        "numeric_code": "450",
        "phonecode": "261",
        "capital": "Antananarivo",
        "currency": "MGA",
        "currency_name": "Malagasy ariary",
        "currency_symbol": "Ar",
        "tld": ".mg",
        "native": "Madagasikara",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Malagasy",
        "timezones": [
            {
                "zoneName": "Indian\/Antananarivo",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Madagaskar",
            "ko": "마다가스카르",
            "pt-BR": "Madagascar",
            "pt": "Madagáscar",
            "nl": "Madagaskar",
            "hr": "Madagaskar",
            "fa": "ماداگاسکار",
            "de": "Madagaskar",
            "es": "Madagascar",
            "fr": "Madagascar",
            "ja": "マダガスカル",
            "it": "Madagascar",
            "zh-CN": "马达加斯加",
            "tr": "Madagaskar",
            "ru": "Мадагаскар",
            "uk": "Мадагаскар",
            "pl": "Madagaskar"
        },
        "latitude": "-20.00000000",
        "longitude": "47.00000000",
        "emoji": "🇲🇬",
        "emojiU": "U+1F1F2 U+1F1EC",
        "states": [
            {
                "id": 2951,
                "name": "Antananarivo",
                "iso2": "T",
                "latitude": "-18.70514740",
                "longitude": "46.82528380",
                "type": "province",
                "cities": []
            },
            {
                "id": 2950,
                "name": "Antsiranana",
                "iso2": "D",
                "latitude": "-13.77153900",
                "longitude": "49.52799960",
                "type": "province",
                "cities": [
                    {
                        "id": 67377,
                        "name": "Ampasimanolotra",
                        "latitude": "-18.81667000",
                        "longitude": "49.06667000"
                    },
                    {
                        "id": 67378,
                        "name": "Andovoranto",
                        "latitude": "-18.95443000",
                        "longitude": "49.10940000"
                    },
                    {
                        "id": 67379,
                        "name": "Mahanoro",
                        "latitude": "-19.90000000",
                        "longitude": "48.80000000"
                    },
                    {
                        "id": 67380,
                        "name": "Mahavelona",
                        "latitude": "-17.68475000",
                        "longitude": "49.50869000"
                    },
                    {
                        "id": 67381,
                        "name": "Marolambo",
                        "latitude": "-20.05000000",
                        "longitude": "48.11667000"
                    },
                    {
                        "id": 67382,
                        "name": "Toamasina",
                        "latitude": "-18.14920000",
                        "longitude": "49.40234000"
                    },
                    {
                        "id": 67383,
                        "name": "Toamasina I",
                        "latitude": "-18.13863000",
                        "longitude": "49.39203000"
                    },
                    {
                        "id": 67384,
                        "name": "Toamasina II",
                        "latitude": "-17.94053000",
                        "longitude": "49.14608000"
                    },
                    {
                        "id": 67385,
                        "name": "Vohibinany",
                        "latitude": "-17.35000000",
                        "longitude": "49.03333000"
                    }
                ]
            },
            {
                "id": 2948,
                "name": "Fianarantsoa",
                "iso2": "F",
                "latitude": "-22.35362400",
                "longitude": "46.82528380",
                "type": "province",
                "cities": []
            },
            {
                "id": 2953,
                "name": "Mahajanga",
                "iso2": "M",
                "latitude": "-16.52388300",
                "longitude": "46.51626200",
                "type": "province",
                "cities": []
            },
            {
                "id": 2952,
                "name": "Toamasina",
                "iso2": "A",
                "latitude": "-18.14428110",
                "longitude": "49.39578360",
                "type": "province",
                "cities": []
            },
            {
                "id": 2949,
                "name": "Toliara",
                "iso2": "U",
                "latitude": "-23.35161910",
                "longitude": "43.68549360",
                "type": "province",
                "cities": []
            }
        ]
    },
    {
        "id": 131,
        "name": "Malawi",
        "iso3": "MWI",
        "iso2": "MW",
        "numeric_code": "454",
        "phonecode": "265",
        "capital": "Lilongwe",
        "currency": "MWK",
        "currency_name": "Malawian kwacha",
        "currency_symbol": "MK",
        "tld": ".mw",
        "native": "Malawi",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Malawian",
        "timezones": [
            {
                "zoneName": "Africa\/Blantyre",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "br": "Malawi",
            "ko": "말라위",
            "pt-BR": "Malawi",
            "pt": "Malávi",
            "nl": "Malawi",
            "hr": "Malavi",
            "fa": "مالاوی",
            "de": "Malawi",
            "es": "Malawi",
            "fr": "Malawi",
            "ja": "マラウイ",
            "it": "Malawi",
            "zh-CN": "马拉维",
            "tr": "Malavi",
            "ru": "Малави",
            "uk": "Малаві",
            "pl": "Malawi"
        },
        "latitude": "-13.50000000",
        "longitude": "34.00000000",
        "emoji": "🇲🇼",
        "emojiU": "U+1F1F2 U+1F1FC",
        "states": [
            {
                "id": 3096,
                "name": "Balaka",
                "iso2": "BA",
                "latitude": "-15.05065950",
                "longitude": "35.08285880",
                "type": "district",
                "cities": []
            },
            {
                "id": 3102,
                "name": "Blantyre",
                "iso2": "BL",
                "latitude": "-15.67785410",
                "longitude": "34.95066250",
                "type": "district",
                "cities": []
            },
            {
                "id": 3092,
                "name": "Central",
                "iso2": "C",
                "latitude": "-13.74023640",
                "longitude": "32.50396190",
                "type": "region",
                "cities": [
                    {
                        "id": 67950,
                        "name": "Chipoka",
                        "latitude": "-13.99329000",
                        "longitude": "34.51566000"
                    },
                    {
                        "id": 67955,
                        "name": "Dedza",
                        "latitude": "-14.37790000",
                        "longitude": "34.33322000"
                    },
                    {
                        "id": 67956,
                        "name": "Dedza District",
                        "latitude": "-14.26273000",
                        "longitude": "34.18559000"
                    },
                    {
                        "id": 67957,
                        "name": "Dowa",
                        "latitude": "-13.65399000",
                        "longitude": "33.93754000"
                    },
                    {
                        "id": 67958,
                        "name": "Dowa District",
                        "latitude": "-13.60098000",
                        "longitude": "33.82378000"
                    },
                    {
                        "id": 67961,
                        "name": "Kasungu",
                        "latitude": "-13.03333000",
                        "longitude": "33.48333000"
                    },
                    {
                        "id": 67962,
                        "name": "Kasungu District",
                        "latitude": "-13.00000000",
                        "longitude": "33.41667000"
                    },
                    {
                        "id": 67964,
                        "name": "Lilongwe",
                        "latitude": "-13.96692000",
                        "longitude": "33.78725000"
                    },
                    {
                        "id": 67965,
                        "name": "Lilongwe District",
                        "latitude": "-14.01962000",
                        "longitude": "33.68407000"
                    },
                    {
                        "id": 67973,
                        "name": "Mchinji",
                        "latitude": "-13.79841000",
                        "longitude": "32.88019000"
                    },
                    {
                        "id": 67974,
                        "name": "Mchinji District",
                        "latitude": "-13.76230000",
                        "longitude": "33.07998000"
                    },
                    {
                        "id": 67976,
                        "name": "Mponela",
                        "latitude": "-13.53194000",
                        "longitude": "33.74008000"
                    },
                    {
                        "id": 67987,
                        "name": "Nkhotakota",
                        "latitude": "-12.92744000",
                        "longitude": "34.29614000"
                    },
                    {
                        "id": 67988,
                        "name": "Nkhotakota District",
                        "latitude": "-12.80417000",
                        "longitude": "34.08298000"
                    },
                    {
                        "id": 67991,
                        "name": "Ntcheu",
                        "latitude": "-14.82027000",
                        "longitude": "34.63586000"
                    },
                    {
                        "id": 67992,
                        "name": "Ntcheu District",
                        "latitude": "-14.75000000",
                        "longitude": "34.75000000"
                    },
                    {
                        "id": 67993,
                        "name": "Ntchisi",
                        "latitude": "-13.52775000",
                        "longitude": "33.91490000"
                    },
                    {
                        "id": 67994,
                        "name": "Ntchisi District",
                        "latitude": "-13.29574000",
                        "longitude": "33.90798000"
                    },
                    {
                        "id": 67999,
                        "name": "Salima",
                        "latitude": "-13.78040000",
                        "longitude": "34.45870000"
                    },
                    {
                        "id": 68000,
                        "name": "Salima District",
                        "latitude": "-13.71959000",
                        "longitude": "34.40184000"
                    }
                ]
            },
            {
                "id": 3107,
                "name": "Chikwawa",
                "iso2": "CK",
                "latitude": "-16.19584460",
                "longitude": "34.77407930",
                "type": "district",
                "cities": []
            },
            {
                "id": 3109,
                "name": "Chiradzulu",
                "iso2": "CR",
                "latitude": "-15.74231510",
                "longitude": "35.25879640",
                "type": "district",
                "cities": []
            },
            {
                "id": 3087,
                "name": "Chitipa",
                "iso2": "CT",
                "latitude": "-9.70376550",
                "longitude": "33.27002530",
                "type": "district",
                "cities": []
            },
            {
                "id": 3097,
                "name": "Dedza",
                "iso2": "DE",
                "latitude": "-14.18945850",
                "longitude": "34.24215970",
                "type": "district",
                "cities": []
            },
            {
                "id": 3090,
                "name": "Dowa",
                "iso2": "DO",
                "latitude": "-13.60412560",
                "longitude": "33.88577470",
                "type": "district",
                "cities": []
            },
            {
                "id": 3091,
                "name": "Karonga",
                "iso2": "KR",
                "latitude": "-9.90363650",
                "longitude": "33.97500180",
                "type": "district",
                "cities": []
            },
            {
                "id": 3094,
                "name": "Kasungu",
                "iso2": "KS",
                "latitude": "-13.13670650",
                "longitude": "33.25879300",
                "type": "district",
                "cities": []
            },
            {
                "id": 3093,
                "name": "Likoma",
                "iso2": "LK",
                "latitude": "-12.05840050",
                "longitude": "34.73540310",
                "type": "district",
                "cities": []
            },
            {
                "id": 3101,
                "name": "Lilongwe",
                "iso2": "LI",
                "latitude": "-14.04752280",
                "longitude": "33.61757700",
                "type": "district",
                "cities": []
            },
            {
                "id": 3082,
                "name": "Machinga",
                "iso2": "MH",
                "latitude": "-14.94072630",
                "longitude": "35.47819260",
                "type": "district",
                "cities": []
            },
            {
                "id": 3110,
                "name": "Mangochi",
                "iso2": "MG",
                "latitude": "-14.13882480",
                "longitude": "35.03881640",
                "type": "district",
                "cities": []
            },
            {
                "id": 3099,
                "name": "Mchinji",
                "iso2": "MC",
                "latitude": "-13.74015250",
                "longitude": "32.98883190",
                "type": "district",
                "cities": []
            },
            {
                "id": 3103,
                "name": "Mulanje",
                "iso2": "MU",
                "latitude": "-15.93464340",
                "longitude": "35.52200120",
                "type": "district",
                "cities": []
            },
            {
                "id": 3084,
                "name": "Mwanza",
                "iso2": "MW",
                "latitude": "-15.40085520",
                "longitude": "34.40492400",
                "type": "district",
                "cities": []
            },
            {
                "id": 3104,
                "name": "Mzimba",
                "iso2": "MZ",
                "latitude": "-11.74754520",
                "longitude": "33.52800720",
                "type": "district",
                "cities": []
            },
            {
                "id": 5347,
                "name": "Neno",
                "iso2": "NE",
                "latitude": "-15.69042540",
                "longitude": "34.22913860",
                "type": "district",
                "cities": []
            },
            {
                "id": 3095,
                "name": "Nkhata Bay",
                "iso2": "NB",
                "latitude": "-11.71850420",
                "longitude": "34.33103640",
                "type": "district",
                "cities": []
            },
            {
                "id": 3100,
                "name": "Nkhotakota",
                "iso2": "NK",
                "latitude": "-12.75419610",
                "longitude": "34.24215970",
                "type": "district",
                "cities": []
            },
            {
                "id": 3105,
                "name": "Northern",
                "iso2": "N",
                "latitude": "-11.04950910",
                "longitude": "32.63414610",
                "type": "region",
                "cities": [
                    {
                        "id": 67953,
                        "name": "Chitipa",
                        "latitude": "-9.70237000",
                        "longitude": "33.26969000"
                    },
                    {
                        "id": 67954,
                        "name": "Chitipa District",
                        "latitude": "-9.92727000",
                        "longitude": "33.42541000"
                    },
                    {
                        "id": 67959,
                        "name": "Karonga",
                        "latitude": "-9.93333000",
                        "longitude": "33.93333000"
                    },
                    {
                        "id": 67960,
                        "name": "Karonga District",
                        "latitude": "-10.11153000",
                        "longitude": "33.88151000"
                    },
                    {
                        "id": 67963,
                        "name": "Likoma District",
                        "latitude": "-12.06065000",
                        "longitude": "34.73608000"
                    },
                    {
                        "id": 67966,
                        "name": "Livingstonia",
                        "latitude": "-10.60602000",
                        "longitude": "34.10628000"
                    },
                    {
                        "id": 67981,
                        "name": "Mzimba",
                        "latitude": "-11.90000000",
                        "longitude": "33.60000000"
                    },
                    {
                        "id": 67982,
                        "name": "Mzimba District",
                        "latitude": "-11.85428000",
                        "longitude": "33.60778000"
                    },
                    {
                        "id": 67983,
                        "name": "Mzuzu",
                        "latitude": "-11.46556000",
                        "longitude": "34.02071000"
                    },
                    {
                        "id": 67985,
                        "name": "Nkhata Bay",
                        "latitude": "-11.60659000",
                        "longitude": "34.29073000"
                    },
                    {
                        "id": 67986,
                        "name": "Nkhata Bay District",
                        "latitude": "-11.65304000",
                        "longitude": "34.05322000"
                    },
                    {
                        "id": 67997,
                        "name": "Rumphi",
                        "latitude": "-11.01863000",
                        "longitude": "33.85746000"
                    },
                    {
                        "id": 67998,
                        "name": "Rumphi District",
                        "latitude": "-10.80292000",
                        "longitude": "33.80524000"
                    }
                ]
            },
            {
                "id": 3085,
                "name": "Nsanje",
                "iso2": "NS",
                "latitude": "-16.72882020",
                "longitude": "35.17087410",
                "type": "district",
                "cities": []
            },
            {
                "id": 3088,
                "name": "Ntcheu",
                "iso2": "NU",
                "latitude": "-14.90375380",
                "longitude": "34.77407930",
                "type": "district",
                "cities": []
            },
            {
                "id": 3111,
                "name": "Ntchisi",
                "iso2": "NI",
                "latitude": "-13.28419920",
                "longitude": "33.88577470",
                "type": "district",
                "cities": []
            },
            {
                "id": 3108,
                "name": "Phalombe",
                "iso2": "PH",
                "latitude": "-15.70920380",
                "longitude": "35.65328480",
                "type": "district",
                "cities": []
            },
            {
                "id": 3089,
                "name": "Rumphi",
                "iso2": "RU",
                "latitude": "-10.78515370",
                "longitude": "34.33103640",
                "type": "district",
                "cities": []
            },
            {
                "id": 3086,
                "name": "Salima",
                "iso2": "SA",
                "latitude": "-13.68095860",
                "longitude": "34.41982430",
                "type": "district",
                "cities": []
            },
            {
                "id": 3106,
                "name": "Southern",
                "iso2": "S",
                "latitude": "-15.30244780",
                "longitude": "33.76440830",
                "type": "region",
                "cities": [
                    {
                        "id": 67944,
                        "name": "Balaka",
                        "latitude": "-14.97928000",
                        "longitude": "34.95575000"
                    },
                    {
                        "id": 67945,
                        "name": "Balaka District",
                        "latitude": "-15.04839000",
                        "longitude": "35.05910000"
                    },
                    {
                        "id": 67946,
                        "name": "Blantyre",
                        "latitude": "-15.78499000",
                        "longitude": "35.00854000"
                    },
                    {
                        "id": 67947,
                        "name": "Blantyre District",
                        "latitude": "-15.64732000",
                        "longitude": "34.93956000"
                    },
                    {
                        "id": 67948,
                        "name": "Chikwawa",
                        "latitude": "-16.03352000",
                        "longitude": "34.80091000"
                    },
                    {
                        "id": 67949,
                        "name": "Chikwawa District",
                        "latitude": "-16.16667000",
                        "longitude": "34.75000000"
                    },
                    {
                        "id": 67951,
                        "name": "Chiradzulu",
                        "latitude": "-15.67461000",
                        "longitude": "35.14071000"
                    },
                    {
                        "id": 67952,
                        "name": "Chiradzulu District",
                        "latitude": "-15.75268000",
                        "longitude": "35.21576000"
                    },
                    {
                        "id": 67967,
                        "name": "Liwonde",
                        "latitude": "-15.06665000",
                        "longitude": "35.22543000"
                    },
                    {
                        "id": 67968,
                        "name": "Luchenza",
                        "latitude": "-16.00693000",
                        "longitude": "35.30947000"
                    },
                    {
                        "id": 67969,
                        "name": "Machinga",
                        "latitude": "-15.16849000",
                        "longitude": "35.30002000"
                    },
                    {
                        "id": 67970,
                        "name": "Machinga District",
                        "latitude": "-14.94583000",
                        "longitude": "35.57367000"
                    },
                    {
                        "id": 67971,
                        "name": "Mangochi",
                        "latitude": "-14.47815000",
                        "longitude": "35.26448000"
                    },
                    {
                        "id": 67972,
                        "name": "Mangochi District",
                        "latitude": "-14.39296000",
                        "longitude": "35.34658000"
                    },
                    {
                        "id": 67975,
                        "name": "Monkey Bay",
                        "latitude": "-14.08239000",
                        "longitude": "34.91652000"
                    },
                    {
                        "id": 67977,
                        "name": "Mulanje",
                        "latitude": "-16.03163000",
                        "longitude": "35.50000000"
                    },
                    {
                        "id": 67978,
                        "name": "Mulanje District",
                        "latitude": "-15.93440000",
                        "longitude": "35.49990000"
                    },
                    {
                        "id": 67979,
                        "name": "Mwanza",
                        "latitude": "-15.60262000",
                        "longitude": "34.52479000"
                    },
                    {
                        "id": 67980,
                        "name": "Mwanza District",
                        "latitude": "-15.63337000",
                        "longitude": "34.51682000"
                    },
                    {
                        "id": 67984,
                        "name": "Neno District",
                        "latitude": "-15.45051000",
                        "longitude": "34.70034000"
                    },
                    {
                        "id": 67989,
                        "name": "Nsanje",
                        "latitude": "-16.91995000",
                        "longitude": "35.26199000"
                    },
                    {
                        "id": 67990,
                        "name": "Nsanje District",
                        "latitude": "-16.75000000",
                        "longitude": "35.16667000"
                    },
                    {
                        "id": 67995,
                        "name": "Phalombe",
                        "latitude": "-15.80635000",
                        "longitude": "35.65067000"
                    },
                    {
                        "id": 67996,
                        "name": "Phalombe District",
                        "latitude": "-15.66667000",
                        "longitude": "35.66667000"
                    },
                    {
                        "id": 68001,
                        "name": "Thyolo",
                        "latitude": "-16.06775000",
                        "longitude": "35.14046000"
                    },
                    {
                        "id": 68002,
                        "name": "Thyolo District",
                        "latitude": "-16.10583000",
                        "longitude": "35.15060000"
                    },
                    {
                        "id": 68003,
                        "name": "Zomba",
                        "latitude": "-15.38596000",
                        "longitude": "35.31880000"
                    },
                    {
                        "id": 68004,
                        "name": "Zomba District",
                        "latitude": "-15.43007000",
                        "longitude": "35.41829000"
                    }
                ]
            },
            {
                "id": 3098,
                "name": "Thyolo",
                "iso2": "TH",
                "latitude": "-16.12991770",
                "longitude": "35.12687810",
                "type": "district",
                "cities": []
            },
            {
                "id": 3083,
                "name": "Zomba",
                "iso2": "ZO",
                "latitude": "-15.37658570",
                "longitude": "35.33565180",
                "type": "district",
                "cities": []
            }
        ]
    },
    {
        "id": 132,
        "name": "Malaysia",
        "iso3": "MYS",
        "iso2": "MY",
        "numeric_code": "458",
        "phonecode": "60",
        "capital": "Kuala Lumpur",
        "currency": "MYR",
        "currency_name": "Malaysian ringgit",
        "currency_symbol": "RM",
        "tld": ".my",
        "native": "Malaysia",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Malaysian",
        "timezones": [
            {
                "zoneName": "Asia\/Kuala_Lumpur",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "MYT",
                "tzName": "Malaysia Time"
            },
            {
                "zoneName": "Asia\/Kuching",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "MYT",
                "tzName": "Malaysia Time"
            }
        ],
        "translations": {
            "br": "Malaysia",
            "ko": "말레이시아",
            "pt-BR": "Malásia",
            "pt": "Malásia",
            "nl": "Maleisië",
            "hr": "Malezija",
            "fa": "مالزی",
            "de": "Malaysia",
            "es": "Malasia",
            "fr": "Malaisie",
            "ja": "マレーシア",
            "it": "Malesia",
            "zh-CN": "马来西亚",
            "tr": "Malezya",
            "ru": "Малайзия",
            "uk": "Малайзія",
            "pl": "Malezja"
        },
        "latitude": "2.50000000",
        "longitude": "112.50000000",
        "emoji": "🇲🇾",
        "emojiU": "U+1F1F2 U+1F1FE",
        "states": [
            {
                "id": 1950,
                "name": "Johor",
                "iso2": "01",
                "latitude": "1.48536820",
                "longitude": "103.76181540",
                "type": "state",
                "cities": [
                    {
                        "id": 76416,
                        "name": "Bakri",
                        "latitude": "2.04410000",
                        "longitude": "102.65270000"
                    },
                    {
                        "id": 76424,
                        "name": "Batu Pahat",
                        "latitude": "1.85480000",
                        "longitude": "102.93250000"
                    },
                    {
                        "id": 76433,
                        "name": "Buloh Kasap",
                        "latitude": "2.55360000",
                        "longitude": "102.76400000"
                    },
                    {
                        "id": 76435,
                        "name": "Chaah",
                        "latitude": "2.24900000",
                        "longitude": "103.04800000"
                    },
                    {
                        "id": 76437,
                        "name": "Daerah Batu Pahat",
                        "latitude": "1.93333000",
                        "longitude": "103.00000000"
                    },
                    {
                        "id": 76438,
                        "name": "Daerah Johor Baharu",
                        "latitude": "1.65000000",
                        "longitude": "103.60000000"
                    },
                    {
                        "id": 76439,
                        "name": "Daerah Keluang",
                        "latitude": "2.20000000",
                        "longitude": "103.33333000"
                    },
                    {
                        "id": 76440,
                        "name": "Daerah Kota Tinggi",
                        "latitude": "1.81667000",
                        "longitude": "103.96667000"
                    },
                    {
                        "id": 76441,
                        "name": "Daerah Mersing",
                        "latitude": "2.31667000",
                        "longitude": "103.71667000"
                    },
                    {
                        "id": 76442,
                        "name": "Daerah Muar",
                        "latitude": "2.25000000",
                        "longitude": "102.75000000"
                    },
                    {
                        "id": 76443,
                        "name": "Daerah Pontian",
                        "latitude": "1.50000000",
                        "longitude": "103.50000000"
                    },
                    {
                        "id": 76444,
                        "name": "Daerah Segamat",
                        "latitude": "2.60000000",
                        "longitude": "102.81667000"
                    },
                    {
                        "id": 76455,
                        "name": "Johor Bahru",
                        "latitude": "1.46550000",
                        "longitude": "103.75780000"
                    },
                    {
                        "id": 76473,
                        "name": "Kampung Pasir Gudang Baru",
                        "latitude": "1.47260000",
                        "longitude": "103.87800000"
                    },
                    {
                        "id": 76474,
                        "name": "Kampung Simpang Renggam",
                        "latitude": "1.82780000",
                        "longitude": "103.30000000"
                    },
                    {
                        "id": 76480,
                        "name": "Kelapa Sawit",
                        "latitude": "1.66980000",
                        "longitude": "103.53270000"
                    },
                    {
                        "id": 76487,
                        "name": "Kluang",
                        "latitude": "2.03046000",
                        "longitude": "103.31689000"
                    },
                    {
                        "id": 76491,
                        "name": "Kota Tinggi",
                        "latitude": "1.73810000",
                        "longitude": "103.89990000"
                    },
                    {
                        "id": 76508,
                        "name": "Kulai",
                        "latitude": "1.65610000",
                        "longitude": "103.60320000"
                    },
                    {
                        "id": 76510,
                        "name": "Labis",
                        "latitude": "2.38500000",
                        "longitude": "103.02100000"
                    },
                    {
                        "id": 76524,
                        "name": "Mersing",
                        "latitude": "2.43120000",
                        "longitude": "103.84050000"
                    },
                    {
                        "id": 76526,
                        "name": "Muar",
                        "latitude": "2.04420000",
                        "longitude": "102.56890000"
                    },
                    {
                        "id": 76535,
                        "name": "Parit Raja",
                        "latitude": "1.86810000",
                        "longitude": "103.11240000"
                    },
                    {
                        "id": 76538,
                        "name": "Pekan Nenas",
                        "latitude": "1.51000000",
                        "longitude": "103.51410000"
                    },
                    {
                        "id": 76544,
                        "name": "Pontian Kechil",
                        "latitude": "1.48660000",
                        "longitude": "103.38960000"
                    },
                    {
                        "id": 76556,
                        "name": "Segamat",
                        "latitude": "2.51480000",
                        "longitude": "102.81580000"
                    },
                    {
                        "id": 76565,
                        "name": "Skudai",
                        "latitude": "1.53741000",
                        "longitude": "103.65779000"
                    },
                    {
                        "id": 76573,
                        "name": "Taman Senai",
                        "latitude": "1.60060000",
                        "longitude": "103.64190000"
                    },
                    {
                        "id": 76576,
                        "name": "Tangkak",
                        "latitude": "2.26730000",
                        "longitude": "102.54530000"
                    },
                    {
                        "id": 76586,
                        "name": "Ulu Tiram",
                        "latitude": "1.60000000",
                        "longitude": "103.81667000"
                    },
                    {
                        "id": 76587,
                        "name": "Yong Peng",
                        "latitude": "2.01360000",
                        "longitude": "103.06590000"
                    }
                ]
            },
            {
                "id": 1947,
                "name": "Kedah",
                "iso2": "02",
                "latitude": "6.11839640",
                "longitude": "100.36845950",
                "type": "state",
                "cities": [
                    {
                        "id": 76410,
                        "name": "Alor Setar",
                        "latitude": "6.12104000",
                        "longitude": "100.36014000"
                    },
                    {
                        "id": 76412,
                        "name": "Ayer Hangat",
                        "latitude": "6.42062000",
                        "longitude": "99.82199000"
                    },
                    {
                        "id": 76426,
                        "name": "Bedong",
                        "latitude": "5.72743000",
                        "longitude": "100.50876000"
                    },
                    {
                        "id": 76449,
                        "name": "Gurun",
                        "latitude": "5.81717000",
                        "longitude": "100.47381000"
                    },
                    {
                        "id": 76454,
                        "name": "Jitra",
                        "latitude": "6.26812000",
                        "longitude": "100.42167000"
                    },
                    {
                        "id": 76470,
                        "name": "Kampung Kilim",
                        "latitude": "6.40550000",
                        "longitude": "99.85020000"
                    },
                    {
                        "id": 76471,
                        "name": "Kampung Kok",
                        "latitude": "6.36759000",
                        "longitude": "99.68252000"
                    },
                    {
                        "id": 76492,
                        "name": "Kuah",
                        "latitude": "6.32649000",
                        "longitude": "99.84320000"
                    },
                    {
                        "id": 76495,
                        "name": "Kuala Kedah",
                        "latitude": "6.10000000",
                        "longitude": "100.30000000"
                    },
                    {
                        "id": 76503,
                        "name": "Kuala Teriang",
                        "latitude": "6.36377000",
                        "longitude": "99.71532000"
                    },
                    {
                        "id": 76509,
                        "name": "Kulim",
                        "latitude": "5.36499000",
                        "longitude": "100.56177000"
                    },
                    {
                        "id": 76514,
                        "name": "Langkawi",
                        "latitude": "6.35608000",
                        "longitude": "99.78375000"
                    },
                    {
                        "id": 76529,
                        "name": "Padang Mat Sirat",
                        "latitude": "6.35423000",
                        "longitude": "99.73404000"
                    },
                    {
                        "id": 76569,
                        "name": "Sungai Petani",
                        "latitude": "5.64700000",
                        "longitude": "100.48772000"
                    }
                ]
            },
            {
                "id": 1946,
                "name": "Kelantan",
                "iso2": "03",
                "latitude": "6.12539690",
                "longitude": "102.23807100",
                "type": "state",
                "cities": [
                    {
                        "id": 76448,
                        "name": "Gua Musang",
                        "latitude": "4.88441000",
                        "longitude": "101.96857000"
                    },
                    {
                        "id": 76460,
                        "name": "Kampong Kadok",
                        "latitude": "6.00000000",
                        "longitude": "102.25000000"
                    },
                    {
                        "id": 76462,
                        "name": "Kampong Pangkal Kalong",
                        "latitude": "5.91667000",
                        "longitude": "102.21667000"
                    },
                    {
                        "id": 76489,
                        "name": "Kota Bharu",
                        "latitude": "6.12361000",
                        "longitude": "102.24333000"
                    },
                    {
                        "id": 76536,
                        "name": "Pasir Mas",
                        "latitude": "6.04934000",
                        "longitude": "102.13987000"
                    },
                    {
                        "id": 76541,
                        "name": "Peringat",
                        "latitude": "6.03333000",
                        "longitude": "102.28333000"
                    },
                    {
                        "id": 76585,
                        "name": "Tumpat",
                        "latitude": "6.19775000",
                        "longitude": "102.17098000"
                    }
                ]
            },
            {
                "id": 1949,
                "name": "Kuala Lumpur",
                "iso2": "14",
                "latitude": "3.13900300",
                "longitude": "101.68685500",
                "type": "federal territory",
                "cities": [
                    {
                        "id": 76497,
                        "name": "Kuala Lumpur",
                        "latitude": "3.14120000",
                        "longitude": "101.68653000"
                    }
                ]
            },
            {
                "id": 1935,
                "name": "Labuan",
                "iso2": "15",
                "latitude": "5.28314560",
                "longitude": "115.23082500",
                "type": "federal territory",
                "cities": [
                    {
                        "id": 76511,
                        "name": "Labuan",
                        "latitude": "5.28028000",
                        "longitude": "115.24750000"
                    }
                ]
            },
            {
                "id": 1941,
                "name": "Malacca",
                "iso2": "04",
                "latitude": "2.18959400",
                "longitude": "102.25008680",
                "type": "state",
                "cities": [
                    {
                        "id": 76409,
                        "name": "Alor Gajah",
                        "latitude": "2.38040000",
                        "longitude": "102.20890000"
                    },
                    {
                        "id": 76421,
                        "name": "Batu Berendam",
                        "latitude": "2.24870000",
                        "longitude": "102.24600000"
                    },
                    {
                        "id": 76427,
                        "name": "Bemban",
                        "latitude": "2.26840000",
                        "longitude": "102.37460000"
                    },
                    {
                        "id": 76432,
                        "name": "Bukit Rambai",
                        "latitude": "2.25940000",
                        "longitude": "102.18380000"
                    },
                    {
                        "id": 76461,
                        "name": "Kampong Masjid Tanah",
                        "latitude": "2.35000000",
                        "longitude": "102.11667000"
                    },
                    {
                        "id": 76463,
                        "name": "Kampung Ayer Keroh",
                        "latitude": "2.26540000",
                        "longitude": "102.28010000"
                    },
                    {
                        "id": 76464,
                        "name": "Kampung Ayer Molek",
                        "latitude": "2.21390000",
                        "longitude": "102.32780000"
                    },
                    {
                        "id": 76468,
                        "name": "Kampung Bukit Baharu",
                        "latitude": "2.21520000",
                        "longitude": "102.28510000"
                    },
                    {
                        "id": 76486,
                        "name": "Klebang Besar",
                        "latitude": "2.21860000",
                        "longitude": "102.19950000"
                    },
                    {
                        "id": 76501,
                        "name": "Kuala Sungai Baru",
                        "latitude": "2.35940000",
                        "longitude": "102.03530000"
                    },
                    {
                        "id": 76520,
                        "name": "Malacca",
                        "latitude": "2.19600000",
                        "longitude": "102.24050000"
                    },
                    {
                        "id": 76546,
                        "name": "Pulau Sebang",
                        "latitude": "2.45500000",
                        "longitude": "102.23290000"
                    },
                    {
                        "id": 76570,
                        "name": "Sungai Udang",
                        "latitude": "2.26900000",
                        "longitude": "102.14270000"
                    }
                ]
            },
            {
                "id": 1948,
                "name": "Negeri Sembilan",
                "iso2": "05",
                "latitude": "2.72580580",
                "longitude": "101.94237820",
                "type": "state",
                "cities": [
                    {
                        "id": 76415,
                        "name": "Bahau",
                        "latitude": "2.80790000",
                        "longitude": "102.40490000"
                    },
                    {
                        "id": 76465,
                        "name": "Kampung Baharu Nilai",
                        "latitude": "2.80330000",
                        "longitude": "101.79720000"
                    },
                    {
                        "id": 76499,
                        "name": "Kuala Pilah",
                        "latitude": "2.73890000",
                        "longitude": "102.24870000"
                    },
                    {
                        "id": 76545,
                        "name": "Port Dickson",
                        "latitude": "2.53718000",
                        "longitude": "101.80571000"
                    },
                    {
                        "id": 76559,
                        "name": "Seremban",
                        "latitude": "2.72970000",
                        "longitude": "101.93810000"
                    },
                    {
                        "id": 76574,
                        "name": "Tampin",
                        "latitude": "2.47010000",
                        "longitude": "102.23020000"
                    }
                ]
            },
            {
                "id": 1940,
                "name": "Pahang",
                "iso2": "06",
                "latitude": "3.81263180",
                "longitude": "103.32562040",
                "type": "state",
                "cities": [
                    {
                        "id": 76428,
                        "name": "Bentong Town",
                        "latitude": "3.52229000",
                        "longitude": "101.90866000"
                    },
                    {
                        "id": 76452,
                        "name": "Jerantut",
                        "latitude": "3.93600000",
                        "longitude": "102.36260000"
                    },
                    {
                        "id": 76469,
                        "name": "Kampung Bukit Tinggi Bentong",
                        "latitude": "3.34944000",
                        "longitude": "101.82631000"
                    },
                    {
                        "id": 76477,
                        "name": "Kampung Tekek",
                        "latitude": "2.81470000",
                        "longitude": "104.15920000"
                    },
                    {
                        "id": 76496,
                        "name": "Kuala Lipis",
                        "latitude": "4.18420000",
                        "longitude": "102.04680000"
                    },
                    {
                        "id": 76505,
                        "name": "Kuantan",
                        "latitude": "3.80770000",
                        "longitude": "103.32600000"
                    },
                    {
                        "id": 76523,
                        "name": "Mentekab",
                        "latitude": "3.48540000",
                        "longitude": "102.34840000"
                    },
                    {
                        "id": 76537,
                        "name": "Pekan",
                        "latitude": "3.48360000",
                        "longitude": "103.39960000"
                    },
                    {
                        "id": 76551,
                        "name": "Raub",
                        "latitude": "3.78990000",
                        "longitude": "101.85700000"
                    },
                    {
                        "id": 76575,
                        "name": "Tanah Rata",
                        "latitude": "4.46361000",
                        "longitude": "101.37630000"
                    },
                    {
                        "id": 76584,
                        "name": "Temerluh",
                        "latitude": "3.45060000",
                        "longitude": "102.41760000"
                    }
                ]
            },
            {
                "id": 1939,
                "name": "Penang",
                "iso2": "07",
                "latitude": "5.41639350",
                "longitude": "100.33267860",
                "type": "state",
                "cities": [
                    {
                        "id": 76422,
                        "name": "Batu Feringgi",
                        "latitude": "5.47090000",
                        "longitude": "100.24529000"
                    },
                    {
                        "id": 76431,
                        "name": "Bukit Mertajam",
                        "latitude": "5.36301000",
                        "longitude": "100.46670000"
                    },
                    {
                        "id": 76434,
                        "name": "Butterworth",
                        "latitude": "5.39910000",
                        "longitude": "100.36382000"
                    },
                    {
                        "id": 76447,
                        "name": "George Town",
                        "latitude": "5.41123000",
                        "longitude": "100.33543000"
                    },
                    {
                        "id": 76456,
                        "name": "Juru",
                        "latitude": "5.31201000",
                        "longitude": "100.44229000"
                    },
                    {
                        "id": 76467,
                        "name": "Kampung Batu Feringgi",
                        "latitude": "5.46948000",
                        "longitude": "100.24449000"
                    },
                    {
                        "id": 76475,
                        "name": "Kampung Sungai Ara",
                        "latitude": "5.32699000",
                        "longitude": "100.27348000"
                    },
                    {
                        "id": 76482,
                        "name": "Kepala Batas",
                        "latitude": "5.51707000",
                        "longitude": "100.42650000"
                    },
                    {
                        "id": 76528,
                        "name": "Nibong Tebal",
                        "latitude": "5.16586000",
                        "longitude": "100.47793000"
                    },
                    {
                        "id": 76540,
                        "name": "Perai",
                        "latitude": "5.38333000",
                        "longitude": "100.38333000"
                    },
                    {
                        "id": 76542,
                        "name": "Permatang Kuching",
                        "latitude": "5.46339000",
                        "longitude": "100.38144000"
                    },
                    {
                        "id": 76555,
                        "name": "Seberang Perai",
                        "latitude": "5.38770000",
                        "longitude": "100.42603000"
                    },
                    {
                        "id": 76578,
                        "name": "Tanjung Tokong",
                        "latitude": "5.46061000",
                        "longitude": "100.30742000"
                    },
                    {
                        "id": 76580,
                        "name": "Tasek Glugor",
                        "latitude": "5.48032000",
                        "longitude": "100.49849000"
                    },
                    {
                        "id": 76582,
                        "name": "Telaga Batu",
                        "latitude": "5.46667000",
                        "longitude": "100.23333000"
                    }
                ]
            },
            {
                "id": 1943,
                "name": "Perak",
                "iso2": "08",
                "latitude": "4.59211260",
                "longitude": "101.09010900",
                "type": "state",
                "cities": [
                    {
                        "id": 76414,
                        "name": "Bagan Serai",
                        "latitude": "5.01080000",
                        "longitude": "100.54101000"
                    },
                    {
                        "id": 76423,
                        "name": "Batu Gajah",
                        "latitude": "4.46916000",
                        "longitude": "101.04107000"
                    },
                    {
                        "id": 76429,
                        "name": "Bidur",
                        "latitude": "4.11667000",
                        "longitude": "101.28333000"
                    },
                    {
                        "id": 76450,
                        "name": "Ipoh",
                        "latitude": "4.58410000",
                        "longitude": "101.08290000"
                    },
                    {
                        "id": 76457,
                        "name": "Kampar",
                        "latitude": "4.30000000",
                        "longitude": "101.15000000"
                    },
                    {
                        "id": 76459,
                        "name": "Kampong Dungun",
                        "latitude": "3.21667000",
                        "longitude": "101.31667000"
                    },
                    {
                        "id": 76494,
                        "name": "Kuala Kangsar",
                        "latitude": "4.76667000",
                        "longitude": "100.93333000"
                    },
                    {
                        "id": 76519,
                        "name": "Lumut",
                        "latitude": "4.23230000",
                        "longitude": "100.62980000"
                    },
                    {
                        "id": 76532,
                        "name": "Pantai Remis",
                        "latitude": "4.45570000",
                        "longitude": "100.62880000"
                    },
                    {
                        "id": 76534,
                        "name": "Parit Buntar",
                        "latitude": "5.12671000",
                        "longitude": "100.49316000"
                    },
                    {
                        "id": 76564,
                        "name": "Simpang Empat",
                        "latitude": "4.95000000",
                        "longitude": "100.63333000"
                    },
                    {
                        "id": 76571,
                        "name": "Taiping",
                        "latitude": "4.85000000",
                        "longitude": "100.73333000"
                    },
                    {
                        "id": 76579,
                        "name": "Tapah Road",
                        "latitude": "4.16667000",
                        "longitude": "101.20000000"
                    },
                    {
                        "id": 76583,
                        "name": "Teluk Intan",
                        "latitude": "4.02219000",
                        "longitude": "101.02083000"
                    }
                ]
            },
            {
                "id": 1938,
                "name": "Perlis",
                "iso2": "09",
                "latitude": "29.92270940",
                "longitude": "-90.12285590",
                "type": "state",
                "cities": [
                    {
                        "id": 76478,
                        "name": "Kangar",
                        "latitude": "6.44140000",
                        "longitude": "100.19862000"
                    },
                    {
                        "id": 76498,
                        "name": "Kuala Perlis",
                        "latitude": "6.40000000",
                        "longitude": "100.13333000"
                    },
                    {
                        "id": 76531,
                        "name": "Pantai Cenang",
                        "latitude": "6.29369000",
                        "longitude": "99.72786000"
                    }
                ]
            },
            {
                "id": 1945,
                "name": "Putrajaya",
                "iso2": "16",
                "latitude": "2.92636100",
                "longitude": "101.69644500",
                "type": "federal territory",
                "cities": [
                    {
                        "id": 76549,
                        "name": "Putrajaya",
                        "latitude": "2.93527000",
                        "longitude": "101.69112000"
                    }
                ]
            },
            {
                "id": 1936,
                "name": "Sabah",
                "iso2": "12",
                "latitude": "5.97883980",
                "longitude": "116.07531990",
                "type": "state",
                "cities": [
                    {
                        "id": 76417,
                        "name": "Bandar Labuan",
                        "latitude": "5.28883000",
                        "longitude": "115.26924000"
                    },
                    {
                        "id": 76425,
                        "name": "Beaufort",
                        "latitude": "5.34730000",
                        "longitude": "115.74550000"
                    },
                    {
                        "id": 76446,
                        "name": "Donggongon",
                        "latitude": "5.90702000",
                        "longitude": "116.10146000"
                    },
                    {
                        "id": 76481,
                        "name": "Keningau",
                        "latitude": "5.33780000",
                        "longitude": "116.16020000"
                    },
                    {
                        "id": 76484,
                        "name": "Kinarut",
                        "latitude": "5.82310000",
                        "longitude": "116.04660000"
                    },
                    {
                        "id": 76488,
                        "name": "Kota Belud",
                        "latitude": "6.35100000",
                        "longitude": "116.43050000"
                    },
                    {
                        "id": 76490,
                        "name": "Kota Kinabalu",
                        "latitude": "5.97490000",
                        "longitude": "116.07240000"
                    },
                    {
                        "id": 76507,
                        "name": "Kudat",
                        "latitude": "6.88732000",
                        "longitude": "116.82364000"
                    },
                    {
                        "id": 76513,
                        "name": "Lahad Datu",
                        "latitude": "5.02298000",
                        "longitude": "118.32897000"
                    },
                    {
                        "id": 76533,
                        "name": "Papar",
                        "latitude": "5.73333000",
                        "longitude": "115.93333000"
                    },
                    {
                        "id": 76547,
                        "name": "Putatan",
                        "latitude": "5.92580000",
                        "longitude": "116.06094000"
                    },
                    {
                        "id": 76550,
                        "name": "Ranau",
                        "latitude": "5.95380000",
                        "longitude": "116.66410000"
                    },
                    {
                        "id": 76553,
                        "name": "Sandakan",
                        "latitude": "5.84020000",
                        "longitude": "118.11790000"
                    },
                    {
                        "id": 76558,
                        "name": "Semporna",
                        "latitude": "4.48178000",
                        "longitude": "118.61119000"
                    },
                    {
                        "id": 76572,
                        "name": "Taman Rajawali",
                        "latitude": "5.89477000",
                        "longitude": "118.04576000"
                    },
                    {
                        "id": 76581,
                        "name": "Tawau",
                        "latitude": "4.24482000",
                        "longitude": "117.89115000"
                    }
                ]
            },
            {
                "id": 1937,
                "name": "Sarawak",
                "iso2": "13",
                "latitude": "1.55327830",
                "longitude": "110.35921270",
                "type": "state",
                "cities": [
                    {
                        "id": 76430,
                        "name": "Bintulu",
                        "latitude": "3.16667000",
                        "longitude": "113.03333000"
                    },
                    {
                        "id": 76445,
                        "name": "Data Kakus",
                        "latitude": "2.65465000",
                        "longitude": "113.62249000"
                    },
                    {
                        "id": 76479,
                        "name": "Kapit",
                        "latitude": "1.99546000",
                        "longitude": "112.93254000"
                    },
                    {
                        "id": 76506,
                        "name": "Kuching",
                        "latitude": "1.55000000",
                        "longitude": "110.33333000"
                    },
                    {
                        "id": 76515,
                        "name": "Lawas",
                        "latitude": "4.86040000",
                        "longitude": "115.40900000"
                    },
                    {
                        "id": 76516,
                        "name": "Lidung Jelo",
                        "latitude": "2.64848000",
                        "longitude": "114.78653000"
                    },
                    {
                        "id": 76517,
                        "name": "Limbang",
                        "latitude": "4.75000000",
                        "longitude": "115.00000000"
                    },
                    {
                        "id": 76518,
                        "name": "Long Ampan Aing or Abanang",
                        "latitude": "2.65671000",
                        "longitude": "114.73675000"
                    },
                    {
                        "id": 76522,
                        "name": "Marudi",
                        "latitude": "4.18333000",
                        "longitude": "114.31667000"
                    },
                    {
                        "id": 76525,
                        "name": "Miri",
                        "latitude": "4.39928000",
                        "longitude": "113.99163000"
                    },
                    {
                        "id": 76527,
                        "name": "Mukah",
                        "latitude": "2.89435000",
                        "longitude": "112.09145000"
                    },
                    {
                        "id": 76554,
                        "name": "Sarikei",
                        "latitude": "2.11667000",
                        "longitude": "111.51667000"
                    },
                    {
                        "id": 76562,
                        "name": "Sibu",
                        "latitude": "2.30000000",
                        "longitude": "111.81667000"
                    },
                    {
                        "id": 76563,
                        "name": "Simanggang",
                        "latitude": "1.24722000",
                        "longitude": "111.45278000"
                    }
                ]
            },
            {
                "id": 1944,
                "name": "Selangor",
                "iso2": "10",
                "latitude": "3.07383790",
                "longitude": "101.51834690",
                "type": "state",
                "cities": [
                    {
                        "id": 76411,
                        "name": "Ampang",
                        "latitude": "3.15000000",
                        "longitude": "101.76667000"
                    },
                    {
                        "id": 76413,
                        "name": "Bagan Pulau Ketam",
                        "latitude": "3.01667000",
                        "longitude": "101.26667000"
                    },
                    {
                        "id": 76418,
                        "name": "Banting",
                        "latitude": "2.81360000",
                        "longitude": "101.50185000"
                    },
                    {
                        "id": 76419,
                        "name": "Batang Berjuntai",
                        "latitude": "3.38333000",
                        "longitude": "101.41667000"
                    },
                    {
                        "id": 76420,
                        "name": "Batu Arang",
                        "latitude": "3.31667000",
                        "longitude": "101.46667000"
                    },
                    {
                        "id": 76451,
                        "name": "Jenjarum",
                        "latitude": "2.87240000",
                        "longitude": "101.49484000"
                    },
                    {
                        "id": 76458,
                        "name": "Kampong Baharu Balakong",
                        "latitude": "3.03333000",
                        "longitude": "101.75000000"
                    },
                    {
                        "id": 76466,
                        "name": "Kampung Baru Subang",
                        "latitude": "3.15000000",
                        "longitude": "101.53333000"
                    },
                    {
                        "id": 76476,
                        "name": "Kampung Tanjung Karang",
                        "latitude": "3.42420000",
                        "longitude": "101.18490000"
                    },
                    {
                        "id": 76485,
                        "name": "Klang",
                        "latitude": "3.03667000",
                        "longitude": "101.44333000"
                    },
                    {
                        "id": 76500,
                        "name": "Kuala Selangor",
                        "latitude": "3.35000000",
                        "longitude": "101.25000000"
                    },
                    {
                        "id": 76504,
                        "name": "Kuang",
                        "latitude": "3.25940000",
                        "longitude": "101.55410000"
                    },
                    {
                        "id": 76512,
                        "name": "Ladang Seri Kundang",
                        "latitude": "3.28560000",
                        "longitude": "101.51900000"
                    },
                    {
                        "id": 76539,
                        "name": "Pelabuhan Klang",
                        "latitude": "2.99959000",
                        "longitude": "101.39287000"
                    },
                    {
                        "id": 76543,
                        "name": "Petaling Jaya",
                        "latitude": "3.10726000",
                        "longitude": "101.60671000"
                    },
                    {
                        "id": 153725,
                        "name": "Puchong",
                        "latitude": "3.03270000",
                        "longitude": "101.61880000"
                    },
                    {
                        "id": 76548,
                        "name": "Putra Heights",
                        "latitude": "2.99361000",
                        "longitude": "101.57255000"
                    },
                    {
                        "id": 76552,
                        "name": "Rawang",
                        "latitude": "3.32130000",
                        "longitude": "101.57670000"
                    },
                    {
                        "id": 76557,
                        "name": "Semenyih",
                        "latitude": "2.95160000",
                        "longitude": "101.84300000"
                    },
                    {
                        "id": 76560,
                        "name": "Serendah",
                        "latitude": "3.36460000",
                        "longitude": "101.60410000"
                    },
                    {
                        "id": 76561,
                        "name": "Shah Alam",
                        "latitude": "3.08507000",
                        "longitude": "101.53281000"
                    },
                    {
                        "id": 76566,
                        "name": "Subang Jaya",
                        "latitude": "3.04384000",
                        "longitude": "101.58062000"
                    },
                    {
                        "id": 76567,
                        "name": "Sungai Besar",
                        "latitude": "3.67460000",
                        "longitude": "100.98670000"
                    },
                    {
                        "id": 76568,
                        "name": "Sungai Pelek New Village",
                        "latitude": "2.65000000",
                        "longitude": "101.70000000"
                    },
                    {
                        "id": 76577,
                        "name": "Tanjung Sepat",
                        "latitude": "2.65790000",
                        "longitude": "101.56290000"
                    }
                ]
            },
            {
                "id": 1942,
                "name": "Terengganu",
                "iso2": "11",
                "latitude": "5.31169160",
                "longitude": "103.13241540",
                "type": "state",
                "cities": [
                    {
                        "id": 76436,
                        "name": "Cukai",
                        "latitude": "4.25000000",
                        "longitude": "103.41667000"
                    },
                    {
                        "id": 76453,
                        "name": "Jertih",
                        "latitude": "5.73360000",
                        "longitude": "102.48970000"
                    },
                    {
                        "id": 76472,
                        "name": "Kampung Kuala Besut",
                        "latitude": "5.83297000",
                        "longitude": "102.55061000"
                    },
                    {
                        "id": 76483,
                        "name": "Kertih",
                        "latitude": "4.51410000",
                        "longitude": "103.44830000"
                    },
                    {
                        "id": 76493,
                        "name": "Kuala Besut",
                        "latitude": "5.83303000",
                        "longitude": "102.55514000"
                    },
                    {
                        "id": 76502,
                        "name": "Kuala Terengganu",
                        "latitude": "5.33020000",
                        "longitude": "103.14080000"
                    },
                    {
                        "id": 76521,
                        "name": "Marang",
                        "latitude": "5.20560000",
                        "longitude": "103.20590000"
                    },
                    {
                        "id": 76530,
                        "name": "Paka",
                        "latitude": "4.63740000",
                        "longitude": "103.43680000"
                    }
                ]
            }
        ]
    },
    {
        "id": 133,
        "name": "Maldives",
        "iso3": "MDV",
        "iso2": "MV",
        "numeric_code": "462",
        "phonecode": "960",
        "capital": "Male",
        "currency": "MVR",
        "currency_name": "Maldivian rufiyaa",
        "currency_symbol": "Rf",
        "tld": ".mv",
        "native": "Maldives",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Southern Asia",
        "subregion_id": 14,
        "nationality": "Maldivian",
        "timezones": [
            {
                "zoneName": "Indian\/Maldives",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "MVT",
                "tzName": "Maldives Time"
            }
        ],
        "translations": {
            "br": "Maldivez",
            "ko": "몰디브",
            "pt-BR": "Maldivas",
            "pt": "Maldivas",
            "nl": "Maldiven",
            "hr": "Maldivi",
            "fa": "مالدیو",
            "de": "Malediven",
            "es": "Maldivas",
            "fr": "Maldives",
            "ja": "モルディブ",
            "it": "Maldive",
            "zh-CN": "马尔代夫",
            "tr": "Maldivler",
            "ru": "Мальдивы",
            "uk": "Мальдіви",
            "pl": "Malediwy"
        },
        "latitude": "3.25000000",
        "longitude": "73.00000000",
        "emoji": "🇲🇻",
        "emojiU": "U+1F1F2 U+1F1FB",
        "states": [
            {
                "id": 2594,
                "name": "Addu",
                "iso2": "01",
                "latitude": "-0.63009950",
                "longitude": "73.15856260",
                "type": "city",
                "cities": [
                    {
                        "id": 67929,
                        "name": "Hithadhoo",
                        "latitude": "-0.60000000",
                        "longitude": "73.08333000"
                    },
                    {
                        "id": 67937,
                        "name": "Meedhoo",
                        "latitude": "-0.58333000",
                        "longitude": "73.23333000"
                    }
                ]
            },
            {
                "id": 2587,
                "name": "Alif Alif",
                "iso2": "02",
                "latitude": "4.08500000",
                "longitude": "72.85154790",
                "type": "administrative atoll",
                "cities": []
            },
            {
                "id": 2600,
                "name": "Alif Dhaal",
                "iso2": "00",
                "latitude": "3.65433020",
                "longitude": "72.80427970",
                "type": "administrative atoll",
                "cities": []
            },
            {
                "id": 2604,
                "name": "Central",
                "iso2": "CE",
                "latitude": "2.96933090",
                "longitude": "72.90826190",
                "type": "province",
                "cities": []
            },
            {
                "id": 2590,
                "name": "Dhaalu",
                "iso2": "17",
                "latitude": "2.84685020",
                "longitude": "72.94605660",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67931,
                        "name": "Kudahuvadhoo",
                        "latitude": "2.67075000",
                        "longitude": "72.89437000"
                    }
                ]
            },
            {
                "id": 2599,
                "name": "Faafu",
                "iso2": "14",
                "latitude": "3.23094090",
                "longitude": "72.94605660",
                "type": "administrative atoll",
                "cities": []
            },
            {
                "id": 2598,
                "name": "Gaafu Alif",
                "iso2": "27",
                "latitude": "0.61248130",
                "longitude": "73.32370800",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67943,
                        "name": "Viligili",
                        "latitude": "0.75906000",
                        "longitude": "73.43296000"
                    }
                ]
            },
            {
                "id": 2603,
                "name": "Gaafu Dhaalu",
                "iso2": "28",
                "latitude": "0.35880400",
                "longitude": "73.18216230",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67940,
                        "name": "Thinadhoo",
                        "latitude": "0.53060000",
                        "longitude": "72.99969000"
                    }
                ]
            },
            {
                "id": 2595,
                "name": "Gnaviyani",
                "iso2": "29",
                "latitude": "-0.30064250",
                "longitude": "73.42391430",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67927,
                        "name": "Fuvahmulah",
                        "latitude": "-0.29878000",
                        "longitude": "73.42403000"
                    }
                ]
            },
            {
                "id": 2586,
                "name": "Haa Alif",
                "iso2": "07",
                "latitude": "6.99034880",
                "longitude": "72.94605660",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67923,
                        "name": "Dhidhdhoo",
                        "latitude": "6.88744000",
                        "longitude": "73.11402000"
                    }
                ]
            },
            {
                "id": 2597,
                "name": "Haa Dhaalu",
                "iso2": "23",
                "latitude": "6.57827170",
                "longitude": "72.94605660",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67932,
                        "name": "Kulhudhuffushi",
                        "latitude": "6.62207000",
                        "longitude": "73.06998000"
                    }
                ]
            },
            {
                "id": 2596,
                "name": "Kaafu",
                "iso2": "26",
                "latitude": "4.45589790",
                "longitude": "73.55941280",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67928,
                        "name": "Guraidhoo",
                        "latitude": "3.90045000",
                        "longitude": "73.46623000"
                    },
                    {
                        "id": 67930,
                        "name": "Hulhumale",
                        "latitude": "4.21169000",
                        "longitude": "73.54008000"
                    },
                    {
                        "id": 67933,
                        "name": "Maafushi",
                        "latitude": "3.94231000",
                        "longitude": "73.49070000"
                    },
                    {
                        "id": 67935,
                        "name": "Male",
                        "latitude": "4.17521000",
                        "longitude": "73.50916000"
                    }
                ]
            },
            {
                "id": 2601,
                "name": "Laamu",
                "iso2": "05",
                "latitude": "1.94307370",
                "longitude": "73.41802110",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67925,
                        "name": "Fonadhoo",
                        "latitude": "1.83243000",
                        "longitude": "73.50257000"
                    }
                ]
            },
            {
                "id": 2607,
                "name": "Lhaviyani",
                "iso2": "03",
                "latitude": "5.37470210",
                "longitude": "73.51229280",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67939,
                        "name": "Naifaru",
                        "latitude": "5.44438000",
                        "longitude": "73.36571000"
                    }
                ]
            },
            {
                "id": 2609,
                "name": "Malé",
                "iso2": "MLE",
                "latitude": "4.41666300",
                "longitude": "73.42617980",
                "type": "administrative atoll",
                "cities": []
            },
            {
                "id": 2608,
                "name": "Meemu",
                "iso2": "12",
                "latitude": "3.00903450",
                "longitude": "73.51229280",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67938,
                        "name": "Muli",
                        "latitude": "2.91667000",
                        "longitude": "73.56667000"
                    }
                ]
            },
            {
                "id": 2592,
                "name": "Noonu",
                "iso2": "25",
                "latitude": "5.85512760",
                "longitude": "73.32370800",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67936,
                        "name": "Manadhoo",
                        "latitude": "5.76687000",
                        "longitude": "73.41360000"
                    }
                ]
            },
            {
                "id": 2589,
                "name": "North Central",
                "iso2": "NC",
                "latitude": "4.13897880",
                "longitude": "72.57340290",
                "type": "province",
                "cities": []
            },
            {
                "id": 2602,
                "name": "Raa",
                "iso2": "13",
                "latitude": "5.60064570",
                "longitude": "72.94605660",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67941,
                        "name": "Ugoofaaru",
                        "latitude": "5.66812000",
                        "longitude": "73.03017000"
                    }
                ]
            },
            {
                "id": 2585,
                "name": "Shaviyani",
                "iso2": "24",
                "latitude": "6.17511000",
                "longitude": "73.13496050",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67926,
                        "name": "Funadhoo",
                        "latitude": "6.15091000",
                        "longitude": "73.29013000"
                    }
                ]
            },
            {
                "id": 2605,
                "name": "South",
                "iso2": "SU",
                "latitude": "-0.47831260",
                "longitude": "73.07683270",
                "type": "province",
                "cities": []
            },
            {
                "id": 2606,
                "name": "South Central",
                "iso2": "SC",
                "latitude": "2.17076980",
                "longitude": "72.91687870",
                "type": "province",
                "cities": [
                    {
                        "id": 67934,
                        "name": "Mahibadhoo",
                        "latitude": "3.75713000",
                        "longitude": "72.96893000"
                    }
                ]
            },
            {
                "id": 2591,
                "name": "Thaa",
                "iso2": "08",
                "latitude": "2.43111610",
                "longitude": "73.18216230",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67942,
                        "name": "Veymandoo",
                        "latitude": "2.18772000",
                        "longitude": "73.09556000"
                    }
                ]
            },
            {
                "id": 2593,
                "name": "Upper South",
                "iso2": "US",
                "latitude": "0.23070000",
                "longitude": "73.27948460",
                "type": "province",
                "cities": []
            },
            {
                "id": 2584,
                "name": "Vaavu",
                "iso2": "04",
                "latitude": "3.39554380",
                "longitude": "73.51229280",
                "type": "administrative atoll",
                "cities": [
                    {
                        "id": 67924,
                        "name": "Felidhoo",
                        "latitude": "3.47182000",
                        "longitude": "73.54699000"
                    }
                ]
            }
        ]
    },
    {
        "id": 134,
        "name": "Mali",
        "iso3": "MLI",
        "iso2": "ML",
        "numeric_code": "466",
        "phonecode": "223",
        "capital": "Bamako",
        "currency": "XOF",
        "currency_name": "West African CFA franc",
        "currency_symbol": "CFA",
        "tld": ".ml",
        "native": "Mali",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Malian, Malinese",
        "timezones": [
            {
                "zoneName": "Africa\/Bamako",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Mali",
            "ko": "말리",
            "pt-BR": "Mali",
            "pt": "Mali",
            "nl": "Mali",
            "hr": "Mali",
            "fa": "مالی",
            "de": "Mali",
            "es": "Mali",
            "fr": "Mali",
            "ja": "マリ",
            "it": "Mali",
            "zh-CN": "马里",
            "tr": "Mali",
            "ru": "Мали",
            "uk": "Малі",
            "pl": "Mali"
        },
        "latitude": "17.00000000",
        "longitude": "-4.00000000",
        "emoji": "🇲🇱",
        "emojiU": "U+1F1F2 U+1F1F1",
        "states": [
            {
                "id": 253,
                "name": "Bamako",
                "iso2": "BKO",
                "latitude": "12.63923160",
                "longitude": "-8.00288920",
                "type": "district",
                "cities": [
                    {
                        "id": 67587,
                        "name": "Bamako",
                        "latitude": "12.65000000",
                        "longitude": "-8.00000000"
                    }
                ]
            },
            {
                "id": 258,
                "name": "Gao",
                "iso2": "7",
                "latitude": "16.90663320",
                "longitude": "1.52086240",
                "type": "region",
                "cities": [
                    {
                        "id": 67584,
                        "name": "Ansongo",
                        "latitude": "15.65970000",
                        "longitude": "0.50220000"
                    },
                    {
                        "id": 67592,
                        "name": "Cercle de Bourem",
                        "latitude": "17.71192000",
                        "longitude": "-0.34284000"
                    },
                    {
                        "id": 67601,
                        "name": "Gao",
                        "latitude": "16.27167000",
                        "longitude": "-0.04472000"
                    },
                    {
                        "id": 67602,
                        "name": "Gao Cercle",
                        "latitude": "16.72237000",
                        "longitude": "0.43984000"
                    },
                    {
                        "id": 67605,
                        "name": "Inékar",
                        "latitude": "15.95944000",
                        "longitude": "3.14111000"
                    }
                ]
            },
            {
                "id": 252,
                "name": "Kayes",
                "iso2": "1",
                "latitude": "14.08183080",
                "longitude": "-9.90181310",
                "type": "region",
                "cities": [
                    {
                        "id": 67586,
                        "name": "Bafoulabé",
                        "latitude": "13.80650000",
                        "longitude": "-10.83210000"
                    },
                    {
                        "id": 67608,
                        "name": "Kayes",
                        "latitude": "14.44693000",
                        "longitude": "-11.44448000"
                    },
                    {
                        "id": 67611,
                        "name": "Kita",
                        "latitude": "13.03490000",
                        "longitude": "-9.48950000"
                    },
                    {
                        "id": 67612,
                        "name": "Kokofata",
                        "latitude": "12.88333000",
                        "longitude": "-9.95000000"
                    },
                    {
                        "id": 67623,
                        "name": "Sagalo",
                        "latitude": "12.20000000",
                        "longitude": "-10.70000000"
                    }
                ]
            },
            {
                "id": 257,
                "name": "Kidal",
                "iso2": "8",
                "latitude": "18.79868320",
                "longitude": "1.83183340",
                "type": "region",
                "cities": [
                    {
                        "id": 67583,
                        "name": "Abeïbara",
                        "latitude": "19.11667000",
                        "longitude": "1.75000000"
                    },
                    {
                        "id": 67595,
                        "name": "Cercle d’Abeïbara",
                        "latitude": "19.48878000",
                        "longitude": "2.20025000"
                    },
                    {
                        "id": 67609,
                        "name": "Kidal",
                        "latitude": "18.44111000",
                        "longitude": "1.40778000"
                    }
                ]
            },
            {
                "id": 250,
                "name": "Koulikoro",
                "iso2": "2",
                "latitude": "13.80180740",
                "longitude": "-7.43813550",
                "type": "region",
                "cities": [
                    {
                        "id": 67588,
                        "name": "Banamba",
                        "latitude": "13.54773000",
                        "longitude": "-7.44808000"
                    },
                    {
                        "id": 67606,
                        "name": "Kangaba",
                        "latitude": "11.93333000",
                        "longitude": "-8.41667000"
                    },
                    {
                        "id": 67607,
                        "name": "Kati",
                        "latitude": "12.74409000",
                        "longitude": "-8.07257000"
                    },
                    {
                        "id": 67613,
                        "name": "Kolokani",
                        "latitude": "13.57280000",
                        "longitude": "-8.03390000"
                    },
                    {
                        "id": 67615,
                        "name": "Koulikoro",
                        "latitude": "12.86273000",
                        "longitude": "-7.55985000"
                    }
                ]
            },
            {
                "id": 251,
                "name": "Ménaka",
                "iso2": "9",
                "latitude": "15.91564210",
                "longitude": "2.39617400",
                "type": "region",
                "cities": []
            },
            {
                "id": 255,
                "name": "Mopti",
                "iso2": "5",
                "latitude": "14.63380390",
                "longitude": "-3.41955270",
                "type": "region",
                "cities": [
                    {
                        "id": 67589,
                        "name": "Bandiagara",
                        "latitude": "14.35005000",
                        "longitude": "-3.61038000"
                    },
                    {
                        "id": 67598,
                        "name": "Djénné",
                        "latitude": "13.90608000",
                        "longitude": "-4.55332000"
                    },
                    {
                        "id": 67599,
                        "name": "Douentza",
                        "latitude": "15.00155000",
                        "longitude": "-2.94978000"
                    },
                    {
                        "id": 67600,
                        "name": "Douentza Cercle",
                        "latitude": "15.06947000",
                        "longitude": "-2.40875000"
                    },
                    {
                        "id": 67620,
                        "name": "Mopti",
                        "latitude": "14.48430000",
                        "longitude": "-4.18296000"
                    },
                    {
                        "id": 67629,
                        "name": "Ténenkou",
                        "latitude": "14.45722000",
                        "longitude": "-4.91690000"
                    }
                ]
            },
            {
                "id": 249,
                "name": "Ségou",
                "iso2": "4",
                "latitude": "13.83944560",
                "longitude": "-6.06791940",
                "type": "region",
                "cities": [
                    {
                        "id": 67590,
                        "name": "Baroueli",
                        "latitude": "13.07489000",
                        "longitude": "-6.57171000"
                    },
                    {
                        "id": 67594,
                        "name": "Cercle de San",
                        "latitude": "13.17895000",
                        "longitude": "-5.01617000"
                    },
                    {
                        "id": 67618,
                        "name": "Ké-Macina",
                        "latitude": "13.96410000",
                        "longitude": "-5.35791000"
                    },
                    {
                        "id": 67610,
                        "name": "Kinmparana",
                        "latitude": "12.84217000",
                        "longitude": "-4.92450000"
                    },
                    {
                        "id": 67619,
                        "name": "Markala",
                        "latitude": "13.70210000",
                        "longitude": "-6.06590000"
                    },
                    {
                        "id": 67624,
                        "name": "San",
                        "latitude": "13.30335000",
                        "longitude": "-4.89562000"
                    },
                    {
                        "id": 67627,
                        "name": "Ségou",
                        "latitude": "13.43170000",
                        "longitude": "-6.21570000"
                    },
                    {
                        "id": 67626,
                        "name": "Sokolo",
                        "latitude": "14.73280000",
                        "longitude": "-6.12190000"
                    }
                ]
            },
            {
                "id": 254,
                "name": "Sikasso",
                "iso2": "3",
                "latitude": "10.89051860",
                "longitude": "-7.43813550",
                "type": "region",
                "cities": [
                    {
                        "id": 67591,
                        "name": "Bougouni",
                        "latitude": "11.41769000",
                        "longitude": "-7.48323000"
                    },
                    {
                        "id": 67614,
                        "name": "Kolondiéba",
                        "latitude": "11.08943000",
                        "longitude": "-6.89290000"
                    },
                    {
                        "id": 67616,
                        "name": "Koutiala",
                        "latitude": "12.39173000",
                        "longitude": "-5.46421000"
                    },
                    {
                        "id": 67617,
                        "name": "Koutiala Cercle",
                        "latitude": "12.35311000",
                        "longitude": "-5.58390000"
                    },
                    {
                        "id": 67622,
                        "name": "Ntossoni",
                        "latitude": "12.53040000",
                        "longitude": "-5.77003000"
                    },
                    {
                        "id": 67625,
                        "name": "Sikasso",
                        "latitude": "11.31755000",
                        "longitude": "-5.66654000"
                    },
                    {
                        "id": 67630,
                        "name": "Yorosso",
                        "latitude": "12.35811000",
                        "longitude": "-4.77688000"
                    }
                ]
            },
            {
                "id": 256,
                "name": "Taoudénit",
                "iso2": "10",
                "latitude": "22.67641320",
                "longitude": "-3.97891430",
                "type": "region",
                "cities": []
            },
            {
                "id": 248,
                "name": "Tombouctou",
                "iso2": "6",
                "latitude": "21.05267060",
                "longitude": "-3.74350900",
                "type": "region",
                "cities": [
                    {
                        "id": 67585,
                        "name": "Araouane",
                        "latitude": "18.90476000",
                        "longitude": "-3.52649000"
                    },
                    {
                        "id": 67593,
                        "name": "Cercle de Goundam",
                        "latitude": "18.60035000",
                        "longitude": "-4.99306000"
                    },
                    {
                        "id": 67596,
                        "name": "Dire",
                        "latitude": "16.28017000",
                        "longitude": "-3.31302000"
                    },
                    {
                        "id": 67603,
                        "name": "Goundam",
                        "latitude": "16.41453000",
                        "longitude": "-3.67075000"
                    },
                    {
                        "id": 67604,
                        "name": "Gourma-Rharous Cercle",
                        "latitude": "16.07979000",
                        "longitude": "-1.76981000"
                    },
                    {
                        "id": 67621,
                        "name": "Niafunké",
                        "latitude": "15.93220000",
                        "longitude": "-3.99060000"
                    },
                    {
                        "id": 67628,
                        "name": "Timbuktu",
                        "latitude": "16.77348000",
                        "longitude": "-3.00742000"
                    }
                ]
            }
        ]
    },
    {
        "id": 135,
        "name": "Malta",
        "iso3": "MLT",
        "iso2": "MT",
        "numeric_code": "470",
        "phonecode": "356",
        "capital": "Valletta",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".mt",
        "native": "Malta",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Maltese",
        "timezones": [
            {
                "zoneName": "Europe\/Malta",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Malta",
            "ko": "몰타",
            "pt-BR": "Malta",
            "pt": "Malta",
            "nl": "Malta",
            "hr": "Malta",
            "fa": "مالت",
            "de": "Malta",
            "es": "Malta",
            "fr": "Malte",
            "ja": "マルタ",
            "it": "Malta",
            "zh-CN": "马耳他",
            "tr": "Malta",
            "ru": "Мальта",
            "uk": "Мальта",
            "pl": "Malta"
        },
        "latitude": "35.83333333",
        "longitude": "14.58333333",
        "emoji": "🇲🇹",
        "emojiU": "U+1F1F2 U+1F1F9",
        "states": [
            {
                "id": 110,
                "name": "Attard",
                "iso2": "01",
                "latitude": "35.89049670",
                "longitude": "14.41993220",
                "type": "local council",
                "cities": [
                    {
                        "id": 67758,
                        "name": "Attard",
                        "latitude": "35.88972000",
                        "longitude": "14.44250000"
                    }
                ]
            },
            {
                "id": 108,
                "name": "Balzan",
                "iso2": "02",
                "latitude": "35.89574140",
                "longitude": "14.45340650",
                "type": "local council",
                "cities": [
                    {
                        "id": 67759,
                        "name": "Balzan",
                        "latitude": "35.90028000",
                        "longitude": "14.45500000"
                    }
                ]
            },
            {
                "id": 107,
                "name": "Birgu",
                "iso2": "03",
                "latitude": "35.88792140",
                "longitude": "14.52256200",
                "type": "local council",
                "cities": [
                    {
                        "id": 67817,
                        "name": "Birgu (Vittoriosa)",
                        "latitude": "35.89222000",
                        "longitude": "14.51833000"
                    }
                ]
            },
            {
                "id": 97,
                "name": "Birkirkara",
                "iso2": "04",
                "latitude": "35.89547060",
                "longitude": "14.46650720",
                "type": "local council",
                "cities": [
                    {
                        "id": 67760,
                        "name": "Birkirkara",
                        "latitude": "35.89722000",
                        "longitude": "14.46111000"
                    },
                    {
                        "id": 153733,
                        "name": "Fleur De Lys",
                        "latitude": "35.89530000",
                        "longitude": "14.46560000"
                    },
                    {
                        "id": 153742,
                        "name": "Swatar",
                        "latitude": "35.89877800",
                        "longitude": "14.47659200"
                    }
                ]
            },
            {
                "id": 88,
                "name": "Birżebbuġa",
                "iso2": "05",
                "latitude": "35.81359890",
                "longitude": "14.52474630",
                "type": "local council",
                "cities": [
                    {
                        "id": 67761,
                        "name": "Birżebbuġa",
                        "latitude": "35.82583000",
                        "longitude": "14.52694000"
                    },
                    {
                        "id": 153734,
                        "name": "Ħal Far",
                        "latitude": "35.81134900",
                        "longitude": "14.51068600"
                    }
                ]
            },
            {
                "id": 138,
                "name": "Cospicua",
                "iso2": "06",
                "latitude": "35.88067530",
                "longitude": "14.52183380",
                "type": "local council",
                "cities": [
                    {
                        "id": 67762,
                        "name": "Cospicua",
                        "latitude": "35.88556000",
                        "longitude": "14.52750000"
                    }
                ]
            },
            {
                "id": 117,
                "name": "Dingli",
                "iso2": "07",
                "latitude": "35.86273090",
                "longitude": "14.38501070",
                "type": "local council",
                "cities": [
                    {
                        "id": 67763,
                        "name": "Dingli",
                        "latitude": "35.86139000",
                        "longitude": "14.38222000"
                    }
                ]
            },
            {
                "id": 129,
                "name": "Fgura",
                "iso2": "08",
                "latitude": "35.87382690",
                "longitude": "14.52329010",
                "type": "local council",
                "cities": [
                    {
                        "id": 67764,
                        "name": "Fgura",
                        "latitude": "35.87028000",
                        "longitude": "14.51333000"
                    }
                ]
            },
            {
                "id": 84,
                "name": "Floriana",
                "iso2": "09",
                "latitude": "45.49521850",
                "longitude": "-73.71395760",
                "type": "local council",
                "cities": [
                    {
                        "id": 67765,
                        "name": "Floriana",
                        "latitude": "35.89583000",
                        "longitude": "14.50833000"
                    }
                ]
            },
            {
                "id": 134,
                "name": "Fontana",
                "iso2": "10",
                "latitude": "34.09223350",
                "longitude": "-117.43504800",
                "type": "local council",
                "cities": [
                    {
                        "id": 67766,
                        "name": "Fontana",
                        "latitude": "36.03750000",
                        "longitude": "14.23611000"
                    }
                ]
            },
            {
                "id": 130,
                "name": "Għajnsielem",
                "iso2": "13",
                "latitude": "36.02479660",
                "longitude": "14.28029610",
                "type": "local council",
                "cities": [
                    {
                        "id": 67768,
                        "name": "Għajnsielem",
                        "latitude": "36.02639000",
                        "longitude": "14.28500000"
                    },
                    {
                        "id": 67772,
                        "name": "Ħal Għargħur",
                        "latitude": "35.92409000",
                        "longitude": "14.45118000"
                    }
                ]
            },
            {
                "id": 92,
                "name": "Għarb",
                "iso2": "14",
                "latitude": "36.06890900",
                "longitude": "14.20180980",
                "type": "local council",
                "cities": []
            },
            {
                "id": 120,
                "name": "Għargħur",
                "iso2": "15",
                "latitude": "35.92205690",
                "longitude": "14.45631760",
                "type": "local council",
                "cities": [
                    {
                        "id": 67770,
                        "name": "Ħal Għaxaq",
                        "latitude": "35.84889000",
                        "longitude": "14.51667000"
                    }
                ]
            },
            {
                "id": 106,
                "name": "Għasri",
                "iso2": "16",
                "latitude": "36.06680750",
                "longitude": "14.21924750",
                "type": "local council",
                "cities": [
                    {
                        "id": 67767,
                        "name": "Gudja",
                        "latitude": "35.84917000",
                        "longitude": "14.50306000"
                    }
                ]
            },
            {
                "id": 124,
                "name": "Għaxaq",
                "iso2": "17",
                "latitude": "35.84403590",
                "longitude": "14.51600900",
                "type": "local council",
                "cities": [
                    {
                        "id": 67771,
                        "name": "Gżira",
                        "latitude": "35.90583000",
                        "longitude": "14.48806000"
                    }
                ]
            },
            {
                "id": 118,
                "name": "Gudja",
                "iso2": "11",
                "latitude": "35.84698030",
                "longitude": "14.50290400",
                "type": "local council",
                "cities": []
            },
            {
                "id": 113,
                "name": "Gżira",
                "iso2": "12",
                "latitude": "35.90589700",
                "longitude": "14.49533380",
                "type": "local council",
                "cities": [
                    {
                        "id": 67769,
                        "name": "Għarb",
                        "latitude": "36.06000000",
                        "longitude": "14.20889000"
                    }
                ]
            },
            {
                "id": 105,
                "name": "Ħamrun",
                "iso2": "18",
                "latitude": "35.88612370",
                "longitude": "14.48834420",
                "type": "local council",
                "cities": [
                    {
                        "id": 153730,
                        "name": "Blata l' Bajda",
                        "latitude": "35.88750000",
                        "longitude": "14.49861100"
                    },
                    {
                        "id": 67821,
                        "name": "Ħamrun",
                        "latitude": "35.88472000",
                        "longitude": "14.48444000"
                    }
                ]
            },
            {
                "id": 93,
                "name": "Iklin",
                "iso2": "19",
                "latitude": "35.90987740",
                "longitude": "14.45777320",
                "type": "local council",
                "cities": [
                    {
                        "id": 67781,
                        "name": "L-Iklin",
                        "latitude": "35.90414000",
                        "longitude": "14.45415000"
                    }
                ]
            },
            {
                "id": 99,
                "name": "Kalkara",
                "iso2": "21",
                "latitude": "35.89142420",
                "longitude": "14.53202780",
                "type": "local council",
                "cities": [
                    {
                        "id": 67777,
                        "name": "Imġarr",
                        "latitude": "35.92056000",
                        "longitude": "14.36639000"
                    },
                    {
                        "id": 67791,
                        "name": "Mġarr",
                        "latitude": "36.02528000",
                        "longitude": "14.29500000"
                    }
                ]
            },
            {
                "id": 91,
                "name": "Kerċem",
                "iso2": "22",
                "latitude": "36.04479390",
                "longitude": "14.22506050",
                "type": "local council",
                "cities": [
                    {
                        "id": 67789,
                        "name": "Mqabba",
                        "latitude": "35.84763000",
                        "longitude": "14.46824000"
                    }
                ]
            },
            {
                "id": 82,
                "name": "Kirkop",
                "iso2": "23",
                "latitude": "35.84378620",
                "longitude": "14.48543240",
                "type": "local council",
                "cities": [
                    {
                        "id": 67775,
                        "name": "Imsida",
                        "latitude": "35.89250000",
                        "longitude": "14.48278000"
                    },
                    {
                        "id": 67780,
                        "name": "Kirkop",
                        "latitude": "35.84222000",
                        "longitude": "14.48528000"
                    }
                ]
            },
            {
                "id": 126,
                "name": "Lija",
                "iso2": "24",
                "latitude": "49.18007600",
                "longitude": "-123.10331700",
                "type": "local council",
                "cities": [
                    {
                        "id": 67782,
                        "name": "Ħal Lija",
                        "latitude": "35.90056000",
                        "longitude": "14.44639000"
                    },
                    {
                        "id": 67776,
                        "name": "Imtarfa",
                        "latitude": "35.89333000",
                        "longitude": "14.39889000"
                    }
                ]
            },
            {
                "id": 77,
                "name": "Luqa",
                "iso2": "25",
                "latitude": "35.85828650",
                "longitude": "14.48688830",
                "type": "local council",
                "cities": [
                    {
                        "id": 67783,
                        "name": "Ħal Luqa",
                        "latitude": "35.85889000",
                        "longitude": "14.48861000"
                    },
                    {
                        "id": 153740,
                        "name": "Ħal Safi",
                        "latitude": "35.83333300",
                        "longitude": "14.48500000"
                    },
                    {
                        "id": 67809,
                        "name": "Senglea",
                        "latitude": "35.88750000",
                        "longitude": "14.51694000"
                    }
                ]
            },
            {
                "id": 128,
                "name": "Marsa",
                "iso2": "26",
                "latitude": "34.03195870",
                "longitude": "-118.44555350",
                "type": "local council",
                "cities": [
                    {
                        "id": 67778,
                        "name": "Kalkara",
                        "latitude": "35.88917000",
                        "longitude": "14.53278000"
                    }
                ]
            },
            {
                "id": 137,
                "name": "Marsaskala",
                "iso2": "27",
                "latitude": "35.86036400",
                "longitude": "14.55678760",
                "type": "local council",
                "cities": [
                    {
                        "id": 67779,
                        "name": "Kerċem",
                        "latitude": "36.04194000",
                        "longitude": "14.22667000"
                    },
                    {
                        "id": 67785,
                        "name": "Marsaskala",
                        "latitude": "35.86220000",
                        "longitude": "14.56701000"
                    }
                ]
            },
            {
                "id": 78,
                "name": "Marsaxlokk",
                "iso2": "28",
                "latitude": "35.84116990",
                "longitude": "14.53930970",
                "type": "local council",
                "cities": [
                    {
                        "id": 67786,
                        "name": "Marsaxlokk",
                        "latitude": "35.84194000",
                        "longitude": "14.54306000"
                    }
                ]
            },
            {
                "id": 89,
                "name": "Mdina",
                "iso2": "29",
                "latitude": "35.88809300",
                "longitude": "14.40683570",
                "type": "local council",
                "cities": []
            },
            {
                "id": 102,
                "name": "Mellieħa",
                "iso2": "30",
                "latitude": "35.95235290",
                "longitude": "14.35009750",
                "type": "local council",
                "cities": [
                    {
                        "id": 153737,
                        "name": "Manikata",
                        "latitude": "35.94000000",
                        "longitude": "14.35333000"
                    }
                ]
            },
            {
                "id": 109,
                "name": "Mġarr",
                "iso2": "31",
                "latitude": "35.91893270",
                "longitude": "14.36173430",
                "type": "local council",
                "cities": [
                    {
                        "id": 67784,
                        "name": "Marsa",
                        "latitude": "35.87917000",
                        "longitude": "14.49528000"
                    }
                ]
            },
            {
                "id": 140,
                "name": "Mosta",
                "iso2": "32",
                "latitude": "35.91415040",
                "longitude": "14.42284270",
                "type": "local council",
                "cities": [
                    {
                        "id": 153728,
                        "name": "Bidnija",
                        "latitude": "35.92694400",
                        "longitude": "14.39833300"
                    }
                ]
            },
            {
                "id": 74,
                "name": "Mqabba",
                "iso2": "33",
                "latitude": "35.84441430",
                "longitude": "14.46941860",
                "type": "local council",
                "cities": []
            },
            {
                "id": 96,
                "name": "Msida",
                "iso2": "34",
                "latitude": "35.89563880",
                "longitude": "14.48688830",
                "type": "local council",
                "cities": [
                    {
                        "id": 67787,
                        "name": "Mellieħa",
                        "latitude": "35.95639000",
                        "longitude": "14.36222000"
                    }
                ]
            },
            {
                "id": 131,
                "name": "Mtarfa",
                "iso2": "35",
                "latitude": "35.88951250",
                "longitude": "14.39519530",
                "type": "local council",
                "cities": []
            },
            {
                "id": 132,
                "name": "Munxar",
                "iso2": "36",
                "latitude": "36.02880580",
                "longitude": "14.22506050",
                "type": "local council",
                "cities": [
                    {
                        "id": 67790,
                        "name": "Munxar",
                        "latitude": "36.03000000",
                        "longitude": "14.23333000"
                    }
                ]
            },
            {
                "id": 133,
                "name": "Nadur",
                "iso2": "37",
                "latitude": "36.04470190",
                "longitude": "14.29192730",
                "type": "local council",
                "cities": [
                    {
                        "id": 67792,
                        "name": "Nadur",
                        "latitude": "36.03778000",
                        "longitude": "14.29417000"
                    }
                ]
            },
            {
                "id": 112,
                "name": "Naxxar",
                "iso2": "38",
                "latitude": "35.93175180",
                "longitude": "14.43157460",
                "type": "local council",
                "cities": [
                    {
                        "id": 153726,
                        "name": "Baħar iċ-Ċagħaq",
                        "latitude": "35.93878700",
                        "longitude": "14.45372500"
                    },
                    {
                        "id": 153736,
                        "name": "Magħtab",
                        "latitude": "35.94500000",
                        "longitude": "14.44000000"
                    },
                    {
                        "id": 67793,
                        "name": "Naxxar",
                        "latitude": "35.91361000",
                        "longitude": "14.44361000"
                    },
                    {
                        "id": 153741,
                        "name": "Salina",
                        "latitude": "35.94555600",
                        "longitude": "14.42444400"
                    }
                ]
            },
            {
                "id": 115,
                "name": "Paola",
                "iso2": "39",
                "latitude": "38.57223530",
                "longitude": "-94.87912940",
                "type": "local council",
                "cities": [
                    {
                        "id": 67794,
                        "name": "Paola",
                        "latitude": "35.87306000",
                        "longitude": "14.49889000"
                    }
                ]
            },
            {
                "id": 125,
                "name": "Pembroke",
                "iso2": "40",
                "latitude": "34.68016260",
                "longitude": "-79.19503730",
                "type": "local council",
                "cities": [
                    {
                        "id": 67795,
                        "name": "Pembroke",
                        "latitude": "35.93056000",
                        "longitude": "14.47639000"
                    }
                ]
            },
            {
                "id": 127,
                "name": "Pietà",
                "iso2": "41",
                "latitude": "42.21862000",
                "longitude": "-83.73464700",
                "type": "local council",
                "cities": [
                    {
                        "id": 67796,
                        "name": "Pietà",
                        "latitude": "35.89472000",
                        "longitude": "14.49500000"
                    }
                ]
            },
            {
                "id": 79,
                "name": "Qala",
                "iso2": "42",
                "latitude": "36.03886280",
                "longitude": "14.31810100",
                "type": "local council",
                "cities": [
                    {
                        "id": 67797,
                        "name": "Qala",
                        "latitude": "36.03611000",
                        "longitude": "14.30944000"
                    }
                ]
            },
            {
                "id": 119,
                "name": "Qormi",
                "iso2": "43",
                "latitude": "35.87643880",
                "longitude": "14.46941860",
                "type": "local council",
                "cities": [
                    {
                        "id": 67798,
                        "name": "Qormi",
                        "latitude": "35.87601000",
                        "longitude": "14.47200000"
                    }
                ]
            },
            {
                "id": 111,
                "name": "Qrendi",
                "iso2": "44",
                "latitude": "35.83284880",
                "longitude": "14.45486210",
                "type": "local council",
                "cities": [
                    {
                        "id": 67799,
                        "name": "Qrendi",
                        "latitude": "35.83472000",
                        "longitude": "14.45833000"
                    }
                ]
            },
            {
                "id": 83,
                "name": "Rabat",
                "iso2": "46",
                "latitude": "33.97159040",
                "longitude": "-6.84981290",
                "type": "local council",
                "cities": [
                    {
                        "id": 153727,
                        "name": "Baħrija",
                        "latitude": "35.89472200",
                        "longitude": "14.34833300"
                    },
                    {
                        "id": 153729,
                        "name": "Binġemma",
                        "latitude": "35.90277800",
                        "longitude": "14.37777800"
                    }
                ]
            },
            {
                "id": 75,
                "name": "San Ġwann",
                "iso2": "49",
                "latitude": "35.90773650",
                "longitude": "14.47524160",
                "type": "local council",
                "cities": [
                    {
                        "id": 67805,
                        "name": "San Ġiljan (St. Julian's)",
                        "latitude": "35.91839000",
                        "longitude": "14.48977000"
                    }
                ]
            },
            {
                "id": 87,
                "name": "San Lawrenz",
                "iso2": "50",
                "latitude": "38.95780560",
                "longitude": "-95.25656890",
                "type": "local council",
                "cities": [
                    {
                        "id": 67803,
                        "name": "San Lawrenz",
                        "latitude": "36.05556000",
                        "longitude": "14.20361000"
                    }
                ]
            },
            {
                "id": 116,
                "name": "Sannat",
                "iso2": "52",
                "latitude": "36.01926430",
                "longitude": "14.25994370",
                "type": "local council",
                "cities": [
                    {
                        "id": 67804,
                        "name": "San Pawl il-Baħar",
                        "latitude": "35.95064000",
                        "longitude": "14.41561000"
                    },
                    {
                        "id": 67806,
                        "name": "Sannat",
                        "latitude": "36.02444000",
                        "longitude": "14.24278000"
                    }
                ]
            },
            {
                "id": 94,
                "name": "Santa Luċija",
                "iso2": "53",
                "latitude": "35.85614200",
                "longitude": "14.50436000",
                "type": "local council",
                "cities": [
                    {
                        "id": 67808,
                        "name": "Santa Venera",
                        "latitude": "35.89083000",
                        "longitude": "14.47417000"
                    }
                ]
            },
            {
                "id": 90,
                "name": "Santa Venera",
                "iso2": "54",
                "latitude": "35.89022010",
                "longitude": "14.47669740",
                "type": "local council",
                "cities": []
            },
            {
                "id": 136,
                "name": "Senglea",
                "iso2": "20",
                "latitude": "35.88730410",
                "longitude": "14.51673710",
                "type": "local council",
                "cities": [
                    {
                        "id": 67774,
                        "name": "Imdina",
                        "latitude": "35.88694000",
                        "longitude": "14.40250000"
                    }
                ]
            },
            {
                "id": 98,
                "name": "Siġġiewi",
                "iso2": "55",
                "latitude": "35.84637420",
                "longitude": "14.43157460",
                "type": "local council",
                "cities": [
                    {
                        "id": 67810,
                        "name": "Siġġiewi",
                        "latitude": "35.85556000",
                        "longitude": "14.43639000"
                    }
                ]
            },
            {
                "id": 104,
                "name": "Sliema",
                "iso2": "56",
                "latitude": "35.91100810",
                "longitude": "14.50290400",
                "type": "local council",
                "cities": [
                    {
                        "id": 67811,
                        "name": "Sliema",
                        "latitude": "35.91250000",
                        "longitude": "14.50194000"
                    }
                ]
            },
            {
                "id": 100,
                "name": "St. Julian's",
                "iso2": "48",
                "latitude": "42.21225130",
                "longitude": "-85.89171270",
                "type": "local council",
                "cities": [
                    {
                        "id": 153738,
                        "name": "Paceville",
                        "latitude": "35.92370000",
                        "longitude": "14.49140000"
                    },
                    {
                        "id": 67801,
                        "name": "San Ġwann",
                        "latitude": "35.90556000",
                        "longitude": "14.47611000"
                    }
                ]
            },
            {
                "id": 139,
                "name": "St. Paul's Bay",
                "iso2": "51",
                "latitude": "35.93601700",
                "longitude": "14.39665030",
                "type": "local council",
                "cities": [
                    {
                        "id": 153731,
                        "name": "Buġibba",
                        "latitude": "35.94916700",
                        "longitude": "14.41166700"
                    },
                    {
                        "id": 153732,
                        "name": "Burmarrad",
                        "latitude": "35.93490000",
                        "longitude": "14.41430000"
                    },
                    {
                        "id": 67788,
                        "name": "Mosta",
                        "latitude": "35.90917000",
                        "longitude": "14.42556000"
                    },
                    {
                        "id": 153739,
                        "name": "Qawra",
                        "latitude": "35.95416700",
                        "longitude": "14.42000000"
                    },
                    {
                        "id": 67802,
                        "name": "Santa Luċija",
                        "latitude": "36.04306000",
                        "longitude": "14.21722000"
                    },
                    {
                        "id": 67807,
                        "name": "Santa Luċija, Gozo",
                        "latitude": "35.86278000",
                        "longitude": "14.50750000"
                    },
                    {
                        "id": 153743,
                        "name": "Wardija",
                        "latitude": "35.93795800",
                        "longitude": "14.39254200"
                    },
                    {
                        "id": 153744,
                        "name": "Xemxija",
                        "latitude": "35.95055600",
                        "longitude": "14.38583300"
                    }
                ]
            },
            {
                "id": 86,
                "name": "Swieqi",
                "iso2": "57",
                "latitude": "35.91911820",
                "longitude": "14.46941860",
                "type": "local council",
                "cities": [
                    {
                        "id": 153735,
                        "name": "Madliena",
                        "latitude": "35.93333300",
                        "longitude": "14.46666700"
                    },
                    {
                        "id": 67812,
                        "name": "Swieqi",
                        "latitude": "35.92250000",
                        "longitude": "14.48000000"
                    }
                ]
            },
            {
                "id": 122,
                "name": "Ta' Xbiex",
                "iso2": "58",
                "latitude": "35.89914480",
                "longitude": "14.49635190",
                "type": "local council",
                "cities": [
                    {
                        "id": 67814,
                        "name": "Ta’ Xbiex",
                        "latitude": "35.89917000",
                        "longitude": "14.49444000"
                    }
                ]
            },
            {
                "id": 103,
                "name": "Tarxien",
                "iso2": "59",
                "latitude": "35.86725520",
                "longitude": "14.51164050",
                "type": "local council",
                "cities": [
                    {
                        "id": 67813,
                        "name": "Ħal Tarxien",
                        "latitude": "35.86583000",
                        "longitude": "14.51500000"
                    }
                ]
            },
            {
                "id": 95,
                "name": "Valletta",
                "iso2": "60",
                "latitude": "35.89890850",
                "longitude": "14.51455280",
                "type": "local council",
                "cities": [
                    {
                        "id": 67815,
                        "name": "Valletta",
                        "latitude": "35.89972000",
                        "longitude": "14.51472000"
                    }
                ]
            },
            {
                "id": 101,
                "name": "Victoria",
                "iso2": "45",
                "latitude": "28.80526740",
                "longitude": "-97.00359820",
                "type": "local council",
                "cities": [
                    {
                        "id": 67800,
                        "name": "Rabat",
                        "latitude": "35.88152000",
                        "longitude": "14.39872000"
                    },
                    {
                        "id": 67816,
                        "name": "Victoria",
                        "latitude": "36.04444000",
                        "longitude": "14.23972000"
                    }
                ]
            },
            {
                "id": 114,
                "name": "Xagħra",
                "iso2": "61",
                "latitude": "36.05084500",
                "longitude": "14.26748200",
                "type": "local council",
                "cities": [
                    {
                        "id": 67818,
                        "name": "Xagħra",
                        "latitude": "36.05000000",
                        "longitude": "14.26444000"
                    }
                ]
            },
            {
                "id": 121,
                "name": "Xewkija",
                "iso2": "62",
                "latitude": "36.02992360",
                "longitude": "14.25994370",
                "type": "local council",
                "cities": [
                    {
                        "id": 67819,
                        "name": "Xewkija",
                        "latitude": "36.03278000",
                        "longitude": "14.25806000"
                    }
                ]
            },
            {
                "id": 81,
                "name": "Xgħajra",
                "iso2": "63",
                "latitude": "35.88682820",
                "longitude": "14.54723910",
                "type": "local council",
                "cities": [
                    {
                        "id": 67820,
                        "name": "Xgħajra",
                        "latitude": "35.88556000",
                        "longitude": "14.54750000"
                    }
                ]
            },
            {
                "id": 123,
                "name": "Żabbar",
                "iso2": "64",
                "latitude": "35.87247150",
                "longitude": "14.54513540",
                "type": "local council",
                "cities": [
                    {
                        "id": 67822,
                        "name": "Żabbar",
                        "latitude": "35.87611000",
                        "longitude": "14.53500000"
                    }
                ]
            },
            {
                "id": 85,
                "name": "Żebbuġ Gozo",
                "iso2": "65",
                "latitude": "36.07164030",
                "longitude": "14.24540800",
                "type": "local council",
                "cities": [
                    {
                        "id": 67773,
                        "name": "Ħaż-Żebbuġ",
                        "latitude": "35.87194000",
                        "longitude": "14.44111000"
                    }
                ]
            },
            {
                "id": 80,
                "name": "Żebbuġ Malta",
                "iso2": "66",
                "latitude": "35.87646480",
                "longitude": "14.43908400",
                "type": "local council",
                "cities": [
                    {
                        "id": 67823,
                        "name": "Żebbuġ",
                        "latitude": "36.07222000",
                        "longitude": "14.23583000"
                    }
                ]
            },
            {
                "id": 135,
                "name": "Żejtun",
                "iso2": "67",
                "latitude": "35.85487140",
                "longitude": "14.53639690",
                "type": "local council",
                "cities": [
                    {
                        "id": 67824,
                        "name": "Żejtun",
                        "latitude": "35.85583000",
                        "longitude": "14.53306000"
                    }
                ]
            },
            {
                "id": 76,
                "name": "Żurrieq",
                "iso2": "68",
                "latitude": "35.82163060",
                "longitude": "14.48106480",
                "type": "local council",
                "cities": [
                    {
                        "id": 67825,
                        "name": "Żurrieq",
                        "latitude": "35.83111000",
                        "longitude": "14.47417000"
                    }
                ]
            }
        ]
    },
    {
        "id": 136,
        "name": "Man (Isle of)",
        "iso3": "IMN",
        "iso2": "IM",
        "numeric_code": "833",
        "phonecode": "44",
        "capital": "Douglas, Isle of Man",
        "currency": "GBP",
        "currency_name": "British pound",
        "currency_symbol": "£",
        "tld": ".im",
        "native": "Isle of Man",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Manx",
        "timezones": [
            {
                "zoneName": "Europe\/Isle_of_Man",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Manav",
            "ko": "맨 섬",
            "pt-BR": "Ilha de Man",
            "pt": "Ilha de Man",
            "nl": "Isle of Man",
            "hr": "Otok Man",
            "fa": "جزیره من",
            "de": "Insel Man",
            "es": "Isla de Man",
            "fr": "Île de Man",
            "ja": "マン島",
            "it": "Isola di Man",
            "zh-CN": "马恩岛",
            "tr": "Man Adasi",
            "ru": "Мэн (остров)",
            "uk": "Мен (острів Мен)",
            "pl": "Man (Wyspa)"
        },
        "latitude": "54.25000000",
        "longitude": "-4.50000000",
        "emoji": "🇮🇲",
        "emojiU": "U+1F1EE U+1F1F2",
        "states": [
            {
                "id": 5303,
                "name": "Ayre",
                "iso2": "01",
                "latitude": "54.32975770",
                "longitude": "-4.60258790",
                "type": "sheadings",
                "cities": [
                    {
                        "id": 154082,
                        "name": "Andreas",
                        "latitude": "54.36841400",
                        "longitude": "-4.52114630"
                    },
                    {
                        "id": 154083,
                        "name": "Bride",
                        "latitude": "54.38316570",
                        "longitude": "-4.40803560"
                    },
                    {
                        "id": 154084,
                        "name": "Lezayre",
                        "latitude": "54.29621930",
                        "longitude": "-4.53110150"
                    }
                ]
            },
            {
                "id": 5304,
                "name": "Garff",
                "iso2": "02",
                "latitude": "54.25687200",
                "longitude": "-4.55473070",
                "type": "sheadings",
                "cities": [
                    {
                        "id": 154085,
                        "name": "Lonan",
                        "latitude": "54.22104520",
                        "longitude": "-4.50103060"
                    },
                    {
                        "id": 154086,
                        "name": "Maughold",
                        "latitude": "54.25494540",
                        "longitude": "-4.51223490"
                    },
                    {
                        "id": 154087,
                        "name": "Onchan",
                        "latitude": "54.19815080",
                        "longitude": "-4.54908980"
                    }
                ]
            },
            {
                "id": 5305,
                "name": "Glenfaba",
                "iso2": "03",
                "latitude": "54.19855340",
                "longitude": "-4.81314070",
                "type": "sheadings",
                "cities": [
                    {
                        "id": 154088,
                        "name": "German",
                        "latitude": "54.21871450",
                        "longitude": "-4.70652730"
                    }
                ]
            },
            {
                "id": 5306,
                "name": "Michael",
                "iso2": "04",
                "latitude": "54.27427780",
                "longitude": "-4.64273250",
                "type": "sheadings",
                "cities": [
                    {
                        "id": 154089,
                        "name": "Ballaugh",
                        "latitude": "54.30481210",
                        "longitude": "-4.62075260"
                    },
                    {
                        "id": 154090,
                        "name": "Jurby",
                        "latitude": "54.35905280",
                        "longitude": "-4.54065860"
                    },
                    {
                        "id": 154091,
                        "name": "Michael",
                        "latitude": "54.27427780",
                        "longitude": "-4.64273250"
                    }
                ]
            },
            {
                "id": 5307,
                "name": "Middle",
                "iso2": "05",
                "latitude": "54.17770520",
                "longitude": "-4.81064360",
                "type": "sheadings",
                "cities": [
                    {
                        "id": 154092,
                        "name": "Braddan",
                        "latitude": "54.16328280",
                        "longitude": "-4.52585060"
                    },
                    {
                        "id": 154093,
                        "name": "Marown",
                        "latitude": "54.18462420",
                        "longitude": "-4.64952180"
                    },
                    {
                        "id": 154094,
                        "name": "Santon",
                        "latitude": "54.12054890",
                        "longitude": "-4.64937750"
                    }
                ]
            },
            {
                "id": 5308,
                "name": "Rushen",
                "iso2": "06",
                "latitude": "54.09574060",
                "longitude": "-4.82835170",
                "type": "sheadings",
                "cities": [
                    {
                        "id": 154095,
                        "name": "Arbory",
                        "latitude": "54.10878070",
                        "longitude": "-4.83564540"
                    },
                    {
                        "id": 154097,
                        "name": "Malew",
                        "latitude": "54.11180490",
                        "longitude": "-4.80138270"
                    },
                    {
                        "id": 154096,
                        "name": "Rushen",
                        "latitude": "54.09084920",
                        "longitude": "-4.84149820"
                    }
                ]
            }
        ]
    },
    {
        "id": 137,
        "name": "Marshall Islands",
        "iso3": "MHL",
        "iso2": "MH",
        "numeric_code": "584",
        "phonecode": "692",
        "capital": "Majuro",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".mh",
        "native": "M̧ajeļ",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Micronesia",
        "subregion_id": 21,
        "nationality": "Marshallese",
        "timezones": [
            {
                "zoneName": "Pacific\/Kwajalein",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "MHT",
                "tzName": "Marshall Islands Time"
            },
            {
                "zoneName": "Pacific\/Majuro",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "MHT",
                "tzName": "Marshall Islands Time"
            }
        ],
        "translations": {
            "br": "Inizi Marshall",
            "ko": "마셜 제도",
            "pt-BR": "Ilhas Marshall",
            "pt": "Ilhas Marshall",
            "nl": "Marshalleilanden",
            "hr": "Maršalovi Otoci",
            "fa": "جزایر مارشال",
            "de": "Marshallinseln",
            "es": "Islas Marshall",
            "fr": "Îles Marshall",
            "ja": "マーシャル諸島",
            "it": "Isole Marshall",
            "zh-CN": "马绍尔群岛",
            "tr": "Marşal Adalari",
            "ru": "Маршалловы острова",
            "uk": "Маршаллові острови",
            "pl": "Wyspy Marshalla"
        },
        "latitude": "9.00000000",
        "longitude": "168.00000000",
        "emoji": "🇲🇭",
        "emojiU": "U+1F1F2 U+1F1ED",
        "states": [
            {
                "id": 2574,
                "name": "Ralik",
                "iso2": "L",
                "latitude": "8.13614600",
                "longitude": "164.88679560",
                "type": "chain",
                "cities": []
            },
            {
                "id": 2573,
                "name": "Ratak",
                "iso2": "T",
                "latitude": "10.27632760",
                "longitude": "170.55009370",
                "type": "chain",
                "cities": []
            }
        ]
    },
    {
        "id": 138,
        "name": "Martinique",
        "iso3": "MTQ",
        "iso2": "MQ",
        "numeric_code": "474",
        "phonecode": "596",
        "capital": "Fort-de-France",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".mq",
        "native": "Martinique",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Martiniquais, Martinican",
        "timezones": [
            {
                "zoneName": "America\/Martinique",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Martinik",
            "ko": "마르티니크",
            "pt-BR": "Martinica",
            "pt": "Martinica",
            "nl": "Martinique",
            "hr": "Martinique",
            "fa": "مونتسرات",
            "de": "Martinique",
            "es": "Martinica",
            "fr": "Martinique",
            "ja": "マルティニーク",
            "it": "Martinica",
            "zh-CN": "马提尼克岛",
            "tr": "Martinik",
            "ru": "Мартиника",
            "uk": "Мартініка",
            "pl": "Martynika"
        },
        "latitude": "14.66666700",
        "longitude": "-61.00000000",
        "emoji": "🇲🇶",
        "emojiU": "U+1F1F2 U+1F1F6",
        "states": [
            {
                "id": 5398,
                "name": "Fort-de-France",
                "iso2": "01",
                "latitude": "14.64349950",
                "longitude": "-61.11431890",
                "type": "district",
                "cities": [
                    {
                        "id": 154980,
                        "name": "Fort-de-France",
                        "latitude": "14.64924180",
                        "longitude": "-61.10984450"
                    },
                    {
                        "id": 154981,
                        "name": "Le Lamentin",
                        "latitude": "14.62308620",
                        "longitude": "-61.03347490"
                    },
                    {
                        "id": 154982,
                        "name": "Saint-Joseph",
                        "latitude": "14.68353400",
                        "longitude": "-61.08186620"
                    },
                    {
                        "id": 154983,
                        "name": "Schœlcher",
                        "latitude": "14.65179970",
                        "longitude": "-61.14128670"
                    }
                ]
            },
            {
                "id": 5399,
                "name": "La Trinité",
                "iso2": "02",
                "latitude": "14.75519490",
                "longitude": "-61.20281970",
                "type": "district",
                "cities": [
                    {
                        "id": 154985,
                        "name": "Basse-Pointe",
                        "latitude": "14.84097080",
                        "longitude": "-61.16485230"
                    },
                    {
                        "id": 154986,
                        "name": "Grand'Rivière",
                        "latitude": "14.84696630",
                        "longitude": "-61.20427640"
                    },
                    {
                        "id": 154987,
                        "name": "Gros-Morne",
                        "latitude": "14.70841840",
                        "longitude": "-61.11271220"
                    },
                    {
                        "id": 154984,
                        "name": "L'Ajoupa-Bouillon",
                        "latitude": "14.81597180",
                        "longitude": "-61.17170630"
                    },
                    {
                        "id": 154993,
                        "name": "La Trinité",
                        "latitude": "14.73804150",
                        "longitude": "-61.02929560"
                    },
                    {
                        "id": 154988,
                        "name": "Le Lorrain",
                        "latitude": "14.79952560",
                        "longitude": "-61.11513740"
                    },
                    {
                        "id": 154990,
                        "name": "Le Marigot",
                        "latitude": "14.77958180",
                        "longitude": "-61.09424580"
                    },
                    {
                        "id": 154991,
                        "name": "Le Robert",
                        "latitude": "14.67443270",
                        "longitude": "-61.01692720"
                    },
                    {
                        "id": 154989,
                        "name": "Macouba",
                        "latitude": "14.84743860",
                        "longitude": "-61.16709460"
                    },
                    {
                        "id": 154992,
                        "name": "Sainte-Marie",
                        "latitude": "14.77300930",
                        "longitude": "-61.04959970"
                    }
                ]
            },
            {
                "id": 5400,
                "name": "Le Marin",
                "iso2": "03",
                "latitude": "14.52205810",
                "longitude": "-61.12011970",
                "type": "district",
                "cities": [
                    {
                        "id": 154996,
                        "name": "Ducos",
                        "latitude": "14.57854420",
                        "longitude": "-61.00973860"
                    },
                    {
                        "id": 154995,
                        "name": "Le Diamant",
                        "latitude": "14.47680040",
                        "longitude": "-61.05973840"
                    },
                    {
                        "id": 154997,
                        "name": "Le François",
                        "latitude": "14.60928850",
                        "longitude": "-60.97999110"
                    },
                    {
                        "id": 154998,
                        "name": "Le Marin",
                        "latitude": "14.48221690",
                        "longitude": "-60.90011410"
                    },
                    {
                        "id": 155005,
                        "name": "Le Vauclin",
                        "latitude": "14.54208600",
                        "longitude": "-60.90060060"
                    },
                    {
                        "id": 154994,
                        "name": "Les Anses-d'Arlet",
                        "latitude": "14.49954780",
                        "longitude": "-61.11481620"
                    },
                    {
                        "id": 155004,
                        "name": "Les Trois-Îlets",
                        "latitude": "14.53287460",
                        "longitude": "-61.07877690"
                    },
                    {
                        "id": 154999,
                        "name": "Rivière-Pilote",
                        "latitude": "14.50266970",
                        "longitude": "-60.93819210"
                    },
                    {
                        "id": 155000,
                        "name": "Rivière-Salée",
                        "latitude": "14.52621400",
                        "longitude": "-61.00353090"
                    },
                    {
                        "id": 155001,
                        "name": "Saint-Esprit",
                        "latitude": "14.56175950",
                        "longitude": "-60.96451110"
                    },
                    {
                        "id": 155002,
                        "name": "Sainte-Anne",
                        "latitude": "14.43142200",
                        "longitude": "-60.89278760"
                    },
                    {
                        "id": 155003,
                        "name": "Sainte-Luce",
                        "latitude": "14.49040930",
                        "longitude": "-60.98793650"
                    }
                ]
            },
            {
                "id": 5401,
                "name": "Saint-Pierre",
                "iso2": "04",
                "latitude": "14.74505200",
                "longitude": "-61.23631840",
                "type": "district",
                "cities": [
                    {
                        "id": 155006,
                        "name": "Bellefontaine",
                        "latitude": "14.67474760",
                        "longitude": "-61.16653080"
                    },
                    {
                        "id": 155008,
                        "name": "Case-Pilote",
                        "latitude": "14.65933990",
                        "longitude": "-61.15026120"
                    },
                    {
                        "id": 155009,
                        "name": "Fonds-Saint-Denis",
                        "latitude": "14.72275460",
                        "longitude": "-61.16189190"
                    },
                    {
                        "id": 155007,
                        "name": "Le Carbet",
                        "latitude": "14.70521580",
                        "longitude": "-61.19444680"
                    },
                    {
                        "id": 155010,
                        "name": "Le Morne-Rouge",
                        "latitude": "14.76953640",
                        "longitude": "-61.16292840"
                    },
                    {
                        "id": 155011,
                        "name": "Le Morne-Vert",
                        "latitude": "14.70464330",
                        "longitude": "-61.15679770"
                    },
                    {
                        "id": 155012,
                        "name": "Le Prêcheur",
                        "latitude": "14.82202610",
                        "longitude": "-61.23746860"
                    },
                    {
                        "id": 155013,
                        "name": "Saint-Pierre",
                        "latitude": "14.77167190",
                        "longitude": "-61.21475010"
                    }
                ]
            }
        ]
    },
    {
        "id": 139,
        "name": "Mauritania",
        "iso3": "MRT",
        "iso2": "MR",
        "numeric_code": "478",
        "phonecode": "222",
        "capital": "Nouakchott",
        "currency": "MRU",
        "currency_name": "Mauritanian ouguiya",
        "currency_symbol": "UM",
        "tld": ".mr",
        "native": "موريتانيا",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Mauritanian",
        "timezones": [
            {
                "zoneName": "Africa\/Nouakchott",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Maouritania",
            "ko": "모리타니",
            "pt-BR": "Mauritânia",
            "pt": "Mauritânia",
            "nl": "Mauritanië",
            "hr": "Mauritanija",
            "fa": "موریتانی",
            "de": "Mauretanien",
            "es": "Mauritania",
            "fr": "Mauritanie",
            "ja": "モーリタニア",
            "it": "Mauritania",
            "zh-CN": "毛里塔尼亚",
            "tr": "Moritanya",
            "ru": "Мавритания",
            "uk": "Мавританія",
            "pl": "Mauretania"
        },
        "latitude": "20.00000000",
        "longitude": "-12.00000000",
        "emoji": "🇲🇷",
        "emojiU": "U+1F1F2 U+1F1F7",
        "states": [
            {
                "id": 3344,
                "name": "Adrar",
                "iso2": "07",
                "latitude": "19.86521760",
                "longitude": "-12.80547530",
                "type": "region",
                "cities": [
                    {
                        "id": 67746,
                        "name": "Atar",
                        "latitude": "20.51770000",
                        "longitude": "-13.04857000"
                    },
                    {
                        "id": 150074,
                        "name": "Azougui",
                        "latitude": "20.56764000",
                        "longitude": "-13.11191000"
                    },
                    {
                        "id": 67748,
                        "name": "Chingueṭṭi",
                        "latitude": "20.46300000",
                        "longitude": "-12.36200000"
                    },
                    {
                        "id": 150075,
                        "name": "Ksar el Khali",
                        "latitude": "20.93333333",
                        "longitude": "-11.61666667"
                    }
                ]
            },
            {
                "id": 3349,
                "name": "Assaba",
                "iso2": "03",
                "latitude": "16.77595580",
                "longitude": "-11.52480550",
                "type": "region",
                "cities": [
                    {
                        "id": 67747,
                        "name": "Barkéwol",
                        "latitude": "16.64039000",
                        "longitude": "-12.49849000"
                    },
                    {
                        "id": 67750,
                        "name": "Kiffa",
                        "latitude": "16.62073000",
                        "longitude": "-11.40208000"
                    }
                ]
            },
            {
                "id": 3339,
                "name": "Brakna",
                "iso2": "05",
                "latitude": "17.23175610",
                "longitude": "-13.17403480",
                "type": "region",
                "cities": [
                    {
                        "id": 67757,
                        "name": "’Elb el Jmel",
                        "latitude": "17.01050000",
                        "longitude": "-13.97102000"
                    },
                    {
                        "id": 67745,
                        "name": "Aleg",
                        "latitude": "17.05314000",
                        "longitude": "-13.91312000"
                    },
                    {
                        "id": 150071,
                        "name": "Bofal",
                        "latitude": "16.41666667",
                        "longitude": "-13.80000000"
                    },
                    {
                        "id": 150072,
                        "name": "Sori Malé",
                        "latitude": "16.95416667",
                        "longitude": "-13.37916667"
                    }
                ]
            },
            {
                "id": 3346,
                "name": "Dakhlet Nouadhibou",
                "iso2": "08",
                "latitude": "20.59855880",
                "longitude": "-16.25221430",
                "type": "region",
                "cities": [
                    {
                        "id": 150076,
                        "name": "Cansado",
                        "latitude": "20.85333333",
                        "longitude": "-17.03250000"
                    },
                    {
                        "id": 150077,
                        "name": "Iouik",
                        "latitude": "19.84944444",
                        "longitude": "-16.33083333"
                    },
                    {
                        "id": 67751,
                        "name": "Nouadhibou",
                        "latitude": "20.94188000",
                        "longitude": "-17.03842000"
                    }
                ]
            },
            {
                "id": 3341,
                "name": "Gorgol",
                "iso2": "04",
                "latitude": "15.97173570",
                "longitude": "-12.62162110",
                "type": "region",
                "cities": [
                    {
                        "id": 67749,
                        "name": "Kaédi",
                        "latitude": "16.15027000",
                        "longitude": "-13.50370000"
                    }
                ]
            },
            {
                "id": 3350,
                "name": "Guidimaka",
                "iso2": "10",
                "latitude": "15.25573310",
                "longitude": "-12.25479190",
                "type": "region",
                "cities": [
                    {
                        "id": 67754,
                        "name": "Sélibaby",
                        "latitude": "15.15846000",
                        "longitude": "-12.18430000"
                    }
                ]
            },
            {
                "id": 3338,
                "name": "Hodh Ech Chargui",
                "iso2": "01",
                "latitude": "18.67370260",
                "longitude": "-7.09287700",
                "type": "region",
                "cities": [
                    {
                        "id": 150066,
                        "name": "Diade",
                        "latitude": "16.23333333",
                        "longitude": "-7.41666667"
                    },
                    {
                        "id": 150067,
                        "name": "Kataouane",
                        "latitude": "16.06888889",
                        "longitude": "-6.49888889"
                    },
                    {
                        "id": 67752,
                        "name": "Néma",
                        "latitude": "16.61702000",
                        "longitude": "-7.25649000"
                    },
                    {
                        "id": 150068,
                        "name": "Timbedra",
                        "latitude": "16.24472222",
                        "longitude": "-8.16750000"
                    }
                ]
            },
            {
                "id": 3351,
                "name": "Hodh El Gharbi",
                "iso2": "02",
                "latitude": "16.69121490",
                "longitude": "-9.54509740",
                "type": "region",
                "cities": [
                    {
                        "id": 67743,
                        "name": "Aioun",
                        "latitude": "16.66140000",
                        "longitude": "-9.61490000"
                    },
                    {
                        "id": 150069,
                        "name": "Ayoun el Atrous",
                        "latitude": "16.66666667",
                        "longitude": "-9.61666667"
                    },
                    {
                        "id": 150070,
                        "name": "Togba",
                        "latitude": "17.40000000",
                        "longitude": "-10.36666667"
                    }
                ]
            },
            {
                "id": 3342,
                "name": "Inchiri",
                "iso2": "12",
                "latitude": "20.02805610",
                "longitude": "-15.40680790",
                "type": "region",
                "cities": [
                    {
                        "id": 67744,
                        "name": "Akjoujt",
                        "latitude": "19.74657000",
                        "longitude": "-14.38531000"
                    }
                ]
            },
            {
                "id": 3343,
                "name": "Nouakchott-Nord",
                "iso2": "14",
                "latitude": "18.11302050",
                "longitude": "-15.89949560",
                "type": "region",
                "cities": [
                    {
                        "id": 150085,
                        "name": "Dar-Naim",
                        "latitude": "18.03333333",
                        "longitude": "-15.96666667"
                    },
                    {
                        "id": 150086,
                        "name": "Teyarett",
                        "latitude": "18.12895720",
                        "longitude": "-15.93778340"
                    },
                    {
                        "id": 150087,
                        "name": "Toujouonine",
                        "latitude": "18.07169000",
                        "longitude": "-15.90311000"
                    }
                ]
            },
            {
                "id": 3352,
                "name": "Nouakchott-Ouest",
                "iso2": "13",
                "latitude": "18.15113570",
                "longitude": "-15.99349100",
                "type": "region",
                "cities": [
                    {
                        "id": 150082,
                        "name": "Ksar",
                        "latitude": "18.10222222",
                        "longitude": "-15.95500000"
                    },
                    {
                        "id": 150083,
                        "name": "Sebkha",
                        "latitude": "18.07555556",
                        "longitude": "-16.00194444"
                    },
                    {
                        "id": 150084,
                        "name": "Tevragh-Zeina",
                        "latitude": "18.11011000",
                        "longitude": "-15.99931000"
                    }
                ]
            },
            {
                "id": 3347,
                "name": "Nouakchott-Sud",
                "iso2": "15",
                "latitude": "17.97092880",
                "longitude": "-15.94648740",
                "type": "region",
                "cities": [
                    {
                        "id": 150088,
                        "name": "Arafat",
                        "latitude": "18.04639000",
                        "longitude": "-15.97194000"
                    },
                    {
                        "id": 150089,
                        "name": "Riyad",
                        "latitude": "18.10222222",
                        "longitude": "-15.95500000"
                    }
                ]
            },
            {
                "id": 3345,
                "name": "Tagant",
                "iso2": "09",
                "latitude": "18.54675270",
                "longitude": "-9.90181310",
                "type": "region",
                "cities": [
                    {
                        "id": 153945,
                        "name": "Moudjeria",
                        "latitude": "17.97955140",
                        "longitude": "-13.39795340"
                    },
                    {
                        "id": 153946,
                        "name": "Tichit",
                        "latitude": "18.49686260",
                        "longitude": "-12.12199350"
                    },
                    {
                        "id": 153947,
                        "name": "Tijigja",
                        "latitude": "18.51647870",
                        "longitude": "-12.98264760"
                    }
                ]
            },
            {
                "id": 3340,
                "name": "Tiris Zemmour",
                "iso2": "11",
                "latitude": "24.57737640",
                "longitude": "-9.90181310",
                "type": "region",
                "cities": [
                    {
                        "id": 150078,
                        "name": "Ain Ben Tili",
                        "latitude": "25.99444444",
                        "longitude": "-9.55333333"
                    },
                    {
                        "id": 150079,
                        "name": "Chegga",
                        "latitude": "25.37194444",
                        "longitude": "-5.78666667"
                    },
                    {
                        "id": 150080,
                        "name": "Fderîck",
                        "latitude": "22.67777778",
                        "longitude": "-12.70750000"
                    },
                    {
                        "id": 150081,
                        "name": "Zouérat",
                        "latitude": "22.73444444",
                        "longitude": "-12.47250000"
                    },
                    {
                        "id": 67756,
                        "name": "Zouerate",
                        "latitude": "22.73542000",
                        "longitude": "-12.47134000"
                    }
                ]
            },
            {
                "id": 3348,
                "name": "Trarza",
                "iso2": "06",
                "latitude": "17.86649640",
                "longitude": "-14.65878210",
                "type": "region",
                "cities": [
                    {
                        "id": 150073,
                        "name": "Legat",
                        "latitude": "16.75000000",
                        "longitude": "-14.83333333"
                    },
                    {
                        "id": 67753,
                        "name": "Rosso",
                        "latitude": "16.51378000",
                        "longitude": "-15.80503000"
                    },
                    {
                        "id": 67755,
                        "name": "Tékane",
                        "latitude": "16.60175000",
                        "longitude": "-15.34866000"
                    }
                ]
            }
        ]
    },
    {
        "id": 140,
        "name": "Mauritius",
        "iso3": "MUS",
        "iso2": "MU",
        "numeric_code": "480",
        "phonecode": "230",
        "capital": "Port Louis",
        "currency": "MUR",
        "currency_name": "Mauritian rupee",
        "currency_symbol": "₨",
        "tld": ".mu",
        "native": "Maurice",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Mauritian",
        "timezones": [
            {
                "zoneName": "Indian\/Mauritius",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "MUT",
                "tzName": "Mauritius Time"
            }
        ],
        "translations": {
            "br": "Moris",
            "ko": "모리셔스",
            "pt-BR": "Maurício",
            "pt": "Maurícia",
            "nl": "Mauritius",
            "hr": "Mauricijus",
            "fa": "موریس",
            "de": "Mauritius",
            "es": "Mauricio",
            "fr": "Île Maurice",
            "ja": "モーリシャス",
            "it": "Mauritius",
            "zh-CN": "毛里求斯",
            "tr": "Morityus",
            "ru": "Маврикий",
            "uk": "Маврикій",
            "pl": "Mauritius"
        },
        "latitude": "-20.28333333",
        "longitude": "57.55000000",
        "emoji": "🇲🇺",
        "emojiU": "U+1F1F2 U+1F1FA",
        "states": [
            {
                "id": 3248,
                "name": "Agalega Islands",
                "iso2": "AG",
                "latitude": "-10.40000000",
                "longitude": "56.61666670",
                "type": "dependency",
                "cities": [
                    {
                        "id": 67922,
                        "name": "Vingt Cinq",
                        "latitude": "-10.38803000",
                        "longitude": "56.61795000"
                    }
                ]
            },
            {
                "id": 3259,
                "name": "Black River",
                "iso2": "BL",
                "latitude": "-20.37084920",
                "longitude": "57.39486490",
                "type": "district",
                "cities": [
                    {
                        "id": 67826,
                        "name": "Albion",
                        "latitude": "-20.20814000",
                        "longitude": "57.40766000"
                    },
                    {
                        "id": 67830,
                        "name": "Bambous",
                        "latitude": "-20.25667000",
                        "longitude": "57.40611000"
                    },
                    {
                        "id": 153385,
                        "name": "Black River",
                        "latitude": "-20.32047900",
                        "longitude": "57.40372500"
                    },
                    {
                        "id": 67845,
                        "name": "Cascavelle",
                        "latitude": "-20.28694000",
                        "longitude": "57.40722000"
                    },
                    {
                        "id": 153383,
                        "name": "Case Noyale",
                        "latitude": "-20.41370400",
                        "longitude": "57.36906500"
                    },
                    {
                        "id": 153384,
                        "name": "Chamarel",
                        "latitude": "-20.42523600",
                        "longitude": "57.39116500"
                    },
                    {
                        "id": 67860,
                        "name": "Flic en Flac",
                        "latitude": "-20.27417000",
                        "longitude": "57.36306000"
                    },
                    {
                        "id": 67867,
                        "name": "Grande Rivière Noire",
                        "latitude": "-20.36028000",
                        "longitude": "57.36611000"
                    },
                    {
                        "id": 67869,
                        "name": "Gros Cailloux",
                        "latitude": "-20.20722000",
                        "longitude": "57.43000000"
                    },
                    {
                        "id": 153387,
                        "name": "La Gaulette",
                        "latitude": "-20.42938800",
                        "longitude": "57.35884100"
                    },
                    {
                        "id": 153388,
                        "name": "Le Morne",
                        "latitude": "-20.44417400",
                        "longitude": "57.33031500"
                    },
                    {
                        "id": 67888,
                        "name": "Petite Case Noyale",
                        "latitude": "-20.39306000",
                        "longitude": "57.36500000"
                    },
                    {
                        "id": 67889,
                        "name": "Petite Rivière",
                        "latitude": "-20.19551000",
                        "longitude": "57.44592000"
                    },
                    {
                        "id": 153389,
                        "name": "Richelieu",
                        "latitude": "-20.19084900",
                        "longitude": "57.46129900"
                    },
                    {
                        "id": 67916,
                        "name": "Tamarin",
                        "latitude": "-20.32556000",
                        "longitude": "57.37056000"
                    }
                ]
            },
            {
                "id": 3254,
                "name": "Flacq",
                "iso2": "FL",
                "latitude": "-20.22578360",
                "longitude": "57.71192740",
                "type": "district",
                "cities": [
                    {
                        "id": 153436,
                        "name": "Bel Air",
                        "latitude": "-20.25849300",
                        "longitude": "57.75498700"
                    },
                    {
                        "id": 67834,
                        "name": "Bel Air Rivière Sèche",
                        "latitude": "-20.25777000",
                        "longitude": "57.74976000"
                    },
                    {
                        "id": 67836,
                        "name": "Bon Accueil",
                        "latitude": "-20.17083000",
                        "longitude": "57.65639000"
                    },
                    {
                        "id": 153443,
                        "name": "Bramsthan",
                        "latitude": "-20.21297900",
                        "longitude": "57.73768000"
                    },
                    {
                        "id": 67837,
                        "name": "Brisée Verdière",
                        "latitude": "-20.16389000",
                        "longitude": "57.64667000"
                    },
                    {
                        "id": 67842,
                        "name": "Camp de Masque",
                        "latitude": "-20.23694000",
                        "longitude": "57.66333000"
                    },
                    {
                        "id": 153437,
                        "name": "Camp De Masque Pave",
                        "latitude": "-20.25006300",
                        "longitude": "57.67997000"
                    },
                    {
                        "id": 67840,
                        "name": "Camp Ithier",
                        "latitude": "-20.21583000",
                        "longitude": "57.74556000"
                    },
                    {
                        "id": 67846,
                        "name": "Centre de Flacq",
                        "latitude": "-20.18972000",
                        "longitude": "57.71444000"
                    },
                    {
                        "id": 67850,
                        "name": "Clémencia",
                        "latitude": "-20.26389000",
                        "longitude": "57.70611000"
                    },
                    {
                        "id": 67858,
                        "name": "Ecroignard",
                        "latitude": "-20.22611000",
                        "longitude": "57.73611000"
                    },
                    {
                        "id": 153444,
                        "name": "Grande Retraite",
                        "latitude": "-20.16507700",
                        "longitude": "57.69461600"
                    },
                    {
                        "id": 67868,
                        "name": "Grande Rivière Sud Est",
                        "latitude": "-20.28611000",
                        "longitude": "57.77583000"
                    },
                    {
                        "id": 67870,
                        "name": "Lalmatie",
                        "latitude": "-20.18972000",
                        "longitude": "57.66111000"
                    },
                    {
                        "id": 67871,
                        "name": "Laventure",
                        "latitude": "-20.14583000",
                        "longitude": "57.67667000"
                    },
                    {
                        "id": 67876,
                        "name": "Mare La Chaux",
                        "latitude": "-20.19806000",
                        "longitude": "57.74944000"
                    },
                    {
                        "id": 153441,
                        "name": "Medine Camp De Masque",
                        "latitude": "-20.24395800",
                        "longitude": "57.64703500"
                    },
                    {
                        "id": 67884,
                        "name": "Olivia",
                        "latitude": "-20.28778000",
                        "longitude": "57.73097000"
                    },
                    {
                        "id": 67897,
                        "name": "Poste de Flacq",
                        "latitude": "-20.16306000",
                        "longitude": "57.73056000"
                    },
                    {
                        "id": 67901,
                        "name": "Quatre Cocos",
                        "latitude": "-20.20151000",
                        "longitude": "57.77448000"
                    },
                    {
                        "id": 67902,
                        "name": "Quatre Soeurs",
                        "latitude": "-20.29917000",
                        "longitude": "57.77056000"
                    },
                    {
                        "id": 67903,
                        "name": "Queen Victoria",
                        "latitude": "-20.22000000",
                        "longitude": "57.70750000"
                    },
                    {
                        "id": 67911,
                        "name": "Saint Julien",
                        "latitude": "-20.22639000",
                        "longitude": "57.63639000"
                    },
                    {
                        "id": 67913,
                        "name": "Sebastopol",
                        "latitude": "-20.29070000",
                        "longitude": "57.68779000"
                    },
                    {
                        "id": 153442,
                        "name": "Trou D'Eau Douce",
                        "latitude": "-20.23458600",
                        "longitude": "57.79486100"
                    }
                ]
            },
            {
                "id": 3264,
                "name": "Grand Port",
                "iso2": "GP",
                "latitude": "-20.38515460",
                "longitude": "57.66657420",
                "type": "district",
                "cities": [
                    {
                        "id": 67831,
                        "name": "Bambous Virieux",
                        "latitude": "-20.34278000",
                        "longitude": "57.75750000"
                    },
                    {
                        "id": 67833,
                        "name": "Beau Vallon",
                        "latitude": "-20.41889000",
                        "longitude": "57.69528000"
                    },
                    {
                        "id": 67835,
                        "name": "Bois des Amourettes",
                        "latitude": "-20.36306000",
                        "longitude": "57.73111000"
                    },
                    {
                        "id": 153399,
                        "name": "Camp Carol",
                        "latitude": "-20.46178500",
                        "longitude": "57.67845600"
                    },
                    {
                        "id": 67849,
                        "name": "Cluny",
                        "latitude": "-20.36694000",
                        "longitude": "57.60389000"
                    },
                    {
                        "id": 153400,
                        "name": "Grand Bel Air",
                        "latitude": "-20.40912400",
                        "longitude": "57.68174200"
                    },
                    {
                        "id": 67866,
                        "name": "Grand Sable",
                        "latitude": "-20.31417000",
                        "longitude": "57.76444000"
                    },
                    {
                        "id": 67874,
                        "name": "Mahébourg",
                        "latitude": "-20.40806000",
                        "longitude": "57.70000000"
                    },
                    {
                        "id": 153391,
                        "name": "Mare D'Albert",
                        "latitude": "-20.42019500",
                        "longitude": "57.62728800"
                    },
                    {
                        "id": 153392,
                        "name": "Mare Tabac",
                        "latitude": "-20.44035800",
                        "longitude": "57.59421500"
                    },
                    {
                        "id": 67881,
                        "name": "New Grove",
                        "latitude": "-20.40861000",
                        "longitude": "57.61361000"
                    },
                    {
                        "id": 67883,
                        "name": "Nouvelle France",
                        "latitude": "-20.37056000",
                        "longitude": "57.56111000"
                    },
                    {
                        "id": 153398,
                        "name": "Petit Bel Air",
                        "latitude": "-20.39941200",
                        "longitude": "57.69295900"
                    },
                    {
                        "id": 67891,
                        "name": "Plaine Magnien",
                        "latitude": "-20.42967000",
                        "longitude": "57.66968000"
                    },
                    {
                        "id": 153394,
                        "name": "Riviere Des Creoles",
                        "latitude": "-20.39084000",
                        "longitude": "57.69696000"
                    },
                    {
                        "id": 67908,
                        "name": "Rose Belle",
                        "latitude": "-20.40028000",
                        "longitude": "57.59667000"
                    },
                    {
                        "id": 67910,
                        "name": "Saint Hubert",
                        "latitude": "-20.36417000",
                        "longitude": "57.63833000"
                    },
                    {
                        "id": 153401,
                        "name": "Seizieme Mille",
                        "latitude": "-20.34211100",
                        "longitude": "57.54924400"
                    },
                    {
                        "id": 153396,
                        "name": "Trois Boutiques",
                        "latitude": "-20.45046100",
                        "longitude": "57.64682900"
                    },
                    {
                        "id": 153397,
                        "name": "Union Park",
                        "latitude": "-20.38629400",
                        "longitude": "57.58068000"
                    },
                    {
                        "id": 153393,
                        "name": "Vieux Grand Port",
                        "latitude": "-20.37406600",
                        "longitude": "57.71607700"
                    }
                ]
            },
            {
                "id": 3253,
                "name": "Moka",
                "iso2": "MO",
                "latitude": "-20.23997820",
                "longitude": "57.57592600",
                "type": "district",
                "cities": [
                    {
                        "id": 67841,
                        "name": "Camp Thorel",
                        "latitude": "-20.21472000",
                        "longitude": "57.61611000"
                    },
                    {
                        "id": 67855,
                        "name": "Dagotière",
                        "latitude": "-20.24476000",
                        "longitude": "57.56188000"
                    },
                    {
                        "id": 67856,
                        "name": "Dubreuil",
                        "latitude": "-20.30132000",
                        "longitude": "57.59861000"
                    },
                    {
                        "id": 153448,
                        "name": "L'Avenir",
                        "latitude": "-20.21714200",
                        "longitude": "57.55048200"
                    },
                    {
                        "id": 153447,
                        "name": "L'Esperance",
                        "latitude": "-20.23041300",
                        "longitude": "57.59526800"
                    },
                    {
                        "id": 153449,
                        "name": "La Laura-Malenga",
                        "latitude": "-20.20386100",
                        "longitude": "57.54991500"
                    },
                    {
                        "id": 67877,
                        "name": "Melrose",
                        "latitude": "-20.26972000",
                        "longitude": "57.63194000"
                    },
                    {
                        "id": 67879,
                        "name": "Moka",
                        "latitude": "-20.21889000",
                        "longitude": "57.49583000"
                    },
                    {
                        "id": 153450,
                        "name": "Montagne Blanche",
                        "latitude": "-20.28592000",
                        "longitude": "57.65774600"
                    },
                    {
                        "id": 153451,
                        "name": "Nouvelle Découverte",
                        "latitude": "-20.18600000",
                        "longitude": "57.59079700"
                    },
                    {
                        "id": 67885,
                        "name": "Pailles",
                        "latitude": "-20.19271000",
                        "longitude": "57.48826000"
                    },
                    {
                        "id": 67898,
                        "name": "Providence",
                        "latitude": "-20.24472000",
                        "longitude": "57.61222000"
                    },
                    {
                        "id": 67899,
                        "name": "Quartier Militaire",
                        "latitude": "-20.24790000",
                        "longitude": "57.59737000"
                    },
                    {
                        "id": 153452,
                        "name": "Ripailles",
                        "latitude": "-20.19472500",
                        "longitude": "57.58059600"
                    },
                    {
                        "id": 153445,
                        "name": "Saint Julien D'Hotman",
                        "latitude": "-20.23067000",
                        "longitude": "57.64037800"
                    },
                    {
                        "id": 67912,
                        "name": "Saint Pierre",
                        "latitude": "-20.21750000",
                        "longitude": "57.52083000"
                    },
                    {
                        "id": 67921,
                        "name": "Verdun",
                        "latitude": "-20.23417000",
                        "longitude": "57.55476000"
                    }
                ]
            },
            {
                "id": 3250,
                "name": "Pamplemousses",
                "iso2": "PA",
                "latitude": "-20.11360080",
                "longitude": "57.57592600",
                "type": "district",
                "cities": [
                    {
                        "id": 67828,
                        "name": "Arsenal",
                        "latitude": "-20.10556000",
                        "longitude": "57.53528000"
                    },
                    {
                        "id": 67838,
                        "name": "Calebasses",
                        "latitude": "-20.11167000",
                        "longitude": "57.55389000"
                    },
                    {
                        "id": 67851,
                        "name": "Congomah",
                        "latitude": "-20.14889000",
                        "longitude": "57.59083000"
                    },
                    {
                        "id": 67853,
                        "name": "Crève Coeur",
                        "latitude": "-20.19111000",
                        "longitude": "57.55722000"
                    },
                    {
                        "id": 153413,
                        "name": "D'Epinay",
                        "latitude": "-20.13021100",
                        "longitude": "57.59583800"
                    },
                    {
                        "id": 67861,
                        "name": "Fond du Sac",
                        "latitude": "-20.04732000",
                        "longitude": "57.58400000"
                    },
                    {
                        "id": 67872,
                        "name": "Le Hochet",
                        "latitude": "-20.13500000",
                        "longitude": "57.52111000"
                    },
                    {
                        "id": 67873,
                        "name": "Long Mountain",
                        "latitude": "-20.14306000",
                        "longitude": "57.56222000"
                    },
                    {
                        "id": 67880,
                        "name": "Morcellement Saint André",
                        "latitude": "-20.07199000",
                        "longitude": "57.56833000"
                    },
                    {
                        "id": 67882,
                        "name": "Notre Dame",
                        "latitude": "-20.14056000",
                        "longitude": "57.55306000"
                    },
                    {
                        "id": 67886,
                        "name": "Pamplemousses",
                        "latitude": "-20.10389000",
                        "longitude": "57.57028000"
                    },
                    {
                        "id": 67892,
                        "name": "Plaine des Papayes",
                        "latitude": "-20.06500000",
                        "longitude": "57.57250000"
                    },
                    {
                        "id": 67894,
                        "name": "Pointe aux Piments",
                        "latitude": "-20.06494000",
                        "longitude": "57.52347000"
                    },
                    {
                        "id": 67917,
                        "name": "Terre Rouge",
                        "latitude": "-20.12611000",
                        "longitude": "57.52444000"
                    },
                    {
                        "id": 153416,
                        "name": "Tombeau Bay",
                        "latitude": "-20.12345100",
                        "longitude": "57.50218400"
                    },
                    {
                        "id": 67919,
                        "name": "Triolet",
                        "latitude": "-20.05760000",
                        "longitude": "57.55025000"
                    },
                    {
                        "id": 153417,
                        "name": "Trou Aux Biches",
                        "latitude": "-20.03123500",
                        "longitude": "57.55189700"
                    },
                    {
                        "id": 153415,
                        "name": "Ville Bague",
                        "latitude": "-20.14604500",
                        "longitude": "57.62414900"
                    }
                ]
            },
            {
                "id": 3263,
                "name": "Plaines Wilhems",
                "iso2": "PW",
                "latitude": "-20.30548720",
                "longitude": "57.48535610",
                "type": "district",
                "cities": [
                    {
                        "id": 153454,
                        "name": "Beau Bassin",
                        "latitude": "-20.22538700",
                        "longitude": "57.47145500"
                    },
                    {
                        "id": 67832,
                        "name": "Beau Bassin-Rose Hill",
                        "latitude": "-20.23325000",
                        "longitude": "57.46609000"
                    },
                    {
                        "id": 153916,
                        "name": "Belle Terre",
                        "latitude": "-20.26948370",
                        "longitude": "57.51655530"
                    },
                    {
                        "id": 153911,
                        "name": "Camp Fouqueraux",
                        "latitude": "-20.28568630",
                        "longitude": "57.51718270"
                    },
                    {
                        "id": 153914,
                        "name": "Chebel",
                        "latitude": "-20.21373190",
                        "longitude": "57.46075450"
                    },
                    {
                        "id": 153913,
                        "name": "Coromandel",
                        "latitude": "-20.19522920",
                        "longitude": "57.44565340"
                    },
                    {
                        "id": 67854,
                        "name": "Curepipe",
                        "latitude": "-20.31628000",
                        "longitude": "57.52594000"
                    },
                    {
                        "id": 153456,
                        "name": "Eau Coulee",
                        "latitude": "-20.30336600",
                        "longitude": "57.52778800"
                    },
                    {
                        "id": 67857,
                        "name": "Ebene",
                        "latitude": "-20.24494000",
                        "longitude": "57.49163000"
                    },
                    {
                        "id": 153455,
                        "name": "Floreal",
                        "latitude": "-20.31121400",
                        "longitude": "57.50726300"
                    },
                    {
                        "id": 153457,
                        "name": "Forest Side",
                        "latitude": "-20.32952100",
                        "longitude": "57.53898100"
                    },
                    {
                        "id": 153912,
                        "name": "Glen Park",
                        "latitude": "-20.32440680",
                        "longitude": "57.47531880"
                    },
                    {
                        "id": 153915,
                        "name": "Henrietta",
                        "latitude": "-20.27200480",
                        "longitude": "57.52898870"
                    },
                    {
                        "id": 153918,
                        "name": "Hermitage",
                        "latitude": "-20.27685080",
                        "longitude": "57.53471370"
                    },
                    {
                        "id": 153917,
                        "name": "Highlands",
                        "latitude": "-20.27827480",
                        "longitude": "57.51350410"
                    },
                    {
                        "id": 67878,
                        "name": "Midlands",
                        "latitude": "-20.31907000",
                        "longitude": "57.57016000"
                    },
                    {
                        "id": 153910,
                        "name": "Phoenix",
                        "latitude": "-20.28584460",
                        "longitude": "57.50291860"
                    },
                    {
                        "id": 67900,
                        "name": "Quatre Bornes",
                        "latitude": "-20.26381000",
                        "longitude": "57.47910000"
                    },
                    {
                        "id": 153453,
                        "name": "Rose Hill",
                        "latitude": "-20.24347800",
                        "longitude": "57.46985500"
                    },
                    {
                        "id": 67920,
                        "name": "Vacoas",
                        "latitude": "-20.29806000",
                        "longitude": "57.47833000"
                    }
                ]
            },
            {
                "id": 3260,
                "name": "Port Louis",
                "iso2": "PL",
                "latitude": "-20.16089120",
                "longitude": "57.50122220",
                "type": "district",
                "cities": [
                    {
                        "id": 153419,
                        "name": "Bell Village",
                        "latitude": "-20.17049700",
                        "longitude": "57.48618400"
                    },
                    {
                        "id": 153423,
                        "name": "Caudan Waterfront",
                        "latitude": "-20.16089880",
                        "longitude": "57.49772560"
                    },
                    {
                        "id": 153428,
                        "name": "China Town",
                        "latitude": "-20.15879700",
                        "longitude": "57.50678900"
                    },
                    {
                        "id": 153420,
                        "name": "Les Pailles",
                        "latitude": "-20.19352700",
                        "longitude": "57.48962900"
                    },
                    {
                        "id": 153424,
                        "name": "Les Salines",
                        "latitude": "-20.16016800",
                        "longitude": "57.48904100"
                    },
                    {
                        "id": 153426,
                        "name": "Plaine Verte",
                        "latitude": "-20.15841000",
                        "longitude": "57.51421500"
                    },
                    {
                        "id": 153418,
                        "name": "Pointe aux Sables",
                        "latitude": "-20.17168700",
                        "longitude": "57.45389300"
                    },
                    {
                        "id": 67895,
                        "name": "Port Louis",
                        "latitude": "-20.16194000",
                        "longitude": "57.49889000"
                    },
                    {
                        "id": 153422,
                        "name": "Soreze",
                        "latitude": "-20.20856100",
                        "longitude": "57.48638200"
                    },
                    {
                        "id": 153421,
                        "name": "Tour Koenig",
                        "latitude": "-20.17864600",
                        "longitude": "57.46872100"
                    },
                    {
                        "id": 153425,
                        "name": "Tranquebar",
                        "latitude": "-20.17681600",
                        "longitude": "57.51132900"
                    },
                    {
                        "id": 153429,
                        "name": "Vallée des Prêtres",
                        "latitude": "-20.16514700",
                        "longitude": "57.53403900"
                    },
                    {
                        "id": 153427,
                        "name": "Vallee Pitot",
                        "latitude": "-20.16920000",
                        "longitude": "57.51997000"
                    }
                ]
            },
            {
                "id": 3261,
                "name": "Rivière du Rempart",
                "iso2": "RR",
                "latitude": "-20.05609830",
                "longitude": "57.65523890",
                "type": "district",
                "cities": [
                    {
                        "id": 67827,
                        "name": "Amaury",
                        "latitude": "-20.13083000",
                        "longitude": "57.65917000"
                    },
                    {
                        "id": 153434,
                        "name": "Amitié Gokoola",
                        "latitude": "-20.10688300",
                        "longitude": "57.65472800"
                    },
                    {
                        "id": 67843,
                        "name": "Cap Malheureux",
                        "latitude": "-19.98417000",
                        "longitude": "57.61417000"
                    },
                    {
                        "id": 67852,
                        "name": "Cottage",
                        "latitude": "-20.05972000",
                        "longitude": "57.62917000"
                    },
                    {
                        "id": 67859,
                        "name": "Espérance Trébuchet",
                        "latitude": "-20.06972000",
                        "longitude": "57.64194000"
                    },
                    {
                        "id": 67862,
                        "name": "Goodlands",
                        "latitude": "-20.03841000",
                        "longitude": "57.65055000"
                    },
                    {
                        "id": 67863,
                        "name": "Grand Baie",
                        "latitude": "-20.01816000",
                        "longitude": "57.58015000"
                    },
                    {
                        "id": 67865,
                        "name": "Grand Gaube",
                        "latitude": "-20.00639000",
                        "longitude": "57.66083000"
                    },
                    {
                        "id": 67875,
                        "name": "Mapou",
                        "latitude": "-20.07583000",
                        "longitude": "57.60139000"
                    },
                    {
                        "id": 67887,
                        "name": "Petit Raffray",
                        "latitude": "-20.02022000",
                        "longitude": "57.62296000"
                    },
                    {
                        "id": 67890,
                        "name": "Piton",
                        "latitude": "-20.09028000",
                        "longitude": "57.63028000"
                    },
                    {
                        "id": 67893,
                        "name": "Plaines des Roches",
                        "latitude": "-20.11167000",
                        "longitude": "57.69083000"
                    },
                    {
                        "id": 153431,
                        "name": "Poudre D'Or",
                        "latitude": "-20.06162700",
                        "longitude": "57.68297100"
                    },
                    {
                        "id": 153432,
                        "name": "Poudre D'Or Hamlet",
                        "latitude": "-20.08102400",
                        "longitude": "57.65272600"
                    },
                    {
                        "id": 67905,
                        "name": "Rivière du Rempart",
                        "latitude": "-20.10306000",
                        "longitude": "57.68472000"
                    },
                    {
                        "id": 67906,
                        "name": "Roche Terre",
                        "latitude": "-20.01861000",
                        "longitude": "57.64472000"
                    },
                    {
                        "id": 67907,
                        "name": "Roches Noire",
                        "latitude": "-20.11111000",
                        "longitude": "57.71222000"
                    },
                    {
                        "id": 67918,
                        "name": "The Vale",
                        "latitude": "-20.03018000",
                        "longitude": "57.60219000"
                    }
                ]
            },
            {
                "id": 3249,
                "name": "Rodrigues Island",
                "iso2": "RO",
                "latitude": "-19.72453850",
                "longitude": "63.42721850",
                "type": "dependency",
                "cities": [
                    {
                        "id": 67829,
                        "name": "Baie aux Huîtres",
                        "latitude": "-19.69444000",
                        "longitude": "63.40833000"
                    },
                    {
                        "id": 67896,
                        "name": "Port Mathurin",
                        "latitude": "-19.68333000",
                        "longitude": "63.41667000"
                    }
                ]
            },
            {
                "id": 3251,
                "name": "Saint Brandon Islands",
                "iso2": "CC",
                "latitude": "-16.58333300",
                "longitude": "59.61666700",
                "type": "dependency",
                "cities": [
                    {
                        "id": 67844,
                        "name": "Cargados Carajos",
                        "latitude": "-16.60329000",
                        "longitude": "59.65851000"
                    }
                ]
            },
            {
                "id": 3257,
                "name": "Savanne",
                "iso2": "SA",
                "latitude": "-20.47395300",
                "longitude": "57.48535610",
                "type": "district",
                "cities": [
                    {
                        "id": 153402,
                        "name": "Baie Du Cap",
                        "latitude": "-20.48664400",
                        "longitude": "57.37881500"
                    },
                    {
                        "id": 153406,
                        "name": "Bel Ombre",
                        "latitude": "-20.50191900",
                        "longitude": "57.42550700"
                    },
                    {
                        "id": 153407,
                        "name": "Benares",
                        "latitude": "-20.48440700",
                        "longitude": "57.58871700"
                    },
                    {
                        "id": 153403,
                        "name": "Bois Cheri",
                        "latitude": "-20.42667100",
                        "longitude": "57.53425200"
                    },
                    {
                        "id": 153408,
                        "name": "Britannia",
                        "latitude": "-20.44865500",
                        "longitude": "57.56340700"
                    },
                    {
                        "id": 67839,
                        "name": "Camp Diable",
                        "latitude": "-20.46278000",
                        "longitude": "57.57889000"
                    },
                    {
                        "id": 67847,
                        "name": "Chamouny",
                        "latitude": "-20.48222000",
                        "longitude": "57.46611000"
                    },
                    {
                        "id": 67848,
                        "name": "Chemin Grenier",
                        "latitude": "-20.48722000",
                        "longitude": "57.46556000"
                    },
                    {
                        "id": 67864,
                        "name": "Grand Bois",
                        "latitude": "-20.41889000",
                        "longitude": "57.54417000"
                    },
                    {
                        "id": 153409,
                        "name": "L'Escalier",
                        "latitude": "-20.47333500",
                        "longitude": "57.61867600"
                    },
                    {
                        "id": 153411,
                        "name": "La Flora",
                        "latitude": "-20.41000500",
                        "longitude": "57.56048700"
                    },
                    {
                        "id": 67904,
                        "name": "Rivière des Anguilles",
                        "latitude": "-20.48528000",
                        "longitude": "57.55083000"
                    },
                    {
                        "id": 153405,
                        "name": "Rivière Du Poste",
                        "latitude": "-20.42866200",
                        "longitude": "57.57368100"
                    },
                    {
                        "id": 67909,
                        "name": "Saint Aubin",
                        "latitude": "-20.49600000",
                        "longitude": "57.55000000"
                    },
                    {
                        "id": 67914,
                        "name": "Souillac",
                        "latitude": "-20.51667000",
                        "longitude": "57.51667000"
                    },
                    {
                        "id": 153410,
                        "name": "St Aubin",
                        "latitude": "-20.49444600",
                        "longitude": "57.55033500"
                    },
                    {
                        "id": 67915,
                        "name": "Surinam",
                        "latitude": "-20.50972000",
                        "longitude": "57.50528000"
                    }
                ]
            }
        ]
    },
    {
        "id": 141,
        "name": "Mayotte",
        "iso3": "MYT",
        "iso2": "YT",
        "numeric_code": "175",
        "phonecode": "262",
        "capital": "Mamoudzou",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".yt",
        "native": "Mayotte",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Mahoran",
        "timezones": [
            {
                "zoneName": "Indian\/Mayotte",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Mayotte",
            "ko": "마요트",
            "pt-BR": "Mayotte",
            "pt": "Mayotte",
            "nl": "Mayotte",
            "hr": "Mayotte",
            "fa": "مایوت",
            "de": "Mayotte",
            "es": "Mayotte",
            "fr": "Mayotte",
            "ja": "マヨット",
            "it": "Mayotte",
            "zh-CN": "马约特",
            "tr": "Mayotte",
            "ru": "Майотта",
            "uk": "Майотта",
            "pl": "Majotta"
        },
        "latitude": "-12.83333333",
        "longitude": "45.16666666",
        "emoji": "🇾🇹",
        "emojiU": "U+1F1FE U+1F1F9",
        "states": [
            {
                "id": 5415,
                "name": "Acoua",
                "iso2": "14",
                "latitude": "-12.72491260",
                "longitude": "45.02659610",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5417,
                "name": "Bandraboua",
                "iso2": "16",
                "latitude": "-12.71756860",
                "longitude": "45.08256190",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5406,
                "name": "Bandrélé",
                "iso2": "05",
                "latitude": "-12.93380490",
                "longitude": "45.14634720",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5408,
                "name": "Boueni",
                "iso2": "07",
                "latitude": "-12.93035660",
                "longitude": "45.05747370",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5412,
                "name": "Chiconi",
                "iso2": "11",
                "latitude": "-12.83220320",
                "longitude": "45.10251220",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5409,
                "name": "Chirongui",
                "iso2": "08",
                "latitude": "-12.91752330",
                "longitude": "45.10196780",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5405,
                "name": "Dembeni",
                "iso2": "04",
                "latitude": "-12.85300290",
                "longitude": "45.13925120",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5402,
                "name": "Dzaoudzi",
                "iso2": "01",
                "latitude": "-12.77606510",
                "longitude": "45.25632460",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5407,
                "name": "Kani Keli",
                "iso2": "06",
                "latitude": "-12.97464500",
                "longitude": "45.07951430",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5418,
                "name": "Koungou",
                "iso2": "17",
                "latitude": "-12.74168230",
                "longitude": "45.14998710",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5414,
                "name": "M'Tsangamouji",
                "iso2": "13",
                "latitude": "-12.75500880",
                "longitude": "45.04327920",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5404,
                "name": "Mamoudzou",
                "iso2": "03",
                "latitude": "-12.78750520",
                "longitude": "45.15522010",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5416,
                "name": "Mtsamboro",
                "iso2": "15",
                "latitude": "-12.67625800",
                "longitude": "45.02152010",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5411,
                "name": "Ouangani",
                "iso2": "10",
                "latitude": "-12.83925080",
                "longitude": "45.09716170",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5403,
                "name": "Pamandzi",
                "iso2": "02",
                "latitude": "-12.80096930",
                "longitude": "45.26361320",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5410,
                "name": "Sada",
                "iso2": "09",
                "latitude": "-12.86424390",
                "longitude": "45.07224040",
                "type": "commune",
                "cities": []
            },
            {
                "id": 5413,
                "name": "Tsingoni",
                "iso2": "12",
                "latitude": "-12.78236960",
                "longitude": "45.09220000",
                "type": "commune",
                "cities": []
            }
        ]
    },
    {
        "id": 142,
        "name": "Mexico",
        "iso3": "MEX",
        "iso2": "MX",
        "numeric_code": "484",
        "phonecode": "52",
        "capital": "Ciudad de México",
        "currency": "MXN",
        "currency_name": "Mexican peso",
        "currency_symbol": "$",
        "tld": ".mx",
        "native": "México",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Northern America",
        "subregion_id": 6,
        "nationality": "Mexican",
        "timezones": [
            {
                "zoneName": "America\/Bahia_Banderas",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Cancun",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Chihuahua",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Hermosillo",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Matamoros",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Mazatlan",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Merida",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Mexico_City",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Monterrey",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Ojinaga",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Tijuana",
                "gmtOffset": -28800,
                "gmtOffsetName": "UTC-08:00",
                "abbreviation": "PST",
                "tzName": "Pacific Standard Time (North America"
            }
        ],
        "translations": {
            "ko": "멕시코",
            "pt-BR": "México",
            "pt": "México",
            "nl": "Mexico",
            "hr": "Meksiko",
            "fa": "مکزیک",
            "de": "Mexibr",
            "es": "México",
            "fr": "Mexique",
            "ja": "メキシコ",
            "it": "Messico",
            "zh-CN": "墨西哥",
            "tr": "Meksika",
            "ru": "Мексика",
            "uk": "Мексика",
            "pl": "Meksyk"
        },
        "latitude": "23.00000000",
        "longitude": "-102.00000000",
        "emoji": "🇲🇽",
        "emojiU": "U+1F1F2 U+1F1FD",
        "states": [
            {
                "id": 3456,
                "name": "Aguascalientes",
                "iso2": "AGU",
                "latitude": "21.88525620",
                "longitude": "-102.29156770",
                "type": "state",
                "cities": [
                    {
                        "id": 68127,
                        "name": "Aguascalientes",
                        "latitude": "21.88333000",
                        "longitude": "-102.30000000"
                    },
                    {
                        "id": 68336,
                        "name": "Arboledas Paso Blanco [Fraccionamiento]",
                        "latitude": "21.96361000",
                        "longitude": "-102.30194000"
                    },
                    {
                        "id": 68342,
                        "name": "Arellano",
                        "latitude": "21.80106000",
                        "longitude": "-102.27384000"
                    },
                    {
                        "id": 68380,
                        "name": "Asientos",
                        "latitude": "22.23333000",
                        "longitude": "-102.08333000"
                    },
                    {
                        "id": 68616,
                        "name": "Bimbaletes Aguascalientes (El Álamo)",
                        "latitude": "22.23444000",
                        "longitude": "-102.01917000"
                    },
                    {
                        "id": 68752,
                        "name": "Calvillo",
                        "latitude": "21.85000000",
                        "longitude": "-102.71666000"
                    },
                    {
                        "id": 68820,
                        "name": "Carboneras",
                        "latitude": "22.18311000",
                        "longitude": "-102.24601000"
                    },
                    {
                        "id": 68844,
                        "name": "Cartagena [Fraccionamiento]",
                        "latitude": "21.95639000",
                        "longitude": "-102.27639000"
                    },
                    {
                        "id": 68900,
                        "name": "Centro de Arriba",
                        "latitude": "21.73123000",
                        "longitude": "-102.49888000"
                    },
                    {
                        "id": 69197,
                        "name": "Ciénega Grande",
                        "latitude": "22.19434000",
                        "longitude": "-102.01940000"
                    },
                    {
                        "id": 69486,
                        "name": "Corral de Barrancos",
                        "latitude": "21.95028000",
                        "longitude": "-102.33222000"
                    },
                    {
                        "id": 69507,
                        "name": "Cosío",
                        "latitude": "22.36667000",
                        "longitude": "-102.30000000"
                    },
                    {
                        "id": 69510,
                        "name": "Cotorina",
                        "latitude": "21.75154000",
                        "longitude": "-102.26832000"
                    },
                    {
                        "id": 69539,
                        "name": "Crucero Las Pilas",
                        "latitude": "21.82722000",
                        "longitude": "-102.76033000"
                    },
                    {
                        "id": 69634,
                        "name": "Cumbres III",
                        "latitude": "21.92222000",
                        "longitude": "-102.23750000"
                    },
                    {
                        "id": 69813,
                        "name": "Ejido la Guayana (Rancho Seco)",
                        "latitude": "21.98028000",
                        "longitude": "-102.27306000"
                    },
                    {
                        "id": 69837,
                        "name": "El Bajío",
                        "latitude": "22.24558000",
                        "longitude": "-102.30825000"
                    },
                    {
                        "id": 69899,
                        "name": "El Chayote",
                        "latitude": "22.28667000",
                        "longitude": "-102.23900000"
                    },
                    {
                        "id": 69935,
                        "name": "El Cuervero (Cuerveros)",
                        "latitude": "21.86056000",
                        "longitude": "-102.68389000"
                    },
                    {
                        "id": 70023,
                        "name": "El Llano",
                        "latitude": "21.91667000",
                        "longitude": "-101.96666000"
                    },
                    {
                        "id": 70154,
                        "name": "El Refugio de Peñuelas",
                        "latitude": "21.71635000",
                        "longitude": "-102.28941000"
                    },
                    {
                        "id": 70155,
                        "name": "El Refugio de Providencia (Providencia)",
                        "latitude": "22.34667000",
                        "longitude": "-102.25778000"
                    },
                    {
                        "id": 70185,
                        "name": "El Salero",
                        "latitude": "22.38706000",
                        "longitude": "-102.32323000"
                    },
                    {
                        "id": 70240,
                        "name": "El Tule",
                        "latitude": "22.08438000",
                        "longitude": "-102.09100000"
                    },
                    {
                        "id": 70285,
                        "name": "Emiliano Zapata",
                        "latitude": "22.10635000",
                        "longitude": "-102.30056000"
                    },
                    {
                        "id": 70315,
                        "name": "Escaleras",
                        "latitude": "22.25054000",
                        "longitude": "-102.33377000"
                    },
                    {
                        "id": 70387,
                        "name": "Ex-Viñedos Guadalupe",
                        "latitude": "21.95944000",
                        "longitude": "-102.27417000"
                    },
                    {
                        "id": 70535,
                        "name": "General Ignacio Zaragoza",
                        "latitude": "21.88136000",
                        "longitude": "-102.46454000"
                    },
                    {
                        "id": 70608,
                        "name": "Guadalupe de Atlas",
                        "latitude": "22.26653000",
                        "longitude": "-102.03118000"
                    },
                    {
                        "id": 70989,
                        "name": "Jaltiche de Arriba",
                        "latitude": "21.77525000",
                        "longitude": "-102.78849000"
                    },
                    {
                        "id": 70993,
                        "name": "Jaltomate",
                        "latitude": "22.01528000",
                        "longitude": "-102.14583000"
                    },
                    {
                        "id": 71007,
                        "name": "Jarillas",
                        "latitude": "22.29611000",
                        "longitude": "-102.06333000"
                    },
                    {
                        "id": 71024,
                        "name": "Jesús Gómez Portugal",
                        "latitude": "21.99607000",
                        "longitude": "-102.29095000"
                    },
                    {
                        "id": 71025,
                        "name": "Jesús Gómez Portugal (Margaritas)",
                        "latitude": "21.99917000",
                        "longitude": "-102.29139000"
                    },
                    {
                        "id": 71032,
                        "name": "Jesús María",
                        "latitude": "21.96667000",
                        "longitude": "-102.35000000"
                    },
                    {
                        "id": 71232,
                        "name": "La Concepción",
                        "latitude": "22.03537000",
                        "longitude": "-102.29989000"
                    },
                    {
                        "id": 71267,
                        "name": "La Escondida",
                        "latitude": "22.03573000",
                        "longitude": "-102.25931000"
                    },
                    {
                        "id": 71340,
                        "name": "La Labor",
                        "latitude": "21.96207000",
                        "longitude": "-102.69626000"
                    },
                    {
                        "id": 71369,
                        "name": "La Loma de los Negritos",
                        "latitude": "21.87056000",
                        "longitude": "-102.35000000"
                    },
                    {
                        "id": 71431,
                        "name": "La Panadera",
                        "latitude": "21.86398000",
                        "longitude": "-102.69832000"
                    },
                    {
                        "id": 71467,
                        "name": "La Punta",
                        "latitude": "22.32411000",
                        "longitude": "-102.29212000"
                    },
                    {
                        "id": 71656,
                        "name": "Las Ánimas",
                        "latitude": "22.09057000",
                        "longitude": "-102.26684000"
                    },
                    {
                        "id": 71627,
                        "name": "Las Norias de Ojocaliente",
                        "latitude": "21.88944000",
                        "longitude": "-102.21738000"
                    },
                    {
                        "id": 71893,
                        "name": "Lázaro Cárdenas",
                        "latitude": "22.17137000",
                        "longitude": "-102.02704000"
                    },
                    {
                        "id": 71774,
                        "name": "Los Arquitos",
                        "latitude": "21.92299000",
                        "longitude": "-102.38554000"
                    },
                    {
                        "id": 71785,
                        "name": "Los Caños",
                        "latitude": "21.78167000",
                        "longitude": "-102.46750000"
                    },
                    {
                        "id": 71792,
                        "name": "Los Conos",
                        "latitude": "21.89739000",
                        "longitude": "-101.99487000"
                    },
                    {
                        "id": 71903,
                        "name": "Macario J. Gómez [Colonia]",
                        "latitude": "21.98056000",
                        "longitude": "-102.25139000"
                    },
                    {
                        "id": 71948,
                        "name": "Malpaso",
                        "latitude": "21.85896000",
                        "longitude": "-102.66441000"
                    },
                    {
                        "id": 71986,
                        "name": "Maravillas",
                        "latitude": "21.95408000",
                        "longitude": "-102.32982000"
                    },
                    {
                        "id": 72079,
                        "name": "Mesa Grande",
                        "latitude": "21.80529000",
                        "longitude": "-102.72181000"
                    },
                    {
                        "id": 72155,
                        "name": "Miravalle",
                        "latitude": "21.97250000",
                        "longitude": "-102.31139000"
                    },
                    {
                        "id": 72187,
                        "name": "Molinos",
                        "latitude": "22.16278000",
                        "longitude": "-102.09472000"
                    },
                    {
                        "id": 72221,
                        "name": "Montoro",
                        "latitude": "21.75603000",
                        "longitude": "-102.30219000"
                    },
                    {
                        "id": 72353,
                        "name": "Noria del Borrego (Norias)",
                        "latitude": "22.28722000",
                        "longitude": "-102.04194000"
                    },
                    {
                        "id": 72354,
                        "name": "Norias del Paso Hondo",
                        "latitude": "21.86177000",
                        "longitude": "-102.20681000"
                    },
                    {
                        "id": 72491,
                        "name": "Ojo de Agua de Crucitas",
                        "latitude": "21.96426000",
                        "longitude": "-101.95202000"
                    },
                    {
                        "id": 72498,
                        "name": "Ojocaliente",
                        "latitude": "21.87390000",
                        "longitude": "-102.67684000"
                    },
                    {
                        "id": 72562,
                        "name": "Pabellón de Arteaga",
                        "latitude": "22.15000000",
                        "longitude": "-102.26666000"
                    },
                    {
                        "id": 72563,
                        "name": "Pabellón de Hidalgo",
                        "latitude": "22.17871000",
                        "longitude": "-102.34014000"
                    },
                    {
                        "id": 72604,
                        "name": "Palo Alto",
                        "latitude": "21.91801000",
                        "longitude": "-101.96453000"
                    },
                    {
                        "id": 72652,
                        "name": "Paredes",
                        "latitude": "22.14958000",
                        "longitude": "-102.48232000"
                    },
                    {
                        "id": 72671,
                        "name": "Paseos de la Providencia [Fraccionamiento]",
                        "latitude": "22.02425000",
                        "longitude": "-102.27711000"
                    },
                    {
                        "id": 72672,
                        "name": "Paseos de las Haciendas [Fraccionamiento]",
                        "latitude": "21.99222000",
                        "longitude": "-102.34361000"
                    },
                    {
                        "id": 72675,
                        "name": "Paso Blanco",
                        "latitude": "21.97361000",
                        "longitude": "-102.31694000"
                    },
                    {
                        "id": 72755,
                        "name": "Peñuelas (El Cienegal)",
                        "latitude": "21.72250000",
                        "longitude": "-102.27583000"
                    },
                    {
                        "id": 72777,
                        "name": "Pilotos",
                        "latitude": "22.03722000",
                        "longitude": "-101.95917000"
                    },
                    {
                        "id": 72835,
                        "name": "Pocitos",
                        "latitude": "21.92167000",
                        "longitude": "-102.33472000"
                    },
                    {
                        "id": 72964,
                        "name": "Puertecito de la Virgen",
                        "latitude": "21.96028000",
                        "longitude": "-102.26889000"
                    },
                    {
                        "id": 73133,
                        "name": "Rincón de Romos",
                        "latitude": "22.23333000",
                        "longitude": "-102.31666000"
                    },
                    {
                        "id": 73315,
                        "name": "San Antonio",
                        "latitude": "22.22823000",
                        "longitude": "-102.25034000"
                    },
                    {
                        "id": 73374,
                        "name": "San Antonio de los Horcones",
                        "latitude": "21.99832000",
                        "longitude": "-102.32663000"
                    },
                    {
                        "id": 73376,
                        "name": "San Antonio de los Ríos",
                        "latitude": "22.16104000",
                        "longitude": "-102.47118000"
                    },
                    {
                        "id": 73365,
                        "name": "San Antonio de Peñuelas",
                        "latitude": "21.67471000",
                        "longitude": "-102.30010000"
                    },
                    {
                        "id": 73616,
                        "name": "San Francisco de los Romo",
                        "latitude": "22.03307000",
                        "longitude": "-102.22902000"
                    },
                    {
                        "id": 73650,
                        "name": "San Ignacio",
                        "latitude": "21.89269000",
                        "longitude": "-102.33974000"
                    },
                    {
                        "id": 73693,
                        "name": "San Jacinto",
                        "latitude": "22.34861000",
                        "longitude": "-102.23361000"
                    },
                    {
                        "id": 73819,
                        "name": "San José de Gracia",
                        "latitude": "22.15000000",
                        "longitude": "-102.41666000"
                    },
                    {
                        "id": 74058,
                        "name": "San Luis de Letras",
                        "latitude": "22.13551000",
                        "longitude": "-102.29729000"
                    },
                    {
                        "id": 74475,
                        "name": "San Sebastián [Fraccionamiento]",
                        "latitude": "21.82139000",
                        "longitude": "-102.27111000"
                    },
                    {
                        "id": 74490,
                        "name": "San Tadeo",
                        "latitude": "21.91954000",
                        "longitude": "-102.70043000"
                    },
                    {
                        "id": 74680,
                        "name": "Santa Isabel [Fraccionamiento]",
                        "latitude": "22.08111000",
                        "longitude": "-102.26778000"
                    },
                    {
                        "id": 74807,
                        "name": "Santa María de la Paz",
                        "latitude": "22.38786000",
                        "longitude": "-102.25697000"
                    },
                    {
                        "id": 74839,
                        "name": "Santa Rosa (El Huizache)",
                        "latitude": "21.93500000",
                        "longitude": "-102.02194000"
                    },
                    {
                        "id": 74869,
                        "name": "Santiago",
                        "latitude": "22.11948000",
                        "longitude": "-102.33769000"
                    },
                    {
                        "id": 75415,
                        "name": "Tepetates",
                        "latitude": "21.95667000",
                        "longitude": "-102.32167000"
                    },
                    {
                        "id": 75446,
                        "name": "Tepezalá",
                        "latitude": "22.21667000",
                        "longitude": "-102.16666000"
                    },
                    {
                        "id": 75913,
                        "name": "Valladolid",
                        "latitude": "22.02111000",
                        "longitude": "-102.31500000"
                    },
                    {
                        "id": 75915,
                        "name": "Valle Huejúcar (Fraccionamiento Popular) [Fraccionamiento]",
                        "latitude": "21.83111000",
                        "longitude": "-102.75028000"
                    },
                    {
                        "id": 76024,
                        "name": "Villa Juárez",
                        "latitude": "22.09447000",
                        "longitude": "-102.06930000"
                    },
                    {
                        "id": 76026,
                        "name": "Villa Licenciado Jesús Terán (Calvillito)",
                        "latitude": "21.82528000",
                        "longitude": "-102.18778000"
                    }
                ]
            },
            {
                "id": 3457,
                "name": "Baja California",
                "iso2": "BCN",
                "latitude": "30.84063380",
                "longitude": "-115.28375850",
                "type": "state",
                "cities": [
                    {
                        "id": 68194,
                        "name": "Alfonso Garzón [Granjas Familiares]",
                        "latitude": "32.54667000",
                        "longitude": "-116.61722000"
                    },
                    {
                        "id": 68586,
                        "name": "Benito García (El Zorrillo)",
                        "latitude": "31.67111000",
                        "longitude": "-116.51139000"
                    },
                    {
                        "id": 68596,
                        "name": "Benito Juárez",
                        "latitude": "32.56852000",
                        "longitude": "-114.99422000"
                    },
                    {
                        "id": 68689,
                        "name": "Buenos Aires",
                        "latitude": "32.42278000",
                        "longitude": "-116.94111000"
                    },
                    {
                        "id": 68757,
                        "name": "Camalú",
                        "latitude": "30.84222000",
                        "longitude": "-116.06328000"
                    },
                    {
                        "id": 68906,
                        "name": "Cereso del Hongo",
                        "latitude": "32.48417000",
                        "longitude": "-116.25056000"
                    },
                    {
                        "id": 69150,
                        "name": "Ciudad Coahuila (Kilómetro Cincuenta y Siete)",
                        "latitude": "32.19556000",
                        "longitude": "-115.00250000"
                    },
                    {
                        "id": 69172,
                        "name": "Ciudad Morelos",
                        "latitude": "32.34389000",
                        "longitude": "-117.01056000"
                    },
                    {
                        "id": 69260,
                        "name": "Colinas del Sol",
                        "latitude": "32.40306000",
                        "longitude": "-117.03056000"
                    },
                    {
                        "id": 69310,
                        "name": "Colonia Gómez Morín",
                        "latitude": "31.88167000",
                        "longitude": "-116.54389000"
                    },
                    {
                        "id": 69323,
                        "name": "Colonia Lomas de San Ramón (Triquis)",
                        "latitude": "30.70167000",
                        "longitude": "-116.00278000"
                    },
                    {
                        "id": 69339,
                        "name": "Colonia Nueva Era",
                        "latitude": "30.50667000",
                        "longitude": "-115.92250000"
                    },
                    {
                        "id": 69376,
                        "name": "Colonia Venustiano Carranza",
                        "latitude": "32.23700000",
                        "longitude": "-115.16656000"
                    },
                    {
                        "id": 69677,
                        "name": "Delta",
                        "latitude": "32.35497000",
                        "longitude": "-115.19617000"
                    },
                    {
                        "id": 69691,
                        "name": "Doctor Alberto Oviedo Mota",
                        "latitude": "32.22756000",
                        "longitude": "-115.16792000"
                    },
                    {
                        "id": 69732,
                        "name": "Durango",
                        "latitude": "32.24865000",
                        "longitude": "-115.25227000"
                    },
                    {
                        "id": 69762,
                        "name": "Ejido Doctor Alberto Oviedo Mota (El Indiviso)",
                        "latitude": "32.02444000",
                        "longitude": "-114.98361000"
                    },
                    {
                        "id": 69765,
                        "name": "Ejido General Leandro Valle",
                        "latitude": "30.62167000",
                        "longitude": "-115.96583000"
                    },
                    {
                        "id": 69768,
                        "name": "Ejido Javier Rojo Gómez",
                        "latitude": "32.49389000",
                        "longitude": "-116.82222000"
                    },
                    {
                        "id": 69770,
                        "name": "Ejido Jiquilpan",
                        "latitude": "32.50131000",
                        "longitude": "-115.06382000"
                    },
                    {
                        "id": 69774,
                        "name": "Ejido Lázaro Cárdenas",
                        "latitude": "32.60794000",
                        "longitude": "-115.02076000"
                    },
                    {
                        "id": 69776,
                        "name": "Ejido Michoacán de Ocampo",
                        "latitude": "32.46512000",
                        "longitude": "-115.31003000"
                    },
                    {
                        "id": 69778,
                        "name": "Ejido Netzahualcóyotl",
                        "latitude": "32.62444000",
                        "longitude": "-115.06222000"
                    },
                    {
                        "id": 69780,
                        "name": "Ejido Nuevo León",
                        "latitude": "32.41103000",
                        "longitude": "-115.18827000"
                    },
                    {
                        "id": 69782,
                        "name": "Ejido Ojo de Agua",
                        "latitude": "32.47556000",
                        "longitude": "-116.78917000"
                    },
                    {
                        "id": 69785,
                        "name": "Ejido Pátzcuaro",
                        "latitude": "32.35139000",
                        "longitude": "-115.06583000"
                    },
                    {
                        "id": 69784,
                        "name": "Ejido Plan de Ayala",
                        "latitude": "32.22023000",
                        "longitude": "-115.03158000"
                    },
                    {
                        "id": 69786,
                        "name": "Ejido Quintana Roo",
                        "latitude": "32.46844000",
                        "longitude": "-115.08250000"
                    },
                    {
                        "id": 69787,
                        "name": "Ejido Saltillo",
                        "latitude": "32.42430000",
                        "longitude": "-115.12480000"
                    },
                    {
                        "id": 69792,
                        "name": "Ejido Sinaloa",
                        "latitude": "32.54734000",
                        "longitude": "-115.27041000"
                    },
                    {
                        "id": 69793,
                        "name": "Ejido Sonora",
                        "latitude": "32.28749000",
                        "longitude": "-115.23134000"
                    },
                    {
                        "id": 69794,
                        "name": "Ejido Tabasco",
                        "latitude": "32.56187000",
                        "longitude": "-114.92659000"
                    },
                    {
                        "id": 69795,
                        "name": "Ejido Toluca",
                        "latitude": "32.43050000",
                        "longitude": "-115.08316000"
                    },
                    {
                        "id": 69798,
                        "name": "Ejido Vicente Guerrero",
                        "latitude": "32.39593000",
                        "longitude": "-115.14026000"
                    },
                    {
                        "id": 69800,
                        "name": "Ejido Yucatán",
                        "latitude": "32.60435000",
                        "longitude": "-115.09380000"
                    },
                    {
                        "id": 70066,
                        "name": "El Niño",
                        "latitude": "32.50750000",
                        "longitude": "-116.79194000"
                    },
                    {
                        "id": 70116,
                        "name": "El Porvenir",
                        "latitude": "32.07606000",
                        "longitude": "-116.62473000"
                    },
                    {
                        "id": 70178,
                        "name": "El Rosario de Arriba",
                        "latitude": "30.05984000",
                        "longitude": "-115.72448000"
                    },
                    {
                        "id": 70203,
                        "name": "El Sauzal de Rodríguez",
                        "latitude": "31.89329000",
                        "longitude": "-116.69256000"
                    },
                    {
                        "id": 70289,
                        "name": "Emiliano Zapata",
                        "latitude": "30.75417000",
                        "longitude": "-116.00306000"
                    },
                    {
                        "id": 70305,
                        "name": "Ensenada",
                        "latitude": "31.86667000",
                        "longitude": "-116.61666000"
                    },
                    {
                        "id": 70337,
                        "name": "Estación Coahuila",
                        "latitude": "32.19304000",
                        "longitude": "-114.99933000"
                    },
                    {
                        "id": 70349,
                        "name": "Estación Pescaderos",
                        "latitude": "32.31196000",
                        "longitude": "-115.13823000"
                    },
                    {
                        "id": 70449,
                        "name": "Fraccionamiento del Valle",
                        "latitude": "31.91139000",
                        "longitude": "-116.26056000"
                    },
                    {
                        "id": 70484,
                        "name": "Francisco Zarco",
                        "latitude": "32.09872000",
                        "longitude": "-116.56863000"
                    },
                    {
                        "id": 70599,
                        "name": "Guadalupe Victoria",
                        "latitude": "32.28924000",
                        "longitude": "-115.10534000"
                    },
                    {
                        "id": 70633,
                        "name": "Guerrero Negro",
                        "latitude": "27.96891000",
                        "longitude": "-114.04427000"
                    },
                    {
                        "id": 70655,
                        "name": "Hacienda Tecate",
                        "latitude": "32.56500000",
                        "longitude": "-116.52500000"
                    },
                    {
                        "id": 70673,
                        "name": "Hermosillo",
                        "latitude": "32.51097000",
                        "longitude": "-114.92278000"
                    },
                    {
                        "id": 70888,
                        "name": "Islas Agrarias Grupo A",
                        "latitude": "32.61096000",
                        "longitude": "-115.33151000"
                    },
                    {
                        "id": 70889,
                        "name": "Islas Agrarias Grupo B",
                        "latitude": "32.60034000",
                        "longitude": "-115.27172000"
                    },
                    {
                        "id": 71277,
                        "name": "La Esperanza [Granjas Familiares]",
                        "latitude": "32.46278000",
                        "longitude": "-117.10500000"
                    },
                    {
                        "id": 71463,
                        "name": "La Providencia",
                        "latitude": "30.96889000",
                        "longitude": "-116.15861000"
                    },
                    {
                        "id": 71581,
                        "name": "Las Brisas",
                        "latitude": "30.96056000",
                        "longitude": "-116.16444000"
                    },
                    {
                        "id": 71597,
                        "name": "Las Delicias",
                        "latitude": "32.40889000",
                        "longitude": "-116.94361000"
                    },
                    {
                        "id": 71891,
                        "name": "Lázaro Cárdenas",
                        "latitude": "30.52815000",
                        "longitude": "-115.92617000"
                    },
                    {
                        "id": 71676,
                        "name": "Licenciado Gustavo Díaz Ordaz",
                        "latitude": "30.97506000",
                        "longitude": "-116.15565000"
                    },
                    {
                        "id": 71753,
                        "name": "Lomas de Santa Anita",
                        "latitude": "32.54278000",
                        "longitude": "-116.65139000"
                    },
                    {
                        "id": 71757,
                        "name": "Lomas de Tlatelolco",
                        "latitude": "32.48306000",
                        "longitude": "-116.80167000"
                    },
                    {
                        "id": 71766,
                        "name": "Los Algodones",
                        "latitude": "32.70000000",
                        "longitude": "-114.73333000"
                    },
                    {
                        "id": 71867,
                        "name": "Los Valles",
                        "latitude": "32.39250000",
                        "longitude": "-116.95500000"
                    },
                    {
                        "id": 71883,
                        "name": "Luis Rodríguez (El Vergel)",
                        "latitude": "30.40722000",
                        "longitude": "-115.88722000"
                    },
                    {
                        "id": 71908,
                        "name": "Maclovio Herrera (Colonia Aviación)",
                        "latitude": "32.54194000",
                        "longitude": "-116.63611000"
                    },
                    {
                        "id": 71909,
                        "name": "Maclovio Rojas",
                        "latitude": "32.47306000",
                        "longitude": "-116.80278000"
                    },
                    {
                        "id": 72099,
                        "name": "Mexicali",
                        "latitude": "32.50513000",
                        "longitude": "-115.14771000"
                    },
                    {
                        "id": 72815,
                        "name": "Playas de Rosarito",
                        "latitude": "32.34342000",
                        "longitude": "-117.03186000"
                    },
                    {
                        "id": 72824,
                        "name": "Poblado Chulavista (El Chorizo)",
                        "latitude": "30.74722000",
                        "longitude": "-116.00306000"
                    },
                    {
                        "id": 72827,
                        "name": "Poblado Lázaro Cárdenas (La Veintiocho)",
                        "latitude": "32.37333000",
                        "longitude": "-115.06528000"
                    },
                    {
                        "id": 73014,
                        "name": "Pórticos de San Antonio",
                        "latitude": "32.44250000",
                        "longitude": "-117.03417000"
                    },
                    {
                        "id": 72904,
                        "name": "Primo Tapia",
                        "latitude": "32.22226000",
                        "longitude": "-116.91390000"
                    },
                    {
                        "id": 72910,
                        "name": "Progreso",
                        "latitude": "32.58039000",
                        "longitude": "-115.58479000"
                    },
                    {
                        "id": 72926,
                        "name": "Puebla",
                        "latitude": "32.56654000",
                        "longitude": "-115.35340000"
                    },
                    {
                        "id": 72930,
                        "name": "Pueblo Benito García",
                        "latitude": "30.51583000",
                        "longitude": "-115.93278000"
                    },
                    {
                        "id": 73035,
                        "name": "Quinta del Cedro",
                        "latitude": "32.43750000",
                        "longitude": "-117.06583000"
                    },
                    {
                        "id": 73061,
                        "name": "Rancho La Gloria",
                        "latitude": "32.44619000",
                        "longitude": "-117.00103000"
                    },
                    {
                        "id": 73071,
                        "name": "Rancho Verde",
                        "latitude": "31.91611000",
                        "longitude": "-116.58833000"
                    },
                    {
                        "id": 73147,
                        "name": "Rodolfo Sánchez Taboada",
                        "latitude": "31.72099000",
                        "longitude": "-116.57184000"
                    },
                    {
                        "id": 73164,
                        "name": "Rosarito",
                        "latitude": "32.36044000",
                        "longitude": "-117.04645000"
                    },
                    {
                        "id": 73165,
                        "name": "Rumorosa",
                        "latitude": "32.52396000",
                        "longitude": "-116.05397000"
                    },
                    {
                        "id": 73229,
                        "name": "Salvador Rosas Magallón",
                        "latitude": "31.90139000",
                        "longitude": "-116.54778000"
                    },
                    {
                        "id": 73510,
                        "name": "San Felipe",
                        "latitude": "31.02468000",
                        "longitude": "-114.83919000"
                    },
                    {
                        "id": 74042,
                        "name": "San Luis",
                        "latitude": "32.43167000",
                        "longitude": "-116.95361000"
                    },
                    {
                        "id": 74421,
                        "name": "San Quintín",
                        "latitude": "30.57228000",
                        "longitude": "-115.94607000"
                    },
                    {
                        "id": 74492,
                        "name": "San Vicente",
                        "latitude": "31.32518000",
                        "longitude": "-116.24662000"
                    },
                    {
                        "id": 74560,
                        "name": "Santa Anita",
                        "latitude": "32.10083000",
                        "longitude": "-116.86917000"
                    },
                    {
                        "id": 74663,
                        "name": "Santa Fé",
                        "latitude": "30.67984000",
                        "longitude": "-115.97653000"
                    },
                    {
                        "id": 74673,
                        "name": "Santa Isabel",
                        "latitude": "32.63330000",
                        "longitude": "-115.57605000"
                    },
                    {
                        "id": 75267,
                        "name": "Tecate",
                        "latitude": "32.55029000",
                        "longitude": "-116.63223000"
                    },
                    {
                        "id": 75276,
                        "name": "Tecolots",
                        "latitude": "32.56667000",
                        "longitude": "-114.98333000"
                    },
                    {
                        "id": 75469,
                        "name": "Terrazas del Valle",
                        "latitude": "32.48750000",
                        "longitude": "-116.82667000"
                    },
                    {
                        "id": 75562,
                        "name": "Tijuana",
                        "latitude": "32.50223000",
                        "longitude": "-116.97212000"
                    },
                    {
                        "id": 75976,
                        "name": "Vicente Guerrero",
                        "latitude": "30.73097000",
                        "longitude": "-115.99071000"
                    },
                    {
                        "id": 76072,
                        "name": "Villa del Campo",
                        "latitude": "32.50750000",
                        "longitude": "-116.73833000"
                    },
                    {
                        "id": 76074,
                        "name": "Villa del Prado 2da Sección",
                        "latitude": "32.42389000",
                        "longitude": "-116.97167000"
                    },
                    {
                        "id": 76103,
                        "name": "Viñas del Sol",
                        "latitude": "32.62694000",
                        "longitude": "-115.54667000"
                    }
                ]
            },
            {
                "id": 3460,
                "name": "Baja California Sur",
                "iso2": "BCS",
                "latitude": "26.04444460",
                "longitude": "-111.66607250",
                "type": "state",
                "cities": [
                    {
                        "id": 68498,
                        "name": "Bahía Asunción",
                        "latitude": "27.14231000",
                        "longitude": "-114.29582000"
                    },
                    {
                        "id": 68499,
                        "name": "Bahía Tortugas",
                        "latitude": "27.69056000",
                        "longitude": "-114.89660000"
                    },
                    {
                        "id": 68704,
                        "name": "Cabo San Lucas",
                        "latitude": "22.89088000",
                        "longitude": "-109.91238000"
                    },
                    {
                        "id": 68967,
                        "name": "Chametla",
                        "latitude": "24.09926000",
                        "longitude": "-110.37395000"
                    },
                    {
                        "id": 69151,
                        "name": "Ciudad Constitución",
                        "latitude": "25.03210000",
                        "longitude": "-111.66256000"
                    },
                    {
                        "id": 69162,
                        "name": "Ciudad Insurgentes",
                        "latitude": "25.26345000",
                        "longitude": "-111.77444000"
                    },
                    {
                        "id": 69382,
                        "name": "Colonia del Sol",
                        "latitude": "22.91273000",
                        "longitude": "-109.92655000"
                    },
                    {
                        "id": 69427,
                        "name": "Comondú",
                        "latitude": "26.06667000",
                        "longitude": "-111.81666000"
                    },
                    {
                        "id": 69893,
                        "name": "El Centenario",
                        "latitude": "24.10250000",
                        "longitude": "-110.41444000"
                    },
                    {
                        "id": 70100,
                        "name": "El Pescadero",
                        "latitude": "23.36417000",
                        "longitude": "-110.16833000"
                    },
                    {
                        "id": 70206,
                        "name": "El Silencio",
                        "latitude": "27.46801000",
                        "longitude": "-113.29987000"
                    },
                    {
                        "id": 71436,
                        "name": "La Paz",
                        "latitude": "24.14437000",
                        "longitude": "-110.30050000"
                    },
                    {
                        "id": 71453,
                        "name": "La Playa",
                        "latitude": "23.06417000",
                        "longitude": "-109.66833000"
                    },
                    {
                        "id": 71479,
                        "name": "La Rivera",
                        "latitude": "23.59458000",
                        "longitude": "-109.58523000"
                    },
                    {
                        "id": 71619,
                        "name": "Las Margaritas",
                        "latitude": "27.61833000",
                        "longitude": "-113.45361000"
                    },
                    {
                        "id": 71630,
                        "name": "Las Palmas",
                        "latitude": "22.93672000",
                        "longitude": "-109.94235000"
                    },
                    {
                        "id": 71651,
                        "name": "Las Veredas",
                        "latitude": "23.15028000",
                        "longitude": "-109.70611000"
                    },
                    {
                        "id": 71762,
                        "name": "Loreto",
                        "latitude": "26.01217000",
                        "longitude": "-111.34888000"
                    },
                    {
                        "id": 71777,
                        "name": "Los Barriles",
                        "latitude": "23.68273000",
                        "longitude": "-109.69953000"
                    },
                    {
                        "id": 71781,
                        "name": "Los Cabos",
                        "latitude": "23.27663000",
                        "longitude": "-109.75322000"
                    },
                    {
                        "id": 72073,
                        "name": "Melitón Albáñez Domínguez",
                        "latitude": "23.66139000",
                        "longitude": "-110.42083000"
                    },
                    {
                        "id": 72153,
                        "name": "Miraflores",
                        "latitude": "23.36975000",
                        "longitude": "-109.77436000"
                    },
                    {
                        "id": 72251,
                        "name": "Mulegé",
                        "latitude": "26.60000000",
                        "longitude": "-112.33333000"
                    },
                    {
                        "id": 72965,
                        "name": "Puerto Adolfo Lopez Mateos",
                        "latitude": "25.19224000",
                        "longitude": "-112.11680000"
                    },
                    {
                        "id": 72974,
                        "name": "Puerto San Carlos",
                        "latitude": "24.78874000",
                        "longitude": "-112.10504000"
                    },
                    {
                        "id": 73543,
                        "name": "San Francisco",
                        "latitude": "27.64500000",
                        "longitude": "-113.41917000"
                    },
                    {
                        "id": 73834,
                        "name": "San José del Cabo",
                        "latitude": "23.05888000",
                        "longitude": "-109.69771000"
                    },
                    {
                        "id": 74855,
                        "name": "Santa Rosalía",
                        "latitude": "27.34045000",
                        "longitude": "-112.26761000"
                    },
                    {
                        "id": 75719,
                        "name": "Todos Santos",
                        "latitude": "23.44688000",
                        "longitude": "-110.22308000"
                    },
                    {
                        "id": 75988,
                        "name": "Villa Alberto Andrés Alvarado Arámburo",
                        "latitude": "27.64444000",
                        "longitude": "-113.38472000"
                    },
                    {
                        "id": 76037,
                        "name": "Villa Morelos",
                        "latitude": "24.93000000",
                        "longitude": "-111.62806000"
                    }
                ]
            },
            {
                "id": 3475,
                "name": "Campeche",
                "iso2": "CAM",
                "latitude": "19.83012510",
                "longitude": "-90.53490870",
                "type": "state",
                "cities": [
                    {
                        "id": 68019,
                        "name": "Abelardo L. Rodríguez",
                        "latitude": "18.72842000",
                        "longitude": "-90.90456000"
                    },
                    {
                        "id": 68197,
                        "name": "Alfredo V. Bonfil",
                        "latitude": "19.53032000",
                        "longitude": "-90.18214000"
                    },
                    {
                        "id": 68223,
                        "name": "Altamira de Zináparo",
                        "latitude": "18.58208000",
                        "longitude": "-90.25610000"
                    },
                    {
                        "id": 68393,
                        "name": "Atasta",
                        "latitude": "18.61954000",
                        "longitude": "-92.10326000"
                    },
                    {
                        "id": 68481,
                        "name": "Bacabchén",
                        "latitude": "20.28903000",
                        "longitude": "-90.05602000"
                    },
                    {
                        "id": 68696,
                        "name": "Bécal",
                        "latitude": "20.44172000",
                        "longitude": "-90.02738000"
                    },
                    {
                        "id": 68606,
                        "name": "Benito Juárez Uno",
                        "latitude": "18.27695000",
                        "longitude": "-91.09914000"
                    },
                    {
                        "id": 68630,
                        "name": "Bolonchén de Rejón",
                        "latitude": "20.00386000",
                        "longitude": "-89.74663000"
                    },
                    {
                        "id": 68726,
                        "name": "Calakmul",
                        "latitude": "18.00000000",
                        "longitude": "-89.75000000"
                    },
                    {
                        "id": 68741,
                        "name": "Calkiní",
                        "latitude": "20.38583000",
                        "longitude": "-89.98764000"
                    },
                    {
                        "id": 68770,
                        "name": "Campeche",
                        "latitude": "19.84386000",
                        "longitude": "-90.52554000"
                    },
                    {
                        "id": 68789,
                        "name": "Candelaria",
                        "latitude": "18.00000000",
                        "longitude": "-90.75000000"
                    },
                    {
                        "id": 68827,
                        "name": "Carmen",
                        "latitude": "18.63000000",
                        "longitude": "-91.83000000"
                    },
                    {
                        "id": 68838,
                        "name": "Carrillo Puerto",
                        "latitude": "19.09400000",
                        "longitude": "-90.52279000"
                    },
                    {
                        "id": 68858,
                        "name": "Castamay",
                        "latitude": "19.83782000",
                        "longitude": "-90.43181000"
                    },
                    {
                        "id": 68968,
                        "name": "Champotón",
                        "latitude": "19.35042000",
                        "longitude": "-90.70991000"
                    },
                    {
                        "id": 69019,
                        "name": "Chicbul",
                        "latitude": "18.77558000",
                        "longitude": "-90.92429000"
                    },
                    {
                        "id": 69087,
                        "name": "Chiná",
                        "latitude": "19.76993000",
                        "longitude": "-90.49595000"
                    },
                    {
                        "id": 69117,
                        "name": "Chunchintok",
                        "latitude": "19.36145000",
                        "longitude": "-89.58218000"
                    },
                    {
                        "id": 69195,
                        "name": "Ciudad del Carmen",
                        "latitude": "18.64592000",
                        "longitude": "-91.82991000"
                    },
                    {
                        "id": 69294,
                        "name": "Colonia Emiliano Zapata",
                        "latitude": "18.66504000",
                        "longitude": "-92.31088000"
                    },
                    {
                        "id": 69463,
                        "name": "Constitución",
                        "latitude": "18.62675000",
                        "longitude": "-90.13584000"
                    },
                    {
                        "id": 69636,
                        "name": "Cumpich",
                        "latitude": "20.18612000",
                        "longitude": "-89.97081000"
                    },
                    {
                        "id": 69689,
                        "name": "División del Norte",
                        "latitude": "18.52946000",
                        "longitude": "-90.76416000"
                    },
                    {
                        "id": 69712,
                        "name": "Don Samuel",
                        "latitude": "18.36000000",
                        "longitude": "-90.85722000"
                    },
                    {
                        "id": 69735,
                        "name": "Dzibalchén",
                        "latitude": "19.45847000",
                        "longitude": "-89.73111000"
                    },
                    {
                        "id": 69741,
                        "name": "Dzitbalché",
                        "latitude": "20.31857000",
                        "longitude": "-90.05611000"
                    },
                    {
                        "id": 69824,
                        "name": "El Aguacatal",
                        "latitude": "18.21361000",
                        "longitude": "-91.51095000"
                    },
                    {
                        "id": 70058,
                        "name": "El Naranjo",
                        "latitude": "18.02193000",
                        "longitude": "-91.12654000"
                    },
                    {
                        "id": 70324,
                        "name": "Escárcega",
                        "latitude": "18.61404000",
                        "longitude": "-90.72870000"
                    },
                    {
                        "id": 70662,
                        "name": "Hampolol",
                        "latitude": "19.92716000",
                        "longitude": "-90.38924000"
                    },
                    {
                        "id": 70663,
                        "name": "Haro",
                        "latitude": "18.44418000",
                        "longitude": "-90.79153000"
                    },
                    {
                        "id": 70664,
                        "name": "Hecelchakán",
                        "latitude": "20.16667000",
                        "longitude": "-90.13333000"
                    },
                    {
                        "id": 70707,
                        "name": "Hool",
                        "latitude": "19.51294000",
                        "longitude": "-90.44631000"
                    },
                    {
                        "id": 70708,
                        "name": "Hopelchén",
                        "latitude": "19.74671000",
                        "longitude": "-89.84437000"
                    },
                    {
                        "id": 70883,
                        "name": "Isla Aguada",
                        "latitude": "18.78714000",
                        "longitude": "-91.49277000"
                    },
                    {
                        "id": 70892,
                        "name": "Iturbide",
                        "latitude": "19.57903000",
                        "longitude": "-89.60222000"
                    },
                    {
                        "id": 71331,
                        "name": "La Joya",
                        "latitude": "19.48028000",
                        "longitude": "-90.67333000"
                    },
                    {
                        "id": 71354,
                        "name": "La Libertad",
                        "latitude": "18.57042000",
                        "longitude": "-90.51399000"
                    },
                    {
                        "id": 71663,
                        "name": "Lerma",
                        "latitude": "19.80404000",
                        "longitude": "-90.60088000"
                    },
                    {
                        "id": 71677,
                        "name": "Licenciado Gustavo Díaz Ordaz (18 de Marzo)",
                        "latitude": "18.63222000",
                        "longitude": "-91.00278000"
                    },
                    {
                        "id": 71808,
                        "name": "Los Laureles",
                        "latitude": "19.48778000",
                        "longitude": "-89.99444000"
                    },
                    {
                        "id": 71951,
                        "name": "Mamantel",
                        "latitude": "18.52512000",
                        "longitude": "-91.08885000"
                    },
                    {
                        "id": 72016,
                        "name": "Matamoros",
                        "latitude": "18.58414000",
                        "longitude": "-90.64669000"
                    },
                    {
                        "id": 72030,
                        "name": "Maya Tecún I",
                        "latitude": "19.15292000",
                        "longitude": "-90.50641000"
                    },
                    {
                        "id": 72405,
                        "name": "Nuevo Progreso",
                        "latitude": "18.62294000",
                        "longitude": "-92.29124000"
                    },
                    {
                        "id": 72426,
                        "name": "Nunkiní",
                        "latitude": "20.40046000",
                        "longitude": "-90.14803000"
                    },
                    {
                        "id": 72584,
                        "name": "Palizada",
                        "latitude": "18.25261000",
                        "longitude": "-92.07779000"
                    },
                    {
                        "id": 72759,
                        "name": "Pich",
                        "latitude": "19.48568000",
                        "longitude": "-90.11795000"
                    },
                    {
                        "id": 72830,
                        "name": "Pocboc",
                        "latitude": "20.23541000",
                        "longitude": "-90.10219000"
                    },
                    {
                        "id": 72847,
                        "name": "Pomuch",
                        "latitude": "20.13727000",
                        "longitude": "-90.17488000"
                    },
                    {
                        "id": 73190,
                        "name": "Sabancuy",
                        "latitude": "18.97270000",
                        "longitude": "-91.17783000"
                    },
                    {
                        "id": 73331,
                        "name": "San Antonio Cárdenas",
                        "latitude": "18.61399000",
                        "longitude": "-92.22341000"
                    },
                    {
                        "id": 73347,
                        "name": "San Antonio Sahcabchén",
                        "latitude": "20.30696000",
                        "longitude": "-90.13778000"
                    },
                    {
                        "id": 73573,
                        "name": "San Francisco Kobén",
                        "latitude": "19.91516000",
                        "longitude": "-90.41709000"
                    },
                    {
                        "id": 74299,
                        "name": "San Pablo Pixtún",
                        "latitude": "19.13361000",
                        "longitude": "-90.73194000"
                    },
                    {
                        "id": 74608,
                        "name": "Santa Cruz",
                        "latitude": "20.20339000",
                        "longitude": "-90.11771000"
                    },
                    {
                        "id": 74624,
                        "name": "Santa Cruz Ex-Hacienda",
                        "latitude": "20.39684000",
                        "longitude": "-90.24068000"
                    },
                    {
                        "id": 74636,
                        "name": "Santa Cruz Pueblo",
                        "latitude": "20.33359000",
                        "longitude": "-90.10342000"
                    },
                    {
                        "id": 75003,
                        "name": "Santo Domingo Kesté",
                        "latitude": "19.49972000",
                        "longitude": "-90.51139000"
                    },
                    {
                        "id": 75065,
                        "name": "Seybaplaya",
                        "latitude": "19.63994000",
                        "longitude": "-90.68706000"
                    },
                    {
                        "id": 75076,
                        "name": "Sihochac",
                        "latitude": "19.50120000",
                        "longitude": "-90.58472000"
                    },
                    {
                        "id": 75137,
                        "name": "Suc-Tuc",
                        "latitude": "19.71259000",
                        "longitude": "-90.03768000"
                    },
                    {
                        "id": 75215,
                        "name": "Tankuché",
                        "latitude": "20.50743000",
                        "longitude": "-90.24164000"
                    },
                    {
                        "id": 75345,
                        "name": "Tenabo",
                        "latitude": "19.83333000",
                        "longitude": "-90.00000000"
                    },
                    {
                        "id": 75390,
                        "name": "Tepakán",
                        "latitude": "20.39716000",
                        "longitude": "-90.04075000"
                    },
                    {
                        "id": 75563,
                        "name": "Tikinmul",
                        "latitude": "19.76611000",
                        "longitude": "-90.22306000"
                    },
                    {
                        "id": 75865,
                        "name": "Ukúm",
                        "latitude": "19.24197000",
                        "longitude": "-89.33529000"
                    },
                    {
                        "id": 76029,
                        "name": "Villa Madero",
                        "latitude": "19.52833000",
                        "longitude": "-90.69917000"
                    },
                    {
                        "id": 76130,
                        "name": "Xbacab",
                        "latitude": "18.94139000",
                        "longitude": "-90.72194000"
                    },
                    {
                        "id": 76151,
                        "name": "Xmabén",
                        "latitude": "19.23530000",
                        "longitude": "-89.31426000"
                    },
                    {
                        "id": 76204,
                        "name": "Xpujil",
                        "latitude": "18.50760000",
                        "longitude": "-89.39437000"
                    },
                    {
                        "id": 76358,
                        "name": "Zoh-Laguna",
                        "latitude": "18.59306000",
                        "longitude": "-89.41714000"
                    }
                ]
            },
            {
                "id": 3451,
                "name": "Chiapas",
                "iso2": "CHP",
                "latitude": "16.75693180",
                "longitude": "-93.12923530",
                "type": "state",
                "cities": [
                    {
                        "id": 68007,
                        "name": "1ra. Sección de Izapa",
                        "latitude": "14.92083000",
                        "longitude": "-92.17083000"
                    },
                    {
                        "id": 68008,
                        "name": "2da. Sección de Medio Monte",
                        "latitude": "14.88194000",
                        "longitude": "-92.18444000"
                    },
                    {
                        "id": 68013,
                        "name": "Abasolo",
                        "latitude": "16.82140000",
                        "longitude": "-92.21611000"
                    },
                    {
                        "id": 68024,
                        "name": "Acacoyagua",
                        "latitude": "15.41414000",
                        "longitude": "-92.68169000"
                    },
                    {
                        "id": 68029,
                        "name": "Acala",
                        "latitude": "16.55625000",
                        "longitude": "-92.80449000"
                    },
                    {
                        "id": 68036,
                        "name": "Acapetahua",
                        "latitude": "15.28189000",
                        "longitude": "-92.68987000"
                    },
                    {
                        "id": 68089,
                        "name": "Adolfo López Mateos",
                        "latitude": "17.21600000",
                        "longitude": "-93.47895000"
                    },
                    {
                        "id": 68101,
                        "name": "Agrónomos Mexicanos",
                        "latitude": "16.35000000",
                        "longitude": "-93.53000000"
                    },
                    {
                        "id": 68102,
                        "name": "Agua Azul",
                        "latitude": "16.81432000",
                        "longitude": "-91.52391000"
                    },
                    {
                        "id": 68105,
                        "name": "Agua Blanca Serranía",
                        "latitude": "17.26781000",
                        "longitude": "-91.83564000"
                    },
                    {
                        "id": 68120,
                        "name": "Agua Zarca",
                        "latitude": "15.63417000",
                        "longitude": "-92.14472000"
                    },
                    {
                        "id": 68122,
                        "name": "Aguacatenango",
                        "latitude": "16.47388000",
                        "longitude": "-92.40875000"
                    },
                    {
                        "id": 68130,
                        "name": "Agustín de Iturbide",
                        "latitude": "15.07523000",
                        "longitude": "-92.19858000"
                    },
                    {
                        "id": 68135,
                        "name": "Ahuacatlán",
                        "latitude": "15.04030000",
                        "longitude": "-92.18036000"
                    },
                    {
                        "id": 68165,
                        "name": "Ajilhó",
                        "latitude": "16.98376000",
                        "longitude": "-92.93804000"
                    },
                    {
                        "id": 68186,
                        "name": "Aldama",
                        "latitude": "16.91667000",
                        "longitude": "-92.68333000"
                    },
                    {
                        "id": 68195,
                        "name": "Alfonso Moguel",
                        "latitude": "16.66750000",
                        "longitude": "-93.50639000"
                    },
                    {
                        "id": 68224,
                        "name": "Altamirano",
                        "latitude": "16.88333000",
                        "longitude": "-92.15000000"
                    },
                    {
                        "id": 76395,
                        "name": "Álvaro Obregón",
                        "latitude": "14.92231000",
                        "longitude": "-92.37813000"
                    },
                    {
                        "id": 68234,
                        "name": "Amado Nervo",
                        "latitude": "17.23107000",
                        "longitude": "-92.24581000"
                    },
                    {
                        "id": 68247,
                        "name": "Amatán",
                        "latitude": "17.36667000",
                        "longitude": "-92.81667000"
                    },
                    {
                        "id": 68237,
                        "name": "Amatenango de la Frontera",
                        "latitude": "15.43333000",
                        "longitude": "-92.11667000"
                    },
                    {
                        "id": 68238,
                        "name": "Amatenango del Valle",
                        "latitude": "16.52722000",
                        "longitude": "-92.43472000"
                    },
                    {
                        "id": 68264,
                        "name": "América Libre",
                        "latitude": "16.61462000",
                        "longitude": "-92.99185000"
                    },
                    {
                        "id": 76404,
                        "name": "Ángel Albino Corzo",
                        "latitude": "15.86624000",
                        "longitude": "-92.72324000"
                    },
                    {
                        "id": 76405,
                        "name": "Ángel Albino Corzo (Guadalupe)",
                        "latitude": "17.12639000",
                        "longitude": "-93.27500000"
                    },
                    {
                        "id": 68295,
                        "name": "Apas",
                        "latitude": "16.71066000",
                        "longitude": "-92.79335000"
                    },
                    {
                        "id": 68320,
                        "name": "Aquiles Serdán",
                        "latitude": "14.93980000",
                        "longitude": "-92.51444000"
                    },
                    {
                        "id": 68349,
                        "name": "Arimatea",
                        "latitude": "17.34139000",
                        "longitude": "-91.87639000"
                    },
                    {
                        "id": 68355,
                        "name": "Arriaga",
                        "latitude": "16.23589000",
                        "longitude": "-93.89995000"
                    },
                    {
                        "id": 68358,
                        "name": "Arroyo Grande",
                        "latitude": "17.19122000",
                        "longitude": "-92.87207000"
                    },
                    {
                        "id": 68359,
                        "name": "Arroyo Granizo",
                        "latitude": "17.03716000",
                        "longitude": "-91.42563000"
                    },
                    {
                        "id": 68363,
                        "name": "Arroyo Palenque",
                        "latitude": "17.39167000",
                        "longitude": "-92.10444000"
                    },
                    {
                        "id": 68378,
                        "name": "Arvenza Uno",
                        "latitude": "16.77972000",
                        "longitude": "-92.72028000"
                    },
                    {
                        "id": 68445,
                        "name": "Aurora Ermita",
                        "latitude": "17.23583000",
                        "longitude": "-92.87389000"
                    },
                    {
                        "id": 68446,
                        "name": "Aurora Esquipulas",
                        "latitude": "17.11704000",
                        "longitude": "-92.47626000"
                    },
                    {
                        "id": 68474,
                        "name": "Azteca",
                        "latitude": "16.21775000",
                        "longitude": "-93.94557000"
                    },
                    {
                        "id": 68475,
                        "name": "Aztlán",
                        "latitude": "16.76919000",
                        "longitude": "-92.92316000"
                    },
                    {
                        "id": 68487,
                        "name": "Bachajón",
                        "latitude": "17.03963000",
                        "longitude": "-92.18986000"
                    },
                    {
                        "id": 68504,
                        "name": "Bajucu",
                        "latitude": "16.47520000",
                        "longitude": "-92.06471000"
                    },
                    {
                        "id": 68567,
                        "name": "Bautista Chico",
                        "latitude": "16.79972000",
                        "longitude": "-92.71194000"
                    },
                    {
                        "id": 68570,
                        "name": "Bejucal de Ocampo",
                        "latitude": "15.45535000",
                        "longitude": "-92.15835000"
                    },
                    {
                        "id": 68574,
                        "name": "Belisario Domínguez",
                        "latitude": "15.29944000",
                        "longitude": "-92.38056000"
                    },
                    {
                        "id": 68576,
                        "name": "Bella Vista",
                        "latitude": "15.58333000",
                        "longitude": "-92.21667000"
                    },
                    {
                        "id": 68585,
                        "name": "Benemérito de las Américas",
                        "latitude": "16.51599000",
                        "longitude": "-90.65371000"
                    },
                    {
                        "id": 68601,
                        "name": "Benito Juárez",
                        "latitude": "15.05500000",
                        "longitude": "-92.19111000"
                    },
                    {
                        "id": 68611,
                        "name": "Berriozábal",
                        "latitude": "16.80000000",
                        "longitude": "-93.26667000"
                    },
                    {
                        "id": 68612,
                        "name": "Betania",
                        "latitude": "16.60639000",
                        "longitude": "-92.52194000"
                    },
                    {
                        "id": 68625,
                        "name": "Bochil",
                        "latitude": "16.99625000",
                        "longitude": "-92.89218000"
                    },
                    {
                        "id": 68626,
                        "name": "Bochojbo Alto",
                        "latitude": "16.73583000",
                        "longitude": "-92.71694000"
                    },
                    {
                        "id": 68649,
                        "name": "Brisas Barra de Suchiate",
                        "latitude": "14.53588000",
                        "longitude": "-92.22414000"
                    },
                    {
                        "id": 68673,
                        "name": "Buenavista",
                        "latitude": "16.24278000",
                        "longitude": "-91.98778000"
                    },
                    {
                        "id": 68676,
                        "name": "Buenavista (Matasanos)",
                        "latitude": "17.10778000",
                        "longitude": "-93.06694000"
                    },
                    {
                        "id": 68686,
                        "name": "Buenos Aires",
                        "latitude": "14.88980000",
                        "longitude": "-92.48121000"
                    },
                    {
                        "id": 68702,
                        "name": "Cabeza de Toro",
                        "latitude": "15.93698000",
                        "longitude": "-93.78256000"
                    },
                    {
                        "id": 68705,
                        "name": "Cacahoatán",
                        "latitude": "14.99201000",
                        "longitude": "-92.16376000"
                    },
                    {
                        "id": 68715,
                        "name": "Cacaté",
                        "latitude": "16.84534000",
                        "longitude": "-92.83485000"
                    },
                    {
                        "id": 69657,
                        "name": "Cálido",
                        "latitude": "17.09889000",
                        "longitude": "-92.78750000"
                    },
                    {
                        "id": 68753,
                        "name": "Calzada Larga",
                        "latitude": "16.35115000",
                        "longitude": "-93.31518000"
                    },
                    {
                        "id": 68786,
                        "name": "Cancuc",
                        "latitude": "16.91667000",
                        "longitude": "-92.48333000"
                    },
                    {
                        "id": 68797,
                        "name": "Cantioc",
                        "latitude": "17.26222000",
                        "longitude": "-92.40694000"
                    },
                    {
                        "id": 68801,
                        "name": "Cantón las Delicias",
                        "latitude": "15.10245000",
                        "longitude": "-92.50002000"
                    },
                    {
                        "id": 68799,
                        "name": "Cantón Rancho Nuevo",
                        "latitude": "15.06742000",
                        "longitude": "-92.52565000"
                    },
                    {
                        "id": 68800,
                        "name": "Cantón Villaflor",
                        "latitude": "15.11424000",
                        "longitude": "-92.35261000"
                    },
                    {
                        "id": 68829,
                        "name": "Carmen Yalchuch",
                        "latitude": "16.64482000",
                        "longitude": "-92.36245000"
                    },
                    {
                        "id": 68830,
                        "name": "Carmen Zacatal",
                        "latitude": "17.08083000",
                        "longitude": "-92.80250000"
                    },
                    {
                        "id": 68837,
                        "name": "Carrillo Puerto",
                        "latitude": "15.01120000",
                        "longitude": "-92.19552000"
                    },
                    {
                        "id": 68856,
                        "name": "Cash",
                        "latitude": "16.26426000",
                        "longitude": "-92.09775000"
                    },
                    {
                        "id": 68862,
                        "name": "Catazajá",
                        "latitude": "17.73333000",
                        "longitude": "-92.01667000"
                    },
                    {
                        "id": 68864,
                        "name": "Catishtic",
                        "latitude": "16.78028000",
                        "longitude": "-92.73778000"
                    },
                    {
                        "id": 68884,
                        "name": "Cebadilla 1ra. Sección",
                        "latitude": "14.86381000",
                        "longitude": "-92.27969000"
                    },
                    {
                        "id": 68895,
                        "name": "Cenobio Aguilar (La Trinidad)",
                        "latitude": "17.40472000",
                        "longitude": "-92.31944000"
                    },
                    {
                        "id": 68905,
                        "name": "Cereso 14 (El Amate)",
                        "latitude": "16.59472000",
                        "longitude": "-93.80278000"
                    },
                    {
                        "id": 68946,
                        "name": "Chacaljocóm",
                        "latitude": "16.29919000",
                        "longitude": "-92.18345000"
                    },
                    {
                        "id": 68949,
                        "name": "Chacoma",
                        "latitude": "16.87611000",
                        "longitude": "-92.49139000"
                    },
                    {
                        "id": 68955,
                        "name": "Chalam",
                        "latitude": "16.88771000",
                        "longitude": "-92.55009000"
                    },
                    {
                        "id": 68960,
                        "name": "Chalchihuitán",
                        "latitude": "16.96667000",
                        "longitude": "-92.65000000"
                    },
                    {
                        "id": 68969,
                        "name": "Chamula",
                        "latitude": "16.78416000",
                        "longitude": "-92.68959000"
                    },
                    {
                        "id": 68970,
                        "name": "Chamulapita",
                        "latitude": "15.06892000",
                        "longitude": "-92.36942000"
                    },
                    {
                        "id": 68973,
                        "name": "Chanal",
                        "latitude": "16.65750000",
                        "longitude": "-92.25750000"
                    },
                    {
                        "id": 68980,
                        "name": "Chapallal Grande",
                        "latitude": "17.29631000",
                        "longitude": "-92.94519000"
                    },
                    {
                        "id": 68989,
                        "name": "Chapultenango",
                        "latitude": "17.33333000",
                        "longitude": "-93.13333000"
                    },
                    {
                        "id": 69010,
                        "name": "Chiapa de Corzo",
                        "latitude": "16.70770000",
                        "longitude": "-93.01184000"
                    },
                    {
                        "id": 69011,
                        "name": "Chiapilla",
                        "latitude": "16.55397000",
                        "longitude": "-92.72594000"
                    },
                    {
                        "id": 69034,
                        "name": "Chicoasén",
                        "latitude": "16.96528000",
                        "longitude": "-93.10472000"
                    },
                    {
                        "id": 69037,
                        "name": "Chicomuselo",
                        "latitude": "15.74420000",
                        "longitude": "-92.28330000"
                    },
                    {
                        "id": 69048,
                        "name": "Chicumtantic",
                        "latitude": "16.86556000",
                        "longitude": "-92.60528000"
                    },
                    {
                        "id": 69055,
                        "name": "Chihuahua",
                        "latitude": "16.02966000",
                        "longitude": "-91.97331000"
                    },
                    {
                        "id": 69071,
                        "name": "Chiloljá",
                        "latitude": "16.88528000",
                        "longitude": "-92.42472000"
                    },
                    {
                        "id": 69075,
                        "name": "Chilón",
                        "latitude": "17.11667000",
                        "longitude": "-92.28333000"
                    },
                    {
                        "id": 69079,
                        "name": "Chimhucum",
                        "latitude": "16.89000000",
                        "longitude": "-92.53139000"
                    },
                    {
                        "id": 69092,
                        "name": "Chiquinival",
                        "latitude": "16.99111000",
                        "longitude": "-91.96028000"
                    },
                    {
                        "id": 69093,
                        "name": "Chiquinshulum",
                        "latitude": "17.07194000",
                        "longitude": "-92.59806000"
                    },
                    {
                        "id": 69096,
                        "name": "Chixtontic",
                        "latitude": "16.89080000",
                        "longitude": "-92.45793000"
                    },
                    {
                        "id": 69113,
                        "name": "Chulum Cárdenas",
                        "latitude": "17.38417000",
                        "longitude": "-92.57389000"
                    },
                    {
                        "id": 69114,
                        "name": "Chulum Juárez",
                        "latitude": "17.33194000",
                        "longitude": "-92.53389000"
                    },
                    {
                        "id": 69136,
                        "name": "Cintalapa",
                        "latitude": "16.68778000",
                        "longitude": "-93.71083000"
                    },
                    {
                        "id": 69137,
                        "name": "Cintalapa de Figueroa",
                        "latitude": "16.68393000",
                        "longitude": "-93.71814000"
                    },
                    {
                        "id": 69153,
                        "name": "Ciudad Cuauhtémoc",
                        "latitude": "15.66587000",
                        "longitude": "-92.00388000"
                    },
                    {
                        "id": 69160,
                        "name": "Ciudad Hidalgo",
                        "latitude": "14.68148000",
                        "longitude": "-92.15217000"
                    },
                    {
                        "id": 69222,
                        "name": "Coapilla",
                        "latitude": "17.13137000",
                        "longitude": "-93.15946000"
                    },
                    {
                        "id": 69342,
                        "name": "Colonia Obrera",
                        "latitude": "15.09806000",
                        "longitude": "-92.49806000"
                    },
                    {
                        "id": 69417,
                        "name": "Comalapa",
                        "latitude": "15.65924000",
                        "longitude": "-92.14237000"
                    },
                    {
                        "id": 69425,
                        "name": "Comitán",
                        "latitude": "16.24710000",
                        "longitude": "-92.13515000"
                    },
                    {
                        "id": 69432,
                        "name": "Concepción",
                        "latitude": "16.80908000",
                        "longitude": "-92.96526000"
                    },
                    {
                        "id": 69453,
                        "name": "Congregación Reforma",
                        "latitude": "14.78208000",
                        "longitude": "-92.31424000"
                    },
                    {
                        "id": 69465,
                        "name": "Constitución",
                        "latitude": "17.07556000",
                        "longitude": "-92.52417000"
                    },
                    {
                        "id": 69469,
                        "name": "Copainalá",
                        "latitude": "17.09366000",
                        "longitude": "-93.21059000"
                    },
                    {
                        "id": 69474,
                        "name": "Copoya",
                        "latitude": "16.71191000",
                        "longitude": "-93.12089000"
                    },
                    {
                        "id": 69535,
                        "name": "Cristóbal Colón",
                        "latitude": "17.19194000",
                        "longitude": "-91.62917000"
                    },
                    {
                        "id": 69536,
                        "name": "Cristóbal Obregón",
                        "latitude": "16.43246000",
                        "longitude": "-93.45689000"
                    },
                    {
                        "id": 69548,
                        "name": "Cruztón",
                        "latitude": "16.76167000",
                        "longitude": "-92.57917000"
                    },
                    {
                        "id": 69580,
                        "name": "Cuauhtémoc",
                        "latitude": "16.55000000",
                        "longitude": "-93.71611000"
                    },
                    {
                        "id": 69606,
                        "name": "Cuchulumtic",
                        "latitude": "16.77722000",
                        "longitude": "-92.70417000"
                    },
                    {
                        "id": 69665,
                        "name": "Damasco",
                        "latitude": "17.16161000",
                        "longitude": "-91.60058000"
                    },
                    {
                        "id": 69683,
                        "name": "Diamante de Echeverría",
                        "latitude": "16.11181000",
                        "longitude": "-92.87931000"
                    },
                    {
                        "id": 69685,
                        "name": "Dieciséis de Septiembre",
                        "latitude": "16.29715000",
                        "longitude": "-93.17490000"
                    },
                    {
                        "id": 69693,
                        "name": "Doctor Belisario Domínguez (La Barra)",
                        "latitude": "15.88947000",
                        "longitude": "-93.70404000"
                    },
                    {
                        "id": 69695,
                        "name": "Doctor Domingo Chanona",
                        "latitude": "16.34611000",
                        "longitude": "-93.41667000"
                    },
                    {
                        "id": 69700,
                        "name": "Doctor Rodulfo Figueroa (Tierra Blanca)",
                        "latitude": "15.85083000",
                        "longitude": "-92.06222000"
                    },
                    {
                        "id": 69701,
                        "name": "Doctor Samuel León Brindis",
                        "latitude": "17.43528000",
                        "longitude": "-91.93194000"
                    },
                    {
                        "id": 69707,
                        "name": "Dolores Jaltenango",
                        "latitude": "15.89694000",
                        "longitude": "-92.77777000"
                    },
                    {
                        "id": 69755,
                        "name": "Efraín A. Gutiérrez",
                        "latitude": "16.34442000",
                        "longitude": "-92.19927000"
                    },
                    {
                        "id": 69756,
                        "name": "Egipto",
                        "latitude": "17.26207000",
                        "longitude": "-91.97150000"
                    },
                    {
                        "id": 70264,
                        "name": "El Águila",
                        "latitude": "15.09334000",
                        "longitude": "-92.18512000"
                    },
                    {
                        "id": 70267,
                        "name": "El Ámbar",
                        "latitude": "17.02500000",
                        "longitude": "-92.83417000"
                    },
                    {
                        "id": 70268,
                        "name": "El Ámbar (El Ámbar de Echeverría)",
                        "latitude": "16.09639000",
                        "longitude": "-92.83333000"
                    },
                    {
                        "id": 69832,
                        "name": "El Arenal",
                        "latitude": "15.17273000",
                        "longitude": "-92.69923000"
                    },
                    {
                        "id": 69848,
                        "name": "El Bosque",
                        "latitude": "17.06273000",
                        "longitude": "-92.72147000"
                    },
                    {
                        "id": 69855,
                        "name": "El Calvario",
                        "latitude": "17.21750000",
                        "longitude": "-92.55694000"
                    },
                    {
                        "id": 69870,
                        "name": "El Carmen",
                        "latitude": "15.57549000",
                        "longitude": "-93.12865000"
                    },
                    {
                        "id": 69876,
                        "name": "El Carmen (El Limón)",
                        "latitude": "17.89056000",
                        "longitude": "-93.16528000"
                    },
                    {
                        "id": 69892,
                        "name": "El Censo",
                        "latitude": "16.86287000",
                        "longitude": "-91.55988000"
                    },
                    {
                        "id": 69920,
                        "name": "El Consuelo Ulapa",
                        "latitude": "15.38662000",
                        "longitude": "-92.79228000"
                    },
                    {
                        "id": 69923,
                        "name": "El Copal",
                        "latitude": "16.96729000",
                        "longitude": "-92.92625000"
                    },
                    {
                        "id": 69924,
                        "name": "El Copalar",
                        "latitude": "16.87694000",
                        "longitude": "-93.21389000"
                    },
                    {
                        "id": 69950,
                        "name": "El Edén",
                        "latitude": "16.29191000",
                        "longitude": "-91.63755000"
                    },
                    {
                        "id": 69952,
                        "name": "El Encanto",
                        "latitude": "14.73083000",
                        "longitude": "-92.41028000"
                    },
                    {
                        "id": 69960,
                        "name": "El Espinal",
                        "latitude": "16.36862000",
                        "longitude": "-94.10449000"
                    },
                    {
                        "id": 70001,
                        "name": "El Jardín",
                        "latitude": "17.16657000",
                        "longitude": "-92.59933000"
                    },
                    {
                        "id": 70007,
                        "name": "El Jobo",
                        "latitude": "16.70369000",
                        "longitude": "-93.10569000"
                    },
                    {
                        "id": 70014,
                        "name": "El Limar",
                        "latitude": "17.41491000",
                        "longitude": "-92.40293000"
                    },
                    {
                        "id": 70015,
                        "name": "El Limonar",
                        "latitude": "16.97026000",
                        "longitude": "-91.37820000"
                    },
                    {
                        "id": 70032,
                        "name": "El Mango",
                        "latitude": "17.16236000",
                        "longitude": "-92.05985000"
                    },
                    {
                        "id": 70067,
                        "name": "El Nopal",
                        "latitude": "16.91161000",
                        "longitude": "-92.84471000"
                    },
                    {
                        "id": 70076,
                        "name": "El Pacayal",
                        "latitude": "15.59849000",
                        "longitude": "-92.04254000"
                    },
                    {
                        "id": 70081,
                        "name": "El Palmar (San Gabriel)",
                        "latitude": "16.84556000",
                        "longitude": "-93.01639000"
                    },
                    {
                        "id": 70082,
                        "name": "El Palmar Grande",
                        "latitude": "15.49858000",
                        "longitude": "-92.25518000"
                    },
                    {
                        "id": 70083,
                        "name": "El Palmarcito",
                        "latitude": "15.49728000",
                        "longitude": "-93.21387000"
                    },
                    {
                        "id": 70091,
                        "name": "El Paraíso",
                        "latitude": "17.24639000",
                        "longitude": "-92.55694000"
                    },
                    {
                        "id": 70095,
                        "name": "El Parral",
                        "latitude": "16.37035000",
                        "longitude": "-93.00567000"
                    },
                    {
                        "id": 70114,
                        "name": "El Portal",
                        "latitude": "15.67726000",
                        "longitude": "-92.09588000"
                    },
                    {
                        "id": 70118,
                        "name": "El Porvenir",
                        "latitude": "15.43092000",
                        "longitude": "-92.26447000"
                    },
                    {
                        "id": 70120,
                        "name": "El Porvenir Agrarista",
                        "latitude": "16.16465000",
                        "longitude": "-91.83575000"
                    },
                    {
                        "id": 70122,
                        "name": "El Porvenir de Velasco Suárez",
                        "latitude": "15.45695000",
                        "longitude": "-92.27987000"
                    },
                    {
                        "id": 70128,
                        "name": "El Pozo",
                        "latitude": "16.92034000",
                        "longitude": "-92.41166000"
                    },
                    {
                        "id": 70133,
                        "name": "El Progreso",
                        "latitude": "16.87694000",
                        "longitude": "-93.22222000"
                    },
                    {
                        "id": 70139,
                        "name": "El Puerto",
                        "latitude": "16.42575000",
                        "longitude": "-92.43059000"
                    },
                    {
                        "id": 70143,
                        "name": "El Ramal (Porvenir)",
                        "latitude": "15.86583000",
                        "longitude": "-92.94556000"
                    },
                    {
                        "id": 70182,
                        "name": "El Sacrificio",
                        "latitude": "14.87283000",
                        "longitude": "-92.22782000"
                    },
                    {
                        "id": 70205,
                        "name": "El Sibal",
                        "latitude": "16.98000000",
                        "longitude": "-91.49111000"
                    },
                    {
                        "id": 70235,
                        "name": "El Triunfo",
                        "latitude": "16.20200000",
                        "longitude": "-91.85916000"
                    },
                    {
                        "id": 70237,
                        "name": "El Triunfo 1ra. Sección (Cardona)",
                        "latitude": "17.60778000",
                        "longitude": "-93.23306000"
                    },
                    {
                        "id": 70238,
                        "name": "El Triunfo de las Tres Maravillas",
                        "latitude": "15.64694000",
                        "longitude": "-92.15639000"
                    },
                    {
                        "id": 70244,
                        "name": "El Tumbo",
                        "latitude": "17.07779000",
                        "longitude": "-91.62595000"
                    },
                    {
                        "id": 70246,
                        "name": "El Tzay",
                        "latitude": "16.86361000",
                        "longitude": "-92.31222000"
                    },
                    {
                        "id": 70255,
                        "name": "El Vergel",
                        "latitude": "16.57951000",
                        "longitude": "-92.08148000"
                    },
                    {
                        "id": 70260,
                        "name": "El Zapotal",
                        "latitude": "16.74991000",
                        "longitude": "-91.44192000"
                    },
                    {
                        "id": 70263,
                        "name": "El Zapotillo",
                        "latitude": "16.83700000",
                        "longitude": "-92.95152000"
                    },
                    {
                        "id": 70276,
                        "name": "Emiliano Zapata",
                        "latitude": "17.74058000",
                        "longitude": "-91.76635000"
                    },
                    {
                        "id": 70323,
                        "name": "Escuintla",
                        "latitude": "15.33333000",
                        "longitude": "-92.63333000"
                    },
                    {
                        "id": 70343,
                        "name": "Estación Huehuetán",
                        "latitude": "15.01091000",
                        "longitude": "-92.40662000"
                    },
                    {
                        "id": 70354,
                        "name": "Estación San Manuel",
                        "latitude": "17.65256000",
                        "longitude": "-93.38427000"
                    },
                    {
                        "id": 70357,
                        "name": "Estación Tuzantán",
                        "latitude": "15.10643000",
                        "longitude": "-92.45092000"
                    },
                    {
                        "id": 70373,
                        "name": "Estrella de Belén",
                        "latitude": "17.38722000",
                        "longitude": "-91.95861000"
                    },
                    {
                        "id": 70392,
                        "name": "Faja de Oro",
                        "latitude": "15.03244000",
                        "longitude": "-92.15634000"
                    },
                    {
                        "id": 70405,
                        "name": "Flor de Cacao",
                        "latitude": "16.12889000",
                        "longitude": "-90.45111000"
                    },
                    {
                        "id": 70469,
                        "name": "Francisco I. Madero",
                        "latitude": "16.87427000",
                        "longitude": "-93.21678000"
                    },
                    {
                        "id": 70473,
                        "name": "Francisco León",
                        "latitude": "17.31667000",
                        "longitude": "-93.25000000"
                    },
                    {
                        "id": 70475,
                        "name": "Francisco Sarabia",
                        "latitude": "16.94583000",
                        "longitude": "-93.01306000"
                    },
                    {
                        "id": 70480,
                        "name": "Francisco Villa",
                        "latitude": "16.21426000",
                        "longitude": "-93.33697000"
                    },
                    {
                        "id": 70492,
                        "name": "Frontera Corozal",
                        "latitude": "16.81473000",
                        "longitude": "-90.88351000"
                    },
                    {
                        "id": 70493,
                        "name": "Frontera Hidalgo",
                        "latitude": "14.77744000",
                        "longitude": "-92.17741000"
                    },
                    {
                        "id": 70501,
                        "name": "Gabriel Esquinca",
                        "latitude": "16.94056000",
                        "longitude": "-93.17555000"
                    },
                    {
                        "id": 70512,
                        "name": "Galecio Narcia",
                        "latitude": "16.58820000",
                        "longitude": "-93.02052000"
                    },
                    {
                        "id": 70571,
                        "name": "Guadalupe",
                        "latitude": "14.98033000",
                        "longitude": "-92.33938000"
                    },
                    {
                        "id": 70583,
                        "name": "Guadalupe Grijalva",
                        "latitude": "15.69899000",
                        "longitude": "-92.16414000"
                    },
                    {
                        "id": 70605,
                        "name": "Guadalupe Victoria",
                        "latitude": "16.40500000",
                        "longitude": "-92.55250000"
                    },
                    {
                        "id": 70619,
                        "name": "Guaquitepec",
                        "latitude": "16.98017000",
                        "longitude": "-92.28795000"
                    },
                    {
                        "id": 70669,
                        "name": "Hermenegildo Galeana",
                        "latitude": "16.57722000",
                        "longitude": "-93.35944000"
                    },
                    {
                        "id": 70829,
                        "name": "Héroes de Chapultepec",
                        "latitude": "16.06920000",
                        "longitude": "-92.28621000"
                    },
                    {
                        "id": 70682,
                        "name": "Hidalgo",
                        "latitude": "15.16249000",
                        "longitude": "-92.63030000"
                    },
                    {
                        "id": 70688,
                        "name": "Hidalgo Joshil",
                        "latitude": "17.22743000",
                        "longitude": "-92.34719000"
                    },
                    {
                        "id": 70762,
                        "name": "Huehuetán",
                        "latitude": "15.01981000",
                        "longitude": "-92.38249000"
                    },
                    {
                        "id": 70801,
                        "name": "Huitiupán",
                        "latitude": "17.17240000",
                        "longitude": "-92.68621000"
                    },
                    {
                        "id": 70821,
                        "name": "Huixtla",
                        "latitude": "15.13915000",
                        "longitude": "-92.46410000"
                    },
                    {
                        "id": 70822,
                        "name": "Huizachal",
                        "latitude": "16.05184000",
                        "longitude": "-93.80011000"
                    },
                    {
                        "id": 70838,
                        "name": "Ignacio Allende",
                        "latitude": "16.52556000",
                        "longitude": "-92.99222000"
                    },
                    {
                        "id": 70842,
                        "name": "Ignacio López Rayón",
                        "latitude": "14.62164000",
                        "longitude": "-92.18678000"
                    },
                    {
                        "id": 70845,
                        "name": "Ignacio Ramírez",
                        "latitude": "16.11091000",
                        "longitude": "-93.87323000"
                    },
                    {
                        "id": 70857,
                        "name": "Ignacio Zaragoza",
                        "latitude": "17.29000000",
                        "longitude": "-92.93806000"
                    },
                    {
                        "id": 70858,
                        "name": "Ignacio Zaragoza (El Morro)",
                        "latitude": "16.59944000",
                        "longitude": "-93.35083000"
                    },
                    {
                        "id": 70869,
                        "name": "Independencia",
                        "latitude": "16.08611000",
                        "longitude": "-92.83824000"
                    },
                    {
                        "id": 70916,
                        "name": "Ixhuatán",
                        "latitude": "17.29341000",
                        "longitude": "-93.00829000"
                    },
                    {
                        "id": 70923,
                        "name": "Ixtacomitán",
                        "latitude": "17.43093000",
                        "longitude": "-93.09704000"
                    },
                    {
                        "id": 70926,
                        "name": "Ixtapa",
                        "latitude": "16.80320000",
                        "longitude": "-92.90532000"
                    },
                    {
                        "id": 70933,
                        "name": "Ixtapangajoya",
                        "latitude": "17.49849000",
                        "longitude": "-93.00155000"
                    },
                    {
                        "id": 70973,
                        "name": "Jalisco",
                        "latitude": "16.43033000",
                        "longitude": "-91.97499000"
                    },
                    {
                        "id": 70983,
                        "name": "Jaltenango de la Paz",
                        "latitude": "15.87314000",
                        "longitude": "-92.72437000"
                    },
                    {
                        "id": 71006,
                        "name": "Jardínes del Grijalva",
                        "latitude": "16.72847000",
                        "longitude": "-93.03463000"
                    },
                    {
                        "id": 71019,
                        "name": "Jericó",
                        "latitude": "16.28713000",
                        "longitude": "-92.96630000"
                    },
                    {
                        "id": 71020,
                        "name": "Jerusalén",
                        "latitude": "17.36806000",
                        "longitude": "-92.06083000"
                    },
                    {
                        "id": 71033,
                        "name": "Jesús María Garza",
                        "latitude": "16.39669000",
                        "longitude": "-93.29368000"
                    },
                    {
                        "id": 71054,
                        "name": "Jiquilpan (Estación Bonanza)",
                        "latitude": "15.34194000",
                        "longitude": "-92.74750000"
                    },
                    {
                        "id": 71055,
                        "name": "Jiquipilas",
                        "latitude": "16.66806000",
                        "longitude": "-93.64667000"
                    },
                    {
                        "id": 71059,
                        "name": "Jitotol",
                        "latitude": "17.06723000",
                        "longitude": "-92.86111000"
                    },
                    {
                        "id": 71064,
                        "name": "Joaquín Miguel Gutiérrez",
                        "latitude": "16.37000000",
                        "longitude": "-93.36556000"
                    },
                    {
                        "id": 71065,
                        "name": "Joaquín Miguel Gutiérrez (Margaritas)",
                        "latitude": "15.55028000",
                        "longitude": "-93.09306000"
                    },
                    {
                        "id": 71071,
                        "name": "Joljá",
                        "latitude": "17.20459000",
                        "longitude": "-92.49946000"
                    },
                    {
                        "id": 71074,
                        "name": "Jolsibaquil",
                        "latitude": "17.25972000",
                        "longitude": "-92.48167000"
                    },
                    {
                        "id": 71075,
                        "name": "Joltealal",
                        "latitude": "17.07683000",
                        "longitude": "-92.62163000"
                    },
                    {
                        "id": 71076,
                        "name": "Jomanichim",
                        "latitude": "16.90056000",
                        "longitude": "-92.47222000"
                    },
                    {
                        "id": 71097,
                        "name": "José María Morelos",
                        "latitude": "16.04189000",
                        "longitude": "-91.83201000"
                    },
                    {
                        "id": 71105,
                        "name": "José María Morelos y Pavón",
                        "latitude": "17.24105000",
                        "longitude": "-92.70231000"
                    },
                    {
                        "id": 71108,
                        "name": "José María Pino Suárez",
                        "latitude": "16.50571000",
                        "longitude": "-93.73910000"
                    },
                    {
                        "id": 71087,
                        "name": "Joshil",
                        "latitude": "17.24667000",
                        "longitude": "-92.36278000"
                    },
                    {
                        "id": 71112,
                        "name": "Juan Aldama",
                        "latitude": "17.60939000",
                        "longitude": "-93.02826000"
                    },
                    {
                        "id": 71129,
                        "name": "Juan del Grijalva",
                        "latitude": "16.72806000",
                        "longitude": "-92.97750000"
                    },
                    {
                        "id": 71145,
                        "name": "Juárez",
                        "latitude": "17.60572000",
                        "longitude": "-93.19433000"
                    },
                    {
                        "id": 71137,
                        "name": "Julián Grajales",
                        "latitude": "16.42917000",
                        "longitude": "-93.71417000"
                    },
                    {
                        "id": 71143,
                        "name": "Justo Sierra",
                        "latitude": "16.54248000",
                        "longitude": "-92.05737000"
                    },
                    {
                        "id": 71168,
                        "name": "Kotolte",
                        "latitude": "16.86444000",
                        "longitude": "-92.46111000"
                    },
                    {
                        "id": 71195,
                        "name": "La Candelaria",
                        "latitude": "16.74289000",
                        "longitude": "-92.52156000"
                    },
                    {
                        "id": 71210,
                        "name": "La Ceiba",
                        "latitude": "17.13371000",
                        "longitude": "-92.51887000"
                    },
                    {
                        "id": 71226,
                        "name": "La Competencia",
                        "latitude": "17.23588000",
                        "longitude": "-92.75718000"
                    },
                    {
                        "id": 71242,
                        "name": "La Concordia",
                        "latitude": "16.11774000",
                        "longitude": "-92.69018000"
                    },
                    {
                        "id": 71271,
                        "name": "La Esperanza",
                        "latitude": "16.15191000",
                        "longitude": "-91.86874000"
                    },
                    {
                        "id": 71276,
                        "name": "La Esperanza (El Zapotal)",
                        "latitude": "15.44917000",
                        "longitude": "-93.16417000"
                    },
                    {
                        "id": 71292,
                        "name": "La Floresta",
                        "latitude": "16.50915000",
                        "longitude": "-92.31251000"
                    },
                    {
                        "id": 71302,
                        "name": "La Gloria",
                        "latitude": "15.96389000",
                        "longitude": "-91.96500000"
                    },
                    {
                        "id": 71307,
                        "name": "La Grandeza",
                        "latitude": "15.51033000",
                        "longitude": "-92.22603000"
                    },
                    {
                        "id": 71323,
                        "name": "La Independencia",
                        "latitude": "16.25263000",
                        "longitude": "-92.02371000"
                    },
                    {
                        "id": 71324,
                        "name": "La Independencia (Las Pilas)",
                        "latitude": "16.67750000",
                        "longitude": "-93.24944000"
                    },
                    {
                        "id": 71343,
                        "name": "La Laguna",
                        "latitude": "16.69357000",
                        "longitude": "-91.94929000"
                    },
                    {
                        "id": 71351,
                        "name": "La Libertad",
                        "latitude": "14.59167000",
                        "longitude": "-92.19315000"
                    },
                    {
                        "id": 71379,
                        "name": "La Línea",
                        "latitude": "16.13078000",
                        "longitude": "-94.03563000"
                    },
                    {
                        "id": 71434,
                        "name": "La Patria",
                        "latitude": "16.22975000",
                        "longitude": "-91.91148000"
                    },
                    {
                        "id": 71448,
                        "name": "La Pimienta",
                        "latitude": "17.14111000",
                        "longitude": "-92.76222000"
                    },
                    {
                        "id": 71477,
                        "name": "La Rinconada",
                        "latitude": "15.59333000",
                        "longitude": "-92.26806000"
                    },
                    {
                        "id": 71502,
                        "name": "La Tigrilla",
                        "latitude": "15.98769000",
                        "longitude": "-92.85220000"
                    },
                    {
                        "id": 71516,
                        "name": "La Trinitaria",
                        "latitude": "16.11859000",
                        "longitude": "-92.05201000"
                    },
                    {
                        "id": 71540,
                        "name": "Lacandón",
                        "latitude": "17.02141000",
                        "longitude": "-91.59523000"
                    },
                    {
                        "id": 71557,
                        "name": "Laguna del Cofre",
                        "latitude": "15.62751000",
                        "longitude": "-92.64143000"
                    },
                    {
                        "id": 71571,
                        "name": "Larráinzar",
                        "latitude": "16.88392000",
                        "longitude": "-92.71329000"
                    },
                    {
                        "id": 71579,
                        "name": "Las Brisas",
                        "latitude": "15.51681000",
                        "longitude": "-93.11763000"
                    },
                    {
                        "id": 71586,
                        "name": "Las Chicharras",
                        "latitude": "15.67089000",
                        "longitude": "-92.21070000"
                    },
                    {
                        "id": 71596,
                        "name": "Las Delicias",
                        "latitude": "15.96932000",
                        "longitude": "-91.86315000"
                    },
                    {
                        "id": 71599,
                        "name": "Las Flechas",
                        "latitude": "16.70028000",
                        "longitude": "-93.02639000"
                    },
                    {
                        "id": 71616,
                        "name": "Las Maravillas",
                        "latitude": "16.95951000",
                        "longitude": "-93.32012000"
                    },
                    {
                        "id": 71617,
                        "name": "Las Margaritas",
                        "latitude": "16.31265000",
                        "longitude": "-91.98107000"
                    },
                    {
                        "id": 71628,
                        "name": "Las Ollas",
                        "latitude": "16.78146000",
                        "longitude": "-92.55278000"
                    },
                    {
                        "id": 71637,
                        "name": "Las Rosas",
                        "latitude": "16.36574000",
                        "longitude": "-92.37040000"
                    },
                    {
                        "id": 71642,
                        "name": "Las Tazas",
                        "latitude": "16.75722000",
                        "longitude": "-91.61500000"
                    },
                    {
                        "id": 71888,
                        "name": "Lázaro Cárdenas",
                        "latitude": "16.60417000",
                        "longitude": "-93.79139000"
                    },
                    {
                        "id": 71896,
                        "name": "Lázaro Cárdenas (Chilil)",
                        "latitude": "16.67611000",
                        "longitude": "-92.48917000"
                    },
                    {
                        "id": 71670,
                        "name": "Libertad Melchor Ocampo",
                        "latitude": "16.37389000",
                        "longitude": "-93.47500000"
                    },
                    {
                        "id": 71671,
                        "name": "Libertad Ventanas",
                        "latitude": "15.53954000",
                        "longitude": "-92.27576000"
                    },
                    {
                        "id": 71693,
                        "name": "Llano de la Lima",
                        "latitude": "14.86596000",
                        "longitude": "-92.29714000"
                    },
                    {
                        "id": 71713,
                        "name": "Loma Bonita",
                        "latitude": "17.78697000",
                        "longitude": "-92.07651000"
                    },
                    {
                        "id": 71741,
                        "name": "Lomantán",
                        "latitude": "16.43999000",
                        "longitude": "-92.06445000"
                    },
                    {
                        "id": 71782,
                        "name": "Los Cafetales",
                        "latitude": "14.86745000",
                        "longitude": "-92.30200000"
                    },
                    {
                        "id": 71793,
                        "name": "Los Corazones",
                        "latitude": "16.21026000",
                        "longitude": "-94.07391000"
                    },
                    {
                        "id": 71819,
                        "name": "Los Naranjos",
                        "latitude": "17.26446000",
                        "longitude": "-92.61972000"
                    },
                    {
                        "id": 71827,
                        "name": "Los Palacios",
                        "latitude": "14.85718000",
                        "longitude": "-92.25821000"
                    },
                    {
                        "id": 71832,
                        "name": "Los Pinos",
                        "latitude": "16.92083000",
                        "longitude": "-92.10861000"
                    },
                    {
                        "id": 71834,
                        "name": "Los Plátanos",
                        "latitude": "17.00556000",
                        "longitude": "-92.74264000"
                    },
                    {
                        "id": 71836,
                        "name": "Los Pozos",
                        "latitude": "16.64770000",
                        "longitude": "-92.40726000"
                    },
                    {
                        "id": 71853,
                        "name": "Los Riegos",
                        "latitude": "16.30457000",
                        "longitude": "-92.12425000"
                    },
                    {
                        "id": 71880,
                        "name": "Luis Espinoza",
                        "latitude": "17.03167000",
                        "longitude": "-93.02694000"
                    },
                    {
                        "id": 71915,
                        "name": "Macvilhó",
                        "latitude": "16.85760000",
                        "longitude": "-92.69419000"
                    },
                    {
                        "id": 71942,
                        "name": "Majastic",
                        "latitude": "17.28944000",
                        "longitude": "-92.62833000"
                    },
                    {
                        "id": 71943,
                        "name": "Majomut",
                        "latitude": "16.84917000",
                        "longitude": "-92.65944000"
                    },
                    {
                        "id": 71966,
                        "name": "Manuel Ávila Camacho",
                        "latitude": "16.14647000",
                        "longitude": "-93.01701000"
                    },
                    {
                        "id": 71968,
                        "name": "Manuel Ávila Camacho (Ponte Duro)",
                        "latitude": "15.80973000",
                        "longitude": "-93.58933000"
                    },
                    {
                        "id": 71961,
                        "name": "Manuel Lazos",
                        "latitude": "14.97159000",
                        "longitude": "-92.18726000"
                    },
                    {
                        "id": 71977,
                        "name": "Mapastepec",
                        "latitude": "15.43358000",
                        "longitude": "-92.90039000"
                    },
                    {
                        "id": 71981,
                        "name": "Maravilla Tenejapa",
                        "latitude": "16.20391000",
                        "longitude": "-91.26093000"
                    },
                    {
                        "id": 71982,
                        "name": "Maravillas",
                        "latitude": "17.09693000",
                        "longitude": "-92.89107000"
                    },
                    {
                        "id": 71993,
                        "name": "Mariano Matamoros",
                        "latitude": "16.48119000",
                        "longitude": "-92.58472000"
                    },
                    {
                        "id": 71995,
                        "name": "Mariscal Subikuski",
                        "latitude": "17.33250000",
                        "longitude": "-92.38083000"
                    },
                    {
                        "id": 71998,
                        "name": "Marqués de Comillas",
                        "latitude": "16.21471000",
                        "longitude": "-90.75917000"
                    },
                    {
                        "id": 72000,
                        "name": "Marte R. Gómez",
                        "latitude": "14.92653000",
                        "longitude": "-92.44389000"
                    },
                    {
                        "id": 72023,
                        "name": "Matzam",
                        "latitude": "16.78917000",
                        "longitude": "-92.47694000"
                    },
                    {
                        "id": 72036,
                        "name": "Mazapa",
                        "latitude": "15.38773000",
                        "longitude": "-92.18780000"
                    },
                    {
                        "id": 72038,
                        "name": "Mazapa de Madero",
                        "latitude": "15.36461000",
                        "longitude": "-92.18762000"
                    },
                    {
                        "id": 72049,
                        "name": "Mazatán",
                        "latitude": "14.86319000",
                        "longitude": "-92.45030000"
                    },
                    {
                        "id": 72262,
                        "name": "Mérida",
                        "latitude": "16.56750000",
                        "longitude": "-93.81722000"
                    },
                    {
                        "id": 72087,
                        "name": "Metapa",
                        "latitude": "14.83624000",
                        "longitude": "-92.19186000"
                    },
                    {
                        "id": 72128,
                        "name": "Miguel Hidalgo",
                        "latitude": "16.35060000",
                        "longitude": "-92.62852000"
                    },
                    {
                        "id": 72135,
                        "name": "Miguel Utrilla (Los Chorros)",
                        "latitude": "16.94278000",
                        "longitude": "-92.47972000"
                    },
                    {
                        "id": 72158,
                        "name": "Misija",
                        "latitude": "17.26611000",
                        "longitude": "-92.38167000"
                    },
                    {
                        "id": 72161,
                        "name": "Mitontic",
                        "latitude": "16.87540000",
                        "longitude": "-92.57130000"
                    },
                    {
                        "id": 72163,
                        "name": "Mitzitón",
                        "latitude": "16.64639000",
                        "longitude": "-92.54333000"
                    },
                    {
                        "id": 72164,
                        "name": "Mixcum",
                        "latitude": "15.02560000",
                        "longitude": "-92.14080000"
                    },
                    {
                        "id": 72205,
                        "name": "Monte Redondo",
                        "latitude": "15.65217000",
                        "longitude": "-92.05045000"
                    },
                    {
                        "id": 72212,
                        "name": "Montecristo",
                        "latitude": "15.69263000",
                        "longitude": "-92.61999000"
                    },
                    {
                        "id": 72213,
                        "name": "Montecristo de Guerrero",
                        "latitude": "15.67526000",
                        "longitude": "-92.64399000"
                    },
                    {
                        "id": 72218,
                        "name": "Monterrey",
                        "latitude": "16.06191000",
                        "longitude": "-93.36928000"
                    },
                    {
                        "id": 72226,
                        "name": "Morelia (Victórico Rodolfo Grajales)",
                        "latitude": "16.72306000",
                        "longitude": "-91.96778000"
                    },
                    {
                        "id": 72241,
                        "name": "Motozintla",
                        "latitude": "15.36694000",
                        "longitude": "-92.24605000"
                    },
                    {
                        "id": 72246,
                        "name": "Moyos",
                        "latitude": "17.35889000",
                        "longitude": "-92.64134000"
                    },
                    {
                        "id": 72256,
                        "name": "Muquén",
                        "latitude": "16.80641000",
                        "longitude": "-92.61006000"
                    },
                    {
                        "id": 72265,
                        "name": "Nachig",
                        "latitude": "16.73056000",
                        "longitude": "-92.72528000"
                    },
                    {
                        "id": 72285,
                        "name": "Narciso Mendoza",
                        "latitude": "16.57996000",
                        "longitude": "-92.98911000"
                    },
                    {
                        "id": 72296,
                        "name": "Navenchauc",
                        "latitude": "16.73501000",
                        "longitude": "-92.77900000"
                    },
                    {
                        "id": 72323,
                        "name": "Nicolás Bravo",
                        "latitude": "16.51058000",
                        "longitude": "-92.99222000"
                    },
                    {
                        "id": 72328,
                        "name": "Nicolás Ruiz",
                        "latitude": "16.43714000",
                        "longitude": "-92.58522000"
                    },
                    {
                        "id": 72359,
                        "name": "Nueva América",
                        "latitude": "15.92281000",
                        "longitude": "-92.30587000"
                    },
                    {
                        "id": 72362,
                        "name": "Nueva Colombia",
                        "latitude": "15.69670000",
                        "longitude": "-92.72111000"
                    },
                    {
                        "id": 72364,
                        "name": "Nueva Esperanza",
                        "latitude": "17.24746000",
                        "longitude": "-92.45524000"
                    },
                    {
                        "id": 72366,
                        "name": "Nueva Independencia",
                        "latitude": "15.78259000",
                        "longitude": "-92.20883000"
                    },
                    {
                        "id": 72368,
                        "name": "Nueva Libertad",
                        "latitude": "16.09038000",
                        "longitude": "-92.80813000"
                    },
                    {
                        "id": 72369,
                        "name": "Nueva Libertad (El Colorado)",
                        "latitude": "15.89861000",
                        "longitude": "-92.05917000"
                    },
                    {
                        "id": 72370,
                        "name": "Nueva Morelia",
                        "latitude": "15.61784000",
                        "longitude": "-92.14517000"
                    },
                    {
                        "id": 72371,
                        "name": "Nueva Palestina",
                        "latitude": "16.81722000",
                        "longitude": "-91.26000000"
                    },
                    {
                        "id": 72375,
                        "name": "Nueva Sesecapa",
                        "latitude": "15.40205000",
                        "longitude": "-92.82239000"
                    },
                    {
                        "id": 72376,
                        "name": "Nueva Tenochtitlán (Rizo de Oro)",
                        "latitude": "16.47639000",
                        "longitude": "-94.08056000"
                    },
                    {
                        "id": 72378,
                        "name": "Nuevo Amatenango",
                        "latitude": "15.50852000",
                        "longitude": "-92.10958000"
                    },
                    {
                        "id": 72380,
                        "name": "Nuevo Carmen Tonapac",
                        "latitude": "16.69667000",
                        "longitude": "-92.95556000"
                    },
                    {
                        "id": 72385,
                        "name": "Nuevo Francisco León",
                        "latitude": "17.03031000",
                        "longitude": "-91.32216000"
                    },
                    {
                        "id": 72389,
                        "name": "Nuevo Juan del Grijalva",
                        "latitude": "17.42722000",
                        "longitude": "-93.37222000"
                    },
                    {
                        "id": 72391,
                        "name": "Nuevo León",
                        "latitude": "16.48629000",
                        "longitude": "-92.57140000"
                    },
                    {
                        "id": 72393,
                        "name": "Nuevo Limar",
                        "latitude": "17.45514000",
                        "longitude": "-92.39890000"
                    },
                    {
                        "id": 72398,
                        "name": "Nuevo México",
                        "latitude": "16.46944000",
                        "longitude": "-93.43806000"
                    },
                    {
                        "id": 72395,
                        "name": "Nuevo Milenio Valdivia",
                        "latitude": "15.50306000",
                        "longitude": "-92.94861000"
                    },
                    {
                        "id": 72399,
                        "name": "Nuevo Naranjo",
                        "latitude": "17.15444000",
                        "longitude": "-93.43333000"
                    },
                    {
                        "id": 72401,
                        "name": "Nuevo Nicapa",
                        "latitude": "17.63464000",
                        "longitude": "-93.07238000"
                    },
                    {
                        "id": 72402,
                        "name": "Nuevo Pacayal",
                        "latitude": "15.66010000",
                        "longitude": "-92.31538000"
                    },
                    {
                        "id": 72407,
                        "name": "Nuevo Pumpuapa (Cereso)",
                        "latitude": "14.92562000",
                        "longitude": "-92.36533000"
                    },
                    {
                        "id": 72409,
                        "name": "Nuevo San Juan Chamula",
                        "latitude": "16.14426000",
                        "longitude": "-91.44379000"
                    },
                    {
                        "id": 72413,
                        "name": "Nuevo Sitalá",
                        "latitude": "17.13936000",
                        "longitude": "-92.48287000"
                    },
                    {
                        "id": 72419,
                        "name": "Nuevo Vicente Guerrero",
                        "latitude": "16.03860000",
                        "longitude": "-92.97542000"
                    },
                    {
                        "id": 72420,
                        "name": "Nuevo Vicente Guerrero (El Chichonal)",
                        "latitude": "16.48528000",
                        "longitude": "-92.87139000"
                    },
                    {
                        "id": 72421,
                        "name": "Nuevo Volcán Chichonal",
                        "latitude": "17.77263000",
                        "longitude": "-93.10955000"
                    },
                    {
                        "id": 72423,
                        "name": "Nuevo Xochimilco",
                        "latitude": "17.45442000",
                        "longitude": "-93.36904000"
                    },
                    {
                        "id": 72447,
                        "name": "Ochusjob",
                        "latitude": "16.22482000",
                        "longitude": "-92.25201000"
                    },
                    {
                        "id": 72448,
                        "name": "Ococh",
                        "latitude": "16.83806000",
                        "longitude": "-92.47528000"
                    },
                    {
                        "id": 72450,
                        "name": "Ocosingo",
                        "latitude": "16.90639000",
                        "longitude": "-92.09374000"
                    },
                    {
                        "id": 72452,
                        "name": "Ocotepec",
                        "latitude": "17.22620000",
                        "longitude": "-93.16440000"
                    },
                    {
                        "id": 72464,
                        "name": "Ocozocoautla de Espinosa",
                        "latitude": "16.76231000",
                        "longitude": "-93.37476000"
                    },
                    {
                        "id": 72467,
                        "name": "Octavio Paz",
                        "latitude": "14.85778000",
                        "longitude": "-92.26389000"
                    },
                    {
                        "id": 72484,
                        "name": "Ojo de Agua",
                        "latitude": "16.15773000",
                        "longitude": "-91.75794000"
                    },
                    {
                        "id": 72508,
                        "name": "Omoa",
                        "latitude": "14.83292000",
                        "longitude": "-92.23279000"
                    },
                    {
                        "id": 72510,
                        "name": "Once de Abril",
                        "latitude": "15.05199000",
                        "longitude": "-92.14224000"
                    },
                    {
                        "id": 72534,
                        "name": "Ostuacán",
                        "latitude": "17.40664000",
                        "longitude": "-93.33643000"
                    },
                    {
                        "id": 72535,
                        "name": "Osumacinta",
                        "latitude": "16.93611000",
                        "longitude": "-93.09028000"
                    },
                    {
                        "id": 72546,
                        "name": "Oxchuc",
                        "latitude": "16.78588000",
                        "longitude": "-92.34455000"
                    },
                    {
                        "id": 72550,
                        "name": "Oxinam",
                        "latitude": "16.86306000",
                        "longitude": "-92.54917000"
                    },
                    {
                        "id": 72564,
                        "name": "Pablo L. Sidar",
                        "latitude": "15.83053000",
                        "longitude": "-92.27977000"
                    },
                    {
                        "id": 72571,
                        "name": "Pacú",
                        "latitude": "16.63584000",
                        "longitude": "-93.13437000"
                    },
                    {
                        "id": 72582,
                        "name": "Palenque",
                        "latitude": "17.50953000",
                        "longitude": "-91.98248000"
                    },
                    {
                        "id": 72625,
                        "name": "Pantelhó",
                        "latitude": "17.00563000",
                        "longitude": "-92.47165000"
                    },
                    {
                        "id": 72626,
                        "name": "Pantepec",
                        "latitude": "17.18842000",
                        "longitude": "-93.04998000"
                    },
                    {
                        "id": 72650,
                        "name": "Paraíso del Grijalva",
                        "latitude": "16.22576000",
                        "longitude": "-92.64318000"
                    },
                    {
                        "id": 72653,
                        "name": "Paredón",
                        "latitude": "16.05083000",
                        "longitude": "-93.86667000"
                    },
                    {
                        "id": 72680,
                        "name": "Paso Hondo",
                        "latitude": "15.68390000",
                        "longitude": "-92.01860000"
                    },
                    {
                        "id": 72704,
                        "name": "Pasté",
                        "latitude": "16.70420000",
                        "longitude": "-92.74111000"
                    },
                    {
                        "id": 72709,
                        "name": "Patosil",
                        "latitude": "16.75210000",
                        "longitude": "-92.74133000"
                    },
                    {
                        "id": 72712,
                        "name": "Patria Nueva (San José el Contento)",
                        "latitude": "16.92778000",
                        "longitude": "-92.11361000"
                    },
                    {
                        "id": 72714,
                        "name": "Pavencul",
                        "latitude": "15.20249000",
                        "longitude": "-92.17993000"
                    },
                    {
                        "id": 72736,
                        "name": "Perla de Acapulco",
                        "latitude": "16.79570000",
                        "longitude": "-91.47793000"
                    },
                    {
                        "id": 72742,
                        "name": "Petalcingo",
                        "latitude": "17.22715000",
                        "longitude": "-92.41511000"
                    },
                    {
                        "id": 72761,
                        "name": "Pichucalco",
                        "latitude": "17.51000000",
                        "longitude": "-93.11591000"
                    },
                    {
                        "id": 72766,
                        "name": "Piedra Labrada",
                        "latitude": "15.68226000",
                        "longitude": "-92.30538000"
                    },
                    {
                        "id": 72774,
                        "name": "Pijijiapan",
                        "latitude": "15.68618000",
                        "longitude": "-93.20938000"
                    },
                    {
                        "id": 72795,
                        "name": "Plan de Agua Prieta",
                        "latitude": "16.13111000",
                        "longitude": "-92.79139000"
                    },
                    {
                        "id": 72798,
                        "name": "Plan de Ayala",
                        "latitude": "16.47152000",
                        "longitude": "-92.02735000"
                    },
                    {
                        "id": 72846,
                        "name": "Pomposo Castellanos",
                        "latitude": "16.59033000",
                        "longitude": "-93.86688000"
                    },
                    {
                        "id": 72861,
                        "name": "Potrerillo",
                        "latitude": "15.63096000",
                        "longitude": "-92.02059000"
                    },
                    {
                        "id": 72891,
                        "name": "Presidente Echeverría (Laja Tendida)",
                        "latitude": "16.33583000",
                        "longitude": "-92.66861000"
                    },
                    {
                        "id": 72895,
                        "name": "Primer Cantón",
                        "latitude": "15.12056000",
                        "longitude": "-92.44000000"
                    },
                    {
                        "id": 72907,
                        "name": "Profresor Roberto Barrios",
                        "latitude": "17.32583000",
                        "longitude": "-91.92639000"
                    },
                    {
                        "id": 72927,
                        "name": "Puebla",
                        "latitude": "16.91583000",
                        "longitude": "-92.50389000"
                    },
                    {
                        "id": 72938,
                        "name": "Pueblo Nuevo",
                        "latitude": "17.16027000",
                        "longitude": "-92.89977000"
                    },
                    {
                        "id": 72971,
                        "name": "Puerto Madero",
                        "latitude": "14.72076000",
                        "longitude": "-92.42146000"
                    },
                    {
                        "id": 72983,
                        "name": "Pugchén Mumuntic",
                        "latitude": "16.86389000",
                        "longitude": "-92.82361000"
                    },
                    {
                        "id": 72986,
                        "name": "Punta Arena",
                        "latitude": "17.74601000",
                        "longitude": "-92.05871000"
                    },
                    {
                        "id": 73024,
                        "name": "Querétaro",
                        "latitude": "15.83752000",
                        "longitude": "-92.75774000"
                    },
                    {
                        "id": 73036,
                        "name": "Quintana Roo",
                        "latitude": "16.60667000",
                        "longitude": "-93.56194000"
                    },
                    {
                        "id": 73046,
                        "name": "Rafael Pascacio Gamboa",
                        "latitude": "17.91818000",
                        "longitude": "-93.26833000"
                    },
                    {
                        "id": 73047,
                        "name": "Rafael Ramírez",
                        "latitude": "16.46199000",
                        "longitude": "-91.94523000"
                    },
                    {
                        "id": 73052,
                        "name": "Ramón F. Balboa",
                        "latitude": "16.47427000",
                        "longitude": "-91.40318000"
                    },
                    {
                        "id": 73082,
                        "name": "Raudales Malpaso",
                        "latitude": "17.18833000",
                        "longitude": "-93.60583000"
                    },
                    {
                        "id": 73084,
                        "name": "Raymundo Enríquez",
                        "latitude": "14.86722000",
                        "longitude": "-92.31466000"
                    },
                    {
                        "id": 73087,
                        "name": "Rayón",
                        "latitude": "17.20137000",
                        "longitude": "-93.01110000"
                    },
                    {
                        "id": 73094,
                        "name": "Reforma",
                        "latitude": "17.86876000",
                        "longitude": "-93.22673000"
                    },
                    {
                        "id": 73096,
                        "name": "Reforma y Planada",
                        "latitude": "17.38694000",
                        "longitude": "-92.86583000"
                    },
                    {
                        "id": 73100,
                        "name": "Revolución Mexicana",
                        "latitude": "16.17156000",
                        "longitude": "-93.07666000"
                    },
                    {
                        "id": 73106,
                        "name": "Ricardo Flores Magón",
                        "latitude": "16.39397000",
                        "longitude": "-92.69618000"
                    },
                    {
                        "id": 73118,
                        "name": "Rincón Chamula",
                        "latitude": "17.20718000",
                        "longitude": "-92.93912000"
                    },
                    {
                        "id": 73168,
                        "name": "Río Blanco",
                        "latitude": "16.20501000",
                        "longitude": "-91.63429000"
                    },
                    {
                        "id": 73171,
                        "name": "Río Chancalá",
                        "latitude": "17.33454000",
                        "longitude": "-91.68430000"
                    },
                    {
                        "id": 73178,
                        "name": "Río Jordán",
                        "latitude": "17.24611000",
                        "longitude": "-91.93306000"
                    },
                    {
                        "id": 73143,
                        "name": "Rizo de Oro",
                        "latitude": "15.97088000",
                        "longitude": "-92.48316000"
                    },
                    {
                        "id": 73145,
                        "name": "Roblada Grande",
                        "latitude": "16.48909000",
                        "longitude": "-93.19499000"
                    },
                    {
                        "id": 73151,
                        "name": "Rodulfo Figueroa",
                        "latitude": "15.92006000",
                        "longitude": "-91.90370000"
                    },
                    {
                        "id": 73153,
                        "name": "Romerillo",
                        "latitude": "16.76528000",
                        "longitude": "-92.56750000"
                    },
                    {
                        "id": 73192,
                        "name": "Sabanilla",
                        "latitude": "17.30308000",
                        "longitude": "-92.58368000"
                    },
                    {
                        "id": 73195,
                        "name": "Sabinalito",
                        "latitude": "15.70186000",
                        "longitude": "-91.98636000"
                    },
                    {
                        "id": 73198,
                        "name": "Saclamantón",
                        "latitude": "16.78833000",
                        "longitude": "-92.63500000"
                    },
                    {
                        "id": 73225,
                        "name": "Saltillo",
                        "latitude": "16.39359000",
                        "longitude": "-91.94890000"
                    },
                    {
                        "id": 73227,
                        "name": "Salto de Agua",
                        "latitude": "17.55435000",
                        "longitude": "-92.33941000"
                    },
                    {
                        "id": 73230,
                        "name": "Salvador Urbina",
                        "latitude": "15.03535000",
                        "longitude": "-92.20805000"
                    },
                    {
                        "id": 73278,
                        "name": "San Andrés Duraznal",
                        "latitude": "17.15653000",
                        "longitude": "-92.79606000"
                    },
                    {
                        "id": 73325,
                        "name": "San Antonio Buenavista",
                        "latitude": "16.15234000",
                        "longitude": "-91.65020000"
                    },
                    {
                        "id": 73326,
                        "name": "San Antonio Bulujib",
                        "latitude": "16.99667000",
                        "longitude": "-92.29667000"
                    },
                    {
                        "id": 73380,
                        "name": "San Antonio del Monte",
                        "latitude": "16.76028000",
                        "longitude": "-92.65306000"
                    },
                    {
                        "id": 73455,
                        "name": "San Caralampio",
                        "latitude": "15.82935000",
                        "longitude": "-92.03555000"
                    },
                    {
                        "id": 73466,
                        "name": "San Cayetano",
                        "latitude": "16.96119000",
                        "longitude": "-92.76016000"
                    },
                    {
                        "id": 73483,
                        "name": "San Cristóbal de las Casas",
                        "latitude": "16.73176000",
                        "longitude": "-92.64126000"
                    },
                    {
                        "id": 73526,
                        "name": "San Felipe Tizapa",
                        "latitude": "15.27616000",
                        "longitude": "-92.61300000"
                    },
                    {
                        "id": 73535,
                        "name": "San Fernando",
                        "latitude": "16.87153000",
                        "longitude": "-93.20759000"
                    },
                    {
                        "id": 73547,
                        "name": "San Francisco (El Calvito)",
                        "latitude": "16.32167000",
                        "longitude": "-92.56194000"
                    },
                    {
                        "id": 73569,
                        "name": "San Francisco Jaconá",
                        "latitude": "17.26278000",
                        "longitude": "-93.03250000"
                    },
                    {
                        "id": 73588,
                        "name": "San Francisco Pujiltic",
                        "latitude": "16.27922000",
                        "longitude": "-92.45319000"
                    },
                    {
                        "id": 73665,
                        "name": "San Isidro",
                        "latitude": "15.74373000",
                        "longitude": "-93.35276000"
                    },
                    {
                        "id": 73691,
                        "name": "San Isidro las Banderas",
                        "latitude": "17.23028000",
                        "longitude": "-93.06028000"
                    },
                    {
                        "id": 73720,
                        "name": "San Jerónimo Tulijá",
                        "latitude": "17.22361000",
                        "longitude": "-91.78972000"
                    },
                    {
                        "id": 73756,
                        "name": "San José Chapayal",
                        "latitude": "17.30056000",
                        "longitude": "-92.89028000"
                    },
                    {
                        "id": 73855,
                        "name": "San José las Chicharras",
                        "latitude": "15.64363000",
                        "longitude": "-92.20659000"
                    },
                    {
                        "id": 73803,
                        "name": "San José Yashitinín",
                        "latitude": "16.65472000",
                        "longitude": "-92.44500000"
                    },
                    {
                        "id": 73804,
                        "name": "San José Yocnajab",
                        "latitude": "16.25383000",
                        "longitude": "-92.08698000"
                    },
                    {
                        "id": 74021,
                        "name": "San Lucas",
                        "latitude": "16.61167000",
                        "longitude": "-92.71806000"
                    },
                    {
                        "id": 74061,
                        "name": "San Luqueño",
                        "latitude": "16.01278000",
                        "longitude": "-93.84583000"
                    },
                    {
                        "id": 74150,
                        "name": "San Miguel",
                        "latitude": "17.36324000",
                        "longitude": "-92.00762000"
                    },
                    {
                        "id": 74242,
                        "name": "San Miguel la Sardina",
                        "latitude": "17.29417000",
                        "longitude": "-93.35250000"
                    },
                    {
                        "id": 74290,
                        "name": "San Pablo Huacano",
                        "latitude": "17.19583000",
                        "longitude": "-93.20750000"
                    },
                    {
                        "id": 74321,
                        "name": "San Pedro Buenavista",
                        "latitude": "16.08333000",
                        "longitude": "-93.11667000"
                    },
                    {
                        "id": 74362,
                        "name": "San Pedro Nichtalucum",
                        "latitude": "17.03444000",
                        "longitude": "-92.72694000"
                    },
                    {
                        "id": 74420,
                        "name": "San Quintín",
                        "latitude": "16.40672000",
                        "longitude": "-91.34575000"
                    },
                    {
                        "id": 74510,
                        "name": "San Vicente la Mesilla",
                        "latitude": "16.17861000",
                        "longitude": "-92.29333000"
                    },
                    {
                        "id": 74653,
                        "name": "Santa Elena",
                        "latitude": "16.89267000",
                        "longitude": "-91.58987000"
                    },
                    {
                        "id": 74704,
                        "name": "Santa María",
                        "latitude": "17.35230000",
                        "longitude": "-92.07679000"
                    },
                    {
                        "id": 74829,
                        "name": "Santa Rita",
                        "latitude": "16.13167000",
                        "longitude": "-91.97500000"
                    },
                    {
                        "id": 74989,
                        "name": "Santiago el Pinar",
                        "latitude": "16.94838000",
                        "longitude": "-92.72074000"
                    },
                    {
                        "id": 74936,
                        "name": "Santiago Pojcol",
                        "latitude": "16.99148000",
                        "longitude": "-91.98071000"
                    },
                    {
                        "id": 74993,
                        "name": "Santo Domingo",
                        "latitude": "15.03067000",
                        "longitude": "-92.10361000"
                    },
                    {
                        "id": 75019,
                        "name": "Santo Domingo de las Palmas",
                        "latitude": "16.13667000",
                        "longitude": "-91.32194000"
                    },
                    {
                        "id": 75068,
                        "name": "Señor del Pozo",
                        "latitude": "16.29625000",
                        "longitude": "-92.11165000"
                    },
                    {
                        "id": 75069,
                        "name": "Shoctic",
                        "latitude": "17.22361000",
                        "longitude": "-92.48806000"
                    },
                    {
                        "id": 75070,
                        "name": "Sibacá",
                        "latitude": "16.93093000",
                        "longitude": "-92.14006000"
                    },
                    {
                        "id": 75071,
                        "name": "Sibaniljá Pocolum",
                        "latitude": "16.87639000",
                        "longitude": "-92.46111000"
                    },
                    {
                        "id": 75081,
                        "name": "Siltepec",
                        "latitude": "15.55717000",
                        "longitude": "-92.32314000"
                    },
                    {
                        "id": 75084,
                        "name": "Simojovel",
                        "latitude": "17.14736000",
                        "longitude": "-92.67154000"
                    },
                    {
                        "id": 75085,
                        "name": "Simojovel de Allende",
                        "latitude": "17.14036000",
                        "longitude": "-92.71394000"
                    },
                    {
                        "id": 75089,
                        "name": "Sinaloa",
                        "latitude": "15.89261000",
                        "longitude": "-92.12896000"
                    },
                    {
                        "id": 75099,
                        "name": "Sitalá",
                        "latitude": "17.02417000",
                        "longitude": "-92.30694000"
                    },
                    {
                        "id": 75107,
                        "name": "Socoltenango",
                        "latitude": "16.17412000",
                        "longitude": "-92.36658000"
                    },
                    {
                        "id": 75109,
                        "name": "Soconusco",
                        "latitude": "15.31502000",
                        "longitude": "-92.72645000"
                    },
                    {
                        "id": 75119,
                        "name": "Solosuchiapa",
                        "latitude": "17.39364000",
                        "longitude": "-93.01301000"
                    },
                    {
                        "id": 75129,
                        "name": "Soyaló",
                        "latitude": "16.91352000",
                        "longitude": "-92.96579000"
                    },
                    {
                        "id": 75133,
                        "name": "Soyatitán",
                        "latitude": "16.29427000",
                        "longitude": "-92.42402000"
                    },
                    {
                        "id": 75138,
                        "name": "Suchiapa",
                        "latitude": "16.60775000",
                        "longitude": "-93.10003000"
                    },
                    {
                        "id": 75139,
                        "name": "Suchiate",
                        "latitude": "14.64138000",
                        "longitude": "-92.22252000"
                    },
                    {
                        "id": 75161,
                        "name": "Tacuba Nueva",
                        "latitude": "17.09028000",
                        "longitude": "-92.37028000"
                    },
                    {
                        "id": 75172,
                        "name": "Talismán",
                        "latitude": "14.96333000",
                        "longitude": "-92.14722000"
                    },
                    {
                        "id": 75176,
                        "name": "Tamaulipas",
                        "latitude": "15.77189000",
                        "longitude": "-93.40718000"
                    },
                    {
                        "id": 75214,
                        "name": "Taniperla",
                        "latitude": "16.82222000",
                        "longitude": "-91.52333000"
                    },
                    {
                        "id": 75221,
                        "name": "Tapachula",
                        "latitude": "14.90385000",
                        "longitude": "-92.25749000"
                    },
                    {
                        "id": 75222,
                        "name": "Tapalapa",
                        "latitude": "17.22618000",
                        "longitude": "-93.11552000"
                    },
                    {
                        "id": 75227,
                        "name": "Tapilula",
                        "latitude": "17.25355000",
                        "longitude": "-93.00933000"
                    },
                    {
                        "id": 75288,
                        "name": "Tecpatán",
                        "latitude": "17.13676000",
                        "longitude": "-93.31133000"
                    },
                    {
                        "id": 75352,
                        "name": "Tenango",
                        "latitude": "16.96667000",
                        "longitude": "-92.41667000"
                    },
                    {
                        "id": 75371,
                        "name": "Tentic",
                        "latitude": "16.86333000",
                        "longitude": "-92.68222000"
                    },
                    {
                        "id": 75381,
                        "name": "Teopisca",
                        "latitude": "16.54182000",
                        "longitude": "-92.47405000"
                    },
                    {
                        "id": 75506,
                        "name": "Texcaltic",
                        "latitude": "14.79550000",
                        "longitude": "-92.18737000"
                    },
                    {
                        "id": 75556,
                        "name": "Tierra y Libertad",
                        "latitude": "16.37889000",
                        "longitude": "-93.86056000"
                    },
                    {
                        "id": 75565,
                        "name": "Tila",
                        "latitude": "17.30054000",
                        "longitude": "-92.42730000"
                    },
                    {
                        "id": 75569,
                        "name": "Tiltepec",
                        "latitude": "16.39389000",
                        "longitude": "-93.86972000"
                    },
                    {
                        "id": 75574,
                        "name": "Tinajas 1ra. Sección",
                        "latitude": "14.71750000",
                        "longitude": "-92.32861000"
                    },
                    {
                        "id": 75715,
                        "name": "Tocob Leglemal",
                        "latitude": "17.23389000",
                        "longitude": "-92.37833000"
                    },
                    {
                        "id": 75738,
                        "name": "Tonalá",
                        "latitude": "16.08977000",
                        "longitude": "-93.75489000"
                    },
                    {
                        "id": 75750,
                        "name": "Totolapa",
                        "latitude": "16.54357000",
                        "longitude": "-92.68019000"
                    },
                    {
                        "id": 75771,
                        "name": "Tres Cerros",
                        "latitude": "16.91556000",
                        "longitude": "-92.47278000"
                    },
                    {
                        "id": 75777,
                        "name": "Tres Picos",
                        "latitude": "15.88209000",
                        "longitude": "-93.52867000"
                    },
                    {
                        "id": 75805,
                        "name": "Tumbala",
                        "latitude": "17.27746000",
                        "longitude": "-92.31700000"
                    },
                    {
                        "id": 75825,
                        "name": "Tuxtla",
                        "latitude": "16.75973000",
                        "longitude": "-93.11308000"
                    },
                    {
                        "id": 75827,
                        "name": "Tuxtla Chico",
                        "latitude": "14.93945000",
                        "longitude": "-92.16730000"
                    },
                    {
                        "id": 75831,
                        "name": "Tuzantán",
                        "latitude": "15.14711000",
                        "longitude": "-92.42237000"
                    },
                    {
                        "id": 75833,
                        "name": "Tz'Aquiviljok",
                        "latitude": "16.85528000",
                        "longitude": "-92.45972000"
                    },
                    {
                        "id": 75835,
                        "name": "Tzajalá",
                        "latitude": "17.13559000",
                        "longitude": "-92.39328000"
                    },
                    {
                        "id": 75834,
                        "name": "Tzajalchén",
                        "latitude": "16.84165000",
                        "longitude": "-92.46014000"
                    },
                    {
                        "id": 75836,
                        "name": "Tzeltal",
                        "latitude": "16.93944000",
                        "longitude": "-92.47778000"
                    },
                    {
                        "id": 75840,
                        "name": "Tzimol",
                        "latitude": "16.18356000",
                        "longitude": "-92.18934000"
                    },
                    {
                        "id": 75842,
                        "name": "Tzinil",
                        "latitude": "16.25778000",
                        "longitude": "-92.32222000"
                    },
                    {
                        "id": 75848,
                        "name": "Tziscao",
                        "latitude": "16.08155000",
                        "longitude": "-91.66641000"
                    },
                    {
                        "id": 75850,
                        "name": "Tzoeptic",
                        "latitude": "16.88278000",
                        "longitude": "-92.56806000"
                    },
                    {
                        "id": 75852,
                        "name": "Tzontehuitz",
                        "latitude": "16.83314000",
                        "longitude": "-92.57965000"
                    },
                    {
                        "id": 75853,
                        "name": "Tzopilja",
                        "latitude": "16.73972000",
                        "longitude": "-92.30917000"
                    },
                    {
                        "id": 75860,
                        "name": "Ubilio García",
                        "latitude": "17.08405000",
                        "longitude": "-91.47241000"
                    },
                    {
                        "id": 75881,
                        "name": "Unión Buena Vista",
                        "latitude": "16.48582000",
                        "longitude": "-92.81823000"
                    },
                    {
                        "id": 75882,
                        "name": "Unión Buenavista",
                        "latitude": "15.79527000",
                        "longitude": "-92.54417000"
                    },
                    {
                        "id": 75885,
                        "name": "Unión Juárez",
                        "latitude": "17.28083000",
                        "longitude": "-92.39972000"
                    },
                    {
                        "id": 75886,
                        "name": "Unión Roja",
                        "latitude": "15.04658000",
                        "longitude": "-92.21653000"
                    },
                    {
                        "id": 75901,
                        "name": "Usipa",
                        "latitude": "17.50028000",
                        "longitude": "-92.43806000"
                    },
                    {
                        "id": 75940,
                        "name": "Vega del Rosario",
                        "latitude": "15.52083000",
                        "longitude": "-92.30720000"
                    },
                    {
                        "id": 75943,
                        "name": "Veinte de Noviembre",
                        "latitude": "14.97730000",
                        "longitude": "-92.26509000"
                    },
                    {
                        "id": 75963,
                        "name": "Venustiano Carranza",
                        "latitude": "16.32314000",
                        "longitude": "-92.55844000"
                    },
                    {
                        "id": 75966,
                        "name": "Veracruz",
                        "latitude": "16.40417000",
                        "longitude": "-91.99944000"
                    },
                    {
                        "id": 75967,
                        "name": "Verapaz",
                        "latitude": "15.71166000",
                        "longitude": "-92.06199000"
                    },
                    {
                        "id": 75973,
                        "name": "Vicente Guerrero",
                        "latitude": "16.66028000",
                        "longitude": "-93.58306000"
                    },
                    {
                        "id": 75986,
                        "name": "Vida Mejor I",
                        "latitude": "14.86972000",
                        "longitude": "-92.30778000"
                    },
                    {
                        "id": 75995,
                        "name": "Villa Comaltitlán",
                        "latitude": "15.18645000",
                        "longitude": "-92.59053000"
                    },
                    {
                        "id": 75996,
                        "name": "Villa Corzo",
                        "latitude": "16.18510000",
                        "longitude": "-93.26881000"
                    },
                    {
                        "id": 76010,
                        "name": "Villa Hidalgo",
                        "latitude": "16.30457000",
                        "longitude": "-93.15466000"
                    },
                    {
                        "id": 76077,
                        "name": "Villaflores",
                        "latitude": "16.34149000",
                        "longitude": "-93.33191000"
                    },
                    {
                        "id": 76081,
                        "name": "Villahermosa Yaluma",
                        "latitude": "16.33366000",
                        "longitude": "-92.07771000"
                    },
                    {
                        "id": 76084,
                        "name": "Villamorelos",
                        "latitude": "16.48000000",
                        "longitude": "-93.92778000"
                    },
                    {
                        "id": 76100,
                        "name": "Viva Cárdenas",
                        "latitude": "16.83570000",
                        "longitude": "-93.19333000"
                    },
                    {
                        "id": 76101,
                        "name": "Viva México",
                        "latitude": "14.91008000",
                        "longitude": "-92.32609000"
                    },
                    {
                        "id": 76163,
                        "name": "Xochiltepec",
                        "latitude": "15.12780000",
                        "longitude": "-92.43388000"
                    },
                    {
                        "id": 76211,
                        "name": "Yajalón",
                        "latitude": "17.18519000",
                        "longitude": "-92.32715000"
                    },
                    {
                        "id": 76214,
                        "name": "Yaltem",
                        "latitude": "16.84402000",
                        "longitude": "-92.79057000"
                    },
                    {
                        "id": 76217,
                        "name": "Yasha",
                        "latitude": "16.39141000",
                        "longitude": "-92.06878000"
                    },
                    {
                        "id": 76218,
                        "name": "Yashanal",
                        "latitude": "16.82889000",
                        "longitude": "-92.45194000"
                    },
                    {
                        "id": 76238,
                        "name": "Yibeljoj",
                        "latitude": "16.95750000",
                        "longitude": "-92.50361000"
                    },
                    {
                        "id": 76244,
                        "name": "Yoshib",
                        "latitude": "16.84528000",
                        "longitude": "-92.44611000"
                    },
                    {
                        "id": 76278,
                        "name": "Zacatonal de Juárez",
                        "latitude": "17.27097000",
                        "longitude": "-92.79936000"
                    },
                    {
                        "id": 76282,
                        "name": "Zacualpa",
                        "latitude": "15.16820000",
                        "longitude": "-92.62705000"
                    },
                    {
                        "id": 76295,
                        "name": "Zamora Pico de Oro",
                        "latitude": "16.33205000",
                        "longitude": "-90.76560000"
                    },
                    {
                        "id": 76317,
                        "name": "Zaragoza",
                        "latitude": "17.00906000",
                        "longitude": "-91.64033000"
                    },
                    {
                        "id": 76323,
                        "name": "Zaragoza la Montaña",
                        "latitude": "16.41653000",
                        "longitude": "-92.20512000"
                    },
                    {
                        "id": 76331,
                        "name": "Zequentic",
                        "latitude": "16.71694000",
                        "longitude": "-92.82667000"
                    },
                    {
                        "id": 76340,
                        "name": "Zinacantán",
                        "latitude": "16.76020000",
                        "longitude": "-92.72257000"
                    }
                ]
            },
            {
                "id": 3447,
                "name": "Chihuahua",
                "iso2": "CHH",
                "latitude": "28.63299570",
                "longitude": "-106.06910040",
                "type": "state",
                "cities": [
                    {
                        "id": 68018,
                        "name": "Abdenago C. García",
                        "latitude": "29.98937000",
                        "longitude": "-107.55210000"
                    },
                    {
                        "id": 68091,
                        "name": "Adolfo López Mateos",
                        "latitude": "28.46667000",
                        "longitude": "-107.30000000"
                    },
                    {
                        "id": 68162,
                        "name": "Ahumada",
                        "latitude": "30.48174000",
                        "longitude": "-106.48832000"
                    },
                    {
                        "id": 68187,
                        "name": "Aldama",
                        "latitude": "28.93636000",
                        "longitude": "-105.71098000"
                    },
                    {
                        "id": 68208,
                        "name": "Allende",
                        "latitude": "27.07787000",
                        "longitude": "-105.28789000"
                    },
                    {
                        "id": 68259,
                        "name": "Ampliación Colonia Lázaro Cárdenas",
                        "latitude": "28.38333000",
                        "longitude": "-105.61667000"
                    },
                    {
                        "id": 68286,
                        "name": "Anáhuac",
                        "latitude": "28.48396000",
                        "longitude": "-106.74720000"
                    },
                    {
                        "id": 68323,
                        "name": "Aquiles Serdán",
                        "latitude": "28.58454000",
                        "longitude": "-105.88108000"
                    },
                    {
                        "id": 68379,
                        "name": "Ascensión",
                        "latitude": "31.27914000",
                        "longitude": "-107.73149000"
                    },
                    {
                        "id": 68477,
                        "name": "Baborigame",
                        "latitude": "26.42962000",
                        "longitude": "-107.26857000"
                    },
                    {
                        "id": 68491,
                        "name": "Bachíniva",
                        "latitude": "28.76801000",
                        "longitude": "-107.25559000"
                    },
                    {
                        "id": 68497,
                        "name": "Bahuichivo",
                        "latitude": "27.40950000",
                        "longitude": "-108.06740000"
                    },
                    {
                        "id": 68508,
                        "name": "Balleza",
                        "latitude": "26.95154000",
                        "longitude": "-106.34921000"
                    },
                    {
                        "id": 68563,
                        "name": "Basaseachic",
                        "latitude": "28.20626000",
                        "longitude": "-108.21270000"
                    },
                    {
                        "id": 68565,
                        "name": "Basúchil",
                        "latitude": "28.52479000",
                        "longitude": "-107.40172000"
                    },
                    {
                        "id": 68566,
                        "name": "Batopilas",
                        "latitude": "27.02846000",
                        "longitude": "-107.74125000"
                    },
                    {
                        "id": 68598,
                        "name": "Benito Juárez",
                        "latitude": "29.74624000",
                        "longitude": "-107.93966000"
                    },
                    {
                        "id": 68627,
                        "name": "Bocoyna",
                        "latitude": "27.84133000",
                        "longitude": "-107.58918000"
                    },
                    {
                        "id": 68638,
                        "name": "Boquilla de Babisas (La Boquilla de Conchos)",
                        "latitude": "27.54861000",
                        "longitude": "-105.40361000"
                    },
                    {
                        "id": 68667,
                        "name": "Buenaventura",
                        "latitude": "30.02116000",
                        "longitude": "-107.19308000"
                    },
                    {
                        "id": 68758,
                        "name": "Camargo",
                        "latitude": "27.82905000",
                        "longitude": "-104.78012000"
                    },
                    {
                        "id": 68822,
                        "name": "Carichí",
                        "latitude": "27.74601000",
                        "longitude": "-107.07795000"
                    },
                    {
                        "id": 68834,
                        "name": "Carretas",
                        "latitude": "28.24920000",
                        "longitude": "-106.51062000"
                    },
                    {
                        "id": 68853,
                        "name": "Casas Grandes",
                        "latitude": "30.38269000",
                        "longitude": "-107.95628000"
                    },
                    {
                        "id": 68907,
                        "name": "Cerocahui",
                        "latitude": "27.29906000",
                        "longitude": "-108.05500000"
                    },
                    {
                        "id": 69056,
                        "name": "Chihuahua",
                        "latitude": "28.82669000",
                        "longitude": "-106.19876000"
                    },
                    {
                        "id": 69126,
                        "name": "Chínipas",
                        "latitude": "27.39502000",
                        "longitude": "-108.53730000"
                    },
                    {
                        "id": 69154,
                        "name": "Ciudad Delicias",
                        "latitude": "28.19013000",
                        "longitude": "-105.47012000"
                    },
                    {
                        "id": 69270,
                        "name": "Colonia Abraham González (La Quemada)",
                        "latitude": "28.20667000",
                        "longitude": "-105.40750000"
                    },
                    {
                        "id": 69286,
                        "name": "Colonia Campesina",
                        "latitude": "28.14028000",
                        "longitude": "-105.52667000"
                    },
                    {
                        "id": 69300,
                        "name": "Colonia Felipe Ángeles",
                        "latitude": "28.38550000",
                        "longitude": "-105.51184000"
                    },
                    {
                        "id": 69338,
                        "name": "Colonia Nicolás Bravo (Kilómetro Noventa y Dos)",
                        "latitude": "28.09222000",
                        "longitude": "-105.52778000"
                    },
                    {
                        "id": 69356,
                        "name": "Colonia Revolución",
                        "latitude": "28.24167000",
                        "longitude": "-105.44361000"
                    },
                    {
                        "id": 69371,
                        "name": "Colonia Terrazas",
                        "latitude": "28.23795000",
                        "longitude": "-105.46527000"
                    },
                    {
                        "id": 69443,
                        "name": "Conchos",
                        "latitude": "27.58745000",
                        "longitude": "-105.33358000"
                    },
                    {
                        "id": 69452,
                        "name": "Congregación Ortíz",
                        "latitude": "28.25375000",
                        "longitude": "-105.51922000"
                    },
                    {
                        "id": 69515,
                        "name": "Coyame",
                        "latitude": "29.46141000",
                        "longitude": "-105.09404000"
                    },
                    {
                        "id": 69516,
                        "name": "Coyame del Sotol",
                        "latitude": "29.68793000",
                        "longitude": "-105.13855000"
                    },
                    {
                        "id": 69532,
                        "name": "Creel",
                        "latitude": "27.75054000",
                        "longitude": "-107.63520000"
                    },
                    {
                        "id": 69583,
                        "name": "Cuauhtémoc",
                        "latitude": "28.40884000",
                        "longitude": "-106.86319000"
                    },
                    {
                        "id": 69648,
                        "name": "Cusihuiriachi",
                        "latitude": "28.23980000",
                        "longitude": "-106.83477000"
                    },
                    {
                        "id": 69676,
                        "name": "Delicias",
                        "latitude": "28.16948000",
                        "longitude": "-105.44913000"
                    },
                    {
                        "id": 69729,
                        "name": "Dr. Belisario Domínguez",
                        "latitude": "27.98462000",
                        "longitude": "-106.45234000"
                    },
                    {
                        "id": 69758,
                        "name": "Ejido Benito Juárez",
                        "latitude": "30.14937000",
                        "longitude": "-106.88362000"
                    },
                    {
                        "id": 69763,
                        "name": "Ejido El Largo",
                        "latitude": "29.68333000",
                        "longitude": "-108.26667000"
                    },
                    {
                        "id": 69764,
                        "name": "Ejido El Vergel",
                        "latitude": "26.47133000",
                        "longitude": "-106.38320000"
                    },
                    {
                        "id": 69771,
                        "name": "Ejido La Quemada",
                        "latitude": "28.84761000",
                        "longitude": "-107.02152000"
                    },
                    {
                        "id": 70045,
                        "name": "El Molino",
                        "latitude": "28.16608000",
                        "longitude": "-105.53783000"
                    },
                    {
                        "id": 70074,
                        "name": "El Oro",
                        "latitude": "26.86320000",
                        "longitude": "-105.84838000"
                    },
                    {
                        "id": 70200,
                        "name": "El Sauz",
                        "latitude": "29.05056000",
                        "longitude": "-106.25280000"
                    },
                    {
                        "id": 70224,
                        "name": "El Terrero",
                        "latitude": "29.18152000",
                        "longitude": "-107.38740000"
                    },
                    {
                        "id": 70242,
                        "name": "El Tule",
                        "latitude": "27.07325000",
                        "longitude": "-106.31735000"
                    },
                    {
                        "id": 70338,
                        "name": "Estación Conchos",
                        "latitude": "27.97326000",
                        "longitude": "-105.28843000"
                    },
                    {
                        "id": 70339,
                        "name": "Estación Consuelo",
                        "latitude": "28.33118000",
                        "longitude": "-105.59471000"
                    },
                    {
                        "id": 70511,
                        "name": "Galeana",
                        "latitude": "30.10916000",
                        "longitude": "-107.63167000"
                    },
                    {
                        "id": 70645,
                        "name": "Gómez Farías",
                        "latitude": "29.35981000",
                        "longitude": "-107.73960000"
                    },
                    {
                        "id": 70560,
                        "name": "Gran Morelos",
                        "latitude": "28.24841000",
                        "longitude": "-106.49357000"
                    },
                    {
                        "id": 70568,
                        "name": "Guachochi",
                        "latitude": "27.17004000",
                        "longitude": "-107.29404000"
                    },
                    {
                        "id": 70575,
                        "name": "Guadalupe",
                        "latitude": "30.82737000",
                        "longitude": "-105.64057000"
                    },
                    {
                        "id": 70602,
                        "name": "Guadalupe Victoria",
                        "latitude": "31.53396000",
                        "longitude": "-107.73835000"
                    },
                    {
                        "id": 70613,
                        "name": "Guadalupe y Calvo",
                        "latitude": "26.09117000",
                        "longitude": "-106.96260000"
                    },
                    {
                        "id": 70628,
                        "name": "Guazapares",
                        "latitude": "27.44005000",
                        "longitude": "-108.23338000"
                    },
                    {
                        "id": 70631,
                        "name": "Guerrero",
                        "latitude": "28.42888000",
                        "longitude": "-107.50377000"
                    },
                    {
                        "id": 70689,
                        "name": "Hidalgo del Parral",
                        "latitude": "27.07964000",
                        "longitude": "-105.70722000"
                    },
                    {
                        "id": 70765,
                        "name": "Huejotitán",
                        "latitude": "27.05623000",
                        "longitude": "-106.17819000"
                    },
                    {
                        "id": 70852,
                        "name": "Ignacio Zaragoza",
                        "latitude": "29.64248000",
                        "longitude": "-107.76375000"
                    },
                    {
                        "id": 70870,
                        "name": "Independencia",
                        "latitude": "29.09231000",
                        "longitude": "-107.54322000"
                    },
                    {
                        "id": 71002,
                        "name": "Janos",
                        "latitude": "30.88909000",
                        "longitude": "-108.19431000"
                    },
                    {
                        "id": 71049,
                        "name": "Jiménez",
                        "latitude": "28.33333000",
                        "longitude": "-105.40000000"
                    },
                    {
                        "id": 71090,
                        "name": "José Esteban Coronado",
                        "latitude": "26.73722000",
                        "longitude": "-105.15833000"
                    },
                    {
                        "id": 71094,
                        "name": "José Mariano Jiménez",
                        "latitude": "27.13076000",
                        "longitude": "-104.92391000"
                    },
                    {
                        "id": 71146,
                        "name": "Juárez",
                        "latitude": "31.72024000",
                        "longitude": "-106.46084000"
                    },
                    {
                        "id": 71135,
                        "name": "Julimes",
                        "latitude": "28.42376000",
                        "longitude": "-105.42727000"
                    },
                    {
                        "id": 71159,
                        "name": "Kilómetro Noventa y Nueve",
                        "latitude": "28.12668000",
                        "longitude": "-105.58018000"
                    },
                    {
                        "id": 71244,
                        "name": "La Constitución",
                        "latitude": "29.92077000",
                        "longitude": "-106.79620000"
                    },
                    {
                        "id": 71249,
                        "name": "La Cruz",
                        "latitude": "27.86359000",
                        "longitude": "-105.19596000"
                    },
                    {
                        "id": 71336,
                        "name": "La Junta",
                        "latitude": "28.48003000",
                        "longitude": "-107.32948000"
                    },
                    {
                        "id": 71594,
                        "name": "Las Cruces",
                        "latitude": "29.43278000",
                        "longitude": "-107.38958000"
                    },
                    {
                        "id": 71649,
                        "name": "Las Varas",
                        "latitude": "28.15659000",
                        "longitude": "-105.34058000"
                    },
                    {
                        "id": 71650,
                        "name": "Las Varas (Estación Babícora)",
                        "latitude": "29.48083000",
                        "longitude": "-108.02556000"
                    },
                    {
                        "id": 71654,
                        "name": "Las Yerbitas [Aserradero]",
                        "latitude": "26.08025000",
                        "longitude": "-106.77969000"
                    },
                    {
                        "id": 71890,
                        "name": "Lázaro Cárdenas",
                        "latitude": "28.39051000",
                        "longitude": "-105.62346000"
                    },
                    {
                        "id": 71712,
                        "name": "Loma Blanca",
                        "latitude": "31.57996000",
                        "longitude": "-106.29604000"
                    },
                    {
                        "id": 71917,
                        "name": "Madera",
                        "latitude": "29.19366000",
                        "longitude": "-108.14684000"
                    },
                    {
                        "id": 71937,
                        "name": "Maguarichi",
                        "latitude": "27.81655000",
                        "longitude": "-107.96866000"
                    },
                    {
                        "id": 71958,
                        "name": "Manuel Benavides",
                        "latitude": "28.94431000",
                        "longitude": "-103.91889000"
                    },
                    {
                        "id": 71964,
                        "name": "Manuel Ojinaga",
                        "latitude": "29.56444000",
                        "longitude": "-104.41639000"
                    },
                    {
                        "id": 71990,
                        "name": "Mariano Balleza",
                        "latitude": "26.95389000",
                        "longitude": "-106.34611000"
                    },
                    {
                        "id": 72015,
                        "name": "Matachí",
                        "latitude": "28.84287000",
                        "longitude": "-107.75503000"
                    },
                    {
                        "id": 72017,
                        "name": "Matamoros",
                        "latitude": "26.76209000",
                        "longitude": "-105.58523000"
                    },
                    {
                        "id": 72075,
                        "name": "Meoqui",
                        "latitude": "28.27226000",
                        "longitude": "-105.48046000"
                    },
                    {
                        "id": 72081,
                        "name": "Mesa del Huracán",
                        "latitude": "29.67045000",
                        "longitude": "-108.25182000"
                    },
                    {
                        "id": 72122,
                        "name": "Miguel Ahumada",
                        "latitude": "30.61861000",
                        "longitude": "-106.51222000"
                    },
                    {
                        "id": 72132,
                        "name": "Miguel Hidalgo",
                        "latitude": "28.15361000",
                        "longitude": "-105.39389000"
                    },
                    {
                        "id": 72207,
                        "name": "Monte Verde",
                        "latitude": "30.91401000",
                        "longitude": "-108.71573000"
                    },
                    {
                        "id": 72229,
                        "name": "Morelos",
                        "latitude": "26.67289000",
                        "longitude": "-107.67665000"
                    },
                    {
                        "id": 72236,
                        "name": "Moris",
                        "latitude": "28.14888000",
                        "longitude": "-108.52325000"
                    },
                    {
                        "id": 72272,
                        "name": "Naica",
                        "latitude": "27.85736000",
                        "longitude": "-105.49233000"
                    },
                    {
                        "id": 72273,
                        "name": "Namiquipa",
                        "latitude": "29.25173000",
                        "longitude": "-107.41400000"
                    },
                    {
                        "id": 72317,
                        "name": "Nicolas Bravo",
                        "latitude": "29.35306000",
                        "longitude": "-107.93440000"
                    },
                    {
                        "id": 72334,
                        "name": "Ninguno [CERESO]",
                        "latitude": "28.60972000",
                        "longitude": "-105.94028000"
                    },
                    {
                        "id": 72344,
                        "name": "Nonoava",
                        "latitude": "27.43854000",
                        "longitude": "-106.73285000"
                    },
                    {
                        "id": 72381,
                        "name": "Nuevo Casas Grandes",
                        "latitude": "30.41552000",
                        "longitude": "-107.91166000"
                    },
                    {
                        "id": 72440,
                        "name": "Ocampo",
                        "latitude": "28.19367000",
                        "longitude": "-108.36760000"
                    },
                    {
                        "id": 72466,
                        "name": "Octaviano López",
                        "latitude": "27.00250000",
                        "longitude": "-105.03306000"
                    },
                    {
                        "id": 72479,
                        "name": "Ojinaga",
                        "latitude": "29.31371000",
                        "longitude": "-104.44840000"
                    },
                    {
                        "id": 72530,
                        "name": "Orranteño",
                        "latitude": "28.18272000",
                        "longitude": "-105.33774000"
                    },
                    {
                        "id": 72532,
                        "name": "Oscar Soto Maynez",
                        "latitude": "29.02963000",
                        "longitude": "-107.47242000"
                    },
                    {
                        "id": 72660,
                        "name": "Parral",
                        "latitude": "26.93022000",
                        "longitude": "-105.66640000"
                    },
                    {
                        "id": 72748,
                        "name": "Peña Blanca",
                        "latitude": "29.28984000",
                        "longitude": "-107.71130000"
                    },
                    {
                        "id": 72858,
                        "name": "Porvenir",
                        "latitude": "31.24038000",
                        "longitude": "-105.87664000"
                    },
                    {
                        "id": 72884,
                        "name": "Praxedis G. Guerrero",
                        "latitude": "31.37061000",
                        "longitude": "-106.00616000"
                    },
                    {
                        "id": 72886,
                        "name": "Praxédis Guerrero",
                        "latitude": "31.36667000",
                        "longitude": "-106.01667000"
                    },
                    {
                        "id": 72929,
                        "name": "Pueblito de Allende",
                        "latitude": "26.99065000",
                        "longitude": "-105.32686000"
                    },
                    {
                        "id": 72972,
                        "name": "Puerto Palomas",
                        "latitude": "31.77718000",
                        "longitude": "-107.63439000"
                    },
                    {
                        "id": 73142,
                        "name": "Riva Palacio",
                        "latitude": "28.81462000",
                        "longitude": "-106.64990000"
                    },
                    {
                        "id": 73149,
                        "name": "Rodrígo M. Quevedo",
                        "latitude": "29.91982000",
                        "longitude": "-107.52079000"
                    },
                    {
                        "id": 73159,
                        "name": "Rosales",
                        "latitude": "28.18753000",
                        "longitude": "-105.55717000"
                    },
                    {
                        "id": 73163,
                        "name": "Rosario",
                        "latitude": "27.25616000",
                        "longitude": "-106.29878000"
                    },
                    {
                        "id": 73232,
                        "name": "Samachique",
                        "latitude": "27.30156000",
                        "longitude": "-107.53897000"
                    },
                    {
                        "id": 73234,
                        "name": "Samalayuca",
                        "latitude": "31.34242000",
                        "longitude": "-106.47981000"
                    },
                    {
                        "id": 73239,
                        "name": "San Agustín",
                        "latitude": "31.51674000",
                        "longitude": "-106.25548000"
                    },
                    {
                        "id": 73266,
                        "name": "San Andrés",
                        "latitude": "28.54726000",
                        "longitude": "-106.50350000"
                    },
                    {
                        "id": 73451,
                        "name": "San Buenaventura",
                        "latitude": "29.84320000",
                        "longitude": "-107.46067000"
                    },
                    {
                        "id": 73460,
                        "name": "San Carlos",
                        "latitude": "29.10665000",
                        "longitude": "-103.90722000"
                    },
                    {
                        "id": 73609,
                        "name": "San Francisco de Borja",
                        "latitude": "27.90171000",
                        "longitude": "-106.68562000"
                    },
                    {
                        "id": 73610,
                        "name": "San Francisco de Conchos",
                        "latitude": "27.57356000",
                        "longitude": "-105.37779000"
                    },
                    {
                        "id": 73620,
                        "name": "San Francisco del Oro",
                        "latitude": "26.89417000",
                        "longitude": "-105.90594000"
                    },
                    {
                        "id": 73667,
                        "name": "San Isidro",
                        "latitude": "31.54683000",
                        "longitude": "-106.27868000"
                    },
                    {
                        "id": 73982,
                        "name": "San Juanito",
                        "latitude": "27.97295000",
                        "longitude": "-107.60199000"
                    },
                    {
                        "id": 73992,
                        "name": "San Lorenzo",
                        "latitude": "28.15352000",
                        "longitude": "-106.47695000"
                    },
                    {
                        "id": 74425,
                        "name": "San Rafael",
                        "latitude": "27.49750000",
                        "longitude": "-107.89099000"
                    },
                    {
                        "id": 74565,
                        "name": "Santa Bárbara",
                        "latitude": "26.80381000",
                        "longitude": "-105.82024000"
                    },
                    {
                        "id": 74657,
                        "name": "Santa Eulalia",
                        "latitude": "28.59450000",
                        "longitude": "-105.88796000"
                    },
                    {
                        "id": 74674,
                        "name": "Santa Isabel",
                        "latitude": "28.34166000",
                        "longitude": "-106.37220000"
                    },
                    {
                        "id": 75044,
                        "name": "Saucillo",
                        "latitude": "28.03055000",
                        "longitude": "-105.29376000"
                    },
                    {
                        "id": 75098,
                        "name": "Sisoguichi",
                        "latitude": "27.78304000",
                        "longitude": "-107.49517000"
                    },
                    {
                        "id": 75856,
                        "name": "Témoris",
                        "latitude": "27.27569000",
                        "longitude": "-108.27946000"
                    },
                    {
                        "id": 75344,
                        "name": "Temósachic",
                        "latitude": "28.95469000",
                        "longitude": "-107.82957000"
                    },
                    {
                        "id": 75730,
                        "name": "Tomochic",
                        "latitude": "28.35273000",
                        "longitude": "-107.84576000"
                    },
                    {
                        "id": 75816,
                        "name": "Turuachi",
                        "latitude": "26.13139000",
                        "longitude": "-106.70417000"
                    },
                    {
                        "id": 75894,
                        "name": "Urique",
                        "latitude": "27.21122000",
                        "longitude": "-107.91415000"
                    },
                    {
                        "id": 75897,
                        "name": "Uruachi",
                        "latitude": "27.84669000",
                        "longitude": "-108.36712000"
                    },
                    {
                        "id": 75910,
                        "name": "Valentín Gómez Farías",
                        "latitude": "28.21667000",
                        "longitude": "-106.58333000"
                    },
                    {
                        "id": 75919,
                        "name": "Valle de Allende",
                        "latitude": "26.93527000",
                        "longitude": "-105.39271000"
                    },
                    {
                        "id": 75927,
                        "name": "Valle de Zaragoza",
                        "latitude": "27.45066000",
                        "longitude": "-105.80847000"
                    },
                    {
                        "id": 75928,
                        "name": "Valle del Rosario",
                        "latitude": "27.31881000",
                        "longitude": "-106.29551000"
                    },
                    {
                        "id": 76252,
                        "name": "Yécora",
                        "latitude": "28.37154000",
                        "longitude": "-108.92781000"
                    }
                ]
            },
            {
                "id": 3473,
                "name": "Ciudad de México",
                "iso2": "CMX",
                "latitude": "19.43260770",
                "longitude": "-99.13320800",
                "type": "federal district",
                "cities": [
                    {
                        "id": 76401,
                        "name": "Álvaro Obregón",
                        "latitude": "19.37496000",
                        "longitude": "-99.21976000"
                    },
                    {
                        "id": 68472,
                        "name": "Azcapotzalco",
                        "latitude": "19.48698000",
                        "longitude": "-99.18594000"
                    },
                    {
                        "id": 68588,
                        "name": "Benito Juarez",
                        "latitude": "19.39840000",
                        "longitude": "-99.15766000"
                    },
                    {
                        "id": 72102,
                        "name": "Ciudad de México",
                        "latitude": "19.42847000",
                        "longitude": "-99.12766000"
                    },
                    {
                        "id": 69255,
                        "name": "Col. Bosques de las Lomas",
                        "latitude": "19.37893000",
                        "longitude": "-99.26587000"
                    },
                    {
                        "id": 69383,
                        "name": "Colonia del Valle",
                        "latitude": "19.38611000",
                        "longitude": "-99.16204000"
                    },
                    {
                        "id": 69337,
                        "name": "Colonia Nativitas",
                        "latitude": "19.38119000",
                        "longitude": "-99.13685000"
                    },
                    {
                        "id": 69517,
                        "name": "Coyoacán",
                        "latitude": "19.34670000",
                        "longitude": "-99.16174000"
                    },
                    {
                        "id": 69581,
                        "name": "Cuauhtémoc",
                        "latitude": "19.44506000",
                        "longitude": "-99.14612000"
                    },
                    {
                        "id": 69672,
                        "name": "Delegación Cuajimalpa de Morelos",
                        "latitude": "19.36920000",
                        "longitude": "-99.29089000"
                    },
                    {
                        "id": 70638,
                        "name": "Gustavo A. Madero",
                        "latitude": "19.48407000",
                        "longitude": "-99.11144000"
                    },
                    {
                        "id": 70639,
                        "name": "Gustavo Adolfo Madero",
                        "latitude": "19.49392000",
                        "longitude": "-99.11075000"
                    },
                    {
                        "id": 70950,
                        "name": "Iztacalco",
                        "latitude": "19.39528000",
                        "longitude": "-99.09778000"
                    },
                    {
                        "id": 70952,
                        "name": "Iztapalapa",
                        "latitude": "19.35529000",
                        "longitude": "-99.06224000"
                    },
                    {
                        "id": 71756,
                        "name": "Lomas de Tepemecatl",
                        "latitude": "19.23861000",
                        "longitude": "-99.23944000"
                    },
                    {
                        "id": 71923,
                        "name": "Magdalena Contreras",
                        "latitude": "19.33212000",
                        "longitude": "-99.21118000"
                    },
                    {
                        "id": 72130,
                        "name": "Miguel Hidalgo",
                        "latitude": "19.43411000",
                        "longitude": "-99.20024000"
                    },
                    {
                        "id": 72138,
                        "name": "Milpa Alta",
                        "latitude": "19.19251000",
                        "longitude": "-99.02317000"
                    },
                    {
                        "id": 72836,
                        "name": "Polanco",
                        "latitude": "19.43332000",
                        "longitude": "-99.19919000"
                    },
                    {
                        "id": 73286,
                        "name": "San Andrés Mixquic",
                        "latitude": "19.22512000",
                        "longitude": "-98.96408000"
                    },
                    {
                        "id": 73352,
                        "name": "San Antonio Tecómitl",
                        "latitude": "19.21778000",
                        "longitude": "-98.98806000"
                    },
                    {
                        "id": 73416,
                        "name": "San Bartolome Xicomulco",
                        "latitude": "19.20607000",
                        "longitude": "-99.06820000"
                    },
                    {
                        "id": 73592,
                        "name": "San Francisco Tecoxpa",
                        "latitude": "19.19167000",
                        "longitude": "-99.00639000"
                    },
                    {
                        "id": 73900,
                        "name": "San Juan Ixtayopan",
                        "latitude": "19.23187000",
                        "longitude": "-98.99867000"
                    },
                    {
                        "id": 73996,
                        "name": "San Lorenzo Acopilco",
                        "latitude": "19.33002000",
                        "longitude": "-99.32721000"
                    },
                    {
                        "id": 74014,
                        "name": "San Lorenzo Tlacoyucan",
                        "latitude": "19.17605000",
                        "longitude": "-99.03219000"
                    },
                    {
                        "id": 74157,
                        "name": "San Miguel Ajusco",
                        "latitude": "19.22201000",
                        "longitude": "-99.20242000"
                    },
                    {
                        "id": 74216,
                        "name": "San Miguel Topilejo",
                        "latitude": "19.20264000",
                        "longitude": "-99.14193000"
                    },
                    {
                        "id": 74297,
                        "name": "San Pablo Oztotepec",
                        "latitude": "19.18652000",
                        "longitude": "-99.07361000"
                    },
                    {
                        "id": 74318,
                        "name": "San Pedro Atocpan",
                        "latitude": "19.20160000",
                        "longitude": "-99.04963000"
                    },
                    {
                        "id": 74447,
                        "name": "San Salvador Cuauhtenco",
                        "latitude": "19.19276000",
                        "longitude": "-99.08983000"
                    },
                    {
                        "id": 74546,
                        "name": "Santa Ana Tlacotenco",
                        "latitude": "19.17569000",
                        "longitude": "-98.99788000"
                    },
                    {
                        "id": 74592,
                        "name": "Santa Catarina Yecahuizotl",
                        "latitude": "19.31205000",
                        "longitude": "-98.96461000"
                    },
                    {
                        "id": 75481,
                        "name": "Tetelco",
                        "latitude": "19.21673000",
                        "longitude": "-98.97295000"
                    },
                    {
                        "id": 75711,
                        "name": "Tláhuac",
                        "latitude": "19.28689000",
                        "longitude": "-99.00507000"
                    },
                    {
                        "id": 75649,
                        "name": "Tlalpan",
                        "latitude": "19.29513000",
                        "longitude": "-99.16206000"
                    },
                    {
                        "id": 75960,
                        "name": "Venustiano Carranza",
                        "latitude": "19.44361000",
                        "longitude": "-99.10499000"
                    },
                    {
                        "id": 76166,
                        "name": "Xochimilco",
                        "latitude": "19.25465000",
                        "longitude": "-99.10356000"
                    }
                ]
            },
            {
                "id": 3471,
                "name": "Coahuila de Zaragoza",
                "iso2": "COA",
                "latitude": "27.05867600",
                "longitude": "-101.70682940",
                "type": "state",
                "cities": [
                    {
                        "id": 68014,
                        "name": "Abasolo",
                        "latitude": "27.18219000",
                        "longitude": "-101.42757000"
                    },
                    {
                        "id": 68114,
                        "name": "Agua Nueva",
                        "latitude": "25.18934000",
                        "longitude": "-101.08840000"
                    },
                    {
                        "id": 68175,
                        "name": "Albia",
                        "latitude": "25.66537000",
                        "longitude": "-103.36253000"
                    },
                    {
                        "id": 68188,
                        "name": "Alejo González (Bilbao)",
                        "latitude": "25.82194000",
                        "longitude": "-103.19472000"
                    },
                    {
                        "id": 68374,
                        "name": "Arteaga",
                        "latitude": "25.44528000",
                        "longitude": "-100.84667000"
                    },
                    {
                        "id": 68639,
                        "name": "Boquilla de las Perlas",
                        "latitude": "25.32803000",
                        "longitude": "-103.28870000"
                    },
                    {
                        "id": 68788,
                        "name": "Candela",
                        "latitude": "26.83840000",
                        "longitude": "-100.66630000"
                    },
                    {
                        "id": 68859,
                        "name": "Castaños",
                        "latitude": "26.78932000",
                        "longitude": "-101.43211000"
                    },
                    {
                        "id": 69112,
                        "name": "Chula Vista",
                        "latitude": "27.04083000",
                        "longitude": "-103.36611000"
                    },
                    {
                        "id": 69142,
                        "name": "Ciudad Acuña",
                        "latitude": "29.32322000",
                        "longitude": "-100.95217000"
                    },
                    {
                        "id": 69169,
                        "name": "Ciudad Melchor Múzquiz",
                        "latitude": "27.87933000",
                        "longitude": "-101.51615000"
                    },
                    {
                        "id": 69202,
                        "name": "Cloete",
                        "latitude": "27.92097000",
                        "longitude": "-101.17576000"
                    },
                    {
                        "id": 69291,
                        "name": "Colonia Diana Laura Riojas de Colosio",
                        "latitude": "26.97722000",
                        "longitude": "-101.48083000"
                    },
                    {
                        "id": 69377,
                        "name": "Colonia Venustiano Carranza",
                        "latitude": "28.63861000",
                        "longitude": "-100.55667000"
                    },
                    {
                        "id": 69430,
                        "name": "Compuertas",
                        "latitude": "25.74681000",
                        "longitude": "-103.30250000"
                    },
                    {
                        "id": 69445,
                        "name": "Concordia",
                        "latitude": "25.77982000",
                        "longitude": "-103.11696000"
                    },
                    {
                        "id": 69520,
                        "name": "Coyote",
                        "latitude": "25.69510000",
                        "longitude": "-103.28420000"
                    },
                    {
                        "id": 69570,
                        "name": "Cuatro Ciénegas de Carranza",
                        "latitude": "26.98542000",
                        "longitude": "-102.06386000"
                    },
                    {
                        "id": 69797,
                        "name": "Ejido Venustiano Carranza",
                        "latitude": "25.35091000",
                        "longitude": "-102.95698000"
                    },
                    {
                        "id": 69858,
                        "name": "El Cambio",
                        "latitude": "25.64048000",
                        "longitude": "-103.32710000"
                    },
                    {
                        "id": 69919,
                        "name": "El Consuelo",
                        "latitude": "25.57131000",
                        "longitude": "-103.27620000"
                    },
                    {
                        "id": 69936,
                        "name": "El Cuije",
                        "latitude": "25.69670000",
                        "longitude": "-103.34107000"
                    },
                    {
                        "id": 70012,
                        "name": "El Lequeitio",
                        "latitude": "25.84673000",
                        "longitude": "-103.27890000"
                    },
                    {
                        "id": 70063,
                        "name": "El Nilo",
                        "latitude": "25.73363000",
                        "longitude": "-102.94297000"
                    },
                    {
                        "id": 70099,
                        "name": "El Perú",
                        "latitude": "25.60290000",
                        "longitude": "-103.34423000"
                    },
                    {
                        "id": 70119,
                        "name": "El Porvenir (El Porvenir de Arriba)",
                        "latitude": "25.77444000",
                        "longitude": "-103.32528000"
                    },
                    {
                        "id": 70158,
                        "name": "El Retiro",
                        "latitude": "25.82758000",
                        "longitude": "-103.13004000"
                    },
                    {
                        "id": 70321,
                        "name": "Escuadrón Doscientos Uno",
                        "latitude": "25.67433000",
                        "longitude": "-103.34829000"
                    },
                    {
                        "id": 70452,
                        "name": "Fraccionamiento la Noria",
                        "latitude": "25.55722000",
                        "longitude": "-103.34361000"
                    },
                    {
                        "id": 70491,
                        "name": "Frontera",
                        "latitude": "26.92814000",
                        "longitude": "-101.45212000"
                    },
                    {
                        "id": 70529,
                        "name": "General Cepeda",
                        "latitude": "25.37767000",
                        "longitude": "-101.47571000"
                    },
                    {
                        "id": 70550,
                        "name": "Gilita",
                        "latitude": "25.39314000",
                        "longitude": "-103.19976000"
                    },
                    {
                        "id": 70561,
                        "name": "Granada",
                        "latitude": "25.64127000",
                        "longitude": "-103.26710000"
                    },
                    {
                        "id": 70630,
                        "name": "Guerrero",
                        "latitude": "28.30992000",
                        "longitude": "-100.38048000"
                    },
                    {
                        "id": 70828,
                        "name": "Hércules",
                        "latitude": "28.04306000",
                        "longitude": "-103.79111000"
                    },
                    {
                        "id": 70683,
                        "name": "Hidalgo",
                        "latitude": "27.78994000",
                        "longitude": "-99.87699000"
                    },
                    {
                        "id": 70710,
                        "name": "Hormiguero",
                        "latitude": "25.68386000",
                        "longitude": "-103.34121000"
                    },
                    {
                        "id": 70714,
                        "name": "Huachichil",
                        "latitude": "25.21114000",
                        "longitude": "-100.82570000"
                    },
                    {
                        "id": 70802,
                        "name": "Huitrón",
                        "latitude": "25.85748000",
                        "longitude": "-103.34825000"
                    },
                    {
                        "id": 70956,
                        "name": "Jaboncillo",
                        "latitude": "25.74809000",
                        "longitude": "-103.26550000"
                    },
                    {
                        "id": 71051,
                        "name": "Jiménez",
                        "latitude": "29.06975000",
                        "longitude": "-100.67895000"
                    },
                    {
                        "id": 71240,
                        "name": "La Concha",
                        "latitude": "25.63524000",
                        "longitude": "-103.38136000"
                    },
                    {
                        "id": 71248,
                        "name": "La Cruz",
                        "latitude": "26.99339000",
                        "longitude": "-101.49580000"
                    },
                    {
                        "id": 71268,
                        "name": "La Esmeralda",
                        "latitude": "27.28735000",
                        "longitude": "-103.66283000"
                    },
                    {
                        "id": 71273,
                        "name": "La Esperanza",
                        "latitude": "25.56631000",
                        "longitude": "-103.28123000"
                    },
                    {
                        "id": 71289,
                        "name": "La Fe",
                        "latitude": "25.84743000",
                        "longitude": "-103.20117000"
                    },
                    {
                        "id": 71293,
                        "name": "La Florida",
                        "latitude": "25.76811000",
                        "longitude": "-103.32424000"
                    },
                    {
                        "id": 71374,
                        "name": "La Luz",
                        "latitude": "25.72621000",
                        "longitude": "-103.24540000"
                    },
                    {
                        "id": 71425,
                        "name": "La Palma",
                        "latitude": "25.60830000",
                        "longitude": "-103.32228000"
                    },
                    {
                        "id": 71432,
                        "name": "La Partida",
                        "latitude": "25.59181000",
                        "longitude": "-103.29994000"
                    },
                    {
                        "id": 71435,
                        "name": "La Paz",
                        "latitude": "25.59390000",
                        "longitude": "-103.35852000"
                    },
                    {
                        "id": 71442,
                        "name": "La Perla",
                        "latitude": "25.49696000",
                        "longitude": "-103.35088000"
                    },
                    {
                        "id": 71449,
                        "name": "La Pinta",
                        "latitude": "25.90281000",
                        "longitude": "-103.26476000"
                    },
                    {
                        "id": 71559,
                        "name": "Laguna del Rey (Químicas del Rey)",
                        "latitude": "27.03056000",
                        "longitude": "-103.36667000"
                    },
                    {
                        "id": 71566,
                        "name": "Lamadrid",
                        "latitude": "27.05087000",
                        "longitude": "-101.79552000"
                    },
                    {
                        "id": 71623,
                        "name": "Las Mieleras",
                        "latitude": "25.39948000",
                        "longitude": "-103.26740000"
                    },
                    {
                        "id": 71869,
                        "name": "Los Álamos",
                        "latitude": "28.35645000",
                        "longitude": "-100.94564000"
                    },
                    {
                        "id": 71878,
                        "name": "Luchanas",
                        "latitude": "25.79091000",
                        "longitude": "-103.19384000"
                    },
                    {
                        "id": 71984,
                        "name": "Maravillas",
                        "latitude": "25.65872000",
                        "longitude": "-103.34079000"
                    },
                    {
                        "id": 72018,
                        "name": "Matamoros",
                        "latitude": "25.52699000",
                        "longitude": "-103.22850000"
                    },
                    {
                        "id": 72035,
                        "name": "Mayran",
                        "latitude": "25.67296000",
                        "longitude": "-102.84288000"
                    },
                    {
                        "id": 72144,
                        "name": "Minas de Barroterán",
                        "latitude": "27.65144000",
                        "longitude": "-101.28212000"
                    },
                    {
                        "id": 72191,
                        "name": "Monclova",
                        "latitude": "26.90687000",
                        "longitude": "-101.42056000"
                    },
                    {
                        "id": 72270,
                        "name": "Nadadores",
                        "latitude": "27.02819000",
                        "longitude": "-101.59420000"
                    },
                    {
                        "id": 72294,
                        "name": "Nava",
                        "latitude": "28.42071000",
                        "longitude": "-100.76565000"
                    },
                    {
                        "id": 72373,
                        "name": "Nueva Rosita",
                        "latitude": "27.94028000",
                        "longitude": "-101.21812000"
                    },
                    {
                        "id": 72392,
                        "name": "Nuevo León",
                        "latitude": "25.71863000",
                        "longitude": "-103.29471000"
                    },
                    {
                        "id": 72438,
                        "name": "Ocampo",
                        "latitude": "27.31477000",
                        "longitude": "-102.39660000"
                    },
                    {
                        "id": 72446,
                        "name": "Ocho de Enero",
                        "latitude": "26.99733000",
                        "longitude": "-101.49598000"
                    },
                    {
                        "id": 72581,
                        "name": "Palau",
                        "latitude": "27.89232000",
                        "longitude": "-101.42319000"
                    },
                    {
                        "id": 72654,
                        "name": "Paredón",
                        "latitude": "25.94580000",
                        "longitude": "-100.93449000"
                    },
                    {
                        "id": 72661,
                        "name": "Parras de la Fuente",
                        "latitude": "25.44185000",
                        "longitude": "-102.17808000"
                    },
                    {
                        "id": 72772,
                        "name": "Piedras Negras",
                        "latitude": "28.70007000",
                        "longitude": "-100.52353000"
                    },
                    {
                        "id": 72902,
                        "name": "Primero de Mayo",
                        "latitude": "27.23675000",
                        "longitude": "-101.22360000"
                    },
                    {
                        "id": 72909,
                        "name": "Progreso",
                        "latitude": "27.42841000",
                        "longitude": "-100.98892000"
                    },
                    {
                        "id": 72993,
                        "name": "Purísima",
                        "latitude": "25.68038000",
                        "longitude": "-103.32218000"
                    },
                    {
                        "id": 73049,
                        "name": "Ramos Arizpe",
                        "latitude": "25.53928000",
                        "longitude": "-100.94742000"
                    },
                    {
                        "id": 73056,
                        "name": "Rancho Alegre",
                        "latitude": "25.50237000",
                        "longitude": "-103.32789000"
                    },
                    {
                        "id": 73169,
                        "name": "Río Bravo",
                        "latitude": "28.31254000",
                        "longitude": "-100.91668000"
                    },
                    {
                        "id": 73196,
                        "name": "Sabinas",
                        "latitude": "27.85591000",
                        "longitude": "-101.11738000"
                    },
                    {
                        "id": 73199,
                        "name": "Sacramento",
                        "latitude": "27.00264000",
                        "longitude": "-101.72463000"
                    },
                    {
                        "id": 73226,
                        "name": "Saltillo",
                        "latitude": "25.42321000",
                        "longitude": "-101.00530000"
                    },
                    {
                        "id": 73370,
                        "name": "San Antonio de las Alazanas",
                        "latitude": "25.27166000",
                        "longitude": "-100.57835000"
                    },
                    {
                        "id": 73379,
                        "name": "San Antonio del Coyote",
                        "latitude": "25.69444000",
                        "longitude": "-103.28556000"
                    },
                    {
                        "id": 73450,
                        "name": "San Buenaventura",
                        "latitude": "27.06193000",
                        "longitude": "-101.54891000"
                    },
                    {
                        "id": 73459,
                        "name": "San Carlos",
                        "latitude": "29.02844000",
                        "longitude": "-100.90217000"
                    },
                    {
                        "id": 73509,
                        "name": "San Esteban de Abajo",
                        "latitude": "25.70903000",
                        "longitude": "-103.00047000"
                    },
                    {
                        "id": 73608,
                        "name": "San Francisco de Arriba",
                        "latitude": "25.75028000",
                        "longitude": "-103.15631000"
                    },
                    {
                        "id": 73648,
                        "name": "San Ignacio",
                        "latitude": "25.73643000",
                        "longitude": "-103.09049000"
                    },
                    {
                        "id": 73808,
                        "name": "San José de Aura",
                        "latitude": "27.58778000",
                        "longitude": "-101.37250000"
                    },
                    {
                        "id": 73965,
                        "name": "San Juan de la Vaquería",
                        "latitude": "25.25275000",
                        "longitude": "-101.22011000"
                    },
                    {
                        "id": 73963,
                        "name": "San Juan de Sabinas",
                        "latitude": "27.92942000",
                        "longitude": "-101.30495000"
                    },
                    {
                        "id": 73989,
                        "name": "San Lorenzo",
                        "latitude": "25.72272000",
                        "longitude": "-103.15350000"
                    },
                    {
                        "id": 74065,
                        "name": "San Marcos",
                        "latitude": "25.66667000",
                        "longitude": "-103.00910000"
                    },
                    {
                        "id": 74152,
                        "name": "San Miguel",
                        "latitude": "25.69924000",
                        "longitude": "-102.95072000"
                    },
                    {
                        "id": 74555,
                        "name": "Santa Ana del Pilar",
                        "latitude": "25.70938000",
                        "longitude": "-103.30840000"
                    },
                    {
                        "id": 74662,
                        "name": "Santa Fé",
                        "latitude": "25.56665000",
                        "longitude": "-103.33200000"
                    },
                    {
                        "id": 75020,
                        "name": "Santo Niño Aguanaval",
                        "latitude": "25.43118000",
                        "longitude": "-103.27909000"
                    },
                    {
                        "id": 75058,
                        "name": "Seis de Octubre (Santo Niño)",
                        "latitude": "25.76389000",
                        "longitude": "-103.23889000"
                    },
                    {
                        "id": 75072,
                        "name": "Sierra Mojada",
                        "latitude": "27.28861000",
                        "longitude": "-103.70124000"
                    },
                    {
                        "id": 75118,
                        "name": "Solima",
                        "latitude": "25.66249000",
                        "longitude": "-103.27560000"
                    },
                    {
                        "id": 75162,
                        "name": "Tacubaya",
                        "latitude": "25.68361000",
                        "longitude": "-103.06861000"
                    },
                    {
                        "id": 75748,
                        "name": "Torreón",
                        "latitude": "25.54389000",
                        "longitude": "-103.41898000"
                    },
                    {
                        "id": 75946,
                        "name": "Veinte de Noviembre",
                        "latitude": "25.71193000",
                        "longitude": "-103.32960000"
                    },
                    {
                        "id": 75947,
                        "name": "Veinte de Noviembre (Santa Lucía)",
                        "latitude": "25.78923000",
                        "longitude": "-103.15127000"
                    },
                    {
                        "id": 75956,
                        "name": "Ventana",
                        "latitude": "25.32695000",
                        "longitude": "-103.47772000"
                    },
                    {
                        "id": 75987,
                        "name": "Viesca",
                        "latitude": "25.33923000",
                        "longitude": "-102.80493000"
                    },
                    {
                        "id": 76025,
                        "name": "Villa Las Esperanzas",
                        "latitude": "27.74274000",
                        "longitude": "-101.35295000"
                    },
                    {
                        "id": 76049,
                        "name": "Villa Union",
                        "latitude": "28.21667000",
                        "longitude": "-100.71667000"
                    },
                    {
                        "id": 76092,
                        "name": "Virginias",
                        "latitude": "25.80083000",
                        "longitude": "-103.27235000"
                    },
                    {
                        "id": 76318,
                        "name": "Zaragoza",
                        "latitude": "28.49320000",
                        "longitude": "-100.92230000"
                    }
                ]
            },
            {
                "id": 3472,
                "name": "Colima",
                "iso2": "COL",
                "latitude": "19.24523420",
                "longitude": "-103.72408680",
                "type": "state",
                "cities": [
                    {
                        "id": 68179,
                        "name": "Alcaraces",
                        "latitude": "19.36433000",
                        "longitude": "-103.57676000"
                    },
                    {
                        "id": 68354,
                        "name": "Armería",
                        "latitude": "18.95554000",
                        "longitude": "-103.98357000"
                    },
                    {
                        "id": 68443,
                        "name": "Augusto Gómez Villanueva",
                        "latitude": "19.02154000",
                        "longitude": "-104.00156000"
                    },
                    {
                        "id": 68732,
                        "name": "Caleras",
                        "latitude": "18.99687000",
                        "longitude": "-103.87898000"
                    },
                    {
                        "id": 68768,
                        "name": "Camotlán de Miraflores",
                        "latitude": "19.22033000",
                        "longitude": "-104.23491000"
                    },
                    {
                        "id": 68933,
                        "name": "Cerro de Ortega",
                        "latitude": "18.75080000",
                        "longitude": "-103.72155000"
                    },
                    {
                        "id": 69186,
                        "name": "Ciudad de Armería",
                        "latitude": "18.93780000",
                        "longitude": "-103.96417000"
                    },
                    {
                        "id": 69193,
                        "name": "Ciudad de Villa de Álvarez",
                        "latitude": "19.26722000",
                        "longitude": "-103.73778000"
                    },
                    {
                        "id": 69247,
                        "name": "Cofradía",
                        "latitude": "19.43333000",
                        "longitude": "-103.55000000"
                    },
                    {
                        "id": 69248,
                        "name": "Cofradía de Juárez",
                        "latitude": "18.96261000",
                        "longitude": "-103.95549000"
                    },
                    {
                        "id": 69249,
                        "name": "Cofradía de Morelos",
                        "latitude": "18.86785000",
                        "longitude": "-103.83668000"
                    },
                    {
                        "id": 69251,
                        "name": "Cofradía de Suchitlán",
                        "latitude": "19.40954000",
                        "longitude": "-103.70043000"
                    },
                    {
                        "id": 69416,
                        "name": "Comala",
                        "latitude": "19.32717000",
                        "longitude": "-103.75926000"
                    },
                    {
                        "id": 69477,
                        "name": "Coquimatlán",
                        "latitude": "19.20625000",
                        "longitude": "-103.80952000"
                    },
                    {
                        "id": 69582,
                        "name": "Cuauhtémoc",
                        "latitude": "19.32861000",
                        "longitude": "-103.60284000"
                    },
                    {
                        "id": 69653,
                        "name": "Cuyutlán",
                        "latitude": "18.91937000",
                        "longitude": "-104.06873000"
                    },
                    {
                        "id": 69911,
                        "name": "El Colomo",
                        "latitude": "19.06101000",
                        "longitude": "-104.25853000"
                    },
                    {
                        "id": 70059,
                        "name": "El Naranjo",
                        "latitude": "19.13016000",
                        "longitude": "-104.41821000"
                    },
                    {
                        "id": 70233,
                        "name": "El Trapiche",
                        "latitude": "19.27787000",
                        "longitude": "-103.66090000"
                    },
                    {
                        "id": 70942,
                        "name": "Ixtlahuacán",
                        "latitude": "19.00119000",
                        "longitude": "-103.73638000"
                    },
                    {
                        "id": 70972,
                        "name": "Jalipa",
                        "latitude": "19.12275000",
                        "longitude": "-104.26737000"
                    },
                    {
                        "id": 71212,
                        "name": "La Central",
                        "latitude": "19.14276000",
                        "longitude": "-104.43819000"
                    },
                    {
                        "id": 71862,
                        "name": "Los Tepames",
                        "latitude": "19.09389000",
                        "longitude": "-103.62250000"
                    },
                    {
                        "id": 71918,
                        "name": "Madrid",
                        "latitude": "19.08459000",
                        "longitude": "-103.87123000"
                    },
                    {
                        "id": 153374,
                        "name": "Manzanillo",
                        "latitude": "19.11360000",
                        "longitude": "-104.34600000"
                    },
                    {
                        "id": 72146,
                        "name": "Minatitlán",
                        "latitude": "19.36667000",
                        "longitude": "-104.06667000"
                    },
                    {
                        "id": 72787,
                        "name": "Piscila",
                        "latitude": "19.15889000",
                        "longitude": "-103.70105000"
                    },
                    {
                        "id": 72933,
                        "name": "Pueblo Juárez (La Magdalena)",
                        "latitude": "19.16722000",
                        "longitude": "-103.93111000"
                    },
                    {
                        "id": 73026,
                        "name": "Quesería",
                        "latitude": "19.38708000",
                        "longitude": "-103.57243000"
                    },
                    {
                        "id": 73130,
                        "name": "Rincón de López",
                        "latitude": "19.05308000",
                        "longitude": "-103.93241000"
                    },
                    {
                        "id": 75142,
                        "name": "Suchitlán",
                        "latitude": "19.37541000",
                        "longitude": "-103.71141000"
                    },
                    {
                        "id": 75285,
                        "name": "Tecomán",
                        "latitude": "18.89473000",
                        "longitude": "-103.87345000"
                    },
                    {
                        "id": 75959,
                        "name": "Venustiano Carranza",
                        "latitude": "19.01112000",
                        "longitude": "-104.11033000"
                    },
                    {
                        "id": 76285,
                        "name": "Zacualpan",
                        "latitude": "19.36318000",
                        "longitude": "-103.82433000"
                    }
                ]
            },
            {
                "id": 3453,
                "name": "Durango",
                "iso2": "DUR",
                "latitude": "37.27528000",
                "longitude": "-107.88006670",
                "type": "state",
                "cities": [
                    {
                        "id": 68016,
                        "name": "Abasolo",
                        "latitude": "25.31145000",
                        "longitude": "-104.65580000"
                    },
                    {
                        "id": 76400,
                        "name": "Álvaro Obregón",
                        "latitude": "25.51417000",
                        "longitude": "-103.50500000"
                    },
                    {
                        "id": 68278,
                        "name": "Antonio Amaro",
                        "latitude": "24.27684000",
                        "longitude": "-104.01873000"
                    },
                    {
                        "id": 68341,
                        "name": "Arcinas",
                        "latitude": "25.77556000",
                        "longitude": "-103.40913000"
                    },
                    {
                        "id": 68376,
                        "name": "Arturo Martínez Adame",
                        "latitude": "25.83157000",
                        "longitude": "-103.38291000"
                    },
                    {
                        "id": 68510,
                        "name": "Banco Nacional",
                        "latitude": "25.87139000",
                        "longitude": "-103.35667000"
                    },
                    {
                        "id": 68513,
                        "name": "Banderas del Águila",
                        "latitude": "23.92596000",
                        "longitude": "-105.33950000"
                    },
                    {
                        "id": 68609,
                        "name": "Bermejillo",
                        "latitude": "25.88682000",
                        "longitude": "-103.62069000"
                    },
                    {
                        "id": 68736,
                        "name": "California",
                        "latitude": "25.76090000",
                        "longitude": "-103.37556000"
                    },
                    {
                        "id": 68785,
                        "name": "Canatlán",
                        "latitude": "24.52576000",
                        "longitude": "-104.77327000"
                    },
                    {
                        "id": 68885,
                        "name": "Ceballos",
                        "latitude": "26.52580000",
                        "longitude": "-104.12950000"
                    },
                    {
                        "id": 69199,
                        "name": "Ciénega de Nuestra Señora de Guadalupe",
                        "latitude": "25.06223000",
                        "longitude": "-106.32900000"
                    },
                    {
                        "id": 69131,
                        "name": "Cieneguillas",
                        "latitude": "24.05472000",
                        "longitude": "-104.05186000"
                    },
                    {
                        "id": 69133,
                        "name": "Cinco de Febrero",
                        "latitude": "24.07657000",
                        "longitude": "-104.50467000"
                    },
                    {
                        "id": 69134,
                        "name": "Cinco de Mayo",
                        "latitude": "24.10181000",
                        "longitude": "-104.57449000"
                    },
                    {
                        "id": 69158,
                        "name": "Ciudad Guadalupe Victoria",
                        "latitude": "24.44401000",
                        "longitude": "-104.12156000"
                    },
                    {
                        "id": 69163,
                        "name": "Ciudad Lerdo",
                        "latitude": "25.53718000",
                        "longitude": "-103.52456000"
                    },
                    {
                        "id": 69575,
                        "name": "Cuauhtemoc",
                        "latitude": "24.29037000",
                        "longitude": "-103.80913000"
                    },
                    {
                        "id": 69611,
                        "name": "Cuencamé",
                        "latitude": "24.64123000",
                        "longitude": "-103.73772000"
                    },
                    {
                        "id": 69612,
                        "name": "Cuencamé de Ceniceros",
                        "latitude": "24.87116000",
                        "longitude": "-103.69731000"
                    },
                    {
                        "id": 69686,
                        "name": "Diez de Octubre",
                        "latitude": "24.72849000",
                        "longitude": "-104.63626000"
                    },
                    {
                        "id": 69835,
                        "name": "El Arenal",
                        "latitude": "24.06527000",
                        "longitude": "-104.43387000"
                    },
                    {
                        "id": 69948,
                        "name": "El Durazno",
                        "latitude": "25.47042000",
                        "longitude": "-106.92742000"
                    },
                    {
                        "id": 69986,
                        "name": "El Huarache (El Guarache)",
                        "latitude": "25.52000000",
                        "longitude": "-103.48667000"
                    },
                    {
                        "id": 70027,
                        "name": "El Lucero",
                        "latitude": "25.87830000",
                        "longitude": "-103.40209000"
                    },
                    {
                        "id": 70060,
                        "name": "El Nayar",
                        "latitude": "23.96422000",
                        "longitude": "-104.69541000"
                    },
                    {
                        "id": 70144,
                        "name": "El Rayo",
                        "latitude": "25.52112000",
                        "longitude": "-103.60821000"
                    },
                    {
                        "id": 70190,
                        "name": "El Salto",
                        "latitude": "23.77781000",
                        "longitude": "-105.36192000"
                    },
                    {
                        "id": 70256,
                        "name": "El Vergel",
                        "latitude": "25.63965000",
                        "longitude": "-103.52139000"
                    },
                    {
                        "id": 70284,
                        "name": "Emiliano Zapata",
                        "latitude": "24.44218000",
                        "longitude": "-103.88784000"
                    },
                    {
                        "id": 70325,
                        "name": "Esfuerzos Unidos",
                        "latitude": "24.82214000",
                        "longitude": "-104.99000000"
                    },
                    {
                        "id": 70326,
                        "name": "Esmeralda",
                        "latitude": "25.74326000",
                        "longitude": "-103.43097000"
                    },
                    {
                        "id": 70379,
                        "name": "Eureka de Media Luna (Eureka)",
                        "latitude": "25.79889000",
                        "longitude": "-103.37361000"
                    },
                    {
                        "id": 70399,
                        "name": "Felipe Carrillo Puerto",
                        "latitude": "24.33305000",
                        "longitude": "-104.01105000"
                    },
                    {
                        "id": 70467,
                        "name": "Francisco I. Madero",
                        "latitude": "24.40091000",
                        "longitude": "-104.31980000"
                    },
                    {
                        "id": 70502,
                        "name": "Gabriel Hernández (Mancinas)",
                        "latitude": "23.81167000",
                        "longitude": "-104.02444000"
                    },
                    {
                        "id": 70527,
                        "name": "General Calixto Contreras",
                        "latitude": "24.42916000",
                        "longitude": "-104.04592000"
                    },
                    {
                        "id": 70540,
                        "name": "General Lázaro Cárdenas",
                        "latitude": "25.29372000",
                        "longitude": "-103.99800000"
                    },
                    {
                        "id": 70646,
                        "name": "Gómez Palacio",
                        "latitude": "25.56985000",
                        "longitude": "-103.49588000"
                    },
                    {
                        "id": 70616,
                        "name": "Guanaceví",
                        "latitude": "25.99610000",
                        "longitude": "-106.10898000"
                    },
                    {
                        "id": 70623,
                        "name": "Guatimapé",
                        "latitude": "24.80733000",
                        "longitude": "-104.91994000"
                    },
                    {
                        "id": 70686,
                        "name": "Hidalgo",
                        "latitude": "26.02409000",
                        "longitude": "-104.82823000"
                    },
                    {
                        "id": 70837,
                        "name": "Ignacio Allende",
                        "latitude": "24.47432000",
                        "longitude": "-103.99710000"
                    },
                    {
                        "id": 70846,
                        "name": "Ignacio Ramírez",
                        "latitude": "24.50796000",
                        "longitude": "-104.08751000"
                    },
                    {
                        "id": 70851,
                        "name": "Ignacio Zaragoza",
                        "latitude": "25.13643000",
                        "longitude": "-103.38430000"
                    },
                    {
                        "id": 70872,
                        "name": "Indé",
                        "latitude": "25.91248000",
                        "longitude": "-105.22319000"
                    },
                    {
                        "id": 71010,
                        "name": "Jauja",
                        "latitude": "25.92894000",
                        "longitude": "-103.37382000"
                    },
                    {
                        "id": 71050,
                        "name": "Jiménez",
                        "latitude": "25.83051000",
                        "longitude": "-103.35733000"
                    },
                    {
                        "id": 71092,
                        "name": "José Guadalupe Aguilera (Santa Lucía)",
                        "latitude": "24.45420000",
                        "longitude": "-104.70888000"
                    },
                    {
                        "id": 71093,
                        "name": "José Guadalupe Rodríguez",
                        "latitude": "24.31912000",
                        "longitude": "-104.08002000"
                    },
                    {
                        "id": 71100,
                        "name": "José María Morelos",
                        "latitude": "25.01270000",
                        "longitude": "-105.20882000"
                    },
                    {
                        "id": 71109,
                        "name": "José María Pino Suárez",
                        "latitude": "23.87733000",
                        "longitude": "-104.49104000"
                    },
                    {
                        "id": 71111,
                        "name": "José Refugio Salcido",
                        "latitude": "23.96444000",
                        "longitude": "-104.51806000"
                    },
                    {
                        "id": 71117,
                        "name": "Juan E. García",
                        "latitude": "25.49206000",
                        "longitude": "-103.69170000"
                    },
                    {
                        "id": 71215,
                        "name": "La Ciudad",
                        "latitude": "23.73052000",
                        "longitude": "-105.68882000"
                    },
                    {
                        "id": 71291,
                        "name": "La Flor",
                        "latitude": "25.68138000",
                        "longitude": "-103.36837000"
                    },
                    {
                        "id": 71305,
                        "name": "La Goma",
                        "latitude": "25.48460000",
                        "longitude": "-103.68884000"
                    },
                    {
                        "id": 71332,
                        "name": "La Joya",
                        "latitude": "23.83750000",
                        "longitude": "-103.99861000"
                    },
                    {
                        "id": 71364,
                        "name": "La Loma",
                        "latitude": "25.46401000",
                        "longitude": "-103.67351000"
                    },
                    {
                        "id": 71373,
                        "name": "La Luz",
                        "latitude": "25.63481000",
                        "longitude": "-103.61093000"
                    },
                    {
                        "id": 71455,
                        "name": "La Popular",
                        "latitude": "25.67951000",
                        "longitude": "-103.46621000"
                    },
                    {
                        "id": 71595,
                        "name": "Las Cuevas",
                        "latitude": "25.49815000",
                        "longitude": "-103.54950000"
                    },
                    {
                        "id": 71667,
                        "name": "León Guzmán",
                        "latitude": "25.49986000",
                        "longitude": "-103.65924000"
                    },
                    {
                        "id": 71687,
                        "name": "Llano Grande",
                        "latitude": "23.86367000",
                        "longitude": "-105.20558000"
                    },
                    {
                        "id": 71769,
                        "name": "Los Angeles",
                        "latitude": "25.52206000",
                        "longitude": "-103.56757000"
                    },
                    {
                        "id": 71978,
                        "name": "Mapimí",
                        "latitude": "26.19095000",
                        "longitude": "-104.05463000"
                    },
                    {
                        "id": 72107,
                        "name": "Mezquital",
                        "latitude": "22.88401000",
                        "longitude": "-104.55350000"
                    },
                    {
                        "id": 72286,
                        "name": "Narciso Mendoza",
                        "latitude": "24.01310000",
                        "longitude": "-103.96620000"
                    },
                    {
                        "id": 72299,
                        "name": "Nazareno",
                        "latitude": "25.39916000",
                        "longitude": "-103.42065000"
                    },
                    {
                        "id": 72301,
                        "name": "Nazas",
                        "latitude": "25.22462000",
                        "longitude": "-104.11458000"
                    },
                    {
                        "id": 72324,
                        "name": "Nicolás Bravo",
                        "latitude": "24.39010000",
                        "longitude": "-104.74374000"
                    },
                    {
                        "id": 72341,
                        "name": "Nogales",
                        "latitude": "24.98130000",
                        "longitude": "-104.72229000"
                    },
                    {
                        "id": 72343,
                        "name": "Nombre de Dios",
                        "latitude": "23.84891000",
                        "longitude": "-104.24712000"
                    },
                    {
                        "id": 72387,
                        "name": "Nuevo Ideal",
                        "latitude": "24.88544000",
                        "longitude": "-105.07552000"
                    },
                    {
                        "id": 72442,
                        "name": "Ocampo",
                        "latitude": "26.55251000",
                        "longitude": "-105.75999000"
                    },
                    {
                        "id": 72528,
                        "name": "Orizaba",
                        "latitude": "23.95750000",
                        "longitude": "-104.07389000"
                    },
                    {
                        "id": 73008,
                        "name": "Pánuco de Coronado",
                        "latitude": "24.53972000",
                        "longitude": "-104.32707000"
                    },
                    {
                        "id": 72666,
                        "name": "Pasaje",
                        "latitude": "24.92775000",
                        "longitude": "-103.80746000"
                    },
                    {
                        "id": 72683,
                        "name": "Paso Nacional",
                        "latitude": "25.26311000",
                        "longitude": "-104.01941000"
                    },
                    {
                        "id": 72701,
                        "name": "Pastor Rovaix",
                        "latitude": "25.68230000",
                        "longitude": "-103.51019000"
                    },
                    {
                        "id": 72723,
                        "name": "Pedriceña",
                        "latitude": "25.11858000",
                        "longitude": "-103.78942000"
                    },
                    {
                        "id": 72758,
                        "name": "Picardías",
                        "latitude": "25.32466000",
                        "longitude": "-103.48588000"
                    },
                    {
                        "id": 72943,
                        "name": "Pueblo Nuevo",
                        "latitude": "23.41405000",
                        "longitude": "-105.34021000"
                    },
                    {
                        "id": 73051,
                        "name": "Ramón Corona",
                        "latitude": "24.18611000",
                        "longitude": "-103.63028000"
                    },
                    {
                        "id": 73108,
                        "name": "Ricardo Flores Magón",
                        "latitude": "24.46250000",
                        "longitude": "-104.53040000"
                    },
                    {
                        "id": 73146,
                        "name": "Rodeo",
                        "latitude": "25.17860000",
                        "longitude": "-104.55950000"
                    },
                    {
                        "id": 73392,
                        "name": "San Atenógenes (La Villita)",
                        "latitude": "23.99056000",
                        "longitude": "-104.01722000"
                    },
                    {
                        "id": 73437,
                        "name": "San Bernardino de Milpillas Chico",
                        "latitude": "23.38463000",
                        "longitude": "-105.15314000"
                    },
                    {
                        "id": 73440,
                        "name": "San Bernardo",
                        "latitude": "26.16986000",
                        "longitude": "-105.66251000"
                    },
                    {
                        "id": 73512,
                        "name": "San Felipe",
                        "latitude": "25.69278000",
                        "longitude": "-103.38250000"
                    },
                    {
                        "id": 73613,
                        "name": "San Francisco de Horizonte (Horizonte)",
                        "latitude": "25.93690000",
                        "longitude": "-103.41688000"
                    },
                    {
                        "id": 73619,
                        "name": "San Francisco del Mezquital",
                        "latitude": "23.47444000",
                        "longitude": "-104.39490000"
                    },
                    {
                        "id": 73571,
                        "name": "San Francisco Javier",
                        "latitude": "23.72572000",
                        "longitude": "-104.03371000"
                    },
                    {
                        "id": 73694,
                        "name": "San Jacinto",
                        "latitude": "25.48030000",
                        "longitude": "-103.73750000"
                    },
                    {
                        "id": 73816,
                        "name": "San José de Gracia",
                        "latitude": "24.47510000",
                        "longitude": "-104.74189000"
                    },
                    {
                        "id": 73827,
                        "name": "San José de Viñedo",
                        "latitude": "25.64865000",
                        "longitude": "-103.40255000"
                    },
                    {
                        "id": 73828,
                        "name": "San José de Zaragoza",
                        "latitude": "25.22753000",
                        "longitude": "-103.46650000"
                    },
                    {
                        "id": 73961,
                        "name": "San Juan de Guadalupe",
                        "latitude": "24.63273000",
                        "longitude": "-102.78180000"
                    },
                    {
                        "id": 73975,
                        "name": "San Juan del Rio del Centauro del Norte",
                        "latitude": "24.77824000",
                        "longitude": "-104.45833000"
                    },
                    {
                        "id": 73984,
                        "name": "San Julio",
                        "latitude": "25.93639000",
                        "longitude": "-103.42083000"
                    },
                    {
                        "id": 74229,
                        "name": "San Miguel de Cruces",
                        "latitude": "24.41255000",
                        "longitude": "-105.84152000"
                    },
                    {
                        "id": 74411,
                        "name": "San Pedro del Gallo",
                        "latitude": "25.56411000",
                        "longitude": "-104.29284000"
                    },
                    {
                        "id": 74593,
                        "name": "Santa Catarina de Tepehuanes",
                        "latitude": "25.33961000",
                        "longitude": "-105.72445000"
                    },
                    {
                        "id": 74598,
                        "name": "Santa Clara",
                        "latitude": "24.47500000",
                        "longitude": "-103.35694000"
                    },
                    {
                        "id": 74628,
                        "name": "Santa Cruz Luján",
                        "latitude": "25.72478000",
                        "longitude": "-103.35860000"
                    },
                    {
                        "id": 74814,
                        "name": "Santa María del Oro",
                        "latitude": "25.94944000",
                        "longitude": "-105.36444000"
                    },
                    {
                        "id": 74883,
                        "name": "Santiago Bayacora",
                        "latitude": "23.89373000",
                        "longitude": "-104.61276000"
                    },
                    {
                        "id": 74935,
                        "name": "Santiago Papasquiaro",
                        "latitude": "25.04389000",
                        "longitude": "-105.41917000"
                    },
                    {
                        "id": 75039,
                        "name": "Sapioris",
                        "latitude": "25.45248000",
                        "longitude": "-103.71612000"
                    },
                    {
                        "id": 75051,
                        "name": "Sebastián Lerdo de Tejada",
                        "latitude": "23.95444000",
                        "longitude": "-104.63639000"
                    },
                    {
                        "id": 75056,
                        "name": "Seis de Enero",
                        "latitude": "25.52052000",
                        "longitude": "-103.60150000"
                    },
                    {
                        "id": 75057,
                        "name": "Seis de Octubre",
                        "latitude": "25.81361000",
                        "longitude": "-103.57333000"
                    },
                    {
                        "id": 75155,
                        "name": "Súchil",
                        "latitude": "23.62193000",
                        "longitude": "-103.92320000"
                    },
                    {
                        "id": 75180,
                        "name": "Tamazula",
                        "latitude": "25.05586000",
                        "longitude": "-106.76728000"
                    },
                    {
                        "id": 75181,
                        "name": "Tamazula de Victoria",
                        "latitude": "24.96818000",
                        "longitude": "-106.96717000"
                    },
                    {
                        "id": 75249,
                        "name": "Tayoltita",
                        "latitude": "24.10278000",
                        "longitude": "-105.93083000"
                    },
                    {
                        "id": 75409,
                        "name": "Tepehuanes",
                        "latitude": "25.47838000",
                        "longitude": "-106.20884000"
                    },
                    {
                        "id": 75627,
                        "name": "Tlahualilo de Zaragoza",
                        "latitude": "26.10593000",
                        "longitude": "-103.44257000"
                    },
                    {
                        "id": 75743,
                        "name": "Topia",
                        "latitude": "25.21090000",
                        "longitude": "-106.57134000"
                    },
                    {
                        "id": 75767,
                        "name": "Transporte",
                        "latitude": "25.63411000",
                        "longitude": "-103.54070000"
                    },
                    {
                        "id": 75950,
                        "name": "Velardeña",
                        "latitude": "25.06472000",
                        "longitude": "-103.73668000"
                    },
                    {
                        "id": 75952,
                        "name": "Venecia",
                        "latitude": "25.77844000",
                        "longitude": "-103.35266000"
                    },
                    {
                        "id": 75962,
                        "name": "Venustiano Carranza",
                        "latitude": "24.47158000",
                        "longitude": "-104.62630000"
                    },
                    {
                        "id": 75977,
                        "name": "Vicente Guerrero",
                        "latitude": "23.73429000",
                        "longitude": "-103.98487000"
                    },
                    {
                        "id": 75985,
                        "name": "Victoria de Durango",
                        "latitude": "24.02032000",
                        "longitude": "-104.65756000"
                    },
                    {
                        "id": 76065,
                        "name": "Villa de Guadalupe",
                        "latitude": "25.51444000",
                        "longitude": "-103.48917000"
                    },
                    {
                        "id": 76004,
                        "name": "Villa Gregorio García",
                        "latitude": "25.75221000",
                        "longitude": "-103.35215000"
                    },
                    {
                        "id": 76015,
                        "name": "Villa Hidalgo",
                        "latitude": "26.24833000",
                        "longitude": "-104.91441000"
                    },
                    {
                        "id": 76022,
                        "name": "Villa Juárez",
                        "latitude": "25.49203000",
                        "longitude": "-103.59389000"
                    },
                    {
                        "id": 76035,
                        "name": "Villa Montemorelos",
                        "latitude": "23.99154000",
                        "longitude": "-104.48045000"
                    },
                    {
                        "id": 76039,
                        "name": "Villa Ocampo",
                        "latitude": "26.44085000",
                        "longitude": "-105.50640000"
                    },
                    {
                        "id": 76053,
                        "name": "Villa Unión",
                        "latitude": "23.97460000",
                        "longitude": "-104.04705000"
                    }
                ]
            },
            {
                "id": 3450,
                "name": "Estado de México",
                "iso2": "MEX",
                "latitude": "23.63450100",
                "longitude": "-102.55278400",
                "type": "state",
                "cities": [
                    {
                        "id": 68023,
                        "name": "Acachuén",
                        "latitude": "19.84715000",
                        "longitude": "-102.09272000"
                    },
                    {
                        "id": 68031,
                        "name": "Acalpican de Morelos",
                        "latitude": "18.01854000",
                        "longitude": "-102.34033000"
                    },
                    {
                        "id": 68032,
                        "name": "Acambay",
                        "latitude": "19.95522000",
                        "longitude": "-99.84428000"
                    },
                    {
                        "id": 68054,
                        "name": "Acatzingo (Acatzingo de la Piedra)",
                        "latitude": "18.92389000",
                        "longitude": "-99.58861000"
                    },
                    {
                        "id": 68063,
                        "name": "Acolman de Netzahualcóyotl",
                        "latitude": "19.63976000",
                        "longitude": "-98.90777000"
                    },
                    {
                        "id": 68079,
                        "name": "Acuitlapilco",
                        "latitude": "18.90873000",
                        "longitude": "-99.78464000"
                    },
                    {
                        "id": 68082,
                        "name": "Aculco de Espinoza",
                        "latitude": "20.09867000",
                        "longitude": "-99.82757000"
                    },
                    {
                        "id": 68104,
                        "name": "Agua Blanca",
                        "latitude": "19.22056000",
                        "longitude": "-99.47056000"
                    },
                    {
                        "id": 68107,
                        "name": "Agua Caliente",
                        "latitude": "19.90011000",
                        "longitude": "-100.17186000"
                    },
                    {
                        "id": 68111,
                        "name": "Agua Escondida",
                        "latitude": "19.97893000",
                        "longitude": "-99.57829000"
                    },
                    {
                        "id": 68133,
                        "name": "Ahuacatitlán",
                        "latitude": "18.89414000",
                        "longitude": "-99.70867000"
                    },
                    {
                        "id": 68134,
                        "name": "Ahuacatitlán Cuarto y Quinto Cuartel",
                        "latitude": "19.96222000",
                        "longitude": "-99.98694000"
                    },
                    {
                        "id": 68178,
                        "name": "Alborada Jaltenco",
                        "latitude": "19.66194000",
                        "longitude": "-99.06889000"
                    },
                    {
                        "id": 68215,
                        "name": "Almoloya de Alquisiras",
                        "latitude": "18.84217000",
                        "longitude": "-99.86416000"
                    },
                    {
                        "id": 68216,
                        "name": "Almoloya del Río",
                        "latitude": "19.16046000",
                        "longitude": "-99.48740000"
                    },
                    {
                        "id": 68235,
                        "name": "Amanalco de Becerra",
                        "latitude": "19.31667000",
                        "longitude": "-100.01667000"
                    },
                    {
                        "id": 68239,
                        "name": "Amatepec",
                        "latitude": "18.68222000",
                        "longitude": "-100.18583000"
                    },
                    {
                        "id": 68252,
                        "name": "Amecameca",
                        "latitude": "19.12384000",
                        "longitude": "-98.76649000"
                    },
                    {
                        "id": 68260,
                        "name": "Ampliación San Mateo (Colonia Solidaridad)",
                        "latitude": "19.61639000",
                        "longitude": "-99.14722000"
                    },
                    {
                        "id": 68261,
                        "name": "Ampliación Tezoyuca",
                        "latitude": "19.58057000",
                        "longitude": "-98.92053000"
                    },
                    {
                        "id": 68301,
                        "name": "Apaxco de Ocampo",
                        "latitude": "19.97512000",
                        "longitude": "-99.17112000"
                    },
                    {
                        "id": 68334,
                        "name": "Arbolada los Sauces",
                        "latitude": "19.81583000",
                        "longitude": "-99.04417000"
                    },
                    {
                        "id": 68346,
                        "name": "Arenal",
                        "latitude": "19.38111000",
                        "longitude": "-98.94278000"
                    },
                    {
                        "id": 68400,
                        "name": "Atenguillo",
                        "latitude": "19.56361000",
                        "longitude": "-98.87639000"
                    },
                    {
                        "id": 68407,
                        "name": "Atizapán",
                        "latitude": "19.25000000",
                        "longitude": "-99.55000000"
                    },
                    {
                        "id": 68411,
                        "name": "Atlacomulco de Fabela",
                        "latitude": "19.79919000",
                        "longitude": "-99.87500000"
                    },
                    {
                        "id": 68418,
                        "name": "Atlatongo",
                        "latitude": "19.66776000",
                        "longitude": "-98.90402000"
                    },
                    {
                        "id": 68419,
                        "name": "Atlautla",
                        "latitude": "19.02188000",
                        "longitude": "-98.77859000"
                    },
                    {
                        "id": 68448,
                        "name": "Axapusco",
                        "latitude": "19.72456000",
                        "longitude": "-98.75863000"
                    },
                    {
                        "id": 68453,
                        "name": "Axotlán",
                        "latitude": "19.69417000",
                        "longitude": "-99.23944000"
                    },
                    {
                        "id": 68461,
                        "name": "Ayapango",
                        "latitude": "19.12692000",
                        "longitude": "-98.79988000"
                    },
                    {
                        "id": 68525,
                        "name": "Barrio Bordo Nuevo",
                        "latitude": "19.37917000",
                        "longitude": "-99.67333000"
                    },
                    {
                        "id": 68526,
                        "name": "Barrio Chiquichuca",
                        "latitude": "19.32139000",
                        "longitude": "-100.21278000"
                    },
                    {
                        "id": 68527,
                        "name": "Barrio Cuarto (La Loma)",
                        "latitude": "19.76861000",
                        "longitude": "-99.67694000"
                    },
                    {
                        "id": 68536,
                        "name": "Barrio de Arriba de San Juan Xoconusco",
                        "latitude": "19.32040000",
                        "longitude": "-100.27020000"
                    },
                    {
                        "id": 68537,
                        "name": "Barrio de Boyecha",
                        "latitude": "19.70778000",
                        "longitude": "-99.68444000"
                    },
                    {
                        "id": 68538,
                        "name": "Barrio de Canales",
                        "latitude": "19.37333000",
                        "longitude": "-99.37556000"
                    },
                    {
                        "id": 68539,
                        "name": "Barrio de Centro del Cerrillo",
                        "latitude": "19.53694000",
                        "longitude": "-99.95417000"
                    },
                    {
                        "id": 68540,
                        "name": "Barrio de Ensido",
                        "latitude": "19.49389000",
                        "longitude": "-99.37444000"
                    },
                    {
                        "id": 68541,
                        "name": "Barrio de España",
                        "latitude": "19.86139000",
                        "longitude": "-99.08167000"
                    },
                    {
                        "id": 68542,
                        "name": "Barrio de Guadalupe",
                        "latitude": "19.23054000",
                        "longitude": "-98.93090000"
                    },
                    {
                        "id": 68544,
                        "name": "Barrio de Jesús Fracción Primera",
                        "latitude": "19.36778000",
                        "longitude": "-99.68694000"
                    },
                    {
                        "id": 68554,
                        "name": "Barrio de la Barranca",
                        "latitude": "19.43583000",
                        "longitude": "-99.55833000"
                    },
                    {
                        "id": 68545,
                        "name": "Barrio de México",
                        "latitude": "19.28250000",
                        "longitude": "-99.82833000"
                    },
                    {
                        "id": 68547,
                        "name": "Barrio de Puentecillas",
                        "latitude": "19.53558000",
                        "longitude": "-99.98463000"
                    },
                    {
                        "id": 68548,
                        "name": "Barrio de San Isidro",
                        "latitude": "19.52139000",
                        "longitude": "-99.95861000"
                    },
                    {
                        "id": 68549,
                        "name": "Barrio de San Juan",
                        "latitude": "19.41420000",
                        "longitude": "-99.53717000"
                    },
                    {
                        "id": 68551,
                        "name": "Barrio de San Miguel",
                        "latitude": "19.51232000",
                        "longitude": "-99.95467000"
                    },
                    {
                        "id": 68552,
                        "name": "Barrio de San Pedro la Cabecera",
                        "latitude": "19.56528000",
                        "longitude": "-99.75000000"
                    },
                    {
                        "id": 68553,
                        "name": "Barrio de San Ramón",
                        "latitude": "19.37361000",
                        "longitude": "-99.33111000"
                    },
                    {
                        "id": 68555,
                        "name": "Barrio del Cajón",
                        "latitude": "19.39139000",
                        "longitude": "-99.65806000"
                    },
                    {
                        "id": 68556,
                        "name": "Barrio el Boncho",
                        "latitude": "19.42611000",
                        "longitude": "-100.10639000"
                    },
                    {
                        "id": 68557,
                        "name": "Barrio el Vivero",
                        "latitude": "19.45306000",
                        "longitude": "-100.03528000"
                    },
                    {
                        "id": 68558,
                        "name": "Barrio la Joya",
                        "latitude": "19.42000000",
                        "longitude": "-100.09972000"
                    },
                    {
                        "id": 68559,
                        "name": "Barrio la Tenería",
                        "latitude": "19.69361000",
                        "longitude": "-99.79194000"
                    },
                    {
                        "id": 68560,
                        "name": "Barrio los Tules",
                        "latitude": "19.42917000",
                        "longitude": "-100.07472000"
                    },
                    {
                        "id": 68531,
                        "name": "Barrio San Joaquín el Junco",
                        "latitude": "19.56417000",
                        "longitude": "-99.77333000"
                    },
                    {
                        "id": 68532,
                        "name": "Barrio San Miguel Dorami",
                        "latitude": "19.44622000",
                        "longitude": "-99.34296000"
                    },
                    {
                        "id": 68533,
                        "name": "Barrio Santa Cruz",
                        "latitude": "19.35139000",
                        "longitude": "-99.66278000"
                    },
                    {
                        "id": 68534,
                        "name": "Barrio Tepetitlán Emilio Portes Gil",
                        "latitude": "19.65306000",
                        "longitude": "-99.88667000"
                    },
                    {
                        "id": 68535,
                        "name": "Barrio Tlatenco",
                        "latitude": "19.73917000",
                        "longitude": "-99.19167000"
                    },
                    {
                        "id": 68571,
                        "name": "Bejucos",
                        "latitude": "18.77802000",
                        "longitude": "-100.42778000"
                    },
                    {
                        "id": 68572,
                        "name": "Belem",
                        "latitude": "19.63334000",
                        "longitude": "-98.79664000"
                    },
                    {
                        "id": 68595,
                        "name": "Benito Juárez",
                        "latitude": "19.43765000",
                        "longitude": "-99.85384000"
                    },
                    {
                        "id": 68620,
                        "name": "Bobashi de Guadalupe",
                        "latitude": "19.87583000",
                        "longitude": "-99.91167000"
                    },
                    {
                        "id": 68642,
                        "name": "Boshindó",
                        "latitude": "19.91922000",
                        "longitude": "-99.84075000"
                    },
                    {
                        "id": 68645,
                        "name": "Bosques de la Magdalena",
                        "latitude": "19.35778000",
                        "longitude": "-98.94750000"
                    },
                    {
                        "id": 68670,
                        "name": "Buenavista",
                        "latitude": "19.60833000",
                        "longitude": "-99.16944000"
                    },
                    {
                        "id": 68687,
                        "name": "Buenos Aires",
                        "latitude": "19.61745000",
                        "longitude": "-99.66790000"
                    },
                    {
                        "id": 68701,
                        "name": "Cabecera de Indígenas",
                        "latitude": "19.37213000",
                        "longitude": "-100.13667000"
                    },
                    {
                        "id": 68709,
                        "name": "Cacalomacan",
                        "latitude": "19.25311000",
                        "longitude": "-99.70623000"
                    },
                    {
                        "id": 68721,
                        "name": "Caja de Agua",
                        "latitude": "19.64329000",
                        "longitude": "-99.36497000"
                    },
                    {
                        "id": 68738,
                        "name": "Calimaya",
                        "latitude": "19.16324000",
                        "longitude": "-99.61810000"
                    },
                    {
                        "id": 68740,
                        "name": "Calixtlahuaca",
                        "latitude": "19.33651000",
                        "longitude": "-99.68923000"
                    },
                    {
                        "id": 68750,
                        "name": "Calvario Buenavista",
                        "latitude": "19.70387000",
                        "longitude": "-99.95674000"
                    },
                    {
                        "id": 68751,
                        "name": "Calvario del Carmen",
                        "latitude": "19.63562000",
                        "longitude": "-100.01030000"
                    },
                    {
                        "id": 68876,
                        "name": "Cañada de Cisneros",
                        "latitude": "19.69534000",
                        "longitude": "-99.33570000"
                    },
                    {
                        "id": 68877,
                        "name": "Cañada de Guadarrama",
                        "latitude": "19.31272000",
                        "longitude": "-99.78972000"
                    },
                    {
                        "id": 68783,
                        "name": "Canalejas",
                        "latitude": "19.97867000",
                        "longitude": "-99.60548000"
                    },
                    {
                        "id": 68808,
                        "name": "Capula",
                        "latitude": "18.87018000",
                        "longitude": "-99.96075000"
                    },
                    {
                        "id": 68811,
                        "name": "Capulhuac de Mirafuentes",
                        "latitude": "19.19354000",
                        "longitude": "-99.46585000"
                    },
                    {
                        "id": 68815,
                        "name": "Carapán",
                        "latitude": "19.86003000",
                        "longitude": "-102.03644000"
                    },
                    {
                        "id": 68849,
                        "name": "Casa Nueva",
                        "latitude": "19.83333000",
                        "longitude": "-99.20944000"
                    },
                    {
                        "id": 68854,
                        "name": "Casas Viejas",
                        "latitude": "19.15167000",
                        "longitude": "-100.10778000"
                    },
                    {
                        "id": 68855,
                        "name": "Caserío de Cortés",
                        "latitude": "19.19861000",
                        "longitude": "-98.95444000"
                    },
                    {
                        "id": 68887,
                        "name": "Cedro de la Manzana",
                        "latitude": "19.69213000",
                        "longitude": "-100.11656000"
                    },
                    {
                        "id": 68892,
                        "name": "Celayita",
                        "latitude": "20.24113000",
                        "longitude": "-99.86142000"
                    },
                    {
                        "id": 68919,
                        "name": "Cerritos del Pilar",
                        "latitude": "19.44508000",
                        "longitude": "-100.01909000"
                    },
                    {
                        "id": 68935,
                        "name": "Cerro de San Francisco",
                        "latitude": "19.37038000",
                        "longitude": "-99.35162000"
                    },
                    {
                        "id": 68939,
                        "name": "Cerro del Murciélago",
                        "latitude": "19.28194000",
                        "longitude": "-99.75472000"
                    },
                    {
                        "id": 68931,
                        "name": "Cerro La Calera",
                        "latitude": "19.18333000",
                        "longitude": "-99.81667000"
                    },
                    {
                        "id": 68957,
                        "name": "Chalchihuapan",
                        "latitude": "18.97694000",
                        "longitude": "-99.57472000"
                    },
                    {
                        "id": 68962,
                        "name": "Chalco",
                        "latitude": "19.26174000",
                        "longitude": "-98.89775000"
                    },
                    {
                        "id": 68963,
                        "name": "Chalma",
                        "latitude": "18.93048000",
                        "longitude": "-99.43505000"
                    },
                    {
                        "id": 68965,
                        "name": "Chalmita",
                        "latitude": "18.93433000",
                        "longitude": "-99.42325000"
                    },
                    {
                        "id": 68977,
                        "name": "Chapa de Mota",
                        "latitude": "19.82420000",
                        "longitude": "-99.55252000"
                    },
                    {
                        "id": 68982,
                        "name": "Chaparaco",
                        "latitude": "19.96061000",
                        "longitude": "-102.26092000"
                    },
                    {
                        "id": 68990,
                        "name": "Chapultepec",
                        "latitude": "19.20216000",
                        "longitude": "-99.56176000"
                    },
                    {
                        "id": 69013,
                        "name": "Chiautla",
                        "latitude": "19.54895000",
                        "longitude": "-98.88236000"
                    },
                    {
                        "id": 69036,
                        "name": "Chicoloapan",
                        "latitude": "19.41687000",
                        "longitude": "-98.90202000"
                    },
                    {
                        "id": 69040,
                        "name": "Chiconcuac",
                        "latitude": "19.55939000",
                        "longitude": "-98.89884000"
                    },
                    {
                        "id": 69066,
                        "name": "Chilchota",
                        "latitude": "19.84654000",
                        "longitude": "-102.11716000"
                    },
                    {
                        "id": 69073,
                        "name": "Chiltepec de Hidalgo",
                        "latitude": "18.91266000",
                        "longitude": "-99.83450000"
                    },
                    {
                        "id": 69077,
                        "name": "Chimalpa Viejo",
                        "latitude": "19.44956000",
                        "longitude": "-99.34435000"
                    },
                    {
                        "id": 69108,
                        "name": "Chosto de los Jarros",
                        "latitude": "19.86333000",
                        "longitude": "-99.91000000"
                    },
                    {
                        "id": 69165,
                        "name": "Ciudad López Mateos",
                        "latitude": "19.55793000",
                        "longitude": "-99.25675000"
                    },
                    {
                        "id": 69173,
                        "name": "Ciudad Nezahualcoyotl",
                        "latitude": "19.40061000",
                        "longitude": "-99.01483000"
                    },
                    {
                        "id": 69203,
                        "name": "Coacalco",
                        "latitude": "19.62923000",
                        "longitude": "-99.10689000"
                    },
                    {
                        "id": 69221,
                        "name": "Coamilpa de Juárez",
                        "latitude": "19.19778000",
                        "longitude": "-99.44361000"
                    },
                    {
                        "id": 69225,
                        "name": "Coatepec",
                        "latitude": "19.38485000",
                        "longitude": "-98.84546000"
                    },
                    {
                        "id": 69228,
                        "name": "Coatepec Harinas",
                        "latitude": "18.89492000",
                        "longitude": "-99.72153000"
                    },
                    {
                        "id": 69239,
                        "name": "Cocotitlán",
                        "latitude": "19.23336000",
                        "longitude": "-98.86596000"
                    },
                    {
                        "id": 69265,
                        "name": "Colonia 2 de Septiembre",
                        "latitude": "19.70056000",
                        "longitude": "-99.11667000"
                    },
                    {
                        "id": 69268,
                        "name": "Colonia 3 de Mayo",
                        "latitude": "18.82726000",
                        "longitude": "-99.69304000"
                    },
                    {
                        "id": 69269,
                        "name": "Colonia 3 de Mayo (La Cruz)",
                        "latitude": "19.98083000",
                        "longitude": "-99.16361000"
                    },
                    {
                        "id": 69271,
                        "name": "Colonia Adolfo López Mateos",
                        "latitude": "19.40056000",
                        "longitude": "-99.45944000"
                    },
                    {
                        "id": 69277,
                        "name": "Colonia Agrícola Álvaro Obregón",
                        "latitude": "19.22806000",
                        "longitude": "-99.55583000"
                    },
                    {
                        "id": 69274,
                        "name": "Colonia Agrícola Analco",
                        "latitude": "19.34972000",
                        "longitude": "-99.47500000"
                    },
                    {
                        "id": 69405,
                        "name": "Colonia Álvaro Obregón",
                        "latitude": "19.37691000",
                        "longitude": "-99.49484000"
                    },
                    {
                        "id": 69281,
                        "name": "Colonia Arboledas (San Andrés)",
                        "latitude": "19.20250000",
                        "longitude": "-99.58083000"
                    },
                    {
                        "id": 69282,
                        "name": "Colonia Aviación Autopan",
                        "latitude": "19.37917000",
                        "longitude": "-99.69278000"
                    },
                    {
                        "id": 69283,
                        "name": "Colonia Azteca",
                        "latitude": "19.07806000",
                        "longitude": "-99.65417000"
                    },
                    {
                        "id": 69284,
                        "name": "Colonia Bellavista",
                        "latitude": "19.29820000",
                        "longitude": "-99.80879000"
                    },
                    {
                        "id": 69290,
                        "name": "Colonia Cuauhtémoc",
                        "latitude": "19.25122000",
                        "longitude": "-99.79717000"
                    },
                    {
                        "id": 69292,
                        "name": "Colonia Doctor Gustavo Baz",
                        "latitude": "19.41056000",
                        "longitude": "-99.92167000"
                    },
                    {
                        "id": 69385,
                        "name": "Colonia el Mirador",
                        "latitude": "19.67167000",
                        "longitude": "-99.35722000"
                    },
                    {
                        "id": 69388,
                        "name": "Colonia el Pirame",
                        "latitude": "19.24083000",
                        "longitude": "-99.47194000"
                    },
                    {
                        "id": 69389,
                        "name": "Colonia el Refugio",
                        "latitude": "19.22694000",
                        "longitude": "-99.69417000"
                    },
                    {
                        "id": 69391,
                        "name": "Colonia el Salado",
                        "latitude": "19.58389000",
                        "longitude": "-98.99139000"
                    },
                    {
                        "id": 69296,
                        "name": "Colonia Emiliano Zapata",
                        "latitude": "19.39111000",
                        "longitude": "-99.52528000"
                    },
                    {
                        "id": 69298,
                        "name": "Colonia Emiliano Zapata Ejido de Tenancingo",
                        "latitude": "18.95361000",
                        "longitude": "-99.55889000"
                    },
                    {
                        "id": 69306,
                        "name": "Colonia Guadalupe",
                        "latitude": "19.71306000",
                        "longitude": "-99.24972000"
                    },
                    {
                        "id": 69307,
                        "name": "Colonia Guadalupe Victoria",
                        "latitude": "19.49917000",
                        "longitude": "-98.91917000"
                    },
                    {
                        "id": 69308,
                        "name": "Colonia Guadalupe Victoria (La Capilla)",
                        "latitude": "19.40222000",
                        "longitude": "-99.45417000"
                    },
                    {
                        "id": 69309,
                        "name": "Colonia Gustavo Baz Prada",
                        "latitude": "19.42139000",
                        "longitude": "-99.01361000"
                    },
                    {
                        "id": 69314,
                        "name": "Colonia Isidro Fabela",
                        "latitude": "19.30056000",
                        "longitude": "-99.52278000"
                    },
                    {
                        "id": 69318,
                        "name": "Colonia Juárez",
                        "latitude": "19.99583000",
                        "longitude": "-99.14944000"
                    },
                    {
                        "id": 69392,
                        "name": "Colonia la Asunción",
                        "latitude": "19.69083000",
                        "longitude": "-99.06417000"
                    },
                    {
                        "id": 69395,
                        "name": "Colonia la Libertad",
                        "latitude": "19.18528000",
                        "longitude": "-99.50278000"
                    },
                    {
                        "id": 69325,
                        "name": "Colonia Lázaro Cárdenas",
                        "latitude": "19.51306000",
                        "longitude": "-98.92000000"
                    },
                    {
                        "id": 69326,
                        "name": "Colonia Lázaro Cárdenas (Los Hornos)",
                        "latitude": "19.63167000",
                        "longitude": "-99.15333000"
                    },
                    {
                        "id": 69322,
                        "name": "Colonia Lindavista",
                        "latitude": "19.49156000",
                        "longitude": "-99.12475000"
                    },
                    {
                        "id": 69399,
                        "name": "Colonia los Aguiluchos",
                        "latitude": "19.72611000",
                        "longitude": "-99.09028000"
                    },
                    {
                        "id": 69400,
                        "name": "Colonia los Cedros",
                        "latitude": "19.31167000",
                        "longitude": "-99.54111000"
                    },
                    {
                        "id": 69402,
                        "name": "Colonia los Remedios",
                        "latitude": "19.73444000",
                        "longitude": "-98.79111000"
                    },
                    {
                        "id": 69333,
                        "name": "Colonia Morelos",
                        "latitude": "19.63778000",
                        "longitude": "-99.33917000"
                    },
                    {
                        "id": 69346,
                        "name": "Colonia Palma",
                        "latitude": "19.56444000",
                        "longitude": "-99.42417000"
                    },
                    {
                        "id": 69354,
                        "name": "Colonia Reforma Tlalmimilolpan",
                        "latitude": "19.38806000",
                        "longitude": "-99.48889000"
                    },
                    {
                        "id": 69357,
                        "name": "Colonia Ricardo Flores Magón",
                        "latitude": "19.26833000",
                        "longitude": "-99.75833000"
                    },
                    {
                        "id": 69359,
                        "name": "Colonia Rincón Villa del Valle",
                        "latitude": "19.20966000",
                        "longitude": "-100.11917000"
                    },
                    {
                        "id": 69360,
                        "name": "Colonia Río Lerma (Tic Ti)",
                        "latitude": "19.80556000",
                        "longitude": "-99.89722000"
                    },
                    {
                        "id": 69363,
                        "name": "Colonia San Francisco de Asís",
                        "latitude": "19.57861000",
                        "longitude": "-99.75444000"
                    },
                    {
                        "id": 69368,
                        "name": "Colonia San Ramón",
                        "latitude": "18.96833000",
                        "longitude": "-99.57222000"
                    },
                    {
                        "id": 69373,
                        "name": "Colonia Tulteca Teopan",
                        "latitude": "19.56139000",
                        "longitude": "-98.84417000"
                    },
                    {
                        "id": 69379,
                        "name": "Colonia Wenceslao Labra",
                        "latitude": "19.82773000",
                        "longitude": "-99.12435000"
                    },
                    {
                        "id": 69409,
                        "name": "Colorines",
                        "latitude": "19.17829000",
                        "longitude": "-100.21817000"
                    },
                    {
                        "id": 69434,
                        "name": "Concepción Caro",
                        "latitude": "19.77139000",
                        "longitude": "-99.90917000"
                    },
                    {
                        "id": 69440,
                        "name": "Concepción del Monte",
                        "latitude": "19.65128000",
                        "longitude": "-100.15440000"
                    },
                    {
                        "id": 69438,
                        "name": "Concepción Jolalpan",
                        "latitude": "19.58399000",
                        "longitude": "-98.84643000"
                    },
                    {
                        "id": 69442,
                        "name": "Concepción la Venta",
                        "latitude": "19.69144000",
                        "longitude": "-100.15181000"
                    },
                    {
                        "id": 69448,
                        "name": "Conejeras",
                        "latitude": "20.01271000",
                        "longitude": "-99.96202000"
                    },
                    {
                        "id": 69455,
                        "name": "Conjunto Habitacional Ecológico SUTEYM",
                        "latitude": "19.36889000",
                        "longitude": "-99.77861000"
                    },
                    {
                        "id": 69458,
                        "name": "Conjunto Urbano la Loma I",
                        "latitude": "19.32639000",
                        "longitude": "-99.73194000"
                    },
                    {
                        "id": 69467,
                        "name": "Contepec",
                        "latitude": "19.95432000",
                        "longitude": "-100.16385000"
                    },
                    {
                        "id": 69501,
                        "name": "Coscomate del Progreso",
                        "latitude": "19.93416000",
                        "longitude": "-99.51902000"
                    },
                    {
                        "id": 69521,
                        "name": "Coyotepec",
                        "latitude": "19.77722000",
                        "longitude": "-99.21295000"
                    },
                    {
                        "id": 69530,
                        "name": "Cozotlán Norte",
                        "latitude": "19.70833000",
                        "longitude": "-98.86000000"
                    },
                    {
                        "id": 69552,
                        "name": "Cuadrilla de Dolores",
                        "latitude": "19.14000000",
                        "longitude": "-100.06944000"
                    },
                    {
                        "id": 69551,
                        "name": "Cuadrilla Vieja",
                        "latitude": "19.51205000",
                        "longitude": "-99.98692000"
                    },
                    {
                        "id": 69590,
                        "name": "Cuautitlán",
                        "latitude": "19.67052000",
                        "longitude": "-99.17989000"
                    },
                    {
                        "id": 69592,
                        "name": "Cuautlacingo",
                        "latitude": "19.69405000",
                        "longitude": "-98.78385000"
                    },
                    {
                        "id": 69610,
                        "name": "Cuecuecuatitla",
                        "latitude": "19.01349000",
                        "longitude": "-98.84351000"
                    },
                    {
                        "id": 69613,
                        "name": "Cuendo",
                        "latitude": "19.80028000",
                        "longitude": "-99.94778000"
                    },
                    {
                        "id": 69679,
                        "name": "Denjhi",
                        "latitude": "19.92116000",
                        "longitude": "-99.53561000"
                    },
                    {
                        "id": 69682,
                        "name": "Detiña (San Antonio Detiña)",
                        "latitude": "19.97028000",
                        "longitude": "-99.88389000"
                    },
                    {
                        "id": 69688,
                        "name": "Dios Padre",
                        "latitude": "19.61474000",
                        "longitude": "-100.06499000"
                    },
                    {
                        "id": 69702,
                        "name": "Dolores",
                        "latitude": "20.06059000",
                        "longitude": "-100.32211000"
                    },
                    {
                        "id": 69704,
                        "name": "Dolores Hidalgo",
                        "latitude": "19.65528000",
                        "longitude": "-99.92639000"
                    },
                    {
                        "id": 69715,
                        "name": "Dongu",
                        "latitude": "19.84295000",
                        "longitude": "-99.58651000"
                    },
                    {
                        "id": 69723,
                        "name": "Dotegiare",
                        "latitude": "19.70705000",
                        "longitude": "-100.04354000"
                    },
                    {
                        "id": 69725,
                        "name": "Doxhicho",
                        "latitude": "19.89999000",
                        "longitude": "-99.55727000"
                    },
                    {
                        "id": 69726,
                        "name": "Doxteje Barrio Primero",
                        "latitude": "19.95972000",
                        "longitude": "-99.95861000"
                    },
                    {
                        "id": 69727,
                        "name": "Doxteje Centro",
                        "latitude": "19.97528000",
                        "longitude": "-99.95472000"
                    },
                    {
                        "id": 69752,
                        "name": "Ecatepec de Morelos",
                        "latitude": "19.60378000",
                        "longitude": "-99.05514000"
                    },
                    {
                        "id": 69753,
                        "name": "Ecatzingo de Hidalgo",
                        "latitude": "18.95508000",
                        "longitude": "-98.75198000"
                    },
                    {
                        "id": 69802,
                        "name": "Ejido de Coscomate del Progreso",
                        "latitude": "19.93379000",
                        "longitude": "-99.54720000"
                    },
                    {
                        "id": 69803,
                        "name": "Ejido de Dolores",
                        "latitude": "19.43083000",
                        "longitude": "-99.61278000"
                    },
                    {
                        "id": 69804,
                        "name": "Ejido de Guadalupe",
                        "latitude": "19.63765000",
                        "longitude": "-99.27178000"
                    },
                    {
                        "id": 69807,
                        "name": "Ejido de la Finca",
                        "latitude": "18.88635000",
                        "longitude": "-99.62693000"
                    },
                    {
                        "id": 69805,
                        "name": "Ejido de Mozoquilpan",
                        "latitude": "19.42417000",
                        "longitude": "-99.52833000"
                    },
                    {
                        "id": 69806,
                        "name": "Ejido de San Mateo Coapexco",
                        "latitude": "18.94889000",
                        "longitude": "-99.64249000"
                    },
                    {
                        "id": 69808,
                        "name": "Ejido del Tejocote",
                        "latitude": "19.48474000",
                        "longitude": "-99.27847000"
                    },
                    {
                        "id": 69809,
                        "name": "Ejido del Tunal Nenaxi",
                        "latitude": "19.74389000",
                        "longitude": "-99.90889000"
                    },
                    {
                        "id": 69810,
                        "name": "Ejido el Castillo",
                        "latitude": "19.43583000",
                        "longitude": "-99.30583000"
                    },
                    {
                        "id": 69817,
                        "name": "Ejido la Soledad",
                        "latitude": "19.64500000",
                        "longitude": "-100.10639000"
                    },
                    {
                        "id": 69773,
                        "name": "Ejido Loma de Malacota",
                        "latitude": "19.65753000",
                        "longitude": "-99.67122000"
                    },
                    {
                        "id": 69777,
                        "name": "Ejido Miraflores",
                        "latitude": "19.57000000",
                        "longitude": "-99.39750000"
                    },
                    {
                        "id": 69783,
                        "name": "Ejido Palma (Ejido San Francisco)",
                        "latitude": "19.56889000",
                        "longitude": "-99.40889000"
                    },
                    {
                        "id": 69788,
                        "name": "Ejido San Cristóbal",
                        "latitude": "19.54250000",
                        "longitude": "-98.89417000"
                    },
                    {
                        "id": 69789,
                        "name": "Ejido San Diego",
                        "latitude": "19.41329000",
                        "longitude": "-99.82537000"
                    },
                    {
                        "id": 69791,
                        "name": "Ejido San Lorenzo Cuauhtenco",
                        "latitude": "19.30139000",
                        "longitude": "-99.75028000"
                    },
                    {
                        "id": 70266,
                        "name": "El Águila (La Mesa)",
                        "latitude": "19.16694000",
                        "longitude": "-99.40639000"
                    },
                    {
                        "id": 69831,
                        "name": "El Arco",
                        "latitude": "19.22528000",
                        "longitude": "-100.13167000"
                    },
                    {
                        "id": 69853,
                        "name": "El Cabi",
                        "latitude": "19.18986000",
                        "longitude": "-98.85371000"
                    },
                    {
                        "id": 69875,
                        "name": "El Carmen (El Desierto del Carmen)",
                        "latitude": "18.92028000",
                        "longitude": "-99.55667000"
                    },
                    {
                        "id": 69878,
                        "name": "El Carmen Ocotepec",
                        "latitude": "19.68722000",
                        "longitude": "-99.97417000"
                    },
                    {
                        "id": 69894,
                        "name": "El Cerrillo Vista Hermosa",
                        "latitude": "19.32337000",
                        "longitude": "-99.54250000"
                    },
                    {
                        "id": 69895,
                        "name": "El Cerrito",
                        "latitude": "19.35528000",
                        "longitude": "-99.34833000"
                    },
                    {
                        "id": 69914,
                        "name": "El Colorado",
                        "latitude": "20.09639000",
                        "longitude": "-99.76278000"
                    },
                    {
                        "id": 69915,
                        "name": "El Coloso",
                        "latitude": "19.09778000",
                        "longitude": "-99.59778000"
                    },
                    {
                        "id": 69921,
                        "name": "El Contadero de Matamoros",
                        "latitude": "19.23734000",
                        "longitude": "-99.80990000"
                    },
                    {
                        "id": 69941,
                        "name": "El Cóporo",
                        "latitude": "19.28306000",
                        "longitude": "-99.83528000"
                    },
                    {
                        "id": 69938,
                        "name": "El Curtidor",
                        "latitude": "19.29167000",
                        "longitude": "-99.83500000"
                    },
                    {
                        "id": 69954,
                        "name": "El Esclavo",
                        "latitude": "19.67667000",
                        "longitude": "-99.37139000"
                    },
                    {
                        "id": 69962,
                        "name": "El Espinal",
                        "latitude": "19.46756000",
                        "longitude": "-100.06051000"
                    },
                    {
                        "id": 69980,
                        "name": "El Habillal",
                        "latitude": "18.00699000",
                        "longitude": "-102.37263000"
                    },
                    {
                        "id": 69982,
                        "name": "El Hielo",
                        "latitude": "19.42583000",
                        "longitude": "-99.35556000"
                    },
                    {
                        "id": 69996,
                        "name": "El Jacal",
                        "latitude": "19.40500000",
                        "longitude": "-100.08944000"
                    },
                    {
                        "id": 70025,
                        "name": "El Llano del Compromiso",
                        "latitude": "19.25472000",
                        "longitude": "-99.47917000"
                    },
                    {
                        "id": 70024,
                        "name": "El Llano Santa María",
                        "latitude": "19.78389000",
                        "longitude": "-99.08639000"
                    },
                    {
                        "id": 70030,
                        "name": "El Magueyal",
                        "latitude": "19.94250000",
                        "longitude": "-99.57462000"
                    },
                    {
                        "id": 70042,
                        "name": "El Mogote",
                        "latitude": "20.16583000",
                        "longitude": "-99.91444000"
                    },
                    {
                        "id": 70069,
                        "name": "El Obraje",
                        "latitude": "19.72269000",
                        "longitude": "-99.96259000"
                    },
                    {
                        "id": 70070,
                        "name": "El Ocotal",
                        "latitude": "19.67983000",
                        "longitude": "-99.47008000"
                    },
                    {
                        "id": 70075,
                        "name": "El Oro de Hidalgo",
                        "latitude": "19.80272000",
                        "longitude": "-100.13081000"
                    },
                    {
                        "id": 70077,
                        "name": "El Palacio",
                        "latitude": "19.35139000",
                        "longitude": "-99.35667000"
                    },
                    {
                        "id": 70084,
                        "name": "El Palmito",
                        "latitude": "19.91733000",
                        "longitude": "-99.68127000"
                    },
                    {
                        "id": 70097,
                        "name": "El Pedregal de Guadalupe Hidalgo",
                        "latitude": "19.25278000",
                        "longitude": "-99.46500000"
                    },
                    {
                        "id": 70103,
                        "name": "El Pilar",
                        "latitude": "20.24201000",
                        "longitude": "-101.40209000"
                    },
                    {
                        "id": 70104,
                        "name": "El Pino",
                        "latitude": "19.35139000",
                        "longitude": "-98.94833000"
                    },
                    {
                        "id": 70109,
                        "name": "El Plan",
                        "latitude": "19.37452000",
                        "longitude": "-99.80049000"
                    },
                    {
                        "id": 70121,
                        "name": "El Porvenir I",
                        "latitude": "19.31694000",
                        "longitude": "-99.72889000"
                    },
                    {
                        "id": 70124,
                        "name": "El Potrero",
                        "latitude": "19.30625000",
                        "longitude": "-99.99393000"
                    },
                    {
                        "id": 70126,
                        "name": "El Potrero de San Diego",
                        "latitude": "19.48899000",
                        "longitude": "-100.08210000"
                    },
                    {
                        "id": 70135,
                        "name": "El Progreso Hidalgo",
                        "latitude": "18.84639000",
                        "longitude": "-99.61417000"
                    },
                    {
                        "id": 70140,
                        "name": "El Puerto Magú",
                        "latitude": "19.68846000",
                        "longitude": "-99.37290000"
                    },
                    {
                        "id": 70147,
                        "name": "El Recodo de San José Axalco",
                        "latitude": "19.20278000",
                        "longitude": "-98.90278000"
                    },
                    {
                        "id": 70164,
                        "name": "El Rincón de la Candelaria",
                        "latitude": "19.79000000",
                        "longitude": "-99.84306000"
                    },
                    {
                        "id": 70165,
                        "name": "El Rincón de los Perales",
                        "latitude": "19.54222000",
                        "longitude": "-99.82806000"
                    },
                    {
                        "id": 70170,
                        "name": "El Rosal",
                        "latitude": "20.10126000",
                        "longitude": "-99.68555000"
                    },
                    {
                        "id": 70186,
                        "name": "El Salitre",
                        "latitude": "18.95250000",
                        "longitude": "-99.58972000"
                    },
                    {
                        "id": 70217,
                        "name": "El Tepetatal",
                        "latitude": "19.34581000",
                        "longitude": "-99.77086000"
                    },
                    {
                        "id": 70223,
                        "name": "El Terrero",
                        "latitude": "18.79028000",
                        "longitude": "-99.64528000"
                    },
                    {
                        "id": 70286,
                        "name": "Emiliano Zapata",
                        "latitude": "19.34361000",
                        "longitude": "-98.97472000"
                    },
                    {
                        "id": 70292,
                        "name": "Emiliano Zapata (San José Bata)",
                        "latitude": "19.91111000",
                        "longitude": "-99.00667000"
                    },
                    {
                        "id": 70293,
                        "name": "Emiliano Zapata (Santo Domingo)",
                        "latitude": "19.57972000",
                        "longitude": "-99.78806000"
                    },
                    {
                        "id": 70297,
                        "name": "Emilio Portes Gil",
                        "latitude": "19.64444000",
                        "longitude": "-99.91667000"
                    },
                    {
                        "id": 70312,
                        "name": "Epitacio Huerta",
                        "latitude": "20.13493000",
                        "longitude": "-100.29321000"
                    },
                    {
                        "id": 70376,
                        "name": "Etúcuaro",
                        "latitude": "19.89286000",
                        "longitude": "-102.12945000"
                    },
                    {
                        "id": 70382,
                        "name": "Ex-Hacienda de Guadalupe",
                        "latitude": "19.80889000",
                        "longitude": "-98.97250000"
                    },
                    {
                        "id": 70388,
                        "name": "Ex-hacienda de Xalpa",
                        "latitude": "19.82150000",
                        "longitude": "-99.18275000"
                    },
                    {
                        "id": 70381,
                        "name": "Ex-Hacienda Santa Inés",
                        "latitude": "19.70667000",
                        "longitude": "-99.07250000"
                    },
                    {
                        "id": 70386,
                        "name": "Ex-Rancho San Dimas",
                        "latitude": "19.17389000",
                        "longitude": "-99.56528000"
                    },
                    {
                        "id": 70498,
                        "name": "Fábrica Concepción",
                        "latitude": "19.63445000",
                        "longitude": "-100.13596000"
                    },
                    {
                        "id": 70462,
                        "name": "Fracción San Roque (El Prieto)",
                        "latitude": "19.68722000",
                        "longitude": "-99.17222000"
                    },
                    {
                        "id": 70416,
                        "name": "Fraccionamiento Colinas del Sol",
                        "latitude": "19.37222000",
                        "longitude": "-99.74028000"
                    },
                    {
                        "id": 70423,
                        "name": "Fraccionamiento Hacienda del Bosque",
                        "latitude": "19.72667000",
                        "longitude": "-98.96861000"
                    },
                    {
                        "id": 70453,
                        "name": "Fraccionamiento la Trinidad",
                        "latitude": "19.82917000",
                        "longitude": "-99.08278000"
                    },
                    {
                        "id": 70436,
                        "name": "Fraccionamiento Real de San Pablo",
                        "latitude": "19.38944000",
                        "longitude": "-99.64861000"
                    },
                    {
                        "id": 70439,
                        "name": "Fraccionamiento Rinconada del Valle",
                        "latitude": "19.41111000",
                        "longitude": "-99.57417000"
                    },
                    {
                        "id": 70460,
                        "name": "Fraccionamiento y Club de Golf los Encinos",
                        "latitude": "19.28917000",
                        "longitude": "-99.48000000"
                    },
                    {
                        "id": 70489,
                        "name": "Fresno Nichi",
                        "latitude": "19.56694000",
                        "longitude": "-99.94889000"
                    },
                    {
                        "id": 70496,
                        "name": "Fuentes del Valle",
                        "latitude": "19.63250000",
                        "longitude": "-99.13861000"
                    },
                    {
                        "id": 70507,
                        "name": "Galaxias Toluca",
                        "latitude": "19.39806000",
                        "longitude": "-99.65000000"
                    },
                    {
                        "id": 70510,
                        "name": "Galeana",
                        "latitude": "20.03585000",
                        "longitude": "-101.57150000"
                    },
                    {
                        "id": 70519,
                        "name": "Ganzda",
                        "latitude": "19.99000000",
                        "longitude": "-99.84750000"
                    },
                    {
                        "id": 70564,
                        "name": "Granjas Ampliación Santa Rosa",
                        "latitude": "19.59278000",
                        "longitude": "-98.96667000"
                    },
                    {
                        "id": 70577,
                        "name": "Guadalupe Buenavista",
                        "latitude": "19.61194000",
                        "longitude": "-100.12720000"
                    },
                    {
                        "id": 70578,
                        "name": "Guadalupe Cachi",
                        "latitude": "19.60111000",
                        "longitude": "-99.82500000"
                    },
                    {
                        "id": 70580,
                        "name": "Guadalupe Coté",
                        "latitude": "19.61075000",
                        "longitude": "-99.98499000"
                    },
                    {
                        "id": 70594,
                        "name": "Guadalupe Totoltepec",
                        "latitude": "19.34833000",
                        "longitude": "-99.56417000"
                    },
                    {
                        "id": 70637,
                        "name": "Gunyo Poniente (San José Gunyo)",
                        "latitude": "20.11149000",
                        "longitude": "-99.83861000"
                    },
                    {
                        "id": 70730,
                        "name": "Huancito",
                        "latitude": "19.84889000",
                        "longitude": "-102.06784000"
                    },
                    {
                        "id": 70761,
                        "name": "Huehuetoca",
                        "latitude": "19.82819000",
                        "longitude": "-99.20370000"
                    },
                    {
                        "id": 70768,
                        "name": "Huemetla",
                        "latitude": "19.71500000",
                        "longitude": "-99.73583000"
                    },
                    {
                        "id": 70782,
                        "name": "Hueypoxtla",
                        "latitude": "19.91301000",
                        "longitude": "-99.07384000"
                    },
                    {
                        "id": 70791,
                        "name": "Huilango",
                        "latitude": "19.68056000",
                        "longitude": "-99.25639000"
                    },
                    {
                        "id": 70814,
                        "name": "Huitzoltepec",
                        "latitude": "18.76737000",
                        "longitude": "-99.80014000"
                    },
                    {
                        "id": 70818,
                        "name": "Huixquilucan",
                        "latitude": "19.35985000",
                        "longitude": "-99.35016000"
                    },
                    {
                        "id": 70819,
                        "name": "Huixquilucan de Degollado",
                        "latitude": "19.36028000",
                        "longitude": "-99.34980000"
                    },
                    {
                        "id": 70836,
                        "name": "Ignacio Allende",
                        "latitude": "19.34426000",
                        "longitude": "-99.36146000"
                    },
                    {
                        "id": 70929,
                        "name": "Ixtapaluca",
                        "latitude": "19.31556000",
                        "longitude": "-98.88284000"
                    },
                    {
                        "id": 70931,
                        "name": "Ixtapan de la Sal",
                        "latitude": "18.84369000",
                        "longitude": "-99.67671000"
                    },
                    {
                        "id": 70932,
                        "name": "Ixtapan del Oro",
                        "latitude": "19.26303000",
                        "longitude": "-100.26459000"
                    },
                    {
                        "id": 70940,
                        "name": "Ixtlahuaca de Cuauhtémoc",
                        "latitude": "19.88139000",
                        "longitude": "-98.86028000"
                    },
                    {
                        "id": 70941,
                        "name": "Ixtlahuaca de Rayón",
                        "latitude": "19.56889000",
                        "longitude": "-99.76694000"
                    },
                    {
                        "id": 70960,
                        "name": "Jacona de Plancarte",
                        "latitude": "19.95232000",
                        "longitude": "-102.30781000"
                    },
                    {
                        "id": 70974,
                        "name": "Jalmolonga (La Hacienda)",
                        "latitude": "18.91835000",
                        "longitude": "-99.49407000"
                    },
                    {
                        "id": 70978,
                        "name": "Jalpa de los Baños",
                        "latitude": "19.67833000",
                        "longitude": "-99.87389000"
                    },
                    {
                        "id": 70984,
                        "name": "Jaltenco",
                        "latitude": "19.75298000",
                        "longitude": "-99.09390000"
                    },
                    {
                        "id": 70999,
                        "name": "Janambo",
                        "latitude": "20.20642000",
                        "longitude": "-101.52644000"
                    },
                    {
                        "id": 71000,
                        "name": "Janamuato",
                        "latitude": "20.09961000",
                        "longitude": "-101.58540000"
                    },
                    {
                        "id": 71023,
                        "name": "Jesús Carranza (Rancho de Jesús)",
                        "latitude": "18.94528000",
                        "longitude": "-99.63056000"
                    },
                    {
                        "id": 71036,
                        "name": "Jesús del Monte",
                        "latitude": "19.37500000",
                        "longitude": "-99.29444000"
                    },
                    {
                        "id": 71027,
                        "name": "Jesús María",
                        "latitude": "19.41773000",
                        "longitude": "-99.99696000"
                    },
                    {
                        "id": 71039,
                        "name": "Jicaltepec Autopan",
                        "latitude": "19.37167000",
                        "longitude": "-99.64083000"
                    },
                    {
                        "id": 71040,
                        "name": "Jicaltepec Cuexcontitlán",
                        "latitude": "19.37306000",
                        "longitude": "-99.62750000"
                    },
                    {
                        "id": 71045,
                        "name": "Jilotepec de Molina Enríquez",
                        "latitude": "19.95194000",
                        "longitude": "-99.53278000"
                    },
                    {
                        "id": 71046,
                        "name": "Jilotzingo",
                        "latitude": "19.86889000",
                        "longitude": "-99.06194000"
                    },
                    {
                        "id": 71056,
                        "name": "Jiquipilco",
                        "latitude": "19.55644000",
                        "longitude": "-99.60833000"
                    },
                    {
                        "id": 71067,
                        "name": "Jocotitlán",
                        "latitude": "19.70991000",
                        "longitude": "-99.78867000"
                    },
                    {
                        "id": 71083,
                        "name": "Joquicingo",
                        "latitude": "19.05032000",
                        "longitude": "-99.53375000"
                    },
                    {
                        "id": 71084,
                        "name": "Jorge Jiménez Cantú",
                        "latitude": "19.30972000",
                        "longitude": "-98.84667000"
                    },
                    {
                        "id": 71085,
                        "name": "Jorobas",
                        "latitude": "19.82389000",
                        "longitude": "-99.24833000"
                    },
                    {
                        "id": 71132,
                        "name": "Juchitepec",
                        "latitude": "19.10059000",
                        "longitude": "-98.87880000"
                    },
                    {
                        "id": 71169,
                        "name": "La Albarrada (San Francisco la Albarrada)",
                        "latitude": "19.06750000",
                        "longitude": "-100.07528000"
                    },
                    {
                        "id": 71187,
                        "name": "La Cabecera",
                        "latitude": "19.35611000",
                        "longitude": "-99.74806000"
                    },
                    {
                        "id": 71188,
                        "name": "La Cabecera Concepción",
                        "latitude": "19.70361000",
                        "longitude": "-99.94111000"
                    },
                    {
                        "id": 71192,
                        "name": "La Calle",
                        "latitude": "20.28628000",
                        "longitude": "-101.63679000"
                    },
                    {
                        "id": 71194,
                        "name": "La Campanilla",
                        "latitude": "19.50983000",
                        "longitude": "-99.94230000"
                    },
                    {
                        "id": 71207,
                        "name": "La Cañada",
                        "latitude": "19.48639000",
                        "longitude": "-99.59889000"
                    },
                    {
                        "id": 71198,
                        "name": "La Candelaria Tlapala",
                        "latitude": "19.24042000",
                        "longitude": "-98.84766000"
                    },
                    {
                        "id": 71199,
                        "name": "La Cantera",
                        "latitude": "19.86375000",
                        "longitude": "-102.40838000"
                    },
                    {
                        "id": 71204,
                        "name": "La Caridad",
                        "latitude": "19.94778000",
                        "longitude": "-99.83694000"
                    },
                    {
                        "id": 71217,
                        "name": "La Ciénega",
                        "latitude": "18.95611000",
                        "longitude": "-99.58139000"
                    },
                    {
                        "id": 71220,
                        "name": "La Colonia",
                        "latitude": "19.14444000",
                        "longitude": "-98.78667000"
                    },
                    {
                        "id": 71225,
                        "name": "La Compañía",
                        "latitude": "19.16460000",
                        "longitude": "-100.07966000"
                    },
                    {
                        "id": 71227,
                        "name": "La Comunidad",
                        "latitude": "20.02111000",
                        "longitude": "-99.57611000"
                    },
                    {
                        "id": 71233,
                        "name": "La Concepción",
                        "latitude": "19.69611000",
                        "longitude": "-99.30028000"
                    },
                    {
                        "id": 71235,
                        "name": "La Concepción Coatipac (La Conchita)",
                        "latitude": "19.18188000",
                        "longitude": "-99.56833000"
                    },
                    {
                        "id": 71238,
                        "name": "La Concepción de Hidalgo",
                        "latitude": "19.45054000",
                        "longitude": "-99.53139000"
                    },
                    {
                        "id": 71239,
                        "name": "La Concepción de los Baños",
                        "latitude": "19.68249000",
                        "longitude": "-99.86104000"
                    },
                    {
                        "id": 71236,
                        "name": "La Concepción Enyege",
                        "latitude": "19.56472000",
                        "longitude": "-99.84139000"
                    },
                    {
                        "id": 71237,
                        "name": "La Concepción Xochicuautla",
                        "latitude": "19.38226000",
                        "longitude": "-99.44050000"
                    },
                    {
                        "id": 71245,
                        "name": "La Constitución Toltepec",
                        "latitude": "19.34861000",
                        "longitude": "-99.54917000"
                    },
                    {
                        "id": 71253,
                        "name": "La Cruz y Carrizal",
                        "latitude": "19.83021000",
                        "longitude": "-99.42168000"
                    },
                    {
                        "id": 71270,
                        "name": "La Esperanza",
                        "latitude": "19.68377000",
                        "longitude": "-99.51575000"
                    },
                    {
                        "id": 71283,
                        "name": "La Estancia Sector Uno (La Estancia)",
                        "latitude": "19.87056000",
                        "longitude": "-99.79167000"
                    },
                    {
                        "id": 71290,
                        "name": "La Finca",
                        "latitude": "18.89047000",
                        "longitude": "-99.64028000"
                    },
                    {
                        "id": 71303,
                        "name": "La Glorieta",
                        "latitude": "19.41154000",
                        "longitude": "-99.38562000"
                    },
                    {
                        "id": 71309,
                        "name": "La Guadalupana",
                        "latitude": "19.55414000",
                        "longitude": "-99.90922000"
                    },
                    {
                        "id": 71315,
                        "name": "La Herradura",
                        "latitude": "19.04000000",
                        "longitude": "-99.58472000"
                    },
                    {
                        "id": 71333,
                        "name": "La Joya",
                        "latitude": "19.27639000",
                        "longitude": "-99.75889000"
                    },
                    {
                        "id": 71365,
                        "name": "La Loma",
                        "latitude": "20.01966000",
                        "longitude": "-100.01027000"
                    },
                    {
                        "id": 71368,
                        "name": "La Loma Cuexcontitlán",
                        "latitude": "19.38000000",
                        "longitude": "-99.64889000"
                    },
                    {
                        "id": 71381,
                        "name": "La Magdalena",
                        "latitude": "19.94796000",
                        "longitude": "-99.99947000"
                    },
                    {
                        "id": 71382,
                        "name": "La Magdalena Chichicaspa",
                        "latitude": "19.41237000",
                        "longitude": "-99.32555000"
                    },
                    {
                        "id": 71387,
                        "name": "La Magdalena de los Reyes (La Magdalena)",
                        "latitude": "19.18972000",
                        "longitude": "-99.41000000"
                    },
                    {
                        "id": 71383,
                        "name": "La Magdalena Tenexpan",
                        "latitude": "19.46333000",
                        "longitude": "-99.58861000"
                    },
                    {
                        "id": 71389,
                        "name": "La Mesa",
                        "latitude": "19.58748000",
                        "longitude": "-100.17373000"
                    },
                    {
                        "id": 71392,
                        "name": "La Mesa de Chosto",
                        "latitude": "19.85250000",
                        "longitude": "-99.89028000"
                    },
                    {
                        "id": 71433,
                        "name": "La Pastoría",
                        "latitude": "19.54306000",
                        "longitude": "-98.91111000"
                    },
                    {
                        "id": 71451,
                        "name": "La Planada",
                        "latitude": "19.78129000",
                        "longitude": "-99.18267000"
                    },
                    {
                        "id": 71452,
                        "name": "La Planada (El Arenal)",
                        "latitude": "19.33333000",
                        "longitude": "-99.67694000"
                    },
                    {
                        "id": 71459,
                        "name": "La Presita Segundo Cuartel",
                        "latitude": "20.16278000",
                        "longitude": "-99.87278000"
                    },
                    {
                        "id": 71462,
                        "name": "La Providencia",
                        "latitude": "19.75833000",
                        "longitude": "-99.14667000"
                    },
                    {
                        "id": 71466,
                        "name": "La Puerta del Pilar",
                        "latitude": "19.46018000",
                        "longitude": "-100.01577000"
                    },
                    {
                        "id": 71468,
                        "name": "La Purificación",
                        "latitude": "19.52441000",
                        "longitude": "-98.81731000"
                    },
                    {
                        "id": 71480,
                        "name": "La Rosa",
                        "latitude": "19.48519000",
                        "longitude": "-99.32984000"
                    },
                    {
                        "id": 71496,
                        "name": "La Soledad Barrio",
                        "latitude": "20.09194000",
                        "longitude": "-99.82306000"
                    },
                    {
                        "id": 71510,
                        "name": "La Trinidad",
                        "latitude": "18.96639000",
                        "longitude": "-99.58083000"
                    },
                    {
                        "id": 71536,
                        "name": "La Y",
                        "latitude": "19.39806000",
                        "longitude": "-99.58972000"
                    },
                    {
                        "id": 71555,
                        "name": "Laguna de Tabernillas (El Resbaloso)",
                        "latitude": "19.46139000",
                        "longitude": "-99.87833000"
                    },
                    {
                        "id": 71604,
                        "name": "Las Huertas",
                        "latitude": "19.97222000",
                        "longitude": "-99.55611000"
                    },
                    {
                        "id": 71615,
                        "name": "Las Manzanas",
                        "latitude": "19.95069000",
                        "longitude": "-99.56109000"
                    },
                    {
                        "id": 71631,
                        "name": "Las Peñas",
                        "latitude": "19.44972000",
                        "longitude": "-99.99944000"
                    },
                    {
                        "id": 71633,
                        "name": "Las Pintas",
                        "latitude": "19.89667000",
                        "longitude": "-98.88694000"
                    },
                    {
                        "id": 71636,
                        "name": "Las Ranas",
                        "latitude": "20.20860000",
                        "longitude": "-101.47810000"
                    },
                    {
                        "id": 71638,
                        "name": "Las Rosas",
                        "latitude": "19.54631000",
                        "longitude": "-100.15986000"
                    },
                    {
                        "id": 71664,
                        "name": "Lerma de Villada",
                        "latitude": "19.28881000",
                        "longitude": "-99.51163000"
                    },
                    {
                        "id": 71695,
                        "name": "Llano de la Y",
                        "latitude": "19.40278000",
                        "longitude": "-99.61639000"
                    },
                    {
                        "id": 71696,
                        "name": "Llano de las Flores (Barrio del Hueso)",
                        "latitude": "19.43583000",
                        "longitude": "-99.32250000"
                    },
                    {
                        "id": 71692,
                        "name": "Llano de Zacapexco",
                        "latitude": "19.70405000",
                        "longitude": "-99.48507000"
                    },
                    {
                        "id": 71684,
                        "name": "Llano Grande",
                        "latitude": "18.82733000",
                        "longitude": "-99.76774000"
                    },
                    {
                        "id": 71708,
                        "name": "Loma Alta",
                        "latitude": "19.68944000",
                        "longitude": "-99.44917000"
                    },
                    {
                        "id": 71710,
                        "name": "Loma Alta Taxhimay",
                        "latitude": "19.84222000",
                        "longitude": "-99.40806000"
                    },
                    {
                        "id": 71716,
                        "name": "Loma Bonita",
                        "latitude": "19.18722000",
                        "longitude": "-100.21500000"
                    },
                    {
                        "id": 71726,
                        "name": "Loma de Guadalupe (La Biznaga)",
                        "latitude": "19.65219000",
                        "longitude": "-99.36873000"
                    },
                    {
                        "id": 71728,
                        "name": "Loma de Juárez",
                        "latitude": "19.43523000",
                        "longitude": "-100.09020000"
                    },
                    {
                        "id": 71729,
                        "name": "Loma de San Francisco",
                        "latitude": "19.28333000",
                        "longitude": "-99.80917000"
                    },
                    {
                        "id": 71730,
                        "name": "Loma de San José",
                        "latitude": "19.64222000",
                        "longitude": "-99.32778000"
                    },
                    {
                        "id": 71731,
                        "name": "Loma de San Miguel",
                        "latitude": "19.34194000",
                        "longitude": "-99.79167000"
                    },
                    {
                        "id": 71739,
                        "name": "Loma del Río",
                        "latitude": "19.60056000",
                        "longitude": "-99.35056000"
                    },
                    {
                        "id": 71720,
                        "name": "Loma Larga",
                        "latitude": "19.62750000",
                        "longitude": "-99.34611000"
                    },
                    {
                        "id": 71721,
                        "name": "Loma Larga (Barrio de Loma Larga)",
                        "latitude": "19.86722000",
                        "longitude": "-99.11611000"
                    },
                    {
                        "id": 71744,
                        "name": "Lomas de Altavista",
                        "latitude": "19.36139000",
                        "longitude": "-98.94472000"
                    },
                    {
                        "id": 71751,
                        "name": "Lomas de San Pablo",
                        "latitude": "19.20250000",
                        "longitude": "-98.91778000"
                    },
                    {
                        "id": 71752,
                        "name": "Lomas de San Sebastián",
                        "latitude": "19.38206000",
                        "longitude": "-98.93320000"
                    },
                    {
                        "id": 71755,
                        "name": "Lomas de Tenopalco",
                        "latitude": "19.70232000",
                        "longitude": "-99.11237000"
                    },
                    {
                        "id": 71771,
                        "name": "Los Arana",
                        "latitude": "19.70981000",
                        "longitude": "-99.50222000"
                    },
                    {
                        "id": 71780,
                        "name": "Los Berros",
                        "latitude": "19.39771000",
                        "longitude": "-100.04840000"
                    },
                    {
                        "id": 71807,
                        "name": "Los Hucuares",
                        "latitude": "19.89916000",
                        "longitude": "-102.49759000"
                    },
                    {
                        "id": 71823,
                        "name": "Los Nogales",
                        "latitude": "19.85734000",
                        "longitude": "-102.15612000"
                    },
                    {
                        "id": 71842,
                        "name": "Los Remedios",
                        "latitude": "19.97810000",
                        "longitude": "-102.67954000"
                    },
                    {
                        "id": 71844,
                        "name": "Los Reyes",
                        "latitude": "19.68524000",
                        "longitude": "-99.76450000"
                    },
                    {
                        "id": 71847,
                        "name": "Los Reyes Acaquilpan",
                        "latitude": "19.36357000",
                        "longitude": "-98.97707000"
                    },
                    {
                        "id": 71848,
                        "name": "Los Reyes Acatlixhuayán",
                        "latitude": "19.20889000",
                        "longitude": "-98.88242000"
                    },
                    {
                        "id": 71861,
                        "name": "Los Saucos",
                        "latitude": "19.16520000",
                        "longitude": "-99.99895000"
                    },
                    {
                        "id": 71884,
                        "name": "Luvianos",
                        "latitude": "18.94554000",
                        "longitude": "-100.42448000"
                    },
                    {
                        "id": 71922,
                        "name": "Magdalena Atlicpac",
                        "latitude": "19.36906000",
                        "longitude": "-98.94935000"
                    },
                    {
                        "id": 71945,
                        "name": "Malinalco",
                        "latitude": "18.94847000",
                        "longitude": "-99.49619000"
                    },
                    {
                        "id": 71957,
                        "name": "Manto del Río Ejido",
                        "latitude": "19.84008000",
                        "longitude": "-99.92729000"
                    },
                    {
                        "id": 71969,
                        "name": "Manzana Quinta (La Cañada)",
                        "latitude": "19.54222000",
                        "longitude": "-99.60250000"
                    },
                    {
                        "id": 71970,
                        "name": "Manzana Segunda",
                        "latitude": "19.56722000",
                        "longitude": "-99.59389000"
                    },
                    {
                        "id": 71971,
                        "name": "Manzana Sexta Parte Centro",
                        "latitude": "19.52750000",
                        "longitude": "-99.60528000"
                    },
                    {
                        "id": 71972,
                        "name": "Manzana Tercera de Santa Cruz Tepexpan",
                        "latitude": "19.56917000",
                        "longitude": "-99.70361000"
                    },
                    {
                        "id": 72025,
                        "name": "Mavoro",
                        "latitude": "19.70417000",
                        "longitude": "-99.82222000"
                    },
                    {
                        "id": 72028,
                        "name": "Maxtleca de Galeana",
                        "latitude": "19.02889000",
                        "longitude": "-99.55722000"
                    },
                    {
                        "id": 72034,
                        "name": "Mayorazgo de León",
                        "latitude": "19.46889000",
                        "longitude": "-99.74365000"
                    },
                    {
                        "id": 72069,
                        "name": "Melchor Ocampo",
                        "latitude": "19.70186000",
                        "longitude": "-99.14485000"
                    },
                    {
                        "id": 72088,
                        "name": "Metepec",
                        "latitude": "19.25934000",
                        "longitude": "-99.60175000"
                    },
                    {
                        "id": 72100,
                        "name": "Mexicaltzingo",
                        "latitude": "19.21130000",
                        "longitude": "-99.58469000"
                    },
                    {
                        "id": 72103,
                        "name": "Mextepec",
                        "latitude": "19.46118000",
                        "longitude": "-99.89126000"
                    },
                    {
                        "id": 72104,
                        "name": "Mezapa la Fábrica",
                        "latitude": "19.17556000",
                        "longitude": "-99.44528000"
                    },
                    {
                        "id": 72142,
                        "name": "Mina México",
                        "latitude": "19.41014000",
                        "longitude": "-99.72771000"
                    },
                    {
                        "id": 72143,
                        "name": "Mina Vieja",
                        "latitude": "19.55250000",
                        "longitude": "-99.94389000"
                    },
                    {
                        "id": 72152,
                        "name": "Miraflores",
                        "latitude": "19.22210000",
                        "longitude": "-98.80741000"
                    },
                    {
                        "id": 72183,
                        "name": "Molino Abajo",
                        "latitude": "19.44972000",
                        "longitude": "-99.60222000"
                    },
                    {
                        "id": 72198,
                        "name": "Monte Calvario",
                        "latitude": "19.10444000",
                        "longitude": "-99.59528000"
                    },
                    {
                        "id": 72210,
                        "name": "Montecillo",
                        "latitude": "19.45711000",
                        "longitude": "-98.90835000"
                    },
                    {
                        "id": 72233,
                        "name": "Morelos",
                        "latitude": "19.74542000",
                        "longitude": "-99.64687000"
                    },
                    {
                        "id": 72290,
                        "name": "Naucalpan de Juárez",
                        "latitude": "19.47851000",
                        "longitude": "-99.23963000"
                    },
                    {
                        "id": 72311,
                        "name": "Nepantla de Sor Juana Inés de la Cruz",
                        "latitude": "18.98028000",
                        "longitude": "-98.84083000"
                    },
                    {
                        "id": 72327,
                        "name": "Nicolás Romero",
                        "latitude": "19.64177000",
                        "longitude": "-99.30680000"
                    },
                    {
                        "id": 72347,
                        "name": "Nopaltepec",
                        "latitude": "19.77829000",
                        "longitude": "-98.71046000"
                    },
                    {
                        "id": 72358,
                        "name": "Nueva Ameyalco",
                        "latitude": "19.29790000",
                        "longitude": "-99.50483000"
                    },
                    {
                        "id": 72374,
                        "name": "Nueva Santa Rosa",
                        "latitude": "19.59028000",
                        "longitude": "-98.96000000"
                    },
                    {
                        "id": 72449,
                        "name": "Ocopulco",
                        "latitude": "19.58972000",
                        "longitude": "-98.89694000"
                    },
                    {
                        "id": 72463,
                        "name": "Ocoyoacac",
                        "latitude": "19.27127000",
                        "longitude": "-99.45787000"
                    },
                    {
                        "id": 72468,
                        "name": "Octeyuco Dos Mil",
                        "latitude": "19.96333000",
                        "longitude": "-99.58806000"
                    },
                    {
                        "id": 72470,
                        "name": "Ocuilan",
                        "latitude": "18.99043000",
                        "longitude": "-99.40910000"
                    },
                    {
                        "id": 72471,
                        "name": "Ocuilan de Arteaga",
                        "latitude": "18.97784000",
                        "longitude": "-99.41986000"
                    },
                    {
                        "id": 72474,
                        "name": "Ocumicho",
                        "latitude": "19.79654000",
                        "longitude": "-102.22169000"
                    },
                    {
                        "id": 72485,
                        "name": "Ojo de Agua",
                        "latitude": "19.68028000",
                        "longitude": "-99.01000000"
                    },
                    {
                        "id": 72542,
                        "name": "Otumba",
                        "latitude": "19.69985000",
                        "longitude": "-98.75638000"
                    },
                    {
                        "id": 72543,
                        "name": "Otzoloapan",
                        "latitude": "19.11728000",
                        "longitude": "-100.29684000"
                    },
                    {
                        "id": 72544,
                        "name": "Otzolotepec",
                        "latitude": "19.43526000",
                        "longitude": "-99.54407000"
                    },
                    {
                        "id": 72554,
                        "name": "Oxtotipac",
                        "latitude": "19.65521000",
                        "longitude": "-98.79319000"
                    },
                    {
                        "id": 72560,
                        "name": "Ozumba de Alzate",
                        "latitude": "19.03689000",
                        "longitude": "-98.79516000"
                    },
                    {
                        "id": 72583,
                        "name": "Palizada",
                        "latitude": "19.50611000",
                        "longitude": "-100.10033000"
                    },
                    {
                        "id": 72588,
                        "name": "Palmar Chico",
                        "latitude": "18.69593000",
                        "longitude": "-100.36852000"
                    },
                    {
                        "id": 72600,
                        "name": "Palmillas",
                        "latitude": "19.69361000",
                        "longitude": "-99.95028000"
                    },
                    {
                        "id": 72615,
                        "name": "Palos Amarillos (Palos Amarillos Yebuciví)",
                        "latitude": "19.53944000",
                        "longitude": "-99.91667000"
                    },
                    {
                        "id": 72633,
                        "name": "Papalotla",
                        "latitude": "19.56341000",
                        "longitude": "-98.85681000"
                    },
                    {
                        "id": 72647,
                        "name": "Paraje el Mirador",
                        "latitude": "19.39944000",
                        "longitude": "-99.32694000"
                    },
                    {
                        "id": 72648,
                        "name": "Paraje la Pera",
                        "latitude": "19.38056000",
                        "longitude": "-99.34500000"
                    },
                    {
                        "id": 72646,
                        "name": "Paraje Trejo (El Chaparral)",
                        "latitude": "19.40556000",
                        "longitude": "-99.31222000"
                    },
                    {
                        "id": 72669,
                        "name": "Paseos de San Juan",
                        "latitude": "19.78194000",
                        "longitude": "-99.01750000"
                    },
                    {
                        "id": 72706,
                        "name": "Pathé",
                        "latitude": "19.92695000",
                        "longitude": "-99.83957000"
                    },
                    {
                        "id": 72809,
                        "name": "Playa Azul",
                        "latitude": "17.98170000",
                        "longitude": "-102.34761000"
                    },
                    {
                        "id": 72817,
                        "name": "Plaza Nueva",
                        "latitude": "18.92944000",
                        "longitude": "-99.43444000"
                    },
                    {
                        "id": 72843,
                        "name": "Polígonos",
                        "latitude": "19.41612000",
                        "longitude": "-98.99091000"
                    },
                    {
                        "id": 72838,
                        "name": "Polotitlán",
                        "latitude": "20.21988000",
                        "longitude": "-99.82205000"
                    },
                    {
                        "id": 72839,
                        "name": "Polotitlán de la Ilustración",
                        "latitude": "20.22530000",
                        "longitude": "-99.81537000"
                    },
                    {
                        "id": 72841,
                        "name": "Polvillos (San Bartolo Quinta Sección)",
                        "latitude": "19.23611000",
                        "longitude": "-100.08000000"
                    },
                    {
                        "id": 72849,
                        "name": "Popo Park",
                        "latitude": "19.06510000",
                        "longitude": "-98.78087000"
                    },
                    {
                        "id": 72852,
                        "name": "Porfirío Díaz",
                        "latitude": "18.92875000",
                        "longitude": "-99.72684000"
                    },
                    {
                        "id": 72860,
                        "name": "Pothé",
                        "latitude": "19.47417000",
                        "longitude": "-99.60306000"
                    },
                    {
                        "id": 72868,
                        "name": "Potreros",
                        "latitude": "20.25414000",
                        "longitude": "-101.65747000"
                    },
                    {
                        "id": 72881,
                        "name": "Prados de San Juan",
                        "latitude": "19.63998000",
                        "longitude": "-98.97519000"
                    },
                    {
                        "id": 72880,
                        "name": "Prados San Francisco",
                        "latitude": "19.72154000",
                        "longitude": "-99.08366000"
                    },
                    {
                        "id": 72897,
                        "name": "Primera de Analco",
                        "latitude": "18.90250000",
                        "longitude": "-99.77556000"
                    },
                    {
                        "id": 72906,
                        "name": "Profesor Carlos Hank González",
                        "latitude": "19.37222000",
                        "longitude": "-98.93889000"
                    },
                    {
                        "id": 72917,
                        "name": "Progreso Industrial",
                        "latitude": "19.63635000",
                        "longitude": "-99.35687000"
                    },
                    {
                        "id": 72939,
                        "name": "Pueblo Nuevo",
                        "latitude": "19.67419000",
                        "longitude": "-99.61750000"
                    },
                    {
                        "id": 72944,
                        "name": "Pueblo Nuevo Tlalmimilolpan",
                        "latitude": "19.39222000",
                        "longitude": "-99.50167000"
                    },
                    {
                        "id": 72958,
                        "name": "Puentecillas",
                        "latitude": "20.02568000",
                        "longitude": "-99.97806000"
                    },
                    {
                        "id": 72969,
                        "name": "Puerto Escondido (Tepeolulco Puerto Escondido)",
                        "latitude": "19.55194000",
                        "longitude": "-99.09806000"
                    },
                    {
                        "id": 72994,
                        "name": "Purísima Concepción Mayorazgo",
                        "latitude": "19.69159000",
                        "longitude": "-100.00211000"
                    },
                    {
                        "id": 73029,
                        "name": "Quetzalapa",
                        "latitude": "18.94056000",
                        "longitude": "-99.59694000"
                    },
                    {
                        "id": 73039,
                        "name": "Quinto Barrio (Ejido Cahuacán)",
                        "latitude": "19.62222000",
                        "longitude": "-99.41806000"
                    },
                    {
                        "id": 73055,
                        "name": "Rancho Alegre",
                        "latitude": "19.62528000",
                        "longitude": "-99.68361000"
                    },
                    {
                        "id": 73121,
                        "name": "Rincón de Aguirre",
                        "latitude": "18.89947000",
                        "longitude": "-100.13659000"
                    },
                    {
                        "id": 73127,
                        "name": "Rincón de Guadalupe",
                        "latitude": "19.27404000",
                        "longitude": "-99.99648000"
                    },
                    {
                        "id": 73129,
                        "name": "Rincón de Jaimes",
                        "latitude": "18.89844000",
                        "longitude": "-100.16536000"
                    },
                    {
                        "id": 73135,
                        "name": "Rincón de los Pirules",
                        "latitude": "19.73932000",
                        "longitude": "-100.03022000"
                    },
                    {
                        "id": 73120,
                        "name": "Rincón Verde",
                        "latitude": "19.49639000",
                        "longitude": "-99.29083000"
                    },
                    {
                        "id": 73174,
                        "name": "Río Frío de Juárez",
                        "latitude": "19.35336000",
                        "longitude": "-98.67057000"
                    },
                    {
                        "id": 73218,
                        "name": "Salitrillo",
                        "latitude": "19.43333000",
                        "longitude": "-99.85000000"
                    },
                    {
                        "id": 73238,
                        "name": "San Agustín",
                        "latitude": "18.94224000",
                        "longitude": "-99.93913000"
                    },
                    {
                        "id": 73243,
                        "name": "San Agustín Berros",
                        "latitude": "19.40272000",
                        "longitude": "-100.01048000"
                    },
                    {
                        "id": 73244,
                        "name": "San Agustín Buenavista",
                        "latitude": "20.04337000",
                        "longitude": "-99.48960000"
                    },
                    {
                        "id": 73246,
                        "name": "San Agustín Citlali",
                        "latitude": "19.48025000",
                        "longitude": "-99.80222000"
                    },
                    {
                        "id": 73260,
                        "name": "San Agustín de las Palmas",
                        "latitude": "19.32607000",
                        "longitude": "-100.14911000"
                    },
                    {
                        "id": 73248,
                        "name": "San Agustín Huitzizilapan",
                        "latitude": "19.42000000",
                        "longitude": "-99.46360000"
                    },
                    {
                        "id": 73251,
                        "name": "San Agustín Mextepec",
                        "latitude": "19.63292000",
                        "longitude": "-99.92654000"
                    },
                    {
                        "id": 73252,
                        "name": "San Agustín Mimbres",
                        "latitude": "19.45069000",
                        "longitude": "-99.55626000"
                    },
                    {
                        "id": 73264,
                        "name": "San Alejo",
                        "latitude": "18.83857000",
                        "longitude": "-99.72922000"
                    },
                    {
                        "id": 73307,
                        "name": "San Andrés de las Peras",
                        "latitude": "19.55653000",
                        "longitude": "-98.79202000"
                    },
                    {
                        "id": 73308,
                        "name": "San Andrés de los Gama",
                        "latitude": "19.03766000",
                        "longitude": "-99.97403000"
                    },
                    {
                        "id": 73309,
                        "name": "San Andrés del Pedregal",
                        "latitude": "19.58104000",
                        "longitude": "-99.86860000"
                    },
                    {
                        "id": 73285,
                        "name": "San Andrés Metla",
                        "latitude": "19.21695000",
                        "longitude": "-98.84167000"
                    },
                    {
                        "id": 73287,
                        "name": "San Andrés Nicolás Bravo",
                        "latitude": "18.76778000",
                        "longitude": "-99.46528000"
                    },
                    {
                        "id": 73288,
                        "name": "San Andrés Ocotepec",
                        "latitude": "18.90361000",
                        "longitude": "-100.04667000"
                    },
                    {
                        "id": 73297,
                        "name": "San Andrés Tepetitlán",
                        "latitude": "18.89833000",
                        "longitude": "-99.91972000"
                    },
                    {
                        "id": 73298,
                        "name": "San Andrés Timilpan",
                        "latitude": "19.87610000",
                        "longitude": "-99.73375000"
                    },
                    {
                        "id": 73299,
                        "name": "San Andrés Tlalamac",
                        "latitude": "18.96694000",
                        "longitude": "-98.80778000"
                    },
                    {
                        "id": 73319,
                        "name": "San Antonio Acahualco",
                        "latitude": "19.27400000",
                        "longitude": "-99.77169000"
                    },
                    {
                        "id": 73323,
                        "name": "San Antonio Bonixi",
                        "latitude": "19.49226000",
                        "longitude": "-99.72686000"
                    },
                    {
                        "id": 73324,
                        "name": "San Antonio Buenavista",
                        "latitude": "19.26083000",
                        "longitude": "-99.71194000"
                    },
                    {
                        "id": 73369,
                        "name": "San Antonio de la Laguna",
                        "latitude": "19.30134000",
                        "longitude": "-100.07179000"
                    },
                    {
                        "id": 73371,
                        "name": "San Antonio de las Huertas",
                        "latitude": "19.56222000",
                        "longitude": "-99.97111000"
                    },
                    {
                        "id": 73373,
                        "name": "San Antonio de las Palmas",
                        "latitude": "19.71806000",
                        "longitude": "-98.85684000"
                    },
                    {
                        "id": 73382,
                        "name": "San Antonio del Rosario",
                        "latitude": "18.40012000",
                        "longitude": "-100.30874000"
                    },
                    {
                        "id": 73385,
                        "name": "San Antonio el Llanito",
                        "latitude": "19.27750000",
                        "longitude": "-99.49500000"
                    },
                    {
                        "id": 73333,
                        "name": "San Antonio Enchisi",
                        "latitude": "19.75472000",
                        "longitude": "-99.81667000"
                    },
                    {
                        "id": 73335,
                        "name": "San Antonio Guaracha",
                        "latitude": "19.94592000",
                        "longitude": "-102.55590000"
                    },
                    {
                        "id": 73388,
                        "name": "San Antonio la Isla",
                        "latitude": "19.17317000",
                        "longitude": "-99.55400000"
                    },
                    {
                        "id": 73341,
                        "name": "San Antonio Nixini",
                        "latitude": "19.67472000",
                        "longitude": "-99.68472000"
                    },
                    {
                        "id": 73349,
                        "name": "San Antonio Solís",
                        "latitude": "19.99965000",
                        "longitude": "-100.08622000"
                    },
                    {
                        "id": 73357,
                        "name": "San Antonio Tlaltecahuacán",
                        "latitude": "19.15795000",
                        "longitude": "-98.76895000"
                    },
                    {
                        "id": 73361,
                        "name": "San Antonio Xahuento",
                        "latitude": "19.69167000",
                        "longitude": "-99.10722000"
                    },
                    {
                        "id": 73398,
                        "name": "San Bartolito Tlaltelolco",
                        "latitude": "19.19170000",
                        "longitude": "-99.56136000"
                    },
                    {
                        "id": 73399,
                        "name": "San Bartolo",
                        "latitude": "19.24496000",
                        "longitude": "-100.05329000"
                    },
                    {
                        "id": 73403,
                        "name": "San Bartolo Cuautlalpan",
                        "latitude": "19.81510000",
                        "longitude": "-99.01044000"
                    },
                    {
                        "id": 73412,
                        "name": "San Bartolo del Llano",
                        "latitude": "19.59069000",
                        "longitude": "-99.74099000"
                    },
                    {
                        "id": 73413,
                        "name": "San Bartolo del Llano (San Isidro)",
                        "latitude": "19.30528000",
                        "longitude": "-99.82750000"
                    },
                    {
                        "id": 73414,
                        "name": "San Bartolo del Progreso",
                        "latitude": "19.10156000",
                        "longitude": "-99.40409000"
                    },
                    {
                        "id": 73415,
                        "name": "San Bartolo el Viejo",
                        "latitude": "19.29889000",
                        "longitude": "-99.82389000"
                    },
                    {
                        "id": 73405,
                        "name": "San Bartolo Lanzados",
                        "latitude": "19.86639000",
                        "longitude": "-99.89389000"
                    },
                    {
                        "id": 73406,
                        "name": "San Bartolo Morelos",
                        "latitude": "19.78643000",
                        "longitude": "-99.66879000"
                    },
                    {
                        "id": 73407,
                        "name": "San Bartolo Oxtotitlán",
                        "latitude": "19.61902000",
                        "longitude": "-99.61347000"
                    },
                    {
                        "id": 73418,
                        "name": "San Bartolomé",
                        "latitude": "19.00944000",
                        "longitude": "-99.67856000"
                    },
                    {
                        "id": 73420,
                        "name": "San Bartolomé Atlatlahuca",
                        "latitude": "19.06963000",
                        "longitude": "-99.60981000"
                    },
                    {
                        "id": 73422,
                        "name": "San Bartolomé Coatepec",
                        "latitude": "19.39776000",
                        "longitude": "-99.31211000"
                    },
                    {
                        "id": 73434,
                        "name": "San Bernardino",
                        "latitude": "19.47667000",
                        "longitude": "-98.89635000"
                    },
                    {
                        "id": 73443,
                        "name": "San Bernardo Tlalmimilolpan",
                        "latitude": "19.56179000",
                        "longitude": "-98.79288000"
                    },
                    {
                        "id": 73452,
                        "name": "San Buenaventura",
                        "latitude": "19.30250000",
                        "longitude": "-98.86306000"
                    },
                    {
                        "id": 73462,
                        "name": "San Carlos Autopan",
                        "latitude": "19.38583000",
                        "longitude": "-99.68722000"
                    },
                    {
                        "id": 73481,
                        "name": "San Cristóbal Nexquipayac",
                        "latitude": "19.58010000",
                        "longitude": "-98.93053000"
                    },
                    {
                        "id": 73491,
                        "name": "San Diego",
                        "latitude": "18.97291000",
                        "longitude": "-99.58530000"
                    },
                    {
                        "id": 73497,
                        "name": "San Diego del Cerrito",
                        "latitude": "19.50795000",
                        "longitude": "-100.00684000"
                    },
                    {
                        "id": 73493,
                        "name": "San Diego Huehuecalco",
                        "latitude": "19.09276000",
                        "longitude": "-98.76336000"
                    },
                    {
                        "id": 73499,
                        "name": "San Diego la Huerta",
                        "latitude": "19.14472000",
                        "longitude": "-99.63333000"
                    },
                    {
                        "id": 73501,
                        "name": "San Diego los Padres Cuexcontitlán Sección 5 B",
                        "latitude": "19.37611000",
                        "longitude": "-99.61222000"
                    },
                    {
                        "id": 73515,
                        "name": "San Felipe Coamango",
                        "latitude": "19.85902000",
                        "longitude": "-99.60675000"
                    },
                    {
                        "id": 73531,
                        "name": "San Felipe del Progreso",
                        "latitude": "19.71440000",
                        "longitude": "-99.95197000"
                    },
                    {
                        "id": 73532,
                        "name": "San Felipe el Mirasol",
                        "latitude": "19.20266000",
                        "longitude": "-99.42113000"
                    },
                    {
                        "id": 73520,
                        "name": "San Felipe Pueblo Nuevo",
                        "latitude": "19.76778000",
                        "longitude": "-99.75833000"
                    },
                    {
                        "id": 73522,
                        "name": "San Felipe Santiago",
                        "latitude": "19.39039000",
                        "longitude": "-100.10639000"
                    },
                    {
                        "id": 73527,
                        "name": "San Felipe Tlalmimilolpan",
                        "latitude": "19.23934000",
                        "longitude": "-99.64215000"
                    },
                    {
                        "id": 73545,
                        "name": "San Francisco",
                        "latitude": "18.94931000",
                        "longitude": "-99.64723000"
                    },
                    {
                        "id": 73549,
                        "name": "San Francisco Acuautla",
                        "latitude": "19.34564000",
                        "longitude": "-98.86034000"
                    },
                    {
                        "id": 73551,
                        "name": "San Francisco Ayotuzco",
                        "latitude": "19.36583000",
                        "longitude": "-99.35694000"
                    },
                    {
                        "id": 73553,
                        "name": "San Francisco Chalchihuapan",
                        "latitude": "19.77000000",
                        "longitude": "-99.82167000"
                    },
                    {
                        "id": 73554,
                        "name": "San Francisco Chejé",
                        "latitude": "19.68044000",
                        "longitude": "-99.74877000"
                    },
                    {
                        "id": 73561,
                        "name": "San Francisco Cuaxusco",
                        "latitude": "19.26755000",
                        "longitude": "-99.61925000"
                    },
                    {
                        "id": 73612,
                        "name": "San Francisco de Guzmán",
                        "latitude": "19.62028000",
                        "longitude": "-99.77472000"
                    },
                    {
                        "id": 73577,
                        "name": "San Francisco Magú",
                        "latitude": "19.68540000",
                        "longitude": "-99.34800000"
                    },
                    {
                        "id": 73578,
                        "name": "San Francisco Mazapa",
                        "latitude": "19.69142000",
                        "longitude": "-98.83442000"
                    },
                    {
                        "id": 73579,
                        "name": "San Francisco Mihualtepec",
                        "latitude": "19.24507000",
                        "longitude": "-100.09830000"
                    },
                    {
                        "id": 73583,
                        "name": "San Francisco Oxtotilpan",
                        "latitude": "19.16926000",
                        "longitude": "-99.90273000"
                    },
                    {
                        "id": 73589,
                        "name": "San Francisco Putla",
                        "latitude": "19.12778000",
                        "longitude": "-99.63556000"
                    },
                    {
                        "id": 73591,
                        "name": "San Francisco Solis",
                        "latitude": "19.92969000",
                        "longitude": "-100.04506000"
                    },
                    {
                        "id": 73595,
                        "name": "San Francisco Tenopalco",
                        "latitude": "19.71259000",
                        "longitude": "-99.11616000"
                    },
                    {
                        "id": 73596,
                        "name": "San Francisco Tepeolulco",
                        "latitude": "19.83291000",
                        "longitude": "-99.98834000"
                    },
                    {
                        "id": 73597,
                        "name": "San Francisco Tepexoxica",
                        "latitude": "19.06043000",
                        "longitude": "-99.54783000"
                    },
                    {
                        "id": 73601,
                        "name": "San Francisco Tlalcilalcalpan",
                        "latitude": "19.29474000",
                        "longitude": "-99.76771000"
                    },
                    {
                        "id": 73602,
                        "name": "San Francisco Tlaltica",
                        "latitude": "19.65833000",
                        "longitude": "-98.77500000"
                    },
                    {
                        "id": 73605,
                        "name": "San Francisco Xochicuautla",
                        "latitude": "19.37291000",
                        "longitude": "-99.44530000"
                    },
                    {
                        "id": 73628,
                        "name": "San Gabriel Ixtla",
                        "latitude": "19.25782000",
                        "longitude": "-100.12400000"
                    },
                    {
                        "id": 73631,
                        "name": "San Gabriel Zepayautla",
                        "latitude": "19.01306000",
                        "longitude": "-99.55194000"
                    },
                    {
                        "id": 73634,
                        "name": "San Gaspar",
                        "latitude": "18.77750000",
                        "longitude": "-99.54861000"
                    },
                    {
                        "id": 73636,
                        "name": "San Gaspar Tonatico",
                        "latitude": "18.80671000",
                        "longitude": "-99.66917000"
                    },
                    {
                        "id": 73644,
                        "name": "San Gregorio Cuautzingo",
                        "latitude": "19.25962000",
                        "longitude": "-98.85742000"
                    },
                    {
                        "id": 73657,
                        "name": "San Ildefonso",
                        "latitude": "19.56111000",
                        "longitude": "-99.78583000"
                    },
                    {
                        "id": 73668,
                        "name": "San Isidro",
                        "latitude": "19.33972000",
                        "longitude": "-98.95056000"
                    },
                    {
                        "id": 73672,
                        "name": "San Isidro (El Reservado)",
                        "latitude": "19.30694000",
                        "longitude": "-99.77889000"
                    },
                    {
                        "id": 73675,
                        "name": "San Isidro Boxipe",
                        "latitude": "19.60111000",
                        "longitude": "-99.89083000"
                    },
                    {
                        "id": 73692,
                        "name": "San Jacinto",
                        "latitude": "19.36288000",
                        "longitude": "-99.32308000"
                    },
                    {
                        "id": 73700,
                        "name": "San Jerónimo",
                        "latitude": "19.24255000",
                        "longitude": "-100.02224000"
                    },
                    {
                        "id": 73703,
                        "name": "San Jerónimo Amanalco",
                        "latitude": "19.51791000",
                        "longitude": "-98.75673000"
                    },
                    {
                        "id": 73705,
                        "name": "San Jerónimo Bonchete",
                        "latitude": "19.63106000",
                        "longitude": "-99.94949000"
                    },
                    {
                        "id": 73710,
                        "name": "San Jerónimo Cuatro Vientos",
                        "latitude": "19.29306000",
                        "longitude": "-98.84167000"
                    },
                    {
                        "id": 73726,
                        "name": "San Jerónimo de los Jarros",
                        "latitude": "19.87861000",
                        "longitude": "-99.92333000"
                    },
                    {
                        "id": 73711,
                        "name": "San Jerónimo Ixtapantongo",
                        "latitude": "19.53872000",
                        "longitude": "-99.76779000"
                    },
                    {
                        "id": 73719,
                        "name": "San Jerónimo Totoltepec",
                        "latitude": "19.31494000",
                        "longitude": "-100.20290000"
                    },
                    {
                        "id": 73729,
                        "name": "San Joaquín Coapango",
                        "latitude": "19.54043000",
                        "longitude": "-98.82739000"
                    },
                    {
                        "id": 73730,
                        "name": "San Joaquín del Monte",
                        "latitude": "19.41967000",
                        "longitude": "-99.90161000"
                    },
                    {
                        "id": 73732,
                        "name": "San Jorge Pueblo Nuevo",
                        "latitude": "19.25417000",
                        "longitude": "-99.62778000"
                    },
                    {
                        "id": 73746,
                        "name": "San José Barbabosa",
                        "latitude": "19.27583000",
                        "longitude": "-99.72000000"
                    },
                    {
                        "id": 73747,
                        "name": "San José Boqui",
                        "latitude": "19.70167000",
                        "longitude": "-99.72861000"
                    },
                    {
                        "id": 73755,
                        "name": "San José Chalmita",
                        "latitude": "18.85862000",
                        "longitude": "-99.54831000"
                    },
                    {
                        "id": 73838,
                        "name": "San José del Progreso",
                        "latitude": "18.93443000",
                        "longitude": "-99.79230000"
                    },
                    {
                        "id": 73840,
                        "name": "San José del Puente",
                        "latitude": "19.72056000",
                        "longitude": "-99.19667000"
                    },
                    {
                        "id": 73841,
                        "name": "San José del Rincón Centro",
                        "latitude": "19.66216000",
                        "longitude": "-100.15315000"
                    },
                    {
                        "id": 73843,
                        "name": "San José del Sitio",
                        "latitude": "19.60263000",
                        "longitude": "-99.66627000"
                    },
                    {
                        "id": 73846,
                        "name": "San José del Tunal",
                        "latitude": "19.79056000",
                        "longitude": "-99.84000000"
                    },
                    {
                        "id": 73848,
                        "name": "San José el Cuartel",
                        "latitude": "18.95972000",
                        "longitude": "-99.57722000"
                    },
                    {
                        "id": 73852,
                        "name": "San José el Vidrio",
                        "latitude": "19.65333000",
                        "longitude": "-99.38417000"
                    },
                    {
                        "id": 73765,
                        "name": "San José Guadalupe Otzacatipan",
                        "latitude": "19.34472000",
                        "longitude": "-99.59194000"
                    },
                    {
                        "id": 73856,
                        "name": "San José las Lomas",
                        "latitude": "19.47936000",
                        "longitude": "-99.67052000"
                    },
                    {
                        "id": 73857,
                        "name": "San José las Palmas",
                        "latitude": "19.36724000",
                        "longitude": "-98.93368000"
                    },
                    {
                        "id": 73774,
                        "name": "San José Mezapa Sección I",
                        "latitude": "19.16306000",
                        "longitude": "-99.45500000"
                    },
                    {
                        "id": 73779,
                        "name": "San José Pathé",
                        "latitude": "19.43528000",
                        "longitude": "-99.63111000"
                    },
                    {
                        "id": 73785,
                        "name": "San José Tejamanil",
                        "latitude": "19.43139000",
                        "longitude": "-99.35889000"
                    },
                    {
                        "id": 73789,
                        "name": "San José Tenería (Tenería)",
                        "latitude": "18.95028000",
                        "longitude": "-99.54306000"
                    },
                    {
                        "id": 73794,
                        "name": "San José Tlacotitlán",
                        "latitude": "18.98583000",
                        "longitude": "-98.80611000"
                    },
                    {
                        "id": 73796,
                        "name": "San José Toxi",
                        "latitude": "19.86803000",
                        "longitude": "-99.93736000"
                    },
                    {
                        "id": 73799,
                        "name": "San José Villa de Allende",
                        "latitude": "19.37521000",
                        "longitude": "-100.14850000"
                    },
                    {
                        "id": 73859,
                        "name": "San Juan",
                        "latitude": "19.24677000",
                        "longitude": "-100.03040000"
                    },
                    {
                        "id": 73867,
                        "name": "San Juan Atezcapan",
                        "latitude": "19.16736000",
                        "longitude": "-100.18491000"
                    },
                    {
                        "id": 73879,
                        "name": "San Juan Coajomulco",
                        "latitude": "19.75306000",
                        "longitude": "-99.96861000"
                    },
                    {
                        "id": 73883,
                        "name": "San Juan Cote Ejido",
                        "latitude": "19.60516000",
                        "longitude": "-99.95913000"
                    },
                    {
                        "id": 73885,
                        "name": "San Juan Coxtocan",
                        "latitude": "19.13932000",
                        "longitude": "-98.84728000"
                    },
                    {
                        "id": 73888,
                        "name": "San Juan Daxthi",
                        "latitude": "20.09838000",
                        "longitude": "-99.52599000"
                    },
                    {
                        "id": 73967,
                        "name": "San Juan de las Huertas",
                        "latitude": "19.24755000",
                        "longitude": "-99.75834000"
                    },
                    {
                        "id": 73968,
                        "name": "San Juan de las Manzanas",
                        "latitude": "19.55111000",
                        "longitude": "-99.83833000"
                    },
                    {
                        "id": 73970,
                        "name": "San Juan de los Jarros",
                        "latitude": "19.86194000",
                        "longitude": "-99.91611000"
                    },
                    {
                        "id": 73901,
                        "name": "San Juan Jalpa Centro",
                        "latitude": "19.69806000",
                        "longitude": "-99.93000000"
                    },
                    {
                        "id": 73928,
                        "name": "San Juan Tehuixtitlán",
                        "latitude": "19.05428000",
                        "longitude": "-98.76718000"
                    },
                    {
                        "id": 73933,
                        "name": "San Juan Tepecoculco",
                        "latitude": "18.98306000",
                        "longitude": "-98.78750000"
                    },
                    {
                        "id": 73942,
                        "name": "San Juan Tlacotompa (Tlacotompa)",
                        "latitude": "18.94111000",
                        "longitude": "-98.79056000"
                    },
                    {
                        "id": 73943,
                        "name": "San Juan Tomasquillo Herradura",
                        "latitude": "19.17222000",
                        "longitude": "-99.40389000"
                    },
                    {
                        "id": 73944,
                        "name": "San Juan Totolapan",
                        "latitude": "19.53093000",
                        "longitude": "-98.72691000"
                    },
                    {
                        "id": 73947,
                        "name": "San Juan Tuxtepec",
                        "latitude": "19.85865000",
                        "longitude": "-99.63289000"
                    },
                    {
                        "id": 73951,
                        "name": "San Juan Xoconusco",
                        "latitude": "19.31159000",
                        "longitude": "-100.25930000"
                    },
                    {
                        "id": 73979,
                        "name": "San Juan y San Pedro Tezompa",
                        "latitude": "19.20680000",
                        "longitude": "-98.96073000"
                    },
                    {
                        "id": 73981,
                        "name": "San Juanico Sector Uno",
                        "latitude": "19.93458000",
                        "longitude": "-99.76778000"
                    },
                    {
                        "id": 74003,
                        "name": "San Lorenzo Huehuetitlán",
                        "latitude": "19.13417000",
                        "longitude": "-99.48222000"
                    },
                    {
                        "id": 74006,
                        "name": "San Lorenzo Malacota",
                        "latitude": "19.64950000",
                        "longitude": "-99.61363000"
                    },
                    {
                        "id": 74013,
                        "name": "San Lorenzo Tlacotepec",
                        "latitude": "19.81250000",
                        "longitude": "-99.91222000"
                    },
                    {
                        "id": 74015,
                        "name": "San Lorenzo Tlalmimilolpan",
                        "latitude": "19.66731000",
                        "longitude": "-98.87221000"
                    },
                    {
                        "id": 74017,
                        "name": "San Lorenzo Toxico",
                        "latitude": "19.50917000",
                        "longitude": "-99.76278000"
                    },
                    {
                        "id": 74024,
                        "name": "San Lucas",
                        "latitude": "18.97806000",
                        "longitude": "-99.66056000"
                    },
                    {
                        "id": 74025,
                        "name": "San Lucas Amalinalco",
                        "latitude": "19.27046000",
                        "longitude": "-98.86403000"
                    },
                    {
                        "id": 74039,
                        "name": "San Lucas del Pulque",
                        "latitude": "19.10139000",
                        "longitude": "-100.02806000"
                    },
                    {
                        "id": 74029,
                        "name": "San Lucas Huitzilhuacán",
                        "latitude": "19.58694000",
                        "longitude": "-98.88362000"
                    },
                    {
                        "id": 74030,
                        "name": "San Lucas Ocotepec",
                        "latitude": "19.67833000",
                        "longitude": "-99.97194000"
                    },
                    {
                        "id": 74035,
                        "name": "San Lucas Texcaltitlán",
                        "latitude": "19.30065000",
                        "longitude": "-100.17163000"
                    },
                    {
                        "id": 74037,
                        "name": "San Lucas Totolmaloya",
                        "latitude": "20.16333000",
                        "longitude": "-99.89722000"
                    },
                    {
                        "id": 74046,
                        "name": "San Luis Anáhuac (Toriles)",
                        "latitude": "19.79679000",
                        "longitude": "-99.40029000"
                    },
                    {
                        "id": 74049,
                        "name": "San Luis Boro",
                        "latitude": "19.81316000",
                        "longitude": "-99.85580000"
                    },
                    {
                        "id": 74054,
                        "name": "San Luis Taxhimay",
                        "latitude": "19.83972000",
                        "longitude": "-99.39861000"
                    },
                    {
                        "id": 74081,
                        "name": "San Marcos de la Loma",
                        "latitude": "19.50112000",
                        "longitude": "-99.96041000"
                    },
                    {
                        "id": 74072,
                        "name": "San Marcos Huixtoco",
                        "latitude": "19.29668000",
                        "longitude": "-98.86369000"
                    },
                    {
                        "id": 74073,
                        "name": "San Marcos Nepantla",
                        "latitude": "19.66930000",
                        "longitude": "-98.93198000"
                    },
                    {
                        "id": 74074,
                        "name": "San Marcos Tecomaxusco",
                        "latitude": "18.98152000",
                        "longitude": "-98.76035000"
                    },
                    {
                        "id": 74076,
                        "name": "San Marcos Tlazalpan",
                        "latitude": "19.80611000",
                        "longitude": "-99.71750000"
                    },
                    {
                        "id": 74077,
                        "name": "San Marcos Yachihuacaltepec",
                        "latitude": "19.32319000",
                        "longitude": "-99.67910000"
                    },
                    {
                        "id": 74086,
                        "name": "San Martín",
                        "latitude": "20.21570000",
                        "longitude": "-101.61140000"
                    },
                    {
                        "id": 74088,
                        "name": "San Martín Ahuatepec",
                        "latitude": "19.68139000",
                        "longitude": "-98.72806000"
                    },
                    {
                        "id": 74089,
                        "name": "San Martín Azcatepec",
                        "latitude": "19.68667000",
                        "longitude": "-98.97278000"
                    },
                    {
                        "id": 74090,
                        "name": "San Martín Cachihuapan",
                        "latitude": "19.70789000",
                        "longitude": "-99.43124000"
                    },
                    {
                        "id": 74093,
                        "name": "San Martín Coapaxtongo",
                        "latitude": "18.99417000",
                        "longitude": "-99.57000000"
                    },
                    {
                        "id": 74094,
                        "name": "San Martín Cuautlalpan",
                        "latitude": "19.27618000",
                        "longitude": "-98.83167000"
                    },
                    {
                        "id": 74113,
                        "name": "San Martín de las Pirámides",
                        "latitude": "19.70582000",
                        "longitude": "-98.83554000"
                    },
                    {
                        "id": 74095,
                        "name": "San Martín Ejido",
                        "latitude": "20.07156000",
                        "longitude": "-99.69393000"
                    },
                    {
                        "id": 74101,
                        "name": "San Martín Obispo (San Martín San Pedro)",
                        "latitude": "19.31944000",
                        "longitude": "-100.07472000"
                    },
                    {
                        "id": 74105,
                        "name": "San Martín Tequesquipan (Tequesquipan)",
                        "latitude": "19.05806000",
                        "longitude": "-99.94667000"
                    },
                    {
                        "id": 74110,
                        "name": "San Martín Toltepec",
                        "latitude": "19.35194000",
                        "longitude": "-99.70583000"
                    },
                    {
                        "id": 74112,
                        "name": "San Martín Tuchicuitlapilco",
                        "latitude": "20.09397000",
                        "longitude": "-99.64669000"
                    },
                    {
                        "id": 74116,
                        "name": "San Mateo",
                        "latitude": "19.27950000",
                        "longitude": "-100.01510000"
                    },
                    {
                        "id": 74117,
                        "name": "San Mateo Almomoloha",
                        "latitude": "19.14590000",
                        "longitude": "-99.93478000"
                    },
                    {
                        "id": 74119,
                        "name": "San Mateo Atenco",
                        "latitude": "19.26757000",
                        "longitude": "-99.53214000"
                    },
                    {
                        "id": 74122,
                        "name": "San Mateo Capulhuac",
                        "latitude": "19.47028000",
                        "longitude": "-99.52611000"
                    },
                    {
                        "id": 74124,
                        "name": "San Mateo Coapexco",
                        "latitude": "18.96163000",
                        "longitude": "-99.68346000"
                    },
                    {
                        "id": 74143,
                        "name": "San Mateo el Viejo",
                        "latitude": "19.91441000",
                        "longitude": "-99.91080000"
                    },
                    {
                        "id": 74126,
                        "name": "San Mateo Huitzilzingo",
                        "latitude": "19.22906000",
                        "longitude": "-98.92504000"
                    },
                    {
                        "id": 74127,
                        "name": "San Mateo Ixtacalco",
                        "latitude": "19.69920000",
                        "longitude": "-99.17159000"
                    },
                    {
                        "id": 74128,
                        "name": "San Mateo Ixtlahuaca",
                        "latitude": "19.60651000",
                        "longitude": "-99.80098000"
                    },
                    {
                        "id": 74129,
                        "name": "San Mateo Mozoquilpan",
                        "latitude": "19.43414000",
                        "longitude": "-99.55466000"
                    },
                    {
                        "id": 74137,
                        "name": "San Mateo Tecalco",
                        "latitude": "19.05315000",
                        "longitude": "-98.79576000"
                    },
                    {
                        "id": 74138,
                        "name": "San Mateo Texcalyacac",
                        "latitude": "19.16667000",
                        "longitude": "-99.46667000"
                    },
                    {
                        "id": 74139,
                        "name": "San Mateo Tlalchichilpan",
                        "latitude": "19.34277000",
                        "longitude": "-99.75769000"
                    },
                    {
                        "id": 74140,
                        "name": "San Mateo Xoloc",
                        "latitude": "19.70650000",
                        "longitude": "-99.24818000"
                    },
                    {
                        "id": 74146,
                        "name": "San Matías Cuijingo",
                        "latitude": "19.08487000",
                        "longitude": "-98.85307000"
                    },
                    {
                        "id": 74149,
                        "name": "San Miguel",
                        "latitude": "18.99105000",
                        "longitude": "-99.66555000"
                    },
                    {
                        "id": 74155,
                        "name": "San Miguel Agua Bendita",
                        "latitude": "19.63037000",
                        "longitude": "-100.07933000"
                    },
                    {
                        "id": 74159,
                        "name": "San Miguel Almoloyan",
                        "latitude": "19.35500000",
                        "longitude": "-99.79932000"
                    },
                    {
                        "id": 74165,
                        "name": "San Miguel Atlamajac",
                        "latitude": "19.74884000",
                        "longitude": "-98.93335000"
                    },
                    {
                        "id": 74172,
                        "name": "San Miguel Coatlinchán",
                        "latitude": "19.44999000",
                        "longitude": "-98.87274000"
                    },
                    {
                        "id": 74234,
                        "name": "San Miguel del Centro",
                        "latitude": "19.72067000",
                        "longitude": "-100.10875000"
                    },
                    {
                        "id": 74177,
                        "name": "San Miguel Enyege",
                        "latitude": "19.56984000",
                        "longitude": "-99.85962000"
                    },
                    {
                        "id": 74181,
                        "name": "San Miguel Hila",
                        "latitude": "19.59361000",
                        "longitude": "-99.32528000"
                    },
                    {
                        "id": 74183,
                        "name": "San Miguel Ixtapan",
                        "latitude": "18.80728000",
                        "longitude": "-100.15245000"
                    },
                    {
                        "id": 74184,
                        "name": "San Miguel Jaltocan",
                        "latitude": "19.72306000",
                        "longitude": "-99.05028000"
                    },
                    {
                        "id": 74185,
                        "name": "San Miguel Laderas",
                        "latitude": "18.88319000",
                        "longitude": "-99.69686000"
                    },
                    {
                        "id": 74187,
                        "name": "San Miguel Mimlapan",
                        "latitude": "19.44829000",
                        "longitude": "-99.46328000"
                    },
                    {
                        "id": 74192,
                        "name": "San Miguel Oxtotilpan",
                        "latitude": "19.14380000",
                        "longitude": "-99.89590000"
                    },
                    {
                        "id": 74199,
                        "name": "San Miguel Tecomatlán",
                        "latitude": "18.97833000",
                        "longitude": "-99.52861000"
                    },
                    {
                        "id": 74200,
                        "name": "San Miguel Tecpan",
                        "latitude": "19.53213000",
                        "longitude": "-99.39803000"
                    },
                    {
                        "id": 74206,
                        "name": "San Miguel Tenochtitlán",
                        "latitude": "19.76028000",
                        "longitude": "-99.92250000"
                    },
                    {
                        "id": 74213,
                        "name": "San Miguel Tlaixpan",
                        "latitude": "19.50958000",
                        "longitude": "-98.81083000"
                    },
                    {
                        "id": 74217,
                        "name": "San Miguel Totocuitlapilco",
                        "latitude": "19.22889000",
                        "longitude": "-99.59417000"
                    },
                    {
                        "id": 74222,
                        "name": "San Miguel Xoltepec",
                        "latitude": "19.25265000",
                        "longitude": "-100.08320000"
                    },
                    {
                        "id": 74224,
                        "name": "San Miguel Yuxtepec",
                        "latitude": "19.54056000",
                        "longitude": "-99.71250000"
                    },
                    {
                        "id": 74252,
                        "name": "San Nicolás",
                        "latitude": "18.93333000",
                        "longitude": "-99.56833000"
                    },
                    {
                        "id": 74253,
                        "name": "San Nicolás Amealco",
                        "latitude": "19.32599000",
                        "longitude": "-99.87146000"
                    },
                    {
                        "id": 74277,
                        "name": "San Nicolás el Oro",
                        "latitude": "19.80593000",
                        "longitude": "-100.11753000"
                    },
                    {
                        "id": 74256,
                        "name": "San Nicolás Guadalupe",
                        "latitude": "19.61412000",
                        "longitude": "-100.03080000"
                    },
                    {
                        "id": 74266,
                        "name": "San Nicolás Tolentino",
                        "latitude": "19.35889000",
                        "longitude": "-99.57167000"
                    },
                    {
                        "id": 74282,
                        "name": "San Pablo Atlazalpan",
                        "latitude": "19.21742000",
                        "longitude": "-98.90763000"
                    },
                    {
                        "id": 74283,
                        "name": "San Pablo Atotonilco",
                        "latitude": "19.79627000",
                        "longitude": "-99.82301000"
                    },
                    {
                        "id": 74304,
                        "name": "San Pablo de las Salinas",
                        "latitude": "19.66658000",
                        "longitude": "-99.09477000"
                    },
                    {
                        "id": 74306,
                        "name": "San Pablo de los Gallos",
                        "latitude": "19.67722000",
                        "longitude": "-99.24611000"
                    },
                    {
                        "id": 74307,
                        "name": "San Pablo de los Remedios",
                        "latitude": "19.64111000",
                        "longitude": "-99.83833000"
                    },
                    {
                        "id": 74291,
                        "name": "San Pablo Huantepec",
                        "latitude": "19.98216000",
                        "longitude": "-99.49126000"
                    },
                    {
                        "id": 74294,
                        "name": "San Pablo Ixayoc",
                        "latitude": "19.47317000",
                        "longitude": "-98.79522000"
                    },
                    {
                        "id": 74295,
                        "name": "San Pablo Ixquitlán",
                        "latitude": "19.70944000",
                        "longitude": "-98.78833000"
                    },
                    {
                        "id": 74300,
                        "name": "San Pablo Tecalco",
                        "latitude": "19.67309000",
                        "longitude": "-98.95837000"
                    },
                    {
                        "id": 74301,
                        "name": "San Pablo Tejalpa",
                        "latitude": "18.86667000",
                        "longitude": "-99.59111000"
                    },
                    {
                        "id": 74310,
                        "name": "San Pedro Abajo",
                        "latitude": "19.48093000",
                        "longitude": "-99.56700000"
                    },
                    {
                        "id": 74314,
                        "name": "San Pedro Arriba",
                        "latitude": "19.48641000",
                        "longitude": "-99.56253000"
                    },
                    {
                        "id": 74315,
                        "name": "San Pedro Arriba 3ra. Sección",
                        "latitude": "19.50083000",
                        "longitude": "-99.55722000"
                    },
                    {
                        "id": 74323,
                        "name": "San Pedro Chiautzingo",
                        "latitude": "19.57111000",
                        "longitude": "-98.78878000"
                    },
                    {
                        "id": 74326,
                        "name": "San Pedro Cholula",
                        "latitude": "19.26444000",
                        "longitude": "-99.48639000"
                    },
                    {
                        "id": 74406,
                        "name": "San Pedro de la Hortaliza (Ejido Almoloyán)",
                        "latitude": "19.38806000",
                        "longitude": "-99.81778000"
                    },
                    {
                        "id": 74407,
                        "name": "San Pedro de los Baños",
                        "latitude": "19.66873000",
                        "longitude": "-99.83533000"
                    },
                    {
                        "id": 74408,
                        "name": "San Pedro de los Metates",
                        "latitude": "19.89907000",
                        "longitude": "-99.85827000"
                    },
                    {
                        "id": 74412,
                        "name": "San Pedro del Rincón",
                        "latitude": "19.43515000",
                        "longitude": "-100.01353000"
                    },
                    {
                        "id": 74413,
                        "name": "San Pedro del Rosal",
                        "latitude": "19.77806000",
                        "longitude": "-99.81250000"
                    },
                    {
                        "id": 74333,
                        "name": "San Pedro Denxhi Centro",
                        "latitude": "20.25026000",
                        "longitude": "-99.96731000"
                    },
                    {
                        "id": 74414,
                        "name": "San Pedro el Alto",
                        "latitude": "19.58429000",
                        "longitude": "-99.88050000"
                    },
                    {
                        "id": 74342,
                        "name": "San Pedro Huitzizilapan",
                        "latitude": "19.40573000",
                        "longitude": "-99.47813000"
                    },
                    {
                        "id": 74350,
                        "name": "San Pedro Limón",
                        "latitude": "18.58200000",
                        "longitude": "-100.30707000"
                    },
                    {
                        "id": 74351,
                        "name": "San Pedro Los Baños",
                        "latitude": "19.62537000",
                        "longitude": "-99.82170000"
                    },
                    {
                        "id": 74361,
                        "name": "San Pedro Nexapa",
                        "latitude": "19.08365000",
                        "longitude": "-98.73724000"
                    },
                    {
                        "id": 74373,
                        "name": "San Pedro Tarímbaro",
                        "latitude": "19.80799000",
                        "longitude": "-100.22541000"
                    },
                    {
                        "id": 74376,
                        "name": "San Pedro Tejalpa",
                        "latitude": "19.25809000",
                        "longitude": "-99.79232000"
                    },
                    {
                        "id": 74379,
                        "name": "San Pedro Tenayac",
                        "latitude": "19.04667000",
                        "longitude": "-100.17694000"
                    },
                    {
                        "id": 74380,
                        "name": "San Pedro Tepetitlán",
                        "latitude": "19.62839000",
                        "longitude": "-98.88839000"
                    },
                    {
                        "id": 74424,
                        "name": "San Rafael",
                        "latitude": "19.20959000",
                        "longitude": "-98.75636000"
                    },
                    {
                        "id": 74441,
                        "name": "San Roque",
                        "latitude": "19.48028000",
                        "longitude": "-99.96056000"
                    },
                    {
                        "id": 74446,
                        "name": "San Salvador Atenco",
                        "latitude": "19.55170000",
                        "longitude": "-98.91867000"
                    },
                    {
                        "id": 74449,
                        "name": "San Salvador Tizatlalli",
                        "latitude": "19.26028000",
                        "longitude": "-99.59083000"
                    },
                    {
                        "id": 74457,
                        "name": "San Sebastián",
                        "latitude": "19.75101000",
                        "longitude": "-99.21441000"
                    },
                    {
                        "id": 74460,
                        "name": "San Sebastián Buenos Aires",
                        "latitude": "19.72722000",
                        "longitude": "-99.60361000"
                    },
                    {
                        "id": 74461,
                        "name": "San Sebastián Chimalpa",
                        "latitude": "19.38151000",
                        "longitude": "-98.95505000"
                    },
                    {
                        "id": 74474,
                        "name": "San Sebastián Xolalpa",
                        "latitude": "19.67653000",
                        "longitude": "-98.84529000"
                    },
                    {
                        "id": 74487,
                        "name": "San Simón de Guerrero",
                        "latitude": "19.02276000",
                        "longitude": "-100.00645000"
                    },
                    {
                        "id": 74488,
                        "name": "San Simón de la Laguna",
                        "latitude": "19.29273000",
                        "longitude": "-100.08070000"
                    },
                    {
                        "id": 74489,
                        "name": "San Simón el Alto",
                        "latitude": "18.99653000",
                        "longitude": "-99.50344000"
                    },
                    {
                        "id": 74481,
                        "name": "San Simonito",
                        "latitude": "18.99139000",
                        "longitude": "-99.54000000"
                    },
                    {
                        "id": 74495,
                        "name": "San Vicente (Calpulalpan Tercera Manzana)",
                        "latitude": "20.03722000",
                        "longitude": "-99.64167000"
                    },
                    {
                        "id": 74497,
                        "name": "San Vicente Chimalhuacán",
                        "latitude": "19.02381000",
                        "longitude": "-98.80176000"
                    },
                    {
                        "id": 74515,
                        "name": "Sanata Lucía",
                        "latitude": "19.74807000",
                        "longitude": "-98.98069000"
                    },
                    {
                        "id": 74522,
                        "name": "Santa Ana",
                        "latitude": "18.98750000",
                        "longitude": "-99.41333000"
                    },
                    {
                        "id": 74535,
                        "name": "Santa Ana Ixtlahuaca (Santa Ana Ixtlahuacingo)",
                        "latitude": "19.58472000",
                        "longitude": "-99.88750000"
                    },
                    {
                        "id": 74536,
                        "name": "Santa Ana Ixtlahuatzingo (Santa Ana)",
                        "latitude": "18.97056000",
                        "longitude": "-99.62361000"
                    },
                    {
                        "id": 74537,
                        "name": "Santa Ana Jilotzingo",
                        "latitude": "19.54116000",
                        "longitude": "-99.39477000"
                    },
                    {
                        "id": 74557,
                        "name": "Santa Ana la Ladera",
                        "latitude": "19.59583000",
                        "longitude": "-99.87000000"
                    },
                    {
                        "id": 74540,
                        "name": "Santa Ana Mayorazgo",
                        "latitude": "19.42951000",
                        "longitude": "-99.51270000"
                    },
                    {
                        "id": 74542,
                        "name": "Santa Ana Nextlalpan",
                        "latitude": "19.74171000",
                        "longitude": "-99.07496000"
                    },
                    {
                        "id": 74543,
                        "name": "Santa Ana Nichi Ejido",
                        "latitude": "19.58441000",
                        "longitude": "-99.98905000"
                    },
                    {
                        "id": 74551,
                        "name": "Santa Ana Zicatecoyan",
                        "latitude": "18.57167000",
                        "longitude": "-100.22000000"
                    },
                    {
                        "id": 74576,
                        "name": "Santa Catarina",
                        "latitude": "19.63659000",
                        "longitude": "-98.92651000"
                    },
                    {
                        "id": 74581,
                        "name": "Santa Catarina Ayotzingo",
                        "latitude": "19.20948000",
                        "longitude": "-98.92985000"
                    },
                    {
                        "id": 74594,
                        "name": "Santa Catarina del Monte",
                        "latitude": "19.48404000",
                        "longitude": "-98.77239000"
                    },
                    {
                        "id": 74602,
                        "name": "Santa Clara de Juárez",
                        "latitude": "19.71909000",
                        "longitude": "-99.60695000"
                    },
                    {
                        "id": 74609,
                        "name": "Santa Cruz",
                        "latitude": "18.83333000",
                        "longitude": "-99.98333000"
                    },
                    {
                        "id": 74618,
                        "name": "Santa Cruz Atizapán",
                        "latitude": "19.17692000",
                        "longitude": "-99.48852000"
                    },
                    {
                        "id": 74620,
                        "name": "Santa Cruz Bombatevi",
                        "latitude": "19.80500000",
                        "longitude": "-99.88667000"
                    },
                    {
                        "id": 74621,
                        "name": "Santa Cruz Cuauhtenco",
                        "latitude": "19.24907000",
                        "longitude": "-99.72939000"
                    },
                    {
                        "id": 74650,
                        "name": "Santa Cruz del Monte",
                        "latitude": "19.76702000",
                        "longitude": "-99.22867000"
                    },
                    {
                        "id": 74626,
                        "name": "Santa Cruz Huitzizilapan",
                        "latitude": "19.39694000",
                        "longitude": "-99.44806000"
                    },
                    {
                        "id": 74629,
                        "name": "Santa Cruz Mextepec",
                        "latitude": "19.65972000",
                        "longitude": "-99.95306000"
                    },
                    {
                        "id": 74638,
                        "name": "Santa Cruz Pueblo Nuevo (Pueblo Nuevo)",
                        "latitude": "19.10000000",
                        "longitude": "-99.65806000"
                    },
                    {
                        "id": 74665,
                        "name": "Santa Gertrudis",
                        "latitude": "19.73333000",
                        "longitude": "-99.36667000"
                    },
                    {
                        "id": 74676,
                        "name": "Santa Isabel Chalma",
                        "latitude": "19.15712000",
                        "longitude": "-98.76533000"
                    },
                    {
                        "id": 74678,
                        "name": "Santa Isabel Ixtapan",
                        "latitude": "19.58655000",
                        "longitude": "-98.94667000"
                    },
                    {
                        "id": 74682,
                        "name": "Santa Juana Centro",
                        "latitude": "19.42406000",
                        "longitude": "-99.75063000"
                    },
                    {
                        "id": 74683,
                        "name": "Santa Juana Primera Sección",
                        "latitude": "19.39018000",
                        "longitude": "-99.75186000"
                    },
                    {
                        "id": 74686,
                        "name": "Santa Lucía",
                        "latitude": "19.02749000",
                        "longitude": "-99.38683000"
                    },
                    {
                        "id": 74702,
                        "name": "Santa María",
                        "latitude": "19.85704000",
                        "longitude": "-99.55486000"
                    },
                    {
                        "id": 74708,
                        "name": "Santa María Ajoloapan",
                        "latitude": "19.97694000",
                        "longitude": "-99.04472000"
                    },
                    {
                        "id": 74714,
                        "name": "Santa María Aranzazú (Santa María)",
                        "latitude": "18.98833000",
                        "longitude": "-99.65056000"
                    },
                    {
                        "id": 74723,
                        "name": "Santa María Canchesdá",
                        "latitude": "19.85521000",
                        "longitude": "-100.05592000"
                    },
                    {
                        "id": 74728,
                        "name": "Santa María Chimalhuacán",
                        "latitude": "19.42155000",
                        "longitude": "-98.95038000"
                    },
                    {
                        "id": 74729,
                        "name": "Santa María Citendejé",
                        "latitude": "19.78190000",
                        "longitude": "-99.92863000"
                    },
                    {
                        "id": 74733,
                        "name": "Santa María Cuevas",
                        "latitude": "19.86611000",
                        "longitude": "-99.09875000"
                    },
                    {
                        "id": 74805,
                        "name": "Santa María de Guadalupe",
                        "latitude": "19.82111000",
                        "longitude": "-99.12778000"
                    },
                    {
                        "id": 74811,
                        "name": "Santa María del Llano",
                        "latitude": "19.63444000",
                        "longitude": "-99.72500000"
                    },
                    {
                        "id": 74813,
                        "name": "Santa María del Monte",
                        "latitude": "19.28973000",
                        "longitude": "-99.82355000"
                    },
                    {
                        "id": 74735,
                        "name": "Santa María Endare",
                        "latitude": "19.72556000",
                        "longitude": "-99.81583000"
                    },
                    {
                        "id": 74742,
                        "name": "Santa María Huecatitla",
                        "latitude": "19.72511000",
                        "longitude": "-99.16911000"
                    },
                    {
                        "id": 74743,
                        "name": "Santa María Huexoculco",
                        "latitude": "19.25804000",
                        "longitude": "-98.82050000"
                    },
                    {
                        "id": 74750,
                        "name": "Santa María Jajalpa",
                        "latitude": "19.11167000",
                        "longitude": "-99.53583000"
                    },
                    {
                        "id": 74822,
                        "name": "Santa María la Asunción",
                        "latitude": "19.26750000",
                        "longitude": "-99.55250000"
                    },
                    {
                        "id": 74756,
                        "name": "Santa María Magdalena Cahuacán",
                        "latitude": "19.63804000",
                        "longitude": "-99.41349000"
                    },
                    {
                        "id": 74759,
                        "name": "Santa María Mazatla",
                        "latitude": "19.51528000",
                        "longitude": "-99.38694000"
                    },
                    {
                        "id": 74762,
                        "name": "Santa María Nativitas",
                        "latitude": "19.21139000",
                        "longitude": "-99.62944000"
                    },
                    {
                        "id": 74767,
                        "name": "Santa María Palapa",
                        "latitude": "19.73589000",
                        "longitude": "-98.84834000"
                    },
                    {
                        "id": 74769,
                        "name": "Santa María Pipioltepec (Pipioltepec)",
                        "latitude": "19.24056000",
                        "longitude": "-100.09750000"
                    },
                    {
                        "id": 74774,
                        "name": "Santa María Rayón",
                        "latitude": "19.14808000",
                        "longitude": "-99.57974000"
                    },
                    {
                        "id": 74778,
                        "name": "Santa María Tecuanulco",
                        "latitude": "19.50660000",
                        "longitude": "-98.76211000"
                    },
                    {
                        "id": 74787,
                        "name": "Santa María Tlalmimilolpan",
                        "latitude": "19.39130000",
                        "longitude": "-99.47088000"
                    },
                    {
                        "id": 74789,
                        "name": "Santa María Totoltepec",
                        "latitude": "19.30653000",
                        "longitude": "-99.59279000"
                    },
                    {
                        "id": 74803,
                        "name": "Santa María Zolotepec",
                        "latitude": "19.41728000",
                        "longitude": "-99.49327000"
                    },
                    {
                        "id": 74699,
                        "name": "Santa Martha",
                        "latitude": "19.43145000",
                        "longitude": "-98.91744000"
                    },
                    {
                        "id": 74827,
                        "name": "Santa Mónica",
                        "latitude": "18.99306000",
                        "longitude": "-99.42361000"
                    },
                    {
                        "id": 74849,
                        "name": "Santa Rosa de Lima",
                        "latitude": "19.78587000",
                        "longitude": "-100.09606000"
                    },
                    {
                        "id": 74861,
                        "name": "Santa Teresa",
                        "latitude": "19.84500000",
                        "longitude": "-99.23333000"
                    },
                    {
                        "id": 74874,
                        "name": "Santiago Acutzilapan",
                        "latitude": "19.78640000",
                        "longitude": "-99.76569000"
                    },
                    {
                        "id": 74886,
                        "name": "Santiago Casandeje",
                        "latitude": "19.76972000",
                        "longitude": "-99.96917000"
                    },
                    {
                        "id": 74890,
                        "name": "Santiago Chimalpa (Chimalpa)",
                        "latitude": "19.56917000",
                        "longitude": "-98.89167000"
                    },
                    {
                        "id": 74892,
                        "name": "Santiago Citendejé",
                        "latitude": "19.78139000",
                        "longitude": "-99.92917000"
                    },
                    {
                        "id": 74893,
                        "name": "Santiago Coachochitlan",
                        "latitude": "19.86289000",
                        "longitude": "-100.03455000"
                    },
                    {
                        "id": 74897,
                        "name": "Santiago Cuautenco",
                        "latitude": "19.14803000",
                        "longitude": "-98.74685000"
                    },
                    {
                        "id": 74898,
                        "name": "Santiago Cuautlalpan",
                        "latitude": "19.68417000",
                        "longitude": "-99.28870000"
                    },
                    {
                        "id": 74987,
                        "name": "Santiago del Monte",
                        "latitude": "19.40141000",
                        "longitude": "-99.94186000"
                    },
                    {
                        "id": 74904,
                        "name": "Santiago Huitlapaltepec",
                        "latitude": "19.28676000",
                        "longitude": "-100.20649000"
                    },
                    {
                        "id": 74920,
                        "name": "Santiago Mamalhuazuca",
                        "latitude": "18.99659000",
                        "longitude": "-98.79602000"
                    },
                    {
                        "id": 74932,
                        "name": "Santiago Oxtempan",
                        "latitude": "19.78034000",
                        "longitude": "-100.12191000"
                    },
                    {
                        "id": 74934,
                        "name": "Santiago Oxtotitlán",
                        "latitude": "18.96146000",
                        "longitude": "-99.66827000"
                    },
                    {
                        "id": 74942,
                        "name": "Santiago Tejocotillos",
                        "latitude": "19.43308000",
                        "longitude": "-99.45155000"
                    },
                    {
                        "id": 74947,
                        "name": "Santiago Tepetitlán",
                        "latitude": "19.63807000",
                        "longitude": "-98.81841000"
                    },
                    {
                        "id": 74950,
                        "name": "Santiago Tepopula",
                        "latitude": "19.14399000",
                        "longitude": "-98.85692000"
                    },
                    {
                        "id": 74954,
                        "name": "Santiago Teyahualco",
                        "latitude": "19.65985000",
                        "longitude": "-99.12493000"
                    },
                    {
                        "id": 74956,
                        "name": "Santiago Tianguistenco de Galeana",
                        "latitude": "19.18024000",
                        "longitude": "-99.46644000"
                    },
                    {
                        "id": 74961,
                        "name": "Santiago Tlacotepec",
                        "latitude": "19.22708000",
                        "longitude": "-99.67083000"
                    },
                    {
                        "id": 74966,
                        "name": "Santiago Tolman",
                        "latitude": "19.72781000",
                        "longitude": "-98.79011000"
                    },
                    {
                        "id": 74974,
                        "name": "Santiago Yancuitlalpan",
                        "latitude": "19.38404000",
                        "longitude": "-99.30471000"
                    },
                    {
                        "id": 74975,
                        "name": "Santiago Yeché",
                        "latitude": "19.70853000",
                        "longitude": "-99.71190000"
                    },
                    {
                        "id": 74980,
                        "name": "Santiago Zacualuca",
                        "latitude": "19.70038000",
                        "longitude": "-98.92908000"
                    },
                    {
                        "id": 74991,
                        "name": "Santiaguito Tlalcilalcalli",
                        "latitude": "19.34032000",
                        "longitude": "-99.72717000"
                    },
                    {
                        "id": 75017,
                        "name": "Santo Domingo de Guzmán",
                        "latitude": "19.59306000",
                        "longitude": "-99.77972000"
                    },
                    {
                        "id": 75008,
                        "name": "Santo Domingo Shomege (Shomege)",
                        "latitude": "19.84524000",
                        "longitude": "-99.90166000"
                    },
                    {
                        "id": 75023,
                        "name": "Santo Tomás",
                        "latitude": "19.84524000",
                        "longitude": "-102.08571000"
                    },
                    {
                        "id": 75025,
                        "name": "Santo Tomás Atzingo",
                        "latitude": "19.17270000",
                        "longitude": "-98.77873000"
                    },
                    {
                        "id": 75027,
                        "name": "Santo Tomás Chiconautla",
                        "latitude": "19.63894000",
                        "longitude": "-99.00755000"
                    },
                    {
                        "id": 75033,
                        "name": "Santo Tomás de los Plátanos",
                        "latitude": "19.18310000",
                        "longitude": "-100.25999000"
                    },
                    {
                        "id": 75050,
                        "name": "Sebastián Lerdo de Tejada",
                        "latitude": "19.38972000",
                        "longitude": "-99.72528000"
                    },
                    {
                        "id": 75053,
                        "name": "Sección del Cerrito",
                        "latitude": "19.55889000",
                        "longitude": "-99.67833000"
                    },
                    {
                        "id": 75075,
                        "name": "Sierra de Guadalupe",
                        "latitude": "19.59250000",
                        "longitude": "-99.15944000"
                    },
                    {
                        "id": 75101,
                        "name": "Sitio Ejido",
                        "latitude": "19.45334000",
                        "longitude": "-99.90069000"
                    },
                    {
                        "id": 75110,
                        "name": "Solalpan 1ra. Sección",
                        "latitude": "19.49278000",
                        "longitude": "-99.57444000"
                    },
                    {
                        "id": 75130,
                        "name": "Soyaniquilpan",
                        "latitude": "20.01488000",
                        "longitude": "-99.53022000"
                    },
                    {
                        "id": 75146,
                        "name": "Sultepec",
                        "latitude": "18.85855000",
                        "longitude": "-99.96588000"
                    },
                    {
                        "id": 75197,
                        "name": "Tamándaro",
                        "latitude": "19.94941000",
                        "longitude": "-102.28416000"
                    },
                    {
                        "id": 75201,
                        "name": "Tanaquillo",
                        "latitude": "19.84611000",
                        "longitude": "-102.09797000"
                    },
                    {
                        "id": 75209,
                        "name": "Tangancícuaro de Arista",
                        "latitude": "19.88733000",
                        "longitude": "-102.20636000"
                    },
                    {
                        "id": 75234,
                        "name": "Tarécuato",
                        "latitude": "19.84359000",
                        "longitude": "-102.46485000"
                    },
                    {
                        "id": 75294,
                        "name": "Tecámac",
                        "latitude": "19.71288000",
                        "longitude": "-98.96895000"
                    },
                    {
                        "id": 75295,
                        "name": "Tecámac de Felipe Villanueva",
                        "latitude": "19.71306000",
                        "longitude": "-98.96833000"
                    },
                    {
                        "id": 75264,
                        "name": "Tecamachalco",
                        "latitude": "19.35992000",
                        "longitude": "-98.95957000"
                    },
                    {
                        "id": 75269,
                        "name": "Tecaxic",
                        "latitude": "19.32270000",
                        "longitude": "-99.71524000"
                    },
                    {
                        "id": 75270,
                        "name": "Techachaltitla",
                        "latitude": "19.36500000",
                        "longitude": "-98.94056000"
                    },
                    {
                        "id": 75271,
                        "name": "Techichili",
                        "latitude": "19.17139000",
                        "longitude": "-99.42222000"
                    },
                    {
                        "id": 75272,
                        "name": "Tecoac (Santa María Nativitas)",
                        "latitude": "19.78917000",
                        "longitude": "-99.85306000"
                    },
                    {
                        "id": 75280,
                        "name": "Tecomatepec",
                        "latitude": "18.83903000",
                        "longitude": "-99.70363000"
                    },
                    {
                        "id": 75303,
                        "name": "Tejalpa",
                        "latitude": "19.25167000",
                        "longitude": "-99.76580000"
                    },
                    {
                        "id": 75306,
                        "name": "Tejupilco",
                        "latitude": "18.86162000",
                        "longitude": "-100.23277000"
                    },
                    {
                        "id": 75307,
                        "name": "Tejupilco de Hidalgo",
                        "latitude": "18.90475000",
                        "longitude": "-100.15275000"
                    },
                    {
                        "id": 75326,
                        "name": "Temamatla",
                        "latitude": "19.20306000",
                        "longitude": "-98.86921000"
                    },
                    {
                        "id": 75330,
                        "name": "Temascalapa",
                        "latitude": "19.82766000",
                        "longitude": "-98.90171000"
                    },
                    {
                        "id": 75331,
                        "name": "Temascalcingo",
                        "latitude": "19.91635000",
                        "longitude": "-100.00369000"
                    },
                    {
                        "id": 75332,
                        "name": "Temascaltepec",
                        "latitude": "19.06561000",
                        "longitude": "-99.98379000"
                    },
                    {
                        "id": 75333,
                        "name": "Temascaltepec de González",
                        "latitude": "19.04409000",
                        "longitude": "-100.04236000"
                    },
                    {
                        "id": 75339,
                        "name": "Temoaya",
                        "latitude": "19.46747000",
                        "longitude": "-99.59407000"
                    },
                    {
                        "id": 75349,
                        "name": "Tenancingo",
                        "latitude": "18.96057000",
                        "longitude": "-99.57561000"
                    },
                    {
                        "id": 75350,
                        "name": "Tenancingo de Degollado",
                        "latitude": "18.96136000",
                        "longitude": "-99.59030000"
                    },
                    {
                        "id": 75354,
                        "name": "Tenango de Arista",
                        "latitude": "19.10446000",
                        "longitude": "-99.58980000"
                    },
                    {
                        "id": 75357,
                        "name": "Tenango del Aire",
                        "latitude": "19.15774000",
                        "longitude": "-98.85687000"
                    },
                    {
                        "id": 75361,
                        "name": "Tenería",
                        "latitude": "18.97322000",
                        "longitude": "-100.09299000"
                    },
                    {
                        "id": 75366,
                        "name": "Tengüecho",
                        "latitude": "19.83836000",
                        "longitude": "-102.34347000"
                    },
                    {
                        "id": 75368,
                        "name": "Tenjay",
                        "latitude": "19.80768000",
                        "longitude": "-99.55221000"
                    },
                    {
                        "id": 75378,
                        "name": "Teoloyucan",
                        "latitude": "19.74423000",
                        "longitude": "-99.18113000"
                    },
                    {
                        "id": 75382,
                        "name": "Teotihuacán",
                        "latitude": "19.68862000",
                        "longitude": "-98.86110000"
                    },
                    {
                        "id": 75383,
                        "name": "Teotihuacán de Arista",
                        "latitude": "19.68972000",
                        "longitude": "-98.86083000"
                    },
                    {
                        "id": 75392,
                        "name": "Tepalcatepec",
                        "latitude": "18.93556000",
                        "longitude": "-99.59917000"
                    },
                    {
                        "id": 75419,
                        "name": "Tepetitlán",
                        "latitude": "19.57266000",
                        "longitude": "-98.87053000"
                    },
                    {
                        "id": 75425,
                        "name": "Tepetlaoxtoc",
                        "latitude": "19.57495000",
                        "longitude": "-98.81910000"
                    },
                    {
                        "id": 75426,
                        "name": "Tepetlaoxtoc de Hidalgo",
                        "latitude": "19.57437000",
                        "longitude": "-98.81835000"
                    },
                    {
                        "id": 75428,
                        "name": "Tepetlixpa",
                        "latitude": "19.03007000",
                        "longitude": "-98.82125000"
                    },
                    {
                        "id": 75431,
                        "name": "Tepetongo",
                        "latitude": "19.90877000",
                        "longitude": "-100.13356000"
                    },
                    {
                        "id": 75434,
                        "name": "Tepetzingo",
                        "latitude": "18.93806000",
                        "longitude": "-99.61250000"
                    },
                    {
                        "id": 75441,
                        "name": "Tepexpan",
                        "latitude": "19.61387000",
                        "longitude": "-98.93640000"
                    },
                    {
                        "id": 75450,
                        "name": "Tepotzotlán",
                        "latitude": "19.72116000",
                        "longitude": "-99.22391000"
                    },
                    {
                        "id": 75451,
                        "name": "Tepoxtepec",
                        "latitude": "18.96278000",
                        "longitude": "-99.55639000"
                    },
                    {
                        "id": 75457,
                        "name": "Tequexquináhuac",
                        "latitude": "19.47757000",
                        "longitude": "-98.82485000"
                    },
                    {
                        "id": 75461,
                        "name": "Tequisistlán",
                        "latitude": "19.59642000",
                        "longitude": "-98.94105000"
                    },
                    {
                        "id": 75462,
                        "name": "Tequisistlán Primero",
                        "latitude": "19.60002000",
                        "longitude": "-98.95689000"
                    },
                    {
                        "id": 75465,
                        "name": "Tequixquiac",
                        "latitude": "19.90944000",
                        "longitude": "-99.14472000"
                    },
                    {
                        "id": 75466,
                        "name": "Tercera Manzana de Zaragoza",
                        "latitude": "19.89556000",
                        "longitude": "-99.75278000"
                    },
                    {
                        "id": 75467,
                        "name": "Teremendo",
                        "latitude": "19.78530000",
                        "longitude": "-101.47980000"
                    },
                    {
                        "id": 75507,
                        "name": "Texcaltitlán",
                        "latitude": "18.93997000",
                        "longitude": "-99.93763000"
                    },
                    {
                        "id": 75509,
                        "name": "Texcalyacac",
                        "latitude": "19.13253000",
                        "longitude": "-99.50163000"
                    },
                    {
                        "id": 75511,
                        "name": "Texcapilla",
                        "latitude": "18.94574000",
                        "longitude": "-99.89535000"
                    },
                    {
                        "id": 75515,
                        "name": "Texcoco de Mora",
                        "latitude": "19.51194000",
                        "longitude": "-98.88293000"
                    },
                    {
                        "id": 75533,
                        "name": "Tezoyuca",
                        "latitude": "19.59283000",
                        "longitude": "-98.91084000"
                    },
                    {
                        "id": 75546,
                        "name": "Tierra Blanca",
                        "latitude": "19.50667000",
                        "longitude": "-99.58389000"
                    },
                    {
                        "id": 75571,
                        "name": "Timilpan",
                        "latitude": "19.88017000",
                        "longitude": "-99.72552000"
                    },
                    {
                        "id": 75589,
                        "name": "Tixmadeje Chiquito",
                        "latitude": "19.96556000",
                        "longitude": "-99.91444000"
                    },
                    {
                        "id": 75612,
                        "name": "Tlacomulco",
                        "latitude": "19.12111000",
                        "longitude": "-99.44750000"
                    },
                    {
                        "id": 75642,
                        "name": "Tlalmanalco",
                        "latitude": "19.20521000",
                        "longitude": "-98.80115000"
                    },
                    {
                        "id": 75645,
                        "name": "Tlalnepantla",
                        "latitude": "19.54005000",
                        "longitude": "-99.19538000"
                    },
                    {
                        "id": 75648,
                        "name": "Tlalnepantla de Baz",
                        "latitude": "19.54054000",
                        "longitude": "-99.19341000"
                    },
                    {
                        "id": 75651,
                        "name": "Tlaltecahuacán",
                        "latitude": "19.57896000",
                        "longitude": "-98.88067000"
                    },
                    {
                        "id": 75666,
                        "name": "Tlaminca",
                        "latitude": "19.13571000",
                        "longitude": "-99.43999000"
                    },
                    {
                        "id": 75690,
                        "name": "Tlatlaya",
                        "latitude": "18.61773000",
                        "longitude": "-100.20779000"
                    },
                    {
                        "id": 75707,
                        "name": "Tlazala de Fabela",
                        "latitude": "19.55857000",
                        "longitude": "-99.41469000"
                    },
                    {
                        "id": 75708,
                        "name": "Tlazazalca",
                        "latitude": "19.97085000",
                        "longitude": "-102.05842000"
                    },
                    {
                        "id": 75723,
                        "name": "Toluca",
                        "latitude": "19.32780000",
                        "longitude": "-99.66024000"
                    },
                    {
                        "id": 75740,
                        "name": "Tonanitla",
                        "latitude": "19.68794000",
                        "longitude": "-99.05342000"
                    },
                    {
                        "id": 75741,
                        "name": "Tonatico",
                        "latitude": "18.78199000",
                        "longitude": "-99.64363000"
                    },
                    {
                        "id": 75753,
                        "name": "Totolmajac",
                        "latitude": "18.92694000",
                        "longitude": "-99.68593000"
                    },
                    {
                        "id": 75765,
                        "name": "Transfiguración",
                        "latitude": "19.57712000",
                        "longitude": "-99.41951000"
                    },
                    {
                        "id": 75772,
                        "name": "Tres Estrellas",
                        "latitude": "19.58697000",
                        "longitude": "-100.02281000"
                    },
                    {
                        "id": 75775,
                        "name": "Tres Mezquites",
                        "latitude": "20.26203000",
                        "longitude": "-101.62735000"
                    },
                    {
                        "id": 75794,
                        "name": "Tulantongo",
                        "latitude": "19.53159000",
                        "longitude": "-98.87464000"
                    },
                    {
                        "id": 75802,
                        "name": "Tultepec",
                        "latitude": "19.68500000",
                        "longitude": "-99.12806000"
                    },
                    {
                        "id": 75803,
                        "name": "Tultitlán de Mariano Escobedo",
                        "latitude": "19.64655000",
                        "longitude": "-99.16787000"
                    },
                    {
                        "id": 75813,
                        "name": "Tupátaro",
                        "latitude": "19.81375000",
                        "longitude": "-100.30543000"
                    },
                    {
                        "id": 75814,
                        "name": "Turcio Segunda Sección",
                        "latitude": "19.36527000",
                        "longitude": "-99.96009000"
                    },
                    {
                        "id": 75868,
                        "name": "Unidad Acaquilpan",
                        "latitude": "19.36694000",
                        "longitude": "-98.93917000"
                    },
                    {
                        "id": 75875,
                        "name": "Unidad Habitacional Santa Teresa",
                        "latitude": "19.21611000",
                        "longitude": "-99.55222000"
                    },
                    {
                        "id": 75877,
                        "name": "Unidad San Miguel Jagüeyes",
                        "latitude": "19.82361000",
                        "longitude": "-99.28889000"
                    },
                    {
                        "id": 75900,
                        "name": "Urén",
                        "latitude": "19.84564000",
                        "longitude": "-102.10524000"
                    },
                    {
                        "id": 75921,
                        "name": "Valle de Bravo",
                        "latitude": "19.19501000",
                        "longitude": "-100.13132000"
                    },
                    {
                        "id": 75937,
                        "name": "Vare Chiquichuca",
                        "latitude": "19.35539000",
                        "longitude": "-100.19493000"
                    },
                    {
                        "id": 75948,
                        "name": "Veintidós de Febrero",
                        "latitude": "19.61139000",
                        "longitude": "-99.34667000"
                    },
                    {
                        "id": 75954,
                        "name": "Venta de Bravo",
                        "latitude": "19.86376000",
                        "longitude": "-100.17323000"
                    },
                    {
                        "id": 75955,
                        "name": "Venta de Ocotillos",
                        "latitude": "19.47141000",
                        "longitude": "-99.95879000"
                    },
                    {
                        "id": 75997,
                        "name": "Villa Cuauhtémoc",
                        "latitude": "19.41676000",
                        "longitude": "-99.55872000"
                    },
                    {
                        "id": 76060,
                        "name": "Villa de Almoloya de Juárez",
                        "latitude": "19.36915000",
                        "longitude": "-99.75836000"
                    },
                    {
                        "id": 76073,
                        "name": "Villa del Carbón",
                        "latitude": "19.72875000",
                        "longitude": "-99.46362000"
                    },
                    {
                        "id": 76005,
                        "name": "Villa Guerrero",
                        "latitude": "18.96211000",
                        "longitude": "-99.64061000"
                    },
                    {
                        "id": 76027,
                        "name": "Villa Luvianos",
                        "latitude": "18.91667000",
                        "longitude": "-100.40000000"
                    },
                    {
                        "id": 76036,
                        "name": "Villa Morelos",
                        "latitude": "20.00335000",
                        "longitude": "-101.41360000"
                    },
                    {
                        "id": 76048,
                        "name": "Villa URBI del Rey",
                        "latitude": "19.84132000",
                        "longitude": "-99.25719000"
                    },
                    {
                        "id": 76056,
                        "name": "Villa Victoria",
                        "latitude": "19.43693000",
                        "longitude": "-99.99589000"
                    },
                    {
                        "id": 76076,
                        "name": "Villachuato",
                        "latitude": "20.14848000",
                        "longitude": "-101.63460000"
                    },
                    {
                        "id": 76089,
                        "name": "Villas de la Laguna",
                        "latitude": "19.83611000",
                        "longitude": "-99.09000000"
                    },
                    {
                        "id": 76091,
                        "name": "Villas del Campo",
                        "latitude": "19.18028000",
                        "longitude": "-99.61222000"
                    },
                    {
                        "id": 76093,
                        "name": "Vista Hermosa",
                        "latitude": "19.51616000",
                        "longitude": "-99.22335000"
                    },
                    {
                        "id": 76114,
                        "name": "Xalatlaco",
                        "latitude": "19.18314000",
                        "longitude": "-99.41844000"
                    },
                    {
                        "id": 76132,
                        "name": "Xhimojay",
                        "latitude": "19.92144000",
                        "longitude": "-99.64232000"
                    },
                    {
                        "id": 76133,
                        "name": "Xhitey",
                        "latitude": "19.98163000",
                        "longitude": "-99.52779000"
                    },
                    {
                        "id": 76134,
                        "name": "Xhixhata",
                        "latitude": "19.97056000",
                        "longitude": "-99.54611000"
                    },
                    {
                        "id": 76136,
                        "name": "Xico",
                        "latitude": "19.27032000",
                        "longitude": "-98.95088000"
                    },
                    {
                        "id": 76165,
                        "name": "Xochimanca",
                        "latitude": "19.49052000",
                        "longitude": "-98.82433000"
                    },
                    {
                        "id": 76186,
                        "name": "Xocotlán",
                        "latitude": "19.51633000",
                        "longitude": "-98.84633000"
                    },
                    {
                        "id": 76193,
                        "name": "Xometla",
                        "latitude": "19.64281000",
                        "longitude": "-98.88171000"
                    },
                    {
                        "id": 76194,
                        "name": "Xonacatlan",
                        "latitude": "19.40000000",
                        "longitude": "-99.53300000"
                    },
                    {
                        "id": 76257,
                        "name": "Zacamulpa",
                        "latitude": "19.35565000",
                        "longitude": "-99.33145000"
                    },
                    {
                        "id": 76259,
                        "name": "Zacamulpa Tlalmimilolpan",
                        "latitude": "19.38934000",
                        "longitude": "-99.44615000"
                    },
                    {
                        "id": 76260,
                        "name": "Zacango",
                        "latitude": "18.95611000",
                        "longitude": "-99.69806000"
                    },
                    {
                        "id": 76280,
                        "name": "Zacazonapan",
                        "latitude": "19.07317000",
                        "longitude": "-100.25515000"
                    },
                    {
                        "id": 76283,
                        "name": "Zacualpan",
                        "latitude": "18.71895000",
                        "longitude": "-99.77605000"
                    },
                    {
                        "id": 76311,
                        "name": "Zapotlán",
                        "latitude": "19.54667000",
                        "longitude": "-98.90306000"
                    },
                    {
                        "id": 76330,
                        "name": "Zentlalpan",
                        "latitude": "19.15003000",
                        "longitude": "-98.78494000"
                    },
                    {
                        "id": 76339,
                        "name": "Zinacantepec",
                        "latitude": "19.28428000",
                        "longitude": "-99.73394000"
                    },
                    {
                        "id": 76344,
                        "name": "Zipiajo",
                        "latitude": "19.79445000",
                        "longitude": "-101.55250000"
                    },
                    {
                        "id": 76365,
                        "name": "Zopoco",
                        "latitude": "19.84029000",
                        "longitude": "-102.07483000"
                    },
                    {
                        "id": 76367,
                        "name": "Zoquiapan",
                        "latitude": "19.31769000",
                        "longitude": "-98.84967000"
                    },
                    {
                        "id": 76379,
                        "name": "Zoyatzingo",
                        "latitude": "19.09023000",
                        "longitude": "-98.78359000"
                    },
                    {
                        "id": 76383,
                        "name": "Zula",
                        "latitude": "19.22011000",
                        "longitude": "-98.88950000"
                    },
                    {
                        "id": 76384,
                        "name": "Zumpahuacán",
                        "latitude": "18.91642000",
                        "longitude": "-99.56568000"
                    },
                    {
                        "id": 76385,
                        "name": "Zumpango",
                        "latitude": "19.79670000",
                        "longitude": "-99.09946000"
                    }
                ]
            },
            {
                "id": 3469,
                "name": "Guanajuato",
                "iso2": "GUA",
                "latitude": "21.01901450",
                "longitude": "-101.25735860",
                "type": "state",
                "cities": [
                    {
                        "id": 68015,
                        "name": "Abasolo",
                        "latitude": "20.44997000",
                        "longitude": "-101.53073000"
                    },
                    {
                        "id": 68087,
                        "name": "Acámbaro",
                        "latitude": "20.03085000",
                        "longitude": "-100.72194000"
                    },
                    {
                        "id": 68088,
                        "name": "Adjuntas del Río",
                        "latitude": "21.11667000",
                        "longitude": "-100.86806000"
                    },
                    {
                        "id": 68125,
                        "name": "Aguas Buenas",
                        "latitude": "20.97028000",
                        "longitude": "-101.37250000"
                    },
                    {
                        "id": 68181,
                        "name": "Alcocer",
                        "latitude": "20.86867000",
                        "longitude": "-100.70456000"
                    },
                    {
                        "id": 68185,
                        "name": "Aldama",
                        "latitude": "20.81641000",
                        "longitude": "-101.31467000"
                    },
                    {
                        "id": 68191,
                        "name": "Alfaro",
                        "latitude": "21.14941000",
                        "longitude": "-101.60611000"
                    },
                    {
                        "id": 68253,
                        "name": "Ameche",
                        "latitude": "20.55261000",
                        "longitude": "-100.58367000"
                    },
                    {
                        "id": 68296,
                        "name": "Apaseo el Alto",
                        "latitude": "20.45798000",
                        "longitude": "-100.62081000"
                    },
                    {
                        "id": 68297,
                        "name": "Apaseo el Grande",
                        "latitude": "20.54495000",
                        "longitude": "-100.68462000"
                    },
                    {
                        "id": 68329,
                        "name": "Arandas",
                        "latitude": "20.72468000",
                        "longitude": "-101.37296000"
                    },
                    {
                        "id": 68392,
                        "name": "Atarjea",
                        "latitude": "21.26777000",
                        "longitude": "-99.71914000"
                    },
                    {
                        "id": 68505,
                        "name": "Bajío de Bonillas",
                        "latitude": "20.94944000",
                        "longitude": "-101.49528000"
                    },
                    {
                        "id": 68523,
                        "name": "Barretos",
                        "latitude": "20.93933000",
                        "longitude": "-101.64282000"
                    },
                    {
                        "id": 68543,
                        "name": "Barrio de Guadalupe del Mezquitillo",
                        "latitude": "20.94417000",
                        "longitude": "-101.80083000"
                    },
                    {
                        "id": 68562,
                        "name": "Barrón",
                        "latitude": "20.67667000",
                        "longitude": "-101.08423000"
                    },
                    {
                        "id": 68640,
                        "name": "Boquillas",
                        "latitude": "20.41642000",
                        "longitude": "-101.43333000"
                    },
                    {
                        "id": 68681,
                        "name": "Buenavista de Cortés",
                        "latitude": "20.37326000",
                        "longitude": "-101.87021000"
                    },
                    {
                        "id": 68733,
                        "name": "Caleras de Ameche",
                        "latitude": "20.56133000",
                        "longitude": "-100.56013000"
                    },
                    {
                        "id": 68754,
                        "name": "Calzada del Tepozán",
                        "latitude": "20.73762000",
                        "longitude": "-101.88299000"
                    },
                    {
                        "id": 68874,
                        "name": "Cañada de Bustos",
                        "latitude": "20.90436000",
                        "longitude": "-101.31260000"
                    },
                    {
                        "id": 68875,
                        "name": "Cañada de Caracheo",
                        "latitude": "20.37552000",
                        "longitude": "-100.94549000"
                    },
                    {
                        "id": 68879,
                        "name": "Cañada de Negros",
                        "latitude": "20.92636000",
                        "longitude": "-101.92115000"
                    },
                    {
                        "id": 68813,
                        "name": "Capulín de Bustos",
                        "latitude": "20.88242000",
                        "longitude": "-101.30680000"
                    },
                    {
                        "id": 69660,
                        "name": "Cárdenas",
                        "latitude": "20.63012000",
                        "longitude": "-101.22040000"
                    },
                    {
                        "id": 68842,
                        "name": "Carrizal Grande",
                        "latitude": "20.70634000",
                        "longitude": "-101.30600000"
                    },
                    {
                        "id": 68891,
                        "name": "Celaya",
                        "latitude": "20.52353000",
                        "longitude": "-100.81570000"
                    },
                    {
                        "id": 68899,
                        "name": "Centro Familiar la Soledad",
                        "latitude": "21.13500000",
                        "longitude": "-101.74972000"
                    },
                    {
                        "id": 68904,
                        "name": "Cerano",
                        "latitude": "20.10877000",
                        "longitude": "-101.38710000"
                    },
                    {
                        "id": 68910,
                        "name": "Cerrito de Gasca",
                        "latitude": "20.61829000",
                        "longitude": "-101.06200000"
                    },
                    {
                        "id": 68915,
                        "name": "Cerritos",
                        "latitude": "20.88552000",
                        "longitude": "-100.59880000"
                    },
                    {
                        "id": 68923,
                        "name": "Cerro Colorado",
                        "latitude": "20.40111000",
                        "longitude": "-101.32451000"
                    },
                    {
                        "id": 68928,
                        "name": "Cerro Gordo",
                        "latitude": "20.59294000",
                        "longitude": "-101.12684000"
                    },
                    {
                        "id": 68971,
                        "name": "Chamácuaro",
                        "latitude": "20.10444000",
                        "longitude": "-100.82756000"
                    },
                    {
                        "id": 68997,
                        "name": "Charco de Pantoja",
                        "latitude": "20.38949000",
                        "longitude": "-101.35436000"
                    },
                    {
                        "id": 69029,
                        "name": "Chichimequillas",
                        "latitude": "21.03716000",
                        "longitude": "-101.44274000"
                    },
                    {
                        "id": 69094,
                        "name": "Chirimoya (Estación Chirimoya)",
                        "latitude": "21.59278000",
                        "longitude": "-101.09139000"
                    },
                    {
                        "id": 69124,
                        "name": "Churipitzeo",
                        "latitude": "20.41185000",
                        "longitude": "-101.74206000"
                    },
                    {
                        "id": 69129,
                        "name": "Cieneguilla",
                        "latitude": "21.24833000",
                        "longitude": "-100.27389000"
                    },
                    {
                        "id": 69168,
                        "name": "Ciudad Manuel Doblado",
                        "latitude": "20.72888000",
                        "longitude": "-101.95226000"
                    },
                    {
                        "id": 69205,
                        "name": "Coachiti",
                        "latitude": "20.55944000",
                        "longitude": "-100.58944000"
                    },
                    {
                        "id": 69264,
                        "name": "Colonia 18 de Marzo",
                        "latitude": "20.55556000",
                        "longitude": "-101.03556000"
                    },
                    {
                        "id": 69302,
                        "name": "Colonia Fraccionamiento el Puente",
                        "latitude": "20.52361000",
                        "longitude": "-100.89667000"
                    },
                    {
                        "id": 69304,
                        "name": "Colonia Francisco Javier Mina",
                        "latitude": "20.97944000",
                        "longitude": "-101.41639000"
                    },
                    {
                        "id": 69393,
                        "name": "Colonia la Calzada (La Olla)",
                        "latitude": "20.50278000",
                        "longitude": "-100.95889000"
                    },
                    {
                        "id": 69319,
                        "name": "Colonia Latinoamericana",
                        "latitude": "21.03028000",
                        "longitude": "-101.70583000"
                    },
                    {
                        "id": 69332,
                        "name": "Colonia Morelos",
                        "latitude": "20.36832000",
                        "longitude": "-101.89937000"
                    },
                    {
                        "id": 69336,
                        "name": "Colonia Morelos de Guadalupe de Rivera",
                        "latitude": "20.59556000",
                        "longitude": "-101.44833000"
                    },
                    {
                        "id": 69341,
                        "name": "Colonia Nuevo México",
                        "latitude": "20.98475000",
                        "longitude": "-101.48502000"
                    },
                    {
                        "id": 69345,
                        "name": "Colonia Padre Hidalgo",
                        "latitude": "21.17056000",
                        "longitude": "-100.93556000"
                    },
                    {
                        "id": 69349,
                        "name": "Colonia Patria Nueva",
                        "latitude": "20.52833000",
                        "longitude": "-100.87944000"
                    },
                    {
                        "id": 69350,
                        "name": "Colonia Pedro María Anaya",
                        "latitude": "20.52611000",
                        "longitude": "-100.87778000"
                    },
                    {
                        "id": 69353,
                        "name": "Colonia Rafael Corrales Ayala",
                        "latitude": "20.90194000",
                        "longitude": "-101.51611000"
                    },
                    {
                        "id": 69367,
                        "name": "Colonia San Luis Rey",
                        "latitude": "20.93556000",
                        "longitude": "-100.73611000"
                    },
                    {
                        "id": 69421,
                        "name": "Comanjilla",
                        "latitude": "21.06510000",
                        "longitude": "-101.47303000"
                    },
                    {
                        "id": 69428,
                        "name": "Comonfort",
                        "latitude": "20.72278000",
                        "longitude": "-100.75946000"
                    },
                    {
                        "id": 69482,
                        "name": "Coroneo",
                        "latitude": "20.20001000",
                        "longitude": "-100.36546000"
                    },
                    {
                        "id": 69488,
                        "name": "Corral de Piedras de Arriba",
                        "latitude": "20.97577000",
                        "longitude": "-100.59474000"
                    },
                    {
                        "id": 69490,
                        "name": "Corralejo de Arriba",
                        "latitude": "20.89667000",
                        "longitude": "-100.65444000"
                    },
                    {
                        "id": 69494,
                        "name": "Cortazar",
                        "latitude": "20.48362000",
                        "longitude": "-100.96237000"
                    },
                    {
                        "id": 69565,
                        "name": "Cuarta Brigada",
                        "latitude": "20.62194000",
                        "longitude": "-101.28001000"
                    },
                    {
                        "id": 69605,
                        "name": "Cuchicuato",
                        "latitude": "20.66092000",
                        "longitude": "-101.46203000"
                    },
                    {
                        "id": 69616,
                        "name": "Cuerámaro",
                        "latitude": "20.62546000",
                        "longitude": "-101.67242000"
                    },
                    {
                        "id": 69620,
                        "name": "Cuesta de Peñones",
                        "latitude": "21.08400000",
                        "longitude": "-100.23671000"
                    },
                    {
                        "id": 69642,
                        "name": "Cupareo",
                        "latitude": "20.22876000",
                        "longitude": "-101.01806000"
                    },
                    {
                        "id": 69670,
                        "name": "De Parral",
                        "latitude": "20.45611000",
                        "longitude": "-101.00778000"
                    },
                    {
                        "id": 69674,
                        "name": "Delgado de Abajo",
                        "latitude": "20.71749000",
                        "longitude": "-100.89338000"
                    },
                    {
                        "id": 69675,
                        "name": "Delgado de Arriba",
                        "latitude": "20.72222000",
                        "longitude": "-100.90080000"
                    },
                    {
                        "id": 69680,
                        "name": "Derramadero Segundo (Infiernillo)",
                        "latitude": "21.09750000",
                        "longitude": "-100.51417000"
                    },
                    {
                        "id": 69699,
                        "name": "Doctor Mora",
                        "latitude": "21.14246000",
                        "longitude": "-100.31966000"
                    },
                    {
                        "id": 69706,
                        "name": "Dolores Hidalgo Cuna de la Independencia Nacional",
                        "latitude": "21.15611000",
                        "longitude": "-100.93250000"
                    },
                    {
                        "id": 69710,
                        "name": "Don Diego",
                        "latitude": "20.69791000",
                        "longitude": "-100.90209000"
                    },
                    {
                        "id": 69711,
                        "name": "Don Francisco",
                        "latitude": "20.90281000",
                        "longitude": "-100.91873000"
                    },
                    {
                        "id": 69730,
                        "name": "Duarte",
                        "latitude": "21.08712000",
                        "longitude": "-101.52431000"
                    },
                    {
                        "id": 69769,
                        "name": "Ejido Jesús María",
                        "latitude": "21.14194000",
                        "longitude": "-100.91167000"
                    },
                    {
                        "id": 69814,
                        "name": "Ejido la Joya",
                        "latitude": "21.14325000",
                        "longitude": "-101.73922000"
                    },
                    {
                        "id": 69823,
                        "name": "El Acebuche",
                        "latitude": "20.22311000",
                        "longitude": "-100.74196000"
                    },
                    {
                        "id": 69860,
                        "name": "El Canario",
                        "latitude": "20.15694000",
                        "longitude": "-101.33556000"
                    },
                    {
                        "id": 69865,
                        "name": "El Capulín",
                        "latitude": "21.04043000",
                        "longitude": "-100.32220000"
                    },
                    {
                        "id": 69868,
                        "name": "El Caracol",
                        "latitude": "20.56718000",
                        "longitude": "-100.98290000"
                    },
                    {
                        "id": 69872,
                        "name": "El Carmen",
                        "latitude": "20.64009000",
                        "longitude": "-101.37259000"
                    },
                    {
                        "id": 69880,
                        "name": "El Carretón",
                        "latitude": "21.63045000",
                        "longitude": "-100.98064000"
                    },
                    {
                        "id": 69883,
                        "name": "El Carrizalito",
                        "latitude": "20.70371000",
                        "longitude": "-101.32439000"
                    },
                    {
                        "id": 69887,
                        "name": "El Castillo",
                        "latitude": "20.58072000",
                        "longitude": "-100.49297000"
                    },
                    {
                        "id": 69852,
                        "name": "El CERESO",
                        "latitude": "21.02222000",
                        "longitude": "-101.68917000"
                    },
                    {
                        "id": 69901,
                        "name": "El Chinaco (El Pujido)",
                        "latitude": "20.52222000",
                        "longitude": "-100.91972000"
                    },
                    {
                        "id": 69909,
                        "name": "El Coecillo",
                        "latitude": "20.97651000",
                        "longitude": "-101.45010000"
                    },
                    {
                        "id": 69925,
                        "name": "El Copalillo",
                        "latitude": "20.72745000",
                        "longitude": "-101.34570000"
                    },
                    {
                        "id": 69944,
                        "name": "El Divisador",
                        "latitude": "20.57722000",
                        "longitude": "-101.15806000"
                    },
                    {
                        "id": 69957,
                        "name": "El Escoplo",
                        "latitude": "20.91004000",
                        "longitude": "-101.51127000"
                    },
                    {
                        "id": 69959,
                        "name": "El Espejo",
                        "latitude": "20.44094000",
                        "longitude": "-100.55417000"
                    },
                    {
                        "id": 69968,
                        "name": "El Fresno",
                        "latitude": "20.27322000",
                        "longitude": "-100.49154000"
                    },
                    {
                        "id": 69975,
                        "name": "El Gallinero",
                        "latitude": "21.18208000",
                        "longitude": "-100.95996000"
                    },
                    {
                        "id": 69992,
                        "name": "El Huizache",
                        "latitude": "20.41934000",
                        "longitude": "-100.95978000"
                    },
                    {
                        "id": 69997,
                        "name": "El Jaguey",
                        "latitude": "20.91499000",
                        "longitude": "-101.63426000"
                    },
                    {
                        "id": 70020,
                        "name": "El Llanito",
                        "latitude": "21.12143000",
                        "longitude": "-100.95110000"
                    },
                    {
                        "id": 70029,
                        "name": "El Maguey",
                        "latitude": "20.98035000",
                        "longitude": "-101.84651000"
                    },
                    {
                        "id": 70036,
                        "name": "El Mezquitillo",
                        "latitude": "20.96213000",
                        "longitude": "-101.80857000"
                    },
                    {
                        "id": 70049,
                        "name": "El Moral",
                        "latitude": "20.13030000",
                        "longitude": "-101.28862000"
                    },
                    {
                        "id": 70053,
                        "name": "El Nacimiento",
                        "latitude": "20.53596000",
                        "longitude": "-100.61017000"
                    },
                    {
                        "id": 70054,
                        "name": "El Naranjillo",
                        "latitude": "20.71417000",
                        "longitude": "-101.00056000"
                    },
                    {
                        "id": 70102,
                        "name": "El Picacho",
                        "latitude": "20.71016000",
                        "longitude": "-100.63704000"
                    },
                    {
                        "id": 70141,
                        "name": "El Puesto",
                        "latitude": "20.46890000",
                        "longitude": "-100.82763000"
                    },
                    {
                        "id": 70149,
                        "name": "El Recuerdo de Ancón (Xoconoxtle de Arriba)",
                        "latitude": "20.63806000",
                        "longitude": "-101.12694000"
                    },
                    {
                        "id": 70156,
                        "name": "El Refugio de los Sauces",
                        "latitude": "21.01488000",
                        "longitude": "-101.53084000"
                    },
                    {
                        "id": 70181,
                        "name": "El Sabino",
                        "latitude": "20.28131000",
                        "longitude": "-101.00224000"
                    },
                    {
                        "id": 70192,
                        "name": "El Salto de Espejo",
                        "latitude": "20.45045000",
                        "longitude": "-100.50587000"
                    },
                    {
                        "id": 70195,
                        "name": "El Salvador (Ranchito San José del Carmen)",
                        "latitude": "20.28750000",
                        "longitude": "-100.87722000"
                    },
                    {
                        "id": 70201,
                        "name": "El Sauz (El Sauz de Villaseñor)",
                        "latitude": "20.41056000",
                        "longitude": "-100.79667000"
                    },
                    {
                        "id": 70212,
                        "name": "El Tecolote",
                        "latitude": "20.88407000",
                        "longitude": "-101.92432000"
                    },
                    {
                        "id": 70216,
                        "name": "El Tejocote (El Domingo)",
                        "latitude": "21.67611000",
                        "longitude": "-100.91500000"
                    },
                    {
                        "id": 70245,
                        "name": "El Tunal",
                        "latitude": "20.56944000",
                        "longitude": "-100.61995000"
                    },
                    {
                        "id": 70248,
                        "name": "El Varal",
                        "latitude": "20.34845000",
                        "longitude": "-101.60028000"
                    },
                    {
                        "id": 70257,
                        "name": "El Vicarlo",
                        "latitude": "20.58211000",
                        "longitude": "-100.67120000"
                    },
                    {
                        "id": 70261,
                        "name": "El Zapote",
                        "latitude": "21.73563000",
                        "longitude": "-101.04905000"
                    },
                    {
                        "id": 70299,
                        "name": "Empalme Escobedo",
                        "latitude": "20.67250000",
                        "longitude": "-100.74675000"
                    },
                    {
                        "id": 70341,
                        "name": "Estación Corralejo",
                        "latitude": "20.47000000",
                        "longitude": "-101.61639000"
                    },
                    {
                        "id": 70360,
                        "name": "Estación de San Francisco",
                        "latitude": "21.03722000",
                        "longitude": "-101.82472000"
                    },
                    {
                        "id": 70344,
                        "name": "Estación Joaquín",
                        "latitude": "20.56082000",
                        "longitude": "-101.51993000"
                    },
                    {
                        "id": 70361,
                        "name": "Estación la Piedad",
                        "latitude": "20.36750000",
                        "longitude": "-101.99806000"
                    },
                    {
                        "id": 70350,
                        "name": "Estación Pénjamo",
                        "latitude": "20.39470000",
                        "longitude": "-101.69188000"
                    },
                    {
                        "id": 70364,
                        "name": "Estancia del Llano",
                        "latitude": "20.51101000",
                        "longitude": "-100.72637000"
                    },
                    {
                        "id": 70367,
                        "name": "Estanzuela de Romero",
                        "latitude": "20.18477000",
                        "longitude": "-100.50448000"
                    },
                    {
                        "id": 70372,
                        "name": "Estrada",
                        "latitude": "20.52918000",
                        "longitude": "-100.86550000"
                    },
                    {
                        "id": 70384,
                        "name": "Ex-Hacienda del Copal",
                        "latitude": "20.74083000",
                        "longitude": "-101.33528000"
                    },
                    {
                        "id": 70499,
                        "name": "Fábrica de Melchor",
                        "latitude": "21.67223000",
                        "longitude": "-100.90171000"
                    },
                    {
                        "id": 70451,
                        "name": "Fraccionamiento la Mezquitera",
                        "latitude": "21.00972000",
                        "longitude": "-101.83472000"
                    },
                    {
                        "id": 70456,
                        "name": "Fraccionamiento las Liebres",
                        "latitude": "20.64750000",
                        "longitude": "-101.39556000"
                    },
                    {
                        "id": 70431,
                        "name": "Fraccionamiento Paraíso Real",
                        "latitude": "21.11250000",
                        "longitude": "-101.58083000"
                    },
                    {
                        "id": 70432,
                        "name": "Fraccionamiento Paseo de las Torres",
                        "latitude": "21.16833000",
                        "longitude": "-101.75806000"
                    },
                    {
                        "id": 70433,
                        "name": "Fraccionamiento Praderas de la Venta",
                        "latitude": "20.53611000",
                        "longitude": "-101.00000000"
                    },
                    {
                        "id": 70445,
                        "name": "Fraccionamiento Villa Jardín",
                        "latitude": "20.99167000",
                        "longitude": "-101.85194000"
                    },
                    {
                        "id": 70446,
                        "name": "Fraccionamiento Villas de Guanajuato",
                        "latitude": "20.96028000",
                        "longitude": "-101.29806000"
                    },
                    {
                        "id": 70485,
                        "name": "Franco",
                        "latitude": "20.94327000",
                        "longitude": "-101.46180000"
                    },
                    {
                        "id": 70486,
                        "name": "Franco Tavera",
                        "latitude": "20.60595000",
                        "longitude": "-100.92700000"
                    },
                    {
                        "id": 70495,
                        "name": "Frías",
                        "latitude": "20.79945000",
                        "longitude": "-101.99644000"
                    },
                    {
                        "id": 70505,
                        "name": "Gachupines",
                        "latitude": "21.76259000",
                        "longitude": "-101.56247000"
                    },
                    {
                        "id": 70513,
                        "name": "Galerade Panales",
                        "latitude": "20.29452000",
                        "longitude": "-100.81452000"
                    },
                    {
                        "id": 70521,
                        "name": "Gasca",
                        "latitude": "20.60444000",
                        "longitude": "-100.85639000"
                    },
                    {
                        "id": 70522,
                        "name": "Gavia de Rionda",
                        "latitude": "20.83357000",
                        "longitude": "-101.61647000"
                    },
                    {
                        "id": 70574,
                        "name": "Guadalupe",
                        "latitude": "21.71644000",
                        "longitude": "-100.97645000"
                    },
                    {
                        "id": 70609,
                        "name": "Guadalupe de Paso Blanco",
                        "latitude": "20.75498000",
                        "longitude": "-101.40345000"
                    },
                    {
                        "id": 70610,
                        "name": "Guadalupe de Rivera",
                        "latitude": "20.60499000",
                        "longitude": "-101.46745000"
                    },
                    {
                        "id": 70611,
                        "name": "Guadalupe de Tambula",
                        "latitude": "20.86645000",
                        "longitude": "-100.57620000"
                    },
                    {
                        "id": 70612,
                        "name": "Guadalupe del Monte",
                        "latitude": "20.55688000",
                        "longitude": "-100.64064000"
                    },
                    {
                        "id": 70618,
                        "name": "Guanajuato",
                        "latitude": "21.01858000",
                        "longitude": "-101.25910000"
                    },
                    {
                        "id": 70650,
                        "name": "Hacienda Arriba",
                        "latitude": "21.23366000",
                        "longitude": "-101.70393000"
                    },
                    {
                        "id": 70659,
                        "name": "Hacienda de la Bolsa",
                        "latitude": "20.37524000",
                        "longitude": "-101.10425000"
                    },
                    {
                        "id": 70658,
                        "name": "Hacienda de Márquez",
                        "latitude": "20.78037000",
                        "longitude": "-101.35979000"
                    },
                    {
                        "id": 70712,
                        "name": "Hoya de Cintora (La Hoya de Arriba)",
                        "latitude": "20.36444000",
                        "longitude": "-101.20833000"
                    },
                    {
                        "id": 70734,
                        "name": "Huanímaro",
                        "latitude": "20.36783000",
                        "longitude": "-101.49869000"
                    },
                    {
                        "id": 70803,
                        "name": "Huitzatarito",
                        "latitude": "20.49213000",
                        "longitude": "-101.57064000"
                    },
                    {
                        "id": 70832,
                        "name": "Ibarrilla",
                        "latitude": "21.18664000",
                        "longitude": "-101.64576000"
                    },
                    {
                        "id": 70880,
                        "name": "Irámuco",
                        "latitude": "19.96156000",
                        "longitude": "-100.92202000"
                    },
                    {
                        "id": 70876,
                        "name": "Irapuato",
                        "latitude": "20.67675000",
                        "longitude": "-101.35628000"
                    },
                    {
                        "id": 70982,
                        "name": "Jalpilla",
                        "latitude": "20.73129000",
                        "longitude": "-100.72090000"
                    },
                    {
                        "id": 70995,
                        "name": "Jamaica",
                        "latitude": "21.14364000",
                        "longitude": "-100.73430000"
                    },
                    {
                        "id": 71004,
                        "name": "Jaral del Progreso",
                        "latitude": "20.37237000",
                        "longitude": "-101.06249000"
                    },
                    {
                        "id": 71013,
                        "name": "Jauregui",
                        "latitude": "20.59280000",
                        "longitude": "-100.71940000"
                    },
                    {
                        "id": 71021,
                        "name": "Jerécuaro",
                        "latitude": "20.15467000",
                        "longitude": "-100.50860000"
                    },
                    {
                        "id": 71038,
                        "name": "Jesús del Monte",
                        "latitude": "20.91504000",
                        "longitude": "-101.74129000"
                    },
                    {
                        "id": 71149,
                        "name": "Jícamas",
                        "latitude": "20.27602000",
                        "longitude": "-101.35916000"
                    },
                    {
                        "id": 71066,
                        "name": "Jocoqui",
                        "latitude": "20.58201000",
                        "longitude": "-100.69870000"
                    },
                    {
                        "id": 71123,
                        "name": "Juan Martín",
                        "latitude": "20.47301000",
                        "longitude": "-100.74691000"
                    },
                    {
                        "id": 71144,
                        "name": "Juventino Rosas",
                        "latitude": "20.64337000",
                        "longitude": "-100.99286000"
                    },
                    {
                        "id": 71170,
                        "name": "La Aldea",
                        "latitude": "20.90166000",
                        "longitude": "-101.47852000"
                    },
                    {
                        "id": 71174,
                        "name": "La Angostura",
                        "latitude": "20.27733000",
                        "longitude": "-101.11005000"
                    },
                    {
                        "id": 71178,
                        "name": "La Aurora",
                        "latitude": "20.62667000",
                        "longitude": "-100.75750000"
                    },
                    {
                        "id": 71189,
                        "name": "La Caja",
                        "latitude": "20.71146000",
                        "longitude": "-101.43769000"
                    },
                    {
                        "id": 71190,
                        "name": "La Calera",
                        "latitude": "20.80119000",
                        "longitude": "-101.33207000"
                    },
                    {
                        "id": 71203,
                        "name": "La Capilla",
                        "latitude": "20.55655000",
                        "longitude": "-101.30019000"
                    },
                    {
                        "id": 71216,
                        "name": "La Ciénega",
                        "latitude": "21.30050000",
                        "longitude": "-100.48027000"
                    },
                    {
                        "id": 71214,
                        "name": "La Cieneguita",
                        "latitude": "20.94630000",
                        "longitude": "-100.78966000"
                    },
                    {
                        "id": 71224,
                        "name": "La Compañía",
                        "latitude": "20.37760000",
                        "longitude": "-101.15852000"
                    },
                    {
                        "id": 71251,
                        "name": "La Cruz",
                        "latitude": "20.45694000",
                        "longitude": "-100.79583000"
                    },
                    {
                        "id": 71252,
                        "name": "La Cruz del Palmar",
                        "latitude": "20.96973000",
                        "longitude": "-100.84354000"
                    },
                    {
                        "id": 71255,
                        "name": "La Cuevita",
                        "latitude": "20.33872000",
                        "longitude": "-100.57891000"
                    },
                    {
                        "id": 71262,
                        "name": "La Ermita",
                        "latitude": "21.15194000",
                        "longitude": "-101.73306000"
                    },
                    {
                        "id": 71266,
                        "name": "La Escondida",
                        "latitude": "21.68723000",
                        "longitude": "-101.53446000"
                    },
                    {
                        "id": 71285,
                        "name": "La Estancia de San José del Carmen",
                        "latitude": "20.29555000",
                        "longitude": "-100.86083000"
                    },
                    {
                        "id": 71288,
                        "name": "La Estrella",
                        "latitude": "20.39050000",
                        "longitude": "-101.92109000"
                    },
                    {
                        "id": 71299,
                        "name": "La Gavia",
                        "latitude": "20.39431000",
                        "longitude": "-100.88122000"
                    },
                    {
                        "id": 71334,
                        "name": "La Joya de Calvillo",
                        "latitude": "20.74883000",
                        "longitude": "-101.60847000"
                    },
                    {
                        "id": 71338,
                        "name": "La Labor",
                        "latitude": "20.53388000",
                        "longitude": "-100.70200000"
                    },
                    {
                        "id": 71341,
                        "name": "La Laborcita",
                        "latitude": "21.10636000",
                        "longitude": "-101.55170000"
                    },
                    {
                        "id": 71350,
                        "name": "La Laja",
                        "latitude": "20.52946000",
                        "longitude": "-100.76170000"
                    },
                    {
                        "id": 71362,
                        "name": "La Lobera",
                        "latitude": "20.35815000",
                        "longitude": "-101.54030000"
                    },
                    {
                        "id": 71376,
                        "name": "La Luz",
                        "latitude": "20.55386000",
                        "longitude": "-101.18097000"
                    },
                    {
                        "id": 71402,
                        "name": "La Moncada",
                        "latitude": "20.28348000",
                        "longitude": "-100.80502000"
                    },
                    {
                        "id": 71409,
                        "name": "La Norita",
                        "latitude": "20.55409000",
                        "longitude": "-100.51660000"
                    },
                    {
                        "id": 71412,
                        "name": "La Ordeña",
                        "latitude": "20.68988000",
                        "longitude": "-101.11830000"
                    },
                    {
                        "id": 71415,
                        "name": "La Ortiga",
                        "latitude": "19.96222000",
                        "longitude": "-101.00056000"
                    },
                    {
                        "id": 71421,
                        "name": "La Palma",
                        "latitude": "20.51560000",
                        "longitude": "-100.69787000"
                    },
                    {
                        "id": 71429,
                        "name": "La Palmita (La Palmita de San Gabriel)",
                        "latitude": "20.49806000",
                        "longitude": "-100.87806000"
                    },
                    {
                        "id": 71470,
                        "name": "La Purísima",
                        "latitude": "20.51444000",
                        "longitude": "-100.67250000"
                    },
                    {
                        "id": 71481,
                        "name": "La Sabana",
                        "latitude": "21.19956000",
                        "longitude": "-100.68956000"
                    },
                    {
                        "id": 71484,
                        "name": "La Sardina",
                        "latitude": "20.88118000",
                        "longitude": "-101.66440000"
                    },
                    {
                        "id": 71485,
                        "name": "La Sauceda",
                        "latitude": "20.89831000",
                        "longitude": "-101.19124000"
                    },
                    {
                        "id": 71491,
                        "name": "La Soledad",
                        "latitude": "20.60792000",
                        "longitude": "-101.41558000"
                    },
                    {
                        "id": 71504,
                        "name": "La Tinaja",
                        "latitude": "20.49028000",
                        "longitude": "-101.21556000"
                    },
                    {
                        "id": 71511,
                        "name": "La Trinidad",
                        "latitude": "20.56333000",
                        "longitude": "-100.78361000"
                    },
                    {
                        "id": 71539,
                        "name": "Labor de Peralta",
                        "latitude": "20.40885000",
                        "longitude": "-101.40901000"
                    },
                    {
                        "id": 71544,
                        "name": "Ladrilleras del Refugio",
                        "latitude": "21.08472000",
                        "longitude": "-101.55361000"
                    },
                    {
                        "id": 71552,
                        "name": "Laguna de Guadalupe",
                        "latitude": "21.80046000",
                        "longitude": "-101.35689000"
                    },
                    {
                        "id": 71548,
                        "name": "Laguna Larga",
                        "latitude": "20.54131000",
                        "longitude": "-101.48451000"
                    },
                    {
                        "id": 71549,
                        "name": "Laguna Larga de Cortés",
                        "latitude": "20.39270000",
                        "longitude": "-101.94062000"
                    },
                    {
                        "id": 71570,
                        "name": "Landín",
                        "latitude": "20.75392000",
                        "longitude": "-100.90592000"
                    },
                    {
                        "id": 71657,
                        "name": "Las Ánimas",
                        "latitude": "20.39709000",
                        "longitude": "-101.79964000"
                    },
                    {
                        "id": 71584,
                        "name": "Las Cañas",
                        "latitude": "20.29586000",
                        "longitude": "-101.41823000"
                    },
                    {
                        "id": 71605,
                        "name": "Las Huertas Tercera Sección",
                        "latitude": "20.65278000",
                        "longitude": "-101.39306000"
                    },
                    {
                        "id": 71610,
                        "name": "Las Liebres",
                        "latitude": "20.83532000",
                        "longitude": "-101.47062000"
                    },
                    {
                        "id": 71620,
                        "name": "Las Masas (La Luz Masas)",
                        "latitude": "20.59917000",
                        "longitude": "-101.54278000"
                    },
                    {
                        "id": 71646,
                        "name": "Las Trojas",
                        "latitude": "20.71111000",
                        "longitude": "-100.78083000"
                    },
                    {
                        "id": 71666,
                        "name": "León",
                        "latitude": "21.09309000",
                        "longitude": "-101.64501000"
                    },
                    {
                        "id": 71668,
                        "name": "León de los Aldama",
                        "latitude": "21.12908000",
                        "longitude": "-101.67374000"
                    },
                    {
                        "id": 71701,
                        "name": "Lo de Juárez",
                        "latitude": "20.76833000",
                        "longitude": "-101.34111000"
                    },
                    {
                        "id": 71735,
                        "name": "Loma de la Esperanza",
                        "latitude": "20.65927000",
                        "longitude": "-101.55670000"
                    },
                    {
                        "id": 71733,
                        "name": "Loma de Yerbabuena",
                        "latitude": "21.06056000",
                        "longitude": "-101.44944000"
                    },
                    {
                        "id": 71734,
                        "name": "Loma de Zempoala",
                        "latitude": "20.29182000",
                        "longitude": "-101.08023000"
                    },
                    {
                        "id": 71723,
                        "name": "Loma Pelada",
                        "latitude": "20.57222000",
                        "longitude": "-101.29417000"
                    },
                    {
                        "id": 71724,
                        "name": "Loma Tendida",
                        "latitude": "20.37560000",
                        "longitude": "-101.31057000"
                    },
                    {
                        "id": 71871,
                        "name": "Los Ángeles",
                        "latitude": "20.55361000",
                        "longitude": "-100.94167000"
                    },
                    {
                        "id": 71772,
                        "name": "Los Arcos",
                        "latitude": "21.04928000",
                        "longitude": "-101.68864000"
                    },
                    {
                        "id": 71796,
                        "name": "Los Desmontes",
                        "latitude": "19.95662000",
                        "longitude": "-100.73917000"
                    },
                    {
                        "id": 71798,
                        "name": "Los Dolores (Las Quince Letras)",
                        "latitude": "21.31778000",
                        "longitude": "-100.56583000"
                    },
                    {
                        "id": 71799,
                        "name": "Los Dulces Nombres",
                        "latitude": "20.64806000",
                        "longitude": "-100.96472000"
                    },
                    {
                        "id": 71801,
                        "name": "Los Fierros",
                        "latitude": "20.19353000",
                        "longitude": "-100.75941000"
                    },
                    {
                        "id": 71802,
                        "name": "Los Galvan",
                        "latitude": "21.06377000",
                        "longitude": "-100.80114000"
                    },
                    {
                        "id": 71812,
                        "name": "Los Lorenzos",
                        "latitude": "21.07229000",
                        "longitude": "-101.37580000"
                    },
                    {
                        "id": 71813,
                        "name": "Los Mancera",
                        "latitude": "20.47028000",
                        "longitude": "-100.80389000"
                    },
                    {
                        "id": 71815,
                        "name": "Los Medranos",
                        "latitude": "20.88283000",
                        "longitude": "-101.43640000"
                    },
                    {
                        "id": 71822,
                        "name": "Los Nicolases",
                        "latitude": "20.85806000",
                        "longitude": "-101.31750000"
                    },
                    {
                        "id": 71824,
                        "name": "Los Ocotes",
                        "latitude": "20.41560000",
                        "longitude": "-101.96108000"
                    },
                    {
                        "id": 71838,
                        "name": "Los Prietos",
                        "latitude": "20.57513000",
                        "longitude": "-101.26574000"
                    },
                    {
                        "id": 71841,
                        "name": "Los Ramírez",
                        "latitude": "21.01942000",
                        "longitude": "-101.64411000"
                    },
                    {
                        "id": 71843,
                        "name": "Los Remedios",
                        "latitude": "21.18492000",
                        "longitude": "-100.19919000"
                    },
                    {
                        "id": 71855,
                        "name": "Los Rodríguez",
                        "latitude": "21.04311000",
                        "longitude": "-100.64361000"
                    },
                    {
                        "id": 71876,
                        "name": "Loza de Barrera",
                        "latitude": "20.98461000",
                        "longitude": "-101.52972000"
                    },
                    {
                        "id": 71877,
                        "name": "Loza de los Padres",
                        "latitude": "21.07181000",
                        "longitude": "-101.54603000"
                    },
                    {
                        "id": 71879,
                        "name": "Lucio Blanco (Los Gavilanes)",
                        "latitude": "21.11528000",
                        "longitude": "-101.55111000"
                    },
                    {
                        "id": 71933,
                        "name": "Magdalena de Araceo",
                        "latitude": "20.30935000",
                        "longitude": "-101.17861000"
                    },
                    {
                        "id": 71944,
                        "name": "Malagana (San Antonio del Monte)",
                        "latitude": "21.04670000",
                        "longitude": "-101.75350000"
                    },
                    {
                        "id": 71959,
                        "name": "Manuel Doblado",
                        "latitude": "20.72085000",
                        "longitude": "-101.85600000"
                    },
                    {
                        "id": 71980,
                        "name": "Maravatío del Encinal",
                        "latitude": "20.20513000",
                        "longitude": "-100.96211000"
                    },
                    {
                        "id": 71989,
                        "name": "Marfil",
                        "latitude": "20.99165000",
                        "longitude": "-101.28434000"
                    },
                    {
                        "id": 71999,
                        "name": "Marroquín",
                        "latitude": "20.51138000",
                        "longitude": "-100.55946000"
                    },
                    {
                        "id": 72065,
                        "name": "Medina",
                        "latitude": "21.14972000",
                        "longitude": "-101.62250000"
                    },
                    {
                        "id": 72066,
                        "name": "Medio Sitio",
                        "latitude": "20.86948000",
                        "longitude": "-101.35689000"
                    },
                    {
                        "id": 72074,
                        "name": "Menores",
                        "latitude": "20.92028000",
                        "longitude": "-101.39500000"
                    },
                    {
                        "id": 72078,
                        "name": "Merino",
                        "latitude": "20.49424000",
                        "longitude": "-100.88411000"
                    },
                    {
                        "id": 72101,
                        "name": "Mexicanos",
                        "latitude": "20.52903000",
                        "longitude": "-101.07064000"
                    },
                    {
                        "id": 72110,
                        "name": "Mezquite de Luna",
                        "latitude": "20.29765000",
                        "longitude": "-101.89260000"
                    },
                    {
                        "id": 72111,
                        "name": "Mezquite de Sotelo",
                        "latitude": "21.00825000",
                        "longitude": "-101.50287000"
                    },
                    {
                        "id": 72109,
                        "name": "Mezquite Gordo",
                        "latitude": "20.81463000",
                        "longitude": "-101.49277000"
                    },
                    {
                        "id": 72148,
                        "name": "Mineral de la Luz",
                        "latitude": "21.06456000",
                        "longitude": "-101.33806000"
                    },
                    {
                        "id": 72160,
                        "name": "Misión de Chichimecas",
                        "latitude": "21.28496000",
                        "longitude": "-100.48658000"
                    },
                    {
                        "id": 72185,
                        "name": "Molino de San José",
                        "latitude": "21.57083000",
                        "longitude": "-101.26389000"
                    },
                    {
                        "id": 72186,
                        "name": "Molino de Santa Ana",
                        "latitude": "20.82874000",
                        "longitude": "-101.34929000"
                    },
                    {
                        "id": 72197,
                        "name": "Monte Blanco",
                        "latitude": "20.35472000",
                        "longitude": "-101.52750000"
                    },
                    {
                        "id": 72209,
                        "name": "Monte del Coecillo",
                        "latitude": "20.97900000",
                        "longitude": "-101.43542000"
                    },
                    {
                        "id": 72201,
                        "name": "Monte Grande",
                        "latitude": "20.99806000",
                        "longitude": "-101.86333000"
                    },
                    {
                        "id": 72223,
                        "name": "Morales",
                        "latitude": "20.77821000",
                        "longitude": "-100.80932000"
                    },
                    {
                        "id": 72238,
                        "name": "Moroleón",
                        "latitude": "20.12571000",
                        "longitude": "-101.19208000"
                    },
                    {
                        "id": 72314,
                        "name": "Neutla",
                        "latitude": "20.70800000",
                        "longitude": "-100.83957000"
                    },
                    {
                        "id": 72331,
                        "name": "Nigromante",
                        "latitude": "20.96194000",
                        "longitude": "-100.78028000"
                    },
                    {
                        "id": 72435,
                        "name": "Obrajuelo",
                        "latitude": "20.10820000",
                        "longitude": "-100.84950000"
                    },
                    {
                        "id": 72441,
                        "name": "Ocampo",
                        "latitude": "21.64653000",
                        "longitude": "-101.48012000"
                    },
                    {
                        "id": 72489,
                        "name": "Ojo de Agua de Ballesteros",
                        "latitude": "20.22821000",
                        "longitude": "-100.82424000"
                    },
                    {
                        "id": 72495,
                        "name": "Ojo de Agua de la Trinidad",
                        "latitude": "20.39356000",
                        "longitude": "-100.63255000"
                    },
                    {
                        "id": 72492,
                        "name": "Ojo de Agua de Mendoza",
                        "latitude": "20.16585000",
                        "longitude": "-100.56909000"
                    },
                    {
                        "id": 72496,
                        "name": "Ojo de Agua del Refugio",
                        "latitude": "21.01386000",
                        "longitude": "-100.31687000"
                    },
                    {
                        "id": 72483,
                        "name": "Ojo Seco",
                        "latitude": "20.38687000",
                        "longitude": "-100.79659000"
                    },
                    {
                        "id": 72517,
                        "name": "Orduña de Abajo",
                        "latitude": "20.75806000",
                        "longitude": "-100.78278000"
                    },
                    {
                        "id": 72518,
                        "name": "Orduña de Arriba",
                        "latitude": "20.76583000",
                        "longitude": "-100.79262000"
                    },
                    {
                        "id": 72537,
                        "name": "Otates",
                        "latitude": "20.40064000",
                        "longitude": "-101.48169000"
                    },
                    {
                        "id": 72601,
                        "name": "Palmillas de San Juan",
                        "latitude": "20.76873000",
                        "longitude": "-100.86432000"
                    },
                    {
                        "id": 72608,
                        "name": "Palo Colorado",
                        "latitude": "21.00836000",
                        "longitude": "-100.72917000"
                    },
                    {
                        "id": 72621,
                        "name": "Panales Jamaica (Cañones)",
                        "latitude": "20.29556000",
                        "longitude": "-100.82306000"
                    },
                    {
                        "id": 72663,
                        "name": "Parácuaro",
                        "latitude": "20.14381000",
                        "longitude": "-100.76352000"
                    },
                    {
                        "id": 72649,
                        "name": "Parangarico",
                        "latitude": "20.19232000",
                        "longitude": "-101.16550000"
                    },
                    {
                        "id": 72692,
                        "name": "Paso de Pirules",
                        "latitude": "20.95028000",
                        "longitude": "-101.29972000"
                    },
                    {
                        "id": 72716,
                        "name": "Paxtle",
                        "latitude": "21.05897000",
                        "longitude": "-101.40390000"
                    },
                    {
                        "id": 73011,
                        "name": "Pénjamo",
                        "latitude": "20.43108000",
                        "longitude": "-101.72261000"
                    },
                    {
                        "id": 72754,
                        "name": "Peñuelas",
                        "latitude": "20.71676000",
                        "longitude": "-101.29749000"
                    },
                    {
                        "id": 72731,
                        "name": "Peralta",
                        "latitude": "20.47350000",
                        "longitude": "-101.40811000"
                    },
                    {
                        "id": 72773,
                        "name": "Piedras de Lumbre",
                        "latitude": "20.25097000",
                        "longitude": "-100.59972000"
                    },
                    {
                        "id": 72771,
                        "name": "Piedras Negras",
                        "latitude": "20.43059000",
                        "longitude": "-101.39158000"
                    },
                    {
                        "id": 72792,
                        "name": "Piñícuaro",
                        "latitude": "20.04751000",
                        "longitude": "-101.24097000"
                    },
                    {
                        "id": 72800,
                        "name": "Plan de Ayala",
                        "latitude": "21.07209000",
                        "longitude": "-101.72165000"
                    },
                    {
                        "id": 72794,
                        "name": "Plan Guanajuato (La Sandía)",
                        "latitude": "20.92167000",
                        "longitude": "-101.69694000"
                    },
                    {
                        "id": 72805,
                        "name": "Plancarte",
                        "latitude": "20.58681000",
                        "longitude": "-100.79620000"
                    },
                    {
                        "id": 72864,
                        "name": "Potrerillos (Guanajal)",
                        "latitude": "21.08154000",
                        "longitude": "-101.86986000"
                    },
                    {
                        "id": 72874,
                        "name": "Pozos",
                        "latitude": "20.62003000",
                        "longitude": "-100.89560000"
                    },
                    {
                        "id": 72883,
                        "name": "Prados del Rosario",
                        "latitude": "21.02194000",
                        "longitude": "-100.39250000"
                    },
                    {
                        "id": 72887,
                        "name": "Presa Blanca",
                        "latitude": "20.64146000",
                        "longitude": "-100.79241000"
                    },
                    {
                        "id": 72896,
                        "name": "Primera Fracción de Crespo",
                        "latitude": "20.49638000",
                        "longitude": "-100.85150000"
                    },
                    {
                        "id": 72922,
                        "name": "Providencia",
                        "latitude": "20.35439000",
                        "longitude": "-101.01895000"
                    },
                    {
                        "id": 72923,
                        "name": "Providencia de Nápoles",
                        "latitude": "21.02297000",
                        "longitude": "-101.45775000"
                    },
                    {
                        "id": 72941,
                        "name": "Pueblo Nuevo",
                        "latitude": "20.52516000",
                        "longitude": "-101.37196000"
                    },
                    {
                        "id": 72959,
                        "name": "Puentecillas",
                        "latitude": "20.93187000",
                        "longitude": "-101.27873000"
                    },
                    {
                        "id": 72963,
                        "name": "Puerta del Monte",
                        "latitude": "20.25853000",
                        "longitude": "-101.02597000"
                    },
                    {
                        "id": 72996,
                        "name": "Purísima de Bustos",
                        "latitude": "21.03150000",
                        "longitude": "-101.87833000"
                    },
                    {
                        "id": 72997,
                        "name": "Purísima de Covarrubias",
                        "latitude": "20.61932000",
                        "longitude": "-101.48340000"
                    },
                    {
                        "id": 72999,
                        "name": "Purísima del Progreso",
                        "latitude": "20.79333000",
                        "longitude": "-101.33028000"
                    },
                    {
                        "id": 73000,
                        "name": "Purísima del Rincón",
                        "latitude": "20.94704000",
                        "longitude": "-101.90939000"
                    },
                    {
                        "id": 72989,
                        "name": "Puroagua",
                        "latitude": "20.07913000",
                        "longitude": "-100.45291000"
                    },
                    {
                        "id": 73078,
                        "name": "Rancho de Guadalupe",
                        "latitude": "21.21639000",
                        "longitude": "-101.01000000"
                    },
                    {
                        "id": 73068,
                        "name": "Rancho Nuevo de la Cruz",
                        "latitude": "20.65105000",
                        "longitude": "-101.51786000"
                    },
                    {
                        "id": 73069,
                        "name": "Rancho Nuevo de la Luz",
                        "latitude": "20.96246000",
                        "longitude": "-101.64573000"
                    },
                    {
                        "id": 73070,
                        "name": "Rancho Nuevo del Llanito",
                        "latitude": "20.82361000",
                        "longitude": "-101.36861000"
                    },
                    {
                        "id": 73074,
                        "name": "Rancho Viejo",
                        "latitude": "21.02091000",
                        "longitude": "-100.77142000"
                    },
                    {
                        "id": 73124,
                        "name": "Rincón de Cano",
                        "latitude": "21.05519000",
                        "longitude": "-100.24196000"
                    },
                    {
                        "id": 73132,
                        "name": "Rincón de Parangueo",
                        "latitude": "20.42193000",
                        "longitude": "-101.25101000"
                    },
                    {
                        "id": 73134,
                        "name": "Rincón de Tamayo",
                        "latitude": "20.42344000",
                        "longitude": "-100.75470000"
                    },
                    {
                        "id": 73137,
                        "name": "Rincón del Centeno",
                        "latitude": "20.66076000",
                        "longitude": "-100.88532000"
                    },
                    {
                        "id": 73115,
                        "name": "Rinconadas del Bosque",
                        "latitude": "20.08528000",
                        "longitude": "-101.19833000"
                    },
                    {
                        "id": 73180,
                        "name": "Río Laja",
                        "latitude": "21.20326000",
                        "longitude": "-100.92339000"
                    },
                    {
                        "id": 73144,
                        "name": "Rizos de la Joya (Rizos del Saucillo)",
                        "latitude": "21.14861000",
                        "longitude": "-101.76194000"
                    },
                    {
                        "id": 73156,
                        "name": "Romita",
                        "latitude": "20.87127000",
                        "longitude": "-101.51683000"
                    },
                    {
                        "id": 73157,
                        "name": "Roque",
                        "latitude": "20.58228000",
                        "longitude": "-100.83727000"
                    },
                    {
                        "id": 73209,
                        "name": "Salamanca",
                        "latitude": "20.57196000",
                        "longitude": "-101.19154000"
                    },
                    {
                        "id": 73220,
                        "name": "Salitrillo",
                        "latitude": "21.03629000",
                        "longitude": "-101.45650000"
                    },
                    {
                        "id": 73231,
                        "name": "Salvatierra",
                        "latitude": "20.21322000",
                        "longitude": "-100.88023000"
                    },
                    {
                        "id": 73258,
                        "name": "San Agustín de las Flores",
                        "latitude": "21.00727000",
                        "longitude": "-101.43710000"
                    },
                    {
                        "id": 73279,
                        "name": "San Andrés Enguaro",
                        "latitude": "20.19472000",
                        "longitude": "-101.23639000"
                    },
                    {
                        "id": 74512,
                        "name": "San Ángel",
                        "latitude": "20.90193000",
                        "longitude": "-101.91895000"
                    },
                    {
                        "id": 73327,
                        "name": "San Antonio Calichar",
                        "latitude": "20.49669000",
                        "longitude": "-100.51775000"
                    },
                    {
                        "id": 73364,
                        "name": "San Antonio de Corrales",
                        "latitude": "20.74556000",
                        "longitude": "-100.96361000"
                    },
                    {
                        "id": 73375,
                        "name": "San Antonio de los Morales",
                        "latitude": "20.58055000",
                        "longitude": "-100.91020000"
                    },
                    {
                        "id": 73377,
                        "name": "San Antonio de los Tepetates",
                        "latitude": "21.04472000",
                        "longitude": "-101.67611000"
                    },
                    {
                        "id": 73366,
                        "name": "San Antonio de Romerillo",
                        "latitude": "20.60784000",
                        "longitude": "-100.94854000"
                    },
                    {
                        "id": 73383,
                        "name": "San Antonio el Chico",
                        "latitude": "20.62798000",
                        "longitude": "-101.28373000"
                    },
                    {
                        "id": 73387,
                        "name": "San Antonio el Rico",
                        "latitude": "20.82308000",
                        "longitude": "-101.37161000"
                    },
                    {
                        "id": 73332,
                        "name": "San Antonio Eménguaro",
                        "latitude": "20.13997000",
                        "longitude": "-100.87874000"
                    },
                    {
                        "id": 73334,
                        "name": "San Antonio Gallardo",
                        "latitude": "20.62833000",
                        "longitude": "-100.76778000"
                    },
                    {
                        "id": 73345,
                        "name": "San Antonio Primero",
                        "latitude": "21.09417000",
                        "longitude": "-100.52844000"
                    },
                    {
                        "id": 73355,
                        "name": "San Antonio Texas",
                        "latitude": "20.98556000",
                        "longitude": "-101.49000000"
                    },
                    {
                        "id": 73411,
                        "name": "San Bartolo de Berrios",
                        "latitude": "21.61240000",
                        "longitude": "-101.06845000"
                    },
                    {
                        "id": 73419,
                        "name": "San Bartolomé Aguas Calientes",
                        "latitude": "20.49556000",
                        "longitude": "-100.54833000"
                    },
                    {
                        "id": 73438,
                        "name": "San Bernardo",
                        "latitude": "20.96764000",
                        "longitude": "-101.86972000"
                    },
                    {
                        "id": 73442,
                        "name": "San Bernardo Peña Blanca",
                        "latitude": "20.46167000",
                        "longitude": "-101.48250000"
                    },
                    {
                        "id": 73465,
                        "name": "San Cayetano",
                        "latitude": "20.60357000",
                        "longitude": "-100.82021000"
                    },
                    {
                        "id": 73472,
                        "name": "San Cristóbal",
                        "latitude": "20.65787000",
                        "longitude": "-101.47683000"
                    },
                    {
                        "id": 73489,
                        "name": "San Diego",
                        "latitude": "20.88838000",
                        "longitude": "-101.40973000"
                    },
                    {
                        "id": 73495,
                        "name": "San Diego de Alcalá",
                        "latitude": "20.03062000",
                        "longitude": "-100.86350000"
                    },
                    {
                        "id": 73496,
                        "name": "San Diego de la Unión",
                        "latitude": "21.46749000",
                        "longitude": "-100.87310000"
                    },
                    {
                        "id": 73505,
                        "name": "San Elías",
                        "latitude": "20.63529000",
                        "longitude": "-100.84120000"
                    },
                    {
                        "id": 73511,
                        "name": "San Felipe",
                        "latitude": "21.47831000",
                        "longitude": "-101.21566000"
                    },
                    {
                        "id": 73521,
                        "name": "San Felipe Quiriceo",
                        "latitude": "20.44303000",
                        "longitude": "-101.28960000"
                    },
                    {
                        "id": 73542,
                        "name": "San Francisco",
                        "latitude": "21.63387000",
                        "longitude": "-101.05884000"
                    },
                    {
                        "id": 73546,
                        "name": "San Francisco (Baños de Agua Caliente)",
                        "latitude": "21.07389000",
                        "longitude": "-101.47278000"
                    },
                    {
                        "id": 73611,
                        "name": "San Francisco de Durán",
                        "latitude": "21.00513000",
                        "longitude": "-101.61990000"
                    },
                    {
                        "id": 73621,
                        "name": "San Francisco del Rincón",
                        "latitude": "21.01843000",
                        "longitude": "-101.85515000"
                    },
                    {
                        "id": 73625,
                        "name": "San Gabriel",
                        "latitude": "21.12949000",
                        "longitude": "-100.83496000"
                    },
                    {
                        "id": 73633,
                        "name": "San Gabriel y San Ignacio",
                        "latitude": "20.44028000",
                        "longitude": "-101.60816000"
                    },
                    {
                        "id": 73640,
                        "name": "San Gregorio",
                        "latitude": "20.54694000",
                        "longitude": "-101.62847000"
                    },
                    {
                        "id": 73651,
                        "name": "San Ignacio",
                        "latitude": "21.28194000",
                        "longitude": "-100.53722000"
                    },
                    {
                        "id": 73654,
                        "name": "San Ignacio de Hidalgo",
                        "latitude": "20.91167000",
                        "longitude": "-101.86056000"
                    },
                    {
                        "id": 73655,
                        "name": "San Ignacio de Rivera (Ojo de Agua)",
                        "latitude": "20.55926000",
                        "longitude": "-101.46127000"
                    },
                    {
                        "id": 73656,
                        "name": "San Ignacio de San José Parangueo",
                        "latitude": "20.41473000",
                        "longitude": "-101.29780000"
                    },
                    {
                        "id": 73686,
                        "name": "San Isidro de Gamboa",
                        "latitude": "20.39501000",
                        "longitude": "-100.52705000"
                    },
                    {
                        "id": 73687,
                        "name": "San Isidro de la Concepción",
                        "latitude": "20.62776000",
                        "longitude": "-100.78570000"
                    },
                    {
                        "id": 73688,
                        "name": "San Isidro de la Estacada",
                        "latitude": "21.14746000",
                        "longitude": "-100.68473000"
                    },
                    {
                        "id": 73689,
                        "name": "San Isidro de los Sauces",
                        "latitude": "21.02103000",
                        "longitude": "-101.53724000"
                    },
                    {
                        "id": 73697,
                        "name": "San Javier",
                        "latitude": "20.66729000",
                        "longitude": "-101.42940000"
                    },
                    {
                        "id": 73724,
                        "name": "San Jerónimo de Araceo",
                        "latitude": "20.32507000",
                        "longitude": "-101.18195000"
                    },
                    {
                        "id": 73807,
                        "name": "San José de Agua Azul",
                        "latitude": "20.48662000",
                        "longitude": "-100.65587000"
                    },
                    {
                        "id": 73809,
                        "name": "San José de Ayala",
                        "latitude": "20.38709000",
                        "longitude": "-101.44143000"
                    },
                    {
                        "id": 73811,
                        "name": "San José de Bernalejo (El Guayabo)",
                        "latitude": "20.64000000",
                        "longitude": "-101.40139000"
                    },
                    {
                        "id": 73813,
                        "name": "San José de Cervera",
                        "latitude": "20.96778000",
                        "longitude": "-101.30250000"
                    },
                    {
                        "id": 73814,
                        "name": "San José de Durán (Los Troncoso)",
                        "latitude": "21.06306000",
                        "longitude": "-101.67417000"
                    },
                    {
                        "id": 73820,
                        "name": "San José de Guanajuato",
                        "latitude": "20.55601000",
                        "longitude": "-100.89277000"
                    },
                    {
                        "id": 73831,
                        "name": "San José de la Montaña",
                        "latitude": "20.60037000",
                        "longitude": "-101.07228000"
                    },
                    {
                        "id": 73833,
                        "name": "San José de las Pilas",
                        "latitude": "20.65227000",
                        "longitude": "-101.04523000"
                    },
                    {
                        "id": 73822,
                        "name": "San José de Llanos",
                        "latitude": "20.85568000",
                        "longitude": "-101.30897000"
                    },
                    {
                        "id": 73823,
                        "name": "San José de Mendoza",
                        "latitude": "20.68965000",
                        "longitude": "-101.21353000"
                    },
                    {
                        "id": 73824,
                        "name": "San José de Rancho Nuevo (Los Arrieros)",
                        "latitude": "21.59639000",
                        "longitude": "-101.00389000"
                    },
                    {
                        "id": 73835,
                        "name": "San José del Cerrito de Camargo",
                        "latitude": "20.41917000",
                        "longitude": "-101.04222000"
                    },
                    {
                        "id": 73837,
                        "name": "San José del Potrero",
                        "latitude": "21.12815000",
                        "longitude": "-101.59737000"
                    },
                    {
                        "id": 73842,
                        "name": "San José del Rodeo",
                        "latitude": "20.92083000",
                        "longitude": "-101.21639000"
                    },
                    {
                        "id": 73845,
                        "name": "San José del Torreón",
                        "latitude": "21.47444000",
                        "longitude": "-101.47056000"
                    },
                    {
                        "id": 73850,
                        "name": "San José el Nuevo",
                        "latitude": "20.44389000",
                        "longitude": "-100.77194000"
                    },
                    {
                        "id": 73769,
                        "name": "San José Iturbide",
                        "latitude": "21.00153000",
                        "longitude": "-100.38416000"
                    },
                    {
                        "id": 73786,
                        "name": "San José Temascatío",
                        "latitude": "20.69183000",
                        "longitude": "-101.26028000"
                    },
                    {
                        "id": 73798,
                        "name": "San José Viborillas",
                        "latitude": "20.56778000",
                        "longitude": "-100.63361000"
                    },
                    {
                        "id": 73871,
                        "name": "San Juan Bautista Cacalote",
                        "latitude": "20.34806000",
                        "longitude": "-100.78833000"
                    },
                    {
                        "id": 73959,
                        "name": "San Juan de Abajo",
                        "latitude": "21.05623000",
                        "longitude": "-101.63544000"
                    },
                    {
                        "id": 73966,
                        "name": "San Juan de la Vega",
                        "latitude": "20.62521000",
                        "longitude": "-100.76141000"
                    },
                    {
                        "id": 73962,
                        "name": "San Juan de Otates",
                        "latitude": "21.11562000",
                        "longitude": "-101.55773000"
                    },
                    {
                        "id": 73974,
                        "name": "San Juan del Llanito",
                        "latitude": "20.51369000",
                        "longitude": "-100.53980000"
                    },
                    {
                        "id": 73893,
                        "name": "San Juan Grande",
                        "latitude": "20.37627000",
                        "longitude": "-101.52677000"
                    },
                    {
                        "id": 73903,
                        "name": "San Juan Jaripeo",
                        "latitude": "20.00601000",
                        "longitude": "-100.76052000"
                    },
                    {
                        "id": 73914,
                        "name": "San Juan Pan de Arriba",
                        "latitude": "21.47151000",
                        "longitude": "-100.92021000"
                    },
                    {
                        "id": 73991,
                        "name": "San Lorenzo",
                        "latitude": "20.46687000",
                        "longitude": "-100.71970000"
                    },
                    {
                        "id": 74023,
                        "name": "San Lucas",
                        "latitude": "20.29341000",
                        "longitude": "-100.55238000"
                    },
                    {
                        "id": 74060,
                        "name": "San Luis de la Paz",
                        "latitude": "21.29771000",
                        "longitude": "-100.51736000"
                    },
                    {
                        "id": 74228,
                        "name": "San Miguel de Allende",
                        "latitude": "20.91528000",
                        "longitude": "-100.74389000"
                    },
                    {
                        "id": 74233,
                        "name": "San Miguel del Arenal",
                        "latitude": "20.99083000",
                        "longitude": "-101.48556000"
                    },
                    {
                        "id": 74176,
                        "name": "San Miguel Eménguaro",
                        "latitude": "20.16402000",
                        "longitude": "-100.88596000"
                    },
                    {
                        "id": 74191,
                        "name": "San Miguel Octopan",
                        "latitude": "20.57428000",
                        "longitude": "-100.74780000"
                    },
                    {
                        "id": 74270,
                        "name": "San Nicolás de la Condesa",
                        "latitude": "20.23259000",
                        "longitude": "-100.78108000"
                    },
                    {
                        "id": 74272,
                        "name": "San Nicolás de los Agustinos",
                        "latitude": "20.24614000",
                        "longitude": "-100.96679000"
                    },
                    {
                        "id": 74275,
                        "name": "San Nicolás del Cármen",
                        "latitude": "21.27405000",
                        "longitude": "-100.55032000"
                    },
                    {
                        "id": 74258,
                        "name": "San Nicolás Parangueo",
                        "latitude": "20.39356000",
                        "longitude": "-101.25364000"
                    },
                    {
                        "id": 74263,
                        "name": "San Nicolás Temascatío",
                        "latitude": "20.72486000",
                        "longitude": "-101.24874000"
                    },
                    {
                        "id": 74298,
                        "name": "San Pablo Pejo",
                        "latitude": "20.03375000",
                        "longitude": "-100.93763000"
                    },
                    {
                        "id": 74404,
                        "name": "San Pedro de Ibarra",
                        "latitude": "21.48320000",
                        "longitude": "-101.54046000"
                    },
                    {
                        "id": 74409,
                        "name": "San Pedro de los Naranjos",
                        "latitude": "20.22716000",
                        "longitude": "-100.93782000"
                    },
                    {
                        "id": 74378,
                        "name": "San Pedro Tenango",
                        "latitude": "20.50769000",
                        "longitude": "-100.63247000"
                    },
                    {
                        "id": 74440,
                        "name": "San Roque",
                        "latitude": "20.59966000",
                        "longitude": "-101.34182000"
                    },
                    {
                        "id": 74442,
                        "name": "San Roque de Montes",
                        "latitude": "21.01000000",
                        "longitude": "-101.81083000"
                    },
                    {
                        "id": 74443,
                        "name": "San Roque de Torres",
                        "latitude": "20.97138000",
                        "longitude": "-101.85290000"
                    },
                    {
                        "id": 74450,
                        "name": "San Salvador Torrecillas",
                        "latitude": "20.55981000",
                        "longitude": "-100.95784000"
                    },
                    {
                        "id": 74478,
                        "name": "San Sebastián de Salitre",
                        "latitude": "21.10278000",
                        "longitude": "-100.48086000"
                    },
                    {
                        "id": 74494,
                        "name": "San Vicente",
                        "latitude": "20.82864000",
                        "longitude": "-101.34130000"
                    },
                    {
                        "id": 74507,
                        "name": "San Vicente de Flores",
                        "latitude": "20.62172000",
                        "longitude": "-101.25296000"
                    },
                    {
                        "id": 74523,
                        "name": "Santa Ana",
                        "latitude": "21.05917000",
                        "longitude": "-101.67583000"
                    },
                    {
                        "id": 74544,
                        "name": "Santa Ana Pacueco",
                        "latitude": "20.34722000",
                        "longitude": "-102.01583000"
                    },
                    {
                        "id": 74558,
                        "name": "Santa Anita",
                        "latitude": "20.47028000",
                        "longitude": "-100.81500000"
                    },
                    {
                        "id": 74566,
                        "name": "Santa Bárbara",
                        "latitude": "21.53716000",
                        "longitude": "-101.37787000"
                    },
                    {
                        "id": 74579,
                        "name": "Santa Catarina",
                        "latitude": "21.15134000",
                        "longitude": "-100.06954000"
                    },
                    {
                        "id": 74599,
                        "name": "Santa Clara",
                        "latitude": "20.17904000",
                        "longitude": "-101.43350000"
                    },
                    {
                        "id": 74648,
                        "name": "Santa Cruz de Juventino Rosas",
                        "latitude": "20.63658000",
                        "longitude": "-100.97956000"
                    },
                    {
                        "id": 74659,
                        "name": "Santa Fe de la Purísima",
                        "latitude": "20.49556000",
                        "longitude": "-100.89278000"
                    },
                    {
                        "id": 74816,
                        "name": "Santa María del Refugio",
                        "latitude": "20.44030000",
                        "longitude": "-100.80032000"
                    },
                    {
                        "id": 74838,
                        "name": "Santa Rosa",
                        "latitude": "21.55181000",
                        "longitude": "-101.09210000"
                    },
                    {
                        "id": 74850,
                        "name": "Santa Rosa de Lima",
                        "latitude": "21.07179000",
                        "longitude": "-101.19723000"
                    },
                    {
                        "id": 74852,
                        "name": "Santa Rosa de Rivas",
                        "latitude": "20.78112000",
                        "longitude": "-101.53632000"
                    },
                    {
                        "id": 74853,
                        "name": "Santa Rosa los Angeles",
                        "latitude": "20.56585000",
                        "longitude": "-100.92356000"
                    },
                    {
                        "id": 74860,
                        "name": "Santa Teresa",
                        "latitude": "20.95973000",
                        "longitude": "-101.31644000"
                    },
                    {
                        "id": 74862,
                        "name": "Santa Teresita de Don Diego",
                        "latitude": "20.88000000",
                        "longitude": "-100.77861000"
                    },
                    {
                        "id": 74885,
                        "name": "Santiago Capitiro",
                        "latitude": "20.30427000",
                        "longitude": "-101.01767000"
                    },
                    {
                        "id": 74983,
                        "name": "Santiago de Cuenda",
                        "latitude": "20.59956000",
                        "longitude": "-100.99405000"
                    },
                    {
                        "id": 74921,
                        "name": "Santiago Maravatío",
                        "latitude": "20.17297000",
                        "longitude": "-100.99468000"
                    },
                    {
                        "id": 75028,
                        "name": "Santo Tomás Huatzindeo",
                        "latitude": "20.22205000",
                        "longitude": "-100.92068000"
                    },
                    {
                        "id": 75040,
                        "name": "Sarabia",
                        "latitude": "20.52256000",
                        "longitude": "-101.06163000"
                    },
                    {
                        "id": 75063,
                        "name": "Serrano",
                        "latitude": "20.77830000",
                        "longitude": "-101.39540000"
                    },
                    {
                        "id": 75079,
                        "name": "Silao",
                        "latitude": "20.94356000",
                        "longitude": "-101.42703000"
                    },
                    {
                        "id": 75080,
                        "name": "Silao de la Victoria",
                        "latitude": "20.93718000",
                        "longitude": "-101.44987000"
                    },
                    {
                        "id": 75082,
                        "name": "Silva",
                        "latitude": "20.94617000",
                        "longitude": "-101.85687000"
                    },
                    {
                        "id": 75114,
                        "name": "Soledad Nueva",
                        "latitude": "21.27942000",
                        "longitude": "-100.92249000"
                    },
                    {
                        "id": 75126,
                        "name": "Sotelo",
                        "latitude": "20.45773000",
                        "longitude": "-101.07766000"
                    },
                    {
                        "id": 75141,
                        "name": "Suchitlán",
                        "latitude": "20.53320000",
                        "longitude": "-101.02360000"
                    },
                    {
                        "id": 75178,
                        "name": "Tamazula",
                        "latitude": "20.44228000",
                        "longitude": "-101.55330000"
                    },
                    {
                        "id": 75229,
                        "name": "Tarandacuao",
                        "latitude": "20.00094000",
                        "longitude": "-100.51856000"
                    },
                    {
                        "id": 75232,
                        "name": "Taretán",
                        "latitude": "20.77880000",
                        "longitude": "-101.33526000"
                    },
                    {
                        "id": 75233,
                        "name": "Tarimoro",
                        "latitude": "20.28336000",
                        "longitude": "-100.75477000"
                    },
                    {
                        "id": 75305,
                        "name": "Tejocote de Calera",
                        "latitude": "20.17918000",
                        "longitude": "-101.39710000"
                    },
                    {
                        "id": 75358,
                        "name": "Tenango el Nuevo",
                        "latitude": "20.53111000",
                        "longitude": "-100.67170000"
                    },
                    {
                        "id": 75362,
                        "name": "Tenería del Santuario",
                        "latitude": "20.59955000",
                        "longitude": "-100.79790000"
                    },
                    {
                        "id": 75464,
                        "name": "Tequisquiapan",
                        "latitude": "21.07996000",
                        "longitude": "-100.82067000"
                    },
                    {
                        "id": 75551,
                        "name": "Tierra Fría",
                        "latitude": "20.46145000",
                        "longitude": "-101.03927000"
                    },
                    {
                        "id": 75728,
                        "name": "Tomelopitos",
                        "latitude": "20.59463000",
                        "longitude": "-101.36846000"
                    },
                    {
                        "id": 75798,
                        "name": "Tulillos de Abajo",
                        "latitude": "21.08563000",
                        "longitude": "-100.48411000"
                    },
                    {
                        "id": 75812,
                        "name": "Tupataro",
                        "latitude": "20.59512000",
                        "longitude": "-101.64637000"
                    },
                    {
                        "id": 75891,
                        "name": "Uriangato",
                        "latitude": "20.14085000",
                        "longitude": "-101.18251000"
                    },
                    {
                        "id": 75895,
                        "name": "Urireo",
                        "latitude": "20.21314000",
                        "longitude": "-100.84188000"
                    },
                    {
                        "id": 75907,
                        "name": "Valencia de Cerro Gordo",
                        "latitude": "20.60133000",
                        "longitude": "-101.08173000"
                    },
                    {
                        "id": 75908,
                        "name": "Valencianita",
                        "latitude": "20.74701000",
                        "longitude": "-101.30223000"
                    },
                    {
                        "id": 75924,
                        "name": "Valle de Santiago",
                        "latitude": "20.39140000",
                        "longitude": "-101.19222000"
                    },
                    {
                        "id": 75934,
                        "name": "Valtierrilla",
                        "latitude": "20.53244000",
                        "longitude": "-101.12761000"
                    },
                    {
                        "id": 75982,
                        "name": "Victoria",
                        "latitude": "21.21183000",
                        "longitude": "-100.21545000"
                    },
                    {
                        "id": 75984,
                        "name": "Victoria de Cortazar",
                        "latitude": "20.33460000",
                        "longitude": "-101.03173000"
                    },
                    {
                        "id": 76079,
                        "name": "Villagrán",
                        "latitude": "20.51452000",
                        "longitude": "-100.99745000"
                    },
                    {
                        "id": 76088,
                        "name": "Villas de Irapuato",
                        "latitude": "20.68722000",
                        "longitude": "-101.40528000"
                    },
                    {
                        "id": 76135,
                        "name": "Xichú",
                        "latitude": "21.34418000",
                        "longitude": "-99.99970000"
                    },
                    {
                        "id": 76183,
                        "name": "Xoconoxtle el Grande",
                        "latitude": "20.93857000",
                        "longitude": "-100.98149000"
                    },
                    {
                        "id": 76233,
                        "name": "Yerbabuena",
                        "latitude": "20.96319000",
                        "longitude": "-101.27448000"
                    },
                    {
                        "id": 76248,
                        "name": "Yuriria",
                        "latitude": "20.21081000",
                        "longitude": "-101.13212000"
                    },
                    {
                        "id": 76250,
                        "name": "Yustis",
                        "latitude": "20.58233000",
                        "longitude": "-100.86392000"
                    },
                    {
                        "id": 76297,
                        "name": "Zangarro (Zangarro Nuevo)",
                        "latitude": "20.85806000",
                        "longitude": "-101.27278000"
                    },
                    {
                        "id": 76302,
                        "name": "Zapote de Barajas",
                        "latitude": "20.37536000",
                        "longitude": "-101.69964000"
                    },
                    {
                        "id": 76303,
                        "name": "Zapote de Cestao",
                        "latitude": "20.48362000",
                        "longitude": "-101.67596000"
                    },
                    {
                        "id": 76304,
                        "name": "Zapote de Palomas",
                        "latitude": "20.58444000",
                        "longitude": "-101.11500000"
                    },
                    {
                        "id": 76305,
                        "name": "Zapote de Peralta",
                        "latitude": "20.45068000",
                        "longitude": "-101.39481000"
                    },
                    {
                        "id": 76306,
                        "name": "Zapotillo de Mogotes",
                        "latitude": "20.37850000",
                        "longitude": "-101.24795000"
                    }
                ]
            },
            {
                "id": 3459,
                "name": "Guerrero",
                "iso2": "GRO",
                "latitude": "17.43919260",
                "longitude": "-99.54509740",
                "type": "state",
                "cities": [
                    {
                        "id": 68005,
                        "name": "10 de Abril",
                        "latitude": "16.82917000",
                        "longitude": "-99.74083000"
                    },
                    {
                        "id": 68026,
                        "name": "Acahuizotla",
                        "latitude": "17.36054000",
                        "longitude": "-99.46759000"
                    },
                    {
                        "id": 68030,
                        "name": "Acalco",
                        "latitude": "17.50575000",
                        "longitude": "-99.16670000"
                    },
                    {
                        "id": 68034,
                        "name": "Acamixtla",
                        "latitude": "18.56512000",
                        "longitude": "-99.56599000"
                    },
                    {
                        "id": 68037,
                        "name": "Acapetlahuaya",
                        "latitude": "18.41942000",
                        "longitude": "-100.07237000"
                    },
                    {
                        "id": 68039,
                        "name": "Acapulco de Juárez",
                        "latitude": "16.84942000",
                        "longitude": "-99.90891000"
                    },
                    {
                        "id": 68040,
                        "name": "Acatempa",
                        "latitude": "17.64333000",
                        "longitude": "-99.36639000"
                    },
                    {
                        "id": 68041,
                        "name": "Acatempan",
                        "latitude": "18.31809000",
                        "longitude": "-99.88298000"
                    },
                    {
                        "id": 68045,
                        "name": "Acatepec",
                        "latitude": "17.17482000",
                        "longitude": "-98.97603000"
                    },
                    {
                        "id": 68048,
                        "name": "Acatlán",
                        "latitude": "17.65807000",
                        "longitude": "-99.16944000"
                    },
                    {
                        "id": 68077,
                        "name": "Acuitlapan",
                        "latitude": "18.60155000",
                        "longitude": "-99.54260000"
                    },
                    {
                        "id": 68119,
                        "name": "Agua Zarca",
                        "latitude": "16.62365000",
                        "longitude": "-98.70245000"
                    },
                    {
                        "id": 68124,
                        "name": "Aguas Blancas",
                        "latitude": "17.03654000",
                        "longitude": "-100.06300000"
                    },
                    {
                        "id": 68126,
                        "name": "Aguas Calientes",
                        "latitude": "16.84250000",
                        "longitude": "-99.64056000"
                    },
                    {
                        "id": 68132,
                        "name": "Ahuacachahue (Ndog'yo Itún Tichi)",
                        "latitude": "16.82861000",
                        "longitude": "-98.98556000"
                    },
                    {
                        "id": 68140,
                        "name": "Ahuacuotzingo",
                        "latitude": "17.74253000",
                        "longitude": "-98.91781000"
                    },
                    {
                        "id": 68141,
                        "name": "Ahuajutla",
                        "latitude": "17.43043000",
                        "longitude": "-98.29029000"
                    },
                    {
                        "id": 68146,
                        "name": "Ahuatepec Pueblo",
                        "latitude": "17.60577000",
                        "longitude": "-98.58970000"
                    },
                    {
                        "id": 68152,
                        "name": "Ahuehuepan",
                        "latitude": "18.00625000",
                        "longitude": "-99.49995000"
                    },
                    {
                        "id": 68158,
                        "name": "Ahuexotitlán",
                        "latitude": "17.52849000",
                        "longitude": "-99.24398000"
                    },
                    {
                        "id": 68160,
                        "name": "Ahuihuiyuco",
                        "latitude": "17.62958000",
                        "longitude": "-99.22738000"
                    },
                    {
                        "id": 68168,
                        "name": "Ajuchitlán del Progreso",
                        "latitude": "18.15189000",
                        "longitude": "-100.48353000"
                    },
                    {
                        "id": 68180,
                        "name": "Alcholoa",
                        "latitude": "17.15110000",
                        "longitude": "-100.40837000"
                    },
                    {
                        "id": 68182,
                        "name": "Alcozacán",
                        "latitude": "17.50444000",
                        "longitude": "-99.09500000"
                    },
                    {
                        "id": 68183,
                        "name": "Alcozauca de Guerrero",
                        "latitude": "17.46481000",
                        "longitude": "-98.38428000"
                    },
                    {
                        "id": 68211,
                        "name": "Almolonga",
                        "latitude": "17.63826000",
                        "longitude": "-99.29502000"
                    },
                    {
                        "id": 68218,
                        "name": "Alpoyeca",
                        "latitude": "17.64600000",
                        "longitude": "-98.51004000"
                    },
                    {
                        "id": 68220,
                        "name": "Alpuyecancingo de las Montañas",
                        "latitude": "17.67083000",
                        "longitude": "-98.85194000"
                    },
                    {
                        "id": 68240,
                        "name": "Amatillo",
                        "latitude": "16.82028000",
                        "longitude": "-99.66611000"
                    },
                    {
                        "id": 68263,
                        "name": "Amuco de la Reforma",
                        "latitude": "18.29361000",
                        "longitude": "-100.63972000"
                    },
                    {
                        "id": 68287,
                        "name": "Apalani",
                        "latitude": "16.85361000",
                        "longitude": "-99.58944000"
                    },
                    {
                        "id": 68289,
                        "name": "Apango",
                        "latitude": "17.74121000",
                        "longitude": "-99.32909000"
                    },
                    {
                        "id": 68291,
                        "name": "Apantla",
                        "latitude": "17.03972000",
                        "longitude": "-99.16944000"
                    },
                    {
                        "id": 68302,
                        "name": "Apaxtla",
                        "latitude": "18.07628000",
                        "longitude": "-99.99562000"
                    },
                    {
                        "id": 68303,
                        "name": "Apaxtla de Castrejón",
                        "latitude": "18.13127000",
                        "longitude": "-99.93255000"
                    },
                    {
                        "id": 68307,
                        "name": "Apipilulco",
                        "latitude": "18.19104000",
                        "longitude": "-99.67205000"
                    },
                    {
                        "id": 68333,
                        "name": "Aratichanguío",
                        "latitude": "18.47877000",
                        "longitude": "-101.36211000"
                    },
                    {
                        "id": 68338,
                        "name": "Arcelia",
                        "latitude": "18.26627000",
                        "longitude": "-100.19066000"
                    },
                    {
                        "id": 68339,
                        "name": "Arcelia de Rodríguez",
                        "latitude": "16.73668000",
                        "longitude": "-98.64486000"
                    },
                    {
                        "id": 68348,
                        "name": "Arenal de Álvarez (Arenal de Paco)",
                        "latitude": "17.12611000",
                        "longitude": "-100.45500000"
                    },
                    {
                        "id": 68397,
                        "name": "Atenango del Río",
                        "latitude": "18.10526000",
                        "longitude": "-99.10777000"
                    },
                    {
                        "id": 68401,
                        "name": "Atenxoxola",
                        "latitude": "17.48819000",
                        "longitude": "-99.14285000"
                    },
                    {
                        "id": 68413,
                        "name": "Atlamajac",
                        "latitude": "17.55528000",
                        "longitude": "-98.54722000"
                    },
                    {
                        "id": 68414,
                        "name": "Atlamajalcingo del Río",
                        "latitude": "17.52667000",
                        "longitude": "-98.65556000"
                    },
                    {
                        "id": 68421,
                        "name": "Atliaca",
                        "latitude": "17.65168000",
                        "longitude": "-99.37471000"
                    },
                    {
                        "id": 68423,
                        "name": "Atlixtac",
                        "latitude": "17.51434000",
                        "longitude": "-98.90305000"
                    },
                    {
                        "id": 68434,
                        "name": "Atoyac de Álvarez",
                        "latitude": "17.20667000",
                        "longitude": "-100.43306000"
                    },
                    {
                        "id": 68437,
                        "name": "Atzacoaloya",
                        "latitude": "17.54659000",
                        "longitude": "-99.13757000"
                    },
                    {
                        "id": 68449,
                        "name": "Axaxacualco",
                        "latitude": "17.80387000",
                        "longitude": "-99.46175000"
                    },
                    {
                        "id": 68450,
                        "name": "Axixintla",
                        "latitude": "18.60222000",
                        "longitude": "-99.51806000"
                    },
                    {
                        "id": 68457,
                        "name": "Ayahualulco",
                        "latitude": "17.50066000",
                        "longitude": "-99.18264000"
                    },
                    {
                        "id": 68467,
                        "name": "Ayotzinapa",
                        "latitude": "17.55628000",
                        "longitude": "-98.76346000"
                    },
                    {
                        "id": 68471,
                        "name": "Ayutla de los Libres",
                        "latitude": "16.96376000",
                        "longitude": "-99.09616000"
                    },
                    {
                        "id": 68473,
                        "name": "Azoyú",
                        "latitude": "16.64925000",
                        "longitude": "-98.57828000"
                    },
                    {
                        "id": 68503,
                        "name": "Bajos del Ejido",
                        "latitude": "16.96086000",
                        "longitude": "-99.97169000"
                    },
                    {
                        "id": 68519,
                        "name": "Barra de Tecoanapa",
                        "latitude": "16.50864000",
                        "longitude": "-98.73216000"
                    },
                    {
                        "id": 68528,
                        "name": "Barrio Nuevo",
                        "latitude": "17.72075000",
                        "longitude": "-101.63657000"
                    },
                    {
                        "id": 68529,
                        "name": "Barrio Nuevo de los Muertos",
                        "latitude": "16.89278000",
                        "longitude": "-99.54389000"
                    },
                    {
                        "id": 68660,
                        "name": "Buena Vista",
                        "latitude": "16.96250000",
                        "longitude": "-98.58077000"
                    },
                    {
                        "id": 68666,
                        "name": "Buena Vista de la Salud",
                        "latitude": "17.26082000",
                        "longitude": "-99.50183000"
                    },
                    {
                        "id": 68679,
                        "name": "Buenavista de Allende",
                        "latitude": "17.00086000",
                        "longitude": "-99.21325000"
                    },
                    {
                        "id": 68682,
                        "name": "Buenavista de Cuéllar",
                        "latitude": "18.45958000",
                        "longitude": "-99.40868000"
                    },
                    {
                        "id": 68710,
                        "name": "Cacalotenango",
                        "latitude": "18.54639000",
                        "longitude": "-99.64361000"
                    },
                    {
                        "id": 68713,
                        "name": "Cacalutla",
                        "latitude": "17.12433000",
                        "longitude": "-100.35038000"
                    },
                    {
                        "id": 68719,
                        "name": "Cahuatache",
                        "latitude": "17.41624000",
                        "longitude": "-98.53184000"
                    },
                    {
                        "id": 68722,
                        "name": "Cajelitos",
                        "latitude": "17.26778000",
                        "longitude": "-99.49306000"
                    },
                    {
                        "id": 68769,
                        "name": "Campanario",
                        "latitude": "16.83534000",
                        "longitude": "-99.57178000"
                    },
                    {
                        "id": 68843,
                        "name": "Carrizalillo",
                        "latitude": "17.85077000",
                        "longitude": "-99.71263000"
                    },
                    {
                        "id": 68869,
                        "name": "Caxitepec",
                        "latitude": "17.29449000",
                        "longitude": "-98.96741000"
                    },
                    {
                        "id": 68871,
                        "name": "Cayaco",
                        "latitude": "17.04743000",
                        "longitude": "-100.26859000"
                    },
                    {
                        "id": 68934,
                        "name": "Cerro de Piedra",
                        "latitude": "16.77646000",
                        "longitude": "-99.63037000"
                    },
                    {
                        "id": 68944,
                        "name": "Chacalapa",
                        "latitude": "16.80682000",
                        "longitude": "-98.45788000"
                    },
                    {
                        "id": 68974,
                        "name": "Changata",
                        "latitude": "18.27306000",
                        "longitude": "-100.58528000"
                    },
                    {
                        "id": 69000,
                        "name": "Chaucingo",
                        "latitude": "18.30038000",
                        "longitude": "-99.11535000"
                    },
                    {
                        "id": 69012,
                        "name": "Chiaucingo",
                        "latitude": "17.74207000",
                        "longitude": "-98.69720000"
                    },
                    {
                        "id": 69026,
                        "name": "Chichihualco",
                        "latitude": "17.65902000",
                        "longitude": "-99.67624000"
                    },
                    {
                        "id": 69051,
                        "name": "Chiepetepec",
                        "latitude": "17.56568000",
                        "longitude": "-98.73364000"
                    },
                    {
                        "id": 69062,
                        "name": "Chilacachapa",
                        "latitude": "18.27394000",
                        "longitude": "-99.76177000"
                    },
                    {
                        "id": 69065,
                        "name": "Chilapa de Álvarez",
                        "latitude": "17.59917000",
                        "longitude": "-99.17389000"
                    },
                    {
                        "id": 69072,
                        "name": "Chilpancingo",
                        "latitude": "17.55060000",
                        "longitude": "-99.50578000"
                    },
                    {
                        "id": 69105,
                        "name": "Chontalcoatlán",
                        "latitude": "18.65421000",
                        "longitude": "-99.57380000"
                    },
                    {
                        "id": 69143,
                        "name": "Ciudad Altamirano",
                        "latitude": "18.35820000",
                        "longitude": "-100.66965000"
                    },
                    {
                        "id": 69190,
                        "name": "Ciudad de Huitzuco",
                        "latitude": "18.30334000",
                        "longitude": "-99.33376000"
                    },
                    {
                        "id": 69204,
                        "name": "Coachimalco",
                        "latitude": "17.62523000",
                        "longitude": "-98.68122000"
                    },
                    {
                        "id": 69208,
                        "name": "Coacoyula de Álvarez",
                        "latitude": "18.07635000",
                        "longitude": "-99.63050000"
                    },
                    {
                        "id": 69209,
                        "name": "Coacoyulichán",
                        "latitude": "16.79484000",
                        "longitude": "-98.93551000"
                    },
                    {
                        "id": 69210,
                        "name": "Coacoyulillo",
                        "latitude": "17.33471000",
                        "longitude": "-99.64859000"
                    },
                    {
                        "id": 69214,
                        "name": "Coahuayutla de Guerrero",
                        "latitude": "18.31469000",
                        "longitude": "-101.73574000"
                    },
                    {
                        "id": 69215,
                        "name": "Coahuayutla de José María Izazaga",
                        "latitude": "18.27847000",
                        "longitude": "-101.63863000"
                    },
                    {
                        "id": 69227,
                        "name": "Coatepec Costales",
                        "latitude": "18.33922000",
                        "longitude": "-99.72140000"
                    },
                    {
                        "id": 69235,
                        "name": "Cochoapa",
                        "latitude": "16.72190000",
                        "longitude": "-98.37196000"
                    },
                    {
                        "id": 69236,
                        "name": "Cochoapa el Grande",
                        "latitude": "17.19280000",
                        "longitude": "-98.45592000"
                    },
                    {
                        "id": 69244,
                        "name": "Cocula",
                        "latitude": "18.14296000",
                        "longitude": "-99.70452000"
                    },
                    {
                        "id": 69263,
                        "name": "Colombia de Guadalupe",
                        "latitude": "17.08840000",
                        "longitude": "-98.75901000"
                    },
                    {
                        "id": 69273,
                        "name": "Colonia Aeropuerto",
                        "latitude": "17.62028000",
                        "longitude": "-101.45889000"
                    },
                    {
                        "id": 69278,
                        "name": "Colonia Alborada",
                        "latitude": "16.88151000",
                        "longitude": "-99.81779000"
                    },
                    {
                        "id": 69288,
                        "name": "Colonia Constitución",
                        "latitude": "17.53667000",
                        "longitude": "-98.59944000"
                    },
                    {
                        "id": 69387,
                        "name": "Colonia el Pedregal",
                        "latitude": "18.34961000",
                        "longitude": "-99.85642000"
                    },
                    {
                        "id": 69324,
                        "name": "Colonia Luces en el Mar",
                        "latitude": "16.92162000",
                        "longitude": "-100.01526000"
                    },
                    {
                        "id": 69340,
                        "name": "Colonia Nueva Revolución",
                        "latitude": "16.89833000",
                        "longitude": "-99.80583000"
                    },
                    {
                        "id": 69355,
                        "name": "Colonia Renacimiento",
                        "latitude": "16.76278000",
                        "longitude": "-98.18222000"
                    },
                    {
                        "id": 69411,
                        "name": "Colotepec",
                        "latitude": "17.04104000",
                        "longitude": "-99.21273000"
                    },
                    {
                        "id": 69412,
                        "name": "Colotlipa",
                        "latitude": "17.41242000",
                        "longitude": "-99.16711000"
                    },
                    {
                        "id": 69470,
                        "name": "Copala",
                        "latitude": "16.60674000",
                        "longitude": "-98.94094000"
                    },
                    {
                        "id": 69471,
                        "name": "Copalillo",
                        "latitude": "17.97003000",
                        "longitude": "-99.05436000"
                    },
                    {
                        "id": 69472,
                        "name": "Copanatoyac",
                        "latitude": "17.42911000",
                        "longitude": "-98.70006000"
                    },
                    {
                        "id": 69484,
                        "name": "Corral Falso",
                        "latitude": "18.24472000",
                        "longitude": "-100.56000000"
                    },
                    {
                        "id": 69514,
                        "name": "Coyahualco",
                        "latitude": "17.74139000",
                        "longitude": "-98.56667000"
                    },
                    {
                        "id": 69526,
                        "name": "Coyuca de Benítez",
                        "latitude": "17.00895000",
                        "longitude": "-100.08714000"
                    },
                    {
                        "id": 69527,
                        "name": "Coyuca de Catalán",
                        "latitude": "18.32614000",
                        "longitude": "-100.69898000"
                    },
                    {
                        "id": 69528,
                        "name": "Coyuquilla Norte",
                        "latitude": "17.38027000",
                        "longitude": "-101.05631000"
                    },
                    {
                        "id": 69543,
                        "name": "Cruz Grande",
                        "latitude": "16.72241000",
                        "longitude": "-99.12356000"
                    },
                    {
                        "id": 69544,
                        "name": "Cruz Quemada",
                        "latitude": "16.99722000",
                        "longitude": "-99.17964000"
                    },
                    {
                        "id": 69553,
                        "name": "Cuajinicuilapa",
                        "latitude": "16.47347000",
                        "longitude": "-98.41389000"
                    },
                    {
                        "id": 69554,
                        "name": "Cualác",
                        "latitude": "17.72928000",
                        "longitude": "-98.67254000"
                    },
                    {
                        "id": 69557,
                        "name": "Cuanacaxtitlán",
                        "latitude": "16.79953000",
                        "longitude": "-98.63992000"
                    },
                    {
                        "id": 69571,
                        "name": "Cuatzoquitengo",
                        "latitude": "17.28822000",
                        "longitude": "-98.61523000"
                    },
                    {
                        "id": 69577,
                        "name": "Cuauhtenango",
                        "latitude": "17.54625000",
                        "longitude": "-99.20683000"
                    },
                    {
                        "id": 69587,
                        "name": "Cuautepec",
                        "latitude": "16.70520000",
                        "longitude": "-98.98471000"
                    },
                    {
                        "id": 69621,
                        "name": "Cuetzala del Progreso",
                        "latitude": "18.13472000",
                        "longitude": "-99.83190000"
                    },
                    {
                        "id": 69633,
                        "name": "Cumbre de Barranca Honda",
                        "latitude": "16.73167000",
                        "longitude": "-98.33667000"
                    },
                    {
                        "id": 69641,
                        "name": "Cuonetzingo",
                        "latitude": "17.52722000",
                        "longitude": "-99.26583000"
                    },
                    {
                        "id": 69651,
                        "name": "Cutzamala de Pinzón",
                        "latitude": "18.46783000",
                        "longitude": "-100.58089000"
                    },
                    {
                        "id": 69654,
                        "name": "Cuyuxtlahuaca",
                        "latitude": "17.48213000",
                        "longitude": "-98.34456000"
                    },
                    {
                        "id": 69716,
                        "name": "Dos Arroyos",
                        "latitude": "17.02060000",
                        "longitude": "-99.64966000"
                    },
                    {
                        "id": 69779,
                        "name": "Ejido Nuevo",
                        "latitude": "16.97405000",
                        "longitude": "-99.73702000"
                    },
                    {
                        "id": 69799,
                        "name": "Ejido Viejo",
                        "latitude": "16.94812000",
                        "longitude": "-99.94606000"
                    },
                    {
                        "id": 69843,
                        "name": "El Bejuco",
                        "latitude": "16.82488000",
                        "longitude": "-99.70720000"
                    },
                    {
                        "id": 69869,
                        "name": "El Carmen",
                        "latitude": "16.95036000",
                        "longitude": "-98.23764000"
                    },
                    {
                        "id": 69907,
                        "name": "El Coacoyul",
                        "latitude": "17.63810000",
                        "longitude": "-101.47571000"
                    },
                    {
                        "id": 69916,
                        "name": "El Conchero",
                        "latitude": "16.94266000",
                        "longitude": "-99.96233000"
                    },
                    {
                        "id": 69930,
                        "name": "El Cortés",
                        "latitude": "16.78063000",
                        "longitude": "-99.50210000"
                    },
                    {
                        "id": 69929,
                        "name": "El Cortijo",
                        "latitude": "16.98972000",
                        "longitude": "-99.14889000"
                    },
                    {
                        "id": 69947,
                        "name": "El Durazno",
                        "latitude": "17.52828000",
                        "longitude": "-99.29057000"
                    },
                    {
                        "id": 69951,
                        "name": "El Embarcadero",
                        "latitude": "16.96417000",
                        "longitude": "-100.00167000"
                    },
                    {
                        "id": 69956,
                        "name": "El Escondido",
                        "latitude": "18.22068000",
                        "longitude": "-100.31208000"
                    },
                    {
                        "id": 69964,
                        "name": "El Espinalillo",
                        "latitude": "16.98472000",
                        "longitude": "-100.12694000"
                    },
                    {
                        "id": 69967,
                        "name": "El Fresno",
                        "latitude": "17.43143000",
                        "longitude": "-99.58605000"
                    },
                    {
                        "id": 70004,
                        "name": "El Jicaral",
                        "latitude": "17.12617000",
                        "longitude": "-98.19697000"
                    },
                    {
                        "id": 70017,
                        "name": "El Limón",
                        "latitude": "16.99556000",
                        "longitude": "-99.37750000"
                    },
                    {
                        "id": 70034,
                        "name": "El Mesón",
                        "latitude": "16.84570000",
                        "longitude": "-99.05868000"
                    },
                    {
                        "id": 70035,
                        "name": "El Metlapil",
                        "latitude": "16.84167000",
                        "longitude": "-99.74889000"
                    },
                    {
                        "id": 70055,
                        "name": "El Naranjito",
                        "latitude": "17.98801000",
                        "longitude": "-102.15752000"
                    },
                    {
                        "id": 70071,
                        "name": "El Ocotito",
                        "latitude": "17.24603000",
                        "longitude": "-99.51525000"
                    },
                    {
                        "id": 70086,
                        "name": "El Papayo",
                        "latitude": "17.03468000",
                        "longitude": "-100.24788000"
                    },
                    {
                        "id": 70090,
                        "name": "El Paraíso",
                        "latitude": "17.34361000",
                        "longitude": "-100.22806000"
                    },
                    {
                        "id": 70098,
                        "name": "El Pericón",
                        "latitude": "16.98001000",
                        "longitude": "-99.32573000"
                    },
                    {
                        "id": 70107,
                        "name": "El Pitahayo",
                        "latitude": "16.53236000",
                        "longitude": "-98.52760000"
                    },
                    {
                        "id": 70113,
                        "name": "El Polvorín",
                        "latitude": "16.57833000",
                        "longitude": "-98.80139000"
                    },
                    {
                        "id": 70123,
                        "name": "El Potrerillo (Potrerillo del Rincón)",
                        "latitude": "16.95806000",
                        "longitude": "-98.73083000"
                    },
                    {
                        "id": 70153,
                        "name": "El Refugio",
                        "latitude": "17.03833000",
                        "longitude": "-99.20056000"
                    },
                    {
                        "id": 70161,
                        "name": "El Rincón (Santa Cruz del Rincón)",
                        "latitude": "16.99611000",
                        "longitude": "-98.73528000"
                    },
                    {
                        "id": 70189,
                        "name": "El Salto",
                        "latitude": "16.86460000",
                        "longitude": "-99.76543000"
                    },
                    {
                        "id": 70210,
                        "name": "El Súchil",
                        "latitude": "17.22694000",
                        "longitude": "-100.63917000"
                    },
                    {
                        "id": 70214,
                        "name": "El Tejocote",
                        "latitude": "17.32903000",
                        "longitude": "-98.65866000"
                    },
                    {
                        "id": 70225,
                        "name": "El Terrero",
                        "latitude": "18.12934000",
                        "longitude": "-100.31819000"
                    },
                    {
                        "id": 70226,
                        "name": "El Ticui",
                        "latitude": "17.21639000",
                        "longitude": "-100.44472000"
                    },
                    {
                        "id": 70316,
                        "name": "Escalerilla Lagunas",
                        "latitude": "17.37806000",
                        "longitude": "-98.84667000"
                    },
                    {
                        "id": 70401,
                        "name": "Fermín Rabadán Cervantes",
                        "latitude": "18.31528000",
                        "longitude": "-99.56722000"
                    },
                    {
                        "id": 70407,
                        "name": "Florencio Villarreal",
                        "latitude": "16.70143000",
                        "longitude": "-99.15247000"
                    },
                    {
                        "id": 70528,
                        "name": "General Canuto A. Neri",
                        "latitude": "18.43072000",
                        "longitude": "-100.10110000"
                    },
                    {
                        "id": 70534,
                        "name": "General Heliodoro Castillo",
                        "latitude": "17.74297000",
                        "longitude": "-100.02859000"
                    },
                    {
                        "id": 70604,
                        "name": "Guadalupe Victoria",
                        "latitude": "16.75611000",
                        "longitude": "-98.18167000"
                    },
                    {
                        "id": 70625,
                        "name": "Guayameo",
                        "latitude": "18.30407000",
                        "longitude": "-101.26167000"
                    },
                    {
                        "id": 70657,
                        "name": "Hacienda de Cabañas",
                        "latitude": "17.09731000",
                        "longitude": "-100.47163000"
                    },
                    {
                        "id": 70709,
                        "name": "Horcasitas",
                        "latitude": "16.88821000",
                        "longitude": "-98.74609000"
                    },
                    {
                        "id": 70728,
                        "name": "Huamuchapa",
                        "latitude": "16.94349000",
                        "longitude": "-99.31884000"
                    },
                    {
                        "id": 70729,
                        "name": "Huamuxtitlán",
                        "latitude": "17.78905000",
                        "longitude": "-98.55569000"
                    },
                    {
                        "id": 70763,
                        "name": "Huehuetán",
                        "latitude": "16.63583000",
                        "longitude": "-98.55889000"
                    },
                    {
                        "id": 70778,
                        "name": "Hueycantenango",
                        "latitude": "17.44873000",
                        "longitude": "-99.02440000"
                    },
                    {
                        "id": 70779,
                        "name": "Hueyitlalpan",
                        "latitude": "17.67528000",
                        "longitude": "-99.29556000"
                    },
                    {
                        "id": 70810,
                        "name": "Huitziltepec",
                        "latitude": "17.75610000",
                        "longitude": "-99.47983000"
                    },
                    {
                        "id": 70815,
                        "name": "Huitzuco de los Figueroa",
                        "latitude": "18.29064000",
                        "longitude": "-99.26361000"
                    },
                    {
                        "id": 70820,
                        "name": "Huixtepec",
                        "latitude": "16.65361000",
                        "longitude": "-98.30455000"
                    },
                    {
                        "id": 70861,
                        "name": "Iguala de la Independencia",
                        "latitude": "18.34536000",
                        "longitude": "-99.54130000"
                    },
                    {
                        "id": 70862,
                        "name": "Igualapa",
                        "latitude": "16.75528000",
                        "longitude": "-98.48370000"
                    },
                    {
                        "id": 70865,
                        "name": "Iliatenco",
                        "latitude": "17.03524000",
                        "longitude": "-98.67721000"
                    },
                    {
                        "id": 70897,
                        "name": "Ixcamilpa",
                        "latitude": "18.02769000",
                        "longitude": "-98.69643000"
                    },
                    {
                        "id": 70900,
                        "name": "Ixcapuzalco",
                        "latitude": "18.51204000",
                        "longitude": "-99.88755000"
                    },
                    {
                        "id": 70902,
                        "name": "Ixcateopan",
                        "latitude": "17.61812000",
                        "longitude": "-98.51405000"
                    },
                    {
                        "id": 70903,
                        "name": "Ixcateopan de Cuauhtémoc",
                        "latitude": "18.50139000",
                        "longitude": "-99.79139000"
                    },
                    {
                        "id": 70906,
                        "name": "Ixcatla",
                        "latitude": "17.42250000",
                        "longitude": "-98.99944000"
                    },
                    {
                        "id": 70927,
                        "name": "Ixtapa",
                        "latitude": "17.66782000",
                        "longitude": "-101.64165000"
                    },
                    {
                        "id": 70928,
                        "name": "Ixtapa-Zihuatanejo",
                        "latitude": "17.64344000",
                        "longitude": "-101.55212000"
                    },
                    {
                        "id": 70949,
                        "name": "Izotepec",
                        "latitude": "17.58500000",
                        "longitude": "-99.95444000"
                    },
                    {
                        "id": 70966,
                        "name": "Jalapa",
                        "latitude": "16.71227000",
                        "longitude": "-99.05564000"
                    },
                    {
                        "id": 70971,
                        "name": "Jaleaca de Catalán",
                        "latitude": "17.44636000",
                        "longitude": "-99.85968000"
                    },
                    {
                        "id": 71042,
                        "name": "Jicayán de Tovar",
                        "latitude": "17.12716000",
                        "longitude": "-98.23622000"
                    },
                    {
                        "id": 71073,
                        "name": "Jolotichán",
                        "latitude": "16.75222000",
                        "longitude": "-98.73056000"
                    },
                    {
                        "id": 71136,
                        "name": "Julián Blanco (Dos Caminos)",
                        "latitude": "17.21889000",
                        "longitude": "-99.52472000"
                    },
                    {
                        "id": 71157,
                        "name": "Kilómetro 30",
                        "latitude": "16.99778000",
                        "longitude": "-99.78000000"
                    },
                    {
                        "id": 71158,
                        "name": "Kilómetro 40",
                        "latitude": "17.04944000",
                        "longitude": "-99.77056000"
                    },
                    {
                        "id": 71179,
                        "name": "La Azozuca",
                        "latitude": "16.82139000",
                        "longitude": "-99.04194000"
                    },
                    {
                        "id": 71228,
                        "name": "La Concepción",
                        "latitude": "16.87867000",
                        "longitude": "-99.65140000"
                    },
                    {
                        "id": 71234,
                        "name": "La Concepción (La Concha)",
                        "latitude": "18.76778000",
                        "longitude": "-99.69250000"
                    },
                    {
                        "id": 71243,
                        "name": "La Concordia",
                        "latitude": "16.90583000",
                        "longitude": "-98.97583000"
                    },
                    {
                        "id": 71260,
                        "name": "La Dicha",
                        "latitude": "16.76720000",
                        "longitude": "-99.01058000"
                    },
                    {
                        "id": 71269,
                        "name": "La Esperanza",
                        "latitude": "17.76022000",
                        "longitude": "-99.24726000"
                    },
                    {
                        "id": 71280,
                        "name": "La Estación",
                        "latitude": "16.76734000",
                        "longitude": "-99.66716000"
                    },
                    {
                        "id": 71310,
                        "name": "La Guadalupe",
                        "latitude": "16.68883000",
                        "longitude": "-98.26222000"
                    },
                    {
                        "id": 71378,
                        "name": "La Luz de Juárez",
                        "latitude": "17.53500000",
                        "longitude": "-98.34833000"
                    },
                    {
                        "id": 71400,
                        "name": "La Mohonera",
                        "latitude": "17.63839000",
                        "longitude": "-99.20222000"
                    },
                    {
                        "id": 71418,
                        "name": "La Palma",
                        "latitude": "17.08148000",
                        "longitude": "-99.50994000"
                    },
                    {
                        "id": 71492,
                        "name": "La Soledad",
                        "latitude": "16.92000000",
                        "longitude": "-98.16694000"
                    },
                    {
                        "id": 71522,
                        "name": "La Unión",
                        "latitude": "17.98561000",
                        "longitude": "-101.80655000"
                    },
                    {
                        "id": 71563,
                        "name": "Lagunillas",
                        "latitude": "17.82438000",
                        "longitude": "-101.71074000"
                    },
                    {
                        "id": 71655,
                        "name": "Las Ánimas",
                        "latitude": "16.97284000",
                        "longitude": "-99.31964000"
                    },
                    {
                        "id": 71591,
                        "name": "Las Compuertas",
                        "latitude": "17.19559000",
                        "longitude": "-100.00840000"
                    },
                    {
                        "id": 71593,
                        "name": "Las Cruces",
                        "latitude": "16.97304000",
                        "longitude": "-99.44515000"
                    },
                    {
                        "id": 71613,
                        "name": "Las Lomas",
                        "latitude": "16.98194000",
                        "longitude": "-100.09500000"
                    },
                    {
                        "id": 71622,
                        "name": "Las Mesas",
                        "latitude": "17.00794000",
                        "longitude": "-99.45786000"
                    },
                    {
                        "id": 71634,
                        "name": "Las Plazuelas",
                        "latitude": "16.87417000",
                        "longitude": "-99.78556000"
                    },
                    {
                        "id": 71647,
                        "name": "Las Tunas",
                        "latitude": "17.11972000",
                        "longitude": "-100.48311000"
                    },
                    {
                        "id": 71652,
                        "name": "Las Vigas",
                        "latitude": "16.76144000",
                        "longitude": "-99.22942000"
                    },
                    {
                        "id": 71694,
                        "name": "Llano de la Puerta",
                        "latitude": "16.74355000",
                        "longitude": "-99.52721000"
                    },
                    {
                        "id": 71683,
                        "name": "Llano Grande",
                        "latitude": "16.94010000",
                        "longitude": "-99.43353000"
                    },
                    {
                        "id": 71706,
                        "name": "Lodo Grande",
                        "latitude": "17.60972000",
                        "longitude": "-99.21194000"
                    },
                    {
                        "id": 71746,
                        "name": "Lomas de Chapultepec",
                        "latitude": "16.71615000",
                        "longitude": "-99.61021000"
                    },
                    {
                        "id": 71749,
                        "name": "Lomas de San Juan",
                        "latitude": "16.98468000",
                        "longitude": "-99.80384000"
                    },
                    {
                        "id": 71764,
                        "name": "Los Achotes",
                        "latitude": "17.60056000",
                        "longitude": "-101.41750000"
                    },
                    {
                        "id": 71767,
                        "name": "Los Almendros",
                        "latitude": "17.61167000",
                        "longitude": "-101.43917000"
                    },
                    {
                        "id": 71811,
                        "name": "Los Liros",
                        "latitude": "16.73972000",
                        "longitude": "-98.21722000"
                    },
                    {
                        "id": 71817,
                        "name": "Los Mogotes",
                        "latitude": "16.94170000",
                        "longitude": "-100.07653000"
                    },
                    {
                        "id": 71874,
                        "name": "Los Órganos de San Agustín",
                        "latitude": "16.93488000",
                        "longitude": "-99.82329000"
                    },
                    {
                        "id": 71858,
                        "name": "Los Sauces",
                        "latitude": "18.26656000",
                        "longitude": "-99.83502000"
                    },
                    {
                        "id": 71860,
                        "name": "Los Saucitos",
                        "latitude": "16.98549000",
                        "longitude": "-99.29998000"
                    },
                    {
                        "id": 71863,
                        "name": "Los Tepetates",
                        "latitude": "17.05893000",
                        "longitude": "-99.24728000"
                    },
                    {
                        "id": 71946,
                        "name": "Malinaltepec",
                        "latitude": "17.17825000",
                        "longitude": "-98.70573000"
                    },
                    {
                        "id": 71997,
                        "name": "Marquelia",
                        "latitude": "16.58335000",
                        "longitude": "-98.81686000"
                    },
                    {
                        "id": 72027,
                        "name": "Maxela",
                        "latitude": "18.05364000",
                        "longitude": "-99.59473000"
                    },
                    {
                        "id": 72031,
                        "name": "Mayanalán",
                        "latitude": "18.17290000",
                        "longitude": "-99.43259000"
                    },
                    {
                        "id": 72046,
                        "name": "Mazatlán",
                        "latitude": "17.43620000",
                        "longitude": "-99.46483000"
                    },
                    {
                        "id": 72071,
                        "name": "Melchor Ocampo",
                        "latitude": "17.35895000",
                        "longitude": "-98.44754000"
                    },
                    {
                        "id": 72094,
                        "name": "Metlapa",
                        "latitude": "18.31019000",
                        "longitude": "-99.60910000"
                    },
                    {
                        "id": 72095,
                        "name": "Metlatónoc",
                        "latitude": "17.12361000",
                        "longitude": "-98.55806000"
                    },
                    {
                        "id": 72105,
                        "name": "Mezcala",
                        "latitude": "17.93240000",
                        "longitude": "-99.60257000"
                    },
                    {
                        "id": 72173,
                        "name": "Mochitlán",
                        "latitude": "17.38348000",
                        "longitude": "-99.36727000"
                    },
                    {
                        "id": 72179,
                        "name": "Mohoneras",
                        "latitude": "17.23500000",
                        "longitude": "-99.51611000"
                    },
                    {
                        "id": 72211,
                        "name": "Montecillos",
                        "latitude": "16.39106000",
                        "longitude": "-98.49818000"
                    },
                    {
                        "id": 72227,
                        "name": "Morelita",
                        "latitude": "18.27025000",
                        "longitude": "-100.56403000"
                    },
                    {
                        "id": 72248,
                        "name": "Moyotepec (Moyotepec de Juárez)",
                        "latitude": "17.33167000",
                        "longitude": "-98.68556000"
                    },
                    {
                        "id": 72308,
                        "name": "Nejapa",
                        "latitude": "17.61389000",
                        "longitude": "-99.14500000"
                    },
                    {
                        "id": 72365,
                        "name": "Nueva Frontera",
                        "latitude": "16.88806000",
                        "longitude": "-99.81583000"
                    },
                    {
                        "id": 72379,
                        "name": "Nuevo Balsas",
                        "latitude": "18.03253000",
                        "longitude": "-99.75913000"
                    },
                    {
                        "id": 72386,
                        "name": "Nuevo Guerrero",
                        "latitude": "18.22583000",
                        "longitude": "-100.52583000"
                    },
                    {
                        "id": 72428,
                        "name": "Nuxco",
                        "latitude": "17.20954000",
                        "longitude": "-100.75622000"
                    },
                    {
                        "id": 72454,
                        "name": "Ocotequila",
                        "latitude": "17.44944000",
                        "longitude": "-98.67750000"
                    },
                    {
                        "id": 72455,
                        "name": "Ocotillo",
                        "latitude": "17.03551000",
                        "longitude": "-99.87671000"
                    },
                    {
                        "id": 72458,
                        "name": "Ocotlán",
                        "latitude": "16.93947000",
                        "longitude": "-99.36919000"
                    },
                    {
                        "id": 72500,
                        "name": "Olinalá",
                        "latitude": "17.86441000",
                        "longitude": "-98.75153000"
                    },
                    {
                        "id": 72506,
                        "name": "Ometepec",
                        "latitude": "16.68044000",
                        "longitude": "-98.38266000"
                    },
                    {
                        "id": 72555,
                        "name": "Oxtotitlán",
                        "latitude": "18.19004000",
                        "longitude": "-99.93248000"
                    },
                    {
                        "id": 72558,
                        "name": "Oztotitlán",
                        "latitude": "17.67232000",
                        "longitude": "-99.02464000"
                    },
                    {
                        "id": 72577,
                        "name": "Paintla",
                        "latitude": "18.50333000",
                        "longitude": "-99.65528000"
                    },
                    {
                        "id": 72596,
                        "name": "Palmillas",
                        "latitude": "18.52202000",
                        "longitude": "-99.42563000"
                    },
                    {
                        "id": 72607,
                        "name": "Palo Blanco",
                        "latitude": "17.40355000",
                        "longitude": "-99.46622000"
                    },
                    {
                        "id": 72616,
                        "name": "Palos Blancos",
                        "latitude": "17.55851000",
                        "longitude": "-101.33180000"
                    },
                    {
                        "id": 72628,
                        "name": "Pantitlán",
                        "latitude": "17.63972000",
                        "longitude": "-99.10972000"
                    },
                    {
                        "id": 72629,
                        "name": "Pantla",
                        "latitude": "17.73861000",
                        "longitude": "-101.63639000"
                    },
                    {
                        "id": 72635,
                        "name": "Papanoa",
                        "latitude": "17.32551000",
                        "longitude": "-101.04166000"
                    },
                    {
                        "id": 72644,
                        "name": "Paraje Montero (Paraje Montero de Zaragoza)",
                        "latitude": "17.16349000",
                        "longitude": "-98.70394000"
                    },
                    {
                        "id": 72667,
                        "name": "Pascala del Oro",
                        "latitude": "17.05472000",
                        "longitude": "-98.80972000"
                    },
                    {
                        "id": 72686,
                        "name": "Paso de Arena",
                        "latitude": "18.30333000",
                        "longitude": "-100.84639000"
                    },
                    {
                        "id": 72681,
                        "name": "Paso Morelos",
                        "latitude": "18.22123000",
                        "longitude": "-99.20984000"
                    },
                    {
                        "id": 72705,
                        "name": "Patambó",
                        "latitude": "18.22377000",
                        "longitude": "-100.87390000"
                    },
                    {
                        "id": 72708,
                        "name": "Patlicha",
                        "latitude": "17.43944000",
                        "longitude": "-98.72167000"
                    },
                    {
                        "id": 72741,
                        "name": "Petacalco",
                        "latitude": "17.98167000",
                        "longitude": "-102.10841000"
                    },
                    {
                        "id": 72743,
                        "name": "Petaquillas",
                        "latitude": "17.48636000",
                        "longitude": "-99.45633000"
                    },
                    {
                        "id": 72744,
                        "name": "Petatlán",
                        "latitude": "17.53768000",
                        "longitude": "-101.26798000"
                    },
                    {
                        "id": 72775,
                        "name": "Pilcaya",
                        "latitude": "18.71128000",
                        "longitude": "-99.62655000"
                    },
                    {
                        "id": 72793,
                        "name": "Placeres del Oro",
                        "latitude": "18.23578000",
                        "longitude": "-100.90200000"
                    },
                    {
                        "id": 72806,
                        "name": "Platanillo",
                        "latitude": "17.06478000",
                        "longitude": "-99.91088000"
                    },
                    {
                        "id": 72831,
                        "name": "Pochahuizco",
                        "latitude": "17.66472000",
                        "longitude": "-99.22278000"
                    },
                    {
                        "id": 72832,
                        "name": "Pochotillo",
                        "latitude": "17.02075000",
                        "longitude": "-99.42725000"
                    },
                    {
                        "id": 72833,
                        "name": "Pochutla",
                        "latitude": "17.65907000",
                        "longitude": "-98.89798000"
                    },
                    {
                        "id": 72837,
                        "name": "Pololcingo",
                        "latitude": "18.28105000",
                        "longitude": "-99.39254000"
                    },
                    {
                        "id": 72932,
                        "name": "Pueblo Hidalgo",
                        "latitude": "16.95210000",
                        "longitude": "-98.65596000"
                    },
                    {
                        "id": 72934,
                        "name": "Pueblo Madero (El Playón)",
                        "latitude": "17.12611000",
                        "longitude": "-99.67250000"
                    },
                    {
                        "id": 72949,
                        "name": "Pueblo Viejo",
                        "latitude": "17.09774000",
                        "longitude": "-99.98811000"
                    },
                    {
                        "id": 72985,
                        "name": "Pungarabato",
                        "latitude": "18.34938000",
                        "longitude": "-100.63890000"
                    },
                    {
                        "id": 73019,
                        "name": "Quechultenango",
                        "latitude": "17.41425000",
                        "longitude": "-99.24221000"
                    },
                    {
                        "id": 73021,
                        "name": "Querendas",
                        "latitude": "18.34250000",
                        "longitude": "-100.63444000"
                    },
                    {
                        "id": 73028,
                        "name": "Quetzalapa",
                        "latitude": "16.78551000",
                        "longitude": "-98.50272000"
                    },
                    {
                        "id": 73079,
                        "name": "Rancho de las Lomas",
                        "latitude": "17.73972000",
                        "longitude": "-99.24583000"
                    },
                    {
                        "id": 73076,
                        "name": "Rancho Viejo",
                        "latitude": "16.86500000",
                        "longitude": "-99.28944000"
                    },
                    {
                        "id": 73077,
                        "name": "Rancho Viejo (Rancho Nuevo de la Democracia)",
                        "latitude": "17.03257000",
                        "longitude": "-98.22389000"
                    },
                    {
                        "id": 73193,
                        "name": "Sabanillas",
                        "latitude": "17.00038000",
                        "longitude": "-99.70266000"
                    },
                    {
                        "id": 73253,
                        "name": "San Agustín Oapan",
                        "latitude": "17.95250000",
                        "longitude": "-99.43806000"
                    },
                    {
                        "id": 73292,
                        "name": "San Andrés Playa Encantada (El Podrido)",
                        "latitude": "16.69222000",
                        "longitude": "-99.63389000"
                    },
                    {
                        "id": 74511,
                        "name": "San Ángel",
                        "latitude": "17.48193000",
                        "longitude": "-99.16558000"
                    },
                    {
                        "id": 73330,
                        "name": "San Antonio Coyahuacán",
                        "latitude": "17.86194000",
                        "longitude": "-98.68000000"
                    },
                    {
                        "id": 73372,
                        "name": "San Antonio de las Huertas",
                        "latitude": "18.28151000",
                        "longitude": "-100.51828000"
                    },
                    {
                        "id": 73471,
                        "name": "San Cristóbal",
                        "latitude": "16.82221000",
                        "longitude": "-98.40283000"
                    },
                    {
                        "id": 73540,
                        "name": "San Francisco",
                        "latitude": "17.00583000",
                        "longitude": "-99.28306000"
                    },
                    {
                        "id": 73584,
                        "name": "San Francisco Oxtutla",
                        "latitude": "17.96172000",
                        "longitude": "-98.98495000"
                    },
                    {
                        "id": 73586,
                        "name": "San Francisco Ozomatlán",
                        "latitude": "17.92537000",
                        "longitude": "-99.33902000"
                    },
                    {
                        "id": 73639,
                        "name": "San Gregorio",
                        "latitude": "18.62967000",
                        "longitude": "-99.59386000"
                    },
                    {
                        "id": 73678,
                        "name": "San Isidro Gallinero (El Gallinero)",
                        "latitude": "16.88139000",
                        "longitude": "-99.71417000"
                    },
                    {
                        "id": 73698,
                        "name": "San Jeronimito",
                        "latitude": "17.56818000",
                        "longitude": "-101.34562000"
                    },
                    {
                        "id": 73725,
                        "name": "San Jerónimo de Juárez",
                        "latitude": "17.13915000",
                        "longitude": "-100.47067000"
                    },
                    {
                        "id": 73727,
                        "name": "San Jerónimo el Grande",
                        "latitude": "18.21167000",
                        "longitude": "-100.50179000"
                    },
                    {
                        "id": 73771,
                        "name": "San José Ixtapa (Barrio Viejo)",
                        "latitude": "17.70222000",
                        "longitude": "-101.61944000"
                    },
                    {
                        "id": 73854,
                        "name": "San José la Hacienda",
                        "latitude": "16.97944000",
                        "longitude": "-99.06667000"
                    },
                    {
                        "id": 73781,
                        "name": "San José Poliutla",
                        "latitude": "18.27310000",
                        "longitude": "-100.39070000"
                    },
                    {
                        "id": 73960,
                        "name": "San Juan de Dios (Naranjas de Dios)",
                        "latitude": "18.54972000",
                        "longitude": "-99.55583000"
                    },
                    {
                        "id": 73945,
                        "name": "San Juan Totolcintla",
                        "latitude": "17.90667000",
                        "longitude": "-99.32694000"
                    },
                    {
                        "id": 73990,
                        "name": "San Lorenzo",
                        "latitude": "18.27352000",
                        "longitude": "-100.61122000"
                    },
                    {
                        "id": 74043,
                        "name": "San Luis Acatlán",
                        "latitude": "16.80901000",
                        "longitude": "-98.73331000"
                    },
                    {
                        "id": 74057,
                        "name": "San Luis de La Loma",
                        "latitude": "17.27000000",
                        "longitude": "-100.89369000"
                    },
                    {
                        "id": 74053,
                        "name": "San Luis San Pedro",
                        "latitude": "17.26514000",
                        "longitude": "-100.88093000"
                    },
                    {
                        "id": 74063,
                        "name": "San Marcos",
                        "latitude": "16.79772000",
                        "longitude": "-99.38921000"
                    },
                    {
                        "id": 74085,
                        "name": "San Martín",
                        "latitude": "17.46311000",
                        "longitude": "-99.29436000"
                    },
                    {
                        "id": 74103,
                        "name": "San Martín Pachivia (Pachivia)",
                        "latitude": "18.40855000",
                        "longitude": "-99.78759000"
                    },
                    {
                        "id": 74104,
                        "name": "San Martín Peras",
                        "latitude": "17.35919000",
                        "longitude": "-98.23718000"
                    },
                    {
                        "id": 74167,
                        "name": "San Miguel Axoxuca",
                        "latitude": "17.54930000",
                        "longitude": "-98.66163000"
                    },
                    {
                        "id": 74232,
                        "name": "San Miguel de las Palmas",
                        "latitude": "18.25203000",
                        "longitude": "-99.20081000"
                    },
                    {
                        "id": 74239,
                        "name": "San Miguel el Grande",
                        "latitude": "17.24533000",
                        "longitude": "-98.23553000"
                    },
                    {
                        "id": 74201,
                        "name": "San Miguel Tecuiciapan",
                        "latitude": "17.96218000",
                        "longitude": "-99.41518000"
                    },
                    {
                        "id": 74218,
                        "name": "San Miguel Totolapan",
                        "latitude": "18.16132000",
                        "longitude": "-100.39049000"
                    },
                    {
                        "id": 74244,
                        "name": "San Miguelito",
                        "latitude": "17.63583000",
                        "longitude": "-101.43750000"
                    },
                    {
                        "id": 74246,
                        "name": "San Nicolás",
                        "latitude": "16.41775000",
                        "longitude": "-98.51923000"
                    },
                    {
                        "id": 74284,
                        "name": "San Pablo Atzompa",
                        "latitude": "17.24722000",
                        "longitude": "-98.37000000"
                    },
                    {
                        "id": 74322,
                        "name": "San Pedro Cacahuatepec",
                        "latitude": "16.81500000",
                        "longitude": "-99.66833000"
                    },
                    {
                        "id": 74332,
                        "name": "San Pedro Cuitlapan",
                        "latitude": "16.97306000",
                        "longitude": "-98.25167000"
                    },
                    {
                        "id": 74341,
                        "name": "San Pedro Huitzapula Norte (Huitzapula Norte)",
                        "latitude": "17.42642000",
                        "longitude": "-98.80588000"
                    },
                    {
                        "id": 74417,
                        "name": "San Pedro las Playas",
                        "latitude": "16.82286000",
                        "longitude": "-99.73158000"
                    },
                    {
                        "id": 74429,
                        "name": "San Rafael",
                        "latitude": "17.22667000",
                        "longitude": "-98.42417000"
                    },
                    {
                        "id": 74491,
                        "name": "San Vicente",
                        "latitude": "17.51426000",
                        "longitude": "-99.68377000"
                    },
                    {
                        "id": 74503,
                        "name": "San Vicente Palapa",
                        "latitude": "18.32430000",
                        "longitude": "-99.41104000"
                    },
                    {
                        "id": 74506,
                        "name": "San Vicente Zoyatlán",
                        "latitude": "17.32250000",
                        "longitude": "-98.36417000"
                    },
                    {
                        "id": 74559,
                        "name": "Santa Anita",
                        "latitude": "17.42583000",
                        "longitude": "-98.71889000"
                    },
                    {
                        "id": 74567,
                        "name": "Santa Bárbara",
                        "latitude": "18.33082000",
                        "longitude": "-100.63991000"
                    },
                    {
                        "id": 74575,
                        "name": "Santa Catarina",
                        "latitude": "17.54835000",
                        "longitude": "-99.17500000"
                    },
                    {
                        "id": 74607,
                        "name": "Santa Cruz",
                        "latitude": "17.53310000",
                        "longitude": "-98.40269000"
                    },
                    {
                        "id": 74646,
                        "name": "Santa Cruz Yucucani",
                        "latitude": "17.07650000",
                        "longitude": "-98.11298000"
                    },
                    {
                        "id": 74658,
                        "name": "Santa Fe Tepetlapa",
                        "latitude": "18.54915000",
                        "longitude": "-99.42467000"
                    },
                    {
                        "id": 74703,
                        "name": "Santa María",
                        "latitude": "16.77012000",
                        "longitude": "-98.39105000"
                    },
                    {
                        "id": 74858,
                        "name": "Santa Teresa",
                        "latitude": "18.22966000",
                        "longitude": "-99.50697000"
                    },
                    {
                        "id": 74958,
                        "name": "Santiago Tilapa",
                        "latitude": "17.25889000",
                        "longitude": "-98.26107000"
                    },
                    {
                        "id": 75087,
                        "name": "Sinahua",
                        "latitude": "18.28111000",
                        "longitude": "-100.60028000"
                    },
                    {
                        "id": 75210,
                        "name": "Tanganhuato",
                        "latitude": "18.28608000",
                        "longitude": "-100.61178000"
                    },
                    {
                        "id": 75246,
                        "name": "Taxco el Viejo",
                        "latitude": "18.48342000",
                        "longitude": "-99.58420000"
                    },
                    {
                        "id": 75261,
                        "name": "Tecalpulco",
                        "latitude": "18.48808000",
                        "longitude": "-99.60282000"
                    },
                    {
                        "id": 75275,
                        "name": "Tecolcuautla",
                        "latitude": "17.78650000",
                        "longitude": "-98.94828000"
                    },
                    {
                        "id": 75855,
                        "name": "Técpan de Galeana",
                        "latitude": "17.21976000",
                        "longitude": "-100.63032000"
                    },
                    {
                        "id": 75293,
                        "name": "Tecuexcontitlán (Tecoescontitlán)",
                        "latitude": "18.14254000",
                        "longitude": "-99.57787000"
                    },
                    {
                        "id": 75298,
                        "name": "Tehuilotepec",
                        "latitude": "18.55167000",
                        "longitude": "-99.58111000"
                    },
                    {
                        "id": 75302,
                        "name": "Tehuixtla",
                        "latitude": "18.31680000",
                        "longitude": "-99.93300000"
                    },
                    {
                        "id": 75320,
                        "name": "Teloloapan",
                        "latitude": "18.35802000",
                        "longitude": "-99.93621000"
                    },
                    {
                        "id": 75364,
                        "name": "Tenexpa",
                        "latitude": "17.18486000",
                        "longitude": "-100.67088000"
                    },
                    {
                        "id": 75405,
                        "name": "Tepechicotlán",
                        "latitude": "17.48317000",
                        "longitude": "-99.41549000"
                    },
                    {
                        "id": 75407,
                        "name": "Tepecoacuilco de Trujano",
                        "latitude": "18.28750000",
                        "longitude": "-99.46423000"
                    },
                    {
                        "id": 75423,
                        "name": "Tepetixtla",
                        "latitude": "17.21541000",
                        "longitude": "-100.11771000"
                    },
                    {
                        "id": 75452,
                        "name": "Tepozcuautla",
                        "latitude": "17.62222000",
                        "longitude": "-99.22778000"
                    },
                    {
                        "id": 75458,
                        "name": "Tequicuilco",
                        "latitude": "18.10387000",
                        "longitude": "-99.19812000"
                    },
                    {
                        "id": 75487,
                        "name": "Tetipac",
                        "latitude": "18.65209000",
                        "longitude": "-99.67783000"
                    },
                    {
                        "id": 75489,
                        "name": "Tetitlán",
                        "latitude": "17.15899000",
                        "longitude": "-100.63981000"
                    },
                    {
                        "id": 75500,
                        "name": "Texca",
                        "latitude": "17.01170000",
                        "longitude": "-99.82474000"
                    },
                    {
                        "id": 75549,
                        "name": "Tierra Colorada",
                        "latitude": "17.16571000",
                        "longitude": "-99.52791000"
                    },
                    {
                        "id": 75593,
                        "name": "Tixtla de Guerrero",
                        "latitude": "17.56732000",
                        "longitude": "-99.39799000"
                    },
                    {
                        "id": 75594,
                        "name": "Tixtlancingo",
                        "latitude": "17.05780000",
                        "longitude": "-99.96177000"
                    },
                    {
                        "id": 75603,
                        "name": "Tlacoachistlahuaca",
                        "latitude": "16.92618000",
                        "longitude": "-98.25896000"
                    },
                    {
                        "id": 75604,
                        "name": "Tlacoapa",
                        "latitude": "17.24642000",
                        "longitude": "-98.76947000"
                    },
                    {
                        "id": 75606,
                        "name": "Tlacoaxtla",
                        "latitude": "17.55485000",
                        "longitude": "-99.20081000"
                    },
                    {
                        "id": 75616,
                        "name": "Tlacotepec",
                        "latitude": "17.78978000",
                        "longitude": "-99.97961000"
                    },
                    {
                        "id": 75628,
                        "name": "Tlahuapa",
                        "latitude": "17.37500000",
                        "longitude": "-98.33750000"
                    },
                    {
                        "id": 75635,
                        "name": "Tlalchapa",
                        "latitude": "18.42915000",
                        "longitude": "-100.45396000"
                    },
                    {
                        "id": 75638,
                        "name": "Tlalcozotitlán",
                        "latitude": "17.88355000",
                        "longitude": "-99.13083000"
                    },
                    {
                        "id": 75641,
                        "name": "Tlalixtaquilla",
                        "latitude": "17.57674000",
                        "longitude": "-98.36727000"
                    },
                    {
                        "id": 75652,
                        "name": "Tlaltempanapa",
                        "latitude": "17.73611000",
                        "longitude": "-99.17722000"
                    },
                    {
                        "id": 75660,
                        "name": "Tlamacazapa",
                        "latitude": "18.49649000",
                        "longitude": "-99.50037000"
                    },
                    {
                        "id": 75667,
                        "name": "Tlamixtlahuacan",
                        "latitude": "17.50306000",
                        "longitude": "-99.22583000"
                    },
                    {
                        "id": 75673,
                        "name": "Tlanipatla",
                        "latitude": "17.80806000",
                        "longitude": "-99.45139000"
                    },
                    {
                        "id": 75675,
                        "name": "Tlapa de Comonfort",
                        "latitude": "17.54528000",
                        "longitude": "-98.57599000"
                    },
                    {
                        "id": 75681,
                        "name": "Tlapehuala",
                        "latitude": "18.27215000",
                        "longitude": "-100.45164000"
                    },
                    {
                        "id": 75683,
                        "name": "Tlaquiltepec",
                        "latitude": "17.73143000",
                        "longitude": "-98.54736000"
                    },
                    {
                        "id": 75689,
                        "name": "Tlatlauquitepec",
                        "latitude": "17.54825000",
                        "longitude": "-98.82711000"
                    },
                    {
                        "id": 75691,
                        "name": "Tlatzala",
                        "latitude": "17.61498000",
                        "longitude": "-98.54970000"
                    },
                    {
                        "id": 75696,
                        "name": "Tlaxcalixtlahuaca",
                        "latitude": "16.98179000",
                        "longitude": "-98.77843000"
                    },
                    {
                        "id": 75701,
                        "name": "Tlaxinga (Clatzinga)",
                        "latitude": "17.52106000",
                        "longitude": "-99.19331000"
                    },
                    {
                        "id": 75702,
                        "name": "Tlaxmalac",
                        "latitude": "18.36115000",
                        "longitude": "-99.41316000"
                    },
                    {
                        "id": 75739,
                        "name": "Tonalá",
                        "latitude": "16.86167000",
                        "longitude": "-99.05444000"
                    },
                    {
                        "id": 75732,
                        "name": "Tonalapa",
                        "latitude": "17.49056000",
                        "longitude": "-99.24194000"
                    },
                    {
                        "id": 75733,
                        "name": "Tonalapa del Sur",
                        "latitude": "18.09766000",
                        "longitude": "-99.55938000"
                    },
                    {
                        "id": 75745,
                        "name": "Topiltepec",
                        "latitude": "17.65037000",
                        "longitude": "-99.22252000"
                    },
                    {
                        "id": 75756,
                        "name": "Totomixtlahuaca",
                        "latitude": "17.15819000",
                        "longitude": "-98.80317000"
                    },
                    {
                        "id": 75758,
                        "name": "Tototepec",
                        "latitude": "17.43227000",
                        "longitude": "-98.58715000"
                    },
                    {
                        "id": 75776,
                        "name": "Tres Palos",
                        "latitude": "16.82959000",
                        "longitude": "-99.77813000"
                    },
                    {
                        "id": 75800,
                        "name": "Tulimán",
                        "latitude": "18.02865000",
                        "longitude": "-99.25572000"
                    },
                    {
                        "id": 75807,
                        "name": "Tuncingo",
                        "latitude": "16.85083000",
                        "longitude": "-99.78917000"
                    },
                    {
                        "id": 75818,
                        "name": "Tutepec",
                        "latitude": "16.92167000",
                        "longitude": "-99.15639000"
                    },
                    {
                        "id": 75819,
                        "name": "Tuxpan",
                        "latitude": "18.34933000",
                        "longitude": "-99.47965000"
                    },
                    {
                        "id": 75929,
                        "name": "Valle del Río",
                        "latitude": "16.97607000",
                        "longitude": "-99.93639000"
                    },
                    {
                        "id": 75916,
                        "name": "Valle Luz",
                        "latitude": "18.13071000",
                        "longitude": "-100.33983000"
                    },
                    {
                        "id": 75931,
                        "name": "Vallecitos de Zaragoza",
                        "latitude": "17.92028000",
                        "longitude": "-101.32361000"
                    },
                    {
                        "id": 76007,
                        "name": "Villa Hermosa",
                        "latitude": "16.93861000",
                        "longitude": "-99.33000000"
                    },
                    {
                        "id": 76008,
                        "name": "Villa Hermosa (Las Pozas)",
                        "latitude": "17.63361000",
                        "longitude": "-101.46639000"
                    },
                    {
                        "id": 76016,
                        "name": "Villa Hidalgo (El Cubo)",
                        "latitude": "18.16167000",
                        "longitude": "-100.31500000"
                    },
                    {
                        "id": 76031,
                        "name": "Villa Madero",
                        "latitude": "18.41120000",
                        "longitude": "-100.44857000"
                    },
                    {
                        "id": 76038,
                        "name": "Villa Nicolás Bravo",
                        "latitude": "18.21426000",
                        "longitude": "-100.54790000"
                    },
                    {
                        "id": 76042,
                        "name": "Villa Rotaria",
                        "latitude": "17.19444000",
                        "longitude": "-100.66917000"
                    },
                    {
                        "id": 76116,
                        "name": "Xalatzala",
                        "latitude": "17.47355000",
                        "longitude": "-98.57355000"
                    },
                    {
                        "id": 76117,
                        "name": "Xalitla",
                        "latitude": "17.99744000",
                        "longitude": "-99.54438000"
                    },
                    {
                        "id": 76120,
                        "name": "Xalpatlahuac",
                        "latitude": "17.47066000",
                        "longitude": "-98.60675000"
                    },
                    {
                        "id": 76124,
                        "name": "Xaltianguis",
                        "latitude": "17.09834000",
                        "longitude": "-99.71557000"
                    },
                    {
                        "id": 76155,
                        "name": "Xochapa",
                        "latitude": "17.38398000",
                        "longitude": "-98.45103000"
                    },
                    {
                        "id": 76162,
                        "name": "Xochihuehuetlán",
                        "latitude": "17.89242000",
                        "longitude": "-98.47886000"
                    },
                    {
                        "id": 76170,
                        "name": "Xochipala",
                        "latitude": "17.81180000",
                        "longitude": "-99.63977000"
                    },
                    {
                        "id": 76171,
                        "name": "Xochistlahuaca",
                        "latitude": "16.81680000",
                        "longitude": "-98.18687000"
                    },
                    {
                        "id": 76174,
                        "name": "Xochitepec",
                        "latitude": "17.18250000",
                        "longitude": "-99.22639000"
                    },
                    {
                        "id": 76187,
                        "name": "Xocoyolzintla",
                        "latitude": "17.71278000",
                        "longitude": "-98.98194000"
                    },
                    {
                        "id": 76234,
                        "name": "Yetla",
                        "latitude": "16.99355000",
                        "longitude": "-100.00328000"
                    },
                    {
                        "id": 76236,
                        "name": "Yetlancingo",
                        "latitude": "17.72130000",
                        "longitude": "-99.11538000"
                    },
                    {
                        "id": 76237,
                        "name": "Yextla",
                        "latitude": "17.60446000",
                        "longitude": "-99.93446000"
                    },
                    {
                        "id": 76242,
                        "name": "Yoloxóchitl",
                        "latitude": "16.81605000",
                        "longitude": "-98.68627000"
                    },
                    {
                        "id": 76253,
                        "name": "Zacacoyuca",
                        "latitude": "18.25029000",
                        "longitude": "-99.52763000"
                    },
                    {
                        "id": 76267,
                        "name": "Zacapuato",
                        "latitude": "18.66867000",
                        "longitude": "-100.60653000"
                    },
                    {
                        "id": 76279,
                        "name": "Zacatula",
                        "latitude": "18.00983000",
                        "longitude": "-102.17946000"
                    },
                    {
                        "id": 76281,
                        "name": "Zacoalpan",
                        "latitude": "16.74491000",
                        "longitude": "-98.28763000"
                    },
                    {
                        "id": 76286,
                        "name": "Zacualpan",
                        "latitude": "17.08895000",
                        "longitude": "-100.32590000"
                    },
                    {
                        "id": 76310,
                        "name": "Zapotitlán Tablas",
                        "latitude": "17.42417000",
                        "longitude": "-98.78056000"
                    },
                    {
                        "id": 76326,
                        "name": "Zelocotitlán",
                        "latitude": "17.44640000",
                        "longitude": "-99.10620000"
                    },
                    {
                        "id": 76335,
                        "name": "Zilacayotitlán",
                        "latitude": "17.29491000",
                        "longitude": "-98.54976000"
                    },
                    {
                        "id": 76350,
                        "name": "Zirándaro",
                        "latitude": "18.36395000",
                        "longitude": "-101.19046000"
                    },
                    {
                        "id": 76351,
                        "name": "Zirándaro de los Chávez",
                        "latitude": "18.47622000",
                        "longitude": "-100.97915000"
                    },
                    {
                        "id": 76352,
                        "name": "Zitlala",
                        "latitude": "17.71969000",
                        "longitude": "-99.19569000"
                    },
                    {
                        "id": 76354,
                        "name": "Zizicazapa",
                        "latitude": "17.51556000",
                        "longitude": "-99.15250000"
                    },
                    {
                        "id": 76366,
                        "name": "Zoquiapa",
                        "latitude": "17.54472000",
                        "longitude": "-99.27694000"
                    },
                    {
                        "id": 76372,
                        "name": "Zoquitlán",
                        "latitude": "17.34194000",
                        "longitude": "-98.94917000"
                    },
                    {
                        "id": 76375,
                        "name": "Zotoltitlán",
                        "latitude": "17.71426000",
                        "longitude": "-99.29177000"
                    },
                    {
                        "id": 76378,
                        "name": "Zoyatlán",
                        "latitude": "16.70917000",
                        "longitude": "-98.73349000"
                    },
                    {
                        "id": 76387,
                        "name": "Zumpango",
                        "latitude": "17.93521000",
                        "longitude": "-98.68304000"
                    },
                    {
                        "id": 76388,
                        "name": "Zumpango del Río",
                        "latitude": "17.65437000",
                        "longitude": "-99.52725000"
                    }
                ]
            },
            {
                "id": 3470,
                "name": "Hidalgo",
                "iso2": "HID",
                "latitude": "26.10035470",
                "longitude": "-98.26306840",
                "type": "state",
                "cities": [
                    {
                        "id": 68025,
                        "name": "Acahuasco",
                        "latitude": "20.96254000",
                        "longitude": "-98.59656000"
                    },
                    {
                        "id": 68043,
                        "name": "Acatepec",
                        "latitude": "20.95367000",
                        "longitude": "-98.27373000"
                    },
                    {
                        "id": 68047,
                        "name": "Acatlán",
                        "latitude": "20.14562000",
                        "longitude": "-98.43959000"
                    },
                    {
                        "id": 68055,
                        "name": "Acaxochitlán",
                        "latitude": "20.16674000",
                        "longitude": "-98.18971000"
                    },
                    {
                        "id": 68057,
                        "name": "Acayuca",
                        "latitude": "20.02567000",
                        "longitude": "-98.84110000"
                    },
                    {
                        "id": 68062,
                        "name": "Acoapa",
                        "latitude": "21.12116000",
                        "longitude": "-98.48701000"
                    },
                    {
                        "id": 68067,
                        "name": "Acoxcatlán",
                        "latitude": "20.97343000",
                        "longitude": "-98.77793000"
                    },
                    {
                        "id": 68068,
                        "name": "Acoyotla",
                        "latitude": "21.12551000",
                        "longitude": "-98.77729000"
                    },
                    {
                        "id": 68073,
                        "name": "Actopan",
                        "latitude": "20.28451000",
                        "longitude": "-98.91525000"
                    },
                    {
                        "id": 68148,
                        "name": "Ahuatitla",
                        "latitude": "21.16495000",
                        "longitude": "-98.66594000"
                    },
                    {
                        "id": 68154,
                        "name": "Ahuehuetitla",
                        "latitude": "20.08444000",
                        "longitude": "-98.41667000"
                    },
                    {
                        "id": 68163,
                        "name": "Ajacuba",
                        "latitude": "20.14326000",
                        "longitude": "-99.06141000"
                    },
                    {
                        "id": 68190,
                        "name": "Alfajayucan",
                        "latitude": "20.41183000",
                        "longitude": "-99.38388000"
                    },
                    {
                        "id": 68214,
                        "name": "Almoloya",
                        "latitude": "19.74335000",
                        "longitude": "-98.33939000"
                    },
                    {
                        "id": 76396,
                        "name": "Álvaro Obregón",
                        "latitude": "20.70662000",
                        "longitude": "-99.37323000"
                    },
                    {
                        "id": 68288,
                        "name": "Apan",
                        "latitude": "19.71128000",
                        "longitude": "-98.45086000"
                    },
                    {
                        "id": 68399,
                        "name": "Atengo",
                        "latitude": "20.17526000",
                        "longitude": "-99.32714000"
                    },
                    {
                        "id": 68406,
                        "name": "Atitalaquia",
                        "latitude": "20.05691000",
                        "longitude": "-99.21779000"
                    },
                    {
                        "id": 68416,
                        "name": "Atlapexco",
                        "latitude": "21.02507000",
                        "longitude": "-98.36834000"
                    },
                    {
                        "id": 68431,
                        "name": "Atotonilco de Tula",
                        "latitude": "19.97025000",
                        "longitude": "-99.23866000"
                    },
                    {
                        "id": 68432,
                        "name": "Atotonilco el Grande",
                        "latitude": "20.28632000",
                        "longitude": "-98.66850000"
                    },
                    {
                        "id": 68515,
                        "name": "Bangandhó",
                        "latitude": "20.48277000",
                        "longitude": "-99.14901000"
                    },
                    {
                        "id": 68524,
                        "name": "Barrio Aztlán",
                        "latitude": "20.46562000",
                        "longitude": "-98.08553000"
                    },
                    {
                        "id": 68590,
                        "name": "Benito Juárez",
                        "latitude": "20.16047000",
                        "longitude": "-98.82606000"
                    },
                    {
                        "id": 68632,
                        "name": "Bomanxotha",
                        "latitude": "20.51542000",
                        "longitude": "-99.66679000"
                    },
                    {
                        "id": 68633,
                        "name": "Bomintzha",
                        "latitude": "20.01400000",
                        "longitude": "-99.27277000"
                    },
                    {
                        "id": 68634,
                        "name": "Bondojito",
                        "latitude": "20.44395000",
                        "longitude": "-99.70022000"
                    },
                    {
                        "id": 68744,
                        "name": "Calnali",
                        "latitude": "20.90221000",
                        "longitude": "-98.57029000"
                    },
                    {
                        "id": 68748,
                        "name": "Caltimacan",
                        "latitude": "20.53672000",
                        "longitude": "-99.37000000"
                    },
                    {
                        "id": 68761,
                        "name": "Camelia (Barrio la Camelia)",
                        "latitude": "20.14917000",
                        "longitude": "-98.72222000"
                    },
                    {
                        "id": 68773,
                        "name": "Campestre Villas del Álamo",
                        "latitude": "20.10167000",
                        "longitude": "-98.70722000"
                    },
                    {
                        "id": 68873,
                        "name": "Cañada",
                        "latitude": "19.99798000",
                        "longitude": "-99.23947000"
                    },
                    {
                        "id": 68878,
                        "name": "Cañada de Madero",
                        "latitude": "19.96528000",
                        "longitude": "-99.39389000"
                    },
                    {
                        "id": 68795,
                        "name": "Cantera de Villagrán",
                        "latitude": "19.84083000",
                        "longitude": "-99.30917000"
                    },
                    {
                        "id": 68796,
                        "name": "Cantinela",
                        "latitude": "20.45778000",
                        "longitude": "-99.21028000"
                    },
                    {
                        "id": 68819,
                        "name": "Carboneras",
                        "latitude": "20.09000000",
                        "longitude": "-98.70528000"
                    },
                    {
                        "id": 68821,
                        "name": "Cardonal",
                        "latitude": "20.05689000",
                        "longitude": "-99.23025000"
                    },
                    {
                        "id": 68832,
                        "name": "Carpinteros",
                        "latitude": "20.58606000",
                        "longitude": "-98.53964000"
                    },
                    {
                        "id": 68870,
                        "name": "Caxuxi",
                        "latitude": "20.30522000",
                        "longitude": "-98.99067000"
                    },
                    {
                        "id": 68917,
                        "name": "Cerritos",
                        "latitude": "20.35306000",
                        "longitude": "-99.01222000"
                    },
                    {
                        "id": 68948,
                        "name": "Chachahuantla",
                        "latitude": "20.20182000",
                        "longitude": "-98.13261000"
                    },
                    {
                        "id": 68954,
                        "name": "Chalahuiyapa",
                        "latitude": "21.15088000",
                        "longitude": "-98.36429000"
                    },
                    {
                        "id": 68981,
                        "name": "Chapantongo",
                        "latitude": "20.28635000",
                        "longitude": "-99.41319000"
                    },
                    {
                        "id": 68988,
                        "name": "Chapulhuacán",
                        "latitude": "21.15731000",
                        "longitude": "-98.90361000"
                    },
                    {
                        "id": 68987,
                        "name": "Chapulhuacanito",
                        "latitude": "21.20911000",
                        "longitude": "-98.67016000"
                    },
                    {
                        "id": 68999,
                        "name": "Chatipán",
                        "latitude": "21.02006000",
                        "longitude": "-98.52731000"
                    },
                    {
                        "id": 69018,
                        "name": "Chicavasco",
                        "latitude": "20.19715000",
                        "longitude": "-98.95386000"
                    },
                    {
                        "id": 69020,
                        "name": "Chichatla",
                        "latitude": "20.95833000",
                        "longitude": "-98.62946000"
                    },
                    {
                        "id": 69069,
                        "name": "Chilcuautla",
                        "latitude": "20.33059000",
                        "longitude": "-99.23117000"
                    },
                    {
                        "id": 69070,
                        "name": "Chililico",
                        "latitude": "21.13444000",
                        "longitude": "-98.43556000"
                    },
                    {
                        "id": 69076,
                        "name": "Chimalapa",
                        "latitude": "20.18806000",
                        "longitude": "-98.16000000"
                    },
                    {
                        "id": 69078,
                        "name": "Chimalpa y Tlalayote",
                        "latitude": "19.66522000",
                        "longitude": "-98.51224000"
                    },
                    {
                        "id": 69138,
                        "name": "Cipreses",
                        "latitude": "20.05889000",
                        "longitude": "-98.76750000"
                    },
                    {
                        "id": 69178,
                        "name": "Ciudad Sahagun",
                        "latitude": "19.77557000",
                        "longitude": "-98.57471000"
                    },
                    {
                        "id": 69211,
                        "name": "Coacuilco",
                        "latitude": "21.10377000",
                        "longitude": "-98.58643000"
                    },
                    {
                        "id": 69257,
                        "name": "Colinas de Plata",
                        "latitude": "20.07833000",
                        "longitude": "-98.72667000"
                    },
                    {
                        "id": 69267,
                        "name": "Colonia 28 de Mayo (Santa Rosa)",
                        "latitude": "20.16611000",
                        "longitude": "-98.39000000"
                    },
                    {
                        "id": 69285,
                        "name": "Colonia Benito Juárez",
                        "latitude": "19.88985000",
                        "longitude": "-98.80661000"
                    },
                    {
                        "id": 69301,
                        "name": "Colonia Felipe Ángeles",
                        "latitude": "20.05417000",
                        "longitude": "-98.41861000"
                    },
                    {
                        "id": 69305,
                        "name": "Colonia Guadalupe",
                        "latitude": "19.93917000",
                        "longitude": "-98.76556000"
                    },
                    {
                        "id": 69330,
                        "name": "Colonia Militar",
                        "latitude": "20.11139000",
                        "longitude": "-98.70306000"
                    },
                    {
                        "id": 69334,
                        "name": "Colonia Morelos",
                        "latitude": "19.89056000",
                        "longitude": "-98.81667000"
                    },
                    {
                        "id": 69335,
                        "name": "Colonia Morelos (El Nueve)",
                        "latitude": "20.22500000",
                        "longitude": "-99.14111000"
                    },
                    {
                        "id": 69365,
                        "name": "Colonia San Juan",
                        "latitude": "20.19028000",
                        "longitude": "-99.28278000"
                    },
                    {
                        "id": 69370,
                        "name": "Colonia Sesenta y Dos",
                        "latitude": "20.00528000",
                        "longitude": "-99.34583000"
                    },
                    {
                        "id": 69372,
                        "name": "Colonia Teñhe",
                        "latitude": "20.19291000",
                        "longitude": "-99.17866000"
                    },
                    {
                        "id": 69449,
                        "name": "Conejos",
                        "latitude": "19.97570000",
                        "longitude": "-99.24337000"
                    },
                    {
                        "id": 69523,
                        "name": "Coyotillos",
                        "latitude": "19.99980000",
                        "longitude": "-99.15817000"
                    },
                    {
                        "id": 69560,
                        "name": "Cuapaxtitla",
                        "latitude": "21.13292000",
                        "longitude": "-98.55264000"
                    },
                    {
                        "id": 69567,
                        "name": "Cuatolol",
                        "latitude": "21.11967000",
                        "longitude": "-98.82563000"
                    },
                    {
                        "id": 69588,
                        "name": "Cuautepec de Hinojosa",
                        "latitude": "20.03557000",
                        "longitude": "-98.31015000"
                    },
                    {
                        "id": 69601,
                        "name": "Cuazahuatl",
                        "latitude": "21.01637000",
                        "longitude": "-98.88691000"
                    },
                    {
                        "id": 69664,
                        "name": "Dajiedi",
                        "latitude": "20.31114000",
                        "longitude": "-98.94006000"
                    },
                    {
                        "id": 69667,
                        "name": "Dantzibojay",
                        "latitude": "20.43934000",
                        "longitude": "-99.58587000"
                    },
                    {
                        "id": 69669,
                        "name": "Daxtha",
                        "latitude": "20.27994000",
                        "longitude": "-98.97964000"
                    },
                    {
                        "id": 69678,
                        "name": "Dengantzha",
                        "latitude": "20.27211000",
                        "longitude": "-99.12098000"
                    },
                    {
                        "id": 69751,
                        "name": "Déxtho de Victoria",
                        "latitude": "20.32528000",
                        "longitude": "-99.02389000"
                    },
                    {
                        "id": 69687,
                        "name": "Dios Padre",
                        "latitude": "20.46469000",
                        "longitude": "-99.20132000"
                    },
                    {
                        "id": 69709,
                        "name": "Don Antonio",
                        "latitude": "19.87444000",
                        "longitude": "-98.93472000"
                    },
                    {
                        "id": 69724,
                        "name": "Doxey",
                        "latitude": "20.09169000",
                        "longitude": "-99.24362000"
                    },
                    {
                        "id": 69833,
                        "name": "El Arenal",
                        "latitude": "20.22258000",
                        "longitude": "-98.90957000"
                    },
                    {
                        "id": 69840,
                        "name": "El Barrido",
                        "latitude": "20.45028000",
                        "longitude": "-99.19083000"
                    },
                    {
                        "id": 69845,
                        "name": "El Bingú",
                        "latitude": "20.59296000",
                        "longitude": "-99.14315000"
                    },
                    {
                        "id": 69850,
                        "name": "El Boxtha",
                        "latitude": "20.25972000",
                        "longitude": "-98.97417000"
                    },
                    {
                        "id": 69863,
                        "name": "El Capulín",
                        "latitude": "20.00898000",
                        "longitude": "-98.27613000"
                    },
                    {
                        "id": 69904,
                        "name": "El Cid",
                        "latitude": "19.86722000",
                        "longitude": "-98.92694000"
                    },
                    {
                        "id": 69913,
                        "name": "El Colorado",
                        "latitude": "20.21528000",
                        "longitude": "-99.00222000"
                    },
                    {
                        "id": 69987,
                        "name": "El Huaxtho",
                        "latitude": "20.23444000",
                        "longitude": "-98.96222000"
                    },
                    {
                        "id": 69991,
                        "name": "El Huixmí",
                        "latitude": "20.07569000",
                        "longitude": "-98.81972000"
                    },
                    {
                        "id": 69998,
                        "name": "El Jagüey",
                        "latitude": "20.24691000",
                        "longitude": "-99.61516000"
                    },
                    {
                        "id": 70003,
                        "name": "El Jiadi",
                        "latitude": "20.24842000",
                        "longitude": "-98.92815000"
                    },
                    {
                        "id": 70021,
                        "name": "El Llano",
                        "latitude": "20.06537000",
                        "longitude": "-99.31976000"
                    },
                    {
                        "id": 70040,
                        "name": "El Mirador",
                        "latitude": "20.03000000",
                        "longitude": "-98.81056000"
                    },
                    {
                        "id": 70050,
                        "name": "El Moreno (San Miguel Moreno)",
                        "latitude": "20.30139000",
                        "longitude": "-99.17361000"
                    },
                    {
                        "id": 70065,
                        "name": "El Nith",
                        "latitude": "20.48778000",
                        "longitude": "-99.19194000"
                    },
                    {
                        "id": 70072,
                        "name": "El Olvera",
                        "latitude": "20.27000000",
                        "longitude": "-99.02556000"
                    },
                    {
                        "id": 70094,
                        "name": "El Paredón",
                        "latitude": "19.86686000",
                        "longitude": "-98.25224000"
                    },
                    {
                        "id": 70106,
                        "name": "El Pintor",
                        "latitude": "21.15932000",
                        "longitude": "-98.41284000"
                    },
                    {
                        "id": 70150,
                        "name": "El Refugio",
                        "latitude": "20.00480000",
                        "longitude": "-99.18835000"
                    },
                    {
                        "id": 70160,
                        "name": "El Rincón",
                        "latitude": "20.27334000",
                        "longitude": "-98.90431000"
                    },
                    {
                        "id": 70167,
                        "name": "El Roble",
                        "latitude": "20.05806000",
                        "longitude": "-98.75833000"
                    },
                    {
                        "id": 70172,
                        "name": "El Rosario",
                        "latitude": "20.24842000",
                        "longitude": "-99.02539000"
                    },
                    {
                        "id": 70197,
                        "name": "El Saucillo",
                        "latitude": "20.07694000",
                        "longitude": "-98.73722000"
                    },
                    {
                        "id": 70198,
                        "name": "El Saucillo (Fraccionamiento)",
                        "latitude": "20.06778000",
                        "longitude": "-98.73194000"
                    },
                    {
                        "id": 70209,
                        "name": "El Susto",
                        "latitude": "20.05905000",
                        "longitude": "-98.49303000"
                    },
                    {
                        "id": 70219,
                        "name": "El Tepeyac",
                        "latitude": "20.05073000",
                        "longitude": "-98.31063000"
                    },
                    {
                        "id": 70220,
                        "name": "El Tephé",
                        "latitude": "20.44861000",
                        "longitude": "-99.17500000"
                    },
                    {
                        "id": 70252,
                        "name": "El Venado",
                        "latitude": "20.06291000",
                        "longitude": "-98.76018000"
                    },
                    {
                        "id": 70272,
                        "name": "Eloxochitlán",
                        "latitude": "20.72703000",
                        "longitude": "-98.87693000"
                    },
                    {
                        "id": 70278,
                        "name": "Emiliano Zapata",
                        "latitude": "19.65490000",
                        "longitude": "-98.54497000"
                    },
                    {
                        "id": 70310,
                        "name": "Epazoyucan",
                        "latitude": "20.02654000",
                        "longitude": "-98.63802000"
                    },
                    {
                        "id": 70359,
                        "name": "Estación de Apulco",
                        "latitude": "20.28611000",
                        "longitude": "-98.34750000"
                    },
                    {
                        "id": 70408,
                        "name": "Fontezuelas",
                        "latitude": "20.48853000",
                        "longitude": "-98.87164000"
                    },
                    {
                        "id": 70409,
                        "name": "Forjadores de Pachuca",
                        "latitude": "20.05500000",
                        "longitude": "-98.76333000"
                    },
                    {
                        "id": 70412,
                        "name": "Fraccionamiento Carlos Salinas de Gortari",
                        "latitude": "20.11028000",
                        "longitude": "-98.43028000"
                    },
                    {
                        "id": 70448,
                        "name": "Fraccionamiento del Magisterio Tulancinguense",
                        "latitude": "20.07639000",
                        "longitude": "-98.39972000"
                    },
                    {
                        "id": 70518,
                        "name": "Gandhó",
                        "latitude": "20.54525000",
                        "longitude": "-99.68737000"
                    },
                    {
                        "id": 70532,
                        "name": "General Felipe Ángeles (Los Ángeles)",
                        "latitude": "19.89750000",
                        "longitude": "-98.92611000"
                    },
                    {
                        "id": 70544,
                        "name": "General Pedro María Anaya",
                        "latitude": "20.15600000",
                        "longitude": "-99.34800000"
                    },
                    {
                        "id": 70587,
                        "name": "Guadalupe Minerva",
                        "latitude": "20.12583000",
                        "longitude": "-98.71389000"
                    },
                    {
                        "id": 70597,
                        "name": "Guadalupe Victoria",
                        "latitude": "20.03748000",
                        "longitude": "-98.26864000"
                    },
                    {
                        "id": 70726,
                        "name": "Hualula",
                        "latitude": "20.70877000",
                        "longitude": "-98.83688000"
                    },
                    {
                        "id": 70739,
                        "name": "Huasca de Ocampo",
                        "latitude": "20.20357000",
                        "longitude": "-98.57603000"
                    },
                    {
                        "id": 70746,
                        "name": "Huautla",
                        "latitude": "21.03105000",
                        "longitude": "-98.28685000"
                    },
                    {
                        "id": 70757,
                        "name": "Huehuetla",
                        "latitude": "20.53204000",
                        "longitude": "-98.03311000"
                    },
                    {
                        "id": 70767,
                        "name": "Huejutla de Reyes",
                        "latitude": "21.14000000",
                        "longitude": "-98.41944000"
                    },
                    {
                        "id": 70773,
                        "name": "Hueyapa",
                        "latitude": "21.08506000",
                        "longitude": "-98.68871000"
                    },
                    {
                        "id": 70788,
                        "name": "Huichapan",
                        "latitude": "20.37593000",
                        "longitude": "-99.64869000"
                    },
                    {
                        "id": 70799,
                        "name": "Huitel",
                        "latitude": "20.16707000",
                        "longitude": "-99.27860000"
                    },
                    {
                        "id": 70800,
                        "name": "Huitepec",
                        "latitude": "21.05451000",
                        "longitude": "-98.72291000"
                    },
                    {
                        "id": 70804,
                        "name": "Huitzila",
                        "latitude": "19.81137000",
                        "longitude": "-98.95583000"
                    },
                    {
                        "id": 70812,
                        "name": "Huitzitzilingo",
                        "latitude": "21.17295000",
                        "longitude": "-98.65693000"
                    },
                    {
                        "id": 70847,
                        "name": "Ignacio Zaragoza",
                        "latitude": "20.01574000",
                        "longitude": "-99.32101000"
                    },
                    {
                        "id": 70879,
                        "name": "Irolo",
                        "latitude": "19.73452000",
                        "longitude": "-98.59641000"
                    },
                    {
                        "id": 70907,
                        "name": "Ixcatlán",
                        "latitude": "21.08134000",
                        "longitude": "-98.53468000"
                    },
                    {
                        "id": 70908,
                        "name": "Ixcuinquitlapilco",
                        "latitude": "20.11091000",
                        "longitude": "-98.93980000"
                    },
                    {
                        "id": 70918,
                        "name": "Ixmiquilpan",
                        "latitude": "20.47841000",
                        "longitude": "-99.21697000"
                    },
                    {
                        "id": 70937,
                        "name": "Ixtlahuaca",
                        "latitude": "20.88368000",
                        "longitude": "-98.70379000"
                    },
                    {
                        "id": 70957,
                        "name": "Jacala",
                        "latitude": "21.00952000",
                        "longitude": "-99.19134000"
                    },
                    {
                        "id": 70961,
                        "name": "Jagüey Blanco",
                        "latitude": "20.27639000",
                        "longitude": "-99.15222000"
                    },
                    {
                        "id": 70962,
                        "name": "Jagüey de Téllez (Estación Téllez)",
                        "latitude": "19.98056000",
                        "longitude": "-98.78833000"
                    },
                    {
                        "id": 70975,
                        "name": "Jalpa",
                        "latitude": "21.10908000",
                        "longitude": "-98.71313000"
                    },
                    {
                        "id": 70986,
                        "name": "Jaltepec",
                        "latitude": "20.11552000",
                        "longitude": "-98.41712000"
                    },
                    {
                        "id": 70990,
                        "name": "Jaltocan",
                        "latitude": "21.13284000",
                        "longitude": "-98.53898000"
                    },
                    {
                        "id": 71014,
                        "name": "Javier Rojo Gómez",
                        "latitude": "20.06972000",
                        "longitude": "-98.41778000"
                    },
                    {
                        "id": 71078,
                        "name": "Jonacapa",
                        "latitude": "20.43358000",
                        "longitude": "-99.53306000"
                    },
                    {
                        "id": 71103,
                        "name": "José María Morelos (San José)",
                        "latitude": "19.68250000",
                        "longitude": "-98.57639000"
                    },
                    {
                        "id": 71110,
                        "name": "José María Pino Suárez",
                        "latitude": "20.24722000",
                        "longitude": "-99.42111000"
                    },
                    {
                        "id": 71138,
                        "name": "Julián Villagrán",
                        "latitude": "20.39645000",
                        "longitude": "-99.10431000"
                    },
                    {
                        "id": 71172,
                        "name": "La Amistad",
                        "latitude": "20.00833000",
                        "longitude": "-99.32028000"
                    },
                    {
                        "id": 71185,
                        "name": "La Boveda",
                        "latitude": "20.12496000",
                        "longitude": "-98.12468000"
                    },
                    {
                        "id": 71219,
                        "name": "La Colonia",
                        "latitude": "20.05472000",
                        "longitude": "-98.77028000"
                    },
                    {
                        "id": 71247,
                        "name": "La Cruz",
                        "latitude": "20.17603000",
                        "longitude": "-99.24156000"
                    },
                    {
                        "id": 71278,
                        "name": "La Esquina",
                        "latitude": "20.54712000",
                        "longitude": "-99.70770000"
                    },
                    {
                        "id": 71282,
                        "name": "La Estancia",
                        "latitude": "20.29889000",
                        "longitude": "-98.68944000"
                    },
                    {
                        "id": 71286,
                        "name": "La Estanzuela",
                        "latitude": "20.17828000",
                        "longitude": "-98.75703000"
                    },
                    {
                        "id": 71342,
                        "name": "La Laguna",
                        "latitude": "19.73447000",
                        "longitude": "-98.49989000"
                    },
                    {
                        "id": 71348,
                        "name": "La Lagunilla",
                        "latitude": "20.06787000",
                        "longitude": "-98.47801000"
                    },
                    {
                        "id": 71363,
                        "name": "La Loma",
                        "latitude": "20.16959000",
                        "longitude": "-99.37882000"
                    },
                    {
                        "id": 71394,
                        "name": "La Mesilla",
                        "latitude": "20.48949000",
                        "longitude": "-99.67676000"
                    },
                    {
                        "id": 71465,
                        "name": "La Providencia Siglo XXI",
                        "latitude": "20.06417000",
                        "longitude": "-98.71722000"
                    },
                    {
                        "id": 71472,
                        "name": "La Reforma",
                        "latitude": "21.07327000",
                        "longitude": "-98.87057000"
                    },
                    {
                        "id": 71482,
                        "name": "La Sabinita",
                        "latitude": "20.36286000",
                        "longitude": "-99.63423000"
                    },
                    {
                        "id": 71483,
                        "name": "La Sala (La Caliente)",
                        "latitude": "20.20722000",
                        "longitude": "-98.87250000"
                    },
                    {
                        "id": 71507,
                        "name": "La Trinidad",
                        "latitude": "19.95975000",
                        "longitude": "-98.70942000"
                    },
                    {
                        "id": 71561,
                        "name": "Lagunilla",
                        "latitude": "20.34306000",
                        "longitude": "-99.02737000"
                    },
                    {
                        "id": 71885,
                        "name": "Lázaro Cárdenas",
                        "latitude": "19.64032000",
                        "longitude": "-98.47166000"
                    },
                    {
                        "id": 71681,
                        "name": "Lindavista",
                        "latitude": "20.02611000",
                        "longitude": "-98.79778000"
                    },
                    {
                        "id": 71688,
                        "name": "Llano Largo",
                        "latitude": "20.30111000",
                        "longitude": "-99.76556000"
                    },
                    {
                        "id": 71707,
                        "name": "Lolotla",
                        "latitude": "21.00922000",
                        "longitude": "-98.73116000"
                    },
                    {
                        "id": 71790,
                        "name": "Los Cides",
                        "latitude": "19.80439000",
                        "longitude": "-98.51870000"
                    },
                    {
                        "id": 71845,
                        "name": "Los Reyes",
                        "latitude": "20.15529000",
                        "longitude": "-98.16424000"
                    },
                    {
                        "id": 71856,
                        "name": "Los Romeros",
                        "latitude": "20.02976000",
                        "longitude": "-98.41496000"
                    },
                    {
                        "id": 71857,
                        "name": "Los Sabinos",
                        "latitude": "20.31535000",
                        "longitude": "-98.64862000"
                    },
                    {
                        "id": 71866,
                        "name": "Los Tuzos",
                        "latitude": "20.05389000",
                        "longitude": "-98.75639000"
                    },
                    {
                        "id": 71905,
                        "name": "Machetla",
                        "latitude": "21.05946000",
                        "longitude": "-98.49445000"
                    },
                    {
                        "id": 71936,
                        "name": "Magisterio Digno",
                        "latitude": "20.05694000",
                        "longitude": "-98.76889000"
                    },
                    {
                        "id": 71938,
                        "name": "Maguey Blanco",
                        "latitude": "20.42357000",
                        "longitude": "-99.17032000"
                    },
                    {
                        "id": 71952,
                        "name": "Mamithi",
                        "latitude": "20.41003000",
                        "longitude": "-99.65797000"
                    },
                    {
                        "id": 71955,
                        "name": "Mangas",
                        "latitude": "20.18647000",
                        "longitude": "-99.24799000"
                    },
                    {
                        "id": 71967,
                        "name": "Manuel Ávila Camacho",
                        "latitude": "20.11194000",
                        "longitude": "-98.70694000"
                    },
                    {
                        "id": 72055,
                        "name": "Mecatlán",
                        "latitude": "20.93573000",
                        "longitude": "-98.40305000"
                    },
                    {
                        "id": 72067,
                        "name": "Melchor Ocampo",
                        "latitude": "19.94540000",
                        "longitude": "-99.28171000"
                    },
                    {
                        "id": 72090,
                        "name": "Metepec",
                        "latitude": "20.26375000",
                        "longitude": "-98.34366000"
                    },
                    {
                        "id": 72091,
                        "name": "Metepec Primero",
                        "latitude": "20.14167000",
                        "longitude": "-98.43222000"
                    },
                    {
                        "id": 72096,
                        "name": "Metztitlán",
                        "latitude": "20.56753000",
                        "longitude": "-98.79696000"
                    },
                    {
                        "id": 72112,
                        "name": "Mezquititlán",
                        "latitude": "20.53307000",
                        "longitude": "-98.63749000"
                    },
                    {
                        "id": 72120,
                        "name": "Michimaloya",
                        "latitude": "20.09151000",
                        "longitude": "-99.39885000"
                    },
                    {
                        "id": 72149,
                        "name": "Mineral del Monte",
                        "latitude": "20.13830000",
                        "longitude": "-98.67364000"
                    },
                    {
                        "id": 72166,
                        "name": "Mixquiahuala de Juarez",
                        "latitude": "20.23031000",
                        "longitude": "-99.21396000"
                    },
                    {
                        "id": 72181,
                        "name": "Molango",
                        "latitude": "20.78693000",
                        "longitude": "-98.72878000"
                    },
                    {
                        "id": 72195,
                        "name": "Monte Alegre",
                        "latitude": "19.98250000",
                        "longitude": "-99.34139000"
                    },
                    {
                        "id": 72240,
                        "name": "Motovatha",
                        "latitude": "20.18377000",
                        "longitude": "-99.20514000"
                    },
                    {
                        "id": 72255,
                        "name": "Munitepec de Madero",
                        "latitude": "20.12858000",
                        "longitude": "-99.19948000"
                    },
                    {
                        "id": 72277,
                        "name": "Nantzha",
                        "latitude": "20.05317000",
                        "longitude": "-99.36856000"
                    },
                    {
                        "id": 72345,
                        "name": "Nopala de Villagran",
                        "latitude": "20.25198000",
                        "longitude": "-99.64541000"
                    },
                    {
                        "id": 72382,
                        "name": "Nuevo Centro de Población Agrícola el Chacón",
                        "latitude": "20.07028000",
                        "longitude": "-98.73944000"
                    },
                    {
                        "id": 72437,
                        "name": "Ocampo",
                        "latitude": "20.00896000",
                        "longitude": "-99.23926000"
                    },
                    {
                        "id": 72477,
                        "name": "Ohuatipa",
                        "latitude": "20.89308000",
                        "longitude": "-98.26197000"
                    },
                    {
                        "id": 72487,
                        "name": "Ojo de Agua",
                        "latitude": "19.97635000",
                        "longitude": "-99.44498000"
                    },
                    {
                        "id": 72507,
                        "name": "Omitlán de Juárez",
                        "latitude": "20.16980000",
                        "longitude": "-98.64842000"
                    },
                    {
                        "id": 72520,
                        "name": "Oriental de Zapata",
                        "latitude": "19.98528000",
                        "longitude": "-99.03167000"
                    },
                    {
                        "id": 72529,
                        "name": "Orizabita",
                        "latitude": "20.58338000",
                        "longitude": "-99.20874000"
                    },
                    {
                        "id": 72548,
                        "name": "Oxeloco",
                        "latitude": "20.91889000",
                        "longitude": "-98.32556000"
                    },
                    {
                        "id": 72566,
                        "name": "Pachiquita",
                        "latitude": "20.84608000",
                        "longitude": "-98.33478000"
                    },
                    {
                        "id": 72569,
                        "name": "Pachuca de Soto",
                        "latitude": "20.11697000",
                        "longitude": "-98.73329000"
                    },
                    {
                        "id": 72570,
                        "name": "Pachuquilla",
                        "latitude": "20.07099000",
                        "longitude": "-98.69572000"
                    },
                    {
                        "id": 72573,
                        "name": "Pahactla",
                        "latitude": "20.97440000",
                        "longitude": "-98.35634000"
                    },
                    {
                        "id": 72575,
                        "name": "Pahuatlán",
                        "latitude": "21.06940000",
                        "longitude": "-98.47667000"
                    },
                    {
                        "id": 72598,
                        "name": "Palmillas",
                        "latitude": "20.21859000",
                        "longitude": "-99.19840000"
                    },
                    {
                        "id": 72620,
                        "name": "Panales",
                        "latitude": "20.46965000",
                        "longitude": "-99.26674000"
                    },
                    {
                        "id": 72717,
                        "name": "Pañhé",
                        "latitude": "20.52167000",
                        "longitude": "-99.69667000"
                    },
                    {
                        "id": 72630,
                        "name": "Panuaya",
                        "latitude": "20.19500000",
                        "longitude": "-99.27083000"
                    },
                    {
                        "id": 72637,
                        "name": "Papatlatla",
                        "latitude": "20.90154000",
                        "longitude": "-98.45192000"
                    },
                    {
                        "id": 72659,
                        "name": "Parque de Poblamiento Solidaridad",
                        "latitude": "21.15194000",
                        "longitude": "-98.38611000"
                    },
                    {
                        "id": 72658,
                        "name": "Parque Urbano Napateco",
                        "latitude": "20.14278000",
                        "longitude": "-98.34083000"
                    },
                    {
                        "id": 72670,
                        "name": "Paseos de la Pradera",
                        "latitude": "19.89111000",
                        "longitude": "-99.23806000"
                    },
                    {
                        "id": 72710,
                        "name": "Patria Nueva",
                        "latitude": "20.37151000",
                        "longitude": "-99.05172000"
                    },
                    {
                        "id": 72715,
                        "name": "Paxtepec",
                        "latitude": "20.05278000",
                        "longitude": "-98.43139000"
                    },
                    {
                        "id": 72721,
                        "name": "Pedregal de San José",
                        "latitude": "20.06616000",
                        "longitude": "-98.40703000"
                    },
                    {
                        "id": 72779,
                        "name": "Pino Suárez",
                        "latitude": "20.24577000",
                        "longitude": "-99.42107000"
                    },
                    {
                        "id": 72785,
                        "name": "Pisaflores",
                        "latitude": "21.19417000",
                        "longitude": "-99.00551000"
                    },
                    {
                        "id": 72855,
                        "name": "Portezuelo",
                        "latitude": "20.48687000",
                        "longitude": "-99.30610000"
                    },
                    {
                        "id": 72876,
                        "name": "Pozuelos",
                        "latitude": "20.49271000",
                        "longitude": "-99.05974000"
                    },
                    {
                        "id": 72879,
                        "name": "Praderas del Potrero",
                        "latitude": "19.88472000",
                        "longitude": "-99.23028000"
                    },
                    {
                        "id": 72890,
                        "name": "Presas",
                        "latitude": "20.15946000",
                        "longitude": "-99.25242000"
                    },
                    {
                        "id": 72561,
                        "name": "PRI Chacón",
                        "latitude": "20.08139000",
                        "longitude": "-98.73694000"
                    },
                    {
                        "id": 72905,
                        "name": "Privada del Álamo",
                        "latitude": "20.09833000",
                        "longitude": "-98.70028000"
                    },
                    {
                        "id": 72914,
                        "name": "Progreso",
                        "latitude": "20.01972000",
                        "longitude": "-99.23861000"
                    },
                    {
                        "id": 72918,
                        "name": "Progreso de Alvaro Obregon",
                        "latitude": "20.24929000",
                        "longitude": "-99.18988000"
                    },
                    {
                        "id": 72931,
                        "name": "Pueblo Hidalgo",
                        "latitude": "21.11447000",
                        "longitude": "-98.67817000"
                    },
                    {
                        "id": 72940,
                        "name": "Pueblo Nuevo",
                        "latitude": "20.45511000",
                        "longitude": "-99.16652000"
                    },
                    {
                        "id": 73097,
                        "name": "Residencial Arboledas",
                        "latitude": "20.06444000",
                        "longitude": "-99.30167000"
                    },
                    {
                        "id": 73113,
                        "name": "Rinconada de los Ángeles",
                        "latitude": "20.02611000",
                        "longitude": "-98.71139000"
                    },
                    {
                        "id": 73114,
                        "name": "Rinconadas de San Francisco",
                        "latitude": "20.06611000",
                        "longitude": "-98.76806000"
                    },
                    {
                        "id": 73116,
                        "name": "Rinconadas del Venado I",
                        "latitude": "20.06361000",
                        "longitude": "-98.76333000"
                    },
                    {
                        "id": 73117,
                        "name": "Rincones de la Hacienda",
                        "latitude": "20.12000000",
                        "longitude": "-98.40167000"
                    },
                    {
                        "id": 73140,
                        "name": "Rio de la Soledad",
                        "latitude": "20.11500000",
                        "longitude": "-98.71194000"
                    },
                    {
                        "id": 73184,
                        "name": "Río Seco Puente de Doria",
                        "latitude": "20.21094000",
                        "longitude": "-98.50077000"
                    },
                    {
                        "id": 73219,
                        "name": "Salitrillo",
                        "latitude": "19.82937000",
                        "longitude": "-99.21594000"
                    },
                    {
                        "id": 73255,
                        "name": "San Agustín Tlaxiaca",
                        "latitude": "20.11510000",
                        "longitude": "-98.88640000"
                    },
                    {
                        "id": 73257,
                        "name": "San Agustín Zapotlán",
                        "latitude": "19.87550000",
                        "longitude": "-98.71426000"
                    },
                    {
                        "id": 73265,
                        "name": "San Andrés",
                        "latitude": "20.05446000",
                        "longitude": "-99.38008000"
                    },
                    {
                        "id": 73268,
                        "name": "San Andrés (San Andrés Chichayotla)",
                        "latitude": "20.92667000",
                        "longitude": "-98.56333000"
                    },
                    {
                        "id": 73314,
                        "name": "San Antonio",
                        "latitude": "20.53204000",
                        "longitude": "-99.71038000"
                    },
                    {
                        "id": 73384,
                        "name": "San Antonio el Grande",
                        "latitude": "20.45683000",
                        "longitude": "-98.03484000"
                    },
                    {
                        "id": 73386,
                        "name": "San Antonio el Paso",
                        "latitude": "20.14722000",
                        "longitude": "-98.61611000"
                    },
                    {
                        "id": 73363,
                        "name": "San Antonio Zaragoza",
                        "latitude": "20.25497000",
                        "longitude": "-98.99828000"
                    },
                    {
                        "id": 73408,
                        "name": "San Bartolo Ozocalpan",
                        "latitude": "20.22336000",
                        "longitude": "-99.48906000"
                    },
                    {
                        "id": 73409,
                        "name": "San Bartolo Tutotepec",
                        "latitude": "20.39841000",
                        "longitude": "-98.20080000"
                    },
                    {
                        "id": 73448,
                        "name": "San Buenaventura",
                        "latitude": "19.82083000",
                        "longitude": "-99.32209000"
                    },
                    {
                        "id": 73477,
                        "name": "San Cristóbal Chacón",
                        "latitude": "20.08028000",
                        "longitude": "-98.73278000"
                    },
                    {
                        "id": 73506,
                        "name": "San Esteban",
                        "latitude": "20.54452000",
                        "longitude": "-98.06004000"
                    },
                    {
                        "id": 73518,
                        "name": "San Felipe Orizatlán",
                        "latitude": "21.17109000",
                        "longitude": "-98.60744000"
                    },
                    {
                        "id": 73539,
                        "name": "San Francisco",
                        "latitude": "21.01819000",
                        "longitude": "-98.48699000"
                    },
                    {
                        "id": 73550,
                        "name": "San Francisco Atotonilco",
                        "latitude": "20.19472000",
                        "longitude": "-98.15167000"
                    },
                    {
                        "id": 73624,
                        "name": "San Gabriel",
                        "latitude": "20.17154000",
                        "longitude": "-99.33502000"
                    },
                    {
                        "id": 73626,
                        "name": "San Gabriel Azteca",
                        "latitude": "19.88039000",
                        "longitude": "-98.61610000"
                    },
                    {
                        "id": 73638,
                        "name": "San Gregorio",
                        "latitude": "20.49808000",
                        "longitude": "-98.01809000"
                    },
                    {
                        "id": 73652,
                        "name": "San Ignacio Nopala",
                        "latitude": "19.83528000",
                        "longitude": "-99.34556000"
                    },
                    {
                        "id": 73658,
                        "name": "San Ildefonso",
                        "latitude": "19.99629000",
                        "longitude": "-99.37193000"
                    },
                    {
                        "id": 73664,
                        "name": "San Isidro",
                        "latitude": "19.78927000",
                        "longitude": "-98.59141000"
                    },
                    {
                        "id": 73728,
                        "name": "San Joaquín",
                        "latitude": "20.50542000",
                        "longitude": "-99.77600000"
                    },
                    {
                        "id": 73738,
                        "name": "San José",
                        "latitude": "21.06917000",
                        "longitude": "-98.59444000"
                    },
                    {
                        "id": 73742,
                        "name": "San José Atlán",
                        "latitude": "20.33833000",
                        "longitude": "-99.67396000"
                    },
                    {
                        "id": 73748,
                        "name": "San José Boxay",
                        "latitude": "20.26236000",
                        "longitude": "-99.10085000"
                    },
                    {
                        "id": 73760,
                        "name": "San José Corral Blanco",
                        "latitude": "19.90884000",
                        "longitude": "-98.17811000"
                    },
                    {
                        "id": 73777,
                        "name": "San José Ocotillos",
                        "latitude": "20.20687000",
                        "longitude": "-98.61306000"
                    },
                    {
                        "id": 73860,
                        "name": "San Juan Achichilco",
                        "latitude": "20.17868000",
                        "longitude": "-99.31462000"
                    },
                    {
                        "id": 73862,
                        "name": "San Juan Ahuehueco",
                        "latitude": "21.04167000",
                        "longitude": "-98.90694000"
                    },
                    {
                        "id": 73896,
                        "name": "San Juan Hueyapan",
                        "latitude": "20.03000000",
                        "longitude": "-98.28194000"
                    },
                    {
                        "id": 73925,
                        "name": "San Juan Solís",
                        "latitude": "20.15830000",
                        "longitude": "-98.93147000"
                    },
                    {
                        "id": 73932,
                        "name": "San Juan Tepa",
                        "latitude": "20.21579000",
                        "longitude": "-99.06592000"
                    },
                    {
                        "id": 73940,
                        "name": "San Juan Tilcuautla",
                        "latitude": "20.15873000",
                        "longitude": "-98.80112000"
                    },
                    {
                        "id": 73941,
                        "name": "San Juan Tizahuapán",
                        "latitude": "20.05073000",
                        "longitude": "-98.66540000"
                    },
                    {
                        "id": 73995,
                        "name": "San Lorenzo Achiotepec",
                        "latitude": "20.59732000",
                        "longitude": "-98.06876000"
                    },
                    {
                        "id": 74010,
                        "name": "San Lorenzo Sayula",
                        "latitude": "19.98921000",
                        "longitude": "-98.29774000"
                    },
                    {
                        "id": 74055,
                        "name": "San Luis Tecuhautitlán",
                        "latitude": "19.76736000",
                        "longitude": "-98.88868000"
                    },
                    {
                        "id": 74064,
                        "name": "San Marcos",
                        "latitude": "20.03056000",
                        "longitude": "-99.33547000"
                    },
                    {
                        "id": 74071,
                        "name": "San Marcos Guaquilpan",
                        "latitude": "19.59853000",
                        "longitude": "-98.62866000"
                    },
                    {
                        "id": 74115,
                        "name": "San Mateo",
                        "latitude": "20.18267000",
                        "longitude": "-98.24657000"
                    },
                    {
                        "id": 74170,
                        "name": "San Miguel Cerezo (El Cerezo)",
                        "latitude": "20.15909000",
                        "longitude": "-98.72853000"
                    },
                    {
                        "id": 74220,
                        "name": "San Miguel Vindho",
                        "latitude": "19.99447000",
                        "longitude": "-99.31782000"
                    },
                    {
                        "id": 74247,
                        "name": "San Nicolás",
                        "latitude": "20.32218000",
                        "longitude": "-98.18781000"
                    },
                    {
                        "id": 74276,
                        "name": "San Nicolás el Chico",
                        "latitude": "20.09580000",
                        "longitude": "-98.38776000"
                    },
                    {
                        "id": 74262,
                        "name": "San Nicolás Tecomatlán",
                        "latitude": "20.17944000",
                        "longitude": "-99.03639000"
                    },
                    {
                        "id": 74308,
                        "name": "San Pablo el Grande",
                        "latitude": "20.36127000",
                        "longitude": "-98.15999000"
                    },
                    {
                        "id": 74384,
                        "name": "San Pedro Tlachichilco",
                        "latitude": "20.16109000",
                        "longitude": "-98.26415000"
                    },
                    {
                        "id": 74390,
                        "name": "San Pedro Tlaquilpan",
                        "latitude": "19.94514000",
                        "longitude": "-98.75293000"
                    },
                    {
                        "id": 74444,
                        "name": "San Salvador",
                        "latitude": "20.28583000",
                        "longitude": "-99.01457000"
                    },
                    {
                        "id": 74469,
                        "name": "San Sebastián Tenochtitlán",
                        "latitude": "20.27988000",
                        "longitude": "-99.68879000"
                    },
                    {
                        "id": 74526,
                        "name": "Santa Ana Ahuehuepan",
                        "latitude": "20.12288000",
                        "longitude": "-99.34497000"
                    },
                    {
                        "id": 74528,
                        "name": "Santa Ana Azcapotzaltongo",
                        "latitude": "19.94325000",
                        "longitude": "-99.38800000"
                    },
                    {
                        "id": 74529,
                        "name": "Santa Ana Batha",
                        "latitude": "20.37944000",
                        "longitude": "-99.19186000"
                    },
                    {
                        "id": 74553,
                        "name": "Santa Ana de Allende",
                        "latitude": "21.12301000",
                        "longitude": "-98.98606000"
                    },
                    {
                        "id": 74534,
                        "name": "Santa Ana Hueytlalpan",
                        "latitude": "20.17484000",
                        "longitude": "-98.31209000"
                    },
                    {
                        "id": 74545,
                        "name": "Santa Ana Tlachiahualpa",
                        "latitude": "19.76869000",
                        "longitude": "-98.90885000"
                    },
                    {
                        "id": 74548,
                        "name": "Santa Ana Tzacuala",
                        "latitude": "20.19798000",
                        "longitude": "-98.20403000"
                    },
                    {
                        "id": 74564,
                        "name": "Santa Bárbara",
                        "latitude": "19.66666000",
                        "longitude": "-98.56920000"
                    },
                    {
                        "id": 74574,
                        "name": "Santa Catarina",
                        "latitude": "21.10045000",
                        "longitude": "-98.38077000"
                    },
                    {
                        "id": 74600,
                        "name": "Santa Clara",
                        "latitude": "19.69889000",
                        "longitude": "-98.57778000"
                    },
                    {
                        "id": 74606,
                        "name": "Santa Cruz",
                        "latitude": "21.19813000",
                        "longitude": "-98.49395000"
                    },
                    {
                        "id": 74656,
                        "name": "Santa Elena Paliseca",
                        "latitude": "19.99805000",
                        "longitude": "-98.24144000"
                    },
                    {
                        "id": 74706,
                        "name": "Santa María Actipac",
                        "latitude": "19.85547000",
                        "longitude": "-98.74561000"
                    },
                    {
                        "id": 74711,
                        "name": "Santa María Amajac",
                        "latitude": "20.22949000",
                        "longitude": "-98.99833000"
                    },
                    {
                        "id": 74694,
                        "name": "Santa Maria Amealco",
                        "latitude": "20.23771000",
                        "longitude": "-99.54963000"
                    },
                    {
                        "id": 74712,
                        "name": "Santa María Apaxco",
                        "latitude": "19.95524000",
                        "longitude": "-99.18680000"
                    },
                    {
                        "id": 74715,
                        "name": "Santa María Asunción",
                        "latitude": "20.15508000",
                        "longitude": "-98.27037000"
                    },
                    {
                        "id": 74720,
                        "name": "Santa María Batha",
                        "latitude": "20.22413000",
                        "longitude": "-99.25174000"
                    },
                    {
                        "id": 74745,
                        "name": "Santa María Ilucan",
                        "latitude": "19.99222000",
                        "longitude": "-99.33951000"
                    },
                    {
                        "id": 74823,
                        "name": "Santa María la Calera",
                        "latitude": "20.03072000",
                        "longitude": "-98.71929000"
                    },
                    {
                        "id": 74696,
                        "name": "Santa Maria Macua",
                        "latitude": "20.13605000",
                        "longitude": "-99.47544000"
                    },
                    {
                        "id": 74754,
                        "name": "Santa María Magdalena",
                        "latitude": "19.97398000",
                        "longitude": "-99.37387000"
                    },
                    {
                        "id": 74761,
                        "name": "Santa María Nativitas",
                        "latitude": "20.03901000",
                        "longitude": "-98.29535000"
                    },
                    {
                        "id": 74772,
                        "name": "Santa María Quelites",
                        "latitude": "19.85391000",
                        "longitude": "-99.34773000"
                    },
                    {
                        "id": 74793,
                        "name": "Santa María Xigui",
                        "latitude": "20.46111000",
                        "longitude": "-99.34500000"
                    },
                    {
                        "id": 74825,
                        "name": "Santa Mónica",
                        "latitude": "19.98363000",
                        "longitude": "-98.62143000"
                    },
                    {
                        "id": 74856,
                        "name": "Santa Teresa",
                        "latitude": "20.88989000",
                        "longitude": "-98.38330000"
                    },
                    {
                        "id": 74863,
                        "name": "Santa Úrsula",
                        "latitude": "20.42030000",
                        "longitude": "-98.10478000"
                    },
                    {
                        "id": 74872,
                        "name": "Santiago Acayutlán",
                        "latitude": "20.19719000",
                        "longitude": "-99.29534000"
                    },
                    {
                        "id": 74896,
                        "name": "Santiago Cuaula",
                        "latitude": "19.60136000",
                        "longitude": "-98.64941000"
                    },
                    {
                        "id": 74982,
                        "name": "Santiago de Anaya",
                        "latitude": "20.38410000",
                        "longitude": "-98.96512000"
                    },
                    {
                        "id": 74910,
                        "name": "Santiago Jaltepec",
                        "latitude": "20.10972000",
                        "longitude": "-98.71111000"
                    },
                    {
                        "id": 74949,
                        "name": "Santiago Tepeyahualco",
                        "latitude": "19.84864000",
                        "longitude": "-98.66970000"
                    },
                    {
                        "id": 74955,
                        "name": "Santiago Tezontlale",
                        "latitude": "20.16217000",
                        "longitude": "-99.09865000"
                    },
                    {
                        "id": 74962,
                        "name": "Santiago Tlaltepoxco",
                        "latitude": "19.88365000",
                        "longitude": "-99.26046000"
                    },
                    {
                        "id": 74963,
                        "name": "Santiago Tlapacoya",
                        "latitude": "20.10925000",
                        "longitude": "-98.83037000"
                    },
                    {
                        "id": 74964,
                        "name": "Santiago Tlapanaloya",
                        "latitude": "19.87056000",
                        "longitude": "-99.35083000"
                    },
                    {
                        "id": 74965,
                        "name": "Santiago Tlautla",
                        "latitude": "19.96222000",
                        "longitude": "-99.36909000"
                    },
                    {
                        "id": 74967,
                        "name": "Santiago Tulantepec",
                        "latitude": "20.03618000",
                        "longitude": "-98.35563000"
                    },
                    {
                        "id": 75022,
                        "name": "Santo Tomas",
                        "latitude": "19.90364000",
                        "longitude": "-98.56882000"
                    },
                    {
                        "id": 75095,
                        "name": "Singuilucan",
                        "latitude": "19.98964000",
                        "longitude": "-98.51923000"
                    },
                    {
                        "id": 75173,
                        "name": "Talol",
                        "latitude": "21.12025000",
                        "longitude": "-98.62655000"
                    },
                    {
                        "id": 75203,
                        "name": "Tancazahuela",
                        "latitude": "21.18300000",
                        "longitude": "-98.43483000"
                    },
                    {
                        "id": 75236,
                        "name": "Tasquillo",
                        "latitude": "20.54698000",
                        "longitude": "-99.34562000"
                    },
                    {
                        "id": 75244,
                        "name": "Taxadho",
                        "latitude": "20.43330000",
                        "longitude": "-99.14934000"
                    },
                    {
                        "id": 75253,
                        "name": "Teacalco",
                        "latitude": "19.80561000",
                        "longitude": "-98.85209000"
                    },
                    {
                        "id": 75258,
                        "name": "Tecacahuaco",
                        "latitude": "20.94133000",
                        "longitude": "-98.33889000"
                    },
                    {
                        "id": 75286,
                        "name": "Tecozautla",
                        "latitude": "20.53302000",
                        "longitude": "-99.64662000"
                    },
                    {
                        "id": 75297,
                        "name": "Tehuetlán",
                        "latitude": "21.05337000",
                        "longitude": "-98.50853000"
                    },
                    {
                        "id": 75323,
                        "name": "Teltipán de Juárez",
                        "latitude": "20.11527000",
                        "longitude": "-99.20146000"
                    },
                    {
                        "id": 75327,
                        "name": "Temango",
                        "latitude": "21.13143000",
                        "longitude": "-98.69051000"
                    },
                    {
                        "id": 75353,
                        "name": "Tenango",
                        "latitude": "20.22714000",
                        "longitude": "-99.29068000"
                    },
                    {
                        "id": 75355,
                        "name": "Tenango de Doria",
                        "latitude": "20.33828000",
                        "longitude": "-98.22805000"
                    },
                    {
                        "id": 75372,
                        "name": "Teocalco",
                        "latitude": "20.08582000",
                        "longitude": "-99.28289000"
                    },
                    {
                        "id": 75375,
                        "name": "Teofani",
                        "latitude": "20.32284000",
                        "longitude": "-99.04300000"
                    },
                    {
                        "id": 75399,
                        "name": "Tepatepec",
                        "latitude": "20.24568000",
                        "longitude": "-99.08981000"
                    },
                    {
                        "id": 75404,
                        "name": "Tepeapulco",
                        "latitude": "19.80470000",
                        "longitude": "-98.50153000"
                    },
                    {
                        "id": 75408,
                        "name": "Tepehuacán de Guerrero",
                        "latitude": "21.01350000",
                        "longitude": "-98.84184000"
                    },
                    {
                        "id": 75410,
                        "name": "Tepeitic",
                        "latitude": "20.24123000",
                        "longitude": "-99.29084000"
                    },
                    {
                        "id": 75411,
                        "name": "Tepeji del Río de Ocampo",
                        "latitude": "19.90481000",
                        "longitude": "-99.34379000"
                    },
                    {
                        "id": 75414,
                        "name": "Tepepa",
                        "latitude": "20.13440000",
                        "longitude": "-98.17131000"
                    },
                    {
                        "id": 75418,
                        "name": "Tepetitla",
                        "latitude": "20.96140000",
                        "longitude": "-98.38400000"
                    },
                    {
                        "id": 75420,
                        "name": "Tepetitlán",
                        "latitude": "20.18301000",
                        "longitude": "-99.38882000"
                    },
                    {
                        "id": 75440,
                        "name": "Tepexititla",
                        "latitude": "21.13205000",
                        "longitude": "-98.44735000"
                    },
                    {
                        "id": 75449,
                        "name": "Tepojaco",
                        "latitude": "19.84070000",
                        "longitude": "-98.94759000"
                    },
                    {
                        "id": 75485,
                        "name": "Tetepango",
                        "latitude": "20.10168000",
                        "longitude": "-99.15108000"
                    },
                    {
                        "id": 75501,
                        "name": "Texcaco",
                        "latitude": "20.83982000",
                        "longitude": "-98.61613000"
                    },
                    {
                        "id": 75505,
                        "name": "Texcaltepec",
                        "latitude": "20.03028000",
                        "longitude": "-98.32417000"
                    },
                    {
                        "id": 75510,
                        "name": "Texcapa",
                        "latitude": "21.09228000",
                        "longitude": "-98.85403000"
                    },
                    {
                        "id": 75512,
                        "name": "Texcatepec",
                        "latitude": "20.27655000",
                        "longitude": "-99.25375000"
                    },
                    {
                        "id": 75523,
                        "name": "Tezapotla",
                        "latitude": "21.17381000",
                        "longitude": "-98.81242000"
                    },
                    {
                        "id": 75529,
                        "name": "Tezontepec",
                        "latitude": "19.88063000",
                        "longitude": "-98.81972000"
                    },
                    {
                        "id": 75530,
                        "name": "Tezontepec de Aldama",
                        "latitude": "20.19073000",
                        "longitude": "-99.27429000"
                    },
                    {
                        "id": 75531,
                        "name": "Tezoquipa",
                        "latitude": "20.05639000",
                        "longitude": "-99.20472000"
                    },
                    {
                        "id": 75536,
                        "name": "Tianguistengo",
                        "latitude": "20.72796000",
                        "longitude": "-98.63209000"
                    },
                    {
                        "id": 75537,
                        "name": "Tianguistengo (La Romera)",
                        "latitude": "19.91417000",
                        "longitude": "-99.32583000"
                    },
                    {
                        "id": 75568,
                        "name": "Tiltepec",
                        "latitude": "20.31394000",
                        "longitude": "-98.68288000"
                    },
                    {
                        "id": 75573,
                        "name": "Tinajas",
                        "latitude": "19.89739000",
                        "longitude": "-99.36662000"
                    },
                    {
                        "id": 75595,
                        "name": "Tizayuca",
                        "latitude": "19.83721000",
                        "longitude": "-98.97607000"
                    },
                    {
                        "id": 75611,
                        "name": "Tlacomulco",
                        "latitude": "20.15301000",
                        "longitude": "-98.12027000"
                    },
                    {
                        "id": 75622,
                        "name": "Tlacpac",
                        "latitude": "20.14889000",
                        "longitude": "-98.21694000"
                    },
                    {
                        "id": 75630,
                        "name": "Tlahuelilpan",
                        "latitude": "20.13087000",
                        "longitude": "-99.22677000"
                    },
                    {
                        "id": 75631,
                        "name": "Tlahuelompa (San Francisco Tlahuelompa)",
                        "latitude": "20.65082000",
                        "longitude": "-98.57522000"
                    },
                    {
                        "id": 75632,
                        "name": "Tlahuiltepa",
                        "latitude": "20.89805000",
                        "longitude": "-98.96263000"
                    },
                    {
                        "id": 75636,
                        "name": "Tlalchiyahualica",
                        "latitude": "20.97086000",
                        "longitude": "-98.39975000"
                    },
                    {
                        "id": 75643,
                        "name": "Tlalminulpa",
                        "latitude": "20.07491000",
                        "longitude": "-99.22220000"
                    },
                    {
                        "id": 75661,
                        "name": "Tlamaco (San Gerónimo Tlamaco)",
                        "latitude": "20.03472000",
                        "longitude": "-99.22917000"
                    },
                    {
                        "id": 75668,
                        "name": "Tlanalapa",
                        "latitude": "19.82525000",
                        "longitude": "-98.59449000"
                    },
                    {
                        "id": 75670,
                        "name": "Tlanchinol",
                        "latitude": "21.03005000",
                        "longitude": "-98.64996000"
                    },
                    {
                        "id": 75695,
                        "name": "Tlaxcalilla",
                        "latitude": "20.37731000",
                        "longitude": "-99.81545000"
                    },
                    {
                        "id": 75700,
                        "name": "Tlaxcoapan",
                        "latitude": "20.09163000",
                        "longitude": "-99.22042000"
                    },
                    {
                        "id": 75703,
                        "name": "Tlaxocoyucan",
                        "latitude": "20.22895000",
                        "longitude": "-98.49034000"
                    },
                    {
                        "id": 75720,
                        "name": "Tolcayuca",
                        "latitude": "19.94112000",
                        "longitude": "-98.91908000"
                    },
                    {
                        "id": 75791,
                        "name": "Tula de Allende",
                        "latitude": "20.05161000",
                        "longitude": "-99.34397000"
                    },
                    {
                        "id": 75792,
                        "name": "Tulancingo",
                        "latitude": "20.08355000",
                        "longitude": "-98.36288000"
                    },
                    {
                        "id": 75793,
                        "name": "Tulancingo de Bravo",
                        "latitude": "20.11983000",
                        "longitude": "-98.36049000"
                    },
                    {
                        "id": 75801,
                        "name": "Tulipanes",
                        "latitude": "20.06028000",
                        "longitude": "-98.76722000"
                    },
                    {
                        "id": 75809,
                        "name": "Tunititlán",
                        "latitude": "20.24938000",
                        "longitude": "-99.24433000"
                    },
                    {
                        "id": 75871,
                        "name": "Unidad Habitacional Antonio Osorio de León (Bojay)",
                        "latitude": "20.04389000",
                        "longitude": "-99.24472000"
                    },
                    {
                        "id": 75876,
                        "name": "Unidad Minera 11 de Julio",
                        "latitude": "20.10472000",
                        "longitude": "-98.72278000"
                    },
                    {
                        "id": 75878,
                        "name": "Unidades Habitacionales",
                        "latitude": "20.06389000",
                        "longitude": "-98.42056000"
                    },
                    {
                        "id": 75957,
                        "name": "Ventoquipa",
                        "latitude": "20.03361000",
                        "longitude": "-98.33778000"
                    },
                    {
                        "id": 75972,
                        "name": "Vicente Guerrero",
                        "latitude": "20.16567000",
                        "longitude": "-99.05746000"
                    },
                    {
                        "id": 75980,
                        "name": "Vicente Guerrero (San Javier)",
                        "latitude": "19.94991000",
                        "longitude": "-98.90135000"
                    },
                    {
                        "id": 76099,
                        "name": "Vito",
                        "latitude": "19.99014000",
                        "longitude": "-99.19898000"
                    },
                    {
                        "id": 76147,
                        "name": "Xiquila",
                        "latitude": "21.07803000",
                        "longitude": "-98.44315000"
                    },
                    {
                        "id": 76148,
                        "name": "Xiteje de Zapata",
                        "latitude": "20.09728000",
                        "longitude": "-99.38872000"
                    },
                    {
                        "id": 76157,
                        "name": "Xochiatipan",
                        "latitude": "20.85794000",
                        "longitude": "-98.28206000"
                    },
                    {
                        "id": 76158,
                        "name": "Xochiatipan de Castillo",
                        "latitude": "20.83510000",
                        "longitude": "-98.28556000"
                    },
                    {
                        "id": 76160,
                        "name": "Xochicoatlán",
                        "latitude": "20.79715000",
                        "longitude": "-98.63718000"
                    },
                    {
                        "id": 76178,
                        "name": "Xochitlán",
                        "latitude": "20.29585000",
                        "longitude": "-99.18741000"
                    },
                    {
                        "id": 76191,
                        "name": "Xolostitla de Morelos (Xolostitla)",
                        "latitude": "20.06639000",
                        "longitude": "-98.63861000"
                    },
                    {
                        "id": 76202,
                        "name": "Xoxolpa",
                        "latitude": "20.87574000",
                        "longitude": "-98.42386000"
                    },
                    {
                        "id": 76210,
                        "name": "Yahualica",
                        "latitude": "20.91485000",
                        "longitude": "-98.37868000"
                    },
                    {
                        "id": 76241,
                        "name": "Yolotepec",
                        "latitude": "20.38767000",
                        "longitude": "-99.07307000"
                    },
                    {
                        "id": 76254,
                        "name": "Zacacuautla",
                        "latitude": "20.21500000",
                        "longitude": "-98.22887000"
                    },
                    {
                        "id": 76258,
                        "name": "Zacamulpa",
                        "latitude": "20.00583000",
                        "longitude": "-99.25694000"
                    },
                    {
                        "id": 76290,
                        "name": "Zacualtipán",
                        "latitude": "20.65002000",
                        "longitude": "-98.65628000"
                    },
                    {
                        "id": 76289,
                        "name": "Zacualtipanito",
                        "latitude": "21.15407000",
                        "longitude": "-98.79997000"
                    },
                    {
                        "id": 76312,
                        "name": "Zapotlán de Juárez",
                        "latitude": "19.97709000",
                        "longitude": "-98.86420000"
                    },
                    {
                        "id": 76328,
                        "name": "Zempoala",
                        "latitude": "19.93850000",
                        "longitude": "-98.66871000"
                    },
                    {
                        "id": 76336,
                        "name": "Zimapan",
                        "latitude": "20.73814000",
                        "longitude": "-99.38180000"
                    },
                    {
                        "id": 76356,
                        "name": "Zocea",
                        "latitude": "20.43760000",
                        "longitude": "-99.35742000"
                    },
                    {
                        "id": 76371,
                        "name": "Zoquitipán",
                        "latitude": "20.90902000",
                        "longitude": "-98.43242000"
                    },
                    {
                        "id": 76374,
                        "name": "Zothé",
                        "latitude": "20.36959000",
                        "longitude": "-99.71581000"
                    },
                    {
                        "id": 76376,
                        "name": "Zotoluca",
                        "latitude": "19.61063000",
                        "longitude": "-98.51094000"
                    }
                ]
            },
            {
                "id": 4857,
                "name": "Jalisco",
                "iso2": "JAL",
                "latitude": "20.65953820",
                "longitude": "-103.34943760",
                "type": "state",
                "cities": [
                    {
                        "id": 142147,
                        "name": "Acatlán de Juárez Municipality",
                        "latitude": "20.42416667",
                        "longitude": "-103.60138889"
                    },
                    {
                        "id": 142148,
                        "name": "Acueducto Fraccionamiento",
                        "latitude": "19.47917000",
                        "longitude": "-103.31806000"
                    },
                    {
                        "id": 142149,
                        "name": "Agua Bermeja",
                        "latitude": "20.66750000",
                        "longitude": "-102.97056000"
                    },
                    {
                        "id": 142150,
                        "name": "Agua Caliente",
                        "latitude": "21.77250000",
                        "longitude": "-103.78806000"
                    },
                    {
                        "id": 142151,
                        "name": "Agua Colorada",
                        "latitude": "20.94694000",
                        "longitude": "-103.20611000"
                    },
                    {
                        "id": 142152,
                        "name": "Agua Delgada",
                        "latitude": "20.16222000",
                        "longitude": "-103.82750000"
                    },
                    {
                        "id": 142153,
                        "name": "Agua Escondida",
                        "latitude": "20.86083000",
                        "longitude": "-102.72500000"
                    },
                    {
                        "id": 142154,
                        "name": "Agua Fría",
                        "latitude": "20.58778000",
                        "longitude": "-102.55833000"
                    },
                    {
                        "id": 142155,
                        "name": "Agua Nueva",
                        "latitude": "20.67889000",
                        "longitude": "-102.45111000"
                    },
                    {
                        "id": 142156,
                        "name": "Agua Paloma",
                        "latitude": "19.67799000",
                        "longitude": "-105.18473000"
                    },
                    {
                        "id": 142157,
                        "name": "Agua Prieta",
                        "latitude": "20.79361000",
                        "longitude": "-102.89194000"
                    },
                    {
                        "id": 142158,
                        "name": "Agua Rica",
                        "latitude": "20.83639000",
                        "longitude": "-103.18778000"
                    },
                    {
                        "id": 142159,
                        "name": "Agua Salada",
                        "latitude": "19.73111000",
                        "longitude": "-103.19639000"
                    },
                    {
                        "id": 142160,
                        "name": "Agua Zarca",
                        "latitude": "21.85035000",
                        "longitude": "-103.49102000"
                    },
                    {
                        "id": 142161,
                        "name": "Ahualulco de Mercado Municipality",
                        "latitude": "20.61666667",
                        "longitude": "-103.86666667"
                    },
                    {
                        "id": 142162,
                        "name": "Ahuatlán",
                        "latitude": "20.41836000",
                        "longitude": "-102.88759000"
                    },
                    {
                        "id": 142163,
                        "name": "Ahuetita de Abajo",
                        "latitude": "21.41972000",
                        "longitude": "-102.65278000"
                    },
                    {
                        "id": 142164,
                        "name": "Ahuisculco",
                        "latitude": "20.56875000",
                        "longitude": "-103.70313000"
                    },
                    {
                        "id": 142165,
                        "name": "Ajijic",
                        "latitude": "20.29944444",
                        "longitude": "-103.25805556"
                    },
                    {
                        "id": 142166,
                        "name": "Alfredo V. Bonfil",
                        "latitude": "20.66278000",
                        "longitude": "-103.72278000"
                    },
                    {
                        "id": 142167,
                        "name": "Alista",
                        "latitude": "19.63401000",
                        "longitude": "-103.78890000"
                    },
                    {
                        "id": 142168,
                        "name": "Allende",
                        "latitude": "20.72054000",
                        "longitude": "-102.08557000"
                    },
                    {
                        "id": 142169,
                        "name": "Altavista de Ramos",
                        "latitude": "20.43333333",
                        "longitude": "-104.01666667"
                    },
                    {
                        "id": 142170,
                        "name": "Altus Bosques",
                        "latitude": "20.56806000",
                        "longitude": "-103.37250000"
                    },
                    {
                        "id": 142171,
                        "name": "Amacuautitlán",
                        "latitude": "19.81619000",
                        "longitude": "-104.02078000"
                    },
                    {
                        "id": 142172,
                        "name": "Amacueca Municipality",
                        "latitude": "19.93333333",
                        "longitude": "-103.06666667"
                    },
                    {
                        "id": 142173,
                        "name": "Amajaquillo",
                        "latitude": "20.92750000",
                        "longitude": "-104.60028000"
                    },
                    {
                        "id": 142174,
                        "name": "Amatanejo",
                        "latitude": "20.95241000",
                        "longitude": "-104.73775000"
                    },
                    {
                        "id": 142175,
                        "name": "Amatitán",
                        "latitude": "20.83333333",
                        "longitude": "-103.71666667"
                    },
                    {
                        "id": 142176,
                        "name": "Ambrosio",
                        "latitude": "20.27605000",
                        "longitude": "-103.97092000"
                    },
                    {
                        "id": 142177,
                        "name": "Ameca",
                        "latitude": "20.67000000",
                        "longitude": "-103.70000000"
                    },
                    {
                        "id": 142178,
                        "name": "Ameca Municipality",
                        "latitude": "20.54831370",
                        "longitude": "-104.04750230"
                    },
                    {
                        "id": 142179,
                        "name": "Analco",
                        "latitude": "21.38500000",
                        "longitude": "-102.63417000"
                    },
                    {
                        "id": 142180,
                        "name": "Anoca",
                        "latitude": "20.09222000",
                        "longitude": "-103.54556000"
                    },
                    {
                        "id": 142181,
                        "name": "Antonio Escobedo",
                        "latitude": "20.80000000",
                        "longitude": "-104.01667000"
                    },
                    {
                        "id": 142182,
                        "name": "Apazulco",
                        "latitude": "19.36972000",
                        "longitude": "-104.87889000"
                    },
                    {
                        "id": 142183,
                        "name": "Apozol de Gutiérrez",
                        "latitude": "21.01778000",
                        "longitude": "-102.82556000"
                    },
                    {
                        "id": 142184,
                        "name": "Aquiles Serdán",
                        "latitude": "20.30019000",
                        "longitude": "-105.62230000"
                    },
                    {
                        "id": 142185,
                        "name": "Arandas",
                        "latitude": "20.70519000",
                        "longitude": "-102.34635000"
                    },
                    {
                        "id": 142186,
                        "name": "Arroyo Hondo",
                        "latitude": "19.68222000",
                        "longitude": "-103.30000000"
                    },
                    {
                        "id": 142187,
                        "name": "Atacco",
                        "latitude": "19.92662000",
                        "longitude": "-103.74249000"
                    },
                    {
                        "id": 142188,
                        "name": "Atarjeas de Covarrubias",
                        "latitude": "19.91944000",
                        "longitude": "-103.94333000"
                    },
                    {
                        "id": 142189,
                        "name": "Atemanica",
                        "latitude": "21.07528000",
                        "longitude": "-103.75028000"
                    },
                    {
                        "id": 142190,
                        "name": "Atengo",
                        "latitude": "20.21666667",
                        "longitude": "-104.08333333"
                    },
                    {
                        "id": 142191,
                        "name": "Atenguillo",
                        "latitude": "20.41553000",
                        "longitude": "-104.49387000"
                    },
                    {
                        "id": 142192,
                        "name": "Atequiza",
                        "latitude": "20.39006000",
                        "longitude": "-103.14065000"
                    },
                    {
                        "id": 142193,
                        "name": "Atotonilco el Alto Municipality",
                        "latitude": "20.53333333",
                        "longitude": "-102.50000000"
                    },
                    {
                        "id": 142194,
                        "name": "Atotonilco el Bajo",
                        "latitude": "20.34833333",
                        "longitude": "-103.67083333"
                    },
                    {
                        "id": 142195,
                        "name": "Atotonilquillo",
                        "latitude": "20.39287000",
                        "longitude": "-103.12356000"
                    },
                    {
                        "id": 142196,
                        "name": "Atoyac",
                        "latitude": "20.01700000",
                        "longitude": "-103.53300000"
                    },
                    {
                        "id": 142197,
                        "name": "Atzcatlán",
                        "latitude": "20.40306000",
                        "longitude": "-102.97111000"
                    },
                    {
                        "id": 142198,
                        "name": "Autlán de Navarro",
                        "latitude": "19.76666667",
                        "longitude": "-104.36666667"
                    },
                    {
                        "id": 142199,
                        "name": "Ayotitlán",
                        "latitude": "20.22048000",
                        "longitude": "-103.94397000"
                    },
                    {
                        "id": 142200,
                        "name": "Ayotlán Municipality",
                        "latitude": "20.49388889",
                        "longitude": "-102.35083333"
                    },
                    {
                        "id": 142201,
                        "name": "Ayuquila",
                        "latitude": "19.84001000",
                        "longitude": "-104.27156000"
                    },
                    {
                        "id": 142202,
                        "name": "Ayutla Jalisco",
                        "latitude": "20.81666667",
                        "longitude": "-104.20000000"
                    },
                    {
                        "id": 142204,
                        "name": "Bajío de Ratones",
                        "latitude": "20.71306000",
                        "longitude": "-102.42861000"
                    },
                    {
                        "id": 142205,
                        "name": "Bajío de San José",
                        "latitude": "21.67525000",
                        "longitude": "-102.11606000"
                    },
                    {
                        "id": 142203,
                        "name": "Bajío Seco",
                        "latitude": "20.70889000",
                        "longitude": "-102.39028000"
                    },
                    {
                        "id": 142206,
                        "name": "Balcones de la Calera",
                        "latitude": "20.44250000",
                        "longitude": "-103.26722000"
                    },
                    {
                        "id": 142207,
                        "name": "Banus Vallarta",
                        "latitude": "20.71611000",
                        "longitude": "-105.22306000"
                    },
                    {
                        "id": 142208,
                        "name": "Barra de Navidad",
                        "latitude": "19.20805556",
                        "longitude": "-104.68055556"
                    },
                    {
                        "id": 142211,
                        "name": "Barranca de los Laureles",
                        "latitude": "20.23333333",
                        "longitude": "-103.63333333"
                    },
                    {
                        "id": 142209,
                        "name": "Barranca de Otates",
                        "latitude": "20.26806000",
                        "longitude": "-103.66472000"
                    },
                    {
                        "id": 142210,
                        "name": "Barranca de Santa Clara",
                        "latitude": "20.25566000",
                        "longitude": "-103.65560000"
                    },
                    {
                        "id": 142212,
                        "name": "Barranca del Tule",
                        "latitude": "21.98028000",
                        "longitude": "-103.90694000"
                    },
                    {
                        "id": 142213,
                        "name": "Barrio de Reyes",
                        "latitude": "21.29194000",
                        "longitude": "-102.50556000"
                    },
                    {
                        "id": 142214,
                        "name": "Barrio de Tapias",
                        "latitude": "22.18361000",
                        "longitude": "-103.22667000"
                    },
                    {
                        "id": 142215,
                        "name": "Belem del Refugio",
                        "latitude": "21.53023000",
                        "longitude": "-102.43515000"
                    },
                    {
                        "id": 142216,
                        "name": "Bellavista",
                        "latitude": "20.43408000",
                        "longitude": "-103.63742000"
                    },
                    {
                        "id": 142217,
                        "name": "Benito Juárez",
                        "latitude": "20.03639000",
                        "longitude": "-105.26806000"
                    },
                    {
                        "id": 142218,
                        "name": "Betania",
                        "latitude": "20.58199000",
                        "longitude": "-102.37914000"
                    },
                    {
                        "id": 142219,
                        "name": "Betulia",
                        "latitude": "21.75935000",
                        "longitude": "-102.01940000"
                    },
                    {
                        "id": 142220,
                        "name": "Bicercio",
                        "latitude": "20.65944000",
                        "longitude": "-102.98389000"
                    },
                    {
                        "id": 142221,
                        "name": "Boca de Tomatlán",
                        "latitude": "20.51211000",
                        "longitude": "-105.31442000"
                    },
                    {
                        "id": 142222,
                        "name": "Bolaños Municipality",
                        "latitude": "21.83055556",
                        "longitude": "-103.78055556"
                    },
                    {
                        "id": 142223,
                        "name": "Bosque Real Fraccionamiento",
                        "latitude": "20.56833000",
                        "longitude": "-103.49389000"
                    },
                    {
                        "id": 142224,
                        "name": "Brisas de la Navidad",
                        "latitude": "19.22444000",
                        "longitude": "-104.65639000"
                    },
                    {
                        "id": 142225,
                        "name": "Brizuela",
                        "latitude": "20.18333333",
                        "longitude": "-103.70000000"
                    },
                    {
                        "id": 142226,
                        "name": "Buena Vista",
                        "latitude": "20.77722000",
                        "longitude": "-102.75778000"
                    },
                    {
                        "id": 142227,
                        "name": "Buenavista",
                        "latitude": "21.55889000",
                        "longitude": "-102.55639000"
                    },
                    {
                        "id": 142228,
                        "name": "Buenos Aires",
                        "latitude": "20.54056000",
                        "longitude": "-102.93444000"
                    },
                    {
                        "id": 142229,
                        "name": "Cabo Corrientes",
                        "latitude": "20.34394000",
                        "longitude": "-105.39322000"
                    },
                    {
                        "id": 142230,
                        "name": "Cajititlán",
                        "latitude": "20.43174000",
                        "longitude": "-103.30940000"
                    },
                    {
                        "id": 142231,
                        "name": "Calerita",
                        "latitude": "21.46000000",
                        "longitude": "-102.58806000"
                    },
                    {
                        "id": 142232,
                        "name": "Callejones",
                        "latitude": "19.66833000",
                        "longitude": "-103.26278000"
                    },
                    {
                        "id": 142233,
                        "name": "Camajapita",
                        "latitude": "20.35000000",
                        "longitude": "-103.91666667"
                    },
                    {
                        "id": 142234,
                        "name": "Campestre las Palomas Fraccionamiento",
                        "latitude": "20.81778000",
                        "longitude": "-103.45167000"
                    },
                    {
                        "id": 142235,
                        "name": "Campo Acosta",
                        "latitude": "19.77061000",
                        "longitude": "-105.24917000"
                    },
                    {
                        "id": 142236,
                        "name": "Campo Real",
                        "latitude": "20.78722000",
                        "longitude": "-103.44306000"
                    },
                    {
                        "id": 142252,
                        "name": "Cañada de Islas",
                        "latitude": "21.24139000",
                        "longitude": "-102.83722000"
                    },
                    {
                        "id": 142253,
                        "name": "Cañada de Ricos",
                        "latitude": "21.37140000",
                        "longitude": "-101.87653000"
                    },
                    {
                        "id": 142254,
                        "name": "Cañada de San Ignacio",
                        "latitude": "20.55222000",
                        "longitude": "-102.35333000"
                    },
                    {
                        "id": 142251,
                        "name": "Cañada Grande",
                        "latitude": "21.03889000",
                        "longitude": "-102.59278000"
                    },
                    {
                        "id": 142255,
                        "name": "Cañadas de Obregón",
                        "latitude": "21.14685000",
                        "longitude": "-102.68616111"
                    },
                    {
                        "id": 142237,
                        "name": "Canchol",
                        "latitude": "19.30028000",
                        "longitude": "-102.94889000"
                    },
                    {
                        "id": 142238,
                        "name": "Canoas",
                        "latitude": "21.27222000",
                        "longitude": "-101.80694000"
                    },
                    {
                        "id": 142239,
                        "name": "Canoas de Arriba",
                        "latitude": "22.12333000",
                        "longitude": "-103.24556000"
                    },
                    {
                        "id": 142240,
                        "name": "Capilla de Guadalupe",
                        "latitude": "20.82694444",
                        "longitude": "-102.59222222"
                    },
                    {
                        "id": 142241,
                        "name": "Capilla de Milpillas",
                        "latitude": "20.66331000",
                        "longitude": "-102.84295000"
                    },
                    {
                        "id": 142242,
                        "name": "Capulín",
                        "latitude": "20.47802000",
                        "longitude": "-103.26947000"
                    },
                    {
                        "id": 142243,
                        "name": "Caquixtle de Arriba",
                        "latitude": "21.51250000",
                        "longitude": "-102.07472000"
                    },
                    {
                        "id": 142244,
                        "name": "Carrasqueño",
                        "latitude": "20.37917000",
                        "longitude": "-102.61889000"
                    },
                    {
                        "id": 142245,
                        "name": "Carretas",
                        "latitude": "20.44222000",
                        "longitude": "-102.42417000"
                    },
                    {
                        "id": 142246,
                        "name": "Carrizal",
                        "latitude": "22.21306000",
                        "longitude": "-104.30389000"
                    },
                    {
                        "id": 142247,
                        "name": "Casa de Teja",
                        "latitude": "20.45639000",
                        "longitude": "-103.13583000"
                    },
                    {
                        "id": 142248,
                        "name": "Casas Viejas",
                        "latitude": "21.18972000",
                        "longitude": "-102.25389000"
                    },
                    {
                        "id": 142249,
                        "name": "Casimiro Castillo",
                        "latitude": "19.60429000",
                        "longitude": "-104.43572000"
                    },
                    {
                        "id": 142250,
                        "name": "Castro Urdiales",
                        "latitude": "20.59754000",
                        "longitude": "-103.82046000"
                    },
                    {
                        "id": 142256,
                        "name": "Ceja de Bolitas",
                        "latitude": "21.31083000",
                        "longitude": "-102.02861000"
                    },
                    {
                        "id": 142257,
                        "name": "Centro de Readaptación Social",
                        "latitude": "20.55444000",
                        "longitude": "-103.19361000"
                    },
                    {
                        "id": 142258,
                        "name": "Cerrito de Buenos Aires",
                        "latitude": "20.52778000",
                        "longitude": "-102.93889000"
                    },
                    {
                        "id": 142259,
                        "name": "Cerrito de Tierra",
                        "latitude": "20.88861000",
                        "longitude": "-103.10389000"
                    },
                    {
                        "id": 142260,
                        "name": "Cerro Santa Fe",
                        "latitude": "20.52599000",
                        "longitude": "-103.08448000"
                    },
                    {
                        "id": 142261,
                        "name": "Chacala",
                        "latitude": "20.42833000",
                        "longitude": "-105.46778000"
                    },
                    {
                        "id": 142262,
                        "name": "Chachahuatlán",
                        "latitude": "19.63361000",
                        "longitude": "-103.98750000"
                    },
                    {
                        "id": 142263,
                        "name": "Chalpicote",
                        "latitude": "20.30972000",
                        "longitude": "-102.91615000"
                    },
                    {
                        "id": 142264,
                        "name": "Chamacuero",
                        "latitude": "20.10793000",
                        "longitude": "-103.29326000"
                    },
                    {
                        "id": 142265,
                        "name": "Chamela Jalisco",
                        "latitude": "19.52722222",
                        "longitude": "-105.07333333"
                    },
                    {
                        "id": 142266,
                        "name": "Chancol",
                        "latitude": "19.48056000",
                        "longitude": "-104.17194000"
                    },
                    {
                        "id": 142267,
                        "name": "Chancuellar",
                        "latitude": "19.50972000",
                        "longitude": "-103.83111000"
                    },
                    {
                        "id": 142268,
                        "name": "Chapala",
                        "latitude": "20.29333333",
                        "longitude": "-103.18972222"
                    },
                    {
                        "id": 142269,
                        "name": "Chayotillo",
                        "latitude": "21.74972000",
                        "longitude": "-101.93861000"
                    },
                    {
                        "id": 142270,
                        "name": "Chilacayote",
                        "latitude": "20.13861000",
                        "longitude": "-104.64861000"
                    },
                    {
                        "id": 142271,
                        "name": "Chimaltitán",
                        "latitude": "21.74805556",
                        "longitude": "-103.69472222"
                    },
                    {
                        "id": 142272,
                        "name": "Chinampas",
                        "latitude": "21.83686000",
                        "longitude": "-101.81564000"
                    },
                    {
                        "id": 142273,
                        "name": "Chipinque de Arriba",
                        "latitude": "21.43194000",
                        "longitude": "-101.90667000"
                    },
                    {
                        "id": 142274,
                        "name": "Chiquihuitillo",
                        "latitude": "20.74556000",
                        "longitude": "-102.98722000"
                    },
                    {
                        "id": 142275,
                        "name": "Chiquilistlán",
                        "latitude": "20.20000000",
                        "longitude": "-103.81667000"
                    },
                    {
                        "id": 142276,
                        "name": "Chiquilistlán Jalisco",
                        "latitude": "20.08555556",
                        "longitude": "-103.89388889"
                    },
                    {
                        "id": 142277,
                        "name": "Chome",
                        "latitude": "20.89528000",
                        "longitude": "-103.73528000"
                    },
                    {
                        "id": 142278,
                        "name": "Churintzio",
                        "latitude": "21.26167000",
                        "longitude": "-102.01444000"
                    },
                    {
                        "id": 142284,
                        "name": "Ciénega de Galvanes",
                        "latitude": "20.57500000",
                        "longitude": "-101.97000000"
                    },
                    {
                        "id": 142285,
                        "name": "Ciénega del Pastor",
                        "latitude": "20.52060000",
                        "longitude": "-102.65710000"
                    },
                    {
                        "id": 142279,
                        "name": "Cihuatlán Jalisco",
                        "latitude": "19.25000000",
                        "longitude": "-104.56666667"
                    },
                    {
                        "id": 142280,
                        "name": "Cima del Sol",
                        "latitude": "20.46889000",
                        "longitude": "-103.41722000"
                    },
                    {
                        "id": 142281,
                        "name": "Citala",
                        "latitude": "20.10454000",
                        "longitude": "-103.26194000"
                    },
                    {
                        "id": 142282,
                        "name": "Ciudad Guzmán",
                        "latitude": "19.70861111",
                        "longitude": "-103.46416667"
                    },
                    {
                        "id": 142283,
                        "name": "Ciudad Guzmán CERESO",
                        "latitude": "19.65194000",
                        "longitude": "-103.50000000"
                    },
                    {
                        "id": 142286,
                        "name": "Coamostita",
                        "latitude": "21.92833000",
                        "longitude": "-103.99083000"
                    },
                    {
                        "id": 142287,
                        "name": "Coatlancillo",
                        "latitude": "19.89314000",
                        "longitude": "-103.96414000"
                    },
                    {
                        "id": 142288,
                        "name": "Cocuasco",
                        "latitude": "21.83444000",
                        "longitude": "-103.64389000"
                    },
                    {
                        "id": 142289,
                        "name": "Cocula Jalisco",
                        "latitude": "20.36516667",
                        "longitude": "-103.82214167"
                    },
                    {
                        "id": 142290,
                        "name": "Codorniz",
                        "latitude": "22.14528000",
                        "longitude": "-104.31694000"
                    },
                    {
                        "id": 142291,
                        "name": "Cofradía",
                        "latitude": "19.51667000",
                        "longitude": "-104.71667000"
                    },
                    {
                        "id": 142292,
                        "name": "Cofradía Santa Cruz de Camotlán",
                        "latitude": "20.93086000",
                        "longitude": "-104.64303000"
                    },
                    {
                        "id": 142293,
                        "name": "Colinas del Roble",
                        "latitude": "20.50417000",
                        "longitude": "-103.39833000"
                    },
                    {
                        "id": 142294,
                        "name": "Colinas del Valle",
                        "latitude": "20.75694000",
                        "longitude": "-105.15917000"
                    },
                    {
                        "id": 142295,
                        "name": "Colonia Agua Caliente",
                        "latitude": "21.37778000",
                        "longitude": "-101.91611000"
                    },
                    {
                        "id": 142296,
                        "name": "Colonia Bosques del Sol",
                        "latitude": "20.59944000",
                        "longitude": "-103.21778000"
                    },
                    {
                        "id": 142297,
                        "name": "Colonia Capilla de Rayo",
                        "latitude": "20.14806000",
                        "longitude": "-104.34639000"
                    },
                    {
                        "id": 142298,
                        "name": "Colonia Cuisillos",
                        "latitude": "20.72417000",
                        "longitude": "-103.65528000"
                    },
                    {
                        "id": 142299,
                        "name": "Colonia Ganadera",
                        "latitude": "21.15611000",
                        "longitude": "-102.89944000"
                    },
                    {
                        "id": 142300,
                        "name": "Colonia Guadalupana",
                        "latitude": "20.56667000",
                        "longitude": "-103.21889000"
                    },
                    {
                        "id": 142301,
                        "name": "Colonia Hatmasie",
                        "latitude": "22.39278000",
                        "longitude": "-103.99111000"
                    },
                    {
                        "id": 142313,
                        "name": "Colonia la Granjena",
                        "latitude": "20.35167000",
                        "longitude": "-102.79639000"
                    },
                    {
                        "id": 142314,
                        "name": "Colonia las Granjas",
                        "latitude": "22.61583000",
                        "longitude": "-103.89639000"
                    },
                    {
                        "id": 142315,
                        "name": "Colonia las Palmas Campamento SAGAR",
                        "latitude": "19.97139000",
                        "longitude": "-105.32389000"
                    },
                    {
                        "id": 142303,
                        "name": "Colonia Lázaro Cárdenas",
                        "latitude": "20.42778000",
                        "longitude": "-103.68083000"
                    },
                    {
                        "id": 142304,
                        "name": "Colonia Lázaro Cárdenas del Río",
                        "latitude": "19.98917000",
                        "longitude": "-103.25583000"
                    },
                    {
                        "id": 142302,
                        "name": "Colonia Loma Alta",
                        "latitude": "19.44583000",
                        "longitude": "-104.36556000"
                    },
                    {
                        "id": 142316,
                        "name": "Colonia los Robles",
                        "latitude": "20.59194000",
                        "longitude": "-105.21500000"
                    },
                    {
                        "id": 142317,
                        "name": "Colonia los Sauces",
                        "latitude": "20.55028000",
                        "longitude": "-103.35167000"
                    },
                    {
                        "id": 142305,
                        "name": "Colonia Madero",
                        "latitude": "20.07056000",
                        "longitude": "-103.08917000"
                    },
                    {
                        "id": 142306,
                        "name": "Colonia Niños Héroes",
                        "latitude": "20.55917000",
                        "longitude": "-103.43083000"
                    },
                    {
                        "id": 142307,
                        "name": "Colonia Paso del Molino",
                        "latitude": "20.59278000",
                        "longitude": "-105.21833000"
                    },
                    {
                        "id": 142308,
                        "name": "Colonia Pinal Villa",
                        "latitude": "19.23806000",
                        "longitude": "-104.69389000"
                    },
                    {
                        "id": 142309,
                        "name": "Colonia Santa Cecilia",
                        "latitude": "21.25250000",
                        "longitude": "-102.35139000"
                    },
                    {
                        "id": 142310,
                        "name": "Colonia Trigomil",
                        "latitude": "19.94222000",
                        "longitude": "-104.24917000"
                    },
                    {
                        "id": 142311,
                        "name": "Colonia Veintitrés de Mayo",
                        "latitude": "21.01000000",
                        "longitude": "-102.19778000"
                    },
                    {
                        "id": 142312,
                        "name": "Colonia Veintiuno de Marzo",
                        "latitude": "22.23710000",
                        "longitude": "-103.08390000"
                    },
                    {
                        "id": 142318,
                        "name": "Colotlán",
                        "latitude": "22.11343000",
                        "longitude": "-103.26664000"
                    },
                    {
                        "id": 142319,
                        "name": "Colotlán Municipality",
                        "latitude": "22.20000000",
                        "longitude": "-103.30000000"
                    },
                    {
                        "id": 142320,
                        "name": "Comanja de Corona",
                        "latitude": "21.32520000",
                        "longitude": "-101.71379000"
                    },
                    {
                        "id": 142321,
                        "name": "Concepción de Buenos Aires",
                        "latitude": "19.86666667",
                        "longitude": "-103.15000000"
                    },
                    {
                        "id": 142322,
                        "name": "Concepción del Bramador",
                        "latitude": "20.24460000",
                        "longitude": "-105.07807000"
                    },
                    {
                        "id": 142342,
                        "name": "Cópala",
                        "latitude": "19.92333000",
                        "longitude": "-103.74806000"
                    },
                    {
                        "id": 142323,
                        "name": "Copales",
                        "latitude": "20.85278000",
                        "longitude": "-104.74778000"
                    },
                    {
                        "id": 142324,
                        "name": "Corral Blanco",
                        "latitude": "21.56778000",
                        "longitude": "-102.37139000"
                    },
                    {
                        "id": 142325,
                        "name": "Corral de Piedra",
                        "latitude": "21.48333000",
                        "longitude": "-102.11806000"
                    },
                    {
                        "id": 142326,
                        "name": "Corralillos",
                        "latitude": "20.64944000",
                        "longitude": "-102.91056000"
                    },
                    {
                        "id": 142327,
                        "name": "Coyamel",
                        "latitude": "19.49806000",
                        "longitude": "-104.52306000"
                    },
                    {
                        "id": 142328,
                        "name": "Coyula",
                        "latitude": "20.65881000",
                        "longitude": "-103.22654000"
                    },
                    {
                        "id": 142329,
                        "name": "Cristeros Fraccionamiento",
                        "latitude": "21.32111000",
                        "longitude": "-101.97333000"
                    },
                    {
                        "id": 142330,
                        "name": "Cuauhtémoc",
                        "latitude": "19.63306000",
                        "longitude": "-103.92722000"
                    },
                    {
                        "id": 142331,
                        "name": "Cuautitlán",
                        "latitude": "21.73639000",
                        "longitude": "-101.96917000"
                    },
                    {
                        "id": 142332,
                        "name": "Cuautitlán de García Barragán",
                        "latitude": "19.43333333",
                        "longitude": "-104.30000000"
                    },
                    {
                        "id": 142333,
                        "name": "Cuautla",
                        "latitude": "20.20139000",
                        "longitude": "-104.40750000"
                    },
                    {
                        "id": 142334,
                        "name": "Cuesta Chica",
                        "latitude": "20.56444000",
                        "longitude": "-102.67167000"
                    },
                    {
                        "id": 142335,
                        "name": "Cuesta de Ovejas",
                        "latitude": "20.55222000",
                        "longitude": "-102.66750000"
                    },
                    {
                        "id": 142336,
                        "name": "Cuexcomatitlán",
                        "latitude": "20.42810000",
                        "longitude": "-103.36189000"
                    },
                    {
                        "id": 142337,
                        "name": "Cuisillos",
                        "latitude": "20.60948000",
                        "longitude": "-103.77441000"
                    },
                    {
                        "id": 142338,
                        "name": "Cuitzeo",
                        "latitude": "20.34278000",
                        "longitude": "-102.78389000"
                    },
                    {
                        "id": 142339,
                        "name": "Cuquío",
                        "latitude": "20.92750000",
                        "longitude": "-103.02388889"
                    },
                    {
                        "id": 142340,
                        "name": "Custique",
                        "latitude": "21.62000000",
                        "longitude": "-102.49111000"
                    },
                    {
                        "id": 142341,
                        "name": "Cuxpala",
                        "latitude": "20.55935000",
                        "longitude": "-103.64510000"
                    },
                    {
                        "id": 142343,
                        "name": "Degollado",
                        "latitude": "20.46702000",
                        "longitude": "-102.14976000"
                    },
                    {
                        "id": 142344,
                        "name": "Dieciocho de Marzo",
                        "latitude": "21.48238000",
                        "longitude": "-101.79880000"
                    },
                    {
                        "id": 142345,
                        "name": "Ejido Agua Zarca",
                        "latitude": "19.83611000",
                        "longitude": "-103.26917000"
                    },
                    {
                        "id": 142346,
                        "name": "Ejido Ciénega de Mora",
                        "latitude": "21.50389000",
                        "longitude": "-102.35000000"
                    },
                    {
                        "id": 142347,
                        "name": "Ejido Modelo",
                        "latitude": "19.53750000",
                        "longitude": "-104.51361000"
                    },
                    {
                        "id": 142348,
                        "name": "Ejido Poblado Atenquique",
                        "latitude": "19.56639000",
                        "longitude": "-103.51722000"
                    },
                    {
                        "id": 142349,
                        "name": "Ejido Uno de Febrero",
                        "latitude": "19.81417000",
                        "longitude": "-103.49139000"
                    },
                    {
                        "id": 142350,
                        "name": "Ejutla",
                        "latitude": "19.90000000",
                        "longitude": "-104.15000000"
                    },
                    {
                        "id": 142351,
                        "name": "El Agostadero",
                        "latitude": "19.14493000",
                        "longitude": "-103.38721000"
                    },
                    {
                        "id": 142352,
                        "name": "El Aguacate",
                        "latitude": "20.70172000",
                        "longitude": "-103.20799000"
                    },
                    {
                        "id": 142353,
                        "name": "El Alto",
                        "latitude": "20.77472000",
                        "longitude": "-102.49583000"
                    },
                    {
                        "id": 142354,
                        "name": "El Amarillo",
                        "latitude": "20.91333000",
                        "longitude": "-103.72500000"
                    },
                    {
                        "id": 142355,
                        "name": "El Amarradero",
                        "latitude": "20.65306000",
                        "longitude": "-102.01278000"
                    },
                    {
                        "id": 142356,
                        "name": "El Arca",
                        "latitude": "20.37167000",
                        "longitude": "-102.17611000"
                    },
                    {
                        "id": 142357,
                        "name": "El Arco Ameca",
                        "latitude": "20.60944000",
                        "longitude": "-104.07333000"
                    },
                    {
                        "id": 142358,
                        "name": "El Arenal",
                        "latitude": "20.77538000",
                        "longitude": "-103.69353000"
                    },
                    {
                        "id": 142359,
                        "name": "El Asoleadero",
                        "latitude": "21.36389000",
                        "longitude": "-102.38222000"
                    },
                    {
                        "id": 142360,
                        "name": "El Bajío",
                        "latitude": "21.37944000",
                        "longitude": "-101.95028000"
                    },
                    {
                        "id": 142362,
                        "name": "El Bajío de Plascencia",
                        "latitude": "20.71583000",
                        "longitude": "-102.79278000"
                    },
                    {
                        "id": 142361,
                        "name": "El Bajío Lomas del Club",
                        "latitude": "20.58361000",
                        "longitude": "-103.29583000"
                    },
                    {
                        "id": 142363,
                        "name": "El Banco del Venado",
                        "latitude": "21.85083000",
                        "longitude": "-103.98722000"
                    },
                    {
                        "id": 142364,
                        "name": "El Barrio",
                        "latitude": "21.40056000",
                        "longitude": "-102.55444000"
                    },
                    {
                        "id": 142365,
                        "name": "El Brillante Fraccionamiento",
                        "latitude": "20.55750000",
                        "longitude": "-104.03194000"
                    },
                    {
                        "id": 142366,
                        "name": "El Briseño",
                        "latitude": "20.23889000",
                        "longitude": "-103.59500000"
                    },
                    {
                        "id": 142367,
                        "name": "El Cabezón",
                        "latitude": "20.49569000",
                        "longitude": "-103.95144000"
                    },
                    {
                        "id": 142368,
                        "name": "El Cacalote",
                        "latitude": "19.84417000",
                        "longitude": "-104.28083000"
                    },
                    {
                        "id": 142369,
                        "name": "El Camichín",
                        "latitude": "19.64194000",
                        "longitude": "-104.04452000"
                    },
                    {
                        "id": 142370,
                        "name": "El Cantón",
                        "latitude": "20.74268000",
                        "longitude": "-105.18052000"
                    },
                    {
                        "id": 142371,
                        "name": "El Capulín de Chávez",
                        "latitude": "20.65806000",
                        "longitude": "-102.20583000"
                    },
                    {
                        "id": 142372,
                        "name": "El Carmen",
                        "latitude": "21.70111000",
                        "longitude": "-101.99250000"
                    },
                    {
                        "id": 142373,
                        "name": "El Carricillo",
                        "latitude": "20.73000000",
                        "longitude": "-103.03056000"
                    },
                    {
                        "id": 142374,
                        "name": "El Carrizal",
                        "latitude": "19.99750000",
                        "longitude": "-103.38750000"
                    },
                    {
                        "id": 142375,
                        "name": "El Cedazo",
                        "latitude": "20.70583000",
                        "longitude": "-102.69222000"
                    },
                    {
                        "id": 142376,
                        "name": "El Cerrito",
                        "latitude": "19.85394000",
                        "longitude": "-103.93187000"
                    },
                    {
                        "id": 142377,
                        "name": "El Cerro Jalisco",
                        "latitude": "22.18639000",
                        "longitude": "-103.39944000"
                    },
                    {
                        "id": 142378,
                        "name": "El Chalate",
                        "latitude": "22.13556000",
                        "longitude": "-104.27944000"
                    },
                    {
                        "id": 142379,
                        "name": "El Chante",
                        "latitude": "19.71800000",
                        "longitude": "-104.20025000"
                    },
                    {
                        "id": 142380,
                        "name": "El Chaveño",
                        "latitude": "20.44056000",
                        "longitude": "-102.31333000"
                    },
                    {
                        "id": 142381,
                        "name": "El Chilar",
                        "latitude": "20.83667000",
                        "longitude": "-103.29528000"
                    },
                    {
                        "id": 142382,
                        "name": "El Chispeadero",
                        "latitude": "20.77083000",
                        "longitude": "-102.80000000"
                    },
                    {
                        "id": 142383,
                        "name": "El Chivatillo",
                        "latitude": "20.29733000",
                        "longitude": "-103.78934000"
                    },
                    {
                        "id": 142384,
                        "name": "El Coahuayote",
                        "latitude": "19.61028000",
                        "longitude": "-103.35611000"
                    },
                    {
                        "id": 142385,
                        "name": "El Colomo",
                        "latitude": "20.86962000",
                        "longitude": "-105.15597000"
                    },
                    {
                        "id": 142386,
                        "name": "El Colorado",
                        "latitude": "20.77029000",
                        "longitude": "-105.15651000"
                    },
                    {
                        "id": 142387,
                        "name": "El Columpio",
                        "latitude": "20.39861000",
                        "longitude": "-105.31056000"
                    },
                    {
                        "id": 142388,
                        "name": "El Conde",
                        "latitude": "20.38250000",
                        "longitude": "-103.85389000"
                    },
                    {
                        "id": 142389,
                        "name": "El Conejo",
                        "latitude": "21.46528000",
                        "longitude": "-101.86944000"
                    },
                    {
                        "id": 142390,
                        "name": "El Corcovado",
                        "latitude": "19.84525000",
                        "longitude": "-104.28566000"
                    },
                    {
                        "id": 142391,
                        "name": "El Cortijo",
                        "latitude": "20.46917000",
                        "longitude": "-103.42194000"
                    },
                    {
                        "id": 142392,
                        "name": "El Coyotillo",
                        "latitude": "20.94611000",
                        "longitude": "-103.11250000"
                    },
                    {
                        "id": 142393,
                        "name": "El Crucero",
                        "latitude": "20.73306000",
                        "longitude": "-103.60333000"
                    },
                    {
                        "id": 142394,
                        "name": "El Crucero de Arandas",
                        "latitude": "20.88861000",
                        "longitude": "-102.70972000"
                    },
                    {
                        "id": 142395,
                        "name": "El Crucero de Santa María",
                        "latitude": "20.38398611",
                        "longitude": "-103.86053333"
                    },
                    {
                        "id": 142396,
                        "name": "El Cuatro",
                        "latitude": "20.85611000",
                        "longitude": "-103.02583000"
                    },
                    {
                        "id": 142397,
                        "name": "El Derramadero",
                        "latitude": "21.00417000",
                        "longitude": "-102.97472000"
                    },
                    {
                        "id": 142398,
                        "name": "El Dique",
                        "latitude": "20.45694000",
                        "longitude": "-102.73861000"
                    },
                    {
                        "id": 142399,
                        "name": "El Fraile",
                        "latitude": "22.26646000",
                        "longitude": "-103.23881000"
                    },
                    {
                        "id": 142400,
                        "name": "El Gato",
                        "latitude": "20.60444000",
                        "longitude": "-102.89722000"
                    },
                    {
                        "id": 142401,
                        "name": "El Grullo Municipality",
                        "latitude": "19.79388889",
                        "longitude": "-104.20166667"
                    },
                    {
                        "id": 142402,
                        "name": "El Hollejo",
                        "latitude": "20.63750000",
                        "longitude": "-104.50389000"
                    },
                    {
                        "id": 142403,
                        "name": "El Huiroche",
                        "latitude": "21.77722000",
                        "longitude": "-102.00583000"
                    },
                    {
                        "id": 142404,
                        "name": "El Jabalí",
                        "latitude": "20.46583000",
                        "longitude": "-102.97528000"
                    },
                    {
                        "id": 142405,
                        "name": "El Jagüey",
                        "latitude": "20.92889000",
                        "longitude": "-103.19611000"
                    },
                    {
                        "id": 142406,
                        "name": "El Jaral",
                        "latitude": "21.17444000",
                        "longitude": "-101.97139000"
                    },
                    {
                        "id": 142407,
                        "name": "El Jaralillo",
                        "latitude": "21.64056000",
                        "longitude": "-102.27278000"
                    },
                    {
                        "id": 142408,
                        "name": "El Jaralito",
                        "latitude": "21.44389000",
                        "longitude": "-101.80556000"
                    },
                    {
                        "id": 142409,
                        "name": "El Jardín",
                        "latitude": "19.77528000",
                        "longitude": "-103.89667000"
                    },
                    {
                        "id": 142410,
                        "name": "El Jazmín",
                        "latitude": "19.65344000",
                        "longitude": "-103.71006000"
                    },
                    {
                        "id": 142411,
                        "name": "El Jomate",
                        "latitude": "21.81278000",
                        "longitude": "-104.16111000"
                    },
                    {
                        "id": 142412,
                        "name": "El Laurel",
                        "latitude": "20.63194000",
                        "longitude": "-102.38889000"
                    },
                    {
                        "id": 142413,
                        "name": "El Lazo",
                        "latitude": "20.79639000",
                        "longitude": "-103.32806000"
                    },
                    {
                        "id": 142414,
                        "name": "El Limón",
                        "latitude": "19.75000000",
                        "longitude": "-104.01666667"
                    },
                    {
                        "id": 142415,
                        "name": "El Llano de Barajas",
                        "latitude": "20.87583000",
                        "longitude": "-103.03722000"
                    },
                    {
                        "id": 142417,
                        "name": "El Llano de los Toros",
                        "latitude": "19.93500000",
                        "longitude": "-103.00944000"
                    },
                    {
                        "id": 142416,
                        "name": "El Llano de Plascencia",
                        "latitude": "20.92889000",
                        "longitude": "-103.09917000"
                    },
                    {
                        "id": 142418,
                        "name": "El Lobo",
                        "latitude": "21.17361000",
                        "longitude": "-101.79361000"
                    },
                    {
                        "id": 142419,
                        "name": "El Lopeño",
                        "latitude": "20.39639000",
                        "longitude": "-102.56139000"
                    },
                    {
                        "id": 142420,
                        "name": "El Loreto Occidental",
                        "latitude": "20.34222000",
                        "longitude": "-102.47093000"
                    },
                    {
                        "id": 142421,
                        "name": "El Macuchi",
                        "latitude": "20.37882000",
                        "longitude": "-104.26388000"
                    },
                    {
                        "id": 142422,
                        "name": "El Maestranzo",
                        "latitude": "20.72444000",
                        "longitude": "-103.14528000"
                    },
                    {
                        "id": 142423,
                        "name": "El Manantial",
                        "latitude": "20.52694000",
                        "longitude": "-103.35750000"
                    },
                    {
                        "id": 142424,
                        "name": "El Mastranzo",
                        "latitude": "20.88917000",
                        "longitude": "-102.39528000"
                    },
                    {
                        "id": 142425,
                        "name": "El Mayoral de Abajo",
                        "latitude": "21.21056000",
                        "longitude": "-102.45222000"
                    },
                    {
                        "id": 142426,
                        "name": "El Medineño",
                        "latitude": "20.86722000",
                        "longitude": "-103.77917000"
                    },
                    {
                        "id": 142427,
                        "name": "El Mentidero",
                        "latitude": "19.77070000",
                        "longitude": "-104.29313000"
                    },
                    {
                        "id": 142428,
                        "name": "El Mesoncito",
                        "latitude": "21.41583000",
                        "longitude": "-101.85250000"
                    },
                    {
                        "id": 142429,
                        "name": "El Mezquite Grande",
                        "latitude": "20.68611000",
                        "longitude": "-103.12583000"
                    },
                    {
                        "id": 142430,
                        "name": "El Mirador",
                        "latitude": "21.16722000",
                        "longitude": "-102.87111000"
                    },
                    {
                        "id": 142431,
                        "name": "El Molino",
                        "latitude": "22.01750000",
                        "longitude": "-101.85389000"
                    },
                    {
                        "id": 142432,
                        "name": "El Moral",
                        "latitude": "19.92667000",
                        "longitude": "-102.93750000"
                    },
                    {
                        "id": 142433,
                        "name": "El Muey",
                        "latitude": "20.50278000",
                        "longitude": "-103.22083000"
                    },
                    {
                        "id": 142434,
                        "name": "El Nacimiento",
                        "latitude": "20.53828000",
                        "longitude": "-102.55107000"
                    },
                    {
                        "id": 142435,
                        "name": "El Nacimiento de Abajo",
                        "latitude": "20.65361000",
                        "longitude": "-102.28444000"
                    },
                    {
                        "id": 142436,
                        "name": "El Naranjo",
                        "latitude": "20.53417000",
                        "longitude": "-104.06028000"
                    },
                    {
                        "id": 142437,
                        "name": "El Nuevo Poblado",
                        "latitude": "19.52778000",
                        "longitude": "-103.40111000"
                    },
                    {
                        "id": 142438,
                        "name": "El Ocote",
                        "latitude": "20.74028000",
                        "longitude": "-102.51556000"
                    },
                    {
                        "id": 142439,
                        "name": "El Ocotillo",
                        "latitude": "20.60306000",
                        "longitude": "-103.20722000"
                    },
                    {
                        "id": 142440,
                        "name": "El Ojo de Agua",
                        "latitude": "20.66361000",
                        "longitude": "-102.35500000"
                    },
                    {
                        "id": 142441,
                        "name": "El Ojuelo",
                        "latitude": "21.40167000",
                        "longitude": "-101.83750000"
                    },
                    {
                        "id": 142442,
                        "name": "El Olvido",
                        "latitude": "20.96583000",
                        "longitude": "-103.65556000"
                    },
                    {
                        "id": 142443,
                        "name": "El Padre Juan",
                        "latitude": "21.36000000",
                        "longitude": "-102.36583000"
                    },
                    {
                        "id": 142444,
                        "name": "El Palmar de San Antonio",
                        "latitude": "19.89083000",
                        "longitude": "-104.03972000"
                    },
                    {
                        "id": 142445,
                        "name": "El Pantano",
                        "latitude": "20.58000000",
                        "longitude": "-104.75472000"
                    },
                    {
                        "id": 142446,
                        "name": "El Paso Real",
                        "latitude": "19.60457000",
                        "longitude": "-103.95977000"
                    },
                    {
                        "id": 142447,
                        "name": "El Pino",
                        "latitude": "20.57667000",
                        "longitude": "-103.39389000"
                    },
                    {
                        "id": 142448,
                        "name": "El Plan",
                        "latitude": "20.41836000",
                        "longitude": "-103.60667000"
                    },
                    {
                        "id": 142449,
                        "name": "El Platanar",
                        "latitude": "20.44387000",
                        "longitude": "-103.05006000"
                    },
                    {
                        "id": 142450,
                        "name": "El Pochote",
                        "latitude": "20.81778000",
                        "longitude": "-102.80639000"
                    },
                    {
                        "id": 142451,
                        "name": "El Popote",
                        "latitude": "21.91639000",
                        "longitude": "-104.16972000"
                    },
                    {
                        "id": 142452,
                        "name": "El Portezuelo",
                        "latitude": "20.60004000",
                        "longitude": "-104.04624000"
                    },
                    {
                        "id": 142453,
                        "name": "El Porvenir",
                        "latitude": "20.75379000",
                        "longitude": "-105.24196000"
                    },
                    {
                        "id": 142454,
                        "name": "El Pozo Santo",
                        "latitude": "19.32611000",
                        "longitude": "-103.38611000"
                    },
                    {
                        "id": 142455,
                        "name": "El Pueblito",
                        "latitude": "21.46250000",
                        "longitude": "-102.46056000"
                    },
                    {
                        "id": 142456,
                        "name": "El Puente",
                        "latitude": "21.76389000",
                        "longitude": "-102.02306000"
                    },
                    {
                        "id": 142457,
                        "name": "El Puerto",
                        "latitude": "20.49222000",
                        "longitude": "-103.45944000"
                    },
                    {
                        "id": 142458,
                        "name": "El Puerto de Amolero",
                        "latitude": "20.96639000",
                        "longitude": "-102.12889000"
                    },
                    {
                        "id": 142459,
                        "name": "El Puesto",
                        "latitude": "21.62448000",
                        "longitude": "-101.96540000"
                    },
                    {
                        "id": 142460,
                        "name": "El Quemado",
                        "latitude": "20.79639000",
                        "longitude": "-103.42722000"
                    },
                    {
                        "id": 142461,
                        "name": "El Quince",
                        "latitude": "20.54388000",
                        "longitude": "-103.28467000"
                    },
                    {
                        "id": 142462,
                        "name": "El Ranchito",
                        "latitude": "20.07806000",
                        "longitude": "-103.86861000"
                    },
                    {
                        "id": 142463,
                        "name": "El Rayo",
                        "latitude": "19.38083000",
                        "longitude": "-103.16028000"
                    },
                    {
                        "id": 142464,
                        "name": "El Rebalse",
                        "latitude": "19.18750000",
                        "longitude": "-104.59352000"
                    },
                    {
                        "id": 142465,
                        "name": "El Rebalsito de Apazulco",
                        "latitude": "19.30556000",
                        "longitude": "-104.88667000"
                    },
                    {
                        "id": 142466,
                        "name": "El Refugio",
                        "latitude": "20.12231000",
                        "longitude": "-103.14516000"
                    },
                    {
                        "id": 142469,
                        "name": "El Refugio de los Altos",
                        "latitude": "20.63083000",
                        "longitude": "-102.57944000"
                    },
                    {
                        "id": 142468,
                        "name": "El Refugio de Vázquez",
                        "latitude": "20.39806000",
                        "longitude": "-102.19306000"
                    },
                    {
                        "id": 142470,
                        "name": "El Refugio Jalisco",
                        "latitude": "20.11670000",
                        "longitude": "-103.13300000"
                    },
                    {
                        "id": 142467,
                        "name": "El Refugio Suchitlán",
                        "latitude": "20.44333000",
                        "longitude": "-105.54583000"
                    },
                    {
                        "id": 142471,
                        "name": "El Reparo",
                        "latitude": "21.79028000",
                        "longitude": "-102.04944000"
                    },
                    {
                        "id": 142472,
                        "name": "El Rincón",
                        "latitude": "19.34083000",
                        "longitude": "-103.08972000"
                    },
                    {
                        "id": 142473,
                        "name": "El Rodeo",
                        "latitude": "19.58194000",
                        "longitude": "-103.18611000"
                    },
                    {
                        "id": 142474,
                        "name": "El Rodeo Viejo",
                        "latitude": "20.20417000",
                        "longitude": "-103.86500000"
                    },
                    {
                        "id": 142475,
                        "name": "El Romereño",
                        "latitude": "20.38083000",
                        "longitude": "-102.94944000"
                    },
                    {
                        "id": 142476,
                        "name": "El Rosario",
                        "latitude": "21.04528000",
                        "longitude": "-102.58944000"
                    },
                    {
                        "id": 142477,
                        "name": "El Sabino",
                        "latitude": "22.61528000",
                        "longitude": "-103.90389000"
                    },
                    {
                        "id": 142478,
                        "name": "El Sacrificio",
                        "latitude": "20.40806000",
                        "longitude": "-103.19667000"
                    },
                    {
                        "id": 142479,
                        "name": "El Salero",
                        "latitude": "20.76250000",
                        "longitude": "-102.50917000"
                    },
                    {
                        "id": 142480,
                        "name": "El Salitre",
                        "latitude": "20.51000000",
                        "longitude": "-103.85800000"
                    },
                    {
                        "id": 142481,
                        "name": "El Salto",
                        "latitude": "20.33333000",
                        "longitude": "-104.50000000"
                    },
                    {
                        "id": 142484,
                        "name": "El Salto de las Peñas",
                        "latitude": "20.65250000",
                        "longitude": "-103.04222000"
                    },
                    {
                        "id": 142483,
                        "name": "El Salto de San Antonio",
                        "latitude": "21.17833000",
                        "longitude": "-101.82389000"
                    },
                    {
                        "id": 142482,
                        "name": "El Salto Municipality",
                        "latitude": "20.51666667",
                        "longitude": "-103.18333333"
                    },
                    {
                        "id": 142485,
                        "name": "El Salvador",
                        "latitude": "21.01659000",
                        "longitude": "-103.71568000"
                    },
                    {
                        "id": 142486,
                        "name": "El Salvial",
                        "latitude": "20.83917000",
                        "longitude": "-103.26306000"
                    },
                    {
                        "id": 142487,
                        "name": "El Saucillo",
                        "latitude": "20.31389000",
                        "longitude": "-103.91333000"
                    },
                    {
                        "id": 142488,
                        "name": "El Saucillo de los Pérez",
                        "latitude": "22.02861000",
                        "longitude": "-103.23444000"
                    },
                    {
                        "id": 142489,
                        "name": "El Saucito",
                        "latitude": "20.73194000",
                        "longitude": "-102.50889000"
                    },
                    {
                        "id": 142490,
                        "name": "El Sauz de Ibarra",
                        "latitude": "21.33083000",
                        "longitude": "-102.23222000"
                    },
                    {
                        "id": 142491,
                        "name": "El Seminario",
                        "latitude": "21.27333000",
                        "longitude": "-102.30806000"
                    },
                    {
                        "id": 142492,
                        "name": "El Sitio",
                        "latitude": "21.33306000",
                        "longitude": "-102.04056000"
                    },
                    {
                        "id": 142493,
                        "name": "El Sopial",
                        "latitude": "20.58278000",
                        "longitude": "-102.62806000"
                    },
                    {
                        "id": 142494,
                        "name": "El Soyate",
                        "latitude": "21.50667000",
                        "longitude": "-101.89250000"
                    },
                    {
                        "id": 142495,
                        "name": "El Tablero",
                        "latitude": "21.47472000",
                        "longitude": "-102.41639000"
                    },
                    {
                        "id": 142496,
                        "name": "El Taray",
                        "latitude": "19.62361000",
                        "longitude": "-103.26806000"
                    },
                    {
                        "id": 142497,
                        "name": "El Tarengo Nuevo",
                        "latitude": "20.43121000",
                        "longitude": "-102.49508000"
                    },
                    {
                        "id": 142498,
                        "name": "El Tecolote",
                        "latitude": "21.20056000",
                        "longitude": "-102.24583000"
                    },
                    {
                        "id": 142499,
                        "name": "El Tecuán",
                        "latitude": "20.31389000",
                        "longitude": "-103.73083000"
                    },
                    {
                        "id": 142500,
                        "name": "El Tempisque",
                        "latitude": "20.77861000",
                        "longitude": "-103.32667000"
                    },
                    {
                        "id": 142501,
                        "name": "El Tepame",
                        "latitude": "20.56972000",
                        "longitude": "-103.19444000"
                    },
                    {
                        "id": 142502,
                        "name": "El Tepec",
                        "latitude": "21.84111000",
                        "longitude": "-103.77389000"
                    },
                    {
                        "id": 142503,
                        "name": "El Tepetate",
                        "latitude": "21.06472000",
                        "longitude": "-103.77333000"
                    },
                    {
                        "id": 142504,
                        "name": "El Tepozán",
                        "latitude": "20.79194000",
                        "longitude": "-102.52917000"
                    },
                    {
                        "id": 142505,
                        "name": "El Tequesquite",
                        "latitude": "20.06613000",
                        "longitude": "-105.30064000"
                    },
                    {
                        "id": 142506,
                        "name": "El Terrerito de Sevilla",
                        "latitude": "20.45417000",
                        "longitude": "-102.08000000"
                    },
                    {
                        "id": 142507,
                        "name": "El Terrero",
                        "latitude": "19.29917000",
                        "longitude": "-102.87806000"
                    },
                    {
                        "id": 142508,
                        "name": "El Torque",
                        "latitude": "21.37056000",
                        "longitude": "-102.36667000"
                    },
                    {
                        "id": 142509,
                        "name": "El Torreón",
                        "latitude": "21.78583000",
                        "longitude": "-102.00139000"
                    },
                    {
                        "id": 142510,
                        "name": "El Tuito",
                        "latitude": "20.32042000",
                        "longitude": "-105.32469000"
                    },
                    {
                        "id": 142511,
                        "name": "El Tule",
                        "latitude": "20.71667000",
                        "longitude": "-102.44083000"
                    },
                    {
                        "id": 142512,
                        "name": "El Tulillo",
                        "latitude": "21.20472000",
                        "longitude": "-102.90222000"
                    },
                    {
                        "id": 142513,
                        "name": "El Uvalano",
                        "latitude": "20.43861000",
                        "longitude": "-102.79028000"
                    },
                    {
                        "id": 142514,
                        "name": "El Verde",
                        "latitude": "20.55567000",
                        "longitude": "-103.27901000"
                    },
                    {
                        "id": 142515,
                        "name": "El Vergel",
                        "latitude": "21.62139000",
                        "longitude": "-102.30639000"
                    },
                    {
                        "id": 142516,
                        "name": "El Vigía",
                        "latitude": "19.50417000",
                        "longitude": "-104.29639000"
                    },
                    {
                        "id": 142517,
                        "name": "El Zancudo",
                        "latitude": "20.77972000",
                        "longitude": "-105.15333000"
                    },
                    {
                        "id": 142518,
                        "name": "El Zapatero",
                        "latitude": "19.86778000",
                        "longitude": "-103.07556000"
                    },
                    {
                        "id": 142519,
                        "name": "El Zapote",
                        "latitude": "21.11257000",
                        "longitude": "-102.80555000"
                    },
                    {
                        "id": 142520,
                        "name": "El Zapote de Chávez",
                        "latitude": "20.21972000",
                        "longitude": "-104.32639000"
                    },
                    {
                        "id": 142521,
                        "name": "El Zapotillo",
                        "latitude": "19.96611000",
                        "longitude": "-104.39889000"
                    },
                    {
                        "id": 142522,
                        "name": "Emiliano Zapata",
                        "latitude": "19.24278000",
                        "longitude": "-104.71778000"
                    },
                    {
                        "id": 142523,
                        "name": "Emiliano Zapata Jalisco",
                        "latitude": "19.38305556",
                        "longitude": "-104.96583333"
                    },
                    {
                        "id": 142524,
                        "name": "Encarnación de Díaz",
                        "latitude": "21.51666667",
                        "longitude": "-102.23333333"
                    },
                    {
                        "id": 142525,
                        "name": "Epeche Chico",
                        "latitude": "19.93917000",
                        "longitude": "-103.01972000"
                    },
                    {
                        "id": 142526,
                        "name": "Epeche Grande",
                        "latitude": "19.92333000",
                        "longitude": "-103.10667000"
                    },
                    {
                        "id": 142528,
                        "name": "Estancia de San Nicolás",
                        "latitude": "20.38417000",
                        "longitude": "-102.83750000"
                    },
                    {
                        "id": 142527,
                        "name": "Estancia Vieja de Arriba",
                        "latitude": "21.16722000",
                        "longitude": "-102.32389000"
                    },
                    {
                        "id": 142529,
                        "name": "Estanzuela",
                        "latitude": "20.52306000",
                        "longitude": "-104.34000000"
                    },
                    {
                        "id": 142530,
                        "name": "Estipa",
                        "latitude": "20.36199000",
                        "longitude": "-103.72345000"
                    },
                    {
                        "id": 142531,
                        "name": "Etzatlán Municipality",
                        "latitude": "20.76666667",
                        "longitude": "-104.08333333"
                    },
                    {
                        "id": 142532,
                        "name": "Ferrería de Tula",
                        "latitude": "20.06529000",
                        "longitude": "-103.72980000"
                    },
                    {
                        "id": 142533,
                        "name": "Francisco I. Madero",
                        "latitude": "19.56000000",
                        "longitude": "-104.55917000"
                    },
                    {
                        "id": 142534,
                        "name": "Francisco Primo de Verdad",
                        "latitude": "21.74472000",
                        "longitude": "-101.82611000"
                    },
                    {
                        "id": 142535,
                        "name": "Galaxia Bonito Jalisco",
                        "latitude": "20.50500000",
                        "longitude": "-103.20472000"
                    },
                    {
                        "id": 142536,
                        "name": "Galaxia la Noria",
                        "latitude": "20.45722000",
                        "longitude": "-103.41889000"
                    },
                    {
                        "id": 142537,
                        "name": "Gargantillo",
                        "latitude": "20.01747000",
                        "longitude": "-105.34619000"
                    },
                    {
                        "id": 142538,
                        "name": "General Andrés Figueroa",
                        "latitude": "20.30396000",
                        "longitude": "-103.60923000"
                    },
                    {
                        "id": 142539,
                        "name": "General Gabriel Leyva",
                        "latitude": "20.42889000",
                        "longitude": "-102.47111000"
                    },
                    {
                        "id": 142540,
                        "name": "Geovillas Laureles del Campanario",
                        "latitude": "21.33056000",
                        "longitude": "-101.92361000"
                    },
                    {
                        "id": 142541,
                        "name": "Getsemaní",
                        "latitude": "20.72778000",
                        "longitude": "-105.20639000"
                    },
                    {
                        "id": 142549,
                        "name": "Gómez Farías Municipality",
                        "latitude": "19.80000000",
                        "longitude": "-103.48333333"
                    },
                    {
                        "id": 142542,
                        "name": "Granadillas",
                        "latitude": "21.37972000",
                        "longitude": "-101.90139000"
                    },
                    {
                        "id": 142543,
                        "name": "Guachinango",
                        "latitude": "20.56700000",
                        "longitude": "-104.36700000"
                    },
                    {
                        "id": 142544,
                        "name": "Guadalajara",
                        "latitude": "20.67666667",
                        "longitude": "-103.34750000"
                    },
                    {
                        "id": 142546,
                        "name": "Guadalupe de Lerma",
                        "latitude": "20.34077000",
                        "longitude": "-102.36090000"
                    },
                    {
                        "id": 142545,
                        "name": "Guadalupe Victoria",
                        "latitude": "21.70106000",
                        "longitude": "-101.61778000"
                    },
                    {
                        "id": 142547,
                        "name": "Guamuchilillo",
                        "latitude": "22.05028000",
                        "longitude": "-104.31583000"
                    },
                    {
                        "id": 142548,
                        "name": "Guayabitos",
                        "latitude": "20.42611000",
                        "longitude": "-104.73111000"
                    },
                    {
                        "id": 142553,
                        "name": "Hacienda de la Labor",
                        "latitude": "20.31639000",
                        "longitude": "-103.17333000"
                    },
                    {
                        "id": 142554,
                        "name": "Hacienda los Fresnos",
                        "latitude": "20.51944000",
                        "longitude": "-103.39306000"
                    },
                    {
                        "id": 142550,
                        "name": "Hacienda Santa Fe",
                        "latitude": "20.51806000",
                        "longitude": "-103.38056000"
                    },
                    {
                        "id": 142551,
                        "name": "Hacienda Vieja",
                        "latitude": "19.60083000",
                        "longitude": "-103.21444000"
                    },
                    {
                        "id": 142552,
                        "name": "Hacienda Vieja del Castillo",
                        "latitude": "20.54000000",
                        "longitude": "-103.24417000"
                    },
                    {
                        "id": 142555,
                        "name": "Haciendas la Herradura",
                        "latitude": "20.77250000",
                        "longitude": "-103.60861000"
                    },
                    {
                        "id": 142556,
                        "name": "Hierba de Matancillas",
                        "latitude": "21.86528000",
                        "longitude": "-101.67333000"
                    },
                    {
                        "id": 142557,
                        "name": "Higueras San Miguel",
                        "latitude": "19.59472000",
                        "longitude": "-103.17944000"
                    },
                    {
                        "id": 142558,
                        "name": "Higuerillas",
                        "latitude": "20.76083000",
                        "longitude": "-102.47417000"
                    },
                    {
                        "id": 142559,
                        "name": "Hostotipaquillo",
                        "latitude": "21.06035000",
                        "longitude": "-104.05091000"
                    },
                    {
                        "id": 142560,
                        "name": "Huajacatlán",
                        "latitude": "21.04444000",
                        "longitude": "-103.95222000"
                    },
                    {
                        "id": 142561,
                        "name": "Huascato",
                        "latitude": "20.47951000",
                        "longitude": "-102.24806000"
                    },
                    {
                        "id": 142562,
                        "name": "Huaxtla",
                        "latitude": "20.73179000",
                        "longitude": "-103.66291000"
                    },
                    {
                        "id": 142564,
                        "name": "Huejotitán",
                        "latitude": "20.35524000",
                        "longitude": "-103.48742000"
                    },
                    {
                        "id": 142563,
                        "name": "Huejotitlán",
                        "latitude": "20.65694000",
                        "longitude": "-103.04222000"
                    },
                    {
                        "id": 142566,
                        "name": "Huejúcar",
                        "latitude": "22.33409000",
                        "longitude": "-103.25253000"
                    },
                    {
                        "id": 142565,
                        "name": "Huejuquilla El Alto Municipality",
                        "latitude": "22.61666667",
                        "longitude": "-103.88333333"
                    },
                    {
                        "id": 142567,
                        "name": "Huertas Familiares San Pedro",
                        "latitude": "21.32750000",
                        "longitude": "-101.97444000"
                    },
                    {
                        "id": 142568,
                        "name": "Huisichi",
                        "latitude": "19.56611000",
                        "longitude": "-103.86556000"
                    },
                    {
                        "id": 142569,
                        "name": "Huitzometl",
                        "latitude": "19.51000000",
                        "longitude": "-103.75250000"
                    },
                    {
                        "id": 142570,
                        "name": "Huizaches",
                        "latitude": "19.17167000",
                        "longitude": "-103.49000000"
                    },
                    {
                        "id": 142572,
                        "name": "Ipazoltic",
                        "latitude": "20.43330000",
                        "longitude": "-103.98300000"
                    },
                    {
                        "id": 142571,
                        "name": "IPROVIPE I",
                        "latitude": "20.88639000",
                        "longitude": "-103.82444000"
                    },
                    {
                        "id": 142573,
                        "name": "Ixtapa",
                        "latitude": "20.71623000",
                        "longitude": "-105.20408000"
                    },
                    {
                        "id": 142574,
                        "name": "Ixtlahuacán de los Membrillos",
                        "latitude": "20.34666667",
                        "longitude": "-103.19138889"
                    },
                    {
                        "id": 142575,
                        "name": "Ixtlahuacán del Río",
                        "latitude": "20.86666667",
                        "longitude": "-103.25000000"
                    },
                    {
                        "id": 142576,
                        "name": "Izolta",
                        "latitude": "22.01000000",
                        "longitude": "-103.74639000"
                    },
                    {
                        "id": 142577,
                        "name": "J. Isabel Flores",
                        "latitude": "20.63750000",
                        "longitude": "-103.07806000"
                    },
                    {
                        "id": 142578,
                        "name": "Jalostotitlan",
                        "latitude": "21.16741000",
                        "longitude": "-102.46386000"
                    },
                    {
                        "id": 142579,
                        "name": "Jaluco",
                        "latitude": "19.23089000",
                        "longitude": "-104.68527000"
                    },
                    {
                        "id": 142580,
                        "name": "Jamay",
                        "latitude": "20.29444444",
                        "longitude": "-102.70972222"
                    },
                    {
                        "id": 142581,
                        "name": "Jardines de San Sebastián",
                        "latitude": "20.51889000",
                        "longitude": "-103.42222000"
                    },
                    {
                        "id": 142582,
                        "name": "Jardines del Edén",
                        "latitude": "20.53250000",
                        "longitude": "-103.36278000"
                    },
                    {
                        "id": 142583,
                        "name": "Jaritas",
                        "latitude": "21.31167000",
                        "longitude": "-101.99750000"
                    },
                    {
                        "id": 142584,
                        "name": "Jesús María",
                        "latitude": "20.66666667",
                        "longitude": "-103.35027778"
                    },
                    {
                        "id": 142585,
                        "name": "Jesús María Nayarit",
                        "latitude": "20.66667000",
                        "longitude": "-104.26670000"
                    },
                    {
                        "id": 142586,
                        "name": "Jilotlán de los Dolores",
                        "latitude": "19.37083333",
                        "longitude": "-103.01972222"
                    },
                    {
                        "id": 142587,
                        "name": "Jiquilpan",
                        "latitude": "19.77889000",
                        "longitude": "-103.77895000"
                    },
                    {
                        "id": 142588,
                        "name": "Joconoxtle",
                        "latitude": "20.45222000",
                        "longitude": "-102.67639000"
                    },
                    {
                        "id": 142589,
                        "name": "Jocotepec",
                        "latitude": "20.16666667",
                        "longitude": "-103.28333333"
                    },
                    {
                        "id": 142592,
                        "name": "José de Jesús Aguirre Teocaltiche",
                        "latitude": "21.52167000",
                        "longitude": "-102.47139000"
                    },
                    {
                        "id": 142591,
                        "name": "José María Pino Suárez",
                        "latitude": "19.94889000",
                        "longitude": "-105.32778000"
                    },
                    {
                        "id": 142590,
                        "name": "Josefa Ortíz de Domínguez",
                        "latitude": "20.90000000",
                        "longitude": "-103.83306000"
                    },
                    {
                        "id": 142593,
                        "name": "Juan Gil Preciado",
                        "latitude": "20.37269000",
                        "longitude": "-103.72752000"
                    },
                    {
                        "id": 142594,
                        "name": "Juanacatlán",
                        "latitude": "20.50000000",
                        "longitude": "-103.16666667"
                    },
                    {
                        "id": 142595,
                        "name": "La Alameda",
                        "latitude": "20.49528000",
                        "longitude": "-103.24833000"
                    },
                    {
                        "id": 142596,
                        "name": "La Aldaba",
                        "latitude": "19.74964000",
                        "longitude": "-104.23306000"
                    },
                    {
                        "id": 142597,
                        "name": "La Angostura de los Altos",
                        "latitude": "20.56194000",
                        "longitude": "-102.43500000"
                    },
                    {
                        "id": 142598,
                        "name": "La Arbolada Plus",
                        "latitude": "20.53694000",
                        "longitude": "-103.36389000"
                    },
                    {
                        "id": 142599,
                        "name": "La Barca",
                        "latitude": "20.28333333",
                        "longitude": "-102.56666667"
                    },
                    {
                        "id": 142600,
                        "name": "La Barranca",
                        "latitude": "20.51639000",
                        "longitude": "-103.07306000"
                    },
                    {
                        "id": 142601,
                        "name": "La Calera",
                        "latitude": "21.49694000",
                        "longitude": "-102.58556000"
                    },
                    {
                        "id": 142602,
                        "name": "La Calera Fraccionamiento",
                        "latitude": "21.26889000",
                        "longitude": "-102.33778000"
                    },
                    {
                        "id": 142604,
                        "name": "La Cañada",
                        "latitude": "20.48222000",
                        "longitude": "-102.94306000"
                    },
                    {
                        "id": 142605,
                        "name": "La Cañada Tezcaltilti",
                        "latitude": "20.01167000",
                        "longitude": "-103.71278000"
                    },
                    {
                        "id": 142603,
                        "name": "La Cantera",
                        "latitude": "21.34333000",
                        "longitude": "-102.01972000"
                    },
                    {
                        "id": 142606,
                        "name": "La Cebadilla",
                        "latitude": "20.89028000",
                        "longitude": "-102.74250000"
                    },
                    {
                        "id": 142607,
                        "name": "La Ceja de la Capilla",
                        "latitude": "20.73583000",
                        "longitude": "-102.41833000"
                    },
                    {
                        "id": 142608,
                        "name": "La Cerca Blanca",
                        "latitude": "21.15806000",
                        "longitude": "-102.88361000"
                    },
                    {
                        "id": 142610,
                        "name": "La Ciénega",
                        "latitude": "20.66056000",
                        "longitude": "-102.71333000"
                    },
                    {
                        "id": 142611,
                        "name": "La Ciénega de Huaistita",
                        "latitude": "22.06306000",
                        "longitude": "-104.32583000"
                    },
                    {
                        "id": 142609,
                        "name": "La Cieneguita",
                        "latitude": "20.75611000",
                        "longitude": "-102.29944000"
                    },
                    {
                        "id": 142612,
                        "name": "La Cofradía",
                        "latitude": "22.61361000",
                        "longitude": "-103.92417000"
                    },
                    {
                        "id": 142613,
                        "name": "La Cofradía del Rosario",
                        "latitude": "19.88861000",
                        "longitude": "-103.72444000"
                    },
                    {
                        "id": 142614,
                        "name": "La Colonia San Juanito",
                        "latitude": "21.19361000",
                        "longitude": "-102.90472000"
                    },
                    {
                        "id": 142615,
                        "name": "La Concepción",
                        "latitude": "20.35171000",
                        "longitude": "-102.32959000"
                    },
                    {
                        "id": 142616,
                        "name": "La Conchilla",
                        "latitude": "20.90528000",
                        "longitude": "-103.73861000"
                    },
                    {
                        "id": 142617,
                        "name": "La Conchita",
                        "latitude": "19.49972000",
                        "longitude": "-104.56139000"
                    },
                    {
                        "id": 142618,
                        "name": "La Constancia",
                        "latitude": "20.40333000",
                        "longitude": "-102.98361000"
                    },
                    {
                        "id": 142619,
                        "name": "La Cruz",
                        "latitude": "20.25083000",
                        "longitude": "-103.59111000"
                    },
                    {
                        "id": 142620,
                        "name": "La Cruz de Loreto",
                        "latitude": "20.00755000",
                        "longitude": "-105.45508000"
                    },
                    {
                        "id": 142621,
                        "name": "La Cuchilla",
                        "latitude": "20.78000000",
                        "longitude": "-103.46222000"
                    },
                    {
                        "id": 142622,
                        "name": "La Cuesta de Medina",
                        "latitude": "21.22583000",
                        "longitude": "-102.33056000"
                    },
                    {
                        "id": 142623,
                        "name": "La Cueva",
                        "latitude": "21.24056000",
                        "longitude": "-102.59444000"
                    },
                    {
                        "id": 142624,
                        "name": "La Estacada",
                        "latitude": "19.93528000",
                        "longitude": "-103.03472000"
                    },
                    {
                        "id": 142625,
                        "name": "La Estancia",
                        "latitude": "21.04694000",
                        "longitude": "-102.84167000"
                    },
                    {
                        "id": 142626,
                        "name": "La Estancia de Arriba",
                        "latitude": "22.61972000",
                        "longitude": "-103.90861000"
                    },
                    {
                        "id": 142627,
                        "name": "La Estancia de Ayones",
                        "latitude": "20.88220000",
                        "longitude": "-104.08717000"
                    },
                    {
                        "id": 142628,
                        "name": "La Estancia de Navarro",
                        "latitude": "20.54917000",
                        "longitude": "-102.60944000"
                    },
                    {
                        "id": 142629,
                        "name": "La Estancita",
                        "latitude": "20.56722000",
                        "longitude": "-104.01083000"
                    },
                    {
                        "id": 142630,
                        "name": "La Estanzuela",
                        "latitude": "20.66892000",
                        "longitude": "-103.82609000"
                    },
                    {
                        "id": 142631,
                        "name": "La Floreña",
                        "latitude": "20.46750000",
                        "longitude": "-102.73500000"
                    },
                    {
                        "id": 142632,
                        "name": "La Fortuna Fraccionamiento",
                        "latitude": "20.48472000",
                        "longitude": "-103.39583000"
                    },
                    {
                        "id": 142633,
                        "name": "La Frontera",
                        "latitude": "19.96083000",
                        "longitude": "-103.71139000"
                    },
                    {
                        "id": 142634,
                        "name": "La Garita Jalisco",
                        "latitude": "19.76666667",
                        "longitude": "-103.11666667"
                    },
                    {
                        "id": 142635,
                        "name": "La Garruña",
                        "latitude": "20.95556000",
                        "longitude": "-103.13944000"
                    },
                    {
                        "id": 142636,
                        "name": "La Gila",
                        "latitude": "20.61444000",
                        "longitude": "-102.20472000"
                    },
                    {
                        "id": 142637,
                        "name": "La Gloria",
                        "latitude": "20.61222000",
                        "longitude": "-102.38389000"
                    },
                    {
                        "id": 142638,
                        "name": "La Granjena",
                        "latitude": "20.70694000",
                        "longitude": "-102.44361000"
                    },
                    {
                        "id": 142639,
                        "name": "La Guadalupe",
                        "latitude": "19.73556000",
                        "longitude": "-103.78083000"
                    },
                    {
                        "id": 142640,
                        "name": "La Guásima",
                        "latitude": "22.11889000",
                        "longitude": "-103.74111000"
                    },
                    {
                        "id": 142641,
                        "name": "La Hermosura",
                        "latitude": "20.11333000",
                        "longitude": "-103.60139000"
                    },
                    {
                        "id": 142642,
                        "name": "La Higuera",
                        "latitude": "19.42358000",
                        "longitude": "-103.40955000"
                    },
                    {
                        "id": 142643,
                        "name": "La Huerta",
                        "latitude": "19.48444444",
                        "longitude": "-104.64388889"
                    },
                    {
                        "id": 142644,
                        "name": "La Huevera",
                        "latitude": "19.88917000",
                        "longitude": "-103.12000000"
                    },
                    {
                        "id": 142645,
                        "name": "La Isla",
                        "latitude": "21.39472000",
                        "longitude": "-101.92278000"
                    },
                    {
                        "id": 142646,
                        "name": "La Jarrilla",
                        "latitude": "21.05444000",
                        "longitude": "-102.95417000"
                    },
                    {
                        "id": 142647,
                        "name": "La Joya",
                        "latitude": "19.94472000",
                        "longitude": "-102.86944000"
                    },
                    {
                        "id": 142648,
                        "name": "La Joya Chica",
                        "latitude": "20.71021000",
                        "longitude": "-103.00250000"
                    },
                    {
                        "id": 142649,
                        "name": "La Joya Grande",
                        "latitude": "20.70861000",
                        "longitude": "-103.04444000"
                    },
                    {
                        "id": 142650,
                        "name": "La Labor de la Concepción",
                        "latitude": "21.23306000",
                        "longitude": "-102.78333000"
                    },
                    {
                        "id": 142651,
                        "name": "La Labor de los Alba",
                        "latitude": "21.37722000",
                        "longitude": "-102.31639000"
                    },
                    {
                        "id": 142652,
                        "name": "La Ladera",
                        "latitude": "20.20722000",
                        "longitude": "-104.15139000"
                    },
                    {
                        "id": 142653,
                        "name": "La Ladera Grande",
                        "latitude": "20.52417000",
                        "longitude": "-102.35167000"
                    },
                    {
                        "id": 142654,
                        "name": "La Laguna",
                        "latitude": "22.25417000",
                        "longitude": "-104.20667000"
                    },
                    {
                        "id": 142655,
                        "name": "La Laguna Grande",
                        "latitude": "20.93611000",
                        "longitude": "-103.06111000"
                    },
                    {
                        "id": 142656,
                        "name": "La Laja",
                        "latitude": "19.85481000",
                        "longitude": "-104.28520000"
                    },
                    {
                        "id": 142657,
                        "name": "La Lobera",
                        "latitude": "21.08694000",
                        "longitude": "-103.56583000"
                    },
                    {
                        "id": 142658,
                        "name": "La Loma",
                        "latitude": "20.44139000",
                        "longitude": "-102.08833000"
                    },
                    {
                        "id": 142659,
                        "name": "La Loma de los Rizo",
                        "latitude": "20.72444000",
                        "longitude": "-102.22222000"
                    },
                    {
                        "id": 142660,
                        "name": "La Loma del Nopal",
                        "latitude": "20.73000000",
                        "longitude": "-102.40167000"
                    },
                    {
                        "id": 142661,
                        "name": "La Lomita",
                        "latitude": "21.44056000",
                        "longitude": "-102.31278000"
                    },
                    {
                        "id": 142662,
                        "name": "La Luz",
                        "latitude": "20.44917000",
                        "longitude": "-102.71750000"
                    },
                    {
                        "id": 142663,
                        "name": "La Manzanilla",
                        "latitude": "19.28111111",
                        "longitude": "-104.78750000"
                    },
                    {
                        "id": 142664,
                        "name": "La Manzanilla de La Paz",
                        "latitude": "19.91666667",
                        "longitude": "-102.01666667"
                    },
                    {
                        "id": 142665,
                        "name": "La Mata",
                        "latitude": "20.89528000",
                        "longitude": "-103.74889000"
                    },
                    {
                        "id": 142666,
                        "name": "La Merced",
                        "latitude": "21.48250000",
                        "longitude": "-101.86722000"
                    },
                    {
                        "id": 142667,
                        "name": "La Mesa",
                        "latitude": "20.54944000",
                        "longitude": "-103.11918000"
                    },
                    {
                        "id": 142668,
                        "name": "La Mesa del Guitarrero",
                        "latitude": "20.66972000",
                        "longitude": "-102.76667000"
                    },
                    {
                        "id": 142669,
                        "name": "La Mesita",
                        "latitude": "20.83889000",
                        "longitude": "-103.50667000"
                    },
                    {
                        "id": 142670,
                        "name": "La Mezcalilla",
                        "latitude": "20.45250000",
                        "longitude": "-103.12306000"
                    },
                    {
                        "id": 142671,
                        "name": "La Mezquitera",
                        "latitude": "20.55833000",
                        "longitude": "-103.11250000"
                    },
                    {
                        "id": 142672,
                        "name": "La Mial",
                        "latitude": "20.58639000",
                        "longitude": "-103.27500000"
                    },
                    {
                        "id": 142673,
                        "name": "La Mina",
                        "latitude": "20.94750000",
                        "longitude": "-102.72250000"
                    },
                    {
                        "id": 142674,
                        "name": "La Mojarra",
                        "latitude": "20.84944000",
                        "longitude": "-103.04250000"
                    },
                    {
                        "id": 142675,
                        "name": "La Mora",
                        "latitude": "20.70575000",
                        "longitude": "-104.03409000"
                    },
                    {
                        "id": 142676,
                        "name": "La Mota",
                        "latitude": "20.70556000",
                        "longitude": "-102.69028000"
                    },
                    {
                        "id": 142677,
                        "name": "La Nance",
                        "latitude": "19.48667000",
                        "longitude": "-104.39639000"
                    },
                    {
                        "id": 142678,
                        "name": "La Nopalera",
                        "latitude": "20.47750000",
                        "longitude": "-102.40056000"
                    },
                    {
                        "id": 142679,
                        "name": "La Noria",
                        "latitude": "21.10972000",
                        "longitude": "-101.83750000"
                    },
                    {
                        "id": 142680,
                        "name": "La Orilla de la Cerca",
                        "latitude": "20.36556000",
                        "longitude": "-102.71667000"
                    },
                    {
                        "id": 142681,
                        "name": "La Orilla del Agua",
                        "latitude": "21.38389000",
                        "longitude": "-101.95250000"
                    },
                    {
                        "id": 142682,
                        "name": "La Palma",
                        "latitude": "21.38778000",
                        "longitude": "-101.92167000"
                    },
                    {
                        "id": 142683,
                        "name": "La Palmita",
                        "latitude": "21.76833000",
                        "longitude": "-101.91778000"
                    },
                    {
                        "id": 142684,
                        "name": "La Parota",
                        "latitude": "19.55944000",
                        "longitude": "-103.89028000"
                    },
                    {
                        "id": 142685,
                        "name": "La Parrita",
                        "latitude": "21.54722000",
                        "longitude": "-102.55056000"
                    },
                    {
                        "id": 142686,
                        "name": "La Paz",
                        "latitude": "21.81608000",
                        "longitude": "-101.76793000"
                    },
                    {
                        "id": 142687,
                        "name": "La Paz de Ordaz",
                        "latitude": "20.34489000",
                        "longitude": "-102.53059000"
                    },
                    {
                        "id": 142688,
                        "name": "La Peña Jalisco",
                        "latitude": "20.32722000",
                        "longitude": "-102.97556000"
                    },
                    {
                        "id": 142689,
                        "name": "La Playa",
                        "latitude": "21.82278000",
                        "longitude": "-103.78861000"
                    },
                    {
                        "id": 142690,
                        "name": "La Presa",
                        "latitude": "21.77589000",
                        "longitude": "-101.81477000"
                    },
                    {
                        "id": 142691,
                        "name": "La Primavera",
                        "latitude": "20.72302000",
                        "longitude": "-103.56543000"
                    },
                    {
                        "id": 142692,
                        "name": "La Providencia",
                        "latitude": "21.02556000",
                        "longitude": "-102.60444000"
                    },
                    {
                        "id": 142693,
                        "name": "La Puerta de San Pedro",
                        "latitude": "20.92778000",
                        "longitude": "-103.84389000"
                    },
                    {
                        "id": 142694,
                        "name": "La Puerta del Coche",
                        "latitude": "20.80400000",
                        "longitude": "-104.22577000"
                    },
                    {
                        "id": 142695,
                        "name": "La Punta",
                        "latitude": "20.57156000",
                        "longitude": "-103.21147000"
                    },
                    {
                        "id": 142696,
                        "name": "La Purísima",
                        "latitude": "19.49162000",
                        "longitude": "-103.32896000"
                    },
                    {
                        "id": 142697,
                        "name": "La Quemada",
                        "latitude": "20.97127000",
                        "longitude": "-104.04914000"
                    },
                    {
                        "id": 142698,
                        "name": "La Rana",
                        "latitude": "20.81056000",
                        "longitude": "-102.42444000"
                    },
                    {
                        "id": 142699,
                        "name": "La Raya",
                        "latitude": "20.53639000",
                        "longitude": "-102.51944000"
                    },
                    {
                        "id": 142700,
                        "name": "La Red",
                        "latitude": "20.71861000",
                        "longitude": "-102.81333000"
                    },
                    {
                        "id": 142701,
                        "name": "La Resolana",
                        "latitude": "20.74139000",
                        "longitude": "-102.92528000"
                    },
                    {
                        "id": 142702,
                        "name": "La Ribera",
                        "latitude": "20.34908000",
                        "longitude": "-102.28273000"
                    },
                    {
                        "id": 142703,
                        "name": "La Roca",
                        "latitude": "20.51278000",
                        "longitude": "-103.42639000"
                    },
                    {
                        "id": 142704,
                        "name": "La Rosa",
                        "latitude": "19.46278000",
                        "longitude": "-104.31556000"
                    },
                    {
                        "id": 142705,
                        "name": "La Rosa Amarilla",
                        "latitude": "20.08404000",
                        "longitude": "-103.10903000"
                    },
                    {
                        "id": 142706,
                        "name": "La Rosa de Castilla",
                        "latitude": "20.70806000",
                        "longitude": "-102.25083000"
                    },
                    {
                        "id": 142707,
                        "name": "La Rueda",
                        "latitude": "20.10167000",
                        "longitude": "-103.26250000"
                    },
                    {
                        "id": 142708,
                        "name": "La Sanguijuela",
                        "latitude": "20.49222000",
                        "longitude": "-102.04417000"
                    },
                    {
                        "id": 142709,
                        "name": "La Sauceda",
                        "latitude": "20.45251000",
                        "longitude": "-103.80681000"
                    },
                    {
                        "id": 142710,
                        "name": "La Soledad",
                        "latitude": "20.63528000",
                        "longitude": "-102.55444000"
                    },
                    {
                        "id": 142711,
                        "name": "La Teja",
                        "latitude": "20.44611000",
                        "longitude": "-103.48306000"
                    },
                    {
                        "id": 142712,
                        "name": "La Tijera",
                        "latitude": "20.58167000",
                        "longitude": "-103.44056000"
                    },
                    {
                        "id": 142713,
                        "name": "La Tinajera",
                        "latitude": "20.46972000",
                        "longitude": "-102.18778000"
                    },
                    {
                        "id": 142714,
                        "name": "La Tiricia",
                        "latitude": "20.47833000",
                        "longitude": "-102.72306000"
                    },
                    {
                        "id": 142715,
                        "name": "La Tortuga",
                        "latitude": "20.90139000",
                        "longitude": "-104.61583000"
                    },
                    {
                        "id": 142716,
                        "name": "La Trinidad",
                        "latitude": "21.27389000",
                        "longitude": "-101.99250000"
                    },
                    {
                        "id": 142717,
                        "name": "La Unión del Cuatro",
                        "latitude": "20.53148000",
                        "longitude": "-103.36812000"
                    },
                    {
                        "id": 142718,
                        "name": "La Vaquera",
                        "latitude": "20.85611000",
                        "longitude": "-102.22056000"
                    },
                    {
                        "id": 142719,
                        "name": "La Vega",
                        "latitude": "20.58331000",
                        "longitude": "-103.85830000"
                    },
                    {
                        "id": 142720,
                        "name": "La Venta del Astillero",
                        "latitude": "20.72795000",
                        "longitude": "-103.54509000"
                    },
                    {
                        "id": 142721,
                        "name": "La Verdolaga",
                        "latitude": "21.68917000",
                        "longitude": "-102.03778000"
                    },
                    {
                        "id": 142722,
                        "name": "La Villa",
                        "latitude": "20.62806000",
                        "longitude": "-102.94667000"
                    },
                    {
                        "id": 142723,
                        "name": "La Virgencita",
                        "latitude": "20.72889000",
                        "longitude": "-102.53389000"
                    },
                    {
                        "id": 142724,
                        "name": "La Yerbabuena",
                        "latitude": "20.53722000",
                        "longitude": "-103.09722000"
                    },
                    {
                        "id": 142725,
                        "name": "La Zapotera",
                        "latitude": "20.30611000",
                        "longitude": "-102.89778000"
                    },
                    {
                        "id": 142726,
                        "name": "Labor de Medina",
                        "latitude": "20.46666667",
                        "longitude": "-103.91666667"
                    },
                    {
                        "id": 142727,
                        "name": "Labor de Montoya",
                        "latitude": "21.36722000",
                        "longitude": "-102.21917000"
                    },
                    {
                        "id": 142728,
                        "name": "Ladera Chica",
                        "latitude": "20.52167000",
                        "longitude": "-102.34694000"
                    },
                    {
                        "id": 142729,
                        "name": "Lagos de Moreno",
                        "latitude": "21.35638889",
                        "longitude": "-101.92916667"
                    },
                    {
                        "id": 142730,
                        "name": "Laguna Colorada",
                        "latitude": "20.75917000",
                        "longitude": "-102.83111000"
                    },
                    {
                        "id": 142731,
                        "name": "Laguna de Piedra",
                        "latitude": "20.82028000",
                        "longitude": "-102.13778000"
                    },
                    {
                        "id": 142732,
                        "name": "Lagunillas Jalisco",
                        "latitude": "20.33972222",
                        "longitude": "-103.99583333"
                    },
                    {
                        "id": 142733,
                        "name": "Las Alfalfas",
                        "latitude": "21.32861000",
                        "longitude": "-101.91056000"
                    },
                    {
                        "id": 142734,
                        "name": "Las Amarillas",
                        "latitude": "21.58918000",
                        "longitude": "-101.65548000"
                    },
                    {
                        "id": 142735,
                        "name": "Las Asturias Fraccionamiento",
                        "latitude": "20.52222000",
                        "longitude": "-103.29083000"
                    },
                    {
                        "id": 142736,
                        "name": "Las Azules",
                        "latitude": "20.89194000",
                        "longitude": "-102.79167000"
                    },
                    {
                        "id": 142737,
                        "name": "Las Calaveras",
                        "latitude": "20.19944000",
                        "longitude": "-104.02250000"
                    },
                    {
                        "id": 142740,
                        "name": "Las Cañadas",
                        "latitude": "21.14000000",
                        "longitude": "-102.46167000"
                    },
                    {
                        "id": 142738,
                        "name": "Las Canoas",
                        "latitude": "19.61028000",
                        "longitude": "-103.47389000"
                    },
                    {
                        "id": 142739,
                        "name": "Las Carretas",
                        "latitude": "20.44861000",
                        "longitude": "-103.24639000"
                    },
                    {
                        "id": 142741,
                        "name": "Las Golondrinas [Fraccionamiento]",
                        "latitude": "22.10528000",
                        "longitude": "-103.25417000"
                    },
                    {
                        "id": 142742,
                        "name": "Las Juntas",
                        "latitude": "19.43061000",
                        "longitude": "-104.70646000"
                    },
                    {
                        "id": 142743,
                        "name": "Las Pintas de Arriba",
                        "latitude": "20.57376000",
                        "longitude": "-103.32345000"
                    },
                    {
                        "id": 142744,
                        "name": "Las Pintitas",
                        "latitude": "20.56444000",
                        "longitude": "-103.30222000"
                    },
                    {
                        "id": 142745,
                        "name": "Las Primaveras [Invernadero]",
                        "latitude": "19.69472000",
                        "longitude": "-103.83333000"
                    },
                    {
                        "id": 142760,
                        "name": "Lázaro Cárdenas Jalisco",
                        "latitude": "20.44166667",
                        "longitude": "-103.96888889"
                    },
                    {
                        "id": 142746,
                        "name": "Lo Arado",
                        "latitude": "19.62139000",
                        "longitude": "-104.53444000"
                    },
                    {
                        "id": 142747,
                        "name": "Lomas de San Agustín",
                        "latitude": "20.52750000",
                        "longitude": "-103.46778000"
                    },
                    {
                        "id": 142748,
                        "name": "Lomas de Tejeda",
                        "latitude": "20.46658000",
                        "longitude": "-103.40202000"
                    },
                    {
                        "id": 142749,
                        "name": "Lomas del Sur",
                        "latitude": "20.49250000",
                        "longitude": "-103.41750000"
                    },
                    {
                        "id": 142750,
                        "name": "Los Azulitos",
                        "latitude": "21.84610000",
                        "longitude": "-101.96527000"
                    },
                    {
                        "id": 142751,
                        "name": "Los Cedros",
                        "latitude": "20.38980000",
                        "longitude": "-103.23250000"
                    },
                    {
                        "id": 142752,
                        "name": "Los Gavilanes",
                        "latitude": "20.57456000",
                        "longitude": "-103.44881000"
                    },
                    {
                        "id": 142753,
                        "name": "Los Guerrero",
                        "latitude": "20.43333333",
                        "longitude": "-103.88333333"
                    },
                    {
                        "id": 142754,
                        "name": "Los Mazos",
                        "latitude": "19.57000000",
                        "longitude": "-103.50000000"
                    },
                    {
                        "id": 142755,
                        "name": "Los Olivos",
                        "latitude": "20.43917000",
                        "longitude": "-103.23778000"
                    },
                    {
                        "id": 142756,
                        "name": "Los Pocitos",
                        "latitude": "20.53724000",
                        "longitude": "-103.93721000"
                    },
                    {
                        "id": 142757,
                        "name": "Los Ruiseñores",
                        "latitude": "20.71083000",
                        "longitude": "-103.69139000"
                    },
                    {
                        "id": 142758,
                        "name": "Los Sauces",
                        "latitude": "21.57425000",
                        "longitude": "-102.13827000"
                    },
                    {
                        "id": 142759,
                        "name": "Los Vergara",
                        "latitude": "20.45000000",
                        "longitude": "-103.91666667"
                    },
                    {
                        "id": 142761,
                        "name": "Magdalena",
                        "latitude": "20.90916667",
                        "longitude": "-103.98027778"
                    },
                    {
                        "id": 142762,
                        "name": "Manalisco",
                        "latitude": "21.05928000",
                        "longitude": "-102.92203000"
                    },
                    {
                        "id": 142763,
                        "name": "Margaritas",
                        "latitude": "20.45306000",
                        "longitude": "-102.47417000"
                    },
                    {
                        "id": 142764,
                        "name": "Mascota Municipality",
                        "latitude": "20.52611111",
                        "longitude": "-104.78777778"
                    },
                    {
                        "id": 142765,
                        "name": "Matancillas (San Isidro Matancillas)",
                        "latitude": "21.89036000",
                        "longitude": "-101.65059000"
                    },
                    {
                        "id": 142766,
                        "name": "Matanzas",
                        "latitude": "21.63333000",
                        "longitude": "-101.65528000"
                    },
                    {
                        "id": 142767,
                        "name": "Matatlán",
                        "latitude": "20.70978000",
                        "longitude": "-103.15009000"
                    },
                    {
                        "id": 142768,
                        "name": "Mazamitlongo",
                        "latitude": "19.91555556",
                        "longitude": "-103.01944444"
                    },
                    {
                        "id": 142769,
                        "name": "Mechoacanejo",
                        "latitude": "21.54038000",
                        "longitude": "-102.59587000"
                    },
                    {
                        "id": 142770,
                        "name": "Mexticacán",
                        "latitude": "21.21666667",
                        "longitude": "-102.71666667"
                    },
                    {
                        "id": 142771,
                        "name": "Mezcala",
                        "latitude": "20.95278000",
                        "longitude": "-102.84611000"
                    },
                    {
                        "id": 142773,
                        "name": "Mezquitic de la Magdalena",
                        "latitude": "21.22111000",
                        "longitude": "-102.30444000"
                    },
                    {
                        "id": 142772,
                        "name": "Mezquitic Municipality",
                        "latitude": "22.20609000",
                        "longitude": "-104.04531000"
                    },
                    {
                        "id": 142774,
                        "name": "Milpillas",
                        "latitude": "20.50111000",
                        "longitude": "-102.53418000"
                    },
                    {
                        "id": 142775,
                        "name": "Misión San Luis Gonzaga Chiriyaqui",
                        "latitude": "21.78333000",
                        "longitude": "-101.97278000"
                    },
                    {
                        "id": 142776,
                        "name": "Mismaloya",
                        "latitude": "20.53101800",
                        "longitude": "-105.29262500"
                    },
                    {
                        "id": 142777,
                        "name": "Mismaloya (Fraccionamiento Pedregal de Santa Martha)",
                        "latitude": "20.60694000",
                        "longitude": "-103.17139000"
                    },
                    {
                        "id": 142778,
                        "name": "Mixtlán",
                        "latitude": "20.36666667",
                        "longitude": "-104.25000000"
                    },
                    {
                        "id": 142779,
                        "name": "Moras",
                        "latitude": "20.32622000",
                        "longitude": "-102.59254000"
                    },
                    {
                        "id": 142780,
                        "name": "Navajas",
                        "latitude": "20.53318000",
                        "longitude": "-103.67972000"
                    },
                    {
                        "id": 142781,
                        "name": "Nextipac",
                        "latitude": "20.76725000",
                        "longitude": "-103.52405000"
                    },
                    {
                        "id": 142782,
                        "name": "Nicolás R Casillas",
                        "latitude": "20.54638000",
                        "longitude": "-103.46622000"
                    },
                    {
                        "id": 142783,
                        "name": "Nuevo México Jalisco",
                        "latitude": "20.75777778",
                        "longitude": "-103.43416667"
                    },
                    {
                        "id": 142784,
                        "name": "Nuevo Refugio de Afuera (Nuevo Refugio)",
                        "latitude": "20.54889000",
                        "longitude": "-102.70722000"
                    },
                    {
                        "id": 142785,
                        "name": "Oconahua Jalisco",
                        "latitude": "20.74373667",
                        "longitude": "-104.16384278"
                    },
                    {
                        "id": 142786,
                        "name": "Ocotlán Jalisco",
                        "latitude": "20.35138889",
                        "longitude": "-102.76805556"
                    },
                    {
                        "id": 142787,
                        "name": "Ojo de Agua de Morán Jalisco",
                        "latitude": "20.53333333",
                        "longitude": "-102.50000000"
                    },
                    {
                        "id": 142788,
                        "name": "Ojuelos de Jalisco",
                        "latitude": "21.86416667",
                        "longitude": "-101.59333333"
                    },
                    {
                        "id": 142789,
                        "name": "Otatlán",
                        "latitude": "20.44084000",
                        "longitude": "-102.80389000"
                    },
                    {
                        "id": 142790,
                        "name": "Palomar",
                        "latitude": "20.59250000",
                        "longitude": "-103.46056000"
                    },
                    {
                        "id": 142791,
                        "name": "Palos Altos",
                        "latitude": "20.87143000",
                        "longitude": "-103.15296000"
                    },
                    {
                        "id": 142793,
                        "name": "Paseo de las Cañadas",
                        "latitude": "20.62139000",
                        "longitude": "-103.19778000"
                    },
                    {
                        "id": 142794,
                        "name": "Paseo del Prado",
                        "latitude": "20.56444000",
                        "longitude": "-103.38917000"
                    },
                    {
                        "id": 142792,
                        "name": "Paseo Puente Viejo",
                        "latitude": "20.56917000",
                        "longitude": "-103.19056000"
                    },
                    {
                        "id": 142795,
                        "name": "Paseos del Valle [Fraccionamiento]",
                        "latitude": "20.52222000",
                        "longitude": "-103.33333000"
                    },
                    {
                        "id": 142796,
                        "name": "Paso de Cuarenta",
                        "latitude": "21.50344000",
                        "longitude": "-101.75236000"
                    },
                    {
                        "id": 142797,
                        "name": "Pegueros",
                        "latitude": "20.95353000",
                        "longitude": "-102.66762000"
                    },
                    {
                        "id": 142798,
                        "name": "Piedra Pesada",
                        "latitude": "19.55056000",
                        "longitude": "-104.47683000"
                    },
                    {
                        "id": 142799,
                        "name": "Pihuamo",
                        "latitude": "18.95000000",
                        "longitude": "-103.16700000"
                    },
                    {
                        "id": 142800,
                        "name": "Pochotita",
                        "latitude": "22.27306000",
                        "longitude": "-104.11611000"
                    },
                    {
                        "id": 142801,
                        "name": "Poncitlán Municipality",
                        "latitude": "20.30000000",
                        "longitude": "-102.26666667"
                    },
                    {
                        "id": 142802,
                        "name": "Portes Gil",
                        "latitude": "20.65812000",
                        "longitude": "-103.93838000"
                    },
                    {
                        "id": 142803,
                        "name": "Potrerillos",
                        "latitude": "20.33837000",
                        "longitude": "-103.37762000"
                    },
                    {
                        "id": 142804,
                        "name": "Primero de Mayo (Chupaderos)",
                        "latitude": "21.46611000",
                        "longitude": "-101.82722000"
                    },
                    {
                        "id": 142806,
                        "name": "Puente de Camotlán",
                        "latitude": "21.69870000",
                        "longitude": "-104.07996000"
                    },
                    {
                        "id": 142805,
                        "name": "Puente Grande",
                        "latitude": "20.56977000",
                        "longitude": "-103.15377000"
                    },
                    {
                        "id": 142807,
                        "name": "Puerta del Llano",
                        "latitude": "20.78528000",
                        "longitude": "-103.46139000"
                    },
                    {
                        "id": 142808,
                        "name": "Puerto Vallarta",
                        "latitude": "20.61666667",
                        "longitude": "-105.23333333"
                    },
                    {
                        "id": 142809,
                        "name": "Punta de la Vega",
                        "latitude": "20.59070000",
                        "longitude": "-103.89831000"
                    },
                    {
                        "id": 142810,
                        "name": "Purificación",
                        "latitude": "19.71738000",
                        "longitude": "-104.60534000"
                    },
                    {
                        "id": 142811,
                        "name": "Quitupan",
                        "latitude": "19.65000000",
                        "longitude": "-102.75000000"
                    },
                    {
                        "id": 142812,
                        "name": "Rancho Alegre [Fraccionamiento]",
                        "latitude": "20.47361000",
                        "longitude": "-103.25778000"
                    },
                    {
                        "id": 142813,
                        "name": "Real del Valle (El Paraíso) [Fraccionamiento]",
                        "latitude": "20.54556000",
                        "longitude": "-103.36972000"
                    },
                    {
                        "id": 142814,
                        "name": "Rinconada la Loma [Fraccionamiento]",
                        "latitude": "20.45417000",
                        "longitude": "-103.21917000"
                    },
                    {
                        "id": 142815,
                        "name": "San Agustín",
                        "latitude": "20.28557000",
                        "longitude": "-102.63293000"
                    },
                    {
                        "id": 142816,
                        "name": "San Andrés Cohamiata",
                        "latitude": "22.18944000",
                        "longitude": "-104.24083000"
                    },
                    {
                        "id": 142817,
                        "name": "San Andrés Ixtlán",
                        "latitude": "19.82059000",
                        "longitude": "-103.47144000"
                    },
                    {
                        "id": 142818,
                        "name": "San Antonio",
                        "latitude": "20.55186000",
                        "longitude": "-102.61761000"
                    },
                    {
                        "id": 142820,
                        "name": "San Antonio de los Barrera",
                        "latitude": "21.38944000",
                        "longitude": "-102.25528000"
                    },
                    {
                        "id": 142821,
                        "name": "San Antonio de los Vázquez",
                        "latitude": "20.81767000",
                        "longitude": "-103.14623000"
                    },
                    {
                        "id": 142819,
                        "name": "San Antonio de Rivas",
                        "latitude": "20.35015000",
                        "longitude": "-102.42786000"
                    },
                    {
                        "id": 142822,
                        "name": "San Clemente",
                        "latitude": "20.08433000",
                        "longitude": "-104.25161000"
                    },
                    {
                        "id": 142823,
                        "name": "San Cristóbal",
                        "latitude": "21.68159000",
                        "longitude": "-101.94093000"
                    },
                    {
                        "id": 142825,
                        "name": "San Cristóbal de la Barranca Municipality",
                        "latitude": "21.04472222",
                        "longitude": "-103.42805556"
                    },
                    {
                        "id": 142824,
                        "name": "San Cristóbal Zapotitlán",
                        "latitude": "20.22453000",
                        "longitude": "-103.36969000"
                    },
                    {
                        "id": 142826,
                        "name": "San Diego de Alejandría",
                        "latitude": "20.86666667",
                        "longitude": "-101.90000000"
                    },
                    {
                        "id": 142827,
                        "name": "San Esteban (San Miguel Tateposco)",
                        "latitude": "20.79889000",
                        "longitude": "-103.37444000"
                    },
                    {
                        "id": 142828,
                        "name": "San Felipe de Híjar",
                        "latitude": "20.90171000",
                        "longitude": "-104.72172000"
                    },
                    {
                        "id": 142829,
                        "name": "San Francisco de Asís",
                        "latitude": "20.53333333",
                        "longitude": "-102.50000000"
                    },
                    {
                        "id": 142830,
                        "name": "San Francisco de Rivas",
                        "latitude": "20.34053000",
                        "longitude": "-102.57208000"
                    },
                    {
                        "id": 142831,
                        "name": "San Gabriel  Jalisco",
                        "latitude": "19.74750000",
                        "longitude": "-103.76527778"
                    },
                    {
                        "id": 142832,
                        "name": "San Gaspar",
                        "latitude": "20.51056000",
                        "longitude": "-102.62361000"
                    },
                    {
                        "id": 142833,
                        "name": "San Gaspar de los Reyes",
                        "latitude": "21.28333333",
                        "longitude": "-102.50000000"
                    },
                    {
                        "id": 142834,
                        "name": "San Ignacio Municipality Jalisco",
                        "latitude": "20.73330000",
                        "longitude": "-102.51700000"
                    },
                    {
                        "id": 142835,
                        "name": "San Isidro",
                        "latitude": "20.79111000",
                        "longitude": "-103.35111000"
                    },
                    {
                        "id": 142836,
                        "name": "San Isidro Mazatepec",
                        "latitude": "20.52284000",
                        "longitude": "-103.61294000"
                    },
                    {
                        "id": 142837,
                        "name": "San Jacintito",
                        "latitude": "20.35400000",
                        "longitude": "-103.92400000"
                    },
                    {
                        "id": 142838,
                        "name": "San Jacinto Jalisco",
                        "latitude": "20.35900000",
                        "longitude": "-103.93300000"
                    },
                    {
                        "id": 142839,
                        "name": "San Joaquín Zorrillos",
                        "latitude": "20.62070000",
                        "longitude": "-103.01546000"
                    },
                    {
                        "id": 142840,
                        "name": "San Jorge",
                        "latitude": "21.37167000",
                        "longitude": "-101.86556000"
                    },
                    {
                        "id": 142842,
                        "name": "San José Casas Caídas",
                        "latitude": "20.42108000",
                        "longitude": "-102.44066000"
                    },
                    {
                        "id": 142841,
                        "name": "San Jose de Gracia Jalisco",
                        "latitude": "20.67444444",
                        "longitude": "-102.56694444"
                    },
                    {
                        "id": 142843,
                        "name": "San José de la Paz",
                        "latitude": "20.55094000",
                        "longitude": "-102.05858000"
                    },
                    {
                        "id": 142844,
                        "name": "San José de las Flores",
                        "latitude": "20.64851000",
                        "longitude": "-102.96616000"
                    },
                    {
                        "id": 142845,
                        "name": "San José de los Reynoso",
                        "latitude": "21.02361111",
                        "longitude": "-102.40583333"
                    },
                    {
                        "id": 142846,
                        "name": "San José del Caliche (El Caliche)",
                        "latitude": "21.12528000",
                        "longitude": "-101.93000000"
                    },
                    {
                        "id": 142847,
                        "name": "San José del Castillo",
                        "latitude": "20.53333333",
                        "longitude": "-103.23333333"
                    },
                    {
                        "id": 142848,
                        "name": "San José del Valle",
                        "latitude": "20.76376000",
                        "longitude": "-105.22813000"
                    },
                    {
                        "id": 142849,
                        "name": "San Juan Cosalá",
                        "latitude": "20.28756000",
                        "longitude": "-103.34109000"
                    },
                    {
                        "id": 142851,
                        "name": "San Juan de los Arcos",
                        "latitude": "20.60508000",
                        "longitude": "-103.71947000"
                    },
                    {
                        "id": 142852,
                        "name": "San Juan de los Lagos",
                        "latitude": "21.24583333",
                        "longitude": "-102.33083333"
                    },
                    {
                        "id": 142850,
                        "name": "San Juan Tecomatlán",
                        "latitude": "20.32838000",
                        "longitude": "-103.10035000"
                    },
                    {
                        "id": 142853,
                        "name": "San Juanito de Escobedo",
                        "latitude": "20.80000000",
                        "longitude": "-104.00000000"
                    },
                    {
                        "id": 142854,
                        "name": "San Julián",
                        "latitude": "21.01666667",
                        "longitude": "-102.16666667"
                    },
                    {
                        "id": 142855,
                        "name": "San Lucas Evangelista",
                        "latitude": "20.40815000",
                        "longitude": "-103.36080000"
                    },
                    {
                        "id": 142856,
                        "name": "San Luciano",
                        "latitude": "20.31426000",
                        "longitude": "-103.41693000"
                    },
                    {
                        "id": 142858,
                        "name": "San Luis de Agua Caliente",
                        "latitude": "20.38317000",
                        "longitude": "-102.82447000"
                    },
                    {
                        "id": 142857,
                        "name": "San Luis Soyatlán",
                        "latitude": "20.19834000",
                        "longitude": "-103.30720000"
                    },
                    {
                        "id": 142859,
                        "name": "San Marcos",
                        "latitude": "20.78333333",
                        "longitude": "-104.18333333"
                    },
                    {
                        "id": 142860,
                        "name": "San Martín de Bolaños",
                        "latitude": "21.50000000",
                        "longitude": "-103.80000000"
                    },
                    {
                        "id": 142861,
                        "name": "San Martín de Hidalgo",
                        "latitude": "20.43538000",
                        "longitude": "-103.92878000"
                    },
                    {
                        "id": 142862,
                        "name": "San Miguel Cuyutlán",
                        "latitude": "20.41633000",
                        "longitude": "-103.38987000"
                    },
                    {
                        "id": 142864,
                        "name": "San Miguel de la Paz",
                        "latitude": "20.37051000",
                        "longitude": "-102.66267000"
                    },
                    {
                        "id": 142865,
                        "name": "San Miguel de la Sierra Ayutla",
                        "latitude": "20.09934000",
                        "longitude": "-104.60035000"
                    },
                    {
                        "id": 142866,
                        "name": "San Miguel el Alto",
                        "latitude": "21.02361111",
                        "longitude": "-102.40583333"
                    },
                    {
                        "id": 142863,
                        "name": "San Miguel Zapotitlán",
                        "latitude": "20.39085000",
                        "longitude": "-102.99428000"
                    },
                    {
                        "id": 142867,
                        "name": "San Nicolas",
                        "latitude": "20.32982000",
                        "longitude": "-103.12881000"
                    },
                    {
                        "id": 142868,
                        "name": "San Nicolás de las Flores",
                        "latitude": "21.29055556",
                        "longitude": "-102.55138889"
                    },
                    {
                        "id": 142869,
                        "name": "San Patricio Jalisco",
                        "latitude": "19.22527778",
                        "longitude": "-104.70111111"
                    },
                    {
                        "id": 142870,
                        "name": "San Pedro",
                        "latitude": "20.22687000",
                        "longitude": "-103.41488000"
                    },
                    {
                        "id": 142871,
                        "name": "San Pedro Itzicán",
                        "latitude": "20.31724000",
                        "longitude": "-102.95406000"
                    },
                    {
                        "id": 142872,
                        "name": "San Sebastian",
                        "latitude": "20.53274000",
                        "longitude": "-103.42804000"
                    },
                    {
                        "id": 142873,
                        "name": "San Sebastián del Oeste",
                        "latitude": "20.85110000",
                        "longitude": "-104.81903000"
                    },
                    {
                        "id": 142874,
                        "name": "San Vicente",
                        "latitude": "20.42833000",
                        "longitude": "-102.65443000"
                    },
                    {
                        "id": 142875,
                        "name": "Santa Anita",
                        "latitude": "20.55090000",
                        "longitude": "-103.44396000"
                    },
                    {
                        "id": 142876,
                        "name": "Santa Cruz de Barcenas",
                        "latitude": "20.66868000",
                        "longitude": "-104.00161000"
                    },
                    {
                        "id": 142877,
                        "name": "Santa Cruz de la Loma (Tepetates)",
                        "latitude": "20.48806000",
                        "longitude": "-103.54972000"
                    },
                    {
                        "id": 142878,
                        "name": "Santa Cruz de la Soledad",
                        "latitude": "20.31746000",
                        "longitude": "-103.15860000"
                    },
                    {
                        "id": 142879,
                        "name": "Santa Cruz de las Flores Tlajomulco de Zúñiga Jalisco",
                        "latitude": "20.48056000",
                        "longitude": "-103.50278000"
                    },
                    {
                        "id": 142880,
                        "name": "Santa Cruz del Astillero",
                        "latitude": "20.74661000",
                        "longitude": "-103.64281000"
                    },
                    {
                        "id": 142881,
                        "name": "Santa Cruz del Valle",
                        "latitude": "20.53333000",
                        "longitude": "-103.43333000"
                    },
                    {
                        "id": 142882,
                        "name": "Santa Cruz el Grande",
                        "latitude": "20.37514000",
                        "longitude": "-102.86382000"
                    },
                    {
                        "id": 142884,
                        "name": "Santa María de Enmedio",
                        "latitude": "21.41938000",
                        "longitude": "-102.22231000"
                    },
                    {
                        "id": 142885,
                        "name": "Santa María de los Ángeles",
                        "latitude": "22.30000000",
                        "longitude": "-103.03333333"
                    },
                    {
                        "id": 142886,
                        "name": "Santa María del Valle",
                        "latitude": "20.87837000",
                        "longitude": "-102.37983000"
                    },
                    {
                        "id": 142883,
                        "name": "Santa María Transpontina",
                        "latitude": "21.41490000",
                        "longitude": "-102.25720000"
                    },
                    {
                        "id": 142887,
                        "name": "Santa Rita",
                        "latitude": "20.44150000",
                        "longitude": "-102.39016000"
                    },
                    {
                        "id": 142888,
                        "name": "Santa Rosa",
                        "latitude": "20.41440000",
                        "longitude": "-103.23534000"
                    },
                    {
                        "id": 142889,
                        "name": "Santa Rosalía Jalisco",
                        "latitude": "20.81805556",
                        "longitude": "-104.08472222"
                    },
                    {
                        "id": 142890,
                        "name": "Santa Teresa",
                        "latitude": "20.91587000",
                        "longitude": "-103.89208000"
                    },
                    {
                        "id": 142891,
                        "name": "Santiaguito",
                        "latitude": "20.77992000",
                        "longitude": "-103.72394000"
                    },
                    {
                        "id": 142892,
                        "name": "Santiaguito (Santiaguito de Velázquez)",
                        "latitude": "20.72533000",
                        "longitude": "-102.23716000"
                    },
                    {
                        "id": 142893,
                        "name": "Sayula",
                        "latitude": "19.88361111",
                        "longitude": "-103.59722222"
                    },
                    {
                        "id": 142894,
                        "name": "Soyatlán de Afuera",
                        "latitude": "19.69083000",
                        "longitude": "-103.28278000"
                    },
                    {
                        "id": 142895,
                        "name": "Soyatlán del Oro",
                        "latitude": "20.30194000",
                        "longitude": "-104.28056000"
                    },
                    {
                        "id": 142896,
                        "name": "Talpa de Allende",
                        "latitude": "20.38084000",
                        "longitude": "-104.82213000"
                    },
                    {
                        "id": 142897,
                        "name": "Tamazula de Gordiano",
                        "latitude": "19.67638889",
                        "longitude": "-103.25000000"
                    },
                    {
                        "id": 142898,
                        "name": "Tamazulita Jalisco",
                        "latitude": "20.20000000",
                        "longitude": "-103.96700000"
                    },
                    {
                        "id": 142899,
                        "name": "Tapalpa",
                        "latitude": "19.94452080",
                        "longitude": "-103.75854800"
                    },
                    {
                        "id": 142900,
                        "name": "Tazumbo",
                        "latitude": "19.29401000",
                        "longitude": "-102.64513000"
                    },
                    {
                        "id": 142901,
                        "name": "Tecalitlán Municipality",
                        "latitude": "19.46666667",
                        "longitude": "-103.30000000"
                    },
                    {
                        "id": 142902,
                        "name": "Techaluta de Montenegro",
                        "latitude": "20.07416667",
                        "longitude": "-103.55277778"
                    },
                    {
                        "id": 142903,
                        "name": "Tecolotlán",
                        "latitude": "20.10000000",
                        "longitude": "-103.83333333"
                    },
                    {
                        "id": 142904,
                        "name": "Tecomates",
                        "latitude": "19.54998000",
                        "longitude": "-104.48528000"
                    },
                    {
                        "id": 142905,
                        "name": "Tecuattitan",
                        "latitude": "20.42545000",
                        "longitude": "-103.02801000"
                    },
                    {
                        "id": 142906,
                        "name": "Telcruz",
                        "latitude": "19.47665000",
                        "longitude": "-104.12581000"
                    },
                    {
                        "id": 142907,
                        "name": "Temastián (La Cantera)",
                        "latitude": "21.97722000",
                        "longitude": "-103.52500000"
                    },
                    {
                        "id": 142908,
                        "name": "Tenamaxtlán",
                        "latitude": "20.21670000",
                        "longitude": "-104.16700000"
                    },
                    {
                        "id": 142909,
                        "name": "Tenayuca",
                        "latitude": "21.50318000",
                        "longitude": "-102.65799000"
                    },
                    {
                        "id": 142910,
                        "name": "Teocaltiche",
                        "latitude": "21.13330000",
                        "longitude": "-102.85000000"
                    },
                    {
                        "id": 142911,
                        "name": "Teocuitatlán de Corona",
                        "latitude": "20.09183333",
                        "longitude": "-103.37847222"
                    },
                    {
                        "id": 142912,
                        "name": "Tepatitlán de Morelos",
                        "latitude": "20.81700000",
                        "longitude": "-102.73300000"
                    },
                    {
                        "id": 142913,
                        "name": "Tepec",
                        "latitude": "19.98964000",
                        "longitude": "-103.64116000"
                    },
                    {
                        "id": 142914,
                        "name": "Tepusco",
                        "latitude": "21.61291000",
                        "longitude": "-102.60211000"
                    },
                    {
                        "id": 142915,
                        "name": "Tequesquitlán",
                        "latitude": "19.38755000",
                        "longitude": "-104.52037000"
                    },
                    {
                        "id": 142916,
                        "name": "Tequila",
                        "latitude": "20.88205000",
                        "longitude": "-103.83599000"
                    },
                    {
                        "id": 142917,
                        "name": "Tesistán",
                        "latitude": "20.80051000",
                        "longitude": "-103.46993000"
                    },
                    {
                        "id": 142918,
                        "name": "Teuchitlán Jalisco",
                        "latitude": "20.68527778",
                        "longitude": "-103.84916667"
                    },
                    {
                        "id": 142919,
                        "name": "Tierras Coloradas",
                        "latitude": "20.72889000",
                        "longitude": "-102.86083000"
                    },
                    {
                        "id": 142920,
                        "name": "Tizapán el Alto",
                        "latitude": "20.03333333",
                        "longitude": "-102.60000000"
                    },
                    {
                        "id": 142921,
                        "name": "Tlacuitapan",
                        "latitude": "21.19829000",
                        "longitude": "-102.12416000"
                    },
                    {
                        "id": 142922,
                        "name": "Tlajomulco de Zuñiga",
                        "latitude": "20.47361111",
                        "longitude": "-103.44305556"
                    },
                    {
                        "id": 142923,
                        "name": "Tlaquepaque",
                        "latitude": "20.65000000",
                        "longitude": "-103.31666667"
                    },
                    {
                        "id": 142924,
                        "name": "Tolimán Municipality",
                        "latitude": "19.40000000",
                        "longitude": "-103.73333333"
                    },
                    {
                        "id": 142925,
                        "name": "Tomatlán",
                        "latitude": "19.93333333",
                        "longitude": "-105.23333333"
                    },
                    {
                        "id": 142926,
                        "name": "Tonalá",
                        "latitude": "20.60990000",
                        "longitude": "-103.20230000"
                    },
                    {
                        "id": 142927,
                        "name": "Tonaya",
                        "latitude": "19.78333333",
                        "longitude": "-103.96666667"
                    },
                    {
                        "id": 142928,
                        "name": "Tonila",
                        "latitude": "19.42611111",
                        "longitude": "-103.53194444"
                    },
                    {
                        "id": 142929,
                        "name": "Totatiche Municipality",
                        "latitude": "21.80000000",
                        "longitude": "-103.33333333"
                    },
                    {
                        "id": 142930,
                        "name": "Tototlán",
                        "latitude": "20.53333333",
                        "longitude": "-102.78333333"
                    },
                    {
                        "id": 142931,
                        "name": "Trapiche de Abra",
                        "latitude": "20.53900000",
                        "longitude": "-103.82000000"
                    },
                    {
                        "id": 142932,
                        "name": "Trejos",
                        "latitude": "20.79439000",
                        "longitude": "-103.19711000"
                    },
                    {
                        "id": 142933,
                        "name": "Tultitlán",
                        "latitude": "19.98378000",
                        "longitude": "-103.52237000"
                    },
                    {
                        "id": 142934,
                        "name": "Tuxcacuesco",
                        "latitude": "19.55000000",
                        "longitude": "-103.86666667"
                    },
                    {
                        "id": 142935,
                        "name": "Tuxcueca",
                        "latitude": "20.06666667",
                        "longitude": "-103.36666667"
                    },
                    {
                        "id": 142936,
                        "name": "Tuxpan",
                        "latitude": "19.55388889",
                        "longitude": "-103.37555556"
                    },
                    {
                        "id": 142937,
                        "name": "Tuxpan de Bolaños",
                        "latitude": "21.87500000",
                        "longitude": "-104.01300000"
                    },
                    {
                        "id": 142938,
                        "name": "Unión de San Antonio",
                        "latitude": "21.12800000",
                        "longitude": "-102.00600000"
                    },
                    {
                        "id": 142939,
                        "name": "Unión de Tula",
                        "latitude": "19.68333333",
                        "longitude": "-104.11666667"
                    },
                    {
                        "id": 142940,
                        "name": "Usmajac",
                        "latitude": "19.87458000",
                        "longitude": "-103.54085000"
                    },
                    {
                        "id": 142942,
                        "name": "Valle de Guadalupe Municipality",
                        "latitude": "21.00000000",
                        "longitude": "-102.61666667"
                    },
                    {
                        "id": 142943,
                        "name": "Valle de Juárez",
                        "latitude": "19.86666667",
                        "longitude": "-102.81666667"
                    },
                    {
                        "id": 142944,
                        "name": "Valle de los Girasoles [Fraccionamiento]",
                        "latitude": "20.42667000",
                        "longitude": "-103.19889000"
                    },
                    {
                        "id": 142941,
                        "name": "Valle Dorado Inn",
                        "latitude": "20.52444000",
                        "longitude": "-103.36194000"
                    },
                    {
                        "id": 142945,
                        "name": "Vaquerias",
                        "latitude": "21.76831000",
                        "longitude": "-101.65385000"
                    },
                    {
                        "id": 142946,
                        "name": "Villa Corona",
                        "latitude": "20.39888889",
                        "longitude": "-103.68888889"
                    },
                    {
                        "id": 142951,
                        "name": "Villa de los Niños",
                        "latitude": "20.40667000",
                        "longitude": "-103.54167000"
                    },
                    {
                        "id": 142947,
                        "name": "Villa Emiliano Zapata",
                        "latitude": "20.16651000",
                        "longitude": "-102.99123000"
                    },
                    {
                        "id": 142948,
                        "name": "Villa Guerrero Municipality",
                        "latitude": "21.88133333",
                        "longitude": "-103.59604167"
                    },
                    {
                        "id": 142949,
                        "name": "Villa Hidalgo",
                        "latitude": "21.66670000",
                        "longitude": "-102.60000000"
                    },
                    {
                        "id": 142952,
                        "name": "Villa las Flores",
                        "latitude": "20.48111000",
                        "longitude": "-103.53083000"
                    },
                    {
                        "id": 142950,
                        "name": "Villa Purificación",
                        "latitude": "19.78583333",
                        "longitude": "-104.70777778"
                    },
                    {
                        "id": 142953,
                        "name": "Villas de la Hacienda [Fraccionamiento]",
                        "latitude": "20.53111000",
                        "longitude": "-103.38278000"
                    },
                    {
                        "id": 142954,
                        "name": "Vista Hermosa",
                        "latitude": "19.69391000",
                        "longitude": "-103.33933000"
                    },
                    {
                        "id": 142955,
                        "name": "Vistas del Maguey [Fraccionamiento]",
                        "latitude": "20.52806000",
                        "longitude": "-102.52333000"
                    },
                    {
                        "id": 142956,
                        "name": "Xochitlán",
                        "latitude": "19.83333333",
                        "longitude": "-103.98333333"
                    },
                    {
                        "id": 142957,
                        "name": "Yahualica de González Gallo",
                        "latitude": "21.17978000",
                        "longitude": "-102.88611000"
                    },
                    {
                        "id": 142958,
                        "name": "Zacoalco de Torres",
                        "latitude": "20.23333333",
                        "longitude": "-103.58333333"
                    },
                    {
                        "id": 142959,
                        "name": "Zalamea",
                        "latitude": "20.31371000",
                        "longitude": "-102.50967000"
                    },
                    {
                        "id": 142960,
                        "name": "Zapopan",
                        "latitude": "20.72027778",
                        "longitude": "-103.39194444"
                    },
                    {
                        "id": 142961,
                        "name": "Zapotiltic",
                        "latitude": "19.63333333",
                        "longitude": "-103.16666667"
                    },
                    {
                        "id": 142963,
                        "name": "Zapotitán de Hidalgo",
                        "latitude": "20.32641000",
                        "longitude": "-103.47841000"
                    },
                    {
                        "id": 142962,
                        "name": "Zapotitlán de Vadillo",
                        "latitude": "19.41666667",
                        "longitude": "-103.60000000"
                    },
                    {
                        "id": 142966,
                        "name": "Zapotlán del Rey",
                        "latitude": "20.45500000",
                        "longitude": "-102.91444444"
                    },
                    {
                        "id": 142965,
                        "name": "Zapotlán El Grande Municipality",
                        "latitude": "19.70360000",
                        "longitude": "-103.46500000"
                    },
                    {
                        "id": 142964,
                        "name": "Zapotlanejo",
                        "latitude": "20.62248000",
                        "longitude": "-103.06766000"
                    },
                    {
                        "id": 142967,
                        "name": "Zula",
                        "latitude": "20.40931000",
                        "longitude": "-102.72816000"
                    }
                ]
            },
            {
                "id": 3474,
                "name": "Michoacán de Ocampo",
                "iso2": "MIC",
                "latitude": "19.56651920",
                "longitude": "-101.70682940",
                "type": "state",
                "cities": [
                    {
                        "id": 68080,
                        "name": "Acuitzio",
                        "latitude": "19.47178000",
                        "longitude": "-101.32921000"
                    },
                    {
                        "id": 68084,
                        "name": "Acuítzio del Canje",
                        "latitude": "19.49585000",
                        "longitude": "-101.33321000"
                    },
                    {
                        "id": 68099,
                        "name": "Agostitlán",
                        "latitude": "19.53818000",
                        "longitude": "-100.61849000"
                    },
                    {
                        "id": 68108,
                        "name": "Agua Caliente",
                        "latitude": "20.06519000",
                        "longitude": "-101.73466000"
                    },
                    {
                        "id": 68129,
                        "name": "Aguililla",
                        "latitude": "18.73742000",
                        "longitude": "-102.78934000"
                    },
                    {
                        "id": 68161,
                        "name": "Ahuirán",
                        "latitude": "19.66574000",
                        "longitude": "-102.07347000"
                    },
                    {
                        "id": 68169,
                        "name": "Ajuno",
                        "latitude": "19.51262000",
                        "longitude": "-101.72280000"
                    },
                    {
                        "id": 76399,
                        "name": "Álvaro Obregón",
                        "latitude": "19.82096000",
                        "longitude": "-101.04008000"
                    },
                    {
                        "id": 68271,
                        "name": "Angahuán",
                        "latitude": "19.54790000",
                        "longitude": "-102.22563000"
                    },
                    {
                        "id": 68272,
                        "name": "Angamacutiro de la Unión",
                        "latitude": "20.14998000",
                        "longitude": "-101.71113000"
                    },
                    {
                        "id": 68276,
                        "name": "Ansihuacuaro",
                        "latitude": "20.19984000",
                        "longitude": "-101.80670000"
                    },
                    {
                        "id": 68282,
                        "name": "Antúnez",
                        "latitude": "19.01451000",
                        "longitude": "-102.20432000"
                    },
                    {
                        "id": 68283,
                        "name": "Antúnez (Morelos)",
                        "latitude": "19.01278000",
                        "longitude": "-102.20389000"
                    },
                    {
                        "id": 68300,
                        "name": "Apatzingán",
                        "latitude": "19.08864000",
                        "longitude": "-102.35704000"
                    },
                    {
                        "id": 68305,
                        "name": "Apeo",
                        "latitude": "19.88722000",
                        "longitude": "-100.34194000"
                    },
                    {
                        "id": 68309,
                        "name": "Apo",
                        "latitude": "19.42722000",
                        "longitude": "-102.41126000"
                    },
                    {
                        "id": 68312,
                        "name": "Aporo",
                        "latitude": "19.67021000",
                        "longitude": "-100.41068000"
                    },
                    {
                        "id": 68314,
                        "name": "Aputzio de Juárez",
                        "latitude": "19.34183000",
                        "longitude": "-100.34689000"
                    },
                    {
                        "id": 68315,
                        "name": "Aquila",
                        "latitude": "18.59970000",
                        "longitude": "-103.50454000"
                    },
                    {
                        "id": 68317,
                        "name": "Aquiles Córdova Morán",
                        "latitude": "19.70685000",
                        "longitude": "-100.53615000"
                    },
                    {
                        "id": 68322,
                        "name": "Aquiles Serdán",
                        "latitude": "20.00357000",
                        "longitude": "-102.21609000"
                    },
                    {
                        "id": 68330,
                        "name": "Arantepacua",
                        "latitude": "19.59580000",
                        "longitude": "-101.96860000"
                    },
                    {
                        "id": 68331,
                        "name": "Aranza",
                        "latitude": "19.66418000",
                        "longitude": "-102.02365000"
                    },
                    {
                        "id": 68332,
                        "name": "Araró",
                        "latitude": "19.91136000",
                        "longitude": "-100.82460000"
                    },
                    {
                        "id": 68350,
                        "name": "Ario de Rayón",
                        "latitude": "20.02651000",
                        "longitude": "-102.34814000"
                    },
                    {
                        "id": 68351,
                        "name": "Ario de Rosales",
                        "latitude": "19.20900000",
                        "longitude": "-101.70743000"
                    },
                    {
                        "id": 68373,
                        "name": "Arteaga",
                        "latitude": "18.35779000",
                        "longitude": "-102.29122000"
                    },
                    {
                        "id": 68388,
                        "name": "Atacheo de Regalado",
                        "latitude": "20.05874000",
                        "longitude": "-102.18703000"
                    },
                    {
                        "id": 68391,
                        "name": "Atapán",
                        "latitude": "19.65057000",
                        "longitude": "-102.42463000"
                    },
                    {
                        "id": 68390,
                        "name": "Atapaneo",
                        "latitude": "19.73892000",
                        "longitude": "-101.11576000"
                    },
                    {
                        "id": 68395,
                        "name": "Atecucario de la Constitución (Atecuario)",
                        "latitude": "20.06444000",
                        "longitude": "-102.23861000"
                    },
                    {
                        "id": 68430,
                        "name": "Atotonilco",
                        "latitude": "19.94111000",
                        "longitude": "-100.22306000"
                    },
                    {
                        "id": 68573,
                        "name": "Belisario Domínguez",
                        "latitude": "19.87140000",
                        "longitude": "-100.97184000"
                    },
                    {
                        "id": 68578,
                        "name": "Bellas Fuentes",
                        "latitude": "19.82132000",
                        "longitude": "-101.67950000"
                    },
                    {
                        "id": 68599,
                        "name": "Benito Juárez",
                        "latitude": "19.23333000",
                        "longitude": "-100.46667000"
                    },
                    {
                        "id": 68623,
                        "name": "Bocaneo (San Pedro)",
                        "latitude": "19.83861000",
                        "longitude": "-100.81722000"
                    },
                    {
                        "id": 68636,
                        "name": "Bonifacio Moreno (El Aguaje)",
                        "latitude": "18.99167000",
                        "longitude": "-102.71083000"
                    },
                    {
                        "id": 68652,
                        "name": "Briseñas",
                        "latitude": "20.25149000",
                        "longitude": "-102.57124000"
                    },
                    {
                        "id": 68653,
                        "name": "Briseñas de Matamoros",
                        "latitude": "20.26821000",
                        "longitude": "-102.56195000"
                    },
                    {
                        "id": 68675,
                        "name": "Buenavista",
                        "latitude": "19.18802000",
                        "longitude": "-102.58471000"
                    },
                    {
                        "id": 68680,
                        "name": "Buenavista de Benito Juárez",
                        "latitude": "18.46034000",
                        "longitude": "-98.63735000"
                    },
                    {
                        "id": 68678,
                        "name": "Buenavista Tomatlán",
                        "latitude": "19.21281000",
                        "longitude": "-102.58735000"
                    },
                    {
                        "id": 68688,
                        "name": "Buenos Aires",
                        "latitude": "18.02444000",
                        "longitude": "-102.28583000"
                    },
                    {
                        "id": 68749,
                        "name": "Caltzontzín",
                        "latitude": "19.42340000",
                        "longitude": "-102.00673000"
                    },
                    {
                        "id": 68782,
                        "name": "Camémbaro",
                        "latitude": "19.42722000",
                        "longitude": "-100.39889000"
                    },
                    {
                        "id": 68772,
                        "name": "Campestre Tarímbaro",
                        "latitude": "19.77500000",
                        "longitude": "-101.12917000"
                    },
                    {
                        "id": 68880,
                        "name": "Cañada de Ramírez",
                        "latitude": "20.29637000",
                        "longitude": "-101.96360000"
                    },
                    {
                        "id": 68793,
                        "name": "Cantabria",
                        "latitude": "19.83994000",
                        "longitude": "-101.72652000"
                    },
                    {
                        "id": 68804,
                        "name": "Capacho",
                        "latitude": "19.96457000",
                        "longitude": "-101.23117000"
                    },
                    {
                        "id": 68814,
                        "name": "Capácuaro",
                        "latitude": "19.54741000",
                        "longitude": "-102.05184000"
                    },
                    {
                        "id": 68810,
                        "name": "Capula",
                        "latitude": "19.70000000",
                        "longitude": "-101.80000000"
                    },
                    {
                        "id": 68845,
                        "name": "Carácuaro",
                        "latitude": "18.98513000",
                        "longitude": "-101.04164000"
                    },
                    {
                        "id": 68831,
                        "name": "Carona",
                        "latitude": "19.52667000",
                        "longitude": "-102.45074000"
                    },
                    {
                        "id": 68866,
                        "name": "Caurio de Guadalupe",
                        "latitude": "19.92455000",
                        "longitude": "-101.86067000"
                    },
                    {
                        "id": 68896,
                        "name": "Cenobio Moreno",
                        "latitude": "19.09629000",
                        "longitude": "-102.50415000"
                    },
                    {
                        "id": 68924,
                        "name": "Cerro Colorado de Ocampo",
                        "latitude": "19.31712000",
                        "longitude": "-100.46538000"
                    },
                    {
                        "id": 68976,
                        "name": "Chapa",
                        "latitude": "19.37976000",
                        "longitude": "-101.66556000"
                    },
                    {
                        "id": 68992,
                        "name": "Charapán",
                        "latitude": "19.65112000",
                        "longitude": "-102.25190000"
                    },
                    {
                        "id": 68991,
                        "name": "Charapendo",
                        "latitude": "19.26383000",
                        "longitude": "-102.06610000"
                    },
                    {
                        "id": 68998,
                        "name": "Charo",
                        "latitude": "19.74966000",
                        "longitude": "-101.04571000"
                    },
                    {
                        "id": 69004,
                        "name": "Chavinda",
                        "latitude": "20.00625000",
                        "longitude": "-102.46015000"
                    },
                    {
                        "id": 69007,
                        "name": "Cherán",
                        "latitude": "19.68536000",
                        "longitude": "-101.95368000"
                    },
                    {
                        "id": 69008,
                        "name": "Cherán Atzicuirín (Cheranástico)",
                        "latitude": "19.70000000",
                        "longitude": "-102.01556000"
                    },
                    {
                        "id": 69067,
                        "name": "Chilchota",
                        "latitude": "19.84190000",
                        "longitude": "-102.08477000"
                    },
                    {
                        "id": 69091,
                        "name": "Chiquimitío",
                        "latitude": "19.79507000",
                        "longitude": "-101.25208000"
                    },
                    {
                        "id": 69095,
                        "name": "Chitejé de Garabato",
                        "latitude": "20.10111000",
                        "longitude": "-100.18899000"
                    },
                    {
                        "id": 69111,
                        "name": "Chucándiro",
                        "latitude": "19.90008000",
                        "longitude": "-101.33380000"
                    },
                    {
                        "id": 69122,
                        "name": "Chupio",
                        "latitude": "19.17836000",
                        "longitude": "-101.44599000"
                    },
                    {
                        "id": 69123,
                        "name": "Churintzio",
                        "latitude": "20.15056000",
                        "longitude": "-102.06469000"
                    },
                    {
                        "id": 69125,
                        "name": "Churumuco de Morelos",
                        "latitude": "18.66333000",
                        "longitude": "-101.64741000"
                    },
                    {
                        "id": 69161,
                        "name": "Ciudad Hidalgo",
                        "latitude": "19.69270000",
                        "longitude": "-100.55445000"
                    },
                    {
                        "id": 69164,
                        "name": "Ciudad Lázaro Cárdenas",
                        "latitude": "17.97066000",
                        "longitude": "-102.22124000"
                    },
                    {
                        "id": 69213,
                        "name": "Coahuayana de Hidalgo",
                        "latitude": "18.70224000",
                        "longitude": "-103.66145000"
                    },
                    {
                        "id": 69212,
                        "name": "Coahuayana Viejo",
                        "latitude": "18.75119000",
                        "longitude": "-103.66798000"
                    },
                    {
                        "id": 69219,
                        "name": "Coajomulco",
                        "latitude": "19.03375000",
                        "longitude": "-99.20428000"
                    },
                    {
                        "id": 69220,
                        "name": "Coalcomán de Vázquez Pallares",
                        "latitude": "18.77750000",
                        "longitude": "-103.16000000"
                    },
                    {
                        "id": 69243,
                        "name": "Cocucho",
                        "latitude": "19.69477000",
                        "longitude": "-102.18925000"
                    },
                    {
                        "id": 69245,
                        "name": "Coeneo de la Libertad",
                        "latitude": "19.82195000",
                        "longitude": "-101.58470000"
                    },
                    {
                        "id": 69254,
                        "name": "Cojumatlán de Régules",
                        "latitude": "20.11858000",
                        "longitude": "-102.85182000"
                    },
                    {
                        "id": 69279,
                        "name": "Colonia Antorcha Campesina (Santa Rosa)",
                        "latitude": "19.68000000",
                        "longitude": "-100.52611000"
                    },
                    {
                        "id": 69280,
                        "name": "Colonia Aquiles Córdoba Morán",
                        "latitude": "19.70667000",
                        "longitude": "-100.53528000"
                    },
                    {
                        "id": 69381,
                        "name": "Colonia de Guadalupe",
                        "latitude": "19.80083000",
                        "longitude": "-100.91556000"
                    },
                    {
                        "id": 69293,
                        "name": "Colonia Ecológica Asociación de Lucha Social (Lucha Social)",
                        "latitude": "19.68833000",
                        "longitude": "-100.60917000"
                    },
                    {
                        "id": 69386,
                        "name": "Colonia el Mirador (Llano del Ejido)",
                        "latitude": "19.67583000",
                        "longitude": "-100.55361000"
                    },
                    {
                        "id": 69297,
                        "name": "Colonia Emiliano Zapata (San Juan Zitácuaro)",
                        "latitude": "19.44778000",
                        "longitude": "-100.30583000"
                    },
                    {
                        "id": 69313,
                        "name": "Colonia Independencia",
                        "latitude": "19.61556000",
                        "longitude": "-100.32389000"
                    },
                    {
                        "id": 69398,
                        "name": "Colonia las Malvinas (Colonia Antorcha)",
                        "latitude": "19.87833000",
                        "longitude": "-102.22583000"
                    },
                    {
                        "id": 69329,
                        "name": "Colonia Miguel Hidalgo",
                        "latitude": "19.78583000",
                        "longitude": "-101.10139000"
                    },
                    {
                        "id": 69378,
                        "name": "Colonia Vista Bella (Lomas del Peaje)",
                        "latitude": "19.49083000",
                        "longitude": "-101.59389000"
                    },
                    {
                        "id": 69415,
                        "name": "Comachuén",
                        "latitude": "19.57132000",
                        "longitude": "-101.90433000"
                    },
                    {
                        "id": 69422,
                        "name": "Comanjá",
                        "latitude": "19.74696000",
                        "longitude": "-101.69080000"
                    },
                    {
                        "id": 69447,
                        "name": "Condémbaro",
                        "latitude": "19.29292000",
                        "longitude": "-102.30401000"
                    },
                    {
                        "id": 69457,
                        "name": "Conjunto Habitacional el Trébol",
                        "latitude": "19.76694000",
                        "longitude": "-101.15472000"
                    },
                    {
                        "id": 69456,
                        "name": "Conjunto Habitacional Villas del Pedregal",
                        "latitude": "19.68361000",
                        "longitude": "-101.30361000"
                    },
                    {
                        "id": 69475,
                        "name": "Copándaro (Copándaro del Cuatro)",
                        "latitude": "19.90057000",
                        "longitude": "-101.65945000"
                    },
                    {
                        "id": 69476,
                        "name": "Copándaro de Galeana",
                        "latitude": "19.89254000",
                        "longitude": "-101.21394000"
                    },
                    {
                        "id": 69495,
                        "name": "Corupo",
                        "latitude": "19.60912000",
                        "longitude": "-102.23479000"
                    },
                    {
                        "id": 69509,
                        "name": "Cotija de la Paz",
                        "latitude": "19.80922000",
                        "longitude": "-102.70198000"
                    },
                    {
                        "id": 69533,
                        "name": "Crescencio Morales (San Mateo)",
                        "latitude": "19.49111000",
                        "longitude": "-100.24306000"
                    },
                    {
                        "id": 69556,
                        "name": "Cuamio",
                        "latitude": "20.03390000",
                        "longitude": "-101.15167000"
                    },
                    {
                        "id": 69558,
                        "name": "Cuanajo",
                        "latitude": "19.48485000",
                        "longitude": "-101.50794000"
                    },
                    {
                        "id": 69564,
                        "name": "Cuaracurío",
                        "latitude": "20.06102000",
                        "longitude": "-101.14774000"
                    },
                    {
                        "id": 69566,
                        "name": "Cuartel la Mesa (El Asoleadero)",
                        "latitude": "19.56972000",
                        "longitude": "-100.28694000"
                    },
                    {
                        "id": 69568,
                        "name": "Cuatro Caminos",
                        "latitude": "18.98826000",
                        "longitude": "-102.10360000"
                    },
                    {
                        "id": 69607,
                        "name": "Cucuchucho",
                        "latitude": "19.58275000",
                        "longitude": "-101.63111000"
                    },
                    {
                        "id": 69629,
                        "name": "Cuitzeo del Porvenir",
                        "latitude": "19.97025000",
                        "longitude": "-101.14290000"
                    },
                    {
                        "id": 69638,
                        "name": "Cumuato",
                        "latitude": "20.25724000",
                        "longitude": "-102.59060000"
                    },
                    {
                        "id": 69643,
                        "name": "Cuparátaro",
                        "latitude": "19.85071000",
                        "longitude": "-101.08903000"
                    },
                    {
                        "id": 69645,
                        "name": "Cupuán del Río",
                        "latitude": "18.77806000",
                        "longitude": "-102.18778000"
                    },
                    {
                        "id": 69646,
                        "name": "Curimeo",
                        "latitude": "20.02043000",
                        "longitude": "-101.69534000"
                    },
                    {
                        "id": 69647,
                        "name": "Curungueo",
                        "latitude": "19.46459000",
                        "longitude": "-100.34340000"
                    },
                    {
                        "id": 69649,
                        "name": "Cuto de la Esperanza",
                        "latitude": "19.73083000",
                        "longitude": "-101.34028000"
                    },
                    {
                        "id": 69650,
                        "name": "Cuto del Porvenir",
                        "latitude": "19.86976000",
                        "longitude": "-101.14339000"
                    },
                    {
                        "id": 69684,
                        "name": "Dieciocho de Marzo",
                        "latitude": "19.23138000",
                        "longitude": "-102.70570000"
                    },
                    {
                        "id": 69690,
                        "name": "División del Norte",
                        "latitude": "19.08193000",
                        "longitude": "-102.61218000"
                    },
                    {
                        "id": 69697,
                        "name": "Doctor Miguel Silva (San Guillermo)",
                        "latitude": "19.96583000",
                        "longitude": "-101.17417000"
                    },
                    {
                        "id": 69713,
                        "name": "Donaciano Ojeda",
                        "latitude": "19.49093000",
                        "longitude": "-100.27952000"
                    },
                    {
                        "id": 69754,
                        "name": "Ecuandureo",
                        "latitude": "20.16188000",
                        "longitude": "-102.19340000"
                    },
                    {
                        "id": 69811,
                        "name": "Ejido el Rosario",
                        "latitude": "19.57185000",
                        "longitude": "-100.27673000"
                    },
                    {
                        "id": 69828,
                        "name": "El Alvareño",
                        "latitude": "20.30078000",
                        "longitude": "-102.43723000"
                    },
                    {
                        "id": 69854,
                        "name": "El Cahulote de Santa Ana",
                        "latitude": "19.07611000",
                        "longitude": "-101.58250000"
                    },
                    {
                        "id": 69866,
                        "name": "El Capulín",
                        "latitude": "20.22795000",
                        "longitude": "-102.48991000"
                    },
                    {
                        "id": 69896,
                        "name": "El Ceñidor",
                        "latitude": "19.00276000",
                        "longitude": "-102.19035000"
                    },
                    {
                        "id": 69940,
                        "name": "El Césped",
                        "latitude": "19.88250000",
                        "longitude": "-100.13972000"
                    },
                    {
                        "id": 69898,
                        "name": "El Chauz",
                        "latitude": "18.89195000",
                        "longitude": "-102.03978000"
                    },
                    {
                        "id": 69910,
                        "name": "El Colegio",
                        "latitude": "19.77333000",
                        "longitude": "-101.17750000"
                    },
                    {
                        "id": 69934,
                        "name": "El Cuenqueño",
                        "latitude": "20.32745000",
                        "longitude": "-102.45760000"
                    },
                    {
                        "id": 69937,
                        "name": "El Cuitzillo Grande",
                        "latitude": "19.77972000",
                        "longitude": "-101.11694000"
                    },
                    {
                        "id": 69949,
                        "name": "El Durazno",
                        "latitude": "19.65314000",
                        "longitude": "-101.17139000"
                    },
                    {
                        "id": 69966,
                        "name": "El Fortín",
                        "latitude": "20.18005000",
                        "longitude": "-102.60051000"
                    },
                    {
                        "id": 69969,
                        "name": "El Fuerte",
                        "latitude": "20.37215000",
                        "longitude": "-102.06709000"
                    },
                    {
                        "id": 69977,
                        "name": "El Guaco",
                        "latitude": "19.06711000",
                        "longitude": "-102.05760000"
                    },
                    {
                        "id": 70013,
                        "name": "El Letrero",
                        "latitude": "18.96339000",
                        "longitude": "-102.11025000"
                    },
                    {
                        "id": 70031,
                        "name": "El Maluco",
                        "latitude": "20.14434000",
                        "longitude": "-101.67528000"
                    },
                    {
                        "id": 70087,
                        "name": "El Paracho",
                        "latitude": "20.10819000",
                        "longitude": "-102.52272000"
                    },
                    {
                        "id": 70096,
                        "name": "El Pedregal",
                        "latitude": "19.51083000",
                        "longitude": "-101.44917000"
                    },
                    {
                        "id": 70110,
                        "name": "El Platanal",
                        "latitude": "20.06200000",
                        "longitude": "-102.57779000"
                    },
                    {
                        "id": 70163,
                        "name": "El Rincón de San Felipe (Tercera Manzana San Felipe)",
                        "latitude": "19.50639000",
                        "longitude": "-100.37278000"
                    },
                    {
                        "id": 70202,
                        "name": "El Sauz de Abajo",
                        "latitude": "20.07500000",
                        "longitude": "-102.26833000"
                    },
                    {
                        "id": 70221,
                        "name": "El Tequesquite",
                        "latitude": "20.30174000",
                        "longitude": "-102.28833000"
                    },
                    {
                        "id": 70228,
                        "name": "El Tigre (Segunda Manzana de Crescencio Morales)",
                        "latitude": "19.47361000",
                        "longitude": "-100.24417000"
                    },
                    {
                        "id": 70287,
                        "name": "Emiliano Zapata",
                        "latitude": "19.33780000",
                        "longitude": "-101.93550000"
                    },
                    {
                        "id": 70314,
                        "name": "Erongarícuaro",
                        "latitude": "19.58881000",
                        "longitude": "-101.72110000"
                    },
                    {
                        "id": 70351,
                        "name": "Estación Queréndaro",
                        "latitude": "19.88285000",
                        "longitude": "-100.94861000"
                    },
                    {
                        "id": 70377,
                        "name": "Etúcuaro",
                        "latitude": "19.41939000",
                        "longitude": "-101.21547000"
                    },
                    {
                        "id": 70383,
                        "name": "Ex-Hacienda de Guadalupe",
                        "latitude": "19.78417000",
                        "longitude": "-101.21472000"
                    },
                    {
                        "id": 70397,
                        "name": "Felipe Carrillo Puerto",
                        "latitude": "19.16325000",
                        "longitude": "-102.70834000"
                    },
                    {
                        "id": 70415,
                        "name": "Fraccionamiento Colinas Universidad",
                        "latitude": "20.01833000",
                        "longitude": "-102.73694000"
                    },
                    {
                        "id": 70420,
                        "name": "Fraccionamiento Ex-Hacienda el Refugio",
                        "latitude": "19.95083000",
                        "longitude": "-102.25639000"
                    },
                    {
                        "id": 70421,
                        "name": "Fraccionamiento Galaxia Tarímbaro",
                        "latitude": "19.76167000",
                        "longitude": "-101.19444000"
                    },
                    {
                        "id": 70424,
                        "name": "Fraccionamiento Laureles Eréndira",
                        "latitude": "19.77222000",
                        "longitude": "-101.13056000"
                    },
                    {
                        "id": 70426,
                        "name": "Fraccionamiento Metrópolis II",
                        "latitude": "19.75639000",
                        "longitude": "-101.20444000"
                    },
                    {
                        "id": 70428,
                        "name": "Fraccionamiento Misión del Valle",
                        "latitude": "19.76556000",
                        "longitude": "-101.12167000"
                    },
                    {
                        "id": 70429,
                        "name": "Fraccionamiento Monte Olivo",
                        "latitude": "19.98472000",
                        "longitude": "-102.25111000"
                    },
                    {
                        "id": 70434,
                        "name": "Fraccionamiento Privadas del Sol",
                        "latitude": "19.75222000",
                        "longitude": "-101.19139000"
                    },
                    {
                        "id": 70441,
                        "name": "Fraccionamiento San Miguel",
                        "latitude": "20.07111000",
                        "longitude": "-102.68667000"
                    },
                    {
                        "id": 70477,
                        "name": "Francisco Sarabia (Cerrito Pelón)",
                        "latitude": "20.03086000",
                        "longitude": "-102.70158000"
                    },
                    {
                        "id": 70478,
                        "name": "Francisco Serrato (San Bartolo)",
                        "latitude": "19.50680000",
                        "longitude": "-100.26000000"
                    },
                    {
                        "id": 70481,
                        "name": "Francisco Villa",
                        "latitude": "19.87500000",
                        "longitude": "-100.93583000"
                    },
                    {
                        "id": 70516,
                        "name": "Gambara",
                        "latitude": "18.93230000",
                        "longitude": "-102.11240000"
                    },
                    {
                        "id": 70533,
                        "name": "General Francisco Villa",
                        "latitude": "18.74304000",
                        "longitude": "-102.24920000"
                    },
                    {
                        "id": 70549,
                        "name": "Gildardo Magaña (Los Ángeles)",
                        "latitude": "19.54889000",
                        "longitude": "-102.45861000"
                    },
                    {
                        "id": 70567,
                        "name": "Guacamayas",
                        "latitude": "18.01932000",
                        "longitude": "-102.21225000"
                    },
                    {
                        "id": 70643,
                        "name": "Guándaro",
                        "latitude": "20.19201000",
                        "longitude": "-101.87398000"
                    },
                    {
                        "id": 70830,
                        "name": "Héroes de Chapultepec (Rodeo de San Antonio)",
                        "latitude": "20.31111000",
                        "longitude": "-101.50250000"
                    },
                    {
                        "id": 70681,
                        "name": "Heróica Zitácuaro",
                        "latitude": "19.43612000",
                        "longitude": "-100.35733000"
                    },
                    {
                        "id": 70723,
                        "name": "Huajúmbaro",
                        "latitude": "19.68210000",
                        "longitude": "-100.74065000"
                    },
                    {
                        "id": 70731,
                        "name": "Huandacareo",
                        "latitude": "19.99136000",
                        "longitude": "-101.27610000"
                    },
                    {
                        "id": 70732,
                        "name": "Huanguitío",
                        "latitude": "19.39707000",
                        "longitude": "-100.48732000"
                    },
                    {
                        "id": 70733,
                        "name": "Huaniqueo de Morales",
                        "latitude": "19.89682000",
                        "longitude": "-101.50450000"
                    },
                    {
                        "id": 70771,
                        "name": "Huetamo de Núñez",
                        "latitude": "18.62926000",
                        "longitude": "-100.89700000"
                    },
                    {
                        "id": 70797,
                        "name": "Huiramba",
                        "latitude": "19.52645000",
                        "longitude": "-101.45959000"
                    },
                    {
                        "id": 70831,
                        "name": "Ibarra",
                        "latitude": "20.22967000",
                        "longitude": "-102.62373000"
                    },
                    {
                        "id": 70833,
                        "name": "Ichán",
                        "latitude": "19.85806000",
                        "longitude": "-102.05417000"
                    },
                    {
                        "id": 70863,
                        "name": "Ihuatzio",
                        "latitude": "19.56647000",
                        "longitude": "-101.61649000"
                    },
                    {
                        "id": 70868,
                        "name": "Indaparapeo",
                        "latitude": "19.78767000",
                        "longitude": "-100.96907000"
                    },
                    {
                        "id": 70873,
                        "name": "Infiernillo (Morelos de Infiernillo)",
                        "latitude": "18.28250000",
                        "longitude": "-101.90111000"
                    },
                    {
                        "id": 70875,
                        "name": "Irapeo",
                        "latitude": "19.69334000",
                        "longitude": "-101.05842000"
                    },
                    {
                        "id": 70877,
                        "name": "Iratzio",
                        "latitude": "19.64583000",
                        "longitude": "-101.41194000"
                    },
                    {
                        "id": 70878,
                        "name": "Irimbo",
                        "latitude": "19.70083000",
                        "longitude": "-100.47847000"
                    },
                    {
                        "id": 70881,
                        "name": "Isaac Arriaga (Santa Ana Mancera)",
                        "latitude": "20.24583000",
                        "longitude": "-101.49361000"
                    },
                    {
                        "id": 70891,
                        "name": "Istaro",
                        "latitude": "19.32806000",
                        "longitude": "-101.75361000"
                    },
                    {
                        "id": 70945,
                        "name": "Ixtlán de los Hervores",
                        "latitude": "20.16895000",
                        "longitude": "-102.39480000"
                    },
                    {
                        "id": 70954,
                        "name": "J. Jesús Díaz Tzirio",
                        "latitude": "19.76667000",
                        "longitude": "-102.39722000"
                    },
                    {
                        "id": 70959,
                        "name": "Jacona",
                        "latitude": "19.94951000",
                        "longitude": "-102.31788000"
                    },
                    {
                        "id": 70996,
                        "name": "Jamaica",
                        "latitude": "19.85577000",
                        "longitude": "-101.13486000"
                    },
                    {
                        "id": 71001,
                        "name": "Janitzio",
                        "latitude": "19.57327000",
                        "longitude": "-101.65189000"
                    },
                    {
                        "id": 71009,
                        "name": "Jarácuaro",
                        "latitude": "19.56058000",
                        "longitude": "-101.67785000"
                    },
                    {
                        "id": 71008,
                        "name": "Jaripeo",
                        "latitude": "19.68026000",
                        "longitude": "-101.08545000"
                    },
                    {
                        "id": 71037,
                        "name": "Jesús del Monte",
                        "latitude": "19.65151000",
                        "longitude": "-101.15227000"
                    },
                    {
                        "id": 71057,
                        "name": "Jiquílpan de Juárez",
                        "latitude": "19.99482000",
                        "longitude": "-102.71969000"
                    },
                    {
                        "id": 71102,
                        "name": "José María Morelos (La Yegüería)",
                        "latitude": "19.86389000",
                        "longitude": "-100.87917000"
                    },
                    {
                        "id": 71134,
                        "name": "Jucutacato",
                        "latitude": "19.37771000",
                        "longitude": "-102.07924000"
                    },
                    {
                        "id": 71140,
                        "name": "Jungapeo de Juárez",
                        "latitude": "19.45915000",
                        "longitude": "-100.49483000"
                    },
                    {
                        "id": 71171,
                        "name": "La Aldea",
                        "latitude": "19.74306000",
                        "longitude": "-101.13500000"
                    },
                    {
                        "id": 71173,
                        "name": "La Angostura",
                        "latitude": "20.19639000",
                        "longitude": "-102.44167000"
                    },
                    {
                        "id": 71191,
                        "name": "La Calera (Nacimientos)",
                        "latitude": "20.27528000",
                        "longitude": "-101.57556000"
                    },
                    {
                        "id": 71261,
                        "name": "La Encarnación",
                        "latitude": "19.41242000",
                        "longitude": "-100.39211000"
                    },
                    {
                        "id": 71263,
                        "name": "La Ermita (Nueva Jerusalén)",
                        "latitude": "19.07444000",
                        "longitude": "-101.50667000"
                    },
                    {
                        "id": 71275,
                        "name": "La Esperanza",
                        "latitude": "20.05559000",
                        "longitude": "-102.41104000"
                    },
                    {
                        "id": 71284,
                        "name": "La Estancia de Amezcua",
                        "latitude": "20.00735000",
                        "longitude": "-102.24487000"
                    },
                    {
                        "id": 71297,
                        "name": "La Fundición (Quinta Manzana)",
                        "latitude": "19.45528000",
                        "longitude": "-100.30361000"
                    },
                    {
                        "id": 71304,
                        "name": "La Goleta",
                        "latitude": "19.73904000",
                        "longitude": "-101.08127000"
                    },
                    {
                        "id": 71316,
                        "name": "La Higuerilla (Los Lirios)",
                        "latitude": "19.92250000",
                        "longitude": "-100.27639000"
                    },
                    {
                        "id": 71317,
                        "name": "La Higuerita (Colonia San Rafael)",
                        "latitude": "19.61861000",
                        "longitude": "-102.48444000"
                    },
                    {
                        "id": 71319,
                        "name": "La Huacana",
                        "latitude": "18.96312000",
                        "longitude": "-101.80720000"
                    },
                    {
                        "id": 71322,
                        "name": "La Ibérica (La Gotera)",
                        "latitude": "19.16472000",
                        "longitude": "-101.91611000"
                    },
                    {
                        "id": 71375,
                        "name": "La Luz",
                        "latitude": "20.15234000",
                        "longitude": "-102.48528000"
                    },
                    {
                        "id": 71391,
                        "name": "La Mesa (La Mesa de Cedano)",
                        "latitude": "19.44861000",
                        "longitude": "-100.32722000"
                    },
                    {
                        "id": 71396,
                        "name": "La Mintzita (Piedra Dura)",
                        "latitude": "19.65194000",
                        "longitude": "-101.27750000"
                    },
                    {
                        "id": 71397,
                        "name": "La Mira",
                        "latitude": "18.03349000",
                        "longitude": "-102.32566000"
                    },
                    {
                        "id": 71398,
                        "name": "La Mira Tumbiscatio",
                        "latitude": "18.68333000",
                        "longitude": "-102.28333000"
                    },
                    {
                        "id": 71401,
                        "name": "La Mojonera",
                        "latitude": "19.70366000",
                        "longitude": "-101.83343000"
                    },
                    {
                        "id": 71414,
                        "name": "La Orilla",
                        "latitude": "17.99583000",
                        "longitude": "-102.22694000"
                    },
                    {
                        "id": 71423,
                        "name": "La Palma",
                        "latitude": "20.14780000",
                        "longitude": "-102.75850000"
                    },
                    {
                        "id": 71427,
                        "name": "La Palma (Las Palmas)",
                        "latitude": "19.77111000",
                        "longitude": "-101.14083000"
                    },
                    {
                        "id": 71445,
                        "name": "La Piedad",
                        "latitude": "20.34239000",
                        "longitude": "-102.03050000"
                    },
                    {
                        "id": 71450,
                        "name": "La Placita de Morelos",
                        "latitude": "18.53270000",
                        "longitude": "-103.58841000"
                    },
                    {
                        "id": 71454,
                        "name": "La Plaza del Limón",
                        "latitude": "20.13524000",
                        "longitude": "-102.43117000"
                    },
                    {
                        "id": 71478,
                        "name": "La Rinconoda",
                        "latitude": "20.04363000",
                        "longitude": "-102.28850000"
                    },
                    {
                        "id": 71486,
                        "name": "La Sauceda",
                        "latitude": "20.09390000",
                        "longitude": "-102.34512000"
                    },
                    {
                        "id": 71494,
                        "name": "La Soledad",
                        "latitude": "19.52111000",
                        "longitude": "-100.48333000"
                    },
                    {
                        "id": 71565,
                        "name": "Lagunillas",
                        "latitude": "19.57070000",
                        "longitude": "-101.41941000"
                    },
                    {
                        "id": 71583,
                        "name": "Las Cañadas",
                        "latitude": "20.29750000",
                        "longitude": "-101.97806000"
                    },
                    {
                        "id": 71585,
                        "name": "Las Cañas",
                        "latitude": "18.56583000",
                        "longitude": "-101.97611000"
                    },
                    {
                        "id": 71588,
                        "name": "Las Cieneguitas",
                        "latitude": "20.24884000",
                        "longitude": "-102.24505000"
                    },
                    {
                        "id": 71609,
                        "name": "Las Letras",
                        "latitude": "20.23083000",
                        "longitude": "-101.43361000"
                    },
                    {
                        "id": 71898,
                        "name": "Lázaro Cárdenas (La Purísima)",
                        "latitude": "19.86972000",
                        "longitude": "-101.02306000"
                    },
                    {
                        "id": 71737,
                        "name": "Loma de los Hoyos",
                        "latitude": "19.03556000",
                        "longitude": "-102.44278000"
                    },
                    {
                        "id": 71758,
                        "name": "Lomas de la Maestranza",
                        "latitude": "19.68750000",
                        "longitude": "-101.33028000"
                    },
                    {
                        "id": 71760,
                        "name": "Lombardía",
                        "latitude": "19.15806000",
                        "longitude": "-102.05111000"
                    },
                    {
                        "id": 71783,
                        "name": "Los Cajones",
                        "latitude": "19.20964000",
                        "longitude": "-101.91317000"
                    },
                    {
                        "id": 71789,
                        "name": "Los Charcos",
                        "latitude": "20.26459000",
                        "longitude": "-102.40815000"
                    },
                    {
                        "id": 71804,
                        "name": "Los Guajes",
                        "latitude": "20.26111000",
                        "longitude": "-102.14164000"
                    },
                    {
                        "id": 71809,
                        "name": "Los Limones",
                        "latitude": "19.60032000",
                        "longitude": "-102.53038000"
                    },
                    {
                        "id": 71831,
                        "name": "Los Pilares",
                        "latitude": "20.32582000",
                        "longitude": "-102.37322000"
                    },
                    {
                        "id": 71852,
                        "name": "Los Reyes de Salgado",
                        "latitude": "19.59042000",
                        "longitude": "-102.47242000"
                    },
                    {
                        "id": 71906,
                        "name": "Macho de Agua",
                        "latitude": "19.44184000",
                        "longitude": "-100.24100000"
                    },
                    {
                        "id": 71914,
                        "name": "Macutzio",
                        "latitude": "19.49917000",
                        "longitude": "-100.35500000"
                    },
                    {
                        "id": 71965,
                        "name": "Manuel Villalongín",
                        "latitude": "20.23750000",
                        "longitude": "-101.52667000"
                    },
                    {
                        "id": 71973,
                        "name": "Manzana de San Luis",
                        "latitude": "19.56236000",
                        "longitude": "-100.27703000"
                    },
                    {
                        "id": 71974,
                        "name": "Manzana la Cofradía",
                        "latitude": "19.54944000",
                        "longitude": "-100.35583000"
                    },
                    {
                        "id": 71979,
                        "name": "Maravatío de Ocampo",
                        "latitude": "19.89113000",
                        "longitude": "-100.44443000"
                    },
                    {
                        "id": 71992,
                        "name": "Mariano Escobedo",
                        "latitude": "19.96481000",
                        "longitude": "-101.06206000"
                    },
                    {
                        "id": 72086,
                        "name": "Mesón Nuevo (Cañada de la Magdalena)",
                        "latitude": "19.81474000",
                        "longitude": "-101.16597000"
                    },
                    {
                        "id": 72147,
                        "name": "Mineral de Angangueo",
                        "latitude": "19.62056000",
                        "longitude": "-100.28436000"
                    },
                    {
                        "id": 72194,
                        "name": "Montaña Monarca (Punta Altozano)",
                        "latitude": "19.66056000",
                        "longitude": "-101.16556000"
                    },
                    {
                        "id": 72214,
                        "name": "Monteleón",
                        "latitude": "20.30841000",
                        "longitude": "-102.20813000"
                    },
                    {
                        "id": 72225,
                        "name": "Morelia",
                        "latitude": "19.70078000",
                        "longitude": "-101.18443000"
                    },
                    {
                        "id": 72231,
                        "name": "Morelos",
                        "latitude": "19.64889000",
                        "longitude": "-101.23889000"
                    },
                    {
                        "id": 72271,
                        "name": "Nahuatzén",
                        "latitude": "19.65506000",
                        "longitude": "-101.91704000"
                    },
                    {
                        "id": 72280,
                        "name": "Naranja de Tapia",
                        "latitude": "19.77708000",
                        "longitude": "-101.75947000"
                    },
                    {
                        "id": 72338,
                        "name": "Nocupétaro",
                        "latitude": "19.04392000",
                        "longitude": "-101.16187000"
                    },
                    {
                        "id": 72367,
                        "name": "Nueva Italia de Ruiz",
                        "latitude": "19.02492000",
                        "longitude": "-102.09318000"
                    },
                    {
                        "id": 72410,
                        "name": "Nuevo San Juan Parangaricutiro",
                        "latitude": "19.41857000",
                        "longitude": "-102.13087000"
                    },
                    {
                        "id": 72417,
                        "name": "Nuevo Urecho",
                        "latitude": "19.16602000",
                        "longitude": "-101.86816000"
                    },
                    {
                        "id": 72424,
                        "name": "Nuevo Zirosto",
                        "latitude": "19.54808000",
                        "longitude": "-102.34747000"
                    },
                    {
                        "id": 72425,
                        "name": "Numarán",
                        "latitude": "20.25580000",
                        "longitude": "-101.94988000"
                    },
                    {
                        "id": 72427,
                        "name": "Nurío",
                        "latitude": "19.65656000",
                        "longitude": "-102.12957000"
                    },
                    {
                        "id": 72439,
                        "name": "Ocampo",
                        "latitude": "19.58241000",
                        "longitude": "-100.33913000"
                    },
                    {
                        "id": 72475,
                        "name": "Ocurio",
                        "latitude": "19.48254000",
                        "longitude": "-100.42344000"
                    },
                    {
                        "id": 72490,
                        "name": "Ojo de Agua de Bucio",
                        "latitude": "19.78048000",
                        "longitude": "-100.72815000"
                    },
                    {
                        "id": 72497,
                        "name": "Ojo de Rana",
                        "latitude": "20.04839000",
                        "longitude": "-102.89314000"
                    },
                    {
                        "id": 72514,
                        "name": "Opopeo",
                        "latitude": "19.41163000",
                        "longitude": "-101.60515000"
                    },
                    {
                        "id": 72579,
                        "name": "Pajacuarán",
                        "latitude": "20.11909000",
                        "longitude": "-102.56623000"
                    },
                    {
                        "id": 72618,
                        "name": "Pamatácuaro",
                        "latitude": "19.69177000",
                        "longitude": "-102.34576000"
                    },
                    {
                        "id": 72622,
                        "name": "Panindícuaro",
                        "latitude": "19.98518000",
                        "longitude": "-101.76096000"
                    },
                    {
                        "id": 72639,
                        "name": "Paracho de Verduzco",
                        "latitude": "19.64745000",
                        "longitude": "-102.04897000"
                    },
                    {
                        "id": 72640,
                        "name": "Paracuaro",
                        "latitude": "19.14926000",
                        "longitude": "-102.21871000"
                    },
                    {
                        "id": 72641,
                        "name": "Parahuén",
                        "latitude": "19.35177000",
                        "longitude": "-101.69204000"
                    },
                    {
                        "id": 73009,
                        "name": "Páreo",
                        "latitude": "19.33259000",
                        "longitude": "-102.45219000"
                    },
                    {
                        "id": 72665,
                        "name": "Parícuaro",
                        "latitude": "19.26133000",
                        "longitude": "-100.45867000"
                    },
                    {
                        "id": 72687,
                        "name": "Paso de Hidalgo (Paso de Álamos)",
                        "latitude": "20.27278000",
                        "longitude": "-102.54528000"
                    },
                    {
                        "id": 72690,
                        "name": "Paso de Núñez (Buenavista)",
                        "latitude": "18.89472000",
                        "longitude": "-100.94667000"
                    },
                    {
                        "id": 72700,
                        "name": "Pastor Ortíz",
                        "latitude": "20.30552000",
                        "longitude": "-101.59588000"
                    },
                    {
                        "id": 72713,
                        "name": "Patuán",
                        "latitude": "19.39231000",
                        "longitude": "-101.91651000"
                    },
                    {
                        "id": 73010,
                        "name": "Pátzcuaro",
                        "latitude": "19.51594000",
                        "longitude": "-101.60887000"
                    },
                    {
                        "id": 72720,
                        "name": "Pedernales",
                        "latitude": "19.14133000",
                        "longitude": "-101.46889000"
                    },
                    {
                        "id": 72751,
                        "name": "Peña del Panal",
                        "latitude": "19.77333000",
                        "longitude": "-101.18944000"
                    },
                    {
                        "id": 72729,
                        "name": "Penjamillo de Degollado",
                        "latitude": "20.10410000",
                        "longitude": "-101.93444000"
                    },
                    {
                        "id": 72732,
                        "name": "Peribán de Ramos",
                        "latitude": "19.52010000",
                        "longitude": "-102.41397000"
                    },
                    {
                        "id": 72762,
                        "name": "Pichátaro",
                        "latitude": "19.57289000",
                        "longitude": "-101.80737000"
                    },
                    {
                        "id": 72784,
                        "name": "Pinzándaro",
                        "latitude": "19.10928000",
                        "longitude": "-102.54082000"
                    },
                    {
                        "id": 72844,
                        "name": "Pomacuarán",
                        "latitude": "19.62198000",
                        "longitude": "-102.10286000"
                    },
                    {
                        "id": 72869,
                        "name": "Poturo",
                        "latitude": "18.82592000",
                        "longitude": "-101.61335000"
                    },
                    {
                        "id": 72889,
                        "name": "Presa del Rosario",
                        "latitude": "19.06789000",
                        "longitude": "-102.40909000"
                    },
                    {
                        "id": 73006,
                        "name": "Puácuaro",
                        "latitude": "19.60280000",
                        "longitude": "-101.67419000"
                    },
                    {
                        "id": 72951,
                        "name": "Pueblo Viejo",
                        "latitude": "19.77638000",
                        "longitude": "-100.81474000"
                    },
                    {
                        "id": 72960,
                        "name": "Puentecillas (Tercera Manzana de Zirahuato)",
                        "latitude": "19.50500000",
                        "longitude": "-100.40500000"
                    },
                    {
                        "id": 72976,
                        "name": "Puerto de Buenavista (Lázaro Cárdenas)",
                        "latitude": "19.68806000",
                        "longitude": "-101.12722000"
                    },
                    {
                        "id": 72988,
                        "name": "Purechucho",
                        "latitude": "18.58227000",
                        "longitude": "-100.88843000"
                    },
                    {
                        "id": 72992,
                        "name": "Purépero de Echáiz",
                        "latitude": "19.91039000",
                        "longitude": "-102.00625000"
                    },
                    {
                        "id": 72991,
                        "name": "Puruándiro",
                        "latitude": "20.08886000",
                        "longitude": "-101.51579000"
                    },
                    {
                        "id": 72990,
                        "name": "Puruarán",
                        "latitude": "19.09630000",
                        "longitude": "-101.52234000"
                    },
                    {
                        "id": 73023,
                        "name": "Queréndaro",
                        "latitude": "19.69745000",
                        "longitude": "-100.84379000"
                    },
                    {
                        "id": 73033,
                        "name": "Quinceo",
                        "latitude": "19.59470000",
                        "longitude": "-101.99977000"
                    },
                    {
                        "id": 73042,
                        "name": "Quiroga",
                        "latitude": "19.66557000",
                        "longitude": "-101.52287000"
                    },
                    {
                        "id": 73075,
                        "name": "Rancho Viejo",
                        "latitude": "19.24878000",
                        "longitude": "-100.41737000"
                    },
                    {
                        "id": 73089,
                        "name": "Real Hacienda (Metrópolis)",
                        "latitude": "19.75056000",
                        "longitude": "-101.19694000"
                    },
                    {
                        "id": 73125,
                        "name": "Rincón de Cedeños (Rincón de Dolores)",
                        "latitude": "19.67806000",
                        "longitude": "-100.57639000"
                    },
                    {
                        "id": 73126,
                        "name": "Rincón de Curungueo",
                        "latitude": "19.48336000",
                        "longitude": "-100.34414000"
                    },
                    {
                        "id": 73131,
                        "name": "Rincón de Nicolás Romero (Cedros Tercera Manzana)",
                        "latitude": "19.41361000",
                        "longitude": "-100.29750000"
                    },
                    {
                        "id": 73177,
                        "name": "Río Grande",
                        "latitude": "20.34417000",
                        "longitude": "-102.00556000"
                    },
                    {
                        "id": 73154,
                        "name": "Romero de Guzmán",
                        "latitude": "20.02974000",
                        "longitude": "-102.25876000"
                    },
                    {
                        "id": 73155,
                        "name": "Romero de Torres",
                        "latitude": "20.02435000",
                        "longitude": "-102.25295000"
                    },
                    {
                        "id": 73203,
                        "name": "Sahuayo",
                        "latitude": "20.05792000",
                        "longitude": "-102.75119000"
                    },
                    {
                        "id": 73204,
                        "name": "Sahuayo de Morelos",
                        "latitude": "20.05859000",
                        "longitude": "-102.71575000"
                    },
                    {
                        "id": 73212,
                        "name": "Salguero",
                        "latitude": "18.41401000",
                        "longitude": "-100.62583000"
                    },
                    {
                        "id": 73261,
                        "name": "San Agustín del Maíz",
                        "latitude": "19.89910000",
                        "longitude": "-101.16467000"
                    },
                    {
                        "id": 73263,
                        "name": "San Agustín del Pulque",
                        "latitude": "19.96267000",
                        "longitude": "-101.07327000"
                    },
                    {
                        "id": 73275,
                        "name": "San Andrés Coru",
                        "latitude": "19.46680000",
                        "longitude": "-101.94490000"
                    },
                    {
                        "id": 73305,
                        "name": "San Andrés Ziróndaro",
                        "latitude": "19.66943000",
                        "longitude": "-101.63221000"
                    },
                    {
                        "id": 73317,
                        "name": "San Antonio",
                        "latitude": "19.66722000",
                        "longitude": "-101.26806000"
                    },
                    {
                        "id": 73389,
                        "name": "San Antonio la Labor",
                        "latitude": "19.02942000",
                        "longitude": "-102.30075000"
                    },
                    {
                        "id": 73340,
                        "name": "San Antonio Molinos",
                        "latitude": "20.07533000",
                        "longitude": "-100.21501000"
                    },
                    {
                        "id": 73350,
                        "name": "San Antonio Tariácuri",
                        "latitude": "19.88249000",
                        "longitude": "-101.74715000"
                    },
                    {
                        "id": 73359,
                        "name": "San Antonio Villalongín",
                        "latitude": "19.53456000",
                        "longitude": "-100.75271000"
                    },
                    {
                        "id": 73404,
                        "name": "San Bartolo Cuitareo",
                        "latitude": "19.65139000",
                        "longitude": "-100.60111000"
                    },
                    {
                        "id": 73429,
                        "name": "San Benito",
                        "latitude": "19.70714000",
                        "longitude": "-102.32170000"
                    },
                    {
                        "id": 73433,
                        "name": "San Bernabé de las Canteras",
                        "latitude": "19.76639000",
                        "longitude": "-101.16333000"
                    },
                    {
                        "id": 73530,
                        "name": "San Felipe de los Herreros",
                        "latitude": "19.61701000",
                        "longitude": "-102.18128000"
                    },
                    {
                        "id": 73533,
                        "name": "San Felipe los Alzati (Colonia Nueva)",
                        "latitude": "19.48972000",
                        "longitude": "-100.37389000"
                    },
                    {
                        "id": 73587,
                        "name": "San Francisco Peribán",
                        "latitude": "19.55601000",
                        "longitude": "-102.39844000"
                    },
                    {
                        "id": 73641,
                        "name": "San Gregorio",
                        "latitude": "20.19470000",
                        "longitude": "-102.54890000"
                    },
                    {
                        "id": 73671,
                        "name": "San Isidro",
                        "latitude": "19.76806000",
                        "longitude": "-100.20361000"
                    },
                    {
                        "id": 73673,
                        "name": "San Isidro Alta Huerta",
                        "latitude": "19.72472000",
                        "longitude": "-100.63889000"
                    },
                    {
                        "id": 73713,
                        "name": "San Jerónimo Purenchecuaro",
                        "latitude": "19.67924000",
                        "longitude": "-101.61230000"
                    },
                    {
                        "id": 73762,
                        "name": "San José Cuaro",
                        "latitude": "19.98833000",
                        "longitude": "-101.25194000"
                    },
                    {
                        "id": 73817,
                        "name": "San José de Gracia",
                        "latitude": "19.98966000",
                        "longitude": "-103.02198000"
                    },
                    {
                        "id": 73766,
                        "name": "San José Huipana",
                        "latitude": "20.27752000",
                        "longitude": "-101.46990000"
                    },
                    {
                        "id": 73875,
                        "name": "San Juan Benito Juárez (San Juan Tararameo)",
                        "latitude": "19.91694000",
                        "longitude": "-101.12861000"
                    },
                    {
                        "id": 73889,
                        "name": "San Juan De Los Platanos",
                        "latitude": "19.13710000",
                        "longitude": "-102.43929000"
                    },
                    {
                        "id": 73964,
                        "name": "San Juan de Viña",
                        "latitude": "19.34427000",
                        "longitude": "-101.47866000"
                    },
                    {
                        "id": 73983,
                        "name": "San Juanito Itzícuaro",
                        "latitude": "19.67572000",
                        "longitude": "-101.25457000"
                    },
                    {
                        "id": 73994,
                        "name": "San Lorenzo",
                        "latitude": "19.98917000",
                        "longitude": "-101.64583000"
                    },
                    {
                        "id": 74004,
                        "name": "San Lorenzo Itzícuaro",
                        "latitude": "19.67673000",
                        "longitude": "-101.28096000"
                    },
                    {
                        "id": 74009,
                        "name": "San Lorenzo Queréndaro",
                        "latitude": "19.66750000",
                        "longitude": "-100.48861000"
                    },
                    {
                        "id": 74022,
                        "name": "San Lucas",
                        "latitude": "18.59031000",
                        "longitude": "-100.78529000"
                    },
                    {
                        "id": 74028,
                        "name": "San Lucas Huarirapeo (La Mesa de San Lucas)",
                        "latitude": "19.67861000",
                        "longitude": "-100.62389000"
                    },
                    {
                        "id": 74032,
                        "name": "San Lucas Pío",
                        "latitude": "19.79361000",
                        "longitude": "-100.92472000"
                    },
                    {
                        "id": 74111,
                        "name": "San Martín Totolán",
                        "latitude": "19.98520000",
                        "longitude": "-102.68017000"
                    },
                    {
                        "id": 74178,
                        "name": "San Miguel Epejan",
                        "latitude": "20.06632000",
                        "longitude": "-101.81584000"
                    },
                    {
                        "id": 74257,
                        "name": "San Nicolás Obispo",
                        "latitude": "19.65272000",
                        "longitude": "-101.31571000"
                    },
                    {
                        "id": 74410,
                        "name": "San Pedro de los Sauces",
                        "latitude": "19.78639000",
                        "longitude": "-101.13778000"
                    },
                    {
                        "id": 74348,
                        "name": "San Pedro Jácuaro",
                        "latitude": "19.71496000",
                        "longitude": "-100.64493000"
                    },
                    {
                        "id": 74433,
                        "name": "San Rafael Tecario",
                        "latitude": "19.21080000",
                        "longitude": "-101.50627000"
                    },
                    {
                        "id": 74456,
                        "name": "San Sebastián",
                        "latitude": "19.57158000",
                        "longitude": "-102.48066000"
                    },
                    {
                        "id": 74524,
                        "name": "Santa Ana",
                        "latitude": "19.58222000",
                        "longitude": "-100.46889000"
                    },
                    {
                        "id": 74527,
                        "name": "Santa Ana Amatlán",
                        "latitude": "19.16097000",
                        "longitude": "-102.54059000"
                    },
                    {
                        "id": 74530,
                        "name": "Santa Ana Chapitiro",
                        "latitude": "19.52611000",
                        "longitude": "-101.65250000"
                    },
                    {
                        "id": 74554,
                        "name": "Santa Ana de Guerrero (El Cascabel)",
                        "latitude": "19.27639000",
                        "longitude": "-100.44139000"
                    },
                    {
                        "id": 74539,
                        "name": "Santa Ana Maya",
                        "latitude": "20.00690000",
                        "longitude": "-101.02189000"
                    },
                    {
                        "id": 74552,
                        "name": "Santa Ana Zirosto",
                        "latitude": "19.53512000",
                        "longitude": "-102.32442000"
                    },
                    {
                        "id": 74569,
                        "name": "Santa Casilda",
                        "latitude": "19.15284000",
                        "longitude": "-101.95373000"
                    },
                    {
                        "id": 74577,
                        "name": "Santa Catarina",
                        "latitude": "19.29033000",
                        "longitude": "-102.39845000"
                    },
                    {
                        "id": 74603,
                        "name": "Santa Clara de Valladares",
                        "latitude": "19.63658000",
                        "longitude": "-102.49120000"
                    },
                    {
                        "id": 74604,
                        "name": "Santa Clara del Cobre",
                        "latitude": "19.40580000",
                        "longitude": "-101.63998000"
                    },
                    {
                        "id": 74605,
                        "name": "Santa Clara del Tule",
                        "latitude": "19.82389000",
                        "longitude": "-100.82694000"
                    },
                    {
                        "id": 74655,
                        "name": "Santa Elena",
                        "latitude": "19.85861000",
                        "longitude": "-100.40833000"
                    },
                    {
                        "id": 74664,
                        "name": "Santa Fé de la Laguna",
                        "latitude": "19.67257000",
                        "longitude": "-101.55487000"
                    },
                    {
                        "id": 74660,
                        "name": "Santa Fe del Río",
                        "latitude": "20.20358000",
                        "longitude": "-101.82695000"
                    },
                    {
                        "id": 74681,
                        "name": "Santa Juana",
                        "latitude": "19.43019000",
                        "longitude": "-101.56106000"
                    },
                    {
                        "id": 74809,
                        "name": "Santa María de los Ángeles",
                        "latitude": "19.78629000",
                        "longitude": "-100.19938000"
                    },
                    {
                        "id": 74744,
                        "name": "Santa María Huiramangaro (San Juan Tumbio)",
                        "latitude": "19.51306000",
                        "longitude": "-101.76528000"
                    },
                    {
                        "id": 74790,
                        "name": "Santa María Urapicho",
                        "latitude": "19.68139000",
                        "longitude": "-102.11194000"
                    },
                    {
                        "id": 74840,
                        "name": "Santa Rosa (Santa Bárbara)",
                        "latitude": "19.38333000",
                        "longitude": "-102.03611000"
                    },
                    {
                        "id": 74882,
                        "name": "Santiago Azajo",
                        "latitude": "19.70666000",
                        "longitude": "-101.68659000"
                    },
                    {
                        "id": 74937,
                        "name": "Santiago Puriatzícuaro",
                        "latitude": "19.88306000",
                        "longitude": "-100.58861000"
                    },
                    {
                        "id": 74941,
                        "name": "Santiago Tangamandapio",
                        "latitude": "19.95568000",
                        "longitude": "-102.43546000"
                    },
                    {
                        "id": 74970,
                        "name": "Santiago Undameo",
                        "latitude": "19.59515000",
                        "longitude": "-101.28480000"
                    },
                    {
                        "id": 75059,
                        "name": "Senguio",
                        "latitude": "19.75386000",
                        "longitude": "-100.33771000"
                    },
                    {
                        "id": 75064,
                        "name": "Sevina",
                        "latitude": "19.62898000",
                        "longitude": "-101.90057000"
                    },
                    {
                        "id": 75152,
                        "name": "Susupuato de Guerrero",
                        "latitude": "19.21505000",
                        "longitude": "-100.40798000"
                    },
                    {
                        "id": 75164,
                        "name": "Tacámbaro",
                        "latitude": "19.24033000",
                        "longitude": "-101.44730000"
                    },
                    {
                        "id": 75165,
                        "name": "Tacámbaro de Codallos",
                        "latitude": "19.23502000",
                        "longitude": "-101.45824000"
                    },
                    {
                        "id": 75166,
                        "name": "Tacátzcuaro",
                        "latitude": "19.73009000",
                        "longitude": "-102.54742000"
                    },
                    {
                        "id": 75157,
                        "name": "Tacicuaro",
                        "latitude": "19.66980000",
                        "longitude": "-101.35967000"
                    },
                    {
                        "id": 75163,
                        "name": "Tacuro (Santa María Tacuro)",
                        "latitude": "19.85696000",
                        "longitude": "-102.05084000"
                    },
                    {
                        "id": 75167,
                        "name": "Tafetán",
                        "latitude": "19.41876000",
                        "longitude": "-100.90817000"
                    },
                    {
                        "id": 75199,
                        "name": "Tanaco",
                        "latitude": "19.73943000",
                        "longitude": "-102.08146000"
                    },
                    {
                        "id": 75205,
                        "name": "Tancítaro",
                        "latitude": "19.33843000",
                        "longitude": "-102.36264000"
                    },
                    {
                        "id": 75208,
                        "name": "Tangancícuaro",
                        "latitude": "19.88294000",
                        "longitude": "-102.22859000"
                    },
                    {
                        "id": 75211,
                        "name": "Tanhuato de Guerrero",
                        "latitude": "20.28552000",
                        "longitude": "-102.33113000"
                    },
                    {
                        "id": 75230,
                        "name": "Tarejero",
                        "latitude": "19.81941000",
                        "longitude": "-101.71564000"
                    },
                    {
                        "id": 75231,
                        "name": "Taretán",
                        "latitude": "19.33420000",
                        "longitude": "-101.91849000"
                    },
                    {
                        "id": 75235,
                        "name": "Tarímbaro",
                        "latitude": "19.79578000",
                        "longitude": "-101.17782000"
                    },
                    {
                        "id": 75243,
                        "name": "Tavera",
                        "latitude": "19.06126000",
                        "longitude": "-101.55910000"
                    },
                    {
                        "id": 75266,
                        "name": "Tecario",
                        "latitude": "19.23247000",
                        "longitude": "-101.54443000"
                    },
                    {
                        "id": 75282,
                        "name": "Tecomatán",
                        "latitude": "20.11514000",
                        "longitude": "-102.49634000"
                    },
                    {
                        "id": 75393,
                        "name": "Tepalcatepec",
                        "latitude": "19.18666000",
                        "longitude": "-102.84930000"
                    },
                    {
                        "id": 75454,
                        "name": "Tepuxtepec",
                        "latitude": "19.99135000",
                        "longitude": "-100.22566000"
                    },
                    {
                        "id": 75557,
                        "name": "Tierras Coloradas (San Pedro)",
                        "latitude": "19.71889000",
                        "longitude": "-100.64639000"
                    },
                    {
                        "id": 75577,
                        "name": "Tingambato",
                        "latitude": "19.50109000",
                        "longitude": "-101.85327000"
                    },
                    {
                        "id": 75578,
                        "name": "Tingüindín",
                        "latitude": "19.73921000",
                        "longitude": "-102.48120000"
                    },
                    {
                        "id": 75580,
                        "name": "Tiquicheo",
                        "latitude": "18.90301000",
                        "longitude": "-100.73731000"
                    },
                    {
                        "id": 75581,
                        "name": "Tiquicheo de Nicolás Romero",
                        "latitude": "19.08089000",
                        "longitude": "-100.82552000"
                    },
                    {
                        "id": 75582,
                        "name": "Tiríndaro",
                        "latitude": "19.77121000",
                        "longitude": "-101.74350000"
                    },
                    {
                        "id": 75583,
                        "name": "Tirípetio",
                        "latitude": "19.54897000",
                        "longitude": "-101.34667000"
                    },
                    {
                        "id": 75650,
                        "name": "Tlalpujahua de Rayón",
                        "latitude": "19.80523000",
                        "longitude": "-100.17409000"
                    },
                    {
                        "id": 75718,
                        "name": "Tocumbo",
                        "latitude": "19.70177000",
                        "longitude": "-102.52323000"
                    },
                    {
                        "id": 75729,
                        "name": "Tomendán",
                        "latitude": "19.31142000",
                        "longitude": "-101.86030000"
                    },
                    {
                        "id": 75747,
                        "name": "Toreo Bajo (El Toreo Bajo)",
                        "latitude": "19.44472000",
                        "longitude": "-102.00444000"
                    },
                    {
                        "id": 75806,
                        "name": "Tumbiscatío de Ruiz",
                        "latitude": "18.52667000",
                        "longitude": "-102.37823000"
                    },
                    {
                        "id": 75808,
                        "name": "Tungareo",
                        "latitude": "19.90833000",
                        "longitude": "-100.36639000"
                    },
                    {
                        "id": 75815,
                        "name": "Turicato",
                        "latitude": "19.05402000",
                        "longitude": "-101.41899000"
                    },
                    {
                        "id": 75817,
                        "name": "Turícuaro",
                        "latitude": "19.57085000",
                        "longitude": "-101.93747000"
                    },
                    {
                        "id": 75820,
                        "name": "Tuxpan",
                        "latitude": "19.56788000",
                        "longitude": "-100.46189000"
                    },
                    {
                        "id": 75830,
                        "name": "Tuzantla",
                        "latitude": "19.20289000",
                        "longitude": "-100.56679000"
                    },
                    {
                        "id": 75843,
                        "name": "Tzintzimeo",
                        "latitude": "19.87028000",
                        "longitude": "-100.97778000"
                    },
                    {
                        "id": 75844,
                        "name": "Tzintzingareo",
                        "latitude": "19.76376000",
                        "longitude": "-100.48524000"
                    },
                    {
                        "id": 75845,
                        "name": "Tzintzuntzan",
                        "latitude": "19.60593000",
                        "longitude": "-101.54798000"
                    },
                    {
                        "id": 75847,
                        "name": "Tziritzícuaro",
                        "latitude": "19.95609000",
                        "longitude": "-100.45945000"
                    },
                    {
                        "id": 75849,
                        "name": "Tzitzio",
                        "latitude": "19.44492000",
                        "longitude": "-100.90849000"
                    },
                    {
                        "id": 75861,
                        "name": "Ucareo",
                        "latitude": "19.89850000",
                        "longitude": "-100.68595000"
                    },
                    {
                        "id": 75892,
                        "name": "Uricho",
                        "latitude": "19.57104000",
                        "longitude": "-101.71614000"
                    },
                    {
                        "id": 75893,
                        "name": "Uripitio",
                        "latitude": "19.95338000",
                        "longitude": "-100.53800000"
                    },
                    {
                        "id": 75898,
                        "name": "Uruapan",
                        "latitude": "19.41116000",
                        "longitude": "-102.05644000"
                    },
                    {
                        "id": 75899,
                        "name": "Uruétaro",
                        "latitude": "19.79056000",
                        "longitude": "-101.08778000"
                    },
                    {
                        "id": 75902,
                        "name": "Uspero",
                        "latitude": "19.01421000",
                        "longitude": "-102.26907000"
                    },
                    {
                        "id": 75918,
                        "name": "Valle Verde",
                        "latitude": "19.47250000",
                        "longitude": "-100.35528000"
                    },
                    {
                        "id": 75961,
                        "name": "Venustiano Carranza",
                        "latitude": "20.11553000",
                        "longitude": "-102.65391000"
                    },
                    {
                        "id": 76019,
                        "name": "Villa Jiménez",
                        "latitude": "19.92306000",
                        "longitude": "-101.74694000"
                    },
                    {
                        "id": 76030,
                        "name": "Villa Madero",
                        "latitude": "19.39150000",
                        "longitude": "-101.27883000"
                    },
                    {
                        "id": 76032,
                        "name": "Villa Magna",
                        "latitude": "19.68361000",
                        "longitude": "-101.32667000"
                    },
                    {
                        "id": 76057,
                        "name": "Villa Victoria",
                        "latitude": "18.75749000",
                        "longitude": "-103.36967000"
                    },
                    {
                        "id": 76083,
                        "name": "Villamar",
                        "latitude": "20.02040000",
                        "longitude": "-102.59655000"
                    },
                    {
                        "id": 76090,
                        "name": "Villas de la Loma",
                        "latitude": "19.69000000",
                        "longitude": "-101.29944000"
                    },
                    {
                        "id": 76097,
                        "name": "Vista Hermosa de Negrete",
                        "latitude": "20.27169000",
                        "longitude": "-102.47488000"
                    },
                    {
                        "id": 76249,
                        "name": "Yurécuaro",
                        "latitude": "20.33606000",
                        "longitude": "-102.28382000"
                    },
                    {
                        "id": 76266,
                        "name": "Zacapu",
                        "latitude": "19.82189000",
                        "longitude": "-101.78928000"
                    },
                    {
                        "id": 76294,
                        "name": "Zamora",
                        "latitude": "19.98550000",
                        "longitude": "-102.28387000"
                    },
                    {
                        "id": 76321,
                        "name": "Zaragoza (Puerto de Medina)",
                        "latitude": "19.87389000",
                        "longitude": "-100.11778000"
                    },
                    {
                        "id": 76332,
                        "name": "Zicuicho",
                        "latitude": "19.66309000",
                        "longitude": "-102.33314000"
                    },
                    {
                        "id": 76333,
                        "name": "Zicuirán",
                        "latitude": "18.87788000",
                        "longitude": "-101.96867000"
                    },
                    {
                        "id": 76343,
                        "name": "Zináparo",
                        "latitude": "20.16937000",
                        "longitude": "-101.99923000"
                    },
                    {
                        "id": 76342,
                        "name": "Zinapécuaro",
                        "latitude": "19.86006000",
                        "longitude": "-100.82857000"
                    },
                    {
                        "id": 76345,
                        "name": "Ziquítaro",
                        "latitude": "20.06212000",
                        "longitude": "-101.89033000"
                    },
                    {
                        "id": 76346,
                        "name": "Ziracuaretiro",
                        "latitude": "19.41887000",
                        "longitude": "-101.90884000"
                    },
                    {
                        "id": 76347,
                        "name": "Zirahuato de los Bernal",
                        "latitude": "19.52124000",
                        "longitude": "-100.40662000"
                    },
                    {
                        "id": 76348,
                        "name": "Zirahuén",
                        "latitude": "19.45334000",
                        "longitude": "-101.73170000"
                    },
                    {
                        "id": 76349,
                        "name": "Zirimícuaro",
                        "latitude": "19.40792000",
                        "longitude": "-101.95840000"
                    },
                    {
                        "id": 76389,
                        "name": "Zurumbeneo",
                        "latitude": "19.69981000",
                        "longitude": "-101.01113000"
                    }
                ]
            },
            {
                "id": 3465,
                "name": "Morelos",
                "iso2": "MOR",
                "latitude": "18.68130490",
                "longitude": "-99.10134980",
                "type": "state",
                "cities": [
                    {
                        "id": 68020,
                        "name": "Abelardo L. Rodríguez",
                        "latitude": "18.73750000",
                        "longitude": "-98.98528000"
                    },
                    {
                        "id": 68033,
                        "name": "Acamilpa",
                        "latitude": "18.71695000",
                        "longitude": "-99.15724000"
                    },
                    {
                        "id": 68060,
                        "name": "Achichipico",
                        "latitude": "18.94861000",
                        "longitude": "-98.82611000"
                    },
                    {
                        "id": 68090,
                        "name": "Adolfo López Mateos",
                        "latitude": "19.80083000",
                        "longitude": "-100.00055000"
                    },
                    {
                        "id": 68156,
                        "name": "Ahuehuetzingo",
                        "latitude": "18.68024000",
                        "longitude": "-99.30834000"
                    },
                    {
                        "id": 68199,
                        "name": "Alfredo V. Bonfil (Chacampalco)",
                        "latitude": "18.65528000",
                        "longitude": "-99.15417000"
                    },
                    {
                        "id": 68219,
                        "name": "Alpuyeca",
                        "latitude": "18.74006000",
                        "longitude": "-99.25937000"
                    },
                    {
                        "id": 68231,
                        "name": "Amacuitlapilco",
                        "latitude": "18.69611000",
                        "longitude": "-98.81167000"
                    },
                    {
                        "id": 68232,
                        "name": "Amacuzac",
                        "latitude": "18.60056000",
                        "longitude": "-99.37252000"
                    },
                    {
                        "id": 68245,
                        "name": "Amatlán de Quetzalcoatl",
                        "latitude": "18.97537000",
                        "longitude": "-99.03742000"
                    },
                    {
                        "id": 68249,
                        "name": "Amayuca",
                        "latitude": "18.72408000",
                        "longitude": "-98.79812000"
                    },
                    {
                        "id": 68255,
                        "name": "Amilcingo",
                        "latitude": "18.74274000",
                        "longitude": "-98.77089000"
                    },
                    {
                        "id": 68270,
                        "name": "Anenecuilco",
                        "latitude": "18.77738000",
                        "longitude": "-98.98907000"
                    },
                    {
                        "id": 68366,
                        "name": "Arroyo Vista Hermosa",
                        "latitude": "19.33082000",
                        "longitude": "-99.53694000"
                    },
                    {
                        "id": 68409,
                        "name": "Atlacahualoya",
                        "latitude": "18.54057000",
                        "longitude": "-98.72982000"
                    },
                    {
                        "id": 68410,
                        "name": "Atlacholoaya",
                        "latitude": "18.74238000",
                        "longitude": "-99.22656000"
                    },
                    {
                        "id": 68417,
                        "name": "Atlatlahucan",
                        "latitude": "18.93554000",
                        "longitude": "-98.89496000"
                    },
                    {
                        "id": 68429,
                        "name": "Atotonilco",
                        "latitude": "18.64947000",
                        "longitude": "-98.83117000"
                    },
                    {
                        "id": 68451,
                        "name": "Axochiapan",
                        "latitude": "18.50246000",
                        "longitude": "-98.75358000"
                    },
                    {
                        "id": 68459,
                        "name": "Ayala",
                        "latitude": "18.72604000",
                        "longitude": "-98.95106000"
                    },
                    {
                        "id": 68635,
                        "name": "Bonifacio García",
                        "latitude": "18.71786000",
                        "longitude": "-99.12011000"
                    },
                    {
                        "id": 68671,
                        "name": "Buenavista",
                        "latitude": "19.80082000",
                        "longitude": "-100.04385000"
                    },
                    {
                        "id": 68731,
                        "name": "Calera Chica",
                        "latitude": "18.85833000",
                        "longitude": "-99.18194000"
                    },
                    {
                        "id": 68742,
                        "name": "Calle Real",
                        "latitude": "19.48858000",
                        "longitude": "-99.61332000"
                    },
                    {
                        "id": 68851,
                        "name": "Casahuatlán",
                        "latitude": "18.57271000",
                        "longitude": "-99.39051000"
                    },
                    {
                        "id": 68918,
                        "name": "Cerritos de Cárdenas",
                        "latitude": "19.96942000",
                        "longitude": "-100.02254000"
                    },
                    {
                        "id": 68956,
                        "name": "Chalcatzingo",
                        "latitude": "18.68951000",
                        "longitude": "-98.77434000"
                    },
                    {
                        "id": 69002,
                        "name": "Chavarría",
                        "latitude": "18.72575000",
                        "longitude": "-99.46826000"
                    },
                    {
                        "id": 69041,
                        "name": "Chiconcuac",
                        "latitude": "18.78278000",
                        "longitude": "-99.20722000"
                    },
                    {
                        "id": 69081,
                        "name": "Chinameca",
                        "latitude": "18.62220000",
                        "longitude": "-98.99766000"
                    },
                    {
                        "id": 69145,
                        "name": "Ciudad Ayala",
                        "latitude": "18.76694000",
                        "longitude": "-98.98222000"
                    },
                    {
                        "id": 69201,
                        "name": "Cliserio Alanís (San Gaspar)",
                        "latitude": "18.86111000",
                        "longitude": "-99.16000000"
                    },
                    {
                        "id": 69218,
                        "name": "Coahuixtla",
                        "latitude": "18.57417000",
                        "longitude": "-99.37000000"
                    },
                    {
                        "id": 69229,
                        "name": "Coatetelco",
                        "latitude": "18.72963000",
                        "longitude": "-99.32605000"
                    },
                    {
                        "id": 69230,
                        "name": "Coatlán del Río",
                        "latitude": "18.74423000",
                        "longitude": "-99.43324000"
                    },
                    {
                        "id": 69240,
                        "name": "Cocoyoc",
                        "latitude": "18.88417000",
                        "longitude": "-98.98194000"
                    },
                    {
                        "id": 69242,
                        "name": "Cocoyotla",
                        "latitude": "18.75445000",
                        "longitude": "-99.45075000"
                    },
                    {
                        "id": 69406,
                        "name": "Colonia Ángel Bocanegra (Adolfo López Mateos)",
                        "latitude": "18.92639000",
                        "longitude": "-99.02972000"
                    },
                    {
                        "id": 69384,
                        "name": "Colonia el Florido",
                        "latitude": "18.73833000",
                        "longitude": "-99.36722000"
                    },
                    {
                        "id": 69396,
                        "name": "Colonia las Arboledas",
                        "latitude": "18.78528000",
                        "longitude": "-98.93972000"
                    },
                    {
                        "id": 69401,
                        "name": "Colonia los Cerritos",
                        "latitude": "18.95389000",
                        "longitude": "-99.19250000"
                    },
                    {
                        "id": 69343,
                        "name": "Colonia Obrera",
                        "latitude": "18.93167000",
                        "longitude": "-99.03889000"
                    },
                    {
                        "id": 69347,
                        "name": "Colonia Palo Prieto (Chipitongo)",
                        "latitude": "18.70417000",
                        "longitude": "-99.11278000"
                    },
                    {
                        "id": 69361,
                        "name": "Colonia San Francisco",
                        "latitude": "18.89611000",
                        "longitude": "-98.90361000"
                    },
                    {
                        "id": 69462,
                        "name": "Constancio Farfán (La Pascuala)",
                        "latitude": "18.74194000",
                        "longitude": "-98.95389000"
                    },
                    {
                        "id": 69572,
                        "name": "Cuauchichinola",
                        "latitude": "18.66389000",
                        "longitude": "-99.37583000"
                    },
                    {
                        "id": 69576,
                        "name": "Cuauhtempan (San Andrés Cuauhtempan)",
                        "latitude": "18.97472000",
                        "longitude": "-98.94639000"
                    },
                    {
                        "id": 69591,
                        "name": "Cuautla",
                        "latitude": "18.81060000",
                        "longitude": "-98.93525000"
                    },
                    {
                        "id": 69614,
                        "name": "Cuentepec",
                        "latitude": "18.86159000",
                        "longitude": "-99.32611000"
                    },
                    {
                        "id": 69615,
                        "name": "Cuernavaca",
                        "latitude": "18.95532000",
                        "longitude": "-99.24002000"
                    },
                    {
                        "id": 69721,
                        "name": "Dos Ríos",
                        "latitude": "19.37467000",
                        "longitude": "-99.34359000"
                    },
                    {
                        "id": 69871,
                        "name": "El Carmen",
                        "latitude": "19.88796000",
                        "longitude": "-98.95732000"
                    },
                    {
                        "id": 69965,
                        "name": "El Estudiante",
                        "latitude": "18.57760000",
                        "longitude": "-99.29712000"
                    },
                    {
                        "id": 70039,
                        "name": "El Mirador",
                        "latitude": "18.77139000",
                        "longitude": "-99.34139000"
                    },
                    {
                        "id": 70168,
                        "name": "El Rodeo",
                        "latitude": "18.77864000",
                        "longitude": "-99.32269000"
                    },
                    {
                        "id": 70188,
                        "name": "El Salitre",
                        "latitude": "18.67583000",
                        "longitude": "-98.95806000"
                    },
                    {
                        "id": 70277,
                        "name": "Emiliano Zapata",
                        "latitude": "18.84065000",
                        "longitude": "-99.18463000"
                    },
                    {
                        "id": 70291,
                        "name": "Emiliano Zapata (Casahuates)",
                        "latitude": "18.93056000",
                        "longitude": "-98.95889000"
                    },
                    {
                        "id": 70307,
                        "name": "Enthavi",
                        "latitude": "19.49842000",
                        "longitude": "-99.57502000"
                    },
                    {
                        "id": 70385,
                        "name": "Ex-Hacienda el Hospital",
                        "latitude": "18.83111000",
                        "longitude": "-98.99667000"
                    },
                    {
                        "id": 70400,
                        "name": "Felipe Neri (Cuatepec)",
                        "latitude": "19.03944000",
                        "longitude": "-98.94361000"
                    },
                    {
                        "id": 70425,
                        "name": "Fraccionamiento Lomas de Ahuatlán",
                        "latitude": "18.95444000",
                        "longitude": "-99.25722000"
                    },
                    {
                        "id": 70443,
                        "name": "Fraccionamiento Universo",
                        "latitude": "18.96167000",
                        "longitude": "-99.18639000"
                    },
                    {
                        "id": 70508,
                        "name": "Galeana",
                        "latitude": "18.63810000",
                        "longitude": "-99.21240000"
                    },
                    {
                        "id": 70698,
                        "name": "Higuerón",
                        "latitude": "18.57750000",
                        "longitude": "-99.18056000"
                    },
                    {
                        "id": 70721,
                        "name": "Huajintlán",
                        "latitude": "18.60923000",
                        "longitude": "-99.42432000"
                    },
                    {
                        "id": 70741,
                        "name": "Huatecalco",
                        "latitude": "18.67676000",
                        "longitude": "-99.14354000"
                    },
                    {
                        "id": 70754,
                        "name": "Huazulco",
                        "latitude": "18.75299000",
                        "longitude": "-98.77535000"
                    },
                    {
                        "id": 70756,
                        "name": "Huecahuasco",
                        "latitude": "18.93694000",
                        "longitude": "-98.78250000"
                    },
                    {
                        "id": 70770,
                        "name": "Huepalcalco (San Miguel)",
                        "latitude": "18.90889000",
                        "longitude": "-98.75000000"
                    },
                    {
                        "id": 70774,
                        "name": "Hueyapan",
                        "latitude": "18.88970000",
                        "longitude": "-98.68200000"
                    },
                    {
                        "id": 70798,
                        "name": "Huitchila",
                        "latitude": "18.63880000",
                        "longitude": "-98.92529000"
                    },
                    {
                        "id": 70806,
                        "name": "Huitzilac",
                        "latitude": "19.02983000",
                        "longitude": "-99.26788000"
                    },
                    {
                        "id": 70809,
                        "name": "Huitzililla",
                        "latitude": "18.69425000",
                        "longitude": "-98.89687000"
                    },
                    {
                        "id": 70840,
                        "name": "Ignacio Bastida (Santa Catarina Tlayca)",
                        "latitude": "18.94028000",
                        "longitude": "-99.01444000"
                    },
                    {
                        "id": 70871,
                        "name": "Independencia",
                        "latitude": "18.87716000",
                        "longitude": "-99.12237000"
                    },
                    {
                        "id": 70894,
                        "name": "Itzamatitlán",
                        "latitude": "18.90942000",
                        "longitude": "-99.02236000"
                    },
                    {
                        "id": 70943,
                        "name": "Ixtlilco el Chico",
                        "latitude": "18.55833000",
                        "longitude": "-98.84694000"
                    },
                    {
                        "id": 70985,
                        "name": "Jaltepec",
                        "latitude": "19.72960000",
                        "longitude": "-98.63456000"
                    },
                    {
                        "id": 71003,
                        "name": "Jantetelco",
                        "latitude": "18.71828000",
                        "longitude": "-98.77760000"
                    },
                    {
                        "id": 71041,
                        "name": "Jicarero",
                        "latitude": "18.61488000",
                        "longitude": "-99.22344000"
                    },
                    {
                        "id": 71061,
                        "name": "Jiutepec",
                        "latitude": "18.88139000",
                        "longitude": "-99.17778000"
                    },
                    {
                        "id": 71069,
                        "name": "Jojutla",
                        "latitude": "18.61472000",
                        "longitude": "-99.18028000"
                    },
                    {
                        "id": 71079,
                        "name": "Jonacatepec",
                        "latitude": "18.68081000",
                        "longitude": "-98.80336000"
                    },
                    {
                        "id": 71124,
                        "name": "Juan Morales",
                        "latitude": "18.81139000",
                        "longitude": "-98.92194000"
                    },
                    {
                        "id": 71139,
                        "name": "Jumiltepec",
                        "latitude": "18.91359000",
                        "longitude": "-98.77666000"
                    },
                    {
                        "id": 71320,
                        "name": "La Huanica",
                        "latitude": "19.45956000",
                        "longitude": "-99.50079000"
                    },
                    {
                        "id": 71330,
                        "name": "La Joya",
                        "latitude": "18.66667000",
                        "longitude": "-99.46667000"
                    },
                    {
                        "id": 71517,
                        "name": "La Unidad Huitzizilapan",
                        "latitude": "19.42223000",
                        "longitude": "-99.39771000"
                    },
                    {
                        "id": 71897,
                        "name": "Lázaro Cárdenas (El Empalme)",
                        "latitude": "18.93222000",
                        "longitude": "-99.02528000"
                    },
                    {
                        "id": 71715,
                        "name": "Loma Bonita",
                        "latitude": "18.93144000",
                        "longitude": "-99.17564000"
                    },
                    {
                        "id": 71743,
                        "name": "Lomas de Ahuatepec",
                        "latitude": "18.97139000",
                        "longitude": "-99.18972000"
                    },
                    {
                        "id": 71773,
                        "name": "Los Arcos",
                        "latitude": "18.88722000",
                        "longitude": "-99.02417000"
                    },
                    {
                        "id": 71987,
                        "name": "Marcelino Rodríguez (San Ignacio)",
                        "latitude": "18.57889000",
                        "longitude": "-98.74361000"
                    },
                    {
                        "id": 72043,
                        "name": "Mazatepec",
                        "latitude": "18.72795000",
                        "longitude": "-99.36339000"
                    },
                    {
                        "id": 72089,
                        "name": "Metepec",
                        "latitude": "18.87889000",
                        "longitude": "-98.74667000"
                    },
                    {
                        "id": 72114,
                        "name": "Miacatlán",
                        "latitude": "18.76203000",
                        "longitude": "-99.35944000"
                    },
                    {
                        "id": 72119,
                        "name": "Michapa",
                        "latitude": "18.70241000",
                        "longitude": "-99.47907000"
                    },
                    {
                        "id": 72126,
                        "name": "Miguel Bocanegra",
                        "latitude": "19.84574000",
                        "longitude": "-99.11193000"
                    },
                    {
                        "id": 72170,
                        "name": "Mixtlalcingo",
                        "latitude": "18.80333000",
                        "longitude": "-98.90028000"
                    },
                    {
                        "id": 72247,
                        "name": "Moyotepec",
                        "latitude": "18.72084000",
                        "longitude": "-98.99471000"
                    },
                    {
                        "id": 72287,
                        "name": "Narciso Mendoza",
                        "latitude": "18.87417000",
                        "longitude": "-98.96972000"
                    },
                    {
                        "id": 72312,
                        "name": "Nepopualco",
                        "latitude": "18.99926000",
                        "longitude": "-98.94270000"
                    },
                    {
                        "id": 72335,
                        "name": "Ninguno [Centro de Readaptación Social de Atlacholoaya]",
                        "latitude": "18.75778000",
                        "longitude": "-99.22944000"
                    },
                    {
                        "id": 72430,
                        "name": "Oacalco",
                        "latitude": "18.92342000",
                        "longitude": "-99.02935000"
                    },
                    {
                        "id": 72434,
                        "name": "Oaxtepec",
                        "latitude": "18.91825000",
                        "longitude": "-98.95644000"
                    },
                    {
                        "id": 72462,
                        "name": "Ocoxaltepec",
                        "latitude": "18.93500000",
                        "longitude": "-98.75250000"
                    },
                    {
                        "id": 72473,
                        "name": "Ocuituco",
                        "latitude": "18.87731000",
                        "longitude": "-98.77323000"
                    },
                    {
                        "id": 72501,
                        "name": "Olintepec",
                        "latitude": "18.74056000",
                        "longitude": "-98.98722000"
                    },
                    {
                        "id": 72724,
                        "name": "Pedro Amaro",
                        "latitude": "18.59639000",
                        "longitude": "-99.17306000"
                    },
                    {
                        "id": 72750,
                        "name": "Peña Flores (Palo Verde)",
                        "latitude": "18.86722000",
                        "longitude": "-98.96833000"
                    },
                    {
                        "id": 73013,
                        "name": "Pérez de Galeana",
                        "latitude": "19.97933000",
                        "longitude": "-99.14164000"
                    },
                    {
                        "id": 72911,
                        "name": "Progreso",
                        "latitude": "18.88008000",
                        "longitude": "-99.15260000"
                    },
                    {
                        "id": 72936,
                        "name": "Pueblo Nuevo",
                        "latitude": "18.70068000",
                        "longitude": "-99.15277000"
                    },
                    {
                        "id": 72945,
                        "name": "Pueblo Nuevo de Morelos",
                        "latitude": "19.76245000",
                        "longitude": "-99.05385000"
                    },
                    {
                        "id": 72956,
                        "name": "Puente de Ixtla",
                        "latitude": "18.61472000",
                        "longitude": "-99.31806000"
                    },
                    {
                        "id": 73005,
                        "name": "Puxtla",
                        "latitude": "18.81000000",
                        "longitude": "-98.98250000"
                    },
                    {
                        "id": 73016,
                        "name": "Quebrantadero",
                        "latitude": "18.52429000",
                        "longitude": "-98.79023000"
                    },
                    {
                        "id": 73101,
                        "name": "Reyes Acozac",
                        "latitude": "19.77550000",
                        "longitude": "-98.98079000"
                    },
                    {
                        "id": 73210,
                        "name": "Salazar",
                        "latitude": "19.30767000",
                        "longitude": "-99.38863000"
                    },
                    {
                        "id": 73276,
                        "name": "San Andrés Cuexcontitlán",
                        "latitude": "19.35892000",
                        "longitude": "-99.62151000"
                    },
                    {
                        "id": 73306,
                        "name": "San Andrés de la Cal",
                        "latitude": "18.95694000",
                        "longitude": "-99.11444000"
                    },
                    {
                        "id": 73289,
                        "name": "San Andrés Ocotlán",
                        "latitude": "19.19297000",
                        "longitude": "-99.58612000"
                    },
                    {
                        "id": 73329,
                        "name": "San Antonio Chiverías",
                        "latitude": "18.65222000",
                        "longitude": "-99.22139000"
                    },
                    {
                        "id": 73381,
                        "name": "San Antonio del Puente",
                        "latitude": "19.41832000",
                        "longitude": "-99.61734000"
                    },
                    {
                        "id": 73428,
                        "name": "San Bartolomé Tlaltelulco",
                        "latitude": "19.22738000",
                        "longitude": "-99.62964000"
                    },
                    {
                        "id": 73487,
                        "name": "San Diego",
                        "latitude": "19.00833000",
                        "longitude": "-99.65434000"
                    },
                    {
                        "id": 73492,
                        "name": "San Diego Alcalá",
                        "latitude": "19.45121000",
                        "longitude": "-99.62115000"
                    },
                    {
                        "id": 73494,
                        "name": "San Diego Linares",
                        "latitude": "19.38628000",
                        "longitude": "-99.63748000"
                    },
                    {
                        "id": 73525,
                        "name": "San Felipe Teotitlán",
                        "latitude": "19.80431000",
                        "longitude": "-98.70106000"
                    },
                    {
                        "id": 73555,
                        "name": "San Francisco Chimalpa",
                        "latitude": "19.44279000",
                        "longitude": "-99.34398000"
                    },
                    {
                        "id": 73599,
                        "name": "San Francisco Tetetla",
                        "latitude": "19.11669000",
                        "longitude": "-99.60141000"
                    },
                    {
                        "id": 73606,
                        "name": "San Francisco Zacacalco",
                        "latitude": "19.92875000",
                        "longitude": "-98.98279000"
                    },
                    {
                        "id": 73632,
                        "name": "San Gabriel las Palmas",
                        "latitude": "18.61417000",
                        "longitude": "-99.34694000"
                    },
                    {
                        "id": 73635,
                        "name": "San Gaspar Tlahuelilpan",
                        "latitude": "19.24290000",
                        "longitude": "-99.54568000"
                    },
                    {
                        "id": 73701,
                        "name": "San Jerónimo Acazulco",
                        "latitude": "19.26563000",
                        "longitude": "-99.41629000"
                    },
                    {
                        "id": 73706,
                        "name": "San Jerónimo Chicahualco",
                        "latitude": "19.28279000",
                        "longitude": "-99.59290000"
                    },
                    {
                        "id": 73737,
                        "name": "San José",
                        "latitude": "19.00777000",
                        "longitude": "-99.66345000"
                    },
                    {
                        "id": 73752,
                        "name": "San José Buenavista el Grande",
                        "latitude": "19.40833000",
                        "longitude": "-99.58141000"
                    },
                    {
                        "id": 73759,
                        "name": "San José Comalco",
                        "latitude": "19.47097000",
                        "longitude": "-99.62627000"
                    },
                    {
                        "id": 73849,
                        "name": "San José el Llanito",
                        "latitude": "19.30337000",
                        "longitude": "-99.47950000"
                    },
                    {
                        "id": 73734,
                        "name": "San Jose Solís",
                        "latitude": "19.99877000",
                        "longitude": "-100.04922000"
                    },
                    {
                        "id": 73801,
                        "name": "San José Vista Hermosa",
                        "latitude": "18.65443000",
                        "longitude": "-99.26622000"
                    },
                    {
                        "id": 73863,
                        "name": "San Juan Ahuehueyo",
                        "latitude": "18.71500000",
                        "longitude": "-98.93278000"
                    },
                    {
                        "id": 73978,
                        "name": "San Juan la Isla",
                        "latitude": "19.13027000",
                        "longitude": "-99.57076000"
                    },
                    {
                        "id": 73917,
                        "name": "San Juan Pueblo Nuevo",
                        "latitude": "19.77583000",
                        "longitude": "-99.01976000"
                    },
                    {
                        "id": 73937,
                        "name": "San Juan Texcalpan",
                        "latitude": "18.93583000",
                        "longitude": "-98.92889000"
                    },
                    {
                        "id": 73939,
                        "name": "San Juan Tilapa",
                        "latitude": "19.22021000",
                        "longitude": "-99.66012000"
                    },
                    {
                        "id": 73950,
                        "name": "San Juan Xochiaca",
                        "latitude": "19.01349000",
                        "longitude": "-99.53938000"
                    },
                    {
                        "id": 73955,
                        "name": "San Juan Yautepec",
                        "latitude": "19.34887000",
                        "longitude": "-99.34045000"
                    },
                    {
                        "id": 73957,
                        "name": "San Juan Zitlaltepec",
                        "latitude": "19.81207000",
                        "longitude": "-99.14526000"
                    },
                    {
                        "id": 74001,
                        "name": "San Lorenzo Cuauhtenco",
                        "latitude": "19.19573000",
                        "longitude": "-99.63156000"
                    },
                    {
                        "id": 74007,
                        "name": "San Lorenzo Nenamicoyan",
                        "latitude": "20.13699000",
                        "longitude": "-99.63877000"
                    },
                    {
                        "id": 74008,
                        "name": "San Lorenzo Oyamel",
                        "latitude": "19.43355000",
                        "longitude": "-99.57761000"
                    },
                    {
                        "id": 74048,
                        "name": "San Luis Ayucán",
                        "latitude": "19.49597000",
                        "longitude": "-99.36312000"
                    },
                    {
                        "id": 74080,
                        "name": "San Marcos de la Cruz",
                        "latitude": "19.18682000",
                        "longitude": "-99.65430000"
                    },
                    {
                        "id": 74118,
                        "name": "San Mateo Atarasquíllo",
                        "latitude": "19.32304000",
                        "longitude": "-99.46156000"
                    },
                    {
                        "id": 74131,
                        "name": "San Mateo Otzacatipan",
                        "latitude": "19.33273000",
                        "longitude": "-99.60345000"
                    },
                    {
                        "id": 74151,
                        "name": "San Miguel",
                        "latitude": "19.86852000",
                        "longitude": "-99.13448000"
                    },
                    {
                        "id": 74158,
                        "name": "San Miguel Almaya",
                        "latitude": "19.21047000",
                        "longitude": "-99.44195000"
                    },
                    {
                        "id": 74162,
                        "name": "San Miguel Ameyalco",
                        "latitude": "19.30681000",
                        "longitude": "-99.45880000"
                    },
                    {
                        "id": 74164,
                        "name": "San Miguel Atepoxco",
                        "latitude": "19.74498000",
                        "longitude": "-98.74038000"
                    },
                    {
                        "id": 74168,
                        "name": "San Miguel Balderas",
                        "latitude": "19.10943000",
                        "longitude": "-99.65165000"
                    },
                    {
                        "id": 74231,
                        "name": "San Miguel de La Victoria",
                        "latitude": "20.05611000",
                        "longitude": "-99.59109000"
                    },
                    {
                        "id": 74219,
                        "name": "San Miguel Totoltepec",
                        "latitude": "19.32402000",
                        "longitude": "-99.57779000"
                    },
                    {
                        "id": 74255,
                        "name": "San Nicolás Coatepec",
                        "latitude": "19.13735000",
                        "longitude": "-99.42948000"
                    },
                    {
                        "id": 74259,
                        "name": "San Nicolás Peralta",
                        "latitude": "19.35954000",
                        "longitude": "-99.48555000"
                    },
                    {
                        "id": 74261,
                        "name": "San Nicolás Solís",
                        "latitude": "19.99107000",
                        "longitude": "-100.02610000"
                    },
                    {
                        "id": 74264,
                        "name": "San Nicolás Tlazala",
                        "latitude": "19.22623000",
                        "longitude": "-99.46372000"
                    },
                    {
                        "id": 74285,
                        "name": "San Pablo Autopan",
                        "latitude": "19.35638000",
                        "longitude": "-99.65724000"
                    },
                    {
                        "id": 74312,
                        "name": "San Pedro Apatlaco",
                        "latitude": "18.79306000",
                        "longitude": "-98.95972000"
                    },
                    {
                        "id": 74316,
                        "name": "San Pedro Atlapulco",
                        "latitude": "19.24402000",
                        "longitude": "-99.39505000"
                    },
                    {
                        "id": 74325,
                        "name": "San Pedro Chochula",
                        "latitude": "19.26359000",
                        "longitude": "-99.48590000"
                    },
                    {
                        "id": 74339,
                        "name": "San Pedro Huaquilpan",
                        "latitude": "19.98840000",
                        "longitude": "-98.86777000"
                    },
                    {
                        "id": 74375,
                        "name": "San Pedro Techuchulco",
                        "latitude": "19.11359000",
                        "longitude": "-99.52425000"
                    },
                    {
                        "id": 74386,
                        "name": "San Pedro Tlaltizapan",
                        "latitude": "19.19973000",
                        "longitude": "-99.49956000"
                    },
                    {
                        "id": 74392,
                        "name": "San Pedro Totoltepec",
                        "latitude": "19.31108000",
                        "longitude": "-99.57197000"
                    },
                    {
                        "id": 74395,
                        "name": "San Pedro Tultepec",
                        "latitude": "19.26514000",
                        "longitude": "-99.50934000"
                    },
                    {
                        "id": 74397,
                        "name": "San Pedro Xalpa",
                        "latitude": "19.82666000",
                        "longitude": "-99.18466000"
                    },
                    {
                        "id": 74403,
                        "name": "San Pedro Zictepec",
                        "latitude": "19.03659000",
                        "longitude": "-99.57771000"
                    },
                    {
                        "id": 74437,
                        "name": "San Rafael Zaragoza",
                        "latitude": "18.64166000",
                        "longitude": "-99.00399000"
                    },
                    {
                        "id": 74454,
                        "name": "San Sebastián",
                        "latitude": "19.78431000",
                        "longitude": "-99.05560000"
                    },
                    {
                        "id": 74508,
                        "name": "San Vicente de Juárez",
                        "latitude": "18.68343000",
                        "longitude": "-98.98517000"
                    },
                    {
                        "id": 74538,
                        "name": "Santa Ana Jilotzingo",
                        "latitude": "19.45617000",
                        "longitude": "-99.48836000"
                    },
                    {
                        "id": 74572,
                        "name": "Santa Catarina",
                        "latitude": "18.96972000",
                        "longitude": "-99.14028000"
                    },
                    {
                        "id": 74619,
                        "name": "Santa Cruz Ayotuxco",
                        "latitude": "19.38273000",
                        "longitude": "-99.37192000"
                    },
                    {
                        "id": 74637,
                        "name": "Santa Cruz Pueblo Nuevo",
                        "latitude": "19.09864000",
                        "longitude": "-99.65531000"
                    },
                    {
                        "id": 74709,
                        "name": "Santa María Ajoloapan",
                        "latitude": "19.76360000",
                        "longitude": "-98.95908000"
                    },
                    {
                        "id": 74716,
                        "name": "Santa María Atarasquillo",
                        "latitude": "19.32831000",
                        "longitude": "-99.46899000"
                    },
                    {
                        "id": 74757,
                        "name": "Santa María Magdalena Ocotitlán",
                        "latitude": "19.23713000",
                        "longitude": "-99.62418000"
                    },
                    {
                        "id": 74698,
                        "name": "Santa Martha",
                        "latitude": "19.05977000",
                        "longitude": "-99.38132000"
                    },
                    {
                        "id": 74846,
                        "name": "Santa Rosa Treinta",
                        "latitude": "18.70025000",
                        "longitude": "-99.18357000"
                    },
                    {
                        "id": 74877,
                        "name": "Santiago Analco",
                        "latitude": "19.33116000",
                        "longitude": "-99.45208000"
                    },
                    {
                        "id": 74933,
                        "name": "Santiago Oxthoc",
                        "latitude": "20.11599000",
                        "longitude": "-99.54422000"
                    },
                    {
                        "id": 74945,
                        "name": "Santiago Tepatlaxco",
                        "latitude": "19.47485000",
                        "longitude": "-99.34410000"
                    },
                    {
                        "id": 74969,
                        "name": "Santiago Tílapa",
                        "latitude": "19.18953000",
                        "longitude": "-99.42089000"
                    },
                    {
                        "id": 74999,
                        "name": "Santo Domingo Aztacameca",
                        "latitude": "19.78223000",
                        "longitude": "-98.76811000"
                    },
                    {
                        "id": 75004,
                        "name": "Santo Domingo Ocotitlán",
                        "latitude": "19.01445000",
                        "longitude": "-99.06101000"
                    },
                    {
                        "id": 75259,
                        "name": "Tecajec",
                        "latitude": "18.79806000",
                        "longitude": "-98.81500000"
                    },
                    {
                        "id": 75301,
                        "name": "Tehuixtla",
                        "latitude": "18.55944000",
                        "longitude": "-99.27119000"
                    },
                    {
                        "id": 75319,
                        "name": "Telixtac",
                        "latitude": "18.56031000",
                        "longitude": "-98.77625000"
                    },
                    {
                        "id": 75336,
                        "name": "Temimilcingo",
                        "latitude": "18.72954000",
                        "longitude": "-99.16071000"
                    },
                    {
                        "id": 75337,
                        "name": "Temixco",
                        "latitude": "18.85254000",
                        "longitude": "-99.22537000"
                    },
                    {
                        "id": 75338,
                        "name": "Temoac",
                        "latitude": "18.77222000",
                        "longitude": "-98.77750000"
                    },
                    {
                        "id": 75351,
                        "name": "Tenango",
                        "latitude": "18.62253000",
                        "longitude": "-98.75175000"
                    },
                    {
                        "id": 75365,
                        "name": "Tenextepango",
                        "latitude": "18.72889000",
                        "longitude": "-98.95778000"
                    },
                    {
                        "id": 75394,
                        "name": "Tepalcingo",
                        "latitude": "18.60151000",
                        "longitude": "-98.86942000"
                    },
                    {
                        "id": 75432,
                        "name": "Tepetzingo",
                        "latitude": "18.78537000",
                        "longitude": "-99.17758000"
                    },
                    {
                        "id": 75453,
                        "name": "Tepoztlán",
                        "latitude": "18.98622000",
                        "longitude": "-99.10051000"
                    },
                    {
                        "id": 75456,
                        "name": "Tequesquitengo",
                        "latitude": "18.61096000",
                        "longitude": "-99.26025000"
                    },
                    {
                        "id": 75474,
                        "name": "Tetecala",
                        "latitude": "18.73009000",
                        "longitude": "-99.40021000"
                    },
                    {
                        "id": 75475,
                        "name": "Tetecalita",
                        "latitude": "18.76823000",
                        "longitude": "-99.17749000"
                    },
                    {
                        "id": 75476,
                        "name": "Tetecolala",
                        "latitude": "18.92250000",
                        "longitude": "-99.16278000"
                    },
                    {
                        "id": 75479,
                        "name": "Tetela del Volcán",
                        "latitude": "18.89306000",
                        "longitude": "-98.72972000"
                    },
                    {
                        "id": 75483,
                        "name": "Tetelilla",
                        "latitude": "18.61349000",
                        "longitude": "-98.77356000"
                    },
                    {
                        "id": 75502,
                        "name": "Texcala",
                        "latitude": "18.93444000",
                        "longitude": "-98.79472000"
                    },
                    {
                        "id": 75532,
                        "name": "Tezoyuca",
                        "latitude": "18.80498000",
                        "longitude": "-99.20212000"
                    },
                    {
                        "id": 75538,
                        "name": "Tianguistongo",
                        "latitude": "20.00612000",
                        "longitude": "-99.03845000"
                    },
                    {
                        "id": 75542,
                        "name": "Ticumán",
                        "latitude": "18.75671000",
                        "longitude": "-99.11991000"
                    },
                    {
                        "id": 75552,
                        "name": "Tierra Larga (Campo Nuevo)",
                        "latitude": "18.86444000",
                        "longitude": "-98.94806000"
                    },
                    {
                        "id": 75570,
                        "name": "Tilzapotla",
                        "latitude": "18.48916000",
                        "longitude": "-99.27442000"
                    },
                    {
                        "id": 75598,
                        "name": "Tlachaloya",
                        "latitude": "19.44846000",
                        "longitude": "-99.66225000"
                    },
                    {
                        "id": 75617,
                        "name": "Tlacotepec",
                        "latitude": "18.81444000",
                        "longitude": "-98.74514000"
                    },
                    {
                        "id": 75626,
                        "name": "Tlacuitlapa",
                        "latitude": "19.12209000",
                        "longitude": "-99.41534000"
                    },
                    {
                        "id": 75646,
                        "name": "Tlalnepantla",
                        "latitude": "19.00885000",
                        "longitude": "-98.99613000"
                    },
                    {
                        "id": 75655,
                        "name": "Tlaltenanguito",
                        "latitude": "19.49822000",
                        "longitude": "-99.58309000"
                    },
                    {
                        "id": 75658,
                        "name": "Tlaltetelco (San Miguel Tlaltetelco)",
                        "latitude": "18.95222000",
                        "longitude": "-98.88806000"
                    },
                    {
                        "id": 75659,
                        "name": "Tlaltizapán",
                        "latitude": "18.68630000",
                        "longitude": "-99.11868000"
                    },
                    {
                        "id": 75679,
                        "name": "Tlapanaloya",
                        "latitude": "19.93619000",
                        "longitude": "-99.09664000"
                    },
                    {
                        "id": 75682,
                        "name": "Tlaquiltenango",
                        "latitude": "18.63429000",
                        "longitude": "-99.16320000"
                    },
                    {
                        "id": 75686,
                        "name": "Tlatenchi",
                        "latitude": "18.59639000",
                        "longitude": "-99.18639000"
                    },
                    {
                        "id": 75705,
                        "name": "Tlayacapan",
                        "latitude": "18.95556000",
                        "longitude": "-98.98111000"
                    },
                    {
                        "id": 75752,
                        "name": "Totolapan",
                        "latitude": "18.98487000",
                        "longitude": "-98.92073000"
                    },
                    {
                        "id": 75780,
                        "name": "Tres de Mayo",
                        "latitude": "18.86861000",
                        "longitude": "-99.20833000"
                    },
                    {
                        "id": 75774,
                        "name": "Tres Marías",
                        "latitude": "19.05490000",
                        "longitude": "-99.24301000"
                    },
                    {
                        "id": 75870,
                        "name": "Unidad Habitacional 10 de Abril",
                        "latitude": "18.75444000",
                        "longitude": "-98.91611000"
                    },
                    {
                        "id": 75872,
                        "name": "Unidad Habitacional José María Morelos y Pavón",
                        "latitude": "18.82028000",
                        "longitude": "-99.26222000"
                    },
                    {
                        "id": 75873,
                        "name": "Unidad Habitacional Mariano Matamoros",
                        "latitude": "18.74750000",
                        "longitude": "-98.85222000"
                    },
                    {
                        "id": 75874,
                        "name": "Unidad Habitacional Rinconada Acolapa",
                        "latitude": "18.89722000",
                        "longitude": "-99.13139000"
                    },
                    {
                        "id": 75926,
                        "name": "Valle de Vázquez",
                        "latitude": "18.52858000",
                        "longitude": "-99.06943000"
                    },
                    {
                        "id": 76043,
                        "name": "Villa Santiago",
                        "latitude": "18.97972000",
                        "longitude": "-99.18528000"
                    },
                    {
                        "id": 76119,
                        "name": "Xalostoc",
                        "latitude": "18.72251000",
                        "longitude": "-98.89877000"
                    },
                    {
                        "id": 76159,
                        "name": "Xochicalco (Cirenio Longares)",
                        "latitude": "18.78722000",
                        "longitude": "-99.29944000"
                    },
                    {
                        "id": 76172,
                        "name": "Xochitepec",
                        "latitude": "18.78080000",
                        "longitude": "-99.23049000"
                    },
                    {
                        "id": 76177,
                        "name": "Xochitlán",
                        "latitude": "18.88865000",
                        "longitude": "-98.81209000"
                    },
                    {
                        "id": 76201,
                        "name": "Xoxocotla",
                        "latitude": "18.68415000",
                        "longitude": "-99.24577000"
                    },
                    {
                        "id": 76221,
                        "name": "Yautepec",
                        "latitude": "18.88188000",
                        "longitude": "-99.06715000"
                    },
                    {
                        "id": 76228,
                        "name": "Yecapixteca",
                        "latitude": "18.88230000",
                        "longitude": "-98.90272000"
                    },
                    {
                        "id": 76229,
                        "name": "Yecapixtla",
                        "latitude": "18.88333000",
                        "longitude": "-98.86500000"
                    },
                    {
                        "id": 76263,
                        "name": "Zacapalco",
                        "latitude": "18.63917000",
                        "longitude": "-98.95944000"
                    },
                    {
                        "id": 76274,
                        "name": "Zacatepec",
                        "latitude": "18.65409000",
                        "longitude": "-99.18981000"
                    },
                    {
                        "id": 76288,
                        "name": "Zacualpan de Amilpas",
                        "latitude": "18.78389000",
                        "longitude": "-98.76583000"
                    },
                    {
                        "id": 76322,
                        "name": "Zaragoza de Guadalupe",
                        "latitude": "19.14830000",
                        "longitude": "-99.64405000"
                    }
                ]
            },
            {
                "id": 3477,
                "name": "Nayarit",
                "iso2": "NAY",
                "latitude": "21.75138440",
                "longitude": "-104.84546190",
                "type": "state",
                "cities": [
                    {
                        "id": 68038,
                        "name": "Acaponeta",
                        "latitude": "22.49396000",
                        "longitude": "-105.36369000"
                    },
                    {
                        "id": 68136,
                        "name": "Ahuacatlán",
                        "latitude": "21.05405000",
                        "longitude": "-104.48398000"
                    },
                    {
                        "id": 68236,
                        "name": "Amapa",
                        "latitude": "21.78359000",
                        "longitude": "-105.25482000"
                    },
                    {
                        "id": 68244,
                        "name": "Amatlán de Cañas",
                        "latitude": "20.80699000",
                        "longitude": "-104.40408000"
                    },
                    {
                        "id": 68321,
                        "name": "Aquiles Serdán",
                        "latitude": "21.38198000",
                        "longitude": "-104.88891000"
                    },
                    {
                        "id": 68404,
                        "name": "Aticama",
                        "latitude": "21.48387000",
                        "longitude": "-105.19787000"
                    },
                    {
                        "id": 68427,
                        "name": "Atonalisco",
                        "latitude": "21.66551000",
                        "longitude": "-104.83949000"
                    },
                    {
                        "id": 68447,
                        "name": "Aután",
                        "latitude": "21.68973000",
                        "longitude": "-105.30750000"
                    },
                    {
                        "id": 68579,
                        "name": "Bellavista",
                        "latitude": "21.56236000",
                        "longitude": "-104.88267000"
                    },
                    {
                        "id": 68656,
                        "name": "Bucerías",
                        "latitude": "20.75626000",
                        "longitude": "-105.33438000"
                    },
                    {
                        "id": 68756,
                        "name": "Camalotita",
                        "latitude": "22.40453000",
                        "longitude": "-105.43156000"
                    },
                    {
                        "id": 68764,
                        "name": "Camichín de Jauja",
                        "latitude": "21.46532000",
                        "longitude": "-104.80080000"
                    },
                    {
                        "id": 68881,
                        "name": "Cañada del Tabaco",
                        "latitude": "21.70972000",
                        "longitude": "-105.35417000"
                    },
                    {
                        "id": 68979,
                        "name": "Chapalilla",
                        "latitude": "21.18852000",
                        "longitude": "-104.63783000"
                    },
                    {
                        "id": 69064,
                        "name": "Chilapa",
                        "latitude": "22.03138000",
                        "longitude": "-105.23057000"
                    },
                    {
                        "id": 69295,
                        "name": "Colonia Emiliano Zapata",
                        "latitude": "21.82861000",
                        "longitude": "-105.21972000"
                    },
                    {
                        "id": 69348,
                        "name": "Colonia Paraíso Escondido",
                        "latitude": "21.05333000",
                        "longitude": "-105.23833000"
                    },
                    {
                        "id": 69429,
                        "name": "Compostela",
                        "latitude": "21.23777000",
                        "longitude": "-104.90010000"
                    },
                    {
                        "id": 69489,
                        "name": "Corral del Risco (Punta de Mita)",
                        "latitude": "20.77361000",
                        "longitude": "-105.51667000"
                    },
                    {
                        "id": 69546,
                        "name": "Cruz de Huanacaxtle",
                        "latitude": "20.75415000",
                        "longitude": "-105.37734000"
                    },
                    {
                        "id": 69555,
                        "name": "Cuamiles",
                        "latitude": "21.92347000",
                        "longitude": "-105.25405000"
                    },
                    {
                        "id": 69827,
                        "name": "El Ahuacate",
                        "latitude": "21.51535000",
                        "longitude": "-104.94436000"
                    },
                    {
                        "id": 69849,
                        "name": "El Botadero",
                        "latitude": "21.75404000",
                        "longitude": "-105.28640000"
                    },
                    {
                        "id": 69861,
                        "name": "El Capomal",
                        "latitude": "21.83935000",
                        "longitude": "-105.12116000"
                    },
                    {
                        "id": 69928,
                        "name": "El Corte",
                        "latitude": "21.72025000",
                        "longitude": "-105.24488000"
                    },
                    {
                        "id": 70005,
                        "name": "El Jicote",
                        "latitude": "21.72545000",
                        "longitude": "-105.05787000"
                    },
                    {
                        "id": 70022,
                        "name": "El Llano",
                        "latitude": "21.41854000",
                        "longitude": "-105.17963000"
                    },
                    {
                        "id": 70175,
                        "name": "El Rosario",
                        "latitude": "20.89195000",
                        "longitude": "-104.46836000"
                    },
                    {
                        "id": 70211,
                        "name": "El Tamarindo",
                        "latitude": "21.95810000",
                        "longitude": "-105.23220000"
                    },
                    {
                        "id": 70230,
                        "name": "El Tizate",
                        "latitude": "21.80179000",
                        "longitude": "-105.11670000"
                    },
                    {
                        "id": 70247,
                        "name": "El Vado de San Pedro",
                        "latitude": "21.94742000",
                        "longitude": "-105.18005000"
                    },
                    {
                        "id": 70253,
                        "name": "El Venado",
                        "latitude": "21.94426000",
                        "longitude": "-105.00100000"
                    },
                    {
                        "id": 70283,
                        "name": "Emiliano Zapata",
                        "latitude": "21.36477000",
                        "longitude": "-104.91283000"
                    },
                    {
                        "id": 70398,
                        "name": "Felipe Carrillo Puerto",
                        "latitude": "21.13200000",
                        "longitude": "-104.86068000"
                    },
                    {
                        "id": 70468,
                        "name": "Francisco I. Madero",
                        "latitude": "21.58186000",
                        "longitude": "-104.81927000"
                    },
                    {
                        "id": 70601,
                        "name": "Guadalupe Victoria",
                        "latitude": "21.67972000",
                        "longitude": "-105.32750000"
                    },
                    {
                        "id": 70692,
                        "name": "Higuera Blanca",
                        "latitude": "20.79746000",
                        "longitude": "-105.46747000"
                    },
                    {
                        "id": 70718,
                        "name": "Huajicori",
                        "latitude": "22.63667000",
                        "longitude": "-105.31972000"
                    },
                    {
                        "id": 70719,
                        "name": "Huajimic",
                        "latitude": "21.68347000",
                        "longitude": "-104.31542000"
                    },
                    {
                        "id": 70930,
                        "name": "Ixtapan de la Concepción",
                        "latitude": "21.30774000",
                        "longitude": "-105.15773000"
                    },
                    {
                        "id": 70946,
                        "name": "Ixtlán del Río",
                        "latitude": "21.03907000",
                        "longitude": "-104.37116000"
                    },
                    {
                        "id": 70969,
                        "name": "Jalcocotán",
                        "latitude": "21.48122000",
                        "longitude": "-105.09851000"
                    },
                    {
                        "id": 71030,
                        "name": "Jesús María",
                        "latitude": "22.25056000",
                        "longitude": "-104.51792000"
                    },
                    {
                        "id": 71077,
                        "name": "Jomulco",
                        "latitude": "21.10394000",
                        "longitude": "-104.42378000"
                    },
                    {
                        "id": 71118,
                        "name": "Juan Escutia (Borbollón)",
                        "latitude": "21.16741000",
                        "longitude": "-104.86698000"
                    },
                    {
                        "id": 71200,
                        "name": "La Cantera",
                        "latitude": "21.50308000",
                        "longitude": "-104.82237000"
                    },
                    {
                        "id": 71246,
                        "name": "La Corregidora",
                        "latitude": "21.44417000",
                        "longitude": "-104.81222000"
                    },
                    {
                        "id": 71295,
                        "name": "La Fortuna",
                        "latitude": "21.55285000",
                        "longitude": "-104.95077000"
                    },
                    {
                        "id": 71312,
                        "name": "La Guásima",
                        "latitude": "22.40607000",
                        "longitude": "-105.38767000"
                    },
                    {
                        "id": 71339,
                        "name": "La Labor",
                        "latitude": "21.37299000",
                        "longitude": "-104.71910000"
                    },
                    {
                        "id": 71355,
                        "name": "La Libertad",
                        "latitude": "21.59347000",
                        "longitude": "-105.17365000"
                    },
                    {
                        "id": 71422,
                        "name": "La Palma",
                        "latitude": "21.49172000",
                        "longitude": "-105.17817000"
                    },
                    {
                        "id": 71444,
                        "name": "La Peñita de Jaltomba",
                        "latitude": "21.03884000",
                        "longitude": "-105.24792000"
                    },
                    {
                        "id": 71457,
                        "name": "La Presa",
                        "latitude": "22.34358000",
                        "longitude": "-105.39350000"
                    },
                    {
                        "id": 71537,
                        "name": "La Yesca",
                        "latitude": "21.31871000",
                        "longitude": "-104.01161000"
                    },
                    {
                        "id": 71606,
                        "name": "Las Jarretaderas",
                        "latitude": "20.69250000",
                        "longitude": "-105.27389000"
                    },
                    {
                        "id": 71648,
                        "name": "Las Varas",
                        "latitude": "21.18021000",
                        "longitude": "-105.13595000"
                    },
                    {
                        "id": 71697,
                        "name": "Llano del Tigre",
                        "latitude": "22.12707000",
                        "longitude": "-105.30581000"
                    },
                    {
                        "id": 71702,
                        "name": "Lo de Lamedo",
                        "latitude": "21.53843000",
                        "longitude": "-104.93945000"
                    },
                    {
                        "id": 71703,
                        "name": "Lo de Marcos",
                        "latitude": "20.95509000",
                        "longitude": "-105.35223000"
                    },
                    {
                        "id": 71765,
                        "name": "Los Aguajes",
                        "latitude": "21.10729000",
                        "longitude": "-104.35447000"
                    },
                    {
                        "id": 71826,
                        "name": "Los Otates",
                        "latitude": "21.70427000",
                        "longitude": "-105.37622000"
                    },
                    {
                        "id": 72057,
                        "name": "Mecatán",
                        "latitude": "21.53643000",
                        "longitude": "-105.11946000"
                    },
                    {
                        "id": 72082,
                        "name": "Mesa del Nayar",
                        "latitude": "22.21770000",
                        "longitude": "-104.65352000"
                    },
                    {
                        "id": 72263,
                        "name": "Méxpan",
                        "latitude": "21.03567000",
                        "longitude": "-104.41479000"
                    },
                    {
                        "id": 72106,
                        "name": "Mezcales",
                        "latitude": "20.73072000",
                        "longitude": "-105.28257000"
                    },
                    {
                        "id": 72139,
                        "name": "Milpas Viejas",
                        "latitude": "22.36478000",
                        "longitude": "-105.47549000"
                    },
                    {
                        "id": 72180,
                        "name": "Mojarras",
                        "latitude": "21.42592000",
                        "longitude": "-104.60851000"
                    },
                    {
                        "id": 72220,
                        "name": "Monteón",
                        "latitude": "20.99108000",
                        "longitude": "-105.29988000"
                    },
                    {
                        "id": 72295,
                        "name": "Navarrete",
                        "latitude": "21.64841000",
                        "longitude": "-105.11539000"
                    },
                    {
                        "id": 72418,
                        "name": "Nuevo Vallarta",
                        "latitude": "20.70169000",
                        "longitude": "-105.29417000"
                    },
                    {
                        "id": 72585,
                        "name": "Palma Grande",
                        "latitude": "21.99333000",
                        "longitude": "-105.38944000"
                    },
                    {
                        "id": 72592,
                        "name": "Palmar de Cuautla",
                        "latitude": "22.21972000",
                        "longitude": "-105.64750000"
                    },
                    {
                        "id": 72624,
                        "name": "Pantanal",
                        "latitude": "21.42824000",
                        "longitude": "-104.86122000"
                    },
                    {
                        "id": 72734,
                        "name": "Pericos",
                        "latitude": "22.04925000",
                        "longitude": "-105.35402000"
                    },
                    {
                        "id": 72872,
                        "name": "Pozo de Ibarra",
                        "latitude": "21.86692000",
                        "longitude": "-105.27949000"
                    },
                    {
                        "id": 72961,
                        "name": "Puerta de Mangos",
                        "latitude": "21.71853000",
                        "longitude": "-105.33534000"
                    },
                    {
                        "id": 72982,
                        "name": "Puga",
                        "latitude": "21.58443000",
                        "longitude": "-104.82318000"
                    },
                    {
                        "id": 73032,
                        "name": "Quimichis",
                        "latitude": "22.36122000",
                        "longitude": "-105.53913000"
                    },
                    {
                        "id": 73128,
                        "name": "Rincón de Guayabitos",
                        "latitude": "21.02315000",
                        "longitude": "-105.27054000"
                    },
                    {
                        "id": 73158,
                        "name": "Rosa Blanca",
                        "latitude": "21.12454000",
                        "longitude": "-104.35811000"
                    },
                    {
                        "id": 73161,
                        "name": "Rosamorada",
                        "latitude": "22.12208000",
                        "longitude": "-105.20640000"
                    },
                    {
                        "id": 73166,
                        "name": "Ruíz",
                        "latitude": "21.95107000",
                        "longitude": "-105.14380000"
                    },
                    {
                        "id": 73445,
                        "name": "San Blas",
                        "latitude": "21.54333000",
                        "longitude": "-105.28558000"
                    },
                    {
                        "id": 73464,
                        "name": "San Cayetano",
                        "latitude": "21.44949000",
                        "longitude": "-104.81702000"
                    },
                    {
                        "id": 73469,
                        "name": "San Clemente de Lima",
                        "latitude": "20.73722000",
                        "longitude": "-105.27083000"
                    },
                    {
                        "id": 73513,
                        "name": "San Felipe Aztatán",
                        "latitude": "22.38374000",
                        "longitude": "-105.41980000"
                    },
                    {
                        "id": 73541,
                        "name": "San Francisco",
                        "latitude": "20.90196000",
                        "longitude": "-105.41279000"
                    },
                    {
                        "id": 73818,
                        "name": "San José de Gracia",
                        "latitude": "22.48105000",
                        "longitude": "-105.37869000"
                    },
                    {
                        "id": 73870,
                        "name": "San Juan Bautista",
                        "latitude": "22.14359000",
                        "longitude": "-105.09750000"
                    },
                    {
                        "id": 73958,
                        "name": "San Juan de Abajo",
                        "latitude": "20.81484000",
                        "longitude": "-105.19154000"
                    },
                    {
                        "id": 74059,
                        "name": "San Luis de Lozada",
                        "latitude": "21.50297000",
                        "longitude": "-104.70552000"
                    },
                    {
                        "id": 74349,
                        "name": "San Pedro Lagunillas",
                        "latitude": "21.21920000",
                        "longitude": "-104.75228000"
                    },
                    {
                        "id": 74493,
                        "name": "San Vicente",
                        "latitude": "21.95043000",
                        "longitude": "-105.29710000"
                    },
                    {
                        "id": 74611,
                        "name": "Santa Cruz",
                        "latitude": "21.98118000",
                        "longitude": "-105.60169000"
                    },
                    {
                        "id": 74672,
                        "name": "Santa Isabel",
                        "latitude": "21.16304000",
                        "longitude": "-104.62374000"
                    },
                    {
                        "id": 74815,
                        "name": "Santa María del Oro",
                        "latitude": "21.33390000",
                        "longitude": "-104.58696000"
                    },
                    {
                        "id": 74859,
                        "name": "Santa Teresa",
                        "latitude": "22.49730000",
                        "longitude": "-104.76547000"
                    },
                    {
                        "id": 74984,
                        "name": "Santiago de Pochotitán",
                        "latitude": "21.58159000",
                        "longitude": "-104.69858000"
                    },
                    {
                        "id": 74907,
                        "name": "Santiago Ixcuintla",
                        "latitude": "21.81295000",
                        "longitude": "-105.20844000"
                    },
                    {
                        "id": 75045,
                        "name": "Sauta",
                        "latitude": "21.72116000",
                        "longitude": "-105.14249000"
                    },
                    {
                        "id": 75048,
                        "name": "Sayulilla",
                        "latitude": "22.43822000",
                        "longitude": "-105.39137000"
                    },
                    {
                        "id": 75049,
                        "name": "Sayulita",
                        "latitude": "20.87006000",
                        "longitude": "-105.43992000"
                    },
                    {
                        "id": 75060,
                        "name": "Sentispac",
                        "latitude": "21.80478000",
                        "longitude": "-105.34593000"
                    },
                    {
                        "id": 75289,
                        "name": "Tecuala",
                        "latitude": "22.39815000",
                        "longitude": "-105.45808000"
                    },
                    {
                        "id": 75447,
                        "name": "Tepic",
                        "latitude": "21.50951000",
                        "longitude": "-104.89569000"
                    },
                    {
                        "id": 75455,
                        "name": "Tequepexpan",
                        "latitude": "21.21571000",
                        "longitude": "-104.56958000"
                    },
                    {
                        "id": 75473,
                        "name": "Testerazo",
                        "latitude": "21.40242000",
                        "longitude": "-104.89420000"
                    },
                    {
                        "id": 75488,
                        "name": "Tetitlán",
                        "latitude": "21.12903000",
                        "longitude": "-104.61613000"
                    },
                    {
                        "id": 75887,
                        "name": "Unión de Corrientes",
                        "latitude": "21.97644000",
                        "longitude": "-105.43026000"
                    },
                    {
                        "id": 75904,
                        "name": "Uzeta",
                        "latitude": "21.11497000",
                        "longitude": "-104.60171000"
                    },
                    {
                        "id": 75920,
                        "name": "Valle de Banderas",
                        "latitude": "20.80792000",
                        "longitude": "-105.24813000"
                    },
                    {
                        "id": 76013,
                        "name": "Villa Hidalgo",
                        "latitude": "21.74185000",
                        "longitude": "-105.23096000"
                    },
                    {
                        "id": 76020,
                        "name": "Villa Juárez",
                        "latitude": "21.68917000",
                        "longitude": "-105.38972000"
                    },
                    {
                        "id": 76209,
                        "name": "Yago",
                        "latitude": "21.83601000",
                        "longitude": "-105.06451000"
                    },
                    {
                        "id": 76284,
                        "name": "Zacualpan",
                        "latitude": "21.24715000",
                        "longitude": "-105.16570000"
                    },
                    {
                        "id": 76313,
                        "name": "Zapotán",
                        "latitude": "21.08936000",
                        "longitude": "-104.86246000"
                    },
                    {
                        "id": 76301,
                        "name": "Zapotanito",
                        "latitude": "21.30533000",
                        "longitude": "-104.60899000"
                    }
                ]
            },
            {
                "id": 3452,
                "name": "Nuevo León",
                "iso2": "NLE",
                "latitude": "25.59217200",
                "longitude": "-99.99619470",
                "type": "state",
                "cities": [
                    {
                        "id": 68123,
                        "name": "Agualeguas",
                        "latitude": "26.31362000",
                        "longitude": "-99.53728000"
                    },
                    {
                        "id": 149670,
                        "name": "Agualeguas Nuevo León",
                        "latitude": "26.31083333",
                        "longitude": "-99.53916667"
                    },
                    {
                        "id": 149671,
                        "name": "Alberto Villarreal",
                        "latitude": "25.94389000",
                        "longitude": "-100.41167000"
                    },
                    {
                        "id": 149672,
                        "name": "Aldama Estación",
                        "latitude": "26.02444000",
                        "longitude": "-99.20250000"
                    },
                    {
                        "id": 149673,
                        "name": "Alfonso Reyes",
                        "latitude": "26.07667000",
                        "longitude": "-99.59611000"
                    },
                    {
                        "id": 68203,
                        "name": "Alianza Real",
                        "latitude": "25.85139000",
                        "longitude": "-100.38278000"
                    },
                    {
                        "id": 149674,
                        "name": "Allende",
                        "latitude": "25.28333333",
                        "longitude": "-100.01666667"
                    },
                    {
                        "id": 149675,
                        "name": "Altamira",
                        "latitude": "25.68910000",
                        "longitude": "-99.61940000"
                    },
                    {
                        "id": 149676,
                        "name": "Ampliación de la Laguna",
                        "latitude": "25.29785000",
                        "longitude": "-99.72584000"
                    },
                    {
                        "id": 68285,
                        "name": "Anáhuac",
                        "latitude": "27.24457000",
                        "longitude": "-100.13229000"
                    },
                    {
                        "id": 149677,
                        "name": "Apodaca",
                        "latitude": "25.78166667",
                        "longitude": "-100.18861111"
                    },
                    {
                        "id": 149678,
                        "name": "Aquiles Serdán",
                        "latitude": "24.96056000",
                        "longitude": "-100.71556000"
                    },
                    {
                        "id": 68328,
                        "name": "Aramberri",
                        "latitude": "24.09984000",
                        "longitude": "-99.81729000"
                    },
                    {
                        "id": 149679,
                        "name": "Armando Fernández Garza",
                        "latitude": "25.82278000",
                        "longitude": "-100.62778000"
                    },
                    {
                        "id": 68375,
                        "name": "Artemio Treviño",
                        "latitude": "25.83528000",
                        "longitude": "-100.14278000"
                    },
                    {
                        "id": 149680,
                        "name": "Barrio Aldamas",
                        "latitude": "26.08056000",
                        "longitude": "-99.18139000"
                    },
                    {
                        "id": 149681,
                        "name": "Barrio de Jalisco",
                        "latitude": "24.82093000",
                        "longitude": "-100.10461000"
                    },
                    {
                        "id": 149682,
                        "name": "Bello Amanecer",
                        "latitude": "25.69806000",
                        "longitude": "-100.13528000"
                    },
                    {
                        "id": 68644,
                        "name": "Bosques de San Pedro",
                        "latitude": "25.60139000",
                        "longitude": "-100.17972000"
                    },
                    {
                        "id": 68661,
                        "name": "Buena Vista",
                        "latitude": "25.85222000",
                        "longitude": "-100.36000000"
                    },
                    {
                        "id": 68694,
                        "name": "Bustamante",
                        "latitude": "26.55567000",
                        "longitude": "-100.50603000"
                    },
                    {
                        "id": 68717,
                        "name": "Cadereyta",
                        "latitude": "25.58333000",
                        "longitude": "-99.98333000"
                    },
                    {
                        "id": 68718,
                        "name": "Cadereyta Jiménez",
                        "latitude": "25.58896000",
                        "longitude": "-100.00156000"
                    },
                    {
                        "id": 149683,
                        "name": "Caja Pinta",
                        "latitude": "24.71708000",
                        "longitude": "-99.66759000"
                    },
                    {
                        "id": 149684,
                        "name": "Campestre el Montesito",
                        "latitude": "25.46861000",
                        "longitude": "-100.08750000"
                    },
                    {
                        "id": 149688,
                        "name": "Cañón de Vacas",
                        "latitude": "24.29472000",
                        "longitude": "-99.72000000"
                    },
                    {
                        "id": 149685,
                        "name": "Cantú",
                        "latitude": "25.88000000",
                        "longitude": "-99.17944000"
                    },
                    {
                        "id": 149686,
                        "name": "Carboneras",
                        "latitude": "26.49222000",
                        "longitude": "-100.07639000"
                    },
                    {
                        "id": 68826,
                        "name": "Carmen",
                        "latitude": "25.93650000",
                        "longitude": "-100.36396000"
                    },
                    {
                        "id": 149687,
                        "name": "Casa Rosa",
                        "latitude": "25.94667000",
                        "longitude": "-100.40389000"
                    },
                    {
                        "id": 68861,
                        "name": "Catarino Rodríguez",
                        "latitude": "24.84542000",
                        "longitude": "-100.32046000"
                    },
                    {
                        "id": 149689,
                        "name": "Centro Habitacional Burócratas de Guadalupe",
                        "latitude": "25.63667000",
                        "longitude": "-100.15333000"
                    },
                    {
                        "id": 68908,
                        "name": "Cerralvo",
                        "latitude": "26.09766000",
                        "longitude": "-99.65340000"
                    },
                    {
                        "id": 149690,
                        "name": "Charco Redondo",
                        "latitude": "26.06194000",
                        "longitude": "-99.56194000"
                    },
                    {
                        "id": 69080,
                        "name": "China",
                        "latitude": "25.69997000",
                        "longitude": "-99.23454000"
                    },
                    {
                        "id": 69198,
                        "name": "Ciénega de Flores",
                        "latitude": "25.95467000",
                        "longitude": "-100.16695000"
                    },
                    {
                        "id": 149691,
                        "name": "Cinco Señores",
                        "latitude": "24.87480000",
                        "longitude": "-99.62277000"
                    },
                    {
                        "id": 149692,
                        "name": "Ciudad Anáhuac",
                        "latitude": "27.24457000",
                        "longitude": "-100.13229000"
                    },
                    {
                        "id": 69144,
                        "name": "Ciudad Apodaca",
                        "latitude": "25.78195000",
                        "longitude": "-100.18839000"
                    },
                    {
                        "id": 69146,
                        "name": "Ciudad Benito Juárez",
                        "latitude": "25.64724000",
                        "longitude": "-100.09582000"
                    },
                    {
                        "id": 69148,
                        "name": "Ciudad Cerralvo",
                        "latitude": "26.08499000",
                        "longitude": "-99.61508000"
                    },
                    {
                        "id": 69185,
                        "name": "Ciudad de Allende",
                        "latitude": "25.27673000",
                        "longitude": "-100.01442000"
                    },
                    {
                        "id": 69194,
                        "name": "Ciudad de Villaldama",
                        "latitude": "26.49952000",
                        "longitude": "-100.42508000"
                    },
                    {
                        "id": 69156,
                        "name": "Ciudad General Escobedo",
                        "latitude": "25.79698000",
                        "longitude": "-100.31791000"
                    },
                    {
                        "id": 69157,
                        "name": "Ciudad General Terán",
                        "latitude": "25.25857000",
                        "longitude": "-99.68371000"
                    },
                    {
                        "id": 69177,
                        "name": "Ciudad Sabinas Hidalgo",
                        "latitude": "26.50358000",
                        "longitude": "-100.18187000"
                    },
                    {
                        "id": 69180,
                        "name": "Ciudad Satélite del Norte",
                        "latitude": "25.91448000",
                        "longitude": "-100.26542000"
                    },
                    {
                        "id": 69259,
                        "name": "Colinas del Aeropuerto",
                        "latitude": "25.81705000",
                        "longitude": "-100.10258000"
                    },
                    {
                        "id": 149693,
                        "name": "Colinas del Río Juárez",
                        "latitude": "25.66944000",
                        "longitude": "-100.12250000"
                    },
                    {
                        "id": 149694,
                        "name": "Colombia",
                        "latitude": "27.70333333",
                        "longitude": "-99.75944444"
                    },
                    {
                        "id": 149695,
                        "name": "Colonia Independencia (Monterrey)",
                        "latitude": "25.65917000",
                        "longitude": "-100.32416000"
                    },
                    {
                        "id": 149696,
                        "name": "Colonia la Mesa",
                        "latitude": "25.81389000",
                        "longitude": "-100.07306000"
                    },
                    {
                        "id": 149697,
                        "name": "Conferín Arizpe",
                        "latitude": "25.80833000",
                        "longitude": "-99.15806000"
                    },
                    {
                        "id": 69450,
                        "name": "Congregación Calles",
                        "latitude": "25.22528000",
                        "longitude": "-99.93472000"
                    },
                    {
                        "id": 149698,
                        "name": "Constitución",
                        "latitude": "26.47611000",
                        "longitude": "-100.11972000"
                    },
                    {
                        "id": 149699,
                        "name": "Dieciocho de Marzo",
                        "latitude": "24.88951000",
                        "longitude": "-100.18001000"
                    },
                    {
                        "id": 149700,
                        "name": "Dieciséis de Septiembre",
                        "latitude": "25.59111000",
                        "longitude": "-100.15000000"
                    },
                    {
                        "id": 149701,
                        "name": "Doce de Octubre",
                        "latitude": "25.62333000",
                        "longitude": "-100.06583000"
                    },
                    {
                        "id": 69692,
                        "name": "Doctor Arroyo",
                        "latitude": "23.67211000",
                        "longitude": "-100.18134000"
                    },
                    {
                        "id": 69694,
                        "name": "Doctor Coss",
                        "latitude": "25.92492000",
                        "longitude": "-99.18316000"
                    },
                    {
                        "id": 149702,
                        "name": "Doctor Coss Nuevo León",
                        "latitude": "25.92589722",
                        "longitude": "-99.18437222"
                    },
                    {
                        "id": 69696,
                        "name": "Doctor González",
                        "latitude": "25.85983000",
                        "longitude": "-99.94409000"
                    },
                    {
                        "id": 149703,
                        "name": "Dolores",
                        "latitude": "23.51333000",
                        "longitude": "-100.23194000"
                    },
                    {
                        "id": 149704,
                        "name": "El Bajío",
                        "latitude": "25.19972000",
                        "longitude": "-99.86583000"
                    },
                    {
                        "id": 149705,
                        "name": "El Barco",
                        "latitude": "25.37722000",
                        "longitude": "-99.85750000"
                    },
                    {
                        "id": 149706,
                        "name": "El Bosque",
                        "latitude": "25.21861000",
                        "longitude": "-99.86750000"
                    },
                    {
                        "id": 149707,
                        "name": "El Brasil",
                        "latitude": "25.89417000",
                        "longitude": "-98.99028000"
                    },
                    {
                        "id": 149708,
                        "name": "El Carmen de los Elizondo",
                        "latitude": "24.97670000",
                        "longitude": "-99.43876000"
                    },
                    {
                        "id": 149709,
                        "name": "El Carmen Nuevo León",
                        "latitude": "25.93222778",
                        "longitude": "-100.36412222"
                    },
                    {
                        "id": 149710,
                        "name": "El Cedral",
                        "latitude": "24.89528000",
                        "longitude": "-100.18500000"
                    },
                    {
                        "id": 149711,
                        "name": "El Cerrito",
                        "latitude": "25.29542000",
                        "longitude": "-99.98675000"
                    },
                    {
                        "id": 149712,
                        "name": "El Chamizal",
                        "latitude": "24.90250000",
                        "longitude": "-99.52028000"
                    },
                    {
                        "id": 149713,
                        "name": "El Dieciséis",
                        "latitude": "23.55591000",
                        "longitude": "-100.37882000"
                    },
                    {
                        "id": 149714,
                        "name": "El Diez",
                        "latitude": "24.86472000",
                        "longitude": "-99.45667000"
                    },
                    {
                        "id": 149715,
                        "name": "El Fraile",
                        "latitude": "25.80722000",
                        "longitude": "-100.50361000"
                    },
                    {
                        "id": 149716,
                        "name": "El Leal",
                        "latitude": "25.88500000",
                        "longitude": "-100.29250000"
                    },
                    {
                        "id": 149717,
                        "name": "El Maguey",
                        "latitude": "25.30784000",
                        "longitude": "-100.00779000"
                    },
                    {
                        "id": 149718,
                        "name": "El Mosquito Linares",
                        "latitude": "24.66417000",
                        "longitude": "-99.67417000"
                    },
                    {
                        "id": 149719,
                        "name": "El Nogalito",
                        "latitude": "25.28556000",
                        "longitude": "-99.87639000"
                    },
                    {
                        "id": 149720,
                        "name": "El Palmital",
                        "latitude": "25.83088000",
                        "longitude": "-100.59476000"
                    },
                    {
                        "id": 149721,
                        "name": "El Pastor",
                        "latitude": "25.14907000",
                        "longitude": "-99.92974000"
                    },
                    {
                        "id": 149722,
                        "name": "El Ranchito Número Uno",
                        "latitude": "25.69167000",
                        "longitude": "-100.16667000"
                    },
                    {
                        "id": 149723,
                        "name": "El Realito",
                        "latitude": "24.10222000",
                        "longitude": "-99.83694000"
                    },
                    {
                        "id": 149724,
                        "name": "El Refugio",
                        "latitude": "24.90583000",
                        "longitude": "-99.52861000"
                    },
                    {
                        "id": 149725,
                        "name": "El Refugio y el Reparo",
                        "latitude": "23.65972000",
                        "longitude": "-100.34028000"
                    },
                    {
                        "id": 149726,
                        "name": "El Rucio",
                        "latitude": "24.39758000",
                        "longitude": "-99.80775000"
                    },
                    {
                        "id": 149727,
                        "name": "El Saladito",
                        "latitude": "25.89833000",
                        "longitude": "-100.03139000"
                    },
                    {
                        "id": 149728,
                        "name": "El Salitre",
                        "latitude": "23.95990000",
                        "longitude": "-99.83058000"
                    },
                    {
                        "id": 70288,
                        "name": "Emiliano Zapata",
                        "latitude": "25.91028000",
                        "longitude": "-100.28056000"
                    },
                    {
                        "id": 70308,
                        "name": "Entronque Laredo-Salinas Victoria",
                        "latitude": "25.85500000",
                        "longitude": "-100.24722000"
                    },
                    {
                        "id": 149729,
                        "name": "Estados Unidos",
                        "latitude": "25.12444000",
                        "longitude": "-100.47639000"
                    },
                    {
                        "id": 70417,
                        "name": "Fraccionamiento Cosmópolis Octavo Sector",
                        "latitude": "25.82528000",
                        "longitude": "-100.24611000"
                    },
                    {
                        "id": 149730,
                        "name": "Fraccionamiento del Valle",
                        "latitude": "25.92306000",
                        "longitude": "-100.37944000"
                    },
                    {
                        "id": 70427,
                        "name": "Fraccionamiento Misión de San Javier",
                        "latitude": "25.74556000",
                        "longitude": "-100.15194000"
                    },
                    {
                        "id": 70435,
                        "name": "Fraccionamiento Real Palmas",
                        "latitude": "25.90417000",
                        "longitude": "-100.15972000"
                    },
                    {
                        "id": 149731,
                        "name": "Francisco I. Madero",
                        "latitude": "25.09139000",
                        "longitude": "-98.92250000"
                    },
                    {
                        "id": 149732,
                        "name": "Francisco Villa",
                        "latitude": "25.70500000",
                        "longitude": "-99.99639000"
                    },
                    {
                        "id": 70509,
                        "name": "Galeana",
                        "latitude": "24.82455000",
                        "longitude": "-100.07601000"
                    },
                    {
                        "id": 70520,
                        "name": "García",
                        "latitude": "25.81201000",
                        "longitude": "-100.59874000"
                    },
                    {
                        "id": 149733,
                        "name": "Garza García",
                        "latitude": "25.65384000",
                        "longitude": "-100.37758000"
                    },
                    {
                        "id": 149734,
                        "name": "Garza González",
                        "latitude": "25.83139000",
                        "longitude": "-99.62417000"
                    },
                    {
                        "id": 70526,
                        "name": "General Bravo",
                        "latitude": "25.79239000",
                        "longitude": "-99.18147000"
                    },
                    {
                        "id": 149735,
                        "name": "General Escobedo",
                        "latitude": "25.80833333",
                        "longitude": "-100.32666667"
                    },
                    {
                        "id": 149736,
                        "name": "General Tapia",
                        "latitude": "25.82556000",
                        "longitude": "-99.03972000"
                    },
                    {
                        "id": 149737,
                        "name": "General Terán Nuevo León",
                        "latitude": "25.26666667",
                        "longitude": "-99.68333333"
                    },
                    {
                        "id": 149738,
                        "name": "General Treviño",
                        "latitude": "26.21666667",
                        "longitude": "-99.48333333"
                    },
                    {
                        "id": 70546,
                        "name": "General Zuazua",
                        "latitude": "25.89491000",
                        "longitude": "-100.10800000"
                    },
                    {
                        "id": 149739,
                        "name": "Graciano Bortoni",
                        "latitude": "26.48583000",
                        "longitude": "-100.14333000"
                    },
                    {
                        "id": 70573,
                        "name": "Guadalupe",
                        "latitude": "25.67678000",
                        "longitude": "-100.25646000"
                    },
                    {
                        "id": 149741,
                        "name": "Hacienda de Enmedio",
                        "latitude": "25.23389000",
                        "longitude": "-99.84944000"
                    },
                    {
                        "id": 149740,
                        "name": "Hacienda San Juan",
                        "latitude": "26.48306000",
                        "longitude": "-100.16778000"
                    },
                    {
                        "id": 70653,
                        "name": "Hacienda San Pedro",
                        "latitude": "25.91472000",
                        "longitude": "-100.16278000"
                    },
                    {
                        "id": 70827,
                        "name": "Héctor Caballero",
                        "latitude": "25.63556000",
                        "longitude": "-100.12667000"
                    },
                    {
                        "id": 149742,
                        "name": "Hidalgo",
                        "latitude": "25.97555556",
                        "longitude": "-100.45083333"
                    },
                    {
                        "id": 149743,
                        "name": "Higueras Nuevo León",
                        "latitude": "25.96195556",
                        "longitude": "-100.01435000"
                    },
                    {
                        "id": 70724,
                        "name": "Hualahuises",
                        "latitude": "24.88295000",
                        "longitude": "-99.67490000"
                    },
                    {
                        "id": 149744,
                        "name": "Huertas Estación",
                        "latitude": "25.03778000",
                        "longitude": "-99.70861000"
                    },
                    {
                        "id": 149745,
                        "name": "Ibarrilla",
                        "latitude": "24.37250000",
                        "longitude": "-99.67306000"
                    },
                    {
                        "id": 149746,
                        "name": "Ismael Flores",
                        "latitude": "25.62389000",
                        "longitude": "-100.07222000"
                    },
                    {
                        "id": 70893,
                        "name": "Iturbide",
                        "latitude": "24.72596000",
                        "longitude": "-99.90406000"
                    },
                    {
                        "id": 149747,
                        "name": "Iturbide Nuevo León",
                        "latitude": "24.72527778",
                        "longitude": "-99.90000000"
                    },
                    {
                        "id": 149748,
                        "name": "Jardines de la Silla",
                        "latitude": "25.62944000",
                        "longitude": "-100.18778000"
                    },
                    {
                        "id": 71005,
                        "name": "Jardines de la Silla (Jardines)",
                        "latitude": "25.62944000",
                        "longitude": "-100.18778000"
                    },
                    {
                        "id": 149754,
                        "name": "Jáuregui",
                        "latitude": "25.29500000",
                        "longitude": "-99.95167000"
                    },
                    {
                        "id": 149749,
                        "name": "Jesús María Aguirre Galeana",
                        "latitude": "24.41340000",
                        "longitude": "-100.37303000"
                    },
                    {
                        "id": 149750,
                        "name": "Jesús María de Berrones",
                        "latitude": "23.91748000",
                        "longitude": "-100.02869000"
                    },
                    {
                        "id": 149751,
                        "name": "Jesús María del Terrero",
                        "latitude": "23.39944000",
                        "longitude": "-100.17806000"
                    },
                    {
                        "id": 149752,
                        "name": "Juan Salazar",
                        "latitude": "27.46918000",
                        "longitude": "-100.38395000"
                    },
                    {
                        "id": 149753,
                        "name": "Juárez Nuevo León",
                        "latitude": "25.65000000",
                        "longitude": "-100.08333333"
                    },
                    {
                        "id": 149755,
                        "name": "Kilómetro Dieciséis",
                        "latitude": "24.77361000",
                        "longitude": "-99.67722000"
                    },
                    {
                        "id": 149756,
                        "name": "La Agüita",
                        "latitude": "23.96500000",
                        "longitude": "-100.18361000"
                    },
                    {
                        "id": 149757,
                        "name": "La Aldea",
                        "latitude": "24.08064000",
                        "longitude": "-99.80357000"
                    },
                    {
                        "id": 149758,
                        "name": "La Arena",
                        "latitude": "24.97472000",
                        "longitude": "-99.72167000"
                    },
                    {
                        "id": 71176,
                        "name": "La Ascensión",
                        "latitude": "24.32392000",
                        "longitude": "-99.91410000"
                    },
                    {
                        "id": 149759,
                        "name": "La Barreta",
                        "latitude": "25.07694000",
                        "longitude": "-98.98306000"
                    },
                    {
                        "id": 149760,
                        "name": "La Baticolla",
                        "latitude": "23.88702000",
                        "longitude": "-100.47412000"
                    },
                    {
                        "id": 149761,
                        "name": "La Boquilla",
                        "latitude": "25.27028000",
                        "longitude": "-100.04361000"
                    },
                    {
                        "id": 149762,
                        "name": "La Campana",
                        "latitude": "25.29898000",
                        "longitude": "-98.67721000"
                    },
                    {
                        "id": 149763,
                        "name": "La Candelaria",
                        "latitude": "25.67833000",
                        "longitude": "-100.70333000"
                    },
                    {
                        "id": 149764,
                        "name": "La Cardona",
                        "latitude": "23.40328000",
                        "longitude": "-99.98111000"
                    },
                    {
                        "id": 149765,
                        "name": "La Chiripa",
                        "latitude": "23.72129000",
                        "longitude": "-100.37007000"
                    },
                    {
                        "id": 149766,
                        "name": "La Chueca Cadereyta Jiménez",
                        "latitude": "25.51917000",
                        "longitude": "-99.98083000"
                    },
                    {
                        "id": 149767,
                        "name": "La Colmena de Arriba",
                        "latitude": "25.28284000",
                        "longitude": "-100.05473000"
                    },
                    {
                        "id": 149768,
                        "name": "La Escuadra",
                        "latitude": "25.25284000",
                        "longitude": "-99.99029000"
                    },
                    {
                        "id": 149769,
                        "name": "La Esperanza",
                        "latitude": "24.71556000",
                        "longitude": "-100.56000000"
                    },
                    {
                        "id": 149770,
                        "name": "La Estrella",
                        "latitude": "24.94750000",
                        "longitude": "-99.78722000"
                    },
                    {
                        "id": 149771,
                        "name": "La Fama",
                        "latitude": "25.66341000",
                        "longitude": "-100.42650000"
                    },
                    {
                        "id": 149772,
                        "name": "La Florida",
                        "latitude": "24.12111000",
                        "longitude": "-99.82361000"
                    },
                    {
                        "id": 149773,
                        "name": "La Gloria",
                        "latitude": "25.67139000",
                        "longitude": "-100.71417000"
                    },
                    {
                        "id": 149774,
                        "name": "La Haciendita",
                        "latitude": "25.51853000",
                        "longitude": "-99.76589000"
                    },
                    {
                        "id": 149775,
                        "name": "La Joya de Alardín",
                        "latitude": "23.99917000",
                        "longitude": "-99.79472000"
                    },
                    {
                        "id": 149776,
                        "name": "La Lagunita",
                        "latitude": "24.93472000",
                        "longitude": "-100.23917000"
                    },
                    {
                        "id": 149777,
                        "name": "La Lobera de Portillo",
                        "latitude": "23.57250000",
                        "longitude": "-100.21333000"
                    },
                    {
                        "id": 149778,
                        "name": "La Maestranza",
                        "latitude": "25.61028000",
                        "longitude": "-100.16833000"
                    },
                    {
                        "id": 149779,
                        "name": "La Mesa de Berrones",
                        "latitude": "23.64139000",
                        "longitude": "-100.09667000"
                    },
                    {
                        "id": 149780,
                        "name": "La Palmita Nuevo Leon",
                        "latitude": "25.92952500",
                        "longitude": "-99.30310278"
                    },
                    {
                        "id": 149781,
                        "name": "La Presita de Berlanga",
                        "latitude": "24.43655000",
                        "longitude": "-100.15287000"
                    },
                    {
                        "id": 149782,
                        "name": "La Providencia",
                        "latitude": "25.74500000",
                        "longitude": "-99.88639000"
                    },
                    {
                        "id": 149783,
                        "name": "La Purísima",
                        "latitude": "24.53536000",
                        "longitude": "-99.83052000"
                    },
                    {
                        "id": 149784,
                        "name": "La Reforma",
                        "latitude": "24.69781000",
                        "longitude": "-99.54136000"
                    },
                    {
                        "id": 149785,
                        "name": "La Soledad",
                        "latitude": "24.70889000",
                        "longitude": "-99.53500000"
                    },
                    {
                        "id": 149786,
                        "name": "La Tinaja",
                        "latitude": "25.48034000",
                        "longitude": "-100.10530000"
                    },
                    {
                        "id": 149787,
                        "name": "La Trinidad",
                        "latitude": "25.23148000",
                        "longitude": "-100.14323000"
                    },
                    {
                        "id": 149788,
                        "name": "La Unión y el Cardonal",
                        "latitude": "23.84741000",
                        "longitude": "-100.09433000"
                    },
                    {
                        "id": 149789,
                        "name": "La Ventana",
                        "latitude": "25.14284000",
                        "longitude": "-100.15445000"
                    },
                    {
                        "id": 149790,
                        "name": "Ladrillera",
                        "latitude": "25.80306000",
                        "longitude": "-100.10111000"
                    },
                    {
                        "id": 71542,
                        "name": "Ladrillera (Entronque Pesquería)",
                        "latitude": "25.80306000",
                        "longitude": "-100.10111000"
                    },
                    {
                        "id": 71567,
                        "name": "Lampazos de Naranjo",
                        "latitude": "27.02549000",
                        "longitude": "-100.50528000"
                    },
                    {
                        "id": 149791,
                        "name": "Las Barretas",
                        "latitude": "24.84870000",
                        "longitude": "-99.43584000"
                    },
                    {
                        "id": 149792,
                        "name": "Las Brisas",
                        "latitude": "25.39284000",
                        "longitude": "-99.54898000"
                    },
                    {
                        "id": 149793,
                        "name": "Las Mesas de San Juan",
                        "latitude": "23.50675000",
                        "longitude": "-100.13910000"
                    },
                    {
                        "id": 149794,
                        "name": "Las Palomas",
                        "latitude": "23.54611000",
                        "longitude": "-100.18083000"
                    },
                    {
                        "id": 71643,
                        "name": "Las Torres",
                        "latitude": "25.95167000",
                        "longitude": "-100.31806000"
                    },
                    {
                        "id": 71644,
                        "name": "Las Torres de Guadalupe",
                        "latitude": "25.80611000",
                        "longitude": "-100.62250000"
                    },
                    {
                        "id": 71679,
                        "name": "Linares",
                        "latitude": "24.85798000",
                        "longitude": "-99.56768000"
                    },
                    {
                        "id": 149795,
                        "name": "Linares Nuevo León",
                        "latitude": "24.85965278",
                        "longitude": "-99.56786944"
                    },
                    {
                        "id": 71740,
                        "name": "Loma la Paz",
                        "latitude": "25.71111000",
                        "longitude": "-100.13472000"
                    },
                    {
                        "id": 149796,
                        "name": "Lomas de San Francisco",
                        "latitude": "25.21056000",
                        "longitude": "-100.00250000"
                    },
                    {
                        "id": 71750,
                        "name": "Lomas de San Martín",
                        "latitude": "25.74722000",
                        "longitude": "-100.11972000"
                    },
                    {
                        "id": 149801,
                        "name": "Los Álamos",
                        "latitude": "25.07807000",
                        "longitude": "-98.95178000"
                    },
                    {
                        "id": 149797,
                        "name": "Los Aldamas",
                        "latitude": "26.05000000",
                        "longitude": "-99.18333333"
                    },
                    {
                        "id": 149802,
                        "name": "Los Ángeles Nuevo León",
                        "latitude": "25.20257000",
                        "longitude": "-99.74834000"
                    },
                    {
                        "id": 149798,
                        "name": "Los Dos Ríos",
                        "latitude": "25.66812000",
                        "longitude": "-99.63752000"
                    },
                    {
                        "id": 149799,
                        "name": "Los Herreras",
                        "latitude": "25.90500000",
                        "longitude": "-99.40250000"
                    },
                    {
                        "id": 71828,
                        "name": "Los Parques",
                        "latitude": "25.79073000",
                        "longitude": "-100.46992000"
                    },
                    {
                        "id": 149800,
                        "name": "Los Pocitos",
                        "latitude": "25.23478000",
                        "longitude": "-100.19335000"
                    },
                    {
                        "id": 71839,
                        "name": "Los Ramones",
                        "latitude": "25.69716000",
                        "longitude": "-99.62529000"
                    },
                    {
                        "id": 149803,
                        "name": "María Aurora",
                        "latitude": "25.86923000",
                        "longitude": "-99.80864000"
                    },
                    {
                        "id": 149804,
                        "name": "María Auxiliadora",
                        "latitude": "25.23812000",
                        "longitude": "-99.79417000"
                    },
                    {
                        "id": 72007,
                        "name": "Marín",
                        "latitude": "25.87946000",
                        "longitude": "-100.03028000"
                    },
                    {
                        "id": 72045,
                        "name": "Mazatlan",
                        "latitude": "25.18909000",
                        "longitude": "-99.82865000"
                    },
                    {
                        "id": 149805,
                        "name": "Melchor Ocampo Nuevo León",
                        "latitude": "26.05861111",
                        "longitude": "-99.54222222"
                    },
                    {
                        "id": 149806,
                        "name": "Mexiquito",
                        "latitude": "25.19951000",
                        "longitude": "-99.80723000"
                    },
                    {
                        "id": 149807,
                        "name": "Mier y Noriega",
                        "latitude": "23.42671000",
                        "longitude": "-100.17282000"
                    },
                    {
                        "id": 72141,
                        "name": "Mina",
                        "latitude": "26.00110000",
                        "longitude": "-100.52988000"
                    },
                    {
                        "id": 149808,
                        "name": "Mina Nuevo León",
                        "latitude": "26.00110000",
                        "longitude": "-100.52988000"
                    },
                    {
                        "id": 72159,
                        "name": "Misión San Pablo",
                        "latitude": "25.74000000",
                        "longitude": "-100.14417000"
                    },
                    {
                        "id": 72162,
                        "name": "Mitras Poniente",
                        "latitude": "25.77583000",
                        "longitude": "-100.42583000"
                    },
                    {
                        "id": 72192,
                        "name": "Monclova Primer Sector",
                        "latitude": "25.81472000",
                        "longitude": "-100.40306000"
                    },
                    {
                        "id": 72193,
                        "name": "Monclova Segundo Sector",
                        "latitude": "25.81531000",
                        "longitude": "-100.39682000"
                    },
                    {
                        "id": 72202,
                        "name": "Monte Kristal",
                        "latitude": "25.62611000",
                        "longitude": "-100.15694000"
                    },
                    {
                        "id": 72215,
                        "name": "Montemorelos",
                        "latitude": "25.16697000",
                        "longitude": "-99.84430000"
                    },
                    {
                        "id": 72219,
                        "name": "Monterrey",
                        "latitude": "25.67507000",
                        "longitude": "-100.31847000"
                    },
                    {
                        "id": 149809,
                        "name": "Náñez González",
                        "latitude": "25.45451000",
                        "longitude": "-100.07002000"
                    },
                    {
                        "id": 72664,
                        "name": "Parás",
                        "latitude": "26.50013000",
                        "longitude": "-99.52156000"
                    },
                    {
                        "id": 149810,
                        "name": "Parás Nuevo León",
                        "latitude": "26.49888889",
                        "longitude": "-99.52250000"
                    },
                    {
                        "id": 72657,
                        "name": "Parque Industrial Ciudad Mitras",
                        "latitude": "25.78861000",
                        "longitude": "-100.44778000"
                    },
                    {
                        "id": 72668,
                        "name": "Paseo de San Javier",
                        "latitude": "25.73972000",
                        "longitude": "-100.13444000"
                    },
                    {
                        "id": 149811,
                        "name": "Pedro Ibarra Hernández",
                        "latitude": "23.40508000",
                        "longitude": "-100.17270000"
                    },
                    {
                        "id": 72740,
                        "name": "Pesquería",
                        "latitude": "25.78543000",
                        "longitude": "-100.05098000"
                    },
                    {
                        "id": 72854,
                        "name": "Portal de las Salinas",
                        "latitude": "25.98222000",
                        "longitude": "-100.14333000"
                    },
                    {
                        "id": 72878,
                        "name": "Praderas de San Francisco",
                        "latitude": "25.81833000",
                        "longitude": "-100.40250000"
                    },
                    {
                        "id": 72882,
                        "name": "Prados de Santa Rosa",
                        "latitude": "25.79808000",
                        "longitude": "-100.22687000"
                    },
                    {
                        "id": 72937,
                        "name": "Pueblo Nuevo",
                        "latitude": "25.48409000",
                        "longitude": "-99.75987000"
                    },
                    {
                        "id": 149812,
                        "name": "Puerto Genovevo Santiago",
                        "latitude": "25.34264000",
                        "longitude": "-100.18364000"
                    },
                    {
                        "id": 73085,
                        "name": "Rayones",
                        "latitude": "25.01799000",
                        "longitude": "-100.07362000"
                    },
                    {
                        "id": 73091,
                        "name": "Real del Sol",
                        "latitude": "25.93833000",
                        "longitude": "-100.18111000"
                    },
                    {
                        "id": 73185,
                        "name": "Río Verde",
                        "latitude": "24.90081000",
                        "longitude": "-99.54345000"
                    },
                    {
                        "id": 149813,
                        "name": "Rubén Carlos Gallegos Reyes Villaldama",
                        "latitude": "26.48254000",
                        "longitude": "-100.42588000"
                    },
                    {
                        "id": 149814,
                        "name": "Sabinas Hidalgo",
                        "latitude": "26.49833333",
                        "longitude": "-100.18111111"
                    },
                    {
                        "id": 73215,
                        "name": "Salinas Victoria",
                        "latitude": "25.96329000",
                        "longitude": "-100.29091000"
                    },
                    {
                        "id": 73316,
                        "name": "San Antonio",
                        "latitude": "25.63868000",
                        "longitude": "-100.05844000"
                    },
                    {
                        "id": 149815,
                        "name": "San Antonio de Alamitos",
                        "latitude": "23.46476000",
                        "longitude": "-100.21659000"
                    },
                    {
                        "id": 149816,
                        "name": "San Bernardo Nuevo León",
                        "latitude": "25.63333333",
                        "longitude": "-98.93333333"
                    },
                    {
                        "id": 149817,
                        "name": "San José de Cuatro Caminos",
                        "latitude": "23.50250000",
                        "longitude": "-100.27528000"
                    },
                    {
                        "id": 149818,
                        "name": "San José de Medina",
                        "latitude": "23.40508000",
                        "longitude": "-100.10687000"
                    },
                    {
                        "id": 73825,
                        "name": "San José de Raíces",
                        "latitude": "24.57145000",
                        "longitude": "-100.24002000"
                    },
                    {
                        "id": 149819,
                        "name": "San José Linares",
                        "latitude": "24.69202000",
                        "longitude": "-99.69665000"
                    },
                    {
                        "id": 73858,
                        "name": "San Juan",
                        "latitude": "25.54280000",
                        "longitude": "-99.84091000"
                    },
                    {
                        "id": 149820,
                        "name": "San Mateo Doctor Arroyo",
                        "latitude": "23.83925000",
                        "longitude": "-100.06995000"
                    },
                    {
                        "id": 74273,
                        "name": "San Nicolás de los Garza",
                        "latitude": "25.74167000",
                        "longitude": "-100.30222000"
                    },
                    {
                        "id": 74335,
                        "name": "San Pedro Garza Garcia",
                        "latitude": "25.65716000",
                        "longitude": "-100.40268000"
                    },
                    {
                        "id": 74427,
                        "name": "San Rafael",
                        "latitude": "25.03060000",
                        "longitude": "-100.55139000"
                    },
                    {
                        "id": 149821,
                        "name": "Santa Catarina",
                        "latitude": "25.67325000",
                        "longitude": "-100.45813000"
                    },
                    {
                        "id": 74837,
                        "name": "Santa Rosa",
                        "latitude": "25.82463000",
                        "longitude": "-100.22164000"
                    },
                    {
                        "id": 149822,
                        "name": "Santa Teresita",
                        "latitude": "25.87255000",
                        "longitude": "-100.11531000"
                    },
                    {
                        "id": 149823,
                        "name": "Santa Verónica",
                        "latitude": "24.72306000",
                        "longitude": "-99.64778000"
                    },
                    {
                        "id": 74868,
                        "name": "Santiago",
                        "latitude": "25.42533000",
                        "longitude": "-100.15205000"
                    },
                    {
                        "id": 75083,
                        "name": "Simeprodeso (Colectivo Nuevo)",
                        "latitude": "25.85306000",
                        "longitude": "-100.29167000"
                    },
                    {
                        "id": 75880,
                        "name": "Unión Agropecuarios Lázaro Cárdenas del Norte",
                        "latitude": "25.83222000",
                        "longitude": "-100.38417000"
                    },
                    {
                        "id": 149824,
                        "name": "Valle Alto",
                        "latitude": "25.56670000",
                        "longitude": "-100.25000000"
                    },
                    {
                        "id": 75922,
                        "name": "Valle de Juárez",
                        "latitude": "25.63778000",
                        "longitude": "-100.15833000"
                    },
                    {
                        "id": 75923,
                        "name": "Valle de Lincoln",
                        "latitude": "25.79333000",
                        "longitude": "-100.47778000"
                    },
                    {
                        "id": 75925,
                        "name": "Valle de Vaquerías",
                        "latitude": "25.63250000",
                        "longitude": "-100.14694000"
                    },
                    {
                        "id": 75930,
                        "name": "Vallecillo",
                        "latitude": "26.66033000",
                        "longitude": "-99.98744000"
                    },
                    {
                        "id": 76082,
                        "name": "Villaldama",
                        "latitude": "26.47039000",
                        "longitude": "-100.38726000"
                    },
                    {
                        "id": 149825,
                        "name": "Villaldama Nuevo León",
                        "latitude": "26.49952000",
                        "longitude": "-100.42508000"
                    },
                    {
                        "id": 76087,
                        "name": "Villas de Alcalá",
                        "latitude": "25.91528000",
                        "longitude": "-100.18528000"
                    }
                ]
            },
            {
                "id": 3448,
                "name": "Oaxaca",
                "iso2": "OAX",
                "latitude": "17.07318420",
                "longitude": "-96.72658890",
                "type": "state",
                "cities": [
                    {
                        "id": 68052,
                        "name": "Acatlán de Pérez Figueroa",
                        "latitude": "18.53973000",
                        "longitude": "-96.60568000"
                    },
                    {
                        "id": 68121,
                        "name": "Agua del Espino",
                        "latitude": "16.59095000",
                        "longitude": "-96.80204000"
                    },
                    {
                        "id": 68155,
                        "name": "Ahuehuetitlán",
                        "latitude": "17.67130000",
                        "longitude": "-98.32024000"
                    },
                    {
                        "id": 68173,
                        "name": "Albarradas",
                        "latitude": "17.06752000",
                        "longitude": "-96.20012000"
                    },
                    {
                        "id": 68212,
                        "name": "Almolonga",
                        "latitude": "18.60848000",
                        "longitude": "-96.66099000"
                    },
                    {
                        "id": 76394,
                        "name": "Álvaro Obregón",
                        "latitude": "16.29811000",
                        "longitude": "-95.08392000"
                    },
                    {
                        "id": 68275,
                        "name": "Animas Trujano",
                        "latitude": "16.99086000",
                        "longitude": "-96.71319000"
                    },
                    {
                        "id": 68310,
                        "name": "Apoala",
                        "latitude": "17.64845000",
                        "longitude": "-97.13608000"
                    },
                    {
                        "id": 68356,
                        "name": "Arroyo Chical (Nuevo Arroyo Chicali)",
                        "latitude": "18.21611000",
                        "longitude": "-96.33667000"
                    },
                    {
                        "id": 68357,
                        "name": "Arroyo Choápam",
                        "latitude": "17.97028000",
                        "longitude": "-96.15722000"
                    },
                    {
                        "id": 68368,
                        "name": "Arroyo de Banco",
                        "latitude": "17.80312000",
                        "longitude": "-96.34794000"
                    },
                    {
                        "id": 68369,
                        "name": "Arroyo de Enmedio",
                        "latitude": "18.49750000",
                        "longitude": "-96.54722000"
                    },
                    {
                        "id": 68362,
                        "name": "Arroyo Limón",
                        "latitude": "17.90008000",
                        "longitude": "-95.96175000"
                    },
                    {
                        "id": 68367,
                        "name": "Arroyo Zapotillo",
                        "latitude": "18.07639000",
                        "longitude": "-96.54417000"
                    },
                    {
                        "id": 68383,
                        "name": "Asunción Cacalotepec",
                        "latitude": "17.03470000",
                        "longitude": "-95.93361000"
                    },
                    {
                        "id": 68384,
                        "name": "Asunción Ixtaltepec",
                        "latitude": "16.50315000",
                        "longitude": "-95.06121000"
                    },
                    {
                        "id": 68385,
                        "name": "Asunción Nochixtlán",
                        "latitude": "17.45916000",
                        "longitude": "-97.22605000"
                    },
                    {
                        "id": 68386,
                        "name": "Asunción Ocotlán",
                        "latitude": "16.76195000",
                        "longitude": "-96.72137000"
                    },
                    {
                        "id": 68387,
                        "name": "Asunción Tlacolulita",
                        "latitude": "16.22612000",
                        "longitude": "-95.76620000"
                    },
                    {
                        "id": 68463,
                        "name": "Ayoquezco de Aldama",
                        "latitude": "16.68370000",
                        "longitude": "-96.84287000"
                    },
                    {
                        "id": 68468,
                        "name": "Ayotzintepec",
                        "latitude": "17.67261000",
                        "longitude": "-96.12855000"
                    },
                    {
                        "id": 68469,
                        "name": "Ayutla",
                        "latitude": "17.02756000",
                        "longitude": "-96.07632000"
                    },
                    {
                        "id": 68502,
                        "name": "Bajos de Chila",
                        "latitude": "15.92343000",
                        "longitude": "-97.12113000"
                    },
                    {
                        "id": 68530,
                        "name": "Barrio San Diego",
                        "latitude": "17.27917000",
                        "longitude": "-97.67417000"
                    },
                    {
                        "id": 68584,
                        "name": "Benemérito Juárez",
                        "latitude": "18.11944000",
                        "longitude": "-96.00194000"
                    },
                    {
                        "id": 68593,
                        "name": "Benito Juárez",
                        "latitude": "15.88178000",
                        "longitude": "-96.32405000"
                    },
                    {
                        "id": 68605,
                        "name": "Benito Juárez II (San Martín)",
                        "latitude": "18.14056000",
                        "longitude": "-96.46139000"
                    },
                    {
                        "id": 68614,
                        "name": "Bethania",
                        "latitude": "17.91939000",
                        "longitude": "-96.00459000"
                    },
                    {
                        "id": 68650,
                        "name": "Brisas de Zicatela",
                        "latitude": "15.83694000",
                        "longitude": "-97.04194000"
                    },
                    {
                        "id": 68723,
                        "name": "Cajonos",
                        "latitude": "17.16801000",
                        "longitude": "-96.26174000"
                    },
                    {
                        "id": 68737,
                        "name": "Calihualá",
                        "latitude": "17.53134000",
                        "longitude": "-98.27792000"
                    },
                    {
                        "id": 68762,
                        "name": "Camelia Roja",
                        "latitude": "18.02833000",
                        "longitude": "-96.20806000"
                    },
                    {
                        "id": 68767,
                        "name": "Camotinchan",
                        "latitude": "16.55873000",
                        "longitude": "-98.12433000"
                    },
                    {
                        "id": 68790,
                        "name": "Candelaria Loxicha",
                        "latitude": "15.92638000",
                        "longitude": "-96.49268000"
                    },
                    {
                        "id": 68812,
                        "name": "Capulálpam de Méndez",
                        "latitude": "17.30972000",
                        "longitude": "-96.44656000"
                    },
                    {
                        "id": 68921,
                        "name": "Cerro Armadillo Grande",
                        "latitude": "17.86611000",
                        "longitude": "-96.30861000"
                    },
                    {
                        "id": 68938,
                        "name": "Cerro del Aire",
                        "latitude": "16.11012000",
                        "longitude": "-97.20438000"
                    },
                    {
                        "id": 68932,
                        "name": "Cerro Quemado",
                        "latitude": "18.15417000",
                        "longitude": "-96.57500000"
                    },
                    {
                        "id": 68952,
                        "name": "Chahuite",
                        "latitude": "16.30000000",
                        "longitude": "-94.18333000"
                    },
                    {
                        "id": 68953,
                        "name": "Chahuites",
                        "latitude": "16.28842000",
                        "longitude": "-94.19478000"
                    },
                    {
                        "id": 69015,
                        "name": "Chicahua",
                        "latitude": "17.63667000",
                        "longitude": "-97.19497000"
                    },
                    {
                        "id": 69017,
                        "name": "Chicapa de Castro",
                        "latitude": "16.43844000",
                        "longitude": "-94.82206000"
                    },
                    {
                        "id": 69200,
                        "name": "Ciénega de Zimatlán",
                        "latitude": "16.89366000",
                        "longitude": "-96.76801000"
                    },
                    {
                        "id": 69128,
                        "name": "Cieneguilla",
                        "latitude": "16.32353000",
                        "longitude": "-97.31762000"
                    },
                    {
                        "id": 69189,
                        "name": "Ciudad de Huajuapan de León",
                        "latitude": "17.80787000",
                        "longitude": "-97.77956000"
                    },
                    {
                        "id": 69223,
                        "name": "Coatecas Altas",
                        "latitude": "16.53926000",
                        "longitude": "-96.66878000"
                    },
                    {
                        "id": 69253,
                        "name": "Coixtlahuaca",
                        "latitude": "17.72021000",
                        "longitude": "-97.31880000"
                    },
                    {
                        "id": 69262,
                        "name": "Collantes",
                        "latitude": "16.18810000",
                        "longitude": "-97.97184000"
                    },
                    {
                        "id": 69315,
                        "name": "Colonia Jordán",
                        "latitude": "16.38893000",
                        "longitude": "-95.20203000"
                    },
                    {
                        "id": 69317,
                        "name": "Colonia Juárez",
                        "latitude": "16.20967000",
                        "longitude": "-95.02722000"
                    },
                    {
                        "id": 69394,
                        "name": "Colonia la Central",
                        "latitude": "18.08666000",
                        "longitude": "-96.51619000"
                    },
                    {
                        "id": 69352,
                        "name": "Colonia Progreso",
                        "latitude": "16.80111000",
                        "longitude": "-95.07972000"
                    },
                    {
                        "id": 69358,
                        "name": "Colonia Rincón Viejo",
                        "latitude": "16.88678000",
                        "longitude": "-95.04731000"
                    },
                    {
                        "id": 69366,
                        "name": "Colonia San Luis",
                        "latitude": "16.38000000",
                        "longitude": "-95.24111000"
                    },
                    {
                        "id": 69439,
                        "name": "Concepción Pápalo",
                        "latitude": "17.85391000",
                        "longitude": "-96.84472000"
                    },
                    {
                        "id": 69461,
                        "name": "Constancia del Rosario",
                        "latitude": "17.03820000",
                        "longitude": "-97.94125000"
                    },
                    {
                        "id": 69466,
                        "name": "Constitución Mexicana",
                        "latitude": "17.34102000",
                        "longitude": "-95.37326000"
                    },
                    {
                        "id": 69487,
                        "name": "Corral de Piedra",
                        "latitude": "18.24528000",
                        "longitude": "-96.30556000"
                    },
                    {
                        "id": 69491,
                        "name": "Corralero",
                        "latitude": "16.23846000",
                        "longitude": "-98.18952000"
                    },
                    {
                        "id": 69505,
                        "name": "Cosoltepec",
                        "latitude": "18.14255000",
                        "longitude": "-97.79084000"
                    },
                    {
                        "id": 69538,
                        "name": "Crucecita",
                        "latitude": "15.76889000",
                        "longitude": "-96.13500000"
                    },
                    {
                        "id": 69563,
                        "name": "Cuapinolito (Azulillo)",
                        "latitude": "15.82194000",
                        "longitude": "-96.31833000"
                    },
                    {
                        "id": 69579,
                        "name": "Cuauhtémoc",
                        "latitude": "17.10149000",
                        "longitude": "-94.88532000"
                    },
                    {
                        "id": 69625,
                        "name": "Cuicatlan",
                        "latitude": "17.80272000",
                        "longitude": "-96.95939000"
                    },
                    {
                        "id": 69627,
                        "name": "Cuilapan de Guerrero",
                        "latitude": "16.97756000",
                        "longitude": "-96.78081000"
                    },
                    {
                        "id": 69714,
                        "name": "Donaji",
                        "latitude": "17.22950000",
                        "longitude": "-95.05295000"
                    },
                    {
                        "id": 69819,
                        "name": "Ejutla de Crespo",
                        "latitude": "16.56623000",
                        "longitude": "-96.73123000"
                    },
                    {
                        "id": 69830,
                        "name": "El Arador",
                        "latitude": "16.54111000",
                        "longitude": "-97.18194000"
                    },
                    {
                        "id": 69836,
                        "name": "El Bajío",
                        "latitude": "16.88917000",
                        "longitude": "-95.03528000"
                    },
                    {
                        "id": 69842,
                        "name": "El Barrio de la Soledad",
                        "latitude": "16.80131000",
                        "longitude": "-95.03909000"
                    },
                    {
                        "id": 69856,
                        "name": "El Camalote",
                        "latitude": "15.87250000",
                        "longitude": "-96.62361000"
                    },
                    {
                        "id": 69857,
                        "name": "El Camarón",
                        "latitude": "16.55745000",
                        "longitude": "-96.02868000"
                    },
                    {
                        "id": 69867,
                        "name": "El Capulín (La Nueva Pochota)",
                        "latitude": "18.22972000",
                        "longitude": "-96.27806000"
                    },
                    {
                        "id": 69881,
                        "name": "El Carrizal",
                        "latitude": "16.06438000",
                        "longitude": "-95.39308000"
                    },
                    {
                        "id": 69884,
                        "name": "El Carrizo",
                        "latitude": "16.25453000",
                        "longitude": "-98.03080000"
                    },
                    {
                        "id": 69902,
                        "name": "El Chocolate",
                        "latitude": "16.93191000",
                        "longitude": "-95.08946000"
                    },
                    {
                        "id": 69906,
                        "name": "El Ciruelo",
                        "latitude": "16.31780000",
                        "longitude": "-98.25707000"
                    },
                    {
                        "id": 69933,
                        "name": "El Coyul",
                        "latitude": "15.91472000",
                        "longitude": "-95.81028000"
                    },
                    {
                        "id": 69963,
                        "name": "El Espinal",
                        "latitude": "16.46751000",
                        "longitude": "-95.04198000"
                    },
                    {
                        "id": 70044,
                        "name": "El Molino",
                        "latitude": "17.77536000",
                        "longitude": "-97.75227000"
                    },
                    {
                        "id": 70051,
                        "name": "El Morro",
                        "latitude": "16.09745000",
                        "longitude": "-95.37906000"
                    },
                    {
                        "id": 70115,
                        "name": "El Porvenir",
                        "latitude": "17.47446000",
                        "longitude": "-95.25596000"
                    },
                    {
                        "id": 70171,
                        "name": "El Rosario",
                        "latitude": "17.04271000",
                        "longitude": "-96.69209000"
                    },
                    {
                        "id": 70274,
                        "name": "Eloxochitlán de Flores Magón",
                        "latitude": "18.17724000",
                        "longitude": "-96.87538000"
                    },
                    {
                        "id": 70301,
                        "name": "Encinal Colorado",
                        "latitude": "17.00995000",
                        "longitude": "-95.10732000"
                    },
                    {
                        "id": 70347,
                        "name": "Estación Mogoñé",
                        "latitude": "16.99472000",
                        "longitude": "-95.03667000"
                    },
                    {
                        "id": 70404,
                        "name": "Flor Batavia",
                        "latitude": "17.98475000",
                        "longitude": "-96.51880000"
                    },
                    {
                        "id": 70414,
                        "name": "Fraccionamiento Ciudad Yagul",
                        "latitude": "16.97750000",
                        "longitude": "-96.46194000"
                    },
                    {
                        "id": 70419,
                        "name": "Fraccionamiento Ex-Hacienda Catano",
                        "latitude": "17.22750000",
                        "longitude": "-96.81556000"
                    },
                    {
                        "id": 70437,
                        "name": "Fraccionamiento Real del Valle",
                        "latitude": "16.93278000",
                        "longitude": "-96.76778000"
                    },
                    {
                        "id": 70438,
                        "name": "Fraccionamiento Riberas de San Jerónimo",
                        "latitude": "17.11250000",
                        "longitude": "-96.77722000"
                    },
                    {
                        "id": 70440,
                        "name": "Fraccionamiento San Miguel",
                        "latitude": "17.21278000",
                        "longitude": "-96.78694000"
                    },
                    {
                        "id": 70470,
                        "name": "Francisco Ibarra Ramos",
                        "latitude": "17.97781000",
                        "longitude": "-97.91748000"
                    },
                    {
                        "id": 70543,
                        "name": "General Pascual Fentes",
                        "latitude": "16.43472000",
                        "longitude": "-94.26270000"
                    },
                    {
                        "id": 70582,
                        "name": "Guadalupe Etla",
                        "latitude": "17.17268000",
                        "longitude": "-96.81022000"
                    },
                    {
                        "id": 70584,
                        "name": "Guadalupe Hidalgo",
                        "latitude": "17.14950000",
                        "longitude": "-96.81109000"
                    },
                    {
                        "id": 70596,
                        "name": "Guadalupe Victoria",
                        "latitude": "16.89627000",
                        "longitude": "-95.84981000"
                    },
                    {
                        "id": 70614,
                        "name": "Guamúchil",
                        "latitude": "16.36937000",
                        "longitude": "-94.66863000"
                    },
                    {
                        "id": 70636,
                        "name": "Guixé",
                        "latitude": "16.46991000",
                        "longitude": "-96.70271000"
                    },
                    {
                        "id": 70651,
                        "name": "Hacienda Blanca",
                        "latitude": "17.13994000",
                        "longitude": "-96.77590000"
                    },
                    {
                        "id": 70676,
                        "name": "Heroica Ciudad de Ejutla de Crespo",
                        "latitude": "16.57835000",
                        "longitude": "-96.73079000"
                    },
                    {
                        "id": 70677,
                        "name": "Heroica Ciudad de Juchitán de Zaragoza",
                        "latitude": "16.44873000",
                        "longitude": "-94.98619000"
                    },
                    {
                        "id": 70678,
                        "name": "Heroica Ciudad de Tlaxiaco",
                        "latitude": "17.26916000",
                        "longitude": "-97.68053000"
                    },
                    {
                        "id": 70720,
                        "name": "Huajintepec",
                        "latitude": "16.61003000",
                        "longitude": "-98.23028000"
                    },
                    {
                        "id": 70745,
                        "name": "Huautepec",
                        "latitude": "18.10138000",
                        "longitude": "-96.79590000"
                    },
                    {
                        "id": 70753,
                        "name": "Huazantlán del Río",
                        "latitude": "16.21932000",
                        "longitude": "-95.12864000"
                    },
                    {
                        "id": 70853,
                        "name": "Ignacio Zaragoza",
                        "latitude": "17.53556000",
                        "longitude": "-95.89361000"
                    },
                    {
                        "id": 70886,
                        "name": "Isla Soyaltepec",
                        "latitude": "18.20107000",
                        "longitude": "-96.48325000"
                    },
                    {
                        "id": 70919,
                        "name": "Ixpantepec Nieves",
                        "latitude": "17.50690000",
                        "longitude": "-98.04264000"
                    },
                    {
                        "id": 70934,
                        "name": "Ixtepec",
                        "latitude": "16.56052000",
                        "longitude": "-95.10375000"
                    },
                    {
                        "id": 70944,
                        "name": "Ixtlán de Juárez",
                        "latitude": "17.33211000",
                        "longitude": "-96.48812000"
                    },
                    {
                        "id": 70964,
                        "name": "Jalapa",
                        "latitude": "16.50000000",
                        "longitude": "-95.46667000"
                    },
                    {
                        "id": 70987,
                        "name": "Jaltepec de Candayoc",
                        "latitude": "17.35495000",
                        "longitude": "-95.41428000"
                    },
                    {
                        "id": 70988,
                        "name": "Jaltepetongo",
                        "latitude": "17.68623000",
                        "longitude": "-97.03569000"
                    },
                    {
                        "id": 70998,
                        "name": "Jamiltepec",
                        "latitude": "16.28258000",
                        "longitude": "-97.82446000"
                    },
                    {
                        "id": 71095,
                        "name": "José María Morelos",
                        "latitude": "16.20389000",
                        "longitude": "-97.93000000"
                    },
                    {
                        "id": 71133,
                        "name": "Juchitán de Zaragoza",
                        "latitude": "16.43603000",
                        "longitude": "-95.01975000"
                    },
                    {
                        "id": 71181,
                        "name": "La Barra de Colotepec",
                        "latitude": "15.82546000",
                        "longitude": "-97.02882000"
                    },
                    {
                        "id": 71183,
                        "name": "La Blanca",
                        "latitude": "16.59482000",
                        "longitude": "-94.69256000"
                    },
                    {
                        "id": 71208,
                        "name": "La Cañada",
                        "latitude": "17.07000000",
                        "longitude": "-96.77806000"
                    },
                    {
                        "id": 71196,
                        "name": "La Candelaria",
                        "latitude": "17.21833000",
                        "longitude": "-95.93306000"
                    },
                    {
                        "id": 71264,
                        "name": "La Erradura",
                        "latitude": "15.83402000",
                        "longitude": "-96.33478000"
                    },
                    {
                        "id": 71321,
                        "name": "La Humedad",
                        "latitude": "16.58222000",
                        "longitude": "-97.66724000"
                    },
                    {
                        "id": 71337,
                        "name": "La Junta",
                        "latitude": "17.82778000",
                        "longitude": "-97.74556000"
                    },
                    {
                        "id": 71371,
                        "name": "La Luz",
                        "latitude": "16.11477000",
                        "longitude": "-97.59570000"
                    },
                    {
                        "id": 71395,
                        "name": "La Mina",
                        "latitude": "17.98689000",
                        "longitude": "-96.09978000"
                    },
                    {
                        "id": 71407,
                        "name": "La Noria",
                        "latitude": "16.25444000",
                        "longitude": "-95.22056000"
                    },
                    {
                        "id": 71437,
                        "name": "La Pe",
                        "latitude": "16.63027000",
                        "longitude": "-96.79766000"
                    },
                    {
                        "id": 71471,
                        "name": "La Reforma",
                        "latitude": "16.62414000",
                        "longitude": "-97.84544000"
                    },
                    {
                        "id": 71500,
                        "name": "La Tabaquera",
                        "latitude": "18.33582000",
                        "longitude": "-96.45129000"
                    },
                    {
                        "id": 71527,
                        "name": "La Venta",
                        "latitude": "16.57109000",
                        "longitude": "-94.81773000"
                    },
                    {
                        "id": 71529,
                        "name": "La Ventosa",
                        "latitude": "16.55188000",
                        "longitude": "-94.94762000"
                    },
                    {
                        "id": 71574,
                        "name": "Las Amilpas",
                        "latitude": "16.36667000",
                        "longitude": "-94.61667000"
                    },
                    {
                        "id": 71618,
                        "name": "Las Margaritas",
                        "latitude": "18.25501000",
                        "longitude": "-96.28421000"
                    },
                    {
                        "id": 71887,
                        "name": "Lázaro Cárdenas",
                        "latitude": "16.72818000",
                        "longitude": "-94.85981000"
                    },
                    {
                        "id": 71690,
                        "name": "Llano de Agua",
                        "latitude": "18.10611000",
                        "longitude": "-96.81083000"
                    },
                    {
                        "id": 71689,
                        "name": "Llano Suchiapa",
                        "latitude": "16.86611000",
                        "longitude": "-95.05389000"
                    },
                    {
                        "id": 71714,
                        "name": "Loma Bonita",
                        "latitude": "18.10721000",
                        "longitude": "-95.87904000"
                    },
                    {
                        "id": 71718,
                        "name": "Loma Chapultepec",
                        "latitude": "18.11972000",
                        "longitude": "-96.83917000"
                    },
                    {
                        "id": 71870,
                        "name": "Los Ángeles",
                        "latitude": "17.39485000",
                        "longitude": "-95.16540000"
                    },
                    {
                        "id": 71821,
                        "name": "Los Naranjos Esquipulas",
                        "latitude": "15.98167000",
                        "longitude": "-96.45889000"
                    },
                    {
                        "id": 71916,
                        "name": "Macín Chico",
                        "latitude": "18.06820000",
                        "longitude": "-96.27184000"
                    },
                    {
                        "id": 71911,
                        "name": "Macuilxóchitl de Artigas Carranza",
                        "latitude": "17.01583000",
                        "longitude": "-96.54000000"
                    },
                    {
                        "id": 71921,
                        "name": "Magdalena Apasco",
                        "latitude": "17.24083000",
                        "longitude": "-96.82083000"
                    },
                    {
                        "id": 71925,
                        "name": "Magdalena Jaltepec",
                        "latitude": "17.32318000",
                        "longitude": "-97.22122000"
                    },
                    {
                        "id": 71926,
                        "name": "Magdalena Mixtepec",
                        "latitude": "16.89659000",
                        "longitude": "-96.90618000"
                    },
                    {
                        "id": 71927,
                        "name": "Magdalena Ocotlán",
                        "latitude": "16.70865000",
                        "longitude": "-96.71010000"
                    },
                    {
                        "id": 71928,
                        "name": "Magdalena Teitipac",
                        "latitude": "16.90393000",
                        "longitude": "-96.55840000"
                    },
                    {
                        "id": 71929,
                        "name": "Magdalena Tequisistlán",
                        "latitude": "16.39929000",
                        "longitude": "-95.60204000"
                    },
                    {
                        "id": 71930,
                        "name": "Magdalena Tlacotepec",
                        "latitude": "16.50416000",
                        "longitude": "-95.20248000"
                    },
                    {
                        "id": 71931,
                        "name": "Magdalena Yodocono de Porfirio Díaz",
                        "latitude": "17.38470000",
                        "longitude": "-97.35530000"
                    },
                    {
                        "id": 71932,
                        "name": "Magdalena Zahuatlán",
                        "latitude": "17.38978000",
                        "longitude": "-97.22747000"
                    },
                    {
                        "id": 71954,
                        "name": "Mancuernas",
                        "latitude": "16.38940000",
                        "longitude": "-98.11018000"
                    },
                    {
                        "id": 72005,
                        "name": "María Lombardo de Caso",
                        "latitude": "17.44931000",
                        "longitude": "-95.42821000"
                    },
                    {
                        "id": 71996,
                        "name": "Mariscala de Juárez",
                        "latitude": "17.85972000",
                        "longitude": "-98.14083000"
                    },
                    {
                        "id": 72024,
                        "name": "Matías Romero",
                        "latitude": "16.87902000",
                        "longitude": "-95.03939000"
                    },
                    {
                        "id": 72048,
                        "name": "Mazatlán Villa de Flores",
                        "latitude": "18.03264000",
                        "longitude": "-96.91404000"
                    },
                    {
                        "id": 72052,
                        "name": "Mazín Grande",
                        "latitude": "18.11630000",
                        "longitude": "-96.30956000"
                    },
                    {
                        "id": 72077,
                        "name": "Merced del Potrero",
                        "latitude": "16.04679000",
                        "longitude": "-96.07048000"
                    },
                    {
                        "id": 72085,
                        "name": "Mesones Hidalgo",
                        "latitude": "16.92208000",
                        "longitude": "-97.99765000"
                    },
                    {
                        "id": 72117,
                        "name": "Miahuatlán de Porfirio Díaz",
                        "latitude": "16.33276000",
                        "longitude": "-96.59562000"
                    },
                    {
                        "id": 72165,
                        "name": "Mixistlán de la Reforma",
                        "latitude": "17.14669000",
                        "longitude": "-96.10669000"
                    },
                    {
                        "id": 72217,
                        "name": "Montenegro la Lana",
                        "latitude": "17.59296000",
                        "longitude": "-95.86510000"
                    },
                    {
                        "id": 72275,
                        "name": "Nanahuatípam",
                        "latitude": "18.13414000",
                        "longitude": "-97.12501000"
                    },
                    {
                        "id": 72288,
                        "name": "Nativitas",
                        "latitude": "17.66160000",
                        "longitude": "-97.33566000"
                    },
                    {
                        "id": 72300,
                        "name": "Nazareno Etla",
                        "latitude": "17.17667000",
                        "longitude": "-96.83264000"
                    },
                    {
                        "id": 72309,
                        "name": "Nejapa de Madero",
                        "latitude": "16.60571000",
                        "longitude": "-95.97855000"
                    },
                    {
                        "id": 72332,
                        "name": "Niltepec",
                        "latitude": "16.56401000",
                        "longitude": "-94.61373000"
                    },
                    {
                        "id": 72388,
                        "name": "Nuevo Ixcatlán",
                        "latitude": "17.64145000",
                        "longitude": "-95.43807000"
                    },
                    {
                        "id": 72403,
                        "name": "Nuevo Paso Nazareno (Chichicazapa)",
                        "latitude": "18.29667000",
                        "longitude": "-96.34722000"
                    },
                    {
                        "id": 72411,
                        "name": "Nuevo San Martín",
                        "latitude": "17.57987000",
                        "longitude": "-95.52346000"
                    },
                    {
                        "id": 72432,
                        "name": "Oaxaca",
                        "latitude": "17.06542000",
                        "longitude": "-96.72365000"
                    },
                    {
                        "id": 72433,
                        "name": "Oaxaca de Juárez",
                        "latitude": "17.11345000",
                        "longitude": "-96.73556000"
                    },
                    {
                        "id": 72460,
                        "name": "Ocotlán de Morelos",
                        "latitude": "16.79151000",
                        "longitude": "-96.67455000"
                    },
                    {
                        "id": 72612,
                        "name": "Palomares",
                        "latitude": "17.13830000",
                        "longitude": "-95.06266000"
                    },
                    {
                        "id": 72631,
                        "name": "Papaloapan",
                        "latitude": "18.16087000",
                        "longitude": "-96.09383000"
                    },
                    {
                        "id": 72678,
                        "name": "Paso Canoa",
                        "latitude": "18.01274000",
                        "longitude": "-96.23786000"
                    },
                    {
                        "id": 72685,
                        "name": "Paso Real de Sarabia",
                        "latitude": "17.07389000",
                        "longitude": "-95.04667000"
                    },
                    {
                        "id": 72749,
                        "name": "Peña Colorada",
                        "latitude": "17.47778000",
                        "longitude": "-97.79417000"
                    },
                    {
                        "id": 72764,
                        "name": "Piedra Blanca",
                        "latitude": "16.98861000",
                        "longitude": "-95.01278000"
                    },
                    {
                        "id": 72769,
                        "name": "Piedra de Amolar",
                        "latitude": "18.12000000",
                        "longitude": "-96.45122000"
                    },
                    {
                        "id": 72782,
                        "name": "Pinotepa de Don Luis",
                        "latitude": "16.42716000",
                        "longitude": "-97.97678000"
                    },
                    {
                        "id": 72781,
                        "name": "Pinotepa Nacional",
                        "latitude": "16.34014000",
                        "longitude": "-98.05297000"
                    },
                    {
                        "id": 72810,
                        "name": "Playa Chica",
                        "latitude": "18.06139000",
                        "longitude": "-96.51833000"
                    },
                    {
                        "id": 72818,
                        "name": "Pluma Hidalgo",
                        "latitude": "15.92127000",
                        "longitude": "-96.42977000"
                    },
                    {
                        "id": 72885,
                        "name": "Praxedis de Guerrero",
                        "latitude": "16.72000000",
                        "longitude": "-96.64000000"
                    },
                    {
                        "id": 72915,
                        "name": "Progreso",
                        "latitude": "17.04528000",
                        "longitude": "-97.57028000"
                    },
                    {
                        "id": 72948,
                        "name": "Pueblo Viejo",
                        "latitude": "17.90750000",
                        "longitude": "-96.05778000"
                    },
                    {
                        "id": 72981,
                        "name": "Puerto Ángel",
                        "latitude": "15.66898000",
                        "longitude": "-96.49095000"
                    },
                    {
                        "id": 72968,
                        "name": "Puerto Escondido",
                        "latitude": "15.87037000",
                        "longitude": "-97.07726000"
                    },
                    {
                        "id": 73002,
                        "name": "Putla Villa de Guerrero",
                        "latitude": "17.02630000",
                        "longitude": "-97.92854000"
                    },
                    {
                        "id": 73020,
                        "name": "Quelové",
                        "latitude": "15.98273000",
                        "longitude": "-96.67890000"
                    },
                    {
                        "id": 73034,
                        "name": "Quinicuena",
                        "latitude": "16.53101000",
                        "longitude": "-97.52385000"
                    },
                    {
                        "id": 73060,
                        "name": "Rancho Grande",
                        "latitude": "18.35389000",
                        "longitude": "-96.34944000"
                    },
                    {
                        "id": 73072,
                        "name": "Rancho Viejo",
                        "latitude": "16.33966000",
                        "longitude": "-97.96399000"
                    },
                    {
                        "id": 73095,
                        "name": "Reforma de Pineda",
                        "latitude": "16.40103000",
                        "longitude": "-94.45786000"
                    },
                    {
                        "id": 73102,
                        "name": "Reyes Etla",
                        "latitude": "17.20220000",
                        "longitude": "-96.81802000"
                    },
                    {
                        "id": 73103,
                        "name": "Reyes Mantecón",
                        "latitude": "16.90717000",
                        "longitude": "-96.72702000"
                    },
                    {
                        "id": 73119,
                        "name": "Rincón Moreno",
                        "latitude": "16.23007000",
                        "longitude": "-95.31327000"
                    },
                    {
                        "id": 73172,
                        "name": "Río Chiquito",
                        "latitude": "17.61989000",
                        "longitude": "-95.93688000"
                    },
                    {
                        "id": 73175,
                        "name": "Río Grande",
                        "latitude": "16.01079000",
                        "longitude": "-97.43574000"
                    },
                    {
                        "id": 73182,
                        "name": "Río Pachiñe",
                        "latitude": "16.96870000",
                        "longitude": "-95.06533000"
                    },
                    {
                        "id": 73152,
                        "name": "Rojas de Cuauhtémoc",
                        "latitude": "17.00861000",
                        "longitude": "-96.61944000"
                    },
                    {
                        "id": 73213,
                        "name": "Salina Cruz",
                        "latitude": "16.17535000",
                        "longitude": "-95.19424000"
                    },
                    {
                        "id": 73240,
                        "name": "San Agustín Amatengo",
                        "latitude": "16.51086000",
                        "longitude": "-96.78919000"
                    },
                    {
                        "id": 73241,
                        "name": "San Agustín Atenango",
                        "latitude": "17.61150000",
                        "longitude": "-98.01095000"
                    },
                    {
                        "id": 73245,
                        "name": "San Agustín Chayuco",
                        "latitude": "16.40234000",
                        "longitude": "-97.80823000"
                    },
                    {
                        "id": 73237,
                        "name": "San Agustin de las Juntas",
                        "latitude": "17.00389000",
                        "longitude": "-96.70806000"
                    },
                    {
                        "id": 73247,
                        "name": "San Agustín Etla",
                        "latitude": "17.18654000",
                        "longitude": "-96.76661000"
                    },
                    {
                        "id": 73250,
                        "name": "San Agustín Loxicha",
                        "latitude": "16.01687000",
                        "longitude": "-96.61615000"
                    },
                    {
                        "id": 73256,
                        "name": "San Agustín Yatareni",
                        "latitude": "17.08635000",
                        "longitude": "-96.67845000"
                    },
                    {
                        "id": 73273,
                        "name": "San Andrés Chicahuaxtla",
                        "latitude": "17.15698000",
                        "longitude": "-97.83703000"
                    },
                    {
                        "id": 73277,
                        "name": "San Andrés Dinicuiti",
                        "latitude": "17.68812000",
                        "longitude": "-97.72669000"
                    },
                    {
                        "id": 73280,
                        "name": "San Andrés Hidalgo",
                        "latitude": "18.13734000",
                        "longitude": "-96.80604000"
                    },
                    {
                        "id": 73281,
                        "name": "San Andrés Huaxpaltepec",
                        "latitude": "16.32952000",
                        "longitude": "-97.91647000"
                    },
                    {
                        "id": 73282,
                        "name": "San Andrés Huayápam",
                        "latitude": "17.10264000",
                        "longitude": "-96.66556000"
                    },
                    {
                        "id": 73284,
                        "name": "San Andrés Ixtlahuaca",
                        "latitude": "17.07112000",
                        "longitude": "-96.82635000"
                    },
                    {
                        "id": 73290,
                        "name": "San Andrés Paxtlán",
                        "latitude": "16.21621000",
                        "longitude": "-96.50783000"
                    },
                    {
                        "id": 73293,
                        "name": "San Andrés Sinaxtla",
                        "latitude": "17.46928000",
                        "longitude": "-97.28298000"
                    },
                    {
                        "id": 73294,
                        "name": "San Andrés Solaga",
                        "latitude": "17.27254000",
                        "longitude": "-96.23610000"
                    },
                    {
                        "id": 73296,
                        "name": "San Andrés Teotilalpam",
                        "latitude": "17.95414000",
                        "longitude": "-96.65607000"
                    },
                    {
                        "id": 73302,
                        "name": "San Andrés Yaá",
                        "latitude": "17.29290000",
                        "longitude": "-96.15384000"
                    },
                    {
                        "id": 73303,
                        "name": "San Andrés Zabache",
                        "latitude": "16.59917000",
                        "longitude": "-96.85889000"
                    },
                    {
                        "id": 73304,
                        "name": "San Andrés Zautla",
                        "latitude": "17.18697000",
                        "longitude": "-96.86419000"
                    },
                    {
                        "id": 73311,
                        "name": "San Antonino Castillo Velasco",
                        "latitude": "16.80900000",
                        "longitude": "-96.69267000"
                    },
                    {
                        "id": 73313,
                        "name": "San Antonino el Alto",
                        "latitude": "16.81984000",
                        "longitude": "-97.02719000"
                    },
                    {
                        "id": 73312,
                        "name": "San Antonino Monte Verde",
                        "latitude": "17.51869000",
                        "longitude": "-97.72654000"
                    },
                    {
                        "id": 73321,
                        "name": "San Antonio Arrazola",
                        "latitude": "17.03972000",
                        "longitude": "-96.79034000"
                    },
                    {
                        "id": 73368,
                        "name": "San Antonio de la Cal",
                        "latitude": "17.02921000",
                        "longitude": "-96.70094000"
                    },
                    {
                        "id": 73336,
                        "name": "San Antonio Huitepec",
                        "latitude": "16.92888000",
                        "longitude": "-97.14670000"
                    },
                    {
                        "id": 73391,
                        "name": "San Antonio las Palmas",
                        "latitude": "17.67167000",
                        "longitude": "-96.09083000"
                    },
                    {
                        "id": 73343,
                        "name": "San Antonio Ocotlán",
                        "latitude": "16.64929000",
                        "longitude": "-98.16585000"
                    },
                    {
                        "id": 73354,
                        "name": "San Antonio Tepetlapa",
                        "latitude": "16.54391000",
                        "longitude": "-98.06551000"
                    },
                    {
                        "id": 73394,
                        "name": "San Baltazar Chichicapam",
                        "latitude": "16.76151000",
                        "longitude": "-96.48970000"
                    },
                    {
                        "id": 73395,
                        "name": "San Baltazar Guelavila",
                        "latitude": "16.79638000",
                        "longitude": "-96.30542000"
                    },
                    {
                        "id": 73396,
                        "name": "San Baltazar Loxicha",
                        "latitude": "16.07670000",
                        "longitude": "-96.78740000"
                    },
                    {
                        "id": 73397,
                        "name": "San Baltazar Yatzachi el Bajo",
                        "latitude": "17.22958000",
                        "longitude": "-96.22046000"
                    },
                    {
                        "id": 73400,
                        "name": "San Bartolo",
                        "latitude": "18.09222000",
                        "longitude": "-96.10750000"
                    },
                    {
                        "id": 73401,
                        "name": "San Bartolo Coyotepec",
                        "latitude": "16.94877000",
                        "longitude": "-96.70977000"
                    },
                    {
                        "id": 73402,
                        "name": "San Bartolo Coyotespec",
                        "latitude": "16.95837000",
                        "longitude": "-96.70930000"
                    },
                    {
                        "id": 73410,
                        "name": "San Bartolo Yautepec",
                        "latitude": "16.42935000",
                        "longitude": "-95.97438000"
                    },
                    {
                        "id": 73421,
                        "name": "San Bartolomé Ayautla",
                        "latitude": "18.03239000",
                        "longitude": "-96.67078000"
                    },
                    {
                        "id": 73425,
                        "name": "San Bartolomé Loxícha",
                        "latitude": "15.96981000",
                        "longitude": "-96.70957000"
                    },
                    {
                        "id": 73426,
                        "name": "San Bartolomé Quialana",
                        "latitude": "16.90302000",
                        "longitude": "-96.50169000"
                    },
                    {
                        "id": 73430,
                        "name": "San Benito Encinal",
                        "latitude": "17.98722000",
                        "longitude": "-95.91056000"
                    },
                    {
                        "id": 73441,
                        "name": "San Bernardo Mixtepec",
                        "latitude": "16.82579000",
                        "longitude": "-96.89911000"
                    },
                    {
                        "id": 73447,
                        "name": "San Blas Atempa",
                        "latitude": "16.33103000",
                        "longitude": "-95.22559000"
                    },
                    {
                        "id": 73463,
                        "name": "San Carlos Yautepec",
                        "latitude": "16.49699000",
                        "longitude": "-96.10648000"
                    },
                    {
                        "id": 73475,
                        "name": "San Cristóbal Amatlán",
                        "latitude": "16.31713000",
                        "longitude": "-96.40785000"
                    },
                    {
                        "id": 73476,
                        "name": "San Cristóbal Amoltepec",
                        "latitude": "17.28428000",
                        "longitude": "-97.57216000"
                    },
                    {
                        "id": 73479,
                        "name": "San Cristóbal Honduras",
                        "latitude": "16.32528000",
                        "longitude": "-97.04111000"
                    },
                    {
                        "id": 73480,
                        "name": "San Cristóbal Lachirioag",
                        "latitude": "17.33582000",
                        "longitude": "-96.16503000"
                    },
                    {
                        "id": 73504,
                        "name": "San Dionisio del Mar",
                        "latitude": "16.32371000",
                        "longitude": "-94.75830000"
                    },
                    {
                        "id": 73502,
                        "name": "San Dionisio Ocotepec",
                        "latitude": "16.80457000",
                        "longitude": "-96.39334000"
                    },
                    {
                        "id": 73503,
                        "name": "San Dionisio Ocotlán",
                        "latitude": "16.74704000",
                        "longitude": "-96.68002000"
                    },
                    {
                        "id": 73507,
                        "name": "San Esteban Atatlahuca",
                        "latitude": "17.06716000",
                        "longitude": "-97.67836000"
                    },
                    {
                        "id": 73514,
                        "name": "San Felipe Cihualtepec",
                        "latitude": "17.47763000",
                        "longitude": "-95.36767000"
                    },
                    {
                        "id": 73517,
                        "name": "San Felipe Jalapa de Díaz",
                        "latitude": "18.07120000",
                        "longitude": "-96.53562000"
                    },
                    {
                        "id": 73524,
                        "name": "San Felipe Tejalápam",
                        "latitude": "17.11134000",
                        "longitude": "-96.85420000"
                    },
                    {
                        "id": 73528,
                        "name": "San Felipe Tílpam",
                        "latitude": "18.18889000",
                        "longitude": "-96.58639000"
                    },
                    {
                        "id": 73529,
                        "name": "San Felipe Usila",
                        "latitude": "17.88790000",
                        "longitude": "-96.52474000"
                    },
                    {
                        "id": 73552,
                        "name": "San Francisco Cajonos",
                        "latitude": "17.18086000",
                        "longitude": "-96.26465000"
                    },
                    {
                        "id": 73556,
                        "name": "San Francisco Chindúa",
                        "latitude": "17.42809000",
                        "longitude": "-97.31266000"
                    },
                    {
                        "id": 73557,
                        "name": "San Francisco Coatlán",
                        "latitude": "16.18175000",
                        "longitude": "-96.76099000"
                    },
                    {
                        "id": 73558,
                        "name": "San Francisco Cozoaltepec",
                        "latitude": "15.81476000",
                        "longitude": "-96.72396000"
                    },
                    {
                        "id": 73617,
                        "name": "San Francisco del Mar",
                        "latitude": "16.33987000",
                        "longitude": "-94.51529000"
                    },
                    {
                        "id": 73618,
                        "name": "San Francisco del Mar Viejo",
                        "latitude": "16.23185000",
                        "longitude": "-94.63297000"
                    },
                    {
                        "id": 73565,
                        "name": "San Francisco Huehuetlán",
                        "latitude": "18.19725000",
                        "longitude": "-96.94805000"
                    },
                    {
                        "id": 73567,
                        "name": "San Francisco Ixhuatan",
                        "latitude": "16.35109000",
                        "longitude": "-94.48402000"
                    },
                    {
                        "id": 73570,
                        "name": "San Francisco Jaltepetongo",
                        "latitude": "17.38579000",
                        "longitude": "-97.26481000"
                    },
                    {
                        "id": 73572,
                        "name": "San Francisco Javier",
                        "latitude": "17.02861000",
                        "longitude": "-96.77750000"
                    },
                    {
                        "id": 73574,
                        "name": "San Francisco Lachigoló",
                        "latitude": "17.01624000",
                        "longitude": "-96.59947000"
                    },
                    {
                        "id": 73575,
                        "name": "San Francisco Logueche",
                        "latitude": "16.37576000",
                        "longitude": "-96.37907000"
                    },
                    {
                        "id": 73576,
                        "name": "San Francisco Loxicha",
                        "latitude": "15.90658000",
                        "longitude": "-96.61295000"
                    },
                    {
                        "id": 73581,
                        "name": "San Francisco Nuxaño",
                        "latitude": "17.38173000",
                        "longitude": "-97.34262000"
                    },
                    {
                        "id": 73585,
                        "name": "San Francisco Ozolotepec",
                        "latitude": "16.10079000",
                        "longitude": "-96.22181000"
                    },
                    {
                        "id": 73590,
                        "name": "San Francisco Sola",
                        "latitude": "16.51584000",
                        "longitude": "-96.97488000"
                    },
                    {
                        "id": 73593,
                        "name": "San Francisco Telixtlahuaca",
                        "latitude": "17.29684000",
                        "longitude": "-96.90529000"
                    },
                    {
                        "id": 73604,
                        "name": "San Francisco Tutla",
                        "latitude": "17.07092000",
                        "longitude": "-96.66810000"
                    },
                    {
                        "id": 73629,
                        "name": "San Gabriel Mixtepec",
                        "latitude": "16.09593000",
                        "longitude": "-97.08237000"
                    },
                    {
                        "id": 73660,
                        "name": "San Ildefonso Amatlán",
                        "latitude": "16.33390000",
                        "longitude": "-96.49122000"
                    },
                    {
                        "id": 73662,
                        "name": "San Ildefonso Villa Alta",
                        "latitude": "17.33827000",
                        "longitude": "-96.15232000"
                    },
                    {
                        "id": 73674,
                        "name": "San Isidro Apango",
                        "latitude": "15.80952000",
                        "longitude": "-96.35856000"
                    },
                    {
                        "id": 73681,
                        "name": "San Isidro Monjas",
                        "latitude": "17.00167000",
                        "longitude": "-96.74861000"
                    },
                    {
                        "id": 73695,
                        "name": "San Jacinto Amilpas",
                        "latitude": "17.10188000",
                        "longitude": "-96.76228000"
                    },
                    {
                        "id": 73708,
                        "name": "San Jerónimo Coatlán",
                        "latitude": "16.23211000",
                        "longitude": "-96.87047000"
                    },
                    {
                        "id": 73714,
                        "name": "San Jerónimo Silacayoapilla",
                        "latitude": "17.81021000",
                        "longitude": "-97.84488000"
                    },
                    {
                        "id": 73715,
                        "name": "San Jerónimo Sosola",
                        "latitude": "17.36685000",
                        "longitude": "-97.03291000"
                    },
                    {
                        "id": 73716,
                        "name": "San Jerónimo Taviche",
                        "latitude": "16.71468000",
                        "longitude": "-96.59360000"
                    },
                    {
                        "id": 73717,
                        "name": "San Jerónimo Tecóatl",
                        "latitude": "18.16633000",
                        "longitude": "-96.91256000"
                    },
                    {
                        "id": 73718,
                        "name": "San Jerónimo Tlacochahuaya",
                        "latitude": "17.00843000",
                        "longitude": "-96.55522000"
                    },
                    {
                        "id": 73722,
                        "name": "San Jerónimo Yahuiche",
                        "latitude": "17.10861000",
                        "longitude": "-96.76972000"
                    },
                    {
                        "id": 73731,
                        "name": "San Jorge Nuchita",
                        "latitude": "17.65921000",
                        "longitude": "-98.10153000"
                    },
                    {
                        "id": 73744,
                        "name": "San José Ayuquila",
                        "latitude": "17.94221000",
                        "longitude": "-97.96861000"
                    },
                    {
                        "id": 73754,
                        "name": "San José Chacalapa",
                        "latitude": "15.82957000",
                        "longitude": "-96.46390000"
                    },
                    {
                        "id": 73758,
                        "name": "San José Chiltepec",
                        "latitude": "17.94734000",
                        "longitude": "-96.16957000"
                    },
                    {
                        "id": 73832,
                        "name": "San José de las Flores",
                        "latitude": "17.35076000",
                        "longitude": "-95.39837000"
                    },
                    {
                        "id": 73839,
                        "name": "San José del Progreso",
                        "latitude": "16.69909000",
                        "longitude": "-96.68148000"
                    },
                    {
                        "id": 73764,
                        "name": "San José Estancia Grande",
                        "latitude": "16.36545000",
                        "longitude": "-98.25092000"
                    },
                    {
                        "id": 73853,
                        "name": "San José la Garzona",
                        "latitude": "16.68029000",
                        "longitude": "-96.63853000"
                    },
                    {
                        "id": 73772,
                        "name": "San José Lachiguirí",
                        "latitude": "16.37784000",
                        "longitude": "-96.33589000"
                    },
                    {
                        "id": 73780,
                        "name": "San José Piedras Negras",
                        "latitude": "15.83658000",
                        "longitude": "-96.59151000"
                    },
                    {
                        "id": 73782,
                        "name": "San José Río Manzo",
                        "latitude": "17.67003000",
                        "longitude": "-95.88012000"
                    },
                    {
                        "id": 73787,
                        "name": "San José Tenango",
                        "latitude": "18.15084000",
                        "longitude": "-96.71744000"
                    },
                    {
                        "id": 73861,
                        "name": "San Juan Achiutla",
                        "latitude": "17.35019000",
                        "longitude": "-97.50804000"
                    },
                    {
                        "id": 73866,
                        "name": "San Juan Atepec",
                        "latitude": "17.42819000",
                        "longitude": "-96.53968000"
                    },
                    {
                        "id": 73872,
                        "name": "San Juan Bautista Jayacatlán",
                        "latitude": "17.42458000",
                        "longitude": "-96.82639000"
                    },
                    {
                        "id": 73874,
                        "name": "San Juan Bautista la Raya",
                        "latitude": "16.98617000",
                        "longitude": "-96.72472000"
                    },
                    {
                        "id": 73873,
                        "name": "San Juan Bautista Lo de Soto",
                        "latitude": "16.51197000",
                        "longitude": "-98.34772000"
                    },
                    {
                        "id": 73876,
                        "name": "San Juan Cabeza del Río",
                        "latitude": "16.75285000",
                        "longitude": "-97.88240000"
                    },
                    {
                        "id": 73877,
                        "name": "San Juan Cacahuatepec",
                        "latitude": "16.61532000",
                        "longitude": "-98.15501000"
                    },
                    {
                        "id": 73878,
                        "name": "San Juan Chilateca",
                        "latitude": "16.83042000",
                        "longitude": "-96.66915000"
                    },
                    {
                        "id": 73880,
                        "name": "San Juan Coatzospam",
                        "latitude": "18.04998000",
                        "longitude": "-96.76304000"
                    },
                    {
                        "id": 73881,
                        "name": "San Juan Colorado",
                        "latitude": "16.46066000",
                        "longitude": "-97.95431000"
                    },
                    {
                        "id": 73884,
                        "name": "San Juan Cotzocón",
                        "latitude": "17.16373000",
                        "longitude": "-95.78259000"
                    },
                    {
                        "id": 73969,
                        "name": "San Juan de los Cues",
                        "latitude": "18.04654000",
                        "longitude": "-97.06020000"
                    },
                    {
                        "id": 73973,
                        "name": "San Juan del Estado",
                        "latitude": "17.27430000",
                        "longitude": "-96.79912000"
                    },
                    {
                        "id": 73977,
                        "name": "San Juan del Río",
                        "latitude": "17.49278000",
                        "longitude": "-95.76028000"
                    },
                    {
                        "id": 73890,
                        "name": "San Juan Diuxi",
                        "latitude": "17.28597000",
                        "longitude": "-97.37005000"
                    },
                    {
                        "id": 73894,
                        "name": "San Juan Guelavía",
                        "latitude": "16.95507000",
                        "longitude": "-96.54359000"
                    },
                    {
                        "id": 73895,
                        "name": "San Juan Guichicovi",
                        "latitude": "16.96231000",
                        "longitude": "-95.09418000"
                    },
                    {
                        "id": 73898,
                        "name": "San Juan Ihualtepec",
                        "latitude": "17.75656000",
                        "longitude": "-98.28518000"
                    },
                    {
                        "id": 73902,
                        "name": "San Juan Jaltepec",
                        "latitude": "17.35264000",
                        "longitude": "-95.66263000"
                    },
                    {
                        "id": 73904,
                        "name": "San Juan Jicayán",
                        "latitude": "16.47583000",
                        "longitude": "-98.01250000"
                    },
                    {
                        "id": 73905,
                        "name": "San Juan Juquila",
                        "latitude": "16.93585000",
                        "longitude": "-95.91889000"
                    },
                    {
                        "id": 73906,
                        "name": "San Juan Juquila Vijanos",
                        "latitude": "17.33734000",
                        "longitude": "-96.27421000"
                    },
                    {
                        "id": 73907,
                        "name": "San Juan Lachao",
                        "latitude": "16.15891000",
                        "longitude": "-97.12449000"
                    },
                    {
                        "id": 73986,
                        "name": "San Juán Lachigalla",
                        "latitude": "16.58947000",
                        "longitude": "-96.55052000"
                    },
                    {
                        "id": 73908,
                        "name": "San Juan Lagunas",
                        "latitude": "16.99748000",
                        "longitude": "-97.93066000"
                    },
                    {
                        "id": 73909,
                        "name": "San Juan Mazatlán",
                        "latitude": "17.02988000",
                        "longitude": "-95.44606000"
                    },
                    {
                        "id": 73910,
                        "name": "San Juan Metaltepec",
                        "latitude": "17.17563000",
                        "longitude": "-95.91174000"
                    },
                    {
                        "id": 73911,
                        "name": "San Juan Mixtepec -Dto. 08 -",
                        "latitude": "17.31676000",
                        "longitude": "-97.86147000"
                    },
                    {
                        "id": 73912,
                        "name": "San Juan Mixtepec -Dto. 26 -",
                        "latitude": "16.27667000",
                        "longitude": "-96.29917000"
                    },
                    {
                        "id": 73980,
                        "name": "San Juan Ñumí",
                        "latitude": "17.39734000",
                        "longitude": "-97.70624000"
                    },
                    {
                        "id": 73913,
                        "name": "San Juan Ozolotepec",
                        "latitude": "16.13320000",
                        "longitude": "-96.25925000"
                    },
                    {
                        "id": 73916,
                        "name": "San Juan Petlapa",
                        "latitude": "17.46916000",
                        "longitude": "-96.03610000"
                    },
                    {
                        "id": 73919,
                        "name": "San Juan Quiahue",
                        "latitude": "16.30220000",
                        "longitude": "-97.31729000"
                    },
                    {
                        "id": 73920,
                        "name": "San Juan Quiotepec",
                        "latitude": "17.60156000",
                        "longitude": "-96.58731000"
                    },
                    {
                        "id": 73922,
                        "name": "San Juan Sautla",
                        "latitude": "17.85800000",
                        "longitude": "-96.67445000"
                    },
                    {
                        "id": 73923,
                        "name": "San Juan Sayultepec",
                        "latitude": "17.44736000",
                        "longitude": "-97.29375000"
                    },
                    {
                        "id": 73926,
                        "name": "San Juan Tabaá",
                        "latitude": "17.30495000",
                        "longitude": "-96.20718000"
                    },
                    {
                        "id": 73929,
                        "name": "San Juan Teitipac",
                        "latitude": "16.92630000",
                        "longitude": "-96.60954000"
                    },
                    {
                        "id": 73934,
                        "name": "San Juan Teposcolula",
                        "latitude": "17.58142000",
                        "longitude": "-97.41686000"
                    },
                    {
                        "id": 73952,
                        "name": "San Juan Yaee",
                        "latitude": "17.43000000",
                        "longitude": "-96.28355000"
                    },
                    {
                        "id": 73954,
                        "name": "San Juan Yatzona",
                        "latitude": "17.40184000",
                        "longitude": "-96.16878000"
                    },
                    {
                        "id": 73956,
                        "name": "San Juan Zapotitlán",
                        "latitude": "17.80528000",
                        "longitude": "-96.60639000"
                    },
                    {
                        "id": 73988,
                        "name": "San Lorenzo",
                        "latitude": "16.39483000",
                        "longitude": "-97.87403000"
                    },
                    {
                        "id": 73997,
                        "name": "San Lorenzo Albarradas",
                        "latitude": "16.91129000",
                        "longitude": "-96.25826000"
                    },
                    {
                        "id": 73999,
                        "name": "San Lorenzo Cacaotepec",
                        "latitude": "17.12774000",
                        "longitude": "-96.80244000"
                    },
                    {
                        "id": 74002,
                        "name": "San Lorenzo Cuaunecuiltitla",
                        "latitude": "18.20694000",
                        "longitude": "-96.91139000"
                    },
                    {
                        "id": 74018,
                        "name": "San Lorenzo Victoria",
                        "latitude": "17.63190000",
                        "longitude": "-98.12383000"
                    },
                    {
                        "id": 74019,
                        "name": "San Lorenzo Vista Hermosa",
                        "latitude": "17.95888000",
                        "longitude": "-98.06852000"
                    },
                    {
                        "id": 74027,
                        "name": "San Lucas Camotlán",
                        "latitude": "16.94473000",
                        "longitude": "-95.71382000"
                    },
                    {
                        "id": 74031,
                        "name": "San Lucas Ojitlán",
                        "latitude": "18.05767000",
                        "longitude": "-96.39825000"
                    },
                    {
                        "id": 74033,
                        "name": "San Lucas Quiavini",
                        "latitude": "16.89555000",
                        "longitude": "-96.46813000"
                    },
                    {
                        "id": 74038,
                        "name": "San Lucas Zoquiápam",
                        "latitude": "18.13669000",
                        "longitude": "-96.90545000"
                    },
                    {
                        "id": 74045,
                        "name": "San Luis Amatlán",
                        "latitude": "16.38652000",
                        "longitude": "-96.49824000"
                    },
                    {
                        "id": 74062,
                        "name": "San Marcial Ozolotepec",
                        "latitude": "16.08903000",
                        "longitude": "-96.40561000"
                    },
                    {
                        "id": 74067,
                        "name": "San Marcos Arteaga",
                        "latitude": "17.72238000",
                        "longitude": "-97.86034000"
                    },
                    {
                        "id": 74078,
                        "name": "San Marcos Zacatepec",
                        "latitude": "16.14344000",
                        "longitude": "-97.35725000"
                    },
                    {
                        "id": 74114,
                        "name": "San Martín de los Canseco",
                        "latitude": "16.65655000",
                        "longitude": "-96.72777000"
                    },
                    {
                        "id": 74098,
                        "name": "San Martín Itunyoso",
                        "latitude": "17.22806000",
                        "longitude": "-97.88083000"
                    },
                    {
                        "id": 74099,
                        "name": "San Martín Lachila",
                        "latitude": "16.61186000",
                        "longitude": "-96.84882000"
                    },
                    {
                        "id": 74107,
                        "name": "San Martín Tilcajete",
                        "latitude": "16.86008000",
                        "longitude": "-96.69490000"
                    },
                    {
                        "id": 74121,
                        "name": "San Mateo Cajonos",
                        "latitude": "17.16147000",
                        "longitude": "-96.20777000"
                    },
                    {
                        "id": 74142,
                        "name": "San Mateo del Mar",
                        "latitude": "16.21054000",
                        "longitude": "-94.98218000"
                    },
                    {
                        "id": 74125,
                        "name": "San Mateo Etlatongo",
                        "latitude": "17.41609000",
                        "longitude": "-97.27389000"
                    },
                    {
                        "id": 74130,
                        "name": "San Mateo Nejápam",
                        "latitude": "17.65604000",
                        "longitude": "-98.41662000"
                    },
                    {
                        "id": 74134,
                        "name": "San Mateo Piñas",
                        "latitude": "16.00049000",
                        "longitude": "-96.33449000"
                    },
                    {
                        "id": 74135,
                        "name": "San Mateo Sindihui",
                        "latitude": "17.00456000",
                        "longitude": "-97.35066000"
                    },
                    {
                        "id": 74141,
                        "name": "San Mateo Yoloxochitlán",
                        "latitude": "18.14157000",
                        "longitude": "-96.86417000"
                    },
                    {
                        "id": 74148,
                        "name": "San Melchor Betaza",
                        "latitude": "17.25267000",
                        "longitude": "-96.15284000"
                    },
                    {
                        "id": 74153,
                        "name": "San Miguel Abejones",
                        "latitude": "17.43684000",
                        "longitude": "-96.60866000"
                    },
                    {
                        "id": 74154,
                        "name": "San Miguel Achiutla",
                        "latitude": "17.30900000",
                        "longitude": "-97.48392000"
                    },
                    {
                        "id": 74160,
                        "name": "San Miguel Aloápam",
                        "latitude": "17.41136000",
                        "longitude": "-96.69154000"
                    },
                    {
                        "id": 74171,
                        "name": "San Miguel Chimalapa",
                        "latitude": "16.71424000",
                        "longitude": "-94.74811000"
                    },
                    {
                        "id": 74173,
                        "name": "San Miguel Coatlán",
                        "latitude": "16.19701000",
                        "longitude": "-96.69458000"
                    },
                    {
                        "id": 74237,
                        "name": "San Miguel del Puerto",
                        "latitude": "15.92169000",
                        "longitude": "-96.17499000"
                    },
                    {
                        "id": 74238,
                        "name": "San Miguel del Valle",
                        "latitude": "17.02083000",
                        "longitude": "-96.41727000"
                    },
                    {
                        "id": 74175,
                        "name": "San Miguel Ejutla",
                        "latitude": "16.58053000",
                        "longitude": "-96.73897000"
                    },
                    {
                        "id": 74240,
                        "name": "San Miguel el Grande",
                        "latitude": "17.06466000",
                        "longitude": "-97.61547000"
                    },
                    {
                        "id": 74241,
                        "name": "San Miguel el Grande Villa Juárez",
                        "latitude": "17.04669000",
                        "longitude": "-97.62160000"
                    },
                    {
                        "id": 74180,
                        "name": "San Miguel Figueroa",
                        "latitude": "15.78639000",
                        "longitude": "-96.40417000"
                    },
                    {
                        "id": 74188,
                        "name": "San Miguel Mixtepec",
                        "latitude": "16.77719000",
                        "longitude": "-96.95726000"
                    },
                    {
                        "id": 74189,
                        "name": "San Miguel Monteverde",
                        "latitude": "17.53111000",
                        "longitude": "-97.79250000"
                    },
                    {
                        "id": 74193,
                        "name": "San Miguel Panixtlahuaca",
                        "latitude": "16.26012000",
                        "longitude": "-97.37710000"
                    },
                    {
                        "id": 74195,
                        "name": "San Miguel Peras",
                        "latitude": "16.93903000",
                        "longitude": "-97.01119000"
                    },
                    {
                        "id": 74196,
                        "name": "San Miguel Quetzaltepec",
                        "latitude": "16.97380000",
                        "longitude": "-95.76045000"
                    },
                    {
                        "id": 74197,
                        "name": "San Miguel Suchixtepec",
                        "latitude": "16.07765000",
                        "longitude": "-96.46299000"
                    },
                    {
                        "id": 74198,
                        "name": "San Miguel Tecomatlán",
                        "latitude": "17.39454000",
                        "longitude": "-97.26845000"
                    },
                    {
                        "id": 74203,
                        "name": "San Miguel Tenango",
                        "latitude": "16.26659000",
                        "longitude": "-95.59532000"
                    },
                    {
                        "id": 74207,
                        "name": "San Miguel Tetepelcingo",
                        "latitude": "16.39789000",
                        "longitude": "-97.90127000"
                    },
                    {
                        "id": 74210,
                        "name": "San Miguel Tilquiapam",
                        "latitude": "16.78218000",
                        "longitude": "-96.58165000"
                    },
                    {
                        "id": 74211,
                        "name": "San Miguel Tlacamama",
                        "latitude": "16.41547000",
                        "longitude": "-98.06301000"
                    },
                    {
                        "id": 74212,
                        "name": "San Miguel Tlacotepec",
                        "latitude": "17.45621000",
                        "longitude": "-98.00547000"
                    },
                    {
                        "id": 74251,
                        "name": "San Nicolás",
                        "latitude": "16.42010000",
                        "longitude": "-96.74133000"
                    },
                    {
                        "id": 74260,
                        "name": "San Nicolás Quialana",
                        "latitude": "16.84335000",
                        "longitude": "-96.77892000"
                    },
                    {
                        "id": 74286,
                        "name": "San Pablo Coatlán",
                        "latitude": "16.22429000",
                        "longitude": "-96.78379000"
                    },
                    {
                        "id": 74287,
                        "name": "San Pablo Cuatro Venados",
                        "latitude": "16.98120000",
                        "longitude": "-96.89103000"
                    },
                    {
                        "id": 74288,
                        "name": "San Pablo Etla",
                        "latitude": "17.14397000",
                        "longitude": "-96.74812000"
                    },
                    {
                        "id": 74289,
                        "name": "San Pablo Güilá",
                        "latitude": "16.80324000",
                        "longitude": "-96.44025000"
                    },
                    {
                        "id": 74292,
                        "name": "San Pablo Huitzo",
                        "latitude": "17.27708000",
                        "longitude": "-96.88661000"
                    },
                    {
                        "id": 74293,
                        "name": "San Pablo Huixtepec",
                        "latitude": "16.81948000",
                        "longitude": "-96.78128000"
                    },
                    {
                        "id": 74296,
                        "name": "San Pablo Macuiltianguis",
                        "latitude": "17.53348000",
                        "longitude": "-96.55212000"
                    },
                    {
                        "id": 74303,
                        "name": "San Pablo Villa de Mitla",
                        "latitude": "16.92283000",
                        "longitude": "-96.35990000"
                    },
                    {
                        "id": 74311,
                        "name": "San Pedro Amuzgos",
                        "latitude": "16.65388000",
                        "longitude": "-98.09175000"
                    },
                    {
                        "id": 74313,
                        "name": "San Pedro Apóstol",
                        "latitude": "16.73657000",
                        "longitude": "-96.72509000"
                    },
                    {
                        "id": 74319,
                        "name": "San Pedro Atoyac",
                        "latitude": "16.49005000",
                        "longitude": "-97.98585000"
                    },
                    {
                        "id": 74328,
                        "name": "San Pedro Comitancillo",
                        "latitude": "16.49134000",
                        "longitude": "-95.15649000"
                    },
                    {
                        "id": 74329,
                        "name": "San Pedro Coxcaltepec Cántaros",
                        "latitude": "17.49933000",
                        "longitude": "-97.13802000"
                    },
                    {
                        "id": 74415,
                        "name": "San Pedro el Alto",
                        "latitude": "16.01077000",
                        "longitude": "-96.47591000"
                    },
                    {
                        "id": 74338,
                        "name": "San Pedro Huamelula",
                        "latitude": "16.02697000",
                        "longitude": "-95.66735000"
                    },
                    {
                        "id": 74340,
                        "name": "San Pedro Huilotepec",
                        "latitude": "16.24607000",
                        "longitude": "-95.15094000"
                    },
                    {
                        "id": 74344,
                        "name": "San Pedro Ixcatlán",
                        "latitude": "18.14575000",
                        "longitude": "-96.50953000"
                    },
                    {
                        "id": 74345,
                        "name": "San Pedro Ixtlahuaca",
                        "latitude": "17.06360000",
                        "longitude": "-96.81841000"
                    },
                    {
                        "id": 74346,
                        "name": "San Pedro Jicayán",
                        "latitude": "16.45179000",
                        "longitude": "-98.01425000"
                    },
                    {
                        "id": 74347,
                        "name": "San Pedro Juchaltengo",
                        "latitude": "16.34530000",
                        "longitude": "-97.08954000"
                    },
                    {
                        "id": 74352,
                        "name": "San Pedro Martir",
                        "latitude": "16.74317000",
                        "longitude": "-96.71118000"
                    },
                    {
                        "id": 74359,
                        "name": "San Pedro Mártir Quiechapa",
                        "latitude": "16.41516000",
                        "longitude": "-96.24451000"
                    },
                    {
                        "id": 74360,
                        "name": "San Pedro Mártir Yucuxaco",
                        "latitude": "17.43245000",
                        "longitude": "-97.61100000"
                    },
                    {
                        "id": 74354,
                        "name": "San Pedro Mixtepec",
                        "latitude": "16.27060000",
                        "longitude": "-96.28406000"
                    },
                    {
                        "id": 74363,
                        "name": "San Pedro Ocopetatillo",
                        "latitude": "18.18638000",
                        "longitude": "-96.91166000"
                    },
                    {
                        "id": 74364,
                        "name": "San Pedro Ocotepec",
                        "latitude": "16.95501000",
                        "longitude": "-95.84563000"
                    },
                    {
                        "id": 74365,
                        "name": "San Pedro Ozumacín",
                        "latitude": "17.67861000",
                        "longitude": "-96.22556000"
                    },
                    {
                        "id": 74368,
                        "name": "San Pedro Pochutla",
                        "latitude": "15.74587000",
                        "longitude": "-96.46601000"
                    },
                    {
                        "id": 74369,
                        "name": "San Pedro Quiatoni",
                        "latitude": "16.78295000",
                        "longitude": "-96.03085000"
                    },
                    {
                        "id": 74371,
                        "name": "San Pedro Sochiápam",
                        "latitude": "17.82803000",
                        "longitude": "-96.66274000"
                    },
                    {
                        "id": 74372,
                        "name": "San Pedro Tapanatepec",
                        "latitude": "16.37107000",
                        "longitude": "-94.19313000"
                    },
                    {
                        "id": 74374,
                        "name": "San Pedro Taviche",
                        "latitude": "16.63858000",
                        "longitude": "-96.53687000"
                    },
                    {
                        "id": 74382,
                        "name": "San Pedro Teutila",
                        "latitude": "17.97773000",
                        "longitude": "-96.70599000"
                    },
                    {
                        "id": 74383,
                        "name": "San Pedro Tidaá",
                        "latitude": "17.34122000",
                        "longitude": "-97.37239000"
                    },
                    {
                        "id": 74391,
                        "name": "San Pedro Topiltepec",
                        "latitude": "17.43633000",
                        "longitude": "-97.34403000"
                    },
                    {
                        "id": 74393,
                        "name": "San Pedro Totolápam",
                        "latitude": "16.66915000",
                        "longitude": "-96.30755000"
                    },
                    {
                        "id": 74394,
                        "name": "San Pedro Tulixtlahuaca",
                        "latitude": "16.53972000",
                        "longitude": "-98.03472000"
                    },
                    {
                        "id": 74418,
                        "name": "San Pedro y San Pablo Teposcolula",
                        "latitude": "17.50179000",
                        "longitude": "-97.48836000"
                    },
                    {
                        "id": 74419,
                        "name": "San Pedro y San Pablo Tequistepec",
                        "latitude": "18.06106000",
                        "longitude": "-97.71816000"
                    },
                    {
                        "id": 74401,
                        "name": "San Pedro Yólox",
                        "latitude": "17.58907000",
                        "longitude": "-96.55235000"
                    },
                    {
                        "id": 74438,
                        "name": "San Raymundo Jalpam",
                        "latitude": "16.97164000",
                        "longitude": "-96.75699000"
                    },
                    {
                        "id": 74439,
                        "name": "San Roque",
                        "latitude": "15.78682000",
                        "longitude": "-96.46342000"
                    },
                    {
                        "id": 74458,
                        "name": "San Sebastián Abasolo",
                        "latitude": "16.99432000",
                        "longitude": "-96.58701000"
                    },
                    {
                        "id": 74462,
                        "name": "San Sebastián Coatlán",
                        "latitude": "16.20212000",
                        "longitude": "-96.82645000"
                    },
                    {
                        "id": 74479,
                        "name": "San Sebastián del Monte",
                        "latitude": "17.67778000",
                        "longitude": "-98.02194000"
                    },
                    {
                        "id": 74463,
                        "name": "San Sebastián Etla",
                        "latitude": "17.16437000",
                        "longitude": "-96.78343000"
                    },
                    {
                        "id": 74464,
                        "name": "San Sebastián Ixcapa",
                        "latitude": "16.54548000",
                        "longitude": "-98.14478000"
                    },
                    {
                        "id": 74465,
                        "name": "San Sebastián Nicananduta",
                        "latitude": "17.51657000",
                        "longitude": "-97.68370000"
                    },
                    {
                        "id": 74466,
                        "name": "San Sebastián Nopalera",
                        "latitude": "16.94310000",
                        "longitude": "-97.77793000"
                    },
                    {
                        "id": 74467,
                        "name": "San Sebastián Río Hondo",
                        "latitude": "16.18380000",
                        "longitude": "-96.46535000"
                    },
                    {
                        "id": 74468,
                        "name": "San Sebastián Tecomaxtlahuaca",
                        "latitude": "17.34721000",
                        "longitude": "-98.03167000"
                    },
                    {
                        "id": 74452,
                        "name": "San Sebastian Teitipac",
                        "latitude": "16.95192000",
                        "longitude": "-96.61427000"
                    },
                    {
                        "id": 74472,
                        "name": "San Sebastián Tutla",
                        "latitude": "17.04755000",
                        "longitude": "-96.68158000"
                    },
                    {
                        "id": 74484,
                        "name": "San Simón Almolongas",
                        "latitude": "16.40659000",
                        "longitude": "-96.71927000"
                    },
                    {
                        "id": 74498,
                        "name": "San Vicente Coatlán",
                        "latitude": "16.38852000",
                        "longitude": "-96.84390000"
                    },
                    {
                        "id": 74501,
                        "name": "San Vicente Lachixío",
                        "latitude": "16.70502000",
                        "longitude": "-97.01864000"
                    },
                    {
                        "id": 74502,
                        "name": "San Vicente Nuñu",
                        "latitude": "17.45648000",
                        "longitude": "-97.44319000"
                    },
                    {
                        "id": 74504,
                        "name": "San Vicente Piñas",
                        "latitude": "16.78527000",
                        "longitude": "-98.06041000"
                    },
                    {
                        "id": 74519,
                        "name": "Santa Ana",
                        "latitude": "17.05455000",
                        "longitude": "-95.08509000"
                    },
                    {
                        "id": 74556,
                        "name": "Santa Ana del Valle",
                        "latitude": "16.99488000",
                        "longitude": "-96.47112000"
                    },
                    {
                        "id": 74547,
                        "name": "Santa Ana Tlapacoyan",
                        "latitude": "16.74340000",
                        "longitude": "-96.83688000"
                    },
                    {
                        "id": 74550,
                        "name": "Santa Ana Zegache",
                        "latitude": "16.83706000",
                        "longitude": "-96.72948000"
                    },
                    {
                        "id": 74571,
                        "name": "Santa Catalina Quierí",
                        "latitude": "16.31972000",
                        "longitude": "-96.26694000"
                    },
                    {
                        "id": 74582,
                        "name": "Santa Catarina Cuixtla",
                        "latitude": "16.30616000",
                        "longitude": "-96.64236000"
                    },
                    {
                        "id": 74583,
                        "name": "Santa Catarina Juquila",
                        "latitude": "16.23819000",
                        "longitude": "-97.29161000"
                    },
                    {
                        "id": 74584,
                        "name": "Santa Catarina Loxicha",
                        "latitude": "16.06327000",
                        "longitude": "-96.71942000"
                    },
                    {
                        "id": 74585,
                        "name": "Santa Catarina Mechoacán",
                        "latitude": "16.33591000",
                        "longitude": "-97.83707000"
                    },
                    {
                        "id": 74586,
                        "name": "Santa Catarina Minas",
                        "latitude": "16.77969000",
                        "longitude": "-96.61536000"
                    },
                    {
                        "id": 74587,
                        "name": "Santa Catarina Quiané",
                        "latitude": "16.88255000",
                        "longitude": "-96.74067000"
                    },
                    {
                        "id": 74588,
                        "name": "Santa Catarina Roatina",
                        "latitude": "16.27917000",
                        "longitude": "-96.51778000"
                    },
                    {
                        "id": 74589,
                        "name": "Santa Catarina Tayata",
                        "latitude": "17.34715000",
                        "longitude": "-97.55822000"
                    },
                    {
                        "id": 74595,
                        "name": "Santa Cecilia Jalieza",
                        "latitude": "16.88383000",
                        "longitude": "-96.61558000"
                    },
                    {
                        "id": 74614,
                        "name": "Santa Cruz Acatepec",
                        "latitude": "18.16369000",
                        "longitude": "-96.87503000"
                    },
                    {
                        "id": 74616,
                        "name": "Santa Cruz Amilpas",
                        "latitude": "17.05833000",
                        "longitude": "-96.68333000"
                    },
                    {
                        "id": 74647,
                        "name": "Santa Cruz de Bravo",
                        "latitude": "17.58096000",
                        "longitude": "-98.22378000"
                    },
                    {
                        "id": 74649,
                        "name": "Santa Cruz de Juárez",
                        "latitude": "18.15045000",
                        "longitude": "-96.83541000"
                    },
                    {
                        "id": 74627,
                        "name": "Santa Cruz Lachixolana",
                        "latitude": "17.22784000",
                        "longitude": "-96.85561000"
                    },
                    {
                        "id": 74630,
                        "name": "Santa Cruz Mixtepec",
                        "latitude": "16.79283000",
                        "longitude": "-96.88072000"
                    },
                    {
                        "id": 74631,
                        "name": "Santa Cruz Nundaco",
                        "latitude": "17.17109000",
                        "longitude": "-97.72382000"
                    },
                    {
                        "id": 74633,
                        "name": "Santa Cruz Ozolotepec",
                        "latitude": "16.07041000",
                        "longitude": "-96.30246000"
                    },
                    {
                        "id": 74634,
                        "name": "Santa Cruz Papalutla",
                        "latitude": "16.95667000",
                        "longitude": "-96.58444000"
                    },
                    {
                        "id": 74639,
                        "name": "Santa Cruz Tacache de Mina",
                        "latitude": "17.82898000",
                        "longitude": "-98.15297000"
                    },
                    {
                        "id": 74640,
                        "name": "Santa Cruz Tayata",
                        "latitude": "17.35718000",
                        "longitude": "-97.56843000"
                    },
                    {
                        "id": 74644,
                        "name": "Santa Cruz Xitla",
                        "latitude": "16.32321000",
                        "longitude": "-96.67369000"
                    },
                    {
                        "id": 74645,
                        "name": "Santa Cruz Xoxocotlán",
                        "latitude": "17.02958000",
                        "longitude": "-96.73518000"
                    },
                    {
                        "id": 74661,
                        "name": "Santa Fe y la Mar",
                        "latitude": "17.76611000",
                        "longitude": "-96.31611000"
                    },
                    {
                        "id": 74666,
                        "name": "Santa Gertrudis",
                        "latitude": "16.78580000",
                        "longitude": "-96.80024000"
                    },
                    {
                        "id": 74670,
                        "name": "Santa Inés de Zaragoza",
                        "latitude": "17.26946000",
                        "longitude": "-97.15120000"
                    },
                    {
                        "id": 74671,
                        "name": "Santa Inés del Monte",
                        "latitude": "16.92387000",
                        "longitude": "-96.86238000"
                    },
                    {
                        "id": 74669,
                        "name": "Santa Inés Yatzeche",
                        "latitude": "16.80444000",
                        "longitude": "-96.75486000"
                    },
                    {
                        "id": 74685,
                        "name": "Santa Lucía",
                        "latitude": "16.18860000",
                        "longitude": "-96.61404000"
                    },
                    {
                        "id": 74691,
                        "name": "Santa Lucía del Camino",
                        "latitude": "17.06667000",
                        "longitude": "-96.68069000"
                    },
                    {
                        "id": 74688,
                        "name": "Santa Lucía Ocotlán",
                        "latitude": "16.72986000",
                        "longitude": "-96.66514000"
                    },
                    {
                        "id": 74690,
                        "name": "Santa Lucía Teotepec",
                        "latitude": "16.14256000",
                        "longitude": "-97.20872000"
                    },
                    {
                        "id": 74692,
                        "name": "Santa Magdalena Jicotlán",
                        "latitude": "17.80819000",
                        "longitude": "-97.47389000"
                    },
                    {
                        "id": 74693,
                        "name": "Santa Margarita Huitepec",
                        "latitude": "16.93817000",
                        "longitude": "-95.66944000"
                    },
                    {
                        "id": 74705,
                        "name": "Santa María Acatepec",
                        "latitude": "16.14841000",
                        "longitude": "-97.51261000"
                    },
                    {
                        "id": 74710,
                        "name": "Santa María Alotepec",
                        "latitude": "17.09259000",
                        "longitude": "-95.85423000"
                    },
                    {
                        "id": 74713,
                        "name": "Santa María Apazco",
                        "latitude": "17.62226000",
                        "longitude": "-97.08524000"
                    },
                    {
                        "id": 74719,
                        "name": "Santa María Atzompa",
                        "latitude": "17.09835000",
                        "longitude": "-96.78495000"
                    },
                    {
                        "id": 74722,
                        "name": "Santa María Camotlán",
                        "latitude": "17.89688000",
                        "longitude": "-97.69200000"
                    },
                    {
                        "id": 74724,
                        "name": "Santa María Chachoápam",
                        "latitude": "17.52570000",
                        "longitude": "-97.28422000"
                    },
                    {
                        "id": 74725,
                        "name": "Santa María Chico Ometepec",
                        "latitude": "16.17500000",
                        "longitude": "-97.96670000"
                    },
                    {
                        "id": 74726,
                        "name": "Santa María Chilapa de Díaz",
                        "latitude": "17.51667000",
                        "longitude": "-97.68333000"
                    },
                    {
                        "id": 74727,
                        "name": "Santa María Chimalapa",
                        "latitude": "16.90639000",
                        "longitude": "-94.68333000"
                    },
                    {
                        "id": 74730,
                        "name": "Santa María Colotepec",
                        "latitude": "15.89737000",
                        "longitude": "-96.93951000"
                    },
                    {
                        "id": 74731,
                        "name": "Santa María Cortijo",
                        "latitude": "16.45151000",
                        "longitude": "-98.28549000"
                    },
                    {
                        "id": 74732,
                        "name": "Santa María Coyotepec",
                        "latitude": "16.96663000",
                        "longitude": "-96.70513000"
                    },
                    {
                        "id": 74817,
                        "name": "Santa María del Rosario",
                        "latitude": "17.34848000",
                        "longitude": "-97.60247000"
                    },
                    {
                        "id": 74819,
                        "name": "Santa María del Tule",
                        "latitude": "17.04712000",
                        "longitude": "-96.63573000"
                    },
                    {
                        "id": 74734,
                        "name": "Santa María Ecatepec",
                        "latitude": "16.28498000",
                        "longitude": "-95.87997000"
                    },
                    {
                        "id": 74737,
                        "name": "Santa María Guelacé",
                        "latitude": "17.00151000",
                        "longitude": "-96.60946000"
                    },
                    {
                        "id": 74738,
                        "name": "Santa María Guenagati",
                        "latitude": "16.73862000",
                        "longitude": "-95.35440000"
                    },
                    {
                        "id": 74739,
                        "name": "Santa María Huamelula",
                        "latitude": "15.99245000",
                        "longitude": "-95.70382000"
                    },
                    {
                        "id": 74740,
                        "name": "Santa María Huatulco",
                        "latitude": "15.83267000",
                        "longitude": "-96.32063000"
                    },
                    {
                        "id": 74741,
                        "name": "Santa María Huazolotitlán",
                        "latitude": "16.30359000",
                        "longitude": "-97.91293000"
                    },
                    {
                        "id": 74746,
                        "name": "Santa María Ipalapa",
                        "latitude": "16.63944000",
                        "longitude": "-98.03154000"
                    },
                    {
                        "id": 74749,
                        "name": "Santa María Jacatepec",
                        "latitude": "17.86068000",
                        "longitude": "-96.21174000"
                    },
                    {
                        "id": 74751,
                        "name": "Santa María Jalapa del Marqués",
                        "latitude": "16.44027000",
                        "longitude": "-95.44454000"
                    },
                    {
                        "id": 74752,
                        "name": "Santa María Jicaltepec",
                        "latitude": "16.37917000",
                        "longitude": "-98.04333000"
                    },
                    {
                        "id": 74821,
                        "name": "Santa María la Asunción",
                        "latitude": "18.10722000",
                        "longitude": "-96.81917000"
                    },
                    {
                        "id": 74753,
                        "name": "Santa María Lachixío",
                        "latitude": "16.72694000",
                        "longitude": "-97.01889000"
                    },
                    {
                        "id": 74760,
                        "name": "Santa María Mixtequilla",
                        "latitude": "16.39111000",
                        "longitude": "-95.27798000"
                    },
                    {
                        "id": 74763,
                        "name": "Santa María Nativitas",
                        "latitude": "17.64714000",
                        "longitude": "-97.32925000"
                    },
                    {
                        "id": 74764,
                        "name": "Santa María Nduayaco",
                        "latitude": "17.40832000",
                        "longitude": "-97.50586000"
                    },
                    {
                        "id": 74771,
                        "name": "Santa María Pápalo",
                        "latitude": "17.78452000",
                        "longitude": "-96.79727000"
                    },
                    {
                        "id": 74768,
                        "name": "Santa María Petapa",
                        "latitude": "16.82060000",
                        "longitude": "-95.11913000"
                    },
                    {
                        "id": 74770,
                        "name": "Santa María Puxmetacán",
                        "latitude": "17.26861000",
                        "longitude": "-95.62333000"
                    },
                    {
                        "id": 74773,
                        "name": "Santa María Quiegolani",
                        "latitude": "16.28978000",
                        "longitude": "-96.04156000"
                    },
                    {
                        "id": 74775,
                        "name": "Santa María Sola",
                        "latitude": "16.56615000",
                        "longitude": "-97.01297000"
                    },
                    {
                        "id": 74779,
                        "name": "Santa María Temaxcalapa",
                        "latitude": "17.38036000",
                        "longitude": "-96.16137000"
                    },
                    {
                        "id": 74780,
                        "name": "Santa María Temaxcaltepec",
                        "latitude": "16.16552000",
                        "longitude": "-97.19710000"
                    },
                    {
                        "id": 74781,
                        "name": "Santa María Teopoxco",
                        "latitude": "18.16655000",
                        "longitude": "-96.95488000"
                    },
                    {
                        "id": 74782,
                        "name": "Santa María Tepantlali",
                        "latitude": "16.99663000",
                        "longitude": "-96.00883000"
                    },
                    {
                        "id": 74785,
                        "name": "Santa María Tiltepec",
                        "latitude": "16.06270000",
                        "longitude": "-97.17036000"
                    },
                    {
                        "id": 74786,
                        "name": "Santa María Tlalixtac",
                        "latitude": "17.93618000",
                        "longitude": "-96.73402000"
                    },
                    {
                        "id": 74788,
                        "name": "Santa María Tonameca",
                        "latitude": "15.74805000",
                        "longitude": "-96.54704000"
                    },
                    {
                        "id": 74791,
                        "name": "Santa María Velato",
                        "latitude": "16.50421000",
                        "longitude": "-96.64514000"
                    },
                    {
                        "id": 74792,
                        "name": "Santa María Xadani",
                        "latitude": "15.94825000",
                        "longitude": "-96.07364000"
                    },
                    {
                        "id": 74795,
                        "name": "Santa María Yavesía",
                        "latitude": "17.23531000",
                        "longitude": "-96.43062000"
                    },
                    {
                        "id": 74796,
                        "name": "Santa María Yolotepec",
                        "latitude": "16.88134000",
                        "longitude": "-97.48014000"
                    },
                    {
                        "id": 74797,
                        "name": "Santa María Yucuhiti",
                        "latitude": "17.01873000",
                        "longitude": "-97.76951000"
                    },
                    {
                        "id": 74798,
                        "name": "Santa María Yucunicoco",
                        "latitude": "17.23754000",
                        "longitude": "-97.91698000"
                    },
                    {
                        "id": 74799,
                        "name": "Santa María Zacatepec",
                        "latitude": "16.76369000",
                        "longitude": "-97.99028000"
                    },
                    {
                        "id": 74801,
                        "name": "Santa María Zaniza",
                        "latitude": "16.65531000",
                        "longitude": "-97.33785000"
                    },
                    {
                        "id": 74802,
                        "name": "Santa María Zapotitlán",
                        "latitude": "16.12781000",
                        "longitude": "-95.85239000"
                    },
                    {
                        "id": 74804,
                        "name": "Santa María Zoquitlán",
                        "latitude": "16.55886000",
                        "longitude": "-96.35325000"
                    },
                    {
                        "id": 74700,
                        "name": "Santa Martha Chichihualtepec",
                        "latitude": "16.64948000",
                        "longitude": "-96.77451000"
                    },
                    {
                        "id": 74835,
                        "name": "Santa Rosa",
                        "latitude": "16.31655000",
                        "longitude": "-95.09944000"
                    },
                    {
                        "id": 74842,
                        "name": "Santa Rosa Caxtlahuaca",
                        "latitude": "17.30306000",
                        "longitude": "-98.01694000"
                    },
                    {
                        "id": 74851,
                        "name": "Santa Rosa de Lima",
                        "latitude": "16.07111000",
                        "longitude": "-97.62333000"
                    },
                    {
                        "id": 74876,
                        "name": "Santiago Amoltepec",
                        "latitude": "16.64263000",
                        "longitude": "-97.49674000"
                    },
                    {
                        "id": 74878,
                        "name": "Santiago Apostol",
                        "latitude": "16.80381000",
                        "longitude": "-96.72046000"
                    },
                    {
                        "id": 74879,
                        "name": "Santiago Astata",
                        "latitude": "15.98775000",
                        "longitude": "-95.67571000"
                    },
                    {
                        "id": 74881,
                        "name": "Santiago Ayuquililla",
                        "latitude": "17.93310000",
                        "longitude": "-97.95769000"
                    },
                    {
                        "id": 74884,
                        "name": "Santiago Cacaloxtepec",
                        "latitude": "17.73444000",
                        "longitude": "-97.74139000"
                    },
                    {
                        "id": 74888,
                        "name": "Santiago Chazumba",
                        "latitude": "18.19012000",
                        "longitude": "-97.67983000"
                    },
                    {
                        "id": 74889,
                        "name": "Santiago Chilixtlahuaca",
                        "latitude": "17.90611000",
                        "longitude": "-97.89528000"
                    },
                    {
                        "id": 74891,
                        "name": "Santiago Choápam",
                        "latitude": "17.36084000",
                        "longitude": "-95.92219000"
                    },
                    {
                        "id": 74895,
                        "name": "Santiago Comaltepec",
                        "latitude": "17.56547000",
                        "longitude": "-96.54873000"
                    },
                    {
                        "id": 74899,
                        "name": "Santiago Cuixtla",
                        "latitude": "16.06196000",
                        "longitude": "-97.18586000"
                    },
                    {
                        "id": 74988,
                        "name": "Santiago del Río",
                        "latitude": "17.44838000",
                        "longitude": "-98.09111000"
                    },
                    {
                        "id": 74900,
                        "name": "Santiago Etla",
                        "latitude": "17.15250000",
                        "longitude": "-96.78972000"
                    },
                    {
                        "id": 74901,
                        "name": "Santiago Huajolotitlán",
                        "latitude": "17.82783000",
                        "longitude": "-97.73266000"
                    },
                    {
                        "id": 74902,
                        "name": "Santiago Huauclilla",
                        "latitude": "17.45179000",
                        "longitude": "-97.07277000"
                    },
                    {
                        "id": 74903,
                        "name": "Santiago Huaxolotipac",
                        "latitude": "16.97383000",
                        "longitude": "-97.08610000"
                    },
                    {
                        "id": 74905,
                        "name": "Santiago Ihuitlán Plumas",
                        "latitude": "17.88057000",
                        "longitude": "-97.43215000"
                    },
                    {
                        "id": 74906,
                        "name": "Santiago Ixcuintepec",
                        "latitude": "16.93540000",
                        "longitude": "-95.62282000"
                    },
                    {
                        "id": 74908,
                        "name": "Santiago Ixtaltepec",
                        "latitude": "16.68833000",
                        "longitude": "-94.90583000"
                    },
                    {
                        "id": 74909,
                        "name": "Santiago Ixtayutla",
                        "latitude": "16.56649000",
                        "longitude": "-97.65285000"
                    },
                    {
                        "id": 74911,
                        "name": "Santiago Jicayán",
                        "latitude": "16.47884000",
                        "longitude": "-98.01018000"
                    },
                    {
                        "id": 74912,
                        "name": "Santiago Jocotepec",
                        "latitude": "16.12837000",
                        "longitude": "-97.43760000"
                    },
                    {
                        "id": 74913,
                        "name": "Santiago Juxtlahuaca",
                        "latitude": "17.33462000",
                        "longitude": "-98.01147000"
                    },
                    {
                        "id": 74914,
                        "name": "Santiago Lachiguiri",
                        "latitude": "16.68706000",
                        "longitude": "-95.53067000"
                    },
                    {
                        "id": 74915,
                        "name": "Santiago Lalopa",
                        "latitude": "17.41786000",
                        "longitude": "-96.24893000"
                    },
                    {
                        "id": 74916,
                        "name": "Santiago Laollaga",
                        "latitude": "16.58418000",
                        "longitude": "-95.20707000"
                    },
                    {
                        "id": 74917,
                        "name": "Santiago Laxopa",
                        "latitude": "17.21842000",
                        "longitude": "-96.31099000"
                    },
                    {
                        "id": 74918,
                        "name": "Santiago Llano Grande",
                        "latitude": "16.48833000",
                        "longitude": "-98.28972000"
                    },
                    {
                        "id": 74919,
                        "name": "Santiago Malacatepec",
                        "latitude": "17.01639000",
                        "longitude": "-95.60750000"
                    },
                    {
                        "id": 74922,
                        "name": "Santiago Matatlán",
                        "latitude": "16.86470000",
                        "longitude": "-96.38261000"
                    },
                    {
                        "id": 74925,
                        "name": "Santiago Miltepec",
                        "latitude": "17.98461000",
                        "longitude": "-97.69006000"
                    },
                    {
                        "id": 74927,
                        "name": "Santiago Nejapilla",
                        "latitude": "17.41983000",
                        "longitude": "-97.37411000"
                    },
                    {
                        "id": 74928,
                        "name": "Santiago Niltepec",
                        "latitude": "16.52438000",
                        "longitude": "-94.59337000"
                    },
                    {
                        "id": 74929,
                        "name": "Santiago Nundiche",
                        "latitude": "17.34392000",
                        "longitude": "-97.66988000"
                    },
                    {
                        "id": 74931,
                        "name": "Santiago Nuyoó",
                        "latitude": "17.00937000",
                        "longitude": "-97.75000000"
                    },
                    {
                        "id": 74938,
                        "name": "Santiago Quiavicuzas",
                        "latitude": "16.86297000",
                        "longitude": "-95.71616000"
                    },
                    {
                        "id": 74940,
                        "name": "Santiago Suchilquitongo",
                        "latitude": "17.25316000",
                        "longitude": "-96.87825000"
                    },
                    {
                        "id": 74944,
                        "name": "Santiago Tenango",
                        "latitude": "17.32489000",
                        "longitude": "-97.00467000"
                    },
                    {
                        "id": 74948,
                        "name": "Santiago Tepextla",
                        "latitude": "16.34065000",
                        "longitude": "-98.44684000"
                    },
                    {
                        "id": 74951,
                        "name": "Santiago Tetepec",
                        "latitude": "16.32172000",
                        "longitude": "-97.74794000"
                    },
                    {
                        "id": 74952,
                        "name": "Santiago Texcalcingo",
                        "latitude": "18.21438000",
                        "longitude": "-96.97358000"
                    },
                    {
                        "id": 74953,
                        "name": "Santiago Textitlán",
                        "latitude": "16.69264000",
                        "longitude": "-97.25884000"
                    },
                    {
                        "id": 74957,
                        "name": "Santiago Tilantongo",
                        "latitude": "17.28464000",
                        "longitude": "-97.33879000"
                    },
                    {
                        "id": 74959,
                        "name": "Santiago Tillo",
                        "latitude": "17.46497000",
                        "longitude": "-97.32040000"
                    },
                    {
                        "id": 74971,
                        "name": "Santiago Xanica",
                        "latitude": "16.01009000",
                        "longitude": "-96.22462000"
                    },
                    {
                        "id": 74972,
                        "name": "Santiago Yaitepec",
                        "latitude": "16.22628000",
                        "longitude": "-97.26953000"
                    },
                    {
                        "id": 74976,
                        "name": "Santiago Yogana",
                        "latitude": "16.46130000",
                        "longitude": "-96.78786000"
                    },
                    {
                        "id": 74977,
                        "name": "Santiago Yolomécatl",
                        "latitude": "17.47237000",
                        "longitude": "-97.56981000"
                    },
                    {
                        "id": 74978,
                        "name": "Santiago Yosondúa",
                        "latitude": "16.87601000",
                        "longitude": "-97.57607000"
                    },
                    {
                        "id": 74979,
                        "name": "Santiago Zacatepec",
                        "latitude": "17.16005000",
                        "longitude": "-95.91455000"
                    },
                    {
                        "id": 74981,
                        "name": "Santiago Zoochila",
                        "latitude": "17.22000000",
                        "longitude": "-96.24167000"
                    },
                    {
                        "id": 74996,
                        "name": "Santo Domingo Albarradas",
                        "latitude": "17.07257000",
                        "longitude": "-96.19076000"
                    },
                    {
                        "id": 74997,
                        "name": "Santo Domingo Armenta",
                        "latitude": "16.33194000",
                        "longitude": "-98.37778000"
                    },
                    {
                        "id": 75000,
                        "name": "Santo Domingo Chihuitán",
                        "latitude": "16.59135000",
                        "longitude": "-95.16331000"
                    },
                    {
                        "id": 75018,
                        "name": "Santo Domingo de Morelos",
                        "latitude": "15.83397000",
                        "longitude": "-96.66695000"
                    },
                    {
                        "id": 75002,
                        "name": "Santo Domingo Jalieza",
                        "latitude": "16.86848000",
                        "longitude": "-96.62919000"
                    },
                    {
                        "id": 75005,
                        "name": "Santo Domingo Ozolotepec",
                        "latitude": "16.17103000",
                        "longitude": "-96.32044000"
                    },
                    {
                        "id": 75006,
                        "name": "Santo Domingo Petapa",
                        "latitude": "16.81869000",
                        "longitude": "-95.14072000"
                    },
                    {
                        "id": 75007,
                        "name": "Santo Domingo Roayaga",
                        "latitude": "17.33782000",
                        "longitude": "-96.11506000"
                    },
                    {
                        "id": 75009,
                        "name": "Santo Domingo Tehuantepec",
                        "latitude": "16.32463000",
                        "longitude": "-95.24104000"
                    },
                    {
                        "id": 75010,
                        "name": "Santo Domingo Tepuxtepec",
                        "latitude": "16.95584000",
                        "longitude": "-96.05823000"
                    },
                    {
                        "id": 75011,
                        "name": "Santo Domingo Tlatayapam",
                        "latitude": "17.40778000",
                        "longitude": "-97.34581000"
                    },
                    {
                        "id": 75012,
                        "name": "Santo Domingo Tomaltepec",
                        "latitude": "17.06117000",
                        "longitude": "-96.62280000"
                    },
                    {
                        "id": 75013,
                        "name": "Santo Domingo Tonalá",
                        "latitude": "17.67352000",
                        "longitude": "-97.96556000"
                    },
                    {
                        "id": 75014,
                        "name": "Santo Domingo Yanhuitlán",
                        "latitude": "17.53283000",
                        "longitude": "-97.35332000"
                    },
                    {
                        "id": 75015,
                        "name": "Santo Domingo Yodohino",
                        "latitude": "17.61694000",
                        "longitude": "-97.68289000"
                    },
                    {
                        "id": 75016,
                        "name": "Santo Domingo Zanatepec",
                        "latitude": "16.48307000",
                        "longitude": "-94.34754000"
                    },
                    {
                        "id": 75024,
                        "name": "Santo Tomás",
                        "latitude": "18.04194000",
                        "longitude": "-96.51389000"
                    },
                    {
                        "id": 75029,
                        "name": "Santo Tomás Jalieza",
                        "latitude": "16.84469000",
                        "longitude": "-96.67063000"
                    },
                    {
                        "id": 75030,
                        "name": "Santo Tomás Mazaltepec",
                        "latitude": "17.17222000",
                        "longitude": "-96.87083000"
                    },
                    {
                        "id": 75031,
                        "name": "Santo Tomás Ocotepec",
                        "latitude": "17.12204000",
                        "longitude": "-97.77344000"
                    },
                    {
                        "id": 75032,
                        "name": "Santo Tomás Tamazulapam",
                        "latitude": "16.27064000",
                        "longitude": "-96.58193000"
                    },
                    {
                        "id": 75035,
                        "name": "Santos Reyes Nopala",
                        "latitude": "16.10694000",
                        "longitude": "-97.14435000"
                    },
                    {
                        "id": 75036,
                        "name": "Santos Reyes Pápalo",
                        "latitude": "17.80532000",
                        "longitude": "-96.86157000"
                    },
                    {
                        "id": 75037,
                        "name": "Santos Reyes Tepejillo",
                        "latitude": "17.43782000",
                        "longitude": "-97.93845000"
                    },
                    {
                        "id": 75038,
                        "name": "Santos Reyes Yucuná",
                        "latitude": "17.77400000",
                        "longitude": "-98.00172000"
                    },
                    {
                        "id": 75054,
                        "name": "Sector H Tres",
                        "latitude": "15.76611000",
                        "longitude": "-96.14694000"
                    },
                    {
                        "id": 75078,
                        "name": "Silacayoápam",
                        "latitude": "17.50297000",
                        "longitude": "-98.13966000"
                    },
                    {
                        "id": 75102,
                        "name": "Sitio de Xitlapehua",
                        "latitude": "16.35139000",
                        "longitude": "-96.53215000"
                    },
                    {
                        "id": 75112,
                        "name": "Soledad Etla",
                        "latitude": "17.16556000",
                        "longitude": "-96.82212000"
                    },
                    {
                        "id": 75115,
                        "name": "Soledad Salinas",
                        "latitude": "16.66229000",
                        "longitude": "-96.00266000"
                    },
                    {
                        "id": 75177,
                        "name": "Tamazola",
                        "latitude": "17.67020000",
                        "longitude": "-98.22084000"
                    },
                    {
                        "id": 75183,
                        "name": "Tamazulápam del Espíritu Santo",
                        "latitude": "17.05500000",
                        "longitude": "-96.06528000"
                    },
                    {
                        "id": 75182,
                        "name": "Tamazulapam Villa del Progreso",
                        "latitude": "17.67710000",
                        "longitude": "-97.57315000"
                    },
                    {
                        "id": 75207,
                        "name": "Tanetze de Zaragoza",
                        "latitude": "17.37616000",
                        "longitude": "-96.30111000"
                    },
                    {
                        "id": 75213,
                        "name": "Taniche",
                        "latitude": "16.56860000",
                        "longitude": "-96.75514000"
                    },
                    {
                        "id": 75224,
                        "name": "Tapanalá",
                        "latitude": "15.96659000",
                        "longitude": "-95.72476000"
                    },
                    {
                        "id": 75238,
                        "name": "Tatahuicapá",
                        "latitude": "17.55113000",
                        "longitude": "-95.64088000"
                    },
                    {
                        "id": 75239,
                        "name": "Tataltepec de Valdés",
                        "latitude": "16.30549000",
                        "longitude": "-97.54615000"
                    },
                    {
                        "id": 75283,
                        "name": "Tecomavaca",
                        "latitude": "17.95577000",
                        "longitude": "-97.02263000"
                    },
                    {
                        "id": 75329,
                        "name": "Temascal",
                        "latitude": "18.24285000",
                        "longitude": "-96.40165000"
                    },
                    {
                        "id": 75374,
                        "name": "Teococuilco de Marcos Pérez",
                        "latitude": "17.35270000",
                        "longitude": "-96.61528000"
                    },
                    {
                        "id": 75376,
                        "name": "Teojomulco",
                        "latitude": "16.59032000",
                        "longitude": "-97.22493000"
                    },
                    {
                        "id": 75384,
                        "name": "Teotitlán",
                        "latitude": "18.13179000",
                        "longitude": "-97.07056000"
                    },
                    {
                        "id": 75385,
                        "name": "Teotitlán del Valle",
                        "latitude": "17.02975000",
                        "longitude": "-96.51926000"
                    },
                    {
                        "id": 75412,
                        "name": "Tepenixtlahuaca",
                        "latitude": "16.29236000",
                        "longitude": "-97.49184000"
                    },
                    {
                        "id": 75427,
                        "name": "Tepetlapa",
                        "latitude": "17.66601000",
                        "longitude": "-98.39188000"
                    },
                    {
                        "id": 75477,
                        "name": "Tetela",
                        "latitude": "18.50887000",
                        "longitude": "-96.45880000"
                    },
                    {
                        "id": 75514,
                        "name": "Texcatitlán",
                        "latitude": "17.71259000",
                        "longitude": "-97.06625000"
                    },
                    {
                        "id": 75519,
                        "name": "Texmelucan",
                        "latitude": "16.58510000",
                        "longitude": "-97.19907000"
                    },
                    {
                        "id": 75526,
                        "name": "Tezoatlán de Segura y Luna",
                        "latitude": "17.65388000",
                        "longitude": "-97.81068000"
                    },
                    {
                        "id": 75601,
                        "name": "Tlachichilco",
                        "latitude": "17.62220000",
                        "longitude": "-98.34312000"
                    },
                    {
                        "id": 75605,
                        "name": "Tlacoatzintepec",
                        "latitude": "17.85985000",
                        "longitude": "-96.58647000"
                    },
                    {
                        "id": 75609,
                        "name": "Tlacolula de Matamoros",
                        "latitude": "16.95471000",
                        "longitude": "-96.47590000"
                    },
                    {
                        "id": 75633,
                        "name": "Tlahuitoltepec",
                        "latitude": "17.09746000",
                        "longitude": "-96.06279000"
                    },
                    {
                        "id": 75640,
                        "name": "Tlalixtac de Cabrera",
                        "latitude": "17.07112000",
                        "longitude": "-96.64710000"
                    },
                    {
                        "id": 75757,
                        "name": "Totontepec Villa de Morelos",
                        "latitude": "17.25679000",
                        "longitude": "-96.02786000"
                    },
                    {
                        "id": 75760,
                        "name": "Toxpalan",
                        "latitude": "18.10125000",
                        "longitude": "-97.05869000"
                    },
                    {
                        "id": 75783,
                        "name": "Trinidad de Viguera",
                        "latitude": "17.13059000",
                        "longitude": "-96.75025000"
                    },
                    {
                        "id": 75782,
                        "name": "Trinidad Zaachila",
                        "latitude": "16.92135000",
                        "longitude": "-96.76384000"
                    },
                    {
                        "id": 75823,
                        "name": "Tuxtepec",
                        "latitude": "18.08830000",
                        "longitude": "-96.12535000"
                    },
                    {
                        "id": 75884,
                        "name": "Unión Hidalgo",
                        "latitude": "16.47230000",
                        "longitude": "-94.82952000"
                    },
                    {
                        "id": 75906,
                        "name": "Valdeflores",
                        "latitude": "16.76588000",
                        "longitude": "-96.82435000"
                    },
                    {
                        "id": 75911,
                        "name": "Valerio Trujano",
                        "latitude": "17.78130000",
                        "longitude": "-96.97852000"
                    },
                    {
                        "id": 75917,
                        "name": "Valle Nacional",
                        "latitude": "17.77579000",
                        "longitude": "-96.30174000"
                    },
                    {
                        "id": 75941,
                        "name": "Vega del Sol",
                        "latitude": "17.80972000",
                        "longitude": "-96.21694000"
                    },
                    {
                        "id": 75970,
                        "name": "Vicente Camalote",
                        "latitude": "18.51443000",
                        "longitude": "-96.52915000"
                    },
                    {
                        "id": 75978,
                        "name": "Vicente Guerrero",
                        "latitude": "16.93306000",
                        "longitude": "-96.70139000"
                    },
                    {
                        "id": 75994,
                        "name": "Villa Chalcatongo de Hidalgo",
                        "latitude": "17.03247000",
                        "longitude": "-97.57057000"
                    },
                    {
                        "id": 76064,
                        "name": "Villa de Etla",
                        "latitude": "17.20615000",
                        "longitude": "-96.79890000"
                    },
                    {
                        "id": 76068,
                        "name": "Villa de Tamazulápam del Progreso",
                        "latitude": "17.69300000",
                        "longitude": "-97.57366000"
                    },
                    {
                        "id": 76069,
                        "name": "Villa de Tututepec de Melchor Ocampo",
                        "latitude": "16.04794000",
                        "longitude": "-97.53109000"
                    },
                    {
                        "id": 76070,
                        "name": "Villa de Zaachila",
                        "latitude": "16.95098000",
                        "longitude": "-96.74938000"
                    },
                    {
                        "id": 75999,
                        "name": "Villa Díaz Ordaz",
                        "latitude": "16.99578000",
                        "longitude": "-96.43231000"
                    },
                    {
                        "id": 76009,
                        "name": "Villa Hidalgo",
                        "latitude": "17.18409000",
                        "longitude": "-96.17831000"
                    },
                    {
                        "id": 76044,
                        "name": "Villa Sola de Vega",
                        "latitude": "16.51844000",
                        "longitude": "-96.97810000"
                    },
                    {
                        "id": 76045,
                        "name": "Villa Talea de Castro",
                        "latitude": "17.36489000",
                        "longitude": "-96.24722000"
                    },
                    {
                        "id": 76047,
                        "name": "Villa Tejúpam de la Unión",
                        "latitude": "17.66250000",
                        "longitude": "-97.47083000"
                    },
                    {
                        "id": 76095,
                        "name": "Vista Hermosa",
                        "latitude": "17.79639000",
                        "longitude": "-97.75694000"
                    },
                    {
                        "id": 76109,
                        "name": "Xaaga",
                        "latitude": "16.90420000",
                        "longitude": "-96.32779000"
                    },
                    {
                        "id": 76111,
                        "name": "Xagacía",
                        "latitude": "17.15436000",
                        "longitude": "-96.26753000"
                    },
                    {
                        "id": 76181,
                        "name": "Xochitonalco",
                        "latitude": "18.09443000",
                        "longitude": "-96.84848000"
                    },
                    {
                        "id": 76208,
                        "name": "Yaganiza",
                        "latitude": "17.14495000",
                        "longitude": "-96.22960000"
                    },
                    {
                        "id": 76212,
                        "name": "Yalina",
                        "latitude": "17.23969000",
                        "longitude": "-96.26233000"
                    },
                    {
                        "id": 76219,
                        "name": "Yatzachi",
                        "latitude": "17.22588000",
                        "longitude": "-96.22137000"
                    },
                    {
                        "id": 76225,
                        "name": "Yaxe",
                        "latitude": "16.72595000",
                        "longitude": "-96.47191000"
                    },
                    {
                        "id": 76235,
                        "name": "Yetla de Juárez",
                        "latitude": "17.66559000",
                        "longitude": "-97.99124000"
                    },
                    {
                        "id": 76247,
                        "name": "Yucuita",
                        "latitude": "17.51073000",
                        "longitude": "-97.26965000"
                    },
                    {
                        "id": 76251,
                        "name": "Yutanduchi de Guerrero",
                        "latitude": "17.04020000",
                        "longitude": "-97.29795000"
                    },
                    {
                        "id": 76269,
                        "name": "Zacatal",
                        "latitude": "16.93982000",
                        "longitude": "-95.20312000"
                    },
                    {
                        "id": 76308,
                        "name": "Zapotitlán Lagunas",
                        "latitude": "17.75621000",
                        "longitude": "-98.38958000"
                    },
                    {
                        "id": 76309,
                        "name": "Zapotitlán Palmas",
                        "latitude": "17.88965000",
                        "longitude": "-97.81849000"
                    },
                    {
                        "id": 76316,
                        "name": "Zaragoza",
                        "latitude": "16.66923000",
                        "longitude": "-97.79322000"
                    },
                    {
                        "id": 76324,
                        "name": "Zarzal",
                        "latitude": "17.01419000",
                        "longitude": "-95.03738000"
                    },
                    {
                        "id": 76338,
                        "name": "Zimatlán de Álvarez",
                        "latitude": "16.86939000",
                        "longitude": "-96.78435000"
                    },
                    {
                        "id": 76357,
                        "name": "Zocoteaca de León",
                        "latitude": "16.63818000",
                        "longitude": "-98.00276000"
                    },
                    {
                        "id": 76360,
                        "name": "Zona Urbana Ejidal",
                        "latitude": "18.53250000",
                        "longitude": "-96.58917000"
                    }
                ]
            },
            {
                "id": 3476,
                "name": "Puebla",
                "iso2": "PUE",
                "latitude": "19.04143980",
                "longitude": "-98.20627270",
                "type": "state",
                "cities": [
                    {
                        "id": 68006,
                        "name": "18 de Marzo",
                        "latitude": "18.96889000",
                        "longitude": "-98.16028000"
                    },
                    {
                        "id": 68027,
                        "name": "Acajete",
                        "latitude": "19.11154000",
                        "longitude": "-97.95231000"
                    },
                    {
                        "id": 68042,
                        "name": "Acateno",
                        "latitude": "20.11324000",
                        "longitude": "-97.22710000"
                    },
                    {
                        "id": 68044,
                        "name": "Acatepec",
                        "latitude": "18.37236000",
                        "longitude": "-97.03651000"
                    },
                    {
                        "id": 68049,
                        "name": "Acatlán",
                        "latitude": "18.22374000",
                        "longitude": "-98.07685000"
                    },
                    {
                        "id": 68051,
                        "name": "Acatlán de Osorio",
                        "latitude": "18.20250000",
                        "longitude": "-98.04864000"
                    },
                    {
                        "id": 68053,
                        "name": "Acatzingo",
                        "latitude": "18.98196000",
                        "longitude": "-97.78363000"
                    },
                    {
                        "id": 68056,
                        "name": "Acaxtlahuacán de Albino Zertuche",
                        "latitude": "18.01714000",
                        "longitude": "-98.54018000"
                    },
                    {
                        "id": 68069,
                        "name": "Acteopan",
                        "latitude": "18.76388000",
                        "longitude": "-98.71366000"
                    },
                    {
                        "id": 68070,
                        "name": "Actipan",
                        "latitude": "18.93689000",
                        "longitude": "-97.90252000"
                    },
                    {
                        "id": 68071,
                        "name": "Actipan de Morelos",
                        "latitude": "18.96003000",
                        "longitude": "-97.79904000"
                    },
                    {
                        "id": 68074,
                        "name": "Acuaco",
                        "latitude": "19.76250000",
                        "longitude": "-97.56444000"
                    },
                    {
                        "id": 68076,
                        "name": "Acuexcomac",
                        "latitude": "19.03742000",
                        "longitude": "-98.38501000"
                    },
                    {
                        "id": 68137,
                        "name": "Ahuacatlán",
                        "latitude": "20.13722000",
                        "longitude": "-98.00750000"
                    },
                    {
                        "id": 68143,
                        "name": "Ahuatempan",
                        "latitude": "18.41269000",
                        "longitude": "-98.01850000"
                    },
                    {
                        "id": 68145,
                        "name": "Ahuatepec",
                        "latitude": "18.85831000",
                        "longitude": "-97.91764000"
                    },
                    {
                        "id": 68147,
                        "name": "Ahuatepec de Camino",
                        "latitude": "19.04087000",
                        "longitude": "-97.43457000"
                    },
                    {
                        "id": 68149,
                        "name": "Ahuatlán",
                        "latitude": "18.57930000",
                        "longitude": "-98.27791000"
                    },
                    {
                        "id": 68150,
                        "name": "Ahuaxintitla",
                        "latitude": "20.25325000",
                        "longitude": "-97.89561000"
                    },
                    {
                        "id": 68151,
                        "name": "Ahuazotepec",
                        "latitude": "20.04535000",
                        "longitude": "-98.16332000"
                    },
                    {
                        "id": 68153,
                        "name": "Ahuehuetitla",
                        "latitude": "18.21272000",
                        "longitude": "-98.21949000"
                    },
                    {
                        "id": 68164,
                        "name": "Ajalpan",
                        "latitude": "18.37908000",
                        "longitude": "-97.25867000"
                    },
                    {
                        "id": 76393,
                        "name": "Álamos Tepetitlán",
                        "latitude": "19.19619000",
                        "longitude": "-97.43858000"
                    },
                    {
                        "id": 68176,
                        "name": "Albino Zertuche",
                        "latitude": "18.01275000",
                        "longitude": "-98.55511000"
                    },
                    {
                        "id": 68201,
                        "name": "Alhuaca",
                        "latitude": "18.56795000",
                        "longitude": "-97.16594000"
                    },
                    {
                        "id": 68204,
                        "name": "Aljojuca",
                        "latitude": "19.09933000",
                        "longitude": "-97.52973000"
                    },
                    {
                        "id": 68206,
                        "name": "Allende",
                        "latitude": "19.53879000",
                        "longitude": "-97.59711000"
                    },
                    {
                        "id": 68210,
                        "name": "Almecatla",
                        "latitude": "19.14286000",
                        "longitude": "-98.23597000"
                    },
                    {
                        "id": 68213,
                        "name": "Almolonga",
                        "latitude": "18.47627000",
                        "longitude": "-97.96353000"
                    },
                    {
                        "id": 68226,
                        "name": "Altepexi",
                        "latitude": "18.37035000",
                        "longitude": "-97.29966000"
                    },
                    {
                        "id": 76398,
                        "name": "Álvaro Obregón",
                        "latitude": "19.02781000",
                        "longitude": "-97.90219000"
                    },
                    {
                        "id": 68242,
                        "name": "Amatitlán de Azueta",
                        "latitude": "18.17631000",
                        "longitude": "-98.07640000"
                    },
                    {
                        "id": 68254,
                        "name": "Ameluca",
                        "latitude": "20.56344000",
                        "longitude": "-97.82571000"
                    },
                    {
                        "id": 68256,
                        "name": "Amixtlán",
                        "latitude": "20.04778000",
                        "longitude": "-97.79918000"
                    },
                    {
                        "id": 68257,
                        "name": "Amozoc",
                        "latitude": "19.05019000",
                        "longitude": "-98.04154000"
                    },
                    {
                        "id": 68258,
                        "name": "Amozoc de Mota",
                        "latitude": "19.04611000",
                        "longitude": "-98.04500000"
                    },
                    {
                        "id": 68268,
                        "name": "Analco de Ponciano Arriaga (Santa Cruz Analco)",
                        "latitude": "19.26444000",
                        "longitude": "-98.50028000"
                    },
                    {
                        "id": 68290,
                        "name": "Apango de Zaragoza",
                        "latitude": "19.06833000",
                        "longitude": "-97.94028000"
                    },
                    {
                        "id": 68292,
                        "name": "Apantéopan",
                        "latitude": "19.35820000",
                        "longitude": "-97.19104000"
                    },
                    {
                        "id": 68293,
                        "name": "Apapantilla",
                        "latitude": "20.40356000",
                        "longitude": "-97.84665000"
                    },
                    {
                        "id": 68298,
                        "name": "Apatauyan",
                        "latitude": "19.79911000",
                        "longitude": "-97.44440000"
                    },
                    {
                        "id": 68327,
                        "name": "Aquixtla",
                        "latitude": "19.77957000",
                        "longitude": "-97.93526000"
                    },
                    {
                        "id": 68377,
                        "name": "Artículo Primero Constitucional",
                        "latitude": "18.97412000",
                        "longitude": "-98.15848000"
                    },
                    {
                        "id": 68389,
                        "name": "Atalpan",
                        "latitude": "19.84374000",
                        "longitude": "-97.56008000"
                    },
                    {
                        "id": 68394,
                        "name": "Atecax",
                        "latitude": "19.69870000",
                        "longitude": "-97.36698000"
                    },
                    {
                        "id": 68396,
                        "name": "Atempan",
                        "latitude": "19.83945000",
                        "longitude": "-97.45855000"
                    },
                    {
                        "id": 68398,
                        "name": "Atencingo",
                        "latitude": "18.51347000",
                        "longitude": "-98.60542000"
                    },
                    {
                        "id": 68402,
                        "name": "Atexcal",
                        "latitude": "18.36391000",
                        "longitude": "-97.68770000"
                    },
                    {
                        "id": 68408,
                        "name": "Atla",
                        "latitude": "20.27527000",
                        "longitude": "-98.12469000"
                    },
                    {
                        "id": 68420,
                        "name": "Atlequizayan",
                        "latitude": "20.01214000",
                        "longitude": "-97.62423000"
                    },
                    {
                        "id": 68422,
                        "name": "Atlixco",
                        "latitude": "18.90815000",
                        "longitude": "-98.43613000"
                    },
                    {
                        "id": 68426,
                        "name": "Atoluca",
                        "latitude": "19.85500000",
                        "longitude": "-97.35361000"
                    },
                    {
                        "id": 68435,
                        "name": "Atoyatempan",
                        "latitude": "18.81925000",
                        "longitude": "-97.91390000"
                    },
                    {
                        "id": 68438,
                        "name": "Atzala",
                        "latitude": "18.54639000",
                        "longitude": "-98.55306000"
                    },
                    {
                        "id": 68440,
                        "name": "Atzalán",
                        "latitude": "19.82472000",
                        "longitude": "-97.44417000"
                    },
                    {
                        "id": 68441,
                        "name": "Atzingo (La Cumbre)",
                        "latitude": "19.97972000",
                        "longitude": "-97.96861000"
                    },
                    {
                        "id": 68442,
                        "name": "Atzitzintla",
                        "latitude": "18.89915000",
                        "longitude": "-97.32440000"
                    },
                    {
                        "id": 68455,
                        "name": "Axutla",
                        "latitude": "18.18938000",
                        "longitude": "-98.38935000"
                    },
                    {
                        "id": 68456,
                        "name": "Axuxco",
                        "latitude": "18.23045000",
                        "longitude": "-97.20739000"
                    },
                    {
                        "id": 68464,
                        "name": "Ayotla",
                        "latitude": "18.67004000",
                        "longitude": "-98.37266000"
                    },
                    {
                        "id": 68465,
                        "name": "Ayotoxco de Guerrero",
                        "latitude": "20.09589000",
                        "longitude": "-97.40961000"
                    },
                    {
                        "id": 68470,
                        "name": "Ayutla",
                        "latitude": "18.54503000",
                        "longitude": "-98.50537000"
                    },
                    {
                        "id": 68476,
                        "name": "Azumbilla",
                        "latitude": "18.64552000",
                        "longitude": "-97.39815000"
                    },
                    {
                        "id": 68546,
                        "name": "Barrio de Nuevo León",
                        "latitude": "19.08861000",
                        "longitude": "-98.29000000"
                    },
                    {
                        "id": 68581,
                        "name": "Bellavista de Victoria (San José Bellavista)",
                        "latitude": "18.87639000",
                        "longitude": "-97.54389000"
                    },
                    {
                        "id": 68592,
                        "name": "Benito Juárez",
                        "latitude": "19.81654000",
                        "longitude": "-97.79108000"
                    },
                    {
                        "id": 68608,
                        "name": "Beristain",
                        "latitude": "20.09426000",
                        "longitude": "-98.13290000"
                    },
                    {
                        "id": 68615,
                        "name": "Bienvenido",
                        "latitude": "20.12235000",
                        "longitude": "-97.74434000"
                    },
                    {
                        "id": 68662,
                        "name": "Buena Vista",
                        "latitude": "20.12767000",
                        "longitude": "-97.45373000"
                    },
                    {
                        "id": 68674,
                        "name": "Buenavista",
                        "latitude": "19.25767000",
                        "longitude": "-97.07531000"
                    },
                    {
                        "id": 68683,
                        "name": "Buenavista de Juárez",
                        "latitude": "18.94500000",
                        "longitude": "-97.82778000"
                    },
                    {
                        "id": 68677,
                        "name": "Buenavista Tetela",
                        "latitude": "18.91967000",
                        "longitude": "-98.17632000"
                    },
                    {
                        "id": 68690,
                        "name": "Buenos Aires",
                        "latitude": "20.15333000",
                        "longitude": "-97.74833000"
                    },
                    {
                        "id": 68712,
                        "name": "Cacaloxúchitl",
                        "latitude": "18.78747000",
                        "longitude": "-98.48614000"
                    },
                    {
                        "id": 68724,
                        "name": "Cala Norte",
                        "latitude": "19.84778000",
                        "longitude": "-97.42306000"
                    },
                    {
                        "id": 68725,
                        "name": "Cala Sur",
                        "latitude": "19.83278000",
                        "longitude": "-97.42111000"
                    },
                    {
                        "id": 68739,
                        "name": "Calipan",
                        "latitude": "18.29519000",
                        "longitude": "-97.16376000"
                    },
                    {
                        "id": 68743,
                        "name": "Calmeca",
                        "latitude": "18.63501000",
                        "longitude": "-98.63414000"
                    },
                    {
                        "id": 68746,
                        "name": "Calpanería Atezquilla",
                        "latitude": "19.65556000",
                        "longitude": "-97.99528000"
                    },
                    {
                        "id": 68765,
                        "name": "Camocuautla",
                        "latitude": "20.03805000",
                        "longitude": "-97.75853000"
                    },
                    {
                        "id": 68766,
                        "name": "Camotepec",
                        "latitude": "20.04720000",
                        "longitude": "-98.06825000"
                    },
                    {
                        "id": 68791,
                        "name": "Candelaria Portezuelo",
                        "latitude": "19.04194000",
                        "longitude": "-97.70083000"
                    },
                    {
                        "id": 68828,
                        "name": "Carmen Serdán",
                        "latitude": "19.03639000",
                        "longitude": "-97.81194000"
                    },
                    {
                        "id": 68846,
                        "name": "Casa Blanca",
                        "latitude": "19.04222000",
                        "longitude": "-98.11889000"
                    },
                    {
                        "id": 68868,
                        "name": "Caxhuacán",
                        "latitude": "20.06359000",
                        "longitude": "-97.60688000"
                    },
                    {
                        "id": 68958,
                        "name": "Chalchihuapan",
                        "latitude": "18.97183000",
                        "longitude": "-98.33698000"
                    },
                    {
                        "id": 68986,
                        "name": "Chapulco",
                        "latitude": "18.62586000",
                        "longitude": "-97.40474000"
                    },
                    {
                        "id": 69014,
                        "name": "Chiautla de Tapia",
                        "latitude": "18.30149000",
                        "longitude": "-98.60339000"
                    },
                    {
                        "id": 69016,
                        "name": "Chicahuaxtla",
                        "latitude": "20.14250000",
                        "longitude": "-97.94556000"
                    },
                    {
                        "id": 69022,
                        "name": "Chichicapa",
                        "latitude": "18.40056000",
                        "longitude": "-97.04694000"
                    },
                    {
                        "id": 69025,
                        "name": "Chichicuautla",
                        "latitude": "19.39073000",
                        "longitude": "-97.39394000"
                    },
                    {
                        "id": 69032,
                        "name": "Chichiquila",
                        "latitude": "19.20073000",
                        "longitude": "-97.06691000"
                    },
                    {
                        "id": 69042,
                        "name": "Chiconcuautla",
                        "latitude": "20.09517000",
                        "longitude": "-97.93896000"
                    },
                    {
                        "id": 69045,
                        "name": "Chicontla",
                        "latitude": "20.24402000",
                        "longitude": "-97.83063000"
                    },
                    {
                        "id": 69052,
                        "name": "Chietla",
                        "latitude": "18.52028000",
                        "longitude": "-98.57889000"
                    },
                    {
                        "id": 69053,
                        "name": "Chigmecatitlán",
                        "latitude": "18.64634000",
                        "longitude": "-98.07203000"
                    },
                    {
                        "id": 69054,
                        "name": "Chignahuapan",
                        "latitude": "19.83866000",
                        "longitude": "-98.03171000"
                    },
                    {
                        "id": 69059,
                        "name": "Chila",
                        "latitude": "17.96747000",
                        "longitude": "-97.87478000"
                    },
                    {
                        "id": 69060,
                        "name": "Chila de Juárez",
                        "latitude": "20.28113000",
                        "longitude": "-98.20937000"
                    },
                    {
                        "id": 69061,
                        "name": "Chila de la Sal",
                        "latitude": "18.10975000",
                        "longitude": "-98.48574000"
                    },
                    {
                        "id": 69068,
                        "name": "Chilchotla",
                        "latitude": "19.26916000",
                        "longitude": "-97.19916000"
                    },
                    {
                        "id": 69084,
                        "name": "Chinantla",
                        "latitude": "18.23423000",
                        "longitude": "-98.27627000"
                    },
                    {
                        "id": 69085,
                        "name": "Chinautla",
                        "latitude": "19.81996000",
                        "longitude": "-97.38859000"
                    },
                    {
                        "id": 69088,
                        "name": "Chipahuatlán",
                        "latitude": "20.06111000",
                        "longitude": "-97.68861000"
                    },
                    {
                        "id": 69089,
                        "name": "Chipilo de Francisco Javier Mina",
                        "latitude": "19.00611000",
                        "longitude": "-98.33056000"
                    },
                    {
                        "id": 69103,
                        "name": "Cholula",
                        "latitude": "19.06406000",
                        "longitude": "-98.30352000"
                    },
                    {
                        "id": 69135,
                        "name": "Cinco de Mayo",
                        "latitude": "20.13167000",
                        "longitude": "-97.63000000"
                    },
                    {
                        "id": 69187,
                        "name": "Ciudad de Chiautla de Tapia",
                        "latitude": "18.30000000",
                        "longitude": "-98.60389000"
                    },
                    {
                        "id": 69188,
                        "name": "Ciudad de Cuetzalan",
                        "latitude": "20.01861000",
                        "longitude": "-97.52111000"
                    },
                    {
                        "id": 69192,
                        "name": "Ciudad de Tlatlauquitepec",
                        "latitude": "19.85278000",
                        "longitude": "-97.49528000"
                    },
                    {
                        "id": 69181,
                        "name": "Ciudad Serdán",
                        "latitude": "18.98856000",
                        "longitude": "-97.44643000"
                    },
                    {
                        "id": 69217,
                        "name": "Coahuixco",
                        "latitude": "19.80556000",
                        "longitude": "-97.41028000"
                    },
                    {
                        "id": 69226,
                        "name": "Coatepec",
                        "latitude": "20.06236000",
                        "longitude": "-97.73069000"
                    },
                    {
                        "id": 69232,
                        "name": "Coatzingo",
                        "latitude": "18.61199000",
                        "longitude": "-98.17267000"
                    },
                    {
                        "id": 69252,
                        "name": "Cohuecán",
                        "latitude": "18.78268000",
                        "longitude": "-98.72085000"
                    },
                    {
                        "id": 69276,
                        "name": "Colonia Agrícola de Ocotepec (Colonia San José)",
                        "latitude": "18.92972000",
                        "longitude": "-98.54444000"
                    },
                    {
                        "id": 69344,
                        "name": "Colonia Obrera",
                        "latitude": "19.22944000",
                        "longitude": "-97.79750000"
                    },
                    {
                        "id": 69413,
                        "name": "Colucan",
                        "latitude": "18.50905000",
                        "longitude": "-98.48078000"
                    },
                    {
                        "id": 69420,
                        "name": "Comaltepec",
                        "latitude": "19.85893000",
                        "longitude": "-97.59938000"
                    },
                    {
                        "id": 69433,
                        "name": "Concepción Capulac (La Ex-Hacienda)",
                        "latitude": "19.09444000",
                        "longitude": "-98.06139000"
                    },
                    {
                        "id": 69436,
                        "name": "Concepción Cuautla",
                        "latitude": "18.86722000",
                        "longitude": "-97.98475000"
                    },
                    {
                        "id": 69473,
                        "name": "Copila",
                        "latitude": "20.27300000",
                        "longitude": "-98.08294000"
                    },
                    {
                        "id": 69480,
                        "name": "Coronango",
                        "latitude": "19.12090000",
                        "longitude": "-98.30594000"
                    },
                    {
                        "id": 69481,
                        "name": "Coronel Tito Hernández",
                        "latitude": "20.45642000",
                        "longitude": "-97.73607000"
                    },
                    {
                        "id": 69511,
                        "name": "Coxcatlán",
                        "latitude": "18.26709000",
                        "longitude": "-97.15078000"
                    },
                    {
                        "id": 69512,
                        "name": "Coxolico",
                        "latitude": "18.45104000",
                        "longitude": "-97.02991000"
                    },
                    {
                        "id": 69519,
                        "name": "Coyomeapan",
                        "latitude": "18.28206000",
                        "longitude": "-96.99336000"
                    },
                    {
                        "id": 69522,
                        "name": "Coyotepec",
                        "latitude": "18.41656000",
                        "longitude": "-97.82703000"
                    },
                    {
                        "id": 69549,
                        "name": "Cuacnopalan",
                        "latitude": "18.81758000",
                        "longitude": "-97.51116000"
                    },
                    {
                        "id": 69550,
                        "name": "Cuacuila",
                        "latitude": "20.17205000",
                        "longitude": "-98.03150000"
                    },
                    {
                        "id": 69559,
                        "name": "Cuanalá",
                        "latitude": "19.10917000",
                        "longitude": "-98.32788000"
                    },
                    {
                        "id": 69562,
                        "name": "Cuapiaxtla de Madero",
                        "latitude": "18.91544000",
                        "longitude": "-97.82382000"
                    },
                    {
                        "id": 69569,
                        "name": "Cuatro Caminos",
                        "latitude": "18.49130000",
                        "longitude": "-97.12901000"
                    },
                    {
                        "id": 69573,
                        "name": "Cuauhtamazaco",
                        "latitude": "20.02500000",
                        "longitude": "-97.48722000"
                    },
                    {
                        "id": 69584,
                        "name": "Cuauhtémoc",
                        "latitude": "19.22306000",
                        "longitude": "-97.33833000"
                    },
                    {
                        "id": 69586,
                        "name": "Cuautempan",
                        "latitude": "19.91612000",
                        "longitude": "-97.79097000"
                    },
                    {
                        "id": 69589,
                        "name": "Cuautinchán",
                        "latitude": "18.95463000",
                        "longitude": "-98.01566000"
                    },
                    {
                        "id": 69593,
                        "name": "Cuautlancingo",
                        "latitude": "19.08995000",
                        "longitude": "-98.27319000"
                    },
                    {
                        "id": 69595,
                        "name": "Cuautotola",
                        "latitude": "20.06841000",
                        "longitude": "-97.79806000"
                    },
                    {
                        "id": 69596,
                        "name": "Cuautotolapan (San José)",
                        "latitude": "18.43299000",
                        "longitude": "-97.12091000"
                    },
                    {
                        "id": 69598,
                        "name": "Cuaxoxpan",
                        "latitude": "19.80806000",
                        "longitude": "-97.34583000"
                    },
                    {
                        "id": 69599,
                        "name": "Cuaxuxpa",
                        "latitude": "18.46211000",
                        "longitude": "-97.03556000"
                    },
                    {
                        "id": 69600,
                        "name": "Cuayuca de Andrade",
                        "latitude": "18.44416000",
                        "longitude": "-98.19193000"
                    },
                    {
                        "id": 69618,
                        "name": "Cuesta Blanca",
                        "latitude": "18.84536000",
                        "longitude": "-97.46753000"
                    },
                    {
                        "id": 69622,
                        "name": "Cuetzalan",
                        "latitude": "20.01766000",
                        "longitude": "-97.52277000"
                    },
                    {
                        "id": 69623,
                        "name": "Cuetzalan del Progreso",
                        "latitude": "20.03857000",
                        "longitude": "-97.49268000"
                    },
                    {
                        "id": 69624,
                        "name": "Cuexpala",
                        "latitude": "18.62720000",
                        "longitude": "-98.55842000"
                    },
                    {
                        "id": 69652,
                        "name": "Cuyoaco",
                        "latitude": "19.60192000",
                        "longitude": "-97.62024000"
                    },
                    {
                        "id": 69705,
                        "name": "Dolores Hidalgo",
                        "latitude": "18.75697000",
                        "longitude": "-97.86062000"
                    },
                    {
                        "id": 69708,
                        "name": "Domingo Arenas",
                        "latitude": "19.13998000",
                        "longitude": "-98.45678000"
                    },
                    {
                        "id": 69862,
                        "name": "El Capulo (La Quebradora)",
                        "latitude": "18.94944000",
                        "longitude": "-98.26889000"
                    },
                    {
                        "id": 69874,
                        "name": "El Carmen",
                        "latitude": "19.24167000",
                        "longitude": "-97.20111000"
                    },
                    {
                        "id": 69897,
                        "name": "El Chacal",
                        "latitude": "20.22228000",
                        "longitude": "-97.46025000"
                    },
                    {
                        "id": 69953,
                        "name": "El Encanto del Cerril",
                        "latitude": "18.93194000",
                        "longitude": "-98.42556000"
                    },
                    {
                        "id": 69973,
                        "name": "El Fuerte de la Unión",
                        "latitude": "19.43077000",
                        "longitude": "-97.56064000"
                    },
                    {
                        "id": 70041,
                        "name": "El Mirador",
                        "latitude": "19.55694000",
                        "longitude": "-97.77194000"
                    },
                    {
                        "id": 70047,
                        "name": "El Molino",
                        "latitude": "19.81333000",
                        "longitude": "-97.58028000"
                    },
                    {
                        "id": 70080,
                        "name": "El Palmar",
                        "latitude": "19.13972000",
                        "longitude": "-97.05306000"
                    },
                    {
                        "id": 70132,
                        "name": "El Progreso",
                        "latitude": "20.01917000",
                        "longitude": "-97.36472000"
                    },
                    {
                        "id": 70162,
                        "name": "El Rincón Citlaltépetl",
                        "latitude": "19.15556000",
                        "longitude": "-97.89444000"
                    },
                    {
                        "id": 70251,
                        "name": "El Veladero",
                        "latitude": "18.96421000",
                        "longitude": "-97.48289000"
                    },
                    {
                        "id": 70273,
                        "name": "Eloxochitlán",
                        "latitude": "18.50883000",
                        "longitude": "-96.92271000"
                    },
                    {
                        "id": 70275,
                        "name": "Emancipación Quetzalapa",
                        "latitude": "19.17333000",
                        "longitude": "-97.39203000"
                    },
                    {
                        "id": 70295,
                        "name": "Emilio Carranza (Santa Cruz)",
                        "latitude": "19.71278000",
                        "longitude": "-97.65278000"
                    },
                    {
                        "id": 70296,
                        "name": "Emilio Portes Gil",
                        "latitude": "19.30751000",
                        "longitude": "-97.51027000"
                    },
                    {
                        "id": 70327,
                        "name": "Esperanza",
                        "latitude": "18.85853000",
                        "longitude": "-97.37641000"
                    },
                    {
                        "id": 70466,
                        "name": "Francisco I. Madero",
                        "latitude": "19.24985000",
                        "longitude": "-97.22648000"
                    },
                    {
                        "id": 70471,
                        "name": "Francisco Ignacio Madero",
                        "latitude": "18.49306000",
                        "longitude": "-97.46384000"
                    },
                    {
                        "id": 70476,
                        "name": "Francisco Sarabia",
                        "latitude": "18.96417000",
                        "longitude": "-98.31389000"
                    },
                    {
                        "id": 70482,
                        "name": "Francisco Villa",
                        "latitude": "18.84446000",
                        "longitude": "-97.76336000"
                    },
                    {
                        "id": 70483,
                        "name": "Francisco Z. Mena",
                        "latitude": "20.72614000",
                        "longitude": "-97.81882000"
                    },
                    {
                        "id": 70506,
                        "name": "Galaxia la Calera",
                        "latitude": "18.99900000",
                        "longitude": "-98.15250000"
                    },
                    {
                        "id": 70531,
                        "name": "General Felipe Ángeles",
                        "latitude": "19.00786000",
                        "longitude": "-97.68282000"
                    },
                    {
                        "id": 70548,
                        "name": "Gilberto Camacho",
                        "latitude": "20.37365000",
                        "longitude": "-97.88546000"
                    },
                    {
                        "id": 70647,
                        "name": "Gómez Poniente",
                        "latitude": "19.77250000",
                        "longitude": "-97.48694000"
                    },
                    {
                        "id": 70556,
                        "name": "González Ortega",
                        "latitude": "19.34268000",
                        "longitude": "-97.27023000"
                    },
                    {
                        "id": 70559,
                        "name": "Grajales",
                        "latitude": "19.22796000",
                        "longitude": "-97.80307000"
                    },
                    {
                        "id": 70576,
                        "name": "Guadalupe",
                        "latitude": "18.06521000",
                        "longitude": "-98.14673000"
                    },
                    {
                        "id": 70579,
                        "name": "Guadalupe Calderón",
                        "latitude": "18.96611000",
                        "longitude": "-97.85833000"
                    },
                    {
                        "id": 70581,
                        "name": "Guadalupe Enríquez",
                        "latitude": "18.89374000",
                        "longitude": "-97.58759000"
                    },
                    {
                        "id": 70586,
                        "name": "Guadalupe Libertad",
                        "latitude": "19.18789000",
                        "longitude": "-97.38744000"
                    },
                    {
                        "id": 70588,
                        "name": "Guadalupe Morelos",
                        "latitude": "19.02556000",
                        "longitude": "-97.80417000"
                    },
                    {
                        "id": 70589,
                        "name": "Guadalupe Santa Ana",
                        "latitude": "18.09140000",
                        "longitude": "-98.12079000"
                    },
                    {
                        "id": 70590,
                        "name": "Guadalupe Sarabia",
                        "latitude": "19.53096000",
                        "longitude": "-97.42752000"
                    },
                    {
                        "id": 70598,
                        "name": "Guadalupe Victoria",
                        "latitude": "19.29110000",
                        "longitude": "-97.34290000"
                    },
                    {
                        "id": 70607,
                        "name": "Guadalupe Zaragoza",
                        "latitude": "19.35833000",
                        "longitude": "-98.53750000"
                    },
                    {
                        "id": 70668,
                        "name": "Hermenegildo Galeana",
                        "latitude": "18.25667000",
                        "longitude": "-98.10222000"
                    },
                    {
                        "id": 70706,
                        "name": "Honey",
                        "latitude": "20.25454000",
                        "longitude": "-98.23090000"
                    },
                    {
                        "id": 70715,
                        "name": "Huachinantla",
                        "latitude": "18.28175000",
                        "longitude": "-98.96796000"
                    },
                    {
                        "id": 70717,
                        "name": "Huahuaxtla",
                        "latitude": "19.91627000",
                        "longitude": "-97.63717000"
                    },
                    {
                        "id": 70722,
                        "name": "Huajoyuca",
                        "latitude": "18.51240000",
                        "longitude": "-97.93737000"
                    },
                    {
                        "id": 70738,
                        "name": "Huaquechula",
                        "latitude": "18.77116000",
                        "longitude": "-98.54460000"
                    },
                    {
                        "id": 70742,
                        "name": "Huatlatlauca",
                        "latitude": "18.69189000",
                        "longitude": "-98.03819000"
                    },
                    {
                        "id": 70744,
                        "name": "Huauchinango",
                        "latitude": "20.17376000",
                        "longitude": "-98.05491000"
                    },
                    {
                        "id": 70747,
                        "name": "Huautla de Jiménez",
                        "latitude": "18.13150000",
                        "longitude": "-96.84088000"
                    },
                    {
                        "id": 70748,
                        "name": "Huaxcaleca",
                        "latitude": "19.23401000",
                        "longitude": "-97.07696000"
                    },
                    {
                        "id": 70758,
                        "name": "Huehuetla",
                        "latitude": "20.10391000",
                        "longitude": "-97.62507000"
                    },
                    {
                        "id": 70759,
                        "name": "Huehuetlan el Chico",
                        "latitude": "18.37347000",
                        "longitude": "-98.69002000"
                    },
                    {
                        "id": 70760,
                        "name": "Huehuetlán el Grande",
                        "latitude": "18.74693000",
                        "longitude": "-98.15770000"
                    },
                    {
                        "id": 70764,
                        "name": "Huejonapan",
                        "latitude": "18.46971000",
                        "longitude": "-97.92149000"
                    },
                    {
                        "id": 70766,
                        "name": "Huejotzingo",
                        "latitude": "19.15892000",
                        "longitude": "-98.40824000"
                    },
                    {
                        "id": 70775,
                        "name": "Hueyapan",
                        "latitude": "19.91856000",
                        "longitude": "-97.41023000"
                    },
                    {
                        "id": 70780,
                        "name": "Hueyotlipan",
                        "latitude": "18.89148000",
                        "longitude": "-97.86575000"
                    },
                    {
                        "id": 70783,
                        "name": "Hueytamalco",
                        "latitude": "19.94029000",
                        "longitude": "-97.28848000"
                    },
                    {
                        "id": 70785,
                        "name": "Hueytlalpan",
                        "latitude": "20.02707000",
                        "longitude": "-97.69694000"
                    },
                    {
                        "id": 70790,
                        "name": "Huilacapixtla",
                        "latitude": "20.21232000",
                        "longitude": "-98.08185000"
                    },
                    {
                        "id": 70807,
                        "name": "Huitzilac",
                        "latitude": "20.60669000",
                        "longitude": "-97.74207000"
                    },
                    {
                        "id": 70808,
                        "name": "Huitzilan",
                        "latitude": "19.96750000",
                        "longitude": "-97.69441000"
                    },
                    {
                        "id": 70811,
                        "name": "Huitziltepec",
                        "latitude": "18.76693000",
                        "longitude": "-97.85963000"
                    },
                    {
                        "id": 70813,
                        "name": "Huitzmaloc",
                        "latitude": "18.45639000",
                        "longitude": "-96.94056000"
                    },
                    {
                        "id": 70816,
                        "name": "Huixcolotla",
                        "latitude": "18.92073000",
                        "longitude": "-97.77166000"
                    },
                    {
                        "id": 70834,
                        "name": "Icxotitla",
                        "latitude": "20.24253000",
                        "longitude": "-98.10069000"
                    },
                    {
                        "id": 70839,
                        "name": "Ignacio Allende (Concepción)",
                        "latitude": "20.01055000",
                        "longitude": "-97.63448000"
                    },
                    {
                        "id": 70843,
                        "name": "Ignacio Manuel Altamirano",
                        "latitude": "19.36722000",
                        "longitude": "-98.58306000"
                    },
                    {
                        "id": 70856,
                        "name": "Ignacio Zaragoza",
                        "latitude": "19.27889000",
                        "longitude": "-97.19944000"
                    },
                    {
                        "id": 70896,
                        "name": "Itzoteno",
                        "latitude": "19.41656000",
                        "longitude": "-97.43776000"
                    },
                    {
                        "id": 70898,
                        "name": "Ixcamilpa de Guerrero",
                        "latitude": "18.03036000",
                        "longitude": "-98.71770000"
                    },
                    {
                        "id": 70901,
                        "name": "Ixcaquixtla",
                        "latitude": "18.47131000",
                        "longitude": "-97.84214000"
                    },
                    {
                        "id": 70921,
                        "name": "Ixtacamaxtitlán",
                        "latitude": "19.62352000",
                        "longitude": "-97.81539000"
                    },
                    {
                        "id": 70925,
                        "name": "Ixtahuiata (La Legua)",
                        "latitude": "19.84389000",
                        "longitude": "-97.33556000"
                    },
                    {
                        "id": 70935,
                        "name": "Ixtepec",
                        "latitude": "20.03936000",
                        "longitude": "-97.64262000"
                    },
                    {
                        "id": 70936,
                        "name": "Ixticpan",
                        "latitude": "19.81419000",
                        "longitude": "-97.34454000"
                    },
                    {
                        "id": 70938,
                        "name": "Ixtlahuaca",
                        "latitude": "19.82309000",
                        "longitude": "-97.33496000"
                    },
                    {
                        "id": 70939,
                        "name": "Ixtlahuaca Barrio",
                        "latitude": "19.83889000",
                        "longitude": "-98.01444000"
                    },
                    {
                        "id": 70947,
                        "name": "Ixtolco de Morelos",
                        "latitude": "19.90553000",
                        "longitude": "-97.81762000"
                    },
                    {
                        "id": 70953,
                        "name": "Izúcar de Matamoros",
                        "latitude": "18.60157000",
                        "longitude": "-98.46152000"
                    },
                    {
                        "id": 70980,
                        "name": "Jalpan",
                        "latitude": "20.44324000",
                        "longitude": "-97.85610000"
                    },
                    {
                        "id": 70991,
                        "name": "Jaltocan",
                        "latitude": "20.61968000",
                        "longitude": "-97.81787000"
                    },
                    {
                        "id": 71034,
                        "name": "Jesús Nazareno",
                        "latitude": "18.87667000",
                        "longitude": "-97.62306000"
                    },
                    {
                        "id": 71043,
                        "name": "Jicolapa",
                        "latitude": "19.96596000",
                        "longitude": "-97.97345000"
                    },
                    {
                        "id": 71047,
                        "name": "Jilotzingo",
                        "latitude": "20.03250000",
                        "longitude": "-97.90250000"
                    },
                    {
                        "id": 71070,
                        "name": "Jolalpan",
                        "latitude": "18.32495000",
                        "longitude": "-98.84489000"
                    },
                    {
                        "id": 71080,
                        "name": "Jonotla",
                        "latitude": "20.03032000",
                        "longitude": "-97.57530000"
                    },
                    {
                        "id": 71082,
                        "name": "Jopala",
                        "latitude": "20.16353000",
                        "longitude": "-97.69285000"
                    },
                    {
                        "id": 71099,
                        "name": "José María Morelos",
                        "latitude": "19.14147000",
                        "longitude": "-97.46809000"
                    },
                    {
                        "id": 71115,
                        "name": "Juan C. Bonilla",
                        "latitude": "19.12101000",
                        "longitude": "-98.34091000"
                    },
                    {
                        "id": 71128,
                        "name": "Juan de la Granja",
                        "latitude": "19.22118000",
                        "longitude": "-97.80884000"
                    },
                    {
                        "id": 71119,
                        "name": "Juan Galindo",
                        "latitude": "20.21980000",
                        "longitude": "-97.99083000"
                    },
                    {
                        "id": 71125,
                        "name": "Juan N. Méndez",
                        "latitude": "18.52411000",
                        "longitude": "-97.74829000"
                    },
                    {
                        "id": 71147,
                        "name": "Juárez Coronaco",
                        "latitude": "19.36056000",
                        "longitude": "-98.52500000"
                    },
                    {
                        "id": 71205,
                        "name": "La Cañada",
                        "latitude": "19.49898000",
                        "longitude": "-97.73400000"
                    },
                    {
                        "id": 71223,
                        "name": "La Compañia",
                        "latitude": "18.97080000",
                        "longitude": "-97.72280000"
                    },
                    {
                        "id": 71298,
                        "name": "La Galarza",
                        "latitude": "18.66778000",
                        "longitude": "-98.45528000"
                    },
                    {
                        "id": 71301,
                        "name": "La Gloria",
                        "latitude": "19.39561000",
                        "longitude": "-97.28246000"
                    },
                    {
                        "id": 71346,
                        "name": "La Laguna",
                        "latitude": "18.79944000",
                        "longitude": "-97.73667000"
                    },
                    {
                        "id": 71357,
                        "name": "La Libertad",
                        "latitude": "19.75583000",
                        "longitude": "-97.60722000"
                    },
                    {
                        "id": 71380,
                        "name": "La Magdalena",
                        "latitude": "20.25698000",
                        "longitude": "-98.27534000"
                    },
                    {
                        "id": 71384,
                        "name": "La Magdalena Tetela Morelos",
                        "latitude": "19.04922000",
                        "longitude": "-97.94131000"
                    },
                    {
                        "id": 71386,
                        "name": "La Magdalena Yancuitlalpan",
                        "latitude": "18.91083000",
                        "longitude": "-98.58944000"
                    },
                    {
                        "id": 71416,
                        "name": "La Pahua",
                        "latitude": "20.61181000",
                        "longitude": "-97.85358000"
                    },
                    {
                        "id": 71469,
                        "name": "La Purísima",
                        "latitude": "18.82974000",
                        "longitude": "-97.57301000"
                    },
                    {
                        "id": 71476,
                        "name": "La Resurrección",
                        "latitude": "19.10279000",
                        "longitude": "-98.13013000"
                    },
                    {
                        "id": 71493,
                        "name": "La Soledad",
                        "latitude": "18.81000000",
                        "longitude": "-97.76417000"
                    },
                    {
                        "id": 71512,
                        "name": "La Trinidad Chautenco",
                        "latitude": "19.09000000",
                        "longitude": "-98.26389000"
                    },
                    {
                        "id": 71515,
                        "name": "La Trinidad Tianguismanalco",
                        "latitude": "18.89417000",
                        "longitude": "-98.03250000"
                    },
                    {
                        "id": 71520,
                        "name": "La Unión",
                        "latitude": "20.26181000",
                        "longitude": "-97.87135000"
                    },
                    {
                        "id": 71524,
                        "name": "La Unión Ejido Mexcaltepec",
                        "latitude": "19.60806000",
                        "longitude": "-97.71056000"
                    },
                    {
                        "id": 71541,
                        "name": "Lacapan Camallagne",
                        "latitude": "20.12862000",
                        "longitude": "-97.65343000"
                    },
                    {
                        "id": 71545,
                        "name": "Lafragua",
                        "latitude": "19.30684000",
                        "longitude": "-97.29748000"
                    },
                    {
                        "id": 71589,
                        "name": "Las Colonias de Hidalgo",
                        "latitude": "20.19611000",
                        "longitude": "-97.97667000"
                    },
                    {
                        "id": 71607,
                        "name": "Las Lajas",
                        "latitude": "19.99831000",
                        "longitude": "-98.07332000"
                    },
                    {
                        "id": 71611,
                        "name": "Las Lomas",
                        "latitude": "19.82390000",
                        "longitude": "-97.61227000"
                    },
                    {
                        "id": 71626,
                        "name": "Las Nieves",
                        "latitude": "18.18361000",
                        "longitude": "-98.04611000"
                    },
                    {
                        "id": 71894,
                        "name": "Lázaro Cárdenas",
                        "latitude": "19.14306000",
                        "longitude": "-97.40056000"
                    },
                    {
                        "id": 71658,
                        "name": "Leacaman",
                        "latitude": "20.09861000",
                        "longitude": "-97.64306000"
                    },
                    {
                        "id": 71672,
                        "name": "Libertad Álvaro Obregón",
                        "latitude": "19.13452000",
                        "longitude": "-97.76728000"
                    },
                    {
                        "id": 71674,
                        "name": "Libres",
                        "latitude": "19.46574000",
                        "longitude": "-97.68737000"
                    },
                    {
                        "id": 71682,
                        "name": "Lipuntahuaca",
                        "latitude": "20.09119000",
                        "longitude": "-97.63026000"
                    },
                    {
                        "id": 71709,
                        "name": "Loma Alta",
                        "latitude": "19.79716000",
                        "longitude": "-98.02712000"
                    },
                    {
                        "id": 71717,
                        "name": "Loma Bonita",
                        "latitude": "18.51333000",
                        "longitude": "-96.86778000"
                    },
                    {
                        "id": 71747,
                        "name": "Lomas de Romero",
                        "latitude": "18.91444000",
                        "longitude": "-97.71722000"
                    },
                    {
                        "id": 71754,
                        "name": "Lomas de Santa Cruz",
                        "latitude": "18.92444000",
                        "longitude": "-97.73000000"
                    },
                    {
                        "id": 71872,
                        "name": "Los Ángeles Tetela",
                        "latitude": "18.88995000",
                        "longitude": "-98.16712000"
                    },
                    {
                        "id": 71794,
                        "name": "Los Cristales (Talican)",
                        "latitude": "19.87237000",
                        "longitude": "-97.59424000"
                    },
                    {
                        "id": 71800,
                        "name": "Los Encinos",
                        "latitude": "19.17917000",
                        "longitude": "-98.39833000"
                    },
                    {
                        "id": 71803,
                        "name": "Los Garcías",
                        "latitude": "18.80333000",
                        "longitude": "-97.39417000"
                    },
                    {
                        "id": 71851,
                        "name": "Los Reyes de Juárez",
                        "latitude": "18.96457000",
                        "longitude": "-97.82541000"
                    },
                    {
                        "id": 71850,
                        "name": "Los Reyes Tlanechicolpan",
                        "latitude": "19.03250000",
                        "longitude": "-98.35250000"
                    },
                    {
                        "id": 71924,
                        "name": "Magdalena Cuayucatepec",
                        "latitude": "18.54972000",
                        "longitude": "-97.48472000"
                    },
                    {
                        "id": 71953,
                        "name": "Manantiales",
                        "latitude": "20.17316000",
                        "longitude": "-97.11064000"
                    },
                    {
                        "id": 71960,
                        "name": "Manuel Edgardo Ávalos (San Isidro)",
                        "latitude": "19.06778000",
                        "longitude": "-97.39194000"
                    },
                    {
                        "id": 72021,
                        "name": "Matlahuacales Aquiles Serdán",
                        "latitude": "19.76196000",
                        "longitude": "-98.05375000"
                    },
                    {
                        "id": 72022,
                        "name": "Matzaco",
                        "latitude": "18.55953000",
                        "longitude": "-98.48820000"
                    },
                    {
                        "id": 72259,
                        "name": "Máximo Serdán",
                        "latitude": "19.26298000",
                        "longitude": "-97.82825000"
                    },
                    {
                        "id": 72040,
                        "name": "Mazapiltepec",
                        "latitude": "19.11912000",
                        "longitude": "-97.70280000"
                    },
                    {
                        "id": 72042,
                        "name": "Mazatepec",
                        "latitude": "20.01695000",
                        "longitude": "-97.41891000"
                    },
                    {
                        "id": 72053,
                        "name": "Mecapalapa",
                        "latitude": "20.52684000",
                        "longitude": "-97.85643000"
                    },
                    {
                        "id": 72093,
                        "name": "Metlaltoyuca",
                        "latitude": "20.73556000",
                        "longitude": "-97.85194000"
                    },
                    {
                        "id": 72098,
                        "name": "Mexcalcuautla",
                        "latitude": "19.86657000",
                        "longitude": "-97.39154000"
                    },
                    {
                        "id": 72115,
                        "name": "Miahuatlán",
                        "latitude": "18.54983000",
                        "longitude": "-97.43953000"
                    },
                    {
                        "id": 72118,
                        "name": "Michac",
                        "latitude": "19.85241000",
                        "longitude": "-98.05127000"
                    },
                    {
                        "id": 72129,
                        "name": "Miguel Hidalgo",
                        "latitude": "19.75764000",
                        "longitude": "-97.28209000"
                    },
                    {
                        "id": 72134,
                        "name": "Miguel Negrete",
                        "latitude": "18.95222000",
                        "longitude": "-97.82917000"
                    },
                    {
                        "id": 72156,
                        "name": "Miravalles",
                        "latitude": "19.34130000",
                        "longitude": "-97.53854000"
                    },
                    {
                        "id": 72168,
                        "name": "Mixtla",
                        "latitude": "18.91153000",
                        "longitude": "-97.89786000"
                    },
                    {
                        "id": 72232,
                        "name": "Morelos",
                        "latitude": "19.75472000",
                        "longitude": "-97.57750000"
                    },
                    {
                        "id": 72234,
                        "name": "Morelos Cañada",
                        "latitude": "18.73549000",
                        "longitude": "-97.42068000"
                    },
                    {
                        "id": 72249,
                        "name": "Moyotzingo",
                        "latitude": "19.24811000",
                        "longitude": "-98.40486000"
                    },
                    {
                        "id": 72274,
                        "name": "Nanacatlán",
                        "latitude": "20.00366000",
                        "longitude": "-97.67584000"
                    },
                    {
                        "id": 72291,
                        "name": "Naupan",
                        "latitude": "20.23131000",
                        "longitude": "-98.10881000"
                    },
                    {
                        "id": 72293,
                        "name": "Nauzontla",
                        "latitude": "19.95952000",
                        "longitude": "-97.60314000"
                    },
                    {
                        "id": 72302,
                        "name": "Nealtican",
                        "latitude": "19.04990000",
                        "longitude": "-98.42720000"
                    },
                    {
                        "id": 72303,
                        "name": "Necaxa",
                        "latitude": "20.21271000",
                        "longitude": "-98.01188000"
                    },
                    {
                        "id": 72304,
                        "name": "Necoxcalco",
                        "latitude": "18.46092000",
                        "longitude": "-97.29827000"
                    },
                    {
                        "id": 72305,
                        "name": "Necoxtla",
                        "latitude": "18.39811000",
                        "longitude": "-97.35999000"
                    },
                    {
                        "id": 72310,
                        "name": "Nenehuaca",
                        "latitude": "19.14389000",
                        "longitude": "-97.04222000"
                    },
                    {
                        "id": 72315,
                        "name": "Nexpan",
                        "latitude": "19.88389000",
                        "longitude": "-97.42333000"
                    },
                    {
                        "id": 72316,
                        "name": "Nexticapan",
                        "latitude": "19.82722000",
                        "longitude": "-97.55417000"
                    },
                    {
                        "id": 72325,
                        "name": "Nicolás Bravo",
                        "latitude": "18.61983000",
                        "longitude": "-97.33230000"
                    },
                    {
                        "id": 72349,
                        "name": "Nopalucan",
                        "latitude": "19.20114000",
                        "longitude": "-97.82391000"
                    },
                    {
                        "id": 72397,
                        "name": "Nuevo México",
                        "latitude": "19.45492000",
                        "longitude": "-97.61757000"
                    },
                    {
                        "id": 72400,
                        "name": "Nuevo Necaxa",
                        "latitude": "20.21049000",
                        "longitude": "-98.00657000"
                    },
                    {
                        "id": 72453,
                        "name": "Ocotepec",
                        "latitude": "19.55519000",
                        "longitude": "-97.65078000"
                    },
                    {
                        "id": 72457,
                        "name": "Ocotlamanic",
                        "latitude": "18.32389000",
                        "longitude": "-97.09667000"
                    },
                    {
                        "id": 72459,
                        "name": "Ocotlán de Betancourt",
                        "latitude": "19.79752000",
                        "longitude": "-97.53664000"
                    },
                    {
                        "id": 72461,
                        "name": "Ocotlán de Venustiano Carranza",
                        "latitude": "18.79111000",
                        "longitude": "-97.66917000"
                    },
                    {
                        "id": 72502,
                        "name": "Olintla",
                        "latitude": "20.10196000",
                        "longitude": "-97.68427000"
                    },
                    {
                        "id": 72505,
                        "name": "Ometepec",
                        "latitude": "18.85439000",
                        "longitude": "-97.85350000"
                    },
                    {
                        "id": 72519,
                        "name": "Oriental",
                        "latitude": "19.37614000",
                        "longitude": "-97.62051000"
                    },
                    {
                        "id": 72556,
                        "name": "Oyameles de Hidalgo",
                        "latitude": "19.69736000",
                        "longitude": "-97.53376000"
                    },
                    {
                        "id": 72557,
                        "name": "Ozelonacaxtla",
                        "latitude": "20.04657000",
                        "longitude": "-97.61440000"
                    },
                    {
                        "id": 72576,
                        "name": "Pahuatlán de Valle",
                        "latitude": "20.27800000",
                        "longitude": "-98.14997000"
                    },
                    {
                        "id": 72591,
                        "name": "Palmar de Bravo",
                        "latitude": "18.83573000",
                        "longitude": "-97.54704000"
                    },
                    {
                        "id": 72593,
                        "name": "Palmarito Tochapan",
                        "latitude": "18.90135000",
                        "longitude": "-97.63833000"
                    },
                    {
                        "id": 72627,
                        "name": "Pantepec",
                        "latitude": "20.55146000",
                        "longitude": "-97.87453000"
                    },
                    {
                        "id": 72632,
                        "name": "Papaloctipan",
                        "latitude": "20.42429000",
                        "longitude": "-97.95535000"
                    },
                    {
                        "id": 72638,
                        "name": "Papatlazolco",
                        "latitude": "20.17750000",
                        "longitude": "-97.99167000"
                    },
                    {
                        "id": 72679,
                        "name": "Paso Carretas",
                        "latitude": "18.91993000",
                        "longitude": "-97.25153000"
                    },
                    {
                        "id": 72682,
                        "name": "Paso Nacional",
                        "latitude": "19.14385000",
                        "longitude": "-97.35769000"
                    },
                    {
                        "id": 72707,
                        "name": "Patla",
                        "latitude": "20.24821000",
                        "longitude": "-97.85295000"
                    },
                    {
                        "id": 72735,
                        "name": "Pericotepec",
                        "latitude": "18.60670000",
                        "longitude": "-97.63098000"
                    },
                    {
                        "id": 72745,
                        "name": "Petlalcingo",
                        "latitude": "18.08463000",
                        "longitude": "-97.91750000"
                    },
                    {
                        "id": 72747,
                        "name": "Pezmatlán",
                        "latitude": "19.84664000",
                        "longitude": "-97.48529000"
                    },
                    {
                        "id": 72756,
                        "name": "Piaxtla",
                        "latitude": "18.08403000",
                        "longitude": "-98.21988000"
                    },
                    {
                        "id": 72834,
                        "name": "Pochálcatl",
                        "latitude": "20.00295000",
                        "longitude": "-97.85408000"
                    },
                    {
                        "id": 72903,
                        "name": "Primero de Mayo",
                        "latitude": "19.08167000",
                        "longitude": "-98.09778000"
                    },
                    {
                        "id": 72912,
                        "name": "Progreso",
                        "latitude": "19.48833000",
                        "longitude": "-97.67722000"
                    },
                    {
                        "id": 72919,
                        "name": "Progreso de Juárez",
                        "latitude": "18.96167000",
                        "longitude": "-97.75556000"
                    },
                    {
                        "id": 72925,
                        "name": "Puebla",
                        "latitude": "19.03793000",
                        "longitude": "-98.20346000"
                    },
                    {
                        "id": 73003,
                        "name": "Putlunichuchut (Vista Hermosa)",
                        "latitude": "20.15593000",
                        "longitude": "-97.61557000"
                    },
                    {
                        "id": 73015,
                        "name": "Quamila",
                        "latitude": "20.16632000",
                        "longitude": "-97.91855000"
                    },
                    {
                        "id": 73017,
                        "name": "Quecholac",
                        "latitude": "18.95471000",
                        "longitude": "-97.65858000"
                    },
                    {
                        "id": 73018,
                        "name": "Quechulac",
                        "latitude": "19.37273000",
                        "longitude": "-97.34783000"
                    },
                    {
                        "id": 73044,
                        "name": "Rafael J. García",
                        "latitude": "19.25413000",
                        "longitude": "-97.18315000"
                    },
                    {
                        "id": 73059,
                        "name": "Rancho Chico",
                        "latitude": "18.74667000",
                        "longitude": "-97.66500000"
                    },
                    {
                        "id": 73066,
                        "name": "Rancho Nuevo",
                        "latitude": "18.58139000",
                        "longitude": "-97.22472000"
                    },
                    {
                        "id": 73107,
                        "name": "Ricardo Flores Magón",
                        "latitude": "20.19224000",
                        "longitude": "-97.61961000"
                    },
                    {
                        "id": 73136,
                        "name": "Rincón de los Reyes",
                        "latitude": "19.19444000",
                        "longitude": "-97.16056000"
                    },
                    {
                        "id": 73223,
                        "name": "Saltillo",
                        "latitude": "19.29644000",
                        "longitude": "-97.29661000"
                    },
                    {
                        "id": 73236,
                        "name": "San Acateno",
                        "latitude": "19.87527000",
                        "longitude": "-97.36686000"
                    },
                    {
                        "id": 73242,
                        "name": "San Agustín Atzompa",
                        "latitude": "19.20174000",
                        "longitude": "-98.51384000"
                    },
                    {
                        "id": 73249,
                        "name": "San Agustín Huixaxtla",
                        "latitude": "18.91778000",
                        "longitude": "-98.39694000"
                    },
                    {
                        "id": 73254,
                        "name": "San Agustín Tlaxco",
                        "latitude": "19.05630000",
                        "longitude": "-97.99158000"
                    },
                    {
                        "id": 73267,
                        "name": "San Andrés",
                        "latitude": "19.79000000",
                        "longitude": "-97.33889000"
                    },
                    {
                        "id": 73270,
                        "name": "San Andrés Azumiatla",
                        "latitude": "18.90417000",
                        "longitude": "-98.25278000"
                    },
                    {
                        "id": 73271,
                        "name": "San Andrés Cacaloapan",
                        "latitude": "18.58364000",
                        "longitude": "-97.58711000"
                    },
                    {
                        "id": 73272,
                        "name": "San Andrés Calpan",
                        "latitude": "19.10356000",
                        "longitude": "-98.46188000"
                    },
                    {
                        "id": 73274,
                        "name": "San Andrés Cholula",
                        "latitude": "19.05144000",
                        "longitude": "-98.29526000"
                    },
                    {
                        "id": 73283,
                        "name": "San Andrés Hueyacatitla",
                        "latitude": "19.25600000",
                        "longitude": "-98.53628000"
                    },
                    {
                        "id": 73291,
                        "name": "San Andrés Payuca",
                        "latitude": "19.52563000",
                        "longitude": "-97.61782000"
                    },
                    {
                        "id": 73301,
                        "name": "San Andrés Yahuitlalpan",
                        "latitude": "19.67333000",
                        "longitude": "-97.72694000"
                    },
                    {
                        "id": 73318,
                        "name": "San Antonio",
                        "latitude": "19.75611000",
                        "longitude": "-97.35694000"
                    },
                    {
                        "id": 73320,
                        "name": "San Antonio Alpanocan",
                        "latitude": "18.87722000",
                        "longitude": "-98.71083000"
                    },
                    {
                        "id": 73322,
                        "name": "San Antonio Atotonilco",
                        "latitude": "19.37466000",
                        "longitude": "-98.46584000"
                    },
                    {
                        "id": 73328,
                        "name": "San Antonio Cañada",
                        "latitude": "18.51604000",
                        "longitude": "-97.29412000"
                    },
                    {
                        "id": 73337,
                        "name": "San Antonio Juárez",
                        "latitude": "18.79379000",
                        "longitude": "-97.98964000"
                    },
                    {
                        "id": 73390,
                        "name": "San Antonio la Portilla",
                        "latitude": "18.79611000",
                        "longitude": "-97.76278000"
                    },
                    {
                        "id": 73338,
                        "name": "San Antonio Matlahuacales",
                        "latitude": "19.75528000",
                        "longitude": "-98.08194000"
                    },
                    {
                        "id": 73339,
                        "name": "San Antonio Mihuacán",
                        "latitude": "19.15333000",
                        "longitude": "-98.30472000"
                    },
                    {
                        "id": 73342,
                        "name": "San Antonio Ocopetlatlán",
                        "latitude": "20.24703000",
                        "longitude": "-97.94621000"
                    },
                    {
                        "id": 73344,
                        "name": "San Antonio Portezuelo",
                        "latitude": "18.99889000",
                        "longitude": "-97.71361000"
                    },
                    {
                        "id": 73348,
                        "name": "San Antonio Soledad",
                        "latitude": "18.78414000",
                        "longitude": "-97.40738000"
                    },
                    {
                        "id": 73351,
                        "name": "San Antonio Tecolco",
                        "latitude": "18.85222000",
                        "longitude": "-97.77806000"
                    },
                    {
                        "id": 73356,
                        "name": "San Antonio Tlacamilco",
                        "latitude": "19.06271000",
                        "longitude": "-97.93024000"
                    },
                    {
                        "id": 73358,
                        "name": "San Antonio Tlatenco",
                        "latitude": "19.17339000",
                        "longitude": "-98.49996000"
                    },
                    {
                        "id": 73360,
                        "name": "San Antonio Virreyes",
                        "latitude": "19.40989000",
                        "longitude": "-97.63697000"
                    },
                    {
                        "id": 73393,
                        "name": "San Baltazar Atlimeyaya",
                        "latitude": "18.98694000",
                        "longitude": "-98.48111000"
                    },
                    {
                        "id": 73417,
                        "name": "San Bartolomé",
                        "latitude": "18.91765000",
                        "longitude": "-97.61912000"
                    },
                    {
                        "id": 73424,
                        "name": "San Bartolomé Hueyapan",
                        "latitude": "19.02528000",
                        "longitude": "-97.93056000"
                    },
                    {
                        "id": 73432,
                        "name": "San Bernabé Temoxtitla",
                        "latitude": "18.99722000",
                        "longitude": "-98.33083000"
                    },
                    {
                        "id": 73435,
                        "name": "San Bernardino Lagunas",
                        "latitude": "18.60374000",
                        "longitude": "-97.26566000"
                    },
                    {
                        "id": 73436,
                        "name": "San Bernardino Tlaxcalancingo",
                        "latitude": "19.02867000",
                        "longitude": "-98.27698000"
                    },
                    {
                        "id": 73449,
                        "name": "San Buenaventura",
                        "latitude": "18.90204000",
                        "longitude": "-97.92616000"
                    },
                    {
                        "id": 73454,
                        "name": "San Buenaventura Tecaltzingo",
                        "latitude": "19.24778000",
                        "longitude": "-98.46056000"
                    },
                    {
                        "id": 73457,
                        "name": "San Carlos",
                        "latitude": "19.43882000",
                        "longitude": "-97.69035000"
                    },
                    {
                        "id": 73478,
                        "name": "San Cristóbal Hidalgo",
                        "latitude": "19.02194000",
                        "longitude": "-97.81028000"
                    },
                    {
                        "id": 73484,
                        "name": "San Cristóbal los Nava",
                        "latitude": "18.99528000",
                        "longitude": "-97.83194000"
                    },
                    {
                        "id": 73482,
                        "name": "San Cristóbal Xochimilpa",
                        "latitude": "20.06639000",
                        "longitude": "-97.90750000"
                    },
                    {
                        "id": 73490,
                        "name": "San Diego",
                        "latitude": "19.85667000",
                        "longitude": "-97.36111000"
                    },
                    {
                        "id": 73498,
                        "name": "San Diego el Organal",
                        "latitude": "18.73083000",
                        "longitude": "-98.51667000"
                    },
                    {
                        "id": 73500,
                        "name": "San Diego la Mesa Tochimiltzingo",
                        "latitude": "18.79205000",
                        "longitude": "-98.31631000"
                    },
                    {
                        "id": 73516,
                        "name": "San Felipe Hidalgo",
                        "latitude": "19.46792000",
                        "longitude": "-98.55898000"
                    },
                    {
                        "id": 73519,
                        "name": "San Felipe Otlaltepec",
                        "latitude": "18.40152000",
                        "longitude": "-97.90786000"
                    },
                    {
                        "id": 73622,
                        "name": "San Félix Hidalgo",
                        "latitude": "18.89888000",
                        "longitude": "-98.39908000"
                    },
                    {
                        "id": 73623,
                        "name": "San Félix Rijo",
                        "latitude": "18.62028000",
                        "longitude": "-98.55028000"
                    },
                    {
                        "id": 73544,
                        "name": "San Francisco",
                        "latitude": "19.77722000",
                        "longitude": "-97.32806000"
                    },
                    {
                        "id": 73559,
                        "name": "San Francisco Cuapa",
                        "latitude": "19.06835000",
                        "longitude": "-98.36562000"
                    },
                    {
                        "id": 73560,
                        "name": "San Francisco Cuautlancingo",
                        "latitude": "18.99690000",
                        "longitude": "-97.41491000"
                    },
                    {
                        "id": 73566,
                        "name": "San Francisco Independencia (Santa María Aserradero)",
                        "latitude": "19.06889000",
                        "longitude": "-97.43028000"
                    },
                    {
                        "id": 73582,
                        "name": "San Francisco Ocotlán",
                        "latitude": "19.13411000",
                        "longitude": "-98.28345000"
                    },
                    {
                        "id": 73598,
                        "name": "San Francisco Tepeyecac",
                        "latitude": "19.24861000",
                        "longitude": "-98.43833000"
                    },
                    {
                        "id": 73603,
                        "name": "San Francisco Tláloc",
                        "latitude": "19.36972000",
                        "longitude": "-98.47722000"
                    },
                    {
                        "id": 73607,
                        "name": "San Francisco Zacapexpan",
                        "latitude": "19.88028000",
                        "longitude": "-97.59611000"
                    },
                    {
                        "id": 73627,
                        "name": "San Gabriel Chilac",
                        "latitude": "18.32596000",
                        "longitude": "-97.34697000"
                    },
                    {
                        "id": 73630,
                        "name": "San Gabriel Tetzoyocán",
                        "latitude": "18.75727000",
                        "longitude": "-97.70324000"
                    },
                    {
                        "id": 73642,
                        "name": "San Gregorio Atzompa",
                        "latitude": "19.02349000",
                        "longitude": "-98.34822000"
                    },
                    {
                        "id": 73643,
                        "name": "San Gregorio Aztotoacan",
                        "latitude": "19.26444000",
                        "longitude": "-98.49194000"
                    },
                    {
                        "id": 73645,
                        "name": "San Hipólito",
                        "latitude": "18.94069000",
                        "longitude": "-97.87322000"
                    },
                    {
                        "id": 73670,
                        "name": "San Isidro",
                        "latitude": "19.79639000",
                        "longitude": "-97.38361000"
                    },
                    {
                        "id": 73679,
                        "name": "San Isidro Huilotepec",
                        "latitude": "18.88083000",
                        "longitude": "-98.38306000"
                    },
                    {
                        "id": 73682,
                        "name": "San Isidro Monterrosas",
                        "latitude": "18.85667000",
                        "longitude": "-97.57528000"
                    },
                    {
                        "id": 73684,
                        "name": "San Isidro Vista Hermosa",
                        "latitude": "18.50556000",
                        "longitude": "-97.40028000"
                    },
                    {
                        "id": 73702,
                        "name": "San Jerónimo Almoloya",
                        "latitude": "18.94111000",
                        "longitude": "-98.01056000"
                    },
                    {
                        "id": 73704,
                        "name": "San Jerónimo Axochitlán",
                        "latitude": "18.27833000",
                        "longitude": "-97.26278000"
                    },
                    {
                        "id": 73707,
                        "name": "San Jerónimo Coaltepec",
                        "latitude": "20.00389000",
                        "longitude": "-97.86639000"
                    },
                    {
                        "id": 73709,
                        "name": "San Jerónimo Coyula",
                        "latitude": "18.89438000",
                        "longitude": "-98.51706000"
                    },
                    {
                        "id": 73712,
                        "name": "San Jerónimo Ocotitla",
                        "latitude": "19.03127000",
                        "longitude": "-97.96359000"
                    },
                    {
                        "id": 73721,
                        "name": "San Jerónimo Xayacatlán",
                        "latitude": "18.22034000",
                        "longitude": "-97.91288000"
                    },
                    {
                        "id": 73739,
                        "name": "San José",
                        "latitude": "19.80306000",
                        "longitude": "-97.33389000"
                    },
                    {
                        "id": 73740,
                        "name": "San José Acateno",
                        "latitude": "20.13067000",
                        "longitude": "-97.20997000"
                    },
                    {
                        "id": 73741,
                        "name": "San José Alchichica",
                        "latitude": "19.43433000",
                        "longitude": "-97.38992000"
                    },
                    {
                        "id": 73749,
                        "name": "San José Buena Vista",
                        "latitude": "18.40528000",
                        "longitude": "-97.26833000"
                    },
                    {
                        "id": 73750,
                        "name": "San José Buenavista",
                        "latitude": "18.65951000",
                        "longitude": "-97.57911000"
                    },
                    {
                        "id": 73753,
                        "name": "San José Carpinteros",
                        "latitude": "18.99472000",
                        "longitude": "-97.91167000"
                    },
                    {
                        "id": 73757,
                        "name": "San José Chiapa",
                        "latitude": "19.24105000",
                        "longitude": "-97.76642000"
                    },
                    {
                        "id": 73763,
                        "name": "San José Cuyachapa",
                        "latitude": "18.85466000",
                        "longitude": "-97.31398000"
                    },
                    {
                        "id": 73815,
                        "name": "San José de Gracia",
                        "latitude": "18.64342000",
                        "longitude": "-97.84729000"
                    },
                    {
                        "id": 73770,
                        "name": "San José Ixtapa",
                        "latitude": "18.71599000",
                        "longitude": "-97.45940000"
                    },
                    {
                        "id": 73773,
                        "name": "San José Manzanitos",
                        "latitude": "19.26111000",
                        "longitude": "-97.21472000"
                    },
                    {
                        "id": 73775,
                        "name": "San José Monte Chiquito",
                        "latitude": "18.49611000",
                        "longitude": "-97.43806000"
                    },
                    {
                        "id": 73778,
                        "name": "San José Ozumba",
                        "latitude": "19.23306000",
                        "longitude": "-97.72833000"
                    },
                    {
                        "id": 73793,
                        "name": "San José Tilapa",
                        "latitude": "18.16361000",
                        "longitude": "-97.10137000"
                    },
                    {
                        "id": 73795,
                        "name": "San José Tlacuitlapan",
                        "latitude": "18.70763000",
                        "longitude": "-97.62538000"
                    },
                    {
                        "id": 73864,
                        "name": "San Juan Amecac",
                        "latitude": "18.83469000",
                        "longitude": "-98.65909000"
                    },
                    {
                        "id": 73865,
                        "name": "San Juan Atenco",
                        "latitude": "19.08670000",
                        "longitude": "-97.54074000"
                    },
                    {
                        "id": 73868,
                        "name": "San Juan Atzingo",
                        "latitude": "18.29862000",
                        "longitude": "-97.38614000"
                    },
                    {
                        "id": 73869,
                        "name": "San Juan Atzompa",
                        "latitude": "18.73899000",
                        "longitude": "-98.00738000"
                    },
                    {
                        "id": 73882,
                        "name": "San Juan Colón",
                        "latitude": "18.57722000",
                        "longitude": "-98.55833000"
                    },
                    {
                        "id": 73886,
                        "name": "San Juan Cuauhtémoc",
                        "latitude": "19.38845000",
                        "longitude": "-98.59764000"
                    },
                    {
                        "id": 73887,
                        "name": "San Juan Cuautla",
                        "latitude": "18.24416000",
                        "longitude": "-96.95673000"
                    },
                    {
                        "id": 73891,
                        "name": "San Juan Epatlán",
                        "latitude": "18.64272000",
                        "longitude": "-98.37250000"
                    },
                    {
                        "id": 73897,
                        "name": "San Juan Huiluco",
                        "latitude": "18.78904000",
                        "longitude": "-98.44941000"
                    },
                    {
                        "id": 73899,
                        "name": "San Juan Ixcaquixtla",
                        "latitude": "18.46067000",
                        "longitude": "-97.83103000"
                    },
                    {
                        "id": 73915,
                        "name": "San Juan Pancoac",
                        "latitude": "19.14917000",
                        "longitude": "-98.44194000"
                    },
                    {
                        "id": 73921,
                        "name": "San Juan Raboso",
                        "latitude": "18.57153000",
                        "longitude": "-98.43962000"
                    },
                    {
                        "id": 73927,
                        "name": "San Juan Tahitic",
                        "latitude": "19.93605000",
                        "longitude": "-97.55082000"
                    },
                    {
                        "id": 73930,
                        "name": "San Juan Tejaluca",
                        "latitude": "18.89917000",
                        "longitude": "-98.40472000"
                    },
                    {
                        "id": 73931,
                        "name": "San Juan Tejupa",
                        "latitude": "18.85519000",
                        "longitude": "-98.54124000"
                    },
                    {
                        "id": 73935,
                        "name": "San Juan Tepulco",
                        "latitude": "19.11709000",
                        "longitude": "-97.98847000"
                    },
                    {
                        "id": 73936,
                        "name": "San Juan Tetla",
                        "latitude": "19.21550000",
                        "longitude": "-98.50481000"
                    },
                    {
                        "id": 73938,
                        "name": "San Juan Tezongo",
                        "latitude": "19.84472000",
                        "longitude": "-97.36389000"
                    },
                    {
                        "id": 73946,
                        "name": "San Juan Tuxco",
                        "latitude": "19.25942000",
                        "longitude": "-98.45166000"
                    },
                    {
                        "id": 73949,
                        "name": "San Juan Xiutetelco",
                        "latitude": "19.79563000",
                        "longitude": "-97.32578000"
                    },
                    {
                        "id": 73993,
                        "name": "San Lorenzo",
                        "latitude": "20.35054000",
                        "longitude": "-97.93630000"
                    },
                    {
                        "id": 74000,
                        "name": "San Lorenzo Chiautzingo",
                        "latitude": "19.20432000",
                        "longitude": "-98.46747000"
                    },
                    {
                        "id": 74005,
                        "name": "San Lorenzo Joya de Rodríguez",
                        "latitude": "19.05444000",
                        "longitude": "-97.85333000"
                    },
                    {
                        "id": 74016,
                        "name": "San Lorenzo Tlaxipehuala",
                        "latitude": "20.13028000",
                        "longitude": "-97.97361000"
                    },
                    {
                        "id": 74026,
                        "name": "San Lucas Atzala",
                        "latitude": "19.10378000",
                        "longitude": "-98.48201000"
                    },
                    {
                        "id": 74040,
                        "name": "San Lucas el Grande",
                        "latitude": "19.30583000",
                        "longitude": "-98.47833000"
                    },
                    {
                        "id": 74041,
                        "name": "San Lucas el Viejo",
                        "latitude": "18.67724000",
                        "longitude": "-97.71824000"
                    },
                    {
                        "id": 74044,
                        "name": "San Luis Ajajalpan",
                        "latitude": "18.93624000",
                        "longitude": "-97.93386000"
                    },
                    {
                        "id": 74050,
                        "name": "San Luis Coyotzingo",
                        "latitude": "19.19818000",
                        "longitude": "-98.43716000"
                    },
                    {
                        "id": 74056,
                        "name": "San Luis Tehuiloyocan",
                        "latitude": "19.03924000",
                        "longitude": "-98.33749000"
                    },
                    {
                        "id": 74070,
                        "name": "San Marcos Eloxochitlán",
                        "latitude": "20.02528000",
                        "longitude": "-97.87194000"
                    },
                    {
                        "id": 74075,
                        "name": "San Marcos Tlacoyalco",
                        "latitude": "18.67388000",
                        "longitude": "-97.60354000"
                    },
                    {
                        "id": 74087,
                        "name": "San Martín",
                        "latitude": "19.78250000",
                        "longitude": "-97.34028000"
                    },
                    {
                        "id": 74091,
                        "name": "San Martín Caltenco",
                        "latitude": "18.88487000",
                        "longitude": "-97.81887000"
                    },
                    {
                        "id": 74096,
                        "name": "San Martín Esperilla",
                        "latitude": "18.73221000",
                        "longitude": "-97.54741000"
                    },
                    {
                        "id": 74100,
                        "name": "San Martín Mazateopan",
                        "latitude": "18.45278000",
                        "longitude": "-96.81611000"
                    },
                    {
                        "id": 74102,
                        "name": "San Martín Ojo de Agua",
                        "latitude": "19.01245000",
                        "longitude": "-97.39201000"
                    },
                    {
                        "id": 74106,
                        "name": "San Martín Texmelucan",
                        "latitude": "19.26929000",
                        "longitude": "-98.42831000"
                    },
                    {
                        "id": 74083,
                        "name": "San Martin Texmelucan de Labastida",
                        "latitude": "19.28431000",
                        "longitude": "-98.43885000"
                    },
                    {
                        "id": 74108,
                        "name": "San Martín Tlamapa",
                        "latitude": "18.97750000",
                        "longitude": "-98.39694000"
                    },
                    {
                        "id": 74109,
                        "name": "San Martín Tlapala",
                        "latitude": "18.96667000",
                        "longitude": "-98.45889000"
                    },
                    {
                        "id": 74120,
                        "name": "San Mateo Ayecac",
                        "latitude": "19.27898000",
                        "longitude": "-98.39466000"
                    },
                    {
                        "id": 74123,
                        "name": "San Mateo Capultitlán",
                        "latitude": "19.19500000",
                        "longitude": "-98.41528000"
                    },
                    {
                        "id": 74132,
                        "name": "San Mateo Ozolco",
                        "latitude": "19.09994000",
                        "longitude": "-98.51566000"
                    },
                    {
                        "id": 74133,
                        "name": "San Mateo Parra",
                        "latitude": "18.99139000",
                        "longitude": "-97.86167000"
                    },
                    {
                        "id": 74136,
                        "name": "San Mateo Soltepec",
                        "latitude": "19.09868000",
                        "longitude": "-97.76054000"
                    },
                    {
                        "id": 74145,
                        "name": "San Matías Atzala",
                        "latitude": "19.25127000",
                        "longitude": "-98.48167000"
                    },
                    {
                        "id": 74144,
                        "name": "San Matias Tlalancaleca",
                        "latitude": "19.32536000",
                        "longitude": "-98.49863000"
                    },
                    {
                        "id": 74156,
                        "name": "San Miguel Aguacomulican",
                        "latitude": "18.82222000",
                        "longitude": "-98.55056000"
                    },
                    {
                        "id": 74163,
                        "name": "San Miguel Analco",
                        "latitude": "19.18087000",
                        "longitude": "-98.33933000"
                    },
                    {
                        "id": 74166,
                        "name": "San Miguel Atlapulco",
                        "latitude": "18.79243000",
                        "longitude": "-98.19482000"
                    },
                    {
                        "id": 74169,
                        "name": "San Miguel Canoa",
                        "latitude": "19.15194000",
                        "longitude": "-98.10306000"
                    },
                    {
                        "id": 74235,
                        "name": "San Miguel del Milagro",
                        "latitude": "19.24123000",
                        "longitude": "-98.33352000"
                    },
                    {
                        "id": 74236,
                        "name": "San Miguel del Progreso",
                        "latitude": "19.98972000",
                        "longitude": "-97.66667000"
                    },
                    {
                        "id": 74179,
                        "name": "San Miguel Espejo",
                        "latitude": "19.09500000",
                        "longitude": "-98.06667000"
                    },
                    {
                        "id": 74182,
                        "name": "San Miguel Ixitlán",
                        "latitude": "18.00082000",
                        "longitude": "-97.77483000"
                    },
                    {
                        "id": 74190,
                        "name": "San Miguel Ocotenco",
                        "latitude": "19.06660000",
                        "longitude": "-97.45245000"
                    },
                    {
                        "id": 74194,
                        "name": "San Miguel Papaxtla",
                        "latitude": "19.06278000",
                        "longitude": "-98.39000000"
                    },
                    {
                        "id": 74202,
                        "name": "San Miguel Tecuitlapa",
                        "latitude": "19.12118000",
                        "longitude": "-97.54714000"
                    },
                    {
                        "id": 74204,
                        "name": "San Miguel Tenango",
                        "latitude": "19.90877000",
                        "longitude": "-97.93474000"
                    },
                    {
                        "id": 74205,
                        "name": "San Miguel Tenextatiloyan",
                        "latitude": "19.70973000",
                        "longitude": "-97.59769000"
                    },
                    {
                        "id": 74208,
                        "name": "San Miguel Tianguistenco",
                        "latitude": "19.29389000",
                        "longitude": "-98.53083000"
                    },
                    {
                        "id": 74209,
                        "name": "San Miguel Tianguizolco",
                        "latitude": "19.15861000",
                        "longitude": "-98.44083000"
                    },
                    {
                        "id": 74223,
                        "name": "San Miguel Xoxtla",
                        "latitude": "19.16763000",
                        "longitude": "-98.30758000"
                    },
                    {
                        "id": 74226,
                        "name": "San Miguel Zoapan",
                        "latitude": "19.08433000",
                        "longitude": "-97.35359000"
                    },
                    {
                        "id": 74227,
                        "name": "San Miguel Zozutla",
                        "latitude": "18.75430000",
                        "longitude": "-97.65478000"
                    },
                    {
                        "id": 74245,
                        "name": "San Nicolas Buenos Aires",
                        "latitude": "19.16488000",
                        "longitude": "-97.55131000"
                    },
                    {
                        "id": 74274,
                        "name": "San Nicolás de los Ranchos",
                        "latitude": "19.07139000",
                        "longitude": "-98.48601000"
                    },
                    {
                        "id": 74267,
                        "name": "San Nicolás Tolentino",
                        "latitude": "18.55078000",
                        "longitude": "-98.50371000"
                    },
                    {
                        "id": 74268,
                        "name": "San Nicolás Zecalacoayan",
                        "latitude": "19.19917000",
                        "longitude": "-98.48833000"
                    },
                    {
                        "id": 74269,
                        "name": "San Nicolás Zoyapetlayoca",
                        "latitude": "18.92417000",
                        "longitude": "-97.86528000"
                    },
                    {
                        "id": 74278,
                        "name": "San Pablito",
                        "latitude": "20.30071000",
                        "longitude": "-98.16201000"
                    },
                    {
                        "id": 74280,
                        "name": "San Pablo Ahuatempa",
                        "latitude": "18.98139000",
                        "longitude": "-98.35889000"
                    },
                    {
                        "id": 74281,
                        "name": "San Pablo Anicano",
                        "latitude": "18.14237000",
                        "longitude": "-98.12565000"
                    },
                    {
                        "id": 74305,
                        "name": "San Pablo de las Tunas",
                        "latitude": "18.99556000",
                        "longitude": "-97.70972000"
                    },
                    {
                        "id": 74317,
                        "name": "San Pedro Atmatla",
                        "latitude": "19.91083000",
                        "longitude": "-97.96750000"
                    },
                    {
                        "id": 74320,
                        "name": "San Pedro Benito Juárez",
                        "latitude": "18.94722000",
                        "longitude": "-98.55139000"
                    },
                    {
                        "id": 74327,
                        "name": "San Pedro Cholula",
                        "latitude": "19.07395000",
                        "longitude": "-98.36011000"
                    },
                    {
                        "id": 74331,
                        "name": "San Pedro Cuayuca",
                        "latitude": "18.48214000",
                        "longitude": "-98.18316000"
                    },
                    {
                        "id": 74343,
                        "name": "San Pedro Itztla",
                        "latitude": "20.27466000",
                        "longitude": "-97.93449000"
                    },
                    {
                        "id": 74416,
                        "name": "San Pedro la Joya",
                        "latitude": "19.06528000",
                        "longitude": "-97.83806000"
                    },
                    {
                        "id": 74353,
                        "name": "San Pedro Matamoros",
                        "latitude": "19.36972000",
                        "longitude": "-98.55472000"
                    },
                    {
                        "id": 74366,
                        "name": "San Pedro Petlacotla",
                        "latitude": "20.41186000",
                        "longitude": "-97.91443000"
                    },
                    {
                        "id": 74377,
                        "name": "San Pedro Temamatla",
                        "latitude": "18.92553000",
                        "longitude": "-97.51198000"
                    },
                    {
                        "id": 74381,
                        "name": "San Pedro Tetitlán",
                        "latitude": "18.25972000",
                        "longitude": "-97.32306000"
                    },
                    {
                        "id": 74388,
                        "name": "San Pedro Tlaolantongo",
                        "latitude": "20.23120000",
                        "longitude": "-97.80213000"
                    },
                    {
                        "id": 74399,
                        "name": "San Pedro Yancuitlalpan",
                        "latitude": "19.07750000",
                        "longitude": "-98.48333000"
                    },
                    {
                        "id": 74400,
                        "name": "San Pedro Yeloixtlahuaca",
                        "latitude": "18.07881000",
                        "longitude": "-98.06492000"
                    },
                    {
                        "id": 74402,
                        "name": "San Pedro Zacachimalpa",
                        "latitude": "18.94278000",
                        "longitude": "-98.15611000"
                    },
                    {
                        "id": 74431,
                        "name": "San Rafael Ixtapalucan",
                        "latitude": "19.29193000",
                        "longitude": "-98.55829000"
                    },
                    {
                        "id": 74436,
                        "name": "San Rafael Tlanalapan",
                        "latitude": "19.29167000",
                        "longitude": "-98.46806000"
                    },
                    {
                        "id": 74445,
                        "name": "San Salvador (Naranjillo)",
                        "latitude": "19.83139000",
                        "longitude": "-97.31500000"
                    },
                    {
                        "id": 74448,
                        "name": "San Salvador El Seco",
                        "latitude": "19.13325000",
                        "longitude": "-97.64167000"
                    },
                    {
                        "id": 74451,
                        "name": "San Salvador el Verde",
                        "latitude": "19.27002000",
                        "longitude": "-98.51648000"
                    },
                    {
                        "id": 74453,
                        "name": "San Sebastián",
                        "latitude": "19.85502000",
                        "longitude": "-97.37061000"
                    },
                    {
                        "id": 74459,
                        "name": "San Sebastián Alcomunga",
                        "latitude": "18.43705000",
                        "longitude": "-97.02683000"
                    },
                    {
                        "id": 74476,
                        "name": "San Sebastián de Aparicio",
                        "latitude": "19.10333000",
                        "longitude": "-98.16083000"
                    },
                    {
                        "id": 74470,
                        "name": "San Sebastián Teteles",
                        "latitude": "19.03241000",
                        "longitude": "-97.79021000"
                    },
                    {
                        "id": 74471,
                        "name": "San Sebastián Tlacotepec",
                        "latitude": "18.36518000",
                        "longitude": "-96.83309000"
                    },
                    {
                        "id": 74473,
                        "name": "San Sebastián Villanueva",
                        "latitude": "19.06085000",
                        "longitude": "-97.71935000"
                    },
                    {
                        "id": 74483,
                        "name": "San Simón",
                        "latitude": "18.96733000",
                        "longitude": "-97.71197000"
                    },
                    {
                        "id": 74485,
                        "name": "San Simón Atzitzintla",
                        "latitude": "19.26336000",
                        "longitude": "-98.47584000"
                    },
                    {
                        "id": 74496,
                        "name": "San Vicente Boquerón",
                        "latitude": "18.27984000",
                        "longitude": "-98.05540000"
                    },
                    {
                        "id": 74499,
                        "name": "San Vicente Coyotepec",
                        "latitude": "18.40439000",
                        "longitude": "-97.82924000"
                    },
                    {
                        "id": 74516,
                        "name": "Sanctorum",
                        "latitude": "19.09917000",
                        "longitude": "-98.25417000"
                    },
                    {
                        "id": 74525,
                        "name": "Santa Ana Acozautla",
                        "latitude": "18.95556000",
                        "longitude": "-98.38306000"
                    },
                    {
                        "id": 74532,
                        "name": "Santa Ana Coapan",
                        "latitude": "18.83109000",
                        "longitude": "-97.89167000"
                    },
                    {
                        "id": 74533,
                        "name": "Santa Ana Coatepec",
                        "latitude": "18.83667000",
                        "longitude": "-98.43472000"
                    },
                    {
                        "id": 74541,
                        "name": "Santa Ana Necoxtla",
                        "latitude": "18.61312000",
                        "longitude": "-98.38307000"
                    },
                    {
                        "id": 74549,
                        "name": "Santa Ana Xalmimilulco",
                        "latitude": "19.21287000",
                        "longitude": "-98.38207000"
                    },
                    {
                        "id": 74590,
                        "name": "Santa Catarina Tlaltempan",
                        "latitude": "18.61583000",
                        "longitude": "-98.08083000"
                    },
                    {
                        "id": 74591,
                        "name": "Santa Catarina Villanueva",
                        "latitude": "18.99917000",
                        "longitude": "-97.61472000"
                    },
                    {
                        "id": 74596,
                        "name": "Santa Cecilia Tepetitlán",
                        "latitude": "19.19254000",
                        "longitude": "-97.43395000"
                    },
                    {
                        "id": 74597,
                        "name": "Santa Clara",
                        "latitude": "18.97616000",
                        "longitude": "-98.30140000"
                    },
                    {
                        "id": 74601,
                        "name": "Santa Clara Huitziltepec",
                        "latitude": "18.76890000",
                        "longitude": "-97.88117000"
                    },
                    {
                        "id": 74613,
                        "name": "Santa Cruz Acapa",
                        "latitude": "18.40556000",
                        "longitude": "-97.32611000"
                    },
                    {
                        "id": 74615,
                        "name": "Santa Cruz Ajajalpan",
                        "latitude": "18.95169000",
                        "longitude": "-97.94998000"
                    },
                    {
                        "id": 74622,
                        "name": "Santa Cruz Cuautomatitla",
                        "latitude": "18.88917000",
                        "longitude": "-98.65917000"
                    },
                    {
                        "id": 74651,
                        "name": "Santa Cruz el Porvenir",
                        "latitude": "19.33178000",
                        "longitude": "-98.34801000"
                    },
                    {
                        "id": 74625,
                        "name": "Santa Cruz Huitziltepec",
                        "latitude": "18.73318000",
                        "longitude": "-97.87599000"
                    },
                    {
                        "id": 74632,
                        "name": "Santa Cruz Otlatla",
                        "latitude": "19.37222000",
                        "longitude": "-98.62250000"
                    },
                    {
                        "id": 74642,
                        "name": "Santa Cruz Texmalaquilla",
                        "latitude": "18.94306000",
                        "longitude": "-97.28750000"
                    },
                    {
                        "id": 74643,
                        "name": "Santa Cruz Xaltetela",
                        "latitude": "19.87417000",
                        "longitude": "-97.58083000"
                    },
                    {
                        "id": 74667,
                        "name": "Santa Inés Tecuexcomac",
                        "latitude": "19.29385000",
                        "longitude": "-98.34717000"
                    },
                    {
                        "id": 74668,
                        "name": "Santa Inés Varela la Luz",
                        "latitude": "19.15473000",
                        "longitude": "-97.38867000"
                    },
                    {
                        "id": 74677,
                        "name": "Santa Isabel Cholula",
                        "latitude": "18.99667000",
                        "longitude": "-98.37944000"
                    },
                    {
                        "id": 74687,
                        "name": "Santa Lucía Cosamaloapan",
                        "latitude": "18.88361000",
                        "longitude": "-98.35194000"
                    },
                    {
                        "id": 74717,
                        "name": "Santa María Atexcac",
                        "latitude": "19.13602000",
                        "longitude": "-98.49684000"
                    },
                    {
                        "id": 74695,
                        "name": "Santa Maria Coatepec",
                        "latitude": "19.10924000",
                        "longitude": "-97.59253000"
                    },
                    {
                        "id": 74812,
                        "name": "Santa María del Monte",
                        "latitude": "18.54117000",
                        "longitude": "-97.19990000"
                    },
                    {
                        "id": 74736,
                        "name": "Santa María Guadalupe Tecola",
                        "latitude": "18.90639000",
                        "longitude": "-98.19597000"
                    },
                    {
                        "id": 74747,
                        "name": "Santa María Ixtiyucán",
                        "latitude": "19.18688000",
                        "longitude": "-97.81094000"
                    },
                    {
                        "id": 74820,
                        "name": "Santa María la Alta",
                        "latitude": "18.59982000",
                        "longitude": "-97.65809000"
                    },
                    {
                        "id": 74758,
                        "name": "Santa María Malacatepec",
                        "latitude": "18.94147000",
                        "longitude": "-98.30218000"
                    },
                    {
                        "id": 74765,
                        "name": "Santa María Nenetzintla",
                        "latitude": "19.05413000",
                        "longitude": "-97.96664000"
                    },
                    {
                        "id": 74766,
                        "name": "Santa María Nepopualco",
                        "latitude": "19.15085000",
                        "longitude": "-98.49105000"
                    },
                    {
                        "id": 74777,
                        "name": "Santa María Techachalco",
                        "latitude": "18.95369000",
                        "longitude": "-97.47041000"
                    },
                    {
                        "id": 74784,
                        "name": "Santa María Texmelucan",
                        "latitude": "19.29417000",
                        "longitude": "-98.53778000"
                    },
                    {
                        "id": 74794,
                        "name": "Santa María Xonacatepec",
                        "latitude": "19.08944000",
                        "longitude": "-98.10361000"
                    },
                    {
                        "id": 74800,
                        "name": "Santa María Zacatepec",
                        "latitude": "19.12333000",
                        "longitude": "-98.36528000"
                    },
                    {
                        "id": 74701,
                        "name": "Santa Martha Hidalgo",
                        "latitude": "18.98500000",
                        "longitude": "-98.32444000"
                    },
                    {
                        "id": 74831,
                        "name": "Santa Rita",
                        "latitude": "20.36410000",
                        "longitude": "-97.81689000"
                    },
                    {
                        "id": 74833,
                        "name": "Santa Rita Tlahuapan",
                        "latitude": "19.33211000",
                        "longitude": "-98.57688000"
                    },
                    {
                        "id": 74836,
                        "name": "Santa Rosa",
                        "latitude": "18.87704000",
                        "longitude": "-97.78122000"
                    },
                    {
                        "id": 74870,
                        "name": "Santiago",
                        "latitude": "19.81194000",
                        "longitude": "-97.32361000"
                    },
                    {
                        "id": 74871,
                        "name": "Santiago Acatlán",
                        "latitude": "18.99334000",
                        "longitude": "-97.93375000"
                    },
                    {
                        "id": 74873,
                        "name": "Santiago Acozac",
                        "latitude": "18.95694000",
                        "longitude": "-97.81167000"
                    },
                    {
                        "id": 74875,
                        "name": "Santiago Alseseca",
                        "latitude": "18.84511000",
                        "longitude": "-97.70716000"
                    },
                    {
                        "id": 74880,
                        "name": "Santiago Atzitzihuacán",
                        "latitude": "18.82472000",
                        "longitude": "-98.58167000"
                    },
                    {
                        "id": 74894,
                        "name": "Santiago Coltzingo",
                        "latitude": "19.38318000",
                        "longitude": "-98.53483000"
                    },
                    {
                        "id": 74926,
                        "name": "Santiago Momoxpan",
                        "latitude": "19.07361000",
                        "longitude": "-98.26694000"
                    },
                    {
                        "id": 74943,
                        "name": "Santiago Tenango",
                        "latitude": "19.00335000",
                        "longitude": "-97.64430000"
                    },
                    {
                        "id": 74973,
                        "name": "Santiago Yancuictlalpan",
                        "latitude": "20.06092000",
                        "longitude": "-97.47223000"
                    },
                    {
                        "id": 74998,
                        "name": "Santo Domingo Atoyatempan",
                        "latitude": "18.90444000",
                        "longitude": "-98.37306000"
                    },
                    {
                        "id": 75001,
                        "name": "Santo Domingo Huehuetlán",
                        "latitude": "18.73940000",
                        "longitude": "-98.16438000"
                    },
                    {
                        "id": 75021,
                        "name": "Santo Nombre",
                        "latitude": "18.67389000",
                        "longitude": "-97.67611000"
                    },
                    {
                        "id": 75026,
                        "name": "Santo Tomás Chautla",
                        "latitude": "18.96573000",
                        "longitude": "-98.15288000"
                    },
                    {
                        "id": 75052,
                        "name": "Sección 23",
                        "latitude": "19.78778000",
                        "longitude": "-97.37917000"
                    },
                    {
                        "id": 75113,
                        "name": "Soledad Morelos",
                        "latitude": "18.82808000",
                        "longitude": "-98.48952000"
                    },
                    {
                        "id": 75120,
                        "name": "Soltepec",
                        "latitude": "19.12111000",
                        "longitude": "-97.70861000"
                    },
                    {
                        "id": 75124,
                        "name": "Sosa",
                        "latitude": "19.80111000",
                        "longitude": "-97.39611000"
                    },
                    {
                        "id": 75159,
                        "name": "Tacopan",
                        "latitude": "19.83750000",
                        "longitude": "-97.43111000"
                    },
                    {
                        "id": 75200,
                        "name": "Tanamacoyan",
                        "latitude": "19.89056000",
                        "longitude": "-97.42972000"
                    },
                    {
                        "id": 75212,
                        "name": "Tanhuixco",
                        "latitude": "19.82056000",
                        "longitude": "-97.46722000"
                    },
                    {
                        "id": 75241,
                        "name": "Tatauzoquico",
                        "latitude": "19.82833000",
                        "longitude": "-97.52694000"
                    },
                    {
                        "id": 75242,
                        "name": "Tatoxcac",
                        "latitude": "19.86944000",
                        "longitude": "-97.57306000"
                    },
                    {
                        "id": 75254,
                        "name": "Teacalco de Dorantes (San José Teacalco)",
                        "latitude": "18.80444000",
                        "longitude": "-98.50722000"
                    },
                    {
                        "id": 75260,
                        "name": "Tecali",
                        "latitude": "18.90060000",
                        "longitude": "-97.97064000"
                    },
                    {
                        "id": 75263,
                        "name": "Tecamachalco",
                        "latitude": "18.88352000",
                        "longitude": "-97.73344000"
                    },
                    {
                        "id": 75277,
                        "name": "Tecoltepec",
                        "latitude": "18.32515000",
                        "longitude": "-97.07868000"
                    },
                    {
                        "id": 75281,
                        "name": "Tecomatlán",
                        "latitude": "18.06956000",
                        "longitude": "-98.30690000"
                    },
                    {
                        "id": 75287,
                        "name": "Tecpantzacoalco",
                        "latitude": "18.47694000",
                        "longitude": "-97.03944000"
                    },
                    {
                        "id": 75291,
                        "name": "Tecuanipa",
                        "latitude": "18.88117000",
                        "longitude": "-98.61895000"
                    },
                    {
                        "id": 75292,
                        "name": "Tecuanipan",
                        "latitude": "19.01316000",
                        "longitude": "-98.39843000"
                    },
                    {
                        "id": 75296,
                        "name": "Tehuacán",
                        "latitude": "18.46422000",
                        "longitude": "-97.39735000"
                    },
                    {
                        "id": 75300,
                        "name": "Tehuitzingo",
                        "latitude": "18.36169000",
                        "longitude": "-98.30763000"
                    },
                    {
                        "id": 75304,
                        "name": "Tejaluca",
                        "latitude": "18.63677000",
                        "longitude": "-98.25046000"
                    },
                    {
                        "id": 75321,
                        "name": "Teloxtoc",
                        "latitude": "18.37919000",
                        "longitude": "-97.58021000"
                    },
                    {
                        "id": 75322,
                        "name": "Telpatlán",
                        "latitude": "18.48417000",
                        "longitude": "-97.15222000"
                    },
                    {
                        "id": 75325,
                        "name": "Temalacayuca",
                        "latitude": "18.60439000",
                        "longitude": "-97.55735000"
                    },
                    {
                        "id": 75335,
                        "name": "Temextla",
                        "latitude": "19.60910000",
                        "longitude": "-97.66714000"
                    },
                    {
                        "id": 75347,
                        "name": "Tenampulco",
                        "latitude": "20.18593000",
                        "longitude": "-97.40264000"
                    },
                    {
                        "id": 75356,
                        "name": "Tenango de las Flores",
                        "latitude": "20.20583000",
                        "longitude": "-97.98806000"
                    },
                    {
                        "id": 75379,
                        "name": "Teontepec",
                        "latitude": "18.49217000",
                        "longitude": "-97.52962000"
                    },
                    {
                        "id": 75380,
                        "name": "Teopantlán",
                        "latitude": "18.71219000",
                        "longitude": "-98.26341000"
                    },
                    {
                        "id": 75386,
                        "name": "Teotlalco",
                        "latitude": "18.46645000",
                        "longitude": "-98.81346000"
                    },
                    {
                        "id": 75387,
                        "name": "Teotlaltzingo",
                        "latitude": "19.23088000",
                        "longitude": "-98.50077000"
                    },
                    {
                        "id": 75395,
                        "name": "Tepanco",
                        "latitude": "18.55686000",
                        "longitude": "-97.56130000"
                    },
                    {
                        "id": 75396,
                        "name": "Tepango",
                        "latitude": "20.00314000",
                        "longitude": "-97.79651000"
                    },
                    {
                        "id": 75397,
                        "name": "Tepango de Rodríguez",
                        "latitude": "20.00161000",
                        "longitude": "-97.78366000"
                    },
                    {
                        "id": 75398,
                        "name": "Tepapayeca",
                        "latitude": "18.67036000",
                        "longitude": "-98.52944000"
                    },
                    {
                        "id": 75401,
                        "name": "Tepatlaxco de Hidalgo",
                        "latitude": "19.08067000",
                        "longitude": "-97.97338000"
                    },
                    {
                        "id": 75402,
                        "name": "Tepazolco",
                        "latitude": "18.69967000",
                        "longitude": "-97.69637000"
                    },
                    {
                        "id": 75403,
                        "name": "Tepeaca",
                        "latitude": "18.96688000",
                        "longitude": "-97.89980000"
                    },
                    {
                        "id": 75413,
                        "name": "Tepeojuma",
                        "latitude": "18.72468000",
                        "longitude": "-98.44633000"
                    },
                    {
                        "id": 75416,
                        "name": "Tepeteno de Iturbide",
                        "latitude": "19.79583000",
                        "longitude": "-97.49722000"
                    },
                    {
                        "id": 75422,
                        "name": "Tepetitán Reyeshogpan de Hidalgo",
                        "latitude": "20.08361000",
                        "longitude": "-97.49361000"
                    },
                    {
                        "id": 75424,
                        "name": "Tepetlacolco",
                        "latitude": "18.64104000",
                        "longitude": "-97.69284000"
                    },
                    {
                        "id": 75433,
                        "name": "Tepetzingo",
                        "latitude": "18.42185000",
                        "longitude": "-97.33785000"
                    },
                    {
                        "id": 75436,
                        "name": "Tepetzintla",
                        "latitude": "19.95318000",
                        "longitude": "-97.84725000"
                    },
                    {
                        "id": 75437,
                        "name": "Tepetzitzintla",
                        "latitude": "18.47159000",
                        "longitude": "-97.11931000"
                    },
                    {
                        "id": 75438,
                        "name": "Tepexco",
                        "latitude": "18.64150000",
                        "longitude": "-98.69064000"
                    },
                    {
                        "id": 75439,
                        "name": "Tepexi de Rodríguez",
                        "latitude": "18.58108000",
                        "longitude": "-97.92606000"
                    },
                    {
                        "id": 75442,
                        "name": "Tepeyahualco",
                        "latitude": "19.45781000",
                        "longitude": "-97.46240000"
                    },
                    {
                        "id": 75443,
                        "name": "Tepeyahualco de Cuauhtémoc",
                        "latitude": "18.81098000",
                        "longitude": "-97.86749000"
                    },
                    {
                        "id": 75445,
                        "name": "Tepeyehualco de Hidalgo",
                        "latitude": "19.48867000",
                        "longitude": "-97.49254000"
                    },
                    {
                        "id": 75478,
                        "name": "Tetela de Ocampo",
                        "latitude": "19.81770000",
                        "longitude": "-97.80691000"
                    },
                    {
                        "id": 75480,
                        "name": "Tetelcingo",
                        "latitude": "18.23917000",
                        "longitude": "-98.02667000"
                    },
                    {
                        "id": 75482,
                        "name": "Teteles de Avila Castillo",
                        "latitude": "19.85748000",
                        "longitude": "-97.45703000"
                    },
                    {
                        "id": 75503,
                        "name": "Texcala",
                        "latitude": "18.39716000",
                        "longitude": "-97.44519000"
                    },
                    {
                        "id": 75504,
                        "name": "Texcalapa de Juárez",
                        "latitude": "18.06490000",
                        "longitude": "-97.98876000"
                    },
                    {
                        "id": 75521,
                        "name": "Texocoyohuac",
                        "latitude": "19.77778000",
                        "longitude": "-97.59028000"
                    },
                    {
                        "id": 75524,
                        "name": "Tezhuatepec",
                        "latitude": "19.81167000",
                        "longitude": "-97.46250000"
                    },
                    {
                        "id": 75525,
                        "name": "Teziutlan",
                        "latitude": "19.81730000",
                        "longitude": "-97.35992000"
                    },
                    {
                        "id": 75528,
                        "name": "Tezonteopan de Bonilla",
                        "latitude": "18.74803000",
                        "longitude": "-98.49134000"
                    },
                    {
                        "id": 75535,
                        "name": "Tianguismanalco",
                        "latitude": "18.97624000",
                        "longitude": "-98.44861000"
                    },
                    {
                        "id": 75553,
                        "name": "Tierra Negra",
                        "latitude": "20.24333000",
                        "longitude": "-97.95667000"
                    },
                    {
                        "id": 75566,
                        "name": "Tilapa",
                        "latitude": "18.60495000",
                        "longitude": "-98.54575000"
                    },
                    {
                        "id": 75597,
                        "name": "Tlacamilco",
                        "latitude": "19.07590000",
                        "longitude": "-97.91640000"
                    },
                    {
                        "id": 75602,
                        "name": "Tlachichuca",
                        "latitude": "19.11485000",
                        "longitude": "-97.41915000"
                    },
                    {
                        "id": 75615,
                        "name": "Tlacotepec",
                        "latitude": "18.68193000",
                        "longitude": "-97.65602000"
                    },
                    {
                        "id": 75618,
                        "name": "Tlacotepec (San Mateo)",
                        "latitude": "20.06028000",
                        "longitude": "-97.84917000"
                    },
                    {
                        "id": 75619,
                        "name": "Tlacotepec de Benito Juárez",
                        "latitude": "18.66151000",
                        "longitude": "-97.63459000"
                    },
                    {
                        "id": 75620,
                        "name": "Tlacotepec de José Manzo",
                        "latitude": "19.27194000",
                        "longitude": "-98.48472000"
                    },
                    {
                        "id": 75625,
                        "name": "Tlacuilotepec",
                        "latitude": "20.38033000",
                        "longitude": "-97.98624000"
                    },
                    {
                        "id": 75629,
                        "name": "Tlahuapan",
                        "latitude": "19.36494000",
                        "longitude": "-98.57345000"
                    },
                    {
                        "id": 75634,
                        "name": "Tlaixpan",
                        "latitude": "18.91217000",
                        "longitude": "-97.73818000"
                    },
                    {
                        "id": 75653,
                        "name": "Tlaltenango",
                        "latitude": "19.17165000",
                        "longitude": "-98.34072000"
                    },
                    {
                        "id": 75656,
                        "name": "Tlaltepango",
                        "latitude": "20.14531000",
                        "longitude": "-97.87723000"
                    },
                    {
                        "id": 75662,
                        "name": "Tlamanca",
                        "latitude": "19.67457000",
                        "longitude": "-97.69640000"
                    },
                    {
                        "id": 75663,
                        "name": "Tlamanca de Hernández",
                        "latitude": "19.95597000",
                        "longitude": "-97.81489000"
                    },
                    {
                        "id": 75665,
                        "name": "Tlamaya Grande",
                        "latitude": "20.14689000",
                        "longitude": "-97.80313000"
                    },
                    {
                        "id": 75669,
                        "name": "Tlanalapan",
                        "latitude": "19.25084000",
                        "longitude": "-97.27604000"
                    },
                    {
                        "id": 75671,
                        "name": "Tlancualpican",
                        "latitude": "18.43333000",
                        "longitude": "-98.70000000"
                    },
                    {
                        "id": 75672,
                        "name": "Tlanepantla",
                        "latitude": "18.86310000",
                        "longitude": "-97.88701000"
                    },
                    {
                        "id": 75674,
                        "name": "Tlaola",
                        "latitude": "20.13861000",
                        "longitude": "-97.92306000"
                    },
                    {
                        "id": 75676,
                        "name": "Tlapacoya",
                        "latitude": "20.13512000",
                        "longitude": "-97.83347000"
                    },
                    {
                        "id": 75680,
                        "name": "Tlapanalá",
                        "latitude": "18.69585000",
                        "longitude": "-98.53561000"
                    },
                    {
                        "id": 75684,
                        "name": "Tlatempa",
                        "latitude": "19.94484000",
                        "longitude": "-97.93526000"
                    },
                    {
                        "id": 75688,
                        "name": "Tlatlauquitepec",
                        "latitude": "19.84765000",
                        "longitude": "-97.49718000"
                    },
                    {
                        "id": 75694,
                        "name": "Tlaxcalantongo",
                        "latitude": "20.31397000",
                        "longitude": "-97.87199000"
                    },
                    {
                        "id": 75697,
                        "name": "Tlaxco",
                        "latitude": "20.42345000",
                        "longitude": "-98.02917000"
                    },
                    {
                        "id": 75699,
                        "name": "Tlaxco (Santiago Tlaxco)",
                        "latitude": "20.05788000",
                        "longitude": "-97.96249000"
                    },
                    {
                        "id": 75704,
                        "name": "Tlaxpanaloya",
                        "latitude": "20.22589000",
                        "longitude": "-98.12036000"
                    },
                    {
                        "id": 75706,
                        "name": "Tlayehualancingo",
                        "latitude": "20.03301000",
                        "longitude": "-97.82661000"
                    },
                    {
                        "id": 75710,
                        "name": "Tlixco",
                        "latitude": "18.27389000",
                        "longitude": "-96.99972000"
                    },
                    {
                        "id": 75713,
                        "name": "Tochimilco",
                        "latitude": "18.89062000",
                        "longitude": "-98.57154000"
                    },
                    {
                        "id": 75714,
                        "name": "Tochtepec",
                        "latitude": "18.83928000",
                        "longitude": "-97.82282000"
                    },
                    {
                        "id": 75725,
                        "name": "Tomaquilapa",
                        "latitude": "19.75635000",
                        "longitude": "-97.32161000"
                    },
                    {
                        "id": 75726,
                        "name": "Tomatlán",
                        "latitude": "19.89399000",
                        "longitude": "-97.97346000"
                    },
                    {
                        "id": 75736,
                        "name": "Tonalixco",
                        "latitude": "19.98111000",
                        "longitude": "-97.83944000"
                    },
                    {
                        "id": 75754,
                        "name": "Totoltepec",
                        "latitude": "18.65255000",
                        "longitude": "-98.34706000"
                    },
                    {
                        "id": 75755,
                        "name": "Totoltepec de Guerrero",
                        "latitude": "18.22560000",
                        "longitude": "-97.85511000"
                    },
                    {
                        "id": 75761,
                        "name": "Toxtla",
                        "latitude": "20.06632000",
                        "longitude": "-97.94748000"
                    },
                    {
                        "id": 75762,
                        "name": "Tozihuic",
                        "latitude": "19.25138000",
                        "longitude": "-97.09697000"
                    },
                    {
                        "id": 75785,
                        "name": "Tronconal",
                        "latitude": "18.80500000",
                        "longitude": "-98.48361000"
                    },
                    {
                        "id": 75789,
                        "name": "Tula",
                        "latitude": "18.53857000",
                        "longitude": "-97.90935000"
                    },
                    {
                        "id": 75796,
                        "name": "Tulcingo",
                        "latitude": "17.99891000",
                        "longitude": "-98.40925000"
                    },
                    {
                        "id": 75797,
                        "name": "Tulcingo de Valle",
                        "latitude": "18.04370000",
                        "longitude": "-98.44074000"
                    },
                    {
                        "id": 75799,
                        "name": "Tulimanca",
                        "latitude": "18.46944000",
                        "longitude": "-97.14000000"
                    },
                    {
                        "id": 75826,
                        "name": "Tuxtla",
                        "latitude": "20.00037000",
                        "longitude": "-97.65526000"
                    },
                    {
                        "id": 75828,
                        "name": "Tuzamapan",
                        "latitude": "20.06572000",
                        "longitude": "-97.57520000"
                    },
                    {
                        "id": 75832,
                        "name": "Tuzuapan",
                        "latitude": "18.90110000",
                        "longitude": "-97.66693000"
                    },
                    {
                        "id": 75837,
                        "name": "Tzicatlacoyan",
                        "latitude": "18.84071000",
                        "longitude": "-98.04840000"
                    },
                    {
                        "id": 75839,
                        "name": "Tzicatlán",
                        "latitude": "18.45073000",
                        "longitude": "-98.75574000"
                    },
                    {
                        "id": 75841,
                        "name": "Tzinacapan",
                        "latitude": "20.02944000",
                        "longitude": "-97.54047000"
                    },
                    {
                        "id": 75869,
                        "name": "Unidad Grajales INFONAVIT",
                        "latitude": "19.24126000",
                        "longitude": "-97.81068000"
                    },
                    {
                        "id": 75953,
                        "name": "Venta Grande",
                        "latitude": "20.11893000",
                        "longitude": "-98.09944000"
                    },
                    {
                        "id": 75958,
                        "name": "Venustiano Carranza",
                        "latitude": "20.50667000",
                        "longitude": "-97.66806000"
                    },
                    {
                        "id": 75979,
                        "name": "Vicente Guerrero",
                        "latitude": "20.12322000",
                        "longitude": "-97.65417000"
                    },
                    {
                        "id": 75992,
                        "name": "Villa Avila Camacho",
                        "latitude": "20.38593000",
                        "longitude": "-97.87989000"
                    },
                    {
                        "id": 75998,
                        "name": "Villa Cuauhtémoc",
                        "latitude": "19.77839000",
                        "longitude": "-98.09719000"
                    },
                    {
                        "id": 76034,
                        "name": "Villa Mariano Matamoros",
                        "latitude": "19.32659000",
                        "longitude": "-98.37827000"
                    },
                    {
                        "id": 76110,
                        "name": "Xacaxomulco",
                        "latitude": "19.18866000",
                        "longitude": "-97.14703000"
                    },
                    {
                        "id": 76112,
                        "name": "Xalacapan de Lucke",
                        "latitude": "19.90403000",
                        "longitude": "-97.59047000"
                    },
                    {
                        "id": 76118,
                        "name": "Xalitzintla",
                        "latitude": "19.08170000",
                        "longitude": "-98.51620000"
                    },
                    {
                        "id": 76122,
                        "name": "Xaltepec",
                        "latitude": "18.88163000",
                        "longitude": "-97.60825000"
                    },
                    {
                        "id": 76123,
                        "name": "Xaltepuxtla",
                        "latitude": "20.17546000",
                        "longitude": "-97.97208000"
                    },
                    {
                        "id": 76125,
                        "name": "Xalticpac",
                        "latitude": "19.84301000",
                        "longitude": "-97.59556000"
                    },
                    {
                        "id": 76129,
                        "name": "Xayacatlán de Bravo",
                        "latitude": "18.23712000",
                        "longitude": "-97.97524000"
                    },
                    {
                        "id": 76139,
                        "name": "Xicotepec",
                        "latitude": "20.31813000",
                        "longitude": "-97.90889000"
                    },
                    {
                        "id": 76140,
                        "name": "Xicotepec de Juárez",
                        "latitude": "20.27605000",
                        "longitude": "-97.96111000"
                    },
                    {
                        "id": 76141,
                        "name": "Xicotlán",
                        "latitude": "18.08110000",
                        "longitude": "-98.59359000"
                    },
                    {
                        "id": 76145,
                        "name": "Xilocuautla",
                        "latitude": "20.13948000",
                        "longitude": "-98.02341000"
                    },
                    {
                        "id": 76146,
                        "name": "Xiloxochico de Rafael Ávila Camacho",
                        "latitude": "20.04583000",
                        "longitude": "-97.49083000"
                    },
                    {
                        "id": 76149,
                        "name": "Xitlama",
                        "latitude": "18.30344000",
                        "longitude": "-97.01743000"
                    },
                    {
                        "id": 76150,
                        "name": "Xiutetelco",
                        "latitude": "19.75755000",
                        "longitude": "-97.34252000"
                    },
                    {
                        "id": 76156,
                        "name": "Xochiapulco",
                        "latitude": "19.82110000",
                        "longitude": "-97.65947000"
                    },
                    {
                        "id": 76161,
                        "name": "Xochicuautla",
                        "latitude": "20.05377000",
                        "longitude": "-97.88912000"
                    },
                    {
                        "id": 76164,
                        "name": "Xochiltepec",
                        "latitude": "18.65272000",
                        "longitude": "-98.32540000"
                    },
                    {
                        "id": 76168,
                        "name": "Xochimilco",
                        "latitude": "18.84167000",
                        "longitude": "-97.72583000"
                    },
                    {
                        "id": 76169,
                        "name": "Xochinanacatlán",
                        "latitude": "20.19482000",
                        "longitude": "-97.89765000"
                    },
                    {
                        "id": 76173,
                        "name": "Xochitepec",
                        "latitude": "18.22833000",
                        "longitude": "-98.87611000"
                    },
                    {
                        "id": 76180,
                        "name": "Xochitlán de Vicente Suárez",
                        "latitude": "19.95002000",
                        "longitude": "-97.64375000"
                    },
                    {
                        "id": 76175,
                        "name": "Xochitlan Todos Santos",
                        "latitude": "18.70395000",
                        "longitude": "-97.77609000"
                    },
                    {
                        "id": 76176,
                        "name": "Xochitlaxco (San Baltazar)",
                        "latitude": "19.94139000",
                        "longitude": "-97.86361000"
                    },
                    {
                        "id": 76184,
                        "name": "Xocotepéc",
                        "latitude": "19.36758000",
                        "longitude": "-97.17093000"
                    },
                    {
                        "id": 76190,
                        "name": "Xoloateno",
                        "latitude": "19.83111000",
                        "longitude": "-97.36944000"
                    },
                    {
                        "id": 76192,
                        "name": "Xolotla",
                        "latitude": "20.25801000",
                        "longitude": "-98.13325000"
                    },
                    {
                        "id": 76196,
                        "name": "Xonalpu",
                        "latitude": "20.12833000",
                        "longitude": "-97.61056000"
                    },
                    {
                        "id": 76197,
                        "name": "Xonocuautla",
                        "latitude": "19.78873000",
                        "longitude": "-97.51627000"
                    },
                    {
                        "id": 76203,
                        "name": "Xoxonacatla",
                        "latitude": "20.00750000",
                        "longitude": "-97.94056000"
                    },
                    {
                        "id": 76205,
                        "name": "Xuchapa",
                        "latitude": "18.52650000",
                        "longitude": "-98.45705000"
                    },
                    {
                        "id": 76216,
                        "name": "Yaonahuac",
                        "latitude": "19.87076000",
                        "longitude": "-97.46587000"
                    },
                    {
                        "id": 76231,
                        "name": "Yehualtepec",
                        "latitude": "18.79518000",
                        "longitude": "-97.66160000"
                    },
                    {
                        "id": 76243,
                        "name": "Yopi",
                        "latitude": "19.82667000",
                        "longitude": "-97.38028000"
                    },
                    {
                        "id": 76261,
                        "name": "Zacaola",
                        "latitude": "18.88099000",
                        "longitude": "-97.84762000"
                    },
                    {
                        "id": 76262,
                        "name": "Zacapala",
                        "latitude": "18.57810000",
                        "longitude": "-98.04505000"
                    },
                    {
                        "id": 76264,
                        "name": "Zacapechpan",
                        "latitude": "19.05441000",
                        "longitude": "-98.35109000"
                    },
                    {
                        "id": 76265,
                        "name": "Zacapoaxtla",
                        "latitude": "19.87271000",
                        "longitude": "-97.58899000"
                    },
                    {
                        "id": 76275,
                        "name": "Zacatepec",
                        "latitude": "19.26631000",
                        "longitude": "-97.53280000"
                    },
                    {
                        "id": 76277,
                        "name": "Zacatlán",
                        "latitude": "19.93550000",
                        "longitude": "-97.96125000"
                    },
                    {
                        "id": 76291,
                        "name": "Zahuatlán de Morelos (San José)",
                        "latitude": "18.98333000",
                        "longitude": "-97.86750000"
                    },
                    {
                        "id": 76307,
                        "name": "Zapotitlán",
                        "latitude": "20.00209000",
                        "longitude": "-97.71385000"
                    },
                    {
                        "id": 76315,
                        "name": "Zaragoza",
                        "latitude": "19.77097000",
                        "longitude": "-97.55506000"
                    },
                    {
                        "id": 76325,
                        "name": "Zautla",
                        "latitude": "19.72013000",
                        "longitude": "-97.65952000"
                    },
                    {
                        "id": 76327,
                        "name": "Zempoala",
                        "latitude": "20.08670000",
                        "longitude": "-97.99850000"
                    },
                    {
                        "id": 76334,
                        "name": "Zihuateutla",
                        "latitude": "20.28699000",
                        "longitude": "-97.81998000"
                    },
                    {
                        "id": 76341,
                        "name": "Zinacatepec",
                        "latitude": "18.33516000",
                        "longitude": "-97.24621000"
                    },
                    {
                        "id": 76355,
                        "name": "Zoatecpan",
                        "latitude": "19.93444000",
                        "longitude": "-97.62028000"
                    },
                    {
                        "id": 76359,
                        "name": "Zolonquiapa",
                        "latitude": "18.57611000",
                        "longitude": "-98.52722000"
                    },
                    {
                        "id": 76363,
                        "name": "Zongozotla",
                        "latitude": "19.97930000",
                        "longitude": "-97.72751000"
                    },
                    {
                        "id": 76368,
                        "name": "Zoquiapan",
                        "latitude": "20.00735000",
                        "longitude": "-97.59691000"
                    },
                    {
                        "id": 76369,
                        "name": "Zoquiopan",
                        "latitude": "20.00898000",
                        "longitude": "-97.59606000"
                    },
                    {
                        "id": 76373,
                        "name": "Zoquitlán",
                        "latitude": "18.37700000",
                        "longitude": "-96.98165000"
                    },
                    {
                        "id": 76377,
                        "name": "Zoyatitla",
                        "latitude": "19.82343000",
                        "longitude": "-97.81831000"
                    },
                    {
                        "id": 76380,
                        "name": "Zoyotla",
                        "latitude": "19.92778000",
                        "longitude": "-97.69389000"
                    },
                    {
                        "id": 76381,
                        "name": "Zozocolco de Guerrero",
                        "latitude": "20.10396000",
                        "longitude": "-97.56934000"
                    }
                ]
            },
            {
                "id": 3455,
                "name": "Querétaro",
                "iso2": "QUE",
                "latitude": "20.58879320",
                "longitude": "-100.38988810",
                "type": "state",
                "cities": [
                    {
                        "id": 68103,
                        "name": "Agua Azul",
                        "latitude": "20.60271000",
                        "longitude": "-100.20472000"
                    },
                    {
                        "id": 68112,
                        "name": "Agua Fría",
                        "latitude": "21.15304000",
                        "longitude": "-99.80638000"
                    },
                    {
                        "id": 68118,
                        "name": "Agua Zarca",
                        "latitude": "21.22003000",
                        "longitude": "-99.09075000"
                    },
                    {
                        "id": 68138,
                        "name": "Ahuacatlán de Guadalupe",
                        "latitude": "21.21472000",
                        "longitude": "-99.54056000"
                    },
                    {
                        "id": 68167,
                        "name": "Ajuchitlán",
                        "latitude": "20.70713000",
                        "longitude": "-100.02008000"
                    },
                    {
                        "id": 68166,
                        "name": "Ajuchitlancito",
                        "latitude": "20.47601000",
                        "longitude": "-100.21583000"
                    },
                    {
                        "id": 68189,
                        "name": "Alfajayucan",
                        "latitude": "20.75370000",
                        "longitude": "-100.21773000"
                    },
                    {
                        "id": 68250,
                        "name": "Amazcala",
                        "latitude": "20.70339000",
                        "longitude": "-100.26511000"
                    },
                    {
                        "id": 68251,
                        "name": "Amealco",
                        "latitude": "20.18758000",
                        "longitude": "-100.14485000"
                    },
                    {
                        "id": 68294,
                        "name": "Apapátaro",
                        "latitude": "20.46806000",
                        "longitude": "-100.36861000"
                    },
                    {
                        "id": 68340,
                        "name": "Arcila",
                        "latitude": "20.41037000",
                        "longitude": "-100.10993000"
                    },
                    {
                        "id": 68365,
                        "name": "Arroyo Seco",
                        "latitude": "21.54777000",
                        "longitude": "-99.68832000"
                    },
                    {
                        "id": 68428,
                        "name": "Atongo",
                        "latitude": "20.77288000",
                        "longitude": "-100.23953000"
                    },
                    {
                        "id": 68577,
                        "name": "Bella Vista del Río",
                        "latitude": "20.69000000",
                        "longitude": "-99.57139000"
                    },
                    {
                        "id": 68610,
                        "name": "Bernal",
                        "latitude": "20.74030000",
                        "longitude": "-99.94125000"
                    },
                    {
                        "id": 68641,
                        "name": "Bordo Blanco",
                        "latitude": "20.49631000",
                        "longitude": "-99.92855000"
                    },
                    {
                        "id": 68646,
                        "name": "Boxasní",
                        "latitude": "20.67083000",
                        "longitude": "-99.84861000"
                    },
                    {
                        "id": 68647,
                        "name": "Boyé",
                        "latitude": "20.68091000",
                        "longitude": "-99.73933000"
                    },
                    {
                        "id": 68648,
                        "name": "Bravo",
                        "latitude": "20.39977000",
                        "longitude": "-100.42423000"
                    },
                    {
                        "id": 68672,
                        "name": "Buenavista",
                        "latitude": "20.82372000",
                        "longitude": "-100.47009000"
                    },
                    {
                        "id": 68716,
                        "name": "Cadereyta",
                        "latitude": "20.69701000",
                        "longitude": "-99.81624000"
                    },
                    {
                        "id": 68727,
                        "name": "Calamanda",
                        "latitude": "20.54672000",
                        "longitude": "-100.18616000"
                    },
                    {
                        "id": 68817,
                        "name": "Carbonera",
                        "latitude": "20.80518000",
                        "longitude": "-100.17117000"
                    },
                    {
                        "id": 68848,
                        "name": "Casa Blanca",
                        "latitude": "20.38658000",
                        "longitude": "-100.02009000"
                    },
                    {
                        "id": 68890,
                        "name": "Ceja de Bravo",
                        "latitude": "20.37856000",
                        "longitude": "-100.39423000"
                    },
                    {
                        "id": 68937,
                        "name": "Cerro de la Cruz",
                        "latitude": "20.81474000",
                        "longitude": "-100.50109000"
                    },
                    {
                        "id": 68926,
                        "name": "Cerro Gordo",
                        "latitude": "20.37329000",
                        "longitude": "-99.91385000"
                    },
                    {
                        "id": 68995,
                        "name": "Charco Blanco",
                        "latitude": "20.43404000",
                        "longitude": "-100.47244000"
                    },
                    {
                        "id": 69028,
                        "name": "Chichimequillas",
                        "latitude": "20.76512000",
                        "longitude": "-100.33588000"
                    },
                    {
                        "id": 69258,
                        "name": "Colinas de Santa Cruz Segunda Sección",
                        "latitude": "20.62361000",
                        "longitude": "-100.46667000"
                    },
                    {
                        "id": 69414,
                        "name": "Colón",
                        "latitude": "20.78323000",
                        "longitude": "-100.05149000"
                    },
                    {
                        "id": 69403,
                        "name": "Colonia los Ángeles",
                        "latitude": "20.53523000",
                        "longitude": "-100.48828000"
                    },
                    {
                        "id": 69446,
                        "name": "Concá",
                        "latitude": "21.44477000",
                        "longitude": "-99.63582000"
                    },
                    {
                        "id": 69524,
                        "name": "Coyotillos",
                        "latitude": "20.59938000",
                        "longitude": "-100.20898000"
                    },
                    {
                        "id": 69703,
                        "name": "Dolores Cuadrilla de Enmedio",
                        "latitude": "20.35257000",
                        "longitude": "-100.07967000"
                    },
                    {
                        "id": 69847,
                        "name": "El Blanco",
                        "latitude": "20.61119000",
                        "longitude": "-100.10159000"
                    },
                    {
                        "id": 69873,
                        "name": "El Carmen",
                        "latitude": "20.57445000",
                        "longitude": "-100.28804000"
                    },
                    {
                        "id": 69889,
                        "name": "El Cazadero",
                        "latitude": "20.30011000",
                        "longitude": "-99.87186000"
                    },
                    {
                        "id": 69905,
                        "name": "El Ciervo",
                        "latitude": "20.61834000",
                        "longitude": "-99.87242000"
                    },
                    {
                        "id": 69912,
                        "name": "El Colorado",
                        "latitude": "20.56185000",
                        "longitude": "-100.24520000"
                    },
                    {
                        "id": 69931,
                        "name": "El Coto",
                        "latitude": "20.39491000",
                        "longitude": "-100.13465000"
                    },
                    {
                        "id": 69976,
                        "name": "El Gallo",
                        "latitude": "20.66973000",
                        "longitude": "-100.04677000"
                    },
                    {
                        "id": 69999,
                        "name": "El Jaral",
                        "latitude": "20.40647000",
                        "longitude": "-100.45524000"
                    },
                    {
                        "id": 70002,
                        "name": "El Jazmín",
                        "latitude": "20.34444000",
                        "longitude": "-100.04667000"
                    },
                    {
                        "id": 70026,
                        "name": "El Lobo",
                        "latitude": "20.72904000",
                        "longitude": "-100.20226000"
                    },
                    {
                        "id": 70037,
                        "name": "El Milagro",
                        "latitude": "20.47429000",
                        "longitude": "-100.34918000"
                    },
                    {
                        "id": 70052,
                        "name": "El Nabo",
                        "latitude": "20.69389000",
                        "longitude": "-100.48028000"
                    },
                    {
                        "id": 70073,
                        "name": "El Organal",
                        "latitude": "20.47751000",
                        "longitude": "-100.05457000"
                    },
                    {
                        "id": 70078,
                        "name": "El Palmar",
                        "latitude": "20.69347000",
                        "longitude": "-99.70645000"
                    },
                    {
                        "id": 70089,
                        "name": "El Paraíso",
                        "latitude": "20.56402000",
                        "longitude": "-100.21617000"
                    },
                    {
                        "id": 70105,
                        "name": "El Pinto",
                        "latitude": "20.80270000",
                        "longitude": "-100.41096000"
                    },
                    {
                        "id": 70129,
                        "name": "El Pozo",
                        "latitude": "20.63750000",
                        "longitude": "-100.33306000"
                    },
                    {
                        "id": 70136,
                        "name": "El Pueblito",
                        "latitude": "20.53996000",
                        "longitude": "-100.43817000"
                    },
                    {
                        "id": 70159,
                        "name": "El Rincón",
                        "latitude": "20.74111000",
                        "longitude": "-99.78472000"
                    },
                    {
                        "id": 70177,
                        "name": "El Rosario",
                        "latitude": "20.39180000",
                        "longitude": "-100.06583000"
                    },
                    {
                        "id": 70187,
                        "name": "El Salitre",
                        "latitude": "20.66596000",
                        "longitude": "-100.42288000"
                    },
                    {
                        "id": 70204,
                        "name": "El Saúz",
                        "latitude": "20.47774000",
                        "longitude": "-100.11540000"
                    },
                    {
                        "id": 70215,
                        "name": "El Tejocote",
                        "latitude": "20.61976000",
                        "longitude": "-100.03447000"
                    },
                    {
                        "id": 70250,
                        "name": "El Vegil",
                        "latitude": "20.43111000",
                        "longitude": "-100.35024000"
                    },
                    {
                        "id": 70311,
                        "name": "Epigmenio González",
                        "latitude": "20.55090000",
                        "longitude": "-100.16505000"
                    },
                    {
                        "id": 70319,
                        "name": "Escolasticas",
                        "latitude": "20.42809000",
                        "longitude": "-100.21186000"
                    },
                    {
                        "id": 70328,
                        "name": "Esperanza",
                        "latitude": "20.64610000",
                        "longitude": "-100.11128000"
                    },
                    {
                        "id": 70391,
                        "name": "Ezequiel Montes",
                        "latitude": "20.66481000",
                        "longitude": "-99.89960000"
                    },
                    {
                        "id": 70497,
                        "name": "Fuentezuelas",
                        "latitude": "20.55586000",
                        "longitude": "-99.98209000"
                    },
                    {
                        "id": 70514,
                        "name": "Galeras",
                        "latitude": "20.61759000",
                        "longitude": "-100.15731000"
                    },
                    {
                        "id": 70515,
                        "name": "Galindo",
                        "latitude": "20.39725000",
                        "longitude": "-100.09840000"
                    },
                    {
                        "id": 70541,
                        "name": "General Lázaro Cárdenas (El Colorado)",
                        "latitude": "20.56389000",
                        "longitude": "-100.24389000"
                    },
                    {
                        "id": 70591,
                        "name": "Guadalupe Septién",
                        "latitude": "20.52746000",
                        "longitude": "-100.11352000"
                    },
                    {
                        "id": 70660,
                        "name": "Hacienda la Cruz [Fraccionamiento]",
                        "latitude": "20.63333000",
                        "longitude": "-100.26278000"
                    },
                    {
                        "id": 70697,
                        "name": "Higuerillas",
                        "latitude": "20.91625000",
                        "longitude": "-99.76556000"
                    },
                    {
                        "id": 70796,
                        "name": "Huimilpan",
                        "latitude": "20.37199000",
                        "longitude": "-100.27737000"
                    },
                    {
                        "id": 70844,
                        "name": "Ignacio Pérez",
                        "latitude": "20.52225000",
                        "longitude": "-100.11129000"
                    },
                    {
                        "id": 70979,
                        "name": "Jalpan",
                        "latitude": "21.21802000",
                        "longitude": "-99.47152000"
                    },
                    {
                        "id": 71031,
                        "name": "Jesús María",
                        "latitude": "20.62274000",
                        "longitude": "-100.25631000"
                    },
                    {
                        "id": 71063,
                        "name": "Joaquín Herrera",
                        "latitude": "20.48300000",
                        "longitude": "-100.43854000"
                    },
                    {
                        "id": 71068,
                        "name": "Jofrito",
                        "latitude": "20.86154000",
                        "longitude": "-100.41884000"
                    },
                    {
                        "id": 71142,
                        "name": "Juriquilla",
                        "latitude": "20.71277000",
                        "longitude": "-100.45568000"
                    },
                    {
                        "id": 71182,
                        "name": "La Barreta",
                        "latitude": "20.82806000",
                        "longitude": "-100.50647000"
                    },
                    {
                        "id": 71206,
                        "name": "La Cañada",
                        "latitude": "20.60805000",
                        "longitude": "-100.33275000"
                    },
                    {
                        "id": 71211,
                        "name": "La Ceja",
                        "latitude": "20.38026000",
                        "longitude": "-100.26505000"
                    },
                    {
                        "id": 71257,
                        "name": "La D",
                        "latitude": "20.44046000",
                        "longitude": "-100.15296000"
                    },
                    {
                        "id": 71279,
                        "name": "La Estacada",
                        "latitude": "20.82151000",
                        "longitude": "-100.40763000"
                    },
                    {
                        "id": 71281,
                        "name": "La Estancia",
                        "latitude": "20.42123000",
                        "longitude": "-100.06616000"
                    },
                    {
                        "id": 71296,
                        "name": "La Fuente",
                        "latitude": "20.55255000",
                        "longitude": "-100.03591000"
                    },
                    {
                        "id": 71306,
                        "name": "La Gotera",
                        "latitude": "20.86319000",
                        "longitude": "-100.37575000"
                    },
                    {
                        "id": 71308,
                        "name": "La Griega",
                        "latitude": "20.66642000",
                        "longitude": "-100.24012000"
                    },
                    {
                        "id": 71349,
                        "name": "La Laja",
                        "latitude": "20.57468000",
                        "longitude": "-99.98070000"
                    },
                    {
                        "id": 71360,
                        "name": "La Lira",
                        "latitude": "20.47554000",
                        "longitude": "-100.16145000"
                    },
                    {
                        "id": 71361,
                        "name": "La Llave",
                        "latitude": "20.46628000",
                        "longitude": "-99.99373000"
                    },
                    {
                        "id": 71366,
                        "name": "La Loma",
                        "latitude": "20.60000000",
                        "longitude": "-100.23889000"
                    },
                    {
                        "id": 71377,
                        "name": "La Luz",
                        "latitude": "20.86857000",
                        "longitude": "-100.43839000"
                    },
                    {
                        "id": 71403,
                        "name": "La Monja",
                        "latitude": "20.84275000",
                        "longitude": "-100.49754000"
                    },
                    {
                        "id": 71404,
                        "name": "La Negreta",
                        "latitude": "20.52647000",
                        "longitude": "-100.45053000"
                    },
                    {
                        "id": 71406,
                        "name": "La Noria",
                        "latitude": "20.51261000",
                        "longitude": "-100.34610000"
                    },
                    {
                        "id": 71420,
                        "name": "La Palma",
                        "latitude": "20.52219000",
                        "longitude": "-100.17392000"
                    },
                    {
                        "id": 71446,
                        "name": "La Piedad",
                        "latitude": "20.57890000",
                        "longitude": "-100.25573000"
                    },
                    {
                        "id": 71456,
                        "name": "La Pradera",
                        "latitude": "20.65889000",
                        "longitude": "-100.34222000"
                    },
                    {
                        "id": 71489,
                        "name": "La Solana",
                        "latitude": "20.73835000",
                        "longitude": "-100.39469000"
                    },
                    {
                        "id": 71495,
                        "name": "La Soledad",
                        "latitude": "20.16944000",
                        "longitude": "-100.19111000"
                    },
                    {
                        "id": 71506,
                        "name": "La Tortuga",
                        "latitude": "20.56703000",
                        "longitude": "-99.92317000"
                    },
                    {
                        "id": 71508,
                        "name": "La Trinidad",
                        "latitude": "20.51560000",
                        "longitude": "-99.96283000"
                    },
                    {
                        "id": 71526,
                        "name": "La Valla",
                        "latitude": "20.49966000",
                        "longitude": "-100.02689000"
                    },
                    {
                        "id": 71530,
                        "name": "La Versolilla",
                        "latitude": "20.87306000",
                        "longitude": "-100.37889000"
                    },
                    {
                        "id": 71556,
                        "name": "Laguna de Vaquerías",
                        "latitude": "20.35392000",
                        "longitude": "-100.13515000"
                    },
                    {
                        "id": 71564,
                        "name": "Lagunillas",
                        "latitude": "20.45876000",
                        "longitude": "-100.29500000"
                    },
                    {
                        "id": 71568,
                        "name": "Landa de Matamoros",
                        "latitude": "21.18484000",
                        "longitude": "-99.31985000"
                    },
                    {
                        "id": 71608,
                        "name": "Las Lajitas",
                        "latitude": "20.80360000",
                        "longitude": "-100.40107000"
                    },
                    {
                        "id": 71641,
                        "name": "Las Taponas",
                        "latitude": "20.41747000",
                        "longitude": "-100.38421000"
                    },
                    {
                        "id": 71722,
                        "name": "Loma Linda",
                        "latitude": "20.40079000",
                        "longitude": "-100.03132000"
                    },
                    {
                        "id": 71778,
                        "name": "Los Baños",
                        "latitude": "20.79050000",
                        "longitude": "-100.31310000"
                    },
                    {
                        "id": 71779,
                        "name": "Los Benitos",
                        "latitude": "20.68500000",
                        "longitude": "-99.95611000"
                    },
                    {
                        "id": 71788,
                        "name": "Los Cerritos",
                        "latitude": "20.56204000",
                        "longitude": "-100.06338000"
                    },
                    {
                        "id": 71795,
                        "name": "Los Cues",
                        "latitude": "20.50194000",
                        "longitude": "-100.26417000"
                    },
                    {
                        "id": 71825,
                        "name": "Los Olvera",
                        "latitude": "20.53434000",
                        "longitude": "-100.40795000"
                    },
                    {
                        "id": 71835,
                        "name": "Los Pocitos",
                        "latitude": "20.80000000",
                        "longitude": "-100.31408000"
                    },
                    {
                        "id": 71875,
                        "name": "Lourdes",
                        "latitude": "20.51271000",
                        "longitude": "-100.47643000"
                    },
                    {
                        "id": 72084,
                        "name": "Mesillas",
                        "latitude": "20.13653000",
                        "longitude": "-100.00157000"
                    },
                    {
                        "id": 72190,
                        "name": "Mompaní",
                        "latitude": "20.69214000",
                        "longitude": "-100.50679000"
                    },
                    {
                        "id": 72216,
                        "name": "Montenegro",
                        "latitude": "20.76333000",
                        "longitude": "-100.42861000"
                    },
                    {
                        "id": 72333,
                        "name": "Ninguno [CERESO]",
                        "latitude": "20.67361000",
                        "longitude": "-100.36028000"
                    },
                    {
                        "id": 72351,
                        "name": "Noria Nueva",
                        "latitude": "20.55671000",
                        "longitude": "-100.12502000"
                    },
                    {
                        "id": 72488,
                        "name": "Ojo de Agua",
                        "latitude": "20.34746000",
                        "longitude": "-100.03528000"
                    },
                    {
                        "id": 72595,
                        "name": "Palmillas",
                        "latitude": "20.33631000",
                        "longitude": "-99.94035000"
                    },
                    {
                        "id": 72605,
                        "name": "Palo Alto",
                        "latitude": "20.54065000",
                        "longitude": "-100.22130000"
                    },
                    {
                        "id": 72673,
                        "name": "Paseos del Marqués",
                        "latitude": "20.60389000",
                        "longitude": "-100.24028000"
                    },
                    {
                        "id": 72674,
                        "name": "Paseos del Pedregal",
                        "latitude": "20.66417000",
                        "longitude": "-100.39806000"
                    },
                    {
                        "id": 72688,
                        "name": "Paso de Mata",
                        "latitude": "20.34230000",
                        "longitude": "-99.92712000"
                    },
                    {
                        "id": 72711,
                        "name": "Patria Nueva",
                        "latitude": "20.63222000",
                        "longitude": "-100.47694000"
                    },
                    {
                        "id": 72725,
                        "name": "Pedro Escobedo",
                        "latitude": "20.49963000",
                        "longitude": "-100.14278000"
                    },
                    {
                        "id": 72752,
                        "name": "Peñamiller",
                        "latitude": "21.05408000",
                        "longitude": "-99.81573000"
                    },
                    {
                        "id": 72763,
                        "name": "Pie de Gallo",
                        "latitude": "20.78351000",
                        "longitude": "-100.49243000"
                    },
                    {
                        "id": 72778,
                        "name": "Pinal de Amoles",
                        "latitude": "21.13448000",
                        "longitude": "-99.62590000"
                    },
                    {
                        "id": 72783,
                        "name": "Pintillo",
                        "latitude": "20.79667000",
                        "longitude": "-100.41694000"
                    },
                    {
                        "id": 72888,
                        "name": "Presa de Rayas",
                        "latitude": "20.80712000",
                        "longitude": "-100.22252000"
                    },
                    {
                        "id": 72962,
                        "name": "Puerta de Palmillas",
                        "latitude": "20.31204000",
                        "longitude": "-99.91629000"
                    },
                    {
                        "id": 72975,
                        "name": "Puerto de Aguirre",
                        "latitude": "20.80652000",
                        "longitude": "-100.43213000"
                    },
                    {
                        "id": 72977,
                        "name": "Puerto de Carroza",
                        "latitude": "20.89862000",
                        "longitude": "-100.41164000"
                    },
                    {
                        "id": 72978,
                        "name": "Puerto de Chiquihuite",
                        "latitude": "20.70083000",
                        "longitude": "-99.83528000"
                    },
                    {
                        "id": 72979,
                        "name": "Puerto de Nieto",
                        "latitude": "20.88975000",
                        "longitude": "-100.53814000"
                    },
                    {
                        "id": 72995,
                        "name": "Purísima de Arista",
                        "latitude": "21.31090000",
                        "longitude": "-99.51215000"
                    },
                    {
                        "id": 72998,
                        "name": "Purísima de Cubos (La Purísima)",
                        "latitude": "20.60028000",
                        "longitude": "-100.11833000"
                    },
                    {
                        "id": 73025,
                        "name": "Querétaro",
                        "latitude": "20.72105000",
                        "longitude": "-100.44738000"
                    },
                    {
                        "id": 73058,
                        "name": "Rancho Bellavista [Fraccionamiento]",
                        "latitude": "20.60667000",
                        "longitude": "-100.44972000"
                    },
                    {
                        "id": 73211,
                        "name": "Saldarriaga",
                        "latitude": "20.62781000",
                        "longitude": "-100.29307000"
                    },
                    {
                        "id": 73367,
                        "name": "San Antonio de la Cal",
                        "latitude": "20.76693000",
                        "longitude": "-99.93771000"
                    },
                    {
                        "id": 73468,
                        "name": "San Clemente",
                        "latitude": "20.51509000",
                        "longitude": "-100.08459000"
                    },
                    {
                        "id": 73615,
                        "name": "San Francisco de la Palma",
                        "latitude": "20.66028000",
                        "longitude": "-100.51528000"
                    },
                    {
                        "id": 73659,
                        "name": "San Ildefonso",
                        "latitude": "20.56750000",
                        "longitude": "-100.17262000"
                    },
                    {
                        "id": 73661,
                        "name": "San Ildefonso Tultepec",
                        "latitude": "20.14381000",
                        "longitude": "-99.95946000"
                    },
                    {
                        "id": 73677,
                        "name": "San Isidro Buenavista",
                        "latitude": "20.78874000",
                        "longitude": "-100.44908000"
                    },
                    {
                        "id": 73680,
                        "name": "San Isidro Miranda",
                        "latitude": "20.57018000",
                        "longitude": "-100.32425000"
                    },
                    {
                        "id": 73696,
                        "name": "San Javier",
                        "latitude": "20.75265000",
                        "longitude": "-99.71683000"
                    },
                    {
                        "id": 73751,
                        "name": "San José Buenavista",
                        "latitude": "20.73482000",
                        "longitude": "-100.40997000"
                    },
                    {
                        "id": 73830,
                        "name": "San José de la Laja",
                        "latitude": "20.61844000",
                        "longitude": "-99.97550000"
                    },
                    {
                        "id": 73736,
                        "name": "San Jose de los Olvera",
                        "latitude": "20.55307000",
                        "longitude": "-100.41518000"
                    },
                    {
                        "id": 73836,
                        "name": "San José del Jagüey",
                        "latitude": "20.73722000",
                        "longitude": "-99.92444000"
                    },
                    {
                        "id": 73847,
                        "name": "San José el Alto",
                        "latitude": "20.65339000",
                        "longitude": "-100.38218000"
                    },
                    {
                        "id": 73768,
                        "name": "San José Itho",
                        "latitude": "20.16544000",
                        "longitude": "-100.12704000"
                    },
                    {
                        "id": 73791,
                        "name": "San José Tepuzas",
                        "latitude": "20.35417000",
                        "longitude": "-100.37528000"
                    },
                    {
                        "id": 73976,
                        "name": "San Juan del Río",
                        "latitude": "20.38886000",
                        "longitude": "-99.99577000"
                    },
                    {
                        "id": 74084,
                        "name": "San Martín",
                        "latitude": "20.72282000",
                        "longitude": "-99.97522000"
                    },
                    {
                        "id": 74097,
                        "name": "San Martín Florida",
                        "latitude": "20.75662000",
                        "longitude": "-99.82508000"
                    },
                    {
                        "id": 74161,
                        "name": "San Miguel Amazcala",
                        "latitude": "20.75056000",
                        "longitude": "-100.23556000"
                    },
                    {
                        "id": 74243,
                        "name": "San Miguelito",
                        "latitude": "20.73709000",
                        "longitude": "-100.50276000"
                    },
                    {
                        "id": 74248,
                        "name": "San Nicolás",
                        "latitude": "20.47689000",
                        "longitude": "-99.93749000"
                    },
                    {
                        "id": 74271,
                        "name": "San Nicolás de la Torre",
                        "latitude": "20.07806000",
                        "longitude": "-100.10139000"
                    },
                    {
                        "id": 74302,
                        "name": "San Pablo Tolimán",
                        "latitude": "20.85703000",
                        "longitude": "-99.89985000"
                    },
                    {
                        "id": 74309,
                        "name": "San Pedro",
                        "latitude": "20.32055000",
                        "longitude": "-100.28466000"
                    },
                    {
                        "id": 74357,
                        "name": "San Pedro Mártir",
                        "latitude": "20.61795000",
                        "longitude": "-100.47024000"
                    },
                    {
                        "id": 74426,
                        "name": "San Rafael",
                        "latitude": "20.75246000",
                        "longitude": "-100.28583000"
                    },
                    {
                        "id": 74477,
                        "name": "San Sebastián de Las Barrancas Sur",
                        "latitude": "20.26565000",
                        "longitude": "-99.93622000"
                    },
                    {
                        "id": 74509,
                        "name": "San Vicente el Alto",
                        "latitude": "20.56857000",
                        "longitude": "-100.16495000"
                    },
                    {
                        "id": 74500,
                        "name": "San Vicente Ferrer",
                        "latitude": "20.72703000",
                        "longitude": "-100.34584000"
                    },
                    {
                        "id": 74568,
                        "name": "Santa Bárbara de La Cueva",
                        "latitude": "20.29632000",
                        "longitude": "-99.96296000"
                    },
                    {
                        "id": 74578,
                        "name": "Santa Catarina",
                        "latitude": "20.77678000",
                        "longitude": "-100.45233000"
                    },
                    {
                        "id": 74610,
                        "name": "Santa Cruz",
                        "latitude": "20.71179000",
                        "longitude": "-100.30414000"
                    },
                    {
                        "id": 74623,
                        "name": "Santa Cruz Escandón",
                        "latitude": "20.41603000",
                        "longitude": "-99.95563000"
                    },
                    {
                        "id": 74721,
                        "name": "Santa María Begoña",
                        "latitude": "20.74662000",
                        "longitude": "-100.31765000"
                    },
                    {
                        "id": 74755,
                        "name": "Santa María Magdalena",
                        "latitude": "20.59690000",
                        "longitude": "-100.44749000"
                    },
                    {
                        "id": 74824,
                        "name": "Santa Matilde",
                        "latitude": "20.43268000",
                        "longitude": "-100.02611000"
                    },
                    {
                        "id": 74848,
                        "name": "Santa Rosa de Lima",
                        "latitude": "20.66565000",
                        "longitude": "-99.97851000"
                    },
                    {
                        "id": 74843,
                        "name": "Santa Rosa Jauregui",
                        "latitude": "20.74122000",
                        "longitude": "-100.44843000"
                    },
                    {
                        "id": 74847,
                        "name": "Santa Rosa Xajay",
                        "latitude": "20.43667000",
                        "longitude": "-99.89923000"
                    },
                    {
                        "id": 74985,
                        "name": "Santiago de Querétaro",
                        "latitude": "20.58806000",
                        "longitude": "-100.38806000"
                    },
                    {
                        "id": 74923,
                        "name": "Santiago Mexquititlán Barrio 4to.",
                        "latitude": "20.06306000",
                        "longitude": "-100.06833000"
                    },
                    {
                        "id": 74992,
                        "name": "Santillán",
                        "latitude": "20.60073000",
                        "longitude": "-99.93951000"
                    },
                    {
                        "id": 75062,
                        "name": "Sergio Villaseñor",
                        "latitude": "20.64500000",
                        "longitude": "-100.42083000"
                    },
                    {
                        "id": 75463,
                        "name": "Tequisquiapan",
                        "latitude": "20.52250000",
                        "longitude": "-99.89167000"
                    },
                    {
                        "id": 75543,
                        "name": "Tierra Blanca",
                        "latitude": "20.78026000",
                        "longitude": "-100.38000000"
                    },
                    {
                        "id": 75614,
                        "name": "Tlacote el Bajo",
                        "latitude": "20.66139000",
                        "longitude": "-100.50769000"
                    },
                    {
                        "id": 75721,
                        "name": "Tolimán",
                        "latitude": "20.90845000",
                        "longitude": "-99.93040000"
                    },
                    {
                        "id": 75889,
                        "name": "Urecho",
                        "latitude": "20.65388000",
                        "longitude": "-100.07402000"
                    },
                    {
                        "id": 75951,
                        "name": "Venceremos",
                        "latitude": "20.55083000",
                        "longitude": "-100.39806000"
                    },
                    {
                        "id": 75968,
                        "name": "Viborillas",
                        "latitude": "20.60882000",
                        "longitude": "-100.18558000"
                    },
                    {
                        "id": 76006,
                        "name": "Villa Guerrero",
                        "latitude": "20.69704000",
                        "longitude": "-99.76093000"
                    },
                    {
                        "id": 76041,
                        "name": "Villa Progreso",
                        "latitude": "20.64234000",
                        "longitude": "-99.83501000"
                    },
                    {
                        "id": 76086,
                        "name": "Villas Fundadores [Fraccionamiento]",
                        "latitude": "20.37778000",
                        "longitude": "-99.90944000"
                    },
                    {
                        "id": 76096,
                        "name": "Vista Hermosa (Cuasinada)",
                        "latitude": "20.36861000",
                        "longitude": "-100.01250000"
                    },
                    {
                        "id": 76098,
                        "name": "Visthá",
                        "latitude": "20.44670000",
                        "longitude": "-99.97673000"
                    },
                    {
                        "id": 76102,
                        "name": "Vizarrón",
                        "latitude": "20.83218000",
                        "longitude": "-99.72011000"
                    },
                    {
                        "id": 76245,
                        "name": "Yosphí",
                        "latitude": "20.17083000",
                        "longitude": "-99.95222000"
                    },
                    {
                        "id": 76296,
                        "name": "Zamorano",
                        "latitude": "20.80819000",
                        "longitude": "-100.11797000"
                    }
                ]
            },
            {
                "id": 3467,
                "name": "Quintana Roo",
                "iso2": "ROO",
                "latitude": "19.18173930",
                "longitude": "-88.47913760",
                "type": "state",
                "cities": [
                    {
                        "id": 68171,
                        "name": "Akumal",
                        "latitude": "20.39693000",
                        "longitude": "-87.31444000"
                    },
                    {
                        "id": 68198,
                        "name": "Alfredo V. Bonfil",
                        "latitude": "21.08776000",
                        "longitude": "-86.84706000"
                    },
                    {
                        "id": 76397,
                        "name": "Álvaro Obregón",
                        "latitude": "18.29900000",
                        "longitude": "-88.65145000"
                    },
                    {
                        "id": 68483,
                        "name": "Bacalar",
                        "latitude": "18.68109000",
                        "longitude": "-88.39333000"
                    },
                    {
                        "id": 68602,
                        "name": "Benito Juárez",
                        "latitude": "21.02029000",
                        "longitude": "-87.04101000"
                    },
                    {
                        "id": 68714,
                        "name": "Cacao",
                        "latitude": "18.19458000",
                        "longitude": "-88.69529000"
                    },
                    {
                        "id": 68730,
                        "name": "Calderitas",
                        "latitude": "18.55564000",
                        "longitude": "-88.25518000"
                    },
                    {
                        "id": 68787,
                        "name": "Cancún",
                        "latitude": "21.17429000",
                        "longitude": "-86.84656000"
                    },
                    {
                        "id": 68803,
                        "name": "Caobas",
                        "latitude": "18.44497000",
                        "longitude": "-89.10498000"
                    },
                    {
                        "id": 68825,
                        "name": "Carlos A. Madrazo",
                        "latitude": "18.50172000",
                        "longitude": "-88.52508000"
                    },
                    {
                        "id": 69009,
                        "name": "Chetumal",
                        "latitude": "18.51413000",
                        "longitude": "-88.30381000"
                    },
                    {
                        "id": 69090,
                        "name": "Chiquilá",
                        "latitude": "21.43273000",
                        "longitude": "-87.33559000"
                    },
                    {
                        "id": 69119,
                        "name": "Chunhuhub",
                        "latitude": "19.58533000",
                        "longitude": "-88.59220000"
                    },
                    {
                        "id": 69149,
                        "name": "Ciudad Chemuyil",
                        "latitude": "20.34861000",
                        "longitude": "-87.35306000"
                    },
                    {
                        "id": 69234,
                        "name": "Coba",
                        "latitude": "20.48298000",
                        "longitude": "-87.73888000"
                    },
                    {
                        "id": 69241,
                        "name": "Cocoyol",
                        "latitude": "18.16448000",
                        "longitude": "-88.69080000"
                    },
                    {
                        "id": 69531,
                        "name": "Cozumel",
                        "latitude": "20.50038000",
                        "longitude": "-86.94272000"
                    },
                    {
                        "id": 69745,
                        "name": "Dziuche",
                        "latitude": "19.89744000",
                        "longitude": "-88.80949000"
                    },
                    {
                        "id": 69748,
                        "name": "Dzula",
                        "latitude": "19.60328000",
                        "longitude": "-88.41566000"
                    },
                    {
                        "id": 70229,
                        "name": "El Tintal",
                        "latitude": "20.89194000",
                        "longitude": "-87.46611000"
                    },
                    {
                        "id": 70394,
                        "name": "Felipe Carrillo Puerto",
                        "latitude": "19.57750000",
                        "longitude": "-88.04529000"
                    },
                    {
                        "id": 70749,
                        "name": "Huay Max",
                        "latitude": "20.04173000",
                        "longitude": "-88.52588000"
                    },
                    {
                        "id": 70750,
                        "name": "Huay-Pix",
                        "latitude": "18.51664000",
                        "longitude": "-88.42614000"
                    },
                    {
                        "id": 70855,
                        "name": "Ignacio Zaragoza",
                        "latitude": "20.88167000",
                        "longitude": "-87.52500000"
                    },
                    {
                        "id": 70884,
                        "name": "Isla Holbox",
                        "latitude": "21.52391000",
                        "longitude": "-87.37798000"
                    },
                    {
                        "id": 70885,
                        "name": "Isla Mujeres",
                        "latitude": "21.23114000",
                        "longitude": "-86.73105000"
                    },
                    {
                        "id": 71015,
                        "name": "Javier Rojo Gómez",
                        "latitude": "18.27389000",
                        "longitude": "-88.68111000"
                    },
                    {
                        "id": 71098,
                        "name": "José María Morelos",
                        "latitude": "19.74887000",
                        "longitude": "-88.70866000"
                    },
                    {
                        "id": 71086,
                        "name": "Jose Narciso Rovirosa",
                        "latitude": "18.10620000",
                        "longitude": "-88.72565000"
                    },
                    {
                        "id": 71127,
                        "name": "Juan Sarabia",
                        "latitude": "18.50035000",
                        "longitude": "-88.48013000"
                    },
                    {
                        "id": 71152,
                        "name": "Kancabchén",
                        "latitude": "19.71492000",
                        "longitude": "-88.86211000"
                    },
                    {
                        "id": 71154,
                        "name": "Kantunilkín",
                        "latitude": "21.10182000",
                        "longitude": "-87.48644000"
                    },
                    {
                        "id": 71460,
                        "name": "La Presumida",
                        "latitude": "19.80083000",
                        "longitude": "-88.75389000"
                    },
                    {
                        "id": 71519,
                        "name": "La Unión",
                        "latitude": "17.89918000",
                        "longitude": "-88.88092000"
                    },
                    {
                        "id": 71895,
                        "name": "Lázaro Cárdenas",
                        "latitude": "20.99900000",
                        "longitude": "-87.44275000"
                    },
                    {
                        "id": 71659,
                        "name": "Leona Vicario",
                        "latitude": "20.98970000",
                        "longitude": "-87.20224000"
                    },
                    {
                        "id": 71797,
                        "name": "Los Divorciados",
                        "latitude": "19.07687000",
                        "longitude": "-88.45647000"
                    },
                    {
                        "id": 72029,
                        "name": "Maya Balam",
                        "latitude": "18.93917000",
                        "longitude": "-88.39972000"
                    },
                    {
                        "id": 72237,
                        "name": "Morocoy",
                        "latitude": "18.60324000",
                        "longitude": "-88.81097000"
                    },
                    {
                        "id": 72319,
                        "name": "Nicolás Bravo",
                        "latitude": "18.45910000",
                        "longitude": "-88.92802000"
                    },
                    {
                        "id": 72422,
                        "name": "Nuevo Xcán",
                        "latitude": "20.86917000",
                        "longitude": "-87.60306000"
                    },
                    {
                        "id": 72540,
                        "name": "Othón P. Blanco",
                        "latitude": "18.52309000",
                        "longitude": "-88.38672000"
                    },
                    {
                        "id": 72814,
                        "name": "Playa del Carmen",
                        "latitude": "20.62740000",
                        "longitude": "-87.07987000"
                    },
                    {
                        "id": 72842,
                        "name": "Polyuc",
                        "latitude": "19.60889000",
                        "longitude": "-88.56148000"
                    },
                    {
                        "id": 72892,
                        "name": "Presidente Juárez",
                        "latitude": "19.32836000",
                        "longitude": "-88.56164000"
                    },
                    {
                        "id": 72924,
                        "name": "Pucté",
                        "latitude": "18.23237000",
                        "longitude": "-88.66760000"
                    },
                    {
                        "id": 72966,
                        "name": "Puerto Aventuras",
                        "latitude": "20.50075000",
                        "longitude": "-87.22647000"
                    },
                    {
                        "id": 73188,
                        "name": "Saban",
                        "latitude": "20.03450000",
                        "longitude": "-88.53891000"
                    },
                    {
                        "id": 73194,
                        "name": "Sabidos",
                        "latitude": "18.35716000",
                        "longitude": "-88.58743000"
                    },
                    {
                        "id": 73310,
                        "name": "San Angel",
                        "latitude": "21.23535000",
                        "longitude": "-87.43156000"
                    },
                    {
                        "id": 74845,
                        "name": "Santa Rosa Segundo",
                        "latitude": "19.97778000",
                        "longitude": "-88.26250000"
                    },
                    {
                        "id": 75067,
                        "name": "Señor",
                        "latitude": "19.84424000",
                        "longitude": "-88.13524000"
                    },
                    {
                        "id": 75061,
                        "name": "Sergio Butrón Casas",
                        "latitude": "18.51390000",
                        "longitude": "-88.56883000"
                    },
                    {
                        "id": 75136,
                        "name": "Subteniente López",
                        "latitude": "18.49546000",
                        "longitude": "-88.39126000"
                    },
                    {
                        "id": 75448,
                        "name": "Tepich",
                        "latitude": "20.24212000",
                        "longitude": "-88.25694000"
                    },
                    {
                        "id": 75559,
                        "name": "Tihosuco",
                        "latitude": "20.19642000",
                        "longitude": "-88.37361000"
                    },
                    {
                        "id": 75804,
                        "name": "Tulum",
                        "latitude": "20.22618000",
                        "longitude": "-87.51702000"
                    },
                    {
                        "id": 75863,
                        "name": "Ucum",
                        "latitude": "18.50258000",
                        "longitude": "-88.51836000"
                    },
                    {
                        "id": 76105,
                        "name": "X Cabil",
                        "latitude": "20.16542000",
                        "longitude": "-88.46398000"
                    },
                    {
                        "id": 76107,
                        "name": "X-Hazil Sur",
                        "latitude": "19.39167000",
                        "longitude": "-88.07417000"
                    },
                    {
                        "id": 76108,
                        "name": "X-pichil",
                        "latitude": "19.69529000",
                        "longitude": "-88.37681000"
                    },
                    {
                        "id": 76207,
                        "name": "Xul-Ha",
                        "latitude": "18.55108000",
                        "longitude": "-88.46363000"
                    },
                    {
                        "id": 76255,
                        "name": "Zacalaca",
                        "latitude": "20.06240000",
                        "longitude": "-88.59606000"
                    },
                    {
                        "id": 76361,
                        "name": "Zona Urbana Ejido Isla Mujeres",
                        "latitude": "21.22472000",
                        "longitude": "-86.85361000"
                    }
                ]
            },
            {
                "id": 3461,
                "name": "San Luis Potosí",
                "iso2": "SLP",
                "latitude": "22.15646990",
                "longitude": "-100.98554090",
                "type": "state",
                "cities": [
                    {
                        "id": 68106,
                        "name": "Agua Buena",
                        "latitude": "21.95791000",
                        "longitude": "-99.39416000"
                    },
                    {
                        "id": 68116,
                        "name": "Agua Señora",
                        "latitude": "22.23750000",
                        "longitude": "-101.04222000"
                    },
                    {
                        "id": 68142,
                        "name": "Ahualulco del Sonido Trece",
                        "latitude": "22.40019000",
                        "longitude": "-101.16614000"
                    },
                    {
                        "id": 68157,
                        "name": "Ahuehueyo Primero Centro",
                        "latitude": "21.34500000",
                        "longitude": "-98.83722000"
                    },
                    {
                        "id": 68172,
                        "name": "Alaquines",
                        "latitude": "22.12973000",
                        "longitude": "-99.60093000"
                    },
                    {
                        "id": 68174,
                        "name": "Alberto Carrera Torres",
                        "latitude": "21.77240000",
                        "longitude": "-101.01193000"
                    },
                    {
                        "id": 68262,
                        "name": "Ampliación la Hincada",
                        "latitude": "22.21528000",
                        "longitude": "-99.23611000"
                    },
                    {
                        "id": 68326,
                        "name": "Aquismón",
                        "latitude": "21.62159000",
                        "longitude": "-99.01984000"
                    },
                    {
                        "id": 68372,
                        "name": "Arroyos",
                        "latitude": "22.05455000",
                        "longitude": "-100.90520000"
                    },
                    {
                        "id": 68444,
                        "name": "Aurelio Manrique",
                        "latitude": "22.28750000",
                        "longitude": "-98.65083000"
                    },
                    {
                        "id": 68454,
                        "name": "Axtla de Terrazas",
                        "latitude": "21.43923000",
                        "longitude": "-98.87508000"
                    },
                    {
                        "id": 68619,
                        "name": "Bledos",
                        "latitude": "21.84148000",
                        "longitude": "-101.11651000"
                    },
                    {
                        "id": 68624,
                        "name": "Bocas",
                        "latitude": "22.51817000",
                        "longitude": "-101.02186000"
                    },
                    {
                        "id": 69658,
                        "name": "Cárdenas",
                        "latitude": "22.00144000",
                        "longitude": "-99.64247000"
                    },
                    {
                        "id": 68833,
                        "name": "Carranco",
                        "latitude": "21.82002000",
                        "longitude": "-101.09699000"
                    },
                    {
                        "id": 68911,
                        "name": "Cerrito de Jaral",
                        "latitude": "22.22361000",
                        "longitude": "-101.06250000"
                    },
                    {
                        "id": 68912,
                        "name": "Cerrito de Zavala",
                        "latitude": "22.53690000",
                        "longitude": "-100.97683000"
                    },
                    {
                        "id": 68916,
                        "name": "Cerritos",
                        "latitude": "22.42835000",
                        "longitude": "-100.28474000"
                    },
                    {
                        "id": 68936,
                        "name": "Cerro de San Pedro",
                        "latitude": "22.21780000",
                        "longitude": "-100.79961000"
                    },
                    {
                        "id": 68927,
                        "name": "Cerro Gordo",
                        "latitude": "21.97448000",
                        "longitude": "-100.80661000"
                    },
                    {
                        "id": 68961,
                        "name": "Chalchocoyo",
                        "latitude": "21.31444000",
                        "longitude": "-98.79194000"
                    },
                    {
                        "id": 68994,
                        "name": "Charcas",
                        "latitude": "23.12943000",
                        "longitude": "-101.11346000"
                    },
                    {
                        "id": 69038,
                        "name": "Chiconamel",
                        "latitude": "21.36806000",
                        "longitude": "-98.71917000"
                    },
                    {
                        "id": 69196,
                        "name": "Ciudad del Maíz",
                        "latitude": "22.40187000",
                        "longitude": "-99.60468000"
                    },
                    {
                        "id": 69155,
                        "name": "Ciudad Fernández",
                        "latitude": "21.94045000",
                        "longitude": "-100.01153000"
                    },
                    {
                        "id": 69179,
                        "name": "Ciudad Satélite",
                        "latitude": "22.11083000",
                        "longitude": "-100.79583000"
                    },
                    {
                        "id": 69183,
                        "name": "Ciudad Valles",
                        "latitude": "21.99631000",
                        "longitude": "-99.01093000"
                    },
                    {
                        "id": 69404,
                        "name": "Colonia Álvaro Obregón",
                        "latitude": "22.25183000",
                        "longitude": "-99.67416000"
                    },
                    {
                        "id": 69374,
                        "name": "Colonia Veinte de Noviembre",
                        "latitude": "21.97917000",
                        "longitude": "-100.04981000"
                    },
                    {
                        "id": 69478,
                        "name": "Corcovado",
                        "latitude": "22.39517000",
                        "longitude": "-100.69337000"
                    },
                    {
                        "id": 69666,
                        "name": "Damian Carmona",
                        "latitude": "22.09723000",
                        "longitude": "-99.29216000"
                    },
                    {
                        "id": 69681,
                        "name": "Derramaderos",
                        "latitude": "22.57025000",
                        "longitude": "-100.93226000"
                    },
                    {
                        "id": 69731,
                        "name": "Dulce Grande",
                        "latitude": "23.00175000",
                        "longitude": "-102.17405000"
                    },
                    {
                        "id": 76407,
                        "name": "Ébano",
                        "latitude": "22.21808000",
                        "longitude": "-98.37706000"
                    },
                    {
                        "id": 69812,
                        "name": "Ejido el Saucillo",
                        "latitude": "21.83666000",
                        "longitude": "-100.99490000"
                    },
                    {
                        "id": 69766,
                        "name": "Ejido Gogorrón (Ex-Hacienda de Gogorrón)",
                        "latitude": "21.84019000",
                        "longitude": "-100.91138000"
                    },
                    {
                        "id": 69815,
                        "name": "Ejido la Pitahaya (Santo Domingo)",
                        "latitude": "21.60611000",
                        "longitude": "-100.76111000"
                    },
                    {
                        "id": 69818,
                        "name": "Ejido los Huastecos",
                        "latitude": "21.95917000",
                        "longitude": "-98.65028000"
                    },
                    {
                        "id": 69790,
                        "name": "Ejido San José Xilatzén",
                        "latitude": "21.67472000",
                        "longitude": "-98.92750000"
                    },
                    {
                        "id": 69841,
                        "name": "El Barril",
                        "latitude": "23.07509000",
                        "longitude": "-102.15374000"
                    },
                    {
                        "id": 69864,
                        "name": "El Capulín",
                        "latitude": "21.82806000",
                        "longitude": "-100.03743000"
                    },
                    {
                        "id": 69882,
                        "name": "El Carrizal",
                        "latitude": "22.34146000",
                        "longitude": "-101.16778000"
                    },
                    {
                        "id": 69972,
                        "name": "El Fuerte",
                        "latitude": "21.71289000",
                        "longitude": "-100.66445000"
                    },
                    {
                        "id": 69988,
                        "name": "El Huexco",
                        "latitude": "21.34075000",
                        "longitude": "-98.75350000"
                    },
                    {
                        "id": 69995,
                        "name": "El Jabalí",
                        "latitude": "21.88431000",
                        "longitude": "-100.05315000"
                    },
                    {
                        "id": 70000,
                        "name": "El Jaralito",
                        "latitude": "22.03851000",
                        "longitude": "-100.82119000"
                    },
                    {
                        "id": 70057,
                        "name": "El Naranjo",
                        "latitude": "22.52597000",
                        "longitude": "-99.32968000"
                    },
                    {
                        "id": 70101,
                        "name": "El Peñasco",
                        "latitude": "22.32534000",
                        "longitude": "-100.95014000"
                    },
                    {
                        "id": 70174,
                        "name": "El Rosario",
                        "latitude": "21.73411000",
                        "longitude": "-100.92631000"
                    },
                    {
                        "id": 70218,
                        "name": "El Tepetate",
                        "latitude": "22.01344000",
                        "longitude": "-101.24195000"
                    },
                    {
                        "id": 70281,
                        "name": "Emiliano Zapata",
                        "latitude": "21.92149000",
                        "longitude": "-100.91358000"
                    },
                    {
                        "id": 70303,
                        "name": "Enramadas",
                        "latitude": "21.88316000",
                        "longitude": "-100.78204000"
                    },
                    {
                        "id": 70304,
                        "name": "Enrique Estrada",
                        "latitude": "22.24030000",
                        "longitude": "-100.88869000"
                    },
                    {
                        "id": 70309,
                        "name": "Entronque de Matehuala (El Huizache)",
                        "latitude": "22.92500000",
                        "longitude": "-100.45889000"
                    },
                    {
                        "id": 70317,
                        "name": "Escalerillas",
                        "latitude": "22.11167000",
                        "longitude": "-101.07305000"
                    },
                    {
                        "id": 70356,
                        "name": "Estación Tamuín",
                        "latitude": "22.07750000",
                        "longitude": "-98.81111000"
                    },
                    {
                        "id": 70366,
                        "name": "Estanzuela",
                        "latitude": "22.26889000",
                        "longitude": "-101.00806000"
                    },
                    {
                        "id": 70461,
                        "name": "Fracción Milpillas",
                        "latitude": "22.22778000",
                        "longitude": "-100.96417000"
                    },
                    {
                        "id": 70565,
                        "name": "Granjenal",
                        "latitude": "22.39270000",
                        "longitude": "-100.06893000"
                    },
                    {
                        "id": 70569,
                        "name": "Guadalcázar",
                        "latitude": "22.61804000",
                        "longitude": "-100.39936000"
                    },
                    {
                        "id": 70606,
                        "name": "Guadalupe Victoria",
                        "latitude": "22.16333000",
                        "longitude": "-101.07000000"
                    },
                    {
                        "id": 70674,
                        "name": "Hernández",
                        "latitude": "23.03337000",
                        "longitude": "-102.03763000"
                    },
                    {
                        "id": 70691,
                        "name": "Higinio Olivo",
                        "latitude": "21.98012000",
                        "longitude": "-99.57935000"
                    },
                    {
                        "id": 70789,
                        "name": "Huichihuayan",
                        "latitude": "21.48369000",
                        "longitude": "-98.96840000"
                    },
                    {
                        "id": 70866,
                        "name": "Illescas",
                        "latitude": "23.24066000",
                        "longitude": "-102.14463000"
                    },
                    {
                        "id": 70951,
                        "name": "Iztacapa",
                        "latitude": "21.37000000",
                        "longitude": "-98.94167000"
                    },
                    {
                        "id": 70981,
                        "name": "Jalpilla",
                        "latitude": "21.39571000",
                        "longitude": "-98.87229000"
                    },
                    {
                        "id": 71028,
                        "name": "Jesús María",
                        "latitude": "23.15488000",
                        "longitude": "-102.19253000"
                    },
                    {
                        "id": 71272,
                        "name": "La Esperanza",
                        "latitude": "22.00788000",
                        "longitude": "-100.76496000"
                    },
                    {
                        "id": 71314,
                        "name": "La Herradura",
                        "latitude": "21.44250000",
                        "longitude": "-98.94917000"
                    },
                    {
                        "id": 71359,
                        "name": "La Lima",
                        "latitude": "21.92722000",
                        "longitude": "-99.10278000"
                    },
                    {
                        "id": 71393,
                        "name": "La Mesa de los Conejos",
                        "latitude": "22.10316000",
                        "longitude": "-101.05309000"
                    },
                    {
                        "id": 71447,
                        "name": "La Pila",
                        "latitude": "22.03425000",
                        "longitude": "-100.86786000"
                    },
                    {
                        "id": 71474,
                        "name": "La Reforma",
                        "latitude": "21.99879000",
                        "longitude": "-100.09452000"
                    },
                    {
                        "id": 71498,
                        "name": "La Subida",
                        "latitude": "21.90506000",
                        "longitude": "-99.09892000"
                    },
                    {
                        "id": 71528,
                        "name": "La Ventilla",
                        "latitude": "21.77389000",
                        "longitude": "-101.03028000"
                    },
                    {
                        "id": 71553,
                        "name": "Laguna de San Vicente",
                        "latitude": "21.94603000",
                        "longitude": "-100.85926000"
                    },
                    {
                        "id": 71554,
                        "name": "Laguna de Santa Rita",
                        "latitude": "22.11449000",
                        "longitude": "-100.84713000"
                    },
                    {
                        "id": 71558,
                        "name": "Laguna del Mante",
                        "latitude": "22.21954000",
                        "longitude": "-98.98758000"
                    },
                    {
                        "id": 71576,
                        "name": "Las Armas",
                        "latitude": "21.69685000",
                        "longitude": "-98.96752000"
                    },
                    {
                        "id": 71629,
                        "name": "Las Palmas",
                        "latitude": "22.03339000",
                        "longitude": "-98.87407000"
                    },
                    {
                        "id": 71868,
                        "name": "Los Zacatones",
                        "latitude": "22.96139000",
                        "longitude": "-102.05556000"
                    },
                    {
                        "id": 71941,
                        "name": "Maitinez",
                        "latitude": "22.37167000",
                        "longitude": "-99.29306000"
                    },
                    {
                        "id": 71985,
                        "name": "Maravillas",
                        "latitude": "22.23876000",
                        "longitude": "-101.01073000"
                    },
                    {
                        "id": 72002,
                        "name": "Martinez",
                        "latitude": "22.06790000",
                        "longitude": "-99.62546000"
                    },
                    {
                        "id": 72020,
                        "name": "Matehuala",
                        "latitude": "23.64824000",
                        "longitude": "-100.64334000"
                    },
                    {
                        "id": 72177,
                        "name": "Moctezuma",
                        "latitude": "22.74787000",
                        "longitude": "-101.08219000"
                    },
                    {
                        "id": 72204,
                        "name": "Monte Obscuro",
                        "latitude": "22.21972000",
                        "longitude": "-101.02879000"
                    },
                    {
                        "id": 72307,
                        "name": "Negritas",
                        "latitude": "22.79361000",
                        "longitude": "-100.16015000"
                    },
                    {
                        "id": 72355,
                        "name": "Norias del Refugio",
                        "latitude": "23.01334000",
                        "longitude": "-100.47189000"
                    },
                    {
                        "id": 72372,
                        "name": "Nueva Primavera",
                        "latitude": "21.91342000",
                        "longitude": "-98.85785000"
                    },
                    {
                        "id": 72384,
                        "name": "Nuevo Crucitas",
                        "latitude": "22.10833000",
                        "longitude": "-99.20444000"
                    },
                    {
                        "id": 72414,
                        "name": "Nuevo Tampaón",
                        "latitude": "22.06223000",
                        "longitude": "-98.56548000"
                    },
                    {
                        "id": 72472,
                        "name": "Ocuiltzapoyo",
                        "latitude": "21.32444000",
                        "longitude": "-98.72861000"
                    },
                    {
                        "id": 72482,
                        "name": "Ojo Caliente",
                        "latitude": "21.84678000",
                        "longitude": "-100.75375000"
                    },
                    {
                        "id": 72486,
                        "name": "Ojo de Agua",
                        "latitude": "22.44378000",
                        "longitude": "-100.09283000"
                    },
                    {
                        "id": 72494,
                        "name": "Ojo de Agua de Solano",
                        "latitude": "21.98533000",
                        "longitude": "-100.07946000"
                    },
                    {
                        "id": 72578,
                        "name": "Paisanos",
                        "latitude": "22.20361000",
                        "longitude": "-101.03583000"
                    },
                    {
                        "id": 72586,
                        "name": "Palma Pegada",
                        "latitude": "22.71046000",
                        "longitude": "-101.79187000"
                    },
                    {
                        "id": 72590,
                        "name": "Palmar Primero",
                        "latitude": "22.37079000",
                        "longitude": "-101.09827000"
                    },
                    {
                        "id": 72611,
                        "name": "Palo Seco (El Gato)",
                        "latitude": "22.35417000",
                        "longitude": "-100.19194000"
                    },
                    {
                        "id": 72613,
                        "name": "Palomas",
                        "latitude": "22.48124000",
                        "longitude": "-99.84922000"
                    },
                    {
                        "id": 72651,
                        "name": "Pardo",
                        "latitude": "21.88379000",
                        "longitude": "-100.85617000"
                    },
                    {
                        "id": 72676,
                        "name": "Paso Blanco",
                        "latitude": "22.20611000",
                        "longitude": "-101.07056000"
                    },
                    {
                        "id": 72677,
                        "name": "Paso Bonito",
                        "latitude": "22.32528000",
                        "longitude": "-101.26167000"
                    },
                    {
                        "id": 72702,
                        "name": "Pastora",
                        "latitude": "22.13595000",
                        "longitude": "-100.05691000"
                    },
                    {
                        "id": 72727,
                        "name": "Pemucho",
                        "latitude": "21.19738000",
                        "longitude": "-98.83015000"
                    },
                    {
                        "id": 72730,
                        "name": "Peotillos",
                        "latitude": "22.49386000",
                        "longitude": "-100.61128000"
                    },
                    {
                        "id": 72760,
                        "name": "Picholco",
                        "latitude": "21.38797000",
                        "longitude": "-98.85338000"
                    },
                    {
                        "id": 72848,
                        "name": "Ponciano Arriaga",
                        "latitude": "22.26222000",
                        "longitude": "-98.58972000"
                    },
                    {
                        "id": 72856,
                        "name": "Portezuelo",
                        "latitude": "22.16980000",
                        "longitude": "-100.82559000"
                    },
                    {
                        "id": 72877,
                        "name": "Pozuelos",
                        "latitude": "22.08943000",
                        "longitude": "-101.11523000"
                    },
                    {
                        "id": 72913,
                        "name": "Progreso",
                        "latitude": "22.22833000",
                        "longitude": "-100.12806000"
                    },
                    {
                        "id": 72980,
                        "name": "Puerto de Providencia",
                        "latitude": "22.36528000",
                        "longitude": "-101.06556000"
                    },
                    {
                        "id": 72984,
                        "name": "Pujal-Coy",
                        "latitude": "22.17600000",
                        "longitude": "-98.50512000"
                    },
                    {
                        "id": 73064,
                        "name": "Rancho Nuevo",
                        "latitude": "22.22216000",
                        "longitude": "-100.92287000"
                    },
                    {
                        "id": 73081,
                        "name": "Rascón",
                        "latitude": "21.97075000",
                        "longitude": "-99.25742000"
                    },
                    {
                        "id": 73086,
                        "name": "Rayón",
                        "latitude": "21.84329000",
                        "longitude": "-99.64258000"
                    },
                    {
                        "id": 73090,
                        "name": "Real de Catorce",
                        "latitude": "23.68996000",
                        "longitude": "-100.88676000"
                    },
                    {
                        "id": 73138,
                        "name": "Rincón del Porvenir",
                        "latitude": "22.32306000",
                        "longitude": "-101.17639000"
                    },
                    {
                        "id": 73112,
                        "name": "Rinconada",
                        "latitude": "22.25332000",
                        "longitude": "-100.94974000"
                    },
                    {
                        "id": 73141,
                        "name": "Rioverde",
                        "latitude": "21.93115000",
                        "longitude": "-99.99488000"
                    },
                    {
                        "id": 73148,
                        "name": "Rodrigo",
                        "latitude": "21.89158000",
                        "longitude": "-100.95363000"
                    },
                    {
                        "id": 73216,
                        "name": "Salinas de Hidalgo",
                        "latitude": "22.62795000",
                        "longitude": "-101.71417000"
                    },
                    {
                        "id": 73217,
                        "name": "Salitral de Carrera",
                        "latitude": "22.86605000",
                        "longitude": "-102.08305000"
                    },
                    {
                        "id": 73467,
                        "name": "San Ciro de Acosta",
                        "latitude": "21.65072000",
                        "longitude": "-99.81916000"
                    },
                    {
                        "id": 73486,
                        "name": "San Diego",
                        "latitude": "21.91692000",
                        "longitude": "-100.10100000"
                    },
                    {
                        "id": 73537,
                        "name": "San Francisco",
                        "latitude": "22.07479000",
                        "longitude": "-99.86001000"
                    },
                    {
                        "id": 73562,
                        "name": "San Francisco Cuayalab",
                        "latitude": "21.73260000",
                        "longitude": "-98.71754000"
                    },
                    {
                        "id": 73666,
                        "name": "San Isidro",
                        "latitude": "23.86600000",
                        "longitude": "-100.77506000"
                    },
                    {
                        "id": 73844,
                        "name": "San José del Tapanco",
                        "latitude": "21.77097000",
                        "longitude": "-99.90847000"
                    },
                    {
                        "id": 74051,
                        "name": "San Luis Potosí",
                        "latitude": "22.14982000",
                        "longitude": "-100.97916000"
                    },
                    {
                        "id": 74092,
                        "name": "San Martín Chalchicuautla",
                        "latitude": "21.37033000",
                        "longitude": "-98.65697000"
                    },
                    {
                        "id": 74250,
                        "name": "San Nicolás",
                        "latitude": "21.67740000",
                        "longitude": "-98.77778000"
                    },
                    {
                        "id": 74265,
                        "name": "San Nicolás Tolentino",
                        "latitude": "22.24898000",
                        "longitude": "-100.55240000"
                    },
                    {
                        "id": 74505,
                        "name": "San Vicente Tancuayalab",
                        "latitude": "21.71886000",
                        "longitude": "-98.58769000"
                    },
                    {
                        "id": 75153,
                        "name": "Sánchez",
                        "latitude": "21.78709000",
                        "longitude": "-100.69615000"
                    },
                    {
                        "id": 74573,
                        "name": "Santa Catarina",
                        "latitude": "21.65624000",
                        "longitude": "-99.49548000"
                    },
                    {
                        "id": 74818,
                        "name": "Santa María del Río",
                        "latitude": "21.79615000",
                        "longitude": "-100.73815000"
                    },
                    {
                        "id": 74697,
                        "name": "Santa Martha",
                        "latitude": "22.34278000",
                        "longitude": "-98.70639000"
                    },
                    {
                        "id": 74828,
                        "name": "Santa Rita",
                        "latitude": "21.98168000",
                        "longitude": "-99.84412000"
                    },
                    {
                        "id": 74887,
                        "name": "Santiago Centro",
                        "latitude": "21.20528000",
                        "longitude": "-98.86361000"
                    },
                    {
                        "id": 74995,
                        "name": "Santo Domingo",
                        "latitude": "22.28325000",
                        "longitude": "-100.16965000"
                    },
                    {
                        "id": 75046,
                        "name": "Sauz de Calera",
                        "latitude": "22.86729000",
                        "longitude": "-102.18755000"
                    },
                    {
                        "id": 75105,
                        "name": "Socavón (El Carmen)",
                        "latitude": "21.85139000",
                        "longitude": "-100.87184000"
                    },
                    {
                        "id": 75117,
                        "name": "Soledad de Graciano Sánchez",
                        "latitude": "22.18912000",
                        "longitude": "-100.93792000"
                    },
                    {
                        "id": 75150,
                        "name": "Suspiro Picacho",
                        "latitude": "22.21103000",
                        "longitude": "-101.08597000"
                    },
                    {
                        "id": 75196,
                        "name": "Tamán",
                        "latitude": "21.23216000",
                        "longitude": "-98.87945000"
                    },
                    {
                        "id": 75198,
                        "name": "Tamápatz",
                        "latitude": "21.56654000",
                        "longitude": "-99.07764000"
                    },
                    {
                        "id": 75175,
                        "name": "Tamasopo",
                        "latitude": "21.92426000",
                        "longitude": "-99.39365000"
                    },
                    {
                        "id": 75184,
                        "name": "Tamazunchale",
                        "latitude": "21.25993000",
                        "longitude": "-98.78935000"
                    },
                    {
                        "id": 75185,
                        "name": "Tambaca",
                        "latitude": "21.96083000",
                        "longitude": "-99.30106000"
                    },
                    {
                        "id": 75186,
                        "name": "Tamcuime",
                        "latitude": "21.60137000",
                        "longitude": "-99.01077000"
                    },
                    {
                        "id": 75188,
                        "name": "Tampacán",
                        "latitude": "21.40201000",
                        "longitude": "-98.72819000"
                    },
                    {
                        "id": 75189,
                        "name": "Tampate",
                        "latitude": "21.63639000",
                        "longitude": "-99.02552000"
                    },
                    {
                        "id": 75190,
                        "name": "Tampemoche",
                        "latitude": "21.68943000",
                        "longitude": "-99.08174000"
                    },
                    {
                        "id": 75195,
                        "name": "Tamuín",
                        "latitude": "22.00554000",
                        "longitude": "-98.77972000"
                    },
                    {
                        "id": 75202,
                        "name": "Tancanhuitz",
                        "latitude": "21.59790000",
                        "longitude": "-98.96773000"
                    },
                    {
                        "id": 75206,
                        "name": "Tandzumadz",
                        "latitude": "21.56528000",
                        "longitude": "-98.98028000"
                    },
                    {
                        "id": 75217,
                        "name": "Tanquián de Escobedo",
                        "latitude": "21.60587000",
                        "longitude": "-98.66275000"
                    },
                    {
                        "id": 75220,
                        "name": "Tanute",
                        "latitude": "21.65243000",
                        "longitude": "-99.03765000"
                    },
                    {
                        "id": 75251,
                        "name": "Tazaquil",
                        "latitude": "21.49111000",
                        "longitude": "-98.94000000"
                    },
                    {
                        "id": 75324,
                        "name": "Temalacaco",
                        "latitude": "21.41389000",
                        "longitude": "-98.84694000"
                    },
                    {
                        "id": 75363,
                        "name": "Tenexio",
                        "latitude": "21.37667000",
                        "longitude": "-98.87944000"
                    },
                    {
                        "id": 75555,
                        "name": "Tierra Nueva",
                        "latitude": "21.66904000",
                        "longitude": "-100.57287000"
                    },
                    {
                        "id": 75623,
                        "name": "Tlacuilola",
                        "latitude": "21.23750000",
                        "longitude": "-98.86806000"
                    },
                    {
                        "id": 75647,
                        "name": "Tlalnepantla",
                        "latitude": "21.18000000",
                        "longitude": "-98.84611000"
                    },
                    {
                        "id": 75716,
                        "name": "Tocoy",
                        "latitude": "21.63861000",
                        "longitude": "-98.87083000"
                    },
                    {
                        "id": 75936,
                        "name": "Vanegas",
                        "latitude": "23.88459000",
                        "longitude": "-100.95148000"
                    },
                    {
                        "id": 76066,
                        "name": "Villa de Ramos",
                        "latitude": "22.83045000",
                        "longitude": "-101.91079000"
                    },
                    {
                        "id": 76067,
                        "name": "Villa de Reyes",
                        "latitude": "21.80309000",
                        "longitude": "-100.93418000"
                    },
                    {
                        "id": 76011,
                        "name": "Villa Hidalgo",
                        "latitude": "22.45049000",
                        "longitude": "-100.67827000"
                    },
                    {
                        "id": 76058,
                        "name": "Villa Zaragoza",
                        "latitude": "22.03716000",
                        "longitude": "-100.73088000"
                    },
                    {
                        "id": 76144,
                        "name": "Xilitla",
                        "latitude": "21.38681000",
                        "longitude": "-98.99009000"
                    },
                    {
                        "id": 76232,
                        "name": "Yerbabuena",
                        "latitude": "21.68586000",
                        "longitude": "-100.76728000"
                    },
                    {
                        "id": 76292,
                        "name": "Zamachihue",
                        "latitude": "22.50986000",
                        "longitude": "-99.65620000"
                    },
                    {
                        "id": 76314,
                        "name": "Zapuyo",
                        "latitude": "21.35472000",
                        "longitude": "-98.92139000"
                    }
                ]
            },
            {
                "id": 3449,
                "name": "Sinaloa",
                "iso2": "SIN",
                "latitude": "25.17210910",
                "longitude": "-107.47951730",
                "type": "state",
                "cities": [
                    {
                        "id": 68092,
                        "name": "Adolfo López Mateos (El Tamarindo)",
                        "latitude": "24.89639000",
                        "longitude": "-107.63278000"
                    },
                    {
                        "id": 68094,
                        "name": "Adolfo Ruiz Cortines",
                        "latitude": "25.70275000",
                        "longitude": "-108.71975000"
                    },
                    {
                        "id": 68109,
                        "name": "Agua Caliente Grande (De Gastélum)",
                        "latitude": "26.53762000",
                        "longitude": "-108.34814000"
                    },
                    {
                        "id": 68117,
                        "name": "Agua Verde",
                        "latitude": "22.89259000",
                        "longitude": "-105.97355000"
                    },
                    {
                        "id": 68131,
                        "name": "Ahome",
                        "latitude": "25.91985000",
                        "longitude": "-109.17320000"
                    },
                    {
                        "id": 68192,
                        "name": "Alfonso G. Calderón (Poblado Siete)",
                        "latitude": "26.06528000",
                        "longitude": "-109.01972000"
                    },
                    {
                        "id": 68193,
                        "name": "Alfonso G. Calderón Velarde",
                        "latitude": "25.78556000",
                        "longitude": "-108.60222000"
                    },
                    {
                        "id": 68200,
                        "name": "Alfredo V. Bonfil (Siete Ejidos)",
                        "latitude": "25.64306000",
                        "longitude": "-108.23333000"
                    },
                    {
                        "id": 68202,
                        "name": "Alhuey",
                        "latitude": "25.37806000",
                        "longitude": "-108.13028000"
                    },
                    {
                        "id": 68225,
                        "name": "Altata",
                        "latitude": "24.63403000",
                        "longitude": "-107.93101000"
                    },
                    {
                        "id": 68274,
                        "name": "Angostura",
                        "latitude": "25.36586000",
                        "longitude": "-108.16107000"
                    },
                    {
                        "id": 68311,
                        "name": "Apoderado",
                        "latitude": "22.90867000",
                        "longitude": "-105.92458000"
                    },
                    {
                        "id": 68478,
                        "name": "Baburia",
                        "latitude": "25.84289000",
                        "longitude": "-108.20276000"
                    },
                    {
                        "id": 68488,
                        "name": "Bachigualatito",
                        "latitude": "24.71344000",
                        "longitude": "-107.46938000"
                    },
                    {
                        "id": 68489,
                        "name": "Bachoco",
                        "latitude": "25.69687000",
                        "longitude": "-108.81437000"
                    },
                    {
                        "id": 68490,
                        "name": "Bachomobampo Número Dos",
                        "latitude": "25.73888000",
                        "longitude": "-109.14776000"
                    },
                    {
                        "id": 68493,
                        "name": "Bacorehuis",
                        "latitude": "26.31749000",
                        "longitude": "-109.08510000"
                    },
                    {
                        "id": 68494,
                        "name": "Bacubirito",
                        "latitude": "25.80944000",
                        "longitude": "-107.91500000"
                    },
                    {
                        "id": 68495,
                        "name": "Badiraguato",
                        "latitude": "25.36525000",
                        "longitude": "-107.55083000"
                    },
                    {
                        "id": 68496,
                        "name": "Bagojo Colectivo",
                        "latitude": "25.87417000",
                        "longitude": "-109.11778000"
                    },
                    {
                        "id": 68509,
                        "name": "Bamoa",
                        "latitude": "25.70523000",
                        "longitude": "-108.34614000"
                    },
                    {
                        "id": 68517,
                        "name": "Bariometo",
                        "latitude": "24.76695000",
                        "longitude": "-107.66254000"
                    },
                    {
                        "id": 68561,
                        "name": "Barrón",
                        "latitude": "23.12322000",
                        "longitude": "-106.27650000"
                    },
                    {
                        "id": 68580,
                        "name": "Bellavista",
                        "latitude": "24.81373000",
                        "longitude": "-107.46188000"
                    },
                    {
                        "id": 68600,
                        "name": "Benito Juárez",
                        "latitude": "25.77373000",
                        "longitude": "-109.03311000"
                    },
                    {
                        "id": 68604,
                        "name": "Benito Juárez (Vinatería)",
                        "latitude": "25.97376000",
                        "longitude": "-108.87315000"
                    },
                    {
                        "id": 68658,
                        "name": "Buen Retiro (El Retiro)",
                        "latitude": "25.46194000",
                        "longitude": "-108.47833000"
                    },
                    {
                        "id": 68711,
                        "name": "Cacalotán",
                        "latitude": "23.06779000",
                        "longitude": "-105.84194000"
                    },
                    {
                        "id": 68720,
                        "name": "Caimanero",
                        "latitude": "25.60564000",
                        "longitude": "-108.44247000"
                    },
                    {
                        "id": 68774,
                        "name": "Campo Balbuena",
                        "latitude": "24.74688000",
                        "longitude": "-107.54975000"
                    },
                    {
                        "id": 68781,
                        "name": "Campo la Arrocera",
                        "latitude": "25.84500000",
                        "longitude": "-108.91833000"
                    },
                    {
                        "id": 68778,
                        "name": "Campo Pesquero el Colorado",
                        "latitude": "25.75828000",
                        "longitude": "-109.31510000"
                    },
                    {
                        "id": 68835,
                        "name": "Carricitos",
                        "latitude": "25.97595000",
                        "longitude": "-108.93130000"
                    },
                    {
                        "id": 68847,
                        "name": "Casa Blanca",
                        "latitude": "25.43036000",
                        "longitude": "-108.42308000"
                    },
                    {
                        "id": 68700,
                        "name": "CERESO Nuevo",
                        "latitude": "25.89139000",
                        "longitude": "-109.04222000"
                    },
                    {
                        "id": 68909,
                        "name": "Cerrillos (Campo 35)",
                        "latitude": "25.87806000",
                        "longitude": "-108.90139000"
                    },
                    {
                        "id": 68920,
                        "name": "Cerro Agudo",
                        "latitude": "25.59796000",
                        "longitude": "-107.96310000"
                    },
                    {
                        "id": 68941,
                        "name": "Ceuta",
                        "latitude": "23.90042000",
                        "longitude": "-106.92847000"
                    },
                    {
                        "id": 68966,
                        "name": "Chametla",
                        "latitude": "22.87750000",
                        "longitude": "-105.95750000"
                    },
                    {
                        "id": 68993,
                        "name": "Charay",
                        "latitude": "26.02140000",
                        "longitude": "-108.83090000"
                    },
                    {
                        "id": 69057,
                        "name": "Chihuahuita",
                        "latitude": "26.15469000",
                        "longitude": "-109.05496000"
                    },
                    {
                        "id": 69086,
                        "name": "Chinobampo",
                        "latitude": "26.39000000",
                        "longitude": "-108.36440000"
                    },
                    {
                        "id": 69100,
                        "name": "Choix",
                        "latitude": "26.70901000",
                        "longitude": "-108.32545000"
                    },
                    {
                        "id": 69250,
                        "name": "Cofradía de Navolato (Cofradía de los Rocha)",
                        "latitude": "24.76806000",
                        "longitude": "-107.64806000"
                    },
                    {
                        "id": 69266,
                        "name": "Colonia 24 de Febrero",
                        "latitude": "25.64722000",
                        "longitude": "-108.64917000"
                    },
                    {
                        "id": 69275,
                        "name": "Colonia Agrícola México (Palmitas)",
                        "latitude": "25.10972000",
                        "longitude": "-107.94472000"
                    },
                    {
                        "id": 69328,
                        "name": "Colonia Michoacana",
                        "latitude": "24.72476000",
                        "longitude": "-107.63201000"
                    },
                    {
                        "id": 69431,
                        "name": "Concentración 5 de Febrero",
                        "latitude": "25.85639000",
                        "longitude": "-108.62944000"
                    },
                    {
                        "id": 69444,
                        "name": "Concordia",
                        "latitude": "23.28694000",
                        "longitude": "-106.06389000"
                    },
                    {
                        "id": 69460,
                        "name": "Constancia",
                        "latitude": "25.96219000",
                        "longitude": "-108.89937000"
                    },
                    {
                        "id": 69479,
                        "name": "Corerepe",
                        "latitude": "25.62786000",
                        "longitude": "-108.71488000"
                    },
                    {
                        "id": 69496,
                        "name": "Cosalá",
                        "latitude": "24.41501000",
                        "longitude": "-106.69073000"
                    },
                    {
                        "id": 69506,
                        "name": "Costa Azul",
                        "latitude": "25.10183000",
                        "longitude": "-108.13735000"
                    },
                    {
                        "id": 69525,
                        "name": "Coyotitán",
                        "latitude": "23.79416000",
                        "longitude": "-106.60080000"
                    },
                    {
                        "id": 69534,
                        "name": "Cristo Rey",
                        "latitude": "22.58167000",
                        "longitude": "-105.72444000"
                    },
                    {
                        "id": 69542,
                        "name": "Cruz Blanca",
                        "latitude": "25.67460000",
                        "longitude": "-108.37090000"
                    },
                    {
                        "id": 69602,
                        "name": "Cubiri de Portelas",
                        "latitude": "25.78677000",
                        "longitude": "-108.25966000"
                    },
                    {
                        "id": 69632,
                        "name": "Culiacán",
                        "latitude": "24.79032000",
                        "longitude": "-107.38782000"
                    },
                    {
                        "id": 69631,
                        "name": "Culiacancito",
                        "latitude": "24.82538000",
                        "longitude": "-107.53445000"
                    },
                    {
                        "id": 69668,
                        "name": "Dautillos",
                        "latitude": "24.72167000",
                        "longitude": "-107.97528000"
                    },
                    {
                        "id": 69722,
                        "name": "Dos de Abril",
                        "latitude": "25.91116000",
                        "longitude": "-108.94077000"
                    },
                    {
                        "id": 69759,
                        "name": "Ejido Cajón Ojo de Agua Número Dos",
                        "latitude": "22.90000000",
                        "longitude": "-105.97139000"
                    },
                    {
                        "id": 69760,
                        "name": "Ejido Cinco de Mayo",
                        "latitude": "25.85055000",
                        "longitude": "-108.95932000"
                    },
                    {
                        "id": 69761,
                        "name": "Ejido Cohuibampo",
                        "latitude": "25.94094000",
                        "longitude": "-109.15880000"
                    },
                    {
                        "id": 69775,
                        "name": "Ejido Mayocoba",
                        "latitude": "25.93824000",
                        "longitude": "-109.22130000"
                    },
                    {
                        "id": 69781,
                        "name": "Ejido Ohuira",
                        "latitude": "25.71663000",
                        "longitude": "-108.97850000"
                    },
                    {
                        "id": 69796,
                        "name": "Ejido Tosalibampo",
                        "latitude": "25.98100000",
                        "longitude": "-109.11270000"
                    },
                    {
                        "id": 69826,
                        "name": "El Aguajito",
                        "latitude": "25.95965000",
                        "longitude": "-109.32970000"
                    },
                    {
                        "id": 69851,
                        "name": "El Burrión",
                        "latitude": "25.53878000",
                        "longitude": "-108.41286000"
                    },
                    {
                        "id": 69885,
                        "name": "El Carrizo",
                        "latitude": "24.01416000",
                        "longitude": "-106.85196000"
                    },
                    {
                        "id": 69888,
                        "name": "El Castillo",
                        "latitude": "24.54353000",
                        "longitude": "-107.70364000"
                    },
                    {
                        "id": 69943,
                        "name": "El Diez",
                        "latitude": "24.72389000",
                        "longitude": "-107.45194000"
                    },
                    {
                        "id": 69945,
                        "name": "El Dorado",
                        "latitude": "24.32283000",
                        "longitude": "-107.36298000"
                    },
                    {
                        "id": 69970,
                        "name": "El Fuerte",
                        "latitude": "26.41686000",
                        "longitude": "-108.61828000"
                    },
                    {
                        "id": 69978,
                        "name": "El Guayabo",
                        "latitude": "25.94132000",
                        "longitude": "-109.13880000"
                    },
                    {
                        "id": 69979,
                        "name": "El Habal",
                        "latitude": "23.35014000",
                        "longitude": "-106.41834000"
                    },
                    {
                        "id": 69984,
                        "name": "El Higueral",
                        "latitude": "24.31044000",
                        "longitude": "-107.34800000"
                    },
                    {
                        "id": 69985,
                        "name": "El Huajote",
                        "latitude": "23.12889000",
                        "longitude": "-106.05889000"
                    },
                    {
                        "id": 69990,
                        "name": "El Huitusi",
                        "latitude": "25.50974000",
                        "longitude": "-108.77875000"
                    },
                    {
                        "id": 70018,
                        "name": "El Limón de los Ramos",
                        "latitude": "24.91361000",
                        "longitude": "-107.52333000"
                    },
                    {
                        "id": 70046,
                        "name": "El Molino",
                        "latitude": "24.57147000",
                        "longitude": "-107.66483000"
                    },
                    {
                        "id": 70064,
                        "name": "El Nio",
                        "latitude": "25.62455000",
                        "longitude": "-108.40029000"
                    },
                    {
                        "id": 70112,
                        "name": "El Pochotal",
                        "latitude": "25.99541000",
                        "longitude": "-108.84355000"
                    },
                    {
                        "id": 70127,
                        "name": "El Potrero de Sataya",
                        "latitude": "24.69000000",
                        "longitude": "-107.70917000"
                    },
                    {
                        "id": 70130,
                        "name": "El Pozole",
                        "latitude": "22.91472000",
                        "longitude": "-105.91333000"
                    },
                    {
                        "id": 70131,
                        "name": "El Progreso",
                        "latitude": "25.43104000",
                        "longitude": "-108.59195000"
                    },
                    {
                        "id": 70142,
                        "name": "El Quelite",
                        "latitude": "23.55897000",
                        "longitude": "-106.46738000"
                    },
                    {
                        "id": 70151,
                        "name": "El Refugio",
                        "latitude": "25.99619000",
                        "longitude": "-109.29990000"
                    },
                    {
                        "id": 70166,
                        "name": "El Roble",
                        "latitude": "23.24556000",
                        "longitude": "-106.20583000"
                    },
                    {
                        "id": 70176,
                        "name": "El Rosario",
                        "latitude": "24.25556000",
                        "longitude": "-107.18278000"
                    },
                    {
                        "id": 70180,
                        "name": "El Sabino",
                        "latitude": "25.68325000",
                        "longitude": "-108.39349000"
                    },
                    {
                        "id": 70184,
                        "name": "El Saladito",
                        "latitude": "23.86987000",
                        "longitude": "-106.84784000"
                    },
                    {
                        "id": 70249,
                        "name": "El Varal (San Sebastián Número Uno)",
                        "latitude": "25.64278000",
                        "longitude": "-108.42500000"
                    },
                    {
                        "id": 70254,
                        "name": "El Verde",
                        "latitude": "23.36461000",
                        "longitude": "-106.13514000"
                    },
                    {
                        "id": 70259,
                        "name": "El Walamo",
                        "latitude": "23.14009000",
                        "longitude": "-106.24500000"
                    },
                    {
                        "id": 70269,
                        "name": "Eldorado",
                        "latitude": "24.32444000",
                        "longitude": "-107.36722000"
                    },
                    {
                        "id": 70270,
                        "name": "Elota",
                        "latitude": "24.03463000",
                        "longitude": "-106.84491000"
                    },
                    {
                        "id": 70300,
                        "name": "Empaque Tarriba",
                        "latitude": "23.90028000",
                        "longitude": "-106.93111000"
                    },
                    {
                        "id": 70318,
                        "name": "Escamillas",
                        "latitude": "23.27217000",
                        "longitude": "-106.24670000"
                    },
                    {
                        "id": 70322,
                        "name": "Escuinapa",
                        "latitude": "22.83279000",
                        "longitude": "-105.77772000"
                    },
                    {
                        "id": 70333,
                        "name": "Estacion Bamoa",
                        "latitude": "25.70842000",
                        "longitude": "-108.31298000"
                    },
                    {
                        "id": 70335,
                        "name": "Estación Capomas",
                        "latitude": "25.60066000",
                        "longitude": "-108.22333000"
                    },
                    {
                        "id": 70336,
                        "name": "Estación Chimaneco",
                        "latitude": "24.95430000",
                        "longitude": "-107.74913000"
                    },
                    {
                        "id": 70348,
                        "name": "Estación Obispo",
                        "latitude": "24.29306000",
                        "longitude": "-107.15944000"
                    },
                    {
                        "id": 70352,
                        "name": "Estación Rosales",
                        "latitude": "24.83719000",
                        "longitude": "-107.58005000"
                    },
                    {
                        "id": 70393,
                        "name": "Felipe Angeles",
                        "latitude": "25.86763000",
                        "longitude": "-109.04080000"
                    },
                    {
                        "id": 70403,
                        "name": "Flor Azul",
                        "latitude": "25.86987000",
                        "longitude": "-109.00839000"
                    },
                    {
                        "id": 70459,
                        "name": "Fraccionamiento los Ángeles",
                        "latitude": "23.18833000",
                        "longitude": "-106.33000000"
                    },
                    {
                        "id": 70503,
                        "name": "Gabriel Leyva Solano (Zapotillo Dos)",
                        "latitude": "25.88306000",
                        "longitude": "-109.00917000"
                    },
                    {
                        "id": 70504,
                        "name": "Gabriel Leyva Velázquez",
                        "latitude": "25.79111000",
                        "longitude": "-108.56333000"
                    },
                    {
                        "id": 70517,
                        "name": "Gambino",
                        "latitude": "25.65168000",
                        "longitude": "-108.38680000"
                    },
                    {
                        "id": 70524,
                        "name": "Genaro Estrada",
                        "latitude": "25.93611000",
                        "longitude": "-108.39639000"
                    },
                    {
                        "id": 70547,
                        "name": "General Ángel Flores (La Palma)",
                        "latitude": "24.81917000",
                        "longitude": "-107.65667000"
                    },
                    {
                        "id": 70557,
                        "name": "Goros Número Dos",
                        "latitude": "25.87694000",
                        "longitude": "-109.04417000"
                    },
                    {
                        "id": 70600,
                        "name": "Guadalupe Victoria",
                        "latitude": "24.29933000",
                        "longitude": "-107.27061000"
                    },
                    {
                        "id": 70615,
                        "name": "Guamúchil",
                        "latitude": "25.45870000",
                        "longitude": "-108.07732000"
                    },
                    {
                        "id": 70620,
                        "name": "Guasave",
                        "latitude": "25.56745000",
                        "longitude": "-108.46756000"
                    },
                    {
                        "id": 70621,
                        "name": "Guasavito",
                        "latitude": "25.55298000",
                        "longitude": "-108.43501000"
                    },
                    {
                        "id": 70640,
                        "name": "Gustavo Díaz Ordaz",
                        "latitude": "25.26692000",
                        "longitude": "-108.09486000"
                    },
                    {
                        "id": 70666,
                        "name": "Heriberto Valdez Romero (El Guayabo)",
                        "latitude": "25.94056000",
                        "longitude": "-109.13722000"
                    },
                    {
                        "id": 70694,
                        "name": "Higuera de los Vega",
                        "latitude": "25.65500000",
                        "longitude": "-107.95778000"
                    },
                    {
                        "id": 70693,
                        "name": "Higuera de Zaragoza",
                        "latitude": "25.96892000",
                        "longitude": "-109.30420000"
                    },
                    {
                        "id": 70695,
                        "name": "Higueras de Abuya",
                        "latitude": "24.26058000",
                        "longitude": "-107.07090000"
                    },
                    {
                        "id": 70696,
                        "name": "Higueras de los Natoches",
                        "latitude": "25.95653000",
                        "longitude": "-108.97741000"
                    },
                    {
                        "id": 70769,
                        "name": "Huepaco",
                        "latitude": "25.98417000",
                        "longitude": "-108.86056000"
                    },
                    {
                        "id": 70887,
                        "name": "Isla del Bosque",
                        "latitude": "22.73306000",
                        "longitude": "-105.84556000"
                    },
                    {
                        "id": 71016,
                        "name": "Javier Rojo Gómez",
                        "latitude": "25.49472000",
                        "longitude": "-108.37750000"
                    },
                    {
                        "id": 71029,
                        "name": "Jesús María",
                        "latitude": "25.08897000",
                        "longitude": "-107.45220000"
                    },
                    {
                        "id": 71060,
                        "name": "Jitzamuri",
                        "latitude": "26.21508000",
                        "longitude": "-109.26330000"
                    },
                    {
                        "id": 71114,
                        "name": "Juan Aldama (El Tigre)",
                        "latitude": "24.93972000",
                        "longitude": "-107.82083000"
                    },
                    {
                        "id": 71121,
                        "name": "Juan José Ríos",
                        "latitude": "25.75781000",
                        "longitude": "-108.82420000"
                    },
                    {
                        "id": 71186,
                        "name": "La Brecha",
                        "latitude": "25.37078000",
                        "longitude": "-108.41922000"
                    },
                    {
                        "id": 71230,
                        "name": "La Concepción",
                        "latitude": "23.39450000",
                        "longitude": "-106.16890000"
                    },
                    {
                        "id": 71241,
                        "name": "La Concha (La Concepción)",
                        "latitude": "22.53250000",
                        "longitude": "-105.45250000"
                    },
                    {
                        "id": 71250,
                        "name": "La Cruz",
                        "latitude": "23.92126000",
                        "longitude": "-106.89250000"
                    },
                    {
                        "id": 71259,
                        "name": "La Despensa",
                        "latitude": "25.99137000",
                        "longitude": "-109.27274000"
                    },
                    {
                        "id": 71274,
                        "name": "La Esperanza",
                        "latitude": "25.34872000",
                        "longitude": "-108.18678000"
                    },
                    {
                        "id": 71367,
                        "name": "La Loma (La Loma de Quila)",
                        "latitude": "24.38061000",
                        "longitude": "-107.22649000"
                    },
                    {
                        "id": 71405,
                        "name": "La Noria",
                        "latitude": "25.70909000",
                        "longitude": "-108.49185000"
                    },
                    {
                        "id": 71408,
                        "name": "La Noria de San Antonio",
                        "latitude": "23.50653000",
                        "longitude": "-106.31459000"
                    },
                    {
                        "id": 71424,
                        "name": "La Palma",
                        "latitude": "25.38286000",
                        "longitude": "-108.15909000"
                    },
                    {
                        "id": 71430,
                        "name": "La Palmita y Anexos (La Presita)",
                        "latitude": "24.90917000",
                        "longitude": "-107.45194000"
                    },
                    {
                        "id": 71458,
                        "name": "La Presita",
                        "latitude": "25.70734000",
                        "longitude": "-108.58523000"
                    },
                    {
                        "id": 71475,
                        "name": "La Reforma",
                        "latitude": "25.08164000",
                        "longitude": "-108.05673000"
                    },
                    {
                        "id": 71509,
                        "name": "La Trinidad",
                        "latitude": "25.73367000",
                        "longitude": "-108.48409000"
                    },
                    {
                        "id": 71543,
                        "name": "Ladrilleras de Ocoro",
                        "latitude": "25.59806000",
                        "longitude": "-108.44944000"
                    },
                    {
                        "id": 71572,
                        "name": "Las Aguamitas",
                        "latitude": "24.57556000",
                        "longitude": "-107.80056000"
                    },
                    {
                        "id": 71575,
                        "name": "Las Arenitas",
                        "latitude": "24.37245000",
                        "longitude": "-107.53612000"
                    },
                    {
                        "id": 71580,
                        "name": "Las Brisas",
                        "latitude": "25.49022000",
                        "longitude": "-108.24587000"
                    },
                    {
                        "id": 71592,
                        "name": "Las Compuertas",
                        "latitude": "25.84202000",
                        "longitude": "-109.01980000"
                    },
                    {
                        "id": 71600,
                        "name": "Las Grullas Margen Derecha",
                        "latitude": "25.87770000",
                        "longitude": "-109.33773000"
                    },
                    {
                        "id": 71601,
                        "name": "Las Grullas Margen Izquierda",
                        "latitude": "25.85306000",
                        "longitude": "-109.32917000"
                    },
                    {
                        "id": 71625,
                        "name": "Las Moras",
                        "latitude": "25.65745000",
                        "longitude": "-108.45807000"
                    },
                    {
                        "id": 71635,
                        "name": "Las Quemazones",
                        "latitude": "25.68583000",
                        "longitude": "-108.45243000"
                    },
                    {
                        "id": 71892,
                        "name": "Lázaro Cárdenas",
                        "latitude": "26.04918000",
                        "longitude": "-108.79858000"
                    },
                    {
                        "id": 71665,
                        "name": "Leyva Solano",
                        "latitude": "25.66163000",
                        "longitude": "-108.63700000"
                    },
                    {
                        "id": 71675,
                        "name": "Licenciado Benito Juárez (Campo Gobierno)",
                        "latitude": "24.65667000",
                        "longitude": "-107.54500000"
                    },
                    {
                        "id": 71686,
                        "name": "Llano Grande",
                        "latitude": "25.75187000",
                        "longitude": "-108.08636000"
                    },
                    {
                        "id": 71700,
                        "name": "Lo de Jesús (Campo Romero)",
                        "latitude": "24.68000000",
                        "longitude": "-107.54556000"
                    },
                    {
                        "id": 71770,
                        "name": "Los Angeles",
                        "latitude": "25.60289000",
                        "longitude": "-108.48095000"
                    },
                    {
                        "id": 71816,
                        "name": "Los Mochis",
                        "latitude": "25.79302000",
                        "longitude": "-108.99808000"
                    },
                    {
                        "id": 71837,
                        "name": "Los Pozos",
                        "latitude": "23.00944000",
                        "longitude": "-106.15250000"
                    },
                    {
                        "id": 71902,
                        "name": "Macapule",
                        "latitude": "25.88607000",
                        "longitude": "-109.14820000"
                    },
                    {
                        "id": 71988,
                        "name": "Marcol",
                        "latitude": "25.49445000",
                        "longitude": "-108.51586000"
                    },
                    {
                        "id": 71994,
                        "name": "Maripa",
                        "latitude": "25.86371000",
                        "longitude": "-108.15737000"
                    },
                    {
                        "id": 72047,
                        "name": "Mazatlán",
                        "latitude": "23.23290000",
                        "longitude": "-106.40620000"
                    },
                    {
                        "id": 72068,
                        "name": "Melchor Ocampo",
                        "latitude": "25.04699000",
                        "longitude": "-107.89463000"
                    },
                    {
                        "id": 72083,
                        "name": "Mesillas",
                        "latitude": "23.24652000",
                        "longitude": "-106.04783000"
                    },
                    {
                        "id": 72136,
                        "name": "Miguel Valdez Quintero (El Corazón)",
                        "latitude": "24.49417000",
                        "longitude": "-107.31778000"
                    },
                    {
                        "id": 72171,
                        "name": "Mochicahui",
                        "latitude": "25.95095000",
                        "longitude": "-108.92991000"
                    },
                    {
                        "id": 72172,
                        "name": "Mochis",
                        "latitude": "25.82720000",
                        "longitude": "-109.05120000"
                    },
                    {
                        "id": 72176,
                        "name": "Mocorito",
                        "latitude": "25.48202000",
                        "longitude": "-107.92008000"
                    },
                    {
                        "id": 72282,
                        "name": "Naranjo",
                        "latitude": "25.80633000",
                        "longitude": "-108.48127000"
                    },
                    {
                        "id": 72298,
                        "name": "Navolato",
                        "latitude": "24.76610000",
                        "longitude": "-107.70225000"
                    },
                    {
                        "id": 72412,
                        "name": "Nuevo San Miguel",
                        "latitude": "25.96306000",
                        "longitude": "-109.05401000"
                    },
                    {
                        "id": 72493,
                        "name": "Ojo de Agua de Palmillas",
                        "latitude": "22.61972000",
                        "longitude": "-105.60389000"
                    },
                    {
                        "id": 72516,
                        "name": "Orba (Infiernito)",
                        "latitude": "25.68944000",
                        "longitude": "-108.36278000"
                    },
                    {
                        "id": 72533,
                        "name": "Oso Viejo",
                        "latitude": "24.39944000",
                        "longitude": "-107.17139000"
                    },
                    {
                        "id": 72603,
                        "name": "Palmito del Verde",
                        "latitude": "22.65861000",
                        "longitude": "-105.77111000"
                    },
                    {
                        "id": 72617,
                        "name": "Palos Verdes",
                        "latitude": "25.37937000",
                        "longitude": "-108.45831000"
                    },
                    {
                        "id": 72733,
                        "name": "Pericos",
                        "latitude": "25.08093000",
                        "longitude": "-107.69966000"
                    },
                    {
                        "id": 72757,
                        "name": "Piaxtla de Abajo",
                        "latitude": "23.83254000",
                        "longitude": "-106.65923000"
                    },
                    {
                        "id": 72789,
                        "name": "Pitahayal",
                        "latitude": "25.47076000",
                        "longitude": "-108.36818000"
                    },
                    {
                        "id": 72801,
                        "name": "Plan de Ayala (Campo Cinco)",
                        "latitude": "25.76910000",
                        "longitude": "-109.04121000"
                    },
                    {
                        "id": 72828,
                        "name": "Poblado Número Cinco",
                        "latitude": "26.22250000",
                        "longitude": "-109.06167000"
                    },
                    {
                        "id": 72853,
                        "name": "Portaceli",
                        "latitude": "24.34809000",
                        "longitude": "-107.30594000"
                    },
                    {
                        "id": 72857,
                        "name": "Portugués de Gálvez",
                        "latitude": "25.72780000",
                        "longitude": "-108.39572000"
                    },
                    {
                        "id": 72863,
                        "name": "Potrerillo del Norote",
                        "latitude": "24.02143000",
                        "longitude": "-106.97397000"
                    },
                    {
                        "id": 72866,
                        "name": "Potrero de los Sánchez (Estación Techa)",
                        "latitude": "25.11000000",
                        "longitude": "-107.90111000"
                    },
                    {
                        "id": 72901,
                        "name": "Primero de Mayo",
                        "latitude": "25.73942000",
                        "longitude": "-108.93491000"
                    },
                    {
                        "id": 72942,
                        "name": "Pueblo Nuevo",
                        "latitude": "23.99111000",
                        "longitude": "-106.95639000"
                    },
                    {
                        "id": 72950,
                        "name": "Pueblo Viejo",
                        "latitude": "25.61413000",
                        "longitude": "-108.41581000"
                    },
                    {
                        "id": 72954,
                        "name": "Pueblos Unidos",
                        "latitude": "24.29250000",
                        "longitude": "-107.15139000"
                    },
                    {
                        "id": 73031,
                        "name": "Quila",
                        "latitude": "24.42362000",
                        "longitude": "-107.22186000"
                    },
                    {
                        "id": 73054,
                        "name": "Ranchito de Castro",
                        "latitude": "25.58688000",
                        "longitude": "-108.41767000"
                    },
                    {
                        "id": 73092,
                        "name": "Recoveco",
                        "latitude": "24.99356000",
                        "longitude": "-107.72796000"
                    },
                    {
                        "id": 73110,
                        "name": "Ricardo Flores Magón",
                        "latitude": "25.74056000",
                        "longitude": "-108.99583000"
                    },
                    {
                        "id": 73208,
                        "name": "Salado",
                        "latitude": "24.50775000",
                        "longitude": "-107.15872000"
                    },
                    {
                        "id": 73444,
                        "name": "San Blas",
                        "latitude": "26.08019000",
                        "longitude": "-108.76110000"
                    },
                    {
                        "id": 73488,
                        "name": "San Diego",
                        "latitude": "24.38250000",
                        "longitude": "-107.33135000"
                    },
                    {
                        "id": 73614,
                        "name": "San Francisco de Tacuichamona",
                        "latitude": "24.36160000",
                        "longitude": "-107.07630000"
                    },
                    {
                        "id": 73647,
                        "name": "San Ignacio",
                        "latitude": "23.94105000",
                        "longitude": "-106.42467000"
                    },
                    {
                        "id": 73669,
                        "name": "San Isidro",
                        "latitude": "25.97722000",
                        "longitude": "-109.25111000"
                    },
                    {
                        "id": 74225,
                        "name": "San Miguel Zapotitlan",
                        "latitude": "25.94831000",
                        "longitude": "-109.04738000"
                    },
                    {
                        "id": 74337,
                        "name": "San Pedro Guasave",
                        "latitude": "25.53809000",
                        "longitude": "-108.45673000"
                    },
                    {
                        "id": 74428,
                        "name": "San Rafael",
                        "latitude": "25.49390000",
                        "longitude": "-108.30527000"
                    },
                    {
                        "id": 74514,
                        "name": "Sanalona",
                        "latitude": "24.80222000",
                        "longitude": "-107.14000000"
                    },
                    {
                        "id": 75090,
                        "name": "Sinaloa",
                        "latitude": "25.94103000",
                        "longitude": "-108.09076000"
                    },
                    {
                        "id": 75091,
                        "name": "Sinaloa de Leyva",
                        "latitude": "25.82190000",
                        "longitude": "-108.22261000"
                    },
                    {
                        "id": 75096,
                        "name": "Siqueros",
                        "latitude": "23.34177000",
                        "longitude": "-106.24124000"
                    },
                    {
                        "id": 75179,
                        "name": "Tamazula",
                        "latitude": "25.44639000",
                        "longitude": "-108.45528000"
                    },
                    {
                        "id": 75216,
                        "name": "Tanques",
                        "latitude": "24.06349000",
                        "longitude": "-107.01360000"
                    },
                    {
                        "id": 75247,
                        "name": "Taxtes",
                        "latitude": "25.91625000",
                        "longitude": "-108.93545000"
                    },
                    {
                        "id": 75255,
                        "name": "Teacapan",
                        "latitude": "22.53959000",
                        "longitude": "-105.73623000"
                    },
                    {
                        "id": 75290,
                        "name": "Tecualilla",
                        "latitude": "22.76667000",
                        "longitude": "-105.67167000"
                    },
                    {
                        "id": 75746,
                        "name": "Topolobampo",
                        "latitude": "25.60084000",
                        "longitude": "-109.05230000"
                    },
                    {
                        "id": 75773,
                        "name": "Tres Garantías",
                        "latitude": "25.88567000",
                        "longitude": "-108.71837000"
                    },
                    {
                        "id": 75932,
                        "name": "Vallejo (Porvenir Vallejo)",
                        "latitude": "25.88278000",
                        "longitude": "-109.07361000"
                    },
                    {
                        "id": 76062,
                        "name": "Villa de Costa Rica",
                        "latitude": "24.59167000",
                        "longitude": "-107.38836000"
                    },
                    {
                        "id": 76023,
                        "name": "Villa Juárez",
                        "latitude": "24.65869000",
                        "longitude": "-107.54059000"
                    },
                    {
                        "id": 76052,
                        "name": "Villa Unión",
                        "latitude": "23.18992000",
                        "longitude": "-106.21947000"
                    }
                ]
            },
            {
                "id": 3468,
                "name": "Sonora",
                "iso2": "SON",
                "latitude": "37.98294960",
                "longitude": "-120.38217240",
                "type": "state",
                "cities": [
                    {
                        "id": 68009,
                        "name": "31 de Octubre",
                        "latitude": "27.29583000",
                        "longitude": "-110.03750000"
                    },
                    {
                        "id": 68064,
                        "name": "Aconchi",
                        "latitude": "29.82628000",
                        "longitude": "-110.22492000"
                    },
                    {
                        "id": 68097,
                        "name": "Aduana del Sásabe",
                        "latitude": "31.47076000",
                        "longitude": "-111.54608000"
                    },
                    {
                        "id": 68098,
                        "name": "Agiabampo Uno",
                        "latitude": "26.36686000",
                        "longitude": "-109.14572000"
                    },
                    {
                        "id": 68115,
                        "name": "Agua Prieta",
                        "latitude": "31.33071000",
                        "longitude": "-109.54876000"
                    },
                    {
                        "id": 76392,
                        "name": "Álamos",
                        "latitude": "27.02326000",
                        "longitude": "-108.93440000"
                    },
                    {
                        "id": 68207,
                        "name": "Allende",
                        "latitude": "27.19201000",
                        "longitude": "-109.90730000"
                    },
                    {
                        "id": 68280,
                        "name": "Antonio Rosales",
                        "latitude": "27.35111000",
                        "longitude": "-109.85306000"
                    },
                    {
                        "id": 68352,
                        "name": "Arivechi",
                        "latitude": "28.92765000",
                        "longitude": "-109.18681000"
                    },
                    {
                        "id": 68353,
                        "name": "Arizpe",
                        "latitude": "30.33690000",
                        "longitude": "-110.16649000"
                    },
                    {
                        "id": 68405,
                        "name": "Atil",
                        "latitude": "30.84361000",
                        "longitude": "-111.58361000"
                    },
                    {
                        "id": 68480,
                        "name": "Bacabachi",
                        "latitude": "26.89471000",
                        "longitude": "-109.39320000"
                    },
                    {
                        "id": 68482,
                        "name": "Bacadéhuachi",
                        "latitude": "29.80872000",
                        "longitude": "-109.14054000"
                    },
                    {
                        "id": 68484,
                        "name": "Bacame Nuevo",
                        "latitude": "27.15899000",
                        "longitude": "-109.59286000"
                    },
                    {
                        "id": 68485,
                        "name": "Bacanora",
                        "latitude": "28.98152000",
                        "longitude": "-109.40012000"
                    },
                    {
                        "id": 68486,
                        "name": "Bacerac",
                        "latitude": "30.35565000",
                        "longitude": "-108.93147000"
                    },
                    {
                        "id": 68492,
                        "name": "Bacobampo",
                        "latitude": "26.98239000",
                        "longitude": "-109.65350000"
                    },
                    {
                        "id": 68695,
                        "name": "Bácum",
                        "latitude": "27.55142000",
                        "longitude": "-110.08330000"
                    },
                    {
                        "id": 68500,
                        "name": "Bahía de Kino",
                        "latitude": "28.82278000",
                        "longitude": "-111.94083000"
                    },
                    {
                        "id": 68501,
                        "name": "Bahía de Lobos",
                        "latitude": "27.35167000",
                        "longitude": "-110.45472000"
                    },
                    {
                        "id": 68564,
                        "name": "Basconcobe",
                        "latitude": "26.95491000",
                        "longitude": "-109.66860000"
                    },
                    {
                        "id": 68568,
                        "name": "Bavispe",
                        "latitude": "30.47931000",
                        "longitude": "-108.93982000"
                    },
                    {
                        "id": 68607,
                        "name": "Benjamín Hill",
                        "latitude": "30.16904000",
                        "longitude": "-111.11403000"
                    },
                    {
                        "id": 68654,
                        "name": "Buaysiacobe",
                        "latitude": "27.06795000",
                        "longitude": "-109.68628000"
                    },
                    {
                        "id": 68655,
                        "name": "Buayums",
                        "latitude": "26.86336000",
                        "longitude": "-109.43427000"
                    },
                    {
                        "id": 68775,
                        "name": "Campo Carretero",
                        "latitude": "30.77154000",
                        "longitude": "-110.85380000"
                    },
                    {
                        "id": 68779,
                        "name": "Campo Sesenta",
                        "latitude": "27.45000000",
                        "longitude": "-110.10000000"
                    },
                    {
                        "id": 68784,
                        "name": "Cananea",
                        "latitude": "30.98699000",
                        "longitude": "-110.29062000"
                    },
                    {
                        "id": 68816,
                        "name": "Carbo",
                        "latitude": "29.68306000",
                        "longitude": "-110.95619000"
                    },
                    {
                        "id": 68902,
                        "name": "Centro de Readaptación Social Nuevo",
                        "latitude": "31.18444000",
                        "longitude": "-110.96778000"
                    },
                    {
                        "id": 69110,
                        "name": "Chucarit",
                        "latitude": "27.03157000",
                        "longitude": "-109.58421000"
                    },
                    {
                        "id": 69174,
                        "name": "Ciudad Obregón",
                        "latitude": "27.48642000",
                        "longitude": "-109.94083000"
                    },
                    {
                        "id": 69238,
                        "name": "Cocorit",
                        "latitude": "27.57519000",
                        "longitude": "-109.95910000"
                    },
                    {
                        "id": 69585,
                        "name": "Cuauhtémoc (Campo Cinco)",
                        "latitude": "27.43333000",
                        "longitude": "-110.01667000"
                    },
                    {
                        "id": 69608,
                        "name": "Cucurpe",
                        "latitude": "30.33049000",
                        "longitude": "-110.70609000"
                    },
                    {
                        "id": 69635,
                        "name": "Cumpas",
                        "latitude": "29.99587000",
                        "longitude": "-109.78087000"
                    },
                    {
                        "id": 69772,
                        "name": "Ejido Lagunitas",
                        "latitude": "32.31956000",
                        "longitude": "-114.89568000"
                    },
                    {
                        "id": 69932,
                        "name": "El Coyote",
                        "latitude": "30.82877000",
                        "longitude": "-112.61531000"
                    },
                    {
                        "id": 69942,
                        "name": "El Diamante (La Retranca)",
                        "latitude": "30.84556000",
                        "longitude": "-112.63972000"
                    },
                    {
                        "id": 70093,
                        "name": "El Paredoncito",
                        "latitude": "27.05920000",
                        "longitude": "-109.91286000"
                    },
                    {
                        "id": 70146,
                        "name": "El Recodo",
                        "latitude": "27.07722000",
                        "longitude": "-109.52750000"
                    },
                    {
                        "id": 70169,
                        "name": "El Rodeo",
                        "latitude": "27.01482000",
                        "longitude": "-109.64254000"
                    },
                    {
                        "id": 70183,
                        "name": "El Sahuaral",
                        "latitude": "26.92633000",
                        "longitude": "-109.66643000"
                    },
                    {
                        "id": 70196,
                        "name": "El Saneal",
                        "latitude": "26.91150000",
                        "longitude": "-109.38817000"
                    },
                    {
                        "id": 70208,
                        "name": "El Siviral (Jigica)",
                        "latitude": "27.10222000",
                        "longitude": "-109.50083000"
                    },
                    {
                        "id": 70231,
                        "name": "El Tobarito",
                        "latitude": "27.37057000",
                        "longitude": "-109.89379000"
                    },
                    {
                        "id": 70298,
                        "name": "Empalme",
                        "latitude": "27.96166000",
                        "longitude": "-110.81411000"
                    },
                    {
                        "id": 70329,
                        "name": "Esperanza",
                        "latitude": "27.57916000",
                        "longitude": "-109.92980000"
                    },
                    {
                        "id": 70332,
                        "name": "Esqueda",
                        "latitude": "30.72412000",
                        "longitude": "-109.58930000"
                    },
                    {
                        "id": 70340,
                        "name": "Estación Corral",
                        "latitude": "27.62889000",
                        "longitude": "-109.96611000"
                    },
                    {
                        "id": 70346,
                        "name": "Estación Llano",
                        "latitude": "30.36149000",
                        "longitude": "-111.10381000"
                    },
                    {
                        "id": 70358,
                        "name": "Estación Zamora",
                        "latitude": "29.26116000",
                        "longitude": "-110.88653000"
                    },
                    {
                        "id": 70374,
                        "name": "Etchojoa",
                        "latitude": "26.91094000",
                        "longitude": "-109.62610000"
                    },
                    {
                        "id": 70375,
                        "name": "Etchoropo",
                        "latitude": "26.76727000",
                        "longitude": "-109.68236000"
                    },
                    {
                        "id": 70472,
                        "name": "Francisco Javier Mina",
                        "latitude": "27.46217000",
                        "longitude": "-110.10893000"
                    },
                    {
                        "id": 70494,
                        "name": "Fronteras",
                        "latitude": "30.89753000",
                        "longitude": "-109.55968000"
                    },
                    {
                        "id": 70553,
                        "name": "Golfo de Santa Clara",
                        "latitude": "31.68689000",
                        "longitude": "-114.49797000"
                    },
                    {
                        "id": 70563,
                        "name": "Granados",
                        "latitude": "29.86195000",
                        "longitude": "-109.31016000"
                    },
                    {
                        "id": 70644,
                        "name": "Guásimas (De Belem)",
                        "latitude": "27.88583000",
                        "longitude": "-110.58167000"
                    },
                    {
                        "id": 70626,
                        "name": "Guaymitas",
                        "latitude": "27.11028000",
                        "longitude": "-109.43833000"
                    },
                    {
                        "id": 70672,
                        "name": "Hermosillo",
                        "latitude": "29.10260000",
                        "longitude": "-110.97732000"
                    },
                    {
                        "id": 70675,
                        "name": "Heroica Caborca",
                        "latitude": "30.71825000",
                        "longitude": "-112.15822000"
                    },
                    {
                        "id": 70679,
                        "name": "Heroica Guaymas",
                        "latitude": "27.91928000",
                        "longitude": "-110.89755000"
                    },
                    {
                        "id": 70716,
                        "name": "Huachinera",
                        "latitude": "30.21027000",
                        "longitude": "-108.95854000"
                    },
                    {
                        "id": 70825,
                        "name": "Huásabas",
                        "latitude": "29.90772000",
                        "longitude": "-109.30098000"
                    },
                    {
                        "id": 70740,
                        "name": "Huatabampo",
                        "latitude": "26.82610000",
                        "longitude": "-109.64220000"
                    },
                    {
                        "id": 70826,
                        "name": "Huépac",
                        "latitude": "29.91135000",
                        "longitude": "-110.21323000"
                    },
                    {
                        "id": 70867,
                        "name": "Imuris",
                        "latitude": "30.78955000",
                        "longitude": "-110.84596000"
                    },
                    {
                        "id": 70890,
                        "name": "Islita",
                        "latitude": "32.38312000",
                        "longitude": "-114.86864000"
                    },
                    {
                        "id": 71017,
                        "name": "Jecopaco",
                        "latitude": "27.19831000",
                        "longitude": "-109.76946000"
                    },
                    {
                        "id": 71058,
                        "name": "Jitonhueca",
                        "latitude": "27.06167000",
                        "longitude": "-109.60500000"
                    },
                    {
                        "id": 71107,
                        "name": "José María Morelos y Pavón",
                        "latitude": "28.09786000",
                        "longitude": "-110.69030000"
                    },
                    {
                        "id": 71141,
                        "name": "Juraré",
                        "latitude": "26.80191000",
                        "longitude": "-109.70198000"
                    },
                    {
                        "id": 71184,
                        "name": "La Bocana",
                        "latitude": "26.88711000",
                        "longitude": "-109.66797000"
                    },
                    {
                        "id": 71222,
                        "name": "La Colorada",
                        "latitude": "28.80348000",
                        "longitude": "-110.57994000"
                    },
                    {
                        "id": 71356,
                        "name": "La Libertad",
                        "latitude": "29.91313000",
                        "longitude": "-112.69179000"
                    },
                    {
                        "id": 71390,
                        "name": "La Mesa",
                        "latitude": "31.15972000",
                        "longitude": "-110.97444000"
                    },
                    {
                        "id": 71426,
                        "name": "La Palma",
                        "latitude": "28.05028000",
                        "longitude": "-110.70111000"
                    },
                    {
                        "id": 71461,
                        "name": "La Providencia",
                        "latitude": "28.72268000",
                        "longitude": "-111.58687000"
                    },
                    {
                        "id": 71521,
                        "name": "La Unión",
                        "latitude": "26.81961000",
                        "longitude": "-109.60831000"
                    },
                    {
                        "id": 71534,
                        "name": "La Victoria",
                        "latitude": "29.12215000",
                        "longitude": "-110.89080000"
                    },
                    {
                        "id": 71578,
                        "name": "Las Bocas",
                        "latitude": "26.58821000",
                        "longitude": "-109.33622000"
                    },
                    {
                        "id": 71621,
                        "name": "Las Mercedes [Agropecuaria]",
                        "latitude": "29.36389000",
                        "longitude": "-110.95167000"
                    },
                    {
                        "id": 71725,
                        "name": "Loma de Bácum",
                        "latitude": "27.58707000",
                        "longitude": "-110.08601000"
                    },
                    {
                        "id": 71727,
                        "name": "Loma de Guamúchil",
                        "latitude": "27.61157000",
                        "longitude": "-109.98730000"
                    },
                    {
                        "id": 71738,
                        "name": "Loma del Refugio",
                        "latitude": "27.12194000",
                        "longitude": "-109.45917000"
                    },
                    {
                        "id": 71776,
                        "name": "Los Bahuises",
                        "latitude": "27.11667000",
                        "longitude": "-109.46722000"
                    },
                    {
                        "id": 71806,
                        "name": "Los Hoyos",
                        "latitude": "30.12444000",
                        "longitude": "-109.78222000"
                    },
                    {
                        "id": 71934,
                        "name": "Magdalena de Kino",
                        "latitude": "30.62789000",
                        "longitude": "-110.96203000"
                    },
                    {
                        "id": 72001,
                        "name": "Marte R. Gómez (Tobarito)",
                        "latitude": "27.36778000",
                        "longitude": "-109.88583000"
                    },
                    {
                        "id": 72008,
                        "name": "Masiaca",
                        "latitude": "26.76427000",
                        "longitude": "-109.23496000"
                    },
                    {
                        "id": 72050,
                        "name": "Mazatán",
                        "latitude": "29.00503000",
                        "longitude": "-110.13785000"
                    },
                    {
                        "id": 72113,
                        "name": "Mi Patria es Primero",
                        "latitude": "28.05122000",
                        "longitude": "-110.67780000"
                    },
                    {
                        "id": 72124,
                        "name": "Miguel Alemán (La Doce)",
                        "latitude": "28.84028000",
                        "longitude": "-111.47750000"
                    },
                    {
                        "id": 72140,
                        "name": "Milpillas",
                        "latitude": "27.20534000",
                        "longitude": "-108.64493000"
                    },
                    {
                        "id": 72178,
                        "name": "Moctezuma",
                        "latitude": "29.80615000",
                        "longitude": "-109.67949000"
                    },
                    {
                        "id": 72184,
                        "name": "Molino de Camou",
                        "latitude": "29.20409000",
                        "longitude": "-110.75768000"
                    },
                    {
                        "id": 72222,
                        "name": "Mora Villalobos",
                        "latitude": "27.51145000",
                        "longitude": "-110.05610000"
                    },
                    {
                        "id": 72239,
                        "name": "Moroncarit",
                        "latitude": "26.73307000",
                        "longitude": "-109.61676000"
                    },
                    {
                        "id": 72266,
                        "name": "Naco",
                        "latitude": "31.32701000",
                        "longitude": "-109.94669000"
                    },
                    {
                        "id": 72429,
                        "name": "Nácori Chico",
                        "latitude": "29.68726000",
                        "longitude": "-108.98020000"
                    },
                    {
                        "id": 72268,
                        "name": "Nacozari de García",
                        "latitude": "30.37489000",
                        "longitude": "-109.68898000"
                    },
                    {
                        "id": 72267,
                        "name": "Nacozari Viejo",
                        "latitude": "30.40000000",
                        "longitude": "-109.65000000"
                    },
                    {
                        "id": 72297,
                        "name": "Navojoa",
                        "latitude": "27.07028000",
                        "longitude": "-109.44372000"
                    },
                    {
                        "id": 72340,
                        "name": "Nogales",
                        "latitude": "31.30862000",
                        "longitude": "-110.94217000"
                    },
                    {
                        "id": 72394,
                        "name": "Nuevo Michoacán (Estación Riíto)",
                        "latitude": "32.16611000",
                        "longitude": "-114.96167000"
                    },
                    {
                        "id": 72509,
                        "name": "Onavas",
                        "latitude": "28.46083000",
                        "longitude": "-109.53013000"
                    },
                    {
                        "id": 72513,
                        "name": "Opodepe",
                        "latitude": "29.92573000",
                        "longitude": "-110.62933000"
                    },
                    {
                        "id": 72515,
                        "name": "Oquitoa",
                        "latitude": "30.74197000",
                        "longitude": "-111.73463000"
                    },
                    {
                        "id": 72531,
                        "name": "Ortiz",
                        "latitude": "28.28786000",
                        "longitude": "-110.71410000"
                    },
                    {
                        "id": 72655,
                        "name": "Paredón Colorado",
                        "latitude": "27.07929000",
                        "longitude": "-109.93363000"
                    },
                    {
                        "id": 72739,
                        "name": "Pesqueira",
                        "latitude": "29.37972000",
                        "longitude": "-110.89611000"
                    },
                    {
                        "id": 72790,
                        "name": "Pitiquito",
                        "latitude": "30.67663000",
                        "longitude": "-112.05466000"
                    },
                    {
                        "id": 72819,
                        "name": "Plutarco Elías Calles (La Y Griega)",
                        "latitude": "30.80194000",
                        "longitude": "-112.71833000"
                    },
                    {
                        "id": 72859,
                        "name": "Potam",
                        "latitude": "27.62600000",
                        "longitude": "-110.41580000"
                    },
                    {
                        "id": 72871,
                        "name": "Pozo Dulce",
                        "latitude": "26.84506000",
                        "longitude": "-109.75350000"
                    },
                    {
                        "id": 72900,
                        "name": "Primero de Mayo",
                        "latitude": "27.38825000",
                        "longitude": "-110.12163000"
                    },
                    {
                        "id": 72916,
                        "name": "Progreso (Campo 47)",
                        "latitude": "27.34028000",
                        "longitude": "-110.09361000"
                    },
                    {
                        "id": 72921,
                        "name": "Providencia",
                        "latitude": "27.51219000",
                        "longitude": "-109.99080000"
                    },
                    {
                        "id": 72935,
                        "name": "Pueblo Mayo",
                        "latitude": "27.20361000",
                        "longitude": "-109.55500000"
                    },
                    {
                        "id": 72953,
                        "name": "Pueblo Yaqui",
                        "latitude": "27.35521000",
                        "longitude": "-110.03444000"
                    },
                    {
                        "id": 72973,
                        "name": "Puerto Peñasco",
                        "latitude": "31.31716000",
                        "longitude": "-113.53799000"
                    },
                    {
                        "id": 73022,
                        "name": "Querobabi",
                        "latitude": "30.05062000",
                        "longitude": "-111.02649000"
                    },
                    {
                        "id": 73027,
                        "name": "Quetchehueca",
                        "latitude": "27.26365000",
                        "longitude": "-109.94920000"
                    },
                    {
                        "id": 73041,
                        "name": "Quiriego",
                        "latitude": "27.51987000",
                        "longitude": "-109.25233000"
                    },
                    {
                        "id": 73088,
                        "name": "Rayón",
                        "latitude": "29.71195000",
                        "longitude": "-110.56749000"
                    },
                    {
                        "id": 73160,
                        "name": "Rosales",
                        "latitude": "27.13294000",
                        "longitude": "-109.43843000"
                    },
                    {
                        "id": 73162,
                        "name": "Rosario",
                        "latitude": "27.84111000",
                        "longitude": "-109.36806000"
                    },
                    {
                        "id": 73201,
                        "name": "Sahuaral de Otero",
                        "latitude": "26.88487000",
                        "longitude": "-109.73175000"
                    },
                    {
                        "id": 73202,
                        "name": "Sahuaripa",
                        "latitude": "29.05408000",
                        "longitude": "-109.23399000"
                    },
                    {
                        "id": 73439,
                        "name": "San Bernardo",
                        "latitude": "27.39909000",
                        "longitude": "-108.84440000"
                    },
                    {
                        "id": 73461,
                        "name": "San Carlos",
                        "latitude": "27.95749000",
                        "longitude": "-111.04354000"
                    },
                    {
                        "id": 73649,
                        "name": "San Ignacio",
                        "latitude": "30.69695000",
                        "longitude": "-110.92207000"
                    },
                    {
                        "id": 73653,
                        "name": "San Ignacio Río Muerto",
                        "latitude": "27.41656000",
                        "longitude": "-110.24584000"
                    },
                    {
                        "id": 73810,
                        "name": "San José de Bacum",
                        "latitude": "27.51477000",
                        "longitude": "-110.14308000"
                    },
                    {
                        "id": 73821,
                        "name": "San José de Guaymas",
                        "latitude": "27.98644000",
                        "longitude": "-110.88064000"
                    },
                    {
                        "id": 74052,
                        "name": "San Luis Río Colorado",
                        "latitude": "32.45612000",
                        "longitude": "-114.77186000"
                    },
                    {
                        "id": 74230,
                        "name": "San Miguel de Horcasitas",
                        "latitude": "29.48737000",
                        "longitude": "-110.72479000"
                    },
                    {
                        "id": 74405,
                        "name": "San Pedro de la Cueva",
                        "latitude": "29.28684000",
                        "longitude": "-109.73696000"
                    },
                    {
                        "id": 74370,
                        "name": "San Pedro Río Mayo",
                        "latitude": "27.02094000",
                        "longitude": "-109.63198000"
                    },
                    {
                        "id": 74521,
                        "name": "Santa Ana",
                        "latitude": "30.54075000",
                        "longitude": "-111.11888000"
                    },
                    {
                        "id": 74612,
                        "name": "Santa Cruz",
                        "latitude": "31.23362000",
                        "longitude": "-110.59618000"
                    },
                    {
                        "id": 74806,
                        "name": "Santa María de Guaymas",
                        "latitude": "28.14255000",
                        "longitude": "-110.69301000"
                    },
                    {
                        "id": 74810,
                        "name": "Santa María del Buáraje",
                        "latitude": "27.30118000",
                        "longitude": "-109.80256000"
                    },
                    {
                        "id": 75154,
                        "name": "Sáric",
                        "latitude": "31.10328000",
                        "longitude": "-111.37931000"
                    },
                    {
                        "id": 75088,
                        "name": "Sinahuiza",
                        "latitude": "26.91105000",
                        "longitude": "-109.43901000"
                    },
                    {
                        "id": 75104,
                        "name": "Siviral",
                        "latitude": "27.10145000",
                        "longitude": "-109.50236000"
                    },
                    {
                        "id": 75121,
                        "name": "Sonoita",
                        "latitude": "31.86165000",
                        "longitude": "-112.85129000"
                    },
                    {
                        "id": 75134,
                        "name": "Soyopa",
                        "latitude": "28.76424000",
                        "longitude": "-109.63453000"
                    },
                    {
                        "id": 75135,
                        "name": "Suaqui Grande",
                        "latitude": "28.39383000",
                        "longitude": "-109.88798000"
                    },
                    {
                        "id": 75388,
                        "name": "Tepache",
                        "latitude": "29.53275000",
                        "longitude": "-109.53134000"
                    },
                    {
                        "id": 75544,
                        "name": "Tierra Blanca",
                        "latitude": "27.18773000",
                        "longitude": "-109.34514000"
                    },
                    {
                        "id": 75786,
                        "name": "Tubutama",
                        "latitude": "30.88458000",
                        "longitude": "-111.46514000"
                    },
                    {
                        "id": 75890,
                        "name": "Ures",
                        "latitude": "29.42708000",
                        "longitude": "-110.38760000"
                    },
                    {
                        "id": 75969,
                        "name": "Vicam",
                        "latitude": "27.64354000",
                        "longitude": "-110.29351000"
                    },
                    {
                        "id": 75975,
                        "name": "Vicente Guerrero",
                        "latitude": "27.53786000",
                        "longitude": "-109.97697000"
                    },
                    {
                        "id": 76014,
                        "name": "Villa Hidalgo",
                        "latitude": "30.16183000",
                        "longitude": "-109.32154000"
                    },
                    {
                        "id": 76021,
                        "name": "Villa Juárez",
                        "latitude": "27.12851000",
                        "longitude": "-109.83921000"
                    },
                    {
                        "id": 76040,
                        "name": "Villa Pesqueira",
                        "latitude": "29.11813000",
                        "longitude": "-109.96753000"
                    },
                    {
                        "id": 76222,
                        "name": "Yavaros",
                        "latitude": "26.70483000",
                        "longitude": "-109.52103000"
                    }
                ]
            },
            {
                "id": 3454,
                "name": "Tabasco",
                "iso2": "TAB",
                "latitude": "17.84091730",
                "longitude": "-92.61892730",
                "type": "state",
                "cities": [
                    {
                        "id": 68022,
                        "name": "Acachapan y Colmena 3ra. Sección",
                        "latitude": "18.04858000",
                        "longitude": "-92.77750000"
                    },
                    {
                        "id": 76402,
                        "name": "Álvaro Obregón (Santa Cruz)",
                        "latitude": "18.39422000",
                        "longitude": "-92.79982000"
                    },
                    {
                        "id": 76403,
                        "name": "Álvaro Obregón 2da. Sección (El Lechugal)",
                        "latitude": "18.39287000",
                        "longitude": "-92.79119000"
                    },
                    {
                        "id": 68233,
                        "name": "Amado Gómez",
                        "latitude": "18.14684000",
                        "longitude": "-93.35618000"
                    },
                    {
                        "id": 68265,
                        "name": "Anacleto Canabal 2da. Sección",
                        "latitude": "17.97556000",
                        "longitude": "-93.02417000"
                    },
                    {
                        "id": 68266,
                        "name": "Anacleto Canabal 3ra. Sección",
                        "latitude": "18.01830000",
                        "longitude": "-92.98992000"
                    },
                    {
                        "id": 68269,
                        "name": "Andrés Quintana Roo",
                        "latitude": "17.70771000",
                        "longitude": "-93.01077000"
                    },
                    {
                        "id": 68299,
                        "name": "Apatzingán",
                        "latitude": "17.60803000",
                        "longitude": "-91.06687000"
                    },
                    {
                        "id": 68318,
                        "name": "Aquiles Serdán",
                        "latitude": "17.78333000",
                        "longitude": "-92.28333000"
                    },
                    {
                        "id": 68324,
                        "name": "Aquiles Serdán (San Fernando)",
                        "latitude": "17.80556000",
                        "longitude": "-92.48972000"
                    },
                    {
                        "id": 68325,
                        "name": "Aquiles Serdán 1ra. Sección",
                        "latitude": "17.82474000",
                        "longitude": "-92.73977000"
                    },
                    {
                        "id": 68343,
                        "name": "Arena 1ra. Sección",
                        "latitude": "18.20139000",
                        "longitude": "-93.36694000"
                    },
                    {
                        "id": 68344,
                        "name": "Arena 6ta. Sección (La Bolsa)",
                        "latitude": "18.16218000",
                        "longitude": "-93.39539000"
                    },
                    {
                        "id": 68345,
                        "name": "Arena de Hidalgo",
                        "latitude": "17.45827000",
                        "longitude": "-91.58847000"
                    },
                    {
                        "id": 68361,
                        "name": "Arroyo Hondo Abejonal",
                        "latitude": "17.97739000",
                        "longitude": "-93.41039000"
                    },
                    {
                        "id": 68382,
                        "name": "Astapa",
                        "latitude": "17.78165000",
                        "longitude": "-92.84938000"
                    },
                    {
                        "id": 68460,
                        "name": "Ayapa",
                        "latitude": "18.22410000",
                        "longitude": "-93.11158000"
                    },
                    {
                        "id": 68507,
                        "name": "Balancán",
                        "latitude": "17.80903000",
                        "longitude": "-91.53682000"
                    },
                    {
                        "id": 68512,
                        "name": "Banderas (Guatacalca 2da. Sección)",
                        "latitude": "18.15167000",
                        "longitude": "-92.89881000"
                    },
                    {
                        "id": 68521,
                        "name": "Barrancas y Amate 3ra. Sección",
                        "latitude": "17.97100000",
                        "longitude": "-92.76173000"
                    },
                    {
                        "id": 68582,
                        "name": "Belén",
                        "latitude": "17.78907000",
                        "longitude": "-92.61137000"
                    },
                    {
                        "id": 68587,
                        "name": "Benito González",
                        "latitude": "17.86993000",
                        "longitude": "-92.70834000"
                    },
                    {
                        "id": 68591,
                        "name": "Benito Juárez",
                        "latitude": "18.42573000",
                        "longitude": "-92.80285000"
                    },
                    {
                        "id": 68603,
                        "name": "Benito Juárez (La Playita)",
                        "latitude": "17.93231000",
                        "longitude": "-93.36472000"
                    },
                    {
                        "id": 68613,
                        "name": "Betania",
                        "latitude": "18.28003000",
                        "longitude": "-93.32081000"
                    },
                    {
                        "id": 68618,
                        "name": "Blasillo 1ra. Sección (Nicolás Bravo)",
                        "latitude": "18.07861000",
                        "longitude": "-93.91833000"
                    },
                    {
                        "id": 68637,
                        "name": "Boquiapa",
                        "latitude": "18.16111000",
                        "longitude": "-93.13750000"
                    },
                    {
                        "id": 68643,
                        "name": "Bosque de Saloya",
                        "latitude": "18.01611000",
                        "longitude": "-92.95806000"
                    },
                    {
                        "id": 68651,
                        "name": "Brisas del Carrizal",
                        "latitude": "18.01556000",
                        "longitude": "-92.97083000"
                    },
                    {
                        "id": 68663,
                        "name": "Buena Vista (Apasco)",
                        "latitude": "17.65556000",
                        "longitude": "-92.44389000"
                    },
                    {
                        "id": 68664,
                        "name": "Buena Vista (Puxcatán)",
                        "latitude": "17.73073000",
                        "longitude": "-92.61996000"
                    },
                    {
                        "id": 68665,
                        "name": "Buena Vista 1ra. Sección",
                        "latitude": "18.14417000",
                        "longitude": "-92.74972000"
                    },
                    {
                        "id": 68668,
                        "name": "Buenavista",
                        "latitude": "17.91667000",
                        "longitude": "-92.53333000"
                    },
                    {
                        "id": 68697,
                        "name": "C-32 (Licenciado Francisco Trujillo Gurría)",
                        "latitude": "17.96833000",
                        "longitude": "-93.50139000"
                    },
                    {
                        "id": 68698,
                        "name": "C-41 (Licenciado Carlos A. Madrazo)",
                        "latitude": "17.92306000",
                        "longitude": "-93.44806000"
                    },
                    {
                        "id": 68802,
                        "name": "Caobanal 1ra. Sección (Mezcalapa)",
                        "latitude": "17.64858000",
                        "longitude": "-93.39464000"
                    },
                    {
                        "id": 68805,
                        "name": "Caparroso",
                        "latitude": "18.34500000",
                        "longitude": "-92.80361000"
                    },
                    {
                        "id": 68806,
                        "name": "Capitán Felipe Castellanos Díaz (San Pedro)",
                        "latitude": "17.77306000",
                        "longitude": "-91.14750000"
                    },
                    {
                        "id": 69659,
                        "name": "Cárdenas",
                        "latitude": "18.00135000",
                        "longitude": "-93.37559000"
                    },
                    {
                        "id": 68889,
                        "name": "Ceiba 1ra. Sección (Jahuactal)",
                        "latitude": "18.06222000",
                        "longitude": "-93.11306000"
                    },
                    {
                        "id": 68898,
                        "name": "Centro",
                        "latitude": "17.98633000",
                        "longitude": "-92.88674000"
                    },
                    {
                        "id": 68943,
                        "name": "Chablé",
                        "latitude": "17.85895000",
                        "longitude": "-91.78130000"
                    },
                    {
                        "id": 69021,
                        "name": "Chichicapa",
                        "latitude": "18.26228000",
                        "longitude": "-93.18210000"
                    },
                    {
                        "id": 69023,
                        "name": "Chichicastle 1ra. Sección",
                        "latitude": "18.30417000",
                        "longitude": "-92.43139000"
                    },
                    {
                        "id": 69106,
                        "name": "Chontalpa",
                        "latitude": "17.66614000",
                        "longitude": "-93.48115000"
                    },
                    {
                        "id": 69175,
                        "name": "Ciudad Pemex",
                        "latitude": "17.88268000",
                        "longitude": "-92.48406000"
                    },
                    {
                        "id": 69237,
                        "name": "Cocohital",
                        "latitude": "18.39527000",
                        "longitude": "-93.34527000"
                    },
                    {
                        "id": 69418,
                        "name": "Comalcalco",
                        "latitude": "18.26316000",
                        "longitude": "-93.22397000"
                    },
                    {
                        "id": 69464,
                        "name": "Constitución",
                        "latitude": "18.07278000",
                        "longitude": "-92.87194000"
                    },
                    {
                        "id": 69493,
                        "name": "Corriente 1ra. Sección",
                        "latitude": "18.15767000",
                        "longitude": "-92.99372000"
                    },
                    {
                        "id": 69609,
                        "name": "Cucuyulapa Primera Sección",
                        "latitude": "17.99082000",
                        "longitude": "-93.25619000"
                    },
                    {
                        "id": 69663,
                        "name": "Cúlico 2da. Sección",
                        "latitude": "18.14116000",
                        "longitude": "-93.13222000"
                    },
                    {
                        "id": 69637,
                        "name": "Cumuapa 1ra. Sección",
                        "latitude": "17.98519000",
                        "longitude": "-93.13806000"
                    },
                    {
                        "id": 69640,
                        "name": "Cunduacán",
                        "latitude": "18.06557000",
                        "longitude": "-93.17302000"
                    },
                    {
                        "id": 69644,
                        "name": "Cupilco",
                        "latitude": "18.23947000",
                        "longitude": "-93.12767000"
                    },
                    {
                        "id": 69718,
                        "name": "Dos Ceibas",
                        "latitude": "18.04112000",
                        "longitude": "-93.03561000"
                    },
                    {
                        "id": 69719,
                        "name": "Dos Montes",
                        "latitude": "17.98774000",
                        "longitude": "-92.82832000"
                    },
                    {
                        "id": 69838,
                        "name": "El Bajío",
                        "latitude": "17.98173000",
                        "longitude": "-92.78229000"
                    },
                    {
                        "id": 69844,
                        "name": "El Bellote (Miguel de la Madrid)",
                        "latitude": "18.42528000",
                        "longitude": "-93.15083000"
                    },
                    {
                        "id": 69891,
                        "name": "El Cedro",
                        "latitude": "18.02699000",
                        "longitude": "-92.94760000"
                    },
                    {
                        "id": 69918,
                        "name": "El Congo",
                        "latitude": "17.82522000",
                        "longitude": "-92.43887000"
                    },
                    {
                        "id": 69946,
                        "name": "El Dorado",
                        "latitude": "17.88323000",
                        "longitude": "-93.36788000"
                    },
                    {
                        "id": 69958,
                        "name": "El Escribano",
                        "latitude": "18.41028000",
                        "longitude": "-93.22167000"
                    },
                    {
                        "id": 70148,
                        "name": "El Recreo",
                        "latitude": "18.28058000",
                        "longitude": "-93.09285000"
                    },
                    {
                        "id": 70227,
                        "name": "El Tigre",
                        "latitude": "18.10194000",
                        "longitude": "-92.94194000"
                    },
                    {
                        "id": 70232,
                        "name": "El Tortuguero",
                        "latitude": "18.31413000",
                        "longitude": "-93.28499000"
                    },
                    {
                        "id": 70234,
                        "name": "El Triunfo",
                        "latitude": "17.92241000",
                        "longitude": "-91.16946000"
                    },
                    {
                        "id": 70239,
                        "name": "El Tular",
                        "latitude": "18.15429000",
                        "longitude": "-93.33820000"
                    },
                    {
                        "id": 70302,
                        "name": "Encrucijada 3ra. Sección (Las Calzadas)",
                        "latitude": "18.25491000",
                        "longitude": "-93.55619000"
                    },
                    {
                        "id": 70368,
                        "name": "Estapilla",
                        "latitude": "17.54491000",
                        "longitude": "-91.40503000"
                    },
                    {
                        "id": 70380,
                        "name": "Eureka y Belén",
                        "latitude": "17.55968000",
                        "longitude": "-92.92899000"
                    },
                    {
                        "id": 70430,
                        "name": "Fraccionamiento Ocuiltzapotlán Dos",
                        "latitude": "18.10889000",
                        "longitude": "-92.86778000"
                    },
                    {
                        "id": 70464,
                        "name": "Francisco I. Madero",
                        "latitude": "18.34047000",
                        "longitude": "-93.20999000"
                    },
                    {
                        "id": 70474,
                        "name": "Francisco Rueda",
                        "latitude": "17.82917000",
                        "longitude": "-93.93389000"
                    },
                    {
                        "id": 70490,
                        "name": "Frontera",
                        "latitude": "18.54326000",
                        "longitude": "-92.64530000"
                    },
                    {
                        "id": 70523,
                        "name": "Gaviotas Sur (El Cedral)",
                        "latitude": "17.95373000",
                        "longitude": "-92.89071000"
                    },
                    {
                        "id": 70539,
                        "name": "General Luis Felipe Domínguez Suárez",
                        "latitude": "17.65639000",
                        "longitude": "-91.53667000"
                    },
                    {
                        "id": 70551,
                        "name": "Gobernador Cruz",
                        "latitude": "18.43364000",
                        "longitude": "-92.87180000"
                    },
                    {
                        "id": 70552,
                        "name": "Gobernadores",
                        "latitude": "18.24694000",
                        "longitude": "-93.18528000"
                    },
                    {
                        "id": 70566,
                        "name": "Gregorio Méndez",
                        "latitude": "18.19639000",
                        "longitude": "-93.10222000"
                    },
                    {
                        "id": 70622,
                        "name": "Guatacalca",
                        "latitude": "18.16599000",
                        "longitude": "-92.97871000"
                    },
                    {
                        "id": 70627,
                        "name": "Guaytalpa",
                        "latitude": "18.21727000",
                        "longitude": "-93.03235000"
                    },
                    {
                        "id": 70649,
                        "name": "Habanero 1ra. Sección (Venustiano Carranza)",
                        "latitude": "17.96778000",
                        "longitude": "-93.32806000"
                    },
                    {
                        "id": 70670,
                        "name": "Hermenegildo Galeana 2da. Sección",
                        "latitude": "18.17054000",
                        "longitude": "-93.13508000"
                    },
                    {
                        "id": 70713,
                        "name": "Huacapa y Amestoy",
                        "latitude": "18.05377000",
                        "longitude": "-93.19694000"
                    },
                    {
                        "id": 70735,
                        "name": "Huapacal 1ra. Sección",
                        "latitude": "17.92667000",
                        "longitude": "-93.76639000"
                    },
                    {
                        "id": 70736,
                        "name": "Huapacal 2da. Sección (Punta Brava)",
                        "latitude": "18.19722000",
                        "longitude": "-93.17194000"
                    },
                    {
                        "id": 70737,
                        "name": "Huapinol",
                        "latitude": "17.92285000",
                        "longitude": "-92.91090000"
                    },
                    {
                        "id": 70795,
                        "name": "Huimanguillo",
                        "latitude": "17.83366000",
                        "longitude": "-93.38926000"
                    },
                    {
                        "id": 70835,
                        "name": "Ignacio Allende",
                        "latitude": "18.38299000",
                        "longitude": "-92.84418000"
                    },
                    {
                        "id": 70841,
                        "name": "Ignacio Gutiérrez Gómez",
                        "latitude": "18.24948000",
                        "longitude": "-93.39748000"
                    },
                    {
                        "id": 70854,
                        "name": "Ignacio Zaragoza",
                        "latitude": "18.40139000",
                        "longitude": "-92.95944000"
                    },
                    {
                        "id": 70859,
                        "name": "Ignacio Zaragoza 1ra. Sección",
                        "latitude": "18.33157000",
                        "longitude": "-93.33508000"
                    },
                    {
                        "id": 70874,
                        "name": "Iquinuapa",
                        "latitude": "18.19583000",
                        "longitude": "-93.12056000"
                    },
                    {
                        "id": 70965,
                        "name": "Jalapa",
                        "latitude": "17.72168000",
                        "longitude": "-92.81272000"
                    },
                    {
                        "id": 70968,
                        "name": "Jalapita",
                        "latitude": "18.41506000",
                        "longitude": "-92.99483000"
                    },
                    {
                        "id": 70977,
                        "name": "Jalpa de Méndez",
                        "latitude": "18.17633000",
                        "longitude": "-93.06300000"
                    },
                    {
                        "id": 70994,
                        "name": "Jalupa",
                        "latitude": "18.13687000",
                        "longitude": "-93.04534000"
                    },
                    {
                        "id": 71048,
                        "name": "Jiménez",
                        "latitude": "18.16043000",
                        "longitude": "-92.93336000"
                    },
                    {
                        "id": 71072,
                        "name": "Jolochero 2da. Sección",
                        "latitude": "18.12000000",
                        "longitude": "-92.79833000"
                    },
                    {
                        "id": 71081,
                        "name": "Jonuta",
                        "latitude": "18.08984000",
                        "longitude": "-92.13807000"
                    },
                    {
                        "id": 71089,
                        "name": "José Colomo",
                        "latitude": "17.94691000",
                        "longitude": "-92.46659000"
                    },
                    {
                        "id": 71209,
                        "name": "La Ceiba",
                        "latitude": "18.14436000",
                        "longitude": "-92.77805000"
                    },
                    {
                        "id": 71256,
                        "name": "La Curva",
                        "latitude": "17.86604000",
                        "longitude": "-92.48814000"
                    },
                    {
                        "id": 71265,
                        "name": "La Escalera",
                        "latitude": "17.84361000",
                        "longitude": "-92.52556000"
                    },
                    {
                        "id": 71287,
                        "name": "La Estrella",
                        "latitude": "18.60302000",
                        "longitude": "-92.58256000"
                    },
                    {
                        "id": 71358,
                        "name": "La Lima",
                        "latitude": "17.91056000",
                        "longitude": "-92.93389000"
                    },
                    {
                        "id": 71370,
                        "name": "La Lucha",
                        "latitude": "18.18069000",
                        "longitude": "-93.32176000"
                    },
                    {
                        "id": 71388,
                        "name": "La Manga 2da. Sección (El Jobal)",
                        "latitude": "18.01917000",
                        "longitude": "-92.86944000"
                    },
                    {
                        "id": 71417,
                        "name": "La Palma",
                        "latitude": "17.97980000",
                        "longitude": "-92.80555000"
                    },
                    {
                        "id": 71440,
                        "name": "La Península",
                        "latitude": "17.94347000",
                        "longitude": "-93.36148000"
                    },
                    {
                        "id": 71499,
                        "name": "La Sábana",
                        "latitude": "18.44461000",
                        "longitude": "-92.88411000"
                    },
                    {
                        "id": 71487,
                        "name": "La Selva",
                        "latitude": "18.02333000",
                        "longitude": "-92.96306000"
                    },
                    {
                        "id": 71518,
                        "name": "La Unión",
                        "latitude": "17.84839000",
                        "longitude": "-92.49628000"
                    },
                    {
                        "id": 71531,
                        "name": "La Victoria",
                        "latitude": "18.59102000",
                        "longitude": "-92.63284000"
                    },
                    {
                        "id": 71546,
                        "name": "Lagartera 1ra. Sección",
                        "latitude": "18.06277000",
                        "longitude": "-92.88563000"
                    },
                    {
                        "id": 71669,
                        "name": "Libertad",
                        "latitude": "17.41027000",
                        "longitude": "-92.71502000"
                    },
                    {
                        "id": 71761,
                        "name": "Lomitas",
                        "latitude": "18.06434000",
                        "longitude": "-92.96201000"
                    },
                    {
                        "id": 71786,
                        "name": "Los Cenotes",
                        "latitude": "17.63461000",
                        "longitude": "-91.03759000"
                    },
                    {
                        "id": 71859,
                        "name": "Los Sauces",
                        "latitude": "18.03335000",
                        "longitude": "-92.91693000"
                    },
                    {
                        "id": 71881,
                        "name": "Luis Gil Pérez",
                        "latitude": "17.87541000",
                        "longitude": "-93.07124000"
                    },
                    {
                        "id": 71910,
                        "name": "Mactún",
                        "latitude": "17.58980000",
                        "longitude": "-91.29298000"
                    },
                    {
                        "id": 71912,
                        "name": "Macultepec",
                        "latitude": "18.15026000",
                        "longitude": "-92.86092000"
                    },
                    {
                        "id": 71913,
                        "name": "Macuspana",
                        "latitude": "17.76052000",
                        "longitude": "-92.59539000"
                    },
                    {
                        "id": 72044,
                        "name": "Mazateupa",
                        "latitude": "18.20217000",
                        "longitude": "-93.00933000"
                    },
                    {
                        "id": 72054,
                        "name": "Mecatepec",
                        "latitude": "17.88988000",
                        "longitude": "-93.52498000"
                    },
                    {
                        "id": 72059,
                        "name": "Mecoacán",
                        "latitude": "18.23855000",
                        "longitude": "-93.08187000"
                    },
                    {
                        "id": 72060,
                        "name": "Mecoacán 2da. Sección (San Lorenzo)",
                        "latitude": "18.27790000",
                        "longitude": "-93.09095000"
                    },
                    {
                        "id": 72063,
                        "name": "Medellín y Madero Segunda Sección",
                        "latitude": "18.11351000",
                        "longitude": "-92.85400000"
                    },
                    {
                        "id": 72070,
                        "name": "Melchor Ocampo",
                        "latitude": "18.03694000",
                        "longitude": "-93.36250000"
                    },
                    {
                        "id": 72127,
                        "name": "Miguel Hidalgo",
                        "latitude": "18.25691000",
                        "longitude": "-93.31073000"
                    },
                    {
                        "id": 72133,
                        "name": "Miguel Hidalgo 2da. Sección B (La Natividad)",
                        "latitude": "18.07861000",
                        "longitude": "-93.35056000"
                    },
                    {
                        "id": 72200,
                        "name": "Monte Grande",
                        "latitude": "17.93541000",
                        "longitude": "-92.26444000"
                    },
                    {
                        "id": 72203,
                        "name": "Monte Largo 1ra. Sección",
                        "latitude": "17.83567000",
                        "longitude": "-92.60664000"
                    },
                    {
                        "id": 72235,
                        "name": "Morelos Piedra 3ra. Sección",
                        "latitude": "18.14389000",
                        "longitude": "-93.22000000"
                    },
                    {
                        "id": 72252,
                        "name": "Multé",
                        "latitude": "17.68850000",
                        "longitude": "-91.37944000"
                    },
                    {
                        "id": 72264,
                        "name": "Nacajuca",
                        "latitude": "18.16971000",
                        "longitude": "-93.01843000"
                    },
                    {
                        "id": 72313,
                        "name": "Netzahualcóyotl",
                        "latitude": "17.71086000",
                        "longitude": "-91.44322000"
                    },
                    {
                        "id": 72321,
                        "name": "Nicolás Bravo",
                        "latitude": "18.15504000",
                        "longitude": "-93.08304000"
                    },
                    {
                        "id": 72326,
                        "name": "Nicolás Bravo 5ta. Sección (Punta Brava)",
                        "latitude": "18.27827000",
                        "longitude": "-93.12872000"
                    },
                    {
                        "id": 72356,
                        "name": "Norte 1ra. Sección (San Julián)",
                        "latitude": "18.30139000",
                        "longitude": "-93.20944000"
                    },
                    {
                        "id": 72363,
                        "name": "Nueva División del Bayo (Guatemala)",
                        "latitude": "17.84000000",
                        "longitude": "-92.48889000"
                    },
                    {
                        "id": 72416,
                        "name": "Nuevo Torno Largo",
                        "latitude": "18.43228000",
                        "longitude": "-93.16443000"
                    },
                    {
                        "id": 72443,
                        "name": "Occidente (San Francisco)",
                        "latitude": "18.33130000",
                        "longitude": "-93.25238000"
                    },
                    {
                        "id": 72444,
                        "name": "Occidente 4ta. Sección",
                        "latitude": "18.30347000",
                        "longitude": "-93.23388000"
                    },
                    {
                        "id": 72469,
                        "name": "Ocuapan",
                        "latitude": "17.85430000",
                        "longitude": "-93.48978000"
                    },
                    {
                        "id": 72499,
                        "name": "Olcuatitán",
                        "latitude": "18.19045000",
                        "longitude": "-92.96114000"
                    },
                    {
                        "id": 72521,
                        "name": "Oriente 1ra. Sección",
                        "latitude": "18.33889000",
                        "longitude": "-93.20056000"
                    },
                    {
                        "id": 72522,
                        "name": "Oriente 1ra. Sección (Santo Domingo)",
                        "latitude": "18.26417000",
                        "longitude": "-93.20306000"
                    },
                    {
                        "id": 72523,
                        "name": "Oriente 2da. Sección (Palma Huaca)",
                        "latitude": "18.32917000",
                        "longitude": "-93.18528000"
                    },
                    {
                        "id": 72524,
                        "name": "Oriente 2da. Sección (San Cayetano)",
                        "latitude": "18.18667000",
                        "longitude": "-93.22944000"
                    },
                    {
                        "id": 72525,
                        "name": "Oriente 6ta. Sección (Los Mulatos)",
                        "latitude": "18.16722000",
                        "longitude": "-93.23583000"
                    },
                    {
                        "id": 72549,
                        "name": "Oxiacaque",
                        "latitude": "18.21386000",
                        "longitude": "-92.94674000"
                    },
                    {
                        "id": 72553,
                        "name": "Oxolotán",
                        "latitude": "17.37947000",
                        "longitude": "-92.74933000"
                    },
                    {
                        "id": 72565,
                        "name": "Pablo L. Sidar",
                        "latitude": "17.90028000",
                        "longitude": "-93.02917000"
                    },
                    {
                        "id": 72610,
                        "name": "Palo Mulato",
                        "latitude": "18.02035000",
                        "longitude": "-93.76943000"
                    },
                    {
                        "id": 72614,
                        "name": "Palomas",
                        "latitude": "17.65466000",
                        "longitude": "-92.47800000"
                    },
                    {
                        "id": 72642,
                        "name": "Paraiso",
                        "latitude": "18.40116000",
                        "longitude": "-93.21406000"
                    },
                    {
                        "id": 72656,
                        "name": "Parilla",
                        "latitude": "17.91552000",
                        "longitude": "-92.91612000"
                    },
                    {
                        "id": 72662,
                        "name": "Parrilla II",
                        "latitude": "17.87900000",
                        "longitude": "-92.92235000"
                    },
                    {
                        "id": 72694,
                        "name": "Paso de la Mina 2da. Sección (Barrial)",
                        "latitude": "17.95278000",
                        "longitude": "-93.69083000"
                    },
                    {
                        "id": 72695,
                        "name": "Paso de la Mina 3ra. Sección",
                        "latitude": "17.96335000",
                        "longitude": "-93.66582000"
                    },
                    {
                        "id": 72718,
                        "name": "Pechucalco",
                        "latitude": "18.09361000",
                        "longitude": "-93.16611000"
                    },
                    {
                        "id": 72719,
                        "name": "Pechucalco 2da. Sección (Las Cruces)",
                        "latitude": "18.12694000",
                        "longitude": "-93.19056000"
                    },
                    {
                        "id": 72726,
                        "name": "Pejelagartero 1ra. Sección (Plataforma)",
                        "latitude": "18.05500000",
                        "longitude": "-93.82472000"
                    },
                    {
                        "id": 73012,
                        "name": "Pénjamo",
                        "latitude": "18.43444000",
                        "longitude": "-93.09306000"
                    },
                    {
                        "id": 72816,
                        "name": "Playas del Rosario",
                        "latitude": "17.85308000",
                        "longitude": "-92.93219000"
                    },
                    {
                        "id": 72821,
                        "name": "Poblado C-11 José María Morelos y Pavón",
                        "latitude": "18.17419000",
                        "longitude": "-93.62356000"
                    },
                    {
                        "id": 72822,
                        "name": "Poblado C-21 Licenciado Benito Juárez García",
                        "latitude": "18.06778000",
                        "longitude": "-93.56139000"
                    },
                    {
                        "id": 72823,
                        "name": "Poblado C-33 20 de Noviembre",
                        "latitude": "17.96750000",
                        "longitude": "-93.56500000"
                    },
                    {
                        "id": 72845,
                        "name": "Pomoca",
                        "latitude": "18.04972000",
                        "longitude": "-92.93056000"
                    },
                    {
                        "id": 72862,
                        "name": "Potrerillo",
                        "latitude": "18.25472000",
                        "longitude": "-93.13472000"
                    },
                    {
                        "id": 72946,
                        "name": "Pueblo Nuevo de las Raíces",
                        "latitude": "17.84572000",
                        "longitude": "-92.87930000"
                    },
                    {
                        "id": 72947,
                        "name": "Pueblo Viejo",
                        "latitude": "18.19990000",
                        "longitude": "-93.08546000"
                    },
                    {
                        "id": 72967,
                        "name": "Puerto Ceiba",
                        "latitude": "18.41081000",
                        "longitude": "-93.17890000"
                    },
                    {
                        "id": 73004,
                        "name": "Puxcatán",
                        "latitude": "17.45083000",
                        "longitude": "-92.68712000"
                    },
                    {
                        "id": 73040,
                        "name": "Quintín Arauz",
                        "latitude": "18.37275000",
                        "longitude": "-93.21879000"
                    },
                    {
                        "id": 73062,
                        "name": "Rancho Nuevo",
                        "latitude": "18.07201000",
                        "longitude": "-93.07252000"
                    },
                    {
                        "id": 73083,
                        "name": "Raya Zaragoza",
                        "latitude": "17.40595000",
                        "longitude": "-92.68519000"
                    },
                    {
                        "id": 73093,
                        "name": "Reforma",
                        "latitude": "18.21398000",
                        "longitude": "-93.34291000"
                    },
                    {
                        "id": 73187,
                        "name": "Río de Teapa",
                        "latitude": "17.78342000",
                        "longitude": "-92.90033000"
                    },
                    {
                        "id": 73183,
                        "name": "Río Seco 2da. Sección (Santiaguito)",
                        "latitude": "18.13750000",
                        "longitude": "-93.27583000"
                    },
                    {
                        "id": 73186,
                        "name": "Río Viejo Primera Sección",
                        "latitude": "17.93913000",
                        "longitude": "-92.98022000"
                    },
                    {
                        "id": 73221,
                        "name": "Saloya 2da. Sección",
                        "latitude": "18.05306000",
                        "longitude": "-92.93639000"
                    },
                    {
                        "id": 73235,
                        "name": "Samarkanda",
                        "latitude": "18.04216000",
                        "longitude": "-92.91050000"
                    },
                    {
                        "id": 73456,
                        "name": "San Carlos",
                        "latitude": "17.55221000",
                        "longitude": "-91.15408000"
                    },
                    {
                        "id": 74482,
                        "name": "San Simón",
                        "latitude": "18.23687000",
                        "longitude": "-93.03416000"
                    },
                    {
                        "id": 74854,
                        "name": "Santa Rosalía",
                        "latitude": "18.08851000",
                        "longitude": "-93.35806000"
                    },
                    {
                        "id": 74864,
                        "name": "Santana 2da. Sección B (La Palma)",
                        "latitude": "18.17505000",
                        "longitude": "-93.43180000"
                    },
                    {
                        "id": 75041,
                        "name": "Sargento López 2da. Sección (El Chuzo)",
                        "latitude": "18.19953000",
                        "longitude": "-93.29235000"
                    },
                    {
                        "id": 75086,
                        "name": "Simón Sarlat",
                        "latitude": "18.34447000",
                        "longitude": "-92.80811000"
                    },
                    {
                        "id": 75132,
                        "name": "Soyataco",
                        "latitude": "18.20995000",
                        "longitude": "-93.07430000"
                    },
                    {
                        "id": 75160,
                        "name": "Tacotalpa",
                        "latitude": "17.59638000",
                        "longitude": "-92.82596000"
                    },
                    {
                        "id": 75194,
                        "name": "Tamulte de las Sabanas",
                        "latitude": "18.16168000",
                        "longitude": "-92.78354000"
                    },
                    {
                        "id": 75226,
                        "name": "Tapijulapa",
                        "latitude": "17.46208000",
                        "longitude": "-92.77908000"
                    },
                    {
                        "id": 75228,
                        "name": "Tapotzingo",
                        "latitude": "18.20443000",
                        "longitude": "-93.01421000"
                    },
                    {
                        "id": 75245,
                        "name": "Taxco",
                        "latitude": "18.13917000",
                        "longitude": "-93.00528000"
                    },
                    {
                        "id": 75256,
                        "name": "Teapa",
                        "latitude": "17.54970000",
                        "longitude": "-92.95211000"
                    },
                    {
                        "id": 75278,
                        "name": "Tecoluta 2da. Sección",
                        "latitude": "18.24408000",
                        "longitude": "-93.01956000"
                    },
                    {
                        "id": 75284,
                        "name": "Tecominoacán",
                        "latitude": "17.92122000",
                        "longitude": "-93.56318000"
                    },
                    {
                        "id": 75370,
                        "name": "Tenosique",
                        "latitude": "17.47290000",
                        "longitude": "-91.42360000"
                    },
                    {
                        "id": 75421,
                        "name": "Tepetitán",
                        "latitude": "17.81987000",
                        "longitude": "-92.37269000"
                    },
                    {
                        "id": 75460,
                        "name": "Tequila 1ra. Sección (La Aurora)",
                        "latitude": "17.88000000",
                        "longitude": "-92.72306000"
                    },
                    {
                        "id": 75766,
                        "name": "Transito Tular",
                        "latitude": "18.33849000",
                        "longitude": "-93.40283000"
                    },
                    {
                        "id": 75770,
                        "name": "Tres Bocas 1ra. Sección",
                        "latitude": "17.93231000",
                        "longitude": "-93.87444000"
                    },
                    {
                        "id": 75787,
                        "name": "Tucta",
                        "latitude": "18.19346000",
                        "longitude": "-92.99535000"
                    },
                    {
                        "id": 75944,
                        "name": "Veinte de Noviembre",
                        "latitude": "17.84699000",
                        "longitude": "-92.58910000"
                    },
                    {
                        "id": 75971,
                        "name": "Vicente Guerrero",
                        "latitude": "17.51323000",
                        "longitude": "-92.92236000"
                    },
                    {
                        "id": 75990,
                        "name": "Villa Aldama",
                        "latitude": "18.24088000",
                        "longitude": "-93.35068000"
                    },
                    {
                        "id": 76075,
                        "name": "Villa la Venta",
                        "latitude": "18.09863000",
                        "longitude": "-94.04593000"
                    },
                    {
                        "id": 76046,
                        "name": "Villa Tecolutilla",
                        "latitude": "18.28338000",
                        "longitude": "-93.33398000"
                    },
                    {
                        "id": 76054,
                        "name": "Villa Vicente Guerrero",
                        "latitude": "18.39007000",
                        "longitude": "-92.89607000"
                    },
                    {
                        "id": 76080,
                        "name": "Villahermosa",
                        "latitude": "17.98689000",
                        "longitude": "-92.93028000"
                    },
                    {
                        "id": 76142,
                        "name": "Xicoténcatl",
                        "latitude": "17.51833000",
                        "longitude": "-92.70474000"
                    }
                ]
            },
            {
                "id": 3463,
                "name": "Tamaulipas",
                "iso2": "TAM",
                "latitude": "24.26694000",
                "longitude": "-98.83627550",
                "type": "state",
                "cities": [
                    {
                        "id": 68012,
                        "name": "Abasolo",
                        "latitude": "24.05844000",
                        "longitude": "-98.37333000"
                    },
                    {
                        "id": 68184,
                        "name": "Aldama",
                        "latitude": "22.92157000",
                        "longitude": "-98.07519000"
                    },
                    {
                        "id": 68196,
                        "name": "Alfredo V. Bonfil",
                        "latitude": "25.56203000",
                        "longitude": "-98.23952000"
                    },
                    {
                        "id": 68221,
                        "name": "Altamira",
                        "latitude": "22.39215000",
                        "longitude": "-97.93867000"
                    },
                    {
                        "id": 68284,
                        "name": "Anáhuac",
                        "latitude": "25.77638000",
                        "longitude": "-97.77413000"
                    },
                    {
                        "id": 68277,
                        "name": "Antiguo Morelos",
                        "latitude": "22.54950000",
                        "longitude": "-99.08123000"
                    },
                    {
                        "id": 68522,
                        "name": "Barretal",
                        "latitude": "24.08337000",
                        "longitude": "-99.12526000"
                    },
                    {
                        "id": 68692,
                        "name": "Burgos",
                        "latitude": "24.94722000",
                        "longitude": "-98.79921000"
                    },
                    {
                        "id": 68693,
                        "name": "Bustamante",
                        "latitude": "23.43524000",
                        "longitude": "-99.75875000"
                    },
                    {
                        "id": 68759,
                        "name": "Camargo",
                        "latitude": "26.23130000",
                        "longitude": "-98.85019000"
                    },
                    {
                        "id": 68818,
                        "name": "Carboneras",
                        "latitude": "24.62766000",
                        "longitude": "-97.71755000"
                    },
                    {
                        "id": 68839,
                        "name": "Carrillo Puerto",
                        "latitude": "22.43139000",
                        "longitude": "-97.96417000"
                    },
                    {
                        "id": 68852,
                        "name": "Casas",
                        "latitude": "23.72686000",
                        "longitude": "-98.73662000"
                    },
                    {
                        "id": 68699,
                        "name": "CEFERESO Número 3",
                        "latitude": "25.84722000",
                        "longitude": "-97.63333000"
                    },
                    {
                        "id": 69147,
                        "name": "Ciudad Camargo",
                        "latitude": "26.31437000",
                        "longitude": "-98.83378000"
                    },
                    {
                        "id": 69159,
                        "name": "Ciudad Gustavo Díaz Ordaz",
                        "latitude": "26.23186000",
                        "longitude": "-98.59560000"
                    },
                    {
                        "id": 69166,
                        "name": "Ciudad Madero",
                        "latitude": "22.27228000",
                        "longitude": "-97.83623000"
                    },
                    {
                        "id": 69167,
                        "name": "Ciudad Mante",
                        "latitude": "22.74304000",
                        "longitude": "-98.97390000"
                    },
                    {
                        "id": 69171,
                        "name": "Ciudad Miguel Alemán",
                        "latitude": "26.39952000",
                        "longitude": "-99.02836000"
                    },
                    {
                        "id": 69176,
                        "name": "Ciudad Río Bravo",
                        "latitude": "25.98729000",
                        "longitude": "-98.09414000"
                    },
                    {
                        "id": 69182,
                        "name": "Ciudad Tula",
                        "latitude": "22.99732000",
                        "longitude": "-99.71101000"
                    },
                    {
                        "id": 69184,
                        "name": "Ciudad Victoria",
                        "latitude": "23.74174000",
                        "longitude": "-99.14599000"
                    },
                    {
                        "id": 69419,
                        "name": "Comales",
                        "latitude": "26.18187000",
                        "longitude": "-98.92037000"
                    },
                    {
                        "id": 69540,
                        "name": "Cruillas",
                        "latitude": "24.75658000",
                        "longitude": "-98.53739000"
                    },
                    {
                        "id": 69578,
                        "name": "Cuauhtémoc",
                        "latitude": "22.54408000",
                        "longitude": "-98.15074000"
                    },
                    {
                        "id": 69822,
                        "name": "El Abra",
                        "latitude": "22.62058000",
                        "longitude": "-99.02142000"
                    },
                    {
                        "id": 69839,
                        "name": "El Barrancón del Tío Blas (El Barrancón)",
                        "latitude": "25.01556000",
                        "longitude": "-97.71694000"
                    },
                    {
                        "id": 69859,
                        "name": "El Campanario y Oradel",
                        "latitude": "27.47306000",
                        "longitude": "-99.62000000"
                    },
                    {
                        "id": 69922,
                        "name": "El Control",
                        "latitude": "25.95867000",
                        "longitude": "-97.81281000"
                    },
                    {
                        "id": 69974,
                        "name": "El Galaneño",
                        "latitude": "25.76091000",
                        "longitude": "-97.54507000"
                    },
                    {
                        "id": 70016,
                        "name": "El Limón",
                        "latitude": "22.82498000",
                        "longitude": "-99.00512000"
                    },
                    {
                        "id": 70033,
                        "name": "El Mante",
                        "latitude": "22.67241000",
                        "longitude": "-98.93820000"
                    },
                    {
                        "id": 70145,
                        "name": "El Realito",
                        "latitude": "25.66528000",
                        "longitude": "-97.87540000"
                    },
                    {
                        "id": 70355,
                        "name": "Estación Santa Engracia",
                        "latitude": "24.01528000",
                        "longitude": "-99.20194000"
                    },
                    {
                        "id": 70371,
                        "name": "Esteros",
                        "latitude": "22.52005000",
                        "longitude": "-98.12607000"
                    },
                    {
                        "id": 70555,
                        "name": "González",
                        "latitude": "22.82735000",
                        "longitude": "-98.42713000"
                    },
                    {
                        "id": 70558,
                        "name": "Graciano Sánchez",
                        "latitude": "22.65430000",
                        "longitude": "-98.55467000"
                    },
                    {
                        "id": 70595,
                        "name": "Guadalupe Victoria",
                        "latitude": "24.08205000",
                        "longitude": "-98.23340000"
                    },
                    {
                        "id": 70629,
                        "name": "Guemes",
                        "latitude": "23.91865000",
                        "longitude": "-99.00609000"
                    },
                    {
                        "id": 70648,
                        "name": "Güémez",
                        "latitude": "23.90693000",
                        "longitude": "-99.06872000"
                    },
                    {
                        "id": 70632,
                        "name": "Guerrero",
                        "latitude": "26.90952000",
                        "longitude": "-99.45995000"
                    },
                    {
                        "id": 70635,
                        "name": "Guillermo Zúñiga",
                        "latitude": "24.01548000",
                        "longitude": "-99.20074000"
                    },
                    {
                        "id": 70641,
                        "name": "Gustavo Díaz Ordaz",
                        "latitude": "26.16130000",
                        "longitude": "-98.64045000"
                    },
                    {
                        "id": 70680,
                        "name": "Heroica Matamoros",
                        "latitude": "25.87972000",
                        "longitude": "-97.50417000"
                    },
                    {
                        "id": 70684,
                        "name": "Hidalgo",
                        "latitude": "24.24812000",
                        "longitude": "-99.43897000"
                    },
                    {
                        "id": 71012,
                        "name": "Jaumave",
                        "latitude": "23.40621000",
                        "longitude": "-99.38072000"
                    },
                    {
                        "id": 71052,
                        "name": "Jiménez",
                        "latitude": "24.26262000",
                        "longitude": "-98.49656000"
                    },
                    {
                        "id": 71218,
                        "name": "La Colonia",
                        "latitude": "22.43880000",
                        "longitude": "-98.01729000"
                    },
                    {
                        "id": 71352,
                        "name": "La Libertad",
                        "latitude": "23.79079000",
                        "longitude": "-99.19132000"
                    },
                    {
                        "id": 71399,
                        "name": "La Misión",
                        "latitude": "23.80326000",
                        "longitude": "-99.17025000"
                    },
                    {
                        "id": 71438,
                        "name": "La Pedrera",
                        "latitude": "22.39353000",
                        "longitude": "-97.88210000"
                    },
                    {
                        "id": 71443,
                        "name": "La Pesca",
                        "latitude": "23.78660000",
                        "longitude": "-97.77712000"
                    },
                    {
                        "id": 71603,
                        "name": "Las Higuerillas",
                        "latitude": "25.26222000",
                        "longitude": "-97.43611000"
                    },
                    {
                        "id": 71889,
                        "name": "Lázaro Cárdenas",
                        "latitude": "22.97090000",
                        "longitude": "-100.05357000"
                    },
                    {
                        "id": 71698,
                        "name": "Llera",
                        "latitude": "23.26609000",
                        "longitude": "-98.91836000"
                    },
                    {
                        "id": 71699,
                        "name": "Llera de Canales",
                        "latitude": "23.31774000",
                        "longitude": "-99.02608000"
                    },
                    {
                        "id": 71759,
                        "name": "Lomas del Real",
                        "latitude": "22.52052000",
                        "longitude": "-97.89913000"
                    },
                    {
                        "id": 71901,
                        "name": "López Rayón",
                        "latitude": "22.49758000",
                        "longitude": "-98.45979000"
                    },
                    {
                        "id": 71775,
                        "name": "Los Aztecas",
                        "latitude": "22.50093000",
                        "longitude": "-98.61417000"
                    },
                    {
                        "id": 71784,
                        "name": "Los Cavazos",
                        "latitude": "26.14803000",
                        "longitude": "-98.34508000"
                    },
                    {
                        "id": 71805,
                        "name": "Los Guerra",
                        "latitude": "26.39429000",
                        "longitude": "-99.07972000"
                    },
                    {
                        "id": 71907,
                        "name": "Maclovio Herrera",
                        "latitude": "22.50062000",
                        "longitude": "-98.08545000"
                    },
                    {
                        "id": 71935,
                        "name": "Magdaleno Cedillo",
                        "latitude": "22.78882000",
                        "longitude": "-99.93799000"
                    },
                    {
                        "id": 71940,
                        "name": "Mainero",
                        "latitude": "24.58503000",
                        "longitude": "-99.56313000"
                    },
                    {
                        "id": 72019,
                        "name": "Matamoros",
                        "latitude": "25.72171000",
                        "longitude": "-97.60135000"
                    },
                    {
                        "id": 72260,
                        "name": "Méndez",
                        "latitude": "25.11819000",
                        "longitude": "-98.58666000"
                    },
                    {
                        "id": 72121,
                        "name": "Mier",
                        "latitude": "26.42969000",
                        "longitude": "-99.15212000"
                    },
                    {
                        "id": 72123,
                        "name": "Miguel Alemán",
                        "latitude": "26.26713000",
                        "longitude": "-99.06203000"
                    },
                    {
                        "id": 72151,
                        "name": "Miquihuana",
                        "latitude": "23.57575000",
                        "longitude": "-99.75438000"
                    },
                    {
                        "id": 72154,
                        "name": "Miramar",
                        "latitude": "22.36094000",
                        "longitude": "-97.89997000"
                    },
                    {
                        "id": 72320,
                        "name": "Nicolás Bravo",
                        "latitude": "24.00180000",
                        "longitude": "-98.25927000"
                    },
                    {
                        "id": 72360,
                        "name": "Nueva Apolonia",
                        "latitude": "22.49743000",
                        "longitude": "-98.63103000"
                    },
                    {
                        "id": 72361,
                        "name": "Nueva Ciudad Guerrero",
                        "latitude": "26.56219000",
                        "longitude": "-99.22863000"
                    },
                    {
                        "id": 72377,
                        "name": "Nueva Villa de Padilla",
                        "latitude": "24.04784000",
                        "longitude": "-98.90085000"
                    },
                    {
                        "id": 72383,
                        "name": "Nuevo Cereso Regional de Altamira",
                        "latitude": "22.46056000",
                        "longitude": "-98.00833000"
                    },
                    {
                        "id": 72390,
                        "name": "Nuevo Laredo",
                        "latitude": "27.47629000",
                        "longitude": "-99.51639000"
                    },
                    {
                        "id": 72396,
                        "name": "Nuevo Morelos",
                        "latitude": "22.53604000",
                        "longitude": "-99.21934000"
                    },
                    {
                        "id": 72404,
                        "name": "Nuevo Progreso",
                        "latitude": "26.05530000",
                        "longitude": "-97.95217000"
                    },
                    {
                        "id": 72415,
                        "name": "Nuevo Tantoán",
                        "latitude": "22.42623000",
                        "longitude": "-98.56834000"
                    },
                    {
                        "id": 72436,
                        "name": "Ocampo",
                        "latitude": "22.84695000",
                        "longitude": "-99.33866000"
                    },
                    {
                        "id": 72572,
                        "name": "Padilla",
                        "latitude": "24.05571000",
                        "longitude": "-98.89671000"
                    },
                    {
                        "id": 72597,
                        "name": "Palmillas",
                        "latitude": "23.30225000",
                        "longitude": "-99.54896000"
                    },
                    {
                        "id": 72799,
                        "name": "Plan de Ayala",
                        "latitude": "22.54028000",
                        "longitude": "-98.76722000"
                    },
                    {
                        "id": 72898,
                        "name": "Primero de Mayo",
                        "latitude": "22.96058000",
                        "longitude": "-98.94992000"
                    },
                    {
                        "id": 73038,
                        "name": "Quintero",
                        "latitude": "22.66289000",
                        "longitude": "-99.03584000"
                    },
                    {
                        "id": 73050,
                        "name": "Ramírez",
                        "latitude": "25.95180000",
                        "longitude": "-97.78558000"
                    },
                    {
                        "id": 73104,
                        "name": "Reynosa",
                        "latitude": "26.08061000",
                        "longitude": "-98.28835000"
                    },
                    {
                        "id": 73105,
                        "name": "Ricardo Flores Magón",
                        "latitude": "22.45115000",
                        "longitude": "-97.90739000"
                    },
                    {
                        "id": 73170,
                        "name": "Río Bravo",
                        "latitude": "25.83854000",
                        "longitude": "-98.03879000"
                    },
                    {
                        "id": 73346,
                        "name": "San Antonio Rayón",
                        "latitude": "22.42079000",
                        "longitude": "-98.41648000"
                    },
                    {
                        "id": 73458,
                        "name": "San Carlos",
                        "latitude": "24.58223000",
                        "longitude": "-98.94208000"
                    },
                    {
                        "id": 73534,
                        "name": "San Fernando",
                        "latitude": "24.84749000",
                        "longitude": "-98.14828000"
                    },
                    {
                        "id": 73637,
                        "name": "San Germán",
                        "latitude": "25.21681000",
                        "longitude": "-97.92186000"
                    },
                    {
                        "id": 74249,
                        "name": "San Nicolás",
                        "latitude": "24.69377000",
                        "longitude": "-98.83000000"
                    },
                    {
                        "id": 74518,
                        "name": "Santa Adelaida",
                        "latitude": "25.85414000",
                        "longitude": "-97.65216000"
                    },
                    {
                        "id": 74562,
                        "name": "Santa Apolonia",
                        "latitude": "25.64303000",
                        "longitude": "-97.98486000"
                    },
                    {
                        "id": 74865,
                        "name": "Santander Jiménez",
                        "latitude": "24.21682000",
                        "longitude": "-98.48433000"
                    },
                    {
                        "id": 75127,
                        "name": "Soto la Marina",
                        "latitude": "23.76953000",
                        "longitude": "-98.20442000"
                    },
                    {
                        "id": 75191,
                        "name": "Tampico",
                        "latitude": "22.29508000",
                        "longitude": "-97.93595000"
                    },
                    {
                        "id": 75193,
                        "name": "Tampiquito",
                        "latitude": "23.83333000",
                        "longitude": "-98.19469000"
                    },
                    {
                        "id": 75790,
                        "name": "Tula",
                        "latitude": "22.97028000",
                        "longitude": "-99.70257000"
                    },
                    {
                        "id": 75879,
                        "name": "Unidos Avanzamos",
                        "latitude": "22.43389000",
                        "longitude": "-97.97167000"
                    },
                    {
                        "id": 75896,
                        "name": "Ursulo Galván",
                        "latitude": "22.72779000",
                        "longitude": "-98.32191000"
                    },
                    {
                        "id": 75905,
                        "name": "Valadeces",
                        "latitude": "26.23176000",
                        "longitude": "-98.67726000"
                    },
                    {
                        "id": 75914,
                        "name": "Valle Hermoso",
                        "latitude": "25.67207000",
                        "longitude": "-97.81313000"
                    },
                    {
                        "id": 75935,
                        "name": "Vamos Tamaulipas",
                        "latitude": "25.98667000",
                        "longitude": "-98.22167000"
                    },
                    {
                        "id": 75983,
                        "name": "Victoria",
                        "latitude": "23.75836000",
                        "longitude": "-99.13489000"
                    },
                    {
                        "id": 76033,
                        "name": "Villa Mainero",
                        "latitude": "24.56007000",
                        "longitude": "-99.61561000"
                    },
                    {
                        "id": 76078,
                        "name": "Villagrán",
                        "latitude": "24.47264000",
                        "longitude": "-99.49107000"
                    },
                    {
                        "id": 76143,
                        "name": "Xicoténcatl",
                        "latitude": "22.99623000",
                        "longitude": "-98.94218000"
                    }
                ]
            },
            {
                "id": 3458,
                "name": "Tlaxcala",
                "iso2": "TLA",
                "latitude": "19.31815400",
                "longitude": "-98.23749540",
                "type": "state",
                "cities": [
                    {
                        "id": 68066,
                        "name": "Acopinalco del Peñón",
                        "latitude": "19.65929000",
                        "longitude": "-98.16299000"
                    },
                    {
                        "id": 68075,
                        "name": "Acuamanala",
                        "latitude": "19.22361000",
                        "longitude": "-98.20056000"
                    },
                    {
                        "id": 68078,
                        "name": "Acuitlapilco",
                        "latitude": "19.27333000",
                        "longitude": "-98.23542000"
                    },
                    {
                        "id": 68085,
                        "name": "Acxotla del Monte",
                        "latitude": "19.25208000",
                        "longitude": "-98.16777000"
                    },
                    {
                        "id": 68086,
                        "name": "Acxotla del Río",
                        "latitude": "19.32417000",
                        "longitude": "-98.23750000"
                    },
                    {
                        "id": 68229,
                        "name": "Altzayanca",
                        "latitude": "19.43121000",
                        "longitude": "-97.79555000"
                    },
                    {
                        "id": 68248,
                        "name": "Amaxac de Guerrero",
                        "latitude": "19.34661000",
                        "longitude": "-98.17057000"
                    },
                    {
                        "id": 68306,
                        "name": "Apetatitlán Antonio Carbajal",
                        "latitude": "19.33622000",
                        "longitude": "-98.17912000"
                    },
                    {
                        "id": 68308,
                        "name": "Apizaco",
                        "latitude": "19.41333000",
                        "longitude": "-98.14358000"
                    },
                    {
                        "id": 68403,
                        "name": "Atexcatzingo",
                        "latitude": "19.46882000",
                        "longitude": "-98.14716000"
                    },
                    {
                        "id": 68415,
                        "name": "Atlangatepec",
                        "latitude": "19.53220000",
                        "longitude": "-98.20888000"
                    },
                    {
                        "id": 68424,
                        "name": "Atlzayanca",
                        "latitude": "19.43111000",
                        "longitude": "-97.79556000"
                    },
                    {
                        "id": 68462,
                        "name": "Ayometitla",
                        "latitude": "19.20722000",
                        "longitude": "-98.19306000"
                    },
                    {
                        "id": 68583,
                        "name": "Belén Atzitzimititlán",
                        "latitude": "19.34694000",
                        "longitude": "-98.19000000"
                    },
                    {
                        "id": 68589,
                        "name": "Benito Juárez",
                        "latitude": "19.37391000",
                        "longitude": "-97.90900000"
                    },
                    {
                        "id": 68747,
                        "name": "Calpulalpan",
                        "latitude": "19.58867000",
                        "longitude": "-98.56972000"
                    },
                    {
                        "id": 68809,
                        "name": "Capula",
                        "latitude": "19.53642000",
                        "longitude": "-98.04219000"
                    },
                    {
                        "id": 69191,
                        "name": "Ciudad de Nanacamilpa",
                        "latitude": "19.49339000",
                        "longitude": "-98.53665000"
                    },
                    {
                        "id": 69289,
                        "name": "Colonia Cuauhtémoc",
                        "latitude": "19.33182000",
                        "longitude": "-97.96487000"
                    },
                    {
                        "id": 69312,
                        "name": "Colonia Ignacio Allende",
                        "latitude": "19.35667000",
                        "longitude": "-97.78389000"
                    },
                    {
                        "id": 69364,
                        "name": "Colonia San Isidro",
                        "latitude": "19.41167000",
                        "longitude": "-98.11278000"
                    },
                    {
                        "id": 69375,
                        "name": "Colonia Venustiano Carranza",
                        "latitude": "19.40005000",
                        "longitude": "-98.05822000"
                    },
                    {
                        "id": 69435,
                        "name": "Concepción Chimalpa",
                        "latitude": "19.21639000",
                        "longitude": "-98.19806000"
                    },
                    {
                        "id": 69437,
                        "name": "Concepción Hidalgo",
                        "latitude": "19.39810000",
                        "longitude": "-97.81951000"
                    },
                    {
                        "id": 69468,
                        "name": "Contla",
                        "latitude": "19.32932000",
                        "longitude": "-98.16640000"
                    },
                    {
                        "id": 69561,
                        "name": "Cuapiaxtla",
                        "latitude": "19.29588000",
                        "longitude": "-97.76880000"
                    },
                    {
                        "id": 69597,
                        "name": "Cuaxomulco",
                        "latitude": "19.35264000",
                        "longitude": "-98.09670000"
                    },
                    {
                        "id": 69877,
                        "name": "El Carmen Aztama",
                        "latitude": "19.22972000",
                        "longitude": "-98.21944000"
                    },
                    {
                        "id": 69879,
                        "name": "El Carmen Xalpatlahuaya",
                        "latitude": "19.39193000",
                        "longitude": "-97.98167000"
                    },
                    {
                        "id": 70173,
                        "name": "El Rosario",
                        "latitude": "19.66109000",
                        "longitude": "-98.22892000"
                    },
                    {
                        "id": 70279,
                        "name": "Emiliano Zapata",
                        "latitude": "19.55861000",
                        "longitude": "-97.91667000"
                    },
                    {
                        "id": 70395,
                        "name": "Felipe Carrillo Puerto",
                        "latitude": "19.39922000",
                        "longitude": "-97.85520000"
                    },
                    {
                        "id": 70454,
                        "name": "Fraccionamiento la Virgen",
                        "latitude": "19.32306000",
                        "longitude": "-98.27389000"
                    },
                    {
                        "id": 70463,
                        "name": "Francisco I. Madero",
                        "latitude": "19.52096000",
                        "longitude": "-98.49052000"
                    },
                    {
                        "id": 70479,
                        "name": "Francisco Villa",
                        "latitude": "19.58630000",
                        "longitude": "-98.46225000"
                    },
                    {
                        "id": 70585,
                        "name": "Guadalupe Hidalgo",
                        "latitude": "19.22611000",
                        "longitude": "-98.18750000"
                    },
                    {
                        "id": 70592,
                        "name": "Guadalupe Texcalac",
                        "latitude": "19.43839000",
                        "longitude": "-98.07806000"
                    },
                    {
                        "id": 70593,
                        "name": "Guadalupe Tlachco",
                        "latitude": "19.32852000",
                        "longitude": "-98.11044000"
                    },
                    {
                        "id": 70725,
                        "name": "Hualcaltzinco",
                        "latitude": "19.40056000",
                        "longitude": "-98.16000000"
                    },
                    {
                        "id": 70727,
                        "name": "Huamantla",
                        "latitude": "19.31451000",
                        "longitude": "-97.92520000"
                    },
                    {
                        "id": 70781,
                        "name": "Hueyotlipan",
                        "latitude": "19.47088000",
                        "longitude": "-98.34778000"
                    },
                    {
                        "id": 70792,
                        "name": "Huiloapan",
                        "latitude": "19.38679000",
                        "longitude": "-98.26992000"
                    },
                    {
                        "id": 70848,
                        "name": "Ignacio Zaragoza",
                        "latitude": "19.29228000",
                        "longitude": "-97.92122000"
                    },
                    {
                        "id": 71026,
                        "name": "Jesús Huitznahuac",
                        "latitude": "19.34251000",
                        "longitude": "-98.12807000"
                    },
                    {
                        "id": 71035,
                        "name": "Jesús Tepactepec",
                        "latitude": "19.22917000",
                        "longitude": "-98.31417000"
                    },
                    {
                        "id": 71096,
                        "name": "José María Morelos",
                        "latitude": "19.31750000",
                        "longitude": "-97.97789000"
                    },
                    {
                        "id": 71177,
                        "name": "La Aurora",
                        "latitude": "19.25680000",
                        "longitude": "-98.22320000"
                    },
                    {
                        "id": 71197,
                        "name": "La Candelaria Teotlalpan",
                        "latitude": "19.33306000",
                        "longitude": "-98.22556000"
                    },
                    {
                        "id": 71385,
                        "name": "La Magdalena Tlaltelulco",
                        "latitude": "19.28287000",
                        "longitude": "-98.19609000"
                    },
                    {
                        "id": 71490,
                        "name": "La Soledad",
                        "latitude": "19.53841000",
                        "longitude": "-98.61750000"
                    },
                    {
                        "id": 71513,
                        "name": "La Trinidad Chimalpa",
                        "latitude": "19.32944000",
                        "longitude": "-98.24528000"
                    },
                    {
                        "id": 71514,
                        "name": "La Trinidad Tenexyecac",
                        "latitude": "19.33596000",
                        "longitude": "-98.31476000"
                    },
                    {
                        "id": 71562,
                        "name": "Lagunilla",
                        "latitude": "19.63607000",
                        "longitude": "-98.27434000"
                    },
                    {
                        "id": 71886,
                        "name": "Lázaro Cárdenas",
                        "latitude": "19.53750000",
                        "longitude": "-97.98222000"
                    },
                    {
                        "id": 71830,
                        "name": "Los Pilares",
                        "latitude": "19.27159000",
                        "longitude": "-97.94703000"
                    },
                    {
                        "id": 71849,
                        "name": "Los Reyes Quiahuixtlan",
                        "latitude": "19.33955000",
                        "longitude": "-98.25155000"
                    },
                    {
                        "id": 72037,
                        "name": "Mazapa",
                        "latitude": "19.54083000",
                        "longitude": "-98.55684000"
                    },
                    {
                        "id": 72041,
                        "name": "Mazatecochco",
                        "latitude": "19.17865000",
                        "longitude": "-98.18677000"
                    },
                    {
                        "id": 72258,
                        "name": "Muñoz",
                        "latitude": "19.47458000",
                        "longitude": "-98.20963000"
                    },
                    {
                        "id": 72289,
                        "name": "Natívitas",
                        "latitude": "19.23333000",
                        "longitude": "-98.31472000"
                    },
                    {
                        "id": 72322,
                        "name": "Nicolás Bravo",
                        "latitude": "19.42213000",
                        "longitude": "-97.96759000"
                    },
                    {
                        "id": 72623,
                        "name": "Panotla",
                        "latitude": "19.31619000",
                        "longitude": "-98.27013000"
                    },
                    {
                        "id": 72634,
                        "name": "Papalotla",
                        "latitude": "19.16861000",
                        "longitude": "-98.20389000"
                    },
                    {
                        "id": 73053,
                        "name": "Ranchería de Pocitos",
                        "latitude": "19.39389000",
                        "longitude": "-97.75944000"
                    },
                    {
                        "id": 73269,
                        "name": "San Andrés Ahuashuatepec",
                        "latitude": "19.37831000",
                        "longitude": "-98.10654000"
                    },
                    {
                        "id": 73423,
                        "name": "San Bartolomé Cuahuixmatlac",
                        "latitude": "19.29333000",
                        "longitude": "-98.14806000"
                    },
                    {
                        "id": 73427,
                        "name": "San Bartolomé Tenango",
                        "latitude": "19.25253000",
                        "longitude": "-98.29172000"
                    },
                    {
                        "id": 73431,
                        "name": "San Benito Xaltocan",
                        "latitude": "19.40594000",
                        "longitude": "-98.16683000"
                    },
                    {
                        "id": 73453,
                        "name": "San Buenaventura Atempan",
                        "latitude": "19.32667000",
                        "longitude": "-98.22194000"
                    },
                    {
                        "id": 73470,
                        "name": "San Cosme Atlamaxac",
                        "latitude": "19.23840000",
                        "longitude": "-98.22513000"
                    },
                    {
                        "id": 73485,
                        "name": "San Damián Texoloc",
                        "latitude": "19.27833000",
                        "longitude": "-98.28544000"
                    },
                    {
                        "id": 73508,
                        "name": "San Esteban Tizatlán",
                        "latitude": "19.33911000",
                        "longitude": "-98.21374000"
                    },
                    {
                        "id": 73523,
                        "name": "San Felipe Sultepec",
                        "latitude": "19.59083000",
                        "longitude": "-98.61528000"
                    },
                    {
                        "id": 73563,
                        "name": "San Francisco Cuexcontzi",
                        "latitude": "19.32023000",
                        "longitude": "-97.71092000"
                    },
                    {
                        "id": 73594,
                        "name": "San Francisco Temetzontla",
                        "latitude": "19.35028000",
                        "longitude": "-98.28861000"
                    },
                    {
                        "id": 73600,
                        "name": "San Francisco Tlacuilohcan",
                        "latitude": "19.40167000",
                        "longitude": "-98.19278000"
                    },
                    {
                        "id": 73646,
                        "name": "San Hipólito Chimalpa",
                        "latitude": "19.31963000",
                        "longitude": "-98.25004000"
                    },
                    {
                        "id": 73676,
                        "name": "San Isidro Buen Suceso",
                        "latitude": "19.15489000",
                        "longitude": "-98.10492000"
                    },
                    {
                        "id": 73723,
                        "name": "San Jerónimo Zacualpan",
                        "latitude": "19.24083000",
                        "longitude": "-98.26139000"
                    },
                    {
                        "id": 73733,
                        "name": "San Jorge Tezoquipan",
                        "latitude": "19.32094000",
                        "longitude": "-98.31319000"
                    },
                    {
                        "id": 73743,
                        "name": "San José Atoyatenco",
                        "latitude": "19.25083000",
                        "longitude": "-98.35528000"
                    },
                    {
                        "id": 73745,
                        "name": "San José Aztatla",
                        "latitude": "19.31004000",
                        "longitude": "-98.12655000"
                    },
                    {
                        "id": 73761,
                        "name": "San José Cuamantzingo",
                        "latitude": "19.51555000",
                        "longitude": "-98.25373000"
                    },
                    {
                        "id": 73784,
                        "name": "San José Teacalco",
                        "latitude": "19.33558000",
                        "longitude": "-98.06455000"
                    },
                    {
                        "id": 73790,
                        "name": "San José Tepeyahualco",
                        "latitude": "19.59944000",
                        "longitude": "-98.26889000"
                    },
                    {
                        "id": 73792,
                        "name": "San José Tetel",
                        "latitude": "19.43313000",
                        "longitude": "-98.15948000"
                    },
                    {
                        "id": 73800,
                        "name": "San José Villarreal",
                        "latitude": "19.53278000",
                        "longitude": "-97.89750000"
                    },
                    {
                        "id": 73802,
                        "name": "San José Xicohténcatl",
                        "latitude": "19.35440000",
                        "longitude": "-97.83081000"
                    },
                    {
                        "id": 73918,
                        "name": "San Juan Quetzalcoapan",
                        "latitude": "19.37947000",
                        "longitude": "-98.07113000"
                    },
                    {
                        "id": 73998,
                        "name": "San Lorenzo Axocomanitla",
                        "latitude": "19.22389000",
                        "longitude": "-98.24861000"
                    },
                    {
                        "id": 74011,
                        "name": "San Lorenzo Sóltepec",
                        "latitude": "19.60422000",
                        "longitude": "-98.31356000"
                    },
                    {
                        "id": 74020,
                        "name": "San Lorenzo Xaltelulco",
                        "latitude": "19.34075000",
                        "longitude": "-98.10585000"
                    },
                    {
                        "id": 74034,
                        "name": "San Lucas Tecopilco",
                        "latitude": "19.48626000",
                        "longitude": "-98.25605000"
                    },
                    {
                        "id": 74036,
                        "name": "San Lucas Tlacochcalco",
                        "latitude": "19.34261000",
                        "longitude": "-98.14641000"
                    },
                    {
                        "id": 74047,
                        "name": "San Luis Apizaquito",
                        "latitude": "19.42524000",
                        "longitude": "-98.11709000"
                    },
                    {
                        "id": 74069,
                        "name": "San Marcos Contla",
                        "latitude": "19.19923000",
                        "longitude": "-98.19950000"
                    },
                    {
                        "id": 74147,
                        "name": "San Matías Tepetomatitlán",
                        "latitude": "19.35389000",
                        "longitude": "-98.19490000"
                    },
                    {
                        "id": 74174,
                        "name": "San Miguel Contla",
                        "latitude": "19.36111000",
                        "longitude": "-98.13250000"
                    },
                    {
                        "id": 74215,
                        "name": "San Miguel Tlamahuco",
                        "latitude": "19.32417000",
                        "longitude": "-98.23972000"
                    },
                    {
                        "id": 74221,
                        "name": "San Miguel Xochitecatitla",
                        "latitude": "19.23877000",
                        "longitude": "-98.35422000"
                    },
                    {
                        "id": 74334,
                        "name": "San Pedro Ecatepec",
                        "latitude": "19.52158000",
                        "longitude": "-98.15468000"
                    },
                    {
                        "id": 74355,
                        "name": "San Pedro Muñoztla",
                        "latitude": "19.28167000",
                        "longitude": "-98.16693000"
                    },
                    {
                        "id": 74385,
                        "name": "San Pedro Tlacotepec",
                        "latitude": "19.39579000",
                        "longitude": "-98.04589000"
                    },
                    {
                        "id": 74396,
                        "name": "San Pedro Xalcaltzinco",
                        "latitude": "19.22778000",
                        "longitude": "-98.22806000"
                    },
                    {
                        "id": 74398,
                        "name": "San Pedro Xochiteotla",
                        "latitude": "19.30788000",
                        "longitude": "-98.13858000"
                    },
                    {
                        "id": 74434,
                        "name": "San Rafael Tenanyecac",
                        "latitude": "19.24786000",
                        "longitude": "-98.37121000"
                    },
                    {
                        "id": 74435,
                        "name": "San Rafael Tepatlaxco",
                        "latitude": "19.29833000",
                        "longitude": "-98.11972000"
                    },
                    {
                        "id": 74480,
                        "name": "San Simeón Xipetzingo",
                        "latitude": "19.48004000",
                        "longitude": "-98.29284000"
                    },
                    {
                        "id": 74486,
                        "name": "San Simón Tlatlahuquitepec",
                        "latitude": "19.39842000",
                        "longitude": "-98.22396000"
                    },
                    {
                        "id": 74517,
                        "name": "Sanctórum",
                        "latitude": "19.49333000",
                        "longitude": "-98.47156000"
                    },
                    {
                        "id": 74531,
                        "name": "Santa Ana Chiautempan",
                        "latitude": "19.30661000",
                        "longitude": "-98.18773000"
                    },
                    {
                        "id": 74561,
                        "name": "Santa Anita Huiloac",
                        "latitude": "19.38841000",
                        "longitude": "-98.14362000"
                    },
                    {
                        "id": 74563,
                        "name": "Santa Apolonia Teacalco",
                        "latitude": "19.24153000",
                        "longitude": "-98.31188000"
                    },
                    {
                        "id": 74580,
                        "name": "Santa Catarina Ayometla",
                        "latitude": "19.19833000",
                        "longitude": "-98.21361000"
                    },
                    {
                        "id": 74617,
                        "name": "Santa Cruz Aquiahuac",
                        "latitude": "19.23944000",
                        "longitude": "-98.28222000"
                    },
                    {
                        "id": 74635,
                        "name": "Santa Cruz Pocitos",
                        "latitude": "19.37924000",
                        "longitude": "-97.76116000"
                    },
                    {
                        "id": 74641,
                        "name": "Santa Cruz Tetela",
                        "latitude": "19.29250000",
                        "longitude": "-98.20778000"
                    },
                    {
                        "id": 74679,
                        "name": "Santa Isabel Xiloxoxtla",
                        "latitude": "19.26786000",
                        "longitude": "-98.21399000"
                    },
                    {
                        "id": 74684,
                        "name": "Santa Justina Ecatepec",
                        "latitude": "19.31083000",
                        "longitude": "-98.35500000"
                    },
                    {
                        "id": 74718,
                        "name": "Santa María Atlihuetzian",
                        "latitude": "19.37697000",
                        "longitude": "-98.17775000"
                    },
                    {
                        "id": 74748,
                        "name": "Santa María Ixtulco",
                        "latitude": "19.32529000",
                        "longitude": "-98.20843000"
                    },
                    {
                        "id": 74783,
                        "name": "Santa María Texcalac",
                        "latitude": "19.42333000",
                        "longitude": "-98.08663000"
                    },
                    {
                        "id": 74924,
                        "name": "Santiago Michac",
                        "latitude": "19.21985000",
                        "longitude": "-98.33932000"
                    },
                    {
                        "id": 74946,
                        "name": "Santiago Tepeticpac",
                        "latitude": "19.33476000",
                        "longitude": "-98.22692000"
                    },
                    {
                        "id": 74960,
                        "name": "Santiago Tlacochcalco",
                        "latitude": "19.26861000",
                        "longitude": "-98.22306000"
                    },
                    {
                        "id": 75034,
                        "name": "Santo Tomás la Concordia",
                        "latitude": "19.22917000",
                        "longitude": "-98.31944000"
                    },
                    {
                        "id": 75348,
                        "name": "Tenancingo",
                        "latitude": "19.14725000",
                        "longitude": "-98.20132000"
                    },
                    {
                        "id": 75377,
                        "name": "Teolocholco",
                        "latitude": "19.24333000",
                        "longitude": "-98.19083000"
                    },
                    {
                        "id": 75417,
                        "name": "Tepetitla",
                        "latitude": "19.26531000",
                        "longitude": "-98.37645000"
                    },
                    {
                        "id": 75444,
                        "name": "Tepeyanco",
                        "latitude": "19.24558000",
                        "longitude": "-98.23409000"
                    },
                    {
                        "id": 75470,
                        "name": "Terrenate",
                        "latitude": "19.47666000",
                        "longitude": "-97.92020000"
                    },
                    {
                        "id": 75491,
                        "name": "Tetla",
                        "latitude": "19.44204000",
                        "longitude": "-98.10325000"
                    },
                    {
                        "id": 75493,
                        "name": "Tetlanohcán",
                        "latitude": "19.26030000",
                        "longitude": "-98.16433000"
                    },
                    {
                        "id": 75685,
                        "name": "Tlatempan",
                        "latitude": "19.33167000",
                        "longitude": "-98.20306000"
                    },
                    {
                        "id": 75693,
                        "name": "Tlaxcala",
                        "latitude": "19.31905000",
                        "longitude": "-98.19982000"
                    },
                    {
                        "id": 75698,
                        "name": "Tlaxco",
                        "latitude": "19.61442000",
                        "longitude": "-98.11997000"
                    },
                    {
                        "id": 75712,
                        "name": "Tocatlán",
                        "latitude": "19.38865000",
                        "longitude": "-98.02740000"
                    },
                    {
                        "id": 75724,
                        "name": "Toluca de Guadalupe",
                        "latitude": "19.46898000",
                        "longitude": "-97.95588000"
                    },
                    {
                        "id": 75744,
                        "name": "Topilco de Juárez",
                        "latitude": "19.42095000",
                        "longitude": "-98.19990000"
                    },
                    {
                        "id": 75749,
                        "name": "Totolac",
                        "latitude": "19.32580000",
                        "longitude": "-98.25834000"
                    },
                    {
                        "id": 75851,
                        "name": "Tzompantepec",
                        "latitude": "19.37608000",
                        "longitude": "-98.09014000"
                    },
                    {
                        "id": 75883,
                        "name": "Unión Ejidal Tierra y Libertad",
                        "latitude": "19.65750000",
                        "longitude": "-98.33750000"
                    },
                    {
                        "id": 75991,
                        "name": "Villa Alta",
                        "latitude": "19.29263000",
                        "longitude": "-98.40110000"
                    },
                    {
                        "id": 76063,
                        "name": "Villa de El Carmen Tequexquitla",
                        "latitude": "19.32426000",
                        "longitude": "-97.65350000"
                    },
                    {
                        "id": 76055,
                        "name": "Villa Vicente Guerrero",
                        "latitude": "19.12123000",
                        "longitude": "-98.16572000"
                    },
                    {
                        "id": 76126,
                        "name": "Xaltocan",
                        "latitude": "19.42427000",
                        "longitude": "-98.21033000"
                    },
                    {
                        "id": 76138,
                        "name": "Xicohtzinco",
                        "latitude": "19.17371000",
                        "longitude": "-98.23377000"
                    },
                    {
                        "id": 76188,
                        "name": "Xocoyucan",
                        "latitude": "19.30932000",
                        "longitude": "-98.37471000"
                    },
                    {
                        "id": 76220,
                        "name": "Yauhquemehcan",
                        "latitude": "19.40697000",
                        "longitude": "-98.18230000"
                    },
                    {
                        "id": 76273,
                        "name": "Zacatelco",
                        "latitude": "19.21583000",
                        "longitude": "-98.23972000"
                    },
                    {
                        "id": 76319,
                        "name": "Zaragoza",
                        "latitude": "19.31861000",
                        "longitude": "-98.26389000"
                    },
                    {
                        "id": 76337,
                        "name": "Zimatepec",
                        "latitude": "19.42131000",
                        "longitude": "-98.16462000"
                    },
                    {
                        "id": 76353,
                        "name": "Zitlaltépec",
                        "latitude": "19.20389000",
                        "longitude": "-97.90722000"
                    },
                    {
                        "id": 76386,
                        "name": "Zumpango",
                        "latitude": "19.55770000",
                        "longitude": "-98.22407000"
                    }
                ]
            },
            {
                "id": 3464,
                "name": "Veracruz de Ignacio de la Llave",
                "iso2": "VER",
                "latitude": "19.17377300",
                "longitude": "-96.13422410",
                "type": "state",
                "cities": [
                    {
                        "id": 68017,
                        "name": "Abasolo del Valle",
                        "latitude": "17.78306000",
                        "longitude": "-95.54556000"
                    },
                    {
                        "id": 68021,
                        "name": "Abrevadero",
                        "latitude": "18.28222000",
                        "longitude": "-95.21444000"
                    },
                    {
                        "id": 68028,
                        "name": "Acajete",
                        "latitude": "19.56815000",
                        "longitude": "-97.03333000"
                    },
                    {
                        "id": 68046,
                        "name": "Acatla",
                        "latitude": "18.74944000",
                        "longitude": "-97.21833000"
                    },
                    {
                        "id": 68050,
                        "name": "Acatlán",
                        "latitude": "19.69648000",
                        "longitude": "-96.84367000"
                    },
                    {
                        "id": 68058,
                        "name": "Acayucan",
                        "latitude": "17.94979000",
                        "longitude": "-94.91386000"
                    },
                    {
                        "id": 68059,
                        "name": "Acazónica",
                        "latitude": "19.21284000",
                        "longitude": "-96.58978000"
                    },
                    {
                        "id": 68061,
                        "name": "Achotal de Moreno",
                        "latitude": "17.73652000",
                        "longitude": "-95.13395000"
                    },
                    {
                        "id": 68065,
                        "name": "Acontitla",
                        "latitude": "20.68206000",
                        "longitude": "-97.38469000"
                    },
                    {
                        "id": 68072,
                        "name": "Actopan",
                        "latitude": "19.50427000",
                        "longitude": "-96.61668000"
                    },
                    {
                        "id": 68081,
                        "name": "Acula",
                        "latitude": "18.50563000",
                        "longitude": "-95.77427000"
                    },
                    {
                        "id": 68083,
                        "name": "Acultzingo",
                        "latitude": "18.71894000",
                        "longitude": "-97.30367000"
                    },
                    {
                        "id": 68093,
                        "name": "Adolfo Moreno",
                        "latitude": "19.72472000",
                        "longitude": "-97.23806000"
                    },
                    {
                        "id": 68095,
                        "name": "Adolfo Ruíz Cortines",
                        "latitude": "20.59585000",
                        "longitude": "-97.30585000"
                    },
                    {
                        "id": 68100,
                        "name": "Agrícola Lázaro Cárdenas",
                        "latitude": "18.81361000",
                        "longitude": "-97.19833000"
                    },
                    {
                        "id": 68110,
                        "name": "Agua Dulce",
                        "latitude": "18.13909000",
                        "longitude": "-94.14527000"
                    },
                    {
                        "id": 68128,
                        "name": "Aguilera",
                        "latitude": "17.81083000",
                        "longitude": "-95.01500000"
                    },
                    {
                        "id": 68139,
                        "name": "Ahuacatán",
                        "latitude": "19.78351000",
                        "longitude": "-97.29780000"
                    },
                    {
                        "id": 68144,
                        "name": "Ahuateno",
                        "latitude": "21.00245000",
                        "longitude": "-98.15055000"
                    },
                    {
                        "id": 68159,
                        "name": "Ahueyahualco",
                        "latitude": "19.71974000",
                        "longitude": "-97.25984000"
                    },
                    {
                        "id": 76390,
                        "name": "Álamo",
                        "latitude": "20.91154000",
                        "longitude": "-97.67554000"
                    },
                    {
                        "id": 76391,
                        "name": "Álamo Temapache",
                        "latitude": "20.98922000",
                        "longitude": "-97.70592000"
                    },
                    {
                        "id": 68177,
                        "name": "Alborada",
                        "latitude": "19.44851000",
                        "longitude": "-96.87109000"
                    },
                    {
                        "id": 68205,
                        "name": "Allende",
                        "latitude": "18.15514000",
                        "longitude": "-94.39289000"
                    },
                    {
                        "id": 68209,
                        "name": "Almagres",
                        "latitude": "17.80750000",
                        "longitude": "-94.91750000"
                    },
                    {
                        "id": 68217,
                        "name": "Alpatláhuac",
                        "latitude": "19.10155000",
                        "longitude": "-97.12174000"
                    },
                    {
                        "id": 68227,
                        "name": "Alto Lucero",
                        "latitude": "20.95361000",
                        "longitude": "-97.44194000"
                    },
                    {
                        "id": 68228,
                        "name": "Altotonga",
                        "latitude": "19.76613000",
                        "longitude": "-97.24514000"
                    },
                    {
                        "id": 68230,
                        "name": "Alvarado",
                        "latitude": "18.77143000",
                        "longitude": "-95.76181000"
                    },
                    {
                        "id": 68241,
                        "name": "Amatitlán",
                        "latitude": "18.43371000",
                        "longitude": "-95.68388000"
                    },
                    {
                        "id": 68243,
                        "name": "Amatlán",
                        "latitude": "21.33519000",
                        "longitude": "-97.75704000"
                    },
                    {
                        "id": 68246,
                        "name": "Amatlán de los Reyes",
                        "latitude": "18.84658000",
                        "longitude": "-96.91595000"
                    },
                    {
                        "id": 68267,
                        "name": "Anahuac",
                        "latitude": "22.20275000",
                        "longitude": "-97.85506000"
                    },
                    {
                        "id": 68273,
                        "name": "Angel R. Cabada",
                        "latitude": "18.60798000",
                        "longitude": "-95.39724000"
                    },
                    {
                        "id": 68281,
                        "name": "Antón Lizardo",
                        "latitude": "19.05962000",
                        "longitude": "-95.99272000"
                    },
                    {
                        "id": 68279,
                        "name": "Antonio J Bermúdez",
                        "latitude": "22.15046000",
                        "longitude": "-98.15873000"
                    },
                    {
                        "id": 68304,
                        "name": "Apazapan",
                        "latitude": "19.33175000",
                        "longitude": "-96.65058000"
                    },
                    {
                        "id": 68316,
                        "name": "Aquila",
                        "latitude": "18.78958000",
                        "longitude": "-97.32319000"
                    },
                    {
                        "id": 68319,
                        "name": "Aquiles Serdán",
                        "latitude": "21.87206000",
                        "longitude": "-98.14794000"
                    },
                    {
                        "id": 68335,
                        "name": "Arboledas",
                        "latitude": "19.20722000",
                        "longitude": "-96.21444000"
                    },
                    {
                        "id": 68337,
                        "name": "Arbolillo",
                        "latitude": "18.81631000",
                        "longitude": "-95.83601000"
                    },
                    {
                        "id": 68347,
                        "name": "Arenal Santa Ana",
                        "latitude": "17.78951000",
                        "longitude": "-95.76970000"
                    },
                    {
                        "id": 68370,
                        "name": "Arroyo del Maíz Uno",
                        "latitude": "20.53667000",
                        "longitude": "-97.41528000"
                    },
                    {
                        "id": 68371,
                        "name": "Arroyo del Potrero",
                        "latitude": "20.14554000",
                        "longitude": "-97.06520000"
                    },
                    {
                        "id": 68360,
                        "name": "Arroyo Hondo",
                        "latitude": "20.02317000",
                        "longitude": "-96.87372000"
                    },
                    {
                        "id": 68364,
                        "name": "Arroyo San Isidro",
                        "latitude": "18.48667000",
                        "longitude": "-95.41333000"
                    },
                    {
                        "id": 68381,
                        "name": "Astacinga",
                        "latitude": "18.56900000",
                        "longitude": "-97.10376000"
                    },
                    {
                        "id": 68412,
                        "name": "Atlahuilco",
                        "latitude": "18.68308000",
                        "longitude": "-97.11553000"
                    },
                    {
                        "id": 68433,
                        "name": "Atoyac",
                        "latitude": "18.93182000",
                        "longitude": "-96.80203000"
                    },
                    {
                        "id": 68436,
                        "name": "Atzacan",
                        "latitude": "18.90724000",
                        "longitude": "-97.08307000"
                    },
                    {
                        "id": 68439,
                        "name": "Atzalan",
                        "latitude": "19.78864000",
                        "longitude": "-97.24195000"
                    },
                    {
                        "id": 68452,
                        "name": "Axochío",
                        "latitude": "18.37175000",
                        "longitude": "-95.29985000"
                    },
                    {
                        "id": 68458,
                        "name": "Ayahualulco",
                        "latitude": "19.38613000",
                        "longitude": "-97.14853000"
                    },
                    {
                        "id": 68466,
                        "name": "Ayotuxtla",
                        "latitude": "20.64885000",
                        "longitude": "-98.30264000"
                    },
                    {
                        "id": 68511,
                        "name": "Banderas",
                        "latitude": "20.99083000",
                        "longitude": "-97.39361000"
                    },
                    {
                        "id": 68514,
                        "name": "Banderilla",
                        "latitude": "19.58893000",
                        "longitude": "-96.93727000"
                    },
                    {
                        "id": 68516,
                        "name": "Bara de Chachalacas",
                        "latitude": "19.40643000",
                        "longitude": "-96.34159000"
                    },
                    {
                        "id": 68518,
                        "name": "Barra de Cazones",
                        "latitude": "20.72307000",
                        "longitude": "-97.20320000"
                    },
                    {
                        "id": 68520,
                        "name": "Barrancas",
                        "latitude": "18.06918000",
                        "longitude": "-94.58691000"
                    },
                    {
                        "id": 68550,
                        "name": "Barrio de San Miguel",
                        "latitude": "19.64333000",
                        "longitude": "-97.12389000"
                    },
                    {
                        "id": 68575,
                        "name": "Bella Esperanza",
                        "latitude": "19.43329000",
                        "longitude": "-96.86648000"
                    },
                    {
                        "id": 68594,
                        "name": "Benito Juárez",
                        "latitude": "20.88635000",
                        "longitude": "-98.20594000"
                    },
                    {
                        "id": 68617,
                        "name": "Blanca Espuma",
                        "latitude": "19.58117000",
                        "longitude": "-96.68819000"
                    },
                    {
                        "id": 68621,
                        "name": "Boca del Monte",
                        "latitude": "19.15451000",
                        "longitude": "-96.83270000"
                    },
                    {
                        "id": 68622,
                        "name": "Boca del Rio",
                        "latitude": "19.10464000",
                        "longitude": "-96.10405000"
                    },
                    {
                        "id": 68659,
                        "name": "Buena Vista",
                        "latitude": "19.04278000",
                        "longitude": "-96.85667000"
                    },
                    {
                        "id": 68669,
                        "name": "Buenavista",
                        "latitude": "18.89306000",
                        "longitude": "-97.03694000"
                    },
                    {
                        "id": 68685,
                        "name": "Buenos Aires",
                        "latitude": "18.46463000",
                        "longitude": "-95.24879000"
                    },
                    {
                        "id": 68691,
                        "name": "Buenos Aires (San Isidro)",
                        "latitude": "20.84028000",
                        "longitude": "-97.60139000"
                    },
                    {
                        "id": 68703,
                        "name": "Cabezas",
                        "latitude": "19.37167000",
                        "longitude": "-96.38278000"
                    },
                    {
                        "id": 68706,
                        "name": "Cacahuatal",
                        "latitude": "18.83098000",
                        "longitude": "-96.84192000"
                    },
                    {
                        "id": 68728,
                        "name": "Calcahualco",
                        "latitude": "19.13698000",
                        "longitude": "-97.14201000"
                    },
                    {
                        "id": 68734,
                        "name": "Calería",
                        "latitude": "18.42883000",
                        "longitude": "-95.17737000"
                    },
                    {
                        "id": 68735,
                        "name": "Calichar Palma Sola",
                        "latitude": "20.44155000",
                        "longitude": "-97.55103000"
                    },
                    {
                        "id": 68755,
                        "name": "Calzadas",
                        "latitude": "18.10121000",
                        "longitude": "-94.45524000"
                    },
                    {
                        "id": 68760,
                        "name": "Camarón de Tejeda",
                        "latitude": "19.00810000",
                        "longitude": "-96.56807000"
                    },
                    {
                        "id": 68763,
                        "name": "Camerino Z. Mendoza",
                        "latitude": "18.78246000",
                        "longitude": "-97.16016000"
                    },
                    {
                        "id": 68776,
                        "name": "Campo Chico",
                        "latitude": "18.83639000",
                        "longitude": "-97.02802000"
                    },
                    {
                        "id": 68780,
                        "name": "Campo de Águila",
                        "latitude": "18.06750000",
                        "longitude": "-94.98611000"
                    },
                    {
                        "id": 68777,
                        "name": "Campo Grande",
                        "latitude": "18.82296000",
                        "longitude": "-97.01265000"
                    },
                    {
                        "id": 68807,
                        "name": "Capoluca",
                        "latitude": "18.80639000",
                        "longitude": "-97.02722000"
                    },
                    {
                        "id": 68823,
                        "name": "Caristay",
                        "latitude": "20.64538000",
                        "longitude": "-97.30593000"
                    },
                    {
                        "id": 68824,
                        "name": "Carlos A. Carrillo",
                        "latitude": "18.37477000",
                        "longitude": "-95.75444000"
                    },
                    {
                        "id": 68840,
                        "name": "Carrillo Puerto",
                        "latitude": "18.81314000",
                        "longitude": "-96.58230000"
                    },
                    {
                        "id": 68841,
                        "name": "Carrizal",
                        "latitude": "20.59552000",
                        "longitude": "-97.25676000"
                    },
                    {
                        "id": 68857,
                        "name": "Casitas",
                        "latitude": "20.25532000",
                        "longitude": "-96.80114000"
                    },
                    {
                        "id": 68860,
                        "name": "Castillo de Teayo",
                        "latitude": "20.74927000",
                        "longitude": "-97.63030000"
                    },
                    {
                        "id": 68863,
                        "name": "Catemaco",
                        "latitude": "18.42131000",
                        "longitude": "-95.11398000"
                    },
                    {
                        "id": 68867,
                        "name": "Caxapa",
                        "latitude": "18.43103000",
                        "longitude": "-96.77456000"
                    },
                    {
                        "id": 68872,
                        "name": "Cazones de Herrera",
                        "latitude": "20.70423000",
                        "longitude": "-97.30994000"
                    },
                    {
                        "id": 68886,
                        "name": "Cecilio Terán",
                        "latitude": "18.81480000",
                        "longitude": "-97.22526000"
                    },
                    {
                        "id": 68894,
                        "name": "Cementeras del Pital",
                        "latitude": "20.17694000",
                        "longitude": "-96.89583000"
                    },
                    {
                        "id": 68901,
                        "name": "Centro de Readaptación Social",
                        "latitude": "19.62500000",
                        "longitude": "-97.22028000"
                    },
                    {
                        "id": 68914,
                        "name": "Cerritos",
                        "latitude": "19.13329000",
                        "longitude": "-96.60931000"
                    },
                    {
                        "id": 68922,
                        "name": "Cerro Azul",
                        "latitude": "21.19200000",
                        "longitude": "-97.74088000"
                    },
                    {
                        "id": 68925,
                        "name": "Cerro Gordo",
                        "latitude": "19.56951000",
                        "longitude": "-96.64835000"
                    },
                    {
                        "id": 68929,
                        "name": "Cerro Grande",
                        "latitude": "20.23861000",
                        "longitude": "-97.68194000"
                    },
                    {
                        "id": 68930,
                        "name": "Cerro Guzmán",
                        "latitude": "19.23543000",
                        "longitude": "-96.37856000"
                    },
                    {
                        "id": 68940,
                        "name": "Cerro las Iguanas",
                        "latitude": "18.41083000",
                        "longitude": "-95.19972000"
                    },
                    {
                        "id": 68945,
                        "name": "Chacalapa",
                        "latitude": "18.07860000",
                        "longitude": "-94.70280000"
                    },
                    {
                        "id": 68947,
                        "name": "Chacaltianguis",
                        "latitude": "18.30528000",
                        "longitude": "-95.84167000"
                    },
                    {
                        "id": 68964,
                        "name": "Chalma",
                        "latitude": "21.20799000",
                        "longitude": "-98.37526000"
                    },
                    {
                        "id": 68984,
                        "name": "Chapopote Chico",
                        "latitude": "21.13704000",
                        "longitude": "-98.24780000"
                    },
                    {
                        "id": 68985,
                        "name": "Chapopote Núñez",
                        "latitude": "20.93167000",
                        "longitude": "-97.68274000"
                    },
                    {
                        "id": 69001,
                        "name": "Chavarrillo",
                        "latitude": "19.42551000",
                        "longitude": "-96.79458000"
                    },
                    {
                        "id": 69003,
                        "name": "Chavaxtla",
                        "latitude": "19.13016000",
                        "longitude": "-96.83054000"
                    },
                    {
                        "id": 69024,
                        "name": "Chichicaxtle",
                        "latitude": "19.34306000",
                        "longitude": "-96.46861000"
                    },
                    {
                        "id": 69035,
                        "name": "Chicola",
                        "latitude": "18.90139000",
                        "longitude": "-97.10806000"
                    },
                    {
                        "id": 69039,
                        "name": "Chiconamel",
                        "latitude": "21.24326000",
                        "longitude": "-98.45426000"
                    },
                    {
                        "id": 69043,
                        "name": "Chiconquiaco",
                        "latitude": "19.74208000",
                        "longitude": "-96.81851000"
                    },
                    {
                        "id": 69044,
                        "name": "Chicontepec",
                        "latitude": "20.97214000",
                        "longitude": "-98.17239000"
                    },
                    {
                        "id": 69046,
                        "name": "Chicualoque",
                        "latitude": "20.38272000",
                        "longitude": "-97.66163000"
                    },
                    {
                        "id": 69047,
                        "name": "Chicuasen",
                        "latitude": "19.52785000",
                        "longitude": "-96.67224000"
                    },
                    {
                        "id": 69063,
                        "name": "Chilapa",
                        "latitude": "18.98861000",
                        "longitude": "-97.15417000"
                    },
                    {
                        "id": 69074,
                        "name": "Chiltoyac",
                        "latitude": "19.57708000",
                        "longitude": "-96.86660000"
                    },
                    {
                        "id": 69082,
                        "name": "Chinameca",
                        "latitude": "18.02195000",
                        "longitude": "-94.67945000"
                    },
                    {
                        "id": 69083,
                        "name": "Chinampa de Gorostiza",
                        "latitude": "21.35959000",
                        "longitude": "-97.73484000"
                    },
                    {
                        "id": 69097,
                        "name": "Chocamán",
                        "latitude": "19.01214000",
                        "longitude": "-97.03291000"
                    },
                    {
                        "id": 69104,
                        "name": "Chonegal",
                        "latitude": "18.57523000",
                        "longitude": "-95.39347000"
                    },
                    {
                        "id": 69107,
                        "name": "Chontla",
                        "latitude": "21.39198000",
                        "longitude": "-97.97877000"
                    },
                    {
                        "id": 69115,
                        "name": "Chumatlán",
                        "latitude": "20.20574000",
                        "longitude": "-97.59402000"
                    },
                    {
                        "id": 69120,
                        "name": "Chuniapan de Arriba",
                        "latitude": "18.34803000",
                        "longitude": "-95.18156000"
                    },
                    {
                        "id": 69140,
                        "name": "Citlaltépec",
                        "latitude": "21.32912000",
                        "longitude": "-97.87861000"
                    },
                    {
                        "id": 69141,
                        "name": "Citlaltépetl",
                        "latitude": "21.34351000",
                        "longitude": "-97.89201000"
                    },
                    {
                        "id": 69152,
                        "name": "Ciudad Cuauhtémoc",
                        "latitude": "22.18439000",
                        "longitude": "-97.83472000"
                    },
                    {
                        "id": 69170,
                        "name": "Ciudad Mendoza",
                        "latitude": "18.80645000",
                        "longitude": "-97.17870000"
                    },
                    {
                        "id": 69206,
                        "name": "Coacoatzintla",
                        "latitude": "19.65163000",
                        "longitude": "-96.94043000"
                    },
                    {
                        "id": 69207,
                        "name": "Coacotla",
                        "latitude": "17.93656000",
                        "longitude": "-94.66711000"
                    },
                    {
                        "id": 69216,
                        "name": "Coahuitlán",
                        "latitude": "20.27543000",
                        "longitude": "-97.70022000"
                    },
                    {
                        "id": 69224,
                        "name": "Coatepec",
                        "latitude": "19.45229000",
                        "longitude": "-96.96148000"
                    },
                    {
                        "id": 69231,
                        "name": "Coatzacoalcos",
                        "latitude": "18.14905000",
                        "longitude": "-94.44470000"
                    },
                    {
                        "id": 69233,
                        "name": "Coatzintla",
                        "latitude": "20.48699000",
                        "longitude": "-97.46823000"
                    },
                    {
                        "id": 69246,
                        "name": "Coetzala",
                        "latitude": "18.78521000",
                        "longitude": "-96.91697000"
                    },
                    {
                        "id": 69256,
                        "name": "Colatlán",
                        "latitude": "20.81642000",
                        "longitude": "-98.09697000"
                    },
                    {
                        "id": 69261,
                        "name": "Colipa",
                        "latitude": "19.92323000",
                        "longitude": "-96.72713000"
                    },
                    {
                        "id": 69272,
                        "name": "Colonia Adolfo Ruiz Cortines (Colonia Obrera)",
                        "latitude": "18.25694000",
                        "longitude": "-96.16139000"
                    },
                    {
                        "id": 69287,
                        "name": "Colonia Chalchihuecan",
                        "latitude": "19.21417000",
                        "longitude": "-96.21444000"
                    },
                    {
                        "id": 69390,
                        "name": "Colonia el Renacimiento",
                        "latitude": "19.21889000",
                        "longitude": "-96.21639000"
                    },
                    {
                        "id": 69397,
                        "name": "Colonia las Flores",
                        "latitude": "21.36167000",
                        "longitude": "-97.69306000"
                    },
                    {
                        "id": 69320,
                        "name": "Colonia Lealtad",
                        "latitude": "17.96306000",
                        "longitude": "-94.90250000"
                    },
                    {
                        "id": 69321,
                        "name": "Colonia Libertad",
                        "latitude": "19.67734000",
                        "longitude": "-97.21262000"
                    },
                    {
                        "id": 69327,
                        "name": "Colonia Manuel González",
                        "latitude": "19.11495000",
                        "longitude": "-96.85939000"
                    },
                    {
                        "id": 69369,
                        "name": "Colonia Santa Bárbara",
                        "latitude": "19.50191000",
                        "longitude": "-96.87817000"
                    },
                    {
                        "id": 69407,
                        "name": "Colonia Úrsulo Galván",
                        "latitude": "19.42862000",
                        "longitude": "-96.97842000"
                    },
                    {
                        "id": 69408,
                        "name": "Colonias Pedernales",
                        "latitude": "20.04583000",
                        "longitude": "-97.05139000"
                    },
                    {
                        "id": 69410,
                        "name": "Colorines",
                        "latitude": "18.88472000",
                        "longitude": "-96.97833000"
                    },
                    {
                        "id": 69423,
                        "name": "Comapa",
                        "latitude": "19.13889000",
                        "longitude": "-96.71374000"
                    },
                    {
                        "id": 69424,
                        "name": "Comején",
                        "latitude": "18.06126000",
                        "longitude": "-94.88552000"
                    },
                    {
                        "id": 69426,
                        "name": "Comoapan",
                        "latitude": "18.40684000",
                        "longitude": "-95.17415000"
                    },
                    {
                        "id": 69454,
                        "name": "Congregación el Tajín",
                        "latitude": "20.43047000",
                        "longitude": "-97.38183000"
                    },
                    {
                        "id": 69451,
                        "name": "Congregación Hidalgo",
                        "latitude": "17.93750000",
                        "longitude": "-94.97056000"
                    },
                    {
                        "id": 69661,
                        "name": "Córdoba",
                        "latitude": "18.88420000",
                        "longitude": "-96.92559000"
                    },
                    {
                        "id": 69662,
                        "name": "Córdoba (Santa Leticia)",
                        "latitude": "18.90861000",
                        "longitude": "-96.97889000"
                    },
                    {
                        "id": 69483,
                        "name": "Corozal",
                        "latitude": "21.54627000",
                        "longitude": "-98.55444000"
                    },
                    {
                        "id": 69485,
                        "name": "Corral Nuevo",
                        "latitude": "18.11461000",
                        "longitude": "-95.11542000"
                    },
                    {
                        "id": 69492,
                        "name": "Corralillos",
                        "latitude": "20.48273000",
                        "longitude": "-97.52582000"
                    },
                    {
                        "id": 69497,
                        "name": "Cosamaloapan",
                        "latitude": "18.36759000",
                        "longitude": "-95.79857000"
                    },
                    {
                        "id": 69498,
                        "name": "Cosamaloapan de Carpio",
                        "latitude": "18.30163000",
                        "longitude": "-95.95967000"
                    },
                    {
                        "id": 69499,
                        "name": "Cosautlán",
                        "latitude": "19.33196000",
                        "longitude": "-96.99030000"
                    },
                    {
                        "id": 69500,
                        "name": "Cosautlán de Carvajal",
                        "latitude": "19.32878000",
                        "longitude": "-96.97719000"
                    },
                    {
                        "id": 69502,
                        "name": "Coscomatepec de Bravo",
                        "latitude": "19.07275000",
                        "longitude": "-97.04685000"
                    },
                    {
                        "id": 69503,
                        "name": "Cosolapa",
                        "latitude": "18.60055000",
                        "longitude": "-96.68524000"
                    },
                    {
                        "id": 69504,
                        "name": "Cosoleacaque",
                        "latitude": "17.99913000",
                        "longitude": "-94.63590000"
                    },
                    {
                        "id": 69508,
                        "name": "Cotaxtla",
                        "latitude": "18.83555000",
                        "longitude": "-96.39640000"
                    },
                    {
                        "id": 69513,
                        "name": "Coxquihui",
                        "latitude": "20.18398000",
                        "longitude": "-97.58568000"
                    },
                    {
                        "id": 69518,
                        "name": "Coyolito",
                        "latitude": "19.22777000",
                        "longitude": "-96.87039000"
                    },
                    {
                        "id": 69529,
                        "name": "Coyutla",
                        "latitude": "20.24720000",
                        "longitude": "-97.65824000"
                    },
                    {
                        "id": 69541,
                        "name": "Cruz Blanca",
                        "latitude": "19.63744000",
                        "longitude": "-97.16691000"
                    },
                    {
                        "id": 69547,
                        "name": "Cruz del Milagro",
                        "latitude": "17.90833000",
                        "longitude": "-95.01083000"
                    },
                    {
                        "id": 69545,
                        "name": "Cruz Verde",
                        "latitude": "19.13750000",
                        "longitude": "-97.10861000"
                    },
                    {
                        "id": 69574,
                        "name": "Cuauhtamingo",
                        "latitude": "19.76472000",
                        "longitude": "-97.31417000"
                    },
                    {
                        "id": 69594,
                        "name": "Cuautlapán",
                        "latitude": "18.87747000",
                        "longitude": "-97.02291000"
                    },
                    {
                        "id": 69604,
                        "name": "Cucharas",
                        "latitude": "21.61568000",
                        "longitude": "-97.66099000"
                    },
                    {
                        "id": 69617,
                        "name": "Cuesta Amarilla",
                        "latitude": "18.34667000",
                        "longitude": "-95.23389000"
                    },
                    {
                        "id": 69619,
                        "name": "Cuesta de Laja",
                        "latitude": "18.29333000",
                        "longitude": "-95.22111000"
                    },
                    {
                        "id": 69626,
                        "name": "Cuichapa",
                        "latitude": "17.93889000",
                        "longitude": "-94.28000000"
                    },
                    {
                        "id": 69628,
                        "name": "Cuitláhuac",
                        "latitude": "18.81429000",
                        "longitude": "-96.72281000"
                    },
                    {
                        "id": 69630,
                        "name": "Cuiyachapa",
                        "latitude": "19.04569000",
                        "longitude": "-97.17436000"
                    },
                    {
                        "id": 69671,
                        "name": "Dehesa",
                        "latitude": "17.94167000",
                        "longitude": "-94.99806000"
                    },
                    {
                        "id": 69673,
                        "name": "Delfino Victoria (Santa Fe)",
                        "latitude": "19.20750000",
                        "longitude": "-96.27333000"
                    },
                    {
                        "id": 69698,
                        "name": "Doctor Montes de Oca",
                        "latitude": "20.93477000",
                        "longitude": "-97.55585000"
                    },
                    {
                        "id": 69717,
                        "name": "Dos Bocas",
                        "latitude": "18.41087000",
                        "longitude": "-95.70732000"
                    },
                    {
                        "id": 69720,
                        "name": "Dos Ríos",
                        "latitude": "19.48417000",
                        "longitude": "-96.79944000"
                    },
                    {
                        "id": 69757,
                        "name": "Ejidal",
                        "latitude": "18.90380000",
                        "longitude": "-96.22583000"
                    },
                    {
                        "id": 69816,
                        "name": "Ejido la Piña (Maromilla)",
                        "latitude": "19.02861000",
                        "longitude": "-96.78361000"
                    },
                    {
                        "id": 69825,
                        "name": "El Aguacate",
                        "latitude": "18.19808000",
                        "longitude": "-94.97053000"
                    },
                    {
                        "id": 70265,
                        "name": "El Águila",
                        "latitude": "20.63072000",
                        "longitude": "-97.45632000"
                    },
                    {
                        "id": 69829,
                        "name": "El Anono",
                        "latitude": "21.25559000",
                        "longitude": "-97.65648000"
                    },
                    {
                        "id": 69834,
                        "name": "El Arenal",
                        "latitude": "20.26829000",
                        "longitude": "-97.59250000"
                    },
                    {
                        "id": 69846,
                        "name": "El Blanco",
                        "latitude": "18.07418000",
                        "longitude": "-95.28053000"
                    },
                    {
                        "id": 69886,
                        "name": "El Castillo",
                        "latitude": "19.54661000",
                        "longitude": "-96.86425000"
                    },
                    {
                        "id": 69900,
                        "name": "El Chico",
                        "latitude": "19.46570000",
                        "longitude": "-96.83642000"
                    },
                    {
                        "id": 69903,
                        "name": "El Chote",
                        "latitude": "20.40167000",
                        "longitude": "-97.34389000"
                    },
                    {
                        "id": 69908,
                        "name": "El Cocuite",
                        "latitude": "18.71765000",
                        "longitude": "-96.08442000"
                    },
                    {
                        "id": 69917,
                        "name": "El Conejo",
                        "latitude": "19.53140000",
                        "longitude": "-97.15383000"
                    },
                    {
                        "id": 69927,
                        "name": "El Corte",
                        "latitude": "18.45226000",
                        "longitude": "-95.73510000"
                    },
                    {
                        "id": 69955,
                        "name": "El Escobillo",
                        "latitude": "19.51450000",
                        "longitude": "-97.19791000"
                    },
                    {
                        "id": 69961,
                        "name": "El Espinal",
                        "latitude": "19.62444000",
                        "longitude": "-96.87250000"
                    },
                    {
                        "id": 69981,
                        "name": "El Hatito",
                        "latitude": "19.27750000",
                        "longitude": "-96.39361000"
                    },
                    {
                        "id": 69983,
                        "name": "El Higo",
                        "latitude": "21.76708000",
                        "longitude": "-98.45186000"
                    },
                    {
                        "id": 69994,
                        "name": "El Huérfano",
                        "latitude": "19.74082000",
                        "longitude": "-96.74528000"
                    },
                    {
                        "id": 69989,
                        "name": "El Huidero",
                        "latitude": "18.38750000",
                        "longitude": "-95.17917000"
                    },
                    {
                        "id": 69993,
                        "name": "El Humo",
                        "latitude": "21.17568000",
                        "longitude": "-97.94169000"
                    },
                    {
                        "id": 70006,
                        "name": "El Jobo",
                        "latitude": "20.01405000",
                        "longitude": "-97.16461000"
                    },
                    {
                        "id": 70008,
                        "name": "El Juile",
                        "latitude": "17.74412000",
                        "longitude": "-94.98946000"
                    },
                    {
                        "id": 70010,
                        "name": "El Laurel",
                        "latitude": "18.27409000",
                        "longitude": "-95.32900000"
                    },
                    {
                        "id": 70011,
                        "name": "El Lencero",
                        "latitude": "19.48897000",
                        "longitude": "-96.81622000"
                    },
                    {
                        "id": 70019,
                        "name": "El Lindero",
                        "latitude": "21.31278000",
                        "longitude": "-98.22000000"
                    },
                    {
                        "id": 70028,
                        "name": "El Maguey",
                        "latitude": "18.83295000",
                        "longitude": "-96.73434000"
                    },
                    {
                        "id": 70038,
                        "name": "El Mirador",
                        "latitude": "21.01168000",
                        "longitude": "-97.94387000"
                    },
                    {
                        "id": 70043,
                        "name": "El Molino",
                        "latitude": "21.91602000",
                        "longitude": "-98.29885000"
                    },
                    {
                        "id": 70048,
                        "name": "El Mollejon",
                        "latitude": "20.54222000",
                        "longitude": "-97.41111000"
                    },
                    {
                        "id": 70056,
                        "name": "El Naranjito",
                        "latitude": "17.99785000",
                        "longitude": "-94.60666000"
                    },
                    {
                        "id": 70062,
                        "name": "El Nigromante",
                        "latitude": "17.76472000",
                        "longitude": "-95.75722000"
                    },
                    {
                        "id": 70079,
                        "name": "El Palmar",
                        "latitude": "18.80330000",
                        "longitude": "-96.66560000"
                    },
                    {
                        "id": 70085,
                        "name": "El Panorama",
                        "latitude": "20.28918000",
                        "longitude": "-97.63554000"
                    },
                    {
                        "id": 70088,
                        "name": "El Paraíso",
                        "latitude": "17.51592000",
                        "longitude": "-95.14271000"
                    },
                    {
                        "id": 70092,
                        "name": "El Paraíso (La Charca)",
                        "latitude": "19.42889000",
                        "longitude": "-96.35500000"
                    },
                    {
                        "id": 70108,
                        "name": "El Pital",
                        "latitude": "20.15695000",
                        "longitude": "-96.89805000"
                    },
                    {
                        "id": 70117,
                        "name": "El Porvenir",
                        "latitude": "18.92083000",
                        "longitude": "-96.92583000"
                    },
                    {
                        "id": 70125,
                        "name": "El Potrero",
                        "latitude": "18.67822000",
                        "longitude": "-97.25499000"
                    },
                    {
                        "id": 70134,
                        "name": "El Progreso",
                        "latitude": "20.11417000",
                        "longitude": "-97.01444000"
                    },
                    {
                        "id": 70137,
                        "name": "El Pueblito",
                        "latitude": "18.88639000",
                        "longitude": "-96.96946000"
                    },
                    {
                        "id": 70138,
                        "name": "El Pueblito (Garbanzal)",
                        "latitude": "19.59389000",
                        "longitude": "-96.92417000"
                    },
                    {
                        "id": 70157,
                        "name": "El Remolino",
                        "latitude": "20.38921000",
                        "longitude": "-97.21213000"
                    },
                    {
                        "id": 70193,
                        "name": "El Salto de Eyipantla",
                        "latitude": "18.38954000",
                        "longitude": "-95.20285000"
                    },
                    {
                        "id": 70213,
                        "name": "El Tejar",
                        "latitude": "19.07433000",
                        "longitude": "-96.16097000"
                    },
                    {
                        "id": 70222,
                        "name": "El Terrero",
                        "latitude": "19.53709000",
                        "longitude": "-96.79907000"
                    },
                    {
                        "id": 70236,
                        "name": "El Triunfo",
                        "latitude": "19.42136000",
                        "longitude": "-97.22002000"
                    },
                    {
                        "id": 70243,
                        "name": "El Tulín",
                        "latitude": "18.24750000",
                        "longitude": "-94.95373000"
                    },
                    {
                        "id": 70258,
                        "name": "El Volador",
                        "latitude": "20.64294000",
                        "longitude": "-97.24885000"
                    },
                    {
                        "id": 70262,
                        "name": "El Zapote Bravo",
                        "latitude": "20.66200000",
                        "longitude": "-97.99907000"
                    },
                    {
                        "id": 70271,
                        "name": "Elotepec",
                        "latitude": "19.18820000",
                        "longitude": "-97.03768000"
                    },
                    {
                        "id": 70290,
                        "name": "Emiliano Zapata",
                        "latitude": "19.45766000",
                        "longitude": "-96.76584000"
                    },
                    {
                        "id": 70306,
                        "name": "Entabladero",
                        "latitude": "20.27515000",
                        "longitude": "-97.55114000"
                    },
                    {
                        "id": 70320,
                        "name": "Escolín de Olarte",
                        "latitude": "20.49840000",
                        "longitude": "-97.42336000"
                    },
                    {
                        "id": 70330,
                        "name": "Espinal",
                        "latitude": "20.26997000",
                        "longitude": "-97.48927000"
                    },
                    {
                        "id": 70342,
                        "name": "Estación Dobladero",
                        "latitude": "18.11500000",
                        "longitude": "-95.76611000"
                    },
                    {
                        "id": 70345,
                        "name": "Estación Juanita",
                        "latitude": "17.80889000",
                        "longitude": "-95.21750000"
                    },
                    {
                        "id": 70365,
                        "name": "Estanzuela",
                        "latitude": "19.46081000",
                        "longitude": "-96.85819000"
                    },
                    {
                        "id": 70369,
                        "name": "Estero de Milpas",
                        "latitude": "21.25370000",
                        "longitude": "-97.45082000"
                    },
                    {
                        "id": 70370,
                        "name": "Estero del Ídolo",
                        "latitude": "20.88953000",
                        "longitude": "-97.65878000"
                    },
                    {
                        "id": 70389,
                        "name": "Ex-hacienda la Concepción",
                        "latitude": "18.84855000",
                        "longitude": "-96.82437000"
                    },
                    {
                        "id": 70390,
                        "name": "Excola",
                        "latitude": "19.13876000",
                        "longitude": "-97.12251000"
                    },
                    {
                        "id": 70396,
                        "name": "Felipe Carrillo Puerto",
                        "latitude": "20.13578000",
                        "longitude": "-96.95164000"
                    },
                    {
                        "id": 70402,
                        "name": "Filomeno Mata",
                        "latitude": "20.20004000",
                        "longitude": "-97.70392000"
                    },
                    {
                        "id": 70410,
                        "name": "Fortín de las Flores",
                        "latitude": "18.90806000",
                        "longitude": "-97.00000000"
                    },
                    {
                        "id": 70411,
                        "name": "Fraccionamiento Arboledas San Ramón",
                        "latitude": "19.09417000",
                        "longitude": "-96.15667000"
                    },
                    {
                        "id": 70413,
                        "name": "Fraccionamiento Ciudad Olmeca",
                        "latitude": "18.15056000",
                        "longitude": "-94.55250000"
                    },
                    {
                        "id": 70418,
                        "name": "Fraccionamiento Costa Dorada",
                        "latitude": "19.20833000",
                        "longitude": "-96.21639000"
                    },
                    {
                        "id": 70422,
                        "name": "Fraccionamiento Geovillas los Pinos",
                        "latitude": "19.21722000",
                        "longitude": "-96.22639000"
                    },
                    {
                        "id": 70450,
                        "name": "Fraccionamiento la Florida",
                        "latitude": "20.58667000",
                        "longitude": "-97.42833000"
                    },
                    {
                        "id": 70455,
                        "name": "Fraccionamiento las Fuentes",
                        "latitude": "19.49611000",
                        "longitude": "-96.88639000"
                    },
                    {
                        "id": 70458,
                        "name": "Fraccionamiento los Álamos",
                        "latitude": "18.92389000",
                        "longitude": "-96.97528000"
                    },
                    {
                        "id": 70457,
                        "name": "Fraccionamiento los Prados",
                        "latitude": "17.97778000",
                        "longitude": "-94.63917000"
                    },
                    {
                        "id": 70442,
                        "name": "Fraccionamiento Santa Cruz",
                        "latitude": "17.97194000",
                        "longitude": "-94.89500000"
                    },
                    {
                        "id": 70444,
                        "name": "Fraccionamiento Valle Dorado",
                        "latitude": "18.86889000",
                        "longitude": "-97.12222000"
                    },
                    {
                        "id": 70447,
                        "name": "Fraccionamiento Villas de la Llave",
                        "latitude": "18.91583000",
                        "longitude": "-96.99111000"
                    },
                    {
                        "id": 70465,
                        "name": "Francisco I. Madero",
                        "latitude": "19.52718000",
                        "longitude": "-97.27067000"
                    },
                    {
                        "id": 70487,
                        "name": "Fredepo",
                        "latitude": "18.88056000",
                        "longitude": "-96.97694000"
                    },
                    {
                        "id": 70500,
                        "name": "Gabino Barreda",
                        "latitude": "18.17922000",
                        "longitude": "-96.09162000"
                    },
                    {
                        "id": 70525,
                        "name": "General Alatriste (San Joaquín)",
                        "latitude": "18.84028000",
                        "longitude": "-96.79361000"
                    },
                    {
                        "id": 70536,
                        "name": "General Juan José Baz (San José del Corral)",
                        "latitude": "18.82167000",
                        "longitude": "-96.81806000"
                    },
                    {
                        "id": 70542,
                        "name": "General Miguel Alemán",
                        "latitude": "18.89346000",
                        "longitude": "-96.79239000"
                    },
                    {
                        "id": 70570,
                        "name": "Guadalupe",
                        "latitude": "18.81560000",
                        "longitude": "-96.92444000"
                    },
                    {
                        "id": 70603,
                        "name": "Guadalupe Victoria",
                        "latitude": "19.55472000",
                        "longitude": "-96.96056000"
                    },
                    {
                        "id": 70624,
                        "name": "Guayalejo",
                        "latitude": "22.38306000",
                        "longitude": "-98.48306000"
                    },
                    {
                        "id": 70634,
                        "name": "Guillermo Prieto",
                        "latitude": "18.16077000",
                        "longitude": "-94.27658000"
                    },
                    {
                        "id": 70642,
                        "name": "Gutiérrez Zamora",
                        "latitude": "20.45347000",
                        "longitude": "-97.08588000"
                    },
                    {
                        "id": 70654,
                        "name": "Hacienda Sotavento",
                        "latitude": "19.13361000",
                        "longitude": "-96.18139000"
                    },
                    {
                        "id": 70665,
                        "name": "Helio García Alfaro",
                        "latitude": "17.25968000",
                        "longitude": "-94.28849000"
                    },
                    {
                        "id": 70667,
                        "name": "Hermanos Cedillo",
                        "latitude": "17.25194000",
                        "longitude": "-94.61129000"
                    },
                    {
                        "id": 70671,
                        "name": "Hermenegildo J. Aldana",
                        "latitude": "18.00611000",
                        "longitude": "-94.61222000"
                    },
                    {
                        "id": 70687,
                        "name": "Hidalgo Amajac",
                        "latitude": "20.90500000",
                        "longitude": "-97.62944000"
                    },
                    {
                        "id": 70690,
                        "name": "Hidalgotitlán",
                        "latitude": "17.77051000",
                        "longitude": "-94.64703000"
                    },
                    {
                        "id": 70711,
                        "name": "Hornitos",
                        "latitude": "19.46083000",
                        "longitude": "-96.42111000"
                    },
                    {
                        "id": 70743,
                        "name": "Huatusco",
                        "latitude": "19.14876000",
                        "longitude": "-96.96760000"
                    },
                    {
                        "id": 70751,
                        "name": "Huayacanes",
                        "latitude": "17.91844000",
                        "longitude": "-95.27767000"
                    },
                    {
                        "id": 70752,
                        "name": "Huayacocotla",
                        "latitude": "20.53671000",
                        "longitude": "-98.48080000"
                    },
                    {
                        "id": 70755,
                        "name": "Huazuntlán",
                        "latitude": "18.15667000",
                        "longitude": "-94.79306000"
                    },
                    {
                        "id": 70772,
                        "name": "Huexotitla",
                        "latitude": "20.76984000",
                        "longitude": "-98.08872000"
                    },
                    {
                        "id": 70776,
                        "name": "Hueyapan de Ocampo",
                        "latitude": "18.14479000",
                        "longitude": "-95.14873000"
                    },
                    {
                        "id": 70784,
                        "name": "Hueytepec",
                        "latitude": "20.32635000",
                        "longitude": "-97.02680000"
                    },
                    {
                        "id": 70793,
                        "name": "Huiloapan",
                        "latitude": "18.75000000",
                        "longitude": "-97.31667000"
                    },
                    {
                        "id": 70794,
                        "name": "Huiloapan de Cuauhtémoc",
                        "latitude": "18.81722000",
                        "longitude": "-97.15444000"
                    },
                    {
                        "id": 70805,
                        "name": "Huitzila",
                        "latitude": "18.71898000",
                        "longitude": "-97.17033000"
                    },
                    {
                        "id": 70817,
                        "name": "Huixcolotla",
                        "latitude": "18.66556000",
                        "longitude": "-96.49750000"
                    },
                    {
                        "id": 70860,
                        "name": "Ignacio de la Llave",
                        "latitude": "18.72580000",
                        "longitude": "-95.98696000"
                    },
                    {
                        "id": 70849,
                        "name": "Ignacio Zaragoza",
                        "latitude": "19.71222000",
                        "longitude": "-97.22500000"
                    },
                    {
                        "id": 70864,
                        "name": "Ilamatlán",
                        "latitude": "20.78053000",
                        "longitude": "-98.44320000"
                    },
                    {
                        "id": 70882,
                        "name": "Isla",
                        "latitude": "18.06369000",
                        "longitude": "-95.55320000"
                    },
                    {
                        "id": 70899,
                        "name": "Ixcapantla",
                        "latitude": "19.02571000",
                        "longitude": "-96.97052000"
                    },
                    {
                        "id": 70904,
                        "name": "Ixcatepec",
                        "latitude": "21.23695000",
                        "longitude": "-98.00689000"
                    },
                    {
                        "id": 70905,
                        "name": "Ixcatla",
                        "latitude": "19.07528000",
                        "longitude": "-96.91889000"
                    },
                    {
                        "id": 70909,
                        "name": "Ixhuacán de los Reyes",
                        "latitude": "19.35526000",
                        "longitude": "-97.11751000"
                    },
                    {
                        "id": 70910,
                        "name": "Ixhuapan",
                        "latitude": "18.01333000",
                        "longitude": "-94.87667000"
                    },
                    {
                        "id": 70913,
                        "name": "Ixhuatlán de Madero",
                        "latitude": "20.68879000",
                        "longitude": "-98.01177000"
                    },
                    {
                        "id": 70914,
                        "name": "Ixhuatlán del Café",
                        "latitude": "19.04179000",
                        "longitude": "-96.92694000"
                    },
                    {
                        "id": 70915,
                        "name": "Ixhuatlán del Sureste",
                        "latitude": "18.01368000",
                        "longitude": "-94.37794000"
                    },
                    {
                        "id": 70912,
                        "name": "Ixhuatlancillo",
                        "latitude": "18.89766000",
                        "longitude": "-97.14899000"
                    },
                    {
                        "id": 70920,
                        "name": "Ixpila",
                        "latitude": "19.11837000",
                        "longitude": "-96.96675000"
                    },
                    {
                        "id": 70922,
                        "name": "Ixtacapa el Chico",
                        "latitude": "18.49001000",
                        "longitude": "-96.74246000"
                    },
                    {
                        "id": 70924,
                        "name": "Ixtaczoquitlán",
                        "latitude": "18.85364000",
                        "longitude": "-97.06229000"
                    },
                    {
                        "id": 70958,
                        "name": "Jacarandas",
                        "latitude": "19.49556000",
                        "longitude": "-96.85278000"
                    },
                    {
                        "id": 70963,
                        "name": "Jalacingo",
                        "latitude": "19.80333000",
                        "longitude": "-97.30830000"
                    },
                    {
                        "id": 70967,
                        "name": "Jalapilla",
                        "latitude": "18.82642000",
                        "longitude": "-97.08865000"
                    },
                    {
                        "id": 70970,
                        "name": "Jalcomulco",
                        "latitude": "19.33185000",
                        "longitude": "-96.76250000"
                    },
                    {
                        "id": 71148,
                        "name": "Jáltipan de Morelos",
                        "latitude": "17.96542000",
                        "longitude": "-94.71396000"
                    },
                    {
                        "id": 70997,
                        "name": "Jamapa",
                        "latitude": "19.04179000",
                        "longitude": "-96.24143000"
                    },
                    {
                        "id": 71022,
                        "name": "Jesús Carranza",
                        "latitude": "17.43526000",
                        "longitude": "-95.02637000"
                    },
                    {
                        "id": 71044,
                        "name": "Jilotepec",
                        "latitude": "19.61184000",
                        "longitude": "-96.95169000"
                    },
                    {
                        "id": 71062,
                        "name": "Joachín",
                        "latitude": "18.63855000",
                        "longitude": "-96.23318000"
                    },
                    {
                        "id": 71088,
                        "name": "José Cardel",
                        "latitude": "19.36810000",
                        "longitude": "-96.36951000"
                    },
                    {
                        "id": 71091,
                        "name": "José F. Gutiérrez",
                        "latitude": "18.02526000",
                        "longitude": "-94.61028000"
                    },
                    {
                        "id": 71116,
                        "name": "Juan Díaz Covarrubias",
                        "latitude": "18.15964000",
                        "longitude": "-95.18675000"
                    },
                    {
                        "id": 71120,
                        "name": "Juan Jacobo Torres [Bodega de Totontepec]",
                        "latitude": "18.33645000",
                        "longitude": "-95.26033000"
                    },
                    {
                        "id": 71122,
                        "name": "Juan Marcos (San José Buenavista)",
                        "latitude": "19.72917000",
                        "longitude": "-97.19667000"
                    },
                    {
                        "id": 71126,
                        "name": "Juan Rodríguez Clara",
                        "latitude": "17.99283000",
                        "longitude": "-95.40099000"
                    },
                    {
                        "id": 71131,
                        "name": "Juchique de Ferrer",
                        "latitude": "19.83985000",
                        "longitude": "-96.69463000"
                    },
                    {
                        "id": 71175,
                        "name": "La Antigua",
                        "latitude": "19.31619000",
                        "longitude": "-96.31736000"
                    },
                    {
                        "id": 71193,
                        "name": "La Camelia",
                        "latitude": "20.89631000",
                        "longitude": "-97.77247000"
                    },
                    {
                        "id": 71201,
                        "name": "La Capilla",
                        "latitude": "18.89442000",
                        "longitude": "-96.24132000"
                    },
                    {
                        "id": 71213,
                        "name": "La Cerquilla",
                        "latitude": "17.90786000",
                        "longitude": "-95.05497000"
                    },
                    {
                        "id": 71221,
                        "name": "La Colonia Guadalupe",
                        "latitude": "20.34387000",
                        "longitude": "-97.62223000"
                    },
                    {
                        "id": 71229,
                        "name": "La Concepción",
                        "latitude": "19.60620000",
                        "longitude": "-96.90016000"
                    },
                    {
                        "id": 71254,
                        "name": "La Cuesta",
                        "latitude": "18.79028000",
                        "longitude": "-97.16806000"
                    },
                    {
                        "id": 71258,
                        "name": "La Defensa",
                        "latitude": "20.10507000",
                        "longitude": "-96.96079000"
                    },
                    {
                        "id": 71300,
                        "name": "La Gloria",
                        "latitude": "19.42631000",
                        "longitude": "-96.40211000"
                    },
                    {
                        "id": 71311,
                        "name": "La Guadalupe",
                        "latitude": "20.37336000",
                        "longitude": "-96.91925000"
                    },
                    {
                        "id": 71313,
                        "name": "La Guásima",
                        "latitude": "20.53973000",
                        "longitude": "-97.24950000"
                    },
                    {
                        "id": 71318,
                        "name": "La Horqueta (Poblado Doce)",
                        "latitude": "17.21012000",
                        "longitude": "-94.20249000"
                    },
                    {
                        "id": 71325,
                        "name": "La Isla",
                        "latitude": "18.60000000",
                        "longitude": "-96.15000000"
                    },
                    {
                        "id": 71326,
                        "name": "La Isla (Kilómetro 10)",
                        "latitude": "20.60806000",
                        "longitude": "-97.50139000"
                    },
                    {
                        "id": 71328,
                        "name": "La Isla de Chapachapa",
                        "latitude": "20.12186000",
                        "longitude": "-96.88208000"
                    },
                    {
                        "id": 71327,
                        "name": "La Isla Km 10",
                        "latitude": "20.60677000",
                        "longitude": "-97.49950000"
                    },
                    {
                        "id": 71329,
                        "name": "La Joya",
                        "latitude": "19.61099000",
                        "longitude": "-97.02687000"
                    },
                    {
                        "id": 71335,
                        "name": "La Junta",
                        "latitude": "18.49136000",
                        "longitude": "-96.65720000"
                    },
                    {
                        "id": 71344,
                        "name": "La Laguna",
                        "latitude": "19.48214000",
                        "longitude": "-96.93366000"
                    },
                    {
                        "id": 71347,
                        "name": "La Laguna y Monte del Castillo",
                        "latitude": "18.98334000",
                        "longitude": "-96.07806000"
                    },
                    {
                        "id": 71353,
                        "name": "La Libertad",
                        "latitude": "20.05345000",
                        "longitude": "-96.97314000"
                    },
                    {
                        "id": 71410,
                        "name": "La Nueva Era",
                        "latitude": "17.69861000",
                        "longitude": "-95.80833000"
                    },
                    {
                        "id": 71411,
                        "name": "La Nueva Victoria",
                        "latitude": "18.65639000",
                        "longitude": "-95.25806000"
                    },
                    {
                        "id": 71413,
                        "name": "La Orduña",
                        "latitude": "19.45141000",
                        "longitude": "-96.93598000"
                    },
                    {
                        "id": 71419,
                        "name": "La Palma",
                        "latitude": "20.17941000",
                        "longitude": "-97.06718000"
                    },
                    {
                        "id": 71428,
                        "name": "La Palmilla",
                        "latitude": "20.02041000",
                        "longitude": "-97.14553000"
                    },
                    {
                        "id": 71441,
                        "name": "La Perla",
                        "latitude": "18.92817000",
                        "longitude": "-97.13362000"
                    },
                    {
                        "id": 71464,
                        "name": "La Providencia",
                        "latitude": "18.75304000",
                        "longitude": "-96.77087000"
                    },
                    {
                        "id": 71473,
                        "name": "La Reforma",
                        "latitude": "19.59664000",
                        "longitude": "-96.63302000"
                    },
                    {
                        "id": 71488,
                        "name": "La Sidra",
                        "latitude": "18.93380000",
                        "longitude": "-97.07989000"
                    },
                    {
                        "id": 71497,
                        "name": "La Sombra",
                        "latitude": "19.75076000",
                        "longitude": "-96.71420000"
                    },
                    {
                        "id": 71503,
                        "name": "La Tinaja",
                        "latitude": "18.76082000",
                        "longitude": "-96.46283000"
                    },
                    {
                        "id": 71505,
                        "name": "La Toma",
                        "latitude": "19.45278000",
                        "longitude": "-97.19361000"
                    },
                    {
                        "id": 71523,
                        "name": "La Unión",
                        "latitude": "20.89222000",
                        "longitude": "-97.66528000"
                    },
                    {
                        "id": 71525,
                        "name": "La Unión Paso Largo",
                        "latitude": "20.14224000",
                        "longitude": "-96.99995000"
                    },
                    {
                        "id": 71532,
                        "name": "La Victoria",
                        "latitude": "18.37486000",
                        "longitude": "-95.12213000"
                    },
                    {
                        "id": 71535,
                        "name": "La Victoria (La Peñita)",
                        "latitude": "20.93694000",
                        "longitude": "-97.37250000"
                    },
                    {
                        "id": 71547,
                        "name": "Laguna Chica (Pueblo Nuevo)",
                        "latitude": "18.54306000",
                        "longitude": "-96.73306000"
                    },
                    {
                        "id": 71551,
                        "name": "Laguna de Farfán",
                        "latitude": "19.80327000",
                        "longitude": "-96.64386000"
                    },
                    {
                        "id": 71560,
                        "name": "Laguneta",
                        "latitude": "18.34298000",
                        "longitude": "-95.15181000"
                    },
                    {
                        "id": 71569,
                        "name": "Landero y Coss",
                        "latitude": "19.73935000",
                        "longitude": "-96.85009000"
                    },
                    {
                        "id": 71573,
                        "name": "Las Amapolas",
                        "latitude": "19.15194000",
                        "longitude": "-96.19778000"
                    },
                    {
                        "id": 71577,
                        "name": "Las Barrillas",
                        "latitude": "18.18617000",
                        "longitude": "-94.59542000"
                    },
                    {
                        "id": 71587,
                        "name": "Las Choapas",
                        "latitude": "17.91177000",
                        "longitude": "-94.09646000"
                    },
                    {
                        "id": 71602,
                        "name": "Las Higueras",
                        "latitude": "20.03693000",
                        "longitude": "-96.62199000"
                    },
                    {
                        "id": 71612,
                        "name": "Las Lomas",
                        "latitude": "20.26067000",
                        "longitude": "-97.61528000"
                    },
                    {
                        "id": 71614,
                        "name": "Las Lomas de Tacamichapan",
                        "latitude": "17.86611000",
                        "longitude": "-94.70833000"
                    },
                    {
                        "id": 71624,
                        "name": "Las Minas",
                        "latitude": "19.70449000",
                        "longitude": "-97.14699000"
                    },
                    {
                        "id": 71639,
                        "name": "Las Sabanetas",
                        "latitude": "18.12661000",
                        "longitude": "-95.82265000"
                    },
                    {
                        "id": 71640,
                        "name": "Las Sabinas",
                        "latitude": "21.31806000",
                        "longitude": "-97.88083000"
                    },
                    {
                        "id": 71645,
                        "name": "Las Trancas",
                        "latitude": "19.50444000",
                        "longitude": "-96.86444000"
                    },
                    {
                        "id": 71653,
                        "name": "Las Vigas de Ramírez",
                        "latitude": "19.63722000",
                        "longitude": "-97.09821000"
                    },
                    {
                        "id": 71900,
                        "name": "Lázaro Cárdenas (Santana)",
                        "latitude": "20.22500000",
                        "longitude": "-97.59306000"
                    },
                    {
                        "id": 71662,
                        "name": "Lerdo de Tejada",
                        "latitude": "18.62936000",
                        "longitude": "-95.51968000"
                    },
                    {
                        "id": 71678,
                        "name": "Limones",
                        "latitude": "19.33820000",
                        "longitude": "-96.92336000"
                    },
                    {
                        "id": 71680,
                        "name": "Lindavista",
                        "latitude": "18.08899000",
                        "longitude": "-95.77597000"
                    },
                    {
                        "id": 71691,
                        "name": "Llano de Enmedio",
                        "latitude": "20.78328000",
                        "longitude": "-98.01364000"
                    },
                    {
                        "id": 71685,
                        "name": "Llano Grande",
                        "latitude": "19.37035000",
                        "longitude": "-96.88002000"
                    },
                    {
                        "id": 71711,
                        "name": "Loma Angosta",
                        "latitude": "18.78309000",
                        "longitude": "-96.67588000"
                    },
                    {
                        "id": 71736,
                        "name": "Loma de los Carmona",
                        "latitude": "19.10556000",
                        "longitude": "-96.39369000"
                    },
                    {
                        "id": 71732,
                        "name": "Loma de Sogotegoyo",
                        "latitude": "18.21896000",
                        "longitude": "-94.97373000"
                    },
                    {
                        "id": 71719,
                        "name": "Loma Grande",
                        "latitude": "18.92250000",
                        "longitude": "-97.23083000"
                    },
                    {
                        "id": 71745,
                        "name": "Lomas de Barrillas",
                        "latitude": "18.14806000",
                        "longitude": "-94.52639000"
                    },
                    {
                        "id": 71748,
                        "name": "Lomas de Río Medio Cuatro",
                        "latitude": "19.19333000",
                        "longitude": "-96.21056000"
                    },
                    {
                        "id": 71742,
                        "name": "Lomas Verdes",
                        "latitude": "19.50446000",
                        "longitude": "-96.88899000"
                    },
                    {
                        "id": 71768,
                        "name": "Los Altos",
                        "latitude": "21.50976000",
                        "longitude": "-97.75705000"
                    },
                    {
                        "id": 71787,
                        "name": "Los Cerritos",
                        "latitude": "18.07884000",
                        "longitude": "-94.61668000"
                    },
                    {
                        "id": 71873,
                        "name": "Los Ídolos",
                        "latitude": "19.41173000",
                        "longitude": "-96.51808000"
                    },
                    {
                        "id": 71810,
                        "name": "Los Lirios",
                        "latitude": "18.50058000",
                        "longitude": "-95.38828000"
                    },
                    {
                        "id": 71814,
                        "name": "Los Mangos",
                        "latitude": "18.24361000",
                        "longitude": "-95.12222000"
                    },
                    {
                        "id": 71818,
                        "name": "Los Molinos",
                        "latitude": "19.59565000",
                        "longitude": "-97.21513000"
                    },
                    {
                        "id": 71820,
                        "name": "Los Naranjos",
                        "latitude": "18.33111000",
                        "longitude": "-95.24167000"
                    },
                    {
                        "id": 71829,
                        "name": "Los Pescados",
                        "latitude": "19.56114000",
                        "longitude": "-97.14848000"
                    },
                    {
                        "id": 71833,
                        "name": "Los Pinos",
                        "latitude": "18.44389000",
                        "longitude": "-95.24333000"
                    },
                    {
                        "id": 71846,
                        "name": "Los Reyes",
                        "latitude": "18.67428000",
                        "longitude": "-97.03851000"
                    },
                    {
                        "id": 71854,
                        "name": "Los Robles",
                        "latitude": "18.97305000",
                        "longitude": "-96.11768000"
                    },
                    {
                        "id": 71864,
                        "name": "Los Tigres (San Marcos)",
                        "latitude": "17.89056000",
                        "longitude": "-95.34944000"
                    },
                    {
                        "id": 71865,
                        "name": "Los Torrentes",
                        "latitude": "19.20194000",
                        "longitude": "-96.21139000"
                    },
                    {
                        "id": 71904,
                        "name": "Macedonio Alonso",
                        "latitude": "20.27417000",
                        "longitude": "-97.69194000"
                    },
                    {
                        "id": 71919,
                        "name": "Mafafas",
                        "latitude": "19.65866000",
                        "longitude": "-96.75591000"
                    },
                    {
                        "id": 71920,
                        "name": "Magdalena",
                        "latitude": "18.76066000",
                        "longitude": "-97.04385000"
                    },
                    {
                        "id": 71939,
                        "name": "Mahuixtlan",
                        "latitude": "19.40948000",
                        "longitude": "-96.91750000"
                    },
                    {
                        "id": 71949,
                        "name": "Maltrata",
                        "latitude": "18.81091000",
                        "longitude": "-97.27538000"
                    },
                    {
                        "id": 71962,
                        "name": "Manuel León",
                        "latitude": "18.85365000",
                        "longitude": "-96.87124000"
                    },
                    {
                        "id": 71963,
                        "name": "Manuel María Contreras",
                        "latitude": "20.44617000",
                        "longitude": "-97.48329000"
                    },
                    {
                        "id": 71976,
                        "name": "Mapachapa",
                        "latitude": "18.02979000",
                        "longitude": "-94.56700000"
                    },
                    {
                        "id": 72006,
                        "name": "María de la Torre",
                        "latitude": "20.12915000",
                        "longitude": "-96.99544000"
                    },
                    {
                        "id": 71991,
                        "name": "Mariano Escobedo",
                        "latitude": "18.91333000",
                        "longitude": "-97.13000000"
                    },
                    {
                        "id": 72004,
                        "name": "Martínez de la Torre",
                        "latitude": "20.07082000",
                        "longitude": "-97.06078000"
                    },
                    {
                        "id": 72013,
                        "name": "Mata de Indio",
                        "latitude": "19.23028000",
                        "longitude": "-96.84136000"
                    },
                    {
                        "id": 72009,
                        "name": "Mata Loma",
                        "latitude": "19.13172000",
                        "longitude": "-96.29587000"
                    },
                    {
                        "id": 72010,
                        "name": "Mata Naranjo",
                        "latitude": "18.77746000",
                        "longitude": "-96.71333000"
                    },
                    {
                        "id": 72011,
                        "name": "Mata Obscura",
                        "latitude": "19.21795000",
                        "longitude": "-96.85426000"
                    },
                    {
                        "id": 72012,
                        "name": "Mata Tenatito (Casco Hacienda)",
                        "latitude": "18.72187000",
                        "longitude": "-96.66288000"
                    },
                    {
                        "id": 72014,
                        "name": "Matacapan",
                        "latitude": "18.43472000",
                        "longitude": "-95.16583000"
                    },
                    {
                        "id": 72051,
                        "name": "Mazumiapam",
                        "latitude": "18.30744000",
                        "longitude": "-95.33044000"
                    },
                    {
                        "id": 72056,
                        "name": "Mecatlán",
                        "latitude": "20.21349000",
                        "longitude": "-97.65741000"
                    },
                    {
                        "id": 72058,
                        "name": "Mecayapan",
                        "latitude": "18.22001000",
                        "longitude": "-94.83794000"
                    },
                    {
                        "id": 72061,
                        "name": "Medellín",
                        "latitude": "19.00418000",
                        "longitude": "-96.15836000"
                    },
                    {
                        "id": 72062,
                        "name": "Medellín de Bravo",
                        "latitude": "19.05869000",
                        "longitude": "-96.15781000"
                    },
                    {
                        "id": 72064,
                        "name": "Medias Aguas",
                        "latitude": "17.66776000",
                        "longitude": "-95.02857000"
                    },
                    {
                        "id": 72072,
                        "name": "Melchor Ocampo",
                        "latitude": "19.83972000",
                        "longitude": "-97.30667000"
                    },
                    {
                        "id": 72076,
                        "name": "Mequetla",
                        "latitude": "20.79468000",
                        "longitude": "-97.68855000"
                    },
                    {
                        "id": 72080,
                        "name": "Mesa de Guadalupe",
                        "latitude": "19.56403000",
                        "longitude": "-96.69948000"
                    },
                    {
                        "id": 72092,
                        "name": "Metlac Hernández (Metlac Primero)",
                        "latitude": "18.97750000",
                        "longitude": "-97.14306000"
                    },
                    {
                        "id": 72097,
                        "name": "Mexcala",
                        "latitude": "18.69556000",
                        "longitude": "-97.16472000"
                    },
                    {
                        "id": 72116,
                        "name": "Miahuatlán",
                        "latitude": "19.73629000",
                        "longitude": "-96.88062000"
                    },
                    {
                        "id": 72131,
                        "name": "Miguel Hidalgo",
                        "latitude": "20.55316000",
                        "longitude": "-97.50200000"
                    },
                    {
                        "id": 72145,
                        "name": "Minatitlán",
                        "latitude": "18.00011000",
                        "longitude": "-94.55690000"
                    },
                    {
                        "id": 72150,
                        "name": "Minzapan",
                        "latitude": "18.13873000",
                        "longitude": "-94.72733000"
                    },
                    {
                        "id": 72157,
                        "name": "Misantla",
                        "latitude": "19.92992000",
                        "longitude": "-96.85194000"
                    },
                    {
                        "id": 72167,
                        "name": "Mixquiapan",
                        "latitude": "19.70111000",
                        "longitude": "-97.27839000"
                    },
                    {
                        "id": 72169,
                        "name": "Mixtla de Altamirano",
                        "latitude": "18.59591000",
                        "longitude": "-96.99293000"
                    },
                    {
                        "id": 72188,
                        "name": "Moloacán",
                        "latitude": "17.98544000",
                        "longitude": "-94.34714000"
                    },
                    {
                        "id": 72196,
                        "name": "Monte Blanco",
                        "latitude": "18.96642000",
                        "longitude": "-97.01684000"
                    },
                    {
                        "id": 72206,
                        "name": "Monte Salas",
                        "latitude": "18.93722000",
                        "longitude": "-97.01833000"
                    },
                    {
                        "id": 72208,
                        "name": "Monte Verde Chivería",
                        "latitude": "19.70304000",
                        "longitude": "-96.69601000"
                    },
                    {
                        "id": 72224,
                        "name": "Moralillo",
                        "latitude": "22.22552000",
                        "longitude": "-97.91213000"
                    },
                    {
                        "id": 72228,
                        "name": "Morelos",
                        "latitude": "18.17986000",
                        "longitude": "-94.94981000"
                    },
                    {
                        "id": 72243,
                        "name": "Motzorongo",
                        "latitude": "18.64252000",
                        "longitude": "-96.72949000"
                    },
                    {
                        "id": 72245,
                        "name": "Moyoapan",
                        "latitude": "18.91681000",
                        "longitude": "-97.04559000"
                    },
                    {
                        "id": 72250,
                        "name": "Mozomboa",
                        "latitude": "19.50437000",
                        "longitude": "-96.47738000"
                    },
                    {
                        "id": 72254,
                        "name": "Mundo Nuevo",
                        "latitude": "18.08831000",
                        "longitude": "-94.39024000"
                    },
                    {
                        "id": 72276,
                        "name": "Nanchital de Lázaro Cárdenas del Río",
                        "latitude": "18.07117000",
                        "longitude": "-94.40756000"
                    },
                    {
                        "id": 72278,
                        "name": "Naolinco",
                        "latitude": "19.63666000",
                        "longitude": "-96.85254000"
                    },
                    {
                        "id": 72279,
                        "name": "Naolinco de Victoria",
                        "latitude": "19.65474000",
                        "longitude": "-96.87320000"
                    },
                    {
                        "id": 72281,
                        "name": "Naranjal",
                        "latitude": "18.79836000",
                        "longitude": "-96.95972000"
                    },
                    {
                        "id": 72283,
                        "name": "Naranjos",
                        "latitude": "21.35087000",
                        "longitude": "-97.68656000"
                    },
                    {
                        "id": 72284,
                        "name": "Naranjos Amatlán",
                        "latitude": "21.31139000",
                        "longitude": "-97.69131000"
                    },
                    {
                        "id": 72292,
                        "name": "Nautla",
                        "latitude": "20.20795000",
                        "longitude": "-96.77305000"
                    },
                    {
                        "id": 72306,
                        "name": "Necoxtla",
                        "latitude": "18.77861000",
                        "longitude": "-97.15361000"
                    },
                    {
                        "id": 72318,
                        "name": "Nicolás Blanco (San Pancho)",
                        "latitude": "19.35250000",
                        "longitude": "-96.33833000"
                    },
                    {
                        "id": 72336,
                        "name": "Niños Héroes",
                        "latitude": "17.43493000",
                        "longitude": "-94.49884000"
                    },
                    {
                        "id": 72339,
                        "name": "Nogales",
                        "latitude": "18.82776000",
                        "longitude": "-97.16311000"
                    },
                    {
                        "id": 72346,
                        "name": "Nopalapan",
                        "latitude": "18.11211000",
                        "longitude": "-95.33093000"
                    },
                    {
                        "id": 72348,
                        "name": "Nopaltepec",
                        "latitude": "18.27686000",
                        "longitude": "-95.99921000"
                    },
                    {
                        "id": 72357,
                        "name": "Novara",
                        "latitude": "18.19968000",
                        "longitude": "-96.10806000"
                    },
                    {
                        "id": 72406,
                        "name": "Nuevo Progreso",
                        "latitude": "20.61820000",
                        "longitude": "-97.50756000"
                    },
                    {
                        "id": 72408,
                        "name": "Nuevo San José Independencia",
                        "latitude": "18.38968000",
                        "longitude": "-96.06138000"
                    },
                    {
                        "id": 72431,
                        "name": "Oasis",
                        "latitude": "19.20167000",
                        "longitude": "-96.21917000"
                    },
                    {
                        "id": 72445,
                        "name": "Ocelota",
                        "latitude": "18.39920000",
                        "longitude": "-95.28333000"
                    },
                    {
                        "id": 72451,
                        "name": "Ocotal Chico",
                        "latitude": "18.25771000",
                        "longitude": "-94.86047000"
                    },
                    {
                        "id": 72456,
                        "name": "Ocotitlán",
                        "latitude": "19.04256000",
                        "longitude": "-96.90832000"
                    },
                    {
                        "id": 72465,
                        "name": "Ocozotepec",
                        "latitude": "18.25895000",
                        "longitude": "-94.91040000"
                    },
                    {
                        "id": 72476,
                        "name": "Ohuapan",
                        "latitude": "19.25077000",
                        "longitude": "-96.98686000"
                    },
                    {
                        "id": 72478,
                        "name": "Ohuilapam",
                        "latitude": "18.40204000",
                        "longitude": "-95.26279000"
                    },
                    {
                        "id": 72480,
                        "name": "Ojite Rancho Nuevo",
                        "latitude": "20.96944000",
                        "longitude": "-97.52806000"
                    },
                    {
                        "id": 72503,
                        "name": "Oluta",
                        "latitude": "17.92972000",
                        "longitude": "-94.89662000"
                    },
                    {
                        "id": 72504,
                        "name": "Omealca",
                        "latitude": "18.74732000",
                        "longitude": "-96.78520000"
                    },
                    {
                        "id": 72526,
                        "name": "Orilla del Monte",
                        "latitude": "19.66078000",
                        "longitude": "-97.29274000"
                    },
                    {
                        "id": 72527,
                        "name": "Orizaba",
                        "latitude": "18.85195000",
                        "longitude": "-97.09957000"
                    },
                    {
                        "id": 72536,
                        "name": "Otates",
                        "latitude": "19.52100000",
                        "longitude": "-96.71576000"
                    },
                    {
                        "id": 72538,
                        "name": "Otatitlán",
                        "latitude": "18.17706000",
                        "longitude": "-96.03350000"
                    },
                    {
                        "id": 72539,
                        "name": "Oteapan",
                        "latitude": "18.00173000",
                        "longitude": "-94.66615000"
                    },
                    {
                        "id": 72541,
                        "name": "Otilpan",
                        "latitude": "19.55722000",
                        "longitude": "-96.97667000"
                    },
                    {
                        "id": 72545,
                        "name": "Oviedo",
                        "latitude": "22.04478000",
                        "longitude": "-98.40043000"
                    },
                    {
                        "id": 72559,
                        "name": "Ozuluama de Mascareñas",
                        "latitude": "21.66040000",
                        "longitude": "-97.85049000"
                    },
                    {
                        "id": 72567,
                        "name": "Pacho Nuevo",
                        "latitude": "19.47717000",
                        "longitude": "-96.87842000"
                    },
                    {
                        "id": 72568,
                        "name": "Pacho Viejo",
                        "latitude": "19.48239000",
                        "longitude": "-96.91659000"
                    },
                    {
                        "id": 72574,
                        "name": "Pahua Hueca",
                        "latitude": "19.96139000",
                        "longitude": "-97.05511000"
                    },
                    {
                        "id": 72580,
                        "name": "Pajapan",
                        "latitude": "18.26267000",
                        "longitude": "-94.69172000"
                    },
                    {
                        "id": 72587,
                        "name": "Palma Sola",
                        "latitude": "19.77132000",
                        "longitude": "-96.43225000"
                    },
                    {
                        "id": 72589,
                        "name": "Palmar Grande",
                        "latitude": "18.51511000",
                        "longitude": "-96.77880000"
                    },
                    {
                        "id": 72594,
                        "name": "Palmas de Abajo",
                        "latitude": "19.59001000",
                        "longitude": "-96.43659000"
                    },
                    {
                        "id": 72599,
                        "name": "Palmillas",
                        "latitude": "18.81525000",
                        "longitude": "-96.77167000"
                    },
                    {
                        "id": 72602,
                        "name": "Palmira",
                        "latitude": "18.88278000",
                        "longitude": "-97.11139000"
                    },
                    {
                        "id": 72606,
                        "name": "Palo Bendito",
                        "latitude": "20.45710000",
                        "longitude": "-98.50017000"
                    },
                    {
                        "id": 72609,
                        "name": "Palo Gacho",
                        "latitude": "19.39104000",
                        "longitude": "-96.63675000"
                    },
                    {
                        "id": 73007,
                        "name": "Pánuco",
                        "latitude": "22.05373000",
                        "longitude": "-98.18498000"
                    },
                    {
                        "id": 72636,
                        "name": "Papantla de Olarte",
                        "latitude": "20.44655000",
                        "longitude": "-97.32494000"
                    },
                    {
                        "id": 72643,
                        "name": "Paraiso Novillero",
                        "latitude": "18.25294000",
                        "longitude": "-95.93610000"
                    },
                    {
                        "id": 72645,
                        "name": "Paraje Nuevo",
                        "latitude": "18.87886000",
                        "longitude": "-96.86066000"
                    },
                    {
                        "id": 72691,
                        "name": "Paso de Ovejas",
                        "latitude": "19.28450000",
                        "longitude": "-96.44037000"
                    },
                    {
                        "id": 72693,
                        "name": "Paso de Valencia",
                        "latitude": "20.27186000",
                        "longitude": "-97.33346000"
                    },
                    {
                        "id": 72696,
                        "name": "Paso del Correo",
                        "latitude": "20.31619000",
                        "longitude": "-97.27216000"
                    },
                    {
                        "id": 72697,
                        "name": "Paso del Macho",
                        "latitude": "18.97098000",
                        "longitude": "-96.72419000"
                    },
                    {
                        "id": 72698,
                        "name": "Paso del Toro",
                        "latitude": "19.03500000",
                        "longitude": "-96.13555000"
                    },
                    {
                        "id": 72684,
                        "name": "Paso Nacional",
                        "latitude": "18.76639000",
                        "longitude": "-95.74861000"
                    },
                    {
                        "id": 72753,
                        "name": "Peñuela",
                        "latitude": "18.86432000",
                        "longitude": "-96.89327000"
                    },
                    {
                        "id": 72737,
                        "name": "Perote",
                        "latitude": "19.56233000",
                        "longitude": "-97.24235000"
                    },
                    {
                        "id": 72738,
                        "name": "Perseverancia",
                        "latitude": "22.21990000",
                        "longitude": "-97.99627000"
                    },
                    {
                        "id": 72767,
                        "name": "Piedra Parada",
                        "latitude": "19.34654000",
                        "longitude": "-96.96013000"
                    },
                    {
                        "id": 72768,
                        "name": "Piedra Pinta",
                        "latitude": "19.99115000",
                        "longitude": "-97.19538000"
                    },
                    {
                        "id": 72770,
                        "name": "Piedras Negras",
                        "latitude": "18.77026000",
                        "longitude": "-96.17178000"
                    },
                    {
                        "id": 72776,
                        "name": "Piletas",
                        "latitude": "19.58806000",
                        "longitude": "-96.97861000"
                    },
                    {
                        "id": 72786,
                        "name": "Pisaflores",
                        "latitude": "20.60941000",
                        "longitude": "-97.92782000"
                    },
                    {
                        "id": 72796,
                        "name": "Plan de Arroyos",
                        "latitude": "19.89297000",
                        "longitude": "-97.10888000"
                    },
                    {
                        "id": 72797,
                        "name": "Plan de Ayala",
                        "latitude": "20.54889000",
                        "longitude": "-97.47129000"
                    },
                    {
                        "id": 72802,
                        "name": "Plan de Iguala",
                        "latitude": "22.03638000",
                        "longitude": "-98.46457000"
                    },
                    {
                        "id": 72803,
                        "name": "Plan de las Hayas",
                        "latitude": "19.75963000",
                        "longitude": "-96.67594000"
                    },
                    {
                        "id": 72804,
                        "name": "Plan del Río",
                        "latitude": "19.40184000",
                        "longitude": "-96.65250000"
                    },
                    {
                        "id": 72808,
                        "name": "Platón Sánchez",
                        "latitude": "21.27182000",
                        "longitude": "-98.37456000"
                    },
                    {
                        "id": 72812,
                        "name": "Playa de Chachalacas",
                        "latitude": "19.42352000",
                        "longitude": "-96.32280000"
                    },
                    {
                        "id": 72813,
                        "name": "Playa de la Libertad",
                        "latitude": "19.08306000",
                        "longitude": "-96.09778000"
                    },
                    {
                        "id": 72811,
                        "name": "Playa Vicente",
                        "latitude": "17.83107000",
                        "longitude": "-95.81189000"
                    },
                    {
                        "id": 72820,
                        "name": "Poblado 10",
                        "latitude": "17.27722000",
                        "longitude": "-94.45194000"
                    },
                    {
                        "id": 72825,
                        "name": "Poblado Cinco",
                        "latitude": "17.27453000",
                        "longitude": "-94.55152000"
                    },
                    {
                        "id": 72826,
                        "name": "Poblado Dos",
                        "latitude": "18.31895000",
                        "longitude": "-96.03986000"
                    },
                    {
                        "id": 72829,
                        "name": "Poblado Tres",
                        "latitude": "18.28929000",
                        "longitude": "-96.09114000"
                    },
                    {
                        "id": 72840,
                        "name": "Polutla",
                        "latitude": "20.52799000",
                        "longitude": "-97.25884000"
                    },
                    {
                        "id": 72867,
                        "name": "Potrero del Llano",
                        "latitude": "21.07970000",
                        "longitude": "-97.72814000"
                    },
                    {
                        "id": 72865,
                        "name": "Potrero Viejo",
                        "latitude": "18.87733000",
                        "longitude": "-96.84357000"
                    },
                    {
                        "id": 72870,
                        "name": "Poza Rica de Hidalgo",
                        "latitude": "20.53315000",
                        "longitude": "-97.45946000"
                    },
                    {
                        "id": 72893,
                        "name": "Presidio",
                        "latitude": "19.06933000",
                        "longitude": "-96.97209000"
                    },
                    {
                        "id": 72894,
                        "name": "Presidio (Plan de Libres)",
                        "latitude": "18.68056000",
                        "longitude": "-96.77194000"
                    },
                    {
                        "id": 72899,
                        "name": "Primero de Mayo",
                        "latitude": "22.22524000",
                        "longitude": "-97.81940000"
                    },
                    {
                        "id": 72920,
                        "name": "Progreso de Zaragoza",
                        "latitude": "20.27490000",
                        "longitude": "-97.71163000"
                    },
                    {
                        "id": 72928,
                        "name": "Pueblillo",
                        "latitude": "20.25438000",
                        "longitude": "-97.25523000"
                    },
                    {
                        "id": 72952,
                        "name": "Pueblo Viejo",
                        "latitude": "22.16081000",
                        "longitude": "-97.91013000"
                    },
                    {
                        "id": 72957,
                        "name": "Puente de Piedra",
                        "latitude": "20.60550000",
                        "longitude": "-97.19601000"
                    },
                    {
                        "id": 72955,
                        "name": "Puente Jula",
                        "latitude": "19.20018000",
                        "longitude": "-96.34828000"
                    },
                    {
                        "id": 72970,
                        "name": "Puerto Esmeralda",
                        "latitude": "18.14778000",
                        "longitude": "-94.51778000"
                    },
                    {
                        "id": 72987,
                        "name": "Puntilla Aldama",
                        "latitude": "20.18915000",
                        "longitude": "-96.90693000"
                    },
                    {
                        "id": 73030,
                        "name": "Quiamoloapan",
                        "latitude": "18.06180000",
                        "longitude": "-94.99574000"
                    },
                    {
                        "id": 73043,
                        "name": "Rafael Delgado",
                        "latitude": "18.81014000",
                        "longitude": "-97.07172000"
                    },
                    {
                        "id": 73045,
                        "name": "Rafael Lucio",
                        "latitude": "19.59308000",
                        "longitude": "-96.99023000"
                    },
                    {
                        "id": 73057,
                        "name": "Rancho Alegre",
                        "latitude": "20.20722000",
                        "longitude": "-97.63889000"
                    },
                    {
                        "id": 73080,
                        "name": "Rancho del Padre",
                        "latitude": "19.06553000",
                        "longitude": "-96.17281000"
                    },
                    {
                        "id": 73065,
                        "name": "Rancho Nuevo",
                        "latitude": "20.67250000",
                        "longitude": "-97.20611000"
                    },
                    {
                        "id": 73073,
                        "name": "Rancho Viejo",
                        "latitude": "19.44451000",
                        "longitude": "-96.78168000"
                    },
                    {
                        "id": 73099,
                        "name": "Residencial las Olas",
                        "latitude": "18.11861000",
                        "longitude": "-94.56611000"
                    },
                    {
                        "id": 73098,
                        "name": "Residencial Tajín",
                        "latitude": "20.59806000",
                        "longitude": "-97.41694000"
                    },
                    {
                        "id": 73109,
                        "name": "Ricardo Flores Magón",
                        "latitude": "20.51444000",
                        "longitude": "-97.49500000"
                    },
                    {
                        "id": 73122,
                        "name": "Rincón de Barrabás",
                        "latitude": "19.00590000",
                        "longitude": "-96.53640000"
                    },
                    {
                        "id": 73123,
                        "name": "Rincón de Buena Vista",
                        "latitude": "18.75556000",
                        "longitude": "-96.86861000"
                    },
                    {
                        "id": 73111,
                        "name": "Rinconada",
                        "latitude": "19.35438000",
                        "longitude": "-96.56581000"
                    },
                    {
                        "id": 73167,
                        "name": "Río Blanco",
                        "latitude": "18.83036000",
                        "longitude": "-97.15600000"
                    },
                    {
                        "id": 73181,
                        "name": "Río Medio [Granja]",
                        "latitude": "19.20972000",
                        "longitude": "-96.20889000"
                    },
                    {
                        "id": 73150,
                        "name": "Rodríguez Tejeda",
                        "latitude": "18.63198000",
                        "longitude": "-96.41526000"
                    },
                    {
                        "id": 73189,
                        "name": "Sabanas de Xalostoc",
                        "latitude": "20.22223000",
                        "longitude": "-97.53525000"
                    },
                    {
                        "id": 73191,
                        "name": "Sabaneta",
                        "latitude": "18.22325000",
                        "longitude": "-95.08082000"
                    },
                    {
                        "id": 73207,
                        "name": "Saladero",
                        "latitude": "21.42380000",
                        "longitude": "-97.54381000"
                    },
                    {
                        "id": 73214,
                        "name": "Salinas",
                        "latitude": "18.89022000",
                        "longitude": "-95.94299000"
                    },
                    {
                        "id": 73222,
                        "name": "Saltabarranca",
                        "latitude": "18.59119000",
                        "longitude": "-95.53226000"
                    },
                    {
                        "id": 73224,
                        "name": "Saltillo",
                        "latitude": "18.15893000",
                        "longitude": "-94.85325000"
                    },
                    {
                        "id": 73228,
                        "name": "Salvador Díaz Mirón",
                        "latitude": "19.78580000",
                        "longitude": "-96.87314000"
                    },
                    {
                        "id": 73262,
                        "name": "San Agustín del Palmar",
                        "latitude": "18.51679000",
                        "longitude": "-96.72085000"
                    },
                    {
                        "id": 73295,
                        "name": "San Andrés Tenejapan",
                        "latitude": "18.77389000",
                        "longitude": "-97.08583000"
                    },
                    {
                        "id": 73300,
                        "name": "San Andrés Tuxtla",
                        "latitude": "18.44870000",
                        "longitude": "-95.21327000"
                    },
                    {
                        "id": 73362,
                        "name": "San Antonio Xoquitla",
                        "latitude": "19.34056000",
                        "longitude": "-97.16500000"
                    },
                    {
                        "id": 73474,
                        "name": "San Cristóbal",
                        "latitude": "18.82979000",
                        "longitude": "-97.12392000"
                    },
                    {
                        "id": 73536,
                        "name": "San Fernando",
                        "latitude": "18.26900000",
                        "longitude": "-94.88483000"
                    },
                    {
                        "id": 73538,
                        "name": "San Francisco",
                        "latitude": "20.55254000",
                        "longitude": "-98.00209000"
                    },
                    {
                        "id": 73548,
                        "name": "San Francisco (Mata Clara)",
                        "latitude": "18.81444000",
                        "longitude": "-96.74611000"
                    },
                    {
                        "id": 73580,
                        "name": "San Francisco Nacaxtle",
                        "latitude": "19.11083000",
                        "longitude": "-96.59583000"
                    },
                    {
                        "id": 73663,
                        "name": "San Isidro",
                        "latitude": "18.89111000",
                        "longitude": "-97.12583000"
                    },
                    {
                        "id": 73690,
                        "name": "San Isidro el Berro",
                        "latitude": "18.92722000",
                        "longitude": "-97.20556000"
                    },
                    {
                        "id": 73683,
                        "name": "San Isidro Palotal",
                        "latitude": "18.94417000",
                        "longitude": "-96.96583000"
                    },
                    {
                        "id": 73685,
                        "name": "San Isidro Xoteapan (San Isidro Texcaltitán)",
                        "latitude": "18.46778000",
                        "longitude": "-95.23806000"
                    },
                    {
                        "id": 73805,
                        "name": "San José de Abajo",
                        "latitude": "18.77583000",
                        "longitude": "-96.77722000"
                    },
                    {
                        "id": 73806,
                        "name": "San José de Abajo [Unidad Habitacional]",
                        "latitude": "18.91972000",
                        "longitude": "-96.96361000"
                    },
                    {
                        "id": 73826,
                        "name": "San José de Tapia",
                        "latitude": "18.84722000",
                        "longitude": "-96.95389000"
                    },
                    {
                        "id": 73767,
                        "name": "San José Independencia",
                        "latitude": "18.75583000",
                        "longitude": "-96.94500000"
                    },
                    {
                        "id": 73776,
                        "name": "San José Neria",
                        "latitude": "18.99333000",
                        "longitude": "-96.99917000"
                    },
                    {
                        "id": 73783,
                        "name": "San José Súchil",
                        "latitude": "18.88778000",
                        "longitude": "-97.23722000"
                    },
                    {
                        "id": 73788,
                        "name": "San José Tenejapa",
                        "latitude": "19.01556000",
                        "longitude": "-96.84306000"
                    },
                    {
                        "id": 73972,
                        "name": "San Juan de los Reyes (Luis Valenzuela)",
                        "latitude": "18.51778000",
                        "longitude": "-95.44889000"
                    },
                    {
                        "id": 73892,
                        "name": "San Juan Evangelista",
                        "latitude": "17.88615000",
                        "longitude": "-95.13961000"
                    },
                    {
                        "id": 73924,
                        "name": "San Juan Seco de Valencia",
                        "latitude": "18.30946000",
                        "longitude": "-95.15605000"
                    },
                    {
                        "id": 73948,
                        "name": "San Juan Volador",
                        "latitude": "18.26355000",
                        "longitude": "-94.65180000"
                    },
                    {
                        "id": 73985,
                        "name": "San Julián",
                        "latitude": "19.25680000",
                        "longitude": "-96.26717000"
                    },
                    {
                        "id": 73987,
                        "name": "San Leoncio Jamaya",
                        "latitude": "20.31288000",
                        "longitude": "-97.58127000"
                    },
                    {
                        "id": 74012,
                        "name": "San Lorenzo Tenochtitlán",
                        "latitude": "17.75500000",
                        "longitude": "-94.76028000"
                    },
                    {
                        "id": 74068,
                        "name": "San Marcos Atesquilapan",
                        "latitude": "19.68972000",
                        "longitude": "-96.88537000"
                    },
                    {
                        "id": 74079,
                        "name": "San Marcos de León",
                        "latitude": "19.42377000",
                        "longitude": "-96.96442000"
                    },
                    {
                        "id": 74186,
                        "name": "San Miguel Mecatepec",
                        "latitude": "20.52896000",
                        "longitude": "-97.48744000"
                    },
                    {
                        "id": 74214,
                        "name": "San Miguel Tlalpoalán",
                        "latitude": "19.73981000",
                        "longitude": "-97.22662000"
                    },
                    {
                        "id": 74330,
                        "name": "San Pedro Coyutla",
                        "latitude": "21.22410000",
                        "longitude": "-98.43002000"
                    },
                    {
                        "id": 74356,
                        "name": "San Pedro Mártir",
                        "latitude": "17.97870000",
                        "longitude": "-94.61033000"
                    },
                    {
                        "id": 74387,
                        "name": "San Pedro Tlanixco",
                        "latitude": "19.06259000",
                        "longitude": "-99.65237000"
                    },
                    {
                        "id": 74389,
                        "name": "San Pedro Tlapacoyan",
                        "latitude": "20.05806000",
                        "longitude": "-97.09833000"
                    },
                    {
                        "id": 74422,
                        "name": "San Rafael",
                        "latitude": "20.18862000",
                        "longitude": "-96.86737000"
                    },
                    {
                        "id": 74430,
                        "name": "San Rafael Calería",
                        "latitude": "18.94039000",
                        "longitude": "-96.94394000"
                    },
                    {
                        "id": 74432,
                        "name": "San Rafael Río Seco",
                        "latitude": "18.87608000",
                        "longitude": "-96.88127000"
                    },
                    {
                        "id": 74455,
                        "name": "San Sebastián",
                        "latitude": "21.21724000",
                        "longitude": "-98.13271000"
                    },
                    {
                        "id": 74570,
                        "name": "Santa Catalina",
                        "latitude": "18.16353000",
                        "longitude": "-95.20779000"
                    },
                    {
                        "id": 74675,
                        "name": "Santa Isabel",
                        "latitude": "20.19222000",
                        "longitude": "-97.52917000"
                    },
                    {
                        "id": 74689,
                        "name": "Santa Lucía Potrerillo",
                        "latitude": "18.96917000",
                        "longitude": "-97.02417000"
                    },
                    {
                        "id": 74776,
                        "name": "Santa María Tatetla",
                        "latitude": "19.27278000",
                        "longitude": "-96.71251000"
                    },
                    {
                        "id": 74830,
                        "name": "Santa Rita",
                        "latitude": "19.16736000",
                        "longitude": "-96.26000000"
                    },
                    {
                        "id": 74834,
                        "name": "Santa Rosa",
                        "latitude": "19.47078000",
                        "longitude": "-96.46514000"
                    },
                    {
                        "id": 74841,
                        "name": "Santa Rosa Abata",
                        "latitude": "18.46190000",
                        "longitude": "-95.16765000"
                    },
                    {
                        "id": 74844,
                        "name": "Santa Rosa Loma Larga",
                        "latitude": "18.23098000",
                        "longitude": "-95.08710000"
                    },
                    {
                        "id": 74857,
                        "name": "Santa Teresa",
                        "latitude": "17.69562000",
                        "longitude": "-95.67276000"
                    },
                    {
                        "id": 74866,
                        "name": "Santiago",
                        "latitude": "18.44884000",
                        "longitude": "-95.83037000"
                    },
                    {
                        "id": 74986,
                        "name": "Santiago de la Peña",
                        "latitude": "20.94512000",
                        "longitude": "-97.40493000"
                    },
                    {
                        "id": 74939,
                        "name": "Santiago Sochiapan",
                        "latitude": "17.61585000",
                        "longitude": "-95.65276000"
                    },
                    {
                        "id": 74968,
                        "name": "Santiago Tuxtla",
                        "latitude": "18.46576000",
                        "longitude": "-95.30060000"
                    },
                    {
                        "id": 75042,
                        "name": "Sasaltitla",
                        "latitude": "20.93518000",
                        "longitude": "-98.19703000"
                    },
                    {
                        "id": 75047,
                        "name": "Sayula de Alemán",
                        "latitude": "17.88191000",
                        "longitude": "-94.95986000"
                    },
                    {
                        "id": 75074,
                        "name": "Sierra de Agua",
                        "latitude": "18.75028000",
                        "longitude": "-97.24167000"
                    },
                    {
                        "id": 75077,
                        "name": "Sihuapan",
                        "latitude": "18.43663000",
                        "longitude": "-95.17833000"
                    },
                    {
                        "id": 75094,
                        "name": "Sinapan",
                        "latitude": "18.53480000",
                        "longitude": "-95.29287000"
                    },
                    {
                        "id": 75106,
                        "name": "Sochiapa",
                        "latitude": "19.19292000",
                        "longitude": "-96.93989000"
                    },
                    {
                        "id": 75108,
                        "name": "Soconusco",
                        "latitude": "17.96315000",
                        "longitude": "-94.88097000"
                    },
                    {
                        "id": 75111,
                        "name": "Soledad Atzompa",
                        "latitude": "18.75499000",
                        "longitude": "-97.15040000"
                    },
                    {
                        "id": 75116,
                        "name": "Soledad de Doblado",
                        "latitude": "19.04637000",
                        "longitude": "-96.42142000"
                    },
                    {
                        "id": 75122,
                        "name": "Sonora",
                        "latitude": "19.11219000",
                        "longitude": "-96.63531000"
                    },
                    {
                        "id": 75123,
                        "name": "Sontecomapan",
                        "latitude": "18.50289000",
                        "longitude": "-95.03507000"
                    },
                    {
                        "id": 75125,
                        "name": "Soteapan",
                        "latitude": "18.23391000",
                        "longitude": "-94.87296000"
                    },
                    {
                        "id": 75131,
                        "name": "Soyata",
                        "latitude": "18.36889000",
                        "longitude": "-95.28222000"
                    },
                    {
                        "id": 75140,
                        "name": "Suchilapan del Río",
                        "latitude": "17.38611000",
                        "longitude": "-94.98806000"
                    },
                    {
                        "id": 75149,
                        "name": "Sumidero",
                        "latitude": "18.90393000",
                        "longitude": "-97.02152000"
                    },
                    {
                        "id": 75174,
                        "name": "Tamalín",
                        "latitude": "21.33936000",
                        "longitude": "-97.81188000"
                    },
                    {
                        "id": 75187,
                        "name": "Tamiahua",
                        "latitude": "21.27881000",
                        "longitude": "-97.44620000"
                    },
                    {
                        "id": 75192,
                        "name": "Tampico Alto",
                        "latitude": "22.11240000",
                        "longitude": "-97.80184000"
                    },
                    {
                        "id": 75204,
                        "name": "Tancoco",
                        "latitude": "21.28622000",
                        "longitude": "-97.79139000"
                    },
                    {
                        "id": 75218,
                        "name": "Tantima",
                        "latitude": "21.33228000",
                        "longitude": "-97.83327000"
                    },
                    {
                        "id": 75219,
                        "name": "Tantoyuca",
                        "latitude": "21.39307000",
                        "longitude": "-98.18453000"
                    },
                    {
                        "id": 75223,
                        "name": "Tapalapan",
                        "latitude": "18.53250000",
                        "longitude": "-95.30631000"
                    },
                    {
                        "id": 75237,
                        "name": "Tatahuicapan",
                        "latitude": "18.24621000",
                        "longitude": "-94.76124000"
                    },
                    {
                        "id": 75240,
                        "name": "Tatatila",
                        "latitude": "19.69320000",
                        "longitude": "-97.11160000"
                    },
                    {
                        "id": 75250,
                        "name": "Taza de Agua Ojo Zarco",
                        "latitude": "18.78333000",
                        "longitude": "-97.20222000"
                    },
                    {
                        "id": 75257,
                        "name": "Teayo",
                        "latitude": "20.74419000",
                        "longitude": "-97.67966000"
                    },
                    {
                        "id": 75262,
                        "name": "Tecama",
                        "latitude": "19.00379000",
                        "longitude": "-96.98529000"
                    },
                    {
                        "id": 75265,
                        "name": "Tecamalucan",
                        "latitude": "18.76098000",
                        "longitude": "-97.22516000"
                    },
                    {
                        "id": 75274,
                        "name": "Tecolapan",
                        "latitude": "18.57037000",
                        "longitude": "-95.33969000"
                    },
                    {
                        "id": 75279,
                        "name": "Tecolutla",
                        "latitude": "20.48049000",
                        "longitude": "-97.01309000"
                    },
                    {
                        "id": 75299,
                        "name": "Tehuipango",
                        "latitude": "18.51964000",
                        "longitude": "-97.05438000"
                    },
                    {
                        "id": 75328,
                        "name": "Temapache",
                        "latitude": "21.06611000",
                        "longitude": "-97.64207000"
                    },
                    {
                        "id": 75342,
                        "name": "Tempoal",
                        "latitude": "21.56506000",
                        "longitude": "-98.37907000"
                    },
                    {
                        "id": 75343,
                        "name": "Tempoal de Sánchez",
                        "latitude": "21.51998000",
                        "longitude": "-98.38829000"
                    },
                    {
                        "id": 75346,
                        "name": "Tenampa",
                        "latitude": "19.24626000",
                        "longitude": "-96.86858000"
                    },
                    {
                        "id": 75359,
                        "name": "Tenantitla",
                        "latitude": "20.77031000",
                        "longitude": "-98.14433000"
                    },
                    {
                        "id": 75360,
                        "name": "Tenenexpan",
                        "latitude": "19.14105000",
                        "longitude": "-96.39454000"
                    },
                    {
                        "id": 75367,
                        "name": "Tenixtepec",
                        "latitude": "19.02116000",
                        "longitude": "-97.14729000"
                    },
                    {
                        "id": 75369,
                        "name": "Tenochtitlán",
                        "latitude": "19.80917000",
                        "longitude": "-96.91611000"
                    },
                    {
                        "id": 75373,
                        "name": "Teocelo",
                        "latitude": "19.38560000",
                        "longitude": "-96.97371000"
                    },
                    {
                        "id": 75400,
                        "name": "Tepatlaxco",
                        "latitude": "19.06927000",
                        "longitude": "-96.84481000"
                    },
                    {
                        "id": 75429,
                        "name": "Tepetlán",
                        "latitude": "19.67318000",
                        "longitude": "-96.79734000"
                    },
                    {
                        "id": 75435,
                        "name": "Tepetzintla",
                        "latitude": "21.16410000",
                        "longitude": "-97.85236000"
                    },
                    {
                        "id": 75459,
                        "name": "Tequila",
                        "latitude": "18.72998000",
                        "longitude": "-97.06991000"
                    },
                    {
                        "id": 75471,
                        "name": "Tesechoacan",
                        "latitude": "18.13749000",
                        "longitude": "-95.65835000"
                    },
                    {
                        "id": 75484,
                        "name": "Teteltzingo",
                        "latitude": "19.05141000",
                        "longitude": "-97.14465000"
                    },
                    {
                        "id": 75492,
                        "name": "Tetla",
                        "latitude": "18.98709000",
                        "longitude": "-97.06085000"
                    },
                    {
                        "id": 75494,
                        "name": "Tetlatzinga",
                        "latitude": "18.69472000",
                        "longitude": "-97.18444000"
                    },
                    {
                        "id": 75495,
                        "name": "Tetlaxco",
                        "latitude": "19.04044000",
                        "longitude": "-97.06393000"
                    },
                    {
                        "id": 75496,
                        "name": "Tetzacual",
                        "latitude": "20.77329000",
                        "longitude": "-98.26876000"
                    },
                    {
                        "id": 75497,
                        "name": "Texalpan de Abajo",
                        "latitude": "18.42749000",
                        "longitude": "-95.25614000"
                    },
                    {
                        "id": 75498,
                        "name": "Texalpan de Arriba",
                        "latitude": "18.42944000",
                        "longitude": "-95.24417000"
                    },
                    {
                        "id": 75508,
                        "name": "Texcaltitán Xoteapan (Texcaltitán)",
                        "latitude": "18.44667000",
                        "longitude": "-95.25333000"
                    },
                    {
                        "id": 75513,
                        "name": "Texcatepec",
                        "latitude": "20.58505000",
                        "longitude": "-98.36538000"
                    },
                    {
                        "id": 75516,
                        "name": "Texhuacán",
                        "latitude": "18.62233000",
                        "longitude": "-97.04025000"
                    },
                    {
                        "id": 75517,
                        "name": "Texin",
                        "latitude": "19.36598000",
                        "longitude": "-97.00487000"
                    },
                    {
                        "id": 75518,
                        "name": "Texistepec",
                        "latitude": "17.89476000",
                        "longitude": "-94.81711000"
                    },
                    {
                        "id": 75520,
                        "name": "Texmola",
                        "latitude": "18.93972000",
                        "longitude": "-97.24389000"
                    },
                    {
                        "id": 75527,
                        "name": "Tezonapa",
                        "latitude": "18.60706000",
                        "longitude": "-96.68417000"
                    },
                    {
                        "id": 75547,
                        "name": "Tierra Blanca",
                        "latitude": "20.87500000",
                        "longitude": "-97.46000000"
                    },
                    {
                        "id": 75548,
                        "name": "Tierra Blanca Booxter",
                        "latitude": "20.99479000",
                        "longitude": "-97.71681000"
                    },
                    {
                        "id": 75550,
                        "name": "Tierra Colorada",
                        "latitude": "19.22544000",
                        "longitude": "-96.36929000"
                    },
                    {
                        "id": 75554,
                        "name": "Tierra Nueva",
                        "latitude": "19.93925000",
                        "longitude": "-97.01644000"
                    },
                    {
                        "id": 75560,
                        "name": "Tihuatlan",
                        "latitude": "20.71449000",
                        "longitude": "-97.53335000"
                    },
                    {
                        "id": 75567,
                        "name": "Tilapan",
                        "latitude": "18.34917000",
                        "longitude": "-95.32806000"
                    },
                    {
                        "id": 75575,
                        "name": "Tinajitas",
                        "latitude": "19.61806000",
                        "longitude": "-96.44250000"
                    },
                    {
                        "id": 75576,
                        "name": "Tincontlán",
                        "latitude": "20.82141000",
                        "longitude": "-97.69083000"
                    },
                    {
                        "id": 75600,
                        "name": "Tlachichilco",
                        "latitude": "20.62123000",
                        "longitude": "-98.19900000"
                    },
                    {
                        "id": 75607,
                        "name": "Tlacojalpan",
                        "latitude": "18.23096000",
                        "longitude": "-95.94682000"
                    },
                    {
                        "id": 75608,
                        "name": "Tlacolula",
                        "latitude": "21.09177000",
                        "longitude": "-97.95960000"
                    },
                    {
                        "id": 75610,
                        "name": "Tlacolulan",
                        "latitude": "19.66687000",
                        "longitude": "-97.00194000"
                    },
                    {
                        "id": 75613,
                        "name": "Tlacotalpan",
                        "latitude": "18.61333000",
                        "longitude": "-95.65890000"
                    },
                    {
                        "id": 75621,
                        "name": "Tlacotepec de Mejía",
                        "latitude": "19.18946000",
                        "longitude": "-96.83805000"
                    },
                    {
                        "id": 75624,
                        "name": "Tlacuilolapan",
                        "latitude": "17.97778000",
                        "longitude": "-94.26306000"
                    },
                    {
                        "id": 75637,
                        "name": "Tlalconteno",
                        "latitude": "19.44863000",
                        "longitude": "-97.24642000"
                    },
                    {
                        "id": 75639,
                        "name": "Tlalixcoyan",
                        "latitude": "18.80222000",
                        "longitude": "-96.06056000"
                    },
                    {
                        "id": 75644,
                        "name": "Tlalnelhuayocan",
                        "latitude": "19.56681000",
                        "longitude": "-96.97534000"
                    },
                    {
                        "id": 75657,
                        "name": "Tlaltetela",
                        "latitude": "19.31421000",
                        "longitude": "-96.90105000"
                    },
                    {
                        "id": 75664,
                        "name": "Tlamatoca",
                        "latitude": "19.09336000",
                        "longitude": "-96.93685000"
                    },
                    {
                        "id": 75677,
                        "name": "Tlapacoyan",
                        "latitude": "19.96268000",
                        "longitude": "-97.21141000"
                    },
                    {
                        "id": 75678,
                        "name": "Tlapala",
                        "latitude": "19.26165000",
                        "longitude": "-96.91878000"
                    },
                    {
                        "id": 75687,
                        "name": "Tlatilpa",
                        "latitude": "18.73389000",
                        "longitude": "-97.14417000"
                    },
                    {
                        "id": 75692,
                        "name": "Tlatzala",
                        "latitude": "18.72861000",
                        "longitude": "-97.14111000"
                    },
                    {
                        "id": 75709,
                        "name": "Tlilapan",
                        "latitude": "18.80560000",
                        "longitude": "-97.09867000"
                    },
                    {
                        "id": 75717,
                        "name": "Tocuila",
                        "latitude": "18.95000000",
                        "longitude": "-97.01667000"
                    },
                    {
                        "id": 75722,
                        "name": "Tolome",
                        "latitude": "19.26667000",
                        "longitude": "-96.39472000"
                    },
                    {
                        "id": 75727,
                        "name": "Tomatlán",
                        "latitude": "19.03102000",
                        "longitude": "-97.00986000"
                    },
                    {
                        "id": 75737,
                        "name": "Tonalá",
                        "latitude": "18.20714000",
                        "longitude": "-94.14174000"
                    },
                    {
                        "id": 75731,
                        "name": "Tonalaco",
                        "latitude": "19.42931000",
                        "longitude": "-97.13271000"
                    },
                    {
                        "id": 75734,
                        "name": "Tonalapan",
                        "latitude": "18.46833000",
                        "longitude": "-95.22000000"
                    },
                    {
                        "id": 75735,
                        "name": "Tonalixco",
                        "latitude": "18.78194000",
                        "longitude": "-97.05972000"
                    },
                    {
                        "id": 75742,
                        "name": "Tonayán",
                        "latitude": "19.71228000",
                        "longitude": "-96.91959000"
                    },
                    {
                        "id": 75751,
                        "name": "Totolapa",
                        "latitude": "20.55800000",
                        "longitude": "-97.47636000"
                    },
                    {
                        "id": 75759,
                        "name": "Totutla",
                        "latitude": "19.21169000",
                        "longitude": "-96.96118000"
                    },
                    {
                        "id": 75763,
                        "name": "Tozongo",
                        "latitude": "19.10031000",
                        "longitude": "-97.06087000"
                    },
                    {
                        "id": 75769,
                        "name": "Trapiche del Rosario",
                        "latitude": "19.54306000",
                        "longitude": "-96.74111000"
                    },
                    {
                        "id": 75768,
                        "name": "Trapiche Viejo",
                        "latitude": "18.84306000",
                        "longitude": "-96.94556000"
                    },
                    {
                        "id": 75778,
                        "name": "Tres Valles",
                        "latitude": "18.23915000",
                        "longitude": "-96.13569000"
                    },
                    {
                        "id": 75779,
                        "name": "Tres Zapotes",
                        "latitude": "18.46827000",
                        "longitude": "-95.43710000"
                    },
                    {
                        "id": 75784,
                        "name": "Tronconal",
                        "latitude": "19.56404000",
                        "longitude": "-96.86324000"
                    },
                    {
                        "id": 75788,
                        "name": "Tula",
                        "latitude": "18.58672000",
                        "longitude": "-95.37679000"
                    },
                    {
                        "id": 75795,
                        "name": "Tulapam",
                        "latitude": "18.31434000",
                        "longitude": "-95.22619000"
                    },
                    {
                        "id": 75857,
                        "name": "Túxpam de Rodríguez Cano",
                        "latitude": "20.95777000",
                        "longitude": "-97.40805000"
                    },
                    {
                        "id": 75821,
                        "name": "Tuxpan",
                        "latitude": "20.94633000",
                        "longitude": "-97.42603000"
                    },
                    {
                        "id": 75822,
                        "name": "Tuxpanguillo",
                        "latitude": "18.78229000",
                        "longitude": "-97.01283000"
                    },
                    {
                        "id": 75824,
                        "name": "Tuxtilla",
                        "latitude": "18.18790000",
                        "longitude": "-95.88014000"
                    },
                    {
                        "id": 75829,
                        "name": "Tuzamapan",
                        "latitude": "19.40253000",
                        "longitude": "-96.86360000"
                    },
                    {
                        "id": 75838,
                        "name": "Tzicatlán",
                        "latitude": "20.67396000",
                        "longitude": "-98.23604000"
                    },
                    {
                        "id": 75888,
                        "name": "Unión y Progreso",
                        "latitude": "18.87278000",
                        "longitude": "-97.11917000"
                    },
                    {
                        "id": 76408,
                        "name": "Úrsulo Galván",
                        "latitude": "19.40531000",
                        "longitude": "-96.36090000"
                    },
                    {
                        "id": 75903,
                        "name": "Uxpanapa",
                        "latitude": "17.27501000",
                        "longitude": "-94.42594000"
                    },
                    {
                        "id": 75909,
                        "name": "Valente Diaz",
                        "latitude": "19.16347000",
                        "longitude": "-96.21648000"
                    },
                    {
                        "id": 75938,
                        "name": "Vargas",
                        "latitude": "19.22774000",
                        "longitude": "-96.32046000"
                    },
                    {
                        "id": 75939,
                        "name": "Vega de Alatorre",
                        "latitude": "20.02823000",
                        "longitude": "-96.64751000"
                    },
                    {
                        "id": 75942,
                        "name": "Vegas de la Soledad y Soledad Dos",
                        "latitude": "20.94476000",
                        "longitude": "-97.83273000"
                    },
                    {
                        "id": 75945,
                        "name": "Veinte de Noviembre",
                        "latitude": "18.86500000",
                        "longitude": "-96.95472000"
                    },
                    {
                        "id": 75949,
                        "name": "Veintiuno de Agosto",
                        "latitude": "19.72500000",
                        "longitude": "-97.27222000"
                    },
                    {
                        "id": 75964,
                        "name": "Venustiano Carranza (Peña Blanca)",
                        "latitude": "17.64194000",
                        "longitude": "-94.75417000"
                    },
                    {
                        "id": 75965,
                        "name": "Veracruz",
                        "latitude": "19.18095000",
                        "longitude": "-96.14290000"
                    },
                    {
                        "id": 75974,
                        "name": "Vicente Guerrero",
                        "latitude": "17.49594000",
                        "longitude": "-94.71940000"
                    },
                    {
                        "id": 75981,
                        "name": "Vicente Herrera",
                        "latitude": "20.57695000",
                        "longitude": "-97.34973000"
                    },
                    {
                        "id": 75989,
                        "name": "Villa Aldama",
                        "latitude": "19.64861000",
                        "longitude": "-97.22333000"
                    },
                    {
                        "id": 75993,
                        "name": "Villa Azueta",
                        "latitude": "18.07418000",
                        "longitude": "-95.71225000"
                    },
                    {
                        "id": 76071,
                        "name": "Villa de las Flores",
                        "latitude": "20.57639000",
                        "longitude": "-97.43361000"
                    },
                    {
                        "id": 76000,
                        "name": "Villa Emiliano Zapata",
                        "latitude": "19.36353000",
                        "longitude": "-96.65776000"
                    },
                    {
                        "id": 76001,
                        "name": "Villa Emilio Carranza",
                        "latitude": "19.97020000",
                        "longitude": "-96.61162000"
                    },
                    {
                        "id": 76017,
                        "name": "Villa Independencia",
                        "latitude": "20.05523000",
                        "longitude": "-97.05214000"
                    },
                    {
                        "id": 76028,
                        "name": "Villa Lázaro Cárdenas",
                        "latitude": "20.46193000",
                        "longitude": "-97.70024000"
                    },
                    {
                        "id": 76050,
                        "name": "Villa Unión",
                        "latitude": "18.85438000",
                        "longitude": "-96.98246000"
                    },
                    {
                        "id": 76059,
                        "name": "Villa Zempoala",
                        "latitude": "19.44422000",
                        "longitude": "-96.40773000"
                    },
                    {
                        "id": 76094,
                        "name": "Vista Hermosa",
                        "latitude": "17.92361000",
                        "longitude": "-95.06083000"
                    },
                    {
                        "id": 76113,
                        "name": "Xalapa de Enríquez",
                        "latitude": "19.53124000",
                        "longitude": "-96.91589000"
                    },
                    {
                        "id": 76115,
                        "name": "Xalatlaco",
                        "latitude": "19.04972000",
                        "longitude": "-97.04111000"
                    },
                    {
                        "id": 76137,
                        "name": "Xico",
                        "latitude": "19.42178000",
                        "longitude": "-97.00819000"
                    },
                    {
                        "id": 76152,
                        "name": "Xoampolco",
                        "latitude": "19.76055000",
                        "longitude": "-97.22965000"
                    },
                    {
                        "id": 76167,
                        "name": "Xochimilco",
                        "latitude": "20.86302000",
                        "longitude": "-98.06967000"
                    },
                    {
                        "id": 76182,
                        "name": "Xococapa",
                        "latitude": "20.80917000",
                        "longitude": "-98.35118000"
                    },
                    {
                        "id": 76185,
                        "name": "Xocotla",
                        "latitude": "19.01511000",
                        "longitude": "-97.10092000"
                    },
                    {
                        "id": 76198,
                        "name": "Xopilapa",
                        "latitude": "18.50472000",
                        "longitude": "-97.07944000"
                    },
                    {
                        "id": 76199,
                        "name": "Xoteapan",
                        "latitude": "18.43470000",
                        "longitude": "-95.26645000"
                    },
                    {
                        "id": 76200,
                        "name": "Xoxocotla",
                        "latitude": "18.64658000",
                        "longitude": "-97.15244000"
                    },
                    {
                        "id": 76215,
                        "name": "Yanga",
                        "latitude": "18.83288000",
                        "longitude": "-96.79837000"
                    },
                    {
                        "id": 76230,
                        "name": "Yecuatla",
                        "latitude": "19.86614000",
                        "longitude": "-96.77836000"
                    },
                    {
                        "id": 76256,
                        "name": "Zacamixtle",
                        "latitude": "21.24762000",
                        "longitude": "-97.72155000"
                    },
                    {
                        "id": 76270,
                        "name": "Zacate Colorado",
                        "latitude": "20.49735000",
                        "longitude": "-97.52416000"
                    },
                    {
                        "id": 76271,
                        "name": "Zacate Colorado Segundo (Fraternidad)",
                        "latitude": "18.68333000",
                        "longitude": "-95.97111000"
                    },
                    {
                        "id": 76276,
                        "name": "Zacatla",
                        "latitude": "19.00528000",
                        "longitude": "-97.13437000"
                    },
                    {
                        "id": 76287,
                        "name": "Zacualpan",
                        "latitude": "20.49929000",
                        "longitude": "-98.33931000"
                    },
                    {
                        "id": 76293,
                        "name": "Zamora",
                        "latitude": "18.58101000",
                        "longitude": "-95.48361000"
                    },
                    {
                        "id": 76298,
                        "name": "Zapoapan",
                        "latitude": "18.84018000",
                        "longitude": "-96.99297000"
                    },
                    {
                        "id": 76299,
                        "name": "Zapoapan de Amapan",
                        "latitude": "18.23778000",
                        "longitude": "-95.18452000"
                    },
                    {
                        "id": 76300,
                        "name": "Zapoapan de Cabañas",
                        "latitude": "18.33395000",
                        "longitude": "-95.09725000"
                    },
                    {
                        "id": 76320,
                        "name": "Zaragoza",
                        "latitude": "17.94871000",
                        "longitude": "-94.64361000"
                    },
                    {
                        "id": 76329,
                        "name": "Zentla",
                        "latitude": "19.07237000",
                        "longitude": "-96.75442000"
                    },
                    {
                        "id": 76362,
                        "name": "Zongolica",
                        "latitude": "18.66673000",
                        "longitude": "-96.99707000"
                    },
                    {
                        "id": 76364,
                        "name": "Zontecomatlán de López y Fuentes",
                        "latitude": "20.74173000",
                        "longitude": "-98.29972000"
                    },
                    {
                        "id": 76382,
                        "name": "Zozocolco de Hidalgo",
                        "latitude": "20.14048000",
                        "longitude": "-97.57567000"
                    }
                ]
            },
            {
                "id": 3466,
                "name": "Yucatán",
                "iso2": "YUC",
                "latitude": "20.70987860",
                "longitude": "-89.09433770",
                "type": "state",
                "cities": [
                    {
                        "id": 68010,
                        "name": "Abala",
                        "latitude": "20.64745000",
                        "longitude": "-89.68094000"
                    },
                    {
                        "id": 68035,
                        "name": "Acanceh",
                        "latitude": "20.81269000",
                        "longitude": "-89.45295000"
                    },
                    {
                        "id": 68170,
                        "name": "Akil",
                        "latitude": "20.26547000",
                        "longitude": "-89.34787000"
                    },
                    {
                        "id": 68479,
                        "name": "Baca",
                        "latitude": "21.10874000",
                        "longitude": "-89.39866000"
                    },
                    {
                        "id": 68569,
                        "name": "Becanchén",
                        "latitude": "19.87467000",
                        "longitude": "-89.21732000"
                    },
                    {
                        "id": 68628,
                        "name": "Bokoba",
                        "latitude": "21.00755000",
                        "longitude": "-89.17913000"
                    },
                    {
                        "id": 68631,
                        "name": "Bolón",
                        "latitude": "20.85010000",
                        "longitude": "-89.83193000"
                    },
                    {
                        "id": 68657,
                        "name": "Buctzotz",
                        "latitude": "21.20303000",
                        "longitude": "-88.79271000"
                    },
                    {
                        "id": 68707,
                        "name": "Cacalchen",
                        "latitude": "20.98358000",
                        "longitude": "-89.22686000"
                    },
                    {
                        "id": 68729,
                        "name": "Calcehtoc",
                        "latitude": "20.56807000",
                        "longitude": "-89.91242000"
                    },
                    {
                        "id": 68745,
                        "name": "Calotmul",
                        "latitude": "21.02494000",
                        "longitude": "-88.12581000"
                    },
                    {
                        "id": 68771,
                        "name": "Campestre Flamboyanes",
                        "latitude": "21.21000000",
                        "longitude": "-89.65778000"
                    },
                    {
                        "id": 68792,
                        "name": "Cansahcab",
                        "latitude": "21.15749000",
                        "longitude": "-89.10131000"
                    },
                    {
                        "id": 68794,
                        "name": "Cantamayec",
                        "latitude": "20.43186000",
                        "longitude": "-89.07176000"
                    },
                    {
                        "id": 68865,
                        "name": "Caucel",
                        "latitude": "21.01539000",
                        "longitude": "-89.70347000"
                    },
                    {
                        "id": 68893,
                        "name": "Celestún",
                        "latitude": "20.85973000",
                        "longitude": "-90.39902000"
                    },
                    {
                        "id": 68897,
                        "name": "Cenotillo",
                        "latitude": "20.96621000",
                        "longitude": "-88.60438000"
                    },
                    {
                        "id": 68903,
                        "name": "Cepeda",
                        "latitude": "20.50600000",
                        "longitude": "-90.10979000"
                    },
                    {
                        "id": 68942,
                        "name": "Chablekal",
                        "latitude": "21.09647000",
                        "longitude": "-89.57774000"
                    },
                    {
                        "id": 68950,
                        "name": "Chacsinkin",
                        "latitude": "20.17222000",
                        "longitude": "-89.01654000"
                    },
                    {
                        "id": 68972,
                        "name": "Chan Cenote",
                        "latitude": "20.99142000",
                        "longitude": "-87.78564000"
                    },
                    {
                        "id": 68975,
                        "name": "Chankom",
                        "latitude": "20.49656000",
                        "longitude": "-88.56928000"
                    },
                    {
                        "id": 68978,
                        "name": "Chapab",
                        "latitude": "20.48633000",
                        "longitude": "-89.46779000"
                    },
                    {
                        "id": 69005,
                        "name": "Chelem",
                        "latitude": "21.26967000",
                        "longitude": "-89.74006000"
                    },
                    {
                        "id": 69006,
                        "name": "Chemax",
                        "latitude": "20.65613000",
                        "longitude": "-87.93640000"
                    },
                    {
                        "id": 69033,
                        "name": "Chichén-Itzá",
                        "latitude": "20.66667000",
                        "longitude": "-88.56667000"
                    },
                    {
                        "id": 69030,
                        "name": "Chichimila",
                        "latitude": "20.63176000",
                        "longitude": "-88.21689000"
                    },
                    {
                        "id": 69049,
                        "name": "Chicxulub Pueblo",
                        "latitude": "21.14527000",
                        "longitude": "-89.51331000"
                    },
                    {
                        "id": 69050,
                        "name": "Chicxulub Puerto",
                        "latitude": "21.29618000",
                        "longitude": "-89.59867000"
                    },
                    {
                        "id": 69058,
                        "name": "Chikindzonot",
                        "latitude": "20.33436000",
                        "longitude": "-88.48630000"
                    },
                    {
                        "id": 69098,
                        "name": "Chochola",
                        "latitude": "20.75087000",
                        "longitude": "-89.83041000"
                    },
                    {
                        "id": 69101,
                        "name": "Cholul",
                        "latitude": "21.04255000",
                        "longitude": "-89.55875000"
                    },
                    {
                        "id": 69102,
                        "name": "Cholul Cantón",
                        "latitude": "21.01078000",
                        "longitude": "-89.29147000"
                    },
                    {
                        "id": 69109,
                        "name": "Chuburná",
                        "latitude": "21.25778000",
                        "longitude": "-89.79843000"
                    },
                    {
                        "id": 69116,
                        "name": "Chumayel",
                        "latitude": "20.42833000",
                        "longitude": "-89.30111000"
                    },
                    {
                        "id": 69118,
                        "name": "Chunchucmil",
                        "latitude": "20.64303000",
                        "longitude": "-90.21413000"
                    },
                    {
                        "id": 69139,
                        "name": "Citilcum",
                        "latitude": "20.95146000",
                        "longitude": "-89.11805000"
                    },
                    {
                        "id": 69380,
                        "name": "Colonia Yucatán",
                        "latitude": "21.21305000",
                        "longitude": "-87.72416000"
                    },
                    {
                        "id": 69459,
                        "name": "Conkal",
                        "latitude": "21.07365000",
                        "longitude": "-89.51995000"
                    },
                    {
                        "id": 69603,
                        "name": "Cuch Holoch",
                        "latitude": "20.43450000",
                        "longitude": "-90.09694000"
                    },
                    {
                        "id": 69639,
                        "name": "Cuncunul",
                        "latitude": "20.62333000",
                        "longitude": "-88.34637000"
                    },
                    {
                        "id": 69655,
                        "name": "Cuzama",
                        "latitude": "20.74202000",
                        "longitude": "-89.31732000"
                    },
                    {
                        "id": 69733,
                        "name": "Dzan",
                        "latitude": "20.38888000",
                        "longitude": "-89.46855000"
                    },
                    {
                        "id": 69734,
                        "name": "Dzemul",
                        "latitude": "21.21036000",
                        "longitude": "-89.30956000"
                    },
                    {
                        "id": 69736,
                        "name": "Dzibikak",
                        "latitude": "20.90046000",
                        "longitude": "-89.79532000"
                    },
                    {
                        "id": 69737,
                        "name": "Dzidzantun",
                        "latitude": "21.24898000",
                        "longitude": "-89.04205000"
                    },
                    {
                        "id": 69740,
                        "name": "Dzilam de Bravo",
                        "latitude": "21.43361000",
                        "longitude": "-88.66838000"
                    },
                    {
                        "id": 69739,
                        "name": "Dzilam González",
                        "latitude": "21.28098000",
                        "longitude": "-88.92957000"
                    },
                    {
                        "id": 69744,
                        "name": "Dzitás",
                        "latitude": "20.84089000",
                        "longitude": "-88.52908000"
                    },
                    {
                        "id": 69742,
                        "name": "Dzitnup",
                        "latitude": "20.64725000",
                        "longitude": "-88.24453000"
                    },
                    {
                        "id": 69743,
                        "name": "Dzityá",
                        "latitude": "21.05186000",
                        "longitude": "-89.67851000"
                    },
                    {
                        "id": 69746,
                        "name": "Dzoncauich",
                        "latitude": "21.09826000",
                        "longitude": "-88.85402000"
                    },
                    {
                        "id": 69747,
                        "name": "Dzonot Carretero",
                        "latitude": "21.40084000",
                        "longitude": "-87.87860000"
                    },
                    {
                        "id": 69749,
                        "name": "Dzununcan",
                        "latitude": "20.86469000",
                        "longitude": "-89.65380000"
                    },
                    {
                        "id": 69820,
                        "name": "Ekmul",
                        "latitude": "20.96460000",
                        "longitude": "-89.35004000"
                    },
                    {
                        "id": 69821,
                        "name": "Ekpedz",
                        "latitude": "20.31647000",
                        "longitude": "-88.43064000"
                    },
                    {
                        "id": 69939,
                        "name": "El Cuyo",
                        "latitude": "21.51568000",
                        "longitude": "-87.67878000"
                    },
                    {
                        "id": 70280,
                        "name": "Emiliano Zapata",
                        "latitude": "20.22605000",
                        "longitude": "-89.46813000"
                    },
                    {
                        "id": 70331,
                        "name": "Espita",
                        "latitude": "21.01098000",
                        "longitude": "-88.30681000"
                    },
                    {
                        "id": 70378,
                        "name": "Euan",
                        "latitude": "20.99660000",
                        "longitude": "-89.34248000"
                    },
                    {
                        "id": 70661,
                        "name": "Halachó",
                        "latitude": "20.47770000",
                        "longitude": "-90.08104000"
                    },
                    {
                        "id": 70699,
                        "name": "Hocaba",
                        "latitude": "20.81620000",
                        "longitude": "-89.24626000"
                    },
                    {
                        "id": 70701,
                        "name": "Hoctun",
                        "latitude": "20.86513000",
                        "longitude": "-89.20125000"
                    },
                    {
                        "id": 70703,
                        "name": "Holca",
                        "latitude": "20.75647000",
                        "longitude": "-88.92916000"
                    },
                    {
                        "id": 70704,
                        "name": "Homun",
                        "latitude": "20.73918000",
                        "longitude": "-89.28490000"
                    },
                    {
                        "id": 70786,
                        "name": "Huhi",
                        "latitude": "20.72603000",
                        "longitude": "-89.16072000"
                    },
                    {
                        "id": 70823,
                        "name": "Hunucmá",
                        "latitude": "21.01723000",
                        "longitude": "-89.87551000"
                    },
                    {
                        "id": 70824,
                        "name": "Hunuku",
                        "latitude": "20.85230000",
                        "longitude": "-88.08946000"
                    },
                    {
                        "id": 70895,
                        "name": "Itzincab Palomeque",
                        "latitude": "20.91644000",
                        "longitude": "-89.69823000"
                    },
                    {
                        "id": 70917,
                        "name": "Ixil",
                        "latitude": "21.15235000",
                        "longitude": "-89.48182000"
                    },
                    {
                        "id": 70948,
                        "name": "Izamal",
                        "latitude": "20.93537000",
                        "longitude": "-89.01802000"
                    },
                    {
                        "id": 71150,
                        "name": "Kanasín",
                        "latitude": "20.93482000",
                        "longitude": "-89.55871000"
                    },
                    {
                        "id": 71151,
                        "name": "Kancab",
                        "latitude": "20.19571000",
                        "longitude": "-89.34563000"
                    },
                    {
                        "id": 71153,
                        "name": "Kantunil",
                        "latitude": "20.79645000",
                        "longitude": "-89.03539000"
                    },
                    {
                        "id": 71155,
                        "name": "Kanxoc",
                        "latitude": "20.61555000",
                        "longitude": "-88.09764000"
                    },
                    {
                        "id": 71156,
                        "name": "Kaua",
                        "latitude": "20.62476000",
                        "longitude": "-88.42440000"
                    },
                    {
                        "id": 71160,
                        "name": "Kimbila",
                        "latitude": "20.93403000",
                        "longitude": "-89.12470000"
                    },
                    {
                        "id": 71161,
                        "name": "Kinchil",
                        "latitude": "20.91519000",
                        "longitude": "-89.94825000"
                    },
                    {
                        "id": 71162,
                        "name": "Kini",
                        "latitude": "21.13557000",
                        "longitude": "-89.31691000"
                    },
                    {
                        "id": 71163,
                        "name": "Kinil",
                        "latitude": "20.32379000",
                        "longitude": "-89.13285000"
                    },
                    {
                        "id": 71164,
                        "name": "Kochol",
                        "latitude": "20.61867000",
                        "longitude": "-90.15906000"
                    },
                    {
                        "id": 71165,
                        "name": "Komchén",
                        "latitude": "21.10342000",
                        "longitude": "-89.66242000"
                    },
                    {
                        "id": 71166,
                        "name": "Kopoma",
                        "latitude": "20.64906000",
                        "longitude": "-89.89989000"
                    },
                    {
                        "id": 71590,
                        "name": "Las Coloradas",
                        "latitude": "21.60767000",
                        "longitude": "-87.99045000"
                    },
                    {
                        "id": 71660,
                        "name": "Leona Vicario",
                        "latitude": "20.90944000",
                        "longitude": "-89.60111000"
                    },
                    {
                        "id": 71661,
                        "name": "Lepan",
                        "latitude": "20.71243000",
                        "longitude": "-89.49719000"
                    },
                    {
                        "id": 71673,
                        "name": "Libre Unión",
                        "latitude": "20.70635000",
                        "longitude": "-88.80959000"
                    },
                    {
                        "id": 71705,
                        "name": "Loché",
                        "latitude": "21.38828000",
                        "longitude": "-88.14566000"
                    },
                    {
                        "id": 71950,
                        "name": "Mama",
                        "latitude": "20.47857000",
                        "longitude": "-89.36498000"
                    },
                    {
                        "id": 71956,
                        "name": "Mani",
                        "latitude": "20.38774000",
                        "longitude": "-89.39189000"
                    },
                    {
                        "id": 72026,
                        "name": "Maxcanú",
                        "latitude": "20.58456000",
                        "longitude": "-90.00100000"
                    },
                    {
                        "id": 72032,
                        "name": "Mayapan",
                        "latitude": "20.46839000",
                        "longitude": "-89.21395000"
                    },
                    {
                        "id": 72261,
                        "name": "Mérida",
                        "latitude": "20.97537000",
                        "longitude": "-89.61696000"
                    },
                    {
                        "id": 72174,
                        "name": "Mococha",
                        "latitude": "21.10621000",
                        "longitude": "-89.45217000"
                    },
                    {
                        "id": 72182,
                        "name": "Molas",
                        "latitude": "20.81665000",
                        "longitude": "-89.62998000"
                    },
                    {
                        "id": 72242,
                        "name": "Motul",
                        "latitude": "21.09571000",
                        "longitude": "-89.28332000"
                    },
                    {
                        "id": 72253,
                        "name": "Muna",
                        "latitude": "20.48794000",
                        "longitude": "-89.71387000"
                    },
                    {
                        "id": 72257,
                        "name": "Muxupip",
                        "latitude": "21.04728000",
                        "longitude": "-89.32810000"
                    },
                    {
                        "id": 72269,
                        "name": "Nacuche",
                        "latitude": "20.92466000",
                        "longitude": "-88.29582000"
                    },
                    {
                        "id": 72342,
                        "name": "Nolo",
                        "latitude": "21.00947000",
                        "longitude": "-89.42312000"
                    },
                    {
                        "id": 72511,
                        "name": "Opichen",
                        "latitude": "20.55169000",
                        "longitude": "-89.85714000"
                    },
                    {
                        "id": 72547,
                        "name": "Oxcum",
                        "latitude": "20.94514000",
                        "longitude": "-89.76189000"
                    },
                    {
                        "id": 72551,
                        "name": "Oxkutzcab",
                        "latitude": "20.24086000",
                        "longitude": "-89.44600000"
                    },
                    {
                        "id": 72552,
                        "name": "Oxkutzkab",
                        "latitude": "20.30734000",
                        "longitude": "-89.41809000"
                    },
                    {
                        "id": 72619,
                        "name": "Panabá",
                        "latitude": "21.29598000",
                        "longitude": "-88.26982000"
                    },
                    {
                        "id": 72728,
                        "name": "Pencuyut",
                        "latitude": "20.29408000",
                        "longitude": "-89.28947000"
                    },
                    {
                        "id": 72746,
                        "name": "Peto",
                        "latitude": "20.12776000",
                        "longitude": "-88.92282000"
                    },
                    {
                        "id": 72788,
                        "name": "Piste",
                        "latitude": "20.69972000",
                        "longitude": "-88.58889000"
                    },
                    {
                        "id": 72791,
                        "name": "Pixoy",
                        "latitude": "20.71642000",
                        "longitude": "-88.26431000"
                    },
                    {
                        "id": 72850,
                        "name": "Popola",
                        "latitude": "20.73324000",
                        "longitude": "-88.23744000"
                    },
                    {
                        "id": 72851,
                        "name": "Popolnah",
                        "latitude": "20.99350000",
                        "longitude": "-87.56281000"
                    },
                    {
                        "id": 72908,
                        "name": "Progreso",
                        "latitude": "21.28306000",
                        "longitude": "-89.66123000"
                    },
                    {
                        "id": 73001,
                        "name": "Pustunich",
                        "latitude": "20.36914000",
                        "longitude": "-89.51187000"
                    },
                    {
                        "id": 73037,
                        "name": "Quintana Roo",
                        "latitude": "20.84464000",
                        "longitude": "-88.65081000"
                    },
                    {
                        "id": 73179,
                        "name": "Río Lagartos",
                        "latitude": "21.59670000",
                        "longitude": "-88.15773000"
                    },
                    {
                        "id": 73197,
                        "name": "Sacalum",
                        "latitude": "20.49749000",
                        "longitude": "-89.59035000"
                    },
                    {
                        "id": 73200,
                        "name": "Sahcaba",
                        "latitude": "20.79174000",
                        "longitude": "-89.18138000"
                    },
                    {
                        "id": 73233,
                        "name": "Samahil",
                        "latitude": "20.86433000",
                        "longitude": "-89.91398000"
                    },
                    {
                        "id": 73353,
                        "name": "San Antonio Tedzidz",
                        "latitude": "20.83560000",
                        "longitude": "-89.97575000"
                    },
                    {
                        "id": 73564,
                        "name": "San Francisco Grande",
                        "latitude": "20.70071000",
                        "longitude": "-88.47345000"
                    },
                    {
                        "id": 73797,
                        "name": "San José Tzal",
                        "latitude": "20.82418000",
                        "longitude": "-89.66049000"
                    },
                    {
                        "id": 74324,
                        "name": "San Pedro Chimay",
                        "latitude": "20.86465000",
                        "longitude": "-89.57960000"
                    },
                    {
                        "id": 74423,
                        "name": "San Rafael",
                        "latitude": "20.70323000",
                        "longitude": "-90.15843000"
                    },
                    {
                        "id": 74513,
                        "name": "Sanahcat",
                        "latitude": "20.77587000",
                        "longitude": "-89.21091000"
                    },
                    {
                        "id": 74652,
                        "name": "Santa Elena",
                        "latitude": "20.32890000",
                        "longitude": "-89.64363000"
                    },
                    {
                        "id": 74707,
                        "name": "Santa María Acú",
                        "latitude": "20.54644000",
                        "longitude": "-90.16365000"
                    },
                    {
                        "id": 74994,
                        "name": "Santo Domingo",
                        "latitude": "20.60000000",
                        "longitude": "-90.11667000"
                    },
                    {
                        "id": 75066,
                        "name": "Seyé",
                        "latitude": "20.83568000",
                        "longitude": "-89.37174000"
                    },
                    {
                        "id": 75073,
                        "name": "Sierra Papacal",
                        "latitude": "21.12522000",
                        "longitude": "-89.73018000"
                    },
                    {
                        "id": 75092,
                        "name": "Sinanche",
                        "latitude": "21.22591000",
                        "longitude": "-89.18495000"
                    },
                    {
                        "id": 75097,
                        "name": "Sisal",
                        "latitude": "21.16700000",
                        "longitude": "-90.02532000"
                    },
                    {
                        "id": 75100,
                        "name": "Sitilpech",
                        "latitude": "20.94049000",
                        "longitude": "-88.95677000"
                    },
                    {
                        "id": 75103,
                        "name": "Sitpach",
                        "latitude": "21.02652000",
                        "longitude": "-89.52120000"
                    },
                    {
                        "id": 75128,
                        "name": "Sotuta",
                        "latitude": "20.59678000",
                        "longitude": "-89.00815000"
                    },
                    {
                        "id": 75143,
                        "name": "Sucilá",
                        "latitude": "21.15650000",
                        "longitude": "-88.31405000"
                    },
                    {
                        "id": 75144,
                        "name": "Sucopó",
                        "latitude": "21.16155000",
                        "longitude": "-88.04742000"
                    },
                    {
                        "id": 75145,
                        "name": "Sudzal",
                        "latitude": "20.81427000",
                        "longitude": "-88.90030000"
                    },
                    {
                        "id": 75147,
                        "name": "Suma",
                        "latitude": "21.10591000",
                        "longitude": "-89.15487000"
                    },
                    {
                        "id": 75148,
                        "name": "Suma de Hidalgo",
                        "latitude": "21.08643000",
                        "longitude": "-89.14766000"
                    },
                    {
                        "id": 75168,
                        "name": "Tahdzibichen",
                        "latitude": "20.44916000",
                        "longitude": "-88.83068000"
                    },
                    {
                        "id": 75169,
                        "name": "Tahdziu",
                        "latitude": "20.20508000",
                        "longitude": "-88.94555000"
                    },
                    {
                        "id": 75171,
                        "name": "Tahmek",
                        "latitude": "20.87360000",
                        "longitude": "-89.25473000"
                    },
                    {
                        "id": 75252,
                        "name": "Teabo",
                        "latitude": "20.40059000",
                        "longitude": "-89.28316000"
                    },
                    {
                        "id": 75268,
                        "name": "Tecax",
                        "latitude": "20.20520000",
                        "longitude": "-89.28522000"
                    },
                    {
                        "id": 75273,
                        "name": "Tecoh",
                        "latitude": "20.69640000",
                        "longitude": "-89.45174000"
                    },
                    {
                        "id": 75308,
                        "name": "Tekal de Venegas",
                        "latitude": "21.01487000",
                        "longitude": "-88.94658000"
                    },
                    {
                        "id": 75309,
                        "name": "Tekanto",
                        "latitude": "21.00968000",
                        "longitude": "-89.10723000"
                    },
                    {
                        "id": 75311,
                        "name": "Tekax",
                        "latitude": "20.04039000",
                        "longitude": "-89.26448000"
                    },
                    {
                        "id": 75312,
                        "name": "Tekik de Regil",
                        "latitude": "20.81671000",
                        "longitude": "-89.56144000"
                    },
                    {
                        "id": 75313,
                        "name": "Tekit",
                        "latitude": "20.53465000",
                        "longitude": "-89.33315000"
                    },
                    {
                        "id": 75314,
                        "name": "Tekoh",
                        "latitude": "20.74361000",
                        "longitude": "-89.47406000"
                    },
                    {
                        "id": 75315,
                        "name": "Tekom",
                        "latitude": "20.60303000",
                        "longitude": "-88.26490000"
                    },
                    {
                        "id": 75316,
                        "name": "Telchac Pueblo",
                        "latitude": "21.20312000",
                        "longitude": "-89.26945000"
                    },
                    {
                        "id": 75317,
                        "name": "Telchac Puerto",
                        "latitude": "21.34121000",
                        "longitude": "-89.26333000"
                    },
                    {
                        "id": 75318,
                        "name": "Telchaquillo",
                        "latitude": "20.64693000",
                        "longitude": "-89.46367000"
                    },
                    {
                        "id": 75334,
                        "name": "Temax",
                        "latitude": "21.15105000",
                        "longitude": "-88.94039000"
                    },
                    {
                        "id": 75340,
                        "name": "Temozon",
                        "latitude": "20.80393000",
                        "longitude": "-88.20155000"
                    },
                    {
                        "id": 75389,
                        "name": "Tepakan",
                        "latitude": "21.04882000",
                        "longitude": "-89.03873000"
                    },
                    {
                        "id": 75472,
                        "name": "Tesoco",
                        "latitude": "20.72259000",
                        "longitude": "-88.15456000"
                    },
                    {
                        "id": 75490,
                        "name": "Tetiz",
                        "latitude": "20.96316000",
                        "longitude": "-89.93384000"
                    },
                    {
                        "id": 75499,
                        "name": "Texan de Palomeque",
                        "latitude": "20.93750000",
                        "longitude": "-89.83333000"
                    },
                    {
                        "id": 75522,
                        "name": "Teya",
                        "latitude": "21.05071000",
                        "longitude": "-89.07310000"
                    },
                    {
                        "id": 75539,
                        "name": "Tibolón",
                        "latitude": "20.66541000",
                        "longitude": "-88.93929000"
                    },
                    {
                        "id": 75540,
                        "name": "Ticopó",
                        "latitude": "20.88893000",
                        "longitude": "-89.44107000"
                    },
                    {
                        "id": 75541,
                        "name": "Ticul",
                        "latitude": "20.39833000",
                        "longitude": "-89.53541000"
                    },
                    {
                        "id": 75558,
                        "name": "Tiholop",
                        "latitude": "20.33234000",
                        "longitude": "-88.68958000"
                    },
                    {
                        "id": 75564,
                        "name": "Tikuch",
                        "latitude": "20.70301000",
                        "longitude": "-88.11272000"
                    },
                    {
                        "id": 75572,
                        "name": "Timucuy",
                        "latitude": "20.81023000",
                        "longitude": "-89.51383000"
                    },
                    {
                        "id": 75579,
                        "name": "Tinum",
                        "latitude": "20.70004000",
                        "longitude": "-88.51631000"
                    },
                    {
                        "id": 75584,
                        "name": "Tixcacalcupul",
                        "latitude": "20.43929000",
                        "longitude": "-88.30028000"
                    },
                    {
                        "id": 75585,
                        "name": "Tixcacaltuyub",
                        "latitude": "20.49316000",
                        "longitude": "-88.91637000"
                    },
                    {
                        "id": 75586,
                        "name": "Tixcancal",
                        "latitude": "21.03588000",
                        "longitude": "-87.85047000"
                    },
                    {
                        "id": 75587,
                        "name": "Tixhualactún",
                        "latitude": "20.64403000",
                        "longitude": "-88.14308000"
                    },
                    {
                        "id": 75588,
                        "name": "Tixkokob",
                        "latitude": "21.00220000",
                        "longitude": "-89.39484000"
                    },
                    {
                        "id": 75590,
                        "name": "Tixmehuac",
                        "latitude": "20.24682000",
                        "longitude": "-89.08695000"
                    },
                    {
                        "id": 75591,
                        "name": "Tixpehual",
                        "latitude": "20.97739000",
                        "longitude": "-89.44203000"
                    },
                    {
                        "id": 75596,
                        "name": "Tizimín",
                        "latitude": "21.14268000",
                        "longitude": "-88.15101000"
                    },
                    {
                        "id": 75810,
                        "name": "Tunkas",
                        "latitude": "20.90294000",
                        "longitude": "-88.75171000"
                    },
                    {
                        "id": 75854,
                        "name": "Tzucacab",
                        "latitude": "20.07237000",
                        "longitude": "-89.05022000"
                    },
                    {
                        "id": 75858,
                        "name": "Uayalceh de Peón",
                        "latitude": "20.69345000",
                        "longitude": "-89.59483000"
                    },
                    {
                        "id": 75859,
                        "name": "Uayma",
                        "latitude": "20.71781000",
                        "longitude": "-88.31693000"
                    },
                    {
                        "id": 75862,
                        "name": "Uci",
                        "latitude": "21.12682000",
                        "longitude": "-89.26827000"
                    },
                    {
                        "id": 75864,
                        "name": "Ucú",
                        "latitude": "21.03135000",
                        "longitude": "-89.74466000"
                    },
                    {
                        "id": 75866,
                        "name": "Uman",
                        "latitude": "20.88213000",
                        "longitude": "-89.74649000"
                    },
                    {
                        "id": 75912,
                        "name": "Valladolid",
                        "latitude": "20.68812000",
                        "longitude": "-88.19936000"
                    },
                    {
                        "id": 76106,
                        "name": "X-Cán",
                        "latitude": "20.85715000",
                        "longitude": "-87.66915000"
                    },
                    {
                        "id": 76127,
                        "name": "Xanabá",
                        "latitude": "20.83611000",
                        "longitude": "-89.01372000"
                    },
                    {
                        "id": 76128,
                        "name": "Xaya",
                        "latitude": "20.29653000",
                        "longitude": "-89.18674000"
                    },
                    {
                        "id": 76131,
                        "name": "Xcanatún",
                        "latitude": "21.07664000",
                        "longitude": "-89.63028000"
                    },
                    {
                        "id": 76153,
                        "name": "Xocchel",
                        "latitude": "20.83341000",
                        "longitude": "-89.18322000"
                    },
                    {
                        "id": 76154,
                        "name": "Xocen",
                        "latitude": "20.59770000",
                        "longitude": "-88.16430000"
                    },
                    {
                        "id": 76189,
                        "name": "Xohuayan",
                        "latitude": "20.18805000",
                        "longitude": "-89.38319000"
                    },
                    {
                        "id": 76206,
                        "name": "Xul",
                        "latitude": "20.10128000",
                        "longitude": "-89.46274000"
                    },
                    {
                        "id": 76213,
                        "name": "Yalkoba",
                        "latitude": "20.79167000",
                        "longitude": "-88.03673000"
                    },
                    {
                        "id": 76223,
                        "name": "Yaxcabá",
                        "latitude": "20.54846000",
                        "longitude": "-88.82714000"
                    },
                    {
                        "id": 76224,
                        "name": "Yaxcopoil",
                        "latitude": "20.74498000",
                        "longitude": "-89.72217000"
                    },
                    {
                        "id": 76226,
                        "name": "Yaxhachen",
                        "latitude": "20.05177000",
                        "longitude": "-89.56604000"
                    },
                    {
                        "id": 76227,
                        "name": "Yaxkukul",
                        "latitude": "21.06139000",
                        "longitude": "-89.41932000"
                    },
                    {
                        "id": 76239,
                        "name": "Yobain",
                        "latitude": "21.23435000",
                        "longitude": "-89.11488000"
                    },
                    {
                        "id": 76246,
                        "name": "Yotholin",
                        "latitude": "20.32786000",
                        "longitude": "-89.45429000"
                    }
                ]
            },
            {
                "id": 3462,
                "name": "Zacatecas",
                "iso2": "ZAC",
                "latitude": "22.77085550",
                "longitude": "-102.58324260",
                "type": "state",
                "cities": [
                    {
                        "id": 68113,
                        "name": "Agua Gorda",
                        "latitude": "22.10669000",
                        "longitude": "-101.92182000"
                    },
                    {
                        "id": 68222,
                        "name": "Altamira",
                        "latitude": "23.38173000",
                        "longitude": "-102.98674000"
                    },
                    {
                        "id": 68313,
                        "name": "Apozol",
                        "latitude": "21.46952000",
                        "longitude": "-103.09076000"
                    },
                    {
                        "id": 68425,
                        "name": "Atolinga",
                        "latitude": "21.80659000",
                        "longitude": "-103.46496000"
                    },
                    {
                        "id": 68506,
                        "name": "Bajío de San Nicolás",
                        "latitude": "22.56499000",
                        "longitude": "-102.00784000"
                    },
                    {
                        "id": 68684,
                        "name": "Buenavista de Trujillo",
                        "latitude": "23.15200000",
                        "longitude": "-103.18767000"
                    },
                    {
                        "id": 68882,
                        "name": "Cañas",
                        "latitude": "23.74366000",
                        "longitude": "-103.24400000"
                    },
                    {
                        "id": 68883,
                        "name": "Cañitas de Felipe Pescador",
                        "latitude": "23.60371000",
                        "longitude": "-102.72704000"
                    },
                    {
                        "id": 68798,
                        "name": "Cantuna",
                        "latitude": "23.62460000",
                        "longitude": "-103.34630000"
                    },
                    {
                        "id": 68836,
                        "name": "Carrillo",
                        "latitude": "23.20400000",
                        "longitude": "-102.98676000"
                    },
                    {
                        "id": 68850,
                        "name": "Casa de Cerros",
                        "latitude": "22.88499000",
                        "longitude": "-102.52124000"
                    },
                    {
                        "id": 68888,
                        "name": "Cedros",
                        "latitude": "24.67919000",
                        "longitude": "-101.77387000"
                    },
                    {
                        "id": 68913,
                        "name": "Cerrito de la Cruz",
                        "latitude": "22.65781000",
                        "longitude": "-102.27263000"
                    },
                    {
                        "id": 68959,
                        "name": "Chalchihuites",
                        "latitude": "23.47498000",
                        "longitude": "-103.88293000"
                    },
                    {
                        "id": 68983,
                        "name": "Chaparrosa",
                        "latitude": "23.08339000",
                        "longitude": "-102.27728000"
                    },
                    {
                        "id": 68996,
                        "name": "Charco Blanco",
                        "latitude": "23.86306000",
                        "longitude": "-103.65750000"
                    },
                    {
                        "id": 69027,
                        "name": "Chichimequillas",
                        "latitude": "23.23894000",
                        "longitude": "-102.57850000"
                    },
                    {
                        "id": 69121,
                        "name": "Chupaderos",
                        "latitude": "23.15883000",
                        "longitude": "-102.32535000"
                    },
                    {
                        "id": 69127,
                        "name": "Cicacalco",
                        "latitude": "21.71575000",
                        "longitude": "-103.31286000"
                    },
                    {
                        "id": 69130,
                        "name": "Cieneguillas",
                        "latitude": "22.75698000",
                        "longitude": "-102.66267000"
                    },
                    {
                        "id": 69132,
                        "name": "Cieneguitas",
                        "latitude": "22.71363000",
                        "longitude": "-102.49317000"
                    },
                    {
                        "id": 69299,
                        "name": "Colonia Felipe Ángeles",
                        "latitude": "22.54872000",
                        "longitude": "-102.79243000"
                    },
                    {
                        "id": 69303,
                        "name": "Colonia Francisco García Salinas",
                        "latitude": "23.81084000",
                        "longitude": "-103.18180000"
                    },
                    {
                        "id": 69311,
                        "name": "Colonia Hidalgo (El Tecolote)",
                        "latitude": "22.32972000",
                        "longitude": "-102.03583000"
                    },
                    {
                        "id": 69316,
                        "name": "Colonia José María Morelos",
                        "latitude": "22.36794000",
                        "longitude": "-101.79449000"
                    },
                    {
                        "id": 69331,
                        "name": "Colonia Montemariana (Colonia Mariana)",
                        "latitude": "23.32639000",
                        "longitude": "-103.11222000"
                    },
                    {
                        "id": 69351,
                        "name": "Colonia Plenitud",
                        "latitude": "23.23250000",
                        "longitude": "-103.07500000"
                    },
                    {
                        "id": 69362,
                        "name": "Colonia San Francisco (San Francisco)",
                        "latitude": "22.30361000",
                        "longitude": "-101.82056000"
                    },
                    {
                        "id": 69441,
                        "name": "Concepción del Oro",
                        "latitude": "24.61326000",
                        "longitude": "-101.41844000"
                    },
                    {
                        "id": 69537,
                        "name": "Crisóstomos",
                        "latitude": "22.22961000",
                        "longitude": "-101.99615000"
                    },
                    {
                        "id": 69767,
                        "name": "Ejido Hidalgo",
                        "latitude": "22.30083000",
                        "longitude": "-102.03861000"
                    },
                    {
                        "id": 69801,
                        "name": "Ejido Zaragoza",
                        "latitude": "23.94786000",
                        "longitude": "-103.66322000"
                    },
                    {
                        "id": 69890,
                        "name": "El Cazadero",
                        "latitude": "23.67250000",
                        "longitude": "-103.12220000"
                    },
                    {
                        "id": 69926,
                        "name": "El Copetillo",
                        "latitude": "22.14333000",
                        "longitude": "-102.00139000"
                    },
                    {
                        "id": 69971,
                        "name": "El Fuerte",
                        "latitude": "23.85414000",
                        "longitude": "-103.12207000"
                    },
                    {
                        "id": 70009,
                        "name": "El Lampotal",
                        "latitude": "22.89583000",
                        "longitude": "-102.41944000"
                    },
                    {
                        "id": 70061,
                        "name": "El Nigromante",
                        "latitude": "22.15373000",
                        "longitude": "-101.71056000"
                    },
                    {
                        "id": 70068,
                        "name": "El Obraje",
                        "latitude": "22.18059000",
                        "longitude": "-101.59057000"
                    },
                    {
                        "id": 70111,
                        "name": "El Plateado de Joaquín Amaro",
                        "latitude": "21.93622000",
                        "longitude": "-103.09267000"
                    },
                    {
                        "id": 70152,
                        "name": "El Refugio",
                        "latitude": "22.37028000",
                        "longitude": "-101.76083000"
                    },
                    {
                        "id": 70179,
                        "name": "El Rucio",
                        "latitude": "23.40743000",
                        "longitude": "-102.08194000"
                    },
                    {
                        "id": 70191,
                        "name": "El Salto",
                        "latitude": "23.19556000",
                        "longitude": "-103.06750000"
                    },
                    {
                        "id": 70194,
                        "name": "El Salvador",
                        "latitude": "24.52093000",
                        "longitude": "-100.86631000"
                    },
                    {
                        "id": 70199,
                        "name": "El Saucito (El Horno)",
                        "latitude": "22.73111000",
                        "longitude": "-102.09528000"
                    },
                    {
                        "id": 70207,
                        "name": "El Sitio",
                        "latitude": "21.96418000",
                        "longitude": "-101.58832000"
                    },
                    {
                        "id": 70241,
                        "name": "El Tule",
                        "latitude": "22.64128000",
                        "longitude": "-102.03830000"
                    },
                    {
                        "id": 70282,
                        "name": "Emiliano Zapata",
                        "latitude": "23.71873000",
                        "longitude": "-103.19220000"
                    },
                    {
                        "id": 70294,
                        "name": "Emilio Carranza",
                        "latitude": "24.10390000",
                        "longitude": "-103.66746000"
                    },
                    {
                        "id": 70313,
                        "name": "Ermita de Guadalupe",
                        "latitude": "22.58579000",
                        "longitude": "-103.03133000"
                    },
                    {
                        "id": 70334,
                        "name": "Estación Camacho",
                        "latitude": "24.44038000",
                        "longitude": "-102.37283000"
                    },
                    {
                        "id": 70353,
                        "name": "Estación San José",
                        "latitude": "23.18972000",
                        "longitude": "-102.78472000"
                    },
                    {
                        "id": 70363,
                        "name": "Estancia de Ánimas",
                        "latitude": "22.48795000",
                        "longitude": "-101.99526000"
                    },
                    {
                        "id": 70362,
                        "name": "Estancia de Guadalupe",
                        "latitude": "22.28063000",
                        "longitude": "-101.65745000"
                    },
                    {
                        "id": 70406,
                        "name": "Florencia",
                        "latitude": "21.50392000",
                        "longitude": "-103.55353000"
                    },
                    {
                        "id": 70488,
                        "name": "Fresnillo",
                        "latitude": "23.18126000",
                        "longitude": "-102.87136000"
                    },
                    {
                        "id": 70530,
                        "name": "General Enrique Estrada",
                        "latitude": "22.99747000",
                        "longitude": "-102.74255000"
                    },
                    {
                        "id": 70537,
                        "name": "General Juan José Ríos",
                        "latitude": "24.32549000",
                        "longitude": "-103.40575000"
                    },
                    {
                        "id": 70538,
                        "name": "General Lauro G. Caloca (El Rascón)",
                        "latitude": "22.37806000",
                        "longitude": "-102.05750000"
                    },
                    {
                        "id": 70545,
                        "name": "General Pánfilo Natera",
                        "latitude": "22.66461000",
                        "longitude": "-102.11007000"
                    },
                    {
                        "id": 70554,
                        "name": "Gonzales Ortega",
                        "latitude": "23.18056000",
                        "longitude": "-102.47589000"
                    },
                    {
                        "id": 70562,
                        "name": "Granadas",
                        "latitude": "22.10083000",
                        "longitude": "-101.86332000"
                    },
                    {
                        "id": 70572,
                        "name": "Guadalupe",
                        "latitude": "22.74753000",
                        "longitude": "-102.51874000"
                    },
                    {
                        "id": 70617,
                        "name": "Guanajuatillo",
                        "latitude": "22.71649000",
                        "longitude": "-102.14330000"
                    },
                    {
                        "id": 70652,
                        "name": "Hacienda Nueva",
                        "latitude": "22.82461000",
                        "longitude": "-102.60836000"
                    },
                    {
                        "id": 70656,
                        "name": "Hacienda Toribio",
                        "latitude": "23.08333000",
                        "longitude": "-102.68333000"
                    },
                    {
                        "id": 70685,
                        "name": "Hidalgo",
                        "latitude": "23.97833000",
                        "longitude": "-103.66034000"
                    },
                    {
                        "id": 70850,
                        "name": "Ignacio Zaragoza",
                        "latitude": "23.94342000",
                        "longitude": "-103.41693000"
                    },
                    {
                        "id": 70955,
                        "name": "J. Jesús González Ortega (San Mateo)",
                        "latitude": "22.88722000",
                        "longitude": "-103.48528000"
                    },
                    {
                        "id": 70976,
                        "name": "Jalpa",
                        "latitude": "21.63448000",
                        "longitude": "-102.97919000"
                    },
                    {
                        "id": 71011,
                        "name": "Jaula de Abajo",
                        "latitude": "22.02824000",
                        "longitude": "-101.59193000"
                    },
                    {
                        "id": 71018,
                        "name": "Jerez de García Salinas",
                        "latitude": "22.64971000",
                        "longitude": "-102.99032000"
                    },
                    {
                        "id": 71053,
                        "name": "Jiménez del Teul",
                        "latitude": "23.25378000",
                        "longitude": "-103.79855000"
                    },
                    {
                        "id": 71101,
                        "name": "José María Morelos",
                        "latitude": "23.32278000",
                        "longitude": "-103.01444000"
                    },
                    {
                        "id": 71104,
                        "name": "José María Morelos (Santa Mónica)",
                        "latitude": "23.60556000",
                        "longitude": "-103.11028000"
                    },
                    {
                        "id": 71106,
                        "name": "José María Morelos y Pavón",
                        "latitude": "23.86288000",
                        "longitude": "-103.14193000"
                    },
                    {
                        "id": 71113,
                        "name": "Juan Aldama",
                        "latitude": "24.29188000",
                        "longitude": "-103.39272000"
                    },
                    {
                        "id": 71130,
                        "name": "Juchipila",
                        "latitude": "21.40862000",
                        "longitude": "-103.11663000"
                    },
                    {
                        "id": 71180,
                        "name": "La Ballena",
                        "latitude": "22.45572000",
                        "longitude": "-101.70809000"
                    },
                    {
                        "id": 71202,
                        "name": "La Capilla",
                        "latitude": "22.68642000",
                        "longitude": "-102.23750000"
                    },
                    {
                        "id": 71231,
                        "name": "La Concepción",
                        "latitude": "22.51574000",
                        "longitude": "-102.26604000"
                    },
                    {
                        "id": 71294,
                        "name": "La Florida",
                        "latitude": "23.80474000",
                        "longitude": "-103.07648000"
                    },
                    {
                        "id": 71345,
                        "name": "La Laguna",
                        "latitude": "24.21351000",
                        "longitude": "-103.18280000"
                    },
                    {
                        "id": 71372,
                        "name": "La Luz",
                        "latitude": "22.88000000",
                        "longitude": "-102.31028000"
                    },
                    {
                        "id": 71439,
                        "name": "La Pendencia",
                        "latitude": "22.43780000",
                        "longitude": "-101.57606000"
                    },
                    {
                        "id": 71501,
                        "name": "La Tesorera",
                        "latitude": "22.69707000",
                        "longitude": "-102.11670000"
                    },
                    {
                        "id": 71533,
                        "name": "La Victoria",
                        "latitude": "22.25701000",
                        "longitude": "-101.62957000"
                    },
                    {
                        "id": 71538,
                        "name": "La Zacatecana",
                        "latitude": "22.73053000",
                        "longitude": "-102.47462000"
                    },
                    {
                        "id": 71550,
                        "name": "Laguna Seca",
                        "latitude": "23.06180000",
                        "longitude": "-102.49558000"
                    },
                    {
                        "id": 71582,
                        "name": "Las Catarinas",
                        "latitude": "23.09115000",
                        "longitude": "-102.61597000"
                    },
                    {
                        "id": 71598,
                        "name": "Las Esperanzas (El Ranchito)",
                        "latitude": "23.84972000",
                        "longitude": "-103.13111000"
                    },
                    {
                        "id": 71632,
                        "name": "Las Pilas",
                        "latitude": "22.84000000",
                        "longitude": "-102.61278000"
                    },
                    {
                        "id": 71899,
                        "name": "Lázaro Cárdenas (Rancho Grande)",
                        "latitude": "23.45056000",
                        "longitude": "-102.96250000"
                    },
                    {
                        "id": 71704,
                        "name": "Lobatos",
                        "latitude": "22.82280000",
                        "longitude": "-103.40580000"
                    },
                    {
                        "id": 71763,
                        "name": "Loreto",
                        "latitude": "22.27248000",
                        "longitude": "-101.98898000"
                    },
                    {
                        "id": 71791,
                        "name": "Los Condes",
                        "latitude": "23.83889000",
                        "longitude": "-103.07861000"
                    },
                    {
                        "id": 71840,
                        "name": "Los Ramírez",
                        "latitude": "23.84505000",
                        "longitude": "-103.03447000"
                    },
                    {
                        "id": 71882,
                        "name": "Luis Moya",
                        "latitude": "22.43237000",
                        "longitude": "-102.24864000"
                    },
                    {
                        "id": 71947,
                        "name": "Malpaso",
                        "latitude": "22.62627000",
                        "longitude": "-102.76194000"
                    },
                    {
                        "id": 71983,
                        "name": "Maravillas",
                        "latitude": "22.39988000",
                        "longitude": "-102.01676000"
                    },
                    {
                        "id": 72003,
                        "name": "Martínez Domínguez",
                        "latitude": "22.74806000",
                        "longitude": "-102.48111000"
                    },
                    {
                        "id": 72039,
                        "name": "Mazapil",
                        "latitude": "24.63867000",
                        "longitude": "-101.55455000"
                    },
                    {
                        "id": 72108,
                        "name": "Mezquital del Oro",
                        "latitude": "21.21667000",
                        "longitude": "-103.36278000"
                    },
                    {
                        "id": 72125,
                        "name": "Miguel Auza",
                        "latitude": "24.29421000",
                        "longitude": "-103.45090000"
                    },
                    {
                        "id": 72137,
                        "name": "Milagros",
                        "latitude": "22.49986000",
                        "longitude": "-102.18365000"
                    },
                    {
                        "id": 72189,
                        "name": "Momax",
                        "latitude": "21.92260000",
                        "longitude": "-103.31307000"
                    },
                    {
                        "id": 72199,
                        "name": "Monte Escobedo",
                        "latitude": "22.30362000",
                        "longitude": "-103.56751000"
                    },
                    {
                        "id": 72230,
                        "name": "Morelos",
                        "latitude": "22.86215000",
                        "longitude": "-102.61061000"
                    },
                    {
                        "id": 72244,
                        "name": "Moyahua de Estrada",
                        "latitude": "21.26658000",
                        "longitude": "-103.16610000"
                    },
                    {
                        "id": 72330,
                        "name": "Nieves",
                        "latitude": "23.99609000",
                        "longitude": "-103.02013000"
                    },
                    {
                        "id": 72337,
                        "name": "Nochistlán de Mejía",
                        "latitude": "21.36435000",
                        "longitude": "-102.84590000"
                    },
                    {
                        "id": 72352,
                        "name": "Noria de Ángeles",
                        "latitude": "22.44321000",
                        "longitude": "-101.90846000"
                    },
                    {
                        "id": 72481,
                        "name": "Ojitos",
                        "latitude": "24.30969000",
                        "longitude": "-103.34610000"
                    },
                    {
                        "id": 72689,
                        "name": "Paso de Méndez",
                        "latitude": "22.51588000",
                        "longitude": "-102.46956000"
                    },
                    {
                        "id": 72699,
                        "name": "Pastelera",
                        "latitude": "23.74420000",
                        "longitude": "-103.09700000"
                    },
                    {
                        "id": 72703,
                        "name": "Pastoría",
                        "latitude": "22.48615000",
                        "longitude": "-102.08184000"
                    },
                    {
                        "id": 72722,
                        "name": "Pedregoso",
                        "latitude": "22.25274000",
                        "longitude": "-101.75757000"
                    },
                    {
                        "id": 72765,
                        "name": "Piedra Gorda",
                        "latitude": "22.50759000",
                        "longitude": "-102.33187000"
                    },
                    {
                        "id": 72780,
                        "name": "Pinos",
                        "latitude": "22.29571000",
                        "longitude": "-101.57579000"
                    },
                    {
                        "id": 72807,
                        "name": "Plateros",
                        "latitude": "23.22922000",
                        "longitude": "-102.84290000"
                    },
                    {
                        "id": 72873,
                        "name": "Pozo de Jarillas",
                        "latitude": "22.65279000",
                        "longitude": "-102.19782000"
                    },
                    {
                        "id": 72875,
                        "name": "Pozos de Gamboa",
                        "latitude": "22.94861000",
                        "longitude": "-102.57010000"
                    },
                    {
                        "id": 73048,
                        "name": "Rafael Yáñez Sosa (El Mezquite)",
                        "latitude": "23.32833000",
                        "longitude": "-102.61028000"
                    },
                    {
                        "id": 73063,
                        "name": "Rancho Nuevo",
                        "latitude": "22.40783000",
                        "longitude": "-102.34863000"
                    },
                    {
                        "id": 73067,
                        "name": "Rancho Nuevo de Morelos (De Guadalupe)",
                        "latitude": "22.34056000",
                        "longitude": "-101.78528000"
                    },
                    {
                        "id": 73139,
                        "name": "Rio de Medina",
                        "latitude": "23.50260000",
                        "longitude": "-103.01791000"
                    },
                    {
                        "id": 73173,
                        "name": "Río Florido",
                        "latitude": "23.34464000",
                        "longitude": "-102.99039000"
                    },
                    {
                        "id": 73176,
                        "name": "Río Grande",
                        "latitude": "23.82647000",
                        "longitude": "-103.03034000"
                    },
                    {
                        "id": 73205,
                        "name": "Sain Alto",
                        "latitude": "23.58086000",
                        "longitude": "-103.24807000"
                    },
                    {
                        "id": 73206,
                        "name": "Sain Bajo",
                        "latitude": "23.61627000",
                        "longitude": "-103.17447000"
                    },
                    {
                        "id": 73378,
                        "name": "San Antonio del Cipres",
                        "latitude": "22.93857000",
                        "longitude": "-102.48710000"
                    },
                    {
                        "id": 73446,
                        "name": "San Blas",
                        "latitude": "22.29899000",
                        "longitude": "-101.95497000"
                    },
                    {
                        "id": 73473,
                        "name": "San Cristóbal",
                        "latitude": "22.59085000",
                        "longitude": "-102.23390000"
                    },
                    {
                        "id": 73699,
                        "name": "San Jerónimo",
                        "latitude": "22.65402000",
                        "longitude": "-102.49182000"
                    },
                    {
                        "id": 73812,
                        "name": "San José de Castellanos",
                        "latitude": "22.10930000",
                        "longitude": "-101.55091000"
                    },
                    {
                        "id": 73829,
                        "name": "San José de la Era",
                        "latitude": "22.85073000",
                        "longitude": "-102.42239000"
                    },
                    {
                        "id": 73735,
                        "name": "San Jose de Lourdes",
                        "latitude": "23.27645000",
                        "longitude": "-103.00973000"
                    },
                    {
                        "id": 73851,
                        "name": "San José el Saladillo (El Saladillo)",
                        "latitude": "22.68500000",
                        "longitude": "-102.03778000"
                    },
                    {
                        "id": 74066,
                        "name": "San Marcos",
                        "latitude": "22.27744000",
                        "longitude": "-101.95196000"
                    },
                    {
                        "id": 74082,
                        "name": "San Martin",
                        "latitude": "23.67117000",
                        "longitude": "-103.75007000"
                    },
                    {
                        "id": 74279,
                        "name": "San Pablo",
                        "latitude": "22.55937000",
                        "longitude": "-102.09990000"
                    },
                    {
                        "id": 74367,
                        "name": "San Pedro Piedra Gorda",
                        "latitude": "22.44753000",
                        "longitude": "-102.34875000"
                    },
                    {
                        "id": 74520,
                        "name": "Santa Ana",
                        "latitude": "22.39194000",
                        "longitude": "-101.47401000"
                    },
                    {
                        "id": 74654,
                        "name": "Santa Elena",
                        "latitude": "22.59240000",
                        "longitude": "-102.07141000"
                    },
                    {
                        "id": 74808,
                        "name": "Santa María de los Ángeles",
                        "latitude": "22.28383000",
                        "longitude": "-101.86508000"
                    },
                    {
                        "id": 74826,
                        "name": "Santa Mónica",
                        "latitude": "22.75480000",
                        "longitude": "-102.42220000"
                    },
                    {
                        "id": 74832,
                        "name": "Santa Rita",
                        "latitude": "22.91194000",
                        "longitude": "-102.41833000"
                    },
                    {
                        "id": 74867,
                        "name": "Santiago",
                        "latitude": "22.45477000",
                        "longitude": "-101.45898000"
                    },
                    {
                        "id": 74990,
                        "name": "Santiaguillo",
                        "latitude": "23.14718000",
                        "longitude": "-102.65240000"
                    },
                    {
                        "id": 75043,
                        "name": "Sauceda de La Borda",
                        "latitude": "22.83035000",
                        "longitude": "-102.50264000"
                    },
                    {
                        "id": 75055,
                        "name": "Seis de Enero",
                        "latitude": "23.36856000",
                        "longitude": "-103.07468000"
                    },
                    {
                        "id": 75151,
                        "name": "Susticacán",
                        "latitude": "22.60937000",
                        "longitude": "-103.09671000"
                    },
                    {
                        "id": 75156,
                        "name": "Tabasco",
                        "latitude": "21.86286000",
                        "longitude": "-102.91105000"
                    },
                    {
                        "id": 75158,
                        "name": "Tacoaleche",
                        "latitude": "22.82010000",
                        "longitude": "-102.40476000"
                    },
                    {
                        "id": 75225,
                        "name": "Tapias de Santa Cruz (Pedro Ruiz González)",
                        "latitude": "23.18889000",
                        "longitude": "-103.13111000"
                    },
                    {
                        "id": 75248,
                        "name": "Tayahua",
                        "latitude": "22.09355000",
                        "longitude": "-102.87195000"
                    },
                    {
                        "id": 75406,
                        "name": "Tepechitlán",
                        "latitude": "21.67063000",
                        "longitude": "-103.32640000"
                    },
                    {
                        "id": 75430,
                        "name": "Tepetongo",
                        "latitude": "22.45847000",
                        "longitude": "-103.15120000"
                    },
                    {
                        "id": 75468,
                        "name": "Terminal de Providencia",
                        "latitude": "24.69254000",
                        "longitude": "-101.46575000"
                    },
                    {
                        "id": 75486,
                        "name": "Tetillas",
                        "latitude": "23.71464000",
                        "longitude": "-102.90844000"
                    },
                    {
                        "id": 75534,
                        "name": "Teúl de González Ortega",
                        "latitude": "21.46340000",
                        "longitude": "-103.46131000"
                    },
                    {
                        "id": 75545,
                        "name": "Tierra Blanca",
                        "latitude": "22.34796000",
                        "longitude": "-102.06536000"
                    },
                    {
                        "id": 75599,
                        "name": "Tlachichila",
                        "latitude": "21.55745000",
                        "longitude": "-102.78613000"
                    },
                    {
                        "id": 75654,
                        "name": "Tlaltenango de Sánchez Román",
                        "latitude": "21.78221000",
                        "longitude": "-103.30298000"
                    },
                    {
                        "id": 75764,
                        "name": "Trancoso",
                        "latitude": "22.73542000",
                        "longitude": "-102.36697000"
                    },
                    {
                        "id": 75781,
                        "name": "Trinidad García de la Cadena",
                        "latitude": "21.21035000",
                        "longitude": "-103.46532000"
                    },
                    {
                        "id": 75933,
                        "name": "Valparaíso",
                        "latitude": "22.77104000",
                        "longitude": "-103.56991000"
                    },
                    {
                        "id": 76104,
                        "name": "Víctor Rosales",
                        "latitude": "22.94889000",
                        "longitude": "-102.70222000"
                    },
                    {
                        "id": 76061,
                        "name": "Villa de Cos",
                        "latitude": "23.29329000",
                        "longitude": "-102.35020000"
                    },
                    {
                        "id": 76002,
                        "name": "Villa García",
                        "latitude": "22.16169000",
                        "longitude": "-101.95556000"
                    },
                    {
                        "id": 76003,
                        "name": "Villa González Ortega",
                        "latitude": "22.51222000",
                        "longitude": "-101.91616000"
                    },
                    {
                        "id": 76012,
                        "name": "Villa Hidalgo",
                        "latitude": "22.35682000",
                        "longitude": "-101.71259000"
                    },
                    {
                        "id": 76018,
                        "name": "Villa Insurgentes (El Calabazal)",
                        "latitude": "23.74306000",
                        "longitude": "-103.84250000"
                    },
                    {
                        "id": 76085,
                        "name": "Villanueva",
                        "latitude": "22.35527000",
                        "longitude": "-102.88264000"
                    },
                    {
                        "id": 76272,
                        "name": "Zacatecas",
                        "latitude": "22.76843000",
                        "longitude": "-102.58141000"
                    },
                    {
                        "id": 76370,
                        "name": "Zoquite",
                        "latitude": "22.78533000",
                        "longitude": "-102.42248000"
                    }
                ]
            }
        ]
    },
    {
        "id": 143,
        "name": "Micronesia",
        "iso3": "FSM",
        "iso2": "FM",
        "numeric_code": "583",
        "phonecode": "691",
        "capital": "Palikir",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".fm",
        "native": "Micronesia",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Micronesia",
        "subregion_id": 21,
        "nationality": "Micronesian",
        "timezones": [
            {
                "zoneName": "Pacific\/Chuuk",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "CHUT",
                "tzName": "Chuuk Time"
            },
            {
                "zoneName": "Pacific\/Kosrae",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "KOST",
                "tzName": "Kosrae Time"
            },
            {
                "zoneName": "Pacific\/Pohnpei",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "PONT",
                "tzName": "Pohnpei Standard Time"
            }
        ],
        "translations": {
            "br": "Mikronezia",
            "ko": "미크로네시아 연방",
            "pt-BR": "Micronésia",
            "pt": "Micronésia",
            "nl": "Micronesië",
            "hr": "Mikronezija",
            "fa": "ایالات فدرال میکرونزی",
            "de": "Mikronesien",
            "es": "Micronesia",
            "fr": "Micronésie",
            "ja": "ミクロネシア連邦",
            "it": "Micronesia",
            "zh-CN": "密克罗尼西亚",
            "tr": "Mikronezya",
            "ru": "Микронезия",
            "uk": "Мікронезія",
            "pl": "Mikronezja"
        },
        "latitude": "6.91666666",
        "longitude": "158.25000000",
        "emoji": "🇫🇲",
        "emojiU": "U+1F1EB U+1F1F2",
        "states": [
            {
                "id": 2580,
                "name": "Chuuk",
                "iso2": "TRK",
                "latitude": "7.13867590",
                "longitude": "151.55930650",
                "type": "state",
                "cities": [
                    {
                        "id": 39155,
                        "name": "Eot Municipality",
                        "latitude": "7.38540000",
                        "longitude": "151.73920000"
                    },
                    {
                        "id": 39156,
                        "name": "Ettal Municipality",
                        "latitude": "5.59200000",
                        "longitude": "153.56000000"
                    },
                    {
                        "id": 39159,
                        "name": "Fananu Municipality",
                        "latitude": "8.55811000",
                        "longitude": "151.90822000"
                    },
                    {
                        "id": 39160,
                        "name": "Fanapanges Municipality",
                        "latitude": "7.35300000",
                        "longitude": "151.66760000"
                    },
                    {
                        "id": 39163,
                        "name": "Fefen Municipality",
                        "latitude": "7.35300000",
                        "longitude": "151.83100000"
                    },
                    {
                        "id": 39164,
                        "name": "Fonoton Municipality",
                        "latitude": "7.48600000",
                        "longitude": "151.87940000"
                    },
                    {
                        "id": 39167,
                        "name": "Houk Municipality",
                        "latitude": "6.68300000",
                        "longitude": "149.30000000"
                    },
                    {
                        "id": 39173,
                        "name": "Kuttu Municipality",
                        "latitude": "5.45300000",
                        "longitude": "153.45600000"
                    },
                    {
                        "id": 39175,
                        "name": "Lekinioch Municipality",
                        "latitude": "5.50700000",
                        "longitude": "153.81900000"
                    },
                    {
                        "id": 39177,
                        "name": "Losap Municipality",
                        "latitude": "6.89400000",
                        "longitude": "152.73900000"
                    },
                    {
                        "id": 39180,
                        "name": "Makur Municipality",
                        "latitude": "8.98500000",
                        "longitude": "150.12600000"
                    },
                    {
                        "id": 39182,
                        "name": "Moch Municipality",
                        "latitude": "5.49180000",
                        "longitude": "153.53850000"
                    },
                    {
                        "id": 39184,
                        "name": "Murilo",
                        "latitude": "8.69242000",
                        "longitude": "152.33934000"
                    },
                    {
                        "id": 39185,
                        "name": "Murilo Municipality",
                        "latitude": "8.69200000",
                        "longitude": "152.34200000"
                    },
                    {
                        "id": 39186,
                        "name": "Namoluk Municipality",
                        "latitude": "5.91500000",
                        "longitude": "153.13600000"
                    },
                    {
                        "id": 39187,
                        "name": "Nema",
                        "latitude": "6.98922000",
                        "longitude": "152.57377000"
                    },
                    {
                        "id": 39188,
                        "name": "Nema Municipality",
                        "latitude": "6.99300000",
                        "longitude": "152.57400000"
                    },
                    {
                        "id": 39192,
                        "name": "Nomwin Municipality",
                        "latitude": "8.43000000",
                        "longitude": "151.74500000"
                    },
                    {
                        "id": 39194,
                        "name": "Oneop Municipality",
                        "latitude": "5.50660000",
                        "longitude": "153.70900000"
                    },
                    {
                        "id": 39195,
                        "name": "Onou Municipality",
                        "latitude": "8.79900000",
                        "longitude": "150.29000000"
                    },
                    {
                        "id": 39196,
                        "name": "Onoun Municipality",
                        "latitude": "8.57500000",
                        "longitude": "149.68550000"
                    },
                    {
                        "id": 39197,
                        "name": "Paata-Tupunion Municipality",
                        "latitude": "7.37600000",
                        "longitude": "151.58300000"
                    },
                    {
                        "id": 39199,
                        "name": "Parem Municipality",
                        "latitude": "7.36200000",
                        "longitude": "151.78900000"
                    },
                    {
                        "id": 39200,
                        "name": "Piherarh Municipality",
                        "latitude": "8.56900000",
                        "longitude": "150.41800000"
                    },
                    {
                        "id": 39201,
                        "name": "Piis-Emwar Municipality",
                        "latitude": "6.83400000",
                        "longitude": "152.70000000"
                    },
                    {
                        "id": 39202,
                        "name": "Piis-Panewu Municipality",
                        "latitude": "7.67800000",
                        "longitude": "151.76340000"
                    },
                    {
                        "id": 39204,
                        "name": "Pollap Municipality",
                        "latitude": "7.63971000",
                        "longitude": "149.43011000"
                    },
                    {
                        "id": 39205,
                        "name": "Polowat Municipality",
                        "latitude": "7.35500000",
                        "longitude": "149.18200000"
                    },
                    {
                        "id": 39206,
                        "name": "Pwene Municipality",
                        "latitude": "7.33700000",
                        "longitude": "151.58400000"
                    },
                    {
                        "id": 39207,
                        "name": "Ramanum Municipality",
                        "latitude": "7.41350000",
                        "longitude": "151.66460000"
                    },
                    {
                        "id": 39210,
                        "name": "Ruo Municipality",
                        "latitude": "8.60900000",
                        "longitude": "152.24400000"
                    },
                    {
                        "id": 39213,
                        "name": "Satowan Municipality",
                        "latitude": "5.33400000",
                        "longitude": "153.73650000"
                    },
                    {
                        "id": 39214,
                        "name": "Siis Municipality",
                        "latitude": "7.29500000",
                        "longitude": "151.82460000"
                    },
                    {
                        "id": 39216,
                        "name": "Ta Municipality",
                        "latitude": "5.28420000",
                        "longitude": "153.64650000"
                    },
                    {
                        "id": 39218,
                        "name": "Tamatam Municipality",
                        "latitude": "7.53898000",
                        "longitude": "149.41175000"
                    },
                    {
                        "id": 39220,
                        "name": "Tolensom Municipality",
                        "latitude": "7.33300000",
                        "longitude": "151.62300000"
                    },
                    {
                        "id": 39222,
                        "name": "Tonoas Municipality",
                        "latitude": "7.38100000",
                        "longitude": "151.89000000"
                    },
                    {
                        "id": 39224,
                        "name": "Udot-Fonuweisom Municipality",
                        "latitude": "7.38900000",
                        "longitude": "151.70800000"
                    },
                    {
                        "id": 39226,
                        "name": "Uman-Fonuweisom Municipality",
                        "latitude": "7.29900000",
                        "longitude": "151.87700000"
                    },
                    {
                        "id": 39227,
                        "name": "Unanu Municipality",
                        "latitude": "8.75000000",
                        "longitude": "150.33950000"
                    },
                    {
                        "id": 39230,
                        "name": "Weno",
                        "latitude": "7.44648000",
                        "longitude": "151.84135000"
                    },
                    {
                        "id": 39231,
                        "name": "Weno Municipality",
                        "latitude": "7.44000000",
                        "longitude": "151.88100000"
                    },
                    {
                        "id": 39233,
                        "name": "Wonei Municipality",
                        "latitude": "7.38700000",
                        "longitude": "151.60100000"
                    }
                ]
            },
            {
                "id": 2583,
                "name": "Kosrae",
                "iso2": "KSA",
                "latitude": "5.30956180",
                "longitude": "162.98148770",
                "type": "state",
                "cities": [
                    {
                        "id": 39176,
                        "name": "Lelu Municipality",
                        "latitude": "5.34865000",
                        "longitude": "163.01917000"
                    },
                    {
                        "id": 39181,
                        "name": "Malem Municipality",
                        "latitude": "5.27507000",
                        "longitude": "163.01685000"
                    },
                    {
                        "id": 39217,
                        "name": "Tafunsak Municipality",
                        "latitude": "5.34993000",
                        "longitude": "162.96965000"
                    },
                    {
                        "id": 39219,
                        "name": "Tofol",
                        "latitude": "5.32479000",
                        "longitude": "163.00781000"
                    },
                    {
                        "id": 39228,
                        "name": "Utwe Municipality",
                        "latitude": "5.27511000",
                        "longitude": "162.95617000"
                    }
                ]
            },
            {
                "id": 2581,
                "name": "Pohnpei",
                "iso2": "PNI",
                "latitude": "6.85412540",
                "longitude": "158.26238220",
                "type": "state",
                "cities": [
                    {
                        "id": 39169,
                        "name": "Kitti Municipality",
                        "latitude": "6.82490000",
                        "longitude": "158.16081000"
                    },
                    {
                        "id": 39170,
                        "name": "Kolonia",
                        "latitude": "6.96400000",
                        "longitude": "158.20620000"
                    },
                    {
                        "id": 39171,
                        "name": "Kolonia Municipality",
                        "latitude": "6.96400000",
                        "longitude": "158.20580000"
                    },
                    {
                        "id": 39172,
                        "name": "Kolonia Town",
                        "latitude": "6.96400000",
                        "longitude": "158.20600000"
                    },
                    {
                        "id": 39179,
                        "name": "Madolenihm Municipality",
                        "latitude": "6.86759000",
                        "longitude": "158.31277000"
                    },
                    {
                        "id": 39183,
                        "name": "Mokil Municipality",
                        "latitude": "6.68916000",
                        "longitude": "159.76610000"
                    },
                    {
                        "id": 39189,
                        "name": "Nett Municipality",
                        "latitude": "6.95152000",
                        "longitude": "158.22437000"
                    },
                    {
                        "id": 39190,
                        "name": "Ngatik",
                        "latitude": "5.78849000",
                        "longitude": "157.15954000"
                    },
                    {
                        "id": 39193,
                        "name": "Nukuoro Municipality",
                        "latitude": "3.84100000",
                        "longitude": "154.93000000"
                    },
                    {
                        "id": 39198,
                        "name": "Palikir - National Government Center",
                        "latitude": "6.92477000",
                        "longitude": "158.16109000"
                    },
                    {
                        "id": 39203,
                        "name": "Pingelap Municipality",
                        "latitude": "6.20908000",
                        "longitude": "160.71033000"
                    },
                    {
                        "id": 39211,
                        "name": "Sapwuahfik Municipality",
                        "latitude": "5.81500000",
                        "longitude": "157.28000000"
                    },
                    {
                        "id": 39215,
                        "name": "Sokehs Municipality",
                        "latitude": "6.93273000",
                        "longitude": "158.14270000"
                    },
                    {
                        "id": 39223,
                        "name": "U Municipality",
                        "latitude": "6.94972000",
                        "longitude": "158.27361000"
                    }
                ]
            },
            {
                "id": 2582,
                "name": "Yap",
                "iso2": "YAP",
                "latitude": "8.67164900",
                "longitude": "142.84393350",
                "type": "state",
                "cities": [
                    {
                        "id": 39153,
                        "name": "Colonia",
                        "latitude": "9.51638000",
                        "longitude": "138.12167000"
                    },
                    {
                        "id": 39154,
                        "name": "Dalipebinaw Municipality",
                        "latitude": "9.52229000",
                        "longitude": "138.08540000"
                    },
                    {
                        "id": 39157,
                        "name": "Fais",
                        "latitude": "9.76600000",
                        "longitude": "140.52000000"
                    },
                    {
                        "id": 39158,
                        "name": "Fais Municipality",
                        "latitude": "9.76600000",
                        "longitude": "140.51900000"
                    },
                    {
                        "id": 39161,
                        "name": "Fanif Municipality",
                        "latitude": "9.56056000",
                        "longitude": "138.11333000"
                    },
                    {
                        "id": 39162,
                        "name": "Faraulep Municipality",
                        "latitude": "8.58800000",
                        "longitude": "144.50650000"
                    },
                    {
                        "id": 39165,
                        "name": "Gagil Municipality",
                        "latitude": "9.54722000",
                        "longitude": "138.19028000"
                    },
                    {
                        "id": 39166,
                        "name": "Gilman Municipality",
                        "latitude": "9.44611000",
                        "longitude": "138.06389000"
                    },
                    {
                        "id": 39168,
                        "name": "Kanifay Municipality",
                        "latitude": "9.46735000",
                        "longitude": "138.05935000"
                    },
                    {
                        "id": 39174,
                        "name": "Lamotrek Municipality",
                        "latitude": "7.49100000",
                        "longitude": "146.30300000"
                    },
                    {
                        "id": 39178,
                        "name": "Maap Municipality",
                        "latitude": "9.58975000",
                        "longitude": "138.17119000"
                    },
                    {
                        "id": 39191,
                        "name": "Ngulu Municipality",
                        "latitude": "8.45000000",
                        "longitude": "137.48100000"
                    },
                    {
                        "id": 39208,
                        "name": "Rull Municipality",
                        "latitude": "9.50773000",
                        "longitude": "138.11540000"
                    },
                    {
                        "id": 39209,
                        "name": "Rumung Municipality",
                        "latitude": "9.62428000",
                        "longitude": "138.15745000"
                    },
                    {
                        "id": 39212,
                        "name": "Satawal Municipality",
                        "latitude": "7.38200000",
                        "longitude": "147.03180000"
                    },
                    {
                        "id": 39221,
                        "name": "Tomil Municipality",
                        "latitude": "9.52517000",
                        "longitude": "138.15488000"
                    },
                    {
                        "id": 39225,
                        "name": "Ulithi Municipality",
                        "latitude": "9.90000000",
                        "longitude": "139.60000000"
                    },
                    {
                        "id": 39229,
                        "name": "Weloy Municipality",
                        "latitude": "9.52712000",
                        "longitude": "138.11909000"
                    },
                    {
                        "id": 39232,
                        "name": "Woleai Municipality",
                        "latitude": "7.34500000",
                        "longitude": "143.85700000"
                    }
                ]
            }
        ]
    },
    {
        "id": 144,
        "name": "Moldova",
        "iso3": "MDA",
        "iso2": "MD",
        "numeric_code": "498",
        "phonecode": "373",
        "capital": "Chisinau",
        "currency": "MDL",
        "currency_name": "Moldovan leu",
        "currency_symbol": "L",
        "tld": ".md",
        "native": "Moldova",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Moldovan",
        "timezones": [
            {
                "zoneName": "Europe\/Chisinau",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Moldova",
            "ko": "몰도바",
            "pt-BR": "Moldávia",
            "pt": "Moldávia",
            "nl": "Moldavië",
            "hr": "Moldova",
            "fa": "مولداوی",
            "de": "Moldawie",
            "es": "Moldavia",
            "fr": "Moldavie",
            "ja": "モルドバ共和国",
            "it": "Moldavia",
            "zh-CN": "摩尔多瓦",
            "tr": "Moldova",
            "ru": "Молдова",
            "uk": "Молдова",
            "pl": "Mołdawia"
        },
        "latitude": "47.00000000",
        "longitude": "29.00000000",
        "emoji": "🇲🇩",
        "emojiU": "U+1F1F2 U+1F1E9",
        "states": [
            {
                "id": 4368,
                "name": "Anenii Noi",
                "iso2": "AN",
                "latitude": "46.87956630",
                "longitude": "29.23121750",
                "type": "district",
                "cities": [
                    {
                        "id": 67271,
                        "name": "Anenii Noi",
                        "latitude": "46.87839000",
                        "longitude": "29.23483000"
                    },
                    {
                        "id": 67337,
                        "name": "Varniţa",
                        "latitude": "46.86606000",
                        "longitude": "29.46636000"
                    }
                ]
            },
            {
                "id": 4393,
                "name": "Bălți",
                "iso2": "BA",
                "latitude": "47.75399470",
                "longitude": "27.91841480",
                "type": "city",
                "cities": [
                    {
                        "id": 67280,
                        "name": "Bălţi",
                        "latitude": "47.76314000",
                        "longitude": "27.92932000"
                    }
                ]
            },
            {
                "id": 4379,
                "name": "Basarabeasca",
                "iso2": "BS",
                "latitude": "46.42370600",
                "longitude": "28.89354920",
                "type": "district",
                "cities": [
                    {
                        "id": 67272,
                        "name": "Basarabeasca",
                        "latitude": "46.33170000",
                        "longitude": "28.96365000"
                    }
                ]
            },
            {
                "id": 4362,
                "name": "Bender",
                "iso2": "BD",
                "latitude": "46.82275510",
                "longitude": "29.46201010",
                "type": "city",
                "cities": [
                    {
                        "id": 67273,
                        "name": "Bender",
                        "latitude": "46.83156000",
                        "longitude": "29.47769000"
                    }
                ]
            },
            {
                "id": 4375,
                "name": "Briceni",
                "iso2": "BR",
                "latitude": "48.36320220",
                "longitude": "27.07503980",
                "type": "district",
                "cities": [
                    {
                        "id": 67276,
                        "name": "Briceni",
                        "latitude": "48.36289000",
                        "longitude": "27.07787000"
                    }
                ]
            },
            {
                "id": 4391,
                "name": "Cahul",
                "iso2": "CA",
                "latitude": "45.89394040",
                "longitude": "28.18902750",
                "type": "district",
                "cities": [
                    {
                        "id": 67281,
                        "name": "Cahul",
                        "latitude": "45.90425000",
                        "longitude": "28.19929000"
                    },
                    {
                        "id": 67305,
                        "name": "Giurgiuleşti",
                        "latitude": "45.48167000",
                        "longitude": "28.19722000"
                    }
                ]
            },
            {
                "id": 4366,
                "name": "Călărași",
                "iso2": "CL",
                "latitude": "47.28694600",
                "longitude": "28.27453100",
                "type": "district",
                "cities": [
                    {
                        "id": 67294,
                        "name": "Călăraşi",
                        "latitude": "47.25560000",
                        "longitude": "28.30987000"
                    }
                ]
            },
            {
                "id": 4380,
                "name": "Cantemir",
                "iso2": "CT",
                "latitude": "46.27717420",
                "longitude": "28.20096530",
                "type": "district",
                "cities": [
                    {
                        "id": 67283,
                        "name": "Cantemir",
                        "latitude": "46.27743000",
                        "longitude": "28.20270000"
                    },
                    {
                        "id": 67310,
                        "name": "Iargara",
                        "latitude": "46.42520000",
                        "longitude": "28.42676000"
                    },
                    {
                        "id": 67339,
                        "name": "Vişniovca",
                        "latitude": "46.33260000",
                        "longitude": "28.44797000"
                    }
                ]
            },
            {
                "id": 4365,
                "name": "Căușeni",
                "iso2": "CS",
                "latitude": "46.65547150",
                "longitude": "29.40912220",
                "type": "district",
                "cities": [
                    {
                        "id": 67295,
                        "name": "Căuşeni",
                        "latitude": "46.63674000",
                        "longitude": "29.41114000"
                    },
                    {
                        "id": 67286,
                        "name": "Chiţcani",
                        "latitude": "46.78296000",
                        "longitude": "29.61682000"
                    }
                ]
            },
            {
                "id": 4373,
                "name": "Chișinău",
                "iso2": "CU",
                "latitude": "47.01045290",
                "longitude": "28.86381020",
                "type": "city",
                "cities": [
                    {
                        "id": 67285,
                        "name": "Chisinau",
                        "latitude": "47.00556000",
                        "longitude": "28.85750000"
                    },
                    {
                        "id": 67288,
                        "name": "Ciorescu",
                        "latitude": "47.13000000",
                        "longitude": "28.88937000"
                    },
                    {
                        "id": 67292,
                        "name": "Cricova",
                        "latitude": "47.13835000",
                        "longitude": "28.86156000"
                    },
                    {
                        "id": 67327,
                        "name": "Sîngera",
                        "latitude": "46.91557000",
                        "longitude": "28.96673000"
                    },
                    {
                        "id": 67326,
                        "name": "Stăuceni",
                        "latitude": "47.09643000",
                        "longitude": "28.86791000"
                    },
                    {
                        "id": 67336,
                        "name": "Vadul lui Vodă",
                        "latitude": "47.09009000",
                        "longitude": "29.07570000"
                    },
                    {
                        "id": 67338,
                        "name": "Vatra",
                        "latitude": "47.07460000",
                        "longitude": "28.73685000"
                    }
                ]
            },
            {
                "id": 4360,
                "name": "Cimișlia",
                "iso2": "CM",
                "latitude": "46.52508510",
                "longitude": "28.77218350",
                "type": "district",
                "cities": [
                    {
                        "id": 67287,
                        "name": "Cimişlia",
                        "latitude": "46.52685000",
                        "longitude": "28.76441000"
                    }
                ]
            },
            {
                "id": 4390,
                "name": "Criuleni",
                "iso2": "CR",
                "latitude": "47.21361140",
                "longitude": "29.15575190",
                "type": "district",
                "cities": [
                    {
                        "id": 67293,
                        "name": "Criuleni",
                        "latitude": "47.21307000",
                        "longitude": "29.15926000"
                    }
                ]
            },
            {
                "id": 4384,
                "name": "Dondușeni",
                "iso2": "DO",
                "latitude": "48.23383050",
                "longitude": "27.59980870",
                "type": "district",
                "cities": [
                    {
                        "id": 67277,
                        "name": "Briceni",
                        "latitude": "48.35628000",
                        "longitude": "27.70293000"
                    },
                    {
                        "id": 67298,
                        "name": "Donduşeni",
                        "latitude": "48.24268000",
                        "longitude": "27.61010000"
                    }
                ]
            },
            {
                "id": 4392,
                "name": "Drochia",
                "iso2": "DR",
                "latitude": "48.07977880",
                "longitude": "27.86041140",
                "type": "district",
                "cities": [
                    {
                        "id": 67299,
                        "name": "Drochia",
                        "latitude": "48.03555000",
                        "longitude": "27.81293000"
                    }
                ]
            },
            {
                "id": 4383,
                "name": "Dubăsari",
                "iso2": "DU",
                "latitude": "47.26439420",
                "longitude": "29.15503480",
                "type": "district",
                "cities": [
                    {
                        "id": 67289,
                        "name": "Cocieri",
                        "latitude": "47.30170000",
                        "longitude": "29.11755000"
                    },
                    {
                        "id": 67335,
                        "name": "Ustia",
                        "latitude": "47.25524000",
                        "longitude": "29.12406000"
                    }
                ]
            },
            {
                "id": 4387,
                "name": "Edineț",
                "iso2": "ED",
                "latitude": "48.16789910",
                "longitude": "27.29361430",
                "type": "district",
                "cities": [
                    {
                        "id": 67301,
                        "name": "Edineţ",
                        "latitude": "48.17215000",
                        "longitude": "27.30337000"
                    }
                ]
            },
            {
                "id": 4381,
                "name": "Fălești",
                "iso2": "FA",
                "latitude": "47.56477250",
                "longitude": "27.72655930",
                "type": "district",
                "cities": [
                    {
                        "id": 67303,
                        "name": "Fălești",
                        "latitude": "47.57667000",
                        "longitude": "27.71264000"
                    }
                ]
            },
            {
                "id": 4370,
                "name": "Florești",
                "iso2": "FL",
                "latitude": "47.86678490",
                "longitude": "28.33918640",
                "type": "district",
                "cities": [
                    {
                        "id": 67302,
                        "name": "Floreşti",
                        "latitude": "47.89137000",
                        "longitude": "28.29312000"
                    },
                    {
                        "id": 67304,
                        "name": "Ghindești",
                        "latitude": "47.85482000",
                        "longitude": "28.37679000"
                    },
                    {
                        "id": 67313,
                        "name": "Mărculeşti",
                        "latitude": "47.86897000",
                        "longitude": "28.24109000"
                    }
                ]
            },
            {
                "id": 4385,
                "name": "Gagauzia",
                "iso2": "GA",
                "latitude": "46.09794350",
                "longitude": "28.63846450",
                "type": "autonomous territorial unit",
                "cities": [
                    {
                        "id": 67279,
                        "name": "Bugeac",
                        "latitude": "46.36554000",
                        "longitude": "28.66250000"
                    },
                    {
                        "id": 67284,
                        "name": "Ceadîr-Lunga",
                        "latitude": "46.06169000",
                        "longitude": "28.83078000"
                    },
                    {
                        "id": 67290,
                        "name": "Comrat",
                        "latitude": "46.29456000",
                        "longitude": "28.65650000"
                    },
                    {
                        "id": 67340,
                        "name": "Vulcăneşti",
                        "latitude": "45.68492000",
                        "longitude": "28.40613000"
                    }
                ]
            },
            {
                "id": 4367,
                "name": "Glodeni",
                "iso2": "GL",
                "latitude": "47.77901560",
                "longitude": "27.51680100",
                "type": "district",
                "cities": [
                    {
                        "id": 67306,
                        "name": "Glodeni",
                        "latitude": "47.77513000",
                        "longitude": "27.51891000"
                    }
                ]
            },
            {
                "id": 4382,
                "name": "Hîncești",
                "iso2": "HI",
                "latitude": "46.82811470",
                "longitude": "28.58508890",
                "type": "district",
                "cities": [
                    {
                        "id": 67296,
                        "name": "Dancu",
                        "latitude": "46.75818000",
                        "longitude": "28.20716000"
                    },
                    {
                        "id": 67308,
                        "name": "Hînceşti",
                        "latitude": "46.83047000",
                        "longitude": "28.59064000"
                    }
                ]
            },
            {
                "id": 4369,
                "name": "Ialoveni",
                "iso2": "IA",
                "latitude": "46.86308600",
                "longitude": "28.82342180",
                "type": "district",
                "cities": [
                    {
                        "id": 67309,
                        "name": "Ialoveni",
                        "latitude": "46.94346000",
                        "longitude": "28.78233000"
                    }
                ]
            },
            {
                "id": 4363,
                "name": "Nisporeni",
                "iso2": "NI",
                "latitude": "47.07513490",
                "longitude": "28.17681550",
                "type": "district",
                "cities": [
                    {
                        "id": 67314,
                        "name": "Nisporeni",
                        "latitude": "47.08159000",
                        "longitude": "28.17138000"
                    }
                ]
            },
            {
                "id": 4389,
                "name": "Ocnița",
                "iso2": "OC",
                "latitude": "48.41104350",
                "longitude": "27.47680920",
                "type": "district",
                "cities": [
                    {
                        "id": 67315,
                        "name": "Ocniţa",
                        "latitude": "48.38274000",
                        "longitude": "27.43805000"
                    },
                    {
                        "id": 67317,
                        "name": "Otaci",
                        "latitude": "48.43285000",
                        "longitude": "27.79912000"
                    }
                ]
            },
            {
                "id": 4361,
                "name": "Orhei",
                "iso2": "OR",
                "latitude": "47.38604000",
                "longitude": "28.83030820",
                "type": "district",
                "cities": [
                    {
                        "id": 67316,
                        "name": "Orhei",
                        "latitude": "47.38494000",
                        "longitude": "28.82446000"
                    }
                ]
            },
            {
                "id": 4394,
                "name": "Rezina",
                "iso2": "RE",
                "latitude": "47.71804470",
                "longitude": "28.88710240",
                "type": "district",
                "cities": [
                    {
                        "id": 67319,
                        "name": "Rezina",
                        "latitude": "47.74928000",
                        "longitude": "28.96583000"
                    },
                    {
                        "id": 67322,
                        "name": "Saharna",
                        "latitude": "47.69107000",
                        "longitude": "28.97458000"
                    }
                ]
            },
            {
                "id": 4376,
                "name": "Rîșcani",
                "iso2": "RI",
                "latitude": "47.90701530",
                "longitude": "27.53749960",
                "type": "district",
                "cities": [
                    {
                        "id": 67321,
                        "name": "Rîşcani",
                        "latitude": "47.94792000",
                        "longitude": "27.56376000"
                    }
                ]
            },
            {
                "id": 4364,
                "name": "Sîngerei",
                "iso2": "SI",
                "latitude": "47.63891340",
                "longitude": "28.13718160",
                "type": "district",
                "cities": [
                    {
                        "id": 67274,
                        "name": "Bilicenii Vechi",
                        "latitude": "47.65580000",
                        "longitude": "28.04734000"
                    },
                    {
                        "id": 67275,
                        "name": "Biruinţa",
                        "latitude": "47.81353000",
                        "longitude": "28.07004000"
                    },
                    {
                        "id": 67328,
                        "name": "Sîngerei",
                        "latitude": "47.63632000",
                        "longitude": "28.14296000"
                    }
                ]
            },
            {
                "id": 4388,
                "name": "Șoldănești",
                "iso2": "SD",
                "latitude": "47.81473890",
                "longitude": "28.78895860",
                "type": "district",
                "cities": [
                    {
                        "id": 67341,
                        "name": "Şoldăneşti",
                        "latitude": "47.81608000",
                        "longitude": "28.79718000"
                    }
                ]
            },
            {
                "id": 4374,
                "name": "Soroca",
                "iso2": "SO",
                "latitude": "48.15497430",
                "longitude": "28.28707830",
                "type": "district",
                "cities": [
                    {
                        "id": 67324,
                        "name": "Soroca",
                        "latitude": "48.15659000",
                        "longitude": "28.28489000"
                    }
                ]
            },
            {
                "id": 4378,
                "name": "Ștefan Vodă",
                "iso2": "SV",
                "latitude": "46.55404880",
                "longitude": "29.70224200",
                "type": "district",
                "cities": [
                    {
                        "id": 67342,
                        "name": "Ştefan Vodă",
                        "latitude": "46.51287000",
                        "longitude": "29.66193000"
                    }
                ]
            },
            {
                "id": 4377,
                "name": "Strășeni",
                "iso2": "ST",
                "latitude": "47.14502670",
                "longitude": "28.61367360",
                "type": "district",
                "cities": [
                    {
                        "id": 67278,
                        "name": "Bucovăţ",
                        "latitude": "47.19064000",
                        "longitude": "28.45802000"
                    },
                    {
                        "id": 67325,
                        "name": "Strășeni",
                        "latitude": "47.14216000",
                        "longitude": "28.60774000"
                    }
                ]
            },
            {
                "id": 4372,
                "name": "Taraclia",
                "iso2": "TA",
                "latitude": "45.89865100",
                "longitude": "28.66716440",
                "type": "district",
                "cities": [
                    {
                        "id": 67329,
                        "name": "Taraclia",
                        "latitude": "45.90273000",
                        "longitude": "28.66816000"
                    },
                    {
                        "id": 67333,
                        "name": "Tvardița",
                        "latitude": "46.14826000",
                        "longitude": "28.96491000"
                    }
                ]
            },
            {
                "id": 4371,
                "name": "Telenești",
                "iso2": "TE",
                "latitude": "47.49839620",
                "longitude": "28.36760190",
                "type": "district",
                "cities": [
                    {
                        "id": 67312,
                        "name": "Mîndreşti",
                        "latitude": "47.50525000",
                        "longitude": "28.27687000"
                    },
                    {
                        "id": 67330,
                        "name": "Teleneşti",
                        "latitude": "47.50110000",
                        "longitude": "28.36536000"
                    }
                ]
            },
            {
                "id": 4395,
                "name": "Transnistria",
                "iso2": "SN",
                "latitude": "47.21529720",
                "longitude": "29.46380540",
                "type": "territorial unit",
                "cities": [
                    {
                        "id": 67282,
                        "name": "Camenca",
                        "latitude": "48.03233000",
                        "longitude": "28.69899000"
                    },
                    {
                        "id": 67291,
                        "name": "Crasnoe",
                        "latitude": "46.64844000",
                        "longitude": "29.80403000"
                    },
                    {
                        "id": 67297,
                        "name": "Dnestrovsc",
                        "latitude": "46.61640000",
                        "longitude": "29.91926000"
                    },
                    {
                        "id": 67300,
                        "name": "Dubăsari",
                        "latitude": "47.26562000",
                        "longitude": "29.16667000"
                    },
                    {
                        "id": 67307,
                        "name": "Hryhoriopol",
                        "latitude": "47.15413000",
                        "longitude": "29.30008000"
                    },
                    {
                        "id": 67311,
                        "name": "Maiac",
                        "latitude": "47.23727000",
                        "longitude": "29.38498000"
                    },
                    {
                        "id": 67318,
                        "name": "Pervomaisc",
                        "latitude": "46.73253000",
                        "longitude": "29.96170000"
                    },
                    {
                        "id": 67320,
                        "name": "Rîbniţa",
                        "latitude": "47.76817000",
                        "longitude": "29.01000000"
                    },
                    {
                        "id": 67323,
                        "name": "Slobozia",
                        "latitude": "46.72927000",
                        "longitude": "29.70446000"
                    },
                    {
                        "id": 67331,
                        "name": "Tiraspol",
                        "latitude": "46.84274000",
                        "longitude": "29.62909000"
                    },
                    {
                        "id": 67332,
                        "name": "Tiraspolul Nou",
                        "latitude": "46.82874000",
                        "longitude": "29.52174000"
                    }
                ]
            },
            {
                "id": 4386,
                "name": "Ungheni",
                "iso2": "UN",
                "latitude": "47.23057670",
                "longitude": "27.78926610",
                "type": "district",
                "cities": [
                    {
                        "id": 67334,
                        "name": "Ungheni",
                        "latitude": "47.21079000",
                        "longitude": "27.80047000"
                    }
                ]
            }
        ]
    },
    {
        "id": 145,
        "name": "Monaco",
        "iso3": "MCO",
        "iso2": "MC",
        "numeric_code": "492",
        "phonecode": "377",
        "capital": "Monaco",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".mc",
        "native": "Monaco",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Western Europe",
        "subregion_id": 17,
        "nationality": "Monegasque, Monacan",
        "timezones": [
            {
                "zoneName": "Europe\/Monaco",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "ko": "모나코",
            "pt-BR": "Mônaco",
            "pt": "Mónaco",
            "nl": "Monaco",
            "hr": "Monako",
            "fa": "موناکو",
            "de": "Monaco",
            "es": "Mónaco",
            "fr": "Monaco",
            "ja": "モナコ",
            "it": "Principato di Monaco",
            "zh-CN": "摩纳哥",
            "tr": "Monako",
            "ru": "Монако",
            "uk": "Монако",
            "pl": "Monabr"
        },
        "latitude": "43.73333333",
        "longitude": "7.40000000",
        "emoji": "🇲🇨",
        "emojiU": "U+1F1F2 U+1F1E8",
        "states": [
            {
                "id": 4917,
                "name": "La Colle",
                "iso2": "CL",
                "latitude": "43.73274650",
                "longitude": "7.41372760",
                "type": "quarter",
                "cities": []
            },
            {
                "id": 4918,
                "name": "La Condamine",
                "iso2": "CO",
                "latitude": "43.73506650",
                "longitude": "7.41990600",
                "type": "quarter",
                "cities": []
            },
            {
                "id": 4919,
                "name": "Moneghetti",
                "iso2": "MG",
                "latitude": "43.73649270",
                "longitude": "7.41533830",
                "type": "quarter",
                "cities": []
            }
        ]
    },
    {
        "id": 146,
        "name": "Mongolia",
        "iso3": "MNG",
        "iso2": "MN",
        "numeric_code": "496",
        "phonecode": "976",
        "capital": "Ulan Bator",
        "currency": "MNT",
        "currency_name": "Mongolian tögrög",
        "currency_symbol": "₮",
        "tld": ".mn",
        "native": "Монгол улс",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Eastern Asia",
        "subregion_id": 12,
        "nationality": "Mongolian",
        "timezones": [
            {
                "zoneName": "Asia\/Choibalsan",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "CHOT",
                "tzName": "Choibalsan Standard Time"
            },
            {
                "zoneName": "Asia\/Hovd",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "HOVT",
                "tzName": "Hovd Time"
            },
            {
                "zoneName": "Asia\/Ulaanbaatar",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "ULAT",
                "tzName": "Ulaanbaatar Standard Time"
            }
        ],
        "translations": {
            "br": "Mongolia",
            "ko": "몽골",
            "pt-BR": "Mongólia",
            "pt": "Mongólia",
            "nl": "Mongolië",
            "hr": "Mongolija",
            "fa": "مغولستان",
            "de": "Mongolei",
            "es": "Mongolia",
            "fr": "Mongolie",
            "ja": "モンゴル",
            "it": "Mongolia",
            "zh-CN": "蒙古",
            "tr": "Moğolistan",
            "ru": "Монголия",
            "uk": "Монголія",
            "pl": "Mongolia"
        },
        "latitude": "46.00000000",
        "longitude": "105.00000000",
        "emoji": "🇲🇳",
        "emojiU": "U+1F1F2 U+1F1F3",
        "states": [
            {
                "id": 1973,
                "name": "Arkhangai",
                "iso2": "073",
                "latitude": "47.89711010",
                "longitude": "100.72401650",
                "type": "province",
                "cities": [
                    {
                        "id": 67734,
                        "name": "Tsetserleg",
                        "latitude": "47.47500000",
                        "longitude": "101.45417000"
                    }
                ]
            },
            {
                "id": 1969,
                "name": "Bayan-Ölgii",
                "iso2": "071",
                "latitude": "48.39832540",
                "longitude": "89.66259150",
                "type": "province",
                "cities": [
                    {
                        "id": 67706,
                        "name": "Altay",
                        "latitude": "48.29359000",
                        "longitude": "89.51488000"
                    },
                    {
                        "id": 67740,
                        "name": "Ölgii",
                        "latitude": "48.96833000",
                        "longitude": "89.96250000"
                    },
                    {
                        "id": 67733,
                        "name": "Tsengel",
                        "latitude": "48.94314000",
                        "longitude": "89.14358000"
                    }
                ]
            },
            {
                "id": 1976,
                "name": "Bayankhongor",
                "iso2": "069",
                "latitude": "45.15267070",
                "longitude": "100.10736670",
                "type": "province",
                "cities": [
                    {
                        "id": 67709,
                        "name": "Bayanhongor",
                        "latitude": "46.19444000",
                        "longitude": "100.71806000"
                    }
                ]
            },
            {
                "id": 1961,
                "name": "Bulgan",
                "iso2": "067",
                "latitude": "48.96909130",
                "longitude": "102.88317230",
                "type": "province",
                "cities": [
                    {
                        "id": 67710,
                        "name": "Bulgan",
                        "latitude": "48.81250000",
                        "longitude": "103.53472000"
                    }
                ]
            },
            {
                "id": 1962,
                "name": "Darkhan-Uul",
                "iso2": "037",
                "latitude": "49.46484340",
                "longitude": "105.97459190",
                "type": "province",
                "cities": [
                    {
                        "id": 67714,
                        "name": "Darhan",
                        "latitude": "49.48667000",
                        "longitude": "105.92278000"
                    }
                ]
            },
            {
                "id": 1963,
                "name": "Dornod",
                "iso2": "061",
                "latitude": "47.46581540",
                "longitude": "115.39271200",
                "type": "province",
                "cities": [
                    {
                        "id": 67711,
                        "name": "Choibalsan",
                        "latitude": "48.07257000",
                        "longitude": "114.53264000"
                    },
                    {
                        "id": 67718,
                        "name": "Ereencav",
                        "latitude": "49.88070000",
                        "longitude": "115.72526000"
                    }
                ]
            },
            {
                "id": 1981,
                "name": "Dornogovi",
                "iso2": "063",
                "latitude": "43.96538890",
                "longitude": "109.17734590",
                "type": "province",
                "cities": []
            },
            {
                "id": 1970,
                "name": "Dundgovi",
                "iso2": "059",
                "latitude": "45.58227860",
                "longitude": "106.76442090",
                "type": "province",
                "cities": [
                    {
                        "id": 67725,
                        "name": "Mandalgovi",
                        "latitude": "45.76250000",
                        "longitude": "106.27083000"
                    }
                ]
            },
            {
                "id": 1972,
                "name": "Govi-Altai",
                "iso2": "065",
                "latitude": "45.45112270",
                "longitude": "95.85057660",
                "type": "province",
                "cities": [
                    {
                        "id": 67705,
                        "name": "Altai",
                        "latitude": "46.37222000",
                        "longitude": "96.25833000"
                    }
                ]
            },
            {
                "id": 1978,
                "name": "Govisümber",
                "iso2": "064",
                "latitude": "46.47627540",
                "longitude": "108.55706270",
                "type": "province",
                "cities": [
                    {
                        "id": 67712,
                        "name": "Choyr",
                        "latitude": "46.36111000",
                        "longitude": "108.36111000"
                    }
                ]
            },
            {
                "id": 1974,
                "name": "Khentii",
                "iso2": "039",
                "latitude": "47.60812090",
                "longitude": "109.93728560",
                "type": "province",
                "cities": [
                    {
                        "id": 67739,
                        "name": "Undurkhaan",
                        "latitude": "47.31944000",
                        "longitude": "110.65556000"
                    }
                ]
            },
            {
                "id": 1964,
                "name": "Khovd",
                "iso2": "043",
                "latitude": "47.11296540",
                "longitude": "92.31107520",
                "type": "province",
                "cities": [
                    {
                        "id": 67724,
                        "name": "Khovd",
                        "latitude": "48.00556000",
                        "longitude": "91.64194000"
                    },
                    {
                        "id": 67728,
                        "name": "Möst",
                        "latitude": "46.67712000",
                        "longitude": "92.78521000"
                    },
                    {
                        "id": 67741,
                        "name": "Üyönch",
                        "latitude": "46.04786000",
                        "longitude": "92.02612000"
                    }
                ]
            },
            {
                "id": 1975,
                "name": "Khövsgöl",
                "iso2": "041",
                "latitude": "50.22044840",
                "longitude": "100.32137680",
                "type": "province",
                "cities": [
                    {
                        "id": 67719,
                        "name": "Hanh",
                        "latitude": "51.50265000",
                        "longitude": "100.66395000"
                    },
                    {
                        "id": 67726,
                        "name": "Murun-kuren",
                        "latitude": "49.63417000",
                        "longitude": "100.16250000"
                    },
                    {
                        "id": 67732,
                        "name": "Tsengel",
                        "latitude": "49.47833000",
                        "longitude": "100.88944000"
                    },
                    {
                        "id": 67735,
                        "name": "Turt",
                        "latitude": "51.50725000",
                        "longitude": "100.66257000"
                    }
                ]
            },
            {
                "id": 1967,
                "name": "Ömnögovi",
                "iso2": "053",
                "latitude": "43.50002400",
                "longitude": "104.28611160",
                "type": "province",
                "cities": [
                    {
                        "id": 67713,
                        "name": "Dalandzadgad",
                        "latitude": "43.57083000",
                        "longitude": "104.42500000"
                    },
                    {
                        "id": 67720,
                        "name": "Hanhongor",
                        "latitude": "43.77345000",
                        "longitude": "104.47998000"
                    },
                    {
                        "id": 67730,
                        "name": "Nomgon Sum",
                        "latitude": "42.41462000",
                        "longitude": "105.05640000"
                    }
                ]
            },
            {
                "id": 1966,
                "name": "Orkhon",
                "iso2": "035",
                "latitude": "49.00470500",
                "longitude": "104.30165270",
                "type": "province",
                "cities": [
                    {
                        "id": 67717,
                        "name": "Erdenet",
                        "latitude": "49.03333000",
                        "longitude": "104.08333000"
                    }
                ]
            },
            {
                "id": 1965,
                "name": "Övörkhangai",
                "iso2": "055",
                "latitude": "45.76243920",
                "longitude": "103.09170320",
                "type": "province",
                "cities": [
                    {
                        "id": 67707,
                        "name": "Arvayheer",
                        "latitude": "46.26389000",
                        "longitude": "102.77500000"
                    },
                    {
                        "id": 67721,
                        "name": "Harhorin",
                        "latitude": "47.19753000",
                        "longitude": "102.82379000"
                    },
                    {
                        "id": 67722,
                        "name": "Hovd",
                        "latitude": "44.67024000",
                        "longitude": "102.17491000"
                    },
                    {
                        "id": 67723,
                        "name": "Kharkhorin",
                        "latitude": "47.19245000",
                        "longitude": "102.81349000"
                    },
                    {
                        "id": 67729,
                        "name": "Nariynteel",
                        "latitude": "45.95950000",
                        "longitude": "101.45977000"
                    }
                ]
            },
            {
                "id": 1980,
                "name": "Selenge",
                "iso2": "049",
                "latitude": "50.00592730",
                "longitude": "106.44341080",
                "type": "province",
                "cities": [
                    {
                        "id": 67716,
                        "name": "Dzüünharaa",
                        "latitude": "48.85229000",
                        "longitude": "106.45786000"
                    },
                    {
                        "id": 67731,
                        "name": "Sühbaatar",
                        "latitude": "50.23139000",
                        "longitude": "106.20778000"
                    }
                ]
            },
            {
                "id": 1977,
                "name": "Sükhbaatar",
                "iso2": "051",
                "latitude": "46.56531630",
                "longitude": "113.53808360",
                "type": "province",
                "cities": [
                    {
                        "id": 67708,
                        "name": "Baruun-Urt",
                        "latitude": "46.68056000",
                        "longitude": "113.27917000"
                    }
                ]
            },
            {
                "id": 1968,
                "name": "Töv",
                "iso2": "047",
                "latitude": "47.21240560",
                "longitude": "106.41541000",
                "type": "province",
                "cities": [
                    {
                        "id": 67742,
                        "name": "Centipede",
                        "latitude": "47.70693000",
                        "longitude": "106.95276000"
                    },
                    {
                        "id": 67715,
                        "name": "Dzuunmod",
                        "latitude": "47.70694000",
                        "longitude": "106.95278000"
                    },
                    {
                        "id": 67727,
                        "name": "Möngönmorĭt",
                        "latitude": "48.19504000",
                        "longitude": "108.48295000"
                    },
                    {
                        "id": 67737,
                        "name": "Ulaanhudag",
                        "latitude": "47.33333000",
                        "longitude": "104.50000000"
                    },
                    {
                        "id": 153783,
                        "name": "Ulan Bator",
                        "latitude": "47.89176240",
                        "longitude": "106.73706000"
                    }
                ]
            },
            {
                "id": 5453,
                "name": "Ulaanbaatar",
                "iso2": "001",
                "latitude": "47.89153170",
                "longitude": "106.73672220",
                "type": "capital city",
                "cities": [
                    {
                        "id": 157016,
                        "name": "Ulaanbaatar",
                        "latitude": "47.89153170",
                        "longitude": "106.73672220"
                    }
                ]
            },
            {
                "id": 1971,
                "name": "Uvs",
                "iso2": "046",
                "latitude": "49.64497070",
                "longitude": "93.27365760",
                "type": "province",
                "cities": [
                    {
                        "id": 67736,
                        "name": "Ulaangom",
                        "latitude": "49.98111000",
                        "longitude": "92.06667000"
                    }
                ]
            },
            {
                "id": 1979,
                "name": "Zavkhan",
                "iso2": "057",
                "latitude": "48.23881470",
                "longitude": "96.07030190",
                "type": "province",
                "cities": [
                    {
                        "id": 67738,
                        "name": "Uliastay",
                        "latitude": "47.74167000",
                        "longitude": "96.84444000"
                    }
                ]
            }
        ]
    },
    {
        "id": 147,
        "name": "Montenegro",
        "iso3": "MNE",
        "iso2": "ME",
        "numeric_code": "499",
        "phonecode": "382",
        "capital": "Podgorica",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".me",
        "native": "Црна Гора",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Montenegrin",
        "timezones": [
            {
                "zoneName": "Europe\/Podgorica",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Montenegro",
            "ko": "몬테네그로",
            "pt-BR": "Montenegro",
            "pt": "Montenegro",
            "nl": "Montenegro",
            "hr": "Crna Gora",
            "fa": "مونته‌نگرو",
            "de": "Montenegro",
            "es": "Montenegro",
            "fr": "Monténégro",
            "ja": "モンテネグロ",
            "it": "Montenegro",
            "zh-CN": "黑山",
            "tr": "Karadağ",
            "ru": "Черногория",
            "uk": "Чорногорія",
            "pl": "Czarnogóra"
        },
        "latitude": "42.50000000",
        "longitude": "19.30000000",
        "emoji": "🇲🇪",
        "emojiU": "U+1F1F2 U+1F1EA",
        "states": [
            {
                "id": 23,
                "name": "Andrijevica",
                "iso2": "01",
                "latitude": "42.73624770",
                "longitude": "19.78595560",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67343,
                        "name": "Andrijevica",
                        "latitude": "42.73389000",
                        "longitude": "19.79194000"
                    }
                ]
            },
            {
                "id": 13,
                "name": "Bar",
                "iso2": "02",
                "latitude": "42.12781190",
                "longitude": "19.14043800",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67344,
                        "name": "Bar",
                        "latitude": "42.09306000",
                        "longitude": "19.10028000"
                    },
                    {
                        "id": 67369,
                        "name": "Stari Bar",
                        "latitude": "42.09700000",
                        "longitude": "19.13600000"
                    },
                    {
                        "id": 67375,
                        "name": "Šušanj",
                        "latitude": "42.11556000",
                        "longitude": "19.08833000"
                    },
                    {
                        "id": 67370,
                        "name": "Sutomore",
                        "latitude": "42.14278000",
                        "longitude": "19.04667000"
                    }
                ]
            },
            {
                "id": 21,
                "name": "Berane",
                "iso2": "03",
                "latitude": "42.82572890",
                "longitude": "19.90205090",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67345,
                        "name": "Berane",
                        "latitude": "42.84250000",
                        "longitude": "19.87333000"
                    }
                ]
            },
            {
                "id": 25,
                "name": "Bijelo Polje",
                "iso2": "04",
                "latitude": "43.08465260",
                "longitude": "19.71154720",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67346,
                        "name": "Bijelo Polje",
                        "latitude": "43.03834000",
                        "longitude": "19.74758000"
                    }
                ]
            },
            {
                "id": 30,
                "name": "Budva",
                "iso2": "05",
                "latitude": "42.31407200",
                "longitude": "18.83138320",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67347,
                        "name": "Budva",
                        "latitude": "42.28639000",
                        "longitude": "18.84000000"
                    },
                    {
                        "id": 67360,
                        "name": "Petrovac na Moru",
                        "latitude": "42.20556000",
                        "longitude": "18.94250000"
                    }
                ]
            },
            {
                "id": 14,
                "name": "Danilovgrad",
                "iso2": "07",
                "latitude": "42.58357000",
                "longitude": "19.14043800",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67349,
                        "name": "Danilovgrad",
                        "latitude": "42.55384000",
                        "longitude": "19.14608000"
                    },
                    {
                        "id": 67368,
                        "name": "Spuž",
                        "latitude": "42.51500000",
                        "longitude": "19.19500000"
                    }
                ]
            },
            {
                "id": 24,
                "name": "Gusinje",
                "iso2": "22",
                "latitude": "42.55634550",
                "longitude": "19.83060510",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67353,
                        "name": "Gusinje",
                        "latitude": "42.56194000",
                        "longitude": "19.83389000"
                    }
                ]
            },
            {
                "id": 31,
                "name": "Kolašin",
                "iso2": "09",
                "latitude": "42.76019160",
                "longitude": "19.42591140",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67354,
                        "name": "Kolašin",
                        "latitude": "42.82229000",
                        "longitude": "19.51653000"
                    }
                ]
            },
            {
                "id": 26,
                "name": "Kotor",
                "iso2": "10",
                "latitude": "42.57402610",
                "longitude": "18.64131450",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67350,
                        "name": "Dobrota",
                        "latitude": "42.45417000",
                        "longitude": "18.76833000"
                    },
                    {
                        "id": 67355,
                        "name": "Kotor",
                        "latitude": "42.42067000",
                        "longitude": "18.76825000"
                    },
                    {
                        "id": 67365,
                        "name": "Prčanj",
                        "latitude": "42.45750000",
                        "longitude": "18.74222000"
                    },
                    {
                        "id": 67366,
                        "name": "Risan",
                        "latitude": "42.51500000",
                        "longitude": "18.69556000"
                    }
                ]
            },
            {
                "id": 22,
                "name": "Mojkovac",
                "iso2": "11",
                "latitude": "42.96880180",
                "longitude": "19.52110630",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67358,
                        "name": "Mojkovac",
                        "latitude": "42.96044000",
                        "longitude": "19.58330000"
                    }
                ]
            },
            {
                "id": 17,
                "name": "Nikšić",
                "iso2": "12",
                "latitude": "42.79971840",
                "longitude": "18.76009630",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67359,
                        "name": "Nikšić",
                        "latitude": "42.77310000",
                        "longitude": "18.94446000"
                    }
                ]
            },
            {
                "id": 28,
                "name": "Old Royal Capital Cetinje",
                "iso2": "06",
                "latitude": "42.39309590",
                "longitude": "18.91159640",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67348,
                        "name": "Cetinje",
                        "latitude": "42.39063000",
                        "longitude": "18.91417000"
                    }
                ]
            },
            {
                "id": 12,
                "name": "Petnjica",
                "iso2": "23",
                "latitude": "42.93534800",
                "longitude": "20.02114490",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 19,
                "name": "Plav",
                "iso2": "13",
                "latitude": "42.60013370",
                "longitude": "19.94075410",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67361,
                        "name": "Plav",
                        "latitude": "42.59694000",
                        "longitude": "19.94556000"
                    }
                ]
            },
            {
                "id": 20,
                "name": "Pljevlja",
                "iso2": "14",
                "latitude": "43.27233830",
                "longitude": "19.28315310",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67362,
                        "name": "Pljevlja",
                        "latitude": "43.35670000",
                        "longitude": "19.35843000"
                    }
                ]
            },
            {
                "id": 16,
                "name": "Plužine",
                "iso2": "15",
                "latitude": "43.15933840",
                "longitude": "18.85514840",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67363,
                        "name": "Plužine",
                        "latitude": "43.15278000",
                        "longitude": "18.83944000"
                    }
                ]
            },
            {
                "id": 27,
                "name": "Podgorica",
                "iso2": "16",
                "latitude": "42.36938340",
                "longitude": "19.28315310",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67351,
                        "name": "Golubovci",
                        "latitude": "42.33500000",
                        "longitude": "19.23111000"
                    },
                    {
                        "id": 67352,
                        "name": "Goričani",
                        "latitude": "42.33222000",
                        "longitude": "19.21194000"
                    },
                    {
                        "id": 67356,
                        "name": "Mataguži",
                        "latitude": "42.32361000",
                        "longitude": "19.27278000"
                    },
                    {
                        "id": 67357,
                        "name": "Mojanovići",
                        "latitude": "42.34167000",
                        "longitude": "19.22139000"
                    },
                    {
                        "id": 67364,
                        "name": "Podgorica",
                        "latitude": "42.44111000",
                        "longitude": "19.26361000"
                    },
                    {
                        "id": 67372,
                        "name": "Tuzi",
                        "latitude": "42.36556000",
                        "longitude": "19.33139000"
                    }
                ]
            },
            {
                "id": 15,
                "name": "Rožaje",
                "iso2": "17",
                "latitude": "42.84083890",
                "longitude": "20.16706280",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67367,
                        "name": "Rožaje",
                        "latitude": "42.83299000",
                        "longitude": "20.16652000"
                    }
                ]
            },
            {
                "id": 18,
                "name": "Šavnik",
                "iso2": "18",
                "latitude": "42.96037560",
                "longitude": "19.14043800",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67374,
                        "name": "Šavnik",
                        "latitude": "42.95639000",
                        "longitude": "19.09667000"
                    }
                ]
            },
            {
                "id": 29,
                "name": "Tivat",
                "iso2": "19",
                "latitude": "42.42348000",
                "longitude": "18.71851840",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67371,
                        "name": "Tivat",
                        "latitude": "42.43639000",
                        "longitude": "18.69611000"
                    }
                ]
            },
            {
                "id": 33,
                "name": "Ulcinj",
                "iso2": "20",
                "latitude": "41.96527950",
                "longitude": "19.30694320",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67373,
                        "name": "Ulcinj",
                        "latitude": "41.92936000",
                        "longitude": "19.22436000"
                    }
                ]
            },
            {
                "id": 32,
                "name": "Žabljak",
                "iso2": "21",
                "latitude": "43.15551520",
                "longitude": "19.12260180",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67376,
                        "name": "Žabljak",
                        "latitude": "43.15423000",
                        "longitude": "19.12325000"
                    }
                ]
            }
        ]
    },
    {
        "id": 148,
        "name": "Montserrat",
        "iso3": "MSR",
        "iso2": "MS",
        "numeric_code": "500",
        "phonecode": "1",
        "capital": "Plymouth",
        "currency": "XCD",
        "currency_name": "Eastern Caribbean dollar",
        "currency_symbol": "$",
        "tld": ".ms",
        "native": "Montserrat",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Montserratian",
        "timezones": [
            {
                "zoneName": "America\/Montserrat",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Montserrat",
            "ko": "몬트세랫",
            "pt-BR": "Montserrat",
            "pt": "Monserrate",
            "nl": "Montserrat",
            "hr": "Montserrat",
            "fa": "مایوت",
            "de": "Montserrat",
            "es": "Montserrat",
            "fr": "Montserrat",
            "ja": "モントセラト",
            "it": "Montserrat",
            "zh-CN": "蒙特塞拉特",
            "tr": "Montserrat",
            "ru": "Монтсеррат",
            "uk": "Монтсеррат",
            "pl": "Montserrat"
        },
        "latitude": "16.75000000",
        "longitude": "-62.20000000",
        "emoji": "🇲🇸",
        "emojiU": "U+1F1F2 U+1F1F8",
        "states": [
            {
                "id": 5421,
                "name": "Saint Anthony",
                "iso2": "03",
                "latitude": "16.70893000",
                "longitude": "-62.23404970",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5420,
                "name": "Saint Georges",
                "iso2": "02",
                "latitude": "16.74847550",
                "longitude": "-62.19074720",
                "type": "parish",
                "cities": []
            },
            {
                "id": 5419,
                "name": "Saint Peter",
                "iso2": "01",
                "latitude": "16.77686580",
                "longitude": "-62.24434020",
                "type": "parish",
                "cities": []
            }
        ]
    },
    {
        "id": 149,
        "name": "Morocco",
        "iso3": "MAR",
        "iso2": "MA",
        "numeric_code": "504",
        "phonecode": "212",
        "capital": "Rabat",
        "currency": "MAD",
        "currency_name": "Moroccan dirham",
        "currency_symbol": "DH",
        "tld": ".ma",
        "native": "المغرب",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Northern Africa",
        "subregion_id": 1,
        "nationality": "Moroccan",
        "timezones": [
            {
                "zoneName": "Africa\/Casablanca",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WEST",
                "tzName": "Western European Summer Time"
            }
        ],
        "translations": null,
        "latitude": "32.00000000",
        "longitude": "-5.00000000",
        "emoji": "🇲🇦",
        "emojiU": "U+1F1F2 U+1F1E6",
        "states": [
            {
                "id": 4928,
                "name": "Agadir-Ida-Ou-Tanane",
                "iso2": "AGD",
                "latitude": "30.64620910",
                "longitude": "-9.83390610",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 3320,
                "name": "Al Haouz",
                "iso2": "HAO",
                "latitude": "31.29567290",
                "longitude": "-7.87216000",
                "type": "province",
                "cities": []
            },
            {
                "id": 3267,
                "name": "Al Hoceïma",
                "iso2": "HOC",
                "latitude": "35.24455890",
                "longitude": "-3.93174680",
                "type": "province",
                "cities": []
            },
            {
                "id": 3266,
                "name": "Aousserd (EH)",
                "iso2": "AOU",
                "latitude": "22.55215380",
                "longitude": "-14.32973530",
                "type": "province",
                "cities": []
            },
            {
                "id": 3297,
                "name": "Assa-Zag (EH-partial)",
                "iso2": "ASZ",
                "latitude": "28.14023950",
                "longitude": "-9.72326730",
                "type": "province",
                "cities": [
                    {
                        "id": 67046,
                        "name": "Agadir",
                        "latitude": "30.42018000",
                        "longitude": "-9.59815000"
                    },
                    {
                        "id": 67047,
                        "name": "Agadir Melloul",
                        "latitude": "30.22492000",
                        "longitude": "-7.79601000"
                    },
                    {
                        "id": 67048,
                        "name": "Agadir-Ida-ou-Tnan",
                        "latitude": "30.58333000",
                        "longitude": "-9.50000000"
                    },
                    {
                        "id": 67062,
                        "name": "Aoulouz",
                        "latitude": "30.67307000",
                        "longitude": "-8.18087000"
                    },
                    {
                        "id": 67063,
                        "name": "Aourir",
                        "latitude": "30.49238000",
                        "longitude": "-9.63550000"
                    },
                    {
                        "id": 67065,
                        "name": "Arazane",
                        "latitude": "30.50346000",
                        "longitude": "-8.60637000"
                    },
                    {
                        "id": 67068,
                        "name": "Argana",
                        "latitude": "30.78250000",
                        "longitude": "-9.11968000"
                    },
                    {
                        "id": 67084,
                        "name": "Bigoudine",
                        "latitude": "30.72376000",
                        "longitude": "-9.21097000"
                    },
                    {
                        "id": 67102,
                        "name": "Chtouka-Ait-Baha",
                        "latitude": "30.02948000",
                        "longitude": "-9.30909000"
                    },
                    {
                        "id": 67136,
                        "name": "Inezgane",
                        "latitude": "30.35535000",
                        "longitude": "-9.53639000"
                    },
                    {
                        "id": 67137,
                        "name": "Inezgane-Ait Melloul",
                        "latitude": "30.10000000",
                        "longitude": "-9.03333000"
                    },
                    {
                        "id": 67185,
                        "name": "Ouijjane",
                        "latitude": "29.62777000",
                        "longitude": "-9.53959000"
                    },
                    {
                        "id": 67190,
                        "name": "Oulad Teïma",
                        "latitude": "30.39467000",
                        "longitude": "-9.20897000"
                    },
                    {
                        "id": 67194,
                        "name": "Reggada",
                        "latitude": "29.58016000",
                        "longitude": "-9.70086000"
                    },
                    {
                        "id": 67208,
                        "name": "Sidi Ifni",
                        "latitude": "29.37975000",
                        "longitude": "-10.17299000"
                    },
                    {
                        "id": 67223,
                        "name": "Tadrart",
                        "latitude": "30.77477000",
                        "longitude": "-9.45951000"
                    },
                    {
                        "id": 67224,
                        "name": "Tafraout",
                        "latitude": "29.72449000",
                        "longitude": "-8.97470000"
                    },
                    {
                        "id": 67225,
                        "name": "Taghazout",
                        "latitude": "30.54259000",
                        "longitude": "-9.71115000"
                    },
                    {
                        "id": 67227,
                        "name": "Taliouine",
                        "latitude": "30.52917000",
                        "longitude": "-7.91262000"
                    },
                    {
                        "id": 67231,
                        "name": "Tamri",
                        "latitude": "30.69602000",
                        "longitude": "-9.82972000"
                    },
                    {
                        "id": 67233,
                        "name": "Tanalt",
                        "latitude": "29.77548000",
                        "longitude": "-9.16796000"
                    },
                    {
                        "id": 67241,
                        "name": "Taroudannt",
                        "latitude": "30.50000000",
                        "longitude": "-8.41667000"
                    },
                    {
                        "id": 67242,
                        "name": "Taroudant",
                        "latitude": "30.47028000",
                        "longitude": "-8.87695000"
                    },
                    {
                        "id": 67243,
                        "name": "Tarsouat",
                        "latitude": "29.58153000",
                        "longitude": "-9.02664000"
                    },
                    {
                        "id": 67244,
                        "name": "Tata",
                        "latitude": "29.66667000",
                        "longitude": "-7.83333000"
                    },
                    {
                        "id": 67259,
                        "name": "Tiznit",
                        "latitude": "29.58333000",
                        "longitude": "-9.50000000"
                    }
                ]
            },
            {
                "id": 3321,
                "name": "Azilal",
                "iso2": "AZI",
                "latitude": "32.00426200",
                "longitude": "-6.57833870",
                "type": "province",
                "cities": []
            },
            {
                "id": 3272,
                "name": "Béni Mellal",
                "iso2": "BEM",
                "latitude": "32.34244300",
                "longitude": "-6.37579900",
                "type": "province",
                "cities": []
            },
            {
                "id": 3278,
                "name": "Béni Mellal-Khénifra",
                "iso2": "05",
                "latitude": "32.57191840",
                "longitude": "-6.06791940",
                "type": "region",
                "cities": []
            },
            {
                "id": 3304,
                "name": "Benslimane",
                "iso2": "BES",
                "latitude": "33.61896980",
                "longitude": "-7.13055360",
                "type": "province",
                "cities": []
            },
            {
                "id": 3285,
                "name": "Berkane",
                "iso2": "BER",
                "latitude": "34.88408760",
                "longitude": "-2.34188700",
                "type": "province",
                "cities": []
            },
            {
                "id": 4929,
                "name": "Berrechid",
                "iso2": "BRR",
                "latitude": "33.26025230",
                "longitude": "-7.59848370",
                "type": "province",
                "cities": []
            },
            {
                "id": 3275,
                "name": "Boujdour (EH)",
                "iso2": "BOD",
                "latitude": "26.12524930",
                "longitude": "-14.48473470",
                "type": "province",
                "cities": []
            },
            {
                "id": 3270,
                "name": "Boulemane",
                "iso2": "BOM",
                "latitude": "33.36251590",
                "longitude": "-4.73033970",
                "type": "province",
                "cities": []
            },
            {
                "id": 4930,
                "name": "Casablanca",
                "iso2": "CAS",
                "latitude": "33.57226780",
                "longitude": "-7.65703260",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 3303,
                "name": "Casablanca-Settat",
                "iso2": "06",
                "latitude": "33.21608720",
                "longitude": "-7.43813550",
                "type": "region",
                "cities": [
                    {
                        "id": 67071,
                        "name": "Azemmour",
                        "latitude": "33.28952000",
                        "longitude": "-8.34250000"
                    },
                    {
                        "id": 67079,
                        "name": "Benslimane",
                        "latitude": "33.50000000",
                        "longitude": "-7.16667000"
                    },
                    {
                        "id": 67081,
                        "name": "Berrechid",
                        "latitude": "33.26553000",
                        "longitude": "-7.58754000"
                    },
                    {
                        "id": 67082,
                        "name": "Berrechid Province",
                        "latitude": "33.26582000",
                        "longitude": "-7.58142000"
                    },
                    {
                        "id": 67091,
                        "name": "Boulaouane",
                        "latitude": "32.85995000",
                        "longitude": "-8.05555000"
                    },
                    {
                        "id": 67093,
                        "name": "Bouskoura",
                        "latitude": "33.44976000",
                        "longitude": "-7.65239000"
                    },
                    {
                        "id": 67094,
                        "name": "Bouznika",
                        "latitude": "33.78942000",
                        "longitude": "-7.15968000"
                    },
                    {
                        "id": 67098,
                        "name": "Casablanca",
                        "latitude": "33.58840000",
                        "longitude": "-7.55785000"
                    },
                    {
                        "id": 67110,
                        "name": "El Jadid",
                        "latitude": "33.25682000",
                        "longitude": "-8.50882000"
                    },
                    {
                        "id": 67113,
                        "name": "El-Jadida",
                        "latitude": "32.90000000",
                        "longitude": "-8.50000000"
                    },
                    {
                        "id": 67162,
                        "name": "Mediouna",
                        "latitude": "33.52012000",
                        "longitude": "-7.50350000"
                    },
                    {
                        "id": 67170,
                        "name": "Mohammedia",
                        "latitude": "33.68607000",
                        "longitude": "-7.38298000"
                    },
                    {
                        "id": 67174,
                        "name": "Nouaceur",
                        "latitude": "33.45839000",
                        "longitude": "-7.64726000"
                    },
                    {
                        "id": 67175,
                        "name": "Oualidia",
                        "latitude": "32.73372000",
                        "longitude": "-9.03059000"
                    },
                    {
                        "id": 67188,
                        "name": "Oulad Frej",
                        "latitude": "32.95956000",
                        "longitude": "-8.22740000"
                    },
                    {
                        "id": 67203,
                        "name": "Settat",
                        "latitude": "33.00103000",
                        "longitude": "-7.61662000"
                    },
                    {
                        "id": 67204,
                        "name": "Settat Province",
                        "latitude": "33.08333000",
                        "longitude": "-7.41667000"
                    },
                    {
                        "id": 67206,
                        "name": "Sidi Bennour",
                        "latitude": "32.64896000",
                        "longitude": "-8.42686000"
                    },
                    {
                        "id": 67215,
                        "name": "Sidi Smai’il",
                        "latitude": "32.82461000",
                        "longitude": "-8.51122000"
                    },
                    {
                        "id": 67258,
                        "name": "Tit Mellil",
                        "latitude": "33.55808000",
                        "longitude": "-7.48647000"
                    },
                    {
                        "id": 67265,
                        "name": "Zawyat an Nwaçer",
                        "latitude": "33.37981000",
                        "longitude": "-7.61932000"
                    }
                ]
            },
            {
                "id": 3310,
                "name": "Chefchaouen",
                "iso2": "CHE",
                "latitude": "35.01817200",
                "longitude": "-5.14320680",
                "type": "province",
                "cities": []
            },
            {
                "id": 3274,
                "name": "Chichaoua",
                "iso2": "CHI",
                "latitude": "31.53835810",
                "longitude": "-8.76463880",
                "type": "province",
                "cities": []
            },
            {
                "id": 3302,
                "name": "Chtouka-Ait Baha",
                "iso2": "CHT",
                "latitude": "30.10724220",
                "longitude": "-9.27855830",
                "type": "province",
                "cities": []
            },
            {
                "id": 3306,
                "name": "Dakhla-Oued Ed-Dahab (EH)",
                "iso2": "12",
                "latitude": "22.60439730",
                "longitude": "-19.83482410",
                "type": "region",
                "cities": []
            },
            {
                "id": 3290,
                "name": "Drâa-Tafilalet",
                "iso2": "08",
                "latitude": "31.14995380",
                "longitude": "-5.39395510",
                "type": "region",
                "cities": [
                    {
                        "id": 67049,
                        "name": "Agdz",
                        "latitude": "30.69356000",
                        "longitude": "-6.44628000"
                    },
                    {
                        "id": 67060,
                        "name": "Alnif",
                        "latitude": "31.11411000",
                        "longitude": "-5.17154000"
                    },
                    {
                        "id": 67061,
                        "name": "Aoufous",
                        "latitude": "31.68000000",
                        "longitude": "-4.17000000"
                    },
                    {
                        "id": 67067,
                        "name": "Arfoud",
                        "latitude": "31.43530000",
                        "longitude": "-4.23258000"
                    },
                    {
                        "id": 67114,
                        "name": "Errachidia",
                        "latitude": "31.75000000",
                        "longitude": "-4.50000000"
                    },
                    {
                        "id": 67133,
                        "name": "Imilchil",
                        "latitude": "32.15309000",
                        "longitude": "-5.62453000"
                    },
                    {
                        "id": 67140,
                        "name": "Jebel Tiskaouine",
                        "latitude": "31.02722000",
                        "longitude": "-5.11643000"
                    },
                    {
                        "id": 67142,
                        "name": "Jorf",
                        "latitude": "31.49442000",
                        "longitude": "-4.40598000"
                    },
                    {
                        "id": 67145,
                        "name": "Kelaat Mgouna",
                        "latitude": "31.24573000",
                        "longitude": "-6.13260000"
                    },
                    {
                        "id": 67165,
                        "name": "Mhamid",
                        "latitude": "29.82000000",
                        "longitude": "-5.72000000"
                    },
                    {
                        "id": 67168,
                        "name": "Midelt",
                        "latitude": "32.68055000",
                        "longitude": "-4.73691000"
                    },
                    {
                        "id": 67177,
                        "name": "Ouarzazat",
                        "latitude": "30.91894000",
                        "longitude": "-6.89341000"
                    },
                    {
                        "id": 67178,
                        "name": "Ouarzazate",
                        "latitude": "30.94130000",
                        "longitude": "-6.90285000"
                    },
                    {
                        "id": 67196,
                        "name": "Reçani",
                        "latitude": "31.28318000",
                        "longitude": "-4.26565000"
                    },
                    {
                        "id": 67246,
                        "name": "Taznakht",
                        "latitude": "30.57836000",
                        "longitude": "-7.20341000"
                    },
                    {
                        "id": 67247,
                        "name": "Telouet",
                        "latitude": "31.28925000",
                        "longitude": "-7.23789000"
                    },
                    {
                        "id": 67255,
                        "name": "Tinghir",
                        "latitude": "31.51472000",
                        "longitude": "-5.53278000"
                    },
                    {
                        "id": 67256,
                        "name": "Tinghir Province",
                        "latitude": "31.51965000",
                        "longitude": "-5.52999000"
                    },
                    {
                        "id": 67264,
                        "name": "Zagora",
                        "latitude": "30.34839000",
                        "longitude": "-5.83649000"
                    }
                ]
            },
            {
                "id": 4931,
                "name": "Driouch",
                "iso2": "DRI",
                "latitude": "34.97603200",
                "longitude": "-3.39644930",
                "type": "province",
                "cities": []
            },
            {
                "id": 3291,
                "name": "El Hajeb",
                "iso2": "HAJ",
                "latitude": "33.68573500",
                "longitude": "-5.36778440",
                "type": "province",
                "cities": []
            },
            {
                "id": 3280,
                "name": "El Jadida",
                "iso2": "JDI",
                "latitude": "33.23163260",
                "longitude": "-8.50071160",
                "type": "province",
                "cities": []
            },
            {
                "id": 3309,
                "name": "El Kelâa des Sraghna",
                "iso2": "KES",
                "latitude": "32.05227670",
                "longitude": "-7.35165580",
                "type": "province",
                "cities": []
            },
            {
                "id": 3299,
                "name": "Errachidia",
                "iso2": "ERR",
                "latitude": "31.90512750",
                "longitude": "-4.72775280",
                "type": "province",
                "cities": []
            },
            {
                "id": 3292,
                "name": "Es-Semara (EH-partial)",
                "iso2": "ESM",
                "latitude": "26.74185600",
                "longitude": "-11.67836710",
                "type": "province",
                "cities": []
            },
            {
                "id": 3316,
                "name": "Essaouira",
                "iso2": "ESI",
                "latitude": "31.50849260",
                "longitude": "-9.75950410",
                "type": "province",
                "cities": []
            },
            {
                "id": 3300,
                "name": "Fahs-Anjra",
                "iso2": "FAH",
                "latitude": "35.76019920",
                "longitude": "-5.66683060",
                "type": "province",
                "cities": []
            },
            {
                "id": 4932,
                "name": "Fès",
                "iso2": "FES",
                "latitude": "34.02395790",
                "longitude": "-5.03675990",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 3313,
                "name": "Fès-Meknès",
                "iso2": "03",
                "latitude": "34.06252900",
                "longitude": "-4.72775280",
                "type": "region",
                "cities": [
                    {
                        "id": 67076,
                        "name": "Aïn Leuh",
                        "latitude": "33.28984000",
                        "longitude": "-5.33863000"
                    },
                    {
                        "id": 67053,
                        "name": "Aknoul",
                        "latitude": "34.65371000",
                        "longitude": "-3.86754000"
                    },
                    {
                        "id": 67059,
                        "name": "Almis Marmoucha",
                        "latitude": "33.32000000",
                        "longitude": "-4.18000000"
                    },
                    {
                        "id": 67074,
                        "name": "Azrou",
                        "latitude": "33.43443000",
                        "longitude": "-5.22126000"
                    },
                    {
                        "id": 67083,
                        "name": "Bhalil",
                        "latitude": "33.85194000",
                        "longitude": "-4.87228000"
                    },
                    {
                        "id": 67088,
                        "name": "Bouarouss",
                        "latitude": "34.36000000",
                        "longitude": "-4.81000000"
                    },
                    {
                        "id": 67092,
                        "name": "Boulemane",
                        "latitude": "33.16667000",
                        "longitude": "-4.00000000"
                    },
                    {
                        "id": 67109,
                        "name": "El Hajeb",
                        "latitude": "33.68786000",
                        "longitude": "-5.37100000"
                    },
                    {
                        "id": 67112,
                        "name": "El-Hajeb",
                        "latitude": "33.72883000",
                        "longitude": "-5.46119000"
                    },
                    {
                        "id": 67118,
                        "name": "Fes",
                        "latitude": "34.04000000",
                        "longitude": "-4.87000000"
                    },
                    {
                        "id": 67123,
                        "name": "Fès al Bali",
                        "latitude": "34.07010000",
                        "longitude": "-4.95473000"
                    },
                    {
                        "id": 67124,
                        "name": "Galaz",
                        "latitude": "34.54424000",
                        "longitude": "-4.80355000"
                    },
                    {
                        "id": 67125,
                        "name": "Ghouazi",
                        "latitude": "34.47737000",
                        "longitude": "-5.30235000"
                    },
                    {
                        "id": 67128,
                        "name": "Guercif",
                        "latitude": "34.22568000",
                        "longitude": "-3.35361000"
                    },
                    {
                        "id": 67132,
                        "name": "Ifrane",
                        "latitude": "33.33333000",
                        "longitude": "-5.25000000"
                    },
                    {
                        "id": 67163,
                        "name": "Meknes",
                        "latitude": "33.97761000",
                        "longitude": "-5.52496000"
                    },
                    {
                        "id": 67169,
                        "name": "Missour",
                        "latitude": "33.04893000",
                        "longitude": "-3.98947000"
                    },
                    {
                        "id": 67171,
                        "name": "Moulay Bouchta",
                        "latitude": "34.48922000",
                        "longitude": "-5.13023000"
                    },
                    {
                        "id": 67172,
                        "name": "Moulay-Yacoub",
                        "latitude": "34.14558000",
                        "longitude": "-5.10259000"
                    },
                    {
                        "id": 67179,
                        "name": "Oued Amlil",
                        "latitude": "34.20000000",
                        "longitude": "-4.28000000"
                    },
                    {
                        "id": 67189,
                        "name": "Oulad Tayeb",
                        "latitude": "33.94633000",
                        "longitude": "-4.99509000"
                    },
                    {
                        "id": 67192,
                        "name": "Ourtzagh",
                        "latitude": "34.53477000",
                        "longitude": "-4.96878000"
                    },
                    {
                        "id": 67200,
                        "name": "Sefrou",
                        "latitude": "33.79979000",
                        "longitude": "-4.68000000"
                    },
                    {
                        "id": 67226,
                        "name": "Tahla",
                        "latitude": "34.04965000",
                        "longitude": "-4.42162000"
                    },
                    {
                        "id": 67228,
                        "name": "Talzemt",
                        "latitude": "33.59000000",
                        "longitude": "-4.19000000"
                    },
                    {
                        "id": 67237,
                        "name": "Taounate",
                        "latitude": "34.50000000",
                        "longitude": "-4.83333000"
                    },
                    {
                        "id": 67245,
                        "name": "Taza",
                        "latitude": "34.25000000",
                        "longitude": "-3.75000000"
                    },
                    {
                        "id": 67261,
                        "name": "Tmourghout",
                        "latitude": "33.90650000",
                        "longitude": "-4.02696000"
                    }
                ]
            },
            {
                "id": 3301,
                "name": "Figuig",
                "iso2": "FIG",
                "latitude": "32.10926130",
                "longitude": "-1.22980600",
                "type": "province",
                "cities": []
            },
            {
                "id": 4933,
                "name": "Fquih Ben Salah",
                "iso2": "FQH",
                "latitude": "32.50016800",
                "longitude": "-6.71007170",
                "type": "province",
                "cities": []
            },
            {
                "id": 3265,
                "name": "Guelmim",
                "iso2": "GUE",
                "latitude": "28.98836590",
                "longitude": "-10.05274980",
                "type": "province",
                "cities": []
            },
            {
                "id": 3305,
                "name": "Guelmim-Oued Noun (EH-partial)",
                "iso2": "10",
                "latitude": "28.48442810",
                "longitude": "-10.08072980",
                "type": "region",
                "cities": [
                    {
                        "id": 67070,
                        "name": "Assa-Zag",
                        "latitude": "28.16667000",
                        "longitude": "-9.41667000"
                    },
                    {
                        "id": 67126,
                        "name": "Guelmim",
                        "latitude": "28.75000000",
                        "longitude": "-10.00000000"
                    },
                    {
                        "id": 67209,
                        "name": "Sidi Ifni",
                        "latitude": "29.37719000",
                        "longitude": "-10.17111000"
                    },
                    {
                        "id": 67232,
                        "name": "Tan-Tan",
                        "latitude": "28.08333000",
                        "longitude": "-11.08333000"
                    }
                ]
            },
            {
                "id": 4934,
                "name": "Guercif",
                "iso2": "GUF",
                "latitude": "34.23450360",
                "longitude": "-3.38130050",
                "type": "province",
                "cities": []
            },
            {
                "id": 3325,
                "name": "Ifrane",
                "iso2": "IFR",
                "latitude": "33.52280620",
                "longitude": "-5.11095520",
                "type": "province",
                "cities": []
            },
            {
                "id": 3294,
                "name": "Inezgane-Ait Melloul",
                "iso2": "INE",
                "latitude": "30.35090980",
                "longitude": "-9.38951100",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 3307,
                "name": "Jerada",
                "iso2": "JRA",
                "latitude": "34.30617910",
                "longitude": "-2.17941360",
                "type": "province",
                "cities": []
            },
            {
                "id": 3308,
                "name": "Kénitra",
                "iso2": "KEN",
                "latitude": "34.25405030",
                "longitude": "-6.58901660",
                "type": "province",
                "cities": [
                    {
                        "id": 67066,
                        "name": "Arbaoua",
                        "latitude": "34.90239000",
                        "longitude": "-5.94871000"
                    },
                    {
                        "id": 67130,
                        "name": "Had Kourt",
                        "latitude": "34.61588000",
                        "longitude": "-5.74040000"
                    },
                    {
                        "id": 67146,
                        "name": "Kenitra",
                        "latitude": "34.26101000",
                        "longitude": "-6.58020000"
                    },
                    {
                        "id": 67147,
                        "name": "Kenitra Province",
                        "latitude": "34.58333000",
                        "longitude": "-6.33333000"
                    },
                    {
                        "id": 67149,
                        "name": "Khemisset",
                        "latitude": "33.66667000",
                        "longitude": "-6.25000000"
                    },
                    {
                        "id": 67161,
                        "name": "Mechraa Bel Ksiri",
                        "latitude": "34.57373000",
                        "longitude": "-5.95585000"
                    },
                    {
                        "id": 67191,
                        "name": "Oulmes",
                        "latitude": "33.42585000",
                        "longitude": "-6.00137000"
                    },
                    {
                        "id": 67193,
                        "name": "Rabat",
                        "latitude": "34.01325000",
                        "longitude": "-6.83255000"
                    },
                    {
                        "id": 67199,
                        "name": "Sale",
                        "latitude": "34.05310000",
                        "longitude": "-6.79846000"
                    },
                    {
                        "id": 67207,
                        "name": "Sidi Bousber",
                        "latitude": "34.56283000",
                        "longitude": "-5.36208000"
                    },
                    {
                        "id": 67211,
                        "name": "Sidi Qacem",
                        "latitude": "34.22149000",
                        "longitude": "-5.70775000"
                    },
                    {
                        "id": 67213,
                        "name": "Sidi Redouane",
                        "latitude": "34.68692000",
                        "longitude": "-5.44538000"
                    },
                    {
                        "id": 67214,
                        "name": "Sidi Slimane",
                        "latitude": "34.26479000",
                        "longitude": "-5.92598000"
                    },
                    {
                        "id": 67216,
                        "name": "Sidi Yahia El Gharb",
                        "latitude": "34.30494000",
                        "longitude": "-6.30404000"
                    },
                    {
                        "id": 67217,
                        "name": "Sidi-Kacem",
                        "latitude": "34.58333000",
                        "longitude": "-5.75000000"
                    },
                    {
                        "id": 67218,
                        "name": "Skhirate",
                        "latitude": "33.85270000",
                        "longitude": "-7.03171000"
                    },
                    {
                        "id": 67219,
                        "name": "Skhirate-Temara",
                        "latitude": "33.77000000",
                        "longitude": "-6.87000000"
                    },
                    {
                        "id": 67222,
                        "name": "Souq Larb’a al Gharb",
                        "latitude": "34.68664000",
                        "longitude": "-6.00272000"
                    },
                    {
                        "id": 67248,
                        "name": "Temara",
                        "latitude": "33.92866000",
                        "longitude": "-6.90656000"
                    },
                    {
                        "id": 67249,
                        "name": "Teroual",
                        "latitude": "34.67452000",
                        "longitude": "-5.27331000"
                    },
                    {
                        "id": 67252,
                        "name": "Tiflet",
                        "latitude": "33.89469000",
                        "longitude": "-6.30649000"
                    }
                ]
            },
            {
                "id": 3276,
                "name": "Khémisset",
                "iso2": "KHE",
                "latitude": "33.81537040",
                "longitude": "-6.05733020",
                "type": "province",
                "cities": []
            },
            {
                "id": 3317,
                "name": "Khénifra",
                "iso2": "KHN",
                "latitude": "32.93404710",
                "longitude": "-5.66157100",
                "type": "province",
                "cities": [
                    {
                        "id": 67050,
                        "name": "Aguelmous",
                        "latitude": "33.16139000",
                        "longitude": "-5.84626000"
                    },
                    {
                        "id": 67055,
                        "name": "Al Fqih Ben Çalah",
                        "latitude": "32.50213000",
                        "longitude": "-6.68771000"
                    },
                    {
                        "id": 67072,
                        "name": "Azilal",
                        "latitude": "31.96156000",
                        "longitude": "-6.57109000"
                    },
                    {
                        "id": 67073,
                        "name": "Azilal Province",
                        "latitude": "31.91667000",
                        "longitude": "-6.50000000"
                    },
                    {
                        "id": 67077,
                        "name": "Beni Mellal",
                        "latitude": "32.33725000",
                        "longitude": "-6.34983000"
                    },
                    {
                        "id": 67078,
                        "name": "Beni-Mellal",
                        "latitude": "32.50000000",
                        "longitude": "-6.33333000"
                    },
                    {
                        "id": 67090,
                        "name": "Boujniba",
                        "latitude": "32.90046000",
                        "longitude": "-6.77464000"
                    },
                    {
                        "id": 67096,
                        "name": "Bzou",
                        "latitude": "32.09171000",
                        "longitude": "-7.04786000"
                    },
                    {
                        "id": 67103,
                        "name": "Dar Ould Zidouh",
                        "latitude": "32.31247000",
                        "longitude": "-6.90494000"
                    },
                    {
                        "id": 67105,
                        "name": "Demnate",
                        "latitude": "31.73443000",
                        "longitude": "-7.00505000"
                    },
                    {
                        "id": 67111,
                        "name": "El Ksiba",
                        "latitude": "32.57286000",
                        "longitude": "-6.01947000"
                    },
                    {
                        "id": 67121,
                        "name": "Fquih Ben Salah Province",
                        "latitude": "32.50108000",
                        "longitude": "-6.68415000"
                    },
                    {
                        "id": 67131,
                        "name": "Ifrane",
                        "latitude": "31.70217000",
                        "longitude": "-6.34940000"
                    },
                    {
                        "id": 67138,
                        "name": "Isseksi",
                        "latitude": "32.22981000",
                        "longitude": "-6.27661000"
                    },
                    {
                        "id": 67139,
                        "name": "Itzer",
                        "latitude": "32.87830000",
                        "longitude": "-5.05150000"
                    },
                    {
                        "id": 67143,
                        "name": "Kasba Tadla",
                        "latitude": "32.59770000",
                        "longitude": "-6.26844000"
                    },
                    {
                        "id": 67148,
                        "name": "Kerrouchen",
                        "latitude": "32.79639000",
                        "longitude": "-5.31880000"
                    },
                    {
                        "id": 67150,
                        "name": "Khenifra",
                        "latitude": "32.93333000",
                        "longitude": "-5.66667000"
                    },
                    {
                        "id": 67151,
                        "name": "Khouribga",
                        "latitude": "32.88108000",
                        "longitude": "-6.90630000"
                    },
                    {
                        "id": 67152,
                        "name": "Khouribga Province",
                        "latitude": "32.93333000",
                        "longitude": "-6.60000000"
                    },
                    {
                        "id": 67167,
                        "name": "Midelt",
                        "latitude": "32.68520000",
                        "longitude": "-4.74512000"
                    },
                    {
                        "id": 67176,
                        "name": "Ouaoula",
                        "latitude": "31.87000000",
                        "longitude": "-6.75000000"
                    },
                    {
                        "id": 67181,
                        "name": "Oued Zem",
                        "latitude": "32.86270000",
                        "longitude": "-6.57359000"
                    },
                    {
                        "id": 67210,
                        "name": "Sidi Jaber",
                        "latitude": "32.38952000",
                        "longitude": "-6.42095000"
                    },
                    {
                        "id": 67254,
                        "name": "Timoulilt",
                        "latitude": "32.20368000",
                        "longitude": "-6.46660000"
                    },
                    {
                        "id": 67266,
                        "name": "Zawyat ech Cheïkh",
                        "latitude": "32.64445000",
                        "longitude": "-5.91826000"
                    }
                ]
            },
            {
                "id": 3326,
                "name": "Khouribga",
                "iso2": "KHO",
                "latitude": "32.88602300",
                "longitude": "-6.92086550",
                "type": "province",
                "cities": []
            },
            {
                "id": 3271,
                "name": "L'Oriental",
                "iso2": "02",
                "latitude": "37.06968300",
                "longitude": "-94.51227700",
                "type": "region",
                "cities": [
                    {
                        "id": 67051,
                        "name": "Ahfir",
                        "latitude": "34.95368000",
                        "longitude": "-2.10027000"
                    },
                    {
                        "id": 67075,
                        "name": "Aïn Beni Mathar",
                        "latitude": "34.00970000",
                        "longitude": "-2.03238000"
                    },
                    {
                        "id": 67054,
                        "name": "Al Aaroui",
                        "latitude": "35.01090000",
                        "longitude": "-3.00938000"
                    },
                    {
                        "id": 67080,
                        "name": "Berkane",
                        "latitude": "34.61000000",
                        "longitude": "-2.57000000"
                    },
                    {
                        "id": 67087,
                        "name": "Bouarfa",
                        "latitude": "32.53379000",
                        "longitude": "-1.96209000"
                    },
                    {
                        "id": 67104,
                        "name": "Debdou",
                        "latitude": "33.98228000",
                        "longitude": "-3.04263000"
                    },
                    {
                        "id": 67107,
                        "name": "Driouch Province",
                        "latitude": "34.97670000",
                        "longitude": "-3.38842000"
                    },
                    {
                        "id": 67108,
                        "name": "El Aïoun",
                        "latitude": "34.58319000",
                        "longitude": "-2.50612000"
                    },
                    {
                        "id": 67119,
                        "name": "Figuig",
                        "latitude": "32.83333000",
                        "longitude": "-2.25000000"
                    },
                    {
                        "id": 67129,
                        "name": "Guercif Province",
                        "latitude": "34.25041000",
                        "longitude": "-3.32542000"
                    },
                    {
                        "id": 67141,
                        "name": "Jerada",
                        "latitude": "34.23662000",
                        "longitude": "-2.04284000"
                    },
                    {
                        "id": 67157,
                        "name": "Madagh",
                        "latitude": "35.01032000",
                        "longitude": "-2.33701000"
                    },
                    {
                        "id": 67166,
                        "name": "Midar",
                        "latitude": "34.94025000",
                        "longitude": "-3.53311000"
                    },
                    {
                        "id": 67173,
                        "name": "Nador",
                        "latitude": "35.00000000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 67186,
                        "name": "Oujda-Angad",
                        "latitude": "34.23600000",
                        "longitude": "-2.29400000"
                    },
                    {
                        "id": 67198,
                        "name": "Saidia",
                        "latitude": "35.08195000",
                        "longitude": "-2.22897000"
                    },
                    {
                        "id": 67201,
                        "name": "Selouane",
                        "latitude": "35.07313000",
                        "longitude": "-2.94230000"
                    },
                    {
                        "id": 67238,
                        "name": "Taourirt",
                        "latitude": "34.40731000",
                        "longitude": "-2.89732000"
                    },
                    {
                        "id": 67260,
                        "name": "Tiztoutine",
                        "latitude": "34.97159000",
                        "longitude": "-3.15273000"
                    },
                    {
                        "id": 67267,
                        "name": "Zaïo",
                        "latitude": "34.94282000",
                        "longitude": "-2.73290000"
                    }
                ]
            },
            {
                "id": 3293,
                "name": "Laâyoune (EH)",
                "iso2": "LAA",
                "latitude": "27.15003840",
                "longitude": "-13.19907580",
                "type": "province",
                "cities": []
            },
            {
                "id": 3298,
                "name": "Laâyoune-Sakia El Hamra (EH-partial)",
                "iso2": "11",
                "latitude": "27.86831940",
                "longitude": "-11.98046130",
                "type": "region",
                "cities": [
                    {
                        "id": 67052,
                        "name": "Akhfennir",
                        "latitude": "28.09455000",
                        "longitude": "-12.05157000"
                    },
                    {
                        "id": 67089,
                        "name": "Boujdour",
                        "latitude": "25.66172000",
                        "longitude": "-13.68419000"
                    },
                    {
                        "id": 67115,
                        "name": "Es-Semara",
                        "latitude": "27.75000000",
                        "longitude": "-11.00000000"
                    },
                    {
                        "id": 67127,
                        "name": "Gueltat Zemmour",
                        "latitude": "25.14276000",
                        "longitude": "-12.37168000"
                    },
                    {
                        "id": 67154,
                        "name": "Laayoune",
                        "latitude": "27.83333000",
                        "longitude": "-12.33333000"
                    },
                    {
                        "id": 67220,
                        "name": "Smara",
                        "latitude": "26.73841000",
                        "longitude": "-11.67194000"
                    },
                    {
                        "id": 67239,
                        "name": "Tarfaya",
                        "latitude": "27.93901000",
                        "longitude": "-12.92082000"
                    }
                ]
            },
            {
                "id": 3268,
                "name": "Larache",
                "iso2": "LAR",
                "latitude": "35.17442710",
                "longitude": "-6.14739640",
                "type": "province",
                "cities": []
            },
            {
                "id": 4936,
                "name": "M’diq-Fnideq",
                "iso2": "MDF",
                "latitude": "35.77330190",
                "longitude": "-5.51433000",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 4935,
                "name": "Marrakech",
                "iso2": "MAR",
                "latitude": "31.63460230",
                "longitude": "-8.07789320",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 3288,
                "name": "Marrakesh-Safi",
                "iso2": "07",
                "latitude": "31.73308330",
                "longitude": "-8.13385580",
                "type": "region",
                "cities": []
            },
            {
                "id": 3284,
                "name": "Médiouna",
                "iso2": "MED",
                "latitude": "33.45409390",
                "longitude": "-7.51660200",
                "type": "province",
                "cities": []
            },
            {
                "id": 4937,
                "name": "Meknès",
                "iso2": "MEK",
                "latitude": "33.88100000",
                "longitude": "-5.57303970",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 4938,
                "name": "Midelt",
                "iso2": "MID",
                "latitude": "32.68550790",
                "longitude": "-4.75017090",
                "type": "province",
                "cities": []
            },
            {
                "id": 4939,
                "name": "Mohammadia",
                "iso2": "MOH",
                "latitude": "33.68737490",
                "longitude": "-7.42391420",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 3315,
                "name": "Moulay Yacoub",
                "iso2": "MOU",
                "latitude": "34.08744790",
                "longitude": "-5.17840190",
                "type": "province",
                "cities": []
            },
            {
                "id": 3281,
                "name": "Nador",
                "iso2": "NAD",
                "latitude": "34.91719260",
                "longitude": "-2.85771050",
                "type": "province",
                "cities": []
            },
            {
                "id": 3287,
                "name": "Nouaceur",
                "iso2": "NOU",
                "latitude": "33.36703930",
                "longitude": "-7.57325370",
                "type": "province",
                "cities": []
            },
            {
                "id": 3269,
                "name": "Ouarzazate",
                "iso2": "OUA",
                "latitude": "30.93354360",
                "longitude": "-6.93701600",
                "type": "province",
                "cities": []
            },
            {
                "id": 3319,
                "name": "Oued Ed-Dahab (EH)",
                "iso2": "OUD",
                "latitude": "22.73378920",
                "longitude": "-14.28611160",
                "type": "province",
                "cities": [
                    {
                        "id": 67064,
                        "name": "Aousserd",
                        "latitude": "21.91977000",
                        "longitude": "-15.02068000"
                    },
                    {
                        "id": 67134,
                        "name": "Imlili",
                        "latitude": "22.65580000",
                        "longitude": "-15.60719000"
                    },
                    {
                        "id": 67182,
                        "name": "Oued-Ed-Dahab",
                        "latitude": "23.64201000",
                        "longitude": "-14.44934000"
                    }
                ]
            },
            {
                "id": 4941,
                "name": "Ouezzane",
                "iso2": "OUZ",
                "latitude": "34.80634500",
                "longitude": "-5.59145050",
                "type": "province",
                "cities": []
            },
            {
                "id": 4940,
                "name": "Oujda-Angad",
                "iso2": "OUJ",
                "latitude": "34.68375040",
                "longitude": "-2.29932390",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 4942,
                "name": "Rabat",
                "iso2": "RAB",
                "latitude": "33.96919900",
                "longitude": "-6.92730290",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 4927,
                "name": "Rabat-Salé-Kénitra",
                "iso2": "04",
                "latitude": "34.07686400",
                "longitude": "-7.34544760",
                "type": "region",
                "cities": []
            },
            {
                "id": 4943,
                "name": "Rehamna",
                "iso2": "REH",
                "latitude": "32.20329050",
                "longitude": "-8.56896710",
                "type": "province",
                "cities": []
            },
            {
                "id": 3311,
                "name": "Safi",
                "iso2": "SAF",
                "latitude": "32.29898720",
                "longitude": "-9.10134980",
                "type": "province",
                "cities": [
                    {
                        "id": 67044,
                        "name": "Abadou",
                        "latitude": "31.57917000",
                        "longitude": "-7.31308000"
                    },
                    {
                        "id": 67045,
                        "name": "Adassil",
                        "latitude": "31.10783000",
                        "longitude": "-8.49083000"
                    },
                    {
                        "id": 67057,
                        "name": "Al-Haouz",
                        "latitude": "31.34083000",
                        "longitude": "-7.91076000"
                    },
                    {
                        "id": 67086,
                        "name": "Bouabout",
                        "latitude": "31.26554000",
                        "longitude": "-9.17865000"
                    },
                    {
                        "id": 67101,
                        "name": "Chichaoua",
                        "latitude": "31.26365000",
                        "longitude": "-8.84411000"
                    },
                    {
                        "id": 67116,
                        "name": "Essaouira",
                        "latitude": "31.50675000",
                        "longitude": "-9.75655000"
                    },
                    {
                        "id": 67144,
                        "name": "Kelaa-Des-Sraghna",
                        "latitude": "32.16667000",
                        "longitude": "-7.75000000"
                    },
                    {
                        "id": 67158,
                        "name": "Marrakech",
                        "latitude": "31.63623000",
                        "longitude": "-8.01041000"
                    },
                    {
                        "id": 67159,
                        "name": "Marrakesh",
                        "latitude": "31.63416000",
                        "longitude": "-7.99994000"
                    },
                    {
                        "id": 67187,
                        "name": "Oukaïmedene",
                        "latitude": "31.20603000",
                        "longitude": "-7.86089000"
                    },
                    {
                        "id": 67195,
                        "name": "Rehamna",
                        "latitude": "32.24581000",
                        "longitude": "-7.93144000"
                    },
                    {
                        "id": 67197,
                        "name": "Safi",
                        "latitude": "32.16667000",
                        "longitude": "-8.83333000"
                    },
                    {
                        "id": 67205,
                        "name": "Setti Fatma",
                        "latitude": "31.22508000",
                        "longitude": "-7.67751000"
                    },
                    {
                        "id": 67212,
                        "name": "Sidi Rahhal",
                        "latitude": "31.65031000",
                        "longitude": "-7.47288000"
                    },
                    {
                        "id": 67221,
                        "name": "Smimou",
                        "latitude": "31.21014000",
                        "longitude": "-9.70863000"
                    },
                    {
                        "id": 67229,
                        "name": "Tamanar",
                        "latitude": "31.00087000",
                        "longitude": "-9.67802000"
                    },
                    {
                        "id": 67236,
                        "name": "Taouloukoult",
                        "latitude": "31.22218000",
                        "longitude": "-9.07943000"
                    },
                    {
                        "id": 67251,
                        "name": "Tidili Mesfioua",
                        "latitude": "31.46586000",
                        "longitude": "-7.61199000"
                    },
                    {
                        "id": 67253,
                        "name": "Timezgadiouine",
                        "latitude": "30.88366000",
                        "longitude": "-9.04548000"
                    },
                    {
                        "id": 67263,
                        "name": "Youssoufia",
                        "latitude": "32.24634000",
                        "longitude": "-8.52941000"
                    },
                    {
                        "id": 67268,
                        "name": "Zerkten",
                        "latitude": "31.44470000",
                        "longitude": "-7.39224000"
                    }
                ]
            },
            {
                "id": 4944,
                "name": "Salé",
                "iso2": "SAL",
                "latitude": "34.03775700",
                "longitude": "-6.84270730",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 3289,
                "name": "Sefrou",
                "iso2": "SEF",
                "latitude": "33.83052440",
                "longitude": "-4.83531540",
                "type": "province",
                "cities": []
            },
            {
                "id": 3282,
                "name": "Settat",
                "iso2": "SET",
                "latitude": "32.99242420",
                "longitude": "-7.62226650",
                "type": "province",
                "cities": []
            },
            {
                "id": 4945,
                "name": "Sidi Bennour",
                "iso2": "SIB",
                "latitude": "32.64926020",
                "longitude": "-8.44714530",
                "type": "province",
                "cities": []
            },
            {
                "id": 4946,
                "name": "Sidi Ifni",
                "iso2": "SIF",
                "latitude": "29.36657970",
                "longitude": "-10.21084850",
                "type": "province",
                "cities": []
            },
            {
                "id": 3279,
                "name": "Sidi Kacem",
                "iso2": "SIK",
                "latitude": "34.22601720",
                "longitude": "-5.71291640",
                "type": "province",
                "cities": []
            },
            {
                "id": 4952,
                "name": "Sidi Slimane",
                "iso2": "SIL",
                "latitude": "34.27378280",
                "longitude": "-5.98059720",
                "type": "province",
                "cities": []
            },
            {
                "id": 4947,
                "name": "Skhirate-Témara",
                "iso2": "SKH",
                "latitude": "33.76224250",
                "longitude": "-7.04190520",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 3295,
                "name": "Souss-Massa",
                "iso2": "09",
                "latitude": "30.27506110",
                "longitude": "-8.13385580",
                "type": "region",
                "cities": []
            },
            {
                "id": 3286,
                "name": "Tan-Tan (EH-partial)",
                "iso2": "TNT",
                "latitude": "28.03012000",
                "longitude": "-11.16173560",
                "type": "province",
                "cities": []
            },
            {
                "id": 4950,
                "name": "Tanger-Assilah",
                "iso2": "TNG",
                "latitude": "35.76325390",
                "longitude": "-5.90450980",
                "type": "prefecture",
                "cities": []
            },
            {
                "id": 3324,
                "name": "Tanger-Tétouan-Al Hoceïma",
                "iso2": "01",
                "latitude": "35.26295580",
                "longitude": "-5.56172790",
                "type": "region",
                "cities": [
                    {
                        "id": 67056,
                        "name": "Al Hoceïma",
                        "latitude": "35.25165000",
                        "longitude": "-3.93723000"
                    },
                    {
                        "id": 67058,
                        "name": "Al-Hoceima",
                        "latitude": "35.00000000",
                        "longitude": "-4.25000000"
                    },
                    {
                        "id": 67069,
                        "name": "Asilah",
                        "latitude": "35.46522000",
                        "longitude": "-6.03415000"
                    },
                    {
                        "id": 67085,
                        "name": "Bni Bouayach",
                        "latitude": "35.10506000",
                        "longitude": "-3.84028000"
                    },
                    {
                        "id": 67095,
                        "name": "Brikcha",
                        "latitude": "34.96732000",
                        "longitude": "-5.57295000"
                    },
                    {
                        "id": 67097,
                        "name": "Cap Negro II",
                        "latitude": "35.65970000",
                        "longitude": "-5.28525000"
                    },
                    {
                        "id": 67099,
                        "name": "Chefchaouen Province",
                        "latitude": "35.00000000",
                        "longitude": "-5.08333000"
                    },
                    {
                        "id": 67100,
                        "name": "Chefchaouene",
                        "latitude": "35.16878000",
                        "longitude": "-5.26360000"
                    },
                    {
                        "id": 67106,
                        "name": "Derdara",
                        "latitude": "35.11041000",
                        "longitude": "-5.29015000"
                    },
                    {
                        "id": 67117,
                        "name": "Fahs-Anjra",
                        "latitude": "35.74000000",
                        "longitude": "-5.68000000"
                    },
                    {
                        "id": 67120,
                        "name": "Fnidek",
                        "latitude": "35.84906000",
                        "longitude": "-5.35747000"
                    },
                    {
                        "id": 67135,
                        "name": "Imzouren",
                        "latitude": "35.14637000",
                        "longitude": "-3.85063000"
                    },
                    {
                        "id": 67153,
                        "name": "Ksar El Kebir",
                        "latitude": "35.00044000",
                        "longitude": "-5.90378000"
                    },
                    {
                        "id": 67155,
                        "name": "Larache",
                        "latitude": "35.16667000",
                        "longitude": "-5.83333000"
                    },
                    {
                        "id": 67156,
                        "name": "M'Diq-Fnideq",
                        "latitude": "35.85743000",
                        "longitude": "-5.35858000"
                    },
                    {
                        "id": 67160,
                        "name": "Martil",
                        "latitude": "35.61662000",
                        "longitude": "-5.27522000"
                    },
                    {
                        "id": 67180,
                        "name": "Oued Laou",
                        "latitude": "35.44840000",
                        "longitude": "-5.09627000"
                    },
                    {
                        "id": 67183,
                        "name": "Ouezzane",
                        "latitude": "34.79584000",
                        "longitude": "-5.57849000"
                    },
                    {
                        "id": 67184,
                        "name": "Ouezzane Province",
                        "latitude": "34.79759000",
                        "longitude": "-5.58603000"
                    },
                    {
                        "id": 67202,
                        "name": "Senada",
                        "latitude": "35.07452000",
                        "longitude": "-4.21583000"
                    },
                    {
                        "id": 67230,
                        "name": "Tamorot",
                        "latitude": "34.93632000",
                        "longitude": "-4.77940000"
                    },
                    {
                        "id": 67234,
                        "name": "Tanger-Assilah",
                        "latitude": "35.59000000",
                        "longitude": "-5.90000000"
                    },
                    {
                        "id": 67235,
                        "name": "Tangier",
                        "latitude": "35.76727000",
                        "longitude": "-5.79975000"
                    },
                    {
                        "id": 67240,
                        "name": "Targuist",
                        "latitude": "34.93769000",
                        "longitude": "-4.31856000"
                    },
                    {
                        "id": 67250,
                        "name": "Tetouan",
                        "latitude": "35.58333000",
                        "longitude": "-5.50000000"
                    },
                    {
                        "id": 67257,
                        "name": "Tirhanimîne",
                        "latitude": "35.23619000",
                        "longitude": "-3.95453000"
                    },
                    {
                        "id": 67269,
                        "name": "Zinat",
                        "latitude": "35.43000000",
                        "longitude": "-5.40000000"
                    },
                    {
                        "id": 67270,
                        "name": "Zoumi",
                        "latitude": "34.80321000",
                        "longitude": "-5.34458000"
                    }
                ]
            },
            {
                "id": 3323,
                "name": "Taounate",
                "iso2": "TAO",
                "latitude": "34.53691700",
                "longitude": "-4.63986930",
                "type": "province",
                "cities": []
            },
            {
                "id": 3322,
                "name": "Taourirt",
                "iso2": "TAI",
                "latitude": "34.21259800",
                "longitude": "-2.69838680",
                "type": "province",
                "cities": []
            },
            {
                "id": 4948,
                "name": "Tarfaya (EH-partial)",
                "iso2": "TAF",
                "latitude": "27.93777010",
                "longitude": "-12.92940630",
                "type": "province",
                "cities": []
            },
            {
                "id": 3314,
                "name": "Taroudannt",
                "iso2": "TAR",
                "latitude": "30.47271260",
                "longitude": "-8.87487650",
                "type": "province",
                "cities": []
            },
            {
                "id": 3312,
                "name": "Tata",
                "iso2": "TAT",
                "latitude": "29.75087700",
                "longitude": "-7.97563430",
                "type": "province",
                "cities": []
            },
            {
                "id": 3296,
                "name": "Taza",
                "iso2": "TAZ",
                "latitude": "34.27889530",
                "longitude": "-3.58126920",
                "type": "province",
                "cities": []
            },
            {
                "id": 3318,
                "name": "Tétouan",
                "iso2": "TET",
                "latitude": "35.58889950",
                "longitude": "-5.36255160",
                "type": "province",
                "cities": []
            },
            {
                "id": 4949,
                "name": "Tinghir",
                "iso2": "TIN",
                "latitude": "31.48507940",
                "longitude": "-6.20192980",
                "type": "province",
                "cities": []
            },
            {
                "id": 3277,
                "name": "Tiznit",
                "iso2": "TIZ",
                "latitude": "29.69339200",
                "longitude": "-9.73215700",
                "type": "province",
                "cities": []
            },
            {
                "id": 4951,
                "name": "Youssoufia",
                "iso2": "YUS",
                "latitude": "32.02006790",
                "longitude": "-8.86926480",
                "type": "province",
                "cities": []
            },
            {
                "id": 3283,
                "name": "Zagora",
                "iso2": "ZAG",
                "latitude": "30.57860930",
                "longitude": "-5.89871390",
                "type": "province",
                "cities": []
            }
        ]
    },
    {
        "id": 150,
        "name": "Mozambique",
        "iso3": "MOZ",
        "iso2": "MZ",
        "numeric_code": "508",
        "phonecode": "258",
        "capital": "Maputo",
        "currency": "MZN",
        "currency_name": "Mozambican metical",
        "currency_symbol": "MT",
        "tld": ".mz",
        "native": "Moçambique",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Mozambican",
        "timezones": [
            {
                "zoneName": "Africa\/Maputo",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "br": "Mozambik",
            "ko": "모잠비크",
            "pt-BR": "Moçambique",
            "pt": "Moçambique",
            "nl": "Mozambique",
            "hr": "Mozambik",
            "fa": "موزامبیک",
            "de": "Mosambik",
            "es": "Mozambique",
            "fr": "Mozambique",
            "ja": "モザンビーク",
            "it": "Mozambico",
            "zh-CN": "莫桑比克",
            "tr": "Mozambik",
            "ru": "Мозамбик",
            "uk": "Мозамбік",
            "pl": "Mozambik"
        },
        "latitude": "-18.25000000",
        "longitude": "35.00000000",
        "emoji": "🇲🇿",
        "emojiU": "U+1F1F2 U+1F1FF",
        "states": [
            {
                "id": 3327,
                "name": "Cabo Delgado",
                "iso2": "P",
                "latitude": "-12.33354740",
                "longitude": "39.32062410",
                "type": "province",
                "cities": [
                    {
                        "id": 76595,
                        "name": "Chiure",
                        "latitude": "-13.46665000",
                        "longitude": "39.70317000"
                    },
                    {
                        "id": 76614,
                        "name": "Mocímboa",
                        "latitude": "-11.31667000",
                        "longitude": "40.35000000"
                    },
                    {
                        "id": 76615,
                        "name": "Montepuez",
                        "latitude": "-13.12556000",
                        "longitude": "38.99972000"
                    },
                    {
                        "id": 76621,
                        "name": "Pemba",
                        "latitude": "-12.97395000",
                        "longitude": "40.51775000"
                    }
                ]
            },
            {
                "id": 3329,
                "name": "Gaza",
                "iso2": "G",
                "latitude": "-23.02219280",
                "longitude": "32.71813750",
                "type": "province",
                "cities": [
                    {
                        "id": 76592,
                        "name": "Chibuto",
                        "latitude": "-24.68667000",
                        "longitude": "33.53056000"
                    },
                    {
                        "id": 76596,
                        "name": "Chokwé",
                        "latitude": "-24.53333000",
                        "longitude": "32.98333000"
                    },
                    {
                        "id": 76604,
                        "name": "Macia",
                        "latitude": "-25.02694000",
                        "longitude": "33.09889000"
                    },
                    {
                        "id": 76625,
                        "name": "Xai-Xai",
                        "latitude": "-25.05194000",
                        "longitude": "33.64417000"
                    }
                ]
            },
            {
                "id": 3330,
                "name": "Inhambane",
                "iso2": "I",
                "latitude": "-22.85279970",
                "longitude": "34.55087580",
                "type": "province",
                "cities": [
                    {
                        "id": 76601,
                        "name": "Inhambane",
                        "latitude": "-23.86500000",
                        "longitude": "35.38333000"
                    },
                    {
                        "id": 76612,
                        "name": "Maxixe",
                        "latitude": "-23.85972000",
                        "longitude": "35.34722000"
                    }
                ]
            },
            {
                "id": 3337,
                "name": "Manica",
                "iso2": "B",
                "latitude": "-19.50597870",
                "longitude": "33.43835300",
                "type": "province",
                "cities": [
                    {
                        "id": 76593,
                        "name": "Chimoio",
                        "latitude": "-19.11639000",
                        "longitude": "33.48333000"
                    }
                ]
            },
            {
                "id": 3332,
                "name": "Maputo",
                "iso2": "L",
                "latitude": "-25.25698760",
                "longitude": "32.53727410",
                "type": "province",
                "cities": [
                    {
                        "id": 76591,
                        "name": "Boane District",
                        "latitude": "-26.02900000",
                        "longitude": "32.38900000"
                    },
                    {
                        "id": 76597,
                        "name": "Concelho de Matola",
                        "latitude": "-25.83472000",
                        "longitude": "32.49516000"
                    },
                    {
                        "id": 76605,
                        "name": "Magude District",
                        "latitude": "-25.02389000",
                        "longitude": "32.65150000"
                    },
                    {
                        "id": 76607,
                        "name": "Manhica",
                        "latitude": "-25.34035000",
                        "longitude": "32.84234000"
                    },
                    {
                        "id": 76609,
                        "name": "Marracuene District",
                        "latitude": "-25.73938000",
                        "longitude": "32.67436000"
                    },
                    {
                        "id": 76610,
                        "name": "Matola",
                        "latitude": "-25.96222000",
                        "longitude": "32.45889000"
                    },
                    {
                        "id": 76611,
                        "name": "Matutiune District",
                        "latitude": "-26.43418000",
                        "longitude": "32.58820000"
                    },
                    {
                        "id": 76613,
                        "name": "Moamba District",
                        "latitude": "-25.60934000",
                        "longitude": "32.24321000"
                    },
                    {
                        "id": 76618,
                        "name": "Namaacha District",
                        "latitude": "-26.10900000",
                        "longitude": "32.18000000"
                    },
                    {
                        "id": 76623,
                        "name": "Ressano Garcia",
                        "latitude": "-25.44278000",
                        "longitude": "31.99528000"
                    }
                ]
            },
            {
                "id": 3335,
                "name": "Maputo",
                "iso2": "MPM",
                "latitude": "-25.96924800",
                "longitude": "32.57317460",
                "type": "city",
                "cities": [
                    {
                        "id": 76602,
                        "name": "KaTembe",
                        "latitude": "-26.02985000",
                        "longitude": "32.53204000"
                    },
                    {
                        "id": 76608,
                        "name": "Maputo",
                        "latitude": "-25.96553000",
                        "longitude": "32.58322000"
                    }
                ]
            },
            {
                "id": 3336,
                "name": "Nampula",
                "iso2": "N",
                "latitude": "-14.76049310",
                "longitude": "39.32062410",
                "type": "province",
                "cities": [
                    {
                        "id": 76589,
                        "name": "António Enes",
                        "latitude": "-16.23250000",
                        "longitude": "39.90861000"
                    },
                    {
                        "id": 76600,
                        "name": "Ilha de Moçambique",
                        "latitude": "-15.03417000",
                        "longitude": "40.73583000"
                    },
                    {
                        "id": 76616,
                        "name": "Mutuáli",
                        "latitude": "-14.87056000",
                        "longitude": "37.00444000"
                    },
                    {
                        "id": 76617,
                        "name": "Nacala",
                        "latitude": "-14.56257000",
                        "longitude": "40.68538000"
                    },
                    {
                        "id": 76619,
                        "name": "Nampula",
                        "latitude": "-15.11646000",
                        "longitude": "39.26660000"
                    }
                ]
            },
            {
                "id": 3333,
                "name": "Niassa",
                "iso2": "A",
                "latitude": "-12.78262020",
                "longitude": "36.60939260",
                "type": "province",
                "cities": [
                    {
                        "id": 76598,
                        "name": "Cuamba",
                        "latitude": "-14.80306000",
                        "longitude": "36.53722000"
                    },
                    {
                        "id": 76603,
                        "name": "Lichinga",
                        "latitude": "-13.31278000",
                        "longitude": "35.24056000"
                    },
                    {
                        "id": 76606,
                        "name": "Mandimba",
                        "latitude": "-14.35250000",
                        "longitude": "35.65056000"
                    }
                ]
            },
            {
                "id": 3331,
                "name": "Sofala",
                "iso2": "S",
                "latitude": "-19.20390730",
                "longitude": "34.86241660",
                "type": "province",
                "cities": [
                    {
                        "id": 76590,
                        "name": "Beira",
                        "latitude": "-19.84361000",
                        "longitude": "34.83889000"
                    },
                    {
                        "id": 76599,
                        "name": "Dondo",
                        "latitude": "-19.60944000",
                        "longitude": "34.74306000"
                    },
                    {
                        "id": 76620,
                        "name": "Nhamatanda District",
                        "latitude": "-19.34900000",
                        "longitude": "34.26800000"
                    }
                ]
            },
            {
                "id": 3334,
                "name": "Tete",
                "iso2": "T",
                "latitude": "-15.65960560",
                "longitude": "32.71813750",
                "type": "province",
                "cities": [
                    {
                        "id": 76624,
                        "name": "Tete",
                        "latitude": "-16.15639000",
                        "longitude": "33.58667000"
                    }
                ]
            },
            {
                "id": 3328,
                "name": "Zambezia",
                "iso2": "Q",
                "latitude": "-16.56389870",
                "longitude": "36.60939260",
                "type": "province",
                "cities": [
                    {
                        "id": 76588,
                        "name": "Alto Molócuè",
                        "latitude": "-15.64932000",
                        "longitude": "37.66384000"
                    },
                    {
                        "id": 76594,
                        "name": "Chinde",
                        "latitude": "-18.58111000",
                        "longitude": "36.45861000"
                    },
                    {
                        "id": 76622,
                        "name": "Quelimane",
                        "latitude": "-17.87861000",
                        "longitude": "36.88833000"
                    }
                ]
            }
        ]
    },
    {
        "id": 151,
        "name": "Myanmar",
        "iso3": "MMR",
        "iso2": "MM",
        "numeric_code": "104",
        "phonecode": "95",
        "capital": "Nay Pyi Taw",
        "currency": "MMK",
        "currency_name": "Burmese kyat",
        "currency_symbol": "K",
        "tld": ".mm",
        "native": "မြန်မာ",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Burmese",
        "timezones": [
            {
                "zoneName": "Asia\/Yangon",
                "gmtOffset": 23400,
                "gmtOffsetName": "UTC+06:30",
                "abbreviation": "MMT",
                "tzName": "Myanmar Standard Time"
            }
        ],
        "translations": {
            "br": "Myanmar",
            "ko": "미얀마",
            "pt-BR": "Myanmar",
            "pt": "Myanmar",
            "nl": "Myanmar",
            "hr": "Mijanmar",
            "fa": "میانمار",
            "de": "Myanmar",
            "es": "Myanmar",
            "fr": "Myanmar",
            "ja": "ミャンマー",
            "it": "Birmania",
            "zh-CN": "缅甸",
            "tr": "Myanmar",
            "ru": "Мьянма",
            "uk": "М'янма",
            "pl": "Birma"
        },
        "latitude": "22.00000000",
        "longitude": "98.00000000",
        "emoji": "🇲🇲",
        "emojiU": "U+1F1F2 U+1F1F2",
        "states": [
            {
                "id": 2142,
                "name": "Ayeyarwady",
                "iso2": "07",
                "latitude": "17.03421250",
                "longitude": "95.22666750",
                "type": "region",
                "cities": [
                    {
                        "id": 67633,
                        "name": "Bogale",
                        "latitude": "16.29415000",
                        "longitude": "95.39742000"
                    },
                    {
                        "id": 67639,
                        "name": "Hinthada",
                        "latitude": "17.64944000",
                        "longitude": "95.45705000"
                    },
                    {
                        "id": 67646,
                        "name": "Kyaiklat",
                        "latitude": "16.44502000",
                        "longitude": "95.72373000"
                    },
                    {
                        "id": 67656,
                        "name": "Maubin",
                        "latitude": "16.73148000",
                        "longitude": "95.65441000"
                    },
                    {
                        "id": 67659,
                        "name": "Mawlamyinegyunn",
                        "latitude": "16.37720000",
                        "longitude": "95.26488000"
                    },
                    {
                        "id": 67666,
                        "name": "Myanaung",
                        "latitude": "18.28651000",
                        "longitude": "95.32014000"
                    },
                    {
                        "id": 67673,
                        "name": "Nyaungdon",
                        "latitude": "17.04459000",
                        "longitude": "95.63957000"
                    },
                    {
                        "id": 67677,
                        "name": "Pathein",
                        "latitude": "16.77919000",
                        "longitude": "94.73212000"
                    },
                    {
                        "id": 67680,
                        "name": "Pyapon",
                        "latitude": "16.28543000",
                        "longitude": "95.67882000"
                    },
                    {
                        "id": 67701,
                        "name": "Wakema",
                        "latitude": "16.60333000",
                        "longitude": "95.18278000"
                    }
                ]
            },
            {
                "id": 2141,
                "name": "Bago",
                "iso2": "02",
                "latitude": "17.32207110",
                "longitude": "96.46632860",
                "type": "region",
                "cities": [
                    {
                        "id": 67631,
                        "name": "Bago",
                        "latitude": "17.33521000",
                        "longitude": "96.48135000"
                    },
                    {
                        "id": 67651,
                        "name": "Letpandan",
                        "latitude": "17.78664000",
                        "longitude": "95.75076000"
                    },
                    {
                        "id": 67674,
                        "name": "Nyaunglebin",
                        "latitude": "17.95363000",
                        "longitude": "96.72247000"
                    },
                    {
                        "id": 67678,
                        "name": "Paungde",
                        "latitude": "18.49167000",
                        "longitude": "95.50591000"
                    },
                    {
                        "id": 67681,
                        "name": "Pyay",
                        "latitude": "18.82464000",
                        "longitude": "95.22216000"
                    },
                    {
                        "id": 67684,
                        "name": "Pyu",
                        "latitude": "18.48130000",
                        "longitude": "96.43742000"
                    },
                    {
                        "id": 67694,
                        "name": "Taungoo",
                        "latitude": "18.94291000",
                        "longitude": "96.43408000"
                    },
                    {
                        "id": 67695,
                        "name": "Thanatpin",
                        "latitude": "17.29136000",
                        "longitude": "96.57523000"
                    },
                    {
                        "id": 67696,
                        "name": "Tharyarwady",
                        "latitude": "17.65399000",
                        "longitude": "95.78813000"
                    }
                ]
            },
            {
                "id": 2137,
                "name": "Chin",
                "iso2": "14",
                "latitude": "22.00869780",
                "longitude": "93.58126920",
                "type": "state",
                "cities": [
                    {
                        "id": 67637,
                        "name": "Falam",
                        "latitude": "22.91335000",
                        "longitude": "93.67779000"
                    },
                    {
                        "id": 67638,
                        "name": "Hakha",
                        "latitude": "22.64452000",
                        "longitude": "93.61076000"
                    }
                ]
            },
            {
                "id": 2143,
                "name": "Kachin",
                "iso2": "11",
                "latitude": "25.85090400",
                "longitude": "97.43813550",
                "type": "state",
                "cities": [
                    {
                        "id": 67632,
                        "name": "Bhamo",
                        "latitude": "24.25256000",
                        "longitude": "97.23357000"
                    },
                    {
                        "id": 67671,
                        "name": "Myitkyina",
                        "latitude": "25.38327000",
                        "longitude": "97.39637000"
                    }
                ]
            },
            {
                "id": 2144,
                "name": "Kayah",
                "iso2": "12",
                "latitude": "19.23420610",
                "longitude": "97.26528580",
                "type": "state",
                "cities": [
                    {
                        "id": 67652,
                        "name": "Loikaw",
                        "latitude": "19.67798000",
                        "longitude": "97.20975000"
                    }
                ]
            },
            {
                "id": 2133,
                "name": "Kayin",
                "iso2": "13",
                "latitude": "16.94593460",
                "longitude": "97.95928630",
                "type": "state",
                "cities": [
                    {
                        "id": 67636,
                        "name": "Dellok",
                        "latitude": "16.04072000",
                        "longitude": "97.91773000"
                    },
                    {
                        "id": 67640,
                        "name": "Hpa-An",
                        "latitude": "16.88953000",
                        "longitude": "97.63482000"
                    },
                    {
                        "id": 67644,
                        "name": "Klonhtoug",
                        "latitude": "15.95411000",
                        "longitude": "98.43250000"
                    },
                    {
                        "id": 67648,
                        "name": "Kyain Seikgyi Township",
                        "latitude": "15.82288000",
                        "longitude": "98.25257000"
                    },
                    {
                        "id": 67661,
                        "name": "Mikenaungea",
                        "latitude": "15.95846000",
                        "longitude": "98.42721000"
                    },
                    {
                        "id": 67667,
                        "name": "Myawadi",
                        "latitude": "16.68911000",
                        "longitude": "98.50893000"
                    },
                    {
                        "id": 67679,
                        "name": "Pulei",
                        "latitude": "16.06243000",
                        "longitude": "97.88280000"
                    },
                    {
                        "id": 67690,
                        "name": "Tagondaing",
                        "latitude": "16.06750000",
                        "longitude": "97.90694000"
                    },
                    {
                        "id": 67691,
                        "name": "Tamoowoug",
                        "latitude": "16.03447000",
                        "longitude": "97.91458000"
                    }
                ]
            },
            {
                "id": 2136,
                "name": "Magway",
                "iso2": "03",
                "latitude": "19.88713860",
                "longitude": "94.72775280",
                "type": "region",
                "cities": [
                    {
                        "id": 67634,
                        "name": "Chauk",
                        "latitude": "20.89921000",
                        "longitude": "94.81784000"
                    },
                    {
                        "id": 67653,
                        "name": "Magway",
                        "latitude": "20.14956000",
                        "longitude": "94.93246000"
                    },
                    {
                        "id": 67662,
                        "name": "Minbu",
                        "latitude": "20.18059000",
                        "longitude": "94.87595000"
                    },
                    {
                        "id": 67668,
                        "name": "Myaydo",
                        "latitude": "19.36838000",
                        "longitude": "95.21512000"
                    },
                    {
                        "id": 67676,
                        "name": "Pakokku",
                        "latitude": "21.33489000",
                        "longitude": "95.08438000"
                    },
                    {
                        "id": 67692,
                        "name": "Taungdwingyi",
                        "latitude": "20.00650000",
                        "longitude": "95.54531000"
                    },
                    {
                        "id": 67698,
                        "name": "Thayetmyo",
                        "latitude": "19.32076000",
                        "longitude": "95.18272000"
                    },
                    {
                        "id": 67704,
                        "name": "Yenangyaung",
                        "latitude": "20.46504000",
                        "longitude": "94.87120000"
                    }
                ]
            },
            {
                "id": 2134,
                "name": "Mandalay",
                "iso2": "04",
                "latitude": "21.56190580",
                "longitude": "95.89871390",
                "type": "region",
                "cities": [
                    {
                        "id": 67649,
                        "name": "Kyaukse",
                        "latitude": "21.60560000",
                        "longitude": "96.13508000"
                    },
                    {
                        "id": 67654,
                        "name": "Mandalay",
                        "latitude": "21.97473000",
                        "longitude": "96.08359000"
                    },
                    {
                        "id": 67660,
                        "name": "Meiktila",
                        "latitude": "20.87776000",
                        "longitude": "95.85844000"
                    },
                    {
                        "id": 67663,
                        "name": "Mogok",
                        "latitude": "22.91766000",
                        "longitude": "96.50982000"
                    },
                    {
                        "id": 67670,
                        "name": "Myingyan",
                        "latitude": "21.46002000",
                        "longitude": "95.38840000"
                    },
                    {
                        "id": 67675,
                        "name": "Nyaungshwe",
                        "latitude": "20.66084000",
                        "longitude": "96.93405000"
                    },
                    {
                        "id": 67682,
                        "name": "Pyin Oo Lwin",
                        "latitude": "22.03501000",
                        "longitude": "96.45683000"
                    },
                    {
                        "id": 67702,
                        "name": "Yamethin",
                        "latitude": "20.43189000",
                        "longitude": "96.13875000"
                    }
                ]
            },
            {
                "id": 2147,
                "name": "Mon State",
                "iso2": "15",
                "latitude": "16.30031330",
                "longitude": "97.69822720",
                "type": "state",
                "cities": [
                    {
                        "id": 67645,
                        "name": "Kyaikkami",
                        "latitude": "16.07686000",
                        "longitude": "97.56388000"
                    },
                    {
                        "id": 67647,
                        "name": "Kyaikto",
                        "latitude": "17.30858000",
                        "longitude": "97.01124000"
                    },
                    {
                        "id": 67655,
                        "name": "Martaban",
                        "latitude": "16.52834000",
                        "longitude": "97.61570000"
                    },
                    {
                        "id": 67658,
                        "name": "Mawlamyine",
                        "latitude": "16.49051000",
                        "longitude": "97.62825000"
                    },
                    {
                        "id": 67665,
                        "name": "Mudon",
                        "latitude": "16.25624000",
                        "longitude": "97.72460000"
                    },
                    {
                        "id": 67697,
                        "name": "Thaton",
                        "latitude": "16.91867000",
                        "longitude": "97.37001000"
                    }
                ]
            },
            {
                "id": 2146,
                "name": "Naypyidaw",
                "iso2": "18",
                "latitude": "19.93862450",
                "longitude": "96.15269850",
                "type": "union territory",
                "cities": [
                    {
                        "id": 67672,
                        "name": "Nay Pyi Taw",
                        "latitude": "19.74500000",
                        "longitude": "96.12972000"
                    },
                    {
                        "id": 67683,
                        "name": "Pyinmana",
                        "latitude": "19.73810000",
                        "longitude": "96.20742000"
                    }
                ]
            },
            {
                "id": 2138,
                "name": "Rakhine",
                "iso2": "16",
                "latitude": "20.10408180",
                "longitude": "93.58126920",
                "type": "state",
                "cities": [
                    {
                        "id": 67687,
                        "name": "Sittwe",
                        "latitude": "20.14624000",
                        "longitude": "92.89835000"
                    }
                ]
            },
            {
                "id": 2145,
                "name": "Sagaing",
                "iso2": "01",
                "latitude": "24.42838100",
                "longitude": "95.39395510",
                "type": "region",
                "cities": [
                    {
                        "id": 67657,
                        "name": "Mawlaik",
                        "latitude": "23.64254000",
                        "longitude": "94.40478000"
                    },
                    {
                        "id": 67664,
                        "name": "Monywa",
                        "latitude": "22.10856000",
                        "longitude": "95.13583000"
                    },
                    {
                        "id": 67685,
                        "name": "Sagaing",
                        "latitude": "21.87870000",
                        "longitude": "95.97965000"
                    },
                    {
                        "id": 67686,
                        "name": "Shwebo",
                        "latitude": "22.56925000",
                        "longitude": "95.69818000"
                    }
                ]
            },
            {
                "id": 2139,
                "name": "Shan",
                "iso2": "17",
                "latitude": "22.03619850",
                "longitude": "98.13385580",
                "type": "state",
                "cities": [
                    {
                        "id": 67650,
                        "name": "Lashio",
                        "latitude": "22.93590000",
                        "longitude": "97.74980000"
                    },
                    {
                        "id": 67689,
                        "name": "Tachilek",
                        "latitude": "20.44750000",
                        "longitude": "99.88083000"
                    },
                    {
                        "id": 67693,
                        "name": "Taunggyi",
                        "latitude": "20.78919000",
                        "longitude": "97.03776000"
                    }
                ]
            },
            {
                "id": 2140,
                "name": "Tanintharyi",
                "iso2": "05",
                "latitude": "12.47068760",
                "longitude": "99.01289260",
                "type": "region",
                "cities": [
                    {
                        "id": 67635,
                        "name": "Dawei",
                        "latitude": "14.08230000",
                        "longitude": "98.19151000"
                    },
                    {
                        "id": 67642,
                        "name": "Kawthoung",
                        "latitude": "9.98238000",
                        "longitude": "98.55034000"
                    },
                    {
                        "id": 67669,
                        "name": "Myeik",
                        "latitude": "12.43954000",
                        "longitude": "98.60028000"
                    }
                ]
            },
            {
                "id": 2135,
                "name": "Yangon",
                "iso2": "06",
                "latitude": "16.91434880",
                "longitude": "96.15269850",
                "type": "region",
                "cities": [
                    {
                        "id": 67641,
                        "name": "Kanbe",
                        "latitude": "16.70728000",
                        "longitude": "96.00168000"
                    },
                    {
                        "id": 67643,
                        "name": "Kayan",
                        "latitude": "16.90802000",
                        "longitude": "96.56037000"
                    },
                    {
                        "id": 67688,
                        "name": "Syriam",
                        "latitude": "16.76887000",
                        "longitude": "96.24503000"
                    },
                    {
                        "id": 67699,
                        "name": "Thongwa",
                        "latitude": "16.75998000",
                        "longitude": "96.52498000"
                    },
                    {
                        "id": 67700,
                        "name": "Twante",
                        "latitude": "16.71047000",
                        "longitude": "95.92866000"
                    },
                    {
                        "id": 67703,
                        "name": "Yangon",
                        "latitude": "16.80528000",
                        "longitude": "96.15611000"
                    }
                ]
            }
        ]
    },
    {
        "id": 152,
        "name": "Namibia",
        "iso3": "NAM",
        "iso2": "NA",
        "numeric_code": "516",
        "phonecode": "264",
        "capital": "Windhoek",
        "currency": "NAD",
        "currency_name": "Namibian dollar",
        "currency_symbol": "$",
        "tld": ".na",
        "native": "Namibia",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Southern Africa",
        "subregion_id": 5,
        "nationality": "Namibian",
        "timezones": [
            {
                "zoneName": "Africa\/Windhoek",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "WAST",
                "tzName": "West Africa Summer Time"
            }
        ],
        "translations": {
            "br": "Namibia",
            "ko": "나미비아",
            "pt-BR": "Namíbia",
            "pt": "Namíbia",
            "nl": "Namibië",
            "hr": "Namibija",
            "fa": "نامیبیا",
            "de": "Namibia",
            "es": "Namibia",
            "fr": "Namibie",
            "ja": "ナミビア",
            "it": "Namibia",
            "zh-CN": "纳米比亚",
            "tr": "Namibya",
            "ru": "Намибия",
            "uk": "Намібія",
            "pl": "Namibia"
        },
        "latitude": "-22.00000000",
        "longitude": "17.00000000",
        "emoji": "🇳🇦",
        "emojiU": "U+1F1F3 U+1F1E6",
        "states": [
            {
                "id": 43,
                "name": "Erongo",
                "iso2": "ER",
                "latitude": "-22.25656820",
                "longitude": "15.40680790",
                "type": "region",
                "cities": [
                    {
                        "id": 76626,
                        "name": "Arandis",
                        "latitude": "-22.41667000",
                        "longitude": "14.96667000"
                    },
                    {
                        "id": 76633,
                        "name": "Hentiesbaai",
                        "latitude": "-22.11667000",
                        "longitude": "14.28333000"
                    },
                    {
                        "id": 76636,
                        "name": "Karibib",
                        "latitude": "-21.93333000",
                        "longitude": "15.83333000"
                    },
                    {
                        "id": 76648,
                        "name": "Omaruru",
                        "latitude": "-21.43333000",
                        "longitude": "15.93333000"
                    },
                    {
                        "id": 76659,
                        "name": "Otjimbingwe",
                        "latitude": "-22.35000000",
                        "longitude": "16.13333000"
                    },
                    {
                        "id": 76666,
                        "name": "Swakopmund",
                        "latitude": "-22.67842000",
                        "longitude": "14.52663000"
                    },
                    {
                        "id": 76667,
                        "name": "Swakopmund Constituency",
                        "latitude": "-22.63199000",
                        "longitude": "14.60119000"
                    },
                    {
                        "id": 76670,
                        "name": "Usakos",
                        "latitude": "-22.00000000",
                        "longitude": "15.60000000"
                    },
                    {
                        "id": 76671,
                        "name": "Walvis Bay",
                        "latitude": "-22.95750000",
                        "longitude": "14.50528000"
                    }
                ]
            },
            {
                "id": 38,
                "name": "Hardap",
                "iso2": "HA",
                "latitude": "-24.23101340",
                "longitude": "17.66888700",
                "type": "region",
                "cities": [
                    {
                        "id": 76627,
                        "name": "Aranos",
                        "latitude": "-24.13333000",
                        "longitude": "19.11667000"
                    },
                    {
                        "id": 76634,
                        "name": "Hoachanas",
                        "latitude": "-23.91667000",
                        "longitude": "18.05000000"
                    },
                    {
                        "id": 76643,
                        "name": "Maltahöhe",
                        "latitude": "-24.83333000",
                        "longitude": "16.98333000"
                    },
                    {
                        "id": 76644,
                        "name": "Mariental",
                        "latitude": "-24.63333000",
                        "longitude": "17.96667000"
                    },
                    {
                        "id": 76663,
                        "name": "Rehoboth",
                        "latitude": "-23.31700000",
                        "longitude": "17.09000000"
                    }
                ]
            },
            {
                "id": 45,
                "name": "Karas",
                "iso2": "KA",
                "latitude": "-26.84296450",
                "longitude": "17.29028390",
                "type": "region",
                "cities": [
                    {
                        "id": 76629,
                        "name": "Bethanie",
                        "latitude": "-26.48333000",
                        "longitude": "17.15000000"
                    },
                    {
                        "id": 76635,
                        "name": "Karasburg",
                        "latitude": "-28.01667000",
                        "longitude": "18.75000000"
                    },
                    {
                        "id": 76639,
                        "name": "Keetmanshoop",
                        "latitude": "-26.58333000",
                        "longitude": "18.13333000"
                    },
                    {
                        "id": 76642,
                        "name": "Lüderitz",
                        "latitude": "-26.64807000",
                        "longitude": "15.15383000"
                    },
                    {
                        "id": 76655,
                        "name": "Oranjemund",
                        "latitude": "-28.55000000",
                        "longitude": "16.43333000"
                    },
                    {
                        "id": 76668,
                        "name": "Tses",
                        "latitude": "-25.88333000",
                        "longitude": "18.00000000"
                    },
                    {
                        "id": 76672,
                        "name": "Warmbad",
                        "latitude": "-28.45000000",
                        "longitude": "18.73333000"
                    }
                ]
            },
            {
                "id": 36,
                "name": "Kavango East",
                "iso2": "KE",
                "latitude": "-18.49011050",
                "longitude": "19.68116850",
                "type": "region",
                "cities": [
                    {
                        "id": 76664,
                        "name": "Rundu",
                        "latitude": "-17.93333000",
                        "longitude": "19.76667000"
                    }
                ]
            },
            {
                "id": 35,
                "name": "Kavango West",
                "iso2": "KW",
                "latitude": "-18.27624520",
                "longitude": "18.20961070",
                "type": "region",
                "cities": []
            },
            {
                "id": 44,
                "name": "Khomas",
                "iso2": "KH",
                "latitude": "-22.63778540",
                "longitude": "17.10119310",
                "type": "region",
                "cities": [
                    {
                        "id": 76638,
                        "name": "Katutura",
                        "latitude": "-22.52306000",
                        "longitude": "17.06028000"
                    },
                    {
                        "id": 76673,
                        "name": "Windhoek",
                        "latitude": "-22.55941000",
                        "longitude": "17.08323000"
                    }
                ]
            },
            {
                "id": 34,
                "name": "Kunene",
                "iso2": "KU",
                "latitude": "-19.40863170",
                "longitude": "13.91439900",
                "type": "region",
                "cities": [
                    {
                        "id": 76630,
                        "name": "Epupa Constituency",
                        "latitude": "-17.00388000",
                        "longitude": "13.24825000"
                    },
                    {
                        "id": 76640,
                        "name": "Khorixas",
                        "latitude": "-20.36667000",
                        "longitude": "14.96667000"
                    },
                    {
                        "id": 76641,
                        "name": "Khorixas Constituency",
                        "latitude": "-20.36792000",
                        "longitude": "14.95996000"
                    },
                    {
                        "id": 76653,
                        "name": "Opuwo",
                        "latitude": "-18.06068000",
                        "longitude": "13.83998000"
                    },
                    {
                        "id": 76654,
                        "name": "Opuwo Constituency",
                        "latitude": "-18.54247000",
                        "longitude": "13.51617000"
                    },
                    {
                        "id": 76662,
                        "name": "Outjo",
                        "latitude": "-20.11667000",
                        "longitude": "16.15000000"
                    },
                    {
                        "id": 76665,
                        "name": "Sesfontein Constituency",
                        "latitude": "-19.56106000",
                        "longitude": "13.76530000"
                    }
                ]
            },
            {
                "id": 40,
                "name": "Ohangwena",
                "iso2": "OW",
                "latitude": "-17.59792910",
                "longitude": "16.81783770",
                "type": "region",
                "cities": [
                    {
                        "id": 76657,
                        "name": "Oshikango",
                        "latitude": "-17.40000000",
                        "longitude": "15.88333000"
                    }
                ]
            },
            {
                "id": 41,
                "name": "Omaheke",
                "iso2": "OH",
                "latitude": "-21.84666510",
                "longitude": "19.18800470",
                "type": "region",
                "cities": [
                    {
                        "id": 76631,
                        "name": "Gobabis",
                        "latitude": "-22.45000000",
                        "longitude": "18.96667000"
                    }
                ]
            },
            {
                "id": 39,
                "name": "Omusati",
                "iso2": "OS",
                "latitude": "-18.40702940",
                "longitude": "14.84546190",
                "type": "region",
                "cities": [
                    {
                        "id": 76646,
                        "name": "Okahao",
                        "latitude": "-17.88758000",
                        "longitude": "15.06677000"
                    },
                    {
                        "id": 76651,
                        "name": "Ongandjera",
                        "latitude": "-17.88333000",
                        "longitude": "15.06667000"
                    },
                    {
                        "id": 76661,
                        "name": "Outapi",
                        "latitude": "-17.50000000",
                        "longitude": "14.98333000"
                    }
                ]
            },
            {
                "id": 37,
                "name": "Oshana",
                "iso2": "ON",
                "latitude": "-18.43050640",
                "longitude": "15.68817880",
                "type": "region",
                "cities": [
                    {
                        "id": 76650,
                        "name": "Ondangwa",
                        "latitude": "-17.91667000",
                        "longitude": "15.95000000"
                    },
                    {
                        "id": 76652,
                        "name": "Ongwediva",
                        "latitude": "-17.78333000",
                        "longitude": "15.76667000"
                    },
                    {
                        "id": 76656,
                        "name": "Oshakati",
                        "latitude": "-17.78833000",
                        "longitude": "15.70436000"
                    }
                ]
            },
            {
                "id": 42,
                "name": "Oshikoto",
                "iso2": "OT",
                "latitude": "-18.41525750",
                "longitude": "16.91225100",
                "type": "region",
                "cities": [
                    {
                        "id": 76649,
                        "name": "Omuthiya",
                        "latitude": "-18.36463000",
                        "longitude": "16.58146000"
                    },
                    {
                        "id": 76669,
                        "name": "Tsumeb",
                        "latitude": "-19.23333000",
                        "longitude": "17.71667000"
                    }
                ]
            },
            {
                "id": 46,
                "name": "Otjozondjupa",
                "iso2": "OD",
                "latitude": "-20.54869160",
                "longitude": "17.66888700",
                "type": "region",
                "cities": [
                    {
                        "id": 76632,
                        "name": "Grootfontein",
                        "latitude": "-19.56667000",
                        "longitude": "18.11667000"
                    },
                    {
                        "id": 76645,
                        "name": "Okahandja",
                        "latitude": "-21.98333000",
                        "longitude": "16.91667000"
                    },
                    {
                        "id": 76647,
                        "name": "Okakarara",
                        "latitude": "-20.58333000",
                        "longitude": "17.43333000"
                    },
                    {
                        "id": 76658,
                        "name": "Otavi",
                        "latitude": "-19.65000000",
                        "longitude": "17.33333000"
                    },
                    {
                        "id": 76660,
                        "name": "Otjiwarongo",
                        "latitude": "-20.46369000",
                        "longitude": "16.64772000"
                    }
                ]
            },
            {
                "id": 47,
                "name": "Zambezi",
                "iso2": "CA",
                "latitude": "-17.81934190",
                "longitude": "23.95364660",
                "type": "region",
                "cities": [
                    {
                        "id": 76628,
                        "name": "Bagani",
                        "latitude": "-18.11065000",
                        "longitude": "21.61645000"
                    },
                    {
                        "id": 76637,
                        "name": "Katima Mulilo",
                        "latitude": "-17.50000000",
                        "longitude": "24.26667000"
                    }
                ]
            }
        ]
    },
    {
        "id": 153,
        "name": "Nauru",
        "iso3": "NRU",
        "iso2": "NR",
        "numeric_code": "520",
        "phonecode": "674",
        "capital": "Yaren",
        "currency": "AUD",
        "currency_name": "Australian dollar",
        "currency_symbol": "$",
        "tld": ".nr",
        "native": "Nauru",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Micronesia",
        "subregion_id": 21,
        "nationality": "Nauruan",
        "timezones": [
            {
                "zoneName": "Pacific\/Nauru",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "NRT",
                "tzName": "Nauru Time"
            }
        ],
        "translations": {
            "br": "Nauru",
            "ko": "나우루",
            "pt-BR": "Nauru",
            "pt": "Nauru",
            "nl": "Nauru",
            "hr": "Nauru",
            "fa": "نائورو",
            "de": "Nauru",
            "es": "Nauru",
            "fr": "Nauru",
            "ja": "ナウル",
            "it": "Nauru",
            "zh-CN": "瑙鲁",
            "tr": "Nauru",
            "ru": "Науру",
            "uk": "Науру",
            "pl": "Nauru"
        },
        "latitude": "-0.53333333",
        "longitude": "166.91666666",
        "emoji": "🇳🇷",
        "emojiU": "U+1F1F3 U+1F1F7",
        "states": [
            {
                "id": 4656,
                "name": "Aiwo",
                "iso2": "01",
                "latitude": "-0.53400120",
                "longitude": "166.91388730",
                "type": "district",
                "cities": [
                    {
                        "id": 79762,
                        "name": "Arijejen",
                        "latitude": "-0.52545000",
                        "longitude": "166.91247000"
                    }
                ]
            },
            {
                "id": 4658,
                "name": "Anabar",
                "iso2": "02",
                "latitude": "-0.51335170",
                "longitude": "166.94846240",
                "type": "district",
                "cities": [
                    {
                        "id": 79761,
                        "name": "Anabar",
                        "latitude": "-0.50845000",
                        "longitude": "166.95326000"
                    }
                ]
            },
            {
                "id": 4667,
                "name": "Anetan",
                "iso2": "03",
                "latitude": "-0.50643430",
                "longitude": "166.94270060",
                "type": "district",
                "cities": []
            },
            {
                "id": 4663,
                "name": "Anibare",
                "iso2": "04",
                "latitude": "-0.52947580",
                "longitude": "166.95134320",
                "type": "district",
                "cities": []
            },
            {
                "id": 4660,
                "name": "Baiti",
                "iso2": "05",
                "latitude": "-0.51043100",
                "longitude": "166.92757440",
                "type": "district",
                "cities": [
                    {
                        "id": 79763,
                        "name": "Baiti",
                        "latitude": "-0.50803000",
                        "longitude": "166.92945000"
                    }
                ]
            },
            {
                "id": 4665,
                "name": "Boe",
                "iso2": "06",
                "latitude": "39.07327760",
                "longitude": "-94.57104980",
                "type": "district",
                "cities": []
            },
            {
                "id": 4662,
                "name": "Buada",
                "iso2": "07",
                "latitude": "-0.53287770",
                "longitude": "166.92685410",
                "type": "district",
                "cities": []
            },
            {
                "id": 4666,
                "name": "Denigomodu",
                "iso2": "08",
                "latitude": "-0.52479640",
                "longitude": "166.91676890",
                "type": "district",
                "cities": []
            },
            {
                "id": 4654,
                "name": "Ewa",
                "iso2": "09",
                "latitude": "-0.50872410",
                "longitude": "166.93693840",
                "type": "district",
                "cities": []
            },
            {
                "id": 4661,
                "name": "Ijuw",
                "iso2": "10",
                "latitude": "-0.52027670",
                "longitude": "166.95710460",
                "type": "district",
                "cities": [
                    {
                        "id": 79764,
                        "name": "Ijuw",
                        "latitude": "-0.52100000",
                        "longitude": "166.95813000"
                    }
                ]
            },
            {
                "id": 4657,
                "name": "Meneng",
                "iso2": "11",
                "latitude": "-0.54672400",
                "longitude": "166.93837900",
                "type": "district",
                "cities": [
                    {
                        "id": 79765,
                        "name": "Menen",
                        "latitude": "-0.54539000",
                        "longitude": "166.94871000"
                    }
                ]
            },
            {
                "id": 4659,
                "name": "Nibok",
                "iso2": "12",
                "latitude": "-0.51962080",
                "longitude": "166.91893010",
                "type": "district",
                "cities": []
            },
            {
                "id": 4655,
                "name": "Uaboe",
                "iso2": "13",
                "latitude": "-0.52022220",
                "longitude": "166.93117610",
                "type": "district",
                "cities": [
                    {
                        "id": 79766,
                        "name": "Uaboe",
                        "latitude": "-0.51393000",
                        "longitude": "166.92384000"
                    }
                ]
            },
            {
                "id": 4664,
                "name": "Yaren",
                "iso2": "14",
                "latitude": "-0.54668570",
                "longitude": "166.92109130",
                "type": "district",
                "cities": [
                    {
                        "id": 79767,
                        "name": "Yaren",
                        "latitude": "-0.55085000",
                        "longitude": "166.92520000"
                    }
                ]
            }
        ]
    },
    {
        "id": 154,
        "name": "Nepal",
        "iso3": "NPL",
        "iso2": "NP",
        "numeric_code": "524",
        "phonecode": "977",
        "capital": "Kathmandu",
        "currency": "NPR",
        "currency_name": "Nepalese rupee",
        "currency_symbol": "₨",
        "tld": ".np",
        "native": "नपल",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Southern Asia",
        "subregion_id": 14,
        "nationality": "Nepali, Nepalese",
        "timezones": [
            {
                "zoneName": "Asia\/Kathmandu",
                "gmtOffset": 20700,
                "gmtOffsetName": "UTC+05:45",
                "abbreviation": "NPT",
                "tzName": "Nepal Time"
            }
        ],
        "translations": {
            "br": "Nepal",
            "ko": "네팔",
            "pt-BR": "Nepal",
            "pt": "Nepal",
            "nl": "Nepal",
            "hr": "Nepal",
            "fa": "نپال",
            "de": "Népal",
            "es": "Nepal",
            "fr": "Népal",
            "ja": "ネパール",
            "it": "Nepal",
            "zh-CN": "尼泊尔",
            "tr": "Nepal",
            "ru": "Непал",
            "uk": "Непал",
            "pl": "Nepal"
        },
        "latitude": "28.00000000",
        "longitude": "84.00000000",
        "emoji": "🇳🇵",
        "emojiU": "U+1F1F3 U+1F1F5",
        "states": [
            {
                "id": 2073,
                "name": "Bagmati",
                "iso2": "P3",
                "latitude": "27.64892530",
                "longitude": "83.92588340",
                "type": "province",
                "cities": [
                    {
                        "id": 79705,
                        "name": "Bhaktapur",
                        "latitude": "27.67743440",
                        "longitude": "85.40386700"
                    },
                    {
                        "id": 79707,
                        "name": "Chitwan",
                        "latitude": "27.61953620",
                        "longitude": "84.02793400"
                    },
                    {
                        "id": 79713,
                        "name": "Dhading",
                        "latitude": "28.00725840",
                        "longitude": "84.28464170"
                    },
                    {
                        "id": 79722,
                        "name": "Dolakha",
                        "latitude": "27.82371900",
                        "longitude": "85.55991890"
                    },
                    {
                        "id": 79726,
                        "name": "Kathmandu",
                        "latitude": "27.70903020",
                        "longitude": "85.28493270"
                    },
                    {
                        "id": 79728,
                        "name": "Kavrepalanchok",
                        "latitude": "27.54539810",
                        "longitude": "85.30416730"
                    },
                    {
                        "id": 79729,
                        "name": "Lalitpur",
                        "latitude": "27.54820230",
                        "longitude": "85.04201470"
                    },
                    {
                        "id": 79732,
                        "name": "Makwanpur",
                        "latitude": "27.43720820",
                        "longitude": "84.75780400"
                    },
                    {
                        "id": 79733,
                        "name": "Nuwakot",
                        "latitude": "27.92205490",
                        "longitude": "84.05968460"
                    },
                    {
                        "id": 79735,
                        "name": "Ramechhap",
                        "latitude": "27.53749850",
                        "longitude": "85.85535100"
                    },
                    {
                        "id": 79737,
                        "name": "Rasuwa",
                        "latitude": "28.17177410",
                        "longitude": "84.27823120"
                    },
                    {
                        "id": 79740,
                        "name": "Sindhuli",
                        "latitude": "27.18469330",
                        "longitude": "85.24437150"
                    },
                    {
                        "id": 79742,
                        "name": "Sindhupalchok",
                        "latitude": "27.90711960",
                        "longitude": "85.42360670"
                    }
                ]
            },
            {
                "id": 2069,
                "name": "Gandaki",
                "iso2": "P4",
                "latitude": "28.37978120",
                "longitude": "82.71779220",
                "type": "province",
                "cities": [
                    {
                        "id": 79706,
                        "name": "Baglung ",
                        "latitude": "28.27711640",
                        "longitude": "83.54353530"
                    },
                    {
                        "id": 79709,
                        "name": "Gorkha ",
                        "latitude": "28.27346270",
                        "longitude": "84.14877700"
                    },
                    {
                        "id": 79711,
                        "name": "Kaski",
                        "latitude": "28.34572360",
                        "longitude": "83.65987310"
                    },
                    {
                        "id": 79720,
                        "name": "Lamjung ",
                        "latitude": "28.28305670",
                        "longitude": "84.11103120"
                    },
                    {
                        "id": 79721,
                        "name": "Manang ",
                        "latitude": "28.66872810",
                        "longitude": "82.99681360"
                    },
                    {
                        "id": 79730,
                        "name": "Mustang ",
                        "latitude": "28.94399870",
                        "longitude": "82.68067390"
                    },
                    {
                        "id": 79731,
                        "name": "Myagdi ",
                        "latitude": "28.54609860",
                        "longitude": "83.15597750"
                    },
                    {
                        "id": 79736,
                        "name": "Nawalpur ",
                        "latitude": "27.65319650",
                        "longitude": "83.72442870"
                    },
                    {
                        "id": 79738,
                        "name": "Parbat ",
                        "latitude": "28.20276430",
                        "longitude": "83.36121860"
                    },
                    {
                        "id": 79739,
                        "name": "Syangja ",
                        "latitude": "28.04509710",
                        "longitude": "83.40612700"
                    },
                    {
                        "id": 79744,
                        "name": "Tanahun ",
                        "latitude": "27.93565560",
                        "longitude": "83.91793110"
                    }
                ]
            },
            {
                "id": 2068,
                "name": "Karnali",
                "iso2": "P6",
                "latitude": "29.30393430",
                "longitude": "81.01088600",
                "type": "province",
                "cities": [
                    {
                        "id": 79717,
                        "name": "Dailekh ",
                        "latitude": "28.88480530",
                        "longitude": "81.33871970"
                    },
                    {
                        "id": 79719,
                        "name": "Dolpa ",
                        "latitude": "29.21372390",
                        "longitude": "82.37667750"
                    },
                    {
                        "id": 79724,
                        "name": "Humla ",
                        "latitude": "30.02557030",
                        "longitude": "81.21732030"
                    },
                    {
                        "id": 79741,
                        "name": "Jajarkot ",
                        "latitude": "28.86955260",
                        "longitude": "81.87033700"
                    },
                    {
                        "id": 79760,
                        "name": "Jumla",
                        "latitude": "29.23886510",
                        "longitude": "81.88899740"
                    },
                    {
                        "id": 153801,
                        "name": "Kalikot ",
                        "latitude": "29.21645520",
                        "longitude": "81.41396150"
                    },
                    {
                        "id": 153802,
                        "name": "Mugu",
                        "latitude": "29.67782880",
                        "longitude": "81.63611370"
                    },
                    {
                        "id": 153803,
                        "name": "Salyan ",
                        "latitude": "28.40693490",
                        "longitude": "81.76058940"
                    },
                    {
                        "id": 153804,
                        "name": "Surkhet ",
                        "latitude": "28.65735870",
                        "longitude": "80.85115200"
                    },
                    {
                        "id": 153805,
                        "name": "Western Rukum",
                        "latitude": "28.75665210",
                        "longitude": "82.11273090"
                    }
                ]
            },
            {
                "id": 2066,
                "name": "Koshi",
                "iso2": "P1",
                "latitude": "27.15479350",
                "longitude": "82.42107490",
                "type": "province",
                "cities": [
                    {
                        "id": 79710,
                        "name": "Bhojpur",
                        "latitude": "27.16432030",
                        "longitude": "86.97399080"
                    },
                    {
                        "id": 79712,
                        "name": "Dhankuta",
                        "latitude": "26.98445610",
                        "longitude": "87.24311290"
                    },
                    {
                        "id": 79718,
                        "name": "Ilam",
                        "latitude": "26.89856010",
                        "longitude": "87.88160070"
                    },
                    {
                        "id": 79727,
                        "name": "Jhapa",
                        "latitude": "26.58377460",
                        "longitude": "87.58265500"
                    },
                    {
                        "id": 79734,
                        "name": "Khotang",
                        "latitude": "27.15640300",
                        "longitude": "86.37601470"
                    },
                    {
                        "id": 79745,
                        "name": "Morang",
                        "latitude": "26.61072710",
                        "longitude": "87.13496260"
                    },
                    {
                        "id": 79756,
                        "name": "Okhaldhunga",
                        "latitude": "27.33668120",
                        "longitude": "86.11507710"
                    },
                    {
                        "id": 153792,
                        "name": "Panchthar",
                        "latitude": "27.14929510",
                        "longitude": "87.45396980"
                    },
                    {
                        "id": 153793,
                        "name": "Sankhuwasabha ",
                        "latitude": "27.54665800",
                        "longitude": "86.64912720"
                    },
                    {
                        "id": 153794,
                        "name": "Solukhumbu",
                        "latitude": "27.72514640",
                        "longitude": "86.02324040"
                    },
                    {
                        "id": 153795,
                        "name": "Sunsari",
                        "latitude": "26.64116460",
                        "longitude": "86.79919520"
                    },
                    {
                        "id": 153796,
                        "name": "Taplejung",
                        "latitude": "27.61014090",
                        "longitude": "87.16355390"
                    },
                    {
                        "id": 153797,
                        "name": "Terhathum",
                        "latitude": "27.13268960",
                        "longitude": "87.40691430"
                    },
                    {
                        "id": 153798,
                        "name": "Udayapur",
                        "latitude": "26.93274070",
                        "longitude": "86.00264640"
                    }
                ]
            },
            {
                "id": 2067,
                "name": "Lumbini",
                "iso2": "P5",
                "latitude": "28.02240600",
                "longitude": "77.78646280",
                "type": "province",
                "cities": [
                    {
                        "id": 79708,
                        "name": "Arghakhanchi ",
                        "latitude": "27.93234540",
                        "longitude": "82.70966110"
                    },
                    {
                        "id": 79714,
                        "name": "Banke",
                        "latitude": "28.09593710",
                        "longitude": "81.51662830"
                    },
                    {
                        "id": 79715,
                        "name": "Bardiya ",
                        "latitude": "28.37201670",
                        "longitude": "81.08316830"
                    },
                    {
                        "id": 79716,
                        "name": "Dang ",
                        "latitude": "27.88865620",
                        "longitude": "79.29702080"
                    },
                    {
                        "id": 79723,
                        "name": "Eastern Rukum",
                        "latitude": "28.67248040",
                        "longitude": "82.48940030"
                    },
                    {
                        "id": 79725,
                        "name": "Gulmi ",
                        "latitude": "28.09597820",
                        "longitude": "82.98379720"
                    },
                    {
                        "id": 79748,
                        "name": "Kapilvastu ",
                        "latitude": "27.54506960",
                        "longitude": "82.97552520"
                    },
                    {
                        "id": 79752,
                        "name": "Nawalparasi (West of Bardaghat Susta)",
                        "latitude": "27.51977900",
                        "longitude": "83.40494810"
                    },
                    {
                        "id": 79757,
                        "name": "Palpa ",
                        "latitude": "27.81068740",
                        "longitude": "83.30000220"
                    },
                    {
                        "id": 79758,
                        "name": "Pyuthan ",
                        "latitude": "28.10805440",
                        "longitude": "82.78532440"
                    },
                    {
                        "id": 153799,
                        "name": "Rolpa ",
                        "latitude": "28.32573400",
                        "longitude": "82.32376150"
                    },
                    {
                        "id": 153800,
                        "name": "Rupandehi ",
                        "latitude": "27.54931420",
                        "longitude": "83.08930670"
                    }
                ]
            },
            {
                "id": 5240,
                "name": "Madhesh",
                "iso2": "P2",
                "latitude": "26.93918730",
                "longitude": "84.42934670",
                "type": "province",
                "cities": [
                    {
                        "id": 153809,
                        "name": "Bara ",
                        "latitude": "27.10766310",
                        "longitude": "84.73878940"
                    },
                    {
                        "id": 153807,
                        "name": "Dhanusha ",
                        "latitude": "26.85112570",
                        "longitude": "85.72433070"
                    },
                    {
                        "id": 153813,
                        "name": "Mahottari ",
                        "latitude": "26.88439340",
                        "longitude": "85.21963240"
                    },
                    {
                        "id": 153814,
                        "name": "Parsa ",
                        "latitude": "27.21960860",
                        "longitude": "83.54541570"
                    },
                    {
                        "id": 153810,
                        "name": "Rautahat ",
                        "latitude": "26.98892410",
                        "longitude": "85.00379450"
                    },
                    {
                        "id": 153811,
                        "name": "Saptari ",
                        "latitude": "26.60706670",
                        "longitude": "86.42052270"
                    },
                    {
                        "id": 153808,
                        "name": "Sarlahi ",
                        "latitude": "26.96861190",
                        "longitude": "85.23906480"
                    },
                    {
                        "id": 153812,
                        "name": "Siraha ",
                        "latitude": "26.74287390",
                        "longitude": "86.01304490"
                    }
                ]
            },
            {
                "id": 5241,
                "name": "Sudurpashchim",
                "iso2": "P7",
                "latitude": "29.30623710",
                "longitude": "79.61354510",
                "type": "province",
                "cities": [
                    {
                        "id": 153815,
                        "name": "Achham ",
                        "latitude": "29.06759620",
                        "longitude": "80.97452850"
                    },
                    {
                        "id": 153816,
                        "name": "Baitadi ",
                        "latitude": "29.50832630",
                        "longitude": "80.24534200"
                    },
                    {
                        "id": 153817,
                        "name": "Bajhang ",
                        "latitude": "29.72211100",
                        "longitude": "80.49591420"
                    },
                    {
                        "id": 153818,
                        "name": "Bajura ",
                        "latitude": "29.61008120",
                        "longitude": "80.82948020"
                    },
                    {
                        "id": 153819,
                        "name": "Dadeldhura ",
                        "latitude": "29.20934090",
                        "longitude": "80.15536460"
                    },
                    {
                        "id": 153820,
                        "name": "Darchula ",
                        "latitude": "29.59606420",
                        "longitude": "80.05743430"
                    },
                    {
                        "id": 153821,
                        "name": "Doti ",
                        "latitude": "29.18833610",
                        "longitude": "80.52682610"
                    },
                    {
                        "id": 153822,
                        "name": "Kailali ",
                        "latitude": "28.73090610",
                        "longitude": "80.21847770"
                    },
                    {
                        "id": 153823,
                        "name": "Kanchanpur ",
                        "latitude": "28.84471200",
                        "longitude": "79.97926950"
                    }
                ]
            }
        ]
    },
    {
        "id": 156,
        "name": "Netherlands",
        "iso3": "NLD",
        "iso2": "NL",
        "numeric_code": "528",
        "phonecode": "31",
        "capital": "Amsterdam",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".nl",
        "native": "Nederland",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Western Europe",
        "subregion_id": 17,
        "nationality": "Dutch, Netherlandic",
        "timezones": [
            {
                "zoneName": "Europe\/Amsterdam",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Izelvroioù",
            "ko": "네덜란드 ",
            "pt-BR": "Holanda",
            "pt": "Países Baixos",
            "nl": "Nederland",
            "hr": "Nizozemska",
            "fa": "پادشاهی هلند",
            "de": "Niederlande",
            "es": "Países Bajos",
            "fr": "Pays-Bas",
            "ja": "オランダ",
            "it": "Paesi Bassi",
            "zh-CN": "荷兰",
            "tr": "Hollanda",
            "ru": "Нидерланды",
            "uk": "Нідерланди",
            "pl": "Holandia"
        },
        "latitude": "52.50000000",
        "longitude": "5.75000000",
        "emoji": "🇳🇱",
        "emojiU": "U+1F1F3 U+1F1F1",
        "states": [
            {
                "id": 2613,
                "name": "Drenthe",
                "iso2": "DR",
                "latitude": "52.94760120",
                "longitude": "6.62305860",
                "type": "province",
                "cities": [
                    {
                        "id": 77306,
                        "name": "Aalden",
                        "latitude": "52.79000000",
                        "longitude": "6.71806000"
                    },
                    {
                        "id": 77344,
                        "name": "Angelslo",
                        "latitude": "52.78090000",
                        "longitude": "6.92645000"
                    },
                    {
                        "id": 77349,
                        "name": "Annen",
                        "latitude": "53.05750000",
                        "longitude": "6.71944000"
                    },
                    {
                        "id": 77357,
                        "name": "Assen",
                        "latitude": "52.99667000",
                        "longitude": "6.56250000"
                    },
                    {
                        "id": 77376,
                        "name": "Ballast",
                        "latitude": "52.67218000",
                        "longitude": "6.73299000"
                    },
                    {
                        "id": 77380,
                        "name": "Barger-Oosterveld",
                        "latitude": "52.77000000",
                        "longitude": "6.95833000"
                    },
                    {
                        "id": 77381,
                        "name": "Bargeres",
                        "latitude": "52.76152000",
                        "longitude": "6.88145000"
                    },
                    {
                        "id": 77395,
                        "name": "Beilen",
                        "latitude": "52.86333000",
                        "longitude": "6.51389000"
                    },
                    {
                        "id": 77456,
                        "name": "Borger",
                        "latitude": "52.92333000",
                        "longitude": "6.79306000"
                    },
                    {
                        "id": 77519,
                        "name": "Coevorden",
                        "latitude": "52.66103000",
                        "longitude": "6.74046000"
                    },
                    {
                        "id": 77528,
                        "name": "Dalen",
                        "latitude": "52.69917000",
                        "longitude": "6.75556000"
                    },
                    {
                        "id": 77552,
                        "name": "De Loo",
                        "latitude": "52.67167000",
                        "longitude": "6.73967000"
                    },
                    {
                        "id": 77563,
                        "name": "De Wijk",
                        "latitude": "52.67333000",
                        "longitude": "6.29028000"
                    },
                    {
                        "id": 77581,
                        "name": "Diever",
                        "latitude": "52.85417000",
                        "longitude": "6.31806000"
                    },
                    {
                        "id": 77620,
                        "name": "Dwingeloo",
                        "latitude": "52.83417000",
                        "longitude": "6.36944000"
                    },
                    {
                        "id": 77628,
                        "name": "Eelde",
                        "latitude": "53.13583000",
                        "longitude": "6.56250000"
                    },
                    {
                        "id": 77634,
                        "name": "Eext",
                        "latitude": "53.01750000",
                        "longitude": "6.73472000"
                    },
                    {
                        "id": 77653,
                        "name": "Emmen",
                        "latitude": "52.77917000",
                        "longitude": "6.90694000"
                    },
                    {
                        "id": 77654,
                        "name": "Emmer-Compascuum",
                        "latitude": "52.81167000",
                        "longitude": "7.04722000"
                    },
                    {
                        "id": 77655,
                        "name": "Emmer-Erfscheidenveen",
                        "latitude": "52.80667000",
                        "longitude": "6.98889000"
                    },
                    {
                        "id": 77656,
                        "name": "Emmerhout",
                        "latitude": "52.78755000",
                        "longitude": "6.93881000"
                    },
                    {
                        "id": 77657,
                        "name": "Emmermeer",
                        "latitude": "52.80071000",
                        "longitude": "6.89315000"
                    },
                    {
                        "id": 77658,
                        "name": "Emmerschans",
                        "latitude": "52.80083000",
                        "longitude": "6.93889000"
                    },
                    {
                        "id": 77671,
                        "name": "Exloo",
                        "latitude": "52.88250000",
                        "longitude": "6.86389000"
                    },
                    {
                        "id": 77684,
                        "name": "Gasselte",
                        "latitude": "52.97167000",
                        "longitude": "6.79444000"
                    },
                    {
                        "id": 77685,
                        "name": "Gasselternijveen",
                        "latitude": "52.98833000",
                        "longitude": "6.85278000"
                    },
                    {
                        "id": 78031,
                        "name": "Gieten",
                        "latitude": "53.00500000",
                        "longitude": "6.76389000"
                    },
                    {
                        "id": 78104,
                        "name": "Havelte",
                        "latitude": "52.76941000",
                        "longitude": "6.24015000"
                    },
                    {
                        "id": 78181,
                        "name": "Hoogeveen",
                        "latitude": "52.72250000",
                        "longitude": "6.47639000"
                    },
                    {
                        "id": 78235,
                        "name": "Klazienaveen",
                        "latitude": "52.72417000",
                        "longitude": "6.99028000"
                    },
                    {
                        "id": 78241,
                        "name": "Koekange",
                        "latitude": "52.69917000",
                        "longitude": "6.31667000"
                    },
                    {
                        "id": 78255,
                        "name": "Krakeel",
                        "latitude": "52.72339000",
                        "longitude": "6.51146000"
                    },
                    {
                        "id": 78354,
                        "name": "Marsdijk",
                        "latitude": "53.01766000",
                        "longitude": "6.58527000"
                    },
                    {
                        "id": 78381,
                        "name": "Meppel",
                        "latitude": "52.69583000",
                        "longitude": "6.19444000"
                    },
                    {
                        "id": 78431,
                        "name": "Nieuw-Buinen",
                        "latitude": "52.96250000",
                        "longitude": "6.95000000"
                    },
                    {
                        "id": 78432,
                        "name": "Nieuw-Dordrecht",
                        "latitude": "52.74833000",
                        "longitude": "6.96806000"
                    },
                    {
                        "id": 78436,
                        "name": "Nieuw-Roden",
                        "latitude": "53.13167000",
                        "longitude": "6.39722000"
                    },
                    {
                        "id": 78463,
                        "name": "Noordbarge",
                        "latitude": "52.77237000",
                        "longitude": "6.88713000"
                    },
                    {
                        "id": 78473,
                        "name": "Norg",
                        "latitude": "53.06667000",
                        "longitude": "6.45833000"
                    },
                    {
                        "id": 78484,
                        "name": "Odoorn",
                        "latitude": "52.84917000",
                        "longitude": "6.85139000"
                    },
                    {
                        "id": 78516,
                        "name": "Oosterhesselen",
                        "latitude": "52.75417000",
                        "longitude": "6.72222000"
                    },
                    {
                        "id": 78581,
                        "name": "Paterswolde",
                        "latitude": "53.14500000",
                        "longitude": "6.56528000"
                    },
                    {
                        "id": 78583,
                        "name": "Peelo",
                        "latitude": "53.01719000",
                        "longitude": "6.56208000"
                    },
                    {
                        "id": 78585,
                        "name": "Peize",
                        "latitude": "53.14667000",
                        "longitude": "6.49722000"
                    },
                    {
                        "id": 78633,
                        "name": "Roden",
                        "latitude": "53.13750000",
                        "longitude": "6.42083000"
                    },
                    {
                        "id": 78636,
                        "name": "Rolde",
                        "latitude": "52.98417000",
                        "longitude": "6.64861000"
                    },
                    {
                        "id": 78648,
                        "name": "Ruinen",
                        "latitude": "52.76250000",
                        "longitude": "6.35417000"
                    },
                    {
                        "id": 78649,
                        "name": "Ruinerwold",
                        "latitude": "52.72333000",
                        "longitude": "6.24861000"
                    },
                    {
                        "id": 78679,
                        "name": "Schoonebeek",
                        "latitude": "52.66250000",
                        "longitude": "6.88472000"
                    },
                    {
                        "id": 78681,
                        "name": "Schoonoord",
                        "latitude": "52.84583000",
                        "longitude": "6.75556000"
                    },
                    {
                        "id": 78709,
                        "name": "Sleen",
                        "latitude": "52.77167000",
                        "longitude": "6.80278000"
                    },
                    {
                        "id": 78796,
                        "name": "Tweede Exloërmond",
                        "latitude": "52.90917000",
                        "longitude": "6.93333000"
                    },
                    {
                        "id": 78802,
                        "name": "Tynaarlo",
                        "latitude": "53.07750000",
                        "longitude": "6.61667000"
                    },
                    {
                        "id": 78809,
                        "name": "Uffelte",
                        "latitude": "52.79000000",
                        "longitude": "6.28056000"
                    },
                    {
                        "id": 78832,
                        "name": "Valthe",
                        "latitude": "52.84583000",
                        "longitude": "6.89444000"
                    },
                    {
                        "id": 78833,
                        "name": "Valthermond",
                        "latitude": "52.88167000",
                        "longitude": "6.96250000"
                    },
                    {
                        "id": 78838,
                        "name": "Veenoord",
                        "latitude": "52.71087000",
                        "longitude": "6.84869000"
                    },
                    {
                        "id": 78857,
                        "name": "Vledder",
                        "latitude": "52.85583000",
                        "longitude": "6.20833000"
                    },
                    {
                        "id": 78885,
                        "name": "Vries",
                        "latitude": "53.07417000",
                        "longitude": "6.57778000"
                    },
                    {
                        "id": 78917,
                        "name": "Weiteveen",
                        "latitude": "52.67250000",
                        "longitude": "6.98750000"
                    },
                    {
                        "id": 78935,
                        "name": "Westerbork",
                        "latitude": "52.85000000",
                        "longitude": "6.60833000"
                    },
                    {
                        "id": 78943,
                        "name": "Westlaren",
                        "latitude": "53.08480000",
                        "longitude": "6.66469000"
                    },
                    {
                        "id": 78976,
                        "name": "Wolfsbos",
                        "latitude": "52.71734000",
                        "longitude": "6.49881000"
                    },
                    {
                        "id": 79028,
                        "name": "Zuidlaren",
                        "latitude": "53.09417000",
                        "longitude": "6.68194000"
                    }
                ]
            },
            {
                "id": 2619,
                "name": "Flevoland",
                "iso2": "FL",
                "latitude": "52.52797810",
                "longitude": "5.59535080",
                "type": "province",
                "cities": [
                    {
                        "id": 77327,
                        "name": "Almere Stad",
                        "latitude": "52.37025000",
                        "longitude": "5.21413000"
                    },
                    {
                        "id": 77427,
                        "name": "Biddinghuizen",
                        "latitude": "52.45500000",
                        "longitude": "5.69306000"
                    },
                    {
                        "id": 77612,
                        "name": "Dronten",
                        "latitude": "52.52500000",
                        "longitude": "5.71806000"
                    },
                    {
                        "id": 77652,
                        "name": "Emmeloord",
                        "latitude": "52.71083000",
                        "longitude": "5.74861000"
                    },
                    {
                        "id": 77661,
                        "name": "Ens",
                        "latitude": "52.63667000",
                        "longitude": "5.82778000"
                    },
                    {
                        "id": 78288,
                        "name": "Lelystad",
                        "latitude": "52.50833000",
                        "longitude": "5.47500000"
                    },
                    {
                        "id": 78819,
                        "name": "Urk",
                        "latitude": "52.66250000",
                        "longitude": "5.60139000"
                    },
                    {
                        "id": 79002,
                        "name": "Zeewolde",
                        "latitude": "52.33000000",
                        "longitude": "5.54167000"
                    }
                ]
            },
            {
                "id": 2622,
                "name": "Friesland",
                "iso2": "FR",
                "latitude": "53.16416420",
                "longitude": "5.78175420",
                "type": "province",
                "cities": [
                    {
                        "id": 77321,
                        "name": "Akkrum",
                        "latitude": "53.05024000",
                        "longitude": "5.83087000"
                    },
                    {
                        "id": 77323,
                        "name": "Aldeboarn",
                        "latitude": "53.05000000",
                        "longitude": "5.90000000"
                    },
                    {
                        "id": 77324,
                        "name": "Aldlân-Oost",
                        "latitude": "53.18860000",
                        "longitude": "5.82825000"
                    },
                    {
                        "id": 77351,
                        "name": "Appelscha",
                        "latitude": "52.95526000",
                        "longitude": "6.35053000"
                    },
                    {
                        "id": 77359,
                        "name": "Augustinusga",
                        "latitude": "53.21785000",
                        "longitude": "6.16170000"
                    },
                    {
                        "id": 77373,
                        "name": "Bakhuizen",
                        "latitude": "52.86975000",
                        "longitude": "5.45926000"
                    },
                    {
                        "id": 77374,
                        "name": "Bakkeveen",
                        "latitude": "53.08072000",
                        "longitude": "6.25671000"
                    },
                    {
                        "id": 77375,
                        "name": "Balk",
                        "latitude": "52.89756000",
                        "longitude": "5.57964000"
                    },
                    {
                        "id": 77394,
                        "name": "Beetsterzwaag",
                        "latitude": "53.05914000",
                        "longitude": "6.07711000"
                    },
                    {
                        "id": 77420,
                        "name": "Berltsum",
                        "latitude": "53.24370000",
                        "longitude": "5.65101000"
                    },
                    {
                        "id": 77431,
                        "name": "Bilgaard",
                        "latitude": "53.21551000",
                        "longitude": "5.79574000"
                    },
                    {
                        "id": 77452,
                        "name": "Bolsward",
                        "latitude": "53.06555000",
                        "longitude": "5.53176000"
                    },
                    {
                        "id": 77453,
                        "name": "Boornbergum",
                        "latitude": "53.08284000",
                        "longitude": "6.04578000"
                    },
                    {
                        "id": 77487,
                        "name": "Broeksterwâld",
                        "latitude": "53.27466000",
                        "longitude": "5.99648000"
                    },
                    {
                        "id": 77501,
                        "name": "Buitenpost",
                        "latitude": "53.25166000",
                        "longitude": "6.14483000"
                    },
                    {
                        "id": 77505,
                        "name": "Burdaard",
                        "latitude": "53.29421000",
                        "longitude": "5.87897000"
                    },
                    {
                        "id": 77507,
                        "name": "Burgum",
                        "latitude": "53.19243000",
                        "longitude": "5.99009000"
                    },
                    {
                        "id": 77510,
                        "name": "Camminghaburen",
                        "latitude": "53.20973000",
                        "longitude": "5.84318000"
                    },
                    {
                        "id": 77530,
                        "name": "Damwâld",
                        "latitude": "53.29046000",
                        "longitude": "5.99785000"
                    },
                    {
                        "id": 77535,
                        "name": "De Domp",
                        "latitude": "53.03113000",
                        "longitude": "5.67716000"
                    },
                    {
                        "id": 77537,
                        "name": "De Drait",
                        "latitude": "53.09743000",
                        "longitude": "6.06791000"
                    },
                    {
                        "id": 77538,
                        "name": "De Fryske Marren",
                        "latitude": "52.96906000",
                        "longitude": "5.77246000"
                    },
                    {
                        "id": 77541,
                        "name": "De Greiden",
                        "latitude": "52.94960000",
                        "longitude": "5.91366000"
                    },
                    {
                        "id": 77548,
                        "name": "De Knipe",
                        "latitude": "52.96829000",
                        "longitude": "5.97116000"
                    },
                    {
                        "id": 77561,
                        "name": "De Westereen",
                        "latitude": "53.25731000",
                        "longitude": "6.03630000"
                    },
                    {
                        "id": 77588,
                        "name": "Dokkum",
                        "latitude": "53.32224000",
                        "longitude": "5.99697000"
                    },
                    {
                        "id": 77593,
                        "name": "Donkerbroek",
                        "latitude": "53.01734000",
                        "longitude": "6.23927000"
                    },
                    {
                        "id": 77602,
                        "name": "Drachten",
                        "latitude": "53.11254000",
                        "longitude": "6.09890000"
                    },
                    {
                        "id": 77603,
                        "name": "Drachtstercompagnie",
                        "latitude": "53.13462000",
                        "longitude": "6.14153000"
                    },
                    {
                        "id": 77610,
                        "name": "Drogeham",
                        "latitude": "53.20213000",
                        "longitude": "6.11183000"
                    },
                    {
                        "id": 77611,
                        "name": "Dronryp",
                        "latitude": "53.20000000",
                        "longitude": "5.65000000"
                    },
                    {
                        "id": 77621,
                        "name": "Eastermar",
                        "latitude": "53.17466000",
                        "longitude": "6.05999000"
                    },
                    {
                        "id": 77622,
                        "name": "Echtenerbrug",
                        "latitude": "52.87141000",
                        "longitude": "5.82147000"
                    },
                    {
                        "id": 77673,
                        "name": "Feanwâlden",
                        "latitude": "53.23558000",
                        "longitude": "5.98832000"
                    },
                    {
                        "id": 77675,
                        "name": "Ferwert",
                        "latitude": "53.33784000",
                        "longitude": "5.82533000"
                    },
                    {
                        "id": 77678,
                        "name": "Franeker",
                        "latitude": "53.18546000",
                        "longitude": "5.54123000"
                    },
                    {
                        "id": 77683,
                        "name": "Garyp",
                        "latitude": "53.16667000",
                        "longitude": "5.96667000"
                    },
                    {
                        "id": 78042,
                        "name": "Gorredijk",
                        "latitude": "53.00659000",
                        "longitude": "6.06402000"
                    },
                    {
                        "id": 78047,
                        "name": "Goutum",
                        "latitude": "53.17734000",
                        "longitude": "5.80370000"
                    },
                    {
                        "id": 78068,
                        "name": "Grou",
                        "latitude": "53.09456000",
                        "longitude": "5.83745000"
                    },
                    {
                        "id": 78073,
                        "name": "Gytsjerk",
                        "latitude": "53.24293000",
                        "longitude": "5.89502000"
                    },
                    {
                        "id": 78086,
                        "name": "Hallum",
                        "latitude": "53.30657000",
                        "longitude": "5.78379000"
                    },
                    {
                        "id": 78095,
                        "name": "Harkema",
                        "latitude": "53.18333000",
                        "longitude": "6.13333000"
                    },
                    {
                        "id": 78097,
                        "name": "Harlingen",
                        "latitude": "53.17477000",
                        "longitude": "5.42244000"
                    },
                    {
                        "id": 78103,
                        "name": "Haulerwijk",
                        "latitude": "53.06468000",
                        "longitude": "6.33453000"
                    },
                    {
                        "id": 78106,
                        "name": "Heechterp",
                        "latitude": "53.20963000",
                        "longitude": "5.82250000"
                    },
                    {
                        "id": 78107,
                        "name": "Heeg",
                        "latitude": "52.96860000",
                        "longitude": "5.61075000"
                    },
                    {
                        "id": 78114,
                        "name": "Heerenveen",
                        "latitude": "52.95929000",
                        "longitude": "5.91854000"
                    },
                    {
                        "id": 78162,
                        "name": "Hoek",
                        "latitude": "53.20455000",
                        "longitude": "5.80192000"
                    },
                    {
                        "id": 78170,
                        "name": "Hollum",
                        "latitude": "53.43940000",
                        "longitude": "5.63805000"
                    },
                    {
                        "id": 78172,
                        "name": "Holwerd",
                        "latitude": "53.36815000",
                        "longitude": "5.90073000"
                    },
                    {
                        "id": 78193,
                        "name": "Huizum",
                        "latitude": "53.19170000",
                        "longitude": "5.81119000"
                    },
                    {
                        "id": 78198,
                        "name": "Hurdegaryp",
                        "latitude": "53.21333000",
                        "longitude": "5.94137000"
                    },
                    {
                        "id": 78200,
                        "name": "IJlst",
                        "latitude": "53.01009000",
                        "longitude": "5.62312000"
                    },
                    {
                        "id": 78206,
                        "name": "Jirnsum",
                        "latitude": "53.07753000",
                        "longitude": "5.79254000"
                    },
                    {
                        "id": 78207,
                        "name": "Joure",
                        "latitude": "52.96570000",
                        "longitude": "5.80301000"
                    },
                    {
                        "id": 78208,
                        "name": "Jubbega",
                        "latitude": "53.00396000",
                        "longitude": "6.12183000"
                    },
                    {
                        "id": 78243,
                        "name": "Kollum",
                        "latitude": "53.27695000",
                        "longitude": "6.15293000"
                    },
                    {
                        "id": 78244,
                        "name": "Kollumerzwaag",
                        "latitude": "53.26224000",
                        "longitude": "6.07544000"
                    },
                    {
                        "id": 78247,
                        "name": "Kootstertille",
                        "latitude": "53.21261000",
                        "longitude": "6.09209000"
                    },
                    {
                        "id": 78254,
                        "name": "Koudum",
                        "latitude": "52.91551000",
                        "longitude": "5.44834000"
                    },
                    {
                        "id": 78272,
                        "name": "Langweer",
                        "latitude": "52.95836000",
                        "longitude": "5.72173000"
                    },
                    {
                        "id": 78283,
                        "name": "Leeuwarden",
                        "latitude": "53.20139000",
                        "longitude": "5.80859000"
                    },
                    {
                        "id": 78289,
                        "name": "Lemmer",
                        "latitude": "52.84618000",
                        "longitude": "5.70912000"
                    },
                    {
                        "id": 78343,
                        "name": "Makkum",
                        "latitude": "53.05458000",
                        "longitude": "5.40231000"
                    },
                    {
                        "id": 78347,
                        "name": "Mantgum",
                        "latitude": "53.12865000",
                        "longitude": "5.71924000"
                    },
                    {
                        "id": 78353,
                        "name": "Marrum",
                        "latitude": "53.32277000",
                        "longitude": "5.80198000"
                    },
                    {
                        "id": 78355,
                        "name": "Marsum",
                        "latitude": "53.21050000",
                        "longitude": "5.72637000"
                    },
                    {
                        "id": 78380,
                        "name": "Menaam",
                        "latitude": "53.21797000",
                        "longitude": "5.66124000"
                    },
                    {
                        "id": 78403,
                        "name": "Minnertsga",
                        "latitude": "53.25104000",
                        "longitude": "5.59513000"
                    },
                    {
                        "id": 78427,
                        "name": "Nes",
                        "latitude": "53.44502000",
                        "longitude": "5.77400000"
                    },
                    {
                        "id": 78442,
                        "name": "Nieuwehorne",
                        "latitude": "52.95113000",
                        "longitude": "6.06342000"
                    },
                    {
                        "id": 78460,
                        "name": "Noardburgum",
                        "latitude": "53.22135000",
                        "longitude": "6.00523000"
                    },
                    {
                        "id": 78472,
                        "name": "Noordwolde",
                        "latitude": "52.88964000",
                        "longitude": "6.14153000"
                    },
                    {
                        "id": 78486,
                        "name": "Oentsjerk",
                        "latitude": "53.25000000",
                        "longitude": "5.90000000"
                    },
                    {
                        "id": 78493,
                        "name": "Oldeberkoop",
                        "latitude": "52.93788000",
                        "longitude": "6.13089000"
                    },
                    {
                        "id": 78507,
                        "name": "Oost-Vlieland",
                        "latitude": "53.29703000",
                        "longitude": "5.07431000"
                    },
                    {
                        "id": 78524,
                        "name": "Oosterwolde",
                        "latitude": "52.99164000",
                        "longitude": "6.29096000"
                    },
                    {
                        "id": 78533,
                        "name": "Opeinde",
                        "latitude": "53.13410000",
                        "longitude": "6.05656000"
                    },
                    {
                        "id": 78539,
                        "name": "Oppenhuizen",
                        "latitude": "53.01194000",
                        "longitude": "5.69495000"
                    },
                    {
                        "id": 78542,
                        "name": "Oranjewoud",
                        "latitude": "52.94579000",
                        "longitude": "5.95038000"
                    },
                    {
                        "id": 78560,
                        "name": "Oudega",
                        "latitude": "53.12504000",
                        "longitude": "5.99888000"
                    },
                    {
                        "id": 78561,
                        "name": "Oudehaske",
                        "latitude": "52.95709000",
                        "longitude": "5.87095000"
                    },
                    {
                        "id": 78562,
                        "name": "Oudemirdum",
                        "latitude": "52.85019000",
                        "longitude": "5.53544000"
                    },
                    {
                        "id": 78566,
                        "name": "Oudeschoot",
                        "latitude": "52.93343000",
                        "longitude": "5.95579000"
                    },
                    {
                        "id": 78643,
                        "name": "Rottevalle",
                        "latitude": "53.14523000",
                        "longitude": "6.10411000"
                    },
                    {
                        "id": 78661,
                        "name": "Scharnegoutum",
                        "latitude": "53.06051000",
                        "longitude": "5.67822000"
                    },
                    {
                        "id": 78670,
                        "name": "Schiermonnikoog",
                        "latitude": "53.48025000",
                        "longitude": "6.15209000"
                    },
                    {
                        "id": 78689,
                        "name": "Sexbierum",
                        "latitude": "53.21823000",
                        "longitude": "5.48402000"
                    },
                    {
                        "id": 78694,
                        "name": "Sint Annaparochie",
                        "latitude": "53.27620000",
                        "longitude": "5.65727000"
                    },
                    {
                        "id": 78696,
                        "name": "Sint Jacobiparochie",
                        "latitude": "53.27291000",
                        "longitude": "5.60354000"
                    },
                    {
                        "id": 78700,
                        "name": "Sint Nicolaasga",
                        "latitude": "52.92293000",
                        "longitude": "5.74242000"
                    },
                    {
                        "id": 78707,
                        "name": "Sintjohannesga",
                        "latitude": "52.93157000",
                        "longitude": "5.85588000"
                    },
                    {
                        "id": 78717,
                        "name": "Sneek",
                        "latitude": "53.03297000",
                        "longitude": "5.65890000"
                    },
                    {
                        "id": 78741,
                        "name": "Stadsfenne",
                        "latitude": "53.03987000",
                        "longitude": "5.67844000"
                    },
                    {
                        "id": 78759,
                        "name": "Stiens",
                        "latitude": "53.26234000",
                        "longitude": "5.75769000"
                    },
                    {
                        "id": 78766,
                        "name": "Sûdwest Fryslân",
                        "latitude": "53.01056000",
                        "longitude": "5.52580000"
                    },
                    {
                        "id": 78765,
                        "name": "Surhuisterveen",
                        "latitude": "53.18477000",
                        "longitude": "6.17031000"
                    },
                    {
                        "id": 78773,
                        "name": "Ternaard",
                        "latitude": "53.38203000",
                        "longitude": "5.96523000"
                    },
                    {
                        "id": 78785,
                        "name": "Tijnje",
                        "latitude": "53.03058000",
                        "longitude": "5.99193000"
                    },
                    {
                        "id": 78787,
                        "name": "Tinga",
                        "latitude": "53.02064000",
                        "longitude": "5.64575000"
                    },
                    {
                        "id": 78799,
                        "name": "Twijzel",
                        "latitude": "53.23152000",
                        "longitude": "6.08952000"
                    },
                    {
                        "id": 78800,
                        "name": "Twijzelerheide",
                        "latitude": "53.24015000",
                        "longitude": "6.04591000"
                    },
                    {
                        "id": 78803,
                        "name": "Tytsjerk",
                        "latitude": "53.21343000",
                        "longitude": "5.90961000"
                    },
                    {
                        "id": 78804,
                        "name": "Tzummarum",
                        "latitude": "53.23733000",
                        "longitude": "5.54612000"
                    },
                    {
                        "id": 78818,
                        "name": "Ureterp",
                        "latitude": "53.09244000",
                        "longitude": "6.16718000"
                    },
                    {
                        "id": 78890,
                        "name": "Waadhoeke",
                        "latitude": "53.18947000",
                        "longitude": "5.50793000"
                    },
                    {
                        "id": 78905,
                        "name": "Warga",
                        "latitude": "53.15145000",
                        "longitude": "5.84404000"
                    },
                    {
                        "id": 78930,
                        "name": "West-Terschelling",
                        "latitude": "53.35911000",
                        "longitude": "5.21482000"
                    },
                    {
                        "id": 78932,
                        "name": "Westeinde",
                        "latitude": "53.20853000",
                        "longitude": "5.76812000"
                    },
                    {
                        "id": 78957,
                        "name": "Wijnjewoude",
                        "latitude": "53.05814000",
                        "longitude": "6.20470000"
                    },
                    {
                        "id": 78966,
                        "name": "Wirdum",
                        "latitude": "53.14893000",
                        "longitude": "5.80387000"
                    },
                    {
                        "id": 78970,
                        "name": "Witmarsum",
                        "latitude": "53.10452000",
                        "longitude": "5.46902000"
                    },
                    {
                        "id": 78978,
                        "name": "Wolvega",
                        "latitude": "52.87545000",
                        "longitude": "5.99691000"
                    },
                    {
                        "id": 78979,
                        "name": "Wommels",
                        "latitude": "53.10883000",
                        "longitude": "5.58749000"
                    },
                    {
                        "id": 78982,
                        "name": "Workum",
                        "latitude": "52.97969000",
                        "longitude": "5.44710000"
                    },
                    {
                        "id": 78987,
                        "name": "Woudsend",
                        "latitude": "52.94357000",
                        "longitude": "5.62843000"
                    },
                    {
                        "id": 79026,
                        "name": "Zuiderburen",
                        "latitude": "53.17340000",
                        "longitude": "5.84271000"
                    }
                ]
            },
            {
                "id": 2611,
                "name": "Gelderland",
                "iso2": "GE",
                "latitude": "52.04515500",
                "longitude": "5.87182350",
                "type": "province",
                "cities": [
                    {
                        "id": 77300,
                        "name": "'s-Heerenberg",
                        "latitude": "51.87670000",
                        "longitude": "6.25877000"
                    },
                    {
                        "id": 77309,
                        "name": "Aalst",
                        "latitude": "51.78250000",
                        "longitude": "5.12778000"
                    },
                    {
                        "id": 77310,
                        "name": "Aalten",
                        "latitude": "51.92500000",
                        "longitude": "6.58056000"
                    },
                    {
                        "id": 77319,
                        "name": "Afferden",
                        "latitude": "51.88000000",
                        "longitude": "5.63472000"
                    },
                    {
                        "id": 77331,
                        "name": "Alverna",
                        "latitude": "51.80417000",
                        "longitude": "5.75972000"
                    },
                    {
                        "id": 77337,
                        "name": "Ammerzoden",
                        "latitude": "51.74917000",
                        "longitude": "5.22083000"
                    },
                    {
                        "id": 77343,
                        "name": "Andelst",
                        "latitude": "51.90833000",
                        "longitude": "5.72917000"
                    },
                    {
                        "id": 77345,
                        "name": "Angeren",
                        "latitude": "51.91583000",
                        "longitude": "5.95833000"
                    },
                    {
                        "id": 77346,
                        "name": "Angerlo",
                        "latitude": "51.99583000",
                        "longitude": "6.13472000"
                    },
                    {
                        "id": 77348,
                        "name": "Anklaar",
                        "latitude": "52.23111000",
                        "longitude": "5.98497000"
                    },
                    {
                        "id": 77350,
                        "name": "Apeldoorn",
                        "latitude": "52.21000000",
                        "longitude": "5.96944000"
                    },
                    {
                        "id": 77356,
                        "name": "Arnhem",
                        "latitude": "51.98000000",
                        "longitude": "5.91111000"
                    },
                    {
                        "id": 77369,
                        "name": "Babberich",
                        "latitude": "51.90750000",
                        "longitude": "6.11111000"
                    },
                    {
                        "id": 77372,
                        "name": "Bakenberg",
                        "latitude": "52.00511000",
                        "longitude": "5.87710000"
                    },
                    {
                        "id": 77382,
                        "name": "Barneveld",
                        "latitude": "52.14000000",
                        "longitude": "5.58472000"
                    },
                    {
                        "id": 77388,
                        "name": "Beek gem Montferland",
                        "latitude": "51.90667000",
                        "longitude": "6.18750000"
                    },
                    {
                        "id": 77389,
                        "name": "Beekbergen",
                        "latitude": "52.16000000",
                        "longitude": "5.96389000"
                    },
                    {
                        "id": 77392,
                        "name": "Beesd",
                        "latitude": "51.88750000",
                        "longitude": "5.19167000"
                    },
                    {
                        "id": 77399,
                        "name": "Beltrum",
                        "latitude": "52.06667000",
                        "longitude": "6.56389000"
                    },
                    {
                        "id": 77400,
                        "name": "Bemmel",
                        "latitude": "51.89167000",
                        "longitude": "5.89861000"
                    },
                    {
                        "id": 77402,
                        "name": "Bennekom",
                        "latitude": "51.99833000",
                        "longitude": "5.67639000"
                    },
                    {
                        "id": 77405,
                        "name": "Berg en Bos",
                        "latitude": "52.22009000",
                        "longitude": "5.93340000"
                    },
                    {
                        "id": 77406,
                        "name": "Berg en Dal",
                        "latitude": "51.82167000",
                        "longitude": "5.91667000"
                    },
                    {
                        "id": 77409,
                        "name": "Bergharen",
                        "latitude": "51.85083000",
                        "longitude": "5.66944000"
                    },
                    {
                        "id": 77415,
                        "name": "Berkelland",
                        "latitude": "52.10606000",
                        "longitude": "6.56748000"
                    },
                    {
                        "id": 77424,
                        "name": "Beuningen",
                        "latitude": "51.86083000",
                        "longitude": "5.76667000"
                    },
                    {
                        "id": 77425,
                        "name": "Beusichem",
                        "latitude": "51.95000000",
                        "longitude": "5.29167000"
                    },
                    {
                        "id": 77433,
                        "name": "Binnenstad",
                        "latitude": "52.21304000",
                        "longitude": "5.95957000"
                    },
                    {
                        "id": 77454,
                        "name": "Borculo",
                        "latitude": "52.11583000",
                        "longitude": "6.52222000"
                    },
                    {
                        "id": 77470,
                        "name": "Brakel",
                        "latitude": "51.81750000",
                        "longitude": "5.09028000"
                    },
                    {
                        "id": 77471,
                        "name": "Brakkenstein",
                        "latitude": "51.81324000",
                        "longitude": "5.86539000"
                    },
                    {
                        "id": 77474,
                        "name": "Bredevoort",
                        "latitude": "51.94167000",
                        "longitude": "6.62083000"
                    },
                    {
                        "id": 77475,
                        "name": "Bredeweg",
                        "latitude": "51.76019000",
                        "longitude": "5.94189000"
                    },
                    {
                        "id": 77481,
                        "name": "Brinkhorst",
                        "latitude": "52.21302000",
                        "longitude": "5.95167000"
                    },
                    {
                        "id": 77489,
                        "name": "Bruchem",
                        "latitude": "51.78667000",
                        "longitude": "5.23611000"
                    },
                    {
                        "id": 77492,
                        "name": "Brummelhof",
                        "latitude": "52.20503000",
                        "longitude": "5.96789000"
                    },
                    {
                        "id": 77493,
                        "name": "Brummen",
                        "latitude": "52.09000000",
                        "longitude": "6.15556000"
                    },
                    {
                        "id": 77506,
                        "name": "Burgemeesterswijk",
                        "latitude": "51.98943000",
                        "longitude": "5.89597000"
                    },
                    {
                        "id": 77522,
                        "name": "Componistenkwartier",
                        "latitude": "52.18977000",
                        "longitude": "5.96609000"
                    },
                    {
                        "id": 77523,
                        "name": "Corlaer",
                        "latitude": "52.21639000",
                        "longitude": "5.46535000"
                    },
                    {
                        "id": 77527,
                        "name": "Culemborg",
                        "latitude": "51.95500000",
                        "longitude": "5.22778000"
                    },
                    {
                        "id": 77534,
                        "name": "De Bouwhof",
                        "latitude": "52.18546000",
                        "longitude": "5.94704000"
                    },
                    {
                        "id": 77543,
                        "name": "De Haven",
                        "latitude": "52.21045000",
                        "longitude": "5.97407000"
                    },
                    {
                        "id": 77545,
                        "name": "De Heeze",
                        "latitude": "52.20061000",
                        "longitude": "5.95365000"
                    },
                    {
                        "id": 77554,
                        "name": "De Mheen",
                        "latitude": "52.21954000",
                        "longitude": "5.99141000"
                    },
                    {
                        "id": 77564,
                        "name": "Deest",
                        "latitude": "51.89000000",
                        "longitude": "5.66667000"
                    },
                    {
                        "id": 77565,
                        "name": "Deil",
                        "latitude": "51.88417000",
                        "longitude": "5.24306000"
                    },
                    {
                        "id": 77579,
                        "name": "Dieren",
                        "latitude": "52.05250000",
                        "longitude": "6.10000000"
                    },
                    {
                        "id": 77586,
                        "name": "Doesburg",
                        "latitude": "52.01250000",
                        "longitude": "6.13889000"
                    },
                    {
                        "id": 77587,
                        "name": "Doetinchem",
                        "latitude": "51.96500000",
                        "longitude": "6.28889000"
                    },
                    {
                        "id": 77596,
                        "name": "Doornenburg",
                        "latitude": "51.89000000",
                        "longitude": "6.00000000"
                    },
                    {
                        "id": 77597,
                        "name": "Doornspijk",
                        "latitude": "52.41833000",
                        "longitude": "5.81806000"
                    },
                    {
                        "id": 77598,
                        "name": "Doornsteeg",
                        "latitude": "52.23000000",
                        "longitude": "5.45417000"
                    },
                    {
                        "id": 77599,
                        "name": "Doorwerth",
                        "latitude": "51.97917000",
                        "longitude": "5.79722000"
                    },
                    {
                        "id": 77606,
                        "name": "Driehuizen",
                        "latitude": "52.20879000",
                        "longitude": "5.94442000"
                    },
                    {
                        "id": 77607,
                        "name": "Driel",
                        "latitude": "51.95917000",
                        "longitude": "5.81389000"
                    },
                    {
                        "id": 77613,
                        "name": "Drumpt",
                        "latitude": "51.89700000",
                        "longitude": "5.41043000"
                    },
                    {
                        "id": 77614,
                        "name": "Druten",
                        "latitude": "51.88833000",
                        "longitude": "5.60556000"
                    },
                    {
                        "id": 77617,
                        "name": "Duiven",
                        "latitude": "51.94667000",
                        "longitude": "6.01389000"
                    },
                    {
                        "id": 77625,
                        "name": "Ede",
                        "latitude": "52.03333000",
                        "longitude": "5.65833000"
                    },
                    {
                        "id": 77626,
                        "name": "Ederveen",
                        "latitude": "52.06333000",
                        "longitude": "5.57778000"
                    },
                    {
                        "id": 77627,
                        "name": "Eefde",
                        "latitude": "52.16667000",
                        "longitude": "6.22500000"
                    },
                    {
                        "id": 77630,
                        "name": "Eerbeek",
                        "latitude": "52.10500000",
                        "longitude": "6.05833000"
                    },
                    {
                        "id": 77639,
                        "name": "Eibergen",
                        "latitude": "52.10000000",
                        "longitude": "6.64861000"
                    },
                    {
                        "id": 77645,
                        "name": "Elburg",
                        "latitude": "52.44750000",
                        "longitude": "5.84306000"
                    },
                    {
                        "id": 77646,
                        "name": "Elden",
                        "latitude": "51.95833000",
                        "longitude": "5.88194000"
                    },
                    {
                        "id": 77647,
                        "name": "Ellecom",
                        "latitude": "52.03250000",
                        "longitude": "6.08750000"
                    },
                    {
                        "id": 77650,
                        "name": "Elspeet",
                        "latitude": "52.29167000",
                        "longitude": "5.78889000"
                    },
                    {
                        "id": 77651,
                        "name": "Elst",
                        "latitude": "51.91917000",
                        "longitude": "5.84167000"
                    },
                    {
                        "id": 77659,
                        "name": "Emst",
                        "latitude": "52.31583000",
                        "longitude": "5.97361000"
                    },
                    {
                        "id": 77664,
                        "name": "Epe",
                        "latitude": "52.34750000",
                        "longitude": "5.98333000"
                    },
                    {
                        "id": 77665,
                        "name": "Epse",
                        "latitude": "52.22500000",
                        "longitude": "6.20000000"
                    },
                    {
                        "id": 77666,
                        "name": "Ermelo",
                        "latitude": "52.29833000",
                        "longitude": "5.62222000"
                    },
                    {
                        "id": 77670,
                        "name": "Etten",
                        "latitude": "51.91667000",
                        "longitude": "6.33611000"
                    },
                    {
                        "id": 77681,
                        "name": "Gameren",
                        "latitude": "51.80083000",
                        "longitude": "5.20417000"
                    },
                    {
                        "id": 77682,
                        "name": "Garderen",
                        "latitude": "52.23083000",
                        "longitude": "5.71389000"
                    },
                    {
                        "id": 77689,
                        "name": "Geitenkamp",
                        "latitude": "52.00379000",
                        "longitude": "5.93862000"
                    },
                    {
                        "id": 77690,
                        "name": "Geldermalsen",
                        "latitude": "51.88083000",
                        "longitude": "5.28889000"
                    },
                    {
                        "id": 77691,
                        "name": "Geldermalsen-West",
                        "latitude": "51.87968000",
                        "longitude": "5.28015000"
                    },
                    {
                        "id": 78022,
                        "name": "Gendringen",
                        "latitude": "51.87333000",
                        "longitude": "6.37639000"
                    },
                    {
                        "id": 78023,
                        "name": "Gendt",
                        "latitude": "51.87750000",
                        "longitude": "5.97083000"
                    },
                    {
                        "id": 78027,
                        "name": "Giesbeek",
                        "latitude": "51.99333000",
                        "longitude": "6.06667000"
                    },
                    {
                        "id": 78043,
                        "name": "Gorssel",
                        "latitude": "52.20167000",
                        "longitude": "6.20139000"
                    },
                    {
                        "id": 78061,
                        "name": "Groesbeek",
                        "latitude": "51.77667000",
                        "longitude": "5.93611000"
                    },
                    {
                        "id": 78062,
                        "name": "Groessen",
                        "latitude": "51.93167000",
                        "longitude": "6.02639000"
                    },
                    {
                        "id": 78069,
                        "name": "Gulden Bodem",
                        "latitude": "51.99428000",
                        "longitude": "5.89080000"
                    },
                    {
                        "id": 78074,
                        "name": "Haaften",
                        "latitude": "51.81583000",
                        "longitude": "5.21111000"
                    },
                    {
                        "id": 78076,
                        "name": "Haalderen",
                        "latitude": "51.88750000",
                        "longitude": "5.92917000"
                    },
                    {
                        "id": 78092,
                        "name": "Harderwijk",
                        "latitude": "52.34167000",
                        "longitude": "5.62083000"
                    },
                    {
                        "id": 78098,
                        "name": "Harskamp",
                        "latitude": "52.13000000",
                        "longitude": "5.75278000"
                    },
                    {
                        "id": 78100,
                        "name": "Hatert",
                        "latitude": "51.80635000",
                        "longitude": "5.83057000"
                    },
                    {
                        "id": 78101,
                        "name": "Hattem",
                        "latitude": "52.47500000",
                        "longitude": "6.06389000"
                    },
                    {
                        "id": 78102,
                        "name": "Hattemerbroek",
                        "latitude": "52.47417000",
                        "longitude": "6.02222000"
                    },
                    {
                        "id": 78105,
                        "name": "Hedel",
                        "latitude": "51.74802000",
                        "longitude": "5.26134000"
                    },
                    {
                        "id": 78109,
                        "name": "Heelsum",
                        "latitude": "51.98417000",
                        "longitude": "5.75833000"
                    },
                    {
                        "id": 78113,
                        "name": "Heerde",
                        "latitude": "52.38723000",
                        "longitude": "6.04016000"
                    },
                    {
                        "id": 78115,
                        "name": "Heerewaarden",
                        "latitude": "51.81769000",
                        "longitude": "5.39300000"
                    },
                    {
                        "id": 78120,
                        "name": "Hees",
                        "latitude": "51.84136000",
                        "longitude": "5.82846000"
                    },
                    {
                        "id": 78141,
                        "name": "Hengelo",
                        "latitude": "52.05083000",
                        "longitude": "6.30972000"
                    },
                    {
                        "id": 78143,
                        "name": "Hengstdal",
                        "latitude": "51.83333000",
                        "longitude": "5.88333000"
                    },
                    {
                        "id": 78148,
                        "name": "Herwijnen",
                        "latitude": "51.82667000",
                        "longitude": "5.12917000"
                    },
                    {
                        "id": 78149,
                        "name": "Het Loo",
                        "latitude": "52.23390000",
                        "longitude": "5.95275000"
                    },
                    {
                        "id": 78151,
                        "name": "Heteren",
                        "latitude": "51.95667000",
                        "longitude": "5.75556000"
                    },
                    {
                        "id": 78153,
                        "name": "Heumen",
                        "latitude": "51.76500000",
                        "longitude": "5.84444000"
                    },
                    {
                        "id": 78183,
                        "name": "Hoogkamp",
                        "latitude": "51.99630000",
                        "longitude": "5.88026000"
                    },
                    {
                        "id": 78188,
                        "name": "Horssen",
                        "latitude": "51.85583000",
                        "longitude": "5.60972000"
                    },
                    {
                        "id": 78196,
                        "name": "Hummelo",
                        "latitude": "52.00417000",
                        "longitude": "6.23333000"
                    },
                    {
                        "id": 78197,
                        "name": "Hunnerberg",
                        "latitude": "51.84209000",
                        "longitude": "5.87876000"
                    },
                    {
                        "id": 78204,
                        "name": "Ingen",
                        "latitude": "51.95917000",
                        "longitude": "5.48472000"
                    },
                    {
                        "id": 78221,
                        "name": "Keijenborg",
                        "latitude": "52.02917000",
                        "longitude": "6.29444000"
                    },
                    {
                        "id": 78225,
                        "name": "Kerkdriel",
                        "latitude": "51.77167000",
                        "longitude": "5.33472000"
                    },
                    {
                        "id": 78229,
                        "name": "Kerschoten",
                        "latitude": "52.23333000",
                        "longitude": "5.96667000"
                    },
                    {
                        "id": 78231,
                        "name": "Kesteren",
                        "latitude": "51.93500000",
                        "longitude": "5.56944000"
                    },
                    {
                        "id": 78248,
                        "name": "Kootwijkerbroek",
                        "latitude": "52.15083000",
                        "longitude": "5.66944000"
                    },
                    {
                        "id": 78273,
                        "name": "Laren",
                        "latitude": "52.19417000",
                        "longitude": "6.36528000"
                    },
                    {
                        "id": 78282,
                        "name": "Leesten",
                        "latitude": "52.12790000",
                        "longitude": "6.23217000"
                    },
                    {
                        "id": 78290,
                        "name": "Lent",
                        "latitude": "51.86167000",
                        "longitude": "5.86667000"
                    },
                    {
                        "id": 78295,
                        "name": "Leuth",
                        "latitude": "51.83917000",
                        "longitude": "5.99167000"
                    },
                    {
                        "id": 78297,
                        "name": "Lichtenvoorde",
                        "latitude": "51.98667000",
                        "longitude": "6.56667000"
                    },
                    {
                        "id": 78299,
                        "name": "Lienden",
                        "latitude": "51.94833000",
                        "longitude": "5.51806000"
                    },
                    {
                        "id": 78309,
                        "name": "Lindenholt",
                        "latitude": "51.83270000",
                        "longitude": "5.79340000"
                    },
                    {
                        "id": 78315,
                        "name": "Lobith",
                        "latitude": "51.86250000",
                        "longitude": "6.11806000"
                    },
                    {
                        "id": 78316,
                        "name": "Lochem",
                        "latitude": "52.15917000",
                        "longitude": "6.41111000"
                    },
                    {
                        "id": 78317,
                        "name": "Loenen",
                        "latitude": "52.11750000",
                        "longitude": "6.01944000"
                    },
                    {
                        "id": 78327,
                        "name": "Lunteren",
                        "latitude": "52.08500000",
                        "longitude": "5.62222000"
                    },
                    {
                        "id": 78345,
                        "name": "Malburgen West",
                        "latitude": "51.96811000",
                        "longitude": "5.89743000"
                    },
                    {
                        "id": 78357,
                        "name": "Matendonk",
                        "latitude": "52.19766000",
                        "longitude": "6.01115000"
                    },
                    {
                        "id": 78358,
                        "name": "Matendreef",
                        "latitude": "52.19993000",
                        "longitude": "5.98592000"
                    },
                    {
                        "id": 78359,
                        "name": "Matengaarde",
                        "latitude": "52.19793000",
                        "longitude": "5.99570000"
                    },
                    {
                        "id": 78360,
                        "name": "Matenhoeve",
                        "latitude": "52.19056000",
                        "longitude": "6.01338000"
                    },
                    {
                        "id": 78361,
                        "name": "Matenhorst",
                        "latitude": "52.20482000",
                        "longitude": "5.99304000"
                    },
                    {
                        "id": 78362,
                        "name": "Matenveld",
                        "latitude": "52.18767000",
                        "longitude": "5.99879000"
                    },
                    {
                        "id": 78363,
                        "name": "Maurik",
                        "latitude": "51.96083000",
                        "longitude": "5.42222000"
                    },
                    {
                        "id": 78386,
                        "name": "Meteren",
                        "latitude": "51.86500000",
                        "longitude": "5.28333000"
                    },
                    {
                        "id": 78420,
                        "name": "Nederhemert",
                        "latitude": "51.76518000",
                        "longitude": "5.16817000"
                    },
                    {
                        "id": 78421,
                        "name": "Nederhemert-Noord",
                        "latitude": "51.76322000",
                        "longitude": "5.17305000"
                    },
                    {
                        "id": 78423,
                        "name": "Nederwoud",
                        "latitude": "52.10083000",
                        "longitude": "5.57083000"
                    },
                    {
                        "id": 78424,
                        "name": "Neede",
                        "latitude": "52.13417000",
                        "longitude": "6.61389000"
                    },
                    {
                        "id": 78452,
                        "name": "Nijkerk",
                        "latitude": "52.22000000",
                        "longitude": "5.48611000"
                    },
                    {
                        "id": 78453,
                        "name": "Nijkerkerveen",
                        "latitude": "52.19500000",
                        "longitude": "5.46667000"
                    },
                    {
                        "id": 78454,
                        "name": "Nijmegen",
                        "latitude": "51.84250000",
                        "longitude": "5.85278000"
                    },
                    {
                        "id": 78476,
                        "name": "Nunspeet",
                        "latitude": "52.37917000",
                        "longitude": "5.78611000"
                    },
                    {
                        "id": 78481,
                        "name": "Ochten",
                        "latitude": "51.91000000",
                        "longitude": "5.56944000"
                    },
                    {
                        "id": 78494,
                        "name": "Oldebroek",
                        "latitude": "52.44500000",
                        "longitude": "5.90139000"
                    },
                    {
                        "id": 78505,
                        "name": "Ooij",
                        "latitude": "51.85465000",
                        "longitude": "5.93915000"
                    },
                    {
                        "id": 78506,
                        "name": "Oost Gelre",
                        "latitude": "52.00425000",
                        "longitude": "6.54958000"
                    },
                    {
                        "id": 78513,
                        "name": "Oostendorp",
                        "latitude": "52.44722000",
                        "longitude": "5.85443000"
                    },
                    {
                        "id": 78514,
                        "name": "Oosterbeek",
                        "latitude": "51.98583000",
                        "longitude": "5.84583000"
                    },
                    {
                        "id": 78520,
                        "name": "Oosterhout",
                        "latitude": "51.88000000",
                        "longitude": "5.82639000"
                    },
                    {
                        "id": 78531,
                        "name": "Ooy",
                        "latitude": "51.91917000",
                        "longitude": "6.05833000"
                    },
                    {
                        "id": 78532,
                        "name": "Ooyerhoek",
                        "latitude": "52.12838000",
                        "longitude": "6.22307000"
                    },
                    {
                        "id": 78534,
                        "name": "Ophemert",
                        "latitude": "51.84500000",
                        "longitude": "5.38750000"
                    },
                    {
                        "id": 78535,
                        "name": "Opheusden",
                        "latitude": "51.93167000",
                        "longitude": "5.63194000"
                    },
                    {
                        "id": 78537,
                        "name": "Opijnen",
                        "latitude": "51.82917000",
                        "longitude": "5.29861000"
                    },
                    {
                        "id": 78543,
                        "name": "Orden",
                        "latitude": "52.20113000",
                        "longitude": "5.93417000"
                    },
                    {
                        "id": 78549,
                        "name": "Otterlo",
                        "latitude": "52.10000000",
                        "longitude": "5.77222000"
                    },
                    {
                        "id": 78557,
                        "name": "Oude IJsselstreek",
                        "latitude": "51.89963000",
                        "longitude": "6.38078000"
                    },
                    {
                        "id": 78569,
                        "name": "Overasselt",
                        "latitude": "51.76000000",
                        "longitude": "5.78889000"
                    },
                    {
                        "id": 78576,
                        "name": "Pannerden",
                        "latitude": "51.89083000",
                        "longitude": "6.03889000"
                    },
                    {
                        "id": 78598,
                        "name": "Puiflijk",
                        "latitude": "51.87833000",
                        "longitude": "5.59028000"
                    },
                    {
                        "id": 78602,
                        "name": "Putten",
                        "latitude": "52.25917000",
                        "longitude": "5.60694000"
                    },
                    {
                        "id": 78614,
                        "name": "Renkum",
                        "latitude": "51.97667000",
                        "longitude": "5.73333000"
                    },
                    {
                        "id": 78618,
                        "name": "Rheden",
                        "latitude": "52.00500000",
                        "longitude": "6.02917000"
                    },
                    {
                        "id": 78631,
                        "name": "Rivierenkwartier",
                        "latitude": "52.18914000",
                        "longitude": "5.97665000"
                    },
                    {
                        "id": 78639,
                        "name": "Rossum",
                        "latitude": "51.80083000",
                        "longitude": "5.33333000"
                    },
                    {
                        "id": 78645,
                        "name": "Rozendaal",
                        "latitude": "52.00583000",
                        "longitude": "5.96250000"
                    },
                    {
                        "id": 78650,
                        "name": "Ruurlo",
                        "latitude": "52.08833000",
                        "longitude": "6.45000000"
                    },
                    {
                        "id": 78666,
                        "name": "Scherpenzeel",
                        "latitude": "52.08000000",
                        "longitude": "5.48889000"
                    },
                    {
                        "id": 78692,
                        "name": "Silvolde",
                        "latitude": "51.90917000",
                        "longitude": "6.38750000"
                    },
                    {
                        "id": 78716,
                        "name": "Sluisoord",
                        "latitude": "52.22291000",
                        "longitude": "5.98145000"
                    },
                    {
                        "id": 78724,
                        "name": "Spainkbos",
                        "latitude": "52.22228000",
                        "longitude": "5.94738000"
                    },
                    {
                        "id": 78735,
                        "name": "Sprengenbos",
                        "latitude": "52.21902000",
                        "longitude": "5.94163000"
                    },
                    {
                        "id": 78736,
                        "name": "Sprengenweg-Noord",
                        "latitude": "52.21839000",
                        "longitude": "5.95068000"
                    },
                    {
                        "id": 78737,
                        "name": "Sprenkelaar",
                        "latitude": "52.22512000",
                        "longitude": "5.99922000"
                    },
                    {
                        "id": 78739,
                        "name": "Staatsliedenkwartier",
                        "latitude": "52.19951000",
                        "longitude": "5.97691000"
                    },
                    {
                        "id": 78749,
                        "name": "Steenderen",
                        "latitude": "52.06417000",
                        "longitude": "6.18750000"
                    },
                    {
                        "id": 78753,
                        "name": "Stegeslag",
                        "latitude": "51.94151000",
                        "longitude": "6.06194000"
                    },
                    {
                        "id": 78757,
                        "name": "Sterrenberg",
                        "latitude": "51.99350000",
                        "longitude": "5.88387000"
                    },
                    {
                        "id": 78770,
                        "name": "Terborg",
                        "latitude": "51.92000000",
                        "longitude": "6.35417000"
                    },
                    {
                        "id": 78775,
                        "name": "Terschuur",
                        "latitude": "52.16500000",
                        "longitude": "5.51667000"
                    },
                    {
                        "id": 78777,
                        "name": "Terwolde",
                        "latitude": "52.28333000",
                        "longitude": "6.10000000"
                    },
                    {
                        "id": 78783,
                        "name": "Tiel",
                        "latitude": "51.88667000",
                        "longitude": "5.42917000"
                    },
                    {
                        "id": 78789,
                        "name": "Tolkamer",
                        "latitude": "51.85500000",
                        "longitude": "6.10278000"
                    },
                    {
                        "id": 78791,
                        "name": "Tricht",
                        "latitude": "51.89083000",
                        "longitude": "5.26806000"
                    },
                    {
                        "id": 78798,
                        "name": "Twello",
                        "latitude": "52.23667000",
                        "longitude": "6.10278000"
                    },
                    {
                        "id": 78806,
                        "name": "Uddel",
                        "latitude": "52.25917000",
                        "longitude": "5.78056000"
                    },
                    {
                        "id": 78810,
                        "name": "Ugchelen",
                        "latitude": "52.18464000",
                        "longitude": "5.93177000"
                    },
                    {
                        "id": 78825,
                        "name": "Vaassen",
                        "latitude": "52.28583000",
                        "longitude": "5.96667000"
                    },
                    {
                        "id": 78826,
                        "name": "Valburg",
                        "latitude": "51.91167000",
                        "longitude": "5.79028000"
                    },
                    {
                        "id": 78827,
                        "name": "Valendries",
                        "latitude": "51.80658000",
                        "longitude": "5.73445000"
                    },
                    {
                        "id": 78834,
                        "name": "Varsseveld",
                        "latitude": "51.94333000",
                        "longitude": "6.45833000"
                    },
                    {
                        "id": 78842,
                        "name": "Velp",
                        "latitude": "51.99500000",
                        "longitude": "5.97361000"
                    },
                    {
                        "id": 78867,
                        "name": "Vogelkwartier",
                        "latitude": "52.19777000",
                        "longitude": "5.96721000"
                    },
                    {
                        "id": 78877,
                        "name": "Voorst",
                        "latitude": "52.17000000",
                        "longitude": "6.14167000"
                    },
                    {
                        "id": 78878,
                        "name": "Voorthuizen",
                        "latitude": "52.18667000",
                        "longitude": "5.60556000"
                    },
                    {
                        "id": 78879,
                        "name": "Vorden",
                        "latitude": "52.10500000",
                        "longitude": "6.30972000"
                    },
                    {
                        "id": 78881,
                        "name": "Vredenburg",
                        "latitude": "51.95355000",
                        "longitude": "5.90284000"
                    },
                    {
                        "id": 78889,
                        "name": "Vuren",
                        "latitude": "51.82500000",
                        "longitude": "5.04583000"
                    },
                    {
                        "id": 78894,
                        "name": "Waardenburg",
                        "latitude": "51.83250000",
                        "longitude": "5.25694000"
                    },
                    {
                        "id": 78900,
                        "name": "Wageningen",
                        "latitude": "51.97000000",
                        "longitude": "5.66667000"
                    },
                    {
                        "id": 78903,
                        "name": "Wapenveld",
                        "latitude": "52.42917000",
                        "longitude": "6.07361000"
                    },
                    {
                        "id": 78907,
                        "name": "Warnsveld",
                        "latitude": "52.13750000",
                        "longitude": "6.23056000"
                    },
                    {
                        "id": 78918,
                        "name": "Wekerom",
                        "latitude": "52.11250000",
                        "longitude": "5.71389000"
                    },
                    {
                        "id": 78920,
                        "name": "Welgelegen",
                        "latitude": "52.21397000",
                        "longitude": "5.97643000"
                    },
                    {
                        "id": 78928,
                        "name": "West Betuwe",
                        "latitude": "51.86158000",
                        "longitude": "5.20935000"
                    },
                    {
                        "id": 78933,
                        "name": "Westeneng",
                        "latitude": "52.12750000",
                        "longitude": "5.71528000"
                    },
                    {
                        "id": 78934,
                        "name": "Westenenk",
                        "latitude": "52.19624000",
                        "longitude": "5.95656000"
                    },
                    {
                        "id": 78939,
                        "name": "Westervoort",
                        "latitude": "51.95583000",
                        "longitude": "5.97222000"
                    },
                    {
                        "id": 78950,
                        "name": "Wijchen",
                        "latitude": "51.80917000",
                        "longitude": "5.72500000"
                    },
                    {
                        "id": 78962,
                        "name": "Winkewijert",
                        "latitude": "52.19082000",
                        "longitude": "5.95794000"
                    },
                    {
                        "id": 78965,
                        "name": "Winterswijk",
                        "latitude": "51.97250000",
                        "longitude": "6.71944000"
                    },
                    {
                        "id": 78967,
                        "name": "Wisch",
                        "latitude": "51.92648000",
                        "longitude": "6.41705000"
                    },
                    {
                        "id": 78975,
                        "name": "Wolfheze",
                        "latitude": "52.00333000",
                        "longitude": "5.79028000"
                    },
                    {
                        "id": 78985,
                        "name": "Woudhuis",
                        "latitude": "52.21323000",
                        "longitude": "6.01124000"
                    },
                    {
                        "id": 78996,
                        "name": "Zaltbommel",
                        "latitude": "51.81000000",
                        "longitude": "5.24444000"
                    },
                    {
                        "id": 78999,
                        "name": "Zeddam",
                        "latitude": "51.90333000",
                        "longitude": "6.25972000"
                    },
                    {
                        "id": 79006,
                        "name": "Zelhem",
                        "latitude": "52.00667000",
                        "longitude": "6.34861000"
                    },
                    {
                        "id": 79008,
                        "name": "Zetten",
                        "latitude": "51.92833000",
                        "longitude": "5.71389000"
                    },
                    {
                        "id": 79009,
                        "name": "Zevenaar",
                        "latitude": "51.93000000",
                        "longitude": "6.07083000"
                    },
                    {
                        "id": 79012,
                        "name": "Zevenhuizen",
                        "latitude": "52.21816000",
                        "longitude": "5.97841000"
                    },
                    {
                        "id": 79015,
                        "name": "Zoelen",
                        "latitude": "51.91250000",
                        "longitude": "5.40278000"
                    },
                    {
                        "id": 79019,
                        "name": "Zonnemaat",
                        "latitude": "51.93115000",
                        "longitude": "6.06235000"
                    },
                    {
                        "id": 79030,
                        "name": "Zuilichem",
                        "latitude": "51.80917000",
                        "longitude": "5.13611000"
                    },
                    {
                        "id": 79032,
                        "name": "Zutphen",
                        "latitude": "52.13833000",
                        "longitude": "6.20139000"
                    }
                ]
            },
            {
                "id": 2617,
                "name": "Groningen",
                "iso2": "GR",
                "latitude": "53.21938350",
                "longitude": "6.56650170",
                "type": "province",
                "cities": [
                    {
                        "id": 77318,
                        "name": "Aduard",
                        "latitude": "53.25667000",
                        "longitude": "6.45972000"
                    },
                    {
                        "id": 77352,
                        "name": "Appingedam",
                        "latitude": "53.32167000",
                        "longitude": "6.85833000"
                    },
                    {
                        "id": 77370,
                        "name": "Baflo",
                        "latitude": "53.36250000",
                        "longitude": "6.51389000"
                    },
                    {
                        "id": 77384,
                        "name": "Bedum",
                        "latitude": "53.30083000",
                        "longitude": "6.60278000"
                    },
                    {
                        "id": 77398,
                        "name": "Bellingwolde",
                        "latitude": "53.11583000",
                        "longitude": "7.16528000"
                    },
                    {
                        "id": 77441,
                        "name": "Blijham",
                        "latitude": "53.10917000",
                        "longitude": "7.07639000"
                    },
                    {
                        "id": 77517,
                        "name": "Coendersborg",
                        "latitude": "53.19410000",
                        "longitude": "6.58944000"
                    },
                    {
                        "id": 77562,
                        "name": "De Wijert",
                        "latitude": "53.19450000",
                        "longitude": "6.57117000"
                    },
                    {
                        "id": 77569,
                        "name": "Delfzijl",
                        "latitude": "53.33000000",
                        "longitude": "6.91806000"
                    },
                    {
                        "id": 77629,
                        "name": "Eenrum",
                        "latitude": "53.36250000",
                        "longitude": "6.45833000"
                    },
                    {
                        "id": 77635,
                        "name": "Eexta",
                        "latitude": "53.16386000",
                        "longitude": "6.98344000"
                    },
                    {
                        "id": 77672,
                        "name": "Farmsum",
                        "latitude": "53.32167000",
                        "longitude": "6.92639000"
                    },
                    {
                        "id": 77712,
                        "name": "Gemeente Appingedam",
                        "latitude": "53.31926000",
                        "longitude": "6.84864000"
                    },
                    {
                        "id": 77760,
                        "name": "Gemeente Delfzijl",
                        "latitude": "53.30019000",
                        "longitude": "6.93129000"
                    },
                    {
                        "id": 77800,
                        "name": "Gemeente Groningen",
                        "latitude": "53.22369000",
                        "longitude": "6.56479000"
                    },
                    {
                        "id": 77863,
                        "name": "Gemeente Loppersum",
                        "latitude": "53.33849000",
                        "longitude": "6.72149000"
                    },
                    {
                        "id": 77694,
                        "name": "Gemeente Oldambt",
                        "latitude": "53.16859000",
                        "longitude": "7.04224000"
                    },
                    {
                        "id": 77910,
                        "name": "Gemeente Pekela",
                        "latitude": "53.05969000",
                        "longitude": "6.96510000"
                    },
                    {
                        "id": 77943,
                        "name": "Gemeente Stadskanaal",
                        "latitude": "53.00005000",
                        "longitude": "6.98906000"
                    },
                    {
                        "id": 77968,
                        "name": "Gemeente Veendam",
                        "latitude": "53.08951000",
                        "longitude": "6.87923000"
                    },
                    {
                        "id": 78035,
                        "name": "Glimmen",
                        "latitude": "53.13917000",
                        "longitude": "6.62917000"
                    },
                    {
                        "id": 78056,
                        "name": "Grijpskerk",
                        "latitude": "53.26250000",
                        "longitude": "6.30833000"
                    },
                    {
                        "id": 78063,
                        "name": "Groningen",
                        "latitude": "53.21917000",
                        "longitude": "6.56667000"
                    },
                    {
                        "id": 78067,
                        "name": "Grootegast",
                        "latitude": "53.21250000",
                        "longitude": "6.27361000"
                    },
                    {
                        "id": 78093,
                        "name": "Haren",
                        "latitude": "53.17209000",
                        "longitude": "6.60931000"
                    },
                    {
                        "id": 78096,
                        "name": "Harkstede",
                        "latitude": "53.21333000",
                        "longitude": "6.69861000"
                    },
                    {
                        "id": 78129,
                        "name": "Heiligerlee",
                        "latitude": "53.15667000",
                        "longitude": "7.00972000"
                    },
                    {
                        "id": 78136,
                        "name": "Helpman",
                        "latitude": "53.19794000",
                        "longitude": "6.57978000"
                    },
                    {
                        "id": 78182,
                        "name": "Hoogezand",
                        "latitude": "53.16167000",
                        "longitude": "6.76111000"
                    },
                    {
                        "id": 78250,
                        "name": "Korrewegwijk",
                        "latitude": "53.23235000",
                        "longitude": "6.56804000"
                    },
                    {
                        "id": 78276,
                        "name": "Leek",
                        "latitude": "53.16250000",
                        "longitude": "6.37639000"
                    },
                    {
                        "id": 78278,
                        "name": "Leens",
                        "latitude": "53.36000000",
                        "longitude": "6.37917000"
                    },
                    {
                        "id": 78322,
                        "name": "Loppersum",
                        "latitude": "53.33167000",
                        "longitude": "6.74722000"
                    },
                    {
                        "id": 78356,
                        "name": "Marum",
                        "latitude": "53.14417000",
                        "longitude": "6.26250000"
                    },
                    {
                        "id": 78366,
                        "name": "Meeden",
                        "latitude": "53.14000000",
                        "longitude": "6.92639000"
                    },
                    {
                        "id": 78392,
                        "name": "Middelstum",
                        "latitude": "53.34667000",
                        "longitude": "6.64167000"
                    },
                    {
                        "id": 78393,
                        "name": "Midden-Groningen",
                        "latitude": "53.15113000",
                        "longitude": "6.83313000"
                    },
                    {
                        "id": 78396,
                        "name": "Midwolda",
                        "latitude": "53.19500000",
                        "longitude": "7.01389000"
                    },
                    {
                        "id": 78428,
                        "name": "Niekerk",
                        "latitude": "53.22500000",
                        "longitude": "6.35278000"
                    },
                    {
                        "id": 78439,
                        "name": "Nieuwe Pekela",
                        "latitude": "53.07917000",
                        "longitude": "6.96528000"
                    },
                    {
                        "id": 78447,
                        "name": "Nieuwolda",
                        "latitude": "53.24417000",
                        "longitude": "6.97500000"
                    },
                    {
                        "id": 78464,
                        "name": "Noordbroek",
                        "latitude": "53.19500000",
                        "longitude": "6.87361000"
                    },
                    {
                        "id": 78469,
                        "name": "Noordhorn",
                        "latitude": "53.26167000",
                        "longitude": "6.39583000"
                    },
                    {
                        "id": 78480,
                        "name": "Obergum",
                        "latitude": "53.33333000",
                        "longitude": "6.51667000"
                    },
                    {
                        "id": 78495,
                        "name": "Oldehove",
                        "latitude": "53.30333000",
                        "longitude": "6.39583000"
                    },
                    {
                        "id": 78499,
                        "name": "Ommelanderwijk",
                        "latitude": "53.08917000",
                        "longitude": "6.90556000"
                    },
                    {
                        "id": 78503,
                        "name": "Onstwedde",
                        "latitude": "53.03500000",
                        "longitude": "7.04028000"
                    },
                    {
                        "id": 78518,
                        "name": "Oosterhoogebrug",
                        "latitude": "53.22892000",
                        "longitude": "6.60141000"
                    },
                    {
                        "id": 78523,
                        "name": "Oosterpark",
                        "latitude": "53.22370000",
                        "longitude": "6.58530000"
                    },
                    {
                        "id": 78558,
                        "name": "Oude Pekela",
                        "latitude": "53.10417000",
                        "longitude": "7.00972000"
                    },
                    {
                        "id": 78612,
                        "name": "Reitdiep",
                        "latitude": "53.24252000",
                        "longitude": "6.51957000"
                    },
                    {
                        "id": 78652,
                        "name": "Sappemeer",
                        "latitude": "53.16417000",
                        "longitude": "6.79028000"
                    },
                    {
                        "id": 78662,
                        "name": "Scheemda",
                        "latitude": "53.17333000",
                        "longitude": "6.97222000"
                    },
                    {
                        "id": 78673,
                        "name": "Schildwolde",
                        "latitude": "53.23327000",
                        "longitude": "6.81566000"
                    },
                    {
                        "id": 78685,
                        "name": "Sellingen",
                        "latitude": "52.94583000",
                        "longitude": "7.15139000"
                    },
                    {
                        "id": 78686,
                        "name": "Selwerd",
                        "latitude": "53.23520000",
                        "longitude": "6.55450000"
                    },
                    {
                        "id": 78691,
                        "name": "Siddeburen",
                        "latitude": "53.25000000",
                        "longitude": "6.86806000"
                    },
                    {
                        "id": 78712,
                        "name": "Slochteren",
                        "latitude": "53.22078000",
                        "longitude": "6.80547000"
                    },
                    {
                        "id": 78732,
                        "name": "Spijk",
                        "latitude": "53.39000000",
                        "longitude": "6.83750000"
                    },
                    {
                        "id": 78742,
                        "name": "Stadskanaal",
                        "latitude": "52.98947000",
                        "longitude": "6.95040000"
                    },
                    {
                        "id": 78768,
                        "name": "Ten Boer",
                        "latitude": "53.27583000",
                        "longitude": "6.69444000"
                    },
                    {
                        "id": 78769,
                        "name": "Ter Apel",
                        "latitude": "52.87667000",
                        "longitude": "7.05972000"
                    },
                    {
                        "id": 78793,
                        "name": "Tuikwerd",
                        "latitude": "53.31667000",
                        "longitude": "6.90000000"
                    },
                    {
                        "id": 78813,
                        "name": "Uithuizen",
                        "latitude": "53.40750000",
                        "longitude": "6.67083000"
                    },
                    {
                        "id": 78814,
                        "name": "Uithuizermeeden",
                        "latitude": "53.41417000",
                        "longitude": "6.72361000"
                    },
                    {
                        "id": 78816,
                        "name": "Ulrum",
                        "latitude": "53.35917000",
                        "longitude": "6.33333000"
                    },
                    {
                        "id": 78821,
                        "name": "Usquert",
                        "latitude": "53.40250000",
                        "longitude": "6.61111000"
                    },
                    {
                        "id": 78836,
                        "name": "Veendam",
                        "latitude": "53.10667000",
                        "longitude": "6.87917000"
                    },
                    {
                        "id": 78856,
                        "name": "Vlagtwedde",
                        "latitude": "53.02750000",
                        "longitude": "7.10833000"
                    },
                    {
                        "id": 78899,
                        "name": "Wagenborgen",
                        "latitude": "53.25583000",
                        "longitude": "6.93333000"
                    },
                    {
                        "id": 78904,
                        "name": "Warffum",
                        "latitude": "53.39250000",
                        "longitude": "6.55833000"
                    },
                    {
                        "id": 78938,
                        "name": "Westerlee",
                        "latitude": "53.14583000",
                        "longitude": "6.98750000"
                    },
                    {
                        "id": 78940,
                        "name": "Westerwolde",
                        "latitude": "53.02800000",
                        "longitude": "7.15671000"
                    },
                    {
                        "id": 78958,
                        "name": "Wildervank",
                        "latitude": "53.08083000",
                        "longitude": "6.86250000"
                    },
                    {
                        "id": 78963,
                        "name": "Winschoten",
                        "latitude": "53.14417000",
                        "longitude": "7.03472000"
                    },
                    {
                        "id": 78964,
                        "name": "Winsum",
                        "latitude": "53.33000000",
                        "longitude": "6.52083000"
                    },
                    {
                        "id": 79021,
                        "name": "Zoutkamp",
                        "latitude": "53.33917000",
                        "longitude": "6.30417000"
                    },
                    {
                        "id": 79025,
                        "name": "Zuidbroek",
                        "latitude": "53.16333000",
                        "longitude": "6.86111000"
                    },
                    {
                        "id": 79027,
                        "name": "Zuidhorn",
                        "latitude": "53.24667000",
                        "longitude": "6.40278000"
                    }
                ]
            },
            {
                "id": 2615,
                "name": "Limburg",
                "iso2": "LI",
                "latitude": "51.44272380",
                "longitude": "6.06087260",
                "type": "province",
                "cities": [
                    {
                        "id": 77316,
                        "name": "Abdissenbosch",
                        "latitude": "50.91667000",
                        "longitude": "6.03333000"
                    },
                    {
                        "id": 77332,
                        "name": "Amby",
                        "latitude": "50.86215000",
                        "longitude": "5.73226000"
                    },
                    {
                        "id": 77333,
                        "name": "America",
                        "latitude": "51.43667000",
                        "longitude": "5.97917000"
                    },
                    {
                        "id": 77339,
                        "name": "Amstenrade",
                        "latitude": "50.93917000",
                        "longitude": "5.92361000"
                    },
                    {
                        "id": 77353,
                        "name": "Arcen",
                        "latitude": "51.47667000",
                        "longitude": "6.18056000"
                    },
                    {
                        "id": 77367,
                        "name": "Baarlo",
                        "latitude": "51.33083000",
                        "longitude": "6.09444000"
                    },
                    {
                        "id": 77378,
                        "name": "Banholt",
                        "latitude": "50.79000000",
                        "longitude": "5.80833000"
                    },
                    {
                        "id": 77385,
                        "name": "Beegden",
                        "latitude": "51.18917000",
                        "longitude": "5.91944000"
                    },
                    {
                        "id": 77387,
                        "name": "Beek",
                        "latitude": "50.94083000",
                        "longitude": "5.79722000"
                    },
                    {
                        "id": 77391,
                        "name": "Beersdal",
                        "latitude": "50.90597000",
                        "longitude": "5.96440000"
                    },
                    {
                        "id": 77393,
                        "name": "Beesel",
                        "latitude": "51.26833000",
                        "longitude": "6.03889000"
                    },
                    {
                        "id": 77397,
                        "name": "Belfort",
                        "latitude": "50.84698000",
                        "longitude": "5.65991000"
                    },
                    {
                        "id": 77404,
                        "name": "Berg",
                        "latitude": "50.86167000",
                        "longitude": "5.78333000"
                    },
                    {
                        "id": 77413,
                        "name": "Beringe",
                        "latitude": "51.33667000",
                        "longitude": "5.94861000"
                    },
                    {
                        "id": 77429,
                        "name": "Biesland",
                        "latitude": "50.84110000",
                        "longitude": "5.67573000"
                    },
                    {
                        "id": 77438,
                        "name": "Bleijerheide",
                        "latitude": "50.85538000",
                        "longitude": "6.06789000"
                    },
                    {
                        "id": 77442,
                        "name": "Blitterswijck",
                        "latitude": "51.53083000",
                        "longitude": "6.10833000"
                    },
                    {
                        "id": 77447,
                        "name": "Bocholtz",
                        "latitude": "50.81833000",
                        "longitude": "6.00556000"
                    },
                    {
                        "id": 77457,
                        "name": "Borgharen",
                        "latitude": "50.87750000",
                        "longitude": "5.68750000"
                    },
                    {
                        "id": 77458,
                        "name": "Born",
                        "latitude": "51.03167000",
                        "longitude": "5.80972000"
                    },
                    {
                        "id": 77468,
                        "name": "Brabander",
                        "latitude": "51.53583000",
                        "longitude": "5.96806000"
                    },
                    {
                        "id": 77469,
                        "name": "Brachterbeek",
                        "latitude": "51.14694000",
                        "longitude": "5.90446000"
                    },
                    {
                        "id": 77484,
                        "name": "Broekhem",
                        "latitude": "50.87119000",
                        "longitude": "5.82069000"
                    },
                    {
                        "id": 77486,
                        "name": "Broeksittard",
                        "latitude": "51.00290000",
                        "longitude": "5.89511000"
                    },
                    {
                        "id": 77491,
                        "name": "Brukske",
                        "latitude": "51.52101000",
                        "longitude": "5.99270000"
                    },
                    {
                        "id": 77495,
                        "name": "Brunssum",
                        "latitude": "50.94667000",
                        "longitude": "5.97083000"
                    },
                    {
                        "id": 77496,
                        "name": "Buchten",
                        "latitude": "51.04333000",
                        "longitude": "5.80972000"
                    },
                    {
                        "id": 77500,
                        "name": "Budschop",
                        "latitude": "51.28511000",
                        "longitude": "5.75898000"
                    },
                    {
                        "id": 77502,
                        "name": "Bunde",
                        "latitude": "50.89667000",
                        "longitude": "5.73194000"
                    },
                    {
                        "id": 77516,
                        "name": "Chevremont",
                        "latitude": "50.87554000",
                        "longitude": "6.05981000"
                    },
                    {
                        "id": 77544,
                        "name": "De Heeg",
                        "latitude": "50.82454000",
                        "longitude": "5.72309000"
                    },
                    {
                        "id": 77585,
                        "name": "Doenrade",
                        "latitude": "50.96750000",
                        "longitude": "5.90694000"
                    },
                    {
                        "id": 77636,
                        "name": "Egchel",
                        "latitude": "51.31417000",
                        "longitude": "5.97222000"
                    },
                    {
                        "id": 77640,
                        "name": "Eijsden",
                        "latitude": "50.78000000",
                        "longitude": "5.71770000"
                    },
                    {
                        "id": 77641,
                        "name": "Eijsden-Margraten",
                        "latitude": "50.80090000",
                        "longitude": "5.77408000"
                    },
                    {
                        "id": 77643,
                        "name": "Einighausen",
                        "latitude": "51.00167000",
                        "longitude": "5.82778000"
                    },
                    {
                        "id": 77649,
                        "name": "Elsloo",
                        "latitude": "50.94917000",
                        "longitude": "5.77083000"
                    },
                    {
                        "id": 77693,
                        "name": "Geleen",
                        "latitude": "50.97417000",
                        "longitude": "5.82917000"
                    },
                    {
                        "id": 78024,
                        "name": "Gennep",
                        "latitude": "51.69833000",
                        "longitude": "5.97361000"
                    },
                    {
                        "id": 78049,
                        "name": "Gracht",
                        "latitude": "50.85175000",
                        "longitude": "6.02793000"
                    },
                    {
                        "id": 78051,
                        "name": "Grashoek",
                        "latitude": "51.36083000",
                        "longitude": "5.94306000"
                    },
                    {
                        "id": 78054,
                        "name": "Grevenbicht",
                        "latitude": "51.03833000",
                        "longitude": "5.77500000"
                    },
                    {
                        "id": 78064,
                        "name": "Gronsveld",
                        "latitude": "50.81083000",
                        "longitude": "5.73056000"
                    },
                    {
                        "id": 78070,
                        "name": "Gulpen",
                        "latitude": "50.81583000",
                        "longitude": "5.88889000"
                    },
                    {
                        "id": 78071,
                        "name": "Gulpen-Wittem",
                        "latitude": "50.81374000",
                        "longitude": "5.89296000"
                    },
                    {
                        "id": 78072,
                        "name": "Guttecoven",
                        "latitude": "51.01500000",
                        "longitude": "5.81806000"
                    },
                    {
                        "id": 78078,
                        "name": "Haanrade",
                        "latitude": "50.87981000",
                        "longitude": "6.07411000"
                    },
                    {
                        "id": 78084,
                        "name": "Haelen",
                        "latitude": "51.23583000",
                        "longitude": "5.95694000"
                    },
                    {
                        "id": 78108,
                        "name": "Heel",
                        "latitude": "51.17917000",
                        "longitude": "5.89444000"
                    },
                    {
                        "id": 78112,
                        "name": "Heer",
                        "latitude": "50.83836000",
                        "longitude": "5.72989000"
                    },
                    {
                        "id": 78119,
                        "name": "Heerlen",
                        "latitude": "50.88365000",
                        "longitude": "5.98154000"
                    },
                    {
                        "id": 78125,
                        "name": "Hegelsom",
                        "latitude": "51.43917000",
                        "longitude": "6.03889000"
                    },
                    {
                        "id": 78126,
                        "name": "Heide",
                        "latitude": "51.06833000",
                        "longitude": "5.87222000"
                    },
                    {
                        "id": 78127,
                        "name": "Heijen",
                        "latitude": "51.67500000",
                        "longitude": "5.98056000"
                    },
                    {
                        "id": 78132,
                        "name": "Heksenberg",
                        "latitude": "50.92068000",
                        "longitude": "5.97373000"
                    },
                    {
                        "id": 78133,
                        "name": "Helden",
                        "latitude": "51.31917000",
                        "longitude": "6.00000000"
                    },
                    {
                        "id": 78145,
                        "name": "Herkenbosch",
                        "latitude": "51.15333000",
                        "longitude": "6.06389000"
                    },
                    {
                        "id": 78147,
                        "name": "Herten",
                        "latitude": "51.18083000",
                        "longitude": "5.96250000"
                    },
                    {
                        "id": 78152,
                        "name": "Heugem",
                        "latitude": "50.82791000",
                        "longitude": "5.70774000"
                    },
                    {
                        "id": 78156,
                        "name": "Heythuysen",
                        "latitude": "51.25000000",
                        "longitude": "5.89861000"
                    },
                    {
                        "id": 78164,
                        "name": "Hoensbroek",
                        "latitude": "50.92387000",
                        "longitude": "5.92528000"
                    },
                    {
                        "id": 78171,
                        "name": "Holtum",
                        "latitude": "51.04750000",
                        "longitude": "5.82222000"
                    },
                    {
                        "id": 78173,
                        "name": "Holz",
                        "latitude": "50.86415000",
                        "longitude": "6.07424000"
                    },
                    {
                        "id": 78187,
                        "name": "Hopel",
                        "latitude": "50.89245000",
                        "longitude": "6.05046000"
                    },
                    {
                        "id": 78190,
                        "name": "Houthem",
                        "latitude": "50.87250000",
                        "longitude": "5.79306000"
                    },
                    {
                        "id": 78194,
                        "name": "Hulsberg",
                        "latitude": "50.88917000",
                        "longitude": "5.85556000"
                    },
                    {
                        "id": 78199,
                        "name": "Husken",
                        "latitude": "50.89567000",
                        "longitude": "5.95648000"
                    },
                    {
                        "id": 78209,
                        "name": "Kaalheide",
                        "latitude": "50.86505000",
                        "longitude": "6.03643000"
                    },
                    {
                        "id": 78211,
                        "name": "Kakert",
                        "latitude": "50.90414000",
                        "longitude": "6.00463000"
                    },
                    {
                        "id": 78220,
                        "name": "Keent",
                        "latitude": "51.24218000",
                        "longitude": "5.70079000"
                    },
                    {
                        "id": 78222,
                        "name": "Kelpen-Oler",
                        "latitude": "51.21817000",
                        "longitude": "5.82602000"
                    },
                    {
                        "id": 78224,
                        "name": "Kerensheide",
                        "latitude": "50.97210000",
                        "longitude": "5.77666000"
                    },
                    {
                        "id": 78228,
                        "name": "Kerkrade",
                        "latitude": "50.86583000",
                        "longitude": "6.06250000"
                    },
                    {
                        "id": 78230,
                        "name": "Kessel",
                        "latitude": "51.29167000",
                        "longitude": "6.05417000"
                    },
                    {
                        "id": 78238,
                        "name": "Klimmen",
                        "latitude": "50.87583000",
                        "longitude": "5.88056000"
                    },
                    {
                        "id": 78245,
                        "name": "Koningsbosch",
                        "latitude": "51.05167000",
                        "longitude": "5.95833000"
                    },
                    {
                        "id": 78246,
                        "name": "Koningslust",
                        "latitude": "51.35750000",
                        "longitude": "5.99306000"
                    },
                    {
                        "id": 78259,
                        "name": "Kruisberg",
                        "latitude": "50.94234000",
                        "longitude": "5.96519000"
                    },
                    {
                        "id": 78262,
                        "name": "Kunrade",
                        "latitude": "50.87769000",
                        "longitude": "5.93107000"
                    },
                    {
                        "id": 78267,
                        "name": "Landgraaf",
                        "latitude": "50.91333000",
                        "longitude": "6.05722000"
                    },
                    {
                        "id": 78275,
                        "name": "Lauradorp",
                        "latitude": "50.91229000",
                        "longitude": "6.04591000"
                    },
                    {
                        "id": 78284,
                        "name": "Leeuwen",
                        "latitude": "51.21032000",
                        "longitude": "5.99862000"
                    },
                    {
                        "id": 78292,
                        "name": "Leuken",
                        "latitude": "51.25288000",
                        "longitude": "5.73460000"
                    },
                    {
                        "id": 78293,
                        "name": "Leunen",
                        "latitude": "51.51000000",
                        "longitude": "5.97917000"
                    },
                    {
                        "id": 78296,
                        "name": "Lichtenberg",
                        "latitude": "50.90220000",
                        "longitude": "6.02523000"
                    },
                    {
                        "id": 78305,
                        "name": "Limbricht",
                        "latitude": "51.01167000",
                        "longitude": "5.83750000"
                    },
                    {
                        "id": 78306,
                        "name": "Limmel",
                        "latitude": "50.86718000",
                        "longitude": "5.70719000"
                    },
                    {
                        "id": 78308,
                        "name": "Lindenheuvel",
                        "latitude": "50.98509000",
                        "longitude": "5.81667000"
                    },
                    {
                        "id": 78310,
                        "name": "Linne",
                        "latitude": "51.15500000",
                        "longitude": "5.93889000"
                    },
                    {
                        "id": 78324,
                        "name": "Lottum",
                        "latitude": "51.46167000",
                        "longitude": "6.16111000"
                    },
                    {
                        "id": 78334,
                        "name": "Maasbracht",
                        "latitude": "51.13929000",
                        "longitude": "5.88627000"
                    },
                    {
                        "id": 78335,
                        "name": "Maasbree",
                        "latitude": "51.35750000",
                        "longitude": "6.04861000"
                    },
                    {
                        "id": 78340,
                        "name": "Maastricht",
                        "latitude": "50.84833000",
                        "longitude": "5.68889000"
                    },
                    {
                        "id": 78344,
                        "name": "Malberg",
                        "latitude": "50.86244000",
                        "longitude": "5.65419000"
                    },
                    {
                        "id": 78348,
                        "name": "Margraten",
                        "latitude": "50.82083000",
                        "longitude": "5.82083000"
                    },
                    {
                        "id": 78350,
                        "name": "Mariarade",
                        "latitude": "50.92906000",
                        "longitude": "5.92738000"
                    },
                    {
                        "id": 78364,
                        "name": "Mechelen",
                        "latitude": "50.79583000",
                        "longitude": "5.92639000"
                    },
                    {
                        "id": 78368,
                        "name": "Meerlo",
                        "latitude": "51.51333000",
                        "longitude": "6.08472000"
                    },
                    {
                        "id": 78369,
                        "name": "Meerssen",
                        "latitude": "50.88750000",
                        "longitude": "5.75000000"
                    },
                    {
                        "id": 78371,
                        "name": "Meezenbroek",
                        "latitude": "50.89680000",
                        "longitude": "5.99051000"
                    },
                    {
                        "id": 78374,
                        "name": "Meijel",
                        "latitude": "51.34417000",
                        "longitude": "5.88472000"
                    },
                    {
                        "id": 78376,
                        "name": "Melderslo",
                        "latitude": "51.46167000",
                        "longitude": "6.08611000"
                    },
                    {
                        "id": 78377,
                        "name": "Melick",
                        "latitude": "51.15917000",
                        "longitude": "6.01667000"
                    },
                    {
                        "id": 78383,
                        "name": "Merkelbeek",
                        "latitude": "50.95389000",
                        "longitude": "5.94069000"
                    },
                    {
                        "id": 78384,
                        "name": "Merselo",
                        "latitude": "51.53000000",
                        "longitude": "5.92778000"
                    },
                    {
                        "id": 78385,
                        "name": "Merum",
                        "latitude": "51.17333000",
                        "longitude": "5.95972000"
                    },
                    {
                        "id": 78402,
                        "name": "Milsbeek",
                        "latitude": "51.72500000",
                        "longitude": "5.94861000"
                    },
                    {
                        "id": 78405,
                        "name": "Moesel",
                        "latitude": "51.23828000",
                        "longitude": "5.71778000"
                    },
                    {
                        "id": 78410,
                        "name": "Montfort",
                        "latitude": "51.12583000",
                        "longitude": "5.94861000"
                    },
                    {
                        "id": 78411,
                        "name": "Mook",
                        "latitude": "51.75250000",
                        "longitude": "5.88194000"
                    },
                    {
                        "id": 78414,
                        "name": "Munstergeleen",
                        "latitude": "50.97500000",
                        "longitude": "5.86389000"
                    },
                    {
                        "id": 78422,
                        "name": "Nederweert",
                        "latitude": "51.28583000",
                        "longitude": "5.74861000"
                    },
                    {
                        "id": 78425,
                        "name": "Neerbeek",
                        "latitude": "50.95000000",
                        "longitude": "5.81528000"
                    },
                    {
                        "id": 78435,
                        "name": "Nieuw-Lotbroek",
                        "latitude": "50.91283000",
                        "longitude": "5.92798000"
                    },
                    {
                        "id": 78438,
                        "name": "Nieuwdorp",
                        "latitude": "50.96216000",
                        "longitude": "5.77297000"
                    },
                    {
                        "id": 78477,
                        "name": "Nuth",
                        "latitude": "50.91750000",
                        "longitude": "5.88611000"
                    },
                    {
                        "id": 78478,
                        "name": "Obbicht",
                        "latitude": "51.02833000",
                        "longitude": "5.78056000"
                    },
                    {
                        "id": 78488,
                        "name": "Offenbeek",
                        "latitude": "51.28225000",
                        "longitude": "6.09500000"
                    },
                    {
                        "id": 78489,
                        "name": "Oirlo",
                        "latitude": "51.51167000",
                        "longitude": "6.03750000"
                    },
                    {
                        "id": 78490,
                        "name": "Oirsbeek",
                        "latitude": "50.95083000",
                        "longitude": "5.90833000"
                    },
                    {
                        "id": 78528,
                        "name": "Oostrum",
                        "latitude": "51.52917000",
                        "longitude": "6.01667000"
                    },
                    {
                        "id": 78536,
                        "name": "Ophoven",
                        "latitude": "50.99036000",
                        "longitude": "5.85868000"
                    },
                    {
                        "id": 78545,
                        "name": "Ospel",
                        "latitude": "51.29750000",
                        "longitude": "5.78472000"
                    },
                    {
                        "id": 78550,
                        "name": "Ottersum",
                        "latitude": "51.70333000",
                        "longitude": "5.98333000"
                    },
                    {
                        "id": 78553,
                        "name": "Oud-Caberg",
                        "latitude": "50.86539000",
                        "longitude": "5.66444000"
                    },
                    {
                        "id": 78571,
                        "name": "Overhoven",
                        "latitude": "51.00869000",
                        "longitude": "5.86628000"
                    },
                    {
                        "id": 78577,
                        "name": "Panningen",
                        "latitude": "51.32667000",
                        "longitude": "5.97917000"
                    },
                    {
                        "id": 78580,
                        "name": "Passart",
                        "latitude": "50.92389000",
                        "longitude": "5.94674000"
                    },
                    {
                        "id": 78584,
                        "name": "Peij",
                        "latitude": "51.09417000",
                        "longitude": "5.89583000"
                    },
                    {
                        "id": 78594,
                        "name": "Posterholt",
                        "latitude": "51.12333000",
                        "longitude": "6.03472000"
                    },
                    {
                        "id": 78595,
                        "name": "Pottenberg",
                        "latitude": "50.85135000",
                        "longitude": "5.65668000"
                    },
                    {
                        "id": 78600,
                        "name": "Puth",
                        "latitude": "50.95417000",
                        "longitude": "5.87361000"
                    },
                    {
                        "id": 78617,
                        "name": "Reuver",
                        "latitude": "51.28417000",
                        "longitude": "6.07778000"
                    },
                    {
                        "id": 78635,
                        "name": "Roermond",
                        "latitude": "51.19417000",
                        "longitude": "5.98750000"
                    },
                    {
                        "id": 78638,
                        "name": "Roosteren",
                        "latitude": "51.08333000",
                        "longitude": "5.81806000"
                    },
                    {
                        "id": 78641,
                        "name": "Rothem",
                        "latitude": "50.87667000",
                        "longitude": "5.73889000"
                    },
                    {
                        "id": 78660,
                        "name": "Scharn",
                        "latitude": "50.85000000",
                        "longitude": "5.73333000"
                    },
                    {
                        "id": 78672,
                        "name": "Schilberg",
                        "latitude": "51.09917000",
                        "longitude": "5.88611000"
                    },
                    {
                        "id": 78674,
                        "name": "Schimmert",
                        "latitude": "50.90667000",
                        "longitude": "5.82361000"
                    },
                    {
                        "id": 78675,
                        "name": "Schinnen",
                        "latitude": "50.94333000",
                        "longitude": "5.88889000"
                    },
                    {
                        "id": 78676,
                        "name": "Schinveld",
                        "latitude": "50.96917000",
                        "longitude": "5.97917000"
                    },
                    {
                        "id": 78688,
                        "name": "Sevenum",
                        "latitude": "51.41250000",
                        "longitude": "6.03750000"
                    },
                    {
                        "id": 78690,
                        "name": "Sibbe",
                        "latitude": "50.84417000",
                        "longitude": "5.82639000"
                    },
                    {
                        "id": 78693,
                        "name": "Simpelveld",
                        "latitude": "50.83417000",
                        "longitude": "5.98194000"
                    },
                    {
                        "id": 78698,
                        "name": "Sint Joost",
                        "latitude": "51.11750000",
                        "longitude": "5.89861000"
                    },
                    {
                        "id": 78701,
                        "name": "Sint Odiliënberg",
                        "latitude": "51.14333000",
                        "longitude": "6.00000000"
                    },
                    {
                        "id": 78708,
                        "name": "Sittard",
                        "latitude": "50.99833000",
                        "longitude": "5.86944000"
                    },
                    {
                        "id": 78727,
                        "name": "Spaubeek",
                        "latitude": "50.94000000",
                        "longitude": "5.84306000"
                    },
                    {
                        "id": 78730,
                        "name": "Spekholzerheide",
                        "latitude": "50.85559000",
                        "longitude": "6.02471000"
                    },
                    {
                        "id": 78740,
                        "name": "Stadbroek",
                        "latitude": "51.00187000",
                        "longitude": "5.87656000"
                    },
                    {
                        "id": 78754,
                        "name": "Stein",
                        "latitude": "50.96917000",
                        "longitude": "5.76667000"
                    },
                    {
                        "id": 78762,
                        "name": "Stramproy",
                        "latitude": "51.19417000",
                        "longitude": "5.71944000"
                    },
                    {
                        "id": 78767,
                        "name": "Tegelen",
                        "latitude": "51.34417000",
                        "longitude": "6.13611000"
                    },
                    {
                        "id": 78776,
                        "name": "Terwinselen",
                        "latitude": "50.86659000",
                        "longitude": "6.02471000"
                    },
                    {
                        "id": 78782,
                        "name": "Thorn",
                        "latitude": "51.16167000",
                        "longitude": "5.84167000"
                    },
                    {
                        "id": 78784,
                        "name": "Tienray",
                        "latitude": "51.49500000",
                        "longitude": "6.09306000"
                    },
                    {
                        "id": 78805,
                        "name": "Ubachsberg",
                        "latitude": "50.85333000",
                        "longitude": "5.94861000"
                    },
                    {
                        "id": 78815,
                        "name": "Ulestraten",
                        "latitude": "50.90583000",
                        "longitude": "5.78194000"
                    },
                    {
                        "id": 78820,
                        "name": "Urmond",
                        "latitude": "50.99083000",
                        "longitude": "5.77222000"
                    },
                    {
                        "id": 78823,
                        "name": "Vaals",
                        "latitude": "50.77083000",
                        "longitude": "6.01806000"
                    },
                    {
                        "id": 78829,
                        "name": "Valkenburg",
                        "latitude": "50.86523000",
                        "longitude": "5.83205000"
                    },
                    {
                        "id": 78830,
                        "name": "Valkenburg aan de Geul",
                        "latitude": "50.85711000",
                        "longitude": "5.83489000"
                    },
                    {
                        "id": 78844,
                        "name": "Veltum",
                        "latitude": "51.51954000",
                        "longitude": "5.96032000"
                    },
                    {
                        "id": 78847,
                        "name": "Venlo",
                        "latitude": "51.37000000",
                        "longitude": "6.16806000"
                    },
                    {
                        "id": 78848,
                        "name": "Venray",
                        "latitude": "51.52500000",
                        "longitude": "5.97500000"
                    },
                    {
                        "id": 78852,
                        "name": "Vijlen",
                        "latitude": "50.78833000",
                        "longitude": "5.96528000"
                    },
                    {
                        "id": 78863,
                        "name": "Vlodrop",
                        "latitude": "51.13333000",
                        "longitude": "6.07639000"
                    },
                    {
                        "id": 78865,
                        "name": "Voerendaal",
                        "latitude": "50.88327000",
                        "longitude": "5.92978000"
                    },
                    {
                        "id": 78884,
                        "name": "Vrieheide",
                        "latitude": "50.92192000",
                        "longitude": "5.96701000"
                    },
                    {
                        "id": 78902,
                        "name": "Wanssum",
                        "latitude": "51.53583000",
                        "longitude": "6.07639000"
                    },
                    {
                        "id": 78912,
                        "name": "Waubach",
                        "latitude": "50.91833000",
                        "longitude": "6.05000000"
                    },
                    {
                        "id": 78914,
                        "name": "Weert",
                        "latitude": "51.25167000",
                        "longitude": "5.70694000"
                    },
                    {
                        "id": 78921,
                        "name": "Well",
                        "latitude": "51.55000000",
                        "longitude": "6.08889000"
                    },
                    {
                        "id": 78922,
                        "name": "Wellerlooi",
                        "latitude": "51.53417000",
                        "longitude": "6.13611000"
                    },
                    {
                        "id": 78927,
                        "name": "Wessem",
                        "latitude": "51.15954000",
                        "longitude": "5.88146000"
                    },
                    {
                        "id": 78955,
                        "name": "Wijlre",
                        "latitude": "50.83333000",
                        "longitude": "5.89583000"
                    },
                    {
                        "id": 78956,
                        "name": "Wijnandsrade",
                        "latitude": "50.90583000",
                        "longitude": "5.88333000"
                    },
                    {
                        "id": 78974,
                        "name": "Wolder",
                        "latitude": "50.83752000",
                        "longitude": "5.65938000"
                    },
                    {
                        "id": 78991,
                        "name": "Ysselsteyn",
                        "latitude": "51.49000000",
                        "longitude": "5.89722000"
                    }
                ]
            },
            {
                "id": 2623,
                "name": "North Brabant",
                "iso2": "NB",
                "latitude": "51.48265370",
                "longitude": "5.23216870",
                "type": "province",
                "cities": [
                    {
                        "id": 77297,
                        "name": "'s Gravenmoer",
                        "latitude": "51.65594000",
                        "longitude": "4.94076000"
                    },
                    {
                        "id": 77301,
                        "name": "'s-Hertogenbosch",
                        "latitude": "51.69917000",
                        "longitude": "5.30417000"
                    },
                    {
                        "id": 77302,
                        "name": "'t Hofke",
                        "latitude": "51.44943000",
                        "longitude": "5.51926000"
                    },
                    {
                        "id": 77305,
                        "name": "Aalburg",
                        "latitude": "51.75482000",
                        "longitude": "5.13156000"
                    },
                    {
                        "id": 77312,
                        "name": "Aarle-Rixtel",
                        "latitude": "51.50976000",
                        "longitude": "5.63839000"
                    },
                    {
                        "id": 77315,
                        "name": "Abcoven",
                        "latitude": "51.52750000",
                        "longitude": "5.08333000"
                    },
                    {
                        "id": 77320,
                        "name": "Akert",
                        "latitude": "51.41407000",
                        "longitude": "5.55960000"
                    },
                    {
                        "id": 77328,
                        "name": "Almkerk",
                        "latitude": "51.77083000",
                        "longitude": "4.95972000"
                    },
                    {
                        "id": 77329,
                        "name": "Alphen",
                        "latitude": "51.48167000",
                        "longitude": "4.95833000"
                    },
                    {
                        "id": 77342,
                        "name": "Andel",
                        "latitude": "51.78333000",
                        "longitude": "5.05833000"
                    },
                    {
                        "id": 77358,
                        "name": "Asten",
                        "latitude": "51.40417000",
                        "longitude": "5.74861000"
                    },
                    {
                        "id": 77365,
                        "name": "Baardwijk",
                        "latitude": "51.69246000",
                        "longitude": "5.09628000"
                    },
                    {
                        "id": 77366,
                        "name": "Baarle-Nassau",
                        "latitude": "51.44750000",
                        "longitude": "4.92917000"
                    },
                    {
                        "id": 77371,
                        "name": "Bakel",
                        "latitude": "51.50333000",
                        "longitude": "5.74028000"
                    },
                    {
                        "id": 77383,
                        "name": "Bavel",
                        "latitude": "51.56583000",
                        "longitude": "4.83056000"
                    },
                    {
                        "id": 77386,
                        "name": "Beek",
                        "latitude": "51.52890000",
                        "longitude": "5.63382000"
                    },
                    {
                        "id": 77390,
                        "name": "Beers",
                        "latitude": "51.72583000",
                        "longitude": "5.82778000"
                    },
                    {
                        "id": 77396,
                        "name": "Belcrum",
                        "latitude": "51.59911000",
                        "longitude": "4.76994000"
                    },
                    {
                        "id": 77407,
                        "name": "Bergeijk",
                        "latitude": "51.30182000",
                        "longitude": "5.33946000"
                    },
                    {
                        "id": 77408,
                        "name": "Bergen op Zoom",
                        "latitude": "51.49500000",
                        "longitude": "4.29167000"
                    },
                    {
                        "id": 77410,
                        "name": "Berghem",
                        "latitude": "51.76991000",
                        "longitude": "5.56827000"
                    },
                    {
                        "id": 77419,
                        "name": "Berlicum",
                        "latitude": "51.67750000",
                        "longitude": "5.40000000"
                    },
                    {
                        "id": 77421,
                        "name": "Besoijen",
                        "latitude": "51.68333000",
                        "longitude": "5.05000000"
                    },
                    {
                        "id": 77422,
                        "name": "Best",
                        "latitude": "51.50750000",
                        "longitude": "5.39028000"
                    },
                    {
                        "id": 77423,
                        "name": "Besterd",
                        "latitude": "51.56380000",
                        "longitude": "5.08658000"
                    },
                    {
                        "id": 77428,
                        "name": "Biesdonk",
                        "latitude": "51.60613000",
                        "longitude": "4.78515000"
                    },
                    {
                        "id": 77434,
                        "name": "Bitswijk",
                        "latitude": "51.66870000",
                        "longitude": "5.60921000"
                    },
                    {
                        "id": 77435,
                        "name": "Blaarthem",
                        "latitude": "51.42501000",
                        "longitude": "5.45784000"
                    },
                    {
                        "id": 77436,
                        "name": "Bladel",
                        "latitude": "51.36833000",
                        "longitude": "5.22083000"
                    },
                    {
                        "id": 77450,
                        "name": "Boekel",
                        "latitude": "51.60333000",
                        "longitude": "5.67500000"
                    },
                    {
                        "id": 77464,
                        "name": "Bosschenhoofd",
                        "latitude": "51.56083000",
                        "longitude": "4.54028000"
                    },
                    {
                        "id": 77466,
                        "name": "Boxmeer",
                        "latitude": "51.64667000",
                        "longitude": "5.94722000"
                    },
                    {
                        "id": 77467,
                        "name": "Boxtel",
                        "latitude": "51.59083000",
                        "longitude": "5.32917000"
                    },
                    {
                        "id": 77472,
                        "name": "Brand",
                        "latitude": "51.45839000",
                        "longitude": "5.62427000"
                    },
                    {
                        "id": 77473,
                        "name": "Breda",
                        "latitude": "51.58656000",
                        "longitude": "4.77596000"
                    },
                    {
                        "id": 77478,
                        "name": "Breugel",
                        "latitude": "51.51750000",
                        "longitude": "5.51111000"
                    },
                    {
                        "id": 77485,
                        "name": "Broekhoven",
                        "latitude": "51.54801000",
                        "longitude": "5.09175000"
                    },
                    {
                        "id": 77497,
                        "name": "Budel",
                        "latitude": "51.27167000",
                        "longitude": "5.57500000"
                    },
                    {
                        "id": 77498,
                        "name": "Budel-Dorplein",
                        "latitude": "51.23667000",
                        "longitude": "5.58750000"
                    },
                    {
                        "id": 77499,
                        "name": "Budel-Schoot",
                        "latitude": "51.24750000",
                        "longitude": "5.56528000"
                    },
                    {
                        "id": 77515,
                        "name": "Chaam",
                        "latitude": "51.50583000",
                        "longitude": "4.86111000"
                    },
                    {
                        "id": 77518,
                        "name": "Coevering",
                        "latitude": "51.41742000",
                        "longitude": "5.57463000"
                    },
                    {
                        "id": 77525,
                        "name": "Cranendonck",
                        "latitude": "51.30417000",
                        "longitude": "5.58889000"
                    },
                    {
                        "id": 77526,
                        "name": "Cuijk",
                        "latitude": "51.73083000",
                        "longitude": "5.87917000"
                    },
                    {
                        "id": 77533,
                        "name": "De Blaak",
                        "latitude": "51.54626000",
                        "longitude": "5.04465000"
                    },
                    {
                        "id": 77536,
                        "name": "De Doornakkers",
                        "latitude": "51.43844000",
                        "longitude": "5.50887000"
                    },
                    {
                        "id": 77550,
                        "name": "De Kruiskamp",
                        "latitude": "51.69978000",
                        "longitude": "5.26032000"
                    },
                    {
                        "id": 77557,
                        "name": "De Reit",
                        "latitude": "51.56038000",
                        "longitude": "5.04932000"
                    },
                    {
                        "id": 77559,
                        "name": "De Rompert",
                        "latitude": "51.71667000",
                        "longitude": "5.31667000"
                    },
                    {
                        "id": 77571,
                        "name": "Den Dungen",
                        "latitude": "51.66500000",
                        "longitude": "5.37222000"
                    },
                    {
                        "id": 77575,
                        "name": "Deuteren",
                        "latitude": "51.68667000",
                        "longitude": "5.26667000"
                    },
                    {
                        "id": 77580,
                        "name": "Diessen",
                        "latitude": "51.47583000",
                        "longitude": "5.17500000"
                    },
                    {
                        "id": 77582,
                        "name": "Dinteloord",
                        "latitude": "51.63500000",
                        "longitude": "4.36944000"
                    },
                    {
                        "id": 77590,
                        "name": "Dommelen",
                        "latitude": "51.34624000",
                        "longitude": "5.43394000"
                    },
                    {
                        "id": 77591,
                        "name": "Dongen",
                        "latitude": "51.62667000",
                        "longitude": "4.93889000"
                    },
                    {
                        "id": 77592,
                        "name": "Donk",
                        "latitude": "51.53843000",
                        "longitude": "5.62914000"
                    },
                    {
                        "id": 77594,
                        "name": "Doonheide",
                        "latitude": "51.56667000",
                        "longitude": "5.69444000"
                    },
                    {
                        "id": 77601,
                        "name": "Dorst",
                        "latitude": "51.59000000",
                        "longitude": "4.85694000"
                    },
                    {
                        "id": 77619,
                        "name": "Duizel",
                        "latitude": "51.36833000",
                        "longitude": "5.29722000"
                    },
                    {
                        "id": 77623,
                        "name": "Eckart",
                        "latitude": "51.47320000",
                        "longitude": "5.49449000"
                    },
                    {
                        "id": 77631,
                        "name": "Eerde",
                        "latitude": "51.60417000",
                        "longitude": "5.49861000"
                    },
                    {
                        "id": 77632,
                        "name": "Eerschot",
                        "latitude": "51.56833000",
                        "longitude": "5.47361000"
                    },
                    {
                        "id": 77633,
                        "name": "Eersel",
                        "latitude": "51.35750000",
                        "longitude": "5.31806000"
                    },
                    {
                        "id": 77642,
                        "name": "Eindhoven",
                        "latitude": "51.44083000",
                        "longitude": "5.47778000"
                    },
                    {
                        "id": 77644,
                        "name": "Ekenrooi",
                        "latitude": "51.39656000",
                        "longitude": "5.48624000"
                    },
                    {
                        "id": 77648,
                        "name": "Elshout",
                        "latitude": "51.70083000",
                        "longitude": "5.14167000"
                    },
                    {
                        "id": 77663,
                        "name": "Enschot",
                        "latitude": "51.57846000",
                        "longitude": "5.13885000"
                    },
                    {
                        "id": 77667,
                        "name": "Erp",
                        "latitude": "51.60000000",
                        "longitude": "5.60694000"
                    },
                    {
                        "id": 77668,
                        "name": "Esch",
                        "latitude": "51.61083000",
                        "longitude": "5.29028000"
                    },
                    {
                        "id": 77676,
                        "name": "Fijnaart",
                        "latitude": "51.63750000",
                        "longitude": "4.46944000"
                    },
                    {
                        "id": 77680,
                        "name": "Gageldonk",
                        "latitude": "51.60167000",
                        "longitude": "4.73889000"
                    },
                    {
                        "id": 77686,
                        "name": "Geenhoven",
                        "latitude": "51.35935000",
                        "longitude": "5.46021000"
                    },
                    {
                        "id": 77687,
                        "name": "Geertruidenberg",
                        "latitude": "51.70167000",
                        "longitude": "4.85694000"
                    },
                    {
                        "id": 77688,
                        "name": "Geffen",
                        "latitude": "51.74000000",
                        "longitude": "5.46389000"
                    },
                    {
                        "id": 77692,
                        "name": "Geldrop",
                        "latitude": "51.42167000",
                        "longitude": "5.55972000"
                    },
                    {
                        "id": 78019,
                        "name": "Gemert",
                        "latitude": "51.55583000",
                        "longitude": "5.69028000"
                    },
                    {
                        "id": 78020,
                        "name": "Gemonde",
                        "latitude": "51.61833000",
                        "longitude": "5.35694000"
                    },
                    {
                        "id": 78021,
                        "name": "Genderen",
                        "latitude": "51.73583000",
                        "longitude": "5.08750000"
                    },
                    {
                        "id": 78025,
                        "name": "Genoenhuis",
                        "latitude": "51.40917000",
                        "longitude": "5.53889000"
                    },
                    {
                        "id": 78026,
                        "name": "Gerwen",
                        "latitude": "51.49000000",
                        "longitude": "5.56250000"
                    },
                    {
                        "id": 78028,
                        "name": "Giessen",
                        "latitude": "51.79000000",
                        "longitude": "5.03056000"
                    },
                    {
                        "id": 78033,
                        "name": "Gilze",
                        "latitude": "51.54417000",
                        "longitude": "4.94028000"
                    },
                    {
                        "id": 78034,
                        "name": "Ginneken",
                        "latitude": "51.56593000",
                        "longitude": "4.79310000"
                    },
                    {
                        "id": 78038,
                        "name": "Goirle",
                        "latitude": "51.52083000",
                        "longitude": "5.06667000"
                    },
                    {
                        "id": 78052,
                        "name": "Grasrijk",
                        "latitude": "51.43916000",
                        "longitude": "5.41544000"
                    },
                    {
                        "id": 78053,
                        "name": "Grave",
                        "latitude": "51.75902000",
                        "longitude": "5.73882000"
                    },
                    {
                        "id": 78059,
                        "name": "Groenewoud",
                        "latitude": "51.53860000",
                        "longitude": "5.09028000"
                    },
                    {
                        "id": 78079,
                        "name": "Haaren",
                        "latitude": "51.60250000",
                        "longitude": "5.22222000"
                    },
                    {
                        "id": 78082,
                        "name": "Haarsteeg",
                        "latitude": "51.71167000",
                        "longitude": "5.19861000"
                    },
                    {
                        "id": 78087,
                        "name": "Halsteren",
                        "latitude": "51.52834000",
                        "longitude": "4.26785000"
                    },
                    {
                        "id": 78088,
                        "name": "Handel",
                        "latitude": "51.58000000",
                        "longitude": "5.70972000"
                    },
                    {
                        "id": 78089,
                        "name": "Hapert",
                        "latitude": "51.36833000",
                        "longitude": "5.25694000"
                    },
                    {
                        "id": 78090,
                        "name": "Haps",
                        "latitude": "51.68917000",
                        "longitude": "5.86111000"
                    },
                    {
                        "id": 78118,
                        "name": "Heerle",
                        "latitude": "51.51917000",
                        "longitude": "4.35972000"
                    },
                    {
                        "id": 78121,
                        "name": "Heesch",
                        "latitude": "51.73362000",
                        "longitude": "5.52672000"
                    },
                    {
                        "id": 78122,
                        "name": "Heesterakker",
                        "latitude": "51.48610000",
                        "longitude": "5.49681000"
                    },
                    {
                        "id": 78123,
                        "name": "Heeswijk-Dinther",
                        "latitude": "51.65083000",
                        "longitude": "5.47500000"
                    },
                    {
                        "id": 78124,
                        "name": "Heeze",
                        "latitude": "51.38280000",
                        "longitude": "5.57145000"
                    },
                    {
                        "id": 78135,
                        "name": "Helmond",
                        "latitude": "51.48167000",
                        "longitude": "5.66111000"
                    },
                    {
                        "id": 78137,
                        "name": "Helvoirt",
                        "latitude": "51.63167000",
                        "longitude": "5.23056000"
                    },
                    {
                        "id": 78146,
                        "name": "Herpen",
                        "latitude": "51.77167000",
                        "longitude": "5.64167000"
                    },
                    {
                        "id": 78154,
                        "name": "Heusden",
                        "latitude": "51.38417000",
                        "longitude": "5.76389000"
                    },
                    {
                        "id": 78155,
                        "name": "Heusdenhout",
                        "latitude": "51.58811000",
                        "longitude": "4.81930000"
                    },
                    {
                        "id": 78158,
                        "name": "Hilvarenbeek",
                        "latitude": "51.48583000",
                        "longitude": "5.13750000"
                    },
                    {
                        "id": 78165,
                        "name": "Hoeven",
                        "latitude": "51.57917000",
                        "longitude": "4.58333000"
                    },
                    {
                        "id": 78168,
                        "name": "Hoge Vucht",
                        "latitude": "51.60794000",
                        "longitude": "4.79150000"
                    },
                    {
                        "id": 78177,
                        "name": "Hooge Mierde",
                        "latitude": "51.38750000",
                        "longitude": "5.12917000"
                    },
                    {
                        "id": 78178,
                        "name": "Hooge Zwaluwe",
                        "latitude": "51.68750000",
                        "longitude": "4.74444000"
                    },
                    {
                        "id": 78179,
                        "name": "Hoogeloon",
                        "latitude": "51.39750000",
                        "longitude": "5.26806000"
                    },
                    {
                        "id": 78180,
                        "name": "Hoogerheide",
                        "latitude": "51.42417000",
                        "longitude": "4.32500000"
                    },
                    {
                        "id": 78191,
                        "name": "Huijbergen",
                        "latitude": "51.43250000",
                        "longitude": "4.37639000"
                    },
                    {
                        "id": 78205,
                        "name": "Jagershoef",
                        "latitude": "51.47330000",
                        "longitude": "5.46720000"
                    },
                    {
                        "id": 78212,
                        "name": "Kalsdonk",
                        "latitude": "51.53973000",
                        "longitude": "4.47111000"
                    },
                    {
                        "id": 78237,
                        "name": "Klein-Zundert",
                        "latitude": "51.48083000",
                        "longitude": "4.65417000"
                    },
                    {
                        "id": 78240,
                        "name": "Klundert",
                        "latitude": "51.66500000",
                        "longitude": "4.53472000"
                    },
                    {
                        "id": 78252,
                        "name": "Korvel",
                        "latitude": "51.54954000",
                        "longitude": "5.07079000"
                    },
                    {
                        "id": 78258,
                        "name": "Krooswijk",
                        "latitude": "51.64665000",
                        "longitude": "4.59203000"
                    },
                    {
                        "id": 78260,
                        "name": "Kruisland",
                        "latitude": "51.56917000",
                        "longitude": "4.40972000"
                    },
                    {
                        "id": 78264,
                        "name": "Lage Mierde",
                        "latitude": "51.40583000",
                        "longitude": "5.14722000"
                    },
                    {
                        "id": 78265,
                        "name": "Lakerlopen",
                        "latitude": "51.43791000",
                        "longitude": "5.50106000"
                    },
                    {
                        "id": 78270,
                        "name": "Langenboom",
                        "latitude": "51.70417000",
                        "longitude": "5.73056000"
                    },
                    {
                        "id": 78277,
                        "name": "Leende",
                        "latitude": "51.35083000",
                        "longitude": "5.55417000"
                    },
                    {
                        "id": 78281,
                        "name": "Leest",
                        "latitude": "51.60983000",
                        "longitude": "5.54312000"
                    },
                    {
                        "id": 78291,
                        "name": "Lepelstraat",
                        "latitude": "51.54833000",
                        "longitude": "4.27639000"
                    },
                    {
                        "id": 78298,
                        "name": "Liempde",
                        "latitude": "51.56917000",
                        "longitude": "5.37222000"
                    },
                    {
                        "id": 78300,
                        "name": "Lierop",
                        "latitude": "51.41917000",
                        "longitude": "5.67917000"
                    },
                    {
                        "id": 78301,
                        "name": "Lieshout",
                        "latitude": "51.52036000",
                        "longitude": "5.59479000"
                    },
                    {
                        "id": 78302,
                        "name": "Liessel",
                        "latitude": "51.41333000",
                        "longitude": "5.82083000"
                    },
                    {
                        "id": 78304,
                        "name": "Lievendaal",
                        "latitude": "51.44219000",
                        "longitude": "5.43405000"
                    },
                    {
                        "id": 78314,
                        "name": "Lith",
                        "latitude": "51.80583000",
                        "longitude": "5.43889000"
                    },
                    {
                        "id": 78319,
                        "name": "Loon op Zand",
                        "latitude": "51.62750000",
                        "longitude": "5.07500000"
                    },
                    {
                        "id": 78320,
                        "name": "Loosbroek",
                        "latitude": "51.67833000",
                        "longitude": "5.50694000"
                    },
                    {
                        "id": 78325,
                        "name": "Loven",
                        "latitude": "51.56480000",
                        "longitude": "5.09748000"
                    },
                    {
                        "id": 78329,
                        "name": "Luyksgestel",
                        "latitude": "51.28917000",
                        "longitude": "5.32361000"
                    },
                    {
                        "id": 78330,
                        "name": "Maarheeze",
                        "latitude": "51.31167000",
                        "longitude": "5.61667000"
                    },
                    {
                        "id": 78337,
                        "name": "Maaskantje",
                        "latitude": "51.65833000",
                        "longitude": "5.37083000"
                    },
                    {
                        "id": 78341,
                        "name": "Made",
                        "latitude": "51.67667000",
                        "longitude": "4.79306000"
                    },
                    {
                        "id": 78349,
                        "name": "Mariahout",
                        "latitude": "51.54083000",
                        "longitude": "5.57222000"
                    },
                    {
                        "id": 78367,
                        "name": "Meerhoven",
                        "latitude": "51.44267000",
                        "longitude": "5.41102000"
                    },
                    {
                        "id": 78370,
                        "name": "Meerveldhoven",
                        "latitude": "51.41705000",
                        "longitude": "5.41618000"
                    },
                    {
                        "id": 78372,
                        "name": "Megen",
                        "latitude": "51.82167000",
                        "longitude": "5.56250000"
                    },
                    {
                        "id": 78373,
                        "name": "Meierijstad",
                        "latitude": "51.59968000",
                        "longitude": "5.50278000"
                    },
                    {
                        "id": 78379,
                        "name": "Melle",
                        "latitude": "51.66244000",
                        "longitude": "5.63367000"
                    },
                    {
                        "id": 78387,
                        "name": "Middelbeers",
                        "latitude": "51.46667000",
                        "longitude": "5.25000000"
                    },
                    {
                        "id": 78390,
                        "name": "Middelrode",
                        "latitude": "51.66417000",
                        "longitude": "5.41944000"
                    },
                    {
                        "id": 78398,
                        "name": "Mierlo",
                        "latitude": "51.44000000",
                        "longitude": "5.61944000"
                    },
                    {
                        "id": 78401,
                        "name": "Milheeze",
                        "latitude": "51.50167000",
                        "longitude": "5.77917000"
                    },
                    {
                        "id": 78404,
                        "name": "Moerdijk",
                        "latitude": "51.70167000",
                        "longitude": "4.62639000"
                    },
                    {
                        "id": 78406,
                        "name": "Molenhoek",
                        "latitude": "51.71113000",
                        "longitude": "5.36809000"
                    },
                    {
                        "id": 78415,
                        "name": "Muschberg en Geestenberg",
                        "latitude": "51.44384000",
                        "longitude": "5.52329000"
                    },
                    {
                        "id": 78418,
                        "name": "Naastenbest",
                        "latitude": "51.50484000",
                        "longitude": "5.38579000"
                    },
                    {
                        "id": 78426,
                        "name": "Neerkant",
                        "latitude": "51.36833000",
                        "longitude": "5.86667000"
                    },
                    {
                        "id": 78437,
                        "name": "Nieuw-Vossemeer",
                        "latitude": "51.59000000",
                        "longitude": "4.21806000"
                    },
                    {
                        "id": 78446,
                        "name": "Nieuwkuijk",
                        "latitude": "51.69000000",
                        "longitude": "5.18194000"
                    },
                    {
                        "id": 78455,
                        "name": "Nijnsel",
                        "latitude": "51.55083000",
                        "longitude": "5.48333000"
                    },
                    {
                        "id": 78457,
                        "name": "Nispen",
                        "latitude": "51.48331000",
                        "longitude": "4.46131000"
                    },
                    {
                        "id": 78459,
                        "name": "Nistelrode",
                        "latitude": "51.70417000",
                        "longitude": "5.56250000"
                    },
                    {
                        "id": 78467,
                        "name": "Noordgeest",
                        "latitude": "51.50917000",
                        "longitude": "4.27917000"
                    },
                    {
                        "id": 78468,
                        "name": "Noordhoek",
                        "latitude": "51.64250000",
                        "longitude": "4.53194000"
                    },
                    {
                        "id": 78474,
                        "name": "Nuenen",
                        "latitude": "51.47000000",
                        "longitude": "5.55278000"
                    },
                    {
                        "id": 78483,
                        "name": "Odiliapeel",
                        "latitude": "51.64333000",
                        "longitude": "5.70556000"
                    },
                    {
                        "id": 78487,
                        "name": "Oerle",
                        "latitude": "51.42255000",
                        "longitude": "5.37163000"
                    },
                    {
                        "id": 78491,
                        "name": "Oirschot",
                        "latitude": "51.50500000",
                        "longitude": "5.31389000"
                    },
                    {
                        "id": 78492,
                        "name": "Oisterwijk",
                        "latitude": "51.57917000",
                        "longitude": "5.18889000"
                    },
                    {
                        "id": 78510,
                        "name": "Oosteind",
                        "latitude": "51.64418000",
                        "longitude": "4.89784000"
                    },
                    {
                        "id": 78512,
                        "name": "Oostelbeers",
                        "latitude": "51.47171000",
                        "longitude": "5.26897000"
                    },
                    {
                        "id": 78519,
                        "name": "Oosterhout",
                        "latitude": "51.64500000",
                        "longitude": "4.85972000"
                    },
                    {
                        "id": 78544,
                        "name": "Orthen",
                        "latitude": "51.70613000",
                        "longitude": "5.30468000"
                    },
                    {
                        "id": 78546,
                        "name": "Oss",
                        "latitude": "51.76500000",
                        "longitude": "5.51806000"
                    },
                    {
                        "id": 78547,
                        "name": "Ossendrecht",
                        "latitude": "51.39417000",
                        "longitude": "4.32639000"
                    },
                    {
                        "id": 78551,
                        "name": "Oud Gastel",
                        "latitude": "51.58667000",
                        "longitude": "4.45972000"
                    },
                    {
                        "id": 78572,
                        "name": "Overloon",
                        "latitude": "51.57167000",
                        "longitude": "5.94722000"
                    },
                    {
                        "id": 78596,
                        "name": "Princenhage",
                        "latitude": "51.57632000",
                        "longitude": "4.73906000"
                    },
                    {
                        "id": 78597,
                        "name": "Prinsenbeek",
                        "latitude": "51.59833000",
                        "longitude": "4.71250000"
                    },
                    {
                        "id": 78601,
                        "name": "Putte",
                        "latitude": "51.36000000",
                        "longitude": "4.39583000"
                    },
                    {
                        "id": 78603,
                        "name": "Quirijnstok",
                        "latitude": "51.58430000",
                        "longitude": "5.09810000"
                    },
                    {
                        "id": 78605,
                        "name": "Raam",
                        "latitude": "51.65967000",
                        "longitude": "5.63637000"
                    },
                    {
                        "id": 78606,
                        "name": "Raamsdonk",
                        "latitude": "51.68750000",
                        "longitude": "4.90833000"
                    },
                    {
                        "id": 78607,
                        "name": "Raamsdonksveer",
                        "latitude": "51.69667000",
                        "longitude": "4.87361000"
                    },
                    {
                        "id": 78609,
                        "name": "Ravenstein",
                        "latitude": "51.79667000",
                        "longitude": "5.65000000"
                    },
                    {
                        "id": 78610,
                        "name": "Reek",
                        "latitude": "51.74583000",
                        "longitude": "5.68194000"
                    },
                    {
                        "id": 78616,
                        "name": "Reusel",
                        "latitude": "51.36250000",
                        "longitude": "5.16528000"
                    },
                    {
                        "id": 78622,
                        "name": "Riethoven",
                        "latitude": "51.35417000",
                        "longitude": "5.38750000"
                    },
                    {
                        "id": 78623,
                        "name": "Rijen",
                        "latitude": "51.59083000",
                        "longitude": "4.91944000"
                    },
                    {
                        "id": 78627,
                        "name": "Rijsbergen",
                        "latitude": "51.51750000",
                        "longitude": "4.69722000"
                    },
                    {
                        "id": 78629,
                        "name": "Rijswijk",
                        "latitude": "51.79750000",
                        "longitude": "5.02500000"
                    },
                    {
                        "id": 78637,
                        "name": "Roosendaal",
                        "latitude": "51.53083000",
                        "longitude": "4.46528000"
                    },
                    {
                        "id": 78646,
                        "name": "Rucphen",
                        "latitude": "51.53167000",
                        "longitude": "4.55833000"
                    },
                    {
                        "id": 78651,
                        "name": "Salderes",
                        "latitude": "51.51505000",
                        "longitude": "5.38991000"
                    },
                    {
                        "id": 78657,
                        "name": "Schaijk",
                        "latitude": "51.74583000",
                        "longitude": "5.63194000"
                    },
                    {
                        "id": 78671,
                        "name": "Schijndel",
                        "latitude": "51.62250000",
                        "longitude": "5.43194000"
                    },
                    {
                        "id": 78684,
                        "name": "Schutsboom",
                        "latitude": "51.46152000",
                        "longitude": "5.62260000"
                    },
                    {
                        "id": 78695,
                        "name": "Sint Anthonis",
                        "latitude": "51.62667000",
                        "longitude": "5.88194000"
                    },
                    {
                        "id": 78704,
                        "name": "Sint Willebrord",
                        "latitude": "51.54833000",
                        "longitude": "4.58889000"
                    },
                    {
                        "id": 78705,
                        "name": "Sint-Michielsgestel",
                        "latitude": "51.64167000",
                        "longitude": "5.35278000"
                    },
                    {
                        "id": 78706,
                        "name": "Sint-Oedenrode",
                        "latitude": "51.56750000",
                        "longitude": "5.45972000"
                    },
                    {
                        "id": 78718,
                        "name": "Soerendonk",
                        "latitude": "51.30083000",
                        "longitude": "5.57500000"
                    },
                    {
                        "id": 78721,
                        "name": "Someren",
                        "latitude": "51.38500000",
                        "longitude": "5.71111000"
                    },
                    {
                        "id": 78722,
                        "name": "Someren-Eind",
                        "latitude": "51.35750000",
                        "longitude": "5.73333000"
                    },
                    {
                        "id": 78723,
                        "name": "Son",
                        "latitude": "51.51136000",
                        "longitude": "5.49282000"
                    },
                    {
                        "id": 78729,
                        "name": "Speelheide",
                        "latitude": "51.50607000",
                        "longitude": "5.40519000"
                    },
                    {
                        "id": 78738,
                        "name": "Sprundel",
                        "latitude": "51.53750000",
                        "longitude": "4.59722000"
                    },
                    {
                        "id": 78743,
                        "name": "Stampersgat",
                        "latitude": "51.61333000",
                        "longitude": "4.44444000"
                    },
                    {
                        "id": 78744,
                        "name": "Standdaarbuiten",
                        "latitude": "51.61333000",
                        "longitude": "4.51389000"
                    },
                    {
                        "id": 78748,
                        "name": "Steenbergen",
                        "latitude": "51.58417000",
                        "longitude": "4.31944000"
                    },
                    {
                        "id": 78750,
                        "name": "Steensel",
                        "latitude": "51.37667000",
                        "longitude": "5.35278000"
                    },
                    {
                        "id": 78756,
                        "name": "Stepekolk",
                        "latitude": "51.45500000",
                        "longitude": "5.61251000"
                    },
                    {
                        "id": 78772,
                        "name": "Terheijden",
                        "latitude": "51.64333000",
                        "longitude": "4.75417000"
                    },
                    {
                        "id": 78778,
                        "name": "Teteringen",
                        "latitude": "51.60917000",
                        "longitude": "4.82083000"
                    },
                    {
                        "id": 78780,
                        "name": "Theereheide",
                        "latitude": "51.63843000",
                        "longitude": "5.33729000"
                    },
                    {
                        "id": 78786,
                        "name": "Tilburg",
                        "latitude": "51.55551000",
                        "longitude": "5.09130000"
                    },
                    {
                        "id": 78788,
                        "name": "Tivoli",
                        "latitude": "51.42069000",
                        "longitude": "5.50818000"
                    },
                    {
                        "id": 78790,
                        "name": "Tongelre",
                        "latitude": "51.44889000",
                        "longitude": "5.51978000"
                    },
                    {
                        "id": 78807,
                        "name": "Uden",
                        "latitude": "51.66083000",
                        "longitude": "5.61944000"
                    },
                    {
                        "id": 78808,
                        "name": "Udenhout",
                        "latitude": "51.60917000",
                        "longitude": "5.14306000"
                    },
                    {
                        "id": 78817,
                        "name": "Ulvenhout",
                        "latitude": "51.54907000",
                        "longitude": "4.79931000"
                    },
                    {
                        "id": 78824,
                        "name": "Vaartbroek",
                        "latitude": "51.47954000",
                        "longitude": "5.49806000"
                    },
                    {
                        "id": 78831,
                        "name": "Valkenswaard",
                        "latitude": "51.35083000",
                        "longitude": "5.45972000"
                    },
                    {
                        "id": 78835,
                        "name": "Veen",
                        "latitude": "51.77750000",
                        "longitude": "5.10833000"
                    },
                    {
                        "id": 78839,
                        "name": "Veghel",
                        "latitude": "51.61667000",
                        "longitude": "5.54861000"
                    },
                    {
                        "id": 78840,
                        "name": "Veldhoven",
                        "latitude": "51.41833000",
                        "longitude": "5.40278000"
                    },
                    {
                        "id": 78845,
                        "name": "Ven",
                        "latitude": "51.64000000",
                        "longitude": "5.55000000"
                    },
                    {
                        "id": 78846,
                        "name": "Venhorst",
                        "latitude": "51.60833000",
                        "longitude": "5.73750000"
                    },
                    {
                        "id": 78853,
                        "name": "Villapark",
                        "latitude": "51.44144000",
                        "longitude": "5.49385000"
                    },
                    {
                        "id": 78859,
                        "name": "Vliedberg",
                        "latitude": "51.68961000",
                        "longitude": "5.19031000"
                    },
                    {
                        "id": 78860,
                        "name": "Vlierden",
                        "latitude": "51.44500000",
                        "longitude": "5.75833000"
                    },
                    {
                        "id": 78864,
                        "name": "Vlokhoven",
                        "latitude": "51.46667000",
                        "longitude": "5.48333000"
                    },
                    {
                        "id": 78869,
                        "name": "Voldijn",
                        "latitude": "51.40052000",
                        "longitude": "5.47196000"
                    },
                    {
                        "id": 78871,
                        "name": "Volkel",
                        "latitude": "51.64250000",
                        "longitude": "5.65417000"
                    },
                    {
                        "id": 78880,
                        "name": "Vorstenbosch",
                        "latitude": "51.65250000",
                        "longitude": "5.55000000"
                    },
                    {
                        "id": 78888,
                        "name": "Vught",
                        "latitude": "51.65333000",
                        "longitude": "5.28750000"
                    },
                    {
                        "id": 78891,
                        "name": "Waalre",
                        "latitude": "51.38667000",
                        "longitude": "5.44444000"
                    },
                    {
                        "id": 78892,
                        "name": "Waalwijk",
                        "latitude": "51.68250000",
                        "longitude": "5.07083000"
                    },
                    {
                        "id": 78898,
                        "name": "Wagenberg",
                        "latitude": "51.66500000",
                        "longitude": "4.74861000"
                    },
                    {
                        "id": 78901,
                        "name": "Wanroij",
                        "latitude": "51.65750000",
                        "longitude": "5.81806000"
                    },
                    {
                        "id": 78908,
                        "name": "Waspik",
                        "latitude": "51.68667000",
                        "longitude": "4.94444000"
                    },
                    {
                        "id": 78911,
                        "name": "Waterdonken",
                        "latitude": "51.60959000",
                        "longitude": "4.80452000"
                    },
                    {
                        "id": 78919,
                        "name": "Welberg",
                        "latitude": "51.57667000",
                        "longitude": "4.33056000"
                    },
                    {
                        "id": 78924,
                        "name": "Werkendam",
                        "latitude": "51.81000000",
                        "longitude": "4.89444000"
                    },
                    {
                        "id": 78926,
                        "name": "Wernhout",
                        "latitude": "51.45500000",
                        "longitude": "4.64167000"
                    },
                    {
                        "id": 78937,
                        "name": "Westerhoven",
                        "latitude": "51.33250000",
                        "longitude": "5.39583000"
                    },
                    {
                        "id": 78949,
                        "name": "Wijbosch",
                        "latitude": "51.61667000",
                        "longitude": "5.46806000"
                    },
                    {
                        "id": 78959,
                        "name": "Wilhelminadorp",
                        "latitude": "51.49742000",
                        "longitude": "5.39223000"
                    },
                    {
                        "id": 78968,
                        "name": "Wisselaar",
                        "latitude": "51.61285000",
                        "longitude": "4.78444000"
                    },
                    {
                        "id": 78971,
                        "name": "Woensdrecht",
                        "latitude": "51.42897000",
                        "longitude": "4.30355000"
                    },
                    {
                        "id": 78972,
                        "name": "Woenselse Heide",
                        "latitude": "51.48333000",
                        "longitude": "5.46667000"
                    },
                    {
                        "id": 78986,
                        "name": "Woudrichem",
                        "latitude": "51.81500000",
                        "longitude": "5.00139000"
                    },
                    {
                        "id": 78988,
                        "name": "Wouw",
                        "latitude": "51.52167000",
                        "longitude": "4.39028000"
                    },
                    {
                        "id": 78997,
                        "name": "Zandberg",
                        "latitude": "51.57333000",
                        "longitude": "4.78472000"
                    },
                    {
                        "id": 79000,
                        "name": "Zeeland",
                        "latitude": "51.69750000",
                        "longitude": "5.67639000"
                    },
                    {
                        "id": 79001,
                        "name": "Zeelst",
                        "latitude": "51.42421000",
                        "longitude": "5.41566000"
                    },
                    {
                        "id": 79003,
                        "name": "Zegge",
                        "latitude": "51.55667000",
                        "longitude": "4.51806000"
                    },
                    {
                        "id": 79004,
                        "name": "Zeilberg",
                        "latitude": "51.45469000",
                        "longitude": "5.81878000"
                    },
                    {
                        "id": 79007,
                        "name": "Zesgehuchten",
                        "latitude": "51.41667000",
                        "longitude": "5.55000000"
                    },
                    {
                        "id": 79010,
                        "name": "Zevenbergschen Hoek",
                        "latitude": "51.67250000",
                        "longitude": "4.67917000"
                    },
                    {
                        "id": 79014,
                        "name": "Zijtaart",
                        "latitude": "51.59250000",
                        "longitude": "5.54167000"
                    },
                    {
                        "id": 79018,
                        "name": "Zonderwijk",
                        "latitude": "51.41141000",
                        "longitude": "5.39361000"
                    },
                    {
                        "id": 79031,
                        "name": "Zundert",
                        "latitude": "51.47167000",
                        "longitude": "4.65556000"
                    }
                ]
            },
            {
                "id": 2612,
                "name": "North Holland",
                "iso2": "NH",
                "latitude": "52.52058690",
                "longitude": "4.78847400",
                "type": "province",
                "cities": [
                    {
                        "id": 149826,
                        "name": "'s-Graveland",
                        "latitude": "52.24420000",
                        "longitude": "5.12110000"
                    },
                    {
                        "id": 149827,
                        "name": "'t Horntje",
                        "latitude": "53.00560000",
                        "longitude": "4.78610000"
                    },
                    {
                        "id": 149828,
                        "name": "'t Kabel",
                        "latitude": "52.25610000",
                        "longitude": "4.64970000"
                    },
                    {
                        "id": 149829,
                        "name": "'t Nopeind",
                        "latitude": "52.41000000",
                        "longitude": "4.96360000"
                    },
                    {
                        "id": 149830,
                        "name": "'t Veld",
                        "latitude": "52.73920000",
                        "longitude": "4.85560000"
                    },
                    {
                        "id": 77303,
                        "name": "'t Zand",
                        "latitude": "52.83667000",
                        "longitude": "4.75556000"
                    },
                    {
                        "id": 149831,
                        "name": "Aagtdorp",
                        "latitude": "52.68890000",
                        "longitude": "4.70190000"
                    },
                    {
                        "id": 77307,
                        "name": "Aalsmeer",
                        "latitude": "52.25917000",
                        "longitude": "4.75972000"
                    },
                    {
                        "id": 149832,
                        "name": "Aalsmeerderbrug",
                        "latitude": "52.27580000",
                        "longitude": "4.75000000"
                    },
                    {
                        "id": 149833,
                        "name": "Aartswoud",
                        "latitude": "52.74440000",
                        "longitude": "4.95360000"
                    },
                    {
                        "id": 77313,
                        "name": "Abbekerk",
                        "latitude": "52.73167000",
                        "longitude": "5.01806000"
                    },
                    {
                        "id": 149834,
                        "name": "Abbenes",
                        "latitude": "52.23390000",
                        "longitude": "4.58940000"
                    },
                    {
                        "id": 149835,
                        "name": "Akersloot",
                        "latitude": "52.56030000",
                        "longitude": "4.72830000"
                    },
                    {
                        "id": 77325,
                        "name": "Alkmaar",
                        "latitude": "52.63167000",
                        "longitude": "4.74861000"
                    },
                    {
                        "id": 77338,
                        "name": "Amstelveen",
                        "latitude": "52.30083000",
                        "longitude": "4.86389000"
                    },
                    {
                        "id": 77340,
                        "name": "Amsterdam",
                        "latitude": "52.37403000",
                        "longitude": "4.88969000"
                    },
                    {
                        "id": 77341,
                        "name": "Amsterdam-Zuidoost",
                        "latitude": "52.30750000",
                        "longitude": "4.97222000"
                    },
                    {
                        "id": 149836,
                        "name": "Andijk",
                        "latitude": "52.75000000",
                        "longitude": "5.22000000"
                    },
                    {
                        "id": 149837,
                        "name": "Ankeveen",
                        "latitude": "52.26530000",
                        "longitude": "5.09890000"
                    },
                    {
                        "id": 77347,
                        "name": "Ankeveense Rade",
                        "latitude": "52.25891000",
                        "longitude": "5.10160000"
                    },
                    {
                        "id": 149838,
                        "name": "Assendelft",
                        "latitude": "52.46666667",
                        "longitude": "4.75000000"
                    },
                    {
                        "id": 77361,
                        "name": "Avenhorn",
                        "latitude": "52.61750000",
                        "longitude": "4.95139000"
                    },
                    {
                        "id": 149839,
                        "name": "Badhoevedorp",
                        "latitude": "52.33810000",
                        "longitude": "4.78030000"
                    },
                    {
                        "id": 149840,
                        "name": "Bakkum",
                        "latitude": "52.55830000",
                        "longitude": "4.65670000"
                    },
                    {
                        "id": 77377,
                        "name": "Bangert",
                        "latitude": "52.73582000",
                        "longitude": "5.18010000"
                    },
                    {
                        "id": 149841,
                        "name": "Bargen",
                        "latitude": "53.08416667",
                        "longitude": "4.83472222"
                    },
                    {
                        "id": 149842,
                        "name": "Barsingerhorn",
                        "latitude": "52.78527778",
                        "longitude": "4.84166667"
                    },
                    {
                        "id": 149843,
                        "name": "Beemster",
                        "latitude": "52.55000000",
                        "longitude": "4.92780000"
                    },
                    {
                        "id": 149844,
                        "name": "Beets",
                        "latitude": "52.58920000",
                        "longitude": "4.97750000"
                    },
                    {
                        "id": 149845,
                        "name": "Beinsdorp",
                        "latitude": "52.28720000",
                        "longitude": "4.59440000"
                    },
                    {
                        "id": 149846,
                        "name": "Belt",
                        "latitude": "52.90420000",
                        "longitude": "4.95390000"
                    },
                    {
                        "id": 77401,
                        "name": "Bennebroek",
                        "latitude": "52.32083000",
                        "longitude": "4.59861000"
                    },
                    {
                        "id": 149847,
                        "name": "Benningbroek",
                        "latitude": "52.70310000",
                        "longitude": "5.00970000"
                    },
                    {
                        "id": 149848,
                        "name": "Bentveld",
                        "latitude": "52.36580000",
                        "longitude": "4.57170000"
                    },
                    {
                        "id": 149849,
                        "name": "Bergen",
                        "latitude": "52.67030000",
                        "longitude": "4.70540000"
                    },
                    {
                        "id": 77417,
                        "name": "Berkhout",
                        "latitude": "52.64083000",
                        "longitude": "5.00139000"
                    },
                    {
                        "id": 149850,
                        "name": "Berkmeer",
                        "latitude": "52.68560000",
                        "longitude": "4.89830000"
                    },
                    {
                        "id": 77426,
                        "name": "Beverwijk",
                        "latitude": "52.48333000",
                        "longitude": "4.65694000"
                    },
                    {
                        "id": 149851,
                        "name": "Bijlmermeer",
                        "latitude": "52.31861000",
                        "longitude": "4.96528000"
                    },
                    {
                        "id": 77430,
                        "name": "Bijvanck",
                        "latitude": "52.28585000",
                        "longitude": "5.26534000"
                    },
                    {
                        "id": 149852,
                        "name": "Binnenstad",
                        "latitude": "52.37200000",
                        "longitude": "4.89600000"
                    },
                    {
                        "id": 77437,
                        "name": "Blaricum",
                        "latitude": "52.27250000",
                        "longitude": "5.24167000"
                    },
                    {
                        "id": 149853,
                        "name": "Blauwe Keet",
                        "latitude": "52.89560000",
                        "longitude": "4.78190000"
                    },
                    {
                        "id": 77443,
                        "name": "Bloemendaal",
                        "latitude": "52.40250000",
                        "longitude": "4.62222000"
                    },
                    {
                        "id": 78515,
                        "name": "Blokker",
                        "latitude": "52.66917000",
                        "longitude": "5.11806000"
                    },
                    {
                        "id": 149854,
                        "name": "Bobeldijk",
                        "latitude": "52.65360000",
                        "longitude": "5.00440000"
                    },
                    {
                        "id": 149855,
                        "name": "Boekel",
                        "latitude": "52.59000000",
                        "longitude": "4.75330000"
                    },
                    {
                        "id": 149856,
                        "name": "Boesingheliede",
                        "latitude": "52.35830000",
                        "longitude": "4.72830000"
                    },
                    {
                        "id": 149857,
                        "name": "Bos en Lommer",
                        "latitude": "52.37865000",
                        "longitude": "4.85050700"
                    },
                    {
                        "id": 149858,
                        "name": "Bovenkarspel",
                        "latitude": "52.70000000",
                        "longitude": "5.25000000"
                    },
                    {
                        "id": 77476,
                        "name": "Breezand",
                        "latitude": "52.89000000",
                        "longitude": "4.80417000"
                    },
                    {
                        "id": 149859,
                        "name": "Bregtdorp",
                        "latitude": "52.71666667",
                        "longitude": "4.68333333"
                    },
                    {
                        "id": 149860,
                        "name": "Breukeleveen",
                        "latitude": "52.17810000",
                        "longitude": "5.06920000"
                    },
                    {
                        "id": 77482,
                        "name": "Broek in Waterland",
                        "latitude": "52.43417000",
                        "longitude": "4.99583000"
                    },
                    {
                        "id": 77483,
                        "name": "Broek op Langedijk",
                        "latitude": "52.67417000",
                        "longitude": "4.80556000"
                    },
                    {
                        "id": 149861,
                        "name": "Buiksloot",
                        "latitude": "52.39890000",
                        "longitude": "4.92210000"
                    },
                    {
                        "id": 149862,
                        "name": "Buikslotermeer",
                        "latitude": "52.40350000",
                        "longitude": "4.93740000"
                    },
                    {
                        "id": 149863,
                        "name": "Buitenkaag",
                        "latitude": "52.21970000",
                        "longitude": "4.56080000"
                    },
                    {
                        "id": 149864,
                        "name": "Buitenveldert",
                        "latitude": "52.33000000",
                        "longitude": "4.87420000"
                    },
                    {
                        "id": 149865,
                        "name": "Burgerbrug",
                        "latitude": "52.74810000",
                        "longitude": "4.70220000"
                    },
                    {
                        "id": 149866,
                        "name": "Burgerveen",
                        "latitude": "52.24030000",
                        "longitude": "4.68220000"
                    },
                    {
                        "id": 149867,
                        "name": "Burgervlotbrug",
                        "latitude": "52.75390000",
                        "longitude": "4.68190000"
                    },
                    {
                        "id": 77508,
                        "name": "Bussum",
                        "latitude": "52.27333000",
                        "longitude": "5.16111000"
                    },
                    {
                        "id": 149868,
                        "name": "Butterhuizen",
                        "latitude": "52.64970000",
                        "longitude": "4.81670000"
                    },
                    {
                        "id": 77509,
                        "name": "Callantsoog",
                        "latitude": "52.84000000",
                        "longitude": "4.69583000"
                    },
                    {
                        "id": 149869,
                        "name": "Calslagen",
                        "latitude": "52.23330000",
                        "longitude": "4.73080000"
                    },
                    {
                        "id": 149870,
                        "name": "Camperduin",
                        "latitude": "52.73333333",
                        "longitude": "4.65000000"
                    },
                    {
                        "id": 77514,
                        "name": "Castricum",
                        "latitude": "52.54833000",
                        "longitude": "4.66944000"
                    },
                    {
                        "id": 149871,
                        "name": "Catrijp",
                        "latitude": "52.71390000",
                        "longitude": "4.68170000"
                    },
                    {
                        "id": 77521,
                        "name": "Commandeurs",
                        "latitude": "52.50902000",
                        "longitude": "4.65843000"
                    },
                    {
                        "id": 149872,
                        "name": "Cruquius",
                        "latitude": "52.33333333",
                        "longitude": "4.63333333"
                    },
                    {
                        "id": 149873,
                        "name": "De Aker",
                        "latitude": "52.35140000",
                        "longitude": "4.77920000"
                    },
                    {
                        "id": 149874,
                        "name": "De Cocksdorp",
                        "latitude": "53.15500000",
                        "longitude": "4.86670000"
                    },
                    {
                        "id": 77539,
                        "name": "De Glip",
                        "latitude": "52.33083000",
                        "longitude": "4.61111000"
                    },
                    {
                        "id": 77540,
                        "name": "De Goorn",
                        "latitude": "52.62583000",
                        "longitude": "4.94722000"
                    },
                    {
                        "id": 149875,
                        "name": "De Haukes",
                        "latitude": "52.88830000",
                        "longitude": "4.93610000"
                    },
                    {
                        "id": 149876,
                        "name": "De Hulk",
                        "latitude": "52.63610000",
                        "longitude": "5.02220000"
                    },
                    {
                        "id": 77549,
                        "name": "De Koog",
                        "latitude": "53.09750000",
                        "longitude": "4.76111000"
                    },
                    {
                        "id": 149877,
                        "name": "De Kooy",
                        "latitude": "52.91440000",
                        "longitude": "4.78580000"
                    },
                    {
                        "id": 149878,
                        "name": "De Kwakel",
                        "latitude": "52.24080000",
                        "longitude": "4.79080000"
                    },
                    {
                        "id": 77553,
                        "name": "De Maer",
                        "latitude": "52.51901000",
                        "longitude": "4.68171000"
                    },
                    {
                        "id": 77555,
                        "name": "De Noord",
                        "latitude": "52.70750000",
                        "longitude": "4.85139000"
                    },
                    {
                        "id": 149879,
                        "name": "De Pijp",
                        "latitude": "52.35310000",
                        "longitude": "4.89610000"
                    },
                    {
                        "id": 77558,
                        "name": "De Rijp",
                        "latitude": "52.55667000",
                        "longitude": "4.84583000"
                    },
                    {
                        "id": 149880,
                        "name": "De Stolpen",
                        "latitude": "52.81220000",
                        "longitude": "4.72970000"
                    },
                    {
                        "id": 149881,
                        "name": "De Waal",
                        "latitude": "53.07190000",
                        "longitude": "4.82280000"
                    },
                    {
                        "id": 149882,
                        "name": "De Wallen",
                        "latitude": "52.37348000",
                        "longitude": "4.89806000"
                    },
                    {
                        "id": 149883,
                        "name": "De Weere",
                        "latitude": "52.77444444",
                        "longitude": "4.86694444"
                    },
                    {
                        "id": 149885,
                        "name": "De Woude",
                        "latitude": "52.54667000",
                        "longitude": "4.77361000"
                    },
                    {
                        "id": 77570,
                        "name": "Den Burg",
                        "latitude": "53.05417000",
                        "longitude": "4.79722000"
                    },
                    {
                        "id": 77573,
                        "name": "Den Helder",
                        "latitude": "52.95988000",
                        "longitude": "4.75933000"
                    },
                    {
                        "id": 149886,
                        "name": "Den Hoorn",
                        "latitude": "53.02500000",
                        "longitude": "4.75110000"
                    },
                    {
                        "id": 149887,
                        "name": "Den Ilp",
                        "latitude": "52.45030000",
                        "longitude": "4.90750000"
                    },
                    {
                        "id": 77574,
                        "name": "Den Oever",
                        "latitude": "52.93353000",
                        "longitude": "5.03079000"
                    },
                    {
                        "id": 77577,
                        "name": "Diemen",
                        "latitude": "52.33964000",
                        "longitude": "4.96256000"
                    },
                    {
                        "id": 77583,
                        "name": "Dirkshorn",
                        "latitude": "52.75000000",
                        "longitude": "4.77500000"
                    },
                    {
                        "id": 149888,
                        "name": "Drechterland",
                        "latitude": "52.66454000",
                        "longitude": "5.16569000"
                    },
                    {
                        "id": 149889,
                        "name": "Driehuis",
                        "latitude": "52.44720000",
                        "longitude": "4.63670000"
                    },
                    {
                        "id": 149890,
                        "name": "Driehuizen",
                        "latitude": "52.57890000",
                        "longitude": "4.80890000"
                    },
                    {
                        "id": 77609,
                        "name": "Driemond",
                        "latitude": "52.30583000",
                        "longitude": "5.01667000"
                    },
                    {
                        "id": 77618,
                        "name": "Duivendrecht",
                        "latitude": "52.32941000",
                        "longitude": "4.93964000"
                    },
                    {
                        "id": 149892,
                        "name": "Durgerdam",
                        "latitude": "52.37770000",
                        "longitude": "4.98908000"
                    },
                    {
                        "id": 77624,
                        "name": "Edam",
                        "latitude": "52.51215000",
                        "longitude": "5.04805000"
                    },
                    {
                        "id": 149893,
                        "name": "Edam-Volendam",
                        "latitude": "52.50190000",
                        "longitude": "5.06140000"
                    },
                    {
                        "id": 149894,
                        "name": "Eenigenburg",
                        "latitude": "52.74250000",
                        "longitude": "4.72560000"
                    },
                    {
                        "id": 149895,
                        "name": "Egmond aan den Hoef",
                        "latitude": "52.62190000",
                        "longitude": "4.65310000"
                    },
                    {
                        "id": 77637,
                        "name": "Egmond aan Zee",
                        "latitude": "52.62040000",
                        "longitude": "4.62705000"
                    },
                    {
                        "id": 77638,
                        "name": "Egmond-Binnen",
                        "latitude": "52.59583000",
                        "longitude": "4.65556000"
                    },
                    {
                        "id": 77660,
                        "name": "Enkhuizen",
                        "latitude": "52.70333000",
                        "longitude": "5.29167000"
                    },
                    {
                        "id": 149896,
                        "name": "Etersheim",
                        "latitude": "52.58500000",
                        "longitude": "5.02220000"
                    },
                    {
                        "id": 149897,
                        "name": "Friese Buurt",
                        "latitude": "52.92140000",
                        "longitude": "4.76670000"
                    },
                    {
                        "id": 149898,
                        "name": "Geuzenveld",
                        "latitude": "52.37790000",
                        "longitude": "4.79965000"
                    },
                    {
                        "id": 78039,
                        "name": "Gooise Meren",
                        "latitude": "52.29735000",
                        "longitude": "5.13371000"
                    },
                    {
                        "id": 149899,
                        "name": "Gouwe",
                        "latitude": "52.72940000",
                        "longitude": "4.96250000"
                    },
                    {
                        "id": 149900,
                        "name": "Graft",
                        "latitude": "52.56080000",
                        "longitude": "4.83390000"
                    },
                    {
                        "id": 149901,
                        "name": "Grootebroek",
                        "latitude": "52.69890000",
                        "longitude": "5.21890000"
                    },
                    {
                        "id": 149902,
                        "name": "Grootschermer",
                        "latitude": "52.58080000",
                        "longitude": "4.85170000"
                    },
                    {
                        "id": 149903,
                        "name": "Grosthuizen",
                        "latitude": "52.61666667",
                        "longitude": "4.98333333"
                    },
                    {
                        "id": 78081,
                        "name": "Haarlem",
                        "latitude": "52.38084000",
                        "longitude": "4.63683000"
                    },
                    {
                        "id": 149904,
                        "name": "Haarlemmerliede",
                        "latitude": "52.38810000",
                        "longitude": "4.68750000"
                    },
                    {
                        "id": 149905,
                        "name": "Haarlemmermeer",
                        "latitude": "52.30080000",
                        "longitude": "4.66530000"
                    },
                    {
                        "id": 149906,
                        "name": "Hakkelaarsbrug",
                        "latitude": "52.31920000",
                        "longitude": "5.10220000"
                    },
                    {
                        "id": 78085,
                        "name": "Halfweg",
                        "latitude": "52.38250000",
                        "longitude": "4.75417000"
                    },
                    {
                        "id": 149907,
                        "name": "Harderwijk",
                        "latitude": "52.73833333",
                        "longitude": "4.99333333"
                    },
                    {
                        "id": 78094,
                        "name": "Harenkarspel",
                        "latitude": "52.73416000",
                        "longitude": "4.77682000"
                    },
                    {
                        "id": 149908,
                        "name": "Hargen",
                        "latitude": "52.72167000",
                        "longitude": "4.66250000"
                    },
                    {
                        "id": 149909,
                        "name": "Haringhuizen",
                        "latitude": "52.77330000",
                        "longitude": "4.82890000"
                    },
                    {
                        "id": 149910,
                        "name": "Hauwert",
                        "latitude": "52.70750000",
                        "longitude": "5.09890000"
                    },
                    {
                        "id": 78110,
                        "name": "Heemskerk",
                        "latitude": "52.51108000",
                        "longitude": "4.67165000"
                    },
                    {
                        "id": 78111,
                        "name": "Heemstede",
                        "latitude": "52.34992000",
                        "longitude": "4.62301000"
                    },
                    {
                        "id": 78116,
                        "name": "Heerhugowaard",
                        "latitude": "52.67144000",
                        "longitude": "4.84862000"
                    },
                    {
                        "id": 78130,
                        "name": "Heiloo",
                        "latitude": "52.60252000",
                        "longitude": "4.68815000"
                    },
                    {
                        "id": 78138,
                        "name": "Hem",
                        "latitude": "52.66083000",
                        "longitude": "5.18333000"
                    },
                    {
                        "id": 78144,
                        "name": "Hensbroek",
                        "latitude": "52.65833000",
                        "longitude": "4.88472000"
                    },
                    {
                        "id": 78159,
                        "name": "Hilversum",
                        "latitude": "52.22333000",
                        "longitude": "5.17639000"
                    },
                    {
                        "id": 78160,
                        "name": "Hilversumse Meent",
                        "latitude": "52.27115000",
                        "longitude": "5.13729000"
                    },
                    {
                        "id": 149911,
                        "name": "Hinderdam",
                        "latitude": "52.28280000",
                        "longitude": "5.05690000"
                    },
                    {
                        "id": 78161,
                        "name": "Hippolytushoef",
                        "latitude": "52.90750000",
                        "longitude": "4.96250000"
                    },
                    {
                        "id": 149912,
                        "name": "Hobrede",
                        "latitude": "52.54500000",
                        "longitude": "4.98080000"
                    },
                    {
                        "id": 78166,
                        "name": "Hofgeest",
                        "latitude": "52.44333000",
                        "longitude": "4.65833000"
                    },
                    {
                        "id": 149913,
                        "name": "Hollands Kroon",
                        "latitude": "52.87830000",
                        "longitude": "4.81140000"
                    },
                    {
                        "id": 149914,
                        "name": "Holysloot",
                        "latitude": "52.41310000",
                        "longitude": "5.02530000"
                    },
                    {
                        "id": 78175,
                        "name": "Hoofddorp",
                        "latitude": "52.30250000",
                        "longitude": "4.68889000"
                    },
                    {
                        "id": 149915,
                        "name": "Hoogkarspel",
                        "latitude": "52.69470000",
                        "longitude": "5.17780000"
                    },
                    {
                        "id": 78185,
                        "name": "Hoogwoud",
                        "latitude": "52.71583000",
                        "longitude": "4.93889000"
                    },
                    {
                        "id": 78186,
                        "name": "Hoorn",
                        "latitude": "52.64250000",
                        "longitude": "5.05972000"
                    },
                    {
                        "id": 149916,
                        "name": "Horstermeer",
                        "latitude": "52.24970000",
                        "longitude": "5.07420000"
                    },
                    {
                        "id": 149917,
                        "name": "Huigsloot",
                        "latitude": "52.21667000",
                        "longitude": "4.59722000"
                    },
                    {
                        "id": 149918,
                        "name": "Huisduinen",
                        "latitude": "52.95330000",
                        "longitude": "4.72500000"
                    },
                    {
                        "id": 78192,
                        "name": "Huizen",
                        "latitude": "52.29917000",
                        "longitude": "5.24167000"
                    },
                    {
                        "id": 149919,
                        "name": "IJburg",
                        "latitude": "52.35500000",
                        "longitude": "4.99778000"
                    },
                    {
                        "id": 149920,
                        "name": "IJmuiden",
                        "latitude": "52.45860000",
                        "longitude": "4.61940000"
                    },
                    {
                        "id": 78203,
                        "name": "Ilpendam",
                        "latitude": "52.46333000",
                        "longitude": "4.95000000"
                    },
                    {
                        "id": 149921,
                        "name": "Jisp",
                        "latitude": "52.50670000",
                        "longitude": "4.84890000"
                    },
                    {
                        "id": 149922,
                        "name": "Jordaan",
                        "latitude": "52.37917000",
                        "longitude": "4.88028000"
                    },
                    {
                        "id": 149923,
                        "name": "Julianadorp",
                        "latitude": "52.89060000",
                        "longitude": "4.73890000"
                    },
                    {
                        "id": 78210,
                        "name": "Kadoelen",
                        "latitude": "52.41750000",
                        "longitude": "4.90561000"
                    },
                    {
                        "id": 149924,
                        "name": "Kalverdijk",
                        "latitude": "52.73250000",
                        "longitude": "4.76806000"
                    },
                    {
                        "id": 149925,
                        "name": "Kapel",
                        "latitude": "52.58333333",
                        "longitude": "4.69305556"
                    },
                    {
                        "id": 149926,
                        "name": "Katwoude",
                        "latitude": "52.46940000",
                        "longitude": "5.05060000"
                    },
                    {
                        "id": 149927,
                        "name": "Kerkbuurt",
                        "latitude": "52.73996100",
                        "longitude": "4.75877500"
                    },
                    {
                        "id": 78227,
                        "name": "Kerkelanden",
                        "latitude": "52.21755000",
                        "longitude": "5.13575000"
                    },
                    {
                        "id": 149928,
                        "name": "Koedijk",
                        "latitude": "52.67500000",
                        "longitude": "4.74830000"
                    },
                    {
                        "id": 149929,
                        "name": "Koggenland",
                        "latitude": "52.63333333",
                        "longitude": "4.95000000"
                    },
                    {
                        "id": 149930,
                        "name": "Kolhorn",
                        "latitude": "52.79280000",
                        "longitude": "4.88890000"
                    },
                    {
                        "id": 149931,
                        "name": "Koog aan de Zaan",
                        "latitude": "52.46666667",
                        "longitude": "4.80000000"
                    },
                    {
                        "id": 78251,
                        "name": "Kortenhoef",
                        "latitude": "52.23917000",
                        "longitude": "5.10694000"
                    },
                    {
                        "id": 149932,
                        "name": "Krabbendam",
                        "latitude": "52.73220000",
                        "longitude": "4.70250000"
                    },
                    {
                        "id": 149933,
                        "name": "Kreileroord",
                        "latitude": "52.84220000",
                        "longitude": "5.08140000"
                    },
                    {
                        "id": 149934,
                        "name": "Krommenie",
                        "latitude": "52.50000000",
                        "longitude": "4.76666667"
                    },
                    {
                        "id": 78261,
                        "name": "Kudelstaart",
                        "latitude": "52.23417000",
                        "longitude": "4.75139000"
                    },
                    {
                        "id": 149935,
                        "name": "Kwadijk",
                        "latitude": "52.52750000",
                        "longitude": "4.98110000"
                    },
                    {
                        "id": 149936,
                        "name": "Lambertschaag",
                        "latitude": "52.74580000",
                        "longitude": "5.01670000"
                    },
                    {
                        "id": 78268,
                        "name": "Landsmeer",
                        "latitude": "52.43083000",
                        "longitude": "4.91528000"
                    },
                    {
                        "id": 149937,
                        "name": "Langedijk",
                        "latitude": "52.69360000",
                        "longitude": "4.79440000"
                    },
                    {
                        "id": 78269,
                        "name": "Langeheit",
                        "latitude": "52.49200000",
                        "longitude": "4.75849000"
                    },
                    {
                        "id": 149938,
                        "name": "Langereis",
                        "latitude": "52.71111111",
                        "longitude": "4.90361111"
                    },
                    {
                        "id": 78274,
                        "name": "Laren",
                        "latitude": "52.25667000",
                        "longitude": "5.22778000"
                    },
                    {
                        "id": 149939,
                        "name": "Leimuiderbrug",
                        "latitude": "52.23083000",
                        "longitude": "4.66806000"
                    },
                    {
                        "id": 149940,
                        "name": "Lijnden",
                        "latitude": "52.35220000",
                        "longitude": "4.75970000"
                    },
                    {
                        "id": 78307,
                        "name": "Limmen",
                        "latitude": "52.56917000",
                        "longitude": "4.69444000"
                    },
                    {
                        "id": 78313,
                        "name": "Lisserbroek",
                        "latitude": "52.25667000",
                        "longitude": "4.57222000"
                    },
                    {
                        "id": 149941,
                        "name": "Loosdrecht",
                        "latitude": "52.20000000",
                        "longitude": "5.13333333"
                    },
                    {
                        "id": 78328,
                        "name": "Lutjebroek",
                        "latitude": "52.69750000",
                        "longitude": "5.20417000"
                    },
                    {
                        "id": 149942,
                        "name": "Lutjewinkel",
                        "latitude": "52.76890000",
                        "longitude": "4.88280000"
                    },
                    {
                        "id": 78352,
                        "name": "Marken",
                        "latitude": "52.45833000",
                        "longitude": "5.10278000"
                    },
                    {
                        "id": 149943,
                        "name": "Markenbinnen",
                        "latitude": "52.53080000",
                        "longitude": "4.78060000"
                    },
                    {
                        "id": 78365,
                        "name": "Medemblik",
                        "latitude": "52.77167000",
                        "longitude": "5.10556000"
                    },
                    {
                        "id": 149944,
                        "name": "Middelie",
                        "latitude": "52.53220000",
                        "longitude": "5.01720000"
                    },
                    {
                        "id": 78394,
                        "name": "Middenbeemster",
                        "latitude": "52.54917000",
                        "longitude": "4.91250000"
                    },
                    {
                        "id": 78395,
                        "name": "Middenmeer",
                        "latitude": "52.80667000",
                        "longitude": "4.99861000"
                    },
                    {
                        "id": 78397,
                        "name": "Midwoud",
                        "latitude": "52.71667000",
                        "longitude": "5.07500000"
                    },
                    {
                        "id": 149945,
                        "name": "Moerbeek",
                        "latitude": "52.76310000",
                        "longitude": "4.85280000"
                    },
                    {
                        "id": 78407,
                        "name": "Monnickendam",
                        "latitude": "52.45833000",
                        "longitude": "5.03750000"
                    },
                    {
                        "id": 78412,
                        "name": "Muiden",
                        "latitude": "52.33000000",
                        "longitude": "5.06944000"
                    },
                    {
                        "id": 78413,
                        "name": "Muiderberg",
                        "latitude": "52.32583000",
                        "longitude": "5.12083000"
                    },
                    {
                        "id": 149946,
                        "name": "Muyeveld",
                        "latitude": "52.18640000",
                        "longitude": "5.07170000"
                    },
                    {
                        "id": 78417,
                        "name": "Naarden",
                        "latitude": "52.29583000",
                        "longitude": "5.16250000"
                    },
                    {
                        "id": 149947,
                        "name": "Neck",
                        "latitude": "52.50830000",
                        "longitude": "4.91250000"
                    },
                    {
                        "id": 149948,
                        "name": "Nederhorst den Berg",
                        "latitude": "52.25670000",
                        "longitude": "5.04580000"
                    },
                    {
                        "id": 149949,
                        "name": "Nes aan de Amstel",
                        "latitude": "52.25940000",
                        "longitude": "4.87030000"
                    },
                    {
                        "id": 149950,
                        "name": "Nibbixwoud",
                        "latitude": "52.69280000",
                        "longitude": "5.05530000"
                    },
                    {
                        "id": 78434,
                        "name": "Nieuw-Loosdrecht",
                        "latitude": "52.19917000",
                        "longitude": "5.13889000"
                    },
                    {
                        "id": 149951,
                        "name": "Nieuw-Vennep",
                        "latitude": "52.26390000",
                        "longitude": "4.63750000"
                    },
                    {
                        "id": 149952,
                        "name": "Nieuwe Meer",
                        "latitude": "52.32640000",
                        "longitude": "4.81530000"
                    },
                    {
                        "id": 78440,
                        "name": "Nieuwe Niedorp",
                        "latitude": "52.74000000",
                        "longitude": "4.89861000"
                    },
                    {
                        "id": 149953,
                        "name": "Nieuwebrug",
                        "latitude": "52.37220000",
                        "longitude": "4.67360000"
                    },
                    {
                        "id": 149954,
                        "name": "Nieuwendam",
                        "latitude": "52.39150000",
                        "longitude": "4.93410000"
                    },
                    {
                        "id": 149955,
                        "name": "Nieuwesluis",
                        "latitude": "52.83560000",
                        "longitude": "4.89080000"
                    },
                    {
                        "id": 78462,
                        "name": "Noord-Scharwoude",
                        "latitude": "52.69833000",
                        "longitude": "4.81111000"
                    },
                    {
                        "id": 149956,
                        "name": "Noordbeemster",
                        "latitude": "52.58250000",
                        "longitude": "4.93670000"
                    },
                    {
                        "id": 149957,
                        "name": "Noordburen",
                        "latitude": "52.91940000",
                        "longitude": "4.96280000"
                    },
                    {
                        "id": 149958,
                        "name": "Noorddijk",
                        "latitude": "52.63333333",
                        "longitude": "4.91666667"
                    },
                    {
                        "id": 149959,
                        "name": "Noordeinde",
                        "latitude": "52.57190000",
                        "longitude": "4.83610000"
                    },
                    {
                        "id": 78479,
                        "name": "Obdam",
                        "latitude": "52.67583000",
                        "longitude": "4.90694000"
                    },
                    {
                        "id": 149960,
                        "name": "Omval",
                        "latitude": "52.34310000",
                        "longitude": "4.91640000"
                    },
                    {
                        "id": 78502,
                        "name": "Onderdijk",
                        "latitude": "52.74333000",
                        "longitude": "5.13750000"
                    },
                    {
                        "id": 149961,
                        "name": "Oost-Graftdijk",
                        "latitude": "52.54640000",
                        "longitude": "4.81470000"
                    },
                    {
                        "id": 78511,
                        "name": "Oosteinde",
                        "latitude": "52.27917000",
                        "longitude": "4.79583000"
                    },
                    {
                        "id": 149962,
                        "name": "Oosterdijk",
                        "latitude": "52.74470000",
                        "longitude": "5.26890000"
                    },
                    {
                        "id": 149963,
                        "name": "Oosterend",
                        "latitude": "53.08640000",
                        "longitude": "4.87610000"
                    },
                    {
                        "id": 149964,
                        "name": "Oosterland",
                        "latitude": "52.92920000",
                        "longitude": "5.01140000"
                    },
                    {
                        "id": 149965,
                        "name": "Oosterleek",
                        "latitude": "52.63830000",
                        "longitude": "5.19750000"
                    },
                    {
                        "id": 78525,
                        "name": "Oosterzij",
                        "latitude": "52.58500000",
                        "longitude": "4.70556000"
                    },
                    {
                        "id": 78526,
                        "name": "Oosthuizen",
                        "latitude": "52.57250000",
                        "longitude": "4.99583000"
                    },
                    {
                        "id": 149966,
                        "name": "Oostknollendam",
                        "latitude": "52.51720000",
                        "longitude": "4.79030000"
                    },
                    {
                        "id": 149967,
                        "name": "Oostwoud",
                        "latitude": "52.72440000",
                        "longitude": "5.09030000"
                    },
                    {
                        "id": 149968,
                        "name": "Oostzaan",
                        "latitude": "52.44060000",
                        "longitude": "4.87890000"
                    },
                    {
                        "id": 78538,
                        "name": "Opmeer",
                        "latitude": "52.70667000",
                        "longitude": "4.94444000"
                    },
                    {
                        "id": 78540,
                        "name": "Opperdoes",
                        "latitude": "52.75915000",
                        "longitude": "5.07534000"
                    },
                    {
                        "id": 149969,
                        "name": "Osdorp",
                        "latitude": "52.35694000",
                        "longitude": "4.80077000"
                    },
                    {
                        "id": 149970,
                        "name": "Oterleek",
                        "latitude": "52.63333333",
                        "longitude": "4.84166667"
                    },
                    {
                        "id": 78554,
                        "name": "Oud-Loosdrecht",
                        "latitude": "52.20667000",
                        "longitude": "5.08056000"
                    },
                    {
                        "id": 149971,
                        "name": "Oude Meer",
                        "latitude": "52.28750000",
                        "longitude": "4.78220000"
                    },
                    {
                        "id": 149972,
                        "name": "Oude Niedorp",
                        "latitude": "52.71780000",
                        "longitude": "4.87190000"
                    },
                    {
                        "id": 149973,
                        "name": "Oudendijk",
                        "latitude": "52.60000000",
                        "longitude": "4.96666667"
                    },
                    {
                        "id": 149974,
                        "name": "Ouder-Amstel",
                        "latitude": "52.29060000",
                        "longitude": "4.91170000"
                    },
                    {
                        "id": 78563,
                        "name": "Ouderkerk aan de Amstel",
                        "latitude": "52.29504000",
                        "longitude": "4.90746000"
                    },
                    {
                        "id": 78565,
                        "name": "Oudeschild",
                        "latitude": "53.03917000",
                        "longitude": "4.84722000"
                    },
                    {
                        "id": 149975,
                        "name": "Oudesluis",
                        "latitude": "52.83530000",
                        "longitude": "4.80640000"
                    },
                    {
                        "id": 78568,
                        "name": "Oudkarspel",
                        "latitude": "52.71583000",
                        "longitude": "4.80556000"
                    },
                    {
                        "id": 149976,
                        "name": "Oudorp",
                        "latitude": "52.63310000",
                        "longitude": "4.77360000"
                    },
                    {
                        "id": 149977,
                        "name": "Overleek",
                        "latitude": "52.45360000",
                        "longitude": "4.99580000"
                    },
                    {
                        "id": 149978,
                        "name": "Overmeer",
                        "latitude": "52.25420000",
                        "longitude": "5.04640000"
                    },
                    {
                        "id": 78574,
                        "name": "Overveen",
                        "latitude": "52.39167000",
                        "longitude": "4.61389000"
                    },
                    {
                        "id": 149979,
                        "name": "Penningsveer",
                        "latitude": "52.39280000",
                        "longitude": "4.67610000"
                    },
                    {
                        "id": 78588,
                        "name": "Petten",
                        "latitude": "52.76667000",
                        "longitude": "4.66111000"
                    },
                    {
                        "id": 78599,
                        "name": "Purmerend",
                        "latitude": "52.50500000",
                        "longitude": "4.95972000"
                    },
                    {
                        "id": 149980,
                        "name": "Purmerland",
                        "latitude": "52.47810000",
                        "longitude": "4.92170000"
                    },
                    {
                        "id": 149981,
                        "name": "Ransdorp",
                        "latitude": "52.39310000",
                        "longitude": "4.99420000"
                    },
                    {
                        "id": 149982,
                        "name": "Rijsenhout",
                        "latitude": "52.26060000",
                        "longitude": "4.71000000"
                    },
                    {
                        "id": 149983,
                        "name": "Risdam",
                        "latitude": "52.66139200",
                        "longitude": "5.05250900"
                    },
                    {
                        "id": 149984,
                        "name": "Ruigoord",
                        "latitude": "52.40920000",
                        "longitude": "4.74890000"
                    },
                    {
                        "id": 149985,
                        "name": "Rustenburg",
                        "latitude": "52.63470000",
                        "longitude": "4.87670000"
                    },
                    {
                        "id": 149986,
                        "name": "Santpoort",
                        "latitude": "52.42250000",
                        "longitude": "4.62610000"
                    },
                    {
                        "id": 78655,
                        "name": "Schagen",
                        "latitude": "52.78750000",
                        "longitude": "4.79861000"
                    },
                    {
                        "id": 78656,
                        "name": "Schagerbrug",
                        "latitude": "52.80250000",
                        "longitude": "4.75833000"
                    },
                    {
                        "id": 149987,
                        "name": "Schalkwijk",
                        "latitude": "52.35890000",
                        "longitude": "4.65560000"
                    },
                    {
                        "id": 149988,
                        "name": "Schardam",
                        "latitude": "52.59690000",
                        "longitude": "5.01690000"
                    },
                    {
                        "id": 149989,
                        "name": "Scharwoude",
                        "latitude": "52.62250000",
                        "longitude": "5.00810000"
                    },
                    {
                        "id": 149990,
                        "name": "Schellingwoude",
                        "latitude": "52.38440000",
                        "longitude": "4.96610000"
                    },
                    {
                        "id": 149991,
                        "name": "Schellinkhout",
                        "latitude": "52.63420000",
                        "longitude": "5.12030000"
                    },
                    {
                        "id": 78664,
                        "name": "Schermerhorn",
                        "latitude": "52.60083000",
                        "longitude": "4.89167000"
                    },
                    {
                        "id": 149992,
                        "name": "Schiphol-Rijk",
                        "latitude": "52.28000000",
                        "longitude": "4.75670000"
                    },
                    {
                        "id": 149993,
                        "name": "Schoorl",
                        "latitude": "52.70140000",
                        "longitude": "4.69440000"
                    },
                    {
                        "id": 149994,
                        "name": "Schoorldam",
                        "latitude": "52.70000000",
                        "longitude": "4.71666667"
                    },
                    {
                        "id": 149995,
                        "name": "Sijbekarspel",
                        "latitude": "52.70861111",
                        "longitude": "4.99055556"
                    },
                    {
                        "id": 149996,
                        "name": "Sint Maartenszee",
                        "latitude": "52.79250000",
                        "longitude": "4.68970000"
                    },
                    {
                        "id": 78702,
                        "name": "Sint Pancras",
                        "latitude": "52.66000000",
                        "longitude": "4.78333000"
                    },
                    {
                        "id": 78713,
                        "name": "Slootdorp",
                        "latitude": "52.84250000",
                        "longitude": "4.97222000"
                    },
                    {
                        "id": 149997,
                        "name": "Sloten",
                        "latitude": "52.34277778",
                        "longitude": "4.79638889"
                    },
                    {
                        "id": 149998,
                        "name": "Sloterdijk",
                        "latitude": "52.38722222",
                        "longitude": "4.84638889"
                    },
                    {
                        "id": 149999,
                        "name": "Slotermeer",
                        "latitude": "52.37832000",
                        "longitude": "4.82231000"
                    },
                    {
                        "id": 150000,
                        "name": "Slotervaart (former borough)",
                        "latitude": "52.35100000",
                        "longitude": "4.83400000"
                    },
                    {
                        "id": 150001,
                        "name": "Spaarndam-Oost",
                        "latitude": "52.41388889",
                        "longitude": "4.69000000"
                    },
                    {
                        "id": 150002,
                        "name": "Spaarndam-West",
                        "latitude": "52.41500000",
                        "longitude": "4.67690000"
                    },
                    {
                        "id": 150003,
                        "name": "Spaarnwoude",
                        "latitude": "52.40388889",
                        "longitude": "4.69416667"
                    },
                    {
                        "id": 150004,
                        "name": "Spanbroek",
                        "latitude": "52.69810000",
                        "longitude": "4.96080000"
                    },
                    {
                        "id": 78731,
                        "name": "Spierdijk",
                        "latitude": "52.65083000",
                        "longitude": "4.94306000"
                    },
                    {
                        "id": 150005,
                        "name": "Spijkerboor",
                        "latitude": "52.53830000",
                        "longitude": "4.83330000"
                    },
                    {
                        "id": 150006,
                        "name": "Starnmeer",
                        "latitude": "52.54190000",
                        "longitude": "4.79330000"
                    },
                    {
                        "id": 150007,
                        "name": "Stede Broec",
                        "latitude": "52.70060000",
                        "longitude": "5.22530000"
                    },
                    {
                        "id": 150008,
                        "name": "Stierop",
                        "latitude": "52.53330000",
                        "longitude": "4.77530000"
                    },
                    {
                        "id": 78761,
                        "name": "Stompetoren",
                        "latitude": "52.61333000",
                        "longitude": "4.82083000"
                    },
                    {
                        "id": 150009,
                        "name": "Stroe",
                        "latitude": "52.93333333",
                        "longitude": "4.98333333"
                    },
                    {
                        "id": 150010,
                        "name": "Stroet",
                        "latitude": "52.75000000",
                        "longitude": "4.75000000"
                    },
                    {
                        "id": 150011,
                        "name": "Terdiek",
                        "latitude": "52.72690000",
                        "longitude": "4.89690000"
                    },
                    {
                        "id": 150012,
                        "name": "Texel",
                        "latitude": "53.06666667",
                        "longitude": "4.80000000"
                    },
                    {
                        "id": 150013,
                        "name": "Tuindorp Oostzaan",
                        "latitude": "52.41135000",
                        "longitude": "4.89291100"
                    },
                    {
                        "id": 150014,
                        "name": "Tuitjenhorn",
                        "latitude": "52.73333333",
                        "longitude": "4.75000000"
                    },
                    {
                        "id": 78801,
                        "name": "Twisk",
                        "latitude": "52.74083000",
                        "longitude": "5.05278000"
                    },
                    {
                        "id": 150015,
                        "name": "Uitdam",
                        "latitude": "52.41917000",
                        "longitude": "5.07083000"
                    },
                    {
                        "id": 78811,
                        "name": "Uitgeest",
                        "latitude": "52.52917000",
                        "longitude": "4.70972000"
                    },
                    {
                        "id": 78812,
                        "name": "Uithoorn",
                        "latitude": "52.23750000",
                        "longitude": "4.82639000"
                    },
                    {
                        "id": 150016,
                        "name": "Ursem",
                        "latitude": "52.62720000",
                        "longitude": "4.89170000"
                    },
                    {
                        "id": 150017,
                        "name": "Valkkoog",
                        "latitude": "52.78333333",
                        "longitude": "4.76666667"
                    },
                    {
                        "id": 150018,
                        "name": "Van Ewijcksluis",
                        "latitude": "52.88330000",
                        "longitude": "4.87330000"
                    },
                    {
                        "id": 150019,
                        "name": "Vatrop",
                        "latitude": "52.93390000",
                        "longitude": "5.00530000"
                    },
                    {
                        "id": 150020,
                        "name": "Veenhuizen",
                        "latitude": "52.70250000",
                        "longitude": "4.89030000"
                    },
                    {
                        "id": 150021,
                        "name": "Velsen",
                        "latitude": "52.46666667",
                        "longitude": "4.61666667"
                    },
                    {
                        "id": 78843,
                        "name": "Velsen-Zuid",
                        "latitude": "52.46000000",
                        "longitude": "4.65000000"
                    },
                    {
                        "id": 150022,
                        "name": "Velserbroek",
                        "latitude": "52.43500000",
                        "longitude": "4.65720000"
                    },
                    {
                        "id": 150023,
                        "name": "Venhuizen",
                        "latitude": "52.66666667",
                        "longitude": "5.21666667"
                    },
                    {
                        "id": 78851,
                        "name": "Vijfhuizen",
                        "latitude": "52.35083000",
                        "longitude": "4.67778000"
                    },
                    {
                        "id": 150024,
                        "name": "Vinkebrug",
                        "latitude": "52.38670000",
                        "longitude": "4.72030000"
                    },
                    {
                        "id": 78866,
                        "name": "Vogelenzang",
                        "latitude": "52.31917000",
                        "longitude": "4.57778000"
                    },
                    {
                        "id": 78870,
                        "name": "Volendam",
                        "latitude": "52.49500000",
                        "longitude": "5.07083000"
                    },
                    {
                        "id": 78896,
                        "name": "Waarland",
                        "latitude": "52.72667000",
                        "longitude": "4.83194000"
                    },
                    {
                        "id": 150025,
                        "name": "Wadway",
                        "latitude": "52.69170000",
                        "longitude": "4.97970000"
                    },
                    {
                        "id": 150026,
                        "name": "Warder",
                        "latitude": "52.56410000",
                        "longitude": "5.03110000"
                    },
                    {
                        "id": 150027,
                        "name": "Warmenhuizen",
                        "latitude": "52.72250000",
                        "longitude": "4.73970000"
                    },
                    {
                        "id": 78910,
                        "name": "Waterakkers",
                        "latitude": "52.50440000",
                        "longitude": "4.65608000"
                    },
                    {
                        "id": 150028,
                        "name": "Watergang",
                        "latitude": "52.43333333",
                        "longitude": "4.95000000"
                    },
                    {
                        "id": 150029,
                        "name": "Watergraafsmeer",
                        "latitude": "52.34900000",
                        "longitude": "4.93800000"
                    },
                    {
                        "id": 150030,
                        "name": "Wateringskant",
                        "latitude": "52.76111111",
                        "longitude": "4.87361111"
                    },
                    {
                        "id": 150031,
                        "name": "Waterland",
                        "latitude": "52.45110000",
                        "longitude": "5.02000000"
                    },
                    {
                        "id": 150032,
                        "name": "Waver",
                        "latitude": "52.25290000",
                        "longitude": "4.90780000"
                    },
                    {
                        "id": 78915,
                        "name": "Weesp",
                        "latitude": "52.30750000",
                        "longitude": "5.04167000"
                    },
                    {
                        "id": 150033,
                        "name": "Weidevenne",
                        "latitude": "52.49716700",
                        "longitude": "4.93883300"
                    },
                    {
                        "id": 150034,
                        "name": "Wervershoof",
                        "latitude": "52.73470000",
                        "longitude": "5.14920000"
                    },
                    {
                        "id": 150035,
                        "name": "West-Graftdijk",
                        "latitude": "52.55390000",
                        "longitude": "4.79610000"
                    },
                    {
                        "id": 150036,
                        "name": "West-Knollendam",
                        "latitude": "52.51780000",
                        "longitude": "4.78640000"
                    },
                    {
                        "id": 150037,
                        "name": "Westbeemster",
                        "latitude": "52.57440000",
                        "longitude": "4.89860000"
                    },
                    {
                        "id": 150038,
                        "name": "Westerland",
                        "latitude": "52.89420000",
                        "longitude": "4.93080000"
                    },
                    {
                        "id": 78945,
                        "name": "Westwoud",
                        "latitude": "52.68500000",
                        "longitude": "5.13472000"
                    },
                    {
                        "id": 150039,
                        "name": "Westzaan",
                        "latitude": "52.46666667",
                        "longitude": "4.76666667"
                    },
                    {
                        "id": 150040,
                        "name": "Weteringbrug",
                        "latitude": "52.22250000",
                        "longitude": "4.64390000"
                    },
                    {
                        "id": 78947,
                        "name": "Wieringerwaard",
                        "latitude": "52.83583000",
                        "longitude": "4.86528000"
                    },
                    {
                        "id": 78948,
                        "name": "Wieringerwerf",
                        "latitude": "52.85083000",
                        "longitude": "5.02639000"
                    },
                    {
                        "id": 150041,
                        "name": "Wijdemeren",
                        "latitude": "52.23000000",
                        "longitude": "5.12000000"
                    },
                    {
                        "id": 78951,
                        "name": "Wijdenes",
                        "latitude": "52.63500000",
                        "longitude": "5.15694000"
                    },
                    {
                        "id": 150042,
                        "name": "Wijdewormer",
                        "latitude": "52.50024000",
                        "longitude": "4.89244000"
                    },
                    {
                        "id": 78953,
                        "name": "Wijk aan Zee",
                        "latitude": "52.49360000",
                        "longitude": "4.59409000"
                    },
                    {
                        "id": 150043,
                        "name": "Wimmenum",
                        "latitude": "52.63920000",
                        "longitude": "4.65580000"
                    },
                    {
                        "id": 78961,
                        "name": "Winkel",
                        "latitude": "52.75417000",
                        "longitude": "4.90278000"
                    },
                    {
                        "id": 150044,
                        "name": "Wognum",
                        "latitude": "52.68420000",
                        "longitude": "5.02080000"
                    },
                    {
                        "id": 150045,
                        "name": "Wormerland",
                        "latitude": "52.50860000",
                        "longitude": "4.87140000"
                    },
                    {
                        "id": 150046,
                        "name": "Wormerveer",
                        "latitude": "52.48333333",
                        "longitude": "4.78333333"
                    },
                    {
                        "id": 78993,
                        "name": "Zaandam",
                        "latitude": "52.43854000",
                        "longitude": "4.82643000"
                    },
                    {
                        "id": 78994,
                        "name": "Zaandijk",
                        "latitude": "52.47494000",
                        "longitude": "4.80686000"
                    },
                    {
                        "id": 78995,
                        "name": "Zaanstad",
                        "latitude": "52.45313000",
                        "longitude": "4.81356000"
                    },
                    {
                        "id": 78998,
                        "name": "Zandvoort",
                        "latitude": "52.37125000",
                        "longitude": "4.53306000"
                    },
                    {
                        "id": 79024,
                        "name": "Zuid-Scharwoude",
                        "latitude": "52.68667000",
                        "longitude": "4.80833000"
                    },
                    {
                        "id": 150047,
                        "name": "Zuidermeer",
                        "latitude": "52.66560000",
                        "longitude": "4.97580000"
                    },
                    {
                        "id": 150048,
                        "name": "Zwaag",
                        "latitude": "52.66860000",
                        "longitude": "5.07530000"
                    },
                    {
                        "id": 79033,
                        "name": "Zwaagdijk-Oost",
                        "latitude": "52.70750000",
                        "longitude": "5.14028000"
                    },
                    {
                        "id": 150049,
                        "name": "Zwaagdijk-West",
                        "latitude": "52.67580000",
                        "longitude": "5.05920000"
                    },
                    {
                        "id": 79034,
                        "name": "Zwaanshoek",
                        "latitude": "52.31250000",
                        "longitude": "4.61667000"
                    }
                ]
            },
            {
                "id": 2618,
                "name": "Overijssel",
                "iso2": "OV",
                "latitude": "52.43878140",
                "longitude": "6.50164110",
                "type": "province",
                "cities": [
                    {
                        "id": 77326,
                        "name": "Almelo",
                        "latitude": "52.35667000",
                        "longitude": "6.66250000"
                    },
                    {
                        "id": 77363,
                        "name": "Baalder",
                        "latitude": "52.58579000",
                        "longitude": "6.65299000"
                    },
                    {
                        "id": 77418,
                        "name": "Berkum",
                        "latitude": "52.52395000",
                        "longitude": "6.13655000"
                    },
                    {
                        "id": 77446,
                        "name": "Blokzijl",
                        "latitude": "52.72667000",
                        "longitude": "5.96111000"
                    },
                    {
                        "id": 77455,
                        "name": "Borgele",
                        "latitude": "52.27630000",
                        "longitude": "6.14926000"
                    },
                    {
                        "id": 77459,
                        "name": "Borne",
                        "latitude": "52.30136000",
                        "longitude": "6.74820000"
                    },
                    {
                        "id": 77462,
                        "name": "Boskamp",
                        "latitude": "52.33083000",
                        "longitude": "6.12778000"
                    },
                    {
                        "id": 77494,
                        "name": "Brunnepe",
                        "latitude": "52.56185000",
                        "longitude": "5.90343000"
                    },
                    {
                        "id": 77529,
                        "name": "Dalfsen",
                        "latitude": "52.51167000",
                        "longitude": "6.25694000"
                    },
                    {
                        "id": 77546,
                        "name": "De Hoven",
                        "latitude": "52.24901000",
                        "longitude": "6.14367000"
                    },
                    {
                        "id": 77566,
                        "name": "Delden",
                        "latitude": "52.26000000",
                        "longitude": "6.71111000"
                    },
                    {
                        "id": 77572,
                        "name": "Den Ham",
                        "latitude": "52.46583000",
                        "longitude": "6.49583000"
                    },
                    {
                        "id": 77576,
                        "name": "Deventer",
                        "latitude": "52.25500000",
                        "longitude": "6.16389000"
                    },
                    {
                        "id": 77578,
                        "name": "Diepenheim",
                        "latitude": "52.20000000",
                        "longitude": "6.55556000"
                    },
                    {
                        "id": 77662,
                        "name": "Enschede",
                        "latitude": "52.21833000",
                        "longitude": "6.89583000"
                    },
                    {
                        "id": 77677,
                        "name": "Flevowijk",
                        "latitude": "52.54583000",
                        "longitude": "5.91338000"
                    },
                    {
                        "id": 77679,
                        "name": "Frankhuis",
                        "latitude": "52.52500000",
                        "longitude": "6.06806000"
                    },
                    {
                        "id": 78032,
                        "name": "Giethoorn",
                        "latitude": "52.74000000",
                        "longitude": "6.07917000"
                    },
                    {
                        "id": 78040,
                        "name": "Goor",
                        "latitude": "52.23333000",
                        "longitude": "6.58611000"
                    },
                    {
                        "id": 78050,
                        "name": "Grafhorst",
                        "latitude": "52.58250000",
                        "longitude": "5.93333000"
                    },
                    {
                        "id": 78075,
                        "name": "Haaksbergen",
                        "latitude": "52.15667000",
                        "longitude": "6.73889000"
                    },
                    {
                        "id": 78080,
                        "name": "Haarle",
                        "latitude": "52.35917000",
                        "longitude": "6.38056000"
                    },
                    {
                        "id": 78091,
                        "name": "Hardenberg",
                        "latitude": "52.57583000",
                        "longitude": "6.61944000"
                    },
                    {
                        "id": 78099,
                        "name": "Hasselt",
                        "latitude": "52.59267000",
                        "longitude": "6.09527000"
                    },
                    {
                        "id": 78131,
                        "name": "Heino",
                        "latitude": "52.43661000",
                        "longitude": "6.23282000"
                    },
                    {
                        "id": 78140,
                        "name": "Hengelo",
                        "latitude": "52.26583000",
                        "longitude": "6.79306000"
                    },
                    {
                        "id": 78142,
                        "name": "Hengevelde",
                        "latitude": "52.19917000",
                        "longitude": "6.63611000"
                    },
                    {
                        "id": 78150,
                        "name": "Het Oostrik",
                        "latitude": "52.25000000",
                        "longitude": "6.21667000"
                    },
                    {
                        "id": 78213,
                        "name": "Kampen",
                        "latitude": "52.55500000",
                        "longitude": "5.91111000"
                    },
                    {
                        "id": 78236,
                        "name": "Klein Driene",
                        "latitude": "52.26935000",
                        "longitude": "6.81613000"
                    },
                    {
                        "id": 78323,
                        "name": "Losser",
                        "latitude": "52.26083000",
                        "longitude": "7.00417000"
                    },
                    {
                        "id": 78342,
                        "name": "Magele",
                        "latitude": "52.46917000",
                        "longitude": "6.52083000"
                    },
                    {
                        "id": 78351,
                        "name": "Markelo",
                        "latitude": "52.23500000",
                        "longitude": "6.49861000"
                    },
                    {
                        "id": 78375,
                        "name": "Mekkelholt",
                        "latitude": "52.23645000",
                        "longitude": "6.89058000"
                    },
                    {
                        "id": 78448,
                        "name": "Nieuwoord",
                        "latitude": "52.46667000",
                        "longitude": "6.55000000"
                    },
                    {
                        "id": 78456,
                        "name": "Nijrees",
                        "latitude": "52.33500000",
                        "longitude": "6.66389000"
                    },
                    {
                        "id": 78496,
                        "name": "Oldemarkt",
                        "latitude": "52.82083000",
                        "longitude": "5.97500000"
                    },
                    {
                        "id": 78497,
                        "name": "Oldenzaal",
                        "latitude": "52.31333000",
                        "longitude": "6.92917000"
                    },
                    {
                        "id": 78498,
                        "name": "Olst",
                        "latitude": "52.33750000",
                        "longitude": "6.10972000"
                    },
                    {
                        "id": 78500,
                        "name": "Ommen",
                        "latitude": "52.52083000",
                        "longitude": "6.42083000"
                    },
                    {
                        "id": 78517,
                        "name": "Oosterholt",
                        "latitude": "52.55917000",
                        "longitude": "5.95556000"
                    },
                    {
                        "id": 78522,
                        "name": "Oostermeenthe",
                        "latitude": "52.79319000",
                        "longitude": "6.13138000"
                    },
                    {
                        "id": 78530,
                        "name": "Ootmarsum",
                        "latitude": "52.40833000",
                        "longitude": "6.90139000"
                    },
                    {
                        "id": 78582,
                        "name": "Pathmos",
                        "latitude": "52.21397000",
                        "longitude": "6.87555000"
                    },
                    {
                        "id": 78589,
                        "name": "Pierik",
                        "latitude": "52.50141000",
                        "longitude": "6.11170000"
                    },
                    {
                        "id": 78604,
                        "name": "Raalte",
                        "latitude": "52.38583000",
                        "longitude": "6.27500000"
                    },
                    {
                        "id": 78640,
                        "name": "Rossum",
                        "latitude": "52.35167000",
                        "longitude": "6.92222000"
                    },
                    {
                        "id": 78658,
                        "name": "Schalkhaar",
                        "latitude": "52.26833000",
                        "longitude": "6.19444000"
                    },
                    {
                        "id": 78697,
                        "name": "Sint Jansklooster",
                        "latitude": "52.67750000",
                        "longitude": "6.00556000"
                    },
                    {
                        "id": 78745,
                        "name": "Staphorst",
                        "latitude": "52.64500000",
                        "longitude": "6.21111000"
                    },
                    {
                        "id": 78751,
                        "name": "Steenwijk",
                        "latitude": "52.78750000",
                        "longitude": "6.12083000"
                    },
                    {
                        "id": 78752,
                        "name": "Steenwijkerwold",
                        "latitude": "52.80417000",
                        "longitude": "6.06389000"
                    },
                    {
                        "id": 78792,
                        "name": "Tubbergen",
                        "latitude": "52.40750000",
                        "longitude": "6.78472000"
                    },
                    {
                        "id": 78795,
                        "name": "Tuk",
                        "latitude": "52.79667000",
                        "longitude": "6.09444000"
                    },
                    {
                        "id": 78797,
                        "name": "Twekkelerveld",
                        "latitude": "52.23064000",
                        "longitude": "6.86004000"
                    },
                    {
                        "id": 78872,
                        "name": "Vollenhove",
                        "latitude": "52.68083000",
                        "longitude": "5.95417000"
                    },
                    {
                        "id": 78886,
                        "name": "Vriezenveen",
                        "latitude": "52.40833000",
                        "longitude": "6.62222000"
                    },
                    {
                        "id": 78887,
                        "name": "Vroomshoop",
                        "latitude": "52.46083000",
                        "longitude": "6.56528000"
                    },
                    {
                        "id": 78936,
                        "name": "Westerhaar-Vriezenveensewijk",
                        "latitude": "52.45583000",
                        "longitude": "6.62361000"
                    },
                    {
                        "id": 78946,
                        "name": "Wierden",
                        "latitude": "52.35917000",
                        "longitude": "6.59306000"
                    },
                    {
                        "id": 78952,
                        "name": "Wijhe",
                        "latitude": "52.38667000",
                        "longitude": "6.13472000"
                    },
                    {
                        "id": 78980,
                        "name": "Woolde",
                        "latitude": "52.27210000",
                        "longitude": "6.75891000"
                    },
                    {
                        "id": 78981,
                        "name": "Wooldrik",
                        "latitude": "52.21667000",
                        "longitude": "6.91667000"
                    },
                    {
                        "id": 79023,
                        "name": "Zuid-Berghuizen",
                        "latitude": "52.30083000",
                        "longitude": "6.93333000"
                    },
                    {
                        "id": 79036,
                        "name": "Zwolle",
                        "latitude": "52.51250000",
                        "longitude": "6.09444000"
                    }
                ]
            },
            {
                "id": 2614,
                "name": "South Holland",
                "iso2": "ZH",
                "latitude": "51.99667920",
                "longitude": "4.55973970",
                "type": "province",
                "cities": [
                    {
                        "id": 77298,
                        "name": "'s-Gravenland",
                        "latitude": "51.92336000",
                        "longitude": "4.55315000"
                    },
                    {
                        "id": 77299,
                        "name": "'s-Gravenzande",
                        "latitude": "52.00167000",
                        "longitude": "4.16528000"
                    },
                    {
                        "id": 77317,
                        "name": "Adegeest",
                        "latitude": "52.13621000",
                        "longitude": "4.45249000"
                    },
                    {
                        "id": 77322,
                        "name": "Alblasserdam",
                        "latitude": "51.86583000",
                        "longitude": "4.66111000"
                    },
                    {
                        "id": 77330,
                        "name": "Alphen aan den Rijn",
                        "latitude": "52.12917000",
                        "longitude": "4.65546000"
                    },
                    {
                        "id": 77336,
                        "name": "Ammerstol",
                        "latitude": "51.92750000",
                        "longitude": "4.80833000"
                    },
                    {
                        "id": 77354,
                        "name": "Arkel",
                        "latitude": "51.86417000",
                        "longitude": "4.99444000"
                    },
                    {
                        "id": 77379,
                        "name": "Barendrecht",
                        "latitude": "51.85667000",
                        "longitude": "4.53472000"
                    },
                    {
                        "id": 77403,
                        "name": "Benthuizen",
                        "latitude": "52.07750000",
                        "longitude": "4.54444000"
                    },
                    {
                        "id": 77411,
                        "name": "Bergschenhoek",
                        "latitude": "51.99000000",
                        "longitude": "4.49861000"
                    },
                    {
                        "id": 77412,
                        "name": "Bergstoep",
                        "latitude": "51.92250000",
                        "longitude": "4.78472000"
                    },
                    {
                        "id": 77414,
                        "name": "Berkel en Rodenrijs",
                        "latitude": "51.99313000",
                        "longitude": "4.47865000"
                    },
                    {
                        "id": 77416,
                        "name": "Berkenwoude",
                        "latitude": "51.94500000",
                        "longitude": "4.70694000"
                    },
                    {
                        "id": 77432,
                        "name": "Binnenhof",
                        "latitude": "52.16418000",
                        "longitude": "4.53644000"
                    },
                    {
                        "id": 77439,
                        "name": "Bleiswijk",
                        "latitude": "52.01083000",
                        "longitude": "4.53194000"
                    },
                    {
                        "id": 77440,
                        "name": "Bleskensgraaf",
                        "latitude": "51.87250000",
                        "longitude": "4.78333000"
                    },
                    {
                        "id": 77444,
                        "name": "Bloemendaal",
                        "latitude": "52.02878000",
                        "longitude": "4.69440000"
                    },
                    {
                        "id": 77445,
                        "name": "Bloemhof",
                        "latitude": "51.89723000",
                        "longitude": "4.49943000"
                    },
                    {
                        "id": 77448,
                        "name": "Bodegraven",
                        "latitude": "52.08250000",
                        "longitude": "4.75000000"
                    },
                    {
                        "id": 77449,
                        "name": "Bodegraven-Reeuwijk",
                        "latitude": "52.06541000",
                        "longitude": "4.76634000"
                    },
                    {
                        "id": 77451,
                        "name": "Bolnes",
                        "latitude": "51.89500000",
                        "longitude": "4.57917000"
                    },
                    {
                        "id": 77463,
                        "name": "Boskoop",
                        "latitude": "52.07500000",
                        "longitude": "4.65556000"
                    },
                    {
                        "id": 77465,
                        "name": "Boven-Hardinxveld",
                        "latitude": "51.82333000",
                        "longitude": "4.88194000"
                    },
                    {
                        "id": 77480,
                        "name": "Brielle",
                        "latitude": "51.90167000",
                        "longitude": "4.16250000"
                    },
                    {
                        "id": 77511,
                        "name": "Capelle aan den IJssel",
                        "latitude": "51.92917000",
                        "longitude": "4.57778000"
                    },
                    {
                        "id": 77512,
                        "name": "Capelle-West",
                        "latitude": "51.91667000",
                        "longitude": "4.56667000"
                    },
                    {
                        "id": 77513,
                        "name": "Carnisse",
                        "latitude": "51.88932000",
                        "longitude": "4.47758000"
                    },
                    {
                        "id": 77547,
                        "name": "De Kieviet",
                        "latitude": "52.12333000",
                        "longitude": "4.35839000"
                    },
                    {
                        "id": 77551,
                        "name": "De Lier",
                        "latitude": "51.97500000",
                        "longitude": "4.24861000"
                    },
                    {
                        "id": 77556,
                        "name": "De Peulen",
                        "latitude": "51.82362000",
                        "longitude": "4.82165000"
                    },
                    {
                        "id": 77567,
                        "name": "Delfshaven",
                        "latitude": "51.90488000",
                        "longitude": "4.45315000"
                    },
                    {
                        "id": 77568,
                        "name": "Delft",
                        "latitude": "52.00667000",
                        "longitude": "4.35556000"
                    },
                    {
                        "id": 77584,
                        "name": "Dirksland",
                        "latitude": "51.74917000",
                        "longitude": "4.10000000"
                    },
                    {
                        "id": 77600,
                        "name": "Dordrecht",
                        "latitude": "51.81000000",
                        "longitude": "4.67361000"
                    },
                    {
                        "id": 77605,
                        "name": "Driebruggen",
                        "latitude": "52.04417000",
                        "longitude": "4.80000000"
                    },
                    {
                        "id": 77608,
                        "name": "Driemanspolder",
                        "latitude": "52.05176000",
                        "longitude": "4.48504000"
                    },
                    {
                        "id": 77615,
                        "name": "Duindorp",
                        "latitude": "52.09078000",
                        "longitude": "4.26038000"
                    },
                    {
                        "id": 77616,
                        "name": "Duinzigt",
                        "latitude": "52.10485000",
                        "longitude": "4.32494000"
                    },
                    {
                        "id": 77669,
                        "name": "Essesteijn",
                        "latitude": "52.08534000",
                        "longitude": "4.37263000"
                    },
                    {
                        "id": 77674,
                        "name": "Feijenoord",
                        "latitude": "51.91169000",
                        "longitude": "4.50645000"
                    },
                    {
                        "id": 78029,
                        "name": "Giessenburg",
                        "latitude": "51.85083000",
                        "longitude": "4.89028000"
                    },
                    {
                        "id": 78030,
                        "name": "Giessendam",
                        "latitude": "51.83257000",
                        "longitude": "4.83583000"
                    },
                    {
                        "id": 78036,
                        "name": "Goedereede",
                        "latitude": "51.81750000",
                        "longitude": "3.98056000"
                    },
                    {
                        "id": 78041,
                        "name": "Gorinchem",
                        "latitude": "51.83652000",
                        "longitude": "4.97243000"
                    },
                    {
                        "id": 78044,
                        "name": "Gouda",
                        "latitude": "52.01667000",
                        "longitude": "4.70833000"
                    },
                    {
                        "id": 78045,
                        "name": "Gouderak",
                        "latitude": "51.98417000",
                        "longitude": "4.67778000"
                    },
                    {
                        "id": 78046,
                        "name": "Goudswaard",
                        "latitude": "51.79417000",
                        "longitude": "4.27639000"
                    },
                    {
                        "id": 78048,
                        "name": "Gouwsluis",
                        "latitude": "52.11943000",
                        "longitude": "4.66899000"
                    },
                    {
                        "id": 78060,
                        "name": "Groenswaard",
                        "latitude": "52.05154000",
                        "longitude": "4.64541000"
                    },
                    {
                        "id": 78065,
                        "name": "Groot IJsselmonde",
                        "latitude": "51.88264000",
                        "longitude": "4.54937000"
                    },
                    {
                        "id": 78066,
                        "name": "Groot-Ammers",
                        "latitude": "51.92333000",
                        "longitude": "4.82361000"
                    },
                    {
                        "id": 78083,
                        "name": "Haastrecht",
                        "latitude": "52.00074000",
                        "longitude": "4.77639000"
                    },
                    {
                        "id": 78117,
                        "name": "Heerjansdam",
                        "latitude": "51.83583000",
                        "longitude": "4.56389000"
                    },
                    {
                        "id": 78128,
                        "name": "Heijplaat",
                        "latitude": "51.89333000",
                        "longitude": "4.42083000"
                    },
                    {
                        "id": 78134,
                        "name": "Hellevoetsluis",
                        "latitude": "51.83333000",
                        "longitude": "4.13333000"
                    },
                    {
                        "id": 78139,
                        "name": "Hendrik-Ido-Ambacht",
                        "latitude": "51.84417000",
                        "longitude": "4.63889000"
                    },
                    {
                        "id": 78157,
                        "name": "Hillegom",
                        "latitude": "52.29083000",
                        "longitude": "4.58333000"
                    },
                    {
                        "id": 78163,
                        "name": "Hoek van Holland",
                        "latitude": "51.97750000",
                        "longitude": "4.13333000"
                    },
                    {
                        "id": 78167,
                        "name": "Hoge Mors",
                        "latitude": "52.15616000",
                        "longitude": "4.46025000"
                    },
                    {
                        "id": 78174,
                        "name": "Honselersdijk",
                        "latitude": "52.00665000",
                        "longitude": "4.22441000"
                    },
                    {
                        "id": 78176,
                        "name": "Hoogblokland",
                        "latitude": "51.87500000",
                        "longitude": "4.97639000"
                    },
                    {
                        "id": 78184,
                        "name": "Hoogmade",
                        "latitude": "52.16917000",
                        "longitude": "4.58194000"
                    },
                    {
                        "id": 78216,
                        "name": "Katendrecht",
                        "latitude": "51.90074000",
                        "longitude": "4.48254000"
                    },
                    {
                        "id": 78218,
                        "name": "Katwijk aan den Rijn",
                        "latitude": "52.19417000",
                        "longitude": "4.42222000"
                    },
                    {
                        "id": 78217,
                        "name": "Katwijk aan Zee",
                        "latitude": "52.20333000",
                        "longitude": "4.39861000"
                    },
                    {
                        "id": 78226,
                        "name": "Kerkehout",
                        "latitude": "52.11018000",
                        "longitude": "4.37957000"
                    },
                    {
                        "id": 78232,
                        "name": "Kijkduin",
                        "latitude": "52.06765000",
                        "longitude": "4.22188000"
                    },
                    {
                        "id": 78233,
                        "name": "Klaaswaal",
                        "latitude": "51.77000000",
                        "longitude": "4.44583000"
                    },
                    {
                        "id": 78249,
                        "name": "Kop van Zuid",
                        "latitude": "51.90553000",
                        "longitude": "4.48706000"
                    },
                    {
                        "id": 78256,
                        "name": "Krimpen aan den IJssel",
                        "latitude": "51.91667000",
                        "longitude": "4.60278000"
                    },
                    {
                        "id": 78257,
                        "name": "Krimpenerwaard",
                        "latitude": "51.98171000",
                        "longitude": "4.77828000"
                    },
                    {
                        "id": 78263,
                        "name": "Kwintsheul",
                        "latitude": "52.01333000",
                        "longitude": "4.25556000"
                    },
                    {
                        "id": 78285,
                        "name": "Leiden",
                        "latitude": "52.15833000",
                        "longitude": "4.49306000"
                    },
                    {
                        "id": 78286,
                        "name": "Leiderdorp",
                        "latitude": "52.15833000",
                        "longitude": "4.52917000"
                    },
                    {
                        "id": 78287,
                        "name": "Leimuiden",
                        "latitude": "52.22417000",
                        "longitude": "4.66944000"
                    },
                    {
                        "id": 78303,
                        "name": "Liesveld",
                        "latitude": "51.93250000",
                        "longitude": "4.83194000"
                    },
                    {
                        "id": 78312,
                        "name": "Lisse",
                        "latitude": "52.26000000",
                        "longitude": "4.55694000"
                    },
                    {
                        "id": 78318,
                        "name": "Lombardijen",
                        "latitude": "51.87380000",
                        "longitude": "4.52192000"
                    },
                    {
                        "id": 78336,
                        "name": "Maasdijk",
                        "latitude": "51.95917000",
                        "longitude": "4.21389000"
                    },
                    {
                        "id": 78338,
                        "name": "Maasland",
                        "latitude": "51.93417000",
                        "longitude": "4.27222000"
                    },
                    {
                        "id": 78339,
                        "name": "Maassluis",
                        "latitude": "51.92333000",
                        "longitude": "4.25000000"
                    },
                    {
                        "id": 78382,
                        "name": "Merenwijk",
                        "latitude": "52.17655000",
                        "longitude": "4.50885000"
                    },
                    {
                        "id": 78389,
                        "name": "Middelharnis",
                        "latitude": "51.75750000",
                        "longitude": "4.16528000"
                    },
                    {
                        "id": 78391,
                        "name": "Middelsluis",
                        "latitude": "51.74250000",
                        "longitude": "4.44167000"
                    },
                    {
                        "id": 78400,
                        "name": "Mijnsheerenland",
                        "latitude": "51.79667000",
                        "longitude": "4.48750000"
                    },
                    {
                        "id": 78408,
                        "name": "Monster",
                        "latitude": "52.02583000",
                        "longitude": "4.17500000"
                    },
                    {
                        "id": 78416,
                        "name": "Naaldwijk",
                        "latitude": "51.99417000",
                        "longitude": "4.20972000"
                    },
                    {
                        "id": 78419,
                        "name": "Neder-Hardinxveld",
                        "latitude": "51.82879000",
                        "longitude": "4.85489000"
                    },
                    {
                        "id": 78430,
                        "name": "Nieuw-Beijerland",
                        "latitude": "51.81250000",
                        "longitude": "4.34306000"
                    },
                    {
                        "id": 78433,
                        "name": "Nieuw-Lekkerland",
                        "latitude": "51.88915000",
                        "longitude": "4.68653000"
                    },
                    {
                        "id": 78443,
                        "name": "Nieuwenhoorn",
                        "latitude": "51.85417000",
                        "longitude": "4.14306000"
                    },
                    {
                        "id": 78445,
                        "name": "Nieuwkoop",
                        "latitude": "52.15083000",
                        "longitude": "4.77639000"
                    },
                    {
                        "id": 78449,
                        "name": "Nieuwpoort",
                        "latitude": "51.93583000",
                        "longitude": "4.86806000"
                    },
                    {
                        "id": 78450,
                        "name": "Nieuwveen",
                        "latitude": "52.19667000",
                        "longitude": "4.75694000"
                    },
                    {
                        "id": 78458,
                        "name": "Nissewaard",
                        "latitude": "51.83716000",
                        "longitude": "4.27540000"
                    },
                    {
                        "id": 78461,
                        "name": "Noord-Hofland",
                        "latitude": "52.14059000",
                        "longitude": "4.45864000"
                    },
                    {
                        "id": 78465,
                        "name": "Noordeinde",
                        "latitude": "52.01667000",
                        "longitude": "4.48333000"
                    },
                    {
                        "id": 78466,
                        "name": "Noordeloos",
                        "latitude": "51.90333000",
                        "longitude": "4.94167000"
                    },
                    {
                        "id": 78470,
                        "name": "Noordwijk-Binnen",
                        "latitude": "52.23400000",
                        "longitude": "4.44474000"
                    },
                    {
                        "id": 78471,
                        "name": "Noordwijkerhout",
                        "latitude": "52.26167000",
                        "longitude": "4.49306000"
                    },
                    {
                        "id": 78475,
                        "name": "Numansdorp",
                        "latitude": "51.73167000",
                        "longitude": "4.43750000"
                    },
                    {
                        "id": 78485,
                        "name": "Oegstgeest",
                        "latitude": "52.18000000",
                        "longitude": "4.46944000"
                    },
                    {
                        "id": 78501,
                        "name": "Ommoord",
                        "latitude": "51.95951000",
                        "longitude": "4.54533000"
                    },
                    {
                        "id": 78509,
                        "name": "Oostdorp",
                        "latitude": "52.14994000",
                        "longitude": "4.39319000"
                    },
                    {
                        "id": 78529,
                        "name": "Oostvoorne",
                        "latitude": "51.91250000",
                        "longitude": "4.09861000"
                    },
                    {
                        "id": 78541,
                        "name": "Oranjewijk",
                        "latitude": "52.04922000",
                        "longitude": "4.65374000"
                    },
                    {
                        "id": 78552,
                        "name": "Oud-Beijerland",
                        "latitude": "51.82417000",
                        "longitude": "4.41250000"
                    },
                    {
                        "id": 78556,
                        "name": "Ouddorp",
                        "latitude": "51.81167000",
                        "longitude": "3.93472000"
                    },
                    {
                        "id": 78559,
                        "name": "Oude Wetering",
                        "latitude": "52.21417000",
                        "longitude": "4.64444000"
                    },
                    {
                        "id": 78564,
                        "name": "Ouderkerk aan den IJssel",
                        "latitude": "51.93417000",
                        "longitude": "4.63611000"
                    },
                    {
                        "id": 78573,
                        "name": "Overschie",
                        "latitude": "51.93863000",
                        "longitude": "4.42766000"
                    },
                    {
                        "id": 78575,
                        "name": "Palenstein",
                        "latitude": "52.05579000",
                        "longitude": "4.50869000"
                    },
                    {
                        "id": 78578,
                        "name": "Papendrecht",
                        "latitude": "51.83167000",
                        "longitude": "4.68750000"
                    },
                    {
                        "id": 78579,
                        "name": "Papenveer",
                        "latitude": "52.18500000",
                        "longitude": "4.72500000"
                    },
                    {
                        "id": 78586,
                        "name": "Pendrecht",
                        "latitude": "51.87152000",
                        "longitude": "4.46901000"
                    },
                    {
                        "id": 78587,
                        "name": "Pernis",
                        "latitude": "51.88833000",
                        "longitude": "4.38889000"
                    },
                    {
                        "id": 78590,
                        "name": "Piershil",
                        "latitude": "51.79333000",
                        "longitude": "4.31389000"
                    },
                    {
                        "id": 78591,
                        "name": "Pijnacker",
                        "latitude": "52.01954000",
                        "longitude": "4.42946000"
                    },
                    {
                        "id": 78592,
                        "name": "Poeldijk",
                        "latitude": "52.02417000",
                        "longitude": "4.21944000"
                    },
                    {
                        "id": 78611,
                        "name": "Reeuwijk",
                        "latitude": "52.04667000",
                        "longitude": "4.72500000"
                    },
                    {
                        "id": 78620,
                        "name": "Rhoon",
                        "latitude": "51.85750000",
                        "longitude": "4.42222000"
                    },
                    {
                        "id": 78621,
                        "name": "Ridderkerk",
                        "latitude": "51.87250000",
                        "longitude": "4.60278000"
                    },
                    {
                        "id": 78624,
                        "name": "Rijnsaterwoude",
                        "latitude": "52.19583000",
                        "longitude": "4.67083000"
                    },
                    {
                        "id": 78625,
                        "name": "Rijnsburg",
                        "latitude": "52.19000000",
                        "longitude": "4.44167000"
                    },
                    {
                        "id": 78626,
                        "name": "Rijpwetering",
                        "latitude": "52.19250000",
                        "longitude": "4.58333000"
                    },
                    {
                        "id": 78628,
                        "name": "Rijsoord",
                        "latitude": "51.85083000",
                        "longitude": "4.59583000"
                    },
                    {
                        "id": 78630,
                        "name": "Rijswijk",
                        "latitude": "52.03634000",
                        "longitude": "4.32501000"
                    },
                    {
                        "id": 78632,
                        "name": "Rockanje",
                        "latitude": "51.87167000",
                        "longitude": "4.07083000"
                    },
                    {
                        "id": 78634,
                        "name": "Roelofarendsveen",
                        "latitude": "52.20333000",
                        "longitude": "4.63333000"
                    },
                    {
                        "id": 78642,
                        "name": "Rotterdam",
                        "latitude": "51.92250000",
                        "longitude": "4.47917000"
                    },
                    {
                        "id": 78644,
                        "name": "Rozenburg",
                        "latitude": "51.90417000",
                        "longitude": "4.24861000"
                    },
                    {
                        "id": 78647,
                        "name": "Rugge",
                        "latitude": "51.89921000",
                        "longitude": "4.15231000"
                    },
                    {
                        "id": 78654,
                        "name": "Sassenheim",
                        "latitude": "52.22500000",
                        "longitude": "4.52222000"
                    },
                    {
                        "id": 78663,
                        "name": "Schelluinen",
                        "latitude": "51.84333000",
                        "longitude": "4.92639000"
                    },
                    {
                        "id": 78667,
                        "name": "Scheveningen",
                        "latitude": "52.10461000",
                        "longitude": "4.27557000"
                    },
                    {
                        "id": 78668,
                        "name": "Schiebroek",
                        "latitude": "51.95838000",
                        "longitude": "4.47124000"
                    },
                    {
                        "id": 78669,
                        "name": "Schiedam",
                        "latitude": "51.91917000",
                        "longitude": "4.38889000"
                    },
                    {
                        "id": 78677,
                        "name": "Schipluiden",
                        "latitude": "51.97583000",
                        "longitude": "4.31389000"
                    },
                    {
                        "id": 78680,
                        "name": "Schoonhoven",
                        "latitude": "51.94750000",
                        "longitude": "4.84861000"
                    },
                    {
                        "id": 78710,
                        "name": "Sliedrecht",
                        "latitude": "51.82083000",
                        "longitude": "4.77639000"
                    },
                    {
                        "id": 78711,
                        "name": "Slikkerveer",
                        "latitude": "51.88531000",
                        "longitude": "4.60494000"
                    },
                    {
                        "id": 78726,
                        "name": "Spangen",
                        "latitude": "51.91688000",
                        "longitude": "4.43539000"
                    },
                    {
                        "id": 78733,
                        "name": "Spijkenisse",
                        "latitude": "51.84500000",
                        "longitude": "4.32917000"
                    },
                    {
                        "id": 78734,
                        "name": "Spoorwijk",
                        "latitude": "52.05347000",
                        "longitude": "4.31339000"
                    },
                    {
                        "id": 78746,
                        "name": "Statenkwartier",
                        "latitude": "52.09311000",
                        "longitude": "4.27577000"
                    },
                    {
                        "id": 78755,
                        "name": "Stein",
                        "latitude": "52.00333000",
                        "longitude": "4.78194000"
                    },
                    {
                        "id": 78760,
                        "name": "Stolwijk",
                        "latitude": "51.97250000",
                        "longitude": "4.77361000"
                    },
                    {
                        "id": 78763,
                        "name": "Strijen",
                        "latitude": "51.74521000",
                        "longitude": "4.55083000"
                    },
                    {
                        "id": 78764,
                        "name": "Strijp",
                        "latitude": "52.03083000",
                        "longitude": "4.30139000"
                    },
                    {
                        "id": 78771,
                        "name": "Terbregge",
                        "latitude": "51.95328000",
                        "longitude": "4.51537000"
                    },
                    {
                        "id": 78779,
                        "name": "The Hague",
                        "latitude": "52.07667000",
                        "longitude": "4.29861000"
                    },
                    {
                        "id": 78794,
                        "name": "Tuindorp",
                        "latitude": "51.93032000",
                        "longitude": "4.37840000"
                    },
                    {
                        "id": 78828,
                        "name": "Valkenburg",
                        "latitude": "52.18000000",
                        "longitude": "4.43194000"
                    },
                    {
                        "id": 78850,
                        "name": "Vierpolders",
                        "latitude": "51.87917000",
                        "longitude": "4.17917000"
                    },
                    {
                        "id": 78855,
                        "name": "Vlaardingen",
                        "latitude": "51.91250000",
                        "longitude": "4.34167000"
                    },
                    {
                        "id": 78861,
                        "name": "Vlietwijk",
                        "latitude": "52.12436000",
                        "longitude": "4.45736000"
                    },
                    {
                        "id": 78868,
                        "name": "Vogelwijk",
                        "latitude": "52.07631000",
                        "longitude": "4.24790000"
                    },
                    {
                        "id": 78873,
                        "name": "Vondelwijk",
                        "latitude": "52.05497000",
                        "longitude": "4.65314000"
                    },
                    {
                        "id": 78874,
                        "name": "Voorburg",
                        "latitude": "52.07417000",
                        "longitude": "4.35972000"
                    },
                    {
                        "id": 78875,
                        "name": "Voorhout",
                        "latitude": "52.22167000",
                        "longitude": "4.48472000"
                    },
                    {
                        "id": 78876,
                        "name": "Voorschoten",
                        "latitude": "52.12750000",
                        "longitude": "4.44861000"
                    },
                    {
                        "id": 78883,
                        "name": "Vreewijk",
                        "latitude": "51.88428000",
                        "longitude": "4.51967000"
                    },
                    {
                        "id": 78895,
                        "name": "Waarder",
                        "latitude": "52.06083000",
                        "longitude": "4.82083000"
                    },
                    {
                        "id": 78897,
                        "name": "Waddinxveen",
                        "latitude": "52.04500000",
                        "longitude": "4.65139000"
                    },
                    {
                        "id": 78906,
                        "name": "Warmond",
                        "latitude": "52.19667000",
                        "longitude": "4.50278000"
                    },
                    {
                        "id": 78909,
                        "name": "Wassenaar",
                        "latitude": "52.14583000",
                        "longitude": "4.40278000"
                    },
                    {
                        "id": 78913,
                        "name": "Weerestein",
                        "latitude": "52.30381000",
                        "longitude": "4.58861000"
                    },
                    {
                        "id": 78916,
                        "name": "Weijpoort",
                        "latitude": "52.08167000",
                        "longitude": "4.80278000"
                    },
                    {
                        "id": 78944,
                        "name": "Westmaas",
                        "latitude": "51.78667000",
                        "longitude": "4.47500000"
                    },
                    {
                        "id": 78983,
                        "name": "Woubrugge",
                        "latitude": "52.17000000",
                        "longitude": "4.63611000"
                    },
                    {
                        "id": 78990,
                        "name": "Ypenburg",
                        "latitude": "52.04098000",
                        "longitude": "4.36981000"
                    },
                    {
                        "id": 79011,
                        "name": "Zevenhoven",
                        "latitude": "52.18167000",
                        "longitude": "4.77917000"
                    },
                    {
                        "id": 79016,
                        "name": "Zoetermeer",
                        "latitude": "52.05750000",
                        "longitude": "4.49306000"
                    },
                    {
                        "id": 79017,
                        "name": "Zoeterwoude-Dorp",
                        "latitude": "52.12000000",
                        "longitude": "4.49583000"
                    },
                    {
                        "id": 79022,
                        "name": "Zuid-Beijerland",
                        "latitude": "51.75083000",
                        "longitude": "4.36806000"
                    },
                    {
                        "id": 79029,
                        "name": "Zuidwijk",
                        "latitude": "51.87532000",
                        "longitude": "4.48514000"
                    },
                    {
                        "id": 79035,
                        "name": "Zwijndrecht",
                        "latitude": "51.81750000",
                        "longitude": "4.63333000"
                    }
                ]
            },
            {
                "id": 2610,
                "name": "Utrecht",
                "iso2": "UT",
                "latitude": "52.09073740",
                "longitude": "5.12142010",
                "type": "province",
                "cities": [
                    {
                        "id": 77314,
                        "name": "Abcoude",
                        "latitude": "52.27250000",
                        "longitude": "4.96944000"
                    },
                    {
                        "id": 77334,
                        "name": "Amerongen",
                        "latitude": "52.00250000",
                        "longitude": "5.45972000"
                    },
                    {
                        "id": 77335,
                        "name": "Amersfoort",
                        "latitude": "52.15500000",
                        "longitude": "5.38750000"
                    },
                    {
                        "id": 77360,
                        "name": "Austerlitz",
                        "latitude": "52.08000000",
                        "longitude": "5.31528000"
                    },
                    {
                        "id": 77364,
                        "name": "Baambrugge",
                        "latitude": "52.24583000",
                        "longitude": "4.98889000"
                    },
                    {
                        "id": 77368,
                        "name": "Baarn",
                        "latitude": "52.21167000",
                        "longitude": "5.28750000"
                    },
                    {
                        "id": 77461,
                        "name": "Bosch en Duin",
                        "latitude": "52.11667000",
                        "longitude": "5.24167000"
                    },
                    {
                        "id": 77479,
                        "name": "Breukelen",
                        "latitude": "52.17417000",
                        "longitude": "5.00139000"
                    },
                    {
                        "id": 77503,
                        "name": "Bunnik",
                        "latitude": "52.06667000",
                        "longitude": "5.19861000"
                    },
                    {
                        "id": 77504,
                        "name": "Bunschoten",
                        "latitude": "52.24304000",
                        "longitude": "5.37884000"
                    },
                    {
                        "id": 77524,
                        "name": "Cothen",
                        "latitude": "51.99667000",
                        "longitude": "5.30833000"
                    },
                    {
                        "id": 77532,
                        "name": "De Bilt",
                        "latitude": "52.11000000",
                        "longitude": "5.18056000"
                    },
                    {
                        "id": 77542,
                        "name": "De Hagen",
                        "latitude": "51.99381000",
                        "longitude": "5.10263000"
                    },
                    {
                        "id": 77560,
                        "name": "De Uithof",
                        "latitude": "52.08526000",
                        "longitude": "5.17456000"
                    },
                    {
                        "id": 77595,
                        "name": "Doorn",
                        "latitude": "52.03343000",
                        "longitude": "5.34571000"
                    },
                    {
                        "id": 77604,
                        "name": "Driebergen-Rijsenburg",
                        "latitude": "52.05333000",
                        "longitude": "5.28056000"
                    },
                    {
                        "id": 78058,
                        "name": "Groenekan",
                        "latitude": "52.12333000",
                        "longitude": "5.15278000"
                    },
                    {
                        "id": 78169,
                        "name": "Hollandsche Rading",
                        "latitude": "52.17500000",
                        "longitude": "5.17778000"
                    },
                    {
                        "id": 78189,
                        "name": "Houten",
                        "latitude": "52.02833000",
                        "longitude": "5.16806000"
                    },
                    {
                        "id": 78201,
                        "name": "IJsselstein",
                        "latitude": "52.02000000",
                        "longitude": "5.04306000"
                    },
                    {
                        "id": 78219,
                        "name": "Kedichem",
                        "latitude": "51.86000000",
                        "longitude": "5.05000000"
                    },
                    {
                        "id": 78223,
                        "name": "Kerckebosch",
                        "latitude": "52.07844000",
                        "longitude": "5.26584000"
                    },
                    {
                        "id": 78271,
                        "name": "Langenoord",
                        "latitude": "52.18768000",
                        "longitude": "5.38034000"
                    },
                    {
                        "id": 78279,
                        "name": "Leerdam",
                        "latitude": "51.89333000",
                        "longitude": "5.09167000"
                    },
                    {
                        "id": 78280,
                        "name": "Leersum",
                        "latitude": "52.01167000",
                        "longitude": "5.42778000"
                    },
                    {
                        "id": 78294,
                        "name": "Leusden",
                        "latitude": "52.13250000",
                        "longitude": "5.43194000"
                    },
                    {
                        "id": 78311,
                        "name": "Linschoten",
                        "latitude": "52.06250000",
                        "longitude": "4.91528000"
                    },
                    {
                        "id": 78321,
                        "name": "Lopik",
                        "latitude": "51.97250000",
                        "longitude": "4.94861000"
                    },
                    {
                        "id": 78326,
                        "name": "Lunetten",
                        "latitude": "52.06178000",
                        "longitude": "5.13474000"
                    },
                    {
                        "id": 78331,
                        "name": "Maarn",
                        "latitude": "52.06417000",
                        "longitude": "5.37083000"
                    },
                    {
                        "id": 78332,
                        "name": "Maarssen",
                        "latitude": "52.13917000",
                        "longitude": "5.04167000"
                    },
                    {
                        "id": 78333,
                        "name": "Maartensdijk",
                        "latitude": "52.15500000",
                        "longitude": "5.17500000"
                    },
                    {
                        "id": 78399,
                        "name": "Mijdrecht",
                        "latitude": "52.20667000",
                        "longitude": "4.86250000"
                    },
                    {
                        "id": 78409,
                        "name": "Montfoort",
                        "latitude": "52.04583000",
                        "longitude": "4.95278000"
                    },
                    {
                        "id": 78441,
                        "name": "Nieuwegein",
                        "latitude": "52.02917000",
                        "longitude": "5.08056000"
                    },
                    {
                        "id": 78451,
                        "name": "Nijenheim",
                        "latitude": "52.08689000",
                        "longitude": "5.21852000"
                    },
                    {
                        "id": 78482,
                        "name": "Odijk",
                        "latitude": "52.05250000",
                        "longitude": "5.23611000"
                    },
                    {
                        "id": 78504,
                        "name": "Oog in Al",
                        "latitude": "52.08636000",
                        "longitude": "5.08470000"
                    },
                    {
                        "id": 78567,
                        "name": "Oudewater",
                        "latitude": "52.02500000",
                        "longitude": "4.86806000"
                    },
                    {
                        "id": 78570,
                        "name": "Overberg",
                        "latitude": "52.04000000",
                        "longitude": "5.49444000"
                    },
                    {
                        "id": 78608,
                        "name": "Randenbroek",
                        "latitude": "52.14863000",
                        "longitude": "5.40120000"
                    },
                    {
                        "id": 78615,
                        "name": "Renswoude",
                        "latitude": "52.07333000",
                        "longitude": "5.54028000"
                    },
                    {
                        "id": 78619,
                        "name": "Rhenen",
                        "latitude": "51.95917000",
                        "longitude": "5.56806000"
                    },
                    {
                        "id": 78682,
                        "name": "Schoonrewoerd",
                        "latitude": "51.92083000",
                        "longitude": "5.11667000"
                    },
                    {
                        "id": 78719,
                        "name": "Soest",
                        "latitude": "52.17333000",
                        "longitude": "5.29167000"
                    },
                    {
                        "id": 78720,
                        "name": "Soestdijk",
                        "latitude": "52.19083000",
                        "longitude": "5.28472000"
                    },
                    {
                        "id": 78725,
                        "name": "Spakenburg",
                        "latitude": "52.25000000",
                        "longitude": "5.36667000"
                    },
                    {
                        "id": 78728,
                        "name": "Spechtenkamp",
                        "latitude": "52.13926000",
                        "longitude": "5.01758000"
                    },
                    {
                        "id": 78758,
                        "name": "Stichtse Vecht",
                        "latitude": "52.17679000",
                        "longitude": "5.01259000"
                    },
                    {
                        "id": 78822,
                        "name": "Utrecht",
                        "latitude": "52.09083000",
                        "longitude": "5.12222000"
                    },
                    {
                        "id": 78837,
                        "name": "Veenendaal",
                        "latitude": "52.02863000",
                        "longitude": "5.55891000"
                    },
                    {
                        "id": 78841,
                        "name": "Veldhuizen",
                        "latitude": "52.07537000",
                        "longitude": "5.01234000"
                    },
                    {
                        "id": 78849,
                        "name": "Vianen",
                        "latitude": "51.99250000",
                        "longitude": "5.09167000"
                    },
                    {
                        "id": 78854,
                        "name": "Vinkeveen",
                        "latitude": "52.21507000",
                        "longitude": "4.93372000"
                    },
                    {
                        "id": 78858,
                        "name": "Vleuten",
                        "latitude": "52.10583000",
                        "longitude": "5.01528000"
                    },
                    {
                        "id": 78882,
                        "name": "Vreeswijk",
                        "latitude": "52.01088000",
                        "longitude": "5.09285000"
                    },
                    {
                        "id": 78925,
                        "name": "Werkhoven",
                        "latitude": "52.02500000",
                        "longitude": "5.24444000"
                    },
                    {
                        "id": 78954,
                        "name": "Wijk bij Duurstede",
                        "latitude": "51.97417000",
                        "longitude": "5.34167000"
                    },
                    {
                        "id": 78960,
                        "name": "Wilnis",
                        "latitude": "52.19667000",
                        "longitude": "4.89722000"
                    },
                    {
                        "id": 78973,
                        "name": "Woerden",
                        "latitude": "52.08500000",
                        "longitude": "4.88333000"
                    },
                    {
                        "id": 78984,
                        "name": "Woudenberg",
                        "latitude": "52.08083000",
                        "longitude": "5.41667000"
                    },
                    {
                        "id": 79005,
                        "name": "Zeist",
                        "latitude": "52.09000000",
                        "longitude": "5.23333000"
                    }
                ]
            },
            {
                "id": 2620,
                "name": "Zeeland",
                "iso2": "ZE",
                "latitude": "51.49403090",
                "longitude": "3.84968150",
                "type": "province",
                "cities": [
                    {
                        "id": 77304,
                        "name": "Aagtekerke",
                        "latitude": "51.54667000",
                        "longitude": "3.50972000"
                    },
                    {
                        "id": 77311,
                        "name": "Aardenburg",
                        "latitude": "51.27333000",
                        "longitude": "3.44722000"
                    },
                    {
                        "id": 77355,
                        "name": "Arnemuiden",
                        "latitude": "51.50167000",
                        "longitude": "3.67500000"
                    },
                    {
                        "id": 77362,
                        "name": "Axel",
                        "latitude": "51.26667000",
                        "longitude": "3.90833000"
                    },
                    {
                        "id": 77460,
                        "name": "Borssele",
                        "latitude": "51.42333000",
                        "longitude": "3.73472000"
                    },
                    {
                        "id": 77477,
                        "name": "Breskens",
                        "latitude": "51.39583000",
                        "longitude": "3.55556000"
                    },
                    {
                        "id": 77488,
                        "name": "Brouwershaven",
                        "latitude": "51.72667000",
                        "longitude": "3.91250000"
                    },
                    {
                        "id": 77490,
                        "name": "Bruinisse",
                        "latitude": "51.66167000",
                        "longitude": "4.09444000"
                    },
                    {
                        "id": 77520,
                        "name": "Colijnsplaat",
                        "latitude": "51.59917000",
                        "longitude": "3.84861000"
                    },
                    {
                        "id": 77531,
                        "name": "Dauwendaele",
                        "latitude": "51.49299000",
                        "longitude": "3.62624000"
                    },
                    {
                        "id": 77589,
                        "name": "Domburg",
                        "latitude": "51.56333000",
                        "longitude": "3.49583000"
                    },
                    {
                        "id": 78037,
                        "name": "Goes",
                        "latitude": "51.50417000",
                        "longitude": "3.88889000"
                    },
                    {
                        "id": 78055,
                        "name": "Griffioen",
                        "latitude": "51.50548000",
                        "longitude": "3.59598000"
                    },
                    {
                        "id": 78057,
                        "name": "Grijpskerke",
                        "latitude": "51.53417000",
                        "longitude": "3.56111000"
                    },
                    {
                        "id": 78077,
                        "name": "Haamstede",
                        "latitude": "51.69682000",
                        "longitude": "3.74299000"
                    },
                    {
                        "id": 78195,
                        "name": "Hulst",
                        "latitude": "51.28000000",
                        "longitude": "4.05278000"
                    },
                    {
                        "id": 78202,
                        "name": "IJzendijke",
                        "latitude": "51.32167000",
                        "longitude": "3.61667000"
                    },
                    {
                        "id": 78214,
                        "name": "Kamperland",
                        "latitude": "51.57167000",
                        "longitude": "3.70417000"
                    },
                    {
                        "id": 78215,
                        "name": "Kapelle",
                        "latitude": "51.48627000",
                        "longitude": "3.95804000"
                    },
                    {
                        "id": 78234,
                        "name": "Klarenbeek",
                        "latitude": "51.50964000",
                        "longitude": "3.61132000"
                    },
                    {
                        "id": 78239,
                        "name": "Kloetinge",
                        "latitude": "51.49833000",
                        "longitude": "3.91528000"
                    },
                    {
                        "id": 78242,
                        "name": "Koewacht",
                        "latitude": "51.22833000",
                        "longitude": "3.97361000"
                    },
                    {
                        "id": 78253,
                        "name": "Koudekerke",
                        "latitude": "51.48167000",
                        "longitude": "3.55417000"
                    },
                    {
                        "id": 78266,
                        "name": "Lammerenburg",
                        "latitude": "51.46667000",
                        "longitude": "3.55833000"
                    },
                    {
                        "id": 78346,
                        "name": "Malta",
                        "latitude": "51.65000000",
                        "longitude": "3.93333000"
                    },
                    {
                        "id": 78378,
                        "name": "Meliskerke",
                        "latitude": "51.51417000",
                        "longitude": "3.50972000"
                    },
                    {
                        "id": 78388,
                        "name": "Middelburg",
                        "latitude": "51.50000000",
                        "longitude": "3.61389000"
                    },
                    {
                        "id": 78429,
                        "name": "Nieuw- en Sint Joosland",
                        "latitude": "51.48333000",
                        "longitude": "3.65694000"
                    },
                    {
                        "id": 78444,
                        "name": "Nieuwerkerk",
                        "latitude": "51.65083000",
                        "longitude": "4.00139000"
                    },
                    {
                        "id": 78508,
                        "name": "Oostburg",
                        "latitude": "51.32583000",
                        "longitude": "3.48750000"
                    },
                    {
                        "id": 78521,
                        "name": "Oosterland",
                        "latitude": "51.65000000",
                        "longitude": "4.03611000"
                    },
                    {
                        "id": 78527,
                        "name": "Oostkapelle",
                        "latitude": "51.56667000",
                        "longitude": "3.55139000"
                    },
                    {
                        "id": 78548,
                        "name": "Othene",
                        "latitude": "51.33083000",
                        "longitude": "3.85972000"
                    },
                    {
                        "id": 78555,
                        "name": "Oud-Vossemeer",
                        "latitude": "51.57083000",
                        "longitude": "4.19861000"
                    },
                    {
                        "id": 78593,
                        "name": "Poortvliet",
                        "latitude": "51.54417000",
                        "longitude": "4.14306000"
                    },
                    {
                        "id": 78613,
                        "name": "Renesse",
                        "latitude": "51.73250000",
                        "longitude": "3.77500000"
                    },
                    {
                        "id": 78653,
                        "name": "Sas van Gent",
                        "latitude": "51.22750000",
                        "longitude": "3.79861000"
                    },
                    {
                        "id": 78659,
                        "name": "Scharendijke",
                        "latitude": "51.73583000",
                        "longitude": "3.84306000"
                    },
                    {
                        "id": 78665,
                        "name": "Scherpenisse",
                        "latitude": "51.54667000",
                        "longitude": "4.10556000"
                    },
                    {
                        "id": 78678,
                        "name": "Schoondijke",
                        "latitude": "51.35417000",
                        "longitude": "3.55556000"
                    },
                    {
                        "id": 78683,
                        "name": "Schouwen-Duiveland",
                        "latitude": "51.69294000",
                        "longitude": "3.88676000"
                    },
                    {
                        "id": 78687,
                        "name": "Serooskerke",
                        "latitude": "51.54833000",
                        "longitude": "3.59444000"
                    },
                    {
                        "id": 78699,
                        "name": "Sint Laurens",
                        "latitude": "51.52750000",
                        "longitude": "3.60278000"
                    },
                    {
                        "id": 78703,
                        "name": "Sint Philipsland",
                        "latitude": "51.61667000",
                        "longitude": "4.16528000"
                    },
                    {
                        "id": 78714,
                        "name": "Sluis",
                        "latitude": "51.30833000",
                        "longitude": "3.38611000"
                    },
                    {
                        "id": 78715,
                        "name": "Sluiskil",
                        "latitude": "51.27833000",
                        "longitude": "3.83611000"
                    },
                    {
                        "id": 78747,
                        "name": "Stavenisse",
                        "latitude": "51.58750000",
                        "longitude": "4.01250000"
                    },
                    {
                        "id": 78774,
                        "name": "Terneuzen",
                        "latitude": "51.33583000",
                        "longitude": "3.82778000"
                    },
                    {
                        "id": 78781,
                        "name": "Tholen",
                        "latitude": "51.53167000",
                        "longitude": "4.22083000"
                    },
                    {
                        "id": 78862,
                        "name": "Vlissingen",
                        "latitude": "51.44250000",
                        "longitude": "3.57361000"
                    },
                    {
                        "id": 78893,
                        "name": "Waarde",
                        "latitude": "51.41750000",
                        "longitude": "4.06806000"
                    },
                    {
                        "id": 78923,
                        "name": "Wemeldinge",
                        "latitude": "51.51833000",
                        "longitude": "3.99722000"
                    },
                    {
                        "id": 78929,
                        "name": "West-Souburg",
                        "latitude": "51.46417000",
                        "longitude": "3.59167000"
                    },
                    {
                        "id": 78931,
                        "name": "Westdorpe",
                        "latitude": "51.23250000",
                        "longitude": "3.82639000"
                    },
                    {
                        "id": 78941,
                        "name": "Westerzicht",
                        "latitude": "51.46252000",
                        "longitude": "3.58687000"
                    },
                    {
                        "id": 78942,
                        "name": "Westkapelle",
                        "latitude": "51.52917000",
                        "longitude": "3.44028000"
                    },
                    {
                        "id": 78969,
                        "name": "Wissenkerke",
                        "latitude": "51.58500000",
                        "longitude": "3.74722000"
                    },
                    {
                        "id": 78977,
                        "name": "Wolphaartsdijk",
                        "latitude": "51.53167000",
                        "longitude": "3.81944000"
                    },
                    {
                        "id": 78989,
                        "name": "Yerseke",
                        "latitude": "51.49250000",
                        "longitude": "4.05000000"
                    },
                    {
                        "id": 78992,
                        "name": "Zaamslag",
                        "latitude": "51.31250000",
                        "longitude": "3.91250000"
                    },
                    {
                        "id": 79013,
                        "name": "Zierikzee",
                        "latitude": "51.65000000",
                        "longitude": "3.91944000"
                    },
                    {
                        "id": 79020,
                        "name": "Zoutelande",
                        "latitude": "51.50167000",
                        "longitude": "3.48472000"
                    }
                ]
            }
        ]
    },
    {
        "id": 157,
        "name": "New Caledonia",
        "iso3": "NCL",
        "iso2": "NC",
        "numeric_code": "540",
        "phonecode": "687",
        "capital": "Noumea",
        "currency": "XPF",
        "currency_name": "CFP franc",
        "currency_symbol": "₣",
        "tld": ".nc",
        "native": "Nouvelle-Calédonie",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Melanesia",
        "subregion_id": 20,
        "nationality": "New Caledonian",
        "timezones": [
            {
                "zoneName": "Pacific\/Noumea",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "NCT",
                "tzName": "New Caledonia Time"
            }
        ],
        "translations": {
            "br": "Kaledonia-Nevez",
            "ko": "누벨칼레도니",
            "pt-BR": "Nova Caledônia",
            "pt": "Nova Caledónia",
            "nl": "Nieuw-Caledonië",
            "hr": "Nova Kaledonija",
            "fa": "کالدونیای جدید",
            "de": "Neukaledonien",
            "es": "Nueva Caledonia",
            "fr": "Nouvelle-Calédonie",
            "ja": "ニューカレドニア",
            "it": "Nuova Caledonia",
            "zh-CN": "新喀里多尼亚",
            "tr": "Yeni Kaledonya",
            "ru": "Новая Каледония",
            "uk": "Нова Каледонія",
            "pl": "Nowa Kaledonia"
        },
        "latitude": "-21.50000000",
        "longitude": "165.50000000",
        "emoji": "🇳🇨",
        "emojiU": "U+1F1F3 U+1F1E8",
        "states": [
            {
                "id": 5227,
                "name": "Loyalty Islands Province",
                "iso2": "03",
                "latitude": "-20.96670000",
                "longitude": "167.23330000",
                "type": "province",
                "cities": [
                    {
                        "id": 153638,
                        "name": "Lifou",
                        "latitude": "-20.96670000",
                        "longitude": "167.23330000"
                    },
                    {
                        "id": 153639,
                        "name": "Maré",
                        "latitude": "-21.51670000",
                        "longitude": "167.98330000"
                    }
                ]
            },
            {
                "id": 5226,
                "name": "North Province",
                "iso2": "02",
                "latitude": "-20.58060150",
                "longitude": "164.19308100",
                "type": "province",
                "cities": [
                    {
                        "id": 153637,
                        "name": "Houaïlou",
                        "latitude": "-21.29090000",
                        "longitude": "165.62170000"
                    },
                    {
                        "id": 153635,
                        "name": "Koné",
                        "latitude": "-21.05900000",
                        "longitude": "164.85180000"
                    },
                    {
                        "id": 153636,
                        "name": "Poindimié",
                        "latitude": "-20.94960000",
                        "longitude": "165.32930000"
                    }
                ]
            },
            {
                "id": 5225,
                "name": "South Province",
                "iso2": "01",
                "latitude": "-22.01408610",
                "longitude": "165.01835610",
                "type": "province",
                "cities": [
                    {
                        "id": 153634,
                        "name": "Bourail",
                        "latitude": "-21.57010000",
                        "longitude": "165.48040000"
                    },
                    {
                        "id": 153632,
                        "name": "Dumbéa",
                        "latitude": "-22.15000000",
                        "longitude": "166.45000000"
                    },
                    {
                        "id": 153631,
                        "name": "Le Mont-Dore",
                        "latitude": "-22.21570000",
                        "longitude": "166.46650000"
                    },
                    {
                        "id": 153630,
                        "name": "Nouméa",
                        "latitude": "-22.27580000",
                        "longitude": "166.45800000"
                    },
                    {
                        "id": 153633,
                        "name": "Païta",
                        "latitude": "-22.13370000",
                        "longitude": "166.35050000"
                    }
                ]
            }
        ]
    },
    {
        "id": 158,
        "name": "New Zealand",
        "iso3": "NZL",
        "iso2": "NZ",
        "numeric_code": "554",
        "phonecode": "64",
        "capital": "Wellington",
        "currency": "NZD",
        "currency_name": "New Zealand dollar",
        "currency_symbol": "$",
        "tld": ".nz",
        "native": "New Zealand",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Australia and New Zealand",
        "subregion_id": 19,
        "nationality": "New Zealand, NZ",
        "timezones": [
            {
                "zoneName": "Pacific\/Auckland",
                "gmtOffset": 46800,
                "gmtOffsetName": "UTC+13:00",
                "abbreviation": "NZDT",
                "tzName": "New Zealand Daylight Time"
            },
            {
                "zoneName": "Pacific\/Chatham",
                "gmtOffset": 49500,
                "gmtOffsetName": "UTC+13:45",
                "abbreviation": "CHAST",
                "tzName": "Chatham Standard Time"
            }
        ],
        "translations": {
            "br": "Zeland-Nevez",
            "ko": "뉴질랜드",
            "pt-BR": "Nova Zelândia",
            "pt": "Nova Zelândia",
            "nl": "Nieuw-Zeeland",
            "hr": "Novi Zeland",
            "fa": "نیوزیلند",
            "de": "Neuseeland",
            "es": "Nueva Zelanda",
            "fr": "Nouvelle-Zélande",
            "ja": "ニュージーランド",
            "it": "Nuova Zelanda",
            "zh-CN": "新西兰",
            "tr": "Yeni Zelanda",
            "ru": "Новая Зеландия",
            "uk": "Нова Зеландія",
            "pl": "Nowa Zelandia"
        },
        "latitude": "-41.00000000",
        "longitude": "174.00000000",
        "emoji": "🇳🇿",
        "emojiU": "U+1F1F3 U+1F1FF",
        "states": [
            {
                "id": 4072,
                "name": "Auckland",
                "iso2": "AUK",
                "latitude": "-36.66753280",
                "longitude": "174.77333250",
                "type": "region",
                "cities": [
                    {
                        "id": 79773,
                        "name": "Auckland",
                        "latitude": "-36.84853000",
                        "longitude": "174.76349000"
                    },
                    {
                        "id": 79823,
                        "name": "Mangere",
                        "latitude": "-36.96807000",
                        "longitude": "174.79875000"
                    },
                    {
                        "id": 79824,
                        "name": "Manukau City",
                        "latitude": "-36.99282000",
                        "longitude": "174.87986000"
                    },
                    {
                        "id": 79833,
                        "name": "Muriwai Beach",
                        "latitude": "-36.81667000",
                        "longitude": "174.45000000"
                    },
                    {
                        "id": 79834,
                        "name": "Murrays Bay",
                        "latitude": "-36.72819000",
                        "longitude": "174.75019000"
                    },
                    {
                        "id": 79843,
                        "name": "North Shore",
                        "latitude": "-36.80000000",
                        "longitude": "174.75000000"
                    },
                    {
                        "id": 79852,
                        "name": "Pakuranga",
                        "latitude": "-36.88333000",
                        "longitude": "174.91667000"
                    },
                    {
                        "id": 79854,
                        "name": "Papakura",
                        "latitude": "-37.06573000",
                        "longitude": "174.94393000"
                    },
                    {
                        "id": 79856,
                        "name": "Parakai",
                        "latitude": "-36.65000000",
                        "longitude": "174.43333000"
                    },
                    {
                        "id": 79865,
                        "name": "Pukekohe East",
                        "latitude": "-37.20000000",
                        "longitude": "174.95000000"
                    },
                    {
                        "id": 79869,
                        "name": "Red Hill",
                        "latitude": "-37.05820000",
                        "longitude": "174.97019000"
                    },
                    {
                        "id": 79873,
                        "name": "Rosebank",
                        "latitude": "-36.87495000",
                        "longitude": "174.66991000"
                    },
                    {
                        "id": 79874,
                        "name": "Rothesay Bay",
                        "latitude": "-36.72602000",
                        "longitude": "174.74064000"
                    },
                    {
                        "id": 79885,
                        "name": "Takanini",
                        "latitude": "-37.04820000",
                        "longitude": "174.90019000"
                    },
                    {
                        "id": 79886,
                        "name": "Tamaki",
                        "latitude": "-36.88820000",
                        "longitude": "174.86019000"
                    },
                    {
                        "id": 79896,
                        "name": "Titirangi",
                        "latitude": "-36.93754000",
                        "longitude": "174.65584000"
                    },
                    {
                        "id": 79907,
                        "name": "Waitakere",
                        "latitude": "-36.91754000",
                        "longitude": "174.65773000"
                    },
                    {
                        "id": 79910,
                        "name": "Waiuku",
                        "latitude": "-37.24806000",
                        "longitude": "174.73489000"
                    },
                    {
                        "id": 79914,
                        "name": "Warkworth",
                        "latitude": "-36.40000000",
                        "longitude": "174.66667000"
                    },
                    {
                        "id": 79917,
                        "name": "Wellsford",
                        "latitude": "-36.28333000",
                        "longitude": "174.51667000"
                    },
                    {
                        "id": 79924,
                        "name": "Wiri",
                        "latitude": "-36.99820000",
                        "longitude": "174.86019000"
                    }
                ]
            },
            {
                "id": 4074,
                "name": "Bay of Plenty",
                "iso2": "BOP",
                "latitude": "-37.42339170",
                "longitude": "176.74163740",
                "type": "region",
                "cities": [
                    {
                        "id": 79791,
                        "name": "Edgecumbe",
                        "latitude": "-37.98333000",
                        "longitude": "176.83333000"
                    },
                    {
                        "id": 79809,
                        "name": "Katikati",
                        "latitude": "-37.55000000",
                        "longitude": "175.91667000"
                    },
                    {
                        "id": 79811,
                        "name": "Kawerau",
                        "latitude": "-38.10000000",
                        "longitude": "176.70000000"
                    },
                    {
                        "id": 79821,
                        "name": "Maketu",
                        "latitude": "-37.76667000",
                        "longitude": "176.45000000"
                    },
                    {
                        "id": 79835,
                        "name": "Murupara",
                        "latitude": "-38.46667000",
                        "longitude": "176.70000000"
                    },
                    {
                        "id": 79845,
                        "name": "Opotiki",
                        "latitude": "-38.00915000",
                        "longitude": "177.28706000"
                    },
                    {
                        "id": 79875,
                        "name": "Rotorua",
                        "latitude": "-38.13874000",
                        "longitude": "176.24516000"
                    },
                    {
                        "id": 79889,
                        "name": "Tauranga",
                        "latitude": "-37.68611000",
                        "longitude": "176.16667000"
                    },
                    {
                        "id": 79901,
                        "name": "Waihi Beach",
                        "latitude": "-37.40000000",
                        "longitude": "175.93333000"
                    },
                    {
                        "id": 79919,
                        "name": "Whakatane",
                        "latitude": "-37.95855000",
                        "longitude": "176.98545000"
                    }
                ]
            },
            {
                "id": 4066,
                "name": "Canterbury",
                "iso2": "CAN",
                "latitude": "-43.75422750",
                "longitude": "171.16372450",
                "type": "region",
                "cities": [
                    {
                        "id": 79769,
                        "name": "Amberley",
                        "latitude": "-43.15589000",
                        "longitude": "172.72975000"
                    },
                    {
                        "id": 79771,
                        "name": "Ashburton",
                        "latitude": "-43.89834000",
                        "longitude": "171.73011000"
                    },
                    {
                        "id": 79772,
                        "name": "Ashburton District",
                        "latitude": "-43.90000000",
                        "longitude": "171.75000000"
                    },
                    {
                        "id": 79780,
                        "name": "Burnham",
                        "latitude": "-43.61667000",
                        "longitude": "172.31667000"
                    },
                    {
                        "id": 79783,
                        "name": "Christchurch",
                        "latitude": "-43.53333000",
                        "longitude": "172.63333000"
                    },
                    {
                        "id": 79784,
                        "name": "Christchurch City",
                        "latitude": "-43.64578000",
                        "longitude": "172.74586000"
                    },
                    {
                        "id": 79788,
                        "name": "Darfield",
                        "latitude": "-43.48333000",
                        "longitude": "172.11667000"
                    },
                    {
                        "id": 79795,
                        "name": "Geraldine",
                        "latitude": "-44.09061000",
                        "longitude": "171.24458000"
                    },
                    {
                        "id": 79805,
                        "name": "Kaiapoi",
                        "latitude": "-43.37832000",
                        "longitude": "172.64013000"
                    },
                    {
                        "id": 79816,
                        "name": "Leeston",
                        "latitude": "-43.76667000",
                        "longitude": "172.30000000"
                    },
                    {
                        "id": 79818,
                        "name": "Lincoln",
                        "latitude": "-43.65000000",
                        "longitude": "172.48333000"
                    },
                    {
                        "id": 79820,
                        "name": "Mackenzie District",
                        "latitude": "-43.93987000",
                        "longitude": "170.51913000"
                    },
                    {
                        "id": 79829,
                        "name": "Methven",
                        "latitude": "-43.63333000",
                        "longitude": "171.65000000"
                    },
                    {
                        "id": 79849,
                        "name": "Oxford",
                        "latitude": "-43.30000000",
                        "longitude": "172.18333000"
                    },
                    {
                        "id": 79861,
                        "name": "Pleasant Point",
                        "latitude": "-44.26667000",
                        "longitude": "171.13333000"
                    },
                    {
                        "id": 79864,
                        "name": "Prebbleton",
                        "latitude": "-43.58333000",
                        "longitude": "172.51667000"
                    },
                    {
                        "id": 79868,
                        "name": "Rakaia",
                        "latitude": "-43.75000000",
                        "longitude": "172.01667000"
                    },
                    {
                        "id": 79872,
                        "name": "Rolleston",
                        "latitude": "-43.58333000",
                        "longitude": "172.38333000"
                    },
                    {
                        "id": 79877,
                        "name": "Selwyn District",
                        "latitude": "-43.32226000",
                        "longitude": "171.87064000"
                    },
                    {
                        "id": 79893,
                        "name": "Timaru",
                        "latitude": "-44.39672000",
                        "longitude": "171.25364000"
                    },
                    {
                        "id": 79894,
                        "name": "Timaru District",
                        "latitude": "-44.40000000",
                        "longitude": "171.21667000"
                    },
                    {
                        "id": 79895,
                        "name": "Tinwald",
                        "latitude": "-43.91667000",
                        "longitude": "171.71667000"
                    },
                    {
                        "id": 79902,
                        "name": "Waimakariri District",
                        "latitude": "-43.20750000",
                        "longitude": "172.33286000"
                    },
                    {
                        "id": 79925,
                        "name": "Woodend",
                        "latitude": "-43.31667000",
                        "longitude": "172.66667000"
                    }
                ]
            },
            {
                "id": 4067,
                "name": "Chatham Islands",
                "iso2": "CIT",
                "latitude": "-44.00575230",
                "longitude": "-176.54006740",
                "type": "special island authority",
                "cities": [
                    {
                        "id": 79908,
                        "name": "Waitangi",
                        "latitude": "-43.95353000",
                        "longitude": "-176.55973000"
                    }
                ]
            },
            {
                "id": 4068,
                "name": "Gisborne",
                "iso2": "GIS",
                "latitude": "-38.13581740",
                "longitude": "178.32393090",
                "type": "region",
                "cities": [
                    {
                        "id": 79796,
                        "name": "Gisborne",
                        "latitude": "-38.65333000",
                        "longitude": "178.00417000"
                    }
                ]
            },
            {
                "id": 4075,
                "name": "Hawke's Bay",
                "iso2": "HKB",
                "latitude": "-39.60165970",
                "longitude": "176.58044730",
                "type": "region",
                "cities": [
                    {
                        "id": 79800,
                        "name": "Hastings",
                        "latitude": "-39.63810000",
                        "longitude": "176.84918000"
                    },
                    {
                        "id": 79836,
                        "name": "Napier",
                        "latitude": "-39.49260000",
                        "longitude": "176.91233000"
                    },
                    {
                        "id": 79887,
                        "name": "Taradale",
                        "latitude": "-39.53333000",
                        "longitude": "176.85000000"
                    },
                    {
                        "id": 79906,
                        "name": "Wairoa",
                        "latitude": "-39.03333000",
                        "longitude": "177.36667000"
                    }
                ]
            },
            {
                "id": 4060,
                "name": "Manawatu-Wanganui",
                "iso2": "MWT",
                "latitude": "-39.72733560",
                "longitude": "175.43755740",
                "type": "region",
                "cities": [
                    {
                        "id": 79779,
                        "name": "Bulls",
                        "latitude": "-40.17487000",
                        "longitude": "175.38463000"
                    },
                    {
                        "id": 79794,
                        "name": "Foxton",
                        "latitude": "-40.46667000",
                        "longitude": "175.30000000"
                    },
                    {
                        "id": 79803,
                        "name": "Horowhenua District",
                        "latitude": "-40.57733000",
                        "longitude": "175.38071000"
                    },
                    {
                        "id": 79817,
                        "name": "Levin",
                        "latitude": "-40.63333000",
                        "longitude": "175.27500000"
                    },
                    {
                        "id": 79822,
                        "name": "Manawatu District",
                        "latitude": "-40.11979000",
                        "longitude": "175.67426000"
                    },
                    {
                        "id": 79853,
                        "name": "Palmerston North",
                        "latitude": "-40.35636000",
                        "longitude": "175.61113000"
                    },
                    {
                        "id": 79904,
                        "name": "Waiouru",
                        "latitude": "-39.47753000",
                        "longitude": "175.66834000"
                    },
                    {
                        "id": 79913,
                        "name": "Wanganui",
                        "latitude": "-39.93333000",
                        "longitude": "175.05000000"
                    }
                ]
            },
            {
                "id": 4063,
                "name": "Marlborough",
                "iso2": "MBH",
                "latitude": "-41.59168830",
                "longitude": "173.76240530",
                "type": "region",
                "cities": [
                    {
                        "id": 79775,
                        "name": "Blenheim",
                        "latitude": "-41.51603000",
                        "longitude": "173.95280000"
                    },
                    {
                        "id": 79860,
                        "name": "Picton",
                        "latitude": "-41.29067000",
                        "longitude": "174.00801000"
                    }
                ]
            },
            {
                "id": 4070,
                "name": "Nelson",
                "iso2": "NSN",
                "latitude": "-41.29853970",
                "longitude": "173.24414910",
                "type": "region",
                "cities": [
                    {
                        "id": 79837,
                        "name": "Nelson",
                        "latitude": "-41.27078000",
                        "longitude": "173.28404000"
                    }
                ]
            },
            {
                "id": 4059,
                "name": "Northland",
                "iso2": "NTL",
                "latitude": "-35.41361720",
                "longitude": "173.93208060",
                "type": "region",
                "cities": [
                    {
                        "id": 79768,
                        "name": "Ahipara",
                        "latitude": "-35.16667000",
                        "longitude": "173.16667000"
                    },
                    {
                        "id": 79789,
                        "name": "Dargaville",
                        "latitude": "-35.93333000",
                        "longitude": "173.88333000"
                    },
                    {
                        "id": 79793,
                        "name": "Far North District",
                        "latitude": "-35.03359000",
                        "longitude": "173.48841000"
                    },
                    {
                        "id": 79806,
                        "name": "Kaipara District",
                        "latitude": "-35.99546000",
                        "longitude": "174.04688000"
                    },
                    {
                        "id": 79807,
                        "name": "Kaitaia",
                        "latitude": "-35.11485000",
                        "longitude": "173.26366000"
                    },
                    {
                        "id": 79810,
                        "name": "Kawakawa",
                        "latitude": "-35.38333000",
                        "longitude": "174.06667000"
                    },
                    {
                        "id": 79813,
                        "name": "Kerikeri",
                        "latitude": "-35.22676000",
                        "longitude": "173.94739000"
                    },
                    {
                        "id": 79828,
                        "name": "Maungatapere",
                        "latitude": "-35.75000000",
                        "longitude": "174.20000000"
                    },
                    {
                        "id": 79831,
                        "name": "Moerewa",
                        "latitude": "-35.38333000",
                        "longitude": "174.03333000"
                    },
                    {
                        "id": 79842,
                        "name": "Ngunguru",
                        "latitude": "-35.61667000",
                        "longitude": "174.50000000"
                    },
                    {
                        "id": 79851,
                        "name": "Paihia",
                        "latitude": "-35.28067000",
                        "longitude": "174.09103000"
                    },
                    {
                        "id": 79876,
                        "name": "Ruakaka",
                        "latitude": "-35.90818000",
                        "longitude": "174.45019000"
                    },
                    {
                        "id": 79882,
                        "name": "Taipa",
                        "latitude": "-34.99604000",
                        "longitude": "173.46665000"
                    },
                    {
                        "id": 79903,
                        "name": "Waimate North",
                        "latitude": "-35.31667000",
                        "longitude": "173.88333000"
                    },
                    {
                        "id": 79921,
                        "name": "Whangarei",
                        "latitude": "-35.73167000",
                        "longitude": "174.32391000"
                    }
                ]
            },
            {
                "id": 4062,
                "name": "Otago",
                "iso2": "OTA",
                "latitude": "-45.47906710",
                "longitude": "170.15475670",
                "type": "region",
                "cities": [
                    {
                        "id": 79770,
                        "name": "Arrowtown",
                        "latitude": "-44.93837000",
                        "longitude": "168.81007000"
                    },
                    {
                        "id": 79774,
                        "name": "Balclutha",
                        "latitude": "-46.23389000",
                        "longitude": "169.75000000"
                    },
                    {
                        "id": 79785,
                        "name": "Clutha District",
                        "latitude": "-46.03883000",
                        "longitude": "169.60617000"
                    },
                    {
                        "id": 79787,
                        "name": "Cromwell",
                        "latitude": "-45.03837000",
                        "longitude": "169.20008000"
                    },
                    {
                        "id": 79790,
                        "name": "Dunedin",
                        "latitude": "-45.87416000",
                        "longitude": "170.50361000"
                    },
                    {
                        "id": 79815,
                        "name": "Kingston",
                        "latitude": "-45.33288000",
                        "longitude": "168.71476000"
                    },
                    {
                        "id": 79830,
                        "name": "Milton",
                        "latitude": "-46.12083000",
                        "longitude": "169.96944000"
                    },
                    {
                        "id": 79844,
                        "name": "Oamaru",
                        "latitude": "-45.09758000",
                        "longitude": "170.97087000"
                    },
                    {
                        "id": 79855,
                        "name": "Papatowai",
                        "latitude": "-46.56069000",
                        "longitude": "169.47068000"
                    },
                    {
                        "id": 79863,
                        "name": "Portobello",
                        "latitude": "-45.85000000",
                        "longitude": "170.65000000"
                    },
                    {
                        "id": 79866,
                        "name": "Queenstown",
                        "latitude": "-45.03023000",
                        "longitude": "168.66271000"
                    },
                    {
                        "id": 79912,
                        "name": "Wanaka",
                        "latitude": "-44.70000000",
                        "longitude": "169.15000000"
                    }
                ]
            },
            {
                "id": 4071,
                "name": "Southland",
                "iso2": "STL",
                "latitude": "-45.84891590",
                "longitude": "167.67553870",
                "type": "region",
                "cities": [
                    {
                        "id": 79776,
                        "name": "Bluff",
                        "latitude": "-46.60000000",
                        "longitude": "168.33333000"
                    },
                    {
                        "id": 79797,
                        "name": "Gore",
                        "latitude": "-46.10282000",
                        "longitude": "168.94357000"
                    },
                    {
                        "id": 79804,
                        "name": "Invercargill",
                        "latitude": "-46.40000000",
                        "longitude": "168.35000000"
                    },
                    {
                        "id": 79871,
                        "name": "Riverton",
                        "latitude": "-46.35000000",
                        "longitude": "168.01667000"
                    },
                    {
                        "id": 79881,
                        "name": "Southland District",
                        "latitude": "-45.77256000",
                        "longitude": "167.85266000"
                    },
                    {
                        "id": 79890,
                        "name": "Te Anau",
                        "latitude": "-45.41667000",
                        "longitude": "167.71667000"
                    },
                    {
                        "id": 79923,
                        "name": "Winton",
                        "latitude": "-46.15000000",
                        "longitude": "168.33333000"
                    }
                ]
            },
            {
                "id": 4069,
                "name": "Taranaki",
                "iso2": "TKI",
                "latitude": "-39.35381490",
                "longitude": "174.43827210",
                "type": "region",
                "cities": [
                    {
                        "id": 79792,
                        "name": "Eltham",
                        "latitude": "-39.42917000",
                        "longitude": "174.30000000"
                    },
                    {
                        "id": 79801,
                        "name": "Hawera",
                        "latitude": "-39.59167000",
                        "longitude": "174.28333000"
                    },
                    {
                        "id": 79838,
                        "name": "New Plymouth",
                        "latitude": "-39.06667000",
                        "longitude": "174.08333000"
                    },
                    {
                        "id": 79839,
                        "name": "New Plymouth District",
                        "latitude": "-39.05865000",
                        "longitude": "174.10309000"
                    },
                    {
                        "id": 79846,
                        "name": "Opunake",
                        "latitude": "-39.45556000",
                        "longitude": "173.85833000"
                    },
                    {
                        "id": 79858,
                        "name": "Patea",
                        "latitude": "-39.75833000",
                        "longitude": "174.48333000"
                    },
                    {
                        "id": 79878,
                        "name": "South Taranaki District",
                        "latitude": "-39.52156000",
                        "longitude": "174.37160000"
                    },
                    {
                        "id": 153921,
                        "name": "Stratford",
                        "latitude": "-39.32215170",
                        "longitude": "174.26298160"
                    },
                    {
                        "id": 79909,
                        "name": "Waitara",
                        "latitude": "-39.00158000",
                        "longitude": "174.23836000"
                    }
                ]
            },
            {
                "id": 4073,
                "name": "Tasman",
                "iso2": "TAS",
                "latitude": "-41.45711840",
                "longitude": "172.82097400",
                "type": "region",
                "cities": [
                    {
                        "id": 79777,
                        "name": "Brightwater",
                        "latitude": "-41.38333000",
                        "longitude": "173.11667000"
                    },
                    {
                        "id": 79825,
                        "name": "Mapua",
                        "latitude": "-41.25000000",
                        "longitude": "173.10000000"
                    },
                    {
                        "id": 79832,
                        "name": "Motueka",
                        "latitude": "-41.13333000",
                        "longitude": "173.01667000"
                    },
                    {
                        "id": 79870,
                        "name": "Richmond",
                        "latitude": "-41.33333000",
                        "longitude": "173.18333000"
                    },
                    {
                        "id": 79884,
                        "name": "Takaka",
                        "latitude": "-40.85000000",
                        "longitude": "172.80000000"
                    },
                    {
                        "id": 79911,
                        "name": "Wakefield",
                        "latitude": "-41.40000000",
                        "longitude": "173.05000000"
                    }
                ]
            },
            {
                "id": 4061,
                "name": "Waikato",
                "iso2": "WKO",
                "latitude": "-37.61908620",
                "longitude": "175.02334600",
                "type": "region",
                "cities": [
                    {
                        "id": 79781,
                        "name": "Cambridge",
                        "latitude": "-37.87822000",
                        "longitude": "175.44020000"
                    },
                    {
                        "id": 79786,
                        "name": "Coromandel",
                        "latitude": "-36.76110000",
                        "longitude": "175.49634000"
                    },
                    {
                        "id": 79799,
                        "name": "Hamilton",
                        "latitude": "-37.78333000",
                        "longitude": "175.28333000"
                    },
                    {
                        "id": 79827,
                        "name": "Matamata",
                        "latitude": "-37.81060000",
                        "longitude": "175.76237000"
                    },
                    {
                        "id": 79840,
                        "name": "Ngaruawahia",
                        "latitude": "-37.66738000",
                        "longitude": "175.15554000"
                    },
                    {
                        "id": 79841,
                        "name": "Ngatea",
                        "latitude": "-37.28333000",
                        "longitude": "175.50000000"
                    },
                    {
                        "id": 79848,
                        "name": "Otorohanga",
                        "latitude": "-38.18333000",
                        "longitude": "175.20000000"
                    },
                    {
                        "id": 79850,
                        "name": "Paeroa",
                        "latitude": "-37.36667000",
                        "longitude": "175.66667000"
                    },
                    {
                        "id": 79867,
                        "name": "Raglan",
                        "latitude": "-37.80000000",
                        "longitude": "174.88333000"
                    },
                    {
                        "id": 79879,
                        "name": "South Waikato District",
                        "latitude": "-38.16797000",
                        "longitude": "175.88624000"
                    },
                    {
                        "id": 79883,
                        "name": "Tairua",
                        "latitude": "-37.01667000",
                        "longitude": "175.85000000"
                    },
                    {
                        "id": 79888,
                        "name": "Taupo",
                        "latitude": "-38.68333000",
                        "longitude": "176.08333000"
                    },
                    {
                        "id": 79891,
                        "name": "Te Kauwhata",
                        "latitude": "-37.40000000",
                        "longitude": "175.15000000"
                    },
                    {
                        "id": 79892,
                        "name": "Thames",
                        "latitude": "-37.13832000",
                        "longitude": "175.54011000"
                    },
                    {
                        "id": 79897,
                        "name": "Tokoroa",
                        "latitude": "-38.23333000",
                        "longitude": "175.86667000"
                    },
                    {
                        "id": 79898,
                        "name": "Turangi",
                        "latitude": "-38.99037000",
                        "longitude": "175.80837000"
                    },
                    {
                        "id": 79900,
                        "name": "Waihi",
                        "latitude": "-37.38333000",
                        "longitude": "175.83333000"
                    },
                    {
                        "id": 79920,
                        "name": "Whangamata",
                        "latitude": "-37.20000000",
                        "longitude": "175.86667000"
                    },
                    {
                        "id": 79922,
                        "name": "Whitianga",
                        "latitude": "-36.83333000",
                        "longitude": "175.70000000"
                    }
                ]
            },
            {
                "id": 4065,
                "name": "Wellington",
                "iso2": "WGN",
                "latitude": "-41.02993230",
                "longitude": "175.43755740",
                "type": "region",
                "cities": [
                    {
                        "id": 79778,
                        "name": "Brooklyn",
                        "latitude": "-41.30586000",
                        "longitude": "174.76257000"
                    },
                    {
                        "id": 79782,
                        "name": "Castlepoint",
                        "latitude": "-40.90000000",
                        "longitude": "176.21667000"
                    },
                    {
                        "id": 79808,
                        "name": "Kapiti Coast District",
                        "latitude": "-40.85682000",
                        "longitude": "175.14690000"
                    },
                    {
                        "id": 79812,
                        "name": "Kelburn",
                        "latitude": "-41.28333000",
                        "longitude": "174.76667000"
                    },
                    {
                        "id": 79814,
                        "name": "Khandallah",
                        "latitude": "-41.24500000",
                        "longitude": "174.79422000"
                    },
                    {
                        "id": 79819,
                        "name": "Lower Hutt",
                        "latitude": "-41.21667000",
                        "longitude": "174.91667000"
                    },
                    {
                        "id": 79826,
                        "name": "Masterton",
                        "latitude": "-40.95972000",
                        "longitude": "175.65750000"
                    },
                    {
                        "id": 79847,
                        "name": "Otaki",
                        "latitude": "-40.75833000",
                        "longitude": "175.15000000"
                    },
                    {
                        "id": 79857,
                        "name": "Paraparaumu",
                        "latitude": "-40.91667000",
                        "longitude": "175.01667000"
                    },
                    {
                        "id": 79859,
                        "name": "Petone",
                        "latitude": "-41.22827000",
                        "longitude": "174.87019000"
                    },
                    {
                        "id": 79862,
                        "name": "Porirua",
                        "latitude": "-41.13333000",
                        "longitude": "174.85000000"
                    },
                    {
                        "id": 79880,
                        "name": "South Wairarapa District",
                        "latitude": "-41.26731000",
                        "longitude": "175.38442000"
                    },
                    {
                        "id": 79899,
                        "name": "Upper Hutt",
                        "latitude": "-41.13827000",
                        "longitude": "175.05020000"
                    },
                    {
                        "id": 79905,
                        "name": "Waipawa",
                        "latitude": "-41.41222000",
                        "longitude": "175.51528000"
                    },
                    {
                        "id": 79915,
                        "name": "Wellington",
                        "latitude": "-41.28664000",
                        "longitude": "174.77557000"
                    },
                    {
                        "id": 79916,
                        "name": "Wellington City",
                        "latitude": "-41.25300000",
                        "longitude": "174.75424000"
                    }
                ]
            },
            {
                "id": 4064,
                "name": "West Coast",
                "iso2": "WTC",
                "latitude": "62.41136340",
                "longitude": "-149.07297140",
                "type": "region",
                "cities": [
                    {
                        "id": 79798,
                        "name": "Greymouth",
                        "latitude": "-42.46667000",
                        "longitude": "171.20000000"
                    },
                    {
                        "id": 79802,
                        "name": "Hokitika",
                        "latitude": "-42.71667000",
                        "longitude": "170.96667000"
                    },
                    {
                        "id": 79918,
                        "name": "Westport",
                        "latitude": "-41.75262000",
                        "longitude": "171.60370000"
                    }
                ]
            }
        ]
    },
    {
        "id": 159,
        "name": "Nicaragua",
        "iso3": "NIC",
        "iso2": "NI",
        "numeric_code": "558",
        "phonecode": "505",
        "capital": "Managua",
        "currency": "NIO",
        "currency_name": "Nicaraguan córdoba",
        "currency_symbol": "C$",
        "tld": ".ni",
        "native": "Nicaragua",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Central America",
        "subregion_id": 9,
        "nationality": "Nicaraguan",
        "timezones": [
            {
                "zoneName": "America\/Managua",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Nicaragua",
            "ko": "니카라과",
            "pt-BR": "Nicarágua",
            "pt": "Nicarágua",
            "nl": "Nicaragua",
            "hr": "Nikaragva",
            "fa": "نیکاراگوئه",
            "de": "Nicaragua",
            "es": "Nicaragua",
            "fr": "Nicaragua",
            "ja": "ニカラグア",
            "it": "Nicaragua",
            "zh-CN": "尼加拉瓜",
            "tr": "Nikaragua",
            "ru": "Никарагуа",
            "uk": "Нікарагуа",
            "pl": "Nikaragua"
        },
        "latitude": "13.00000000",
        "longitude": "-85.00000000",
        "emoji": "🇳🇮",
        "emojiU": "U+1F1F3 U+1F1EE",
        "states": [
            {
                "id": 946,
                "name": "Boaco",
                "iso2": "BO",
                "latitude": "12.46928400",
                "longitude": "-85.66146820",
                "type": "department",
                "cities": [
                    {
                        "id": 77159,
                        "name": "Boaco",
                        "latitude": "12.47224000",
                        "longitude": "-85.65860000"
                    },
                    {
                        "id": 77163,
                        "name": "Camoapa",
                        "latitude": "12.38383000",
                        "longitude": "-85.51277000"
                    },
                    {
                        "id": 77260,
                        "name": "San José de los Remates",
                        "latitude": "12.59750000",
                        "longitude": "-85.76174000"
                    },
                    {
                        "id": 77265,
                        "name": "San Lorenzo",
                        "latitude": "12.37830000",
                        "longitude": "-85.66646000"
                    },
                    {
                        "id": 77273,
                        "name": "Santa Lucía",
                        "latitude": "12.53262000",
                        "longitude": "-85.71074000"
                    },
                    {
                        "id": 77285,
                        "name": "Teustepe",
                        "latitude": "12.42030000",
                        "longitude": "-85.79798000"
                    }
                ]
            },
            {
                "id": 950,
                "name": "Carazo",
                "iso2": "CA",
                "latitude": "11.72747290",
                "longitude": "-86.21584970",
                "type": "department",
                "cities": [
                    {
                        "id": 77176,
                        "name": "Diriamba",
                        "latitude": "11.85812000",
                        "longitude": "-86.23922000"
                    },
                    {
                        "id": 77179,
                        "name": "Dolores",
                        "latitude": "11.85672000",
                        "longitude": "-86.21552000"
                    },
                    {
                        "id": 77187,
                        "name": "El Rosario",
                        "latitude": "11.77756000",
                        "longitude": "-86.37374000"
                    },
                    {
                        "id": 77195,
                        "name": "Jinotepe",
                        "latitude": "11.84962000",
                        "longitude": "-86.19903000"
                    },
                    {
                        "id": 77202,
                        "name": "La Conquista",
                        "latitude": "11.73426000",
                        "longitude": "-86.19279000"
                    },
                    {
                        "id": 77206,
                        "name": "La Paz de Carazo",
                        "latitude": "11.82311000",
                        "longitude": "-86.12781000"
                    },
                    {
                        "id": 77236,
                        "name": "Municipio de San Marcos",
                        "latitude": "11.91784000",
                        "longitude": "-86.27474000"
                    },
                    {
                        "id": 77267,
                        "name": "San Marcos",
                        "latitude": "11.90949000",
                        "longitude": "-86.20351000"
                    },
                    {
                        "id": 77275,
                        "name": "Santa Teresa",
                        "latitude": "11.74321000",
                        "longitude": "-86.21413000"
                    }
                ]
            },
            {
                "id": 954,
                "name": "Chinandega",
                "iso2": "CI",
                "latitude": "12.88200620",
                "longitude": "-87.14228950",
                "type": "department",
                "cities": [
                    {
                        "id": 77165,
                        "name": "Chichigalpa",
                        "latitude": "12.57758000",
                        "longitude": "-87.02705000"
                    },
                    {
                        "id": 77166,
                        "name": "Chinandega",
                        "latitude": "12.62937000",
                        "longitude": "-87.13105000"
                    },
                    {
                        "id": 77167,
                        "name": "Cinco Pinos",
                        "latitude": "13.22956000",
                        "longitude": "-86.86808000"
                    },
                    {
                        "id": 77172,
                        "name": "Corinto",
                        "latitude": "12.48250000",
                        "longitude": "-87.17304000"
                    },
                    {
                        "id": 77186,
                        "name": "El Realejo",
                        "latitude": "12.54333000",
                        "longitude": "-87.16517000"
                    },
                    {
                        "id": 77190,
                        "name": "El Viejo",
                        "latitude": "12.66348000",
                        "longitude": "-87.16663000"
                    },
                    {
                        "id": 77196,
                        "name": "Jiquilillo",
                        "latitude": "12.74593000",
                        "longitude": "-87.45160000"
                    },
                    {
                        "id": 77232,
                        "name": "Municipio de San Francisco del Norte",
                        "latitude": "13.21187000",
                        "longitude": "-86.77107000"
                    },
                    {
                        "id": 77246,
                        "name": "Posoltega",
                        "latitude": "12.54422000",
                        "longitude": "-86.97982000"
                    },
                    {
                        "id": 77251,
                        "name": "Puerto Morazán",
                        "latitude": "12.85042000",
                        "longitude": "-87.17167000"
                    },
                    {
                        "id": 77278,
                        "name": "Santo Tomás del Norte",
                        "latitude": "13.18610000",
                        "longitude": "-86.92267000"
                    },
                    {
                        "id": 77280,
                        "name": "Somotillo",
                        "latitude": "13.04387000",
                        "longitude": "-86.90506000"
                    }
                ]
            },
            {
                "id": 940,
                "name": "Chontales",
                "iso2": "CO",
                "latitude": "11.93947170",
                "longitude": "-85.18940450",
                "type": "department",
                "cities": [
                    {
                        "id": 77155,
                        "name": "Acoyapa",
                        "latitude": "11.97028000",
                        "longitude": "-85.17113000"
                    },
                    {
                        "id": 77170,
                        "name": "Comalapa",
                        "latitude": "12.28345000",
                        "longitude": "-85.51081000"
                    },
                    {
                        "id": 77174,
                        "name": "Cuapa",
                        "latitude": "12.26875000",
                        "longitude": "-85.38205000"
                    },
                    {
                        "id": 77181,
                        "name": "El Ayote",
                        "latitude": "12.19046000",
                        "longitude": "-85.28737000"
                    },
                    {
                        "id": 77197,
                        "name": "Juigalpa",
                        "latitude": "12.10629000",
                        "longitude": "-85.36452000"
                    },
                    {
                        "id": 77204,
                        "name": "La Libertad",
                        "latitude": "12.21635000",
                        "longitude": "-85.16595000"
                    },
                    {
                        "id": 77276,
                        "name": "Santo Domingo",
                        "latitude": "12.26438000",
                        "longitude": "-85.08235000"
                    },
                    {
                        "id": 77277,
                        "name": "Santo Tomás",
                        "latitude": "12.06938000",
                        "longitude": "-85.09059000"
                    },
                    {
                        "id": 77293,
                        "name": "Villa Sandino",
                        "latitude": "12.04830000",
                        "longitude": "-84.99362000"
                    }
                ]
            },
            {
                "id": 945,
                "name": "Estelí",
                "iso2": "ES",
                "latitude": "13.08511390",
                "longitude": "-86.36301970",
                "type": "department",
                "cities": [
                    {
                        "id": 77171,
                        "name": "Condega",
                        "latitude": "13.36502000",
                        "longitude": "-86.39846000"
                    },
                    {
                        "id": 77191,
                        "name": "Estelí",
                        "latitude": "13.09185000",
                        "longitude": "-86.35384000"
                    },
                    {
                        "id": 77207,
                        "name": "La Trinidad",
                        "latitude": "12.96881000",
                        "longitude": "-86.23534000"
                    },
                    {
                        "id": 77249,
                        "name": "Pueblo Nuevo",
                        "latitude": "13.37984000",
                        "longitude": "-86.48075000"
                    },
                    {
                        "id": 77261,
                        "name": "San Juan de Limay",
                        "latitude": "13.17603000",
                        "longitude": "-86.61234000"
                    }
                ]
            },
            {
                "id": 943,
                "name": "Granada",
                "iso2": "GR",
                "latitude": "11.93440730",
                "longitude": "-85.95600050",
                "type": "department",
                "cities": [
                    {
                        "id": 77178,
                        "name": "Diriá",
                        "latitude": "11.88420000",
                        "longitude": "-86.05508000"
                    },
                    {
                        "id": 77177,
                        "name": "Diriomo",
                        "latitude": "11.87631000",
                        "longitude": "-86.05184000"
                    },
                    {
                        "id": 77192,
                        "name": "Granada",
                        "latitude": "11.92988000",
                        "longitude": "-85.95602000"
                    },
                    {
                        "id": 77240,
                        "name": "Nandaime",
                        "latitude": "11.75696000",
                        "longitude": "-86.05286000"
                    }
                ]
            },
            {
                "id": 955,
                "name": "Jinotega",
                "iso2": "JI",
                "latitude": "13.08839070",
                "longitude": "-85.99939970",
                "type": "department",
                "cities": [
                    {
                        "id": 77183,
                        "name": "El Cuá",
                        "latitude": "13.41667000",
                        "longitude": "-85.75000000"
                    },
                    {
                        "id": 77194,
                        "name": "Jinotega",
                        "latitude": "13.09103000",
                        "longitude": "-86.00234000"
                    },
                    {
                        "id": 77201,
                        "name": "La Concordia",
                        "latitude": "13.19528000",
                        "longitude": "-86.16659000"
                    },
                    {
                        "id": 77210,
                        "name": "Las Praderas",
                        "latitude": "13.17000000",
                        "longitude": "-85.85000000"
                    },
                    {
                        "id": 77199,
                        "name": "LLano de La Cruz",
                        "latitude": "13.12449000",
                        "longitude": "-86.00833000"
                    },
                    {
                        "id": 77258,
                        "name": "San José de Bocay",
                        "latitude": "13.54204000",
                        "longitude": "-85.53942000"
                    },
                    {
                        "id": 77269,
                        "name": "San Rafael del Norte",
                        "latitude": "13.21248000",
                        "longitude": "-86.11089000"
                    },
                    {
                        "id": 77272,
                        "name": "San Sebastián de Yalí",
                        "latitude": "13.30540000",
                        "longitude": "-86.18641000"
                    }
                ]
            },
            {
                "id": 944,
                "name": "León",
                "iso2": "LE",
                "latitude": "12.50920370",
                "longitude": "-86.66110830",
                "type": "department",
                "cities": [
                    {
                        "id": 77154,
                        "name": "Achuapa",
                        "latitude": "13.05370000",
                        "longitude": "-86.59004000"
                    },
                    {
                        "id": 77184,
                        "name": "El Jicaral",
                        "latitude": "12.72676000",
                        "longitude": "-86.38057000"
                    },
                    {
                        "id": 77188,
                        "name": "El Sauce",
                        "latitude": "12.88687000",
                        "longitude": "-86.53903000"
                    },
                    {
                        "id": 77205,
                        "name": "La Paz Centro",
                        "latitude": "12.34000000",
                        "longitude": "-86.67528000"
                    },
                    {
                        "id": 77209,
                        "name": "Larreynaga",
                        "latitude": "12.67692000",
                        "longitude": "-86.57193000"
                    },
                    {
                        "id": 77212,
                        "name": "León",
                        "latitude": "12.43787000",
                        "longitude": "-86.87804000"
                    },
                    {
                        "id": 77239,
                        "name": "Nagarote",
                        "latitude": "12.26593000",
                        "longitude": "-86.56474000"
                    },
                    {
                        "id": 77252,
                        "name": "Quezalguaque",
                        "latitude": "12.50683000",
                        "longitude": "-86.90292000"
                    },
                    {
                        "id": 77274,
                        "name": "Santa Rosa del Peñón",
                        "latitude": "12.80116000",
                        "longitude": "-86.36994000"
                    },
                    {
                        "id": 77282,
                        "name": "Telica",
                        "latitude": "12.52200000",
                        "longitude": "-86.85938000"
                    }
                ]
            },
            {
                "id": 948,
                "name": "Madriz",
                "iso2": "MD",
                "latitude": "13.47260050",
                "longitude": "-86.45920910",
                "type": "department",
                "cities": [
                    {
                        "id": 77211,
                        "name": "Las Sabanas",
                        "latitude": "13.34302000",
                        "longitude": "-86.62184000"
                    },
                    {
                        "id": 77245,
                        "name": "Palacagüina",
                        "latitude": "13.45566000",
                        "longitude": "-86.40622000"
                    },
                    {
                        "id": 77259,
                        "name": "San José de Cusmapa",
                        "latitude": "13.28841000",
                        "longitude": "-86.65539000"
                    },
                    {
                        "id": 77263,
                        "name": "San Juan de Río Coco",
                        "latitude": "13.54476000",
                        "longitude": "-86.16499000"
                    },
                    {
                        "id": 77266,
                        "name": "San Lucas",
                        "latitude": "13.41380000",
                        "longitude": "-86.61110000"
                    },
                    {
                        "id": 77281,
                        "name": "Somoto",
                        "latitude": "13.48082000",
                        "longitude": "-86.58208000"
                    },
                    {
                        "id": 77283,
                        "name": "Telpaneca",
                        "latitude": "13.53151000",
                        "longitude": "-86.28710000"
                    },
                    {
                        "id": 77290,
                        "name": "Totogalpa",
                        "latitude": "13.56284000",
                        "longitude": "-86.49254000"
                    },
                    {
                        "id": 77296,
                        "name": "Yalagüina",
                        "latitude": "13.48383000",
                        "longitude": "-86.49305000"
                    }
                ]
            },
            {
                "id": 941,
                "name": "Managua",
                "iso2": "MN",
                "latitude": "12.13916990",
                "longitude": "-86.33767610",
                "type": "department",
                "cities": [
                    {
                        "id": 77169,
                        "name": "Ciudad Sandino",
                        "latitude": "12.15889000",
                        "longitude": "-86.34417000"
                    },
                    {
                        "id": 77182,
                        "name": "El Crucero",
                        "latitude": "11.99008000",
                        "longitude": "-86.30954000"
                    },
                    {
                        "id": 77213,
                        "name": "Managua",
                        "latitude": "12.13282000",
                        "longitude": "-86.25040000"
                    },
                    {
                        "id": 77214,
                        "name": "Masachapa",
                        "latitude": "11.78687000",
                        "longitude": "-86.51416000"
                    },
                    {
                        "id": 77270,
                        "name": "San Rafael del Sur",
                        "latitude": "11.84854000",
                        "longitude": "-86.43839000"
                    },
                    {
                        "id": 77286,
                        "name": "Ticuantepe",
                        "latitude": "12.02263000",
                        "longitude": "-86.20493000"
                    },
                    {
                        "id": 77287,
                        "name": "Tipitapa",
                        "latitude": "12.19732000",
                        "longitude": "-86.09706000"
                    },
                    {
                        "id": 77291,
                        "name": "Valle San Francisco",
                        "latitude": "12.51667000",
                        "longitude": "-86.28333000"
                    },
                    {
                        "id": 77292,
                        "name": "Villa El Carmen",
                        "latitude": "11.98009000",
                        "longitude": "-86.50571000"
                    }
                ]
            },
            {
                "id": 953,
                "name": "Masaya",
                "iso2": "MS",
                "latitude": "11.97593280",
                "longitude": "-86.07334980",
                "type": "department",
                "cities": [
                    {
                        "id": 77164,
                        "name": "Catarina",
                        "latitude": "11.91197000",
                        "longitude": "-86.07383000"
                    },
                    {
                        "id": 77200,
                        "name": "La Concepción",
                        "latitude": "11.93711000",
                        "longitude": "-86.18976000"
                    },
                    {
                        "id": 77215,
                        "name": "Masatepe",
                        "latitude": "11.91445000",
                        "longitude": "-86.14458000"
                    },
                    {
                        "id": 77216,
                        "name": "Masaya",
                        "latitude": "11.97444000",
                        "longitude": "-86.09417000"
                    },
                    {
                        "id": 77226,
                        "name": "Municipio de Masatepe",
                        "latitude": "11.90567000",
                        "longitude": "-86.14946000"
                    },
                    {
                        "id": 77228,
                        "name": "Municipio de Nandasmo",
                        "latitude": "11.93333000",
                        "longitude": "-86.11667000"
                    },
                    {
                        "id": 77229,
                        "name": "Municipio de Niquinohomo",
                        "latitude": "11.88228000",
                        "longitude": "-86.10035000"
                    },
                    {
                        "id": 77234,
                        "name": "Municipio de San Juan de Oriente",
                        "latitude": "11.90517000",
                        "longitude": "-86.07460000"
                    },
                    {
                        "id": 77241,
                        "name": "Nandasmo",
                        "latitude": "11.92411000",
                        "longitude": "-86.12072000"
                    },
                    {
                        "id": 77242,
                        "name": "Nindirí",
                        "latitude": "12.00386000",
                        "longitude": "-86.12128000"
                    },
                    {
                        "id": 77243,
                        "name": "Niquinohomo",
                        "latitude": "11.90518000",
                        "longitude": "-86.09446000"
                    },
                    {
                        "id": 77262,
                        "name": "San Juan de Oriente",
                        "latitude": "11.90624000",
                        "longitude": "-86.07343000"
                    },
                    {
                        "id": 77288,
                        "name": "Tisma",
                        "latitude": "12.08194000",
                        "longitude": "-86.01739000"
                    }
                ]
            },
            {
                "id": 947,
                "name": "Matagalpa",
                "iso2": "MT",
                "latitude": "12.94984360",
                "longitude": "-85.43755740",
                "type": "department",
                "cities": [
                    {
                        "id": 77168,
                        "name": "Ciudad Darío",
                        "latitude": "12.73143000",
                        "longitude": "-86.12402000"
                    },
                    {
                        "id": 77217,
                        "name": "Matagalpa",
                        "latitude": "12.92559000",
                        "longitude": "-85.91747000"
                    },
                    {
                        "id": 77218,
                        "name": "Matiguás",
                        "latitude": "12.83734000",
                        "longitude": "-85.46218000"
                    },
                    {
                        "id": 77238,
                        "name": "Muy Muy",
                        "latitude": "12.76224000",
                        "longitude": "-85.62915000"
                    },
                    {
                        "id": 77254,
                        "name": "Río Blanco",
                        "latitude": "12.93435000",
                        "longitude": "-85.22354000"
                    },
                    {
                        "id": 77256,
                        "name": "San Dionisio",
                        "latitude": "12.76023000",
                        "longitude": "-85.85018000"
                    },
                    {
                        "id": 77271,
                        "name": "San Ramón",
                        "latitude": "12.92344000",
                        "longitude": "-85.83898000"
                    },
                    {
                        "id": 77284,
                        "name": "Terrabona",
                        "latitude": "12.73028000",
                        "longitude": "-85.96474000"
                    }
                ]
            },
            {
                "id": 951,
                "name": "North Caribbean Coast",
                "iso2": "AN",
                "latitude": "13.83944560",
                "longitude": "-83.93208060",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 77161,
                        "name": "Bonanza",
                        "latitude": "14.02885000",
                        "longitude": "-84.59103000"
                    },
                    {
                        "id": 77248,
                        "name": "Prinzapolka",
                        "latitude": "13.40708000",
                        "longitude": "-83.56452000"
                    },
                    {
                        "id": 77250,
                        "name": "Puerto Cabezas",
                        "latitude": "14.03507000",
                        "longitude": "-83.38882000"
                    },
                    {
                        "id": 77279,
                        "name": "Siuna",
                        "latitude": "13.73321000",
                        "longitude": "-84.77725000"
                    },
                    {
                        "id": 77294,
                        "name": "Waslala",
                        "latitude": "13.23333000",
                        "longitude": "-85.38333000"
                    },
                    {
                        "id": 77295,
                        "name": "Waspán",
                        "latitude": "14.74189000",
                        "longitude": "-83.97170000"
                    }
                ]
            },
            {
                "id": 4964,
                "name": "Nueva Segovia",
                "iso2": "NS",
                "latitude": "13.76570610",
                "longitude": "-86.53700390",
                "type": "department",
                "cities": [
                    {
                        "id": 149132,
                        "name": "Ciudad Antigua",
                        "latitude": "13.63929030",
                        "longitude": "-86.31189830"
                    },
                    {
                        "id": 149133,
                        "name": "Dipilto",
                        "latitude": "13.72225520",
                        "longitude": "-86.51366060"
                    },
                    {
                        "id": 149134,
                        "name": "El Jícaro",
                        "latitude": "13.72222480",
                        "longitude": "-86.14115420"
                    },
                    {
                        "id": 149135,
                        "name": "Jalapa",
                        "latitude": "13.92071420",
                        "longitude": "-86.14212330"
                    },
                    {
                        "id": 149136,
                        "name": "Macuelizo",
                        "latitude": "13.65192960",
                        "longitude": "-86.61427170"
                    },
                    {
                        "id": 149137,
                        "name": "Mozonte",
                        "latitude": "13.65956840",
                        "longitude": "-86.44536490"
                    },
                    {
                        "id": 149138,
                        "name": "Murra",
                        "latitude": "13.75927550",
                        "longitude": "-86.02196840"
                    },
                    {
                        "id": 149139,
                        "name": "Ocotal",
                        "latitude": "13.63411380",
                        "longitude": "-86.50107470"
                    },
                    {
                        "id": 149140,
                        "name": "Quilalí",
                        "latitude": "13.56491080",
                        "longitude": "-86.02921480"
                    },
                    {
                        "id": 149141,
                        "name": "San Fernando",
                        "latitude": "13.67873430",
                        "longitude": "-86.32079750"
                    },
                    {
                        "id": 149142,
                        "name": "Santa María",
                        "latitude": "13.74665480",
                        "longitude": "-86.71124070"
                    },
                    {
                        "id": 149143,
                        "name": "Wiwilí",
                        "latitude": "13.62076450",
                        "longitude": "-85.83169700"
                    }
                ]
            },
            {
                "id": 949,
                "name": "Río San Juan",
                "iso2": "SJ",
                "latitude": "11.47816100",
                "longitude": "-84.77333250",
                "type": "department",
                "cities": [
                    {
                        "id": 77180,
                        "name": "El Almendro",
                        "latitude": "11.67859000",
                        "longitude": "-84.70269000"
                    },
                    {
                        "id": 77193,
                        "name": "Greytown",
                        "latitude": "10.94684000",
                        "longitude": "-83.73467000"
                    },
                    {
                        "id": 77219,
                        "name": "Morrito",
                        "latitude": "11.62118000",
                        "longitude": "-85.08052000"
                    },
                    {
                        "id": 77255,
                        "name": "San Carlos",
                        "latitude": "11.12360000",
                        "longitude": "-84.77795000"
                    },
                    {
                        "id": 77268,
                        "name": "San Miguelito",
                        "latitude": "11.40255000",
                        "longitude": "-84.89991000"
                    }
                ]
            },
            {
                "id": 942,
                "name": "Rivas",
                "iso2": "RI",
                "latitude": "11.40234900",
                "longitude": "-85.68457800",
                "type": "department",
                "cities": [
                    {
                        "id": 77156,
                        "name": "Altagracia",
                        "latitude": "11.56615000",
                        "longitude": "-85.57840000"
                    },
                    {
                        "id": 77157,
                        "name": "Belén",
                        "latitude": "11.50299000",
                        "longitude": "-85.88935000"
                    },
                    {
                        "id": 77162,
                        "name": "Buenos Aires",
                        "latitude": "11.46916000",
                        "longitude": "-85.81661000"
                    },
                    {
                        "id": 77175,
                        "name": "Cárdenas",
                        "latitude": "11.19639000",
                        "longitude": "-85.50890000"
                    },
                    {
                        "id": 77220,
                        "name": "Moyogalpa",
                        "latitude": "11.54006000",
                        "longitude": "-85.69795000"
                    },
                    {
                        "id": 77222,
                        "name": "Municipio de Altagracia",
                        "latitude": "11.47983000",
                        "longitude": "-85.54166000"
                    },
                    {
                        "id": 77223,
                        "name": "Municipio de Belén",
                        "latitude": "11.57193000",
                        "longitude": "-85.96316000"
                    },
                    {
                        "id": 77224,
                        "name": "Municipio de Buenos Aires",
                        "latitude": "11.51760000",
                        "longitude": "-85.78333000"
                    },
                    {
                        "id": 77225,
                        "name": "Municipio de Cárdenas",
                        "latitude": "11.14912000",
                        "longitude": "-85.42323000"
                    },
                    {
                        "id": 77227,
                        "name": "Municipio de Moyogalpa",
                        "latitude": "11.52632000",
                        "longitude": "-85.67329000"
                    },
                    {
                        "id": 77230,
                        "name": "Municipio de Potosí",
                        "latitude": "11.57854000",
                        "longitude": "-85.87764000"
                    },
                    {
                        "id": 77231,
                        "name": "Municipio de Rivas",
                        "latitude": "11.43931000",
                        "longitude": "-85.82700000"
                    },
                    {
                        "id": 77233,
                        "name": "Municipio de San Jorge",
                        "latitude": "11.42703000",
                        "longitude": "-85.78904000"
                    },
                    {
                        "id": 77235,
                        "name": "Municipio de San Juan del Sur",
                        "latitude": "11.22368000",
                        "longitude": "-85.78289000"
                    },
                    {
                        "id": 77237,
                        "name": "Municipio de Tola",
                        "latitude": "11.46009000",
                        "longitude": "-86.00789000"
                    },
                    {
                        "id": 77247,
                        "name": "Potosí",
                        "latitude": "11.49416000",
                        "longitude": "-85.85680000"
                    },
                    {
                        "id": 77253,
                        "name": "Rivas",
                        "latitude": "11.43716000",
                        "longitude": "-85.82632000"
                    },
                    {
                        "id": 77257,
                        "name": "San Jorge",
                        "latitude": "11.45584000",
                        "longitude": "-85.80308000"
                    },
                    {
                        "id": 77264,
                        "name": "San Juan del Sur",
                        "latitude": "11.25292000",
                        "longitude": "-85.87049000"
                    },
                    {
                        "id": 77289,
                        "name": "Tola",
                        "latitude": "11.43927000",
                        "longitude": "-85.93891000"
                    }
                ]
            },
            {
                "id": 952,
                "name": "South Caribbean Coast",
                "iso2": "AS",
                "latitude": "12.19185020",
                "longitude": "-84.10128610",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 77158,
                        "name": "Bluefields",
                        "latitude": "12.01366000",
                        "longitude": "-83.76353000"
                    },
                    {
                        "id": 77160,
                        "name": "Bocana de Paiwas",
                        "latitude": "12.78571000",
                        "longitude": "-85.12269000"
                    },
                    {
                        "id": 77173,
                        "name": "Corn Island",
                        "latitude": "12.17575000",
                        "longitude": "-83.06145000"
                    },
                    {
                        "id": 77185,
                        "name": "El Rama",
                        "latitude": "12.15965000",
                        "longitude": "-84.21952000"
                    },
                    {
                        "id": 77189,
                        "name": "El Tortuguero",
                        "latitude": "12.82247000",
                        "longitude": "-84.19629000"
                    },
                    {
                        "id": 77198,
                        "name": "Kukrahill",
                        "latitude": "12.24096000",
                        "longitude": "-83.74517000"
                    },
                    {
                        "id": 77203,
                        "name": "La Cruz de Río Grande",
                        "latitude": "13.11290000",
                        "longitude": "-84.18588000"
                    },
                    {
                        "id": 77208,
                        "name": "Laguna de Perlas",
                        "latitude": "12.34294000",
                        "longitude": "-83.67123000"
                    },
                    {
                        "id": 77221,
                        "name": "Muelle de los Bueyes",
                        "latitude": "12.06999000",
                        "longitude": "-84.53503000"
                    },
                    {
                        "id": 77244,
                        "name": "Nueva Guinea",
                        "latitude": "11.68758000",
                        "longitude": "-84.45616000"
                    }
                ]
            }
        ]
    },
    {
        "id": 160,
        "name": "Niger",
        "iso3": "NER",
        "iso2": "NE",
        "numeric_code": "562",
        "phonecode": "227",
        "capital": "Niamey",
        "currency": "XOF",
        "currency_name": "West African CFA franc",
        "currency_symbol": "CFA",
        "tld": ".ne",
        "native": "Niger",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Nigerien",
        "timezones": [
            {
                "zoneName": "Africa\/Niamey",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "br": "Niger",
            "ko": "니제르",
            "pt-BR": "Níger",
            "pt": "Níger",
            "nl": "Niger",
            "hr": "Niger",
            "fa": "نیجر",
            "de": "Niger",
            "es": "Níger",
            "fr": "Niger",
            "ja": "ニジェール",
            "it": "Niger",
            "zh-CN": "尼日尔",
            "tr": "Nijer",
            "ru": "Нигер",
            "uk": "Нігер",
            "pl": "Niger"
        },
        "latitude": "16.00000000",
        "longitude": "8.00000000",
        "emoji": "🇳🇪",
        "emojiU": "U+1F1F3 U+1F1EA",
        "states": [
            {
                "id": 71,
                "name": "Agadez",
                "iso2": "1",
                "latitude": "20.66707520",
                "longitude": "12.07182810",
                "type": "region",
                "cities": [
                    {
                        "id": 76675,
                        "name": "Agadez",
                        "latitude": "16.97333000",
                        "longitude": "7.99111000"
                    },
                    {
                        "id": 76677,
                        "name": "Alaghsas",
                        "latitude": "17.01870000",
                        "longitude": "8.01680000"
                    },
                    {
                        "id": 76678,
                        "name": "Arlit",
                        "latitude": "18.83409000",
                        "longitude": "7.43327000"
                    },
                    {
                        "id": 76681,
                        "name": "Bilma",
                        "latitude": "18.68532000",
                        "longitude": "12.91643000"
                    },
                    {
                        "id": 76690,
                        "name": "Département de Bilma",
                        "latitude": "20.50000000",
                        "longitude": "13.25000000"
                    },
                    {
                        "id": 76711,
                        "name": "Département de Tchirozérine",
                        "latitude": "17.43293000",
                        "longitude": "7.89321000"
                    }
                ]
            },
            {
                "id": 72,
                "name": "Diffa",
                "iso2": "2",
                "latitude": "13.67686470",
                "longitude": "12.71351210",
                "type": "region",
                "cities": [
                    {
                        "id": 76694,
                        "name": "Département de Diffa",
                        "latitude": "13.66667000",
                        "longitude": "12.50000000"
                    },
                    {
                        "id": 76705,
                        "name": "Département de Maïné-Soroa",
                        "latitude": "13.31206000",
                        "longitude": "12.08321000"
                    },
                    {
                        "id": 76706,
                        "name": "Département de Nguigmi",
                        "latitude": "14.20753000",
                        "longitude": "13.12177000"
                    },
                    {
                        "id": 76686,
                        "name": "Diffa",
                        "latitude": "13.31536000",
                        "longitude": "12.61135000"
                    },
                    {
                        "id": 76729,
                        "name": "Maïné Soroa",
                        "latitude": "13.21139000",
                        "longitude": "12.02410000"
                    },
                    {
                        "id": 76731,
                        "name": "Nguigmi",
                        "latitude": "14.24953000",
                        "longitude": "13.10921000"
                    }
                ]
            },
            {
                "id": 68,
                "name": "Dosso",
                "iso2": "3",
                "latitude": "13.15139470",
                "longitude": "3.41955270",
                "type": "region",
                "cities": [
                    {
                        "id": 76683,
                        "name": "Boboye Department",
                        "latitude": "13.08167000",
                        "longitude": "2.91083000"
                    },
                    {
                        "id": 76695,
                        "name": "Département de Dogondoutchi",
                        "latitude": "13.50000000",
                        "longitude": "4.00000000"
                    },
                    {
                        "id": 76696,
                        "name": "Département de Dosso",
                        "latitude": "12.83333000",
                        "longitude": "3.33333000"
                    },
                    {
                        "id": 76698,
                        "name": "Département de Gaya",
                        "latitude": "11.95970000",
                        "longitude": "3.46045000"
                    },
                    {
                        "id": 76702,
                        "name": "Département de Loga",
                        "latitude": "13.63333000",
                        "longitude": "3.50000000"
                    },
                    {
                        "id": 76687,
                        "name": "Dogondoutchi",
                        "latitude": "13.64030000",
                        "longitude": "4.02649000"
                    },
                    {
                        "id": 76688,
                        "name": "Dosso",
                        "latitude": "13.04900000",
                        "longitude": "3.19370000"
                    },
                    {
                        "id": 76716,
                        "name": "Gaya",
                        "latitude": "11.88435000",
                        "longitude": "3.44919000"
                    }
                ]
            },
            {
                "id": 70,
                "name": "Maradi",
                "iso2": "4",
                "latitude": "13.80180740",
                "longitude": "7.43813550",
                "type": "region",
                "cities": [
                    {
                        "id": 76676,
                        "name": "Aguié",
                        "latitude": "13.50601000",
                        "longitude": "7.77863000"
                    },
                    {
                        "id": 76685,
                        "name": "Dakoro",
                        "latitude": "14.51056000",
                        "longitude": "6.76500000"
                    },
                    {
                        "id": 76714,
                        "name": "Département d’Aguié",
                        "latitude": "13.46976000",
                        "longitude": "7.74219000"
                    },
                    {
                        "id": 76693,
                        "name": "Département de Dakoro",
                        "latitude": "14.75000000",
                        "longitude": "7.00000000"
                    },
                    {
                        "id": 76704,
                        "name": "Département de Mayahi",
                        "latitude": "14.10000000",
                        "longitude": "7.60000000"
                    },
                    {
                        "id": 76712,
                        "name": "Département de Tessaoua",
                        "latitude": "13.60000000",
                        "longitude": "7.90000000"
                    },
                    {
                        "id": 76718,
                        "name": "Guidan Roumdji Department",
                        "latitude": "13.65750000",
                        "longitude": "6.69583000"
                    },
                    {
                        "id": 76724,
                        "name": "Madarounfa",
                        "latitude": "13.28253000",
                        "longitude": "7.15495000"
                    },
                    {
                        "id": 76726,
                        "name": "Maradi",
                        "latitude": "13.50000000",
                        "longitude": "7.10174000"
                    },
                    {
                        "id": 76728,
                        "name": "Mayahi",
                        "latitude": "13.95532000",
                        "longitude": "7.67122000"
                    },
                    {
                        "id": 76738,
                        "name": "Tessaoua",
                        "latitude": "13.75737000",
                        "longitude": "7.98740000"
                    },
                    {
                        "id": 76739,
                        "name": "Tibiri",
                        "latitude": "13.56271000",
                        "longitude": "7.04848000"
                    }
                ]
            },
            {
                "id": 73,
                "name": "Tahoua",
                "iso2": "5",
                "latitude": "16.09025430",
                "longitude": "5.39395510",
                "type": "region",
                "cities": [
                    {
                        "id": 76674,
                        "name": "Abalak",
                        "latitude": "15.41618000",
                        "longitude": "6.16975000"
                    },
                    {
                        "id": 76682,
                        "name": "Birni N Konni",
                        "latitude": "13.79599000",
                        "longitude": "5.25026000"
                    },
                    {
                        "id": 76684,
                        "name": "Bouza",
                        "latitude": "14.42293000",
                        "longitude": "6.04278000"
                    },
                    {
                        "id": 76689,
                        "name": "Département d' Illéla",
                        "latitude": "14.25000000",
                        "longitude": "5.00000000"
                    },
                    {
                        "id": 76691,
                        "name": "Département de Birni Nkonni",
                        "latitude": "13.90000000",
                        "longitude": "5.25000000"
                    },
                    {
                        "id": 76692,
                        "name": "Département de Bouza",
                        "latitude": "14.43333000",
                        "longitude": "6.00000000"
                    },
                    {
                        "id": 76701,
                        "name": "Département de Keïta",
                        "latitude": "14.80000000",
                        "longitude": "6.00000000"
                    },
                    {
                        "id": 76703,
                        "name": "Département de Madaoua",
                        "latitude": "13.99988000",
                        "longitude": "6.10012000"
                    },
                    {
                        "id": 76709,
                        "name": "Département de Tahoua",
                        "latitude": "14.80000000",
                        "longitude": "4.80000000"
                    },
                    {
                        "id": 76710,
                        "name": "Département de Tchin-Tabaraden",
                        "latitude": "15.86694000",
                        "longitude": "5.71042000"
                    },
                    {
                        "id": 76719,
                        "name": "Illéla",
                        "latitude": "14.46050000",
                        "longitude": "5.24370000"
                    },
                    {
                        "id": 76720,
                        "name": "Keïta",
                        "latitude": "14.75510000",
                        "longitude": "5.77490000"
                    },
                    {
                        "id": 76723,
                        "name": "Madaoua",
                        "latitude": "14.07300000",
                        "longitude": "5.96000000"
                    },
                    {
                        "id": 76734,
                        "name": "Tahoua",
                        "latitude": "14.88880000",
                        "longitude": "5.26920000"
                    },
                    {
                        "id": 76736,
                        "name": "Tchintabaraden",
                        "latitude": "15.89690000",
                        "longitude": "5.79850000"
                    }
                ]
            },
            {
                "id": 67,
                "name": "Tillabéri",
                "iso2": "6",
                "latitude": "14.64895250",
                "longitude": "2.14502450",
                "type": "region",
                "cities": [
                    {
                        "id": 76679,
                        "name": "Ayorou",
                        "latitude": "14.73075000",
                        "longitude": "0.91739000"
                    },
                    {
                        "id": 76680,
                        "name": "Balleyara",
                        "latitude": "13.72848000",
                        "longitude": "2.87503000"
                    },
                    {
                        "id": 76697,
                        "name": "Département de Filingué",
                        "latitude": "14.31645000",
                        "longitude": "3.23611000"
                    },
                    {
                        "id": 76707,
                        "name": "Département de Ouallam",
                        "latitude": "14.63333000",
                        "longitude": "2.25000000"
                    },
                    {
                        "id": 76708,
                        "name": "Département de Say",
                        "latitude": "13.03579000",
                        "longitude": "2.22112000"
                    },
                    {
                        "id": 76715,
                        "name": "Filingué",
                        "latitude": "14.35210000",
                        "longitude": "3.31680000"
                    },
                    {
                        "id": 76721,
                        "name": "Kollo",
                        "latitude": "13.30430000",
                        "longitude": "2.33900000"
                    },
                    {
                        "id": 76722,
                        "name": "Kollo Department",
                        "latitude": "13.57600000",
                        "longitude": "2.45200000"
                    },
                    {
                        "id": 76732,
                        "name": "Ouallam",
                        "latitude": "14.31641000",
                        "longitude": "2.08597000"
                    },
                    {
                        "id": 76733,
                        "name": "Say",
                        "latitude": "13.10070000",
                        "longitude": "2.36890000"
                    },
                    {
                        "id": 76742,
                        "name": "Téra",
                        "latitude": "14.00776000",
                        "longitude": "0.75306000"
                    },
                    {
                        "id": 76737,
                        "name": "Tera Department",
                        "latitude": "14.18600000",
                        "longitude": "0.84300000"
                    },
                    {
                        "id": 76741,
                        "name": "Tillabéri",
                        "latitude": "14.20711000",
                        "longitude": "1.45418000"
                    },
                    {
                        "id": 76740,
                        "name": "Tillaberi Department",
                        "latitude": "14.51600000",
                        "longitude": "1.44300000"
                    }
                ]
            },
            {
                "id": 69,
                "name": "Zinder",
                "iso2": "7",
                "latitude": "15.17188810",
                "longitude": "10.26001250",
                "type": "region",
                "cities": [
                    {
                        "id": 76699,
                        "name": "Département de Gouré",
                        "latitude": "14.01618000",
                        "longitude": "10.14722000"
                    },
                    {
                        "id": 76700,
                        "name": "Département de Kantché",
                        "latitude": "13.40000000",
                        "longitude": "8.60000000"
                    },
                    {
                        "id": 76713,
                        "name": "Département de Tânout",
                        "latitude": "14.75000000",
                        "longitude": "8.33333000"
                    },
                    {
                        "id": 76717,
                        "name": "Gouré",
                        "latitude": "13.98350000",
                        "longitude": "10.27035000"
                    },
                    {
                        "id": 76725,
                        "name": "Magaria",
                        "latitude": "12.99826000",
                        "longitude": "8.90991000"
                    },
                    {
                        "id": 76727,
                        "name": "Matamey",
                        "latitude": "13.42309000",
                        "longitude": "8.47485000"
                    },
                    {
                        "id": 76730,
                        "name": "Mirriah",
                        "latitude": "13.70727000",
                        "longitude": "9.15013000"
                    },
                    {
                        "id": 76735,
                        "name": "Tanout",
                        "latitude": "14.97089000",
                        "longitude": "8.88786000"
                    },
                    {
                        "id": 76743,
                        "name": "Zinder",
                        "latitude": "13.80716000",
                        "longitude": "8.98810000"
                    }
                ]
            }
        ]
    },
    {
        "id": 161,
        "name": "Nigeria",
        "iso3": "NGA",
        "iso2": "NG",
        "numeric_code": "566",
        "phonecode": "234",
        "capital": "Abuja",
        "currency": "NGN",
        "currency_name": "Nigerian naira",
        "currency_symbol": "₦",
        "tld": ".ng",
        "native": "Nigeria",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Nigerian",
        "timezones": [
            {
                "zoneName": "Africa\/Lagos",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "br": "Nigeria",
            "ko": "나이지리아",
            "pt-BR": "Nigéria",
            "pt": "Nigéria",
            "nl": "Nigeria",
            "hr": "Nigerija",
            "fa": "نیجریه",
            "de": "Nigeria",
            "es": "Nigeria",
            "fr": "Nigéria",
            "ja": "ナイジェリア",
            "it": "Nigeria",
            "zh-CN": "尼日利亚",
            "tr": "Nijerya",
            "ru": "Нигерия",
            "uk": "Нігерія",
            "pl": "Nigeria"
        },
        "latitude": "10.00000000",
        "longitude": "8.00000000",
        "emoji": "🇳🇬",
        "emojiU": "U+1F1F3 U+1F1EC",
        "states": [
            {
                "id": 303,
                "name": "Abia",
                "iso2": "AB",
                "latitude": "5.45273540",
                "longitude": "7.52484140",
                "type": "state",
                "cities": [
                    {
                        "id": 76744,
                        "name": "Aba",
                        "latitude": "5.10658000",
                        "longitude": "7.36667000"
                    },
                    {
                        "id": 76769,
                        "name": "Amaigbo",
                        "latitude": "5.78917000",
                        "longitude": "7.83829000"
                    },
                    {
                        "id": 76779,
                        "name": "Arochukwu",
                        "latitude": "5.38941000",
                        "longitude": "7.91235000"
                    },
                    {
                        "id": 76799,
                        "name": "Bende",
                        "latitude": "5.55874000",
                        "longitude": "7.63359000"
                    },
                    {
                        "id": 77057,
                        "name": "Ohafia-Ifigh",
                        "latitude": "5.61455000",
                        "longitude": "7.81191000"
                    },
                    {
                        "id": 77125,
                        "name": "Umuahia",
                        "latitude": "5.52491000",
                        "longitude": "7.49461000"
                    }
                ]
            },
            {
                "id": 293,
                "name": "Abuja Federal Capital Territory",
                "iso2": "FC",
                "latitude": "8.89406910",
                "longitude": "7.18604020",
                "type": "capital territory",
                "cities": [
                    {
                        "id": 76749,
                        "name": "Abuja",
                        "latitude": "9.05785000",
                        "longitude": "7.49508000"
                    },
                    {
                        "id": 153367,
                        "name": "Asokoro",
                        "latitude": "9.04790000",
                        "longitude": "7.51550000"
                    },
                    {
                        "id": 153362,
                        "name": "Bamburu",
                        "latitude": "9.11360000",
                        "longitude": "7.10960000"
                    },
                    {
                        "id": 153366,
                        "name": "Garki",
                        "latitude": "9.03190000",
                        "longitude": "7.48280000"
                    },
                    {
                        "id": 153364,
                        "name": "Gwagwalada",
                        "latitude": "8.95080000",
                        "longitude": "7.07670000"
                    },
                    {
                        "id": 153363,
                        "name": "Gwarinpa",
                        "latitude": "9.10990000",
                        "longitude": "7.40420000"
                    },
                    {
                        "id": 153371,
                        "name": "Jikwoyi",
                        "latitude": "8.99130000",
                        "longitude": "7.55630000"
                    },
                    {
                        "id": 153368,
                        "name": "Karu",
                        "latitude": "8.99280000",
                        "longitude": "7.57250000"
                    },
                    {
                        "id": 153369,
                        "name": "Kubwa",
                        "latitude": "9.15380000",
                        "longitude": "7.32200000"
                    },
                    {
                        "id": 76990,
                        "name": "Kuje",
                        "latitude": "8.87952000",
                        "longitude": "7.22756000"
                    },
                    {
                        "id": 153370,
                        "name": "Kurunduma",
                        "latitude": "9.01510000",
                        "longitude": "7.53490000"
                    },
                    {
                        "id": 76997,
                        "name": "Kwali",
                        "latitude": "8.88346000",
                        "longitude": "7.01858000"
                    },
                    {
                        "id": 77014,
                        "name": "Madala",
                        "latitude": "9.10444000",
                        "longitude": "7.21333000"
                    },
                    {
                        "id": 153365,
                        "name": "Maitama",
                        "latitude": "9.08820000",
                        "longitude": "7.49340000"
                    },
                    {
                        "id": 153373,
                        "name": "Wuse",
                        "latitude": "9.07470000",
                        "longitude": "7.47600000"
                    },
                    {
                        "id": 153372,
                        "name": "Zuba",
                        "latitude": "9.10230000",
                        "longitude": "7.19520000"
                    }
                ]
            },
            {
                "id": 320,
                "name": "Adamawa",
                "iso2": "AD",
                "latitude": "9.14855660",
                "longitude": "11.21619340",
                "type": "state",
                "cities": [
                    {
                        "id": 76876,
                        "name": "Ganye",
                        "latitude": "8.43497000",
                        "longitude": "12.05107000"
                    },
                    {
                        "id": 76885,
                        "name": "Gombi",
                        "latitude": "10.16756000",
                        "longitude": "12.73684000"
                    },
                    {
                        "id": 76904,
                        "name": "Holma",
                        "latitude": "9.89863000",
                        "longitude": "13.05450000"
                    },
                    {
                        "id": 76962,
                        "name": "Jimeta",
                        "latitude": "9.27949000",
                        "longitude": "12.45819000"
                    },
                    {
                        "id": 77013,
                        "name": "Madagali",
                        "latitude": "10.88942000",
                        "longitude": "13.62832000"
                    },
                    {
                        "id": 77027,
                        "name": "Mayo-Belwa",
                        "latitude": "9.05421000",
                        "longitude": "12.05794000"
                    },
                    {
                        "id": 77035,
                        "name": "Mubi",
                        "latitude": "10.26858000",
                        "longitude": "13.26701000"
                    },
                    {
                        "id": 77041,
                        "name": "Ngurore",
                        "latitude": "9.28871000",
                        "longitude": "12.24026000"
                    },
                    {
                        "id": 77046,
                        "name": "Numan",
                        "latitude": "9.46374000",
                        "longitude": "12.03062000"
                    },
                    {
                        "id": 77114,
                        "name": "Toungo",
                        "latitude": "8.11733000",
                        "longitude": "12.04611000"
                    },
                    {
                        "id": 77146,
                        "name": "Yola",
                        "latitude": "9.20839000",
                        "longitude": "12.48146000"
                    }
                ]
            },
            {
                "id": 304,
                "name": "Akwa Ibom",
                "iso2": "AK",
                "latitude": "4.90573710",
                "longitude": "7.85366750",
                "type": "state",
                "cities": [
                    {
                        "id": 76858,
                        "name": "Eket",
                        "latitude": "4.64231000",
                        "longitude": "7.92438000"
                    },
                    {
                        "id": 76865,
                        "name": "Esuk Oron",
                        "latitude": "4.80293000",
                        "longitude": "8.25341000"
                    },
                    {
                        "id": 76937,
                        "name": "Ikot Ekpene",
                        "latitude": "5.18194000",
                        "longitude": "7.71481000"
                    },
                    {
                        "id": 76955,
                        "name": "Itu",
                        "latitude": "5.20131000",
                        "longitude": "7.98373000"
                    },
                    {
                        "id": 77129,
                        "name": "Uyo",
                        "latitude": "5.05127000",
                        "longitude": "7.93350000"
                    }
                ]
            },
            {
                "id": 315,
                "name": "Anambra",
                "iso2": "AN",
                "latitude": "6.22089970",
                "longitude": "6.93695590",
                "type": "state",
                "cities": [
                    {
                        "id": 76759,
                        "name": "Agulu",
                        "latitude": "6.10045000",
                        "longitude": "7.06100000"
                    },
                    {
                        "id": 76781,
                        "name": "Atani",
                        "latitude": "6.01277000",
                        "longitude": "6.74768000"
                    },
                    {
                        "id": 76785,
                        "name": "Awka",
                        "latitude": "6.21269000",
                        "longitude": "7.07199000"
                    },
                    {
                        "id": 76863,
                        "name": "Enugu-Ukwu",
                        "latitude": "6.17146000",
                        "longitude": "7.00525000"
                    },
                    {
                        "id": 76920,
                        "name": "Igbo-Ukwu",
                        "latitude": "6.01798000",
                        "longitude": "7.02027000"
                    },
                    {
                        "id": 76924,
                        "name": "Ihiala",
                        "latitude": "5.85475000",
                        "longitude": "6.85944000"
                    },
                    {
                        "id": 77043,
                        "name": "Nkpor",
                        "latitude": "6.15038000",
                        "longitude": "6.83042000"
                    },
                    {
                        "id": 77044,
                        "name": "Nnewi",
                        "latitude": "6.01962000",
                        "longitude": "6.91729000"
                    },
                    {
                        "id": 77068,
                        "name": "Onitsha",
                        "latitude": "6.14978000",
                        "longitude": "6.78569000"
                    },
                    {
                        "id": 77083,
                        "name": "Ozubulu",
                        "latitude": "5.95753000",
                        "longitude": "6.85305000"
                    },
                    {
                        "id": 77120,
                        "name": "Uga",
                        "latitude": "5.93576000",
                        "longitude": "7.07930000"
                    },
                    {
                        "id": 77128,
                        "name": "Uruobo-Okija",
                        "latitude": "5.90016000",
                        "longitude": "6.84312000"
                    }
                ]
            },
            {
                "id": 312,
                "name": "Bauchi",
                "iso2": "BA",
                "latitude": "10.77606240",
                "longitude": "9.99919430",
                "type": "state",
                "cities": [
                    {
                        "id": 76786,
                        "name": "Azare",
                        "latitude": "11.67478000",
                        "longitude": "10.19069000"
                    },
                    {
                        "id": 76796,
                        "name": "Bauchi",
                        "latitude": "10.31032000",
                        "longitude": "9.84388000"
                    },
                    {
                        "id": 76810,
                        "name": "Boi",
                        "latitude": "9.56109000",
                        "longitude": "9.50154000"
                    },
                    {
                        "id": 76818,
                        "name": "Bununu",
                        "latitude": "9.88224000",
                        "longitude": "9.68058000"
                    },
                    {
                        "id": 76835,
                        "name": "Darazo",
                        "latitude": "10.99920000",
                        "longitude": "10.41062000"
                    },
                    {
                        "id": 76836,
                        "name": "Dass",
                        "latitude": "10.00065000",
                        "longitude": "9.51596000"
                    },
                    {
                        "id": 76843,
                        "name": "Dindima",
                        "latitude": "10.22629000",
                        "longitude": "10.15132000"
                    },
                    {
                        "id": 76844,
                        "name": "Disina",
                        "latitude": "11.48135000",
                        "longitude": "9.91903000"
                    },
                    {
                        "id": 76871,
                        "name": "Gabarin",
                        "latitude": "11.10930000",
                        "longitude": "10.44410000"
                    },
                    {
                        "id": 76898,
                        "name": "Gwaram",
                        "latitude": "10.23295000",
                        "longitude": "10.28572000"
                    },
                    {
                        "id": 76978,
                        "name": "Kari",
                        "latitude": "11.24710000",
                        "longitude": "10.56100000"
                    },
                    {
                        "id": 77005,
                        "name": "Lame",
                        "latitude": "10.44154000",
                        "longitude": "9.23955000"
                    },
                    {
                        "id": 77009,
                        "name": "Lere",
                        "latitude": "9.71052000",
                        "longitude": "9.34029000"
                    },
                    {
                        "id": 77015,
                        "name": "Madara",
                        "latitude": "11.77980000",
                        "longitude": "10.44790000"
                    },
                    {
                        "id": 77031,
                        "name": "Misau",
                        "latitude": "11.31370000",
                        "longitude": "10.46664000"
                    },
                    {
                        "id": 77095,
                        "name": "Sade",
                        "latitude": "11.35950000",
                        "longitude": "10.67320000"
                    },
                    {
                        "id": 77140,
                        "name": "Yamrat",
                        "latitude": "10.11161000",
                        "longitude": "9.82604000"
                    },
                    {
                        "id": 77141,
                        "name": "Yanda Bayo",
                        "latitude": "11.50710000",
                        "longitude": "10.74590000"
                    },
                    {
                        "id": 77147,
                        "name": "Yuli",
                        "latitude": "9.69707000",
                        "longitude": "10.27350000"
                    },
                    {
                        "id": 77148,
                        "name": "Zadawa",
                        "latitude": "11.44960000",
                        "longitude": "10.36720000"
                    },
                    {
                        "id": 77150,
                        "name": "Zalanga",
                        "latitude": "10.61432000",
                        "longitude": "10.17647000"
                    }
                ]
            },
            {
                "id": 305,
                "name": "Bayelsa",
                "iso2": "BY",
                "latitude": "4.77190710",
                "longitude": "6.06985260",
                "type": "state",
                "cities": [
                    {
                        "id": 76770,
                        "name": "Amassoma",
                        "latitude": "4.97032000",
                        "longitude": "6.10915000"
                    },
                    {
                        "id": 77116,
                        "name": "Twon-Brass",
                        "latitude": "4.31231000",
                        "longitude": "6.24091000"
                    },
                    {
                        "id": 77145,
                        "name": "Yenagoa",
                        "latitude": "4.92675000",
                        "longitude": "6.26764000"
                    }
                ]
            },
            {
                "id": 291,
                "name": "Benue",
                "iso2": "BE",
                "latitude": "7.33690240",
                "longitude": "8.74036870",
                "type": "state",
                "cities": [
                    {
                        "id": 76767,
                        "name": "Aliade",
                        "latitude": "7.29627000",
                        "longitude": "8.48278000"
                    },
                    {
                        "id": 76811,
                        "name": "Boju",
                        "latitude": "7.35572000",
                        "longitude": "7.89303000"
                    },
                    {
                        "id": 149066,
                        "name": "Gboko",
                        "latitude": "7.33159530",
                        "longitude": "8.97600680"
                    },
                    {
                        "id": 76922,
                        "name": "Igbor",
                        "latitude": "7.45123000",
                        "longitude": "8.60805000"
                    },
                    {
                        "id": 77021,
                        "name": "Makurdi",
                        "latitude": "7.73375000",
                        "longitude": "8.52139000"
                    },
                    {
                        "id": 77049,
                        "name": "Ochobo",
                        "latitude": "7.18045000",
                        "longitude": "7.98240000"
                    },
                    {
                        "id": 77077,
                        "name": "Otukpa",
                        "latitude": "7.10168000",
                        "longitude": "7.65945000"
                    },
                    {
                        "id": 77110,
                        "name": "Takum",
                        "latitude": "7.26667000",
                        "longitude": "9.98333000"
                    },
                    {
                        "id": 77121,
                        "name": "Ugbokpo",
                        "latitude": "7.65321000",
                        "longitude": "7.88410000"
                    },
                    {
                        "id": 77142,
                        "name": "Yandev",
                        "latitude": "7.36308000",
                        "longitude": "9.04235000"
                    },
                    {
                        "id": 77149,
                        "name": "Zaki Biam",
                        "latitude": "7.50671000",
                        "longitude": "9.61040000"
                    }
                ]
            },
            {
                "id": 307,
                "name": "Borno",
                "iso2": "BO",
                "latitude": "11.88463560",
                "longitude": "13.15196650",
                "type": "state",
                "cities": [
                    {
                        "id": 76793,
                        "name": "Bama",
                        "latitude": "11.52134000",
                        "longitude": "13.68952000"
                    },
                    {
                        "id": 76801,
                        "name": "Benisheikh",
                        "latitude": "11.80919000",
                        "longitude": "12.49151000"
                    },
                    {
                        "id": 76808,
                        "name": "Biu",
                        "latitude": "10.61285000",
                        "longitude": "12.19458000"
                    },
                    {
                        "id": 76814,
                        "name": "Bornu Yassu",
                        "latitude": "12.27503000",
                        "longitude": "12.56856000"
                    },
                    {
                        "id": 76825,
                        "name": "Damasak",
                        "latitude": "13.10518000",
                        "longitude": "12.50854000"
                    },
                    {
                        "id": 76827,
                        "name": "Damboa",
                        "latitude": "11.15534000",
                        "longitude": "12.75638000"
                    },
                    {
                        "id": 76842,
                        "name": "Dikwa",
                        "latitude": "12.03609000",
                        "longitude": "13.91815000"
                    },
                    {
                        "id": 76874,
                        "name": "Gamboru",
                        "latitude": "12.37299000",
                        "longitude": "14.20690000"
                    },
                    {
                        "id": 76901,
                        "name": "Gwoza",
                        "latitude": "11.08313000",
                        "longitude": "13.69595000"
                    },
                    {
                        "id": 76991,
                        "name": "Kukawa",
                        "latitude": "12.92475000",
                        "longitude": "13.56617000"
                    },
                    {
                        "id": 77016,
                        "name": "Magumeri",
                        "latitude": "12.11451000",
                        "longitude": "12.82620000"
                    },
                    {
                        "id": 77018,
                        "name": "Maiduguri",
                        "latitude": "11.84692000",
                        "longitude": "13.15712000"
                    },
                    {
                        "id": 77024,
                        "name": "Marte",
                        "latitude": "12.36532000",
                        "longitude": "13.82930000"
                    },
                    {
                        "id": 77030,
                        "name": "Miringa",
                        "latitude": "10.73115000",
                        "longitude": "12.14626000"
                    },
                    {
                        "id": 77033,
                        "name": "Monguno",
                        "latitude": "12.67059000",
                        "longitude": "13.61224000"
                    },
                    {
                        "id": 77040,
                        "name": "Ngala",
                        "latitude": "12.34053000",
                        "longitude": "14.18670000"
                    },
                    {
                        "id": 77101,
                        "name": "Shaffa",
                        "latitude": "10.50673000",
                        "longitude": "12.33315000"
                    },
                    {
                        "id": 77103,
                        "name": "Shani",
                        "latitude": "10.21824000",
                        "longitude": "12.06059000"
                    },
                    {
                        "id": 77113,
                        "name": "Tokombere",
                        "latitude": "11.22135000",
                        "longitude": "13.48783000"
                    },
                    {
                        "id": 77117,
                        "name": "Uba",
                        "latitude": "10.45509000",
                        "longitude": "13.22233000"
                    },
                    {
                        "id": 77138,
                        "name": "Wuyo",
                        "latitude": "10.38522000",
                        "longitude": "11.69678000"
                    },
                    {
                        "id": 77139,
                        "name": "Yajiwa",
                        "latitude": "11.38623000",
                        "longitude": "12.71992000"
                    }
                ]
            },
            {
                "id": 314,
                "name": "Cross River",
                "iso2": "CR",
                "latitude": "5.87017240",
                "longitude": "8.59880140",
                "type": "state",
                "cities": [
                    {
                        "id": 76761,
                        "name": "Akankpa",
                        "latitude": "5.12640000",
                        "longitude": "8.18980000"
                    },
                    {
                        "id": 76821,
                        "name": "Calabar",
                        "latitude": "4.95893000",
                        "longitude": "8.32695000"
                    },
                    {
                        "id": 76873,
                        "name": "Gakem",
                        "latitude": "6.76963000",
                        "longitude": "8.99120000"
                    },
                    {
                        "id": 76931,
                        "name": "Ikang",
                        "latitude": "4.78978000",
                        "longitude": "8.53160000"
                    },
                    {
                        "id": 77122,
                        "name": "Ugep",
                        "latitude": "5.80865000",
                        "longitude": "8.08098000"
                    }
                ]
            },
            {
                "id": 316,
                "name": "Delta",
                "iso2": "DE",
                "latitude": "33.74537840",
                "longitude": "-90.73545080",
                "type": "state",
                "cities": [
                    {
                        "id": 76748,
                        "name": "Abraka",
                        "latitude": "5.79023000",
                        "longitude": "6.10473000"
                    },
                    {
                        "id": 76756,
                        "name": "Agbor",
                        "latitude": "6.25375000",
                        "longitude": "6.19420000"
                    },
                    {
                        "id": 76780,
                        "name": "Asaba",
                        "latitude": "6.19824000",
                        "longitude": "6.73187000"
                    },
                    {
                        "id": 76813,
                        "name": "Bomadi",
                        "latitude": "5.16073000",
                        "longitude": "5.92375000"
                    },
                    {
                        "id": 76820,
                        "name": "Burutu",
                        "latitude": "5.35328000",
                        "longitude": "5.50826000"
                    },
                    {
                        "id": 76996,
                        "name": "Kwale",
                        "latitude": "5.70773000",
                        "longitude": "6.43402000"
                    },
                    {
                        "id": 77047,
                        "name": "Obiaruku",
                        "latitude": "5.84672000",
                        "longitude": "6.15290000"
                    },
                    {
                        "id": 77056,
                        "name": "Ogwashi-Uku",
                        "latitude": "6.17811000",
                        "longitude": "6.52461000"
                    },
                    {
                        "id": 77071,
                        "name": "Orerokpe",
                        "latitude": "5.63747000",
                        "longitude": "5.89013000"
                    },
                    {
                        "id": 77086,
                        "name": "Patani",
                        "latitude": "5.22885000",
                        "longitude": "6.19139000"
                    },
                    {
                        "id": 77099,
                        "name": "Sapele",
                        "latitude": "5.89405000",
                        "longitude": "5.67666000"
                    },
                    {
                        "id": 77123,
                        "name": "Ughelli",
                        "latitude": "5.48956000",
                        "longitude": "6.00407000"
                    },
                    {
                        "id": 77126,
                        "name": "Umunede",
                        "latitude": "6.26549000",
                        "longitude": "6.30962000"
                    },
                    {
                        "id": 77133,
                        "name": "Warri",
                        "latitude": "5.51737000",
                        "longitude": "5.75006000"
                    }
                ]
            },
            {
                "id": 311,
                "name": "Ebonyi",
                "iso2": "EB",
                "latitude": "6.26492320",
                "longitude": "8.01373020",
                "type": "state",
                "cities": [
                    {
                        "id": 76745,
                        "name": "Abakaliki",
                        "latitude": "6.32485000",
                        "longitude": "8.11368000"
                    },
                    {
                        "id": 76754,
                        "name": "Afikpo",
                        "latitude": "5.89258000",
                        "longitude": "7.93534000"
                    },
                    {
                        "id": 76852,
                        "name": "Effium",
                        "latitude": "6.63105000",
                        "longitude": "8.05814000"
                    },
                    {
                        "id": 76867,
                        "name": "Ezza-Ohu",
                        "latitude": "6.44094000",
                        "longitude": "8.08432000"
                    },
                    {
                        "id": 76954,
                        "name": "Isieke",
                        "latitude": "6.38186000",
                        "longitude": "8.03736000"
                    }
                ]
            },
            {
                "id": 318,
                "name": "Edo",
                "iso2": "ED",
                "latitude": "6.63418310",
                "longitude": "5.93040560",
                "type": "state",
                "cities": [
                    {
                        "id": 76757,
                        "name": "Agenebode",
                        "latitude": "7.10512000",
                        "longitude": "6.69381000"
                    },
                    {
                        "id": 76782,
                        "name": "Auchi",
                        "latitude": "7.06756000",
                        "longitude": "6.26360000"
                    },
                    {
                        "id": 76800,
                        "name": "Benin City",
                        "latitude": "6.33815000",
                        "longitude": "5.62575000"
                    },
                    {
                        "id": 76859,
                        "name": "Ekpoma",
                        "latitude": "6.74300000",
                        "longitude": "6.14029000"
                    },
                    {
                        "id": 76916,
                        "name": "Igarra",
                        "latitude": "7.29366000",
                        "longitude": "6.10432000"
                    },
                    {
                        "id": 76944,
                        "name": "Illushi",
                        "latitude": "6.67033000",
                        "longitude": "6.62907000"
                    },
                    {
                        "id": 77104,
                        "name": "Siluko",
                        "latitude": "6.53589000",
                        "longitude": "5.16005000"
                    },
                    {
                        "id": 77118,
                        "name": "Ubiaja",
                        "latitude": "6.65581000",
                        "longitude": "6.38494000"
                    },
                    {
                        "id": 77127,
                        "name": "Uromi",
                        "latitude": "6.70000000",
                        "longitude": "6.33333000"
                    }
                ]
            },
            {
                "id": 309,
                "name": "Ekiti",
                "iso2": "EK",
                "latitude": "7.71898620",
                "longitude": "5.31095050",
                "type": "state",
                "cities": [
                    {
                        "id": 76752,
                        "name": "Ado-Ekiti",
                        "latitude": "7.62329000",
                        "longitude": "5.22087000"
                    },
                    {
                        "id": 76777,
                        "name": "Aramoko-Ekiti",
                        "latitude": "7.70483000",
                        "longitude": "5.04054000"
                    },
                    {
                        "id": 76853,
                        "name": "Efon-Alaaye",
                        "latitude": "7.65649000",
                        "longitude": "4.92235000"
                    },
                    {
                        "id": 76860,
                        "name": "Emure-Ekiti",
                        "latitude": "7.43636000",
                        "longitude": "5.45925000"
                    },
                    {
                        "id": 76913,
                        "name": "Ifaki",
                        "latitude": "7.78942000",
                        "longitude": "5.24852000"
                    },
                    {
                        "id": 76917,
                        "name": "Igbara-Odo",
                        "latitude": "7.50251000",
                        "longitude": "5.06258000"
                    },
                    {
                        "id": 76923,
                        "name": "Igede-Ekiti",
                        "latitude": "7.66850000",
                        "longitude": "5.12627000"
                    },
                    {
                        "id": 76930,
                        "name": "Ijero-Ekiti",
                        "latitude": "7.81514000",
                        "longitude": "5.06716000"
                    },
                    {
                        "id": 76934,
                        "name": "Ikere-Ekiti",
                        "latitude": "7.49748000",
                        "longitude": "5.23041000"
                    },
                    {
                        "id": 76950,
                        "name": "Ipoti",
                        "latitude": "7.87377000",
                        "longitude": "5.07691000"
                    },
                    {
                        "id": 76953,
                        "name": "Ise-Ekiti",
                        "latitude": "7.46478000",
                        "longitude": "5.42333000"
                    },
                    {
                        "id": 77058,
                        "name": "Oke Ila",
                        "latitude": "7.95000000",
                        "longitude": "4.98333000"
                    },
                    {
                        "id": 77066,
                        "name": "Omuo-Ekiti",
                        "latitude": "7.75833000",
                        "longitude": "5.72227000"
                    }
                ]
            },
            {
                "id": 289,
                "name": "Enugu",
                "iso2": "EN",
                "latitude": "6.53635300",
                "longitude": "7.43561940",
                "type": "state",
                "cities": [
                    {
                        "id": 76750,
                        "name": "Adani",
                        "latitude": "6.73971000",
                        "longitude": "7.01117000"
                    },
                    {
                        "id": 76762,
                        "name": "Ake-Eze",
                        "latitude": "5.91677000",
                        "longitude": "7.67615000"
                    },
                    {
                        "id": 76764,
                        "name": "Aku",
                        "latitude": "6.70902000",
                        "longitude": "7.31826000"
                    },
                    {
                        "id": 76768,
                        "name": "Amagunze",
                        "latitude": "6.33063000",
                        "longitude": "7.65247000"
                    },
                    {
                        "id": 76784,
                        "name": "Awgu",
                        "latitude": "6.07278000",
                        "longitude": "7.47739000"
                    },
                    {
                        "id": 76855,
                        "name": "Eha Amufu",
                        "latitude": "6.65915000",
                        "longitude": "7.75961000"
                    },
                    {
                        "id": 76861,
                        "name": "Enugu",
                        "latitude": "6.44132000",
                        "longitude": "7.49883000"
                    },
                    {
                        "id": 76862,
                        "name": "Enugu-Ezike",
                        "latitude": "6.98270000",
                        "longitude": "7.45534000"
                    },
                    {
                        "id": 76866,
                        "name": "Ete",
                        "latitude": "7.08956000",
                        "longitude": "7.45341000"
                    },
                    {
                        "id": 76933,
                        "name": "Ikem",
                        "latitude": "6.77993000",
                        "longitude": "7.71484000"
                    },
                    {
                        "id": 77028,
                        "name": "Mberubu",
                        "latitude": "6.17310000",
                        "longitude": "7.63017000"
                    },
                    {
                        "id": 77045,
                        "name": "Nsukka",
                        "latitude": "6.85783000",
                        "longitude": "7.39577000"
                    },
                    {
                        "id": 77048,
                        "name": "Obolo-Eke (1)",
                        "latitude": "6.88333000",
                        "longitude": "7.63333000"
                    },
                    {
                        "id": 77069,
                        "name": "Opi",
                        "latitude": "6.78223000",
                        "longitude": "7.43319000"
                    },
                    {
                        "id": 77119,
                        "name": "Udi",
                        "latitude": "6.31592000",
                        "longitude": "7.42086000"
                    }
                ]
            },
            {
                "id": 310,
                "name": "Gombe",
                "iso2": "GO",
                "latitude": "10.36377950",
                "longitude": "11.19275870",
                "type": "state",
                "cities": [
                    {
                        "id": 76763,
                        "name": "Akko",
                        "latitude": "10.28899000",
                        "longitude": "10.97320000"
                    },
                    {
                        "id": 76794,
                        "name": "Bara",
                        "latitude": "10.37444000",
                        "longitude": "10.72884000"
                    },
                    {
                        "id": 76802,
                        "name": "Billiri",
                        "latitude": "9.86545000",
                        "longitude": "11.22624000"
                    },
                    {
                        "id": 76823,
                        "name": "Dadiya",
                        "latitude": "9.61667000",
                        "longitude": "11.43333000"
                    },
                    {
                        "id": 76839,
                        "name": "Deba",
                        "latitude": "10.21187000",
                        "longitude": "11.38710000"
                    },
                    {
                        "id": 76846,
                        "name": "Dukku",
                        "latitude": "10.82379000",
                        "longitude": "10.77221000"
                    },
                    {
                        "id": 76877,
                        "name": "Garko",
                        "latitude": "10.17506000",
                        "longitude": "11.16458000"
                    },
                    {
                        "id": 76884,
                        "name": "Gombe",
                        "latitude": "10.28969000",
                        "longitude": "11.16729000"
                    },
                    {
                        "id": 76903,
                        "name": "Hinna",
                        "latitude": "10.30426000",
                        "longitude": "11.49905000"
                    },
                    {
                        "id": 76968,
                        "name": "Kafarati",
                        "latitude": "10.38304000",
                        "longitude": "11.09567000"
                    },
                    {
                        "id": 76973,
                        "name": "Kaltungo",
                        "latitude": "9.81998000",
                        "longitude": "11.30871000"
                    },
                    {
                        "id": 76993,
                        "name": "Kumo",
                        "latitude": "10.04807000",
                        "longitude": "11.21055000"
                    },
                    {
                        "id": 77037,
                        "name": "Nafada",
                        "latitude": "11.09596000",
                        "longitude": "11.33261000"
                    },
                    {
                        "id": 77088,
                        "name": "Pindiga",
                        "latitude": "9.98433000",
                        "longitude": "10.95229000"
                    }
                ]
            },
            {
                "id": 308,
                "name": "Imo",
                "iso2": "IM",
                "latitude": "5.57201220",
                "longitude": "7.05882190",
                "type": "state",
                "cities": [
                    {
                        "id": 76925,
                        "name": "Iho",
                        "latitude": "5.58225000",
                        "longitude": "7.09896000"
                    },
                    {
                        "id": 77055,
                        "name": "Oguta",
                        "latitude": "5.71044000",
                        "longitude": "6.80936000"
                    },
                    {
                        "id": 77062,
                        "name": "Okigwe",
                        "latitude": "5.82917000",
                        "longitude": "7.35056000"
                    },
                    {
                        "id": 77073,
                        "name": "Orlu",
                        "latitude": "5.79565000",
                        "longitude": "7.03513000"
                    },
                    {
                        "id": 77074,
                        "name": "Orodo",
                        "latitude": "5.61667000",
                        "longitude": "7.03333000"
                    },
                    {
                        "id": 77078,
                        "name": "Owerri",
                        "latitude": "5.48363000",
                        "longitude": "7.03325000"
                    }
                ]
            },
            {
                "id": 288,
                "name": "Jigawa",
                "iso2": "JI",
                "latitude": "12.22801200",
                "longitude": "9.56158670",
                "type": "state",
                "cities": [
                    {
                        "id": 76788,
                        "name": "Babura",
                        "latitude": "12.77256000",
                        "longitude": "9.01525000"
                    },
                    {
                        "id": 76806,
                        "name": "Birnin Kudu",
                        "latitude": "11.45207000",
                        "longitude": "9.47856000"
                    },
                    {
                        "id": 76807,
                        "name": "Birniwa",
                        "latitude": "12.79070000",
                        "longitude": "10.23614000"
                    },
                    {
                        "id": 76848,
                        "name": "Dutse",
                        "latitude": "11.75618000",
                        "longitude": "9.33896000"
                    },
                    {
                        "id": 76872,
                        "name": "Gagarawa",
                        "latitude": "12.40848000",
                        "longitude": "9.52881000"
                    },
                    {
                        "id": 76892,
                        "name": "Gumel",
                        "latitude": "12.62690000",
                        "longitude": "9.38807000"
                    },
                    {
                        "id": 76897,
                        "name": "Gwaram",
                        "latitude": "11.27727000",
                        "longitude": "9.88385000"
                    },
                    {
                        "id": 76902,
                        "name": "Hadejia",
                        "latitude": "12.45347000",
                        "longitude": "10.04115000"
                    },
                    {
                        "id": 76969,
                        "name": "Kafin Hausa",
                        "latitude": "12.23933000",
                        "longitude": "9.91105000"
                    },
                    {
                        "id": 76981,
                        "name": "Kazaure",
                        "latitude": "12.64846000",
                        "longitude": "8.41178000"
                    },
                    {
                        "id": 76985,
                        "name": "Kiyawa",
                        "latitude": "11.78442000",
                        "longitude": "9.60690000"
                    },
                    {
                        "id": 77022,
                        "name": "Mallammaduri",
                        "latitude": "12.56427000",
                        "longitude": "9.95727000"
                    },
                    {
                        "id": 77091,
                        "name": "Ringim",
                        "latitude": "12.15143000",
                        "longitude": "9.16216000"
                    },
                    {
                        "id": 77097,
                        "name": "Samamiya",
                        "latitude": "11.34873000",
                        "longitude": "9.63989000"
                    }
                ]
            },
            {
                "id": 294,
                "name": "Kaduna",
                "iso2": "KD",
                "latitude": "10.37640060",
                "longitude": "7.70945370",
                "type": "state",
                "cities": [
                    {
                        "id": 76772,
                        "name": "Anchau",
                        "latitude": "10.96245000",
                        "longitude": "8.39233000"
                    },
                    {
                        "id": 76819,
                        "name": "Burumburum",
                        "latitude": "11.39106000",
                        "longitude": "8.72341000"
                    },
                    {
                        "id": 76849,
                        "name": "Dutsen Wai",
                        "latitude": "10.85009000",
                        "longitude": "8.19900000"
                    },
                    {
                        "id": 76905,
                        "name": "Hunkuyi",
                        "latitude": "11.26680000",
                        "longitude": "7.64916000"
                    },
                    {
                        "id": 76965,
                        "name": "Kachia",
                        "latitude": "9.87342000",
                        "longitude": "7.95407000"
                    },
                    {
                        "id": 76966,
                        "name": "Kaduna",
                        "latitude": "10.52641000",
                        "longitude": "7.43879000"
                    },
                    {
                        "id": 76967,
                        "name": "Kafanchan",
                        "latitude": "9.58126000",
                        "longitude": "8.29260000"
                    },
                    {
                        "id": 76970,
                        "name": "Kagoro",
                        "latitude": "9.60776000",
                        "longitude": "8.39043000"
                    },
                    {
                        "id": 76972,
                        "name": "Kajuru",
                        "latitude": "10.32281000",
                        "longitude": "7.68462000"
                    },
                    {
                        "id": 76989,
                        "name": "Kujama",
                        "latitude": "10.45767000",
                        "longitude": "7.63808000"
                    },
                    {
                        "id": 77010,
                        "name": "Lere",
                        "latitude": "10.38584000",
                        "longitude": "8.57286000"
                    },
                    {
                        "id": 77023,
                        "name": "Mando",
                        "latitude": "10.71667000",
                        "longitude": "6.56667000"
                    },
                    {
                        "id": 77098,
                        "name": "Saminaka",
                        "latitude": "10.41227000",
                        "longitude": "8.68748000"
                    },
                    {
                        "id": 77105,
                        "name": "Soba",
                        "latitude": "10.98133000",
                        "longitude": "8.05749000"
                    },
                    {
                        "id": 77106,
                        "name": "Sofo-Birnin-Gwari",
                        "latitude": "11.01537000",
                        "longitude": "6.78036000"
                    },
                    {
                        "id": 77151,
                        "name": "Zaria",
                        "latitude": "11.11128000",
                        "longitude": "7.72270000"
                    }
                ]
            },
            {
                "id": 300,
                "name": "Kano",
                "iso2": "KN",
                "latitude": "11.74706980",
                "longitude": "8.52471070",
                "type": "state",
                "cities": [
                    {
                        "id": 76828,
                        "name": "Dan Gora",
                        "latitude": "11.53485000",
                        "longitude": "8.15224000"
                    },
                    {
                        "id": 76880,
                        "name": "Gaya",
                        "latitude": "11.86064000",
                        "longitude": "9.00270000"
                    },
                    {
                        "id": 76977,
                        "name": "Kano",
                        "latitude": "12.00012000",
                        "longitude": "8.51672000"
                    }
                ]
            },
            {
                "id": 313,
                "name": "Katsina",
                "iso2": "KT",
                "latitude": "12.37967070",
                "longitude": "7.63057480",
                "type": "state",
                "cities": [
                    {
                        "id": 76831,
                        "name": "Danja",
                        "latitude": "11.37710000",
                        "longitude": "7.56097000"
                    },
                    {
                        "id": 76833,
                        "name": "Dankama",
                        "latitude": "13.29782000",
                        "longitude": "7.79492000"
                    },
                    {
                        "id": 76838,
                        "name": "Daura",
                        "latitude": "13.03299000",
                        "longitude": "8.32351000"
                    },
                    {
                        "id": 76850,
                        "name": "Dutsin-Ma",
                        "latitude": "12.45392000",
                        "longitude": "7.49723000"
                    },
                    {
                        "id": 76870,
                        "name": "Funtua",
                        "latitude": "11.47196000",
                        "longitude": "7.30699000"
                    },
                    {
                        "id": 76887,
                        "name": "Gora",
                        "latitude": "11.91294000",
                        "longitude": "7.66531000"
                    },
                    {
                        "id": 76960,
                        "name": "Jibia",
                        "latitude": "13.09378000",
                        "longitude": "7.22624000"
                    },
                    {
                        "id": 76961,
                        "name": "Jikamshi",
                        "latitude": "12.17328000",
                        "longitude": "7.77424000"
                    },
                    {
                        "id": 76976,
                        "name": "Kankara",
                        "latitude": "11.93114000",
                        "longitude": "7.41115000"
                    },
                    {
                        "id": 76979,
                        "name": "Katsina",
                        "latitude": "12.99082000",
                        "longitude": "7.60177000"
                    },
                    {
                        "id": 77026,
                        "name": "Mashi",
                        "latitude": "12.98044000",
                        "longitude": "7.94703000"
                    },
                    {
                        "id": 77093,
                        "name": "Ruma",
                        "latitude": "12.86260000",
                        "longitude": "7.23469000"
                    },
                    {
                        "id": 77094,
                        "name": "Runka",
                        "latitude": "12.44788000",
                        "longitude": "7.30918000"
                    },
                    {
                        "id": 77131,
                        "name": "Wagini",
                        "latitude": "12.68781000",
                        "longitude": "7.19579000"
                    }
                ]
            },
            {
                "id": 290,
                "name": "Kebbi",
                "iso2": "KE",
                "latitude": "11.49420030",
                "longitude": "4.23333550",
                "type": "state",
                "cities": [
                    {
                        "id": 76778,
                        "name": "Argungu",
                        "latitude": "12.74482000",
                        "longitude": "4.52514000"
                    },
                    {
                        "id": 76791,
                        "name": "Bagudo",
                        "latitude": "11.40351000",
                        "longitude": "4.22571000"
                    },
                    {
                        "id": 76798,
                        "name": "Bena",
                        "latitude": "11.28444000",
                        "longitude": "5.93472000"
                    },
                    {
                        "id": 76803,
                        "name": "Bin Yauri",
                        "latitude": "10.78230000",
                        "longitude": "4.81135000"
                    },
                    {
                        "id": 76805,
                        "name": "Birnin Kebbi",
                        "latitude": "12.45389000",
                        "longitude": "4.19750000"
                    },
                    {
                        "id": 76822,
                        "name": "Dabai",
                        "latitude": "11.47651000",
                        "longitude": "5.20625000"
                    },
                    {
                        "id": 76824,
                        "name": "Dakingari",
                        "latitude": "11.64809000",
                        "longitude": "4.06177000"
                    },
                    {
                        "id": 76891,
                        "name": "Gulma",
                        "latitude": "12.64231000",
                        "longitude": "4.35545000"
                    },
                    {
                        "id": 76896,
                        "name": "Gwandu",
                        "latitude": "12.50204000",
                        "longitude": "4.64295000"
                    },
                    {
                        "id": 76959,
                        "name": "Jega",
                        "latitude": "12.22336000",
                        "longitude": "4.37971000"
                    },
                    {
                        "id": 76974,
                        "name": "Kamba",
                        "latitude": "11.85172000",
                        "longitude": "3.65478000"
                    },
                    {
                        "id": 76975,
                        "name": "Kangiwa",
                        "latitude": "12.55339000",
                        "longitude": "3.81814000"
                    },
                    {
                        "id": 76983,
                        "name": "Kende",
                        "latitude": "11.51966000",
                        "longitude": "4.26030000"
                    },
                    {
                        "id": 77017,
                        "name": "Mahuta",
                        "latitude": "11.55338000",
                        "longitude": "4.98138000"
                    },
                    {
                        "id": 77019,
                        "name": "Maiyama",
                        "latitude": "12.08225000",
                        "longitude": "4.36907000"
                    },
                    {
                        "id": 77102,
                        "name": "Shanga",
                        "latitude": "11.21374000",
                        "longitude": "4.57941000"
                    },
                    {
                        "id": 77134,
                        "name": "Wasagu",
                        "latitude": "11.37640000",
                        "longitude": "5.79536000"
                    },
                    {
                        "id": 77153,
                        "name": "Zuru",
                        "latitude": "11.43522000",
                        "longitude": "5.23494000"
                    }
                ]
            },
            {
                "id": 298,
                "name": "Kogi",
                "iso2": "KO",
                "latitude": "7.73373250",
                "longitude": "6.69058360",
                "type": "state",
                "cities": [
                    {
                        "id": 76747,
                        "name": "Abocho",
                        "latitude": "7.56770000",
                        "longitude": "6.98630000"
                    },
                    {
                        "id": 76753,
                        "name": "Adoru",
                        "latitude": "6.97694000",
                        "longitude": "7.16262000"
                    },
                    {
                        "id": 76774,
                        "name": "Ankpa",
                        "latitude": "7.40249000",
                        "longitude": "7.63196000"
                    },
                    {
                        "id": 76816,
                        "name": "Bugana",
                        "latitude": "7.99917000",
                        "longitude": "7.58361000"
                    },
                    {
                        "id": 76840,
                        "name": "Dekina",
                        "latitude": "7.68967000",
                        "longitude": "7.04380000"
                    },
                    {
                        "id": 76854,
                        "name": "Egbe",
                        "latitude": "8.21667000",
                        "longitude": "5.51667000"
                    },
                    {
                        "id": 76909,
                        "name": "Icheu",
                        "latitude": "7.70670000",
                        "longitude": "6.77180000"
                    },
                    {
                        "id": 76910,
                        "name": "Idah",
                        "latitude": "7.11345000",
                        "longitude": "6.73866000"
                    },
                    {
                        "id": 76951,
                        "name": "Isanlu-Itedoijowa",
                        "latitude": "8.27445000",
                        "longitude": "5.83528000"
                    },
                    {
                        "id": 76964,
                        "name": "Kabba",
                        "latitude": "7.82719000",
                        "longitude": "6.07502000"
                    },
                    {
                        "id": 76988,
                        "name": "Koton-Karfe",
                        "latitude": "8.09120000",
                        "longitude": "6.79782000"
                    },
                    {
                        "id": 77011,
                        "name": "Lokoja",
                        "latitude": "7.79688000",
                        "longitude": "6.74048000"
                    },
                    {
                        "id": 77052,
                        "name": "Ogaminana",
                        "latitude": "7.59383000",
                        "longitude": "6.21798000"
                    },
                    {
                        "id": 77054,
                        "name": "Ogurugu",
                        "latitude": "6.78636000",
                        "longitude": "6.95017000"
                    },
                    {
                        "id": 77061,
                        "name": "Okene",
                        "latitude": "7.55122000",
                        "longitude": "6.23589000"
                    }
                ]
            },
            {
                "id": 295,
                "name": "Kwara",
                "iso2": "KW",
                "latitude": "8.96689610",
                "longitude": "4.38740510",
                "type": "state",
                "cities": [
                    {
                        "id": 76760,
                        "name": "Ajasse Ipo",
                        "latitude": "8.23333000",
                        "longitude": "4.81667000"
                    },
                    {
                        "id": 76809,
                        "name": "Bode Saadu",
                        "latitude": "8.93900000",
                        "longitude": "4.78227000"
                    },
                    {
                        "id": 76899,
                        "name": "Gwasero",
                        "latitude": "9.48333000",
                        "longitude": "3.50000000"
                    },
                    {
                        "id": 76946,
                        "name": "Ilorin",
                        "latitude": "8.49664000",
                        "longitude": "4.54214000"
                    },
                    {
                        "id": 76958,
                        "name": "Jebba",
                        "latitude": "9.11972000",
                        "longitude": "4.82360000"
                    },
                    {
                        "id": 76971,
                        "name": "Kaiama",
                        "latitude": "9.60530000",
                        "longitude": "3.94101000"
                    },
                    {
                        "id": 77001,
                        "name": "Lafiagi",
                        "latitude": "8.85299000",
                        "longitude": "5.41641000"
                    },
                    {
                        "id": 77051,
                        "name": "Offa",
                        "latitude": "8.14911000",
                        "longitude": "4.72074000"
                    },
                    {
                        "id": 77063,
                        "name": "Okuta",
                        "latitude": "9.21667000",
                        "longitude": "3.18333000"
                    },
                    {
                        "id": 77065,
                        "name": "Omu-Aran",
                        "latitude": "8.13857000",
                        "longitude": "5.10260000"
                    },
                    {
                        "id": 77087,
                        "name": "Patigi",
                        "latitude": "8.72851000",
                        "longitude": "5.75561000"
                    },
                    {
                        "id": 77109,
                        "name": "Suya",
                        "latitude": "9.46667000",
                        "longitude": "3.18333000"
                    },
                    {
                        "id": 77143,
                        "name": "Yashikera",
                        "latitude": "9.76667000",
                        "longitude": "3.40000000"
                    }
                ]
            },
            {
                "id": 306,
                "name": "Lagos",
                "iso2": "LA",
                "latitude": "6.52437930",
                "longitude": "3.37920570",
                "type": "state",
                "cities": [
                    {
                        "id": 153687,
                        "name": "Abule Egba",
                        "latitude": "6.65074410",
                        "longitude": "3.26554510"
                    },
                    {
                        "id": 153665,
                        "name": "Agege",
                        "latitude": "6.61522360",
                        "longitude": "3.30029700"
                    },
                    {
                        "id": 153661,
                        "name": "Alimosho",
                        "latitude": "6.58890000",
                        "longitude": "3.24850000"
                    },
                    {
                        "id": 153672,
                        "name": "Amuwo-Odofin",
                        "latitude": "6.44674340",
                        "longitude": "3.19682600"
                    },
                    {
                        "id": 76775,
                        "name": "Apapa",
                        "latitude": "6.44880000",
                        "longitude": "3.35901000"
                    },
                    {
                        "id": 76789,
                        "name": "Badagry",
                        "latitude": "6.41502000",
                        "longitude": "2.88132000"
                    },
                    {
                        "id": 153677,
                        "name": "Bariga",
                        "latitude": "6.53931230",
                        "longitude": "3.37627060"
                    },
                    {
                        "id": 76851,
                        "name": "Ebute Ikorodu",
                        "latitude": "6.60086000",
                        "longitude": "3.48818000"
                    },
                    {
                        "id": 153686,
                        "name": "Ebute Metta",
                        "latitude": "6.48437590",
                        "longitude": "3.37591680"
                    },
                    {
                        "id": 76857,
                        "name": "Ejirin",
                        "latitude": "6.61423000",
                        "longitude": "3.90019000"
                    },
                    {
                        "id": 76864,
                        "name": "Epe",
                        "latitude": "6.58412000",
                        "longitude": "3.98336000"
                    },
                    {
                        "id": 153666,
                        "name": "Eti-Osa",
                        "latitude": "6.46812400",
                        "longitude": "3.37093780"
                    },
                    {
                        "id": 153680,
                        "name": "Festac",
                        "latitude": "6.47178330",
                        "longitude": "3.26493870"
                    },
                    {
                        "id": 153674,
                        "name": "Ibeju-Lekki",
                        "latitude": "6.45764360",
                        "longitude": "3.62324400"
                    },
                    {
                        "id": 153682,
                        "name": "Idimu",
                        "latitude": "6.58337980",
                        "longitude": "3.20442780"
                    },
                    {
                        "id": 153671,
                        "name": "Ifako-Ijaiye",
                        "latitude": "6.68309720",
                        "longitude": "3.22079170"
                    },
                    {
                        "id": 153681,
                        "name": "Igando",
                        "latitude": "6.55132390",
                        "longitude": "3.22181130"
                    },
                    {
                        "id": 153679,
                        "name": "Ijora",
                        "latitude": "6.46330450",
                        "longitude": "3.34062410"
                    },
                    {
                        "id": 76932,
                        "name": "Ikeja",
                        "latitude": "6.59651000",
                        "longitude": "3.34205000"
                    },
                    {
                        "id": 153663,
                        "name": "Ikorodu",
                        "latitude": "6.61526000",
                        "longitude": "3.50690000"
                    },
                    {
                        "id": 153683,
                        "name": "Ipaja",
                        "latitude": "6.60983200",
                        "longitude": "3.22299940"
                    },
                    {
                        "id": 153664,
                        "name": "Isheri-Olofin",
                        "latitude": "6.58092030",
                        "longitude": "3.27417280"
                    },
                    {
                        "id": 77002,
                        "name": "Lagos",
                        "latitude": "6.45407000",
                        "longitude": "3.39467000"
                    },
                    {
                        "id": 153662,
                        "name": "Lagos Island",
                        "latitude": "6.44999820",
                        "longitude": "3.39999840"
                    },
                    {
                        "id": 153673,
                        "name": "Lekki",
                        "latitude": "6.51148130",
                        "longitude": "3.44453810"
                    },
                    {
                        "id": 77020,
                        "name": "Makoko",
                        "latitude": "6.49611000",
                        "longitude": "3.38778000"
                    },
                    {
                        "id": 153668,
                        "name": "Mushin",
                        "latitude": "6.53563240",
                        "longitude": "3.33022530"
                    },
                    {
                        "id": 153684,
                        "name": "Ogba",
                        "latitude": "6.62306240",
                        "longitude": "3.33418360"
                    },
                    {
                        "id": 153667,
                        "name": "Ojo",
                        "latitude": "6.46202130",
                        "longitude": "3.07969150"
                    },
                    {
                        "id": 153688,
                        "name": "Ojodu Berger",
                        "latitude": "6.64545230",
                        "longitude": "3.36639730"
                    },
                    {
                        "id": 153685,
                        "name": "Ojota",
                        "latitude": "6.58516560",
                        "longitude": "3.37092540"
                    },
                    {
                        "id": 153670,
                        "name": "Oshodi-Isolo",
                        "latitude": "6.53654830",
                        "longitude": "3.27551430"
                    },
                    {
                        "id": 153675,
                        "name": "Shomolu",
                        "latitude": "6.53759550",
                        "longitude": "3.36506450"
                    },
                    {
                        "id": 153669,
                        "name": "Surulere",
                        "latitude": "6.49009830",
                        "longitude": "3.30251430"
                    },
                    {
                        "id": 153676,
                        "name": "Victoria Island",
                        "latitude": "6.42998400",
                        "longitude": "3.40224490"
                    },
                    {
                        "id": 153678,
                        "name": "Yaba",
                        "latitude": "6.50594570",
                        "longitude": "3.36012860"
                    }
                ]
            },
            {
                "id": 301,
                "name": "Nasarawa",
                "iso2": "NA",
                "latitude": "8.49979080",
                "longitude": "8.19969370",
                "type": "state",
                "cities": [
                    {
                        "id": 76815,
                        "name": "Buga",
                        "latitude": "8.49056000",
                        "longitude": "7.34139000"
                    },
                    {
                        "id": 76845,
                        "name": "Doma",
                        "latitude": "8.39307000",
                        "longitude": "8.35544000"
                    },
                    {
                        "id": 76982,
                        "name": "Keffi",
                        "latitude": "8.84651000",
                        "longitude": "7.87354000"
                    },
                    {
                        "id": 77000,
                        "name": "Lafia",
                        "latitude": "8.49390000",
                        "longitude": "8.51532000"
                    },
                    {
                        "id": 77038,
                        "name": "Nasarawa",
                        "latitude": "8.53895000",
                        "longitude": "7.70821000"
                    },
                    {
                        "id": 77132,
                        "name": "Wamba",
                        "latitude": "8.94153000",
                        "longitude": "8.60315000"
                    }
                ]
            },
            {
                "id": 317,
                "name": "Niger",
                "iso2": "NI",
                "latitude": "9.93092240",
                "longitude": "5.59832100",
                "type": "state",
                "cities": [
                    {
                        "id": 76783,
                        "name": "Auna",
                        "latitude": "10.18805000",
                        "longitude": "4.72318000"
                    },
                    {
                        "id": 76787,
                        "name": "Babana",
                        "latitude": "10.42949000",
                        "longitude": "3.81495000"
                    },
                    {
                        "id": 76790,
                        "name": "Badeggi",
                        "latitude": "9.05630000",
                        "longitude": "6.14300000"
                    },
                    {
                        "id": 76795,
                        "name": "Baro",
                        "latitude": "8.61565000",
                        "longitude": "6.41850000"
                    },
                    {
                        "id": 76812,
                        "name": "Bokani",
                        "latitude": "9.43333000",
                        "longitude": "5.20000000"
                    },
                    {
                        "id": 76847,
                        "name": "Duku",
                        "latitude": "11.23610000",
                        "longitude": "4.90727000"
                    },
                    {
                        "id": 76907,
                        "name": "Ibeto",
                        "latitude": "10.48536000",
                        "longitude": "5.14501000"
                    },
                    {
                        "id": 76986,
                        "name": "Konkwesso",
                        "latitude": "10.84686000",
                        "longitude": "4.09835000"
                    },
                    {
                        "id": 76987,
                        "name": "Kontagora",
                        "latitude": "10.40319000",
                        "longitude": "5.47080000"
                    },
                    {
                        "id": 76994,
                        "name": "Kusheriki",
                        "latitude": "10.53283000",
                        "longitude": "6.44222000"
                    },
                    {
                        "id": 76995,
                        "name": "Kuta",
                        "latitude": "9.86864000",
                        "longitude": "6.71042000"
                    },
                    {
                        "id": 77007,
                        "name": "Lapai",
                        "latitude": "9.04439000",
                        "longitude": "6.57089000"
                    },
                    {
                        "id": 77029,
                        "name": "Minna",
                        "latitude": "9.61524000",
                        "longitude": "6.54776000"
                    },
                    {
                        "id": 77039,
                        "name": "New Shagunnu",
                        "latitude": "10.33957000",
                        "longitude": "4.46880000"
                    },
                    {
                        "id": 77108,
                        "name": "Suleja",
                        "latitude": "9.18059000",
                        "longitude": "7.17939000"
                    },
                    {
                        "id": 77112,
                        "name": "Tegina",
                        "latitude": "10.07060000",
                        "longitude": "6.19060000"
                    },
                    {
                        "id": 77124,
                        "name": "Ukata",
                        "latitude": "10.83122000",
                        "longitude": "5.82494000"
                    },
                    {
                        "id": 77135,
                        "name": "Wawa",
                        "latitude": "9.90222000",
                        "longitude": "4.41917000"
                    },
                    {
                        "id": 77152,
                        "name": "Zungeru",
                        "latitude": "9.80726000",
                        "longitude": "6.15238000"
                    }
                ]
            },
            {
                "id": 323,
                "name": "Ogun",
                "iso2": "OG",
                "latitude": "6.99797470",
                "longitude": "3.47373780",
                "type": "state",
                "cities": [
                    {
                        "id": 76746,
                        "name": "Abeokuta",
                        "latitude": "7.15571000",
                        "longitude": "3.34509000"
                    },
                    {
                        "id": 76751,
                        "name": "Ado Odo",
                        "latitude": "6.60000000",
                        "longitude": "2.93333000"
                    },
                    {
                        "id": 76912,
                        "name": "Idi Iroko",
                        "latitude": "6.63333000",
                        "longitude": "2.73333000"
                    },
                    {
                        "id": 76914,
                        "name": "Ifo",
                        "latitude": "6.81491000",
                        "longitude": "3.19518000"
                    },
                    {
                        "id": 76926,
                        "name": "Ijebu-Ife",
                        "latitude": "6.77837000",
                        "longitude": "4.03386000"
                    },
                    {
                        "id": 76927,
                        "name": "Ijebu-Igbo",
                        "latitude": "6.97198000",
                        "longitude": "3.99938000"
                    },
                    {
                        "id": 76929,
                        "name": "Ijebu-Ode",
                        "latitude": "6.81944000",
                        "longitude": "3.91731000"
                    },
                    {
                        "id": 76940,
                        "name": "Ilaro",
                        "latitude": "6.88901000",
                        "longitude": "3.01416000"
                    },
                    {
                        "id": 76947,
                        "name": "Imeko",
                        "latitude": "7.44888000",
                        "longitude": "2.84289000"
                    },
                    {
                        "id": 76949,
                        "name": "Iperu",
                        "latitude": "6.91002000",
                        "longitude": "3.66557000"
                    },
                    {
                        "id": 76952,
                        "name": "Isara",
                        "latitude": "6.99345000",
                        "longitude": "3.68148000"
                    },
                    {
                        "id": 77080,
                        "name": "Owode",
                        "latitude": "6.94851000",
                        "longitude": "3.50561000"
                    }
                ]
            },
            {
                "id": 321,
                "name": "Ondo",
                "iso2": "ON",
                "latitude": "6.91486820",
                "longitude": "5.14781440",
                "type": "state",
                "cities": [
                    {
                        "id": 76755,
                        "name": "Agbabu",
                        "latitude": "6.58862000",
                        "longitude": "4.83430000"
                    },
                    {
                        "id": 76765,
                        "name": "Akure",
                        "latitude": "7.25256000",
                        "longitude": "5.19312000"
                    },
                    {
                        "id": 76911,
                        "name": "Idanre",
                        "latitude": "7.11270000",
                        "longitude": "5.11590000"
                    },
                    {
                        "id": 76915,
                        "name": "Ifon",
                        "latitude": "6.92973000",
                        "longitude": "5.77368000"
                    },
                    {
                        "id": 76939,
                        "name": "Ilare",
                        "latitude": "7.35067000",
                        "longitude": "5.11333000"
                    },
                    {
                        "id": 77050,
                        "name": "Ode",
                        "latitude": "7.78990000",
                        "longitude": "5.71170000"
                    },
                    {
                        "id": 77067,
                        "name": "Ondo",
                        "latitude": "7.09316000",
                        "longitude": "4.83528000"
                    },
                    {
                        "id": 77070,
                        "name": "Ore",
                        "latitude": "6.74716000",
                        "longitude": "4.87610000"
                    },
                    {
                        "id": 77079,
                        "name": "Owo",
                        "latitude": "7.19620000",
                        "longitude": "5.58681000"
                    }
                ]
            },
            {
                "id": 322,
                "name": "Osun",
                "iso2": "OS",
                "latitude": "7.56289640",
                "longitude": "4.51995930",
                "type": "state",
                "cities": [
                    {
                        "id": 76776,
                        "name": "Apomu",
                        "latitude": "7.35156000",
                        "longitude": "4.18335000"
                    },
                    {
                        "id": 76856,
                        "name": "Ejigbo",
                        "latitude": "7.90292000",
                        "longitude": "4.31419000"
                    },
                    {
                        "id": 76881,
                        "name": "Gbongan",
                        "latitude": "7.47734000",
                        "longitude": "4.35351000"
                    },
                    {
                        "id": 76928,
                        "name": "Ijebu-Jesa",
                        "latitude": "7.68287000",
                        "longitude": "4.81769000"
                    },
                    {
                        "id": 76935,
                        "name": "Ikire",
                        "latitude": "7.36983000",
                        "longitude": "4.18630000"
                    },
                    {
                        "id": 76936,
                        "name": "Ikirun",
                        "latitude": "7.91283000",
                        "longitude": "4.66741000"
                    },
                    {
                        "id": 76938,
                        "name": "Ila Orangun",
                        "latitude": "8.01714000",
                        "longitude": "4.90421000"
                    },
                    {
                        "id": 76941,
                        "name": "Ile-Ife",
                        "latitude": "7.48240000",
                        "longitude": "4.56032000"
                    },
                    {
                        "id": 76942,
                        "name": "Ilesa",
                        "latitude": "7.62789000",
                        "longitude": "4.74161000"
                    },
                    {
                        "id": 76945,
                        "name": "Ilobu",
                        "latitude": "7.84036000",
                        "longitude": "4.48557000"
                    },
                    {
                        "id": 76948,
                        "name": "Inisa",
                        "latitude": "7.85000000",
                        "longitude": "4.33333000"
                    },
                    {
                        "id": 76956,
                        "name": "Iwo",
                        "latitude": "7.63527000",
                        "longitude": "4.18156000"
                    },
                    {
                        "id": 77032,
                        "name": "Modakeke",
                        "latitude": "7.38299000",
                        "longitude": "4.26031000"
                    },
                    {
                        "id": 77059,
                        "name": "Oke Mesi",
                        "latitude": "7.81667000",
                        "longitude": "4.91667000"
                    },
                    {
                        "id": 77064,
                        "name": "Olupona",
                        "latitude": "7.60000000",
                        "longitude": "4.18333000"
                    },
                    {
                        "id": 77075,
                        "name": "Osogbo",
                        "latitude": "7.77104000",
                        "longitude": "4.55698000"
                    },
                    {
                        "id": 77076,
                        "name": "Otan Ayegbaju",
                        "latitude": "7.94783000",
                        "longitude": "4.78836000"
                    },
                    {
                        "id": 77081,
                        "name": "Oyan",
                        "latitude": "8.05000000",
                        "longitude": "4.76667000"
                    }
                ]
            },
            {
                "id": 296,
                "name": "Oyo",
                "iso2": "OY",
                "latitude": "8.15738090",
                "longitude": "3.61465340",
                "type": "state",
                "cities": [
                    {
                        "id": 76758,
                        "name": "Ago Are",
                        "latitude": "8.50000000",
                        "longitude": "3.41667000"
                    },
                    {
                        "id": 76766,
                        "name": "Alapa",
                        "latitude": "8.61667000",
                        "longitude": "4.38333000"
                    },
                    {
                        "id": 76868,
                        "name": "Fiditi",
                        "latitude": "7.71361000",
                        "longitude": "3.91722000"
                    },
                    {
                        "id": 76906,
                        "name": "Ibadan",
                        "latitude": "7.37756000",
                        "longitude": "3.90591000"
                    },
                    {
                        "id": 76918,
                        "name": "Igbeti",
                        "latitude": "8.74921000",
                        "longitude": "4.13113000"
                    },
                    {
                        "id": 76919,
                        "name": "Igbo-Ora",
                        "latitude": "7.43383000",
                        "longitude": "3.28788000"
                    },
                    {
                        "id": 76921,
                        "name": "Igboho",
                        "latitude": "8.83784000",
                        "longitude": "3.75628000"
                    },
                    {
                        "id": 76984,
                        "name": "Kisi",
                        "latitude": "9.08297000",
                        "longitude": "3.85196000"
                    },
                    {
                        "id": 77004,
                        "name": "Lalupon",
                        "latitude": "7.46791000",
                        "longitude": "4.06594000"
                    },
                    {
                        "id": 77053,
                        "name": "Ogbomoso",
                        "latitude": "8.13373000",
                        "longitude": "4.24014000"
                    },
                    {
                        "id": 77060,
                        "name": "Okeho",
                        "latitude": "8.03386000",
                        "longitude": "3.34759000"
                    },
                    {
                        "id": 77072,
                        "name": "Orita Eruwa",
                        "latitude": "7.55000000",
                        "longitude": "3.43333000"
                    },
                    {
                        "id": 77082,
                        "name": "Oyo",
                        "latitude": "7.85257000",
                        "longitude": "3.93125000"
                    },
                    {
                        "id": 77096,
                        "name": "Saki",
                        "latitude": "8.66762000",
                        "longitude": "3.39393000"
                    }
                ]
            },
            {
                "id": 302,
                "name": "Plateau",
                "iso2": "PL",
                "latitude": "9.21820930",
                "longitude": "9.51794880",
                "type": "state",
                "cities": [
                    {
                        "id": 76771,
                        "name": "Amper",
                        "latitude": "9.35509000",
                        "longitude": "9.70121000"
                    },
                    {
                        "id": 76817,
                        "name": "Bukuru",
                        "latitude": "9.79399000",
                        "longitude": "8.86397000"
                    },
                    {
                        "id": 76841,
                        "name": "Dengi",
                        "latitude": "9.36872000",
                        "longitude": "9.96223000"
                    },
                    {
                        "id": 76963,
                        "name": "Jos",
                        "latitude": "9.92849000",
                        "longitude": "8.89212000"
                    },
                    {
                        "id": 76999,
                        "name": "Kwolla",
                        "latitude": "8.90361000",
                        "longitude": "9.29086000"
                    },
                    {
                        "id": 77006,
                        "name": "Langtang",
                        "latitude": "9.14164000",
                        "longitude": "9.79101000"
                    },
                    {
                        "id": 77084,
                        "name": "Pankshin",
                        "latitude": "9.32541000",
                        "longitude": "9.43520000"
                    },
                    {
                        "id": 77085,
                        "name": "Panyam",
                        "latitude": "9.40756000",
                        "longitude": "9.21481000"
                    },
                    {
                        "id": 77130,
                        "name": "Vom",
                        "latitude": "9.72910000",
                        "longitude": "8.79138000"
                    },
                    {
                        "id": 77144,
                        "name": "Yelwa",
                        "latitude": "8.83333000",
                        "longitude": "9.63333000"
                    }
                ]
            },
            {
                "id": 4926,
                "name": "Rivers",
                "iso2": "RI",
                "latitude": "5.02134200",
                "longitude": "6.43760220",
                "type": "state",
                "cities": [
                    {
                        "id": 148541,
                        "name": "Abalama",
                        "latitude": "4.76305556",
                        "longitude": "6.84027778"
                    },
                    {
                        "id": 148542,
                        "name": "Abonnema",
                        "latitude": "4.72311690",
                        "longitude": "6.77884610"
                    },
                    {
                        "id": 148543,
                        "name": "Ahoada",
                        "latitude": "5.08333333",
                        "longitude": "6.65000000"
                    },
                    {
                        "id": 148544,
                        "name": "Bori",
                        "latitude": "4.67277778",
                        "longitude": "7.37027778"
                    },
                    {
                        "id": 148545,
                        "name": "Buguma",
                        "latitude": "4.73333333",
                        "longitude": "6.86666667"
                    },
                    {
                        "id": 148546,
                        "name": "Chokocho",
                        "latitude": "4.99083300",
                        "longitude": "7.05444400"
                    },
                    {
                        "id": 148547,
                        "name": "Elele",
                        "latitude": "5.10184167",
                        "longitude": "6.81902222"
                    },
                    {
                        "id": 148548,
                        "name": "Obonoma",
                        "latitude": "4.71138889",
                        "longitude": "6.79083333"
                    },
                    {
                        "id": 148549,
                        "name": "Omoku",
                        "latitude": "5.34200000",
                        "longitude": "6.65600000"
                    },
                    {
                        "id": 148550,
                        "name": "Onne",
                        "latitude": "4.74444444",
                        "longitude": "7.03611111"
                    },
                    {
                        "id": 148551,
                        "name": "Opobo",
                        "latitude": "4.51138889",
                        "longitude": "7.54000000"
                    },
                    {
                        "id": 148552,
                        "name": "Port Harcourt",
                        "latitude": "4.75000000",
                        "longitude": "7.00000000"
                    },
                    {
                        "id": 148553,
                        "name": "Rumuokoro",
                        "latitude": "4.86666667",
                        "longitude": "6.98333333"
                    }
                ]
            },
            {
                "id": 292,
                "name": "Sokoto",
                "iso2": "SO",
                "latitude": "13.05331430",
                "longitude": "5.32227220",
                "type": "state",
                "cities": [
                    {
                        "id": 76804,
                        "name": "Binji",
                        "latitude": "13.22294000",
                        "longitude": "4.90888000"
                    },
                    {
                        "id": 76830,
                        "name": "Dange",
                        "latitude": "12.85313000",
                        "longitude": "5.34572000"
                    },
                    {
                        "id": 76875,
                        "name": "Gandi",
                        "latitude": "12.96358000",
                        "longitude": "5.74337000"
                    },
                    {
                        "id": 76889,
                        "name": "Goronyo",
                        "latitude": "13.44226000",
                        "longitude": "5.67234000"
                    },
                    {
                        "id": 76895,
                        "name": "Gwadabawa",
                        "latitude": "13.35819000",
                        "longitude": "5.23812000"
                    },
                    {
                        "id": 76943,
                        "name": "Illela",
                        "latitude": "13.73064000",
                        "longitude": "5.29777000"
                    },
                    {
                        "id": 77090,
                        "name": "Rabah",
                        "latitude": "13.12257000",
                        "longitude": "5.50762000"
                    },
                    {
                        "id": 77107,
                        "name": "Sokoto",
                        "latitude": "13.06269000",
                        "longitude": "5.24322000"
                    },
                    {
                        "id": 77111,
                        "name": "Tambuwal",
                        "latitude": "12.40592000",
                        "longitude": "4.64605000"
                    },
                    {
                        "id": 77137,
                        "name": "Wurno",
                        "latitude": "13.29048000",
                        "longitude": "5.42373000"
                    }
                ]
            },
            {
                "id": 319,
                "name": "Taraba",
                "iso2": "TA",
                "latitude": "7.99936160",
                "longitude": "10.77398630",
                "type": "state",
                "cities": [
                    {
                        "id": 76792,
                        "name": "Baissa",
                        "latitude": "7.23087000",
                        "longitude": "10.62444000"
                    },
                    {
                        "id": 76797,
                        "name": "Beli",
                        "latitude": "7.85868000",
                        "longitude": "10.97187000"
                    },
                    {
                        "id": 76879,
                        "name": "Gassol",
                        "latitude": "8.53535000",
                        "longitude": "10.44615000"
                    },
                    {
                        "id": 76883,
                        "name": "Gembu",
                        "latitude": "6.72556000",
                        "longitude": "11.25652000"
                    },
                    {
                        "id": 76908,
                        "name": "Ibi",
                        "latitude": "8.18122000",
                        "longitude": "9.74431000"
                    },
                    {
                        "id": 76957,
                        "name": "Jalingo",
                        "latitude": "8.89367000",
                        "longitude": "11.35960000"
                    },
                    {
                        "id": 77008,
                        "name": "Lau",
                        "latitude": "9.20827000",
                        "longitude": "11.27541000"
                    },
                    {
                        "id": 77036,
                        "name": "Mutum Biyu",
                        "latitude": "8.64138000",
                        "longitude": "10.77355000"
                    },
                    {
                        "id": 77092,
                        "name": "Riti",
                        "latitude": "7.90844000",
                        "longitude": "9.61688000"
                    },
                    {
                        "id": 77136,
                        "name": "Wukari",
                        "latitude": "7.87139000",
                        "longitude": "9.77786000"
                    }
                ]
            },
            {
                "id": 297,
                "name": "Yobe",
                "iso2": "YO",
                "latitude": "12.29387600",
                "longitude": "11.43904110",
                "type": "state",
                "cities": [
                    {
                        "id": 76826,
                        "name": "Damaturu",
                        "latitude": "11.74697000",
                        "longitude": "11.96083000"
                    },
                    {
                        "id": 76832,
                        "name": "Dankalwa",
                        "latitude": "11.74449000",
                        "longitude": "12.18545000"
                    },
                    {
                        "id": 76834,
                        "name": "Dapchi",
                        "latitude": "12.49536000",
                        "longitude": "11.49977000"
                    },
                    {
                        "id": 76837,
                        "name": "Daura",
                        "latitude": "11.55410000",
                        "longitude": "11.40600000"
                    },
                    {
                        "id": 76869,
                        "name": "Fika",
                        "latitude": "11.37700000",
                        "longitude": "11.23746000"
                    },
                    {
                        "id": 76878,
                        "name": "Gashua",
                        "latitude": "12.87398000",
                        "longitude": "11.04057000"
                    },
                    {
                        "id": 76882,
                        "name": "Geidam",
                        "latitude": "12.89439000",
                        "longitude": "11.92649000"
                    },
                    {
                        "id": 76886,
                        "name": "Goniri",
                        "latitude": "11.48451000",
                        "longitude": "12.31264000"
                    },
                    {
                        "id": 76888,
                        "name": "Gorgoram",
                        "latitude": "12.63958000",
                        "longitude": "10.70422000"
                    },
                    {
                        "id": 76890,
                        "name": "Gujba",
                        "latitude": "11.49959000",
                        "longitude": "11.93396000"
                    },
                    {
                        "id": 76900,
                        "name": "Gwio Kura",
                        "latitude": "12.67479000",
                        "longitude": "11.06690000"
                    },
                    {
                        "id": 76992,
                        "name": "Kumagunnam",
                        "latitude": "13.15498000",
                        "longitude": "10.63468000"
                    },
                    {
                        "id": 77003,
                        "name": "Lajere",
                        "latitude": "11.98022000",
                        "longitude": "11.44002000"
                    },
                    {
                        "id": 77012,
                        "name": "Machina",
                        "latitude": "13.13639000",
                        "longitude": "10.04924000"
                    },
                    {
                        "id": 77042,
                        "name": "Nguru",
                        "latitude": "12.87695000",
                        "longitude": "10.45536000"
                    },
                    {
                        "id": 77089,
                        "name": "Potiskum",
                        "latitude": "11.71391000",
                        "longitude": "11.08108000"
                    }
                ]
            },
            {
                "id": 299,
                "name": "Zamfara",
                "iso2": "ZA",
                "latitude": "12.12218050",
                "longitude": "6.22358190",
                "type": "state",
                "cities": [
                    {
                        "id": 76773,
                        "name": "Anka",
                        "latitude": "12.11347000",
                        "longitude": "5.92681000"
                    },
                    {
                        "id": 76829,
                        "name": "Dan Sadau",
                        "latitude": "11.29621000",
                        "longitude": "6.49520000"
                    },
                    {
                        "id": 76893,
                        "name": "Gummi",
                        "latitude": "12.14484000",
                        "longitude": "5.11776000"
                    },
                    {
                        "id": 76894,
                        "name": "Gusau",
                        "latitude": "12.17024000",
                        "longitude": "6.66412000"
                    },
                    {
                        "id": 76980,
                        "name": "Kaura Namoda",
                        "latitude": "12.59371000",
                        "longitude": "6.58648000"
                    },
                    {
                        "id": 76998,
                        "name": "Kwatarkwashi",
                        "latitude": "12.14082000",
                        "longitude": "6.82196000"
                    },
                    {
                        "id": 77025,
                        "name": "Maru",
                        "latitude": "12.33360000",
                        "longitude": "6.40372000"
                    },
                    {
                        "id": 77034,
                        "name": "Moriki",
                        "latitude": "12.87405000",
                        "longitude": "6.48754000"
                    },
                    {
                        "id": 77100,
                        "name": "Sauri",
                        "latitude": "11.72655000",
                        "longitude": "6.78374000"
                    },
                    {
                        "id": 77115,
                        "name": "Tsafe",
                        "latitude": "11.95775000",
                        "longitude": "6.92083000"
                    }
                ]
            }
        ]
    },
    {
        "id": 162,
        "name": "Niue",
        "iso3": "NIU",
        "iso2": "NU",
        "numeric_code": "570",
        "phonecode": "683",
        "capital": "Alofi",
        "currency": "NZD",
        "currency_name": "New Zealand dollar",
        "currency_symbol": "$",
        "tld": ".nu",
        "native": "Niuē",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Polynesia",
        "subregion_id": 22,
        "nationality": "Niuean",
        "timezones": [
            {
                "zoneName": "Pacific\/Niue",
                "gmtOffset": -39600,
                "gmtOffsetName": "UTC-11:00",
                "abbreviation": "NUT",
                "tzName": "Niue Time"
            }
        ],
        "translations": {
            "br": "Niue",
            "ko": "니우에",
            "pt-BR": "Niue",
            "pt": "Niue",
            "nl": "Niue",
            "hr": "Niue",
            "fa": "نیووی",
            "de": "Niue",
            "es": "Niue",
            "fr": "Niue",
            "ja": "ニウエ",
            "it": "Niue",
            "zh-CN": "纽埃",
            "tr": "Niue",
            "ru": "Ниуэ",
            "uk": "Ніуе",
            "pl": "Niue"
        },
        "latitude": "-19.03333333",
        "longitude": "-169.86666666",
        "emoji": "🇳🇺",
        "emojiU": "U+1F1F3 U+1F1FA",
        "states": [
            {
                "id": 5435,
                "name": "Alofi North",
                "iso2": "14",
                "latitude": "-19.04889770",
                "longitude": "-169.91909050",
                "type": "village",
                "cities": []
            },
            {
                "id": 5434,
                "name": "Alofi South",
                "iso2": "13",
                "latitude": "-19.07359680",
                "longitude": "-169.94804080",
                "type": "village",
                "cities": []
            },
            {
                "id": 5432,
                "name": "Avatele",
                "iso2": "11",
                "latitude": "-19.12373020",
                "longitude": "-169.91656780",
                "type": "village",
                "cities": []
            },
            {
                "id": 5430,
                "name": "Hakupu",
                "iso2": "09",
                "latitude": "-19.12872750",
                "longitude": "-169.84921230",
                "type": "village",
                "cities": []
            },
            {
                "id": 5425,
                "name": "Hikutavake",
                "iso2": "04",
                "latitude": "-18.97755110",
                "longitude": "-169.89445360",
                "type": "village",
                "cities": []
            },
            {
                "id": 5428,
                "name": "Lakepa",
                "iso2": "07",
                "latitude": "-19.00964250",
                "longitude": "-169.81200460",
                "type": "village",
                "cities": []
            },
            {
                "id": 5429,
                "name": "Liku",
                "iso2": "08",
                "latitude": "-19.05369070",
                "longitude": "-169.79425910",
                "type": "village",
                "cities": []
            },
            {
                "id": 5422,
                "name": "Makefu",
                "iso2": "01",
                "latitude": "-19.00326180",
                "longitude": "-169.92047320",
                "type": "village",
                "cities": []
            },
            {
                "id": 5427,
                "name": "Mutalau",
                "iso2": "06",
                "latitude": "-18.96393850",
                "longitude": "-169.83278630",
                "type": "village",
                "cities": []
            },
            {
                "id": 5424,
                "name": "Namukulu",
                "iso2": "03",
                "latitude": "-18.98122750",
                "longitude": "-169.90294220",
                "type": "village",
                "cities": []
            },
            {
                "id": 5433,
                "name": "Tamakautoga",
                "iso2": "12",
                "latitude": "-19.10198510",
                "longitude": "-169.93017210",
                "type": "village",
                "cities": []
            },
            {
                "id": 5426,
                "name": "Toi",
                "iso2": "05",
                "latitude": "-18.97376000",
                "longitude": "-169.86297740",
                "type": "village",
                "cities": []
            },
            {
                "id": 5423,
                "name": "Tuapa",
                "iso2": "02",
                "latitude": "-18.99125070",
                "longitude": "-169.90920780",
                "type": "village",
                "cities": []
            },
            {
                "id": 5431,
                "name": "Vaiea",
                "iso2": "10",
                "latitude": "-19.13083580",
                "longitude": "-169.89380120",
                "type": "village",
                "cities": []
            }
        ]
    },
    {
        "id": 163,
        "name": "Norfolk Island",
        "iso3": "NFK",
        "iso2": "NF",
        "numeric_code": "574",
        "phonecode": "672",
        "capital": "Kingston",
        "currency": "AUD",
        "currency_name": "Australian dollar",
        "currency_symbol": "$",
        "tld": ".nf",
        "native": "Norfolk Island",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Australia and New Zealand",
        "subregion_id": 19,
        "nationality": "Norfolk Island",
        "timezones": [
            {
                "zoneName": "Pacific\/Norfolk",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "NFT",
                "tzName": "Norfolk Time"
            }
        ],
        "translations": {
            "br": "Enez Norfolk",
            "ko": "노퍽 섬",
            "pt-BR": "Ilha Norfolk",
            "pt": "Ilha Norfolk",
            "nl": "Norfolkeiland",
            "hr": "Otok Norfolk",
            "fa": "جزیره نورفک",
            "de": "Norfolkinsel",
            "es": "Isla de Norfolk",
            "fr": "Île de Norfolk",
            "ja": "ノーフォーク島",
            "it": "Isola Norfolk",
            "zh-CN": "诺福克岛",
            "tr": "Norfolk Adasi",
            "ru": "Остров Норфолк",
            "uk": "Острів Норфолк",
            "pl": "Wyspa Norfolk"
        },
        "latitude": "-29.03333333",
        "longitude": "167.95000000",
        "emoji": "🇳🇫",
        "emojiU": "U+1F1F3 U+1F1EB",
        "states": []
    },
    {
        "id": 115,
        "name": "North Korea",
        "iso3": "PRK",
        "iso2": "KP",
        "numeric_code": "408",
        "phonecode": "850",
        "capital": "Pyongyang",
        "currency": "KPW",
        "currency_name": "North Korean Won",
        "currency_symbol": "₩",
        "tld": ".kp",
        "native": "북한",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Eastern Asia",
        "subregion_id": 12,
        "nationality": "North Korean",
        "timezones": [
            {
                "zoneName": "Asia\/Pyongyang",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "KST",
                "tzName": "Korea Standard Time"
            }
        ],
        "translations": {
            "br": "Korea an Norzh",
            "ko": "조선민주주의인민공화국",
            "pt-BR": "Coreia do Norte",
            "pt": "Coreia do Norte",
            "nl": "Noord-Korea",
            "hr": "Sjeverna Koreja",
            "fa": "کره جنوبی",
            "de": "Nordkorea",
            "es": "Corea del Norte",
            "fr": "Corée du Nord",
            "ja": "朝鮮民主主義人民共和国",
            "it": "Corea del Nord",
            "zh-CN": "朝鲜",
            "tr": "Kuzey Kore",
            "ru": "Северная Корея",
            "uk": "Північна Корея",
            "pl": "Korea Północna"
        },
        "latitude": "40.00000000",
        "longitude": "127.00000000",
        "emoji": "🇰🇵",
        "emojiU": "U+1F1F0 U+1F1F5",
        "states": [
            {
                "id": 3998,
                "name": "Chagang",
                "iso2": "04",
                "latitude": "40.72028090",
                "longitude": "126.56211370",
                "type": "province",
                "cities": [
                    {
                        "id": 65186,
                        "name": "Changgang-gun",
                        "latitude": "41.06333000",
                        "longitude": "126.72556000"
                    },
                    {
                        "id": 65188,
                        "name": "Chasŏng",
                        "latitude": "41.46083000",
                        "longitude": "126.64139000"
                    },
                    {
                        "id": 65208,
                        "name": "Kanggye",
                        "latitude": "40.96946000",
                        "longitude": "126.58523000"
                    },
                    {
                        "id": 65221,
                        "name": "Manp’o",
                        "latitude": "41.15472000",
                        "longitude": "126.28944000"
                    }
                ]
            },
            {
                "id": 3999,
                "name": "Kangwon",
                "iso2": "07",
                "latitude": "38.84323930",
                "longitude": "127.55970670",
                "type": "province",
                "cities": [
                    {
                        "id": 65181,
                        "name": "Anbyŏn-ŭp",
                        "latitude": "39.04250000",
                        "longitude": "127.52389000"
                    },
                    {
                        "id": 65198,
                        "name": "Hoeyang",
                        "latitude": "38.71028000",
                        "longitude": "127.59833000"
                    },
                    {
                        "id": 65214,
                        "name": "Kosan",
                        "latitude": "38.85583000",
                        "longitude": "127.41806000"
                    },
                    {
                        "id": 65250,
                        "name": "T’ongch’ŏn-ŭp",
                        "latitude": "38.95389000",
                        "longitude": "127.89167000"
                    },
                    {
                        "id": 65252,
                        "name": "Wŏnsan",
                        "latitude": "39.15278000",
                        "longitude": "127.44361000"
                    }
                ]
            },
            {
                "id": 3995,
                "name": "North Hamgyong",
                "iso2": "09",
                "latitude": "41.81487580",
                "longitude": "129.45819550",
                "type": "province",
                "cities": [
                    {
                        "id": 65183,
                        "name": "Aoji",
                        "latitude": "42.52448000",
                        "longitude": "130.39718000"
                    },
                    {
                        "id": 65189,
                        "name": "Chongjin",
                        "latitude": "41.79556000",
                        "longitude": "129.77583000"
                    },
                    {
                        "id": 65195,
                        "name": "Hau-ri",
                        "latitude": "41.20056000",
                        "longitude": "129.47028000"
                    },
                    {
                        "id": 65196,
                        "name": "Hoemul-li",
                        "latitude": "41.43389000",
                        "longitude": "129.67000000"
                    },
                    {
                        "id": 65197,
                        "name": "Hoeryŏng",
                        "latitude": "42.44113000",
                        "longitude": "129.74601000"
                    },
                    {
                        "id": 65210,
                        "name": "Kilju",
                        "latitude": "40.96417000",
                        "longitude": "129.32778000"
                    },
                    {
                        "id": 65211,
                        "name": "Kimch’aek-si",
                        "latitude": "40.66889000",
                        "longitude": "129.18972000"
                    },
                    {
                        "id": 65213,
                        "name": "Komusan Il-tong",
                        "latitude": "42.10914000",
                        "longitude": "129.69997000"
                    },
                    {
                        "id": 65219,
                        "name": "Kyŏngsŏng",
                        "latitude": "41.58778000",
                        "longitude": "129.60611000"
                    },
                    {
                        "id": 65220,
                        "name": "Kyŏngwŏn",
                        "latitude": "42.81361000",
                        "longitude": "130.15278000"
                    },
                    {
                        "id": 65222,
                        "name": "Musan-ŭp",
                        "latitude": "42.22609000",
                        "longitude": "129.20776000"
                    },
                    {
                        "id": 65224,
                        "name": "Namyang-dong",
                        "latitude": "42.95000000",
                        "longitude": "129.86667000"
                    },
                    {
                        "id": 65225,
                        "name": "Nanam",
                        "latitude": "41.71361000",
                        "longitude": "129.68444000"
                    },
                    {
                        "id": 65227,
                        "name": "Onsŏng",
                        "latitude": "42.95722000",
                        "longitude": "129.99333000"
                    },
                    {
                        "id": 65230,
                        "name": "Puryŏng",
                        "latitude": "42.06056000",
                        "longitude": "129.71167000"
                    },
                    {
                        "id": 65247,
                        "name": "Sŭngam-nodongjagu",
                        "latitude": "41.66972000",
                        "longitude": "129.66889000"
                    }
                ]
            },
            {
                "id": 4004,
                "name": "North Hwanghae",
                "iso2": "06",
                "latitude": "38.37860850",
                "longitude": "126.43643630",
                "type": "province",
                "cities": [
                    {
                        "id": 65180,
                        "name": "Anak",
                        "latitude": "38.51083000",
                        "longitude": "125.49417000"
                    },
                    {
                        "id": 65203,
                        "name": "Hŭkkyo-ri",
                        "latitude": "38.79861000",
                        "longitude": "125.79194000"
                    },
                    {
                        "id": 65200,
                        "name": "Hwangju-ŭp",
                        "latitude": "38.67028000",
                        "longitude": "125.77611000"
                    },
                    {
                        "id": 65212,
                        "name": "Koksan",
                        "latitude": "38.78194000",
                        "longitude": "126.66639000"
                    },
                    {
                        "id": 65237,
                        "name": "Sariwŏn",
                        "latitude": "38.50722000",
                        "longitude": "125.75583000"
                    },
                    {
                        "id": 65240,
                        "name": "Sinmak",
                        "latitude": "38.41667000",
                        "longitude": "126.23333000"
                    },
                    {
                        "id": 65243,
                        "name": "Songnim",
                        "latitude": "38.75417000",
                        "longitude": "125.64500000"
                    }
                ]
            },
            {
                "id": 4002,
                "name": "North Pyongan",
                "iso2": "03",
                "latitude": "39.92556180",
                "longitude": "125.39280250",
                "type": "province",
                "cities": [
                    {
                        "id": 65191,
                        "name": "Chŏngju",
                        "latitude": "39.69333000",
                        "longitude": "125.21028000"
                    },
                    {
                        "id": 65192,
                        "name": "Chŏngju-gun",
                        "latitude": "39.70944000",
                        "longitude": "125.25278000"
                    },
                    {
                        "id": 65216,
                        "name": "Kujang-ŭp",
                        "latitude": "39.86722000",
                        "longitude": "126.03028000"
                    },
                    {
                        "id": 65217,
                        "name": "Kusŏng",
                        "latitude": "39.98111000",
                        "longitude": "125.24472000"
                    },
                    {
                        "id": 65218,
                        "name": "Kwaksan",
                        "latitude": "39.68750000",
                        "longitude": "125.08278000"
                    },
                    {
                        "id": 65228,
                        "name": "Panghyŏn-dong",
                        "latitude": "39.88722000",
                        "longitude": "125.24139000"
                    },
                    {
                        "id": 65229,
                        "name": "Pukchil-lodongjagu",
                        "latitude": "40.20194000",
                        "longitude": "125.74833000"
                    },
                    {
                        "id": 65234,
                        "name": "Sakchu-ŭp",
                        "latitude": "40.38944000",
                        "longitude": "125.04667000"
                    },
                    {
                        "id": 65242,
                        "name": "Sinŭiju",
                        "latitude": "40.10056000",
                        "longitude": "124.39806000"
                    },
                    {
                        "id": 65259,
                        "name": "Ŭiju",
                        "latitude": "40.19944000",
                        "longitude": "124.53167000"
                    },
                    {
                        "id": 65255,
                        "name": "Yŏmju-ŭp",
                        "latitude": "39.89333000",
                        "longitude": "124.59806000"
                    },
                    {
                        "id": 65257,
                        "name": "Yŏngbyŏn",
                        "latitude": "39.81333000",
                        "longitude": "125.80417000"
                    }
                ]
            },
            {
                "id": 4005,
                "name": "Pyongyang",
                "iso2": "01",
                "latitude": "39.03921930",
                "longitude": "125.76252410",
                "type": "capital city",
                "cities": [
                    {
                        "id": 65190,
                        "name": "Chunghwa",
                        "latitude": "38.86389000",
                        "longitude": "125.80000000"
                    },
                    {
                        "id": 65207,
                        "name": "Kangdong-ŭp",
                        "latitude": "39.14250000",
                        "longitude": "126.09611000"
                    },
                    {
                        "id": 65231,
                        "name": "Pyongyang",
                        "latitude": "39.03385000",
                        "longitude": "125.75432000"
                    },
                    {
                        "id": 65244,
                        "name": "Sunan",
                        "latitude": "39.19833000",
                        "longitude": "125.69000000"
                    },
                    {
                        "id": 65248,
                        "name": "Sŭngho 1-tong",
                        "latitude": "38.99139000",
                        "longitude": "125.97778000"
                    }
                ]
            },
            {
                "id": 4001,
                "name": "Rason",
                "iso2": "13",
                "latitude": "42.25690630",
                "longitude": "130.29771860",
                "type": "special city",
                "cities": [
                    {
                        "id": 65246,
                        "name": "Sŏnbong",
                        "latitude": "42.35118000",
                        "longitude": "130.38307000"
                    },
                    {
                        "id": 65251,
                        "name": "Ungsang-nodongjagu",
                        "latitude": "42.35778000",
                        "longitude": "130.46222000"
                    }
                ]
            },
            {
                "id": 3996,
                "name": "Ryanggang",
                "iso2": "10",
                "latitude": "41.23189210",
                "longitude": "128.50763590",
                "type": "province",
                "cities": [
                    {
                        "id": 65201,
                        "name": "Hyesan",
                        "latitude": "41.40167000",
                        "longitude": "128.17778000"
                    },
                    {
                        "id": 65202,
                        "name": "Hyesan-dong",
                        "latitude": "41.39756000",
                        "longitude": "128.17873000"
                    },
                    {
                        "id": 65209,
                        "name": "Kapsan-ŭp",
                        "latitude": "41.09028000",
                        "longitude": "128.29333000"
                    },
                    {
                        "id": 65249,
                        "name": "Sŭngjibaegam",
                        "latitude": "41.24278000",
                        "longitude": "128.79889000"
                    }
                ]
            },
            {
                "id": 4000,
                "name": "South Hamgyong",
                "iso2": "08",
                "latitude": "40.37253390",
                "longitude": "128.29888400",
                "type": "province",
                "cities": [
                    {
                        "id": 65194,
                        "name": "Hamhŭng",
                        "latitude": "39.91833000",
                        "longitude": "127.53639000"
                    },
                    {
                        "id": 65199,
                        "name": "Hongwŏn",
                        "latitude": "40.02528000",
                        "longitude": "127.95583000"
                    },
                    {
                        "id": 65204,
                        "name": "Hŭngnam",
                        "latitude": "39.83167000",
                        "longitude": "127.61861000"
                    },
                    {
                        "id": 65205,
                        "name": "Iwŏn-ŭp",
                        "latitude": "40.32306000",
                        "longitude": "128.65528000"
                    },
                    {
                        "id": 65215,
                        "name": "Kowŏn-ŭp",
                        "latitude": "39.43806000",
                        "longitude": "127.24306000"
                    },
                    {
                        "id": 65235,
                        "name": "Samho-rodongjagu",
                        "latitude": "39.94750000",
                        "longitude": "127.87111000"
                    },
                    {
                        "id": 65241,
                        "name": "Sinsang-ni",
                        "latitude": "39.65028000",
                        "longitude": "127.40583000"
                    },
                    {
                        "id": 65258,
                        "name": "Yŏnggwang-ŭp",
                        "latitude": "40.01833000",
                        "longitude": "127.45472000"
                    },
                    {
                        "id": 65254,
                        "name": "Yuktae-dong",
                        "latitude": "40.02472000",
                        "longitude": "128.15972000"
                    }
                ]
            },
            {
                "id": 4003,
                "name": "South Hwanghae",
                "iso2": "05",
                "latitude": "38.20072150",
                "longitude": "125.47819260",
                "type": "province",
                "cities": [
                    {
                        "id": 65184,
                        "name": "Ayang-ni",
                        "latitude": "38.24306000",
                        "longitude": "125.78000000"
                    },
                    {
                        "id": 65185,
                        "name": "Chaeryŏng-ŭp",
                        "latitude": "38.39917000",
                        "longitude": "125.61556000"
                    },
                    {
                        "id": 65187,
                        "name": "Changyŏn",
                        "latitude": "38.25083000",
                        "longitude": "125.09611000"
                    },
                    {
                        "id": 65193,
                        "name": "Haeju",
                        "latitude": "38.04056000",
                        "longitude": "125.71472000"
                    },
                    {
                        "id": 65206,
                        "name": "Kaesŏng",
                        "latitude": "37.97083000",
                        "longitude": "126.55444000"
                    },
                    {
                        "id": 65226,
                        "name": "Ongjin",
                        "latitude": "37.93472000",
                        "longitude": "125.36194000"
                    },
                    {
                        "id": 65232,
                        "name": "Pyŏksŏng-ŭp",
                        "latitude": "38.04750000",
                        "longitude": "125.55667000"
                    },
                    {
                        "id": 65256,
                        "name": "Yŏnan-ŭp",
                        "latitude": "37.90889000",
                        "longitude": "126.16111000"
                    }
                ]
            },
            {
                "id": 3997,
                "name": "South Pyongan",
                "iso2": "02",
                "latitude": "39.35391780",
                "longitude": "126.16827100",
                "type": "province",
                "cities": [
                    {
                        "id": 65182,
                        "name": "Anju",
                        "latitude": "39.61778000",
                        "longitude": "125.66472000"
                    },
                    {
                        "id": 65223,
                        "name": "Namp’o",
                        "latitude": "38.73750000",
                        "longitude": "125.40778000"
                    },
                    {
                        "id": 65233,
                        "name": "P’yŏngsŏng",
                        "latitude": "39.24639000",
                        "longitude": "125.87194000"
                    },
                    {
                        "id": 65236,
                        "name": "Sangsŏng-ni",
                        "latitude": "39.16944000",
                        "longitude": "126.88556000"
                    },
                    {
                        "id": 65238,
                        "name": "Sil-li",
                        "latitude": "39.49472000",
                        "longitude": "125.47361000"
                    },
                    {
                        "id": 65239,
                        "name": "Sinanju",
                        "latitude": "39.59806000",
                        "longitude": "125.60972000"
                    },
                    {
                        "id": 65245,
                        "name": "Sunch’ŏn",
                        "latitude": "39.43167000",
                        "longitude": "125.93278000"
                    },
                    {
                        "id": 65253,
                        "name": "Yonggang-ŭp",
                        "latitude": "38.85611000",
                        "longitude": "125.42444000"
                    }
                ]
            }
        ]
    },
    {
        "id": 129,
        "name": "North Macedonia",
        "iso3": "MKD",
        "iso2": "MK",
        "numeric_code": "807",
        "phonecode": "389",
        "capital": "Skopje",
        "currency": "MKD",
        "currency_name": "Denar",
        "currency_symbol": "ден",
        "tld": ".mk",
        "native": "Северна Македонија",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Macedonian",
        "timezones": [
            {
                "zoneName": "Europe\/Skopje",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Makedonia an Norzh",
            "ko": "북마케도니아",
            "pt-BR": "Macedônia do Norte",
            "pt": "Macedónia do Norte",
            "nl": "Noord-Macedonië",
            "hr": "Sjeverna Makedonija",
            "fa": "ﻢﻗﺩﻮﻨﯿﻫ ﺶﻣﺎﻠﯾ",
            "de": "Nordmazedonien",
            "es": "Macedonia del Norte",
            "fr": "Macédoine du Nord",
            "ja": "北マケドニア",
            "it": "Macedonia del Nord",
            "zh-CN": "北馬其頓",
            "tr": "Kuzey Makedonya",
            "ru": "Северная Македония",
            "uk": "Північна Македонія",
            "pl": "Macedonia Północna"
        },
        "latitude": "41.83333333",
        "longitude": "22.00000000",
        "emoji": "🇲🇰",
        "emojiU": "U+1F1F2 U+1F1F0",
        "states": [
            {
                "id": 703,
                "name": "Aerodrom",
                "iso2": "01",
                "latitude": "41.94643630",
                "longitude": "21.49317130",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 656,
                "name": "Aračinovo",
                "iso2": "02",
                "latitude": "42.02473810",
                "longitude": "21.57664070",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67574,
                        "name": "Арачиново",
                        "latitude": "42.02639000",
                        "longitude": "21.56194000"
                    }
                ]
            },
            {
                "id": 716,
                "name": "Berovo",
                "iso2": "03",
                "latitude": "41.66619290",
                "longitude": "22.76288300",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67390,
                        "name": "Berovo",
                        "latitude": "41.70306000",
                        "longitude": "22.85778000"
                    },
                    {
                        "id": 67519,
                        "name": "Rusinovo",
                        "latitude": "41.68728000",
                        "longitude": "22.80849000"
                    },
                    {
                        "id": 67556,
                        "name": "Vladimirovo",
                        "latitude": "41.71000000",
                        "longitude": "22.79278000"
                    }
                ]
            },
            {
                "id": 679,
                "name": "Bitola",
                "iso2": "04",
                "latitude": "41.03633020",
                "longitude": "21.33219740",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67391,
                        "name": "Bistrica",
                        "latitude": "40.97892000",
                        "longitude": "21.36580000"
                    },
                    {
                        "id": 67392,
                        "name": "Bitola",
                        "latitude": "41.03143000",
                        "longitude": "21.33474000"
                    },
                    {
                        "id": 67403,
                        "name": "Capari",
                        "latitude": "41.05656000",
                        "longitude": "21.17884000"
                    },
                    {
                        "id": 67420,
                        "name": "Dolno Orizari",
                        "latitude": "41.05028000",
                        "longitude": "21.37944000"
                    },
                    {
                        "id": 67430,
                        "name": "Gorno Orizari",
                        "latitude": "41.05188000",
                        "longitude": "21.34548000"
                    },
                    {
                        "id": 67464,
                        "name": "Kukurečani",
                        "latitude": "41.09562000",
                        "longitude": "21.32454000"
                    },
                    {
                        "id": 67472,
                        "name": "Logovardi",
                        "latitude": "41.03096000",
                        "longitude": "21.40967000"
                    }
                ]
            },
            {
                "id": 649,
                "name": "Bogdanci",
                "iso2": "05",
                "latitude": "41.18696160",
                "longitude": "22.59602680",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67394,
                        "name": "Bogdanci",
                        "latitude": "41.20306000",
                        "longitude": "22.57556000"
                    },
                    {
                        "id": 67534,
                        "name": "Stojakovo",
                        "latitude": "41.15556000",
                        "longitude": "22.57750000"
                    }
                ]
            },
            {
                "id": 721,
                "name": "Bogovinje",
                "iso2": "06",
                "latitude": "41.92363710",
                "longitude": "20.91638870",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67396,
                        "name": "Bogovinje",
                        "latitude": "41.92361000",
                        "longitude": "20.91361000"
                    },
                    {
                        "id": 67421,
                        "name": "Dolno Palčište",
                        "latitude": "41.96859000",
                        "longitude": "20.92899000"
                    },
                    {
                        "id": 67434,
                        "name": "Gradec",
                        "latitude": "41.89611000",
                        "longitude": "20.90417000"
                    },
                    {
                        "id": 67447,
                        "name": "Kamenjane",
                        "latitude": "41.94568000",
                        "longitude": "20.92894000"
                    }
                ]
            },
            {
                "id": 652,
                "name": "Bosilovo",
                "iso2": "07",
                "latitude": "41.49048640",
                "longitude": "22.78671740",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67398,
                        "name": "Bosilovo",
                        "latitude": "41.44056000",
                        "longitude": "22.72778000"
                    },
                    {
                        "id": 67441,
                        "name": "Ilovica",
                        "latitude": "41.47224000",
                        "longitude": "22.80480000"
                    },
                    {
                        "id": 67523,
                        "name": "Sekirnik",
                        "latitude": "41.43999000",
                        "longitude": "22.79536000"
                    }
                ]
            },
            {
                "id": 660,
                "name": "Brvenica",
                "iso2": "08",
                "latitude": "41.96814820",
                "longitude": "20.98195860",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67399,
                        "name": "Brvenica",
                        "latitude": "41.96722000",
                        "longitude": "20.98083000"
                    },
                    {
                        "id": 67568,
                        "name": "Čelopek",
                        "latitude": "41.93167000",
                        "longitude": "21.01333000"
                    },
                    {
                        "id": 67439,
                        "name": "Gurgurnica",
                        "latitude": "41.84508000",
                        "longitude": "21.10538000"
                    },
                    {
                        "id": 67483,
                        "name": "Miletino",
                        "latitude": "41.90753000",
                        "longitude": "21.01601000"
                    }
                ]
            },
            {
                "id": 694,
                "name": "Butel",
                "iso2": "09",
                "latitude": "42.08950680",
                "longitude": "21.46336100",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67401,
                        "name": "Butel",
                        "latitude": "42.03083000",
                        "longitude": "21.44667000"
                    },
                    {
                        "id": 67512,
                        "name": "Radishani",
                        "latitude": "42.06111000",
                        "longitude": "21.44778000"
                    }
                ]
            },
            {
                "id": 704,
                "name": "Čair",
                "iso2": "79",
                "latitude": "41.99303550",
                "longitude": "21.43653180",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67566,
                        "name": "Čair",
                        "latitude": "42.01528000",
                        "longitude": "21.44111000"
                    }
                ]
            },
            {
                "id": 676,
                "name": "Čaška",
                "iso2": "80",
                "latitude": "41.64743800",
                "longitude": "21.69141150",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67395,
                        "name": "Bogomila",
                        "latitude": "41.59306000",
                        "longitude": "21.47167000"
                    },
                    {
                        "id": 67567,
                        "name": "Čaška",
                        "latitude": "41.65056000",
                        "longitude": "21.66222000"
                    }
                ]
            },
            {
                "id": 702,
                "name": "Centar",
                "iso2": "77",
                "latitude": "41.96989340",
                "longitude": "21.42162670",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 720,
                "name": "Centar Župa",
                "iso2": "78",
                "latitude": "41.46522590",
                "longitude": "20.59305480",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67405,
                        "name": "Centar Župa",
                        "latitude": "41.47849000",
                        "longitude": "20.55945000"
                    }
                ]
            },
            {
                "id": 644,
                "name": "Češinovo-Obleševo",
                "iso2": "81",
                "latitude": "41.86393160",
                "longitude": "22.26224600",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67569,
                        "name": "Češinovo",
                        "latitude": "41.87148000",
                        "longitude": "22.28961000"
                    },
                    {
                        "id": 67494,
                        "name": "Oblesevo",
                        "latitude": "41.88333000",
                        "longitude": "22.33389000"
                    }
                ]
            },
            {
                "id": 715,
                "name": "Čučer-Sandevo",
                "iso2": "82",
                "latitude": "42.14839460",
                "longitude": "21.40374070",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67582,
                        "name": "Чучер - Сандево",
                        "latitude": "42.10361000",
                        "longitude": "21.38222000"
                    }
                ]
            },
            {
                "id": 645,
                "name": "Debarca",
                "iso2": "22",
                "latitude": "41.35840770",
                "longitude": "20.85529190",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67388,
                        "name": "Belčišta",
                        "latitude": "41.30278000",
                        "longitude": "20.83028000"
                    },
                    {
                        "id": 67481,
                        "name": "Mešeišta",
                        "latitude": "41.23814000",
                        "longitude": "20.77414000"
                    }
                ]
            },
            {
                "id": 695,
                "name": "Delčevo",
                "iso2": "23",
                "latitude": "41.96843870",
                "longitude": "22.76288300",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67408,
                        "name": "Delcevo",
                        "latitude": "41.96722000",
                        "longitude": "22.76944000"
                    }
                ]
            },
            {
                "id": 687,
                "name": "Demir Hisar",
                "iso2": "25",
                "latitude": "41.22708300",
                "longitude": "21.14142260",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67410,
                        "name": "Demir Hisar",
                        "latitude": "41.22097000",
                        "longitude": "21.20302000"
                    },
                    {
                        "id": 67528,
                        "name": "Slepče",
                        "latitude": "41.23333000",
                        "longitude": "21.17500000"
                    },
                    {
                        "id": 67529,
                        "name": "Sopotnica",
                        "latitude": "41.29594000",
                        "longitude": "21.15357000"
                    }
                ]
            },
            {
                "id": 655,
                "name": "Demir Kapija",
                "iso2": "24",
                "latitude": "41.37955380",
                "longitude": "22.21455710",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67411,
                        "name": "Demir Kapija",
                        "latitude": "41.40613000",
                        "longitude": "22.24631000"
                    }
                ]
            },
            {
                "id": 697,
                "name": "Dojran",
                "iso2": "26",
                "latitude": "41.24366720",
                "longitude": "22.69137640",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67533,
                        "name": "Star Dojran",
                        "latitude": "41.18647000",
                        "longitude": "22.72030000"
                    }
                ]
            },
            {
                "id": 675,
                "name": "Dolneni",
                "iso2": "27",
                "latitude": "41.46409350",
                "longitude": "21.40374070",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67407,
                        "name": "Crnilište",
                        "latitude": "41.53025000",
                        "longitude": "21.41416000"
                    },
                    {
                        "id": 67412,
                        "name": "Desovo",
                        "latitude": "41.46278000",
                        "longitude": "21.49111000"
                    },
                    {
                        "id": 67418,
                        "name": "Dolneni",
                        "latitude": "41.42579000",
                        "longitude": "21.45402000"
                    },
                    {
                        "id": 67468,
                        "name": "Lažani",
                        "latitude": "41.44222000",
                        "longitude": "21.31583000"
                    },
                    {
                        "id": 67572,
                        "name": "Žitoše",
                        "latitude": "41.41991000",
                        "longitude": "21.29078000"
                    }
                ]
            },
            {
                "id": 657,
                "name": "Drugovo",
                "iso2": "28",
                "latitude": "41.44081530",
                "longitude": "20.92682010",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 707,
                "name": "Gazi Baba",
                "iso2": "17",
                "latitude": "42.01629610",
                "longitude": "21.49913340",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67406,
                        "name": "Cresevo",
                        "latitude": "42.05083000",
                        "longitude": "21.50972000"
                    }
                ]
            },
            {
                "id": 648,
                "name": "Gevgelija",
                "iso2": "18",
                "latitude": "41.21186060",
                "longitude": "22.38146240",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67427,
                        "name": "Gevgelija",
                        "latitude": "41.14166000",
                        "longitude": "22.50141000"
                    },
                    {
                        "id": 67484,
                        "name": "Miravci",
                        "latitude": "41.30925000",
                        "longitude": "22.43641000"
                    }
                ]
            },
            {
                "id": 722,
                "name": "Gjorče Petrov",
                "iso2": "29",
                "latitude": "42.06063740",
                "longitude": "21.32027360",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67428,
                        "name": "Gjorče Petro",
                        "latitude": "42.00778000",
                        "longitude": "21.35306000"
                    }
                ]
            },
            {
                "id": 693,
                "name": "Gostivar",
                "iso2": "19",
                "latitude": "41.80255410",
                "longitude": "20.90893780",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67404,
                        "name": "Cegrane",
                        "latitude": "41.83889000",
                        "longitude": "20.97583000"
                    },
                    {
                        "id": 67417,
                        "name": "Dolna Banjica",
                        "latitude": "41.78611000",
                        "longitude": "20.90611000"
                    },
                    {
                        "id": 67426,
                        "name": "Forino",
                        "latitude": "41.82334000",
                        "longitude": "20.96174000"
                    },
                    {
                        "id": 67433,
                        "name": "Gostivar",
                        "latitude": "41.79601000",
                        "longitude": "20.90819000"
                    },
                    {
                        "id": 67531,
                        "name": "Srbinovo",
                        "latitude": "41.70586000",
                        "longitude": "20.95859000"
                    },
                    {
                        "id": 67560,
                        "name": "Vrutok",
                        "latitude": "41.76861000",
                        "longitude": "20.83917000"
                    }
                ]
            },
            {
                "id": 708,
                "name": "Gradsko",
                "iso2": "20",
                "latitude": "41.59916080",
                "longitude": "21.88070640",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67436,
                        "name": "Gradsko",
                        "latitude": "41.57750000",
                        "longitude": "21.94278000"
                    }
                ]
            },
            {
                "id": 684,
                "name": "Greater Skopje",
                "iso2": "85",
                "latitude": "41.99812940",
                "longitude": "21.42543550",
                "type": "capital city",
                "cities": [
                    {
                        "id": 67397,
                        "name": "Bojane",
                        "latitude": "42.00009000",
                        "longitude": "21.19265000"
                    },
                    {
                        "id": 67423,
                        "name": "Dračevo",
                        "latitude": "41.93667000",
                        "longitude": "21.52167000"
                    },
                    {
                        "id": 67471,
                        "name": "Ljubin",
                        "latitude": "42.00139000",
                        "longitude": "21.30917000"
                    },
                    {
                        "id": 67521,
                        "name": "Saraj",
                        "latitude": "42.00000000",
                        "longitude": "21.32778000"
                    },
                    {
                        "id": 67546,
                        "name": "Usje",
                        "latitude": "41.95871000",
                        "longitude": "21.45835000"
                    }
                ]
            },
            {
                "id": 690,
                "name": "Ilinden",
                "iso2": "34",
                "latitude": "41.99574430",
                "longitude": "21.56769750",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67440,
                        "name": "Ilinden",
                        "latitude": "41.99451000",
                        "longitude": "21.58002000"
                    },
                    {
                        "id": 67446,
                        "name": "Kadino",
                        "latitude": "41.96889000",
                        "longitude": "21.60139000"
                    },
                    {
                        "id": 67478,
                        "name": "Marino",
                        "latitude": "41.98776000",
                        "longitude": "21.59148000"
                    },
                    {
                        "id": 67482,
                        "name": "Miladinovci",
                        "latitude": "41.98029000",
                        "longitude": "21.64982000"
                    },
                    {
                        "id": 67575,
                        "name": "Идризово",
                        "latitude": "41.96083000",
                        "longitude": "21.57556000"
                    },
                    {
                        "id": 67573,
                        "name": "Јурумлери",
                        "latitude": "41.96722000",
                        "longitude": "21.55694000"
                    }
                ]
            },
            {
                "id": 678,
                "name": "Jegunovce",
                "iso2": "35",
                "latitude": "42.07407200",
                "longitude": "21.12204780",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67445,
                        "name": "Jegunovce",
                        "latitude": "42.07238000",
                        "longitude": "21.12367000"
                    },
                    {
                        "id": 67559,
                        "name": "Vratnica",
                        "latitude": "42.14333000",
                        "longitude": "21.11694000"
                    }
                ]
            },
            {
                "id": 674,
                "name": "Karbinci",
                "iso2": "37",
                "latitude": "41.81801590",
                "longitude": "22.23247580",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67449,
                        "name": "Karbinci",
                        "latitude": "41.81758000",
                        "longitude": "22.23529000"
                    }
                ]
            },
            {
                "id": 681,
                "name": "Karpoš",
                "iso2": "38",
                "latitude": "41.97096610",
                "longitude": "21.39181680",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67526,
                        "name": "Skopje",
                        "latitude": "41.99646000",
                        "longitude": "21.43141000"
                    }
                ]
            },
            {
                "id": 713,
                "name": "Kavadarci",
                "iso2": "36",
                "latitude": "41.28900680",
                "longitude": "21.99994350",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67450,
                        "name": "Kavadarci",
                        "latitude": "41.43306000",
                        "longitude": "22.01194000"
                    },
                    {
                        "id": 67550,
                        "name": "Vataša",
                        "latitude": "41.41694000",
                        "longitude": "22.01889000"
                    }
                ]
            },
            {
                "id": 688,
                "name": "Kičevo",
                "iso2": "40",
                "latitude": "41.51291120",
                "longitude": "20.95250650",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67424,
                        "name": "Drugovo",
                        "latitude": "41.48490000",
                        "longitude": "20.92636000"
                    },
                    {
                        "id": 67452,
                        "name": "Kičevo",
                        "latitude": "41.51267000",
                        "longitude": "20.95886000"
                    },
                    {
                        "id": 67530,
                        "name": "Srbica",
                        "latitude": "41.58672000",
                        "longitude": "21.03027000"
                    },
                    {
                        "id": 67535,
                        "name": "Strelci",
                        "latitude": "41.54046000",
                        "longitude": "21.00563000"
                    },
                    {
                        "id": 67545,
                        "name": "Tuin",
                        "latitude": "41.61944000",
                        "longitude": "21.04528000"
                    },
                    {
                        "id": 67557,
                        "name": "Vraneštica",
                        "latitude": "41.44496000",
                        "longitude": "21.02683000"
                    },
                    {
                        "id": 67561,
                        "name": "Zajas",
                        "latitude": "41.60722000",
                        "longitude": "20.93833000"
                    }
                ]
            },
            {
                "id": 686,
                "name": "Kisela Voda",
                "iso2": "39",
                "latitude": "41.92748000",
                "longitude": "21.49317130",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67451,
                        "name": "Kisela Voda",
                        "latitude": "41.94889000",
                        "longitude": "21.50278000"
                    }
                ]
            },
            {
                "id": 723,
                "name": "Kočani",
                "iso2": "42",
                "latitude": "41.98583740",
                "longitude": "22.40530460",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67453,
                        "name": "Kochani",
                        "latitude": "41.91639000",
                        "longitude": "22.41278000"
                    },
                    {
                        "id": 67501,
                        "name": "Orizari",
                        "latitude": "41.92262000",
                        "longitude": "22.44628000"
                    }
                ]
            },
            {
                "id": 665,
                "name": "Konče",
                "iso2": "41",
                "latitude": "41.51710110",
                "longitude": "22.38146240",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67455,
                        "name": "Konče",
                        "latitude": "41.49511000",
                        "longitude": "22.38359000"
                    }
                ]
            },
            {
                "id": 641,
                "name": "Kratovo",
                "iso2": "43",
                "latitude": "42.05371410",
                "longitude": "22.07148350",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67458,
                        "name": "Kratovo",
                        "latitude": "42.07838000",
                        "longitude": "22.18070000"
                    }
                ]
            },
            {
                "id": 677,
                "name": "Kriva Palanka",
                "iso2": "44",
                "latitude": "42.20584540",
                "longitude": "22.33079650",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67459,
                        "name": "Kriva Palanka",
                        "latitude": "42.20088000",
                        "longitude": "22.33244000"
                    }
                ]
            },
            {
                "id": 647,
                "name": "Krivogaštani",
                "iso2": "45",
                "latitude": "41.30823060",
                "longitude": "21.36796890",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67460,
                        "name": "Krivogashtani",
                        "latitude": "41.33611000",
                        "longitude": "21.33306000"
                    },
                    {
                        "id": 67495,
                        "name": "Obršani",
                        "latitude": "41.28168000",
                        "longitude": "21.36150000"
                    },
                    {
                        "id": 67576,
                        "name": "Клечовце",
                        "latitude": "42.11611000",
                        "longitude": "21.85722000"
                    }
                ]
            },
            {
                "id": 714,
                "name": "Kruševo",
                "iso2": "46",
                "latitude": "41.37693310",
                "longitude": "21.26065540",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67402,
                        "name": "Bučin",
                        "latitude": "41.27377000",
                        "longitude": "21.31692000"
                    },
                    {
                        "id": 67461,
                        "name": "Krusevo",
                        "latitude": "41.36889000",
                        "longitude": "21.24889000"
                    }
                ]
            },
            {
                "id": 683,
                "name": "Kumanovo",
                "iso2": "47",
                "latitude": "42.07326130",
                "longitude": "21.78531430",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67387,
                        "name": "Bedinje",
                        "latitude": "42.14167000",
                        "longitude": "21.69639000"
                    },
                    {
                        "id": 67465,
                        "name": "Kumanovo",
                        "latitude": "42.13222000",
                        "longitude": "21.71444000"
                    },
                    {
                        "id": 67516,
                        "name": "Romanovci",
                        "latitude": "42.09472000",
                        "longitude": "21.69306000"
                    }
                ]
            },
            {
                "id": 659,
                "name": "Lipkovo",
                "iso2": "48",
                "latitude": "42.20066260",
                "longitude": "21.61837550",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67443,
                        "name": "Izvor",
                        "latitude": "42.20322000",
                        "longitude": "21.57812000"
                    },
                    {
                        "id": 67469,
                        "name": "Lipkovo",
                        "latitude": "42.15639000",
                        "longitude": "21.58528000"
                    },
                    {
                        "id": 67473,
                        "name": "Lojane",
                        "latitude": "42.23276000",
                        "longitude": "21.66550000"
                    },
                    {
                        "id": 67480,
                        "name": "Matejce",
                        "latitude": "42.12556000",
                        "longitude": "21.59778000"
                    },
                    {
                        "id": 67502,
                        "name": "Otlja",
                        "latitude": "42.14315000",
                        "longitude": "21.58675000"
                    },
                    {
                        "id": 67547,
                        "name": "Vaksince",
                        "latitude": "42.20611000",
                        "longitude": "21.66306000"
                    },
                    {
                        "id": 67579,
                        "name": "Слупчане",
                        "latitude": "42.17333000",
                        "longitude": "21.62778000"
                    }
                ]
            },
            {
                "id": 705,
                "name": "Lozovo",
                "iso2": "49",
                "latitude": "41.78181390",
                "longitude": "21.90008270",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67474,
                        "name": "Lozovo",
                        "latitude": "41.78389000",
                        "longitude": "21.90556000"
                    }
                ]
            },
            {
                "id": 701,
                "name": "Makedonska Kamenica",
                "iso2": "51",
                "latitude": "42.06946040",
                "longitude": "22.54834900",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67476,
                        "name": "Makedonska Kamenica",
                        "latitude": "42.02079000",
                        "longitude": "22.58760000"
                    }
                ]
            },
            {
                "id": 692,
                "name": "Makedonski Brod",
                "iso2": "52",
                "latitude": "41.51330880",
                "longitude": "21.21743290",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67477,
                        "name": "Makedonski Brod",
                        "latitude": "41.51361000",
                        "longitude": "21.21528000"
                    },
                    {
                        "id": 67520,
                        "name": "Samokov",
                        "latitude": "41.68331000",
                        "longitude": "21.14625000"
                    }
                ]
            },
            {
                "id": 669,
                "name": "Mavrovo and Rostuša",
                "iso2": "50",
                "latitude": "41.60924270",
                "longitude": "20.60124880",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67518,
                        "name": "Rostusa",
                        "latitude": "41.61000000",
                        "longitude": "20.60000000"
                    }
                ]
            },
            {
                "id": 653,
                "name": "Mogila",
                "iso2": "53",
                "latitude": "41.14796450",
                "longitude": "21.45143690",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67389,
                        "name": "Beranci",
                        "latitude": "41.15969000",
                        "longitude": "21.35963000"
                    },
                    {
                        "id": 67416,
                        "name": "Dobruševo",
                        "latitude": "41.16861000",
                        "longitude": "21.48250000"
                    },
                    {
                        "id": 67422,
                        "name": "Dolno Srpci",
                        "latitude": "41.17480000",
                        "longitude": "21.36464000"
                    },
                    {
                        "id": 67486,
                        "name": "Mogila",
                        "latitude": "41.10833000",
                        "longitude": "21.37861000"
                    }
                ]
            },
            {
                "id": 664,
                "name": "Negotino",
                "iso2": "54",
                "latitude": "41.49899850",
                "longitude": "22.09532970",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67490,
                        "name": "Negotino",
                        "latitude": "41.48456000",
                        "longitude": "22.09056000"
                    }
                ]
            },
            {
                "id": 696,
                "name": "Novaci",
                "iso2": "55",
                "latitude": "41.04426610",
                "longitude": "21.45888940",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67492,
                        "name": "Novaci",
                        "latitude": "41.04197000",
                        "longitude": "21.45866000"
                    }
                ]
            },
            {
                "id": 718,
                "name": "Novo Selo",
                "iso2": "56",
                "latitude": "41.43255800",
                "longitude": "22.88204890",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67493,
                        "name": "Novo Selo",
                        "latitude": "41.41486000",
                        "longitude": "22.88164000"
                    },
                    {
                        "id": 67540,
                        "name": "Sušica",
                        "latitude": "41.43982000",
                        "longitude": "22.83676000"
                    }
                ]
            },
            {
                "id": 699,
                "name": "Ohrid",
                "iso2": "58",
                "latitude": "41.06820880",
                "longitude": "20.75992660",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67456,
                        "name": "Kosel",
                        "latitude": "41.17444000",
                        "longitude": "20.83556000"
                    },
                    {
                        "id": 67496,
                        "name": "Ohrid",
                        "latitude": "41.11722000",
                        "longitude": "20.80194000"
                    },
                    {
                        "id": 67497,
                        "name": "Ohrid Opština",
                        "latitude": "41.16667000",
                        "longitude": "20.83333000"
                    }
                ]
            },
            {
                "id": 682,
                "name": "Oslomej ",
                "iso2": "57",
                "latitude": "41.57583910",
                "longitude": "21.02219600",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 685,
                "name": "Pehčevo",
                "iso2": "60",
                "latitude": "41.77371320",
                "longitude": "22.88204890",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67503,
                        "name": "Pehčevo",
                        "latitude": "41.76226000",
                        "longitude": "22.88921000"
                    }
                ]
            },
            {
                "id": 698,
                "name": "Petrovec",
                "iso2": "59",
                "latitude": "41.90298970",
                "longitude": "21.68992100",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67532,
                        "name": "Sredno Konjare",
                        "latitude": "41.95743000",
                        "longitude": "21.71494000"
                    },
                    {
                        "id": 67577,
                        "name": "Петровец",
                        "latitude": "41.93889000",
                        "longitude": "21.61500000"
                    }
                ]
            },
            {
                "id": 670,
                "name": "Plasnica",
                "iso2": "61",
                "latitude": "41.45463490",
                "longitude": "21.10565390",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67470,
                        "name": "Lisičani",
                        "latitude": "41.46139000",
                        "longitude": "21.05444000"
                    },
                    {
                        "id": 67506,
                        "name": "Plasnica",
                        "latitude": "41.46722000",
                        "longitude": "21.12306000"
                    }
                ]
            },
            {
                "id": 666,
                "name": "Prilep",
                "iso2": "62",
                "latitude": "41.26931420",
                "longitude": "21.71376940",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67448,
                        "name": "Kanatlarci",
                        "latitude": "41.21028000",
                        "longitude": "21.50333000"
                    },
                    {
                        "id": 67479,
                        "name": "Markov Grad",
                        "latitude": "41.35722000",
                        "longitude": "21.53250000"
                    },
                    {
                        "id": 67509,
                        "name": "Prilep",
                        "latitude": "41.34514000",
                        "longitude": "21.55504000"
                    },
                    {
                        "id": 67544,
                        "name": "Topolčani",
                        "latitude": "41.22772000",
                        "longitude": "21.43113000"
                    }
                ]
            },
            {
                "id": 646,
                "name": "Probištip",
                "iso2": "63",
                "latitude": "41.95891460",
                "longitude": "22.16686700",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67510,
                        "name": "Probishtip",
                        "latitude": "42.00306000",
                        "longitude": "22.17861000"
                    },
                    {
                        "id": 67564,
                        "name": "Zletovo",
                        "latitude": "41.98861000",
                        "longitude": "22.23611000"
                    }
                ]
            },
            {
                "id": 709,
                "name": "Radoviš",
                "iso2": "64",
                "latitude": "41.64955310",
                "longitude": "22.47682870",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67499,
                        "name": "Oraovica",
                        "latitude": "41.62583000",
                        "longitude": "22.51333000"
                    },
                    {
                        "id": 67507,
                        "name": "Podareš",
                        "latitude": "41.61389000",
                        "longitude": "22.54222000"
                    },
                    {
                        "id": 67514,
                        "name": "Radovis",
                        "latitude": "41.63833000",
                        "longitude": "22.46472000"
                    }
                ]
            },
            {
                "id": 717,
                "name": "Rankovce",
                "iso2": "65",
                "latitude": "42.18081410",
                "longitude": "22.09532970",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67578,
                        "name": "Ранковце",
                        "latitude": "42.16964000",
                        "longitude": "22.11617000"
                    }
                ]
            },
            {
                "id": 712,
                "name": "Resen",
                "iso2": "66",
                "latitude": "40.93680930",
                "longitude": "21.04604070",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67437,
                        "name": "Grnčari",
                        "latitude": "41.01722000",
                        "longitude": "21.05333000"
                    },
                    {
                        "id": 67444,
                        "name": "Jankovec",
                        "latitude": "41.11028000",
                        "longitude": "21.01139000"
                    },
                    {
                        "id": 67457,
                        "name": "Krani",
                        "latitude": "40.93934000",
                        "longitude": "21.10911000"
                    },
                    {
                        "id": 67515,
                        "name": "Resen",
                        "latitude": "41.08934000",
                        "longitude": "21.01092000"
                    }
                ]
            },
            {
                "id": 691,
                "name": "Rosoman",
                "iso2": "67",
                "latitude": "41.48480060",
                "longitude": "21.88070640",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67517,
                        "name": "Rosoman",
                        "latitude": "41.51671000",
                        "longitude": "21.94585000"
                    }
                ]
            },
            {
                "id": 667,
                "name": "Saraj",
                "iso2": "68",
                "latitude": "41.98694960",
                "longitude": "21.26065540",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67400,
                        "name": "Bukovik",
                        "latitude": "41.96833000",
                        "longitude": "21.23694000"
                    },
                    {
                        "id": 67438,
                        "name": "Grčec",
                        "latitude": "41.98806000",
                        "longitude": "21.33028000"
                    },
                    {
                        "id": 67454,
                        "name": "Kondovo",
                        "latitude": "42.01167000",
                        "longitude": "21.31361000"
                    },
                    {
                        "id": 67462,
                        "name": "Krušopek",
                        "latitude": "41.97833000",
                        "longitude": "21.35444000"
                    }
                ]
            },
            {
                "id": 719,
                "name": "Sopište",
                "iso2": "70",
                "latitude": "41.86384920",
                "longitude": "21.30834990",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67580,
                        "name": "Сопиште",
                        "latitude": "41.95472000",
                        "longitude": "21.42750000"
                    }
                ]
            },
            {
                "id": 643,
                "name": "Staro Nagoričane",
                "iso2": "71",
                "latitude": "42.21916920",
                "longitude": "21.90455410",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67581,
                        "name": "Старо Нагоричане",
                        "latitude": "42.19806000",
                        "longitude": "21.82861000"
                    }
                ]
            },
            {
                "id": 661,
                "name": "Štip",
                "iso2": "83",
                "latitude": "41.70792970",
                "longitude": "22.19071220",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67525,
                        "name": "Shtip",
                        "latitude": "41.74583000",
                        "longitude": "22.19583000"
                    }
                ]
            },
            {
                "id": 700,
                "name": "Struga",
                "iso2": "72",
                "latitude": "41.31737440",
                "longitude": "20.66456830",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67409,
                        "name": "Delogožda",
                        "latitude": "41.25728000",
                        "longitude": "20.72180000"
                    },
                    {
                        "id": 67466,
                        "name": "Labunista",
                        "latitude": "41.26861000",
                        "longitude": "20.59611000"
                    },
                    {
                        "id": 67475,
                        "name": "Lukovo",
                        "latitude": "41.35339000",
                        "longitude": "20.60637000"
                    },
                    {
                        "id": 67485,
                        "name": "Mislesevo",
                        "latitude": "41.18500000",
                        "longitude": "20.70861000"
                    },
                    {
                        "id": 67498,
                        "name": "Oktisi",
                        "latitude": "41.23250000",
                        "longitude": "20.60722000"
                    },
                    {
                        "id": 67513,
                        "name": "Radolista",
                        "latitude": "41.16417000",
                        "longitude": "20.62333000"
                    },
                    {
                        "id": 67537,
                        "name": "Struga",
                        "latitude": "41.17799000",
                        "longitude": "20.67784000"
                    },
                    {
                        "id": 67552,
                        "name": "Velesta",
                        "latitude": "41.24083000",
                        "longitude": "20.64389000"
                    }
                ]
            },
            {
                "id": 710,
                "name": "Strumica",
                "iso2": "73",
                "latitude": "41.43780040",
                "longitude": "22.64274280",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67463,
                        "name": "Kuklis",
                        "latitude": "41.40528000",
                        "longitude": "22.66528000"
                    },
                    {
                        "id": 67488,
                        "name": "Murtino",
                        "latitude": "41.41537000",
                        "longitude": "22.72589000"
                    },
                    {
                        "id": 67538,
                        "name": "Strumica",
                        "latitude": "41.43750000",
                        "longitude": "22.64333000"
                    },
                    {
                        "id": 67553,
                        "name": "Veljusa",
                        "latitude": "41.47611000",
                        "longitude": "22.56750000"
                    }
                ]
            },
            {
                "id": 711,
                "name": "Studeničani",
                "iso2": "74",
                "latitude": "41.92256390",
                "longitude": "21.53639650",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67386,
                        "name": "Batinci",
                        "latitude": "41.91909000",
                        "longitude": "21.47978000"
                    },
                    {
                        "id": 67419,
                        "name": "Dolno Količani",
                        "latitude": "41.88639000",
                        "longitude": "21.48556000"
                    },
                    {
                        "id": 67487,
                        "name": "Morani",
                        "latitude": "41.90978000",
                        "longitude": "21.54997000"
                    },
                    {
                        "id": 67539,
                        "name": "Studeničane",
                        "latitude": "41.92208000",
                        "longitude": "21.53483000"
                    }
                ]
            },
            {
                "id": 680,
                "name": "Šuto Orizari",
                "iso2": "84",
                "latitude": "42.02904160",
                "longitude": "21.40970270",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67571,
                        "name": "Šuto Orizare",
                        "latitude": "42.04000000",
                        "longitude": "21.42500000"
                    }
                ]
            },
            {
                "id": 640,
                "name": "Sveti Nikole",
                "iso2": "69",
                "latitude": "41.89803120",
                "longitude": "21.99994350",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67432,
                        "name": "Gorobinci",
                        "latitude": "41.87507000",
                        "longitude": "21.87599000"
                    },
                    {
                        "id": 67541,
                        "name": "Sveti Nikole",
                        "latitude": "41.86956000",
                        "longitude": "21.95274000"
                    }
                ]
            },
            {
                "id": 654,
                "name": "Tearce",
                "iso2": "75",
                "latitude": "42.07775110",
                "longitude": "21.05349230",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67491,
                        "name": "Nerašte",
                        "latitude": "42.10711000",
                        "longitude": "21.10810000"
                    },
                    {
                        "id": 67500,
                        "name": "Orashac",
                        "latitude": "42.06250000",
                        "longitude": "21.79972000"
                    },
                    {
                        "id": 67511,
                        "name": "Pršovce",
                        "latitude": "42.08336000",
                        "longitude": "21.05994000"
                    },
                    {
                        "id": 67527,
                        "name": "Slatino",
                        "latitude": "42.06784000",
                        "longitude": "21.03902000"
                    },
                    {
                        "id": 67542,
                        "name": "Tearce",
                        "latitude": "42.07666000",
                        "longitude": "21.05310000"
                    }
                ]
            },
            {
                "id": 663,
                "name": "Tetovo",
                "iso2": "76",
                "latitude": "42.02748600",
                "longitude": "20.95066360",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67415,
                        "name": "Dobrošte",
                        "latitude": "42.10333000",
                        "longitude": "21.07778000"
                    },
                    {
                        "id": 67425,
                        "name": "Džepčište",
                        "latitude": "42.03287000",
                        "longitude": "20.99817000"
                    },
                    {
                        "id": 67429,
                        "name": "Golema Rečica",
                        "latitude": "41.98803000",
                        "longitude": "20.94517000"
                    },
                    {
                        "id": 67505,
                        "name": "Pirok",
                        "latitude": "41.91083000",
                        "longitude": "20.91056000"
                    },
                    {
                        "id": 67508,
                        "name": "Poroj",
                        "latitude": "42.02913000",
                        "longitude": "20.99266000"
                    },
                    {
                        "id": 67524,
                        "name": "Selce",
                        "latitude": "42.03482000",
                        "longitude": "20.94035000"
                    },
                    {
                        "id": 67570,
                        "name": "Šipkovica",
                        "latitude": "42.03500000",
                        "longitude": "20.91556000"
                    },
                    {
                        "id": 67543,
                        "name": "Tetovo",
                        "latitude": "42.00973000",
                        "longitude": "20.97155000"
                    }
                ]
            },
            {
                "id": 671,
                "name": "Valandovo",
                "iso2": "10",
                "latitude": "41.32119090",
                "longitude": "22.50066930",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67504,
                        "name": "Pirava",
                        "latitude": "41.32042000",
                        "longitude": "22.53047000"
                    },
                    {
                        "id": 67548,
                        "name": "Valandovo",
                        "latitude": "41.31744000",
                        "longitude": "22.56002000"
                    }
                ]
            },
            {
                "id": 658,
                "name": "Vasilevo",
                "iso2": "11",
                "latitude": "41.47416990",
                "longitude": "22.64221280",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67549,
                        "name": "Vasilevo",
                        "latitude": "41.47408000",
                        "longitude": "22.64301000"
                    }
                ]
            },
            {
                "id": 651,
                "name": "Veles",
                "iso2": "13",
                "latitude": "41.72744260",
                "longitude": "21.71376940",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67431,
                        "name": "Gorno Orizari",
                        "latitude": "41.68583000",
                        "longitude": "21.73475000"
                    },
                    {
                        "id": 67442,
                        "name": "Ivankovci",
                        "latitude": "41.84889000",
                        "longitude": "21.82028000"
                    },
                    {
                        "id": 67551,
                        "name": "Veles",
                        "latitude": "41.71556000",
                        "longitude": "21.77556000"
                    }
                ]
            },
            {
                "id": 662,
                "name": "Vevčani",
                "iso2": "12",
                "latitude": "41.24075430",
                "longitude": "20.59156490",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67554,
                        "name": "Vevčani",
                        "latitude": "41.24056000",
                        "longitude": "20.59333000"
                    }
                ]
            },
            {
                "id": 672,
                "name": "Vinica",
                "iso2": "14",
                "latitude": "41.85710200",
                "longitude": "22.57218810",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67393,
                        "name": "Blatec",
                        "latitude": "41.83668000",
                        "longitude": "22.57909000"
                    },
                    {
                        "id": 67435,
                        "name": "Gradec",
                        "latitude": "41.85068000",
                        "longitude": "22.51132000"
                    },
                    {
                        "id": 67555,
                        "name": "Vinica",
                        "latitude": "41.88278000",
                        "longitude": "22.50917000"
                    }
                ]
            },
            {
                "id": 650,
                "name": "Vraneštica",
                "iso2": "15",
                "latitude": "41.48290870",
                "longitude": "21.05796320",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 689,
                "name": "Vrapčište",
                "iso2": "16",
                "latitude": "41.87911600",
                "longitude": "20.83145000",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67414,
                        "name": "Dobri Dol",
                        "latitude": "41.86520000",
                        "longitude": "20.89009000"
                    },
                    {
                        "id": 67489,
                        "name": "Negotino",
                        "latitude": "41.87792000",
                        "longitude": "20.88389000"
                    },
                    {
                        "id": 67558,
                        "name": "Vrapčište",
                        "latitude": "41.83439000",
                        "longitude": "20.88563000"
                    }
                ]
            },
            {
                "id": 642,
                "name": "Zajas",
                "iso2": "31",
                "latitude": "41.60303280",
                "longitude": "20.87913430",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 706,
                "name": "Zelenikovo",
                "iso2": "32",
                "latitude": "41.87338120",
                "longitude": "21.60272500",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67562,
                        "name": "Zelenikovo",
                        "latitude": "41.88413000",
                        "longitude": "21.58848000"
                    }
                ]
            },
            {
                "id": 668,
                "name": "Želino",
                "iso2": "30",
                "latitude": "41.90065310",
                "longitude": "21.11757670",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67413,
                        "name": "Dobarce",
                        "latitude": "41.95530000",
                        "longitude": "21.08875000"
                    },
                    {
                        "id": 67467,
                        "name": "Larce",
                        "latitude": "41.93319000",
                        "longitude": "21.12628000"
                    },
                    {
                        "id": 67522,
                        "name": "Sedlarevo",
                        "latitude": "41.88306000",
                        "longitude": "21.12750000"
                    },
                    {
                        "id": 67536,
                        "name": "Strimnica",
                        "latitude": "41.96719000",
                        "longitude": "21.03598000"
                    },
                    {
                        "id": 67563,
                        "name": "Zelino",
                        "latitude": "41.98028000",
                        "longitude": "21.06417000"
                    }
                ]
            },
            {
                "id": 673,
                "name": "Zrnovci",
                "iso2": "33",
                "latitude": "41.82282210",
                "longitude": "22.41722560",
                "type": "municipality",
                "cities": [
                    {
                        "id": 67565,
                        "name": "Zrnovci",
                        "latitude": "41.85417000",
                        "longitude": "22.44444000"
                    }
                ]
            }
        ]
    },
    {
        "id": 164,
        "name": "Northern Mariana Islands",
        "iso3": "MNP",
        "iso2": "MP",
        "numeric_code": "580",
        "phonecode": "1",
        "capital": "Saipan",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".mp",
        "native": "Northern Mariana Islands",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Micronesia",
        "subregion_id": 21,
        "nationality": "Northern Marianan",
        "timezones": [
            {
                "zoneName": "Pacific\/Saipan",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "ChST",
                "tzName": "Chamorro Standard Time"
            }
        ],
        "translations": {
            "br": "Mariana an Norzh",
            "ko": "북마리아나 제도",
            "pt-BR": "Ilhas Marianas",
            "pt": "Ilhas Marianas",
            "nl": "Noordelijke Marianeneilanden",
            "hr": "Sjevernomarijanski otoci",
            "fa": "جزایر ماریانای شمالی",
            "de": "Nördliche Marianen",
            "es": "Islas Marianas del Norte",
            "fr": "Îles Mariannes du Nord",
            "ja": "北マリアナ諸島",
            "it": "Isole Marianne Settentrionali",
            "zh-CN": "北马里亚纳群岛",
            "tr": "Kuzey Mariana Adalari",
            "ru": "Северные Марианские острова",
            "uk": "Північні Маріанські острови",
            "pl": "Mariany Północne"
        },
        "latitude": "15.20000000",
        "longitude": "145.75000000",
        "emoji": "🇲🇵",
        "emojiU": "U+1F1F2 U+1F1F5",
        "states": []
    },
    {
        "id": 165,
        "name": "Norway",
        "iso3": "NOR",
        "iso2": "NO",
        "numeric_code": "578",
        "phonecode": "47",
        "capital": "Oslo",
        "currency": "NOK",
        "currency_name": "Norwegian krone",
        "currency_symbol": "ko",
        "tld": ".no",
        "native": "Norge",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Norwegian",
        "timezones": [
            {
                "zoneName": "Europe\/Oslo",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Norvegia",
            "ko": "노르웨이",
            "pt-BR": "Noruega",
            "pt": "Noruega",
            "nl": "Noorwegen",
            "hr": "Norveška",
            "fa": "نروژ",
            "de": "Norwegen",
            "es": "Noruega",
            "fr": "Norvège",
            "ja": "ノルウェー",
            "it": "Norvegia",
            "zh-CN": "挪威",
            "tr": "Norveç",
            "ru": "Норвегия",
            "uk": "Норвегія",
            "pl": "Norwegia"
        },
        "latitude": "62.00000000",
        "longitude": "10.00000000",
        "emoji": "🇳🇴",
        "emojiU": "U+1F1F3 U+1F1F4",
        "states": [
            {
                "id": 1014,
                "name": "Agder",
                "iso2": "42",
                "latitude": "58.74069340",
                "longitude": "6.75315210",
                "type": "county",
                "cities": [
                    {
                        "id": 79688,
                        "name": "Åseral",
                        "latitude": "58.61730000",
                        "longitude": "7.41118000"
                    },
                    {
                        "id": 79049,
                        "name": "Audnedal",
                        "latitude": "58.28378000",
                        "longitude": "7.35487000"
                    },
                    {
                        "id": 79134,
                        "name": "Farsund",
                        "latitude": "58.09538000",
                        "longitude": "6.80403000"
                    },
                    {
                        "id": 79149,
                        "name": "Flekkefjord",
                        "latitude": "58.29791000",
                        "longitude": "6.66345000"
                    },
                    {
                        "id": 79246,
                        "name": "Hægebostad",
                        "latitude": "58.37572000",
                        "longitude": "7.21973000"
                    },
                    {
                        "id": 79260,
                        "name": "Justvik",
                        "latitude": "58.19691000",
                        "longitude": "8.03107000"
                    },
                    {
                        "id": 79287,
                        "name": "Kristiansand",
                        "latitude": "58.14642000",
                        "longitude": "7.99687000"
                    },
                    {
                        "id": 79292,
                        "name": "Kvinesdal",
                        "latitude": "58.23894000",
                        "longitude": "6.71445000"
                    },
                    {
                        "id": 79322,
                        "name": "Liknes",
                        "latitude": "58.31216000",
                        "longitude": "6.96180000"
                    },
                    {
                        "id": 79325,
                        "name": "Lindesnes",
                        "latitude": "58.08435000",
                        "longitude": "7.30162000"
                    },
                    {
                        "id": 79337,
                        "name": "Lyngdal",
                        "latitude": "58.13829000",
                        "longitude": "7.06836000"
                    },
                    {
                        "id": 79350,
                        "name": "Mandal",
                        "latitude": "58.02633000",
                        "longitude": "7.45014000"
                    },
                    {
                        "id": 79353,
                        "name": "Marnardal",
                        "latitude": "58.19802000",
                        "longitude": "7.52802000"
                    },
                    {
                        "id": 79400,
                        "name": "Nodeland",
                        "latitude": "58.15517000",
                        "longitude": "7.83576000"
                    },
                    {
                        "id": 79499,
                        "name": "Sirdal",
                        "latitude": "58.66510000",
                        "longitude": "6.71585000"
                    },
                    {
                        "id": 79523,
                        "name": "Skålevik",
                        "latitude": "58.07955000",
                        "longitude": "8.01602000"
                    },
                    {
                        "id": 79533,
                        "name": "Songdalen",
                        "latitude": "58.15273000",
                        "longitude": "7.83677000"
                    },
                    {
                        "id": 79576,
                        "name": "Søgne",
                        "latitude": "58.09663000",
                        "longitude": "7.81491000"
                    },
                    {
                        "id": 79554,
                        "name": "Strai",
                        "latitude": "58.18930000",
                        "longitude": "7.92826000"
                    },
                    {
                        "id": 79602,
                        "name": "Tonstad",
                        "latitude": "58.66263000",
                        "longitude": "6.71694000"
                    },
                    {
                        "id": 79613,
                        "name": "Tveit",
                        "latitude": "58.23366000",
                        "longitude": "8.12199000"
                    },
                    {
                        "id": 79631,
                        "name": "Vanse",
                        "latitude": "58.09812000",
                        "longitude": "6.69184000"
                    },
                    {
                        "id": 79639,
                        "name": "Vennesla",
                        "latitude": "58.34271000",
                        "longitude": "7.97596000"
                    },
                    {
                        "id": 79643,
                        "name": "Vestbygd",
                        "latitude": "58.09991000",
                        "longitude": "6.58696000"
                    },
                    {
                        "id": 79649,
                        "name": "Vigeland",
                        "latitude": "58.08437000",
                        "longitude": "7.30497000"
                    }
                ]
            },
            {
                "id": 5448,
                "name": "Akershus",
                "iso2": "32",
                "latitude": "60.02464190",
                "longitude": "9.74867520",
                "type": "county",
                "cities": [
                    {
                        "id": 79681,
                        "name": "Åneby",
                        "latitude": "60.08926000",
                        "longitude": "10.86998000"
                    },
                    {
                        "id": 79684,
                        "name": "Årnes",
                        "latitude": "60.12237000",
                        "longitude": "11.47005000"
                    },
                    {
                        "id": 79687,
                        "name": "Ås",
                        "latitude": "59.66366000",
                        "longitude": "10.79101000"
                    },
                    {
                        "id": 79044,
                        "name": "Ask",
                        "latitude": "60.07131000",
                        "longitude": "11.03620000"
                    },
                    {
                        "id": 79045,
                        "name": "Asker",
                        "latitude": "59.83734000",
                        "longitude": "10.43595000"
                    },
                    {
                        "id": 79051,
                        "name": "Auli",
                        "latitude": "60.03450000",
                        "longitude": "11.36046000"
                    },
                    {
                        "id": 79054,
                        "name": "Aurskog-Høland",
                        "latitude": "59.88321000",
                        "longitude": "11.56491000"
                    },
                    {
                        "id": 79055,
                        "name": "Aursmoen",
                        "latitude": "59.92763000",
                        "longitude": "11.44275000"
                    },
                    {
                        "id": 79094,
                        "name": "Bærum",
                        "latitude": "59.88996000",
                        "longitude": "10.52649000"
                    },
                    {
                        "id": 79073,
                        "name": "Billingstad",
                        "latitude": "59.87548000",
                        "longitude": "10.48230000"
                    },
                    {
                        "id": 79078,
                        "name": "Bjørkelangen",
                        "latitude": "59.88357000",
                        "longitude": "11.56396000"
                    },
                    {
                        "id": 79080,
                        "name": "Blakstad",
                        "latitude": "59.81910000",
                        "longitude": "10.46450000"
                    },
                    {
                        "id": 79106,
                        "name": "Drøbak",
                        "latitude": "59.66333000",
                        "longitude": "10.62975000"
                    },
                    {
                        "id": 79115,
                        "name": "Eidsvoll",
                        "latitude": "60.32893000",
                        "longitude": "11.26119000"
                    },
                    {
                        "id": 79123,
                        "name": "Enebakk",
                        "latitude": "59.76452000",
                        "longitude": "11.14492000"
                    },
                    {
                        "id": 79132,
                        "name": "Fagerstrand",
                        "latitude": "59.73746000",
                        "longitude": "10.59404000"
                    },
                    {
                        "id": 79137,
                        "name": "Fet",
                        "latitude": "59.92216000",
                        "longitude": "11.16778000"
                    },
                    {
                        "id": 79138,
                        "name": "Fetsund",
                        "latitude": "59.92463000",
                        "longitude": "11.15711000"
                    },
                    {
                        "id": 79145,
                        "name": "Fjellfoten",
                        "latitude": "60.08967000",
                        "longitude": "11.47222000"
                    },
                    {
                        "id": 79148,
                        "name": "Flateby",
                        "latitude": "59.82951000",
                        "longitude": "11.15345000"
                    },
                    {
                        "id": 79161,
                        "name": "Frogn",
                        "latitude": "59.66665000",
                        "longitude": "10.63566000"
                    },
                    {
                        "id": 79162,
                        "name": "Frogner",
                        "latitude": "60.02463000",
                        "longitude": "11.10284000"
                    },
                    {
                        "id": 79178,
                        "name": "Gjerdrum",
                        "latitude": "60.07159000",
                        "longitude": "11.03597000"
                    },
                    {
                        "id": 79239,
                        "name": "Hurdal",
                        "latitude": "60.43518000",
                        "longitude": "11.06707000"
                    },
                    {
                        "id": 79256,
                        "name": "Jessheim",
                        "latitude": "60.14151000",
                        "longitude": "11.17515000"
                    },
                    {
                        "id": 79276,
                        "name": "Kløfta",
                        "latitude": "60.07407000",
                        "longitude": "11.13805000"
                    },
                    {
                        "id": 79310,
                        "name": "Leirsund",
                        "latitude": "59.99682000",
                        "longitude": "11.08746000"
                    },
                    {
                        "id": 79324,
                        "name": "Lillestrøm",
                        "latitude": "59.95597000",
                        "longitude": "11.04918000"
                    },
                    {
                        "id": 79346,
                        "name": "Lørenskog",
                        "latitude": "59.93209000",
                        "longitude": "10.96079000"
                    },
                    {
                        "id": 79340,
                        "name": "Lysaker",
                        "latitude": "59.90994000",
                        "longitude": "10.63545000"
                    },
                    {
                        "id": 79355,
                        "name": "Maura",
                        "latitude": "60.25830000",
                        "longitude": "11.03192000"
                    },
                    {
                        "id": 79385,
                        "name": "Nannestad",
                        "latitude": "60.21707000",
                        "longitude": "11.01200000"
                    },
                    {
                        "id": 79389,
                        "name": "Nes",
                        "latitude": "60.12252000",
                        "longitude": "11.46570000"
                    },
                    {
                        "id": 79392,
                        "name": "Neskollen",
                        "latitude": "60.12159000",
                        "longitude": "11.33926000"
                    },
                    {
                        "id": 79394,
                        "name": "Nesodden",
                        "latitude": "59.84220000",
                        "longitude": "10.64940000"
                    },
                    {
                        "id": 79395,
                        "name": "Nesoddtangen",
                        "latitude": "59.86244000",
                        "longitude": "10.66308000"
                    },
                    {
                        "id": 79399,
                        "name": "Nittedal",
                        "latitude": "60.04278000",
                        "longitude": "10.88167000"
                    },
                    {
                        "id": 79420,
                        "name": "Oppegård",
                        "latitude": "59.81149000",
                        "longitude": "10.79712000"
                    },
                    {
                        "id": 79464,
                        "name": "Råholt",
                        "latitude": "60.27513000",
                        "longitude": "11.17901000"
                    },
                    {
                        "id": 79465,
                        "name": "Rælingen",
                        "latitude": "59.92626000",
                        "longitude": "11.06527000"
                    },
                    {
                        "id": 79458,
                        "name": "Rotnes",
                        "latitude": "60.05707000",
                        "longitude": "10.86135000"
                    },
                    {
                        "id": 79506,
                        "name": "Skedsmo",
                        "latitude": "59.95448000",
                        "longitude": "11.03952000"
                    },
                    {
                        "id": 79507,
                        "name": "Ski",
                        "latitude": "59.72049000",
                        "longitude": "10.83882000"
                    },
                    {
                        "id": 79522,
                        "name": "Skui",
                        "latitude": "59.92746000",
                        "longitude": "10.44750000"
                    },
                    {
                        "id": 79586,
                        "name": "Sørum",
                        "latitude": "59.98709000",
                        "longitude": "11.24019000"
                    },
                    {
                        "id": 79587,
                        "name": "Sørumsand",
                        "latitude": "59.98621000",
                        "longitude": "11.24154000"
                    },
                    {
                        "id": 79621,
                        "name": "Ullensaker",
                        "latitude": "60.14401000",
                        "longitude": "11.17441000"
                    },
                    {
                        "id": 79642,
                        "name": "Vestby",
                        "latitude": "59.60228000",
                        "longitude": "10.74807000"
                    }
                ]
            },
            {
                "id": 5449,
                "name": "Buskerud",
                "iso2": "33",
                "latitude": "60.24322920",
                "longitude": "7.69873090",
                "type": "county",
                "cities": [
                    {
                        "id": 79677,
                        "name": "Ål",
                        "latitude": "60.63028000",
                        "longitude": "8.56115000"
                    },
                    {
                        "id": 79685,
                        "name": "Åros",
                        "latitude": "59.70610000",
                        "longitude": "10.51092000"
                    },
                    {
                        "id": 79104,
                        "name": "Drammen",
                        "latitude": "59.74389000",
                        "longitude": "10.20449000"
                    },
                    {
                        "id": 79153,
                        "name": "Flå",
                        "latitude": "60.42910000",
                        "longitude": "9.46611000"
                    },
                    {
                        "id": 79150,
                        "name": "Flesberg",
                        "latitude": "59.83283000",
                        "longitude": "9.58308000"
                    },
                    {
                        "id": 79174,
                        "name": "Geilo",
                        "latitude": "60.53369000",
                        "longitude": "8.20539000"
                    },
                    {
                        "id": 79184,
                        "name": "Gol",
                        "latitude": "60.69953000",
                        "longitude": "8.95024000"
                    },
                    {
                        "id": 79217,
                        "name": "Hemsedal",
                        "latitude": "60.86114000",
                        "longitude": "8.56537000"
                    },
                    {
                        "id": 79227,
                        "name": "Hol",
                        "latitude": "60.61528000",
                        "longitude": "8.30194000"
                    },
                    {
                        "id": 79228,
                        "name": "Hole",
                        "latitude": "60.08017000",
                        "longitude": "10.27840000"
                    },
                    {
                        "id": 79247,
                        "name": "Hønefoss",
                        "latitude": "60.16804000",
                        "longitude": "10.25647000"
                    },
                    {
                        "id": 79240,
                        "name": "Hurum",
                        "latitude": "59.61401000",
                        "longitude": "10.45763000"
                    },
                    {
                        "id": 79242,
                        "name": "Hvittingfoss",
                        "latitude": "59.48572000",
                        "longitude": "10.01173000"
                    },
                    {
                        "id": 79281,
                        "name": "Kongsberg",
                        "latitude": "59.66516000",
                        "longitude": "9.64653000"
                    },
                    {
                        "id": 79289,
                        "name": "Krødsherad",
                        "latitude": "60.17944000",
                        "longitude": "9.62124000"
                    },
                    {
                        "id": 79320,
                        "name": "Lier",
                        "latitude": "59.78663000",
                        "longitude": "10.24590000"
                    },
                    {
                        "id": 79368,
                        "name": "Modum",
                        "latitude": "59.97346000",
                        "longitude": "10.00468000"
                    },
                    {
                        "id": 79388,
                        "name": "Nedre Eiker",
                        "latitude": "59.75023000",
                        "longitude": "10.00736000"
                    },
                    {
                        "id": 79391,
                        "name": "Nesbyen",
                        "latitude": "60.56809000",
                        "longitude": "9.10274000"
                    },
                    {
                        "id": 79411,
                        "name": "Nore og Uvdal",
                        "latitude": "60.26706000",
                        "longitude": "8.94635000"
                    },
                    {
                        "id": 79412,
                        "name": "Noresund",
                        "latitude": "60.17985000",
                        "longitude": "9.62411000"
                    },
                    {
                        "id": 79700,
                        "name": "Øvre Eiker",
                        "latitude": "59.77111000",
                        "longitude": "9.90840000"
                    },
                    {
                        "id": 79432,
                        "name": "Prestfoss",
                        "latitude": "60.04343000",
                        "longitude": "9.63520000"
                    },
                    {
                        "id": 79451,
                        "name": "Ringerike",
                        "latitude": "60.16018000",
                        "longitude": "10.25660000"
                    },
                    {
                        "id": 79456,
                        "name": "Rollag",
                        "latitude": "59.98413000",
                        "longitude": "9.29489000"
                    },
                    {
                        "id": 79471,
                        "name": "Røyken",
                        "latitude": "59.74019000",
                        "longitude": "10.41321000"
                    },
                    {
                        "id": 79574,
                        "name": "Sætre",
                        "latitude": "59.68129000",
                        "longitude": "10.52749000"
                    },
                    {
                        "id": 79497,
                        "name": "Sigdal",
                        "latitude": "60.04592000",
                        "longitude": "9.63673000"
                    },
                    {
                        "id": 79515,
                        "name": "Skoger",
                        "latitude": "59.71327000",
                        "longitude": "10.25356000"
                    },
                    {
                        "id": 79597,
                        "name": "Tofte",
                        "latitude": "59.54275000",
                        "longitude": "10.56138000"
                    },
                    {
                        "id": 79601,
                        "name": "Tomter",
                        "latitude": "59.65910000",
                        "longitude": "10.99487000"
                    },
                    {
                        "id": 79604,
                        "name": "Tranby",
                        "latitude": "59.80850000",
                        "longitude": "10.26114000"
                    },
                    {
                        "id": 79653,
                        "name": "Vikersund",
                        "latitude": "59.96838000",
                        "longitude": "9.99107000"
                    }
                ]
            },
            {
                "id": 1015,
                "name": "Finnmark",
                "iso2": "56",
                "latitude": "69.85261320",
                "longitude": "20.66464210",
                "type": "county",
                "cities": [
                    {
                        "id": 79039,
                        "name": "Alta",
                        "latitude": "69.97675000",
                        "longitude": "23.29634000"
                    },
                    {
                        "id": 79672,
                        "name": "Ávanuorri",
                        "latitude": "70.99634000",
                        "longitude": "24.66217000"
                    },
                    {
                        "id": 79093,
                        "name": "Båtsfjord",
                        "latitude": "70.63428000",
                        "longitude": "29.71750000"
                    },
                    {
                        "id": 79068,
                        "name": "Berg",
                        "latitude": "69.44444000",
                        "longitude": "17.29950000"
                    },
                    {
                        "id": 79072,
                        "name": "Berlevåg",
                        "latitude": "70.85778000",
                        "longitude": "29.08636000"
                    },
                    {
                        "id": 79079,
                        "name": "Bjørnevatn",
                        "latitude": "69.66745000",
                        "longitude": "29.98722000"
                    },
                    {
                        "id": 79084,
                        "name": "Borkenes",
                        "latitude": "68.77261000",
                        "longitude": "16.17115000"
                    },
                    {
                        "id": 79129,
                        "name": "Evenskjer",
                        "latitude": "68.58283000",
                        "longitude": "16.57203000"
                    },
                    {
                        "id": 79140,
                        "name": "Finnsnes",
                        "latitude": "69.22959000",
                        "longitude": "17.98114000"
                    },
                    {
                        "id": 79170,
                        "name": "Gamvik",
                        "latitude": "71.04107000",
                        "longitude": "27.85144000"
                    },
                    {
                        "id": 79193,
                        "name": "Gryllefjord",
                        "latitude": "69.36304000",
                        "longitude": "17.05284000"
                    },
                    {
                        "id": 79203,
                        "name": "Hammerfest",
                        "latitude": "70.66257000",
                        "longitude": "23.68295000"
                    },
                    {
                        "id": 79204,
                        "name": "Hansnes",
                        "latitude": "69.96701000",
                        "longitude": "19.62752000"
                    },
                    {
                        "id": 79209,
                        "name": "Hasvik",
                        "latitude": "70.59164000",
                        "longitude": "22.30272000"
                    },
                    {
                        "id": 79233,
                        "name": "Honningsvåg",
                        "latitude": "70.98209000",
                        "longitude": "25.97037000"
                    },
                    {
                        "id": 79300,
                        "name": "Kåfjord",
                        "latitude": "69.60400000",
                        "longitude": "20.53456000"
                    },
                    {
                        "id": 79299,
                        "name": "Kárášjohka",
                        "latitude": "69.47187000",
                        "longitude": "25.51122000"
                    },
                    {
                        "id": 79264,
                        "name": "Karasjok",
                        "latitude": "69.47224000",
                        "longitude": "25.51885000"
                    },
                    {
                        "id": 79268,
                        "name": "Kautokeino",
                        "latitude": "69.01151000",
                        "longitude": "23.04151000"
                    },
                    {
                        "id": 79270,
                        "name": "Kirkenes",
                        "latitude": "69.72706000",
                        "longitude": "30.04578000"
                    },
                    {
                        "id": 79272,
                        "name": "Kjøllefjord",
                        "latitude": "70.94574000",
                        "longitude": "27.34650000"
                    },
                    {
                        "id": 79290,
                        "name": "Kvalsund",
                        "latitude": "70.49910000",
                        "longitude": "23.97393000"
                    },
                    {
                        "id": 79301,
                        "name": "Lakselv",
                        "latitude": "70.05133000",
                        "longitude": "24.97182000"
                    },
                    {
                        "id": 79307,
                        "name": "Lebesby",
                        "latitude": "70.94535000",
                        "longitude": "27.35134000"
                    },
                    {
                        "id": 79316,
                        "name": "Lenvik",
                        "latitude": "69.23111000",
                        "longitude": "17.98739000"
                    },
                    {
                        "id": 79329,
                        "name": "Loppa",
                        "latitude": "70.23952000",
                        "longitude": "22.35136000"
                    },
                    {
                        "id": 79339,
                        "name": "Lyngseidet",
                        "latitude": "69.57629000",
                        "longitude": "20.21887000"
                    },
                    {
                        "id": 79381,
                        "name": "Måsøy",
                        "latitude": "70.99654000",
                        "longitude": "24.66146000"
                    },
                    {
                        "id": 79356,
                        "name": "Mehamn",
                        "latitude": "71.04137000",
                        "longitude": "27.85133000"
                    },
                    {
                        "id": 79370,
                        "name": "Moen",
                        "latitude": "69.13043000",
                        "longitude": "18.61226000"
                    },
                    {
                        "id": 79396,
                        "name": "Nesseby",
                        "latitude": "69.88541000",
                        "longitude": "28.43368000"
                    },
                    {
                        "id": 79407,
                        "name": "Nordkapp",
                        "latitude": "70.97808000",
                        "longitude": "25.97473000"
                    },
                    {
                        "id": 79418,
                        "name": "Olderdalen",
                        "latitude": "69.60407000",
                        "longitude": "20.53272000"
                    },
                    {
                        "id": 79691,
                        "name": "Øksfjord",
                        "latitude": "70.23936000",
                        "longitude": "22.35070000"
                    },
                    {
                        "id": 79429,
                        "name": "Porsanger",
                        "latitude": "70.05214000",
                        "longitude": "24.95592000"
                    },
                    {
                        "id": 79462,
                        "name": "Rypefjord",
                        "latitude": "70.64126000",
                        "longitude": "23.67213000"
                    },
                    {
                        "id": 79496,
                        "name": "Setermoen",
                        "latitude": "68.86099000",
                        "longitude": "18.34857000"
                    },
                    {
                        "id": 79503,
                        "name": "Sjøvegan",
                        "latitude": "68.87363000",
                        "longitude": "17.84706000"
                    },
                    {
                        "id": 79524,
                        "name": "Skånland",
                        "latitude": "68.58378000",
                        "longitude": "16.57305000"
                    },
                    {
                        "id": 79582,
                        "name": "Sør-Varanger",
                        "latitude": "69.72859000",
                        "longitude": "30.04264000"
                    },
                    {
                        "id": 79552,
                        "name": "Storslett",
                        "latitude": "69.76783000",
                        "longitude": "21.02466000"
                    },
                    {
                        "id": 79553,
                        "name": "Storsteinnes",
                        "latitude": "69.24081000",
                        "longitude": "19.23437000"
                    },
                    {
                        "id": 79588,
                        "name": "Tana",
                        "latitude": "70.19976000",
                        "longitude": "28.18494000"
                    },
                    {
                        "id": 79603,
                        "name": "Torsken",
                        "latitude": "69.36184000",
                        "longitude": "17.05384000"
                    },
                    {
                        "id": 79605,
                        "name": "Tranøy",
                        "latitude": "69.17022000",
                        "longitude": "17.73480000"
                    },
                    {
                        "id": 79628,
                        "name": "Vadsø",
                        "latitude": "70.07412000",
                        "longitude": "29.74922000"
                    },
                    {
                        "id": 79633,
                        "name": "Vardø",
                        "latitude": "70.37040000",
                        "longitude": "31.10866000"
                    }
                ]
            },
            {
                "id": 1009,
                "name": "Innlandet",
                "iso2": "34",
                "latitude": "61.19357870",
                "longitude": "5.50832660",
                "type": "county",
                "cities": [
                    {
                        "id": 79040,
                        "name": "Alvdal",
                        "latitude": "62.10854000",
                        "longitude": "10.63483000"
                    },
                    {
                        "id": 79679,
                        "name": "Åmot",
                        "latitude": "61.13199000",
                        "longitude": "11.37328000"
                    },
                    {
                        "id": 79690,
                        "name": "Åsnes",
                        "latitude": "60.61363000",
                        "longitude": "12.01200000"
                    },
                    {
                        "id": 79059,
                        "name": "Bagn",
                        "latitude": "60.82249000",
                        "longitude": "9.55207000"
                    },
                    {
                        "id": 79089,
                        "name": "Brumunddal",
                        "latitude": "60.88095000",
                        "longitude": "10.93948000"
                    },
                    {
                        "id": 79101,
                        "name": "Dokka",
                        "latitude": "60.83500000",
                        "longitude": "10.07362000"
                    },
                    {
                        "id": 79102,
                        "name": "Dombås",
                        "latitude": "62.07554000",
                        "longitude": "9.12785000"
                    },
                    {
                        "id": 79103,
                        "name": "Dovre",
                        "latitude": "61.98582000",
                        "longitude": "9.24947000"
                    },
                    {
                        "id": 79114,
                        "name": "Eidskog",
                        "latitude": "59.98556000",
                        "longitude": "12.12502000"
                    },
                    {
                        "id": 79122,
                        "name": "Elverum",
                        "latitude": "60.88159000",
                        "longitude": "11.56314000"
                    },
                    {
                        "id": 79124,
                        "name": "Engerdal",
                        "latitude": "61.75774000",
                        "longitude": "11.95966000"
                    },
                    {
                        "id": 79127,
                        "name": "Etnedal",
                        "latitude": "60.88872000",
                        "longitude": "9.64031000"
                    },
                    {
                        "id": 79131,
                        "name": "Fagernes",
                        "latitude": "60.98584000",
                        "longitude": "9.23236000"
                    },
                    {
                        "id": 79154,
                        "name": "Folldal",
                        "latitude": "62.13329000",
                        "longitude": "9.99710000"
                    },
                    {
                        "id": 79157,
                        "name": "Fossbergom",
                        "latitude": "61.83772000",
                        "longitude": "8.56842000"
                    },
                    {
                        "id": 79173,
                        "name": "Gausdal",
                        "latitude": "61.22685000",
                        "longitude": "10.22145000"
                    },
                    {
                        "id": 79180,
                        "name": "Gjøvik",
                        "latitude": "60.79472000",
                        "longitude": "10.69287000"
                    },
                    {
                        "id": 79185,
                        "name": "Gran",
                        "latitude": "60.39293000",
                        "longitude": "10.56045000"
                    },
                    {
                        "id": 79191,
                        "name": "Grua",
                        "latitude": "60.25701000",
                        "longitude": "10.66222000"
                    },
                    {
                        "id": 79192,
                        "name": "Grue",
                        "latitude": "60.45133000",
                        "longitude": "12.05489000"
                    },
                    {
                        "id": 79201,
                        "name": "Hamar",
                        "latitude": "60.79450000",
                        "longitude": "11.06798000"
                    },
                    {
                        "id": 79237,
                        "name": "Hov",
                        "latitude": "60.69870000",
                        "longitude": "10.35193000"
                    },
                    {
                        "id": 79238,
                        "name": "Hundorp",
                        "latitude": "61.55523000",
                        "longitude": "9.94069000"
                    },
                    {
                        "id": 79254,
                        "name": "Innbygda",
                        "latitude": "61.31484000",
                        "longitude": "12.26374000"
                    },
                    {
                        "id": 79257,
                        "name": "Jevnaker",
                        "latitude": "60.24060000",
                        "longitude": "10.38587000"
                    },
                    {
                        "id": 79271,
                        "name": "Kirkenær",
                        "latitude": "60.45790000",
                        "longitude": "12.05855000"
                    },
                    {
                        "id": 79282,
                        "name": "Kongsvinger",
                        "latitude": "60.19117000",
                        "longitude": "11.99916000"
                    },
                    {
                        "id": 79284,
                        "name": "Koppang",
                        "latitude": "61.57219000",
                        "longitude": "11.04659000"
                    },
                    {
                        "id": 79315,
                        "name": "Lena",
                        "latitude": "60.67391000",
                        "longitude": "10.81317000"
                    },
                    {
                        "id": 79318,
                        "name": "Lesja",
                        "latitude": "62.11785000",
                        "longitude": "8.86262000"
                    },
                    {
                        "id": 79323,
                        "name": "Lillehammer",
                        "latitude": "61.11464000",
                        "longitude": "10.46743000"
                    },
                    {
                        "id": 79327,
                        "name": "Lom",
                        "latitude": "61.83639000",
                        "longitude": "8.56811000"
                    },
                    {
                        "id": 79347,
                        "name": "Løten",
                        "latitude": "60.81771000",
                        "longitude": "11.34373000"
                    },
                    {
                        "id": 79333,
                        "name": "Lunner",
                        "latitude": "60.29462000",
                        "longitude": "10.60860000"
                    },
                    {
                        "id": 79369,
                        "name": "Moelv",
                        "latitude": "60.93333000",
                        "longitude": "10.70000000"
                    },
                    {
                        "id": 79402,
                        "name": "Nord-Aurdal",
                        "latitude": "60.98531000",
                        "longitude": "9.23661000"
                    },
                    {
                        "id": 79403,
                        "name": "Nord-Fron",
                        "latitude": "61.59556000",
                        "longitude": "9.74830000"
                    },
                    {
                        "id": 79404,
                        "name": "Nord-Odal",
                        "latitude": "60.39195000",
                        "longitude": "11.54151000"
                    },
                    {
                        "id": 79408,
                        "name": "Nordre Land",
                        "latitude": "60.83471000",
                        "longitude": "10.07543000"
                    },
                    {
                        "id": 79422,
                        "name": "Os",
                        "latitude": "62.49536000",
                        "longitude": "11.22807000"
                    },
                    {
                        "id": 79427,
                        "name": "Otta",
                        "latitude": "61.77120000",
                        "longitude": "9.53529000"
                    },
                    {
                        "id": 79699,
                        "name": "Østre Toten",
                        "latitude": "60.67659000",
                        "longitude": "10.81997000"
                    },
                    {
                        "id": 79701,
                        "name": "Øyer",
                        "latitude": "61.26495000",
                        "longitude": "10.41297000"
                    },
                    {
                        "id": 79704,
                        "name": "Øystre Slidre",
                        "latitude": "61.13377000",
                        "longitude": "9.07872000"
                    },
                    {
                        "id": 79439,
                        "name": "Raufoss",
                        "latitude": "60.72604000",
                        "longitude": "10.61330000"
                    },
                    {
                        "id": 79443,
                        "name": "Reinsvoll",
                        "latitude": "60.67977000",
                        "longitude": "10.62175000"
                    },
                    {
                        "id": 79444,
                        "name": "Rena",
                        "latitude": "61.13222000",
                        "longitude": "11.37156000"
                    },
                    {
                        "id": 79445,
                        "name": "Rendalen",
                        "latitude": "61.89004000",
                        "longitude": "11.07694000"
                    },
                    {
                        "id": 79450,
                        "name": "Ringebu",
                        "latitude": "61.52980000",
                        "longitude": "10.14180000"
                    },
                    {
                        "id": 79452,
                        "name": "Ringsaker",
                        "latitude": "60.88216000",
                        "longitude": "10.95030000"
                    },
                    {
                        "id": 79477,
                        "name": "Sand",
                        "latitude": "60.39220000",
                        "longitude": "11.54030000"
                    },
                    {
                        "id": 79490,
                        "name": "Sel",
                        "latitude": "61.77278000",
                        "longitude": "9.53415000"
                    },
                    {
                        "id": 79504,
                        "name": "Skarnes",
                        "latitude": "60.25391000",
                        "longitude": "11.68485000"
                    },
                    {
                        "id": 79512,
                        "name": "Skjåk",
                        "latitude": "61.88349000",
                        "longitude": "8.26490000"
                    },
                    {
                        "id": 79519,
                        "name": "Skotterud",
                        "latitude": "59.98281000",
                        "longitude": "12.12825000"
                    },
                    {
                        "id": 79520,
                        "name": "Skreia",
                        "latitude": "60.65257000",
                        "longitude": "10.93564000"
                    },
                    {
                        "id": 79578,
                        "name": "Søndre Land",
                        "latitude": "60.69944000",
                        "longitude": "10.35086000"
                    },
                    {
                        "id": 79579,
                        "name": "Sør-Aurdal",
                        "latitude": "60.82242000",
                        "longitude": "9.54836000"
                    },
                    {
                        "id": 79580,
                        "name": "Sør-Fron",
                        "latitude": "61.55652000",
                        "longitude": "9.93949000"
                    },
                    {
                        "id": 79581,
                        "name": "Sør-Odal",
                        "latitude": "60.25455000",
                        "longitude": "11.68246000"
                    },
                    {
                        "id": 79535,
                        "name": "Spetalen",
                        "latitude": "60.18333000",
                        "longitude": "11.90000000"
                    },
                    {
                        "id": 79537,
                        "name": "Stange",
                        "latitude": "60.71576000",
                        "longitude": "11.19069000"
                    },
                    {
                        "id": 79547,
                        "name": "Stor-Elvdal",
                        "latitude": "61.57198000",
                        "longitude": "11.04759000"
                    },
                    {
                        "id": 79599,
                        "name": "Tolga",
                        "latitude": "62.40984000",
                        "longitude": "10.99770000"
                    },
                    {
                        "id": 79606,
                        "name": "Tretten",
                        "latitude": "61.31423000",
                        "longitude": "10.30066000"
                    },
                    {
                        "id": 79610,
                        "name": "Trysil",
                        "latitude": "61.31549000",
                        "longitude": "12.26422000"
                    },
                    {
                        "id": 79615,
                        "name": "Tynset",
                        "latitude": "62.27387000",
                        "longitude": "10.77626000"
                    },
                    {
                        "id": 79665,
                        "name": "Vågå",
                        "latitude": "61.87565000",
                        "longitude": "9.09572000"
                    },
                    {
                        "id": 79666,
                        "name": "Vågåmo",
                        "latitude": "61.87505000",
                        "longitude": "9.09671000"
                    },
                    {
                        "id": 79667,
                        "name": "Våler",
                        "latitude": "60.67845000",
                        "longitude": "11.83314000"
                    },
                    {
                        "id": 79630,
                        "name": "Vang",
                        "latitude": "61.12564000",
                        "longitude": "8.57167000"
                    },
                    {
                        "id": 79645,
                        "name": "Vestre Slidre",
                        "latitude": "61.08842000",
                        "longitude": "8.98196000"
                    },
                    {
                        "id": 79646,
                        "name": "Vestre Toten",
                        "latitude": "60.72593000",
                        "longitude": "10.60764000"
                    },
                    {
                        "id": 79659,
                        "name": "Vinstra",
                        "latitude": "61.59496000",
                        "longitude": "9.75134000"
                    }
                ]
            },
            {
                "id": 1026,
                "name": "Jan Mayen",
                "iso2": "22",
                "latitude": "71.03181800",
                "longitude": "-8.29203460",
                "type": "arctic region",
                "cities": []
            },
            {
                "id": 1020,
                "name": "Møre og Romsdal",
                "iso2": "15",
                "latitude": "62.84068330",
                "longitude": "7.00714300",
                "type": "county",
                "cities": [
                    {
                        "id": 79678,
                        "name": "Ålesund",
                        "latitude": "62.47225000",
                        "longitude": "6.15492000"
                    },
                    {
                        "id": 79680,
                        "name": "Åndalsnes",
                        "latitude": "62.56749000",
                        "longitude": "7.68709000"
                    },
                    {
                        "id": 79050,
                        "name": "Aukra",
                        "latitude": "62.80500000",
                        "longitude": "6.88722000"
                    },
                    {
                        "id": 79052,
                        "name": "Aure",
                        "latitude": "63.26750000",
                        "longitude": "8.52778000"
                    },
                    {
                        "id": 79058,
                        "name": "Averøy",
                        "latitude": "63.05344000",
                        "longitude": "7.63265000"
                    },
                    {
                        "id": 79066,
                        "name": "Batnfjordsøra",
                        "latitude": "62.89463000",
                        "longitude": "7.67251000"
                    },
                    {
                        "id": 79086,
                        "name": "Brattvåg",
                        "latitude": "62.59991000",
                        "longitude": "6.44426000"
                    },
                    {
                        "id": 79111,
                        "name": "Eide",
                        "latitude": "62.91570000",
                        "longitude": "7.44496000"
                    },
                    {
                        "id": 79116,
                        "name": "Eidsvåg",
                        "latitude": "62.77656000",
                        "longitude": "8.06550000"
                    },
                    {
                        "id": 79121,
                        "name": "Elnesvågen",
                        "latitude": "62.85426000",
                        "longitude": "7.13769000"
                    },
                    {
                        "id": 79164,
                        "name": "Fræna",
                        "latitude": "62.85375000",
                        "longitude": "7.15380000"
                    },
                    {
                        "id": 79176,
                        "name": "Giske",
                        "latitude": "62.50070000",
                        "longitude": "6.13472000"
                    },
                    {
                        "id": 79177,
                        "name": "Gjemnes",
                        "latitude": "62.89379000",
                        "longitude": "7.67714000"
                    },
                    {
                        "id": 79200,
                        "name": "Halsa",
                        "latitude": "63.11855000",
                        "longitude": "8.31536000"
                    },
                    {
                        "id": 79205,
                        "name": "Haram",
                        "latitude": "62.59898000",
                        "longitude": "6.44483000"
                    },
                    {
                        "id": 79207,
                        "name": "Hareid",
                        "latitude": "62.36742000",
                        "longitude": "6.02114000"
                    },
                    {
                        "id": 79221,
                        "name": "Herøy",
                        "latitude": "62.33333000",
                        "longitude": "5.63598000"
                    },
                    {
                        "id": 79225,
                        "name": "Hjelset",
                        "latitude": "62.78050000",
                        "longitude": "7.49277000"
                    },
                    {
                        "id": 79234,
                        "name": "Hopen",
                        "latitude": "63.46539000",
                        "longitude": "8.01437000"
                    },
                    {
                        "id": 79288,
                        "name": "Kristiansund",
                        "latitude": "63.11152000",
                        "longitude": "7.73198000"
                    },
                    {
                        "id": 79303,
                        "name": "Larsnes",
                        "latitude": "62.20282000",
                        "longitude": "5.57729000"
                    },
                    {
                        "id": 79364,
                        "name": "Midsund",
                        "latitude": "62.67614000",
                        "longitude": "6.67776000"
                    },
                    {
                        "id": 79372,
                        "name": "Molde",
                        "latitude": "62.73807000",
                        "longitude": "7.15882000"
                    },
                    {
                        "id": 79397,
                        "name": "Nesset",
                        "latitude": "62.77619000",
                        "longitude": "8.06623000"
                    },
                    {
                        "id": 79405,
                        "name": "Norddal",
                        "latitude": "62.29910000",
                        "longitude": "7.26145000"
                    },
                    {
                        "id": 79410,
                        "name": "Nordstranda",
                        "latitude": "62.51384000",
                        "longitude": "6.13166000"
                    },
                    {
                        "id": 79697,
                        "name": "Ørskog",
                        "latitude": "62.48450000",
                        "longitude": "6.82025000"
                    },
                    {
                        "id": 79698,
                        "name": "Ørsta",
                        "latitude": "62.19937000",
                        "longitude": "6.13084000"
                    },
                    {
                        "id": 79440,
                        "name": "Rauma",
                        "latitude": "62.56810000",
                        "longitude": "7.68612000"
                    },
                    {
                        "id": 79448,
                        "name": "Rensvik",
                        "latitude": "63.09843000",
                        "longitude": "7.82026000"
                    },
                    {
                        "id": 79481,
                        "name": "Sande",
                        "latitude": "62.20455000",
                        "longitude": "5.57971000"
                    },
                    {
                        "id": 79486,
                        "name": "Sandøy",
                        "latitude": "62.78167000",
                        "longitude": "6.46875000"
                    },
                    {
                        "id": 79501,
                        "name": "Sjøholt",
                        "latitude": "62.48263000",
                        "longitude": "6.81376000"
                    },
                    {
                        "id": 79514,
                        "name": "Skodje",
                        "latitude": "62.50306000",
                        "longitude": "6.69817000"
                    },
                    {
                        "id": 79525,
                        "name": "Smøla",
                        "latitude": "63.46526000",
                        "longitude": "8.01814000"
                    },
                    {
                        "id": 79542,
                        "name": "Steinshamn",
                        "latitude": "62.78389000",
                        "longitude": "6.47065000"
                    },
                    {
                        "id": 79549,
                        "name": "Stordal",
                        "latitude": "62.38214000",
                        "longitude": "6.98708000"
                    },
                    {
                        "id": 79556,
                        "name": "Stranda",
                        "latitude": "62.31132000",
                        "longitude": "6.93115000"
                    },
                    {
                        "id": 79562,
                        "name": "Sula",
                        "latitude": "62.44447000",
                        "longitude": "6.21229000"
                    },
                    {
                        "id": 79565,
                        "name": "Sunndal",
                        "latitude": "62.67464000",
                        "longitude": "8.56188000"
                    },
                    {
                        "id": 79566,
                        "name": "Sunndalsøra",
                        "latitude": "62.67519000",
                        "longitude": "8.56327000"
                    },
                    {
                        "id": 79567,
                        "name": "Surnadal",
                        "latitude": "62.97533000",
                        "longitude": "8.72490000"
                    },
                    {
                        "id": 79573,
                        "name": "Sykkylven",
                        "latitude": "62.38962000",
                        "longitude": "6.57825000"
                    },
                    {
                        "id": 79593,
                        "name": "Tingvoll",
                        "latitude": "62.91194000",
                        "longitude": "8.20673000"
                    },
                    {
                        "id": 79600,
                        "name": "Tomra",
                        "latitude": "62.58118000",
                        "longitude": "6.93106000"
                    },
                    {
                        "id": 79623,
                        "name": "Ulstein",
                        "latitude": "62.34423000",
                        "longitude": "5.85241000"
                    },
                    {
                        "id": 79624,
                        "name": "Ulsteinvik",
                        "latitude": "62.34317000",
                        "longitude": "5.84869000"
                    },
                    {
                        "id": 79625,
                        "name": "Ulsteinvik weather pws station",
                        "latitude": "62.34338000",
                        "longitude": "5.84385000"
                    },
                    {
                        "id": 79632,
                        "name": "Vanylven",
                        "latitude": "62.10003000",
                        "longitude": "5.55827000"
                    },
                    {
                        "id": 79635,
                        "name": "Vatne",
                        "latitude": "62.55826000",
                        "longitude": "6.61708000"
                    },
                    {
                        "id": 79644,
                        "name": "Vestnes",
                        "latitude": "62.62130000",
                        "longitude": "7.08966000"
                    },
                    {
                        "id": 79660,
                        "name": "Volda",
                        "latitude": "62.14678000",
                        "longitude": "6.06800000"
                    }
                ]
            },
            {
                "id": 1025,
                "name": "Nordland",
                "iso2": "18",
                "latitude": "67.69305800",
                "longitude": "12.70739360",
                "type": "county",
                "cities": [
                    {
                        "id": 79038,
                        "name": "Alstahaug",
                        "latitude": "65.97556000",
                        "longitude": "12.56836000"
                    },
                    {
                        "id": 79041,
                        "name": "Andenes",
                        "latitude": "69.31428000",
                        "longitude": "16.11939000"
                    },
                    {
                        "id": 79042,
                        "name": "Andøy",
                        "latitude": "69.08033000",
                        "longitude": "15.77637000"
                    },
                    {
                        "id": 79061,
                        "name": "Ballangen",
                        "latitude": "68.34365000",
                        "longitude": "16.83317000"
                    },
                    {
                        "id": 79067,
                        "name": "Beiarn",
                        "latitude": "67.00725000",
                        "longitude": "14.57304000"
                    },
                    {
                        "id": 79074,
                        "name": "Bindal",
                        "latitude": "65.08780000",
                        "longitude": "12.37747000"
                    },
                    {
                        "id": 79076,
                        "name": "Bjerkvik",
                        "latitude": "68.54917000",
                        "longitude": "17.55709000"
                    },
                    {
                        "id": 79081,
                        "name": "Bodø",
                        "latitude": "67.28325000",
                        "longitude": "14.38319000"
                    },
                    {
                        "id": 79082,
                        "name": "Bogen",
                        "latitude": "68.52647000",
                        "longitude": "16.99280000"
                    },
                    {
                        "id": 79096,
                        "name": "Bø",
                        "latitude": "68.68823000",
                        "longitude": "14.47899000"
                    },
                    {
                        "id": 79091,
                        "name": "Brønnøy",
                        "latitude": "65.46786000",
                        "longitude": "12.20626000"
                    },
                    {
                        "id": 79092,
                        "name": "Brønnøysund",
                        "latitude": "65.47487000",
                        "longitude": "12.21285000"
                    },
                    {
                        "id": 79108,
                        "name": "Dønna",
                        "latitude": "66.10606000",
                        "longitude": "12.48189000"
                    },
                    {
                        "id": 79128,
                        "name": "Evenes",
                        "latitude": "68.52334000",
                        "longitude": "17.00888000"
                    },
                    {
                        "id": 79130,
                        "name": "Evjen",
                        "latitude": "68.26667000",
                        "longitude": "13.73333000"
                    },
                    {
                        "id": 79135,
                        "name": "Fauske",
                        "latitude": "67.25963000",
                        "longitude": "15.39410000"
                    },
                    {
                        "id": 79146,
                        "name": "Flakstad",
                        "latitude": "68.09292000",
                        "longitude": "13.23310000"
                    },
                    {
                        "id": 79175,
                        "name": "Gildeskål",
                        "latitude": "67.03394000",
                        "longitude": "14.02582000"
                    },
                    {
                        "id": 79181,
                        "name": "Gladstad",
                        "latitude": "65.67683000",
                        "longitude": "11.96218000"
                    },
                    {
                        "id": 79182,
                        "name": "Glomfjord",
                        "latitude": "66.81663000",
                        "longitude": "13.94404000"
                    },
                    {
                        "id": 79186,
                        "name": "Grane",
                        "latitude": "65.53865000",
                        "longitude": "13.38499000"
                    },
                    {
                        "id": 79189,
                        "name": "Gravdal",
                        "latitude": "68.11832000",
                        "longitude": "13.55339000"
                    },
                    {
                        "id": 79197,
                        "name": "Hadsel",
                        "latitude": "68.56328000",
                        "longitude": "14.90835000"
                    },
                    {
                        "id": 79202,
                        "name": "Hamarøy",
                        "latitude": "68.08381000",
                        "longitude": "15.61671000"
                    },
                    {
                        "id": 79210,
                        "name": "Hattfjelldal",
                        "latitude": "65.59765000",
                        "longitude": "13.98948000"
                    },
                    {
                        "id": 79213,
                        "name": "Hauknes",
                        "latitude": "66.28333000",
                        "longitude": "14.06667000"
                    },
                    {
                        "id": 79215,
                        "name": "Hemnes",
                        "latitude": "66.07712000",
                        "longitude": "13.81350000"
                    },
                    {
                        "id": 79216,
                        "name": "Hemnesberget",
                        "latitude": "66.22489000",
                        "longitude": "13.61643000"
                    },
                    {
                        "id": 79220,
                        "name": "Herøy",
                        "latitude": "65.98427000",
                        "longitude": "12.28916000"
                    },
                    {
                        "id": 79255,
                        "name": "Inndyr",
                        "latitude": "67.03353000",
                        "longitude": "14.02663000"
                    },
                    {
                        "id": 79263,
                        "name": "Kabelvåg",
                        "latitude": "68.21066000",
                        "longitude": "14.47554000"
                    },
                    {
                        "id": 79273,
                        "name": "Kjøpsvik",
                        "latitude": "68.09696000",
                        "longitude": "16.37416000"
                    },
                    {
                        "id": 79285,
                        "name": "Korgen",
                        "latitude": "66.07662000",
                        "longitude": "13.82160000"
                    },
                    {
                        "id": 79309,
                        "name": "Leirfjord",
                        "latitude": "66.06348000",
                        "longitude": "12.93667000"
                    },
                    {
                        "id": 79313,
                        "name": "Leknes",
                        "latitude": "68.14746000",
                        "longitude": "13.61151000"
                    },
                    {
                        "id": 79314,
                        "name": "Leland",
                        "latitude": "66.06406000",
                        "longitude": "12.94325000"
                    },
                    {
                        "id": 79343,
                        "name": "Løding",
                        "latitude": "67.30055000",
                        "longitude": "14.73852000"
                    },
                    {
                        "id": 79344,
                        "name": "Lødingen",
                        "latitude": "68.40998000",
                        "longitude": "15.99012000"
                    },
                    {
                        "id": 79345,
                        "name": "Løpsmarka",
                        "latitude": "67.31343000",
                        "longitude": "14.44934000"
                    },
                    {
                        "id": 79334,
                        "name": "Lurøy",
                        "latitude": "66.41887000",
                        "longitude": "12.84248000"
                    },
                    {
                        "id": 79358,
                        "name": "Melbu",
                        "latitude": "68.50246000",
                        "longitude": "14.79962000"
                    },
                    {
                        "id": 79362,
                        "name": "Meløy",
                        "latitude": "66.87204000",
                        "longitude": "13.70763000"
                    },
                    {
                        "id": 79366,
                        "name": "Mo i Rana",
                        "latitude": "66.31278000",
                        "longitude": "14.14278000"
                    },
                    {
                        "id": 79373,
                        "name": "Mosjøen",
                        "latitude": "65.83599000",
                        "longitude": "13.19076000"
                    },
                    {
                        "id": 79374,
                        "name": "Moskenes",
                        "latitude": "67.93467000",
                        "longitude": "13.09109000"
                    },
                    {
                        "id": 79377,
                        "name": "Myre",
                        "latitude": "68.91400000",
                        "longitude": "15.07843000"
                    },
                    {
                        "id": 79386,
                        "name": "Narvik",
                        "latitude": "68.43896000",
                        "longitude": "17.42775000"
                    },
                    {
                        "id": 79393,
                        "name": "Nesna",
                        "latitude": "66.19796000",
                        "longitude": "13.02229000"
                    },
                    {
                        "id": 79692,
                        "name": "Øksnes",
                        "latitude": "68.91463000",
                        "longitude": "15.08703000"
                    },
                    {
                        "id": 79696,
                        "name": "Ørnes",
                        "latitude": "66.86878000",
                        "longitude": "13.70579000"
                    },
                    {
                        "id": 79436,
                        "name": "Rana",
                        "latitude": "66.31122000",
                        "longitude": "14.13996000"
                    },
                    {
                        "id": 79442,
                        "name": "Reine",
                        "latitude": "67.93249000",
                        "longitude": "13.08955000"
                    },
                    {
                        "id": 79455,
                        "name": "Rognan",
                        "latitude": "67.10021000",
                        "longitude": "15.39086000"
                    },
                    {
                        "id": 79466,
                        "name": "Rødøy",
                        "latitude": "66.71195000",
                        "longitude": "13.28530000"
                    },
                    {
                        "id": 79470,
                        "name": "Røst",
                        "latitude": "67.51727000",
                        "longitude": "12.11564000"
                    },
                    {
                        "id": 79475,
                        "name": "Saltdal",
                        "latitude": "67.10144000",
                        "longitude": "15.39458000"
                    },
                    {
                        "id": 79484,
                        "name": "Sandnessjøen",
                        "latitude": "66.02166000",
                        "longitude": "12.63158000"
                    },
                    {
                        "id": 79534,
                        "name": "Sortland",
                        "latitude": "68.69618000",
                        "longitude": "15.41174000"
                    },
                    {
                        "id": 79577,
                        "name": "Sømna",
                        "latitude": "65.31379000",
                        "longitude": "12.16729000"
                    },
                    {
                        "id": 79583,
                        "name": "Sørfold",
                        "latitude": "67.34803000",
                        "longitude": "15.59445000"
                    },
                    {
                        "id": 79584,
                        "name": "Sørland",
                        "latitude": "67.66564000",
                        "longitude": "12.69784000"
                    },
                    {
                        "id": 79540,
                        "name": "Steigen",
                        "latitude": "67.77625000",
                        "longitude": "15.01621000"
                    },
                    {
                        "id": 79546,
                        "name": "Stokmarknes",
                        "latitude": "68.56462000",
                        "longitude": "14.91075000"
                    },
                    {
                        "id": 79557,
                        "name": "Straume",
                        "latitude": "68.68880000",
                        "longitude": "14.47205000"
                    },
                    {
                        "id": 79560,
                        "name": "Straumen",
                        "latitude": "67.34769000",
                        "longitude": "15.60493000"
                    },
                    {
                        "id": 79571,
                        "name": "Svolvær",
                        "latitude": "68.23417000",
                        "longitude": "14.56834000"
                    },
                    {
                        "id": 79591,
                        "name": "Terråk",
                        "latitude": "65.08700000",
                        "longitude": "12.37148000"
                    },
                    {
                        "id": 79595,
                        "name": "Tjeldsund",
                        "latitude": "68.55557000",
                        "longitude": "16.36172000"
                    },
                    {
                        "id": 79611,
                        "name": "Træna",
                        "latitude": "66.50159000",
                        "longitude": "12.09645000"
                    },
                    {
                        "id": 79607,
                        "name": "Trofors",
                        "latitude": "65.53335000",
                        "longitude": "13.40631000"
                    },
                    {
                        "id": 79616,
                        "name": "Tysfjord",
                        "latitude": "68.09772000",
                        "longitude": "16.37591000"
                    },
                    {
                        "id": 79663,
                        "name": "Vågan",
                        "latitude": "68.23220000",
                        "longitude": "14.56226000"
                    },
                    {
                        "id": 79669,
                        "name": "Værøy",
                        "latitude": "67.66374000",
                        "longitude": "12.69337000"
                    },
                    {
                        "id": 79637,
                        "name": "Vefsn",
                        "latitude": "65.84109000",
                        "longitude": "13.20024000"
                    },
                    {
                        "id": 79638,
                        "name": "Vega",
                        "latitude": "65.67539000",
                        "longitude": "11.96456000"
                    },
                    {
                        "id": 79647,
                        "name": "Vestvågøy",
                        "latitude": "68.14830000",
                        "longitude": "13.61119000"
                    },
                    {
                        "id": 79648,
                        "name": "Vevelstad",
                        "latitude": "65.70002000",
                        "longitude": "12.43921000"
                    },
                    {
                        "id": 79651,
                        "name": "Vik",
                        "latitude": "65.31254000",
                        "longitude": "12.16734000"
                    }
                ]
            },
            {
                "id": 1007,
                "name": "Oslo",
                "iso2": "03",
                "latitude": "59.91386880",
                "longitude": "10.75224540",
                "type": "county",
                "cities": [
                    {
                        "id": 79425,
                        "name": "Oslo",
                        "latitude": "59.91273000",
                        "longitude": "10.74609000"
                    },
                    {
                        "id": 79502,
                        "name": "Sjølyststranda",
                        "latitude": "59.92105000",
                        "longitude": "10.68017000"
                    }
                ]
            },
            {
                "id": 5450,
                "name": "Østfold",
                "iso2": "31",
                "latitude": "59.32190880",
                "longitude": "10.52257370",
                "type": "county",
                "cities": [
                    {
                        "id": 79043,
                        "name": "Aremark",
                        "latitude": "59.22198000",
                        "longitude": "11.69582000"
                    },
                    {
                        "id": 79046,
                        "name": "Askim",
                        "latitude": "59.58464000",
                        "longitude": "11.16084000"
                    },
                    {
                        "id": 79113,
                        "name": "Eidsberg",
                        "latitude": "59.55148000",
                        "longitude": "11.33587000"
                    },
                    {
                        "id": 79158,
                        "name": "Fossby",
                        "latitude": "59.22218000",
                        "longitude": "11.69928000"
                    },
                    {
                        "id": 79159,
                        "name": "Fredrikstad",
                        "latitude": "59.21759000",
                        "longitude": "10.93787000"
                    },
                    {
                        "id": 79199,
                        "name": "Halden",
                        "latitude": "59.12258000",
                        "longitude": "11.38709000"
                    },
                    {
                        "id": 79226,
                        "name": "Hobøl",
                        "latitude": "59.62252000",
                        "longitude": "10.94979000"
                    },
                    {
                        "id": 79241,
                        "name": "Hvaler",
                        "latitude": "59.02809000",
                        "longitude": "11.03110000"
                    },
                    {
                        "id": 79265,
                        "name": "Karlshus",
                        "latitude": "59.35195000",
                        "longitude": "10.87226000"
                    },
                    {
                        "id": 79278,
                        "name": "Knappstad",
                        "latitude": "59.62424000",
                        "longitude": "11.03274000"
                    },
                    {
                        "id": 79302,
                        "name": "Larkollen",
                        "latitude": "59.33196000",
                        "longitude": "10.66687000"
                    },
                    {
                        "id": 79317,
                        "name": "Lervik",
                        "latitude": "59.27119000",
                        "longitude": "10.74610000"
                    },
                    {
                        "id": 79352,
                        "name": "Marker",
                        "latitude": "59.47952000",
                        "longitude": "11.65917000"
                    },
                    {
                        "id": 79375,
                        "name": "Moss",
                        "latitude": "59.43436000",
                        "longitude": "10.65968000"
                    },
                    {
                        "id": 79378,
                        "name": "Mysen",
                        "latitude": "59.55354000",
                        "longitude": "11.32578000"
                    },
                    {
                        "id": 79694,
                        "name": "Ørje",
                        "latitude": "59.48023000",
                        "longitude": "11.66016000"
                    },
                    {
                        "id": 79463,
                        "name": "Råde",
                        "latitude": "59.35162000",
                        "longitude": "10.87135000"
                    },
                    {
                        "id": 79435,
                        "name": "Rakkestad",
                        "latitude": "59.42822000",
                        "longitude": "11.34350000"
                    },
                    {
                        "id": 79467,
                        "name": "Rømskog",
                        "latitude": "59.74968000",
                        "longitude": "11.81122000"
                    },
                    {
                        "id": 79460,
                        "name": "Rygge",
                        "latitude": "59.40629000",
                        "longitude": "10.69298000"
                    },
                    {
                        "id": 79461,
                        "name": "Ryggebyen",
                        "latitude": "59.37500000",
                        "longitude": "10.75000000"
                    },
                    {
                        "id": 79487,
                        "name": "Sarpsborg",
                        "latitude": "59.28148000",
                        "longitude": "11.11167000"
                    },
                    {
                        "id": 79509,
                        "name": "Skiptvet",
                        "latitude": "59.47751000",
                        "longitude": "11.16171000"
                    },
                    {
                        "id": 79513,
                        "name": "Skjærhalden",
                        "latitude": "59.02526000",
                        "longitude": "11.03685000"
                    },
                    {
                        "id": 79510,
                        "name": "Skjeberg",
                        "latitude": "59.21148000",
                        "longitude": "11.19025000"
                    },
                    {
                        "id": 79536,
                        "name": "Spydeberg",
                        "latitude": "59.62028000",
                        "longitude": "11.08069000"
                    },
                    {
                        "id": 79612,
                        "name": "Trøgstad",
                        "latitude": "59.64016000",
                        "longitude": "11.31890000"
                    },
                    {
                        "id": 79668,
                        "name": "Våler",
                        "latitude": "59.48870000",
                        "longitude": "10.86551000"
                    }
                ]
            },
            {
                "id": 1021,
                "name": "Rogaland",
                "iso2": "11",
                "latitude": "59.14895440",
                "longitude": "6.01434320",
                "type": "county",
                "cities": [
                    {
                        "id": 79676,
                        "name": "Åkrehamn",
                        "latitude": "59.26053000",
                        "longitude": "5.18689000"
                    },
                    {
                        "id": 79075,
                        "name": "Bjerkreim",
                        "latitude": "58.63050000",
                        "longitude": "6.08130000"
                    },
                    {
                        "id": 79083,
                        "name": "Bokn",
                        "latitude": "59.23062000",
                        "longitude": "5.43524000"
                    },
                    {
                        "id": 79090,
                        "name": "Bryne",
                        "latitude": "58.73536000",
                        "longitude": "5.64766000"
                    },
                    {
                        "id": 79109,
                        "name": "Egersund",
                        "latitude": "58.45133000",
                        "longitude": "5.99970000"
                    },
                    {
                        "id": 79117,
                        "name": "Eigersund",
                        "latitude": "58.45236000",
                        "longitude": "6.00314000"
                    },
                    {
                        "id": 79118,
                        "name": "Eike",
                        "latitude": "59.39833000",
                        "longitude": "5.36389000"
                    },
                    {
                        "id": 79141,
                        "name": "Finnøy",
                        "latitude": "59.17117000",
                        "longitude": "5.87398000"
                    },
                    {
                        "id": 79155,
                        "name": "Forsand",
                        "latitude": "58.89929000",
                        "longitude": "6.09642000"
                    },
                    {
                        "id": 79179,
                        "name": "Gjesdal",
                        "latitude": "58.76478000",
                        "longitude": "5.85500000"
                    },
                    {
                        "id": 79245,
                        "name": "Hå",
                        "latitude": "58.61610000",
                        "longitude": "5.64497000"
                    },
                    {
                        "id": 79211,
                        "name": "Hauge i Dalane",
                        "latitude": "58.34361000",
                        "longitude": "6.28121000"
                    },
                    {
                        "id": 79212,
                        "name": "Haugesund",
                        "latitude": "59.41015000",
                        "longitude": "5.27551000"
                    },
                    {
                        "id": 79224,
                        "name": "Hjelmeland",
                        "latitude": "59.23668000",
                        "longitude": "6.17912000"
                    },
                    {
                        "id": 79232,
                        "name": "Hommersåk",
                        "latitude": "58.92556000",
                        "longitude": "5.85104000"
                    },
                    {
                        "id": 79262,
                        "name": "Jørpeland",
                        "latitude": "59.02251000",
                        "longitude": "6.04078000"
                    },
                    {
                        "id": 79259,
                        "name": "Judaberg",
                        "latitude": "59.17204000",
                        "longitude": "5.87617000"
                    },
                    {
                        "id": 79267,
                        "name": "Karmøy",
                        "latitude": "59.28079000",
                        "longitude": "5.30529000"
                    },
                    {
                        "id": 79274,
                        "name": "Klepp",
                        "latitude": "58.77655000",
                        "longitude": "5.63009000"
                    },
                    {
                        "id": 79283,
                        "name": "Kopervik",
                        "latitude": "59.28354000",
                        "longitude": "5.30669000"
                    },
                    {
                        "id": 79295,
                        "name": "Kvitsøy",
                        "latitude": "59.06471000",
                        "longitude": "5.40537000"
                    },
                    {
                        "id": 79330,
                        "name": "Lund",
                        "latitude": "58.45715000",
                        "longitude": "6.54871000"
                    },
                    {
                        "id": 79336,
                        "name": "Lyefjell",
                        "latitude": "58.73539000",
                        "longitude": "5.73615000"
                    },
                    {
                        "id": 79371,
                        "name": "Moi",
                        "latitude": "58.45674000",
                        "longitude": "6.55184000"
                    },
                    {
                        "id": 79415,
                        "name": "Nærbø",
                        "latitude": "58.66546000",
                        "longitude": "5.63788000"
                    },
                    {
                        "id": 79693,
                        "name": "Ølen",
                        "latitude": "59.60437000",
                        "longitude": "5.80799000"
                    },
                    {
                        "id": 79437,
                        "name": "Randaberg",
                        "latitude": "58.99870000",
                        "longitude": "5.62055000"
                    },
                    {
                        "id": 79447,
                        "name": "Rennesøy",
                        "latitude": "59.09899000",
                        "longitude": "5.69966000"
                    },
                    {
                        "id": 79483,
                        "name": "Sandnes",
                        "latitude": "58.84760000",
                        "longitude": "5.72855000"
                    },
                    {
                        "id": 79488,
                        "name": "Sauda",
                        "latitude": "59.65067000",
                        "longitude": "6.35312000"
                    },
                    {
                        "id": 79575,
                        "name": "Sæveland",
                        "latitude": "59.26667000",
                        "longitude": "5.20000000"
                    },
                    {
                        "id": 79521,
                        "name": "Skudeneshavn",
                        "latitude": "59.14856000",
                        "longitude": "5.25687000"
                    },
                    {
                        "id": 79530,
                        "name": "Sokndal",
                        "latitude": "58.34256000",
                        "longitude": "6.29425000"
                    },
                    {
                        "id": 79531,
                        "name": "Sola",
                        "latitude": "58.88806000",
                        "longitude": "5.64728000"
                    },
                    {
                        "id": 79538,
                        "name": "Stavanger",
                        "latitude": "58.96941000",
                        "longitude": "5.72856000"
                    },
                    {
                        "id": 79555,
                        "name": "Strand",
                        "latitude": "59.02353000",
                        "longitude": "6.04343000"
                    },
                    {
                        "id": 79563,
                        "name": "Suldal",
                        "latitude": "59.48571000",
                        "longitude": "6.25222000"
                    },
                    {
                        "id": 79589,
                        "name": "Tananger",
                        "latitude": "58.93618000",
                        "longitude": "5.57410000"
                    },
                    {
                        "id": 79590,
                        "name": "Tau",
                        "latitude": "59.06481000",
                        "longitude": "5.92250000"
                    },
                    {
                        "id": 79592,
                        "name": "Time",
                        "latitude": "58.73636000",
                        "longitude": "5.65297000"
                    },
                    {
                        "id": 79618,
                        "name": "Tysvær",
                        "latitude": "59.42159000",
                        "longitude": "5.44781000"
                    },
                    {
                        "id": 79627,
                        "name": "Utsira",
                        "latitude": "59.30565000",
                        "longitude": "4.88621000"
                    },
                    {
                        "id": 79634,
                        "name": "Varhaug",
                        "latitude": "58.61810000",
                        "longitude": "5.65702000"
                    },
                    {
                        "id": 79636,
                        "name": "Vedavågen",
                        "latitude": "59.29483000",
                        "longitude": "5.21874000"
                    },
                    {
                        "id": 79650,
                        "name": "Vigrestad",
                        "latitude": "58.57103000",
                        "longitude": "5.68182000"
                    },
                    {
                        "id": 79654,
                        "name": "Vikeså",
                        "latitude": "58.63759000",
                        "longitude": "6.09133000"
                    },
                    {
                        "id": 79655,
                        "name": "Vikevåg",
                        "latitude": "59.09754000",
                        "longitude": "5.69790000"
                    },
                    {
                        "id": 79657,
                        "name": "Vindafjord",
                        "latitude": "59.60543000",
                        "longitude": "5.80784000"
                    },
                    {
                        "id": 79661,
                        "name": "Vormedal",
                        "latitude": "59.35607000",
                        "longitude": "5.31962000"
                    }
                ]
            },
            {
                "id": 1013,
                "name": "Svalbard",
                "iso2": "21",
                "latitude": "77.87497250",
                "longitude": "20.97518210",
                "type": "arctic region",
                "cities": []
            },
            {
                "id": 1024,
                "name": "Telemark",
                "iso2": "40",
                "latitude": "59.40820670",
                "longitude": "7.17995740",
                "type": "county",
                "cities": [
                    {
                        "id": 79063,
                        "name": "Bamble",
                        "latitude": "59.00146000",
                        "longitude": "9.74573000"
                    },
                    {
                        "id": 79095,
                        "name": "Bø",
                        "latitude": "59.41281000",
                        "longitude": "9.06618000"
                    },
                    {
                        "id": 79100,
                        "name": "Dalen",
                        "latitude": "59.44499000",
                        "longitude": "8.00492000"
                    },
                    {
                        "id": 79105,
                        "name": "Drangedal",
                        "latitude": "59.09655000",
                        "longitude": "9.05960000"
                    },
                    {
                        "id": 79167,
                        "name": "Fyresdal",
                        "latitude": "59.18651000",
                        "longitude": "8.08953000"
                    },
                    {
                        "id": 79196,
                        "name": "Gvarv",
                        "latitude": "59.38767000",
                        "longitude": "9.17240000"
                    },
                    {
                        "id": 79219,
                        "name": "Herre",
                        "latitude": "59.10351000",
                        "longitude": "9.56195000"
                    },
                    {
                        "id": 79223,
                        "name": "Hjartdal",
                        "latitude": "59.61276000",
                        "longitude": "8.94942000"
                    },
                    {
                        "id": 79286,
                        "name": "Kragerø",
                        "latitude": "58.86792000",
                        "longitude": "9.41099000"
                    },
                    {
                        "id": 79294,
                        "name": "Kviteseid",
                        "latitude": "59.40194000",
                        "longitude": "8.49459000"
                    },
                    {
                        "id": 79332,
                        "name": "Lunde",
                        "latitude": "59.29832000",
                        "longitude": "9.10268000"
                    },
                    {
                        "id": 79398,
                        "name": "Nissedal",
                        "latitude": "59.01958000",
                        "longitude": "8.52127000"
                    },
                    {
                        "id": 79401,
                        "name": "Nome",
                        "latitude": "59.28136000",
                        "longitude": "9.25678000"
                    },
                    {
                        "id": 79414,
                        "name": "Notodden",
                        "latitude": "59.55992000",
                        "longitude": "9.26046000"
                    },
                    {
                        "id": 79430,
                        "name": "Porsgrunn",
                        "latitude": "59.14190000",
                        "longitude": "9.65680000"
                    },
                    {
                        "id": 79431,
                        "name": "Prestestranda",
                        "latitude": "59.09773000",
                        "longitude": "9.05866000"
                    },
                    {
                        "id": 79441,
                        "name": "Re",
                        "latitude": "59.35056000",
                        "longitude": "10.24763000"
                    },
                    {
                        "id": 79453,
                        "name": "Rjukan",
                        "latitude": "59.87891000",
                        "longitude": "8.59411000"
                    },
                    {
                        "id": 79480,
                        "name": "Sande",
                        "latitude": "59.59362000",
                        "longitude": "10.20757000"
                    },
                    {
                        "id": 79489,
                        "name": "Sauherad",
                        "latitude": "59.39642000",
                        "longitude": "9.24910000"
                    },
                    {
                        "id": 79493,
                        "name": "Seljord",
                        "latitude": "59.48274000",
                        "longitude": "8.62672000"
                    },
                    {
                        "id": 79498,
                        "name": "Siljan",
                        "latitude": "59.28251000",
                        "longitude": "9.73368000"
                    },
                    {
                        "id": 79508,
                        "name": "Skien",
                        "latitude": "59.20748000",
                        "longitude": "9.61052000"
                    },
                    {
                        "id": 79594,
                        "name": "Tinn",
                        "latitude": "59.83486000",
                        "longitude": "9.13528000"
                    },
                    {
                        "id": 79598,
                        "name": "Tokke",
                        "latitude": "59.44569000",
                        "longitude": "8.01388000"
                    },
                    {
                        "id": 79620,
                        "name": "Ulefoss",
                        "latitude": "59.28245000",
                        "longitude": "9.26548000"
                    },
                    {
                        "id": 79658,
                        "name": "Vinje",
                        "latitude": "59.56924000",
                        "longitude": "7.98896000"
                    }
                ]
            },
            {
                "id": 5451,
                "name": "Troms",
                "iso2": "55",
                "latitude": "69.42828210",
                "longitude": "13.96563080",
                "type": "county",
                "cities": [
                    {
                        "id": 79062,
                        "name": "Balsfjord",
                        "latitude": "69.24024000",
                        "longitude": "19.22653000"
                    },
                    {
                        "id": 79064,
                        "name": "Bardu",
                        "latitude": "68.86058000",
                        "longitude": "18.35052000"
                    },
                    {
                        "id": 79107,
                        "name": "Dyrøy",
                        "latitude": "69.09154000",
                        "longitude": "17.69094000"
                    },
                    {
                        "id": 79188,
                        "name": "Gratangen",
                        "latitude": "68.69273000",
                        "longitude": "17.53186000"
                    },
                    {
                        "id": 79208,
                        "name": "Harstad",
                        "latitude": "68.79896000",
                        "longitude": "16.52930000"
                    },
                    {
                        "id": 79250,
                        "name": "Ibestad",
                        "latitude": "68.77866000",
                        "longitude": "17.17661000"
                    },
                    {
                        "id": 79266,
                        "name": "Karlsøy",
                        "latitude": "69.96185000",
                        "longitude": "19.61811000"
                    },
                    {
                        "id": 79296,
                        "name": "Kvæfjord",
                        "latitude": "68.77201000",
                        "longitude": "16.17294000"
                    },
                    {
                        "id": 79297,
                        "name": "Kvænangen",
                        "latitude": "69.93890000",
                        "longitude": "22.04935000"
                    },
                    {
                        "id": 79306,
                        "name": "Lavangen",
                        "latitude": "68.74722000",
                        "longitude": "17.80558000"
                    },
                    {
                        "id": 79338,
                        "name": "Lyngen",
                        "latitude": "69.57621000",
                        "longitude": "20.21702000"
                    },
                    {
                        "id": 79379,
                        "name": "Målselv",
                        "latitude": "69.12389000",
                        "longitude": "18.61498000"
                    },
                    {
                        "id": 79409,
                        "name": "Nordreisa",
                        "latitude": "69.76825000",
                        "longitude": "21.02569000"
                    },
                    {
                        "id": 79474,
                        "name": "Salangen",
                        "latitude": "68.87669000",
                        "longitude": "17.83375000"
                    },
                    {
                        "id": 79511,
                        "name": "Skjervøy",
                        "latitude": "70.03379000",
                        "longitude": "20.97365000"
                    },
                    {
                        "id": 79585,
                        "name": "Sørreisa",
                        "latitude": "69.14697000",
                        "longitude": "18.15629000"
                    },
                    {
                        "id": 79551,
                        "name": "Storfjord",
                        "latitude": "69.26860000",
                        "longitude": "19.96089000"
                    },
                    {
                        "id": 79608,
                        "name": "Tromsø",
                        "latitude": "69.64961000",
                        "longitude": "18.95702000"
                    }
                ]
            },
            {
                "id": 1006,
                "name": "Trøndelag",
                "iso2": "50",
                "latitude": "63.54201250",
                "longitude": "10.93692670",
                "type": "county",
                "cities": [
                    {
                        "id": 79673,
                        "name": "Å i Åfjord",
                        "latitude": "63.96068000",
                        "longitude": "10.22468000"
                    },
                    {
                        "id": 79674,
                        "name": "Åfjord",
                        "latitude": "63.96196000",
                        "longitude": "10.22587000"
                    },
                    {
                        "id": 79037,
                        "name": "Agdenes",
                        "latitude": "63.50575000",
                        "longitude": "9.82623000"
                    },
                    {
                        "id": 79071,
                        "name": "Berkåk",
                        "latitude": "62.82496000",
                        "longitude": "10.01177000"
                    },
                    {
                        "id": 79077,
                        "name": "Bjugn",
                        "latitude": "63.76522000",
                        "longitude": "9.80940000"
                    },
                    {
                        "id": 79085,
                        "name": "Botngård",
                        "latitude": "63.76484000",
                        "longitude": "9.80863000"
                    },
                    {
                        "id": 79087,
                        "name": "Brekstad",
                        "latitude": "63.68697000",
                        "longitude": "9.66541000"
                    },
                    {
                        "id": 79139,
                        "name": "Fillan",
                        "latitude": "63.60638000",
                        "longitude": "8.96961000"
                    },
                    {
                        "id": 79147,
                        "name": "Flatanger",
                        "latitude": "64.41282000",
                        "longitude": "11.03285000"
                    },
                    {
                        "id": 79156,
                        "name": "Fosnes",
                        "latitude": "64.65910000",
                        "longitude": "11.26535000"
                    },
                    {
                        "id": 79163,
                        "name": "Frosta",
                        "latitude": "63.58910000",
                        "longitude": "10.74230000"
                    },
                    {
                        "id": 79165,
                        "name": "Frøya",
                        "latitude": "63.73005000",
                        "longitude": "8.82426000"
                    },
                    {
                        "id": 79190,
                        "name": "Grong",
                        "latitude": "64.46397000",
                        "longitude": "12.31114000"
                    },
                    {
                        "id": 79214,
                        "name": "Hemne",
                        "latitude": "63.29095000",
                        "longitude": "9.08893000"
                    },
                    {
                        "id": 79222,
                        "name": "Hitra",
                        "latitude": "63.54528000",
                        "longitude": "8.78029000"
                    },
                    {
                        "id": 79230,
                        "name": "Holtålen",
                        "latitude": "62.84318000",
                        "longitude": "11.29284000"
                    },
                    {
                        "id": 79231,
                        "name": "Hommelvik",
                        "latitude": "63.41083000",
                        "longitude": "10.79424000"
                    },
                    {
                        "id": 79249,
                        "name": "Høylandet",
                        "latitude": "64.62759000",
                        "longitude": "12.30041000"
                    },
                    {
                        "id": 79251,
                        "name": "Inderøy",
                        "latitude": "63.87826000",
                        "longitude": "11.28424000"
                    },
                    {
                        "id": 79253,
                        "name": "Indre Fosen",
                        "latitude": "63.58897000",
                        "longitude": "9.95847000"
                    },
                    {
                        "id": 79275,
                        "name": "Klæbu",
                        "latitude": "63.30060000",
                        "longitude": "10.48188000"
                    },
                    {
                        "id": 79280,
                        "name": "Kolvereid",
                        "latitude": "64.86549000",
                        "longitude": "11.60465000"
                    },
                    {
                        "id": 79298,
                        "name": "Kyrksæterøra",
                        "latitude": "63.29057000",
                        "longitude": "9.08909000"
                    },
                    {
                        "id": 79305,
                        "name": "Lauvsnes",
                        "latitude": "64.50061000",
                        "longitude": "10.89396000"
                    },
                    {
                        "id": 79312,
                        "name": "Leka",
                        "latitude": "65.09244000",
                        "longitude": "11.70513000"
                    },
                    {
                        "id": 79319,
                        "name": "Levanger",
                        "latitude": "63.74585000",
                        "longitude": "11.29991000"
                    },
                    {
                        "id": 79321,
                        "name": "Lierne",
                        "latitude": "64.46413000",
                        "longitude": "13.59249000"
                    },
                    {
                        "id": 79331,
                        "name": "Lundamo",
                        "latitude": "63.15216000",
                        "longitude": "10.28555000"
                    },
                    {
                        "id": 79348,
                        "name": "Malm",
                        "latitude": "64.07534000",
                        "longitude": "11.22398000"
                    },
                    {
                        "id": 79349,
                        "name": "Malvik",
                        "latitude": "63.41057000",
                        "longitude": "10.79382000"
                    },
                    {
                        "id": 79359,
                        "name": "Meldal",
                        "latitude": "63.04598000",
                        "longitude": "9.71088000"
                    },
                    {
                        "id": 79360,
                        "name": "Melhus",
                        "latitude": "63.28755000",
                        "longitude": "10.27686000"
                    },
                    {
                        "id": 79363,
                        "name": "Meråker",
                        "latitude": "63.41423000",
                        "longitude": "11.74558000"
                    },
                    {
                        "id": 79365,
                        "name": "Midtre Gauldal",
                        "latitude": "63.03902000",
                        "longitude": "10.28701000"
                    },
                    {
                        "id": 79382,
                        "name": "Namdalseid",
                        "latitude": "64.10843000",
                        "longitude": "10.91862000"
                    },
                    {
                        "id": 79383,
                        "name": "Namsos",
                        "latitude": "64.47842000",
                        "longitude": "11.54182000"
                    },
                    {
                        "id": 79384,
                        "name": "Namsskogan",
                        "latitude": "64.92597000",
                        "longitude": "13.15932000"
                    },
                    {
                        "id": 79416,
                        "name": "Nærøy",
                        "latitude": "64.86298000",
                        "longitude": "11.60505000"
                    },
                    {
                        "id": 79419,
                        "name": "Oppdal",
                        "latitude": "62.59495000",
                        "longitude": "9.68761000"
                    },
                    {
                        "id": 79421,
                        "name": "Orkdal",
                        "latitude": "63.29989000",
                        "longitude": "9.84365000"
                    },
                    {
                        "id": 79424,
                        "name": "Osen",
                        "latitude": "64.29875000",
                        "longitude": "10.51284000"
                    },
                    {
                        "id": 79428,
                        "name": "Overhalla",
                        "latitude": "64.49380000",
                        "longitude": "11.94753000"
                    },
                    {
                        "id": 79695,
                        "name": "Ørland",
                        "latitude": "63.68574000",
                        "longitude": "9.66633000"
                    },
                    {
                        "id": 79433,
                        "name": "Raarvihke - Røyrvik",
                        "latitude": "64.88380000",
                        "longitude": "13.56310000"
                    },
                    {
                        "id": 79438,
                        "name": "Ranemsletta",
                        "latitude": "64.49447000",
                        "longitude": "11.94912000"
                    },
                    {
                        "id": 79446,
                        "name": "Rennebu",
                        "latitude": "62.82864000",
                        "longitude": "10.00487000"
                    },
                    {
                        "id": 79449,
                        "name": "Rindal",
                        "latitude": "63.05511000",
                        "longitude": "9.21274000"
                    },
                    {
                        "id": 79454,
                        "name": "Roan",
                        "latitude": "64.17281000",
                        "longitude": "10.22511000"
                    },
                    {
                        "id": 79468,
                        "name": "Røros",
                        "latitude": "62.57562000",
                        "longitude": "11.38730000"
                    },
                    {
                        "id": 79469,
                        "name": "Rørvik",
                        "latitude": "64.86185000",
                        "longitude": "11.23969000"
                    },
                    {
                        "id": 79472,
                        "name": "Røyrvik",
                        "latitude": "64.88394000",
                        "longitude": "13.56256000"
                    },
                    {
                        "id": 79491,
                        "name": "Selbu",
                        "latitude": "63.21770000",
                        "longitude": "11.03938000"
                    },
                    {
                        "id": 79500,
                        "name": "Sistranda",
                        "latitude": "63.72523000",
                        "longitude": "8.83318000"
                    },
                    {
                        "id": 79505,
                        "name": "Skaun",
                        "latitude": "63.32386000",
                        "longitude": "10.06745000"
                    },
                    {
                        "id": 79516,
                        "name": "Skogn",
                        "latitude": "63.70374000",
                        "longitude": "11.19262000"
                    },
                    {
                        "id": 79527,
                        "name": "Snåase",
                        "latitude": "64.24570000",
                        "longitude": "12.37779000"
                    },
                    {
                        "id": 79528,
                        "name": "Snåase - Snåsa",
                        "latitude": "64.24606000",
                        "longitude": "12.38294000"
                    },
                    {
                        "id": 79526,
                        "name": "Snillfjord",
                        "latitude": "63.39973000",
                        "longitude": "9.50194000"
                    },
                    {
                        "id": 79541,
                        "name": "Steinkjer",
                        "latitude": "64.19303000",
                        "longitude": "11.38505000"
                    },
                    {
                        "id": 79543,
                        "name": "Stjørdal",
                        "latitude": "63.56699000",
                        "longitude": "11.02730000"
                    },
                    {
                        "id": 79544,
                        "name": "Stjørdalshalsen",
                        "latitude": "63.46810000",
                        "longitude": "10.92618000"
                    },
                    {
                        "id": 79559,
                        "name": "Straumen",
                        "latitude": "63.87163000",
                        "longitude": "11.29617000"
                    },
                    {
                        "id": 79609,
                        "name": "Trondheim",
                        "latitude": "63.42811000",
                        "longitude": "10.39687000"
                    },
                    {
                        "id": 79614,
                        "name": "Tydal",
                        "latitude": "63.04477000",
                        "longitude": "11.65038000"
                    },
                    {
                        "id": 79640,
                        "name": "Verdal",
                        "latitude": "63.90023000",
                        "longitude": "11.72724000"
                    },
                    {
                        "id": 79641,
                        "name": "Verran",
                        "latitude": "64.07100000",
                        "longitude": "11.21795000"
                    },
                    {
                        "id": 79656,
                        "name": "Vikna",
                        "latitude": "64.86362000",
                        "longitude": "11.24198000"
                    }
                ]
            },
            {
                "id": 5452,
                "name": "Vestfold",
                "iso2": "39",
                "latitude": "59.22777900",
                "longitude": "9.55451380",
                "type": "county",
                "cities": [
                    {
                        "id": 79686,
                        "name": "Årøysund",
                        "latitude": "59.18321000",
                        "longitude": "10.45743000"
                    },
                    {
                        "id": 79689,
                        "name": "Åsgårdstrand",
                        "latitude": "59.34938000",
                        "longitude": "10.46948000"
                    },
                    {
                        "id": 79065,
                        "name": "Barkåker",
                        "latitude": "59.31859000",
                        "longitude": "10.38963000"
                    },
                    {
                        "id": 79070,
                        "name": "Berger",
                        "latitude": "59.54994000",
                        "longitude": "10.38641000"
                    },
                    {
                        "id": 79168,
                        "name": "Færder",
                        "latitude": "59.22791000",
                        "longitude": "10.41530000"
                    },
                    {
                        "id": 79195,
                        "name": "Gullhaug",
                        "latitude": "59.50130000",
                        "longitude": "10.25224000"
                    },
                    {
                        "id": 79229,
                        "name": "Holmestrand",
                        "latitude": "59.48976000",
                        "longitude": "10.31515000"
                    },
                    {
                        "id": 79236,
                        "name": "Horten",
                        "latitude": "59.41547000",
                        "longitude": "10.48527000"
                    },
                    {
                        "id": 79304,
                        "name": "Larvik",
                        "latitude": "59.05234000",
                        "longitude": "10.02701000"
                    },
                    {
                        "id": 79361,
                        "name": "Melsomvik",
                        "latitude": "59.22394000",
                        "longitude": "10.33616000"
                    },
                    {
                        "id": 79482,
                        "name": "Sandefjord",
                        "latitude": "59.12881000",
                        "longitude": "10.21971000"
                    },
                    {
                        "id": 79494,
                        "name": "Selvik",
                        "latitude": "59.56645000",
                        "longitude": "10.26004000"
                    },
                    {
                        "id": 79495,
                        "name": "Sem",
                        "latitude": "59.28230000",
                        "longitude": "10.33004000"
                    },
                    {
                        "id": 79518,
                        "name": "Skoppum",
                        "latitude": "59.38613000",
                        "longitude": "10.41077000"
                    },
                    {
                        "id": 79539,
                        "name": "Stavern",
                        "latitude": "59.00000000",
                        "longitude": "10.03333000"
                    },
                    {
                        "id": 79545,
                        "name": "Stokke",
                        "latitude": "59.22255000",
                        "longitude": "10.30055000"
                    },
                    {
                        "id": 79570,
                        "name": "Svelvik",
                        "latitude": "59.60677000",
                        "longitude": "10.40225000"
                    },
                    {
                        "id": 79596,
                        "name": "Tjøme",
                        "latitude": "59.11090000",
                        "longitude": "10.39330000"
                    },
                    {
                        "id": 79619,
                        "name": "Tønsberg",
                        "latitude": "59.26754000",
                        "longitude": "10.40762000"
                    }
                ]
            },
            {
                "id": 1018,
                "name": "Vestland",
                "iso2": "46",
                "latitude": "60.90694420",
                "longitude": "3.96270810",
                "type": "county",
                "cities": [
                    {
                        "id": 79675,
                        "name": "Ågotnes",
                        "latitude": "60.40306000",
                        "longitude": "5.01927000"
                    },
                    {
                        "id": 79682,
                        "name": "Årdal",
                        "latitude": "61.23639000",
                        "longitude": "7.70204000"
                    },
                    {
                        "id": 79683,
                        "name": "Årdalstangen",
                        "latitude": "61.23581000",
                        "longitude": "7.70370000"
                    },
                    {
                        "id": 79048,
                        "name": "Askøy",
                        "latitude": "60.40916000",
                        "longitude": "5.22599000"
                    },
                    {
                        "id": 79047,
                        "name": "Askvoll",
                        "latitude": "61.34850000",
                        "longitude": "5.05318000"
                    },
                    {
                        "id": 79053,
                        "name": "Aurland",
                        "latitude": "60.90556000",
                        "longitude": "7.18734000"
                    },
                    {
                        "id": 79056,
                        "name": "Austevoll",
                        "latitude": "60.09578000",
                        "longitude": "5.22722000"
                    },
                    {
                        "id": 79057,
                        "name": "Austrheim",
                        "latitude": "60.77742000",
                        "longitude": "4.93227000"
                    },
                    {
                        "id": 79060,
                        "name": "Balestrand",
                        "latitude": "61.20809000",
                        "longitude": "6.53551000"
                    },
                    {
                        "id": 79069,
                        "name": "Bergen",
                        "latitude": "60.39200000",
                        "longitude": "5.32800000"
                    },
                    {
                        "id": 79097,
                        "name": "Bømlo",
                        "latitude": "59.79384000",
                        "longitude": "5.17624000"
                    },
                    {
                        "id": 79088,
                        "name": "Bremanger",
                        "latitude": "61.76862000",
                        "longitude": "5.28907000"
                    },
                    {
                        "id": 79098,
                        "name": "Dale",
                        "latitude": "60.58639000",
                        "longitude": "5.81888000"
                    },
                    {
                        "id": 79110,
                        "name": "Eid",
                        "latitude": "61.90684000",
                        "longitude": "5.99321000"
                    },
                    {
                        "id": 79112,
                        "name": "Eidfjord",
                        "latitude": "60.46741000",
                        "longitude": "7.06971000"
                    },
                    {
                        "id": 79119,
                        "name": "Eikelandsosen",
                        "latitude": "60.24175000",
                        "longitude": "5.74433000"
                    },
                    {
                        "id": 79120,
                        "name": "Eivindvik",
                        "latitude": "60.98133000",
                        "longitude": "5.07497000"
                    },
                    {
                        "id": 79125,
                        "name": "Espeland",
                        "latitude": "60.38249000",
                        "longitude": "5.46570000"
                    },
                    {
                        "id": 79126,
                        "name": "Etne",
                        "latitude": "59.66472000",
                        "longitude": "5.93438000"
                    },
                    {
                        "id": 79133,
                        "name": "Farnes",
                        "latitude": "61.30850000",
                        "longitude": "7.79694000"
                    },
                    {
                        "id": 79136,
                        "name": "Fedje",
                        "latitude": "60.77873000",
                        "longitude": "4.71965000"
                    },
                    {
                        "id": 79142,
                        "name": "Fitjar",
                        "latitude": "59.91742000",
                        "longitude": "5.31637000"
                    },
                    {
                        "id": 79143,
                        "name": "Fjaler",
                        "latitude": "61.36383000",
                        "longitude": "5.39808000"
                    },
                    {
                        "id": 79144,
                        "name": "Fjell",
                        "latitude": "60.36267000",
                        "longitude": "5.12194000"
                    },
                    {
                        "id": 79151,
                        "name": "Flora",
                        "latitude": "61.59994000",
                        "longitude": "5.03144000"
                    },
                    {
                        "id": 79152,
                        "name": "Florø",
                        "latitude": "61.59957000",
                        "longitude": "5.03280000"
                    },
                    {
                        "id": 79169,
                        "name": "Førde",
                        "latitude": "61.45045000",
                        "longitude": "5.85397000"
                    },
                    {
                        "id": 79160,
                        "name": "Frekhaug",
                        "latitude": "60.51321000",
                        "longitude": "5.24252000"
                    },
                    {
                        "id": 79166,
                        "name": "Fusa",
                        "latitude": "60.24072000",
                        "longitude": "5.74458000"
                    },
                    {
                        "id": 79171,
                        "name": "Gaular",
                        "latitude": "61.32564000",
                        "longitude": "5.79523000"
                    },
                    {
                        "id": 79172,
                        "name": "Gaupne",
                        "latitude": "61.40472000",
                        "longitude": "7.29458000"
                    },
                    {
                        "id": 79183,
                        "name": "Gloppen",
                        "latitude": "61.77728000",
                        "longitude": "6.21561000"
                    },
                    {
                        "id": 79187,
                        "name": "Granvin",
                        "latitude": "60.52629000",
                        "longitude": "6.72178000"
                    },
                    {
                        "id": 79194,
                        "name": "Gulen",
                        "latitude": "60.98192000",
                        "longitude": "5.07408000"
                    },
                    {
                        "id": 79198,
                        "name": "Hagavik",
                        "latitude": "60.18076000",
                        "longitude": "5.40146000"
                    },
                    {
                        "id": 79206,
                        "name": "Hardbakke",
                        "latitude": "61.07562000",
                        "longitude": "4.84111000"
                    },
                    {
                        "id": 79218,
                        "name": "Hermansverk",
                        "latitude": "61.18461000",
                        "longitude": "6.85016000"
                    },
                    {
                        "id": 79235,
                        "name": "Hornindal",
                        "latitude": "61.96925000",
                        "longitude": "6.52249000"
                    },
                    {
                        "id": 79248,
                        "name": "Høyanger",
                        "latitude": "61.21880000",
                        "longitude": "6.07308000"
                    },
                    {
                        "id": 79243,
                        "name": "Hylkje",
                        "latitude": "60.51028000",
                        "longitude": "5.35444000"
                    },
                    {
                        "id": 79244,
                        "name": "Hyllestad",
                        "latitude": "61.17036000",
                        "longitude": "5.29614000"
                    },
                    {
                        "id": 79252,
                        "name": "Indre Arna",
                        "latitude": "60.41768000",
                        "longitude": "5.47087000"
                    },
                    {
                        "id": 79258,
                        "name": "Jondal",
                        "latitude": "60.27620000",
                        "longitude": "6.25257000"
                    },
                    {
                        "id": 79261,
                        "name": "Jølster",
                        "latitude": "61.56923000",
                        "longitude": "6.48351000"
                    },
                    {
                        "id": 79269,
                        "name": "Kinsarvik",
                        "latitude": "60.37567000",
                        "longitude": "6.71948000"
                    },
                    {
                        "id": 79277,
                        "name": "Knappskog",
                        "latitude": "60.37906000",
                        "longitude": "5.05602000"
                    },
                    {
                        "id": 79279,
                        "name": "Knarvik",
                        "latitude": "60.54530000",
                        "longitude": "5.28208000"
                    },
                    {
                        "id": 79291,
                        "name": "Kvam",
                        "latitude": "60.36977000",
                        "longitude": "6.14344000"
                    },
                    {
                        "id": 79293,
                        "name": "Kvinnherad",
                        "latitude": "59.98421000",
                        "longitude": "6.01227000"
                    },
                    {
                        "id": 79341,
                        "name": "Lærdal",
                        "latitude": "61.09842000",
                        "longitude": "7.48101000"
                    },
                    {
                        "id": 79342,
                        "name": "Lærdalsøyri",
                        "latitude": "61.10001000",
                        "longitude": "7.47374000"
                    },
                    {
                        "id": 79308,
                        "name": "Leikanger",
                        "latitude": "61.18556000",
                        "longitude": "6.82199000"
                    },
                    {
                        "id": 79311,
                        "name": "Leirvik",
                        "latitude": "59.77977000",
                        "longitude": "5.50051000"
                    },
                    {
                        "id": 79326,
                        "name": "Lindås",
                        "latitude": "60.54910000",
                        "longitude": "5.28559000"
                    },
                    {
                        "id": 79328,
                        "name": "Lonevåg",
                        "latitude": "60.52556000",
                        "longitude": "5.49563000"
                    },
                    {
                        "id": 79335,
                        "name": "Luster",
                        "latitude": "61.40310000",
                        "longitude": "7.29793000"
                    },
                    {
                        "id": 79380,
                        "name": "Måløy",
                        "latitude": "61.93535000",
                        "longitude": "5.11362000"
                    },
                    {
                        "id": 79351,
                        "name": "Manger",
                        "latitude": "60.64145000",
                        "longitude": "5.04136000"
                    },
                    {
                        "id": 79354,
                        "name": "Masfjorden",
                        "latitude": "60.79947000",
                        "longitude": "5.30035000"
                    },
                    {
                        "id": 79357,
                        "name": "Meland",
                        "latitude": "60.51777000",
                        "longitude": "5.24063000"
                    },
                    {
                        "id": 79367,
                        "name": "Modalen",
                        "latitude": "60.81735000",
                        "longitude": "5.80790000"
                    },
                    {
                        "id": 79376,
                        "name": "Mosterhamn",
                        "latitude": "59.69919000",
                        "longitude": "5.38585000"
                    },
                    {
                        "id": 79387,
                        "name": "Naustdal",
                        "latitude": "61.51034000",
                        "longitude": "5.71719000"
                    },
                    {
                        "id": 79406,
                        "name": "Nordfjordeid",
                        "latitude": "61.91220000",
                        "longitude": "5.98557000"
                    },
                    {
                        "id": 79413,
                        "name": "Norheimsund",
                        "latitude": "60.37089000",
                        "longitude": "6.14562000"
                    },
                    {
                        "id": 79417,
                        "name": "Odda",
                        "latitude": "60.06697000",
                        "longitude": "6.54541000"
                    },
                    {
                        "id": 79423,
                        "name": "Os",
                        "latitude": "60.18547000",
                        "longitude": "5.46962000"
                    },
                    {
                        "id": 79426,
                        "name": "Osterøy",
                        "latitude": "60.52389000",
                        "longitude": "5.50551000"
                    },
                    {
                        "id": 79702,
                        "name": "Øygarden",
                        "latitude": "60.59041000",
                        "longitude": "4.83890000"
                    },
                    {
                        "id": 79703,
                        "name": "Øystese",
                        "latitude": "60.38825000",
                        "longitude": "6.19251000"
                    },
                    {
                        "id": 79434,
                        "name": "Radøy",
                        "latitude": "60.64187000",
                        "longitude": "5.04110000"
                    },
                    {
                        "id": 79457,
                        "name": "Rosendal",
                        "latitude": "59.98589000",
                        "longitude": "6.01157000"
                    },
                    {
                        "id": 79459,
                        "name": "Rubbestadneset",
                        "latitude": "59.81559000",
                        "longitude": "5.26822000"
                    },
                    {
                        "id": 79473,
                        "name": "Sagvåg",
                        "latitude": "59.78139000",
                        "longitude": "5.38996000"
                    },
                    {
                        "id": 79476,
                        "name": "Samnanger",
                        "latitude": "60.37745000",
                        "longitude": "5.76219000"
                    },
                    {
                        "id": 79478,
                        "name": "Sandane",
                        "latitude": "61.77277000",
                        "longitude": "6.21496000"
                    },
                    {
                        "id": 79479,
                        "name": "Sande",
                        "latitude": "61.32511000",
                        "longitude": "5.79773000"
                    },
                    {
                        "id": 79485,
                        "name": "Sandsli",
                        "latitude": "60.30323000",
                        "longitude": "5.28554000"
                    },
                    {
                        "id": 79492,
                        "name": "Selje",
                        "latitude": "62.04263000",
                        "longitude": "5.34449000"
                    },
                    {
                        "id": 79517,
                        "name": "Skogsvågen",
                        "latitude": "60.25512000",
                        "longitude": "5.10161000"
                    },
                    {
                        "id": 79529,
                        "name": "Sogndal",
                        "latitude": "61.23144000",
                        "longitude": "7.10301000"
                    },
                    {
                        "id": 79532,
                        "name": "Solund",
                        "latitude": "61.07394000",
                        "longitude": "4.83876000"
                    },
                    {
                        "id": 79548,
                        "name": "Stord",
                        "latitude": "59.78092000",
                        "longitude": "5.49980000"
                    },
                    {
                        "id": 79550,
                        "name": "Storebø",
                        "latitude": "60.09485000",
                        "longitude": "5.22705000"
                    },
                    {
                        "id": 79558,
                        "name": "Straume",
                        "latitude": "60.36131000",
                        "longitude": "5.12199000"
                    },
                    {
                        "id": 79561,
                        "name": "Stryn",
                        "latitude": "61.90406000",
                        "longitude": "6.72400000"
                    },
                    {
                        "id": 79564,
                        "name": "Sund",
                        "latitude": "60.27019000",
                        "longitude": "5.07225000"
                    },
                    {
                        "id": 79568,
                        "name": "Sveio",
                        "latitude": "59.54303000",
                        "longitude": "5.35410000"
                    },
                    {
                        "id": 79569,
                        "name": "Svelgen",
                        "latitude": "61.76976000",
                        "longitude": "5.29544000"
                    },
                    {
                        "id": 79572,
                        "name": "Syfteland",
                        "latitude": "60.23803000",
                        "longitude": "5.45285000"
                    },
                    {
                        "id": 79617,
                        "name": "Tysnes",
                        "latitude": "60.04076000",
                        "longitude": "5.53129000"
                    },
                    {
                        "id": 79622,
                        "name": "Ullensvang",
                        "latitude": "60.37501000",
                        "longitude": "6.72073000"
                    },
                    {
                        "id": 79626,
                        "name": "Ulvik",
                        "latitude": "60.56719000",
                        "longitude": "6.91871000"
                    },
                    {
                        "id": 79664,
                        "name": "Vågsøy",
                        "latitude": "61.93544000",
                        "longitude": "5.11402000"
                    },
                    {
                        "id": 79629,
                        "name": "Vaksdal",
                        "latitude": "60.59030000",
                        "longitude": "5.82272000"
                    },
                    {
                        "id": 79652,
                        "name": "Vik",
                        "latitude": "61.08863000",
                        "longitude": "6.58512000"
                    },
                    {
                        "id": 79662,
                        "name": "Voss",
                        "latitude": "60.62780000",
                        "longitude": "6.41831000"
                    },
                    {
                        "id": 79670,
                        "name": "Ytre Arna",
                        "latitude": "60.46175000",
                        "longitude": "5.43265000"
                    },
                    {
                        "id": 79671,
                        "name": "Ytrebygda",
                        "latitude": "60.30504000",
                        "longitude": "5.28236000"
                    }
                ]
            }
        ]
    },
    {
        "id": 166,
        "name": "Oman",
        "iso3": "OMN",
        "iso2": "OM",
        "numeric_code": "512",
        "phonecode": "968",
        "capital": "Muscat",
        "currency": "OMR",
        "currency_name": "Omani rial",
        "currency_symbol": ".ع.ر",
        "tld": ".om",
        "native": "عمان",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Omani",
        "timezones": [
            {
                "zoneName": "Asia\/Muscat",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "GST",
                "tzName": "Gulf Standard Time"
            }
        ],
        "translations": {
            "br": "Oman",
            "ko": "오만",
            "pt-BR": "Omã",
            "pt": "Omã",
            "nl": "Oman",
            "hr": "Oman",
            "fa": "عمان",
            "de": "Oman",
            "es": "Omán",
            "fr": "Oman",
            "ja": "オマーン",
            "it": "oman",
            "zh-CN": "阿曼",
            "tr": "Umman",
            "ru": "Оман",
            "uk": "Оман",
            "pl": "Oman"
        },
        "latitude": "21.00000000",
        "longitude": "57.00000000",
        "emoji": "🇴🇲",
        "emojiU": "U+1F1F4 U+1F1F2",
        "states": [
            {
                "id": 3058,
                "name": "Ad Dakhiliyah",
                "iso2": "DA",
                "latitude": "22.85887580",
                "longitude": "57.53943560",
                "type": "governorate",
                "cities": [
                    {
                        "id": 79926,
                        "name": "Adam",
                        "latitude": "22.37934000",
                        "longitude": "57.52718000"
                    },
                    {
                        "id": 79930,
                        "name": "Bahlā’",
                        "latitude": "22.97886000",
                        "longitude": "57.30470000"
                    },
                    {
                        "id": 79934,
                        "name": "Bidbid",
                        "latitude": "23.40787000",
                        "longitude": "58.12830000"
                    },
                    {
                        "id": 79937,
                        "name": "Izkī",
                        "latitude": "22.93333000",
                        "longitude": "57.76667000"
                    },
                    {
                        "id": 79942,
                        "name": "Nizwá",
                        "latitude": "22.93333000",
                        "longitude": "57.53333000"
                    },
                    {
                        "id": 79948,
                        "name": "Sufālat Samā’il",
                        "latitude": "23.31667000",
                        "longitude": "58.01667000"
                    }
                ]
            },
            {
                "id": 3047,
                "name": "Ad Dhahirah",
                "iso2": "ZA",
                "latitude": "23.21616740",
                "longitude": "56.49074440",
                "type": "governorate",
                "cities": [
                    {
                        "id": 79953,
                        "name": "‘Ibrī",
                        "latitude": "23.22573000",
                        "longitude": "56.51572000"
                    },
                    {
                        "id": 79950,
                        "name": "Yanqul",
                        "latitude": "23.58645000",
                        "longitude": "56.53969000"
                    }
                ]
            },
            {
                "id": 3048,
                "name": "Al Batinah North",
                "iso2": "BS",
                "latitude": "24.18227750",
                "longitude": "56.16297130",
                "type": "governorate",
                "cities": [
                    {
                        "id": 79928,
                        "name": "Al Khābūrah",
                        "latitude": "23.97144000",
                        "longitude": "57.09313000"
                    },
                    {
                        "id": 79929,
                        "name": "As Suwayq",
                        "latitude": "23.84944000",
                        "longitude": "57.43861000"
                    },
                    {
                        "id": 79939,
                        "name": "Liwá",
                        "latitude": "24.53077000",
                        "longitude": "56.56300000"
                    },
                    {
                        "id": 79952,
                        "name": "Şaḩam",
                        "latitude": "24.17222000",
                        "longitude": "56.88861000"
                    },
                    {
                        "id": 79946,
                        "name": "Shināş",
                        "latitude": "24.74260000",
                        "longitude": "56.46698000"
                    },
                    {
                        "id": 79947,
                        "name": "Sohar",
                        "latitude": "24.34745000",
                        "longitude": "56.70937000"
                    }
                ]
            },
            {
                "id": 3050,
                "name": "Al Batinah Region",
                "iso2": "BA",
                "latitude": "23.49530460",
                "longitude": "56.91081500",
                "type": "governorate",
                "cities": [
                    {
                        "id": 79931,
                        "name": "Barkā’",
                        "latitude": "23.67872000",
                        "longitude": "57.88605000"
                    },
                    {
                        "id": 79933,
                        "name": "Bayt al ‘Awābī",
                        "latitude": "23.30324000",
                        "longitude": "57.52459000"
                    },
                    {
                        "id": 79943,
                        "name": "Oman Smart Future City",
                        "latitude": "23.65270000",
                        "longitude": "57.59926000"
                    },
                    {
                        "id": 79944,
                        "name": "Rustaq",
                        "latitude": "23.39083000",
                        "longitude": "57.42444000"
                    }
                ]
            },
            {
                "id": 3049,
                "name": "Al Batinah South",
                "iso2": "BJ",
                "latitude": "23.43149030",
                "longitude": "57.42397960",
                "type": "governorate",
                "cities": []
            },
            {
                "id": 3059,
                "name": "Al Buraimi",
                "iso2": "BU",
                "latitude": "24.16714130",
                "longitude": "56.11422530",
                "type": "governorate",
                "cities": [
                    {
                        "id": 79927,
                        "name": "Al Buraymī",
                        "latitude": "24.25088000",
                        "longitude": "55.79312000"
                    }
                ]
            },
            {
                "id": 3056,
                "name": "Al Wusta",
                "iso2": "WU",
                "latitude": "19.95710780",
                "longitude": "56.27568460",
                "type": "governorate",
                "cities": [
                    {
                        "id": 79936,
                        "name": "Haymā’",
                        "latitude": "19.95931000",
                        "longitude": "56.27575000"
                    }
                ]
            },
            {
                "id": 3053,
                "name": "Ash Sharqiyah North",
                "iso2": "SS",
                "latitude": "22.04272490",
                "longitude": "57.35334150",
                "type": "governorate",
                "cities": []
            },
            {
                "id": 3051,
                "name": "Ash Sharqiyah Region",
                "iso2": "SH",
                "latitude": "21.40089120",
                "longitude": "57.69849610",
                "type": "governorate",
                "cities": [
                    {
                        "id": 79949,
                        "name": "Sur",
                        "latitude": "22.56667000",
                        "longitude": "59.52889000"
                    }
                ]
            },
            {
                "id": 3054,
                "name": "Ash Sharqiyah South",
                "iso2": "SJ",
                "latitude": "22.01582490",
                "longitude": "59.32519220",
                "type": "governorate",
                "cities": []
            },
            {
                "id": 3057,
                "name": "Dhofar",
                "iso2": "ZU",
                "latitude": "17.03221210",
                "longitude": "54.14252140",
                "type": "governorate",
                "cities": [
                    {
                        "id": 79951,
                        "name": "Şalālah",
                        "latitude": "17.01505000",
                        "longitude": "54.09237000"
                    }
                ]
            },
            {
                "id": 3052,
                "name": "Musandam",
                "iso2": "MU",
                "latitude": "26.19861440",
                "longitude": "56.24609490",
                "type": "governorate",
                "cities": [
                    {
                        "id": 79935,
                        "name": "Dib Dibba",
                        "latitude": "26.19778000",
                        "longitude": "56.25778000"
                    },
                    {
                        "id": 79938,
                        "name": "Khasab",
                        "latitude": "26.17993000",
                        "longitude": "56.24774000"
                    },
                    {
                        "id": 79940,
                        "name": "Madḩā’ al Jadīdah",
                        "latitude": "25.28345000",
                        "longitude": "56.33280000"
                    }
                ]
            },
            {
                "id": 3055,
                "name": "Muscat",
                "iso2": "MA",
                "latitude": "23.58803070",
                "longitude": "58.38287170",
                "type": "governorate",
                "cities": [
                    {
                        "id": 79932,
                        "name": "Bawshar",
                        "latitude": "23.57769000",
                        "longitude": "58.39982000"
                    },
                    {
                        "id": 79941,
                        "name": "Muscat",
                        "latitude": "23.58413000",
                        "longitude": "58.40778000"
                    },
                    {
                        "id": 79945,
                        "name": "Seeb",
                        "latitude": "23.67027000",
                        "longitude": "58.18911000"
                    }
                ]
            }
        ]
    },
    {
        "id": 167,
        "name": "Pakistan",
        "iso3": "PAK",
        "iso2": "PK",
        "numeric_code": "586",
        "phonecode": "92",
        "capital": "Islamabad",
        "currency": "PKR",
        "currency_name": "Pakistani rupee",
        "currency_symbol": "₨",
        "tld": ".pk",
        "native": "پاکستان",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Southern Asia",
        "subregion_id": 14,
        "nationality": "Pakistani",
        "timezones": [
            {
                "zoneName": "Asia\/Karachi",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "PKT",
                "tzName": "Pakistan Standard Time"
            }
        ],
        "translations": {
            "br": "Pakistan",
            "ko": "파키스탄",
            "pt-BR": "Paquistão",
            "pt": "Paquistão",
            "nl": "Pakistan",
            "hr": "Pakistan",
            "fa": "پاکستان",
            "de": "Pakistan",
            "es": "Pakistán",
            "fr": "Pakistan",
            "ja": "パキスタン",
            "it": "Pakistan",
            "zh-CN": "巴基斯坦",
            "tr": "Pakistan",
            "ru": "Пакистан",
            "uk": "Пакистан",
            "pl": "Pakistan"
        },
        "latitude": "30.00000000",
        "longitude": "70.00000000",
        "emoji": "🇵🇰",
        "emojiU": "U+1F1F5 U+1F1F0",
        "states": [
            {
                "id": 3172,
                "name": "Azad Kashmir",
                "iso2": "JK",
                "latitude": "33.92590550",
                "longitude": "73.78103340",
                "type": "administered area",
                "cities": [
                    {
                        "id": 85368,
                        "name": "Bhimbar",
                        "latitude": "32.97465000",
                        "longitude": "74.07846000"
                    },
                    {
                        "id": 85562,
                        "name": "Kotli",
                        "latitude": "33.51836000",
                        "longitude": "73.90220000"
                    },
                    {
                        "id": 85563,
                        "name": "Kotli District",
                        "latitude": "33.44559000",
                        "longitude": "73.91557000"
                    },
                    {
                        "id": 85614,
                        "name": "Mirpur District",
                        "latitude": "33.21556000",
                        "longitude": "73.75144000"
                    },
                    {
                        "id": 85628,
                        "name": "Muzaffarābād",
                        "latitude": "34.37002000",
                        "longitude": "73.47082000"
                    },
                    {
                        "id": 85643,
                        "name": "New Mirpur",
                        "latitude": "33.14782000",
                        "longitude": "73.75187000"
                    },
                    {
                        "id": 85682,
                        "name": "Rawala Kot",
                        "latitude": "33.85782000",
                        "longitude": "73.76043000"
                    }
                ]
            },
            {
                "id": 3174,
                "name": "Balochistan",
                "iso2": "BA",
                "latitude": "28.49073320",
                "longitude": "65.09577920",
                "type": "province",
                "cities": [
                    {
                        "id": 85334,
                        "name": "Alik Ghund",
                        "latitude": "30.48976000",
                        "longitude": "67.52177000"
                    },
                    {
                        "id": 85342,
                        "name": "Awārān District",
                        "latitude": "26.21157000",
                        "longitude": "65.42944000"
                    },
                    {
                        "id": 85353,
                        "name": "Barkhan",
                        "latitude": "29.89773000",
                        "longitude": "69.52558000"
                    },
                    {
                        "id": 85375,
                        "name": "Bārkhān District",
                        "latitude": "29.98482000",
                        "longitude": "69.69944000"
                    },
                    {
                        "id": 85360,
                        "name": "Bela",
                        "latitude": "26.22718000",
                        "longitude": "66.31178000"
                    },
                    {
                        "id": 85362,
                        "name": "Bhag",
                        "latitude": "29.04174000",
                        "longitude": "67.82394000"
                    },
                    {
                        "id": 85401,
                        "name": "Chāgai District",
                        "latitude": "28.98765000",
                        "longitude": "63.59087000"
                    },
                    {
                        "id": 85385,
                        "name": "Chaman",
                        "latitude": "30.91769000",
                        "longitude": "66.45259000"
                    },
                    {
                        "id": 85397,
                        "name": "Chowki Jamali",
                        "latitude": "28.01944000",
                        "longitude": "67.92083000"
                    },
                    {
                        "id": 85402,
                        "name": "Dadhar",
                        "latitude": "29.47489000",
                        "longitude": "67.65167000"
                    },
                    {
                        "id": 85406,
                        "name": "Dalbandin",
                        "latitude": "28.88846000",
                        "longitude": "64.40616000"
                    },
                    {
                        "id": 85416,
                        "name": "Dera Bugti",
                        "latitude": "29.03619000",
                        "longitude": "69.15849000"
                    },
                    {
                        "id": 85417,
                        "name": "Dera Bugti District",
                        "latitude": "28.94250000",
                        "longitude": "69.06883000"
                    },
                    {
                        "id": 85432,
                        "name": "Duki",
                        "latitude": "30.15307000",
                        "longitude": "68.57323000"
                    },
                    {
                        "id": 85442,
                        "name": "Gadani",
                        "latitude": "25.11879000",
                        "longitude": "66.73219000"
                    },
                    {
                        "id": 85445,
                        "name": "Garhi Khairo",
                        "latitude": "28.06029000",
                        "longitude": "67.98033000"
                    },
                    {
                        "id": 85459,
                        "name": "Gwadar",
                        "latitude": "25.12163000",
                        "longitude": "62.32541000"
                    },
                    {
                        "id": 85465,
                        "name": "Harnai",
                        "latitude": "30.10077000",
                        "longitude": "67.93824000"
                    },
                    {
                        "id": 85497,
                        "name": "Jāfarābād District",
                        "latitude": "28.30104000",
                        "longitude": "68.19783000"
                    },
                    {
                        "id": 85489,
                        "name": "Jhal Magsi District",
                        "latitude": "28.36881000",
                        "longitude": "67.54300000"
                    },
                    {
                        "id": 85495,
                        "name": "Jiwani",
                        "latitude": "25.04852000",
                        "longitude": "61.74573000"
                    },
                    {
                        "id": 85507,
                        "name": "Kalat",
                        "latitude": "29.02663000",
                        "longitude": "66.59361000"
                    },
                    {
                        "id": 85511,
                        "name": "Kalāt District",
                        "latitude": "28.88242000",
                        "longitude": "66.53165000"
                    },
                    {
                        "id": 85530,
                        "name": "Khadan Khak",
                        "latitude": "30.75236000",
                        "longitude": "67.71133000"
                    },
                    {
                        "id": 85543,
                        "name": "Kharan",
                        "latitude": "28.58459000",
                        "longitude": "65.41501000"
                    },
                    {
                        "id": 85550,
                        "name": "Khārān District",
                        "latitude": "27.96308000",
                        "longitude": "64.57113000"
                    },
                    {
                        "id": 85548,
                        "name": "Khuzdar",
                        "latitude": "27.81193000",
                        "longitude": "66.61096000"
                    },
                    {
                        "id": 85549,
                        "name": "Khuzdār District",
                        "latitude": "27.48680000",
                        "longitude": "66.58703000"
                    },
                    {
                        "id": 85552,
                        "name": "Kohlu",
                        "latitude": "29.89651000",
                        "longitude": "69.25324000"
                    },
                    {
                        "id": 85556,
                        "name": "Kot Malik Barkhurdar",
                        "latitude": "30.20379000",
                        "longitude": "66.98723000"
                    },
                    {
                        "id": 85579,
                        "name": "Lasbela District",
                        "latitude": "25.78634000",
                        "longitude": "66.60330000"
                    },
                    {
                        "id": 85584,
                        "name": "Loralai",
                        "latitude": "30.37051000",
                        "longitude": "68.59795000"
                    },
                    {
                        "id": 85585,
                        "name": "Loralai District",
                        "latitude": "30.30253000",
                        "longitude": "68.84636000"
                    },
                    {
                        "id": 85586,
                        "name": "Mach",
                        "latitude": "29.86371000",
                        "longitude": "67.33018000"
                    },
                    {
                        "id": 85599,
                        "name": "Mastung",
                        "latitude": "29.79966000",
                        "longitude": "66.84553000"
                    },
                    {
                        "id": 85600,
                        "name": "Mastung District",
                        "latitude": "29.79455000",
                        "longitude": "66.72068000"
                    },
                    {
                        "id": 85605,
                        "name": "Mehrabpur",
                        "latitude": "28.10773000",
                        "longitude": "68.02554000"
                    },
                    {
                        "id": 85629,
                        "name": "Mūsa Khel District",
                        "latitude": "30.84937000",
                        "longitude": "69.90069000"
                    },
                    {
                        "id": 85635,
                        "name": "Nasīrābād District",
                        "latitude": "28.62643000",
                        "longitude": "68.12925000"
                    },
                    {
                        "id": 85648,
                        "name": "Nushki",
                        "latitude": "29.55218000",
                        "longitude": "66.02288000"
                    },
                    {
                        "id": 85651,
                        "name": "Ormara",
                        "latitude": "25.21018000",
                        "longitude": "64.63626000"
                    },
                    {
                        "id": 85656,
                        "name": "Panjgūr District",
                        "latitude": "26.73750000",
                        "longitude": "64.20380000"
                    },
                    {
                        "id": 85658,
                        "name": "Pasni",
                        "latitude": "25.26302000",
                        "longitude": "63.46921000"
                    },
                    {
                        "id": 85668,
                        "name": "Pishin",
                        "latitude": "30.58176000",
                        "longitude": "66.99406000"
                    },
                    {
                        "id": 85671,
                        "name": "Qila Saifullāh District",
                        "latitude": "30.95392000",
                        "longitude": "68.33996000"
                    },
                    {
                        "id": 85672,
                        "name": "Quetta",
                        "latitude": "30.18414000",
                        "longitude": "67.00141000"
                    },
                    {
                        "id": 85673,
                        "name": "Quetta District",
                        "latitude": "30.17458000",
                        "longitude": "66.76203000"
                    },
                    {
                        "id": 85721,
                        "name": "Sibi",
                        "latitude": "29.54299000",
                        "longitude": "67.87726000"
                    },
                    {
                        "id": 85727,
                        "name": "Sohbatpur",
                        "latitude": "28.52038000",
                        "longitude": "68.54298000"
                    },
                    {
                        "id": 85731,
                        "name": "Surab",
                        "latitude": "28.49276000",
                        "longitude": "66.25999000"
                    },
                    {
                        "id": 85755,
                        "name": "Turbat",
                        "latitude": "26.00122000",
                        "longitude": "63.04849000"
                    },
                    {
                        "id": 85760,
                        "name": "Usta Muhammad",
                        "latitude": "28.17723000",
                        "longitude": "68.04367000"
                    },
                    {
                        "id": 85761,
                        "name": "Uthal",
                        "latitude": "25.80722000",
                        "longitude": "66.62194000"
                    },
                    {
                        "id": 85771,
                        "name": "Zhob",
                        "latitude": "31.34082000",
                        "longitude": "69.44930000"
                    },
                    {
                        "id": 85772,
                        "name": "Zhob District",
                        "latitude": "31.36444000",
                        "longitude": "69.20749000"
                    },
                    {
                        "id": 85773,
                        "name": "Ziarat",
                        "latitude": "30.38244000",
                        "longitude": "67.72562000"
                    },
                    {
                        "id": 85774,
                        "name": "Ziārat District",
                        "latitude": "30.43591000",
                        "longitude": "67.50962000"
                    }
                ]
            },
            {
                "id": 3173,
                "name": "Federally Administered Tribal Areas",
                "iso2": "TA",
                "latitude": "32.66747600",
                "longitude": "69.85974060",
                "type": "administered area",
                "cities": [
                    {
                        "id": 85336,
                        "name": "Alizai",
                        "latitude": "33.53613000",
                        "longitude": "70.34607000"
                    },
                    {
                        "id": 85458,
                        "name": "Gulishah Kach",
                        "latitude": "32.67087000",
                        "longitude": "70.33917000"
                    },
                    {
                        "id": 85577,
                        "name": "Landi Kotal",
                        "latitude": "34.09880000",
                        "longitude": "71.14108000"
                    },
                    {
                        "id": 85611,
                        "name": "Miran Shah",
                        "latitude": "33.00059000",
                        "longitude": "70.07117000"
                    },
                    {
                        "id": 85645,
                        "name": "North Wazīristān Agency",
                        "latitude": "32.95087000",
                        "longitude": "69.95764000"
                    },
                    {
                        "id": 85717,
                        "name": "Shinpokh",
                        "latitude": "34.32959000",
                        "longitude": "71.17852000"
                    },
                    {
                        "id": 85728,
                        "name": "South Wazīristān Agency",
                        "latitude": "32.30397000",
                        "longitude": "69.68207000"
                    },
                    {
                        "id": 85764,
                        "name": "Wana",
                        "latitude": "32.29889000",
                        "longitude": "69.57250000"
                    }
                ]
            },
            {
                "id": 3170,
                "name": "Gilgit-Baltistan",
                "iso2": "GB",
                "latitude": "35.80256670",
                "longitude": "74.98318080",
                "type": "administered area",
                "cities": [
                    {
                        "id": 85352,
                        "name": "Barishal",
                        "latitude": "36.32162000",
                        "longitude": "74.69502000"
                    },
                    {
                        "id": 85450,
                        "name": "Gilgit",
                        "latitude": "35.91869000",
                        "longitude": "74.31245000"
                    },
                    {
                        "id": 85724,
                        "name": "Skardu",
                        "latitude": "35.29787000",
                        "longitude": "75.63372000"
                    }
                ]
            },
            {
                "id": 3169,
                "name": "Islamabad",
                "iso2": "IS",
                "latitude": "33.72049970",
                "longitude": "73.04052770",
                "type": "federal capital territory",
                "cities": [
                    {
                        "id": 85475,
                        "name": "Islamabad",
                        "latitude": "33.72148000",
                        "longitude": "73.04329000"
                    }
                ]
            },
            {
                "id": 3171,
                "name": "Khyber Pakhtunkhwa",
                "iso2": "KP",
                "latitude": "34.95262050",
                "longitude": "72.33111300",
                "type": "province",
                "cities": [
                    {
                        "id": 85329,
                        "name": "Abbottabad",
                        "latitude": "34.14630000",
                        "longitude": "73.21168000"
                    },
                    {
                        "id": 85333,
                        "name": "Akora",
                        "latitude": "34.00337000",
                        "longitude": "72.12561000"
                    },
                    {
                        "id": 85337,
                        "name": "Aman Garh",
                        "latitude": "34.00584000",
                        "longitude": "71.92971000"
                    },
                    {
                        "id": 85338,
                        "name": "Amirabad",
                        "latitude": "34.18729000",
                        "longitude": "73.09078000"
                    },
                    {
                        "id": 85340,
                        "name": "Ashanagro Koto",
                        "latitude": "34.10773000",
                        "longitude": "72.24517000"
                    },
                    {
                        "id": 85345,
                        "name": "Baffa",
                        "latitude": "34.43770000",
                        "longitude": "73.22368000"
                    },
                    {
                        "id": 85351,
                        "name": "Bannu",
                        "latitude": "32.98527000",
                        "longitude": "70.60403000"
                    },
                    {
                        "id": 85356,
                        "name": "Bat Khela",
                        "latitude": "34.61780000",
                        "longitude": "71.97247000"
                    },
                    {
                        "id": 85357,
                        "name": "Battagram",
                        "latitude": "34.67719000",
                        "longitude": "73.02329000"
                    },
                    {
                        "id": 85358,
                        "name": "Battagram District",
                        "latitude": "34.68051000",
                        "longitude": "73.00535000"
                    },
                    {
                        "id": 85374,
                        "name": "Buner District",
                        "latitude": "34.44301000",
                        "longitude": "72.49933000"
                    },
                    {
                        "id": 85387,
                        "name": "Charsadda",
                        "latitude": "34.14822000",
                        "longitude": "71.74060000"
                    },
                    {
                        "id": 85390,
                        "name": "Cherat Cantonement",
                        "latitude": "33.82342000",
                        "longitude": "71.89292000"
                    },
                    {
                        "id": 85395,
                        "name": "Chitral",
                        "latitude": "35.85180000",
                        "longitude": "71.78636000"
                    },
                    {
                        "id": 85419,
                        "name": "Dera Ismail Khan",
                        "latitude": "31.83129000",
                        "longitude": "70.90170000"
                    },
                    {
                        "id": 85420,
                        "name": "Dera Ismāīl Khān District",
                        "latitude": "31.85963000",
                        "longitude": "70.64879000"
                    },
                    {
                        "id": 85430,
                        "name": "Doaba",
                        "latitude": "33.42450000",
                        "longitude": "70.73676000"
                    },
                    {
                        "id": 85463,
                        "name": "Hangu",
                        "latitude": "33.53198000",
                        "longitude": "71.05950000"
                    },
                    {
                        "id": 85464,
                        "name": "Haripur",
                        "latitude": "33.99783000",
                        "longitude": "72.93493000"
                    },
                    {
                        "id": 85470,
                        "name": "Havelian",
                        "latitude": "34.05348000",
                        "longitude": "73.15993000"
                    },
                    {
                        "id": 85504,
                        "name": "Kakad Wari Dir Upper",
                        "latitude": "34.99798000",
                        "longitude": "72.07295000"
                    },
                    {
                        "id": 85522,
                        "name": "Karak",
                        "latitude": "33.11633000",
                        "longitude": "71.09354000"
                    },
                    {
                        "id": 85536,
                        "name": "Khalabat",
                        "latitude": "34.05997000",
                        "longitude": "72.88963000"
                    },
                    {
                        "id": 85551,
                        "name": "Kohat",
                        "latitude": "33.58196000",
                        "longitude": "71.44929000"
                    },
                    {
                        "id": 85566,
                        "name": "Kulachi",
                        "latitude": "31.93058000",
                        "longitude": "70.45959000"
                    },
                    {
                        "id": 85570,
                        "name": "Lachi",
                        "latitude": "33.38291000",
                        "longitude": "71.33733000"
                    },
                    {
                        "id": 85574,
                        "name": "Lakki",
                        "latitude": "32.60724000",
                        "longitude": "70.91234000"
                    },
                    {
                        "id": 85597,
                        "name": "Mansehra",
                        "latitude": "34.33023000",
                        "longitude": "73.19679000"
                    },
                    {
                        "id": 85598,
                        "name": "Mardan",
                        "latitude": "34.19794000",
                        "longitude": "72.04965000"
                    },
                    {
                        "id": 85610,
                        "name": "Mingora",
                        "latitude": "34.77950000",
                        "longitude": "72.36265000"
                    },
                    {
                        "id": 85644,
                        "name": "Noorabad",
                        "latitude": "34.25195000",
                        "longitude": "71.96656000"
                    },
                    {
                        "id": 85646,
                        "name": "Nowshera",
                        "latitude": "34.01583000",
                        "longitude": "71.98123000"
                    },
                    {
                        "id": 85647,
                        "name": "Nowshera Cantonment",
                        "latitude": "33.99829000",
                        "longitude": "71.99834000"
                    },
                    {
                        "id": 85652,
                        "name": "Pabbi",
                        "latitude": "34.00968000",
                        "longitude": "71.79445000"
                    },
                    {
                        "id": 85654,
                        "name": "Paharpur",
                        "latitude": "32.10502000",
                        "longitude": "70.97055000"
                    },
                    {
                        "id": 85661,
                        "name": "Peshawar",
                        "latitude": "34.00800000",
                        "longitude": "71.57849000"
                    },
                    {
                        "id": 85686,
                        "name": "Risalpur Cantonment",
                        "latitude": "34.06048000",
                        "longitude": "71.99276000"
                    },
                    {
                        "id": 85700,
                        "name": "Sarai Naurang",
                        "latitude": "32.82581000",
                        "longitude": "70.78107000"
                    },
                    {
                        "id": 85705,
                        "name": "Shabqadar",
                        "latitude": "34.21599000",
                        "longitude": "71.55480000"
                    },
                    {
                        "id": 85716,
                        "name": "Shingli Bala",
                        "latitude": "34.67872000",
                        "longitude": "72.98491000"
                    },
                    {
                        "id": 85718,
                        "name": "Shorkot",
                        "latitude": "31.91023000",
                        "longitude": "70.87757000"
                    },
                    {
                        "id": 85733,
                        "name": "Swabi",
                        "latitude": "34.12018000",
                        "longitude": "72.46982000"
                    },
                    {
                        "id": 85745,
                        "name": "Tangi",
                        "latitude": "34.30090000",
                        "longitude": "71.65238000"
                    },
                    {
                        "id": 85747,
                        "name": "Tank",
                        "latitude": "32.21707000",
                        "longitude": "70.38315000"
                    },
                    {
                        "id": 85749,
                        "name": "Thal",
                        "latitude": "35.47836000",
                        "longitude": "72.24383000"
                    },
                    {
                        "id": 85754,
                        "name": "Topi",
                        "latitude": "34.07034000",
                        "longitude": "72.62147000"
                    },
                    {
                        "id": 85759,
                        "name": "Upper Dir",
                        "latitude": "35.20740000",
                        "longitude": "71.87680000"
                    },
                    {
                        "id": 85762,
                        "name": "Utmanzai",
                        "latitude": "34.18775000",
                        "longitude": "71.76274000"
                    },
                    {
                        "id": 85770,
                        "name": "Zaida",
                        "latitude": "34.05950000",
                        "longitude": "72.46690000"
                    }
                ]
            },
            {
                "id": 3176,
                "name": "Punjab",
                "iso2": "PB",
                "latitude": "30.77683010",
                "longitude": "67.07652990",
                "type": "province",
                "cities": [
                    {
                        "id": 85332,
                        "name": "Ahmadpur Sial",
                        "latitude": "30.67791000",
                        "longitude": "71.74344000"
                    },
                    {
                        "id": 85331,
                        "name": "Ahmedpur East",
                        "latitude": "29.14269000",
                        "longitude": "71.25771000"
                    },
                    {
                        "id": 85335,
                        "name": "Alipur Chatha",
                        "latitude": "29.38242000",
                        "longitude": "70.91106000"
                    },
                    {
                        "id": 85339,
                        "name": "Arifwala",
                        "latitude": "30.29058000",
                        "longitude": "73.06574000"
                    },
                    {
                        "id": 85341,
                        "name": "Attock Tehsil",
                        "latitude": "33.76671000",
                        "longitude": "72.35977000"
                    },
                    {
                        "id": 85343,
                        "name": "Baddomalhi",
                        "latitude": "31.99042000",
                        "longitude": "74.66410000"
                    },
                    {
                        "id": 85347,
                        "name": "Bahawalnagar",
                        "latitude": "29.99835000",
                        "longitude": "73.25272000"
                    },
                    {
                        "id": 85348,
                        "name": "Bahawalpur",
                        "latitude": "29.39779000",
                        "longitude": "71.67520000"
                    },
                    {
                        "id": 85349,
                        "name": "Bakhri Ahmad Khan",
                        "latitude": "30.73586000",
                        "longitude": "70.83796000"
                    },
                    {
                        "id": 85354,
                        "name": "Basirpur",
                        "latitude": "30.57759000",
                        "longitude": "73.83912000"
                    },
                    {
                        "id": 85355,
                        "name": "Basti Dosa",
                        "latitude": "30.78769000",
                        "longitude": "70.86853000"
                    },
                    {
                        "id": 85359,
                        "name": "Begowala",
                        "latitude": "32.43816000",
                        "longitude": "74.26794000"
                    },
                    {
                        "id": 85363,
                        "name": "Bhakkar",
                        "latitude": "31.62685000",
                        "longitude": "71.06471000"
                    },
                    {
                        "id": 85364,
                        "name": "Bhalwal",
                        "latitude": "32.26576000",
                        "longitude": "72.89809000"
                    },
                    {
                        "id": 85366,
                        "name": "Bhawana",
                        "latitude": "31.56884000",
                        "longitude": "72.64917000"
                    },
                    {
                        "id": 85367,
                        "name": "Bhera",
                        "latitude": "32.48206000",
                        "longitude": "72.90865000"
                    },
                    {
                        "id": 85371,
                        "name": "Bhopalwala",
                        "latitude": "32.42968000",
                        "longitude": "74.36350000"
                    },
                    {
                        "id": 85376,
                        "name": "Burewala",
                        "latitude": "30.16667000",
                        "longitude": "72.65000000"
                    },
                    {
                        "id": 85378,
                        "name": "Chak Azam Saffo",
                        "latitude": "30.75202000",
                        "longitude": "73.02834000"
                    },
                    {
                        "id": 85380,
                        "name": "Chak Jhumra",
                        "latitude": "31.56808000",
                        "longitude": "73.18317000"
                    },
                    {
                        "id": 85381,
                        "name": "Chak One Hundred Twenty Nine Left",
                        "latitude": "30.42919000",
                        "longitude": "73.04522000"
                    },
                    {
                        "id": 85382,
                        "name": "Chak Thirty-one -Eleven Left",
                        "latitude": "30.42388000",
                        "longitude": "72.69737000"
                    },
                    {
                        "id": 85383,
                        "name": "Chak Two Hundred Forty-Nine TDA",
                        "latitude": "31.17772000",
                        "longitude": "71.20480000"
                    },
                    {
                        "id": 85384,
                        "name": "Chakwal",
                        "latitude": "32.93286000",
                        "longitude": "72.85394000"
                    },
                    {
                        "id": 85388,
                        "name": "Chawinda",
                        "latitude": "32.34434000",
                        "longitude": "74.70507000"
                    },
                    {
                        "id": 85392,
                        "name": "Chichawatni",
                        "latitude": "30.53010000",
                        "longitude": "72.69155000"
                    },
                    {
                        "id": 85393,
                        "name": "Chiniot",
                        "latitude": "31.72091000",
                        "longitude": "72.97836000"
                    },
                    {
                        "id": 85394,
                        "name": "Chishtian",
                        "latitude": "29.79713000",
                        "longitude": "72.85772000"
                    },
                    {
                        "id": 85396,
                        "name": "Choa Saidanshah",
                        "latitude": "32.71962000",
                        "longitude": "72.98625000"
                    },
                    {
                        "id": 143765,
                        "name": "Chuhar Kana",
                        "latitude": "31.75000000",
                        "longitude": "73.80000000"
                    },
                    {
                        "id": 85400,
                        "name": "Chunian",
                        "latitude": "30.96621000",
                        "longitude": "73.97908000"
                    },
                    {
                        "id": 85404,
                        "name": "Daira Din Panah",
                        "latitude": "30.57053000",
                        "longitude": "70.93722000"
                    },
                    {
                        "id": 85405,
                        "name": "Dajal",
                        "latitude": "29.55769000",
                        "longitude": "70.37614000"
                    },
                    {
                        "id": 85407,
                        "name": "Dandot RS",
                        "latitude": "32.64167000",
                        "longitude": "72.97500000"
                    },
                    {
                        "id": 85409,
                        "name": "Darya Khan",
                        "latitude": "31.78447000",
                        "longitude": "71.10197000"
                    },
                    {
                        "id": 85411,
                        "name": "Daska",
                        "latitude": "32.32422000",
                        "longitude": "74.35039000"
                    },
                    {
                        "id": 143767,
                        "name": "Daud Khel",
                        "latitude": "32.87498000",
                        "longitude": "71.57013000"
                    },
                    {
                        "id": 85414,
                        "name": "Daultala",
                        "latitude": "33.19282000",
                        "longitude": "73.14099000"
                    },
                    {
                        "id": 85418,
                        "name": "Dera Ghazi Khan",
                        "latitude": "30.04587000",
                        "longitude": "70.64029000"
                    },
                    {
                        "id": 85421,
                        "name": "Dhanot",
                        "latitude": "29.57991000",
                        "longitude": "71.75213000"
                    },
                    {
                        "id": 85422,
                        "name": "Dhaunkal",
                        "latitude": "32.40613000",
                        "longitude": "74.13706000"
                    },
                    {
                        "id": 143766,
                        "name": "Dhok Awan",
                        "latitude": "32.84452000",
                        "longitude": "72.52357000"
                    },
                    {
                        "id": 85425,
                        "name": "Dijkot",
                        "latitude": "31.21735000",
                        "longitude": "72.99621000"
                    },
                    {
                        "id": 85426,
                        "name": "Dinan Bashnoian Wala",
                        "latitude": "29.76584000",
                        "longitude": "73.26557000"
                    },
                    {
                        "id": 85427,
                        "name": "Dinga",
                        "latitude": "32.64101000",
                        "longitude": "73.72039000"
                    },
                    {
                        "id": 85428,
                        "name": "Dipalpur",
                        "latitude": "30.66984000",
                        "longitude": "73.65306000"
                    },
                    {
                        "id": 85433,
                        "name": "Dullewala",
                        "latitude": "31.83439000",
                        "longitude": "71.43639000"
                    },
                    {
                        "id": 85434,
                        "name": "Dunga Bunga",
                        "latitude": "29.74975000",
                        "longitude": "73.24294000"
                    },
                    {
                        "id": 85435,
                        "name": "Dunyapur",
                        "latitude": "29.80275000",
                        "longitude": "71.74344000"
                    },
                    {
                        "id": 85436,
                        "name": "Eminabad",
                        "latitude": "32.04237000",
                        "longitude": "74.25996000"
                    },
                    {
                        "id": 85437,
                        "name": "Faisalabad",
                        "latitude": "31.41554000",
                        "longitude": "73.08969000"
                    },
                    {
                        "id": 85438,
                        "name": "Faqirwali",
                        "latitude": "29.46799000",
                        "longitude": "73.03489000"
                    },
                    {
                        "id": 85439,
                        "name": "Faruka",
                        "latitude": "31.88642000",
                        "longitude": "72.41362000"
                    },
                    {
                        "id": 85440,
                        "name": "Fazilpur",
                        "latitude": "32.17629000",
                        "longitude": "75.06583000"
                    },
                    {
                        "id": 143768,
                        "name": "Ferozewala",
                        "latitude": "29.30000000",
                        "longitude": "70.43333333"
                    },
                    {
                        "id": 85441,
                        "name": "Fort Abbas",
                        "latitude": "29.19344000",
                        "longitude": "72.85525000"
                    },
                    {
                        "id": 85444,
                        "name": "Garh Maharaja",
                        "latitude": "30.83383000",
                        "longitude": "71.90491000"
                    },
                    {
                        "id": 85451,
                        "name": "Gojra",
                        "latitude": "31.14926000",
                        "longitude": "72.68323000"
                    },
                    {
                        "id": 85455,
                        "name": "Gujar Khan",
                        "latitude": "33.25411000",
                        "longitude": "73.30433000"
                    },
                    {
                        "id": 85456,
                        "name": "Gujranwala",
                        "latitude": "32.15567000",
                        "longitude": "74.18705000"
                    },
                    {
                        "id": 143769,
                        "name": "Gujranwala Division",
                        "latitude": "32.45000000",
                        "longitude": "74.13333000"
                    },
                    {
                        "id": 85457,
                        "name": "Gujrat",
                        "latitude": "32.57420000",
                        "longitude": "74.07542000"
                    },
                    {
                        "id": 85460,
                        "name": "Hadali",
                        "latitude": "32.64043000",
                        "longitude": "74.56898000"
                    },
                    {
                        "id": 85461,
                        "name": "Hafizabad",
                        "latitude": "32.07095000",
                        "longitude": "73.68802000"
                    },
                    {
                        "id": 85466,
                        "name": "Harnoli",
                        "latitude": "32.27871000",
                        "longitude": "71.55429000"
                    },
                    {
                        "id": 85467,
                        "name": "Harunabad",
                        "latitude": "29.61206000",
                        "longitude": "73.13802000"
                    },
                    {
                        "id": 143770,
                        "name": "Hasan Abdal",
                        "latitude": "33.81948611",
                        "longitude": "72.68902778"
                    },
                    {
                        "id": 85468,
                        "name": "Hasilpur",
                        "latitude": "29.69221000",
                        "longitude": "72.54566000"
                    },
                    {
                        "id": 85469,
                        "name": "Haveli Lakha",
                        "latitude": "30.45097000",
                        "longitude": "73.69371000"
                    },
                    {
                        "id": 85471,
                        "name": "Hazro",
                        "latitude": "33.90990000",
                        "longitude": "72.49179000"
                    },
                    {
                        "id": 85473,
                        "name": "Hujra Shah Muqeem",
                        "latitude": "30.74168000",
                        "longitude": "73.82327000"
                    },
                    {
                        "id": 85478,
                        "name": "Jahanian Shah",
                        "latitude": "31.80541000",
                        "longitude": "72.27740000"
                    },
                    {
                        "id": 85479,
                        "name": "Jalalpur Jattan",
                        "latitude": "32.64118000",
                        "longitude": "74.20561000"
                    },
                    {
                        "id": 85480,
                        "name": "Jalalpur Pirwala",
                        "latitude": "29.50510000",
                        "longitude": "71.22202000"
                    },
                    {
                        "id": 85481,
                        "name": "Jampur",
                        "latitude": "29.64235000",
                        "longitude": "70.59518000"
                    },
                    {
                        "id": 85483,
                        "name": "Jand",
                        "latitude": "33.43304000",
                        "longitude": "72.01877000"
                    },
                    {
                        "id": 85484,
                        "name": "Jandiala Sher Khan",
                        "latitude": "31.82098000",
                        "longitude": "73.91815000"
                    },
                    {
                        "id": 85485,
                        "name": "Jaranwala",
                        "latitude": "31.33320000",
                        "longitude": "73.41868000"
                    },
                    {
                        "id": 85487,
                        "name": "Jatoi Shimali",
                        "latitude": "29.51827000",
                        "longitude": "70.84474000"
                    },
                    {
                        "id": 85488,
                        "name": "Jauharabad",
                        "latitude": "32.29016000",
                        "longitude": "72.28182000"
                    },
                    {
                        "id": 85490,
                        "name": "Jhang",
                        "latitude": "31.30568000",
                        "longitude": "72.32594000"
                    },
                    {
                        "id": 85491,
                        "name": "Jhang Sadar",
                        "latitude": "31.26981000",
                        "longitude": "72.31687000"
                    },
                    {
                        "id": 85492,
                        "name": "Jhawarian",
                        "latitude": "32.36192000",
                        "longitude": "72.62275000"
                    },
                    {
                        "id": 85493,
                        "name": "Jhelum",
                        "latitude": "32.93448000",
                        "longitude": "73.73102000"
                    },
                    {
                        "id": 85499,
                        "name": "Kabirwala",
                        "latitude": "30.40472000",
                        "longitude": "71.86269000"
                    },
                    {
                        "id": 85501,
                        "name": "Kahna Nau",
                        "latitude": "31.36709000",
                        "longitude": "74.36899000"
                    },
                    {
                        "id": 85503,
                        "name": "Kahuta",
                        "latitude": "33.59183000",
                        "longitude": "73.38736000"
                    },
                    {
                        "id": 85505,
                        "name": "Kalabagh",
                        "latitude": "32.96164000",
                        "longitude": "71.54638000"
                    },
                    {
                        "id": 85506,
                        "name": "Kalaswala",
                        "latitude": "32.20081000",
                        "longitude": "74.64858000"
                    },
                    {
                        "id": 85508,
                        "name": "Kaleke Mandi",
                        "latitude": "31.97597000",
                        "longitude": "73.59999000"
                    },
                    {
                        "id": 85509,
                        "name": "Kallar Kahar",
                        "latitude": "32.77998000",
                        "longitude": "72.69793000"
                    },
                    {
                        "id": 85510,
                        "name": "Kalur Kot",
                        "latitude": "32.15512000",
                        "longitude": "71.26631000"
                    },
                    {
                        "id": 85512,
                        "name": "Kamalia",
                        "latitude": "30.72708000",
                        "longitude": "72.64607000"
                    },
                    {
                        "id": 85513,
                        "name": "Kamar Mushani",
                        "latitude": "32.84318000",
                        "longitude": "71.36192000"
                    },
                    {
                        "id": 85515,
                        "name": "Kamoke",
                        "latitude": "31.97526000",
                        "longitude": "74.22304000"
                    },
                    {
                        "id": 85516,
                        "name": "Kamra",
                        "latitude": "33.74698000",
                        "longitude": "73.51229000"
                    },
                    {
                        "id": 85520,
                        "name": "Kanganpur",
                        "latitude": "30.76468000",
                        "longitude": "74.12286000"
                    },
                    {
                        "id": 85525,
                        "name": "Karor",
                        "latitude": "31.22460000",
                        "longitude": "70.95153000"
                    },
                    {
                        "id": 85527,
                        "name": "Kasur",
                        "latitude": "31.11866000",
                        "longitude": "74.45025000"
                    },
                    {
                        "id": 85528,
                        "name": "Keshupur",
                        "latitude": "32.26000000",
                        "longitude": "72.50000000"
                    },
                    {
                        "id": 85535,
                        "name": "Khairpur Tamiwali",
                        "latitude": "29.58139000",
                        "longitude": "72.23804000"
                    },
                    {
                        "id": 85537,
                        "name": "Khandowa",
                        "latitude": "32.74255000",
                        "longitude": "72.73478000"
                    },
                    {
                        "id": 85538,
                        "name": "Khanewal",
                        "latitude": "30.30173000",
                        "longitude": "71.93212000"
                    },
                    {
                        "id": 85539,
                        "name": "Khanga Dogran",
                        "latitude": "31.83294000",
                        "longitude": "73.62213000"
                    },
                    {
                        "id": 85540,
                        "name": "Khangarh",
                        "latitude": "29.91446000",
                        "longitude": "71.16067000"
                    },
                    {
                        "id": 85541,
                        "name": "Khanpur",
                        "latitude": "28.64739000",
                        "longitude": "70.65694000"
                    },
                    {
                        "id": 85544,
                        "name": "Kharian",
                        "latitude": "32.81612000",
                        "longitude": "73.88697000"
                    },
                    {
                        "id": 85545,
                        "name": "Khewra",
                        "latitude": "32.64910000",
                        "longitude": "73.01059000"
                    },
                    {
                        "id": 85546,
                        "name": "Khurrianwala",
                        "latitude": "31.49936000",
                        "longitude": "73.26763000"
                    },
                    {
                        "id": 85547,
                        "name": "Khushab",
                        "latitude": "32.29667000",
                        "longitude": "72.35250000"
                    },
                    {
                        "id": 143771,
                        "name": "Kohror Pakka",
                        "latitude": "29.62382000",
                        "longitude": "71.91673000"
                    },
                    {
                        "id": 85553,
                        "name": "Kot Addu Tehsil",
                        "latitude": "30.46907000",
                        "longitude": "70.96699000"
                    },
                    {
                        "id": 85555,
                        "name": "Kot Ghulam Muhammad",
                        "latitude": "32.33311000",
                        "longitude": "74.54694000"
                    },
                    {
                        "id": 85557,
                        "name": "Kot Mumin",
                        "latitude": "32.18843000",
                        "longitude": "73.02987000"
                    },
                    {
                        "id": 85558,
                        "name": "Kot Radha Kishan",
                        "latitude": "31.17068000",
                        "longitude": "74.10126000"
                    },
                    {
                        "id": 85559,
                        "name": "Kot Rajkour",
                        "latitude": "32.41208000",
                        "longitude": "74.62855000"
                    },
                    {
                        "id": 85560,
                        "name": "Kot Samaba",
                        "latitude": "28.55207000",
                        "longitude": "70.46837000"
                    },
                    {
                        "id": 85561,
                        "name": "Kot Sultan",
                        "latitude": "30.77370000",
                        "longitude": "70.93125000"
                    },
                    {
                        "id": 85564,
                        "name": "Kotli Loharan",
                        "latitude": "32.58893000",
                        "longitude": "74.49466000"
                    },
                    {
                        "id": 85567,
                        "name": "Kundian",
                        "latitude": "32.45775000",
                        "longitude": "71.47892000"
                    },
                    {
                        "id": 85568,
                        "name": "Kunjah",
                        "latitude": "32.52982000",
                        "longitude": "73.97486000"
                    },
                    {
                        "id": 85571,
                        "name": "Ladhewala Waraich",
                        "latitude": "32.15692000",
                        "longitude": "74.11564000"
                    },
                    {
                        "id": 85572,
                        "name": "Lahore",
                        "latitude": "31.55800000",
                        "longitude": "74.35071000"
                    },
                    {
                        "id": 85575,
                        "name": "Lala Musa",
                        "latitude": "32.70138000",
                        "longitude": "73.95746000"
                    },
                    {
                        "id": 85576,
                        "name": "Lalian",
                        "latitude": "31.82462000",
                        "longitude": "72.80116000"
                    },
                    {
                        "id": 85580,
                        "name": "Layyah",
                        "latitude": "30.96128000",
                        "longitude": "70.93904000"
                    },
                    {
                        "id": 85581,
                        "name": "Layyah District",
                        "latitude": "30.96800000",
                        "longitude": "70.94300000"
                    },
                    {
                        "id": 85582,
                        "name": "Liliani",
                        "latitude": "32.20393000",
                        "longitude": "72.95120000"
                    },
                    {
                        "id": 85583,
                        "name": "Lodhran",
                        "latitude": "29.53390000",
                        "longitude": "71.63244000"
                    },
                    {
                        "id": 85588,
                        "name": "Mailsi",
                        "latitude": "29.80123000",
                        "longitude": "72.17398000"
                    },
                    {
                        "id": 85589,
                        "name": "Malakwal",
                        "latitude": "32.55449000",
                        "longitude": "73.21274000"
                    },
                    {
                        "id": 85590,
                        "name": "Malakwal City",
                        "latitude": "32.55492000",
                        "longitude": "73.21220000"
                    },
                    {
                        "id": 85592,
                        "name": "Mamu Kanjan",
                        "latitude": "30.83044000",
                        "longitude": "72.79943000"
                    },
                    {
                        "id": 85593,
                        "name": "Mananwala",
                        "latitude": "31.58803000",
                        "longitude": "73.68927000"
                    },
                    {
                        "id": 85594,
                        "name": "Mandi Bahauddin",
                        "latitude": "32.58704000",
                        "longitude": "73.49123000"
                    },
                    {
                        "id": 143772,
                        "name": "Mandi Bahauddin District",
                        "latitude": "32.58333333",
                        "longitude": "73.50000000"
                    },
                    {
                        "id": 85595,
                        "name": "Mangla",
                        "latitude": "31.89306000",
                        "longitude": "72.38167000"
                    },
                    {
                        "id": 85596,
                        "name": "Mankera",
                        "latitude": "31.38771000",
                        "longitude": "71.44047000"
                    },
                    {
                        "id": 85604,
                        "name": "Mehmand Chak",
                        "latitude": "32.78518000",
                        "longitude": "73.82306000"
                    },
                    {
                        "id": 85606,
                        "name": "Mian Channun",
                        "latitude": "30.44067000",
                        "longitude": "72.35679000"
                    },
                    {
                        "id": 85607,
                        "name": "Mianke Mor",
                        "latitude": "31.20240000",
                        "longitude": "73.94857000"
                    },
                    {
                        "id": 85608,
                        "name": "Mianwali",
                        "latitude": "32.57756000",
                        "longitude": "71.52847000"
                    },
                    {
                        "id": 85609,
                        "name": "Minchinabad",
                        "latitude": "30.16356000",
                        "longitude": "73.56858000"
                    },
                    {
                        "id": 85619,
                        "name": "Mitha Tiwana",
                        "latitude": "32.24540000",
                        "longitude": "72.10615000"
                    },
                    {
                        "id": 85622,
                        "name": "Moza Shahwala",
                        "latitude": "30.80563000",
                        "longitude": "70.84911000"
                    },
                    {
                        "id": 85623,
                        "name": "Multan",
                        "latitude": "30.19679000",
                        "longitude": "71.47824000"
                    },
                    {
                        "id": 143773,
                        "name": "Multan District",
                        "latitude": "30.08333333",
                        "longitude": "71.66666667"
                    },
                    {
                        "id": 85624,
                        "name": "Muridke",
                        "latitude": "31.80258000",
                        "longitude": "74.25772000"
                    },
                    {
                        "id": 85625,
                        "name": "Murree",
                        "latitude": "33.90836000",
                        "longitude": "73.39030000"
                    },
                    {
                        "id": 85626,
                        "name": "Mustafabad",
                        "latitude": "30.89222000",
                        "longitude": "73.49889000"
                    },
                    {
                        "id": 85627,
                        "name": "Muzaffargarh",
                        "latitude": "30.07258000",
                        "longitude": "71.19379000"
                    },
                    {
                        "id": 85631,
                        "name": "Nankana Sahib",
                        "latitude": "31.45010000",
                        "longitude": "73.70653000"
                    },
                    {
                        "id": 85632,
                        "name": "Narang Mandi",
                        "latitude": "31.90376000",
                        "longitude": "74.51587000"
                    },
                    {
                        "id": 85633,
                        "name": "Narowal",
                        "latitude": "32.10197000",
                        "longitude": "74.87303000"
                    },
                    {
                        "id": 85638,
                        "name": "Naushahra Virkan",
                        "latitude": "31.96258000",
                        "longitude": "73.97117000"
                    },
                    {
                        "id": 85641,
                        "name": "Nazir Town",
                        "latitude": "33.30614000",
                        "longitude": "73.48330000"
                    },
                    {
                        "id": 85650,
                        "name": "Okara",
                        "latitude": "30.81029000",
                        "longitude": "73.45155000"
                    },
                    {
                        "id": 143774,
                        "name": "Pakki Shagwanwali",
                        "latitude": "30.79033000",
                        "longitude": "70.87139000"
                    },
                    {
                        "id": 85655,
                        "name": "Pakpattan",
                        "latitude": "30.34314000",
                        "longitude": "73.38944000"
                    },
                    {
                        "id": 85659,
                        "name": "Pasrur",
                        "latitude": "32.26286000",
                        "longitude": "74.66327000"
                    },
                    {
                        "id": 85660,
                        "name": "Pattoki",
                        "latitude": "31.02021000",
                        "longitude": "73.85333000"
                    },
                    {
                        "id": 85662,
                        "name": "Phalia",
                        "latitude": "32.43104000",
                        "longitude": "73.57900000"
                    },
                    {
                        "id": 85663,
                        "name": "Pind Dadan Khan",
                        "latitude": "32.58662000",
                        "longitude": "73.04456000"
                    },
                    {
                        "id": 85664,
                        "name": "Pindi Bhattian",
                        "latitude": "31.89844000",
                        "longitude": "73.27339000"
                    },
                    {
                        "id": 85665,
                        "name": "Pindi Gheb",
                        "latitude": "33.24095000",
                        "longitude": "72.26480000"
                    },
                    {
                        "id": 85667,
                        "name": "Pir Mahal",
                        "latitude": "30.76663000",
                        "longitude": "72.43455000"
                    },
                    {
                        "id": 85670,
                        "name": "Qadirpur Ran",
                        "latitude": "30.29184000",
                        "longitude": "71.67164000"
                    },
                    {
                        "id": 143775,
                        "name": "Qila Didar Singh",
                        "latitude": "32.80000000",
                        "longitude": "74.10000000"
                    },
                    {
                        "id": 85389,
                        "name": "Rabwah",
                        "latitude": "31.75511000",
                        "longitude": "72.91403000"
                    },
                    {
                        "id": 85674,
                        "name": "Rahim Yar Khan",
                        "latitude": "28.41987000",
                        "longitude": "70.30345000"
                    },
                    {
                        "id": 143776,
                        "name": "Rahimyar Khan District",
                        "latitude": "28.46020000",
                        "longitude": "70.52837000"
                    },
                    {
                        "id": 85675,
                        "name": "Raiwind",
                        "latitude": "31.24895000",
                        "longitude": "74.21534000"
                    },
                    {
                        "id": 85676,
                        "name": "Raja Jang",
                        "latitude": "31.22078000",
                        "longitude": "74.25483000"
                    },
                    {
                        "id": 85677,
                        "name": "Rajanpur",
                        "latitude": "29.10408000",
                        "longitude": "70.32969000"
                    },
                    {
                        "id": 85680,
                        "name": "Rasulnagar",
                        "latitude": "32.32794000",
                        "longitude": "73.78040000"
                    },
                    {
                        "id": 85683,
                        "name": "Rawalpindi",
                        "latitude": "33.59733000",
                        "longitude": "73.04790000"
                    },
                    {
                        "id": 85684,
                        "name": "Rawalpindi District",
                        "latitude": "33.42987000",
                        "longitude": "73.23092000"
                    },
                    {
                        "id": 85685,
                        "name": "Renala Khurd",
                        "latitude": "30.87878000",
                        "longitude": "73.59857000"
                    },
                    {
                        "id": 85688,
                        "name": "Rojhan",
                        "latitude": "28.68735000",
                        "longitude": "69.95350000"
                    },
                    {
                        "id": 85690,
                        "name": "Sadiqabad",
                        "latitude": "28.30910000",
                        "longitude": "70.12652000"
                    },
                    {
                        "id": 85691,
                        "name": "Sahiwal",
                        "latitude": "30.66595000",
                        "longitude": "73.10186000"
                    },
                    {
                        "id": 85694,
                        "name": "Sambrial",
                        "latitude": "32.47835000",
                        "longitude": "74.35338000"
                    },
                    {
                        "id": 85696,
                        "name": "Sangla Hill",
                        "latitude": "31.71667000",
                        "longitude": "73.38333000"
                    },
                    {
                        "id": 85697,
                        "name": "Sanjwal",
                        "latitude": "33.76105000",
                        "longitude": "72.43315000"
                    },
                    {
                        "id": 85699,
                        "name": "Sarai Alamgir",
                        "latitude": "32.90495000",
                        "longitude": "73.75518000"
                    },
                    {
                        "id": 85701,
                        "name": "Sarai Sidhu",
                        "latitude": "30.59476000",
                        "longitude": "71.96990000"
                    },
                    {
                        "id": 85702,
                        "name": "Sargodha",
                        "latitude": "32.08586000",
                        "longitude": "72.67418000"
                    },
                    {
                        "id": 143777,
                        "name": "Shahkot Tehsil",
                        "latitude": "31.56166667",
                        "longitude": "73.48750000"
                    },
                    {
                        "id": 85709,
                        "name": "Shahpur",
                        "latitude": "32.26820000",
                        "longitude": "72.46884000"
                    },
                    {
                        "id": 85711,
                        "name": "Shahr Sultan",
                        "latitude": "29.57517000",
                        "longitude": "71.02209000"
                    },
                    {
                        "id": 85712,
                        "name": "Shakargarh",
                        "latitude": "32.26361000",
                        "longitude": "75.16008000"
                    },
                    {
                        "id": 85713,
                        "name": "Sharqpur",
                        "latitude": "31.46116000",
                        "longitude": "74.10091000"
                    },
                    {
                        "id": 85714,
                        "name": "Sheikhupura",
                        "latitude": "31.71287000",
                        "longitude": "73.98556000"
                    },
                    {
                        "id": 85708,
                        "name": "Shorkot",
                        "latitude": "30.50000000",
                        "longitude": "72.40000000"
                    },
                    {
                        "id": 85719,
                        "name": "Shujaabad",
                        "latitude": "29.88092000",
                        "longitude": "71.29344000"
                    },
                    {
                        "id": 85720,
                        "name": "Sialkot",
                        "latitude": "32.49268000",
                        "longitude": "74.53134000"
                    },
                    {
                        "id": 85722,
                        "name": "Sillanwali",
                        "latitude": "31.82539000",
                        "longitude": "72.54064000"
                    },
                    {
                        "id": 85726,
                        "name": "Sodhra",
                        "latitude": "32.46211000",
                        "longitude": "74.18207000"
                    },
                    {
                        "id": 85729,
                        "name": "Sukheke Mandi",
                        "latitude": "31.86541000",
                        "longitude": "73.50875000"
                    },
                    {
                        "id": 85732,
                        "name": "Surkhpur",
                        "latitude": "32.71816000",
                        "longitude": "74.44773000"
                    },
                    {
                        "id": 85735,
                        "name": "Talagang",
                        "latitude": "32.92766000",
                        "longitude": "72.41594000"
                    },
                    {
                        "id": 85736,
                        "name": "Talamba",
                        "latitude": "30.52693000",
                        "longitude": "72.24079000"
                    },
                    {
                        "id": 85738,
                        "name": "Tandlianwala",
                        "latitude": "31.03359000",
                        "longitude": "73.13268000"
                    },
                    {
                        "id": 85748,
                        "name": "Taunsa",
                        "latitude": "30.70358000",
                        "longitude": "70.65054000"
                    },
                    {
                        "id": 85753,
                        "name": "Toba Tek Singh",
                        "latitude": "30.97127000",
                        "longitude": "72.48275000"
                    },
                    {
                        "id": 143778,
                        "name": "Umerkot",
                        "latitude": "25.36138889",
                        "longitude": "69.73611111"
                    },
                    {
                        "id": 85763,
                        "name": "Vihari",
                        "latitude": "30.04450000",
                        "longitude": "72.35560000"
                    },
                    {
                        "id": 143779,
                        "name": "Wah",
                        "latitude": "33.81000000",
                        "longitude": "72.70972222"
                    },
                    {
                        "id": 143780,
                        "name": "Warburton",
                        "latitude": "31.55000000",
                        "longitude": "73.83330000"
                    },
                    {
                        "id": 85766,
                        "name": "Wazirabad",
                        "latitude": "32.44324000",
                        "longitude": "74.12000000"
                    },
                    {
                        "id": 143781,
                        "name": "West Punjab",
                        "latitude": "31.00000000",
                        "longitude": "72.00000000"
                    },
                    {
                        "id": 85767,
                        "name": "Yazman",
                        "latitude": "29.12122000",
                        "longitude": "71.74459000"
                    },
                    {
                        "id": 85768,
                        "name": "Zafarwal",
                        "latitude": "32.34464000",
                        "longitude": "74.89990000"
                    },
                    {
                        "id": 85769,
                        "name": "Zahir Pir",
                        "latitude": "28.81284000",
                        "longitude": "70.52341000"
                    }
                ]
            },
            {
                "id": 3175,
                "name": "Sindh",
                "iso2": "SD",
                "latitude": "25.89430180",
                "longitude": "68.52471490",
                "type": "province",
                "cities": [
                    {
                        "id": 85330,
                        "name": "Adilpur",
                        "latitude": "27.93677000",
                        "longitude": "69.31941000"
                    },
                    {
                        "id": 85344,
                        "name": "Badin",
                        "latitude": "24.65600000",
                        "longitude": "68.83700000"
                    },
                    {
                        "id": 85346,
                        "name": "Bagarji",
                        "latitude": "27.75431000",
                        "longitude": "68.75866000"
                    },
                    {
                        "id": 85350,
                        "name": "Bandhi",
                        "latitude": "26.58761000",
                        "longitude": "68.30215000"
                    },
                    {
                        "id": 85361,
                        "name": "Berani",
                        "latitude": "25.78497000",
                        "longitude": "68.80754000"
                    },
                    {
                        "id": 85365,
                        "name": "Bhan",
                        "latitude": "26.55831000",
                        "longitude": "67.72139000"
                    },
                    {
                        "id": 85369,
                        "name": "Bhiria",
                        "latitude": "26.91041000",
                        "longitude": "68.19466000"
                    },
                    {
                        "id": 85370,
                        "name": "Bhit Shah",
                        "latitude": "25.80565000",
                        "longitude": "68.49143000"
                    },
                    {
                        "id": 85372,
                        "name": "Bozdar Wada",
                        "latitude": "27.18300000",
                        "longitude": "68.63580000"
                    },
                    {
                        "id": 85373,
                        "name": "Bulri",
                        "latitude": "24.86667000",
                        "longitude": "68.33333000"
                    },
                    {
                        "id": 85377,
                        "name": "Chak",
                        "latitude": "27.85838000",
                        "longitude": "68.83378000"
                    },
                    {
                        "id": 85386,
                        "name": "Chamber",
                        "latitude": "25.29362000",
                        "longitude": "68.81176000"
                    },
                    {
                        "id": 85391,
                        "name": "Chhor",
                        "latitude": "25.51260000",
                        "longitude": "69.78437000"
                    },
                    {
                        "id": 85399,
                        "name": "Chuhar Jamali",
                        "latitude": "24.39440000",
                        "longitude": "67.99298000"
                    },
                    {
                        "id": 85403,
                        "name": "Dadu",
                        "latitude": "26.73033000",
                        "longitude": "67.77690000"
                    },
                    {
                        "id": 85408,
                        "name": "Daromehar",
                        "latitude": "24.79382000",
                        "longitude": "68.17978000"
                    },
                    {
                        "id": 85410,
                        "name": "Darya Khan Marri",
                        "latitude": "26.67765000",
                        "longitude": "68.28666000"
                    },
                    {
                        "id": 85413,
                        "name": "Daulatpur",
                        "latitude": "26.50158000",
                        "longitude": "67.97079000"
                    },
                    {
                        "id": 85415,
                        "name": "Daur",
                        "latitude": "26.45528000",
                        "longitude": "68.31835000"
                    },
                    {
                        "id": 85423,
                        "name": "Dhoro Naro",
                        "latitude": "25.50484000",
                        "longitude": "69.57090000"
                    },
                    {
                        "id": 85424,
                        "name": "Digri",
                        "latitude": "25.15657000",
                        "longitude": "69.11098000"
                    },
                    {
                        "id": 85429,
                        "name": "Diplo",
                        "latitude": "24.46688000",
                        "longitude": "69.58114000"
                    },
                    {
                        "id": 85431,
                        "name": "Dokri",
                        "latitude": "27.37421000",
                        "longitude": "68.09715000"
                    },
                    {
                        "id": 85443,
                        "name": "Gambat",
                        "latitude": "27.35170000",
                        "longitude": "68.52150000"
                    },
                    {
                        "id": 85446,
                        "name": "Garhiyasin",
                        "latitude": "27.90631000",
                        "longitude": "68.51210000"
                    },
                    {
                        "id": 85447,
                        "name": "Gharo",
                        "latitude": "24.74182000",
                        "longitude": "67.58534000"
                    },
                    {
                        "id": 85448,
                        "name": "Ghauspur",
                        "latitude": "28.13882000",
                        "longitude": "69.08245000"
                    },
                    {
                        "id": 85449,
                        "name": "Ghotki",
                        "latitude": "28.00437000",
                        "longitude": "69.31569000"
                    },
                    {
                        "id": 85452,
                        "name": "Goth Garelo",
                        "latitude": "27.43521000",
                        "longitude": "68.07572000"
                    },
                    {
                        "id": 85453,
                        "name": "Goth Phulji",
                        "latitude": "26.88099000",
                        "longitude": "67.68239000"
                    },
                    {
                        "id": 85454,
                        "name": "Goth Radhan",
                        "latitude": "27.19846000",
                        "longitude": "67.95348000"
                    },
                    {
                        "id": 85462,
                        "name": "Hala",
                        "latitude": "25.81459000",
                        "longitude": "68.42198000"
                    },
                    {
                        "id": 85472,
                        "name": "Hingorja",
                        "latitude": "27.21088000",
                        "longitude": "68.41598000"
                    },
                    {
                        "id": 85474,
                        "name": "Hyderabad",
                        "latitude": "25.39242000",
                        "longitude": "68.37366000"
                    },
                    {
                        "id": 85476,
                        "name": "Islamkot",
                        "latitude": "24.69904000",
                        "longitude": "70.17982000"
                    },
                    {
                        "id": 85477,
                        "name": "Jacobabad",
                        "latitude": "28.28187000",
                        "longitude": "68.43761000"
                    },
                    {
                        "id": 85498,
                        "name": "Jām Sāhib",
                        "latitude": "26.29583000",
                        "longitude": "68.62917000"
                    },
                    {
                        "id": 85482,
                        "name": "Jamshoro",
                        "latitude": "25.43608000",
                        "longitude": "68.28017000"
                    },
                    {
                        "id": 85486,
                        "name": "Jati",
                        "latitude": "24.35492000",
                        "longitude": "68.26732000"
                    },
                    {
                        "id": 85494,
                        "name": "Jhol",
                        "latitude": "25.95533000",
                        "longitude": "68.88871000"
                    },
                    {
                        "id": 85496,
                        "name": "Johi",
                        "latitude": "26.69225000",
                        "longitude": "67.61431000"
                    },
                    {
                        "id": 85500,
                        "name": "Kadhan",
                        "latitude": "24.48041000",
                        "longitude": "68.98551000"
                    },
                    {
                        "id": 85514,
                        "name": "Kambar",
                        "latitude": "27.58753000",
                        "longitude": "68.00066000"
                    },
                    {
                        "id": 85517,
                        "name": "Kandhkot",
                        "latitude": "28.24574000",
                        "longitude": "69.17974000"
                    },
                    {
                        "id": 85518,
                        "name": "Kandiari",
                        "latitude": "26.91550000",
                        "longitude": "68.52193000"
                    },
                    {
                        "id": 85519,
                        "name": "Kandiaro",
                        "latitude": "27.05918000",
                        "longitude": "68.21022000"
                    },
                    {
                        "id": 85521,
                        "name": "Karachi",
                        "latitude": "24.86080000",
                        "longitude": "67.01040000"
                    },
                    {
                        "id": 85523,
                        "name": "Karaundi",
                        "latitude": "26.89709000",
                        "longitude": "68.40643000"
                    },
                    {
                        "id": 85524,
                        "name": "Kario Ghanwar",
                        "latitude": "24.80817000",
                        "longitude": "68.60483000"
                    },
                    {
                        "id": 85526,
                        "name": "Kashmor",
                        "latitude": "28.43260000",
                        "longitude": "69.58364000"
                    },
                    {
                        "id": 85529,
                        "name": "Keti Bandar",
                        "latitude": "24.14422000",
                        "longitude": "67.45094000"
                    },
                    {
                        "id": 85531,
                        "name": "Khadro",
                        "latitude": "26.14713000",
                        "longitude": "68.71777000"
                    },
                    {
                        "id": 85532,
                        "name": "Khairpur",
                        "latitude": "28.06437000",
                        "longitude": "69.70363000"
                    },
                    {
                        "id": 85533,
                        "name": "Khairpur Mir’s",
                        "latitude": "27.52948000",
                        "longitude": "68.75915000"
                    },
                    {
                        "id": 85534,
                        "name": "Khairpur Nathan Shah",
                        "latitude": "27.09064000",
                        "longitude": "67.73489000"
                    },
                    {
                        "id": 85542,
                        "name": "Khanpur Mahar",
                        "latitude": "27.84088000",
                        "longitude": "69.41302000"
                    },
                    {
                        "id": 85554,
                        "name": "Kot Diji",
                        "latitude": "27.34156000",
                        "longitude": "68.70821000"
                    },
                    {
                        "id": 85565,
                        "name": "Kotri",
                        "latitude": "25.36566000",
                        "longitude": "68.30831000"
                    },
                    {
                        "id": 85569,
                        "name": "Kunri",
                        "latitude": "25.17874000",
                        "longitude": "69.56572000"
                    },
                    {
                        "id": 85573,
                        "name": "Lakhi",
                        "latitude": "27.84884000",
                        "longitude": "68.69972000"
                    },
                    {
                        "id": 85578,
                        "name": "Larkana",
                        "latitude": "27.55898000",
                        "longitude": "68.21204000"
                    },
                    {
                        "id": 85587,
                        "name": "Madeji",
                        "latitude": "27.75314000",
                        "longitude": "68.45166000"
                    },
                    {
                        "id": 85591,
                        "name": "Malir Cantonment",
                        "latitude": "24.94343000",
                        "longitude": "67.20591000"
                    },
                    {
                        "id": 85601,
                        "name": "Matiari",
                        "latitude": "25.59709000",
                        "longitude": "68.44670000"
                    },
                    {
                        "id": 85602,
                        "name": "Matli",
                        "latitude": "25.04290000",
                        "longitude": "68.65591000"
                    },
                    {
                        "id": 85603,
                        "name": "Mehar",
                        "latitude": "27.18027000",
                        "longitude": "67.82051000"
                    },
                    {
                        "id": 85612,
                        "name": "Miro Khan",
                        "latitude": "27.75985000",
                        "longitude": "68.09195000"
                    },
                    {
                        "id": 85613,
                        "name": "Mirpur Bhtoro",
                        "latitude": "24.72852000",
                        "longitude": "68.26010000"
                    },
                    {
                        "id": 85615,
                        "name": "Mirpur Khas",
                        "latitude": "25.52760000",
                        "longitude": "69.01255000"
                    },
                    {
                        "id": 85616,
                        "name": "Mirpur Mathelo",
                        "latitude": "28.02136000",
                        "longitude": "69.54914000"
                    },
                    {
                        "id": 85617,
                        "name": "Mirpur Sakro",
                        "latitude": "24.54692000",
                        "longitude": "67.62797000"
                    },
                    {
                        "id": 85618,
                        "name": "Mirwah Gorchani",
                        "latitude": "25.30981000",
                        "longitude": "69.05019000"
                    },
                    {
                        "id": 85620,
                        "name": "Mithi",
                        "latitude": "24.73701000",
                        "longitude": "69.79707000"
                    },
                    {
                        "id": 85621,
                        "name": "Moro",
                        "latitude": "26.66317000",
                        "longitude": "68.00016000"
                    },
                    {
                        "id": 85630,
                        "name": "Nabisar",
                        "latitude": "25.06717000",
                        "longitude": "69.64340000"
                    },
                    {
                        "id": 85634,
                        "name": "Nasirabad",
                        "latitude": "27.38137000",
                        "longitude": "67.91644000"
                    },
                    {
                        "id": 85636,
                        "name": "Naudero",
                        "latitude": "27.66684000",
                        "longitude": "68.36090000"
                    },
                    {
                        "id": 85637,
                        "name": "Naukot",
                        "latitude": "24.85822000",
                        "longitude": "69.40153000"
                    },
                    {
                        "id": 85639,
                        "name": "Naushahro Firoz",
                        "latitude": "26.84010000",
                        "longitude": "68.12265000"
                    },
                    {
                        "id": 85640,
                        "name": "Nawabshah",
                        "latitude": "26.23939000",
                        "longitude": "68.40369000"
                    },
                    {
                        "id": 85642,
                        "name": "New Bādāh",
                        "latitude": "27.34167000",
                        "longitude": "68.03194000"
                    },
                    {
                        "id": 85653,
                        "name": "Pad Idan",
                        "latitude": "26.77455000",
                        "longitude": "68.30094000"
                    },
                    {
                        "id": 85657,
                        "name": "Pano Aqil",
                        "latitude": "27.85619000",
                        "longitude": "69.11111000"
                    },
                    {
                        "id": 85666,
                        "name": "Pir Jo Goth",
                        "latitude": "27.59178000",
                        "longitude": "68.61848000"
                    },
                    {
                        "id": 85669,
                        "name": "Pithoro",
                        "latitude": "25.51122000",
                        "longitude": "69.37803000"
                    },
                    {
                        "id": 85678,
                        "name": "Rajo Khanani",
                        "latitude": "24.98391000",
                        "longitude": "68.85370000"
                    },
                    {
                        "id": 85679,
                        "name": "Ranipur",
                        "latitude": "27.28720000",
                        "longitude": "68.50623000"
                    },
                    {
                        "id": 85681,
                        "name": "Ratodero",
                        "latitude": "27.80227000",
                        "longitude": "68.28902000"
                    },
                    {
                        "id": 85687,
                        "name": "Rohri",
                        "latitude": "27.69203000",
                        "longitude": "68.89503000"
                    },
                    {
                        "id": 85689,
                        "name": "Rustam",
                        "latitude": "27.96705000",
                        "longitude": "68.80386000"
                    },
                    {
                        "id": 85692,
                        "name": "Sakrand",
                        "latitude": "26.13845000",
                        "longitude": "68.27444000"
                    },
                    {
                        "id": 85693,
                        "name": "Samaro",
                        "latitude": "25.28143000",
                        "longitude": "69.39623000"
                    },
                    {
                        "id": 85695,
                        "name": "Sanghar",
                        "latitude": "26.04694000",
                        "longitude": "68.94917000"
                    },
                    {
                        "id": 85698,
                        "name": "Sann",
                        "latitude": "26.04030000",
                        "longitude": "68.13763000"
                    },
                    {
                        "id": 85703,
                        "name": "Sehwan",
                        "latitude": "26.42495000",
                        "longitude": "67.86126000"
                    },
                    {
                        "id": 85704,
                        "name": "Setharja Old",
                        "latitude": "27.21270000",
                        "longitude": "68.46883000"
                    },
                    {
                        "id": 85706,
                        "name": "Shahdad Kot",
                        "latitude": "27.84726000",
                        "longitude": "67.90679000"
                    },
                    {
                        "id": 85707,
                        "name": "Shahdadpur",
                        "latitude": "25.92539000",
                        "longitude": "68.62280000"
                    },
                    {
                        "id": 85710,
                        "name": "Shahpur Chakar",
                        "latitude": "26.15411000",
                        "longitude": "68.65013000"
                    },
                    {
                        "id": 85715,
                        "name": "Shikarpur",
                        "latitude": "27.95558000",
                        "longitude": "68.63823000"
                    },
                    {
                        "id": 85723,
                        "name": "Sinjhoro",
                        "latitude": "26.03008000",
                        "longitude": "68.80867000"
                    },
                    {
                        "id": 85734,
                        "name": "Sīta Road",
                        "latitude": "27.03333000",
                        "longitude": "67.85000000"
                    },
                    {
                        "id": 85725,
                        "name": "Sobhodero",
                        "latitude": "27.30475000",
                        "longitude": "68.39715000"
                    },
                    {
                        "id": 85730,
                        "name": "Sukkur",
                        "latitude": "27.70323000",
                        "longitude": "68.85889000"
                    },
                    {
                        "id": 85737,
                        "name": "Talhar",
                        "latitude": "24.88454000",
                        "longitude": "68.81437000"
                    },
                    {
                        "id": 85739,
                        "name": "Tando Adam",
                        "latitude": "25.76818000",
                        "longitude": "68.66196000"
                    },
                    {
                        "id": 85740,
                        "name": "Tando Allahyar",
                        "latitude": "25.46050000",
                        "longitude": "68.71745000"
                    },
                    {
                        "id": 85741,
                        "name": "Tando Bago",
                        "latitude": "24.78914000",
                        "longitude": "68.96535000"
                    },
                    {
                        "id": 85742,
                        "name": "Tando Jam",
                        "latitude": "25.42813000",
                        "longitude": "68.52923000"
                    },
                    {
                        "id": 85743,
                        "name": "Tando Mitha Khan",
                        "latitude": "25.99625000",
                        "longitude": "69.20251000"
                    },
                    {
                        "id": 85744,
                        "name": "Tando Muhammad Khan",
                        "latitude": "25.12384000",
                        "longitude": "68.53677000"
                    },
                    {
                        "id": 85746,
                        "name": "Tangwani",
                        "latitude": "28.27886000",
                        "longitude": "68.99760000"
                    },
                    {
                        "id": 85750,
                        "name": "Tharu Shah",
                        "latitude": "26.94230000",
                        "longitude": "68.11759000"
                    },
                    {
                        "id": 85751,
                        "name": "Thatta",
                        "latitude": "24.74745000",
                        "longitude": "67.92353000"
                    },
                    {
                        "id": 85752,
                        "name": "Thul",
                        "latitude": "28.24030000",
                        "longitude": "68.77550000"
                    },
                    {
                        "id": 85756,
                        "name": "Ubauro",
                        "latitude": "28.16429000",
                        "longitude": "69.73114000"
                    },
                    {
                        "id": 85757,
                        "name": "Umarkot",
                        "latitude": "25.36329000",
                        "longitude": "69.74184000"
                    },
                    {
                        "id": 85758,
                        "name": "Umerkot District",
                        "latitude": "25.37000000",
                        "longitude": "69.73000000"
                    },
                    {
                        "id": 85765,
                        "name": "Warah",
                        "latitude": "27.44805000",
                        "longitude": "67.79654000"
                    }
                ]
            }
        ]
    },
    {
        "id": 168,
        "name": "Palau",
        "iso3": "PLW",
        "iso2": "PW",
        "numeric_code": "585",
        "phonecode": "680",
        "capital": "Melekeok",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".pw",
        "native": "Palau",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Micronesia",
        "subregion_id": 21,
        "nationality": "Palauan",
        "timezones": [
            {
                "zoneName": "Pacific\/Palau",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "PWT",
                "tzName": "Palau Time"
            }
        ],
        "translations": {
            "br": "Palau",
            "ko": "팔라우",
            "pt-BR": "Palau",
            "pt": "Palau",
            "nl": "Palau",
            "hr": "Palau",
            "fa": "پالائو",
            "de": "Palau",
            "es": "Palau",
            "fr": "Palaos",
            "ja": "パラオ",
            "it": "Palau",
            "zh-CN": "帕劳",
            "tr": "Palau",
            "ru": "Палау",
            "uk": "Палау",
            "pl": "Palau"
        },
        "latitude": "7.50000000",
        "longitude": "134.50000000",
        "emoji": "🇵🇼",
        "emojiU": "U+1F1F5 U+1F1FC",
        "states": [
            {
                "id": 4540,
                "name": "Aimeliik",
                "iso2": "002",
                "latitude": "7.44558590",
                "longitude": "134.50308780",
                "type": "state",
                "cities": [
                    {
                        "id": 89709,
                        "name": "Ngchemiangel",
                        "latitude": "7.44613000",
                        "longitude": "134.47678000"
                    }
                ]
            },
            {
                "id": 4528,
                "name": "Airai",
                "iso2": "004",
                "latitude": "7.39661180",
                "longitude": "134.56902250",
                "type": "state",
                "cities": [
                    {
                        "id": 89712,
                        "name": "Ngetkib",
                        "latitude": "7.36451000",
                        "longitude": "134.51484000"
                    }
                ]
            },
            {
                "id": 4538,
                "name": "Angaur",
                "iso2": "010",
                "latitude": "6.90922300",
                "longitude": "134.13879340",
                "type": "state",
                "cities": [
                    {
                        "id": 89700,
                        "name": "Angaur State",
                        "latitude": "6.90601000",
                        "longitude": "134.12997000"
                    }
                ]
            },
            {
                "id": 4529,
                "name": "Hatohobei",
                "iso2": "050",
                "latitude": "3.00706580",
                "longitude": "131.12377810",
                "type": "state",
                "cities": [
                    {
                        "id": 89714,
                        "name": "Tobi Village",
                        "latitude": "3.00488000",
                        "longitude": "131.12168000"
                    }
                ]
            },
            {
                "id": 4539,
                "name": "Kayangel",
                "iso2": "100",
                "latitude": "8.07000000",
                "longitude": "134.70277800",
                "type": "state",
                "cities": [
                    {
                        "id": 89702,
                        "name": "Kayangel",
                        "latitude": "8.08228000",
                        "longitude": "134.71725000"
                    }
                ]
            },
            {
                "id": 4532,
                "name": "Koror",
                "iso2": "150",
                "latitude": "7.33756460",
                "longitude": "134.48894690",
                "type": "state",
                "cities": [
                    {
                        "id": 89704,
                        "name": "Koror",
                        "latitude": "7.33978000",
                        "longitude": "134.47326000"
                    },
                    {
                        "id": 89705,
                        "name": "Koror Town",
                        "latitude": "7.34257000",
                        "longitude": "134.47888000"
                    }
                ]
            },
            {
                "id": 4530,
                "name": "Melekeok",
                "iso2": "212",
                "latitude": "7.51502860",
                "longitude": "134.59725180",
                "type": "state",
                "cities": [
                    {
                        "id": 89706,
                        "name": "Melekeok Village",
                        "latitude": "7.49567000",
                        "longitude": "134.63671000"
                    }
                ]
            },
            {
                "id": 4537,
                "name": "Ngaraard",
                "iso2": "214",
                "latitude": "7.60794000",
                "longitude": "134.63486450",
                "type": "state",
                "cities": [
                    {
                        "id": 89715,
                        "name": "Ulimang",
                        "latitude": "7.62416000",
                        "longitude": "134.64208000"
                    }
                ]
            },
            {
                "id": 4533,
                "name": "Ngarchelong",
                "iso2": "218",
                "latitude": "7.71054690",
                "longitude": "134.63016460",
                "type": "state",
                "cities": [
                    {
                        "id": 89707,
                        "name": "Mengellang",
                        "latitude": "7.69570000",
                        "longitude": "134.63054000"
                    }
                ]
            },
            {
                "id": 4527,
                "name": "Ngardmau",
                "iso2": "222",
                "latitude": "7.58504860",
                "longitude": "134.55960890",
                "type": "state",
                "cities": [
                    {
                        "id": 89708,
                        "name": "Ngardmau",
                        "latitude": "7.60986000",
                        "longitude": "134.57440000"
                    }
                ]
            },
            {
                "id": 4531,
                "name": "Ngatpang",
                "iso2": "224",
                "latitude": "7.47109940",
                "longitude": "134.52664660",
                "type": "state",
                "cities": []
            },
            {
                "id": 4536,
                "name": "Ngchesar",
                "iso2": "226",
                "latitude": "7.45232800",
                "longitude": "134.57843420",
                "type": "state",
                "cities": [
                    {
                        "id": 89710,
                        "name": "Ngchesar Hamlet",
                        "latitude": "7.46932000",
                        "longitude": "134.60991000"
                    }
                ]
            },
            {
                "id": 4541,
                "name": "Ngeremlengui",
                "iso2": "227",
                "latitude": "7.51983970",
                "longitude": "134.55960890",
                "type": "state",
                "cities": [
                    {
                        "id": 89701,
                        "name": "Imeong Hamlet",
                        "latitude": "7.53134000",
                        "longitude": "134.52713000"
                    }
                ]
            },
            {
                "id": 4534,
                "name": "Ngiwal",
                "iso2": "228",
                "latitude": "7.56147640",
                "longitude": "134.61606190",
                "type": "state",
                "cities": [
                    {
                        "id": 89711,
                        "name": "Ngerkeai",
                        "latitude": "7.55456000",
                        "longitude": "134.63612000"
                    }
                ]
            },
            {
                "id": 4526,
                "name": "Peleliu",
                "iso2": "350",
                "latitude": "7.00229060",
                "longitude": "134.24316280",
                "type": "state",
                "cities": [
                    {
                        "id": 89703,
                        "name": "Kloulklubed",
                        "latitude": "7.04192000",
                        "longitude": "134.25561000"
                    }
                ]
            },
            {
                "id": 4535,
                "name": "Sonsorol",
                "iso2": "370",
                "latitude": "5.32681190",
                "longitude": "132.22391170",
                "type": "state",
                "cities": [
                    {
                        "id": 89713,
                        "name": "Sonsorol Village",
                        "latitude": "5.32608000",
                        "longitude": "132.21943000"
                    }
                ]
            }
        ]
    },
    {
        "id": 169,
        "name": "Palestinian Territory Occupied",
        "iso3": "PSE",
        "iso2": "PS",
        "numeric_code": "275",
        "phonecode": "970",
        "capital": "East Jerusalem",
        "currency": "ILS",
        "currency_name": "Israeli new shekel",
        "currency_symbol": "₪",
        "tld": ".ps",
        "native": "فلسطين",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Palestinian",
        "timezones": [
            {
                "zoneName": "Asia\/Gaza",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            },
            {
                "zoneName": "Asia\/Hebron",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Palestina",
            "ko": "팔레스타인 영토",
            "pt-BR": "Palestina",
            "pt": "Palestina",
            "nl": "Palestijnse gebieden",
            "hr": "Palestina",
            "fa": "فلسطین",
            "de": "Palästina",
            "es": "Palestina",
            "fr": "Palestine",
            "ja": "パレスチナ",
            "it": "Palestina",
            "zh-CN": "巴勒斯坦",
            "tr": "Filistin",
            "ru": "Оккупированная палестинская территория",
            "uk": "Окупована палестинська територія",
            "pl": "Okupowane terytorium palestyńskie"
        },
        "latitude": "31.90000000",
        "longitude": "35.20000000",
        "emoji": "🇵🇸",
        "emojiU": "U+1F1F5 U+1F1F8",
        "states": [
            {
                "id": 5118,
                "name": "Bethlehem",
                "iso2": "BTH",
                "latitude": "31.70539960",
                "longitude": "35.19368770",
                "type": "governorate",
                "cities": [
                    {
                        "id": 153955,
                        "name": "Al-Dawha",
                        "latitude": "31.69773990",
                        "longitude": "35.14595450"
                    },
                    {
                        "id": 153957,
                        "name": "al-Khader",
                        "latitude": "31.69484540",
                        "longitude": "35.15014530"
                    },
                    {
                        "id": 153960,
                        "name": "al-Ubeidiya",
                        "latitude": "31.72386430",
                        "longitude": "35.27122130"
                    },
                    {
                        "id": 153950,
                        "name": "Battir",
                        "latitude": "31.72821540",
                        "longitude": "35.11743230"
                    },
                    {
                        "id": 153951,
                        "name": "Beit Fajjar",
                        "latitude": "31.62166990",
                        "longitude": "35.13430330"
                    },
                    {
                        "id": 153952,
                        "name": "Beit Jala",
                        "latitude": "31.71603340",
                        "longitude": "35.16654930"
                    },
                    {
                        "id": 153953,
                        "name": "Beit Sahour",
                        "latitude": "31.69787040",
                        "longitude": "35.20793030"
                    },
                    {
                        "id": 153954,
                        "name": "Bethlehem",
                        "latitude": "31.70541650",
                        "longitude": "35.18184280"
                    },
                    {
                        "id": 153956,
                        "name": "Husan",
                        "latitude": "31.70846040",
                        "longitude": "35.11282530"
                    },
                    {
                        "id": 153958,
                        "name": "Nahalin",
                        "latitude": "31.68564240",
                        "longitude": "35.09976230"
                    },
                    {
                        "id": 153959,
                        "name": "Tuqu'",
                        "latitude": "31.63912740",
                        "longitude": "35.19189030"
                    },
                    {
                        "id": 153961,
                        "name": "Za'atara",
                        "latitude": "31.67447840",
                        "longitude": "35.23449130"
                    }
                ]
            },
            {
                "id": 5119,
                "name": "Deir El Balah",
                "iso2": "DEB",
                "latitude": "31.42028970",
                "longitude": "34.28616400",
                "type": "governorate",
                "cities": [
                    {
                        "id": 153963,
                        "name": "az-Zawayda",
                        "latitude": "31.42979750",
                        "longitude": "34.35014230"
                    },
                    {
                        "id": 153962,
                        "name": "Deir al-Balah",
                        "latitude": "31.41717350",
                        "longitude": "34.33033130"
                    }
                ]
            },
            {
                "id": 5120,
                "name": "Gaza",
                "iso2": "GZA",
                "latitude": "31.48723970",
                "longitude": "34.14998900",
                "type": "governorate",
                "cities": [
                    {
                        "id": 153965,
                        "name": "Al-Zahra",
                        "latitude": "31.47246750",
                        "longitude": "34.37782930"
                    },
                    {
                        "id": 153964,
                        "name": "Gaza City",
                        "latitude": "31.50172950",
                        "longitude": "34.44624480"
                    }
                ]
            },
            {
                "id": 5121,
                "name": "Hebron",
                "iso2": "HBN",
                "latitude": "31.53260010",
                "longitude": "35.06394750",
                "type": "governorate",
                "cities": [
                    {
                        "id": 153970,
                        "name": "ad-Dhahiriya",
                        "latitude": "31.40967250",
                        "longitude": "34.95490830"
                    },
                    {
                        "id": 153980,
                        "name": "as-Samu",
                        "latitude": "31.39864450",
                        "longitude": "35.04468830"
                    },
                    {
                        "id": 153971,
                        "name": "Bani Na'im",
                        "latitude": "31.51490050",
                        "longitude": "35.14474030"
                    },
                    {
                        "id": 153972,
                        "name": "Beit 'Awwa",
                        "latitude": "31.50675240",
                        "longitude": "34.92956130"
                    },
                    {
                        "id": 153973,
                        "name": "Beit Ula",
                        "latitude": "31.59845640",
                        "longitude": "35.00577530"
                    },
                    {
                        "id": 153974,
                        "name": "Beit Ummar",
                        "latitude": "31.62284640",
                        "longitude": "35.08159930"
                    },
                    {
                        "id": 153975,
                        "name": "Deir Sammit",
                        "latitude": "31.51996340",
                        "longitude": "34.95207130"
                    },
                    {
                        "id": 153966,
                        "name": "Dura",
                        "latitude": "31.50512740",
                        "longitude": "35.00692730"
                    },
                    {
                        "id": 153967,
                        "name": "Halhul",
                        "latitude": "31.57992420",
                        "longitude": "35.07930450"
                    },
                    {
                        "id": 153968,
                        "name": "Hebron",
                        "latitude": "31.53260350",
                        "longitude": "35.07922630"
                    },
                    {
                        "id": 153976,
                        "name": "Idhna",
                        "latitude": "31.55728640",
                        "longitude": "34.95864330"
                    },
                    {
                        "id": 153977,
                        "name": "Kharas",
                        "latitude": "31.61225240",
                        "longitude": "35.02365130"
                    },
                    {
                        "id": 153978,
                        "name": "Nuba",
                        "latitude": "31.61382080",
                        "longitude": "35.00579200"
                    },
                    {
                        "id": 153979,
                        "name": "Sa'ir",
                        "latitude": "31.58248950",
                        "longitude": "35.12317630"
                    },
                    {
                        "id": 153981,
                        "name": "Surif",
                        "latitude": "31.64958640",
                        "longitude": "35.04411230"
                    },
                    {
                        "id": 153983,
                        "name": "Taffuh",
                        "latitude": "31.53848250",
                        "longitude": "35.03037330"
                    },
                    {
                        "id": 153982,
                        "name": "Tarqumiya",
                        "latitude": "31.57736440",
                        "longitude": "34.99357430"
                    },
                    {
                        "id": 153969,
                        "name": "Yatta",
                        "latitude": "31.44418450",
                        "longitude": "35.06950530"
                    }
                ]
            },
            {
                "id": 5122,
                "name": "Jenin",
                "iso2": "JEN",
                "latitude": "32.42637610",
                "longitude": "35.08568870",
                "type": "governorate",
                "cities": [
                    {
                        "id": 153986,
                        "name": "Ajjah",
                        "latitude": "32.36001710",
                        "longitude": "35.17739430"
                    },
                    {
                        "id": 153997,
                        "name": "al-Yamun",
                        "latitude": "32.48671110",
                        "longitude": "35.21299230"
                    },
                    {
                        "id": 153987,
                        "name": "Arrabah",
                        "latitude": "32.40331010",
                        "longitude": "35.18531430"
                    },
                    {
                        "id": 153988,
                        "name": "Burqin",
                        "latitude": "32.45616900",
                        "longitude": "35.24108830"
                    },
                    {
                        "id": 153989,
                        "name": "Deir Abu Da'if",
                        "latitude": "32.45609510",
                        "longitude": "35.34432230"
                    },
                    {
                        "id": 153990,
                        "name": "Jaba",
                        "latitude": "32.32506110",
                        "longitude": "35.19956430"
                    },
                    {
                        "id": 153984,
                        "name": "Jenin",
                        "latitude": "32.45728400",
                        "longitude": "35.28161440"
                    },
                    {
                        "id": 153991,
                        "name": "Kafr Dan",
                        "latitude": "32.47801110",
                        "longitude": "35.23318730"
                    },
                    {
                        "id": 153992,
                        "name": "Kafr Rai",
                        "latitude": "32.37345210",
                        "longitude": "35.13493630"
                    },
                    {
                        "id": 153993,
                        "name": "Meithalun",
                        "latitude": "32.34924410",
                        "longitude": "35.25088430"
                    },
                    {
                        "id": 153985,
                        "name": "Qabatiya",
                        "latitude": "32.40961710",
                        "longitude": "35.25949330"
                    },
                    {
                        "id": 153995,
                        "name": "Silat ad-Dhahr",
                        "latitude": "32.31753210",
                        "longitude": "35.16663230"
                    },
                    {
                        "id": 153994,
                        "name": "Silat al-Harithiya",
                        "latitude": "32.50979700",
                        "longitude": "35.20684730"
                    },
                    {
                        "id": 153996,
                        "name": "Ya'bad",
                        "latitude": "32.44686800",
                        "longitude": "35.14667430"
                    },
                    {
                        "id": 153998,
                        "name": "Zababdeh",
                        "latitude": "32.38523610",
                        "longitude": "35.30287930"
                    }
                ]
            },
            {
                "id": 5123,
                "name": "Jericho ",
                "iso2": "JRH",
                "latitude": "31.96764250",
                "longitude": "35.13542790",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154000,
                        "name": "al-Auja",
                        "latitude": "31.94809930",
                        "longitude": "35.45056430"
                    },
                    {
                        "id": 154001,
                        "name": "al-Jiftlik",
                        "latitude": "32.14143230",
                        "longitude": "35.44660250"
                    },
                    {
                        "id": 153999,
                        "name": "Jericho",
                        "latitude": "31.85950700",
                        "longitude": "35.44390820"
                    }
                ]
            },
            {
                "id": 5124,
                "name": "Jerusalem (Quds)",
                "iso2": "JEM",
                "latitude": "31.80203280",
                "longitude": "34.95996640",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154003,
                        "name": "Abu Dis",
                        "latitude": "31.76361630",
                        "longitude": "35.23712230"
                    },
                    {
                        "id": 154004,
                        "name": "Ar-Ram",
                        "latitude": "31.84928630",
                        "longitude": "35.21288930"
                    },
                    {
                        "id": 154006,
                        "name": "Beit 'Anan",
                        "latitude": "31.85109930",
                        "longitude": "35.09111930"
                    },
                    {
                        "id": 154005,
                        "name": "Biddu",
                        "latitude": "31.83445820",
                        "longitude": "35.07441730"
                    },
                    {
                        "id": 154007,
                        "name": "Bir Nabala",
                        "latitude": "31.85121630",
                        "longitude": "35.18023530"
                    },
                    {
                        "id": 154002,
                        "name": "East Jerusalem",
                        "latitude": "31.79650430",
                        "longitude": "35.01054340"
                    },
                    {
                        "id": 154008,
                        "name": "Hizma",
                        "latitude": "31.83649540",
                        "longitude": "35.24263130"
                    },
                    {
                        "id": 154009,
                        "name": "Kafr Aqab",
                        "latitude": "31.87472270",
                        "longitude": "35.21724000"
                    },
                    {
                        "id": 154011,
                        "name": "Qalandiya",
                        "latitude": "31.86163130",
                        "longitude": "35.18731430"
                    },
                    {
                        "id": 154010,
                        "name": "Qatanna",
                        "latitude": "31.82695730",
                        "longitude": "35.08960030"
                    }
                ]
            },
            {
                "id": 5125,
                "name": "Khan Yunis",
                "iso2": "KYS",
                "latitude": "31.32987660",
                "longitude": "34.22548330",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154012,
                        "name": "Abasan al-Kabira",
                        "latitude": "31.32316050",
                        "longitude": "34.32342530"
                    },
                    {
                        "id": 154015,
                        "name": "Abasan al-Saghira",
                        "latitude": "31.33974350",
                        "longitude": "34.32603330"
                    },
                    {
                        "id": 154017,
                        "name": "Al-Qarara",
                        "latitude": "31.37134650",
                        "longitude": "34.31466030"
                    },
                    {
                        "id": 154013,
                        "name": "Bani Suheila",
                        "latitude": "31.34213850",
                        "longitude": "34.30465430"
                    },
                    {
                        "id": 154014,
                        "name": "Khan Yunis",
                        "latitude": "31.34623510",
                        "longitude": "34.28339890"
                    },
                    {
                        "id": 154016,
                        "name": "Khuzaʽa",
                        "latitude": "31.30705660",
                        "longitude": "34.33944730"
                    }
                ]
            },
            {
                "id": 5126,
                "name": "Nablus",
                "iso2": "NBS",
                "latitude": "32.22437550",
                "longitude": "35.20647930",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154019,
                        "name": "Aqraba",
                        "latitude": "32.12762020",
                        "longitude": "35.32213530"
                    },
                    {
                        "id": 154020,
                        "name": "Asira ash-Shamaliya",
                        "latitude": "32.25186910",
                        "longitude": "35.24757130"
                    },
                    {
                        "id": 154026,
                        "name": "Beit Furik",
                        "latitude": "32.17549020",
                        "longitude": "35.31588430"
                    },
                    {
                        "id": 154021,
                        "name": "Beita",
                        "latitude": "32.14137420",
                        "longitude": "35.26579930"
                    },
                    {
                        "id": 154022,
                        "name": "Huwara",
                        "latitude": "32.15134720",
                        "longitude": "35.23619930"
                    },
                    {
                        "id": 154023,
                        "name": "Jammain",
                        "latitude": "32.13211420",
                        "longitude": "35.18274230"
                    },
                    {
                        "id": 154018,
                        "name": "Nablus",
                        "latitude": "32.22437550",
                        "longitude": "35.20647930"
                    },
                    {
                        "id": 154024,
                        "name": "Qabalan",
                        "latitude": "32.10185420",
                        "longitude": "35.26712930"
                    },
                    {
                        "id": 154025,
                        "name": "Sebastia",
                        "latitude": "32.27827510",
                        "longitude": "35.17803330"
                    }
                ]
            },
            {
                "id": 5127,
                "name": "North Gaza",
                "iso2": "NGZ",
                "latitude": "31.54750600",
                "longitude": "34.42814090",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154027,
                        "name": "Beit Hanoun",
                        "latitude": "31.53851740",
                        "longitude": "34.51617030"
                    },
                    {
                        "id": 154028,
                        "name": "Beit Lahia",
                        "latitude": "31.55132340",
                        "longitude": "34.48862230"
                    },
                    {
                        "id": 154029,
                        "name": "Izbat Beit Hanoun",
                        "latitude": "31.54728950",
                        "longitude": "34.50197220"
                    },
                    {
                        "id": 154030,
                        "name": "Jabalia",
                        "latitude": "31.52943050",
                        "longitude": "34.45914130"
                    }
                ]
            },
            {
                "id": 5128,
                "name": "Qalqilya",
                "iso2": "QQA",
                "latitude": "32.18103230",
                "longitude": "34.99369990",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154031,
                        "name": "Azzun",
                        "latitude": "32.17713520",
                        "longitude": "35.03535730"
                    },
                    {
                        "id": 154032,
                        "name": "Hableh",
                        "latitude": "32.16387820",
                        "longitude": "34.95768030"
                    },
                    {
                        "id": 154034,
                        "name": "Kafr Thulth",
                        "latitude": "32.15283320",
                        "longitude": "35.02469030"
                    },
                    {
                        "id": 154033,
                        "name": "Qalqilya",
                        "latitude": "32.19604910",
                        "longitude": "34.96091330"
                    }
                ]
            },
            {
                "id": 5129,
                "name": "Rafah",
                "iso2": "RFH",
                "latitude": "31.29688990",
                "longitude": "34.11166850",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154037,
                        "name": "Al Qarya as Suwaydiya",
                        "latitude": "31.32316550",
                        "longitude": "34.20157530"
                    },
                    {
                        "id": 154035,
                        "name": "Al-Bayuk",
                        "latitude": "31.26347860",
                        "longitude": "34.26098130"
                    },
                    {
                        "id": 154036,
                        "name": "Al-Mawasi",
                        "latitude": "31.34844960",
                        "longitude": "34.23553630"
                    },
                    {
                        "id": 154038,
                        "name": "Rafah ",
                        "latitude": "31.29681450",
                        "longitude": "34.22288230"
                    },
                    {
                        "id": 154039,
                        "name": "Shokat as-Sufi",
                        "latitude": "31.25091250",
                        "longitude": "34.24516720"
                    }
                ]
            },
            {
                "id": 5130,
                "name": "Ramallah",
                "iso2": "RBH",
                "latitude": "31.94301450",
                "longitude": "34.86456510",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154040,
                        "name": "Al-Bireh",
                        "latitude": "31.91259730",
                        "longitude": "35.20111730"
                    },
                    {
                        "id": 154050,
                        "name": "al-Mazra'a ash-Sharqiya",
                        "latitude": "32.00327220",
                        "longitude": "35.25553230"
                    },
                    {
                        "id": 154044,
                        "name": "Bani Zeid al-Sharqiya",
                        "latitude": "32.04074320",
                        "longitude": "35.15327830"
                    },
                    {
                        "id": 154045,
                        "name": "Beit Liqya",
                        "latitude": "31.86997130",
                        "longitude": "35.04460230"
                    },
                    {
                        "id": 154042,
                        "name": "Beitunia",
                        "latitude": "31.88931530",
                        "longitude": "35.14921330"
                    },
                    {
                        "id": 154046,
                        "name": "Bir Zeit",
                        "latitude": "31.97534830",
                        "longitude": "35.17544230"
                    },
                    {
                        "id": 154047,
                        "name": "Deir Dibwan",
                        "latitude": "31.91123930",
                        "longitude": "35.24838830"
                    },
                    {
                        "id": 154048,
                        "name": "Deir Jarir",
                        "latitude": "31.96564630",
                        "longitude": "35.27317630"
                    },
                    {
                        "id": 154049,
                        "name": "Kharbatha al-Misbah",
                        "latitude": "31.88530030",
                        "longitude": "35.05147330"
                    },
                    {
                        "id": 154051,
                        "name": "Ni'lin",
                        "latitude": "31.94687730",
                        "longitude": "35.00086130"
                    },
                    {
                        "id": 154041,
                        "name": "Ramallah",
                        "latitude": "31.90741710",
                        "longitude": "35.16468200"
                    },
                    {
                        "id": 154043,
                        "name": "Rawabi",
                        "latitude": "32.01021570",
                        "longitude": "35.17129410"
                    },
                    {
                        "id": 154052,
                        "name": "Silwad",
                        "latitude": "31.97942420",
                        "longitude": "35.24126530"
                    },
                    {
                        "id": 154053,
                        "name": "Sinjil",
                        "latitude": "32.03364130",
                        "longitude": "35.24333530"
                    },
                    {
                        "id": 154054,
                        "name": "Turmus Ayya",
                        "latitude": "32.03276020",
                        "longitude": "35.26777530"
                    }
                ]
            },
            {
                "id": 5131,
                "name": "Salfit",
                "iso2": "SLT",
                "latitude": "32.11122720",
                "longitude": "34.95787690",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154071,
                        "name": "az-Zawiya",
                        "latitude": "32.09470520",
                        "longitude": "35.01867630"
                    },
                    {
                        "id": 154055,
                        "name": "Biddya",
                        "latitude": "32.11340020",
                        "longitude": "35.05686530"
                    },
                    {
                        "id": 154056,
                        "name": "Bruqin",
                        "latitude": "32.07264720",
                        "longitude": "35.07780630"
                    },
                    {
                        "id": 154057,
                        "name": "Deir Ballut",
                        "latitude": "32.06506720",
                        "longitude": "35.00494930"
                    },
                    {
                        "id": 154058,
                        "name": "Deir Istiya",
                        "latitude": "32.13079620",
                        "longitude": "35.11953630"
                    },
                    {
                        "id": 154059,
                        "name": "Farkha",
                        "latitude": "32.06877720",
                        "longitude": "35.13027630"
                    },
                    {
                        "id": 154060,
                        "name": "Haris",
                        "latitude": "32.11344920",
                        "longitude": "35.12311630"
                    },
                    {
                        "id": 154061,
                        "name": "Iskaka",
                        "latitude": "32.10295520",
                        "longitude": "35.20394930"
                    },
                    {
                        "id": 154062,
                        "name": "Kafr ad-Dik",
                        "latitude": "32.06863540",
                        "longitude": "35.06050810"
                    },
                    {
                        "id": 154063,
                        "name": "Kifl Hares",
                        "latitude": "32.11692420",
                        "longitude": "35.13636430"
                    },
                    {
                        "id": 154064,
                        "name": "Marda",
                        "latitude": "32.11425120",
                        "longitude": "35.17525130"
                    },
                    {
                        "id": 154065,
                        "name": "Mas-ha",
                        "latitude": "32.10729820",
                        "longitude": "35.03037430"
                    },
                    {
                        "id": 154066,
                        "name": "Qarawat Bani Hassan",
                        "latitude": "32.12853920",
                        "longitude": "35.07877830"
                    },
                    {
                        "id": 154067,
                        "name": "Qira",
                        "latitude": "32.12213420",
                        "longitude": "35.15063230"
                    },
                    {
                        "id": 154068,
                        "name": "Rafat",
                        "latitude": "32.07872020",
                        "longitude": "35.02468730"
                    },
                    {
                        "id": 154069,
                        "name": "Sarta",
                        "latitude": "32.10336920",
                        "longitude": "35.07123830"
                    },
                    {
                        "id": 154070,
                        "name": "Yasuf",
                        "latitude": "32.10940520",
                        "longitude": "35.21911530"
                    }
                ]
            },
            {
                "id": 5132,
                "name": "Tubas",
                "iso2": "TBS",
                "latitude": "32.29380430",
                "longitude": "34.85109800",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154073,
                        "name": "'Aqqaba",
                        "latitude": "32.35257060",
                        "longitude": "35.32674760"
                    },
                    {
                        "id": 154074,
                        "name": "Tammun",
                        "latitude": "32.28315510",
                        "longitude": "35.36518930"
                    },
                    {
                        "id": 154072,
                        "name": "Tubas",
                        "latitude": "32.32112010",
                        "longitude": "35.34935330"
                    }
                ]
            },
            {
                "id": 5133,
                "name": "Tulkarm",
                "iso2": "TKM",
                "latitude": "32.32766720",
                "longitude": "34.92311080",
                "type": "governorate",
                "cities": [
                    {
                        "id": 154075,
                        "name": "Anabta",
                        "latitude": "32.30728710",
                        "longitude": "35.09887830"
                    },
                    {
                        "id": 154076,
                        "name": "Attil",
                        "latitude": "32.37010310",
                        "longitude": "35.05193830"
                    },
                    {
                        "id": 154077,
                        "name": "Bal'a",
                        "latitude": "32.33255610",
                        "longitude": "35.08935330"
                    },
                    {
                        "id": 154078,
                        "name": "Baqa ash-Sharqiyya",
                        "latitude": "32.41117510",
                        "longitude": "35.05059330"
                    },
                    {
                        "id": 154079,
                        "name": "Beit Lid",
                        "latitude": "32.26158210",
                        "longitude": "35.10968030"
                    },
                    {
                        "id": 154080,
                        "name": "Qaffin",
                        "latitude": "32.43341200",
                        "longitude": "35.06370030"
                    },
                    {
                        "id": 154081,
                        "name": "Tulkarm",
                        "latitude": "32.30796480",
                        "longitude": "35.00802890"
                    }
                ]
            }
        ]
    },
    {
        "id": 170,
        "name": "Panama",
        "iso3": "PAN",
        "iso2": "PA",
        "numeric_code": "591",
        "phonecode": "507",
        "capital": "Panama City",
        "currency": "PAB",
        "currency_name": "Panamanian balboa",
        "currency_symbol": "B\/.",
        "tld": ".pa",
        "native": "Panamá",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Central America",
        "subregion_id": 9,
        "nationality": "Panamanian",
        "timezones": [
            {
                "zoneName": "America\/Panama",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Panamá",
            "ko": "파나마",
            "pt-BR": "Panamá",
            "pt": "Panamá",
            "nl": "Panama",
            "hr": "Panama",
            "fa": "پاناما",
            "de": "Panama",
            "es": "Panamá",
            "fr": "Panama",
            "ja": "パナマ",
            "it": "Panama",
            "zh-CN": "巴拿马",
            "tr": "Panama",
            "ru": "Панама",
            "uk": "Панама",
            "pl": "Panama"
        },
        "latitude": "9.00000000",
        "longitude": "-80.00000000",
        "emoji": "🇵🇦",
        "emojiU": "U+1F1F5 U+1F1E6",
        "states": [
            {
                "id": 1393,
                "name": "Bocas del Toro",
                "iso2": "1",
                "latitude": "9.41655210",
                "longitude": "-82.52077870",
                "type": "province",
                "cities": [
                    {
                        "id": 79962,
                        "name": "Almirante",
                        "latitude": "9.30091000",
                        "longitude": "-82.40180000"
                    },
                    {
                        "id": 79982,
                        "name": "Barranco",
                        "latitude": "9.51984000",
                        "longitude": "-82.70424000"
                    },
                    {
                        "id": 79983,
                        "name": "Barranco Adentro",
                        "latitude": "9.52757000",
                        "longitude": "-82.73344000"
                    },
                    {
                        "id": 79986,
                        "name": "Bastimentos",
                        "latitude": "9.34707000",
                        "longitude": "-82.20880000"
                    },
                    {
                        "id": 80000,
                        "name": "Bocas del Toro",
                        "latitude": "9.34031000",
                        "longitude": "-82.24204000"
                    },
                    {
                        "id": 80036,
                        "name": "Cauchero",
                        "latitude": "9.15226000",
                        "longitude": "-82.26450000"
                    },
                    {
                        "id": 80054,
                        "name": "Changuinola",
                        "latitude": "9.43000000",
                        "longitude": "-82.52000000"
                    },
                    {
                        "id": 80063,
                        "name": "Chiriquí Grande",
                        "latitude": "8.94557000",
                        "longitude": "-82.11769000"
                    },
                    {
                        "id": 80084,
                        "name": "Distrito Chiriquí Grande",
                        "latitude": "8.94748000",
                        "longitude": "-82.12418000"
                    },
                    {
                        "id": 80092,
                        "name": "Distrito de Bocas del Toro",
                        "latitude": "9.36235000",
                        "longitude": "-82.26288000"
                    },
                    {
                        "id": 80101,
                        "name": "Distrito de Changuinola",
                        "latitude": "9.25000000",
                        "longitude": "-82.63333000"
                    },
                    {
                        "id": 80170,
                        "name": "El Empalme",
                        "latitude": "9.41667000",
                        "longitude": "-82.51667000"
                    },
                    {
                        "id": 80202,
                        "name": "El Silencio",
                        "latitude": "9.37222000",
                        "longitude": "-82.52877000"
                    },
                    {
                        "id": 80217,
                        "name": "Guabito",
                        "latitude": "9.48968000",
                        "longitude": "-82.61279000"
                    },
                    {
                        "id": 80235,
                        "name": "Isla Bastimentos",
                        "latitude": "9.30000000",
                        "longitude": "-82.13333000"
                    },
                    {
                        "id": 80265,
                        "name": "La Mesa",
                        "latitude": "9.49587000",
                        "longitude": "-82.67534000"
                    },
                    {
                        "id": 80355,
                        "name": "Miramar",
                        "latitude": "8.99482000",
                        "longitude": "-82.24147000"
                    },
                    {
                        "id": 80437,
                        "name": "Punta Laurel",
                        "latitude": "9.14100000",
                        "longitude": "-82.12717000"
                    },
                    {
                        "id": 80438,
                        "name": "Punta Peña",
                        "latitude": "8.91659000",
                        "longitude": "-82.18488000"
                    },
                    {
                        "id": 80439,
                        "name": "Punta Róbalo",
                        "latitude": "9.03631000",
                        "longitude": "-82.24952000"
                    },
                    {
                        "id": 80537,
                        "name": "Valle del Risco",
                        "latitude": "9.23064000",
                        "longitude": "-82.42748000"
                    }
                ]
            },
            {
                "id": 1397,
                "name": "Chiriquí Province",
                "iso2": "4",
                "latitude": "8.58489800",
                "longitude": "-82.38857830",
                "type": "province",
                "cities": [
                    {
                        "id": 79959,
                        "name": "Alanje",
                        "latitude": "8.39791000",
                        "longitude": "-82.55947000"
                    },
                    {
                        "id": 79961,
                        "name": "Algarrobos Arriba",
                        "latitude": "8.51550000",
                        "longitude": "-82.42263000"
                    },
                    {
                        "id": 79963,
                        "name": "Alto Boquete",
                        "latitude": "8.73458000",
                        "longitude": "-82.43213000"
                    },
                    {
                        "id": 79974,
                        "name": "Aserrío de Gariché",
                        "latitude": "8.48257000",
                        "longitude": "-82.79086000"
                    },
                    {
                        "id": 80012,
                        "name": "Bágala",
                        "latitude": "8.46399000",
                        "longitude": "-82.52617000"
                    },
                    {
                        "id": 79979,
                        "name": "Bajo Boquete",
                        "latitude": "8.77058000",
                        "longitude": "-82.43306000"
                    },
                    {
                        "id": 79985,
                        "name": "Barrio Guadalupe",
                        "latitude": "8.86482000",
                        "longitude": "-82.56523000"
                    },
                    {
                        "id": 79992,
                        "name": "Bijagual",
                        "latitude": "8.51486000",
                        "longitude": "-82.33361000"
                    },
                    {
                        "id": 79995,
                        "name": "Boca Chica",
                        "latitude": "8.21911000",
                        "longitude": "-82.21592000"
                    },
                    {
                        "id": 79999,
                        "name": "Boca del Monte",
                        "latitude": "8.35296000",
                        "longitude": "-82.11379000"
                    },
                    {
                        "id": 80002,
                        "name": "Boquerón",
                        "latitude": "8.50510000",
                        "longitude": "-82.57025000"
                    },
                    {
                        "id": 80003,
                        "name": "Boquete",
                        "latitude": "8.78024000",
                        "longitude": "-82.44136000"
                    },
                    {
                        "id": 80005,
                        "name": "Breñón",
                        "latitude": "8.62491000",
                        "longitude": "-82.81277000"
                    },
                    {
                        "id": 80010,
                        "name": "Bugaba",
                        "latitude": "8.48255000",
                        "longitude": "-82.61991000"
                    },
                    {
                        "id": 80011,
                        "name": "Bugabita Arriba",
                        "latitude": "8.52143000",
                        "longitude": "-82.63638000"
                    },
                    {
                        "id": 80021,
                        "name": "Caimito",
                        "latitude": "8.54162000",
                        "longitude": "-82.41900000"
                    },
                    {
                        "id": 80023,
                        "name": "Caldera",
                        "latitude": "8.64907000",
                        "longitude": "-82.38058000"
                    },
                    {
                        "id": 80038,
                        "name": "Cañas Gordas",
                        "latitude": "8.74309000",
                        "longitude": "-82.91275000"
                    },
                    {
                        "id": 80043,
                        "name": "Celmira",
                        "latitude": "8.54026000",
                        "longitude": "-82.80022000"
                    },
                    {
                        "id": 80051,
                        "name": "Cerro Punta",
                        "latitude": "8.84968000",
                        "longitude": "-82.57261000"
                    },
                    {
                        "id": 80052,
                        "name": "Cerro Viejo",
                        "latitude": "8.25349000",
                        "longitude": "-81.57658000"
                    },
                    {
                        "id": 80062,
                        "name": "Chiriquí",
                        "latitude": "8.39291000",
                        "longitude": "-82.31993000"
                    },
                    {
                        "id": 80070,
                        "name": "Cochea Abajo",
                        "latitude": "8.50512000",
                        "longitude": "-82.35878000"
                    },
                    {
                        "id": 80075,
                        "name": "Cordillera",
                        "latitude": "8.70683000",
                        "longitude": "-82.60327000"
                    },
                    {
                        "id": 80082,
                        "name": "David",
                        "latitude": "8.42729000",
                        "longitude": "-82.43085000"
                    },
                    {
                        "id": 80087,
                        "name": "Distrito de Alanje",
                        "latitude": "8.39842000",
                        "longitude": "-82.64065000"
                    },
                    {
                        "id": 80091,
                        "name": "Distrito de Barú",
                        "latitude": "8.29482000",
                        "longitude": "-82.92726000"
                    },
                    {
                        "id": 80093,
                        "name": "Distrito de Boquerón",
                        "latitude": "8.61667000",
                        "longitude": "-82.56667000"
                    },
                    {
                        "id": 80094,
                        "name": "Distrito de Boquete",
                        "latitude": "8.74896000",
                        "longitude": "-82.36842000"
                    },
                    {
                        "id": 80095,
                        "name": "Distrito de Bugaba",
                        "latitude": "8.68786000",
                        "longitude": "-82.67937000"
                    },
                    {
                        "id": 80107,
                        "name": "Distrito de David",
                        "latitude": "8.40000000",
                        "longitude": "-82.40000000"
                    },
                    {
                        "id": 80108,
                        "name": "Distrito de Dolega",
                        "latitude": "8.61667000",
                        "longitude": "-82.45000000"
                    },
                    {
                        "id": 80110,
                        "name": "Distrito de Gualaca",
                        "latitude": "8.57398000",
                        "longitude": "-82.22207000"
                    },
                    {
                        "id": 80132,
                        "name": "Distrito de Remedios",
                        "latitude": "8.20253000",
                        "longitude": "-81.81163000"
                    },
                    {
                        "id": 80133,
                        "name": "Distrito de Renacimiento",
                        "latitude": "8.71667000",
                        "longitude": "-82.76667000"
                    },
                    {
                        "id": 80137,
                        "name": "Distrito de San Félix",
                        "latitude": "8.27768000",
                        "longitude": "-81.87377000"
                    },
                    {
                        "id": 80138,
                        "name": "Distrito de San Lorenzo",
                        "latitude": "8.29366000",
                        "longitude": "-82.08922000"
                    },
                    {
                        "id": 80145,
                        "name": "Distrito de Tolé",
                        "latitude": "8.19015000",
                        "longitude": "-81.66007000"
                    },
                    {
                        "id": 80147,
                        "name": "Divalá",
                        "latitude": "8.41066000",
                        "longitude": "-82.71332000"
                    },
                    {
                        "id": 80148,
                        "name": "Dolega District",
                        "latitude": "8.56667000",
                        "longitude": "-82.41407000"
                    },
                    {
                        "id": 80185,
                        "name": "El Nancito",
                        "latitude": "8.23811000",
                        "longitude": "-81.73218000"
                    },
                    {
                        "id": 80186,
                        "name": "El Palmar",
                        "latitude": "8.30098000",
                        "longitude": "-82.85344000"
                    },
                    {
                        "id": 80193,
                        "name": "El Porvenir",
                        "latitude": "8.22919000",
                        "longitude": "-81.83278000"
                    },
                    {
                        "id": 80203,
                        "name": "El Tejar",
                        "latitude": "8.42973000",
                        "longitude": "-82.57294000"
                    },
                    {
                        "id": 80210,
                        "name": "Finca Blanco",
                        "latitude": "8.37979000",
                        "longitude": "-82.87385000"
                    },
                    {
                        "id": 80229,
                        "name": "Gómez",
                        "latitude": "8.56085000",
                        "longitude": "-82.74142000"
                    },
                    {
                        "id": 80216,
                        "name": "Guabal",
                        "latitude": "8.57466000",
                        "longitude": "-82.53730000"
                    },
                    {
                        "id": 80218,
                        "name": "Guaca Arriba",
                        "latitude": "8.53733000",
                        "longitude": "-82.49281000"
                    },
                    {
                        "id": 80220,
                        "name": "Gualaca",
                        "latitude": "8.53006000",
                        "longitude": "-82.29959000"
                    },
                    {
                        "id": 80223,
                        "name": "Guarumal",
                        "latitude": "8.34523000",
                        "longitude": "-82.53205000"
                    },
                    {
                        "id": 80225,
                        "name": "Guayabal",
                        "latitude": "8.62193000",
                        "longitude": "-82.57935000"
                    },
                    {
                        "id": 80233,
                        "name": "Horconcitos",
                        "latitude": "8.31142000",
                        "longitude": "-82.15102000"
                    },
                    {
                        "id": 80247,
                        "name": "La Concepción",
                        "latitude": "8.51212000",
                        "longitude": "-82.61858000"
                    },
                    {
                        "id": 80252,
                        "name": "La Esperanza",
                        "latitude": "8.40344000",
                        "longitude": "-82.79197000"
                    },
                    {
                        "id": 80254,
                        "name": "La Estrella",
                        "latitude": "8.51572000",
                        "longitude": "-82.67212000"
                    },
                    {
                        "id": 80283,
                        "name": "Lajas Adentro",
                        "latitude": "8.24981000",
                        "longitude": "-81.87779000"
                    },
                    {
                        "id": 80284,
                        "name": "Lajas de Tolé",
                        "latitude": "8.16994000",
                        "longitude": "-81.69654000"
                    },
                    {
                        "id": 80295,
                        "name": "Las Lajas",
                        "latitude": "8.24184000",
                        "longitude": "-81.86931000"
                    },
                    {
                        "id": 80296,
                        "name": "Las Lomas",
                        "latitude": "8.42927000",
                        "longitude": "-82.38743000"
                    },
                    {
                        "id": 80311,
                        "name": "Limones",
                        "latitude": "8.10007000",
                        "longitude": "-82.86679000"
                    },
                    {
                        "id": 80326,
                        "name": "Los Algarrobos",
                        "latitude": "8.49601000",
                        "longitude": "-82.42417000"
                    },
                    {
                        "id": 80328,
                        "name": "Los Anastacios",
                        "latitude": "8.53027000",
                        "longitude": "-82.42295000"
                    },
                    {
                        "id": 80344,
                        "name": "Los Ángeles",
                        "latitude": "8.52271000",
                        "longitude": "-82.19997000"
                    },
                    {
                        "id": 80338,
                        "name": "Los Naranjos",
                        "latitude": "8.79210000",
                        "longitude": "-82.44665000"
                    },
                    {
                        "id": 80347,
                        "name": "Manaca Civil",
                        "latitude": "8.32458000",
                        "longitude": "-82.81570000"
                    },
                    {
                        "id": 80348,
                        "name": "Manaca Norte",
                        "latitude": "8.33419000",
                        "longitude": "-82.81003000"
                    },
                    {
                        "id": 80351,
                        "name": "Mata del Nance",
                        "latitude": "8.45056000",
                        "longitude": "-82.40057000"
                    },
                    {
                        "id": 80360,
                        "name": "Monte Lirio",
                        "latitude": "8.78935000",
                        "longitude": "-82.82865000"
                    },
                    {
                        "id": 80378,
                        "name": "Nuevo San Carlitos",
                        "latitude": "8.45698000",
                        "longitude": "-82.43712000"
                    },
                    {
                        "id": 80387,
                        "name": "Paja de Sombrero",
                        "latitude": "8.68335000",
                        "longitude": "-82.31911000"
                    },
                    {
                        "id": 80392,
                        "name": "Palmira",
                        "latitude": "8.73401000",
                        "longitude": "-82.45887000"
                    },
                    {
                        "id": 80393,
                        "name": "Palmira Centro",
                        "latitude": "8.73956000",
                        "longitude": "-82.45228000"
                    },
                    {
                        "id": 80395,
                        "name": "Paraíso",
                        "latitude": "8.65842000",
                        "longitude": "-82.58625000"
                    },
                    {
                        "id": 80402,
                        "name": "Paso Canoas Arriba",
                        "latitude": "8.56516000",
                        "longitude": "-82.82214000"
                    },
                    {
                        "id": 80405,
                        "name": "Pedregal",
                        "latitude": "8.36586000",
                        "longitude": "-82.43524000"
                    },
                    {
                        "id": 80418,
                        "name": "Plaza de Caisán",
                        "latitude": "8.73672000",
                        "longitude": "-82.81968000"
                    },
                    {
                        "id": 80424,
                        "name": "Potrerillos Abajo",
                        "latitude": "8.63978000",
                        "longitude": "-82.48560000"
                    },
                    {
                        "id": 80425,
                        "name": "Potrerillos Arriba",
                        "latitude": "8.68547000",
                        "longitude": "-82.49090000"
                    },
                    {
                        "id": 80428,
                        "name": "Progreso",
                        "latitude": "8.44669000",
                        "longitude": "-82.83859000"
                    },
                    {
                        "id": 80430,
                        "name": "Pueblo Viejo",
                        "latitude": "8.25081000",
                        "longitude": "-81.66259000"
                    },
                    {
                        "id": 80431,
                        "name": "Puerto Armuelles",
                        "latitude": "8.27775000",
                        "longitude": "-82.86206000"
                    },
                    {
                        "id": 80440,
                        "name": "Punta de Burica",
                        "latitude": "8.03333000",
                        "longitude": "-82.86667000"
                    },
                    {
                        "id": 80447,
                        "name": "Quebrada de Piedra",
                        "latitude": "8.09418000",
                        "longitude": "-81.67915000"
                    },
                    {
                        "id": 80449,
                        "name": "Querévalo",
                        "latitude": "8.37174000",
                        "longitude": "-82.52670000"
                    },
                    {
                        "id": 80450,
                        "name": "Quinteño",
                        "latitude": "8.47102000",
                        "longitude": "-82.39352000"
                    },
                    {
                        "id": 80451,
                        "name": "Remedios",
                        "latitude": "8.22436000",
                        "longitude": "-81.82747000"
                    },
                    {
                        "id": 80452,
                        "name": "Rincón",
                        "latitude": "8.46374000",
                        "longitude": "-82.27951000"
                    },
                    {
                        "id": 80465,
                        "name": "Río Sereno",
                        "latitude": "8.81741000",
                        "longitude": "-82.85731000"
                    },
                    {
                        "id": 80455,
                        "name": "Rovira Arriba",
                        "latitude": "8.63822000",
                        "longitude": "-82.49965000"
                    },
                    {
                        "id": 80471,
                        "name": "San Andrés",
                        "latitude": "8.60260000",
                        "longitude": "-82.72588000"
                    },
                    {
                        "id": 80474,
                        "name": "San Carlos",
                        "latitude": "8.51663000",
                        "longitude": "-82.50906000"
                    },
                    {
                        "id": 80478,
                        "name": "San Félix",
                        "latitude": "8.29063000",
                        "longitude": "-81.86702000"
                    },
                    {
                        "id": 80480,
                        "name": "San Isidro",
                        "latitude": "8.53032000",
                        "longitude": "-82.82720000"
                    },
                    {
                        "id": 80487,
                        "name": "San Lorenzo",
                        "latitude": "8.30561000",
                        "longitude": "-82.10114000"
                    },
                    {
                        "id": 80491,
                        "name": "San Pablo Nuevo Abajo",
                        "latitude": "8.42558000",
                        "longitude": "-82.50173000"
                    },
                    {
                        "id": 80492,
                        "name": "San Pablo Viejo Abajo",
                        "latitude": "8.45339000",
                        "longitude": "-82.50179000"
                    },
                    {
                        "id": 80497,
                        "name": "Santa Clara",
                        "latitude": "8.83376000",
                        "longitude": "-82.77945000"
                    },
                    {
                        "id": 80499,
                        "name": "Santa Cruz",
                        "latitude": "8.23219000",
                        "longitude": "-81.91323000"
                    },
                    {
                        "id": 80503,
                        "name": "Santa Marta",
                        "latitude": "8.51406000",
                        "longitude": "-82.69870000"
                    },
                    {
                        "id": 80507,
                        "name": "Santa Rosa",
                        "latitude": "8.59958000",
                        "longitude": "-82.68489000"
                    },
                    {
                        "id": 80510,
                        "name": "Santo Domingo",
                        "latitude": "8.50803000",
                        "longitude": "-82.71295000"
                    },
                    {
                        "id": 80511,
                        "name": "Santo Tomás",
                        "latitude": "8.38959000",
                        "longitude": "-82.65058000"
                    },
                    {
                        "id": 80513,
                        "name": "Sioguí Abajo",
                        "latitude": "8.48678000",
                        "longitude": "-82.66539000"
                    },
                    {
                        "id": 80514,
                        "name": "Sioguí Arriba",
                        "latitude": "8.53865000",
                        "longitude": "-82.68619000"
                    },
                    {
                        "id": 80517,
                        "name": "Sortova",
                        "latitude": "8.54642000",
                        "longitude": "-82.65170000"
                    },
                    {
                        "id": 80520,
                        "name": "Tijeras",
                        "latitude": "8.47514000",
                        "longitude": "-82.56058000"
                    },
                    {
                        "id": 80521,
                        "name": "Tinajas",
                        "latitude": "8.55281000",
                        "longitude": "-82.45963000"
                    },
                    {
                        "id": 80525,
                        "name": "Tolé",
                        "latitude": "8.23989000",
                        "longitude": "-81.67168000"
                    },
                    {
                        "id": 80539,
                        "name": "Veladero",
                        "latitude": "8.23136000",
                        "longitude": "-81.65417000"
                    },
                    {
                        "id": 80550,
                        "name": "Volcán",
                        "latitude": "8.77291000",
                        "longitude": "-82.63823000"
                    }
                ]
            },
            {
                "id": 1387,
                "name": "Coclé",
                "iso2": "2",
                "latitude": "8.62660680",
                "longitude": "-80.36586500",
                "type": "province",
                "cities": [
                    {
                        "id": 79956,
                        "name": "Aguadulce",
                        "latitude": "8.24183000",
                        "longitude": "-80.54609000"
                    },
                    {
                        "id": 79957,
                        "name": "Aguas Blancas",
                        "latitude": "8.50351000",
                        "longitude": "-80.31169000"
                    },
                    {
                        "id": 79965,
                        "name": "Alto de La Estancia",
                        "latitude": "8.58792000",
                        "longitude": "-80.18443000"
                    },
                    {
                        "id": 79969,
                        "name": "Antón",
                        "latitude": "8.39733000",
                        "longitude": "-80.26063000"
                    },
                    {
                        "id": 79984,
                        "name": "Barranco Colorado",
                        "latitude": "8.38937000",
                        "longitude": "-80.63546000"
                    },
                    {
                        "id": 80013,
                        "name": "Caballero",
                        "latitude": "8.54343000",
                        "longitude": "-80.19769000"
                    },
                    {
                        "id": 80017,
                        "name": "Cabuya",
                        "latitude": "8.54703000",
                        "longitude": "-80.16756000"
                    },
                    {
                        "id": 80019,
                        "name": "Caimito",
                        "latitude": "8.62271000",
                        "longitude": "-80.23919000"
                    },
                    {
                        "id": 80039,
                        "name": "Cañaveral",
                        "latitude": "8.51700000",
                        "longitude": "-80.42916000"
                    },
                    {
                        "id": 80032,
                        "name": "Capellanía",
                        "latitude": "8.29858000",
                        "longitude": "-80.55480000"
                    },
                    {
                        "id": 80058,
                        "name": "Chigoré",
                        "latitude": "8.53035000",
                        "longitude": "-80.35117000"
                    },
                    {
                        "id": 80059,
                        "name": "Chiguirí Arriba",
                        "latitude": "8.67187000",
                        "longitude": "-80.18975000"
                    },
                    {
                        "id": 80067,
                        "name": "Churuquita Chiquita",
                        "latitude": "8.57555000",
                        "longitude": "-80.27161000"
                    },
                    {
                        "id": 80068,
                        "name": "Churuquita Grande",
                        "latitude": "8.59449000",
                        "longitude": "-80.27182000"
                    },
                    {
                        "id": 80071,
                        "name": "Coclé",
                        "latitude": "8.45601000",
                        "longitude": "-80.42899000"
                    },
                    {
                        "id": 80086,
                        "name": "Distrito de Aguadulce",
                        "latitude": "8.21270000",
                        "longitude": "-80.61441000"
                    },
                    {
                        "id": 80088,
                        "name": "Distrito de Antón",
                        "latitude": "8.45394000",
                        "longitude": "-80.18361000"
                    },
                    {
                        "id": 80114,
                        "name": "Distrito de La Pintada",
                        "latitude": "8.71801000",
                        "longitude": "-80.53946000"
                    },
                    {
                        "id": 80122,
                        "name": "Distrito de Natá",
                        "latitude": "8.34416000",
                        "longitude": "-80.60934000"
                    },
                    {
                        "id": 80124,
                        "name": "Distrito de Olá",
                        "latitude": "8.48053000",
                        "longitude": "-80.65324000"
                    },
                    {
                        "id": 80085,
                        "name": "Distrito Penonomé",
                        "latitude": "8.63000000",
                        "longitude": "-80.28333000"
                    },
                    {
                        "id": 80157,
                        "name": "El Caño",
                        "latitude": "8.40195000",
                        "longitude": "-80.51791000"
                    },
                    {
                        "id": 80159,
                        "name": "El Chirú",
                        "latitude": "8.39876000",
                        "longitude": "-80.18721000"
                    },
                    {
                        "id": 80163,
                        "name": "El Coco",
                        "latitude": "8.39716000",
                        "longitude": "-80.35000000"
                    },
                    {
                        "id": 80165,
                        "name": "El Copé",
                        "latitude": "8.62036000",
                        "longitude": "-80.58433000"
                    },
                    {
                        "id": 80167,
                        "name": "El Cortezo",
                        "latitude": "8.34556000",
                        "longitude": "-80.58721000"
                    },
                    {
                        "id": 80168,
                        "name": "El Cristo",
                        "latitude": "8.25071000",
                        "longitude": "-80.62093000"
                    },
                    {
                        "id": 80194,
                        "name": "El Potrero",
                        "latitude": "8.52146000",
                        "longitude": "-80.51681000"
                    },
                    {
                        "id": 80198,
                        "name": "El Retiro",
                        "latitude": "8.48014000",
                        "longitude": "-80.15426000"
                    },
                    {
                        "id": 80201,
                        "name": "El Roble",
                        "latitude": "8.16850000",
                        "longitude": "-80.65897000"
                    },
                    {
                        "id": 80207,
                        "name": "Entradero",
                        "latitude": "8.56880000",
                        "longitude": "-80.20743000"
                    },
                    {
                        "id": 80209,
                        "name": "Farallón",
                        "latitude": "8.35658000",
                        "longitude": "-80.13723000"
                    },
                    {
                        "id": 80228,
                        "name": "Guzman",
                        "latitude": "8.51969000",
                        "longitude": "-80.58405000"
                    },
                    {
                        "id": 80237,
                        "name": "Juan Díaz",
                        "latitude": "8.46240000",
                        "longitude": "-80.28280000"
                    },
                    {
                        "id": 80261,
                        "name": "La Loma",
                        "latitude": "8.16667000",
                        "longitude": "-80.63742000"
                    },
                    {
                        "id": 80275,
                        "name": "La Pintada",
                        "latitude": "8.59299000",
                        "longitude": "-80.44349000"
                    },
                    {
                        "id": 80293,
                        "name": "Las Huacas del Quije",
                        "latitude": "8.46702000",
                        "longitude": "-80.75089000"
                    },
                    {
                        "id": 80299,
                        "name": "Las Marias",
                        "latitude": "8.88809000",
                        "longitude": "-80.21893000"
                    },
                    {
                        "id": 80301,
                        "name": "Las Minas",
                        "latitude": "8.64118000",
                        "longitude": "-80.39432000"
                    },
                    {
                        "id": 80305,
                        "name": "Las Sabanas",
                        "latitude": "8.58141000",
                        "longitude": "-80.67978000"
                    },
                    {
                        "id": 80317,
                        "name": "Llano Grande",
                        "latitude": "8.63817000",
                        "longitude": "-80.43848000"
                    },
                    {
                        "id": 80320,
                        "name": "Llano Marín",
                        "latitude": "8.47696000",
                        "longitude": "-80.32499000"
                    },
                    {
                        "id": 80340,
                        "name": "Los Pollos",
                        "latitude": "8.39898000",
                        "longitude": "-80.15731000"
                    },
                    {
                        "id": 80366,
                        "name": "Natá",
                        "latitude": "8.33209000",
                        "longitude": "-80.51969000"
                    },
                    {
                        "id": 80370,
                        "name": "Nuestro Amo",
                        "latitude": "8.44485000",
                        "longitude": "-80.58934000"
                    },
                    {
                        "id": 80383,
                        "name": "Olá",
                        "latitude": "8.41807000",
                        "longitude": "-80.65123000"
                    },
                    {
                        "id": 80406,
                        "name": "Penonomé",
                        "latitude": "8.51889000",
                        "longitude": "-80.35727000"
                    },
                    {
                        "id": 80411,
                        "name": "Piedras Gordas",
                        "latitude": "8.63777000",
                        "longitude": "-80.51024000"
                    },
                    {
                        "id": 80420,
                        "name": "Pocrí",
                        "latitude": "8.25814000",
                        "longitude": "-80.55000000"
                    },
                    {
                        "id": 80460,
                        "name": "Río Grande",
                        "latitude": "8.42679000",
                        "longitude": "-80.48457000"
                    },
                    {
                        "id": 80462,
                        "name": "Río Hato",
                        "latitude": "8.37940000",
                        "longitude": "-80.16621000"
                    },
                    {
                        "id": 80486,
                        "name": "San Juan de Dios",
                        "latitude": "8.55119000",
                        "longitude": "-80.22623000"
                    },
                    {
                        "id": 80522,
                        "name": "Toabré",
                        "latitude": "8.65131000",
                        "longitude": "-80.32017000"
                    },
                    {
                        "id": 80528,
                        "name": "Toza",
                        "latitude": "8.34542000",
                        "longitude": "-80.64012000"
                    },
                    {
                        "id": 80548,
                        "name": "Vista Hermosa",
                        "latitude": "8.52687000",
                        "longitude": "-80.37486000"
                    }
                ]
            },
            {
                "id": 1386,
                "name": "Colón",
                "iso2": "3",
                "latitude": "9.18519890",
                "longitude": "-80.05349230",
                "type": "province",
                "cities": [
                    {
                        "id": 80007,
                        "name": "Buena Vista",
                        "latitude": "9.27356000",
                        "longitude": "-79.69551000"
                    },
                    {
                        "id": 80035,
                        "name": "Cativá",
                        "latitude": "9.36218000",
                        "longitude": "-79.83232000"
                    },
                    {
                        "id": 80072,
                        "name": "Coclé del Norte",
                        "latitude": "9.07540000",
                        "longitude": "-80.57177000"
                    },
                    {
                        "id": 80073,
                        "name": "Colón",
                        "latitude": "9.35451000",
                        "longitude": "-79.90011000"
                    },
                    {
                        "id": 80078,
                        "name": "Cristóbal",
                        "latitude": "9.35222000",
                        "longitude": "-79.90444000"
                    },
                    {
                        "id": 80099,
                        "name": "Distrito de Chagres",
                        "latitude": "9.12300000",
                        "longitude": "-80.11841000"
                    },
                    {
                        "id": 80106,
                        "name": "Distrito de Colón",
                        "latitude": "9.24313000",
                        "longitude": "-79.79463000"
                    },
                    {
                        "id": 80109,
                        "name": "Distrito de Donoso",
                        "latitude": "9.01999000",
                        "longitude": "-80.42967000"
                    },
                    {
                        "id": 80131,
                        "name": "Distrito de Portobelo",
                        "latitude": "9.49748000",
                        "longitude": "-79.60730000"
                    },
                    {
                        "id": 80140,
                        "name": "Distrito de Santa Isabel",
                        "latitude": "9.48333000",
                        "longitude": "-79.31667000"
                    },
                    {
                        "id": 80174,
                        "name": "El Giral",
                        "latitude": "9.24509000",
                        "longitude": "-79.69266000"
                    },
                    {
                        "id": 80175,
                        "name": "El Guabo",
                        "latitude": "9.07842000",
                        "longitude": "-80.08316000"
                    },
                    {
                        "id": 80206,
                        "name": "El Valle de la Unión",
                        "latitude": "9.23630000",
                        "longitude": "-79.65986000"
                    },
                    {
                        "id": 80208,
                        "name": "Escobal",
                        "latitude": "9.14373000",
                        "longitude": "-79.96439000"
                    },
                    {
                        "id": 80214,
                        "name": "Gatún",
                        "latitude": "9.28922000",
                        "longitude": "-79.77204000"
                    },
                    {
                        "id": 80213,
                        "name": "Gatuncillo",
                        "latitude": "9.24346000",
                        "longitude": "-79.64856000"
                    },
                    {
                        "id": 80298,
                        "name": "Las Margaritas",
                        "latitude": "9.32603000",
                        "longitude": "-79.89028000"
                    },
                    {
                        "id": 80350,
                        "name": "María Chiquita",
                        "latitude": "9.43991000",
                        "longitude": "-79.75455000"
                    },
                    {
                        "id": 80354,
                        "name": "Miramar",
                        "latitude": "9.57544000",
                        "longitude": "-79.33573000"
                    },
                    {
                        "id": 80368,
                        "name": "Nombre de Dios",
                        "latitude": "9.57937000",
                        "longitude": "-79.47109000"
                    },
                    {
                        "id": 80376,
                        "name": "Nuevo Chagres",
                        "latitude": "9.23979000",
                        "longitude": "-80.08267000"
                    },
                    {
                        "id": 80379,
                        "name": "Nuevo San Juan",
                        "latitude": "9.22205000",
                        "longitude": "-79.66602000"
                    },
                    {
                        "id": 80380,
                        "name": "Nuevo Vigía",
                        "latitude": "9.24263000",
                        "longitude": "-79.60756000"
                    },
                    {
                        "id": 80388,
                        "name": "Palenque",
                        "latitude": "9.56970000",
                        "longitude": "-79.36341000"
                    },
                    {
                        "id": 80389,
                        "name": "Palmas Bellas",
                        "latitude": "9.22838000",
                        "longitude": "-80.08503000"
                    },
                    {
                        "id": 80391,
                        "name": "Palmira",
                        "latitude": "9.54359000",
                        "longitude": "-79.21946000"
                    },
                    {
                        "id": 80415,
                        "name": "Playa Chiquita",
                        "latitude": "9.56620000",
                        "longitude": "-79.29185000"
                    },
                    {
                        "id": 80423,
                        "name": "Portobelo",
                        "latitude": "9.55303000",
                        "longitude": "-79.65693000"
                    },
                    {
                        "id": 80433,
                        "name": "Puerto Escondido",
                        "latitude": "9.19333000",
                        "longitude": "-80.08833000"
                    },
                    {
                        "id": 80435,
                        "name": "Puerto Pilón",
                        "latitude": "9.36316000",
                        "longitude": "-79.79333000"
                    },
                    {
                        "id": 80443,
                        "name": "Quebrada Bonita Adentro",
                        "latitude": "9.29662000",
                        "longitude": "-79.70606000"
                    },
                    {
                        "id": 80457,
                        "name": "Río Alejandro",
                        "latitude": "9.37149000",
                        "longitude": "-79.78809000"
                    },
                    {
                        "id": 80459,
                        "name": "Río Duque",
                        "latitude": "9.25688000",
                        "longitude": "-79.67937000"
                    },
                    {
                        "id": 80464,
                        "name": "Río Rita",
                        "latitude": "9.30296000",
                        "longitude": "-79.79234000"
                    },
                    {
                        "id": 80469,
                        "name": "Sabanitas",
                        "latitude": "9.34269000",
                        "longitude": "-79.80961000"
                    },
                    {
                        "id": 80502,
                        "name": "Santa Isabel",
                        "latitude": "9.53922000",
                        "longitude": "-79.19570000"
                    },
                    {
                        "id": 80506,
                        "name": "Santa Rita Arriba",
                        "latitude": "9.33032000",
                        "longitude": "-79.79363000"
                    },
                    {
                        "id": 80541,
                        "name": "Viento Frío",
                        "latitude": "9.58263000",
                        "longitude": "-79.40690000"
                    }
                ]
            },
            {
                "id": 1385,
                "name": "Darién",
                "iso2": "5",
                "latitude": "7.86817130",
                "longitude": "-77.83672820",
                "type": "province",
                "cities": [
                    {
                        "id": 79997,
                        "name": "Boca de Cupé",
                        "latitude": "8.03003000",
                        "longitude": "-77.58978000"
                    },
                    {
                        "id": 80030,
                        "name": "Camogantí",
                        "latitude": "8.04171000",
                        "longitude": "-77.88682000"
                    },
                    {
                        "id": 80079,
                        "name": "Cucunatí",
                        "latitude": "8.57508000",
                        "longitude": "-78.25671000"
                    },
                    {
                        "id": 80102,
                        "name": "Distrito de Chepigana",
                        "latitude": "7.84374000",
                        "longitude": "-77.83830000"
                    },
                    {
                        "id": 80129,
                        "name": "Distrito de Pinogana",
                        "latitude": "7.89343000",
                        "longitude": "-77.52562000"
                    },
                    {
                        "id": 80212,
                        "name": "Garachiné",
                        "latitude": "8.06684000",
                        "longitude": "-78.36436000"
                    },
                    {
                        "id": 80236,
                        "name": "Jaqué",
                        "latitude": "7.51826000",
                        "longitude": "-78.16343000"
                    },
                    {
                        "id": 80270,
                        "name": "La Palma",
                        "latitude": "8.40608000",
                        "longitude": "-78.13964000"
                    },
                    {
                        "id": 80353,
                        "name": "Metetí",
                        "latitude": "8.49909000",
                        "longitude": "-77.97897000"
                    },
                    {
                        "id": 80362,
                        "name": "Mortí",
                        "latitude": "8.84246000",
                        "longitude": "-77.97539000"
                    },
                    {
                        "id": 80442,
                        "name": "Púcuro",
                        "latitude": "7.97876000",
                        "longitude": "-77.48758000"
                    },
                    {
                        "id": 80500,
                        "name": "Santa Fé",
                        "latitude": "8.65525000",
                        "longitude": "-78.16140000"
                    },
                    {
                        "id": 80552,
                        "name": "Yaviza",
                        "latitude": "8.15835000",
                        "longitude": "-77.69276000"
                    }
                ]
            },
            {
                "id": 1396,
                "name": "Emberá-Wounaan Comarca",
                "iso2": "EM",
                "latitude": "8.37669830",
                "longitude": "-77.65361250",
                "type": "indigenous region",
                "cities": [
                    {
                        "id": 79987,
                        "name": "Bayamón",
                        "latitude": "7.96817000",
                        "longitude": "-78.21648000"
                    },
                    {
                        "id": 80081,
                        "name": "Cémaco",
                        "latitude": "8.08285000",
                        "longitude": "-77.54210000"
                    },
                    {
                        "id": 80076,
                        "name": "Corozal",
                        "latitude": "8.20108000",
                        "longitude": "-77.59637000"
                    },
                    {
                        "id": 80470,
                        "name": "Sambú",
                        "latitude": "7.82013000",
                        "longitude": "-78.11005000"
                    },
                    {
                        "id": 80531,
                        "name": "Unión Chocó",
                        "latitude": "8.08404000",
                        "longitude": "-77.53507000"
                    },
                    {
                        "id": 80551,
                        "name": "Yape",
                        "latitude": "8.09839000",
                        "longitude": "-77.59817000"
                    }
                ]
            },
            {
                "id": 1388,
                "name": "Guna",
                "iso2": "KY",
                "latitude": "9.23443950",
                "longitude": "-78.19262500",
                "type": "indigenous region",
                "cities": [
                    {
                        "id": 79954,
                        "name": "Achutupo",
                        "latitude": "9.19827000",
                        "longitude": "-77.98729000"
                    },
                    {
                        "id": 79958,
                        "name": "Ailigandí",
                        "latitude": "9.22810000",
                        "longitude": "-78.02778000"
                    },
                    {
                        "id": 80034,
                        "name": "Cartí Sugdup",
                        "latitude": "9.46460000",
                        "longitude": "-78.95931000"
                    },
                    {
                        "id": 80192,
                        "name": "El Porvenir",
                        "latitude": "9.55276000",
                        "longitude": "-78.95230000"
                    },
                    {
                        "id": 80363,
                        "name": "Mulatupo",
                        "latitude": "8.94672000",
                        "longitude": "-77.75080000"
                    },
                    {
                        "id": 80365,
                        "name": "Narganá",
                        "latitude": "9.44394000",
                        "longitude": "-78.58666000"
                    },
                    {
                        "id": 80417,
                        "name": "Playón Chico",
                        "latitude": "9.31128000",
                        "longitude": "-78.23270000"
                    },
                    {
                        "id": 80434,
                        "name": "Puerto Obaldía",
                        "latitude": "8.66632000",
                        "longitude": "-77.41922000"
                    },
                    {
                        "id": 80479,
                        "name": "San Ignacio de Tupile",
                        "latitude": "9.28905000",
                        "longitude": "-78.15206000"
                    },
                    {
                        "id": 80530,
                        "name": "Tubualá",
                        "latitude": "9.51667000",
                        "longitude": "-79.03333000"
                    },
                    {
                        "id": 80534,
                        "name": "Ustupo",
                        "latitude": "9.13112000",
                        "longitude": "-77.92620000"
                    }
                ]
            },
            {
                "id": 1389,
                "name": "Herrera",
                "iso2": "6",
                "latitude": "7.77042820",
                "longitude": "-80.72144170",
                "type": "province",
                "cities": [
                    {
                        "id": 79998,
                        "name": "Boca de Parita",
                        "latitude": "8.00796000",
                        "longitude": "-80.45320000"
                    },
                    {
                        "id": 80015,
                        "name": "Cabuya",
                        "latitude": "8.03138000",
                        "longitude": "-80.63227000"
                    },
                    {
                        "id": 80049,
                        "name": "Cerro Largo",
                        "latitude": "7.83377000",
                        "longitude": "-80.83168000"
                    },
                    {
                        "id": 80064,
                        "name": "Chitré",
                        "latitude": "7.96082000",
                        "longitude": "-80.42944000"
                    },
                    {
                        "id": 80065,
                        "name": "Chumical",
                        "latitude": "7.84482000",
                        "longitude": "-80.72627000"
                    },
                    {
                        "id": 80066,
                        "name": "Chupampa",
                        "latitude": "8.07620000",
                        "longitude": "-80.77656000"
                    },
                    {
                        "id": 80105,
                        "name": "Distrito de Chitré",
                        "latitude": "7.98333000",
                        "longitude": "-80.43333000"
                    },
                    {
                        "id": 80115,
                        "name": "Distrito de Las Minas",
                        "latitude": "7.76525000",
                        "longitude": "-80.82249000"
                    },
                    {
                        "id": 80118,
                        "name": "Distrito de Los Pozos",
                        "latitude": "7.70944000",
                        "longitude": "-80.64311000"
                    },
                    {
                        "id": 80123,
                        "name": "Distrito de Ocú",
                        "latitude": "7.90641000",
                        "longitude": "-80.79752000"
                    },
                    {
                        "id": 80126,
                        "name": "Distrito de Parita",
                        "latitude": "8.06240000",
                        "longitude": "-80.56373000"
                    },
                    {
                        "id": 80128,
                        "name": "Distrito de Pesé",
                        "latitude": "7.88194000",
                        "longitude": "-80.63261000"
                    },
                    {
                        "id": 80141,
                        "name": "Distrito de Santa María",
                        "latitude": "8.11667000",
                        "longitude": "-80.68333000"
                    },
                    {
                        "id": 80153,
                        "name": "El Calabacito",
                        "latitude": "7.71843000",
                        "longitude": "-80.59757000"
                    },
                    {
                        "id": 80154,
                        "name": "El Capurí",
                        "latitude": "7.72571000",
                        "longitude": "-80.64349000"
                    },
                    {
                        "id": 80158,
                        "name": "El Cedro",
                        "latitude": "7.68565000",
                        "longitude": "-80.65927000"
                    },
                    {
                        "id": 80188,
                        "name": "El Pedregoso",
                        "latitude": "7.93642000",
                        "longitude": "-80.63807000"
                    },
                    {
                        "id": 80199,
                        "name": "El Rincón",
                        "latitude": "8.11923000",
                        "longitude": "-80.61707000"
                    },
                    {
                        "id": 80204,
                        "name": "El Toro",
                        "latitude": "7.75110000",
                        "longitude": "-80.86943000"
                    },
                    {
                        "id": 80241,
                        "name": "La Arena",
                        "latitude": "7.96766000",
                        "longitude": "-80.46523000"
                    },
                    {
                        "id": 80279,
                        "name": "La Trinidad",
                        "latitude": "7.91457000",
                        "longitude": "-80.70332000"
                    },
                    {
                        "id": 80289,
                        "name": "Las Guabas",
                        "latitude": "7.90949000",
                        "longitude": "-80.80706000"
                    },
                    {
                        "id": 80300,
                        "name": "Las Minas",
                        "latitude": "7.79581000",
                        "longitude": "-80.74570000"
                    },
                    {
                        "id": 80309,
                        "name": "Leones Arriba",
                        "latitude": "7.76590000",
                        "longitude": "-80.84515000"
                    },
                    {
                        "id": 80312,
                        "name": "Limón de Tijeras",
                        "latitude": "7.81756000",
                        "longitude": "-80.91335000"
                    },
                    {
                        "id": 80314,
                        "name": "Llano Bonito",
                        "latitude": "7.97637000",
                        "longitude": "-80.41646000"
                    },
                    {
                        "id": 80321,
                        "name": "Llano de La Cruz",
                        "latitude": "7.95178000",
                        "longitude": "-80.64239000"
                    },
                    {
                        "id": 80315,
                        "name": "Llano Grande",
                        "latitude": "7.97406000",
                        "longitude": "-80.71103000"
                    },
                    {
                        "id": 80330,
                        "name": "Los Canelos",
                        "latitude": "8.11722000",
                        "longitude": "-80.70769000"
                    },
                    {
                        "id": 80331,
                        "name": "Los Castillos",
                        "latitude": "7.98565000",
                        "longitude": "-80.61886000"
                    },
                    {
                        "id": 80333,
                        "name": "Los Cerritos",
                        "latitude": "7.79746000",
                        "longitude": "-80.61071000"
                    },
                    {
                        "id": 80334,
                        "name": "Los Cerros de Paja",
                        "latitude": "7.71821000",
                        "longitude": "-80.67273000"
                    },
                    {
                        "id": 80341,
                        "name": "Los Pozos",
                        "latitude": "7.78300000",
                        "longitude": "-80.64524000"
                    },
                    {
                        "id": 80358,
                        "name": "Monagrillo",
                        "latitude": "7.98179000",
                        "longitude": "-80.43764000"
                    },
                    {
                        "id": 80382,
                        "name": "Ocú",
                        "latitude": "7.94052000",
                        "longitude": "-80.77936000"
                    },
                    {
                        "id": 80401,
                        "name": "París",
                        "latitude": "8.05053000",
                        "longitude": "-80.55409000"
                    },
                    {
                        "id": 80398,
                        "name": "Parita",
                        "latitude": "7.99393000",
                        "longitude": "-80.52097000"
                    },
                    {
                        "id": 80410,
                        "name": "Peñas Chatas",
                        "latitude": "8.01502000",
                        "longitude": "-80.80366000"
                    },
                    {
                        "id": 80408,
                        "name": "Pesé",
                        "latitude": "7.90863000",
                        "longitude": "-80.61433000"
                    },
                    {
                        "id": 80413,
                        "name": "Pitaloza Arriba",
                        "latitude": "7.64216000",
                        "longitude": "-80.66788000"
                    },
                    {
                        "id": 80422,
                        "name": "Portobelillo",
                        "latitude": "8.01738000",
                        "longitude": "-80.59538000"
                    },
                    {
                        "id": 80427,
                        "name": "Potuga",
                        "latitude": "8.06317000",
                        "longitude": "-80.62271000"
                    },
                    {
                        "id": 80448,
                        "name": "Quebrada del Rosario",
                        "latitude": "7.71238000",
                        "longitude": "-80.74222000"
                    },
                    {
                        "id": 80453,
                        "name": "Rincón Hondo",
                        "latitude": "7.84436000",
                        "longitude": "-80.60397000"
                    },
                    {
                        "id": 80467,
                        "name": "Sabana Grande",
                        "latitude": "7.88002000",
                        "longitude": "-80.63818000"
                    },
                    {
                        "id": 80485,
                        "name": "San Juan Bautista",
                        "latitude": "7.96099000",
                        "longitude": "-80.41283000"
                    },
                    {
                        "id": 80504,
                        "name": "Santa María",
                        "latitude": "8.11143000",
                        "longitude": "-80.66582000"
                    }
                ]
            },
            {
                "id": 1390,
                "name": "Los Santos",
                "iso2": "7",
                "latitude": "7.59093020",
                "longitude": "-80.36586500",
                "type": "province",
                "cities": [
                    {
                        "id": 79955,
                        "name": "Agua Buena",
                        "latitude": "7.83465000",
                        "longitude": "-80.39405000"
                    },
                    {
                        "id": 79976,
                        "name": "Ave María",
                        "latitude": "7.32481000",
                        "longitude": "-80.45361000"
                    },
                    {
                        "id": 79978,
                        "name": "Bahía Honda",
                        "latitude": "7.70517000",
                        "longitude": "-80.45342000"
                    },
                    {
                        "id": 79980,
                        "name": "Bajo Corral",
                        "latitude": "7.60463000",
                        "longitude": "-80.26016000"
                    },
                    {
                        "id": 79988,
                        "name": "Bayano",
                        "latitude": "7.63014000",
                        "longitude": "-80.38201000"
                    },
                    {
                        "id": 79990,
                        "name": "Bella Vista",
                        "latitude": "7.75000000",
                        "longitude": "-80.23333000"
                    },
                    {
                        "id": 80029,
                        "name": "Cambutal",
                        "latitude": "7.26534000",
                        "longitude": "-80.49105000"
                    },
                    {
                        "id": 80037,
                        "name": "Cañas",
                        "latitude": "7.44713000",
                        "longitude": "-80.26480000"
                    },
                    {
                        "id": 80042,
                        "name": "Cedro Arriba",
                        "latitude": "7.78097000",
                        "longitude": "-80.53057000"
                    },
                    {
                        "id": 80111,
                        "name": "Distrito de Guararé",
                        "latitude": "7.77021000",
                        "longitude": "-80.37515000"
                    },
                    {
                        "id": 80117,
                        "name": "Distrito de Las Tablas",
                        "latitude": "7.64843000",
                        "longitude": "-80.29933000"
                    },
                    {
                        "id": 80119,
                        "name": "Distrito de Los Santos",
                        "latitude": "7.88333000",
                        "longitude": "-80.45000000"
                    },
                    {
                        "id": 80120,
                        "name": "Distrito de Macaracas",
                        "latitude": "7.65817000",
                        "longitude": "-80.53526000"
                    },
                    {
                        "id": 80127,
                        "name": "Distrito de Pedasí",
                        "latitude": "7.48528000",
                        "longitude": "-80.12747000"
                    },
                    {
                        "id": 80130,
                        "name": "Distrito de Pocrí",
                        "latitude": "7.63721000",
                        "longitude": "-80.16470000"
                    },
                    {
                        "id": 80146,
                        "name": "Distrito de Tonosí",
                        "latitude": "7.43597000",
                        "longitude": "-80.45828000"
                    },
                    {
                        "id": 80151,
                        "name": "El Cacao",
                        "latitude": "7.44570000",
                        "longitude": "-80.40938000"
                    },
                    {
                        "id": 80156,
                        "name": "El Cañafístulo",
                        "latitude": "7.61768000",
                        "longitude": "-80.23322000"
                    },
                    {
                        "id": 80155,
                        "name": "El Carate",
                        "latitude": "7.73124000",
                        "longitude": "-80.29691000"
                    },
                    {
                        "id": 80161,
                        "name": "El Cocal",
                        "latitude": "7.73697000",
                        "longitude": "-80.27980000"
                    },
                    {
                        "id": 80166,
                        "name": "El Cortezo",
                        "latitude": "7.42661000",
                        "longitude": "-80.63311000"
                    },
                    {
                        "id": 80169,
                        "name": "El Ejido",
                        "latitude": "7.91634000",
                        "longitude": "-80.38686000"
                    },
                    {
                        "id": 80176,
                        "name": "El Guásimo",
                        "latitude": "7.80640000",
                        "longitude": "-80.52991000"
                    },
                    {
                        "id": 80177,
                        "name": "El Hato",
                        "latitude": "7.79316000",
                        "longitude": "-80.38267000"
                    },
                    {
                        "id": 80180,
                        "name": "El Macano",
                        "latitude": "7.68489000",
                        "longitude": "-80.40309000"
                    },
                    {
                        "id": 80181,
                        "name": "El Manantial",
                        "latitude": "7.78245000",
                        "longitude": "-80.24713000"
                    },
                    {
                        "id": 80184,
                        "name": "El Muñoz",
                        "latitude": "7.67582000",
                        "longitude": "-80.32130000"
                    },
                    {
                        "id": 80189,
                        "name": "El Pedregoso",
                        "latitude": "7.69173000",
                        "longitude": "-80.32793000"
                    },
                    {
                        "id": 80211,
                        "name": "Flores",
                        "latitude": "7.48157000",
                        "longitude": "-80.40695000"
                    },
                    {
                        "id": 80221,
                        "name": "Guararé",
                        "latitude": "7.81531000",
                        "longitude": "-80.28345000"
                    },
                    {
                        "id": 80222,
                        "name": "Guararé Arriba",
                        "latitude": "7.80023000",
                        "longitude": "-80.35983000"
                    },
                    {
                        "id": 80246,
                        "name": "La Colorada",
                        "latitude": "7.82362000",
                        "longitude": "-80.55552000"
                    },
                    {
                        "id": 80248,
                        "name": "La Enea",
                        "latitude": "7.83333000",
                        "longitude": "-80.27417000"
                    },
                    {
                        "id": 80253,
                        "name": "La Espigadilla",
                        "latitude": "7.88389000",
                        "longitude": "-80.39039000"
                    },
                    {
                        "id": 80260,
                        "name": "La Laja",
                        "latitude": "7.73102000",
                        "longitude": "-80.25298000"
                    },
                    {
                        "id": 80266,
                        "name": "La Mesa",
                        "latitude": "7.65670000",
                        "longitude": "-80.61794000"
                    },
                    {
                        "id": 80267,
                        "name": "La Miel",
                        "latitude": "7.56022000",
                        "longitude": "-80.32736000"
                    },
                    {
                        "id": 80271,
                        "name": "La Palma",
                        "latitude": "7.71667000",
                        "longitude": "-80.38333000"
                    },
                    {
                        "id": 80272,
                        "name": "La Pasera",
                        "latitude": "7.79757000",
                        "longitude": "-80.30342000"
                    },
                    {
                        "id": 80278,
                        "name": "La Tiza",
                        "latitude": "7.75110000",
                        "longitude": "-80.29216000"
                    },
                    {
                        "id": 80280,
                        "name": "La Tronosa",
                        "latitude": "7.43609000",
                        "longitude": "-80.58698000"
                    },
                    {
                        "id": 80282,
                        "name": "Lajamina",
                        "latitude": "7.58587000",
                        "longitude": "-80.13212000"
                    },
                    {
                        "id": 80287,
                        "name": "Las Cruces",
                        "latitude": "7.82285000",
                        "longitude": "-80.43003000"
                    },
                    {
                        "id": 80290,
                        "name": "Las Guabas",
                        "latitude": "7.81469000",
                        "longitude": "-80.50155000"
                    },
                    {
                        "id": 80303,
                        "name": "Las Palmas",
                        "latitude": "7.68314000",
                        "longitude": "-80.49728000"
                    },
                    {
                        "id": 80304,
                        "name": "Las Palmitas",
                        "latitude": "7.76523000",
                        "longitude": "-80.29350000"
                    },
                    {
                        "id": 80306,
                        "name": "Las Tablas",
                        "latitude": "7.76472000",
                        "longitude": "-80.27483000"
                    },
                    {
                        "id": 80307,
                        "name": "Las Trancas",
                        "latitude": "7.73400000",
                        "longitude": "-80.37384000"
                    },
                    {
                        "id": 80313,
                        "name": "Llano Abajo",
                        "latitude": "7.78598000",
                        "longitude": "-80.41060000"
                    },
                    {
                        "id": 80322,
                        "name": "Llano de Piedra",
                        "latitude": "7.65972000",
                        "longitude": "-80.56347000"
                    },
                    {
                        "id": 80319,
                        "name": "Llano Largo",
                        "latitude": "7.90607000",
                        "longitude": "-80.42561000"
                    },
                    {
                        "id": 80343,
                        "name": "Los Ángeles",
                        "latitude": "7.88422000",
                        "longitude": "-80.35772000"
                    },
                    {
                        "id": 80329,
                        "name": "Los Asientos",
                        "latitude": "7.51656000",
                        "longitude": "-80.13521000"
                    },
                    {
                        "id": 80339,
                        "name": "Los Olivos",
                        "latitude": "7.91589000",
                        "longitude": "-80.48884000"
                    },
                    {
                        "id": 80342,
                        "name": "Los Santos",
                        "latitude": "7.93333000",
                        "longitude": "-80.41667000"
                    },
                    {
                        "id": 80346,
                        "name": "Macaracas",
                        "latitude": "7.73168000",
                        "longitude": "-80.55364000"
                    },
                    {
                        "id": 80357,
                        "name": "Mogollón",
                        "latitude": "7.64261000",
                        "longitude": "-80.45950000"
                    },
                    {
                        "id": 80369,
                        "name": "Nuario",
                        "latitude": "7.53047000",
                        "longitude": "-80.32692000"
                    },
                    {
                        "id": 80385,
                        "name": "Oria Arriba",
                        "latitude": "7.50505000",
                        "longitude": "-80.20567000"
                    },
                    {
                        "id": 80390,
                        "name": "Palmira",
                        "latitude": "7.66347000",
                        "longitude": "-80.35728000"
                    },
                    {
                        "id": 80396,
                        "name": "Paraíso",
                        "latitude": "7.68510000",
                        "longitude": "-80.16082000"
                    },
                    {
                        "id": 80399,
                        "name": "Paritilla",
                        "latitude": "7.62848000",
                        "longitude": "-80.17240000"
                    },
                    {
                        "id": 80403,
                        "name": "Pedasí",
                        "latitude": "7.53034000",
                        "longitude": "-80.02699000"
                    },
                    {
                        "id": 80409,
                        "name": "Peña Blanca",
                        "latitude": "7.71931000",
                        "longitude": "-80.28366000"
                    },
                    {
                        "id": 80407,
                        "name": "Perales",
                        "latitude": "7.77461000",
                        "longitude": "-80.32494000"
                    },
                    {
                        "id": 80419,
                        "name": "Pocrí",
                        "latitude": "7.65816000",
                        "longitude": "-80.12119000"
                    },
                    {
                        "id": 80463,
                        "name": "Río Hondo",
                        "latitude": "7.71192000",
                        "longitude": "-80.35904000"
                    },
                    {
                        "id": 80468,
                        "name": "Sabana Grande",
                        "latitude": "7.83543000",
                        "longitude": "-80.36490000"
                    },
                    {
                        "id": 80481,
                        "name": "San José",
                        "latitude": "7.67395000",
                        "longitude": "-80.24438000"
                    },
                    {
                        "id": 80496,
                        "name": "Santa Ana Arriba",
                        "latitude": "7.93300000",
                        "longitude": "-80.36369000"
                    },
                    {
                        "id": 80509,
                        "name": "Santo Domingo",
                        "latitude": "7.74614000",
                        "longitude": "-80.24173000"
                    },
                    {
                        "id": 80512,
                        "name": "Sesteadero",
                        "latitude": "7.73885000",
                        "longitude": "-80.24854000"
                    },
                    {
                        "id": 80526,
                        "name": "Tonosí",
                        "latitude": "7.40684000",
                        "longitude": "-80.44217000"
                    },
                    {
                        "id": 80529,
                        "name": "Tres Quebradas",
                        "latitude": "7.84018000",
                        "longitude": "-80.40740000"
                    },
                    {
                        "id": 80536,
                        "name": "Valle Rico",
                        "latitude": "7.62011000",
                        "longitude": "-80.35076000"
                    },
                    {
                        "id": 80538,
                        "name": "Vallerriquito",
                        "latitude": "7.62163000",
                        "longitude": "-80.31975000"
                    },
                    {
                        "id": 80544,
                        "name": "Villa Lourdes",
                        "latitude": "7.81141000",
                        "longitude": "-80.47029000"
                    }
                ]
            },
            {
                "id": 1391,
                "name": "Ngöbe-Buglé Comarca",
                "iso2": "NB",
                "latitude": "8.65958330",
                "longitude": "-81.77870210",
                "type": "indigenous region",
                "cities": [
                    {
                        "id": 79977,
                        "name": "Bahía Azul",
                        "latitude": "9.14176000",
                        "longitude": "-81.89425000"
                    },
                    {
                        "id": 79991,
                        "name": "Besiko",
                        "latitude": "8.54863000",
                        "longitude": "-82.08980000"
                    },
                    {
                        "id": 79993,
                        "name": "Bisira",
                        "latitude": "8.89553000",
                        "longitude": "-81.85352000"
                    },
                    {
                        "id": 79996,
                        "name": "Boca de Balsa",
                        "latitude": "8.52995000",
                        "longitude": "-82.03132000"
                    },
                    {
                        "id": 80009,
                        "name": "Buenos Aires",
                        "latitude": "8.41384000",
                        "longitude": "-81.48440000"
                    },
                    {
                        "id": 80028,
                        "name": "Camarón Arriba",
                        "latitude": "8.38324000",
                        "longitude": "-81.99345000"
                    },
                    {
                        "id": 80046,
                        "name": "Cerro Banco",
                        "latitude": "8.45797000",
                        "longitude": "-82.03081000"
                    },
                    {
                        "id": 80048,
                        "name": "Cerro Caña",
                        "latitude": "8.35174000",
                        "longitude": "-81.61050000"
                    },
                    {
                        "id": 80050,
                        "name": "Cerro Plata",
                        "latitude": "8.47733000",
                        "longitude": "-81.54585000"
                    },
                    {
                        "id": 80057,
                        "name": "Chichica",
                        "latitude": "8.35885000",
                        "longitude": "-81.66582000"
                    },
                    {
                        "id": 80226,
                        "name": "Guayabito",
                        "latitude": "8.53949000",
                        "longitude": "-81.48225000"
                    },
                    {
                        "id": 80230,
                        "name": "Hato Chami",
                        "latitude": "8.44281000",
                        "longitude": "-81.77196000"
                    },
                    {
                        "id": 80231,
                        "name": "Hato Corotú",
                        "latitude": "8.33516000",
                        "longitude": "-81.97030000"
                    },
                    {
                        "id": 80239,
                        "name": "Kankintú",
                        "latitude": "8.89503000",
                        "longitude": "-81.85750000"
                    },
                    {
                        "id": 80240,
                        "name": "Kusapín",
                        "latitude": "9.17119000",
                        "longitude": "-81.89621000"
                    },
                    {
                        "id": 80285,
                        "name": "Lajero Arriba",
                        "latitude": "8.29060000",
                        "longitude": "-81.77047000"
                    },
                    {
                        "id": 80323,
                        "name": "Llano Ñopo",
                        "latitude": "8.41996000",
                        "longitude": "-81.61865000"
                    },
                    {
                        "id": 80325,
                        "name": "Loma Yuca",
                        "latitude": "8.71817000",
                        "longitude": "-81.40492000"
                    },
                    {
                        "id": 80356,
                        "name": "Mirono",
                        "latitude": "8.40469000",
                        "longitude": "-81.83064000"
                    },
                    {
                        "id": 80364,
                        "name": "Müna",
                        "latitude": "8.35035000",
                        "longitude": "-81.67219000"
                    },
                    {
                        "id": 80367,
                        "name": "Nole Düima",
                        "latitude": "8.32682000",
                        "longitude": "-81.81531000"
                    },
                    {
                        "id": 80381,
                        "name": "Nurun",
                        "latitude": "8.47815000",
                        "longitude": "-81.47015000"
                    },
                    {
                        "id": 80384,
                        "name": "Oma",
                        "latitude": "8.35019000",
                        "longitude": "-81.80177000"
                    },
                    {
                        "id": 80397,
                        "name": "Paredón Arriba",
                        "latitude": "8.45977000",
                        "longitude": "-81.19592000"
                    },
                    {
                        "id": 80414,
                        "name": "Plan de Chorcha",
                        "latitude": "8.46168000",
                        "longitude": "-82.15924000"
                    },
                    {
                        "id": 80429,
                        "name": "Pueblo Nuevo",
                        "latitude": "8.88070000",
                        "longitude": "-82.22411000"
                    },
                    {
                        "id": 80444,
                        "name": "Quebrada Canoa",
                        "latitude": "8.43333000",
                        "longitude": "-81.78333000"
                    },
                    {
                        "id": 80445,
                        "name": "Quebrada Tula",
                        "latitude": "8.84037000",
                        "longitude": "-81.99645000"
                    },
                    {
                        "id": 80515,
                        "name": "Sitio Prado",
                        "latitude": "8.37233000",
                        "longitude": "-81.58141000"
                    },
                    {
                        "id": 80523,
                        "name": "Tobobe",
                        "latitude": "9.12111000",
                        "longitude": "-81.82471000"
                    }
                ]
            },
            {
                "id": 1395,
                "name": "Panamá",
                "iso2": "8",
                "latitude": "8.86351980",
                "longitude": "-79.53149070",
                "type": "province",
                "cities": [
                    {
                        "id": 79960,
                        "name": "Alcalde Díaz",
                        "latitude": "9.12016000",
                        "longitude": "-79.55641000"
                    },
                    {
                        "id": 79968,
                        "name": "Ancón",
                        "latitude": "8.96015000",
                        "longitude": "-79.55140000"
                    },
                    {
                        "id": 80006,
                        "name": "Brujas",
                        "latitude": "8.58536000",
                        "longitude": "-78.53008000"
                    },
                    {
                        "id": 80014,
                        "name": "Cabra Número Uno",
                        "latitude": "9.10863000",
                        "longitude": "-79.33694000"
                    },
                    {
                        "id": 80018,
                        "name": "Caimitillo",
                        "latitude": "9.15559000",
                        "longitude": "-79.53974000"
                    },
                    {
                        "id": 80027,
                        "name": "Calzada Larga",
                        "latitude": "9.17272000",
                        "longitude": "-79.56212000"
                    },
                    {
                        "id": 80041,
                        "name": "Cañita",
                        "latitude": "9.22236000",
                        "longitude": "-78.89509000"
                    },
                    {
                        "id": 80045,
                        "name": "Cerro Azul",
                        "latitude": "9.15735000",
                        "longitude": "-79.42097000"
                    },
                    {
                        "id": 80055,
                        "name": "Chepillo",
                        "latitude": "8.95396000",
                        "longitude": "-79.12856000"
                    },
                    {
                        "id": 80056,
                        "name": "Chepo",
                        "latitude": "9.17019000",
                        "longitude": "-79.10083000"
                    },
                    {
                        "id": 80060,
                        "name": "Chilibre",
                        "latitude": "9.15093000",
                        "longitude": "-79.62098000"
                    },
                    {
                        "id": 80061,
                        "name": "Chimán",
                        "latitude": "8.69125000",
                        "longitude": "-78.63570000"
                    },
                    {
                        "id": 80074,
                        "name": "Contadora",
                        "latitude": "8.62483000",
                        "longitude": "-79.03748000"
                    },
                    {
                        "id": 80080,
                        "name": "Curundú",
                        "latitude": "8.97092000",
                        "longitude": "-79.54612000"
                    },
                    {
                        "id": 80090,
                        "name": "Distrito de Balboa",
                        "latitude": "8.46667000",
                        "longitude": "-79.00000000"
                    },
                    {
                        "id": 80103,
                        "name": "Distrito de Chepo",
                        "latitude": "9.17391000",
                        "longitude": "-78.70374000"
                    },
                    {
                        "id": 80104,
                        "name": "Distrito de Chimán",
                        "latitude": "8.76043000",
                        "longitude": "-78.56470000"
                    },
                    {
                        "id": 80125,
                        "name": "Distrito de Panamá",
                        "latitude": "9.30612000",
                        "longitude": "-79.45246000"
                    },
                    {
                        "id": 80144,
                        "name": "Distrito de Taboga",
                        "latitude": "8.78333000",
                        "longitude": "-79.55833000"
                    },
                    {
                        "id": 80160,
                        "name": "El Chorrillo",
                        "latitude": "8.94964000",
                        "longitude": "-79.54715000"
                    },
                    {
                        "id": 80196,
                        "name": "El Progreso",
                        "latitude": "9.26667000",
                        "longitude": "-79.11667000"
                    },
                    {
                        "id": 80215,
                        "name": "Gonzalillo",
                        "latitude": "9.09183000",
                        "longitude": "-79.51928000"
                    },
                    {
                        "id": 80234,
                        "name": "Howard",
                        "latitude": "8.93942000",
                        "longitude": "-79.59097000"
                    },
                    {
                        "id": 80238,
                        "name": "Juan Díaz",
                        "latitude": "9.05000000",
                        "longitude": "-79.45000000"
                    },
                    {
                        "id": 80242,
                        "name": "La Cabima",
                        "latitude": "9.11865000",
                        "longitude": "-79.53660000"
                    },
                    {
                        "id": 80245,
                        "name": "La Colorada",
                        "latitude": "9.10224000",
                        "longitude": "-79.41600000"
                    },
                    {
                        "id": 80249,
                        "name": "La Ensenada",
                        "latitude": "8.36618000",
                        "longitude": "-78.84606000"
                    },
                    {
                        "id": 80251,
                        "name": "La Esmeralda",
                        "latitude": "8.26817000",
                        "longitude": "-78.92460000"
                    },
                    {
                        "id": 80256,
                        "name": "La Guinea",
                        "latitude": "8.34250000",
                        "longitude": "-78.93430000"
                    },
                    {
                        "id": 80264,
                        "name": "La Mesa",
                        "latitude": "9.17308000",
                        "longitude": "-79.27401000"
                    },
                    {
                        "id": 80288,
                        "name": "Las Cumbres",
                        "latitude": "9.08916000",
                        "longitude": "-79.52809000"
                    },
                    {
                        "id": 80297,
                        "name": "Las Margaritas",
                        "latitude": "9.18426000",
                        "longitude": "-79.08730000"
                    },
                    {
                        "id": 80345,
                        "name": "Lídice",
                        "latitude": "8.74869000",
                        "longitude": "-79.90974000"
                    },
                    {
                        "id": 80337,
                        "name": "Los Lotes",
                        "latitude": "9.12425000",
                        "longitude": "-79.28929000"
                    },
                    {
                        "id": 80372,
                        "name": "Nueva Esperanza",
                        "latitude": "9.10210000",
                        "longitude": "-79.33414000"
                    },
                    {
                        "id": 80375,
                        "name": "Nuevo Belén",
                        "latitude": "9.07939000",
                        "longitude": "-79.39556000"
                    },
                    {
                        "id": 80386,
                        "name": "Pacora",
                        "latitude": "9.07937000",
                        "longitude": "-79.28997000"
                    },
                    {
                        "id": 80394,
                        "name": "Panamá",
                        "latitude": "8.99360000",
                        "longitude": "-79.51973000"
                    },
                    {
                        "id": 80400,
                        "name": "Parque Lefevre",
                        "latitude": "9.01667000",
                        "longitude": "-79.48333000"
                    },
                    {
                        "id": 80441,
                        "name": "Pásiga",
                        "latitude": "8.93647000",
                        "longitude": "-78.90917000"
                    },
                    {
                        "id": 80404,
                        "name": "Pedregal",
                        "latitude": "9.06667000",
                        "longitude": "-79.43333000"
                    },
                    {
                        "id": 80456,
                        "name": "Río Abajo",
                        "latitude": "9.01667000",
                        "longitude": "-79.50000000"
                    },
                    {
                        "id": 80472,
                        "name": "San Antonio",
                        "latitude": "9.17290000",
                        "longitude": "-79.54743000"
                    },
                    {
                        "id": 80476,
                        "name": "San Felipe",
                        "latitude": "8.95118000",
                        "longitude": "-79.53726000"
                    },
                    {
                        "id": 80489,
                        "name": "San Miguel",
                        "latitude": "8.45685000",
                        "longitude": "-78.93695000"
                    },
                    {
                        "id": 80490,
                        "name": "San Miguelito",
                        "latitude": "9.05032000",
                        "longitude": "-79.47068000"
                    },
                    {
                        "id": 80494,
                        "name": "San Vicente",
                        "latitude": "9.11445000",
                        "longitude": "-79.59755000"
                    },
                    {
                        "id": 80524,
                        "name": "Tocumen",
                        "latitude": "9.08939000",
                        "longitude": "-79.38310000"
                    },
                    {
                        "id": 80527,
                        "name": "Tortí",
                        "latitude": "8.92132000",
                        "longitude": "-78.40546000"
                    },
                    {
                        "id": 80533,
                        "name": "Unión de Azuero",
                        "latitude": "9.15256000",
                        "longitude": "-79.17005000"
                    },
                    {
                        "id": 80532,
                        "name": "Unión Santeña",
                        "latitude": "8.83525000",
                        "longitude": "-78.65104000"
                    },
                    {
                        "id": 80546,
                        "name": "Villa Unida",
                        "latitude": "9.18908000",
                        "longitude": "-79.62452000"
                    },
                    {
                        "id": 80549,
                        "name": "Vista Hermosa",
                        "latitude": "9.11178000",
                        "longitude": "-79.36113000"
                    }
                ]
            },
            {
                "id": 1394,
                "name": "Panamá Oeste",
                "iso2": "10",
                "latitude": "8.80198830",
                "longitude": "-80.19597700",
                "type": "province",
                "cities": [
                    {
                        "id": 79966,
                        "name": "Alto del Espino",
                        "latitude": "8.84213000",
                        "longitude": "-79.84551000"
                    },
                    {
                        "id": 79967,
                        "name": "Altos de San Francisco",
                        "latitude": "8.86167000",
                        "longitude": "-79.79000000"
                    },
                    {
                        "id": 79971,
                        "name": "Arenosa",
                        "latitude": "9.03978000",
                        "longitude": "-79.95128000"
                    },
                    {
                        "id": 79972,
                        "name": "Arosemena",
                        "latitude": "8.97091000",
                        "longitude": "-79.96641000"
                    },
                    {
                        "id": 79973,
                        "name": "Arraiján",
                        "latitude": "8.95187000",
                        "longitude": "-79.66011000"
                    },
                    {
                        "id": 79989,
                        "name": "Bejuco",
                        "latitude": "8.60037000",
                        "longitude": "-79.88988000"
                    },
                    {
                        "id": 80008,
                        "name": "Buenos Aires",
                        "latitude": "8.63146000",
                        "longitude": "-79.94775000"
                    },
                    {
                        "id": 80016,
                        "name": "Cabuya",
                        "latitude": "8.57472000",
                        "longitude": "-79.92714000"
                    },
                    {
                        "id": 80020,
                        "name": "Caimito",
                        "latitude": "8.81143000",
                        "longitude": "-79.94738000"
                    },
                    {
                        "id": 80033,
                        "name": "Capira",
                        "latitude": "8.75636000",
                        "longitude": "-79.87996000"
                    },
                    {
                        "id": 80044,
                        "name": "Cermeño",
                        "latitude": "8.74082000",
                        "longitude": "-79.85299000"
                    },
                    {
                        "id": 80047,
                        "name": "Cerro Cama",
                        "latitude": "9.02802000",
                        "longitude": "-79.90744000"
                    },
                    {
                        "id": 80053,
                        "name": "Chame",
                        "latitude": "8.57753000",
                        "longitude": "-79.88595000"
                    },
                    {
                        "id": 80069,
                        "name": "Cirí de Los Sotos",
                        "latitude": "8.97206000",
                        "longitude": "-80.09209000"
                    },
                    {
                        "id": 80083,
                        "name": "Distrito Arraiján",
                        "latitude": "8.95000000",
                        "longitude": "-79.70000000"
                    },
                    {
                        "id": 80097,
                        "name": "Distrito de Capira",
                        "latitude": "8.76228000",
                        "longitude": "-79.88275000"
                    },
                    {
                        "id": 80100,
                        "name": "Distrito de Chame",
                        "latitude": "8.60000000",
                        "longitude": "-79.91667000"
                    },
                    {
                        "id": 80112,
                        "name": "Distrito de La Chorrera",
                        "latitude": "8.95000000",
                        "longitude": "-79.85000000"
                    },
                    {
                        "id": 80135,
                        "name": "Distrito de San Carlos",
                        "latitude": "8.53196000",
                        "longitude": "-80.06906000"
                    },
                    {
                        "id": 80152,
                        "name": "El Cacao",
                        "latitude": "8.76134000",
                        "longitude": "-80.01294000"
                    },
                    {
                        "id": 80164,
                        "name": "El Coco",
                        "latitude": "8.87009000",
                        "longitude": "-79.80415000"
                    },
                    {
                        "id": 80171,
                        "name": "El Espavé",
                        "latitude": "8.66161000",
                        "longitude": "-79.87584000"
                    },
                    {
                        "id": 80172,
                        "name": "El Espino",
                        "latitude": "8.83795000",
                        "longitude": "-79.84925000"
                    },
                    {
                        "id": 80178,
                        "name": "El Higo",
                        "latitude": "8.44731000",
                        "longitude": "-80.03603000"
                    },
                    {
                        "id": 80179,
                        "name": "El Líbano",
                        "latitude": "8.61685000",
                        "longitude": "-79.83483000"
                    },
                    {
                        "id": 80219,
                        "name": "Guadalupe",
                        "latitude": "8.85452000",
                        "longitude": "-79.81408000"
                    },
                    {
                        "id": 80227,
                        "name": "Guayabito",
                        "latitude": "8.54828000",
                        "longitude": "-80.01350000"
                    },
                    {
                        "id": 80232,
                        "name": "Hato Montaña",
                        "latitude": "8.91938000",
                        "longitude": "-79.73915000"
                    },
                    {
                        "id": 80243,
                        "name": "La Chorrera",
                        "latitude": "8.88028000",
                        "longitude": "-79.78333000"
                    },
                    {
                        "id": 80250,
                        "name": "La Ermita",
                        "latitude": "8.45622000",
                        "longitude": "-80.06835000"
                    },
                    {
                        "id": 80257,
                        "name": "La Herradura",
                        "latitude": "8.84848000",
                        "longitude": "-79.80404000"
                    },
                    {
                        "id": 80258,
                        "name": "La Laguna",
                        "latitude": "9.04404000",
                        "longitude": "-79.84215000"
                    },
                    {
                        "id": 80268,
                        "name": "La Mitra",
                        "latitude": "8.84091000",
                        "longitude": "-79.78648000"
                    },
                    {
                        "id": 80273,
                        "name": "La Pesa",
                        "latitude": "8.85073000",
                        "longitude": "-79.82374000"
                    },
                    {
                        "id": 80286,
                        "name": "Las Colinas",
                        "latitude": "8.55000000",
                        "longitude": "-80.08333000"
                    },
                    {
                        "id": 80294,
                        "name": "Las Lajas",
                        "latitude": "8.54963000",
                        "longitude": "-79.93521000"
                    },
                    {
                        "id": 80308,
                        "name": "Las Uvas",
                        "latitude": "8.45937000",
                        "longitude": "-80.00075000"
                    },
                    {
                        "id": 80318,
                        "name": "Llano Largo",
                        "latitude": "8.83463000",
                        "longitude": "-79.80765000"
                    },
                    {
                        "id": 80336,
                        "name": "Los Llanitos",
                        "latitude": "8.59787000",
                        "longitude": "-80.09503000"
                    },
                    {
                        "id": 80352,
                        "name": "Mendoza",
                        "latitude": "9.01471000",
                        "longitude": "-79.85073000"
                    },
                    {
                        "id": 80371,
                        "name": "Nueva Arenosa",
                        "latitude": "8.86944000",
                        "longitude": "-79.99472000"
                    },
                    {
                        "id": 80373,
                        "name": "Nueva Gorgona",
                        "latitude": "8.55000000",
                        "longitude": "-79.87547000"
                    },
                    {
                        "id": 80374,
                        "name": "Nuevo Arraiján",
                        "latitude": "8.92453000",
                        "longitude": "-79.72004000"
                    },
                    {
                        "id": 80377,
                        "name": "Nuevo Emperador",
                        "latitude": "9.00273000",
                        "longitude": "-79.73141000"
                    },
                    {
                        "id": 80416,
                        "name": "Playa Leona",
                        "latitude": "8.78389000",
                        "longitude": "-79.77547000"
                    },
                    {
                        "id": 80426,
                        "name": "Potrero Grande",
                        "latitude": "8.88051000",
                        "longitude": "-79.82795000"
                    },
                    {
                        "id": 80432,
                        "name": "Puerto Caimito",
                        "latitude": "8.87022000",
                        "longitude": "-79.71423000"
                    },
                    {
                        "id": 80458,
                        "name": "Río Congo",
                        "latitude": "8.96666000",
                        "longitude": "-79.76105000"
                    },
                    {
                        "id": 80475,
                        "name": "San Carlos",
                        "latitude": "8.47323000",
                        "longitude": "-79.96104000"
                    },
                    {
                        "id": 80483,
                        "name": "San José",
                        "latitude": "8.93333000",
                        "longitude": "-79.73333000"
                    },
                    {
                        "id": 80495,
                        "name": "San Vicente de Bique",
                        "latitude": "8.91143000",
                        "longitude": "-79.67360000"
                    },
                    {
                        "id": 80498,
                        "name": "Santa Clara",
                        "latitude": "9.02875000",
                        "longitude": "-79.75443000"
                    },
                    {
                        "id": 80505,
                        "name": "Santa Rita",
                        "latitude": "8.85681000",
                        "longitude": "-79.87954000"
                    },
                    {
                        "id": 80518,
                        "name": "Sorá",
                        "latitude": "8.63191000",
                        "longitude": "-80.00888000"
                    },
                    {
                        "id": 80540,
                        "name": "Veracruz",
                        "latitude": "8.88988000",
                        "longitude": "-79.62603000"
                    },
                    {
                        "id": 80543,
                        "name": "Villa Carmen",
                        "latitude": "8.79832000",
                        "longitude": "-79.86929000"
                    },
                    {
                        "id": 80545,
                        "name": "Villa Rosario",
                        "latitude": "8.77379000",
                        "longitude": "-79.87547000"
                    },
                    {
                        "id": 80547,
                        "name": "Vista Alegre",
                        "latitude": "8.92772000",
                        "longitude": "-79.70280000"
                    }
                ]
            },
            {
                "id": 1392,
                "name": "Veraguas",
                "iso2": "9",
                "latitude": "8.12310330",
                "longitude": "-81.07546570",
                "type": "province",
                "cities": [
                    {
                        "id": 79964,
                        "name": "Alto de Jesús",
                        "latitude": "8.26152000",
                        "longitude": "-81.48412000"
                    },
                    {
                        "id": 79970,
                        "name": "Arenas",
                        "latitude": "7.36865000",
                        "longitude": "-80.86268000"
                    },
                    {
                        "id": 79975,
                        "name": "Atalaya",
                        "latitude": "8.04213000",
                        "longitude": "-80.92528000"
                    },
                    {
                        "id": 79981,
                        "name": "Barnizal",
                        "latitude": "8.40460000",
                        "longitude": "-80.77765000"
                    },
                    {
                        "id": 79994,
                        "name": "Bisvalles",
                        "latitude": "8.18298000",
                        "longitude": "-81.22092000"
                    },
                    {
                        "id": 80001,
                        "name": "Boquerón",
                        "latitude": "8.24414000",
                        "longitude": "-80.85897000"
                    },
                    {
                        "id": 80004,
                        "name": "Boró",
                        "latitude": "8.16933000",
                        "longitude": "-81.30071000"
                    },
                    {
                        "id": 80022,
                        "name": "Calabacito",
                        "latitude": "8.24817000",
                        "longitude": "-81.08187000"
                    },
                    {
                        "id": 80024,
                        "name": "Calidonia",
                        "latitude": "7.95756000",
                        "longitude": "-81.38633000"
                    },
                    {
                        "id": 80025,
                        "name": "Calobre",
                        "latitude": "8.31886000",
                        "longitude": "-80.84067000"
                    },
                    {
                        "id": 80026,
                        "name": "Calovébora",
                        "latitude": "8.78703000",
                        "longitude": "-81.21056000"
                    },
                    {
                        "id": 80040,
                        "name": "Cañazas",
                        "latitude": "8.32004000",
                        "longitude": "-81.21152000"
                    },
                    {
                        "id": 80031,
                        "name": "Canto del Llano",
                        "latitude": "8.12472000",
                        "longitude": "-80.96374000"
                    },
                    {
                        "id": 80077,
                        "name": "Corozal",
                        "latitude": "8.07712000",
                        "longitude": "-81.43990000"
                    },
                    {
                        "id": 80089,
                        "name": "Distrito de Atalaya",
                        "latitude": "8.02899000",
                        "longitude": "-80.91739000"
                    },
                    {
                        "id": 80096,
                        "name": "Distrito de Calobre",
                        "latitude": "8.39684000",
                        "longitude": "-80.85124000"
                    },
                    {
                        "id": 80098,
                        "name": "Distrito de Cañazas",
                        "latitude": "8.35596000",
                        "longitude": "-81.28633000"
                    },
                    {
                        "id": 80113,
                        "name": "Distrito de La Mesa",
                        "latitude": "8.10976000",
                        "longitude": "-81.17767000"
                    },
                    {
                        "id": 80116,
                        "name": "Distrito de Las Palmas",
                        "latitude": "8.14532000",
                        "longitude": "-81.42849000"
                    },
                    {
                        "id": 80121,
                        "name": "Distrito de Montijo",
                        "latitude": "7.95316000",
                        "longitude": "-81.05301000"
                    },
                    {
                        "id": 80134,
                        "name": "Distrito de Río de Jesús",
                        "latitude": "7.91438000",
                        "longitude": "-81.16133000"
                    },
                    {
                        "id": 80136,
                        "name": "Distrito de San Francisco",
                        "latitude": "8.26965000",
                        "longitude": "-81.00108000"
                    },
                    {
                        "id": 80139,
                        "name": "Distrito de Santa Fé",
                        "latitude": "8.72063000",
                        "longitude": "-80.95858000"
                    },
                    {
                        "id": 80142,
                        "name": "Distrito de Santiago",
                        "latitude": "8.12425000",
                        "longitude": "-80.87827000"
                    },
                    {
                        "id": 80143,
                        "name": "Distrito de Soná",
                        "latitude": "7.84378000",
                        "longitude": "-81.36612000"
                    },
                    {
                        "id": 80149,
                        "name": "El Alto",
                        "latitude": "8.51191000",
                        "longitude": "-81.03646000"
                    },
                    {
                        "id": 80150,
                        "name": "El Barrito",
                        "latitude": "7.96059000",
                        "longitude": "-80.94801000"
                    },
                    {
                        "id": 80162,
                        "name": "El Coclá",
                        "latitude": "8.32143000",
                        "longitude": "-80.92069000"
                    },
                    {
                        "id": 80173,
                        "name": "El Espino de Santa Rosa",
                        "latitude": "8.09286000",
                        "longitude": "-80.82380000"
                    },
                    {
                        "id": 80182,
                        "name": "El Marañón",
                        "latitude": "8.03582000",
                        "longitude": "-81.21489000"
                    },
                    {
                        "id": 80183,
                        "name": "El María",
                        "latitude": "8.02905000",
                        "longitude": "-81.44384000"
                    },
                    {
                        "id": 80197,
                        "name": "El Pájaro",
                        "latitude": "7.95342000",
                        "longitude": "-81.12154000"
                    },
                    {
                        "id": 80187,
                        "name": "El Pantano",
                        "latitude": "8.53755000",
                        "longitude": "-81.06941000"
                    },
                    {
                        "id": 80190,
                        "name": "El Peñón",
                        "latitude": "8.35000000",
                        "longitude": "-80.97620000"
                    },
                    {
                        "id": 80191,
                        "name": "El Picador",
                        "latitude": "8.37803000",
                        "longitude": "-81.25621000"
                    },
                    {
                        "id": 80195,
                        "name": "El Potrero",
                        "latitude": "8.37692000",
                        "longitude": "-80.79434000"
                    },
                    {
                        "id": 80200,
                        "name": "El Rincón",
                        "latitude": "8.18422000",
                        "longitude": "-81.43333000"
                    },
                    {
                        "id": 80205,
                        "name": "El Uvito",
                        "latitude": "8.11648000",
                        "longitude": "-80.98461000"
                    },
                    {
                        "id": 80224,
                        "name": "Guarumal",
                        "latitude": "7.79404000",
                        "longitude": "-81.25904000"
                    },
                    {
                        "id": 80244,
                        "name": "La Colorada",
                        "latitude": "8.01319000",
                        "longitude": "-80.98590000"
                    },
                    {
                        "id": 80255,
                        "name": "La Garceana",
                        "latitude": "7.93708000",
                        "longitude": "-81.01643000"
                    },
                    {
                        "id": 80259,
                        "name": "La Laguna",
                        "latitude": "8.33882000",
                        "longitude": "-80.72949000"
                    },
                    {
                        "id": 80262,
                        "name": "La Loma",
                        "latitude": "7.43708000",
                        "longitude": "-80.89118000"
                    },
                    {
                        "id": 80263,
                        "name": "La Mesa",
                        "latitude": "8.14707000",
                        "longitude": "-81.18114000"
                    },
                    {
                        "id": 80269,
                        "name": "La Montañuela",
                        "latitude": "8.02487000",
                        "longitude": "-80.86325000"
                    },
                    {
                        "id": 80274,
                        "name": "La Peña",
                        "latitude": "8.12784000",
                        "longitude": "-81.02693000"
                    },
                    {
                        "id": 80276,
                        "name": "La Raya de Calobre",
                        "latitude": "8.21630000",
                        "longitude": "-80.82729000"
                    },
                    {
                        "id": 80277,
                        "name": "La Raya de Santa María",
                        "latitude": "8.16429000",
                        "longitude": "-80.82143000"
                    },
                    {
                        "id": 80281,
                        "name": "La Yeguada",
                        "latitude": "8.43060000",
                        "longitude": "-80.85752000"
                    },
                    {
                        "id": 80291,
                        "name": "Las Guías Abajo",
                        "latitude": "8.19451000",
                        "longitude": "-80.75494000"
                    },
                    {
                        "id": 80292,
                        "name": "Las Huacas",
                        "latitude": "7.90167000",
                        "longitude": "-81.14056000"
                    },
                    {
                        "id": 80302,
                        "name": "Las Palmas",
                        "latitude": "8.13564000",
                        "longitude": "-81.45674000"
                    },
                    {
                        "id": 80310,
                        "name": "Leones Arriba",
                        "latitude": "7.75415000",
                        "longitude": "-81.11556000"
                    },
                    {
                        "id": 80316,
                        "name": "Llano Grande",
                        "latitude": "8.07473000",
                        "longitude": "-81.13626000"
                    },
                    {
                        "id": 80324,
                        "name": "Lolá",
                        "latitude": "8.09326000",
                        "longitude": "-81.47163000"
                    },
                    {
                        "id": 80327,
                        "name": "Los Algarrobos",
                        "latitude": "8.10898000",
                        "longitude": "-81.01355000"
                    },
                    {
                        "id": 80332,
                        "name": "Los Castillos",
                        "latitude": "8.02326000",
                        "longitude": "-81.11941000"
                    },
                    {
                        "id": 80335,
                        "name": "Los Higos",
                        "latitude": "8.20553000",
                        "longitude": "-80.86022000"
                    },
                    {
                        "id": 80349,
                        "name": "Mariato District",
                        "latitude": "7.67810000",
                        "longitude": "-81.00409000"
                    },
                    {
                        "id": 80359,
                        "name": "Monjarás",
                        "latitude": "8.36942000",
                        "longitude": "-80.86667000"
                    },
                    {
                        "id": 80361,
                        "name": "Montijo",
                        "latitude": "7.98858000",
                        "longitude": "-81.05643000"
                    },
                    {
                        "id": 80412,
                        "name": "Piedras Gordas",
                        "latitude": "8.52419000",
                        "longitude": "-80.91152000"
                    },
                    {
                        "id": 80421,
                        "name": "Ponuga",
                        "latitude": "7.88245000",
                        "longitude": "-80.97880000"
                    },
                    {
                        "id": 80436,
                        "name": "Puerto Vidal",
                        "latitude": "8.04834000",
                        "longitude": "-81.60499000"
                    },
                    {
                        "id": 80446,
                        "name": "Quebrada de Oro",
                        "latitude": "8.03548000",
                        "longitude": "-81.38692000"
                    },
                    {
                        "id": 80466,
                        "name": "Río de Jesús",
                        "latitude": "7.97882000",
                        "longitude": "-81.16162000"
                    },
                    {
                        "id": 80461,
                        "name": "Río Grande",
                        "latitude": "7.71907000",
                        "longitude": "-81.33423000"
                    },
                    {
                        "id": 80454,
                        "name": "Rodeo Viejo",
                        "latitude": "8.11205000",
                        "longitude": "-81.31684000"
                    },
                    {
                        "id": 80473,
                        "name": "San Bartolo",
                        "latitude": "8.21063000",
                        "longitude": "-81.27572000"
                    },
                    {
                        "id": 80477,
                        "name": "San Francisco",
                        "latitude": "8.06667000",
                        "longitude": "-81.36667000"
                    },
                    {
                        "id": 80482,
                        "name": "San José",
                        "latitude": "8.46704000",
                        "longitude": "-80.80514000"
                    },
                    {
                        "id": 80484,
                        "name": "San Juan",
                        "latitude": "8.30311000",
                        "longitude": "-81.01575000"
                    },
                    {
                        "id": 80488,
                        "name": "San Marcelo",
                        "latitude": "8.27252000",
                        "longitude": "-81.15988000"
                    },
                    {
                        "id": 80493,
                        "name": "San Pedro del Espino",
                        "latitude": "8.14011000",
                        "longitude": "-81.08663000"
                    },
                    {
                        "id": 80501,
                        "name": "Santa Fé",
                        "latitude": "8.51063000",
                        "longitude": "-81.07802000"
                    },
                    {
                        "id": 80508,
                        "name": "Santiago de Veraguas",
                        "latitude": "8.10000000",
                        "longitude": "-80.98333000"
                    },
                    {
                        "id": 80516,
                        "name": "Soná",
                        "latitude": "8.01223000",
                        "longitude": "-81.32163000"
                    },
                    {
                        "id": 80519,
                        "name": "Tebario",
                        "latitude": "7.71369000",
                        "longitude": "-80.97825000"
                    },
                    {
                        "id": 80535,
                        "name": "Utirá",
                        "latitude": "7.97208000",
                        "longitude": "-81.21777000"
                    },
                    {
                        "id": 80542,
                        "name": "Viguí",
                        "latitude": "8.33921000",
                        "longitude": "-81.49823000"
                    },
                    {
                        "id": 80553,
                        "name": "Zapotillo",
                        "latitude": "8.00532000",
                        "longitude": "-81.50653000"
                    }
                ]
            }
        ]
    },
    {
        "id": 171,
        "name": "Papua New Guinea",
        "iso3": "PNG",
        "iso2": "PG",
        "numeric_code": "598",
        "phonecode": "675",
        "capital": "Port Moresby",
        "currency": "PGK",
        "currency_name": "Papua New Guinean kina",
        "currency_symbol": "K",
        "tld": ".pg",
        "native": "Papua Niugini",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Melanesia",
        "subregion_id": 20,
        "nationality": "Papua New Guinean, Papuan",
        "timezones": [
            {
                "zoneName": "Pacific\/Bougainville",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "BST",
                "tzName": "Bougainville Standard Time[6"
            },
            {
                "zoneName": "Pacific\/Port_Moresby",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "PGT",
                "tzName": "Papua New Guinea Time"
            }
        ],
        "translations": {
            "br": "Papoua Ginea-Nevez",
            "ko": "파푸아뉴기니",
            "pt-BR": "Papua Nova Guiné",
            "pt": "Papua Nova Guiné",
            "nl": "Papoea-Nieuw-Guinea",
            "hr": "Papua Nova Gvineja",
            "fa": "پاپوآ گینه نو",
            "de": "Papua-Neuguinea",
            "es": "Papúa Nueva Guinea",
            "fr": "Papouasie-Nouvelle-Guinée",
            "ja": "パプアニューギニア",
            "it": "Papua Nuova Guinea",
            "zh-CN": "巴布亚新几内亚",
            "tr": "Papua Yeni Gine",
            "ru": "Папуа - Новая Гвинея",
            "uk": "Папуа-Нова Гвінея",
            "pl": "Papua-Nowa Gwinea"
        },
        "latitude": "-6.00000000",
        "longitude": "147.00000000",
        "emoji": "🇵🇬",
        "emojiU": "U+1F1F5 U+1F1EC",
        "states": [
            {
                "id": 4831,
                "name": "Bougainville",
                "iso2": "NSB",
                "latitude": "-6.37539190",
                "longitude": "155.38071010",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 81029,
                        "name": "Arawa",
                        "latitude": "-6.22977000",
                        "longitude": "155.56598000"
                    },
                    {
                        "id": 81033,
                        "name": "Central Bougainville",
                        "latitude": "-6.22806000",
                        "longitude": "155.56583000"
                    },
                    {
                        "id": 81063,
                        "name": "Kieta",
                        "latitude": "-6.21462000",
                        "longitude": "155.63251000"
                    },
                    {
                        "id": 81091,
                        "name": "North Bougainville",
                        "latitude": "-5.42194000",
                        "longitude": "154.67278000"
                    },
                    {
                        "id": 81097,
                        "name": "Panguna",
                        "latitude": "-6.31639000",
                        "longitude": "155.48483000"
                    },
                    {
                        "id": 81109,
                        "name": "South Bougainville",
                        "latitude": "-6.74593000",
                        "longitude": "155.69640000"
                    }
                ]
            },
            {
                "id": 4847,
                "name": "Central",
                "iso2": "CPM",
                "latitude": "-9.08496860",
                "longitude": "146.70727330",
                "type": "province",
                "cities": [
                    {
                        "id": 81024,
                        "name": "Abau",
                        "latitude": "-10.08333000",
                        "longitude": "148.91667000"
                    },
                    {
                        "id": 81041,
                        "name": "Goilala",
                        "latitude": "-8.33333000",
                        "longitude": "147.00000000"
                    },
                    {
                        "id": 81055,
                        "name": "Kairuku-Hiri",
                        "latitude": "-9.13648000",
                        "longitude": "147.27905000"
                    },
                    {
                        "id": 81104,
                        "name": "Rigo",
                        "latitude": "-9.75000000",
                        "longitude": "147.83333000"
                    }
                ]
            },
            {
                "id": 4846,
                "name": "Chimbu",
                "iso2": "CPK",
                "latitude": "-6.30876820",
                "longitude": "144.87312190",
                "type": "province",
                "cities": [
                    {
                        "id": 81034,
                        "name": "Chuave",
                        "latitude": "-6.16667000",
                        "longitude": "145.08333000"
                    },
                    {
                        "id": 81043,
                        "name": "Gumine",
                        "latitude": "-6.25000000",
                        "longitude": "144.88333000"
                    },
                    {
                        "id": 81059,
                        "name": "Karimui Nomane",
                        "latitude": "-6.58333000",
                        "longitude": "144.83333000"
                    },
                    {
                        "id": 81062,
                        "name": "Kerowagi",
                        "latitude": "-5.93333000",
                        "longitude": "144.88333000"
                    },
                    {
                        "id": 81073,
                        "name": "Kundiawa",
                        "latitude": "-5.91667000",
                        "longitude": "145.05000000"
                    },
                    {
                        "id": 81107,
                        "name": "Sinasina Yonggamugl",
                        "latitude": "-6.08333000",
                        "longitude": "145.01667000"
                    }
                ]
            },
            {
                "id": 4834,
                "name": "East New Britain",
                "iso2": "EBR",
                "latitude": "-4.61289430",
                "longitude": "151.88773210",
                "type": "province",
                "cities": [
                    {
                        "id": 81040,
                        "name": "Gazelle",
                        "latitude": "-4.48333000",
                        "longitude": "151.86667000"
                    },
                    {
                        "id": 81069,
                        "name": "Kokopo",
                        "latitude": "-4.40000000",
                        "longitude": "152.28333000"
                    },
                    {
                        "id": 81098,
                        "name": "Pomio",
                        "latitude": "-5.50000000",
                        "longitude": "151.33333000"
                    },
                    {
                        "id": 81102,
                        "name": "Rabaul",
                        "latitude": "-4.18333000",
                        "longitude": "152.16667000"
                    }
                ]
            },
            {
                "id": 5228,
                "name": "East Sepik",
                "iso2": "ESW",
                "latitude": "-4.00000000",
                "longitude": "143.75000000",
                "type": "province",
                "cities": []
            },
            {
                "id": 4845,
                "name": "Eastern Highlands",
                "iso2": "EHG",
                "latitude": "-6.58616740",
                "longitude": "145.66896360",
                "type": "province",
                "cities": [
                    {
                        "id": 81036,
                        "name": "Daulo",
                        "latitude": "-5.98333000",
                        "longitude": "145.23333000"
                    },
                    {
                        "id": 81042,
                        "name": "Goroka",
                        "latitude": "-6.05000000",
                        "longitude": "145.38333000"
                    },
                    {
                        "id": 81045,
                        "name": "Henganofi",
                        "latitude": "-6.21667000",
                        "longitude": "145.66667000"
                    },
                    {
                        "id": 81054,
                        "name": "Kainantu",
                        "latitude": "-6.41667000",
                        "longitude": "145.91667000"
                    },
                    {
                        "id": 81077,
                        "name": "Lufa",
                        "latitude": "-6.45000000",
                        "longitude": "145.25000000"
                    },
                    {
                        "id": 81095,
                        "name": "Obura Wonenara",
                        "latitude": "-6.55434000",
                        "longitude": "145.97328000"
                    },
                    {
                        "id": 81096,
                        "name": "Okapa",
                        "latitude": "-6.63333000",
                        "longitude": "145.50000000"
                    },
                    {
                        "id": 81118,
                        "name": "Unggai Bena",
                        "latitude": "-6.11667000",
                        "longitude": "145.51667000"
                    }
                ]
            },
            {
                "id": 4848,
                "name": "Enga",
                "iso2": "EPW",
                "latitude": "-5.30058490",
                "longitude": "143.56356370",
                "type": "province",
                "cities": [
                    {
                        "id": 81056,
                        "name": "Kandep",
                        "latitude": "-5.83333000",
                        "longitude": "143.55000000"
                    },
                    {
                        "id": 81071,
                        "name": "Kompiam Ambum",
                        "latitude": "-5.25000000",
                        "longitude": "144.00000000"
                    },
                    {
                        "id": 81075,
                        "name": "Lagaip Porgera",
                        "latitude": "-5.38333000",
                        "longitude": "143.16667000"
                    },
                    {
                        "id": 81100,
                        "name": "Porgera",
                        "latitude": "-5.46300000",
                        "longitude": "143.14800000"
                    },
                    {
                        "id": 81122,
                        "name": "Wabag",
                        "latitude": "-5.33333000",
                        "longitude": "143.65000000"
                    },
                    {
                        "id": 81123,
                        "name": "Wapenamanda",
                        "latitude": "-5.66667000",
                        "longitude": "143.91667000"
                    }
                ]
            },
            {
                "id": 4839,
                "name": "Gulf",
                "iso2": "GPK",
                "latitude": "-7.64003290",
                "longitude": "142.18326770",
                "type": "province",
                "cities": [
                    {
                        "id": 81061,
                        "name": "Kerema",
                        "latitude": "-7.79600000",
                        "longitude": "146.09300000"
                    },
                    {
                        "id": 81064,
                        "name": "Kikori",
                        "latitude": "-7.25000000",
                        "longitude": "144.33333000"
                    }
                ]
            },
            {
                "id": 4833,
                "name": "Hela",
                "iso2": "HLA",
                "latitude": "-5.66131080",
                "longitude": "142.08998570",
                "type": "province",
                "cities": [
                    {
                        "id": 81070,
                        "name": "Komo Margarima",
                        "latitude": "-6.11667000",
                        "longitude": "143.00000000"
                    },
                    {
                        "id": 81072,
                        "name": "Koroba-Lake Kopiago",
                        "latitude": "-5.41667000",
                        "longitude": "142.50000000"
                    },
                    {
                        "id": 81114,
                        "name": "Tari",
                        "latitude": "-5.84500000",
                        "longitude": "142.94667000"
                    },
                    {
                        "id": 81115,
                        "name": "Tari Pori",
                        "latitude": "-6.28333000",
                        "longitude": "142.83333000"
                    }
                ]
            },
            {
                "id": 4832,
                "name": "Jiwaka",
                "iso2": "JWK",
                "latitude": "-5.86911540",
                "longitude": "144.69727740",
                "type": "province",
                "cities": [
                    {
                        "id": 81028,
                        "name": "Angalimp South Wahgi",
                        "latitude": "-6.05000000",
                        "longitude": "144.56667000"
                    },
                    {
                        "id": 81051,
                        "name": "Jimi",
                        "latitude": "-5.53333000",
                        "longitude": "144.56667000"
                    },
                    {
                        "id": 81093,
                        "name": "North Wahgi",
                        "latitude": "-5.80000000",
                        "longitude": "144.68333000"
                    }
                ]
            },
            {
                "id": 4843,
                "name": "Madang",
                "iso2": "MPM",
                "latitude": "-4.98497330",
                "longitude": "145.13758340",
                "type": "province",
                "cities": [
                    {
                        "id": 81031,
                        "name": "Bogia",
                        "latitude": "-4.50000000",
                        "longitude": "145.00000000"
                    },
                    {
                        "id": 81078,
                        "name": "Madang",
                        "latitude": "-5.22152000",
                        "longitude": "145.78695000"
                    },
                    {
                        "id": 81084,
                        "name": "Middle Ramu",
                        "latitude": "-4.91667000",
                        "longitude": "144.75000000"
                    },
                    {
                        "id": 81103,
                        "name": "Rai Coast",
                        "latitude": "-5.72303000",
                        "longitude": "146.46149000"
                    },
                    {
                        "id": 81111,
                        "name": "Sumkar",
                        "latitude": "-4.80000000",
                        "longitude": "145.55000000"
                    },
                    {
                        "id": 81119,
                        "name": "Usino Bundi",
                        "latitude": "-5.53333000",
                        "longitude": "145.16667000"
                    }
                ]
            },
            {
                "id": 4842,
                "name": "Manus",
                "iso2": "MRL",
                "latitude": "-2.09411690",
                "longitude": "146.87609510",
                "type": "province",
                "cities": [
                    {
                        "id": 81076,
                        "name": "Lorengau",
                        "latitude": "-2.03410000",
                        "longitude": "147.27173000"
                    },
                    {
                        "id": 81079,
                        "name": "Manus",
                        "latitude": "-2.09626000",
                        "longitude": "146.96612000"
                    }
                ]
            },
            {
                "id": 4849,
                "name": "Milne Bay",
                "iso2": "MBA",
                "latitude": "-9.52214510",
                "longitude": "150.67496530",
                "type": "province",
                "cities": [
                    {
                        "id": 81027,
                        "name": "Alotau",
                        "latitude": "-10.25000000",
                        "longitude": "150.08333000"
                    },
                    {
                        "id": 81038,
                        "name": "Esa’ala",
                        "latitude": "-9.58333000",
                        "longitude": "150.75000000"
                    },
                    {
                        "id": 81066,
                        "name": "Kiriwina Goodenough",
                        "latitude": "-8.48333000",
                        "longitude": "151.06667000"
                    },
                    {
                        "id": 81105,
                        "name": "Samarai",
                        "latitude": "-10.61038000",
                        "longitude": "150.66207000"
                    },
                    {
                        "id": 81106,
                        "name": "Samarai Murua",
                        "latitude": "-10.49636000",
                        "longitude": "150.54703000"
                    }
                ]
            },
            {
                "id": 4835,
                "name": "Morobe",
                "iso2": "MPL",
                "latitude": "-6.80137370",
                "longitude": "146.56164700",
                "type": "province",
                "cities": [
                    {
                        "id": 81032,
                        "name": "Bulolo",
                        "latitude": "-7.41667000",
                        "longitude": "146.75000000"
                    },
                    {
                        "id": 81039,
                        "name": "Finschhafen",
                        "latitude": "-6.41667000",
                        "longitude": "147.50000000"
                    },
                    {
                        "id": 81046,
                        "name": "Huon Gulf",
                        "latitude": "-7.18333000",
                        "longitude": "146.95000000"
                    },
                    {
                        "id": 81052,
                        "name": "Kabwum",
                        "latitude": "-6.08333000",
                        "longitude": "147.00000000"
                    },
                    {
                        "id": 81074,
                        "name": "Lae",
                        "latitude": "-6.50000000",
                        "longitude": "146.83333000"
                    },
                    {
                        "id": 81080,
                        "name": "Markham",
                        "latitude": "-6.64153000",
                        "longitude": "146.86043000"
                    },
                    {
                        "id": 81082,
                        "name": "Menyamya",
                        "latitude": "-7.25000000",
                        "longitude": "146.16667000"
                    },
                    {
                        "id": 81089,
                        "name": "Nawae",
                        "latitude": "-6.46667000",
                        "longitude": "146.96667000"
                    },
                    {
                        "id": 81117,
                        "name": "Tewai Siassi",
                        "latitude": "-6.15000000",
                        "longitude": "147.53333000"
                    },
                    {
                        "id": 81124,
                        "name": "Wau",
                        "latitude": "-7.33778000",
                        "longitude": "146.71649000"
                    }
                ]
            },
            {
                "id": 4841,
                "name": "New Ireland",
                "iso2": "NIK",
                "latitude": "-4.28532560",
                "longitude": "152.92059180",
                "type": "province",
                "cities": [
                    {
                        "id": 81060,
                        "name": "Kavieng",
                        "latitude": "-3.00000000",
                        "longitude": "151.41667000"
                    },
                    {
                        "id": 81087,
                        "name": "Namatanai",
                        "latitude": "-4.33333000",
                        "longitude": "152.83333000"
                    }
                ]
            },
            {
                "id": 4838,
                "name": "Oro",
                "iso2": "NPP",
                "latitude": "-8.89880630",
                "longitude": "148.18929210",
                "type": "province",
                "cities": [
                    {
                        "id": 81049,
                        "name": "Ijivitari",
                        "latitude": "-9.33333000",
                        "longitude": "148.58333000"
                    },
                    {
                        "id": 81068,
                        "name": "Kokoda",
                        "latitude": "-8.87778000",
                        "longitude": "147.73642000"
                    },
                    {
                        "id": 81099,
                        "name": "Popondetta",
                        "latitude": "-8.76536000",
                        "longitude": "148.23252000"
                    },
                    {
                        "id": 81108,
                        "name": "Sohe",
                        "latitude": "-9.00000000",
                        "longitude": "147.91667000"
                    }
                ]
            },
            {
                "id": 4837,
                "name": "Port Moresby",
                "iso2": "NCD",
                "latitude": "-9.44380040",
                "longitude": "147.18026710",
                "type": "district",
                "cities": [
                    {
                        "id": 81088,
                        "name": "National Capital District",
                        "latitude": "-9.42257000",
                        "longitude": "147.16641000"
                    },
                    {
                        "id": 81101,
                        "name": "Port Moresby",
                        "latitude": "-9.47723000",
                        "longitude": "147.15089000"
                    }
                ]
            },
            {
                "id": 4836,
                "name": "Sandaun",
                "iso2": "SAN",
                "latitude": "-3.71261790",
                "longitude": "141.68342750",
                "type": "province",
                "cities": [
                    {
                        "id": 81025,
                        "name": "Aitape",
                        "latitude": "-3.13697000",
                        "longitude": "142.34913000"
                    },
                    {
                        "id": 81026,
                        "name": "Aitape Lumi",
                        "latitude": "-3.25000000",
                        "longitude": "142.08333000"
                    },
                    {
                        "id": 81094,
                        "name": "Nuku",
                        "latitude": "-3.66667000",
                        "longitude": "142.41667000"
                    },
                    {
                        "id": 81116,
                        "name": "Telefomin",
                        "latitude": "-4.91667000",
                        "longitude": "141.66667000"
                    },
                    {
                        "id": 81120,
                        "name": "Vanimo",
                        "latitude": "-2.68372000",
                        "longitude": "141.30195000"
                    },
                    {
                        "id": 81121,
                        "name": "Vanimo Green",
                        "latitude": "-3.36667000",
                        "longitude": "141.35000000"
                    }
                ]
            },
            {
                "id": 4844,
                "name": "Southern Highlands",
                "iso2": "SHM",
                "latitude": "-6.41790830",
                "longitude": "143.56356370",
                "type": "province",
                "cities": [
                    {
                        "id": 81047,
                        "name": "Ialibu",
                        "latitude": "-6.28208000",
                        "longitude": "143.99354000"
                    },
                    {
                        "id": 81048,
                        "name": "Ialibu Pangia",
                        "latitude": "-6.16667000",
                        "longitude": "144.00000000"
                    },
                    {
                        "id": 81050,
                        "name": "Imbonggu",
                        "latitude": "-6.16667000",
                        "longitude": "144.00000000"
                    },
                    {
                        "id": 81053,
                        "name": "Kagua Erave",
                        "latitude": "-6.66667000",
                        "longitude": "144.00000000"
                    },
                    {
                        "id": 81081,
                        "name": "Mendi",
                        "latitude": "-6.14755000",
                        "longitude": "143.65633000"
                    },
                    {
                        "id": 81090,
                        "name": "Nipa Kutubu",
                        "latitude": "-6.33333000",
                        "longitude": "143.33333000"
                    }
                ]
            },
            {
                "id": 4830,
                "name": "West New Britain",
                "iso2": "WBK",
                "latitude": "-5.70474320",
                "longitude": "150.02594660",
                "type": "province",
                "cities": [
                    {
                        "id": 81057,
                        "name": "Kandrian",
                        "latitude": "-6.20655000",
                        "longitude": "149.54744000"
                    },
                    {
                        "id": 81058,
                        "name": "Kandrian Gloucester",
                        "latitude": "-6.08333000",
                        "longitude": "149.91667000"
                    },
                    {
                        "id": 81065,
                        "name": "Kimbe",
                        "latitude": "-5.55085000",
                        "longitude": "150.13766000"
                    },
                    {
                        "id": 81112,
                        "name": "Talasea",
                        "latitude": "-5.66667000",
                        "longitude": "149.58333000"
                    }
                ]
            },
            {
                "id": 4850,
                "name": "Western",
                "iso2": "WPD",
                "latitude": "-7.16375370",
                "longitude": "141.06357050",
                "type": "province",
                "cities": [
                    {
                        "id": 81035,
                        "name": "Daru",
                        "latitude": "-9.07786000",
                        "longitude": "143.20893000"
                    },
                    {
                        "id": 81067,
                        "name": "Kiunga",
                        "latitude": "-6.12193000",
                        "longitude": "141.29061000"
                    },
                    {
                        "id": 81083,
                        "name": "Middle Fly",
                        "latitude": "-7.16667000",
                        "longitude": "142.03333000"
                    },
                    {
                        "id": 81085,
                        "name": "Morehead",
                        "latitude": "-8.71065000",
                        "longitude": "141.63668000"
                    },
                    {
                        "id": 81092,
                        "name": "North Fly",
                        "latitude": "-5.72896000",
                        "longitude": "141.37482000"
                    },
                    {
                        "id": 81110,
                        "name": "South Fly",
                        "latitude": "-8.61667000",
                        "longitude": "142.11667000"
                    }
                ]
            },
            {
                "id": 4840,
                "name": "Western Highlands",
                "iso2": "WHM",
                "latitude": "-5.62681280",
                "longitude": "144.25931180",
                "type": "province",
                "cities": [
                    {
                        "id": 81030,
                        "name": "Baiyer Mul",
                        "latitude": "-5.53333000",
                        "longitude": "144.15000000"
                    },
                    {
                        "id": 81037,
                        "name": "Dei",
                        "latitude": "-5.68333000",
                        "longitude": "144.36667000"
                    },
                    {
                        "id": 81044,
                        "name": "Hagen",
                        "latitude": "-5.83333000",
                        "longitude": "144.28333000"
                    },
                    {
                        "id": 81086,
                        "name": "Mount Hagen",
                        "latitude": "-5.85746000",
                        "longitude": "144.23058000"
                    },
                    {
                        "id": 81113,
                        "name": "Tambul Nebilyer",
                        "latitude": "-5.98333000",
                        "longitude": "144.15000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 172,
        "name": "Paraguay",
        "iso3": "PRY",
        "iso2": "PY",
        "numeric_code": "600",
        "phonecode": "595",
        "capital": "Asuncion",
        "currency": "PYG",
        "currency_name": "Paraguayan guarani",
        "currency_symbol": "₲",
        "tld": ".py",
        "native": "Paraguay",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Paraguayan",
        "timezones": [
            {
                "zoneName": "America\/Asuncion",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "PYST",
                "tzName": "Paraguay Summer Time"
            }
        ],
        "translations": {
            "br": "Paraguay",
            "ko": "파라과이",
            "pt-BR": "Paraguai",
            "pt": "Paraguai",
            "nl": "Paraguay",
            "hr": "Paragvaj",
            "fa": "پاراگوئه",
            "de": "Paraguay",
            "es": "Paraguay",
            "fr": "Paraguay",
            "ja": "パラグアイ",
            "it": "Paraguay",
            "zh-CN": "巴拉圭",
            "tr": "Paraguay",
            "ru": "Парагвай",
            "uk": "Парагвай",
            "pl": "Paragwaj"
        },
        "latitude": "-23.00000000",
        "longitude": "-58.00000000",
        "emoji": "🇵🇾",
        "emojiU": "U+1F1F5 U+1F1FE",
        "states": [
            {
                "id": 2785,
                "name": "Alto Paraguay",
                "iso2": "16",
                "latitude": "-20.08525080",
                "longitude": "-59.47209040",
                "type": "department",
                "cities": [
                    {
                        "id": 89736,
                        "name": "Capitán Pablo Lagerenza",
                        "latitude": "-19.91667000",
                        "longitude": "-60.78333000"
                    },
                    {
                        "id": 89768,
                        "name": "Fuerte Olimpo",
                        "latitude": "-21.04153000",
                        "longitude": "-57.87377000"
                    }
                ]
            },
            {
                "id": 2784,
                "name": "Alto Paraná",
                "iso2": "10",
                "latitude": "-25.60755460",
                "longitude": "-54.96118360",
                "type": "department",
                "cities": [
                    {
                        "id": 89743,
                        "name": "Cedrales",
                        "latitude": "-25.65668000",
                        "longitude": "-54.72272000"
                    },
                    {
                        "id": 89745,
                        "name": "Ciudad del Este",
                        "latitude": "-25.50972000",
                        "longitude": "-54.61111000"
                    },
                    {
                        "id": 89751,
                        "name": "Colonia Minga Porá",
                        "latitude": "-24.86667000",
                        "longitude": "-54.90000000"
                    },
                    {
                        "id": 89759,
                        "name": "Doctor Juan León Mallorquín",
                        "latitude": "-25.43053000",
                        "longitude": "-55.25412000"
                    },
                    {
                        "id": 89782,
                        "name": "Itakyry",
                        "latitude": "-24.98611000",
                        "longitude": "-55.14963000"
                    },
                    {
                        "id": 89799,
                        "name": "Naranjal",
                        "latitude": "-25.96667000",
                        "longitude": "-55.18333000"
                    },
                    {
                        "id": 89812,
                        "name": "Presidente Franco",
                        "latitude": "-25.56384000",
                        "longitude": "-54.61097000"
                    },
                    {
                        "id": 89818,
                        "name": "San Alberto",
                        "latitude": "-24.96667000",
                        "longitude": "-54.90000000"
                    },
                    {
                        "id": 89835,
                        "name": "Santa Rita",
                        "latitude": "-25.78333000",
                        "longitude": "-55.06667000"
                    },
                    {
                        "id": 89852,
                        "name": "Yguazú",
                        "latitude": "-25.46187000",
                        "longitude": "-55.00007000"
                    }
                ]
            },
            {
                "id": 2782,
                "name": "Amambay",
                "iso2": "13",
                "latitude": "-22.55902720",
                "longitude": "-56.02499820",
                "type": "department",
                "cities": [
                    {
                        "id": 89725,
                        "name": "Bella Vista",
                        "latitude": "-22.13333000",
                        "longitude": "-56.51667000"
                    },
                    {
                        "id": 89734,
                        "name": "Capitán Bado",
                        "latitude": "-23.26667000",
                        "longitude": "-55.53333000"
                    },
                    {
                        "id": 89807,
                        "name": "Pedro Juan Caballero",
                        "latitude": "-22.54722000",
                        "longitude": "-55.73333000"
                    }
                ]
            },
            {
                "id": 5221,
                "name": "Asuncion",
                "iso2": "ASU",
                "latitude": "-25.29682970",
                "longitude": "-57.68066230",
                "type": "capital",
                "cities": []
            },
            {
                "id": 2780,
                "name": "Boquerón",
                "iso2": "19",
                "latitude": "-21.74492540",
                "longitude": "-60.95400730",
                "type": "department",
                "cities": [
                    {
                        "id": 89750,
                        "name": "Colonia Menno",
                        "latitude": "-22.36667000",
                        "longitude": "-59.81667000"
                    },
                    {
                        "id": 89752,
                        "name": "Colonia Neuland",
                        "latitude": "-22.66667000",
                        "longitude": "-60.11667000"
                    },
                    {
                        "id": 89766,
                        "name": "Filadelfia",
                        "latitude": "-22.33936000",
                        "longitude": "-60.03157000"
                    }
                ]
            },
            {
                "id": 2773,
                "name": "Caaguazú",
                "iso2": "5",
                "latitude": "-25.46458180",
                "longitude": "-56.01385100",
                "type": "department",
                "cities": [
                    {
                        "id": 89730,
                        "name": "Caaguazú",
                        "latitude": "-25.47104000",
                        "longitude": "-56.01603000"
                    },
                    {
                        "id": 89740,
                        "name": "Carayaó",
                        "latitude": "-25.19750000",
                        "longitude": "-56.39878000"
                    },
                    {
                        "id": 89742,
                        "name": "Cecilio Baez",
                        "latitude": "-25.07158000",
                        "longitude": "-56.24386000"
                    },
                    {
                        "id": 89748,
                        "name": "Colonia General Alfredo Stroessner",
                        "latitude": "-25.36395000",
                        "longitude": "-55.70690000"
                    },
                    {
                        "id": 89757,
                        "name": "Coronel Oviedo",
                        "latitude": "-25.44444000",
                        "longitude": "-56.44028000"
                    },
                    {
                        "id": 89760,
                        "name": "Doctor Juan Manuel Frutos",
                        "latitude": "-25.38380000",
                        "longitude": "-55.83215000"
                    },
                    {
                        "id": 89796,
                        "name": "Mbutuý",
                        "latitude": "-24.97518000",
                        "longitude": "-56.30927000"
                    },
                    {
                        "id": 89816,
                        "name": "Repatriación",
                        "latitude": "-25.53333000",
                        "longitude": "-55.95000000"
                    },
                    {
                        "id": 89823,
                        "name": "San Joaquín",
                        "latitude": "-25.02853000",
                        "longitude": "-56.04280000"
                    },
                    {
                        "id": 89824,
                        "name": "San José",
                        "latitude": "-25.53333000",
                        "longitude": "-56.73333000"
                    },
                    {
                        "id": 89853,
                        "name": "Yhú",
                        "latitude": "-25.05784000",
                        "longitude": "-55.92267000"
                    }
                ]
            },
            {
                "id": 2775,
                "name": "Caazapá",
                "iso2": "6",
                "latitude": "-26.18277130",
                "longitude": "-56.37123270",
                "type": "department",
                "cities": [
                    {
                        "id": 89716,
                        "name": "Abaí",
                        "latitude": "-26.03333000",
                        "longitude": "-55.93333000"
                    },
                    {
                        "id": 89728,
                        "name": "Buena Vista",
                        "latitude": "-26.18387000",
                        "longitude": "-56.08171000"
                    },
                    {
                        "id": 89732,
                        "name": "Caazapá",
                        "latitude": "-26.19583000",
                        "longitude": "-56.36806000"
                    },
                    {
                        "id": 89772,
                        "name": "General Higinio Morínigo",
                        "latitude": "-25.95000000",
                        "longitude": "-55.91667000"
                    },
                    {
                        "id": 89826,
                        "name": "San Juan Nepomuceno",
                        "latitude": "-26.11229000",
                        "longitude": "-55.93861000"
                    },
                    {
                        "id": 89850,
                        "name": "Yegros",
                        "latitude": "-26.45000000",
                        "longitude": "-56.40000000"
                    },
                    {
                        "id": 89855,
                        "name": "Yuty",
                        "latitude": "-26.61471000",
                        "longitude": "-56.24607000"
                    }
                ]
            },
            {
                "id": 2771,
                "name": "Canindeyú",
                "iso2": "14",
                "latitude": "-24.13787350",
                "longitude": "-55.66896360",
                "type": "department",
                "cities": [
                    {
                        "id": 89747,
                        "name": "Colonia Catuete",
                        "latitude": "-24.13333000",
                        "longitude": "-54.61667000"
                    },
                    {
                        "id": 89758,
                        "name": "Corpus Christi",
                        "latitude": "-24.08040000",
                        "longitude": "-54.93933000"
                    },
                    {
                        "id": 89790,
                        "name": "La Paloma",
                        "latitude": "-24.12957000",
                        "longitude": "-54.61376000"
                    },
                    {
                        "id": 89803,
                        "name": "Nueva Esperanza",
                        "latitude": "-24.50760000",
                        "longitude": "-54.85510000"
                    },
                    {
                        "id": 89817,
                        "name": "Salto del Guairá",
                        "latitude": "-24.06250000",
                        "longitude": "-54.30694000"
                    },
                    {
                        "id": 89822,
                        "name": "San Isidro de Curuguaty",
                        "latitude": "-24.47184000",
                        "longitude": "-55.69227000"
                    },
                    {
                        "id": 89851,
                        "name": "Ygatimi",
                        "latitude": "-24.12371000",
                        "longitude": "-55.64418000"
                    }
                ]
            },
            {
                "id": 2777,
                "name": "Central",
                "iso2": "11",
                "latitude": "36.15592290",
                "longitude": "-95.96620750",
                "type": "department",
                "cities": [
                    {
                        "id": 89720,
                        "name": "Areguá",
                        "latitude": "-25.31250000",
                        "longitude": "-57.38472000"
                    },
                    {
                        "id": 89733,
                        "name": "Capiatá",
                        "latitude": "-25.35520000",
                        "longitude": "-57.44545000"
                    },
                    {
                        "id": 89765,
                        "name": "Fernando de la Mora",
                        "latitude": "-25.33860000",
                        "longitude": "-57.52167000"
                    },
                    {
                        "id": 89774,
                        "name": "Guarambaré",
                        "latitude": "-25.49096000",
                        "longitude": "-57.45567000"
                    },
                    {
                        "id": 89786,
                        "name": "Itá",
                        "latitude": "-25.50054000",
                        "longitude": "-57.36717000"
                    },
                    {
                        "id": 89784,
                        "name": "Itauguá",
                        "latitude": "-25.39258000",
                        "longitude": "-57.35421000"
                    },
                    {
                        "id": 89791,
                        "name": "Lambaré",
                        "latitude": "-25.34682000",
                        "longitude": "-57.60647000"
                    },
                    {
                        "id": 89793,
                        "name": "Limpio",
                        "latitude": "-25.16611000",
                        "longitude": "-57.48562000"
                    },
                    {
                        "id": 89794,
                        "name": "Mariano Roque Alonso",
                        "latitude": "-25.20791000",
                        "longitude": "-57.53202000"
                    },
                    {
                        "id": 89802,
                        "name": "Nemby",
                        "latitude": "-25.39490000",
                        "longitude": "-57.53574000"
                    },
                    {
                        "id": 89804,
                        "name": "Nueva Italia",
                        "latitude": "-25.61080000",
                        "longitude": "-57.46563000"
                    },
                    {
                        "id": 89819,
                        "name": "San Antonio",
                        "latitude": "-25.42126000",
                        "longitude": "-57.54725000"
                    },
                    {
                        "id": 89828,
                        "name": "San Lorenzo",
                        "latitude": "-25.33968000",
                        "longitude": "-57.50879000"
                    },
                    {
                        "id": 89843,
                        "name": "Villa Elisa",
                        "latitude": "-25.36760000",
                        "longitude": "-57.59274000"
                    },
                    {
                        "id": 89854,
                        "name": "Ypacarai",
                        "latitude": "-25.40777000",
                        "longitude": "-57.28889000"
                    }
                ]
            },
            {
                "id": 2779,
                "name": "Concepción",
                "iso2": "1",
                "latitude": "-23.42142640",
                "longitude": "-57.43444510",
                "type": "department",
                "cities": [
                    {
                        "id": 89726,
                        "name": "Belén",
                        "latitude": "-23.46611000",
                        "longitude": "-57.26194000"
                    },
                    {
                        "id": 89755,
                        "name": "Concepción",
                        "latitude": "-23.39985000",
                        "longitude": "-57.43236000"
                    },
                    {
                        "id": 89777,
                        "name": "Horqueta",
                        "latitude": "-23.34278000",
                        "longitude": "-57.05972000"
                    }
                ]
            },
            {
                "id": 2783,
                "name": "Cordillera",
                "iso2": "3",
                "latitude": "-25.22894910",
                "longitude": "-57.01116810",
                "type": "department",
                "cities": [
                    {
                        "id": 89718,
                        "name": "Altos",
                        "latitude": "-25.26263000",
                        "longitude": "-57.25443000"
                    },
                    {
                        "id": 89722,
                        "name": "Arroyos y Esteros",
                        "latitude": "-25.05478000",
                        "longitude": "-57.09873000"
                    },
                    {
                        "id": 89723,
                        "name": "Atyrá",
                        "latitude": "-25.27876000",
                        "longitude": "-57.17192000"
                    },
                    {
                        "id": 89729,
                        "name": "Caacupé",
                        "latitude": "-25.38575000",
                        "longitude": "-57.14217000"
                    },
                    {
                        "id": 89738,
                        "name": "Caraguatay",
                        "latitude": "-25.23844000",
                        "longitude": "-56.82693000"
                    },
                    {
                        "id": 89762,
                        "name": "Emboscada",
                        "latitude": "-25.15000000",
                        "longitude": "-57.35000000"
                    },
                    {
                        "id": 89764,
                        "name": "Eusebio Ayala",
                        "latitude": "-25.38276000",
                        "longitude": "-56.96088000"
                    },
                    {
                        "id": 89779,
                        "name": "Isla Pucú",
                        "latitude": "-25.30853000",
                        "longitude": "-56.89986000"
                    },
                    {
                        "id": 89780,
                        "name": "Itacurubí de la Cordillera",
                        "latitude": "-25.46158000",
                        "longitude": "-56.85333000"
                    },
                    {
                        "id": 89811,
                        "name": "Piribebuy",
                        "latitude": "-25.46498000",
                        "longitude": "-57.04183000"
                    },
                    {
                        "id": 89820,
                        "name": "San Bernardino",
                        "latitude": "-25.31067000",
                        "longitude": "-57.29628000"
                    },
                    {
                        "id": 89833,
                        "name": "Santa Elena",
                        "latitude": "-25.41327000",
                        "longitude": "-56.79708000"
                    },
                    {
                        "id": 89840,
                        "name": "Tobatí",
                        "latitude": "-25.26111000",
                        "longitude": "-57.08329000"
                    }
                ]
            },
            {
                "id": 2772,
                "name": "Guairá",
                "iso2": "4",
                "latitude": "-25.88109320",
                "longitude": "-56.29293810",
                "type": "department",
                "cities": [
                    {
                        "id": 89749,
                        "name": "Colonia Mauricio José Troche",
                        "latitude": "-25.56667000",
                        "longitude": "-56.28333000"
                    },
                    {
                        "id": 89756,
                        "name": "Coronel Martínez",
                        "latitude": "-25.75862000",
                        "longitude": "-56.61677000"
                    },
                    {
                        "id": 89778,
                        "name": "Independencia",
                        "latitude": "-25.69100000",
                        "longitude": "-56.26781000"
                    },
                    {
                        "id": 89783,
                        "name": "Itapé",
                        "latitude": "-25.85172000",
                        "longitude": "-56.61385000"
                    },
                    {
                        "id": 89785,
                        "name": "Iturbe",
                        "latitude": "-26.05508000",
                        "longitude": "-56.48463000"
                    },
                    {
                        "id": 89795,
                        "name": "Mbocayaty",
                        "latitude": "-25.71938000",
                        "longitude": "-56.42179000"
                    },
                    {
                        "id": 89800,
                        "name": "Natalicio Talavera",
                        "latitude": "-25.63333000",
                        "longitude": "-56.30000000"
                    },
                    {
                        "id": 89846,
                        "name": "Villarrica",
                        "latitude": "-25.74946000",
                        "longitude": "-56.43518000"
                    }
                ]
            },
            {
                "id": 2778,
                "name": "Itapúa",
                "iso2": "7",
                "latitude": "-26.79236230",
                "longitude": "-55.66896360",
                "type": "department",
                "cities": [
                    {
                        "id": 89721,
                        "name": "Arquitecto Tomás Romero Pereira",
                        "latitude": "-26.48333000",
                        "longitude": "-55.25000000"
                    },
                    {
                        "id": 89724,
                        "name": "Bella Vista",
                        "latitude": "-27.05000000",
                        "longitude": "-55.55000000"
                    },
                    {
                        "id": 89735,
                        "name": "Capitán Miranda",
                        "latitude": "-27.20000000",
                        "longitude": "-55.80000000"
                    },
                    {
                        "id": 89741,
                        "name": "Carmen del Paraná",
                        "latitude": "-27.22232000",
                        "longitude": "-56.15243000"
                    },
                    {
                        "id": 89746,
                        "name": "Colonia Carlos Antonio López",
                        "latitude": "-26.39853000",
                        "longitude": "-54.75690000"
                    },
                    {
                        "id": 89754,
                        "name": "Colonia San Lorenzo",
                        "latitude": "-26.49324000",
                        "longitude": "-54.79989000"
                    },
                    {
                        "id": 89761,
                        "name": "Edelira",
                        "latitude": "-26.76734000",
                        "longitude": "-55.27872000"
                    },
                    {
                        "id": 89763,
                        "name": "Encarnación",
                        "latitude": "-27.33056000",
                        "longitude": "-55.86667000"
                    },
                    {
                        "id": 89767,
                        "name": "Fram",
                        "latitude": "-26.98333000",
                        "longitude": "-55.88333000"
                    },
                    {
                        "id": 89769,
                        "name": "General Artigas",
                        "latitude": "-26.93522000",
                        "longitude": "-56.22168000"
                    },
                    {
                        "id": 89770,
                        "name": "General Delgado",
                        "latitude": "-27.09046000",
                        "longitude": "-56.52474000"
                    },
                    {
                        "id": 89776,
                        "name": "Hohenau",
                        "latitude": "-27.07315000",
                        "longitude": "-55.64247000"
                    },
                    {
                        "id": 89787,
                        "name": "Jesús",
                        "latitude": "-27.05598000",
                        "longitude": "-55.74130000"
                    },
                    {
                        "id": 89801,
                        "name": "Natalio",
                        "latitude": "-26.75702000",
                        "longitude": "-55.13777000"
                    },
                    {
                        "id": 89805,
                        "name": "Obligado",
                        "latitude": "-27.03333000",
                        "longitude": "-55.63333000"
                    },
                    {
                        "id": 89809,
                        "name": "Pirapó",
                        "latitude": "-26.86012000",
                        "longitude": "-55.54357000"
                    },
                    {
                        "id": 89813,
                        "name": "Puerto Mayor Otaño",
                        "latitude": "-26.40000000",
                        "longitude": "-54.70000000"
                    },
                    {
                        "id": 89821,
                        "name": "San Cosme y Damián",
                        "latitude": "-27.31741000",
                        "longitude": "-56.33087000"
                    },
                    {
                        "id": 89827,
                        "name": "San Juan del Paraná",
                        "latitude": "-27.30168000",
                        "longitude": "-55.96509000"
                    },
                    {
                        "id": 89832,
                        "name": "San Pedro del Paraná",
                        "latitude": "-26.83268000",
                        "longitude": "-56.20575000"
                    },
                    {
                        "id": 89841,
                        "name": "Trinidad",
                        "latitude": "-27.11667000",
                        "longitude": "-55.78333000"
                    }
                ]
            },
            {
                "id": 2786,
                "name": "Misiones",
                "iso2": "8",
                "latitude": "-26.84335120",
                "longitude": "-57.10131880",
                "type": "department",
                "cities": [
                    {
                        "id": 89788,
                        "name": "Juan de Ayolas",
                        "latitude": "-27.38662000",
                        "longitude": "-56.84724000"
                    },
                    {
                        "id": 89825,
                        "name": "San Juan Bautista",
                        "latitude": "-26.66944000",
                        "longitude": "-57.14583000"
                    },
                    {
                        "id": 89829,
                        "name": "San Miguel",
                        "latitude": "-26.50000000",
                        "longitude": "-57.05000000"
                    },
                    {
                        "id": 89830,
                        "name": "San Patricio",
                        "latitude": "-26.96667000",
                        "longitude": "-56.81667000"
                    },
                    {
                        "id": 89834,
                        "name": "Santa María",
                        "latitude": "-26.78333000",
                        "longitude": "-56.93333000"
                    },
                    {
                        "id": 89836,
                        "name": "Santa Rosa Misiones",
                        "latitude": "-26.88730000",
                        "longitude": "-56.84905000"
                    },
                    {
                        "id": 89837,
                        "name": "Santiago",
                        "latitude": "-27.14310000",
                        "longitude": "-56.76803000"
                    },
                    {
                        "id": 89844,
                        "name": "Villa Florida",
                        "latitude": "-26.38333000",
                        "longitude": "-57.15000000"
                    }
                ]
            },
            {
                "id": 2781,
                "name": "Ñeembucú",
                "iso2": "12",
                "latitude": "-27.02991140",
                "longitude": "-57.82539500",
                "type": "department",
                "cities": [
                    {
                        "id": 89744,
                        "name": "Cerrito",
                        "latitude": "-27.34215000",
                        "longitude": "-57.64119000"
                    },
                    {
                        "id": 89773,
                        "name": "General José Eduvigis Díaz",
                        "latitude": "-27.20136000",
                        "longitude": "-58.36740000"
                    },
                    {
                        "id": 89808,
                        "name": "Pilar",
                        "latitude": "-26.85874000",
                        "longitude": "-58.30639000"
                    }
                ]
            },
            {
                "id": 2774,
                "name": "Paraguarí",
                "iso2": "9",
                "latitude": "-25.62621740",
                "longitude": "-57.15206420",
                "type": "department",
                "cities": [
                    {
                        "id": 89717,
                        "name": "Acahay",
                        "latitude": "-25.91667000",
                        "longitude": "-57.15000000"
                    },
                    {
                        "id": 89731,
                        "name": "Caapucú",
                        "latitude": "-26.23523000",
                        "longitude": "-57.18212000"
                    },
                    {
                        "id": 89739,
                        "name": "Carapeguá",
                        "latitude": "-25.80000000",
                        "longitude": "-57.23333000"
                    },
                    {
                        "id": 89789,
                        "name": "La Colmena",
                        "latitude": "-25.88627000",
                        "longitude": "-56.84084000"
                    },
                    {
                        "id": 89797,
                        "name": "Mbuyapey",
                        "latitude": "-26.21921000",
                        "longitude": "-56.75777000"
                    },
                    {
                        "id": 89806,
                        "name": "Paraguarí",
                        "latitude": "-25.62083000",
                        "longitude": "-57.14722000"
                    },
                    {
                        "id": 89810,
                        "name": "Pirayú",
                        "latitude": "-25.48406000",
                        "longitude": "-57.23490000"
                    },
                    {
                        "id": 89815,
                        "name": "Quiindy",
                        "latitude": "-25.97606000",
                        "longitude": "-57.23353000"
                    },
                    {
                        "id": 89838,
                        "name": "Sapucaí",
                        "latitude": "-25.66652000",
                        "longitude": "-56.95215000"
                    },
                    {
                        "id": 89847,
                        "name": "Yaguarón",
                        "latitude": "-25.56139000",
                        "longitude": "-57.28343000"
                    },
                    {
                        "id": 89849,
                        "name": "Ybycuí",
                        "latitude": "-26.01667000",
                        "longitude": "-57.05000000"
                    }
                ]
            },
            {
                "id": 2770,
                "name": "Presidente Hayes",
                "iso2": "15",
                "latitude": "-23.35126050",
                "longitude": "-58.73736340",
                "type": "department",
                "cities": [
                    {
                        "id": 89727,
                        "name": "Benjamín Aceval",
                        "latitude": "-24.96667000",
                        "longitude": "-57.56667000"
                    },
                    {
                        "id": 89798,
                        "name": "Nanawua",
                        "latitude": "-25.27930000",
                        "longitude": "-57.70307000"
                    },
                    {
                        "id": 89845,
                        "name": "Villa Hayes",
                        "latitude": "-25.09306000",
                        "longitude": "-57.52361000"
                    }
                ]
            },
            {
                "id": 2776,
                "name": "San Pedro",
                "iso2": "2",
                "latitude": "-24.19486680",
                "longitude": "-56.56164700",
                "type": "department",
                "cities": [
                    {
                        "id": 89719,
                        "name": "Antequera",
                        "latitude": "-24.08526000",
                        "longitude": "-57.20221000"
                    },
                    {
                        "id": 89737,
                        "name": "Capiíbary",
                        "latitude": "-24.80000000",
                        "longitude": "-56.03333000"
                    },
                    {
                        "id": 89753,
                        "name": "Colonia Nueva Germania",
                        "latitude": "-23.91137000",
                        "longitude": "-56.70091000"
                    },
                    {
                        "id": 89771,
                        "name": "General Elizardo Aquino",
                        "latitude": "-24.44417000",
                        "longitude": "-56.90061000"
                    },
                    {
                        "id": 89775,
                        "name": "Guayaybi",
                        "latitude": "-24.53333000",
                        "longitude": "-56.43333000"
                    },
                    {
                        "id": 89781,
                        "name": "Itacurubí del Rosario",
                        "latitude": "-24.53541000",
                        "longitude": "-56.82352000"
                    },
                    {
                        "id": 89792,
                        "name": "Lima",
                        "latitude": "-23.88327000",
                        "longitude": "-56.48217000"
                    },
                    {
                        "id": 89814,
                        "name": "Puerto Rosario",
                        "latitude": "-24.44127000",
                        "longitude": "-57.14272000"
                    },
                    {
                        "id": 89831,
                        "name": "San Pedro de Ycuamandiyú",
                        "latitude": "-24.08534000",
                        "longitude": "-57.08745000"
                    },
                    {
                        "id": 89839,
                        "name": "Tacuatí",
                        "latitude": "-23.45000000",
                        "longitude": "-56.58333000"
                    },
                    {
                        "id": 89842,
                        "name": "Unión",
                        "latitude": "-24.80790000",
                        "longitude": "-56.52148000"
                    },
                    {
                        "id": 89848,
                        "name": "Yataity del Norte",
                        "latitude": "-24.83333000",
                        "longitude": "-56.35000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 173,
        "name": "Peru",
        "iso3": "PER",
        "iso2": "PE",
        "numeric_code": "604",
        "phonecode": "51",
        "capital": "Lima",
        "currency": "PEN",
        "currency_name": "Peruvian sol",
        "currency_symbol": "S\/.",
        "tld": ".pe",
        "native": "Perú",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Peruvian",
        "timezones": [
            {
                "zoneName": "America\/Lima",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "PET",
                "tzName": "Peru Time"
            }
        ],
        "translations": {
            "br": "Perou",
            "ko": "페루",
            "pt-BR": "Peru",
            "pt": "Peru",
            "nl": "Peru",
            "hr": "Peru",
            "fa": "پرو",
            "de": "Peru",
            "es": "Perú",
            "fr": "Pérou",
            "ja": "ペルー",
            "it": "Perù",
            "zh-CN": "秘鲁",
            "tr": "Peru",
            "ru": "Перу",
            "uk": "Перу",
            "pl": "Peru"
        },
        "latitude": "-10.00000000",
        "longitude": "-76.00000000",
        "emoji": "🇵🇪",
        "emojiU": "U+1F1F5 U+1F1EA",
        "states": [
            {
                "id": 3685,
                "name": "Amazonas",
                "iso2": "AMA",
                "latitude": "-4.98563270",
                "longitude": "-79.24174360",
                "type": "region",
                "cities": [
                    {
                        "id": 80572,
                        "name": "Bagua Grande",
                        "latitude": "-5.75611000",
                        "longitude": "-78.44111000"
                    },
                    {
                        "id": 80582,
                        "name": "Cajaruro",
                        "latitude": "-5.73639000",
                        "longitude": "-78.42556000"
                    },
                    {
                        "id": 80602,
                        "name": "Chachapoyas",
                        "latitude": "-6.23169000",
                        "longitude": "-77.86903000"
                    },
                    {
                        "id": 80632,
                        "name": "Condorcanqui",
                        "latitude": "-4.16515000",
                        "longitude": "-78.03840000"
                    },
                    {
                        "id": 80689,
                        "name": "La Peca",
                        "latitude": "-5.61111000",
                        "longitude": "-78.43500000"
                    },
                    {
                        "id": 80781,
                        "name": "Provincia de Bagua",
                        "latitude": "-5.09006000",
                        "longitude": "-78.39972000"
                    },
                    {
                        "id": 80784,
                        "name": "Provincia de Bongará",
                        "latitude": "-5.68341000",
                        "longitude": "-77.87308000"
                    },
                    {
                        "id": 80803,
                        "name": "Provincia de Chachapoyas",
                        "latitude": "-6.27480000",
                        "longitude": "-77.81067000"
                    },
                    {
                        "id": 80857,
                        "name": "Provincia de Luya",
                        "latitude": "-6.41667000",
                        "longitude": "-78.00000000"
                    },
                    {
                        "id": 80885,
                        "name": "Provincia de Rodríguez de Mendoza",
                        "latitude": "-6.33333000",
                        "longitude": "-77.41667000"
                    },
                    {
                        "id": 81006,
                        "name": "Utcubamba",
                        "latitude": "-5.77031000",
                        "longitude": "-78.32850000"
                    }
                ]
            },
            {
                "id": 3680,
                "name": "Áncash",
                "iso2": "ANC",
                "latitude": "-9.32504970",
                "longitude": "-77.56194190",
                "type": "region",
                "cities": [
                    {
                        "id": 80564,
                        "name": "Asuncion",
                        "latitude": "-9.18987000",
                        "longitude": "-77.39878000"
                    },
                    {
                        "id": 80594,
                        "name": "Carás",
                        "latitude": "-9.04692000",
                        "longitude": "-77.80901000"
                    },
                    {
                        "id": 80592,
                        "name": "Carhuaz",
                        "latitude": "-9.28194000",
                        "longitude": "-77.64472000"
                    },
                    {
                        "id": 80593,
                        "name": "Carlos Fermin Fitzcarrald",
                        "latitude": "-9.04415000",
                        "longitude": "-77.24168000"
                    },
                    {
                        "id": 80615,
                        "name": "Chimbote",
                        "latitude": "-9.08528000",
                        "longitude": "-78.57833000"
                    },
                    {
                        "id": 80628,
                        "name": "Coishco",
                        "latitude": "-9.02306000",
                        "longitude": "-78.61556000"
                    },
                    {
                        "id": 80656,
                        "name": "Huaraz",
                        "latitude": "-9.52779000",
                        "longitude": "-77.52778000"
                    },
                    {
                        "id": 80658,
                        "name": "Huarmey",
                        "latitude": "-10.06806000",
                        "longitude": "-78.15222000"
                    },
                    {
                        "id": 80766,
                        "name": "Pomabamba",
                        "latitude": "-8.83333000",
                        "longitude": "-77.46667000"
                    },
                    {
                        "id": 80770,
                        "name": "Provincia de Aija",
                        "latitude": "-9.83333000",
                        "longitude": "-77.66667000"
                    },
                    {
                        "id": 80776,
                        "name": "Provincia de Antonio Raymondi",
                        "latitude": "-9.08333000",
                        "longitude": "-77.08333000"
                    },
                    {
                        "id": 80782,
                        "name": "Provincia de Bolognesi",
                        "latitude": "-10.10723000",
                        "longitude": "-77.14804000"
                    },
                    {
                        "id": 80796,
                        "name": "Provincia de Carhuaz",
                        "latitude": "-9.31700000",
                        "longitude": "-77.55100000"
                    },
                    {
                        "id": 80797,
                        "name": "Provincia de Casma",
                        "latitude": "-9.47638000",
                        "longitude": "-78.24738000"
                    },
                    {
                        "id": 80816,
                        "name": "Provincia de Corongo",
                        "latitude": "-8.58333000",
                        "longitude": "-77.91667000"
                    },
                    {
                        "id": 80837,
                        "name": "Provincia de Huaraz",
                        "latitude": "-9.56109000",
                        "longitude": "-77.64605000"
                    },
                    {
                        "id": 80838,
                        "name": "Provincia de Huari",
                        "latitude": "-9.33333000",
                        "longitude": "-77.16667000"
                    },
                    {
                        "id": 80839,
                        "name": "Provincia de Huarmey",
                        "latitude": "-9.91667000",
                        "longitude": "-78.00000000"
                    },
                    {
                        "id": 80841,
                        "name": "Provincia de Huaylas",
                        "latitude": "-8.91667000",
                        "longitude": "-77.83333000"
                    },
                    {
                        "id": 80861,
                        "name": "Provincia de Mariscal Luzuriaga",
                        "latitude": "-8.83333000",
                        "longitude": "-77.25000000"
                    },
                    {
                        "id": 80871,
                        "name": "Provincia de Pallasca",
                        "latitude": "-8.33333000",
                        "longitude": "-77.91667000"
                    },
                    {
                        "id": 80880,
                        "name": "Provincia de Pomabamba",
                        "latitude": "-8.82311000",
                        "longitude": "-77.47559000"
                    },
                    {
                        "id": 80883,
                        "name": "Provincia de Recuay",
                        "latitude": "-10.00000000",
                        "longitude": "-77.41667000"
                    },
                    {
                        "id": 80890,
                        "name": "Provincia de Santa",
                        "latitude": "-9.00000000",
                        "longitude": "-78.25000000"
                    },
                    {
                        "id": 80894,
                        "name": "Provincia de Sihuas",
                        "latitude": "-8.50000000",
                        "longitude": "-77.50000000"
                    },
                    {
                        "id": 80911,
                        "name": "Provincia de Yungay",
                        "latitude": "-9.16667000",
                        "longitude": "-77.75000000"
                    },
                    {
                        "id": 80919,
                        "name": "Puerto Santa",
                        "latitude": "-8.98772000",
                        "longitude": "-78.64727000"
                    },
                    {
                        "id": 81017,
                        "name": "Yauya",
                        "latitude": "-8.98333000",
                        "longitude": "-77.30000000"
                    },
                    {
                        "id": 81018,
                        "name": "Yungay",
                        "latitude": "-9.13833000",
                        "longitude": "-77.74361000"
                    }
                ]
            },
            {
                "id": 3699,
                "name": "Apurímac",
                "iso2": "APU",
                "latitude": "-14.05045330",
                "longitude": "-73.08774900",
                "type": "region",
                "cities": [
                    {
                        "id": 80554,
                        "name": "Abancay",
                        "latitude": "-13.63389000",
                        "longitude": "-72.88139000"
                    },
                    {
                        "id": 80559,
                        "name": "Andahuaylas",
                        "latitude": "-13.65556000",
                        "longitude": "-73.38722000"
                    },
                    {
                        "id": 80767,
                        "name": "Provincia de Abancay",
                        "latitude": "-13.66667000",
                        "longitude": "-72.91667000"
                    },
                    {
                        "id": 80772,
                        "name": "Provincia de Andahuaylas",
                        "latitude": "-13.66667000",
                        "longitude": "-73.41667000"
                    },
                    {
                        "id": 80775,
                        "name": "Provincia de Antabamba",
                        "latitude": "-14.41667000",
                        "longitude": "-72.75000000"
                    },
                    {
                        "id": 80779,
                        "name": "Provincia de Aymaraes",
                        "latitude": "-14.41667000",
                        "longitude": "-73.25000000"
                    },
                    {
                        "id": 80817,
                        "name": "Provincia de Cotabambas",
                        "latitude": "-14.00000000",
                        "longitude": "-72.20000000"
                    },
                    {
                        "id": 80825,
                        "name": "Provincia de Grau",
                        "latitude": "-14.00000000",
                        "longitude": "-72.58333000"
                    },
                    {
                        "id": 80946,
                        "name": "San Jerónimo",
                        "latitude": "-13.65138000",
                        "longitude": "-73.36388000"
                    },
                    {
                        "id": 80984,
                        "name": "Talavera",
                        "latitude": "-13.65306000",
                        "longitude": "-73.42917000"
                    }
                ]
            },
            {
                "id": 3681,
                "name": "Arequipa",
                "iso2": "ARE",
                "latitude": "-16.40904740",
                "longitude": "-71.53745100",
                "type": "region",
                "cities": [
                    {
                        "id": 80555,
                        "name": "Acarí",
                        "latitude": "-15.42393000",
                        "longitude": "-74.61361000"
                    },
                    {
                        "id": 80561,
                        "name": "Arequipa",
                        "latitude": "-16.39889000",
                        "longitude": "-71.53500000"
                    },
                    {
                        "id": 80588,
                        "name": "Camaná",
                        "latitude": "-16.62375000",
                        "longitude": "-72.71055000"
                    },
                    {
                        "id": 80598,
                        "name": "Ccolo",
                        "latitude": "-15.50611000",
                        "longitude": "-71.49184000"
                    },
                    {
                        "id": 80619,
                        "name": "Chivay",
                        "latitude": "-15.63833000",
                        "longitude": "-71.60111000"
                    },
                    {
                        "id": 80627,
                        "name": "Cocachacra",
                        "latitude": "-17.08833000",
                        "longitude": "-71.75750000"
                    },
                    {
                        "id": 80634,
                        "name": "Cotahuasi",
                        "latitude": "-15.21306000",
                        "longitude": "-72.88861000"
                    },
                    {
                        "id": 80655,
                        "name": "Huarancante",
                        "latitude": "-15.76803000",
                        "longitude": "-71.45952000"
                    },
                    {
                        "id": 80657,
                        "name": "Huarichancara",
                        "latitude": "-15.63972000",
                        "longitude": "-71.06111000"
                    },
                    {
                        "id": 80673,
                        "name": "Jatun Orcochiri",
                        "latitude": "-15.75003000",
                        "longitude": "-71.34641000"
                    },
                    {
                        "id": 80677,
                        "name": "Jayune",
                        "latitude": "-15.56277000",
                        "longitude": "-71.30312000"
                    },
                    {
                        "id": 80704,
                        "name": "Llongasora",
                        "latitude": "-15.63951000",
                        "longitude": "-71.29921000"
                    },
                    {
                        "id": 80705,
                        "name": "Lluta",
                        "latitude": "-16.01472000",
                        "longitude": "-72.01417000"
                    },
                    {
                        "id": 80717,
                        "name": "Mollendo",
                        "latitude": "-17.02306000",
                        "longitude": "-72.01472000"
                    },
                    {
                        "id": 80733,
                        "name": "Orcopampa",
                        "latitude": "-15.26611000",
                        "longitude": "-72.34167000"
                    },
                    {
                        "id": 80777,
                        "name": "Provincia de Arequipa",
                        "latitude": "-16.33333000",
                        "longitude": "-71.50000000"
                    },
                    {
                        "id": 80789,
                        "name": "Provincia de Camaná",
                        "latitude": "-16.41667000",
                        "longitude": "-72.83333000"
                    },
                    {
                        "id": 80795,
                        "name": "Provincia de Caravelí",
                        "latitude": "-15.58333000",
                        "longitude": "-74.00000000"
                    },
                    {
                        "id": 80798,
                        "name": "Provincia de Castilla",
                        "latitude": "-15.58333000",
                        "longitude": "-72.41667000"
                    },
                    {
                        "id": 80800,
                        "name": "Provincia de Caylloma",
                        "latitude": "-15.66667000",
                        "longitude": "-71.58333000"
                    },
                    {
                        "id": 80812,
                        "name": "Provincia de Condesuyos",
                        "latitude": "-15.58333000",
                        "longitude": "-72.83333000"
                    },
                    {
                        "id": 80845,
                        "name": "Provincia de Islay",
                        "latitude": "-17.00000000",
                        "longitude": "-71.83333000"
                    },
                    {
                        "id": 80851,
                        "name": "Provincia de La Unión",
                        "latitude": "-15.00000000",
                        "longitude": "-72.83333000"
                    },
                    {
                        "id": 80914,
                        "name": "Pucara",
                        "latitude": "-15.97993000",
                        "longitude": "-71.45988000"
                    },
                    {
                        "id": 80923,
                        "name": "Punta de Bombón",
                        "latitude": "-17.17190000",
                        "longitude": "-71.79240000"
                    },
                    {
                        "id": 81012,
                        "name": "Vizcachane",
                        "latitude": "-15.80861000",
                        "longitude": "-71.20111000"
                    },
                    {
                        "id": 81020,
                        "name": "Yura",
                        "latitude": "-16.25223000",
                        "longitude": "-71.67969000"
                    }
                ]
            },
            {
                "id": 3692,
                "name": "Ayacucho",
                "iso2": "AYA",
                "latitude": "-13.16387370",
                "longitude": "-74.22356410",
                "type": "region",
                "cities": [
                    {
                        "id": 80568,
                        "name": "Ayacucho",
                        "latitude": "-13.15878000",
                        "longitude": "-74.22321000"
                    },
                    {
                        "id": 80570,
                        "name": "Ayna",
                        "latitude": "-12.65000000",
                        "longitude": "-73.91667000"
                    },
                    {
                        "id": 80633,
                        "name": "Coracora",
                        "latitude": "-15.03333000",
                        "longitude": "-73.78333000"
                    },
                    {
                        "id": 80653,
                        "name": "Huanta",
                        "latitude": "-12.93333000",
                        "longitude": "-74.25000000"
                    },
                    {
                        "id": 80755,
                        "name": "Paucar Del Sara Sara",
                        "latitude": "-15.12275000",
                        "longitude": "-73.26177000"
                    },
                    {
                        "id": 80792,
                        "name": "Provincia de Cangallo",
                        "latitude": "-13.57300000",
                        "longitude": "-74.38900000"
                    },
                    {
                        "id": 80829,
                        "name": "Provincia de Huamanga",
                        "latitude": "-13.20000000",
                        "longitude": "-74.25000000"
                    },
                    {
                        "id": 80830,
                        "name": "Provincia de Huanca Sancos",
                        "latitude": "-14.07600000",
                        "longitude": "-74.42800000"
                    },
                    {
                        "id": 80835,
                        "name": "Provincia de Huanta",
                        "latitude": "-12.50000000",
                        "longitude": "-74.16667000"
                    },
                    {
                        "id": 80850,
                        "name": "Provincia de La Mar",
                        "latitude": "-12.91667000",
                        "longitude": "-73.83333000"
                    },
                    {
                        "id": 80856,
                        "name": "Provincia de Lucanas",
                        "latitude": "-14.50000000",
                        "longitude": "-74.33333000"
                    },
                    {
                        "id": 80873,
                        "name": "Provincia de Parinacochas",
                        "latitude": "-15.02965000",
                        "longitude": "-73.63487000"
                    },
                    {
                        "id": 80895,
                        "name": "Provincia de Sucre",
                        "latitude": "-14.10300000",
                        "longitude": "-73.78600000"
                    },
                    {
                        "id": 80908,
                        "name": "Provincia de Víctor Fajardo",
                        "latitude": "-13.75000000",
                        "longitude": "-74.33333000"
                    },
                    {
                        "id": 80907,
                        "name": "Provincia de Vilcas Huamán",
                        "latitude": "-13.63200000",
                        "longitude": "-73.88800000"
                    },
                    {
                        "id": 80924,
                        "name": "Puquio",
                        "latitude": "-14.70000000",
                        "longitude": "-74.13333000"
                    },
                    {
                        "id": 80951,
                        "name": "San Miguel",
                        "latitude": "-13.01250000",
                        "longitude": "-73.98083000"
                    },
                    {
                        "id": 80985,
                        "name": "Tambo",
                        "latitude": "-14.79847000",
                        "longitude": "-73.92438000"
                    }
                ]
            },
            {
                "id": 3688,
                "name": "Cajamarca",
                "iso2": "CAJ",
                "latitude": "-7.16174650",
                "longitude": "-78.51278550",
                "type": "region",
                "cities": [
                    {
                        "id": 80573,
                        "name": "Bambamarca",
                        "latitude": "-6.68333000",
                        "longitude": "-78.53333000"
                    },
                    {
                        "id": 80575,
                        "name": "Bellavista",
                        "latitude": "-5.66417000",
                        "longitude": "-78.67722000"
                    },
                    {
                        "id": 80580,
                        "name": "Cajabamba",
                        "latitude": "-7.61667000",
                        "longitude": "-78.05000000"
                    },
                    {
                        "id": 80581,
                        "name": "Cajamarca",
                        "latitude": "-7.16378000",
                        "longitude": "-78.50027000"
                    },
                    {
                        "id": 80600,
                        "name": "Celendín",
                        "latitude": "-6.86590000",
                        "longitude": "-78.14585000"
                    },
                    {
                        "id": 80623,
                        "name": "Chota",
                        "latitude": "-6.55000000",
                        "longitude": "-78.65000000"
                    },
                    {
                        "id": 80678,
                        "name": "Jaén",
                        "latitude": "-5.70729000",
                        "longitude": "-78.80785000"
                    },
                    {
                        "id": 80785,
                        "name": "Provincia de Cajabamba",
                        "latitude": "-7.50000000",
                        "longitude": "-78.16667000"
                    },
                    {
                        "id": 80786,
                        "name": "Provincia de Cajamarca",
                        "latitude": "-7.33333000",
                        "longitude": "-78.41667000"
                    },
                    {
                        "id": 80802,
                        "name": "Provincia de Celendín",
                        "latitude": "-6.83333000",
                        "longitude": "-78.25000000"
                    },
                    {
                        "id": 80806,
                        "name": "Provincia de Chota",
                        "latitude": "-6.38332000",
                        "longitude": "-79.18055000"
                    },
                    {
                        "id": 80814,
                        "name": "Provincia de Contumazá",
                        "latitude": "-7.33333000",
                        "longitude": "-78.91667000"
                    },
                    {
                        "id": 80819,
                        "name": "Provincia de Cutervo",
                        "latitude": "-6.36667000",
                        "longitude": "-78.85000000"
                    },
                    {
                        "id": 80826,
                        "name": "Provincia de Hualgayoc",
                        "latitude": "-6.68000000",
                        "longitude": "-78.53000000"
                    },
                    {
                        "id": 80847,
                        "name": "Provincia de Jaén",
                        "latitude": "-5.71074000",
                        "longitude": "-79.00438000"
                    },
                    {
                        "id": 80886,
                        "name": "Provincia de San Ignacio",
                        "latitude": "-5.08333000",
                        "longitude": "-79.00000000"
                    },
                    {
                        "id": 80888,
                        "name": "Provincia de San Miguel",
                        "latitude": "-7.00000000",
                        "longitude": "-79.00000000"
                    },
                    {
                        "id": 80891,
                        "name": "Provincia de Santa Cruz",
                        "latitude": "-6.83333000",
                        "longitude": "-79.00000000"
                    },
                    {
                        "id": 80944,
                        "name": "San Ignacio",
                        "latitude": "-5.14583000",
                        "longitude": "-79.00139000"
                    }
                ]
            },
            {
                "id": 3701,
                "name": "Callao",
                "iso2": "CAL",
                "latitude": "-12.05084910",
                "longitude": "-77.12598430",
                "type": "region",
                "cities": [
                    {
                        "id": 80587,
                        "name": "Callao",
                        "latitude": "-12.05659000",
                        "longitude": "-77.11814000"
                    }
                ]
            },
            {
                "id": 3691,
                "name": "Cusco",
                "iso2": "CUS",
                "latitude": "-13.53195000",
                "longitude": "-71.96746260",
                "type": "region",
                "cities": [
                    {
                        "id": 80560,
                        "name": "Anta",
                        "latitude": "-13.47056000",
                        "longitude": "-72.14833000"
                    },
                    {
                        "id": 80579,
                        "name": "Cahuanuyo",
                        "latitude": "-14.34147000",
                        "longitude": "-71.46311000"
                    },
                    {
                        "id": 80584,
                        "name": "Calca",
                        "latitude": "-13.33333000",
                        "longitude": "-71.95000000"
                    },
                    {
                        "id": 80586,
                        "name": "Callanca",
                        "latitude": "-14.18137000",
                        "longitude": "-71.14070000"
                    },
                    {
                        "id": 80597,
                        "name": "Ccaquiracunca",
                        "latitude": "-14.27683000",
                        "longitude": "-71.45026000"
                    },
                    {
                        "id": 80599,
                        "name": "Ccuntuma",
                        "latitude": "-14.12540000",
                        "longitude": "-71.41216000"
                    },
                    {
                        "id": 80607,
                        "name": "Checacupe",
                        "latitude": "-14.02694000",
                        "longitude": "-71.45278000"
                    },
                    {
                        "id": 80608,
                        "name": "Checca",
                        "latitude": "-14.47278000",
                        "longitude": "-71.39389000"
                    },
                    {
                        "id": 80613,
                        "name": "Chignayhua",
                        "latitude": "-14.24610000",
                        "longitude": "-71.44442000"
                    },
                    {
                        "id": 80617,
                        "name": "Chinchero",
                        "latitude": "-13.39222000",
                        "longitude": "-72.04778000"
                    },
                    {
                        "id": 80629,
                        "name": "Combapata",
                        "latitude": "-14.10111000",
                        "longitude": "-71.42944000"
                    },
                    {
                        "id": 80631,
                        "name": "Conchopata",
                        "latitude": "-14.46968000",
                        "longitude": "-71.19843000"
                    },
                    {
                        "id": 80635,
                        "name": "Cullcuyre",
                        "latitude": "-14.09272000",
                        "longitude": "-71.33119000"
                    },
                    {
                        "id": 80636,
                        "name": "Cusco",
                        "latitude": "-13.52264000",
                        "longitude": "-71.96734000"
                    },
                    {
                        "id": 80661,
                        "name": "Huayna Alcalde",
                        "latitude": "-14.26989000",
                        "longitude": "-71.09599000"
                    },
                    {
                        "id": 80676,
                        "name": "Jayobamba",
                        "latitude": "-14.09425000",
                        "longitude": "-71.33922000"
                    },
                    {
                        "id": 80696,
                        "name": "Langui",
                        "latitude": "-14.43194000",
                        "longitude": "-71.27306000"
                    },
                    {
                        "id": 80700,
                        "name": "Layo",
                        "latitude": "-14.49361000",
                        "longitude": "-71.15500000"
                    },
                    {
                        "id": 80702,
                        "name": "Lima Pampa",
                        "latitude": "-14.08976000",
                        "longitude": "-71.33664000"
                    },
                    {
                        "id": 80709,
                        "name": "Maranganí",
                        "latitude": "-14.35672000",
                        "longitude": "-71.16924000"
                    },
                    {
                        "id": 80710,
                        "name": "Maras",
                        "latitude": "-13.33500000",
                        "longitude": "-72.15667000"
                    },
                    {
                        "id": 80723,
                        "name": "Mosoc Cancha",
                        "latitude": "-14.28514000",
                        "longitude": "-71.08773000"
                    },
                    {
                        "id": 80724,
                        "name": "Mosoc Llacta",
                        "latitude": "-14.12000000",
                        "longitude": "-71.47278000"
                    },
                    {
                        "id": 80731,
                        "name": "Ollantaytambo",
                        "latitude": "-13.25722000",
                        "longitude": "-72.26306000"
                    },
                    {
                        "id": 80735,
                        "name": "Oropesa",
                        "latitude": "-13.59278000",
                        "longitude": "-71.77194000"
                    },
                    {
                        "id": 80748,
                        "name": "Pampamarca",
                        "latitude": "-14.14639000",
                        "longitude": "-71.45944000"
                    },
                    {
                        "id": 80750,
                        "name": "Pangoa",
                        "latitude": "-12.11667000",
                        "longitude": "-73.00000000"
                    },
                    {
                        "id": 80756,
                        "name": "Paucartambo",
                        "latitude": "-13.31522000",
                        "longitude": "-71.59364000"
                    },
                    {
                        "id": 80763,
                        "name": "Pisac",
                        "latitude": "-13.42250000",
                        "longitude": "-71.84667000"
                    },
                    {
                        "id": 80769,
                        "name": "Provincia de Acomayo",
                        "latitude": "-13.91667000",
                        "longitude": "-71.66667000"
                    },
                    {
                        "id": 80774,
                        "name": "Provincia de Anta",
                        "latitude": "-13.50000000",
                        "longitude": "-72.33333000"
                    },
                    {
                        "id": 80788,
                        "name": "Provincia de Calca",
                        "latitude": "-13.00000000",
                        "longitude": "-72.16667000"
                    },
                    {
                        "id": 80790,
                        "name": "Provincia de Canas",
                        "latitude": "-14.41083000",
                        "longitude": "-71.33694000"
                    },
                    {
                        "id": 80791,
                        "name": "Provincia de Canchis",
                        "latitude": "-14.08194000",
                        "longitude": "-71.18556000"
                    },
                    {
                        "id": 80808,
                        "name": "Provincia de Chumbivilcas",
                        "latitude": "-14.41667000",
                        "longitude": "-72.00000000"
                    },
                    {
                        "id": 80818,
                        "name": "Provincia de Cusco",
                        "latitude": "-13.50000000",
                        "longitude": "-72.00000000"
                    },
                    {
                        "id": 80822,
                        "name": "Provincia de Espinar",
                        "latitude": "-14.75000000",
                        "longitude": "-71.41667000"
                    },
                    {
                        "id": 80849,
                        "name": "Provincia de La Convención",
                        "latitude": "-12.00000000",
                        "longitude": "-73.00000000"
                    },
                    {
                        "id": 80874,
                        "name": "Provincia de Paruro",
                        "latitude": "-13.91667000",
                        "longitude": "-71.91667000"
                    },
                    {
                        "id": 80877,
                        "name": "Provincia de Paucartambo",
                        "latitude": "-13.16667000",
                        "longitude": "-71.41667000"
                    },
                    {
                        "id": 80882,
                        "name": "Provincia de Quispicanchis",
                        "latitude": "-13.41667000",
                        "longitude": "-71.00000000"
                    },
                    {
                        "id": 80906,
                        "name": "Provincia de Urubamba",
                        "latitude": "-13.25000000",
                        "longitude": "-72.33333000"
                    },
                    {
                        "id": 80926,
                        "name": "Qquea",
                        "latitude": "-14.05417000",
                        "longitude": "-71.38583000"
                    },
                    {
                        "id": 80928,
                        "name": "Queromarca",
                        "latitude": "-14.18391000",
                        "longitude": "-71.38343000"
                    },
                    {
                        "id": 80953,
                        "name": "San Pablo",
                        "latitude": "-14.20278000",
                        "longitude": "-71.31556000"
                    },
                    {
                        "id": 80960,
                        "name": "Santa Ana",
                        "latitude": "-12.86667000",
                        "longitude": "-72.71667000"
                    },
                    {
                        "id": 80968,
                        "name": "Santo Tomas",
                        "latitude": "-14.44556000",
                        "longitude": "-72.08417000"
                    },
                    {
                        "id": 80975,
                        "name": "Sicuani",
                        "latitude": "-14.26944000",
                        "longitude": "-71.22611000"
                    },
                    {
                        "id": 80993,
                        "name": "Tinta",
                        "latitude": "-14.14500000",
                        "longitude": "-71.40694000"
                    },
                    {
                        "id": 81000,
                        "name": "Tungasuca",
                        "latitude": "-14.16389000",
                        "longitude": "-71.47667000"
                    },
                    {
                        "id": 81004,
                        "name": "Urcos",
                        "latitude": "-13.68611000",
                        "longitude": "-71.62278000"
                    },
                    {
                        "id": 81005,
                        "name": "Urubamba",
                        "latitude": "-13.30472000",
                        "longitude": "-72.11583000"
                    },
                    {
                        "id": 81015,
                        "name": "Yanaoca",
                        "latitude": "-14.21806000",
                        "longitude": "-71.43167000"
                    }
                ]
            },
            {
                "id": 3679,
                "name": "Huancavelica",
                "iso2": "HUV",
                "latitude": "-12.78619780",
                "longitude": "-74.97640240",
                "type": "region",
                "cities": [
                    {
                        "id": 80651,
                        "name": "Huancavelica",
                        "latitude": "-12.78261000",
                        "longitude": "-74.97266000"
                    },
                    {
                        "id": 80662,
                        "name": "Huaytara",
                        "latitude": "-13.65616000",
                        "longitude": "-75.09234000"
                    },
                    {
                        "id": 80749,
                        "name": "Pampas",
                        "latitude": "-12.39490000",
                        "longitude": "-74.86687000"
                    },
                    {
                        "id": 80768,
                        "name": "Provincia de Acobamba",
                        "latitude": "-12.75000000",
                        "longitude": "-74.66667000"
                    },
                    {
                        "id": 80773,
                        "name": "Provincia de Angaraes",
                        "latitude": "-13.00000000",
                        "longitude": "-74.75000000"
                    },
                    {
                        "id": 80799,
                        "name": "Provincia de Castrovirreyna",
                        "latitude": "-13.14535000",
                        "longitude": "-75.40598000"
                    },
                    {
                        "id": 80810,
                        "name": "Provincia de Churcampa",
                        "latitude": "-12.60000000",
                        "longitude": "-74.52000000"
                    },
                    {
                        "id": 80833,
                        "name": "Provincia de Huancavelica",
                        "latitude": "-12.66667000",
                        "longitude": "-75.25000000"
                    },
                    {
                        "id": 80903,
                        "name": "Provincia de Tayacaja",
                        "latitude": "-12.25000000",
                        "longitude": "-74.75000000"
                    }
                ]
            },
            {
                "id": 3687,
                "name": "Huanuco",
                "iso2": "HUC",
                "latitude": "-9.92076480",
                "longitude": "-76.24108430",
                "type": "region",
                "cities": [
                    {
                        "id": 80558,
                        "name": "Ambo",
                        "latitude": "-10.13083000",
                        "longitude": "-76.20472000"
                    },
                    {
                        "id": 80646,
                        "name": "Huacaybamba",
                        "latitude": "-8.99480000",
                        "longitude": "-76.81027000"
                    },
                    {
                        "id": 80665,
                        "name": "Huánuco",
                        "latitude": "-9.93062000",
                        "longitude": "-76.24223000"
                    },
                    {
                        "id": 80691,
                        "name": "La Unión",
                        "latitude": "-9.82702000",
                        "longitude": "-76.80199000"
                    },
                    {
                        "id": 80699,
                        "name": "Lauricocha",
                        "latitude": "-10.20055000",
                        "longitude": "-76.70359000"
                    },
                    {
                        "id": 80703,
                        "name": "Llata",
                        "latitude": "-9.41667000",
                        "longitude": "-76.78333000"
                    },
                    {
                        "id": 80771,
                        "name": "Provincia de Ambo",
                        "latitude": "-10.16667000",
                        "longitude": "-76.16667000"
                    },
                    {
                        "id": 80821,
                        "name": "Provincia de Dos de Mayo",
                        "latitude": "-9.91667000",
                        "longitude": "-76.75000000"
                    },
                    {
                        "id": 80828,
                        "name": "Provincia de Huamalíes",
                        "latitude": "-9.25000000",
                        "longitude": "-76.50000000"
                    },
                    {
                        "id": 80842,
                        "name": "Provincia de Huánuco",
                        "latitude": "-9.66667000",
                        "longitude": "-76.08333000"
                    },
                    {
                        "id": 80855,
                        "name": "Provincia de Leoncio Prado",
                        "latitude": "-9.16667000",
                        "longitude": "-76.00000000"
                    },
                    {
                        "id": 80859,
                        "name": "Provincia de Marañón",
                        "latitude": "-8.75000000",
                        "longitude": "-76.66667000"
                    },
                    {
                        "id": 80869,
                        "name": "Provincia de Pachitea",
                        "latitude": "-9.95262000",
                        "longitude": "-75.81390000"
                    },
                    {
                        "id": 80917,
                        "name": "Puerto Inca",
                        "latitude": "-9.36696000",
                        "longitude": "-75.08958000"
                    },
                    {
                        "id": 80952,
                        "name": "San Miguel de Cauri",
                        "latitude": "-10.13818000",
                        "longitude": "-76.62288000"
                    },
                    {
                        "id": 80992,
                        "name": "Tingo María",
                        "latitude": "-9.29532000",
                        "longitude": "-75.99574000"
                    },
                    {
                        "id": 81014,
                        "name": "Yanacancha",
                        "latitude": "-10.24111000",
                        "longitude": "-76.64556000"
                    },
                    {
                        "id": 81016,
                        "name": "Yarowilca",
                        "latitude": "-9.80263000",
                        "longitude": "-76.59516000"
                    }
                ]
            },
            {
                "id": 3700,
                "name": "Ica",
                "iso2": "ICA",
                "latitude": "-14.20062390",
                "longitude": "-76.84151950",
                "type": "region",
                "cities": [
                    {
                        "id": 80616,
                        "name": "Chincha Alta",
                        "latitude": "-13.40985000",
                        "longitude": "-76.13235000"
                    },
                    {
                        "id": 80667,
                        "name": "Ica",
                        "latitude": "-14.06777000",
                        "longitude": "-75.72861000"
                    },
                    {
                        "id": 80706,
                        "name": "Los Aquijes",
                        "latitude": "-14.09667000",
                        "longitude": "-75.69083000"
                    },
                    {
                        "id": 80714,
                        "name": "Minas de Marcona",
                        "latitude": "-15.21194000",
                        "longitude": "-75.11028000"
                    },
                    {
                        "id": 80729,
                        "name": "Nazca",
                        "latitude": "-14.83098000",
                        "longitude": "-74.93895000"
                    },
                    {
                        "id": 80747,
                        "name": "Palpa",
                        "latitude": "-14.53361000",
                        "longitude": "-75.18556000"
                    },
                    {
                        "id": 80752,
                        "name": "Paracas",
                        "latitude": "-13.86667000",
                        "longitude": "-76.26667000"
                    },
                    {
                        "id": 80764,
                        "name": "Pisco",
                        "latitude": "-13.71029000",
                        "longitude": "-76.20538000"
                    },
                    {
                        "id": 80805,
                        "name": "Provincia de Chincha",
                        "latitude": "-13.31791000",
                        "longitude": "-75.93930000"
                    },
                    {
                        "id": 80843,
                        "name": "Provincia de Ica",
                        "latitude": "-14.33861000",
                        "longitude": "-75.64833000"
                    },
                    {
                        "id": 80865,
                        "name": "Provincia de Nazca",
                        "latitude": "-15.00000000",
                        "longitude": "-75.08333000"
                    },
                    {
                        "id": 80872,
                        "name": "Provincia de Palpa",
                        "latitude": "-14.41667000",
                        "longitude": "-75.16667000"
                    },
                    {
                        "id": 80878,
                        "name": "Provincia de Pisco",
                        "latitude": "-13.80377000",
                        "longitude": "-75.94264000"
                    },
                    {
                        "id": 80935,
                        "name": "Río Grande",
                        "latitude": "-14.51600000",
                        "longitude": "-75.19933000"
                    },
                    {
                        "id": 80943,
                        "name": "San Clemente",
                        "latitude": "-13.66667000",
                        "longitude": "-76.15000000"
                    },
                    {
                        "id": 80949,
                        "name": "San Juan Bautista",
                        "latitude": "-14.01083000",
                        "longitude": "-75.73583000"
                    },
                    {
                        "id": 80964,
                        "name": "Santiago",
                        "latitude": "-14.18469000",
                        "longitude": "-75.71124000"
                    },
                    {
                        "id": 80978,
                        "name": "Subtanjalla",
                        "latitude": "-14.01889000",
                        "longitude": "-75.75806000"
                    },
                    {
                        "id": 81009,
                        "name": "Villa Tupac Amaru",
                        "latitude": "-13.71135000",
                        "longitude": "-76.14980000"
                    }
                ]
            },
            {
                "id": 3693,
                "name": "Junín",
                "iso2": "JUN",
                "latitude": "-11.15819250",
                "longitude": "-75.99263060",
                "type": "region",
                "cities": [
                    {
                        "id": 80556,
                        "name": "Acolla",
                        "latitude": "-11.73193000",
                        "longitude": "-75.54634000"
                    },
                    {
                        "id": 80591,
                        "name": "Carhuamayo",
                        "latitude": "-10.91667000",
                        "longitude": "-76.03333000"
                    },
                    {
                        "id": 80604,
                        "name": "Chanchamayo",
                        "latitude": "-11.05000000",
                        "longitude": "-75.31667000"
                    },
                    {
                        "id": 80625,
                        "name": "Chupaca",
                        "latitude": "-12.06667000",
                        "longitude": "-75.28333000"
                    },
                    {
                        "id": 80630,
                        "name": "Concepción",
                        "latitude": "-11.91762000",
                        "longitude": "-75.31401000"
                    },
                    {
                        "id": 80652,
                        "name": "Huancayo",
                        "latitude": "-12.06513000",
                        "longitude": "-75.20486000"
                    },
                    {
                        "id": 80659,
                        "name": "Huasahuasi",
                        "latitude": "-11.26527000",
                        "longitude": "-75.64722000"
                    },
                    {
                        "id": 80663,
                        "name": "Huayucachi",
                        "latitude": "-12.13333000",
                        "longitude": "-75.23333000"
                    },
                    {
                        "id": 80674,
                        "name": "Jauja",
                        "latitude": "-11.77584000",
                        "longitude": "-75.49656000"
                    },
                    {
                        "id": 80685,
                        "name": "Junín",
                        "latitude": "-11.15895000",
                        "longitude": "-75.99304000"
                    },
                    {
                        "id": 80688,
                        "name": "La Oroya",
                        "latitude": "-11.51893000",
                        "longitude": "-75.89935000"
                    },
                    {
                        "id": 80713,
                        "name": "Mazamari",
                        "latitude": "-11.32583000",
                        "longitude": "-74.53083000"
                    },
                    {
                        "id": 80720,
                        "name": "Morococha",
                        "latitude": "-11.59972000",
                        "longitude": "-76.14111000"
                    },
                    {
                        "id": 80734,
                        "name": "Orcotuna",
                        "latitude": "-11.96886000",
                        "longitude": "-75.30780000"
                    },
                    {
                        "id": 80758,
                        "name": "Perené",
                        "latitude": "-10.94510000",
                        "longitude": "-75.22394000"
                    },
                    {
                        "id": 80761,
                        "name": "Pilcomay",
                        "latitude": "-12.04722000",
                        "longitude": "-75.24931000"
                    },
                    {
                        "id": 80809,
                        "name": "Provincia de Chupaca",
                        "latitude": "-12.30000000",
                        "longitude": "-75.43300000"
                    },
                    {
                        "id": 80811,
                        "name": "Provincia de Concepción",
                        "latitude": "-11.75000000",
                        "longitude": "-75.00000000"
                    },
                    {
                        "id": 80834,
                        "name": "Provincia de Huancayo",
                        "latitude": "-12.17319000",
                        "longitude": "-75.16169000"
                    },
                    {
                        "id": 80846,
                        "name": "Provincia de Jauja",
                        "latitude": "-11.72600000",
                        "longitude": "-75.54700000"
                    },
                    {
                        "id": 80848,
                        "name": "Provincia de Junín",
                        "latitude": "-11.08333000",
                        "longitude": "-76.00000000"
                    },
                    {
                        "id": 80893,
                        "name": "Provincia de Satipo",
                        "latitude": "-11.50000000",
                        "longitude": "-74.25000000"
                    },
                    {
                        "id": 80902,
                        "name": "Provincia de Tarma",
                        "latitude": "-11.40562000",
                        "longitude": "-75.69129000"
                    },
                    {
                        "id": 80909,
                        "name": "Provincia de Yauli",
                        "latitude": "-11.66667000",
                        "longitude": "-76.16667000"
                    },
                    {
                        "id": 80940,
                        "name": "San Agustin",
                        "latitude": "-11.97195000",
                        "longitude": "-75.25562000"
                    },
                    {
                        "id": 80947,
                        "name": "San Jerónimo",
                        "latitude": "-11.95591000",
                        "longitude": "-75.28411000"
                    },
                    {
                        "id": 80954,
                        "name": "San Pedro de Cajas",
                        "latitude": "-11.25061000",
                        "longitude": "-75.86116000"
                    },
                    {
                        "id": 80956,
                        "name": "San Ramón",
                        "latitude": "-11.12417000",
                        "longitude": "-75.35733000"
                    },
                    {
                        "id": 80970,
                        "name": "Satipo",
                        "latitude": "-11.25222000",
                        "longitude": "-74.63861000"
                    },
                    {
                        "id": 80974,
                        "name": "Sicaya",
                        "latitude": "-12.03333000",
                        "longitude": "-75.28333000"
                    },
                    {
                        "id": 80991,
                        "name": "Tarma",
                        "latitude": "-11.41899000",
                        "longitude": "-75.68992000"
                    }
                ]
            },
            {
                "id": 3683,
                "name": "La Libertad",
                "iso2": "LAL",
                "latitude": "-7.95408870",
                "longitude": "-79.61533950",
                "type": "region",
                "cities": [
                    {
                        "id": 80562,
                        "name": "Ascope",
                        "latitude": "-7.71444000",
                        "longitude": "-79.10778000"
                    },
                    {
                        "id": 80595,
                        "name": "Cascas",
                        "latitude": "-7.48333000",
                        "longitude": "-78.81667000"
                    },
                    {
                        "id": 80609,
                        "name": "Chepen",
                        "latitude": "-7.14367000",
                        "longitude": "-79.45674000"
                    },
                    {
                        "id": 80611,
                        "name": "Chicama",
                        "latitude": "-7.84472000",
                        "longitude": "-79.14694000"
                    },
                    {
                        "id": 80620,
                        "name": "Chocope",
                        "latitude": "-7.79139000",
                        "longitude": "-79.22167000"
                    },
                    {
                        "id": 80643,
                        "name": "Gran Chimu",
                        "latitude": "-7.57976000",
                        "longitude": "-78.64718000"
                    },
                    {
                        "id": 80644,
                        "name": "Guadalupe",
                        "latitude": "-7.25000000",
                        "longitude": "-79.48333000"
                    },
                    {
                        "id": 80649,
                        "name": "Huamachuco",
                        "latitude": "-7.80000000",
                        "longitude": "-78.06667000"
                    },
                    {
                        "id": 80682,
                        "name": "Julcan",
                        "latitude": "-8.17238000",
                        "longitude": "-78.46356000"
                    },
                    {
                        "id": 80697,
                        "name": "Laredo",
                        "latitude": "-8.08965000",
                        "longitude": "-78.96020000"
                    },
                    {
                        "id": 80715,
                        "name": "Moche",
                        "latitude": "-8.17111000",
                        "longitude": "-79.00917000"
                    },
                    {
                        "id": 80736,
                        "name": "Otuzco",
                        "latitude": "-7.90000000",
                        "longitude": "-78.58333000"
                    },
                    {
                        "id": 80741,
                        "name": "Pacanga",
                        "latitude": "-7.16667000",
                        "longitude": "-79.50000000"
                    },
                    {
                        "id": 80742,
                        "name": "Pacasmayo",
                        "latitude": "-7.40056000",
                        "longitude": "-79.57139000"
                    },
                    {
                        "id": 80745,
                        "name": "Paiján",
                        "latitude": "-7.73291000",
                        "longitude": "-79.30150000"
                    },
                    {
                        "id": 80783,
                        "name": "Provincia de Bolívar",
                        "latitude": "-7.33333000",
                        "longitude": "-77.75000000"
                    },
                    {
                        "id": 80866,
                        "name": "Provincia de Otuzco",
                        "latitude": "-7.90457000",
                        "longitude": "-78.56362000"
                    },
                    {
                        "id": 80868,
                        "name": "Provincia de Pacasmayo",
                        "latitude": "-7.25000000",
                        "longitude": "-79.50000000"
                    },
                    {
                        "id": 80876,
                        "name": "Provincia de Pataz",
                        "latitude": "-8.25000000",
                        "longitude": "-77.33333000"
                    },
                    {
                        "id": 80892,
                        "name": "Provincia de Santiago de Chuco",
                        "latitude": "-8.33333000",
                        "longitude": "-78.25000000"
                    },
                    {
                        "id": 80904,
                        "name": "Provincia de Trujillo",
                        "latitude": "-8.08333000",
                        "longitude": "-78.91667000"
                    },
                    {
                        "id": 80915,
                        "name": "Pueblo Nuevo",
                        "latitude": "-7.18806000",
                        "longitude": "-79.51528000"
                    },
                    {
                        "id": 80931,
                        "name": "Quiruvilca",
                        "latitude": "-7.96667000",
                        "longitude": "-78.20000000"
                    },
                    {
                        "id": 80936,
                        "name": "Salaverry",
                        "latitude": "-8.22100000",
                        "longitude": "-78.97698000"
                    },
                    {
                        "id": 80955,
                        "name": "San Pedro de Lloc",
                        "latitude": "-7.42890000",
                        "longitude": "-79.50416000"
                    },
                    {
                        "id": 80959,
                        "name": "Sanchez Carrion",
                        "latitude": "-7.78538000",
                        "longitude": "-77.92586000"
                    },
                    {
                        "id": 80965,
                        "name": "Santiago de Cao",
                        "latitude": "-7.95889000",
                        "longitude": "-79.23917000"
                    },
                    {
                        "id": 80966,
                        "name": "Santiago de Chuco",
                        "latitude": "-8.14099000",
                        "longitude": "-78.17329000"
                    },
                    {
                        "id": 80998,
                        "name": "Trujillo",
                        "latitude": "-8.11599000",
                        "longitude": "-79.02998000"
                    },
                    {
                        "id": 81010,
                        "name": "Viru",
                        "latitude": "-8.52199000",
                        "longitude": "-78.60355000"
                    }
                ]
            },
            {
                "id": 3702,
                "name": "Lambayeque",
                "iso2": "LAM",
                "latitude": "-6.71976660",
                "longitude": "-79.90807570",
                "type": "region",
                "cities": [
                    {
                        "id": 80612,
                        "name": "Chiclayo",
                        "latitude": "-6.77137000",
                        "longitude": "-79.84088000"
                    },
                    {
                        "id": 80621,
                        "name": "Chongoyape",
                        "latitude": "-6.64056000",
                        "longitude": "-79.38917000"
                    },
                    {
                        "id": 80641,
                        "name": "Eten",
                        "latitude": "-6.90806000",
                        "longitude": "-79.86417000"
                    },
                    {
                        "id": 80642,
                        "name": "Ferreñafe",
                        "latitude": "-6.63889000",
                        "longitude": "-79.78889000"
                    },
                    {
                        "id": 80675,
                        "name": "Jayanca",
                        "latitude": "-6.39083000",
                        "longitude": "-79.82194000"
                    },
                    {
                        "id": 80694,
                        "name": "Lambayeque",
                        "latitude": "-6.70111000",
                        "longitude": "-79.90611000"
                    },
                    {
                        "id": 80716,
                        "name": "Mochumí",
                        "latitude": "-6.54364000",
                        "longitude": "-79.86217000"
                    },
                    {
                        "id": 80718,
                        "name": "Monsefú",
                        "latitude": "-6.87431000",
                        "longitude": "-79.86871000"
                    },
                    {
                        "id": 80728,
                        "name": "Mórrope",
                        "latitude": "-6.53536000",
                        "longitude": "-80.01104000"
                    },
                    {
                        "id": 80725,
                        "name": "Motupe",
                        "latitude": "-6.15194000",
                        "longitude": "-79.71417000"
                    },
                    {
                        "id": 80732,
                        "name": "Olmos",
                        "latitude": "-5.98472000",
                        "longitude": "-79.74528000"
                    },
                    {
                        "id": 80739,
                        "name": "Oyotún",
                        "latitude": "-6.84438000",
                        "longitude": "-79.30093000"
                    },
                    {
                        "id": 80760,
                        "name": "Picsi",
                        "latitude": "-6.71778000",
                        "longitude": "-79.76972000"
                    },
                    {
                        "id": 80762,
                        "name": "Pimentel",
                        "latitude": "-6.83667000",
                        "longitude": "-79.93417000"
                    },
                    {
                        "id": 80804,
                        "name": "Provincia de Chiclayo",
                        "latitude": "-6.76667000",
                        "longitude": "-79.85000000"
                    },
                    {
                        "id": 80823,
                        "name": "Provincia de Ferreñafe",
                        "latitude": "-6.33333000",
                        "longitude": "-79.50000000"
                    },
                    {
                        "id": 80853,
                        "name": "Provincia de Lambayeque",
                        "latitude": "-6.08333000",
                        "longitude": "-80.08333000"
                    },
                    {
                        "id": 80916,
                        "name": "Pueblo Nuevo",
                        "latitude": "-5.71667000",
                        "longitude": "-79.88333000"
                    },
                    {
                        "id": 80932,
                        "name": "Reque",
                        "latitude": "-6.86556000",
                        "longitude": "-79.81778000"
                    },
                    {
                        "id": 80948,
                        "name": "San José",
                        "latitude": "-6.73813000",
                        "longitude": "-79.82750000"
                    },
                    {
                        "id": 80972,
                        "name": "Saña",
                        "latitude": "-6.91888000",
                        "longitude": "-79.58200000"
                    },
                    {
                        "id": 80963,
                        "name": "Santa Rosa",
                        "latitude": "-6.75772000",
                        "longitude": "-79.82747000"
                    },
                    {
                        "id": 81001,
                        "name": "Túcume",
                        "latitude": "-6.50637000",
                        "longitude": "-79.85725000"
                    }
                ]
            },
            {
                "id": 3695,
                "name": "Lima",
                "iso2": "LIM",
                "latitude": "-12.04637310",
                "longitude": "-77.04275400",
                "type": "region",
                "cities": [
                    {
                        "id": 80563,
                        "name": "Asentamiento Humano Nicolas de Pierola",
                        "latitude": "-11.93573000",
                        "longitude": "-76.70611000"
                    },
                    {
                        "id": 80574,
                        "name": "Barranca",
                        "latitude": "-10.75000000",
                        "longitude": "-77.76667000"
                    },
                    {
                        "id": 80585,
                        "name": "Caleta de Carquín",
                        "latitude": "-11.09250000",
                        "longitude": "-77.62667000"
                    },
                    {
                        "id": 80603,
                        "name": "Chancay",
                        "latitude": "-11.57139000",
                        "longitude": "-77.26722000"
                    },
                    {
                        "id": 80614,
                        "name": "Chilca",
                        "latitude": "-12.52111000",
                        "longitude": "-76.73722000"
                    },
                    {
                        "id": 80622,
                        "name": "Chosica",
                        "latitude": "-11.94306000",
                        "longitude": "-76.70944000"
                    },
                    {
                        "id": 80647,
                        "name": "Huacho",
                        "latitude": "-11.10667000",
                        "longitude": "-77.60500000"
                    },
                    {
                        "id": 80648,
                        "name": "Hualmay",
                        "latitude": "-11.09639000",
                        "longitude": "-77.61389000"
                    },
                    {
                        "id": 80654,
                        "name": "Huaral",
                        "latitude": "-11.49500000",
                        "longitude": "-77.20778000"
                    },
                    {
                        "id": 80660,
                        "name": "Huaura",
                        "latitude": "-11.07000000",
                        "longitude": "-77.59944000"
                    },
                    {
                        "id": 80671,
                        "name": "Imperial",
                        "latitude": "-13.05927000",
                        "longitude": "-76.35269000"
                    },
                    {
                        "id": 80672,
                        "name": "Independencia",
                        "latitude": "-11.99000000",
                        "longitude": "-77.04583000"
                    },
                    {
                        "id": 80701,
                        "name": "Lima",
                        "latitude": "-12.04318000",
                        "longitude": "-77.02824000"
                    },
                    {
                        "id": 80708,
                        "name": "Mala",
                        "latitude": "-12.65806000",
                        "longitude": "-76.63083000"
                    },
                    {
                        "id": 80712,
                        "name": "Matucana",
                        "latitude": "-11.85000000",
                        "longitude": "-76.40000000"
                    },
                    {
                        "id": 80730,
                        "name": "Nuevo Imperial",
                        "latitude": "-13.07541000",
                        "longitude": "-76.31719000"
                    },
                    {
                        "id": 80738,
                        "name": "Oyon",
                        "latitude": "-10.75869000",
                        "longitude": "-76.87634000"
                    },
                    {
                        "id": 80753,
                        "name": "Paramonga",
                        "latitude": "-10.66667000",
                        "longitude": "-77.83333000"
                    },
                    {
                        "id": 80754,
                        "name": "Pativilca",
                        "latitude": "-10.70000000",
                        "longitude": "-77.78333000"
                    },
                    {
                        "id": 80787,
                        "name": "Provincia de Cajatambo",
                        "latitude": "-10.66667000",
                        "longitude": "-77.00000000"
                    },
                    {
                        "id": 80801,
                        "name": "Provincia de Cañete",
                        "latitude": "-12.75000000",
                        "longitude": "-76.33333000"
                    },
                    {
                        "id": 80793,
                        "name": "Provincia de Canta",
                        "latitude": "-11.46667000",
                        "longitude": "-76.61667000"
                    },
                    {
                        "id": 80836,
                        "name": "Provincia de Huaral",
                        "latitude": "-11.25000000",
                        "longitude": "-76.91667000"
                    },
                    {
                        "id": 80840,
                        "name": "Provincia de Huarochirí",
                        "latitude": "-11.91667000",
                        "longitude": "-76.41667000"
                    },
                    {
                        "id": 80910,
                        "name": "Provincia de Yauyos",
                        "latitude": "-12.41667000",
                        "longitude": "-76.00000000"
                    },
                    {
                        "id": 80920,
                        "name": "Puerto Supe",
                        "latitude": "-10.80135000",
                        "longitude": "-77.74333000"
                    },
                    {
                        "id": 80930,
                        "name": "Quilmaná",
                        "latitude": "-12.94860000",
                        "longitude": "-76.38112000"
                    },
                    {
                        "id": 80933,
                        "name": "Ricardo Palma",
                        "latitude": "-11.91978000",
                        "longitude": "-76.65610000"
                    },
                    {
                        "id": 80942,
                        "name": "San Bartolo",
                        "latitude": "-12.38333000",
                        "longitude": "-76.78333000"
                    },
                    {
                        "id": 80945,
                        "name": "San Isidro",
                        "latitude": "-12.11667000",
                        "longitude": "-77.05000000"
                    },
                    {
                        "id": 80950,
                        "name": "San Luis",
                        "latitude": "-12.07674000",
                        "longitude": "-76.99435000"
                    },
                    {
                        "id": 80958,
                        "name": "San Vicente de Cañete",
                        "latitude": "-13.07556000",
                        "longitude": "-76.38528000"
                    },
                    {
                        "id": 80962,
                        "name": "Santa María",
                        "latitude": "-12.00538000",
                        "longitude": "-76.89329000"
                    },
                    {
                        "id": 80967,
                        "name": "Santiago de Surco",
                        "latitude": "-12.13588000",
                        "longitude": "-77.00742000"
                    },
                    {
                        "id": 80971,
                        "name": "Sayán",
                        "latitude": "-11.13333000",
                        "longitude": "-77.19460000"
                    },
                    {
                        "id": 80980,
                        "name": "Supe",
                        "latitude": "-10.79750000",
                        "longitude": "-77.71306000"
                    },
                    {
                        "id": 81003,
                        "name": "Urb. Santo Domingo",
                        "latitude": "-11.87655000",
                        "longitude": "-77.03345000"
                    },
                    {
                        "id": 81013,
                        "name": "Végueta",
                        "latitude": "-11.02253000",
                        "longitude": "-77.64378000"
                    }
                ]
            },
            {
                "id": 4922,
                "name": "Loreto",
                "iso2": "LOR",
                "latitude": "-4.37416430",
                "longitude": "-76.13042640",
                "type": "region",
                "cities": [
                    {
                        "id": 147944,
                        "name": "Andoas",
                        "latitude": "-2.90250000",
                        "longitude": "-76.40250000"
                    },
                    {
                        "id": 147941,
                        "name": "Borja",
                        "latitude": "-4.43333333",
                        "longitude": "-77.55000000"
                    },
                    {
                        "id": 147949,
                        "name": "Caballococha",
                        "latitude": "-3.90583333",
                        "longitude": "-70.51638889"
                    },
                    {
                        "id": 147947,
                        "name": "Cape Pantoja",
                        "latitude": "-0.96435000",
                        "longitude": "-75.18144000"
                    },
                    {
                        "id": 147952,
                        "name": "Indiana",
                        "latitude": "-3.50142700",
                        "longitude": "-73.04809600"
                    },
                    {
                        "id": 147940,
                        "name": "Iquitos",
                        "latitude": "-3.73333333",
                        "longitude": "-73.25000000"
                    },
                    {
                        "id": 147945,
                        "name": "Jeberos",
                        "latitude": "-5.28333000",
                        "longitude": "-76.28333000"
                    },
                    {
                        "id": 147946,
                        "name": "Jenaro Herrera",
                        "latitude": "-4.90741000",
                        "longitude": "-73.66779000"
                    },
                    {
                        "id": 147948,
                        "name": "Lagunas",
                        "latitude": "-5.22694000",
                        "longitude": "-75.67528000"
                    },
                    {
                        "id": 147942,
                        "name": "Nauta",
                        "latitude": "-4.50833333",
                        "longitude": "-73.58333333"
                    },
                    {
                        "id": 147953,
                        "name": "Punchana",
                        "latitude": "-3.71666667",
                        "longitude": "-73.23333333"
                    },
                    {
                        "id": 147954,
                        "name": "Requena",
                        "latitude": "-6.74797000",
                        "longitude": "-75.05491000"
                    },
                    {
                        "id": 147955,
                        "name": "San Antonio del Estrecho",
                        "latitude": "-2.45012000",
                        "longitude": "-72.66896000"
                    },
                    {
                        "id": 147950,
                        "name": "San Lorenzo",
                        "latitude": "-4.81667000",
                        "longitude": "-76.60000000"
                    },
                    {
                        "id": 147943,
                        "name": "San Pablo",
                        "latitude": "-4.01922000",
                        "longitude": "-71.10281000"
                    },
                    {
                        "id": 147951,
                        "name": "Tamshiyacu",
                        "latitude": "-4.00320000",
                        "longitude": "-73.15850000"
                    },
                    {
                        "id": 147956,
                        "name": "Yurimaguas",
                        "latitude": "-5.90000000",
                        "longitude": "-76.08333333"
                    }
                ]
            },
            {
                "id": 3678,
                "name": "Madre de Dios",
                "iso2": "MDD",
                "latitude": "-11.76687050",
                "longitude": "-70.81199530",
                "type": "region",
                "cities": [
                    {
                        "id": 80666,
                        "name": "Iberia",
                        "latitude": "-11.35000000",
                        "longitude": "-69.58333000"
                    },
                    {
                        "id": 80858,
                        "name": "Provincia de Manú",
                        "latitude": "-12.25000000",
                        "longitude": "-71.00000000"
                    },
                    {
                        "id": 80898,
                        "name": "Provincia de Tahuamanú",
                        "latitude": "-11.25000000",
                        "longitude": "-70.50000000"
                    },
                    {
                        "id": 80900,
                        "name": "Provincia de Tambopata",
                        "latitude": "-12.19948000",
                        "longitude": "-70.05006000"
                    },
                    {
                        "id": 80918,
                        "name": "Puerto Maldonado",
                        "latitude": "-12.59331000",
                        "longitude": "-69.18913000"
                    },
                    {
                        "id": 80939,
                        "name": "Salvación",
                        "latitude": "-12.83605000",
                        "longitude": "-71.36490000"
                    },
                    {
                        "id": 80987,
                        "name": "Tambopata",
                        "latitude": "-12.67191000",
                        "longitude": "-69.35547000"
                    }
                ]
            },
            {
                "id": 3698,
                "name": "Moquegua",
                "iso2": "MOQ",
                "latitude": "-17.19273610",
                "longitude": "-70.93281380",
                "type": "region",
                "cities": [
                    {
                        "id": 80670,
                        "name": "Ilo",
                        "latitude": "-17.63185000",
                        "longitude": "-71.34108000"
                    },
                    {
                        "id": 80719,
                        "name": "Moquegua",
                        "latitude": "-17.19832000",
                        "longitude": "-70.93567000"
                    },
                    {
                        "id": 80743,
                        "name": "Pacocha",
                        "latitude": "-17.64604000",
                        "longitude": "-71.34481000"
                    },
                    {
                        "id": 80824,
                        "name": "Provincia de General Sánchez Cerro",
                        "latitude": "-16.50000000",
                        "longitude": "-70.66667000"
                    },
                    {
                        "id": 80844,
                        "name": "Provincia de Ilo",
                        "latitude": "-17.49694000",
                        "longitude": "-71.16722000"
                    },
                    {
                        "id": 80862,
                        "name": "Provincia de Mariscal Nieto",
                        "latitude": "-17.08361000",
                        "longitude": "-71.00333000"
                    },
                    {
                        "id": 80996,
                        "name": "Torata",
                        "latitude": "-17.07694000",
                        "longitude": "-70.84333000"
                    }
                ]
            },
            {
                "id": 3686,
                "name": "Pasco",
                "iso2": "PAS",
                "latitude": "-10.29806400",
                "longitude": "-76.75061930",
                "type": "region",
                "cities": [
                    {
                        "id": 80601,
                        "name": "Cerro de Pasco",
                        "latitude": "-10.66748000",
                        "longitude": "-76.25668000"
                    },
                    {
                        "id": 80605,
                        "name": "Chaupimarca",
                        "latitude": "-10.40696000",
                        "longitude": "-76.46168000"
                    },
                    {
                        "id": 80737,
                        "name": "Oxapampa",
                        "latitude": "-10.57750000",
                        "longitude": "-75.40167000"
                    },
                    {
                        "id": 80757,
                        "name": "Paucartambo",
                        "latitude": "-10.77326000",
                        "longitude": "-75.81109000"
                    },
                    {
                        "id": 80820,
                        "name": "Provincia de Daniel Carrión",
                        "latitude": "-10.50000000",
                        "longitude": "-76.50000000"
                    },
                    {
                        "id": 80867,
                        "name": "Provincia de Oxapampa",
                        "latitude": "-10.33333000",
                        "longitude": "-75.08333000"
                    },
                    {
                        "id": 80875,
                        "name": "Provincia de Pasco",
                        "latitude": "-10.66667000",
                        "longitude": "-76.08333000"
                    },
                    {
                        "id": 80994,
                        "name": "Tinyahuarco",
                        "latitude": "-10.76771000",
                        "longitude": "-76.27523000"
                    },
                    {
                        "id": 81008,
                        "name": "Villa Rica",
                        "latitude": "-10.73944000",
                        "longitude": "-75.26972000"
                    }
                ]
            },
            {
                "id": 3697,
                "name": "Piura",
                "iso2": "PIU",
                "latitude": "-5.17828840",
                "longitude": "-80.65488820",
                "type": "region",
                "cities": [
                    {
                        "id": 80567,
                        "name": "Ayabaca",
                        "latitude": "-4.63983000",
                        "longitude": "-79.71491000"
                    },
                    {
                        "id": 80577,
                        "name": "Bernal",
                        "latitude": "-5.45000000",
                        "longitude": "-80.75000000"
                    },
                    {
                        "id": 80578,
                        "name": "Buenos Aires",
                        "latitude": "-5.26083000",
                        "longitude": "-79.96417000"
                    },
                    {
                        "id": 80596,
                        "name": "Catacaos",
                        "latitude": "-5.26667000",
                        "longitude": "-80.68333000"
                    },
                    {
                        "id": 80624,
                        "name": "Chulucanas",
                        "latitude": "-5.09250000",
                        "longitude": "-80.16250000"
                    },
                    {
                        "id": 80638,
                        "name": "El Alto",
                        "latitude": "-4.26851000",
                        "longitude": "-81.21719000"
                    },
                    {
                        "id": 80650,
                        "name": "Huancabamba",
                        "latitude": "-5.23861000",
                        "longitude": "-79.45056000"
                    },
                    {
                        "id": 80686,
                        "name": "La Breita",
                        "latitude": "-4.25691000",
                        "longitude": "-80.88599000"
                    },
                    {
                        "id": 80687,
                        "name": "La Huaca",
                        "latitude": "-4.91167000",
                        "longitude": "-80.96000000"
                    },
                    {
                        "id": 80692,
                        "name": "La Unión",
                        "latitude": "-5.40232000",
                        "longitude": "-80.74224000"
                    },
                    {
                        "id": 80698,
                        "name": "Las Lomas",
                        "latitude": "-4.65333000",
                        "longitude": "-80.24667000"
                    },
                    {
                        "id": 80727,
                        "name": "Máncora",
                        "latitude": "-4.10778000",
                        "longitude": "-81.04750000"
                    },
                    {
                        "id": 80711,
                        "name": "Marcavelica",
                        "latitude": "-4.87778000",
                        "longitude": "-80.70528000"
                    },
                    {
                        "id": 80721,
                        "name": "Morropon",
                        "latitude": "-5.25000000",
                        "longitude": "-80.00000000"
                    },
                    {
                        "id": 80746,
                        "name": "Paita",
                        "latitude": "-5.08917000",
                        "longitude": "-81.11444000"
                    },
                    {
                        "id": 80765,
                        "name": "Piura",
                        "latitude": "-5.19449000",
                        "longitude": "-80.63282000"
                    },
                    {
                        "id": 80778,
                        "name": "Provincia de Ayabaca",
                        "latitude": "-4.75000000",
                        "longitude": "-79.83333000"
                    },
                    {
                        "id": 80831,
                        "name": "Provincia de Huancabamba",
                        "latitude": "-5.50000000",
                        "longitude": "-79.58333000"
                    },
                    {
                        "id": 80870,
                        "name": "Provincia de Paita",
                        "latitude": "-5.10189000",
                        "longitude": "-81.09695000"
                    },
                    {
                        "id": 80879,
                        "name": "Provincia de Piura",
                        "latitude": "-5.21416000",
                        "longitude": "-80.40617000"
                    },
                    {
                        "id": 80896,
                        "name": "Provincia de Sullana",
                        "latitude": "-4.50000000",
                        "longitude": "-80.66667000"
                    },
                    {
                        "id": 80899,
                        "name": "Provincia de Talara",
                        "latitude": "-4.41667000",
                        "longitude": "-81.08333000"
                    },
                    {
                        "id": 80927,
                        "name": "Querecotillo",
                        "latitude": "-4.83778000",
                        "longitude": "-80.64556000"
                    },
                    {
                        "id": 80937,
                        "name": "Salinera Colán",
                        "latitude": "-5.03333000",
                        "longitude": "-81.06667000"
                    },
                    {
                        "id": 80938,
                        "name": "Salitral",
                        "latitude": "-4.85722000",
                        "longitude": "-80.68111000"
                    },
                    {
                        "id": 80973,
                        "name": "Sechura",
                        "latitude": "-5.55694000",
                        "longitude": "-80.82222000"
                    },
                    {
                        "id": 80979,
                        "name": "Sullana",
                        "latitude": "-4.90389000",
                        "longitude": "-80.68528000"
                    },
                    {
                        "id": 80983,
                        "name": "Talara",
                        "latitude": "-4.57722000",
                        "longitude": "-81.27194000"
                    },
                    {
                        "id": 80986,
                        "name": "Tambo Grande",
                        "latitude": "-4.92694000",
                        "longitude": "-80.34472000"
                    },
                    {
                        "id": 81007,
                        "name": "Vice",
                        "latitude": "-5.41667000",
                        "longitude": "-80.78333000"
                    }
                ]
            },
            {
                "id": 3682,
                "name": "Puno",
                "iso2": "PUN",
                "latitude": "-15.84022180",
                "longitude": "-70.02188050",
                "type": "region",
                "cities": [
                    {
                        "id": 80566,
                        "name": "Atuncolla",
                        "latitude": "-15.68333000",
                        "longitude": "-70.15000000"
                    },
                    {
                        "id": 80569,
                        "name": "Ayaviri",
                        "latitude": "-14.88639000",
                        "longitude": "-70.58889000"
                    },
                    {
                        "id": 80571,
                        "name": "Azángaro",
                        "latitude": "-14.90843000",
                        "longitude": "-70.19616000"
                    },
                    {
                        "id": 80637,
                        "name": "Desaguadero",
                        "latitude": "-16.56556000",
                        "longitude": "-69.04167000"
                    },
                    {
                        "id": 80639,
                        "name": "El Collao",
                        "latitude": "-16.72641000",
                        "longitude": "-69.75515000"
                    },
                    {
                        "id": 80645,
                        "name": "Hacienda Huancane",
                        "latitude": "-15.82327000",
                        "longitude": "-70.88540000"
                    },
                    {
                        "id": 80669,
                        "name": "Ilave",
                        "latitude": "-16.08333000",
                        "longitude": "-69.66667000"
                    },
                    {
                        "id": 80683,
                        "name": "Juli",
                        "latitude": "-16.21667000",
                        "longitude": "-69.45000000"
                    },
                    {
                        "id": 80684,
                        "name": "Juliaca",
                        "latitude": "-15.50000000",
                        "longitude": "-70.13333000"
                    },
                    {
                        "id": 80690,
                        "name": "La Rinconada",
                        "latitude": "-14.63126000",
                        "longitude": "-69.44638000"
                    },
                    {
                        "id": 80695,
                        "name": "Lampa",
                        "latitude": "-15.35000000",
                        "longitude": "-70.36667000"
                    },
                    {
                        "id": 80707,
                        "name": "Macusani",
                        "latitude": "-14.08333000",
                        "longitude": "-70.43333000"
                    },
                    {
                        "id": 81023,
                        "name": "Ñuñoa",
                        "latitude": "-14.47788000",
                        "longitude": "-70.63583000"
                    },
                    {
                        "id": 80780,
                        "name": "Provincia de Azángaro",
                        "latitude": "-14.83333000",
                        "longitude": "-70.16667000"
                    },
                    {
                        "id": 80794,
                        "name": "Provincia de Carabaya",
                        "latitude": "-13.83333000",
                        "longitude": "-70.25000000"
                    },
                    {
                        "id": 80807,
                        "name": "Provincia de Chucuito",
                        "latitude": "-16.60545000",
                        "longitude": "-69.35761000"
                    },
                    {
                        "id": 80832,
                        "name": "Provincia de Huancané",
                        "latitude": "-15.16667000",
                        "longitude": "-69.58333000"
                    },
                    {
                        "id": 80854,
                        "name": "Provincia de Lampa",
                        "latitude": "-15.41667000",
                        "longitude": "-70.58333000"
                    },
                    {
                        "id": 80863,
                        "name": "Provincia de Melgar",
                        "latitude": "-14.75000000",
                        "longitude": "-70.75000000"
                    },
                    {
                        "id": 80881,
                        "name": "Provincia de Puno",
                        "latitude": "-16.00000000",
                        "longitude": "-70.00000000"
                    },
                    {
                        "id": 80889,
                        "name": "Provincia de Sandia",
                        "latitude": "-13.83333000",
                        "longitude": "-69.33333000"
                    },
                    {
                        "id": 80922,
                        "name": "Puno",
                        "latitude": "-15.84220000",
                        "longitude": "-70.01990000"
                    },
                    {
                        "id": 80941,
                        "name": "San Antonio De Putina",
                        "latitude": "-14.71175000",
                        "longitude": "-69.61559000"
                    },
                    {
                        "id": 80957,
                        "name": "San Roman",
                        "latitude": "-15.83333000",
                        "longitude": "-70.50000000"
                    },
                    {
                        "id": 80961,
                        "name": "Santa Lucía",
                        "latitude": "-15.69788000",
                        "longitude": "-70.60610000"
                    },
                    {
                        "id": 80988,
                        "name": "Taquile",
                        "latitude": "-15.76667000",
                        "longitude": "-69.68333000"
                    },
                    {
                        "id": 81019,
                        "name": "Yunguyo",
                        "latitude": "-16.25000000",
                        "longitude": "-69.08333000"
                    }
                ]
            },
            {
                "id": 3694,
                "name": "San Martín",
                "iso2": "SAM",
                "latitude": "37.08494640",
                "longitude": "-121.61022160",
                "type": "region",
                "cities": [
                    {
                        "id": 80576,
                        "name": "Bellavista",
                        "latitude": "-7.05614000",
                        "longitude": "-76.59110000"
                    },
                    {
                        "id": 80606,
                        "name": "Chazuta",
                        "latitude": "-6.57087000",
                        "longitude": "-76.13753000"
                    },
                    {
                        "id": 80640,
                        "name": "El Dorado",
                        "latitude": "-6.56298000",
                        "longitude": "-76.74130000"
                    },
                    {
                        "id": 80664,
                        "name": "Huicungo",
                        "latitude": "-7.31860000",
                        "longitude": "-76.77556000"
                    },
                    {
                        "id": 80679,
                        "name": "Jepelacio",
                        "latitude": "-6.11667000",
                        "longitude": "-76.95000000"
                    },
                    {
                        "id": 80681,
                        "name": "Juanjuí",
                        "latitude": "-7.17697000",
                        "longitude": "-76.72774000"
                    },
                    {
                        "id": 80693,
                        "name": "Lamas",
                        "latitude": "-6.41667000",
                        "longitude": "-76.53333000"
                    },
                    {
                        "id": 80726,
                        "name": "Moyobamba",
                        "latitude": "-6.03416000",
                        "longitude": "-76.97168000"
                    },
                    {
                        "id": 80759,
                        "name": "Picota",
                        "latitude": "-6.92033000",
                        "longitude": "-76.33142000"
                    },
                    {
                        "id": 80827,
                        "name": "Provincia de Huallaga",
                        "latitude": "-6.75664000",
                        "longitude": "-76.90143000"
                    },
                    {
                        "id": 80852,
                        "name": "Provincia de Lamas",
                        "latitude": "-6.33333000",
                        "longitude": "-76.66667000"
                    },
                    {
                        "id": 80860,
                        "name": "Provincia de Mariscal Cáceres",
                        "latitude": "-7.27390000",
                        "longitude": "-77.18216000"
                    },
                    {
                        "id": 80864,
                        "name": "Provincia de Moyobamba",
                        "latitude": "-5.75000000",
                        "longitude": "-77.25000000"
                    },
                    {
                        "id": 80884,
                        "name": "Provincia de Rioja",
                        "latitude": "-6.00000000",
                        "longitude": "-77.41667000"
                    },
                    {
                        "id": 80887,
                        "name": "Provincia de San Martín",
                        "latitude": "-6.58333000",
                        "longitude": "-76.16667000"
                    },
                    {
                        "id": 80934,
                        "name": "Rioja",
                        "latitude": "-6.05675000",
                        "longitude": "-77.16651000"
                    },
                    {
                        "id": 80969,
                        "name": "Saposoa",
                        "latitude": "-6.93395000",
                        "longitude": "-76.77158000"
                    },
                    {
                        "id": 80976,
                        "name": "Sisa",
                        "latitude": "-6.61085000",
                        "longitude": "-76.69302000"
                    },
                    {
                        "id": 80977,
                        "name": "Soritor",
                        "latitude": "-6.13917000",
                        "longitude": "-77.10389000"
                    },
                    {
                        "id": 80981,
                        "name": "Tabalosos",
                        "latitude": "-6.35000000",
                        "longitude": "-76.68333000"
                    },
                    {
                        "id": 80989,
                        "name": "Tarapoto",
                        "latitude": "-6.50139000",
                        "longitude": "-76.36556000"
                    },
                    {
                        "id": 80995,
                        "name": "Tocache",
                        "latitude": "-8.18770000",
                        "longitude": "-76.52046000"
                    },
                    {
                        "id": 81002,
                        "name": "Uchiza",
                        "latitude": "-8.45917000",
                        "longitude": "-76.46333000"
                    }
                ]
            },
            {
                "id": 3696,
                "name": "Tacna",
                "iso2": "TAC",
                "latitude": "-18.00656790",
                "longitude": "-70.24627410",
                "type": "region",
                "cities": [
                    {
                        "id": 80583,
                        "name": "Calana",
                        "latitude": "-17.94167000",
                        "longitude": "-70.18694000"
                    },
                    {
                        "id": 80590,
                        "name": "Candarave",
                        "latitude": "-17.26778000",
                        "longitude": "-70.24944000"
                    },
                    {
                        "id": 80618,
                        "name": "Chipispaya",
                        "latitude": "-17.49790000",
                        "longitude": "-70.21714000"
                    },
                    {
                        "id": 80626,
                        "name": "Chuquitira",
                        "latitude": "-17.28891000",
                        "longitude": "-70.04363000"
                    },
                    {
                        "id": 80668,
                        "name": "Ilabaya",
                        "latitude": "-17.42083000",
                        "longitude": "-70.51333000"
                    },
                    {
                        "id": 80680,
                        "name": "Jorge Basadre",
                        "latitude": "-17.57919000",
                        "longitude": "-70.73083000"
                    },
                    {
                        "id": 80897,
                        "name": "Provincia de Tacna",
                        "latitude": "-17.83333000",
                        "longitude": "-70.50000000"
                    },
                    {
                        "id": 80901,
                        "name": "Provincia de Tarata",
                        "latitude": "-17.41667000",
                        "longitude": "-70.08333000"
                    },
                    {
                        "id": 80921,
                        "name": "Pujocucho",
                        "latitude": "-17.15778000",
                        "longitude": "-70.35222000"
                    },
                    {
                        "id": 80929,
                        "name": "Quilahuani",
                        "latitude": "-17.31778000",
                        "longitude": "-70.25806000"
                    },
                    {
                        "id": 80982,
                        "name": "Tacna",
                        "latitude": "-18.01465000",
                        "longitude": "-70.25362000"
                    },
                    {
                        "id": 80990,
                        "name": "Tarata",
                        "latitude": "-17.47444000",
                        "longitude": "-70.03278000"
                    },
                    {
                        "id": 80997,
                        "name": "Totoral",
                        "latitude": "-17.40620000",
                        "longitude": "-70.36464000"
                    }
                ]
            },
            {
                "id": 3689,
                "name": "Tumbes",
                "iso2": "TUM",
                "latitude": "-3.55649210",
                "longitude": "-80.42708850",
                "type": "region",
                "cities": [
                    {
                        "id": 80557,
                        "name": "Aguas Verdes",
                        "latitude": "-3.48139000",
                        "longitude": "-80.24500000"
                    },
                    {
                        "id": 80751,
                        "name": "Papayal",
                        "latitude": "-4.07771000",
                        "longitude": "-80.73690000"
                    },
                    {
                        "id": 80813,
                        "name": "Provincia de Contralmirante Villar",
                        "latitude": "-4.00000000",
                        "longitude": "-80.75000000"
                    },
                    {
                        "id": 80905,
                        "name": "Provincia de Tumbes",
                        "latitude": "-3.75000000",
                        "longitude": "-80.41667000"
                    },
                    {
                        "id": 80912,
                        "name": "Provincia de Zarumilla",
                        "latitude": "-3.66667000",
                        "longitude": "-80.25000000"
                    },
                    {
                        "id": 80999,
                        "name": "Tumbes",
                        "latitude": "-3.56694000",
                        "longitude": "-80.45153000"
                    },
                    {
                        "id": 81021,
                        "name": "Zarumilla",
                        "latitude": "-3.50306000",
                        "longitude": "-80.27306000"
                    },
                    {
                        "id": 81022,
                        "name": "Zorritos",
                        "latitude": "-3.68046000",
                        "longitude": "-80.67819000"
                    }
                ]
            },
            {
                "id": 3684,
                "name": "Ucayali",
                "iso2": "UCA",
                "latitude": "-9.82511830",
                "longitude": "-73.08774900",
                "type": "region",
                "cities": [
                    {
                        "id": 80565,
                        "name": "Atalaya",
                        "latitude": "-10.38980000",
                        "longitude": "-73.21977000"
                    },
                    {
                        "id": 80589,
                        "name": "Campoverde",
                        "latitude": "-8.47533000",
                        "longitude": "-74.80709000"
                    },
                    {
                        "id": 80744,
                        "name": "Padre Abad",
                        "latitude": "-8.79680000",
                        "longitude": "-75.42850000"
                    },
                    {
                        "id": 80815,
                        "name": "Provincia de Coronel Portillo",
                        "latitude": "-9.50000000",
                        "longitude": "-73.33333000"
                    },
                    {
                        "id": 80913,
                        "name": "Pucallpa",
                        "latitude": "-8.37915000",
                        "longitude": "-74.55387000"
                    },
                    {
                        "id": 80925,
                        "name": "Purus",
                        "latitude": "-10.37331000",
                        "longitude": "-71.58231000"
                    }
                ]
            }
        ]
    },
    {
        "id": 174,
        "name": "Philippines",
        "iso3": "PHL",
        "iso2": "PH",
        "numeric_code": "608",
        "phonecode": "63",
        "capital": "Manila",
        "currency": "PHP",
        "currency_name": "Philippine peso",
        "currency_symbol": "₱",
        "tld": ".ph",
        "native": "Pilipinas",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Philippine, Filipino",
        "timezones": [
            {
                "zoneName": "Asia\/Manila",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "PHT",
                "tzName": "Philippine Time"
            }
        ],
        "translations": {
            "br": "Filipinez",
            "ko": "필리핀",
            "pt-BR": "Filipinas",
            "pt": "Filipinas",
            "nl": "Filipijnen",
            "hr": "Filipini",
            "fa": "جزایر الندفیلیپین",
            "de": "Philippinen",
            "es": "Filipinas",
            "fr": "Philippines",
            "ja": "フィリピン",
            "it": "Filippine",
            "zh-CN": "菲律宾",
            "tr": "Filipinler",
            "ru": "Филиппины",
            "uk": "Філіппіни",
            "pl": "Filipiny"
        },
        "latitude": "13.00000000",
        "longitude": "122.00000000",
        "emoji": "🇵🇭",
        "emojiU": "U+1F1F5 U+1F1ED",
        "states": [
            {
                "id": 1324,
                "name": "Abra",
                "iso2": "ABR",
                "latitude": "42.49708300",
                "longitude": "-96.38441000",
                "type": "province",
                "cities": [
                    {
                        "id": 145791,
                        "name": "Alac",
                        "latitude": "15.98777778",
                        "longitude": "120.80638889"
                    },
                    {
                        "id": 145795,
                        "name": "Allangigan Primero",
                        "latitude": "17.17388889",
                        "longitude": "120.49194444"
                    },
                    {
                        "id": 145796,
                        "name": "Aloleng",
                        "latitude": "16.13083333",
                        "longitude": "119.78250000"
                    },
                    {
                        "id": 145797,
                        "name": "Amagbagan",
                        "latitude": "16.09138889",
                        "longitude": "120.52333333"
                    },
                    {
                        "id": 145798,
                        "name": "Anambongan",
                        "latitude": "15.86638889",
                        "longitude": "120.38861111"
                    },
                    {
                        "id": 145800,
                        "name": "Angatel",
                        "latitude": "15.80583333",
                        "longitude": "120.34333333"
                    },
                    {
                        "id": 145801,
                        "name": "Anulid",
                        "latitude": "15.82555556",
                        "longitude": "120.48833333"
                    },
                    {
                        "id": 145804,
                        "name": "Baay",
                        "latitude": "18.11888889",
                        "longitude": "120.57527778"
                    },
                    {
                        "id": 145805,
                        "name": "Bacag",
                        "latitude": "15.93000000",
                        "longitude": "120.58222222"
                    },
                    {
                        "id": 145807,
                        "name": "Bacnar",
                        "latitude": "15.88638889",
                        "longitude": "120.34416667"
                    },
                    {
                        "id": 145809,
                        "name": "Bactad Proper",
                        "latitude": "15.97833333",
                        "longitude": "120.61027778"
                    },
                    {
                        "id": 145810,
                        "name": "Bacundao Weste",
                        "latitude": "15.91527778",
                        "longitude": "120.47666667"
                    },
                    {
                        "id": 145813,
                        "name": "Bail",
                        "latitude": "16.28666667",
                        "longitude": "120.40027778"
                    },
                    {
                        "id": 145815,
                        "name": "Balingasay",
                        "latitude": "16.35722222",
                        "longitude": "119.85638889"
                    },
                    {
                        "id": 145816,
                        "name": "Balingueo",
                        "latitude": "15.95833333",
                        "longitude": "120.40972222"
                    },
                    {
                        "id": 145817,
                        "name": "Balogo",
                        "latitude": "15.99027778",
                        "longitude": "120.28305556"
                    },
                    {
                        "id": 145819,
                        "name": "Baluyot",
                        "latitude": "15.79583333",
                        "longitude": "120.46083333"
                    },
                    {
                        "id": 145821,
                        "name": "Bangan-Oda",
                        "latitude": "16.10861111",
                        "longitude": "119.83083333"
                    },
                    {
                        "id": 145827,
                        "name": "Banog Sur",
                        "latitude": "16.16555556",
                        "longitude": "119.89805556"
                    },
                    {
                        "id": 145829,
                        "name": "Bantog",
                        "latitude": "16.00916667",
                        "longitude": "120.69277778"
                    },
                    {
                        "id": 145830,
                        "name": "Barangobong",
                        "latitude": "15.87777778",
                        "longitude": "120.54833333"
                    },
                    {
                        "id": 145831,
                        "name": "Baro",
                        "latitude": "15.99888889",
                        "longitude": "120.67361111"
                    },
                    {
                        "id": 145832,
                        "name": "Barong",
                        "latitude": "18.05750000",
                        "longitude": "120.73388889"
                    },
                    {
                        "id": 145833,
                        "name": "Basing",
                        "latitude": "15.98500000",
                        "longitude": "120.26833333"
                    },
                    {
                        "id": 145836,
                        "name": "Bataquil",
                        "latitude": "16.15527778",
                        "longitude": "120.52750000"
                    },
                    {
                        "id": 145840,
                        "name": "Bayaoas",
                        "latitude": "15.83416667",
                        "longitude": "120.26472222"
                    },
                    {
                        "id": 145841,
                        "name": "Bical Norte",
                        "latitude": "15.81472222",
                        "longitude": "120.43500000"
                    },
                    {
                        "id": 145842,
                        "name": "Bil-Loca",
                        "latitude": "18.08750000",
                        "longitude": "120.56861111"
                    },
                    {
                        "id": 145843,
                        "name": "Binabalian",
                        "latitude": "16.42027778",
                        "longitude": "119.92777778"
                    },
                    {
                        "id": 145845,
                        "name": "Binday",
                        "latitude": "16.12805556",
                        "longitude": "120.45250000"
                    },
                    {
                        "id": 145847,
                        "name": "Bobonan",
                        "latitude": "16.13472222",
                        "longitude": "120.52722222"
                    },
                    {
                        "id": 145848,
                        "name": "Bogtong",
                        "latitude": "15.75527778",
                        "longitude": "120.32888889"
                    },
                    {
                        "id": 145849,
                        "name": "Bolaoit",
                        "latitude": "15.93222222",
                        "longitude": "120.43083333"
                    },
                    {
                        "id": 145851,
                        "name": "Bolingit",
                        "latitude": "15.95861111",
                        "longitude": "120.34972222"
                    },
                    {
                        "id": 145852,
                        "name": "Bolo",
                        "latitude": "15.99472222",
                        "longitude": "120.16472222"
                    },
                    {
                        "id": 145854,
                        "name": "Boñgalon",
                        "latitude": "16.00027778",
                        "longitude": "120.15916667"
                    },
                    {
                        "id": 145853,
                        "name": "Botao",
                        "latitude": "15.91666667",
                        "longitude": "120.41666667"
                    },
                    {
                        "id": 145855,
                        "name": "Bued",
                        "latitude": "16.16083333",
                        "longitude": "119.99888889"
                    },
                    {
                        "id": 145857,
                        "name": "Buenlag",
                        "latitude": "15.82972222",
                        "longitude": "120.51138889"
                    },
                    {
                        "id": 145859,
                        "name": "Bulog",
                        "latitude": "15.96027778",
                        "longitude": "120.40166667"
                    },
                    {
                        "id": 145864,
                        "name": "Butubut Norte",
                        "latitude": "16.80333333",
                        "longitude": "120.43444444"
                    },
                    {
                        "id": 145865,
                        "name": "Caabiangan",
                        "latitude": "16.08750000",
                        "longitude": "119.92444444"
                    },
                    {
                        "id": 145867,
                        "name": "Cabalaoangan",
                        "latitude": "15.98333333",
                        "longitude": "120.78333333"
                    },
                    {
                        "id": 145868,
                        "name": "Cabalitian",
                        "latitude": "16.08833333",
                        "longitude": "120.79222222"
                    },
                    {
                        "id": 145869,
                        "name": "Cabittaogan",
                        "latitude": "17.57777778",
                        "longitude": "120.35916667"
                    },
                    {
                        "id": 145870,
                        "name": "Cabugao",
                        "latitude": "17.80000000",
                        "longitude": "120.45000000"
                    },
                    {
                        "id": 145871,
                        "name": "Cabungan",
                        "latitude": "16.34000000",
                        "longitude": "119.99500000"
                    },
                    {
                        "id": 145873,
                        "name": "Calepaan",
                        "latitude": "16.01944444",
                        "longitude": "120.61888889"
                    },
                    {
                        "id": 145874,
                        "name": "Callaguip",
                        "latitude": "18.07138889",
                        "longitude": "120.48666667"
                    },
                    {
                        "id": 145875,
                        "name": "Calomboyan",
                        "latitude": "15.94638889",
                        "longitude": "120.30361111"
                    },
                    {
                        "id": 145876,
                        "name": "Calongbuyan",
                        "latitude": "17.16472222",
                        "longitude": "120.42722222"
                    },
                    {
                        "id": 145877,
                        "name": "Calsib",
                        "latitude": "15.84722222",
                        "longitude": "120.26416667"
                    },
                    {
                        "id": 145878,
                        "name": "Camaley",
                        "latitude": "15.99722222",
                        "longitude": "120.30111111"
                    },
                    {
                        "id": 145879,
                        "name": "Canan Norte",
                        "latitude": "15.90972222",
                        "longitude": "120.47750000"
                    },
                    {
                        "id": 145880,
                        "name": "Canaoalan",
                        "latitude": "16.02888889",
                        "longitude": "120.29638889"
                    },
                    {
                        "id": 145882,
                        "name": "Cantoria",
                        "latitude": "16.84416667",
                        "longitude": "120.40444444"
                    },
                    {
                        "id": 145884,
                        "name": "Capandanan",
                        "latitude": "15.95944444",
                        "longitude": "120.69527778"
                    },
                    {
                        "id": 145885,
                        "name": "Capulaan",
                        "latitude": "15.90500000",
                        "longitude": "120.53722222"
                    },
                    {
                        "id": 145886,
                        "name": "Caramutan",
                        "latitude": "15.92083333",
                        "longitude": "120.61000000"
                    },
                    {
                        "id": 145889,
                        "name": "Caronoan West",
                        "latitude": "16.26333333",
                        "longitude": "120.44638889"
                    },
                    {
                        "id": 145890,
                        "name": "Carot",
                        "latitude": "16.34472222",
                        "longitude": "119.98000000"
                    },
                    {
                        "id": 145891,
                        "name": "Carriedo",
                        "latitude": "16.03111111",
                        "longitude": "120.75500000"
                    },
                    {
                        "id": 145892,
                        "name": "Carusucan",
                        "latitude": "15.96583333",
                        "longitude": "120.63611111"
                    },
                    {
                        "id": 145893,
                        "name": "Caterman",
                        "latitude": "17.21750000",
                        "longitude": "120.42444444"
                    },
                    {
                        "id": 145894,
                        "name": "Cato",
                        "latitude": "15.83611111",
                        "longitude": "119.91500000"
                    },
                    {
                        "id": 145895,
                        "name": "Catuday",
                        "latitude": "16.29222222",
                        "longitude": "119.80611111"
                    },
                    {
                        "id": 145896,
                        "name": "Cayanga",
                        "latitude": "16.11500000",
                        "longitude": "120.39888889"
                    },
                    {
                        "id": 145897,
                        "name": "Cayungnan",
                        "latitude": "16.13333333",
                        "longitude": "119.83750000"
                    },
                    {
                        "id": 145899,
                        "name": "City of Batac",
                        "latitude": "18.03730000",
                        "longitude": "120.58175000"
                    },
                    {
                        "id": 145900,
                        "name": "City of Candon",
                        "latitude": "17.20000000",
                        "longitude": "120.45000000"
                    },
                    {
                        "id": 145901,
                        "name": "City of Urdaneta",
                        "latitude": "15.97944000",
                        "longitude": "120.59101000"
                    },
                    {
                        "id": 145902,
                        "name": "City of Vigan",
                        "latitude": "17.56275000",
                        "longitude": "120.39071000"
                    },
                    {
                        "id": 145903,
                        "name": "Comillas Norte",
                        "latitude": "16.95888889",
                        "longitude": "120.74694444"
                    },
                    {
                        "id": 145904,
                        "name": "Corrooy",
                        "latitude": "16.79611111",
                        "longitude": "120.44527778"
                    },
                    {
                        "id": 145906,
                        "name": "Dagup",
                        "latitude": "16.63722222",
                        "longitude": "120.44555556"
                    },
                    {
                        "id": 145908,
                        "name": "Damortis",
                        "latitude": "16.24055556",
                        "longitude": "120.40555556"
                    },
                    {
                        "id": 145909,
                        "name": "Darapidap",
                        "latitude": "17.20000000",
                        "longitude": "120.41805556"
                    },
                    {
                        "id": 145911,
                        "name": "Davila",
                        "latitude": "18.47250000",
                        "longitude": "120.57638889"
                    },
                    {
                        "id": 145912,
                        "name": "Diaz",
                        "latitude": "15.84638889",
                        "longitude": "120.83472222"
                    },
                    {
                        "id": 145913,
                        "name": "Dilan",
                        "latitude": "16.08777778",
                        "longitude": "120.52083333"
                    },
                    {
                        "id": 145915,
                        "name": "Domalanoan",
                        "latitude": "16.00305556",
                        "longitude": "120.21166667"
                    },
                    {
                        "id": 145916,
                        "name": "Domampot",
                        "latitude": "16.00000000",
                        "longitude": "120.65000000"
                    },
                    {
                        "id": 145917,
                        "name": "Don Pedro",
                        "latitude": "15.88527778",
                        "longitude": "120.43027778"
                    },
                    {
                        "id": 145918,
                        "name": "Dorongan Punta",
                        "latitude": "15.81472222",
                        "longitude": "120.32277778"
                    },
                    {
                        "id": 145919,
                        "name": "Doyong",
                        "latitude": "15.97222222",
                        "longitude": "120.35388889"
                    },
                    {
                        "id": 145920,
                        "name": "Dulig",
                        "latitude": "16.00222222",
                        "longitude": "120.16861111"
                    },
                    {
                        "id": 145922,
                        "name": "Dumpay",
                        "latitude": "15.88305556",
                        "longitude": "120.38888889"
                    },
                    {
                        "id": 145923,
                        "name": "Eguia",
                        "latitude": "15.90638889",
                        "longitude": "119.88583333"
                    },
                    {
                        "id": 145924,
                        "name": "Esmeralda",
                        "latitude": "15.86722222",
                        "longitude": "120.71500000"
                    },
                    {
                        "id": 145925,
                        "name": "Fuerte",
                        "latitude": "17.53416667",
                        "longitude": "120.36944444"
                    },
                    {
                        "id": 145927,
                        "name": "Gayaman",
                        "latitude": "16.01388889",
                        "longitude": "120.30750000"
                    },
                    {
                        "id": 145930,
                        "name": "Guiling",
                        "latitude": "15.84305556",
                        "longitude": "120.61500000"
                    },
                    {
                        "id": 145931,
                        "name": "Guiset East",
                        "latitude": "16.06666667",
                        "longitude": "120.68333333"
                    },
                    {
                        "id": 145932,
                        "name": "Hacienda",
                        "latitude": "15.93611111",
                        "longitude": "120.17861111"
                    },
                    {
                        "id": 145933,
                        "name": "Halog West",
                        "latitude": "16.36666667",
                        "longitude": "120.41472222"
                    },
                    {
                        "id": 145934,
                        "name": "Ilioilio",
                        "latitude": "15.96166667",
                        "longitude": "119.76583333"
                    },
                    {
                        "id": 145935,
                        "name": "Inabaan Sur",
                        "latitude": "16.26305556",
                        "longitude": "120.47805556"
                    },
                    {
                        "id": 145937,
                        "name": "Isla",
                        "latitude": "15.89500000",
                        "longitude": "120.30138889"
                    },
                    {
                        "id": 145938,
                        "name": "Labayug",
                        "latitude": "16.15277778",
                        "longitude": "120.56611111"
                    },
                    {
                        "id": 145939,
                        "name": "Labney",
                        "latitude": "16.10277778",
                        "longitude": "120.46555556"
                    },
                    {
                        "id": 145941,
                        "name": "Lagasit",
                        "latitude": "15.99333333",
                        "longitude": "120.79388889"
                    },
                    {
                        "id": 145942,
                        "name": "Laguit Centro",
                        "latitude": "15.94722222",
                        "longitude": "120.19027778"
                    },
                    {
                        "id": 145945,
                        "name": "Leones East",
                        "latitude": "16.36333333",
                        "longitude": "120.39194444"
                    },
                    {
                        "id": 145946,
                        "name": "Lepa",
                        "latitude": "15.88444444",
                        "longitude": "120.45083333"
                    },
                    {
                        "id": 145947,
                        "name": "Libas",
                        "latitude": "15.87777778",
                        "longitude": "120.31638889"
                    },
                    {
                        "id": 145950,
                        "name": "Linmansangan",
                        "latitude": "15.82972222",
                        "longitude": "120.29583333"
                    },
                    {
                        "id": 145951,
                        "name": "Lloren",
                        "latitude": "16.33305556",
                        "longitude": "120.43277778"
                    },
                    {
                        "id": 145952,
                        "name": "Lobong",
                        "latitude": "16.08138889",
                        "longitude": "120.47027778"
                    },
                    {
                        "id": 145953,
                        "name": "Longos",
                        "latitude": "16.10722222",
                        "longitude": "120.39666667"
                    },
                    {
                        "id": 145954,
                        "name": "Loqueb Este",
                        "latitude": "15.94472222",
                        "longitude": "120.44611111"
                    },
                    {
                        "id": 145955,
                        "name": "Lucap",
                        "latitude": "16.19027778",
                        "longitude": "120.00222222"
                    },
                    {
                        "id": 145956,
                        "name": "Lucero",
                        "latitude": "16.40500000",
                        "longitude": "119.91250000"
                    },
                    {
                        "id": 145957,
                        "name": "Luna",
                        "latitude": "16.85000000",
                        "longitude": "120.38333333"
                    },
                    {
                        "id": 145958,
                        "name": "Lunec",
                        "latitude": "15.95388889",
                        "longitude": "120.48944444"
                    },
                    {
                        "id": 145959,
                        "name": "Lungog",
                        "latitude": "17.46444444",
                        "longitude": "120.47833333"
                    },
                    {
                        "id": 145960,
                        "name": "Lusong",
                        "latitude": "16.86694444",
                        "longitude": "120.44194444"
                    },
                    {
                        "id": 145961,
                        "name": "Mabilao",
                        "latitude": "16.15361111",
                        "longitude": "120.42500000"
                    },
                    {
                        "id": 145962,
                        "name": "Mabilbila Sur",
                        "latitude": "17.50722222",
                        "longitude": "120.44111111"
                    },
                    {
                        "id": 145964,
                        "name": "Mabusag",
                        "latitude": "17.92611111",
                        "longitude": "120.49750000"
                    },
                    {
                        "id": 145965,
                        "name": "Macabuboni",
                        "latitude": "16.19083333",
                        "longitude": "119.78027778"
                    },
                    {
                        "id": 145966,
                        "name": "Macalong",
                        "latitude": "16.01361111",
                        "longitude": "120.65861111"
                    },
                    {
                        "id": 145967,
                        "name": "Macalva Norte",
                        "latitude": "16.34861111",
                        "longitude": "120.38666667"
                    },
                    {
                        "id": 145968,
                        "name": "Macayug",
                        "latitude": "16.09388889",
                        "longitude": "120.43194444"
                    },
                    {
                        "id": 145971,
                        "name": "Magtaking",
                        "latitude": "15.98527778",
                        "longitude": "120.18333333"
                    },
                    {
                        "id": 145972,
                        "name": "Malabago",
                        "latitude": "15.98166667",
                        "longitude": "120.35916667"
                    },
                    {
                        "id": 145973,
                        "name": "Malanay",
                        "latitude": "16.00861111",
                        "longitude": "120.40944444"
                    },
                    {
                        "id": 145975,
                        "name": "Malawa",
                        "latitude": "15.95805556",
                        "longitude": "120.27777778"
                    },
                    {
                        "id": 145976,
                        "name": "Malibong East",
                        "latitude": "15.84666667",
                        "longitude": "120.32694444"
                    },
                    {
                        "id": 145981,
                        "name": "Mapolopolo",
                        "latitude": "15.88083333",
                        "longitude": "120.37416667"
                    },
                    {
                        "id": 145983,
                        "name": "Maticmatic",
                        "latitude": "15.98638889",
                        "longitude": "120.45194444"
                    },
                    {
                        "id": 145984,
                        "name": "Minien East",
                        "latitude": "15.97722222",
                        "longitude": "120.48138889"
                    },
                    {
                        "id": 145985,
                        "name": "Nagbacalan",
                        "latitude": "18.11583333",
                        "longitude": "120.52361111"
                    },
                    {
                        "id": 145987,
                        "name": "Nagsaing",
                        "latitude": "15.98055556",
                        "longitude": "120.33777778"
                    },
                    {
                        "id": 145988,
                        "name": "Naguelguel",
                        "latitude": "16.00583333",
                        "longitude": "120.26361111"
                    },
                    {
                        "id": 145989,
                        "name": "Naguilayan",
                        "latitude": "16.00305556",
                        "longitude": "120.29111111"
                    },
                    {
                        "id": 145990,
                        "name": "Naguilian",
                        "latitude": "16.53333333",
                        "longitude": "120.40000000"
                    },
                    {
                        "id": 145991,
                        "name": "Nalsian Norte",
                        "latitude": "15.84472222",
                        "longitude": "120.45083333"
                    },
                    {
                        "id": 145992,
                        "name": "Nama",
                        "latitude": "16.14111111",
                        "longitude": "120.54250000"
                    },
                    {
                        "id": 145993,
                        "name": "Namboongan",
                        "latitude": "16.30333333",
                        "longitude": "120.37583333"
                    },
                    {
                        "id": 145994,
                        "name": "Nancalobasaan",
                        "latitude": "15.93416667",
                        "longitude": "120.84250000"
                    },
                    {
                        "id": 145997,
                        "name": "Navatat",
                        "latitude": "15.84972222",
                        "longitude": "120.39055556"
                    },
                    {
                        "id": 145998,
                        "name": "Nibaliw Central",
                        "latitude": "16.12750000",
                        "longitude": "120.40277778"
                    },
                    {
                        "id": 145999,
                        "name": "Nilombot",
                        "latitude": "16.03055556",
                        "longitude": "120.43694444"
                    },
                    {
                        "id": 146000,
                        "name": "Ninoy",
                        "latitude": "15.85972222",
                        "longitude": "120.24777778"
                    },
                    {
                        "id": 146002,
                        "name": "Oaqui",
                        "latitude": "16.85833333",
                        "longitude": "120.41250000"
                    },
                    {
                        "id": 146003,
                        "name": "Olea",
                        "latitude": "15.86250000",
                        "longitude": "120.49361111"
                    },
                    {
                        "id": 146004,
                        "name": "Padong",
                        "latitude": "18.05444444",
                        "longitude": "120.75416667"
                    },
                    {
                        "id": 146005,
                        "name": "Pagsanahan Norte",
                        "latitude": "17.91916667",
                        "longitude": "120.44583333"
                    },
                    {
                        "id": 146007,
                        "name": "Paitan Este",
                        "latitude": "16.08527778",
                        "longitude": "120.03166667"
                    },
                    {
                        "id": 146008,
                        "name": "Palacpalac",
                        "latitude": "16.13111111",
                        "longitude": "120.53055556"
                    },
                    {
                        "id": 146009,
                        "name": "Palguyod",
                        "latitude": "16.12277778",
                        "longitude": "120.52000000"
                    },
                    {
                        "id": 146011,
                        "name": "Pangapisan",
                        "latitude": "16.21611111",
                        "longitude": "119.95694444"
                    },
                    {
                        "id": 146012,
                        "name": "Pangascasan",
                        "latitude": "16.11694444",
                        "longitude": "120.08666667"
                    },
                    {
                        "id": 146013,
                        "name": "Pangpang",
                        "latitude": "15.93888889",
                        "longitude": "120.30944444"
                    },
                    {
                        "id": 146015,
                        "name": "Paringao",
                        "latitude": "16.57166667",
                        "longitude": "120.32416667"
                    },
                    {
                        "id": 146016,
                        "name": "Parioc Segundo",
                        "latitude": "17.17500000",
                        "longitude": "120.46583333"
                    },
                    {
                        "id": 146017,
                        "name": "Pasibi West",
                        "latitude": "15.85861111",
                        "longitude": "120.37944444"
                    },
                    {
                        "id": 146019,
                        "name": "Patayac",
                        "latitude": "15.96305556",
                        "longitude": "120.42250000"
                    },
                    {
                        "id": 146020,
                        "name": "Patpata Segundo",
                        "latitude": "17.18333333",
                        "longitude": "120.43333333"
                    },
                    {
                        "id": 146021,
                        "name": "Payocpoc Sur",
                        "latitude": "16.49444444",
                        "longitude": "120.32805556"
                    },
                    {
                        "id": 146023,
                        "name": "Pindangan Centro",
                        "latitude": "15.86055556",
                        "longitude": "120.55138889"
                    },
                    {
                        "id": 146025,
                        "name": "Pogonsili",
                        "latitude": "15.82055556",
                        "longitude": "120.26027778"
                    },
                    {
                        "id": 146026,
                        "name": "Polo",
                        "latitude": "16.19638889",
                        "longitude": "119.94916667"
                    },
                    {
                        "id": 146027,
                        "name": "Polong",
                        "latitude": "15.97722222",
                        "longitude": "120.20083333"
                    },
                    {
                        "id": 146028,
                        "name": "Polong Norte",
                        "latitude": "15.90305556",
                        "longitude": "120.42138889"
                    },
                    {
                        "id": 146030,
                        "name": "Pudoc",
                        "latitude": "16.92138889",
                        "longitude": "120.42361111"
                    },
                    {
                        "id": 146031,
                        "name": "Pudoc North",
                        "latitude": "17.60972222",
                        "longitude": "120.36861111"
                    },
                    {
                        "id": 146032,
                        "name": "Puelay",
                        "latitude": "15.88694444",
                        "longitude": "120.57361111"
                    },
                    {
                        "id": 146034,
                        "name": "Puro Pinget",
                        "latitude": "17.67972222",
                        "longitude": "120.35888889"
                    },
                    {
                        "id": 146035,
                        "name": "Quiling",
                        "latitude": "18.06833333",
                        "longitude": "120.54388889"
                    },
                    {
                        "id": 146036,
                        "name": "Quinarayan",
                        "latitude": "17.44416667",
                        "longitude": "120.47222222"
                    },
                    {
                        "id": 146037,
                        "name": "Quintong",
                        "latitude": "15.95583333",
                        "longitude": "120.32166667"
                    },
                    {
                        "id": 146040,
                        "name": "Ranao",
                        "latitude": "16.20750000",
                        "longitude": "119.81555556"
                    },
                    {
                        "id": 146042,
                        "name": "Rimus",
                        "latitude": "16.87638889",
                        "longitude": "120.39666667"
                    },
                    {
                        "id": 146043,
                        "name": "Rissing",
                        "latitude": "16.87527778",
                        "longitude": "120.43444444"
                    },
                    {
                        "id": 146046,
                        "name": "Sablig",
                        "latitude": "16.26888889",
                        "longitude": "119.98777778"
                    },
                    {
                        "id": 146047,
                        "name": "Sagud-Bahley",
                        "latitude": "16.11694444",
                        "longitude": "120.39111111"
                    },
                    {
                        "id": 146048,
                        "name": "Sagunto",
                        "latitude": "16.20083333",
                        "longitude": "120.51500000"
                    },
                    {
                        "id": 146051,
                        "name": "Samon",
                        "latitude": "15.93500000",
                        "longitude": "120.65083333"
                    },
                    {
                        "id": 146055,
                        "name": "San Eugenio",
                        "latitude": "16.35972222",
                        "longitude": "120.35694444"
                    },
                    {
                        "id": 146058,
                        "name": "San Fernando Poblacion",
                        "latitude": "16.61591000",
                        "longitude": "120.31663000"
                    },
                    {
                        "id": 146060,
                        "name": "San Gabriel First",
                        "latitude": "15.76638889",
                        "longitude": "120.45666667"
                    },
                    {
                        "id": 146063,
                        "name": "San Juan",
                        "latitude": "16.66861000",
                        "longitude": "120.34139000"
                    },
                    {
                        "id": 146070,
                        "name": "San Pedro Apartado",
                        "latitude": "15.83694444",
                        "longitude": "120.56527778"
                    },
                    {
                        "id": 146071,
                        "name": "San Quintin",
                        "latitude": "15.98444400",
                        "longitude": "120.81500000"
                    },
                    {
                        "id": 146074,
                        "name": "Sanlibo",
                        "latitude": "15.91666667",
                        "longitude": "120.55000000"
                    },
                    {
                        "id": 146085,
                        "name": "Santo Tomas",
                        "latitude": "16.27980000",
                        "longitude": "120.37920000"
                    },
                    {
                        "id": 146093,
                        "name": "Sonquil",
                        "latitude": "15.98805556",
                        "longitude": "120.39055556"
                    },
                    {
                        "id": 146095,
                        "name": "Subusub",
                        "latitude": "16.22694444",
                        "longitude": "120.49500000"
                    },
                    {
                        "id": 146098,
                        "name": "Sumabnit",
                        "latitude": "16.03027778",
                        "longitude": "120.58333333"
                    },
                    {
                        "id": 146099,
                        "name": "Suso",
                        "latitude": "17.35944444",
                        "longitude": "120.46111111"
                    },
                    {
                        "id": 146101,
                        "name": "Tablac",
                        "latitude": "17.21555556",
                        "longitude": "120.45416667"
                    },
                    {
                        "id": 146102,
                        "name": "Tabug",
                        "latitude": "18.03416667",
                        "longitude": "120.54888889"
                    },
                    {
                        "id": 146105,
                        "name": "Talospatang",
                        "latitude": "15.91694444",
                        "longitude": "120.44138889"
                    },
                    {
                        "id": 146106,
                        "name": "Taloy",
                        "latitude": "15.92416667",
                        "longitude": "120.39638889"
                    },
                    {
                        "id": 146107,
                        "name": "Tamayo",
                        "latitude": "15.87750000",
                        "longitude": "120.28444444"
                    },
                    {
                        "id": 146108,
                        "name": "Tamorong",
                        "latitude": "17.33333333",
                        "longitude": "120.43333333"
                    },
                    {
                        "id": 146109,
                        "name": "Tandoc",
                        "latitude": "15.95916667",
                        "longitude": "120.32916667"
                    },
                    {
                        "id": 146110,
                        "name": "Tanolong",
                        "latitude": "15.80416667",
                        "longitude": "120.41416667"
                    },
                    {
                        "id": 146112,
                        "name": "Tebag East",
                        "latitude": "15.98111111",
                        "longitude": "120.46750000"
                    },
                    {
                        "id": 146113,
                        "name": "Telbang",
                        "latitude": "16.17250000",
                        "longitude": "120.06083333"
                    },
                    {
                        "id": 146114,
                        "name": "Tiep",
                        "latitude": "16.23833333",
                        "longitude": "119.86083333"
                    },
                    {
                        "id": 146115,
                        "name": "Toboy",
                        "latitude": "16.02722222",
                        "longitude": "120.63694444"
                    },
                    {
                        "id": 146116,
                        "name": "Tobuan",
                        "latitude": "16.05555556",
                        "longitude": "120.11027778"
                    },
                    {
                        "id": 146117,
                        "name": "Tococ East",
                        "latitude": "15.82500000",
                        "longitude": "120.42611111"
                    },
                    {
                        "id": 146118,
                        "name": "Tocok",
                        "latitude": "15.75000000",
                        "longitude": "120.30000000"
                    },
                    {
                        "id": 146119,
                        "name": "Tombod",
                        "latitude": "15.93166667",
                        "longitude": "120.56722222"
                    },
                    {
                        "id": 146120,
                        "name": "Tondol",
                        "latitude": "16.31027778",
                        "longitude": "120.01305556"
                    },
                    {
                        "id": 146121,
                        "name": "Toritori",
                        "latitude": "16.23833333",
                        "longitude": "119.99555556"
                    },
                    {
                        "id": 146123,
                        "name": "Umanday Centro",
                        "latitude": "15.93805556",
                        "longitude": "120.21527778"
                    },
                    {
                        "id": 146125,
                        "name": "Unzad",
                        "latitude": "15.91888889",
                        "longitude": "120.53916667"
                    },
                    {
                        "id": 146128,
                        "name": "Uyong",
                        "latitude": "16.05000000",
                        "longitude": "120.12083333"
                    }
                ]
            },
            {
                "id": 1323,
                "name": "Agusan del Norte",
                "iso2": "AGN",
                "latitude": "8.94562590",
                "longitude": "125.53192340",
                "type": "province",
                "cities": [
                    {
                        "id": 145098,
                        "name": "Abut",
                        "latitude": "17.35416667",
                        "longitude": "121.60138889"
                    },
                    {
                        "id": 145099,
                        "name": "Accusilian",
                        "latitude": "17.74777778",
                        "longitude": "121.46250000"
                    },
                    {
                        "id": 145100,
                        "name": "Afusing Centro",
                        "latitude": "17.85250000",
                        "longitude": "121.62694444"
                    },
                    {
                        "id": 145102,
                        "name": "Alabug",
                        "latitude": "17.73250000",
                        "longitude": "121.46777778"
                    },
                    {
                        "id": 145103,
                        "name": "Alannay",
                        "latitude": "18.06111111",
                        "longitude": "121.58611111"
                    },
                    {
                        "id": 145106,
                        "name": "Alicia",
                        "latitude": "16.77868611",
                        "longitude": "121.69718056"
                    },
                    {
                        "id": 145107,
                        "name": "Allacapan",
                        "latitude": "18.22696667",
                        "longitude": "121.55558333"
                    },
                    {
                        "id": 145108,
                        "name": "Almaguer North",
                        "latitude": "16.34972222",
                        "longitude": "121.09250000"
                    },
                    {
                        "id": 145110,
                        "name": "Amulung",
                        "latitude": "17.83865556",
                        "longitude": "121.72348333"
                    },
                    {
                        "id": 145112,
                        "name": "Antagan Segunda",
                        "latitude": "17.28277778",
                        "longitude": "121.87138889"
                    },
                    {
                        "id": 145113,
                        "name": "Aparri",
                        "latitude": "18.35497500",
                        "longitude": "121.64185000"
                    },
                    {
                        "id": 145115,
                        "name": "Atulayan",
                        "latitude": "17.66472222",
                        "longitude": "121.69361111"
                    },
                    {
                        "id": 145117,
                        "name": "Awallan",
                        "latitude": "17.92444444",
                        "longitude": "121.91305556"
                    },
                    {
                        "id": 145118,
                        "name": "Bacnor East",
                        "latitude": "17.03444444",
                        "longitude": "121.70361111"
                    },
                    {
                        "id": 145120,
                        "name": "Baggabag B",
                        "latitude": "16.50583333",
                        "longitude": "121.19027778"
                    },
                    {
                        "id": 145121,
                        "name": "Baggao",
                        "latitude": "17.88935278",
                        "longitude": "121.87092222"
                    },
                    {
                        "id": 145122,
                        "name": "Bagong Tanza",
                        "latitude": "16.98277778",
                        "longitude": "121.61111111"
                    },
                    {
                        "id": 145123,
                        "name": "Bagu",
                        "latitude": "18.42444444",
                        "longitude": "121.35583333"
                    },
                    {
                        "id": 145126,
                        "name": "Ballesteros",
                        "latitude": "18.40000000",
                        "longitude": "121.51666667"
                    },
                    {
                        "id": 145128,
                        "name": "Bangad",
                        "latitude": "17.49555556",
                        "longitude": "121.77722222"
                    },
                    {
                        "id": 145129,
                        "name": "Banganan",
                        "latitude": "16.31444444",
                        "longitude": "121.05444444"
                    },
                    {
                        "id": 145130,
                        "name": "Banquero",
                        "latitude": "17.02305556",
                        "longitude": "121.77833333"
                    },
                    {
                        "id": 145131,
                        "name": "Barucboc Norte",
                        "latitude": "17.25861111",
                        "longitude": "121.60555556"
                    },
                    {
                        "id": 145132,
                        "name": "Basco",
                        "latitude": "20.45000000",
                        "longitude": "121.96666667"
                    },
                    {
                        "id": 145133,
                        "name": "Batal",
                        "latitude": "16.68750000",
                        "longitude": "121.60083000"
                    },
                    {
                        "id": 145134,
                        "name": "Battung",
                        "latitude": "17.72250000",
                        "longitude": "121.45916667"
                    },
                    {
                        "id": 145137,
                        "name": "Belance",
                        "latitude": "16.18333333",
                        "longitude": "121.25000000"
                    },
                    {
                        "id": 145139,
                        "name": "Binalan",
                        "latitude": "18.32750000",
                        "longitude": "121.54500000"
                    },
                    {
                        "id": 145140,
                        "name": "Binguang",
                        "latitude": "17.45888889",
                        "longitude": "121.79527778"
                    },
                    {
                        "id": 145141,
                        "name": "Bintawan",
                        "latitude": "16.57583333",
                        "longitude": "121.18777778"
                    },
                    {
                        "id": 145142,
                        "name": "Bitag Grande",
                        "latitude": "17.90250000",
                        "longitude": "121.85000000"
                    },
                    {
                        "id": 145143,
                        "name": "Bone South",
                        "latitude": "16.24472222",
                        "longitude": "120.99583333"
                    },
                    {
                        "id": 145144,
                        "name": "Buguey",
                        "latitude": "18.28823000",
                        "longitude": "121.83310000"
                    },
                    {
                        "id": 145145,
                        "name": "Buliwao",
                        "latitude": "16.48333333",
                        "longitude": "121.23333333"
                    },
                    {
                        "id": 145146,
                        "name": "Bulu",
                        "latitude": "17.33333333",
                        "longitude": "121.76666667"
                    },
                    {
                        "id": 145149,
                        "name": "Busilak",
                        "latitude": "16.47750000",
                        "longitude": "121.12416667"
                    },
                    {
                        "id": 145151,
                        "name": "Cabannungan Second",
                        "latitude": "17.12500000",
                        "longitude": "121.85055556"
                    },
                    {
                        "id": 145152,
                        "name": "Cabaritan East",
                        "latitude": "18.41777778",
                        "longitude": "121.48861111"
                    },
                    {
                        "id": 145155,
                        "name": "Cabiraoan",
                        "latitude": "18.32388889",
                        "longitude": "122.08583333"
                    },
                    {
                        "id": 145156,
                        "name": "Calamagui East",
                        "latitude": "17.48805556",
                        "longitude": "121.76833333"
                    },
                    {
                        "id": 145157,
                        "name": "Calantac",
                        "latitude": "17.90916667",
                        "longitude": "121.72277778"
                    },
                    {
                        "id": 145158,
                        "name": "Calaoagan",
                        "latitude": "18.04277778",
                        "longitude": "121.72333333"
                    },
                    {
                        "id": 145159,
                        "name": "Calayan",
                        "latitude": "19.26666667",
                        "longitude": "121.48333333"
                    },
                    {
                        "id": 145160,
                        "name": "Calinaoan Malasin",
                        "latitude": "17.35194444",
                        "longitude": "121.74083333"
                    },
                    {
                        "id": 145161,
                        "name": "Calog Norte",
                        "latitude": "18.36361111",
                        "longitude": "121.38527778"
                    },
                    {
                        "id": 145162,
                        "name": "Camalaniugan",
                        "latitude": "18.26666667",
                        "longitude": "121.68333333"
                    },
                    {
                        "id": 145163,
                        "name": "Capissayan Sur",
                        "latitude": "18.05083333",
                        "longitude": "121.81777778"
                    },
                    {
                        "id": 145164,
                        "name": "Carig",
                        "latitude": "17.65916667",
                        "longitude": "121.74361111"
                    },
                    {
                        "id": 145165,
                        "name": "Casambalangan",
                        "latitude": "18.37638889",
                        "longitude": "122.12750000"
                    },
                    {
                        "id": 145166,
                        "name": "Catayauan",
                        "latitude": "18.16083333",
                        "longitude": "121.65277778"
                    },
                    {
                        "id": 145170,
                        "name": "Cullalabo del Sur",
                        "latitude": "17.10277778",
                        "longitude": "121.70388889"
                    },
                    {
                        "id": 145172,
                        "name": "Dalaoig",
                        "latitude": "17.94916667",
                        "longitude": "121.71472222"
                    },
                    {
                        "id": 145173,
                        "name": "Daragutan",
                        "latitude": "17.00000000",
                        "longitude": "122.03333333"
                    },
                    {
                        "id": 145174,
                        "name": "Dassun",
                        "latitude": "17.74527778",
                        "longitude": "121.71138889"
                    },
                    {
                        "id": 145177,
                        "name": "Diamantina",
                        "latitude": "16.91805556",
                        "longitude": "121.62666667"
                    },
                    {
                        "id": 145178,
                        "name": "Dibuluan",
                        "latitude": "16.51916667",
                        "longitude": "121.76472222"
                    },
                    {
                        "id": 145179,
                        "name": "Dicabisagan",
                        "latitude": "17.08194444",
                        "longitude": "122.41583333"
                    },
                    {
                        "id": 145180,
                        "name": "Dicamay",
                        "latitude": "16.75611111",
                        "longitude": "122.00361111"
                    },
                    {
                        "id": 145182,
                        "name": "Dinapigui",
                        "latitude": "16.66667000",
                        "longitude": "122.23333000"
                    },
                    {
                        "id": 145183,
                        "name": "Divilican",
                        "latitude": "17.24194000",
                        "longitude": "122.31548000"
                    },
                    {
                        "id": 145184,
                        "name": "Divisoria",
                        "latitude": "17.52277778",
                        "longitude": "121.77416667"
                    },
                    {
                        "id": 145185,
                        "name": "Dodan",
                        "latitude": "17.64111111",
                        "longitude": "121.79444444"
                    },
                    {
                        "id": 145186,
                        "name": "Dumabato",
                        "latitude": "16.31666667",
                        "longitude": "121.70000000"
                    },
                    {
                        "id": 145190,
                        "name": "Echague (town)",
                        "latitude": "16.70500000",
                        "longitude": "121.67638889"
                    },
                    {
                        "id": 145191,
                        "name": "Eden",
                        "latitude": "17.03805556",
                        "longitude": "121.59805556"
                    },
                    {
                        "id": 145192,
                        "name": "Enrile",
                        "latitude": "17.55000000",
                        "longitude": "121.70000000"
                    },
                    {
                        "id": 145193,
                        "name": "Esperanza East",
                        "latitude": "17.02333333",
                        "longitude": "121.68388889"
                    },
                    {
                        "id": 145194,
                        "name": "Estefania",
                        "latitude": "17.79944444",
                        "longitude": "121.72305556"
                    },
                    {
                        "id": 145195,
                        "name": "Furao",
                        "latitude": "17.03472222",
                        "longitude": "121.79694444"
                    },
                    {
                        "id": 145196,
                        "name": "Gadu",
                        "latitude": "17.62916667",
                        "longitude": "121.61055556"
                    },
                    {
                        "id": 145197,
                        "name": "Gammad",
                        "latitude": "17.71027778",
                        "longitude": "121.74361111"
                    },
                    {
                        "id": 145199,
                        "name": "Ganapi",
                        "latitude": "17.20166667",
                        "longitude": "121.86527778"
                    },
                    {
                        "id": 145200,
                        "name": "Gappal",
                        "latitude": "16.83638889",
                        "longitude": "121.82194444"
                    },
                    {
                        "id": 145201,
                        "name": "Gattaran",
                        "latitude": "18.06166667",
                        "longitude": "121.64416667"
                    },
                    {
                        "id": 145202,
                        "name": "Gonzaga",
                        "latitude": "18.26666667",
                        "longitude": "122.00000000"
                    },
                    {
                        "id": 145203,
                        "name": "Guiddam",
                        "latitude": "18.33500000",
                        "longitude": "121.46611111"
                    },
                    {
                        "id": 145204,
                        "name": "Ibung",
                        "latitude": "16.60938000",
                        "longitude": "121.18614000"
                    },
                    {
                        "id": 145205,
                        "name": "Iguig",
                        "latitude": "17.75000000",
                        "longitude": "121.73333333"
                    },
                    {
                        "id": 145208,
                        "name": "Ineangan",
                        "latitude": "16.31805556",
                        "longitude": "121.09305556"
                    },
                    {
                        "id": 145209,
                        "name": "Itbayat",
                        "latitude": "20.76667000",
                        "longitude": "121.83333000"
                    },
                    {
                        "id": 145210,
                        "name": "Ivana",
                        "latitude": "20.36666667",
                        "longitude": "121.91666667"
                    },
                    {
                        "id": 145214,
                        "name": "La Paz",
                        "latitude": "16.91083333",
                        "longitude": "121.66833333"
                    },
                    {
                        "id": 145215,
                        "name": "Lal-lo",
                        "latitude": "18.20000000",
                        "longitude": "121.66666667"
                    },
                    {
                        "id": 145217,
                        "name": "Lallayug",
                        "latitude": "17.70694444",
                        "longitude": "121.44166667"
                    },
                    {
                        "id": 145218,
                        "name": "Lanna",
                        "latitude": "17.69611111",
                        "longitude": "121.70027778"
                    },
                    {
                        "id": 145219,
                        "name": "Lapi",
                        "latitude": "17.71611111",
                        "longitude": "121.89777778"
                    },
                    {
                        "id": 145220,
                        "name": "Larion Alto",
                        "latitude": "17.63083333",
                        "longitude": "121.76055556"
                    },
                    {
                        "id": 145221,
                        "name": "Lasam",
                        "latitude": "18.06666667",
                        "longitude": "121.60000000"
                    },
                    {
                        "id": 145223,
                        "name": "Luna",
                        "latitude": "16.96666667",
                        "longitude": "121.73333333"
                    },
                    {
                        "id": 145224,
                        "name": "Mabasa",
                        "latitude": "16.32111111",
                        "longitude": "121.12611111"
                    },
                    {
                        "id": 145226,
                        "name": "Mabuttal East",
                        "latitude": "18.37611111",
                        "longitude": "121.51472222"
                    },
                    {
                        "id": 145228,
                        "name": "Maddarulug Norte",
                        "latitude": "17.60722222",
                        "longitude": "121.67666667"
                    },
                    {
                        "id": 145230,
                        "name": "Magalalag",
                        "latitude": "17.57722222",
                        "longitude": "121.73500000"
                    },
                    {
                        "id": 145232,
                        "name": "Maguilling",
                        "latitude": "17.76972222",
                        "longitude": "121.49777778"
                    },
                    {
                        "id": 145233,
                        "name": "Mahatao",
                        "latitude": "20.41666667",
                        "longitude": "121.95000000"
                    },
                    {
                        "id": 145234,
                        "name": "Malasin",
                        "latitude": "16.30444444",
                        "longitude": "121.10611111"
                    },
                    {
                        "id": 145237,
                        "name": "Maluno Sur",
                        "latitude": "16.99888889",
                        "longitude": "121.96444444"
                    },
                    {
                        "id": 145238,
                        "name": "Manaring",
                        "latitude": "17.17305556",
                        "longitude": "121.90250000"
                    },
                    {
                        "id": 145239,
                        "name": "Manga",
                        "latitude": "17.70111111",
                        "longitude": "121.86055556"
                    },
                    {
                        "id": 145240,
                        "name": "Masaya Sur",
                        "latitude": "16.50027778",
                        "longitude": "121.74750000"
                    },
                    {
                        "id": 145241,
                        "name": "Masipi West",
                        "latitude": "17.37944444",
                        "longitude": "121.83861111"
                    },
                    {
                        "id": 145242,
                        "name": "Maxingal",
                        "latitude": "18.21500000",
                        "longitude": "121.66805556"
                    },
                    {
                        "id": 145243,
                        "name": "Minallo",
                        "latitude": "16.98694444",
                        "longitude": "121.85388889"
                    },
                    {
                        "id": 145244,
                        "name": "Minanga Norte",
                        "latitude": "17.45222222",
                        "longitude": "121.78527778"
                    },
                    {
                        "id": 145246,
                        "name": "Minante Segundo",
                        "latitude": "16.90222222",
                        "longitude": "121.76194444"
                    },
                    {
                        "id": 145247,
                        "name": "Minuri",
                        "latitude": "16.53222222",
                        "longitude": "121.85527778"
                    },
                    {
                        "id": 145248,
                        "name": "Mozzozzin Sur",
                        "latitude": "17.45694444",
                        "longitude": "121.74611111"
                    },
                    {
                        "id": 145249,
                        "name": "Mungo",
                        "latitude": "17.72416667",
                        "longitude": "121.47083333"
                    },
                    {
                        "id": 145250,
                        "name": "Municipality of Delfin Albano",
                        "latitude": "17.26667000",
                        "longitude": "121.73333000"
                    },
                    {
                        "id": 145251,
                        "name": "Muñoz East",
                        "latitude": "17.15750000",
                        "longitude": "121.61361111"
                    },
                    {
                        "id": 145252,
                        "name": "Nabannagan West",
                        "latitude": "18.07166667",
                        "longitude": "121.53638889"
                    },
                    {
                        "id": 145253,
                        "name": "Nagrumbuan",
                        "latitude": "16.89944444",
                        "longitude": "121.70972222"
                    },
                    {
                        "id": 145256,
                        "name": "Namuac",
                        "latitude": "18.61083333",
                        "longitude": "121.16583333"
                    },
                    {
                        "id": 145257,
                        "name": "Nattapian",
                        "latitude": "17.67527778",
                        "longitude": "121.70305556"
                    },
                    {
                        "id": 145258,
                        "name": "Paddaya",
                        "latitude": "18.32361111",
                        "longitude": "121.73861111"
                    },
                    {
                        "id": 145260,
                        "name": "Palagao Norte",
                        "latitude": "18.04416667",
                        "longitude": "121.71861111"
                    },
                    {
                        "id": 145261,
                        "name": "Palanan",
                        "latitude": "17.05888889",
                        "longitude": "122.43000000"
                    },
                    {
                        "id": 145263,
                        "name": "Pangal Sur",
                        "latitude": "16.60027778",
                        "longitude": "121.66972222"
                    },
                    {
                        "id": 145265,
                        "name": "Pattao",
                        "latitude": "18.24694444",
                        "longitude": "121.81472222"
                    },
                    {
                        "id": 145266,
                        "name": "Peñablanca",
                        "latitude": "17.63333333",
                        "longitude": "121.78333333"
                    },
                    {
                        "id": 145267,
                        "name": "Piat",
                        "latitude": "17.79166667",
                        "longitude": "121.47500000"
                    },
                    {
                        "id": 145268,
                        "name": "Pinoma",
                        "latitude": "16.87416667",
                        "longitude": "121.70666667"
                    },
                    {
                        "id": 145271,
                        "name": "Quibal",
                        "latitude": "17.71583333",
                        "longitude": "121.81138889"
                    },
                    {
                        "id": 145273,
                        "name": "Ragan Norte",
                        "latitude": "17.32305556",
                        "longitude": "121.77416667"
                    },
                    {
                        "id": 145274,
                        "name": "Ramon (municipal capital)",
                        "latitude": "16.78416000",
                        "longitude": "121.53504000"
                    },
                    {
                        "id": 145275,
                        "name": "Ramos West",
                        "latitude": "16.69833333",
                        "longitude": "121.61361111"
                    },
                    {
                        "id": 145277,
                        "name": "Rizal",
                        "latitude": "17.85000000",
                        "longitude": "121.35000000"
                    },
                    {
                        "id": 145280,
                        "name": "Sabtang",
                        "latitude": "20.33333333",
                        "longitude": "121.86666667"
                    },
                    {
                        "id": 145282,
                        "name": "Salinas",
                        "latitude": "16.36944444",
                        "longitude": "121.01888889"
                    },
                    {
                        "id": 145283,
                        "name": "Salinungan Proper",
                        "latitude": "16.86916667",
                        "longitude": "121.61444444"
                    },
                    {
                        "id": 145284,
                        "name": "San Agustin",
                        "latitude": "16.51666667",
                        "longitude": "121.75000000"
                    },
                    {
                        "id": 145285,
                        "name": "San Antonio",
                        "latitude": "16.35027778",
                        "longitude": "121.10916667"
                    },
                    {
                        "id": 145287,
                        "name": "San Bernardo",
                        "latitude": "17.40472222",
                        "longitude": "121.75166667"
                    },
                    {
                        "id": 145290,
                        "name": "San Isidro",
                        "latitude": "16.73333000",
                        "longitude": "121.61667000"
                    },
                    {
                        "id": 145297,
                        "name": "San Mateo",
                        "latitude": "16.88333333",
                        "longitude": "121.58333333"
                    },
                    {
                        "id": 145299,
                        "name": "San Pablo",
                        "latitude": "17.48305556",
                        "longitude": "121.98777778"
                    },
                    {
                        "id": 145300,
                        "name": "San Pedro",
                        "latitude": "17.20000000",
                        "longitude": "121.88333333"
                    },
                    {
                        "id": 145301,
                        "name": "San Vicente",
                        "latitude": "18.50750000",
                        "longitude": "122.15027778"
                    },
                    {
                        "id": 145302,
                        "name": "Sanchez Mira",
                        "latitude": "18.56666667",
                        "longitude": "121.23333333"
                    },
                    {
                        "id": 145303,
                        "name": "Sandiat Centro",
                        "latitude": "17.07305556",
                        "longitude": "121.63750000"
                    },
                    {
                        "id": 145304,
                        "name": "Santa Ana",
                        "latitude": "18.46666667",
                        "longitude": "122.15000000"
                    },
                    {
                        "id": 145305,
                        "name": "Santa Cruz",
                        "latitude": "18.51638889",
                        "longitude": "121.31055556"
                    },
                    {
                        "id": 145309,
                        "name": "Santa Praxedes",
                        "latitude": "18.56666667",
                        "longitude": "121.00000000"
                    },
                    {
                        "id": 145311,
                        "name": "Santiago",
                        "latitude": "16.68333333",
                        "longitude": "121.55000000"
                    },
                    {
                        "id": 145313,
                        "name": "Santo Niño",
                        "latitude": "17.88610000",
                        "longitude": "121.56910000"
                    },
                    {
                        "id": 145316,
                        "name": "Siempre Viva",
                        "latitude": "17.22861111",
                        "longitude": "121.63305556"
                    },
                    {
                        "id": 145317,
                        "name": "Sillawit",
                        "latitude": "16.87305556",
                        "longitude": "121.75916667"
                    },
                    {
                        "id": 145318,
                        "name": "Simanu Sur",
                        "latitude": "17.48527778",
                        "longitude": "121.83416667"
                    },
                    {
                        "id": 145319,
                        "name": "Simimbaan",
                        "latitude": "17.11861111",
                        "longitude": "121.58138889"
                    },
                    {
                        "id": 145320,
                        "name": "Sinamar",
                        "latitude": "16.90000000",
                        "longitude": "121.56666667"
                    },
                    {
                        "id": 145321,
                        "name": "Sindon",
                        "latitude": "17.06027778",
                        "longitude": "122.01527778"
                    },
                    {
                        "id": 145322,
                        "name": "Solana",
                        "latitude": "17.65000000",
                        "longitude": "121.68333333"
                    },
                    {
                        "id": 145324,
                        "name": "Soyung",
                        "latitude": "16.70000000",
                        "longitude": "121.66555556"
                    },
                    {
                        "id": 145325,
                        "name": "Taguing",
                        "latitude": "17.94638889",
                        "longitude": "121.75527778"
                    },
                    {
                        "id": 145326,
                        "name": "Tapel",
                        "latitude": "18.28916667",
                        "longitude": "122.02916667"
                    },
                    {
                        "id": 145327,
                        "name": "Tuao",
                        "latitude": "17.73333333",
                        "longitude": "121.45000000"
                    },
                    {
                        "id": 145329,
                        "name": "Tuguegarao",
                        "latitude": "17.61577000",
                        "longitude": "121.72285000"
                    },
                    {
                        "id": 145330,
                        "name": "Tuguegarao City",
                        "latitude": "17.61667000",
                        "longitude": "121.75000000"
                    },
                    {
                        "id": 145332,
                        "name": "Tupang",
                        "latitude": "17.90472222",
                        "longitude": "121.64111111"
                    },
                    {
                        "id": 145333,
                        "name": "Uddiawan",
                        "latitude": "16.55888889",
                        "longitude": "121.15111111"
                    },
                    {
                        "id": 145334,
                        "name": "Ugac Sur",
                        "latitude": "17.61333333",
                        "longitude": "121.71583333"
                    },
                    {
                        "id": 145335,
                        "name": "Ugad",
                        "latitude": "17.30750000",
                        "longitude": "121.80027778"
                    },
                    {
                        "id": 145337,
                        "name": "Uyugan",
                        "latitude": "20.35000000",
                        "longitude": "121.93333333"
                    },
                    {
                        "id": 145339,
                        "name": "Yeban Norte",
                        "latitude": "17.02194444",
                        "longitude": "121.94194444"
                    }
                ]
            },
            {
                "id": 1326,
                "name": "Agusan del Sur",
                "iso2": "AGS",
                "latitude": "8.04638880",
                "longitude": "126.06153840",
                "type": "province",
                "cities": [
                    {
                        "id": 145340,
                        "name": "Acli",
                        "latitude": "15.12277778",
                        "longitude": "120.64472222"
                    },
                    {
                        "id": 145341,
                        "name": "Agbannawag",
                        "latitude": "15.67916667",
                        "longitude": "121.08333333"
                    },
                    {
                        "id": 145342,
                        "name": "Akle",
                        "latitude": "15.04833333",
                        "longitude": "121.07333333"
                    },
                    {
                        "id": 145344,
                        "name": "Alua",
                        "latitude": "15.31166667",
                        "longitude": "120.89444444"
                    },
                    {
                        "id": 145345,
                        "name": "Amacalan",
                        "latitude": "15.58138889",
                        "longitude": "120.61111111"
                    },
                    {
                        "id": 145346,
                        "name": "Amucao",
                        "latitude": "15.46416667",
                        "longitude": "120.68638889"
                    },
                    {
                        "id": 145347,
                        "name": "Amuñgan",
                        "latitude": "15.36527778",
                        "longitude": "119.95833333"
                    },
                    {
                        "id": 145350,
                        "name": "Angat",
                        "latitude": "14.92814722",
                        "longitude": "121.02931944"
                    },
                    {
                        "id": 145351,
                        "name": "Angeles",
                        "latitude": "15.14718056",
                        "longitude": "120.58473333"
                    },
                    {
                        "id": 145355,
                        "name": "Arenas",
                        "latitude": "15.17055556",
                        "longitude": "120.68583333"
                    },
                    {
                        "id": 145356,
                        "name": "Arminia",
                        "latitude": "15.43555556",
                        "longitude": "120.56388889"
                    },
                    {
                        "id": 145357,
                        "name": "Bacabac",
                        "latitude": "15.72472222",
                        "longitude": "120.42805556"
                    },
                    {
                        "id": 145359,
                        "name": "Bacsay",
                        "latitude": "15.62055556",
                        "longitude": "120.34333333"
                    },
                    {
                        "id": 145360,
                        "name": "Bagac",
                        "latitude": "14.58333000",
                        "longitude": "120.41667000"
                    },
                    {
                        "id": 145361,
                        "name": "Bagong Barrio",
                        "latitude": "14.89000000",
                        "longitude": "120.94083333"
                    },
                    {
                        "id": 145362,
                        "name": "Bagong-Sikat",
                        "latitude": "15.48000000",
                        "longitude": "121.30722222"
                    },
                    {
                        "id": 145363,
                        "name": "Bahay Pare",
                        "latitude": "15.03250000",
                        "longitude": "120.88083333"
                    },
                    {
                        "id": 145364,
                        "name": "Bakulong",
                        "latitude": "15.53777778",
                        "longitude": "120.63861111"
                    },
                    {
                        "id": 145365,
                        "name": "Balagtas",
                        "latitude": "14.81446700",
                        "longitude": "120.90846700"
                    },
                    {
                        "id": 145366,
                        "name": "Balanga",
                        "latitude": "14.68333333",
                        "longitude": "120.53333333"
                    },
                    {
                        "id": 145367,
                        "name": "Balaoang",
                        "latitude": "15.66333333",
                        "longitude": "120.51472222"
                    },
                    {
                        "id": 145368,
                        "name": "Balas",
                        "latitude": "15.05000000",
                        "longitude": "120.58611111"
                    },
                    {
                        "id": 145369,
                        "name": "Balasing",
                        "latitude": "14.85444444",
                        "longitude": "121.01277778"
                    },
                    {
                        "id": 145370,
                        "name": "Balayang",
                        "latitude": "15.54944444",
                        "longitude": "120.69416667"
                    },
                    {
                        "id": 145372,
                        "name": "Balingcanaway",
                        "latitude": "15.48222222",
                        "longitude": "120.68555556"
                    },
                    {
                        "id": 145373,
                        "name": "Balite",
                        "latitude": "15.64444444",
                        "longitude": "120.64194444"
                    },
                    {
                        "id": 145375,
                        "name": "Baliuag",
                        "latitude": "14.95000000",
                        "longitude": "120.90000000"
                    },
                    {
                        "id": 145376,
                        "name": "Baloc",
                        "latitude": "15.64361111",
                        "longitude": "120.88527778"
                    },
                    {
                        "id": 145377,
                        "name": "Baloy",
                        "latitude": "15.80527778",
                        "longitude": "120.77416667"
                    },
                    {
                        "id": 145378,
                        "name": "Balsic",
                        "latitude": "14.85916667",
                        "longitude": "120.48250000"
                    },
                    {
                        "id": 145379,
                        "name": "Balucuc",
                        "latitude": "14.95277778",
                        "longitude": "120.81444444"
                    },
                    {
                        "id": 145380,
                        "name": "Balut",
                        "latitude": "14.68333333",
                        "longitude": "120.55000000"
                    },
                    {
                        "id": 145381,
                        "name": "Balutu",
                        "latitude": "15.29861111",
                        "longitude": "120.69222222"
                    },
                    {
                        "id": 145384,
                        "name": "Banawang",
                        "latitude": "14.61222222",
                        "longitude": "120.39000000"
                    },
                    {
                        "id": 145386,
                        "name": "Baquero Norte",
                        "latitude": "15.71611111",
                        "longitude": "120.55416667"
                    },
                    {
                        "id": 145387,
                        "name": "Batasan Bata",
                        "latitude": "15.14444444",
                        "longitude": "120.94083333"
                    },
                    {
                        "id": 145388,
                        "name": "Batitang",
                        "latitude": "15.40027778",
                        "longitude": "120.80277778"
                    },
                    {
                        "id": 145389,
                        "name": "Bayanan",
                        "latitude": "13.35916667",
                        "longitude": "121.17000000"
                    },
                    {
                        "id": 145390,
                        "name": "Beddeng",
                        "latitude": "14.97722222",
                        "longitude": "120.08500000"
                    },
                    {
                        "id": 145391,
                        "name": "Biay",
                        "latitude": "15.74027778",
                        "longitude": "119.90666667"
                    },
                    {
                        "id": 145392,
                        "name": "Bibiclat",
                        "latitude": "15.52194444",
                        "longitude": "120.86222222"
                    },
                    {
                        "id": 145393,
                        "name": "Bicos",
                        "latitude": "15.66027778",
                        "longitude": "121.04138889"
                    },
                    {
                        "id": 145394,
                        "name": "Biga",
                        "latitude": "13.31055556",
                        "longitude": "121.16111111"
                    },
                    {
                        "id": 145395,
                        "name": "Bilad",
                        "latitude": "15.73666667",
                        "longitude": "120.43333333"
                    },
                    {
                        "id": 145396,
                        "name": "Bobon Second",
                        "latitude": "15.65666667",
                        "longitude": "120.38111111"
                    },
                    {
                        "id": 145397,
                        "name": "Bocaue",
                        "latitude": "14.80000000",
                        "longitude": "120.93333333"
                    },
                    {
                        "id": 145398,
                        "name": "Bodega",
                        "latitude": "14.92277778",
                        "longitude": "120.47972222"
                    },
                    {
                        "id": 145399,
                        "name": "Bolitoc",
                        "latitude": "15.73944444",
                        "longitude": "119.87694444"
                    },
                    {
                        "id": 145402,
                        "name": "Buenlag",
                        "latitude": "15.62750000",
                        "longitude": "120.58194444"
                    },
                    {
                        "id": 145403,
                        "name": "Buensuseso",
                        "latitude": "15.19333333",
                        "longitude": "120.67305556"
                    },
                    {
                        "id": 145404,
                        "name": "Bulakan",
                        "latitude": "14.79278000",
                        "longitude": "120.87889000"
                    },
                    {
                        "id": 145405,
                        "name": "Bulaon",
                        "latitude": "15.08250000",
                        "longitude": "120.66277778"
                    },
                    {
                        "id": 145406,
                        "name": "Bularit",
                        "latitude": "15.56833333",
                        "longitude": "120.62166667"
                    },
                    {
                        "id": 145407,
                        "name": "Bulawin",
                        "latitude": "15.41722222",
                        "longitude": "119.95638889"
                    },
                    {
                        "id": 145408,
                        "name": "Bulihan",
                        "latitude": "14.87583333",
                        "longitude": "120.89555556"
                    },
                    {
                        "id": 145409,
                        "name": "Buliran",
                        "latitude": "15.54611111",
                        "longitude": "120.95972222"
                    },
                    {
                        "id": 145410,
                        "name": "Buliran Segundo",
                        "latitude": "15.26666667",
                        "longitude": "120.86666667"
                    },
                    {
                        "id": 145411,
                        "name": "Bulualto",
                        "latitude": "15.22138889",
                        "longitude": "120.95333333"
                    },
                    {
                        "id": 145412,
                        "name": "Bundoc",
                        "latitude": "15.48583333",
                        "longitude": "120.71750000"
                    },
                    {
                        "id": 145413,
                        "name": "Bunol",
                        "latitude": "15.66722222",
                        "longitude": "120.83444444"
                    },
                    {
                        "id": 145417,
                        "name": "Bustos",
                        "latitude": "14.95806000",
                        "longitude": "120.91778000"
                    },
                    {
                        "id": 145420,
                        "name": "Cabayaoasan",
                        "latitude": "15.66333333",
                        "longitude": "120.55138889"
                    },
                    {
                        "id": 145421,
                        "name": "Cabcaben",
                        "latitude": "14.45388889",
                        "longitude": "120.59138889"
                    },
                    {
                        "id": 145423,
                        "name": "Cabog",
                        "latitude": "15.31527778",
                        "longitude": "121.37027778"
                    },
                    {
                        "id": 145424,
                        "name": "Cafe",
                        "latitude": "15.33694444",
                        "longitude": "120.70611111"
                    },
                    {
                        "id": 145425,
                        "name": "Calaba",
                        "latitude": "15.30055556",
                        "longitude": "120.87416667"
                    },
                    {
                        "id": 145426,
                        "name": "Calancuasan Norte",
                        "latitude": "15.80138889",
                        "longitude": "120.64111111"
                    },
                    {
                        "id": 145427,
                        "name": "Calangain",
                        "latitude": "14.89805556",
                        "longitude": "120.55888889"
                    },
                    {
                        "id": 145428,
                        "name": "Calantas",
                        "latitude": "15.01944444",
                        "longitude": "120.51805556"
                    },
                    {
                        "id": 145429,
                        "name": "Calayaan",
                        "latitude": "15.56750000",
                        "longitude": "120.51444444"
                    },
                    {
                        "id": 145430,
                        "name": "Calibungan",
                        "latitude": "15.59833333",
                        "longitude": "120.72388889"
                    },
                    {
                        "id": 145431,
                        "name": "Calibutbut",
                        "latitude": "15.11500000",
                        "longitude": "120.59805556"
                    },
                    {
                        "id": 145432,
                        "name": "Calingcuan",
                        "latitude": "15.33333333",
                        "longitude": "120.58333333"
                    },
                    {
                        "id": 145433,
                        "name": "Calumpang",
                        "latitude": "15.17388889",
                        "longitude": "121.02500000"
                    },
                    {
                        "id": 145434,
                        "name": "Calumpit",
                        "latitude": "14.91666667",
                        "longitude": "120.76666667"
                    },
                    {
                        "id": 145435,
                        "name": "Cama Juan",
                        "latitude": "15.39222222",
                        "longitude": "120.76861111"
                    },
                    {
                        "id": 145436,
                        "name": "Camachile",
                        "latitude": "14.64361111",
                        "longitude": "120.58083333"
                    },
                    {
                        "id": 145437,
                        "name": "Camias",
                        "latitude": "15.16666667",
                        "longitude": "120.97416667"
                    },
                    {
                        "id": 145440,
                        "name": "Candating",
                        "latitude": "15.15055556",
                        "longitude": "120.81861111"
                    },
                    {
                        "id": 145444,
                        "name": "Carmen",
                        "latitude": "15.44694444",
                        "longitude": "120.82666667"
                    },
                    {
                        "id": 145449,
                        "name": "Cavite",
                        "latitude": "15.67777778",
                        "longitude": "120.76972222"
                    },
                    {
                        "id": 145450,
                        "name": "Cawayan Bugtong",
                        "latitude": "15.63361111",
                        "longitude": "120.77694444"
                    },
                    {
                        "id": 145451,
                        "name": "City of Balanga",
                        "latitude": "14.66695000",
                        "longitude": "120.49430000"
                    },
                    {
                        "id": 145452,
                        "name": "City of Gapan",
                        "latitude": "15.28333000",
                        "longitude": "120.98333000"
                    },
                    {
                        "id": 145453,
                        "name": "City of Malolos",
                        "latitude": "14.82978000",
                        "longitude": "120.83713000"
                    },
                    {
                        "id": 145454,
                        "name": "City of Meycauayan",
                        "latitude": "14.75238000",
                        "longitude": "120.96794000"
                    },
                    {
                        "id": 145455,
                        "name": "City of San Fernando",
                        "latitude": "15.04574000",
                        "longitude": "120.70373000"
                    },
                    {
                        "id": 145456,
                        "name": "City of San Jose del Monte",
                        "latitude": "14.81667000",
                        "longitude": "121.11667000"
                    },
                    {
                        "id": 145457,
                        "name": "Comillas",
                        "latitude": "15.39833333",
                        "longitude": "120.70055556"
                    },
                    {
                        "id": 145458,
                        "name": "Communal",
                        "latitude": "13.25472222",
                        "longitude": "121.13666667"
                    },
                    {
                        "id": 145459,
                        "name": "Concepcion",
                        "latitude": "14.80000000",
                        "longitude": "120.93333333"
                    },
                    {
                        "id": 145462,
                        "name": "Conversion",
                        "latitude": "15.89833333",
                        "longitude": "121.12777778"
                    },
                    {
                        "id": 145463,
                        "name": "Culianin",
                        "latitude": "14.91500000",
                        "longitude": "120.89861111"
                    },
                    {
                        "id": 145464,
                        "name": "Culubasa",
                        "latitude": "15.14444444",
                        "longitude": "120.65222222"
                    },
                    {
                        "id": 145465,
                        "name": "Cut-cut Primero",
                        "latitude": "15.48277778",
                        "longitude": "120.58611111"
                    },
                    {
                        "id": 145467,
                        "name": "Dampol",
                        "latitude": "14.90138889",
                        "longitude": "120.82194444"
                    },
                    {
                        "id": 145469,
                        "name": "Del Pilar",
                        "latitude": "15.03611111",
                        "longitude": "120.69944444"
                    },
                    {
                        "id": 145471,
                        "name": "Digdig",
                        "latitude": "15.94888889",
                        "longitude": "120.97777778"
                    },
                    {
                        "id": 145473,
                        "name": "Diliman Primero",
                        "latitude": "15.02472222",
                        "longitude": "120.95194444"
                    },
                    {
                        "id": 145474,
                        "name": "Dinalongan",
                        "latitude": "16.18333000",
                        "longitude": "121.88333000"
                    },
                    {
                        "id": 145475,
                        "name": "Dinalupihan",
                        "latitude": "14.88333333",
                        "longitude": "120.46666667"
                    },
                    {
                        "id": 145479,
                        "name": "Doña Remedios Trinidad",
                        "latitude": "15.00000000",
                        "longitude": "121.08333333"
                    },
                    {
                        "id": 145480,
                        "name": "Entablado",
                        "latitude": "15.28666667",
                        "longitude": "120.86305556"
                    },
                    {
                        "id": 145481,
                        "name": "Estipona",
                        "latitude": "15.59027778",
                        "longitude": "120.63777778"
                    },
                    {
                        "id": 145482,
                        "name": "Estrella",
                        "latitude": "15.75000000",
                        "longitude": "121.03333333"
                    },
                    {
                        "id": 145491,
                        "name": "Gueset",
                        "latitude": "15.95000000",
                        "longitude": "120.63333333"
                    },
                    {
                        "id": 145492,
                        "name": "Guiguinto",
                        "latitude": "14.83333333",
                        "longitude": "120.88333333"
                    },
                    {
                        "id": 145494,
                        "name": "Guisguis",
                        "latitude": "15.79277778",
                        "longitude": "119.97666667"
                    },
                    {
                        "id": 145495,
                        "name": "Guyong",
                        "latitude": "14.83611111",
                        "longitude": "120.97833333"
                    },
                    {
                        "id": 145497,
                        "name": "Hermosa",
                        "latitude": "14.83333333",
                        "longitude": "120.50000000"
                    },
                    {
                        "id": 145501,
                        "name": "La Paz",
                        "latitude": "15.44305556",
                        "longitude": "120.72888889"
                    },
                    {
                        "id": 145502,
                        "name": "Lambakin",
                        "latitude": "14.75000000",
                        "longitude": "120.86666667"
                    },
                    {
                        "id": 145504,
                        "name": "Lanat",
                        "latitude": "15.79194444",
                        "longitude": "120.60472222"
                    },
                    {
                        "id": 145505,
                        "name": "Laug",
                        "latitude": "15.04666667",
                        "longitude": "120.75138889"
                    },
                    {
                        "id": 145507,
                        "name": "Lawang Kupang",
                        "latitude": "15.34805556",
                        "longitude": "120.85750000"
                    },
                    {
                        "id": 145508,
                        "name": "Lennec",
                        "latitude": "15.68361111",
                        "longitude": "120.73388889"
                    },
                    {
                        "id": 145510,
                        "name": "Ligaya",
                        "latitude": "15.50916667",
                        "longitude": "121.28722222"
                    },
                    {
                        "id": 145511,
                        "name": "Limay",
                        "latitude": "14.56194000",
                        "longitude": "120.59833000"
                    },
                    {
                        "id": 145512,
                        "name": "Liozon",
                        "latitude": "15.39916667",
                        "longitude": "119.93305556"
                    },
                    {
                        "id": 145513,
                        "name": "Lipay",
                        "latitude": "15.45611111",
                        "longitude": "119.92083333"
                    },
                    {
                        "id": 145515,
                        "name": "Lomboy",
                        "latitude": "15.49250000",
                        "longitude": "120.71722222"
                    },
                    {
                        "id": 145516,
                        "name": "Lourdes",
                        "latitude": "14.96666667",
                        "longitude": "120.68333333"
                    },
                    {
                        "id": 145519,
                        "name": "Lucapon",
                        "latitude": "15.69972222",
                        "longitude": "119.93194444"
                    },
                    {
                        "id": 145523,
                        "name": "Mabayo",
                        "latitude": "14.73166667",
                        "longitude": "120.27805556"
                    },
                    {
                        "id": 145524,
                        "name": "Mabilang",
                        "latitude": "15.67500000",
                        "longitude": "120.48833333"
                    },
                    {
                        "id": 145525,
                        "name": "Mabilog",
                        "latitude": "15.39472222",
                        "longitude": "120.66583333"
                    },
                    {
                        "id": 145528,
                        "name": "Macapsing",
                        "latitude": "15.67833333",
                        "longitude": "121.13194444"
                    },
                    {
                        "id": 145529,
                        "name": "Macarse",
                        "latitude": "15.42500000",
                        "longitude": "120.77472222"
                    },
                    {
                        "id": 145530,
                        "name": "Macatbong",
                        "latitude": "15.50472222",
                        "longitude": "121.07916667"
                    },
                    {
                        "id": 145532,
                        "name": "Magliman",
                        "latitude": "15.03555556",
                        "longitude": "120.66416667"
                    },
                    {
                        "id": 145533,
                        "name": "Magtangol",
                        "latitude": "15.75805556",
                        "longitude": "120.91555556"
                    },
                    {
                        "id": 145534,
                        "name": "Maguinao",
                        "latitude": "15.02222222",
                        "longitude": "120.93416667"
                    },
                    {
                        "id": 145535,
                        "name": "Malabon",
                        "latitude": "15.63611111",
                        "longitude": "119.93777778"
                    },
                    {
                        "id": 145536,
                        "name": "Malacampa",
                        "latitude": "15.64333333",
                        "longitude": "120.41111111"
                    },
                    {
                        "id": 145537,
                        "name": "Maligaya",
                        "latitude": "15.67472222",
                        "longitude": "120.88861111"
                    },
                    {
                        "id": 145538,
                        "name": "Malino",
                        "latitude": "15.12694444",
                        "longitude": "120.67444444"
                    },
                    {
                        "id": 145539,
                        "name": "Malolos",
                        "latitude": "14.84333333",
                        "longitude": "120.81138889"
                    },
                    {
                        "id": 145540,
                        "name": "Maloma",
                        "latitude": "15.11361111",
                        "longitude": "120.06388889"
                    },
                    {
                        "id": 145541,
                        "name": "Maluid",
                        "latitude": "15.54916667",
                        "longitude": "120.65277778"
                    },
                    {
                        "id": 145542,
                        "name": "Malusac",
                        "latitude": "14.85833333",
                        "longitude": "120.62111111"
                    },
                    {
                        "id": 145543,
                        "name": "Mambog",
                        "latitude": "15.31361111",
                        "longitude": "120.03027778"
                    },
                    {
                        "id": 145544,
                        "name": "Mamonit",
                        "latitude": "15.58722222",
                        "longitude": "120.39638889"
                    },
                    {
                        "id": 145545,
                        "name": "Manacsac",
                        "latitude": "15.59527778",
                        "longitude": "120.79111111"
                    },
                    {
                        "id": 145546,
                        "name": "Manatal",
                        "latitude": "14.87694444",
                        "longitude": "120.91638889"
                    },
                    {
                        "id": 145547,
                        "name": "Mandili",
                        "latitude": "15.17916667",
                        "longitude": "120.87722222"
                    },
                    {
                        "id": 145548,
                        "name": "Mangga",
                        "latitude": "15.25027778",
                        "longitude": "120.90888889"
                    },
                    {
                        "id": 145549,
                        "name": "Manibaug Pasig",
                        "latitude": "15.09611111",
                        "longitude": "120.56444444"
                    },
                    {
                        "id": 145550,
                        "name": "Manogpi",
                        "latitude": "13.31083333",
                        "longitude": "121.20388889"
                    },
                    {
                        "id": 145551,
                        "name": "Mapalacsiao",
                        "latitude": "15.42833333",
                        "longitude": "120.65250000"
                    },
                    {
                        "id": 145552,
                        "name": "Mapalad",
                        "latitude": "15.45138889",
                        "longitude": "121.08388889"
                    },
                    {
                        "id": 145553,
                        "name": "Mapaniqui",
                        "latitude": "15.10694444",
                        "longitude": "120.92277778"
                    },
                    {
                        "id": 145554,
                        "name": "Maquiapo",
                        "latitude": "14.98555556",
                        "longitude": "120.55861111"
                    },
                    {
                        "id": 145555,
                        "name": "Marawa",
                        "latitude": "15.41722222",
                        "longitude": "120.83805556"
                    },
                    {
                        "id": 145557,
                        "name": "Marilao",
                        "latitude": "14.75805556",
                        "longitude": "120.94805556"
                    },
                    {
                        "id": 145558,
                        "name": "Mariveles",
                        "latitude": "14.43333333",
                        "longitude": "120.48333333"
                    },
                    {
                        "id": 145559,
                        "name": "Masalipit",
                        "latitude": "15.14805556",
                        "longitude": "121.03722222"
                    },
                    {
                        "id": 145562,
                        "name": "Matayumtayum",
                        "latitude": "15.51666667",
                        "longitude": "120.70972222"
                    },
                    {
                        "id": 145563,
                        "name": "Maturanoc",
                        "latitude": "15.65722222",
                        "longitude": "120.79222222"
                    },
                    {
                        "id": 145566,
                        "name": "Meycauayan",
                        "latitude": "14.73333333",
                        "longitude": "120.95000000"
                    },
                    {
                        "id": 145569,
                        "name": "Moriones",
                        "latitude": "15.46111111",
                        "longitude": "120.46583333"
                    },
                    {
                        "id": 145571,
                        "name": "Motrico",
                        "latitude": "15.41361111",
                        "longitude": "120.67666667"
                    },
                    {
                        "id": 145574,
                        "name": "Nagpandayan",
                        "latitude": "15.60138889",
                        "longitude": "120.76888889"
                    },
                    {
                        "id": 145575,
                        "name": "Nambalan",
                        "latitude": "15.59916667",
                        "longitude": "120.46027778"
                    },
                    {
                        "id": 145578,
                        "name": "Nancamarinan",
                        "latitude": "15.67527778",
                        "longitude": "120.53638889"
                    },
                    {
                        "id": 145579,
                        "name": "Nieves",
                        "latitude": "15.32833333",
                        "longitude": "120.94888889"
                    },
                    {
                        "id": 145580,
                        "name": "Niugan",
                        "latitude": "14.94611111",
                        "longitude": "120.96722222"
                    },
                    {
                        "id": 145581,
                        "name": "Norzagaray",
                        "latitude": "14.91083333",
                        "longitude": "121.04916667"
                    },
                    {
                        "id": 145582,
                        "name": "Obando",
                        "latitude": "14.70000000",
                        "longitude": "120.91666667"
                    },
                    {
                        "id": 145584,
                        "name": "Orani",
                        "latitude": "14.80000000",
                        "longitude": "120.53333333"
                    },
                    {
                        "id": 145585,
                        "name": "Orion",
                        "latitude": "14.62056000",
                        "longitude": "120.58167000"
                    },
                    {
                        "id": 145586,
                        "name": "Paco Roman",
                        "latitude": "15.65972222",
                        "longitude": "121.08777778"
                    },
                    {
                        "id": 145587,
                        "name": "Padapada",
                        "latitude": "15.55166667",
                        "longitude": "120.51638889"
                    },
                    {
                        "id": 145588,
                        "name": "Paitan Norte",
                        "latitude": "15.83333333",
                        "longitude": "120.74083333"
                    },
                    {
                        "id": 145591,
                        "name": "Palusapis",
                        "latitude": "15.68333333",
                        "longitude": "120.86277778"
                    },
                    {
                        "id": 145592,
                        "name": "Pamatawan",
                        "latitude": "14.92777778",
                        "longitude": "120.21361111"
                    },
                    {
                        "id": 145593,
                        "name": "Panabingan",
                        "latitude": "15.37722222",
                        "longitude": "120.76500000"
                    },
                    {
                        "id": 145594,
                        "name": "Panan",
                        "latitude": "15.21333333",
                        "longitude": "120.02722222"
                    },
                    {
                        "id": 145595,
                        "name": "Pance",
                        "latitude": "15.68861111",
                        "longitude": "120.62000000"
                    },
                    {
                        "id": 145596,
                        "name": "Pandacaqui",
                        "latitude": "15.17194444",
                        "longitude": "120.65444444"
                    },
                    {
                        "id": 145597,
                        "name": "Pandi",
                        "latitude": "14.86666667",
                        "longitude": "120.95000000"
                    },
                    {
                        "id": 145598,
                        "name": "Pando",
                        "latitude": "15.39388889",
                        "longitude": "120.68472222"
                    },
                    {
                        "id": 145601,
                        "name": "Pantubig",
                        "latitude": "14.96805556",
                        "longitude": "120.95472222"
                    },
                    {
                        "id": 145602,
                        "name": "Paombong",
                        "latitude": "14.83111100",
                        "longitude": "120.78916700"
                    },
                    {
                        "id": 145603,
                        "name": "Papaya",
                        "latitude": "15.32027778",
                        "longitude": "120.83583333"
                    },
                    {
                        "id": 145605,
                        "name": "Parista",
                        "latitude": "15.85361111",
                        "longitude": "120.92833333"
                    },
                    {
                        "id": 145606,
                        "name": "Pau",
                        "latitude": "15.02777778",
                        "longitude": "120.72416667"
                    },
                    {
                        "id": 145608,
                        "name": "Pias",
                        "latitude": "15.34527778",
                        "longitude": "121.07472222"
                    },
                    {
                        "id": 145613,
                        "name": "Piñahan",
                        "latitude": "15.62666667",
                        "longitude": "121.06222222"
                    },
                    {
                        "id": 145611,
                        "name": "Pinambaran",
                        "latitude": "15.20222222",
                        "longitude": "120.97805556"
                    },
                    {
                        "id": 145612,
                        "name": "Pio",
                        "latitude": "15.04750000",
                        "longitude": "120.51888889"
                    },
                    {
                        "id": 145617,
                        "name": "Porais",
                        "latitude": "15.75500000",
                        "longitude": "121.04277778"
                    },
                    {
                        "id": 145618,
                        "name": "Prado Siongco",
                        "latitude": "14.87888889",
                        "longitude": "120.51305556"
                    },
                    {
                        "id": 145619,
                        "name": "Pulilan",
                        "latitude": "14.90000000",
                        "longitude": "120.85000000"
                    },
                    {
                        "id": 145620,
                        "name": "Pulo",
                        "latitude": "14.96222222",
                        "longitude": "121.01472222"
                    },
                    {
                        "id": 145621,
                        "name": "Pulong Gubat",
                        "latitude": "14.85944444",
                        "longitude": "120.90611111"
                    },
                    {
                        "id": 145622,
                        "name": "Pulong Sampalok",
                        "latitude": "14.96111111",
                        "longitude": "121.06083333"
                    },
                    {
                        "id": 145623,
                        "name": "Pulung Santol",
                        "latitude": "15.04583333",
                        "longitude": "120.56194444"
                    },
                    {
                        "id": 145624,
                        "name": "Pulungmasle",
                        "latitude": "15.00027778",
                        "longitude": "120.55777778"
                    },
                    {
                        "id": 145625,
                        "name": "Puncan",
                        "latitude": "15.90722222",
                        "longitude": "120.99083333"
                    },
                    {
                        "id": 145627,
                        "name": "Purac",
                        "latitude": "15.25194444",
                        "longitude": "120.01694444"
                    },
                    {
                        "id": 145628,
                        "name": "Putlod",
                        "latitude": "15.37055556",
                        "longitude": "120.86750000"
                    },
                    {
                        "id": 145630,
                        "name": "Rajal Norte",
                        "latitude": "15.44472222",
                        "longitude": "120.86250000"
                    },
                    {
                        "id": 145632,
                        "name": "Rizal",
                        "latitude": "15.68333333",
                        "longitude": "121.16666667"
                    },
                    {
                        "id": 145633,
                        "name": "Sabang",
                        "latitude": "14.69500000",
                        "longitude": "120.25083333"
                    },
                    {
                        "id": 145634,
                        "name": "Sagana",
                        "latitude": "15.56888889",
                        "longitude": "121.15222222"
                    },
                    {
                        "id": 145635,
                        "name": "Salapungan",
                        "latitude": "15.13388889",
                        "longitude": "120.92805556"
                    },
                    {
                        "id": 145636,
                        "name": "Salaza",
                        "latitude": "15.45416667",
                        "longitude": "119.95527778"
                    },
                    {
                        "id": 145638,
                        "name": "Salvacion I",
                        "latitude": "15.83972222",
                        "longitude": "120.91583333"
                    },
                    {
                        "id": 145641,
                        "name": "San Agustin",
                        "latitude": "14.93333333",
                        "longitude": "120.15000000"
                    },
                    {
                        "id": 145643,
                        "name": "San Alejandro",
                        "latitude": "15.56111111",
                        "longitude": "120.84888889"
                    },
                    {
                        "id": 145644,
                        "name": "San Andres",
                        "latitude": "15.71916667",
                        "longitude": "120.77750000"
                    },
                    {
                        "id": 145645,
                        "name": "San Anton",
                        "latitude": "15.34777778",
                        "longitude": "120.92000000"
                    },
                    {
                        "id": 145651,
                        "name": "San Basilio",
                        "latitude": "15.03333333",
                        "longitude": "120.58416667"
                    },
                    {
                        "id": 145655,
                        "name": "San Casimiro",
                        "latitude": "15.55305556",
                        "longitude": "120.78083333"
                    },
                    {
                        "id": 145657,
                        "name": "San Cristobal",
                        "latitude": "15.55388889",
                        "longitude": "120.76694444"
                    },
                    {
                        "id": 145661,
                        "name": "San Felipe Old",
                        "latitude": "15.50138889",
                        "longitude": "120.90777778"
                    },
                    {
                        "id": 145663,
                        "name": "San Francisco",
                        "latitude": "15.35555556",
                        "longitude": "120.84000000"
                    },
                    {
                        "id": 145667,
                        "name": "San Isidro",
                        "latitude": "15.26666667",
                        "longitude": "120.90000000"
                    },
                    {
                        "id": 145674,
                        "name": "San Jose del Monte",
                        "latitude": "14.81388889",
                        "longitude": "121.04527778"
                    },
                    {
                        "id": 145677,
                        "name": "San Juan de Mata",
                        "latitude": "15.53527778",
                        "longitude": "120.53027778"
                    },
                    {
                        "id": 145679,
                        "name": "San Lorenzo",
                        "latitude": "15.48611111",
                        "longitude": "119.96222222"
                    },
                    {
                        "id": 145680,
                        "name": "San Luis",
                        "latitude": "15.04000000",
                        "longitude": "120.79194444"
                    },
                    {
                        "id": 145685,
                        "name": "San Mariano",
                        "latitude": "15.32083333",
                        "longitude": "120.87611111"
                    },
                    {
                        "id": 145690,
                        "name": "San Nicolas",
                        "latitude": "15.58416667",
                        "longitude": "120.67638889"
                    },
                    {
                        "id": 145694,
                        "name": "San Patricio",
                        "latitude": "15.09777778",
                        "longitude": "120.72888889"
                    },
                    {
                        "id": 145695,
                        "name": "San Rafael",
                        "latitude": "14.95000000",
                        "longitude": "120.96666667"
                    },
                    {
                        "id": 145699,
                        "name": "San Roque",
                        "latitude": "15.00944444",
                        "longitude": "120.93833333"
                    },
                    {
                        "id": 145701,
                        "name": "San Roque Dau First",
                        "latitude": "14.97722222",
                        "longitude": "120.57694444"
                    },
                    {
                        "id": 145703,
                        "name": "San Vicente",
                        "latitude": "15.29222222",
                        "longitude": "120.65500000"
                    },
                    {
                        "id": 145706,
                        "name": "San Vincente",
                        "latitude": "13.40666667",
                        "longitude": "121.17500000"
                    },
                    {
                        "id": 145707,
                        "name": "Santa Ana",
                        "latitude": "15.09388889",
                        "longitude": "120.76805556"
                    },
                    {
                        "id": 145709,
                        "name": "Santa Cruz",
                        "latitude": "15.76527778",
                        "longitude": "119.90916667"
                    },
                    {
                        "id": 145712,
                        "name": "Santa Fe",
                        "latitude": "15.01027778",
                        "longitude": "120.21027778"
                    },
                    {
                        "id": 145714,
                        "name": "Santa Ines West",
                        "latitude": "15.55694444",
                        "longitude": "120.46444444"
                    },
                    {
                        "id": 145715,
                        "name": "Santa Juliana",
                        "latitude": "15.32833333",
                        "longitude": "120.42861111"
                    },
                    {
                        "id": 145719,
                        "name": "Santa Maria",
                        "latitude": "14.81833333",
                        "longitude": "120.95633333"
                    },
                    {
                        "id": 145723,
                        "name": "Santa Monica",
                        "latitude": "15.35777778",
                        "longitude": "120.72000000"
                    },
                    {
                        "id": 145724,
                        "name": "Santa Rita",
                        "latitude": "14.99527800",
                        "longitude": "120.61527800"
                    },
                    {
                        "id": 145728,
                        "name": "Santa Teresa First",
                        "latitude": "14.92638889",
                        "longitude": "120.55777778"
                    },
                    {
                        "id": 145729,
                        "name": "Santiago",
                        "latitude": "14.90361111",
                        "longitude": "120.51138889"
                    },
                    {
                        "id": 145730,
                        "name": "Santo Cristo",
                        "latitude": "15.29694444",
                        "longitude": "120.89027778"
                    },
                    {
                        "id": 145736,
                        "name": "Santo Niño",
                        "latitude": "15.33444444",
                        "longitude": "120.62611111"
                    },
                    {
                        "id": 145738,
                        "name": "Santo Rosario",
                        "latitude": "15.43416667",
                        "longitude": "120.88972222"
                    },
                    {
                        "id": 145744,
                        "name": "Sapang",
                        "latitude": "15.70333333",
                        "longitude": "120.52444444"
                    },
                    {
                        "id": 145745,
                        "name": "Sapang Buho",
                        "latitude": "15.59027778",
                        "longitude": "121.12444444"
                    },
                    {
                        "id": 145746,
                        "name": "Sapol",
                        "latitude": "13.36500000",
                        "longitude": "121.18916667"
                    },
                    {
                        "id": 145749,
                        "name": "Saysain",
                        "latitude": "14.56111111",
                        "longitude": "120.39250000"
                    },
                    {
                        "id": 145750,
                        "name": "Sibul",
                        "latitude": "15.16888889",
                        "longitude": "121.06166667"
                    },
                    {
                        "id": 145752,
                        "name": "Siclong",
                        "latitude": "15.58083333",
                        "longitude": "121.22388889"
                    },
                    {
                        "id": 145754,
                        "name": "Sinilian First",
                        "latitude": "15.69333333",
                        "longitude": "120.45944444"
                    },
                    {
                        "id": 145755,
                        "name": "Soledad",
                        "latitude": "15.42833333",
                        "longitude": "120.98361111"
                    },
                    {
                        "id": 145757,
                        "name": "Suklayin",
                        "latitude": "15.75750000",
                        "longitude": "121.55027778"
                    },
                    {
                        "id": 145758,
                        "name": "Sula",
                        "latitude": "15.45722222",
                        "longitude": "120.39555556"
                    },
                    {
                        "id": 145759,
                        "name": "Sulucan",
                        "latitude": "14.79444444",
                        "longitude": "120.92583333"
                    },
                    {
                        "id": 145760,
                        "name": "Tabacao",
                        "latitude": "15.64972222",
                        "longitude": "120.94055556"
                    },
                    {
                        "id": 145761,
                        "name": "Tabon",
                        "latitude": "15.27111111",
                        "longitude": "120.91277778"
                    },
                    {
                        "id": 145762,
                        "name": "Tabuating",
                        "latitude": "15.39222222",
                        "longitude": "120.94083333"
                    },
                    {
                        "id": 145763,
                        "name": "Tal I Mun Doc",
                        "latitude": "15.21222222",
                        "longitude": "120.68500000"
                    },
                    {
                        "id": 145764,
                        "name": "Talaga",
                        "latitude": "15.38388889",
                        "longitude": "120.58944444"
                    },
                    {
                        "id": 145765,
                        "name": "Talang",
                        "latitude": "15.02500000",
                        "longitude": "120.83777778"
                    },
                    {
                        "id": 145767,
                        "name": "Taltal",
                        "latitude": "15.58777778",
                        "longitude": "119.94555556"
                    },
                    {
                        "id": 145769,
                        "name": "Tariji",
                        "latitude": "15.52111111",
                        "longitude": "120.61444444"
                    },
                    {
                        "id": 145771,
                        "name": "Tayabo",
                        "latitude": "15.83444444",
                        "longitude": "121.03083333"
                    },
                    {
                        "id": 145772,
                        "name": "Telabastagan",
                        "latitude": "15.11861111",
                        "longitude": "120.60777778"
                    },
                    {
                        "id": 145773,
                        "name": "Tikiw",
                        "latitude": "15.31194444",
                        "longitude": "120.86111111"
                    },
                    {
                        "id": 145774,
                        "name": "Tinang",
                        "latitude": "15.37638889",
                        "longitude": "120.65333333"
                    },
                    {
                        "id": 145775,
                        "name": "Tondod",
                        "latitude": "15.71833333",
                        "longitude": "120.96805556"
                    },
                    {
                        "id": 145776,
                        "name": "Uacon",
                        "latitude": "15.67861111",
                        "longitude": "119.94027778"
                    },
                    {
                        "id": 145777,
                        "name": "Umiray",
                        "latitude": "15.22055556",
                        "longitude": "121.41111111"
                    },
                    {
                        "id": 145778,
                        "name": "Upig",
                        "latitude": "15.02555556",
                        "longitude": "120.99194444"
                    },
                    {
                        "id": 145779,
                        "name": "Vargas",
                        "latitude": "15.59333333",
                        "longitude": "120.48722222"
                    },
                    {
                        "id": 145781,
                        "name": "Villa Aglipay",
                        "latitude": "15.46611111",
                        "longitude": "120.45277778"
                    },
                    {
                        "id": 145782,
                        "name": "Villa Isla",
                        "latitude": "15.77027778",
                        "longitude": "120.86666667"
                    },
                    {
                        "id": 145783,
                        "name": "Vizal San Pablo",
                        "latitude": "15.06250000",
                        "longitude": "120.90027778"
                    },
                    {
                        "id": 145784,
                        "name": "Vizal Santo Niño",
                        "latitude": "15.02916667",
                        "longitude": "120.90500000"
                    }
                ]
            },
            {
                "id": 1331,
                "name": "Aklan",
                "iso2": "AKL",
                "latitude": "11.81661090",
                "longitude": "122.09415410",
                "type": "province",
                "cities": [
                    {
                        "id": 81232,
                        "name": "Altavas",
                        "latitude": "11.51937220",
                        "longitude": "122.38395760"
                    },
                    {
                        "id": 81462,
                        "name": "Balete",
                        "latitude": "11.52259720",
                        "longitude": "122.29336200"
                    },
                    {
                        "id": 81522,
                        "name": "Banga",
                        "latitude": "11.59926330",
                        "longitude": "122.29023350"
                    },
                    {
                        "id": 81613,
                        "name": "Batan",
                        "latitude": "11.56991310",
                        "longitude": "122.31240560"
                    },
                    {
                        "id": 81914,
                        "name": "Buruanga",
                        "latitude": "11.82986870",
                        "longitude": "121.84434010"
                    },
                    {
                        "id": 82709,
                        "name": "Ibajay",
                        "latitude": "11.73394600",
                        "longitude": "122.07758510"
                    },
                    {
                        "id": 154475,
                        "name": "Kalibo",
                        "latitude": "11.69854460",
                        "longitude": "122.33619590"
                    },
                    {
                        "id": 154476,
                        "name": "Lezo",
                        "latitude": "11.68036010",
                        "longitude": "122.27302710"
                    },
                    {
                        "id": 83075,
                        "name": "Libacao",
                        "latitude": "11.41467410",
                        "longitude": "122.20092380"
                    },
                    {
                        "id": 83308,
                        "name": "Madalag",
                        "latitude": "11.44121480",
                        "longitude": "122.07375060"
                    },
                    {
                        "id": 83376,
                        "name": "Makato",
                        "latitude": "11.71366850",
                        "longitude": "122.18036730"
                    },
                    {
                        "id": 83415,
                        "name": "Malay",
                        "latitude": "11.91246850",
                        "longitude": "121.86493950"
                    },
                    {
                        "id": 83434,
                        "name": "Malinao",
                        "latitude": "11.60513720",
                        "longitude": "122.15049950"
                    },
                    {
                        "id": 83736,
                        "name": "Nabas",
                        "latitude": "11.85230360",
                        "longitude": "121.95579400"
                    },
                    {
                        "id": 83813,
                        "name": "New Washington",
                        "latitude": "11.63431580",
                        "longitude": "122.34151430"
                    },
                    {
                        "id": 83831,
                        "name": "Numancia",
                        "latitude": "11.71329610",
                        "longitude": "122.29263690"
                    },
                    {
                        "id": 85035,
                        "name": "Tangalan",
                        "latitude": "11.73931560",
                        "longitude": "122.16096950"
                    }
                ]
            },
            {
                "id": 1337,
                "name": "Albay",
                "iso2": "ALB",
                "latitude": "13.17748270",
                "longitude": "123.52800720",
                "type": "province",
                "cities": [
                    {
                        "id": 81125,
                        "name": "Aanislag",
                        "latitude": "13.07480000",
                        "longitude": "123.70300000"
                    },
                    {
                        "id": 81134,
                        "name": "Abucay",
                        "latitude": "12.98200000",
                        "longitude": "123.64920000"
                    },
                    {
                        "id": 81164,
                        "name": "Agos",
                        "latitude": "13.34340000",
                        "longitude": "123.39830000"
                    },
                    {
                        "id": 81167,
                        "name": "Aguada",
                        "latitude": "12.81667000",
                        "longitude": "123.83333000"
                    },
                    {
                        "id": 81171,
                        "name": "Agupit",
                        "latitude": "13.42250000",
                        "longitude": "123.32472000"
                    },
                    {
                        "id": 81191,
                        "name": "Alayao",
                        "latitude": "14.28180000",
                        "longitude": "122.55240000"
                    },
                    {
                        "id": 81287,
                        "name": "Anuling",
                        "latitude": "13.20930000",
                        "longitude": "123.67610000"
                    },
                    {
                        "id": 81290,
                        "name": "Apad",
                        "latitude": "13.81500000",
                        "longitude": "122.76640000"
                    },
                    {
                        "id": 81299,
                        "name": "Apud",
                        "latitude": "13.13928000",
                        "longitude": "123.29164000"
                    },
                    {
                        "id": 81315,
                        "name": "Armenia",
                        "latitude": "12.25324000",
                        "longitude": "123.74361000"
                    },
                    {
                        "id": 81341,
                        "name": "Ayugan",
                        "latitude": "13.54690000",
                        "longitude": "123.32170000"
                    },
                    {
                        "id": 81352,
                        "name": "Bacacay",
                        "latitude": "13.29340000",
                        "longitude": "123.79190000"
                    },
                    {
                        "id": 81363,
                        "name": "Bacolod",
                        "latitude": "12.22854000",
                        "longitude": "123.50851000"
                    },
                    {
                        "id": 81368,
                        "name": "Bacon",
                        "latitude": "13.03778000",
                        "longitude": "124.04111000"
                    },
                    {
                        "id": 81387,
                        "name": "Bagacay",
                        "latitude": "12.98210000",
                        "longitude": "124.14150000"
                    },
                    {
                        "id": 81388,
                        "name": "Bagahanlad",
                        "latitude": "12.57970000",
                        "longitude": "123.66880000"
                    },
                    {
                        "id": 81411,
                        "name": "Bagumbayan",
                        "latitude": "13.45000000",
                        "longitude": "123.66667000"
                    },
                    {
                        "id": 81416,
                        "name": "Bahay",
                        "latitude": "13.54370000",
                        "longitude": "123.04070000"
                    },
                    {
                        "id": 81432,
                        "name": "Balading",
                        "latitude": "13.39060000",
                        "longitude": "123.71210000"
                    },
                    {
                        "id": 81448,
                        "name": "Balaogan",
                        "latitude": "13.43280000",
                        "longitude": "123.28180000"
                    },
                    {
                        "id": 81468,
                        "name": "Baligang",
                        "latitude": "13.15370000",
                        "longitude": "123.64320000"
                    },
                    {
                        "id": 81473,
                        "name": "Balinad",
                        "latitude": "13.29260000",
                        "longitude": "123.54540000"
                    },
                    {
                        "id": 81486,
                        "name": "Baliuag Nuevo",
                        "latitude": "13.52140000",
                        "longitude": "123.20160000"
                    },
                    {
                        "id": 81495,
                        "name": "Balogo",
                        "latitude": "13.28710000",
                        "longitude": "123.54960000"
                    },
                    {
                        "id": 81499,
                        "name": "Balucawi",
                        "latitude": "12.20130000",
                        "longitude": "123.84260000"
                    },
                    {
                        "id": 81513,
                        "name": "Banag",
                        "latitude": "13.37889000",
                        "longitude": "123.70333000"
                    },
                    {
                        "id": 81524,
                        "name": "Bangad",
                        "latitude": "12.16125000",
                        "longitude": "123.40131000"
                    },
                    {
                        "id": 81532,
                        "name": "Bangkirohan",
                        "latitude": "13.05530000",
                        "longitude": "123.74680000"
                    },
                    {
                        "id": 81543,
                        "name": "Banocboc",
                        "latitude": "14.30000000",
                        "longitude": "122.58333000"
                    },
                    {
                        "id": 81560,
                        "name": "Bao",
                        "latitude": "13.64140000",
                        "longitude": "122.83140000"
                    },
                    {
                        "id": 81569,
                        "name": "Barayong",
                        "latitude": "13.10000000",
                        "longitude": "123.71667000"
                    },
                    {
                        "id": 81576,
                        "name": "Bariw",
                        "latitude": "13.13333000",
                        "longitude": "123.73333000"
                    },
                    {
                        "id": 81586,
                        "name": "Barra",
                        "latitude": "12.07170000",
                        "longitude": "123.63950000"
                    },
                    {
                        "id": 81597,
                        "name": "Bascaron",
                        "latitude": "13.10290000",
                        "longitude": "123.69990000"
                    },
                    {
                        "id": 81601,
                        "name": "Basiad",
                        "latitude": "14.15617000",
                        "longitude": "122.33749000"
                    },
                    {
                        "id": 81604,
                        "name": "Basicao Coastal",
                        "latitude": "13.04589000",
                        "longitude": "123.40423000"
                    },
                    {
                        "id": 81608,
                        "name": "Basud",
                        "latitude": "14.06500000",
                        "longitude": "122.96420000"
                    },
                    {
                        "id": 81614,
                        "name": "Batana",
                        "latitude": "13.24980000",
                        "longitude": "123.56410000"
                    },
                    {
                        "id": 81632,
                        "name": "Batobalane",
                        "latitude": "14.23333000",
                        "longitude": "122.75000000"
                    },
                    {
                        "id": 81672,
                        "name": "Beberon",
                        "latitude": "13.54440000",
                        "longitude": "123.14050000"
                    },
                    {
                        "id": 81694,
                        "name": "Bigaa",
                        "latitude": "13.19930000",
                        "longitude": "123.75660000"
                    },
                    {
                        "id": 81714,
                        "name": "Binanwanaan",
                        "latitude": "13.70000000",
                        "longitude": "123.30000000"
                    },
                    {
                        "id": 81721,
                        "name": "Binitayan",
                        "latitude": "13.29450000",
                        "longitude": "123.75790000"
                    },
                    {
                        "id": 81725,
                        "name": "Binodegahan",
                        "latitude": "13.06140000",
                        "longitude": "123.45790000"
                    },
                    {
                        "id": 81776,
                        "name": "Bolo",
                        "latitude": "13.75300000",
                        "longitude": "122.96580000"
                    },
                    {
                        "id": 81787,
                        "name": "Bonga",
                        "latitude": "13.27990000",
                        "longitude": "123.75870000"
                    },
                    {
                        "id": 81805,
                        "name": "Boton",
                        "latitude": "12.92870000",
                        "longitude": "124.04790000"
                    },
                    {
                        "id": 81819,
                        "name": "Buang",
                        "latitude": "13.31150000",
                        "longitude": "123.64210000"
                    },
                    {
                        "id": 81833,
                        "name": "Buenavista",
                        "latitude": "12.17639000",
                        "longitude": "123.79056000"
                    },
                    {
                        "id": 81837,
                        "name": "Buga",
                        "latitude": "13.29660000",
                        "longitude": "123.35960000"
                    },
                    {
                        "id": 81853,
                        "name": "Buhatan",
                        "latitude": "12.97550000",
                        "longitude": "124.04780000"
                    },
                    {
                        "id": 81881,
                        "name": "Bulo",
                        "latitude": "12.41090000",
                        "longitude": "123.56720000"
                    },
                    {
                        "id": 81887,
                        "name": "Buluang",
                        "latitude": "13.30680000",
                        "longitude": "123.34250000"
                    },
                    {
                        "id": 81902,
                        "name": "Burabod",
                        "latitude": "13.26860000",
                        "longitude": "123.41620000"
                    },
                    {
                        "id": 81903,
                        "name": "Buracan",
                        "latitude": "13.60000000",
                        "longitude": "123.50000000"
                    },
                    {
                        "id": 81918,
                        "name": "Busing",
                        "latitude": "13.15139000",
                        "longitude": "122.97139000"
                    },
                    {
                        "id": 81921,
                        "name": "Butag",
                        "latitude": "12.62920000",
                        "longitude": "123.93350000"
                    },
                    {
                        "id": 81930,
                        "name": "Buyo",
                        "latitude": "13.11440000",
                        "longitude": "123.86660000"
                    },
                    {
                        "id": 81963,
                        "name": "Cabcab",
                        "latitude": "13.62680000",
                        "longitude": "124.05150000"
                    },
                    {
                        "id": 81966,
                        "name": "Cabiguan",
                        "latitude": "12.90583000",
                        "longitude": "123.73139000"
                    },
                    {
                        "id": 81971,
                        "name": "Cabitan",
                        "latitude": "12.29434000",
                        "longitude": "123.34121000"
                    },
                    {
                        "id": 81975,
                        "name": "Cabognon",
                        "latitude": "13.18290000",
                        "longitude": "123.67770000"
                    },
                    {
                        "id": 81988,
                        "name": "Caditaan",
                        "latitude": "12.80528000",
                        "longitude": "123.84917000"
                    },
                    {
                        "id": 81990,
                        "name": "Cadlan",
                        "latitude": "13.59710000",
                        "longitude": "123.25700000"
                    },
                    {
                        "id": 81998,
                        "name": "Cagmanaba",
                        "latitude": "13.05501000",
                        "longitude": "123.29706000"
                    },
                    {
                        "id": 82008,
                        "name": "Calabaca",
                        "latitude": "14.30010000",
                        "longitude": "122.43364000"
                    },
                    {
                        "id": 82013,
                        "name": "Calachuchi",
                        "latitude": "12.21775000",
                        "longitude": "123.53061000"
                    },
                    {
                        "id": 82033,
                        "name": "Calasgasan",
                        "latitude": "14.08333000",
                        "longitude": "122.93333000"
                    },
                    {
                        "id": 82062,
                        "name": "Calolbon",
                        "latitude": "13.59600000",
                        "longitude": "124.09910000"
                    },
                    {
                        "id": 82079,
                        "name": "Camalig",
                        "latitude": "13.18210000",
                        "longitude": "123.65430000"
                    },
                    {
                        "id": 82120,
                        "name": "Canomoy",
                        "latitude": "12.15735000",
                        "longitude": "123.27011000"
                    },
                    {
                        "id": 82135,
                        "name": "Capalonga",
                        "latitude": "14.33060000",
                        "longitude": "122.49370000"
                    },
                    {
                        "id": 82141,
                        "name": "Capucnasan",
                        "latitude": "13.60000000",
                        "longitude": "123.21667000"
                    },
                    {
                        "id": 82145,
                        "name": "Capuy",
                        "latitude": "12.98333000",
                        "longitude": "123.93333000"
                    },
                    {
                        "id": 82153,
                        "name": "Caranan",
                        "latitude": "13.51670000",
                        "longitude": "123.01560000"
                    },
                    {
                        "id": 82156,
                        "name": "Caraycayon",
                        "latitude": "13.61667000",
                        "longitude": "123.48333000"
                    },
                    {
                        "id": 82182,
                        "name": "Carriedo",
                        "latitude": "12.93440000",
                        "longitude": "124.10500000"
                    },
                    {
                        "id": 82198,
                        "name": "Castillo",
                        "latitude": "13.73130000",
                        "longitude": "123.11660000"
                    },
                    {
                        "id": 82200,
                        "name": "Catabangan",
                        "latitude": "13.87770000",
                        "longitude": "122.66150000"
                    },
                    {
                        "id": 82223,
                        "name": "Causip",
                        "latitude": "13.51590000",
                        "longitude": "123.28340000"
                    },
                    {
                        "id": 82304,
                        "name": "Cotmon",
                        "latitude": "13.11750000",
                        "longitude": "123.66370000"
                    },
                    {
                        "id": 82310,
                        "name": "Culacling",
                        "latitude": "13.78150000",
                        "longitude": "122.87670000"
                    },
                    {
                        "id": 82319,
                        "name": "Cumadcad",
                        "latitude": "12.98056000",
                        "longitude": "123.78917000"
                    },
                    {
                        "id": 82321,
                        "name": "Curry",
                        "latitude": "13.60000000",
                        "longitude": "123.30000000"
                    },
                    {
                        "id": 82331,
                        "name": "Daet",
                        "latitude": "14.11220000",
                        "longitude": "122.95530000"
                    },
                    {
                        "id": 82336,
                        "name": "Daguit",
                        "latitude": "14.18950000",
                        "longitude": "122.72660000"
                    },
                    {
                        "id": 82354,
                        "name": "Dalupaon",
                        "latitude": "13.55170000",
                        "longitude": "122.94570000"
                    },
                    {
                        "id": 82369,
                        "name": "Dangcalan",
                        "latitude": "12.91680000",
                        "longitude": "123.58380000"
                    },
                    {
                        "id": 82378,
                        "name": "Dapdap",
                        "latitude": "12.21550000",
                        "longitude": "123.76620000"
                    },
                    {
                        "id": 82382,
                        "name": "Daraga",
                        "latitude": "13.14830000",
                        "longitude": "123.71240000"
                    },
                    {
                        "id": 82412,
                        "name": "Del Rosario",
                        "latitude": "13.30570000",
                        "longitude": "123.31330000"
                    },
                    {
                        "id": 82471,
                        "name": "Dugcal",
                        "latitude": "13.62410000",
                        "longitude": "123.16120000"
                    },
                    {
                        "id": 82472,
                        "name": "Dugongan",
                        "latitude": "14.10250000",
                        "longitude": "122.90660000"
                    },
                    {
                        "id": 82528,
                        "name": "Estancia",
                        "latitude": "13.35890000",
                        "longitude": "123.67960000"
                    },
                    {
                        "id": 82535,
                        "name": "Fabrica",
                        "latitude": "13.49000000",
                        "longitude": "123.29400000"
                    },
                    {
                        "id": 82544,
                        "name": "Gabao",
                        "latitude": "12.99240000",
                        "longitude": "124.01690000"
                    },
                    {
                        "id": 82556,
                        "name": "Gambalidio",
                        "latitude": "13.62050000",
                        "longitude": "122.89130000"
                    },
                    {
                        "id": 82572,
                        "name": "Gatbo",
                        "latitude": "13.58333000",
                        "longitude": "123.38333000"
                    },
                    {
                        "id": 82589,
                        "name": "Gibgos",
                        "latitude": "13.85900000",
                        "longitude": "123.76750000"
                    },
                    {
                        "id": 82623,
                        "name": "Guijalo",
                        "latitude": "13.73730000",
                        "longitude": "123.86800000"
                    },
                    {
                        "id": 82629,
                        "name": "Guinacotan",
                        "latitude": "14.15690000",
                        "longitude": "122.86800000"
                    },
                    {
                        "id": 82638,
                        "name": "Guinobatan",
                        "latitude": "13.19130000",
                        "longitude": "123.59870000"
                    },
                    {
                        "id": 82655,
                        "name": "Gumaus",
                        "latitude": "14.31030000",
                        "longitude": "122.72290000"
                    },
                    {
                        "id": 82658,
                        "name": "Guruyan",
                        "latitude": "12.73889000",
                        "longitude": "123.93917000"
                    },
                    {
                        "id": 82676,
                        "name": "Hamoraon",
                        "latitude": "12.22564000",
                        "longitude": "123.55151000"
                    },
                    {
                        "id": 82682,
                        "name": "Herrera",
                        "latitude": "13.26930000",
                        "longitude": "123.57690000"
                    },
                    {
                        "id": 82688,
                        "name": "Himaao",
                        "latitude": "13.54480000",
                        "longitude": "123.30050000"
                    },
                    {
                        "id": 82703,
                        "name": "Hobo",
                        "latitude": "13.51010000",
                        "longitude": "123.17920000"
                    },
                    {
                        "id": 82736,
                        "name": "Imelda",
                        "latitude": "14.03333000",
                        "longitude": "122.88333000"
                    },
                    {
                        "id": 82742,
                        "name": "Inapatan",
                        "latitude": "13.39640000",
                        "longitude": "123.32270000"
                    },
                    {
                        "id": 82764,
                        "name": "Iraya",
                        "latitude": "13.25000000",
                        "longitude": "123.51667000"
                    },
                    {
                        "id": 82811,
                        "name": "Joroan",
                        "latitude": "13.48850000",
                        "longitude": "123.61890000"
                    },
                    {
                        "id": 82812,
                        "name": "Jose Pañganiban",
                        "latitude": "14.29060000",
                        "longitude": "122.69170000"
                    },
                    {
                        "id": 82815,
                        "name": "Jovellar",
                        "latitude": "13.06950000",
                        "longitude": "123.59990000"
                    },
                    {
                        "id": 82854,
                        "name": "Kaliliog",
                        "latitude": "13.90390000",
                        "longitude": "123.29250000"
                    },
                    {
                        "id": 82907,
                        "name": "Kinalansan",
                        "latitude": "13.70360000",
                        "longitude": "123.55310000"
                    },
                    {
                        "id": 82961,
                        "name": "Labnig",
                        "latitude": "13.37690000",
                        "longitude": "123.67880000"
                    },
                    {
                        "id": 82962,
                        "name": "Labo",
                        "latitude": "14.15320000",
                        "longitude": "122.83030000"
                    },
                    {
                        "id": 82968,
                        "name": "Lacag",
                        "latitude": "13.15530000",
                        "longitude": "123.68120000"
                    },
                    {
                        "id": 82985,
                        "name": "Lajong",
                        "latitude": "12.83333000",
                        "longitude": "123.96667000"
                    },
                    {
                        "id": 83018,
                        "name": "Lanigay",
                        "latitude": "13.31667000",
                        "longitude": "123.50000000"
                    },
                    {
                        "id": 83023,
                        "name": "Lantangan",
                        "latitude": "12.19815000",
                        "longitude": "123.27101000"
                    },
                    {
                        "id": 83041,
                        "name": "Larap",
                        "latitude": "14.29900000",
                        "longitude": "122.65040000"
                    },
                    {
                        "id": 83061,
                        "name": "Legaspi",
                        "latitude": "13.14125000",
                        "longitude": "123.74073000"
                    },
                    {
                        "id": 83093,
                        "name": "Libog",
                        "latitude": "13.23490000",
                        "longitude": "123.77780000"
                    },
                    {
                        "id": 83094,
                        "name": "Libon",
                        "latitude": "13.29970000",
                        "longitude": "123.43860000"
                    },
                    {
                        "id": 83097,
                        "name": "Liboro",
                        "latitude": "13.82450000",
                        "longitude": "122.72950000"
                    },
                    {
                        "id": 83104,
                        "name": "Ligao",
                        "latitude": "13.21697000",
                        "longitude": "123.51924000"
                    },
                    {
                        "id": 83122,
                        "name": "Limbuhan",
                        "latitude": "11.88377000",
                        "longitude": "124.05011000"
                    },
                    {
                        "id": 83188,
                        "name": "Lourdes",
                        "latitude": "13.38990000",
                        "longitude": "123.37350000"
                    },
                    {
                        "id": 83194,
                        "name": "Lubigan",
                        "latitude": "13.74200000",
                        "longitude": "122.93730000"
                    },
                    {
                        "id": 83207,
                        "name": "Lugui",
                        "latitude": "14.11310000",
                        "longitude": "122.79350000"
                    },
                    {
                        "id": 83211,
                        "name": "Luklukan",
                        "latitude": "14.32540000",
                        "longitude": "122.71240000"
                    },
                    {
                        "id": 83234,
                        "name": "Luna",
                        "latitude": "12.54920000",
                        "longitude": "123.73360000"
                    },
                    {
                        "id": 83244,
                        "name": "Lupi Viejo",
                        "latitude": "13.78970000",
                        "longitude": "122.90980000"
                    },
                    {
                        "id": 83254,
                        "name": "Maagnas",
                        "latitude": "13.71920000",
                        "longitude": "123.66750000"
                    },
                    {
                        "id": 83285,
                        "name": "Mabiton",
                        "latitude": "12.83340000",
                        "longitude": "123.26120000"
                    },
                    {
                        "id": 83296,
                        "name": "Macabugos",
                        "latitude": "13.23620000",
                        "longitude": "123.30530000"
                    },
                    {
                        "id": 83298,
                        "name": "Macalaya",
                        "latitude": "12.88944000",
                        "longitude": "123.77111000"
                    },
                    {
                        "id": 83340,
                        "name": "Magsalangi",
                        "latitude": "12.18275000",
                        "longitude": "123.56661000"
                    },
                    {
                        "id": 83354,
                        "name": "Mahaba",
                        "latitude": "13.26760000",
                        "longitude": "123.55140000"
                    },
                    {
                        "id": 83385,
                        "name": "Malabog",
                        "latitude": "13.17380000",
                        "longitude": "123.68650000"
                    },
                    {
                        "id": 83411,
                        "name": "Malasugui",
                        "latitude": "14.14390000",
                        "longitude": "122.84710000"
                    },
                    {
                        "id": 83412,
                        "name": "Malatap",
                        "latitude": "14.18710000",
                        "longitude": "122.51190000"
                    },
                    {
                        "id": 83414,
                        "name": "Malawag",
                        "latitude": "13.38333000",
                        "longitude": "123.28333000"
                    },
                    {
                        "id": 83421,
                        "name": "Malbug",
                        "latitude": "12.05630000",
                        "longitude": "123.64610000"
                    },
                    {
                        "id": 83427,
                        "name": "Malidong",
                        "latitude": "13.01333000",
                        "longitude": "123.45962000"
                    },
                    {
                        "id": 83431,
                        "name": "Malilipot",
                        "latitude": "13.31880000",
                        "longitude": "123.73850000"
                    },
                    {
                        "id": 83437,
                        "name": "Malinao",
                        "latitude": "13.39920000",
                        "longitude": "123.70690000"
                    },
                    {
                        "id": 83443,
                        "name": "Malinta",
                        "latitude": "12.30144000",
                        "longitude": "123.55811000"
                    },
                    {
                        "id": 83476,
                        "name": "Mambulo",
                        "latitude": "13.71667000",
                        "longitude": "123.05000000"
                    },
                    {
                        "id": 83480,
                        "name": "Mampurog",
                        "latitude": "14.04580000",
                        "longitude": "122.88360000"
                    },
                    {
                        "id": 83489,
                        "name": "Manamrag",
                        "latitude": "13.73510000",
                        "longitude": "124.10640000"
                    },
                    {
                        "id": 83507,
                        "name": "Manga",
                        "latitude": "13.27190000",
                        "longitude": "123.46230000"
                    },
                    {
                        "id": 83526,
                        "name": "Manito",
                        "latitude": "13.12350000",
                        "longitude": "123.86930000"
                    },
                    {
                        "id": 83533,
                        "name": "Manquiring",
                        "latitude": "13.73410000",
                        "longitude": "123.26900000"
                    },
                    {
                        "id": 83547,
                        "name": "Maonon",
                        "latitude": "13.03643000",
                        "longitude": "123.37074000"
                    },
                    {
                        "id": 83584,
                        "name": "Marintoc",
                        "latitude": "12.28554000",
                        "longitude": "123.72281000"
                    },
                    {
                        "id": 83589,
                        "name": "Marupit",
                        "latitude": "13.62690000",
                        "longitude": "123.16630000"
                    },
                    {
                        "id": 83597,
                        "name": "Masaraway",
                        "latitude": "13.22680000",
                        "longitude": "123.61480000"
                    },
                    {
                        "id": 83606,
                        "name": "Maslog",
                        "latitude": "13.10460000",
                        "longitude": "123.77130000"
                    },
                    {
                        "id": 83608,
                        "name": "Masoli",
                        "latitude": "13.35930000",
                        "longitude": "123.38980000"
                    },
                    {
                        "id": 83613,
                        "name": "Matacon",
                        "latitude": "13.32840000",
                        "longitude": "123.43560000"
                    },
                    {
                        "id": 83640,
                        "name": "Mauraro",
                        "latitude": "13.14940000",
                        "longitude": "123.59530000"
                    },
                    {
                        "id": 83650,
                        "name": "Mayngaran",
                        "latitude": "12.34920000",
                        "longitude": "123.59960000"
                    },
                    {
                        "id": 83659,
                        "name": "Mercedes",
                        "latitude": "14.10930000",
                        "longitude": "123.01090000"
                    },
                    {
                        "id": 83665,
                        "name": "Miaga",
                        "latitude": "12.23760000",
                        "longitude": "123.81670000"
                    },
                    {
                        "id": 83674,
                        "name": "Miliroc",
                        "latitude": "13.34490000",
                        "longitude": "123.70200000"
                    },
                    {
                        "id": 83698,
                        "name": "Monbon",
                        "latitude": "12.73070000",
                        "longitude": "124.01890000"
                    },
                    {
                        "id": 83720,
                        "name": "Muladbucad",
                        "latitude": "13.23890000",
                        "longitude": "123.60570000"
                    },
                    {
                        "id": 83732,
                        "name": "Naagas",
                        "latitude": "13.43570000",
                        "longitude": "123.67810000"
                    },
                    {
                        "id": 83734,
                        "name": "Nabangig",
                        "latitude": "12.09890000",
                        "longitude": "123.95030000"
                    },
                    {
                        "id": 83780,
                        "name": "Naro",
                        "latitude": "11.89697000",
                        "longitude": "123.67392000"
                    },
                    {
                        "id": 83788,
                        "name": "Nato",
                        "latitude": "13.61050000",
                        "longitude": "123.53560000"
                    },
                    {
                        "id": 83842,
                        "name": "Odicon",
                        "latitude": "13.53000000",
                        "longitude": "123.05880000"
                    },
                    {
                        "id": 83847,
                        "name": "Ogod",
                        "latitude": "12.90090000",
                        "longitude": "123.61700000"
                    },
                    {
                        "id": 83863,
                        "name": "Osiao",
                        "latitude": "13.09140000",
                        "longitude": "123.98110000"
                    },
                    {
                        "id": 83867,
                        "name": "Osmeña",
                        "latitude": "12.73150000",
                        "longitude": "123.33180000"
                    },
                    {
                        "id": 83877,
                        "name": "Padang",
                        "latitude": "13.21960000",
                        "longitude": "123.76550000"
                    },
                    {
                        "id": 83910,
                        "name": "Palali",
                        "latitude": "14.30622000",
                        "longitude": "122.48571000"
                    },
                    {
                        "id": 83920,
                        "name": "Palestina",
                        "latitude": "13.61170000",
                        "longitude": "123.24900000"
                    },
                    {
                        "id": 83930,
                        "name": "Palsong",
                        "latitude": "13.42480000",
                        "longitude": "123.29630000"
                    },
                    {
                        "id": 83936,
                        "name": "Pambuhan",
                        "latitude": "13.97360000",
                        "longitude": "123.08370000"
                    },
                    {
                        "id": 83960,
                        "name": "Pandan",
                        "latitude": "14.04530000",
                        "longitude": "124.16940000"
                    },
                    {
                        "id": 83982,
                        "name": "Panguiranan",
                        "latitude": "12.06986000",
                        "longitude": "123.31851000"
                    },
                    {
                        "id": 83999,
                        "name": "Pantao",
                        "latitude": "13.19440000",
                        "longitude": "123.32710000"
                    },
                    {
                        "id": 84011,
                        "name": "Parabcan",
                        "latitude": "13.70880000",
                        "longitude": "123.74500000"
                    },
                    {
                        "id": 84012,
                        "name": "Paracale",
                        "latitude": "14.28040000",
                        "longitude": "122.78810000"
                    },
                    {
                        "id": 84057,
                        "name": "Paulba",
                        "latitude": "13.71360000",
                        "longitude": "123.24960000"
                    },
                    {
                        "id": 84060,
                        "name": "Pawa",
                        "latitude": "13.17730000",
                        "longitude": "123.73010000"
                    },
                    {
                        "id": 84062,
                        "name": "Pawican",
                        "latitude": "12.07410000",
                        "longitude": "123.97060000"
                    },
                    {
                        "id": 84063,
                        "name": "Pawili",
                        "latitude": "13.51667000",
                        "longitude": "123.28333000"
                    },
                    {
                        "id": 84076,
                        "name": "Peña",
                        "latitude": "12.08900000",
                        "longitude": "123.93840000"
                    },
                    {
                        "id": 84112,
                        "name": "Pinit",
                        "latitude": "13.56860000",
                        "longitude": "123.41400000"
                    },
                    {
                        "id": 84119,
                        "name": "Pio Duran",
                        "latitude": "13.02928000",
                        "longitude": "123.44496000"
                    },
                    {
                        "id": 84143,
                        "name": "Polangui",
                        "latitude": "13.29230000",
                        "longitude": "123.48550000"
                    },
                    {
                        "id": 84160,
                        "name": "Ponso",
                        "latitude": "13.29100000",
                        "longitude": "123.51710000"
                    },
                    {
                        "id": 84168,
                        "name": "Potot",
                        "latitude": "12.20345000",
                        "longitude": "123.43191000"
                    },
                    {
                        "id": 84185,
                        "name": "Province of Albay",
                        "latitude": "13.21667000",
                        "longitude": "123.55000000"
                    },
                    {
                        "id": 84196,
                        "name": "Province of Camarines Norte",
                        "latitude": "14.16667000",
                        "longitude": "122.75000000"
                    },
                    {
                        "id": 84197,
                        "name": "Province of Camarines Sur",
                        "latitude": "13.66667000",
                        "longitude": "123.33333000"
                    },
                    {
                        "id": 84200,
                        "name": "Province of Catanduanes",
                        "latitude": "13.83333000",
                        "longitude": "124.25000000"
                    },
                    {
                        "id": 84221,
                        "name": "Province of Masbate",
                        "latitude": "12.16667000",
                        "longitude": "123.58333000"
                    },
                    {
                        "id": 84241,
                        "name": "Province of Sorsogon",
                        "latitude": "12.83333000",
                        "longitude": "123.91667000"
                    },
                    {
                        "id": 84286,
                        "name": "Puro",
                        "latitude": "12.48410000",
                        "longitude": "123.38270000"
                    },
                    {
                        "id": 84289,
                        "name": "Putiao",
                        "latitude": "13.01950000",
                        "longitude": "123.71480000"
                    },
                    {
                        "id": 84317,
                        "name": "Quitang",
                        "latitude": "13.55130000",
                        "longitude": "123.05290000"
                    },
                    {
                        "id": 84330,
                        "name": "Rapu-Rapu",
                        "latitude": "13.18660000",
                        "longitude": "124.12560000"
                    },
                    {
                        "id": 84335,
                        "name": "Recodo",
                        "latitude": "11.94914000",
                        "longitude": "123.73695000"
                    },
                    {
                        "id": 84341,
                        "name": "Rizal",
                        "latitude": "12.97722000",
                        "longitude": "123.91417000"
                    },
                    {
                        "id": 84368,
                        "name": "Sabang",
                        "latitude": "12.73333000",
                        "longitude": "123.93333000"
                    },
                    {
                        "id": 84371,
                        "name": "Sabang Indan",
                        "latitude": "14.21940000",
                        "longitude": "122.91510000"
                    },
                    {
                        "id": 84390,
                        "name": "Sagpon",
                        "latitude": "13.15000000",
                        "longitude": "123.73333000"
                    },
                    {
                        "id": 84391,
                        "name": "Sagrada",
                        "latitude": "13.53010000",
                        "longitude": "123.45270000"
                    },
                    {
                        "id": 84392,
                        "name": "Sagrada Familia",
                        "latitude": "13.26900000",
                        "longitude": "123.39770000"
                    },
                    {
                        "id": 84398,
                        "name": "Sagurong",
                        "latitude": "13.78050000",
                        "longitude": "122.95940000"
                    },
                    {
                        "id": 84412,
                        "name": "Salingogan",
                        "latitude": "13.43330000",
                        "longitude": "123.19230000"
                    },
                    {
                        "id": 84414,
                        "name": "Salogon",
                        "latitude": "13.65860000",
                        "longitude": "123.52250000"
                    },
                    {
                        "id": 84419,
                        "name": "Salvacion",
                        "latitude": "13.06667000",
                        "longitude": "123.61667000"
                    },
                    {
                        "id": 84436,
                        "name": "San Agustin",
                        "latitude": "13.32630000",
                        "longitude": "123.41770000"
                    },
                    {
                        "id": 84442,
                        "name": "San Andres",
                        "latitude": "13.26140000",
                        "longitude": "123.77950000"
                    },
                    {
                        "id": 84446,
                        "name": "San Antonio",
                        "latitude": "13.37100000",
                        "longitude": "123.42020000"
                    },
                    {
                        "id": 84537,
                        "name": "San Lucas",
                        "latitude": "13.70620000",
                        "longitude": "123.20320000"
                    },
                    {
                        "id": 84579,
                        "name": "San Pascual",
                        "latitude": "13.12888000",
                        "longitude": "122.97709000"
                    },
                    {
                        "id": 84585,
                        "name": "San Pedro",
                        "latitude": "12.01667000",
                        "longitude": "124.00000000"
                    },
                    {
                        "id": 84595,
                        "name": "San Rafael",
                        "latitude": "13.21667000",
                        "longitude": "123.60000000"
                    },
                    {
                        "id": 84599,
                        "name": "San Ramon",
                        "latitude": "13.72210000",
                        "longitude": "123.54000000"
                    },
                    {
                        "id": 84607,
                        "name": "San Roque",
                        "latitude": "13.28370000",
                        "longitude": "123.74220000"
                    },
                    {
                        "id": 84623,
                        "name": "San Vicente",
                        "latitude": "14.10610000",
                        "longitude": "122.87330000"
                    },
                    {
                        "id": 84664,
                        "name": "Santa Elena",
                        "latitude": "14.17023000",
                        "longitude": "122.38246000"
                    },
                    {
                        "id": 84676,
                        "name": "Santa Justina",
                        "latitude": "13.39670000",
                        "longitude": "123.47310000"
                    },
                    {
                        "id": 84701,
                        "name": "Santa Rosa Sur",
                        "latitude": "14.25900000",
                        "longitude": "122.72330000"
                    },
                    {
                        "id": 84706,
                        "name": "Santa Teresita",
                        "latitude": "13.47860000",
                        "longitude": "123.41910000"
                    },
                    {
                        "id": 84720,
                        "name": "Santo Domingo",
                        "latitude": "13.42000000",
                        "longitude": "123.44860000"
                    },
                    {
                        "id": 84724,
                        "name": "Santo Niño",
                        "latitude": "13.10430000",
                        "longitude": "123.96820000"
                    },
                    {
                        "id": 84822,
                        "name": "Sinuknipan",
                        "latitude": "13.88940000",
                        "longitude": "122.63750000"
                    },
                    {
                        "id": 84860,
                        "name": "Sugcad",
                        "latitude": "13.36667000",
                        "longitude": "123.70000000"
                    },
                    {
                        "id": 84861,
                        "name": "Sugod",
                        "latitude": "12.98700000",
                        "longitude": "124.08050000"
                    },
                    {
                        "id": 84891,
                        "name": "Tabaco",
                        "latitude": "13.35861000",
                        "longitude": "123.73361000"
                    },
                    {
                        "id": 84930,
                        "name": "Tagas",
                        "latitude": "13.16667000",
                        "longitude": "123.71667000"
                    },
                    {
                        "id": 84946,
                        "name": "Tagoytoy",
                        "latitude": "13.41580000",
                        "longitude": "123.67800000"
                    },
                    {
                        "id": 84980,
                        "name": "Talisay",
                        "latitude": "14.13430000",
                        "longitude": "122.92260000"
                    },
                    {
                        "id": 84997,
                        "name": "Talubatib",
                        "latitude": "14.18250000",
                        "longitude": "122.78530000"
                    },
                    {
                        "id": 85010,
                        "name": "Tambo",
                        "latitude": "13.54680000",
                        "longitude": "123.03580000"
                    },
                    {
                        "id": 85054,
                        "name": "Tara",
                        "latitude": "13.81667000",
                        "longitude": "122.98333000"
                    },
                    {
                        "id": 85057,
                        "name": "Tariric",
                        "latitude": "13.57230000",
                        "longitude": "123.22350000"
                    },
                    {
                        "id": 85106,
                        "name": "Tigbaw",
                        "latitude": "12.14830000",
                        "longitude": "123.59090000"
                    },
                    {
                        "id": 85107,
                        "name": "Tigbinan",
                        "latitude": "14.18648000",
                        "longitude": "122.46923000"
                    },
                    {
                        "id": 85126,
                        "name": "Tinago",
                        "latitude": "13.18333000",
                        "longitude": "123.65000000"
                    },
                    {
                        "id": 85127,
                        "name": "Tinalmud",
                        "latitude": "13.59410000",
                        "longitude": "122.87800000"
                    },
                    {
                        "id": 85130,
                        "name": "Tinampo",
                        "latitude": "13.22825000",
                        "longitude": "123.50723000"
                    },
                    {
                        "id": 85133,
                        "name": "Tinawagan",
                        "latitude": "13.65000000",
                        "longitude": "123.48333000"
                    },
                    {
                        "id": 85149,
                        "name": "Tiwi",
                        "latitude": "13.45850000",
                        "longitude": "123.68050000"
                    },
                    {
                        "id": 85192,
                        "name": "Tubli",
                        "latitude": "13.93180000",
                        "longitude": "124.14780000"
                    },
                    {
                        "id": 85211,
                        "name": "Tugos",
                        "latitude": "14.26667000",
                        "longitude": "122.75000000"
                    },
                    {
                        "id": 85216,
                        "name": "Tulay na Lupa",
                        "latitude": "14.09340000",
                        "longitude": "122.78620000"
                    },
                    {
                        "id": 85219,
                        "name": "Tumalaytay",
                        "latitude": "12.27584000",
                        "longitude": "123.23201000"
                    },
                    {
                        "id": 85247,
                        "name": "Umabay",
                        "latitude": "12.30954000",
                        "longitude": "123.67961000"
                    },
                    {
                        "id": 85269,
                        "name": "Usab",
                        "latitude": "12.32974000",
                        "longitude": "123.58091000"
                    },
                    {
                        "id": 85270,
                        "name": "Uson",
                        "latitude": "12.22530000",
                        "longitude": "123.78340000"
                    },
                    {
                        "id": 85271,
                        "name": "Utabi",
                        "latitude": "12.64170000",
                        "longitude": "123.90920000"
                    },
                    {
                        "id": 85295,
                        "name": "Villahermosa",
                        "latitude": "13.04580000",
                        "longitude": "123.71330000"
                    },
                    {
                        "id": 85304,
                        "name": "Vinzons",
                        "latitude": "14.17370000",
                        "longitude": "122.90660000"
                    }
                ]
            },
            {
                "id": 1336,
                "name": "Antique",
                "iso2": "ANT",
                "latitude": "37.03586950",
                "longitude": "-95.63616940",
                "type": "province",
                "cities": [
                    {
                        "id": 81127,
                        "name": "Abaca",
                        "latitude": "11.13420000",
                        "longitude": "122.71560000"
                    },
                    {
                        "id": 81128,
                        "name": "Abangay",
                        "latitude": "10.96667000",
                        "longitude": "122.65000000"
                    },
                    {
                        "id": 81129,
                        "name": "Abiera",
                        "latitude": "11.57490000",
                        "longitude": "122.09000000"
                    },
                    {
                        "id": 81130,
                        "name": "Abilay",
                        "latitude": "10.73333000",
                        "longitude": "122.50000000"
                    },
                    {
                        "id": 81150,
                        "name": "Ag-ambulong",
                        "latitude": "11.36840000",
                        "longitude": "122.50940000"
                    },
                    {
                        "id": 81152,
                        "name": "Aganan",
                        "latitude": "10.78333000",
                        "longitude": "122.53333000"
                    },
                    {
                        "id": 81159,
                        "name": "Aglalana",
                        "latitude": "11.18030000",
                        "longitude": "122.65740000"
                    },
                    {
                        "id": 81165,
                        "name": "Agpangi",
                        "latitude": "10.57716000",
                        "longitude": "123.42320000"
                    },
                    {
                        "id": 81170,
                        "name": "Aguisan",
                        "latitude": "10.16030000",
                        "longitude": "122.86150000"
                    },
                    {
                        "id": 81180,
                        "name": "Alacaygan",
                        "latitude": "10.84014000",
                        "longitude": "123.05830000"
                    },
                    {
                        "id": 81199,
                        "name": "Alegria",
                        "latitude": "10.64345000",
                        "longitude": "123.08360000"
                    },
                    {
                        "id": 81211,
                        "name": "Alibunan",
                        "latitude": "11.14652000",
                        "longitude": "122.45911000"
                    },
                    {
                        "id": 81212,
                        "name": "Alicante",
                        "latitude": "10.89704000",
                        "longitude": "123.01850000"
                    },
                    {
                        "id": 81216,
                        "name": "Alijis",
                        "latitude": "10.45830000",
                        "longitude": "122.83480000"
                    },
                    {
                        "id": 81218,
                        "name": "Alim",
                        "latitude": "9.56490000",
                        "longitude": "122.48760000"
                    },
                    {
                        "id": 81220,
                        "name": "Alimono",
                        "latitude": "11.18550000",
                        "longitude": "122.71290000"
                    },
                    {
                        "id": 81245,
                        "name": "Ambulong",
                        "latitude": "11.57930000",
                        "longitude": "122.49870000"
                    },
                    {
                        "id": 81263,
                        "name": "Andres Bonifacio",
                        "latitude": "10.91667000",
                        "longitude": "123.25000000"
                    },
                    {
                        "id": 81273,
                        "name": "Anini-y",
                        "latitude": "10.43120000",
                        "longitude": "121.92700000"
                    },
                    {
                        "id": 81277,
                        "name": "Anoring",
                        "latitude": "11.25000000",
                        "longitude": "123.03333000"
                    },
                    {
                        "id": 81301,
                        "name": "Aquino",
                        "latitude": "11.82210000",
                        "longitude": "122.10880000"
                    },
                    {
                        "id": 81302,
                        "name": "Araal",
                        "latitude": "10.41950000",
                        "longitude": "123.04370000"
                    },
                    {
                        "id": 81306,
                        "name": "Aranas Sur",
                        "latitude": "11.56350000",
                        "longitude": "122.39010000"
                    },
                    {
                        "id": 81307,
                        "name": "Aranda",
                        "latitude": "10.23650000",
                        "longitude": "122.94670000"
                    },
                    {
                        "id": 81310,
                        "name": "Arcangel",
                        "latitude": "11.53950000",
                        "longitude": "122.34550000"
                    },
                    {
                        "id": 81319,
                        "name": "Asia",
                        "latitude": "9.55060000",
                        "longitude": "122.51640000"
                    },
                    {
                        "id": 81322,
                        "name": "Asturga",
                        "latitude": "11.25449000",
                        "longitude": "122.80180000"
                    },
                    {
                        "id": 81324,
                        "name": "Atabayan",
                        "latitude": "10.68333000",
                        "longitude": "122.41667000"
                    },
                    {
                        "id": 81326,
                        "name": "Atipuluhan",
                        "latitude": "10.51336000",
                        "longitude": "122.96210000"
                    },
                    {
                        "id": 81331,
                        "name": "Aurelliana",
                        "latitude": "10.88490000",
                        "longitude": "121.97690000"
                    },
                    {
                        "id": 81337,
                        "name": "Avila",
                        "latitude": "10.69200000",
                        "longitude": "122.70900000"
                    },
                    {
                        "id": 81354,
                        "name": "Bacalan",
                        "latitude": "11.54640000",
                        "longitude": "122.08490000"
                    },
                    {
                        "id": 81366,
                        "name": "Bacolod City",
                        "latitude": "10.66667000",
                        "longitude": "122.95000000"
                    },
                    {
                        "id": 81378,
                        "name": "Bacuyangan",
                        "latitude": "9.63700000",
                        "longitude": "122.47210000"
                    },
                    {
                        "id": 81383,
                        "name": "Badlan",
                        "latitude": "11.14140000",
                        "longitude": "122.52000000"
                    },
                    {
                        "id": 81396,
                        "name": "Bago City",
                        "latitude": "10.53333000",
                        "longitude": "122.83333000"
                    },
                    {
                        "id": 81404,
                        "name": "Bagroy",
                        "latitude": "10.20310000",
                        "longitude": "122.93620000"
                    },
                    {
                        "id": 81412,
                        "name": "Bagumbayan",
                        "latitude": "10.44600000",
                        "longitude": "122.83480000"
                    },
                    {
                        "id": 81421,
                        "name": "Bailan",
                        "latitude": "11.45840000",
                        "longitude": "122.83010000"
                    },
                    {
                        "id": 81430,
                        "name": "Balabag",
                        "latitude": "11.97000000",
                        "longitude": "121.91917000"
                    },
                    {
                        "id": 81465,
                        "name": "Balibagan Oeste",
                        "latitude": "10.80000000",
                        "longitude": "122.51667000"
                    },
                    {
                        "id": 81487,
                        "name": "Baliwagan",
                        "latitude": "10.39710000",
                        "longitude": "122.89110000"
                    },
                    {
                        "id": 81520,
                        "name": "Bancal",
                        "latitude": "11.55910000",
                        "longitude": "123.15510000"
                    },
                    {
                        "id": 81570,
                        "name": "Barbaza",
                        "latitude": "11.19572000",
                        "longitude": "122.03861000"
                    },
                    {
                        "id": 81602,
                        "name": "Basiao",
                        "latitude": "11.54861000",
                        "longitude": "122.63750000"
                    },
                    {
                        "id": 81651,
                        "name": "Bay-ang",
                        "latitude": "11.03472000",
                        "longitude": "122.94167000"
                    },
                    {
                        "id": 81659,
                        "name": "Bayas",
                        "latitude": "11.43360000",
                        "longitude": "123.18160000"
                    },
                    {
                        "id": 81677,
                        "name": "Belison",
                        "latitude": "10.83840000",
                        "longitude": "121.96050000"
                    },
                    {
                        "id": 81683,
                        "name": "Biao",
                        "latitude": "10.10880000",
                        "longitude": "122.97720000"
                    },
                    {
                        "id": 81700,
                        "name": "Bilao",
                        "latitude": "11.48800000",
                        "longitude": "122.55990000"
                    },
                    {
                        "id": 81706,
                        "name": "Binabaan",
                        "latitude": "11.01910000",
                        "longitude": "122.52210000"
                    },
                    {
                        "id": 81713,
                        "name": "Binantocan",
                        "latitude": "11.40730000",
                        "longitude": "122.86020000"
                    },
                    {
                        "id": 81726,
                        "name": "Binon-an",
                        "latitude": "11.39470000",
                        "longitude": "123.14260000"
                    },
                    {
                        "id": 81727,
                        "name": "Binonga",
                        "latitude": "10.77190000",
                        "longitude": "122.98170000"
                    },
                    {
                        "id": 81739,
                        "name": "Bitadtun",
                        "latitude": "11.49690000",
                        "longitude": "122.08511000"
                    },
                    {
                        "id": 81757,
                        "name": "Bocana",
                        "latitude": "10.01160000",
                        "longitude": "122.72170000"
                    },
                    {
                        "id": 81765,
                        "name": "Bolanon",
                        "latitude": "10.91710000",
                        "longitude": "123.47340000"
                    },
                    {
                        "id": 81769,
                        "name": "Bolilao",
                        "latitude": "10.88333000",
                        "longitude": "122.73333000"
                    },
                    {
                        "id": 81777,
                        "name": "Bolo",
                        "latitude": "11.54028000",
                        "longitude": "122.75722000"
                    },
                    {
                        "id": 81780,
                        "name": "Bolong",
                        "latitude": "10.81667000",
                        "longitude": "122.51667000"
                    },
                    {
                        "id": 81807,
                        "name": "Brgy. Bachaw Norte Kalibo",
                        "latitude": "11.71806000",
                        "longitude": "122.37806000"
                    },
                    {
                        "id": 81808,
                        "name": "Brgy. Bulwang Numancia",
                        "latitude": "11.72194000",
                        "longitude": "122.36111000"
                    },
                    {
                        "id": 81809,
                        "name": "Brgy. Mabilo New Washington",
                        "latitude": "11.67778000",
                        "longitude": "122.40750000"
                    },
                    {
                        "id": 81810,
                        "name": "Brgy. Nalook kalibo",
                        "latitude": "11.68586000",
                        "longitude": "122.36916000"
                    },
                    {
                        "id": 81811,
                        "name": "Brgy. New Buswang Kalibo",
                        "latitude": "11.71222000",
                        "longitude": "122.38472000"
                    },
                    {
                        "id": 81812,
                        "name": "Brgy. Tinigao Kalibo",
                        "latitude": "11.70000000",
                        "longitude": "122.36667000"
                    },
                    {
                        "id": 81829,
                        "name": "Buenavista",
                        "latitude": "10.79874000",
                        "longitude": "123.55440000"
                    },
                    {
                        "id": 81838,
                        "name": "Buga",
                        "latitude": "10.71667000",
                        "longitude": "122.26667000"
                    },
                    {
                        "id": 81841,
                        "name": "Bugang",
                        "latitude": "10.74185000",
                        "longitude": "123.39330000"
                    },
                    {
                        "id": 81844,
                        "name": "Bugasong",
                        "latitude": "11.04464000",
                        "longitude": "122.06463000"
                    },
                    {
                        "id": 81863,
                        "name": "Bulad",
                        "latitude": "10.25480000",
                        "longitude": "122.99830000"
                    },
                    {
                        "id": 81870,
                        "name": "Bulata",
                        "latitude": "9.85990000",
                        "longitude": "122.40160000"
                    },
                    {
                        "id": 81889,
                        "name": "Buluangan",
                        "latitude": "10.38707000",
                        "longitude": "123.33810000"
                    },
                    {
                        "id": 81898,
                        "name": "Bungsuan",
                        "latitude": "11.24040000",
                        "longitude": "122.69760000"
                    },
                    {
                        "id": 81905,
                        "name": "Buray",
                        "latitude": "10.71500000",
                        "longitude": "122.45944000"
                    },
                    {
                        "id": 81911,
                        "name": "Burias",
                        "latitude": "11.44630000",
                        "longitude": "122.54970000"
                    },
                    {
                        "id": 81915,
                        "name": "Busay",
                        "latitude": "10.53780000",
                        "longitude": "122.88600000"
                    },
                    {
                        "id": 81931,
                        "name": "Buyuan",
                        "latitude": "10.67086000",
                        "longitude": "122.35740000"
                    },
                    {
                        "id": 81935,
                        "name": "Cabacungan",
                        "latitude": "10.32370000",
                        "longitude": "123.13310000"
                    },
                    {
                        "id": 81938,
                        "name": "Cabadiangan",
                        "latitude": "9.75340000",
                        "longitude": "122.47390000"
                    },
                    {
                        "id": 81946,
                        "name": "Cabanbanan",
                        "latitude": "10.08520000",
                        "longitude": "122.95790000"
                    },
                    {
                        "id": 81952,
                        "name": "Cabano",
                        "latitude": "10.58690000",
                        "longitude": "122.70020000"
                    },
                    {
                        "id": 81967,
                        "name": "Cabilao",
                        "latitude": "11.53960000",
                        "longitude": "123.14360000"
                    },
                    {
                        "id": 81968,
                        "name": "Cabilauan",
                        "latitude": "10.89222000",
                        "longitude": "122.65917000"
                    },
                    {
                        "id": 81978,
                        "name": "Cabugao",
                        "latitude": "10.81028000",
                        "longitude": "122.54472000"
                    },
                    {
                        "id": 81987,
                        "name": "Cadagmayan Norte",
                        "latitude": "10.81667000",
                        "longitude": "122.50000000"
                    },
                    {
                        "id": 81996,
                        "name": "Cagbang",
                        "latitude": "10.70000000",
                        "longitude": "122.49889000"
                    },
                    {
                        "id": 82019,
                        "name": "Calampisauan",
                        "latitude": "10.60985000",
                        "longitude": "123.47650000"
                    },
                    {
                        "id": 82030,
                        "name": "Calape",
                        "latitude": "10.27360000",
                        "longitude": "122.97430000"
                    },
                    {
                        "id": 82043,
                        "name": "Calaya",
                        "latitude": "10.49160000",
                        "longitude": "122.62550000"
                    },
                    {
                        "id": 82058,
                        "name": "Calizo",
                        "latitude": "11.58190000",
                        "longitude": "122.38570000"
                    },
                    {
                        "id": 82074,
                        "name": "Caluya",
                        "latitude": "11.93100000",
                        "longitude": "121.54770000"
                    },
                    {
                        "id": 82081,
                        "name": "Camalobalo",
                        "latitude": "10.27310000",
                        "longitude": "122.95050000"
                    },
                    {
                        "id": 82083,
                        "name": "Camandag",
                        "latitude": "10.33333000",
                        "longitude": "123.06667000"
                    },
                    {
                        "id": 82084,
                        "name": "Camangcamang",
                        "latitude": "10.17910000",
                        "longitude": "122.98650000"
                    },
                    {
                        "id": 82091,
                        "name": "Camindangan",
                        "latitude": "9.91840000",
                        "longitude": "122.62960000"
                    },
                    {
                        "id": 82092,
                        "name": "Camingawan",
                        "latitude": "9.89580000",
                        "longitude": "122.86250000"
                    },
                    {
                        "id": 82116,
                        "name": "Caningay",
                        "latitude": "9.82970000",
                        "longitude": "122.64420000"
                    },
                    {
                        "id": 82121,
                        "name": "Canroma",
                        "latitude": "10.36060000",
                        "longitude": "122.87900000"
                    },
                    {
                        "id": 82122,
                        "name": "Cansilayan",
                        "latitude": "10.55976000",
                        "longitude": "123.01840000"
                    },
                    {
                        "id": 82123,
                        "name": "Cansolungon",
                        "latitude": "10.15100000",
                        "longitude": "122.99780000"
                    },
                    {
                        "id": 82130,
                        "name": "Canturay",
                        "latitude": "9.79370000",
                        "longitude": "122.45430000"
                    },
                    {
                        "id": 82133,
                        "name": "Capaga",
                        "latitude": "11.43790000",
                        "longitude": "122.74790000"
                    },
                    {
                        "id": 82139,
                        "name": "Capitan Ramon",
                        "latitude": "10.76020000",
                        "longitude": "123.11480000"
                    },
                    {
                        "id": 82146,
                        "name": "Carabalan",
                        "latitude": "10.09640000",
                        "longitude": "122.94600000"
                    },
                    {
                        "id": 82160,
                        "name": "Caridad",
                        "latitude": "10.49670000",
                        "longitude": "122.89740000"
                    },
                    {
                        "id": 82165,
                        "name": "Carmelo",
                        "latitude": "11.01667000",
                        "longitude": "122.81667000"
                    },
                    {
                        "id": 82174,
                        "name": "Carmen Grande",
                        "latitude": "10.37870000",
                        "longitude": "122.91560000"
                    },
                    {
                        "id": 82184,
                        "name": "Cartagena",
                        "latitude": "9.82030000",
                        "longitude": "122.40040000"
                    },
                    {
                        "id": 82194,
                        "name": "Cassanayan",
                        "latitude": "11.51690000",
                        "longitude": "123.05120000"
                    },
                    {
                        "id": 82211,
                        "name": "Caticlan",
                        "latitude": "11.93337000",
                        "longitude": "121.95981000"
                    },
                    {
                        "id": 82220,
                        "name": "Catungan",
                        "latitude": "10.77060000",
                        "longitude": "122.01490000"
                    },
                    {
                        "id": 82235,
                        "name": "Cayanguan",
                        "latitude": "11.68900000",
                        "longitude": "122.29090000"
                    },
                    {
                        "id": 82236,
                        "name": "Cayhagan",
                        "latitude": "9.67830000",
                        "longitude": "122.43350000"
                    },
                    {
                        "id": 82241,
                        "name": "Cervantes",
                        "latitude": "10.87260000",
                        "longitude": "123.52090000"
                    },
                    {
                        "id": 82243,
                        "name": "Chambrey",
                        "latitude": "10.97680000",
                        "longitude": "123.16820000"
                    },
                    {
                        "id": 82252,
                        "name": "Codcod",
                        "latitude": "10.46337000",
                        "longitude": "123.24950000"
                    },
                    {
                        "id": 82256,
                        "name": "Cogon",
                        "latitude": "11.46410000",
                        "longitude": "122.80300000"
                    },
                    {
                        "id": 82259,
                        "name": "Colipapa",
                        "latitude": "9.47260000",
                        "longitude": "122.56160000"
                    },
                    {
                        "id": 82272,
                        "name": "Concepcion",
                        "latitude": "10.69200000",
                        "longitude": "123.06080000"
                    },
                    {
                        "id": 82277,
                        "name": "Concordia",
                        "latitude": "10.50767000",
                        "longitude": "122.54960000"
                    },
                    {
                        "id": 82283,
                        "name": "Constancia",
                        "latitude": "10.59596000",
                        "longitude": "122.64150000"
                    },
                    {
                        "id": 82286,
                        "name": "Consuelo",
                        "latitude": "9.99960000",
                        "longitude": "122.75800000"
                    },
                    {
                        "id": 82300,
                        "name": "Cortez",
                        "latitude": "11.53010000",
                        "longitude": "122.39750000"
                    },
                    {
                        "id": 82312,
                        "name": "Culasi",
                        "latitude": "11.42721000",
                        "longitude": "122.05601000"
                    },
                    {
                        "id": 82326,
                        "name": "Da-an Sur",
                        "latitude": "11.26120000",
                        "longitude": "122.42020000"
                    },
                    {
                        "id": 82348,
                        "name": "Daliciasao",
                        "latitude": "9.98590000",
                        "longitude": "122.76180000"
                    },
                    {
                        "id": 82360,
                        "name": "Damayan",
                        "latitude": "11.49360000",
                        "longitude": "122.55310000"
                    },
                    {
                        "id": 82368,
                        "name": "Dancalan",
                        "latitude": "9.98210000",
                        "longitude": "122.73860000"
                    },
                    {
                        "id": 82379,
                        "name": "Dapdapan",
                        "latitude": "11.49430000",
                        "longitude": "122.63140000"
                    },
                    {
                        "id": 82402,
                        "name": "De la Paz",
                        "latitude": "11.06444000",
                        "longitude": "122.77917000"
                    },
                    {
                        "id": 82415,
                        "name": "Dian-ay",
                        "latitude": "10.83333000",
                        "longitude": "123.55000000"
                    },
                    {
                        "id": 82465,
                        "name": "Dos Hermanas",
                        "latitude": "10.74210000",
                        "longitude": "123.03770000"
                    },
                    {
                        "id": 82475,
                        "name": "Dulangan",
                        "latitude": "11.45610000",
                        "longitude": "122.95570000"
                    },
                    {
                        "id": 82477,
                        "name": "Dulao",
                        "latitude": "10.54176000",
                        "longitude": "122.93830000"
                    },
                    {
                        "id": 82495,
                        "name": "Dungon",
                        "latitude": "11.71960000",
                        "longitude": "122.31600000"
                    },
                    {
                        "id": 82497,
                        "name": "Duran",
                        "latitude": "11.26180000",
                        "longitude": "122.59170000"
                    },
                    {
                        "id": 82499,
                        "name": "East Valencia",
                        "latitude": "10.66800000",
                        "longitude": "122.71000000"
                    },
                    {
                        "id": 82503,
                        "name": "Egaña",
                        "latitude": "10.74720000",
                        "longitude": "122.00984000"
                    },
                    {
                        "id": 82513,
                        "name": "Ermita",
                        "latitude": "10.90000000",
                        "longitude": "122.71667000"
                    },
                    {
                        "id": 82533,
                        "name": "Eustaquio Lopez",
                        "latitude": "10.81950000",
                        "longitude": "123.04120000"
                    },
                    {
                        "id": 82537,
                        "name": "Feliciano",
                        "latitude": "11.57870000",
                        "longitude": "122.35830000"
                    },
                    {
                        "id": 82548,
                        "name": "Gabi",
                        "latitude": "11.59560000",
                        "longitude": "123.33760000"
                    },
                    {
                        "id": 82586,
                        "name": "Getulio",
                        "latitude": "10.74700000",
                        "longitude": "122.66600000"
                    },
                    {
                        "id": 82588,
                        "name": "Gibato",
                        "latitude": "11.22510000",
                        "longitude": "122.81430000"
                    },
                    {
                        "id": 82590,
                        "name": "Gibong",
                        "latitude": "11.86338000",
                        "longitude": "122.03941000"
                    },
                    {
                        "id": 82596,
                        "name": "Gines-Patay",
                        "latitude": "10.93570000",
                        "longitude": "122.49320000"
                    },
                    {
                        "id": 82608,
                        "name": "Granada",
                        "latitude": "11.63333000",
                        "longitude": "123.35000000"
                    },
                    {
                        "id": 82611,
                        "name": "Guadalupe",
                        "latitude": "10.45447000",
                        "longitude": "123.37320000"
                    },
                    {
                        "id": 82625,
                        "name": "Guiljungan",
                        "latitude": "9.98050000",
                        "longitude": "122.67420000"
                    },
                    {
                        "id": 82637,
                        "name": "Guinoaliuan",
                        "latitude": "11.65760000",
                        "longitude": "122.38510000"
                    },
                    {
                        "id": 82641,
                        "name": "Guinticgan",
                        "latitude": "11.56410000",
                        "longitude": "123.12360000"
                    },
                    {
                        "id": 82642,
                        "name": "Guintubhan",
                        "latitude": "10.20740000",
                        "longitude": "122.96270000"
                    },
                    {
                        "id": 82649,
                        "name": "Guisijan",
                        "latitude": "11.09320000",
                        "longitude": "122.04610000"
                    },
                    {
                        "id": 82664,
                        "name": "Hacienda Refugio",
                        "latitude": "10.52166000",
                        "longitude": "123.44450000"
                    },
                    {
                        "id": 82665,
                        "name": "Hacienda Santa Rosa",
                        "latitude": "10.57226000",
                        "longitude": "123.10120000"
                    },
                    {
                        "id": 82670,
                        "name": "Haguimit",
                        "latitude": "10.39990000",
                        "longitude": "123.01780000"
                    },
                    {
                        "id": 82677,
                        "name": "Hamtic",
                        "latitude": "10.70230000",
                        "longitude": "121.98240000"
                    },
                    {
                        "id": 82690,
                        "name": "Himaya",
                        "latitude": "10.45160000",
                        "longitude": "122.83250000"
                    },
                    {
                        "id": 82702,
                        "name": "Hipona",
                        "latitude": "11.41740000",
                        "longitude": "122.88250000"
                    },
                    {
                        "id": 82713,
                        "name": "Idio",
                        "latitude": "11.62380000",
                        "longitude": "122.09790000"
                    },
                    {
                        "id": 82715,
                        "name": "Igang",
                        "latitude": "10.91600000",
                        "longitude": "122.63880000"
                    },
                    {
                        "id": 82717,
                        "name": "Igbon",
                        "latitude": "11.21420000",
                        "longitude": "123.16550000"
                    },
                    {
                        "id": 82718,
                        "name": "Igcocolo",
                        "latitude": "10.68966000",
                        "longitude": "122.31930000"
                    },
                    {
                        "id": 82719,
                        "name": "Igmaya-an",
                        "latitude": "10.54986000",
                        "longitude": "123.22060000"
                    },
                    {
                        "id": 82733,
                        "name": "Imbang",
                        "latitude": "10.79670000",
                        "longitude": "123.02130000"
                    },
                    {
                        "id": 82745,
                        "name": "Inayauan",
                        "latitude": "9.90050000",
                        "longitude": "122.43400000"
                    },
                    {
                        "id": 82754,
                        "name": "Intampilan",
                        "latitude": "11.48130000",
                        "longitude": "122.74340000"
                    },
                    {
                        "id": 82781,
                        "name": "Jaena",
                        "latitude": "11.41667000",
                        "longitude": "122.40000000"
                    },
                    {
                        "id": 82783,
                        "name": "Jaguimitan",
                        "latitude": "11.14000000",
                        "longitude": "122.72360000"
                    },
                    {
                        "id": 82786,
                        "name": "Jalaud",
                        "latitude": "10.84360000",
                        "longitude": "122.64040000"
                    },
                    {
                        "id": 82787,
                        "name": "Jamabalod",
                        "latitude": "10.87880000",
                        "longitude": "122.62120000"
                    },
                    {
                        "id": 82796,
                        "name": "Japitan",
                        "latitude": "10.76524000",
                        "longitude": "123.54440000"
                    },
                    {
                        "id": 82797,
                        "name": "Jarigue",
                        "latitude": "11.86538000",
                        "longitude": "121.44041000"
                    },
                    {
                        "id": 82802,
                        "name": "Jayubó",
                        "latitude": "11.05000000",
                        "longitude": "122.38333000"
                    },
                    {
                        "id": 82805,
                        "name": "Jibao-an",
                        "latitude": "10.78333000",
                        "longitude": "122.50000000"
                    },
                    {
                        "id": 82827,
                        "name": "Kabilauan",
                        "latitude": "10.86100000",
                        "longitude": "122.57340000"
                    },
                    {
                        "id": 82850,
                        "name": "Kalibo (poblacion)",
                        "latitude": "11.70611000",
                        "longitude": "122.36444000"
                    },
                    {
                        "id": 82853,
                        "name": "Kaliling",
                        "latitude": "9.98040000",
                        "longitude": "122.48140000"
                    },
                    {
                        "id": 82934,
                        "name": "Kumalisquis",
                        "latitude": "10.50726000",
                        "longitude": "123.20300000"
                    },
                    {
                        "id": 82941,
                        "name": "La Granja",
                        "latitude": "10.40820000",
                        "longitude": "122.98980000"
                    },
                    {
                        "id": 82951,
                        "name": "La Paz",
                        "latitude": "10.41310000",
                        "longitude": "122.51620000"
                    },
                    {
                        "id": 82970,
                        "name": "Lacaron",
                        "latitude": "11.42200000",
                        "longitude": "122.74220000"
                    },
                    {
                        "id": 82988,
                        "name": "Lalab",
                        "latitude": "11.57490000",
                        "longitude": "122.42840000"
                    },
                    {
                        "id": 82989,
                        "name": "Lalagsan",
                        "latitude": "10.28240000",
                        "longitude": "123.01300000"
                    },
                    {
                        "id": 83059,
                        "name": "Lañgub",
                        "latitude": "10.79754000",
                        "longitude": "123.53380000"
                    },
                    {
                        "id": 83021,
                        "name": "Lanot",
                        "latitude": "11.51917000",
                        "longitude": "122.75722000"
                    },
                    {
                        "id": 83022,
                        "name": "Lantangan",
                        "latitude": "11.58820000",
                        "longitude": "123.32560000"
                    },
                    {
                        "id": 83054,
                        "name": "Lawigan",
                        "latitude": "10.48562000",
                        "longitude": "122.04442000"
                    },
                    {
                        "id": 83088,
                        "name": "Libertad",
                        "latitude": "11.03528000",
                        "longitude": "122.76944000"
                    },
                    {
                        "id": 83129,
                        "name": "Linabuan",
                        "latitude": "11.65100000",
                        "longitude": "122.35750000"
                    },
                    {
                        "id": 83130,
                        "name": "Linabuan Sur",
                        "latitude": "11.65111000",
                        "longitude": "122.34500000"
                    },
                    {
                        "id": 83135,
                        "name": "Linaon",
                        "latitude": "9.94990000",
                        "longitude": "122.44830000"
                    },
                    {
                        "id": 83161,
                        "name": "Locmayan",
                        "latitude": "10.47260000",
                        "longitude": "122.51900000"
                    },
                    {
                        "id": 83168,
                        "name": "Lono",
                        "latitude": "11.51361000",
                        "longitude": "122.72972000"
                    },
                    {
                        "id": 83169,
                        "name": "Lonoy",
                        "latitude": "11.51222000",
                        "longitude": "122.55333000"
                    },
                    {
                        "id": 83203,
                        "name": "Lucero",
                        "latitude": "11.45420000",
                        "longitude": "122.46431000"
                    },
                    {
                        "id": 83228,
                        "name": "Luna",
                        "latitude": "10.96900000",
                        "longitude": "123.24190000"
                    },
                    {
                        "id": 83245,
                        "name": "Lupo",
                        "latitude": "11.50760000",
                        "longitude": "122.47910000"
                    },
                    {
                        "id": 83257,
                        "name": "Maao",
                        "latitude": "10.48960000",
                        "longitude": "122.99070000"
                    },
                    {
                        "id": 83260,
                        "name": "Maasin",
                        "latitude": "10.89250000",
                        "longitude": "122.43472000"
                    },
                    {
                        "id": 83276,
                        "name": "Mabini",
                        "latitude": "10.79594000",
                        "longitude": "123.48460000"
                    },
                    {
                        "id": 83323,
                        "name": "Magallon Cadre",
                        "latitude": "10.28850000",
                        "longitude": "123.09220000"
                    },
                    {
                        "id": 83332,
                        "name": "Magdalena",
                        "latitude": "10.42360000",
                        "longitude": "121.97510000"
                    },
                    {
                        "id": 83387,
                        "name": "Malabonot",
                        "latitude": "11.96817000",
                        "longitude": "121.92021000"
                    },
                    {
                        "id": 83388,
                        "name": "Malabor",
                        "latitude": "11.27292000",
                        "longitude": "122.04661000"
                    },
                    {
                        "id": 83403,
                        "name": "Malangabang",
                        "latitude": "11.23670000",
                        "longitude": "123.20620000"
                    },
                    {
                        "id": 83419,
                        "name": "Malayo-an",
                        "latitude": "11.09790000",
                        "longitude": "123.00910000"
                    },
                    {
                        "id": 83451,
                        "name": "Malocloc",
                        "latitude": "11.50583000",
                        "longitude": "122.67833000"
                    },
                    {
                        "id": 83452,
                        "name": "Maloco",
                        "latitude": "11.78320000",
                        "longitude": "122.15200000"
                    },
                    {
                        "id": 83470,
                        "name": "Mambagatan",
                        "latitude": "10.10930000",
                        "longitude": "122.88820000"
                    },
                    {
                        "id": 83486,
                        "name": "Manalad",
                        "latitude": "10.00560000",
                        "longitude": "122.77690000"
                    },
                    {
                        "id": 83518,
                        "name": "Mangoso",
                        "latitude": "11.41750000",
                        "longitude": "122.63820000"
                    },
                    {
                        "id": 83522,
                        "name": "Manika",
                        "latitude": "11.38801000",
                        "longitude": "122.27931000"
                    },
                    {
                        "id": 83527,
                        "name": "Manjoy",
                        "latitude": "11.35340000",
                        "longitude": "122.66630000"
                    },
                    {
                        "id": 83529,
                        "name": "Manlucahoc",
                        "latitude": "9.73990000",
                        "longitude": "122.49800000"
                    },
                    {
                        "id": 83530,
                        "name": "Manoc-Manoc",
                        "latitude": "11.94157000",
                        "longitude": "121.94281000"
                    },
                    {
                        "id": 83535,
                        "name": "Mansilingan",
                        "latitude": "10.63111000",
                        "longitude": "122.97889000"
                    },
                    {
                        "id": 83546,
                        "name": "Manup",
                        "latitude": "11.53150000",
                        "longitude": "122.49800000"
                    },
                    {
                        "id": 83553,
                        "name": "Mapili",
                        "latitude": "11.10810000",
                        "longitude": "122.73930000"
                    },
                    {
                        "id": 83559,
                        "name": "Maquiling",
                        "latitude": "10.78094000",
                        "longitude": "123.39380000"
                    },
                    {
                        "id": 83568,
                        "name": "Marawis",
                        "latitude": "10.24530000",
                        "longitude": "122.88690000"
                    },
                    {
                        "id": 83579,
                        "name": "Maribong",
                        "latitude": "11.10000000",
                        "longitude": "122.53333000"
                    },
                    {
                        "id": 83581,
                        "name": "Maricalom",
                        "latitude": "9.70490000",
                        "longitude": "122.41880000"
                    },
                    {
                        "id": 83592,
                        "name": "Masaling",
                        "latitude": "9.98180000",
                        "longitude": "122.53690000"
                    },
                    {
                        "id": 83609,
                        "name": "Masonogan",
                        "latitude": "11.36860000",
                        "longitude": "122.67530000"
                    },
                    {
                        "id": 83667,
                        "name": "Mianay",
                        "latitude": "11.47160000",
                        "longitude": "122.70110000"
                    },
                    {
                        "id": 83682,
                        "name": "Minapasoc",
                        "latitude": "10.69885000",
                        "longitude": "123.34900000"
                    },
                    {
                        "id": 83689,
                        "name": "Minuyan",
                        "latitude": "10.51366000",
                        "longitude": "123.10490000"
                    },
                    {
                        "id": 83690,
                        "name": "Miranda",
                        "latitude": "10.30470000",
                        "longitude": "122.87780000"
                    },
                    {
                        "id": 83703,
                        "name": "Monpon",
                        "latitude": "10.91194000",
                        "longitude": "122.63778000"
                    },
                    {
                        "id": 83708,
                        "name": "Montilla",
                        "latitude": "10.20270000",
                        "longitude": "122.92610000"
                    },
                    {
                        "id": 83710,
                        "name": "Morales",
                        "latitude": "11.54560000",
                        "longitude": "122.37640000"
                    },
                    {
                        "id": 83712,
                        "name": "Morobuan",
                        "latitude": "10.62566000",
                        "longitude": "122.55470000"
                    },
                    {
                        "id": 83738,
                        "name": "Nabulao",
                        "latitude": "9.66160000",
                        "longitude": "122.45770000"
                    },
                    {
                        "id": 83758,
                        "name": "Naili",
                        "latitude": "11.76660000",
                        "longitude": "122.17650000"
                    },
                    {
                        "id": 83760,
                        "name": "Naisud",
                        "latitude": "11.80580000",
                        "longitude": "122.19390000"
                    },
                    {
                        "id": 83774,
                        "name": "Nangka",
                        "latitude": "10.85564000",
                        "longitude": "123.03590000"
                    },
                    {
                        "id": 83777,
                        "name": "Napnapan",
                        "latitude": "10.70845000",
                        "longitude": "122.39300000"
                    },
                    {
                        "id": 83778,
                        "name": "Napoles",
                        "latitude": "10.50400000",
                        "longitude": "122.89790000"
                    },
                    {
                        "id": 83787,
                        "name": "Nato",
                        "latitude": "10.14920000",
                        "longitude": "122.86190000"
                    },
                    {
                        "id": 83810,
                        "name": "New Pandanon",
                        "latitude": "10.55696000",
                        "longitude": "123.14750000"
                    },
                    {
                        "id": 83839,
                        "name": "Ochanado",
                        "latitude": "11.61390000",
                        "longitude": "122.48330000"
                    },
                    {
                        "id": 83843,
                        "name": "Odiong",
                        "latitude": "10.28580000",
                        "longitude": "123.05260000"
                    },
                    {
                        "id": 83848,
                        "name": "Ogtongon",
                        "latitude": "10.77334000",
                        "longitude": "123.52000000"
                    },
                    {
                        "id": 83854,
                        "name": "Ondoy",
                        "latitude": "11.81917000",
                        "longitude": "122.12611000"
                    },
                    {
                        "id": 83856,
                        "name": "Oracon",
                        "latitude": "10.47820000",
                        "longitude": "122.58390000"
                    },
                    {
                        "id": 83861,
                        "name": "Orong",
                        "latitude": "9.93730000",
                        "longitude": "122.82900000"
                    },
                    {
                        "id": 83875,
                        "name": "Pacol",
                        "latitude": "10.45000000",
                        "longitude": "122.81667000"
                    },
                    {
                        "id": 83905,
                        "name": "Pakiad",
                        "latitude": "10.71278000",
                        "longitude": "122.52417000"
                    },
                    {
                        "id": 83911,
                        "name": "Palampas",
                        "latitude": "10.52506000",
                        "longitude": "123.42080000"
                    },
                    {
                        "id": 83954,
                        "name": "Panayacan",
                        "latitude": "11.76030000",
                        "longitude": "122.22360000"
                    },
                    {
                        "id": 83962,
                        "name": "Pandan",
                        "latitude": "11.71950000",
                        "longitude": "122.09490000"
                    },
                    {
                        "id": 84015,
                        "name": "Paraiso",
                        "latitude": "10.88490000",
                        "longitude": "123.36270000"
                    },
                    {
                        "id": 84024,
                        "name": "Parion",
                        "latitude": "11.47480000",
                        "longitude": "122.69720000"
                    },
                    {
                        "id": 84031,
                        "name": "Pasil",
                        "latitude": "10.83780000",
                        "longitude": "122.60980000"
                    },
                    {
                        "id": 84045,
                        "name": "Patique",
                        "latitude": "10.23700000",
                        "longitude": "122.89930000"
                    },
                    {
                        "id": 84047,
                        "name": "Patnongon",
                        "latitude": "10.91320000",
                        "longitude": "121.99370000"
                    },
                    {
                        "id": 84049,
                        "name": "Patonan",
                        "latitude": "10.56816000",
                        "longitude": "123.47230000"
                    },
                    {
                        "id": 84052,
                        "name": "Patria",
                        "latitude": "11.74030000",
                        "longitude": "122.01710000"
                    },
                    {
                        "id": 84059,
                        "name": "Pawa",
                        "latitude": "11.56285000",
                        "longitude": "122.81736000"
                    },
                    {
                        "id": 84067,
                        "name": "Payao",
                        "latitude": "10.17850000",
                        "longitude": "122.92360000"
                    },
                    {
                        "id": 84080,
                        "name": "Piape I",
                        "latitude": "10.72880000",
                        "longitude": "121.97240000"
                    },
                    {
                        "id": 84125,
                        "name": "Piña",
                        "latitude": "10.63956000",
                        "longitude": "122.63820000"
                    },
                    {
                        "id": 84136,
                        "name": "Platagata",
                        "latitude": "11.30300000",
                        "longitude": "123.15670000"
                    },
                    {
                        "id": 84148,
                        "name": "Polo",
                        "latitude": "11.58440000",
                        "longitude": "122.31220000"
                    },
                    {
                        "id": 84155,
                        "name": "Polopina",
                        "latitude": "11.20680000",
                        "longitude": "123.16590000"
                    },
                    {
                        "id": 84158,
                        "name": "Ponong",
                        "latitude": "11.08290000",
                        "longitude": "122.62610000"
                    },
                    {
                        "id": 84179,
                        "name": "Prosperidad",
                        "latitude": "10.51596000",
                        "longitude": "123.30850000"
                    },
                    {
                        "id": 84184,
                        "name": "Province of Aklan",
                        "latitude": "11.66667000",
                        "longitude": "122.33333000"
                    },
                    {
                        "id": 84186,
                        "name": "Province of Antique",
                        "latitude": "11.16667000",
                        "longitude": "122.08333000"
                    },
                    {
                        "id": 84199,
                        "name": "Province of Capiz",
                        "latitude": "11.40000000",
                        "longitude": "122.56667000"
                    },
                    {
                        "id": 84208,
                        "name": "Province of Guimaras",
                        "latitude": "10.58092000",
                        "longitude": "122.62621000"
                    },
                    {
                        "id": 84212,
                        "name": "Province of Iloilo",
                        "latitude": "11.00000000",
                        "longitude": "122.66667000"
                    },
                    {
                        "id": 84226,
                        "name": "Province of Negros Occidental",
                        "latitude": "10.41667000",
                        "longitude": "123.00000000"
                    },
                    {
                        "id": 84274,
                        "name": "Punao",
                        "latitude": "10.56516000",
                        "longitude": "123.40800000"
                    },
                    {
                        "id": 84297,
                        "name": "Quezon",
                        "latitude": "10.43617000",
                        "longitude": "123.26040000"
                    },
                    {
                        "id": 84307,
                        "name": "Quinagaringan",
                        "latitude": "11.12220000",
                        "longitude": "122.58750000"
                    },
                    {
                        "id": 84312,
                        "name": "Quipot",
                        "latitude": "11.28333000",
                        "longitude": "123.00000000"
                    },
                    {
                        "id": 84346,
                        "name": "Rizal",
                        "latitude": "10.88070000",
                        "longitude": "123.41780000"
                    },
                    {
                        "id": 84383,
                        "name": "Sagang",
                        "latitude": "10.36120000",
                        "longitude": "123.07220000"
                    },
                    {
                        "id": 84385,
                        "name": "Sagasa",
                        "latitude": "10.46800000",
                        "longitude": "122.89390000"
                    },
                    {
                        "id": 84400,
                        "name": "Salamanca",
                        "latitude": "10.74655000",
                        "longitude": "123.53000000"
                    },
                    {
                        "id": 84417,
                        "name": "Salvacion",
                        "latitude": "10.68333000",
                        "longitude": "122.61667000"
                    },
                    {
                        "id": 84451,
                        "name": "San Antonio",
                        "latitude": "10.80000000",
                        "longitude": "122.45000000"
                    },
                    {
                        "id": 84511,
                        "name": "San Joaquin",
                        "latitude": "10.58800000",
                        "longitude": "122.13970000"
                    },
                    {
                        "id": 84527,
                        "name": "San Juan",
                        "latitude": "10.38650000",
                        "longitude": "122.86510000"
                    },
                    {
                        "id": 84583,
                        "name": "San Pedro",
                        "latitude": "10.80180000",
                        "longitude": "121.94990000"
                    },
                    {
                        "id": 84594,
                        "name": "San Rafael",
                        "latitude": "11.17810000",
                        "longitude": "122.82730000"
                    },
                    {
                        "id": 84601,
                        "name": "San Remigio",
                        "latitude": "10.83278000",
                        "longitude": "122.08750000"
                    },
                    {
                        "id": 84611,
                        "name": "San Salvador",
                        "latitude": "11.00278000",
                        "longitude": "122.83528000"
                    },
                    {
                        "id": 84642,
                        "name": "Santa Angel",
                        "latitude": "11.30680000",
                        "longitude": "122.64080000"
                    },
                    {
                        "id": 84663,
                        "name": "Santa Cruz",
                        "latitude": "10.63376000",
                        "longitude": "123.08210000"
                    },
                    {
                        "id": 84703,
                        "name": "Santa Teresa",
                        "latitude": "10.58546000",
                        "longitude": "122.56040000"
                    },
                    {
                        "id": 84711,
                        "name": "Santiago",
                        "latitude": "11.05806000",
                        "longitude": "122.91167000"
                    },
                    {
                        "id": 84750,
                        "name": "Saravia",
                        "latitude": "10.87754000",
                        "longitude": "122.96770000"
                    },
                    {
                        "id": 84756,
                        "name": "Sebaste",
                        "latitude": "11.59010000",
                        "longitude": "122.09450000"
                    },
                    {
                        "id": 84757,
                        "name": "Semirara",
                        "latitude": "12.06967000",
                        "longitude": "121.39861000"
                    },
                    {
                        "id": 84769,
                        "name": "Sibaguan",
                        "latitude": "11.55778000",
                        "longitude": "122.71389000"
                    },
                    {
                        "id": 84770,
                        "name": "Sibalom",
                        "latitude": "10.79000000",
                        "longitude": "122.01780000"
                    },
                    {
                        "id": 84772,
                        "name": "Sibucao",
                        "latitude": "10.41790000",
                        "longitude": "122.88700000"
                    },
                    {
                        "id": 84852,
                        "name": "Suay",
                        "latitude": "10.05330000",
                        "longitude": "122.84230000"
                    },
                    {
                        "id": 84867,
                        "name": "Sulangan",
                        "latitude": "10.83000000",
                        "longitude": "122.69000000"
                    },
                    {
                        "id": 84874,
                        "name": "Sumag",
                        "latitude": "10.60139000",
                        "longitude": "122.91924000"
                    },
                    {
                        "id": 84910,
                        "name": "Tabu",
                        "latitude": "9.89230000",
                        "longitude": "122.70980000"
                    },
                    {
                        "id": 84913,
                        "name": "Tabuc Pontevedra",
                        "latitude": "11.48333000",
                        "longitude": "122.81667000"
                    },
                    {
                        "id": 84960,
                        "name": "Talaban",
                        "latitude": "10.12540000",
                        "longitude": "122.86710000"
                    },
                    {
                        "id": 84979,
                        "name": "Talisay",
                        "latitude": "10.73750000",
                        "longitude": "122.96660000"
                    },
                    {
                        "id": 84989,
                        "name": "Taloc",
                        "latitude": "10.57460000",
                        "longitude": "122.89540000"
                    },
                    {
                        "id": 84990,
                        "name": "Talokgañgan",
                        "latitude": "11.00778000",
                        "longitude": "122.84500000"
                    },
                    {
                        "id": 84992,
                        "name": "Talon",
                        "latitude": "11.56000000",
                        "longitude": "122.68111000"
                    },
                    {
                        "id": 85004,
                        "name": "Tambac",
                        "latitude": "11.67050000",
                        "longitude": "122.41120000"
                    },
                    {
                        "id": 85007,
                        "name": "Tambalisa",
                        "latitude": "11.26980000",
                        "longitude": "123.16500000"
                    },
                    {
                        "id": 85017,
                        "name": "Tamlang",
                        "latitude": "10.82544000",
                        "longitude": "123.45410000"
                    },
                    {
                        "id": 85047,
                        "name": "Tapas",
                        "latitude": "11.26130000",
                        "longitude": "122.53640000"
                    },
                    {
                        "id": 85059,
                        "name": "Tarong",
                        "latitude": "11.53140000",
                        "longitude": "123.13200000"
                    },
                    {
                        "id": 85095,
                        "name": "Tibiao",
                        "latitude": "11.29152000",
                        "longitude": "122.03541000"
                    },
                    {
                        "id": 85108,
                        "name": "Tiglauigan",
                        "latitude": "10.95270000",
                        "longitude": "123.35750000"
                    },
                    {
                        "id": 85118,
                        "name": "Tigum",
                        "latitude": "10.78333000",
                        "longitude": "122.56667000"
                    },
                    {
                        "id": 85121,
                        "name": "Tiling",
                        "latitude": "9.97360000",
                        "longitude": "122.65440000"
                    },
                    {
                        "id": 85123,
                        "name": "Timpas",
                        "latitude": "11.47900000",
                        "longitude": "122.73240000"
                    },
                    {
                        "id": 85138,
                        "name": "Tinogboc",
                        "latitude": "12.00737000",
                        "longitude": "121.41221000"
                    },
                    {
                        "id": 85139,
                        "name": "Tinongan",
                        "latitude": "10.21500000",
                        "longitude": "123.03528000"
                    },
                    {
                        "id": 85147,
                        "name": "Tiring",
                        "latitude": "10.85000000",
                        "longitude": "122.50670000"
                    },
                    {
                        "id": 85150,
                        "name": "Tiwi",
                        "latitude": "10.92972000",
                        "longitude": "122.73417000"
                    },
                    {
                        "id": 85151,
                        "name": "Tobias Fornier",
                        "latitude": "10.51500000",
                        "longitude": "121.94610000"
                    },
                    {
                        "id": 85173,
                        "name": "Tortosa",
                        "latitude": "10.93294000",
                        "longitude": "123.09000000"
                    },
                    {
                        "id": 85177,
                        "name": "Trapiche",
                        "latitude": "10.68417000",
                        "longitude": "122.43222000"
                    },
                    {
                        "id": 85207,
                        "name": "Tugas",
                        "latitude": "11.61300000",
                        "longitude": "122.38220000"
                    },
                    {
                        "id": 85224,
                        "name": "Tumcon Ilawod",
                        "latitude": "10.91667000",
                        "longitude": "122.66667000"
                    },
                    {
                        "id": 85238,
                        "name": "Tuyum",
                        "latitude": "9.97690000",
                        "longitude": "122.55820000"
                    },
                    {
                        "id": 85240,
                        "name": "Ualog",
                        "latitude": "10.57396000",
                        "longitude": "123.39330000"
                    },
                    {
                        "id": 85252,
                        "name": "Ungca",
                        "latitude": "10.75000000",
                        "longitude": "122.55000000"
                    },
                    {
                        "id": 85255,
                        "name": "Unidos",
                        "latitude": "11.90677000",
                        "longitude": "122.00051000"
                    },
                    {
                        "id": 85257,
                        "name": "Union",
                        "latitude": "11.76120000",
                        "longitude": "121.89630000"
                    },
                    {
                        "id": 85275,
                        "name": "Valderrama",
                        "latitude": "11.40591000",
                        "longitude": "122.08371000"
                    },
                    {
                        "id": 85287,
                        "name": "Viejo Daan Banua",
                        "latitude": "10.90354000",
                        "longitude": "123.05970000"
                    },
                    {
                        "id": 85307,
                        "name": "Vista Alegre",
                        "latitude": "9.99840000",
                        "longitude": "122.76630000"
                    },
                    {
                        "id": 85309,
                        "name": "Vito",
                        "latitude": "10.90310000",
                        "longitude": "123.51540000"
                    },
                    {
                        "id": 85318,
                        "name": "Yapak",
                        "latitude": "11.95000000",
                        "longitude": "121.93333000"
                    },
                    {
                        "id": 85321,
                        "name": "Yubo",
                        "latitude": "10.38960000",
                        "longitude": "123.06900000"
                    }
                ]
            },
            {
                "id": 1334,
                "name": "Apayao",
                "iso2": "APA",
                "latitude": "18.01203040",
                "longitude": "121.17103890",
                "type": "province",
                "cities": [
                    {
                        "id": 144793,
                        "name": "Calanasan",
                        "latitude": "18.25797860",
                        "longitude": "120.71187320"
                    },
                    {
                        "id": 144795,
                        "name": "Conner",
                        "latitude": "17.77495440",
                        "longitude": "121.09925090"
                    },
                    {
                        "id": 144801,
                        "name": "Flora",
                        "latitude": "18.11880180",
                        "longitude": "121.24518720"
                    },
                    {
                        "id": 144810,
                        "name": "Kabugao",
                        "latitude": "18.02643240",
                        "longitude": "120.82603070"
                    },
                    {
                        "id": 144829,
                        "name": "Luna",
                        "latitude": "18.34990020",
                        "longitude": "121.09053910"
                    },
                    {
                        "id": 144845,
                        "name": "Pudtol",
                        "latitude": "18.13808910",
                        "longitude": "121.15094510"
                    },
                    {
                        "id": 144857,
                        "name": "Santa Marcela",
                        "latitude": "18.29320640",
                        "longitude": "121.39907490"
                    }
                ]
            },
            {
                "id": 1341,
                "name": "Aurora",
                "iso2": "AUR",
                "latitude": "36.97089100",
                "longitude": "-93.71797900",
                "type": "province",
                "cities": [
                    {
                        "id": 145371,
                        "name": "Baler",
                        "latitude": "15.75232690",
                        "longitude": "121.48904400"
                    },
                    {
                        "id": 82192,
                        "name": "Casiguran",
                        "latitude": "16.20941190",
                        "longitude": "121.89393840"
                    },
                    {
                        "id": 145472,
                        "name": "Dilasag",
                        "latitude": "16.43307200",
                        "longitude": "121.96135840"
                    },
                    {
                        "id": 154486,
                        "name": "Dinalungan",
                        "latitude": "16.17637530",
                        "longitude": "121.69571240"
                    },
                    {
                        "id": 145476,
                        "name": "Dingalan",
                        "latitude": "15.24142080",
                        "longitude": "121.23377160"
                    },
                    {
                        "id": 145477,
                        "name": "Dipaculao",
                        "latitude": "15.98420820",
                        "longitude": "121.45942050"
                    },
                    {
                        "id": 145556,
                        "name": "Maria Aurora",
                        "latitude": "15.80140630",
                        "longitude": "121.23728000"
                    },
                    {
                        "id": 144280,
                        "name": "San Luis",
                        "latitude": "15.62334310",
                        "longitude": "121.30140620"
                    }
                ]
            },
            {
                "id": 1316,
                "name": "Autonomous Region in Muslim Mindanao",
                "iso2": "14",
                "latitude": "6.95683130",
                "longitude": "124.24215970",
                "type": "region",
                "cities": [
                    {
                        "id": 81260,
                        "name": "Andalan",
                        "latitude": "5.95944000",
                        "longitude": "121.39028000"
                    },
                    {
                        "id": 81289,
                        "name": "Anuling",
                        "latitude": "6.03556000",
                        "longitude": "121.00667000"
                    },
                    {
                        "id": 81339,
                        "name": "Awang",
                        "latitude": "7.15306000",
                        "longitude": "124.22111000"
                    },
                    {
                        "id": 81356,
                        "name": "Bacayawan",
                        "latitude": "7.76667000",
                        "longitude": "124.23333000"
                    },
                    {
                        "id": 81379,
                        "name": "Badak",
                        "latitude": "6.84722000",
                        "longitude": "124.72056000"
                    },
                    {
                        "id": 81392,
                        "name": "Bagan",
                        "latitude": "6.92556000",
                        "longitude": "124.42028000"
                    },
                    {
                        "id": 81424,
                        "name": "Baka",
                        "latitude": "7.27611000",
                        "longitude": "124.26417000"
                    },
                    {
                        "id": 81427,
                        "name": "Bakung",
                        "latitude": "4.89111000",
                        "longitude": "119.79417000"
                    },
                    {
                        "id": 81449,
                        "name": "Balas",
                        "latitude": "6.68750000",
                        "longitude": "122.13806000"
                    },
                    {
                        "id": 81472,
                        "name": "Balimbing",
                        "latitude": "5.08250000",
                        "longitude": "119.96583000"
                    },
                    {
                        "id": 81531,
                        "name": "Bangkal",
                        "latitude": "6.06667000",
                        "longitude": "121.06667000"
                    },
                    {
                        "id": 81542,
                        "name": "Bankaw",
                        "latitude": "5.01920000",
                        "longitude": "120.00910000"
                    },
                    {
                        "id": 81590,
                        "name": "Barurao",
                        "latitude": "6.89806000",
                        "longitude": "124.59750000"
                    },
                    {
                        "id": 81631,
                        "name": "Bato Bato",
                        "latitude": "6.03440000",
                        "longitude": "120.94630000"
                    },
                    {
                        "id": 81646,
                        "name": "Baunu-Timbangan",
                        "latitude": "6.00547000",
                        "longitude": "120.99406000"
                    },
                    {
                        "id": 81649,
                        "name": "Bawison",
                        "latitude": "5.93750000",
                        "longitude": "120.87450000"
                    },
                    {
                        "id": 81657,
                        "name": "Bayanga",
                        "latitude": "7.52139000",
                        "longitude": "124.25222000"
                    },
                    {
                        "id": 81675,
                        "name": "Begang",
                        "latitude": "6.69090000",
                        "longitude": "122.01680000"
                    },
                    {
                        "id": 81730,
                        "name": "Binuang",
                        "latitude": "5.95694000",
                        "longitude": "121.06000000"
                    },
                    {
                        "id": 81751,
                        "name": "Blinsung",
                        "latitude": "7.01806000",
                        "longitude": "124.18056000"
                    },
                    {
                        "id": 81790,
                        "name": "Bongued",
                        "latitude": "7.11667000",
                        "longitude": "124.40000000"
                    },
                    {
                        "id": 81817,
                        "name": "Bualan",
                        "latitude": "7.75000000",
                        "longitude": "124.26667000"
                    },
                    {
                        "id": 81818,
                        "name": "Buan",
                        "latitude": "5.16080000",
                        "longitude": "120.04260000"
                    },
                    {
                        "id": 81821,
                        "name": "Buansa",
                        "latitude": "6.02580000",
                        "longitude": "120.96140000"
                    },
                    {
                        "id": 81826,
                        "name": "Budta",
                        "latitude": "7.20417000",
                        "longitude": "124.43972000"
                    },
                    {
                        "id": 81843,
                        "name": "Bugasan",
                        "latitude": "7.44083000",
                        "longitude": "124.25917000"
                    },
                    {
                        "id": 81876,
                        "name": "Buliok",
                        "latitude": "7.01667000",
                        "longitude": "124.70000000"
                    },
                    {
                        "id": 81879,
                        "name": "Bulit",
                        "latitude": "7.11528000",
                        "longitude": "124.78944000"
                    },
                    {
                        "id": 81891,
                        "name": "Bumbaran",
                        "latitude": "7.80000000",
                        "longitude": "124.65000000"
                    },
                    {
                        "id": 82245,
                        "name": "City of Isabela",
                        "latitude": "6.70407000",
                        "longitude": "121.97117000"
                    },
                    {
                        "id": 82262,
                        "name": "Colonia",
                        "latitude": "6.64361000",
                        "longitude": "122.15750000"
                    },
                    {
                        "id": 82302,
                        "name": "Cotabato",
                        "latitude": "7.22361000",
                        "longitude": "124.24639000"
                    },
                    {
                        "id": 82329,
                        "name": "Dado",
                        "latitude": "7.05000000",
                        "longitude": "124.45972000"
                    },
                    {
                        "id": 82330,
                        "name": "Dadus",
                        "latitude": "7.05750000",
                        "longitude": "124.32167000"
                    },
                    {
                        "id": 82347,
                        "name": "Dalican",
                        "latitude": "6.96667000",
                        "longitude": "124.40000000"
                    },
                    {
                        "id": 82353,
                        "name": "Dalumangcob",
                        "latitude": "7.21667000",
                        "longitude": "124.30000000"
                    },
                    {
                        "id": 82357,
                        "name": "Damabalas",
                        "latitude": "7.01556000",
                        "longitude": "124.51417000"
                    },
                    {
                        "id": 82358,
                        "name": "Damatulan",
                        "latitude": "7.03889000",
                        "longitude": "124.48278000"
                    },
                    {
                        "id": 82422,
                        "name": "Digal",
                        "latitude": "6.75306000",
                        "longitude": "124.79639000"
                    },
                    {
                        "id": 82436,
                        "name": "Dinaig",
                        "latitude": "7.02556000",
                        "longitude": "124.31500000"
                    },
                    {
                        "id": 82439,
                        "name": "Dinganen",
                        "latitude": "7.32833000",
                        "longitude": "124.37833000"
                    },
                    {
                        "id": 82500,
                        "name": "Ebcor Town",
                        "latitude": "7.44056000",
                        "longitude": "124.39722000"
                    },
                    {
                        "id": 82552,
                        "name": "Gadung",
                        "latitude": "6.80250000",
                        "longitude": "124.02000000"
                    },
                    {
                        "id": 82564,
                        "name": "Gang",
                        "latitude": "7.24583000",
                        "longitude": "124.26639000"
                    },
                    {
                        "id": 82643,
                        "name": "Guiong",
                        "latitude": "6.41861000",
                        "longitude": "122.02583000"
                    },
                    {
                        "id": 82714,
                        "name": "Idtig",
                        "latitude": "6.79889000",
                        "longitude": "124.77278000"
                    },
                    {
                        "id": 82825,
                        "name": "Kabasalan",
                        "latitude": "7.06667000",
                        "longitude": "124.65000000"
                    },
                    {
                        "id": 82836,
                        "name": "Kagay",
                        "latitude": "6.00880000",
                        "longitude": "120.90740000"
                    },
                    {
                        "id": 82837,
                        "name": "Kajatian",
                        "latitude": "6.03111000",
                        "longitude": "120.99194000"
                    },
                    {
                        "id": 82842,
                        "name": "Kalang",
                        "latitude": "5.91972000",
                        "longitude": "121.36306000"
                    },
                    {
                        "id": 82847,
                        "name": "Kalbugan",
                        "latitude": "6.95972000",
                        "longitude": "124.65917000"
                    },
                    {
                        "id": 82858,
                        "name": "Kambing",
                        "latitude": "5.94646000",
                        "longitude": "121.30757000"
                    },
                    {
                        "id": 82862,
                        "name": "Kanlagay",
                        "latitude": "5.87568000",
                        "longitude": "121.29146000"
                    },
                    {
                        "id": 82864,
                        "name": "Kansipati",
                        "latitude": "6.00111000",
                        "longitude": "121.23444000"
                    },
                    {
                        "id": 82874,
                        "name": "Karungdong",
                        "latitude": "5.88440000",
                        "longitude": "121.26300000"
                    },
                    {
                        "id": 82877,
                        "name": "Katico",
                        "latitude": "6.76015000",
                        "longitude": "124.73214000"
                    },
                    {
                        "id": 82878,
                        "name": "Katidtuan",
                        "latitude": "7.18861000",
                        "longitude": "124.31528000"
                    },
                    {
                        "id": 82882,
                        "name": "Katuli",
                        "latitude": "7.43333000",
                        "longitude": "124.21667000"
                    },
                    {
                        "id": 82884,
                        "name": "Kauran",
                        "latitude": "6.79454000",
                        "longitude": "124.47034000"
                    },
                    {
                        "id": 82915,
                        "name": "Kitango",
                        "latitude": "6.94833000",
                        "longitude": "124.44111000"
                    },
                    {
                        "id": 82917,
                        "name": "Kitapak",
                        "latitude": "6.95333000",
                        "longitude": "124.42556000"
                    },
                    {
                        "id": 82923,
                        "name": "Kolape",
                        "latitude": "5.07028000",
                        "longitude": "119.89694000"
                    },
                    {
                        "id": 82930,
                        "name": "Kulase",
                        "latitude": "5.90520000",
                        "longitude": "120.95690000"
                    },
                    {
                        "id": 82931,
                        "name": "Kulay-Kulay",
                        "latitude": "5.94528000",
                        "longitude": "121.23250000"
                    },
                    {
                        "id": 82932,
                        "name": "Kulempang",
                        "latitude": "7.51944000",
                        "longitude": "124.38972000"
                    },
                    {
                        "id": 82935,
                        "name": "Kungtad",
                        "latitude": "5.55720000",
                        "longitude": "120.84720000"
                    },
                    {
                        "id": 82967,
                        "name": "Labuñgan",
                        "latitude": "7.10306000",
                        "longitude": "124.23500000"
                    },
                    {
                        "id": 83000,
                        "name": "Laminusa",
                        "latitude": "5.55490000",
                        "longitude": "120.91360000"
                    },
                    {
                        "id": 83003,
                        "name": "Lamitan City",
                        "latitude": "6.65020000",
                        "longitude": "122.12952000"
                    },
                    {
                        "id": 83015,
                        "name": "Langpas",
                        "latitude": "5.97500000",
                        "longitude": "120.94900000"
                    },
                    {
                        "id": 83042,
                        "name": "Larap",
                        "latitude": "4.76154000",
                        "longitude": "119.40511000"
                    },
                    {
                        "id": 83048,
                        "name": "Latung",
                        "latitude": "5.50000000",
                        "longitude": "120.88333000"
                    },
                    {
                        "id": 83057,
                        "name": "Layog",
                        "latitude": "7.07667000",
                        "longitude": "124.73056000"
                    },
                    {
                        "id": 83107,
                        "name": "Ligayan",
                        "latitude": "4.65442000",
                        "longitude": "119.47062000"
                    },
                    {
                        "id": 83121,
                        "name": "Limbo",
                        "latitude": "7.25167000",
                        "longitude": "124.24389000"
                    },
                    {
                        "id": 83150,
                        "name": "Litayan",
                        "latitude": "7.33583000",
                        "longitude": "124.03472000"
                    },
                    {
                        "id": 83174,
                        "name": "Lookan",
                        "latitude": "5.03700000",
                        "longitude": "120.10270000"
                    },
                    {
                        "id": 83190,
                        "name": "Lu-uk",
                        "latitude": "5.96840000",
                        "longitude": "121.31220000"
                    },
                    {
                        "id": 83216,
                        "name": "Lumbac",
                        "latitude": "7.73417000",
                        "longitude": "124.25278000"
                    },
                    {
                        "id": 83252,
                        "name": "Luuk Datan",
                        "latitude": "4.81194000",
                        "longitude": "119.84528000"
                    },
                    {
                        "id": 83324,
                        "name": "Maganoy",
                        "latitude": "6.86472000",
                        "longitude": "124.44167000"
                    },
                    {
                        "id": 83356,
                        "name": "Mahala",
                        "latitude": "5.91667000",
                        "longitude": "121.13333000"
                    },
                    {
                        "id": 83378,
                        "name": "Makir",
                        "latitude": "7.03083000",
                        "longitude": "124.30417000"
                    },
                    {
                        "id": 83463,
                        "name": "Maluso",
                        "latitude": "6.54300000",
                        "longitude": "121.87530000"
                    },
                    {
                        "id": 83542,
                        "name": "Manubul",
                        "latitude": "5.47320000",
                        "longitude": "120.79860000"
                    },
                    {
                        "id": 83544,
                        "name": "Manuk Mangkaw",
                        "latitude": "4.80000000",
                        "longitude": "119.85000000"
                    },
                    {
                        "id": 83567,
                        "name": "Marawi City",
                        "latitude": "8.00340000",
                        "longitude": "124.28395000"
                    },
                    {
                        "id": 83588,
                        "name": "Marsada",
                        "latitude": "5.93139000",
                        "longitude": "121.10694000"
                    },
                    {
                        "id": 83621,
                        "name": "Mataya",
                        "latitude": "7.47111000",
                        "longitude": "124.37194000"
                    },
                    {
                        "id": 83636,
                        "name": "Mauboh",
                        "latitude": "5.99000000",
                        "longitude": "121.09361000"
                    },
                    {
                        "id": 83673,
                        "name": "Mileb",
                        "latitude": "6.89861000",
                        "longitude": "124.58389000"
                    },
                    {
                        "id": 83802,
                        "name": "New Batu Batu",
                        "latitude": "5.06667000",
                        "longitude": "119.88333000"
                    },
                    {
                        "id": 83833,
                        "name": "Nuyo",
                        "latitude": "7.41806000",
                        "longitude": "124.41083000"
                    },
                    {
                        "id": 83892,
                        "name": "Pagatin",
                        "latitude": "6.97306000",
                        "longitude": "124.47528000"
                    },
                    {
                        "id": 83901,
                        "name": "Paitan",
                        "latitude": "6.66005000",
                        "longitude": "124.87183000"
                    },
                    {
                        "id": 83944,
                        "name": "Panabuan",
                        "latitude": "5.96160000",
                        "longitude": "120.96270000"
                    },
                    {
                        "id": 83946,
                        "name": "Panadtaban",
                        "latitude": "6.90083000",
                        "longitude": "124.64278000"
                    },
                    {
                        "id": 83959,
                        "name": "Pandakan",
                        "latitude": "5.98889000",
                        "longitude": "121.16583000"
                    },
                    {
                        "id": 83963,
                        "name": "Pandan Niog",
                        "latitude": "6.22820000",
                        "longitude": "120.56310000"
                    },
                    {
                        "id": 83967,
                        "name": "Pang",
                        "latitude": "5.94837000",
                        "longitude": "121.28830000"
                    },
                    {
                        "id": 84020,
                        "name": "Parangan",
                        "latitude": "5.08389000",
                        "longitude": "119.93833000"
                    },
                    {
                        "id": 84021,
                        "name": "Parian Dakula",
                        "latitude": "5.55667000",
                        "longitude": "120.77194000"
                    },
                    {
                        "id": 84061,
                        "name": "Pawak",
                        "latitude": "8.01634000",
                        "longitude": "124.25647000"
                    },
                    {
                        "id": 84071,
                        "name": "Payuhan",
                        "latitude": "5.94167000",
                        "longitude": "120.90111000"
                    },
                    {
                        "id": 84085,
                        "name": "Pidsandawan",
                        "latitude": "6.93222000",
                        "longitude": "124.59083000"
                    },
                    {
                        "id": 84107,
                        "name": "Pinaring",
                        "latitude": "7.22889000",
                        "longitude": "124.31056000"
                    },
                    {
                        "id": 84146,
                        "name": "Polloc",
                        "latitude": "7.35340000",
                        "longitude": "124.22088000"
                    },
                    {
                        "id": 84188,
                        "name": "Province of Basilan",
                        "latitude": "6.54729000",
                        "longitude": "122.11853000"
                    },
                    {
                        "id": 84217,
                        "name": "Province of Lanao del Sur",
                        "latitude": "7.85250000",
                        "longitude": "124.45862000"
                    },
                    {
                        "id": 84219,
                        "name": "Province of Maguindanao",
                        "latitude": "7.13333000",
                        "longitude": "124.30000000"
                    },
                    {
                        "id": 84245,
                        "name": "Province of Sulu",
                        "latitude": "6.00000000",
                        "longitude": "121.00000000"
                    },
                    {
                        "id": 84249,
                        "name": "Province of Tawi-Tawi",
                        "latitude": "5.20570000",
                        "longitude": "120.02650000"
                    },
                    {
                        "id": 84275,
                        "name": "Punay",
                        "latitude": "5.96139000",
                        "longitude": "121.19806000"
                    },
                    {
                        "id": 84322,
                        "name": "Ramain",
                        "latitude": "7.97083000",
                        "longitude": "124.34528000"
                    },
                    {
                        "id": 84337,
                        "name": "Rimpeso",
                        "latitude": "7.02389000",
                        "longitude": "124.10028000"
                    },
                    {
                        "id": 84353,
                        "name": "Rominimbang",
                        "latitude": "7.50000000",
                        "longitude": "124.30000000"
                    },
                    {
                        "id": 84384,
                        "name": "Sagasa",
                        "latitude": "6.77405000",
                        "longitude": "124.57408000"
                    },
                    {
                        "id": 84428,
                        "name": "Sambuluan",
                        "latitude": "6.88333000",
                        "longitude": "124.70000000"
                    },
                    {
                        "id": 84630,
                        "name": "Sanga-Sanga",
                        "latitude": "5.07250000",
                        "longitude": "119.78528000"
                    },
                    {
                        "id": 84654,
                        "name": "Santa Clara",
                        "latitude": "6.67820000",
                        "longitude": "122.06000000"
                    },
                    {
                        "id": 84739,
                        "name": "Sapa",
                        "latitude": "5.15440000",
                        "longitude": "120.32410000"
                    },
                    {
                        "id": 84741,
                        "name": "Sapadun",
                        "latitude": "7.48333000",
                        "longitude": "124.25000000"
                    },
                    {
                        "id": 84754,
                        "name": "Satan",
                        "latitude": "6.86306000",
                        "longitude": "124.40861000"
                    },
                    {
                        "id": 84758,
                        "name": "Semut",
                        "latitude": "6.66361000",
                        "longitude": "122.21889000"
                    },
                    {
                        "id": 84801,
                        "name": "Simbahan",
                        "latitude": "6.30320000",
                        "longitude": "120.58360000"
                    },
                    {
                        "id": 84804,
                        "name": "Simuay",
                        "latitude": "7.27722000",
                        "longitude": "124.30722000"
                    },
                    {
                        "id": 84824,
                        "name": "Sionogan",
                        "latitude": "6.00528000",
                        "longitude": "120.94861000"
                    },
                    {
                        "id": 84894,
                        "name": "Tabiauan",
                        "latitude": "6.02806000",
                        "longitude": "121.89355000"
                    },
                    {
                        "id": 84901,
                        "name": "Tablas",
                        "latitude": "6.62917000",
                        "longitude": "122.17472000"
                    },
                    {
                        "id": 84928,
                        "name": "Taganak",
                        "latitude": "6.07328000",
                        "longitude": "118.31226000"
                    },
                    {
                        "id": 84954,
                        "name": "Tairan Camp",
                        "latitude": "6.64020000",
                        "longitude": "121.83950000"
                    },
                    {
                        "id": 84978,
                        "name": "Talipaw",
                        "latitude": "5.91000000",
                        "longitude": "121.09444000"
                    },
                    {
                        "id": 85048,
                        "name": "Tapayan",
                        "latitude": "7.29444000",
                        "longitude": "124.26611000"
                    },
                    {
                        "id": 85051,
                        "name": "Tapikan",
                        "latitude": "6.85194000",
                        "longitude": "124.32250000"
                    },
                    {
                        "id": 85063,
                        "name": "Taungoh",
                        "latitude": "4.70654000",
                        "longitude": "119.49296000"
                    },
                    {
                        "id": 85064,
                        "name": "Taviran",
                        "latitude": "7.12333000",
                        "longitude": "124.31972000"
                    },
                    {
                        "id": 85142,
                        "name": "Tinutulan",
                        "latitude": "7.10000000",
                        "longitude": "124.65000000"
                    },
                    {
                        "id": 85168,
                        "name": "Tongouson",
                        "latitude": "5.02140000",
                        "longitude": "120.13280000"
                    },
                    {
                        "id": 85223,
                        "name": "Tumbagaan",
                        "latitude": "5.36560000",
                        "longitude": "120.31390000"
                    },
                    {
                        "id": 85228,
                        "name": "Tunggol",
                        "latitude": "5.84458000",
                        "longitude": "121.15436000"
                    },
                    {
                        "id": 85229,
                        "name": "Tungol",
                        "latitude": "7.08083000",
                        "longitude": "124.75306000"
                    },
                    {
                        "id": 85253,
                        "name": "Ungus-Ungus",
                        "latitude": "5.05083000",
                        "longitude": "119.83972000"
                    },
                    {
                        "id": 85272,
                        "name": "Uyaan",
                        "latitude": "7.86306000",
                        "longitude": "124.04111000"
                    }
                ]
            },
            {
                "id": 1346,
                "name": "Basilan",
                "iso2": "BAS",
                "latitude": "6.42963490",
                "longitude": "121.98701650",
                "type": "province",
                "cities": [
                    {
                        "id": 154487,
                        "name": "Akbar",
                        "latitude": "6.63622070",
                        "longitude": "122.13063910"
                    },
                    {
                        "id": 154488,
                        "name": "Al-Barka",
                        "latitude": "6.48418650",
                        "longitude": "122.11105890"
                    },
                    {
                        "id": 154489,
                        "name": "Hadji Mohammad Ajul",
                        "latitude": "6.62700220",
                        "longitude": "122.19440060"
                    },
                    {
                        "id": 154490,
                        "name": "Hadji Muhtamad",
                        "latitude": "6.65872100",
                        "longitude": "121.29380290"
                    },
                    {
                        "id": 144530,
                        "name": "Isabela",
                        "latitude": "6.66855650",
                        "longitude": "121.90652440"
                    },
                    {
                        "id": 144558,
                        "name": "Lamitan",
                        "latitude": "6.65077910",
                        "longitude": "122.03653650"
                    },
                    {
                        "id": 154491,
                        "name": "Lantawan",
                        "latitude": "6.65872100",
                        "longitude": "121.29380290"
                    },
                    {
                        "id": 144584,
                        "name": "Maluso",
                        "latitude": "6.52229870",
                        "longitude": "121.85485740"
                    },
                    {
                        "id": 144732,
                        "name": "Sumisip",
                        "latitude": "6.49197520",
                        "longitude": "121.91873390"
                    },
                    {
                        "id": 154492,
                        "name": "Tabuan-Lasa",
                        "latitude": "6.33806560",
                        "longitude": "121.90364910"
                    },
                    {
                        "id": 144750,
                        "name": "Tipo-Tipo",
                        "latitude": "6.51074450",
                        "longitude": "122.12117930"
                    },
                    {
                        "id": 144754,
                        "name": "Tuburan",
                        "latitude": "6.59669650",
                        "longitude": "122.17114350"
                    },
                    {
                        "id": 154493,
                        "name": "Ungkaya Pukan",
                        "latitude": "6.50141960",
                        "longitude": "122.02509960"
                    }
                ]
            },
            {
                "id": 1344,
                "name": "Bataan",
                "iso2": "BAN",
                "latitude": "14.64168420",
                "longitude": "120.48184460",
                "type": "province",
                "cities": [
                    {
                        "id": 81126,
                        "name": "Abaca",
                        "latitude": "9.92040000",
                        "longitude": "124.50510000"
                    },
                    {
                        "id": 81131,
                        "name": "Abis",
                        "latitude": "9.71730000",
                        "longitude": "122.94380000"
                    },
                    {
                        "id": 81136,
                        "name": "Abucayan",
                        "latitude": "9.92900000",
                        "longitude": "123.91460000"
                    },
                    {
                        "id": 81146,
                        "name": "Adlaon",
                        "latitude": "10.30000000",
                        "longitude": "123.90000000"
                    },
                    {
                        "id": 81166,
                        "name": "Agsungot",
                        "latitude": "10.43444000",
                        "longitude": "123.90611000"
                    },
                    {
                        "id": 81169,
                        "name": "Aguining",
                        "latitude": "10.08610000",
                        "longitude": "124.59440000"
                    },
                    {
                        "id": 81187,
                        "name": "Alangilan",
                        "latitude": "9.27930000",
                        "longitude": "122.87890000"
                    },
                    {
                        "id": 81188,
                        "name": "Alangilanan",
                        "latitude": "9.64200000",
                        "longitude": "123.10590000"
                    },
                    {
                        "id": 81193,
                        "name": "Alburquerque",
                        "latitude": "9.60806000",
                        "longitude": "123.95806000"
                    },
                    {
                        "id": 81231,
                        "name": "Alpaco",
                        "latitude": "10.24378000",
                        "longitude": "123.68250000"
                    },
                    {
                        "id": 81246,
                        "name": "Amdos",
                        "latitude": "9.88210000",
                        "longitude": "123.09720000"
                    },
                    {
                        "id": 81247,
                        "name": "Amio",
                        "latitude": "9.35710000",
                        "longitude": "122.94130000"
                    },
                    {
                        "id": 81275,
                        "name": "Anonang",
                        "latitude": "11.00000000",
                        "longitude": "124.03333000"
                    },
                    {
                        "id": 81276,
                        "name": "Anopog",
                        "latitude": "10.25000000",
                        "longitude": "123.25000000"
                    },
                    {
                        "id": 81279,
                        "name": "Antequera",
                        "latitude": "9.78090000",
                        "longitude": "123.89880000"
                    },
                    {
                        "id": 81293,
                        "name": "Apas",
                        "latitude": "10.34076000",
                        "longitude": "123.90261000"
                    },
                    {
                        "id": 81298,
                        "name": "Apoya",
                        "latitude": "9.22070000",
                        "longitude": "122.90530000"
                    },
                    {
                        "id": 81328,
                        "name": "Atop-atop",
                        "latitude": "11.23220000",
                        "longitude": "123.76020000"
                    },
                    {
                        "id": 81344,
                        "name": "Azagra",
                        "latitude": "9.47790000",
                        "longitude": "123.13670000"
                    },
                    {
                        "id": 81357,
                        "name": "Bachauan",
                        "latitude": "11.20670000",
                        "longitude": "123.96340000"
                    },
                    {
                        "id": 81358,
                        "name": "Baclayon",
                        "latitude": "9.62639000",
                        "longitude": "123.89417000"
                    },
                    {
                        "id": 81386,
                        "name": "Bagacay",
                        "latitude": "9.86640000",
                        "longitude": "123.91800000"
                    },
                    {
                        "id": 81394,
                        "name": "Bagay",
                        "latitude": "11.19640000",
                        "longitude": "124.03500000"
                    },
                    {
                        "id": 81405,
                        "name": "Bagtic",
                        "latitude": "9.68640000",
                        "longitude": "123.01220000"
                    },
                    {
                        "id": 81422,
                        "name": "Bairan",
                        "latitude": "10.19718000",
                        "longitude": "123.72710000"
                    },
                    {
                        "id": 81428,
                        "name": "Bal-os",
                        "latitude": "9.44160000",
                        "longitude": "122.62570000"
                    },
                    {
                        "id": 81457,
                        "name": "Balayong",
                        "latitude": "9.47440000",
                        "longitude": "123.06230000"
                    },
                    {
                        "id": 81471,
                        "name": "Balilihan",
                        "latitude": "9.75610000",
                        "longitude": "123.97300000"
                    },
                    {
                        "id": 81492,
                        "name": "Balogo",
                        "latitude": "10.11480000",
                        "longitude": "123.17060000"
                    },
                    {
                        "id": 81536,
                        "name": "Banhigan",
                        "latitude": "9.85903000",
                        "longitude": "123.38926000"
                    },
                    {
                        "id": 81539,
                        "name": "Banilad",
                        "latitude": "9.27860000",
                        "longitude": "123.29360000"
                    },
                    {
                        "id": 81594,
                        "name": "Basak",
                        "latitude": "10.22640000",
                        "longitude": "123.30640000"
                    },
                    {
                        "id": 81599,
                        "name": "Basdiot",
                        "latitude": "9.94718000",
                        "longitude": "123.37515000"
                    },
                    {
                        "id": 81622,
                        "name": "Bateria",
                        "latitude": "11.14160000",
                        "longitude": "124.02670000"
                    },
                    {
                        "id": 81643,
                        "name": "Baud",
                        "latitude": "11.21110000",
                        "longitude": "123.70310000"
                    },
                    {
                        "id": 81644,
                        "name": "Baugo",
                        "latitude": "10.31745000",
                        "longitude": "123.91900000"
                    },
                    {
                        "id": 81673,
                        "name": "Becerril",
                        "latitude": "9.65310000",
                        "longitude": "123.43440000"
                    },
                    {
                        "id": 81681,
                        "name": "Biabas",
                        "latitude": "9.80000000",
                        "longitude": "124.46667000"
                    },
                    {
                        "id": 81685,
                        "name": "Biasong",
                        "latitude": "10.52290000",
                        "longitude": "123.73600000"
                    },
                    {
                        "id": 81690,
                        "name": "Bien Unido",
                        "latitude": "10.13729000",
                        "longitude": "124.37761000"
                    },
                    {
                        "id": 81697,
                        "name": "Biking",
                        "latitude": "9.59382000",
                        "longitude": "123.84303000"
                    },
                    {
                        "id": 81701,
                        "name": "Bilar",
                        "latitude": "9.70825000",
                        "longitude": "124.10717000"
                    },
                    {
                        "id": 81723,
                        "name": "Binlod",
                        "latitude": "9.91845000",
                        "longitude": "123.60743000"
                    },
                    {
                        "id": 81745,
                        "name": "Biton",
                        "latitude": "11.23279000",
                        "longitude": "123.99930000"
                    },
                    {
                        "id": 81746,
                        "name": "Bitoon",
                        "latitude": "10.08040000",
                        "longitude": "123.45870000"
                    },
                    {
                        "id": 81763,
                        "name": "Bohol",
                        "latitude": "9.83333000",
                        "longitude": "124.16667000"
                    },
                    {
                        "id": 81772,
                        "name": "Bolisong",
                        "latitude": "9.69111000",
                        "longitude": "123.15167000"
                    },
                    {
                        "id": 81783,
                        "name": "Bonawon",
                        "latitude": "9.13400000",
                        "longitude": "122.91930000"
                    },
                    {
                        "id": 81784,
                        "name": "Bonbon",
                        "latitude": "10.22450000",
                        "longitude": "123.55730000"
                    },
                    {
                        "id": 81794,
                        "name": "Bood",
                        "latitude": "9.74508000",
                        "longitude": "123.82783000"
                    },
                    {
                        "id": 81803,
                        "name": "Botigues",
                        "latitude": "11.09950000",
                        "longitude": "123.66750000"
                    },
                    {
                        "id": 81815,
                        "name": "Buagsong",
                        "latitude": "10.25302000",
                        "longitude": "123.93909000"
                    },
                    {
                        "id": 81820,
                        "name": "Buanoy",
                        "latitude": "10.46746000",
                        "longitude": "123.69990000"
                    },
                    {
                        "id": 81842,
                        "name": "Bugas",
                        "latitude": "9.89804000",
                        "longitude": "123.40492000"
                    },
                    {
                        "id": 81849,
                        "name": "Bugsoc",
                        "latitude": "9.78340000",
                        "longitude": "124.27120000"
                    },
                    {
                        "id": 81869,
                        "name": "Bulasa",
                        "latitude": "9.93206000",
                        "longitude": "123.61802000"
                    },
                    {
                        "id": 81882,
                        "name": "Bulod",
                        "latitude": "9.68333000",
                        "longitude": "123.15000000"
                    },
                    {
                        "id": 81941,
                        "name": "Cabalawan",
                        "latitude": "10.74139000",
                        "longitude": "123.95250000"
                    },
                    {
                        "id": 81947,
                        "name": "Cabangahan",
                        "latitude": "9.07810000",
                        "longitude": "122.94690000"
                    },
                    {
                        "id": 81981,
                        "name": "Cabul-an",
                        "latitude": "10.15684000",
                        "longitude": "124.04397000"
                    },
                    {
                        "id": 82031,
                        "name": "Calape",
                        "latitude": "9.89220000",
                        "longitude": "123.87480000"
                    },
                    {
                        "id": 82048,
                        "name": "Calero",
                        "latitude": "10.37331000",
                        "longitude": "123.99786000"
                    },
                    {
                        "id": 82051,
                        "name": "Calidñgan",
                        "latitude": "10.10000000",
                        "longitude": "123.63333000"
                    },
                    {
                        "id": 82057,
                        "name": "Calituban",
                        "latitude": "10.23995000",
                        "longitude": "124.29190000"
                    },
                    {
                        "id": 82069,
                        "name": "Calumboyan",
                        "latitude": "10.79129000",
                        "longitude": "124.02749000"
                    },
                    {
                        "id": 82082,
                        "name": "Camambugan",
                        "latitude": "10.05844000",
                        "longitude": "124.43811000"
                    },
                    {
                        "id": 82085,
                        "name": "Cambanay",
                        "latitude": "10.54361000",
                        "longitude": "123.98611000"
                    },
                    {
                        "id": 82095,
                        "name": "Campoyo",
                        "latitude": "9.65640000",
                        "longitude": "123.14790000"
                    },
                    {
                        "id": 82096,
                        "name": "Campusong",
                        "latitude": "10.81583000",
                        "longitude": "124.03222000"
                    },
                    {
                        "id": 82099,
                        "name": "Can-asujan",
                        "latitude": "10.12990000",
                        "longitude": "123.65740000"
                    },
                    {
                        "id": 82103,
                        "name": "Canauay",
                        "latitude": "9.06510000",
                        "longitude": "123.05240000"
                    },
                    {
                        "id": 82106,
                        "name": "Candabong",
                        "latitude": "9.73430000",
                        "longitude": "124.53830000"
                    },
                    {
                        "id": 82111,
                        "name": "Candijay",
                        "latitude": "9.81820000",
                        "longitude": "124.49770000"
                    },
                    {
                        "id": 82115,
                        "name": "Canhaway",
                        "latitude": "9.75010000",
                        "longitude": "124.47220000"
                    },
                    {
                        "id": 82117,
                        "name": "Canjulao",
                        "latitude": "9.66050000",
                        "longitude": "124.35320000"
                    },
                    {
                        "id": 82119,
                        "name": "Canmaya Diot",
                        "latitude": "9.93840000",
                        "longitude": "124.09420000"
                    },
                    {
                        "id": 82124,
                        "name": "Cansuje",
                        "latitude": "9.92314000",
                        "longitude": "123.49629000"
                    },
                    {
                        "id": 82125,
                        "name": "Cantao-an",
                        "latitude": "10.24258000",
                        "longitude": "123.74960000"
                    },
                    {
                        "id": 82166,
                        "name": "Carmelo",
                        "latitude": "10.70510000",
                        "longitude": "123.79350000"
                    },
                    {
                        "id": 82187,
                        "name": "Casala-an",
                        "latitude": "9.11667000",
                        "longitude": "123.05000000"
                    },
                    {
                        "id": 82189,
                        "name": "Casay",
                        "latitude": "9.82040000",
                        "longitude": "123.54960000"
                    },
                    {
                        "id": 82212,
                        "name": "Caticugan",
                        "latitude": "9.10000000",
                        "longitude": "123.00000000"
                    },
                    {
                        "id": 82213,
                        "name": "Catigbian",
                        "latitude": "9.85010000",
                        "longitude": "123.99940000"
                    },
                    {
                        "id": 82216,
                        "name": "Catmondaan",
                        "latitude": "10.68692000",
                        "longitude": "124.01494000"
                    },
                    {
                        "id": 82221,
                        "name": "Catungawan Sur",
                        "latitude": "9.78170000",
                        "longitude": "124.46930000"
                    },
                    {
                        "id": 82233,
                        "name": "Cayang",
                        "latitude": "11.06667000",
                        "longitude": "123.98333000"
                    },
                    {
                        "id": 82253,
                        "name": "Cogan",
                        "latitude": "10.59306000",
                        "longitude": "124.01778000"
                    },
                    {
                        "id": 82254,
                        "name": "Cogon",
                        "latitude": "10.03720000",
                        "longitude": "123.45390000"
                    },
                    {
                        "id": 82257,
                        "name": "Cogon Cruz",
                        "latitude": "10.50944000",
                        "longitude": "123.96972000"
                    },
                    {
                        "id": 82258,
                        "name": "Cogtong",
                        "latitude": "9.83740000",
                        "longitude": "124.52910000"
                    },
                    {
                        "id": 82261,
                        "name": "Colonia",
                        "latitude": "10.65530000",
                        "longitude": "123.79110000"
                    },
                    {
                        "id": 82285,
                        "name": "Consuelo",
                        "latitude": "10.63480000",
                        "longitude": "124.30100000"
                    },
                    {
                        "id": 82293,
                        "name": "Corella",
                        "latitude": "9.68750000",
                        "longitude": "123.92180000"
                    },
                    {
                        "id": 82334,
                        "name": "Dagohoy",
                        "latitude": "9.90016000",
                        "longitude": "124.28322000"
                    },
                    {
                        "id": 82362,
                        "name": "Damolog",
                        "latitude": "10.77271000",
                        "longitude": "124.00639000"
                    },
                    {
                        "id": 82390,
                        "name": "Datagon",
                        "latitude": "9.44610000",
                        "longitude": "123.08910000"
                    },
                    {
                        "id": 82394,
                        "name": "Dauis",
                        "latitude": "9.62528000",
                        "longitude": "123.86583000"
                    },
                    {
                        "id": 82403,
                        "name": "De la Paz",
                        "latitude": "9.70004000",
                        "longitude": "123.86433000"
                    },
                    {
                        "id": 82432,
                        "name": "Dimiao",
                        "latitude": "9.60640000",
                        "longitude": "124.16330000"
                    },
                    {
                        "id": 82449,
                        "name": "Doljo",
                        "latitude": "9.58745000",
                        "longitude": "123.73033000"
                    },
                    {
                        "id": 82461,
                        "name": "Doong",
                        "latitude": "11.07860000",
                        "longitude": "123.63950000"
                    },
                    {
                        "id": 82469,
                        "name": "Duero",
                        "latitude": "9.70900000",
                        "longitude": "124.40550000"
                    },
                    {
                        "id": 82488,
                        "name": "Dumanjog",
                        "latitude": "10.05700000",
                        "longitude": "123.43610000"
                    },
                    {
                        "id": 82506,
                        "name": "El Pardo",
                        "latitude": "9.66000000",
                        "longitude": "123.49440000"
                    },
                    {
                        "id": 82518,
                        "name": "Esperanza",
                        "latitude": "10.69950000",
                        "longitude": "124.31430000"
                    },
                    {
                        "id": 82525,
                        "name": "Estaca",
                        "latitude": "9.69330000",
                        "longitude": "124.27220000"
                    },
                    {
                        "id": 82549,
                        "name": "Gabi",
                        "latitude": "10.26306000",
                        "longitude": "123.96139000"
                    },
                    {
                        "id": 82570,
                        "name": "Garcia Hernandez",
                        "latitude": "9.61440000",
                        "longitude": "124.29460000"
                    },
                    {
                        "id": 82587,
                        "name": "Giawang",
                        "latitude": "9.79220000",
                        "longitude": "124.50900000"
                    },
                    {
                        "id": 82610,
                        "name": "Guadalupe",
                        "latitude": "10.11650000",
                        "longitude": "123.60720000"
                    },
                    {
                        "id": 82614,
                        "name": "Guba",
                        "latitude": "10.31310000",
                        "longitude": "123.26670000"
                    },
                    {
                        "id": 82618,
                        "name": "Guibodangan",
                        "latitude": "10.11570000",
                        "longitude": "123.49440000"
                    },
                    {
                        "id": 82632,
                        "name": "Guindarohan",
                        "latitude": "10.26111000",
                        "longitude": "123.76556000"
                    },
                    {
                        "id": 82633,
                        "name": "Guindulman",
                        "latitude": "9.76290000",
                        "longitude": "124.48780000"
                    },
                    {
                        "id": 82651,
                        "name": "Guiwanon",
                        "latitude": "11.19750000",
                        "longitude": "123.70800000"
                    },
                    {
                        "id": 82666,
                        "name": "Hagdan",
                        "latitude": "11.33333000",
                        "longitude": "123.90000000"
                    },
                    {
                        "id": 82667,
                        "name": "Hagnaya",
                        "latitude": "11.09240000",
                        "longitude": "123.94350000"
                    },
                    {
                        "id": 82683,
                        "name": "Hibaiyo",
                        "latitude": "10.27260000",
                        "longitude": "123.32100000"
                    },
                    {
                        "id": 82685,
                        "name": "Hilantagaan",
                        "latitude": "11.19430000",
                        "longitude": "123.81310000"
                    },
                    {
                        "id": 82687,
                        "name": "Hilotongan",
                        "latitude": "11.14400000",
                        "longitude": "123.64260000"
                    },
                    {
                        "id": 82691,
                        "name": "Himensulan",
                        "latitude": "10.59670000",
                        "longitude": "124.28210000"
                    },
                    {
                        "id": 82697,
                        "name": "Hinlayagan Ilaud",
                        "latitude": "10.03061000",
                        "longitude": "124.33457000"
                    },
                    {
                        "id": 82729,
                        "name": "Ilihan",
                        "latitude": "10.90540000",
                        "longitude": "123.97040000"
                    },
                    {
                        "id": 82740,
                        "name": "Inabanga",
                        "latitude": "10.03070000",
                        "longitude": "124.06710000"
                    },
                    {
                        "id": 82744,
                        "name": "Inayagan",
                        "latitude": "10.23478000",
                        "longitude": "123.76900000"
                    },
                    {
                        "id": 82779,
                        "name": "Jaclupan",
                        "latitude": "10.30138000",
                        "longitude": "123.81650000"
                    },
                    {
                        "id": 82782,
                        "name": "Jagna",
                        "latitude": "9.65310000",
                        "longitude": "124.36970000"
                    },
                    {
                        "id": 82789,
                        "name": "Jampang",
                        "latitude": "9.90761000",
                        "longitude": "123.60015000"
                    },
                    {
                        "id": 82791,
                        "name": "Jandayan Norte",
                        "latitude": "10.16852000",
                        "longitude": "124.18148000"
                    },
                    {
                        "id": 82794,
                        "name": "Jantianon",
                        "latitude": "9.44420000",
                        "longitude": "123.16570000"
                    },
                    {
                        "id": 82795,
                        "name": "Japitan",
                        "latitude": "10.12790000",
                        "longitude": "123.50350000"
                    },
                    {
                        "id": 82803,
                        "name": "Jetafe",
                        "latitude": "10.14722000",
                        "longitude": "124.15389000"
                    },
                    {
                        "id": 82818,
                        "name": "Jugno",
                        "latitude": "9.46830000",
                        "longitude": "123.20380000"
                    },
                    {
                        "id": 82820,
                        "name": "Kabac",
                        "latitude": "11.23530000",
                        "longitude": "123.69790000"
                    },
                    {
                        "id": 82832,
                        "name": "Kabungahan",
                        "latitude": "10.51667000",
                        "longitude": "123.98333000"
                    },
                    {
                        "id": 82861,
                        "name": "Kandabong",
                        "latitude": "9.68590000",
                        "longitude": "123.07280000"
                    },
                    {
                        "id": 82865,
                        "name": "Kaongkod",
                        "latitude": "11.25028000",
                        "longitude": "123.75556000"
                    },
                    {
                        "id": 82883,
                        "name": "Kauit",
                        "latitude": "11.18600000",
                        "longitude": "123.94590000"
                    },
                    {
                        "id": 82926,
                        "name": "Kotkot",
                        "latitude": "10.42500000",
                        "longitude": "124.00050000"
                    },
                    {
                        "id": 82927,
                        "name": "Kuanos",
                        "latitude": "10.28298000",
                        "longitude": "123.78000000"
                    },
                    {
                        "id": 82942,
                        "name": "La Hacienda",
                        "latitude": "9.88150000",
                        "longitude": "124.39230000"
                    },
                    {
                        "id": 83007,
                        "name": "Lanao",
                        "latitude": "11.25636000",
                        "longitude": "124.02423000"
                    },
                    {
                        "id": 83009,
                        "name": "Lanas",
                        "latitude": "10.26667000",
                        "longitude": "123.73333000"
                    },
                    {
                        "id": 83014,
                        "name": "Langob",
                        "latitude": "10.57740000",
                        "longitude": "123.73090000"
                    },
                    {
                        "id": 83016,
                        "name": "Langtad",
                        "latitude": "9.89094000",
                        "longitude": "123.60430000"
                    },
                    {
                        "id": 83031,
                        "name": "Lapaz",
                        "latitude": "10.98870000",
                        "longitude": "123.97970000"
                    },
                    {
                        "id": 83070,
                        "name": "Lepanto",
                        "latitude": "9.68450000",
                        "longitude": "123.40260000"
                    },
                    {
                        "id": 83108,
                        "name": "Lila",
                        "latitude": "9.59180000",
                        "longitude": "124.09580000"
                    },
                    {
                        "id": 83149,
                        "name": "Lipayran",
                        "latitude": "11.05930000",
                        "longitude": "123.63420000"
                    },
                    {
                        "id": 83157,
                        "name": "Loay",
                        "latitude": "9.60060000",
                        "longitude": "124.01420000"
                    },
                    {
                        "id": 83159,
                        "name": "Loboc",
                        "latitude": "9.63833000",
                        "longitude": "124.03482000"
                    },
                    {
                        "id": 83162,
                        "name": "Logon",
                        "latitude": "11.33030000",
                        "longitude": "124.11460000"
                    },
                    {
                        "id": 83165,
                        "name": "Lombog",
                        "latitude": "9.77880000",
                        "longitude": "124.41740000"
                    },
                    {
                        "id": 83175,
                        "name": "Loon",
                        "latitude": "9.79980000",
                        "longitude": "123.79290000"
                    },
                    {
                        "id": 83206,
                        "name": "Lugo",
                        "latitude": "10.81672000",
                        "longitude": "123.98626000"
                    },
                    {
                        "id": 83236,
                        "name": "Lunas",
                        "latitude": "10.64020000",
                        "longitude": "123.75250000"
                    },
                    {
                        "id": 83250,
                        "name": "Lut-od",
                        "latitude": "10.25722000",
                        "longitude": "123.62944000"
                    },
                    {
                        "id": 83263,
                        "name": "Maayong Tubig",
                        "latitude": "9.16720000",
                        "longitude": "123.24690000"
                    },
                    {
                        "id": 83274,
                        "name": "Mabinay",
                        "latitude": "9.72722000",
                        "longitude": "122.90167000"
                    },
                    {
                        "id": 83280,
                        "name": "Mabini",
                        "latitude": "9.86490000",
                        "longitude": "124.52150000"
                    },
                    {
                        "id": 83293,
                        "name": "Macaas",
                        "latitude": "10.69885000",
                        "longitude": "124.01154000"
                    },
                    {
                        "id": 83329,
                        "name": "Magay",
                        "latitude": "10.47190000",
                        "longitude": "124.01320000"
                    },
                    {
                        "id": 83389,
                        "name": "Malabugas",
                        "latitude": "9.36920000",
                        "longitude": "122.77020000"
                    },
                    {
                        "id": 83394,
                        "name": "Malaiba",
                        "latitude": "10.33333000",
                        "longitude": "123.31667000"
                    },
                    {
                        "id": 83422,
                        "name": "Malbug",
                        "latitude": "9.73270000",
                        "longitude": "123.34020000"
                    },
                    {
                        "id": 83423,
                        "name": "Malhiao",
                        "latitude": "9.88487000",
                        "longitude": "123.40641000"
                    },
                    {
                        "id": 83441,
                        "name": "Malingin",
                        "latitude": "11.05000000",
                        "longitude": "123.98333000"
                    },
                    {
                        "id": 83453,
                        "name": "Maloh",
                        "latitude": "9.05600000",
                        "longitude": "122.98510000"
                    },
                    {
                        "id": 83462,
                        "name": "Malusay",
                        "latitude": "10.14390000",
                        "longitude": "123.27170000"
                    },
                    {
                        "id": 83466,
                        "name": "Malway",
                        "latitude": "9.13190000",
                        "longitude": "123.22030000"
                    },
                    {
                        "id": 83488,
                        "name": "Manalongon",
                        "latitude": "9.22090000",
                        "longitude": "122.88600000"
                    },
                    {
                        "id": 83500,
                        "name": "Mancilang",
                        "latitude": "11.28350000",
                        "longitude": "123.74620000"
                    },
                    {
                        "id": 83504,
                        "name": "Mandaue City",
                        "latitude": "10.32361000",
                        "longitude": "123.92222000"
                    },
                    {
                        "id": 83525,
                        "name": "Maninihon",
                        "latitude": "9.37110000",
                        "longitude": "122.84050000"
                    },
                    {
                        "id": 83654,
                        "name": "Maño",
                        "latitude": "11.04167000",
                        "longitude": "123.94472000"
                    },
                    {
                        "id": 83536,
                        "name": "Mantalongon",
                        "latitude": "9.81060000",
                        "longitude": "123.46170000"
                    },
                    {
                        "id": 83540,
                        "name": "Mantiquil",
                        "latitude": "9.16667000",
                        "longitude": "123.05000000"
                    },
                    {
                        "id": 83565,
                        "name": "Maravilla",
                        "latitude": "10.90110000",
                        "longitude": "123.89180000"
                    },
                    {
                        "id": 83578,
                        "name": "Maribojoc",
                        "latitude": "9.74170000",
                        "longitude": "123.84460000"
                    },
                    {
                        "id": 83580,
                        "name": "Maricaban",
                        "latitude": "11.15160000",
                        "longitude": "123.76790000"
                    },
                    {
                        "id": 83590,
                        "name": "Masaba",
                        "latitude": "10.53333000",
                        "longitude": "123.96667000"
                    },
                    {
                        "id": 83643,
                        "name": "Maya",
                        "latitude": "11.27442000",
                        "longitude": "124.05526000"
                    },
                    {
                        "id": 83644,
                        "name": "Mayabon",
                        "latitude": "9.09610000",
                        "longitude": "123.17380000"
                    },
                    {
                        "id": 83645,
                        "name": "Mayana",
                        "latitude": "9.75611000",
                        "longitude": "124.35222000"
                    },
                    {
                        "id": 83647,
                        "name": "Mayapusi",
                        "latitude": "9.62410000",
                        "longitude": "123.01880000"
                    },
                    {
                        "id": 83655,
                        "name": "McKinley",
                        "latitude": "10.08440000",
                        "longitude": "123.25920000"
                    },
                    {
                        "id": 83687,
                        "name": "Minolos",
                        "latitude": "10.10190000",
                        "longitude": "123.47270000"
                    },
                    {
                        "id": 83705,
                        "name": "Montaneza",
                        "latitude": "9.68460000",
                        "longitude": "123.32890000"
                    },
                    {
                        "id": 83744,
                        "name": "Nagbalaye",
                        "latitude": "9.24920000",
                        "longitude": "122.87590000"
                    },
                    {
                        "id": 83756,
                        "name": "Nahawan",
                        "latitude": "9.97110000",
                        "longitude": "124.04840000"
                    },
                    {
                        "id": 83759,
                        "name": "Nailong",
                        "latitude": "11.05370000",
                        "longitude": "124.03850000"
                    },
                    {
                        "id": 83762,
                        "name": "Nalundan",
                        "latitude": "9.75000000",
                        "longitude": "123.06667000"
                    },
                    {
                        "id": 83773,
                        "name": "Nangka",
                        "latitude": "9.40230000",
                        "longitude": "122.82440000"
                    },
                    {
                        "id": 83823,
                        "name": "Novallas",
                        "latitude": "9.51170000",
                        "longitude": "123.12250000"
                    },
                    {
                        "id": 83826,
                        "name": "Nueva Fuerza",
                        "latitude": "9.84640000",
                        "longitude": "124.16700000"
                    },
                    {
                        "id": 83828,
                        "name": "Nueva Vida Sur",
                        "latitude": "9.78460000",
                        "longitude": "124.17450000"
                    },
                    {
                        "id": 83829,
                        "name": "Nugas",
                        "latitude": "9.69680000",
                        "longitude": "123.44150000"
                    },
                    {
                        "id": 83836,
                        "name": "Obong",
                        "latitude": "9.74100000",
                        "longitude": "123.50980000"
                    },
                    {
                        "id": 83838,
                        "name": "Ocaña",
                        "latitude": "10.06560000",
                        "longitude": "123.62440000"
                    },
                    {
                        "id": 83840,
                        "name": "Ocoy",
                        "latitude": "11.17160000",
                        "longitude": "123.79480000"
                    },
                    {
                        "id": 83849,
                        "name": "Okiot",
                        "latitude": "9.56667000",
                        "longitude": "123.16667000"
                    },
                    {
                        "id": 83869,
                        "name": "Owak",
                        "latitude": "10.55000000",
                        "longitude": "123.70000000"
                    },
                    {
                        "id": 83884,
                        "name": "Padre Zamora",
                        "latitude": "10.06667000",
                        "longitude": "123.25000000"
                    },
                    {
                        "id": 83904,
                        "name": "Pajo",
                        "latitude": "11.24121000",
                        "longitude": "124.01067000"
                    },
                    {
                        "id": 83949,
                        "name": "Panalipan",
                        "latitude": "10.64833000",
                        "longitude": "124.02167000"
                    },
                    {
                        "id": 83955,
                        "name": "Panaytayon",
                        "latitude": "9.95000000",
                        "longitude": "123.98333000"
                    },
                    {
                        "id": 83975,
                        "name": "Pangdan",
                        "latitude": "10.23078000",
                        "longitude": "123.73790000"
                    },
                    {
                        "id": 83979,
                        "name": "Panglao",
                        "latitude": "9.57806000",
                        "longitude": "123.74583000"
                    },
                    {
                        "id": 83995,
                        "name": "Panognawan",
                        "latitude": "11.16190000",
                        "longitude": "124.00500000"
                    },
                    {
                        "id": 84039,
                        "name": "Patao",
                        "latitude": "11.22020000",
                        "longitude": "123.69250000"
                    },
                    {
                        "id": 84065,
                        "name": "Payabon",
                        "latitude": "9.75900000",
                        "longitude": "123.14120000"
                    },
                    {
                        "id": 84070,
                        "name": "Paypay",
                        "latitude": "11.21520000",
                        "longitude": "123.97620000"
                    },
                    {
                        "id": 84075,
                        "name": "Perrelos",
                        "latitude": "10.11690000",
                        "longitude": "123.67380000"
                    },
                    {
                        "id": 84106,
                        "name": "Pinamungahan",
                        "latitude": "10.27080000",
                        "longitude": "123.58390000"
                    },
                    {
                        "id": 84108,
                        "name": "Pinayagan Norte",
                        "latitude": "9.93333000",
                        "longitude": "123.95000000"
                    },
                    {
                        "id": 84113,
                        "name": "Pinokawan",
                        "latitude": "10.34117000",
                        "longitude": "123.29390000"
                    },
                    {
                        "id": 84150,
                        "name": "Polo",
                        "latitude": "9.48160000",
                        "longitude": "123.18020000"
                    },
                    {
                        "id": 84202,
                        "name": "Province of Cebu",
                        "latitude": "10.39597000",
                        "longitude": "123.78021000"
                    },
                    {
                        "id": 84227,
                        "name": "Province of Negros Oriental",
                        "latitude": "9.75000000",
                        "longitude": "123.00000000"
                    },
                    {
                        "id": 84240,
                        "name": "Province of Siquijor",
                        "latitude": "9.18333000",
                        "longitude": "123.56667000"
                    },
                    {
                        "id": 84288,
                        "name": "Putat",
                        "latitude": "10.78580000",
                        "longitude": "123.84690000"
                    },
                    {
                        "id": 84365,
                        "name": "Saavedra",
                        "latitude": "9.98517000",
                        "longitude": "123.37158000"
                    },
                    {
                        "id": 84388,
                        "name": "Sagbayan",
                        "latitude": "9.91440000",
                        "longitude": "124.09190000"
                    },
                    {
                        "id": 84502,
                        "name": "San Isidro",
                        "latitude": "9.91667000",
                        "longitude": "123.88333000"
                    },
                    {
                        "id": 84606,
                        "name": "San Roque",
                        "latitude": "10.09190000",
                        "longitude": "124.32262000"
                    },
                    {
                        "id": 84627,
                        "name": "Sandayong Sur",
                        "latitude": "10.49583000",
                        "longitude": "123.99889000"
                    },
                    {
                        "id": 84629,
                        "name": "Sandolot",
                        "latitude": "9.10472000",
                        "longitude": "123.01944000"
                    },
                    {
                        "id": 84632,
                        "name": "Sangat",
                        "latitude": "10.13600000",
                        "longitude": "123.68960000"
                    },
                    {
                        "id": 84671,
                        "name": "Santa Filomena",
                        "latitude": "9.75181000",
                        "longitude": "123.34463000"
                    },
                    {
                        "id": 84693,
                        "name": "Santa Nino",
                        "latitude": "10.68900000",
                        "longitude": "123.78840000"
                    },
                    {
                        "id": 84708,
                        "name": "Santander Poblacion",
                        "latitude": "9.42527000",
                        "longitude": "123.33879000"
                    },
                    {
                        "id": 84761,
                        "name": "Sevilla",
                        "latitude": "9.70383000",
                        "longitude": "124.04829000"
                    },
                    {
                        "id": 84783,
                        "name": "Sierra Bullones",
                        "latitude": "9.80810000",
                        "longitude": "124.29210000"
                    },
                    {
                        "id": 84788,
                        "name": "Sikatuna",
                        "latitude": "9.68830000",
                        "longitude": "123.97510000"
                    },
                    {
                        "id": 84789,
                        "name": "Silab",
                        "latitude": "9.43830000",
                        "longitude": "123.17920000"
                    },
                    {
                        "id": 84795,
                        "name": "Sillon",
                        "latitude": "11.19900000",
                        "longitude": "123.76750000"
                    },
                    {
                        "id": 84799,
                        "name": "Simala",
                        "latitude": "9.97326000",
                        "longitude": "123.61648000"
                    },
                    {
                        "id": 84846,
                        "name": "Songculan",
                        "latitude": "9.62965000",
                        "longitude": "123.82897000"
                    },
                    {
                        "id": 84866,
                        "name": "Sulangan",
                        "latitude": "11.13730000",
                        "longitude": "123.72280000"
                    },
                    {
                        "id": 84892,
                        "name": "Tabalong",
                        "latitude": "9.62157000",
                        "longitude": "123.81231000"
                    },
                    {
                        "id": 84904,
                        "name": "Tabon",
                        "latitude": "9.80420000",
                        "longitude": "123.45630000"
                    },
                    {
                        "id": 84908,
                        "name": "Tabonok",
                        "latitude": "10.85120000",
                        "longitude": "123.87660000"
                    },
                    {
                        "id": 84911,
                        "name": "Tabuan",
                        "latitude": "9.51556000",
                        "longitude": "122.85056000"
                    },
                    {
                        "id": 84917,
                        "name": "Tabunok",
                        "latitude": "10.77673000",
                        "longitude": "124.01602000"
                    },
                    {
                        "id": 84935,
                        "name": "Tagbilaran City",
                        "latitude": "9.65556000",
                        "longitude": "123.85219000"
                    },
                    {
                        "id": 84952,
                        "name": "Tagum Norte",
                        "latitude": "10.07454000",
                        "longitude": "124.38925000"
                    },
                    {
                        "id": 84955,
                        "name": "Tajao",
                        "latitude": "10.31480000",
                        "longitude": "123.58350000"
                    },
                    {
                        "id": 84971,
                        "name": "Talangnan",
                        "latitude": "9.63400000",
                        "longitude": "123.33440000"
                    },
                    {
                        "id": 84974,
                        "name": "Talibon",
                        "latitude": "10.14917000",
                        "longitude": "124.32500000"
                    },
                    {
                        "id": 84981,
                        "name": "Talisay",
                        "latitude": "10.24472000",
                        "longitude": "123.84944000"
                    },
                    {
                        "id": 85006,
                        "name": "Tambalan",
                        "latitude": "9.90850000",
                        "longitude": "123.08960000"
                    },
                    {
                        "id": 85009,
                        "name": "Tambo",
                        "latitude": "9.89500000",
                        "longitude": "123.05560000"
                    },
                    {
                        "id": 85013,
                        "name": "Tambongon",
                        "latitude": "10.96770000",
                        "longitude": "123.92440000"
                    },
                    {
                        "id": 85016,
                        "name": "Tamiso",
                        "latitude": "9.63140000",
                        "longitude": "123.08730000"
                    },
                    {
                        "id": 85026,
                        "name": "Tampocon",
                        "latitude": "9.85000000",
                        "longitude": "123.13333000"
                    },
                    {
                        "id": 85032,
                        "name": "Tandayag",
                        "latitude": "9.45470000",
                        "longitude": "123.22990000"
                    },
                    {
                        "id": 85036,
                        "name": "Tangke",
                        "latitude": "10.25451000",
                        "longitude": "123.86516000"
                    },
                    {
                        "id": 85037,
                        "name": "Tangnan",
                        "latitude": "9.60722000",
                        "longitude": "123.77357000"
                    },
                    {
                        "id": 85052,
                        "name": "Tapilon",
                        "latitude": "11.27740000",
                        "longitude": "124.03060000"
                    },
                    {
                        "id": 85053,
                        "name": "Tapon",
                        "latitude": "10.06310000",
                        "longitude": "123.44530000"
                    },
                    {
                        "id": 85066,
                        "name": "Tawala",
                        "latitude": "9.55421000",
                        "longitude": "123.76955000"
                    },
                    {
                        "id": 85079,
                        "name": "Taytayan",
                        "latitude": "10.87870000",
                        "longitude": "123.97710000"
                    },
                    {
                        "id": 85080,
                        "name": "Tayud",
                        "latitude": "10.37991000",
                        "longitude": "124.00522000"
                    },
                    {
                        "id": 85096,
                        "name": "Tibigan",
                        "latitude": "9.95180000",
                        "longitude": "123.96220000"
                    },
                    {
                        "id": 85115,
                        "name": "Tiguib",
                        "latitude": "9.80080000",
                        "longitude": "123.13520000"
                    },
                    {
                        "id": 85124,
                        "name": "Tinaan",
                        "latitude": "11.26667000",
                        "longitude": "123.75000000"
                    },
                    {
                        "id": 85132,
                        "name": "Tinaogan",
                        "latitude": "9.77910000",
                        "longitude": "123.15030000"
                    },
                    {
                        "id": 85134,
                        "name": "Tindog",
                        "latitude": "11.12470000",
                        "longitude": "124.01180000"
                    },
                    {
                        "id": 85141,
                        "name": "Tinubuan",
                        "latitude": "11.18600000",
                        "longitude": "124.00780000"
                    },
                    {
                        "id": 85146,
                        "name": "Tipolo",
                        "latitude": "10.01960000",
                        "longitude": "124.51440000"
                    },
                    {
                        "id": 85165,
                        "name": "Tominhao",
                        "latitude": "11.23563000",
                        "longitude": "124.03526000"
                    },
                    {
                        "id": 85174,
                        "name": "Totolan",
                        "latitude": "9.63286000",
                        "longitude": "123.84702000"
                    },
                    {
                        "id": 85179,
                        "name": "Trinidad",
                        "latitude": "10.07955000",
                        "longitude": "124.34324000"
                    },
                    {
                        "id": 85189,
                        "name": "Tubigagmanoc",
                        "latitude": "10.62820000",
                        "longitude": "123.74890000"
                    },
                    {
                        "id": 85197,
                        "name": "Tubod-dugoan",
                        "latitude": "10.04430000",
                        "longitude": "123.49940000"
                    },
                    {
                        "id": 85234,
                        "name": "Tutay",
                        "latitude": "10.24630000",
                        "longitude": "123.58050000"
                    },
                    {
                        "id": 85241,
                        "name": "Ubay",
                        "latitude": "10.05600000",
                        "longitude": "124.47294000"
                    },
                    {
                        "id": 85246,
                        "name": "Uling",
                        "latitude": "10.28048000",
                        "longitude": "123.71000000"
                    },
                    {
                        "id": 85258,
                        "name": "Union",
                        "latitude": "10.66950000",
                        "longitude": "124.32520000"
                    },
                    {
                        "id": 85279,
                        "name": "Valle Hermoso",
                        "latitude": "9.79390000",
                        "longitude": "124.23650000"
                    }
                ]
            },
            {
                "id": 1352,
                "name": "Batanes",
                "iso2": "BTN",
                "latitude": "20.44850740",
                "longitude": "121.97081290",
                "type": "province",
                "cities": [
                    {
                        "id": 81236,
                        "name": "Alugan",
                        "latitude": "12.21880000",
                        "longitude": "125.48080000"
                    },
                    {
                        "id": 81274,
                        "name": "Anito",
                        "latitude": "12.44972000",
                        "longitude": "125.28861000"
                    },
                    {
                        "id": 81435,
                        "name": "Balagtas",
                        "latitude": "11.13330000",
                        "longitude": "124.51920000"
                    },
                    {
                        "id": 81437,
                        "name": "Balagui",
                        "latitude": "11.47520000",
                        "longitude": "124.53240000"
                    },
                    {
                        "id": 81480,
                        "name": "Balinsacayao",
                        "latitude": "10.68100000",
                        "longitude": "124.95950000"
                    },
                    {
                        "id": 81491,
                        "name": "Balocawehay",
                        "latitude": "10.72210000",
                        "longitude": "124.96780000"
                    },
                    {
                        "id": 81496,
                        "name": "Balogo",
                        "latitude": "10.88680000",
                        "longitude": "124.71050000"
                    },
                    {
                        "id": 81555,
                        "name": "Bantiqui",
                        "latitude": "10.92450000",
                        "longitude": "124.41540000"
                    },
                    {
                        "id": 81567,
                        "name": "Baras",
                        "latitude": "11.18333000",
                        "longitude": "125.01667000"
                    },
                    {
                        "id": 81609,
                        "name": "Basud",
                        "latitude": "11.36630000",
                        "longitude": "124.36310000"
                    },
                    {
                        "id": 81705,
                        "name": "Bilwang",
                        "latitude": "10.88340000",
                        "longitude": "124.46670000"
                    },
                    {
                        "id": 81742,
                        "name": "Bitanjuan",
                        "latitude": "10.59550000",
                        "longitude": "124.76630000"
                    },
                    {
                        "id": 81846,
                        "name": "Bugho",
                        "latitude": "10.79210000",
                        "longitude": "124.93640000"
                    },
                    {
                        "id": 81847,
                        "name": "Bugko",
                        "latitude": "12.53560000",
                        "longitude": "124.79230000"
                    },
                    {
                        "id": 81894,
                        "name": "Bunga",
                        "latitude": "11.48380000",
                        "longitude": "124.59180000"
                    },
                    {
                        "id": 81922,
                        "name": "Butazon",
                        "latitude": "11.30720000",
                        "longitude": "124.46200000"
                    },
                    {
                        "id": 81936,
                        "name": "Cabacuñgan",
                        "latitude": "10.93333000",
                        "longitude": "124.98167000"
                    },
                    {
                        "id": 81960,
                        "name": "Cabay",
                        "latitude": "11.44556000",
                        "longitude": "125.49333000"
                    },
                    {
                        "id": 81973,
                        "name": "Cabodiongan",
                        "latitude": "12.66430000",
                        "longitude": "125.04560000"
                    },
                    {
                        "id": 81992,
                        "name": "Cagamotan",
                        "latitude": "12.35583000",
                        "longitude": "125.28391000"
                    },
                    {
                        "id": 82032,
                        "name": "Calape",
                        "latitude": "11.94250000",
                        "longitude": "125.02139000"
                    },
                    {
                        "id": 82114,
                        "name": "Canhandugan",
                        "latitude": "11.13500000",
                        "longitude": "124.77972000"
                    },
                    {
                        "id": 82155,
                        "name": "Caraycaray",
                        "latitude": "11.55510000",
                        "longitude": "124.41500000"
                    },
                    {
                        "id": 82161,
                        "name": "Caridad",
                        "latitude": "10.83150000",
                        "longitude": "124.75180000"
                    },
                    {
                        "id": 82284,
                        "name": "Consuegra",
                        "latitude": "11.29760000",
                        "longitude": "124.51240000"
                    },
                    {
                        "id": 82313,
                        "name": "Culasian",
                        "latitude": "11.30694000",
                        "longitude": "124.61056000"
                    },
                    {
                        "id": 82377,
                        "name": "Dapdap",
                        "latitude": "12.06200000",
                        "longitude": "125.48810000"
                    },
                    {
                        "id": 82462,
                        "name": "Doos",
                        "latitude": "10.46528000",
                        "longitude": "124.72944000"
                    },
                    {
                        "id": 82512,
                        "name": "Erenas",
                        "latitude": "12.42450000",
                        "longitude": "124.32380000"
                    },
                    {
                        "id": 82545,
                        "name": "Gabas",
                        "latitude": "10.72970000",
                        "longitude": "124.79610000"
                    },
                    {
                        "id": 82594,
                        "name": "Ginabuyan",
                        "latitude": "11.23830000",
                        "longitude": "124.40470000"
                    },
                    {
                        "id": 82631,
                        "name": "Guindapunan",
                        "latitude": "11.30278000",
                        "longitude": "124.70583000"
                    },
                    {
                        "id": 82645,
                        "name": "Guirang",
                        "latitude": "11.35000000",
                        "longitude": "125.11667000"
                    },
                    {
                        "id": 82695,
                        "name": "Hingatungan",
                        "latitude": "10.58400000",
                        "longitude": "125.18520000"
                    },
                    {
                        "id": 82700,
                        "name": "Hipadpad",
                        "latitude": "12.28550000",
                        "longitude": "125.23610000"
                    },
                    {
                        "id": 82701,
                        "name": "Hipasngo",
                        "latitude": "10.66240000",
                        "longitude": "124.80850000"
                    },
                    {
                        "id": 82710,
                        "name": "Ibarra",
                        "latitude": "10.12472000",
                        "longitude": "124.88417000"
                    },
                    {
                        "id": 82712,
                        "name": "Ichon",
                        "latitude": "10.09495000",
                        "longitude": "124.90168000"
                    },
                    {
                        "id": 82741,
                        "name": "Inangatan",
                        "latitude": "11.25000000",
                        "longitude": "124.40000000"
                    },
                    {
                        "id": 82755,
                        "name": "Ipil",
                        "latitude": "10.97472000",
                        "longitude": "124.63639000"
                    },
                    {
                        "id": 82817,
                        "name": "Jubasan",
                        "latitude": "12.48440000",
                        "longitude": "124.28720000"
                    },
                    {
                        "id": 82833,
                        "name": "Kabuynan",
                        "latitude": "11.08056000",
                        "longitude": "125.02472000"
                    },
                    {
                        "id": 82859,
                        "name": "Kampokpok",
                        "latitude": "11.29620000",
                        "longitude": "124.40500000"
                    },
                    {
                        "id": 82860,
                        "name": "Kananya",
                        "latitude": "11.18670000",
                        "longitude": "124.56010000"
                    },
                    {
                        "id": 82900,
                        "name": "Kilim",
                        "latitude": "10.71180000",
                        "longitude": "124.79680000"
                    },
                    {
                        "id": 82990,
                        "name": "Lalauigan",
                        "latitude": "11.58917000",
                        "longitude": "125.46972000"
                    },
                    {
                        "id": 82993,
                        "name": "Lamak",
                        "latitude": "10.39972000",
                        "longitude": "124.73889000"
                    },
                    {
                        "id": 83026,
                        "name": "Lao",
                        "latitude": "11.01806000",
                        "longitude": "124.55972000"
                    },
                    {
                        "id": 83078,
                        "name": "Libas",
                        "latitude": "10.93880000",
                        "longitude": "124.54500000"
                    },
                    {
                        "id": 83090,
                        "name": "Liberty",
                        "latitude": "10.87417000",
                        "longitude": "125.00250000"
                    },
                    {
                        "id": 83114,
                        "name": "Lim-oo",
                        "latitude": "11.15083000",
                        "longitude": "124.63083000"
                    },
                    {
                        "id": 83123,
                        "name": "Limon",
                        "latitude": "11.28890000",
                        "longitude": "124.56710000"
                    },
                    {
                        "id": 83261,
                        "name": "Maasin",
                        "latitude": "10.13361000",
                        "longitude": "124.84472000"
                    },
                    {
                        "id": 83282,
                        "name": "Mabini",
                        "latitude": "11.41667000",
                        "longitude": "125.16667000"
                    },
                    {
                        "id": 83379,
                        "name": "Makiwalo",
                        "latitude": "12.51010000",
                        "longitude": "124.70600000"
                    },
                    {
                        "id": 83392,
                        "name": "Malaga",
                        "latitude": "12.23686000",
                        "longitude": "124.37529000"
                    },
                    {
                        "id": 83396,
                        "name": "Malajog",
                        "latitude": "12.11020000",
                        "longitude": "124.47930000"
                    },
                    {
                        "id": 83430,
                        "name": "Malilinao",
                        "latitude": "11.10694000",
                        "longitude": "124.50111000"
                    },
                    {
                        "id": 83538,
                        "name": "Mantang",
                        "latitude": "11.87000000",
                        "longitude": "125.42833000"
                    },
                    {
                        "id": 83571,
                        "name": "Margen",
                        "latitude": "11.01722000",
                        "longitude": "124.52833000"
                    },
                    {
                        "id": 83598,
                        "name": "Masarayao",
                        "latitude": "11.08972000",
                        "longitude": "124.61750000"
                    },
                    {
                        "id": 83630,
                        "name": "Matlang",
                        "latitude": "10.89020000",
                        "longitude": "124.45540000"
                    },
                    {
                        "id": 83653,
                        "name": "Maypangdan",
                        "latitude": "11.65194000",
                        "longitude": "125.45028000"
                    },
                    {
                        "id": 83746,
                        "name": "Naghalin",
                        "latitude": "11.14560000",
                        "longitude": "124.56710000"
                    },
                    {
                        "id": 83779,
                        "name": "Napuro",
                        "latitude": "12.02730000",
                        "longitude": "124.70820000"
                    },
                    {
                        "id": 83798,
                        "name": "Nena",
                        "latitude": "11.76583000",
                        "longitude": "125.41778000"
                    },
                    {
                        "id": 83799,
                        "name": "Nenita",
                        "latitude": "12.49167000",
                        "longitude": "124.80444000"
                    },
                    {
                        "id": 83914,
                        "name": "Palanit",
                        "latitude": "12.32134000",
                        "longitude": "124.34341000"
                    },
                    {
                        "id": 83916,
                        "name": "Palaroo",
                        "latitude": "11.40560000",
                        "longitude": "124.48300000"
                    },
                    {
                        "id": 83922,
                        "name": "Palhi",
                        "latitude": "10.64980000",
                        "longitude": "124.80620000"
                    },
                    {
                        "id": 83947,
                        "name": "Panalanoy",
                        "latitude": "11.25111000",
                        "longitude": "125.00639000"
                    },
                    {
                        "id": 83976,
                        "name": "Pangdan",
                        "latitude": "11.74444000",
                        "longitude": "124.91667000"
                    },
                    {
                        "id": 83981,
                        "name": "Pangpang",
                        "latitude": "12.56920000",
                        "longitude": "125.07400000"
                    },
                    {
                        "id": 84050,
                        "name": "Patong",
                        "latitude": "12.33643000",
                        "longitude": "125.28521000"
                    },
                    {
                        "id": 84064,
                        "name": "Pawing",
                        "latitude": "11.18000000",
                        "longitude": "125.00278000"
                    },
                    {
                        "id": 84126,
                        "name": "Piña",
                        "latitude": "12.19078000",
                        "longitude": "124.40150000"
                    },
                    {
                        "id": 84105,
                        "name": "Pinamopoan",
                        "latitude": "11.31472000",
                        "longitude": "124.57389000"
                    },
                    {
                        "id": 84132,
                        "name": "Plaridel",
                        "latitude": "10.56670000",
                        "longitude": "124.76450000"
                    },
                    {
                        "id": 84141,
                        "name": "Polahongon",
                        "latitude": "10.52880000",
                        "longitude": "124.96940000"
                    },
                    {
                        "id": 84144,
                        "name": "Polañge",
                        "latitude": "12.39667000",
                        "longitude": "124.63111000"
                    },
                    {
                        "id": 84207,
                        "name": "Province of Eastern Samar",
                        "latitude": "11.53054000",
                        "longitude": "125.47647000"
                    },
                    {
                        "id": 84218,
                        "name": "Province of Leyte",
                        "latitude": "11.08138000",
                        "longitude": "124.82666000"
                    },
                    {
                        "id": 84228,
                        "name": "Province of Northern Samar",
                        "latitude": "12.33333000",
                        "longitude": "124.66667000"
                    },
                    {
                        "id": 84238,
                        "name": "Province of Samar",
                        "latitude": "11.83333000",
                        "longitude": "125.00000000"
                    },
                    {
                        "id": 84243,
                        "name": "Province of Southern Leyte",
                        "latitude": "10.33333000",
                        "longitude": "125.08333000"
                    },
                    {
                        "id": 84258,
                        "name": "Puerto Bello",
                        "latitude": "10.97330000",
                        "longitude": "124.53510000"
                    },
                    {
                        "id": 84308,
                        "name": "Quinapundan",
                        "latitude": "11.15833000",
                        "longitude": "125.52194000"
                    },
                    {
                        "id": 84366,
                        "name": "Sabang",
                        "latitude": "12.07460000",
                        "longitude": "124.54140000"
                    },
                    {
                        "id": 84420,
                        "name": "Salvacion",
                        "latitude": "12.61510000",
                        "longitude": "125.03900000"
                    },
                    {
                        "id": 84452,
                        "name": "San Antonio",
                        "latitude": "12.41290000",
                        "longitude": "124.27910000"
                    },
                    {
                        "id": 84467,
                        "name": "San Eduardo",
                        "latitude": "12.16790000",
                        "longitude": "125.45030000"
                    },
                    {
                        "id": 84510,
                        "name": "San Joaquin",
                        "latitude": "12.16697000",
                        "longitude": "124.43003000"
                    },
                    {
                        "id": 84587,
                        "name": "San Pedro",
                        "latitude": "10.96100000",
                        "longitude": "124.81970000"
                    },
                    {
                        "id": 84591,
                        "name": "San Policarpio",
                        "latitude": "12.06860000",
                        "longitude": "124.56950000"
                    },
                    {
                        "id": 84612,
                        "name": "San Sebastian",
                        "latitude": "11.71000000",
                        "longitude": "125.01806000"
                    },
                    {
                        "id": 84621,
                        "name": "San Vicente",
                        "latitude": "11.11830000",
                        "longitude": "124.56570000"
                    },
                    {
                        "id": 84694,
                        "name": "Santa Paz",
                        "latitude": "10.26667000",
                        "longitude": "124.78333000"
                    },
                    {
                        "id": 84722,
                        "name": "Santo Niño",
                        "latitude": "11.92630000",
                        "longitude": "124.44920000"
                    },
                    {
                        "id": 84787,
                        "name": "Siguinon",
                        "latitude": "10.94230000",
                        "longitude": "124.68060000"
                    },
                    {
                        "id": 84793,
                        "name": "Silanga",
                        "latitude": "11.81806000",
                        "longitude": "124.84306000"
                    },
                    {
                        "id": 84865,
                        "name": "Sulangan",
                        "latitude": "10.93600000",
                        "longitude": "125.82640000"
                    },
                    {
                        "id": 84898,
                        "name": "Tabing",
                        "latitude": "11.40000000",
                        "longitude": "124.35000000"
                    },
                    {
                        "id": 84907,
                        "name": "Tabonoc",
                        "latitude": "10.35000000",
                        "longitude": "124.80000000"
                    },
                    {
                        "id": 84938,
                        "name": "Tagbubungang Diot",
                        "latitude": "11.12570000",
                        "longitude": "124.40280000"
                    },
                    {
                        "id": 85129,
                        "name": "Tinambacan",
                        "latitude": "12.09430000",
                        "longitude": "124.50250000"
                    },
                    {
                        "id": 85201,
                        "name": "Tucdao",
                        "latitude": "11.70110000",
                        "longitude": "124.47190000"
                    },
                    {
                        "id": 85209,
                        "name": "Tugbong",
                        "latitude": "11.01667000",
                        "longitude": "124.60000000"
                    },
                    {
                        "id": 85235,
                        "name": "Tutubigan",
                        "latitude": "11.83972000",
                        "longitude": "125.06139000"
                    },
                    {
                        "id": 85248,
                        "name": "Umaganhan",
                        "latitude": "11.32920000",
                        "longitude": "124.37700000"
                    },
                    {
                        "id": 85277,
                        "name": "Valencia",
                        "latitude": "11.10889000",
                        "longitude": "124.57250000"
                    },
                    {
                        "id": 85283,
                        "name": "Victoria",
                        "latitude": "12.44722000",
                        "longitude": "124.31111000"
                    },
                    {
                        "id": 85306,
                        "name": "Viriato",
                        "latitude": "12.29031000",
                        "longitude": "124.35333000"
                    },
                    {
                        "id": 85317,
                        "name": "Wright",
                        "latitude": "11.77028000",
                        "longitude": "125.02194000"
                    }
                ]
            },
            {
                "id": 1359,
                "name": "Batangas",
                "iso2": "BTG",
                "latitude": "13.75646510",
                "longitude": "121.05830760",
                "type": "province",
                "cities": [
                    {
                        "id": 81162,
                        "name": "Agoncillo",
                        "latitude": "13.96521120",
                        "longitude": "120.88951970"
                    },
                    {
                        "id": 81221,
                        "name": "Alitagtag",
                        "latitude": "13.87053610",
                        "longitude": "120.97725720"
                    },
                    {
                        "id": 81455,
                        "name": "Balayan",
                        "latitude": "13.95074580",
                        "longitude": "120.64737750"
                    },
                    {
                        "id": 154494,
                        "name": "Balete",
                        "latitude": "14.00985670",
                        "longitude": "121.06021540"
                    },
                    {
                        "id": 81615,
                        "name": "Batangas",
                        "latitude": "13.68745230",
                        "longitude": "120.93977710"
                    },
                    {
                        "id": 81640,
                        "name": "Bauan",
                        "latitude": "13.80183660",
                        "longitude": "120.88691490"
                    },
                    {
                        "id": 82012,
                        "name": "Calaca",
                        "latitude": "13.98655910",
                        "longitude": "120.73686680"
                    },
                    {
                        "id": 82036,
                        "name": "Calatagan",
                        "latitude": "13.84643610",
                        "longitude": "120.57760790"
                    },
                    {
                        "id": 82307,
                        "name": "Cuenca",
                        "latitude": "13.90510380",
                        "longitude": "121.01247750"
                    },
                    {
                        "id": 82707,
                        "name": "Ibaan",
                        "latitude": "13.81660900",
                        "longitude": "121.09821700"
                    },
                    {
                        "id": 83051,
                        "name": "Laurel",
                        "latitude": "14.05013040",
                        "longitude": "120.82716070"
                    },
                    {
                        "id": 83063,
                        "name": "Lemery",
                        "latitude": "13.96294070",
                        "longitude": "120.80381480"
                    },
                    {
                        "id": 83073,
                        "name": "Lian",
                        "latitude": "13.99302760",
                        "longitude": "120.60387500"
                    },
                    {
                        "id": 154495,
                        "name": "Lipa",
                        "latitude": "13.94473300",
                        "longitude": "121.00301570"
                    },
                    {
                        "id": 83158,
                        "name": "Lobo",
                        "latitude": "13.66327100",
                        "longitude": "121.10107990"
                    },
                    {
                        "id": 83465,
                        "name": "Malvar",
                        "latitude": "14.03383520",
                        "longitude": "121.10135440"
                    },
                    {
                        "id": 154496,
                        "name": "Mataasnakahoy",
                        "latitude": "13.98071010",
                        "longitude": "121.08284330"
                    },
                    {
                        "id": 83784,
                        "name": "Nasugbu",
                        "latitude": "14.14465510",
                        "longitude": "120.49992990"
                    },
                    {
                        "id": 83883,
                        "name": "Padre Garcia",
                        "latitude": "13.87999130",
                        "longitude": "121.16823030"
                    },
                    {
                        "id": 154497,
                        "name": "Rosario",
                        "latitude": "13.78366200",
                        "longitude": "121.10029400"
                    },
                    {
                        "id": 154498,
                        "name": "San Jose",
                        "latitude": "13.88153900",
                        "longitude": "121.04820450"
                    },
                    {
                        "id": 154499,
                        "name": "San Juan",
                        "latitude": "13.75800230",
                        "longitude": "121.31789760"
                    },
                    {
                        "id": 154500,
                        "name": "San Luis",
                        "latitude": "13.83949180",
                        "longitude": "120.90745830"
                    },
                    {
                        "id": 84571,
                        "name": "San Nicolas",
                        "latitude": "13.95899570",
                        "longitude": "120.89468790"
                    },
                    {
                        "id": 84578,
                        "name": "San Pascual",
                        "latitude": "13.81713830",
                        "longitude": "120.98481310"
                    },
                    {
                        "id": 84707,
                        "name": "Santa Teresita",
                        "latitude": "13.88665920",
                        "longitude": "120.94870060"
                    },
                    {
                        "id": 84731,
                        "name": "Santo Tomas",
                        "latitude": "14.06512290",
                        "longitude": "121.10148620"
                    },
                    {
                        "id": 84888,
                        "name": "Taal",
                        "latitude": "13.89032270",
                        "longitude": "120.89690100"
                    },
                    {
                        "id": 84984,
                        "name": "Talisay",
                        "latitude": "14.07719980",
                        "longitude": "120.92668130"
                    },
                    {
                        "id": 85028,
                        "name": "Tanauan",
                        "latitude": "14.09139490",
                        "longitude": "121.02628790"
                    },
                    {
                        "id": 85074,
                        "name": "Taysan",
                        "latitude": "13.75887780",
                        "longitude": "121.14322940"
                    },
                    {
                        "id": 85136,
                        "name": "Tingloy",
                        "latitude": "13.66181700",
                        "longitude": "120.81492970"
                    },
                    {
                        "id": 85236,
                        "name": "Tuy",
                        "latitude": "14.03082800",
                        "longitude": "120.65923290"
                    }
                ]
            },
            {
                "id": 1363,
                "name": "Benguet",
                "iso2": "BEN",
                "latitude": "16.55772570",
                "longitude": "120.80394740",
                "type": "province",
                "cities": [
                    {
                        "id": 81148,
                        "name": "Adtugan",
                        "latitude": "7.81194000",
                        "longitude": "124.85444000"
                    },
                    {
                        "id": 81160,
                        "name": "Aglayan",
                        "latitude": "8.05500000",
                        "longitude": "125.13417000"
                    },
                    {
                        "id": 81172,
                        "name": "Agusan",
                        "latitude": "8.49056000",
                        "longitude": "124.73722000"
                    },
                    {
                        "id": 81182,
                        "name": "Alae",
                        "latitude": "8.42444000",
                        "longitude": "124.81278000"
                    },
                    {
                        "id": 81189,
                        "name": "Alanib",
                        "latitude": "8.02778000",
                        "longitude": "124.98611000"
                    },
                    {
                        "id": 81255,
                        "name": "Anakan",
                        "latitude": "8.84778000",
                        "longitude": "125.15139000"
                    },
                    {
                        "id": 81270,
                        "name": "Ani-e",
                        "latitude": "8.61361000",
                        "longitude": "124.87056000"
                    },
                    {
                        "id": 81296,
                        "name": "Aplaya",
                        "latitude": "8.60861000",
                        "longitude": "124.76806000"
                    },
                    {
                        "id": 81330,
                        "name": "Aumbay",
                        "latitude": "7.10260000",
                        "longitude": "125.78370000"
                    },
                    {
                        "id": 81389,
                        "name": "Bagakay",
                        "latitude": "8.14540000",
                        "longitude": "123.81570000"
                    },
                    {
                        "id": 81419,
                        "name": "Baikingon",
                        "latitude": "8.47222000",
                        "longitude": "124.55361000"
                    },
                    {
                        "id": 81469,
                        "name": "Balila",
                        "latitude": "8.00278000",
                        "longitude": "125.01306000"
                    },
                    {
                        "id": 81470,
                        "name": "Balili",
                        "latitude": "7.89500000",
                        "longitude": "123.73370000"
                    },
                    {
                        "id": 81488,
                        "name": "Baliwagan",
                        "latitude": "8.71861000",
                        "longitude": "124.79056000"
                    },
                    {
                        "id": 81526,
                        "name": "Bangahan",
                        "latitude": "7.79634000",
                        "longitude": "124.73361000"
                    },
                    {
                        "id": 81558,
                        "name": "Bantuanon",
                        "latitude": "8.01528000",
                        "longitude": "125.07083000"
                    },
                    {
                        "id": 81587,
                        "name": "Barra",
                        "latitude": "8.51028000",
                        "longitude": "124.60444000"
                    },
                    {
                        "id": 81593,
                        "name": "Basak",
                        "latitude": "8.04111000",
                        "longitude": "124.86278000"
                    },
                    {
                        "id": 81693,
                        "name": "Biga",
                        "latitude": "8.35778000",
                        "longitude": "124.25972000"
                    },
                    {
                        "id": 81722,
                        "name": "Binitinan",
                        "latitude": "8.71000000",
                        "longitude": "124.77556000"
                    },
                    {
                        "id": 81779,
                        "name": "Bolo Bolo",
                        "latitude": "8.55833000",
                        "longitude": "124.53000000"
                    },
                    {
                        "id": 81785,
                        "name": "Bonbon",
                        "latitude": "9.10528000",
                        "longitude": "124.73389000"
                    },
                    {
                        "id": 81799,
                        "name": "Boroon",
                        "latitude": "8.18278000",
                        "longitude": "124.17701000"
                    },
                    {
                        "id": 81845,
                        "name": "Bugcaon",
                        "latitude": "8.04583000",
                        "longitude": "125.11278000"
                    },
                    {
                        "id": 81848,
                        "name": "Bugo",
                        "latitude": "8.50833000",
                        "longitude": "124.75944000"
                    },
                    {
                        "id": 81916,
                        "name": "Busdi",
                        "latitude": "8.27611000",
                        "longitude": "125.25139000"
                    },
                    {
                        "id": 81948,
                        "name": "Cabangahan",
                        "latitude": "8.02278000",
                        "longitude": "125.13750000"
                    },
                    {
                        "id": 81950,
                        "name": "Cabanglasan",
                        "latitude": "8.12139000",
                        "longitude": "125.32750000"
                    },
                    {
                        "id": 82011,
                        "name": "Calabugao",
                        "latitude": "8.45639000",
                        "longitude": "125.15889000"
                    },
                    {
                        "id": 82104,
                        "name": "Canayan",
                        "latitude": "8.19556000",
                        "longitude": "125.14472000"
                    },
                    {
                        "id": 82110,
                        "name": "Candiis",
                        "latitude": "8.97028000",
                        "longitude": "125.18417000"
                    },
                    {
                        "id": 82176,
                        "name": "Caromatan",
                        "latitude": "7.79590000",
                        "longitude": "123.71450000"
                    },
                    {
                        "id": 82193,
                        "name": "Casisang",
                        "latitude": "8.13806000",
                        "longitude": "125.12500000"
                    },
                    {
                        "id": 82287,
                        "name": "Consuelo",
                        "latitude": "8.90167000",
                        "longitude": "125.18750000"
                    },
                    {
                        "id": 82301,
                        "name": "Cosina",
                        "latitude": "8.10611000",
                        "longitude": "124.61972000"
                    },
                    {
                        "id": 82338,
                        "name": "Dagumba-an",
                        "latitude": "8.15306000",
                        "longitude": "124.59083000"
                    },
                    {
                        "id": 82350,
                        "name": "Dalipuga",
                        "latitude": "8.31583000",
                        "longitude": "124.25472000"
                    },
                    {
                        "id": 82351,
                        "name": "Dalirig",
                        "latitude": "8.37722000",
                        "longitude": "124.90139000"
                    },
                    {
                        "id": 82352,
                        "name": "Dalorong",
                        "latitude": "7.58583000",
                        "longitude": "125.13278000"
                    },
                    {
                        "id": 82356,
                        "name": "Dalwangan",
                        "latitude": "8.20056000",
                        "longitude": "125.04056000"
                    },
                    {
                        "id": 82361,
                        "name": "Damilag",
                        "latitude": "8.35472000",
                        "longitude": "124.81222000"
                    },
                    {
                        "id": 82365,
                        "name": "Damulog",
                        "latitude": "7.48361000",
                        "longitude": "124.94306000"
                    },
                    {
                        "id": 82367,
                        "name": "Dancagan",
                        "latitude": "7.60917000",
                        "longitude": "125.00417000"
                    },
                    {
                        "id": 82428,
                        "name": "Dimaluna",
                        "latitude": "8.12180000",
                        "longitude": "123.79950000"
                    },
                    {
                        "id": 82431,
                        "name": "Dimayon",
                        "latitude": "8.06667000",
                        "longitude": "124.15000000"
                    },
                    {
                        "id": 82451,
                        "name": "Dologon",
                        "latitude": "7.84083000",
                        "longitude": "125.04444000"
                    },
                    {
                        "id": 82458,
                        "name": "Don Carlos",
                        "latitude": "7.68000000",
                        "longitude": "125.00500000"
                    },
                    {
                        "id": 82464,
                        "name": "Dorsalanam",
                        "latitude": "8.30667000",
                        "longitude": "124.58556000"
                    },
                    {
                        "id": 82484,
                        "name": "Dumalaguing",
                        "latitude": "8.34694000",
                        "longitude": "125.05500000"
                    },
                    {
                        "id": 82593,
                        "name": "Gimampang",
                        "latitude": "8.47139000",
                        "longitude": "124.29667000"
                    },
                    {
                        "id": 82635,
                        "name": "Guinisiliban",
                        "latitude": "9.09639000",
                        "longitude": "124.78278000"
                    },
                    {
                        "id": 82671,
                        "name": "Halapitan",
                        "latitude": "7.91750000",
                        "longitude": "125.33000000"
                    },
                    {
                        "id": 82692,
                        "name": "Hinapalanan",
                        "latitude": "8.64028000",
                        "longitude": "124.87306000"
                    },
                    {
                        "id": 82721,
                        "name": "Igpit",
                        "latitude": "8.51083000",
                        "longitude": "124.58667000"
                    },
                    {
                        "id": 82734,
                        "name": "Imbatug",
                        "latitude": "8.05444000",
                        "longitude": "125.28389000"
                    },
                    {
                        "id": 82735,
                        "name": "Imelda",
                        "latitude": "7.64703000",
                        "longitude": "122.95349000"
                    },
                    {
                        "id": 82737,
                        "name": "Impalutao",
                        "latitude": "8.25778000",
                        "longitude": "125.02750000"
                    },
                    {
                        "id": 82747,
                        "name": "Indulang",
                        "latitude": "8.09028000",
                        "longitude": "124.58444000"
                    },
                    {
                        "id": 82753,
                        "name": "Inobulan",
                        "latitude": "8.88639000",
                        "longitude": "124.79472000"
                    },
                    {
                        "id": 82822,
                        "name": "Kabalantian",
                        "latitude": "8.37083000",
                        "longitude": "124.32750000"
                    },
                    {
                        "id": 82830,
                        "name": "Kabulohan",
                        "latitude": "8.04333000",
                        "longitude": "125.27667000"
                    },
                    {
                        "id": 82834,
                        "name": "Kadingilan",
                        "latitude": "7.60111000",
                        "longitude": "124.90861000"
                    },
                    {
                        "id": 82843,
                        "name": "Kalanganan",
                        "latitude": "8.08333000",
                        "longitude": "124.24667000"
                    },
                    {
                        "id": 82852,
                        "name": "Kalilangan",
                        "latitude": "7.74514000",
                        "longitude": "124.74777000"
                    },
                    {
                        "id": 82856,
                        "name": "Kalugmanan",
                        "latitude": "8.27778000",
                        "longitude": "124.85972000"
                    },
                    {
                        "id": 82893,
                        "name": "Kibangay",
                        "latitude": "8.04972000",
                        "longitude": "124.89306000"
                    },
                    {
                        "id": 82894,
                        "name": "Kibawe",
                        "latitude": "7.56861000",
                        "longitude": "124.98778000"
                    },
                    {
                        "id": 82896,
                        "name": "Kibonsod",
                        "latitude": "9.00694000",
                        "longitude": "125.20944000"
                    },
                    {
                        "id": 82898,
                        "name": "Kibureau",
                        "latitude": "7.69750000",
                        "longitude": "125.23250000"
                    },
                    {
                        "id": 82902,
                        "name": "Kimanuit",
                        "latitude": "7.76039000",
                        "longitude": "124.72497000"
                    },
                    {
                        "id": 82903,
                        "name": "Kimaya",
                        "latitude": "8.56472000",
                        "longitude": "124.83972000"
                    },
                    {
                        "id": 82914,
                        "name": "Kisolon",
                        "latitude": "8.33000000",
                        "longitude": "124.97694000"
                    },
                    {
                        "id": 82916,
                        "name": "Kitaotao",
                        "latitude": "7.63972000",
                        "longitude": "125.00889000"
                    },
                    {
                        "id": 82919,
                        "name": "Kitobo",
                        "latitude": "7.57444000",
                        "longitude": "125.10500000"
                    },
                    {
                        "id": 82940,
                        "name": "La Fortuna",
                        "latitude": "8.27972000",
                        "longitude": "125.00139000"
                    },
                    {
                        "id": 82952,
                        "name": "La Roxas",
                        "latitude": "7.86417000",
                        "longitude": "124.88694000"
                    },
                    {
                        "id": 82977,
                        "name": "Lagindingan",
                        "latitude": "8.57472000",
                        "longitude": "124.44222000"
                    },
                    {
                        "id": 82982,
                        "name": "Laguitas",
                        "latitude": "8.08917000",
                        "longitude": "125.13056000"
                    },
                    {
                        "id": 83013,
                        "name": "Langcangan",
                        "latitude": "8.47944000",
                        "longitude": "123.75583000"
                    },
                    {
                        "id": 83019,
                        "name": "Lanipao",
                        "latitude": "7.95528000",
                        "longitude": "123.77667000"
                    },
                    {
                        "id": 83024,
                        "name": "Lantapan",
                        "latitude": "7.99778000",
                        "longitude": "125.02778000"
                    },
                    {
                        "id": 83030,
                        "name": "Lapase",
                        "latitude": "8.19240000",
                        "longitude": "123.86320000"
                    },
                    {
                        "id": 83035,
                        "name": "Lapining",
                        "latitude": "7.92270000",
                        "longitude": "123.68830000"
                    },
                    {
                        "id": 83095,
                        "name": "Libona",
                        "latitude": "8.33889000",
                        "longitude": "124.73528000"
                    },
                    {
                        "id": 83096,
                        "name": "Liboran",
                        "latitude": "8.35472000",
                        "longitude": "124.64889000"
                    },
                    {
                        "id": 83119,
                        "name": "Limbaan",
                        "latitude": "7.63960000",
                        "longitude": "125.82090000"
                    },
                    {
                        "id": 83128,
                        "name": "Linabo",
                        "latitude": "8.05417000",
                        "longitude": "125.15500000"
                    },
                    {
                        "id": 83138,
                        "name": "Lingating",
                        "latitude": "8.33167000",
                        "longitude": "124.62889000"
                    },
                    {
                        "id": 83141,
                        "name": "Lingion",
                        "latitude": "8.18806000",
                        "longitude": "124.60972000"
                    },
                    {
                        "id": 83151,
                        "name": "Little Baguio",
                        "latitude": "7.89389000",
                        "longitude": "125.27639000"
                    },
                    {
                        "id": 83172,
                        "name": "Looc",
                        "latitude": "8.84333000",
                        "longitude": "124.79167000"
                    },
                    {
                        "id": 83186,
                        "name": "Lourdes",
                        "latitude": "8.52500000",
                        "longitude": "124.43222000"
                    },
                    {
                        "id": 83222,
                        "name": "Lumbayao",
                        "latitude": "8.01667000",
                        "longitude": "125.16667000"
                    },
                    {
                        "id": 83223,
                        "name": "Lumbia",
                        "latitude": "8.39583000",
                        "longitude": "124.59389000"
                    },
                    {
                        "id": 83235,
                        "name": "Lunao",
                        "latitude": "8.85028000",
                        "longitude": "125.05639000"
                    },
                    {
                        "id": 83247,
                        "name": "Lurugan",
                        "latitude": "8.01667000",
                        "longitude": "124.96667000"
                    },
                    {
                        "id": 83256,
                        "name": "Maanas",
                        "latitude": "8.89389000",
                        "longitude": "125.03083000"
                    },
                    {
                        "id": 83336,
                        "name": "Maglamin",
                        "latitude": "8.05194000",
                        "longitude": "125.26167000"
                    },
                    {
                        "id": 83366,
                        "name": "Mailag",
                        "latitude": "7.97028000",
                        "longitude": "125.13750000"
                    },
                    {
                        "id": 83418,
                        "name": "Malaybalay",
                        "latitude": "8.15750000",
                        "longitude": "125.12778000"
                    },
                    {
                        "id": 83439,
                        "name": "Malinaw",
                        "latitude": "8.82500000",
                        "longitude": "125.19306000"
                    },
                    {
                        "id": 83459,
                        "name": "Maluko",
                        "latitude": "8.37500000",
                        "longitude": "124.95389000"
                    },
                    {
                        "id": 83473,
                        "name": "Mambatangan",
                        "latitude": "8.43333000",
                        "longitude": "124.83333000"
                    },
                    {
                        "id": 83474,
                        "name": "Mambayaan",
                        "latitude": "8.78278000",
                        "longitude": "124.78417000"
                    },
                    {
                        "id": 83481,
                        "name": "Mamungan",
                        "latitude": "8.11722000",
                        "longitude": "124.21861000"
                    },
                    {
                        "id": 83485,
                        "name": "Managok",
                        "latitude": "8.02889000",
                        "longitude": "125.18861000"
                    },
                    {
                        "id": 83490,
                        "name": "Mananum",
                        "latitude": "8.83333000",
                        "longitude": "124.95000000"
                    },
                    {
                        "id": 83502,
                        "name": "Mandangoa",
                        "latitude": "8.77278000",
                        "longitude": "124.79111000"
                    },
                    {
                        "id": 83532,
                        "name": "Manolo Fortich",
                        "latitude": "8.36972000",
                        "longitude": "124.86444000"
                    },
                    {
                        "id": 83537,
                        "name": "Mantampay",
                        "latitude": "8.16667000",
                        "longitude": "124.21667000"
                    },
                    {
                        "id": 83557,
                        "name": "Maputi",
                        "latitude": "8.44972000",
                        "longitude": "124.29056000"
                    },
                    {
                        "id": 83561,
                        "name": "Maramag",
                        "latitude": "7.76333000",
                        "longitude": "125.00528000"
                    },
                    {
                        "id": 83562,
                        "name": "Maranding",
                        "latitude": "7.92480000",
                        "longitude": "123.77150000"
                    },
                    {
                        "id": 83575,
                        "name": "Maria Cristina",
                        "latitude": "8.16604000",
                        "longitude": "124.20396000"
                    },
                    {
                        "id": 83576,
                        "name": "Mariano",
                        "latitude": "8.83333000",
                        "longitude": "125.11667000"
                    },
                    {
                        "id": 83610,
                        "name": "Mat-i",
                        "latitude": "8.40194000",
                        "longitude": "124.34528000"
                    },
                    {
                        "id": 83619,
                        "name": "Matangad",
                        "latitude": "8.57694000",
                        "longitude": "124.37000000"
                    },
                    {
                        "id": 83668,
                        "name": "Miaray",
                        "latitude": "7.57472000",
                        "longitude": "125.04444000"
                    },
                    {
                        "id": 83686,
                        "name": "Minlagas",
                        "latitude": "8.87833000",
                        "longitude": "125.03889000"
                    },
                    {
                        "id": 83696,
                        "name": "Molugan",
                        "latitude": "8.53750000",
                        "longitude": "124.56222000"
                    },
                    {
                        "id": 83709,
                        "name": "Moog",
                        "latitude": "8.60111000",
                        "longitude": "124.46583000"
                    },
                    {
                        "id": 83797,
                        "name": "Nañgka",
                        "latitude": "8.16667000",
                        "longitude": "124.18333000"
                    },
                    {
                        "id": 83776,
                        "name": "Napalitan",
                        "latitude": "8.77528000",
                        "longitude": "124.80222000"
                    },
                    {
                        "id": 83785,
                        "name": "Natalungan",
                        "latitude": "7.53167000",
                        "longitude": "125.02361000"
                    },
                    {
                        "id": 83731,
                        "name": "NIA Valencia",
                        "latitude": "7.90639000",
                        "longitude": "125.09417000"
                    },
                    {
                        "id": 83941,
                        "name": "Pan-an",
                        "latitude": "8.21917000",
                        "longitude": "123.84028000"
                    },
                    {
                        "id": 83950,
                        "name": "Panalo-on",
                        "latitude": "7.91667000",
                        "longitude": "123.75000000"
                    },
                    {
                        "id": 83968,
                        "name": "Pangabuan",
                        "latitude": "8.05694000",
                        "longitude": "123.69583000"
                    },
                    {
                        "id": 84000,
                        "name": "Pantao-Ragat",
                        "latitude": "8.08333000",
                        "longitude": "124.13333000"
                    },
                    {
                        "id": 84053,
                        "name": "Patrocinio",
                        "latitude": "8.61250000",
                        "longitude": "124.84556000"
                    },
                    {
                        "id": 84110,
                        "name": "Pines",
                        "latitude": "8.45222000",
                        "longitude": "123.80750000"
                    },
                    {
                        "id": 84157,
                        "name": "Pongol",
                        "latitude": "8.27861000",
                        "longitude": "124.74833000"
                    },
                    {
                        "id": 84162,
                        "name": "Pontian",
                        "latitude": "8.28111000",
                        "longitude": "124.90028000"
                    },
                    {
                        "id": 84193,
                        "name": "Province of Bukidnon",
                        "latitude": "8.00000000",
                        "longitude": "125.00000000"
                    },
                    {
                        "id": 84198,
                        "name": "Province of Camiguin",
                        "latitude": "9.16667000",
                        "longitude": "124.75000000"
                    },
                    {
                        "id": 84216,
                        "name": "Province of Lanao del Norte",
                        "latitude": "8.00000000",
                        "longitude": "124.00000000"
                    },
                    {
                        "id": 84224,
                        "name": "Province of Misamis Occidental",
                        "latitude": "8.33333000",
                        "longitude": "123.70000000"
                    },
                    {
                        "id": 84225,
                        "name": "Province of Misamis Oriental",
                        "latitude": "8.75000000",
                        "longitude": "125.00000000"
                    },
                    {
                        "id": 84282,
                        "name": "Punta Silum",
                        "latitude": "8.38167000",
                        "longitude": "124.26944000"
                    },
                    {
                        "id": 84333,
                        "name": "Rebe",
                        "latitude": "7.90760000",
                        "longitude": "123.81550000"
                    },
                    {
                        "id": 84402,
                        "name": "Salawagan",
                        "latitude": "7.70528000",
                        "longitude": "125.11500000"
                    },
                    {
                        "id": 84409,
                        "name": "Salimbalan",
                        "latitude": "8.27417000",
                        "longitude": "124.72194000"
                    },
                    {
                        "id": 84430,
                        "name": "Sampagar",
                        "latitude": "7.51389000",
                        "longitude": "124.95528000"
                    },
                    {
                        "id": 84552,
                        "name": "San Martin",
                        "latitude": "8.56111000",
                        "longitude": "124.77139000"
                    },
                    {
                        "id": 84619,
                        "name": "San Vicente",
                        "latitude": "7.65111000",
                        "longitude": "125.03444000"
                    },
                    {
                        "id": 84635,
                        "name": "Sankanan",
                        "latitude": "8.31556000",
                        "longitude": "124.85806000"
                    },
                    {
                        "id": 84641,
                        "name": "Santa Ana",
                        "latitude": "8.51667000",
                        "longitude": "124.78333000"
                    },
                    {
                        "id": 84790,
                        "name": "Silae",
                        "latitude": "8.15889000",
                        "longitude": "125.28250000"
                    },
                    {
                        "id": 84819,
                        "name": "Sinonoc",
                        "latitude": "8.30960000",
                        "longitude": "123.84610000"
                    },
                    {
                        "id": 84841,
                        "name": "Solana",
                        "latitude": "8.62306000",
                        "longitude": "124.77056000"
                    },
                    {
                        "id": 84859,
                        "name": "Sugbongkogon",
                        "latitude": "8.95694000",
                        "longitude": "124.79111000"
                    },
                    {
                        "id": 84877,
                        "name": "Sumilao",
                        "latitude": "8.28722000",
                        "longitude": "124.94556000"
                    },
                    {
                        "id": 84879,
                        "name": "Sumpong",
                        "latitude": "8.16333000",
                        "longitude": "125.11833000"
                    },
                    {
                        "id": 84880,
                        "name": "Sungai",
                        "latitude": "8.45139000",
                        "longitude": "124.40278000"
                    },
                    {
                        "id": 84895,
                        "name": "Tabid",
                        "latitude": "8.10850000",
                        "longitude": "123.78010000"
                    },
                    {
                        "id": 84902,
                        "name": "Taboc",
                        "latitude": "8.87833000",
                        "longitude": "124.79750000"
                    },
                    {
                        "id": 84922,
                        "name": "Tacub",
                        "latitude": "8.18750000",
                        "longitude": "124.10806000"
                    },
                    {
                        "id": 84968,
                        "name": "Talakag",
                        "latitude": "8.23361000",
                        "longitude": "124.60028000"
                    },
                    {
                        "id": 85073,
                        "name": "Taypano",
                        "latitude": "8.37083000",
                        "longitude": "124.55944000"
                    },
                    {
                        "id": 85098,
                        "name": "Ticala-an",
                        "latitude": "8.03528000",
                        "longitude": "124.62083000"
                    },
                    {
                        "id": 85109,
                        "name": "Tignapalan",
                        "latitude": "8.26389000",
                        "longitude": "124.57472000"
                    },
                    {
                        "id": 85190,
                        "name": "Tubigan",
                        "latitude": "8.53222000",
                        "longitude": "124.31222000"
                    },
                    {
                        "id": 85204,
                        "name": "Tudela",
                        "latitude": "8.24720000",
                        "longitude": "123.84240000"
                    },
                    {
                        "id": 85230,
                        "name": "Tuod",
                        "latitude": "8.34333000",
                        "longitude": "124.35417000"
                    },
                    {
                        "id": 85233,
                        "name": "Tupsan",
                        "latitude": "9.19917000",
                        "longitude": "124.77694000"
                    },
                    {
                        "id": 85256,
                        "name": "Unidos",
                        "latitude": "8.59420000",
                        "longitude": "123.66800000"
                    },
                    {
                        "id": 85322,
                        "name": "Yumbing",
                        "latitude": "9.23930000",
                        "longitude": "124.65780000"
                    }
                ]
            },
            {
                "id": 1304,
                "name": "Bicol",
                "iso2": "05",
                "latitude": "13.42098850",
                "longitude": "123.41367360",
                "type": "region",
                "cities": []
            },
            {
                "id": 1274,
                "name": "Biliran",
                "iso2": "BIL",
                "latitude": "11.58331520",
                "longitude": "124.46418480",
                "type": "province",
                "cities": [
                    {
                        "id": 81228,
                        "name": "Almeria",
                        "latitude": "11.63242470",
                        "longitude": "124.31995460"
                    },
                    {
                        "id": 81703,
                        "name": "Biliran",
                        "latitude": "11.50995020",
                        "longitude": "124.40218050"
                    },
                    {
                        "id": 81977,
                        "name": "Cabucgayan",
                        "latitude": "11.49883130",
                        "longitude": "124.48716360"
                    },
                    {
                        "id": 82001,
                        "name": "Caibiran",
                        "latitude": "11.56853520",
                        "longitude": "124.47346290"
                    },
                    {
                        "id": 82309,
                        "name": "Culaba",
                        "latitude": "11.64583080",
                        "longitude": "124.43380910"
                    },
                    {
                        "id": 154501,
                        "name": "Kawayan",
                        "latitude": "11.67991990",
                        "longitude": "124.32227220"
                    },
                    {
                        "id": 83585,
                        "name": "Maripipi",
                        "latitude": "11.78871460",
                        "longitude": "124.28013220"
                    },
                    {
                        "id": 83793,
                        "name": "Naval",
                        "latitude": "11.57605180",
                        "longitude": "124.21201040"
                    }
                ]
            },
            {
                "id": 1272,
                "name": "Bohol",
                "iso2": "BOH",
                "latitude": "9.84999110",
                "longitude": "124.14354270",
                "type": "province",
                "cities": [
                    {
                        "id": 144112,
                        "name": "Andili",
                        "latitude": "7.46194444",
                        "longitude": "125.97000000"
                    },
                    {
                        "id": 144113,
                        "name": "Andop",
                        "latitude": "7.86111111",
                        "longitude": "125.75388889"
                    },
                    {
                        "id": 144114,
                        "name": "Anibongan",
                        "latitude": "7.39333333",
                        "longitude": "125.71888889"
                    },
                    {
                        "id": 144115,
                        "name": "Astorga",
                        "latitude": "6.90722222",
                        "longitude": "125.45583333"
                    },
                    {
                        "id": 144117,
                        "name": "Babag",
                        "latitude": "7.73305556",
                        "longitude": "126.07138889"
                    },
                    {
                        "id": 144118,
                        "name": "Baculin",
                        "latitude": "7.45250000",
                        "longitude": "126.58416667"
                    },
                    {
                        "id": 144120,
                        "name": "Balagunan",
                        "latitude": "7.49222222",
                        "longitude": "125.52111111"
                    },
                    {
                        "id": 144121,
                        "name": "Balangonan",
                        "latitude": "5.57333333",
                        "longitude": "125.35388889"
                    },
                    {
                        "id": 144122,
                        "name": "Balutakay",
                        "latitude": "6.72111111",
                        "longitude": "125.35166667"
                    },
                    {
                        "id": 144124,
                        "name": "Bansalan",
                        "latitude": "6.78333333",
                        "longitude": "125.21666667"
                    },
                    {
                        "id": 144125,
                        "name": "Bantacan",
                        "latitude": "7.60388889",
                        "longitude": "126.12972222"
                    },
                    {
                        "id": 144126,
                        "name": "Baon",
                        "latitude": "6.79555556",
                        "longitude": "126.08777778"
                    },
                    {
                        "id": 144127,
                        "name": "Baracatan",
                        "latitude": "6.96750000",
                        "longitude": "125.41583333"
                    },
                    {
                        "id": 144128,
                        "name": "Basiawan",
                        "latitude": "6.53416667",
                        "longitude": "125.48694444"
                    },
                    {
                        "id": 144129,
                        "name": "Batiano",
                        "latitude": "7.55333333",
                        "longitude": "126.49083333"
                    },
                    {
                        "id": 144131,
                        "name": "Batobato",
                        "latitude": "6.82527778",
                        "longitude": "126.08444444"
                    },
                    {
                        "id": 144132,
                        "name": "Baylo",
                        "latitude": "7.85527778",
                        "longitude": "126.05555556"
                    },
                    {
                        "id": 144133,
                        "name": "Biao",
                        "latitude": "7.16333333",
                        "longitude": "125.52111111"
                    },
                    {
                        "id": 144134,
                        "name": "Bincoñgan",
                        "latitude": "7.36666667",
                        "longitude": "125.75000000"
                    },
                    {
                        "id": 144135,
                        "name": "Bitaogan",
                        "latitude": "6.76833333",
                        "longitude": "126.07750000"
                    },
                    {
                        "id": 144137,
                        "name": "Bolila",
                        "latitude": "6.37166667",
                        "longitude": "125.57138889"
                    },
                    {
                        "id": 144139,
                        "name": "Buclad",
                        "latitude": "7.52777778",
                        "longitude": "125.75055556"
                    },
                    {
                        "id": 144140,
                        "name": "Buhangin",
                        "latitude": "6.49111111",
                        "longitude": "125.54750000"
                    },
                    {
                        "id": 144141,
                        "name": "Bukid",
                        "latitude": "5.57166667",
                        "longitude": "125.40555556"
                    },
                    {
                        "id": 144142,
                        "name": "Bulacan",
                        "latitude": "6.56750000",
                        "longitude": "125.42111111"
                    },
                    {
                        "id": 144143,
                        "name": "Bungabon",
                        "latitude": "7.22222222",
                        "longitude": "125.87305556"
                    },
                    {
                        "id": 144144,
                        "name": "Butulan",
                        "latitude": "5.61444444",
                        "longitude": "125.43166667"
                    },
                    {
                        "id": 144145,
                        "name": "Cabayangan",
                        "latitude": "7.40722222",
                        "longitude": "125.73305556"
                    },
                    {
                        "id": 144146,
                        "name": "Cabinuangan",
                        "latitude": "7.68333333",
                        "longitude": "126.03333333"
                    },
                    {
                        "id": 144147,
                        "name": "Caburan",
                        "latitude": "5.91805556",
                        "longitude": "125.64111111"
                    },
                    {
                        "id": 144148,
                        "name": "Cambanugoy",
                        "latitude": "7.54138889",
                        "longitude": "125.75527778"
                    },
                    {
                        "id": 144149,
                        "name": "Camudmud",
                        "latitude": "7.17611111",
                        "longitude": "125.69333333"
                    },
                    {
                        "id": 144151,
                        "name": "Carmen",
                        "latitude": "7.36055556",
                        "longitude": "125.70638889"
                    },
                    {
                        "id": 144153,
                        "name": "City of Mati",
                        "latitude": "6.75381000",
                        "longitude": "126.24592000"
                    },
                    {
                        "id": 144154,
                        "name": "City of Panabo",
                        "latitude": "7.33038000",
                        "longitude": "125.60607000"
                    },
                    {
                        "id": 144155,
                        "name": "City of Tagum",
                        "latitude": "7.40000000",
                        "longitude": "125.83333000"
                    },
                    {
                        "id": 144156,
                        "name": "Cogon",
                        "latitude": "7.15083333",
                        "longitude": "125.71722222"
                    },
                    {
                        "id": 144157,
                        "name": "Concepcion",
                        "latitude": "7.75055556",
                        "longitude": "125.71194444"
                    },
                    {
                        "id": 144158,
                        "name": "Corocotan",
                        "latitude": "7.39972222",
                        "longitude": "125.77277778"
                    },
                    {
                        "id": 144159,
                        "name": "Coronon",
                        "latitude": "6.87916667",
                        "longitude": "125.44888889"
                    },
                    {
                        "id": 144160,
                        "name": "Cuambog",
                        "latitude": "7.30861111",
                        "longitude": "125.84805556"
                    },
                    {
                        "id": 144161,
                        "name": "Culaman",
                        "latitude": "5.96027778",
                        "longitude": "125.65861111"
                    },
                    {
                        "id": 144162,
                        "name": "Dacudao",
                        "latitude": "7.21527778",
                        "longitude": "125.47138889"
                    },
                    {
                        "id": 144163,
                        "name": "Dakbayan sa Digos",
                        "latitude": "6.83333000",
                        "longitude": "125.35000000"
                    },
                    {
                        "id": 144164,
                        "name": "Davan",
                        "latitude": "6.91500000",
                        "longitude": "126.15333333"
                    },
                    {
                        "id": 144166,
                        "name": "Del Pilar",
                        "latitude": "7.56305556",
                        "longitude": "125.82666667"
                    },
                    {
                        "id": 144168,
                        "name": "Dolo",
                        "latitude": "6.81027778",
                        "longitude": "125.19166667"
                    },
                    {
                        "id": 144169,
                        "name": "Don Marcelino",
                        "latitude": "6.11667000",
                        "longitude": "125.63333000"
                    },
                    {
                        "id": 144170,
                        "name": "Dumlan",
                        "latitude": "7.42750000",
                        "longitude": "125.88194444"
                    },
                    {
                        "id": 144171,
                        "name": "Esperanza",
                        "latitude": "7.49166667",
                        "longitude": "125.72805556"
                    },
                    {
                        "id": 144172,
                        "name": "Gabi",
                        "latitude": "7.62138889",
                        "longitude": "126.09194444"
                    },
                    {
                        "id": 144173,
                        "name": "Gabuyan",
                        "latitude": "7.60805556",
                        "longitude": "125.66888889"
                    },
                    {
                        "id": 144174,
                        "name": "Goma",
                        "latitude": "6.79194444",
                        "longitude": "125.32083333"
                    },
                    {
                        "id": 144176,
                        "name": "Guihing Proper",
                        "latitude": "6.68444444",
                        "longitude": "125.35250000"
                    },
                    {
                        "id": 144177,
                        "name": "Gumalang",
                        "latitude": "7.20833333",
                        "longitude": "125.40361111"
                    },
                    {
                        "id": 144178,
                        "name": "Gupitan",
                        "latitude": "7.77583333",
                        "longitude": "125.64055556"
                    },
                    {
                        "id": 144180,
                        "name": "Ignit",
                        "latitude": "6.70083333",
                        "longitude": "125.29194444"
                    },
                    {
                        "id": 144181,
                        "name": "Ilangay",
                        "latitude": "6.91277778",
                        "longitude": "126.05000000"
                    },
                    {
                        "id": 144182,
                        "name": "Inawayan",
                        "latitude": "6.96083333",
                        "longitude": "125.47333333"
                    },
                    {
                        "id": 144183,
                        "name": "Island Garden City of Samal",
                        "latitude": "7.08333000",
                        "longitude": "125.75000000"
                    },
                    {
                        "id": 144184,
                        "name": "Jose Abad Santos",
                        "latitude": "5.91666667",
                        "longitude": "125.65000000"
                    },
                    {
                        "id": 144186,
                        "name": "Jovellar",
                        "latitude": "7.06361111",
                        "longitude": "126.45555556"
                    },
                    {
                        "id": 144187,
                        "name": "Kalbay",
                        "latitude": "5.72333333",
                        "longitude": "125.49861111"
                    },
                    {
                        "id": 144188,
                        "name": "Kalian",
                        "latitude": "6.12305556",
                        "longitude": "125.70027778"
                    },
                    {
                        "id": 144189,
                        "name": "Kaligutan",
                        "latitude": "7.70305556",
                        "longitude": "125.81305556"
                    },
                    {
                        "id": 144192,
                        "name": "Katipunan",
                        "latitude": "7.32027778",
                        "longitude": "125.62027778"
                    },
                    {
                        "id": 144194,
                        "name": "Kinablangan",
                        "latitude": "7.69277778",
                        "longitude": "126.54916667"
                    },
                    {
                        "id": 144195,
                        "name": "Kinamayan",
                        "latitude": "7.49944444",
                        "longitude": "125.67361111"
                    },
                    {
                        "id": 144196,
                        "name": "Kinangan",
                        "latitude": "6.30138889",
                        "longitude": "125.58500000"
                    },
                    {
                        "id": 144197,
                        "name": "La Libertad",
                        "latitude": "7.48027778",
                        "longitude": "125.64722222"
                    },
                    {
                        "id": 144198,
                        "name": "La Paz",
                        "latitude": "7.31583333",
                        "longitude": "125.73333333"
                    },
                    {
                        "id": 144199,
                        "name": "La Union",
                        "latitude": "6.70416667",
                        "longitude": "126.08805556"
                    },
                    {
                        "id": 144200,
                        "name": "Lacaron",
                        "latitude": "6.44888889",
                        "longitude": "125.57916667"
                    },
                    {
                        "id": 144201,
                        "name": "Lacson",
                        "latitude": "7.21194444",
                        "longitude": "125.44222222"
                    },
                    {
                        "id": 144202,
                        "name": "Lais",
                        "latitude": "6.33277778",
                        "longitude": "125.64638889"
                    },
                    {
                        "id": 144204,
                        "name": "Lapuan",
                        "latitude": "6.14444444",
                        "longitude": "125.70083333"
                    },
                    {
                        "id": 144205,
                        "name": "Lasang",
                        "latitude": "7.26694444",
                        "longitude": "125.66500000"
                    },
                    {
                        "id": 144206,
                        "name": "Libuganon",
                        "latitude": "7.34888889",
                        "longitude": "125.77833333"
                    },
                    {
                        "id": 144207,
                        "name": "Limao",
                        "latitude": "7.07916667",
                        "longitude": "125.67361111"
                    },
                    {
                        "id": 144208,
                        "name": "Limot",
                        "latitude": "7.04055556",
                        "longitude": "126.27277778"
                    },
                    {
                        "id": 144209,
                        "name": "Linao",
                        "latitude": "7.01722222",
                        "longitude": "125.99194444"
                    },
                    {
                        "id": 144210,
                        "name": "Linoan",
                        "latitude": "7.62611111",
                        "longitude": "125.97416667"
                    },
                    {
                        "id": 144211,
                        "name": "Lukatan",
                        "latitude": "7.00972222",
                        "longitude": "126.42111111"
                    },
                    {
                        "id": 144212,
                        "name": "Luna",
                        "latitude": "7.57638889",
                        "longitude": "125.66722222"
                    },
                    {
                        "id": 144213,
                        "name": "Lungaog",
                        "latitude": "7.52944444",
                        "longitude": "125.68777778"
                    },
                    {
                        "id": 144215,
                        "name": "Luzon",
                        "latitude": "6.51916667",
                        "longitude": "126.09416667"
                    },
                    {
                        "id": 144216,
                        "name": "Mabini",
                        "latitude": "7.30000000",
                        "longitude": "125.85000000"
                    },
                    {
                        "id": 144218,
                        "name": "Mabuhay",
                        "latitude": "7.33305556",
                        "longitude": "125.54750000"
                    },
                    {
                        "id": 144220,
                        "name": "Maduao",
                        "latitude": "7.29416667",
                        "longitude": "125.62583333"
                    },
                    {
                        "id": 144221,
                        "name": "Magatos",
                        "latitude": "7.55555556",
                        "longitude": "125.72666667"
                    },
                    {
                        "id": 144222,
                        "name": "Magdug",
                        "latitude": "6.54777778",
                        "longitude": "126.09500000"
                    },
                    {
                        "id": 144223,
                        "name": "Magnaga",
                        "latitude": "7.16944444",
                        "longitude": "125.89305556"
                    },
                    {
                        "id": 144224,
                        "name": "Magsaysay",
                        "latitude": "6.76666667",
                        "longitude": "125.18333333"
                    },
                    {
                        "id": 144227,
                        "name": "Mahanob",
                        "latitude": "7.57333333",
                        "longitude": "126.50694444"
                    },
                    {
                        "id": 144228,
                        "name": "Mahayag",
                        "latitude": "7.21666667",
                        "longitude": "125.61944444"
                    },
                    {
                        "id": 144229,
                        "name": "Malagos",
                        "latitude": "7.18500000",
                        "longitude": "125.42222222"
                    },
                    {
                        "id": 144231,
                        "name": "Malinao",
                        "latitude": "6.65916667",
                        "longitude": "125.28666667"
                    },
                    {
                        "id": 144232,
                        "name": "Malita",
                        "latitude": "6.40000000",
                        "longitude": "125.60000000"
                    },
                    {
                        "id": 144233,
                        "name": "Mambago",
                        "latitude": "7.10555556",
                        "longitude": "125.69444444"
                    },
                    {
                        "id": 144234,
                        "name": "Managa",
                        "latitude": "6.74611111",
                        "longitude": "125.26805556"
                    },
                    {
                        "id": 144235,
                        "name": "Manaloal",
                        "latitude": "7.36611111",
                        "longitude": "125.66027778"
                    },
                    {
                        "id": 144236,
                        "name": "Manat",
                        "latitude": "7.53277778",
                        "longitude": "126.01722222"
                    },
                    {
                        "id": 144239,
                        "name": "Mangili",
                        "latitude": "6.00333333",
                        "longitude": "125.68388889"
                    },
                    {
                        "id": 144240,
                        "name": "Manikling",
                        "latitude": "6.87916667",
                        "longitude": "126.06055556"
                    },
                    {
                        "id": 144244,
                        "name": "Matiao",
                        "latitude": "7.08277778",
                        "longitude": "125.93611111"
                    },
                    {
                        "id": 144245,
                        "name": "Matti",
                        "latitude": "6.77055556",
                        "longitude": "125.30861111"
                    },
                    {
                        "id": 144248,
                        "name": "Mayo",
                        "latitude": "7.00222222",
                        "longitude": "126.33194444"
                    },
                    {
                        "id": 144252,
                        "name": "Nangan",
                        "latitude": "6.47277778",
                        "longitude": "126.12444444"
                    },
                    {
                        "id": 144253,
                        "name": "Nanyo",
                        "latitude": "7.33305556",
                        "longitude": "125.63777778"
                    },
                    {
                        "id": 144254,
                        "name": "New Baclayon",
                        "latitude": "6.58416667",
                        "longitude": "125.36944444"
                    },
                    {
                        "id": 144256,
                        "name": "New Bohol",
                        "latitude": "7.52333333",
                        "longitude": "125.83638889"
                    },
                    {
                        "id": 144258,
                        "name": "New Leyte",
                        "latitude": "7.50000000",
                        "longitude": "125.75000000"
                    },
                    {
                        "id": 144259,
                        "name": "New Sibonga",
                        "latitude": "7.56083333",
                        "longitude": "125.92972222"
                    },
                    {
                        "id": 144260,
                        "name": "New Visayas",
                        "latitude": "7.52333333",
                        "longitude": "125.62333333"
                    },
                    {
                        "id": 144261,
                        "name": "Nuing",
                        "latitude": "5.63277778",
                        "longitude": "125.43527778"
                    },
                    {
                        "id": 144263,
                        "name": "Pag-asa",
                        "latitude": "7.57555556",
                        "longitude": "125.68388889"
                    },
                    {
                        "id": 144264,
                        "name": "Pagsabangan",
                        "latitude": "7.48111111",
                        "longitude": "125.74944444"
                    },
                    {
                        "id": 144265,
                        "name": "Palma Gil",
                        "latitude": "7.64222222",
                        "longitude": "125.62916667"
                    },
                    {
                        "id": 144267,
                        "name": "Pandasan",
                        "latitude": "7.28388889",
                        "longitude": "125.85361111"
                    },
                    {
                        "id": 144268,
                        "name": "Pangian",
                        "latitude": "6.46277778",
                        "longitude": "125.54527778"
                    },
                    {
                        "id": 144269,
                        "name": "Panikian",
                        "latitude": "7.01083333",
                        "longitude": "126.02416667"
                    },
                    {
                        "id": 144271,
                        "name": "Pasian",
                        "latitude": "7.92805556",
                        "longitude": "126.06722222"
                    },
                    {
                        "id": 144272,
                        "name": "Pondaguitan",
                        "latitude": "6.36111111",
                        "longitude": "126.17777778"
                    },
                    {
                        "id": 144273,
                        "name": "Pung-Pang",
                        "latitude": "6.49750000",
                        "longitude": "125.46333333"
                    },
                    {
                        "id": 144275,
                        "name": "Sampao",
                        "latitude": "7.59388889",
                        "longitude": "125.66111111"
                    },
                    {
                        "id": 144276,
                        "name": "San Alfonso",
                        "latitude": "7.78027778",
                        "longitude": "126.42027778"
                    },
                    {
                        "id": 144277,
                        "name": "San Antonio",
                        "latitude": "7.12000000",
                        "longitude": "125.73972222"
                    },
                    {
                        "id": 144278,
                        "name": "San Ignacio",
                        "latitude": "7.11888889",
                        "longitude": "126.48833333"
                    },
                    {
                        "id": 144279,
                        "name": "San Isidro",
                        "latitude": "6.76667000",
                        "longitude": "126.13333000"
                    },
                    {
                        "id": 144282,
                        "name": "San Miguel",
                        "latitude": "7.48500000",
                        "longitude": "125.67638889"
                    },
                    {
                        "id": 144283,
                        "name": "San Pedro",
                        "latitude": "7.34194444",
                        "longitude": "126.51750000"
                    },
                    {
                        "id": 144284,
                        "name": "San Rafael",
                        "latitude": "7.76388889",
                        "longitude": "126.45583333"
                    },
                    {
                        "id": 144286,
                        "name": "San Vicente",
                        "latitude": "7.86667000",
                        "longitude": "125.83333000"
                    },
                    {
                        "id": 144287,
                        "name": "Santa Cruz",
                        "latitude": "6.83333333",
                        "longitude": "125.41666667"
                    },
                    {
                        "id": 144290,
                        "name": "Santo Niño",
                        "latitude": "7.62361111",
                        "longitude": "125.62527778"
                    },
                    {
                        "id": 144293,
                        "name": "Sarangani",
                        "latitude": "5.40000000",
                        "longitude": "125.46666667"
                    },
                    {
                        "id": 144295,
                        "name": "Sigaboy",
                        "latitude": "6.65416667",
                        "longitude": "126.07277778"
                    },
                    {
                        "id": 144296,
                        "name": "Simod",
                        "latitude": "7.47583333",
                        "longitude": "125.34083333"
                    },
                    {
                        "id": 144297,
                        "name": "Sinawilan",
                        "latitude": "6.75444444",
                        "longitude": "125.24638889"
                    },
                    {
                        "id": 144298,
                        "name": "Sinayawan",
                        "latitude": "6.71250000",
                        "longitude": "125.30944444"
                    },
                    {
                        "id": 144299,
                        "name": "Sirib",
                        "latitude": "7.13333333",
                        "longitude": "125.40722222"
                    },
                    {
                        "id": 144300,
                        "name": "Sugal",
                        "latitude": "5.66222222",
                        "longitude": "125.46166667"
                    },
                    {
                        "id": 144302,
                        "name": "Surup",
                        "latitude": "6.39027778",
                        "longitude": "126.14555556"
                    },
                    {
                        "id": 144303,
                        "name": "Suz-on",
                        "latitude": "7.66277778",
                        "longitude": "125.63833333"
                    },
                    {
                        "id": 144304,
                        "name": "Tagakpan",
                        "latitude": "7.11277778",
                        "longitude": "125.42916667"
                    },
                    {
                        "id": 144305,
                        "name": "Tagdanua",
                        "latitude": "7.20416667",
                        "longitude": "125.88416667"
                    },
                    {
                        "id": 144306,
                        "name": "Tagnanan",
                        "latitude": "7.28361111",
                        "longitude": "125.84222222"
                    },
                    {
                        "id": 144307,
                        "name": "Tagum",
                        "latitude": "7.44750000",
                        "longitude": "125.80460000"
                    },
                    {
                        "id": 144308,
                        "name": "Takub",
                        "latitude": "6.85638889",
                        "longitude": "125.42250000"
                    },
                    {
                        "id": 144309,
                        "name": "Talagutong",
                        "latitude": "6.26444444",
                        "longitude": "125.66777778"
                    },
                    {
                        "id": 144310,
                        "name": "Talisay",
                        "latitude": "6.71972222",
                        "longitude": "126.10000000"
                    },
                    {
                        "id": 144311,
                        "name": "Talomo",
                        "latitude": "7.52861111",
                        "longitude": "125.72277778"
                    },
                    {
                        "id": 144312,
                        "name": "Tamayong",
                        "latitude": "7.13305556",
                        "longitude": "125.37972222"
                    },
                    {
                        "id": 144313,
                        "name": "Tambo",
                        "latitude": "7.15694444",
                        "longitude": "125.69916667"
                    },
                    {
                        "id": 144314,
                        "name": "Tamisan",
                        "latitude": "6.84361111",
                        "longitude": "126.29833333"
                    },
                    {
                        "id": 144315,
                        "name": "Tamugan",
                        "latitude": "7.23083333",
                        "longitude": "125.37638889"
                    },
                    {
                        "id": 144316,
                        "name": "Tanlad",
                        "latitude": "6.60222222",
                        "longitude": "125.44500000"
                    },
                    {
                        "id": 144317,
                        "name": "Tapia",
                        "latitude": "7.75416667",
                        "longitude": "126.01194444"
                    },
                    {
                        "id": 144319,
                        "name": "Tawan tawan",
                        "latitude": "7.16916667",
                        "longitude": "125.37277778"
                    },
                    {
                        "id": 144320,
                        "name": "Taytayan",
                        "latitude": "7.73388889",
                        "longitude": "126.50194444"
                    },
                    {
                        "id": 144321,
                        "name": "Tibagon",
                        "latitude": "7.23277778",
                        "longitude": "125.86277778"
                    },
                    {
                        "id": 144322,
                        "name": "Tibanbang",
                        "latitude": "6.63166667",
                        "longitude": "126.10555556"
                    },
                    {
                        "id": 144323,
                        "name": "Tiblawan",
                        "latitude": "6.47833333",
                        "longitude": "126.10833333"
                    },
                    {
                        "id": 144324,
                        "name": "Tombongon",
                        "latitude": "7.07916667",
                        "longitude": "125.94861111"
                    },
                    {
                        "id": 144325,
                        "name": "Tubalan",
                        "latitude": "6.49500000",
                        "longitude": "125.56611111"
                    },
                    {
                        "id": 144326,
                        "name": "Tuban",
                        "latitude": "6.82277778",
                        "longitude": "125.38694444"
                    },
                    {
                        "id": 144327,
                        "name": "Tubod",
                        "latitude": "7.37166667",
                        "longitude": "125.64472222"
                    },
                    {
                        "id": 144328,
                        "name": "Tuganay",
                        "latitude": "7.36888889",
                        "longitude": "125.72305556"
                    },
                    {
                        "id": 144329,
                        "name": "Tuli",
                        "latitude": "7.23333333",
                        "longitude": "125.41666667"
                    },
                    {
                        "id": 144330,
                        "name": "Ula",
                        "latitude": "7.13222222",
                        "longitude": "125.49222222"
                    },
                    {
                        "id": 144331,
                        "name": "Wañgan",
                        "latitude": "7.15972222",
                        "longitude": "125.44527778"
                    },
                    {
                        "id": 144332,
                        "name": "Wines",
                        "latitude": "7.19388889",
                        "longitude": "125.38916667"
                    }
                ]
            },
            {
                "id": 1270,
                "name": "Bukidnon",
                "iso2": "BUK",
                "latitude": "8.05150540",
                "longitude": "124.92299460",
                "type": "province",
                "cities": [
                    {
                        "id": 144334,
                        "name": "Amas",
                        "latitude": "7.05694444",
                        "longitude": "124.98388889"
                    },
                    {
                        "id": 144335,
                        "name": "Bagontapay",
                        "latitude": "6.85888889",
                        "longitude": "124.90888889"
                    },
                    {
                        "id": 144336,
                        "name": "Baguer",
                        "latitude": "7.25611111",
                        "longitude": "124.50416667"
                    },
                    {
                        "id": 144338,
                        "name": "Baliton",
                        "latitude": "5.74361111",
                        "longitude": "125.23638889"
                    },
                    {
                        "id": 144339,
                        "name": "Balogo",
                        "latitude": "7.28222222",
                        "longitude": "124.46388889"
                    },
                    {
                        "id": 144340,
                        "name": "Banawa",
                        "latitude": "7.15361111",
                        "longitude": "124.86666667"
                    },
                    {
                        "id": 144344,
                        "name": "Bantogon",
                        "latitude": "6.53333333",
                        "longitude": "124.03333333"
                    },
                    {
                        "id": 144345,
                        "name": "Barongis",
                        "latitude": "7.26111111",
                        "longitude": "124.56416667"
                    },
                    {
                        "id": 144346,
                        "name": "Basak",
                        "latitude": "6.72722222",
                        "longitude": "124.15111111"
                    },
                    {
                        "id": 144347,
                        "name": "Batasan",
                        "latitude": "7.03333333",
                        "longitude": "125.05000000"
                    },
                    {
                        "id": 144348,
                        "name": "Batutitik",
                        "latitude": "6.22333333",
                        "longitude": "125.25194444"
                    },
                    {
                        "id": 144349,
                        "name": "Bau",
                        "latitude": "7.40527778",
                        "longitude": "124.64972222"
                    },
                    {
                        "id": 144350,
                        "name": "Bayasong",
                        "latitude": "6.64888889",
                        "longitude": "124.87305556"
                    },
                    {
                        "id": 144351,
                        "name": "Bialong",
                        "latitude": "6.98055556",
                        "longitude": "124.88888889"
                    },
                    {
                        "id": 144352,
                        "name": "Biwang",
                        "latitude": "6.60592000",
                        "longitude": "124.54358000"
                    },
                    {
                        "id": 144353,
                        "name": "Blingkong",
                        "latitude": "6.58808000",
                        "longitude": "124.88951000"
                    },
                    {
                        "id": 144354,
                        "name": "Buadtasan",
                        "latitude": "6.00500000",
                        "longitude": "124.61277778"
                    },
                    {
                        "id": 144355,
                        "name": "Bual",
                        "latitude": "6.79583333",
                        "longitude": "124.91083333"
                    },
                    {
                        "id": 144357,
                        "name": "Buayan",
                        "latitude": "6.11638889",
                        "longitude": "125.23472222"
                    },
                    {
                        "id": 144359,
                        "name": "Bucay Pait",
                        "latitude": "6.56161000",
                        "longitude": "124.76706000"
                    },
                    {
                        "id": 144360,
                        "name": "Bulatukan",
                        "latitude": "6.90250000",
                        "longitude": "125.16083333"
                    },
                    {
                        "id": 144361,
                        "name": "Burias",
                        "latitude": "5.71777778",
                        "longitude": "125.25361111"
                    },
                    {
                        "id": 144362,
                        "name": "Busok",
                        "latitude": "6.50820000",
                        "longitude": "124.60009000"
                    },
                    {
                        "id": 144364,
                        "name": "Carpenter",
                        "latitude": "6.44413000",
                        "longitude": "124.88138000"
                    },
                    {
                        "id": 144365,
                        "name": "Cebuano",
                        "latitude": "6.38805556",
                        "longitude": "124.96833333"
                    },
                    {
                        "id": 144366,
                        "name": "City of Kidapawan",
                        "latitude": "7.03333000",
                        "longitude": "125.08333000"
                    },
                    {
                        "id": 144367,
                        "name": "City of Koronadal",
                        "latitude": "6.49162000",
                        "longitude": "124.88840000"
                    },
                    {
                        "id": 144368,
                        "name": "City of Tacurong",
                        "latitude": "6.69133000",
                        "longitude": "124.67300000"
                    },
                    {
                        "id": 144369,
                        "name": "Colongolo",
                        "latitude": "6.33861111",
                        "longitude": "124.72166667"
                    },
                    {
                        "id": 143934,
                        "name": "Dahay",
                        "latitude": "6.39067000",
                        "longitude": "124.71464000"
                    },
                    {
                        "id": 143935,
                        "name": "Daliao",
                        "latitude": "5.86111111",
                        "longitude": "124.95333333"
                    },
                    {
                        "id": 143936,
                        "name": "Damawato",
                        "latitude": "6.70000000",
                        "longitude": "124.78333333"
                    },
                    {
                        "id": 143937,
                        "name": "Dansuli",
                        "latitude": "6.64075000",
                        "longitude": "124.58258000"
                    },
                    {
                        "id": 143939,
                        "name": "Dualing",
                        "latitude": "7.15166667",
                        "longitude": "124.56833333"
                    },
                    {
                        "id": 143940,
                        "name": "Dukay",
                        "latitude": "6.66688000",
                        "longitude": "124.55697000"
                    },
                    {
                        "id": 143941,
                        "name": "Dunguan",
                        "latitude": "6.94972222",
                        "longitude": "124.86083333"
                    },
                    {
                        "id": 143944,
                        "name": "Gansing",
                        "latitude": "6.71851000",
                        "longitude": "124.65338000"
                    },
                    {
                        "id": 143946,
                        "name": "Glad",
                        "latitude": "7.14833333",
                        "longitude": "124.51805556"
                    },
                    {
                        "id": 143947,
                        "name": "Glamang",
                        "latitude": "6.16250000",
                        "longitude": "125.08388889"
                    },
                    {
                        "id": 143949,
                        "name": "Glan Peidu",
                        "latitude": "5.85500000",
                        "longitude": "125.21861111"
                    },
                    {
                        "id": 143950,
                        "name": "Gocoton",
                        "latitude": "7.15611111",
                        "longitude": "124.69111111"
                    },
                    {
                        "id": 143951,
                        "name": "Guinsang-an",
                        "latitude": "6.46499000",
                        "longitude": "124.68491000"
                    },
                    {
                        "id": 143952,
                        "name": "Ilaya",
                        "latitude": "5.81527778",
                        "longitude": "125.22666667"
                    },
                    {
                        "id": 143955,
                        "name": "Kabalen",
                        "latitude": "6.31944444",
                        "longitude": "125.01055556"
                    },
                    {
                        "id": 143956,
                        "name": "Kablalan",
                        "latitude": "5.77972222",
                        "longitude": "125.19777778"
                    },
                    {
                        "id": 143957,
                        "name": "Kalaisan",
                        "latitude": "7.01027778",
                        "longitude": "125.04500000"
                    },
                    {
                        "id": 143958,
                        "name": "Kalamangog",
                        "latitude": "6.72555556",
                        "longitude": "124.06888889"
                    },
                    {
                        "id": 143960,
                        "name": "Kamanga",
                        "latitude": "5.85777778",
                        "longitude": "125.05611111"
                    },
                    {
                        "id": 143961,
                        "name": "Kapatan",
                        "latitude": "5.90055556",
                        "longitude": "125.23750000"
                    },
                    {
                        "id": 143962,
                        "name": "Kapaya",
                        "latitude": "6.54258000",
                        "longitude": "124.56314000"
                    },
                    {
                        "id": 143963,
                        "name": "Kapinkong",
                        "latitude": "6.67503000",
                        "longitude": "124.62632000"
                    },
                    {
                        "id": 143964,
                        "name": "Katubao",
                        "latitude": "5.88916667",
                        "longitude": "124.82944444"
                    },
                    {
                        "id": 143967,
                        "name": "Kipalbig",
                        "latitude": "6.41056000",
                        "longitude": "124.92640000"
                    },
                    {
                        "id": 143968,
                        "name": "Kisante",
                        "latitude": "6.92305556",
                        "longitude": "125.15500000"
                    },
                    {
                        "id": 143969,
                        "name": "Kiupo",
                        "latitude": "5.84166667",
                        "longitude": "125.31916667"
                    },
                    {
                        "id": 143970,
                        "name": "Klinan",
                        "latitude": "6.18694444",
                        "longitude": "125.13694444"
                    },
                    {
                        "id": 143971,
                        "name": "Kling",
                        "latitude": "5.93805556",
                        "longitude": "124.72472222"
                    },
                    {
                        "id": 143973,
                        "name": "Kudanding",
                        "latitude": "6.58803000",
                        "longitude": "124.63274000"
                    },
                    {
                        "id": 143974,
                        "name": "Kulaman",
                        "latitude": "6.46001000",
                        "longitude": "124.08767000"
                    },
                    {
                        "id": 143975,
                        "name": "Labu-o",
                        "latitude": "7.11416667",
                        "longitude": "125.04527778"
                    },
                    {
                        "id": 143976,
                        "name": "Laguilayan",
                        "latitude": "6.67213000",
                        "longitude": "124.52491000"
                    },
                    {
                        "id": 143979,
                        "name": "Lambo",
                        "latitude": "6.35025000",
                        "longitude": "124.81974000"
                    },
                    {
                        "id": 143980,
                        "name": "Lambontong",
                        "latitude": "6.30833333",
                        "longitude": "124.81055556"
                    },
                    {
                        "id": 143981,
                        "name": "Lamian",
                        "latitude": "6.30916667",
                        "longitude": "124.84638889"
                    },
                    {
                        "id": 143982,
                        "name": "Lampari",
                        "latitude": "6.31264000",
                        "longitude": "124.88028000"
                    },
                    {
                        "id": 143983,
                        "name": "Lampitak",
                        "latitude": "6.43222222",
                        "longitude": "125.05250000"
                    },
                    {
                        "id": 143984,
                        "name": "Lapuz",
                        "latitude": "6.49416000",
                        "longitude": "124.63054000"
                    },
                    {
                        "id": 143987,
                        "name": "Libas",
                        "latitude": "6.52014000",
                        "longitude": "124.78234000"
                    },
                    {
                        "id": 143988,
                        "name": "Liberty",
                        "latitude": "6.51989000",
                        "longitude": "124.63194000"
                    },
                    {
                        "id": 143991,
                        "name": "Liliongan",
                        "latitude": "7.36277778",
                        "longitude": "124.79277778"
                    },
                    {
                        "id": 143992,
                        "name": "Limbalod",
                        "latitude": "7.13277778",
                        "longitude": "124.79888889"
                    },
                    {
                        "id": 143993,
                        "name": "Limulan",
                        "latitude": "6.58527778",
                        "longitude": "124.06194444"
                    },
                    {
                        "id": 143994,
                        "name": "Linan (town)",
                        "latitude": "6.43218000",
                        "longitude": "124.97617000"
                    },
                    {
                        "id": 143995,
                        "name": "Linao",
                        "latitude": "7.16777778",
                        "longitude": "124.96750000"
                    },
                    {
                        "id": 143997,
                        "name": "Lumatil",
                        "latitude": "5.87472222",
                        "longitude": "124.88833333"
                    },
                    {
                        "id": 143998,
                        "name": "Lumazal",
                        "latitude": "5.88527778",
                        "longitude": "124.84944444"
                    },
                    {
                        "id": 143999,
                        "name": "Lumuyon",
                        "latitude": "5.91583333",
                        "longitude": "124.78694444"
                    },
                    {
                        "id": 144000,
                        "name": "Lun Pequeño",
                        "latitude": "6.03777778",
                        "longitude": "125.28388889"
                    },
                    {
                        "id": 144001,
                        "name": "Lunen",
                        "latitude": "6.35916667",
                        "longitude": "124.90472222"
                    },
                    {
                        "id": 144003,
                        "name": "M'lang",
                        "latitude": "6.95000000",
                        "longitude": "124.88333333"
                    },
                    {
                        "id": 144005,
                        "name": "Maan",
                        "latitude": "5.93388889",
                        "longitude": "124.73555556"
                    },
                    {
                        "id": 144007,
                        "name": "Mabay",
                        "latitude": "6.05777778",
                        "longitude": "124.46666667"
                    },
                    {
                        "id": 144010,
                        "name": "Maguling",
                        "latitude": "6.09500000",
                        "longitude": "124.40333333"
                    },
                    {
                        "id": 144011,
                        "name": "Maibu",
                        "latitude": "6.57000000",
                        "longitude": "124.79361000"
                    },
                    {
                        "id": 144012,
                        "name": "Maindang",
                        "latitude": "6.58978000",
                        "longitude": "124.84732000"
                    },
                    {
                        "id": 144015,
                        "name": "Malamote",
                        "latitude": "7.07388889",
                        "longitude": "124.94000000"
                    },
                    {
                        "id": 144016,
                        "name": "Malandag",
                        "latitude": "6.31030000",
                        "longitude": "125.24756000"
                    },
                    {
                        "id": 144017,
                        "name": "Malapag",
                        "latitude": "7.13333333",
                        "longitude": "124.81666667"
                    },
                    {
                        "id": 144019,
                        "name": "Malasila",
                        "latitude": "6.94388889",
                        "longitude": "125.12944444"
                    },
                    {
                        "id": 144020,
                        "name": "Malbang",
                        "latitude": "5.85555556",
                        "longitude": "125.04527778"
                    },
                    {
                        "id": 144021,
                        "name": "Malingao",
                        "latitude": "7.16083333",
                        "longitude": "124.47500000"
                    },
                    {
                        "id": 144022,
                        "name": "Malisbeng",
                        "latitude": "6.12000000",
                        "longitude": "124.35472222"
                    },
                    {
                        "id": 144023,
                        "name": "Malitubog",
                        "latitude": "7.31555556",
                        "longitude": "124.63805556"
                    },
                    {
                        "id": 144024,
                        "name": "Maltana",
                        "latitude": "6.42290000",
                        "longitude": "124.93688000"
                    },
                    {
                        "id": 144026,
                        "name": "Mamali",
                        "latitude": "6.77360000",
                        "longitude": "124.64770000"
                    },
                    {
                        "id": 144027,
                        "name": "Manaulanan",
                        "latitude": "7.04805556",
                        "longitude": "124.61944444"
                    },
                    {
                        "id": 144028,
                        "name": "Manga",
                        "latitude": "6.29083333",
                        "longitude": "125.30833333"
                    },
                    {
                        "id": 144029,
                        "name": "Manuangan",
                        "latitude": "7.27694444",
                        "longitude": "124.40444444"
                    },
                    {
                        "id": 144030,
                        "name": "Manuel Roxas",
                        "latitude": "6.44173000",
                        "longitude": "124.66605000"
                    },
                    {
                        "id": 144031,
                        "name": "Marbel",
                        "latitude": "7.11583333",
                        "longitude": "124.91250000"
                    },
                    {
                        "id": 144032,
                        "name": "Mariano Marcos",
                        "latitude": "6.73333000",
                        "longitude": "124.65000000"
                    },
                    {
                        "id": 144034,
                        "name": "Matinao",
                        "latitude": "7.56029000",
                        "longitude": "124.70839000"
                    },
                    {
                        "id": 144036,
                        "name": "Minapan",
                        "latitude": "6.81500000",
                        "longitude": "124.85861111"
                    },
                    {
                        "id": 144037,
                        "name": "Mindupok",
                        "latitude": "6.09055556",
                        "longitude": "124.42333333"
                    },
                    {
                        "id": 144038,
                        "name": "Nalus",
                        "latitude": "6.01222222",
                        "longitude": "124.58527778"
                    },
                    {
                        "id": 144039,
                        "name": "New Cebu",
                        "latitude": "7.09527778",
                        "longitude": "125.03361111"
                    },
                    {
                        "id": 144040,
                        "name": "New Iloilo",
                        "latitude": "6.54776000",
                        "longitude": "124.78951000"
                    },
                    {
                        "id": 144041,
                        "name": "New Lagao",
                        "latitude": "6.70235000",
                        "longitude": "124.64141000"
                    },
                    {
                        "id": 144042,
                        "name": "New Panay",
                        "latitude": "6.74237000",
                        "longitude": "124.55956000"
                    },
                    {
                        "id": 144043,
                        "name": "Noling",
                        "latitude": "6.65972222",
                        "longitude": "124.09972222"
                    },
                    {
                        "id": 144045,
                        "name": "Nunguan",
                        "latitude": "7.12825000",
                        "longitude": "124.68912000"
                    },
                    {
                        "id": 144046,
                        "name": "Osias",
                        "latitude": "7.60000000",
                        "longitude": "124.81666667"
                    },
                    {
                        "id": 144047,
                        "name": "Paatan",
                        "latitude": "7.11972222",
                        "longitude": "124.92388889"
                    },
                    {
                        "id": 144049,
                        "name": "Pagangan",
                        "latitude": "7.11444444",
                        "longitude": "124.59527778"
                    },
                    {
                        "id": 144050,
                        "name": "Palian",
                        "latitude": "6.37427000",
                        "longitude": "124.91062000"
                    },
                    {
                        "id": 144052,
                        "name": "Palkan",
                        "latitude": "6.29638889",
                        "longitude": "125.03166667"
                    },
                    {
                        "id": 144053,
                        "name": "Pamantingan",
                        "latitude": "6.71413000",
                        "longitude": "124.38095000"
                    },
                    {
                        "id": 144055,
                        "name": "Pangyan",
                        "latitude": "5.70083333",
                        "longitude": "125.28111111"
                    },
                    {
                        "id": 144056,
                        "name": "Paraiso",
                        "latitude": "6.47606000",
                        "longitude": "124.80954000"
                    },
                    {
                        "id": 144057,
                        "name": "Patindeguen",
                        "latitude": "7.21972222",
                        "longitude": "124.49833333"
                    },
                    {
                        "id": 144058,
                        "name": "Pedtad",
                        "latitude": "7.16055556",
                        "longitude": "124.81444444"
                    },
                    {
                        "id": 144062,
                        "name": "Pimbalayan",
                        "latitude": "6.86916667",
                        "longitude": "124.67250000"
                    },
                    {
                        "id": 144063,
                        "name": "Polo",
                        "latitude": "6.26472222",
                        "longitude": "125.11250000"
                    },
                    {
                        "id": 144065,
                        "name": "Polonoling",
                        "latitude": "6.28496000",
                        "longitude": "124.96890000"
                    },
                    {
                        "id": 144068,
                        "name": "Puloypuloy",
                        "latitude": "6.63527778",
                        "longitude": "124.09611111"
                    },
                    {
                        "id": 144069,
                        "name": "Punolu",
                        "latitude": "7.05000000",
                        "longitude": "124.58333333"
                    },
                    {
                        "id": 144070,
                        "name": "Puricay",
                        "latitude": "6.68611111",
                        "longitude": "124.06944444"
                    },
                    {
                        "id": 144071,
                        "name": "Ragandang",
                        "latitude": "6.66388889",
                        "longitude": "124.12055556"
                    },
                    {
                        "id": 144072,
                        "name": "Rotunda",
                        "latitude": "6.49179000",
                        "longitude": "124.88616000"
                    },
                    {
                        "id": 144073,
                        "name": "Sadsalan",
                        "latitude": "6.82906000",
                        "longitude": "124.60893000"
                    },
                    {
                        "id": 144074,
                        "name": "Saguing",
                        "latitude": "6.98027778",
                        "longitude": "125.07805556"
                    },
                    {
                        "id": 144075,
                        "name": "Salimbao",
                        "latitude": "7.22250000",
                        "longitude": "124.25333333"
                    },
                    {
                        "id": 144076,
                        "name": "Salunayan",
                        "latitude": "7.15444444",
                        "longitude": "124.49750000"
                    },
                    {
                        "id": 144077,
                        "name": "Sampao",
                        "latitude": "6.87666667",
                        "longitude": "124.59555556"
                    },
                    {
                        "id": 144078,
                        "name": "San Miguel",
                        "latitude": "6.49245000",
                        "longitude": "124.69643000"
                    },
                    {
                        "id": 144079,
                        "name": "San Vicente",
                        "latitude": "6.45375000",
                        "longitude": "124.78005000"
                    },
                    {
                        "id": 144083,
                        "name": "Sañgay",
                        "latitude": "6.44500000",
                        "longitude": "124.04444444"
                    },
                    {
                        "id": 144080,
                        "name": "Santo Niño",
                        "latitude": "6.45733000",
                        "longitude": "124.66819000"
                    },
                    {
                        "id": 144082,
                        "name": "Sapu Padidu",
                        "latitude": "5.91722222",
                        "longitude": "125.26694444"
                    },
                    {
                        "id": 144084,
                        "name": "Sebu",
                        "latitude": "6.22482000",
                        "longitude": "124.71042000"
                    },
                    {
                        "id": 144085,
                        "name": "Silway 7",
                        "latitude": "6.17722222",
                        "longitude": "125.12055556"
                    },
                    {
                        "id": 144086,
                        "name": "Sinolon",
                        "latitude": "6.24388889",
                        "longitude": "124.81444444"
                    },
                    {
                        "id": 144087,
                        "name": "Sulit",
                        "latitude": "6.23611111",
                        "longitude": "125.02055556"
                    },
                    {
                        "id": 144089,
                        "name": "Suyan",
                        "latitude": "6.06027778",
                        "longitude": "125.38527778"
                    },
                    {
                        "id": 144090,
                        "name": "T'boli",
                        "latitude": "6.15000000",
                        "longitude": "124.78333000"
                    },
                    {
                        "id": 144092,
                        "name": "Taguisa",
                        "latitude": "6.69833333",
                        "longitude": "124.03583333"
                    },
                    {
                        "id": 144093,
                        "name": "Taluya",
                        "latitude": "5.81166667",
                        "longitude": "125.17277778"
                    },
                    {
                        "id": 144094,
                        "name": "Tambak",
                        "latitude": "6.72532000",
                        "longitude": "124.62342000"
                    },
                    {
                        "id": 144095,
                        "name": "Tambilil",
                        "latitude": "5.96222222",
                        "longitude": "124.66972222"
                    },
                    {
                        "id": 144096,
                        "name": "Tamnag",
                        "latitude": "6.57298000",
                        "longitude": "124.88004000"
                    },
                    {
                        "id": 144099,
                        "name": "Tañgo",
                        "latitude": "5.88083333",
                        "longitude": "125.22194444"
                    },
                    {
                        "id": 144100,
                        "name": "Telafas",
                        "latitude": "6.62980000",
                        "longitude": "124.97294000"
                    },
                    {
                        "id": 144101,
                        "name": "Teresita",
                        "latitude": "6.41434000",
                        "longitude": "124.70778000"
                    },
                    {
                        "id": 144102,
                        "name": "Tinoto",
                        "latitude": "5.88666667",
                        "longitude": "125.07055556"
                    },
                    {
                        "id": 144103,
                        "name": "Tomado",
                        "latitude": "7.19250000",
                        "longitude": "124.60805556"
                    },
                    {
                        "id": 144104,
                        "name": "Tran",
                        "latitude": "6.72027778",
                        "longitude": "124.05500000"
                    },
                    {
                        "id": 144105,
                        "name": "Tuka",
                        "latitude": "6.51862000",
                        "longitude": "124.58736000"
                    },
                    {
                        "id": 144108,
                        "name": "Tuyan",
                        "latitude": "6.00000000",
                        "longitude": "125.28333333"
                    },
                    {
                        "id": 144109,
                        "name": "Upper Klinan",
                        "latitude": "6.22722222",
                        "longitude": "125.12083333"
                    },
                    {
                        "id": 144110,
                        "name": "Upper San Mateo",
                        "latitude": "7.17305556",
                        "longitude": "124.58222222"
                    },
                    {
                        "id": 144111,
                        "name": "Villamor",
                        "latitude": "6.70380000",
                        "longitude": "124.52009000"
                    }
                ]
            },
            {
                "id": 1278,
                "name": "Bulacan",
                "iso2": "BUL",
                "latitude": "14.79427350",
                "longitude": "120.87990080",
                "type": "province",
                "cities": [
                    {
                        "id": 144371,
                        "name": "Agay",
                        "latitude": "9.05361111",
                        "longitude": "125.58666667"
                    },
                    {
                        "id": 144375,
                        "name": "Amaga",
                        "latitude": "8.53083333",
                        "longitude": "126.07027778"
                    },
                    {
                        "id": 144376,
                        "name": "Anticala",
                        "latitude": "9.00444444",
                        "longitude": "125.64527778"
                    },
                    {
                        "id": 144377,
                        "name": "Aras-asan",
                        "latitude": "8.88777778",
                        "longitude": "126.31111111"
                    },
                    {
                        "id": 144379,
                        "name": "Bacolod",
                        "latitude": "8.93166667",
                        "longitude": "126.28944444"
                    },
                    {
                        "id": 144381,
                        "name": "Bah-Bah",
                        "latitude": "8.60722222",
                        "longitude": "125.91444444"
                    },
                    {
                        "id": 144382,
                        "name": "Balangbalang",
                        "latitude": "9.05694444",
                        "longitude": "125.62277778"
                    },
                    {
                        "id": 144383,
                        "name": "Bancasi",
                        "latitude": "8.96666667",
                        "longitude": "125.46666667"
                    },
                    {
                        "id": 144384,
                        "name": "Bangonay",
                        "latitude": "9.31444444",
                        "longitude": "125.55388889"
                    },
                    {
                        "id": 144387,
                        "name": "Basa",
                        "latitude": "8.07222222",
                        "longitude": "126.06416667"
                    },
                    {
                        "id": 144389,
                        "name": "Bayabas",
                        "latitude": "8.96666667",
                        "longitude": "126.26666667"
                    },
                    {
                        "id": 144390,
                        "name": "Bayugan",
                        "latitude": "8.78564000",
                        "longitude": "125.78175000"
                    },
                    {
                        "id": 144392,
                        "name": "Bigaan",
                        "latitude": "8.31722222",
                        "longitude": "126.28111111"
                    },
                    {
                        "id": 144393,
                        "name": "Binucayan",
                        "latitude": "8.25000000",
                        "longitude": "125.71666667"
                    },
                    {
                        "id": 144396,
                        "name": "Buenavista",
                        "latitude": "8.97694444",
                        "longitude": "125.40888889"
                    },
                    {
                        "id": 144398,
                        "name": "Bunawan",
                        "latitude": "8.16722000",
                        "longitude": "125.99083000"
                    },
                    {
                        "id": 144401,
                        "name": "Butuan",
                        "latitude": "8.95000000",
                        "longitude": "125.53333000"
                    },
                    {
                        "id": 144402,
                        "name": "Cabadbaran",
                        "latitude": "9.12261000",
                        "longitude": "125.53549000"
                    },
                    {
                        "id": 144406,
                        "name": "Caloc-an",
                        "latitude": "9.04694444",
                        "longitude": "125.53055556"
                    },
                    {
                        "id": 144407,
                        "name": "Cantapoy",
                        "latitude": "9.49055556",
                        "longitude": "125.43638889"
                    },
                    {
                        "id": 144409,
                        "name": "Capalayan",
                        "latitude": "9.74055556",
                        "longitude": "125.54444444"
                    },
                    {
                        "id": 144413,
                        "name": "Causwagan",
                        "latitude": "8.44750000",
                        "longitude": "125.84027778"
                    },
                    {
                        "id": 144414,
                        "name": "City of Cabadbaran",
                        "latitude": "9.13748000",
                        "longitude": "125.65543000"
                    },
                    {
                        "id": 144416,
                        "name": "Comagascas",
                        "latitude": "9.13972222",
                        "longitude": "125.55972222"
                    },
                    {
                        "id": 144418,
                        "name": "Cuevas",
                        "latitude": "8.01916667",
                        "longitude": "126.09416667"
                    },
                    {
                        "id": 144419,
                        "name": "Culit",
                        "latitude": "8.94722222",
                        "longitude": "125.35694444"
                    },
                    {
                        "id": 144420,
                        "name": "Dakbayan sa Bislig",
                        "latitude": "8.20996000",
                        "longitude": "126.30947000"
                    },
                    {
                        "id": 144424,
                        "name": "Del Pilar",
                        "latitude": "9.15194444",
                        "longitude": "125.58472222"
                    },
                    {
                        "id": 144427,
                        "name": "Gamut",
                        "latitude": "8.53166667",
                        "longitude": "126.24111111"
                    },
                    {
                        "id": 144431,
                        "name": "Guadalupe",
                        "latitude": "8.58277778",
                        "longitude": "125.70805556"
                    },
                    {
                        "id": 144432,
                        "name": "Guinabsan",
                        "latitude": "8.89750000",
                        "longitude": "125.41611111"
                    },
                    {
                        "id": 144434,
                        "name": "Ipil",
                        "latitude": "9.79083333",
                        "longitude": "125.43861111"
                    },
                    {
                        "id": 144435,
                        "name": "Jabonga",
                        "latitude": "9.34306000",
                        "longitude": "125.51556000"
                    },
                    {
                        "id": 144436,
                        "name": "Jagupit",
                        "latitude": "9.24222222",
                        "longitude": "125.55805556"
                    },
                    {
                        "id": 144439,
                        "name": "Kinabhangan",
                        "latitude": "8.96916667",
                        "longitude": "125.35750000"
                    },
                    {
                        "id": 144440,
                        "name": "Kitcharao",
                        "latitude": "9.45500000",
                        "longitude": "125.57306000"
                    },
                    {
                        "id": 144441,
                        "name": "La Paz",
                        "latitude": "8.27083333",
                        "longitude": "125.79972222"
                    },
                    {
                        "id": 144443,
                        "name": "La Union",
                        "latitude": "9.08555556",
                        "longitude": "125.53583333"
                    },
                    {
                        "id": 144445,
                        "name": "Lapinigan",
                        "latitude": "8.42055556",
                        "longitude": "125.98250000"
                    },
                    {
                        "id": 144446,
                        "name": "Las Nieves",
                        "latitude": "8.73167000",
                        "longitude": "125.59917000"
                    },
                    {
                        "id": 144448,
                        "name": "Libas",
                        "latitude": "9.88333333",
                        "longitude": "125.98333333"
                    },
                    {
                        "id": 144449,
                        "name": "Libertad",
                        "latitude": "8.94416667",
                        "longitude": "125.50194444"
                    },
                    {
                        "id": 144455,
                        "name": "Los Angeles",
                        "latitude": "9.01250000",
                        "longitude": "125.60805556"
                    },
                    {
                        "id": 144456,
                        "name": "Los Arcos",
                        "latitude": "8.63277778",
                        "longitude": "125.98555556"
                    },
                    {
                        "id": 144457,
                        "name": "Loyola",
                        "latitude": "8.33500000",
                        "longitude": "126.33361111"
                    },
                    {
                        "id": 144458,
                        "name": "Luna",
                        "latitude": "9.73694444",
                        "longitude": "125.49750000"
                    },
                    {
                        "id": 144459,
                        "name": "Mabahin",
                        "latitude": "9.18555556",
                        "longitude": "126.17055556"
                    },
                    {
                        "id": 144460,
                        "name": "Mabua",
                        "latitude": "9.80388889",
                        "longitude": "125.44083333"
                    },
                    {
                        "id": 144465,
                        "name": "Manapa",
                        "latitude": "8.97777778",
                        "longitude": "125.43944444"
                    },
                    {
                        "id": 144467,
                        "name": "Matabao",
                        "latitude": "8.95722222",
                        "longitude": "125.39944444"
                    },
                    {
                        "id": 144469,
                        "name": "Maygatasan",
                        "latitude": "8.70944444",
                        "longitude": "125.71833333"
                    },
                    {
                        "id": 144470,
                        "name": "Nasipit",
                        "latitude": "8.96917000",
                        "longitude": "125.29472000"
                    },
                    {
                        "id": 144472,
                        "name": "Panikian",
                        "latitude": "9.32944444",
                        "longitude": "125.93388889"
                    },
                    {
                        "id": 144474,
                        "name": "Patin-ay",
                        "latitude": "8.55055556",
                        "longitude": "125.93722222"
                    },
                    {
                        "id": 144477,
                        "name": "Prosperidad",
                        "latitude": "8.58000000",
                        "longitude": "125.89639000"
                    },
                    {
                        "id": 144478,
                        "name": "Punta",
                        "latitude": "8.98972222",
                        "longitude": "125.34000000"
                    },
                    {
                        "id": 144482,
                        "name": "Salvacion",
                        "latitude": "7.99944444",
                        "longitude": "126.12472222"
                    },
                    {
                        "id": 144485,
                        "name": "San Agustin",
                        "latitude": "8.74366389",
                        "longitude": "126.22143333"
                    },
                    {
                        "id": 144488,
                        "name": "San Francisco",
                        "latitude": "8.53556000",
                        "longitude": "125.95000000"
                    },
                    {
                        "id": 144492,
                        "name": "San Isidro",
                        "latitude": "7.75000000",
                        "longitude": "125.73333333"
                    },
                    {
                        "id": 144495,
                        "name": "San Miguel",
                        "latitude": "8.88333333",
                        "longitude": "126.00000000"
                    },
                    {
                        "id": 144496,
                        "name": "Sanghan",
                        "latitude": "9.08555556",
                        "longitude": "125.57277778"
                    },
                    {
                        "id": 144497,
                        "name": "Santa Ana",
                        "latitude": "9.19277778",
                        "longitude": "125.56444444"
                    },
                    {
                        "id": 144498,
                        "name": "Santa Josefa",
                        "latitude": "7.99111000",
                        "longitude": "126.03000000"
                    },
                    {
                        "id": 144499,
                        "name": "Santa Maria",
                        "latitude": "8.03333333",
                        "longitude": "126.16250000"
                    },
                    {
                        "id": 144501,
                        "name": "Santa Monica",
                        "latitude": "10.02000000",
                        "longitude": "126.03833000"
                    },
                    {
                        "id": 144503,
                        "name": "Santiago",
                        "latitude": "9.26556000",
                        "longitude": "125.55917000"
                    },
                    {
                        "id": 144505,
                        "name": "Sibagat",
                        "latitude": "8.82250000",
                        "longitude": "125.69750000"
                    },
                    {
                        "id": 144506,
                        "name": "Sinubong",
                        "latitude": "8.06833333",
                        "longitude": "125.93083333"
                    },
                    {
                        "id": 144508,
                        "name": "Socorro",
                        "latitude": "9.62100000",
                        "longitude": "125.96700000"
                    },
                    {
                        "id": 144512,
                        "name": "Tagcatong",
                        "latitude": "9.00222222",
                        "longitude": "125.25694444"
                    },
                    {
                        "id": 144514,
                        "name": "Talacogon",
                        "latitude": "8.41667000",
                        "longitude": "125.80000000"
                    },
                    {
                        "id": 144515,
                        "name": "Taligaman",
                        "latitude": "8.90444444",
                        "longitude": "125.65583333"
                    },
                    {
                        "id": 144516,
                        "name": "Talisay",
                        "latitude": "9.81888889",
                        "longitude": "125.61555556"
                    },
                    {
                        "id": 144519,
                        "name": "Tidman",
                        "latitude": "8.29861111",
                        "longitude": "126.33888889"
                    },
                    {
                        "id": 144520,
                        "name": "Tigao",
                        "latitude": "9.20888889",
                        "longitude": "126.17611111"
                    },
                    {
                        "id": 144521,
                        "name": "Trento",
                        "latitude": "8.05000000",
                        "longitude": "126.13333000"
                    },
                    {
                        "id": 144523,
                        "name": "Tubay",
                        "latitude": "9.16694000",
                        "longitude": "125.52389000"
                    },
                    {
                        "id": 144525,
                        "name": "Unidad",
                        "latitude": "8.53555556",
                        "longitude": "126.22861111"
                    },
                    {
                        "id": 144526,
                        "name": "Union",
                        "latitude": "9.75666667",
                        "longitude": "126.11027778"
                    },
                    {
                        "id": 144527,
                        "name": "Veruela",
                        "latitude": "8.07310000",
                        "longitude": "125.95580000"
                    }
                ]
            },
            {
                "id": 1279,
                "name": "Cagayan",
                "iso2": "CAG",
                "latitude": "18.24896290",
                "longitude": "121.87878330",
                "type": "province",
                "cities": [
                    {
                        "id": 144610,
                        "name": "Andalan",
                        "latitude": "5.95944444",
                        "longitude": "121.39027778"
                    },
                    {
                        "id": 144611,
                        "name": "Anuling",
                        "latitude": "6.03555556",
                        "longitude": "121.00666667"
                    },
                    {
                        "id": 144612,
                        "name": "Awang",
                        "latitude": "7.15305556",
                        "longitude": "124.22111111"
                    },
                    {
                        "id": 144613,
                        "name": "Bacayawan",
                        "latitude": "7.76666667",
                        "longitude": "124.23333333"
                    },
                    {
                        "id": 144614,
                        "name": "Bacolod Grande",
                        "latitude": "7.88333000",
                        "longitude": "124.11667000"
                    },
                    {
                        "id": 144616,
                        "name": "Badak",
                        "latitude": "6.84722222",
                        "longitude": "124.72055556"
                    },
                    {
                        "id": 144617,
                        "name": "Bagan",
                        "latitude": "6.92555556",
                        "longitude": "124.42027778"
                    },
                    {
                        "id": 144628,
                        "name": "Baka",
                        "latitude": "7.27611111",
                        "longitude": "124.26416667"
                    },
                    {
                        "id": 144629,
                        "name": "Bakung",
                        "latitude": "4.89111111",
                        "longitude": "119.79416667"
                    },
                    {
                        "id": 144631,
                        "name": "Balas",
                        "latitude": "6.68750000",
                        "longitude": "122.13805556"
                    },
                    {
                        "id": 144634,
                        "name": "Bangkal",
                        "latitude": "6.06666667",
                        "longitude": "121.06666667"
                    },
                    {
                        "id": 144636,
                        "name": "Bankaw",
                        "latitude": "5.01916667",
                        "longitude": "120.00916667"
                    },
                    {
                        "id": 144638,
                        "name": "Barurao",
                        "latitude": "6.89805556",
                        "longitude": "124.59750000"
                    },
                    {
                        "id": 144639,
                        "name": "Bato Bato",
                        "latitude": "6.03444444",
                        "longitude": "120.94638889"
                    },
                    {
                        "id": 144640,
                        "name": "Baunu-Timbangan",
                        "latitude": "6.00555556",
                        "longitude": "120.99416667"
                    },
                    {
                        "id": 144641,
                        "name": "Bawison",
                        "latitude": "5.93750000",
                        "longitude": "120.87444444"
                    },
                    {
                        "id": 144643,
                        "name": "Bayanga",
                        "latitude": "7.52138889",
                        "longitude": "124.25222222"
                    },
                    {
                        "id": 144644,
                        "name": "Begang",
                        "latitude": "6.69083333",
                        "longitude": "122.01666667"
                    },
                    {
                        "id": 144646,
                        "name": "Binuang",
                        "latitude": "5.95694444",
                        "longitude": "121.06000000"
                    },
                    {
                        "id": 144647,
                        "name": "Blinsung",
                        "latitude": "7.01805556",
                        "longitude": "124.18055556"
                    },
                    {
                        "id": 144649,
                        "name": "Bongued",
                        "latitude": "7.11666667",
                        "longitude": "124.40000000"
                    },
                    {
                        "id": 144651,
                        "name": "Bualan",
                        "latitude": "7.75000000",
                        "longitude": "124.26666667"
                    },
                    {
                        "id": 144653,
                        "name": "Buan",
                        "latitude": "5.16083333",
                        "longitude": "120.04250000"
                    },
                    {
                        "id": 144655,
                        "name": "Buansa",
                        "latitude": "6.02583333",
                        "longitude": "120.96138889"
                    },
                    {
                        "id": 144657,
                        "name": "Budta",
                        "latitude": "7.20416667",
                        "longitude": "124.43972222"
                    },
                    {
                        "id": 144668,
                        "name": "Bugasan",
                        "latitude": "7.44083333",
                        "longitude": "124.25916667"
                    },
                    {
                        "id": 144670,
                        "name": "Buliok",
                        "latitude": "7.01666667",
                        "longitude": "124.70000000"
                    },
                    {
                        "id": 144671,
                        "name": "Bulit",
                        "latitude": "7.11527778",
                        "longitude": "124.78944444"
                    },
                    {
                        "id": 144674,
                        "name": "Cagayan de Tawi-Tawi",
                        "latitude": "7.01667000",
                        "longitude": "118.46667000"
                    },
                    {
                        "id": 144677,
                        "name": "Colonia",
                        "latitude": "6.64361111",
                        "longitude": "122.15750000"
                    },
                    {
                        "id": 144678,
                        "name": "Dado",
                        "latitude": "7.05000000",
                        "longitude": "124.45972222"
                    },
                    {
                        "id": 144679,
                        "name": "Dadus",
                        "latitude": "7.05750000",
                        "longitude": "124.32166667"
                    },
                    {
                        "id": 144680,
                        "name": "Dalican",
                        "latitude": "6.96666667",
                        "longitude": "124.40000000"
                    },
                    {
                        "id": 144681,
                        "name": "Dalumangcob",
                        "latitude": "7.21666667",
                        "longitude": "124.30000000"
                    },
                    {
                        "id": 144682,
                        "name": "Damabalas",
                        "latitude": "7.01555556",
                        "longitude": "124.51416667"
                    },
                    {
                        "id": 144683,
                        "name": "Damatulan",
                        "latitude": "7.03888889",
                        "longitude": "124.48277778"
                    },
                    {
                        "id": 144688,
                        "name": "Digal",
                        "latitude": "6.75305556",
                        "longitude": "124.79638889"
                    },
                    {
                        "id": 144689,
                        "name": "Dinaig",
                        "latitude": "7.08333000",
                        "longitude": "124.26667000"
                    },
                    {
                        "id": 144690,
                        "name": "Dinganen",
                        "latitude": "7.32833333",
                        "longitude": "124.37833333"
                    },
                    {
                        "id": 144692,
                        "name": "Ebcor Town",
                        "latitude": "7.44055556",
                        "longitude": "124.39722222"
                    },
                    {
                        "id": 144693,
                        "name": "Gadung",
                        "latitude": "6.80250000",
                        "longitude": "124.02000000"
                    },
                    {
                        "id": 144695,
                        "name": "Gang",
                        "latitude": "7.24583333",
                        "longitude": "124.26638889"
                    },
                    {
                        "id": 144696,
                        "name": "Guiong",
                        "latitude": "6.41861111",
                        "longitude": "122.02583333"
                    },
                    {
                        "id": 144528,
                        "name": "Idtig",
                        "latitude": "6.79888889",
                        "longitude": "124.77277778"
                    },
                    {
                        "id": 144532,
                        "name": "Kabasalan",
                        "latitude": "7.06666667",
                        "longitude": "124.65000000"
                    },
                    {
                        "id": 144534,
                        "name": "Kagay",
                        "latitude": "6.00888889",
                        "longitude": "120.90750000"
                    },
                    {
                        "id": 144535,
                        "name": "Kajatian",
                        "latitude": "6.03111111",
                        "longitude": "120.99194444"
                    },
                    {
                        "id": 144536,
                        "name": "Kalang",
                        "latitude": "5.91972222",
                        "longitude": "121.36305556"
                    },
                    {
                        "id": 144537,
                        "name": "Kalbugan",
                        "latitude": "6.95972222",
                        "longitude": "124.65916667"
                    },
                    {
                        "id": 144539,
                        "name": "Kambing",
                        "latitude": "5.94638889",
                        "longitude": "121.30750000"
                    },
                    {
                        "id": 144540,
                        "name": "Kanlagay",
                        "latitude": "5.87555556",
                        "longitude": "121.29138889"
                    },
                    {
                        "id": 144541,
                        "name": "Kansipati",
                        "latitude": "6.00111111",
                        "longitude": "121.23444444"
                    },
                    {
                        "id": 144544,
                        "name": "Karungdong",
                        "latitude": "5.88444444",
                        "longitude": "121.26305556"
                    },
                    {
                        "id": 144545,
                        "name": "Katico",
                        "latitude": "6.76015000",
                        "longitude": "124.73214000"
                    },
                    {
                        "id": 144546,
                        "name": "Katidtuan",
                        "latitude": "7.18861111",
                        "longitude": "124.31527778"
                    },
                    {
                        "id": 144547,
                        "name": "Katuli",
                        "latitude": "7.43333333",
                        "longitude": "124.21666667"
                    },
                    {
                        "id": 144548,
                        "name": "Kauran",
                        "latitude": "6.79454000",
                        "longitude": "124.47034000"
                    },
                    {
                        "id": 144549,
                        "name": "Kitango",
                        "latitude": "6.94833333",
                        "longitude": "124.44111111"
                    },
                    {
                        "id": 144550,
                        "name": "Kitapak",
                        "latitude": "6.95333333",
                        "longitude": "124.42555556"
                    },
                    {
                        "id": 144551,
                        "name": "Kolape",
                        "latitude": "5.07027778",
                        "longitude": "119.89694444"
                    },
                    {
                        "id": 144552,
                        "name": "Kulase",
                        "latitude": "5.90527778",
                        "longitude": "120.95694444"
                    },
                    {
                        "id": 144553,
                        "name": "Kulay-Kulay",
                        "latitude": "5.94527778",
                        "longitude": "121.23250000"
                    },
                    {
                        "id": 144554,
                        "name": "Kulempang",
                        "latitude": "7.51944444",
                        "longitude": "124.38972222"
                    },
                    {
                        "id": 144555,
                        "name": "Kungtad",
                        "latitude": "5.55722222",
                        "longitude": "120.84722222"
                    },
                    {
                        "id": 144556,
                        "name": "Labuñgan",
                        "latitude": "7.10305556",
                        "longitude": "124.23500000"
                    },
                    {
                        "id": 144557,
                        "name": "Laminusa",
                        "latitude": "5.55500000",
                        "longitude": "120.91361111"
                    },
                    {
                        "id": 144559,
                        "name": "Lamitan City",
                        "latitude": "6.63333000",
                        "longitude": "122.10000000"
                    },
                    {
                        "id": 144560,
                        "name": "Langpas",
                        "latitude": "5.97500000",
                        "longitude": "120.94888889"
                    },
                    {
                        "id": 144562,
                        "name": "Larap",
                        "latitude": "4.76166667",
                        "longitude": "119.40500000"
                    },
                    {
                        "id": 144563,
                        "name": "Latung",
                        "latitude": "5.50000000",
                        "longitude": "120.88333333"
                    },
                    {
                        "id": 144564,
                        "name": "Layog",
                        "latitude": "7.07666667",
                        "longitude": "124.73055556"
                    },
                    {
                        "id": 144565,
                        "name": "Ligayan",
                        "latitude": "4.65444444",
                        "longitude": "119.47055556"
                    },
                    {
                        "id": 144566,
                        "name": "Limbo",
                        "latitude": "7.25166667",
                        "longitude": "124.24388889"
                    },
                    {
                        "id": 144567,
                        "name": "Litayan",
                        "latitude": "7.33583333",
                        "longitude": "124.03472222"
                    },
                    {
                        "id": 144568,
                        "name": "Lookan",
                        "latitude": "5.03694444",
                        "longitude": "120.10277778"
                    },
                    {
                        "id": 144570,
                        "name": "Lumba-a-Bayabao",
                        "latitude": "7.78333000",
                        "longitude": "124.50000000"
                    },
                    {
                        "id": 144571,
                        "name": "Lumbac",
                        "latitude": "7.73416667",
                        "longitude": "124.25277778"
                    },
                    {
                        "id": 144576,
                        "name": "Luuk Datan",
                        "latitude": "4.81194444",
                        "longitude": "119.84527778"
                    },
                    {
                        "id": 144580,
                        "name": "Mahala",
                        "latitude": "5.91666667",
                        "longitude": "121.13333333"
                    },
                    {
                        "id": 144582,
                        "name": "Makir",
                        "latitude": "7.03083333",
                        "longitude": "124.30416667"
                    },
                    {
                        "id": 144585,
                        "name": "Manubul",
                        "latitude": "5.47333333",
                        "longitude": "120.79861111"
                    },
                    {
                        "id": 144586,
                        "name": "Manuk Mangkaw",
                        "latitude": "4.80000000",
                        "longitude": "119.85000000"
                    },
                    {
                        "id": 144590,
                        "name": "Marsada",
                        "latitude": "5.93138889",
                        "longitude": "121.10694444"
                    },
                    {
                        "id": 144591,
                        "name": "Marunggas",
                        "latitude": "6.19193000",
                        "longitude": "120.96085000"
                    },
                    {
                        "id": 144594,
                        "name": "Mataya",
                        "latitude": "7.47111111",
                        "longitude": "124.37194444"
                    },
                    {
                        "id": 144595,
                        "name": "Mauboh",
                        "latitude": "5.99000000",
                        "longitude": "121.09361111"
                    },
                    {
                        "id": 144596,
                        "name": "Mileb",
                        "latitude": "6.89861111",
                        "longitude": "124.58388889"
                    },
                    {
                        "id": 144597,
                        "name": "Molundo",
                        "latitude": "7.91786000",
                        "longitude": "124.36542000"
                    },
                    {
                        "id": 144598,
                        "name": "Municipality of Indanan",
                        "latitude": "5.99429000",
                        "longitude": "120.96028000"
                    },
                    {
                        "id": 144599,
                        "name": "Municipality of Lantawan",
                        "latitude": "6.62650000",
                        "longitude": "121.86420000"
                    },
                    {
                        "id": 144600,
                        "name": "Municipality of Pangutaran",
                        "latitude": "6.30500000",
                        "longitude": "120.55400000"
                    },
                    {
                        "id": 144601,
                        "name": "Municipality of Sultan Gumander",
                        "latitude": "7.69050000",
                        "longitude": "123.94060000"
                    },
                    {
                        "id": 144602,
                        "name": "Municipality of Tongkil",
                        "latitude": "6.02517000",
                        "longitude": "121.83632000"
                    },
                    {
                        "id": 144603,
                        "name": "New Batu Batu",
                        "latitude": "5.06666667",
                        "longitude": "119.88333333"
                    },
                    {
                        "id": 144604,
                        "name": "New Panamao",
                        "latitude": "5.96667000",
                        "longitude": "121.18333000"
                    },
                    {
                        "id": 144605,
                        "name": "Nuyo",
                        "latitude": "7.41805556",
                        "longitude": "124.41083333"
                    },
                    {
                        "id": 144606,
                        "name": "Old Panamao",
                        "latitude": "5.98333333",
                        "longitude": "121.25000000"
                    },
                    {
                        "id": 144619,
                        "name": "Pagatin",
                        "latitude": "6.97305556",
                        "longitude": "124.47527778"
                    },
                    {
                        "id": 144623,
                        "name": "Paitan",
                        "latitude": "6.66005000",
                        "longitude": "124.87183000"
                    },
                    {
                        "id": 144624,
                        "name": "Panabuan",
                        "latitude": "5.96166667",
                        "longitude": "120.96277778"
                    },
                    {
                        "id": 144625,
                        "name": "Panadtaban",
                        "latitude": "6.90083333",
                        "longitude": "124.64277778"
                    },
                    {
                        "id": 144627,
                        "name": "Pandakan",
                        "latitude": "5.98888889",
                        "longitude": "121.16583333"
                    },
                    {
                        "id": 144659,
                        "name": "Pandan Niog",
                        "latitude": "6.22833333",
                        "longitude": "120.56305556"
                    },
                    {
                        "id": 144660,
                        "name": "Pang",
                        "latitude": "5.94833333",
                        "longitude": "121.28833333"
                    },
                    {
                        "id": 144665,
                        "name": "Parangan",
                        "latitude": "5.08388889",
                        "longitude": "119.93833333"
                    },
                    {
                        "id": 144666,
                        "name": "Parian Dakula",
                        "latitude": "5.55666667",
                        "longitude": "120.77194444"
                    },
                    {
                        "id": 144667,
                        "name": "Pata",
                        "latitude": "5.84440833",
                        "longitude": "121.14386111"
                    },
                    {
                        "id": 144698,
                        "name": "Pawak",
                        "latitude": "8.01638889",
                        "longitude": "124.25638889"
                    },
                    {
                        "id": 144699,
                        "name": "Payuhan",
                        "latitude": "5.94166667",
                        "longitude": "120.90111111"
                    },
                    {
                        "id": 144701,
                        "name": "Pidsandawan",
                        "latitude": "6.93222222",
                        "longitude": "124.59083333"
                    },
                    {
                        "id": 144702,
                        "name": "Pinaring",
                        "latitude": "7.22888889",
                        "longitude": "124.31055556"
                    },
                    {
                        "id": 144704,
                        "name": "Poon-a-Bayabao",
                        "latitude": "7.83333000",
                        "longitude": "124.35000000"
                    },
                    {
                        "id": 144706,
                        "name": "Punay",
                        "latitude": "5.96138889",
                        "longitude": "121.19805556"
                    },
                    {
                        "id": 144707,
                        "name": "Rimpeso",
                        "latitude": "7.02388889",
                        "longitude": "124.10027778"
                    },
                    {
                        "id": 144708,
                        "name": "Rominimbang",
                        "latitude": "7.50000000",
                        "longitude": "124.30000000"
                    },
                    {
                        "id": 144709,
                        "name": "Sagasa",
                        "latitude": "6.77405000",
                        "longitude": "124.57408000"
                    },
                    {
                        "id": 144711,
                        "name": "Sambuluan",
                        "latitude": "6.88333333",
                        "longitude": "124.70000000"
                    },
                    {
                        "id": 144712,
                        "name": "Sanga-Sanga",
                        "latitude": "5.07250000",
                        "longitude": "119.78527778"
                    },
                    {
                        "id": 144713,
                        "name": "Santa Clara",
                        "latitude": "6.67833333",
                        "longitude": "122.06000000"
                    },
                    {
                        "id": 144714,
                        "name": "Sapa",
                        "latitude": "5.15444444",
                        "longitude": "120.32416667"
                    },
                    {
                        "id": 144716,
                        "name": "Sapadun",
                        "latitude": "7.48333333",
                        "longitude": "124.25000000"
                    },
                    {
                        "id": 144717,
                        "name": "Satan",
                        "latitude": "6.86305556",
                        "longitude": "124.40861111"
                    },
                    {
                        "id": 144718,
                        "name": "Semut",
                        "latitude": "6.66361111",
                        "longitude": "122.21888889"
                    },
                    {
                        "id": 144721,
                        "name": "Simuay",
                        "latitude": "7.27722222",
                        "longitude": "124.30722222"
                    },
                    {
                        "id": 144723,
                        "name": "Sionogan",
                        "latitude": "6.00527778",
                        "longitude": "120.94861111"
                    },
                    {
                        "id": 144729,
                        "name": "Sultan Sumagka",
                        "latitude": "7.03532500",
                        "longitude": "124.37575556"
                    },
                    {
                        "id": 144733,
                        "name": "Tabiauan",
                        "latitude": "6.02805556",
                        "longitude": "121.89361111"
                    },
                    {
                        "id": 144734,
                        "name": "Tablas",
                        "latitude": "6.62916667",
                        "longitude": "122.17472222"
                    },
                    {
                        "id": 144735,
                        "name": "Tairan Camp",
                        "latitude": "6.64027778",
                        "longitude": "121.83944444"
                    },
                    {
                        "id": 144738,
                        "name": "Talipaw",
                        "latitude": "5.91000000",
                        "longitude": "121.09444444"
                    },
                    {
                        "id": 144742,
                        "name": "Tapayan",
                        "latitude": "7.29444444",
                        "longitude": "124.26611111"
                    },
                    {
                        "id": 144743,
                        "name": "Tapikan",
                        "latitude": "6.85194444",
                        "longitude": "124.32250000"
                    },
                    {
                        "id": 144747,
                        "name": "Taungoh",
                        "latitude": "4.70666667",
                        "longitude": "119.49305556"
                    },
                    {
                        "id": 144748,
                        "name": "Taviran",
                        "latitude": "7.12333333",
                        "longitude": "124.31972222"
                    },
                    {
                        "id": 144749,
                        "name": "Tinutulan",
                        "latitude": "7.10000000",
                        "longitude": "124.65000000"
                    },
                    {
                        "id": 144751,
                        "name": "Tongouson",
                        "latitude": "5.02138889",
                        "longitude": "120.13277778"
                    },
                    {
                        "id": 144756,
                        "name": "Tumbagaan",
                        "latitude": "5.36555556",
                        "longitude": "120.31388889"
                    },
                    {
                        "id": 144757,
                        "name": "Tunggol",
                        "latitude": "5.84444444",
                        "longitude": "121.15444444"
                    },
                    {
                        "id": 144758,
                        "name": "Tungol",
                        "latitude": "7.08083333",
                        "longitude": "124.75305556"
                    },
                    {
                        "id": 144760,
                        "name": "Ungus-Ungus",
                        "latitude": "5.05083333",
                        "longitude": "119.83972222"
                    },
                    {
                        "id": 144762,
                        "name": "Uyaan",
                        "latitude": "7.86305556",
                        "longitude": "124.04111111"
                    }
                ]
            },
            {
                "id": 1342,
                "name": "Cagayan Valley",
                "iso2": "02",
                "latitude": "18.43451760",
                "longitude": "119.00327250",
                "type": "region",
                "cities": [
                    {
                        "id": 81137,
                        "name": "Abulug",
                        "latitude": "18.44528000",
                        "longitude": "121.45333000"
                    },
                    {
                        "id": 81138,
                        "name": "Abut",
                        "latitude": "17.35423000",
                        "longitude": "121.60138000"
                    },
                    {
                        "id": 81143,
                        "name": "Accusilian",
                        "latitude": "17.74791000",
                        "longitude": "121.46254000"
                    },
                    {
                        "id": 81149,
                        "name": "Afusing Centro",
                        "latitude": "17.85260000",
                        "longitude": "121.62690000"
                    },
                    {
                        "id": 81158,
                        "name": "Aggugaddah",
                        "latitude": "17.70016000",
                        "longitude": "121.80250000"
                    },
                    {
                        "id": 81178,
                        "name": "Alabug",
                        "latitude": "17.73261000",
                        "longitude": "121.46773000"
                    },
                    {
                        "id": 81190,
                        "name": "Alannay",
                        "latitude": "18.06114000",
                        "longitude": "121.58616000"
                    },
                    {
                        "id": 81209,
                        "name": "Alibago",
                        "latitude": "17.11667000",
                        "longitude": "121.86667000"
                    },
                    {
                        "id": 81222,
                        "name": "Allacapan",
                        "latitude": "18.22598000",
                        "longitude": "121.55615000"
                    },
                    {
                        "id": 81226,
                        "name": "Almaguer North",
                        "latitude": "16.34970000",
                        "longitude": "121.09260000"
                    },
                    {
                        "id": 81252,
                        "name": "Amulung",
                        "latitude": "17.83570000",
                        "longitude": "121.72375000"
                    },
                    {
                        "id": 81278,
                        "name": "Antagan Segunda",
                        "latitude": "17.28268000",
                        "longitude": "121.87153000"
                    },
                    {
                        "id": 81292,
                        "name": "Aparri",
                        "latitude": "18.35660000",
                        "longitude": "121.64060000"
                    },
                    {
                        "id": 81329,
                        "name": "Atulayan",
                        "latitude": "17.66480000",
                        "longitude": "121.69370000"
                    },
                    {
                        "id": 81338,
                        "name": "Awallan",
                        "latitude": "17.92439000",
                        "longitude": "121.91305000"
                    },
                    {
                        "id": 81360,
                        "name": "Bacnor East",
                        "latitude": "17.03449000",
                        "longitude": "121.70375000"
                    },
                    {
                        "id": 81395,
                        "name": "Baggabag B",
                        "latitude": "16.50588000",
                        "longitude": "121.19014000"
                    },
                    {
                        "id": 81401,
                        "name": "Bagong Tanza",
                        "latitude": "16.98269000",
                        "longitude": "121.61109000"
                    },
                    {
                        "id": 81406,
                        "name": "Bagu",
                        "latitude": "18.42441000",
                        "longitude": "121.35573000"
                    },
                    {
                        "id": 81489,
                        "name": "Ballesteros",
                        "latitude": "18.41260000",
                        "longitude": "121.51520000"
                    },
                    {
                        "id": 81525,
                        "name": "Bangad",
                        "latitude": "17.49543000",
                        "longitude": "121.77714000"
                    },
                    {
                        "id": 81528,
                        "name": "Banganan",
                        "latitude": "16.31440000",
                        "longitude": "121.05440000"
                    },
                    {
                        "id": 81546,
                        "name": "Banquero",
                        "latitude": "17.02305000",
                        "longitude": "121.77834000"
                    },
                    {
                        "id": 81588,
                        "name": "Barucboc Norte",
                        "latitude": "17.25857000",
                        "longitude": "121.60561000"
                    },
                    {
                        "id": 81598,
                        "name": "Basco",
                        "latitude": "20.44865000",
                        "longitude": "121.97017000"
                    },
                    {
                        "id": 81612,
                        "name": "Batal",
                        "latitude": "16.68750000",
                        "longitude": "121.60083000"
                    },
                    {
                        "id": 81634,
                        "name": "Battung",
                        "latitude": "17.72261000",
                        "longitude": "121.45914000"
                    },
                    {
                        "id": 81676,
                        "name": "Belance",
                        "latitude": "16.18333000",
                        "longitude": "121.25000000"
                    },
                    {
                        "id": 81709,
                        "name": "Binalan",
                        "latitude": "18.32750000",
                        "longitude": "121.54510000"
                    },
                    {
                        "id": 81719,
                        "name": "Binguang",
                        "latitude": "17.45893000",
                        "longitude": "121.79519000"
                    },
                    {
                        "id": 81729,
                        "name": "Bintawan",
                        "latitude": "16.57588000",
                        "longitude": "121.18764000"
                    },
                    {
                        "id": 81740,
                        "name": "Bitag Grande",
                        "latitude": "17.90244000",
                        "longitude": "121.85013000"
                    },
                    {
                        "id": 81786,
                        "name": "Bone South",
                        "latitude": "16.24460000",
                        "longitude": "120.99580000"
                    },
                    {
                        "id": 81850,
                        "name": "Buguey",
                        "latitude": "18.28823000",
                        "longitude": "121.83310000"
                    },
                    {
                        "id": 81880,
                        "name": "Buliwao",
                        "latitude": "16.48333000",
                        "longitude": "121.23333000"
                    },
                    {
                        "id": 81884,
                        "name": "Bulu",
                        "latitude": "17.33333000",
                        "longitude": "121.76667000"
                    },
                    {
                        "id": 81917,
                        "name": "Busilak",
                        "latitude": "16.47750000",
                        "longitude": "121.12410000"
                    },
                    {
                        "id": 81951,
                        "name": "Cabannungan Second",
                        "latitude": "17.12490000",
                        "longitude": "121.85060000"
                    },
                    {
                        "id": 81953,
                        "name": "Cabaritan East",
                        "latitude": "18.41781000",
                        "longitude": "121.48872000"
                    },
                    {
                        "id": 81970,
                        "name": "Cabiraoan",
                        "latitude": "18.32377000",
                        "longitude": "122.08595000"
                    },
                    {
                        "id": 81982,
                        "name": "Cabulay",
                        "latitude": "16.74556000",
                        "longitude": "121.49750000"
                    },
                    {
                        "id": 82014,
                        "name": "Calamagui East",
                        "latitude": "17.48815000",
                        "longitude": "121.76845000"
                    },
                    {
                        "id": 82025,
                        "name": "Calantac",
                        "latitude": "17.90904000",
                        "longitude": "121.72280000"
                    },
                    {
                        "id": 82028,
                        "name": "Calaoagan",
                        "latitude": "18.04279000",
                        "longitude": "121.72325000"
                    },
                    {
                        "id": 82053,
                        "name": "Calinaoan Malasin",
                        "latitude": "17.35189000",
                        "longitude": "121.74074000"
                    },
                    {
                        "id": 82061,
                        "name": "Calog Norte",
                        "latitude": "18.36359000",
                        "longitude": "121.38533000"
                    },
                    {
                        "id": 82077,
                        "name": "Camalaniugan",
                        "latitude": "18.27400000",
                        "longitude": "121.67480000"
                    },
                    {
                        "id": 82138,
                        "name": "Capissayan Sur",
                        "latitude": "18.05090000",
                        "longitude": "121.81770000"
                    },
                    {
                        "id": 82162,
                        "name": "Carig",
                        "latitude": "17.65929000",
                        "longitude": "121.74357000"
                    },
                    {
                        "id": 82188,
                        "name": "Casambalangan",
                        "latitude": "18.37646000",
                        "longitude": "122.12745000"
                    },
                    {
                        "id": 82207,
                        "name": "Catayauan",
                        "latitude": "18.16072000",
                        "longitude": "121.65271000"
                    },
                    {
                        "id": 82317,
                        "name": "Cullalabo del Sur",
                        "latitude": "17.10267000",
                        "longitude": "121.70394000"
                    },
                    {
                        "id": 82345,
                        "name": "Dalaoig",
                        "latitude": "17.94917000",
                        "longitude": "121.71480000"
                    },
                    {
                        "id": 82383,
                        "name": "Daragutan",
                        "latitude": "17.00000000",
                        "longitude": "122.03333000"
                    },
                    {
                        "id": 82389,
                        "name": "Dassun",
                        "latitude": "17.74517000",
                        "longitude": "121.71137000"
                    },
                    {
                        "id": 82414,
                        "name": "Diamantina",
                        "latitude": "16.91795000",
                        "longitude": "121.62674000"
                    },
                    {
                        "id": 82417,
                        "name": "Dibuluan",
                        "latitude": "16.51907000",
                        "longitude": "121.76472000"
                    },
                    {
                        "id": 82418,
                        "name": "Dicabisagan",
                        "latitude": "17.08184000",
                        "longitude": "122.41574000"
                    },
                    {
                        "id": 82419,
                        "name": "Dicamay",
                        "latitude": "16.75606000",
                        "longitude": "122.00374000"
                    },
                    {
                        "id": 82446,
                        "name": "Divisoria",
                        "latitude": "17.52268000",
                        "longitude": "121.77421000"
                    },
                    {
                        "id": 82448,
                        "name": "Dodan",
                        "latitude": "17.64107000",
                        "longitude": "121.79449000"
                    },
                    {
                        "id": 82480,
                        "name": "Dumabato",
                        "latitude": "16.31667000",
                        "longitude": "121.70000000"
                    },
                    {
                        "id": 82502,
                        "name": "Eden",
                        "latitude": "17.03809000",
                        "longitude": "121.59799000"
                    },
                    {
                        "id": 82508,
                        "name": "Enrile",
                        "latitude": "17.55960000",
                        "longitude": "121.69740000"
                    },
                    {
                        "id": 82523,
                        "name": "Esperanza East",
                        "latitude": "17.02327000",
                        "longitude": "121.68402000"
                    },
                    {
                        "id": 82529,
                        "name": "Estefania",
                        "latitude": "17.79952000",
                        "longitude": "121.72310000"
                    },
                    {
                        "id": 82542,
                        "name": "Furao",
                        "latitude": "17.03466000",
                        "longitude": "121.79689000"
                    },
                    {
                        "id": 82551,
                        "name": "Gadu",
                        "latitude": "17.62920000",
                        "longitude": "121.61050000"
                    },
                    {
                        "id": 82558,
                        "name": "Gammad",
                        "latitude": "17.71040000",
                        "longitude": "121.74370000"
                    },
                    {
                        "id": 82561,
                        "name": "Ganapi",
                        "latitude": "17.20174000",
                        "longitude": "121.86524000"
                    },
                    {
                        "id": 82568,
                        "name": "Gappal",
                        "latitude": "16.83646000",
                        "longitude": "121.82184000"
                    },
                    {
                        "id": 82573,
                        "name": "Gattaran",
                        "latitude": "18.06157000",
                        "longitude": "121.64410000"
                    },
                    {
                        "id": 82607,
                        "name": "Gonzaga",
                        "latitude": "18.25937000",
                        "longitude": "121.99495000"
                    },
                    {
                        "id": 82619,
                        "name": "Guiddam",
                        "latitude": "18.33493000",
                        "longitude": "121.46617000"
                    },
                    {
                        "id": 82711,
                        "name": "Ibung",
                        "latitude": "16.60938000",
                        "longitude": "121.18614000"
                    },
                    {
                        "id": 82722,
                        "name": "Iguig",
                        "latitude": "17.75060000",
                        "longitude": "121.73645000"
                    },
                    {
                        "id": 82748,
                        "name": "Ineangan",
                        "latitude": "16.31810000",
                        "longitude": "121.09300000"
                    },
                    {
                        "id": 82760,
                        "name": "Iraga",
                        "latitude": "17.70150000",
                        "longitude": "121.65460000"
                    },
                    {
                        "id": 82774,
                        "name": "Itbayat",
                        "latitude": "20.78733000",
                        "longitude": "121.84177000"
                    },
                    {
                        "id": 82776,
                        "name": "Ivana",
                        "latitude": "20.37005000",
                        "longitude": "121.91457000"
                    },
                    {
                        "id": 82992,
                        "name": "Lallayug",
                        "latitude": "17.70684000",
                        "longitude": "121.44175000"
                    },
                    {
                        "id": 83020,
                        "name": "Lanna",
                        "latitude": "17.69600000",
                        "longitude": "121.70014000"
                    },
                    {
                        "id": 83032,
                        "name": "Lapi",
                        "latitude": "17.71600000",
                        "longitude": "121.89775000"
                    },
                    {
                        "id": 83043,
                        "name": "Larion Alto",
                        "latitude": "17.63082000",
                        "longitude": "121.76062000"
                    },
                    {
                        "id": 83046,
                        "name": "Lasam",
                        "latitude": "18.06519000",
                        "longitude": "121.60065000"
                    },
                    {
                        "id": 83267,
                        "name": "Mabasa",
                        "latitude": "16.32100000",
                        "longitude": "121.12620000"
                    },
                    {
                        "id": 83281,
                        "name": "Mabini",
                        "latitude": "17.09936000",
                        "longitude": "121.73454000"
                    },
                    {
                        "id": 83291,
                        "name": "Mabuttal East",
                        "latitude": "18.37620000",
                        "longitude": "121.51470000"
                    },
                    {
                        "id": 83311,
                        "name": "Maddarulug Norte",
                        "latitude": "17.60732000",
                        "longitude": "121.67670000"
                    },
                    {
                        "id": 83317,
                        "name": "Magalalag",
                        "latitude": "17.57732000",
                        "longitude": "121.73497000"
                    },
                    {
                        "id": 83325,
                        "name": "Magapit",
                        "latitude": "18.13741000",
                        "longitude": "121.66942000"
                    },
                    {
                        "id": 83326,
                        "name": "Magapit Aguiguican",
                        "latitude": "18.10788000",
                        "longitude": "121.67705000"
                    },
                    {
                        "id": 83350,
                        "name": "Maguilling",
                        "latitude": "17.76982000",
                        "longitude": "121.49778000"
                    },
                    {
                        "id": 83359,
                        "name": "Mahatao",
                        "latitude": "20.41585000",
                        "longitude": "121.94707000"
                    },
                    {
                        "id": 83409,
                        "name": "Malasin",
                        "latitude": "16.30450000",
                        "longitude": "121.10620000"
                    },
                    {
                        "id": 83460,
                        "name": "Maluno Sur",
                        "latitude": "16.99885000",
                        "longitude": "121.96434000"
                    },
                    {
                        "id": 83494,
                        "name": "Manaring",
                        "latitude": "17.17294000",
                        "longitude": "121.90254000"
                    },
                    {
                        "id": 83509,
                        "name": "Manga",
                        "latitude": "17.70123000",
                        "longitude": "121.86048000"
                    },
                    {
                        "id": 83600,
                        "name": "Masaya Sur",
                        "latitude": "16.50017000",
                        "longitude": "121.74743000"
                    },
                    {
                        "id": 83604,
                        "name": "Masipi West",
                        "latitude": "17.37933000",
                        "longitude": "121.83861000"
                    },
                    {
                        "id": 83642,
                        "name": "Maxingal",
                        "latitude": "18.21488000",
                        "longitude": "121.66815000"
                    },
                    {
                        "id": 83678,
                        "name": "Minallo",
                        "latitude": "16.98685000",
                        "longitude": "121.85394000"
                    },
                    {
                        "id": 83679,
                        "name": "Minanga Norte",
                        "latitude": "17.45233000",
                        "longitude": "121.78533000"
                    },
                    {
                        "id": 83680,
                        "name": "Minante Segundo",
                        "latitude": "16.90220000",
                        "longitude": "121.76191000"
                    },
                    {
                        "id": 83688,
                        "name": "Minuri",
                        "latitude": "16.53233000",
                        "longitude": "121.85532000"
                    },
                    {
                        "id": 83719,
                        "name": "Mozzozzin Sur",
                        "latitude": "17.45685000",
                        "longitude": "121.74607000"
                    },
                    {
                        "id": 83724,
                        "name": "Mungo",
                        "latitude": "17.72412000",
                        "longitude": "121.47096000"
                    },
                    {
                        "id": 83730,
                        "name": "Muñoz East",
                        "latitude": "17.15754000",
                        "longitude": "121.61354000"
                    },
                    {
                        "id": 83735,
                        "name": "Nabannagan West",
                        "latitude": "18.07156000",
                        "longitude": "121.53630000"
                    },
                    {
                        "id": 83749,
                        "name": "Nagrumbuan",
                        "latitude": "16.89955000",
                        "longitude": "121.70974000"
                    },
                    {
                        "id": 83768,
                        "name": "Namuac",
                        "latitude": "18.61090000",
                        "longitude": "121.16570000"
                    },
                    {
                        "id": 83790,
                        "name": "Nattapian",
                        "latitude": "17.67536000",
                        "longitude": "121.70296000"
                    },
                    {
                        "id": 83879,
                        "name": "Paddaya",
                        "latitude": "18.32361000",
                        "longitude": "121.73866000"
                    },
                    {
                        "id": 83908,
                        "name": "Palagao Norte",
                        "latitude": "18.04406000",
                        "longitude": "121.71871000"
                    },
                    {
                        "id": 83969,
                        "name": "Pangal Sur",
                        "latitude": "16.60036000",
                        "longitude": "121.66979000"
                    },
                    {
                        "id": 84054,
                        "name": "Pattao",
                        "latitude": "18.24694000",
                        "longitude": "121.81470000"
                    },
                    {
                        "id": 84077,
                        "name": "Peñablanca",
                        "latitude": "17.63342000",
                        "longitude": "121.78117000"
                    },
                    {
                        "id": 84082,
                        "name": "Piat",
                        "latitude": "17.79050000",
                        "longitude": "121.47800000"
                    },
                    {
                        "id": 84098,
                        "name": "Pilig",
                        "latitude": "17.34278000",
                        "longitude": "121.77389000"
                    },
                    {
                        "id": 84114,
                        "name": "Pinoma",
                        "latitude": "16.87421000",
                        "longitude": "121.70669000"
                    },
                    {
                        "id": 84190,
                        "name": "Province of Batanes",
                        "latitude": "20.45798000",
                        "longitude": "121.99410000"
                    },
                    {
                        "id": 84195,
                        "name": "Province of Cagayan",
                        "latitude": "18.00000000",
                        "longitude": "121.83333000"
                    },
                    {
                        "id": 84213,
                        "name": "Province of Isabela",
                        "latitude": "17.00000000",
                        "longitude": "122.00000000"
                    },
                    {
                        "id": 84230,
                        "name": "Province of Nueva Vizcaya",
                        "latitude": "16.33333000",
                        "longitude": "121.33333000"
                    },
                    {
                        "id": 84235,
                        "name": "Province of Quirino",
                        "latitude": "16.28333000",
                        "longitude": "121.58333000"
                    },
                    {
                        "id": 84303,
                        "name": "Quibal",
                        "latitude": "17.71590000",
                        "longitude": "121.81135000"
                    },
                    {
                        "id": 84318,
                        "name": "Ragan Norte",
                        "latitude": "17.32318000",
                        "longitude": "121.77428000"
                    },
                    {
                        "id": 84326,
                        "name": "Ramos West",
                        "latitude": "16.69840000",
                        "longitude": "121.61360000"
                    },
                    {
                        "id": 84375,
                        "name": "Sabtang",
                        "latitude": "20.33566000",
                        "longitude": "121.87157000"
                    },
                    {
                        "id": 84411,
                        "name": "Salinas",
                        "latitude": "16.36950000",
                        "longitude": "121.01880000"
                    },
                    {
                        "id": 84413,
                        "name": "Salinungan Proper",
                        "latitude": "16.86906000",
                        "longitude": "121.61454000"
                    },
                    {
                        "id": 84457,
                        "name": "San Bernardo",
                        "latitude": "17.40481000",
                        "longitude": "121.75155000"
                    },
                    {
                        "id": 84628,
                        "name": "Sandiat Centro",
                        "latitude": "17.07295000",
                        "longitude": "121.63752000"
                    },
                    {
                        "id": 84695,
                        "name": "Santa Praxedes",
                        "latitude": "18.56667000",
                        "longitude": "121.00000000"
                    },
                    {
                        "id": 84782,
                        "name": "Siempre Viva",
                        "latitude": "17.22874000",
                        "longitude": "121.63294000"
                    },
                    {
                        "id": 84794,
                        "name": "Sillawit",
                        "latitude": "16.87316000",
                        "longitude": "121.75924000"
                    },
                    {
                        "id": 84800,
                        "name": "Simanu Sur",
                        "latitude": "17.48523000",
                        "longitude": "121.83426000"
                    },
                    {
                        "id": 84802,
                        "name": "Simimbaan",
                        "latitude": "17.11856000",
                        "longitude": "121.58138000"
                    },
                    {
                        "id": 84810,
                        "name": "Sinamar",
                        "latitude": "16.90000000",
                        "longitude": "121.56667000"
                    },
                    {
                        "id": 84814,
                        "name": "Sindon",
                        "latitude": "17.06034000",
                        "longitude": "122.01514000"
                    },
                    {
                        "id": 84840,
                        "name": "Solana",
                        "latitude": "17.65280000",
                        "longitude": "121.69100000"
                    },
                    {
                        "id": 84850,
                        "name": "Soyung",
                        "latitude": "16.70010000",
                        "longitude": "121.66550000"
                    },
                    {
                        "id": 84949,
                        "name": "Taguing",
                        "latitude": "17.94636000",
                        "longitude": "121.75521000"
                    },
                    {
                        "id": 85049,
                        "name": "Tapel",
                        "latitude": "18.28907000",
                        "longitude": "122.02915000"
                    },
                    {
                        "id": 85180,
                        "name": "Tuao",
                        "latitude": "16.58833000",
                        "longitude": "121.25778000"
                    },
                    {
                        "id": 85212,
                        "name": "Tuguegarao",
                        "latitude": "17.61577000",
                        "longitude": "121.72285000"
                    },
                    {
                        "id": 85231,
                        "name": "Tupang",
                        "latitude": "17.90483000",
                        "longitude": "121.64099000"
                    },
                    {
                        "id": 85242,
                        "name": "Uddiawan",
                        "latitude": "16.55888000",
                        "longitude": "121.15124000"
                    },
                    {
                        "id": 85243,
                        "name": "Ugac Sur",
                        "latitude": "17.61325000",
                        "longitude": "121.71583000"
                    },
                    {
                        "id": 85244,
                        "name": "Ugad",
                        "latitude": "17.30750000",
                        "longitude": "121.80042000"
                    },
                    {
                        "id": 85274,
                        "name": "Uyugan",
                        "latitude": "20.35045000",
                        "longitude": "121.93777000"
                    },
                    {
                        "id": 85319,
                        "name": "Yeban Norte",
                        "latitude": "17.02195000",
                        "longitude": "121.94194000"
                    }
                ]
            },
            {
                "id": 1294,
                "name": "Calabarzon",
                "iso2": "40",
                "latitude": "14.10078030",
                "longitude": "121.07937050",
                "type": "region",
                "cities": []
            },
            {
                "id": 1283,
                "name": "Camarines Norte",
                "iso2": "CAN",
                "latitude": "14.13902650",
                "longitude": "122.76330360",
                "type": "province",
                "cities": [
                    {
                        "id": 144764,
                        "name": "Ambuclao",
                        "latitude": "16.48333333",
                        "longitude": "120.75000000"
                    },
                    {
                        "id": 144765,
                        "name": "Amlimay",
                        "latitude": "16.69388889",
                        "longitude": "120.83694444"
                    },
                    {
                        "id": 144766,
                        "name": "Ampusungan",
                        "latitude": "16.78027778",
                        "longitude": "120.72472222"
                    },
                    {
                        "id": 144767,
                        "name": "Angad",
                        "latitude": "17.58500000",
                        "longitude": "120.62583333"
                    },
                    {
                        "id": 144768,
                        "name": "Atok",
                        "latitude": "16.62756667",
                        "longitude": "120.76736667"
                    },
                    {
                        "id": 144769,
                        "name": "Baculongan",
                        "latitude": "16.80000000",
                        "longitude": "120.83333333"
                    },
                    {
                        "id": 144770,
                        "name": "Baguinge",
                        "latitude": "16.77777778",
                        "longitude": "121.10611111"
                    },
                    {
                        "id": 144771,
                        "name": "Baguio",
                        "latitude": "16.41516667",
                        "longitude": "120.59559444"
                    },
                    {
                        "id": 144772,
                        "name": "Bakun",
                        "latitude": "16.79222222",
                        "longitude": "120.66527778"
                    },
                    {
                        "id": 144775,
                        "name": "Bangao",
                        "latitude": "16.82111111",
                        "longitude": "120.84027778"
                    },
                    {
                        "id": 144776,
                        "name": "Bangued",
                        "latitude": "17.60833000",
                        "longitude": "120.63806000"
                    },
                    {
                        "id": 144780,
                        "name": "Bayabas",
                        "latitude": "16.45000000",
                        "longitude": "120.51666667"
                    },
                    {
                        "id": 144782,
                        "name": "Betwagan",
                        "latitude": "17.08333333",
                        "longitude": "120.96666667"
                    },
                    {
                        "id": 144783,
                        "name": "Bocos",
                        "latitude": "16.92638889",
                        "longitude": "121.05722222"
                    },
                    {
                        "id": 144784,
                        "name": "Bokod",
                        "latitude": "16.50000000",
                        "longitude": "120.83333333"
                    },
                    {
                        "id": 144785,
                        "name": "Boliney",
                        "latitude": "17.40773000",
                        "longitude": "120.78115000"
                    },
                    {
                        "id": 144787,
                        "name": "Bucay",
                        "latitude": "17.54040000",
                        "longitude": "120.71880000"
                    },
                    {
                        "id": 144788,
                        "name": "Bucloc",
                        "latitude": "17.43333000",
                        "longitude": "120.83333000"
                    },
                    {
                        "id": 144789,
                        "name": "Buguias",
                        "latitude": "16.71666667",
                        "longitude": "120.83333333"
                    },
                    {
                        "id": 144790,
                        "name": "Bulalacao",
                        "latitude": "16.83583333",
                        "longitude": "120.80861111"
                    },
                    {
                        "id": 144791,
                        "name": "Butigui",
                        "latitude": "17.11527778",
                        "longitude": "121.43305556"
                    },
                    {
                        "id": 144792,
                        "name": "Calaba",
                        "latitude": "17.61777778",
                        "longitude": "120.61611111"
                    },
                    {
                        "id": 144796,
                        "name": "Daguioman",
                        "latitude": "17.45000000",
                        "longitude": "120.95000000"
                    },
                    {
                        "id": 144797,
                        "name": "Dalipey",
                        "latitude": "16.80000000",
                        "longitude": "120.71666667"
                    },
                    {
                        "id": 144798,
                        "name": "Dalupirip",
                        "latitude": "16.32611111",
                        "longitude": "120.72416667"
                    },
                    {
                        "id": 144799,
                        "name": "Danglas",
                        "latitude": "17.70090000",
                        "longitude": "120.65560000"
                    },
                    {
                        "id": 144802,
                        "name": "Gambang",
                        "latitude": "16.75000000",
                        "longitude": "120.78333333"
                    },
                    {
                        "id": 144803,
                        "name": "Guinsadan",
                        "latitude": "16.96416667",
                        "longitude": "120.86805556"
                    },
                    {
                        "id": 144804,
                        "name": "Hapao",
                        "latitude": "16.87972222",
                        "longitude": "121.01611111"
                    },
                    {
                        "id": 144808,
                        "name": "Itogon",
                        "latitude": "16.36666667",
                        "longitude": "120.68333333"
                    },
                    {
                        "id": 144809,
                        "name": "Kabayan",
                        "latitude": "16.61666667",
                        "longitude": "120.83333333"
                    },
                    {
                        "id": 144811,
                        "name": "Kapangan",
                        "latitude": "16.58333333",
                        "longitude": "120.60000000"
                    },
                    {
                        "id": 144813,
                        "name": "Kibungan",
                        "latitude": "16.95435000",
                        "longitude": "120.66559000"
                    },
                    {
                        "id": 144815,
                        "name": "La Trinidad",
                        "latitude": "16.46210000",
                        "longitude": "120.58770000"
                    },
                    {
                        "id": 144816,
                        "name": "Lacub",
                        "latitude": "17.66110000",
                        "longitude": "120.95040000"
                    },
                    {
                        "id": 144817,
                        "name": "Lagangilang",
                        "latitude": "17.61250000",
                        "longitude": "120.73580000"
                    },
                    {
                        "id": 144819,
                        "name": "Lagayan",
                        "latitude": "17.72080000",
                        "longitude": "120.70670000"
                    },
                    {
                        "id": 144821,
                        "name": "Langiden",
                        "latitude": "17.61667000",
                        "longitude": "120.51667000"
                    },
                    {
                        "id": 144822,
                        "name": "Laya",
                        "latitude": "17.47250000",
                        "longitude": "121.46777778"
                    },
                    {
                        "id": 144823,
                        "name": "Licuan",
                        "latitude": "17.58333000",
                        "longitude": "120.85000000"
                    },
                    {
                        "id": 144824,
                        "name": "Licuan-Baay",
                        "latitude": "17.60890000",
                        "longitude": "120.90590000"
                    },
                    {
                        "id": 144825,
                        "name": "Liwan",
                        "latitude": "17.51916667",
                        "longitude": "121.63194444"
                    },
                    {
                        "id": 144826,
                        "name": "Loacan",
                        "latitude": "16.55000000",
                        "longitude": "120.66666667"
                    },
                    {
                        "id": 144827,
                        "name": "Luba",
                        "latitude": "17.31800000",
                        "longitude": "120.69450000"
                    },
                    {
                        "id": 144830,
                        "name": "Malibcong",
                        "latitude": "17.56550000",
                        "longitude": "120.99360000"
                    },
                    {
                        "id": 144831,
                        "name": "Manabo",
                        "latitude": "17.43320000",
                        "longitude": "120.70530000"
                    },
                    {
                        "id": 144832,
                        "name": "Mankayan",
                        "latitude": "16.86666667",
                        "longitude": "120.78333333"
                    },
                    {
                        "id": 144834,
                        "name": "Monamon",
                        "latitude": "16.88333333",
                        "longitude": "120.88333333"
                    },
                    {
                        "id": 144835,
                        "name": "Nangalisan",
                        "latitude": "16.43444444",
                        "longitude": "120.47777778"
                    },
                    {
                        "id": 144837,
                        "name": "Natubleng",
                        "latitude": "16.69638889",
                        "longitude": "120.78055556"
                    },
                    {
                        "id": 144840,
                        "name": "Peñarrubia",
                        "latitude": "17.56470000",
                        "longitude": "120.65190000"
                    },
                    {
                        "id": 144841,
                        "name": "Pidigan",
                        "latitude": "17.55000000",
                        "longitude": "120.58333000"
                    },
                    {
                        "id": 144844,
                        "name": "Potia",
                        "latitude": "16.93333000",
                        "longitude": "121.46667000"
                    },
                    {
                        "id": 144846,
                        "name": "Rizal",
                        "latitude": "17.50000000",
                        "longitude": "121.60000000"
                    },
                    {
                        "id": 144848,
                        "name": "Sablan",
                        "latitude": "16.49639000",
                        "longitude": "120.51748000"
                    },
                    {
                        "id": 144850,
                        "name": "Sadsadan",
                        "latitude": "16.93333333",
                        "longitude": "120.86666667"
                    },
                    {
                        "id": 144852,
                        "name": "Sal-Lapadan",
                        "latitude": "17.46667000",
                        "longitude": "120.78333000"
                    },
                    {
                        "id": 144853,
                        "name": "San Isidro",
                        "latitude": "17.46667000",
                        "longitude": "120.60000000"
                    },
                    {
                        "id": 144856,
                        "name": "San Ramon",
                        "latitude": "17.41361111",
                        "longitude": "120.70750000"
                    },
                    {
                        "id": 144858,
                        "name": "Tabaan",
                        "latitude": "16.30000000",
                        "longitude": "120.51666667"
                    },
                    {
                        "id": 144859,
                        "name": "Tabio",
                        "latitude": "16.85000000",
                        "longitude": "120.80000000"
                    },
                    {
                        "id": 144862,
                        "name": "Tacadang",
                        "latitude": "16.72638889",
                        "longitude": "120.64055556"
                    },
                    {
                        "id": 144864,
                        "name": "Taloy",
                        "latitude": "16.33333333",
                        "longitude": "120.50000000"
                    },
                    {
                        "id": 144866,
                        "name": "Tayum",
                        "latitude": "17.60000000",
                        "longitude": "120.68333000"
                    },
                    {
                        "id": 144867,
                        "name": "Tineg",
                        "latitude": "17.76701000",
                        "longitude": "120.92800000"
                    },
                    {
                        "id": 144870,
                        "name": "Topdac",
                        "latitude": "16.55527778",
                        "longitude": "120.71166667"
                    },
                    {
                        "id": 144871,
                        "name": "Tuba",
                        "latitude": "16.31666667",
                        "longitude": "120.55000000"
                    },
                    {
                        "id": 144872,
                        "name": "Tublay",
                        "latitude": "16.51666667",
                        "longitude": "120.61666667"
                    },
                    {
                        "id": 144873,
                        "name": "Tubo",
                        "latitude": "17.16667000",
                        "longitude": "120.71667000"
                    },
                    {
                        "id": 144874,
                        "name": "Tuding",
                        "latitude": "16.41083333",
                        "longitude": "120.64222222"
                    },
                    {
                        "id": 144875,
                        "name": "Villarosa",
                        "latitude": "15.55000000",
                        "longitude": "120.75000000"
                    },
                    {
                        "id": 144876,
                        "name": "Villaviciosa",
                        "latitude": "17.43790000",
                        "longitude": "120.62620000"
                    }
                ]
            },
            {
                "id": 1287,
                "name": "Camarines Sur",
                "iso2": "CAS",
                "latitude": "13.52501970",
                "longitude": "123.34861470",
                "type": "province",
                "cities": [
                    {
                        "id": 81345,
                        "name": "Baao",
                        "latitude": "13.48844070",
                        "longitude": "123.28093120"
                    },
                    {
                        "id": 81453,
                        "name": "Balatan",
                        "latitude": "13.33921120",
                        "longitude": "123.20690530"
                    },
                    {
                        "id": 81625,
                        "name": "Bato",
                        "latitude": "13.31786510",
                        "longitude": "123.24565490"
                    },
                    {
                        "id": 81782,
                        "name": "Bombon",
                        "latitude": "13.68750570",
                        "longitude": "123.12780930"
                    },
                    {
                        "id": 81854,
                        "name": "Buhi",
                        "latitude": "13.44102260",
                        "longitude": "123.44023310"
                    },
                    {
                        "id": 81859,
                        "name": "Bula",
                        "latitude": "13.44577570",
                        "longitude": "123.18737580"
                    },
                    {
                        "id": 81985,
                        "name": "Cabusao",
                        "latitude": "13.73286460",
                        "longitude": "122.97854970"
                    },
                    {
                        "id": 82009,
                        "name": "Calabanga",
                        "latitude": "13.71380760",
                        "longitude": "123.08299360"
                    },
                    {
                        "id": 82080,
                        "name": "Camaligan",
                        "latitude": "13.62463220",
                        "longitude": "123.14000110"
                    },
                    {
                        "id": 82100,
                        "name": "Canaman",
                        "latitude": "13.63826980",
                        "longitude": "123.13566680"
                    },
                    {
                        "id": 82150,
                        "name": "Caramoan",
                        "latitude": "13.84665320",
                        "longitude": "123.68380850"
                    },
                    {
                        "id": 82406,
                        "name": "Del Gallego",
                        "latitude": "13.93817970",
                        "longitude": "122.69720080"
                    },
                    {
                        "id": 82553,
                        "name": "Gainza",
                        "latitude": "13.61702120",
                        "longitude": "123.15167040"
                    },
                    {
                        "id": 82569,
                        "name": "Garchitorena",
                        "latitude": "13.90033380",
                        "longitude": "123.44511350"
                    },
                    {
                        "id": 82604,
                        "name": "Goa",
                        "latitude": "13.76268730",
                        "longitude": "123.35465990"
                    },
                    {
                        "id": 82765,
                        "name": "Iriga City",
                        "latitude": "13.44410330",
                        "longitude": "123.35144110"
                    },
                    {
                        "id": 82979,
                        "name": "Lagonoy",
                        "latitude": "13.84558010",
                        "longitude": "123.36612070"
                    },
                    {
                        "id": 83092,
                        "name": "Libmanan",
                        "latitude": "13.67168970",
                        "longitude": "122.78395950"
                    },
                    {
                        "id": 83243,
                        "name": "Lupi",
                        "latitude": "13.84548490",
                        "longitude": "122.71314930"
                    },
                    {
                        "id": 83327,
                        "name": "Magarao",
                        "latitude": "13.67533000",
                        "longitude": "123.09124550"
                    },
                    {
                        "id": 83672,
                        "name": "Milaor",
                        "latitude": "13.59308600",
                        "longitude": "123.08806970"
                    },
                    {
                        "id": 83676,
                        "name": "Minalabac",
                        "latitude": "13.50328640",
                        "longitude": "123.11965550"
                    },
                    {
                        "id": 83737,
                        "name": "Nabua",
                        "latitude": "13.39185550",
                        "longitude": "123.25767120"
                    },
                    {
                        "id": 83740,
                        "name": "Naga",
                        "latitude": "13.64092560",
                        "longitude": "123.10530960"
                    },
                    {
                        "id": 83837,
                        "name": "Ocampo",
                        "latitude": "13.58940820",
                        "longitude": "123.30024320"
                    },
                    {
                        "id": 83939,
                        "name": "Pamplona",
                        "latitude": "13.60142380",
                        "longitude": "122.98575960"
                    },
                    {
                        "id": 84026,
                        "name": "Pasacao",
                        "latitude": "13.54798050",
                        "longitude": "122.82052350"
                    },
                    {
                        "id": 84097,
                        "name": "Pili",
                        "latitude": "13.58573680",
                        "longitude": "123.21853240"
                    },
                    {
                        "id": 154481,
                        "name": "Presentacion",
                        "latitude": "13.73653240",
                        "longitude": "123.57836540"
                    },
                    {
                        "id": 84320,
                        "name": "Ragay",
                        "latitude": "13.83317230",
                        "longitude": "122.57599190"
                    },
                    {
                        "id": 84389,
                        "name": "Sagnay",
                        "latitude": "13.56212750",
                        "longitude": "123.43971800"
                    },
                    {
                        "id": 84478,
                        "name": "San Fernando",
                        "latitude": "13.51891000",
                        "longitude": "123.08983220"
                    },
                    {
                        "id": 84517,
                        "name": "San Jose",
                        "latitude": "13.60013200",
                        "longitude": "123.24013290"
                    },
                    {
                        "id": 84826,
                        "name": "Sipocot",
                        "latitude": "13.80261240",
                        "longitude": "122.78627700"
                    },
                    {
                        "id": 84830,
                        "name": "Siruma",
                        "latitude": "14.03281110",
                        "longitude": "123.20806090"
                    },
                    {
                        "id": 85102,
                        "name": "Tigaon",
                        "latitude": "13.62027780",
                        "longitude": "123.37474420"
                    },
                    {
                        "id": 85128,
                        "name": "Tinambac",
                        "latitude": "13.86395910",
                        "longitude": "123.18830790"
                    }
                ]
            },
            {
                "id": 1285,
                "name": "Camiguin",
                "iso2": "CAM",
                "latitude": "9.17321640",
                "longitude": "124.72987650",
                "type": "province",
                "cities": [
                    {
                        "id": 82206,
                        "name": "Catarman",
                        "latitude": "9.17776630",
                        "longitude": "124.62218990"
                    },
                    {
                        "id": 154502,
                        "name": "Guinsiliban",
                        "latitude": "9.10904250",
                        "longitude": "124.73748100"
                    },
                    {
                        "id": 83363,
                        "name": "Mahinog",
                        "latitude": "9.16437120",
                        "longitude": "124.69769550"
                    },
                    {
                        "id": 83472,
                        "name": "Mambajao",
                        "latitude": "9.21766480",
                        "longitude": "124.62400980"
                    },
                    {
                        "id": 84386,
                        "name": "Sagay",
                        "latitude": "9.12832000",
                        "longitude": "124.69581030"
                    }
                ]
            },
            {
                "id": 1292,
                "name": "Capiz",
                "iso2": "CAP",
                "latitude": "11.55288160",
                "longitude": "122.74072300",
                "type": "province",
                "cities": [
                    {
                        "id": 82306,
                        "name": "Cuartero",
                        "latitude": "11.31111010",
                        "longitude": "122.60093620"
                    },
                    {
                        "id": 82373,
                        "name": "Dao",
                        "latitude": "11.38463020",
                        "longitude": "122.62605390"
                    },
                    {
                        "id": 82483,
                        "name": "Dumalag",
                        "latitude": "11.31440130",
                        "longitude": "122.58094210"
                    },
                    {
                        "id": 82491,
                        "name": "Dumarao",
                        "latitude": "11.24865090",
                        "longitude": "122.58841560"
                    },
                    {
                        "id": 82777,
                        "name": "Ivisan",
                        "latitude": "11.53959440",
                        "longitude": "122.59857730"
                    },
                    {
                        "id": 82788,
                        "name": "Jamindan",
                        "latitude": "11.36204270",
                        "longitude": "122.06424130"
                    },
                    {
                        "id": 83262,
                        "name": "Maayon",
                        "latitude": "11.35103460",
                        "longitude": "122.68252910"
                    },
                    {
                        "id": 83478,
                        "name": "Mambusao",
                        "latitude": "11.42048940",
                        "longitude": "122.50974250"
                    },
                    {
                        "id": 83953,
                        "name": "Panay",
                        "latitude": "11.54337730",
                        "longitude": "122.76938030"
                    },
                    {
                        "id": 83991,
                        "name": "Panitan",
                        "latitude": "11.44930670",
                        "longitude": "122.69672480"
                    },
                    {
                        "id": 154503,
                        "name": "Pilar",
                        "latitude": "11.46380810",
                        "longitude": "122.94014050"
                    },
                    {
                        "id": 84161,
                        "name": "Pontevedra",
                        "latitude": "11.42837570",
                        "longitude": "122.79748990"
                    },
                    {
                        "id": 84173,
                        "name": "President Roxas",
                        "latitude": "11.42874670",
                        "longitude": "122.96658030"
                    },
                    {
                        "id": 84363,
                        "name": "Roxas City",
                        "latitude": "11.56447990",
                        "longitude": "122.67955860"
                    },
                    {
                        "id": 84745,
                        "name": "Sapian",
                        "latitude": "11.51377930",
                        "longitude": "122.51823980"
                    },
                    {
                        "id": 84786,
                        "name": "Sigma",
                        "latitude": "11.42368430",
                        "longitude": "122.58432940"
                    },
                    {
                        "id": 154504,
                        "name": "Tapaz",
                        "latitude": "11.24319750",
                        "longitude": "122.06439140"
                    }
                ]
            },
            {
                "id": 1314,
                "name": "Caraga",
                "iso2": "13",
                "latitude": "8.80145620",
                "longitude": "125.74068820",
                "type": "region",
                "cities": [
                    {
                        "id": 81147,
                        "name": "Adlay",
                        "latitude": "9.40972000",
                        "longitude": "125.89750000"
                    },
                    {
                        "id": 81153,
                        "name": "Agay",
                        "latitude": "9.05361000",
                        "longitude": "125.58667000"
                    },
                    {
                        "id": 81240,
                        "name": "Amaga",
                        "latitude": "8.53083000",
                        "longitude": "126.07028000"
                    },
                    {
                        "id": 81280,
                        "name": "Anticala",
                        "latitude": "9.00444000",
                        "longitude": "125.64528000"
                    },
                    {
                        "id": 81308,
                        "name": "Aras-asan",
                        "latitude": "8.88781000",
                        "longitude": "126.31120000"
                    },
                    {
                        "id": 81415,
                        "name": "Bah-Bah",
                        "latitude": "8.60722000",
                        "longitude": "125.91444000"
                    },
                    {
                        "id": 81442,
                        "name": "Balangbalang",
                        "latitude": "9.05694000",
                        "longitude": "125.62278000"
                    },
                    {
                        "id": 81521,
                        "name": "Bancasi",
                        "latitude": "8.96667000",
                        "longitude": "125.46667000"
                    },
                    {
                        "id": 81533,
                        "name": "Bangonay",
                        "latitude": "9.31444000",
                        "longitude": "125.55389000"
                    },
                    {
                        "id": 81591,
                        "name": "Basa",
                        "latitude": "8.07222000",
                        "longitude": "126.06417000"
                    },
                    {
                        "id": 81592,
                        "name": "Basag",
                        "latitude": "8.92548000",
                        "longitude": "125.62167000"
                    },
                    {
                        "id": 81668,
                        "name": "Bayugan",
                        "latitude": "8.75611000",
                        "longitude": "125.76750000"
                    },
                    {
                        "id": 81695,
                        "name": "Bigaan",
                        "latitude": "8.31722000",
                        "longitude": "126.28111000"
                    },
                    {
                        "id": 81734,
                        "name": "Binucayan",
                        "latitude": "8.25000000",
                        "longitude": "125.71667000"
                    },
                    {
                        "id": 81892,
                        "name": "Bunawan",
                        "latitude": "8.16722000",
                        "longitude": "125.99083000"
                    },
                    {
                        "id": 81925,
                        "name": "Butuan",
                        "latitude": "8.94917000",
                        "longitude": "125.54361000"
                    },
                    {
                        "id": 81937,
                        "name": "Cabadbaran",
                        "latitude": "9.12261000",
                        "longitude": "125.53549000"
                    },
                    {
                        "id": 82060,
                        "name": "Caloc-an",
                        "latitude": "9.04694000",
                        "longitude": "125.53056000"
                    },
                    {
                        "id": 82126,
                        "name": "Cantapoy",
                        "latitude": "9.49056000",
                        "longitude": "125.43639000"
                    },
                    {
                        "id": 82134,
                        "name": "Capalayan",
                        "latitude": "9.74056000",
                        "longitude": "125.54444000"
                    },
                    {
                        "id": 82224,
                        "name": "Causwagan",
                        "latitude": "8.44750000",
                        "longitude": "125.84028000"
                    },
                    {
                        "id": 82264,
                        "name": "Comagascas",
                        "latitude": "9.13972000",
                        "longitude": "125.55972000"
                    },
                    {
                        "id": 82308,
                        "name": "Cuevas",
                        "latitude": "8.01917000",
                        "longitude": "126.09417000"
                    },
                    {
                        "id": 82316,
                        "name": "Culit",
                        "latitude": "8.94722000",
                        "longitude": "125.35694000"
                    },
                    {
                        "id": 82405,
                        "name": "Del Carmen Surigao del Norte",
                        "latitude": "9.86944000",
                        "longitude": "125.96972000"
                    },
                    {
                        "id": 82410,
                        "name": "Del Pilar",
                        "latitude": "9.15194000",
                        "longitude": "125.58472000"
                    },
                    {
                        "id": 82434,
                        "name": "Dinagat Islands",
                        "latitude": "10.12301000",
                        "longitude": "125.55725000"
                    },
                    {
                        "id": 82560,
                        "name": "Gamut",
                        "latitude": "8.53153000",
                        "longitude": "126.24117000"
                    },
                    {
                        "id": 82612,
                        "name": "Guadalupe",
                        "latitude": "8.58278000",
                        "longitude": "125.70806000"
                    },
                    {
                        "id": 82628,
                        "name": "Guinabsan",
                        "latitude": "8.89750000",
                        "longitude": "125.41611000"
                    },
                    {
                        "id": 82758,
                        "name": "Ipil",
                        "latitude": "9.79070000",
                        "longitude": "125.43860000"
                    },
                    {
                        "id": 82778,
                        "name": "Jabonga",
                        "latitude": "9.34306000",
                        "longitude": "125.51556000"
                    },
                    {
                        "id": 82784,
                        "name": "Jagupit",
                        "latitude": "9.24222000",
                        "longitude": "125.55806000"
                    },
                    {
                        "id": 82904,
                        "name": "Kinabhangan",
                        "latitude": "8.96917000",
                        "longitude": "125.35750000"
                    },
                    {
                        "id": 82918,
                        "name": "Kitcharao",
                        "latitude": "9.45500000",
                        "longitude": "125.57306000"
                    },
                    {
                        "id": 82955,
                        "name": "La Union",
                        "latitude": "9.08556000",
                        "longitude": "125.53583000"
                    },
                    {
                        "id": 83034,
                        "name": "Lapinigan",
                        "latitude": "8.42056000",
                        "longitude": "125.98250000"
                    },
                    {
                        "id": 83081,
                        "name": "Libas",
                        "latitude": "9.88333000",
                        "longitude": "125.98333000"
                    },
                    {
                        "id": 83164,
                        "name": "Lombocan",
                        "latitude": "9.00767000",
                        "longitude": "125.50558000"
                    },
                    {
                        "id": 83183,
                        "name": "Los Angeles",
                        "latitude": "9.01250000",
                        "longitude": "125.60806000"
                    },
                    {
                        "id": 83184,
                        "name": "Los Arcos",
                        "latitude": "8.63278000",
                        "longitude": "125.98556000"
                    },
                    {
                        "id": 83189,
                        "name": "Loyola",
                        "latitude": "8.33492000",
                        "longitude": "126.33366000"
                    },
                    {
                        "id": 83265,
                        "name": "Mabahin",
                        "latitude": "9.18556000",
                        "longitude": "126.17056000"
                    },
                    {
                        "id": 83286,
                        "name": "Mabua",
                        "latitude": "9.80390000",
                        "longitude": "125.44090000"
                    },
                    {
                        "id": 83492,
                        "name": "Manapa",
                        "latitude": "8.97778000",
                        "longitude": "125.43944000"
                    },
                    {
                        "id": 83612,
                        "name": "Matabao",
                        "latitude": "8.95722000",
                        "longitude": "125.39944000"
                    },
                    {
                        "id": 83649,
                        "name": "Maygatasan",
                        "latitude": "8.70944000",
                        "longitude": "125.71833000"
                    },
                    {
                        "id": 83783,
                        "name": "Nasipit",
                        "latitude": "8.96917000",
                        "longitude": "125.29472000"
                    },
                    {
                        "id": 83986,
                        "name": "Panikian",
                        "latitude": "9.32935000",
                        "longitude": "125.93380000"
                    },
                    {
                        "id": 84043,
                        "name": "Patin-ay",
                        "latitude": "8.55056000",
                        "longitude": "125.93722000"
                    },
                    {
                        "id": 84178,
                        "name": "Prosperidad",
                        "latitude": "8.58000000",
                        "longitude": "125.89639000"
                    },
                    {
                        "id": 84182,
                        "name": "Province of Agusan del Norte",
                        "latitude": "8.99360000",
                        "longitude": "125.57098000"
                    },
                    {
                        "id": 84183,
                        "name": "Province of Agusan del Sur",
                        "latitude": "8.50000000",
                        "longitude": "125.83333000"
                    },
                    {
                        "id": 84246,
                        "name": "Province of Surigao del Norte",
                        "latitude": "9.66303000",
                        "longitude": "125.52704000"
                    },
                    {
                        "id": 84247,
                        "name": "Province of Surigao del Sur",
                        "latitude": "8.80908000",
                        "longitude": "126.12854000"
                    },
                    {
                        "id": 84280,
                        "name": "Punta",
                        "latitude": "8.98972000",
                        "longitude": "125.34000000"
                    },
                    {
                        "id": 84421,
                        "name": "Salvacion",
                        "latitude": "7.99954000",
                        "longitude": "126.12480000"
                    },
                    {
                        "id": 84634,
                        "name": "Sanghan",
                        "latitude": "9.08556000",
                        "longitude": "125.57278000"
                    },
                    {
                        "id": 84674,
                        "name": "Santa Josefa",
                        "latitude": "7.99111000",
                        "longitude": "126.03000000"
                    },
                    {
                        "id": 84768,
                        "name": "Sibagat",
                        "latitude": "8.82250000",
                        "longitude": "125.69750000"
                    },
                    {
                        "id": 84820,
                        "name": "Sinubong",
                        "latitude": "8.06840000",
                        "longitude": "125.93080000"
                    },
                    {
                        "id": 84882,
                        "name": "Surigao",
                        "latitude": "9.78900000",
                        "longitude": "125.49500000"
                    },
                    {
                        "id": 84940,
                        "name": "Tagcatong",
                        "latitude": "9.00222000",
                        "longitude": "125.25694000"
                    },
                    {
                        "id": 84961,
                        "name": "Talacogon",
                        "latitude": "8.45611000",
                        "longitude": "125.78417000"
                    },
                    {
                        "id": 84975,
                        "name": "Taligaman",
                        "latitude": "8.90444000",
                        "longitude": "125.65583000"
                    },
                    {
                        "id": 85099,
                        "name": "Tidman",
                        "latitude": "8.29861000",
                        "longitude": "126.33889000"
                    },
                    {
                        "id": 85101,
                        "name": "Tigao",
                        "latitude": "9.20889000",
                        "longitude": "126.17611000"
                    },
                    {
                        "id": 85178,
                        "name": "Trento",
                        "latitude": "8.04583000",
                        "longitude": "126.06361000"
                    },
                    {
                        "id": 85188,
                        "name": "Tubay",
                        "latitude": "9.16694000",
                        "longitude": "125.52389000"
                    },
                    {
                        "id": 85226,
                        "name": "Tungao",
                        "latitude": "8.78368000",
                        "longitude": "125.59587000"
                    },
                    {
                        "id": 85254,
                        "name": "Unidad",
                        "latitude": "8.53556000",
                        "longitude": "126.22865000"
                    },
                    {
                        "id": 85259,
                        "name": "Union",
                        "latitude": "9.75667000",
                        "longitude": "126.11028000"
                    },
                    {
                        "id": 85282,
                        "name": "Veruela",
                        "latitude": "8.07310000",
                        "longitude": "125.95580000"
                    }
                ]
            },
            {
                "id": 1301,
                "name": "Catanduanes",
                "iso2": "CAT",
                "latitude": "13.70886840",
                "longitude": "124.24215970",
                "type": "province",
                "cities": [
                    {
                        "id": 81391,
                        "name": "Bagamanoc",
                        "latitude": "13.96034610",
                        "longitude": "124.18442810"
                    },
                    {
                        "id": 81566,
                        "name": "Baras",
                        "latitude": "13.68655350",
                        "longitude": "124.36716560"
                    },
                    {
                        "id": 154505,
                        "name": "Bato",
                        "latitude": "13.58767010",
                        "longitude": "124.26910310"
                    },
                    {
                        "id": 82151,
                        "name": "Caramoran",
                        "latitude": "13.88008620",
                        "longitude": "123.97254300"
                    },
                    {
                        "id": 82592,
                        "name": "Gigmoto",
                        "latitude": "13.79221860",
                        "longitude": "124.26725470"
                    },
                    {
                        "id": 154506,
                        "name": "Pandan",
                        "latitude": "14.03527870",
                        "longitude": "124.11271650"
                    },
                    {
                        "id": 83970,
                        "name": "Panganiban",
                        "latitude": "13.91834270",
                        "longitude": "124.19186310"
                    },
                    {
                        "id": 84443,
                        "name": "San Andres",
                        "latitude": "13.67121800",
                        "longitude": "124.01495530"
                    },
                    {
                        "id": 154507,
                        "name": "San Miguel",
                        "latitude": "13.70981150",
                        "longitude": "124.25597190"
                    },
                    {
                        "id": 85288,
                        "name": "Viga",
                        "latitude": "13.85268470",
                        "longitude": "124.13924760"
                    },
                    {
                        "id": 85305,
                        "name": "Virac",
                        "latitude": "13.61058510",
                        "longitude": "124.11966880"
                    }
                ]
            },
            {
                "id": 1307,
                "name": "Cavite",
                "iso2": "CAV",
                "latitude": "14.47912970",
                "longitude": "120.89696340",
                "type": "province",
                "cities": [
                    {
                        "id": 81205,
                        "name": "Alfonso",
                        "latitude": "14.11151590",
                        "longitude": "120.85312840"
                    },
                    {
                        "id": 81239,
                        "name": "Amadeo",
                        "latitude": "14.18352860",
                        "longitude": "120.88189830"
                    },
                    {
                        "id": 81370,
                        "name": "Bacoor",
                        "latitude": "14.41609380",
                        "longitude": "120.92757490"
                    },
                    {
                        "id": 82175,
                        "name": "Carmona",
                        "latitude": "14.30182340",
                        "longitude": "120.99866490"
                    },
                    {
                        "id": 82227,
                        "name": "Cavite City",
                        "latitude": "14.40329050",
                        "longitude": "120.39099410"
                    },
                    {
                        "id": 82387,
                        "name": "Dasmariñas",
                        "latitude": "14.31152160",
                        "longitude": "120.92411740"
                    },
                    {
                        "id": 82575,
                        "name": "General Emilio Aguinaldo",
                        "latitude": "14.18290570",
                        "longitude": "120.76248450"
                    },
                    {
                        "id": 154483,
                        "name": "General Mariano Alvarez",
                        "latitude": "14.31005070",
                        "longitude": "120.99703550"
                    },
                    {
                        "id": 82584,
                        "name": "General Trias",
                        "latitude": "14.32270390",
                        "longitude": "120.81542320"
                    },
                    {
                        "id": 82738,
                        "name": "Imus",
                        "latitude": "14.40049000",
                        "longitude": "120.89520550"
                    },
                    {
                        "id": 82746,
                        "name": "Indang",
                        "latitude": "14.18240140",
                        "longitude": "120.78989210"
                    },
                    {
                        "id": 82889,
                        "name": "Kawit",
                        "latitude": "14.43870870",
                        "longitude": "120.88720790"
                    },
                    {
                        "id": 83322,
                        "name": "Magallanes",
                        "latitude": "14.16068420",
                        "longitude": "120.75277090"
                    },
                    {
                        "id": 83560,
                        "name": "Maragondon",
                        "latitude": "14.22579800",
                        "longitude": "120.56826170"
                    },
                    {
                        "id": 154484,
                        "name": "Mendez",
                        "latitude": "14.13043490",
                        "longitude": "120.87347540"
                    },
                    {
                        "id": 83757,
                        "name": "Naic",
                        "latitude": "14.29202020",
                        "longitude": "120.71188360"
                    },
                    {
                        "id": 83824,
                        "name": "Noveleta",
                        "latitude": "14.43487560",
                        "longitude": "120.85981360"
                    },
                    {
                        "id": 84357,
                        "name": "Rosario",
                        "latitude": "14.41589770",
                        "longitude": "120.84110200"
                    },
                    {
                        "id": 84792,
                        "name": "Silang",
                        "latitude": "14.20979730",
                        "longitude": "120.90638310"
                    },
                    {
                        "id": 84932,
                        "name": "Tagaytay",
                        "latitude": "14.11744960",
                        "longitude": "120.88635960"
                    },
                    {
                        "id": 85044,
                        "name": "Tanza",
                        "latitude": "14.33946930",
                        "longitude": "120.74556360"
                    },
                    {
                        "id": 85091,
                        "name": "Ternate",
                        "latitude": "14.26915070",
                        "longitude": "120.60185510"
                    },
                    {
                        "id": 154485,
                        "name": "Trece Martires",
                        "latitude": "14.27033830",
                        "longitude": "120.82811660"
                    }
                ]
            },
            {
                "id": 1306,
                "name": "Cebu",
                "iso2": "CEB",
                "latitude": "10.31569920",
                "longitude": "123.88543660",
                "type": "province",
                "cities": [
                    {
                        "id": 81197,
                        "name": "Alcantara",
                        "latitude": "9.96235140",
                        "longitude": "123.36356470"
                    },
                    {
                        "id": 81198,
                        "name": "Alcoy",
                        "latitude": "9.72267010",
                        "longitude": "123.42821970"
                    },
                    {
                        "id": 81201,
                        "name": "Alegria",
                        "latitude": "9.75304140",
                        "longitude": "123.38268490"
                    },
                    {
                        "id": 81229,
                        "name": "Aloguinsan",
                        "latitude": "10.19565660",
                        "longitude": "123.52151770"
                    },
                    {
                        "id": 81312,
                        "name": "Argao",
                        "latitude": "9.90910010",
                        "longitude": "123.46952270"
                    },
                    {
                        "id": 81323,
                        "name": "Asturias",
                        "latitude": "10.60441570",
                        "longitude": "123.65741540"
                    },
                    {
                        "id": 81381,
                        "name": "Badian",
                        "latitude": "9.83925490",
                        "longitude": "123.33961930"
                    },
                    {
                        "id": 81439,
                        "name": "Balamban",
                        "latitude": "10.47079490",
                        "longitude": "123.61776160"
                    },
                    {
                        "id": 81553,
                        "name": "Bantayan",
                        "latitude": "11.14157830",
                        "longitude": "123.51437850"
                    },
                    {
                        "id": 81574,
                        "name": "Barili",
                        "latitude": "10.11251120",
                        "longitude": "123.43894550"
                    },
                    {
                        "id": 81761,
                        "name": "Bogo",
                        "latitude": "11.02796960",
                        "longitude": "123.95777370"
                    },
                    {
                        "id": 81774,
                        "name": "Boljoon",
                        "latitude": "9.63488370",
                        "longitude": "123.36965870"
                    },
                    {
                        "id": 81796,
                        "name": "Borbon",
                        "latitude": "10.83581880",
                        "longitude": "123.91393260"
                    },
                    {
                        "id": 82157,
                        "name": "Carcar",
                        "latitude": "10.13198480",
                        "longitude": "123.54597640"
                    },
                    {
                        "id": 82170,
                        "name": "Carmen",
                        "latitude": "10.59572150",
                        "longitude": "123.90174460"
                    },
                    {
                        "id": 82215,
                        "name": "Catmon",
                        "latitude": "10.67502210",
                        "longitude": "123.94354730"
                    },
                    {
                        "id": 82238,
                        "name": "Cebu City",
                        "latitude": "10.37892280",
                        "longitude": "123.76372160"
                    },
                    {
                        "id": 82269,
                        "name": "Compostela",
                        "latitude": "10.46696080",
                        "longitude": "123.93050100"
                    },
                    {
                        "id": 82281,
                        "name": "Consolacion",
                        "latitude": "10.41246920",
                        "longitude": "123.92007240"
                    },
                    {
                        "id": 82291,
                        "name": "Cordova",
                        "latitude": "10.23241820",
                        "longitude": "123.86924570"
                    },
                    {
                        "id": 82327,
                        "name": "Daanbantayan",
                        "latitude": "11.33463510",
                        "longitude": "123.87587590"
                    },
                    {
                        "id": 82343,
                        "name": "Dalaguete",
                        "latitude": "9.80355860",
                        "longitude": "123.41362280"
                    },
                    {
                        "id": 82366,
                        "name": "Danao",
                        "latitude": "10.52901970",
                        "longitude": "123.86513790"
                    },
                    {
                        "id": 154508,
                        "name": "Dumanjug",
                        "latitude": "10.03958520",
                        "longitude": "123.39191030"
                    },
                    {
                        "id": 82595,
                        "name": "Ginatilan",
                        "latitude": "9.58759100",
                        "longitude": "123.31089190"
                    },
                    {
                        "id": 83037,
                        "name": "Lapu-Lapu City",
                        "latitude": "10.26553810",
                        "longitude": "123.90292050"
                    },
                    {
                        "id": 83111,
                        "name": "Liloan",
                        "latitude": "10.41022410",
                        "longitude": "123.94672290"
                    },
                    {
                        "id": 83314,
                        "name": "Madridejos",
                        "latitude": "11.27197330",
                        "longitude": "123.69253530"
                    },
                    {
                        "id": 83390,
                        "name": "Malabuyoc",
                        "latitude": "9.66441340",
                        "longitude": "123.28865590"
                    },
                    {
                        "id": 154509,
                        "name": "Mandaue",
                        "latitude": "10.34572080",
                        "longitude": "123.90372540"
                    },
                    {
                        "id": 83656,
                        "name": "Medellin",
                        "latitude": "11.13924760",
                        "longitude": "123.89234610"
                    },
                    {
                        "id": 83684,
                        "name": "Minglanilla",
                        "latitude": "10.27661140",
                        "longitude": "123.73673020"
                    },
                    {
                        "id": 83691,
                        "name": "Moalboal",
                        "latitude": "9.93444800",
                        "longitude": "123.34866240"
                    },
                    {
                        "id": 154510,
                        "name": "Naga",
                        "latitude": "10.23830310",
                        "longitude": "123.64390930"
                    },
                    {
                        "id": 83865,
                        "name": "Oslob",
                        "latitude": "9.52015120",
                        "longitude": "123.32976350"
                    },
                    {
                        "id": 84093,
                        "name": "Pilar",
                        "latitude": "10.77095290",
                        "longitude": "124.49011700"
                    },
                    {
                        "id": 154511,
                        "name": "Pinamungajan",
                        "latitude": "10.27293060",
                        "longitude": "123.54103440"
                    },
                    {
                        "id": 84165,
                        "name": "Poro",
                        "latitude": "10.67177730",
                        "longitude": "124.38892260"
                    },
                    {
                        "id": 84354,
                        "name": "Ronda",
                        "latitude": "9.99770540",
                        "longitude": "123.37371430"
                    },
                    {
                        "id": 84427,
                        "name": "Samboan",
                        "latitude": "9.50649740",
                        "longitude": "123.29302570"
                    },
                    {
                        "id": 154512,
                        "name": "San Fernando",
                        "latitude": "10.19395530",
                        "longitude": "123.58580190"
                    },
                    {
                        "id": 84489,
                        "name": "San Francisco",
                        "latitude": "10.65493720",
                        "longitude": "124.24588290"
                    },
                    {
                        "id": 84602,
                        "name": "San Remigio",
                        "latitude": "11.00057690",
                        "longitude": "123.92947200"
                    },
                    {
                        "id": 84667,
                        "name": "Santa Fe",
                        "latitude": "11.24926140",
                        "longitude": "123.74810780"
                    },
                    {
                        "id": 154513,
                        "name": "Santander",
                        "latitude": "9.45117380",
                        "longitude": "123.28642750"
                    },
                    {
                        "id": 84771,
                        "name": "Sibonga",
                        "latitude": "10.02834070",
                        "longitude": "123.48984310"
                    },
                    {
                        "id": 84837,
                        "name": "Sogod",
                        "latitude": "10.74745400",
                        "longitude": "123.88852680"
                    },
                    {
                        "id": 84903,
                        "name": "Tabogon",
                        "latitude": "10.93128480",
                        "longitude": "123.92232260"
                    },
                    {
                        "id": 84914,
                        "name": "Tabuelan",
                        "latitude": "10.85277130",
                        "longitude": "123.86938950"
                    },
                    {
                        "id": 154514,
                        "name": "Talisay",
                        "latitude": "10.28520540",
                        "longitude": "123.78425030"
                    },
                    {
                        "id": 85157,
                        "name": "Toledo",
                        "latitude": "10.35607120",
                        "longitude": "123.51909920"
                    },
                    {
                        "id": 154515,
                        "name": "Tuburan",
                        "latitude": "10.72400930",
                        "longitude": "123.76578880"
                    },
                    {
                        "id": 85203,
                        "name": "Tudela",
                        "latitude": "10.66570550",
                        "longitude": "124.43879020"
                    }
                ]
            },
            {
                "id": 1345,
                "name": "Central Luzon",
                "iso2": "03",
                "latitude": "15.48277220",
                "longitude": "120.71200230",
                "type": "region",
                "cities": [
                    {
                        "id": 81135,
                        "name": "Abucay",
                        "latitude": "14.73347000",
                        "longitude": "120.53358000"
                    },
                    {
                        "id": 81144,
                        "name": "Acli",
                        "latitude": "15.12279000",
                        "longitude": "120.64470000"
                    },
                    {
                        "id": 81155,
                        "name": "Agbannawag",
                        "latitude": "15.67920000",
                        "longitude": "121.08330000"
                    },
                    {
                        "id": 81175,
                        "name": "Akle",
                        "latitude": "15.04820000",
                        "longitude": "121.07330000"
                    },
                    {
                        "id": 81227,
                        "name": "Almendras",
                        "latitude": "15.27576000",
                        "longitude": "120.69873000"
                    },
                    {
                        "id": 81233,
                        "name": "Alua",
                        "latitude": "15.31154000",
                        "longitude": "120.89433000"
                    },
                    {
                        "id": 81238,
                        "name": "Amacalan",
                        "latitude": "15.58150000",
                        "longitude": "120.61120000"
                    },
                    {
                        "id": 81251,
                        "name": "Amucao",
                        "latitude": "15.46405000",
                        "longitude": "120.68643000"
                    },
                    {
                        "id": 81253,
                        "name": "Amuñgan",
                        "latitude": "15.36520000",
                        "longitude": "119.95820000"
                    },
                    {
                        "id": 81266,
                        "name": "Angat",
                        "latitude": "14.79278000",
                        "longitude": "120.87889000"
                    },
                    {
                        "id": 81311,
                        "name": "Arenas",
                        "latitude": "15.17042000",
                        "longitude": "120.68571000"
                    },
                    {
                        "id": 81316,
                        "name": "Arminia",
                        "latitude": "15.43563000",
                        "longitude": "120.56379000"
                    },
                    {
                        "id": 81349,
                        "name": "Babo-Pangulo",
                        "latitude": "15.08333000",
                        "longitude": "120.51667000"
                    },
                    {
                        "id": 81351,
                        "name": "Bacabac",
                        "latitude": "15.72477000",
                        "longitude": "120.42816000"
                    },
                    {
                        "id": 81371,
                        "name": "Bacsay",
                        "latitude": "15.62063000",
                        "longitude": "120.34341000"
                    },
                    {
                        "id": 81385,
                        "name": "Bagac",
                        "latitude": "14.59620000",
                        "longitude": "120.39280000"
                    },
                    {
                        "id": 81398,
                        "name": "Bagong Barrio",
                        "latitude": "14.88993000",
                        "longitude": "120.94095000"
                    },
                    {
                        "id": 81402,
                        "name": "Bagong-Sikat",
                        "latitude": "15.48010000",
                        "longitude": "121.30730000"
                    },
                    {
                        "id": 81417,
                        "name": "Bahay Pare",
                        "latitude": "15.03238000",
                        "longitude": "120.88083000"
                    },
                    {
                        "id": 81425,
                        "name": "Bakulong",
                        "latitude": "15.53790000",
                        "longitude": "120.63850000"
                    },
                    {
                        "id": 81434,
                        "name": "Balagtas",
                        "latitude": "14.81667000",
                        "longitude": "120.86667000"
                    },
                    {
                        "id": 81441,
                        "name": "Balanga",
                        "latitude": "14.67611000",
                        "longitude": "120.53611000"
                    },
                    {
                        "id": 81447,
                        "name": "Balaoang",
                        "latitude": "15.66330000",
                        "longitude": "120.51470000"
                    },
                    {
                        "id": 81450,
                        "name": "Balas",
                        "latitude": "15.04998000",
                        "longitude": "120.58611000"
                    },
                    {
                        "id": 81452,
                        "name": "Balasing",
                        "latitude": "14.85450000",
                        "longitude": "121.01270000"
                    },
                    {
                        "id": 81456,
                        "name": "Balayang",
                        "latitude": "15.54950000",
                        "longitude": "120.69430000"
                    },
                    {
                        "id": 81466,
                        "name": "Balibago",
                        "latitude": "15.16240000",
                        "longitude": "120.59540000"
                    },
                    {
                        "id": 81477,
                        "name": "Balingcanaway",
                        "latitude": "15.48215000",
                        "longitude": "120.68543000"
                    },
                    {
                        "id": 81481,
                        "name": "Balite",
                        "latitude": "15.64451000",
                        "longitude": "120.64196000"
                    },
                    {
                        "id": 81485,
                        "name": "Baliuag",
                        "latitude": "14.95472000",
                        "longitude": "120.89694000"
                    },
                    {
                        "id": 81490,
                        "name": "Baloc",
                        "latitude": "15.64350000",
                        "longitude": "120.88520000"
                    },
                    {
                        "id": 81497,
                        "name": "Baloy",
                        "latitude": "15.80530000",
                        "longitude": "120.77420000"
                    },
                    {
                        "id": 81498,
                        "name": "Balsic",
                        "latitude": "14.85906000",
                        "longitude": "120.48240000"
                    },
                    {
                        "id": 81500,
                        "name": "Balucuc",
                        "latitude": "14.95282000",
                        "longitude": "120.81452000"
                    },
                    {
                        "id": 81506,
                        "name": "Balut",
                        "latitude": "14.68333000",
                        "longitude": "120.55000000"
                    },
                    {
                        "id": 81508,
                        "name": "Balutu",
                        "latitude": "15.29875000",
                        "longitude": "120.69226000"
                    },
                    {
                        "id": 81517,
                        "name": "Banawang",
                        "latitude": "14.61210000",
                        "longitude": "120.39000000"
                    },
                    {
                        "id": 81523,
                        "name": "Bangad",
                        "latitude": "15.50190000",
                        "longitude": "121.02750000"
                    },
                    {
                        "id": 81562,
                        "name": "Baquero Norte",
                        "latitude": "15.71620000",
                        "longitude": "120.55430000"
                    },
                    {
                        "id": 81621,
                        "name": "Batasan Bata",
                        "latitude": "15.14442000",
                        "longitude": "120.94077000"
                    },
                    {
                        "id": 81624,
                        "name": "Batitang",
                        "latitude": "15.40040000",
                        "longitude": "120.80276000"
                    },
                    {
                        "id": 81655,
                        "name": "Bayanan",
                        "latitude": "13.35920000",
                        "longitude": "121.16990000"
                    },
                    {
                        "id": 81674,
                        "name": "Beddeng",
                        "latitude": "14.97728000",
                        "longitude": "120.08493000"
                    },
                    {
                        "id": 81686,
                        "name": "Biay",
                        "latitude": "15.74020000",
                        "longitude": "119.90670000"
                    },
                    {
                        "id": 81687,
                        "name": "Bibiclat",
                        "latitude": "15.52186000",
                        "longitude": "120.86235000"
                    },
                    {
                        "id": 81689,
                        "name": "Bicos",
                        "latitude": "15.66020000",
                        "longitude": "121.04140000"
                    },
                    {
                        "id": 81692,
                        "name": "Biga",
                        "latitude": "13.31060000",
                        "longitude": "121.16100000"
                    },
                    {
                        "id": 81699,
                        "name": "Bilad",
                        "latitude": "15.73676000",
                        "longitude": "120.43321000"
                    },
                    {
                        "id": 81747,
                        "name": "Bituñgol",
                        "latitude": "14.88333000",
                        "longitude": "121.03333000"
                    },
                    {
                        "id": 81755,
                        "name": "Bobon Second",
                        "latitude": "15.65653000",
                        "longitude": "120.38119000"
                    },
                    {
                        "id": 81758,
                        "name": "Bocaue",
                        "latitude": "14.79833000",
                        "longitude": "120.92611000"
                    },
                    {
                        "id": 81760,
                        "name": "Bodega",
                        "latitude": "14.92290000",
                        "longitude": "120.47982000"
                    },
                    {
                        "id": 81773,
                        "name": "Bolitoc",
                        "latitude": "15.73950000",
                        "longitude": "119.87690000"
                    },
                    {
                        "id": 81834,
                        "name": "Buenlag",
                        "latitude": "15.62743000",
                        "longitude": "120.58199000"
                    },
                    {
                        "id": 81836,
                        "name": "Buensuseso",
                        "latitude": "15.19333000",
                        "longitude": "120.67314000"
                    },
                    {
                        "id": 81867,
                        "name": "Bulaon",
                        "latitude": "15.08262000",
                        "longitude": "120.66288000"
                    },
                    {
                        "id": 81868,
                        "name": "Bularit",
                        "latitude": "15.56824000",
                        "longitude": "120.62167000"
                    },
                    {
                        "id": 81872,
                        "name": "Bulawin",
                        "latitude": "15.41730000",
                        "longitude": "119.95640000"
                    },
                    {
                        "id": 81874,
                        "name": "Bulihan",
                        "latitude": "14.87581000",
                        "longitude": "120.89563000"
                    },
                    {
                        "id": 81877,
                        "name": "Buliran",
                        "latitude": "15.54602000",
                        "longitude": "120.95959000"
                    },
                    {
                        "id": 81878,
                        "name": "Buliran Segundo",
                        "latitude": "15.26667000",
                        "longitude": "120.86667000"
                    },
                    {
                        "id": 81885,
                        "name": "Bulualto",
                        "latitude": "15.22127000",
                        "longitude": "120.95326000"
                    },
                    {
                        "id": 81893,
                        "name": "Bundoc",
                        "latitude": "15.48575000",
                        "longitude": "120.71743000"
                    },
                    {
                        "id": 81901,
                        "name": "Bunol",
                        "latitude": "15.66710000",
                        "longitude": "120.83440000"
                    },
                    {
                        "id": 81920,
                        "name": "Bustos",
                        "latitude": "14.95806000",
                        "longitude": "120.91778000"
                    },
                    {
                        "id": 81944,
                        "name": "Cabanatuan City",
                        "latitude": "15.48586000",
                        "longitude": "120.96648000"
                    },
                    {
                        "id": 81962,
                        "name": "Cabayaoasan",
                        "latitude": "15.66323000",
                        "longitude": "120.55135000"
                    },
                    {
                        "id": 81964,
                        "name": "Cabcaben",
                        "latitude": "14.45400000",
                        "longitude": "120.59140000"
                    },
                    {
                        "id": 81974,
                        "name": "Cabog",
                        "latitude": "15.31530000",
                        "longitude": "121.37030000"
                    },
                    {
                        "id": 81991,
                        "name": "Cafe",
                        "latitude": "15.33686000",
                        "longitude": "120.70623000"
                    },
                    {
                        "id": 82006,
                        "name": "Calaba",
                        "latitude": "15.30050000",
                        "longitude": "120.87423000"
                    },
                    {
                        "id": 82022,
                        "name": "Calancuasan Norte",
                        "latitude": "15.80137000",
                        "longitude": "120.64102000"
                    },
                    {
                        "id": 82023,
                        "name": "Calangain",
                        "latitude": "14.89815000",
                        "longitude": "120.55877000"
                    },
                    {
                        "id": 82026,
                        "name": "Calantas",
                        "latitude": "15.01933000",
                        "longitude": "120.51793000"
                    },
                    {
                        "id": 82044,
                        "name": "Calayaan",
                        "latitude": "15.56739000",
                        "longitude": "120.51434000"
                    },
                    {
                        "id": 82049,
                        "name": "Calibungan",
                        "latitude": "15.59820000",
                        "longitude": "120.72400000"
                    },
                    {
                        "id": 82050,
                        "name": "Calibutbut",
                        "latitude": "15.11494000",
                        "longitude": "120.59815000"
                    },
                    {
                        "id": 82054,
                        "name": "Calingcuan",
                        "latitude": "15.33333000",
                        "longitude": "120.58333000"
                    },
                    {
                        "id": 82072,
                        "name": "Calumpang",
                        "latitude": "15.17400000",
                        "longitude": "121.02490000"
                    },
                    {
                        "id": 82073,
                        "name": "Calumpit",
                        "latitude": "14.91639000",
                        "longitude": "120.76583000"
                    },
                    {
                        "id": 82075,
                        "name": "Cama Juan",
                        "latitude": "15.39223000",
                        "longitude": "120.76848000"
                    },
                    {
                        "id": 82076,
                        "name": "Camachile",
                        "latitude": "14.64361000",
                        "longitude": "120.58083000"
                    },
                    {
                        "id": 82088,
                        "name": "Camias",
                        "latitude": "15.16679000",
                        "longitude": "120.97416000"
                    },
                    {
                        "id": 82107,
                        "name": "Candating",
                        "latitude": "15.15056000",
                        "longitude": "120.81847000"
                    },
                    {
                        "id": 82226,
                        "name": "Cavite",
                        "latitude": "15.67785000",
                        "longitude": "120.76978000"
                    },
                    {
                        "id": 82232,
                        "name": "Cawayan Bugtong",
                        "latitude": "15.63362000",
                        "longitude": "120.77695000"
                    },
                    {
                        "id": 82265,
                        "name": "Comillas",
                        "latitude": "15.39833000",
                        "longitude": "120.70045000"
                    },
                    {
                        "id": 82267,
                        "name": "Communal",
                        "latitude": "13.25480000",
                        "longitude": "121.13660000"
                    },
                    {
                        "id": 82288,
                        "name": "Conversion",
                        "latitude": "15.89840000",
                        "longitude": "121.12770000"
                    },
                    {
                        "id": 82315,
                        "name": "Culianin",
                        "latitude": "14.91511000",
                        "longitude": "120.89847000"
                    },
                    {
                        "id": 82318,
                        "name": "Culubasa",
                        "latitude": "15.14431000",
                        "longitude": "120.65223000"
                    },
                    {
                        "id": 82323,
                        "name": "Cut-cut Primero",
                        "latitude": "15.48277000",
                        "longitude": "120.58604000"
                    },
                    {
                        "id": 82364,
                        "name": "Dampol",
                        "latitude": "14.90128000",
                        "longitude": "120.82187000"
                    },
                    {
                        "id": 82409,
                        "name": "Del Pilar",
                        "latitude": "15.03601000",
                        "longitude": "120.69935000"
                    },
                    {
                        "id": 82423,
                        "name": "Digdig",
                        "latitude": "15.94900000",
                        "longitude": "120.97780000"
                    },
                    {
                        "id": 82427,
                        "name": "Diliman Primero",
                        "latitude": "15.02470000",
                        "longitude": "120.95208000"
                    },
                    {
                        "id": 82437,
                        "name": "Dinalupihan",
                        "latitude": "14.87827000",
                        "longitude": "120.45221000"
                    },
                    {
                        "id": 82467,
                        "name": "Doña Remedios Trinidad",
                        "latitude": "15.00000000",
                        "longitude": "121.08333000"
                    },
                    {
                        "id": 82489,
                        "name": "Dumarais",
                        "latitude": "15.43455000",
                        "longitude": "120.69213000"
                    },
                    {
                        "id": 82510,
                        "name": "Entablado",
                        "latitude": "15.28661000",
                        "longitude": "120.86302000"
                    },
                    {
                        "id": 82526,
                        "name": "Estacion",
                        "latitude": "15.69944000",
                        "longitude": "120.60833000"
                    },
                    {
                        "id": 82530,
                        "name": "Estipona",
                        "latitude": "15.59020000",
                        "longitude": "120.63770000"
                    },
                    {
                        "id": 82531,
                        "name": "Estrella",
                        "latitude": "15.75000000",
                        "longitude": "121.03333000"
                    },
                    {
                        "id": 82617,
                        "name": "Gueset",
                        "latitude": "15.95000000",
                        "longitude": "120.63333000"
                    },
                    {
                        "id": 82620,
                        "name": "Guiguinto",
                        "latitude": "14.83333000",
                        "longitude": "120.88333000"
                    },
                    {
                        "id": 82647,
                        "name": "Guisguis",
                        "latitude": "15.79280000",
                        "longitude": "119.97660000"
                    },
                    {
                        "id": 82659,
                        "name": "Gutad",
                        "latitude": "14.92740000",
                        "longitude": "120.48940000"
                    },
                    {
                        "id": 82662,
                        "name": "Guyong",
                        "latitude": "14.83610000",
                        "longitude": "120.97844000"
                    },
                    {
                        "id": 82680,
                        "name": "Hermosa",
                        "latitude": "14.83140000",
                        "longitude": "120.50810000"
                    },
                    {
                        "id": 82995,
                        "name": "Lambakin",
                        "latitude": "14.75000000",
                        "longitude": "120.86667000"
                    },
                    {
                        "id": 83010,
                        "name": "Lanat",
                        "latitude": "15.79189000",
                        "longitude": "120.60461000"
                    },
                    {
                        "id": 83049,
                        "name": "Laug",
                        "latitude": "15.04659000",
                        "longitude": "120.75149000"
                    },
                    {
                        "id": 83053,
                        "name": "Lawang Kupang",
                        "latitude": "15.34807000",
                        "longitude": "120.85752000"
                    },
                    {
                        "id": 83065,
                        "name": "Lennec",
                        "latitude": "15.68350000",
                        "longitude": "120.73380000"
                    },
                    {
                        "id": 83101,
                        "name": "Liciada",
                        "latitude": "14.91484000",
                        "longitude": "120.93182000"
                    },
                    {
                        "id": 83106,
                        "name": "Ligaya",
                        "latitude": "15.50910000",
                        "longitude": "121.28720000"
                    },
                    {
                        "id": 83118,
                        "name": "Limay",
                        "latitude": "14.56194000",
                        "longitude": "120.59833000"
                    },
                    {
                        "id": 83145,
                        "name": "Liozon",
                        "latitude": "15.39930000",
                        "longitude": "119.93300000"
                    },
                    {
                        "id": 83148,
                        "name": "Lipay",
                        "latitude": "15.45610000",
                        "longitude": "119.92080000"
                    },
                    {
                        "id": 83163,
                        "name": "Loma de Gato",
                        "latitude": "14.78869000",
                        "longitude": "120.99889000"
                    },
                    {
                        "id": 83166,
                        "name": "Lomboy",
                        "latitude": "15.49255000",
                        "longitude": "120.71723000"
                    },
                    {
                        "id": 83187,
                        "name": "Lourdes",
                        "latitude": "14.96667000",
                        "longitude": "120.68333000"
                    },
                    {
                        "id": 83197,
                        "name": "Lucapon",
                        "latitude": "15.69980000",
                        "longitude": "119.93200000"
                    },
                    {
                        "id": 83264,
                        "name": "Mababanaba",
                        "latitude": "15.49715000",
                        "longitude": "120.46053000"
                    },
                    {
                        "id": 83266,
                        "name": "Mabalacat City",
                        "latitude": "15.22303000",
                        "longitude": "120.57117000"
                    },
                    {
                        "id": 83269,
                        "name": "Mabayo",
                        "latitude": "14.73180000",
                        "longitude": "120.27810000"
                    },
                    {
                        "id": 83270,
                        "name": "Mabilang",
                        "latitude": "15.67511000",
                        "longitude": "120.48835000"
                    },
                    {
                        "id": 83273,
                        "name": "Mabilog",
                        "latitude": "15.39485000",
                        "longitude": "120.66573000"
                    },
                    {
                        "id": 83279,
                        "name": "Mabini",
                        "latitude": "15.60000000",
                        "longitude": "120.98333000"
                    },
                    {
                        "id": 83302,
                        "name": "Macapsing",
                        "latitude": "15.67830000",
                        "longitude": "121.13190000"
                    },
                    {
                        "id": 83303,
                        "name": "Macarse",
                        "latitude": "15.42495000",
                        "longitude": "120.77476000"
                    },
                    {
                        "id": 83304,
                        "name": "Macatbong",
                        "latitude": "15.50480000",
                        "longitude": "121.07910000"
                    },
                    {
                        "id": 83337,
                        "name": "Magliman",
                        "latitude": "15.03545000",
                        "longitude": "120.66421000"
                    },
                    {
                        "id": 83348,
                        "name": "Magtangol",
                        "latitude": "15.75800000",
                        "longitude": "120.91560000"
                    },
                    {
                        "id": 83351,
                        "name": "Maguinao",
                        "latitude": "15.02231000",
                        "longitude": "120.93409000"
                    },
                    {
                        "id": 83386,
                        "name": "Malabon",
                        "latitude": "15.63610000",
                        "longitude": "119.93790000"
                    },
                    {
                        "id": 83391,
                        "name": "Malacampa",
                        "latitude": "15.64335000",
                        "longitude": "120.41109000"
                    },
                    {
                        "id": 83428,
                        "name": "Maligaya",
                        "latitude": "15.67470000",
                        "longitude": "120.88870000"
                    },
                    {
                        "id": 83442,
                        "name": "Malino",
                        "latitude": "15.12695000",
                        "longitude": "120.67431000"
                    },
                    {
                        "id": 83454,
                        "name": "Malolos",
                        "latitude": "14.84430000",
                        "longitude": "120.81039000"
                    },
                    {
                        "id": 83455,
                        "name": "Maloma",
                        "latitude": "15.11350000",
                        "longitude": "120.06390000"
                    },
                    {
                        "id": 83458,
                        "name": "Maluid",
                        "latitude": "15.54930000",
                        "longitude": "120.65280000"
                    },
                    {
                        "id": 83461,
                        "name": "Malusac",
                        "latitude": "14.85842000",
                        "longitude": "120.62120000"
                    },
                    {
                        "id": 83475,
                        "name": "Mambog",
                        "latitude": "15.31370000",
                        "longitude": "120.03040000"
                    },
                    {
                        "id": 83479,
                        "name": "Mamonit",
                        "latitude": "15.58719000",
                        "longitude": "120.39644000"
                    },
                    {
                        "id": 83483,
                        "name": "Manacsac",
                        "latitude": "15.59520000",
                        "longitude": "120.79110000"
                    },
                    {
                        "id": 83496,
                        "name": "Manatal",
                        "latitude": "14.87688000",
                        "longitude": "120.91639000"
                    },
                    {
                        "id": 83506,
                        "name": "Mandili",
                        "latitude": "15.17912000",
                        "longitude": "120.87726000"
                    },
                    {
                        "id": 83515,
                        "name": "Mangga",
                        "latitude": "15.25041000",
                        "longitude": "120.90876000"
                    },
                    {
                        "id": 83520,
                        "name": "Manibaug Pasig",
                        "latitude": "15.09621000",
                        "longitude": "120.56445000"
                    },
                    {
                        "id": 83531,
                        "name": "Manogpi",
                        "latitude": "13.31080000",
                        "longitude": "121.20400000"
                    },
                    {
                        "id": 83548,
                        "name": "Mapalacsiao",
                        "latitude": "15.42831000",
                        "longitude": "120.65252000"
                    },
                    {
                        "id": 83549,
                        "name": "Mapalad",
                        "latitude": "15.45133000",
                        "longitude": "121.08384000"
                    },
                    {
                        "id": 83552,
                        "name": "Mapaniqui",
                        "latitude": "15.10696000",
                        "longitude": "120.92287000"
                    },
                    {
                        "id": 83558,
                        "name": "Maquiapo",
                        "latitude": "14.98561000",
                        "longitude": "120.55855000"
                    },
                    {
                        "id": 83566,
                        "name": "Marawa",
                        "latitude": "15.41727000",
                        "longitude": "120.83819000"
                    },
                    {
                        "id": 83583,
                        "name": "Marilao",
                        "latitude": "14.75778000",
                        "longitude": "120.94833000"
                    },
                    {
                        "id": 83586,
                        "name": "Mariveles",
                        "latitude": "14.43385000",
                        "longitude": "120.48569000"
                    },
                    {
                        "id": 83593,
                        "name": "Masalipit",
                        "latitude": "15.14810000",
                        "longitude": "121.03730000"
                    },
                    {
                        "id": 83622,
                        "name": "Matayumtayum",
                        "latitude": "15.51660000",
                        "longitude": "120.70980000"
                    },
                    {
                        "id": 83634,
                        "name": "Maturanoc",
                        "latitude": "15.65710000",
                        "longitude": "120.79210000"
                    },
                    {
                        "id": 83664,
                        "name": "Meycauayan",
                        "latitude": "14.73694000",
                        "longitude": "120.96083000"
                    },
                    {
                        "id": 83711,
                        "name": "Moriones",
                        "latitude": "15.46116000",
                        "longitude": "120.46579000"
                    },
                    {
                        "id": 83716,
                        "name": "Motrico",
                        "latitude": "15.41355000",
                        "longitude": "120.67653000"
                    },
                    {
                        "id": 83748,
                        "name": "Nagpandayan",
                        "latitude": "15.60138000",
                        "longitude": "120.76893000"
                    },
                    {
                        "id": 83765,
                        "name": "Nambalan",
                        "latitude": "15.59911000",
                        "longitude": "120.46031000"
                    },
                    {
                        "id": 83770,
                        "name": "Nancamarinan",
                        "latitude": "15.67520000",
                        "longitude": "120.53640000"
                    },
                    {
                        "id": 83815,
                        "name": "Nieves",
                        "latitude": "15.32842000",
                        "longitude": "120.94892000"
                    },
                    {
                        "id": 83819,
                        "name": "Niugan",
                        "latitude": "14.94607000",
                        "longitude": "120.96720000"
                    },
                    {
                        "id": 83822,
                        "name": "Norzagaray",
                        "latitude": "14.91090000",
                        "longitude": "121.04930000"
                    },
                    {
                        "id": 83835,
                        "name": "Obando",
                        "latitude": "14.70980000",
                        "longitude": "120.93620000"
                    },
                    {
                        "id": 83857,
                        "name": "Orani",
                        "latitude": "14.80060000",
                        "longitude": "120.53710000"
                    },
                    {
                        "id": 83859,
                        "name": "Orion",
                        "latitude": "14.62056000",
                        "longitude": "120.58167000"
                    },
                    {
                        "id": 83874,
                        "name": "Paco Roman",
                        "latitude": "15.65970000",
                        "longitude": "121.08770000"
                    },
                    {
                        "id": 83878,
                        "name": "Padapada",
                        "latitude": "15.55170000",
                        "longitude": "120.51630000"
                    },
                    {
                        "id": 83903,
                        "name": "Paitan Norte",
                        "latitude": "15.83333000",
                        "longitude": "120.74086000"
                    },
                    {
                        "id": 83918,
                        "name": "Palayan City",
                        "latitude": "15.54150000",
                        "longitude": "121.08480000"
                    },
                    {
                        "id": 83932,
                        "name": "Palusapis",
                        "latitude": "15.68324000",
                        "longitude": "120.86267000"
                    },
                    {
                        "id": 83934,
                        "name": "Pamatawan",
                        "latitude": "14.92779000",
                        "longitude": "120.21363000"
                    },
                    {
                        "id": 83942,
                        "name": "Panabingan",
                        "latitude": "15.37732000",
                        "longitude": "120.76492000"
                    },
                    {
                        "id": 83951,
                        "name": "Panan",
                        "latitude": "15.21340000",
                        "longitude": "120.02720000"
                    },
                    {
                        "id": 83956,
                        "name": "Pance",
                        "latitude": "15.68850000",
                        "longitude": "120.62010000"
                    },
                    {
                        "id": 83958,
                        "name": "Pandacaqui",
                        "latitude": "15.17190000",
                        "longitude": "120.65457000"
                    },
                    {
                        "id": 83965,
                        "name": "Pandi",
                        "latitude": "14.86500000",
                        "longitude": "120.95722000"
                    },
                    {
                        "id": 83966,
                        "name": "Pando",
                        "latitude": "15.39395000",
                        "longitude": "120.68473000"
                    },
                    {
                        "id": 83994,
                        "name": "Panlinlang",
                        "latitude": "15.18333000",
                        "longitude": "120.70000000"
                    },
                    {
                        "id": 84004,
                        "name": "Pantubig",
                        "latitude": "14.96806000",
                        "longitude": "120.95472000"
                    },
                    {
                        "id": 84009,
                        "name": "Paombong",
                        "latitude": "14.83111000",
                        "longitude": "120.78917000"
                    },
                    {
                        "id": 84010,
                        "name": "Papaya",
                        "latitude": "15.32016000",
                        "longitude": "120.83574000"
                    },
                    {
                        "id": 84025,
                        "name": "Parista",
                        "latitude": "15.85360000",
                        "longitude": "120.92820000"
                    },
                    {
                        "id": 84056,
                        "name": "Pau",
                        "latitude": "15.02790000",
                        "longitude": "120.72430000"
                    },
                    {
                        "id": 84081,
                        "name": "Pias",
                        "latitude": "15.34525000",
                        "longitude": "121.07473000"
                    },
                    {
                        "id": 84127,
                        "name": "Piñahan",
                        "latitude": "15.62660000",
                        "longitude": "121.06210000"
                    },
                    {
                        "id": 84104,
                        "name": "Pinambaran",
                        "latitude": "15.20233000",
                        "longitude": "120.97797000"
                    },
                    {
                        "id": 84118,
                        "name": "Pio",
                        "latitude": "15.04741000",
                        "longitude": "120.51891000"
                    },
                    {
                        "id": 84137,
                        "name": "Poblacion San Felipe",
                        "latitude": "15.06222000",
                        "longitude": "120.07000000"
                    },
                    {
                        "id": 84164,
                        "name": "Porais",
                        "latitude": "15.75510000",
                        "longitude": "121.04270000"
                    },
                    {
                        "id": 84171,
                        "name": "Prado Siongco",
                        "latitude": "14.87900000",
                        "longitude": "120.51292000"
                    },
                    {
                        "id": 84187,
                        "name": "Province of Aurora",
                        "latitude": "15.98773000",
                        "longitude": "121.58020000"
                    },
                    {
                        "id": 84189,
                        "name": "Province of Bataan",
                        "latitude": "14.66667000",
                        "longitude": "120.41667000"
                    },
                    {
                        "id": 84194,
                        "name": "Province of Bulacan",
                        "latitude": "15.00000000",
                        "longitude": "121.08333000"
                    },
                    {
                        "id": 84229,
                        "name": "Province of Nueva Ecija",
                        "latitude": "15.58333000",
                        "longitude": "121.00000000"
                    },
                    {
                        "id": 84232,
                        "name": "Province of Pampanga",
                        "latitude": "15.06667000",
                        "longitude": "120.66667000"
                    },
                    {
                        "id": 84248,
                        "name": "Province of Tarlac",
                        "latitude": "15.50000000",
                        "longitude": "120.50000000"
                    },
                    {
                        "id": 84250,
                        "name": "Province of Zambales",
                        "latitude": "15.33333000",
                        "longitude": "120.16667000"
                    },
                    {
                        "id": 84263,
                        "name": "Pulilan",
                        "latitude": "14.90167000",
                        "longitude": "120.84917000"
                    },
                    {
                        "id": 84265,
                        "name": "Pulo",
                        "latitude": "14.96220000",
                        "longitude": "121.01470000"
                    },
                    {
                        "id": 84266,
                        "name": "Pulong Gubat",
                        "latitude": "14.85938000",
                        "longitude": "120.90599000"
                    },
                    {
                        "id": 84267,
                        "name": "Pulong Sampalok",
                        "latitude": "14.96110000",
                        "longitude": "121.06090000"
                    },
                    {
                        "id": 84270,
                        "name": "Pulung Santol",
                        "latitude": "15.04574000",
                        "longitude": "120.56188000"
                    },
                    {
                        "id": 84271,
                        "name": "Pulungmasle",
                        "latitude": "15.00040000",
                        "longitude": "120.55774000"
                    },
                    {
                        "id": 84276,
                        "name": "Puncan",
                        "latitude": "15.90710000",
                        "longitude": "120.99070000"
                    },
                    {
                        "id": 84284,
                        "name": "Purac",
                        "latitude": "15.25200000",
                        "longitude": "120.01690000"
                    },
                    {
                        "id": 84292,
                        "name": "Putlod",
                        "latitude": "15.37060000",
                        "longitude": "120.86750000"
                    },
                    {
                        "id": 84321,
                        "name": "Rajal Norte",
                        "latitude": "15.44485000",
                        "longitude": "120.86256000"
                    },
                    {
                        "id": 84367,
                        "name": "Sabang",
                        "latitude": "14.69510000",
                        "longitude": "120.25070000"
                    },
                    {
                        "id": 84381,
                        "name": "Sagana",
                        "latitude": "15.56890000",
                        "longitude": "121.15220000"
                    },
                    {
                        "id": 84401,
                        "name": "Salapungan",
                        "latitude": "15.13390000",
                        "longitude": "120.92794000"
                    },
                    {
                        "id": 84404,
                        "name": "Salaza",
                        "latitude": "15.45410000",
                        "longitude": "119.95530000"
                    },
                    {
                        "id": 84422,
                        "name": "Salvacion I",
                        "latitude": "15.83960000",
                        "longitude": "120.91590000"
                    },
                    {
                        "id": 84440,
                        "name": "San Alejandro",
                        "latitude": "15.56098000",
                        "longitude": "120.84896000"
                    },
                    {
                        "id": 84445,
                        "name": "San Anton",
                        "latitude": "15.34780000",
                        "longitude": "120.91991000"
                    },
                    {
                        "id": 84454,
                        "name": "San Basilio",
                        "latitude": "15.03341000",
                        "longitude": "120.58427000"
                    },
                    {
                        "id": 84461,
                        "name": "San Casimiro",
                        "latitude": "15.55306000",
                        "longitude": "120.78083000"
                    },
                    {
                        "id": 84464,
                        "name": "San Cristobal",
                        "latitude": "15.55382000",
                        "longitude": "120.76703000"
                    },
                    {
                        "id": 84476,
                        "name": "San Felipe Old",
                        "latitude": "15.50140000",
                        "longitude": "120.90780000"
                    },
                    {
                        "id": 84523,
                        "name": "San Jose del Monte",
                        "latitude": "14.81389000",
                        "longitude": "121.04528000"
                    },
                    {
                        "id": 84532,
                        "name": "San Juan de Mata",
                        "latitude": "15.53520000",
                        "longitude": "120.53020000"
                    },
                    {
                        "id": 84581,
                        "name": "San Patricio",
                        "latitude": "15.09775000",
                        "longitude": "120.72876000"
                    },
                    {
                        "id": 84610,
                        "name": "San Roque Dau First",
                        "latitude": "14.97711000",
                        "longitude": "120.57688000"
                    },
                    {
                        "id": 84626,
                        "name": "San Vincente",
                        "latitude": "13.40680000",
                        "longitude": "121.17500000"
                    },
                    {
                        "id": 84673,
                        "name": "Santa Ines West",
                        "latitude": "15.55694000",
                        "longitude": "120.46448000"
                    },
                    {
                        "id": 84675,
                        "name": "Santa Juliana",
                        "latitude": "15.32826000",
                        "longitude": "120.42863000"
                    },
                    {
                        "id": 84704,
                        "name": "Santa Teresa First",
                        "latitude": "14.92650000",
                        "longitude": "120.55791000"
                    },
                    {
                        "id": 84717,
                        "name": "Santo Cristo",
                        "latitude": "15.29683000",
                        "longitude": "120.89025000"
                    },
                    {
                        "id": 84729,
                        "name": "Santo Rosario",
                        "latitude": "15.64470000",
                        "longitude": "120.86120000"
                    },
                    {
                        "id": 84742,
                        "name": "Sapang",
                        "latitude": "15.70320000",
                        "longitude": "120.52450000"
                    },
                    {
                        "id": 84743,
                        "name": "Sapang Buho",
                        "latitude": "15.59038000",
                        "longitude": "121.12454000"
                    },
                    {
                        "id": 84746,
                        "name": "Sapol",
                        "latitude": "13.36500000",
                        "longitude": "121.18930000"
                    },
                    {
                        "id": 84755,
                        "name": "Saysain",
                        "latitude": "14.56111000",
                        "longitude": "120.39250000"
                    },
                    {
                        "id": 84762,
                        "name": "Sexmoan",
                        "latitude": "14.94380000",
                        "longitude": "120.62290000"
                    },
                    {
                        "id": 84774,
                        "name": "Sibul",
                        "latitude": "15.16900000",
                        "longitude": "121.06160000"
                    },
                    {
                        "id": 84780,
                        "name": "Siclong",
                        "latitude": "15.58080000",
                        "longitude": "121.22390000"
                    },
                    {
                        "id": 84815,
                        "name": "Sinilian First",
                        "latitude": "15.69327000",
                        "longitude": "120.45936000"
                    },
                    {
                        "id": 84843,
                        "name": "Soledad",
                        "latitude": "15.42838000",
                        "longitude": "120.98355000"
                    },
                    {
                        "id": 84863,
                        "name": "Suklayin",
                        "latitude": "15.75740000",
                        "longitude": "121.55030000"
                    },
                    {
                        "id": 84864,
                        "name": "Sula",
                        "latitude": "15.45725000",
                        "longitude": "120.39553000"
                    },
                    {
                        "id": 84872,
                        "name": "Sulucan",
                        "latitude": "14.79448000",
                        "longitude": "120.92594000"
                    },
                    {
                        "id": 84890,
                        "name": "Tabacao",
                        "latitude": "15.64973000",
                        "longitude": "120.94066000"
                    },
                    {
                        "id": 84906,
                        "name": "Tabon",
                        "latitude": "15.27098000",
                        "longitude": "120.91273000"
                    },
                    {
                        "id": 84912,
                        "name": "Tabuating",
                        "latitude": "15.39210000",
                        "longitude": "120.94084000"
                    },
                    {
                        "id": 84957,
                        "name": "Tal I Mun Doc",
                        "latitude": "15.21210000",
                        "longitude": "120.68490000"
                    },
                    {
                        "id": 84962,
                        "name": "Talaga",
                        "latitude": "15.38403000",
                        "longitude": "120.58933000"
                    },
                    {
                        "id": 84970,
                        "name": "Talang",
                        "latitude": "15.02488000",
                        "longitude": "120.83782000"
                    },
                    {
                        "id": 84996,
                        "name": "Taltal",
                        "latitude": "15.58780000",
                        "longitude": "119.94550000"
                    },
                    {
                        "id": 85056,
                        "name": "Tariji",
                        "latitude": "15.52112000",
                        "longitude": "120.61442000"
                    },
                    {
                        "id": 85061,
                        "name": "Tartaro",
                        "latitude": "15.16667000",
                        "longitude": "121.01667000"
                    },
                    {
                        "id": 85070,
                        "name": "Tayabo",
                        "latitude": "15.83450000",
                        "longitude": "121.03090000"
                    },
                    {
                        "id": 85086,
                        "name": "Telabastagan",
                        "latitude": "15.11854000",
                        "longitude": "120.60773000"
                    },
                    {
                        "id": 85119,
                        "name": "Tikiw",
                        "latitude": "15.31193000",
                        "longitude": "120.86116000"
                    },
                    {
                        "id": 85131,
                        "name": "Tinang",
                        "latitude": "15.37626000",
                        "longitude": "120.65343000"
                    },
                    {
                        "id": 85166,
                        "name": "Tondod",
                        "latitude": "15.71820000",
                        "longitude": "120.96800000"
                    },
                    {
                        "id": 85239,
                        "name": "Uacon",
                        "latitude": "15.67870000",
                        "longitude": "119.94030000"
                    },
                    {
                        "id": 85251,
                        "name": "Umiray",
                        "latitude": "15.22060000",
                        "longitude": "121.41110000"
                    },
                    {
                        "id": 85264,
                        "name": "Upig",
                        "latitude": "15.02551000",
                        "longitude": "120.99193000"
                    },
                    {
                        "id": 85281,
                        "name": "Vargas",
                        "latitude": "15.59332000",
                        "longitude": "120.48709000"
                    },
                    {
                        "id": 85292,
                        "name": "Villa Aglipay",
                        "latitude": "15.46605000",
                        "longitude": "120.45273000"
                    },
                    {
                        "id": 85293,
                        "name": "Villa Isla",
                        "latitude": "15.77030000",
                        "longitude": "120.86660000"
                    },
                    {
                        "id": 85310,
                        "name": "Vizal San Pablo",
                        "latitude": "15.06247000",
                        "longitude": "120.90021000"
                    },
                    {
                        "id": 85311,
                        "name": "Vizal Santo Niño",
                        "latitude": "15.02924000",
                        "longitude": "120.90505000"
                    }
                ]
            },
            {
                "id": 1308,
                "name": "Central Visayas",
                "iso2": "07",
                "latitude": "9.81687500",
                "longitude": "124.06414190",
                "type": "region",
                "cities": []
            },
            {
                "id": 1335,
                "name": "Cordillera Administrative",
                "iso2": "15",
                "latitude": "17.35125420",
                "longitude": "121.17188510",
                "type": "region",
                "cities": [
                    {
                        "id": 81154,
                        "name": "Agbannawag",
                        "latitude": "17.37641000",
                        "longitude": "121.54780000"
                    },
                    {
                        "id": 81243,
                        "name": "Ambuclao",
                        "latitude": "16.48333000",
                        "longitude": "120.75000000"
                    },
                    {
                        "id": 81248,
                        "name": "Amlimay",
                        "latitude": "16.69377000",
                        "longitude": "120.83704000"
                    },
                    {
                        "id": 81250,
                        "name": "Ampusungan",
                        "latitude": "16.78040000",
                        "longitude": "120.72470000"
                    },
                    {
                        "id": 81264,
                        "name": "Angad",
                        "latitude": "17.58490000",
                        "longitude": "120.62570000"
                    },
                    {
                        "id": 81294,
                        "name": "Apayao",
                        "latitude": "18.03359000",
                        "longitude": "121.17920000"
                    },
                    {
                        "id": 81327,
                        "name": "Atok",
                        "latitude": "16.58355000",
                        "longitude": "120.69949000"
                    },
                    {
                        "id": 81375,
                        "name": "Baculongan",
                        "latitude": "16.80000000",
                        "longitude": "120.83330000"
                    },
                    {
                        "id": 81408,
                        "name": "Baguinge",
                        "latitude": "16.77767000",
                        "longitude": "121.10624000"
                    },
                    {
                        "id": 81409,
                        "name": "Baguio",
                        "latitude": "16.41639000",
                        "longitude": "120.59306000"
                    },
                    {
                        "id": 81426,
                        "name": "Bakun",
                        "latitude": "16.78950000",
                        "longitude": "120.66310000"
                    },
                    {
                        "id": 81529,
                        "name": "Bangao",
                        "latitude": "16.82110000",
                        "longitude": "120.84040000"
                    },
                    {
                        "id": 81534,
                        "name": "Bangued",
                        "latitude": "17.60833000",
                        "longitude": "120.63806000"
                    },
                    {
                        "id": 81680,
                        "name": "Betwagan",
                        "latitude": "17.08333000",
                        "longitude": "120.96667000"
                    },
                    {
                        "id": 81759,
                        "name": "Bocos",
                        "latitude": "16.92646000",
                        "longitude": "121.05734000"
                    },
                    {
                        "id": 81764,
                        "name": "Bokod",
                        "latitude": "16.48950000",
                        "longitude": "120.83130000"
                    },
                    {
                        "id": 81770,
                        "name": "Boliney",
                        "latitude": "17.40773000",
                        "longitude": "120.78115000"
                    },
                    {
                        "id": 81824,
                        "name": "Bucay",
                        "latitude": "17.54040000",
                        "longitude": "120.71880000"
                    },
                    {
                        "id": 81851,
                        "name": "Buguias",
                        "latitude": "16.72267000",
                        "longitude": "120.82834000"
                    },
                    {
                        "id": 81864,
                        "name": "Bulalacao",
                        "latitude": "16.83580000",
                        "longitude": "120.80850000"
                    },
                    {
                        "id": 81924,
                        "name": "Butigui",
                        "latitude": "17.11534000",
                        "longitude": "121.43304000"
                    },
                    {
                        "id": 82007,
                        "name": "Calaba",
                        "latitude": "17.61780000",
                        "longitude": "120.61620000"
                    },
                    {
                        "id": 82335,
                        "name": "Daguioman",
                        "latitude": "17.45093000",
                        "longitude": "120.91505000"
                    },
                    {
                        "id": 82349,
                        "name": "Dalipey",
                        "latitude": "16.80000000",
                        "longitude": "120.71667000"
                    },
                    {
                        "id": 82355,
                        "name": "Dalupirip",
                        "latitude": "16.32603000",
                        "longitude": "120.72414000"
                    },
                    {
                        "id": 82370,
                        "name": "Danglas",
                        "latitude": "17.70090000",
                        "longitude": "120.65560000"
                    },
                    {
                        "id": 82557,
                        "name": "Gambang",
                        "latitude": "16.75000000",
                        "longitude": "120.78330000"
                    },
                    {
                        "id": 82639,
                        "name": "Guinsadan",
                        "latitude": "16.96420000",
                        "longitude": "120.86800000"
                    },
                    {
                        "id": 82678,
                        "name": "Hapao",
                        "latitude": "16.87966000",
                        "longitude": "121.01604000"
                    },
                    {
                        "id": 82775,
                        "name": "Itogon",
                        "latitude": "16.36389000",
                        "longitude": "120.67694000"
                    },
                    {
                        "id": 82855,
                        "name": "Kalinga",
                        "latitude": "17.42599000",
                        "longitude": "121.41609000"
                    },
                    {
                        "id": 82867,
                        "name": "Kapangan",
                        "latitude": "16.57460000",
                        "longitude": "120.59710000"
                    },
                    {
                        "id": 82897,
                        "name": "Kibungan",
                        "latitude": "16.69500000",
                        "longitude": "120.65530000"
                    },
                    {
                        "id": 82953,
                        "name": "La Trinidad",
                        "latitude": "16.45500000",
                        "longitude": "120.58750000"
                    },
                    {
                        "id": 82973,
                        "name": "Lagangilang",
                        "latitude": "17.61250000",
                        "longitude": "120.73580000"
                    },
                    {
                        "id": 82976,
                        "name": "Lagayan",
                        "latitude": "17.72080000",
                        "longitude": "120.70670000"
                    },
                    {
                        "id": 83055,
                        "name": "Laya",
                        "latitude": "17.47260000",
                        "longitude": "121.46780000"
                    },
                    {
                        "id": 83102,
                        "name": "Licuan",
                        "latitude": "17.60890000",
                        "longitude": "120.90590000"
                    },
                    {
                        "id": 83152,
                        "name": "Liwan",
                        "latitude": "17.51910000",
                        "longitude": "121.63200000"
                    },
                    {
                        "id": 83156,
                        "name": "Loacan",
                        "latitude": "16.55000000",
                        "longitude": "120.66667000"
                    },
                    {
                        "id": 83191,
                        "name": "Luba",
                        "latitude": "17.31800000",
                        "longitude": "120.69450000"
                    },
                    {
                        "id": 83482,
                        "name": "Manabo",
                        "latitude": "17.43320000",
                        "longitude": "120.70530000"
                    },
                    {
                        "id": 83528,
                        "name": "Mankayan",
                        "latitude": "16.86320000",
                        "longitude": "120.78290000"
                    },
                    {
                        "id": 83697,
                        "name": "Monamon",
                        "latitude": "16.88330000",
                        "longitude": "120.88330000"
                    },
                    {
                        "id": 83717,
                        "name": "Mountain Province",
                        "latitude": "17.08333000",
                        "longitude": "121.16667000"
                    },
                    {
                        "id": 83771,
                        "name": "Nangalisan",
                        "latitude": "16.43440000",
                        "longitude": "120.47780000"
                    },
                    {
                        "id": 83791,
                        "name": "Natubleng",
                        "latitude": "16.69647000",
                        "longitude": "120.78054000"
                    },
                    {
                        "id": 84079,
                        "name": "Peñarrubia",
                        "latitude": "17.56470000",
                        "longitude": "120.65190000"
                    },
                    {
                        "id": 84084,
                        "name": "Pidigan",
                        "latitude": "17.57000000",
                        "longitude": "120.59030000"
                    },
                    {
                        "id": 84181,
                        "name": "Province of Abra",
                        "latitude": "17.58333000",
                        "longitude": "120.75000000"
                    },
                    {
                        "id": 84192,
                        "name": "Province of Benguet",
                        "latitude": "16.50000000",
                        "longitude": "120.66667000"
                    },
                    {
                        "id": 84209,
                        "name": "Province of Ifugao",
                        "latitude": "16.83333000",
                        "longitude": "121.16667000"
                    },
                    {
                        "id": 84372,
                        "name": "Sablan",
                        "latitude": "16.49300000",
                        "longitude": "120.49540000"
                    },
                    {
                        "id": 84377,
                        "name": "Sadsadan",
                        "latitude": "16.93330000",
                        "longitude": "120.86670000"
                    },
                    {
                        "id": 84600,
                        "name": "San Ramon",
                        "latitude": "17.41350000",
                        "longitude": "120.70760000"
                    },
                    {
                        "id": 84889,
                        "name": "Tabaan",
                        "latitude": "16.30000000",
                        "longitude": "120.51667000"
                    },
                    {
                        "id": 84899,
                        "name": "Tabio",
                        "latitude": "16.85000000",
                        "longitude": "120.80000000"
                    },
                    {
                        "id": 84918,
                        "name": "Tacadang",
                        "latitude": "16.72640000",
                        "longitude": "120.64050000"
                    },
                    {
                        "id": 84994,
                        "name": "Taloy",
                        "latitude": "16.33333000",
                        "longitude": "120.50000000"
                    },
                    {
                        "id": 85082,
                        "name": "Tayum",
                        "latitude": "17.61720000",
                        "longitude": "120.65420000"
                    },
                    {
                        "id": 85170,
                        "name": "Topdac",
                        "latitude": "16.55530000",
                        "longitude": "120.71160000"
                    },
                    {
                        "id": 85191,
                        "name": "Tublay",
                        "latitude": "16.54310000",
                        "longitude": "120.60960000"
                    },
                    {
                        "id": 85205,
                        "name": "Tuding",
                        "latitude": "16.41085000",
                        "longitude": "120.64220000"
                    },
                    {
                        "id": 85300,
                        "name": "Villarosa",
                        "latitude": "15.55000000",
                        "longitude": "120.75000000"
                    },
                    {
                        "id": 85302,
                        "name": "Villaviciosa",
                        "latitude": "17.43790000",
                        "longitude": "120.62620000"
                    }
                ]
            },
            {
                "id": 1320,
                "name": "Cotabato",
                "iso2": "NCO",
                "latitude": "7.20466680",
                "longitude": "124.23104390",
                "type": "province",
                "cities": [
                    {
                        "id": 144333,
                        "name": "Alamada",
                        "latitude": "7.50842730",
                        "longitude": "124.40036580"
                    },
                    {
                        "id": 154519,
                        "name": "Aleosan",
                        "latitude": "7.18182870",
                        "longitude": "124.54811680"
                    },
                    {
                        "id": 154520,
                        "name": "Antipas",
                        "latitude": "7.25961410",
                        "longitude": "124.98825380"
                    },
                    {
                        "id": 154521,
                        "name": "Arakan",
                        "latitude": "7.40489330",
                        "longitude": "125.00173860"
                    },
                    {
                        "id": 144343,
                        "name": "Banisilan",
                        "latitude": "7.47797160",
                        "longitude": "124.56552550"
                    },
                    {
                        "id": 144916,
                        "name": "Carmen",
                        "latitude": "7.32422590",
                        "longitude": "124.62549700"
                    },
                    {
                        "id": 143954,
                        "name": "Kabacan",
                        "latitude": "7.12956940",
                        "longitude": "124.72121310"
                    },
                    {
                        "id": 154522,
                        "name": "Kadayangan",
                        "latitude": "7.12602690",
                        "longitude": "124.47581990"
                    },
                    {
                        "id": 154523,
                        "name": "Kapalawan",
                        "latitude": "7.24369440",
                        "longitude": "124.80060720"
                    },
                    {
                        "id": 143966,
                        "name": "Kidapawan",
                        "latitude": "7.04357670",
                        "longitude": "124.93376070"
                    },
                    {
                        "id": 143990,
                        "name": "Libungan",
                        "latitude": "7.33888800",
                        "longitude": "124.47543430"
                    },
                    {
                        "id": 154524,
                        "name": "Ligawasan",
                        "latitude": "6.93459860",
                        "longitude": "124.53687960"
                    },
                    {
                        "id": 154526,
                        "name": "M'lang",
                        "latitude": "6.95416600",
                        "longitude": "124.75145630"
                    },
                    {
                        "id": 144009,
                        "name": "Magpet",
                        "latitude": "7.13919630",
                        "longitude": "125.02950480"
                    },
                    {
                        "id": 144014,
                        "name": "Makilala",
                        "latitude": "6.91467630",
                        "longitude": "124.96632800"
                    },
                    {
                        "id": 154525,
                        "name": "Malidegao",
                        "latitude": "7.36337870",
                        "longitude": "124.57171620"
                    },
                    {
                        "id": 144033,
                        "name": "Matalam",
                        "latitude": "7.19830420",
                        "longitude": "124.77059650"
                    },
                    {
                        "id": 144035,
                        "name": "Midsayap",
                        "latitude": "7.13534280",
                        "longitude": "124.43662000"
                    },
                    {
                        "id": 154527,
                        "name": "Nabalawag",
                        "latitude": "7.08350290",
                        "longitude": "124.48173870"
                    },
                    {
                        "id": 154528,
                        "name": "Old Kaabakan",
                        "latitude": "6.97246950",
                        "longitude": "124.62748500"
                    },
                    {
                        "id": 154529,
                        "name": "Pahamuddin",
                        "latitude": "0.00000000",
                        "longitude": "0.00000000"
                    },
                    {
                        "id": 144059,
                        "name": "Pigcawayan",
                        "latitude": "7.30613450",
                        "longitude": "124.24772670"
                    },
                    {
                        "id": 144061,
                        "name": "Pikit",
                        "latitude": "7.07075940",
                        "longitude": "124.56639600"
                    },
                    {
                        "id": 154530,
                        "name": "President Roxas",
                        "latitude": "7.39291980",
                        "longitude": "124.81561480"
                    },
                    {
                        "id": 154531,
                        "name": "Tugunan",
                        "latitude": "6.81680660",
                        "longitude": "124.80060830"
                    },
                    {
                        "id": 144106,
                        "name": "Tulunan",
                        "latitude": "6.81680660",
                        "longitude": "124.80053000"
                    }
                ]
            },
            {
                "id": 1340,
                "name": "Davao",
                "iso2": "11",
                "latitude": "7.30416220",
                "longitude": "126.08934060",
                "type": "region",
                "cities": [
                    {
                        "id": 81203,
                        "name": "Alejal",
                        "latitude": "7.38417000",
                        "longitude": "125.66000000"
                    },
                    {
                        "id": 81261,
                        "name": "Andili",
                        "latitude": "7.46200000",
                        "longitude": "125.97010000"
                    },
                    {
                        "id": 81262,
                        "name": "Andop",
                        "latitude": "7.86111000",
                        "longitude": "125.75389000"
                    },
                    {
                        "id": 81271,
                        "name": "Anibongan",
                        "latitude": "7.39333000",
                        "longitude": "125.71889000"
                    },
                    {
                        "id": 81321,
                        "name": "Astorga",
                        "latitude": "6.90722000",
                        "longitude": "125.45583000"
                    },
                    {
                        "id": 81347,
                        "name": "Babag",
                        "latitude": "7.73309000",
                        "longitude": "126.07130000"
                    },
                    {
                        "id": 81374,
                        "name": "Baculin",
                        "latitude": "7.45250000",
                        "longitude": "126.58417000"
                    },
                    {
                        "id": 81438,
                        "name": "Balagunan",
                        "latitude": "7.49222000",
                        "longitude": "125.52111000"
                    },
                    {
                        "id": 81445,
                        "name": "Balangonan",
                        "latitude": "5.57333000",
                        "longitude": "125.35389000"
                    },
                    {
                        "id": 81507,
                        "name": "Balutakay",
                        "latitude": "6.72111000",
                        "longitude": "125.35167000"
                    },
                    {
                        "id": 81549,
                        "name": "Bantacan",
                        "latitude": "7.60400000",
                        "longitude": "126.12980000"
                    },
                    {
                        "id": 81561,
                        "name": "Baon",
                        "latitude": "6.79562000",
                        "longitude": "126.08778000"
                    },
                    {
                        "id": 81563,
                        "name": "Baracatan",
                        "latitude": "6.96750000",
                        "longitude": "125.41583000"
                    },
                    {
                        "id": 81603,
                        "name": "Basiawan",
                        "latitude": "6.53417000",
                        "longitude": "125.48694000"
                    },
                    {
                        "id": 81623,
                        "name": "Batiano",
                        "latitude": "7.55340000",
                        "longitude": "126.49070000"
                    },
                    {
                        "id": 81633,
                        "name": "Batobato",
                        "latitude": "6.82522000",
                        "longitude": "126.08458000"
                    },
                    {
                        "id": 81665,
                        "name": "Baylo",
                        "latitude": "7.85514000",
                        "longitude": "126.05563000"
                    },
                    {
                        "id": 81684,
                        "name": "Biao",
                        "latitude": "7.16333000",
                        "longitude": "125.52111000"
                    },
                    {
                        "id": 81716,
                        "name": "Bincoñgan",
                        "latitude": "7.36667000",
                        "longitude": "125.75000000"
                    },
                    {
                        "id": 81743,
                        "name": "Bitaogan",
                        "latitude": "6.76842000",
                        "longitude": "126.07738000"
                    },
                    {
                        "id": 81768,
                        "name": "Bolila",
                        "latitude": "6.37167000",
                        "longitude": "125.57139000"
                    },
                    {
                        "id": 81825,
                        "name": "Buclad",
                        "latitude": "7.52778000",
                        "longitude": "125.75056000"
                    },
                    {
                        "id": 81852,
                        "name": "Buhangin",
                        "latitude": "6.49111000",
                        "longitude": "125.54750000"
                    },
                    {
                        "id": 81858,
                        "name": "Bukid",
                        "latitude": "5.57167000",
                        "longitude": "125.40556000"
                    },
                    {
                        "id": 81861,
                        "name": "Bulacan",
                        "latitude": "6.56750000",
                        "longitude": "125.42111000"
                    },
                    {
                        "id": 81895,
                        "name": "Bungabon",
                        "latitude": "7.22210000",
                        "longitude": "125.87310000"
                    },
                    {
                        "id": 81927,
                        "name": "Butulan",
                        "latitude": "5.61444000",
                        "longitude": "125.43167000"
                    },
                    {
                        "id": 81961,
                        "name": "Cabayangan",
                        "latitude": "7.40722000",
                        "longitude": "125.73306000"
                    },
                    {
                        "id": 81969,
                        "name": "Cabinuangan",
                        "latitude": "7.68333000",
                        "longitude": "126.03333000"
                    },
                    {
                        "id": 81984,
                        "name": "Caburan",
                        "latitude": "5.91806000",
                        "longitude": "125.64111000"
                    },
                    {
                        "id": 82086,
                        "name": "Cambanugoy",
                        "latitude": "7.54130000",
                        "longitude": "125.75530000"
                    },
                    {
                        "id": 82097,
                        "name": "Camudmud",
                        "latitude": "7.17611000",
                        "longitude": "125.69333000"
                    },
                    {
                        "id": 82255,
                        "name": "Cogon",
                        "latitude": "7.15083000",
                        "longitude": "125.71722000"
                    },
                    {
                        "id": 82270,
                        "name": "Compostela Valley",
                        "latitude": "7.68333000",
                        "longitude": "126.11667000"
                    },
                    {
                        "id": 82294,
                        "name": "Corocotan",
                        "latitude": "7.39980000",
                        "longitude": "125.77270000"
                    },
                    {
                        "id": 82296,
                        "name": "Coronon",
                        "latitude": "6.87917000",
                        "longitude": "125.44889000"
                    },
                    {
                        "id": 82305,
                        "name": "Cuambog",
                        "latitude": "7.30861000",
                        "longitude": "125.84806000"
                    },
                    {
                        "id": 82311,
                        "name": "Culaman",
                        "latitude": "5.96028000",
                        "longitude": "125.65861000"
                    },
                    {
                        "id": 82328,
                        "name": "Dacudao",
                        "latitude": "7.21528000",
                        "longitude": "125.47139000"
                    },
                    {
                        "id": 82395,
                        "name": "Davan",
                        "latitude": "6.91487000",
                        "longitude": "126.15323000"
                    },
                    {
                        "id": 82396,
                        "name": "Davao",
                        "latitude": "7.07306000",
                        "longitude": "125.61278000"
                    },
                    {
                        "id": 82411,
                        "name": "Del Pilar",
                        "latitude": "7.56306000",
                        "longitude": "125.82667000"
                    },
                    {
                        "id": 82450,
                        "name": "Dolo",
                        "latitude": "6.81028000",
                        "longitude": "125.19167000"
                    },
                    {
                        "id": 82493,
                        "name": "Dumlan",
                        "latitude": "7.42750000",
                        "longitude": "125.88190000"
                    },
                    {
                        "id": 82547,
                        "name": "Gabi",
                        "latitude": "7.62150000",
                        "longitude": "126.09200000"
                    },
                    {
                        "id": 82550,
                        "name": "Gabuyan",
                        "latitude": "7.60806000",
                        "longitude": "125.66889000"
                    },
                    {
                        "id": 82606,
                        "name": "Goma",
                        "latitude": "6.79194000",
                        "longitude": "125.32083000"
                    },
                    {
                        "id": 82621,
                        "name": "Guihing Proper",
                        "latitude": "6.68444000",
                        "longitude": "125.35250000"
                    },
                    {
                        "id": 82654,
                        "name": "Gumalang",
                        "latitude": "7.20833000",
                        "longitude": "125.40361000"
                    },
                    {
                        "id": 82657,
                        "name": "Gupitan",
                        "latitude": "7.77583000",
                        "longitude": "125.64056000"
                    },
                    {
                        "id": 82684,
                        "name": "Hiju Maco",
                        "latitude": "7.38541000",
                        "longitude": "125.82822000"
                    },
                    {
                        "id": 82720,
                        "name": "Ignit",
                        "latitude": "6.70083000",
                        "longitude": "125.29194000"
                    },
                    {
                        "id": 82724,
                        "name": "Ilangay",
                        "latitude": "6.91284000",
                        "longitude": "126.05008000"
                    },
                    {
                        "id": 82743,
                        "name": "Inawayan",
                        "latitude": "6.96083000",
                        "longitude": "125.47333000"
                    },
                    {
                        "id": 82814,
                        "name": "Jovellar",
                        "latitude": "7.06350000",
                        "longitude": "126.45558000"
                    },
                    {
                        "id": 82846,
                        "name": "Kalbay",
                        "latitude": "5.72333000",
                        "longitude": "125.49861000"
                    },
                    {
                        "id": 82848,
                        "name": "Kalian",
                        "latitude": "6.12306000",
                        "longitude": "125.70028000"
                    },
                    {
                        "id": 82851,
                        "name": "Kaligutan",
                        "latitude": "7.70306000",
                        "longitude": "125.81306000"
                    },
                    {
                        "id": 82866,
                        "name": "Kapalong",
                        "latitude": "7.77056000",
                        "longitude": "125.55861000"
                    },
                    {
                        "id": 82905,
                        "name": "Kinablangan",
                        "latitude": "7.69280000",
                        "longitude": "126.54912000"
                    },
                    {
                        "id": 82908,
                        "name": "Kinamayan",
                        "latitude": "7.49944000",
                        "longitude": "125.67361000"
                    },
                    {
                        "id": 82909,
                        "name": "Kinangan",
                        "latitude": "6.30139000",
                        "longitude": "125.58500000"
                    },
                    {
                        "id": 82954,
                        "name": "La Union",
                        "latitude": "6.70413000",
                        "longitude": "126.08798000"
                    },
                    {
                        "id": 82969,
                        "name": "Lacaron",
                        "latitude": "6.44889000",
                        "longitude": "125.57917000"
                    },
                    {
                        "id": 82972,
                        "name": "Lacson",
                        "latitude": "7.21194000",
                        "longitude": "125.44222000"
                    },
                    {
                        "id": 82983,
                        "name": "Lais",
                        "latitude": "6.33278000",
                        "longitude": "125.64639000"
                    },
                    {
                        "id": 83038,
                        "name": "Lapuan",
                        "latitude": "6.14444000",
                        "longitude": "125.70083000"
                    },
                    {
                        "id": 83047,
                        "name": "Lasang",
                        "latitude": "7.26694000",
                        "longitude": "125.66500000"
                    },
                    {
                        "id": 83098,
                        "name": "Libuganon",
                        "latitude": "7.34880000",
                        "longitude": "125.77820000"
                    },
                    {
                        "id": 83116,
                        "name": "Limao",
                        "latitude": "7.07917000",
                        "longitude": "125.67361000"
                    },
                    {
                        "id": 83125,
                        "name": "Limot",
                        "latitude": "7.04050000",
                        "longitude": "126.27268000"
                    },
                    {
                        "id": 83133,
                        "name": "Linao",
                        "latitude": "7.01720000",
                        "longitude": "125.99200000"
                    },
                    {
                        "id": 83143,
                        "name": "Linoan",
                        "latitude": "7.62600000",
                        "longitude": "125.97410000"
                    },
                    {
                        "id": 83210,
                        "name": "Lukatan",
                        "latitude": "7.00960000",
                        "longitude": "126.42118000"
                    },
                    {
                        "id": 83239,
                        "name": "Lungaog",
                        "latitude": "7.52944000",
                        "longitude": "125.68778000"
                    },
                    {
                        "id": 83253,
                        "name": "Luzon",
                        "latitude": "6.51904000",
                        "longitude": "126.09408000"
                    },
                    {
                        "id": 83277,
                        "name": "Mabini",
                        "latitude": "7.31139000",
                        "longitude": "125.85278000"
                    },
                    {
                        "id": 83287,
                        "name": "Mabuhay",
                        "latitude": "7.33306000",
                        "longitude": "125.54750000"
                    },
                    {
                        "id": 83315,
                        "name": "Maduao",
                        "latitude": "7.29417000",
                        "longitude": "125.62583000"
                    },
                    {
                        "id": 83328,
                        "name": "Magatos",
                        "latitude": "7.55556000",
                        "longitude": "125.72667000"
                    },
                    {
                        "id": 83335,
                        "name": "Magdug",
                        "latitude": "6.54764000",
                        "longitude": "126.09508000"
                    },
                    {
                        "id": 83338,
                        "name": "Magnaga",
                        "latitude": "7.16940000",
                        "longitude": "125.89310000"
                    },
                    {
                        "id": 83349,
                        "name": "Magugpo Poblacion",
                        "latitude": "7.44750000",
                        "longitude": "125.80460000"
                    },
                    {
                        "id": 83357,
                        "name": "Mahanob",
                        "latitude": "7.57326000",
                        "longitude": "126.50684000"
                    },
                    {
                        "id": 83393,
                        "name": "Malagos",
                        "latitude": "7.18500000",
                        "longitude": "125.42222000"
                    },
                    {
                        "id": 83436,
                        "name": "Malinao",
                        "latitude": "6.65917000",
                        "longitude": "125.28667000"
                    },
                    {
                        "id": 83445,
                        "name": "Malita",
                        "latitude": "6.41500000",
                        "longitude": "125.61167000"
                    },
                    {
                        "id": 83471,
                        "name": "Mambago",
                        "latitude": "7.10556000",
                        "longitude": "125.69444000"
                    },
                    {
                        "id": 83484,
                        "name": "Managa",
                        "latitude": "6.74611000",
                        "longitude": "125.26806000"
                    },
                    {
                        "id": 83487,
                        "name": "Manaloal",
                        "latitude": "7.36611000",
                        "longitude": "125.66028000"
                    },
                    {
                        "id": 83495,
                        "name": "Manat",
                        "latitude": "7.53270000",
                        "longitude": "126.01730000"
                    },
                    {
                        "id": 83517,
                        "name": "Mangili",
                        "latitude": "6.00333000",
                        "longitude": "125.68389000"
                    },
                    {
                        "id": 83523,
                        "name": "Manikling",
                        "latitude": "6.87907000",
                        "longitude": "126.06063000"
                    },
                    {
                        "id": 83626,
                        "name": "Matiao",
                        "latitude": "7.08280000",
                        "longitude": "125.93620000"
                    },
                    {
                        "id": 83632,
                        "name": "Matti",
                        "latitude": "6.77056000",
                        "longitude": "125.30861000"
                    },
                    {
                        "id": 83651,
                        "name": "Mayo",
                        "latitude": "7.00211000",
                        "longitude": "126.33198000"
                    },
                    {
                        "id": 83772,
                        "name": "Nangan",
                        "latitude": "6.47264000",
                        "longitude": "126.12438000"
                    },
                    {
                        "id": 83775,
                        "name": "Nanyo",
                        "latitude": "7.33306000",
                        "longitude": "125.63778000"
                    },
                    {
                        "id": 83801,
                        "name": "New Baclayon",
                        "latitude": "6.58417000",
                        "longitude": "125.36944000"
                    },
                    {
                        "id": 83803,
                        "name": "New Bohol",
                        "latitude": "7.52330000",
                        "longitude": "125.83630000"
                    },
                    {
                        "id": 83808,
                        "name": "New Leyte",
                        "latitude": "7.50000000",
                        "longitude": "125.75000000"
                    },
                    {
                        "id": 83811,
                        "name": "New Sibonga",
                        "latitude": "7.56090000",
                        "longitude": "125.92980000"
                    },
                    {
                        "id": 83812,
                        "name": "New Visayas",
                        "latitude": "7.52333000",
                        "longitude": "125.62333000"
                    },
                    {
                        "id": 83830,
                        "name": "Nuing",
                        "latitude": "5.63278000",
                        "longitude": "125.43528000"
                    },
                    {
                        "id": 83886,
                        "name": "Pag-asa",
                        "latitude": "7.57556000",
                        "longitude": "125.68389000"
                    },
                    {
                        "id": 83894,
                        "name": "Pagsabangan",
                        "latitude": "7.48111000",
                        "longitude": "125.74944000"
                    },
                    {
                        "id": 83926,
                        "name": "Palma Gil",
                        "latitude": "7.64222000",
                        "longitude": "125.62917000"
                    },
                    {
                        "id": 83964,
                        "name": "Pandasan",
                        "latitude": "7.28380000",
                        "longitude": "125.85350000"
                    },
                    {
                        "id": 83977,
                        "name": "Pangian",
                        "latitude": "6.46278000",
                        "longitude": "125.54528000"
                    },
                    {
                        "id": 83985,
                        "name": "Panikian",
                        "latitude": "7.01070000",
                        "longitude": "126.02418000"
                    },
                    {
                        "id": 84028,
                        "name": "Pasian",
                        "latitude": "7.92806000",
                        "longitude": "126.06722000"
                    },
                    {
                        "id": 84156,
                        "name": "Pondaguitan",
                        "latitude": "6.36115000",
                        "longitude": "126.17778000"
                    },
                    {
                        "id": 84205,
                        "name": "Province of Davao del Norte",
                        "latitude": "7.45099000",
                        "longitude": "125.81543000"
                    },
                    {
                        "id": 84206,
                        "name": "Province of Davao del Sur",
                        "latitude": "6.79281000",
                        "longitude": "125.30182000"
                    },
                    {
                        "id": 84204,
                        "name": "Province of Davao Oriental",
                        "latitude": "7.16667000",
                        "longitude": "126.33333000"
                    },
                    {
                        "id": 84277,
                        "name": "Pung-Pang",
                        "latitude": "6.49750000",
                        "longitude": "125.46333000"
                    },
                    {
                        "id": 84434,
                        "name": "Sampao",
                        "latitude": "7.59389000",
                        "longitude": "125.66111000"
                    },
                    {
                        "id": 84441,
                        "name": "San Alfonso",
                        "latitude": "7.78028000",
                        "longitude": "126.42028000"
                    },
                    {
                        "id": 84496,
                        "name": "San Ignacio",
                        "latitude": "7.11890000",
                        "longitude": "126.48838000"
                    },
                    {
                        "id": 84749,
                        "name": "Sarangani",
                        "latitude": "5.40333000",
                        "longitude": "125.46361000"
                    },
                    {
                        "id": 84784,
                        "name": "Sigaboy",
                        "latitude": "6.65413000",
                        "longitude": "126.07268000"
                    },
                    {
                        "id": 84803,
                        "name": "Simod",
                        "latitude": "7.47583000",
                        "longitude": "125.34083000"
                    },
                    {
                        "id": 84811,
                        "name": "Sinawilan",
                        "latitude": "6.75444000",
                        "longitude": "125.24639000"
                    },
                    {
                        "id": 84812,
                        "name": "Sinayawan",
                        "latitude": "6.71250000",
                        "longitude": "125.30944000"
                    },
                    {
                        "id": 84829,
                        "name": "Sirib",
                        "latitude": "7.13333000",
                        "longitude": "125.40722000"
                    },
                    {
                        "id": 84858,
                        "name": "Sugal",
                        "latitude": "5.66222000",
                        "longitude": "125.46167000"
                    },
                    {
                        "id": 84883,
                        "name": "Surup",
                        "latitude": "6.39035000",
                        "longitude": "126.14558000"
                    },
                    {
                        "id": 84887,
                        "name": "Suz-on",
                        "latitude": "7.66278000",
                        "longitude": "125.63833000"
                    },
                    {
                        "id": 84926,
                        "name": "Tagakpan",
                        "latitude": "7.11278000",
                        "longitude": "125.42917000"
                    },
                    {
                        "id": 84941,
                        "name": "Tagdanua",
                        "latitude": "7.20430000",
                        "longitude": "125.88410000"
                    },
                    {
                        "id": 84943,
                        "name": "Tagnanan",
                        "latitude": "7.28361000",
                        "longitude": "125.84222000"
                    },
                    {
                        "id": 84956,
                        "name": "Takub",
                        "latitude": "6.85639000",
                        "longitude": "125.42250000"
                    },
                    {
                        "id": 84964,
                        "name": "Talagutong",
                        "latitude": "6.26444000",
                        "longitude": "125.66778000"
                    },
                    {
                        "id": 84991,
                        "name": "Talomo",
                        "latitude": "7.52861000",
                        "longitude": "125.72278000"
                    },
                    {
                        "id": 85003,
                        "name": "Tamayong",
                        "latitude": "7.13306000",
                        "longitude": "125.37972000"
                    },
                    {
                        "id": 85011,
                        "name": "Tambo",
                        "latitude": "7.15694000",
                        "longitude": "125.69917000"
                    },
                    {
                        "id": 85015,
                        "name": "Tamisan",
                        "latitude": "6.84372000",
                        "longitude": "126.29838000"
                    },
                    {
                        "id": 85027,
                        "name": "Tamugan",
                        "latitude": "7.23083000",
                        "longitude": "125.37639000"
                    },
                    {
                        "id": 85040,
                        "name": "Tanlad",
                        "latitude": "6.60222000",
                        "longitude": "125.44500000"
                    },
                    {
                        "id": 85050,
                        "name": "Tapia",
                        "latitude": "7.75417000",
                        "longitude": "126.01194000"
                    },
                    {
                        "id": 85067,
                        "name": "Tawan tawan",
                        "latitude": "7.16917000",
                        "longitude": "125.37278000"
                    },
                    {
                        "id": 85078,
                        "name": "Taytayan",
                        "latitude": "7.73389000",
                        "longitude": "126.50194000"
                    },
                    {
                        "id": 85093,
                        "name": "Tibagon",
                        "latitude": "7.23270000",
                        "longitude": "125.86280000"
                    },
                    {
                        "id": 85094,
                        "name": "Tibanbang",
                        "latitude": "6.63153000",
                        "longitude": "126.10548000"
                    },
                    {
                        "id": 85097,
                        "name": "Tiblawan",
                        "latitude": "6.47834000",
                        "longitude": "126.10828000"
                    },
                    {
                        "id": 85163,
                        "name": "Tombongon",
                        "latitude": "7.07920000",
                        "longitude": "125.94860000"
                    },
                    {
                        "id": 85182,
                        "name": "Tubalan",
                        "latitude": "6.49500000",
                        "longitude": "125.56611000"
                    },
                    {
                        "id": 85184,
                        "name": "Tuban",
                        "latitude": "6.82278000",
                        "longitude": "125.38694000"
                    },
                    {
                        "id": 85206,
                        "name": "Tuganay",
                        "latitude": "7.36889000",
                        "longitude": "125.72306000"
                    },
                    {
                        "id": 85217,
                        "name": "Tuli",
                        "latitude": "7.23333000",
                        "longitude": "125.41667000"
                    },
                    {
                        "id": 85245,
                        "name": "Ula",
                        "latitude": "7.13222000",
                        "longitude": "125.49222000"
                    },
                    {
                        "id": 85315,
                        "name": "Wañgan",
                        "latitude": "7.15972000",
                        "longitude": "125.44528000"
                    },
                    {
                        "id": 85316,
                        "name": "Wines",
                        "latitude": "7.19389000",
                        "longitude": "125.38917000"
                    }
                ]
            },
            {
                "id": 1311,
                "name": "Davao de Oro",
                "iso2": "COM",
                "latitude": "7.51251500",
                "longitude": "126.17626150",
                "type": "province",
                "cities": [
                    {
                        "id": 154516,
                        "name": "Compostela",
                        "latitude": "7.71401500",
                        "longitude": "125.99196720"
                    },
                    {
                        "id": 154517,
                        "name": "Laak",
                        "latitude": "7.81706790",
                        "longitude": "125.65576840"
                    },
                    {
                        "id": 144981,
                        "name": "Mabini",
                        "latitude": "7.28909420",
                        "longitude": "125.77121070"
                    },
                    {
                        "id": 144219,
                        "name": "Maco",
                        "latitude": "7.35940210",
                        "longitude": "125.84658620"
                    },
                    {
                        "id": 154518,
                        "name": "Maragusan",
                        "latitude": "7.36115360",
                        "longitude": "126.01042080"
                    },
                    {
                        "id": 144246,
                        "name": "Mawab",
                        "latitude": "7.49820290",
                        "longitude": "125.85698840"
                    },
                    {
                        "id": 144249,
                        "name": "Monkayo",
                        "latitude": "7.85150750",
                        "longitude": "125.91274550"
                    },
                    {
                        "id": 144250,
                        "name": "Montevista",
                        "latitude": "7.72522770",
                        "longitude": "125.92327200"
                    },
                    {
                        "id": 144251,
                        "name": "Nabunturan",
                        "latitude": "7.55985990",
                        "longitude": "125.84523960"
                    },
                    {
                        "id": 144255,
                        "name": "New Bataan",
                        "latitude": "7.52403930",
                        "longitude": "126.01788810"
                    },
                    {
                        "id": 144270,
                        "name": "Pantukan",
                        "latitude": "7.21265640",
                        "longitude": "125.74880220"
                    }
                ]
            },
            {
                "id": 1319,
                "name": "Davao del Norte",
                "iso2": "DAV",
                "latitude": "7.56176990",
                "longitude": "125.65328480",
                "type": "province",
                "cities": [
                    {
                        "id": 144116,
                        "name": "Asuncion",
                        "latitude": "7.64215700",
                        "longitude": "125.64255040"
                    },
                    {
                        "id": 154532,
                        "name": "Braulio E. Dujali",
                        "latitude": "7.45139940",
                        "longitude": "125.62497660"
                    },
                    {
                        "id": 154533,
                        "name": "Carmen",
                        "latitude": "7.36724970",
                        "longitude": "125.58138830"
                    },
                    {
                        "id": 144955,
                        "name": "Kapalong",
                        "latitude": "7.69550200",
                        "longitude": "125.45471000"
                    },
                    {
                        "id": 144257,
                        "name": "New Corella",
                        "latitude": "7.60379860",
                        "longitude": "125.77778900"
                    },
                    {
                        "id": 144266,
                        "name": "Panabo",
                        "latitude": "7.33656990",
                        "longitude": "125.56514340"
                    },
                    {
                        "id": 144274,
                        "name": "Samal",
                        "latitude": "7.04524630",
                        "longitude": "125.73004050"
                    },
                    {
                        "id": 154534,
                        "name": "San Isidro",
                        "latitude": "7.38054000",
                        "longitude": "125.76432590"
                    },
                    {
                        "id": 154535,
                        "name": "Santo Tomas",
                        "latitude": "7.51132860",
                        "longitude": "125.45598080"
                    },
                    {
                        "id": 145072,
                        "name": "Tagum",
                        "latitude": "7.42465880",
                        "longitude": "125.72609910"
                    },
                    {
                        "id": 154536,
                        "name": "Talaingod",
                        "latitude": "7.67853800",
                        "longitude": "125.27227230"
                    }
                ]
            },
            {
                "id": 1318,
                "name": "Davao del Sur",
                "iso2": "DAS",
                "latitude": "6.76626870",
                "longitude": "125.32842690",
                "type": "province",
                "cities": [
                    {
                        "id": 144889,
                        "name": "Bansalan",
                        "latitude": "6.84219370",
                        "longitude": "6.84219370"
                    },
                    {
                        "id": 144930,
                        "name": "Davao City",
                        "latitude": "7.25419890",
                        "longitude": "125.12141680"
                    },
                    {
                        "id": 144932,
                        "name": "Digos",
                        "latitude": "6.84352490",
                        "longitude": "125.23817960"
                    },
                    {
                        "id": 144944,
                        "name": "Hagonoy",
                        "latitude": "6.69879730",
                        "longitude": "125.23344760"
                    },
                    {
                        "id": 144958,
                        "name": "Kiblawan",
                        "latitude": "6.63096810",
                        "longitude": "125.13170900"
                    },
                    {
                        "id": 144989,
                        "name": "Magsaysay",
                        "latitude": "6.80014190",
                        "longitude": "125.07541480"
                    },
                    {
                        "id": 144995,
                        "name": "Malalag",
                        "latitude": "6.52397850",
                        "longitude": "125.14508380"
                    },
                    {
                        "id": 145006,
                        "name": "Matanao",
                        "latitude": "6.73990220",
                        "longitude": "125.06744830"
                    },
                    {
                        "id": 145027,
                        "name": "Padada",
                        "latitude": "6.65034450",
                        "longitude": "125.21705710"
                    },
                    {
                        "id": 145052,
                        "name": "Santa Cruz",
                        "latitude": "6.87172090",
                        "longitude": "125.31099990"
                    },
                    {
                        "id": 145066,
                        "name": "Sulop",
                        "latitude": "6.62101640",
                        "longitude": "125.24456580"
                    }
                ]
            },
            {
                "id": 1309,
                "name": "Davao Occidental",
                "iso2": "DVO",
                "latitude": "6.09413960",
                "longitude": "125.60954740",
                "type": "province",
                "cities": [
                    {
                        "id": 144877,
                        "name": "Andili",
                        "latitude": "7.46194444",
                        "longitude": "125.97000000"
                    },
                    {
                        "id": 144878,
                        "name": "Andop",
                        "latitude": "7.86111111",
                        "longitude": "125.75388889"
                    },
                    {
                        "id": 144879,
                        "name": "Anibongan",
                        "latitude": "7.39333333",
                        "longitude": "125.71888889"
                    },
                    {
                        "id": 144880,
                        "name": "Astorga",
                        "latitude": "6.90722222",
                        "longitude": "125.45583333"
                    },
                    {
                        "id": 144882,
                        "name": "Babag",
                        "latitude": "7.73305556",
                        "longitude": "126.07138889"
                    },
                    {
                        "id": 144883,
                        "name": "Baculin",
                        "latitude": "7.45250000",
                        "longitude": "126.58416667"
                    },
                    {
                        "id": 144885,
                        "name": "Balagunan",
                        "latitude": "7.49222222",
                        "longitude": "125.52111111"
                    },
                    {
                        "id": 144886,
                        "name": "Balangonan",
                        "latitude": "5.57333333",
                        "longitude": "125.35388889"
                    },
                    {
                        "id": 144887,
                        "name": "Balutakay",
                        "latitude": "6.72111111",
                        "longitude": "125.35166667"
                    },
                    {
                        "id": 144890,
                        "name": "Bantacan",
                        "latitude": "7.60388889",
                        "longitude": "126.12972222"
                    },
                    {
                        "id": 144891,
                        "name": "Baon",
                        "latitude": "6.79555556",
                        "longitude": "126.08777778"
                    },
                    {
                        "id": 144892,
                        "name": "Baracatan",
                        "latitude": "6.96750000",
                        "longitude": "125.41583333"
                    },
                    {
                        "id": 144893,
                        "name": "Basiawan",
                        "latitude": "6.53416667",
                        "longitude": "125.48694444"
                    },
                    {
                        "id": 144894,
                        "name": "Batiano",
                        "latitude": "7.55333333",
                        "longitude": "126.49083333"
                    },
                    {
                        "id": 144896,
                        "name": "Batobato",
                        "latitude": "6.82527778",
                        "longitude": "126.08444444"
                    },
                    {
                        "id": 144897,
                        "name": "Baylo",
                        "latitude": "7.85527778",
                        "longitude": "126.05555556"
                    },
                    {
                        "id": 144898,
                        "name": "Biao",
                        "latitude": "7.16333333",
                        "longitude": "125.52111111"
                    },
                    {
                        "id": 144899,
                        "name": "Bincoñgan",
                        "latitude": "7.36666667",
                        "longitude": "125.75000000"
                    },
                    {
                        "id": 144900,
                        "name": "Bitaogan",
                        "latitude": "6.76833333",
                        "longitude": "126.07750000"
                    },
                    {
                        "id": 144902,
                        "name": "Bolila",
                        "latitude": "6.37166667",
                        "longitude": "125.57138889"
                    },
                    {
                        "id": 144904,
                        "name": "Buclad",
                        "latitude": "7.52777778",
                        "longitude": "125.75055556"
                    },
                    {
                        "id": 144905,
                        "name": "Buhangin",
                        "latitude": "6.49111111",
                        "longitude": "125.54750000"
                    },
                    {
                        "id": 144906,
                        "name": "Bukid",
                        "latitude": "5.57166667",
                        "longitude": "125.40555556"
                    },
                    {
                        "id": 144907,
                        "name": "Bulacan",
                        "latitude": "6.56750000",
                        "longitude": "125.42111111"
                    },
                    {
                        "id": 144908,
                        "name": "Bungabon",
                        "latitude": "7.22222222",
                        "longitude": "125.87305556"
                    },
                    {
                        "id": 144909,
                        "name": "Butulan",
                        "latitude": "5.61444444",
                        "longitude": "125.43166667"
                    },
                    {
                        "id": 144910,
                        "name": "Cabayangan",
                        "latitude": "7.40722222",
                        "longitude": "125.73305556"
                    },
                    {
                        "id": 144911,
                        "name": "Cabinuangan",
                        "latitude": "7.68333333",
                        "longitude": "126.03333333"
                    },
                    {
                        "id": 144912,
                        "name": "Caburan",
                        "latitude": "5.91805556",
                        "longitude": "125.64111111"
                    },
                    {
                        "id": 144913,
                        "name": "Cambanugoy",
                        "latitude": "7.54138889",
                        "longitude": "125.75527778"
                    },
                    {
                        "id": 144914,
                        "name": "Camudmud",
                        "latitude": "7.17611111",
                        "longitude": "125.69333333"
                    },
                    {
                        "id": 144918,
                        "name": "City of Mati",
                        "latitude": "6.75381000",
                        "longitude": "126.24592000"
                    },
                    {
                        "id": 144919,
                        "name": "City of Panabo",
                        "latitude": "7.33038000",
                        "longitude": "125.60607000"
                    },
                    {
                        "id": 144920,
                        "name": "City of Tagum",
                        "latitude": "7.40000000",
                        "longitude": "125.83333000"
                    },
                    {
                        "id": 144921,
                        "name": "Cogon",
                        "latitude": "7.15083333",
                        "longitude": "125.71722222"
                    },
                    {
                        "id": 144923,
                        "name": "Corocotan",
                        "latitude": "7.39972222",
                        "longitude": "125.77277778"
                    },
                    {
                        "id": 144924,
                        "name": "Coronon",
                        "latitude": "6.87916667",
                        "longitude": "125.44888889"
                    },
                    {
                        "id": 144925,
                        "name": "Cuambog",
                        "latitude": "7.30861111",
                        "longitude": "125.84805556"
                    },
                    {
                        "id": 144926,
                        "name": "Culaman",
                        "latitude": "5.96027778",
                        "longitude": "125.65861111"
                    },
                    {
                        "id": 144927,
                        "name": "Dacudao",
                        "latitude": "7.21527778",
                        "longitude": "125.47138889"
                    },
                    {
                        "id": 144928,
                        "name": "Dakbayan sa Digos",
                        "latitude": "6.83333000",
                        "longitude": "125.35000000"
                    },
                    {
                        "id": 144929,
                        "name": "Davan",
                        "latitude": "6.91500000",
                        "longitude": "126.15333333"
                    },
                    {
                        "id": 144931,
                        "name": "Del Pilar",
                        "latitude": "7.56305556",
                        "longitude": "125.82666667"
                    },
                    {
                        "id": 144933,
                        "name": "Dolo",
                        "latitude": "6.81027778",
                        "longitude": "125.19166667"
                    },
                    {
                        "id": 144934,
                        "name": "Don Marcelino",
                        "latitude": "6.11667000",
                        "longitude": "125.63333000"
                    },
                    {
                        "id": 144935,
                        "name": "Dumlan",
                        "latitude": "7.42750000",
                        "longitude": "125.88194444"
                    },
                    {
                        "id": 144937,
                        "name": "Gabi",
                        "latitude": "7.62138889",
                        "longitude": "126.09194444"
                    },
                    {
                        "id": 144938,
                        "name": "Gabuyan",
                        "latitude": "7.60805556",
                        "longitude": "125.66888889"
                    },
                    {
                        "id": 144939,
                        "name": "Goma",
                        "latitude": "6.79194444",
                        "longitude": "125.32083333"
                    },
                    {
                        "id": 144941,
                        "name": "Guihing Proper",
                        "latitude": "6.68444444",
                        "longitude": "125.35250000"
                    },
                    {
                        "id": 144942,
                        "name": "Gumalang",
                        "latitude": "7.20833333",
                        "longitude": "125.40361111"
                    },
                    {
                        "id": 144943,
                        "name": "Gupitan",
                        "latitude": "7.77583333",
                        "longitude": "125.64055556"
                    },
                    {
                        "id": 144945,
                        "name": "Ignit",
                        "latitude": "6.70083333",
                        "longitude": "125.29194444"
                    },
                    {
                        "id": 144946,
                        "name": "Ilangay",
                        "latitude": "6.91277778",
                        "longitude": "126.05000000"
                    },
                    {
                        "id": 144947,
                        "name": "Inawayan",
                        "latitude": "6.96083333",
                        "longitude": "125.47333333"
                    },
                    {
                        "id": 144948,
                        "name": "Island Garden City of Samal",
                        "latitude": "7.08333000",
                        "longitude": "125.75000000"
                    },
                    {
                        "id": 144949,
                        "name": "Jose Abad Santos",
                        "latitude": "5.91666667",
                        "longitude": "125.65000000"
                    },
                    {
                        "id": 144951,
                        "name": "Jovellar",
                        "latitude": "7.06361111",
                        "longitude": "126.45555556"
                    },
                    {
                        "id": 144952,
                        "name": "Kalbay",
                        "latitude": "5.72333333",
                        "longitude": "125.49861111"
                    },
                    {
                        "id": 144953,
                        "name": "Kalian",
                        "latitude": "6.12305556",
                        "longitude": "125.70027778"
                    },
                    {
                        "id": 144954,
                        "name": "Kaligutan",
                        "latitude": "7.70305556",
                        "longitude": "125.81305556"
                    },
                    {
                        "id": 144959,
                        "name": "Kinablangan",
                        "latitude": "7.69277778",
                        "longitude": "126.54916667"
                    },
                    {
                        "id": 144960,
                        "name": "Kinamayan",
                        "latitude": "7.49944444",
                        "longitude": "125.67361111"
                    },
                    {
                        "id": 144961,
                        "name": "Kinangan",
                        "latitude": "6.30138889",
                        "longitude": "125.58500000"
                    },
                    {
                        "id": 144964,
                        "name": "La Union",
                        "latitude": "6.70416667",
                        "longitude": "126.08805556"
                    },
                    {
                        "id": 144965,
                        "name": "Lacaron",
                        "latitude": "6.44888889",
                        "longitude": "125.57916667"
                    },
                    {
                        "id": 144966,
                        "name": "Lacson",
                        "latitude": "7.21194444",
                        "longitude": "125.44222222"
                    },
                    {
                        "id": 144967,
                        "name": "Lais",
                        "latitude": "6.33277778",
                        "longitude": "125.64638889"
                    },
                    {
                        "id": 144969,
                        "name": "Lapuan",
                        "latitude": "6.14444444",
                        "longitude": "125.70083333"
                    },
                    {
                        "id": 144970,
                        "name": "Lasang",
                        "latitude": "7.26694444",
                        "longitude": "125.66500000"
                    },
                    {
                        "id": 144971,
                        "name": "Libuganon",
                        "latitude": "7.34888889",
                        "longitude": "125.77833333"
                    },
                    {
                        "id": 144972,
                        "name": "Limao",
                        "latitude": "7.07916667",
                        "longitude": "125.67361111"
                    },
                    {
                        "id": 144973,
                        "name": "Limot",
                        "latitude": "7.04055556",
                        "longitude": "126.27277778"
                    },
                    {
                        "id": 144974,
                        "name": "Linao",
                        "latitude": "7.01722222",
                        "longitude": "125.99194444"
                    },
                    {
                        "id": 144975,
                        "name": "Linoan",
                        "latitude": "7.62611111",
                        "longitude": "125.97416667"
                    },
                    {
                        "id": 144976,
                        "name": "Lukatan",
                        "latitude": "7.00972222",
                        "longitude": "126.42111111"
                    },
                    {
                        "id": 144977,
                        "name": "Luna",
                        "latitude": "7.57638889",
                        "longitude": "125.66722222"
                    },
                    {
                        "id": 144978,
                        "name": "Lungaog",
                        "latitude": "7.52944444",
                        "longitude": "125.68777778"
                    },
                    {
                        "id": 144980,
                        "name": "Luzon",
                        "latitude": "6.51916667",
                        "longitude": "126.09416667"
                    },
                    {
                        "id": 144983,
                        "name": "Mabuhay",
                        "latitude": "7.33305556",
                        "longitude": "125.54750000"
                    },
                    {
                        "id": 144985,
                        "name": "Maduao",
                        "latitude": "7.29416667",
                        "longitude": "125.62583333"
                    },
                    {
                        "id": 144986,
                        "name": "Magatos",
                        "latitude": "7.55555556",
                        "longitude": "125.72666667"
                    },
                    {
                        "id": 144987,
                        "name": "Magdug",
                        "latitude": "6.54777778",
                        "longitude": "126.09500000"
                    },
                    {
                        "id": 144988,
                        "name": "Magnaga",
                        "latitude": "7.16944444",
                        "longitude": "125.89305556"
                    },
                    {
                        "id": 144992,
                        "name": "Mahanob",
                        "latitude": "7.57333333",
                        "longitude": "126.50694444"
                    },
                    {
                        "id": 144994,
                        "name": "Malagos",
                        "latitude": "7.18500000",
                        "longitude": "125.42222222"
                    },
                    {
                        "id": 144996,
                        "name": "Malinao",
                        "latitude": "6.65916667",
                        "longitude": "125.28666667"
                    },
                    {
                        "id": 144997,
                        "name": "Malita",
                        "latitude": "6.40000000",
                        "longitude": "125.60000000"
                    },
                    {
                        "id": 144998,
                        "name": "Mambago",
                        "latitude": "7.10555556",
                        "longitude": "125.69444444"
                    },
                    {
                        "id": 144999,
                        "name": "Managa",
                        "latitude": "6.74611111",
                        "longitude": "125.26805556"
                    },
                    {
                        "id": 145000,
                        "name": "Manaloal",
                        "latitude": "7.36611111",
                        "longitude": "125.66027778"
                    },
                    {
                        "id": 145001,
                        "name": "Manat",
                        "latitude": "7.53277778",
                        "longitude": "126.01722222"
                    },
                    {
                        "id": 145004,
                        "name": "Mangili",
                        "latitude": "6.00333333",
                        "longitude": "125.68388889"
                    },
                    {
                        "id": 145005,
                        "name": "Manikling",
                        "latitude": "6.87916667",
                        "longitude": "126.06055556"
                    },
                    {
                        "id": 145009,
                        "name": "Matiao",
                        "latitude": "7.08277778",
                        "longitude": "125.93611111"
                    },
                    {
                        "id": 145010,
                        "name": "Matti",
                        "latitude": "6.77055556",
                        "longitude": "125.30861111"
                    },
                    {
                        "id": 145013,
                        "name": "Mayo",
                        "latitude": "7.00222222",
                        "longitude": "126.33194444"
                    },
                    {
                        "id": 145017,
                        "name": "Nangan",
                        "latitude": "6.47277778",
                        "longitude": "126.12444444"
                    },
                    {
                        "id": 145018,
                        "name": "Nanyo",
                        "latitude": "7.33305556",
                        "longitude": "125.63777778"
                    },
                    {
                        "id": 145019,
                        "name": "New Baclayon",
                        "latitude": "6.58416667",
                        "longitude": "125.36944444"
                    },
                    {
                        "id": 145021,
                        "name": "New Bohol",
                        "latitude": "7.52333333",
                        "longitude": "125.83638889"
                    },
                    {
                        "id": 145023,
                        "name": "New Leyte",
                        "latitude": "7.50000000",
                        "longitude": "125.75000000"
                    },
                    {
                        "id": 145024,
                        "name": "New Sibonga",
                        "latitude": "7.56083333",
                        "longitude": "125.92972222"
                    },
                    {
                        "id": 145025,
                        "name": "New Visayas",
                        "latitude": "7.52333333",
                        "longitude": "125.62333333"
                    },
                    {
                        "id": 145026,
                        "name": "Nuing",
                        "latitude": "5.63277778",
                        "longitude": "125.43527778"
                    },
                    {
                        "id": 145028,
                        "name": "Pag-asa",
                        "latitude": "7.57555556",
                        "longitude": "125.68388889"
                    },
                    {
                        "id": 145029,
                        "name": "Pagsabangan",
                        "latitude": "7.48111111",
                        "longitude": "125.74944444"
                    },
                    {
                        "id": 145030,
                        "name": "Palma Gil",
                        "latitude": "7.64222222",
                        "longitude": "125.62916667"
                    },
                    {
                        "id": 145032,
                        "name": "Pandasan",
                        "latitude": "7.28388889",
                        "longitude": "125.85361111"
                    },
                    {
                        "id": 145033,
                        "name": "Pangian",
                        "latitude": "6.46277778",
                        "longitude": "125.54527778"
                    },
                    {
                        "id": 145034,
                        "name": "Panikian",
                        "latitude": "7.01083333",
                        "longitude": "126.02416667"
                    },
                    {
                        "id": 145036,
                        "name": "Pasian",
                        "latitude": "7.92805556",
                        "longitude": "126.06722222"
                    },
                    {
                        "id": 145037,
                        "name": "Pondaguitan",
                        "latitude": "6.36111111",
                        "longitude": "126.17777778"
                    },
                    {
                        "id": 145038,
                        "name": "Pung-Pang",
                        "latitude": "6.49750000",
                        "longitude": "125.46333333"
                    },
                    {
                        "id": 145040,
                        "name": "Sampao",
                        "latitude": "7.59388889",
                        "longitude": "125.66111111"
                    },
                    {
                        "id": 145041,
                        "name": "San Alfonso",
                        "latitude": "7.78027778",
                        "longitude": "126.42027778"
                    },
                    {
                        "id": 145042,
                        "name": "San Antonio",
                        "latitude": "7.12000000",
                        "longitude": "125.73972222"
                    },
                    {
                        "id": 145043,
                        "name": "San Ignacio",
                        "latitude": "7.11888889",
                        "longitude": "126.48833333"
                    },
                    {
                        "id": 145044,
                        "name": "San Isidro",
                        "latitude": "6.76667000",
                        "longitude": "126.13333000"
                    },
                    {
                        "id": 145045,
                        "name": "San Luis",
                        "latitude": "7.44138889",
                        "longitude": "126.55111111"
                    },
                    {
                        "id": 145046,
                        "name": "San Mariano",
                        "latitude": "7.33819000",
                        "longitude": "126.16464000"
                    },
                    {
                        "id": 145047,
                        "name": "San Miguel",
                        "latitude": "7.48500000",
                        "longitude": "125.67638889"
                    },
                    {
                        "id": 145048,
                        "name": "San Pedro",
                        "latitude": "7.34194444",
                        "longitude": "126.51750000"
                    },
                    {
                        "id": 145049,
                        "name": "San Rafael",
                        "latitude": "7.76388889",
                        "longitude": "126.45583333"
                    },
                    {
                        "id": 145053,
                        "name": "Santa Maria",
                        "latitude": "6.55361111",
                        "longitude": "125.47083333"
                    },
                    {
                        "id": 145055,
                        "name": "Santo Niño",
                        "latitude": "7.62361111",
                        "longitude": "125.62527778"
                    },
                    {
                        "id": 145058,
                        "name": "Sarangani",
                        "latitude": "5.40000000",
                        "longitude": "125.46666667"
                    },
                    {
                        "id": 145060,
                        "name": "Sigaboy",
                        "latitude": "6.65416667",
                        "longitude": "126.07277778"
                    },
                    {
                        "id": 145061,
                        "name": "Simod",
                        "latitude": "7.47583333",
                        "longitude": "125.34083333"
                    },
                    {
                        "id": 145062,
                        "name": "Sinawilan",
                        "latitude": "6.75444444",
                        "longitude": "125.24638889"
                    },
                    {
                        "id": 145063,
                        "name": "Sinayawan",
                        "latitude": "6.71250000",
                        "longitude": "125.30944444"
                    },
                    {
                        "id": 145064,
                        "name": "Sirib",
                        "latitude": "7.13333333",
                        "longitude": "125.40722222"
                    },
                    {
                        "id": 145065,
                        "name": "Sugal",
                        "latitude": "5.66222222",
                        "longitude": "125.46166667"
                    },
                    {
                        "id": 145067,
                        "name": "Surup",
                        "latitude": "6.39027778",
                        "longitude": "126.14555556"
                    },
                    {
                        "id": 145068,
                        "name": "Suz-on",
                        "latitude": "7.66277778",
                        "longitude": "125.63833333"
                    },
                    {
                        "id": 145069,
                        "name": "Tagakpan",
                        "latitude": "7.11277778",
                        "longitude": "125.42916667"
                    },
                    {
                        "id": 145070,
                        "name": "Tagdanua",
                        "latitude": "7.20416667",
                        "longitude": "125.88416667"
                    },
                    {
                        "id": 145071,
                        "name": "Tagnanan",
                        "latitude": "7.28361111",
                        "longitude": "125.84222222"
                    },
                    {
                        "id": 145073,
                        "name": "Takub",
                        "latitude": "6.85638889",
                        "longitude": "125.42250000"
                    },
                    {
                        "id": 145074,
                        "name": "Talagutong",
                        "latitude": "6.26444444",
                        "longitude": "125.66777778"
                    },
                    {
                        "id": 145075,
                        "name": "Talisay",
                        "latitude": "6.71972222",
                        "longitude": "126.10000000"
                    },
                    {
                        "id": 145076,
                        "name": "Talomo",
                        "latitude": "7.52861111",
                        "longitude": "125.72277778"
                    },
                    {
                        "id": 145077,
                        "name": "Tamayong",
                        "latitude": "7.13305556",
                        "longitude": "125.37972222"
                    },
                    {
                        "id": 145078,
                        "name": "Tambo",
                        "latitude": "7.15694444",
                        "longitude": "125.69916667"
                    },
                    {
                        "id": 145079,
                        "name": "Tamisan",
                        "latitude": "6.84361111",
                        "longitude": "126.29833333"
                    },
                    {
                        "id": 145080,
                        "name": "Tamugan",
                        "latitude": "7.23083333",
                        "longitude": "125.37638889"
                    },
                    {
                        "id": 145081,
                        "name": "Tanlad",
                        "latitude": "6.60222222",
                        "longitude": "125.44500000"
                    },
                    {
                        "id": 145082,
                        "name": "Tapia",
                        "latitude": "7.75416667",
                        "longitude": "126.01194444"
                    },
                    {
                        "id": 145084,
                        "name": "Tawan tawan",
                        "latitude": "7.16916667",
                        "longitude": "125.37277778"
                    },
                    {
                        "id": 145085,
                        "name": "Taytayan",
                        "latitude": "7.73388889",
                        "longitude": "126.50194444"
                    },
                    {
                        "id": 145086,
                        "name": "Tibagon",
                        "latitude": "7.23277778",
                        "longitude": "125.86277778"
                    },
                    {
                        "id": 145087,
                        "name": "Tibanbang",
                        "latitude": "6.63166667",
                        "longitude": "126.10555556"
                    },
                    {
                        "id": 145088,
                        "name": "Tiblawan",
                        "latitude": "6.47833333",
                        "longitude": "126.10833333"
                    },
                    {
                        "id": 145089,
                        "name": "Tombongon",
                        "latitude": "7.07916667",
                        "longitude": "125.94861111"
                    },
                    {
                        "id": 145090,
                        "name": "Tubalan",
                        "latitude": "6.49500000",
                        "longitude": "125.56611111"
                    },
                    {
                        "id": 145091,
                        "name": "Tuban",
                        "latitude": "6.82277778",
                        "longitude": "125.38694444"
                    },
                    {
                        "id": 145093,
                        "name": "Tuganay",
                        "latitude": "7.36888889",
                        "longitude": "125.72305556"
                    },
                    {
                        "id": 145094,
                        "name": "Tuli",
                        "latitude": "7.23333333",
                        "longitude": "125.41666667"
                    },
                    {
                        "id": 145095,
                        "name": "Ula",
                        "latitude": "7.13222222",
                        "longitude": "125.49222222"
                    },
                    {
                        "id": 145096,
                        "name": "Wañgan",
                        "latitude": "7.15972222",
                        "longitude": "125.44527778"
                    },
                    {
                        "id": 145097,
                        "name": "Wines",
                        "latitude": "7.19388889",
                        "longitude": "125.38916667"
                    }
                ]
            },
            {
                "id": 1289,
                "name": "Davao Oriental",
                "iso2": "DAO",
                "latitude": "7.31715850",
                "longitude": "126.54198870",
                "type": "province",
                "cities": [
                    {
                        "id": 144884,
                        "name": "Baganga",
                        "latitude": "7.60140380",
                        "longitude": "126.24409090"
                    },
                    {
                        "id": 144888,
                        "name": "Banaybanay",
                        "latitude": "7.09273580",
                        "longitude": "125.79562300"
                    },
                    {
                        "id": 144903,
                        "name": "Boston",
                        "latitude": "7.90499890",
                        "longitude": "126.11753750"
                    },
                    {
                        "id": 144915,
                        "name": "Caraga",
                        "latitude": "7.35321280",
                        "longitude": "126.28919890"
                    },
                    {
                        "id": 144917,
                        "name": "Cateel",
                        "latitude": "7.77548790",
                        "longitude": "126.21418290"
                    },
                    {
                        "id": 144940,
                        "name": "Governor Generoso",
                        "latitude": "6.47502990",
                        "longitude": "125.96347150"
                    },
                    {
                        "id": 144979,
                        "name": "Lupon",
                        "latitude": "7.06625540",
                        "longitude": "125.98505780"
                    },
                    {
                        "id": 145002,
                        "name": "Manay",
                        "latitude": "7.18886940",
                        "longitude": "126.28615190"
                    },
                    {
                        "id": 145008,
                        "name": "Mati",
                        "latitude": "6.69628500",
                        "longitude": "125.89323730"
                    },
                    {
                        "id": 154537,
                        "name": "San Isidro",
                        "latitude": "6.80829550",
                        "longitude": "126.04477390"
                    },
                    {
                        "id": 145083,
                        "name": "Tarragona",
                        "latitude": "7.07402650",
                        "longitude": "126.29690900"
                    }
                ]
            },
            {
                "id": 1291,
                "name": "Dinagat Islands",
                "iso2": "DIN",
                "latitude": "10.12818160",
                "longitude": "125.60954740",
                "type": "province",
                "cities": [
                    {
                        "id": 144388,
                        "name": "Basilisa",
                        "latitude": "10.04008510",
                        "longitude": "125.46317660"
                    },
                    {
                        "id": 144403,
                        "name": "Cagdianao",
                        "latitude": "10.01931460",
                        "longitude": "125.49702460"
                    },
                    {
                        "id": 144425,
                        "name": "Dinagat",
                        "latitude": "9.96098390",
                        "longitude": "125.54737950"
                    },
                    {
                        "id": 144451,
                        "name": "Libjo",
                        "latitude": "10.19620040",
                        "longitude": "125.39681740"
                    },
                    {
                        "id": 144453,
                        "name": "Loreto",
                        "latitude": "10.36344940",
                        "longitude": "125.40694540"
                    },
                    {
                        "id": 154538,
                        "name": "San Jose",
                        "latitude": "10.01778840",
                        "longitude": "125.55115600"
                    },
                    {
                        "id": 144522,
                        "name": "Tubajon",
                        "latitude": "10.28817520",
                        "longitude": "125.50291620"
                    }
                ]
            },
            {
                "id": 1290,
                "name": "Eastern Samar",
                "iso2": "EAS",
                "latitude": "11.50007310",
                "longitude": "125.49999080",
                "type": "province",
                "cities": [
                    {
                        "id": 81318,
                        "name": "Arteche",
                        "latitude": "12.25845870",
                        "longitude": "125.18071710"
                    },
                    {
                        "id": 81443,
                        "name": "Balangiga",
                        "latitude": "11.18308620",
                        "longitude": "125.27078700"
                    },
                    {
                        "id": 81444,
                        "name": "Balangkayan",
                        "latitude": "11.39104930",
                        "longitude": "125.23202240"
                    },
                    {
                        "id": 81798,
                        "name": "Borongan",
                        "latitude": "11.59461150",
                        "longitude": "125.19932100"
                    },
                    {
                        "id": 82098,
                        "name": "Can-Avid",
                        "latitude": "11.99191540",
                        "longitude": "125.19099540"
                    },
                    {
                        "id": 82452,
                        "name": "Dolores",
                        "latitude": "12.08940760",
                        "longitude": "125.23279500"
                    },
                    {
                        "id": 82579,
                        "name": "General MacArthur",
                        "latitude": "11.26387910",
                        "longitude": "125.42790020"
                    },
                    {
                        "id": 82597,
                        "name": "Giporlos",
                        "latitude": "11.12019800",
                        "longitude": "125.39944720"
                    },
                    {
                        "id": 82650,
                        "name": "Guiuan",
                        "latitude": "10.87878670",
                        "longitude": "125.62915880"
                    },
                    {
                        "id": 82681,
                        "name": "Hernani",
                        "latitude": "11.32836350",
                        "longitude": "125.55154220"
                    },
                    {
                        "id": 148104,
                        "name": "Jipapad",
                        "latitude": "12.27276320",
                        "longitude": "125.13629040"
                    },
                    {
                        "id": 154539,
                        "name": "Lawaan",
                        "latitude": "11.20047910",
                        "longitude": "125.21694980"
                    },
                    {
                        "id": 83155,
                        "name": "Llorente",
                        "latitude": "11.34521940",
                        "longitude": "125.27701920"
                    },
                    {
                        "id": 83607,
                        "name": "Maslog",
                        "latitude": "12.10487210",
                        "longitude": "125.11324490"
                    },
                    {
                        "id": 83648,
                        "name": "Maydolong",
                        "latitude": "11.46848540",
                        "longitude": "125.21897610"
                    },
                    {
                        "id": 83660,
                        "name": "Mercedes",
                        "latitude": "11.09241420",
                        "longitude": "125.66398050"
                    },
                    {
                        "id": 83858,
                        "name": "Oras",
                        "latitude": "12.16062050",
                        "longitude": "125.25099100"
                    },
                    {
                        "id": 148153,
                        "name": "Quinapondan",
                        "latitude": "11.17941590",
                        "longitude": "125.40826640"
                    },
                    {
                        "id": 84406,
                        "name": "Salcedo",
                        "latitude": "11.17038020",
                        "longitude": "125.55089560"
                    },
                    {
                        "id": 84533,
                        "name": "San Julian",
                        "latitude": "11.73950370",
                        "longitude": "11.73950370"
                    },
                    {
                        "id": 84592,
                        "name": "San Policarpo",
                        "latitude": "12.21162360",
                        "longitude": "125.37914830"
                    },
                    {
                        "id": 84868,
                        "name": "Sulat",
                        "latitude": "11.81092600",
                        "longitude": "125.22399720"
                    },
                    {
                        "id": 84925,
                        "name": "Taft",
                        "latitude": "11.86583440",
                        "longitude": "125.26520810"
                    }
                ]
            },
            {
                "id": 1322,
                "name": "Eastern Visayas",
                "iso2": "08",
                "latitude": "12.24455330",
                "longitude": "125.03881640",
                "type": "region",
                "cities": [
                    {
                        "id": 147979,
                        "name": "Alugan",
                        "latitude": "12.21888889",
                        "longitude": "125.48083333"
                    },
                    {
                        "id": 147982,
                        "name": "Anito",
                        "latitude": "12.44972222",
                        "longitude": "125.28861111"
                    },
                    {
                        "id": 148066,
                        "name": "Balagtas",
                        "latitude": "11.13333333",
                        "longitude": "124.51916667"
                    },
                    {
                        "id": 148108,
                        "name": "Balagui",
                        "latitude": "11.47527778",
                        "longitude": "124.53250000"
                    },
                    {
                        "id": 148063,
                        "name": "Balinsacayao",
                        "latitude": "10.68111111",
                        "longitude": "124.95944444"
                    },
                    {
                        "id": 148089,
                        "name": "Balite",
                        "latitude": "11.19444444",
                        "longitude": "124.38583333"
                    },
                    {
                        "id": 148068,
                        "name": "Balocawehay",
                        "latitude": "10.72222222",
                        "longitude": "124.96777778"
                    },
                    {
                        "id": 148106,
                        "name": "Balogo",
                        "latitude": "10.88666667",
                        "longitude": "124.71055556"
                    },
                    {
                        "id": 148058,
                        "name": "Bantiqui",
                        "latitude": "10.92444444",
                        "longitude": "124.41527778"
                    },
                    {
                        "id": 148187,
                        "name": "Basud",
                        "latitude": "11.36638889",
                        "longitude": "124.36305556"
                    },
                    {
                        "id": 148067,
                        "name": "Bilwang",
                        "latitude": "10.88333333",
                        "longitude": "124.46666667"
                    },
                    {
                        "id": 148185,
                        "name": "Bitanjuan",
                        "latitude": "10.59555556",
                        "longitude": "124.76638889"
                    },
                    {
                        "id": 148075,
                        "name": "Bugho",
                        "latitude": "10.79222222",
                        "longitude": "124.93638889"
                    },
                    {
                        "id": 148120,
                        "name": "Bugko",
                        "latitude": "12.53555556",
                        "longitude": "124.79222222"
                    },
                    {
                        "id": 148041,
                        "name": "Bunga",
                        "latitude": "11.48388889",
                        "longitude": "124.59166667"
                    },
                    {
                        "id": 148045,
                        "name": "Butazon",
                        "latitude": "11.30722222",
                        "longitude": "124.46194444"
                    },
                    {
                        "id": 148132,
                        "name": "Cabacuñgan",
                        "latitude": "10.93333333",
                        "longitude": "124.98166667"
                    },
                    {
                        "id": 148121,
                        "name": "Cabay",
                        "latitude": "11.44555556",
                        "longitude": "125.49333333"
                    },
                    {
                        "id": 147974,
                        "name": "Cabodiongan",
                        "latitude": "12.66416667",
                        "longitude": "125.04555556"
                    },
                    {
                        "id": 148044,
                        "name": "Cagamotan",
                        "latitude": "12.35583333",
                        "longitude": "125.28388889"
                    },
                    {
                        "id": 148046,
                        "name": "Calape",
                        "latitude": "11.94250000",
                        "longitude": "125.02138889"
                    },
                    {
                        "id": 148131,
                        "name": "Calbayog",
                        "latitude": "12.06666667",
                        "longitude": "124.60000000"
                    },
                    {
                        "id": 147971,
                        "name": "Canhandugan",
                        "latitude": "11.13500000",
                        "longitude": "124.77972222"
                    },
                    {
                        "id": 148042,
                        "name": "Caraycaray",
                        "latitude": "11.55500000",
                        "longitude": "124.41500000"
                    },
                    {
                        "id": 148117,
                        "name": "Caridad",
                        "latitude": "10.83138889",
                        "longitude": "124.75166667"
                    },
                    {
                        "id": 148078,
                        "name": "Cavite",
                        "latitude": "11.21472222",
                        "longitude": "124.82305556"
                    },
                    {
                        "id": 148192,
                        "name": "Consuegra",
                        "latitude": "11.29750000",
                        "longitude": "124.51250000"
                    },
                    {
                        "id": 148052,
                        "name": "Culasian",
                        "latitude": "11.30694444",
                        "longitude": "124.61055556"
                    },
                    {
                        "id": 148128,
                        "name": "Dapdap",
                        "latitude": "12.06194444",
                        "longitude": "125.48805556"
                    },
                    {
                        "id": 148211,
                        "name": "Doos",
                        "latitude": "10.46527778",
                        "longitude": "124.72944444"
                    },
                    {
                        "id": 148191,
                        "name": "Erenas",
                        "latitude": "12.42444444",
                        "longitude": "124.32388889"
                    },
                    {
                        "id": 148116,
                        "name": "Gabas",
                        "latitude": "10.72972222",
                        "longitude": "124.79611111"
                    },
                    {
                        "id": 148055,
                        "name": "Ginabuyan",
                        "latitude": "11.23833333",
                        "longitude": "124.40472222"
                    },
                    {
                        "id": 148086,
                        "name": "Gubang",
                        "latitude": "10.64000000",
                        "longitude": "124.86805556"
                    },
                    {
                        "id": 148125,
                        "name": "Guindapunan",
                        "latitude": "11.30277778",
                        "longitude": "124.70583333"
                    },
                    {
                        "id": 147972,
                        "name": "Guirang",
                        "latitude": "11.35000000",
                        "longitude": "125.11666667"
                    },
                    {
                        "id": 148122,
                        "name": "Hingatungan",
                        "latitude": "10.58388889",
                        "longitude": "125.18527778"
                    },
                    {
                        "id": 148026,
                        "name": "Hipadpad",
                        "latitude": "12.28555556",
                        "longitude": "125.23611111"
                    },
                    {
                        "id": 148048,
                        "name": "Hipasngo",
                        "latitude": "10.66250000",
                        "longitude": "124.80861111"
                    },
                    {
                        "id": 148040,
                        "name": "Ibarra",
                        "latitude": "10.12472222",
                        "longitude": "124.88416667"
                    },
                    {
                        "id": 148051,
                        "name": "Inangatan",
                        "latitude": "11.25000000",
                        "longitude": "124.40000000"
                    },
                    {
                        "id": 148137,
                        "name": "Ipil",
                        "latitude": "10.97472000",
                        "longitude": "124.63639000"
                    },
                    {
                        "id": 148028,
                        "name": "Jubasan",
                        "latitude": "12.48444444",
                        "longitude": "124.28722222"
                    },
                    {
                        "id": 148027,
                        "name": "Kabuynan",
                        "latitude": "11.08055556",
                        "longitude": "125.02472222"
                    },
                    {
                        "id": 148035,
                        "name": "Kampokpok",
                        "latitude": "11.29611111",
                        "longitude": "124.40500000"
                    },
                    {
                        "id": 148143,
                        "name": "Kilim",
                        "latitude": "10.71166667",
                        "longitude": "124.79666667"
                    },
                    {
                        "id": 148196,
                        "name": "Lalauigan",
                        "latitude": "11.58916667",
                        "longitude": "125.46972222"
                    },
                    {
                        "id": 148032,
                        "name": "Lamak",
                        "latitude": "10.39972222",
                        "longitude": "124.73888889"
                    },
                    {
                        "id": 148197,
                        "name": "Lao",
                        "latitude": "11.01806000",
                        "longitude": "124.55972000"
                    },
                    {
                        "id": 148037,
                        "name": "Libas",
                        "latitude": "10.93888889",
                        "longitude": "124.54500000"
                    },
                    {
                        "id": 147968,
                        "name": "Liberty",
                        "latitude": "10.87416667",
                        "longitude": "125.00250000"
                    },
                    {
                        "id": 148112,
                        "name": "Lim-oo",
                        "latitude": "11.15083333",
                        "longitude": "124.63083333"
                    },
                    {
                        "id": 148036,
                        "name": "Limon",
                        "latitude": "11.28888889",
                        "longitude": "124.56722222"
                    },
                    {
                        "id": 148088,
                        "name": "Lubi",
                        "latitude": "10.96666667",
                        "longitude": "124.78333333"
                    },
                    {
                        "id": 148076,
                        "name": "Mahagnao",
                        "latitude": "10.98333000",
                        "longitude": "124.88333000"
                    },
                    {
                        "id": 148199,
                        "name": "Makiwalo",
                        "latitude": "12.51000000",
                        "longitude": "124.70611111"
                    },
                    {
                        "id": 148138,
                        "name": "Malaga",
                        "latitude": "12.23694444",
                        "longitude": "124.37527778"
                    },
                    {
                        "id": 148144,
                        "name": "Malajog",
                        "latitude": "12.11027778",
                        "longitude": "124.47916667"
                    },
                    {
                        "id": 148146,
                        "name": "Mantang",
                        "latitude": "11.87000000",
                        "longitude": "125.42833333"
                    },
                    {
                        "id": 148148,
                        "name": "Margen",
                        "latitude": "11.01722000",
                        "longitude": "124.52833000"
                    },
                    {
                        "id": 148030,
                        "name": "Masarayao",
                        "latitude": "11.08972222",
                        "longitude": "124.61750000"
                    },
                    {
                        "id": 148194,
                        "name": "Matlang",
                        "latitude": "10.89027778",
                        "longitude": "124.45527778"
                    },
                    {
                        "id": 148147,
                        "name": "Maypangdan",
                        "latitude": "11.65194444",
                        "longitude": "125.45027778"
                    },
                    {
                        "id": 148024,
                        "name": "Naghalin",
                        "latitude": "11.14555556",
                        "longitude": "124.56722222"
                    },
                    {
                        "id": 148169,
                        "name": "Napuro",
                        "latitude": "12.02722222",
                        "longitude": "124.70833333"
                    },
                    {
                        "id": 148205,
                        "name": "Nena",
                        "latitude": "11.76583333",
                        "longitude": "125.41777778"
                    },
                    {
                        "id": 148154,
                        "name": "Nenita",
                        "latitude": "12.49166667",
                        "longitude": "124.80444444"
                    },
                    {
                        "id": 147998,
                        "name": "Palanit",
                        "latitude": "12.32138889",
                        "longitude": "124.34333333"
                    },
                    {
                        "id": 148155,
                        "name": "Palaroo",
                        "latitude": "11.40555556",
                        "longitude": "124.48305556"
                    },
                    {
                        "id": 148015,
                        "name": "Palhi",
                        "latitude": "10.64972222",
                        "longitude": "124.80611111"
                    },
                    {
                        "id": 148007,
                        "name": "Panalanoy",
                        "latitude": "11.25111111",
                        "longitude": "125.00638889"
                    },
                    {
                        "id": 148009,
                        "name": "Pangdan",
                        "latitude": "11.79166667",
                        "longitude": "124.87722222"
                    },
                    {
                        "id": 148204,
                        "name": "Pangpang",
                        "latitude": "12.56916667",
                        "longitude": "125.07388889"
                    },
                    {
                        "id": 148091,
                        "name": "Pasay",
                        "latitude": "10.11443000",
                        "longitude": "124.89563000"
                    },
                    {
                        "id": 148166,
                        "name": "Patong",
                        "latitude": "12.33638889",
                        "longitude": "125.28527778"
                    },
                    {
                        "id": 148002,
                        "name": "Pawing",
                        "latitude": "11.18000000",
                        "longitude": "125.00277778"
                    },
                    {
                        "id": 148151,
                        "name": "Piña",
                        "latitude": "12.19083333",
                        "longitude": "124.40138889"
                    },
                    {
                        "id": 148165,
                        "name": "Pinamopoan",
                        "latitude": "11.31472222",
                        "longitude": "124.57388889"
                    },
                    {
                        "id": 148087,
                        "name": "Pinangomhan",
                        "latitude": "11.48944444",
                        "longitude": "124.46166667"
                    },
                    {
                        "id": 148152,
                        "name": "Polahongon",
                        "latitude": "10.52888889",
                        "longitude": "124.96944444"
                    },
                    {
                        "id": 148167,
                        "name": "Polañge",
                        "latitude": "12.39666667",
                        "longitude": "124.63111111"
                    },
                    {
                        "id": 148011,
                        "name": "Puerto Bello",
                        "latitude": "10.97333333",
                        "longitude": "124.53500000"
                    },
                    {
                        "id": 147988,
                        "name": "Sabang",
                        "latitude": "12.07472222",
                        "longitude": "124.54138889"
                    },
                    {
                        "id": 148170,
                        "name": "Salvacion",
                        "latitude": "12.61500000",
                        "longitude": "125.03888889"
                    },
                    {
                        "id": 148006,
                        "name": "San Eduardo",
                        "latitude": "12.16777778",
                        "longitude": "125.45027778"
                    },
                    {
                        "id": 148092,
                        "name": "San Policarpio",
                        "latitude": "12.06861111",
                        "longitude": "124.56944444"
                    },
                    {
                        "id": 147993,
                        "name": "Siguinon",
                        "latitude": "10.94222222",
                        "longitude": "124.68055556"
                    },
                    {
                        "id": 148181,
                        "name": "Silanga",
                        "latitude": "11.81805556",
                        "longitude": "124.84305556"
                    },
                    {
                        "id": 147992,
                        "name": "Sulangan",
                        "latitude": "10.93611111",
                        "longitude": "125.82638889"
                    },
                    {
                        "id": 148206,
                        "name": "Tabing",
                        "latitude": "11.40000000",
                        "longitude": "124.35000000"
                    },
                    {
                        "id": 148207,
                        "name": "Tagbubungang Diot",
                        "latitude": "11.12583333",
                        "longitude": "124.40277778"
                    },
                    {
                        "id": 148081,
                        "name": "Tibur",
                        "latitude": "11.17560000",
                        "longitude": "124.38690000"
                    },
                    {
                        "id": 148174,
                        "name": "Tinambacan",
                        "latitude": "12.09416667",
                        "longitude": "124.50250000"
                    },
                    {
                        "id": 148180,
                        "name": "Tucdao",
                        "latitude": "11.70111111",
                        "longitude": "124.47194444"
                    },
                    {
                        "id": 148172,
                        "name": "Tugbong",
                        "latitude": "11.01666667",
                        "longitude": "124.60000000"
                    },
                    {
                        "id": 147990,
                        "name": "Tutubigan",
                        "latitude": "11.83972222",
                        "longitude": "125.06138889"
                    },
                    {
                        "id": 148210,
                        "name": "Umaganhan",
                        "latitude": "11.32916667",
                        "longitude": "124.37694444"
                    },
                    {
                        "id": 147989,
                        "name": "Viriato",
                        "latitude": "12.29027778",
                        "longitude": "124.35333333"
                    },
                    {
                        "id": 148175,
                        "name": "Wright",
                        "latitude": "11.77027778",
                        "longitude": "125.02194444"
                    }
                ]
            },
            {
                "id": 1303,
                "name": "Guimaras",
                "iso2": "GUI",
                "latitude": "10.59286610",
                "longitude": "122.63250810",
                "type": "province",
                "cities": [
                    {
                        "id": 81828,
                        "name": "Buenavista",
                        "latitude": "10.69045770",
                        "longitude": "122.58102410"
                    },
                    {
                        "id": 82810,
                        "name": "Jordan",
                        "latitude": "10.60930520",
                        "longitude": "122.48744660"
                    },
                    {
                        "id": 83827,
                        "name": "Nueva Valencia",
                        "latitude": "10.43014400",
                        "longitude": "122.46056150"
                    },
                    {
                        "id": 146066,
                        "name": "San Lorenzo",
                        "latitude": "10.59432590",
                        "longitude": "122.58412170"
                    },
                    {
                        "id": 154540,
                        "name": "Sibunag",
                        "latitude": "10.48821720",
                        "longitude": "122.47479730"
                    }
                ]
            },
            {
                "id": 1300,
                "name": "Ifugao",
                "iso2": "IFU",
                "latitude": "16.83307920",
                "longitude": "121.17103890",
                "type": "province",
                "cities": [
                    {
                        "id": 154541,
                        "name": "Aguinaldo",
                        "latitude": "16.92878200",
                        "longitude": "121.17167600"
                    },
                    {
                        "id": 154542,
                        "name": "Alfonso Lista",
                        "latitude": "16.94064700",
                        "longitude": "121.32020320"
                    },
                    {
                        "id": 154543,
                        "name": "Asipulo",
                        "latitude": "16.69006550",
                        "longitude": "120.98551840"
                    },
                    {
                        "id": 144774,
                        "name": "Banaue",
                        "latitude": "16.94323520",
                        "longitude": "121.01744740"
                    },
                    {
                        "id": 144805,
                        "name": "Hingyon",
                        "latitude": "16.85680780",
                        "longitude": "121.00416770"
                    },
                    {
                        "id": 144806,
                        "name": "Hungduan",
                        "latitude": "16.88220070",
                        "longitude": "120.89131660"
                    },
                    {
                        "id": 144812,
                        "name": "Kiangan",
                        "latitude": "16.77028280",
                        "longitude": "121.01192200"
                    },
                    {
                        "id": 144818,
                        "name": "Lagawe",
                        "latitude": "16.78546210",
                        "longitude": "121.04520170"
                    },
                    {
                        "id": 144820,
                        "name": "Lamut",
                        "latitude": "16.69631250",
                        "longitude": "121.13319010"
                    },
                    {
                        "id": 144833,
                        "name": "Mayoyao",
                        "latitude": "16.87244660",
                        "longitude": "121.08883850"
                    },
                    {
                        "id": 144869,
                        "name": "Tinoc",
                        "latitude": "16.69794090",
                        "longitude": "120.87724300"
                    }
                ]
            },
            {
                "id": 1355,
                "name": "Ilocos",
                "iso2": "01",
                "latitude": "16.08321440",
                "longitude": "120.61998950",
                "type": "region",
                "cities": [
                    {
                        "id": 81142,
                        "name": "Acao",
                        "latitude": "16.52556000",
                        "longitude": "120.37639000"
                    },
                    {
                        "id": 81179,
                        "name": "Alac",
                        "latitude": "15.98770000",
                        "longitude": "120.80650000"
                    },
                    {
                        "id": 81223,
                        "name": "Allangigan Primero",
                        "latitude": "17.17393000",
                        "longitude": "120.49195000"
                    },
                    {
                        "id": 81230,
                        "name": "Aloleng",
                        "latitude": "16.13070000",
                        "longitude": "119.78240000"
                    },
                    {
                        "id": 81241,
                        "name": "Amagbagan",
                        "latitude": "16.09140000",
                        "longitude": "120.52320000"
                    },
                    {
                        "id": 81256,
                        "name": "Anambongan",
                        "latitude": "15.86634000",
                        "longitude": "120.38858000"
                    },
                    {
                        "id": 81267,
                        "name": "Angatel",
                        "latitude": "15.80589000",
                        "longitude": "120.34326000"
                    },
                    {
                        "id": 81286,
                        "name": "Anulid",
                        "latitude": "15.82563000",
                        "longitude": "120.48834000"
                    },
                    {
                        "id": 81346,
                        "name": "Baay",
                        "latitude": "18.11880000",
                        "longitude": "120.57530000"
                    },
                    {
                        "id": 81353,
                        "name": "Bacag",
                        "latitude": "15.93000000",
                        "longitude": "120.58222000"
                    },
                    {
                        "id": 81359,
                        "name": "Bacnar",
                        "latitude": "15.88641000",
                        "longitude": "120.34419000"
                    },
                    {
                        "id": 81372,
                        "name": "Bactad Proper",
                        "latitude": "15.97842000",
                        "longitude": "120.61026000"
                    },
                    {
                        "id": 81376,
                        "name": "Bacundao Weste",
                        "latitude": "15.91536000",
                        "longitude": "120.47668000"
                    },
                    {
                        "id": 81420,
                        "name": "Bail",
                        "latitude": "16.28670000",
                        "longitude": "120.40040000"
                    },
                    {
                        "id": 81476,
                        "name": "Balingasay",
                        "latitude": "16.35730000",
                        "longitude": "119.85640000"
                    },
                    {
                        "id": 81479,
                        "name": "Balingueo",
                        "latitude": "15.95830000",
                        "longitude": "120.40973000"
                    },
                    {
                        "id": 81494,
                        "name": "Balogo",
                        "latitude": "15.99032000",
                        "longitude": "120.28302000"
                    },
                    {
                        "id": 81509,
                        "name": "Baluyot",
                        "latitude": "15.79586000",
                        "longitude": "120.46088000"
                    },
                    {
                        "id": 81527,
                        "name": "Bangan-Oda",
                        "latitude": "16.10870000",
                        "longitude": "119.83070000"
                    },
                    {
                        "id": 81544,
                        "name": "Banog Sur",
                        "latitude": "16.16542000",
                        "longitude": "119.89802000"
                    },
                    {
                        "id": 81556,
                        "name": "Bantog",
                        "latitude": "16.00910000",
                        "longitude": "120.69290000"
                    },
                    {
                        "id": 81565,
                        "name": "Barangobong",
                        "latitude": "15.87778000",
                        "longitude": "120.54833000"
                    },
                    {
                        "id": 81578,
                        "name": "Baro",
                        "latitude": "15.99895000",
                        "longitude": "120.67350000"
                    },
                    {
                        "id": 81580,
                        "name": "Barong",
                        "latitude": "18.05760000",
                        "longitude": "120.73400000"
                    },
                    {
                        "id": 81606,
                        "name": "Basing",
                        "latitude": "15.98505000",
                        "longitude": "120.26831000"
                    },
                    {
                        "id": 81610,
                        "name": "Batac City",
                        "latitude": "18.05540000",
                        "longitude": "120.56489000"
                    },
                    {
                        "id": 81616,
                        "name": "Bataquil",
                        "latitude": "16.15528000",
                        "longitude": "120.52750000"
                    },
                    {
                        "id": 81658,
                        "name": "Bayaoas",
                        "latitude": "15.83404000",
                        "longitude": "120.26478000"
                    },
                    {
                        "id": 81688,
                        "name": "Bical Norte",
                        "latitude": "15.81471000",
                        "longitude": "120.43509000"
                    },
                    {
                        "id": 81698,
                        "name": "Bil-Loca",
                        "latitude": "18.08750000",
                        "longitude": "120.56870000"
                    },
                    {
                        "id": 81707,
                        "name": "Binabalian",
                        "latitude": "16.42020000",
                        "longitude": "119.92790000"
                    },
                    {
                        "id": 81717,
                        "name": "Binday",
                        "latitude": "16.12812000",
                        "longitude": "120.45238000"
                    },
                    {
                        "id": 81756,
                        "name": "Bobonan",
                        "latitude": "16.13480000",
                        "longitude": "120.52710000"
                    },
                    {
                        "id": 81762,
                        "name": "Bogtong",
                        "latitude": "15.75536000",
                        "longitude": "120.32899000"
                    },
                    {
                        "id": 81766,
                        "name": "Bolaoit",
                        "latitude": "15.93218000",
                        "longitude": "120.43073000"
                    },
                    {
                        "id": 81771,
                        "name": "Bolingit",
                        "latitude": "15.95873000",
                        "longitude": "120.34960000"
                    },
                    {
                        "id": 81778,
                        "name": "Bolo",
                        "latitude": "15.99480000",
                        "longitude": "120.16470000"
                    },
                    {
                        "id": 81806,
                        "name": "Boñgalon",
                        "latitude": "16.00022000",
                        "longitude": "120.15904000"
                    },
                    {
                        "id": 81802,
                        "name": "Botao",
                        "latitude": "15.91667000",
                        "longitude": "120.41667000"
                    },
                    {
                        "id": 81827,
                        "name": "Bued",
                        "latitude": "16.16086000",
                        "longitude": "119.99880000"
                    },
                    {
                        "id": 81835,
                        "name": "Buenlag",
                        "latitude": "15.82976000",
                        "longitude": "120.51139000"
                    },
                    {
                        "id": 81883,
                        "name": "Bulog",
                        "latitude": "15.96020000",
                        "longitude": "120.40170000"
                    },
                    {
                        "id": 81926,
                        "name": "Butubut Norte",
                        "latitude": "16.80340000",
                        "longitude": "120.43440000"
                    },
                    {
                        "id": 81932,
                        "name": "Caabiangan",
                        "latitude": "16.08740000",
                        "longitude": "119.92450000"
                    },
                    {
                        "id": 81940,
                        "name": "Cabalaoangan",
                        "latitude": "15.98333000",
                        "longitude": "120.78333000"
                    },
                    {
                        "id": 81942,
                        "name": "Cabalitian",
                        "latitude": "16.08830000",
                        "longitude": "120.79220000"
                    },
                    {
                        "id": 81972,
                        "name": "Cabittaogan",
                        "latitude": "17.57788000",
                        "longitude": "120.35914000"
                    },
                    {
                        "id": 81983,
                        "name": "Cabungan",
                        "latitude": "16.33999000",
                        "longitude": "119.99490000"
                    },
                    {
                        "id": 82047,
                        "name": "Calepaan",
                        "latitude": "16.01950000",
                        "longitude": "120.61900000"
                    },
                    {
                        "id": 82059,
                        "name": "Callaguip",
                        "latitude": "18.07139000",
                        "longitude": "120.48667000"
                    },
                    {
                        "id": 82063,
                        "name": "Calomboyan",
                        "latitude": "15.94652000",
                        "longitude": "120.30348000"
                    },
                    {
                        "id": 82064,
                        "name": "Calongbuyan",
                        "latitude": "17.16478000",
                        "longitude": "120.42716000"
                    },
                    {
                        "id": 82066,
                        "name": "Calsib",
                        "latitude": "15.84711000",
                        "longitude": "120.26412000"
                    },
                    {
                        "id": 82078,
                        "name": "Camaley",
                        "latitude": "15.99724000",
                        "longitude": "120.30107000"
                    },
                    {
                        "id": 82101,
                        "name": "Canan Norte",
                        "latitude": "15.90986000",
                        "longitude": "120.47763000"
                    },
                    {
                        "id": 82102,
                        "name": "Canaoalan",
                        "latitude": "16.02902000",
                        "longitude": "120.29641000"
                    },
                    {
                        "id": 82129,
                        "name": "Cantoria",
                        "latitude": "16.84410000",
                        "longitude": "120.40450000"
                    },
                    {
                        "id": 82136,
                        "name": "Capandanan",
                        "latitude": "15.95943000",
                        "longitude": "120.69519000"
                    },
                    {
                        "id": 82143,
                        "name": "Capulaan",
                        "latitude": "15.90497000",
                        "longitude": "120.53719000"
                    },
                    {
                        "id": 82152,
                        "name": "Caramutan",
                        "latitude": "15.92074000",
                        "longitude": "120.61012000"
                    },
                    {
                        "id": 82177,
                        "name": "Caronoan West",
                        "latitude": "16.26330000",
                        "longitude": "120.44630000"
                    },
                    {
                        "id": 82178,
                        "name": "Carot",
                        "latitude": "16.34468000",
                        "longitude": "119.98005000"
                    },
                    {
                        "id": 82183,
                        "name": "Carriedo",
                        "latitude": "16.03100000",
                        "longitude": "120.75490000"
                    },
                    {
                        "id": 82186,
                        "name": "Carusucan",
                        "latitude": "15.96589000",
                        "longitude": "120.63598000"
                    },
                    {
                        "id": 82201,
                        "name": "Catablan",
                        "latitude": "15.97570000",
                        "longitude": "120.49530000"
                    },
                    {
                        "id": 82210,
                        "name": "Caterman",
                        "latitude": "17.21738000",
                        "longitude": "120.42442000"
                    },
                    {
                        "id": 82217,
                        "name": "Cato",
                        "latitude": "15.83620000",
                        "longitude": "119.91510000"
                    },
                    {
                        "id": 82219,
                        "name": "Catuday",
                        "latitude": "16.29230000",
                        "longitude": "119.80620000"
                    },
                    {
                        "id": 82234,
                        "name": "Cayanga",
                        "latitude": "16.11508000",
                        "longitude": "120.39875000"
                    },
                    {
                        "id": 82237,
                        "name": "Cayungnan",
                        "latitude": "16.13320000",
                        "longitude": "119.83750000"
                    },
                    {
                        "id": 82266,
                        "name": "Comillas Norte",
                        "latitude": "16.95900000",
                        "longitude": "120.74690000"
                    },
                    {
                        "id": 82297,
                        "name": "Corrooy",
                        "latitude": "16.79620000",
                        "longitude": "120.44530000"
                    },
                    {
                        "id": 82339,
                        "name": "Dagup",
                        "latitude": "16.63722000",
                        "longitude": "120.44556000"
                    },
                    {
                        "id": 82363,
                        "name": "Damortis",
                        "latitude": "16.24051000",
                        "longitude": "120.40565000"
                    },
                    {
                        "id": 82386,
                        "name": "Darapidap",
                        "latitude": "17.20007000",
                        "longitude": "120.41802000"
                    },
                    {
                        "id": 82397,
                        "name": "Davila",
                        "latitude": "18.47260000",
                        "longitude": "120.57630000"
                    },
                    {
                        "id": 82416,
                        "name": "Diaz",
                        "latitude": "15.84630000",
                        "longitude": "120.83470000"
                    },
                    {
                        "id": 82426,
                        "name": "Dilan",
                        "latitude": "16.08790000",
                        "longitude": "120.52070000"
                    },
                    {
                        "id": 82456,
                        "name": "Domalanoan",
                        "latitude": "16.00292000",
                        "longitude": "120.21154000"
                    },
                    {
                        "id": 82457,
                        "name": "Domampot",
                        "latitude": "16.00000000",
                        "longitude": "120.65000000"
                    },
                    {
                        "id": 82459,
                        "name": "Don Pedro",
                        "latitude": "15.88518000",
                        "longitude": "120.43036000"
                    },
                    {
                        "id": 82463,
                        "name": "Dorongan Punta",
                        "latitude": "15.81476000",
                        "longitude": "120.32266000"
                    },
                    {
                        "id": 82466,
                        "name": "Doyong",
                        "latitude": "15.97224000",
                        "longitude": "120.35386000"
                    },
                    {
                        "id": 82479,
                        "name": "Dulig",
                        "latitude": "16.00212000",
                        "longitude": "120.16864000"
                    },
                    {
                        "id": 82494,
                        "name": "Dumpay",
                        "latitude": "15.88295000",
                        "longitude": "120.38899000"
                    },
                    {
                        "id": 82504,
                        "name": "Eguia",
                        "latitude": "15.90650000",
                        "longitude": "119.88580000"
                    },
                    {
                        "id": 82515,
                        "name": "Esmeralda",
                        "latitude": "15.86722000",
                        "longitude": "120.71500000"
                    },
                    {
                        "id": 82524,
                        "name": "Espiritu",
                        "latitude": "17.98090000",
                        "longitude": "120.65690000"
                    },
                    {
                        "id": 82541,
                        "name": "Fuerte",
                        "latitude": "17.53418000",
                        "longitude": "120.36950000"
                    },
                    {
                        "id": 82574,
                        "name": "Gayaman",
                        "latitude": "16.01402000",
                        "longitude": "120.30757000"
                    },
                    {
                        "id": 82624,
                        "name": "Guiling",
                        "latitude": "15.84295000",
                        "longitude": "120.61513000"
                    },
                    {
                        "id": 82646,
                        "name": "Guiset East",
                        "latitude": "16.06667000",
                        "longitude": "120.68333000"
                    },
                    {
                        "id": 82663,
                        "name": "Hacienda",
                        "latitude": "15.93600000",
                        "longitude": "120.17860000"
                    },
                    {
                        "id": 82675,
                        "name": "Halog West",
                        "latitude": "16.36680000",
                        "longitude": "120.41470000"
                    },
                    {
                        "id": 82730,
                        "name": "Ilioilio",
                        "latitude": "15.96160000",
                        "longitude": "119.76580000"
                    },
                    {
                        "id": 82739,
                        "name": "Inabaan Sur",
                        "latitude": "16.26300000",
                        "longitude": "120.47810000"
                    },
                    {
                        "id": 82771,
                        "name": "Isla",
                        "latitude": "15.89507000",
                        "longitude": "120.30137000"
                    },
                    {
                        "id": 82959,
                        "name": "Labayug",
                        "latitude": "16.15280000",
                        "longitude": "120.56610000"
                    },
                    {
                        "id": 82960,
                        "name": "Labney",
                        "latitude": "16.10280000",
                        "longitude": "120.46550000"
                    },
                    {
                        "id": 82974,
                        "name": "Lagasit",
                        "latitude": "15.99340000",
                        "longitude": "120.79400000"
                    },
                    {
                        "id": 82981,
                        "name": "Laguit Centro",
                        "latitude": "15.94720000",
                        "longitude": "120.19040000"
                    },
                    {
                        "id": 83068,
                        "name": "Leones East",
                        "latitude": "16.36330000",
                        "longitude": "120.39190000"
                    },
                    {
                        "id": 83069,
                        "name": "Lepa",
                        "latitude": "15.88438000",
                        "longitude": "120.45089000"
                    },
                    {
                        "id": 83080,
                        "name": "Libas",
                        "latitude": "15.87789000",
                        "longitude": "120.31633000"
                    },
                    {
                        "id": 83142,
                        "name": "Linmansangan",
                        "latitude": "15.82980000",
                        "longitude": "120.29593000"
                    },
                    {
                        "id": 83154,
                        "name": "Lloren",
                        "latitude": "16.33310000",
                        "longitude": "120.43290000"
                    },
                    {
                        "id": 83160,
                        "name": "Lobong",
                        "latitude": "16.08150000",
                        "longitude": "120.47040000"
                    },
                    {
                        "id": 83167,
                        "name": "Longos",
                        "latitude": "16.10734000",
                        "longitude": "120.39658000"
                    },
                    {
                        "id": 83181,
                        "name": "Loqueb Este",
                        "latitude": "15.94481000",
                        "longitude": "120.44607000"
                    },
                    {
                        "id": 83196,
                        "name": "Lucap",
                        "latitude": "16.19038000",
                        "longitude": "120.00221000"
                    },
                    {
                        "id": 83202,
                        "name": "Lucero",
                        "latitude": "16.40510000",
                        "longitude": "119.91240000"
                    },
                    {
                        "id": 83237,
                        "name": "Lunec",
                        "latitude": "15.95395000",
                        "longitude": "120.48949000"
                    },
                    {
                        "id": 83240,
                        "name": "Lungog",
                        "latitude": "17.46450000",
                        "longitude": "120.47840000"
                    },
                    {
                        "id": 83249,
                        "name": "Lusong",
                        "latitude": "16.86700000",
                        "longitude": "120.44200000"
                    },
                    {
                        "id": 83271,
                        "name": "Mabilao",
                        "latitude": "16.15351000",
                        "longitude": "120.42494000"
                    },
                    {
                        "id": 83272,
                        "name": "Mabilbila Sur",
                        "latitude": "17.50709000",
                        "longitude": "120.44100000"
                    },
                    {
                        "id": 83278,
                        "name": "Mabini",
                        "latitude": "16.06990000",
                        "longitude": "119.93910000"
                    },
                    {
                        "id": 83290,
                        "name": "Mabusag",
                        "latitude": "17.92610000",
                        "longitude": "120.49760000"
                    },
                    {
                        "id": 83295,
                        "name": "Macabuboni",
                        "latitude": "16.19090000",
                        "longitude": "119.78020000"
                    },
                    {
                        "id": 83300,
                        "name": "Macalong",
                        "latitude": "16.01370000",
                        "longitude": "120.65860000"
                    },
                    {
                        "id": 83301,
                        "name": "Macalva Norte",
                        "latitude": "16.34850000",
                        "longitude": "120.38660000"
                    },
                    {
                        "id": 83305,
                        "name": "Macayug",
                        "latitude": "16.09376000",
                        "longitude": "120.43201000"
                    },
                    {
                        "id": 83347,
                        "name": "Magtaking",
                        "latitude": "15.98540000",
                        "longitude": "120.18320000"
                    },
                    {
                        "id": 83381,
                        "name": "Malabago",
                        "latitude": "15.98154000",
                        "longitude": "120.35913000"
                    },
                    {
                        "id": 83400,
                        "name": "Malanay",
                        "latitude": "16.00865000",
                        "longitude": "120.40940000"
                    },
                    {
                        "id": 83413,
                        "name": "Malawa",
                        "latitude": "15.95804000",
                        "longitude": "120.27782000"
                    },
                    {
                        "id": 83425,
                        "name": "Malibong East",
                        "latitude": "15.84660000",
                        "longitude": "120.32690000"
                    },
                    {
                        "id": 83554,
                        "name": "Mapolopolo",
                        "latitude": "15.88087000",
                        "longitude": "120.37422000"
                    },
                    {
                        "id": 83627,
                        "name": "Maticmatic",
                        "latitude": "15.98630000",
                        "longitude": "120.45192000"
                    },
                    {
                        "id": 83685,
                        "name": "Minien East",
                        "latitude": "15.97723000",
                        "longitude": "120.48127000"
                    },
                    {
                        "id": 83743,
                        "name": "Nagbacalan",
                        "latitude": "18.11590000",
                        "longitude": "120.52350000"
                    },
                    {
                        "id": 83750,
                        "name": "Nagsaing",
                        "latitude": "15.98069000",
                        "longitude": "120.33787000"
                    },
                    {
                        "id": 83752,
                        "name": "Naguelguel",
                        "latitude": "16.00585000",
                        "longitude": "120.26351000"
                    },
                    {
                        "id": 83753,
                        "name": "Naguilayan",
                        "latitude": "16.00304000",
                        "longitude": "120.29108000"
                    },
                    {
                        "id": 83761,
                        "name": "Nalsian Norte",
                        "latitude": "15.84476000",
                        "longitude": "120.45084000"
                    },
                    {
                        "id": 83764,
                        "name": "Nama",
                        "latitude": "16.14120000",
                        "longitude": "120.54260000"
                    },
                    {
                        "id": 83766,
                        "name": "Namboongan",
                        "latitude": "16.30330000",
                        "longitude": "120.37580000"
                    },
                    {
                        "id": 83769,
                        "name": "Nancalobasaan",
                        "latitude": "15.93420000",
                        "longitude": "120.84260000"
                    },
                    {
                        "id": 83794,
                        "name": "Navatat",
                        "latitude": "15.84971000",
                        "longitude": "120.39054000"
                    },
                    {
                        "id": 83814,
                        "name": "Nibaliw Central",
                        "latitude": "16.12750000",
                        "longitude": "120.40270000"
                    },
                    {
                        "id": 83816,
                        "name": "Nilombot",
                        "latitude": "16.03060000",
                        "longitude": "120.43685000"
                    },
                    {
                        "id": 83817,
                        "name": "Ninoy",
                        "latitude": "15.85960000",
                        "longitude": "120.24780000"
                    },
                    {
                        "id": 83834,
                        "name": "Oaqui",
                        "latitude": "16.85830000",
                        "longitude": "120.41240000"
                    },
                    {
                        "id": 83850,
                        "name": "Olea",
                        "latitude": "15.86237000",
                        "longitude": "120.49366000"
                    },
                    {
                        "id": 83880,
                        "name": "Padong",
                        "latitude": "18.05435000",
                        "longitude": "120.75427000"
                    },
                    {
                        "id": 83895,
                        "name": "Pagsanahan Norte",
                        "latitude": "17.91930000",
                        "longitude": "120.44580000"
                    },
                    {
                        "id": 83902,
                        "name": "Paitan Este",
                        "latitude": "16.08532000",
                        "longitude": "120.03164000"
                    },
                    {
                        "id": 83907,
                        "name": "Palacpalac",
                        "latitude": "16.13120000",
                        "longitude": "120.53050000"
                    },
                    {
                        "id": 83919,
                        "name": "Paldit",
                        "latitude": "16.16667000",
                        "longitude": "120.53333000"
                    },
                    {
                        "id": 83921,
                        "name": "Palguyod",
                        "latitude": "16.12270000",
                        "longitude": "120.52000000"
                    },
                    {
                        "id": 83973,
                        "name": "Pangapisan",
                        "latitude": "16.21600000",
                        "longitude": "119.95700000"
                    },
                    {
                        "id": 83974,
                        "name": "Pangascasan",
                        "latitude": "16.11691000",
                        "longitude": "120.08664000"
                    },
                    {
                        "id": 83980,
                        "name": "Pangpang",
                        "latitude": "15.93875000",
                        "longitude": "120.30939000"
                    },
                    {
                        "id": 84022,
                        "name": "Paringao",
                        "latitude": "16.57167000",
                        "longitude": "120.32417000"
                    },
                    {
                        "id": 84023,
                        "name": "Parioc Segundo",
                        "latitude": "17.17503000",
                        "longitude": "120.46576000"
                    },
                    {
                        "id": 84029,
                        "name": "Pasibi West",
                        "latitude": "15.85870000",
                        "longitude": "120.37935000"
                    },
                    {
                        "id": 84041,
                        "name": "Patayac",
                        "latitude": "15.96300000",
                        "longitude": "120.42251000"
                    },
                    {
                        "id": 84051,
                        "name": "Patpata Segundo",
                        "latitude": "17.18333000",
                        "longitude": "120.43333000"
                    },
                    {
                        "id": 84069,
                        "name": "Payocpoc Sur",
                        "latitude": "16.49444000",
                        "longitude": "120.32806000"
                    },
                    {
                        "id": 84109,
                        "name": "Pindangan Centro",
                        "latitude": "15.86056000",
                        "longitude": "120.55139000"
                    },
                    {
                        "id": 84139,
                        "name": "Pogonsili",
                        "latitude": "15.82048000",
                        "longitude": "120.26017000"
                    },
                    {
                        "id": 84147,
                        "name": "Polo",
                        "latitude": "16.19630000",
                        "longitude": "119.94910000"
                    },
                    {
                        "id": 84152,
                        "name": "Polong",
                        "latitude": "15.97710000",
                        "longitude": "120.20090000"
                    },
                    {
                        "id": 84153,
                        "name": "Polong Norte",
                        "latitude": "15.90300000",
                        "longitude": "120.42149000"
                    },
                    {
                        "id": 84210,
                        "name": "Province of Ilocos Norte",
                        "latitude": "18.16667000",
                        "longitude": "120.75000000"
                    },
                    {
                        "id": 84211,
                        "name": "Province of Ilocos Sur",
                        "latitude": "17.19852000",
                        "longitude": "120.54199000"
                    },
                    {
                        "id": 84214,
                        "name": "Province of La Union",
                        "latitude": "16.50000000",
                        "longitude": "120.41667000"
                    },
                    {
                        "id": 84233,
                        "name": "Province of Pangasinan",
                        "latitude": "15.91667000",
                        "longitude": "120.33333000"
                    },
                    {
                        "id": 84255,
                        "name": "Pudoc",
                        "latitude": "16.92150000",
                        "longitude": "120.42350000"
                    },
                    {
                        "id": 84256,
                        "name": "Pudoc North",
                        "latitude": "17.60960000",
                        "longitude": "120.36852000"
                    },
                    {
                        "id": 84257,
                        "name": "Puelay",
                        "latitude": "15.88683000",
                        "longitude": "120.57358000"
                    },
                    {
                        "id": 84287,
                        "name": "Puro Pinget",
                        "latitude": "17.67967000",
                        "longitude": "120.35883000"
                    },
                    {
                        "id": 84304,
                        "name": "Quiling",
                        "latitude": "18.06833000",
                        "longitude": "120.54389000"
                    },
                    {
                        "id": 84309,
                        "name": "Quinarayan",
                        "latitude": "17.44410000",
                        "longitude": "120.47220000"
                    },
                    {
                        "id": 84311,
                        "name": "Quintong",
                        "latitude": "15.95581000",
                        "longitude": "120.32171000"
                    },
                    {
                        "id": 84327,
                        "name": "Ranao",
                        "latitude": "16.20760000",
                        "longitude": "119.81550000"
                    },
                    {
                        "id": 84338,
                        "name": "Rimus",
                        "latitude": "16.87640000",
                        "longitude": "120.39660000"
                    },
                    {
                        "id": 84340,
                        "name": "Rissing",
                        "latitude": "16.87520000",
                        "longitude": "120.43450000"
                    },
                    {
                        "id": 84374,
                        "name": "Sablig",
                        "latitude": "16.26887000",
                        "longitude": "119.98770000"
                    },
                    {
                        "id": 84393,
                        "name": "Sagud-Bahley",
                        "latitude": "16.11693000",
                        "longitude": "120.39105000"
                    },
                    {
                        "id": 84397,
                        "name": "Sagunto",
                        "latitude": "16.20070000",
                        "longitude": "120.51490000"
                    },
                    {
                        "id": 84429,
                        "name": "Samon",
                        "latitude": "15.93495000",
                        "longitude": "120.65074000"
                    },
                    {
                        "id": 84471,
                        "name": "San Eugenio",
                        "latitude": "16.35980000",
                        "longitude": "120.35700000"
                    },
                    {
                        "id": 84493,
                        "name": "San Gabriel First",
                        "latitude": "15.76650000",
                        "longitude": "120.45655000"
                    },
                    {
                        "id": 84589,
                        "name": "San Pedro Apartado",
                        "latitude": "15.83702000",
                        "longitude": "120.56521000"
                    },
                    {
                        "id": 84636,
                        "name": "Sanlibo",
                        "latitude": "15.91667000",
                        "longitude": "120.55000000"
                    },
                    {
                        "id": 84847,
                        "name": "Sonquil",
                        "latitude": "15.98814000",
                        "longitude": "120.39057000"
                    },
                    {
                        "id": 84856,
                        "name": "Subusub",
                        "latitude": "16.22689000",
                        "longitude": "120.49513000"
                    },
                    {
                        "id": 84873,
                        "name": "Sumabnit",
                        "latitude": "16.03030000",
                        "longitude": "120.58320000"
                    },
                    {
                        "id": 84884,
                        "name": "Suso",
                        "latitude": "17.35940000",
                        "longitude": "120.46110000"
                    },
                    {
                        "id": 84900,
                        "name": "Tablac",
                        "latitude": "17.21568000",
                        "longitude": "120.45428000"
                    },
                    {
                        "id": 84915,
                        "name": "Tabug",
                        "latitude": "18.03430000",
                        "longitude": "120.54880000"
                    },
                    {
                        "id": 84993,
                        "name": "Talospatang",
                        "latitude": "15.91701000",
                        "longitude": "120.44141000"
                    },
                    {
                        "id": 84995,
                        "name": "Taloy",
                        "latitude": "15.92410000",
                        "longitude": "120.39649000"
                    },
                    {
                        "id": 85002,
                        "name": "Tamayo",
                        "latitude": "15.87746000",
                        "longitude": "120.28455000"
                    },
                    {
                        "id": 85020,
                        "name": "Tamorong",
                        "latitude": "17.33333000",
                        "longitude": "120.43333000"
                    },
                    {
                        "id": 85033,
                        "name": "Tandoc",
                        "latitude": "15.95929000",
                        "longitude": "120.32914000"
                    },
                    {
                        "id": 85041,
                        "name": "Tanolong",
                        "latitude": "15.80411000",
                        "longitude": "120.41409000"
                    },
                    {
                        "id": 85085,
                        "name": "Tebag East",
                        "latitude": "15.98123000",
                        "longitude": "120.46740000"
                    },
                    {
                        "id": 85088,
                        "name": "Telbang",
                        "latitude": "16.17241000",
                        "longitude": "120.06074000"
                    },
                    {
                        "id": 85100,
                        "name": "Tiep",
                        "latitude": "16.23820000",
                        "longitude": "119.86090000"
                    },
                    {
                        "id": 85153,
                        "name": "Toboy",
                        "latitude": "16.02710000",
                        "longitude": "120.63690000"
                    },
                    {
                        "id": 85154,
                        "name": "Tobuan",
                        "latitude": "16.05562000",
                        "longitude": "120.11024000"
                    },
                    {
                        "id": 85155,
                        "name": "Tococ East",
                        "latitude": "15.82498000",
                        "longitude": "120.42605000"
                    },
                    {
                        "id": 85156,
                        "name": "Tocok",
                        "latitude": "15.75000000",
                        "longitude": "120.30000000"
                    },
                    {
                        "id": 85162,
                        "name": "Tombod",
                        "latitude": "15.93168000",
                        "longitude": "120.56721000"
                    },
                    {
                        "id": 85167,
                        "name": "Tondol",
                        "latitude": "16.31040000",
                        "longitude": "120.01310000"
                    },
                    {
                        "id": 85171,
                        "name": "Toritori",
                        "latitude": "16.23827000",
                        "longitude": "119.99561000"
                    },
                    {
                        "id": 85249,
                        "name": "Umanday Centro",
                        "latitude": "15.93800000",
                        "longitude": "120.21530000"
                    },
                    {
                        "id": 85261,
                        "name": "Unzad",
                        "latitude": "15.91889000",
                        "longitude": "120.53917000"
                    },
                    {
                        "id": 85273,
                        "name": "Uyong",
                        "latitude": "16.05002000",
                        "longitude": "120.12074000"
                    }
                ]
            },
            {
                "id": 1298,
                "name": "Ilocos Norte",
                "iso2": "ILN",
                "latitude": "18.16472810",
                "longitude": "120.71155920",
                "type": "province",
                "cities": [
                    {
                        "id": 145786,
                        "name": "Adams",
                        "latitude": "18.43902960",
                        "longitude": "120.83394140"
                    },
                    {
                        "id": 145806,
                        "name": "Bacarra",
                        "latitude": "18.25832460",
                        "longitude": "120.52870080"
                    },
                    {
                        "id": 145811,
                        "name": "Badoc",
                        "latitude": "17.91022520",
                        "longitude": "120.41798330"
                    },
                    {
                        "id": 145823,
                        "name": "Bangui",
                        "latitude": "18.46727860",
                        "longitude": "120.67103470"
                    },
                    {
                        "id": 145825,
                        "name": "Banna",
                        "latitude": "17.97950230",
                        "longitude": "120.57816580"
                    },
                    {
                        "id": 145835,
                        "name": "Batac",
                        "latitude": "18.03211930",
                        "longitude": "120.49237710"
                    },
                    {
                        "id": 145860,
                        "name": "Burgos",
                        "latitude": "18.46357390",
                        "longitude": "120.56095410"
                    },
                    {
                        "id": 145887,
                        "name": "Carasi",
                        "latitude": "18.23050040",
                        "longitude": "120.80123980"
                    },
                    {
                        "id": 145905,
                        "name": "Currimao",
                        "latitude": "18.01890000",
                        "longitude": "120.45959350"
                    },
                    {
                        "id": 145914,
                        "name": "Dingras",
                        "latitude": "18.07588870",
                        "longitude": "120.66133490"
                    },
                    {
                        "id": 145921,
                        "name": "Dumalneg",
                        "latitude": "18.47308420",
                        "longitude": "120.79636650"
                    },
                    {
                        "id": 145944,
                        "name": "Laoag",
                        "latitude": "18.19826940",
                        "longitude": "120.51527430"
                    },
                    {
                        "id": 145982,
                        "name": "Marcos",
                        "latitude": "18.02988670",
                        "longitude": "120.61931440"
                    },
                    {
                        "id": 146001,
                        "name": "Nueva Era",
                        "latitude": "17.95021590",
                        "longitude": "120.41440590"
                    },
                    {
                        "id": 146006,
                        "name": "Pagudpud",
                        "latitude": "18.56598700",
                        "longitude": "120.71179790"
                    },
                    {
                        "id": 146014,
                        "name": "Paoay",
                        "latitude": "18.07796030",
                        "longitude": "120.47480490"
                    },
                    {
                        "id": 146018,
                        "name": "Pasuquin",
                        "latitude": "18.38426810",
                        "longitude": "120.55223440"
                    },
                    {
                        "id": 146022,
                        "name": "Piddig",
                        "latitude": "18.19300140",
                        "longitude": "120.68455300"
                    },
                    {
                        "id": 146024,
                        "name": "Pinili",
                        "latitude": "17.94533870",
                        "longitude": "120.45875310"
                    },
                    {
                        "id": 154544,
                        "name": "San Nicolas",
                        "latitude": "18.14328470",
                        "longitude": "120.55181990"
                    },
                    {
                        "id": 146088,
                        "name": "Sarrat",
                        "latitude": "18.10921290",
                        "longitude": "120.56889880"
                    },
                    {
                        "id": 146092,
                        "name": "Solsona",
                        "latitude": "18.12104980",
                        "longitude": "120.67818720"
                    },
                    {
                        "id": 146131,
                        "name": "Vintar",
                        "latitude": "18.31836550",
                        "longitude": "120.62558840"
                    }
                ]
            },
            {
                "id": 1321,
                "name": "Ilocos Sur",
                "iso2": "ILS",
                "latitude": "17.22786640",
                "longitude": "120.57395790",
                "type": "province",
                "cities": [
                    {
                        "id": 145794,
                        "name": "Alilem",
                        "latitude": "16.89298940",
                        "longitude": "120.50868600"
                    },
                    {
                        "id": 145820,
                        "name": "Banayoyo",
                        "latitude": "17.23901590",
                        "longitude": "120.45737430"
                    },
                    {
                        "id": 145828,
                        "name": "Bantay",
                        "latitude": "17.59949900",
                        "longitude": "120.36224660"
                    },
                    {
                        "id": 154545,
                        "name": "Burgos",
                        "latitude": "17.31831470",
                        "longitude": "120.47759230"
                    },
                    {
                        "id": 81980,
                        "name": "Cabugao",
                        "latitude": "17.78531330",
                        "longitude": "120.38042270"
                    },
                    {
                        "id": 145881,
                        "name": "Candon",
                        "latitude": "17.19090270",
                        "longitude": "120.39073340"
                    },
                    {
                        "id": 145883,
                        "name": "Caoayan",
                        "latitude": "17.52945980",
                        "longitude": "120.35232510"
                    },
                    {
                        "id": 145898,
                        "name": "Cervantes",
                        "latitude": "16.99356150",
                        "longitude": "120.61344230"
                    },
                    {
                        "id": 145926,
                        "name": "Galimuyod",
                        "latitude": "17.18822410",
                        "longitude": "120.43551400"
                    },
                    {
                        "id": 145928,
                        "name": "Gregorio del Pilar",
                        "latitude": "17.13548580",
                        "longitude": "120.56396380"
                    },
                    {
                        "id": 145948,
                        "name": "Lidlidda",
                        "latitude": "17.25651570",
                        "longitude": "120.49342910"
                    },
                    {
                        "id": 145970,
                        "name": "Magsingal",
                        "latitude": "17.68311550",
                        "longitude": "120.35791900"
                    },
                    {
                        "id": 145986,
                        "name": "Nagbukel",
                        "latitude": "17.44484030",
                        "longitude": "120.50126450"
                    },
                    {
                        "id": 145995,
                        "name": "Narvacan",
                        "latitude": "17.44599450",
                        "longitude": "120.41538270"
                    },
                    {
                        "id": 146038,
                        "name": "Quirino",
                        "latitude": "17.12687730",
                        "longitude": "120.57833120"
                    },
                    {
                        "id": 154546,
                        "name": "Salcedo",
                        "latitude": "17.12263280",
                        "longitude": "120.45898730"
                    },
                    {
                        "id": 146053,
                        "name": "San Emilio",
                        "latitude": "17.25301380",
                        "longitude": "120.53117360"
                    },
                    {
                        "id": 146054,
                        "name": "San Esteban",
                        "latitude": "17.32839420",
                        "longitude": "120.41083220"
                    },
                    {
                        "id": 146061,
                        "name": "San Ildefonso",
                        "latitude": "17.61666880",
                        "longitude": "120.37027450"
                    },
                    {
                        "id": 144854,
                        "name": "San Juan",
                        "latitude": "17.73267790",
                        "longitude": "120.38811810"
                    },
                    {
                        "id": 146073,
                        "name": "San Vicente",
                        "latitude": "17.61093710",
                        "longitude": "120.34633580"
                    },
                    {
                        "id": 146075,
                        "name": "Santa",
                        "latitude": "17.51189190",
                        "longitude": "120.40188710"
                    },
                    {
                        "id": 146077,
                        "name": "Santa Catalina",
                        "latitude": "17.58915460",
                        "longitude": "120.34016160"
                    },
                    {
                        "id": 154547,
                        "name": "Santa Cruz",
                        "latitude": "17.04288000",
                        "longitude": "120.42598540"
                    },
                    {
                        "id": 146079,
                        "name": "Santa Lucia",
                        "latitude": "17.12492250",
                        "longitude": "120.39590970"
                    },
                    {
                        "id": 146080,
                        "name": "Santa Maria",
                        "latitude": "17.36864540",
                        "longitude": "120.50081240"
                    },
                    {
                        "id": 146083,
                        "name": "Santiago",
                        "latitude": "17.27401620",
                        "longitude": "120.42240580"
                    },
                    {
                        "id": 146084,
                        "name": "Santo Domingo",
                        "latitude": "17.64519710",
                        "longitude": "120.42664640"
                    },
                    {
                        "id": 146089,
                        "name": "Sigay",
                        "latitude": "17.03796890",
                        "longitude": "120.51774110"
                    },
                    {
                        "id": 146090,
                        "name": "Sinait",
                        "latitude": "17.86199960",
                        "longitude": "120.40290490"
                    },
                    {
                        "id": 146097,
                        "name": "Sugpon",
                        "latitude": "16.76605950",
                        "longitude": "120.48478210"
                    },
                    {
                        "id": 146100,
                        "name": "Suyo",
                        "latitude": "16.99372980",
                        "longitude": "120.47988970"
                    },
                    {
                        "id": 146103,
                        "name": "Tagudin",
                        "latitude": "16.94670050",
                        "longitude": "120.38011960"
                    },
                    {
                        "id": 146129,
                        "name": "Vigan",
                        "latitude": "17.56365940",
                        "longitude": "120.31004050"
                    }
                ]
            },
            {
                "id": 1315,
                "name": "Iloilo",
                "iso2": "ILI",
                "latitude": "10.72015010",
                "longitude": "122.56210630",
                "type": "province",
                "cities": [
                    {
                        "id": 81174,
                        "name": "Ajuy",
                        "latitude": "11.12023540",
                        "longitude": "122.88060490"
                    },
                    {
                        "id": 81219,
                        "name": "Alimodian",
                        "latitude": "10.87096780",
                        "longitude": "122.20288580"
                    },
                    {
                        "id": 154548,
                        "name": "Anilao",
                        "latitude": "11.00849930",
                        "longitude": "122.65865880"
                    },
                    {
                        "id": 81382,
                        "name": "Badiangan",
                        "latitude": "10.99405330",
                        "longitude": "122.44785870"
                    },
                    {
                        "id": 81451,
                        "name": "Balasan",
                        "latitude": "11.46100830",
                        "longitude": "123.04455650"
                    },
                    {
                        "id": 154549,
                        "name": "Banate",
                        "latitude": "11.03849300",
                        "longitude": "122.71075800"
                    },
                    {
                        "id": 81583,
                        "name": "Barotac Nuevo",
                        "latitude": "10.91361920",
                        "longitude": "122.64016230"
                    },
                    {
                        "id": 81584,
                        "name": "Barotac Viejo",
                        "latitude": "11.05483270",
                        "longitude": "122.76809290"
                    },
                    {
                        "id": 81611,
                        "name": "Batad",
                        "latitude": "11.41073420",
                        "longitude": "123.01249590"
                    },
                    {
                        "id": 81718,
                        "name": "Bingawan",
                        "latitude": "11.20362000",
                        "longitude": "122.54798310"
                    },
                    {
                        "id": 81957,
                        "name": "Cabatuan",
                        "latitude": "10.87926220",
                        "longitude": "122.42309660"
                    },
                    {
                        "id": 82055,
                        "name": "Calinog",
                        "latitude": "11.16706710",
                        "longitude": "122.24352660"
                    },
                    {
                        "id": 82164,
                        "name": "Carles",
                        "latitude": "11.53319460",
                        "longitude": "123.05793120"
                    },
                    {
                        "id": 82274,
                        "name": "Concepcion",
                        "latitude": "11.23651550",
                        "longitude": "123.03578670"
                    },
                    {
                        "id": 82440,
                        "name": "Dingle",
                        "latitude": "11.00428630",
                        "longitude": "122.57227020"
                    },
                    {
                        "id": 82470,
                        "name": "Dueñas",
                        "latitude": "11.06923860",
                        "longitude": "122.51429160"
                    },
                    {
                        "id": 82487,
                        "name": "Dumangas",
                        "latitude": "10.82232990",
                        "longitude": "122.63046340"
                    },
                    {
                        "id": 82527,
                        "name": "Estancia",
                        "latitude": "11.45966310",
                        "longitude": "123.11262020"
                    },
                    {
                        "id": 82627,
                        "name": "Guimbal",
                        "latitude": "10.69604830",
                        "longitude": "122.26729530"
                    },
                    {
                        "id": 82716,
                        "name": "Igbaras",
                        "latitude": "10.75310420",
                        "longitude": "122.15775090"
                    },
                    {
                        "id": 82732,
                        "name": "Iloilo",
                        "latitude": "10.73007800",
                        "longitude": "122.46596890"
                    },
                    {
                        "id": 82792,
                        "name": "Janiuay",
                        "latitude": "10.99341180",
                        "longitude": "122.26910690"
                    },
                    {
                        "id": 82998,
                        "name": "Lambunao",
                        "latitude": "11.09009100",
                        "longitude": "122.25515660"
                    },
                    {
                        "id": 83060,
                        "name": "Leganes",
                        "latitude": "10.78918070",
                        "longitude": "122.56162790"
                    },
                    {
                        "id": 154550,
                        "name": "Lemery",
                        "latitude": "11.20662090",
                        "longitude": "122.84267980"
                    },
                    {
                        "id": 83066,
                        "name": "Leon",
                        "latitude": "10.81993360",
                        "longitude": "122.15696630"
                    },
                    {
                        "id": 154551,
                        "name": "Maasin",
                        "latitude": "10.92254670",
                        "longitude": "122.29602420"
                    },
                    {
                        "id": 83666,
                        "name": "Miagao",
                        "latitude": "10.68690520",
                        "longitude": "122.11449220"
                    },
                    {
                        "id": 83675,
                        "name": "Mina",
                        "latitude": "10.94940330",
                        "longitude": "122.52558130"
                    },
                    {
                        "id": 154552,
                        "name": "New Lucena",
                        "latitude": "10.87774230",
                        "longitude": "122.53274890"
                    },
                    {
                        "id": 83868,
                        "name": "Oton",
                        "latitude": "10.72650530",
                        "longitude": "122.38700460"
                    },
                    {
                        "id": 84034,
                        "name": "Passi",
                        "latitude": "11.15864210",
                        "longitude": "122.52037340"
                    },
                    {
                        "id": 84058,
                        "name": "Pavia",
                        "latitude": "10.76564120",
                        "longitude": "122.49686030"
                    },
                    {
                        "id": 84169,
                        "name": "Pototan",
                        "latitude": "10.91955610",
                        "longitude": "122.55351630"
                    },
                    {
                        "id": 84466,
                        "name": "San Dionisio",
                        "latitude": "11.32300520",
                        "longitude": "123.00279700"
                    },
                    {
                        "id": 84469,
                        "name": "San Enrique",
                        "latitude": "11.09979250",
                        "longitude": "122.62887550"
                    },
                    {
                        "id": 154553,
                        "name": "San Joaquin",
                        "latitude": "10.58068700",
                        "longitude": "122.00550860"
                    },
                    {
                        "id": 154554,
                        "name": "San Miguel",
                        "latitude": "10.78183040",
                        "longitude": "122.41670510"
                    },
                    {
                        "id": 154555,
                        "name": "San Rafael",
                        "latitude": "11.13855560",
                        "longitude": "122.75496080"
                    },
                    {
                        "id": 84643,
                        "name": "Santa Barbara",
                        "latitude": "10.81935860",
                        "longitude": "122.46702300"
                    },
                    {
                        "id": 84748,
                        "name": "Sara",
                        "latitude": "11.28992290",
                        "longitude": "122.91718080"
                    },
                    {
                        "id": 85105,
                        "name": "Tigbauan",
                        "latitude": "10.71660410",
                        "longitude": "122.33398570"
                    },
                    {
                        "id": 154556,
                        "name": "Tubungan",
                        "latitude": "10.78658200",
                        "longitude": "122.18719080"
                    },
                    {
                        "id": 85327,
                        "name": "Zarraga",
                        "latitude": "10.82267190",
                        "longitude": "122.59420290"
                    }
                ]
            },
            {
                "id": 1313,
                "name": "Isabela",
                "iso2": "ISA",
                "latitude": "18.50077590",
                "longitude": "-67.02434620",
                "type": "province",
                "cities": [
                    {
                        "id": 81214,
                        "name": "Alicia",
                        "latitude": "16.80918220",
                        "longitude": "121.50199620"
                    },
                    {
                        "id": 145111,
                        "name": "Angadanan",
                        "latitude": "16.77954890",
                        "longitude": "121.62228440"
                    },
                    {
                        "id": 144378,
                        "name": "Aurora",
                        "latitude": "16.97668040",
                        "longitude": "121.55777900"
                    },
                    {
                        "id": 145138,
                        "name": "Benito Soliven",
                        "latitude": "16.90198310",
                        "longitude": "121.75052330"
                    },
                    {
                        "id": 154557,
                        "name": "Burgos",
                        "latitude": "17.05598260",
                        "longitude": "121.65487060"
                    },
                    {
                        "id": 145150,
                        "name": "Cabagan",
                        "latitude": "17.38230230",
                        "longitude": "121.49231040"
                    },
                    {
                        "id": 154558,
                        "name": "Cabatuan",
                        "latitude": "16.93904160",
                        "longitude": "121.61808450"
                    },
                    {
                        "id": 145167,
                        "name": "Cauayan",
                        "latitude": "16.90398170",
                        "longitude": "121.62631110"
                    },
                    {
                        "id": 145169,
                        "name": "Cordon",
                        "latitude": "16.68965790",
                        "longitude": "121.37609090"
                    },
                    {
                        "id": 145175,
                        "name": "Delfin Albano",
                        "latitude": "17.27650590",
                        "longitude": "121.67443840"
                    },
                    {
                        "id": 154559,
                        "name": "Dinapigue",
                        "latitude": "16.67118960",
                        "longitude": "122.07302420"
                    },
                    {
                        "id": 154560,
                        "name": "Divilacan",
                        "latitude": "17.28811790",
                        "longitude": "122.01432140"
                    },
                    {
                        "id": 82501,
                        "name": "Echague",
                        "latitude": "16.64754700",
                        "longitude": "121.50616110"
                    },
                    {
                        "id": 145198,
                        "name": "Gamu",
                        "latitude": "17.07828450",
                        "longitude": "121.73045760"
                    },
                    {
                        "id": 145206,
                        "name": "Ilagan",
                        "latitude": "17.18931710",
                        "longitude": "121.77458590"
                    },
                    {
                        "id": 145211,
                        "name": "Jones",
                        "latitude": "16.52909360",
                        "longitude": "121.60898600"
                    },
                    {
                        "id": 154561,
                        "name": "Luna",
                        "latitude": "16.97325100",
                        "longitude": "121.68994160"
                    },
                    {
                        "id": 145227,
                        "name": "Maconacon",
                        "latitude": "17.37051310",
                        "longitude": "121.97478570"
                    },
                    {
                        "id": 145236,
                        "name": "Mallig",
                        "latitude": "17.18082370",
                        "longitude": "121.53213110"
                    },
                    {
                        "id": 145255,
                        "name": "Naguilian",
                        "latitude": "17.00280380",
                        "longitude": "121.78983560"
                    },
                    {
                        "id": 145269,
                        "name": "Quezon",
                        "latitude": "17.32148880",
                        "longitude": "121.53367600"
                    },
                    {
                        "id": 154562,
                        "name": "Quirino",
                        "latitude": "17.15474890",
                        "longitude": "121.66761500"
                    },
                    {
                        "id": 84323,
                        "name": "Ramon",
                        "latitude": "16.79172680",
                        "longitude": "121.42516460"
                    },
                    {
                        "id": 145276,
                        "name": "Reina Mercedes",
                        "latitude": "17.00245060",
                        "longitude": "121.75611290"
                    },
                    {
                        "id": 145279,
                        "name": "Roxas",
                        "latitude": "17.09549260",
                        "longitude": "121.54055740"
                    },
                    {
                        "id": 84438,
                        "name": "San Agustin",
                        "latitude": "16.46757450",
                        "longitude": "121.70824380"
                    },
                    {
                        "id": 145289,
                        "name": "San Guillermo",
                        "latitude": "16.69140090",
                        "longitude": "121.81325770"
                    },
                    {
                        "id": 154563,
                        "name": "San Isidro",
                        "latitude": "16.73422290",
                        "longitude": "121.53861880"
                    },
                    {
                        "id": 145295,
                        "name": "San Manuel",
                        "latitude": "17.02713990",
                        "longitude": "121.54274080"
                    },
                    {
                        "id": 145296,
                        "name": "San Mariano",
                        "latitude": "16.89448110",
                        "longitude": "121.88522780"
                    },
                    {
                        "id": 145686,
                        "name": "San Mateo",
                        "latitude": "16.87837330",
                        "longitude": "121.51787190"
                    },
                    {
                        "id": 84574,
                        "name": "San Pablo",
                        "latitude": "17.47766430",
                        "longitude": "121.67377800"
                    },
                    {
                        "id": 154564,
                        "name": "Santa Maria",
                        "latitude": "17.46977750",
                        "longitude": "121.63860670"
                    },
                    {
                        "id": 154565,
                        "name": "Santiago City",
                        "latitude": "16.69561490",
                        "longitude": "121.31157320"
                    },
                    {
                        "id": 154566,
                        "name": "Santo Tomas",
                        "latitude": "17.38079660",
                        "longitude": "121.65984440"
                    },
                    {
                        "id": 145331,
                        "name": "Tumauini",
                        "latitude": "17.28384930",
                        "longitude": "121.72021190"
                    }
                ]
            },
            {
                "id": 1312,
                "name": "Kalinga",
                "iso2": "KAL",
                "latitude": "17.47404220",
                "longitude": "121.35416310",
                "type": "province",
                "cities": [
                    {
                        "id": 144773,
                        "name": "Balbalan",
                        "latitude": "17.55137830",
                        "longitude": "120.97473740"
                    },
                    {
                        "id": 144828,
                        "name": "Lubuagan",
                        "latitude": "17.31437780",
                        "longitude": "120.91319690"
                    },
                    {
                        "id": 144839,
                        "name": "Pasil",
                        "latitude": "17.38726110",
                        "longitude": "120.93778470"
                    },
                    {
                        "id": 144843,
                        "name": "Pinukpuk",
                        "latitude": "17.55968610",
                        "longitude": "121.24025470"
                    },
                    {
                        "id": 144479,
                        "name": "Rizal",
                        "latitude": "17.49232380",
                        "longitude": "121.49498790"
                    },
                    {
                        "id": 144860,
                        "name": "Tabuk",
                        "latitude": "17.41508160",
                        "longitude": "121.08427130"
                    },
                    {
                        "id": 144865,
                        "name": "Tanudan",
                        "latitude": "17.26835590",
                        "longitude": "121.10901690"
                    },
                    {
                        "id": 144868,
                        "name": "Tinglayan",
                        "latitude": "17.24217750",
                        "longitude": "120.92778540"
                    }
                ]
            },
            {
                "id": 1317,
                "name": "La Union",
                "iso2": "LUN",
                "latitude": "38.87668780",
                "longitude": "-77.12809120",
                "type": "province",
                "cities": [
                    {
                        "id": 145788,
                        "name": "Agoo",
                        "latitude": "16.33614330",
                        "longitude": "120.32866980"
                    },
                    {
                        "id": 145802,
                        "name": "Aringay",
                        "latitude": "16.41146870",
                        "longitude": "120.31937570"
                    },
                    {
                        "id": 145808,
                        "name": "Bacnotan",
                        "latitude": "16.74118340",
                        "longitude": "120.30198850"
                    },
                    {
                        "id": 145812,
                        "name": "Bagulin",
                        "latitude": "16.60255580",
                        "longitude": "120.41348280"
                    },
                    {
                        "id": 145814,
                        "name": "Balaoan",
                        "latitude": "16.80407950",
                        "longitude": "120.30901140"
                    },
                    {
                        "id": 145822,
                        "name": "Bangar",
                        "latitude": "16.87838470",
                        "longitude": "120.39295890"
                    },
                    {
                        "id": 145837,
                        "name": "Bauang",
                        "latitude": "16.51931970",
                        "longitude": "120.30573150"
                    },
                    {
                        "id": 154567,
                        "name": "Burgos",
                        "latitude": "16.51504470",
                        "longitude": "120.43624770"
                    },
                    {
                        "id": 145866,
                        "name": "Caba",
                        "latitude": "16.44088260",
                        "longitude": "120.30396900"
                    },
                    {
                        "id": 154568,
                        "name": "Luna",
                        "latitude": "16.83983670",
                        "longitude": "120.29631100"
                    },
                    {
                        "id": 154569,
                        "name": "Naguilian",
                        "latitude": "16.52619680",
                        "longitude": "120.33800370"
                    },
                    {
                        "id": 146033,
                        "name": "Pugo",
                        "latitude": "16.32067460",
                        "longitude": "120.40029370"
                    },
                    {
                        "id": 154570,
                        "name": "Rosario",
                        "latitude": "16.25208970",
                        "longitude": "120.37562910"
                    },
                    {
                        "id": 154571,
                        "name": "San Fernando",
                        "latitude": "16.60841830",
                        "longitude": "120.27705910"
                    },
                    {
                        "id": 146059,
                        "name": "San Gabriel",
                        "latitude": "16.67845410",
                        "longitude": "120.40863520"
                    },
                    {
                        "id": 154572,
                        "name": "San Juan",
                        "latitude": "16.66942090",
                        "longitude": "120.29936580"
                    },
                    {
                        "id": 154573,
                        "name": "Santo Tomas",
                        "latitude": "16.27557210",
                        "longitude": "120.31343630"
                    },
                    {
                        "id": 146087,
                        "name": "Santol",
                        "latitude": "16.76492150",
                        "longitude": "120.40582320"
                    },
                    {
                        "id": 146096,
                        "name": "Sudipen",
                        "latitude": "16.85439840",
                        "longitude": "120.41354260"
                    },
                    {
                        "id": 146122,
                        "name": "Tubao",
                        "latitude": "16.34900490",
                        "longitude": "120.38316140"
                    }
                ]
            },
            {
                "id": 1328,
                "name": "Laguna",
                "iso2": "LAG",
                "latitude": "33.54271890",
                "longitude": "-117.78535680",
                "type": "province",
                "cities": [
                    {
                        "id": 81184,
                        "name": "Alaminos",
                        "latitude": "14.04447540",
                        "longitude": "121.20826000"
                    },
                    {
                        "id": 81650,
                        "name": "Bay",
                        "latitude": "14.14166320",
                        "longitude": "121.21217880"
                    },
                    {
                        "id": 81749,
                        "name": "Biñan",
                        "latitude": "14.30323770",
                        "longitude": "121.02888720"
                    },
                    {
                        "id": 81986,
                        "name": "Cabuyao",
                        "latitude": "14.25268700",
                        "longitude": "121.03193130"
                    },
                    {
                        "id": 82018,
                        "name": "Calamba",
                        "latitude": "14.18834100",
                        "longitude": "121.03383020"
                    },
                    {
                        "id": 82042,
                        "name": "Calauan",
                        "latitude": "14.13601420",
                        "longitude": "121.20895710"
                    },
                    {
                        "id": 82225,
                        "name": "Cavinti",
                        "latitude": "14.25105260",
                        "longitude": "121.47183510"
                    },
                    {
                        "id": 82536,
                        "name": "Famy",
                        "latitude": "14.47938530",
                        "longitude": "121.43147600"
                    },
                    {
                        "id": 82845,
                        "name": "Kalayaan",
                        "latitude": "14.33572860",
                        "longitude": "121.46612730"
                    },
                    {
                        "id": 154574,
                        "name": "Liliw",
                        "latitude": "14.13194700",
                        "longitude": "121.40347110"
                    },
                    {
                        "id": 83185,
                        "name": "Los Baños",
                        "latitude": "14.15477420",
                        "longitude": "121.17806090"
                    },
                    {
                        "id": 83209,
                        "name": "Luisiana",
                        "latitude": "14.18299710",
                        "longitude": "121.44175130"
                    },
                    {
                        "id": 154575,
                        "name": "Lumban",
                        "latitude": "14.30702840",
                        "longitude": "121.36093250"
                    },
                    {
                        "id": 145231,
                        "name": "Magdalena",
                        "latitude": "14.19940080",
                        "longitude": "121.39209850"
                    },
                    {
                        "id": 83374,
                        "name": "Majayjay",
                        "latitude": "14.14325140",
                        "longitude": "121.40098170"
                    },
                    {
                        "id": 83745,
                        "name": "Nagcarlan",
                        "latitude": "14.14224950",
                        "longitude": "121.32879820"
                    },
                    {
                        "id": 83885,
                        "name": "Paete",
                        "latitude": "14.38395340",
                        "longitude": "121.46736920"
                    },
                    {
                        "id": 83897,
                        "name": "Pagsanjan",
                        "latitude": "14.24834980",
                        "longitude": "121.37879450"
                    },
                    {
                        "id": 83906,
                        "name": "Pakil",
                        "latitude": "14.38368230",
                        "longitude": "121.38059690"
                    },
                    {
                        "id": 83978,
                        "name": "Pangil",
                        "latitude": "14.41147070",
                        "longitude": "121.38456130"
                    },
                    {
                        "id": 84088,
                        "name": "Pila",
                        "latitude": "14.23180750",
                        "longitude": "121.32918470"
                    },
                    {
                        "id": 154576,
                        "name": "Rizal",
                        "latitude": "14.09836320",
                        "longitude": "121.36214900"
                    },
                    {
                        "id": 154577,
                        "name": "San Pablo",
                        "latitude": "14.05569040",
                        "longitude": "121.25300380"
                    },
                    {
                        "id": 154578,
                        "name": "San Pedro",
                        "latitude": "14.34908610",
                        "longitude": "121.04114900"
                    },
                    {
                        "id": 154579,
                        "name": "Santa Cruz",
                        "latitude": "14.26520770",
                        "longitude": "121.35965730"
                    },
                    {
                        "id": 154580,
                        "name": "Santa Maria",
                        "latitude": "14.50909390",
                        "longitude": "121.34118430"
                    },
                    {
                        "id": 84699,
                        "name": "Santa Rosa",
                        "latitude": "14.28002120",
                        "longitude": "121.04702430"
                    },
                    {
                        "id": 84816,
                        "name": "Siniloan",
                        "latitude": "14.43371750",
                        "longitude": "121.44567840"
                    },
                    {
                        "id": 145780,
                        "name": "Victoria",
                        "latitude": "14.21146890",
                        "longitude": "121.29481490"
                    }
                ]
            },
            {
                "id": 1327,
                "name": "Lanao del Norte",
                "iso2": "LAN",
                "latitude": "8.01821140",
                "longitude": "123.77100600",
                "type": "province",
                "cities": [
                    {
                        "id": 81365,
                        "name": "Bacolod",
                        "latitude": "8.13884430",
                        "longitude": "123.98303210"
                    },
                    {
                        "id": 154663,
                        "name": "Baloi",
                        "latitude": "8.09752910",
                        "longitude": "124.13224300"
                    },
                    {
                        "id": 81585,
                        "name": "Baroy",
                        "latitude": "7.97983380",
                        "longitude": "123.73422460"
                    },
                    {
                        "id": 82727,
                        "name": "Iligan City",
                        "latitude": "8.16332480",
                        "longitude": "124.04307530"
                    },
                    {
                        "id": 82868,
                        "name": "Kapatagan",
                        "latitude": "7.87773310",
                        "longitude": "123.65184850"
                    },
                    {
                        "id": 82886,
                        "name": "Kauswagan",
                        "latitude": "8.16896730",
                        "longitude": "124.05334620"
                    },
                    {
                        "id": 82922,
                        "name": "Kolambugan",
                        "latitude": "8.09197830",
                        "longitude": "123.79982350"
                    },
                    {
                        "id": 82987,
                        "name": "Lala",
                        "latitude": "7.94842580",
                        "longitude": "123.68193490"
                    },
                    {
                        "id": 83131,
                        "name": "Linamon",
                        "latitude": "8.16888340",
                        "longitude": "124.11784740"
                    },
                    {
                        "id": 154664,
                        "name": "Magsaysay",
                        "latitude": "8.02816150",
                        "longitude": "123.83681370"
                    },
                    {
                        "id": 83365,
                        "name": "Maigo",
                        "latitude": "8.09996150",
                        "longitude": "123.89478690"
                    },
                    {
                        "id": 83633,
                        "name": "Matungao",
                        "latitude": "8.11649500",
                        "longitude": "124.12096190"
                    },
                    {
                        "id": 83723,
                        "name": "Munai",
                        "latitude": "7.95875410",
                        "longitude": "124.00881840"
                    },
                    {
                        "id": 154665,
                        "name": "Nunungan",
                        "latitude": "7.80530320",
                        "longitude": "123.77124560"
                    },
                    {
                        "id": 154666,
                        "name": "Pantao Ragat",
                        "latitude": "8.05848800",
                        "longitude": "123.92900520"
                    },
                    {
                        "id": 84001,
                        "name": "Pantar",
                        "latitude": "8.06867590",
                        "longitude": "124.13971010"
                    },
                    {
                        "id": 154667,
                        "name": "Poona Piagapo",
                        "latitude": "8.09370330",
                        "longitude": "123.98845250"
                    },
                    {
                        "id": 84423,
                        "name": "Salvador",
                        "latitude": "7.91304230",
                        "longitude": "123.82051160"
                    },
                    {
                        "id": 84740,
                        "name": "Sapad",
                        "latitude": "7.83217270",
                        "longitude": "123.79364380"
                    },
                    {
                        "id": 154668,
                        "name": "Sultan Naga Dimaporo",
                        "latitude": "7.78949100",
                        "longitude": "123.56617730"
                    },
                    {
                        "id": 84945,
                        "name": "Tagoloan",
                        "latitude": "8.14677810",
                        "longitude": "124.22926150"
                    },
                    {
                        "id": 154669,
                        "name": "Tangcal",
                        "latitude": "7.95867730",
                        "longitude": "123.89390180"
                    },
                    {
                        "id": 85196,
                        "name": "Tubod",
                        "latitude": "7.99802050",
                        "longitude": "123.78557280"
                    }
                ]
            },
            {
                "id": 1333,
                "name": "Lanao del Sur",
                "iso2": "LAS",
                "latitude": "7.82317600",
                "longitude": "124.41982430",
                "type": "province",
                "cities": [
                    {
                        "id": 154670,
                        "name": "Amai Manabilang",
                        "latitude": "7.72220020",
                        "longitude": "124.55045300"
                    },
                    {
                        "id": 144615,
                        "name": "Bacolod-Kalawi",
                        "latitude": "7.87428350",
                        "longitude": "124.08564780"
                    },
                    {
                        "id": 144630,
                        "name": "Balabagan",
                        "latitude": "7.54228570",
                        "longitude": "124.07091690"
                    },
                    {
                        "id": 144632,
                        "name": "Balindong",
                        "latitude": "7.91275830",
                        "longitude": "124.14299000"
                    },
                    {
                        "id": 144642,
                        "name": "Bayang",
                        "latitude": "7.74270960",
                        "longitude": "124.16501190"
                    },
                    {
                        "id": 144645,
                        "name": "Binidayan",
                        "latitude": "7.76266890",
                        "longitude": "124.08278030"
                    },
                    {
                        "id": 144650,
                        "name": "Buadiposo-Buntong",
                        "latitude": "7.97198490",
                        "longitude": "124.35835360"
                    },
                    {
                        "id": 144656,
                        "name": "Bubong",
                        "latitude": "8.01573730",
                        "longitude": "124.31535060"
                    },
                    {
                        "id": 144673,
                        "name": "Butig",
                        "latitude": "7.71148710",
                        "longitude": "124.22717170"
                    },
                    {
                        "id": 144675,
                        "name": "Calanogas",
                        "latitude": "7.73390150",
                        "longitude": "123.95843590"
                    },
                    {
                        "id": 144691,
                        "name": "Ditsaan-Ramain",
                        "latitude": "7.99082140",
                        "longitude": "124.32476490"
                    },
                    {
                        "id": 144694,
                        "name": "Ganassi",
                        "latitude": "7.81282460",
                        "longitude": "124.01825440"
                    },
                    {
                        "id": 144542,
                        "name": "Kapai",
                        "latitude": "8.12362070",
                        "longitude": "124.26616290"
                    },
                    {
                        "id": 154671,
                        "name": "Kapatagan",
                        "latitude": "7.46722750",
                        "longitude": "124.09951990"
                    },
                    {
                        "id": 154672,
                        "name": "Lumba-Bayabao",
                        "latitude": "7.73006720",
                        "longitude": "124.33015630"
                    },
                    {
                        "id": 154673,
                        "name": "Lumbaca-Unayan",
                        "latitude": "7.72727810",
                        "longitude": "124.21670400"
                    },
                    {
                        "id": 144572,
                        "name": "Lumbatan",
                        "latitude": "7.75540590",
                        "longitude": "124.20624810"
                    },
                    {
                        "id": 144573,
                        "name": "Lumbayanague",
                        "latitude": "7.76695110",
                        "longitude": "124.25281660"
                    },
                    {
                        "id": 144577,
                        "name": "Madalum",
                        "latitude": "7.87007460",
                        "longitude": "124.05955540"
                    },
                    {
                        "id": 144578,
                        "name": "Madamba",
                        "latitude": "7.86208910",
                        "longitude": "123.99116950"
                    },
                    {
                        "id": 144579,
                        "name": "Maguing",
                        "latitude": "7.90378650",
                        "longitude": "124.34994040"
                    },
                    {
                        "id": 144583,
                        "name": "Malabang",
                        "latitude": "7.60898590",
                        "longitude": "124.00551390"
                    },
                    {
                        "id": 144587,
                        "name": "Marantao",
                        "latitude": "7.96583130",
                        "longitude": "124.11820950"
                    },
                    {
                        "id": 144588,
                        "name": "Marawi",
                        "latitude": "8.02352470",
                        "longitude": "124.21549870"
                    },
                    {
                        "id": 144589,
                        "name": "Marogong",
                        "latitude": "7.60759410",
                        "longitude": "124.09250340"
                    },
                    {
                        "id": 144592,
                        "name": "Masiu",
                        "latitude": "7.81157590",
                        "longitude": "124.29411320"
                    },
                    {
                        "id": 154674,
                        "name": "Mulondo",
                        "latitude": "7.93011120",
                        "longitude": "124.30881380"
                    },
                    {
                        "id": 144620,
                        "name": "Pagayawan",
                        "latitude": "7.74404140",
                        "longitude": "124.06860260"
                    },
                    {
                        "id": 144700,
                        "name": "Piagapo",
                        "latitude": "8.01240620",
                        "longitude": "124.14396190"
                    },
                    {
                        "id": 154675,
                        "name": "Picong",
                        "latitude": "7.68254660",
                        "longitude": "123.75968260"
                    },
                    {
                        "id": 154676,
                        "name": "Poona Bayabao",
                        "latitude": "7.83156130",
                        "longitude": "124.32980780"
                    },
                    {
                        "id": 144705,
                        "name": "Pualas",
                        "latitude": "7.81180770",
                        "longitude": "124.01118180"
                    },
                    {
                        "id": 144710,
                        "name": "Saguiaran",
                        "latitude": "8.03458660",
                        "longitude": "124.22018750"
                    },
                    {
                        "id": 154677,
                        "name": "Sultan Dumalondong",
                        "latitude": "7.63611670",
                        "longitude": "124.21193670"
                    },
                    {
                        "id": 154678,
                        "name": "Tagoloan",
                        "latitude": "8.09907450",
                        "longitude": "124.37269760"
                    },
                    {
                        "id": 144740,
                        "name": "Tamparan",
                        "latitude": "7.87209600",
                        "longitude": "124.31913830"
                    },
                    {
                        "id": 144746,
                        "name": "Taraka",
                        "latitude": "7.89423090",
                        "longitude": "124.31130600"
                    },
                    {
                        "id": 144752,
                        "name": "Tubaran",
                        "latitude": "7.69150350",
                        "longitude": "124.02401050"
                    },
                    {
                        "id": 144755,
                        "name": "Tugaya",
                        "latitude": "7.90035410",
                        "longitude": "124.10923530"
                    },
                    {
                        "id": 144763,
                        "name": "Wao",
                        "latitude": "7.67316710",
                        "longitude": "124.63898730"
                    }
                ]
            },
            {
                "id": 1332,
                "name": "Leyte",
                "iso2": "LEY",
                "latitude": "10.86245360",
                "longitude": "124.88111950",
                "type": "province",
                "cities": [
                    {
                        "id": 81140,
                        "name": "Abuyog",
                        "latitude": "10.65058610",
                        "longitude": "124.87917240"
                    },
                    {
                        "id": 81186,
                        "name": "Alangalang",
                        "latitude": "11.21542780",
                        "longitude": "124.78185250"
                    },
                    {
                        "id": 81192,
                        "name": "Albuera",
                        "latitude": "10.91766310",
                        "longitude": "124.66030250"
                    },
                    {
                        "id": 81348,
                        "name": "Babatngon",
                        "latitude": "11.38990550",
                        "longitude": "124.81562700"
                    },
                    {
                        "id": 81589,
                        "name": "Barugo",
                        "latitude": "11.31813040",
                        "longitude": "124.68074130"
                    },
                    {
                        "id": 154679,
                        "name": "Bato",
                        "latitude": "10.33293640",
                        "longitude": "124.76316280"
                    },
                    {
                        "id": 81662,
                        "name": "Baybay",
                        "latitude": "10.72185470",
                        "longitude": "124.67792360"
                    },
                    {
                        "id": 81904,
                        "name": "Burauen",
                        "latitude": "10.95069470",
                        "longitude": "124.77480920"
                    },
                    {
                        "id": 82068,
                        "name": "Calubian",
                        "latitude": "11.48508960",
                        "longitude": "124.28605150"
                    },
                    {
                        "id": 82140,
                        "name": "Capoocan",
                        "latitude": "11.25021020",
                        "longitude": "124.50779520"
                    },
                    {
                        "id": 82163,
                        "name": "Carigara",
                        "latitude": "11.23235300",
                        "longitude": "124.59061630"
                    },
                    {
                        "id": 82332,
                        "name": "Dagami",
                        "latitude": "11.05744880",
                        "longitude": "124.77721770"
                    },
                    {
                        "id": 82474,
                        "name": "Dulag",
                        "latitude": "10.96019630",
                        "longitude": "124.96747520"
                    },
                    {
                        "id": 82686,
                        "name": "Hilongos",
                        "latitude": "10.39020240",
                        "longitude": "124.72894970"
                    },
                    {
                        "id": 82694,
                        "name": "Hindang",
                        "latitude": "10.45133750",
                        "longitude": "124.73335820"
                    },
                    {
                        "id": 148095,
                        "name": "Inopacan",
                        "latitude": "10.52588690",
                        "longitude": "124.66858680"
                    },
                    {
                        "id": 82769,
                        "name": "Isabel",
                        "latitude": "10.94470730",
                        "longitude": "124.36982230"
                    },
                    {
                        "id": 82798,
                        "name": "Jaro",
                        "latitude": "11.17532640",
                        "longitude": "124.67370580"
                    },
                    {
                        "id": 82801,
                        "name": "Javier",
                        "latitude": "10.74838520",
                        "longitude": "124.84381960"
                    },
                    {
                        "id": 82819,
                        "name": "Julita",
                        "latitude": "10.97056740",
                        "longitude": "124.91806880"
                    },
                    {
                        "id": 148140,
                        "name": "Kananga",
                        "latitude": "11.16665870",
                        "longitude": "124.47520090"
                    },
                    {
                        "id": 82947,
                        "name": "La Paz",
                        "latitude": "10.88589230",
                        "longitude": "124.81076950"
                    },
                    {
                        "id": 83072,
                        "name": "Leyte",
                        "latitude": "11.32959150",
                        "longitude": "124.39561440"
                    },
                    {
                        "id": 83292,
                        "name": "MacArthur",
                        "latitude": "10.81499960",
                        "longitude": "124.83832640"
                    },
                    {
                        "id": 83358,
                        "name": "Mahaplag",
                        "latitude": "10.59556980",
                        "longitude": "124.90328140"
                    },
                    {
                        "id": 148093,
                        "name": "Matag-ob",
                        "latitude": "11.11792000",
                        "longitude": "124.37252600"
                    },
                    {
                        "id": 83617,
                        "name": "Matalom",
                        "latitude": "10.25933300",
                        "longitude": "124.74357200"
                    },
                    {
                        "id": 83652,
                        "name": "Mayorga",
                        "latitude": "10.88031570",
                        "longitude": "124.94697230"
                    },
                    {
                        "id": 83662,
                        "name": "Merida",
                        "latitude": "10.97254960",
                        "longitude": "124.42651380"
                    },
                    {
                        "id": 83860,
                        "name": "Ormoc",
                        "latitude": "11.05076480",
                        "longitude": "124.47550530"
                    },
                    {
                        "id": 83927,
                        "name": "Palo",
                        "latitude": "11.14411430",
                        "longitude": "124.88424850"
                    },
                    {
                        "id": 83929,
                        "name": "Palompon",
                        "latitude": "11.00857200",
                        "longitude": "124.34154100"
                    },
                    {
                        "id": 84035,
                        "name": "Pastrana",
                        "latitude": "11.10663820",
                        "longitude": "124.76502970"
                    },
                    {
                        "id": 154680,
                        "name": "San Isidro",
                        "latitude": "11.42423310",
                        "longitude": "124.26532350"
                    },
                    {
                        "id": 154681,
                        "name": "San Miguel",
                        "latitude": "11.32932420",
                        "longitude": "124.76211140"
                    },
                    {
                        "id": 154682,
                        "name": "Santa Fe",
                        "latitude": "11.18983780",
                        "longitude": "124.85601030"
                    },
                    {
                        "id": 84893,
                        "name": "Tabango",
                        "latitude": "11.29885020",
                        "longitude": "124.31609230"
                    },
                    {
                        "id": 84909,
                        "name": "Tabontabon",
                        "latitude": "11.04600140",
                        "longitude": "124.90347760"
                    },
                    {
                        "id": 84920,
                        "name": "Tacloban",
                        "latitude": "11.26194850",
                        "longitude": "124.88158780"
                    },
                    {
                        "id": 154683,
                        "name": "Tanauan",
                        "latitude": "11.08322970",
                        "longitude": "124.94725120"
                    },
                    {
                        "id": 85158,
                        "name": "Tolosa",
                        "latitude": "11.03557130",
                        "longitude": "124.96549090"
                    },
                    {
                        "id": 85225,
                        "name": "Tunga",
                        "latitude": "11.23878550",
                        "longitude": "124.72708480"
                    },
                    {
                        "id": 85294,
                        "name": "Villaba",
                        "latitude": "11.19362220",
                        "longitude": "124.35025280"
                    }
                ]
            },
            {
                "id": 1330,
                "name": "Maguindanao del Norte",
                "iso2": "MGN",
                "latitude": "6.94225810",
                "longitude": "124.41982430",
                "type": "province",
                "cities": [
                    {
                        "id": 144637,
                        "name": "Barira",
                        "latitude": "7.47420330",
                        "longitude": "124.23953130"
                    },
                    {
                        "id": 144669,
                        "name": "Buldon",
                        "latitude": "7.49428290",
                        "longitude": "124.24226560"
                    },
                    {
                        "id": 143933,
                        "name": "Cotabato City",
                        "latitude": "7.19867700",
                        "longitude": "124.16271400"
                    },
                    {
                        "id": 144684,
                        "name": "Datu Blah T. Sinsuat",
                        "latitude": "6.93479340",
                        "longitude": "123.85890290"
                    },
                    {
                        "id": 144685,
                        "name": "Datu Odin Sinsuat",
                        "latitude": "7.06435750",
                        "longitude": "124.04588510"
                    },
                    {
                        "id": 144533,
                        "name": "Kabuntalan",
                        "latitude": "7.11795860",
                        "longitude": "124.29141600"
                    },
                    {
                        "id": 144593,
                        "name": "Matanog",
                        "latitude": "7.47161660",
                        "longitude": "124.19314280"
                    },
                    {
                        "id": 154684,
                        "name": "Northern Kabuntalan",
                        "latitude": "7.16496680",
                        "longitude": "124.35171190"
                    },
                    {
                        "id": 144663,
                        "name": "Parang",
                        "latitude": "7.36106390",
                        "longitude": "123.89035320"
                    },
                    {
                        "id": 144727,
                        "name": "Sultan Kudarat",
                        "latitude": "7.24543630",
                        "longitude": "124.16381300"
                    },
                    {
                        "id": 154685,
                        "name": "Sultan Mastura",
                        "latitude": "7.28771400",
                        "longitude": "124.18867660"
                    },
                    {
                        "id": 84988,
                        "name": "Talitay",
                        "latitude": "7.03210120",
                        "longitude": "124.30333570"
                    },
                    {
                        "id": 144761,
                        "name": "Upi",
                        "latitude": "6.99285870",
                        "longitude": "124.07477920"
                    }
                ]
            },
            {
                "id": 1347,
                "name": "Maguindanao del Sur",
                "iso2": "MGS",
                "latitude": "14.60905370",
                "longitude": "121.02225650",
                "type": "province",
                "cities": [
                    {
                        "id": 144608,
                        "name": "Ampatuan",
                        "latitude": "6.79822870",
                        "longitude": "124.22200960"
                    },
                    {
                        "id": 144672,
                        "name": "Buluan",
                        "latitude": "6.72915810",
                        "longitude": "124.71966940"
                    },
                    {
                        "id": 154692,
                        "name": "Datu Abdullah Sangki",
                        "latitude": "6.82019260",
                        "longitude": "124.44011760"
                    },
                    {
                        "id": 154693,
                        "name": "Datu Anggal Midtimbang",
                        "latitude": "6.93337510",
                        "longitude": "124.31273340"
                    },
                    {
                        "id": 154694,
                        "name": "Datu Hoffer Ampatuan",
                        "latitude": "6.84482650",
                        "longitude": "124.41887250"
                    },
                    {
                        "id": 143938,
                        "name": "Datu Montawal",
                        "latitude": "7.11373990",
                        "longitude": "124.67516500"
                    },
                    {
                        "id": 144686,
                        "name": "Datu Paglas",
                        "latitude": "6.72337490",
                        "longitude": "124.83832900"
                    },
                    {
                        "id": 144687,
                        "name": "Datu Piang",
                        "latitude": "7.02141080",
                        "longitude": "124.41346720"
                    },
                    {
                        "id": 154695,
                        "name": "Datu Salibo",
                        "latitude": "7.01779370",
                        "longitude": "124.38938110"
                    },
                    {
                        "id": 154696,
                        "name": "Datu Saudi-Ampatuan",
                        "latitude": "6.96660950",
                        "longitude": "124.30620950"
                    },
                    {
                        "id": 154697,
                        "name": "Datu Unsay",
                        "latitude": "6.91828690",
                        "longitude": "124.41666740"
                    },
                    {
                        "id": 154698,
                        "name": "General Salipada K. Pendatun",
                        "latitude": "6.84013900",
                        "longitude": "124.65490900"
                    },
                    {
                        "id": 154699,
                        "name": "Guindulungan",
                        "latitude": "6.97029220",
                        "longitude": "124.29772450"
                    },
                    {
                        "id": 154700,
                        "name": "Mamasapano",
                        "latitude": "6.93528260",
                        "longitude": "124.45990460"
                    },
                    {
                        "id": 154701,
                        "name": "Mangudadatu",
                        "latitude": "6.68468120",
                        "longitude": "124.74866860"
                    },
                    {
                        "id": 144607,
                        "name": "Pagalungan",
                        "latitude": "6.96096830",
                        "longitude": "124.54855250"
                    },
                    {
                        "id": 144622,
                        "name": "Paglat",
                        "latitude": "6.70004210",
                        "longitude": "124.76273340"
                    },
                    {
                        "id": 144626,
                        "name": "Pandag",
                        "latitude": "6.76241470",
                        "longitude": "124.71666420"
                    },
                    {
                        "id": 154702,
                        "name": "Rajah Buayan",
                        "latitude": "6.92714510",
                        "longitude": "124.53157330"
                    },
                    {
                        "id": 144719,
                        "name": "Shariff Aguak",
                        "latitude": "6.86909350",
                        "longitude": "124.24642850"
                    },
                    {
                        "id": 154703,
                        "name": "Shariff Saydona Mustapha",
                        "latitude": "6.88494090",
                        "longitude": "124.48853960"
                    },
                    {
                        "id": 144726,
                        "name": "South Upi",
                        "latitude": "6.84167650",
                        "longitude": "124.08907010"
                    },
                    {
                        "id": 144730,
                        "name": "Sultan sa Barongis",
                        "latitude": "6.91274170",
                        "longitude": "124.55281340"
                    },
                    {
                        "id": 144736,
                        "name": "Talayan",
                        "latitude": "6.92146870",
                        "longitude": "124.24021800"
                    }
                ]
            },
            {
                "id": 1329,
                "name": "Marinduque",
                "iso2": "MAD",
                "latitude": "13.47671710",
                "longitude": "121.90321920",
                "type": "province",
                "cities": [
                    {
                        "id": 81752,
                        "name": "Boac",
                        "latitude": "13.38925470",
                        "longitude": "121.81348400"
                    },
                    {
                        "id": 154686,
                        "name": "Buenavista",
                        "latitude": "13.25567130",
                        "longitude": "121.89021660"
                    },
                    {
                        "id": 82571,
                        "name": "Gasan",
                        "latitude": "13.29685110",
                        "longitude": "121.79910740"
                    },
                    {
                        "id": 83693,
                        "name": "Mogpog",
                        "latitude": "13.51481250",
                        "longitude": "121.81301200"
                    },
                    {
                        "id": 154687,
                        "name": "Santa Cruz",
                        "latitude": "13.46326140",
                        "longitude": "121.89226460"
                    },
                    {
                        "id": 85172,
                        "name": "Torrijos",
                        "latitude": "13.31692490",
                        "longitude": "121.98132600"
                    }
                ]
            },
            {
                "id": 1338,
                "name": "Masbate",
                "iso2": "MAS",
                "latitude": "12.35743460",
                "longitude": "123.55040760",
                "type": "province",
                "cities": [
                    {
                        "id": 81317,
                        "name": "Aroroy",
                        "latitude": "12.46930250",
                        "longitude": "123.16273030"
                    },
                    {
                        "id": 81460,
                        "name": "Baleno",
                        "latitude": "12.41969550",
                        "longitude": "123.40728940"
                    },
                    {
                        "id": 81503,
                        "name": "Balud",
                        "latitude": "11.91071010",
                        "longitude": "122.81699820"
                    },
                    {
                        "id": 81637,
                        "name": "Batuan",
                        "latitude": "12.38059990",
                        "longitude": "123.67646590"
                    },
                    {
                        "id": 82202,
                        "name": "Cataingan",
                        "latitude": "12.00153380",
                        "longitude": "123.88155300"
                    },
                    {
                        "id": 82228,
                        "name": "Cawayan",
                        "latitude": "11.99285490",
                        "longitude": "123.51532290"
                    },
                    {
                        "id": 82250,
                        "name": "Claveria",
                        "latitude": "12.83769210",
                        "longitude": "123.07020490"
                    },
                    {
                        "id": 82429,
                        "name": "Dimasalang",
                        "latitude": "12.16882270",
                        "longitude": "123.75913710"
                    },
                    {
                        "id": 82522,
                        "name": "Esperanza",
                        "latitude": "11.80872990",
                        "longitude": "123.92307350"
                    },
                    {
                        "id": 83503,
                        "name": "Mandaon",
                        "latitude": "12.22630340",
                        "longitude": "123.14058620"
                    },
                    {
                        "id": 83601,
                        "name": "Masbate",
                        "latitude": "12.35298800",
                        "longitude": "123.48220930"
                    },
                    {
                        "id": 83671,
                        "name": "Milagros",
                        "latitude": "12.18195690",
                        "longitude": "123.16461250"
                    },
                    {
                        "id": 83692,
                        "name": "Mobo",
                        "latitude": "12.27795890",
                        "longitude": "123.58515280"
                    },
                    {
                        "id": 83704,
                        "name": "Monreal",
                        "latitude": "12.64856380",
                        "longitude": "123.56202680"
                    },
                    {
                        "id": 83912,
                        "name": "Palanas",
                        "latitude": "12.10312370",
                        "longitude": "123.80750260"
                    },
                    {
                        "id": 154688,
                        "name": "Pio V. Corpus",
                        "latitude": "11.83556520",
                        "longitude": "123.96036710"
                    },
                    {
                        "id": 84129,
                        "name": "Placer",
                        "latitude": "11.93419930",
                        "longitude": "123.80986290"
                    },
                    {
                        "id": 154689,
                        "name": "San Fernando",
                        "latitude": "12.48405170",
                        "longitude": "123.63927450"
                    },
                    {
                        "id": 84508,
                        "name": "San Jacinto",
                        "latitude": "12.55307660",
                        "longitude": "123.60284750"
                    },
                    {
                        "id": 154690,
                        "name": "San Pascual",
                        "latitude": "13.07626090",
                        "longitude": "122.82893480"
                    },
                    {
                        "id": 154691,
                        "name": "Uson",
                        "latitude": "12.18103470",
                        "longitude": "123.66794180"
                    }
                ]
            },
            {
                "id": 1299,
                "name": "Mimaropa",
                "iso2": "41",
                "latitude": "9.84320650",
                "longitude": "118.73647830",
                "type": "region",
                "cities": []
            },
            {
                "id": 1343,
                "name": "Misamis Occidental",
                "iso2": "MSC",
                "latitude": "8.33749030",
                "longitude": "123.70706190",
                "type": "province",
                "cities": [
                    {
                        "id": 154704,
                        "name": "Aloran",
                        "latitude": "8.39998540",
                        "longitude": "123.66952300"
                    },
                    {
                        "id": 154705,
                        "name": "Baliangao",
                        "latitude": "8.61394410",
                        "longitude": "123.57207190"
                    },
                    {
                        "id": 81791,
                        "name": "Bonifacio",
                        "latitude": "8.08888390",
                        "longitude": "123.56099720"
                    },
                    {
                        "id": 154706,
                        "name": "Calamba",
                        "latitude": "8.51787480",
                        "longitude": "123.59146400"
                    },
                    {
                        "id": 82246,
                        "name": "Clarin",
                        "latitude": "8.19847030",
                        "longitude": "123.60110780"
                    },
                    {
                        "id": 154707,
                        "name": "Concepcion",
                        "latitude": "8.41872210",
                        "longitude": "123.55739490"
                    },
                    {
                        "id": 154708,
                        "name": "Don Victoriano Chiongbian",
                        "latitude": "8.26320820",
                        "longitude": "123.52886940"
                    },
                    {
                        "id": 82807,
                        "name": "Jimenez",
                        "latitude": "8.32471840",
                        "longitude": "123.59737410"
                    },
                    {
                        "id": 83178,
                        "name": "Lopez Jaena",
                        "latitude": "8.52845510",
                        "longitude": "123.63789560"
                    },
                    {
                        "id": 83862,
                        "name": "Oroquieta",
                        "latitude": "8.44661360",
                        "longitude": "123.52158570"
                    },
                    {
                        "id": 83870,
                        "name": "Ozamiz City",
                        "latitude": "8.14584380",
                        "longitude": "123.59332140"
                    },
                    {
                        "id": 154709,
                        "name": "Panaon",
                        "latitude": "8.35995340",
                        "longitude": "123.67287850"
                    },
                    {
                        "id": 84133,
                        "name": "Plaridel",
                        "latitude": "8.61147800",
                        "longitude": "123.62176220"
                    },
                    {
                        "id": 84744,
                        "name": "Sapang Dalaga",
                        "latitude": "8.54213010",
                        "longitude": "123.49799440"
                    },
                    {
                        "id": 84806,
                        "name": "Sinacaban",
                        "latitude": "8.29541420",
                        "longitude": "123.67755220"
                    },
                    {
                        "id": 85038,
                        "name": "Tangub",
                        "latitude": "8.10038770",
                        "longitude": "123.62346010"
                    },
                    {
                        "id": 154710,
                        "name": "Tudela",
                        "latitude": "8.24119720",
                        "longitude": "123.59774690"
                    }
                ]
            },
            {
                "id": 1348,
                "name": "Misamis Oriental",
                "iso2": "MSR",
                "latitude": "8.50455580",
                "longitude": "124.62195920",
                "type": "province",
                "cities": [
                    {
                        "id": 81234,
                        "name": "Alubijid",
                        "latitude": "8.50805920",
                        "longitude": "124.35592760"
                    },
                    {
                        "id": 81475,
                        "name": "Balingasag",
                        "latitude": "8.73832420",
                        "longitude": "124.72486090"
                    },
                    {
                        "id": 81478,
                        "name": "Balingoan",
                        "latitude": "8.94233430",
                        "longitude": "124.78112830"
                    },
                    {
                        "id": 81731,
                        "name": "Binuangan",
                        "latitude": "8.91832250",
                        "longitude": "124.77965170"
                    },
                    {
                        "id": 81994,
                        "name": "Cagayan de Oro",
                        "latitude": "8.38279290",
                        "longitude": "124.46791450"
                    },
                    {
                        "id": 154711,
                        "name": "Claveria",
                        "latitude": "8.72043280",
                        "longitude": "124.69475860"
                    },
                    {
                        "id": 82507,
                        "name": "El Salvador",
                        "latitude": "8.48606140",
                        "longitude": "124.40981940"
                    },
                    {
                        "id": 154712,
                        "name": "Gingoog",
                        "latitude": "8.78455880",
                        "longitude": "124.91650870"
                    },
                    {
                        "id": 82598,
                        "name": "Gitagum",
                        "latitude": "8.55504480",
                        "longitude": "124.35021310"
                    },
                    {
                        "id": 82752,
                        "name": "Initao",
                        "latitude": "8.49689470",
                        "longitude": "124.25553880"
                    },
                    {
                        "id": 82799,
                        "name": "Jasaan",
                        "latitude": "8.64766800",
                        "longitude": "124.67396340"
                    },
                    {
                        "id": 154713,
                        "name": "Kinoguitan",
                        "latitude": "8.97393010",
                        "longitude": "124.79237060"
                    },
                    {
                        "id": 82978,
                        "name": "Lagonglong",
                        "latitude": "8.81637360",
                        "longitude": "124.77464570"
                    },
                    {
                        "id": 154714,
                        "name": "Laguindingan",
                        "latitude": "8.57736610",
                        "longitude": "124.40462970"
                    },
                    {
                        "id": 83087,
                        "name": "Libertad",
                        "latitude": "8.52635630",
                        "longitude": "124.31695360"
                    },
                    {
                        "id": 83205,
                        "name": "Lugait",
                        "latitude": "8.34963580",
                        "longitude": "124.23786070"
                    },
                    {
                        "id": 154715,
                        "name": "Magsaysay",
                        "latitude": "8.97394360",
                        "longitude": "125.12787900"
                    },
                    {
                        "id": 83539,
                        "name": "Manticao",
                        "latitude": "8.37348970",
                        "longitude": "124.26879950"
                    },
                    {
                        "id": 83657,
                        "name": "Medina",
                        "latitude": "8.88157650",
                        "longitude": "124.88690920"
                    },
                    {
                        "id": 83733,
                        "name": "Naawan",
                        "latitude": "8.42711140",
                        "longitude": "124.27180370"
                    },
                    {
                        "id": 83855,
                        "name": "Opol",
                        "latitude": "8.43721820",
                        "longitude": "124.34693620"
                    },
                    {
                        "id": 84403,
                        "name": "Salay",
                        "latitude": "8.85961990",
                        "longitude": "124.78513950"
                    },
                    {
                        "id": 154716,
                        "name": "Sugbongcogon",
                        "latitude": "8.95874550",
                        "longitude": "124.78103040"
                    },
                    {
                        "id": 154717,
                        "name": "Tagoloan",
                        "latitude": "8.51612090",
                        "longitude": "124.70602120"
                    },
                    {
                        "id": 84985,
                        "name": "Talisayan",
                        "latitude": "8.94746290",
                        "longitude": "124.82674200"
                    },
                    {
                        "id": 85298,
                        "name": "Villanueva",
                        "latitude": "8.57195170",
                        "longitude": "124.70863900"
                    }
                ]
            },
            {
                "id": 1353,
                "name": "Mountain Province",
                "iso2": "MOU",
                "latitude": "40.70754370",
                "longitude": "-73.95010330",
                "type": "province",
                "cities": [
                    {
                        "id": 144778,
                        "name": "Barlig",
                        "latitude": "17.09793430",
                        "longitude": "121.05903230"
                    },
                    {
                        "id": 144779,
                        "name": "Bauko",
                        "latitude": "16.94195780",
                        "longitude": "120.80543750"
                    },
                    {
                        "id": 144781,
                        "name": "Besao",
                        "latitude": "17.12193260",
                        "longitude": "120.74608560"
                    },
                    {
                        "id": 144786,
                        "name": "Bontoc",
                        "latitude": "17.10312110",
                        "longitude": "120.83299070"
                    },
                    {
                        "id": 144836,
                        "name": "Natonin",
                        "latitude": "17.12888000",
                        "longitude": "121.13326400"
                    },
                    {
                        "id": 144838,
                        "name": "Paracelis",
                        "latitude": "17.18497180",
                        "longitude": "121.28218840"
                    },
                    {
                        "id": 144847,
                        "name": "Sabangan",
                        "latitude": "16.94475750",
                        "longitude": "120.85385680"
                    },
                    {
                        "id": 144849,
                        "name": "Sadanga",
                        "latitude": "17.16995930",
                        "longitude": "120.92724200"
                    },
                    {
                        "id": 144851,
                        "name": "Sagada",
                        "latitude": "17.10987950",
                        "longitude": "120.82402800"
                    },
                    {
                        "id": 144863,
                        "name": "Tadian",
                        "latitude": "16.95737360",
                        "longitude": "120.74134890"
                    }
                ]
            },
            {
                "id": 5324,
                "name": "National Capital Region (Metro Manila)",
                "iso2": "00",
                "latitude": "14.56807070",
                "longitude": "120.85583270",
                "type": "region",
                "cities": []
            },
            {
                "id": 1351,
                "name": "Negros Occidental",
                "iso2": "NEC",
                "latitude": "10.29256090",
                "longitude": "123.02465180",
                "type": "province",
                "cities": [
                    {
                        "id": 154718,
                        "name": "Bacolod",
                        "latitude": "10.64655290",
                        "longitude": "122.83691700"
                    },
                    {
                        "id": 154719,
                        "name": "Bago",
                        "latitude": "10.50839140",
                        "longitude": "122.78958130"
                    },
                    {
                        "id": 81710,
                        "name": "Binalbagan",
                        "latitude": "10.20781480",
                        "longitude": "122.82414050"
                    },
                    {
                        "id": 81989,
                        "name": "Cadiz",
                        "latitude": "10.84387080",
                        "longitude": "123.09683450"
                    },
                    {
                        "id": 82038,
                        "name": "Calatrava",
                        "latitude": "10.60996950",
                        "longitude": "123.22023680"
                    },
                    {
                        "id": 82113,
                        "name": "Candoni",
                        "latitude": "9.75801540",
                        "longitude": "122.55072660"
                    },
                    {
                        "id": 154720,
                        "name": "Cauayan",
                        "latitude": "9.91046520",
                        "longitude": "122.36892520"
                    },
                    {
                        "id": 154721,
                        "name": "Don Salvador Benedicto",
                        "latitude": "10.57088470",
                        "longitude": "123.08222110"
                    },
                    {
                        "id": 154722,
                        "name": "Enrique B. Magalona",
                        "latitude": "10.86115780",
                        "longitude": "122.88463890"
                    },
                    {
                        "id": 82514,
                        "name": "Escalante",
                        "latitude": "10.81465280",
                        "longitude": "123.29591800"
                    },
                    {
                        "id": 82689,
                        "name": "Himamaylan",
                        "latitude": "10.05431650",
                        "longitude": "122.75889690"
                    },
                    {
                        "id": 82696,
                        "name": "Hinigaran",
                        "latitude": "10.27097380",
                        "longitude": "122.84882060"
                    },
                    {
                        "id": 154723,
                        "name": "Hinoba-an",
                        "latitude": "9.54508220",
                        "longitude": "122.39694890"
                    },
                    {
                        "id": 82731,
                        "name": "Ilog",
                        "latitude": "9.81003780",
                        "longitude": "122.58410270"
                    },
                    {
                        "id": 154724,
                        "name": "Isabela",
                        "latitude": "10.21521240",
                        "longitude": "122.86695770"
                    },
                    {
                        "id": 82824,
                        "name": "Kabankalan",
                        "latitude": "9.81994830",
                        "longitude": "122.68675620"
                    },
                    {
                        "id": 82936,
                        "name": "La Carlota",
                        "latitude": "10.41804750",
                        "longitude": "122.84961990"
                    },
                    {
                        "id": 82937,
                        "name": "La Castellana",
                        "latitude": "10.32088300",
                        "longitude": "123.01468850"
                    },
                    {
                        "id": 83493,
                        "name": "Manapla",
                        "latitude": "10.91310180",
                        "longitude": "123.05974560"
                    },
                    {
                        "id": 83694,
                        "name": "Moises Padilla",
                        "latitude": "10.25350730",
                        "longitude": "123.02223750"
                    },
                    {
                        "id": 83726,
                        "name": "Murcia",
                        "latitude": "10.53508730",
                        "longitude": "122.93862640"
                    },
                    {
                        "id": 154725,
                        "name": "Pontevedra",
                        "latitude": "10.35661780",
                        "longitude": "122.85220700"
                    },
                    {
                        "id": 84272,
                        "name": "Pulupandan",
                        "latitude": "10.51877910",
                        "longitude": "122.77564900"
                    },
                    {
                        "id": 154726,
                        "name": "Sagay",
                        "latitude": "10.80833080",
                        "longitude": "123.24547110"
                    },
                    {
                        "id": 84460,
                        "name": "San Carlos",
                        "latitude": "10.47087620",
                        "longitude": "123.12784010"
                    },
                    {
                        "id": 154727,
                        "name": "San Enrique",
                        "latitude": "10.41762460",
                        "longitude": "122.82491580"
                    },
                    {
                        "id": 154728,
                        "name": "Silay",
                        "latitude": "10.75601470",
                        "longitude": "122.92553730"
                    },
                    {
                        "id": 84825,
                        "name": "Sipalay",
                        "latitude": "9.74642710",
                        "longitude": "122.39464360"
                    },
                    {
                        "id": 154729,
                        "name": "Talisay",
                        "latitude": "10.69380890",
                        "longitude": "122.92329860"
                    },
                    {
                        "id": 85152,
                        "name": "Toboso",
                        "latitude": "10.72200770",
                        "longitude": "123.26553400"
                    },
                    {
                        "id": 85278,
                        "name": "Valladolid",
                        "latitude": "10.46999870",
                        "longitude": "122.81830690"
                    },
                    {
                        "id": 85286,
                        "name": "Victorias",
                        "latitude": "10.86523800",
                        "longitude": "123.01253880"
                    }
                ]
            },
            {
                "id": 1350,
                "name": "Negros Oriental",
                "iso2": "NER",
                "latitude": "9.62820830",
                "longitude": "122.98883190",
                "type": "province",
                "cities": [
                    {
                        "id": 154730,
                        "name": "Amlan",
                        "latitude": "9.42889660",
                        "longitude": "123.09429250"
                    },
                    {
                        "id": 81342,
                        "name": "Ayungon",
                        "latitude": "9.86362920",
                        "longitude": "122.86901760"
                    },
                    {
                        "id": 81369,
                        "name": "Bacong",
                        "latitude": "9.23897310",
                        "longitude": "123.21582970"
                    },
                    {
                        "id": 81423,
                        "name": "Bais",
                        "latitude": "9.60933500",
                        "longitude": "122.86393220"
                    },
                    {
                        "id": 81596,
                        "name": "Basay",
                        "latitude": "9.45475670",
                        "longitude": "122.59059510"
                    },
                    {
                        "id": 81661,
                        "name": "Bayawan",
                        "latitude": "9.50886240",
                        "longitude": "122.65675830"
                    },
                    {
                        "id": 154731,
                        "name": "Bindoy",
                        "latitude": "9.77925590",
                        "longitude": "122.97889310"
                    },
                    {
                        "id": 82118,
                        "name": "Canlaon",
                        "latitude": "10.34377990",
                        "longitude": "123.11742380"
                    },
                    {
                        "id": 82393,
                        "name": "Dauin",
                        "latitude": "9.15898020",
                        "longitude": "123.13150910"
                    },
                    {
                        "id": 82481,
                        "name": "Dumaguete",
                        "latitude": "9.29581450",
                        "longitude": "123.24086770"
                    },
                    {
                        "id": 82622,
                        "name": "Guihulñgan",
                        "latitude": "10.17300590",
                        "longitude": "123.04887590"
                    },
                    {
                        "id": 82806,
                        "name": "Jimalalud",
                        "latitude": "10.01043450",
                        "longitude": "122.96422530"
                    },
                    {
                        "id": 82943,
                        "name": "La Libertad",
                        "latitude": "10.06545490",
                        "longitude": "122.99355790"
                    },
                    {
                        "id": 154732,
                        "name": "Manjuyod",
                        "latitude": "9.69305120",
                        "longitude": "123.01966260"
                    },
                    {
                        "id": 154733,
                        "name": "Pamplona",
                        "latitude": "9.42632320",
                        "longitude": "122.88736400"
                    },
                    {
                        "id": 154734,
                        "name": "San Jose",
                        "latitude": "9.40426600",
                        "longitude": "123.17443980"
                    },
                    {
                        "id": 154735,
                        "name": "Santa Catalina",
                        "latitude": "9.28893920",
                        "longitude": "122.82567310"
                    },
                    {
                        "id": 84765,
                        "name": "Siaton",
                        "latitude": "9.13018240",
                        "longitude": "122.85142240"
                    },
                    {
                        "id": 84777,
                        "name": "Sibulan",
                        "latitude": "9.34876300",
                        "longitude": "122.99299190"
                    },
                    {
                        "id": 85039,
                        "name": "Tanjay",
                        "latitude": "9.50451240",
                        "longitude": "122.87459670"
                    },
                    {
                        "id": 85072,
                        "name": "Tayasan",
                        "latitude": "9.95619580",
                        "longitude": "123.00683100"
                    },
                    {
                        "id": 85276,
                        "name": "Valencia",
                        "latitude": "9.28729930",
                        "longitude": "123.09086190"
                    },
                    {
                        "id": 85280,
                        "name": "Vallehermoso",
                        "latitude": "10.34193050",
                        "longitude": "123.25546400"
                    },
                    {
                        "id": 85325,
                        "name": "Zamboanguita",
                        "latitude": "9.14250760",
                        "longitude": "123.09765050"
                    }
                ]
            },
            {
                "id": 1339,
                "name": "Northern Mindanao",
                "iso2": "10",
                "latitude": "8.02016350",
                "longitude": "124.68565090",
                "type": "region",
                "cities": []
            },
            {
                "id": 1349,
                "name": "Northern Samar",
                "iso2": "NSA",
                "latitude": "12.36131990",
                "longitude": "124.77407930",
                "type": "province",
                "cities": [
                    {
                        "id": 81224,
                        "name": "Allen",
                        "latitude": "12.52978630",
                        "longitude": "124.24781400"
                    },
                    {
                        "id": 81736,
                        "name": "Biri",
                        "latitude": "12.65401400",
                        "longitude": "124.32008350"
                    },
                    {
                        "id": 81754,
                        "name": "Bobon",
                        "latitude": "12.41771900",
                        "longitude": "124.44076140"
                    },
                    {
                        "id": 82142,
                        "name": "Capul",
                        "latitude": "12.43233530",
                        "longitude": "124.12289040"
                    },
                    {
                        "id": 154736,
                        "name": "Catarman",
                        "latitude": "12.41141030",
                        "longitude": "124.57800460"
                    },
                    {
                        "id": 82218,
                        "name": "Catubig",
                        "latitude": "12.38924370",
                        "longitude": "124.91989910"
                    },
                    {
                        "id": 82555,
                        "name": "Gamay",
                        "latitude": "12.40600320",
                        "longitude": "125.17615870"
                    },
                    {
                        "id": 83028,
                        "name": "Laoang",
                        "latitude": "12.56805190",
                        "longitude": "124.94634690"
                    },
                    {
                        "id": 83033,
                        "name": "Lapinig",
                        "latitude": "12.30600350",
                        "longitude": "125.20220830"
                    },
                    {
                        "id": 83044,
                        "name": "Las Navas",
                        "latitude": "12.31420060",
                        "longitude": "124.87470930"
                    },
                    {
                        "id": 83052,
                        "name": "Lavezares",
                        "latitude": "12.55164820",
                        "longitude": "124.26279140"
                    },
                    {
                        "id": 83176,
                        "name": "Lope de Vega",
                        "latitude": "12.30136700",
                        "longitude": "124.58281110"
                    },
                    {
                        "id": 83550,
                        "name": "Mapanas",
                        "latitude": "12.45160030",
                        "longitude": "125.12281490"
                    },
                    {
                        "id": 83701,
                        "name": "Mondragon",
                        "latitude": "12.41050200",
                        "longitude": "124.59339920"
                    },
                    {
                        "id": 83915,
                        "name": "Palapag",
                        "latitude": "12.52819270",
                        "longitude": "124.96732060"
                    },
                    {
                        "id": 83937,
                        "name": "Pambujan",
                        "latitude": "12.47638550",
                        "longitude": "124.83249260"
                    },
                    {
                        "id": 154737,
                        "name": "Rosario",
                        "latitude": "12.51302520",
                        "longitude": "124.35857850"
                    },
                    {
                        "id": 84447,
                        "name": "San Antonio",
                        "latitude": "12.41029060",
                        "longitude": "124.22198190"
                    },
                    {
                        "id": 154738,
                        "name": "San Isidro",
                        "latitude": "12.34861670",
                        "longitude": "124.31162910"
                    },
                    {
                        "id": 154739,
                        "name": "San Jose",
                        "latitude": "12.50954490",
                        "longitude": "124.40728740"
                    },
                    {
                        "id": 84609,
                        "name": "San Roque",
                        "latitude": "12.45473180",
                        "longitude": "124.80228020"
                    },
                    {
                        "id": 154740,
                        "name": "San Vicente",
                        "latitude": "12.33217930",
                        "longitude": "123.97779060"
                    },
                    {
                        "id": 84797,
                        "name": "Silvino Lobos",
                        "latitude": "12.30367240",
                        "longitude": "124.69352070"
                    },
                    {
                        "id": 154741,
                        "name": "Victoria",
                        "latitude": "12.41128970",
                        "longitude": "124.22119440"
                    }
                ]
            },
            {
                "id": 1360,
                "name": "Nueva Ecija",
                "iso2": "NUE",
                "latitude": "15.57837500",
                "longitude": "121.11126150",
                "type": "province",
                "cities": [
                    {
                        "id": 145343,
                        "name": "Aliaga",
                        "latitude": "15.50701190",
                        "longitude": "120.77497560"
                    },
                    {
                        "id": 145400,
                        "name": "Bongabon",
                        "latitude": "15.65749370",
                        "longitude": "121.06088720"
                    },
                    {
                        "id": 145418,
                        "name": "Cabanatuan",
                        "latitude": "15.50017230",
                        "longitude": "120.81621410"
                    },
                    {
                        "id": 145422,
                        "name": "Cabiao",
                        "latitude": "15.22894910",
                        "longitude": "120.75858200"
                    },
                    {
                        "id": 145445,
                        "name": "Carranglan",
                        "latitude": "15.99307140",
                        "longitude": "120.87201140"
                    },
                    {
                        "id": 145466,
                        "name": "Cuyapo",
                        "latitude": "15.78020570",
                        "longitude": "120.62193420"
                    },
                    {
                        "id": 145484,
                        "name": "Gabaldon",
                        "latitude": "15.52837150",
                        "longitude": "121.20446960"
                    },
                    {
                        "id": 145485,
                        "name": "Gapan",
                        "latitude": "15.29316870",
                        "longitude": "120.93706150"
                    },
                    {
                        "id": 145487,
                        "name": "General Mamerto Natividad",
                        "latitude": "15.58622900",
                        "longitude": "120.97302990"
                    },
                    {
                        "id": 145488,
                        "name": "General Tinio",
                        "latitude": "15.32220840",
                        "longitude": "121.03882320"
                    },
                    {
                        "id": 145493,
                        "name": "Guimba",
                        "latitude": "15.66594070",
                        "longitude": "120.66773020"
                    },
                    {
                        "id": 145500,
                        "name": "Jaen",
                        "latitude": "15.37729880",
                        "longitude": "120.79326870"
                    },
                    {
                        "id": 145506,
                        "name": "Laur",
                        "latitude": "15.51969610",
                        "longitude": "121.10070030"
                    },
                    {
                        "id": 145509,
                        "name": "Licab",
                        "latitude": "15.54659660",
                        "longitude": "120.72060210"
                    },
                    {
                        "id": 145514,
                        "name": "Llanera",
                        "latitude": "15.66174440",
                        "longitude": "120.90681150"
                    },
                    {
                        "id": 145520,
                        "name": "Lupao",
                        "latitude": "15.85360270",
                        "longitude": "120.83484980"
                    },
                    {
                        "id": 145573,
                        "name": "Muñoz",
                        "latitude": "15.73091100",
                        "longitude": "120.82167750"
                    },
                    {
                        "id": 145576,
                        "name": "Nampicuan",
                        "latitude": "15.72087080",
                        "longitude": "120.62629840"
                    },
                    {
                        "id": 145590,
                        "name": "Palayan",
                        "latitude": "15.51831660",
                        "longitude": "121.01272660"
                    },
                    {
                        "id": 145600,
                        "name": "Pantabangan",
                        "latitude": "15.82412890",
                        "longitude": "120.99170480"
                    },
                    {
                        "id": 145607,
                        "name": "Peñaranda",
                        "latitude": "15.35256320",
                        "longitude": "120.95277770"
                    },
                    {
                        "id": 154742,
                        "name": "Quezon",
                        "latitude": "15.58829190",
                        "longitude": "120.74626540"
                    },
                    {
                        "id": 154743,
                        "name": "Rizal",
                        "latitude": "15.68954040",
                        "longitude": "121.04201630"
                    },
                    {
                        "id": 154744,
                        "name": "San Antonio",
                        "latitude": "15.33122100",
                        "longitude": "120.73759630"
                    },
                    {
                        "id": 154745,
                        "name": "San Isidro",
                        "latitude": "15.26252280",
                        "longitude": "120.86188210"
                    },
                    {
                        "id": 154746,
                        "name": "San Jose",
                        "latitude": "15.78780170",
                        "longitude": "120.90703540"
                    },
                    {
                        "id": 145678,
                        "name": "San Leonardo",
                        "latitude": "15.35633910",
                        "longitude": "120.91306150"
                    },
                    {
                        "id": 154747,
                        "name": "Santa Rosa",
                        "latitude": "15.43236870",
                        "longitude": "120.82890340"
                    },
                    {
                        "id": 154748,
                        "name": "Santo Domingo",
                        "latitude": "15.61614200",
                        "longitude": "120.84346080"
                    },
                    {
                        "id": 145766,
                        "name": "Talavera",
                        "latitude": "15.61911180",
                        "longitude": "120.85420270"
                    },
                    {
                        "id": 145768,
                        "name": "Talugtug",
                        "latitude": "15.76130730",
                        "longitude": "120.72097340"
                    },
                    {
                        "id": 145785,
                        "name": "Zaragoza",
                        "latitude": "15.44618550",
                        "longitude": "120.71558080"
                    }
                ]
            },
            {
                "id": 1358,
                "name": "Nueva Vizcaya",
                "iso2": "NUV",
                "latitude": "16.33011070",
                "longitude": "121.17103890",
                "type": "province",
                "cities": [
                    {
                        "id": 145105,
                        "name": "Alfonso Castañeda",
                        "latitude": "15.89895800",
                        "longitude": "121.17600760"
                    },
                    {
                        "id": 145109,
                        "name": "Ambaguio",
                        "latitude": "16.53995740",
                        "longitude": "120.97062670"
                    },
                    {
                        "id": 145114,
                        "name": "Aritao",
                        "latitude": "16.23158790",
                        "longitude": "120.83860710"
                    },
                    {
                        "id": 145119,
                        "name": "Bagabag",
                        "latitude": "16.58500130",
                        "longitude": "121.18752090"
                    },
                    {
                        "id": 145127,
                        "name": "Bambang",
                        "latitude": "16.39101600",
                        "longitude": "120.96551050"
                    },
                    {
                        "id": 145136,
                        "name": "Bayombong",
                        "latitude": "16.49330540",
                        "longitude": "121.06941780"
                    },
                    {
                        "id": 145176,
                        "name": "Diadi",
                        "latitude": "16.62456840",
                        "longitude": "121.26303840"
                    },
                    {
                        "id": 145187,
                        "name": "Dupax del Norte",
                        "latitude": "16.18116500",
                        "longitude": "121.03365740"
                    },
                    {
                        "id": 145188,
                        "name": "Dupax del Sur",
                        "latitude": "16.09976590",
                        "longitude": "120.99863310"
                    },
                    {
                        "id": 145212,
                        "name": "Kasibu",
                        "latitude": "16.36132060",
                        "longitude": "121.14973810"
                    },
                    {
                        "id": 145213,
                        "name": "Kayapa",
                        "latitude": "16.42290360",
                        "longitude": "120.73163530"
                    },
                    {
                        "id": 154749,
                        "name": "Quezon",
                        "latitude": "16.46643840",
                        "longitude": "121.20572230"
                    },
                    {
                        "id": 154750,
                        "name": "Santa Fe",
                        "latitude": "16.18084360",
                        "longitude": "120.71655320"
                    },
                    {
                        "id": 145323,
                        "name": "Solano",
                        "latitude": "16.53167980",
                        "longitude": "121.10704650"
                    },
                    {
                        "id": 145338,
                        "name": "Villaverde",
                        "latitude": "16.59986230",
                        "longitude": "121.08084670"
                    }
                ]
            },
            {
                "id": 1356,
                "name": "Occidental Mindoro",
                "iso2": "MDC",
                "latitude": "13.10241110",
                "longitude": "120.76512840",
                "type": "province",
                "cities": [
                    {
                        "id": 81141,
                        "name": "Abuyon",
                        "latitude": "13.62260000",
                        "longitude": "122.51910000"
                    },
                    {
                        "id": 81151,
                        "name": "Aga",
                        "latitude": "14.09650000",
                        "longitude": "120.80217000"
                    },
                    {
                        "id": 81208,
                        "name": "Aliang",
                        "latitude": "14.28333000",
                        "longitude": "120.88333000"
                    },
                    {
                        "id": 81237,
                        "name": "Alupay",
                        "latitude": "13.84696000",
                        "longitude": "121.30719000"
                    },
                    {
                        "id": 81244,
                        "name": "Ambulong",
                        "latitude": "14.08804000",
                        "longitude": "121.06127000"
                    },
                    {
                        "id": 81288,
                        "name": "Anuling",
                        "latitude": "14.12388000",
                        "longitude": "120.89220000"
                    },
                    {
                        "id": 81297,
                        "name": "Aplaya",
                        "latitude": "14.32106000",
                        "longitude": "121.11369000"
                    },
                    {
                        "id": 81332,
                        "name": "Aurora",
                        "latitude": "13.34760000",
                        "longitude": "122.51950000"
                    },
                    {
                        "id": 81340,
                        "name": "Aya",
                        "latitude": "13.89450000",
                        "longitude": "121.11390000"
                    },
                    {
                        "id": 81343,
                        "name": "Ayusan Uno",
                        "latitude": "13.95609000",
                        "longitude": "121.30765000"
                    },
                    {
                        "id": 81390,
                        "name": "Bagalangit",
                        "latitude": "13.71041000",
                        "longitude": "120.88467000"
                    },
                    {
                        "id": 81397,
                        "name": "Bagombong",
                        "latitude": "14.34130000",
                        "longitude": "121.37750000"
                    },
                    {
                        "id": 81399,
                        "name": "Bagong Pagasa",
                        "latitude": "14.66270000",
                        "longitude": "121.03280000"
                    },
                    {
                        "id": 81414,
                        "name": "Bagupaye",
                        "latitude": "13.56500000",
                        "longitude": "122.39020000"
                    },
                    {
                        "id": 81436,
                        "name": "Balagtasin",
                        "latitude": "13.90180000",
                        "longitude": "121.08890000"
                    },
                    {
                        "id": 81459,
                        "name": "Balele",
                        "latitude": "14.06532000",
                        "longitude": "121.09363000"
                    },
                    {
                        "id": 81467,
                        "name": "Balibago",
                        "latitude": "13.92572000",
                        "longitude": "120.62556000"
                    },
                    {
                        "id": 81482,
                        "name": "Balite Segundo",
                        "latitude": "14.18320000",
                        "longitude": "120.97433000"
                    },
                    {
                        "id": 81483,
                        "name": "Balitoc",
                        "latitude": "13.86269000",
                        "longitude": "120.63554000"
                    },
                    {
                        "id": 81512,
                        "name": "Banaba",
                        "latitude": "14.21667000",
                        "longitude": "120.85000000"
                    },
                    {
                        "id": 81514,
                        "name": "Banalo",
                        "latitude": "13.64640000",
                        "longitude": "121.18170000"
                    },
                    {
                        "id": 81540,
                        "name": "Banilad",
                        "latitude": "14.06670000",
                        "longitude": "120.73470000"
                    },
                    {
                        "id": 81554,
                        "name": "Bantilan",
                        "latitude": "14.75814000",
                        "longitude": "121.66902000"
                    },
                    {
                        "id": 81559,
                        "name": "Banugao",
                        "latitude": "14.74825000",
                        "longitude": "121.61840000"
                    },
                    {
                        "id": 81568,
                        "name": "Baras",
                        "latitude": "14.51691000",
                        "longitude": "121.26580000"
                    },
                    {
                        "id": 81618,
                        "name": "Batas",
                        "latitude": "14.20000000",
                        "longitude": "120.81667000"
                    },
                    {
                        "id": 81647,
                        "name": "Bautista",
                        "latitude": "13.99444000",
                        "longitude": "121.27778000"
                    },
                    {
                        "id": 81664,
                        "name": "Baybayin",
                        "latitude": "13.82083000",
                        "longitude": "121.26992000"
                    },
                    {
                        "id": 81691,
                        "name": "Biga",
                        "latitude": "14.25759000",
                        "longitude": "120.97195000"
                    },
                    {
                        "id": 81696,
                        "name": "Bignay Uno",
                        "latitude": "13.86445000",
                        "longitude": "121.48792000"
                    },
                    {
                        "id": 81702,
                        "name": "Bilaran",
                        "latitude": "14.03528000",
                        "longitude": "120.71028000"
                    },
                    {
                        "id": 81704,
                        "name": "Bilog-Bilog",
                        "latitude": "14.11361000",
                        "longitude": "121.08861000"
                    },
                    {
                        "id": 81708,
                        "name": "Binahaan",
                        "latitude": "13.99170000",
                        "longitude": "121.75391000"
                    },
                    {
                        "id": 81715,
                        "name": "Binay",
                        "latitude": "13.50190000",
                        "longitude": "122.59830000"
                    },
                    {
                        "id": 81733,
                        "name": "Binubusan",
                        "latitude": "13.96947000",
                        "longitude": "120.63572000"
                    },
                    {
                        "id": 81735,
                        "name": "Binulasan",
                        "latitude": "14.73159000",
                        "longitude": "121.69781000"
                    },
                    {
                        "id": 81741,
                        "name": "Bitangan",
                        "latitude": "14.25389000",
                        "longitude": "120.87833000"
                    },
                    {
                        "id": 81744,
                        "name": "Bitin",
                        "latitude": "14.11647000",
                        "longitude": "121.22194000"
                    },
                    {
                        "id": 81767,
                        "name": "Bolboc",
                        "latitude": "14.02074000",
                        "longitude": "120.75595000"
                    },
                    {
                        "id": 81775,
                        "name": "Bolo",
                        "latitude": "13.78991000",
                        "longitude": "120.98173000"
                    },
                    {
                        "id": 81795,
                        "name": "Boot",
                        "latitude": "14.04556000",
                        "longitude": "121.07722000"
                    },
                    {
                        "id": 81800,
                        "name": "Bosdak",
                        "latitude": "13.40000000",
                        "longitude": "122.50000000"
                    },
                    {
                        "id": 81839,
                        "name": "Bugaan",
                        "latitude": "14.03987000",
                        "longitude": "120.93609000"
                    },
                    {
                        "id": 81855,
                        "name": "Bukal",
                        "latitude": "13.91320000",
                        "longitude": "121.52640000"
                    },
                    {
                        "id": 81856,
                        "name": "Bukal Sur",
                        "latitude": "13.93806000",
                        "longitude": "121.38556000"
                    },
                    {
                        "id": 81862,
                        "name": "Bulacnin",
                        "latitude": "13.99030000",
                        "longitude": "121.13900000"
                    },
                    {
                        "id": 81875,
                        "name": "Bulihan",
                        "latitude": "14.27820000",
                        "longitude": "120.99503000"
                    },
                    {
                        "id": 81896,
                        "name": "Bungahan",
                        "latitude": "13.94286000",
                        "longitude": "120.66178000"
                    },
                    {
                        "id": 81897,
                        "name": "Bungoy",
                        "latitude": "13.99779000",
                        "longitude": "121.36564000"
                    },
                    {
                        "id": 81945,
                        "name": "Cabanbanan",
                        "latitude": "14.24040000",
                        "longitude": "121.43410000"
                    },
                    {
                        "id": 81955,
                        "name": "Cabatang",
                        "latitude": "13.96690000",
                        "longitude": "121.36680000"
                    },
                    {
                        "id": 81959,
                        "name": "Cabay",
                        "latitude": "13.87080000",
                        "longitude": "121.37992000"
                    },
                    {
                        "id": 81999,
                        "name": "Cagsiay",
                        "latitude": "14.21667000",
                        "longitude": "121.75000000"
                    },
                    {
                        "id": 82027,
                        "name": "Calantas",
                        "latitude": "13.97202000",
                        "longitude": "120.77456000"
                    },
                    {
                        "id": 82052,
                        "name": "Calilayan",
                        "latitude": "13.85030000",
                        "longitude": "121.93000000"
                    },
                    {
                        "id": 82067,
                        "name": "Calubcub Dos",
                        "latitude": "13.73930000",
                        "longitude": "121.42193000"
                    },
                    {
                        "id": 82070,
                        "name": "Calumpang",
                        "latitude": "14.19660000",
                        "longitude": "121.40200000"
                    },
                    {
                        "id": 82087,
                        "name": "Cambuga",
                        "latitude": "13.61667000",
                        "longitude": "122.45000000"
                    },
                    {
                        "id": 82093,
                        "name": "Camohaguin",
                        "latitude": "13.90890000",
                        "longitude": "122.16660000"
                    },
                    {
                        "id": 82094,
                        "name": "Camp Flora",
                        "latitude": "13.35080000",
                        "longitude": "122.66410000"
                    },
                    {
                        "id": 82144,
                        "name": "Capuluan",
                        "latitude": "13.81620000",
                        "longitude": "122.51580000"
                    },
                    {
                        "id": 82190,
                        "name": "Casay",
                        "latitude": "13.26320000",
                        "longitude": "122.52170000"
                    },
                    {
                        "id": 82195,
                        "name": "Castañas",
                        "latitude": "13.87440000",
                        "longitude": "121.55330000"
                    },
                    {
                        "id": 82199,
                        "name": "Casuguran",
                        "latitude": "14.71670000",
                        "longitude": "122.37422000"
                    },
                    {
                        "id": 82244,
                        "name": "Cigaras",
                        "latitude": "14.22660000",
                        "longitude": "121.42980000"
                    },
                    {
                        "id": 82276,
                        "name": "Concepcion Ibaba",
                        "latitude": "13.92309000",
                        "longitude": "121.46099000"
                    },
                    {
                        "id": 82333,
                        "name": "Dagatan",
                        "latitude": "14.00170000",
                        "longitude": "121.37670000"
                    },
                    {
                        "id": 82384,
                        "name": "Daraitan",
                        "latitude": "14.60280000",
                        "longitude": "121.43190000"
                    },
                    {
                        "id": 82399,
                        "name": "Dayap",
                        "latitude": "14.18014000",
                        "longitude": "121.33335000"
                    },
                    {
                        "id": 82400,
                        "name": "Dayapan",
                        "latitude": "13.93723000",
                        "longitude": "120.91620000"
                    },
                    {
                        "id": 82407,
                        "name": "Del Monte",
                        "latitude": "14.64180000",
                        "longitude": "121.01770000"
                    },
                    {
                        "id": 82435,
                        "name": "Dinahican",
                        "latitude": "14.71667000",
                        "longitude": "121.71667000"
                    },
                    {
                        "id": 82630,
                        "name": "Guinayangan Fourth District of Quezon",
                        "latitude": "13.90020000",
                        "longitude": "122.44808000"
                    },
                    {
                        "id": 82648,
                        "name": "Guisguis",
                        "latitude": "13.87380000",
                        "longitude": "121.51890000"
                    },
                    {
                        "id": 82652,
                        "name": "Gulod",
                        "latitude": "14.34490000",
                        "longitude": "121.21770000"
                    },
                    {
                        "id": 82656,
                        "name": "Gumian",
                        "latitude": "14.71006000",
                        "longitude": "121.61867000"
                    },
                    {
                        "id": 82661,
                        "name": "Guyam Malaki",
                        "latitude": "14.15250000",
                        "longitude": "120.86111000"
                    },
                    {
                        "id": 82672,
                        "name": "Halayhay",
                        "latitude": "14.37389000",
                        "longitude": "120.81333000"
                    },
                    {
                        "id": 82673,
                        "name": "Halayhayin",
                        "latitude": "14.18910000",
                        "longitude": "121.40750000"
                    },
                    {
                        "id": 82674,
                        "name": "Haligue",
                        "latitude": "13.66667000",
                        "longitude": "121.11667000"
                    },
                    {
                        "id": 82704,
                        "name": "Hondagua",
                        "latitude": "13.94550000",
                        "longitude": "122.24170000"
                    },
                    {
                        "id": 82705,
                        "name": "Hukay",
                        "latitude": "13.84519000",
                        "longitude": "120.70287000"
                    },
                    {
                        "id": 82708,
                        "name": "Ibabang Tayuman",
                        "latitude": "13.40420000",
                        "longitude": "122.51650000"
                    },
                    {
                        "id": 82728,
                        "name": "Ilihan",
                        "latitude": "13.63100000",
                        "longitude": "121.07090000"
                    },
                    {
                        "id": 82751,
                        "name": "Inicbulan",
                        "latitude": "13.82043000",
                        "longitude": "120.98345000"
                    },
                    {
                        "id": 82768,
                        "name": "Isabang",
                        "latitude": "13.95694000",
                        "longitude": "121.57083000"
                    },
                    {
                        "id": 82790,
                        "name": "Janagdong",
                        "latitude": "13.90340000",
                        "longitude": "121.51340000"
                    },
                    {
                        "id": 82793,
                        "name": "Janopol",
                        "latitude": "14.08586000",
                        "longitude": "121.09489000"
                    },
                    {
                        "id": 82800,
                        "name": "Javalera",
                        "latitude": "14.25813000",
                        "longitude": "120.91558000"
                    },
                    {
                        "id": 82831,
                        "name": "Kabulusan",
                        "latitude": "14.36150000",
                        "longitude": "121.40040000"
                    },
                    {
                        "id": 82863,
                        "name": "Kanluran",
                        "latitude": "14.41667000",
                        "longitude": "120.85000000"
                    },
                    {
                        "id": 82869,
                        "name": "Kapatalan",
                        "latitude": "14.47410000",
                        "longitude": "121.49030000"
                    },
                    {
                        "id": 82873,
                        "name": "Karligan",
                        "latitude": "14.97561000",
                        "longitude": "122.04272000"
                    },
                    {
                        "id": 82890,
                        "name": "Kaytitinga",
                        "latitude": "14.10722000",
                        "longitude": "120.82917000"
                    },
                    {
                        "id": 82901,
                        "name": "Kiloloran",
                        "latitude": "14.63571000",
                        "longitude": "121.60617000"
                    },
                    {
                        "id": 82906,
                        "name": "Kinalaglagan",
                        "latitude": "14.00149000",
                        "longitude": "121.09772000"
                    },
                    {
                        "id": 82910,
                        "name": "Kinatakutan",
                        "latitude": "13.95500000",
                        "longitude": "122.46780000"
                    },
                    {
                        "id": 82971,
                        "name": "Lacdayan",
                        "latitude": "13.60000000",
                        "longitude": "122.53333000"
                    },
                    {
                        "id": 82984,
                        "name": "Laiya",
                        "latitude": "13.68031000",
                        "longitude": "121.40081000"
                    },
                    {
                        "id": 82991,
                        "name": "Lalig",
                        "latitude": "13.98255000",
                        "longitude": "121.32647000"
                    },
                    {
                        "id": 83036,
                        "name": "Lapolapo",
                        "latitude": "13.83410000",
                        "longitude": "121.13790000"
                    },
                    {
                        "id": 83082,
                        "name": "Libato",
                        "latitude": "13.81514000",
                        "longitude": "121.33463000"
                    },
                    {
                        "id": 83109,
                        "name": "Lilio",
                        "latitude": "14.13130000",
                        "longitude": "121.43620000"
                    },
                    {
                        "id": 83146,
                        "name": "Lipa City",
                        "latitude": "13.94110000",
                        "longitude": "121.16310000"
                    },
                    {
                        "id": 83147,
                        "name": "Lipahan",
                        "latitude": "13.83687000",
                        "longitude": "121.40167000"
                    },
                    {
                        "id": 83173,
                        "name": "Looc",
                        "latitude": "14.16480000",
                        "longitude": "120.62930000"
                    },
                    {
                        "id": 83204,
                        "name": "Lucsuhin",
                        "latitude": "13.88186000",
                        "longitude": "120.64131000"
                    },
                    {
                        "id": 83212,
                        "name": "Luksuhin",
                        "latitude": "14.09667000",
                        "longitude": "120.88083000"
                    },
                    {
                        "id": 83217,
                        "name": "Lumbang",
                        "latitude": "14.29730000",
                        "longitude": "121.45980000"
                    },
                    {
                        "id": 83218,
                        "name": "Lumbangan",
                        "latitude": "14.05240000",
                        "longitude": "120.66670000"
                    },
                    {
                        "id": 83225,
                        "name": "Lumil",
                        "latitude": "14.18144000",
                        "longitude": "121.00989000"
                    },
                    {
                        "id": 83241,
                        "name": "Luntal",
                        "latitude": "14.02920000",
                        "longitude": "120.71740000"
                    },
                    {
                        "id": 83248,
                        "name": "Lusacan",
                        "latitude": "13.95523000",
                        "longitude": "121.34477000"
                    },
                    {
                        "id": 83275,
                        "name": "Mabini",
                        "latitude": "13.75324000",
                        "longitude": "120.94049000"
                    },
                    {
                        "id": 83284,
                        "name": "Mabitac",
                        "latitude": "14.42590000",
                        "longitude": "121.42900000"
                    },
                    {
                        "id": 83289,
                        "name": "Mabunga",
                        "latitude": "13.86340000",
                        "longitude": "122.06770000"
                    },
                    {
                        "id": 83297,
                        "name": "Macalamcam A",
                        "latitude": "13.85660000",
                        "longitude": "121.32814000"
                    },
                    {
                        "id": 83316,
                        "name": "Madulao",
                        "latitude": "13.56840000",
                        "longitude": "122.34130000"
                    },
                    {
                        "id": 83345,
                        "name": "Magsaysay",
                        "latitude": "14.33880000",
                        "longitude": "121.03410000"
                    },
                    {
                        "id": 83353,
                        "name": "Maguyam",
                        "latitude": "14.26277000",
                        "longitude": "121.00500000"
                    },
                    {
                        "id": 83355,
                        "name": "Mahabang Parang",
                        "latitude": "13.98333000",
                        "longitude": "121.08333000"
                    },
                    {
                        "id": 83372,
                        "name": "Mainit Norte",
                        "latitude": "14.16546000",
                        "longitude": "121.98496000"
                    },
                    {
                        "id": 83380,
                        "name": "Malabag",
                        "latitude": "14.15520000",
                        "longitude": "120.96547000"
                    },
                    {
                        "id": 83382,
                        "name": "Malabanan",
                        "latitude": "14.00000000",
                        "longitude": "121.13333000"
                    },
                    {
                        "id": 83383,
                        "name": "Malabanban Norte",
                        "latitude": "13.94521000",
                        "longitude": "121.43065000"
                    },
                    {
                        "id": 83395,
                        "name": "Malainen Luma",
                        "latitude": "14.27030000",
                        "longitude": "120.78840000"
                    },
                    {
                        "id": 83402,
                        "name": "Malanday",
                        "latitude": "14.70690000",
                        "longitude": "121.13060000"
                    },
                    {
                        "id": 83407,
                        "name": "Malaruhatan",
                        "latitude": "14.03060000",
                        "longitude": "120.68040000"
                    },
                    {
                        "id": 83416,
                        "name": "Malaya",
                        "latitude": "14.39710000",
                        "longitude": "121.33850000"
                    },
                    {
                        "id": 83426,
                        "name": "Malicboy",
                        "latitude": "13.98155000",
                        "longitude": "121.78888000"
                    },
                    {
                        "id": 83438,
                        "name": "Malinao Ilaya",
                        "latitude": "13.99611000",
                        "longitude": "121.83577000"
                    },
                    {
                        "id": 83467,
                        "name": "Mamala",
                        "latitude": "14.01667000",
                        "longitude": "121.51667000"
                    },
                    {
                        "id": 83469,
                        "name": "Mamatid",
                        "latitude": "14.23490000",
                        "longitude": "121.15902000"
                    },
                    {
                        "id": 83512,
                        "name": "Mangas",
                        "latitude": "14.11769000",
                        "longitude": "120.86661000"
                    },
                    {
                        "id": 83514,
                        "name": "Mangero",
                        "latitude": "13.27050000",
                        "longitude": "122.67740000"
                    },
                    {
                        "id": 83516,
                        "name": "Manggahan",
                        "latitude": "14.29196000",
                        "longitude": "120.90145000"
                    },
                    {
                        "id": 83555,
                        "name": "Mapulo",
                        "latitude": "13.73170000",
                        "longitude": "121.18420000"
                    },
                    {
                        "id": 83556,
                        "name": "Mapulot",
                        "latitude": "14.03300000",
                        "longitude": "122.53990000"
                    },
                    {
                        "id": 83564,
                        "name": "Marao",
                        "latitude": "13.91434000",
                        "longitude": "121.82409000"
                    },
                    {
                        "id": 83594,
                        "name": "Masalukot Uno",
                        "latitude": "13.95533000",
                        "longitude": "121.41887000"
                    },
                    {
                        "id": 83596,
                        "name": "Masapang",
                        "latitude": "14.19710000",
                        "longitude": "121.34230000"
                    },
                    {
                        "id": 83599,
                        "name": "Masaya",
                        "latitude": "14.15189000",
                        "longitude": "121.28190000"
                    },
                    {
                        "id": 83611,
                        "name": "Mataas Na Kahoy",
                        "latitude": "13.95890000",
                        "longitude": "121.11380000"
                    },
                    {
                        "id": 83614,
                        "name": "Matagbak",
                        "latitude": "14.13056000",
                        "longitude": "120.83472000"
                    },
                    {
                        "id": 83615,
                        "name": "Matala",
                        "latitude": "13.82870000",
                        "longitude": "121.15490000"
                    },
                    {
                        "id": 83623,
                        "name": "Mataywanac",
                        "latitude": "14.03110000",
                        "longitude": "120.72960000"
                    },
                    {
                        "id": 83628,
                        "name": "Matingain",
                        "latitude": "13.91290000",
                        "longitude": "120.88006000"
                    },
                    {
                        "id": 83637,
                        "name": "Maugat West",
                        "latitude": "13.86130000",
                        "longitude": "121.28276000"
                    },
                    {
                        "id": 83639,
                        "name": "Maulawin",
                        "latitude": "14.26667000",
                        "longitude": "121.43333000"
                    },
                    {
                        "id": 83658,
                        "name": "Mendez-Nuñez",
                        "latitude": "14.12861000",
                        "longitude": "120.90583000"
                    },
                    {
                        "id": 83706,
                        "name": "Montecillo",
                        "latitude": "13.89067000",
                        "longitude": "121.47575000"
                    },
                    {
                        "id": 83718,
                        "name": "Mozon",
                        "latitude": "13.85260000",
                        "longitude": "120.98935000"
                    },
                    {
                        "id": 83722,
                        "name": "Mulauin",
                        "latitude": "13.86667000",
                        "longitude": "121.01667000"
                    },
                    {
                        "id": 83796,
                        "name": "Navotas",
                        "latitude": "14.41670000",
                        "longitude": "121.22680000"
                    },
                    {
                        "id": 83871,
                        "name": "Paagahan",
                        "latitude": "14.44470000",
                        "longitude": "121.40100000"
                    },
                    {
                        "id": 83898,
                        "name": "Pagsañgahan",
                        "latitude": "13.21583000",
                        "longitude": "122.54306000"
                    },
                    {
                        "id": 83900,
                        "name": "Paiisa",
                        "latitude": "13.92629000",
                        "longitude": "121.35415000"
                    },
                    {
                        "id": 83909,
                        "name": "Palahanan Uno",
                        "latitude": "13.83113000",
                        "longitude": "121.35639000"
                    },
                    {
                        "id": 83913,
                        "name": "Palangue",
                        "latitude": "14.28417000",
                        "longitude": "120.81139000"
                    },
                    {
                        "id": 83972,
                        "name": "Pangao",
                        "latitude": "13.91722000",
                        "longitude": "121.12556000"
                    },
                    {
                        "id": 83987,
                        "name": "Panikihan",
                        "latitude": "13.90830000",
                        "longitude": "122.13100000"
                    },
                    {
                        "id": 83996,
                        "name": "Pansol",
                        "latitude": "13.88660000",
                        "longitude": "121.24320000"
                    },
                    {
                        "id": 83997,
                        "name": "Pansoy",
                        "latitude": "13.18177000",
                        "longitude": "122.59989000"
                    },
                    {
                        "id": 84002,
                        "name": "Pantay Na Matanda",
                        "latitude": "14.11750000",
                        "longitude": "121.12111000"
                    },
                    {
                        "id": 84003,
                        "name": "Pantijan No 2",
                        "latitude": "14.23306000",
                        "longitude": "120.80056000"
                    },
                    {
                        "id": 84014,
                        "name": "Paradahan",
                        "latitude": "14.32123000",
                        "longitude": "120.86059000"
                    },
                    {
                        "id": 84033,
                        "name": "Pasong Kawayan Primero",
                        "latitude": "14.34317000",
                        "longitude": "120.88157000"
                    },
                    {
                        "id": 84038,
                        "name": "Patabog",
                        "latitude": "13.44320000",
                        "longitude": "122.45570000"
                    },
                    {
                        "id": 84055,
                        "name": "Patuto",
                        "latitude": "14.11667000",
                        "longitude": "120.96667000"
                    },
                    {
                        "id": 84068,
                        "name": "Payapa",
                        "latitude": "13.99803000",
                        "longitude": "120.89207000"
                    },
                    {
                        "id": 84102,
                        "name": "Pinagsibaan",
                        "latitude": "13.83479000",
                        "longitude": "121.32118000"
                    },
                    {
                        "id": 84116,
                        "name": "Pinugay",
                        "latitude": "14.59670000",
                        "longitude": "121.26230000"
                    },
                    {
                        "id": 84138,
                        "name": "Poctol",
                        "latitude": "13.82095000",
                        "longitude": "121.44184000"
                    },
                    {
                        "id": 84176,
                        "name": "Prinza",
                        "latitude": "13.99679000",
                        "longitude": "120.65409000"
                    },
                    {
                        "id": 84177,
                        "name": "Progreso",
                        "latitude": "13.90830000",
                        "longitude": "122.09060000"
                    },
                    {
                        "id": 84191,
                        "name": "Province of Batangas",
                        "latitude": "13.91667000",
                        "longitude": "121.08333000"
                    },
                    {
                        "id": 84201,
                        "name": "Province of Cavite",
                        "latitude": "14.25000000",
                        "longitude": "120.83333000"
                    },
                    {
                        "id": 84215,
                        "name": "Province of Laguna",
                        "latitude": "14.16667000",
                        "longitude": "121.33333000"
                    },
                    {
                        "id": 84234,
                        "name": "Province of Quezon",
                        "latitude": "14.66667000",
                        "longitude": "121.50000000"
                    },
                    {
                        "id": 84236,
                        "name": "Province of Rizal",
                        "latitude": "14.58333000",
                        "longitude": "121.16667000"
                    },
                    {
                        "id": 84262,
                        "name": "Pulangbato",
                        "latitude": "13.75387000",
                        "longitude": "121.39266000"
                    },
                    {
                        "id": 84264,
                        "name": "Pulo",
                        "latitude": "14.71462000",
                        "longitude": "121.63293000"
                    },
                    {
                        "id": 84268,
                        "name": "Pulong Santa Cruz",
                        "latitude": "14.27324000",
                        "longitude": "121.07643000"
                    },
                    {
                        "id": 84279,
                        "name": "Punta",
                        "latitude": "14.29140000",
                        "longitude": "121.30740000"
                    },
                    {
                        "id": 84290,
                        "name": "Puting Kahoy",
                        "latitude": "14.21570000",
                        "longitude": "121.03100000"
                    },
                    {
                        "id": 84291,
                        "name": "Putingkahoy",
                        "latitude": "13.83023000",
                        "longitude": "121.32753000"
                    },
                    {
                        "id": 84293,
                        "name": "Putol",
                        "latitude": "13.99220000",
                        "longitude": "120.72750000"
                    },
                    {
                        "id": 84305,
                        "name": "Quilo-quilo",
                        "latitude": "13.86380000",
                        "longitude": "121.22090000"
                    },
                    {
                        "id": 84313,
                        "name": "Quipot",
                        "latitude": "13.95560000",
                        "longitude": "121.31903000"
                    },
                    {
                        "id": 84316,
                        "name": "Quisao",
                        "latitude": "14.43470000",
                        "longitude": "121.33440000"
                    },
                    {
                        "id": 84348,
                        "name": "Rizal",
                        "latitude": "14.10944000",
                        "longitude": "121.39360000"
                    },
                    {
                        "id": 84369,
                        "name": "Sabang",
                        "latitude": "14.30556000",
                        "longitude": "120.80361000"
                    },
                    {
                        "id": 84435,
                        "name": "Sampiro",
                        "latitude": "13.78417000",
                        "longitude": "121.38417000"
                    },
                    {
                        "id": 84459,
                        "name": "San Carlos",
                        "latitude": "13.84220000",
                        "longitude": "121.24160000"
                    },
                    {
                        "id": 84462,
                        "name": "San Celestio",
                        "latitude": "13.92580000",
                        "longitude": "121.23490000"
                    },
                    {
                        "id": 84465,
                        "name": "San Diego",
                        "latitude": "14.04220000",
                        "longitude": "120.62550000"
                    },
                    {
                        "id": 84484,
                        "name": "San Francisco",
                        "latitude": "13.79110000",
                        "longitude": "122.28760000"
                    },
                    {
                        "id": 84494,
                        "name": "San Gregorio",
                        "latitude": "14.02970000",
                        "longitude": "121.26390000"
                    },
                    {
                        "id": 84501,
                        "name": "San Isidro",
                        "latitude": "13.63250000",
                        "longitude": "122.24280000"
                    },
                    {
                        "id": 84509,
                        "name": "San Joaquin",
                        "latitude": "14.04695000",
                        "longitude": "121.21864000"
                    },
                    {
                        "id": 84564,
                        "name": "San Miguel",
                        "latitude": "13.87400000",
                        "longitude": "121.19830000"
                    },
                    {
                        "id": 84575,
                        "name": "San Pablo",
                        "latitude": "14.06830000",
                        "longitude": "121.32560000"
                    },
                    {
                        "id": 84586,
                        "name": "San Pedro",
                        "latitude": "14.35950000",
                        "longitude": "121.04730000"
                    },
                    {
                        "id": 84590,
                        "name": "San Pedro One",
                        "latitude": "14.05341000",
                        "longitude": "121.14536000"
                    },
                    {
                        "id": 84596,
                        "name": "San Rafael",
                        "latitude": "14.12840000",
                        "longitude": "121.41470000"
                    },
                    {
                        "id": 84624,
                        "name": "San Vicente",
                        "latitude": "13.89670000",
                        "longitude": "122.20470000"
                    },
                    {
                        "id": 84650,
                        "name": "Santa Catalina Norte",
                        "latitude": "13.87083000",
                        "longitude": "121.35750000"
                    },
                    {
                        "id": 84651,
                        "name": "Santa Catalina Sur",
                        "latitude": "13.87384000",
                        "longitude": "121.43104000"
                    },
                    {
                        "id": 84652,
                        "name": "Santa Cecilia",
                        "latitude": "14.10540000",
                        "longitude": "122.20160000"
                    },
                    {
                        "id": 84653,
                        "name": "Santa Clara",
                        "latitude": "13.75361000",
                        "longitude": "121.06056000"
                    },
                    {
                        "id": 84659,
                        "name": "Santa Cruz",
                        "latitude": "14.28140000",
                        "longitude": "121.41610000"
                    },
                    {
                        "id": 84677,
                        "name": "Santa Lucia",
                        "latitude": "14.03490000",
                        "longitude": "121.43120000"
                    },
                    {
                        "id": 84698,
                        "name": "Santa Rita Aplaya",
                        "latitude": "13.77173000",
                        "longitude": "121.03492000"
                    },
                    {
                        "id": 84712,
                        "name": "Santiago",
                        "latitude": "14.02110000",
                        "longitude": "121.27920000"
                    },
                    {
                        "id": 84716,
                        "name": "Santisimo Rosario",
                        "latitude": "13.99661000",
                        "longitude": "121.30918000"
                    },
                    {
                        "id": 84727,
                        "name": "Santo Niño",
                        "latitude": "13.84890000",
                        "longitude": "121.13280000"
                    },
                    {
                        "id": 84738,
                        "name": "Santor",
                        "latitude": "14.09549000",
                        "longitude": "121.10874000"
                    },
                    {
                        "id": 84781,
                        "name": "Sico Uno",
                        "latitude": "13.83010000",
                        "longitude": "121.37123000"
                    },
                    {
                        "id": 84796,
                        "name": "Silongin",
                        "latitude": "13.29990000",
                        "longitude": "122.52170000"
                    },
                    {
                        "id": 84809,
                        "name": "Sinala",
                        "latitude": "13.80570000",
                        "longitude": "120.97463000"
                    },
                    {
                        "id": 84817,
                        "name": "Sinisian",
                        "latitude": "13.91560000",
                        "longitude": "120.84401000"
                    },
                    {
                        "id": 84844,
                        "name": "Solo",
                        "latitude": "13.74691000",
                        "longitude": "120.90119000"
                    },
                    {
                        "id": 84933,
                        "name": "Tagbacan Ibaba",
                        "latitude": "13.60280000",
                        "longitude": "122.36870000"
                    },
                    {
                        "id": 84942,
                        "name": "Tagkawayan Sabang",
                        "latitude": "13.99090000",
                        "longitude": "122.52980000"
                    },
                    {
                        "id": 84958,
                        "name": "Tala",
                        "latitude": "13.27420000",
                        "longitude": "122.58590000"
                    },
                    {
                        "id": 84963,
                        "name": "Talaga",
                        "latitude": "13.73646000",
                        "longitude": "120.93618000"
                    },
                    {
                        "id": 84965,
                        "name": "Talahib Payap",
                        "latitude": "13.66083000",
                        "longitude": "121.13639000"
                    },
                    {
                        "id": 84966,
                        "name": "Talahiban I",
                        "latitude": "13.80645000",
                        "longitude": "121.38116000"
                    },
                    {
                        "id": 84967,
                        "name": "Talaibon",
                        "latitude": "13.83780000",
                        "longitude": "121.13980000"
                    },
                    {
                        "id": 84976,
                        "name": "Talipan",
                        "latitude": "13.93333000",
                        "longitude": "121.68333000"
                    },
                    {
                        "id": 85069,
                        "name": "Tayabas Ibaba",
                        "latitude": "13.62220000",
                        "longitude": "122.28140000"
                    },
                    {
                        "id": 85083,
                        "name": "Taywanak Ilaya",
                        "latitude": "14.15759000",
                        "longitude": "120.84655000"
                    },
                    {
                        "id": 85110,
                        "name": "Tignoan",
                        "latitude": "14.56522000",
                        "longitude": "121.61786000"
                    },
                    {
                        "id": 85144,
                        "name": "Tipaz",
                        "latitude": "13.82850000",
                        "longitude": "121.42506000"
                    },
                    {
                        "id": 85169,
                        "name": "Toong",
                        "latitude": "14.07063000",
                        "longitude": "120.76333000"
                    },
                    {
                        "id": 85176,
                        "name": "Tranca",
                        "latitude": "14.11815000",
                        "longitude": "121.05741000"
                    },
                    {
                        "id": 85213,
                        "name": "Tuhian",
                        "latitude": "13.62220000",
                        "longitude": "122.21780000"
                    },
                    {
                        "id": 85215,
                        "name": "Tulay",
                        "latitude": "14.26969000",
                        "longitude": "120.76925000"
                    },
                    {
                        "id": 85220,
                        "name": "Tumalim",
                        "latitude": "14.08010000",
                        "longitude": "120.72310000"
                    },
                    {
                        "id": 85284,
                        "name": "Victoria",
                        "latitude": "14.22770000",
                        "longitude": "121.32920000"
                    },
                    {
                        "id": 85314,
                        "name": "Wawa",
                        "latitude": "13.74010000",
                        "longitude": "121.05290000"
                    },
                    {
                        "id": 85323,
                        "name": "Yuni",
                        "latitude": "13.41240000",
                        "longitude": "122.48460000"
                    }
                ]
            },
            {
                "id": 1354,
                "name": "Oriental Mindoro",
                "iso2": "MDR",
                "latitude": "13.05645980",
                "longitude": "121.40694170",
                "type": "province",
                "cities": [
                    {
                        "id": 81133,
                        "name": "Abra de Ilog",
                        "latitude": "13.44370000",
                        "longitude": "120.72910000"
                    },
                    {
                        "id": 81145,
                        "name": "Adela",
                        "latitude": "12.44164000",
                        "longitude": "120.97291000"
                    },
                    {
                        "id": 81156,
                        "name": "Agcogon",
                        "latitude": "12.06146000",
                        "longitude": "121.95911000"
                    },
                    {
                        "id": 81181,
                        "name": "Alad",
                        "latitude": "12.61682000",
                        "longitude": "122.24751000"
                    },
                    {
                        "id": 81204,
                        "name": "Alemanguan",
                        "latitude": "10.61177000",
                        "longitude": "119.32680000"
                    },
                    {
                        "id": 81206,
                        "name": "Algeciras",
                        "latitude": "11.41540000",
                        "longitude": "120.81680000"
                    },
                    {
                        "id": 81210,
                        "name": "Alibug",
                        "latitude": "12.22906000",
                        "longitude": "121.22811000"
                    },
                    {
                        "id": 81272,
                        "name": "Anilao",
                        "latitude": "12.71402000",
                        "longitude": "121.51242000"
                    },
                    {
                        "id": 81295,
                        "name": "Apitong",
                        "latitude": "13.23910000",
                        "longitude": "121.20750000"
                    },
                    {
                        "id": 81300,
                        "name": "Apurawan",
                        "latitude": "9.59940000",
                        "longitude": "118.34890000"
                    },
                    {
                        "id": 81304,
                        "name": "Aramawayan",
                        "latitude": "9.34247000",
                        "longitude": "118.16230000"
                    },
                    {
                        "id": 81305,
                        "name": "Aramayuan",
                        "latitude": "9.17008000",
                        "longitude": "118.18720000"
                    },
                    {
                        "id": 81333,
                        "name": "Aurora",
                        "latitude": "13.23220000",
                        "longitude": "121.12030000"
                    },
                    {
                        "id": 81350,
                        "name": "Babug",
                        "latitude": "12.37325000",
                        "longitude": "121.04171000"
                    },
                    {
                        "id": 81362,
                        "name": "Baco",
                        "latitude": "13.35730000",
                        "longitude": "121.09830000"
                    },
                    {
                        "id": 81377,
                        "name": "Bacungan",
                        "latitude": "9.91056000",
                        "longitude": "118.70222000"
                    },
                    {
                        "id": 81400,
                        "name": "Bagong Sikat",
                        "latitude": "12.36745000",
                        "longitude": "121.06171000"
                    },
                    {
                        "id": 81418,
                        "name": "Baheli",
                        "latitude": "10.01369000",
                        "longitude": "118.77294000"
                    },
                    {
                        "id": 81440,
                        "name": "Balanacan",
                        "latitude": "13.52890000",
                        "longitude": "121.86770000"
                    },
                    {
                        "id": 81454,
                        "name": "Balatero",
                        "latitude": "13.50210000",
                        "longitude": "120.92440000"
                    },
                    {
                        "id": 81504,
                        "name": "Balugo",
                        "latitude": "12.57923000",
                        "longitude": "121.43931000"
                    },
                    {
                        "id": 81545,
                        "name": "Banos",
                        "latitude": "12.64553000",
                        "longitude": "120.90972000"
                    },
                    {
                        "id": 81548,
                        "name": "Bansud",
                        "latitude": "12.86500000",
                        "longitude": "121.45639000"
                    },
                    {
                        "id": 81564,
                        "name": "Barahan",
                        "latitude": "13.01210000",
                        "longitude": "120.76200000"
                    },
                    {
                        "id": 81581,
                        "name": "Barong Barong",
                        "latitude": "8.85350000",
                        "longitude": "117.89390000"
                    },
                    {
                        "id": 81617,
                        "name": "Batarasa",
                        "latitude": "8.67335000",
                        "longitude": "117.62795000"
                    },
                    {
                        "id": 81620,
                        "name": "Batasan",
                        "latitude": "12.76667000",
                        "longitude": "120.78333000"
                    },
                    {
                        "id": 81669,
                        "name": "Bayuin",
                        "latitude": "13.04110000",
                        "longitude": "121.38852000"
                    },
                    {
                        "id": 81728,
                        "name": "Bintacay",
                        "latitude": "13.49860000",
                        "longitude": "121.87680000"
                    },
                    {
                        "id": 81865,
                        "name": "Bulalacao",
                        "latitude": "12.32535000",
                        "longitude": "121.34351000"
                    },
                    {
                        "id": 81888,
                        "name": "Buluang",
                        "latitude": "12.23336000",
                        "longitude": "119.87581000"
                    },
                    {
                        "id": 81900,
                        "name": "Bunog",
                        "latitude": "9.14028000",
                        "longitude": "117.78167000"
                    },
                    {
                        "id": 81913,
                        "name": "Burirao",
                        "latitude": "9.20000000",
                        "longitude": "118.10000000"
                    },
                    {
                        "id": 81929,
                        "name": "Buyabod",
                        "latitude": "13.46660000",
                        "longitude": "122.05260000"
                    },
                    {
                        "id": 81934,
                        "name": "Cabacao",
                        "latitude": "13.33560000",
                        "longitude": "120.65880000"
                    },
                    {
                        "id": 81976,
                        "name": "Cabra",
                        "latitude": "13.88833000",
                        "longitude": "120.04944000"
                    },
                    {
                        "id": 81993,
                        "name": "Cagayan",
                        "latitude": "6.97470000",
                        "longitude": "118.51440000"
                    },
                    {
                        "id": 82002,
                        "name": "Caigangan",
                        "latitude": "13.25811000",
                        "longitude": "121.93363000"
                    },
                    {
                        "id": 82005,
                        "name": "Cajimos",
                        "latitude": "12.59463000",
                        "longitude": "122.27531000"
                    },
                    {
                        "id": 82020,
                        "name": "Calamundingan",
                        "latitude": "12.93101000",
                        "longitude": "121.47062000"
                    },
                    {
                        "id": 82029,
                        "name": "Calapan",
                        "latitude": "13.41170000",
                        "longitude": "121.18030000"
                    },
                    {
                        "id": 82039,
                        "name": "Calatugas",
                        "latitude": "9.16898000",
                        "longitude": "118.22350000"
                    },
                    {
                        "id": 82056,
                        "name": "Calintaan",
                        "latitude": "12.56667000",
                        "longitude": "120.93333000"
                    },
                    {
                        "id": 82090,
                        "name": "Caminauit",
                        "latitude": "12.33135000",
                        "longitude": "121.08251000"
                    },
                    {
                        "id": 82127,
                        "name": "Cantel",
                        "latitude": "12.61760000",
                        "longitude": "121.51360000"
                    },
                    {
                        "id": 82131,
                        "name": "Canubing No 2",
                        "latitude": "13.35000000",
                        "longitude": "121.13333000"
                    },
                    {
                        "id": 82149,
                        "name": "Caramay",
                        "latitude": "10.18150000",
                        "longitude": "119.23600000"
                    },
                    {
                        "id": 82185,
                        "name": "Caruray",
                        "latitude": "10.30940000",
                        "longitude": "119.01280000"
                    },
                    {
                        "id": 82191,
                        "name": "Casian",
                        "latitude": "11.03500000",
                        "longitude": "119.71360000"
                    },
                    {
                        "id": 82230,
                        "name": "Cawayan",
                        "latitude": "12.65570000",
                        "longitude": "121.54560000"
                    },
                    {
                        "id": 82271,
                        "name": "Concepcion",
                        "latitude": "12.39750000",
                        "longitude": "122.09361000"
                    },
                    {
                        "id": 82278,
                        "name": "Conduaga",
                        "latitude": "8.86200000",
                        "longitude": "117.48930000"
                    },
                    {
                        "id": 82376,
                        "name": "Dapawan",
                        "latitude": "12.40694000",
                        "longitude": "122.02778000"
                    },
                    {
                        "id": 82401,
                        "name": "Daykitin",
                        "latitude": "13.27073000",
                        "longitude": "121.91086000"
                    },
                    {
                        "id": 82447,
                        "name": "Dobdoban",
                        "latitude": "12.57470000",
                        "longitude": "122.11380000"
                    },
                    {
                        "id": 82476,
                        "name": "Dulangan",
                        "latitude": "13.30510000",
                        "longitude": "121.11290000"
                    },
                    {
                        "id": 82511,
                        "name": "Eraan",
                        "latitude": "9.06289000",
                        "longitude": "117.70160000"
                    },
                    {
                        "id": 82516,
                        "name": "España",
                        "latitude": "12.38414000",
                        "longitude": "122.49901000"
                    },
                    {
                        "id": 82532,
                        "name": "Estrella",
                        "latitude": "13.32898000",
                        "longitude": "121.31092000"
                    },
                    {
                        "id": 82534,
                        "name": "Evangelista",
                        "latitude": "13.33350000",
                        "longitude": "121.09720000"
                    },
                    {
                        "id": 82546,
                        "name": "Gabawan",
                        "latitude": "12.42714000",
                        "longitude": "122.01332000"
                    },
                    {
                        "id": 82603,
                        "name": "Gloria",
                        "latitude": "12.98333000",
                        "longitude": "121.46667000"
                    },
                    {
                        "id": 82636,
                        "name": "Guinlo",
                        "latitude": "10.80090000",
                        "longitude": "119.43830000"
                    },
                    {
                        "id": 82679,
                        "name": "Harrison",
                        "latitude": "13.45000000",
                        "longitude": "120.43333000"
                    },
                    {
                        "id": 82757,
                        "name": "Ipil",
                        "latitude": "13.51320000",
                        "longitude": "121.98410000"
                    },
                    {
                        "id": 82759,
                        "name": "Ipilan",
                        "latitude": "8.84306000",
                        "longitude": "117.90333000"
                    },
                    {
                        "id": 82761,
                        "name": "Irahuan",
                        "latitude": "9.80798000",
                        "longitude": "118.69191000"
                    },
                    {
                        "id": 82762,
                        "name": "Iraray",
                        "latitude": "8.99361000",
                        "longitude": "118.05111000"
                    },
                    {
                        "id": 82766,
                        "name": "Irirum",
                        "latitude": "12.61603000",
                        "longitude": "120.93061000"
                    },
                    {
                        "id": 82772,
                        "name": "Isugod",
                        "latitude": "9.34077000",
                        "longitude": "118.11960000"
                    },
                    {
                        "id": 82938,
                        "name": "La Curva",
                        "latitude": "12.40484000",
                        "longitude": "121.04591000"
                    },
                    {
                        "id": 82957,
                        "name": "Labasan",
                        "latitude": "12.77732000",
                        "longitude": "121.46922000"
                    },
                    {
                        "id": 82963,
                        "name": "Labog",
                        "latitude": "9.05580000",
                        "longitude": "118.04950000"
                    },
                    {
                        "id": 83008,
                        "name": "Lanas",
                        "latitude": "12.04946000",
                        "longitude": "121.91851000"
                    },
                    {
                        "id": 83056,
                        "name": "Laylay",
                        "latitude": "13.43910000",
                        "longitude": "121.82020000"
                    },
                    {
                        "id": 83071,
                        "name": "Leuteboro",
                        "latitude": "13.06100000",
                        "longitude": "121.37472000"
                    },
                    {
                        "id": 83079,
                        "name": "Libas",
                        "latitude": "13.24167000",
                        "longitude": "121.95555000"
                    },
                    {
                        "id": 83085,
                        "name": "Libertad",
                        "latitude": "12.45412000",
                        "longitude": "122.00828000"
                    },
                    {
                        "id": 83105,
                        "name": "Ligaya",
                        "latitude": "12.65993000",
                        "longitude": "120.89231000"
                    },
                    {
                        "id": 83115,
                        "name": "Limanancong",
                        "latitude": "10.98930000",
                        "longitude": "119.35930000"
                    },
                    {
                        "id": 83124,
                        "name": "Limon",
                        "latitude": "12.30000000",
                        "longitude": "122.01667000"
                    },
                    {
                        "id": 83192,
                        "name": "Lubang",
                        "latitude": "13.85835000",
                        "longitude": "120.12402000"
                    },
                    {
                        "id": 83213,
                        "name": "Lumangbayan",
                        "latitude": "13.04830000",
                        "longitude": "121.49872000"
                    },
                    {
                        "id": 83330,
                        "name": "Magbay",
                        "latitude": "12.41014000",
                        "longitude": "121.08991000"
                    },
                    {
                        "id": 83398,
                        "name": "Malamig",
                        "latitude": "12.95000000",
                        "longitude": "121.36667000"
                    },
                    {
                        "id": 83424,
                        "name": "Malibago",
                        "latitude": "13.27830000",
                        "longitude": "122.02280000"
                    },
                    {
                        "id": 83429,
                        "name": "Maliig",
                        "latitude": "13.84556000",
                        "longitude": "120.15032000"
                    },
                    {
                        "id": 83447,
                        "name": "Malitbog",
                        "latitude": "12.75212000",
                        "longitude": "121.46591000"
                    },
                    {
                        "id": 83457,
                        "name": "Maluanluan",
                        "latitude": "13.09670000",
                        "longitude": "121.42352000"
                    },
                    {
                        "id": 83477,
                        "name": "Mamburao",
                        "latitude": "13.22330000",
                        "longitude": "120.59600000"
                    },
                    {
                        "id": 83497,
                        "name": "Manaul",
                        "latitude": "12.45300000",
                        "longitude": "121.41070000"
                    },
                    {
                        "id": 83511,
                        "name": "Mangarine",
                        "latitude": "12.35115000",
                        "longitude": "121.09801000"
                    },
                    {
                        "id": 83534,
                        "name": "Mansalay",
                        "latitude": "12.52044000",
                        "longitude": "121.43851000"
                    },
                    {
                        "id": 83591,
                        "name": "Masaguisi",
                        "latitude": "12.75452000",
                        "longitude": "121.44841000"
                    },
                    {
                        "id": 83602,
                        "name": "Masiga",
                        "latitude": "13.36070000",
                        "longitude": "121.82780000"
                    },
                    {
                        "id": 83638,
                        "name": "Mauhao",
                        "latitude": "12.29015000",
                        "longitude": "121.30071000"
                    },
                    {
                        "id": 83747,
                        "name": "Nagiba",
                        "latitude": "13.33018000",
                        "longitude": "121.27432000"
                    },
                    {
                        "id": 83792,
                        "name": "Naujan",
                        "latitude": "13.32328000",
                        "longitude": "121.30282000"
                    },
                    {
                        "id": 83800,
                        "name": "New Agutaya",
                        "latitude": "10.56139000",
                        "longitude": "119.30778000"
                    },
                    {
                        "id": 83841,
                        "name": "Odala",
                        "latitude": "13.47760000",
                        "longitude": "120.82230000"
                    },
                    {
                        "id": 83844,
                        "name": "Odiong",
                        "latitude": "12.59310000",
                        "longitude": "121.50320000"
                    },
                    {
                        "id": 83866,
                        "name": "Osmeña",
                        "latitude": "10.52083000",
                        "longitude": "119.92583000"
                    },
                    {
                        "id": 83873,
                        "name": "Paclolo",
                        "latitude": "12.37675000",
                        "longitude": "121.17351000"
                    },
                    {
                        "id": 83931,
                        "name": "Paluan",
                        "latitude": "13.41600000",
                        "longitude": "120.46230000"
                    },
                    {
                        "id": 83935,
                        "name": "Pambisan",
                        "latitude": "13.01370000",
                        "longitude": "121.41282000"
                    },
                    {
                        "id": 83945,
                        "name": "Panacan",
                        "latitude": "9.24627000",
                        "longitude": "118.40820000"
                    },
                    {
                        "id": 83948,
                        "name": "Panalingaan",
                        "latitude": "8.78417000",
                        "longitude": "117.42306000"
                    },
                    {
                        "id": 83957,
                        "name": "Pancol",
                        "latitude": "10.87150000",
                        "longitude": "119.41570000"
                    },
                    {
                        "id": 84072,
                        "name": "Pañgobilian",
                        "latitude": "8.80111000",
                        "longitude": "117.85944000"
                    },
                    {
                        "id": 83983,
                        "name": "Pangulayan",
                        "latitude": "13.03980000",
                        "longitude": "121.44792000"
                    },
                    {
                        "id": 83988,
                        "name": "Panique",
                        "latitude": "12.48025000",
                        "longitude": "122.01462000"
                    },
                    {
                        "id": 83992,
                        "name": "Panitian",
                        "latitude": "9.09650000",
                        "longitude": "118.08640000"
                    },
                    {
                        "id": 83993,
                        "name": "Panlaitan",
                        "latitude": "12.11907000",
                        "longitude": "119.84861000"
                    },
                    {
                        "id": 84048,
                        "name": "Pato-o",
                        "latitude": "12.43025000",
                        "longitude": "122.06640000"
                    },
                    {
                        "id": 84101,
                        "name": "Pinagsabangan",
                        "latitude": "13.26559000",
                        "longitude": "121.26812000"
                    },
                    {
                        "id": 84103,
                        "name": "Pinamalayan",
                        "latitude": "13.04603000",
                        "longitude": "121.46205000"
                    },
                    {
                        "id": 84140,
                        "name": "Pola",
                        "latitude": "13.14379000",
                        "longitude": "121.44152000"
                    },
                    {
                        "id": 84167,
                        "name": "Port Barton",
                        "latitude": "10.47556000",
                        "longitude": "119.24722000"
                    },
                    {
                        "id": 84220,
                        "name": "Province of Marinduque",
                        "latitude": "13.41667000",
                        "longitude": "121.95000000"
                    },
                    {
                        "id": 84222,
                        "name": "Province of Mindoro Occidental",
                        "latitude": "13.00000000",
                        "longitude": "120.91667000"
                    },
                    {
                        "id": 84223,
                        "name": "Province of Mindoro Oriental",
                        "latitude": "13.15555000",
                        "longitude": "121.26803000"
                    },
                    {
                        "id": 84231,
                        "name": "Province of Palawan",
                        "latitude": "10.00000000",
                        "longitude": "118.75000000"
                    },
                    {
                        "id": 84237,
                        "name": "Province of Romblon",
                        "latitude": "12.55499000",
                        "longitude": "122.28206000"
                    },
                    {
                        "id": 84259,
                        "name": "Puerto Galera",
                        "latitude": "13.50223000",
                        "longitude": "120.95166000"
                    },
                    {
                        "id": 84273,
                        "name": "Punang",
                        "latitude": "9.01690000",
                        "longitude": "118.04950000"
                    },
                    {
                        "id": 84281,
                        "name": "Punta",
                        "latitude": "12.24410000",
                        "longitude": "122.00970000"
                    },
                    {
                        "id": 84306,
                        "name": "Quinabigan",
                        "latitude": "12.99360000",
                        "longitude": "121.47812000"
                    },
                    {
                        "id": 84329,
                        "name": "Ransang",
                        "latitude": "8.96028000",
                        "longitude": "117.58278000"
                    },
                    {
                        "id": 84339,
                        "name": "Rio Tuba",
                        "latitude": "8.50613000",
                        "longitude": "117.43169000"
                    },
                    {
                        "id": 84343,
                        "name": "Rizal",
                        "latitude": "12.46667000",
                        "longitude": "120.96667000"
                    },
                    {
                        "id": 84362,
                        "name": "Roxas",
                        "latitude": "10.32150000",
                        "longitude": "119.34510000"
                    },
                    {
                        "id": 84364,
                        "name": "Saaban",
                        "latitude": "13.13049000",
                        "longitude": "121.36872000"
                    },
                    {
                        "id": 84370,
                        "name": "Sabang",
                        "latitude": "13.50920000",
                        "longitude": "120.97370000"
                    },
                    {
                        "id": 84373,
                        "name": "Sablayan",
                        "latitude": "12.83460000",
                        "longitude": "120.76900000"
                    },
                    {
                        "id": 84382,
                        "name": "Sagana",
                        "latitude": "12.72252000",
                        "longitude": "121.48672000"
                    },
                    {
                        "id": 84405,
                        "name": "Salcedo",
                        "latitude": "12.81052000",
                        "longitude": "121.46742000"
                    },
                    {
                        "id": 84418,
                        "name": "Salvacion",
                        "latitude": "12.13287000",
                        "longitude": "119.93281000"
                    },
                    {
                        "id": 84437,
                        "name": "San Agustin",
                        "latitude": "12.41984000",
                        "longitude": "120.98931000"
                    },
                    {
                        "id": 84453,
                        "name": "San Aquilino",
                        "latitude": "12.59743000",
                        "longitude": "121.48671000"
                    },
                    {
                        "id": 84549,
                        "name": "San Mariano",
                        "latitude": "12.64143000",
                        "longitude": "121.43791000"
                    },
                    {
                        "id": 84567,
                        "name": "San Miguel",
                        "latitude": "11.49240000",
                        "longitude": "119.87030000"
                    },
                    {
                        "id": 84588,
                        "name": "San Pedro",
                        "latitude": "12.46084000",
                        "longitude": "121.01041000"
                    },
                    {
                        "id": 84616,
                        "name": "San Teodoro",
                        "latitude": "13.43354000",
                        "longitude": "121.01440000"
                    },
                    {
                        "id": 84620,
                        "name": "San Vicente",
                        "latitude": "10.53033000",
                        "longitude": "119.25423000"
                    },
                    {
                        "id": 84646,
                        "name": "Santa Brigida",
                        "latitude": "12.56783000",
                        "longitude": "121.48901000"
                    },
                    {
                        "id": 84661,
                        "name": "Santa Cruz",
                        "latitude": "13.47580000",
                        "longitude": "122.02750000"
                    },
                    {
                        "id": 84687,
                        "name": "Santa Maria",
                        "latitude": "12.57883000",
                        "longitude": "121.46041000"
                    },
                    {
                        "id": 84702,
                        "name": "Santa Teresa",
                        "latitude": "12.25186000",
                        "longitude": "121.11251000"
                    },
                    {
                        "id": 84751,
                        "name": "Saraza",
                        "latitude": "8.73556000",
                        "longitude": "117.78000000"
                    },
                    {
                        "id": 84834,
                        "name": "Socorro",
                        "latitude": "13.06690000",
                        "longitude": "121.39858000"
                    },
                    {
                        "id": 84853,
                        "name": "Suba",
                        "latitude": "10.82512000",
                        "longitude": "121.00690000"
                    },
                    {
                        "id": 84875,
                        "name": "Sumagui",
                        "latitude": "12.79532000",
                        "longitude": "121.47401000"
                    },
                    {
                        "id": 84897,
                        "name": "Tabinay",
                        "latitude": "13.48710000",
                        "longitude": "120.95660000"
                    },
                    {
                        "id": 84905,
                        "name": "Tabon",
                        "latitude": "9.23877000",
                        "longitude": "117.99460000"
                    },
                    {
                        "id": 84919,
                        "name": "Tacligan",
                        "latitude": "13.39750000",
                        "longitude": "121.06260000"
                    },
                    {
                        "id": 84921,
                        "name": "Taclobo",
                        "latitude": "12.30744000",
                        "longitude": "122.58601000"
                    },
                    {
                        "id": 84934,
                        "name": "Tagbak",
                        "latitude": "13.84166000",
                        "longitude": "120.08872000"
                    },
                    {
                        "id": 84937,
                        "name": "Tagbita",
                        "latitude": "8.71331000",
                        "longitude": "117.35046000"
                    },
                    {
                        "id": 84939,
                        "name": "Tagburos",
                        "latitude": "9.82861000",
                        "longitude": "118.73194000"
                    },
                    {
                        "id": 84953,
                        "name": "Tagusao",
                        "latitude": "9.19238000",
                        "longitude": "117.81410000"
                    },
                    {
                        "id": 85012,
                        "name": "Tambong",
                        "latitude": "12.96391000",
                        "longitude": "121.48462000"
                    },
                    {
                        "id": 85024,
                        "name": "Tampayan",
                        "latitude": "12.49411000",
                        "longitude": "122.53309000"
                    },
                    {
                        "id": 85034,
                        "name": "Tangal",
                        "latitude": "13.84536000",
                        "longitude": "120.10082000"
                    },
                    {
                        "id": 85062,
                        "name": "Tarusan",
                        "latitude": "8.65461000",
                        "longitude": "117.51040000"
                    },
                    {
                        "id": 85071,
                        "name": "Tayaman",
                        "latitude": "13.22950000",
                        "longitude": "120.57260000"
                    },
                    {
                        "id": 85114,
                        "name": "Tigui",
                        "latitude": "13.26810000",
                        "longitude": "122.04150000"
                    },
                    {
                        "id": 85116,
                        "name": "Tiguion",
                        "latitude": "13.33470000",
                        "longitude": "121.86100000"
                    },
                    {
                        "id": 85117,
                        "name": "Tiguisan",
                        "latitude": "12.83941000",
                        "longitude": "121.46052000"
                    },
                    {
                        "id": 85120,
                        "name": "Tilik",
                        "latitude": "13.81436000",
                        "longitude": "120.20022000"
                    },
                    {
                        "id": 85137,
                        "name": "Tiniguiban",
                        "latitude": "11.35740000",
                        "longitude": "119.50490000"
                    },
                    {
                        "id": 85164,
                        "name": "Tomingad",
                        "latitude": "12.44311000",
                        "longitude": "122.02106000"
                    },
                    {
                        "id": 85183,
                        "name": "Tuban",
                        "latitude": "12.81220000",
                        "longitude": "120.83230000"
                    },
                    {
                        "id": 85210,
                        "name": "Tugdan",
                        "latitude": "12.31340000",
                        "longitude": "122.08530000"
                    },
                    {
                        "id": 85221,
                        "name": "Tumarbong",
                        "latitude": "10.37659000",
                        "longitude": "119.45790000"
                    },
                    {
                        "id": 85285,
                        "name": "Victoria",
                        "latitude": "13.17722000",
                        "longitude": "121.27806000"
                    },
                    {
                        "id": 85291,
                        "name": "Vigo",
                        "latitude": "13.82666000",
                        "longitude": "120.17922000"
                    },
                    {
                        "id": 85313,
                        "name": "Wawa",
                        "latitude": "13.46320000",
                        "longitude": "120.74410000"
                    },
                    {
                        "id": 85320,
                        "name": "Yook",
                        "latitude": "13.22608000",
                        "longitude": "121.96400000"
                    }
                ]
            },
            {
                "id": 1361,
                "name": "Palawan",
                "iso2": "PLW",
                "latitude": "9.83494930",
                "longitude": "118.73836150",
                "type": "province",
                "cities": [
                    {
                        "id": 81132,
                        "name": "Aborlan",
                        "latitude": "9.50252080",
                        "longitude": "118.28831960"
                    },
                    {
                        "id": 81173,
                        "name": "Agutaya",
                        "latitude": "11.29341430",
                        "longitude": "120.60209410"
                    },
                    {
                        "id": 81303,
                        "name": "Araceli",
                        "latitude": "10.60574930",
                        "longitude": "119.70705160"
                    },
                    {
                        "id": 81429,
                        "name": "Balabac",
                        "latitude": "7.92713130",
                        "longitude": "116.80648880"
                    },
                    {
                        "id": 154751,
                        "name": "Bataraza",
                        "latitude": "8.56298460",
                        "longitude": "117.09839910"
                    },
                    {
                        "id": 154752,
                        "name": "Brooke's Point",
                        "latitude": "8.83377580",
                        "longitude": "117.68484400"
                    },
                    {
                        "id": 154753,
                        "name": "Busuanga",
                        "latitude": "12.16039270",
                        "longitude": "119.75769810"
                    },
                    {
                        "id": 81995,
                        "name": "Cagayancillo",
                        "latitude": "9.23938220",
                        "longitude": "119.89799210"
                    },
                    {
                        "id": 82295,
                        "name": "Coron",
                        "latitude": "12.01855290",
                        "longitude": "119.88497880"
                    },
                    {
                        "id": 154754,
                        "name": "Culion",
                        "latitude": "11.82205900",
                        "longitude": "119.82726380"
                    },
                    {
                        "id": 82325,
                        "name": "Cuyo",
                        "latitude": "11.01952820",
                        "longitude": "120.51823740"
                    },
                    {
                        "id": 82490,
                        "name": "Dumaran",
                        "latitude": "10.53529660",
                        "longitude": "119.37102440"
                    },
                    {
                        "id": 82505,
                        "name": "El Nido",
                        "latitude": "11.20503190",
                        "longitude": "119.24127200"
                    },
                    {
                        "id": 154755,
                        "name": "Kalayaan",
                        "latitude": "8.99841890",
                        "longitude": "112.59879290"
                    },
                    {
                        "id": 154756,
                        "name": "Linapacan",
                        "latitude": "11.44156670",
                        "longitude": "119.57873480"
                    },
                    {
                        "id": 154757,
                        "name": "Magsaysay",
                        "latitude": "10.89437450",
                        "longitude": "120.69693690"
                    },
                    {
                        "id": 83781,
                        "name": "Narra",
                        "latitude": "9.28076150",
                        "longitude": "117.96314330"
                    },
                    {
                        "id": 84260,
                        "name": "Puerto Princesa",
                        "latitude": "9.91262530",
                        "longitude": "118.44389050"
                    },
                    {
                        "id": 154758,
                        "name": "Quezon",
                        "latitude": "9.27650520",
                        "longitude": "117.69698230"
                    },
                    {
                        "id": 154759,
                        "name": "Rizal",
                        "latitude": "8.79380800",
                        "longitude": "117.20730680"
                    },
                    {
                        "id": 154760,
                        "name": "Roxas",
                        "latitude": "10.29022220",
                        "longitude": "118.98672170"
                    },
                    {
                        "id": 154761,
                        "name": "San Vicente",
                        "latitude": "10.50320500",
                        "longitude": "118.84592290"
                    },
                    {
                        "id": 154762,
                        "name": "Sofronio Española",
                        "latitude": "9.04032540",
                        "longitude": "117.84174250"
                    },
                    {
                        "id": 85077,
                        "name": "Taytay",
                        "latitude": "10.86069400",
                        "longitude": "119.15181280"
                    }
                ]
            },
            {
                "id": 1365,
                "name": "Pampanga",
                "iso2": "PAM",
                "latitude": "15.07940900",
                "longitude": "120.61998950",
                "type": "province",
                "cities": [
                    {
                        "id": 81268,
                        "name": "Angeles City",
                        "latitude": "15.14649350",
                        "longitude": "120.47721760"
                    },
                    {
                        "id": 81291,
                        "name": "Apalit",
                        "latitude": "14.95510310",
                        "longitude": "120.72276330"
                    },
                    {
                        "id": 81309,
                        "name": "Arayat",
                        "latitude": "15.18828100",
                        "longitude": "120.66932350"
                    },
                    {
                        "id": 81367,
                        "name": "Bacolor",
                        "latitude": "15.04023100",
                        "longitude": "120.55341860"
                    },
                    {
                        "id": 82105,
                        "name": "Candaba",
                        "latitude": "15.11192310",
                        "longitude": "120.78960980"
                    },
                    {
                        "id": 82540,
                        "name": "Floridablanca",
                        "latitude": "14.95888680",
                        "longitude": "120.39815640"
                    },
                    {
                        "id": 82613,
                        "name": "Guagua",
                        "latitude": "14.97065850",
                        "longitude": "120.51825950"
                    },
                    {
                        "id": 83193,
                        "name": "Lubao",
                        "latitude": "14.89801790",
                        "longitude": "120.47335000"
                    },
                    {
                        "id": 145522,
                        "name": "Mabalacat",
                        "latitude": "15.22435400",
                        "longitude": "120.47217320"
                    },
                    {
                        "id": 83294,
                        "name": "Macabebe",
                        "latitude": "14.85698590",
                        "longitude": "120.59381920"
                    },
                    {
                        "id": 83318,
                        "name": "Magalang",
                        "latitude": "15.23737900",
                        "longitude": "120.61425770"
                    },
                    {
                        "id": 83595,
                        "name": "Masantol",
                        "latitude": "14.84821060",
                        "longitude": "120.64227340"
                    },
                    {
                        "id": 83663,
                        "name": "Mexico",
                        "latitude": "15.11156810",
                        "longitude": "120.61878420"
                    },
                    {
                        "id": 83677,
                        "name": "Minalin",
                        "latitude": "14.96392160",
                        "longitude": "120.60854990"
                    },
                    {
                        "id": 84163,
                        "name": "Porac",
                        "latitude": "15.10785980",
                        "longitude": "120.31409770"
                    },
                    {
                        "id": 154763,
                        "name": "San Fernando",
                        "latitude": "15.06672580",
                        "longitude": "120.57887050"
                    },
                    {
                        "id": 154764,
                        "name": "San Luis",
                        "latitude": "15.02558420",
                        "longitude": "120.73473180"
                    },
                    {
                        "id": 84615,
                        "name": "San Simon",
                        "latitude": "15.00684060",
                        "longitude": "120.71863860"
                    },
                    {
                        "id": 84638,
                        "name": "Santa Ana",
                        "latitude": "15.10360920",
                        "longitude": "120.66948510"
                    },
                    {
                        "id": 84697,
                        "name": "Santa Rita",
                        "latitude": "15.02101610",
                        "longitude": "120.55720460"
                    },
                    {
                        "id": 154765,
                        "name": "Santo Tomas",
                        "latitude": "15.00352350",
                        "longitude": "120.69148870"
                    },
                    {
                        "id": 145747,
                        "name": "Sasmuan",
                        "latitude": "14.87348630",
                        "longitude": "120.53634490"
                    }
                ]
            },
            {
                "id": 1364,
                "name": "Pangasinan",
                "iso2": "PAN",
                "latitude": "15.89490550",
                "longitude": "120.28631830",
                "type": "province",
                "cities": [
                    {
                        "id": 81161,
                        "name": "Agno",
                        "latitude": "16.10929910",
                        "longitude": "119.73903000"
                    },
                    {
                        "id": 145790,
                        "name": "Aguilar",
                        "latitude": "15.83519450",
                        "longitude": "120.12969410"
                    },
                    {
                        "id": 154766,
                        "name": "Alaminos",
                        "latitude": "16.14423360",
                        "longitude": "119.90742360"
                    },
                    {
                        "id": 145793,
                        "name": "Alcala",
                        "latitude": "15.84934160",
                        "longitude": "120.44723120"
                    },
                    {
                        "id": 145799,
                        "name": "Anda",
                        "latitude": "16.29469660",
                        "longitude": "119.89168130"
                    },
                    {
                        "id": 81320,
                        "name": "Asingan",
                        "latitude": "15.99412670",
                        "longitude": "120.57396010"
                    },
                    {
                        "id": 145818,
                        "name": "Balungao",
                        "latitude": "15.88619690",
                        "longitude": "120.61859200"
                    },
                    {
                        "id": 145824,
                        "name": "Bani",
                        "latitude": "16.21591730",
                        "longitude": "119.77453320"
                    },
                    {
                        "id": 145834,
                        "name": "Basista",
                        "latitude": "15.87721490",
                        "longitude": "120.35681150"
                    },
                    {
                        "id": 145838,
                        "name": "Bautista",
                        "latitude": "15.79949390",
                        "longitude": "120.43114320"
                    },
                    {
                        "id": 145839,
                        "name": "Bayambang",
                        "latitude": "15.79131900",
                        "longitude": "120.37772970"
                    },
                    {
                        "id": 145844,
                        "name": "Binalonan",
                        "latitude": "16.06881470",
                        "longitude": "120.55704960"
                    },
                    {
                        "id": 145846,
                        "name": "Binmaley",
                        "latitude": "15.99934670",
                        "longitude": "120.25003680"
                    },
                    {
                        "id": 145850,
                        "name": "Bolinao",
                        "latitude": "16.35247980",
                        "longitude": "119.71441830"
                    },
                    {
                        "id": 145858,
                        "name": "Bugallon",
                        "latitude": "15.90900760",
                        "longitude": "120.10198800"
                    },
                    {
                        "id": 154767,
                        "name": "Burgos",
                        "latitude": "16.01938300",
                        "longitude": "119.75831110"
                    },
                    {
                        "id": 145872,
                        "name": "Calasiao",
                        "latitude": "15.99263220",
                        "longitude": "120.31779870"
                    },
                    {
                        "id": 145907,
                        "name": "Dagupan",
                        "latitude": "16.06145180",
                        "longitude": "120.30164500"
                    },
                    {
                        "id": 145910,
                        "name": "Dasol",
                        "latitude": "15.97224980",
                        "longitude": "119.72375230"
                    },
                    {
                        "id": 145936,
                        "name": "Infanta",
                        "latitude": "15.86431270",
                        "longitude": "119.84640440"
                    },
                    {
                        "id": 145940,
                        "name": "Labrador",
                        "latitude": "15.99564390",
                        "longitude": "120.04042590"
                    },
                    {
                        "id": 145943,
                        "name": "Laoac",
                        "latitude": "16.04627590",
                        "longitude": "120.49907580"
                    },
                    {
                        "id": 145949,
                        "name": "Lingayen",
                        "latitude": "15.99084640",
                        "longitude": "120.13165320"
                    },
                    {
                        "id": 154768,
                        "name": "Mabini",
                        "latitude": "16.02690440",
                        "longitude": "119.81432130"
                    },
                    {
                        "id": 145974,
                        "name": "Malasiqui",
                        "latitude": "15.90930890",
                        "longitude": "120.37633500"
                    },
                    {
                        "id": 145977,
                        "name": "Manaoag",
                        "latitude": "16.04309920",
                        "longitude": "120.45543090"
                    },
                    {
                        "id": 145978,
                        "name": "Mangaldan",
                        "latitude": "16.06413760",
                        "longitude": "120.36032930"
                    },
                    {
                        "id": 145979,
                        "name": "Mangatarem",
                        "latitude": "15.74118610",
                        "longitude": "120.11538710"
                    },
                    {
                        "id": 145980,
                        "name": "Mapandan",
                        "latitude": "16.01672730",
                        "longitude": "120.41388890"
                    },
                    {
                        "id": 145996,
                        "name": "Natividad",
                        "latitude": "16.04844910",
                        "longitude": "120.75693510"
                    },
                    {
                        "id": 146029,
                        "name": "Pozorrubio",
                        "latitude": "16.11351010",
                        "longitude": "120.44090820"
                    },
                    {
                        "id": 146044,
                        "name": "Rosales",
                        "latitude": "15.87335080",
                        "longitude": "120.59664060"
                    },
                    {
                        "id": 154769,
                        "name": "San Carlos",
                        "latitude": "15.90870260",
                        "longitude": "120.22909240"
                    },
                    {
                        "id": 146056,
                        "name": "San Fabian",
                        "latitude": "16.15423620",
                        "longitude": "120.34502540"
                    },
                    {
                        "id": 154770,
                        "name": "San Jacinto",
                        "latitude": "16.08572550",
                        "longitude": "120.41131400"
                    },
                    {
                        "id": 154771,
                        "name": "San Manuel",
                        "latitude": "16.11507180",
                        "longitude": "120.59453220"
                    },
                    {
                        "id": 154772,
                        "name": "San Nicolas",
                        "latitude": "16.12204260",
                        "longitude": "120.61126790"
                    },
                    {
                        "id": 144855,
                        "name": "San Quintin",
                        "latitude": "15.98637680",
                        "longitude": "120.73879800"
                    },
                    {
                        "id": 154773,
                        "name": "Santa Barbara",
                        "latitude": "15.98915820",
                        "longitude": "120.35436230"
                    },
                    {
                        "id": 154774,
                        "name": "Santa Maria",
                        "latitude": "15.96227310",
                        "longitude": "120.62625270"
                    },
                    {
                        "id": 154775,
                        "name": "Santo Tomas",
                        "latitude": "15.86918820",
                        "longitude": "120.53232860"
                    },
                    {
                        "id": 146091,
                        "name": "Sison",
                        "latitude": "16.16761040",
                        "longitude": "120.46410620"
                    },
                    {
                        "id": 146094,
                        "name": "Sual",
                        "latitude": "16.09729880",
                        "longitude": "119.96687990"
                    },
                    {
                        "id": 146111,
                        "name": "Tayug",
                        "latitude": "16.01289220",
                        "longitude": "120.70734400"
                    },
                    {
                        "id": 146124,
                        "name": "Umingan",
                        "latitude": "15.89254270",
                        "longitude": "120.73810340"
                    },
                    {
                        "id": 146126,
                        "name": "Urbiztondo",
                        "latitude": "15.82399670",
                        "longitude": "120.29213800"
                    },
                    {
                        "id": 146127,
                        "name": "Urdaneta",
                        "latitude": "15.96570180",
                        "longitude": "120.48205510"
                    },
                    {
                        "id": 146130,
                        "name": "Villasis",
                        "latitude": "15.90899460",
                        "longitude": "120.49168520"
                    }
                ]
            },
            {
                "id": 1275,
                "name": "Quezon",
                "iso2": "QUE",
                "latitude": "14.03139060",
                "longitude": "122.11309090",
                "type": "province",
                "cities": [
                    {
                        "id": 81157,
                        "name": "Agdangan",
                        "latitude": "13.88253030",
                        "longitude": "121.88210860"
                    },
                    {
                        "id": 81176,
                        "name": "Alabat",
                        "latitude": "14.11212590",
                        "longitude": "121.98424710"
                    },
                    {
                        "id": 81325,
                        "name": "Atimonan",
                        "latitude": "13.99405220",
                        "longitude": "121.71914430"
                    },
                    {
                        "id": 154776,
                        "name": "Buenavista",
                        "latitude": "13.73633900",
                        "longitude": "122.37035360"
                    },
                    {
                        "id": 81906,
                        "name": "Burdeos",
                        "latitude": "14.92776760",
                        "longitude": "121.89398140"
                    },
                    {
                        "id": 82041,
                        "name": "Calauag",
                        "latitude": "14.06715670",
                        "longitude": "122.08646220"
                    },
                    {
                        "id": 82108,
                        "name": "Candelaria",
                        "latitude": "13.94751930",
                        "longitude": "121.35820530"
                    },
                    {
                        "id": 82203,
                        "name": "Catanauan",
                        "latitude": "13.63590490",
                        "longitude": "122.13911380"
                    },
                    {
                        "id": 154777,
                        "name": "Dolores",
                        "latitude": "14.02000350",
                        "longitude": "121.31721110"
                    },
                    {
                        "id": 82577,
                        "name": "General Luna",
                        "latitude": "13.69742100",
                        "longitude": "122.14659290"
                    },
                    {
                        "id": 82581,
                        "name": "General Nakar",
                        "latitude": "14.90618880",
                        "longitude": "121.16683700"
                    },
                    {
                        "id": 154778,
                        "name": "Guinayangan",
                        "latitude": "13.93610480",
                        "longitude": "122.27380200"
                    },
                    {
                        "id": 82653,
                        "name": "Gumaca",
                        "latitude": "13.87288600",
                        "longitude": "122.04426130"
                    },
                    {
                        "id": 154779,
                        "name": "Infanta",
                        "latitude": "14.72223710",
                        "longitude": "121.57229980"
                    },
                    {
                        "id": 154780,
                        "name": "Jomalig",
                        "latitude": "14.70464290",
                        "longitude": "122.29083150"
                    },
                    {
                        "id": 83177,
                        "name": "Lopez",
                        "latitude": "13.85790150",
                        "longitude": "122.12975840"
                    },
                    {
                        "id": 83198,
                        "name": "Lucban",
                        "latitude": "14.11965940",
                        "longitude": "121.48818570"
                    },
                    {
                        "id": 83201,
                        "name": "Lucena",
                        "latitude": "13.93905170",
                        "longitude": "121.54677340"
                    },
                    {
                        "id": 83299,
                        "name": "Macalelon",
                        "latitude": "13.75520650",
                        "longitude": "122.10487920"
                    },
                    {
                        "id": 83635,
                        "name": "Mauban",
                        "latitude": "14.24992670",
                        "longitude": "121.55666670"
                    },
                    {
                        "id": 83721,
                        "name": "Mulanay",
                        "latitude": "13.53785610",
                        "longitude": "122.29764300"
                    },
                    {
                        "id": 83882,
                        "name": "Padre Burgos",
                        "latitude": "13.93248420",
                        "longitude": "121.76529250"
                    },
                    {
                        "id": 83893,
                        "name": "Pagbilao",
                        "latitude": "13.96460660",
                        "longitude": "121.65776560"
                    },
                    {
                        "id": 84007,
                        "name": "Panukulan",
                        "latitude": "14.98488420",
                        "longitude": "121.79473000"
                    },
                    {
                        "id": 84046,
                        "name": "Patnanungan",
                        "latitude": "14.78361430",
                        "longitude": "122.09329210"
                    },
                    {
                        "id": 84074,
                        "name": "Perez",
                        "latitude": "14.17323320",
                        "longitude": "121.87749240"
                    },
                    {
                        "id": 84122,
                        "name": "Pitogo",
                        "latitude": "13.79747180",
                        "longitude": "122.00171080"
                    },
                    {
                        "id": 154781,
                        "name": "Plaridel",
                        "latitude": "13.94205750",
                        "longitude": "121.97776690"
                    },
                    {
                        "id": 84145,
                        "name": "Polillo",
                        "latitude": "14.64604070",
                        "longitude": "121.78197240"
                    },
                    {
                        "id": 154782,
                        "name": "Quezon",
                        "latitude": "14.06464960",
                        "longitude": "122.03838180"
                    },
                    {
                        "id": 84331,
                        "name": "Real",
                        "latitude": "14.54463550",
                        "longitude": "121.37895440"
                    },
                    {
                        "id": 84431,
                        "name": "Sampaloc",
                        "latitude": "14.19197710",
                        "longitude": "121.52972790"
                    },
                    {
                        "id": 154783,
                        "name": "San Andres",
                        "latitude": "13.32749030",
                        "longitude": "122.57308570"
                    },
                    {
                        "id": 154784,
                        "name": "San Antonio",
                        "latitude": "13.90209270",
                        "longitude": "121.22304500"
                    },
                    {
                        "id": 154785,
                        "name": "San Francisco",
                        "latitude": "13.30559450",
                        "longitude": "122.40012500"
                    },
                    {
                        "id": 84569,
                        "name": "San Narciso",
                        "latitude": "13.56184610",
                        "longitude": "122.36519180"
                    },
                    {
                        "id": 84752,
                        "name": "Sariaya",
                        "latitude": "13.93526140",
                        "longitude": "121.41783000"
                    },
                    {
                        "id": 154786,
                        "name": "Tagkawayan",
                        "latitude": "14.03473340",
                        "longitude": "122.24172380"
                    },
                    {
                        "id": 85068,
                        "name": "Tayabas",
                        "latitude": "14.02985140",
                        "longitude": "121.45854060"
                    },
                    {
                        "id": 85092,
                        "name": "Tiaong",
                        "latitude": "13.91961930",
                        "longitude": "121.25294560"
                    },
                    {
                        "id": 85260,
                        "name": "Unisan",
                        "latitude": "13.85807970",
                        "longitude": "121.92587950"
                    }
                ]
            },
            {
                "id": 1273,
                "name": "Quirino",
                "iso2": "QUI",
                "latitude": "16.27004240",
                "longitude": "121.53700030",
                "type": "province",
                "cities": [
                    {
                        "id": 145101,
                        "name": "Aglipay",
                        "latitude": "16.44113450",
                        "longitude": "121.53324410"
                    },
                    {
                        "id": 145153,
                        "name": "Cabarroguis",
                        "latitude": "16.44622780",
                        "longitude": "121.41724670"
                    },
                    {
                        "id": 145181,
                        "name": "Diffun",
                        "latitude": "16.53436880",
                        "longitude": "121.31342010"
                    },
                    {
                        "id": 145229,
                        "name": "Maddela",
                        "latitude": "16.37876890",
                        "longitude": "121.45688420"
                    },
                    {
                        "id": 145254,
                        "name": "Nagtipunan",
                        "latitude": "16.13932770",
                        "longitude": "121.22894190"
                    },
                    {
                        "id": 145281,
                        "name": "Saguday",
                        "latitude": "16.55514930",
                        "longitude": "121.49921500"
                    }
                ]
            },
            {
                "id": 1271,
                "name": "Rizal",
                "iso2": "RIZ",
                "latitude": "14.60374460",
                "longitude": "121.30840880",
                "type": "province",
                "cities": [
                    {
                        "id": 81269,
                        "name": "Angono",
                        "latitude": "14.53908180",
                        "longitude": "121.12685790"
                    },
                    {
                        "id": 81281,
                        "name": "Antipolo",
                        "latitude": "14.66547100",
                        "longitude": "121.08089880"
                    },
                    {
                        "id": 154787,
                        "name": "Baras",
                        "latitude": "14.53760640",
                        "longitude": "121.23194580"
                    },
                    {
                        "id": 81712,
                        "name": "Binangonan",
                        "latitude": "14.40893760",
                        "longitude": "121.12346540"
                    },
                    {
                        "id": 82003,
                        "name": "Cainta",
                        "latitude": "14.59230790",
                        "longitude": "121.08194140"
                    },
                    {
                        "id": 82158,
                        "name": "Cardona",
                        "latitude": "14.41283560",
                        "longitude": "121.15400390"
                    },
                    {
                        "id": 82785,
                        "name": "Jalajala",
                        "latitude": "14.32710740",
                        "longitude": "121.30369570"
                    },
                    {
                        "id": 83713,
                        "name": "Morong",
                        "latitude": "14.53422920",
                        "longitude": "121.19373580"
                    },
                    {
                        "id": 84099,
                        "name": "Pililla",
                        "latitude": "14.44685100",
                        "longitude": "121.25394020"
                    },
                    {
                        "id": 84350,
                        "name": "Rodriguez",
                        "latitude": "14.78627200",
                        "longitude": "121.06822850"
                    },
                    {
                        "id": 154788,
                        "name": "San Mateo",
                        "latitude": "14.68191840",
                        "longitude": "121.10877160"
                    },
                    {
                        "id": 85030,
                        "name": "Tanay",
                        "latitude": "14.57779400",
                        "longitude": "121.19182200"
                    },
                    {
                        "id": 154789,
                        "name": "Taytay",
                        "latitude": "14.55319650",
                        "longitude": "121.09611710"
                    },
                    {
                        "id": 85089,
                        "name": "Teresa",
                        "latitude": "14.56702670",
                        "longitude": "121.18751310"
                    }
                ]
            },
            {
                "id": 1269,
                "name": "Romblon",
                "iso2": "ROM",
                "latitude": "12.57780160",
                "longitude": "122.26914600",
                "type": "province",
                "cities": [
                    {
                        "id": 154790,
                        "name": "Alcantara",
                        "latitude": "12.28437610",
                        "longitude": "121.97911810"
                    },
                    {
                        "id": 154791,
                        "name": "Banton",
                        "latitude": "12.95464490",
                        "longitude": "121.82514510"
                    },
                    {
                        "id": 82004,
                        "name": "Cajidiocan",
                        "latitude": "12.40582770",
                        "longitude": "122.63342860"
                    },
                    {
                        "id": 154792,
                        "name": "Calatrava",
                        "latitude": "12.63340510",
                        "longitude": "121.98544590"
                    },
                    {
                        "id": 154793,
                        "name": "Concepcion",
                        "latitude": "12.92496680",
                        "longitude": "121.66804690"
                    },
                    {
                        "id": 82289,
                        "name": "Corcuera",
                        "latitude": "12.80927000",
                        "longitude": "122.01285030"
                    },
                    {
                        "id": 82538,
                        "name": "Ferrol",
                        "latitude": "12.34162780",
                        "longitude": "121.90707460"
                    },
                    {
                        "id": 83171,
                        "name": "Looc",
                        "latitude": "12.26346170",
                        "longitude": "121.91256550"
                    },
                    {
                        "id": 83334,
                        "name": "Magdiwang",
                        "latitude": "12.46606190",
                        "longitude": "122.42987720"
                    },
                    {
                        "id": 83845,
                        "name": "Odiongan",
                        "latitude": "12.39759900",
                        "longitude": "121.92472470"
                    },
                    {
                        "id": 84352,
                        "name": "Romblon",
                        "latitude": "12.57434520",
                        "longitude": "122.19706140"
                    },
                    {
                        "id": 154794,
                        "name": "San Agustin",
                        "latitude": "12.55756780",
                        "longitude": "122.03517860"
                    },
                    {
                        "id": 154795,
                        "name": "San Andres",
                        "latitude": "12.54035430",
                        "longitude": "121.96214290"
                    },
                    {
                        "id": 154796,
                        "name": "San Fernando",
                        "latitude": "12.35757380",
                        "longitude": "122.38115360"
                    },
                    {
                        "id": 154797,
                        "name": "San Jose",
                        "latitude": "12.06445510",
                        "longitude": "121.89554110"
                    },
                    {
                        "id": 154798,
                        "name": "Santa Fe",
                        "latitude": "12.15366320",
                        "longitude": "121.93132960"
                    },
                    {
                        "id": 154799,
                        "name": "Santa Maria",
                        "latitude": "12.40456960",
                        "longitude": "122.04353480"
                    }
                ]
            },
            {
                "id": 1277,
                "name": "Sarangani",
                "iso2": "SAR",
                "latitude": "5.92671750",
                "longitude": "124.99475100",
                "type": "province",
                "cities": [
                    {
                        "id": 81177,
                        "name": "Alabel",
                        "latitude": "6.15485020",
                        "longitude": "125.21985580"
                    },
                    {
                        "id": 82601,
                        "name": "Glan",
                        "latitude": "5.75459120",
                        "longitude": "125.16704840"
                    },
                    {
                        "id": 82891,
                        "name": "Kiamba",
                        "latitude": "5.98155570",
                        "longitude": "124.52667650"
                    },
                    {
                        "id": 83259,
                        "name": "Maasim",
                        "latitude": "5.95304260",
                        "longitude": "124.80343920"
                    },
                    {
                        "id": 83373,
                        "name": "Maitum",
                        "latitude": "6.12012440",
                        "longitude": "124.33337500"
                    },
                    {
                        "id": 83406,
                        "name": "Malapatan",
                        "latitude": "5.99861110",
                        "longitude": "125.23308450"
                    },
                    {
                        "id": 144025,
                        "name": "Malungon",
                        "latitude": "6.36024940",
                        "longitude": "124.96061910"
                    }
                ]
            },
            {
                "id": 1276,
                "name": "Siquijor",
                "iso2": "SIG",
                "latitude": "9.19987790",
                "longitude": "123.59519250",
                "type": "province",
                "cities": [
                    {
                        "id": 82509,
                        "name": "Enrique Villanueva",
                        "latitude": "9.25850550",
                        "longitude": "123.59464550"
                    },
                    {
                        "id": 154800,
                        "name": "Larena",
                        "latitude": "9.24753350",
                        "longitude": "123.55786710"
                    },
                    {
                        "id": 83058,
                        "name": "Lazi",
                        "latitude": "9.14598110",
                        "longitude": "123.53644920"
                    },
                    {
                        "id": 154801,
                        "name": "Maria",
                        "latitude": "9.17721240",
                        "longitude": "123.61709010"
                    },
                    {
                        "id": 154802,
                        "name": "San Juan",
                        "latitude": "9.14737990",
                        "longitude": "123.42456900"
                    },
                    {
                        "id": 84827,
                        "name": "Siquijor",
                        "latitude": "9.19173800",
                        "longitude": "123.44340890"
                    }
                ]
            },
            {
                "id": 1310,
                "name": "Soccsksargen",
                "iso2": "12",
                "latitude": "6.27069180",
                "longitude": "124.68565090",
                "type": "region",
                "cities": [
                    {
                        "id": 81242,
                        "name": "Amas",
                        "latitude": "7.05694000",
                        "longitude": "124.98389000"
                    },
                    {
                        "id": 81403,
                        "name": "Bagontapay",
                        "latitude": "6.85889000",
                        "longitude": "124.90889000"
                    },
                    {
                        "id": 81407,
                        "name": "Baguer",
                        "latitude": "7.25611000",
                        "longitude": "124.50417000"
                    },
                    {
                        "id": 81484,
                        "name": "Baliton",
                        "latitude": "5.74361000",
                        "longitude": "125.23639000"
                    },
                    {
                        "id": 81493,
                        "name": "Balogo",
                        "latitude": "7.28230000",
                        "longitude": "124.46388000"
                    },
                    {
                        "id": 81516,
                        "name": "Banawa",
                        "latitude": "7.15361000",
                        "longitude": "124.86667000"
                    },
                    {
                        "id": 81557,
                        "name": "Bantogon",
                        "latitude": "6.53333000",
                        "longitude": "124.03333000"
                    },
                    {
                        "id": 81582,
                        "name": "Barongis",
                        "latitude": "7.26111000",
                        "longitude": "124.56417000"
                    },
                    {
                        "id": 81595,
                        "name": "Basak",
                        "latitude": "6.72736000",
                        "longitude": "124.15117000"
                    },
                    {
                        "id": 81619,
                        "name": "Batasan",
                        "latitude": "7.03333000",
                        "longitude": "125.05000000"
                    },
                    {
                        "id": 81638,
                        "name": "Batutitik",
                        "latitude": "6.22333000",
                        "longitude": "125.25194000"
                    },
                    {
                        "id": 81639,
                        "name": "Bau",
                        "latitude": "7.40528000",
                        "longitude": "124.64972000"
                    },
                    {
                        "id": 81660,
                        "name": "Bayasong",
                        "latitude": "6.64889000",
                        "longitude": "124.87306000"
                    },
                    {
                        "id": 81682,
                        "name": "Bialong",
                        "latitude": "6.98056000",
                        "longitude": "124.88889000"
                    },
                    {
                        "id": 81748,
                        "name": "Biwang",
                        "latitude": "6.60592000",
                        "longitude": "124.54358000"
                    },
                    {
                        "id": 81750,
                        "name": "Blingkong",
                        "latitude": "6.58808000",
                        "longitude": "124.88951000"
                    },
                    {
                        "id": 81814,
                        "name": "Buadtasan",
                        "latitude": "6.00496000",
                        "longitude": "124.61266000"
                    },
                    {
                        "id": 81816,
                        "name": "Bual",
                        "latitude": "6.79583000",
                        "longitude": "124.91083000"
                    },
                    {
                        "id": 81822,
                        "name": "Buawan",
                        "latitude": "8.31667000",
                        "longitude": "124.30306000"
                    },
                    {
                        "id": 81823,
                        "name": "Buayan",
                        "latitude": "6.11639000",
                        "longitude": "125.23472000"
                    },
                    {
                        "id": 81857,
                        "name": "Bukay Pait",
                        "latitude": "6.56161000",
                        "longitude": "124.76706000"
                    },
                    {
                        "id": 81871,
                        "name": "Bulatukan",
                        "latitude": "6.90250000",
                        "longitude": "125.16083000"
                    },
                    {
                        "id": 81912,
                        "name": "Burias",
                        "latitude": "5.71778000",
                        "longitude": "125.25361000"
                    },
                    {
                        "id": 81919,
                        "name": "Busok",
                        "latitude": "6.50820000",
                        "longitude": "124.60009000"
                    },
                    {
                        "id": 82179,
                        "name": "Carpenter Hill",
                        "latitude": "6.44413000",
                        "longitude": "124.88138000"
                    },
                    {
                        "id": 82239,
                        "name": "Cebuano",
                        "latitude": "6.38794000",
                        "longitude": "124.96841000"
                    },
                    {
                        "id": 82260,
                        "name": "Colongulo",
                        "latitude": "6.33861000",
                        "longitude": "124.72167000"
                    },
                    {
                        "id": 82263,
                        "name": "Columbio",
                        "latitude": "6.69639000",
                        "longitude": "124.93722000"
                    },
                    {
                        "id": 82279,
                        "name": "Conel",
                        "latitude": "6.20222000",
                        "longitude": "125.18722000"
                    },
                    {
                        "id": 82337,
                        "name": "Daguma",
                        "latitude": "6.60345000",
                        "longitude": "124.57020000"
                    },
                    {
                        "id": 82342,
                        "name": "Dahay",
                        "latitude": "6.39067000",
                        "longitude": "124.71464000"
                    },
                    {
                        "id": 82346,
                        "name": "Daliao",
                        "latitude": "5.86111000",
                        "longitude": "124.95333000"
                    },
                    {
                        "id": 82359,
                        "name": "Damawato",
                        "latitude": "6.70000000",
                        "longitude": "124.78333000"
                    },
                    {
                        "id": 82372,
                        "name": "Dansuli",
                        "latitude": "6.64075000",
                        "longitude": "124.58258000"
                    },
                    {
                        "id": 82424,
                        "name": "Digkilaan",
                        "latitude": "8.25111000",
                        "longitude": "124.31722000"
                    },
                    {
                        "id": 82468,
                        "name": "Dualing",
                        "latitude": "7.15167000",
                        "longitude": "124.56833000"
                    },
                    {
                        "id": 82473,
                        "name": "Dukay",
                        "latitude": "6.66688000",
                        "longitude": "124.55697000"
                    },
                    {
                        "id": 82482,
                        "name": "Dumaguil",
                        "latitude": "6.62000000",
                        "longitude": "124.65333000"
                    },
                    {
                        "id": 82496,
                        "name": "Dunguan",
                        "latitude": "6.94972000",
                        "longitude": "124.86083000"
                    },
                    {
                        "id": 82565,
                        "name": "Gansing",
                        "latitude": "6.71851000",
                        "longitude": "124.65338000"
                    },
                    {
                        "id": 82599,
                        "name": "Glad",
                        "latitude": "7.14833000",
                        "longitude": "124.51806000"
                    },
                    {
                        "id": 82600,
                        "name": "Glamang",
                        "latitude": "6.16255000",
                        "longitude": "125.08392000"
                    },
                    {
                        "id": 82602,
                        "name": "Glan Peidu",
                        "latitude": "5.85500000",
                        "longitude": "125.21861000"
                    },
                    {
                        "id": 82605,
                        "name": "Gocoton",
                        "latitude": "7.15611000",
                        "longitude": "124.69111000"
                    },
                    {
                        "id": 82640,
                        "name": "Guinsang-an",
                        "latitude": "6.46499000",
                        "longitude": "124.68491000"
                    },
                    {
                        "id": 82725,
                        "name": "Ilaya",
                        "latitude": "5.81528000",
                        "longitude": "125.22667000"
                    },
                    {
                        "id": 82823,
                        "name": "Kabalen",
                        "latitude": "6.31944000",
                        "longitude": "125.01056000"
                    },
                    {
                        "id": 82828,
                        "name": "Kablalan",
                        "latitude": "5.77972000",
                        "longitude": "125.19778000"
                    },
                    {
                        "id": 82838,
                        "name": "Kalaisan",
                        "latitude": "7.01028000",
                        "longitude": "125.04500000"
                    },
                    {
                        "id": 82839,
                        "name": "Kalamangog",
                        "latitude": "6.72556000",
                        "longitude": "124.06889000"
                    },
                    {
                        "id": 82841,
                        "name": "Kalandagan",
                        "latitude": "6.67826000",
                        "longitude": "124.72477000"
                    },
                    {
                        "id": 82857,
                        "name": "Kamanga",
                        "latitude": "5.85778000",
                        "longitude": "125.05611000"
                    },
                    {
                        "id": 82870,
                        "name": "Kapatan",
                        "latitude": "5.90056000",
                        "longitude": "125.23750000"
                    },
                    {
                        "id": 82871,
                        "name": "Kapaya",
                        "latitude": "6.54258000",
                        "longitude": "124.56314000"
                    },
                    {
                        "id": 82872,
                        "name": "Kapingkong",
                        "latitude": "6.67503000",
                        "longitude": "124.62632000"
                    },
                    {
                        "id": 82876,
                        "name": "Katangawan",
                        "latitude": "6.17222000",
                        "longitude": "125.22139000"
                    },
                    {
                        "id": 82881,
                        "name": "Katubao",
                        "latitude": "5.88917000",
                        "longitude": "124.82944000"
                    },
                    {
                        "id": 82911,
                        "name": "Kipalbig",
                        "latitude": "6.41056000",
                        "longitude": "124.92640000"
                    },
                    {
                        "id": 82913,
                        "name": "Kisante",
                        "latitude": "6.92306000",
                        "longitude": "125.15500000"
                    },
                    {
                        "id": 82920,
                        "name": "Kiupo",
                        "latitude": "5.84167000",
                        "longitude": "125.31917000"
                    },
                    {
                        "id": 82921,
                        "name": "Klinan",
                        "latitude": "6.18683000",
                        "longitude": "125.13684000"
                    },
                    {
                        "id": 82924,
                        "name": "Kolumbug",
                        "latitude": "6.52389000",
                        "longitude": "124.60833000"
                    },
                    {
                        "id": 82928,
                        "name": "Kudanding",
                        "latitude": "6.58803000",
                        "longitude": "124.63274000"
                    },
                    {
                        "id": 82929,
                        "name": "Kulaman",
                        "latitude": "6.46001000",
                        "longitude": "124.08767000"
                    },
                    {
                        "id": 82965,
                        "name": "Labu-o",
                        "latitude": "7.11417000",
                        "longitude": "125.04528000"
                    },
                    {
                        "id": 82980,
                        "name": "Laguilayan",
                        "latitude": "6.67213000",
                        "longitude": "124.52491000"
                    },
                    {
                        "id": 82994,
                        "name": "Lamba",
                        "latitude": "6.35025000",
                        "longitude": "124.81974000"
                    },
                    {
                        "id": 82997,
                        "name": "Lambontong",
                        "latitude": "6.30833000",
                        "longitude": "124.81056000"
                    },
                    {
                        "id": 82999,
                        "name": "Lamian",
                        "latitude": "6.30917000",
                        "longitude": "124.84639000"
                    },
                    {
                        "id": 83004,
                        "name": "Lampari",
                        "latitude": "6.31264000",
                        "longitude": "124.88028000"
                    },
                    {
                        "id": 83005,
                        "name": "Lampitak",
                        "latitude": "6.43222000",
                        "longitude": "125.05250000"
                    },
                    {
                        "id": 83040,
                        "name": "Lapuz",
                        "latitude": "6.49416000",
                        "longitude": "124.63054000"
                    },
                    {
                        "id": 83077,
                        "name": "Libas",
                        "latitude": "6.52014000",
                        "longitude": "124.78234000"
                    },
                    {
                        "id": 83089,
                        "name": "Liberty",
                        "latitude": "6.51989000",
                        "longitude": "124.63194000"
                    },
                    {
                        "id": 83110,
                        "name": "Liliongan",
                        "latitude": "7.36278000",
                        "longitude": "124.79278000"
                    },
                    {
                        "id": 83120,
                        "name": "Limbalod",
                        "latitude": "7.13278000",
                        "longitude": "124.79889000"
                    },
                    {
                        "id": 83127,
                        "name": "Limulan",
                        "latitude": "6.58528000",
                        "longitude": "124.06189000"
                    },
                    {
                        "id": 83132,
                        "name": "Linan",
                        "latitude": "6.43218000",
                        "longitude": "124.97617000"
                    },
                    {
                        "id": 83134,
                        "name": "Linao",
                        "latitude": "7.16778000",
                        "longitude": "124.96750000"
                    },
                    {
                        "id": 83214,
                        "name": "Lumatil",
                        "latitude": "5.87472000",
                        "longitude": "124.88833000"
                    },
                    {
                        "id": 83215,
                        "name": "Lumazal",
                        "latitude": "5.88528000",
                        "longitude": "124.84944000"
                    },
                    {
                        "id": 83226,
                        "name": "Lumuyon",
                        "latitude": "5.91583000",
                        "longitude": "124.78694000"
                    },
                    {
                        "id": 83227,
                        "name": "Lun Pequeño",
                        "latitude": "6.03778000",
                        "longitude": "125.28389000"
                    },
                    {
                        "id": 83238,
                        "name": "Lunen",
                        "latitude": "6.35911000",
                        "longitude": "124.90477000"
                    },
                    {
                        "id": 83255,
                        "name": "Maan",
                        "latitude": "5.93389000",
                        "longitude": "124.73556000"
                    },
                    {
                        "id": 83268,
                        "name": "Mabay",
                        "latitude": "6.05772000",
                        "longitude": "124.46661000"
                    },
                    {
                        "id": 83283,
                        "name": "Mabini",
                        "latitude": "6.50556000",
                        "longitude": "124.90810000"
                    },
                    {
                        "id": 83352,
                        "name": "Maguling",
                        "latitude": "6.09500000",
                        "longitude": "124.40333000"
                    },
                    {
                        "id": 83364,
                        "name": "Maibu",
                        "latitude": "6.57000000",
                        "longitude": "124.79361000"
                    },
                    {
                        "id": 83368,
                        "name": "Maindang",
                        "latitude": "6.58978000",
                        "longitude": "124.84732000"
                    },
                    {
                        "id": 83399,
                        "name": "Malamote",
                        "latitude": "7.07389000",
                        "longitude": "124.94000000"
                    },
                    {
                        "id": 83401,
                        "name": "Malandag",
                        "latitude": "6.31030000",
                        "longitude": "125.24756000"
                    },
                    {
                        "id": 83405,
                        "name": "Malapag",
                        "latitude": "7.13333000",
                        "longitude": "124.81667000"
                    },
                    {
                        "id": 83408,
                        "name": "Malasila",
                        "latitude": "6.94389000",
                        "longitude": "125.12944000"
                    },
                    {
                        "id": 83420,
                        "name": "Malbang",
                        "latitude": "5.85556000",
                        "longitude": "125.04528000"
                    },
                    {
                        "id": 83435,
                        "name": "Malinao",
                        "latitude": "7.56029000",
                        "longitude": "124.70839000"
                    },
                    {
                        "id": 83440,
                        "name": "Malingao",
                        "latitude": "7.16083000",
                        "longitude": "124.47500000"
                    },
                    {
                        "id": 83444,
                        "name": "Malisbeng",
                        "latitude": "6.12000000",
                        "longitude": "124.35472000"
                    },
                    {
                        "id": 83449,
                        "name": "Malitubog",
                        "latitude": "7.31556000",
                        "longitude": "124.63806000"
                    },
                    {
                        "id": 83456,
                        "name": "Maltana",
                        "latitude": "6.42290000",
                        "longitude": "124.93688000"
                    },
                    {
                        "id": 83464,
                        "name": "Maluñgun",
                        "latitude": "6.27917000",
                        "longitude": "125.28167000"
                    },
                    {
                        "id": 83468,
                        "name": "Mamali",
                        "latitude": "6.77360000",
                        "longitude": "124.64770000"
                    },
                    {
                        "id": 83498,
                        "name": "Manaulanan",
                        "latitude": "7.04806000",
                        "longitude": "124.61944000"
                    },
                    {
                        "id": 83508,
                        "name": "Manga",
                        "latitude": "6.29083000",
                        "longitude": "125.30833000"
                    },
                    {
                        "id": 83541,
                        "name": "Manuangan",
                        "latitude": "7.27694000",
                        "longitude": "124.40444000"
                    },
                    {
                        "id": 83543,
                        "name": "Manuel Roxas",
                        "latitude": "6.44173000",
                        "longitude": "124.66605000"
                    },
                    {
                        "id": 83569,
                        "name": "Marbel",
                        "latitude": "7.11583000",
                        "longitude": "124.91250000"
                    },
                    {
                        "id": 83577,
                        "name": "Mariano Marcos",
                        "latitude": "6.73333000",
                        "longitude": "124.66667000"
                    },
                    {
                        "id": 83629,
                        "name": "Matiompong",
                        "latitude": "6.69611000",
                        "longitude": "124.56611000"
                    },
                    {
                        "id": 83681,
                        "name": "Minapan",
                        "latitude": "6.81500000",
                        "longitude": "124.85861000"
                    },
                    {
                        "id": 83683,
                        "name": "Mindupok",
                        "latitude": "6.09056000",
                        "longitude": "124.42333000"
                    },
                    {
                        "id": 83763,
                        "name": "Nalus",
                        "latitude": "6.01222000",
                        "longitude": "124.58528000"
                    },
                    {
                        "id": 83804,
                        "name": "New Cebu",
                        "latitude": "7.09528000",
                        "longitude": "125.03361000"
                    },
                    {
                        "id": 83806,
                        "name": "New Iloilo",
                        "latitude": "6.54776000",
                        "longitude": "124.78951000"
                    },
                    {
                        "id": 83807,
                        "name": "New Lagao",
                        "latitude": "6.70235000",
                        "longitude": "124.64141000"
                    },
                    {
                        "id": 83809,
                        "name": "New Panay",
                        "latitude": "6.74237000",
                        "longitude": "124.55956000"
                    },
                    {
                        "id": 83820,
                        "name": "Noling",
                        "latitude": "6.65984000",
                        "longitude": "124.09981000"
                    },
                    {
                        "id": 83832,
                        "name": "Nunguan",
                        "latitude": "7.12825000",
                        "longitude": "124.68912000"
                    },
                    {
                        "id": 83864,
                        "name": "Osias",
                        "latitude": "7.60000000",
                        "longitude": "124.81667000"
                    },
                    {
                        "id": 83872,
                        "name": "Paatan",
                        "latitude": "7.11972000",
                        "longitude": "124.92389000"
                    },
                    {
                        "id": 83891,
                        "name": "Pagangan",
                        "latitude": "7.11444000",
                        "longitude": "124.59528000"
                    },
                    {
                        "id": 83923,
                        "name": "Palian",
                        "latitude": "6.37427000",
                        "longitude": "124.91062000"
                    },
                    {
                        "id": 83925,
                        "name": "Palkan",
                        "latitude": "6.29639000",
                        "longitude": "125.03167000"
                    },
                    {
                        "id": 83933,
                        "name": "Pamantingan",
                        "latitude": "6.71413000",
                        "longitude": "124.38095000"
                    },
                    {
                        "id": 83984,
                        "name": "Pangyan",
                        "latitude": "5.70083000",
                        "longitude": "125.28111000"
                    },
                    {
                        "id": 84016,
                        "name": "Paraiso",
                        "latitude": "6.47606000",
                        "longitude": "124.80954000"
                    },
                    {
                        "id": 84044,
                        "name": "Patindeguen",
                        "latitude": "7.21972000",
                        "longitude": "124.49833000"
                    },
                    {
                        "id": 84073,
                        "name": "Pedtad",
                        "latitude": "7.16056000",
                        "longitude": "124.81444000"
                    },
                    {
                        "id": 84100,
                        "name": "Pimbalayan",
                        "latitude": "6.86917000",
                        "longitude": "124.67250000"
                    },
                    {
                        "id": 84149,
                        "name": "Polo",
                        "latitude": "6.26472000",
                        "longitude": "125.11250000"
                    },
                    {
                        "id": 84154,
                        "name": "Polonoling",
                        "latitude": "6.28496000",
                        "longitude": "124.96890000"
                    },
                    {
                        "id": 84203,
                        "name": "Province of Cotabato",
                        "latitude": "7.01667000",
                        "longitude": "125.08333000"
                    },
                    {
                        "id": 84239,
                        "name": "Province of Sarangani",
                        "latitude": "5.87472000",
                        "longitude": "125.27528000"
                    },
                    {
                        "id": 84242,
                        "name": "Province of South Cotabato",
                        "latitude": "6.25218000",
                        "longitude": "125.00060000"
                    },
                    {
                        "id": 84244,
                        "name": "Province of Sultan Kudarat",
                        "latitude": "6.55000000",
                        "longitude": "124.28333000"
                    },
                    {
                        "id": 84269,
                        "name": "Puloypuloy",
                        "latitude": "6.63517000",
                        "longitude": "124.09600000"
                    },
                    {
                        "id": 84278,
                        "name": "Punolu",
                        "latitude": "7.05000000",
                        "longitude": "124.58333000"
                    },
                    {
                        "id": 84285,
                        "name": "Puricay",
                        "latitude": "6.68614000",
                        "longitude": "124.06957000"
                    },
                    {
                        "id": 84319,
                        "name": "Ragandang",
                        "latitude": "6.66386000",
                        "longitude": "124.12063000"
                    },
                    {
                        "id": 84351,
                        "name": "Rogongon",
                        "latitude": "8.23333000",
                        "longitude": "124.33333000"
                    },
                    {
                        "id": 84360,
                        "name": "Rotonda",
                        "latitude": "6.49179000",
                        "longitude": "124.88616000"
                    },
                    {
                        "id": 84378,
                        "name": "Sadsalan",
                        "latitude": "6.82906000",
                        "longitude": "124.60893000"
                    },
                    {
                        "id": 84396,
                        "name": "Saguing",
                        "latitude": "6.98028000",
                        "longitude": "125.07806000"
                    },
                    {
                        "id": 84410,
                        "name": "Salimbao",
                        "latitude": "7.22250000",
                        "longitude": "124.25333000"
                    },
                    {
                        "id": 84416,
                        "name": "Salunayan",
                        "latitude": "7.15444000",
                        "longitude": "124.49750000"
                    },
                    {
                        "id": 84433,
                        "name": "Sampao",
                        "latitude": "6.87667000",
                        "longitude": "124.59556000"
                    },
                    {
                        "id": 84633,
                        "name": "Sangay",
                        "latitude": "6.44500000",
                        "longitude": "124.04444000"
                    },
                    {
                        "id": 84747,
                        "name": "Sapu Padidu",
                        "latitude": "5.91722000",
                        "longitude": "125.26694000"
                    },
                    {
                        "id": 84798,
                        "name": "Silway 7",
                        "latitude": "6.17711000",
                        "longitude": "125.12068000"
                    },
                    {
                        "id": 84818,
                        "name": "Sinolon",
                        "latitude": "6.24389000",
                        "longitude": "124.81444000"
                    },
                    {
                        "id": 84869,
                        "name": "Sulit",
                        "latitude": "6.23611000",
                        "longitude": "125.02056000"
                    },
                    {
                        "id": 84885,
                        "name": "Suyan",
                        "latitude": "6.06028000",
                        "longitude": "125.38528000"
                    },
                    {
                        "id": 84950,
                        "name": "Taguisa",
                        "latitude": "6.69833000",
                        "longitude": "124.03583000"
                    },
                    {
                        "id": 85001,
                        "name": "Taluya",
                        "latitude": "5.81167000",
                        "longitude": "125.17278000"
                    },
                    {
                        "id": 85005,
                        "name": "Tambak",
                        "latitude": "6.72532000",
                        "longitude": "124.62342000"
                    },
                    {
                        "id": 85008,
                        "name": "Tambilil",
                        "latitude": "5.96222000",
                        "longitude": "124.66972000"
                    },
                    {
                        "id": 85018,
                        "name": "Tamnag",
                        "latitude": "6.57298000",
                        "longitude": "124.88004000"
                    },
                    {
                        "id": 85019,
                        "name": "Tamontaka",
                        "latitude": "7.18056000",
                        "longitude": "124.22556000"
                    },
                    {
                        "id": 85084,
                        "name": "Tañgo",
                        "latitude": "5.88083000",
                        "longitude": "125.22194000"
                    },
                    {
                        "id": 85087,
                        "name": "Telafas",
                        "latitude": "6.62980000",
                        "longitude": "124.97294000"
                    },
                    {
                        "id": 85090,
                        "name": "Teresita",
                        "latitude": "6.41434000",
                        "longitude": "124.70778000"
                    },
                    {
                        "id": 85125,
                        "name": "Tinagacan",
                        "latitude": "6.19917000",
                        "longitude": "125.22944000"
                    },
                    {
                        "id": 85140,
                        "name": "Tinoto",
                        "latitude": "5.88667000",
                        "longitude": "125.07056000"
                    },
                    {
                        "id": 85160,
                        "name": "Tomado",
                        "latitude": "7.19250000",
                        "longitude": "124.60806000"
                    },
                    {
                        "id": 85175,
                        "name": "Tran",
                        "latitude": "6.72028000",
                        "longitude": "124.05500000"
                    },
                    {
                        "id": 85214,
                        "name": "Tuka",
                        "latitude": "6.51862000",
                        "longitude": "124.58736000"
                    },
                    {
                        "id": 85237,
                        "name": "Tuyan",
                        "latitude": "6.00000000",
                        "longitude": "125.28333000"
                    },
                    {
                        "id": 85265,
                        "name": "Upper Klinan",
                        "latitude": "6.22722000",
                        "longitude": "125.12083000"
                    },
                    {
                        "id": 85266,
                        "name": "Upper San Mateo",
                        "latitude": "7.17306000",
                        "longitude": "124.58222000"
                    },
                    {
                        "id": 85296,
                        "name": "Villamor",
                        "latitude": "6.70380000",
                        "longitude": "124.52009000"
                    }
                ]
            },
            {
                "id": 1281,
                "name": "Sorsogon",
                "iso2": "SOR",
                "latitude": "12.99270950",
                "longitude": "124.01474640",
                "type": "province",
                "cities": [
                    {
                        "id": 81573,
                        "name": "Barcelona",
                        "latitude": "12.83727870",
                        "longitude": "124.07658470"
                    },
                    {
                        "id": 81866,
                        "name": "Bulan",
                        "latitude": "12.65366420",
                        "longitude": "123.83028410"
                    },
                    {
                        "id": 81890,
                        "name": "Bulusan",
                        "latitude": "12.74866770",
                        "longitude": "124.02345260"
                    },
                    {
                        "id": 154803,
                        "name": "Casiguran",
                        "latitude": "12.86207260",
                        "longitude": "123.95155250"
                    },
                    {
                        "id": 82196,
                        "name": "Castilla",
                        "latitude": "12.94647860",
                        "longitude": "123.73092020"
                    },
                    {
                        "id": 82460,
                        "name": "Donsol",
                        "latitude": "12.96271080",
                        "longitude": "123.46802620"
                    },
                    {
                        "id": 82616,
                        "name": "Gubat",
                        "latitude": "12.92335170",
                        "longitude": "124.02916040"
                    },
                    {
                        "id": 82767,
                        "name": "Irosin",
                        "latitude": "12.71702250",
                        "longitude": "123.95199860"
                    },
                    {
                        "id": 82816,
                        "name": "Juban",
                        "latitude": "12.81146110",
                        "longitude": "123.89582110"
                    },
                    {
                        "id": 83321,
                        "name": "Magallanes",
                        "latitude": "12.81395660",
                        "longitude": "123.80660140"
                    },
                    {
                        "id": 83631,
                        "name": "Matnog",
                        "latitude": "12.59462030",
                        "longitude": "123.96843510"
                    },
                    {
                        "id": 154804,
                        "name": "Pilar",
                        "latitude": "12.93506380",
                        "longitude": "123.60986590"
                    },
                    {
                        "id": 84175,
                        "name": "Prieto Diaz",
                        "latitude": "13.03733110",
                        "longitude": "124.12889850"
                    },
                    {
                        "id": 84680,
                        "name": "Santa Magdalena",
                        "latitude": "12.65146010",
                        "longitude": "124.01263800"
                    },
                    {
                        "id": 84848,
                        "name": "Sorsogon",
                        "latitude": "12.97087900",
                        "longitude": "123.80311330"
                    }
                ]
            },
            {
                "id": 1280,
                "name": "South Cotabato",
                "iso2": "SCO",
                "latitude": "6.33575650",
                "longitude": "124.77407930",
                "type": "province",
                "cities": [
                    {
                        "id": 154805,
                        "name": "Banga",
                        "latitude": "6.38235180",
                        "longitude": "124.64562710"
                    },
                    {
                        "id": 143945,
                        "name": "General Santos",
                        "latitude": "6.13742790",
                        "longitude": "124.99270490"
                    },
                    {
                        "id": 143972,
                        "name": "Koronadal",
                        "latitude": "6.46431840",
                        "longitude": "124.74763690"
                    },
                    {
                        "id": 82986,
                        "name": "Lake Sebu",
                        "latitude": "6.24969680",
                        "longitude": "124.26238640"
                    },
                    {
                        "id": 144044,
                        "name": "Norala",
                        "latitude": "6.52797580",
                        "longitude": "124.59392620"
                    },
                    {
                        "id": 144064,
                        "name": "Polomolok",
                        "latitude": "6.24668840",
                        "longitude": "124.98295370"
                    },
                    {
                        "id": 148096,
                        "name": "Santo Niño",
                        "latitude": "6.43889210",
                        "longitude": "124.58973350"
                    },
                    {
                        "id": 144088,
                        "name": "Surallah",
                        "latitude": "6.33262440",
                        "longitude": "124.56322960"
                    },
                    {
                        "id": 154806,
                        "name": "T'Boli",
                        "latitude": "6.14320840",
                        "longitude": "124.69536580"
                    },
                    {
                        "id": 144097,
                        "name": "Tampakan",
                        "latitude": "6.46592380",
                        "longitude": "124.88455610"
                    },
                    {
                        "id": 144098,
                        "name": "Tantangan",
                        "latitude": "6.56745980",
                        "longitude": "124.57796090"
                    },
                    {
                        "id": 144107,
                        "name": "Tupi",
                        "latitude": "6.33117350",
                        "longitude": "124.82647230"
                    }
                ]
            },
            {
                "id": 1284,
                "name": "Southern Leyte",
                "iso2": "SLE",
                "latitude": "10.33462060",
                "longitude": "125.17087410",
                "type": "province",
                "cities": [
                    {
                        "id": 81254,
                        "name": "Anahawan",
                        "latitude": "10.29867120",
                        "longitude": "125.12734260"
                    },
                    {
                        "id": 154807,
                        "name": "Bontoc",
                        "latitude": "10.39098860",
                        "longitude": "124.84611830"
                    },
                    {
                        "id": 82698,
                        "name": "Hinunangan",
                        "latitude": "10.40165330",
                        "longitude": "125.07599430"
                    },
                    {
                        "id": 82699,
                        "name": "Hinundayan",
                        "latitude": "10.35112960",
                        "longitude": "125.13178430"
                    },
                    {
                        "id": 83076,
                        "name": "Libagon",
                        "latitude": "10.33199360",
                        "longitude": "124.98050770"
                    },
                    {
                        "id": 154808,
                        "name": "Liloan",
                        "latitude": "10.15314300",
                        "longitude": "125.07522190"
                    },
                    {
                        "id": 148073,
                        "name": "Limasawa",
                        "latitude": "9.93029600",
                        "longitude": "125.02857590"
                    },
                    {
                        "id": 154809,
                        "name": "Maasin",
                        "latitude": "10.19185120",
                        "longitude": "124.69086000"
                    },
                    {
                        "id": 83307,
                        "name": "Macrohon",
                        "latitude": "10.07632580",
                        "longitude": "124.86723260"
                    },
                    {
                        "id": 83448,
                        "name": "Malitbog",
                        "latitude": "10.17879150",
                        "longitude": "124.87276870"
                    },
                    {
                        "id": 154810,
                        "name": "Padre Burgos",
                        "latitude": "10.06473260",
                        "longitude": "124.95474000"
                    },
                    {
                        "id": 84115,
                        "name": "Pintuyan",
                        "latitude": "9.98011720",
                        "longitude": "125.15860650"
                    },
                    {
                        "id": 84399,
                        "name": "Saint Bernard",
                        "latitude": "10.29378360",
                        "longitude": "125.03719890"
                    },
                    {
                        "id": 154811,
                        "name": "San Francisco",
                        "latitude": "10.07114780",
                        "longitude": "125.08208830"
                    },
                    {
                        "id": 154812,
                        "name": "San Juan",
                        "latitude": "10.28594090",
                        "longitude": "125.11916720"
                    },
                    {
                        "id": 84605,
                        "name": "San Ricardo",
                        "latitude": "9.98692060",
                        "longitude": "125.17637330"
                    },
                    {
                        "id": 84791,
                        "name": "Silago",
                        "latitude": "10.53432970",
                        "longitude": "125.03676970"
                    },
                    {
                        "id": 154813,
                        "name": "Sogod",
                        "latitude": "10.44834400",
                        "longitude": "124.90862460"
                    },
                    {
                        "id": 85161,
                        "name": "Tomas Oppus",
                        "latitude": "10.27468320",
                        "longitude": "124.90472220"
                    }
                ]
            },
            {
                "id": 1282,
                "name": "Sultan Kudarat",
                "iso2": "SUK",
                "latitude": "6.50694010",
                "longitude": "124.41982430",
                "type": "province",
                "cities": [
                    {
                        "id": 81413,
                        "name": "Bagumbayan",
                        "latitude": "6.47305080",
                        "longitude": "124.33843910"
                    },
                    {
                        "id": 154814,
                        "name": "Esperanza",
                        "latitude": "6.72072040",
                        "longitude": "124.26975300"
                    },
                    {
                        "id": 82773,
                        "name": "Isulan",
                        "latitude": "6.60762030",
                        "longitude": "124.29080290"
                    },
                    {
                        "id": 82840,
                        "name": "Kalamansig",
                        "latitude": "6.50930830",
                        "longitude": "123.98334660"
                    },
                    {
                        "id": 82996,
                        "name": "Lambayong",
                        "latitude": "6.77514560",
                        "longitude": "124.54633310"
                    },
                    {
                        "id": 143985,
                        "name": "Lebak",
                        "latitude": "6.66538430",
                        "longitude": "123.98043910"
                    },
                    {
                        "id": 83251,
                        "name": "Lutayan",
                        "latitude": "6.61267500",
                        "longitude": "124.77481440"
                    },
                    {
                        "id": 144051,
                        "name": "Palimbang",
                        "latitude": "6.27259210",
                        "longitude": "124.05820170"
                    },
                    {
                        "id": 144066,
                        "name": "President Quirino",
                        "latitude": "6.69698670",
                        "longitude": "124.64899740"
                    },
                    {
                        "id": 154815,
                        "name": "Senator Ninoy Aquino",
                        "latitude": "6.36771520",
                        "longitude": "124.20437150"
                    },
                    {
                        "id": 144091,
                        "name": "Tacurong",
                        "latitude": "6.66403770",
                        "longitude": "124.59040720"
                    }
                ]
            },
            {
                "id": 1288,
                "name": "Sulu",
                "iso2": "SLU",
                "latitude": "5.97490110",
                "longitude": "121.03351000",
                "type": "province",
                "cities": [
                    {
                        "id": 144635,
                        "name": "Banguingui",
                        "latitude": "6.08188500",
                        "longitude": "121.40761480"
                    },
                    {
                        "id": 154816,
                        "name": "Hadji Panglima Tahil",
                        "latitude": "6.22260290",
                        "longitude": "120.78041360"
                    },
                    {
                        "id": 144529,
                        "name": "Indanan",
                        "latitude": "5.99239660",
                        "longitude": "120.88041850"
                    },
                    {
                        "id": 144531,
                        "name": "Jolo",
                        "latitude": "6.04757200",
                        "longitude": "120.97829560"
                    },
                    {
                        "id": 144538,
                        "name": "Kalingalan Caluang",
                        "latitude": "5.90756470",
                        "longitude": "121.20380710"
                    },
                    {
                        "id": 144569,
                        "name": "Lugus",
                        "latitude": "5.68653540",
                        "longitude": "120.80106040"
                    },
                    {
                        "id": 144575,
                        "name": "Luuk",
                        "latitude": "5.96916260",
                        "longitude": "121.28382580"
                    },
                    {
                        "id": 144581,
                        "name": "Maimbung",
                        "latitude": "5.93176850",
                        "longitude": "120.91329170"
                    },
                    {
                        "id": 154817,
                        "name": "Omar",
                        "latitude": "5.97875910",
                        "longitude": "121.31352020"
                    },
                    {
                        "id": 154818,
                        "name": "Panamao",
                        "latitude": "5.97633070",
                        "longitude": "121.14102200"
                    },
                    {
                        "id": 144658,
                        "name": "Pandami",
                        "latitude": "5.62628300",
                        "longitude": "120.20873160"
                    },
                    {
                        "id": 154819,
                        "name": "Panglima Estino",
                        "latitude": "5.96502490",
                        "longitude": "121.15327730"
                    },
                    {
                        "id": 144662,
                        "name": "Pangutaran",
                        "latitude": "6.11136880",
                        "longitude": "119.51887770"
                    },
                    {
                        "id": 154820,
                        "name": "Parang",
                        "latitude": "5.91074330",
                        "longitude": "120.70067690"
                    },
                    {
                        "id": 145264,
                        "name": "Pata",
                        "latitude": "5.82681960",
                        "longitude": "120.96422010"
                    },
                    {
                        "id": 144697,
                        "name": "Patikul",
                        "latitude": "6.05236640",
                        "longitude": "120.92966670"
                    },
                    {
                        "id": 144720,
                        "name": "Siasi",
                        "latitude": "5.53208770",
                        "longitude": "120.80720510"
                    },
                    {
                        "id": 144737,
                        "name": "Talipao",
                        "latitude": "5.94209640",
                        "longitude": "121.01242620"
                    },
                    {
                        "id": 144744,
                        "name": "Tapul",
                        "latitude": "5.70726520",
                        "longitude": "120.81285770"
                    }
                ]
            },
            {
                "id": 1286,
                "name": "Surigao del Norte",
                "iso2": "SUN",
                "latitude": "9.51482800",
                "longitude": "125.69699840",
                "type": "province",
                "cities": [
                    {
                        "id": 154821,
                        "name": "Alegria",
                        "latitude": "9.48507120",
                        "longitude": "125.53845010"
                    },
                    {
                        "id": 144380,
                        "name": "Bacuag",
                        "latitude": "9.53346440",
                        "longitude": "125.55329880"
                    },
                    {
                        "id": 154822,
                        "name": "Burgos",
                        "latitude": "10.01910090",
                        "longitude": "126.05189300"
                    },
                    {
                        "id": 144415,
                        "name": "Claver",
                        "latitude": "9.46317930",
                        "longitude": "125.64682070"
                    },
                    {
                        "id": 144421,
                        "name": "Dapa",
                        "latitude": "9.75958320",
                        "longitude": "125.96326910"
                    },
                    {
                        "id": 82404,
                        "name": "Del Carmen",
                        "latitude": "9.85210720",
                        "longitude": "125.88275990"
                    },
                    {
                        "id": 154823,
                        "name": "General Luna",
                        "latitude": "9.72399610",
                        "longitude": "126.06381970"
                    },
                    {
                        "id": 82591,
                        "name": "Gigaquit",
                        "latitude": "9.48488370",
                        "longitude": "125.61921670"
                    },
                    {
                        "id": 83370,
                        "name": "Mainit",
                        "latitude": "9.53509280",
                        "longitude": "125.43781350"
                    },
                    {
                        "id": 83433,
                        "name": "Malimono",
                        "latitude": "9.56483210",
                        "longitude": "125.34704750"
                    },
                    {
                        "id": 154824,
                        "name": "Pilar",
                        "latitude": "9.88349580",
                        "longitude": "126.03815940"
                    },
                    {
                        "id": 154825,
                        "name": "Placer",
                        "latitude": "9.66056260",
                        "longitude": "125.50351700"
                    },
                    {
                        "id": 144487,
                        "name": "San Benito",
                        "latitude": "9.95712900",
                        "longitude": "125.90717880"
                    },
                    {
                        "id": 154826,
                        "name": "San Francisco",
                        "latitude": "9.72778720",
                        "longitude": "125.37084720"
                    },
                    {
                        "id": 154827,
                        "name": "San Isidro",
                        "latitude": "9.94885110",
                        "longitude": "126.03592770"
                    },
                    {
                        "id": 84690,
                        "name": "Santa Monica",
                        "latitude": "10.02780360",
                        "longitude": "126.00211050"
                    },
                    {
                        "id": 154828,
                        "name": "Sison",
                        "latitude": "9.66633940",
                        "longitude": "125.41097010"
                    },
                    {
                        "id": 84835,
                        "name": "Socorro",
                        "latitude": "9.66122840",
                        "longitude": "125.85619520"
                    },
                    {
                        "id": 144509,
                        "name": "Surigao City",
                        "latitude": "9.79717500",
                        "longitude": "125.41917610"
                    },
                    {
                        "id": 144510,
                        "name": "Tagana-an",
                        "latitude": "9.70394220",
                        "longitude": "125.53161580"
                    },
                    {
                        "id": 154829,
                        "name": "Tubod",
                        "latitude": "9.56974790",
                        "longitude": "125.52551820"
                    }
                ]
            },
            {
                "id": 1296,
                "name": "Surigao del Sur",
                "iso2": "SUR",
                "latitude": "8.54049060",
                "longitude": "126.11447580",
                "type": "province",
                "cities": [
                    {
                        "id": 144386,
                        "name": "Barobo",
                        "latitude": "8.48629260",
                        "longitude": "126.02381030"
                    },
                    {
                        "id": 81652,
                        "name": "Bayabas",
                        "latitude": "8.97600390",
                        "longitude": "126.22479810"
                    },
                    {
                        "id": 81737,
                        "name": "Bislig",
                        "latitude": "8.20949370",
                        "longitude": "126.17006570"
                    },
                    {
                        "id": 82000,
                        "name": "Cagwait",
                        "latitude": "8.89139090",
                        "longitude": "126.08204640"
                    },
                    {
                        "id": 82128,
                        "name": "Cantilan",
                        "latitude": "9.30891160",
                        "longitude": "125.73361670"
                    },
                    {
                        "id": 154830,
                        "name": "Carmen",
                        "latitude": "9.18191620",
                        "longitude": "125.76301380"
                    },
                    {
                        "id": 82181,
                        "name": "Carrascal",
                        "latitude": "9.38185070",
                        "longitude": "125.71434770"
                    },
                    {
                        "id": 82299,
                        "name": "Cortes",
                        "latitude": "9.23184780",
                        "longitude": "126.07008520"
                    },
                    {
                        "id": 82693,
                        "name": "Hinatuan",
                        "latitude": "8.41820630",
                        "longitude": "126.25166010"
                    },
                    {
                        "id": 83025,
                        "name": "Lanuza",
                        "latitude": "9.16889840",
                        "longitude": "125.82760140"
                    },
                    {
                        "id": 83074,
                        "name": "Lianga",
                        "latitude": "8.63875520",
                        "longitude": "126.00824420"
                    },
                    {
                        "id": 83140,
                        "name": "Lingig",
                        "latitude": "8.09757550",
                        "longitude": "126.21147900"
                    },
                    {
                        "id": 83313,
                        "name": "Madrid",
                        "latitude": "9.21161400",
                        "longitude": "125.73095610"
                    },
                    {
                        "id": 83582,
                        "name": "Marihatag",
                        "latitude": "8.78798430",
                        "longitude": "125.79982840"
                    },
                    {
                        "id": 154831,
                        "name": "San Agustin",
                        "latitude": "8.72141430",
                        "longitude": "125.94712060"
                    },
                    {
                        "id": 154832,
                        "name": "San Miguel",
                        "latitude": "8.94834480",
                        "longitude": "125.81438340"
                    },
                    {
                        "id": 84936,
                        "name": "Tagbina",
                        "latitude": "8.42775660",
                        "longitude": "126.03745740"
                    },
                    {
                        "id": 84944,
                        "name": "Tago",
                        "latitude": "8.97204320",
                        "longitude": "125.94527530"
                    },
                    {
                        "id": 85031,
                        "name": "Tandag",
                        "latitude": "9.09298150",
                        "longitude": "125.96729090"
                    }
                ]
            },
            {
                "id": 1295,
                "name": "Tarlac",
                "iso2": "TAR",
                "latitude": "15.47547860",
                "longitude": "120.59634920",
                "type": "province",
                "cities": [
                    {
                        "id": 81257,
                        "name": "Anao",
                        "latitude": "15.74348520",
                        "longitude": "120.57733200"
                    },
                    {
                        "id": 81510,
                        "name": "Bamban",
                        "latitude": "15.24958250",
                        "longitude": "120.31388110"
                    },
                    {
                        "id": 82089,
                        "name": "Camiling",
                        "latitude": "15.69344400",
                        "longitude": "120.31758390"
                    },
                    {
                        "id": 82137,
                        "name": "Capas",
                        "latitude": "15.33294730",
                        "longitude": "120.26422810"
                    },
                    {
                        "id": 154833,
                        "name": "Concepcion",
                        "latitude": "15.33908210",
                        "longitude": "120.60927940"
                    },
                    {
                        "id": 82585,
                        "name": "Gerona",
                        "latitude": "15.60013720",
                        "longitude": "120.48041050"
                    },
                    {
                        "id": 154834,
                        "name": "La Paz",
                        "latitude": "15.45716560",
                        "longitude": "120.63415970"
                    },
                    {
                        "id": 83646,
                        "name": "Mayantoc",
                        "latitude": "15.57221810",
                        "longitude": "120.12983870"
                    },
                    {
                        "id": 83699,
                        "name": "Moncada",
                        "latitude": "15.76286300",
                        "longitude": "120.46074950"
                    },
                    {
                        "id": 83990,
                        "name": "Paniqui",
                        "latitude": "15.67708780",
                        "longitude": "120.46336720"
                    },
                    {
                        "id": 84283,
                        "name": "Pura",
                        "latitude": "15.62322250",
                        "longitude": "120.64037560"
                    },
                    {
                        "id": 84325,
                        "name": "Ramos",
                        "latitude": "15.67045640",
                        "longitude": "120.63318720"
                    },
                    {
                        "id": 84463,
                        "name": "San Clemente",
                        "latitude": "15.67877350",
                        "longitude": "120.24960860"
                    },
                    {
                        "id": 154835,
                        "name": "San Jose",
                        "latitude": "15.43212170",
                        "longitude": "120.19033890"
                    },
                    {
                        "id": 154836,
                        "name": "San Manuel",
                        "latitude": "15.82887130",
                        "longitude": "120.55838760"
                    },
                    {
                        "id": 84672,
                        "name": "Santa Ignacia",
                        "latitude": "15.58367330",
                        "longitude": "120.37297900"
                    },
                    {
                        "id": 85058,
                        "name": "Tarlac City",
                        "latitude": "15.47274830",
                        "longitude": "120.53060610"
                    },
                    {
                        "id": 154837,
                        "name": "Victoria",
                        "latitude": "15.57946790",
                        "longitude": "120.60706980"
                    }
                ]
            },
            {
                "id": 1293,
                "name": "Tawi-Tawi",
                "iso2": "TAW",
                "latitude": "5.13381100",
                "longitude": "119.95092600",
                "type": "province",
                "cities": [
                    {
                        "id": 81789,
                        "name": "Bongao",
                        "latitude": "5.09318240",
                        "longitude": "119.67366970"
                    },
                    {
                        "id": 83017,
                        "name": "Languyan",
                        "latitude": "5.31145130",
                        "longitude": "119.78489910"
                    },
                    {
                        "id": 154838,
                        "name": "Mapun",
                        "latitude": "7.00709880",
                        "longitude": "118.39656420"
                    },
                    {
                        "id": 144661,
                        "name": "Panglima Sugala",
                        "latitude": "5.09037590",
                        "longitude": "119.86262590"
                    },
                    {
                        "id": 144715,
                        "name": "Sapa-Sapa",
                        "latitude": "5.07907680",
                        "longitude": "120.04398620"
                    },
                    {
                        "id": 154839,
                        "name": "Sibutu",
                        "latitude": "4.77833460",
                        "longitude": "119.39391690"
                    },
                    {
                        "id": 84805,
                        "name": "Simunul",
                        "latitude": "4.86746250",
                        "longitude": "119.74779680"
                    },
                    {
                        "id": 84833,
                        "name": "Sitangkai",
                        "latitude": "4.76052680",
                        "longitude": "119.23786430"
                    },
                    {
                        "id": 144725,
                        "name": "South Ubian",
                        "latitude": "5.33296120",
                        "longitude": "120.36104470"
                    },
                    {
                        "id": 144741,
                        "name": "Tandubas",
                        "latitude": "5.21943750",
                        "longitude": "120.09565630"
                    },
                    {
                        "id": 144759,
                        "name": "Turtle Islands",
                        "latitude": "6.23034090",
                        "longitude": "118.00511410"
                    }
                ]
            },
            {
                "id": 5115,
                "name": "Western Samar",
                "iso2": "WSA",
                "latitude": "12.00002060",
                "longitude": "124.99124520",
                "type": "province",
                "cities": [
                    {
                        "id": 81225,
                        "name": "Almagro",
                        "latitude": "11.92402790",
                        "longitude": "124.24232080"
                    },
                    {
                        "id": 81600,
                        "name": "Basey",
                        "latitude": "11.41137320",
                        "longitude": "124.98083880"
                    },
                    {
                        "id": 82045,
                        "name": "Calbayog City",
                        "latitude": "12.19353630",
                        "longitude": "124.27388810"
                    },
                    {
                        "id": 82046,
                        "name": "Calbiga",
                        "latitude": "11.62534560",
                        "longitude": "124.94011210"
                    },
                    {
                        "id": 82208,
                        "name": "Catbalogan",
                        "latitude": "11.79864480",
                        "longitude": "124.65056240"
                    },
                    {
                        "id": 82385,
                        "name": "Daram",
                        "latitude": "11.62895820",
                        "longitude": "124.69597890"
                    },
                    {
                        "id": 82563,
                        "name": "Gandara",
                        "latitude": "12.08511870",
                        "longitude": "124.65871630"
                    },
                    {
                        "id": 148099,
                        "name": "Hinabangan",
                        "latitude": "11.74592230",
                        "longitude": "125.00465690"
                    },
                    {
                        "id": 82804,
                        "name": "Jiabong",
                        "latitude": "11.85589270",
                        "longitude": "124.88066520"
                    },
                    {
                        "id": 147997,
                        "name": "Marabut",
                        "latitude": "11.23472610",
                        "longitude": "125.07083220"
                    },
                    {
                        "id": 148070,
                        "name": "Matuguinao",
                        "latitude": "12.20719730",
                        "longitude": "124.82379010"
                    },
                    {
                        "id": 83715,
                        "name": "Motiong",
                        "latitude": "11.88134250",
                        "longitude": "124.94956580"
                    },
                    {
                        "id": 83896,
                        "name": "Pagsanghan",
                        "latitude": "11.96483960",
                        "longitude": "124.66177540"
                    },
                    {
                        "id": 154840,
                        "name": "Paranas",
                        "latitude": "11.85071570",
                        "longitude": "124.95976740"
                    },
                    {
                        "id": 148101,
                        "name": "Pinabacdao",
                        "latitude": "11.57952480",
                        "longitude": "124.93144320"
                    },
                    {
                        "id": 84512,
                        "name": "San Jorge",
                        "latitude": "11.97245050",
                        "longitude": "124.71873340"
                    },
                    {
                        "id": 84522,
                        "name": "San Jose de Buan",
                        "latitude": "12.06950670",
                        "longitude": "124.96776180"
                    },
                    {
                        "id": 84613,
                        "name": "San Sebastian",
                        "latitude": "11.70316700",
                        "longitude": "124.97523210"
                    },
                    {
                        "id": 84682,
                        "name": "Santa Margarita",
                        "latitude": "12.08075650",
                        "longitude": "124.62508270"
                    },
                    {
                        "id": 154841,
                        "name": "Santa Rita",
                        "latitude": "11.40491700",
                        "longitude": "124.81823260"
                    },
                    {
                        "id": 154842,
                        "name": "Santo Niño",
                        "latitude": "11.93595800",
                        "longitude": "124.39368620"
                    },
                    {
                        "id": 84929,
                        "name": "Tagapul-an",
                        "latitude": "12.06356460",
                        "longitude": "124.10941200"
                    },
                    {
                        "id": 84969,
                        "name": "Talalora",
                        "latitude": "11.50911890",
                        "longitude": "124.80472930"
                    },
                    {
                        "id": 85055,
                        "name": "Tarangnan",
                        "latitude": "11.90118670",
                        "longitude": "124.57704840"
                    },
                    {
                        "id": 85299,
                        "name": "Villareal",
                        "latitude": "11.55254410",
                        "longitude": "124.85532360"
                    },
                    {
                        "id": 85328,
                        "name": "Zumarraga",
                        "latitude": "11.66240050",
                        "longitude": "124.81653110"
                    }
                ]
            },
            {
                "id": 1305,
                "name": "Western Visayas",
                "iso2": "06",
                "latitude": "11.00498360",
                "longitude": "122.53727410",
                "type": "region",
                "cities": []
            },
            {
                "id": 1297,
                "name": "Zambales",
                "iso2": "ZMB",
                "latitude": "15.50817660",
                "longitude": "119.96978080",
                "type": "province",
                "cities": [
                    {
                        "id": 81804,
                        "name": "Botolan",
                        "latitude": "15.22543770",
                        "longitude": "119.85695690"
                    },
                    {
                        "id": 81949,
                        "name": "Cabangan",
                        "latitude": "15.17284720",
                        "longitude": "120.03065190"
                    },
                    {
                        "id": 154843,
                        "name": "Candelaria",
                        "latitude": "15.63411950",
                        "longitude": "119.91914590"
                    },
                    {
                        "id": 82197,
                        "name": "Castillejos",
                        "latitude": "14.92788480",
                        "longitude": "120.13658850"
                    },
                    {
                        "id": 82706,
                        "name": "Iba",
                        "latitude": "15.36892620",
                        "longitude": "119.88528770"
                    },
                    {
                        "id": 83603,
                        "name": "Masinloc",
                        "latitude": "15.53880200",
                        "longitude": "119.89489880"
                    },
                    {
                        "id": 83852,
                        "name": "Olongapo",
                        "latitude": "14.88172890",
                        "longitude": "120.18114770"
                    },
                    {
                        "id": 83917,
                        "name": "Palauig",
                        "latitude": "15.44894840",
                        "longitude": "119.87369840"
                    },
                    {
                        "id": 154844,
                        "name": "San Antonio",
                        "latitude": "14.85764550",
                        "longitude": "120.00530500"
                    },
                    {
                        "id": 84475,
                        "name": "San Felipe",
                        "latitude": "15.08286780",
                        "longitude": "120.05234550"
                    },
                    {
                        "id": 84547,
                        "name": "San Marcelino",
                        "latitude": "15.03713500",
                        "longitude": "120.12080500"
                    },
                    {
                        "id": 154845,
                        "name": "San Narciso",
                        "latitude": "15.00821630",
                        "longitude": "120.03524370"
                    },
                    {
                        "id": 154846,
                        "name": "Santa Cruz",
                        "latitude": "15.77590360",
                        "longitude": "119.86417130"
                    },
                    {
                        "id": 84854,
                        "name": "Subic",
                        "latitude": "14.87235590",
                        "longitude": "120.10597810"
                    }
                ]
            },
            {
                "id": 1302,
                "name": "Zamboanga del Norte",
                "iso2": "ZAN",
                "latitude": "8.38862820",
                "longitude": "123.16888830",
                "type": "province",
                "cities": [
                    {
                        "id": 82380,
                        "name": "Baliguian",
                        "latitude": "7.82305300",
                        "longitude": "122.26409910"
                    },
                    {
                        "id": 82381,
                        "name": "Dapitan",
                        "latitude": "8.57700720",
                        "longitude": "123.26873100"
                    },
                    {
                        "id": 82444,
                        "name": "Dipolog",
                        "latitude": "8.50856760",
                        "longitude": "123.27535230"
                    },
                    {
                        "id": 154847,
                        "name": "Godod",
                        "latitude": "7.98032130",
                        "longitude": "122.66062060"
                    },
                    {
                        "id": 82660,
                        "name": "Gutalac",
                        "latitude": "7.92708590",
                        "longitude": "122.18988210"
                    },
                    {
                        "id": 154848,
                        "name": "Jose Dalman",
                        "latitude": "8.40066740",
                        "longitude": "122.90296350"
                    },
                    {
                        "id": 82844,
                        "name": "Kalawit",
                        "latitude": "7.90949500",
                        "longitude": "122.36049210"
                    },
                    {
                        "id": 82880,
                        "name": "Katipunan",
                        "latitude": "8.43463170",
                        "longitude": "123.13998500"
                    },
                    {
                        "id": 154849,
                        "name": "La Libertad",
                        "latitude": "8.47784130",
                        "longitude": "123.49332240"
                    },
                    {
                        "id": 82958,
                        "name": "Labason",
                        "latitude": "8.05714820",
                        "longitude": "122.36175820"
                    },
                    {
                        "id": 154850,
                        "name": "Leon B. Postigo",
                        "latitude": "8.05754150",
                        "longitude": "122.86997390"
                    },
                    {
                        "id": 83113,
                        "name": "Liloy",
                        "latitude": "8.09758210",
                        "longitude": "122.59801940"
                    },
                    {
                        "id": 83545,
                        "name": "Manukan",
                        "latitude": "8.41864590",
                        "longitude": "123.03112110"
                    },
                    {
                        "id": 154851,
                        "name": "Mutia",
                        "latitude": "8.38928300",
                        "longitude": "123.42478350"
                    },
                    {
                        "id": 154852,
                        "name": "Piñan",
                        "latitude": "8.42077890",
                        "longitude": "123.37813450"
                    },
                    {
                        "id": 84142,
                        "name": "Polanco",
                        "latitude": "8.47426640",
                        "longitude": "123.31989830"
                    },
                    {
                        "id": 154853,
                        "name": "President Manuel A. Roxas",
                        "latitude": "8.44009000",
                        "longitude": "123.13274450"
                    },
                    {
                        "id": 154854,
                        "name": "Rizal",
                        "latitude": "8.57176310",
                        "longitude": "123.49207780"
                    },
                    {
                        "id": 84415,
                        "name": "Salug",
                        "latitude": "8.08479540",
                        "longitude": "122.71702360"
                    },
                    {
                        "id": 154855,
                        "name": "Sergio Osmeña Sr.",
                        "latitude": "8.28119810",
                        "longitude": "123.03393440"
                    },
                    {
                        "id": 84767,
                        "name": "Siayan",
                        "latitude": "8.14239820",
                        "longitude": "122.93553630"
                    },
                    {
                        "id": 84773,
                        "name": "Sibuco",
                        "latitude": "7.32205300",
                        "longitude": "121.89981740"
                    },
                    {
                        "id": 154856,
                        "name": "Sibutad",
                        "latitude": "8.61753740",
                        "longitude": "123.40341160"
                    },
                    {
                        "id": 84813,
                        "name": "Sindangan",
                        "latitude": "8.25232670",
                        "longitude": "122.86009110"
                    },
                    {
                        "id": 84823,
                        "name": "Siocon",
                        "latitude": "7.70006280",
                        "longitude": "122.03508650"
                    },
                    {
                        "id": 154857,
                        "name": "Sirawai",
                        "latitude": "7.54208790",
                        "longitude": "122.00684820"
                    },
                    {
                        "id": 85025,
                        "name": "Tampilisan",
                        "latitude": "7.97363090",
                        "longitude": "122.59574480"
                    }
                ]
            },
            {
                "id": 1357,
                "name": "Zamboanga del Sur",
                "iso2": "ZAS",
                "latitude": "7.83830540",
                "longitude": "123.29666570",
                "type": "province",
                "cities": [
                    {
                        "id": 154858,
                        "name": "Aurora",
                        "latitude": "7.93139380",
                        "longitude": "123.48785830"
                    },
                    {
                        "id": 81666,
                        "name": "Bayog",
                        "latitude": "7.91051020",
                        "longitude": "122.88438120"
                    },
                    {
                        "id": 82430,
                        "name": "Dimataling",
                        "latitude": "7.52214930",
                        "longitude": "123.24710860"
                    },
                    {
                        "id": 154859,
                        "name": "Dinas",
                        "latitude": "7.63391800",
                        "longitude": "123.26375160"
                    },
                    {
                        "id": 82485,
                        "name": "Dumalinao",
                        "latitude": "7.77851560",
                        "longitude": "123.31373780"
                    },
                    {
                        "id": 82492,
                        "name": "Dumingag",
                        "latitude": "8.16432410",
                        "longitude": "123.20590980"
                    },
                    {
                        "id": 82644,
                        "name": "Guipos",
                        "latitude": "7.74679210",
                        "longitude": "123.24535410"
                    },
                    {
                        "id": 82813,
                        "name": "Josefina",
                        "latitude": "8.18999110",
                        "longitude": "123.49285820"
                    },
                    {
                        "id": 82933,
                        "name": "Kumalarang",
                        "latitude": "7.77038360",
                        "longitude": "123.05467750"
                    },
                    {
                        "id": 82956,
                        "name": "Labangan",
                        "latitude": "7.89453340",
                        "longitude": "123.24559960"
                    },
                    {
                        "id": 154860,
                        "name": "Lakewood",
                        "latitude": "7.89447840",
                        "longitude": "123.09442120"
                    },
                    {
                        "id": 83039,
                        "name": "Lapuyan",
                        "latitude": "7.69787490",
                        "longitude": "123.10763910"
                    },
                    {
                        "id": 83360,
                        "name": "Mahayag",
                        "latitude": "8.13186250",
                        "longitude": "123.35281440"
                    },
                    {
                        "id": 83573,
                        "name": "Margosatubig",
                        "latitude": "7.57444980",
                        "longitude": "123.09197500"
                    },
                    {
                        "id": 83669,
                        "name": "Midsalip",
                        "latitude": "8.04491720",
                        "longitude": "123.10608190"
                    },
                    {
                        "id": 83695,
                        "name": "Molave",
                        "latitude": "8.13381700",
                        "longitude": "123.39980940"
                    },
                    {
                        "id": 83887,
                        "name": "Pagadian",
                        "latitude": "7.87270550",
                        "longitude": "123.16479060"
                    },
                    {
                        "id": 154861,
                        "name": "Pitogo",
                        "latitude": "7.44322590",
                        "longitude": "123.25372290"
                    },
                    {
                        "id": 84324,
                        "name": "Ramon Magsaysay",
                        "latitude": "8.01817460",
                        "longitude": "123.38409440"
                    },
                    {
                        "id": 154862,
                        "name": "San Miguel",
                        "latitude": "7.68605810",
                        "longitude": "123.18831590"
                    },
                    {
                        "id": 154863,
                        "name": "San Pablo",
                        "latitude": "7.66698870",
                        "longitude": "123.33989420"
                    },
                    {
                        "id": 154864,
                        "name": "Sominot",
                        "latitude": "8.03542250",
                        "longitude": "123.28616160"
                    },
                    {
                        "id": 84896,
                        "name": "Tabina",
                        "latitude": "7.41651070",
                        "longitude": "123.37889670"
                    },
                    {
                        "id": 85014,
                        "name": "Tambulig",
                        "latitude": "8.07715230",
                        "longitude": "123.49696700"
                    },
                    {
                        "id": 85103,
                        "name": "Tigbao",
                        "latitude": "7.84589690",
                        "longitude": "123.17655840"
                    },
                    {
                        "id": 154865,
                        "name": "Tukuran",
                        "latitude": "7.90946430",
                        "longitude": "123.35628100"
                    },
                    {
                        "id": 154866,
                        "name": "Vincenzo A. Sagun",
                        "latitude": "7.51429110",
                        "longitude": "123.10175830"
                    },
                    {
                        "id": 85324,
                        "name": "Zamboanga",
                        "latitude": "7.16124910",
                        "longitude": "121.83842940"
                    }
                ]
            },
            {
                "id": 1325,
                "name": "Zamboanga Peninsula",
                "iso2": "09",
                "latitude": "8.15407700",
                "longitude": "123.25879300",
                "type": "region",
                "cities": []
            },
            {
                "id": 1362,
                "name": "Zamboanga Sibugay",
                "iso2": "ZSI",
                "latitude": "7.52252470",
                "longitude": "122.31075170",
                "type": "province",
                "cities": [
                    {
                        "id": 81213,
                        "name": "Alicia",
                        "latitude": "7.51389000",
                        "longitude": "122.93000000"
                    },
                    {
                        "id": 81335,
                        "name": "Aurora",
                        "latitude": "7.95060000",
                        "longitude": "123.58260000"
                    },
                    {
                        "id": 81433,
                        "name": "Balagon",
                        "latitude": "8.00630000",
                        "longitude": "123.23960000"
                    },
                    {
                        "id": 81635,
                        "name": "Batu",
                        "latitude": "7.75333000",
                        "longitude": "122.82944000"
                    },
                    {
                        "id": 81732,
                        "name": "Binuatan",
                        "latitude": "7.61222000",
                        "longitude": "123.34417000"
                    },
                    {
                        "id": 81781,
                        "name": "Bolong",
                        "latitude": "7.09833000",
                        "longitude": "122.23917000"
                    },
                    {
                        "id": 81899,
                        "name": "Bunguiao",
                        "latitude": "7.10444000",
                        "longitude": "122.19639000"
                    },
                    {
                        "id": 81928,
                        "name": "Buug",
                        "latitude": "7.72940000",
                        "longitude": "123.05980000"
                    },
                    {
                        "id": 81943,
                        "name": "Cabaluay",
                        "latitude": "7.00139000",
                        "longitude": "122.18028000"
                    },
                    {
                        "id": 82010,
                        "name": "Calabasa",
                        "latitude": "7.24639000",
                        "longitude": "122.23417000"
                    },
                    {
                        "id": 82147,
                        "name": "Caracal",
                        "latitude": "8.12722000",
                        "longitude": "122.84500000"
                    },
                    {
                        "id": 82314,
                        "name": "Culianan",
                        "latitude": "6.98028000",
                        "longitude": "122.14667000"
                    },
                    {
                        "id": 82322,
                        "name": "Curuan",
                        "latitude": "7.20528000",
                        "longitude": "122.23306000"
                    },
                    {
                        "id": 82344,
                        "name": "Dalangin",
                        "latitude": "7.85056000",
                        "longitude": "122.57833000"
                    },
                    {
                        "id": 82371,
                        "name": "Danlugan",
                        "latitude": "7.89139000",
                        "longitude": "123.37278000"
                    },
                    {
                        "id": 82398,
                        "name": "Dawa-Dawa",
                        "latitude": "7.46833000",
                        "longitude": "122.83694000"
                    },
                    {
                        "id": 82408,
                        "name": "Del Monte",
                        "latitude": "7.72583000",
                        "longitude": "123.00806000"
                    },
                    {
                        "id": 82420,
                        "name": "Dicayong",
                        "latitude": "8.22060000",
                        "longitude": "123.03380000"
                    },
                    {
                        "id": 82442,
                        "name": "Diplahan",
                        "latitude": "7.71667000",
                        "longitude": "123.01667000"
                    },
                    {
                        "id": 82443,
                        "name": "Dipolo",
                        "latitude": "7.78280000",
                        "longitude": "123.11580000"
                    },
                    {
                        "id": 82445,
                        "name": "Disod",
                        "latitude": "8.26110000",
                        "longitude": "123.01690000"
                    },
                    {
                        "id": 82478,
                        "name": "Dulian",
                        "latitude": "7.12139000",
                        "longitude": "122.17889000"
                    },
                    {
                        "id": 82498,
                        "name": "East Migpulao",
                        "latitude": "7.63250000",
                        "longitude": "123.35917000"
                    },
                    {
                        "id": 82566,
                        "name": "Ganyangan",
                        "latitude": "7.67889000",
                        "longitude": "122.90944000"
                    },
                    {
                        "id": 82615,
                        "name": "Gubaan",
                        "latitude": "7.97480000",
                        "longitude": "123.56400000"
                    },
                    {
                        "id": 82634,
                        "name": "Guiniculalay",
                        "latitude": "7.65611000",
                        "longitude": "123.39139000"
                    },
                    {
                        "id": 82726,
                        "name": "Ilaya",
                        "latitude": "8.54590000",
                        "longitude": "123.43080000"
                    },
                    {
                        "id": 82756,
                        "name": "Ipil",
                        "latitude": "7.78444000",
                        "longitude": "122.58611000"
                    },
                    {
                        "id": 82763,
                        "name": "Irasan",
                        "latitude": "8.52600000",
                        "longitude": "123.20600000"
                    },
                    {
                        "id": 82826,
                        "name": "Kabasalan",
                        "latitude": "7.79722000",
                        "longitude": "122.76500000"
                    },
                    {
                        "id": 82835,
                        "name": "Kagawasan",
                        "latitude": "7.86611000",
                        "longitude": "123.39500000"
                    },
                    {
                        "id": 82849,
                        "name": "Kalian",
                        "latitude": "7.59160000",
                        "longitude": "123.23190000"
                    },
                    {
                        "id": 82887,
                        "name": "Kawayan",
                        "latitude": "7.53833000",
                        "longitude": "122.87250000"
                    },
                    {
                        "id": 82912,
                        "name": "Kipit",
                        "latitude": "8.04611000",
                        "longitude": "122.53222000"
                    },
                    {
                        "id": 82939,
                        "name": "La Dicha",
                        "latitude": "7.67600000",
                        "longitude": "123.00230000"
                    },
                    {
                        "id": 82966,
                        "name": "Labuan",
                        "latitude": "7.09972000",
                        "longitude": "121.90417000"
                    },
                    {
                        "id": 83001,
                        "name": "Lamisahan",
                        "latitude": "7.07083000",
                        "longitude": "122.15833000"
                    },
                    {
                        "id": 83011,
                        "name": "Landang Laum",
                        "latitude": "6.96889000",
                        "longitude": "122.24917000"
                    },
                    {
                        "id": 83012,
                        "name": "Langatian",
                        "latitude": "8.52080000",
                        "longitude": "123.23240000"
                    },
                    {
                        "id": 83029,
                        "name": "Laparay",
                        "latitude": "7.40361000",
                        "longitude": "122.81722000"
                    },
                    {
                        "id": 83062,
                        "name": "Legrada",
                        "latitude": "7.63330000",
                        "longitude": "123.30450000"
                    },
                    {
                        "id": 83067,
                        "name": "Leon Postigo",
                        "latitude": "8.15510000",
                        "longitude": "122.93110000"
                    },
                    {
                        "id": 83117,
                        "name": "Limaong",
                        "latitude": "7.36056000",
                        "longitude": "122.36639000"
                    },
                    {
                        "id": 83126,
                        "name": "Limpapa",
                        "latitude": "7.11972000",
                        "longitude": "121.91056000"
                    },
                    {
                        "id": 83136,
                        "name": "Linay",
                        "latitude": "8.51667000",
                        "longitude": "123.13333000"
                    },
                    {
                        "id": 83137,
                        "name": "Lingasan",
                        "latitude": "8.49660000",
                        "longitude": "123.39970000"
                    },
                    {
                        "id": 83144,
                        "name": "Lintangan",
                        "latitude": "7.21554000",
                        "longitude": "121.95200000"
                    },
                    {
                        "id": 83220,
                        "name": "Lumbayan",
                        "latitude": "6.94722000",
                        "longitude": "122.14111000"
                    },
                    {
                        "id": 83224,
                        "name": "Lumbog",
                        "latitude": "7.55810000",
                        "longitude": "123.20140000"
                    },
                    {
                        "id": 83288,
                        "name": "Mabuhay",
                        "latitude": "7.41778000",
                        "longitude": "122.83667000"
                    },
                    {
                        "id": 83404,
                        "name": "Malangas",
                        "latitude": "7.63028000",
                        "longitude": "123.03167000"
                    },
                    {
                        "id": 83417,
                        "name": "Malayal",
                        "latitude": "7.20801000",
                        "longitude": "121.94204000"
                    },
                    {
                        "id": 83432,
                        "name": "Malim",
                        "latitude": "7.45200000",
                        "longitude": "123.43120000"
                    },
                    {
                        "id": 83505,
                        "name": "Mandih",
                        "latitude": "8.20870000",
                        "longitude": "123.01410000"
                    },
                    {
                        "id": 83519,
                        "name": "Mangusu",
                        "latitude": "7.32556000",
                        "longitude": "122.27750000"
                    },
                    {
                        "id": 83521,
                        "name": "Manicahan",
                        "latitude": "7.01944000",
                        "longitude": "122.20111000"
                    },
                    {
                        "id": 83572,
                        "name": "Margos",
                        "latitude": "7.93200000",
                        "longitude": "123.65900000"
                    },
                    {
                        "id": 83661,
                        "name": "Mercedes",
                        "latitude": "6.95861000",
                        "longitude": "122.14833000"
                    },
                    {
                        "id": 83700,
                        "name": "Monching",
                        "latitude": "7.71583000",
                        "longitude": "122.86639000"
                    },
                    {
                        "id": 83727,
                        "name": "Muricay",
                        "latitude": "7.82750000",
                        "longitude": "123.47820000"
                    },
                    {
                        "id": 83728,
                        "name": "Muti",
                        "latitude": "7.27583000",
                        "longitude": "122.28000000"
                    },
                    {
                        "id": 83851,
                        "name": "Olingan",
                        "latitude": "8.53810000",
                        "longitude": "123.32160000"
                    },
                    {
                        "id": 83853,
                        "name": "Olutanga",
                        "latitude": "7.31056000",
                        "longitude": "122.84639000"
                    },
                    {
                        "id": 83928,
                        "name": "Palomoc",
                        "latitude": "7.91530000",
                        "longitude": "122.58290000"
                    },
                    {
                        "id": 84006,
                        "name": "Panubigan",
                        "latitude": "7.42810000",
                        "longitude": "123.34660000"
                    },
                    {
                        "id": 84040,
                        "name": "Patawag",
                        "latitude": "8.10639000",
                        "longitude": "122.62083000"
                    },
                    {
                        "id": 84066,
                        "name": "Payao",
                        "latitude": "7.58667000",
                        "longitude": "122.80278000"
                    },
                    {
                        "id": 84159,
                        "name": "Ponot",
                        "latitude": "8.45200000",
                        "longitude": "123.02220000"
                    },
                    {
                        "id": 84180,
                        "name": "Province of  Zamboanga del Sur",
                        "latitude": "7.90430000",
                        "longitude": "123.31940000"
                    },
                    {
                        "id": 84252,
                        "name": "Province of Zamboanga del Norte",
                        "latitude": "8.00000000",
                        "longitude": "122.66667000"
                    },
                    {
                        "id": 84251,
                        "name": "Province of Zamboanga Sibugay",
                        "latitude": "7.76270000",
                        "longitude": "122.54356000"
                    },
                    {
                        "id": 84310,
                        "name": "Quinipot",
                        "latitude": "7.18028000",
                        "longitude": "122.22028000"
                    },
                    {
                        "id": 84328,
                        "name": "Rancheria Payau",
                        "latitude": "7.85410000",
                        "longitude": "123.15980000"
                    },
                    {
                        "id": 84334,
                        "name": "Recodo",
                        "latitude": "6.95194000",
                        "longitude": "121.96361000"
                    },
                    {
                        "id": 84349,
                        "name": "Robonkon",
                        "latitude": "7.75350000",
                        "longitude": "123.41870000"
                    },
                    {
                        "id": 84379,
                        "name": "Sagacad",
                        "latitude": "7.68611000",
                        "longitude": "123.34056000"
                    },
                    {
                        "id": 84631,
                        "name": "Sangali",
                        "latitude": "7.06944000",
                        "longitude": "122.20139000"
                    },
                    {
                        "id": 84759,
                        "name": "Seres",
                        "latitude": "8.48030000",
                        "longitude": "123.26290000"
                    },
                    {
                        "id": 84760,
                        "name": "Sergio Osmeña Sr",
                        "latitude": "8.16667000",
                        "longitude": "123.50000000"
                    },
                    {
                        "id": 84763,
                        "name": "Siari",
                        "latitude": "8.32450000",
                        "longitude": "122.98810000"
                    },
                    {
                        "id": 84766,
                        "name": "Siay",
                        "latitude": "7.69611000",
                        "longitude": "122.86306000"
                    },
                    {
                        "id": 84778,
                        "name": "Sibulao",
                        "latitude": "7.32417000",
                        "longitude": "122.23944000"
                    },
                    {
                        "id": 84779,
                        "name": "Sibutao",
                        "latitude": "8.59160000",
                        "longitude": "123.48590000"
                    },
                    {
                        "id": 84821,
                        "name": "Sinubong",
                        "latitude": "7.02806000",
                        "longitude": "121.92528000"
                    },
                    {
                        "id": 84828,
                        "name": "Siraway",
                        "latitude": "7.58528000",
                        "longitude": "122.13972000"
                    },
                    {
                        "id": 84876,
                        "name": "Sumalig",
                        "latitude": "7.99860000",
                        "longitude": "123.66270000"
                    },
                    {
                        "id": 84931,
                        "name": "Tagasilay",
                        "latitude": "7.30250000",
                        "longitude": "122.25861000"
                    },
                    {
                        "id": 84951,
                        "name": "Taguitic",
                        "latitude": "7.93870000",
                        "longitude": "123.63120000"
                    },
                    {
                        "id": 84959,
                        "name": "Talabaan",
                        "latitude": "6.94111000",
                        "longitude": "122.17222000"
                    },
                    {
                        "id": 84999,
                        "name": "Taluksangay",
                        "latitude": "6.95417000",
                        "longitude": "122.18389000"
                    },
                    {
                        "id": 85000,
                        "name": "Talusan",
                        "latitude": "7.42667000",
                        "longitude": "122.81028000"
                    },
                    {
                        "id": 85065,
                        "name": "Tawagan",
                        "latitude": "7.84500000",
                        "longitude": "123.47528000"
                    },
                    {
                        "id": 85111,
                        "name": "Tigpalay",
                        "latitude": "7.49479000",
                        "longitude": "122.34496000"
                    },
                    {
                        "id": 85112,
                        "name": "Tigtabon",
                        "latitude": "6.89556000",
                        "longitude": "122.16694000"
                    },
                    {
                        "id": 85113,
                        "name": "Tiguha",
                        "latitude": "7.70444000",
                        "longitude": "123.21139000"
                    },
                    {
                        "id": 85122,
                        "name": "Timonan",
                        "latitude": "8.21170000",
                        "longitude": "123.06820000"
                    },
                    {
                        "id": 85143,
                        "name": "Tiparak",
                        "latitude": "8.03410000",
                        "longitude": "123.52880000"
                    },
                    {
                        "id": 85148,
                        "name": "Titay",
                        "latitude": "7.81250000",
                        "longitude": "122.53444000"
                    },
                    {
                        "id": 85159,
                        "name": "Tolosa",
                        "latitude": "7.03222000",
                        "longitude": "122.16139000"
                    },
                    {
                        "id": 85202,
                        "name": "Tucuran",
                        "latitude": "7.85240000",
                        "longitude": "123.57430000"
                    },
                    {
                        "id": 85227,
                        "name": "Tungawan",
                        "latitude": "7.50806000",
                        "longitude": "122.37111000"
                    },
                    {
                        "id": 85308,
                        "name": "Vitali",
                        "latitude": "7.37111000",
                        "longitude": "122.28861000"
                    }
                ]
            }
        ]
    },
    {
        "id": 175,
        "name": "Pitcairn Island",
        "iso3": "PCN",
        "iso2": "PN",
        "numeric_code": "612",
        "phonecode": "870",
        "capital": "Adamstown",
        "currency": "NZD",
        "currency_name": "New Zealand dollar",
        "currency_symbol": "$",
        "tld": ".pn",
        "native": "Pitcairn Islands",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Polynesia",
        "subregion_id": 22,
        "nationality": "Pitcairn Island",
        "timezones": [
            {
                "zoneName": "Pacific\/Pitcairn",
                "gmtOffset": -28800,
                "gmtOffsetName": "UTC-08:00",
                "abbreviation": "PST",
                "tzName": "Pacific Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Inizi Pitcairn",
            "ko": "핏케언 제도",
            "pt-BR": "Ilhas Pitcairn",
            "pt": "Ilhas Picárnia",
            "nl": "Pitcairneilanden",
            "hr": "Pitcairnovo otočje",
            "fa": "پیتکرن",
            "de": "Pitcairn",
            "es": "Islas Pitcairn",
            "fr": "Îles Pitcairn",
            "ja": "ピトケアン",
            "it": "Isole Pitcairn",
            "zh-CN": "皮特凯恩群岛",
            "tr": "Pitcairn Adalari",
            "ru": "Остров Питкэрн",
            "uk": "Острів Піткерн",
            "pl": "Wyspa Pitcairn"
        },
        "latitude": "-25.06666666",
        "longitude": "-130.10000000",
        "emoji": "🇵🇳",
        "emojiU": "U+1F1F5 U+1F1F3",
        "states": []
    },
    {
        "id": 176,
        "name": "Poland",
        "iso3": "POL",
        "iso2": "PL",
        "numeric_code": "616",
        "phonecode": "48",
        "capital": "Warsaw",
        "currency": "PLN",
        "currency_name": "Polish złoty",
        "currency_symbol": "zł",
        "tld": ".pl",
        "native": "Polska",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Polish",
        "timezones": [
            {
                "zoneName": "Europe\/Warsaw",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Polonia",
            "ko": "폴란드",
            "pt-BR": "Polônia",
            "pt": "Polónia",
            "nl": "Polen",
            "hr": "Poljska",
            "fa": "لهستان",
            "de": "Polen",
            "es": "Polonia",
            "fr": "Pologne",
            "ja": "ポーランド",
            "it": "Polonia",
            "zh-CN": "波兰",
            "tr": "Polonya",
            "ru": "Польша",
            "uk": "Польща",
            "pl": "Polska"
        },
        "latitude": "52.00000000",
        "longitude": "20.00000000",
        "emoji": "🇵🇱",
        "emojiU": "U+1F1F5 U+1F1F1",
        "states": [
            {
                "id": 1634,
                "name": "Greater Poland",
                "iso2": "30",
                "latitude": "52.27998600",
                "longitude": "17.35229390",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85788,
                        "name": "Babiak",
                        "latitude": "52.34530000",
                        "longitude": "18.66663000"
                    },
                    {
                        "id": 85805,
                        "name": "Baranów",
                        "latitude": "51.26342000",
                        "longitude": "18.00470000"
                    },
                    {
                        "id": 85803,
                        "name": "Baranowo",
                        "latitude": "52.43525000",
                        "longitude": "16.78631000"
                    },
                    {
                        "id": 85847,
                        "name": "Białośliwie",
                        "latitude": "53.10461000",
                        "longitude": "17.12533000"
                    },
                    {
                        "id": 85881,
                        "name": "Blizanów",
                        "latitude": "51.90372000",
                        "longitude": "18.01003000"
                    },
                    {
                        "id": 85903,
                        "name": "Bojanowo",
                        "latitude": "51.70749000",
                        "longitude": "16.74827000"
                    },
                    {
                        "id": 85904,
                        "name": "Bojanowo Stare",
                        "latitude": "51.99302000",
                        "longitude": "16.58369000"
                    },
                    {
                        "id": 85919,
                        "name": "Borek Wielkopolski",
                        "latitude": "51.91674000",
                        "longitude": "17.24133000"
                    },
                    {
                        "id": 85934,
                        "name": "Bralin",
                        "latitude": "51.28581000",
                        "longitude": "17.90325000"
                    },
                    {
                        "id": 85939,
                        "name": "Brdów",
                        "latitude": "52.35390000",
                        "longitude": "18.72980000"
                    },
                    {
                        "id": 85941,
                        "name": "Brenno",
                        "latitude": "51.92257000",
                        "longitude": "16.21488000"
                    },
                    {
                        "id": 85944,
                        "name": "Brodnica",
                        "latitude": "52.14123000",
                        "longitude": "16.89096000"
                    },
                    {
                        "id": 85952,
                        "name": "Broniszewice",
                        "latitude": "51.96696000",
                        "longitude": "17.81648000"
                    },
                    {
                        "id": 85954,
                        "name": "Brudzew",
                        "latitude": "52.09949000",
                        "longitude": "18.60432000"
                    },
                    {
                        "id": 85984,
                        "name": "Budzyń",
                        "latitude": "52.88954000",
                        "longitude": "16.98812000"
                    },
                    {
                        "id": 85988,
                        "name": "Buk",
                        "latitude": "52.35532000",
                        "longitude": "16.51958000"
                    },
                    {
                        "id": 86041,
                        "name": "Chocz",
                        "latitude": "51.97642000",
                        "longitude": "17.86995000"
                    },
                    {
                        "id": 86047,
                        "name": "Chodów",
                        "latitude": "52.24961000",
                        "longitude": "19.01218000"
                    },
                    {
                        "id": 86046,
                        "name": "Chodzież",
                        "latitude": "52.99505000",
                        "longitude": "16.91980000"
                    },
                    {
                        "id": 86063,
                        "name": "Chrzypsko Wielkie",
                        "latitude": "52.62817000",
                        "longitude": "16.22852000"
                    },
                    {
                        "id": 86099,
                        "name": "Czajków",
                        "latitude": "51.49197000",
                        "longitude": "18.32726000"
                    },
                    {
                        "id": 86102,
                        "name": "Czapury",
                        "latitude": "52.31719000",
                        "longitude": "16.91268000"
                    },
                    {
                        "id": 86111,
                        "name": "Czarnków",
                        "latitude": "52.90214000",
                        "longitude": "16.56413000"
                    },
                    {
                        "id": 86125,
                        "name": "Czempiń",
                        "latitude": "52.14404000",
                        "longitude": "16.76408000"
                    },
                    {
                        "id": 86128,
                        "name": "Czermin",
                        "latitude": "51.95008000",
                        "longitude": "17.74957000"
                    },
                    {
                        "id": 86134,
                        "name": "Czerniejewo",
                        "latitude": "52.42640000",
                        "longitude": "17.48925000"
                    },
                    {
                        "id": 86143,
                        "name": "Czerwonak",
                        "latitude": "52.46459000",
                        "longitude": "16.98169000"
                    },
                    {
                        "id": 86234,
                        "name": "Dąbie",
                        "latitude": "52.08668000",
                        "longitude": "18.82250000"
                    },
                    {
                        "id": 86156,
                        "name": "Damasławek",
                        "latitude": "52.83979000",
                        "longitude": "17.50062000"
                    },
                    {
                        "id": 86159,
                        "name": "Daszewice",
                        "latitude": "52.30002000",
                        "longitude": "16.95723000"
                    },
                    {
                        "id": 86169,
                        "name": "Dobra",
                        "latitude": "51.91664000",
                        "longitude": "18.61556000"
                    },
                    {
                        "id": 86178,
                        "name": "Dobrzyca",
                        "latitude": "51.86663000",
                        "longitude": "17.60336000"
                    },
                    {
                        "id": 86182,
                        "name": "Dolsk",
                        "latitude": "51.98180000",
                        "longitude": "17.06273000"
                    },
                    {
                        "id": 86188,
                        "name": "Dominowo",
                        "latitude": "52.29158000",
                        "longitude": "17.35754000"
                    },
                    {
                        "id": 86189,
                        "name": "Dopiewo",
                        "latitude": "52.35726000",
                        "longitude": "16.67562000"
                    },
                    {
                        "id": 86191,
                        "name": "Doruchów",
                        "latitude": "51.41719000",
                        "longitude": "18.07697000"
                    },
                    {
                        "id": 86194,
                        "name": "Drawsko",
                        "latitude": "52.85421000",
                        "longitude": "16.03125000"
                    },
                    {
                        "id": 86208,
                        "name": "Duszniki",
                        "latitude": "52.44691000",
                        "longitude": "16.40602000"
                    },
                    {
                        "id": 86304,
                        "name": "Gizałki",
                        "latitude": "52.04267000",
                        "longitude": "17.76936000"
                    },
                    {
                        "id": 86313,
                        "name": "Gniezno",
                        "latitude": "52.53481000",
                        "longitude": "17.58259000"
                    },
                    {
                        "id": 86328,
                        "name": "Golina",
                        "latitude": "52.24315000",
                        "longitude": "18.09268000"
                    },
                    {
                        "id": 86354,
                        "name": "Gołańcz",
                        "latitude": "52.94326000",
                        "longitude": "17.29995000"
                    },
                    {
                        "id": 86357,
                        "name": "Gołuchów",
                        "latitude": "51.85036000",
                        "longitude": "17.93140000"
                    },
                    {
                        "id": 86340,
                        "name": "Gorzyce Wielkie",
                        "latitude": "51.63725000",
                        "longitude": "17.72953000"
                    },
                    {
                        "id": 86347,
                        "name": "Gostyń",
                        "latitude": "51.88247000",
                        "longitude": "17.01225000"
                    },
                    {
                        "id": 86369,
                        "name": "Grabów nad Prosną",
                        "latitude": "51.50596000",
                        "longitude": "18.11929000"
                    },
                    {
                        "id": 86372,
                        "name": "Granowo",
                        "latitude": "52.22244000",
                        "longitude": "16.52859000"
                    },
                    {
                        "id": 86374,
                        "name": "Grodziec",
                        "latitude": "52.03855000",
                        "longitude": "18.05972000"
                    },
                    {
                        "id": 86376,
                        "name": "Grodzisk Wielkopolski",
                        "latitude": "52.22762000",
                        "longitude": "16.36534000"
                    },
                    {
                        "id": 86394,
                        "name": "Grzegorzew",
                        "latitude": "52.20177000",
                        "longitude": "18.73409000"
                    },
                    {
                        "id": 86483,
                        "name": "Jabłonna",
                        "latitude": "52.20598000",
                        "longitude": "16.20741000"
                    },
                    {
                        "id": 86496,
                        "name": "Janków Przygodzki",
                        "latitude": "51.59808000",
                        "longitude": "17.78824000"
                    },
                    {
                        "id": 86505,
                        "name": "Jaraczewo",
                        "latitude": "51.96854000",
                        "longitude": "17.29707000"
                    },
                    {
                        "id": 86509,
                        "name": "Jarocin",
                        "latitude": "51.97266000",
                        "longitude": "17.50256000"
                    },
                    {
                        "id": 86522,
                        "name": "Jastrowie",
                        "latitude": "53.42048000",
                        "longitude": "16.81756000"
                    },
                    {
                        "id": 86573,
                        "name": "Jutrosin",
                        "latitude": "51.65009000",
                        "longitude": "17.16957000"
                    },
                    {
                        "id": 86580,
                        "name": "Kaczory",
                        "latitude": "53.10348000",
                        "longitude": "16.88169000"
                    },
                    {
                        "id": 86586,
                        "name": "Kalisz",
                        "latitude": "51.76109000",
                        "longitude": "18.09102000"
                    },
                    {
                        "id": 86593,
                        "name": "Kamieniec",
                        "latitude": "52.16614000",
                        "longitude": "16.46164000"
                    },
                    {
                        "id": 86622,
                        "name": "Kawęczyn",
                        "latitude": "51.90923000",
                        "longitude": "18.53102000"
                    },
                    {
                        "id": 86625,
                        "name": "Kazimierz Biskupi",
                        "latitude": "52.31100000",
                        "longitude": "18.16581000"
                    },
                    {
                        "id": 86630,
                        "name": "Kaźmierz",
                        "latitude": "52.51309000",
                        "longitude": "16.58403000"
                    },
                    {
                        "id": 86856,
                        "name": "Kępno",
                        "latitude": "51.27840000",
                        "longitude": "17.98908000"
                    },
                    {
                        "id": 86641,
                        "name": "Kiszkowo",
                        "latitude": "52.58871000",
                        "longitude": "17.26630000"
                    },
                    {
                        "id": 86643,
                        "name": "Kleczew",
                        "latitude": "52.37057000",
                        "longitude": "18.17714000"
                    },
                    {
                        "id": 86647,
                        "name": "Kleszczewo",
                        "latitude": "52.33377000",
                        "longitude": "17.17163000"
                    },
                    {
                        "id": 86861,
                        "name": "Kłecko",
                        "latitude": "52.63181000",
                        "longitude": "17.43075000"
                    },
                    {
                        "id": 86865,
                        "name": "Kłodawa",
                        "latitude": "52.25447000",
                        "longitude": "18.91352000"
                    },
                    {
                        "id": 86663,
                        "name": "Kobyla Góra",
                        "latitude": "51.37923000",
                        "longitude": "17.83811000"
                    },
                    {
                        "id": 86666,
                        "name": "Kobylin",
                        "latitude": "51.71645000",
                        "longitude": "17.22682000"
                    },
                    {
                        "id": 86667,
                        "name": "Kobylnica",
                        "latitude": "52.44597000",
                        "longitude": "17.07644000"
                    },
                    {
                        "id": 86740,
                        "name": "Kołaczkowo",
                        "latitude": "52.21739000",
                        "longitude": "17.62413000"
                    },
                    {
                        "id": 86745,
                        "name": "Koło",
                        "latitude": "52.20024000",
                        "longitude": "18.63865000"
                    },
                    {
                        "id": 86686,
                        "name": "Komorniki",
                        "latitude": "52.33870000",
                        "longitude": "16.81063000"
                    },
                    {
                        "id": 86689,
                        "name": "Konary",
                        "latitude": "51.65690000",
                        "longitude": "17.04185000"
                    },
                    {
                        "id": 86693,
                        "name": "Konin",
                        "latitude": "52.22338000",
                        "longitude": "18.25121000"
                    },
                    {
                        "id": 86851,
                        "name": "Kórnik",
                        "latitude": "52.24772000",
                        "longitude": "17.08949000"
                    },
                    {
                        "id": 86752,
                        "name": "Kościan",
                        "latitude": "52.08829000",
                        "longitude": "16.64866000"
                    },
                    {
                        "id": 86754,
                        "name": "Kościelec",
                        "latitude": "52.17425000",
                        "longitude": "18.57067000"
                    },
                    {
                        "id": 86714,
                        "name": "Kostrzyn",
                        "latitude": "52.39847000",
                        "longitude": "17.22811000"
                    },
                    {
                        "id": 86723,
                        "name": "Kotlin",
                        "latitude": "51.91913000",
                        "longitude": "17.64825000"
                    },
                    {
                        "id": 86758,
                        "name": "Koźmin Wielkopolski",
                        "latitude": "51.82712000",
                        "longitude": "17.45391000"
                    },
                    {
                        "id": 86759,
                        "name": "Koźminek",
                        "latitude": "51.79874000",
                        "longitude": "18.33893000"
                    },
                    {
                        "id": 86762,
                        "name": "Krajenka",
                        "latitude": "53.29759000",
                        "longitude": "16.99079000"
                    },
                    {
                        "id": 86765,
                        "name": "Kramsk",
                        "latitude": "52.26469000",
                        "longitude": "18.42407000"
                    },
                    {
                        "id": 86775,
                        "name": "Kraszewice",
                        "latitude": "51.51868000",
                        "longitude": "18.21997000"
                    },
                    {
                        "id": 86779,
                        "name": "Krobia",
                        "latitude": "51.77405000",
                        "longitude": "16.98237000"
                    },
                    {
                        "id": 86783,
                        "name": "Krosno",
                        "latitude": "52.22357000",
                        "longitude": "16.83251000"
                    },
                    {
                        "id": 86785,
                        "name": "Krotoszyn",
                        "latitude": "51.69868000",
                        "longitude": "17.43738000"
                    },
                    {
                        "id": 86806,
                        "name": "Krzemieniewo",
                        "latitude": "51.85905000",
                        "longitude": "16.83354000"
                    },
                    {
                        "id": 86814,
                        "name": "Krzykosy",
                        "latitude": "52.11041000",
                        "longitude": "17.37411000"
                    },
                    {
                        "id": 86820,
                        "name": "Krzywiń",
                        "latitude": "51.96296000",
                        "longitude": "16.81985000"
                    },
                    {
                        "id": 86821,
                        "name": "Krzyż Wielkopolski",
                        "latitude": "52.88097000",
                        "longitude": "16.01116000"
                    },
                    {
                        "id": 86829,
                        "name": "Książ Wielkopolski",
                        "latitude": "52.06167000",
                        "longitude": "17.23952000"
                    },
                    {
                        "id": 86845,
                        "name": "Kuślin",
                        "latitude": "52.36386000",
                        "longitude": "16.31538000"
                    },
                    {
                        "id": 86850,
                        "name": "Kwilcz",
                        "latitude": "52.55506000",
                        "longitude": "16.08562000"
                    },
                    {
                        "id": 86976,
                        "name": "Lądek",
                        "latitude": "52.20929000",
                        "longitude": "17.92994000"
                    },
                    {
                        "id": 86883,
                        "name": "Leszno",
                        "latitude": "51.84034000",
                        "longitude": "16.57494000"
                    },
                    {
                        "id": 86898,
                        "name": "Licheń Stary",
                        "latitude": "52.31226000",
                        "longitude": "18.35515000"
                    },
                    {
                        "id": 86910,
                        "name": "Lipka",
                        "latitude": "53.49601000",
                        "longitude": "17.25085000"
                    },
                    {
                        "id": 86918,
                        "name": "Lipno",
                        "latitude": "51.91722000",
                        "longitude": "16.56708000"
                    },
                    {
                        "id": 86927,
                        "name": "Lisków",
                        "latitude": "51.83313000",
                        "longitude": "18.39789000"
                    },
                    {
                        "id": 86933,
                        "name": "Lubasz",
                        "latitude": "52.85213000",
                        "longitude": "16.52344000"
                    },
                    {
                        "id": 86956,
                        "name": "Luboń",
                        "latitude": "52.34705000",
                        "longitude": "16.89267000"
                    },
                    {
                        "id": 86973,
                        "name": "Lwówek",
                        "latitude": "52.44798000",
                        "longitude": "16.18106000"
                    },
                    {
                        "id": 88820,
                        "name": "Łęka Opatowska",
                        "latitude": "51.21231000",
                        "longitude": "18.10710000"
                    },
                    {
                        "id": 88781,
                        "name": "Łobżenica",
                        "latitude": "53.26244000",
                        "longitude": "17.25574000"
                    },
                    {
                        "id": 88801,
                        "name": "Łubowo",
                        "latitude": "52.51168000",
                        "longitude": "17.45333000"
                    },
                    {
                        "id": 86985,
                        "name": "Malanów",
                        "latitude": "51.95358000",
                        "longitude": "18.39128000"
                    },
                    {
                        "id": 86992,
                        "name": "Margonin",
                        "latitude": "52.97335000",
                        "longitude": "17.09464000"
                    },
                    {
                        "id": 87015,
                        "name": "Miasteczko Krajeńskie",
                        "latitude": "53.09784000",
                        "longitude": "17.00478000"
                    },
                    {
                        "id": 87029,
                        "name": "Miedzichowo",
                        "latitude": "52.37581000",
                        "longitude": "15.95876000"
                    },
                    {
                        "id": 87061,
                        "name": "Międzychód",
                        "latitude": "52.59882000",
                        "longitude": "15.89696000"
                    },
                    {
                        "id": 87034,
                        "name": "Miejska Górka",
                        "latitude": "51.65573000",
                        "longitude": "16.95826000"
                    },
                    {
                        "id": 87036,
                        "name": "Mieleszyn",
                        "latitude": "52.66868000",
                        "longitude": "17.49779000"
                    },
                    {
                        "id": 87041,
                        "name": "Mieścisko",
                        "latitude": "52.74357000",
                        "longitude": "17.33213000"
                    },
                    {
                        "id": 87045,
                        "name": "Mikstat",
                        "latitude": "51.53236000",
                        "longitude": "17.97378000"
                    },
                    {
                        "id": 87074,
                        "name": "Miłosław",
                        "latitude": "52.20318000",
                        "longitude": "17.48955000"
                    },
                    {
                        "id": 87094,
                        "name": "Mosina",
                        "latitude": "52.24543000",
                        "longitude": "16.84709000"
                    },
                    {
                        "id": 87113,
                        "name": "Murowana Goślina",
                        "latitude": "52.57463000",
                        "longitude": "17.00933000"
                    },
                    {
                        "id": 87144,
                        "name": "Nekla",
                        "latitude": "52.36496000",
                        "longitude": "17.41329000"
                    },
                    {
                        "id": 87151,
                        "name": "Niechanowo",
                        "latitude": "52.46527000",
                        "longitude": "17.67812000"
                    },
                    {
                        "id": 87188,
                        "name": "Nowe Miasto nad Wartą",
                        "latitude": "52.09007000",
                        "longitude": "17.41114000"
                    },
                    {
                        "id": 87191,
                        "name": "Nowe Skalmierzyce",
                        "latitude": "51.71038000",
                        "longitude": "17.99337000"
                    },
                    {
                        "id": 87208,
                        "name": "Nowy Tomyśl",
                        "latitude": "52.31950000",
                        "longitude": "16.12844000"
                    },
                    {
                        "id": 87216,
                        "name": "Oborniki",
                        "latitude": "52.64739000",
                        "longitude": "16.81406000"
                    },
                    {
                        "id": 87221,
                        "name": "Obrzycko",
                        "latitude": "52.70338000",
                        "longitude": "16.52807000"
                    },
                    {
                        "id": 87228,
                        "name": "Odolanów",
                        "latitude": "51.57419000",
                        "longitude": "17.67434000"
                    },
                    {
                        "id": 87234,
                        "name": "Okonek",
                        "latitude": "53.53618000",
                        "longitude": "16.85158000"
                    },
                    {
                        "id": 87252,
                        "name": "Olszówka",
                        "latitude": "52.19030000",
                        "longitude": "18.86258000"
                    },
                    {
                        "id": 87254,
                        "name": "Opalenica",
                        "latitude": "52.30887000",
                        "longitude": "16.41278000"
                    },
                    {
                        "id": 87257,
                        "name": "Opatów",
                        "latitude": "51.21463000",
                        "longitude": "18.14615000"
                    },
                    {
                        "id": 87259,
                        "name": "Opatówek",
                        "latitude": "51.73989000",
                        "longitude": "18.21653000"
                    },
                    {
                        "id": 87265,
                        "name": "Orchowo",
                        "latitude": "52.50938000",
                        "longitude": "18.01578000"
                    },
                    {
                        "id": 87279,
                        "name": "Osieczna",
                        "latitude": "51.90420000",
                        "longitude": "16.67862000"
                    },
                    {
                        "id": 87289,
                        "name": "Osiek Mały",
                        "latitude": "52.27630000",
                        "longitude": "18.60234000"
                    },
                    {
                        "id": 87290,
                        "name": "Osiek nad Notecią",
                        "latitude": "53.12030000",
                        "longitude": "17.29102000"
                    },
                    {
                        "id": 87297,
                        "name": "Ostroróg",
                        "latitude": "52.62650000",
                        "longitude": "16.44988000"
                    },
                    {
                        "id": 87311,
                        "name": "Ostrów Wielkopolski",
                        "latitude": "51.65501000",
                        "longitude": "17.80686000"
                    },
                    {
                        "id": 87301,
                        "name": "Ostrowite",
                        "latitude": "52.38199000",
                        "longitude": "18.04470000"
                    },
                    {
                        "id": 87306,
                        "name": "Ostrzeszów",
                        "latitude": "51.42640000",
                        "longitude": "17.93355000"
                    },
                    {
                        "id": 87336,
                        "name": "Pakosław",
                        "latitude": "51.61438000",
                        "longitude": "17.05793000"
                    },
                    {
                        "id": 87340,
                        "name": "Pamiątkowo",
                        "latitude": "52.55334000",
                        "longitude": "16.68094000"
                    },
                    {
                        "id": 87362,
                        "name": "Pecna",
                        "latitude": "52.18333000",
                        "longitude": "16.80000000"
                    },
                    {
                        "id": 87861,
                        "name": "Pępowo",
                        "latitude": "51.76569000",
                        "longitude": "17.12661000"
                    },
                    {
                        "id": 87364,
                        "name": "Perzów",
                        "latitude": "51.27625000",
                        "longitude": "17.80970000"
                    },
                    {
                        "id": 87371,
                        "name": "Piaski",
                        "latitude": "51.88497000",
                        "longitude": "17.07293000"
                    },
                    {
                        "id": 87403,
                        "name": "Piła",
                        "latitude": "53.15145000",
                        "longitude": "16.73782000"
                    },
                    {
                        "id": 87406,
                        "name": "Pleszew",
                        "latitude": "51.89636000",
                        "longitude": "17.78549000"
                    },
                    {
                        "id": 87407,
                        "name": "Plewiska",
                        "latitude": "52.36706000",
                        "longitude": "16.80985000"
                    },
                    {
                        "id": 87409,
                        "name": "Pniewy",
                        "latitude": "52.50943000",
                        "longitude": "16.25668000"
                    },
                    {
                        "id": 87410,
                        "name": "Pobiedziska",
                        "latitude": "52.47753000",
                        "longitude": "17.28767000"
                    },
                    {
                        "id": 87420,
                        "name": "Pogorzela",
                        "latitude": "51.82220000",
                        "longitude": "17.23017000"
                    },
                    {
                        "id": 87775,
                        "name": "Połajewo",
                        "latitude": "52.79923000",
                        "longitude": "16.73347000"
                    },
                    {
                        "id": 87440,
                        "name": "Poniec",
                        "latitude": "51.76343000",
                        "longitude": "16.80867000"
                    },
                    {
                        "id": 87484,
                        "name": "Powiat chodzieski",
                        "latitude": "52.95289000",
                        "longitude": "17.01545000"
                    },
                    {
                        "id": 87490,
                        "name": "Powiat czarnkowsko-trzcianecki",
                        "latitude": "52.92885000",
                        "longitude": "16.34673000"
                    },
                    {
                        "id": 87504,
                        "name": "Powiat gnieźnieński",
                        "latitude": "52.55359000",
                        "longitude": "17.57140000"
                    },
                    {
                        "id": 87510,
                        "name": "Powiat gostyński",
                        "latitude": "51.83680000",
                        "longitude": "17.03471000"
                    },
                    {
                        "id": 87514,
                        "name": "Powiat grodziski",
                        "latitude": "52.16038000",
                        "longitude": "16.33566000"
                    },
                    {
                        "id": 87527,
                        "name": "Powiat jarociński",
                        "latitude": "52.00901000",
                        "longitude": "17.45497000"
                    },
                    {
                        "id": 87533,
                        "name": "Powiat kaliski",
                        "latitude": "51.78921000",
                        "longitude": "18.20809000"
                    },
                    {
                        "id": 87560,
                        "name": "Powiat kępiński",
                        "latitude": "51.24852000",
                        "longitude": "17.95934000"
                    },
                    {
                        "id": 87542,
                        "name": "Powiat kolski",
                        "latitude": "52.24446000",
                        "longitude": "18.78096000"
                    },
                    {
                        "id": 87544,
                        "name": "Powiat koniński",
                        "latitude": "52.25965000",
                        "longitude": "18.29616000"
                    },
                    {
                        "id": 87548,
                        "name": "Powiat kościański",
                        "latitude": "52.06616000",
                        "longitude": "16.71514000"
                    },
                    {
                        "id": 87554,
                        "name": "Powiat krotoszyński",
                        "latitude": "51.74174000",
                        "longitude": "17.42125000"
                    },
                    {
                        "id": 87567,
                        "name": "Powiat leszczyński",
                        "latitude": "51.85010000",
                        "longitude": "16.50120000"
                    },
                    {
                        "id": 87587,
                        "name": "Powiat międzychodzki",
                        "latitude": "52.60187000",
                        "longitude": "16.05741000"
                    },
                    {
                        "id": 87607,
                        "name": "Powiat nowotomyski",
                        "latitude": "52.34837000",
                        "longitude": "16.15849000"
                    },
                    {
                        "id": 87609,
                        "name": "Powiat obornicki",
                        "latitude": "52.71705000",
                        "longitude": "16.85437000"
                    },
                    {
                        "id": 87621,
                        "name": "Powiat ostrowski",
                        "latitude": "51.60798000",
                        "longitude": "17.85030000"
                    },
                    {
                        "id": 87623,
                        "name": "Powiat ostrzeszowski",
                        "latitude": "51.43768000",
                        "longitude": "18.04334000"
                    },
                    {
                        "id": 87632,
                        "name": "Powiat pilski",
                        "latitude": "53.15753000",
                        "longitude": "16.91465000"
                    },
                    {
                        "id": 87636,
                        "name": "Powiat pleszewski",
                        "latitude": "51.92526000",
                        "longitude": "17.77850000"
                    },
                    {
                        "id": 87640,
                        "name": "Powiat poznański",
                        "latitude": "52.32443000",
                        "longitude": "16.86539000"
                    },
                    {
                        "id": 87660,
                        "name": "Powiat rawicki",
                        "latitude": "51.64507000",
                        "longitude": "16.94944000"
                    },
                    {
                        "id": 87699,
                        "name": "Powiat słupecki",
                        "latitude": "52.31422000",
                        "longitude": "17.90822000"
                    },
                    {
                        "id": 87757,
                        "name": "Powiat średzki",
                        "latitude": "52.18010000",
                        "longitude": "17.30686000"
                    },
                    {
                        "id": 87758,
                        "name": "Powiat śremski",
                        "latitude": "52.06149000",
                        "longitude": "17.05853000"
                    },
                    {
                        "id": 87691,
                        "name": "Powiat szamotulski",
                        "latitude": "52.58391000",
                        "longitude": "16.37726000"
                    },
                    {
                        "id": 87711,
                        "name": "Powiat turecki",
                        "latitude": "51.99581000",
                        "longitude": "18.49301000"
                    },
                    {
                        "id": 87730,
                        "name": "Powiat wągrowiecki",
                        "latitude": "52.80805000",
                        "longitude": "17.21077000"
                    },
                    {
                        "id": 87721,
                        "name": "Powiat wolsztyński",
                        "latitude": "52.08791000",
                        "longitude": "16.14983000"
                    },
                    {
                        "id": 87725,
                        "name": "Powiat wrzesiński",
                        "latitude": "52.24091000",
                        "longitude": "17.59019000"
                    },
                    {
                        "id": 87746,
                        "name": "Powiat złotowski",
                        "latitude": "53.41261000",
                        "longitude": "16.91516000"
                    },
                    {
                        "id": 87770,
                        "name": "Powidz",
                        "latitude": "52.41362000",
                        "longitude": "17.91926000"
                    },
                    {
                        "id": 87774,
                        "name": "Poznań",
                        "latitude": "52.40692000",
                        "longitude": "16.92993000"
                    },
                    {
                        "id": 87807,
                        "name": "Przedecz",
                        "latitude": "52.33440000",
                        "longitude": "18.89915000"
                    },
                    {
                        "id": 87813,
                        "name": "Przemęt",
                        "latitude": "52.00808000",
                        "longitude": "16.30114000"
                    },
                    {
                        "id": 87824,
                        "name": "Przygodzice",
                        "latitude": "51.59195000",
                        "longitude": "17.82412000"
                    },
                    {
                        "id": 87825,
                        "name": "Przykona",
                        "latitude": "51.98171000",
                        "longitude": "18.61247000"
                    },
                    {
                        "id": 87850,
                        "name": "Puszczykowo",
                        "latitude": "52.28570000",
                        "longitude": "16.84925000"
                    },
                    {
                        "id": 87858,
                        "name": "Pyzdry",
                        "latitude": "52.17056000",
                        "longitude": "17.69005000"
                    },
                    {
                        "id": 87909,
                        "name": "Rakoniewice",
                        "latitude": "52.13906000",
                        "longitude": "16.27346000"
                    },
                    {
                        "id": 87914,
                        "name": "Raszków",
                        "latitude": "51.71828000",
                        "longitude": "17.72571000"
                    },
                    {
                        "id": 87919,
                        "name": "Rawicz",
                        "latitude": "51.60946000",
                        "longitude": "16.85852000"
                    },
                    {
                        "id": 87943,
                        "name": "Rogalinek",
                        "latitude": "52.24945000",
                        "longitude": "16.89989000"
                    },
                    {
                        "id": 87946,
                        "name": "Rogoźno",
                        "latitude": "52.75226000",
                        "longitude": "16.99049000"
                    },
                    {
                        "id": 87957,
                        "name": "Rokietnica",
                        "latitude": "52.51245000",
                        "longitude": "16.74570000"
                    },
                    {
                        "id": 87964,
                        "name": "Rozdrażew",
                        "latitude": "51.78218000",
                        "longitude": "17.50491000"
                    },
                    {
                        "id": 87999,
                        "name": "Rychtal",
                        "latitude": "51.14533000",
                        "longitude": "17.85132000"
                    },
                    {
                        "id": 88000,
                        "name": "Rychwał",
                        "latitude": "52.07149000",
                        "longitude": "18.16510000"
                    },
                    {
                        "id": 88002,
                        "name": "Ryczywół",
                        "latitude": "52.81324000",
                        "longitude": "16.83114000"
                    },
                    {
                        "id": 88005,
                        "name": "Rydzyna",
                        "latitude": "51.78651000",
                        "longitude": "16.66761000"
                    },
                    {
                        "id": 88028,
                        "name": "Rzgów Pierwszy",
                        "latitude": "52.15134000",
                        "longitude": "18.04976000"
                    },
                    {
                        "id": 88065,
                        "name": "Siedlec",
                        "latitude": "52.13781000",
                        "longitude": "16.00279000"
                    },
                    {
                        "id": 88088,
                        "name": "Sieraków",
                        "latitude": "52.65134000",
                        "longitude": "16.08047000"
                    },
                    {
                        "id": 88090,
                        "name": "Sieroszewice",
                        "latitude": "51.63347000",
                        "longitude": "17.97200000"
                    },
                    {
                        "id": 88096,
                        "name": "Skalmierzyce",
                        "latitude": "51.70097000",
                        "longitude": "17.96333000"
                    },
                    {
                        "id": 88109,
                        "name": "Skoki",
                        "latitude": "52.67222000",
                        "longitude": "17.16107000"
                    },
                    {
                        "id": 88119,
                        "name": "Skulsk",
                        "latitude": "52.48200000",
                        "longitude": "18.33112000"
                    },
                    {
                        "id": 88832,
                        "name": "Ślesin",
                        "latitude": "52.37039000",
                        "longitude": "18.30644000"
                    },
                    {
                        "id": 88347,
                        "name": "Słupca",
                        "latitude": "52.28733000",
                        "longitude": "17.87192000"
                    },
                    {
                        "id": 88350,
                        "name": "Słupia pod Kępnem",
                        "latitude": "51.23924000",
                        "longitude": "18.04255000"
                    },
                    {
                        "id": 88834,
                        "name": "Śmigiel",
                        "latitude": "52.01339000",
                        "longitude": "16.52704000"
                    },
                    {
                        "id": 88835,
                        "name": "Śmiłowo",
                        "latitude": "53.13647000",
                        "longitude": "16.92075000"
                    },
                    {
                        "id": 88146,
                        "name": "Sompolno",
                        "latitude": "52.38832000",
                        "longitude": "18.50282000"
                    },
                    {
                        "id": 88159,
                        "name": "Sośnie",
                        "latitude": "51.47315000",
                        "longitude": "17.63383000"
                    },
                    {
                        "id": 88837,
                        "name": "Śrem",
                        "latitude": "52.08868000",
                        "longitude": "17.01508000"
                    },
                    {
                        "id": 88838,
                        "name": "Środa Wielkopolska",
                        "latitude": "52.22843000",
                        "longitude": "17.27617000"
                    },
                    {
                        "id": 88187,
                        "name": "Stare Miasto",
                        "latitude": "52.17972000",
                        "longitude": "18.21499000"
                    },
                    {
                        "id": 88201,
                        "name": "Stawiszyn",
                        "latitude": "51.91786000",
                        "longitude": "18.11171000"
                    },
                    {
                        "id": 88243,
                        "name": "Stęszew",
                        "latitude": "52.28370000",
                        "longitude": "16.70085000"
                    },
                    {
                        "id": 88222,
                        "name": "Strzałkowo",
                        "latitude": "52.30701000",
                        "longitude": "17.81811000"
                    },
                    {
                        "id": 88254,
                        "name": "Suchy Las",
                        "latitude": "52.47308000",
                        "longitude": "16.87745000"
                    },
                    {
                        "id": 88260,
                        "name": "Sulmierzyce",
                        "latitude": "51.60594000",
                        "longitude": "17.53053000"
                    },
                    {
                        "id": 88275,
                        "name": "Swarzędz",
                        "latitude": "52.41289000",
                        "longitude": "17.08503000"
                    },
                    {
                        "id": 88864,
                        "name": "Święciechowa",
                        "latitude": "51.85503000",
                        "longitude": "16.49805000"
                    },
                    {
                        "id": 88281,
                        "name": "Sypniewo",
                        "latitude": "53.46823000",
                        "longitude": "16.60583000"
                    },
                    {
                        "id": 88285,
                        "name": "Szamocin",
                        "latitude": "53.02795000",
                        "longitude": "17.12653000"
                    },
                    {
                        "id": 88286,
                        "name": "Szamotuły",
                        "latitude": "52.61201000",
                        "longitude": "16.57794000"
                    },
                    {
                        "id": 88321,
                        "name": "Szydłowo",
                        "latitude": "53.16212000",
                        "longitude": "16.61171000"
                    },
                    {
                        "id": 88367,
                        "name": "Tarnówka",
                        "latitude": "53.34174000",
                        "longitude": "16.85273000"
                    },
                    {
                        "id": 88363,
                        "name": "Tarnowo Podgórne",
                        "latitude": "52.46642000",
                        "longitude": "16.66326000"
                    },
                    {
                        "id": 88396,
                        "name": "Trzcianka",
                        "latitude": "53.04063000",
                        "longitude": "16.45629000"
                    },
                    {
                        "id": 88399,
                        "name": "Trzcinica",
                        "latitude": "51.16707000",
                        "longitude": "18.00453000"
                    },
                    {
                        "id": 88411,
                        "name": "Trzemeszno",
                        "latitude": "52.56139000",
                        "longitude": "17.82311000"
                    },
                    {
                        "id": 88422,
                        "name": "Tuliszków",
                        "latitude": "52.07658000",
                        "longitude": "18.29549000"
                    },
                    {
                        "id": 88424,
                        "name": "Turek",
                        "latitude": "52.01548000",
                        "longitude": "18.50055000"
                    },
                    {
                        "id": 88452,
                        "name": "Ujście",
                        "latitude": "53.05339000",
                        "longitude": "16.73201000"
                    },
                    {
                        "id": 88633,
                        "name": "Wągrowiec",
                        "latitude": "52.80842000",
                        "longitude": "17.19961000"
                    },
                    {
                        "id": 88476,
                        "name": "Wapno",
                        "latitude": "52.90804000",
                        "longitude": "17.47504000"
                    },
                    {
                        "id": 88499,
                        "name": "Wieleń",
                        "latitude": "52.89461000",
                        "longitude": "16.17136000"
                    },
                    {
                        "id": 88501,
                        "name": "Wielichowo",
                        "latitude": "52.11573000",
                        "longitude": "16.35180000"
                    },
                    {
                        "id": 88518,
                        "name": "Wierzbinek",
                        "latitude": "52.44026000",
                        "longitude": "18.51085000"
                    },
                    {
                        "id": 88529,
                        "name": "Wijewo",
                        "latitude": "51.91627000",
                        "longitude": "16.18552000"
                    },
                    {
                        "id": 88533,
                        "name": "Wilczogóra",
                        "latitude": "52.47348000",
                        "longitude": "18.16744000"
                    },
                    {
                        "id": 88536,
                        "name": "Wilczyn",
                        "latitude": "52.48816000",
                        "longitude": "18.16126000"
                    },
                    {
                        "id": 88539,
                        "name": "Wilkowice",
                        "latitude": "51.88513000",
                        "longitude": "16.53417000"
                    },
                    {
                        "id": 88549,
                        "name": "Witaszyce",
                        "latitude": "51.94151000",
                        "longitude": "17.56182000"
                    },
                    {
                        "id": 88551,
                        "name": "Witkowo",
                        "latitude": "52.43964000",
                        "longitude": "17.77264000"
                    },
                    {
                        "id": 88647,
                        "name": "Władysławów",
                        "latitude": "52.10313000",
                        "longitude": "18.47626000"
                    },
                    {
                        "id": 88653,
                        "name": "Włoszakowice",
                        "latitude": "51.92754000",
                        "longitude": "16.36456000"
                    },
                    {
                        "id": 88597,
                        "name": "Wolsztyn",
                        "latitude": "52.11552000",
                        "longitude": "16.11712000"
                    },
                    {
                        "id": 88605,
                        "name": "Wronki",
                        "latitude": "52.71051000",
                        "longitude": "16.38044000"
                    },
                    {
                        "id": 88606,
                        "name": "Września",
                        "latitude": "52.32512000",
                        "longitude": "17.56519000"
                    },
                    {
                        "id": 88614,
                        "name": "Wyrzysk",
                        "latitude": "53.15300000",
                        "longitude": "17.26802000"
                    },
                    {
                        "id": 88617,
                        "name": "Wysoka",
                        "latitude": "53.18091000",
                        "longitude": "17.08353000"
                    },
                    {
                        "id": 88672,
                        "name": "Zagórów",
                        "latitude": "52.16835000",
                        "longitude": "17.89561000"
                    },
                    {
                        "id": 88679,
                        "name": "Zakrzewo",
                        "latitude": "53.41186000",
                        "longitude": "17.15472000"
                    },
                    {
                        "id": 88693,
                        "name": "Zaniemyśl",
                        "latitude": "52.15561000",
                        "longitude": "17.16228000"
                    },
                    {
                        "id": 88715,
                        "name": "Zbąszyń",
                        "latitude": "52.25090000",
                        "longitude": "15.92520000"
                    },
                    {
                        "id": 88716,
                        "name": "Zduny",
                        "latitude": "51.64580000",
                        "longitude": "17.37694000"
                    },
                    {
                        "id": 88880,
                        "name": "Żelazków",
                        "latitude": "51.85418000",
                        "longitude": "18.17430000"
                    },
                    {
                        "id": 88884,
                        "name": "Żerków",
                        "latitude": "52.06877000",
                        "longitude": "17.56349000"
                    },
                    {
                        "id": 88746,
                        "name": "Złotniki",
                        "latitude": "52.49407000",
                        "longitude": "16.84496000"
                    },
                    {
                        "id": 88751,
                        "name": "Złotów",
                        "latitude": "53.36346000",
                        "longitude": "17.04082000"
                    }
                ]
            },
            {
                "id": 1630,
                "name": "Holy Cross",
                "iso2": "26",
                "latitude": "50.62610410",
                "longitude": "20.94062790",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85819,
                        "name": "Baćkowice",
                        "latitude": "50.79194000",
                        "longitude": "21.23211000"
                    },
                    {
                        "id": 85820,
                        "name": "Bałtów",
                        "latitude": "51.01845000",
                        "longitude": "21.54385000"
                    },
                    {
                        "id": 85823,
                        "name": "Bejsce",
                        "latitude": "50.23903000",
                        "longitude": "20.59834000"
                    },
                    {
                        "id": 85858,
                        "name": "Bieliny",
                        "latitude": "50.84947000",
                        "longitude": "20.94149000"
                    },
                    {
                        "id": 85883,
                        "name": "Bliżyn",
                        "latitude": "51.10778000",
                        "longitude": "20.75935000"
                    },
                    {
                        "id": 85894,
                        "name": "Bodzentyn",
                        "latitude": "50.94115000",
                        "longitude": "20.95719000"
                    },
                    {
                        "id": 85897,
                        "name": "Bogoria",
                        "latitude": "50.65175000",
                        "longitude": "21.26000000"
                    },
                    {
                        "id": 85945,
                        "name": "Brody",
                        "latitude": "51.02466000",
                        "longitude": "21.22147000"
                    },
                    {
                        "id": 85963,
                        "name": "Brzeziny",
                        "latitude": "50.77273000",
                        "longitude": "20.57319000"
                    },
                    {
                        "id": 85996,
                        "name": "Busko-Zdrój",
                        "latitude": "50.47078000",
                        "longitude": "20.71884000"
                    },
                    {
                        "id": 86073,
                        "name": "Chęciny",
                        "latitude": "50.80021000",
                        "longitude": "20.46229000"
                    },
                    {
                        "id": 86034,
                        "name": "Chmielnik",
                        "latitude": "50.61440000",
                        "longitude": "20.75206000"
                    },
                    {
                        "id": 88754,
                        "name": "Ćmielów",
                        "latitude": "50.89028000",
                        "longitude": "21.51426000"
                    },
                    {
                        "id": 86113,
                        "name": "Czarnocin",
                        "latitude": "50.34080000",
                        "longitude": "20.51620000"
                    },
                    {
                        "id": 86154,
                        "name": "Daleszyce",
                        "latitude": "50.80229000",
                        "longitude": "20.80791000"
                    },
                    {
                        "id": 86186,
                        "name": "Domaszowice",
                        "latitude": "50.87488000",
                        "longitude": "20.68288000"
                    },
                    {
                        "id": 86210,
                        "name": "Dwikozy",
                        "latitude": "50.73613000",
                        "longitude": "21.78864000"
                    },
                    {
                        "id": 86217,
                        "name": "Działoszyce",
                        "latitude": "50.36534000",
                        "longitude": "20.35226000"
                    },
                    {
                        "id": 86268,
                        "name": "Fałków",
                        "latitude": "51.13606000",
                        "longitude": "20.10610000"
                    },
                    {
                        "id": 86316,
                        "name": "Gnojno",
                        "latitude": "50.60263000",
                        "longitude": "20.84913000"
                    },
                    {
                        "id": 86415,
                        "name": "Górno",
                        "latitude": "50.84774000",
                        "longitude": "20.82501000"
                    },
                    {
                        "id": 86350,
                        "name": "Gowarczów",
                        "latitude": "51.27845000",
                        "longitude": "20.43835000"
                    },
                    {
                        "id": 86396,
                        "name": "Grzybowa Góra",
                        "latitude": "51.13326000",
                        "longitude": "20.96174000"
                    },
                    {
                        "id": 86458,
                        "name": "Imielno",
                        "latitude": "50.58569000",
                        "longitude": "20.44813000"
                    },
                    {
                        "id": 86463,
                        "name": "Iwaniska",
                        "latitude": "50.73146000",
                        "longitude": "21.28060000"
                    },
                    {
                        "id": 86578,
                        "name": "Jędrzejów",
                        "latitude": "50.63945000",
                        "longitude": "20.30454000"
                    },
                    {
                        "id": 86607,
                        "name": "Kaniów",
                        "latitude": "50.98577000",
                        "longitude": "20.66391000"
                    },
                    {
                        "id": 86627,
                        "name": "Kazimierza Wielka",
                        "latitude": "50.26564000",
                        "longitude": "20.49358000"
                    },
                    {
                        "id": 86633,
                        "name": "Kielce",
                        "latitude": "50.87033000",
                        "longitude": "20.62752000"
                    },
                    {
                        "id": 86638,
                        "name": "Kije",
                        "latitude": "50.60721000",
                        "longitude": "20.57121000"
                    },
                    {
                        "id": 86650,
                        "name": "Klimontów",
                        "latitude": "50.65588000",
                        "longitude": "21.45587000"
                    },
                    {
                        "id": 86750,
                        "name": "Końskie",
                        "latitude": "51.19166000",
                        "longitude": "20.40607000"
                    },
                    {
                        "id": 86699,
                        "name": "Koprzywnica",
                        "latitude": "50.59340000",
                        "longitude": "21.58380000"
                    },
                    {
                        "id": 86712,
                        "name": "Kostomłoty Drugie",
                        "latitude": "50.92684000",
                        "longitude": "20.56529000"
                    },
                    {
                        "id": 86713,
                        "name": "Kostomłoty Pierwsze",
                        "latitude": "50.92322000",
                        "longitude": "20.59490000"
                    },
                    {
                        "id": 86774,
                        "name": "Krasocin",
                        "latitude": "50.88874000",
                        "longitude": "20.11863000"
                    },
                    {
                        "id": 86839,
                        "name": "Kunów",
                        "latitude": "50.96156000",
                        "longitude": "21.28058000"
                    },
                    {
                        "id": 86916,
                        "name": "Lipnik",
                        "latitude": "50.72977000",
                        "longitude": "21.49389000"
                    },
                    {
                        "id": 88814,
                        "name": "Łączna",
                        "latitude": "51.00231000",
                        "longitude": "20.79712000"
                    },
                    {
                        "id": 88759,
                        "name": "Łagów",
                        "latitude": "50.77517000",
                        "longitude": "21.08431000"
                    },
                    {
                        "id": 88787,
                        "name": "Łoniów",
                        "latitude": "50.56443000",
                        "longitude": "21.52599000"
                    },
                    {
                        "id": 88791,
                        "name": "Łopuszno",
                        "latitude": "50.94864000",
                        "longitude": "20.25081000"
                    },
                    {
                        "id": 88798,
                        "name": "Łubnice",
                        "latitude": "50.41164000",
                        "longitude": "21.15014000"
                    },
                    {
                        "id": 87008,
                        "name": "Małogoszcz",
                        "latitude": "50.81214000",
                        "longitude": "20.26407000"
                    },
                    {
                        "id": 87003,
                        "name": "Masłów",
                        "latitude": "50.90065000",
                        "longitude": "20.72322000"
                    },
                    {
                        "id": 87023,
                        "name": "Michałów",
                        "latitude": "50.49541000",
                        "longitude": "20.46178000"
                    },
                    {
                        "id": 87028,
                        "name": "Miedziana Góra",
                        "latitude": "50.93680000",
                        "longitude": "20.55096000"
                    },
                    {
                        "id": 87057,
                        "name": "Mirzec",
                        "latitude": "51.13466000",
                        "longitude": "21.05710000"
                    },
                    {
                        "id": 87079,
                        "name": "Mniów",
                        "latitude": "51.01224000",
                        "longitude": "20.48427000"
                    },
                    {
                        "id": 87090,
                        "name": "Morawica",
                        "latitude": "50.74678000",
                        "longitude": "20.61756000"
                    },
                    {
                        "id": 87132,
                        "name": "Nagłowice",
                        "latitude": "50.67835000",
                        "longitude": "20.10661000"
                    },
                    {
                        "id": 87176,
                        "name": "Nowa Słupia",
                        "latitude": "50.86432000",
                        "longitude": "21.09049000"
                    },
                    {
                        "id": 87204,
                        "name": "Nowy Korczyn",
                        "latitude": "50.30124000",
                        "longitude": "20.80759000"
                    },
                    {
                        "id": 87218,
                        "name": "Obrazów",
                        "latitude": "50.69276000",
                        "longitude": "21.65045000"
                    },
                    {
                        "id": 87235,
                        "name": "Oksa",
                        "latitude": "50.72874000",
                        "longitude": "20.10086000"
                    },
                    {
                        "id": 87240,
                        "name": "Oleśnica",
                        "latitude": "50.45357000",
                        "longitude": "21.06457000"
                    },
                    {
                        "id": 87256,
                        "name": "Opatów",
                        "latitude": "50.80058000",
                        "longitude": "21.42538000"
                    },
                    {
                        "id": 87255,
                        "name": "Opatowiec",
                        "latitude": "50.24314000",
                        "longitude": "20.72348000"
                    },
                    {
                        "id": 87282,
                        "name": "Osiedle-Nowiny",
                        "latitude": "50.81770000",
                        "longitude": "20.54117000"
                    },
                    {
                        "id": 87283,
                        "name": "Osiek",
                        "latitude": "50.51996000",
                        "longitude": "21.44192000"
                    },
                    {
                        "id": 87299,
                        "name": "Ostrowiec Świętokrzyski",
                        "latitude": "50.92936000",
                        "longitude": "21.38525000"
                    },
                    {
                        "id": 87327,
                        "name": "Ożarów",
                        "latitude": "50.88798000",
                        "longitude": "21.66658000"
                    },
                    {
                        "id": 87331,
                        "name": "Pacanów",
                        "latitude": "50.40031000",
                        "longitude": "21.04148000"
                    },
                    {
                        "id": 87360,
                        "name": "Pawłów",
                        "latitude": "50.96216000",
                        "longitude": "21.12062000"
                    },
                    {
                        "id": 87378,
                        "name": "Piekoszów",
                        "latitude": "50.88035000",
                        "longitude": "20.46418000"
                    },
                    {
                        "id": 87381,
                        "name": "Pierzchnica",
                        "latitude": "50.69754000",
                        "longitude": "20.75489000"
                    },
                    {
                        "id": 87405,
                        "name": "Pińczów",
                        "latitude": "50.52052000",
                        "longitude": "20.52649000"
                    },
                    {
                        "id": 87776,
                        "name": "Połaniec",
                        "latitude": "50.43324000",
                        "longitude": "21.28120000"
                    },
                    {
                        "id": 87478,
                        "name": "Powiat buski",
                        "latitude": "50.45583000",
                        "longitude": "20.87624000"
                    },
                    {
                        "id": 87532,
                        "name": "Powiat jędrzejowski",
                        "latitude": "50.65676000",
                        "longitude": "20.18655000"
                    },
                    {
                        "id": 87537,
                        "name": "Powiat kazimierski",
                        "latitude": "50.28811000",
                        "longitude": "20.53368000"
                    },
                    {
                        "id": 87538,
                        "name": "Powiat kielecki",
                        "latitude": "50.80156000",
                        "longitude": "20.63322000"
                    },
                    {
                        "id": 87543,
                        "name": "Powiat konecki",
                        "latitude": "51.15145000",
                        "longitude": "20.34186000"
                    },
                    {
                        "id": 87615,
                        "name": "Powiat opatowski",
                        "latitude": "50.79639000",
                        "longitude": "21.44531000"
                    },
                    {
                        "id": 87619,
                        "name": "Powiat ostrowiecki",
                        "latitude": "50.94232000",
                        "longitude": "21.40739000"
                    },
                    {
                        "id": 87635,
                        "name": "Powiat pińczowski",
                        "latitude": "50.49968000",
                        "longitude": "20.47253000"
                    },
                    {
                        "id": 87667,
                        "name": "Powiat sandomierski",
                        "latitude": "50.69508000",
                        "longitude": "21.60900000"
                    },
                    {
                        "id": 87674,
                        "name": "Powiat skarżyski",
                        "latitude": "51.06496000",
                        "longitude": "20.79228000"
                    },
                    {
                        "id": 87680,
                        "name": "Powiat starachowicki",
                        "latitude": "51.05365000",
                        "longitude": "21.14295000"
                    },
                    {
                        "id": 87683,
                        "name": "Powiat staszowski",
                        "latitude": "50.51737000",
                        "longitude": "21.19594000"
                    },
                    {
                        "id": 87735,
                        "name": "Powiat włoszczowski",
                        "latitude": "50.83205000",
                        "longitude": "19.97696000"
                    },
                    {
                        "id": 87890,
                        "name": "Radoszyce",
                        "latitude": "51.07392000",
                        "longitude": "20.25836000"
                    },
                    {
                        "id": 87911,
                        "name": "Raków",
                        "latitude": "50.67427000",
                        "longitude": "21.04517000"
                    },
                    {
                        "id": 87947,
                        "name": "Rogów",
                        "latitude": "51.20414000",
                        "longitude": "20.43483000"
                    },
                    {
                        "id": 87970,
                        "name": "Ruda Maleniecka",
                        "latitude": "51.14592000",
                        "longitude": "20.22377000"
                    },
                    {
                        "id": 88014,
                        "name": "Rytwiany",
                        "latitude": "50.52920000",
                        "longitude": "21.20636000"
                    },
                    {
                        "id": 88043,
                        "name": "Sadowie",
                        "latitude": "50.85261000",
                        "longitude": "21.36884000"
                    },
                    {
                        "id": 88045,
                        "name": "Samborzec",
                        "latitude": "50.64663000",
                        "longitude": "21.64822000"
                    },
                    {
                        "id": 88046,
                        "name": "Sandomierz",
                        "latitude": "50.68265000",
                        "longitude": "21.74898000"
                    },
                    {
                        "id": 88054,
                        "name": "Secemin",
                        "latitude": "50.76676000",
                        "longitude": "19.83599000"
                    },
                    {
                        "id": 88328,
                        "name": "Sędziszów",
                        "latitude": "50.56590000",
                        "longitude": "20.05563000"
                    },
                    {
                        "id": 88095,
                        "name": "Skalbmierz",
                        "latitude": "50.31993000",
                        "longitude": "20.39929000"
                    },
                    {
                        "id": 88100,
                        "name": "Skarżysko Kościelne",
                        "latitude": "51.13822000",
                        "longitude": "20.91196000"
                    },
                    {
                        "id": 88101,
                        "name": "Skarżysko-Kamienna",
                        "latitude": "51.11311000",
                        "longitude": "20.87162000"
                    },
                    {
                        "id": 88348,
                        "name": "Słupia",
                        "latitude": "50.60073000",
                        "longitude": "19.97435000"
                    },
                    {
                        "id": 88127,
                        "name": "Smyków",
                        "latitude": "51.04442000",
                        "longitude": "20.40032000"
                    },
                    {
                        "id": 88131,
                        "name": "Sobków",
                        "latitude": "50.69999000",
                        "longitude": "20.45062000"
                    },
                    {
                        "id": 88144,
                        "name": "Solec-Zdrój",
                        "latitude": "50.36594000",
                        "longitude": "20.88956000"
                    },
                    {
                        "id": 88242,
                        "name": "Stąporków",
                        "latitude": "51.13762000",
                        "longitude": "20.57173000"
                    },
                    {
                        "id": 88179,
                        "name": "Starachowice",
                        "latitude": "51.03740000",
                        "longitude": "21.07126000"
                    },
                    {
                        "id": 88198,
                        "name": "Staszów",
                        "latitude": "50.56307000",
                        "longitude": "21.16593000"
                    },
                    {
                        "id": 88207,
                        "name": "Stopnica",
                        "latitude": "50.44018000",
                        "longitude": "20.93780000"
                    },
                    {
                        "id": 88214,
                        "name": "Strawczyn",
                        "latitude": "50.94177000",
                        "longitude": "20.42135000"
                    },
                    {
                        "id": 88250,
                        "name": "Suchedniów",
                        "latitude": "51.04776000",
                        "longitude": "20.82922000"
                    },
                    {
                        "id": 88322,
                        "name": "Szydłów",
                        "latitude": "50.59114000",
                        "longitude": "21.00680000"
                    },
                    {
                        "id": 88368,
                        "name": "Tarłów",
                        "latitude": "51.00160000",
                        "longitude": "21.71474000"
                    },
                    {
                        "id": 88421,
                        "name": "Tuczępy",
                        "latitude": "50.51676000",
                        "longitude": "20.99187000"
                    },
                    {
                        "id": 88632,
                        "name": "Wąchock",
                        "latitude": "51.07391000",
                        "longitude": "21.01243000"
                    },
                    {
                        "id": 88489,
                        "name": "Waśniów",
                        "latitude": "50.89914000",
                        "longitude": "21.22301000"
                    },
                    {
                        "id": 88506,
                        "name": "Wielka Wieś",
                        "latitude": "51.07107000",
                        "longitude": "20.96655000"
                    },
                    {
                        "id": 88534,
                        "name": "Wilczyce",
                        "latitude": "50.74694000",
                        "longitude": "21.65783000"
                    },
                    {
                        "id": 88560,
                        "name": "Wiślica",
                        "latitude": "50.34891000",
                        "longitude": "20.67438000"
                    },
                    {
                        "id": 88654,
                        "name": "Włoszczowa",
                        "latitude": "50.85256000",
                        "longitude": "19.96593000"
                    },
                    {
                        "id": 88568,
                        "name": "Wodzisław",
                        "latitude": "50.52047000",
                        "longitude": "20.19150000"
                    },
                    {
                        "id": 88572,
                        "name": "Wojciechowice",
                        "latitude": "50.84226000",
                        "longitude": "21.58942000"
                    },
                    {
                        "id": 88585,
                        "name": "Wola Jachowa",
                        "latitude": "50.84524000",
                        "longitude": "20.85814000"
                    },
                    {
                        "id": 88666,
                        "name": "Zagnańsk",
                        "latitude": "50.98037000",
                        "longitude": "20.66314000"
                    },
                    {
                        "id": 88702,
                        "name": "Zawichost",
                        "latitude": "50.80743000",
                        "longitude": "21.85408000"
                    },
                    {
                        "id": 88744,
                        "name": "Złota",
                        "latitude": "50.38160000",
                        "longitude": "20.59361000"
                    }
                ]
            },
            {
                "id": 1625,
                "name": "Kuyavia-Pomerania",
                "iso2": "04",
                "latitude": "53.16483630",
                "longitude": "18.48342240",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85781,
                        "name": "Aleksandrów Kujawski",
                        "latitude": "52.87659000",
                        "longitude": "18.69345000"
                    },
                    {
                        "id": 85808,
                        "name": "Barcin",
                        "latitude": "52.86607000",
                        "longitude": "17.94625000"
                    },
                    {
                        "id": 85812,
                        "name": "Bartniczka",
                        "latitude": "53.24776000",
                        "longitude": "19.60433000"
                    },
                    {
                        "id": 85814,
                        "name": "Baruchowo",
                        "latitude": "52.49412000",
                        "longitude": "19.26496000"
                    },
                    {
                        "id": 85839,
                        "name": "Białe Błota",
                        "latitude": "53.09516000",
                        "longitude": "17.91621000"
                    },
                    {
                        "id": 85889,
                        "name": "Bobrowniki",
                        "latitude": "52.78086000",
                        "longitude": "18.96026000"
                    },
                    {
                        "id": 85891,
                        "name": "Bobrowo",
                        "latitude": "53.28549000",
                        "longitude": "19.27053000"
                    },
                    {
                        "id": 85917,
                        "name": "Boniewo",
                        "latitude": "52.46532000",
                        "longitude": "18.89116000"
                    },
                    {
                        "id": 85943,
                        "name": "Brodnica",
                        "latitude": "53.25967000",
                        "longitude": "19.39653000"
                    },
                    {
                        "id": 85966,
                        "name": "Brześć Kujawski",
                        "latitude": "52.60532000",
                        "longitude": "18.90173000"
                    },
                    {
                        "id": 85971,
                        "name": "Brzozie",
                        "latitude": "53.32554000",
                        "longitude": "19.60485000"
                    },
                    {
                        "id": 85973,
                        "name": "Brzuze",
                        "latitude": "53.05458000",
                        "longitude": "19.26195000"
                    },
                    {
                        "id": 85989,
                        "name": "Bukowiec",
                        "latitude": "53.43383000",
                        "longitude": "18.24048000"
                    },
                    {
                        "id": 85999,
                        "name": "Bydgoszcz",
                        "latitude": "53.12350000",
                        "longitude": "18.00762000"
                    },
                    {
                        "id": 86007,
                        "name": "Bytoń",
                        "latitude": "52.55757000",
                        "longitude": "18.59522000"
                    },
                    {
                        "id": 86021,
                        "name": "Cekcyn",
                        "latitude": "53.57294000",
                        "longitude": "18.01123000"
                    },
                    {
                        "id": 86031,
                        "name": "Chełmno",
                        "latitude": "53.34855000",
                        "longitude": "18.42510000"
                    },
                    {
                        "id": 86032,
                        "name": "Chełmża",
                        "latitude": "53.18463000",
                        "longitude": "18.60466000"
                    },
                    {
                        "id": 86038,
                        "name": "Choceń",
                        "latitude": "52.48618000",
                        "longitude": "19.01339000"
                    },
                    {
                        "id": 86044,
                        "name": "Chodecz",
                        "latitude": "52.40513000",
                        "longitude": "19.02759000"
                    },
                    {
                        "id": 86058,
                        "name": "Chrostkowo",
                        "latitude": "52.94378000",
                        "longitude": "19.25328000"
                    },
                    {
                        "id": 86078,
                        "name": "Ciechocin",
                        "latitude": "53.05581000",
                        "longitude": "18.92635000"
                    },
                    {
                        "id": 86079,
                        "name": "Ciechocinek",
                        "latitude": "52.87908000",
                        "longitude": "18.79505000"
                    },
                    {
                        "id": 86136,
                        "name": "Czerniewice",
                        "latitude": "52.51157000",
                        "longitude": "19.08694000"
                    },
                    {
                        "id": 86137,
                        "name": "Czernikowo",
                        "latitude": "52.94688000",
                        "longitude": "18.93803000"
                    },
                    {
                        "id": 86237,
                        "name": "Dąbrowa",
                        "latitude": "52.74668000",
                        "longitude": "17.94342000"
                    },
                    {
                        "id": 86239,
                        "name": "Dąbrowa Chełmińska",
                        "latitude": "53.17518000",
                        "longitude": "18.30537000"
                    },
                    {
                        "id": 86254,
                        "name": "Dębowa Łąka",
                        "latitude": "53.25541000",
                        "longitude": "19.09595000"
                    },
                    {
                        "id": 86171,
                        "name": "Dobre",
                        "latitude": "52.68398000",
                        "longitude": "18.57762000"
                    },
                    {
                        "id": 86180,
                        "name": "Dobrzyń nad Wisłą",
                        "latitude": "52.63814000",
                        "longitude": "19.31875000"
                    },
                    {
                        "id": 86203,
                        "name": "Drzycim",
                        "latitude": "53.50520000",
                        "longitude": "18.30940000"
                    },
                    {
                        "id": 86266,
                        "name": "Fabianki",
                        "latitude": "52.71929000",
                        "longitude": "19.10943000"
                    },
                    {
                        "id": 86272,
                        "name": "Fordon",
                        "latitude": "53.14821000",
                        "longitude": "18.17036000"
                    },
                    {
                        "id": 86424,
                        "name": "Gąsawa",
                        "latitude": "52.76757000",
                        "longitude": "17.75579000"
                    },
                    {
                        "id": 86312,
                        "name": "Gniewkowo",
                        "latitude": "52.89461000",
                        "longitude": "18.40785000"
                    },
                    {
                        "id": 86329,
                        "name": "Golub-Dobrzyń",
                        "latitude": "53.11087000",
                        "longitude": "19.05381000"
                    },
                    {
                        "id": 86419,
                        "name": "Górzno",
                        "latitude": "53.19779000",
                        "longitude": "19.64317000"
                    },
                    {
                        "id": 86344,
                        "name": "Gostycyn",
                        "latitude": "53.49014000",
                        "longitude": "17.80978000"
                    },
                    {
                        "id": 86386,
                        "name": "Grudziądz",
                        "latitude": "53.48411000",
                        "longitude": "18.75366000"
                    },
                    {
                        "id": 86388,
                        "name": "Gruta",
                        "latitude": "53.45315000",
                        "longitude": "18.95700000"
                    },
                    {
                        "id": 86459,
                        "name": "Inowrocław",
                        "latitude": "52.79886000",
                        "longitude": "18.26387000"
                    },
                    {
                        "id": 86469,
                        "name": "Izbica Kujawska",
                        "latitude": "52.42073000",
                        "longitude": "18.76270000"
                    },
                    {
                        "id": 86485,
                        "name": "Jabłonowo Pomorskie",
                        "latitude": "53.39137000",
                        "longitude": "19.15509000"
                    },
                    {
                        "id": 86493,
                        "name": "Janikowo",
                        "latitude": "52.75328000",
                        "longitude": "18.11328000"
                    },
                    {
                        "id": 86501,
                        "name": "Janowiec Wielkopolski",
                        "latitude": "52.75583000",
                        "longitude": "17.48981000"
                    },
                    {
                        "id": 86558,
                        "name": "Jeżewo",
                        "latitude": "53.51061000",
                        "longitude": "18.49437000"
                    },
                    {
                        "id": 86555,
                        "name": "Jeziora Wielkie",
                        "latitude": "52.53043000",
                        "longitude": "18.26803000"
                    },
                    {
                        "id": 86600,
                        "name": "Kamień Krajeński",
                        "latitude": "53.53352000",
                        "longitude": "17.52019000"
                    },
                    {
                        "id": 86631,
                        "name": "Kcynia",
                        "latitude": "52.99192000",
                        "longitude": "17.48830000"
                    },
                    {
                        "id": 86857,
                        "name": "Kęsowo",
                        "latitude": "53.55872000",
                        "longitude": "17.71580000"
                    },
                    {
                        "id": 86639,
                        "name": "Kikół",
                        "latitude": "52.90994000",
                        "longitude": "19.12016000"
                    },
                    {
                        "id": 86705,
                        "name": "Koronowo",
                        "latitude": "53.31370000",
                        "longitude": "17.93698000"
                    },
                    {
                        "id": 86725,
                        "name": "Kowal",
                        "latitude": "52.53019000",
                        "longitude": "19.14767000"
                    },
                    {
                        "id": 86730,
                        "name": "Kowalewo Pomorskie",
                        "latitude": "53.15432000",
                        "longitude": "18.89868000"
                    },
                    {
                        "id": 86793,
                        "name": "Kruszwica",
                        "latitude": "52.67562000",
                        "longitude": "18.33131000"
                    },
                    {
                        "id": 86917,
                        "name": "Lipno",
                        "latitude": "52.84436000",
                        "longitude": "19.17852000"
                    },
                    {
                        "id": 86924,
                        "name": "Lisewo",
                        "latitude": "53.29580000",
                        "longitude": "18.68714000"
                    },
                    {
                        "id": 86929,
                        "name": "Lniano",
                        "latitude": "53.52801000",
                        "longitude": "18.21267000"
                    },
                    {
                        "id": 86931,
                        "name": "Lubanie",
                        "latitude": "52.74689000",
                        "longitude": "18.91940000"
                    },
                    {
                        "id": 86939,
                        "name": "Lubicz Dolny",
                        "latitude": "53.03151000",
                        "longitude": "18.74559000"
                    },
                    {
                        "id": 86940,
                        "name": "Lubicz Górny",
                        "latitude": "53.02686000",
                        "longitude": "18.77100000"
                    },
                    {
                        "id": 86943,
                        "name": "Lubień Kujawski",
                        "latitude": "52.40574000",
                        "longitude": "19.16440000"
                    },
                    {
                        "id": 86941,
                        "name": "Lubiewo",
                        "latitude": "53.46542000",
                        "longitude": "18.02994000"
                    },
                    {
                        "id": 86957,
                        "name": "Lubraniec",
                        "latitude": "52.54178000",
                        "longitude": "18.83254000"
                    },
                    {
                        "id": 88755,
                        "name": "Łabiszyn",
                        "latitude": "52.95210000",
                        "longitude": "17.91971000"
                    },
                    {
                        "id": 88769,
                        "name": "Łasin",
                        "latitude": "53.51794000",
                        "longitude": "19.08832000"
                    },
                    {
                        "id": 88796,
                        "name": "Łubianka",
                        "latitude": "53.13864000",
                        "longitude": "18.48115000"
                    },
                    {
                        "id": 88808,
                        "name": "Łysomice",
                        "latitude": "53.08629000",
                        "longitude": "18.62002000"
                    },
                    {
                        "id": 87086,
                        "name": "Mogilno",
                        "latitude": "52.65806000",
                        "longitude": "17.95578000"
                    },
                    {
                        "id": 87101,
                        "name": "Mrocza",
                        "latitude": "53.24313000",
                        "longitude": "17.60405000"
                    },
                    {
                        "id": 87135,
                        "name": "Nakło nad Notecią",
                        "latitude": "53.14214000",
                        "longitude": "17.60181000"
                    },
                    {
                        "id": 87168,
                        "name": "Nieszawa",
                        "latitude": "52.83452000",
                        "longitude": "18.89921000"
                    },
                    {
                        "id": 87179,
                        "name": "Nowa Wieś Wielka",
                        "latitude": "52.97159000",
                        "longitude": "18.09036000"
                    },
                    {
                        "id": 87180,
                        "name": "Nowe",
                        "latitude": "53.64906000",
                        "longitude": "18.72716000"
                    },
                    {
                        "id": 87219,
                        "name": "Obrowo",
                        "latitude": "52.97149000",
                        "longitude": "18.87863000"
                    },
                    {
                        "id": 87276,
                        "name": "Osie",
                        "latitude": "53.59918000",
                        "longitude": "18.34373000"
                    },
                    {
                        "id": 87294,
                        "name": "Osięciny",
                        "latitude": "52.62926000",
                        "longitude": "18.72208000"
                    },
                    {
                        "id": 87285,
                        "name": "Osiek",
                        "latitude": "52.92629000",
                        "longitude": "18.80765000"
                    },
                    {
                        "id": 87292,
                        "name": "Osielsko",
                        "latitude": "53.18505000",
                        "longitude": "18.08418000"
                    },
                    {
                        "id": 87300,
                        "name": "Ostrowite",
                        "latitude": "53.06917000",
                        "longitude": "19.29337000"
                    },
                    {
                        "id": 87338,
                        "name": "Pakość",
                        "latitude": "52.80178000",
                        "longitude": "18.08530000"
                    },
                    {
                        "id": 87393,
                        "name": "Piotrków Kujawski",
                        "latitude": "52.55111000",
                        "longitude": "18.49905000"
                    },
                    {
                        "id": 87868,
                        "name": "Płużnica",
                        "latitude": "53.29672000",
                        "longitude": "18.77692000"
                    },
                    {
                        "id": 87457,
                        "name": "Powiat aleksandrowski",
                        "latitude": "52.78465000",
                        "longitude": "18.71930000"
                    },
                    {
                        "id": 87473,
                        "name": "Powiat brodnicki",
                        "latitude": "53.26982000",
                        "longitude": "19.42279000"
                    },
                    {
                        "id": 87479,
                        "name": "Powiat bydgoski",
                        "latitude": "53.19029000",
                        "longitude": "18.03808000"
                    },
                    {
                        "id": 87482,
                        "name": "Powiat chełmiński",
                        "latitude": "53.30056000",
                        "longitude": "18.50396000"
                    },
                    {
                        "id": 87506,
                        "name": "Powiat golubsko-dobrzyński",
                        "latitude": "53.09922000",
                        "longitude": "18.99209000"
                    },
                    {
                        "id": 87515,
                        "name": "Powiat grudziądzki",
                        "latitude": "53.47146000",
                        "longitude": "18.91620000"
                    },
                    {
                        "id": 87524,
                        "name": "Powiat inowrocławski",
                        "latitude": "52.76463000",
                        "longitude": "18.29671000"
                    },
                    {
                        "id": 87571,
                        "name": "Powiat lipnowski",
                        "latitude": "52.81573000",
                        "longitude": "19.21704000"
                    },
                    {
                        "id": 87590,
                        "name": "Powiat mogileński",
                        "latitude": "52.66160000",
                        "longitude": "18.07424000"
                    },
                    {
                        "id": 87597,
                        "name": "Powiat nakielski",
                        "latitude": "53.09480000",
                        "longitude": "17.58988000"
                    },
                    {
                        "id": 87658,
                        "name": "Powiat radziejowski",
                        "latitude": "52.62358000",
                        "longitude": "18.52964000"
                    },
                    {
                        "id": 87665,
                        "name": "Powiat rypiński",
                        "latitude": "53.06613000",
                        "longitude": "19.40975000"
                    },
                    {
                        "id": 87696,
                        "name": "Powiat sępoleński",
                        "latitude": "53.44263000",
                        "longitude": "17.50895000"
                    },
                    {
                        "id": 87763,
                        "name": "Powiat świecki",
                        "latitude": "53.48128000",
                        "longitude": "18.41163000"
                    },
                    {
                        "id": 87708,
                        "name": "Powiat toruński",
                        "latitude": "52.98255000",
                        "longitude": "18.83331000"
                    },
                    {
                        "id": 87710,
                        "name": "Powiat tucholski",
                        "latitude": "53.58146000",
                        "longitude": "17.93967000"
                    },
                    {
                        "id": 87729,
                        "name": "Powiat wąbrzeski",
                        "latitude": "53.28267000",
                        "longitude": "18.92649000"
                    },
                    {
                        "id": 87733,
                        "name": "Powiat włocławski",
                        "latitude": "52.55662000",
                        "longitude": "19.05157000"
                    },
                    {
                        "id": 87766,
                        "name": "Powiat żniński",
                        "latitude": "52.82255000",
                        "longitude": "17.73743000"
                    },
                    {
                        "id": 87797,
                        "name": "Pruszcz",
                        "latitude": "53.33021000",
                        "longitude": "18.19894000"
                    },
                    {
                        "id": 87874,
                        "name": "Raciążek",
                        "latitude": "52.85650000",
                        "longitude": "18.81334000"
                    },
                    {
                        "id": 87885,
                        "name": "Radomin",
                        "latitude": "53.08670000",
                        "longitude": "19.19415000"
                    },
                    {
                        "id": 87898,
                        "name": "Radziejów",
                        "latitude": "52.62481000",
                        "longitude": "18.52771000"
                    },
                    {
                        "id": 87903,
                        "name": "Radzyń Chełmiński",
                        "latitude": "53.38509000",
                        "longitude": "18.93725000"
                    },
                    {
                        "id": 87944,
                        "name": "Rogowo",
                        "latitude": "52.72449000",
                        "longitude": "17.65117000"
                    },
                    {
                        "id": 87952,
                        "name": "Rogóźno",
                        "latitude": "53.53587000",
                        "longitude": "18.92859000"
                    },
                    {
                        "id": 88012,
                        "name": "Rypin",
                        "latitude": "53.06603000",
                        "longitude": "19.40941000"
                    },
                    {
                        "id": 88040,
                        "name": "Sadki",
                        "latitude": "53.16036000",
                        "longitude": "17.44912000"
                    },
                    {
                        "id": 88333,
                        "name": "Sępólno Krajeńskie",
                        "latitude": "53.45198000",
                        "longitude": "17.53169000"
                    },
                    {
                        "id": 88060,
                        "name": "Sicienko",
                        "latitude": "53.20387000",
                        "longitude": "17.80051000"
                    },
                    {
                        "id": 88124,
                        "name": "Skępe",
                        "latitude": "52.86798000",
                        "longitude": "19.35604000"
                    },
                    {
                        "id": 88115,
                        "name": "Skrwilno",
                        "latitude": "53.01607000",
                        "longitude": "19.62364000"
                    },
                    {
                        "id": 88831,
                        "name": "Ślesin",
                        "latitude": "53.16514000",
                        "longitude": "17.70258000"
                    },
                    {
                        "id": 88833,
                        "name": "Śliwice",
                        "latitude": "53.70875000",
                        "longitude": "18.17370000"
                    },
                    {
                        "id": 88142,
                        "name": "Solec Kujawski",
                        "latitude": "53.08371000",
                        "longitude": "18.22572000"
                    },
                    {
                        "id": 88160,
                        "name": "Sośno",
                        "latitude": "53.38922000",
                        "longitude": "17.68713000"
                    },
                    {
                        "id": 88232,
                        "name": "Strzelno",
                        "latitude": "52.62789000",
                        "longitude": "18.17246000"
                    },
                    {
                        "id": 88847,
                        "name": "Świecie",
                        "latitude": "53.40953000",
                        "longitude": "18.44742000"
                    },
                    {
                        "id": 88848,
                        "name": "Świecie nad Osą",
                        "latitude": "53.44400000",
                        "longitude": "19.10171000"
                    },
                    {
                        "id": 88849,
                        "name": "Świedziebnia",
                        "latitude": "53.15207000",
                        "longitude": "19.55463000"
                    },
                    {
                        "id": 88850,
                        "name": "Świekatowo",
                        "latitude": "53.41864000",
                        "longitude": "18.09731000"
                    },
                    {
                        "id": 88280,
                        "name": "Sypniewo",
                        "latitude": "53.36981000",
                        "longitude": "17.32690000"
                    },
                    {
                        "id": 88317,
                        "name": "Szubin",
                        "latitude": "53.00967000",
                        "longitude": "17.74000000"
                    },
                    {
                        "id": 88444,
                        "name": "Tłuchowo",
                        "latitude": "52.74715000",
                        "longitude": "19.46563000"
                    },
                    {
                        "id": 88383,
                        "name": "Topólka",
                        "latitude": "52.50327000",
                        "longitude": "18.71246000"
                    },
                    {
                        "id": 88384,
                        "name": "Toruń",
                        "latitude": "53.01375000",
                        "longitude": "18.59814000"
                    },
                    {
                        "id": 88417,
                        "name": "Tuchola",
                        "latitude": "53.58792000",
                        "longitude": "17.85905000"
                    },
                    {
                        "id": 88456,
                        "name": "Unisław",
                        "latitude": "53.21241000",
                        "longitude": "18.38622000"
                    },
                    {
                        "id": 88631,
                        "name": "Wąbrzeźno",
                        "latitude": "53.27989000",
                        "longitude": "18.94773000"
                    },
                    {
                        "id": 88471,
                        "name": "Waganiec",
                        "latitude": "52.80120000",
                        "longitude": "18.87589000"
                    },
                    {
                        "id": 88634,
                        "name": "Wąpielsk",
                        "latitude": "53.13761000",
                        "longitude": "19.27792000"
                    },
                    {
                        "id": 88478,
                        "name": "Warlubie",
                        "latitude": "53.58751000",
                        "longitude": "18.63444000"
                    },
                    {
                        "id": 88557,
                        "name": "Więcbork",
                        "latitude": "53.35384000",
                        "longitude": "17.49064000"
                    },
                    {
                        "id": 88500,
                        "name": "Wielgie",
                        "latitude": "52.74076000",
                        "longitude": "19.26350000"
                    },
                    {
                        "id": 88504,
                        "name": "Wielka Nieszawka",
                        "latitude": "52.99619000",
                        "longitude": "18.50973000"
                    },
                    {
                        "id": 88524,
                        "name": "Wierzchosławice",
                        "latitude": "52.86923000",
                        "longitude": "18.35609000"
                    },
                    {
                        "id": 88649,
                        "name": "Włocławek",
                        "latitude": "52.64817000",
                        "longitude": "19.06780000"
                    },
                    {
                        "id": 88713,
                        "name": "Zbójno",
                        "latitude": "53.00848000",
                        "longitude": "19.15750000"
                    },
                    {
                        "id": 88741,
                        "name": "Zławieś Wielka",
                        "latitude": "53.09562000",
                        "longitude": "18.32897000"
                    },
                    {
                        "id": 88748,
                        "name": "Złotniki Kujawskie",
                        "latitude": "52.89943000",
                        "longitude": "18.14564000"
                    },
                    {
                        "id": 88888,
                        "name": "Żnin",
                        "latitude": "52.84958000",
                        "longitude": "17.71992000"
                    }
                ]
            },
            {
                "id": 1635,
                "name": "Lesser Poland",
                "iso2": "12",
                "latitude": "49.72253060",
                "longitude": "20.25033580",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85783,
                        "name": "Alwernia",
                        "latitude": "50.06056000",
                        "longitude": "19.53953000"
                    },
                    {
                        "id": 85785,
                        "name": "Andrychów",
                        "latitude": "49.85497000",
                        "longitude": "19.33834000"
                    },
                    {
                        "id": 85790,
                        "name": "Babice",
                        "latitude": "50.05565000",
                        "longitude": "19.19955000"
                    },
                    {
                        "id": 85794,
                        "name": "Bachowice",
                        "latitude": "49.95812000",
                        "longitude": "19.49369000"
                    },
                    {
                        "id": 85795,
                        "name": "Balice",
                        "latitude": "50.08799000",
                        "longitude": "19.79462000"
                    },
                    {
                        "id": 85797,
                        "name": "Balin",
                        "latitude": "50.16799000",
                        "longitude": "19.38340000"
                    },
                    {
                        "id": 85815,
                        "name": "Barwałd Górny",
                        "latitude": "49.86211000",
                        "longitude": "19.61746000"
                    },
                    {
                        "id": 85816,
                        "name": "Barwałd Średni",
                        "latitude": "49.86632000",
                        "longitude": "19.59360000"
                    },
                    {
                        "id": 86010,
                        "name": "Bębło",
                        "latitude": "50.18053000",
                        "longitude": "19.78741000"
                    },
                    {
                        "id": 86011,
                        "name": "Bęczarka",
                        "latitude": "49.87793000",
                        "longitude": "19.86723000"
                    },
                    {
                        "id": 85840,
                        "name": "Białka",
                        "latitude": "49.69306000",
                        "longitude": "19.67033000"
                    },
                    {
                        "id": 85841,
                        "name": "Białka Tatrzańska",
                        "latitude": "49.38975000",
                        "longitude": "20.10507000"
                    },
                    {
                        "id": 85849,
                        "name": "Biały Dunajec",
                        "latitude": "49.37380000",
                        "longitude": "20.00898000"
                    },
                    {
                        "id": 85851,
                        "name": "Biecz",
                        "latitude": "49.73596000",
                        "longitude": "21.26301000"
                    },
                    {
                        "id": 85869,
                        "name": "Bieńkówka",
                        "latitude": "49.77600000",
                        "longitude": "19.77179000"
                    },
                    {
                        "id": 85871,
                        "name": "Binarowa",
                        "latitude": "49.75621000",
                        "longitude": "21.22816000"
                    },
                    {
                        "id": 85873,
                        "name": "Biskupice Radłowskie",
                        "latitude": "50.12069000",
                        "longitude": "20.85943000"
                    },
                    {
                        "id": 85885,
                        "name": "Bobowa",
                        "latitude": "49.70866000",
                        "longitude": "20.94767000"
                    },
                    {
                        "id": 85892,
                        "name": "Bochnia",
                        "latitude": "49.96905000",
                        "longitude": "20.43028000"
                    },
                    {
                        "id": 85908,
                        "name": "Bolechowice",
                        "latitude": "50.14831000",
                        "longitude": "19.79273000"
                    },
                    {
                        "id": 85916,
                        "name": "Bolęcin",
                        "latitude": "50.11750000",
                        "longitude": "19.48116000"
                    },
                    {
                        "id": 85910,
                        "name": "Bolesław",
                        "latitude": "50.29729000",
                        "longitude": "19.48073000"
                    },
                    {
                        "id": 85918,
                        "name": "Borek",
                        "latitude": "50.01778000",
                        "longitude": "20.53087000"
                    },
                    {
                        "id": 85930,
                        "name": "Borzęcin",
                        "latitude": "50.06540000",
                        "longitude": "20.71103000"
                    },
                    {
                        "id": 85931,
                        "name": "Borzęta",
                        "latitude": "49.86228000",
                        "longitude": "19.97924000"
                    },
                    {
                        "id": 85949,
                        "name": "Brodła",
                        "latitude": "50.04331000",
                        "longitude": "19.58879000"
                    },
                    {
                        "id": 85946,
                        "name": "Brody",
                        "latitude": "49.86742000",
                        "longitude": "19.69746000"
                    },
                    {
                        "id": 85977,
                        "name": "Brzączowice",
                        "latitude": "49.87478000",
                        "longitude": "20.03709000"
                    },
                    {
                        "id": 85960,
                        "name": "Brzesko",
                        "latitude": "49.96911000",
                        "longitude": "20.60606000"
                    },
                    {
                        "id": 85961,
                        "name": "Brzeszcze",
                        "latitude": "49.98203000",
                        "longitude": "19.15157000"
                    },
                    {
                        "id": 85962,
                        "name": "Brzezinka",
                        "latitude": "50.04237000",
                        "longitude": "19.19020000"
                    },
                    {
                        "id": 85968,
                        "name": "Brzeźnica",
                        "latitude": "49.96497000",
                        "longitude": "19.61952000"
                    },
                    {
                        "id": 85986,
                        "name": "Budzów",
                        "latitude": "49.77622000",
                        "longitude": "19.67274000"
                    },
                    {
                        "id": 85990,
                        "name": "Bukowina Tatrzańska",
                        "latitude": "49.34302000",
                        "longitude": "20.10807000"
                    },
                    {
                        "id": 85991,
                        "name": "Bukowno",
                        "latitude": "50.26474000",
                        "longitude": "19.45962000"
                    },
                    {
                        "id": 85994,
                        "name": "Bulowice",
                        "latitude": "49.87650000",
                        "longitude": "19.28873000"
                    },
                    {
                        "id": 86000,
                        "name": "Bystra",
                        "latitude": "49.64796000",
                        "longitude": "19.77994000"
                    },
                    {
                        "id": 86029,
                        "name": "Chełmek",
                        "latitude": "50.10163000",
                        "longitude": "19.24801000"
                    },
                    {
                        "id": 86030,
                        "name": "Chełmiec",
                        "latitude": "49.63051000",
                        "longitude": "20.66425000"
                    },
                    {
                        "id": 86043,
                        "name": "Chocznia",
                        "latitude": "49.87417000",
                        "longitude": "19.45438000"
                    },
                    {
                        "id": 86062,
                        "name": "Chrzanów",
                        "latitude": "50.13546000",
                        "longitude": "19.40203000"
                    },
                    {
                        "id": 86071,
                        "name": "Chyżne",
                        "latitude": "49.42672000",
                        "longitude": "19.66956000"
                    },
                    {
                        "id": 86094,
                        "name": "Ciężkowice",
                        "latitude": "49.78575000",
                        "longitude": "20.97324000"
                    },
                    {
                        "id": 86107,
                        "name": "Czarna Góra",
                        "latitude": "49.37662000",
                        "longitude": "20.13047000"
                    },
                    {
                        "id": 86112,
                        "name": "Czarnochowice",
                        "latitude": "50.00471000",
                        "longitude": "20.06790000"
                    },
                    {
                        "id": 86118,
                        "name": "Czarny Dunajec",
                        "latitude": "49.43663000",
                        "longitude": "19.85161000"
                    },
                    {
                        "id": 86121,
                        "name": "Czchów",
                        "latitude": "49.83726000",
                        "longitude": "20.68056000"
                    },
                    {
                        "id": 86133,
                        "name": "Czernichów",
                        "latitude": "49.98920000",
                        "longitude": "19.68115000"
                    },
                    {
                        "id": 86147,
                        "name": "Czułów",
                        "latitude": "50.05956000",
                        "longitude": "19.70106000"
                    },
                    {
                        "id": 86241,
                        "name": "Dąbrowa Tarnowska",
                        "latitude": "50.17462000",
                        "longitude": "20.98633000"
                    },
                    {
                        "id": 86251,
                        "name": "Dębno",
                        "latitude": "49.96701000",
                        "longitude": "20.71979000"
                    },
                    {
                        "id": 86164,
                        "name": "Dobczyce",
                        "latitude": "49.88109000",
                        "longitude": "20.08936000"
                    },
                    {
                        "id": 86167,
                        "name": "Dobra",
                        "latitude": "49.71793000",
                        "longitude": "20.25347000"
                    },
                    {
                        "id": 86226,
                        "name": "Dziewin",
                        "latitude": "50.07554000",
                        "longitude": "20.45491000"
                    },
                    {
                        "id": 86269,
                        "name": "Filipowice",
                        "latitude": "50.15573000",
                        "longitude": "19.56579000"
                    },
                    {
                        "id": 86277,
                        "name": "Frydman",
                        "latitude": "49.44927000",
                        "longitude": "20.22961000"
                    },
                    {
                        "id": 86278,
                        "name": "Frydrychowice",
                        "latitude": "49.90481000",
                        "longitude": "19.41936000"
                    },
                    {
                        "id": 86293,
                        "name": "Gdów",
                        "latitude": "49.90818000",
                        "longitude": "20.19879000"
                    },
                    {
                        "id": 86295,
                        "name": "Giebułtów",
                        "latitude": "50.14556000",
                        "longitude": "19.87856000"
                    },
                    {
                        "id": 86298,
                        "name": "Gierałtowice",
                        "latitude": "49.94426000",
                        "longitude": "19.39070000"
                    },
                    {
                        "id": 86426,
                        "name": "Głogoczów",
                        "latitude": "49.89452000",
                        "longitude": "19.87410000"
                    },
                    {
                        "id": 86315,
                        "name": "Gnojnik",
                        "latitude": "49.89397000",
                        "longitude": "20.60863000"
                    },
                    {
                        "id": 86333,
                        "name": "Gorenice",
                        "latitude": "50.20800000",
                        "longitude": "19.62038000"
                    },
                    {
                        "id": 86334,
                        "name": "Gorlice",
                        "latitude": "49.65563000",
                        "longitude": "21.16035000"
                    },
                    {
                        "id": 86402,
                        "name": "Gręboszów",
                        "latitude": "50.24501000",
                        "longitude": "20.77669000"
                    },
                    {
                        "id": 86379,
                        "name": "Grojec",
                        "latitude": "49.98147000",
                        "longitude": "19.23792000"
                    },
                    {
                        "id": 86381,
                        "name": "Gromnik",
                        "latitude": "49.83843000",
                        "longitude": "20.96123000"
                    },
                    {
                        "id": 86387,
                        "name": "Gruszów Wielki",
                        "latitude": "50.19163000",
                        "longitude": "21.03144000"
                    },
                    {
                        "id": 86389,
                        "name": "Grybów",
                        "latitude": "49.62439000",
                        "longitude": "20.94797000"
                    },
                    {
                        "id": 86393,
                        "name": "Grzechynia",
                        "latitude": "49.71360000",
                        "longitude": "19.64561000"
                    },
                    {
                        "id": 86443,
                        "name": "Harbutowice",
                        "latitude": "49.81235000",
                        "longitude": "19.78045000"
                    },
                    {
                        "id": 86461,
                        "name": "Inwałd",
                        "latitude": "49.86355000",
                        "longitude": "19.39276000"
                    },
                    {
                        "id": 86465,
                        "name": "Iwkowa",
                        "latitude": "49.81716000",
                        "longitude": "20.59018000"
                    },
                    {
                        "id": 86471,
                        "name": "Izdebnik",
                        "latitude": "49.87218000",
                        "longitude": "19.76801000"
                    },
                    {
                        "id": 86480,
                        "name": "Jabłonka",
                        "latitude": "49.47968000",
                        "longitude": "19.69370000"
                    },
                    {
                        "id": 86487,
                        "name": "Jadowniki",
                        "latitude": "49.95884000",
                        "longitude": "20.64434000"
                    },
                    {
                        "id": 86488,
                        "name": "Jadowniki Mokre",
                        "latitude": "50.16546000",
                        "longitude": "20.72845000"
                    },
                    {
                        "id": 86497,
                        "name": "Janowice",
                        "latitude": "49.89154000",
                        "longitude": "20.86081000"
                    },
                    {
                        "id": 86510,
                        "name": "Jaroszowice",
                        "latitude": "49.86267000",
                        "longitude": "19.51962000"
                    },
                    {
                        "id": 86517,
                        "name": "Jasień",
                        "latitude": "49.96988000",
                        "longitude": "20.57190000"
                    },
                    {
                        "id": 86513,
                        "name": "Jasienica",
                        "latitude": "49.82281000",
                        "longitude": "19.84191000"
                    },
                    {
                        "id": 86526,
                        "name": "Jastrzębia",
                        "latitude": "49.79733000",
                        "longitude": "20.88089000"
                    },
                    {
                        "id": 86533,
                        "name": "Jawornik",
                        "latitude": "49.85580000",
                        "longitude": "19.89315000"
                    },
                    {
                        "id": 86554,
                        "name": "Jerzmanowice",
                        "latitude": "50.21267000",
                        "longitude": "19.74672000"
                    },
                    {
                        "id": 86564,
                        "name": "Jodłówka",
                        "latitude": "49.99295000",
                        "longitude": "20.54821000"
                    },
                    {
                        "id": 86565,
                        "name": "Jodłówka-Wałki",
                        "latitude": "50.04992000",
                        "longitude": "21.13332000"
                    },
                    {
                        "id": 86568,
                        "name": "Jordanów",
                        "latitude": "49.64935000",
                        "longitude": "19.82981000"
                    },
                    {
                        "id": 86571,
                        "name": "Juszczyn",
                        "latitude": "49.69290000",
                        "longitude": "19.69128000"
                    },
                    {
                        "id": 86588,
                        "name": "Kalwaria Zebrzydowska",
                        "latitude": "49.86759000",
                        "longitude": "19.67720000"
                    },
                    {
                        "id": 86599,
                        "name": "Kamień",
                        "latitude": "50.01215000",
                        "longitude": "19.58536000"
                    },
                    {
                        "id": 86590,
                        "name": "Kamienica",
                        "latitude": "49.57533000",
                        "longitude": "20.34505000"
                    },
                    {
                        "id": 86604,
                        "name": "Kamionka Wielka",
                        "latitude": "49.56848000",
                        "longitude": "20.82364000"
                    },
                    {
                        "id": 86619,
                        "name": "Kasina Wielka",
                        "latitude": "49.72969000",
                        "longitude": "20.13554000"
                    },
                    {
                        "id": 86620,
                        "name": "Kaszów",
                        "latitude": "50.03884000",
                        "longitude": "19.71934000"
                    },
                    {
                        "id": 86859,
                        "name": "Kęty",
                        "latitude": "49.88214000",
                        "longitude": "19.22333000"
                    },
                    {
                        "id": 86642,
                        "name": "Klecza Dolna",
                        "latitude": "49.88291000",
                        "longitude": "19.53764000"
                    },
                    {
                        "id": 86649,
                        "name": "Klikuszowa",
                        "latitude": "49.51930000",
                        "longitude": "19.98490000"
                    },
                    {
                        "id": 86651,
                        "name": "Klimontów",
                        "latitude": "50.22843000",
                        "longitude": "20.31990000"
                    },
                    {
                        "id": 86654,
                        "name": "Klucze",
                        "latitude": "50.33565000",
                        "longitude": "19.56236000"
                    },
                    {
                        "id": 86656,
                        "name": "Kluszkowce",
                        "latitude": "49.45100000",
                        "longitude": "20.30179000"
                    },
                    {
                        "id": 86860,
                        "name": "Kłaj",
                        "latitude": "49.99246000",
                        "longitude": "20.29904000"
                    },
                    {
                        "id": 86664,
                        "name": "Kobylanka",
                        "latitude": "49.66891000",
                        "longitude": "21.22293000"
                    },
                    {
                        "id": 86675,
                        "name": "Kokotów",
                        "latitude": "50.01254000",
                        "longitude": "20.07829000"
                    },
                    {
                        "id": 86709,
                        "name": "Korzenna",
                        "latitude": "49.68635000",
                        "longitude": "20.84355000"
                    },
                    {
                        "id": 86755,
                        "name": "Kościelisko",
                        "latitude": "49.29073000",
                        "longitude": "19.88929000"
                    },
                    {
                        "id": 86718,
                        "name": "Koszyce",
                        "latitude": "49.97226000",
                        "longitude": "20.94166000"
                    },
                    {
                        "id": 86719,
                        "name": "Koszyce Wielkie",
                        "latitude": "49.98076000",
                        "longitude": "20.94552000"
                    },
                    {
                        "id": 86739,
                        "name": "Kozłów",
                        "latitude": "50.48394000",
                        "longitude": "20.02456000"
                    },
                    {
                        "id": 86763,
                        "name": "Kraków",
                        "latitude": "50.07262000",
                        "longitude": "19.93250000"
                    },
                    {
                        "id": 86787,
                        "name": "Krościenko nad Dunajcem",
                        "latitude": "49.44081000",
                        "longitude": "20.42624000"
                    },
                    {
                        "id": 86788,
                        "name": "Krośnica",
                        "latitude": "49.44787000",
                        "longitude": "20.33956000"
                    },
                    {
                        "id": 86795,
                        "name": "Krynica-Zdrój",
                        "latitude": "49.42225000",
                        "longitude": "20.95942000"
                    },
                    {
                        "id": 86799,
                        "name": "Kryspinów",
                        "latitude": "50.04380000",
                        "longitude": "19.79822000"
                    },
                    {
                        "id": 86801,
                        "name": "Krzczonów",
                        "latitude": "49.73813000",
                        "longitude": "19.91821000"
                    },
                    {
                        "id": 86827,
                        "name": "Krzęcin",
                        "latitude": "49.94316000",
                        "longitude": "19.74157000"
                    },
                    {
                        "id": 86804,
                        "name": "Krzeczów",
                        "latitude": "49.98876000",
                        "longitude": "20.48779000"
                    },
                    {
                        "id": 86812,
                        "name": "Krzeszów",
                        "latitude": "49.75915000",
                        "longitude": "19.48915000"
                    },
                    {
                        "id": 86808,
                        "name": "Krzeszowice",
                        "latitude": "50.14248000",
                        "longitude": "19.63223000"
                    },
                    {
                        "id": 86816,
                        "name": "Krzyszkowice",
                        "latitude": "49.88346000",
                        "longitude": "19.92285000"
                    },
                    {
                        "id": 86817,
                        "name": "Krzywaczka",
                        "latitude": "49.89353000",
                        "longitude": "19.83221000"
                    },
                    {
                        "id": 86836,
                        "name": "Kuków",
                        "latitude": "49.73252000",
                        "longitude": "19.48485000"
                    },
                    {
                        "id": 86848,
                        "name": "Kwaczała",
                        "latitude": "50.06408000",
                        "longitude": "19.49215000"
                    },
                    {
                        "id": 86868,
                        "name": "Lachowice",
                        "latitude": "49.71555000",
                        "longitude": "19.47455000"
                    },
                    {
                        "id": 86870,
                        "name": "Lanckorona",
                        "latitude": "49.84496000",
                        "longitude": "19.71578000"
                    },
                    {
                        "id": 86871,
                        "name": "Lasek",
                        "latitude": "49.50883000",
                        "longitude": "19.98078000"
                    },
                    {
                        "id": 86872,
                        "name": "Laskowa",
                        "latitude": "49.76147000",
                        "longitude": "20.45045000"
                    },
                    {
                        "id": 86887,
                        "name": "Leńcze",
                        "latitude": "49.89895000",
                        "longitude": "19.73539000"
                    },
                    {
                        "id": 86891,
                        "name": "Leśnica",
                        "latitude": "49.40092000",
                        "longitude": "20.06001000"
                    },
                    {
                        "id": 86896,
                        "name": "Libertów",
                        "latitude": "49.97242000",
                        "longitude": "19.89461000"
                    },
                    {
                        "id": 86897,
                        "name": "Libiąż",
                        "latitude": "50.10396000",
                        "longitude": "19.31568000"
                    },
                    {
                        "id": 86902,
                        "name": "Limanowa",
                        "latitude": "49.70594000",
                        "longitude": "20.42204000"
                    },
                    {
                        "id": 86908,
                        "name": "Lipinki",
                        "latitude": "49.67296000",
                        "longitude": "21.29288000"
                    },
                    {
                        "id": 86913,
                        "name": "Lipnica Mała",
                        "latitude": "49.51507000",
                        "longitude": "19.63497000"
                    },
                    {
                        "id": 86914,
                        "name": "Lipnica Wielka",
                        "latitude": "49.70489000",
                        "longitude": "20.86844000"
                    },
                    {
                        "id": 86915,
                        "name": "Lipnik",
                        "latitude": "49.78902000",
                        "longitude": "20.08455000"
                    },
                    {
                        "id": 86926,
                        "name": "Lisia Góra",
                        "latitude": "50.08039000",
                        "longitude": "21.04397000"
                    },
                    {
                        "id": 86928,
                        "name": "Liszki",
                        "latitude": "50.03884000",
                        "longitude": "19.76835000"
                    },
                    {
                        "id": 86942,
                        "name": "Lubień",
                        "latitude": "49.71921000",
                        "longitude": "19.97847000"
                    },
                    {
                        "id": 86952,
                        "name": "Lubomierz",
                        "latitude": "49.60854000",
                        "longitude": "20.20214000"
                    },
                    {
                        "id": 86965,
                        "name": "Ludźmierz",
                        "latitude": "49.46656000",
                        "longitude": "19.98250000"
                    },
                    {
                        "id": 86966,
                        "name": "Luszowice",
                        "latitude": "50.17415000",
                        "longitude": "19.40426000"
                    },
                    {
                        "id": 88756,
                        "name": "Łabowa",
                        "latitude": "49.52766000",
                        "longitude": "20.85497000"
                    },
                    {
                        "id": 88812,
                        "name": "Łącko",
                        "latitude": "49.55757000",
                        "longitude": "20.43586000"
                    },
                    {
                        "id": 88813,
                        "name": "Łączany",
                        "latitude": "49.98407000",
                        "longitude": "19.57867000"
                    },
                    {
                        "id": 88765,
                        "name": "Łapanów",
                        "latitude": "49.86538000",
                        "longitude": "20.29149000"
                    },
                    {
                        "id": 88766,
                        "name": "Łapczyca",
                        "latitude": "49.95994000",
                        "longitude": "20.38445000"
                    },
                    {
                        "id": 88767,
                        "name": "Łapsze Niżne",
                        "latitude": "49.39807000",
                        "longitude": "20.24343000"
                    },
                    {
                        "id": 88828,
                        "name": "Łętownia",
                        "latitude": "49.69745000",
                        "longitude": "19.87109000"
                    },
                    {
                        "id": 88790,
                        "name": "Łopuszna",
                        "latitude": "49.47281000",
                        "longitude": "20.13021000"
                    },
                    {
                        "id": 88794,
                        "name": "Łososina Dolna",
                        "latitude": "49.74977000",
                        "longitude": "20.63129000"
                    },
                    {
                        "id": 88802,
                        "name": "Łukowa",
                        "latitude": "50.09300000",
                        "longitude": "20.97548000"
                    },
                    {
                        "id": 88804,
                        "name": "Łukowica",
                        "latitude": "49.61110000",
                        "longitude": "20.48289000"
                    },
                    {
                        "id": 88806,
                        "name": "Łużna",
                        "latitude": "49.71288000",
                        "longitude": "21.04637000"
                    },
                    {
                        "id": 86984,
                        "name": "Maków Podhalański",
                        "latitude": "49.73008000",
                        "longitude": "19.67711000"
                    },
                    {
                        "id": 86988,
                        "name": "Malec",
                        "latitude": "49.92106000",
                        "longitude": "19.24530000"
                    },
                    {
                        "id": 86990,
                        "name": "Maniowy",
                        "latitude": "49.45976000",
                        "longitude": "20.26454000"
                    },
                    {
                        "id": 87002,
                        "name": "Maszkienice",
                        "latitude": "49.98920000",
                        "longitude": "20.68657000"
                    },
                    {
                        "id": 87125,
                        "name": "Mędrzechów",
                        "latitude": "50.28221000",
                        "longitude": "20.94749000"
                    },
                    {
                        "id": 87126,
                        "name": "Mętków",
                        "latitude": "50.05251000",
                        "longitude": "19.37525000"
                    },
                    {
                        "id": 87020,
                        "name": "Michałowice",
                        "latitude": "50.15898000",
                        "longitude": "19.98044000"
                    },
                    {
                        "id": 87026,
                        "name": "Miechów",
                        "latitude": "50.35648000",
                        "longitude": "20.02788000"
                    },
                    {
                        "id": 87027,
                        "name": "Miechów Charsznica",
                        "latitude": "50.39599000",
                        "longitude": "19.95031000"
                    },
                    {
                        "id": 87067,
                        "name": "Miękinia",
                        "latitude": "50.15557000",
                        "longitude": "19.60871000"
                    },
                    {
                        "id": 87077,
                        "name": "Mników",
                        "latitude": "50.06044000",
                        "longitude": "19.72595000"
                    },
                    {
                        "id": 87082,
                        "name": "Modlnica",
                        "latitude": "50.12958000",
                        "longitude": "19.86461000"
                    },
                    {
                        "id": 87083,
                        "name": "Modlniczka",
                        "latitude": "50.11739000",
                        "longitude": "19.85530000"
                    },
                    {
                        "id": 87085,
                        "name": "Mogilany",
                        "latitude": "49.93890000",
                        "longitude": "19.88972000"
                    },
                    {
                        "id": 87098,
                        "name": "Moszczenica",
                        "latitude": "49.73668000",
                        "longitude": "21.09238000"
                    },
                    {
                        "id": 87109,
                        "name": "Mszana Dolna",
                        "latitude": "49.67432000",
                        "longitude": "20.07992000"
                    },
                    {
                        "id": 87110,
                        "name": "Mszana Górna",
                        "latitude": "49.66202000",
                        "longitude": "20.09734000"
                    },
                    {
                        "id": 87115,
                        "name": "Muszyna",
                        "latitude": "49.35661000",
                        "longitude": "20.89718000"
                    },
                    {
                        "id": 87122,
                        "name": "Myślachowice",
                        "latitude": "50.18514000",
                        "longitude": "19.48116000"
                    },
                    {
                        "id": 87123,
                        "name": "Myślenice",
                        "latitude": "49.83383000",
                        "longitude": "19.93830000"
                    },
                    {
                        "id": 87137,
                        "name": "Naprawa",
                        "latitude": "49.64657000",
                        "longitude": "19.87916000"
                    },
                    {
                        "id": 87142,
                        "name": "Nawojowa",
                        "latitude": "49.56686000",
                        "longitude": "20.73927000"
                    },
                    {
                        "id": 87145,
                        "name": "Nidek",
                        "latitude": "49.90492000",
                        "longitude": "19.32461000"
                    },
                    {
                        "id": 87154,
                        "name": "Niedomice",
                        "latitude": "50.10737000",
                        "longitude": "20.89548000"
                    },
                    {
                        "id": 87156,
                        "name": "Niedzica",
                        "latitude": "49.41008000",
                        "longitude": "20.30273000"
                    },
                    {
                        "id": 87159,
                        "name": "Niedźwiedź",
                        "latitude": "49.62100000",
                        "longitude": "20.07794000"
                    },
                    {
                        "id": 87167,
                        "name": "Niepołomice",
                        "latitude": "50.04066000",
                        "longitude": "20.22257000"
                    },
                    {
                        "id": 87172,
                        "name": "Nowa Góra",
                        "latitude": "50.17305000",
                        "longitude": "19.59120000"
                    },
                    {
                        "id": 87177,
                        "name": "Nowa Wieś",
                        "latitude": "49.90746000",
                        "longitude": "19.21646000"
                    },
                    {
                        "id": 87181,
                        "name": "Nowe Brzesko",
                        "latitude": "50.13222000",
                        "longitude": "20.37663000"
                    },
                    {
                        "id": 87206,
                        "name": "Nowy Sącz",
                        "latitude": "49.62177000",
                        "longitude": "20.69705000"
                    },
                    {
                        "id": 87207,
                        "name": "Nowy Targ",
                        "latitude": "49.47783000",
                        "longitude": "20.03228000"
                    },
                    {
                        "id": 87209,
                        "name": "Nowy Wiśnicz",
                        "latitude": "49.91465000",
                        "longitude": "20.46109000"
                    },
                    {
                        "id": 87225,
                        "name": "Ochojno",
                        "latitude": "49.95255000",
                        "longitude": "19.97452000"
                    },
                    {
                        "id": 87227,
                        "name": "Ochotnica Dolna",
                        "latitude": "49.52682000",
                        "longitude": "20.34265000"
                    },
                    {
                        "id": 87233,
                        "name": "Okocim",
                        "latitude": "49.94890000",
                        "longitude": "20.60160000"
                    },
                    {
                        "id": 87237,
                        "name": "Olesno",
                        "latitude": "50.20152000",
                        "longitude": "20.92578000"
                    },
                    {
                        "id": 87242,
                        "name": "Olkusz",
                        "latitude": "50.28130000",
                        "longitude": "19.56503000"
                    },
                    {
                        "id": 87243,
                        "name": "Olszana",
                        "latitude": "49.56748000",
                        "longitude": "20.52126000"
                    },
                    {
                        "id": 87251,
                        "name": "Olszówka",
                        "latitude": "49.61455000",
                        "longitude": "20.02885000"
                    },
                    {
                        "id": 87323,
                        "name": "Ołpiny",
                        "latitude": "49.80686000",
                        "longitude": "21.20464000"
                    },
                    {
                        "id": 87278,
                        "name": "Osieczany",
                        "latitude": "49.84252000",
                        "longitude": "19.98207000"
                    },
                    {
                        "id": 87284,
                        "name": "Osiek",
                        "latitude": "50.24353000",
                        "longitude": "19.60047000"
                    },
                    {
                        "id": 87291,
                        "name": "Osielec",
                        "latitude": "49.68079000",
                        "longitude": "19.78243000"
                    },
                    {
                        "id": 87314,
                        "name": "Ostrężnica",
                        "latitude": "50.19262000",
                        "longitude": "19.57077000"
                    },
                    {
                        "id": 87302,
                        "name": "Ostrowsko",
                        "latitude": "49.47616000",
                        "longitude": "20.10052000"
                    },
                    {
                        "id": 87325,
                        "name": "Oświęcim",
                        "latitude": "50.03437000",
                        "longitude": "19.21037000"
                    },
                    {
                        "id": 87339,
                        "name": "Palcza",
                        "latitude": "49.80454000",
                        "longitude": "19.74389000"
                    },
                    {
                        "id": 87354,
                        "name": "Pawlikowice",
                        "latitude": "49.95310000",
                        "longitude": "20.05486000"
                    },
                    {
                        "id": 87361,
                        "name": "Pcim",
                        "latitude": "49.75166000",
                        "longitude": "19.97108000"
                    },
                    {
                        "id": 87375,
                        "name": "Piekary",
                        "latitude": "50.02495000",
                        "longitude": "19.79616000"
                    },
                    {
                        "id": 87377,
                        "name": "Piekielnik",
                        "latitude": "49.47688000",
                        "longitude": "19.76810000"
                    },
                    {
                        "id": 87400,
                        "name": "Piwniczna-Zdrój",
                        "latitude": "49.44056000",
                        "longitude": "20.71423000"
                    },
                    {
                        "id": 87408,
                        "name": "Pleśna",
                        "latitude": "49.92642000",
                        "longitude": "20.94526000"
                    },
                    {
                        "id": 87863,
                        "name": "Płaza",
                        "latitude": "50.09988000",
                        "longitude": "19.46451000"
                    },
                    {
                        "id": 87415,
                        "name": "Podegrodzie",
                        "latitude": "49.57688000",
                        "longitude": "20.58855000"
                    },
                    {
                        "id": 87419,
                        "name": "Podłęże",
                        "latitude": "50.01458000",
                        "longitude": "20.16781000"
                    },
                    {
                        "id": 87418,
                        "name": "Podwilk",
                        "latitude": "49.54760000",
                        "longitude": "19.73874000"
                    },
                    {
                        "id": 87424,
                        "name": "Pogórska Wola",
                        "latitude": "50.01855000",
                        "longitude": "21.15795000"
                    },
                    {
                        "id": 87421,
                        "name": "Pogorzyce",
                        "latitude": "50.10186000",
                        "longitude": "19.42228000"
                    },
                    {
                        "id": 87431,
                        "name": "Polanka Wielka",
                        "latitude": "49.98501000",
                        "longitude": "19.32615000"
                    },
                    {
                        "id": 87441,
                        "name": "Ponikiew",
                        "latitude": "49.83311000",
                        "longitude": "19.46571000"
                    },
                    {
                        "id": 87447,
                        "name": "Porąbka Uszewska",
                        "latitude": "49.94260000",
                        "longitude": "20.69052000"
                    },
                    {
                        "id": 87448,
                        "name": "Poręba",
                        "latitude": "49.79645000",
                        "longitude": "20.01718000"
                    },
                    {
                        "id": 87450,
                        "name": "Poręba Spytkowska",
                        "latitude": "49.93995000",
                        "longitude": "20.55405000"
                    },
                    {
                        "id": 87451,
                        "name": "Poręba Wielka",
                        "latitude": "50.01116000",
                        "longitude": "19.28375000"
                    },
                    {
                        "id": 87445,
                        "name": "Poronin",
                        "latitude": "49.33781000",
                        "longitude": "20.00291000"
                    },
                    {
                        "id": 87470,
                        "name": "Powiat bocheński",
                        "latitude": "49.96911000",
                        "longitude": "20.43078000"
                    },
                    {
                        "id": 87474,
                        "name": "Powiat brzeski",
                        "latitude": "49.97170000",
                        "longitude": "20.60572000"
                    },
                    {
                        "id": 87487,
                        "name": "Powiat chrzanowski",
                        "latitude": "50.13565000",
                        "longitude": "19.40434000"
                    },
                    {
                        "id": 87496,
                        "name": "Powiat dąbrowski",
                        "latitude": "50.17572000",
                        "longitude": "20.97895000"
                    },
                    {
                        "id": 87507,
                        "name": "Powiat gorlicki",
                        "latitude": "49.66452000",
                        "longitude": "21.16842000"
                    },
                    {
                        "id": 87550,
                        "name": "Powiat krakowski",
                        "latitude": "50.14347000",
                        "longitude": "19.91409000"
                    },
                    {
                        "id": 87570,
                        "name": "Powiat limanowski",
                        "latitude": "49.70761000",
                        "longitude": "20.42444000"
                    },
                    {
                        "id": 87583,
                        "name": "Powiat miechowski",
                        "latitude": "50.35715000",
                        "longitude": "20.03290000"
                    },
                    {
                        "id": 87594,
                        "name": "Powiat myślenicki",
                        "latitude": "49.83394000",
                        "longitude": "19.94482000"
                    },
                    {
                        "id": 87605,
                        "name": "Powiat nowosądecki",
                        "latitude": "49.63467000",
                        "longitude": "20.69824000"
                    },
                    {
                        "id": 87606,
                        "name": "Powiat nowotarski",
                        "latitude": "49.47663000",
                        "longitude": "20.04305000"
                    },
                    {
                        "id": 87613,
                        "name": "Powiat olkuski",
                        "latitude": "50.27932000",
                        "longitude": "19.55772000"
                    },
                    {
                        "id": 87627,
                        "name": "Powiat oświęcimski",
                        "latitude": "50.03796000",
                        "longitude": "19.22771000"
                    },
                    {
                        "id": 87641,
                        "name": "Powiat proszowicki",
                        "latitude": "50.19241000",
                        "longitude": "20.28413000"
                    },
                    {
                        "id": 87689,
                        "name": "Powiat suski",
                        "latitude": "49.74462000",
                        "longitude": "19.59103000"
                    },
                    {
                        "id": 87703,
                        "name": "Powiat tarnowski",
                        "latitude": "50.05449000",
                        "longitude": "20.90527000"
                    },
                    {
                        "id": 87704,
                        "name": "Powiat tatrzański",
                        "latitude": "49.30420000",
                        "longitude": "19.94800000"
                    },
                    {
                        "id": 87712,
                        "name": "Powiat wadowicki",
                        "latitude": "49.89032000",
                        "longitude": "19.48374000"
                    },
                    {
                        "id": 87717,
                        "name": "Powiat wielicki",
                        "latitude": "49.98570000",
                        "longitude": "20.05494000"
                    },
                    {
                        "id": 87792,
                        "name": "Proszowice",
                        "latitude": "50.19275000",
                        "longitude": "20.28909000"
                    },
                    {
                        "id": 87802,
                        "name": "Przecieszyn",
                        "latitude": "49.97838000",
                        "longitude": "19.17046000"
                    },
                    {
                        "id": 87803,
                        "name": "Przeciszów",
                        "latitude": "50.00647000",
                        "longitude": "19.37576000"
                    },
                    {
                        "id": 87809,
                        "name": "Przeginia",
                        "latitude": "50.23831000",
                        "longitude": "19.68853000"
                    },
                    {
                        "id": 87820,
                        "name": "Przyborów",
                        "latitude": "50.03035000",
                        "longitude": "20.66279000"
                    },
                    {
                        "id": 87830,
                        "name": "Przytkowice",
                        "latitude": "49.91785000",
                        "longitude": "19.68570000"
                    },
                    {
                        "id": 87840,
                        "name": "Psary",
                        "latitude": "50.17242000",
                        "longitude": "19.52953000"
                    },
                    {
                        "id": 87869,
                        "name": "Raba Wyżna",
                        "latitude": "49.56681000",
                        "longitude": "19.87967000"
                    },
                    {
                        "id": 87870,
                        "name": "Rabka-Zdrój",
                        "latitude": "49.60889000",
                        "longitude": "19.96654000"
                    },
                    {
                        "id": 87877,
                        "name": "Racławice",
                        "latitude": "50.19344000",
                        "longitude": "19.67686000"
                    },
                    {
                        "id": 88036,
                        "name": "Rączna",
                        "latitude": "50.00984000",
                        "longitude": "19.76784000"
                    },
                    {
                        "id": 87880,
                        "name": "Radgoszcz",
                        "latitude": "50.20580000",
                        "longitude": "21.11315000"
                    },
                    {
                        "id": 87905,
                        "name": "Radłów",
                        "latitude": "50.08419000",
                        "longitude": "20.84967000"
                    },
                    {
                        "id": 87883,
                        "name": "Radocza",
                        "latitude": "49.91774000",
                        "longitude": "19.47498000"
                    },
                    {
                        "id": 87900,
                        "name": "Radziszów",
                        "latitude": "49.93531000",
                        "longitude": "19.81522000"
                    },
                    {
                        "id": 87908,
                        "name": "Rajsko",
                        "latitude": "50.01193000",
                        "longitude": "19.19294000"
                    },
                    {
                        "id": 87924,
                        "name": "Regulice",
                        "latitude": "50.08314000",
                        "longitude": "19.52785000"
                    },
                    {
                        "id": 87942,
                        "name": "Roczyny",
                        "latitude": "49.85370000",
                        "longitude": "19.31568000"
                    },
                    {
                        "id": 87953,
                        "name": "Rokiciny",
                        "latitude": "49.57243000",
                        "longitude": "19.92302000"
                    },
                    {
                        "id": 87960,
                        "name": "Ropa",
                        "latitude": "49.59146000",
                        "longitude": "21.04431000"
                    },
                    {
                        "id": 87973,
                        "name": "Rudawa",
                        "latitude": "50.12151000",
                        "longitude": "19.71239000"
                    },
                    {
                        "id": 87980,
                        "name": "Rudnik",
                        "latitude": "49.85243000",
                        "longitude": "19.84740000"
                    },
                    {
                        "id": 87989,
                        "name": "Rusocice",
                        "latitude": "49.99604000",
                        "longitude": "19.60648000"
                    },
                    {
                        "id": 88003,
                        "name": "Ryczów",
                        "latitude": "49.98103000",
                        "longitude": "19.55017000"
                    },
                    {
                        "id": 88006,
                        "name": "Ryglice",
                        "latitude": "49.87887000",
                        "longitude": "21.13748000"
                    },
                    {
                        "id": 88013,
                        "name": "Rytro",
                        "latitude": "49.48904000",
                        "longitude": "20.66631000"
                    },
                    {
                        "id": 88031,
                        "name": "Rząska",
                        "latitude": "50.09713000",
                        "longitude": "19.84509000"
                    },
                    {
                        "id": 88021,
                        "name": "Rzepiennik Strzyżewski",
                        "latitude": "49.80542000",
                        "longitude": "21.03599000"
                    },
                    {
                        "id": 88023,
                        "name": "Rzeszotary",
                        "latitude": "49.94625000",
                        "longitude": "19.97280000"
                    },
                    {
                        "id": 88026,
                        "name": "Rzezawa",
                        "latitude": "49.98997000",
                        "longitude": "20.51508000"
                    },
                    {
                        "id": 88029,
                        "name": "Rzozów",
                        "latitude": "49.95398000",
                        "longitude": "19.79668000"
                    },
                    {
                        "id": 88030,
                        "name": "Rzyki",
                        "latitude": "49.81129000",
                        "longitude": "19.39619000"
                    },
                    {
                        "id": 88047,
                        "name": "Sanka",
                        "latitude": "50.06871000",
                        "longitude": "19.64596000"
                    },
                    {
                        "id": 88326,
                        "name": "Sąspów",
                        "latitude": "50.22887000",
                        "longitude": "19.77007000"
                    },
                    {
                        "id": 88330,
                        "name": "Sękowa",
                        "latitude": "49.62217000",
                        "longitude": "21.19769000"
                    },
                    {
                        "id": 88061,
                        "name": "Sidzina",
                        "latitude": "49.59146000",
                        "longitude": "19.71119000"
                    },
                    {
                        "id": 88067,
                        "name": "Siedliska",
                        "latitude": "49.87163000",
                        "longitude": "20.99625000"
                    },
                    {
                        "id": 88073,
                        "name": "Siemiechów",
                        "latitude": "49.85359000",
                        "longitude": "20.90595000"
                    },
                    {
                        "id": 88078,
                        "name": "Sieniawa",
                        "latitude": "49.53947000",
                        "longitude": "19.93014000"
                    },
                    {
                        "id": 88084,
                        "name": "Siepraw",
                        "latitude": "49.91437000",
                        "longitude": "19.95864000"
                    },
                    {
                        "id": 88086,
                        "name": "Sieradza",
                        "latitude": "50.13499000",
                        "longitude": "20.92947000"
                    },
                    {
                        "id": 88105,
                        "name": "Skała",
                        "latitude": "50.23052000",
                        "longitude": "19.85363000"
                    },
                    {
                        "id": 88102,
                        "name": "Skawica",
                        "latitude": "49.67718000",
                        "longitude": "19.62321000"
                    },
                    {
                        "id": 88103,
                        "name": "Skawina",
                        "latitude": "49.97524000",
                        "longitude": "19.82869000"
                    },
                    {
                        "id": 88104,
                        "name": "Skawinki",
                        "latitude": "49.82281000",
                        "longitude": "19.71256000"
                    },
                    {
                        "id": 88110,
                        "name": "Skomielna Czarna",
                        "latitude": "49.72709000",
                        "longitude": "19.83633000"
                    },
                    {
                        "id": 88116,
                        "name": "Skrzydlna",
                        "latitude": "49.75343000",
                        "longitude": "20.18618000"
                    },
                    {
                        "id": 88117,
                        "name": "Skrzyszów",
                        "latitude": "49.99373000",
                        "longitude": "21.06139000"
                    },
                    {
                        "id": 88341,
                        "name": "Słomniki",
                        "latitude": "50.24012000",
                        "longitude": "20.08224000"
                    },
                    {
                        "id": 88342,
                        "name": "Słopnice",
                        "latitude": "49.68496000",
                        "longitude": "20.34325000"
                    },
                    {
                        "id": 88351,
                        "name": "Słupiec",
                        "latitude": "50.32787000",
                        "longitude": "21.19374000"
                    },
                    {
                        "id": 88128,
                        "name": "Smęgorzów",
                        "latitude": "50.22843000",
                        "longitude": "21.00414000"
                    },
                    {
                        "id": 88151,
                        "name": "Sosnowice",
                        "latitude": "49.93995000",
                        "longitude": "19.71514000"
                    },
                    {
                        "id": 88162,
                        "name": "Spytkowice",
                        "latitude": "49.99671000",
                        "longitude": "19.51103000"
                    },
                    {
                        "id": 88166,
                        "name": "Stanisław Dolny",
                        "latitude": "49.90470000",
                        "longitude": "19.65334000"
                    },
                    {
                        "id": 88167,
                        "name": "Stanisław Górny",
                        "latitude": "49.91155000",
                        "longitude": "19.62931000"
                    },
                    {
                        "id": 88168,
                        "name": "Stanisławice",
                        "latitude": "49.98550000",
                        "longitude": "20.35123000"
                    },
                    {
                        "id": 88194,
                        "name": "Stary Sącz",
                        "latitude": "49.56364000",
                        "longitude": "20.63496000"
                    },
                    {
                        "id": 88196,
                        "name": "Stary Wiśnicz",
                        "latitude": "49.92548000",
                        "longitude": "20.48641000"
                    },
                    {
                        "id": 88216,
                        "name": "Stronie",
                        "latitude": "49.83056000",
                        "longitude": "19.67497000"
                    },
                    {
                        "id": 88237,
                        "name": "Stróża",
                        "latitude": "49.79628000",
                        "longitude": "19.92379000"
                    },
                    {
                        "id": 88220,
                        "name": "Stryszawa",
                        "latitude": "49.71327000",
                        "longitude": "19.52185000"
                    },
                    {
                        "id": 88221,
                        "name": "Stryszów",
                        "latitude": "49.82569000",
                        "longitude": "19.61763000"
                    },
                    {
                        "id": 88248,
                        "name": "Sucha Beskidzka",
                        "latitude": "49.74188000",
                        "longitude": "19.59429000"
                    },
                    {
                        "id": 88262,
                        "name": "Sulęcin",
                        "latitude": "52.44429000",
                        "longitude": "15.11676000"
                    },
                    {
                        "id": 88271,
                        "name": "Sułkowice",
                        "latitude": "49.84053000",
                        "longitude": "19.80097000"
                    },
                    {
                        "id": 88272,
                        "name": "Sułoszowa",
                        "latitude": "50.26789000",
                        "longitude": "19.73282000"
                    },
                    {
                        "id": 88863,
                        "name": "Świątniki Górne",
                        "latitude": "49.93429000",
                        "longitude": "19.95364000"
                    },
                    {
                        "id": 88284,
                        "name": "Szaflary",
                        "latitude": "49.42655000",
                        "longitude": "20.02713000"
                    },
                    {
                        "id": 88287,
                        "name": "Szarów",
                        "latitude": "49.99505000",
                        "longitude": "20.26960000"
                    },
                    {
                        "id": 88290,
                        "name": "Szczawnica",
                        "latitude": "49.42437000",
                        "longitude": "20.48487000"
                    },
                    {
                        "id": 88299,
                        "name": "Szczucin",
                        "latitude": "50.30957000",
                        "longitude": "21.07444000"
                    },
                    {
                        "id": 88301,
                        "name": "Szczurowa",
                        "latitude": "50.11915000",
                        "longitude": "20.63610000"
                    },
                    {
                        "id": 88309,
                        "name": "Szerzyny",
                        "latitude": "49.80919000",
                        "longitude": "21.24670000"
                    },
                    {
                        "id": 88323,
                        "name": "Szynwałd",
                        "latitude": "49.96767000",
                        "longitude": "21.12293000"
                    },
                    {
                        "id": 88355,
                        "name": "Targanice",
                        "latitude": "49.80575000",
                        "longitude": "19.32444000"
                    },
                    {
                        "id": 88356,
                        "name": "Targowisko",
                        "latitude": "49.98473000",
                        "longitude": "20.29346000"
                    },
                    {
                        "id": 88365,
                        "name": "Tarnów",
                        "latitude": "50.01381000",
                        "longitude": "20.98698000"
                    },
                    {
                        "id": 88361,
                        "name": "Tarnowiec",
                        "latitude": "49.98164000",
                        "longitude": "20.98655000"
                    },
                    {
                        "id": 88372,
                        "name": "Tenczynek",
                        "latitude": "50.11986000",
                        "longitude": "19.61308000"
                    },
                    {
                        "id": 88376,
                        "name": "Tokarnia",
                        "latitude": "49.72720000",
                        "longitude": "19.87161000"
                    },
                    {
                        "id": 88378,
                        "name": "Tomaszkowice",
                        "latitude": "49.97918000",
                        "longitude": "20.09966000"
                    },
                    {
                        "id": 88381,
                        "name": "Tomice",
                        "latitude": "49.89773000",
                        "longitude": "19.48357000"
                    },
                    {
                        "id": 88382,
                        "name": "Toporzysko",
                        "latitude": "49.62495000",
                        "longitude": "19.80226000"
                    },
                    {
                        "id": 88414,
                        "name": "Trąbki",
                        "latitude": "49.96226000",
                        "longitude": "20.14240000"
                    },
                    {
                        "id": 88395,
                        "name": "Trzciana",
                        "latitude": "49.84485000",
                        "longitude": "20.37415000"
                    },
                    {
                        "id": 88407,
                        "name": "Trzebinia",
                        "latitude": "50.15931000",
                        "longitude": "19.46966000"
                    },
                    {
                        "id": 88410,
                        "name": "Trzebunia",
                        "latitude": "49.79146000",
                        "longitude": "19.84715000"
                    },
                    {
                        "id": 88412,
                        "name": "Trzemeśnia",
                        "latitude": "49.82752000",
                        "longitude": "20.02207000"
                    },
                    {
                        "id": 88419,
                        "name": "Tuchów",
                        "latitude": "49.89485000",
                        "longitude": "21.05407000"
                    },
                    {
                        "id": 88439,
                        "name": "Tylicz",
                        "latitude": "49.39598000",
                        "longitude": "21.02368000"
                    },
                    {
                        "id": 88440,
                        "name": "Tymbark",
                        "latitude": "49.72859000",
                        "longitude": "20.32539000"
                    },
                    {
                        "id": 88467,
                        "name": "Uście Gorlickie",
                        "latitude": "49.52192000",
                        "longitude": "21.13821000"
                    },
                    {
                        "id": 88469,
                        "name": "Wadowice",
                        "latitude": "49.88335000",
                        "longitude": "19.49292000"
                    },
                    {
                        "id": 88472,
                        "name": "Waksmund",
                        "latitude": "49.48207000",
                        "longitude": "20.07563000"
                    },
                    {
                        "id": 88486,
                        "name": "Wawrzeńczyce",
                        "latitude": "50.11012000",
                        "longitude": "20.31612000"
                    },
                    {
                        "id": 88640,
                        "name": "Węglówka",
                        "latitude": "49.73424000",
                        "longitude": "20.08575000"
                    },
                    {
                        "id": 88644,
                        "name": "Węgrzce Wielkie",
                        "latitude": "50.01491000",
                        "longitude": "20.11082000"
                    },
                    {
                        "id": 88502,
                        "name": "Wieliczka",
                        "latitude": "49.98738000",
                        "longitude": "20.06473000"
                    },
                    {
                        "id": 88505,
                        "name": "Wielka Wieś",
                        "latitude": "49.93631000",
                        "longitude": "20.82304000"
                    },
                    {
                        "id": 88514,
                        "name": "Wieprz",
                        "latitude": "49.89093000",
                        "longitude": "19.35688000"
                    },
                    {
                        "id": 88523,
                        "name": "Wierzchosławice",
                        "latitude": "50.02478000",
                        "longitude": "20.85677000"
                    },
                    {
                        "id": 88528,
                        "name": "Wietrzychowice",
                        "latitude": "50.19097000",
                        "longitude": "20.76502000"
                    },
                    {
                        "id": 88563,
                        "name": "Wiśniowa",
                        "latitude": "49.78780000",
                        "longitude": "20.11502000"
                    },
                    {
                        "id": 88548,
                        "name": "Witanowice",
                        "latitude": "49.91796000",
                        "longitude": "19.52579000"
                    },
                    {
                        "id": 88550,
                        "name": "Witkowice",
                        "latitude": "49.90746000",
                        "longitude": "19.27963000"
                    },
                    {
                        "id": 88652,
                        "name": "Włosienica",
                        "latitude": "50.01822000",
                        "longitude": "19.31671000"
                    },
                    {
                        "id": 88577,
                        "name": "Wojnicz",
                        "latitude": "49.95800000",
                        "longitude": "20.83785000"
                    },
                    {
                        "id": 88582,
                        "name": "Wola Batorska",
                        "latitude": "50.05262000",
                        "longitude": "20.26617000"
                    },
                    {
                        "id": 88583,
                        "name": "Wola Dębińska",
                        "latitude": "49.98214000",
                        "longitude": "20.68777000"
                    },
                    {
                        "id": 88584,
                        "name": "Wola Filipowska",
                        "latitude": "50.13433000",
                        "longitude": "19.58013000"
                    },
                    {
                        "id": 88587,
                        "name": "Wola Radziszowska",
                        "latitude": "49.90558000",
                        "longitude": "19.78827000"
                    },
                    {
                        "id": 88591,
                        "name": "Wola Zabierzowska",
                        "latitude": "50.07257000",
                        "longitude": "20.33217000"
                    },
                    {
                        "id": 88594,
                        "name": "Wolbrom",
                        "latitude": "50.37957000",
                        "longitude": "19.75831000"
                    },
                    {
                        "id": 88600,
                        "name": "Wołowice",
                        "latitude": "49.98876000",
                        "longitude": "19.72630000"
                    },
                    {
                        "id": 88602,
                        "name": "Woźniki",
                        "latitude": "49.93774000",
                        "longitude": "19.49078000"
                    },
                    {
                        "id": 88607,
                        "name": "Wrząsowice",
                        "latitude": "49.95862000",
                        "longitude": "19.94654000"
                    },
                    {
                        "id": 88616,
                        "name": "Wysoka",
                        "latitude": "49.90713000",
                        "longitude": "19.60356000"
                    },
                    {
                        "id": 88655,
                        "name": "Zabierzów",
                        "latitude": "50.11425000",
                        "longitude": "19.79788000"
                    },
                    {
                        "id": 88656,
                        "name": "Zabierzów Bocheński",
                        "latitude": "50.06821000",
                        "longitude": "20.31896000"
                    },
                    {
                        "id": 88871,
                        "name": "Żabno",
                        "latitude": "50.13334000",
                        "longitude": "20.88615000"
                    },
                    {
                        "id": 88657,
                        "name": "Zaborze",
                        "latitude": "50.02175000",
                        "longitude": "19.24067000"
                    },
                    {
                        "id": 88668,
                        "name": "Zagórnik",
                        "latitude": "49.83710000",
                        "longitude": "19.37868000"
                    },
                    {
                        "id": 88670,
                        "name": "Zagórze",
                        "latitude": "50.09449000",
                        "longitude": "19.40357000"
                    },
                    {
                        "id": 88673,
                        "name": "Zakliczyn",
                        "latitude": "49.85589000",
                        "longitude": "20.80935000"
                    },
                    {
                        "id": 88675,
                        "name": "Zakopane",
                        "latitude": "49.29899000",
                        "longitude": "19.94885000"
                    },
                    {
                        "id": 88680,
                        "name": "Zakrzów",
                        "latitude": "49.82558000",
                        "longitude": "19.64973000"
                    },
                    {
                        "id": 88683,
                        "name": "Zalas",
                        "latitude": "50.08033000",
                        "longitude": "19.62132000"
                    },
                    {
                        "id": 88874,
                        "name": "Żarki",
                        "latitude": "50.08259000",
                        "longitude": "19.35199000"
                    },
                    {
                        "id": 88698,
                        "name": "Zarzecze",
                        "latitude": "50.36715000",
                        "longitude": "19.69591000"
                    },
                    {
                        "id": 88699,
                        "name": "Zator",
                        "latitude": "49.99604000",
                        "longitude": "19.43799000"
                    },
                    {
                        "id": 88706,
                        "name": "Zawoja",
                        "latitude": "49.64396000",
                        "longitude": "19.54227000"
                    },
                    {
                        "id": 88720,
                        "name": "Zebrzydowice",
                        "latitude": "49.89032000",
                        "longitude": "19.67291000"
                    },
                    {
                        "id": 88879,
                        "name": "Żegocina",
                        "latitude": "49.81395000",
                        "longitude": "20.41964000"
                    },
                    {
                        "id": 88723,
                        "name": "Zembrzyce",
                        "latitude": "49.77517000",
                        "longitude": "19.60120000"
                    },
                    {
                        "id": 88730,
                        "name": "Zielonki",
                        "latitude": "50.12091000",
                        "longitude": "19.92156000"
                    },
                    {
                        "id": 88745,
                        "name": "Złota",
                        "latitude": "49.88059000",
                        "longitude": "20.69326000"
                    },
                    {
                        "id": 88733,
                        "name": "Zubrzyca Dolna",
                        "latitude": "49.52688000",
                        "longitude": "19.67342000"
                    },
                    {
                        "id": 88734,
                        "name": "Zubrzyca Górna",
                        "latitude": "49.56174000",
                        "longitude": "19.64973000"
                    },
                    {
                        "id": 88896,
                        "name": "Żurowa",
                        "latitude": "49.82636000",
                        "longitude": "21.16894000"
                    }
                ]
            },
            {
                "id": 1629,
                "name": "Lower Silesia",
                "iso2": "02",
                "latitude": "51.13398610",
                "longitude": "16.88419610",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85810,
                        "name": "Bardo",
                        "latitude": "50.50589000",
                        "longitude": "16.73986000"
                    },
                    {
                        "id": 85853,
                        "name": "Bielany Wrocławskie",
                        "latitude": "51.03610000",
                        "longitude": "16.96770000"
                    },
                    {
                        "id": 85854,
                        "name": "Bielawa",
                        "latitude": "50.69075000",
                        "longitude": "16.62300000"
                    },
                    {
                        "id": 85866,
                        "name": "Bierutów",
                        "latitude": "51.12443000",
                        "longitude": "17.54607000"
                    },
                    {
                        "id": 85875,
                        "name": "Biskupin",
                        "latitude": "51.10097000",
                        "longitude": "17.10442000"
                    },
                    {
                        "id": 85895,
                        "name": "Bogatynia",
                        "latitude": "50.90747000",
                        "longitude": "14.95634000"
                    },
                    {
                        "id": 85899,
                        "name": "Boguszów-Gorce",
                        "latitude": "50.75514000",
                        "longitude": "16.20494000"
                    },
                    {
                        "id": 85911,
                        "name": "Bolesławiec",
                        "latitude": "51.26418000",
                        "longitude": "15.56970000"
                    },
                    {
                        "id": 85914,
                        "name": "Bolków",
                        "latitude": "50.92203000",
                        "longitude": "16.10111000"
                    },
                    {
                        "id": 85932,
                        "name": "Bozkow",
                        "latitude": "50.51315000",
                        "longitude": "16.57528000"
                    },
                    {
                        "id": 85959,
                        "name": "Brzeg Dolny",
                        "latitude": "51.27299000",
                        "longitude": "16.70815000"
                    },
                    {
                        "id": 85985,
                        "name": "Budzów",
                        "latitude": "50.59337000",
                        "longitude": "16.71038000"
                    },
                    {
                        "id": 86002,
                        "name": "Bystrzyca",
                        "latitude": "50.96048000",
                        "longitude": "17.39702000"
                    },
                    {
                        "id": 86003,
                        "name": "Bystrzyca Kłodzka",
                        "latitude": "50.30179000",
                        "longitude": "16.64231000"
                    },
                    {
                        "id": 86039,
                        "name": "Chocianów",
                        "latitude": "51.41867000",
                        "longitude": "15.90172000"
                    },
                    {
                        "id": 86050,
                        "name": "Chojnów",
                        "latitude": "51.27373000",
                        "longitude": "15.93661000"
                    },
                    {
                        "id": 86080,
                        "name": "Ciechów",
                        "latitude": "51.13218000",
                        "longitude": "16.56773000"
                    },
                    {
                        "id": 86084,
                        "name": "Cieplice Śląskie Zdrój",
                        "latitude": "50.86545000",
                        "longitude": "15.68367000"
                    },
                    {
                        "id": 86085,
                        "name": "Ciepłowody",
                        "latitude": "50.67477000",
                        "longitude": "16.90871000"
                    },
                    {
                        "id": 86087,
                        "name": "Cieszków",
                        "latitude": "51.63104000",
                        "longitude": "17.35726000"
                    },
                    {
                        "id": 86117,
                        "name": "Czarny Bór",
                        "latitude": "50.77083000",
                        "longitude": "16.13050000"
                    },
                    {
                        "id": 86129,
                        "name": "Czernica",
                        "latitude": "51.04609000",
                        "longitude": "17.24510000"
                    },
                    {
                        "id": 86235,
                        "name": "Dąbie",
                        "latitude": "51.10573000",
                        "longitude": "17.08108000"
                    },
                    {
                        "id": 86261,
                        "name": "Długołęka",
                        "latitude": "51.17902000",
                        "longitude": "17.19137000"
                    },
                    {
                        "id": 86174,
                        "name": "Dobroszyce",
                        "latitude": "51.26776000",
                        "longitude": "17.34205000"
                    },
                    {
                        "id": 86209,
                        "name": "Duszniki-Zdrój",
                        "latitude": "50.40327000",
                        "longitude": "16.39091000"
                    },
                    {
                        "id": 86215,
                        "name": "Dziadowa Kłoda",
                        "latitude": "51.23543000",
                        "longitude": "17.70919000"
                    },
                    {
                        "id": 86227,
                        "name": "Dziećmorowice",
                        "latitude": "50.76947000",
                        "longitude": "16.35212000"
                    },
                    {
                        "id": 86225,
                        "name": "Dzierżoniów",
                        "latitude": "50.72820000",
                        "longitude": "16.65141000"
                    },
                    {
                        "id": 86423,
                        "name": "Gądów Mały",
                        "latitude": "51.11853000",
                        "longitude": "16.98596000"
                    },
                    {
                        "id": 86288,
                        "name": "Gaworzyce",
                        "latitude": "51.62773000",
                        "longitude": "15.88198000"
                    },
                    {
                        "id": 86427,
                        "name": "Głogów",
                        "latitude": "51.66361000",
                        "longitude": "16.08450000"
                    },
                    {
                        "id": 86435,
                        "name": "Głuszyca",
                        "latitude": "50.68743000",
                        "longitude": "16.37173000"
                    },
                    {
                        "id": 86436,
                        "name": "Głuszyca Górna",
                        "latitude": "50.66606000",
                        "longitude": "16.37585000"
                    },
                    {
                        "id": 86309,
                        "name": "Gniechowice",
                        "latitude": "50.98804000",
                        "longitude": "16.83363000"
                    },
                    {
                        "id": 86408,
                        "name": "Góra",
                        "latitude": "51.66638000",
                        "longitude": "16.53494000"
                    },
                    {
                        "id": 86363,
                        "name": "Grabiszyn",
                        "latitude": "51.09369000",
                        "longitude": "16.97819000"
                    },
                    {
                        "id": 86364,
                        "name": "Grabiszynek",
                        "latitude": "51.08703000",
                        "longitude": "16.98629000"
                    },
                    {
                        "id": 86401,
                        "name": "Grębocice",
                        "latitude": "51.59909000",
                        "longitude": "16.16741000"
                    },
                    {
                        "id": 86380,
                        "name": "Gromadka",
                        "latitude": "51.36063000",
                        "longitude": "15.76452000"
                    },
                    {
                        "id": 86392,
                        "name": "Gryfów Śląski",
                        "latitude": "51.03081000",
                        "longitude": "15.42017000"
                    },
                    {
                        "id": 86447,
                        "name": "Henryków",
                        "latitude": "50.65327000",
                        "longitude": "17.01027000"
                    },
                    {
                        "id": 86499,
                        "name": "Janowice Wielkie",
                        "latitude": "50.87569000",
                        "longitude": "15.92322000"
                    },
                    {
                        "id": 86507,
                        "name": "Jarnołtów-Jerzmanowo",
                        "latitude": "51.12163000",
                        "longitude": "16.86621000"
                    },
                    {
                        "id": 86531,
                        "name": "Jawor",
                        "latitude": "51.05132000",
                        "longitude": "16.19347000"
                    },
                    {
                        "id": 86537,
                        "name": "Jaworzyna Śląska",
                        "latitude": "50.91340000",
                        "longitude": "16.43241000"
                    },
                    {
                        "id": 86541,
                        "name": "Jedlina-Zdrój",
                        "latitude": "50.72005000",
                        "longitude": "16.34645000"
                    },
                    {
                        "id": 86548,
                        "name": "Jelcz",
                        "latitude": "51.02102000",
                        "longitude": "17.32095000"
                    },
                    {
                        "id": 86549,
                        "name": "Jelcz Laskowice",
                        "latitude": "51.02134000",
                        "longitude": "17.31649000"
                    },
                    {
                        "id": 86550,
                        "name": "Jelenia Góra",
                        "latitude": "50.89973000",
                        "longitude": "15.72899000"
                    },
                    {
                        "id": 86561,
                        "name": "Jeżów Sudecki",
                        "latitude": "50.93507000",
                        "longitude": "15.74306000"
                    },
                    {
                        "id": 86569,
                        "name": "Jordanów Śląski",
                        "latitude": "50.86421000",
                        "longitude": "16.86873000"
                    },
                    {
                        "id": 86570,
                        "name": "Jugów",
                        "latitude": "50.62758000",
                        "longitude": "16.51812000"
                    },
                    {
                        "id": 86594,
                        "name": "Kamieniec Wrocławski",
                        "latitude": "51.07182000",
                        "longitude": "17.18193000"
                    },
                    {
                        "id": 86595,
                        "name": "Kamieniec Ząbkowicki",
                        "latitude": "50.52541000",
                        "longitude": "16.87921000"
                    },
                    {
                        "id": 86596,
                        "name": "Kamienna Góra",
                        "latitude": "50.78314000",
                        "longitude": "16.03037000"
                    },
                    {
                        "id": 86618,
                        "name": "Karłowice",
                        "latitude": "51.14132000",
                        "longitude": "17.05212000"
                    },
                    {
                        "id": 86615,
                        "name": "Karpacz",
                        "latitude": "50.77669000",
                        "longitude": "15.75594000"
                    },
                    {
                        "id": 86852,
                        "name": "Kąty Wrocławskie",
                        "latitude": "51.03098000",
                        "longitude": "16.76767000"
                    },
                    {
                        "id": 86636,
                        "name": "Kiełczów",
                        "latitude": "51.13999000",
                        "longitude": "17.17798000"
                    },
                    {
                        "id": 86866,
                        "name": "Kłodzko",
                        "latitude": "50.43488000",
                        "longitude": "16.66145000"
                    },
                    {
                        "id": 86661,
                        "name": "Kobierzyce",
                        "latitude": "50.97054000",
                        "longitude": "16.93508000"
                    },
                    {
                        "id": 86722,
                        "name": "Kotla",
                        "latitude": "51.74542000",
                        "longitude": "16.03575000"
                    },
                    {
                        "id": 86729,
                        "name": "Kowale-Popiele",
                        "latitude": "51.13090000",
                        "longitude": "17.10175000"
                    },
                    {
                        "id": 86731,
                        "name": "Kowary",
                        "latitude": "50.79313000",
                        "longitude": "15.83559000"
                    },
                    {
                        "id": 86733,
                        "name": "Kozanów",
                        "latitude": "51.14447000",
                        "longitude": "16.96937000"
                    },
                    {
                        "id": 86789,
                        "name": "Krośnice",
                        "latitude": "51.47641000",
                        "longitude": "17.35917000"
                    },
                    {
                        "id": 86811,
                        "name": "Krzeszów",
                        "latitude": "50.73434000",
                        "longitude": "16.06991000"
                    },
                    {
                        "id": 86813,
                        "name": "Krzyki",
                        "latitude": "51.07085000",
                        "longitude": "16.99475000"
                    },
                    {
                        "id": 86831,
                        "name": "Księże Małe-Księże Wielkie",
                        "latitude": "51.07293000",
                        "longitude": "17.08881000"
                    },
                    {
                        "id": 86835,
                        "name": "Kudowa-Zdrój",
                        "latitude": "50.44297000",
                        "longitude": "16.24397000"
                    },
                    {
                        "id": 86837,
                        "name": "Kunice",
                        "latitude": "51.22231000",
                        "longitude": "16.24809000"
                    },
                    {
                        "id": 86977,
                        "name": "Lądek-Zdrój",
                        "latitude": "50.34371000",
                        "longitude": "16.87946000"
                    },
                    {
                        "id": 86877,
                        "name": "Legnica",
                        "latitude": "51.21006000",
                        "longitude": "16.16190000"
                    },
                    {
                        "id": 86878,
                        "name": "Legnickie Pole",
                        "latitude": "51.14419000",
                        "longitude": "16.24208000"
                    },
                    {
                        "id": 86889,
                        "name": "Leśna",
                        "latitude": "51.02431000",
                        "longitude": "15.26413000"
                    },
                    {
                        "id": 86893,
                        "name": "Leśnica-Ratyń-Pustki",
                        "latitude": "51.14228000",
                        "longitude": "16.84773000"
                    },
                    {
                        "id": 86886,
                        "name": "Lewin Kłodzki",
                        "latitude": "50.40559000",
                        "longitude": "16.29101000"
                    },
                    {
                        "id": 86936,
                        "name": "Lubań",
                        "latitude": "51.12014000",
                        "longitude": "15.28768000"
                    },
                    {
                        "id": 86935,
                        "name": "Lubawka",
                        "latitude": "50.70456000",
                        "longitude": "16.00026000"
                    },
                    {
                        "id": 86944,
                        "name": "Lubin",
                        "latitude": "51.40089000",
                        "longitude": "16.20149000"
                    },
                    {
                        "id": 86953,
                        "name": "Lubomierz",
                        "latitude": "51.01278000",
                        "longitude": "15.50969000"
                    },
                    {
                        "id": 86963,
                        "name": "Ludwikowice Kłodzkie",
                        "latitude": "50.62464000",
                        "longitude": "16.46052000"
                    },
                    {
                        "id": 86974,
                        "name": "Lwówek Śląski",
                        "latitude": "51.11074000",
                        "longitude": "15.58582000"
                    },
                    {
                        "id": 88758,
                        "name": "Łagiewniki",
                        "latitude": "50.79088000",
                        "longitude": "16.84457000"
                    },
                    {
                        "id": 88760,
                        "name": "Łagów",
                        "latitude": "51.15835000",
                        "longitude": "15.04372000"
                    },
                    {
                        "id": 86987,
                        "name": "Malczyce",
                        "latitude": "51.22038000",
                        "longitude": "16.49365000"
                    },
                    {
                        "id": 86991,
                        "name": "Marciszów",
                        "latitude": "50.84470000",
                        "longitude": "16.02116000"
                    },
                    {
                        "id": 86998,
                        "name": "Marszowice",
                        "latitude": "51.17198000",
                        "longitude": "16.88441000"
                    },
                    {
                        "id": 87011,
                        "name": "Maślice Małe",
                        "latitude": "51.14937000",
                        "longitude": "16.94191000"
                    },
                    {
                        "id": 87012,
                        "name": "Maślice Wielkie",
                        "latitude": "51.16333000",
                        "longitude": "16.92837000"
                    },
                    {
                        "id": 87060,
                        "name": "Międzybórz",
                        "latitude": "51.39626000",
                        "longitude": "17.66610000"
                    },
                    {
                        "id": 87063,
                        "name": "Międzylesie",
                        "latitude": "50.14778000",
                        "longitude": "16.66712000"
                    },
                    {
                        "id": 87068,
                        "name": "Miękinia",
                        "latitude": "51.18844000",
                        "longitude": "16.73595000"
                    },
                    {
                        "id": 87038,
                        "name": "Mieroszów",
                        "latitude": "50.66589000",
                        "longitude": "16.18883000"
                    },
                    {
                        "id": 87050,
                        "name": "Milicz",
                        "latitude": "51.52770000",
                        "longitude": "17.27137000"
                    },
                    {
                        "id": 87071,
                        "name": "Miłkowice",
                        "latitude": "51.25601000",
                        "longitude": "16.07231000"
                    },
                    {
                        "id": 87053,
                        "name": "Mirków",
                        "latitude": "51.16105000",
                        "longitude": "17.17026000"
                    },
                    {
                        "id": 87056,
                        "name": "Mirsk",
                        "latitude": "50.97054000",
                        "longitude": "15.38567000"
                    },
                    {
                        "id": 87103,
                        "name": "Mrozów",
                        "latitude": "51.18817000",
                        "longitude": "16.78831000"
                    },
                    {
                        "id": 87120,
                        "name": "Mysłakowice",
                        "latitude": "50.84123000",
                        "longitude": "15.77894000"
                    },
                    {
                        "id": 87163,
                        "name": "Niemcza",
                        "latitude": "50.72007000",
                        "longitude": "16.83573000"
                    },
                    {
                        "id": 87173,
                        "name": "Nowa Ruda",
                        "latitude": "50.58008000",
                        "longitude": "16.50164000"
                    },
                    {
                        "id": 87195,
                        "name": "Nowogrodziec",
                        "latitude": "51.19543000",
                        "longitude": "15.39854000"
                    },
                    {
                        "id": 87217,
                        "name": "Oborniki Śląskie",
                        "latitude": "51.30137000",
                        "longitude": "16.91465000"
                    },
                    {
                        "id": 87241,
                        "name": "Oleśnica",
                        "latitude": "51.21338000",
                        "longitude": "17.38986000"
                    },
                    {
                        "id": 87245,
                        "name": "Olszanica",
                        "latitude": "51.20672000",
                        "longitude": "15.80040000"
                    },
                    {
                        "id": 87250,
                        "name": "Olszyna",
                        "latitude": "51.06710000",
                        "longitude": "15.37228000"
                    },
                    {
                        "id": 87322,
                        "name": "Oława",
                        "latitude": "50.94660000",
                        "longitude": "17.29260000"
                    },
                    {
                        "id": 87280,
                        "name": "Osiedle Henrykowskie",
                        "latitude": "51.08999000",
                        "longitude": "17.05289000"
                    },
                    {
                        "id": 87281,
                        "name": "Osiedle Kosmonautów",
                        "latitude": "51.12753000",
                        "longitude": "16.96186000"
                    },
                    {
                        "id": 87286,
                        "name": "Osiek",
                        "latitude": "51.36717000",
                        "longitude": "16.23380000"
                    },
                    {
                        "id": 87298,
                        "name": "Ostroszowice",
                        "latitude": "50.64576000",
                        "longitude": "16.63965000"
                    },
                    {
                        "id": 87348,
                        "name": "Partynice",
                        "latitude": "51.06798000",
                        "longitude": "17.01394000"
                    },
                    {
                        "id": 87352,
                        "name": "Paszowice",
                        "latitude": "51.01078000",
                        "longitude": "16.15273000"
                    },
                    {
                        "id": 87358,
                        "name": "Pawłowice-Kłokoczyce",
                        "latitude": "51.16495000",
                        "longitude": "17.09822000"
                    },
                    {
                        "id": 87373,
                        "name": "Piechowice",
                        "latitude": "50.84963000",
                        "longitude": "15.59887000"
                    },
                    {
                        "id": 87386,
                        "name": "Pieńsk",
                        "latitude": "51.24900000",
                        "longitude": "15.04685000"
                    },
                    {
                        "id": 87383,
                        "name": "Pieszyce",
                        "latitude": "50.71287000",
                        "longitude": "16.58232000"
                    },
                    {
                        "id": 87389,
                        "name": "Pilczyce",
                        "latitude": "51.13704000",
                        "longitude": "16.95752000"
                    },
                    {
                        "id": 87404,
                        "name": "Piława Górna",
                        "latitude": "50.68357000",
                        "longitude": "16.74359000"
                    },
                    {
                        "id": 87396,
                        "name": "Pisarzowice",
                        "latitude": "51.14479000",
                        "longitude": "15.23057000"
                    },
                    {
                        "id": 87416,
                        "name": "Podgórzyn",
                        "latitude": "50.83261000",
                        "longitude": "15.68161000"
                    },
                    {
                        "id": 87430,
                        "name": "Polanica-Zdrój",
                        "latitude": "50.40373000",
                        "longitude": "16.51271000"
                    },
                    {
                        "id": 87436,
                        "name": "Polkowice",
                        "latitude": "51.50391000",
                        "longitude": "16.07261000"
                    },
                    {
                        "id": 87782,
                        "name": "Poświętne",
                        "latitude": "51.15702000",
                        "longitude": "17.02904000"
                    },
                    {
                        "id": 87471,
                        "name": "Powiat bolesławiecki",
                        "latitude": "51.32174000",
                        "longitude": "15.53215000"
                    },
                    {
                        "id": 87495,
                        "name": "Powiat dzierżoniowski",
                        "latitude": "50.73506000",
                        "longitude": "16.69192000"
                    },
                    {
                        "id": 87520,
                        "name": "Powiat głogowski",
                        "latitude": "51.67132000",
                        "longitude": "16.09486000"
                    },
                    {
                        "id": 87519,
                        "name": "Powiat górowski",
                        "latitude": "51.63666000",
                        "longitude": "16.54815000"
                    },
                    {
                        "id": 87530,
                        "name": "Powiat jaworski",
                        "latitude": "51.03967000",
                        "longitude": "16.16364000"
                    },
                    {
                        "id": 87531,
                        "name": "Powiat jeleniogórski",
                        "latitude": "50.89654000",
                        "longitude": "15.63835000"
                    },
                    {
                        "id": 87534,
                        "name": "Powiat kamiennogórski",
                        "latitude": "50.75603000",
                        "longitude": "16.00471000"
                    },
                    {
                        "id": 87563,
                        "name": "Powiat kłodzki",
                        "latitude": "50.38882000",
                        "longitude": "16.61185000"
                    },
                    {
                        "id": 87565,
                        "name": "Powiat legnicki",
                        "latitude": "51.24113000",
                        "longitude": "16.10744000"
                    },
                    {
                        "id": 87575,
                        "name": "Powiat lubański",
                        "latitude": "51.04506000",
                        "longitude": "15.27739000"
                    },
                    {
                        "id": 87577,
                        "name": "Powiat lubiński",
                        "latitude": "51.44172000",
                        "longitude": "16.24318000"
                    },
                    {
                        "id": 87579,
                        "name": "Powiat lwówecki",
                        "latitude": "51.01559000",
                        "longitude": "15.52144000"
                    },
                    {
                        "id": 87586,
                        "name": "Powiat milicki",
                        "latitude": "51.50792000",
                        "longitude": "17.28292000"
                    },
                    {
                        "id": 87612,
                        "name": "Powiat oleśnicki",
                        "latitude": "51.25458000",
                        "longitude": "17.51679000"
                    },
                    {
                        "id": 87626,
                        "name": "Powiat oławski",
                        "latitude": "50.96062000",
                        "longitude": "17.30601000"
                    },
                    {
                        "id": 87639,
                        "name": "Powiat polkowicki",
                        "latitude": "51.49982000",
                        "longitude": "16.01528000"
                    },
                    {
                        "id": 87756,
                        "name": "Powiat średzki",
                        "latitude": "51.12628000",
                        "longitude": "16.61904000"
                    },
                    {
                        "id": 87686,
                        "name": "Powiat strzeliński",
                        "latitude": "50.76688000",
                        "longitude": "17.10629000"
                    },
                    {
                        "id": 87759,
                        "name": "Powiat świdnicki",
                        "latitude": "50.87051000",
                        "longitude": "16.43043000"
                    },
                    {
                        "id": 87709,
                        "name": "Powiat trzebnicki",
                        "latitude": "51.37195000",
                        "longitude": "17.04989000"
                    },
                    {
                        "id": 87714,
                        "name": "Powiat wałbrzyski",
                        "latitude": "50.75340000",
                        "longitude": "16.19865000"
                    },
                    {
                        "id": 87723,
                        "name": "Powiat wołowski",
                        "latitude": "51.37202000",
                        "longitude": "16.61399000"
                    },
                    {
                        "id": 87724,
                        "name": "Powiat wrocławski",
                        "latitude": "51.04278000",
                        "longitude": "16.97115000"
                    },
                    {
                        "id": 87744,
                        "name": "Powiat ząbkowicki",
                        "latitude": "50.55669000",
                        "longitude": "16.87221000"
                    },
                    {
                        "id": 87741,
                        "name": "Powiat zgorzelecki",
                        "latitude": "51.16297000",
                        "longitude": "15.07863000"
                    },
                    {
                        "id": 87745,
                        "name": "Powiat złotoryjski",
                        "latitude": "51.09129000",
                        "longitude": "15.87948000"
                    },
                    {
                        "id": 87771,
                        "name": "Powstańców Śląskich Wschód",
                        "latitude": "51.09164000",
                        "longitude": "17.02470000"
                    },
                    {
                        "id": 87772,
                        "name": "Powstańców Śląskich Zachód-Centrum Południow",
                        "latitude": "51.09607000",
                        "longitude": "17.01770000"
                    },
                    {
                        "id": 87784,
                        "name": "Pracze Odrzańskie-Janówek",
                        "latitude": "51.18780000",
                        "longitude": "16.90824000"
                    },
                    {
                        "id": 87789,
                        "name": "Prochowice",
                        "latitude": "51.27307000",
                        "longitude": "16.36532000"
                    },
                    {
                        "id": 87796,
                        "name": "Prusice",
                        "latitude": "51.37116000",
                        "longitude": "16.96025000"
                    },
                    {
                        "id": 87811,
                        "name": "Przemków",
                        "latitude": "51.52530000",
                        "longitude": "15.79441000"
                    },
                    {
                        "id": 87815,
                        "name": "Przeworno",
                        "latitude": "50.68629000",
                        "longitude": "17.16588000"
                    },
                    {
                        "id": 87839,
                        "name": "Psary",
                        "latitude": "51.18712000",
                        "longitude": "17.03173000"
                    },
                    {
                        "id": 87841,
                        "name": "Psie Pole Południe-Kiełczów",
                        "latitude": "51.14783000",
                        "longitude": "17.12744000"
                    },
                    {
                        "id": 87881,
                        "name": "Radków",
                        "latitude": "50.50426000",
                        "longitude": "16.40061000"
                    },
                    {
                        "id": 87892,
                        "name": "Radwanice",
                        "latitude": "51.05413000",
                        "longitude": "17.10932000"
                    },
                    {
                        "id": 87917,
                        "name": "Ratowice",
                        "latitude": "51.03308000",
                        "longitude": "17.27205000"
                    },
                    {
                        "id": 87925,
                        "name": "Rejon alei Kromera",
                        "latitude": "51.13375000",
                        "longitude": "17.07107000"
                    },
                    {
                        "id": 87926,
                        "name": "Rejon placu Grunwaldzkiego",
                        "latitude": "51.11669000",
                        "longitude": "17.06126000"
                    },
                    {
                        "id": 87927,
                        "name": "Rejon placu Świętego Macieja",
                        "latitude": "51.12056000",
                        "longitude": "17.03761000"
                    },
                    {
                        "id": 87928,
                        "name": "Rejon ulicy Borowskiej-Południe",
                        "latitude": "51.07660000",
                        "longitude": "17.02582000"
                    },
                    {
                        "id": 87929,
                        "name": "Rejon ulicy Klęczkowskiej",
                        "latitude": "51.12970000",
                        "longitude": "17.03376000"
                    },
                    {
                        "id": 87930,
                        "name": "Rejon ulicy Mieleckiej",
                        "latitude": "51.09145000",
                        "longitude": "17.00207000"
                    },
                    {
                        "id": 87931,
                        "name": "Rejon ulicy Saperów",
                        "latitude": "51.08614000",
                        "longitude": "17.00050000"
                    },
                    {
                        "id": 87932,
                        "name": "Rejon ulicy Traugutta",
                        "latitude": "51.10247000",
                        "longitude": "17.04827000"
                    },
                    {
                        "id": 88034,
                        "name": "Różanka-Polanka",
                        "latitude": "51.14344000",
                        "longitude": "17.01987000"
                    },
                    {
                        "id": 87975,
                        "name": "Rudna",
                        "latitude": "51.50981000",
                        "longitude": "16.26363000"
                    },
                    {
                        "id": 88829,
                        "name": "Ścinawa",
                        "latitude": "51.41626000",
                        "longitude": "16.42510000"
                    },
                    {
                        "id": 88331,
                        "name": "Sępolno",
                        "latitude": "51.10995000",
                        "longitude": "17.10200000"
                    },
                    {
                        "id": 88063,
                        "name": "Siechnice",
                        "latitude": "51.03384000",
                        "longitude": "17.14743000"
                    },
                    {
                        "id": 88070,
                        "name": "Siekierczyn",
                        "latitude": "51.12217000",
                        "longitude": "15.19375000"
                    },
                    {
                        "id": 88125,
                        "name": "Smolec",
                        "latitude": "51.07322000",
                        "longitude": "16.88221000"
                    },
                    {
                        "id": 88133,
                        "name": "Sobótka",
                        "latitude": "50.89992000",
                        "longitude": "16.74441000"
                    },
                    {
                        "id": 88155,
                        "name": "Sołtysowice",
                        "latitude": "51.15282000",
                        "longitude": "17.07103000"
                    },
                    {
                        "id": 88154,
                        "name": "Sosnówka",
                        "latitude": "50.81830000",
                        "longitude": "15.72315000"
                    },
                    {
                        "id": 88839,
                        "name": "Środa Śląska",
                        "latitude": "51.16406000",
                        "longitude": "16.59508000"
                    },
                    {
                        "id": 88164,
                        "name": "Stabłowice",
                        "latitude": "51.15375000",
                        "longitude": "16.90020000"
                    },
                    {
                        "id": 88172,
                        "name": "Stanowice",
                        "latitude": "50.93106000",
                        "longitude": "16.37426000"
                    },
                    {
                        "id": 88175,
                        "name": "Stara Kamienica",
                        "latitude": "50.91602000",
                        "longitude": "15.57286000"
                    },
                    {
                        "id": 88182,
                        "name": "Stare Bogaczowice",
                        "latitude": "50.84752000",
                        "longitude": "16.19308000"
                    },
                    {
                        "id": 88208,
                        "name": "Stoszowice",
                        "latitude": "50.59986000",
                        "longitude": "16.73896000"
                    },
                    {
                        "id": 88209,
                        "name": "Strachocin-Wojnów",
                        "latitude": "51.10486000",
                        "longitude": "17.15073000"
                    },
                    {
                        "id": 88217,
                        "name": "Stronie Śląskie",
                        "latitude": "50.29554000",
                        "longitude": "16.87397000"
                    },
                    {
                        "id": 88224,
                        "name": "Strzegom",
                        "latitude": "50.96264000",
                        "longitude": "16.35006000"
                    },
                    {
                        "id": 88231,
                        "name": "Strzelin",
                        "latitude": "50.78157000",
                        "longitude": "17.06477000"
                    },
                    {
                        "id": 88259,
                        "name": "Sulików",
                        "latitude": "51.07624000",
                        "longitude": "15.06792000"
                    },
                    {
                        "id": 88274,
                        "name": "Sułów",
                        "latitude": "51.49966000",
                        "longitude": "17.16811000"
                    },
                    {
                        "id": 88842,
                        "name": "Świdnica",
                        "latitude": "50.84378000",
                        "longitude": "16.48859000"
                    },
                    {
                        "id": 88845,
                        "name": "Świebodzice",
                        "latitude": "50.85974000",
                        "longitude": "16.31966000"
                    },
                    {
                        "id": 88851,
                        "name": "Świeradów-Zdrój",
                        "latitude": "50.90920000",
                        "longitude": "15.34309000"
                    },
                    {
                        "id": 88857,
                        "name": "Świerzawa",
                        "latitude": "51.01375000",
                        "longitude": "15.89516000"
                    },
                    {
                        "id": 88865,
                        "name": "Święta Katarzyna",
                        "latitude": "51.02596000",
                        "longitude": "17.11464000"
                    },
                    {
                        "id": 88277,
                        "name": "Swojczyce",
                        "latitude": "51.11567000",
                        "longitude": "17.12535000"
                    },
                    {
                        "id": 88278,
                        "name": "Syców",
                        "latitude": "51.30814000",
                        "longitude": "17.71979000"
                    },
                    {
                        "id": 88291,
                        "name": "Szczawno-Zdrój",
                        "latitude": "50.80352000",
                        "longitude": "16.25655000"
                    },
                    {
                        "id": 88296,
                        "name": "Szczepanów",
                        "latitude": "51.19796000",
                        "longitude": "16.61064000"
                    },
                    {
                        "id": 88304,
                        "name": "Szczytna",
                        "latitude": "50.41343000",
                        "longitude": "16.44743000"
                    },
                    {
                        "id": 88310,
                        "name": "Szklarska Poręba",
                        "latitude": "50.82567000",
                        "longitude": "15.52274000"
                    },
                    {
                        "id": 88408,
                        "name": "Trzebnica",
                        "latitude": "51.31076000",
                        "longitude": "17.06331000"
                    },
                    {
                        "id": 88432,
                        "name": "Twardogóra",
                        "latitude": "51.36487000",
                        "longitude": "17.46878000"
                    },
                    {
                        "id": 88441,
                        "name": "Tyniec Mały",
                        "latitude": "51.01948000",
                        "longitude": "16.91998000"
                    },
                    {
                        "id": 88446,
                        "name": "Uciechów",
                        "latitude": "50.75487000",
                        "longitude": "16.68175000"
                    },
                    {
                        "id": 88447,
                        "name": "Udanin",
                        "latitude": "51.03740000",
                        "longitude": "16.45469000"
                    },
                    {
                        "id": 88475,
                        "name": "Walim",
                        "latitude": "50.69749000",
                        "longitude": "16.44482000"
                    },
                    {
                        "id": 88487,
                        "name": "Wałbrzych",
                        "latitude": "50.77141000",
                        "longitude": "16.28432000"
                    },
                    {
                        "id": 88636,
                        "name": "Wąsosz",
                        "latitude": "51.56224000",
                        "longitude": "16.69059000"
                    },
                    {
                        "id": 88639,
                        "name": "Węgliniec",
                        "latitude": "51.28753000",
                        "longitude": "15.22894000"
                    },
                    {
                        "id": 88556,
                        "name": "Wiązów",
                        "latitude": "50.81399000",
                        "longitude": "17.20214000"
                    },
                    {
                        "id": 88495,
                        "name": "Widawa-Lipa Piotrowska-Polanowice",
                        "latitude": "51.17093000",
                        "longitude": "17.02164000"
                    },
                    {
                        "id": 88521,
                        "name": "Wierzbno",
                        "latitude": "50.93674000",
                        "longitude": "17.17961000"
                    },
                    {
                        "id": 88535,
                        "name": "Wilczyce",
                        "latitude": "51.12944000",
                        "longitude": "17.15472000"
                    },
                    {
                        "id": 88543,
                        "name": "Wilków",
                        "latitude": "51.09212000",
                        "longitude": "15.92824000"
                    },
                    {
                        "id": 88559,
                        "name": "Wińsko",
                        "latitude": "51.47032000",
                        "longitude": "16.61390000"
                    },
                    {
                        "id": 88565,
                        "name": "Wleń",
                        "latitude": "51.01635000",
                        "longitude": "15.67474000"
                    },
                    {
                        "id": 88575,
                        "name": "Wojcieszów",
                        "latitude": "50.95194000",
                        "longitude": "15.92185000"
                    },
                    {
                        "id": 88578,
                        "name": "Wojszyce",
                        "latitude": "51.05837000",
                        "longitude": "17.04513000"
                    },
                    {
                        "id": 88601,
                        "name": "Wołów",
                        "latitude": "51.33656000",
                        "longitude": "16.64429000"
                    },
                    {
                        "id": 88604,
                        "name": "Wrocław",
                        "latitude": "51.10810000",
                        "longitude": "17.03859000"
                    },
                    {
                        "id": 88739,
                        "name": "Ząbkowice Śląskie",
                        "latitude": "50.58969000",
                        "longitude": "16.81239000"
                    },
                    {
                        "id": 88664,
                        "name": "Zacisze",
                        "latitude": "51.12303000",
                        "longitude": "17.07465000"
                    },
                    {
                        "id": 88667,
                        "name": "Zagrodno",
                        "latitude": "51.19134000",
                        "longitude": "15.86533000"
                    },
                    {
                        "id": 88681,
                        "name": "Zakrzów",
                        "latitude": "51.16624000",
                        "longitude": "17.13688000"
                    },
                    {
                        "id": 88686,
                        "name": "Zalesie i Stadion",
                        "latitude": "51.11970000",
                        "longitude": "17.09194000"
                    },
                    {
                        "id": 88878,
                        "name": "Żarów",
                        "latitude": "50.94116000",
                        "longitude": "16.49466000"
                    },
                    {
                        "id": 88886,
                        "name": "Żerniki Wrocławskie",
                        "latitude": "51.03308000",
                        "longitude": "17.05662000"
                    },
                    {
                        "id": 88725,
                        "name": "Zgorzelec",
                        "latitude": "51.14942000",
                        "longitude": "15.00835000"
                    },
                    {
                        "id": 88726,
                        "name": "Zgorzelisko",
                        "latitude": "51.13833000",
                        "longitude": "17.13365000"
                    },
                    {
                        "id": 88731,
                        "name": "Ziębice",
                        "latitude": "50.60122000",
                        "longitude": "17.04065000"
                    },
                    {
                        "id": 88747,
                        "name": "Złotniki",
                        "latitude": "51.13769000",
                        "longitude": "16.88923000"
                    },
                    {
                        "id": 88749,
                        "name": "Złotoryja",
                        "latitude": "51.12637000",
                        "longitude": "15.91979000"
                    },
                    {
                        "id": 88750,
                        "name": "Złoty Stok",
                        "latitude": "50.44472000",
                        "longitude": "16.87586000"
                    },
                    {
                        "id": 88887,
                        "name": "Żmigród",
                        "latitude": "51.46672000",
                        "longitude": "16.90564000"
                    },
                    {
                        "id": 88902,
                        "name": "Żórawina",
                        "latitude": "50.98080000",
                        "longitude": "17.03671000"
                    }
                ]
            },
            {
                "id": 1638,
                "name": "Lublin",
                "iso2": "06",
                "latitude": "51.24935190",
                "longitude": "23.10113920",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85775,
                        "name": "Abramów",
                        "latitude": "51.45647000",
                        "longitude": "22.31521000"
                    },
                    {
                        "id": 85776,
                        "name": "Adamów",
                        "latitude": "51.74335000",
                        "longitude": "22.26414000"
                    },
                    {
                        "id": 85779,
                        "name": "Aleksandrów",
                        "latitude": "50.46630000",
                        "longitude": "22.89225000"
                    },
                    {
                        "id": 85786,
                        "name": "Annopol",
                        "latitude": "50.88551000",
                        "longitude": "21.85678000"
                    },
                    {
                        "id": 85804,
                        "name": "Baranów",
                        "latitude": "51.55786000",
                        "longitude": "22.13625000"
                    },
                    {
                        "id": 85818,
                        "name": "Batorz",
                        "latitude": "50.85050000",
                        "longitude": "22.49313000"
                    },
                    {
                        "id": 85831,
                        "name": "Bełżec",
                        "latitude": "50.38453000",
                        "longitude": "23.43839000"
                    },
                    {
                        "id": 85832,
                        "name": "Bełżyce",
                        "latitude": "51.17415000",
                        "longitude": "22.28027000"
                    },
                    {
                        "id": 85836,
                        "name": "Biała Podlaska",
                        "latitude": "52.03238000",
                        "longitude": "23.11652000"
                    },
                    {
                        "id": 85878,
                        "name": "Biłgoraj",
                        "latitude": "50.54114000",
                        "longitude": "22.72204000"
                    },
                    {
                        "id": 85876,
                        "name": "Biszcza",
                        "latitude": "50.40146000",
                        "longitude": "22.65063000"
                    },
                    {
                        "id": 85920,
                        "name": "Borki",
                        "latitude": "51.72161000",
                        "longitude": "22.52129000"
                    },
                    {
                        "id": 85928,
                        "name": "Borzechów",
                        "latitude": "51.09258000",
                        "longitude": "22.28414000"
                    },
                    {
                        "id": 85997,
                        "name": "Bychawa",
                        "latitude": "51.01608000",
                        "longitude": "22.53296000"
                    },
                    {
                        "id": 86027,
                        "name": "Chełm",
                        "latitude": "51.14312000",
                        "longitude": "23.47160000"
                    },
                    {
                        "id": 86045,
                        "name": "Chodel",
                        "latitude": "51.11177000",
                        "longitude": "22.13269000"
                    },
                    {
                        "id": 86061,
                        "name": "Chrzanów",
                        "latitude": "50.77256000",
                        "longitude": "22.60351000"
                    },
                    {
                        "id": 86097,
                        "name": "Cyców",
                        "latitude": "51.29928000",
                        "longitude": "23.14124000"
                    },
                    {
                        "id": 86124,
                        "name": "Czemierniki",
                        "latitude": "51.67298000",
                        "longitude": "22.63887000"
                    },
                    {
                        "id": 86248,
                        "name": "Dęblin",
                        "latitude": "51.55912000",
                        "longitude": "21.84829000"
                    },
                    {
                        "id": 86253,
                        "name": "Dębowa Kłoda",
                        "latitude": "51.59446000",
                        "longitude": "23.00640000"
                    },
                    {
                        "id": 86192,
                        "name": "Dołhobyczów",
                        "latitude": "50.58591000",
                        "longitude": "24.03594000"
                    },
                    {
                        "id": 86190,
                        "name": "Dorohusk",
                        "latitude": "51.15475000",
                        "longitude": "23.80325000"
                    },
                    {
                        "id": 86196,
                        "name": "Drelów",
                        "latitude": "51.91219000",
                        "longitude": "22.87165000"
                    },
                    {
                        "id": 86205,
                        "name": "Dubienka",
                        "latitude": "51.04862000",
                        "longitude": "23.89252000"
                    },
                    {
                        "id": 86232,
                        "name": "Dzwola",
                        "latitude": "50.69657000",
                        "longitude": "22.56729000"
                    },
                    {
                        "id": 86267,
                        "name": "Fajsławice",
                        "latitude": "51.09592000",
                        "longitude": "22.96323000"
                    },
                    {
                        "id": 86271,
                        "name": "Firlej",
                        "latitude": "51.55882000",
                        "longitude": "22.50841000"
                    },
                    {
                        "id": 86273,
                        "name": "Frampol",
                        "latitude": "50.67159000",
                        "longitude": "22.67061000"
                    },
                    {
                        "id": 86282,
                        "name": "Garbów",
                        "latitude": "51.35517000",
                        "longitude": "22.32937000"
                    },
                    {
                        "id": 86320,
                        "name": "Godziszów",
                        "latitude": "50.74889000",
                        "longitude": "22.49794000"
                    },
                    {
                        "id": 86321,
                        "name": "Godziszów Pierwszy",
                        "latitude": "50.75753000",
                        "longitude": "22.48386000"
                    },
                    {
                        "id": 86332,
                        "name": "Goraj",
                        "latitude": "50.72184000",
                        "longitude": "22.66651000"
                    },
                    {
                        "id": 86337,
                        "name": "Gorzków",
                        "latitude": "50.94778000",
                        "longitude": "23.01267000"
                    },
                    {
                        "id": 86360,
                        "name": "Gościeradów",
                        "latitude": "50.86859000",
                        "longitude": "22.00536000"
                    },
                    {
                        "id": 86365,
                        "name": "Grabowiec",
                        "latitude": "50.82090000",
                        "longitude": "23.55057000"
                    },
                    {
                        "id": 86444,
                        "name": "Hańsk",
                        "latitude": "51.41286000",
                        "longitude": "23.39942000"
                    },
                    {
                        "id": 86450,
                        "name": "Horodło",
                        "latitude": "50.89459000",
                        "longitude": "24.03723000"
                    },
                    {
                        "id": 86452,
                        "name": "Hrubieszów",
                        "latitude": "50.80502000",
                        "longitude": "23.89251000"
                    },
                    {
                        "id": 86468,
                        "name": "Izbica",
                        "latitude": "50.88728000",
                        "longitude": "23.15248000"
                    },
                    {
                        "id": 86486,
                        "name": "Jabłoń",
                        "latitude": "51.72501000",
                        "longitude": "23.08743000"
                    },
                    {
                        "id": 86481,
                        "name": "Jabłonna",
                        "latitude": "51.08875000",
                        "longitude": "22.59364000"
                    },
                    {
                        "id": 86491,
                        "name": "Jakubowice Murowane",
                        "latitude": "51.26992000",
                        "longitude": "22.63415000"
                    },
                    {
                        "id": 86503,
                        "name": "Janów Lubelski",
                        "latitude": "50.70695000",
                        "longitude": "22.41039000"
                    },
                    {
                        "id": 86504,
                        "name": "Janów Podlaski",
                        "latitude": "52.19398000",
                        "longitude": "23.21218000"
                    },
                    {
                        "id": 86500,
                        "name": "Janowiec",
                        "latitude": "51.32359000",
                        "longitude": "21.88940000"
                    },
                    {
                        "id": 86506,
                        "name": "Jarczów",
                        "latitude": "50.42438000",
                        "longitude": "23.58576000"
                    },
                    {
                        "id": 86521,
                        "name": "Jastków",
                        "latitude": "51.30411000",
                        "longitude": "22.43546000"
                    },
                    {
                        "id": 86557,
                        "name": "Jeziorzany",
                        "latitude": "51.60245000",
                        "longitude": "22.27667000"
                    },
                    {
                        "id": 86575,
                        "name": "Józefów",
                        "latitude": "50.48119000",
                        "longitude": "23.05404000"
                    },
                    {
                        "id": 86577,
                        "name": "Józefów nad Wisłą",
                        "latitude": "51.04183000",
                        "longitude": "21.83018000"
                    },
                    {
                        "id": 86603,
                        "name": "Kamionka",
                        "latitude": "51.47165000",
                        "longitude": "22.46275000"
                    },
                    {
                        "id": 86610,
                        "name": "Karczmiska",
                        "latitude": "51.22952000",
                        "longitude": "21.98158000"
                    },
                    {
                        "id": 86626,
                        "name": "Kazimierz Dolny",
                        "latitude": "51.31911000",
                        "longitude": "21.95502000"
                    },
                    {
                        "id": 86863,
                        "name": "Kłoczew",
                        "latitude": "51.72134000",
                        "longitude": "21.96493000"
                    },
                    {
                        "id": 86672,
                        "name": "Kock",
                        "latitude": "51.63997000",
                        "longitude": "22.44391000"
                    },
                    {
                        "id": 86674,
                        "name": "Kodeń",
                        "latitude": "51.91171000",
                        "longitude": "23.60301000"
                    },
                    {
                        "id": 86683,
                        "name": "Komarów-Osada",
                        "latitude": "50.62888000",
                        "longitude": "23.47740000"
                    },
                    {
                        "id": 86684,
                        "name": "Komarówka Podlaska",
                        "latitude": "51.80315000",
                        "longitude": "22.94392000"
                    },
                    {
                        "id": 86751,
                        "name": "Końskowola",
                        "latitude": "51.40922000",
                        "longitude": "22.05175000"
                    },
                    {
                        "id": 86697,
                        "name": "Konstantynów",
                        "latitude": "52.20746000",
                        "longitude": "23.08530000"
                    },
                    {
                        "id": 86736,
                        "name": "Kozubszczyzna",
                        "latitude": "51.22323000",
                        "longitude": "22.42747000"
                    },
                    {
                        "id": 86776,
                        "name": "Kraśniczyn",
                        "latitude": "50.93171000",
                        "longitude": "23.34929000"
                    },
                    {
                        "id": 86777,
                        "name": "Kraśnik",
                        "latitude": "50.92360000",
                        "longitude": "22.22706000"
                    },
                    {
                        "id": 86770,
                        "name": "Krasnobród",
                        "latitude": "50.54551000",
                        "longitude": "23.21308000"
                    },
                    {
                        "id": 86773,
                        "name": "Krasnystaw",
                        "latitude": "50.98464000",
                        "longitude": "23.17420000"
                    },
                    {
                        "id": 86796,
                        "name": "Krynice",
                        "latitude": "50.58760000",
                        "longitude": "23.38157000"
                    },
                    {
                        "id": 86802,
                        "name": "Krzczonów",
                        "latitude": "51.00727000",
                        "longitude": "22.71097000"
                    },
                    {
                        "id": 86819,
                        "name": "Krzywda",
                        "latitude": "51.79519000",
                        "longitude": "22.19994000"
                    },
                    {
                        "id": 86832,
                        "name": "Księżomierz",
                        "latitude": "50.90855000",
                        "longitude": "21.98965000"
                    },
                    {
                        "id": 86833,
                        "name": "Księżpol",
                        "latitude": "50.42323000",
                        "longitude": "22.73526000"
                    },
                    {
                        "id": 86843,
                        "name": "Kurów",
                        "latitude": "51.38941000",
                        "longitude": "22.18637000"
                    },
                    {
                        "id": 86890,
                        "name": "Leśna Podlaska",
                        "latitude": "52.13317000",
                        "longitude": "23.02786000"
                    },
                    {
                        "id": 86932,
                        "name": "Lubartów",
                        "latitude": "51.46026000",
                        "longitude": "22.60952000"
                    },
                    {
                        "id": 86947,
                        "name": "Lublin",
                        "latitude": "51.25000000",
                        "longitude": "22.56667000"
                    },
                    {
                        "id": 86962,
                        "name": "Lubycza Królewska",
                        "latitude": "50.34102000",
                        "longitude": "23.51941000"
                    },
                    {
                        "id": 86964,
                        "name": "Ludwin",
                        "latitude": "51.34605000",
                        "longitude": "22.90581000"
                    },
                    {
                        "id": 88757,
                        "name": "Łabunie",
                        "latitude": "50.65517000",
                        "longitude": "23.36620000"
                    },
                    {
                        "id": 88772,
                        "name": "Łaszczów",
                        "latitude": "50.53332000",
                        "longitude": "23.72562000"
                    },
                    {
                        "id": 88773,
                        "name": "Łaziska",
                        "latitude": "51.14226000",
                        "longitude": "21.87919000"
                    },
                    {
                        "id": 88816,
                        "name": "Łęczna",
                        "latitude": "51.30121000",
                        "longitude": "22.88135000"
                    },
                    {
                        "id": 88784,
                        "name": "Łomazy",
                        "latitude": "51.90435000",
                        "longitude": "23.17656000"
                    },
                    {
                        "id": 88788,
                        "name": "Łopiennik Górny",
                        "latitude": "51.04080000",
                        "longitude": "23.01833000"
                    },
                    {
                        "id": 88805,
                        "name": "Łuków",
                        "latitude": "51.92900000",
                        "longitude": "22.37956000"
                    },
                    {
                        "id": 88803,
                        "name": "Łukowa",
                        "latitude": "50.37426000",
                        "longitude": "22.94349000"
                    },
                    {
                        "id": 86996,
                        "name": "Markuszów",
                        "latitude": "51.37457000",
                        "longitude": "22.25804000"
                    },
                    {
                        "id": 87014,
                        "name": "Mełgiew",
                        "latitude": "51.22519000",
                        "longitude": "22.78414000"
                    },
                    {
                        "id": 87058,
                        "name": "Miączyn",
                        "latitude": "50.73825000",
                        "longitude": "23.50130000"
                    },
                    {
                        "id": 87022,
                        "name": "Michałów",
                        "latitude": "50.54709000",
                        "longitude": "23.60361000"
                    },
                    {
                        "id": 87025,
                        "name": "Michów",
                        "latitude": "51.52573000",
                        "longitude": "22.31435000"
                    },
                    {
                        "id": 87064,
                        "name": "Międzyrzec Podlaski",
                        "latitude": "51.98640000",
                        "longitude": "22.78248000"
                    },
                    {
                        "id": 87046,
                        "name": "Milanów",
                        "latitude": "51.70374000",
                        "longitude": "22.88830000"
                    },
                    {
                        "id": 87049,
                        "name": "Milejów",
                        "latitude": "51.23226000",
                        "longitude": "22.92443000"
                    },
                    {
                        "id": 87052,
                        "name": "Mircze",
                        "latitude": "50.65164000",
                        "longitude": "23.89604000"
                    },
                    {
                        "id": 87081,
                        "name": "Modliborzyce",
                        "latitude": "50.75416000",
                        "longitude": "22.32945000"
                    },
                    {
                        "id": 87143,
                        "name": "Nałęczów",
                        "latitude": "51.28581000",
                        "longitude": "22.21539000"
                    },
                    {
                        "id": 87155,
                        "name": "Niedrzwica Duża",
                        "latitude": "51.11462000",
                        "longitude": "22.38911000"
                    },
                    {
                        "id": 87157,
                        "name": "Niedźwiada",
                        "latitude": "51.54409000",
                        "longitude": "22.69140000"
                    },
                    {
                        "id": 87161,
                        "name": "Nielisz",
                        "latitude": "50.80067000",
                        "longitude": "23.04451000"
                    },
                    {
                        "id": 87162,
                        "name": "Niemce",
                        "latitude": "51.36155000",
                        "longitude": "22.63939000"
                    },
                    {
                        "id": 87193,
                        "name": "Nowodwór",
                        "latitude": "51.63901000",
                        "longitude": "22.10183000"
                    },
                    {
                        "id": 87222,
                        "name": "Obsza",
                        "latitude": "50.31520000",
                        "longitude": "22.95688000"
                    },
                    {
                        "id": 87263,
                        "name": "Opole Lubelskie",
                        "latitude": "51.14775000",
                        "longitude": "21.96897000"
                    },
                    {
                        "id": 87309,
                        "name": "Ostrów Lubelski",
                        "latitude": "51.49416000",
                        "longitude": "22.85287000"
                    },
                    {
                        "id": 87313,
                        "name": "Ostrówek",
                        "latitude": "51.58150000",
                        "longitude": "22.61227000"
                    },
                    {
                        "id": 87347,
                        "name": "Parczew",
                        "latitude": "51.64021000",
                        "longitude": "22.90057000"
                    },
                    {
                        "id": 87370,
                        "name": "Piaski",
                        "latitude": "51.13892000",
                        "longitude": "22.84856000"
                    },
                    {
                        "id": 87399,
                        "name": "Piszczac",
                        "latitude": "51.98118000",
                        "longitude": "23.37719000"
                    },
                    {
                        "id": 87414,
                        "name": "Podedwórze",
                        "latitude": "51.68815000",
                        "longitude": "23.19961000"
                    },
                    {
                        "id": 87428,
                        "name": "Pokrówka",
                        "latitude": "51.09479000",
                        "longitude": "23.46345000"
                    },
                    {
                        "id": 87439,
                        "name": "Poniatowa",
                        "latitude": "51.17983000",
                        "longitude": "22.13093000"
                    },
                    {
                        "id": 87452,
                        "name": "Potok Górny",
                        "latitude": "50.38477000",
                        "longitude": "22.56188000"
                    },
                    {
                        "id": 87453,
                        "name": "Potok Wielki",
                        "latitude": "50.79150000",
                        "longitude": "22.21642000"
                    },
                    {
                        "id": 87461,
                        "name": "Powiat bialski",
                        "latitude": "51.97222000",
                        "longitude": "23.15328000"
                    },
                    {
                        "id": 87469,
                        "name": "Powiat biłgorajski",
                        "latitude": "50.58582000",
                        "longitude": "22.79513000"
                    },
                    {
                        "id": 87483,
                        "name": "Powiat chełmski",
                        "latitude": "51.15092000",
                        "longitude": "23.38165000"
                    },
                    {
                        "id": 87523,
                        "name": "Powiat hrubieszowski",
                        "latitude": "50.70776000",
                        "longitude": "23.86307000"
                    },
                    {
                        "id": 87526,
                        "name": "Powiat janowski",
                        "latitude": "50.74558000",
                        "longitude": "22.41147000"
                    },
                    {
                        "id": 87553,
                        "name": "Powiat kraśnicki",
                        "latitude": "50.91535000",
                        "longitude": "22.14576000"
                    },
                    {
                        "id": 87552,
                        "name": "Powiat krasnostawski",
                        "latitude": "50.98486000",
                        "longitude": "23.17514000"
                    },
                    {
                        "id": 87574,
                        "name": "Powiat lubartowski",
                        "latitude": "51.53497000",
                        "longitude": "22.60585000"
                    },
                    {
                        "id": 87576,
                        "name": "Powiat lubelski",
                        "latitude": "51.13419000",
                        "longitude": "22.46654000"
                    },
                    {
                        "id": 87755,
                        "name": "Powiat łęczyński",
                        "latitude": "51.30429000",
                        "longitude": "22.96701000"
                    },
                    {
                        "id": 87752,
                        "name": "Powiat łukowski",
                        "latitude": "51.85365000",
                        "longitude": "22.24035000"
                    },
                    {
                        "id": 87617,
                        "name": "Powiat opolski",
                        "latitude": "51.12904000",
                        "longitude": "22.00944000"
                    },
                    {
                        "id": 87630,
                        "name": "Powiat parczewski",
                        "latitude": "51.59982000",
                        "longitude": "22.99629000"
                    },
                    {
                        "id": 87650,
                        "name": "Powiat puławski",
                        "latitude": "51.41853000",
                        "longitude": "22.03752000"
                    },
                    {
                        "id": 87659,
                        "name": "Powiat radzyński",
                        "latitude": "51.78255000",
                        "longitude": "22.70758000"
                    },
                    {
                        "id": 87664,
                        "name": "Powiat rycki",
                        "latitude": "51.66219000",
                        "longitude": "21.92929000"
                    },
                    {
                        "id": 87760,
                        "name": "Powiat świdnicki",
                        "latitude": "51.12470000",
                        "longitude": "22.85397000"
                    },
                    {
                        "id": 87706,
                        "name": "Powiat tomaszowski",
                        "latitude": "50.47825000",
                        "longitude": "23.52083000"
                    },
                    {
                        "id": 87734,
                        "name": "Powiat włodawski",
                        "latitude": "51.52267000",
                        "longitude": "23.38279000"
                    },
                    {
                        "id": 87737,
                        "name": "Powiat zamojski",
                        "latitude": "50.69160000",
                        "longitude": "23.21261000"
                    },
                    {
                        "id": 87832,
                        "name": "Przytoczno",
                        "latitude": "51.61951000",
                        "longitude": "22.27135000"
                    },
                    {
                        "id": 87846,
                        "name": "Puchaczów",
                        "latitude": "51.31050000",
                        "longitude": "22.97370000"
                    },
                    {
                        "id": 87851,
                        "name": "Puławy",
                        "latitude": "51.41655000",
                        "longitude": "21.96939000"
                    },
                    {
                        "id": 87871,
                        "name": "Rachanie",
                        "latitude": "50.53842000",
                        "longitude": "23.54688000"
                    },
                    {
                        "id": 87879,
                        "name": "Radecznica",
                        "latitude": "50.75155000",
                        "longitude": "22.82976000"
                    },
                    {
                        "id": 87904,
                        "name": "Radzyń Podlaski",
                        "latitude": "51.78333000",
                        "longitude": "22.61667000"
                    },
                    {
                        "id": 87933,
                        "name": "Rejowiec",
                        "latitude": "51.09134000",
                        "longitude": "23.28192000"
                    },
                    {
                        "id": 87934,
                        "name": "Rejowiec Fabryczny",
                        "latitude": "51.11414000",
                        "longitude": "23.24724000"
                    },
                    {
                        "id": 87951,
                        "name": "Rogóźno",
                        "latitude": "50.46417000",
                        "longitude": "23.39041000"
                    },
                    {
                        "id": 87958,
                        "name": "Rokitno",
                        "latitude": "52.12142000",
                        "longitude": "23.29514000"
                    },
                    {
                        "id": 87972,
                        "name": "Ruda-Huta",
                        "latitude": "51.23666000",
                        "longitude": "23.59486000"
                    },
                    {
                        "id": 87978,
                        "name": "Rudnik",
                        "latitude": "50.88035000",
                        "longitude": "22.97293000"
                    },
                    {
                        "id": 87992,
                        "name": "Rybczewice",
                        "latitude": "51.02876000",
                        "longitude": "22.85053000"
                    },
                    {
                        "id": 88008,
                        "name": "Ryki",
                        "latitude": "51.62574000",
                        "longitude": "21.93274000"
                    },
                    {
                        "id": 88018,
                        "name": "Rzeczyca",
                        "latitude": "51.96225000",
                        "longitude": "22.74942000"
                    },
                    {
                        "id": 88053,
                        "name": "Sawin",
                        "latitude": "51.27443000",
                        "longitude": "23.43375000"
                    },
                    {
                        "id": 88056,
                        "name": "Serniki",
                        "latitude": "51.43716000",
                        "longitude": "22.65853000"
                    },
                    {
                        "id": 88058,
                        "name": "Serokomla",
                        "latitude": "51.70070000",
                        "longitude": "22.33237000"
                    },
                    {
                        "id": 88074,
                        "name": "Siemień",
                        "latitude": "51.62883000",
                        "longitude": "22.77243000"
                    },
                    {
                        "id": 88082,
                        "name": "Siennica Różana",
                        "latitude": "51.00123000",
                        "longitude": "23.32260000"
                    },
                    {
                        "id": 88094,
                        "name": "Sitno",
                        "latitude": "50.74944000",
                        "longitude": "23.36260000"
                    },
                    {
                        "id": 88106,
                        "name": "Skierbieszów",
                        "latitude": "50.85158000",
                        "longitude": "23.35917000"
                    },
                    {
                        "id": 88335,
                        "name": "Sławatycze",
                        "latitude": "51.76338000",
                        "longitude": "23.55460000"
                    },
                    {
                        "id": 88150,
                        "name": "Sosnowica",
                        "latitude": "51.52065000",
                        "longitude": "23.09215000"
                    },
                    {
                        "id": 88153,
                        "name": "Sosnówka",
                        "latitude": "51.75084000",
                        "longitude": "23.33814000"
                    },
                    {
                        "id": 88161,
                        "name": "Spiczyn",
                        "latitude": "51.34128000",
                        "longitude": "22.75354000"
                    },
                    {
                        "id": 88197,
                        "name": "Stary Zamość",
                        "latitude": "50.82004000",
                        "longitude": "23.17154000"
                    },
                    {
                        "id": 88244,
                        "name": "Stężyca",
                        "latitude": "51.58187000",
                        "longitude": "21.77087000"
                    },
                    {
                        "id": 88206,
                        "name": "Stoczek Łukowski",
                        "latitude": "51.96135000",
                        "longitude": "21.97137000"
                    },
                    {
                        "id": 88234,
                        "name": "Strzyżowice",
                        "latitude": "51.04830000",
                        "longitude": "22.44018000"
                    },
                    {
                        "id": 88273,
                        "name": "Sułów",
                        "latitude": "50.90661000",
                        "longitude": "22.36061000"
                    },
                    {
                        "id": 88266,
                        "name": "Susiec",
                        "latitude": "50.41973000",
                        "longitude": "23.19626000"
                    },
                    {
                        "id": 88843,
                        "name": "Świdnik",
                        "latitude": "51.21898000",
                        "longitude": "22.69621000"
                    },
                    {
                        "id": 88288,
                        "name": "Szastarka",
                        "latitude": "50.85527000",
                        "longitude": "22.31971000"
                    },
                    {
                        "id": 88292,
                        "name": "Szczebrzeszyn",
                        "latitude": "50.69499000",
                        "longitude": "22.97954000"
                    },
                    {
                        "id": 88358,
                        "name": "Tarnawatka",
                        "latitude": "50.53154000",
                        "longitude": "23.39590000"
                    },
                    {
                        "id": 88360,
                        "name": "Tarnogród",
                        "latitude": "50.36090000",
                        "longitude": "22.74174000"
                    },
                    {
                        "id": 88371,
                        "name": "Telatyn",
                        "latitude": "50.52712000",
                        "longitude": "23.83956000"
                    },
                    {
                        "id": 88374,
                        "name": "Terespol",
                        "latitude": "52.07550000",
                        "longitude": "23.61614000"
                    },
                    {
                        "id": 88375,
                        "name": "Tereszpol",
                        "latitude": "50.58373000",
                        "longitude": "22.87980000"
                    },
                    {
                        "id": 88379,
                        "name": "Tomaszów Lubelski",
                        "latitude": "50.44767000",
                        "longitude": "23.41616000"
                    },
                    {
                        "id": 88388,
                        "name": "Trawniki",
                        "latitude": "51.13633000",
                        "longitude": "22.99816000"
                    },
                    {
                        "id": 88405,
                        "name": "Trzebieszów",
                        "latitude": "51.99006000",
                        "longitude": "22.55502000"
                    },
                    {
                        "id": 88413,
                        "name": "Trzydnik Duży",
                        "latitude": "50.84887000",
                        "longitude": "22.13359000"
                    },
                    {
                        "id": 88425,
                        "name": "Turobin",
                        "latitude": "50.82367000",
                        "longitude": "22.74273000"
                    },
                    {
                        "id": 88443,
                        "name": "Tyszowce",
                        "latitude": "50.61699000",
                        "longitude": "23.69927000"
                    },
                    {
                        "id": 88454,
                        "name": "Ulhówek",
                        "latitude": "50.44969000",
                        "longitude": "23.79956000"
                    },
                    {
                        "id": 88466,
                        "name": "Ułęż",
                        "latitude": "51.59195000",
                        "longitude": "22.10741000"
                    },
                    {
                        "id": 88459,
                        "name": "Urszulin",
                        "latitude": "51.39390000",
                        "longitude": "23.19480000"
                    },
                    {
                        "id": 88461,
                        "name": "Urzędów",
                        "latitude": "50.99323000",
                        "longitude": "22.14260000"
                    },
                    {
                        "id": 88468,
                        "name": "Uścimów Stary",
                        "latitude": "51.46962000",
                        "longitude": "22.95516000"
                    },
                    {
                        "id": 88637,
                        "name": "Wąwolnica",
                        "latitude": "51.29467000",
                        "longitude": "22.14681000"
                    },
                    {
                        "id": 88491,
                        "name": "Werbkowice",
                        "latitude": "50.75373000",
                        "longitude": "23.76411000"
                    },
                    {
                        "id": 88540,
                        "name": "Wilkołaz",
                        "latitude": "51.01473000",
                        "longitude": "22.35014000"
                    },
                    {
                        "id": 88541,
                        "name": "Wilków",
                        "latitude": "51.26224000",
                        "longitude": "21.87756000"
                    },
                    {
                        "id": 88546,
                        "name": "Wisznice",
                        "latitude": "51.78924000",
                        "longitude": "23.20836000"
                    },
                    {
                        "id": 88650,
                        "name": "Włodawa",
                        "latitude": "51.55000000",
                        "longitude": "23.55000000"
                    },
                    {
                        "id": 88570,
                        "name": "Wohyń",
                        "latitude": "51.75642000",
                        "longitude": "22.78582000"
                    },
                    {
                        "id": 88573,
                        "name": "Wojciechów",
                        "latitude": "51.23543000",
                        "longitude": "22.24551000"
                    },
                    {
                        "id": 88574,
                        "name": "Wojcieszków",
                        "latitude": "51.76922000",
                        "longitude": "22.31589000"
                    },
                    {
                        "id": 88579,
                        "name": "Wojsławice",
                        "latitude": "50.91916000",
                        "longitude": "23.54602000"
                    },
                    {
                        "id": 88589,
                        "name": "Wola Sernicka",
                        "latitude": "51.44978000",
                        "longitude": "22.68351000"
                    },
                    {
                        "id": 88590,
                        "name": "Wola Uhruska",
                        "latitude": "51.32139000",
                        "longitude": "23.62627000"
                    },
                    {
                        "id": 88621,
                        "name": "Wysokie",
                        "latitude": "50.91093000",
                        "longitude": "22.66600000"
                    },
                    {
                        "id": 88678,
                        "name": "Zakrzew",
                        "latitude": "50.89004000",
                        "longitude": "22.59115000"
                    },
                    {
                        "id": 88682,
                        "name": "Zakrzówek",
                        "latitude": "50.95124000",
                        "longitude": "22.38138000"
                    },
                    {
                        "id": 88691,
                        "name": "Zamch",
                        "latitude": "50.31713000",
                        "longitude": "23.02786000"
                    },
                    {
                        "id": 88692,
                        "name": "Zamość",
                        "latitude": "50.72314000",
                        "longitude": "23.25196000"
                    },
                    {
                        "id": 88903,
                        "name": "Żółkiewka",
                        "latitude": "50.90991000",
                        "longitude": "22.83465000"
                    },
                    {
                        "id": 88735,
                        "name": "Zwierzyniec",
                        "latitude": "50.61400000",
                        "longitude": "22.97512000"
                    },
                    {
                        "id": 88900,
                        "name": "Żyrzyn",
                        "latitude": "51.49918000",
                        "longitude": "22.09170000"
                    }
                ]
            },
            {
                "id": 1631,
                "name": "Lubusz",
                "iso2": "08",
                "latitude": "52.22746120",
                "longitude": "15.25591030",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85791,
                        "name": "Babimost",
                        "latitude": "52.16488000",
                        "longitude": "15.82769000"
                    },
                    {
                        "id": 85880,
                        "name": "Bledzew",
                        "latitude": "52.51711000",
                        "longitude": "15.41382000"
                    },
                    {
                        "id": 85887,
                        "name": "Bobrowice",
                        "latitude": "51.94850000",
                        "longitude": "15.09058000"
                    },
                    {
                        "id": 85896,
                        "name": "Bogdaniec",
                        "latitude": "52.68897000",
                        "longitude": "15.07127000"
                    },
                    {
                        "id": 85901,
                        "name": "Bojadła",
                        "latitude": "51.95321000",
                        "longitude": "15.81036000"
                    },
                    {
                        "id": 85947,
                        "name": "Brody",
                        "latitude": "51.79046000",
                        "longitude": "14.77335000"
                    },
                    {
                        "id": 85979,
                        "name": "Brójce",
                        "latitude": "52.31745000",
                        "longitude": "15.67414000"
                    },
                    {
                        "id": 86004,
                        "name": "Bytnica",
                        "latitude": "52.15066000",
                        "longitude": "15.16946000"
                    },
                    {
                        "id": 86006,
                        "name": "Bytom Odrzański",
                        "latitude": "51.73062000",
                        "longitude": "15.82362000"
                    },
                    {
                        "id": 86096,
                        "name": "Cybinka",
                        "latitude": "52.19446000",
                        "longitude": "14.79567000"
                    },
                    {
                        "id": 86139,
                        "name": "Czerwieńsk",
                        "latitude": "52.01289000",
                        "longitude": "15.42317000"
                    },
                    {
                        "id": 86233,
                        "name": "Dąbie",
                        "latitude": "52.01056000",
                        "longitude": "15.15221000"
                    },
                    {
                        "id": 86162,
                        "name": "Deszczno",
                        "latitude": "52.66988000",
                        "longitude": "15.31975000"
                    },
                    {
                        "id": 86165,
                        "name": "Dobiegniew",
                        "latitude": "52.96947000",
                        "longitude": "15.75362000"
                    },
                    {
                        "id": 86197,
                        "name": "Drezdenko",
                        "latitude": "52.83831000",
                        "longitude": "15.83079000"
                    },
                    {
                        "id": 86342,
                        "name": "Gorzów Wielkopolski",
                        "latitude": "52.73679000",
                        "longitude": "15.22878000"
                    },
                    {
                        "id": 86420,
                        "name": "Górzyca",
                        "latitude": "52.49447000",
                        "longitude": "14.65503000"
                    },
                    {
                        "id": 86352,
                        "name": "Gozdnica",
                        "latitude": "51.43630000",
                        "longitude": "15.09856000"
                    },
                    {
                        "id": 86404,
                        "name": "Gubin",
                        "latitude": "51.94956000",
                        "longitude": "14.72837000"
                    },
                    {
                        "id": 86473,
                        "name": "Iłowa",
                        "latitude": "51.50060000",
                        "longitude": "15.19980000"
                    },
                    {
                        "id": 86518,
                        "name": "Jasień",
                        "latitude": "51.75142000",
                        "longitude": "15.01419000"
                    },
                    {
                        "id": 86553,
                        "name": "Jenin",
                        "latitude": "52.69647000",
                        "longitude": "15.09796000"
                    },
                    {
                        "id": 86611,
                        "name": "Kargowa",
                        "latitude": "52.07140000",
                        "longitude": "15.86138000"
                    },
                    {
                        "id": 86645,
                        "name": "Klenica",
                        "latitude": "51.99217000",
                        "longitude": "15.78392000"
                    },
                    {
                        "id": 86864,
                        "name": "Kłodawa",
                        "latitude": "52.78595000",
                        "longitude": "15.21452000"
                    },
                    {
                        "id": 86681,
                        "name": "Kolsko",
                        "latitude": "51.96146000",
                        "longitude": "15.95987000"
                    },
                    {
                        "id": 86695,
                        "name": "Konotop",
                        "latitude": "51.93157000",
                        "longitude": "15.90391000"
                    },
                    {
                        "id": 86715,
                        "name": "Kostrzyn nad Odrą",
                        "latitude": "52.58713000",
                        "longitude": "14.64953000"
                    },
                    {
                        "id": 86760,
                        "name": "Kożuchów",
                        "latitude": "51.74558000",
                        "longitude": "15.59492000"
                    },
                    {
                        "id": 86784,
                        "name": "Krosno Odrzańskie",
                        "latitude": "52.05492000",
                        "longitude": "15.09882000"
                    },
                    {
                        "id": 86809,
                        "name": "Krzeszyce",
                        "latitude": "52.58329000",
                        "longitude": "15.00707000"
                    },
                    {
                        "id": 86838,
                        "name": "Kunice Żarskie",
                        "latitude": "51.59944000",
                        "longitude": "15.16495000"
                    },
                    {
                        "id": 86909,
                        "name": "Lipinki Łużyckie",
                        "latitude": "51.63954000",
                        "longitude": "14.99874000"
                    },
                    {
                        "id": 86945,
                        "name": "Lubiszyn",
                        "latitude": "52.78075000",
                        "longitude": "14.94793000"
                    },
                    {
                        "id": 86949,
                        "name": "Lubniewice",
                        "latitude": "52.51638000",
                        "longitude": "15.25005000"
                    },
                    {
                        "id": 86958,
                        "name": "Lubrza",
                        "latitude": "52.30418000",
                        "longitude": "15.44317000"
                    },
                    {
                        "id": 86960,
                        "name": "Lubsko",
                        "latitude": "51.78467000",
                        "longitude": "14.97196000"
                    },
                    {
                        "id": 88761,
                        "name": "Łagów",
                        "latitude": "52.33429000",
                        "longitude": "15.29769000"
                    },
                    {
                        "id": 88826,
                        "name": "Łęknica",
                        "latitude": "51.54148000",
                        "longitude": "14.73584000"
                    },
                    {
                        "id": 87009,
                        "name": "Małomice",
                        "latitude": "51.55597000",
                        "longitude": "15.45004000"
                    },
                    {
                        "id": 86999,
                        "name": "Maszewo",
                        "latitude": "52.06896000",
                        "longitude": "14.90553000"
                    },
                    {
                        "id": 87062,
                        "name": "Międzylesie",
                        "latitude": "52.14487000",
                        "longitude": "15.38283000"
                    },
                    {
                        "id": 87065,
                        "name": "Międzyrzecz",
                        "latitude": "52.44461000",
                        "longitude": "15.57801000"
                    },
                    {
                        "id": 87175,
                        "name": "Nowa Sól",
                        "latitude": "51.80333000",
                        "longitude": "15.71702000"
                    },
                    {
                        "id": 87184,
                        "name": "Nowe Miasteczko",
                        "latitude": "51.69097000",
                        "longitude": "15.73174000"
                    },
                    {
                        "id": 87197,
                        "name": "Nowogród Bobrzański",
                        "latitude": "51.79856000",
                        "longitude": "15.23520000"
                    },
                    {
                        "id": 87224,
                        "name": "Ochla",
                        "latitude": "51.87903000",
                        "longitude": "15.47132000"
                    },
                    {
                        "id": 87324,
                        "name": "Ośno Lubuskie",
                        "latitude": "52.45360000",
                        "longitude": "14.87549000"
                    },
                    {
                        "id": 87318,
                        "name": "Otyń",
                        "latitude": "51.84766000",
                        "longitude": "15.71105000"
                    },
                    {
                        "id": 87508,
                        "name": "Powiat gorzowski",
                        "latitude": "52.73863000",
                        "longitude": "15.08508000"
                    },
                    {
                        "id": 87556,
                        "name": "Powiat krośnieński",
                        "latitude": "52.00988000",
                        "longitude": "14.95209000"
                    },
                    {
                        "id": 87588,
                        "name": "Powiat międzyrzecki",
                        "latitude": "52.49891000",
                        "longitude": "15.58284000"
                    },
                    {
                        "id": 87604,
                        "name": "Powiat nowosolski",
                        "latitude": "51.84218000",
                        "longitude": "15.72698000"
                    },
                    {
                        "id": 87698,
                        "name": "Powiat słubicki",
                        "latitude": "52.32267000",
                        "longitude": "14.78921000"
                    },
                    {
                        "id": 87685,
                        "name": "Powiat strzelecko-drezdenecki",
                        "latitude": "52.91220000",
                        "longitude": "15.64061000"
                    },
                    {
                        "id": 87688,
                        "name": "Powiat sulęciński",
                        "latitude": "52.42850000",
                        "longitude": "15.04896000"
                    },
                    {
                        "id": 87762,
                        "name": "Powiat świebodziński",
                        "latitude": "52.23799000",
                        "longitude": "15.48522000"
                    },
                    {
                        "id": 87726,
                        "name": "Powiat wschowski",
                        "latitude": "51.83019000",
                        "longitude": "16.12096000"
                    },
                    {
                        "id": 87764,
                        "name": "Powiat żagański",
                        "latitude": "51.59471000",
                        "longitude": "15.42253000"
                    },
                    {
                        "id": 87765,
                        "name": "Powiat żarski",
                        "latitude": "51.62858000",
                        "longitude": "14.96170000"
                    },
                    {
                        "id": 87742,
                        "name": "Powiat zielonogórski",
                        "latitude": "51.93326000",
                        "longitude": "15.44403000"
                    },
                    {
                        "id": 87817,
                        "name": "Przewóz",
                        "latitude": "51.48053000",
                        "longitude": "14.95188000"
                    },
                    {
                        "id": 87822,
                        "name": "Przyborów",
                        "latitude": "51.79991000",
                        "longitude": "15.76890000"
                    },
                    {
                        "id": 87831,
                        "name": "Przytoczna",
                        "latitude": "52.57755000",
                        "longitude": "15.67878000"
                    },
                    {
                        "id": 87842,
                        "name": "Pszczew",
                        "latitude": "52.47724000",
                        "longitude": "15.78160000"
                    },
                    {
                        "id": 88022,
                        "name": "Rzepin",
                        "latitude": "52.34640000",
                        "longitude": "14.83227000"
                    },
                    {
                        "id": 88050,
                        "name": "Santok",
                        "latitude": "52.73785000",
                        "longitude": "15.41021000"
                    },
                    {
                        "id": 88069,
                        "name": "Siedlisko",
                        "latitude": "51.76864000",
                        "longitude": "15.81396000"
                    },
                    {
                        "id": 88079,
                        "name": "Sieniawa",
                        "latitude": "52.36344000",
                        "longitude": "15.37768000"
                    },
                    {
                        "id": 88080,
                        "name": "Sieniawa Żarska",
                        "latitude": "51.64007000",
                        "longitude": "15.06045000"
                    },
                    {
                        "id": 88123,
                        "name": "Skąpe",
                        "latitude": "52.15292000",
                        "longitude": "15.45845000"
                    },
                    {
                        "id": 88120,
                        "name": "Skwierzyna",
                        "latitude": "52.59914000",
                        "longitude": "15.50652000"
                    },
                    {
                        "id": 88334,
                        "name": "Sława",
                        "latitude": "51.87623000",
                        "longitude": "16.07205000"
                    },
                    {
                        "id": 88344,
                        "name": "Słońsk",
                        "latitude": "52.56345000",
                        "longitude": "14.80526000"
                    },
                    {
                        "id": 88345,
                        "name": "Słubice",
                        "latitude": "52.35088000",
                        "longitude": "14.56065000"
                    },
                    {
                        "id": 88185,
                        "name": "Stare Kurowo",
                        "latitude": "52.85669000",
                        "longitude": "15.67749000"
                    },
                    {
                        "id": 88227,
                        "name": "Strzelce Krajeńskie",
                        "latitude": "52.87726000",
                        "longitude": "15.52978000"
                    },
                    {
                        "id": 88256,
                        "name": "Sulechów",
                        "latitude": "52.08362000",
                        "longitude": "15.62513000"
                    },
                    {
                        "id": 88841,
                        "name": "Świdnica",
                        "latitude": "51.88836000",
                        "longitude": "15.39013000"
                    },
                    {
                        "id": 88846,
                        "name": "Świebodzin",
                        "latitude": "52.24751000",
                        "longitude": "15.53355000"
                    },
                    {
                        "id": 88289,
                        "name": "Szczaniec",
                        "latitude": "52.26874000",
                        "longitude": "15.68170000"
                    },
                    {
                        "id": 88312,
                        "name": "Szlichtyngowa",
                        "latitude": "51.71222000",
                        "longitude": "16.24427000"
                    },
                    {
                        "id": 88313,
                        "name": "Szprotawa",
                        "latitude": "51.56563000",
                        "longitude": "15.53664000"
                    },
                    {
                        "id": 88385,
                        "name": "Torzym",
                        "latitude": "52.31331000",
                        "longitude": "15.08243000"
                    },
                    {
                        "id": 88397,
                        "name": "Trzciel",
                        "latitude": "52.36504000",
                        "longitude": "15.87306000"
                    },
                    {
                        "id": 88402,
                        "name": "Trzebiechów",
                        "latitude": "52.02113000",
                        "longitude": "15.73620000"
                    },
                    {
                        "id": 88403,
                        "name": "Trzebiel",
                        "latitude": "51.63496000",
                        "longitude": "14.81609000"
                    },
                    {
                        "id": 88423,
                        "name": "Tuplice",
                        "latitude": "51.67639000",
                        "longitude": "14.82914000"
                    },
                    {
                        "id": 88552,
                        "name": "Witnica",
                        "latitude": "52.67318000",
                        "longitude": "14.89765000"
                    },
                    {
                        "id": 88610,
                        "name": "Wschowa",
                        "latitude": "51.80705000",
                        "longitude": "16.31663000"
                    },
                    {
                        "id": 88612,
                        "name": "Wymiarki",
                        "latitude": "51.51109000",
                        "longitude": "15.08208000"
                    },
                    {
                        "id": 88661,
                        "name": "Zabór",
                        "latitude": "51.95194000",
                        "longitude": "15.71676000"
                    },
                    {
                        "id": 88872,
                        "name": "Żagań",
                        "latitude": "51.61759000",
                        "longitude": "15.31486000"
                    },
                    {
                        "id": 88877,
                        "name": "Żary",
                        "latitude": "51.64205000",
                        "longitude": "15.13727000"
                    },
                    {
                        "id": 88714,
                        "name": "Zbąszynek",
                        "latitude": "52.24315000",
                        "longitude": "15.81654000"
                    },
                    {
                        "id": 88728,
                        "name": "Zielona Góra",
                        "latitude": "51.93768000",
                        "longitude": "15.51216000"
                    },
                    {
                        "id": 88736,
                        "name": "Zwierzyń",
                        "latitude": "52.83212000",
                        "longitude": "15.56763000"
                    }
                ]
            },
            {
                "id": 1636,
                "name": "Łódź",
                "iso2": "10",
                "latitude": "51.46347710",
                "longitude": "19.17269740",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85780,
                        "name": "Aleksandrów",
                        "latitude": "51.27126000",
                        "longitude": "19.99005000"
                    },
                    {
                        "id": 85782,
                        "name": "Aleksandrów Łódzki",
                        "latitude": "51.81965000",
                        "longitude": "19.30384000"
                    },
                    {
                        "id": 85784,
                        "name": "Andrespol",
                        "latitude": "51.72783000",
                        "longitude": "19.64175000"
                    },
                    {
                        "id": 86012,
                        "name": "Będków",
                        "latitude": "51.58763000",
                        "longitude": "19.74956000"
                    },
                    {
                        "id": 85822,
                        "name": "Bedlno",
                        "latitude": "52.20829000",
                        "longitude": "19.57592000"
                    },
                    {
                        "id": 85828,
                        "name": "Bełchatów",
                        "latitude": "51.36883000",
                        "longitude": "19.35671000"
                    },
                    {
                        "id": 85837,
                        "name": "Biała Rawska",
                        "latitude": "51.80779000",
                        "longitude": "20.47259000"
                    },
                    {
                        "id": 85838,
                        "name": "Białaczów",
                        "latitude": "51.29815000",
                        "longitude": "20.29724000"
                    },
                    {
                        "id": 85855,
                        "name": "Bielawy",
                        "latitude": "52.07539000",
                        "longitude": "19.65557000"
                    },
                    {
                        "id": 86014,
                        "name": "Błaszki",
                        "latitude": "51.65163000",
                        "longitude": "18.43472000"
                    },
                    {
                        "id": 85888,
                        "name": "Bobrowniki",
                        "latitude": "52.06442000",
                        "longitude": "20.01949000"
                    },
                    {
                        "id": 85912,
                        "name": "Bolesławiec",
                        "latitude": "51.19866000",
                        "longitude": "18.19147000"
                    },
                    {
                        "id": 85913,
                        "name": "Bolimów",
                        "latitude": "52.07671000",
                        "longitude": "20.16352000"
                    },
                    {
                        "id": 85980,
                        "name": "Brąszewice",
                        "latitude": "51.49902000",
                        "longitude": "18.44982000"
                    },
                    {
                        "id": 85978,
                        "name": "Brójce",
                        "latitude": "51.66436000",
                        "longitude": "19.64802000"
                    },
                    {
                        "id": 85964,
                        "name": "Brzeziny",
                        "latitude": "51.80023000",
                        "longitude": "19.75144000"
                    },
                    {
                        "id": 85969,
                        "name": "Brzeźnio",
                        "latitude": "51.49400000",
                        "longitude": "18.62234000"
                    },
                    {
                        "id": 85981,
                        "name": "Buczek",
                        "latitude": "51.50228000",
                        "longitude": "19.16419000"
                    },
                    {
                        "id": 85983,
                        "name": "Budziszewice",
                        "latitude": "51.66739000",
                        "longitude": "19.93581000"
                    },
                    {
                        "id": 85995,
                        "name": "Burzenin",
                        "latitude": "51.46077000",
                        "longitude": "18.83233000"
                    },
                    {
                        "id": 86072,
                        "name": "Chąśno",
                        "latitude": "52.19535000",
                        "longitude": "19.94259000"
                    },
                    {
                        "id": 86082,
                        "name": "Cielądz",
                        "latitude": "51.71576000",
                        "longitude": "20.34428000"
                    },
                    {
                        "id": 86114,
                        "name": "Czarnocin",
                        "latitude": "51.59142000",
                        "longitude": "19.68158000"
                    },
                    {
                        "id": 86116,
                        "name": "Czarnożyły",
                        "latitude": "51.28533000",
                        "longitude": "18.56106000"
                    },
                    {
                        "id": 86119,
                        "name": "Czastary",
                        "latitude": "51.25869000",
                        "longitude": "18.31953000"
                    },
                    {
                        "id": 86135,
                        "name": "Czerniewice",
                        "latitude": "51.65419000",
                        "longitude": "20.15553000"
                    },
                    {
                        "id": 86243,
                        "name": "Dąbrowice",
                        "latitude": "52.31142000",
                        "longitude": "19.08437000"
                    },
                    {
                        "id": 86155,
                        "name": "Dalików",
                        "latitude": "51.88476000",
                        "longitude": "19.11904000"
                    },
                    {
                        "id": 86160,
                        "name": "Daszyna",
                        "latitude": "52.15503000",
                        "longitude": "19.18153000"
                    },
                    {
                        "id": 86262,
                        "name": "Dłutów",
                        "latitude": "51.55936000",
                        "longitude": "19.39198000"
                    },
                    {
                        "id": 86163,
                        "name": "Dmosin",
                        "latitude": "51.92437000",
                        "longitude": "19.75934000"
                    },
                    {
                        "id": 86175,
                        "name": "Dobroń",
                        "latitude": "51.63885000",
                        "longitude": "19.24539000"
                    },
                    {
                        "id": 86184,
                        "name": "Domaniewice",
                        "latitude": "52.00623000",
                        "longitude": "19.80294000"
                    },
                    {
                        "id": 86201,
                        "name": "Drużbice",
                        "latitude": "51.46369000",
                        "longitude": "19.39404000"
                    },
                    {
                        "id": 86202,
                        "name": "Drzewica",
                        "latitude": "51.45085000",
                        "longitude": "20.47701000"
                    },
                    {
                        "id": 86218,
                        "name": "Działoszyn",
                        "latitude": "51.11699000",
                        "longitude": "18.86524000"
                    },
                    {
                        "id": 86280,
                        "name": "Galewice",
                        "latitude": "51.34471000",
                        "longitude": "18.25756000"
                    },
                    {
                        "id": 86290,
                        "name": "Gałków Mały",
                        "latitude": "51.72554000",
                        "longitude": "19.71359000"
                    },
                    {
                        "id": 86294,
                        "name": "Gidle",
                        "latitude": "50.96199000",
                        "longitude": "19.47181000"
                    },
                    {
                        "id": 86430,
                        "name": "Głowno",
                        "latitude": "51.96463000",
                        "longitude": "19.71565000"
                    },
                    {
                        "id": 86434,
                        "name": "Głuchów",
                        "latitude": "51.77947000",
                        "longitude": "20.07666000"
                    },
                    {
                        "id": 86318,
                        "name": "Godzianów",
                        "latitude": "51.89694000",
                        "longitude": "20.03589000"
                    },
                    {
                        "id": 86330,
                        "name": "Gomunice",
                        "latitude": "51.16890000",
                        "longitude": "19.49335000"
                    },
                    {
                        "id": 86411,
                        "name": "Góra Świętej Małgorzaty",
                        "latitude": "52.05713000",
                        "longitude": "19.31997000"
                    },
                    {
                        "id": 86336,
                        "name": "Gorzkowice",
                        "latitude": "51.21533000",
                        "longitude": "19.59626000"
                    },
                    {
                        "id": 86348,
                        "name": "Goszczanów",
                        "latitude": "51.79163000",
                        "longitude": "18.50570000"
                    },
                    {
                        "id": 86362,
                        "name": "Grabica",
                        "latitude": "51.47989000",
                        "longitude": "19.53137000"
                    },
                    {
                        "id": 86368,
                        "name": "Grabów",
                        "latitude": "52.12717000",
                        "longitude": "19.00257000"
                    },
                    {
                        "id": 86460,
                        "name": "Inowłódz",
                        "latitude": "51.52717000",
                        "longitude": "20.22300000"
                    },
                    {
                        "id": 86560,
                        "name": "Jeżów",
                        "latitude": "51.81376000",
                        "longitude": "19.96877000"
                    },
                    {
                        "id": 86602,
                        "name": "Kamieńsk",
                        "latitude": "51.20242000",
                        "longitude": "19.49661000"
                    },
                    {
                        "id": 86623,
                        "name": "Kawęczyn Nowy",
                        "latitude": "51.88597000",
                        "longitude": "20.24703000"
                    },
                    {
                        "id": 86634,
                        "name": "Kiernozia",
                        "latitude": "52.26858000",
                        "longitude": "19.87092000"
                    },
                    {
                        "id": 86648,
                        "name": "Kleszczów",
                        "latitude": "51.22355000",
                        "longitude": "19.30418000"
                    },
                    {
                        "id": 86652,
                        "name": "Klonowa",
                        "latitude": "51.41928000",
                        "longitude": "18.41815000"
                    },
                    {
                        "id": 86655,
                        "name": "Kluki",
                        "latitude": "51.34187000",
                        "longitude": "19.23938000"
                    },
                    {
                        "id": 86671,
                        "name": "Kocierzew Południowy",
                        "latitude": "52.21728000",
                        "longitude": "20.01812000"
                    },
                    {
                        "id": 86682,
                        "name": "Koluszki",
                        "latitude": "51.73872000",
                        "longitude": "19.81994000"
                    },
                    {
                        "id": 86698,
                        "name": "Konstantynów Łódzki",
                        "latitude": "51.74776000",
                        "longitude": "19.32564000"
                    },
                    {
                        "id": 86732,
                        "name": "Kowiesy",
                        "latitude": "51.88942000",
                        "longitude": "20.41929000"
                    },
                    {
                        "id": 86790,
                        "name": "Krośniewice",
                        "latitude": "52.25592000",
                        "longitude": "19.17037000"
                    },
                    {
                        "id": 86823,
                        "name": "Krzyżanów",
                        "latitude": "52.18409000",
                        "longitude": "19.45619000"
                    },
                    {
                        "id": 86828,
                        "name": "Ksawerów",
                        "latitude": "51.68288000",
                        "longitude": "19.40280000"
                    },
                    {
                        "id": 86844,
                        "name": "Kutno",
                        "latitude": "52.23064000",
                        "longitude": "19.36409000"
                    },
                    {
                        "id": 86895,
                        "name": "Lgota Wielka",
                        "latitude": "51.14904000",
                        "longitude": "19.32735000"
                    },
                    {
                        "id": 86905,
                        "name": "Lipce Reymontowskie",
                        "latitude": "51.89863000",
                        "longitude": "19.94173000"
                    },
                    {
                        "id": 86950,
                        "name": "Lubochnia",
                        "latitude": "51.60794000",
                        "longitude": "20.05391000"
                    },
                    {
                        "id": 86968,
                        "name": "Lutomiersk",
                        "latitude": "51.75376000",
                        "longitude": "19.21097000"
                    },
                    {
                        "id": 86971,
                        "name": "Lututów",
                        "latitude": "51.37033000",
                        "longitude": "18.43480000"
                    },
                    {
                        "id": 88764,
                        "name": "Łanięta",
                        "latitude": "52.36203000",
                        "longitude": "19.28032000"
                    },
                    {
                        "id": 88770,
                        "name": "Łask",
                        "latitude": "51.59056000",
                        "longitude": "19.13278000"
                    },
                    {
                        "id": 88817,
                        "name": "Łęczyca",
                        "latitude": "52.05959000",
                        "longitude": "19.19972000"
                    },
                    {
                        "id": 88825,
                        "name": "Łęki Szlacheckie",
                        "latitude": "51.18774000",
                        "longitude": "19.79796000"
                    },
                    {
                        "id": 88810,
                        "name": "Łódź",
                        "latitude": "51.77058000",
                        "longitude": "19.47395000"
                    },
                    {
                        "id": 88795,
                        "name": "Łowicz",
                        "latitude": "52.10714000",
                        "longitude": "19.94525000"
                    },
                    {
                        "id": 88799,
                        "name": "Łubnice",
                        "latitude": "51.16406000",
                        "longitude": "18.29069000"
                    },
                    {
                        "id": 88809,
                        "name": "Łyszkowice",
                        "latitude": "51.98551000",
                        "longitude": "19.90654000"
                    },
                    {
                        "id": 86982,
                        "name": "Maków",
                        "latitude": "51.94696000",
                        "longitude": "20.05211000"
                    },
                    {
                        "id": 87078,
                        "name": "Mniszków",
                        "latitude": "51.37017000",
                        "longitude": "20.03915000"
                    },
                    {
                        "id": 87089,
                        "name": "Mokrsko",
                        "latitude": "51.17897000",
                        "longitude": "18.48879000"
                    },
                    {
                        "id": 87099,
                        "name": "Moszczenica",
                        "latitude": "51.50297000",
                        "longitude": "19.71986000"
                    },
                    {
                        "id": 87149,
                        "name": "Nieborów",
                        "latitude": "52.07771000",
                        "longitude": "20.06902000"
                    },
                    {
                        "id": 87189,
                        "name": "Nowe Ostrowy",
                        "latitude": "52.30318000",
                        "longitude": "19.19217000"
                    },
                    {
                        "id": 87261,
                        "name": "Opoczno",
                        "latitude": "51.37569000",
                        "longitude": "20.27827000"
                    },
                    {
                        "id": 87264,
                        "name": "Oporów",
                        "latitude": "52.26448000",
                        "longitude": "19.56416000"
                    },
                    {
                        "id": 87295,
                        "name": "Osjaków",
                        "latitude": "51.28946000",
                        "longitude": "18.79151000"
                    },
                    {
                        "id": 87303,
                        "name": "Ostrowy",
                        "latitude": "52.30444000",
                        "longitude": "19.16565000"
                    },
                    {
                        "id": 87328,
                        "name": "Ożarów",
                        "latitude": "51.14489000",
                        "longitude": "18.51110000"
                    },
                    {
                        "id": 87321,
                        "name": "Ozorków",
                        "latitude": "51.96336000",
                        "longitude": "19.29139000"
                    },
                    {
                        "id": 87330,
                        "name": "Pabianice",
                        "latitude": "51.66446000",
                        "longitude": "19.35473000"
                    },
                    {
                        "id": 87335,
                        "name": "Pajęczno",
                        "latitude": "51.14449000",
                        "longitude": "18.99612000"
                    },
                    {
                        "id": 87345,
                        "name": "Paradyż",
                        "latitude": "51.30604000",
                        "longitude": "20.11374000"
                    },
                    {
                        "id": 87350,
                        "name": "Parzęczew",
                        "latitude": "51.94855000",
                        "longitude": "19.20608000"
                    },
                    {
                        "id": 87859,
                        "name": "Pątnów",
                        "latitude": "51.14403000",
                        "longitude": "18.61659000"
                    },
                    {
                        "id": 87860,
                        "name": "Pęczniew",
                        "latitude": "51.80384000",
                        "longitude": "18.72311000"
                    },
                    {
                        "id": 87401,
                        "name": "Piątek",
                        "latitude": "52.06890000",
                        "longitude": "19.47970000"
                    },
                    {
                        "id": 87394,
                        "name": "Piotrków Trybunalski",
                        "latitude": "51.40547000",
                        "longitude": "19.70321000"
                    },
                    {
                        "id": 87862,
                        "name": "Pławno",
                        "latitude": "50.97772000",
                        "longitude": "19.45524000"
                    },
                    {
                        "id": 87412,
                        "name": "Poddębice",
                        "latitude": "51.89344000",
                        "longitude": "18.95730000"
                    },
                    {
                        "id": 87781,
                        "name": "Poświętne",
                        "latitude": "51.53203000",
                        "longitude": "20.36453000"
                    },
                    {
                        "id": 87460,
                        "name": "Powiat bełchatowski",
                        "latitude": "51.36877000",
                        "longitude": "19.17791000"
                    },
                    {
                        "id": 87476,
                        "name": "Powiat brzeziński",
                        "latitude": "51.84073000",
                        "longitude": "19.83037000"
                    },
                    {
                        "id": 87557,
                        "name": "Powiat kutnowski",
                        "latitude": "52.25140000",
                        "longitude": "19.39706000"
                    },
                    {
                        "id": 87747,
                        "name": "Powiat łaski",
                        "latitude": "51.55884000",
                        "longitude": "19.03824000"
                    },
                    {
                        "id": 87754,
                        "name": "Powiat łęczycki",
                        "latitude": "52.10611000",
                        "longitude": "19.19498000"
                    },
                    {
                        "id": 87753,
                        "name": "Powiat łódzki wschodni",
                        "latitude": "51.68616000",
                        "longitude": "19.70098000"
                    },
                    {
                        "id": 88752,
                        "name": "powiat Łowicki",
                        "latitude": "52.10627000",
                        "longitude": "19.94606000"
                    },
                    {
                        "id": 87616,
                        "name": "Powiat opoczyński",
                        "latitude": "51.39265000",
                        "longitude": "20.19430000"
                    },
                    {
                        "id": 87628,
                        "name": "Powiat pabianicki",
                        "latitude": "51.67743000",
                        "longitude": "19.23782000"
                    },
                    {
                        "id": 87629,
                        "name": "Powiat pajęczański",
                        "latitude": "51.14121000",
                        "longitude": "19.02749000"
                    },
                    {
                        "id": 87633,
                        "name": "Powiat piotrkowski",
                        "latitude": "51.37816000",
                        "longitude": "19.73960000"
                    },
                    {
                        "id": 87637,
                        "name": "Powiat poddębicki",
                        "latitude": "51.89837000",
                        "longitude": "18.92132000"
                    },
                    {
                        "id": 87657,
                        "name": "Powiat radomszczański",
                        "latitude": "51.06463000",
                        "longitude": "19.63038000"
                    },
                    {
                        "id": 87661,
                        "name": "Powiat rawski",
                        "latitude": "51.76228000",
                        "longitude": "20.38530000"
                    },
                    {
                        "id": 87672,
                        "name": "Powiat sieradzki",
                        "latitude": "51.60297000",
                        "longitude": "18.60309000"
                    },
                    {
                        "id": 87675,
                        "name": "Powiat skierniewicki",
                        "latitude": "51.94493000",
                        "longitude": "20.19367000"
                    },
                    {
                        "id": 87707,
                        "name": "Powiat tomaszowski",
                        "latitude": "51.59667000",
                        "longitude": "20.06638000"
                    },
                    {
                        "id": 87718,
                        "name": "Powiat wieluński",
                        "latitude": "51.23261000",
                        "longitude": "18.63033000"
                    },
                    {
                        "id": 87719,
                        "name": "Powiat wieruszowski",
                        "latitude": "51.29415000",
                        "longitude": "18.31854000"
                    },
                    {
                        "id": 87739,
                        "name": "Powiat zduńskowolski",
                        "latitude": "51.62040000",
                        "longitude": "18.95085000"
                    },
                    {
                        "id": 87740,
                        "name": "Powiat zgierski",
                        "latitude": "51.90410000",
                        "longitude": "19.48024000"
                    },
                    {
                        "id": 87806,
                        "name": "Przedbórz",
                        "latitude": "51.08789000",
                        "longitude": "19.87384000"
                    },
                    {
                        "id": 87886,
                        "name": "Radomsko",
                        "latitude": "51.06713000",
                        "longitude": "19.44477000"
                    },
                    {
                        "id": 87918,
                        "name": "Rawa Mazowiecka",
                        "latitude": "51.76437000",
                        "longitude": "20.25493000"
                    },
                    {
                        "id": 88037,
                        "name": "Ręczno",
                        "latitude": "51.19026000",
                        "longitude": "19.85375000"
                    },
                    {
                        "id": 87923,
                        "name": "Regnów",
                        "latitude": "51.74850000",
                        "longitude": "20.38711000"
                    },
                    {
                        "id": 87949,
                        "name": "Rogów",
                        "latitude": "51.81758000",
                        "longitude": "19.88654000"
                    },
                    {
                        "id": 87954,
                        "name": "Rokiciny",
                        "latitude": "51.65078000",
                        "longitude": "19.80191000"
                    },
                    {
                        "id": 87955,
                        "name": "Rokiciny-Kolonia",
                        "latitude": "51.66468000",
                        "longitude": "19.78312000"
                    },
                    {
                        "id": 87966,
                        "name": "Rozprza",
                        "latitude": "51.30266000",
                        "longitude": "19.64570000"
                    },
                    {
                        "id": 87987,
                        "name": "Rusiec",
                        "latitude": "51.32444000",
                        "longitude": "18.98506000"
                    },
                    {
                        "id": 88017,
                        "name": "Rzeczyca",
                        "latitude": "51.59824000",
                        "longitude": "20.29484000"
                    },
                    {
                        "id": 88027,
                        "name": "Rzgów",
                        "latitude": "51.66345000",
                        "longitude": "19.49181000"
                    },
                    {
                        "id": 88041,
                        "name": "Sadkowice",
                        "latitude": "51.72517000",
                        "longitude": "20.51465000"
                    },
                    {
                        "id": 88327,
                        "name": "Sędziejowice",
                        "latitude": "51.50677000",
                        "longitude": "19.02763000"
                    },
                    {
                        "id": 88076,
                        "name": "Siemkowice",
                        "latitude": "51.20194000",
                        "longitude": "18.89880000"
                    },
                    {
                        "id": 88085,
                        "name": "Sieradz",
                        "latitude": "51.59584000",
                        "longitude": "18.73023000"
                    },
                    {
                        "id": 88107,
                        "name": "Skierniewice",
                        "latitude": "51.95485000",
                        "longitude": "20.15837000"
                    },
                    {
                        "id": 88111,
                        "name": "Skomlin",
                        "latitude": "51.17089000",
                        "longitude": "18.38699000"
                    },
                    {
                        "id": 88338,
                        "name": "Sławno",
                        "latitude": "51.39273000",
                        "longitude": "20.14043000"
                    },
                    {
                        "id": 88349,
                        "name": "Słupia",
                        "latitude": "51.85518000",
                        "longitude": "19.96997000"
                    },
                    {
                        "id": 88137,
                        "name": "Sokolniki",
                        "latitude": "51.30738000",
                        "longitude": "18.33275000"
                    },
                    {
                        "id": 88192,
                        "name": "Starowa Góra",
                        "latitude": "51.69134000",
                        "longitude": "19.48374000"
                    },
                    {
                        "id": 88219,
                        "name": "Stryków",
                        "latitude": "51.90224000",
                        "longitude": "19.60536000"
                    },
                    {
                        "id": 88226,
                        "name": "Strzelce",
                        "latitude": "52.31478000",
                        "longitude": "19.40701000"
                    },
                    {
                        "id": 88229,
                        "name": "Strzelce Wielkie",
                        "latitude": "51.13940000",
                        "longitude": "19.14539000"
                    },
                    {
                        "id": 88257,
                        "name": "Sulejów",
                        "latitude": "51.35436000",
                        "longitude": "19.88538000"
                    },
                    {
                        "id": 88261,
                        "name": "Sulmierzyce",
                        "latitude": "51.18456000",
                        "longitude": "19.19595000"
                    },
                    {
                        "id": 88860,
                        "name": "Świnice Warckie",
                        "latitude": "52.04072000",
                        "longitude": "18.91786000"
                    },
                    {
                        "id": 88283,
                        "name": "Szadek",
                        "latitude": "51.69174000",
                        "longitude": "18.97549000"
                    },
                    {
                        "id": 88298,
                        "name": "Szczerców",
                        "latitude": "51.33319000",
                        "longitude": "19.10977000"
                    },
                    {
                        "id": 88380,
                        "name": "Tomaszów Mazowiecki",
                        "latitude": "51.53131000",
                        "longitude": "20.00855000"
                    },
                    {
                        "id": 88429,
                        "name": "Tuszyn",
                        "latitude": "51.60949000",
                        "longitude": "19.53009000"
                    },
                    {
                        "id": 88449,
                        "name": "Ujazd",
                        "latitude": "51.59781000",
                        "longitude": "19.92225000"
                    },
                    {
                        "id": 88455,
                        "name": "Uniejów",
                        "latitude": "51.97428000",
                        "longitude": "18.79308000"
                    },
                    {
                        "id": 88474,
                        "name": "Walichnowy",
                        "latitude": "51.29579000",
                        "longitude": "18.38073000"
                    },
                    {
                        "id": 88482,
                        "name": "Warta",
                        "latitude": "51.71049000",
                        "longitude": "18.62483000"
                    },
                    {
                        "id": 88483,
                        "name": "Wartkowice",
                        "latitude": "51.97626000",
                        "longitude": "19.00180000"
                    },
                    {
                        "id": 88494,
                        "name": "Widawa",
                        "latitude": "51.43855000",
                        "longitude": "18.94421000"
                    },
                    {
                        "id": 88511,
                        "name": "Wieluń",
                        "latitude": "51.22097000",
                        "longitude": "18.56964000"
                    },
                    {
                        "id": 88515,
                        "name": "Wieruszów",
                        "latitude": "51.29488000",
                        "longitude": "18.15547000"
                    },
                    {
                        "id": 88522,
                        "name": "Wierzchlas",
                        "latitude": "51.20457000",
                        "longitude": "18.66543000"
                    },
                    {
                        "id": 88553,
                        "name": "Witonia",
                        "latitude": "52.14655000",
                        "longitude": "19.30049000"
                    },
                    {
                        "id": 88567,
                        "name": "Wodzierady",
                        "latitude": "51.71826000",
                        "longitude": "19.15123000"
                    },
                    {
                        "id": 88586,
                        "name": "Wola Krzysztoporska",
                        "latitude": "51.34418000",
                        "longitude": "19.58090000"
                    },
                    {
                        "id": 88595,
                        "name": "Wolbórz",
                        "latitude": "51.50196000",
                        "longitude": "19.83049000"
                    },
                    {
                        "id": 88608,
                        "name": "Wróblew",
                        "latitude": "51.61215000",
                        "longitude": "18.61487000"
                    },
                    {
                        "id": 88665,
                        "name": "Zadzim",
                        "latitude": "51.77666000",
                        "longitude": "18.84928000"
                    },
                    {
                        "id": 88694,
                        "name": "Zapolice",
                        "latitude": "51.54319000",
                        "longitude": "18.88335000"
                    },
                    {
                        "id": 88876,
                        "name": "Żarnów",
                        "latitude": "51.24607000",
                        "longitude": "20.17476000"
                    },
                    {
                        "id": 88717,
                        "name": "Zduńska Wola",
                        "latitude": "51.59915000",
                        "longitude": "18.93974000"
                    },
                    {
                        "id": 88881,
                        "name": "Żelechlinek",
                        "latitude": "51.71214000",
                        "longitude": "20.03460000"
                    },
                    {
                        "id": 88722,
                        "name": "Zelów",
                        "latitude": "51.46452000",
                        "longitude": "19.21972000"
                    },
                    {
                        "id": 88724,
                        "name": "Zgierz",
                        "latitude": "51.85561000",
                        "longitude": "19.40623000"
                    },
                    {
                        "id": 88743,
                        "name": "Złoczew",
                        "latitude": "51.41719000",
                        "longitude": "18.60363000"
                    },
                    {
                        "id": 88897,
                        "name": "Żychlin",
                        "latitude": "52.24404000",
                        "longitude": "19.62613000"
                    }
                ]
            },
            {
                "id": 1637,
                "name": "Mazovia",
                "iso2": "14",
                "latitude": "51.89271820",
                "longitude": "21.00216790",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85793,
                        "name": "Baboszewo",
                        "latitude": "52.68070000",
                        "longitude": "20.25527000"
                    },
                    {
                        "id": 85801,
                        "name": "Baniocha",
                        "latitude": "52.01653000",
                        "longitude": "21.13984000"
                    },
                    {
                        "id": 85802,
                        "name": "Baranowo",
                        "latitude": "53.17554000",
                        "longitude": "21.29803000"
                    },
                    {
                        "id": 85824,
                        "name": "Bemowo",
                        "latitude": "52.25460000",
                        "longitude": "20.90844000"
                    },
                    {
                        "id": 85834,
                        "name": "Biała",
                        "latitude": "52.60524000",
                        "longitude": "19.64956000"
                    },
                    {
                        "id": 85843,
                        "name": "Białobrzegi",
                        "latitude": "51.64695000",
                        "longitude": "20.95041000"
                    },
                    {
                        "id": 85846,
                        "name": "Białołeka",
                        "latitude": "52.32127000",
                        "longitude": "20.97204000"
                    },
                    {
                        "id": 85852,
                        "name": "Bielany",
                        "latitude": "52.29242000",
                        "longitude": "20.93531000"
                    },
                    {
                        "id": 85859,
                        "name": "Bielsk",
                        "latitude": "52.67180000",
                        "longitude": "19.80500000"
                    },
                    {
                        "id": 85863,
                        "name": "Bieniewice",
                        "latitude": "52.18268000",
                        "longitude": "20.56306000"
                    },
                    {
                        "id": 85870,
                        "name": "Bieżuń",
                        "latitude": "52.96107000",
                        "longitude": "19.88976000"
                    },
                    {
                        "id": 86017,
                        "name": "Błędów",
                        "latitude": "51.77767000",
                        "longitude": "20.69798000"
                    },
                    {
                        "id": 86016,
                        "name": "Błonie",
                        "latitude": "52.19849000",
                        "longitude": "20.61709000"
                    },
                    {
                        "id": 85893,
                        "name": "Bodzanów",
                        "latitude": "52.49992000",
                        "longitude": "20.02945000"
                    },
                    {
                        "id": 85900,
                        "name": "Boguty-Pianki",
                        "latitude": "52.71680000",
                        "longitude": "22.41546000"
                    },
                    {
                        "id": 85921,
                        "name": "Borkowice",
                        "latitude": "51.32025000",
                        "longitude": "20.68339000"
                    },
                    {
                        "id": 85925,
                        "name": "Borowie",
                        "latitude": "51.94908000",
                        "longitude": "21.76580000"
                    },
                    {
                        "id": 85938,
                        "name": "Brańszczyk",
                        "latitude": "52.62931000",
                        "longitude": "21.58745000"
                    },
                    {
                        "id": 85942,
                        "name": "Brochów",
                        "latitude": "52.31950000",
                        "longitude": "20.26257000"
                    },
                    {
                        "id": 85948,
                        "name": "Brody-Parcele",
                        "latitude": "52.47797000",
                        "longitude": "20.74974000"
                    },
                    {
                        "id": 85951,
                        "name": "Brok",
                        "latitude": "52.69948000",
                        "longitude": "21.85704000"
                    },
                    {
                        "id": 85955,
                        "name": "Brudzeń Duży",
                        "latitude": "52.66884000",
                        "longitude": "19.50399000"
                    },
                    {
                        "id": 85957,
                        "name": "Brwinów",
                        "latitude": "52.14269000",
                        "longitude": "20.71697000"
                    },
                    {
                        "id": 85993,
                        "name": "Bulkowo",
                        "latitude": "52.54087000",
                        "longitude": "20.11889000"
                    },
                    {
                        "id": 86020,
                        "name": "Cegłów",
                        "latitude": "52.14782000",
                        "longitude": "21.73739000"
                    },
                    {
                        "id": 86022,
                        "name": "Celestynów",
                        "latitude": "52.06093000",
                        "longitude": "21.39107000"
                    },
                    {
                        "id": 86023,
                        "name": "Ceranów",
                        "latitude": "52.63082000",
                        "longitude": "22.22826000"
                    },
                    {
                        "id": 86033,
                        "name": "Chlewiska",
                        "latitude": "51.24376000",
                        "longitude": "20.76871000"
                    },
                    {
                        "id": 86054,
                        "name": "Chorzele",
                        "latitude": "53.26075000",
                        "longitude": "20.89728000"
                    },
                    {
                        "id": 86057,
                        "name": "Chotcza",
                        "latitude": "51.24043000",
                        "longitude": "21.77662000"
                    },
                    {
                        "id": 86070,
                        "name": "Chynów",
                        "latitude": "51.90425000",
                        "longitude": "21.08208000"
                    },
                    {
                        "id": 86077,
                        "name": "Ciechanów",
                        "latitude": "52.88141000",
                        "longitude": "20.61996000"
                    },
                    {
                        "id": 86083,
                        "name": "Ciepielów",
                        "latitude": "51.24838000",
                        "longitude": "21.57475000"
                    },
                    {
                        "id": 86110,
                        "name": "Czarnia",
                        "latitude": "53.35614000",
                        "longitude": "21.19520000"
                    },
                    {
                        "id": 86131,
                        "name": "Czernice Borowe",
                        "latitude": "53.03197000",
                        "longitude": "20.71944000"
                    },
                    {
                        "id": 86140,
                        "name": "Czerwin",
                        "latitude": "52.94905000",
                        "longitude": "21.75842000"
                    },
                    {
                        "id": 86142,
                        "name": "Czerwińsk Nad Wisłą",
                        "latitude": "52.39828000",
                        "longitude": "20.30960000"
                    },
                    {
                        "id": 86144,
                        "name": "Czerwonka",
                        "latitude": "52.89254000",
                        "longitude": "21.21494000"
                    },
                    {
                        "id": 86244,
                        "name": "Dąbrówka",
                        "latitude": "52.48388000",
                        "longitude": "21.29794000"
                    },
                    {
                        "id": 86246,
                        "name": "Dębe Wielkie",
                        "latitude": "52.19961000",
                        "longitude": "21.44334000"
                    },
                    {
                        "id": 86260,
                        "name": "Długosiodło",
                        "latitude": "52.75998000",
                        "longitude": "21.59183000"
                    },
                    {
                        "id": 86170,
                        "name": "Dobre",
                        "latitude": "52.32097000",
                        "longitude": "21.67881000"
                    },
                    {
                        "id": 86183,
                        "name": "Domanice",
                        "latitude": "52.03739000",
                        "longitude": "22.17642000"
                    },
                    {
                        "id": 86198,
                        "name": "Drobin",
                        "latitude": "52.73775000",
                        "longitude": "19.98928000"
                    },
                    {
                        "id": 86206,
                        "name": "Duczki",
                        "latitude": "52.36271000",
                        "longitude": "21.29047000"
                    },
                    {
                        "id": 86219,
                        "name": "Dziekanów Leśny",
                        "latitude": "52.35243000",
                        "longitude": "20.85124000"
                    },
                    {
                        "id": 86224,
                        "name": "Dzierzążnia",
                        "latitude": "52.62811000",
                        "longitude": "20.23364000"
                    },
                    {
                        "id": 86222,
                        "name": "Dzierzgowo",
                        "latitude": "53.15279000",
                        "longitude": "20.66322000"
                    },
                    {
                        "id": 86422,
                        "name": "Gąbin",
                        "latitude": "52.39849000",
                        "longitude": "19.73509000"
                    },
                    {
                        "id": 86281,
                        "name": "Garbatka-Letnisko",
                        "latitude": "51.48320000",
                        "longitude": "21.61079000"
                    },
                    {
                        "id": 86286,
                        "name": "Garwolin",
                        "latitude": "51.89747000",
                        "longitude": "21.61466000"
                    },
                    {
                        "id": 86425,
                        "name": "Gąsocin",
                        "latitude": "52.73754000",
                        "longitude": "20.71180000"
                    },
                    {
                        "id": 86297,
                        "name": "Gielniów",
                        "latitude": "51.40076000",
                        "longitude": "20.48126000"
                    },
                    {
                        "id": 86306,
                        "name": "Glinojeck",
                        "latitude": "52.81983000",
                        "longitude": "20.29198000"
                    },
                    {
                        "id": 86358,
                        "name": "Gołymin-Ośrodek",
                        "latitude": "52.80800000",
                        "longitude": "20.87325000"
                    },
                    {
                        "id": 86410,
                        "name": "Góra Kalwaria",
                        "latitude": "51.97653000",
                        "longitude": "21.21537000"
                    },
                    {
                        "id": 86418,
                        "name": "Górzno",
                        "latitude": "51.84681000",
                        "longitude": "21.70933000"
                    },
                    {
                        "id": 86345,
                        "name": "Gostynin",
                        "latitude": "52.42938000",
                        "longitude": "19.46194000"
                    },
                    {
                        "id": 86349,
                        "name": "Goszczyn",
                        "latitude": "51.73187000",
                        "longitude": "20.85154000"
                    },
                    {
                        "id": 86351,
                        "name": "Goworowo",
                        "latitude": "52.90083000",
                        "longitude": "21.55578000"
                    },
                    {
                        "id": 86421,
                        "name": "Gózd",
                        "latitude": "51.37832000",
                        "longitude": "21.37914000"
                    },
                    {
                        "id": 86353,
                        "name": "Gozdowo",
                        "latitude": "52.72455000",
                        "longitude": "19.68501000"
                    },
                    {
                        "id": 86371,
                        "name": "Granica",
                        "latitude": "52.13359000",
                        "longitude": "20.80313000"
                    },
                    {
                        "id": 86400,
                        "name": "Grębków",
                        "latitude": "52.26931000",
                        "longitude": "21.90974000"
                    },
                    {
                        "id": 86375,
                        "name": "Grodzisk Mazowiecki",
                        "latitude": "52.10387000",
                        "longitude": "20.63370000"
                    },
                    {
                        "id": 86399,
                        "name": "Grójec",
                        "latitude": "51.86252000",
                        "longitude": "20.86757000"
                    },
                    {
                        "id": 86385,
                        "name": "Grudusk",
                        "latitude": "53.05845000",
                        "longitude": "20.62494000"
                    },
                    {
                        "id": 86405,
                        "name": "Guzów",
                        "latitude": "52.11626000",
                        "longitude": "20.33672000"
                    },
                    {
                        "id": 86407,
                        "name": "Gzy",
                        "latitude": "52.74045000",
                        "longitude": "20.94372000"
                    },
                    {
                        "id": 86440,
                        "name": "Halinów",
                        "latitude": "52.22880000",
                        "longitude": "21.35510000"
                    },
                    {
                        "id": 86449,
                        "name": "Hornówek",
                        "latitude": "52.28638000",
                        "longitude": "20.80793000"
                    },
                    {
                        "id": 86475,
                        "name": "Iłów",
                        "latitude": "52.33953000",
                        "longitude": "20.02730000"
                    },
                    {
                        "id": 86476,
                        "name": "Iłża",
                        "latitude": "51.16313000",
                        "longitude": "21.23979000"
                    },
                    {
                        "id": 86467,
                        "name": "Izabelin",
                        "latitude": "52.29992000",
                        "longitude": "20.81729000"
                    },
                    {
                        "id": 86482,
                        "name": "Jabłonna",
                        "latitude": "52.37885000",
                        "longitude": "20.91745000"
                    },
                    {
                        "id": 86484,
                        "name": "Jabłonna Lacka",
                        "latitude": "52.47664000",
                        "longitude": "22.44228000"
                    },
                    {
                        "id": 86489,
                        "name": "Jadów",
                        "latitude": "52.47849000",
                        "longitude": "21.63199000"
                    },
                    {
                        "id": 86492,
                        "name": "Jakubów",
                        "latitude": "52.21965000",
                        "longitude": "21.68032000"
                    },
                    {
                        "id": 86512,
                        "name": "Jasienica",
                        "latitude": "52.41415000",
                        "longitude": "21.41150000"
                    },
                    {
                        "id": 86516,
                        "name": "Jasieniec",
                        "latitude": "51.82104000",
                        "longitude": "20.94099000"
                    },
                    {
                        "id": 86523,
                        "name": "Jastrząb",
                        "latitude": "51.24725000",
                        "longitude": "20.94758000"
                    },
                    {
                        "id": 86525,
                        "name": "Jastrzębia",
                        "latitude": "51.49742000",
                        "longitude": "21.23709000"
                    },
                    {
                        "id": 86542,
                        "name": "Jedlińsk",
                        "latitude": "51.51400000",
                        "longitude": "21.11577000"
                    },
                    {
                        "id": 86543,
                        "name": "Jedlnia-Letnisko",
                        "latitude": "51.43074000",
                        "longitude": "21.33536000"
                    },
                    {
                        "id": 86544,
                        "name": "Jednorożec",
                        "latitude": "53.14116000",
                        "longitude": "21.05161000"
                    },
                    {
                        "id": 86566,
                        "name": "Joniec",
                        "latitude": "52.60128000",
                        "longitude": "20.58177000"
                    },
                    {
                        "id": 86574,
                        "name": "Józefosław",
                        "latitude": "52.10050000",
                        "longitude": "21.04629000"
                    },
                    {
                        "id": 86576,
                        "name": "Józefów",
                        "latitude": "52.13707000",
                        "longitude": "21.23589000"
                    },
                    {
                        "id": 86579,
                        "name": "Kabaty",
                        "latitude": "52.13012000",
                        "longitude": "21.08148000"
                    },
                    {
                        "id": 86582,
                        "name": "Kadzidło",
                        "latitude": "53.23435000",
                        "longitude": "21.46454000"
                    },
                    {
                        "id": 86628,
                        "name": "Kałuszyn",
                        "latitude": "52.20669000",
                        "longitude": "21.80838000"
                    },
                    {
                        "id": 86605,
                        "name": "Kampinos",
                        "latitude": "52.26837000",
                        "longitude": "20.46307000"
                    },
                    {
                        "id": 86609,
                        "name": "Karczew",
                        "latitude": "52.07655000",
                        "longitude": "21.24962000"
                    },
                    {
                        "id": 86614,
                        "name": "Karniewo",
                        "latitude": "52.83700000",
                        "longitude": "20.98886000"
                    },
                    {
                        "id": 86624,
                        "name": "Kazanów",
                        "latitude": "51.27593000",
                        "longitude": "21.46737000"
                    },
                    {
                        "id": 86637,
                        "name": "Kiełpin",
                        "latitude": "52.35796000",
                        "longitude": "20.86214000"
                    },
                    {
                        "id": 86644,
                        "name": "Klembów",
                        "latitude": "52.40650000",
                        "longitude": "21.33176000"
                    },
                    {
                        "id": 86657,
                        "name": "Klwów",
                        "latitude": "51.53448000",
                        "longitude": "20.63644000"
                    },
                    {
                        "id": 86669,
                        "name": "Kobyłka",
                        "latitude": "52.33953000",
                        "longitude": "21.19589000"
                    },
                    {
                        "id": 86743,
                        "name": "Kołbiel",
                        "latitude": "52.06431000",
                        "longitude": "21.48153000"
                    },
                    {
                        "id": 86687,
                        "name": "Komorów",
                        "latitude": "52.14560000",
                        "longitude": "20.81566000"
                    },
                    {
                        "id": 86696,
                        "name": "Konstancin-Jeziorna",
                        "latitude": "52.09380000",
                        "longitude": "21.11761000"
                    },
                    {
                        "id": 86701,
                        "name": "Korczew",
                        "latitude": "52.35327000",
                        "longitude": "22.61338000"
                    },
                    {
                        "id": 86708,
                        "name": "Korytnica",
                        "latitude": "52.41441000",
                        "longitude": "21.84949000"
                    },
                    {
                        "id": 86721,
                        "name": "Kosów Lacki",
                        "latitude": "52.59541000",
                        "longitude": "22.14707000"
                    },
                    {
                        "id": 86724,
                        "name": "Kotuń",
                        "latitude": "52.17643000",
                        "longitude": "22.06819000"
                    },
                    {
                        "id": 86726,
                        "name": "Kowala",
                        "latitude": "51.32503000",
                        "longitude": "21.06972000"
                    },
                    {
                        "id": 86735,
                        "name": "Kozienice",
                        "latitude": "51.58294000",
                        "longitude": "21.54779000"
                    },
                    {
                        "id": 86768,
                        "name": "Krasne",
                        "latitude": "52.92401000",
                        "longitude": "20.96732000"
                    },
                    {
                        "id": 86772,
                        "name": "Krasnosielc",
                        "latitude": "53.03378000",
                        "longitude": "21.15735000"
                    },
                    {
                        "id": 86815,
                        "name": "Krzynowłoga Mała",
                        "latitude": "53.15773000",
                        "longitude": "20.78579000"
                    },
                    {
                        "id": 86834,
                        "name": "Kuczbork-Osada",
                        "latitude": "53.08619000",
                        "longitude": "20.04782000"
                    },
                    {
                        "id": 86874,
                        "name": "Latowicz",
                        "latitude": "52.02636000",
                        "longitude": "21.80829000"
                    },
                    {
                        "id": 86876,
                        "name": "Legionowo",
                        "latitude": "52.40149000",
                        "longitude": "20.92664000"
                    },
                    {
                        "id": 86882,
                        "name": "Leszno",
                        "latitude": "52.25799000",
                        "longitude": "20.59121000"
                    },
                    {
                        "id": 86884,
                        "name": "Lesznowola",
                        "latitude": "52.09095000",
                        "longitude": "20.93479000"
                    },
                    {
                        "id": 86920,
                        "name": "Lipowiec Kościelny",
                        "latitude": "53.10459000",
                        "longitude": "20.17639000"
                    },
                    {
                        "id": 86922,
                        "name": "Lipsko",
                        "latitude": "51.15954000",
                        "longitude": "21.64933000"
                    },
                    {
                        "id": 86955,
                        "name": "Lubowidz",
                        "latitude": "53.11865000",
                        "longitude": "19.84594000"
                    },
                    {
                        "id": 86967,
                        "name": "Lutocin",
                        "latitude": "52.98152000",
                        "longitude": "19.76655000"
                    },
                    {
                        "id": 88811,
                        "name": "Łąck",
                        "latitude": "52.46621000",
                        "longitude": "19.61137000"
                    },
                    {
                        "id": 88762,
                        "name": "Łajski",
                        "latitude": "52.42873000",
                        "longitude": "20.94946000"
                    },
                    {
                        "id": 88771,
                        "name": "Łaskarzew",
                        "latitude": "51.78993000",
                        "longitude": "21.59122000"
                    },
                    {
                        "id": 88782,
                        "name": "Łochów",
                        "latitude": "52.53076000",
                        "longitude": "21.68158000"
                    },
                    {
                        "id": 88785,
                        "name": "Łomianki",
                        "latitude": "52.33413000",
                        "longitude": "20.88602000"
                    },
                    {
                        "id": 88792,
                        "name": "Łosice",
                        "latitude": "52.21129000",
                        "longitude": "22.71801000"
                    },
                    {
                        "id": 88807,
                        "name": "Łyse",
                        "latitude": "53.36443000",
                        "longitude": "21.56487000"
                    },
                    {
                        "id": 86980,
                        "name": "Maciejowice",
                        "latitude": "51.69222000",
                        "longitude": "21.55342000"
                    },
                    {
                        "id": 86983,
                        "name": "Maków Mazowiecki",
                        "latitude": "52.86493000",
                        "longitude": "21.10053000"
                    },
                    {
                        "id": 87005,
                        "name": "Mała Wieś",
                        "latitude": "52.45779000",
                        "longitude": "20.10223000"
                    },
                    {
                        "id": 87007,
                        "name": "Małkinia Górna",
                        "latitude": "52.69220000",
                        "longitude": "22.02836000"
                    },
                    {
                        "id": 86994,
                        "name": "Marki",
                        "latitude": "52.32065000",
                        "longitude": "21.10474000"
                    },
                    {
                        "id": 87001,
                        "name": "Maszewo Duże",
                        "latitude": "52.58026000",
                        "longitude": "19.62905000"
                    },
                    {
                        "id": 87018,
                        "name": "Miastków Kościelny",
                        "latitude": "51.88407000",
                        "longitude": "21.82528000"
                    },
                    {
                        "id": 87024,
                        "name": "Michałów-Reginów",
                        "latitude": "52.41711000",
                        "longitude": "20.96595000"
                    },
                    {
                        "id": 87019,
                        "name": "Michałowice",
                        "latitude": "52.17435000",
                        "longitude": "20.88089000"
                    },
                    {
                        "id": 87030,
                        "name": "Miedzna",
                        "latitude": "52.46778000",
                        "longitude": "22.08947000"
                    },
                    {
                        "id": 87069,
                        "name": "Miętne",
                        "latitude": "51.92135000",
                        "longitude": "21.57457000"
                    },
                    {
                        "id": 87047,
                        "name": "Milanówek",
                        "latitude": "52.11879000",
                        "longitude": "20.67155000"
                    },
                    {
                        "id": 87075,
                        "name": "Mińsk Mazowiecki",
                        "latitude": "52.17935000",
                        "longitude": "21.57251000"
                    },
                    {
                        "id": 87127,
                        "name": "Mława",
                        "latitude": "53.11278000",
                        "longitude": "20.38410000"
                    },
                    {
                        "id": 87128,
                        "name": "Młodzieszyn",
                        "latitude": "52.29945000",
                        "longitude": "20.20017000"
                    },
                    {
                        "id": 87130,
                        "name": "Młynarze",
                        "latitude": "52.95417000",
                        "longitude": "21.41141000"
                    },
                    {
                        "id": 87080,
                        "name": "Mochowo",
                        "latitude": "52.76570000",
                        "longitude": "19.55592000"
                    },
                    {
                        "id": 87084,
                        "name": "Mogielnica",
                        "latitude": "51.69432000",
                        "longitude": "20.72227000"
                    },
                    {
                        "id": 87087,
                        "name": "Mokobody",
                        "latitude": "52.26523000",
                        "longitude": "22.11182000"
                    },
                    {
                        "id": 87088,
                        "name": "Mokotów",
                        "latitude": "52.19340000",
                        "longitude": "21.03487000"
                    },
                    {
                        "id": 87091,
                        "name": "Mordy",
                        "latitude": "52.21160000",
                        "longitude": "22.51725000"
                    },
                    {
                        "id": 87102,
                        "name": "Mrozy",
                        "latitude": "52.01975000",
                        "longitude": "20.36702000"
                    },
                    {
                        "id": 87111,
                        "name": "Mszczonów",
                        "latitude": "51.97415000",
                        "longitude": "20.52083000"
                    },
                    {
                        "id": 87117,
                        "name": "Mysiadło",
                        "latitude": "52.10216000",
                        "longitude": "21.01856000"
                    },
                    {
                        "id": 87119,
                        "name": "Myszyniec",
                        "latitude": "53.38055000",
                        "longitude": "21.34961000"
                    },
                    {
                        "id": 87131,
                        "name": "Nadarzyn",
                        "latitude": "52.09438000",
                        "longitude": "20.80776000"
                    },
                    {
                        "id": 87140,
                        "name": "Naruszewo",
                        "latitude": "52.52687000",
                        "longitude": "20.35157000"
                    },
                    {
                        "id": 87141,
                        "name": "Nasielsk",
                        "latitude": "52.58887000",
                        "longitude": "20.80553000"
                    },
                    {
                        "id": 87166,
                        "name": "Nieporęt",
                        "latitude": "52.43152000",
                        "longitude": "21.03212000"
                    },
                    {
                        "id": 87182,
                        "name": "Nowe Grocholice",
                        "latitude": "52.15924000",
                        "longitude": "20.91110000"
                    },
                    {
                        "id": 87183,
                        "name": "Nowe Lipiny",
                        "latitude": "52.35789000",
                        "longitude": "21.27125000"
                    },
                    {
                        "id": 87185,
                        "name": "Nowe Miasto",
                        "latitude": "52.65691000",
                        "longitude": "20.62838000"
                    },
                    {
                        "id": 87187,
                        "name": "Nowe Miasto nad Pilicą",
                        "latitude": "51.61812000",
                        "longitude": "20.57619000"
                    },
                    {
                        "id": 87201,
                        "name": "Nowy Duninów",
                        "latitude": "52.58271000",
                        "longitude": "19.47996000"
                    },
                    {
                        "id": 87203,
                        "name": "Nowy Dwór Mazowiecki",
                        "latitude": "52.43022000",
                        "longitude": "20.71652000"
                    },
                    {
                        "id": 87212,
                        "name": "Nur",
                        "latitude": "52.66826000",
                        "longitude": "22.32207000"
                    },
                    {
                        "id": 87220,
                        "name": "Obryte",
                        "latitude": "52.71633000",
                        "longitude": "21.24945000"
                    },
                    {
                        "id": 87226,
                        "name": "Ochota",
                        "latitude": "52.22096000",
                        "longitude": "20.98526000"
                    },
                    {
                        "id": 87230,
                        "name": "Odrzywół",
                        "latitude": "51.51953000",
                        "longitude": "20.55559000"
                    },
                    {
                        "id": 87232,
                        "name": "Ojrzeń",
                        "latitude": "52.76570000",
                        "longitude": "20.54315000"
                    },
                    {
                        "id": 87260,
                        "name": "Opinogóra Górna",
                        "latitude": "52.90554000",
                        "longitude": "20.71781000"
                    },
                    {
                        "id": 87270,
                        "name": "Orońsko",
                        "latitude": "51.31339000",
                        "longitude": "20.99067000"
                    },
                    {
                        "id": 87277,
                        "name": "Osieck",
                        "latitude": "51.96653000",
                        "longitude": "21.41913000"
                    },
                    {
                        "id": 87305,
                        "name": "Ostrołęka",
                        "latitude": "53.08621000",
                        "longitude": "21.57566000"
                    },
                    {
                        "id": 87310,
                        "name": "Ostrów Mazowiecka",
                        "latitude": "52.80245000",
                        "longitude": "21.89507000"
                    },
                    {
                        "id": 87312,
                        "name": "Ostrówek",
                        "latitude": "52.55350000",
                        "longitude": "21.76014000"
                    },
                    {
                        "id": 87316,
                        "name": "Otrębusy",
                        "latitude": "52.12843000",
                        "longitude": "20.76073000"
                    },
                    {
                        "id": 87317,
                        "name": "Otwock",
                        "latitude": "52.10577000",
                        "longitude": "21.26129000"
                    },
                    {
                        "id": 87319,
                        "name": "Owczarnia",
                        "latitude": "52.11114000",
                        "longitude": "20.70468000"
                    },
                    {
                        "id": 87329,
                        "name": "Ożarów Mazowiecki",
                        "latitude": "52.21039000",
                        "longitude": "20.79716000"
                    },
                    {
                        "id": 87332,
                        "name": "Pacyna",
                        "latitude": "52.30281000",
                        "longitude": "19.70982000"
                    },
                    {
                        "id": 87344,
                        "name": "Paprotnia",
                        "latitude": "52.20513000",
                        "longitude": "20.42320000"
                    },
                    {
                        "id": 87349,
                        "name": "Parysów",
                        "latitude": "51.97584000",
                        "longitude": "21.68006000"
                    },
                    {
                        "id": 87368,
                        "name": "Piaseczno",
                        "latitude": "52.08140000",
                        "longitude": "21.02397000"
                    },
                    {
                        "id": 87372,
                        "name": "Piastów",
                        "latitude": "52.18435000",
                        "longitude": "20.83952000"
                    },
                    {
                        "id": 87387,
                        "name": "Pilawa",
                        "latitude": "51.95945000",
                        "longitude": "21.53089000"
                    },
                    {
                        "id": 87392,
                        "name": "Pionki",
                        "latitude": "51.47604000",
                        "longitude": "21.44995000"
                    },
                    {
                        "id": 87864,
                        "name": "Płock",
                        "latitude": "52.54682000",
                        "longitude": "19.70638000"
                    },
                    {
                        "id": 87865,
                        "name": "Płoniawy-Bramura",
                        "latitude": "52.97780000",
                        "longitude": "21.07178000"
                    },
                    {
                        "id": 87867,
                        "name": "Płońsk",
                        "latitude": "52.62348000",
                        "longitude": "20.37552000"
                    },
                    {
                        "id": 87413,
                        "name": "Podebłocie",
                        "latitude": "51.64023000",
                        "longitude": "21.74420000"
                    },
                    {
                        "id": 87417,
                        "name": "Podkowa Leśna",
                        "latitude": "52.12237000",
                        "longitude": "20.72665000"
                    },
                    {
                        "id": 87427,
                        "name": "Pokrzywnica",
                        "latitude": "52.62072000",
                        "longitude": "21.01925000"
                    },
                    {
                        "id": 87435,
                        "name": "Policzna",
                        "latitude": "51.45545000",
                        "longitude": "21.62684000"
                    },
                    {
                        "id": 87438,
                        "name": "Pomiechówek",
                        "latitude": "52.47138000",
                        "longitude": "20.72923000"
                    },
                    {
                        "id": 87780,
                        "name": "Poświętne",
                        "latitude": "52.32967000",
                        "longitude": "21.42137000"
                    },
                    {
                        "id": 87455,
                        "name": "Potworów",
                        "latitude": "51.50874000",
                        "longitude": "20.72176000"
                    },
                    {
                        "id": 87462,
                        "name": "Powiat białobrzeski",
                        "latitude": "51.62102000",
                        "longitude": "20.94328000"
                    },
                    {
                        "id": 87488,
                        "name": "Powiat ciechanowski",
                        "latitude": "52.90207000",
                        "longitude": "20.57631000"
                    },
                    {
                        "id": 87500,
                        "name": "Powiat garwoliński",
                        "latitude": "51.82657000",
                        "longitude": "21.61615000"
                    },
                    {
                        "id": 87509,
                        "name": "Powiat gostyniński",
                        "latitude": "52.38988000",
                        "longitude": "19.62187000"
                    },
                    {
                        "id": 87513,
                        "name": "Powiat grodziski",
                        "latitude": "52.06391000",
                        "longitude": "20.59408000"
                    },
                    {
                        "id": 87518,
                        "name": "Powiat grójecki",
                        "latitude": "51.75742000",
                        "longitude": "20.83661000"
                    },
                    {
                        "id": 87546,
                        "name": "Powiat kozienicki",
                        "latitude": "51.63946000",
                        "longitude": "21.49580000"
                    },
                    {
                        "id": 87564,
                        "name": "Powiat legionowski",
                        "latitude": "52.45179000",
                        "longitude": "20.94356000"
                    },
                    {
                        "id": 87572,
                        "name": "Powiat lipski",
                        "latitude": "51.15879000",
                        "longitude": "21.56753000"
                    },
                    {
                        "id": 87751,
                        "name": "Powiat łosicki",
                        "latitude": "52.22363000",
                        "longitude": "22.84510000"
                    },
                    {
                        "id": 87581,
                        "name": "Powiat makowski",
                        "latitude": "52.94770000",
                        "longitude": "21.17950000"
                    },
                    {
                        "id": 87589,
                        "name": "Powiat miński",
                        "latitude": "52.18429000",
                        "longitude": "21.60893000"
                    },
                    {
                        "id": 87596,
                        "name": "Powiat mławski",
                        "latitude": "53.05496000",
                        "longitude": "20.37708000"
                    },
                    {
                        "id": 87601,
                        "name": "Powiat nowodworski",
                        "latitude": "52.46585000",
                        "longitude": "20.66405000"
                    },
                    {
                        "id": 87622,
                        "name": "Powiat ostrołęcki",
                        "latitude": "53.14001000",
                        "longitude": "21.50699000"
                    },
                    {
                        "id": 87620,
                        "name": "Powiat ostrowski",
                        "latitude": "52.79495000",
                        "longitude": "22.03250000"
                    },
                    {
                        "id": 87625,
                        "name": "Powiat otwocki",
                        "latitude": "52.04898000",
                        "longitude": "21.37251000"
                    },
                    {
                        "id": 87631,
                        "name": "Powiat piaseczyński",
                        "latitude": "52.01634000",
                        "longitude": "20.98319000"
                    },
                    {
                        "id": 87653,
                        "name": "Powiat płocki",
                        "latitude": "52.55465000",
                        "longitude": "19.78570000"
                    },
                    {
                        "id": 87654,
                        "name": "Powiat płoński",
                        "latitude": "52.63894000",
                        "longitude": "20.34710000"
                    },
                    {
                        "id": 87643,
                        "name": "Powiat pruszkowski",
                        "latitude": "52.10088000",
                        "longitude": "20.80992000"
                    },
                    {
                        "id": 87644,
                        "name": "Powiat przasnyski",
                        "latitude": "53.11360000",
                        "longitude": "20.93940000"
                    },
                    {
                        "id": 87647,
                        "name": "Powiat przysuski",
                        "latitude": "51.42366000",
                        "longitude": "20.65098000"
                    },
                    {
                        "id": 87651,
                        "name": "Powiat pułtuski",
                        "latitude": "52.67207000",
                        "longitude": "21.02401000"
                    },
                    {
                        "id": 87656,
                        "name": "Powiat radomski",
                        "latitude": "51.33582000",
                        "longitude": "21.16193000"
                    },
                    {
                        "id": 87670,
                        "name": "Powiat siedlecki",
                        "latitude": "52.19186000",
                        "longitude": "22.30406000"
                    },
                    {
                        "id": 87673,
                        "name": "Powiat sierpecki",
                        "latitude": "52.83353000",
                        "longitude": "19.71216000"
                    },
                    {
                        "id": 87676,
                        "name": "Powiat sochaczewski",
                        "latitude": "52.26689000",
                        "longitude": "20.21338000"
                    },
                    {
                        "id": 87677,
                        "name": "Powiat sokołowski",
                        "latitude": "52.49538000",
                        "longitude": "22.26897000"
                    },
                    {
                        "id": 87695,
                        "name": "Powiat szydłowiecki",
                        "latitude": "51.25600000",
                        "longitude": "20.84256000"
                    },
                    {
                        "id": 87713,
                        "name": "Powiat warszawski zachodni",
                        "latitude": "52.26838000",
                        "longitude": "20.61913000"
                    },
                    {
                        "id": 87732,
                        "name": "Powiat węgrowski",
                        "latitude": "52.45628000",
                        "longitude": "21.87342000"
                    },
                    {
                        "id": 87722,
                        "name": "Powiat wołomiński",
                        "latitude": "52.40616000",
                        "longitude": "21.40121000"
                    },
                    {
                        "id": 87728,
                        "name": "Powiat wyszkowski",
                        "latitude": "52.65137000",
                        "longitude": "21.44537000"
                    },
                    {
                        "id": 87767,
                        "name": "Powiat żuromiński",
                        "latitude": "53.01658000",
                        "longitude": "19.89102000"
                    },
                    {
                        "id": 87743,
                        "name": "Powiat zwoleński",
                        "latitude": "51.36079000",
                        "longitude": "21.59279000"
                    },
                    {
                        "id": 87768,
                        "name": "Powiat żyrardowski",
                        "latitude": "52.00028000",
                        "longitude": "20.43275000"
                    },
                    {
                        "id": 87786,
                        "name": "Praga Północ",
                        "latitude": "52.25443000",
                        "longitude": "21.03472000"
                    },
                    {
                        "id": 87785,
                        "name": "Praga Południe",
                        "latitude": "52.24424000",
                        "longitude": "21.08545000"
                    },
                    {
                        "id": 87788,
                        "name": "Prażmów",
                        "latitude": "51.94040000",
                        "longitude": "20.95479000"
                    },
                    {
                        "id": 87790,
                        "name": "Promna",
                        "latitude": "51.68006000",
                        "longitude": "20.95917000"
                    },
                    {
                        "id": 87799,
                        "name": "Pruszków",
                        "latitude": "52.17072000",
                        "longitude": "20.81214000"
                    },
                    {
                        "id": 87800,
                        "name": "Przasnysz",
                        "latitude": "53.01907000",
                        "longitude": "20.88029000"
                    },
                    {
                        "id": 87814,
                        "name": "Przesmyki",
                        "latitude": "52.26816000",
                        "longitude": "22.58394000"
                    },
                    {
                        "id": 87835,
                        "name": "Przyłęk",
                        "latitude": "51.30856000",
                        "longitude": "21.74744000"
                    },
                    {
                        "id": 87828,
                        "name": "Przysucha",
                        "latitude": "51.35858000",
                        "longitude": "20.62889000"
                    },
                    {
                        "id": 87833,
                        "name": "Przytyk",
                        "latitude": "51.46567000",
                        "longitude": "20.90587000"
                    },
                    {
                        "id": 87852,
                        "name": "Pułtusk",
                        "latitude": "52.70250000",
                        "longitude": "21.08276000"
                    },
                    {
                        "id": 87849,
                        "name": "Puszcza Mariańska",
                        "latitude": "51.97901000",
                        "longitude": "20.35037000"
                    },
                    {
                        "id": 87873,
                        "name": "Raciąż",
                        "latitude": "52.78152000",
                        "longitude": "20.11770000"
                    },
                    {
                        "id": 87884,
                        "name": "Radom",
                        "latitude": "51.40253000",
                        "longitude": "21.14714000"
                    },
                    {
                        "id": 87895,
                        "name": "Radzanów",
                        "latitude": "52.94238000",
                        "longitude": "20.09219000"
                    },
                    {
                        "id": 87894,
                        "name": "Radzanowo",
                        "latitude": "52.57306000",
                        "longitude": "19.89109000"
                    },
                    {
                        "id": 87897,
                        "name": "Radziejowice",
                        "latitude": "52.00834000",
                        "longitude": "20.54770000"
                    },
                    {
                        "id": 87902,
                        "name": "Radzymin",
                        "latitude": "52.41592000",
                        "longitude": "21.18415000"
                    },
                    {
                        "id": 87916,
                        "name": "Raszyn",
                        "latitude": "52.15603000",
                        "longitude": "20.92260000"
                    },
                    {
                        "id": 87922,
                        "name": "Regimin",
                        "latitude": "52.94166000",
                        "longitude": "20.55319000"
                    },
                    {
                        "id": 87936,
                        "name": "Rembertów",
                        "latitude": "52.26059000",
                        "longitude": "21.16355000"
                    },
                    {
                        "id": 87937,
                        "name": "Repki",
                        "latitude": "52.38555000",
                        "longitude": "22.39117000"
                    },
                    {
                        "id": 87968,
                        "name": "Rościszewo",
                        "latitude": "52.90331000",
                        "longitude": "19.77419000"
                    },
                    {
                        "id": 88033,
                        "name": "Różan",
                        "latitude": "52.88757000",
                        "longitude": "21.39105000"
                    },
                    {
                        "id": 87988,
                        "name": "Rusinów",
                        "latitude": "51.43678000",
                        "longitude": "20.58701000"
                    },
                    {
                        "id": 87993,
                        "name": "Rybie",
                        "latitude": "52.15229000",
                        "longitude": "20.93655000"
                    },
                    {
                        "id": 87995,
                        "name": "Rybno",
                        "latitude": "52.24278000",
                        "longitude": "20.10301000"
                    },
                    {
                        "id": 88001,
                        "name": "Ryczywół",
                        "latitude": "51.69118000",
                        "longitude": "21.42197000"
                    },
                    {
                        "id": 88032,
                        "name": "Rząśnik",
                        "latitude": "52.71332000",
                        "longitude": "21.36772000"
                    },
                    {
                        "id": 88016,
                        "name": "Rzeczniów",
                        "latitude": "51.12804000",
                        "longitude": "21.44008000"
                    },
                    {
                        "id": 88019,
                        "name": "Rzekuń",
                        "latitude": "53.04756000",
                        "longitude": "21.62069000"
                    },
                    {
                        "id": 88025,
                        "name": "Rzewnie",
                        "latitude": "52.83508000",
                        "longitude": "21.33682000"
                    },
                    {
                        "id": 88039,
                        "name": "Sabnie",
                        "latitude": "52.50097000",
                        "longitude": "22.30697000"
                    },
                    {
                        "id": 88044,
                        "name": "Sadowne",
                        "latitude": "52.64124000",
                        "longitude": "21.84563000"
                    },
                    {
                        "id": 88048,
                        "name": "Sanniki",
                        "latitude": "52.33046000",
                        "longitude": "19.86766000"
                    },
                    {
                        "id": 88051,
                        "name": "Sarnaki",
                        "latitude": "52.31504000",
                        "longitude": "22.89044000"
                    },
                    {
                        "id": 88057,
                        "name": "Serock",
                        "latitude": "52.51036000",
                        "longitude": "21.06910000"
                    },
                    {
                        "id": 88064,
                        "name": "Siedlce",
                        "latitude": "52.16772000",
                        "longitude": "22.29006000"
                    },
                    {
                        "id": 88075,
                        "name": "Siemiątkowo",
                        "latitude": "52.88110000",
                        "longitude": "20.02893000"
                    },
                    {
                        "id": 88081,
                        "name": "Siennica",
                        "latitude": "52.09164000",
                        "longitude": "21.61921000"
                    },
                    {
                        "id": 88083,
                        "name": "Sienno",
                        "latitude": "51.08773000",
                        "longitude": "21.48325000"
                    },
                    {
                        "id": 88091,
                        "name": "Sierpc",
                        "latitude": "52.85680000",
                        "longitude": "19.66913000"
                    },
                    {
                        "id": 88099,
                        "name": "Skaryszew",
                        "latitude": "51.31075000",
                        "longitude": "21.25233000"
                    },
                    {
                        "id": 88122,
                        "name": "Skórzec",
                        "latitude": "52.10727000",
                        "longitude": "22.13052000"
                    },
                    {
                        "id": 88346,
                        "name": "Słubice",
                        "latitude": "52.36942000",
                        "longitude": "19.93881000"
                    },
                    {
                        "id": 88352,
                        "name": "Słupno",
                        "latitude": "52.38409000",
                        "longitude": "21.15572000"
                    },
                    {
                        "id": 88130,
                        "name": "Sobienie Jeziory",
                        "latitude": "51.93273000",
                        "longitude": "21.30335000"
                    },
                    {
                        "id": 88132,
                        "name": "Sobolew",
                        "latitude": "51.73660000",
                        "longitude": "21.66349000"
                    },
                    {
                        "id": 88134,
                        "name": "Sochaczew",
                        "latitude": "52.22944000",
                        "longitude": "20.23838000"
                    },
                    {
                        "id": 88135,
                        "name": "Sochocin",
                        "latitude": "52.68715000",
                        "longitude": "20.47259000"
                    },
                    {
                        "id": 88140,
                        "name": "Sokołów Podlaski",
                        "latitude": "52.40677000",
                        "longitude": "22.25307000"
                    },
                    {
                        "id": 88143,
                        "name": "Solec Nad Wisłą",
                        "latitude": "51.13633000",
                        "longitude": "21.76563000"
                    },
                    {
                        "id": 88156,
                        "name": "Sońsk",
                        "latitude": "52.78164000",
                        "longitude": "20.69901000"
                    },
                    {
                        "id": 88840,
                        "name": "Śródmieście",
                        "latitude": "52.22904000",
                        "longitude": "21.01644000"
                    },
                    {
                        "id": 88169,
                        "name": "Stanisławów",
                        "latitude": "52.28937000",
                        "longitude": "21.54848000"
                    },
                    {
                        "id": 88170,
                        "name": "Stanisławów Pierwszy",
                        "latitude": "52.37485000",
                        "longitude": "21.05184000"
                    },
                    {
                        "id": 88173,
                        "name": "Stara Błotnica",
                        "latitude": "51.54676000",
                        "longitude": "20.97479000"
                    },
                    {
                        "id": 88177,
                        "name": "Stara Kornica",
                        "latitude": "52.18183000",
                        "longitude": "22.93752000"
                    },
                    {
                        "id": 88181,
                        "name": "Stare Babice",
                        "latitude": "52.26028000",
                        "longitude": "20.83403000"
                    },
                    {
                        "id": 88193,
                        "name": "Staroźreby",
                        "latitude": "52.63265000",
                        "longitude": "19.98550000"
                    },
                    {
                        "id": 88204,
                        "name": "Sterdyń",
                        "latitude": "52.58026000",
                        "longitude": "22.29358000"
                    },
                    {
                        "id": 88205,
                        "name": "Stoczek",
                        "latitude": "52.54332000",
                        "longitude": "21.90013000"
                    },
                    {
                        "id": 88211,
                        "name": "Strachówka",
                        "latitude": "52.42692000",
                        "longitude": "21.63500000"
                    },
                    {
                        "id": 88215,
                        "name": "Stromiec",
                        "latitude": "51.64700000",
                        "longitude": "21.09229000"
                    },
                    {
                        "id": 88225,
                        "name": "Strzegowo",
                        "latitude": "52.89394000",
                        "longitude": "20.28548000"
                    },
                    {
                        "id": 88241,
                        "name": "Stupsk",
                        "latitude": "53.02258000",
                        "longitude": "20.43680000"
                    },
                    {
                        "id": 88247,
                        "name": "Sucha",
                        "latitude": "51.61999000",
                        "longitude": "20.94887000"
                    },
                    {
                        "id": 88252,
                        "name": "Suchożebry",
                        "latitude": "52.25948000",
                        "longitude": "22.25289000"
                    },
                    {
                        "id": 88255,
                        "name": "Sulbiny Górne",
                        "latitude": "51.87321000",
                        "longitude": "21.63174000"
                    },
                    {
                        "id": 88258,
                        "name": "Sulejówek",
                        "latitude": "52.25221000",
                        "longitude": "21.26902000"
                    },
                    {
                        "id": 88270,
                        "name": "Sułkowice",
                        "latitude": "51.92310000",
                        "longitude": "21.08929000"
                    },
                    {
                        "id": 88852,
                        "name": "Świercze",
                        "latitude": "52.67055000",
                        "longitude": "20.76390000"
                    },
                    {
                        "id": 88279,
                        "name": "Sypniewo",
                        "latitude": "53.00580000",
                        "longitude": "21.30730000"
                    },
                    {
                        "id": 88302,
                        "name": "Szczutowo",
                        "latitude": "52.94047000",
                        "longitude": "19.57438000"
                    },
                    {
                        "id": 88306,
                        "name": "Szelków",
                        "latitude": "52.83487000",
                        "longitude": "21.21769000"
                    },
                    {
                        "id": 88314,
                        "name": "Szreńsk",
                        "latitude": "53.01277000",
                        "longitude": "20.12009000"
                    },
                    {
                        "id": 88319,
                        "name": "Szydłowiec",
                        "latitude": "51.22823000",
                        "longitude": "20.86106000"
                    },
                    {
                        "id": 88320,
                        "name": "Szydłowo",
                        "latitude": "53.08062000",
                        "longitude": "20.45071000"
                    },
                    {
                        "id": 88354,
                        "name": "Tarczyn",
                        "latitude": "51.98197000",
                        "longitude": "20.83394000"
                    },
                    {
                        "id": 88357,
                        "name": "Targówek",
                        "latitude": "52.29185000",
                        "longitude": "21.04845000"
                    },
                    {
                        "id": 88370,
                        "name": "Tczów",
                        "latitude": "51.32600000",
                        "longitude": "21.44677000"
                    },
                    {
                        "id": 88373,
                        "name": "Teresin",
                        "latitude": "52.19887000",
                        "longitude": "20.41672000"
                    },
                    {
                        "id": 88445,
                        "name": "Tłuszcz",
                        "latitude": "52.43058000",
                        "longitude": "21.43561000"
                    },
                    {
                        "id": 88415,
                        "name": "Trąbki",
                        "latitude": "51.94792000",
                        "longitude": "21.59929000"
                    },
                    {
                        "id": 88387,
                        "name": "Trablice",
                        "latitude": "51.35249000",
                        "longitude": "21.12877000"
                    },
                    {
                        "id": 88389,
                        "name": "Trojanów",
                        "latitude": "51.69225000",
                        "longitude": "21.81112000"
                    },
                    {
                        "id": 88390,
                        "name": "Troszyn",
                        "latitude": "53.03115000",
                        "longitude": "21.73083000"
                    },
                    {
                        "id": 88391,
                        "name": "Truskaw",
                        "latitude": "52.30124000",
                        "longitude": "20.78244000"
                    },
                    {
                        "id": 88457,
                        "name": "Ursus",
                        "latitude": "52.19517000",
                        "longitude": "20.88419000"
                    },
                    {
                        "id": 88458,
                        "name": "Ursynów",
                        "latitude": "52.15051000",
                        "longitude": "21.05041000"
                    },
                    {
                        "id": 88477,
                        "name": "Warka",
                        "latitude": "51.78430000",
                        "longitude": "21.19091000"
                    },
                    {
                        "id": 88480,
                        "name": "Warsaw",
                        "latitude": "52.22977000",
                        "longitude": "21.01178000"
                    },
                    {
                        "id": 88481,
                        "name": "Warszawa",
                        "latitude": "52.23547000",
                        "longitude": "21.04191000"
                    },
                    {
                        "id": 88485,
                        "name": "Wawer",
                        "latitude": "52.19656000",
                        "longitude": "21.17752000"
                    },
                    {
                        "id": 88645,
                        "name": "Węgrów",
                        "latitude": "52.39954000",
                        "longitude": "22.01634000"
                    },
                    {
                        "id": 88493,
                        "name": "Wesoła",
                        "latitude": "52.25451000",
                        "longitude": "21.22407000"
                    },
                    {
                        "id": 88497,
                        "name": "Wieczfnia Kościelna",
                        "latitude": "53.19534000",
                        "longitude": "20.47637000"
                    },
                    {
                        "id": 88503,
                        "name": "Wieliszew",
                        "latitude": "52.45130000",
                        "longitude": "20.96827000"
                    },
                    {
                        "id": 88512,
                        "name": "Wieniawa",
                        "latitude": "51.36171000",
                        "longitude": "20.79489000"
                    },
                    {
                        "id": 88517,
                        "name": "Wierzbica",
                        "latitude": "51.24940000",
                        "longitude": "21.08259000"
                    },
                    {
                        "id": 88520,
                        "name": "Wierzbno",
                        "latitude": "52.31008000",
                        "longitude": "21.85902000"
                    },
                    {
                        "id": 88531,
                        "name": "Wilanów",
                        "latitude": "52.16311000",
                        "longitude": "21.08748000"
                    },
                    {
                        "id": 88537,
                        "name": "Wilga",
                        "latitude": "51.85211000",
                        "longitude": "21.37751000"
                    },
                    {
                        "id": 88544,
                        "name": "Winnica",
                        "latitude": "52.64306000",
                        "longitude": "20.94114000"
                    },
                    {
                        "id": 88545,
                        "name": "Wiskitki",
                        "latitude": "52.08831000",
                        "longitude": "20.38708000"
                    },
                    {
                        "id": 88561,
                        "name": "Wiśniew",
                        "latitude": "52.07265000",
                        "longitude": "22.29392000"
                    },
                    {
                        "id": 88562,
                        "name": "Wiśniewo",
                        "latitude": "53.06474000",
                        "longitude": "20.34805000"
                    },
                    {
                        "id": 88648,
                        "name": "Włochy",
                        "latitude": "52.17941000",
                        "longitude": "20.94612000"
                    },
                    {
                        "id": 88566,
                        "name": "Wodynie",
                        "latitude": "52.04040000",
                        "longitude": "21.95575000"
                    },
                    {
                        "id": 88580,
                        "name": "Wola",
                        "latitude": "52.24010000",
                        "longitude": "20.98869000"
                    },
                    {
                        "id": 88588,
                        "name": "Wola Rębkowska",
                        "latitude": "51.90181000",
                        "longitude": "21.55818000"
                    },
                    {
                        "id": 88593,
                        "name": "Wolanów",
                        "latitude": "51.38030000",
                        "longitude": "20.97702000"
                    },
                    {
                        "id": 88599,
                        "name": "Wołomin",
                        "latitude": "52.34006000",
                        "longitude": "21.24207000"
                    },
                    {
                        "id": 88626,
                        "name": "Wyśmierzyce",
                        "latitude": "51.62494000",
                        "longitude": "20.81394000"
                    },
                    {
                        "id": 88624,
                        "name": "Wyszków",
                        "latitude": "52.59278000",
                        "longitude": "21.45840000"
                    },
                    {
                        "id": 88625,
                        "name": "Wyszogród",
                        "latitude": "52.38988000",
                        "longitude": "20.19081000"
                    },
                    {
                        "id": 88868,
                        "name": "Żabia Wola",
                        "latitude": "52.03169000",
                        "longitude": "20.69112000"
                    },
                    {
                        "id": 88869,
                        "name": "Żabieniec",
                        "latitude": "52.05856000",
                        "longitude": "21.04817000"
                    },
                    {
                        "id": 88738,
                        "name": "Ząbki",
                        "latitude": "52.29271000",
                        "longitude": "21.10539000"
                    },
                    {
                        "id": 88676,
                        "name": "Zakroczym",
                        "latitude": "52.43351000",
                        "longitude": "20.61207000"
                    },
                    {
                        "id": 88677,
                        "name": "Zakrzew",
                        "latitude": "51.44095000",
                        "longitude": "21.00105000"
                    },
                    {
                        "id": 88685,
                        "name": "Zalesie Górne",
                        "latitude": "52.02768000",
                        "longitude": "21.03659000"
                    },
                    {
                        "id": 88707,
                        "name": "Załuski",
                        "latitude": "52.51152000",
                        "longitude": "20.52864000"
                    },
                    {
                        "id": 88700,
                        "name": "Zatory",
                        "latitude": "52.59929000",
                        "longitude": "21.18258000"
                    },
                    {
                        "id": 88703,
                        "name": "Zawidz",
                        "latitude": "52.82745000",
                        "longitude": "19.87367000"
                    },
                    {
                        "id": 88710,
                        "name": "Zbuczyn",
                        "latitude": "52.08974000",
                        "longitude": "22.43829000"
                    },
                    {
                        "id": 88882,
                        "name": "Żelechów",
                        "latitude": "51.81051000",
                        "longitude": "21.89721000"
                    },
                    {
                        "id": 88729,
                        "name": "Zielonka",
                        "latitude": "52.30376000",
                        "longitude": "21.16018000"
                    },
                    {
                        "id": 88889,
                        "name": "Żoliborz",
                        "latitude": "52.26896000",
                        "longitude": "20.98644000"
                    },
                    {
                        "id": 88895,
                        "name": "Żuromin",
                        "latitude": "53.06611000",
                        "longitude": "19.90894000"
                    },
                    {
                        "id": 88737,
                        "name": "Zwoleń",
                        "latitude": "51.35542000",
                        "longitude": "21.58768000"
                    },
                    {
                        "id": 88899,
                        "name": "Żyrardów",
                        "latitude": "52.04880000",
                        "longitude": "20.44599000"
                    }
                ]
            },
            {
                "id": 1632,
                "name": "Podlaskie",
                "iso2": "20",
                "latitude": "53.06971590",
                "longitude": "22.96746390",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85787,
                        "name": "Augustów",
                        "latitude": "53.84321000",
                        "longitude": "22.97979000"
                    },
                    {
                        "id": 85845,
                        "name": "Białowieża",
                        "latitude": "52.70000000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 85850,
                        "name": "Białystok",
                        "latitude": "53.13333000",
                        "longitude": "23.16433000"
                    },
                    {
                        "id": 85860,
                        "name": "Bielsk Podlaski",
                        "latitude": "52.76512000",
                        "longitude": "23.18647000"
                    },
                    {
                        "id": 85933,
                        "name": "Boćki",
                        "latitude": "52.65155000",
                        "longitude": "23.04485000"
                    },
                    {
                        "id": 85937,
                        "name": "Brańsk",
                        "latitude": "52.74440000",
                        "longitude": "22.83774000"
                    },
                    {
                        "id": 86052,
                        "name": "Choroszcz",
                        "latitude": "53.14332000",
                        "longitude": "22.98889000"
                    },
                    {
                        "id": 86076,
                        "name": "Ciechanowiec",
                        "latitude": "52.67828000",
                        "longitude": "22.49815000"
                    },
                    {
                        "id": 86105,
                        "name": "Czarna Białostocka",
                        "latitude": "53.30509000",
                        "longitude": "23.28146000"
                    },
                    {
                        "id": 86126,
                        "name": "Czeremcha",
                        "latitude": "52.51667000",
                        "longitude": "23.35000000"
                    },
                    {
                        "id": 86148,
                        "name": "Czyżew",
                        "latitude": "52.79768000",
                        "longitude": "22.31237000"
                    },
                    {
                        "id": 86238,
                        "name": "Dąbrowa Białostocka",
                        "latitude": "53.65364000",
                        "longitude": "23.34792000"
                    },
                    {
                        "id": 86179,
                        "name": "Dobrzyniewo Duże",
                        "latitude": "53.20022000",
                        "longitude": "23.01129000"
                    },
                    {
                        "id": 86200,
                        "name": "Drohiczyn",
                        "latitude": "52.40011000",
                        "longitude": "22.65853000"
                    },
                    {
                        "id": 86270,
                        "name": "Filipów",
                        "latitude": "54.18037000",
                        "longitude": "22.62076000"
                    },
                    {
                        "id": 86331,
                        "name": "Goniadz",
                        "latitude": "53.48953000",
                        "longitude": "22.73578000"
                    },
                    {
                        "id": 86370,
                        "name": "Grajewo",
                        "latitude": "53.64728000",
                        "longitude": "22.45537000"
                    },
                    {
                        "id": 86384,
                        "name": "Grudki",
                        "latitude": "53.09488000",
                        "longitude": "23.66848000"
                    },
                    {
                        "id": 86439,
                        "name": "Hajnówka",
                        "latitude": "52.74328000",
                        "longitude": "23.58122000"
                    },
                    {
                        "id": 86545,
                        "name": "Jedwabne",
                        "latitude": "53.28554000",
                        "longitude": "22.30353000"
                    },
                    {
                        "id": 86646,
                        "name": "Kleszczele",
                        "latitude": "52.57314000",
                        "longitude": "23.32539000"
                    },
                    {
                        "id": 86659,
                        "name": "Knyszyn",
                        "latitude": "53.31406000",
                        "longitude": "22.91963000"
                    },
                    {
                        "id": 86679,
                        "name": "Kolno",
                        "latitude": "53.41148000",
                        "longitude": "21.92905000"
                    },
                    {
                        "id": 86771,
                        "name": "Krasnopol",
                        "latitude": "54.11613000",
                        "longitude": "23.20476000"
                    },
                    {
                        "id": 86797,
                        "name": "Krynki",
                        "latitude": "53.26444000",
                        "longitude": "23.77304000"
                    },
                    {
                        "id": 86847,
                        "name": "Kuźnica",
                        "latitude": "53.51094000",
                        "longitude": "23.64953000"
                    },
                    {
                        "id": 86921,
                        "name": "Lipsk",
                        "latitude": "53.73312000",
                        "longitude": "23.40225000"
                    },
                    {
                        "id": 88768,
                        "name": "Łapy",
                        "latitude": "52.99110000",
                        "longitude": "22.88422000"
                    },
                    {
                        "id": 88786,
                        "name": "Łomża",
                        "latitude": "53.17806000",
                        "longitude": "22.05935000"
                    },
                    {
                        "id": 87010,
                        "name": "Mały Płock",
                        "latitude": "53.30385000",
                        "longitude": "22.02836000"
                    },
                    {
                        "id": 87021,
                        "name": "Michałowo",
                        "latitude": "53.03492000",
                        "longitude": "23.60996000"
                    },
                    {
                        "id": 87048,
                        "name": "Milejczyce",
                        "latitude": "52.51967000",
                        "longitude": "23.13206000"
                    },
                    {
                        "id": 87100,
                        "name": "Mońki",
                        "latitude": "53.40496000",
                        "longitude": "22.79791000"
                    },
                    {
                        "id": 87138,
                        "name": "Narew",
                        "latitude": "52.91418000",
                        "longitude": "23.51984000"
                    },
                    {
                        "id": 87196,
                        "name": "Nowogród",
                        "latitude": "53.22698000",
                        "longitude": "21.88210000"
                    },
                    {
                        "id": 87213,
                        "name": "Nurzec-Stacja",
                        "latitude": "52.46249000",
                        "longitude": "23.08571000"
                    },
                    {
                        "id": 87266,
                        "name": "Orla",
                        "latitude": "52.70546000",
                        "longitude": "23.33213000"
                    },
                    {
                        "id": 87402,
                        "name": "Piątnica",
                        "latitude": "53.19657000",
                        "longitude": "22.09591000"
                    },
                    {
                        "id": 87458,
                        "name": "Powiat augustowski",
                        "latitude": "53.79742000",
                        "longitude": "23.14275000"
                    },
                    {
                        "id": 87464,
                        "name": "Powiat białostocki",
                        "latitude": "53.09897000",
                        "longitude": "23.59314000"
                    },
                    {
                        "id": 87466,
                        "name": "Powiat bielski",
                        "latitude": "52.74629000",
                        "longitude": "23.00669000"
                    },
                    {
                        "id": 87512,
                        "name": "Powiat grajewski",
                        "latitude": "53.55509000",
                        "longitude": "22.48995000"
                    },
                    {
                        "id": 87522,
                        "name": "Powiat hajnowski",
                        "latitude": "52.70845000",
                        "longitude": "23.55719000"
                    },
                    {
                        "id": 87541,
                        "name": "Powiat kolneński",
                        "latitude": "53.39186000",
                        "longitude": "21.93631000"
                    },
                    {
                        "id": 87750,
                        "name": "Powiat łomżyński",
                        "latitude": "53.20686000",
                        "longitude": "22.08252000"
                    },
                    {
                        "id": 87591,
                        "name": "Powiat moniecki",
                        "latitude": "53.44561000",
                        "longitude": "22.78144000"
                    },
                    {
                        "id": 87669,
                        "name": "Powiat sejneński",
                        "latitude": "54.09561000",
                        "longitude": "23.30425000"
                    },
                    {
                        "id": 87671,
                        "name": "Powiat siemiatycki",
                        "latitude": "52.48842000",
                        "longitude": "22.88642000"
                    },
                    {
                        "id": 87678,
                        "name": "Powiat sokólski",
                        "latitude": "53.43511000",
                        "longitude": "23.41864000"
                    },
                    {
                        "id": 87690,
                        "name": "Powiat suwalski",
                        "latitude": "54.16655000",
                        "longitude": "22.81818000"
                    },
                    {
                        "id": 87727,
                        "name": "Powiat wysokomazowiecki",
                        "latitude": "52.86458000",
                        "longitude": "22.55541000"
                    },
                    {
                        "id": 87736,
                        "name": "Powiat zambrowski",
                        "latitude": "53.02256000",
                        "longitude": "22.28505000"
                    },
                    {
                        "id": 87854,
                        "name": "Puńsk",
                        "latitude": "54.25114000",
                        "longitude": "23.18124000"
                    },
                    {
                        "id": 87875,
                        "name": "Raczki",
                        "latitude": "53.98749000",
                        "longitude": "22.78487000"
                    },
                    {
                        "id": 87901,
                        "name": "Radziłów",
                        "latitude": "53.40994000",
                        "longitude": "22.40988000"
                    },
                    {
                        "id": 87907,
                        "name": "Rajgród",
                        "latitude": "53.73102000",
                        "longitude": "22.70515000"
                    },
                    {
                        "id": 87974,
                        "name": "Rudka",
                        "latitude": "52.72439000",
                        "longitude": "22.72676000"
                    },
                    {
                        "id": 87990,
                        "name": "Rutki-Kossaki",
                        "latitude": "53.08932000",
                        "longitude": "22.44011000"
                    },
                    {
                        "id": 88055,
                        "name": "Sejny",
                        "latitude": "54.10802000",
                        "longitude": "23.34698000"
                    },
                    {
                        "id": 88072,
                        "name": "Siemiatycze",
                        "latitude": "52.42719000",
                        "longitude": "22.86231000"
                    },
                    {
                        "id": 88836,
                        "name": "Śniadowo",
                        "latitude": "53.03874000",
                        "longitude": "21.99077000"
                    },
                    {
                        "id": 88141,
                        "name": "Sokółka",
                        "latitude": "53.40715000",
                        "longitude": "23.50228000"
                    },
                    {
                        "id": 88138,
                        "name": "Sokoły",
                        "latitude": "52.99314000",
                        "longitude": "22.70050000"
                    },
                    {
                        "id": 88200,
                        "name": "Stawiski",
                        "latitude": "53.37987000",
                        "longitude": "22.15462000"
                    },
                    {
                        "id": 88251,
                        "name": "Suchowola",
                        "latitude": "53.57753000",
                        "longitude": "23.10596000"
                    },
                    {
                        "id": 88264,
                        "name": "Supraśl",
                        "latitude": "53.20526000",
                        "longitude": "23.33934000"
                    },
                    {
                        "id": 88265,
                        "name": "Suraż",
                        "latitude": "52.94908000",
                        "longitude": "22.95653000"
                    },
                    {
                        "id": 88269,
                        "name": "Suwałki",
                        "latitude": "54.10272000",
                        "longitude": "22.92914000"
                    },
                    {
                        "id": 88300,
                        "name": "Szczuczyn",
                        "latitude": "53.56330000",
                        "longitude": "22.28534000"
                    },
                    {
                        "id": 88308,
                        "name": "Szepietowo",
                        "latitude": "52.87032000",
                        "longitude": "22.54392000"
                    },
                    {
                        "id": 88318,
                        "name": "Szumowo",
                        "latitude": "52.91884000",
                        "longitude": "22.08449000"
                    },
                    {
                        "id": 88426,
                        "name": "Turośń Kościelna",
                        "latitude": "53.01463000",
                        "longitude": "23.05532000"
                    },
                    {
                        "id": 88438,
                        "name": "Tykocin",
                        "latitude": "53.20567000",
                        "longitude": "22.77457000"
                    },
                    {
                        "id": 88484,
                        "name": "Wasilków",
                        "latitude": "53.19909000",
                        "longitude": "23.20776000"
                    },
                    {
                        "id": 88635,
                        "name": "Wąsosz",
                        "latitude": "53.52209000",
                        "longitude": "22.31915000"
                    },
                    {
                        "id": 88554,
                        "name": "Wizna",
                        "latitude": "53.19518000",
                        "longitude": "22.38241000"
                    },
                    {
                        "id": 88622,
                        "name": "Wysokie Mazowieckie",
                        "latitude": "52.91661000",
                        "longitude": "22.51712000"
                    },
                    {
                        "id": 88623,
                        "name": "Wyszki",
                        "latitude": "52.84129000",
                        "longitude": "22.98119000"
                    },
                    {
                        "id": 88663,
                        "name": "Zabłudów",
                        "latitude": "53.01442000",
                        "longitude": "23.33831000"
                    },
                    {
                        "id": 88690,
                        "name": "Zambrów",
                        "latitude": "52.98550000",
                        "longitude": "22.24319000"
                    },
                    {
                        "id": 88712,
                        "name": "Zbójna",
                        "latitude": "53.24293000",
                        "longitude": "21.78812000"
                    }
                ]
            },
            {
                "id": 1624,
                "name": "Pomerania",
                "iso2": "22",
                "latitude": "54.29442520",
                "longitude": "18.15311640",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85800,
                        "name": "Banino",
                        "latitude": "54.39215000",
                        "longitude": "18.40622000"
                    },
                    {
                        "id": 85886,
                        "name": "Bobowo",
                        "latitude": "53.88378000",
                        "longitude": "18.55681000"
                    },
                    {
                        "id": 85902,
                        "name": "Bojano",
                        "latitude": "54.47123000",
                        "longitude": "18.38408000"
                    },
                    {
                        "id": 85915,
                        "name": "Bolszewo",
                        "latitude": "54.61801000",
                        "longitude": "18.17585000"
                    },
                    {
                        "id": 85929,
                        "name": "Borzytuchom",
                        "latitude": "54.20021000",
                        "longitude": "17.36801000"
                    },
                    {
                        "id": 85956,
                        "name": "Brusy",
                        "latitude": "53.88446000",
                        "longitude": "17.71786000"
                    },
                    {
                        "id": 86008,
                        "name": "Bytów",
                        "latitude": "54.17057000",
                        "longitude": "17.49187000"
                    },
                    {
                        "id": 86018,
                        "name": "Cedry Wielkie",
                        "latitude": "54.24707000",
                        "longitude": "18.84567000"
                    },
                    {
                        "id": 86025,
                        "name": "Cewice",
                        "latitude": "54.43551000",
                        "longitude": "17.73485000"
                    },
                    {
                        "id": 86074,
                        "name": "Chłapowo",
                        "latitude": "54.80365000",
                        "longitude": "18.37352000"
                    },
                    {
                        "id": 86036,
                        "name": "Chmielno",
                        "latitude": "54.32543000",
                        "longitude": "18.09860000"
                    },
                    {
                        "id": 86042,
                        "name": "Choczewo",
                        "latitude": "54.73993000",
                        "longitude": "17.89175000"
                    },
                    {
                        "id": 86049,
                        "name": "Chojnice",
                        "latitude": "53.69554000",
                        "longitude": "17.55701000"
                    },
                    {
                        "id": 86067,
                        "name": "Chwaszczyno",
                        "latitude": "54.44379000",
                        "longitude": "18.41875000"
                    },
                    {
                        "id": 86106,
                        "name": "Czarna Dąbrówka",
                        "latitude": "54.35631000",
                        "longitude": "17.56456000"
                    },
                    {
                        "id": 86108,
                        "name": "Czarna Woda",
                        "latitude": "53.84458000",
                        "longitude": "18.10006000"
                    },
                    {
                        "id": 86109,
                        "name": "Czarne",
                        "latitude": "53.68420000",
                        "longitude": "16.93834000"
                    },
                    {
                        "id": 86138,
                        "name": "Czersk",
                        "latitude": "53.79589000",
                        "longitude": "17.97647000"
                    },
                    {
                        "id": 86152,
                        "name": "Człuchów",
                        "latitude": "53.66722000",
                        "longitude": "17.35883000"
                    },
                    {
                        "id": 86157,
                        "name": "Damnica",
                        "latitude": "54.50025000",
                        "longitude": "17.27154000"
                    },
                    {
                        "id": 86249,
                        "name": "Dębnica Kaszubska",
                        "latitude": "54.37831000",
                        "longitude": "17.16116000"
                    },
                    {
                        "id": 86161,
                        "name": "Debrzno",
                        "latitude": "53.53817000",
                        "longitude": "17.23643000"
                    },
                    {
                        "id": 86220,
                        "name": "Dziemiany",
                        "latitude": "54.00636000",
                        "longitude": "17.76755000"
                    },
                    {
                        "id": 86223,
                        "name": "Dzierzgoń",
                        "latitude": "53.92196000",
                        "longitude": "19.34705000"
                    },
                    {
                        "id": 86283,
                        "name": "Garcz",
                        "latitude": "54.34760000",
                        "longitude": "18.10169000"
                    },
                    {
                        "id": 86285,
                        "name": "Gardeja",
                        "latitude": "53.61125000",
                        "longitude": "18.94687000"
                    },
                    {
                        "id": 86291,
                        "name": "Gdańsk",
                        "latitude": "54.35205000",
                        "longitude": "18.64637000"
                    },
                    {
                        "id": 86292,
                        "name": "Gdynia",
                        "latitude": "54.51889000",
                        "longitude": "18.53188000"
                    },
                    {
                        "id": 86437,
                        "name": "Główczyce",
                        "latitude": "54.61935000",
                        "longitude": "17.37230000"
                    },
                    {
                        "id": 86310,
                        "name": "Gniew",
                        "latitude": "53.83602000",
                        "longitude": "18.82310000"
                    },
                    {
                        "id": 86311,
                        "name": "Gniewino",
                        "latitude": "54.71709000",
                        "longitude": "18.01663000"
                    },
                    {
                        "id": 86314,
                        "name": "Gnieżdżewo",
                        "latitude": "54.74741000",
                        "longitude": "18.37944000"
                    },
                    {
                        "id": 86359,
                        "name": "Gościcino",
                        "latitude": "54.60459000",
                        "longitude": "18.15491000"
                    },
                    {
                        "id": 86367,
                        "name": "Grabowo Kościerskie",
                        "latitude": "54.16816000",
                        "longitude": "18.14692000"
                    },
                    {
                        "id": 86446,
                        "name": "Hel",
                        "latitude": "54.60814000",
                        "longitude": "18.80130000"
                    },
                    {
                        "id": 86520,
                        "name": "Jastarnia",
                        "latitude": "54.69830000",
                        "longitude": "18.67730000"
                    },
                    {
                        "id": 86527,
                        "name": "Jastrzębia Góra",
                        "latitude": "54.83135000",
                        "longitude": "18.31301000"
                    },
                    {
                        "id": 86585,
                        "name": "Kaliska",
                        "latitude": "53.90535000",
                        "longitude": "18.21885000"
                    },
                    {
                        "id": 86616,
                        "name": "Karsin",
                        "latitude": "53.90768000",
                        "longitude": "17.92093000"
                    },
                    {
                        "id": 86617,
                        "name": "Kartuzy",
                        "latitude": "54.33424000",
                        "longitude": "18.19735000"
                    },
                    {
                        "id": 86854,
                        "name": "Kępice",
                        "latitude": "54.24111000",
                        "longitude": "16.88968000"
                    },
                    {
                        "id": 86668,
                        "name": "Kobylnica",
                        "latitude": "54.43975000",
                        "longitude": "16.99782000"
                    },
                    {
                        "id": 86673,
                        "name": "Koczała",
                        "latitude": "53.90449000",
                        "longitude": "17.06529000"
                    },
                    {
                        "id": 86676,
                        "name": "Kolbudy",
                        "latitude": "54.26989000",
                        "longitude": "18.46639000"
                    },
                    {
                        "id": 86678,
                        "name": "Koleczkowo",
                        "latitude": "54.48629000",
                        "longitude": "18.34373000"
                    },
                    {
                        "id": 86744,
                        "name": "Kołczygłowy",
                        "latitude": "54.23895000",
                        "longitude": "17.23154000"
                    },
                    {
                        "id": 86710,
                        "name": "Kosakowo",
                        "latitude": "54.58927000",
                        "longitude": "18.48484000"
                    },
                    {
                        "id": 86756,
                        "name": "Kościerzyna",
                        "latitude": "54.12226000",
                        "longitude": "17.98119000"
                    },
                    {
                        "id": 86727,
                        "name": "Kowale",
                        "latitude": "54.30976000",
                        "longitude": "18.56149000"
                    },
                    {
                        "id": 86781,
                        "name": "Krokowa",
                        "latitude": "54.77921000",
                        "longitude": "18.16160000"
                    },
                    {
                        "id": 86794,
                        "name": "Krynica Morska",
                        "latitude": "54.38051000",
                        "longitude": "19.44413000"
                    },
                    {
                        "id": 86849,
                        "name": "Kwidzyn",
                        "latitude": "53.72495000",
                        "longitude": "18.93114000"
                    },
                    {
                        "id": 86978,
                        "name": "Lębork",
                        "latitude": "54.53921000",
                        "longitude": "17.75012000"
                    },
                    {
                        "id": 86903,
                        "name": "Linia",
                        "latitude": "54.45143000",
                        "longitude": "17.93454000"
                    },
                    {
                        "id": 86904,
                        "name": "Liniewo",
                        "latitude": "54.07661000",
                        "longitude": "18.22675000"
                    },
                    {
                        "id": 86912,
                        "name": "Lipnica",
                        "latitude": "53.99623000",
                        "longitude": "17.40702000"
                    },
                    {
                        "id": 86923,
                        "name": "Lipusz",
                        "latitude": "54.09806000",
                        "longitude": "17.78455000"
                    },
                    {
                        "id": 86925,
                        "name": "Lisewo Malborskie",
                        "latitude": "54.09665000",
                        "longitude": "18.82928000"
                    },
                    {
                        "id": 86938,
                        "name": "Lubichowo",
                        "latitude": "53.85136000",
                        "longitude": "18.39901000"
                    },
                    {
                        "id": 86946,
                        "name": "Lublewo Gdańskie",
                        "latitude": "54.28457000",
                        "longitude": "18.50389000"
                    },
                    {
                        "id": 86972,
                        "name": "Luzino",
                        "latitude": "54.56604000",
                        "longitude": "18.10907000"
                    },
                    {
                        "id": 88778,
                        "name": "Łeba",
                        "latitude": "54.76099000",
                        "longitude": "17.55547000"
                    },
                    {
                        "id": 88818,
                        "name": "Łęczyce",
                        "latitude": "54.59405000",
                        "longitude": "17.85931000"
                    },
                    {
                        "id": 88819,
                        "name": "Łęgowo",
                        "latitude": "54.22641000",
                        "longitude": "18.64277000"
                    },
                    {
                        "id": 86986,
                        "name": "Malbork",
                        "latitude": "54.03591000",
                        "longitude": "19.02660000"
                    },
                    {
                        "id": 87017,
                        "name": "Miastko",
                        "latitude": "54.00283000",
                        "longitude": "16.98263000"
                    },
                    {
                        "id": 87043,
                        "name": "Mikołajki Pomorskie",
                        "latitude": "53.85131000",
                        "longitude": "19.16574000"
                    },
                    {
                        "id": 87073,
                        "name": "Miłoradz",
                        "latitude": "54.01392000",
                        "longitude": "18.91846000"
                    },
                    {
                        "id": 87096,
                        "name": "Mosty",
                        "latitude": "54.61195000",
                        "longitude": "18.49634000"
                    },
                    {
                        "id": 87104,
                        "name": "Mrzezino",
                        "latitude": "54.65378000",
                        "longitude": "18.43025000"
                    },
                    {
                        "id": 87178,
                        "name": "Nowa Wieś Lęborska",
                        "latitude": "54.55878000",
                        "longitude": "17.72756000"
                    },
                    {
                        "id": 87202,
                        "name": "Nowy Dwór Gdański",
                        "latitude": "54.21305000",
                        "longitude": "19.11771000"
                    },
                    {
                        "id": 87205,
                        "name": "Nowy Staw",
                        "latitude": "54.13609000",
                        "longitude": "19.00909000"
                    },
                    {
                        "id": 87267,
                        "name": "Orle",
                        "latitude": "54.64022000",
                        "longitude": "18.17057000"
                    },
                    {
                        "id": 87287,
                        "name": "Osiek",
                        "latitude": "53.72226000",
                        "longitude": "18.49051000"
                    },
                    {
                        "id": 87296,
                        "name": "Ostaszewo",
                        "latitude": "54.21256000",
                        "longitude": "18.95142000"
                    },
                    {
                        "id": 87346,
                        "name": "Parchowo",
                        "latitude": "54.20658000",
                        "longitude": "17.66816000"
                    },
                    {
                        "id": 87363,
                        "name": "Pelplin",
                        "latitude": "53.92834000",
                        "longitude": "18.69770000"
                    },
                    {
                        "id": 87425,
                        "name": "Pogórze",
                        "latitude": "54.56440000",
                        "longitude": "18.48209000"
                    },
                    {
                        "id": 87456,
                        "name": "Potęgowo",
                        "latitude": "54.48285000",
                        "longitude": "17.48620000"
                    },
                    {
                        "id": 87480,
                        "name": "Powiat bytowski",
                        "latitude": "54.15691000",
                        "longitude": "17.29147000"
                    },
                    {
                        "id": 87485,
                        "name": "Powiat chojnicki",
                        "latitude": "53.80099000",
                        "longitude": "17.71882000"
                    },
                    {
                        "id": 87492,
                        "name": "Powiat człuchowski",
                        "latitude": "53.75112000",
                        "longitude": "17.18936000"
                    },
                    {
                        "id": 87501,
                        "name": "Powiat gdański",
                        "latitude": "54.22493000",
                        "longitude": "18.58157000"
                    },
                    {
                        "id": 87536,
                        "name": "Powiat kartuski",
                        "latitude": "54.32687000",
                        "longitude": "18.08632000"
                    },
                    {
                        "id": 87549,
                        "name": "Powiat kościerski",
                        "latitude": "54.01939000",
                        "longitude": "18.00400000"
                    },
                    {
                        "id": 87558,
                        "name": "Powiat kwidzyński",
                        "latitude": "53.74690000",
                        "longitude": "19.03111000"
                    },
                    {
                        "id": 87580,
                        "name": "Powiat lęborski",
                        "latitude": "54.56830000",
                        "longitude": "17.65178000"
                    },
                    {
                        "id": 87582,
                        "name": "Powiat malborski",
                        "latitude": "54.06329000",
                        "longitude": "19.04421000"
                    },
                    {
                        "id": 87602,
                        "name": "Powiat nowodworski",
                        "latitude": "54.28730000",
                        "longitude": "19.24266000"
                    },
                    {
                        "id": 87649,
                        "name": "Powiat pucki",
                        "latitude": "54.69659000",
                        "longitude": "18.36979000"
                    },
                    {
                        "id": 87700,
                        "name": "Powiat słupski",
                        "latitude": "54.42211000",
                        "longitude": "17.15917000"
                    },
                    {
                        "id": 87682,
                        "name": "Powiat starogardzki",
                        "latitude": "53.89912000",
                        "longitude": "18.39912000"
                    },
                    {
                        "id": 87694,
                        "name": "Powiat sztumski",
                        "latitude": "53.90149000",
                        "longitude": "19.22000000"
                    },
                    {
                        "id": 87705,
                        "name": "Powiat tczewski",
                        "latitude": "53.91895000",
                        "longitude": "18.71916000"
                    },
                    {
                        "id": 87716,
                        "name": "Powiat wejherowski",
                        "latitude": "54.61707000",
                        "longitude": "18.04881000"
                    },
                    {
                        "id": 87783,
                        "name": "Prabuty",
                        "latitude": "53.75500000",
                        "longitude": "19.20547000"
                    },
                    {
                        "id": 87798,
                        "name": "Pruszcz Gdański",
                        "latitude": "54.26217000",
                        "longitude": "18.63625000"
                    },
                    {
                        "id": 87801,
                        "name": "Przechlewo",
                        "latitude": "53.79847000",
                        "longitude": "17.25205000"
                    },
                    {
                        "id": 87818,
                        "name": "Przodkowo",
                        "latitude": "54.37991000",
                        "longitude": "18.28760000"
                    },
                    {
                        "id": 87834,
                        "name": "Przywidz",
                        "latitude": "54.19524000",
                        "longitude": "18.32116000"
                    },
                    {
                        "id": 87844,
                        "name": "Pszczółki",
                        "latitude": "54.17304000",
                        "longitude": "18.69787000"
                    },
                    {
                        "id": 87847,
                        "name": "Puck",
                        "latitude": "54.71790000",
                        "longitude": "18.40841000"
                    },
                    {
                        "id": 87921,
                        "name": "Reda",
                        "latitude": "54.60528000",
                        "longitude": "18.34717000"
                    },
                    {
                        "id": 87935,
                        "name": "Rekowo Dolne",
                        "latitude": "54.63133000",
                        "longitude": "18.36279000"
                    },
                    {
                        "id": 87962,
                        "name": "Rotmanka",
                        "latitude": "54.27425000",
                        "longitude": "18.60380000"
                    },
                    {
                        "id": 87986,
                        "name": "Rumia",
                        "latitude": "54.57092000",
                        "longitude": "18.38802000"
                    },
                    {
                        "id": 88007,
                        "name": "Ryjewo",
                        "latitude": "53.84463000",
                        "longitude": "18.96077000"
                    },
                    {
                        "id": 88015,
                        "name": "Rzeczenica",
                        "latitude": "53.75790000",
                        "longitude": "17.10752000"
                    },
                    {
                        "id": 88042,
                        "name": "Sadlinki",
                        "latitude": "53.66539000",
                        "longitude": "18.86807000"
                    },
                    {
                        "id": 88087,
                        "name": "Sierakowice",
                        "latitude": "54.34610000",
                        "longitude": "17.89252000"
                    },
                    {
                        "id": 88098,
                        "name": "Skarszewy",
                        "latitude": "54.06911000",
                        "longitude": "18.44416000"
                    },
                    {
                        "id": 88121,
                        "name": "Skórcz",
                        "latitude": "53.79436000",
                        "longitude": "18.52561000"
                    },
                    {
                        "id": 88353,
                        "name": "Słupsk",
                        "latitude": "54.46405000",
                        "longitude": "17.02872000"
                    },
                    {
                        "id": 88129,
                        "name": "Smętowo Graniczne",
                        "latitude": "53.74638000",
                        "longitude": "18.68586000"
                    },
                    {
                        "id": 88126,
                        "name": "Smołdzino",
                        "latitude": "54.66318000",
                        "longitude": "17.21369000"
                    },
                    {
                        "id": 88145,
                        "name": "Somonino",
                        "latitude": "54.27555000",
                        "longitude": "18.19885000"
                    },
                    {
                        "id": 88148,
                        "name": "Sopot",
                        "latitude": "54.44180000",
                        "longitude": "18.56003000"
                    },
                    {
                        "id": 88176,
                        "name": "Stara Kiszewa",
                        "latitude": "53.99006000",
                        "longitude": "18.16958000"
                    },
                    {
                        "id": 88188,
                        "name": "Stare Pole",
                        "latitude": "54.05667000",
                        "longitude": "19.20874000"
                    },
                    {
                        "id": 88190,
                        "name": "Starogard Gdański",
                        "latitude": "53.96396000",
                        "longitude": "18.52638000"
                    },
                    {
                        "id": 88195,
                        "name": "Stary Targ",
                        "latitude": "53.92335000",
                        "longitude": "19.17003000"
                    },
                    {
                        "id": 88202,
                        "name": "Stegna",
                        "latitude": "54.32684000",
                        "longitude": "19.11252000"
                    },
                    {
                        "id": 88245,
                        "name": "Stężyca",
                        "latitude": "54.20593000",
                        "longitude": "17.95569000"
                    },
                    {
                        "id": 88213,
                        "name": "Straszyn",
                        "latitude": "54.27214000",
                        "longitude": "18.58114000"
                    },
                    {
                        "id": 88233,
                        "name": "Strzelno",
                        "latitude": "54.78564000",
                        "longitude": "18.32515000"
                    },
                    {
                        "id": 88239,
                        "name": "Studzienice",
                        "latitude": "54.09262000",
                        "longitude": "17.57581000"
                    },
                    {
                        "id": 88246,
                        "name": "Subkowy",
                        "latitude": "54.00227000",
                        "longitude": "18.76928000"
                    },
                    {
                        "id": 88253,
                        "name": "Suchy Dąb",
                        "latitude": "54.20809000",
                        "longitude": "18.76731000"
                    },
                    {
                        "id": 88263,
                        "name": "Sulęczyno",
                        "latitude": "54.23302000",
                        "longitude": "17.77330000"
                    },
                    {
                        "id": 88307,
                        "name": "Szemud",
                        "latitude": "54.48709000",
                        "longitude": "18.22280000"
                    },
                    {
                        "id": 88311,
                        "name": "Szlachta",
                        "latitude": "53.76827000",
                        "longitude": "18.11367000"
                    },
                    {
                        "id": 88315,
                        "name": "Sztum",
                        "latitude": "53.92077000",
                        "longitude": "19.03072000"
                    },
                    {
                        "id": 88316,
                        "name": "Sztutowo",
                        "latitude": "54.32679000",
                        "longitude": "19.17921000"
                    },
                    {
                        "id": 88369,
                        "name": "Tczew",
                        "latitude": "54.09242000",
                        "longitude": "18.77787000"
                    },
                    {
                        "id": 88416,
                        "name": "Trąbki Wielkie",
                        "latitude": "54.17062000",
                        "longitude": "18.54003000"
                    },
                    {
                        "id": 88404,
                        "name": "Trzebielino",
                        "latitude": "54.19996000",
                        "longitude": "17.08726000"
                    },
                    {
                        "id": 88418,
                        "name": "Tuchomie",
                        "latitude": "54.11522000",
                        "longitude": "17.33634000"
                    },
                    {
                        "id": 88462,
                        "name": "Ustka",
                        "latitude": "54.58048000",
                        "longitude": "16.86194000"
                    },
                    {
                        "id": 88490,
                        "name": "Wejherowo",
                        "latitude": "54.60568000",
                        "longitude": "18.23559000"
                    },
                    {
                        "id": 88507,
                        "name": "Wielki Kack",
                        "latitude": "54.46754000",
                        "longitude": "18.48810000"
                    },
                    {
                        "id": 88526,
                        "name": "Wierzchucino",
                        "latitude": "54.78797000",
                        "longitude": "18.00307000"
                    },
                    {
                        "id": 88646,
                        "name": "Władysławowo",
                        "latitude": "54.79086000",
                        "longitude": "18.40090000"
                    },
                    {
                        "id": 88708,
                        "name": "Zblewo",
                        "latitude": "53.93366000",
                        "longitude": "18.32262000"
                    },
                    {
                        "id": 88883,
                        "name": "Żelistrzewo",
                        "latitude": "54.67770000",
                        "longitude": "18.41738000"
                    },
                    {
                        "id": 88892,
                        "name": "Żukowo",
                        "latitude": "54.34220000",
                        "longitude": "18.36476000"
                    }
                ]
            },
            {
                "id": 1623,
                "name": "Silesia",
                "iso2": "24",
                "latitude": "50.57165950",
                "longitude": "19.32197680",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 86009,
                        "name": "Bąków",
                        "latitude": "49.89342000",
                        "longitude": "18.71495000"
                    },
                    {
                        "id": 85821,
                        "name": "Bażanowice",
                        "latitude": "49.73791000",
                        "longitude": "18.70345000"
                    },
                    {
                        "id": 86013,
                        "name": "Będzin",
                        "latitude": "50.32607000",
                        "longitude": "19.12565000"
                    },
                    {
                        "id": 85829,
                        "name": "Bełk",
                        "latitude": "50.13048000",
                        "longitude": "18.71667000"
                    },
                    {
                        "id": 85830,
                        "name": "Bełsznica",
                        "latitude": "49.97811000",
                        "longitude": "18.36313000"
                    },
                    {
                        "id": 85826,
                        "name": "Bestwina",
                        "latitude": "49.89712000",
                        "longitude": "19.05776000"
                    },
                    {
                        "id": 85827,
                        "name": "Bestwinka",
                        "latitude": "49.93272000",
                        "longitude": "19.06694000"
                    },
                    {
                        "id": 85861,
                        "name": "Bielsko-Biala",
                        "latitude": "49.82245000",
                        "longitude": "19.04686000"
                    },
                    {
                        "id": 85867,
                        "name": "Bieruń",
                        "latitude": "50.09000000",
                        "longitude": "19.09291000"
                    },
                    {
                        "id": 85879,
                        "name": "Blachownia",
                        "latitude": "50.78015000",
                        "longitude": "18.96389000"
                    },
                    {
                        "id": 85890,
                        "name": "Bobrowniki",
                        "latitude": "50.37985000",
                        "longitude": "18.98661000"
                    },
                    {
                        "id": 85906,
                        "name": "Bojszowy",
                        "latitude": "50.05780000",
                        "longitude": "19.10145000"
                    },
                    {
                        "id": 85907,
                        "name": "Bojszowy Nowe",
                        "latitude": "50.05284000",
                        "longitude": "19.05012000"
                    },
                    {
                        "id": 85923,
                        "name": "Boronów",
                        "latitude": "50.67460000",
                        "longitude": "18.90678000"
                    },
                    {
                        "id": 85926,
                        "name": "Borowno",
                        "latitude": "50.93247000",
                        "longitude": "19.27380000"
                    },
                    {
                        "id": 85927,
                        "name": "Borucin",
                        "latitude": "50.00763000",
                        "longitude": "18.15748000"
                    },
                    {
                        "id": 85940,
                        "name": "Brenna",
                        "latitude": "49.72576000",
                        "longitude": "18.90249000"
                    },
                    {
                        "id": 85953,
                        "name": "Bronów",
                        "latitude": "49.87782000",
                        "longitude": "18.92103000"
                    },
                    {
                        "id": 85965,
                        "name": "Brzeziny Śląskie",
                        "latitude": "50.35439000",
                        "longitude": "18.98129000"
                    },
                    {
                        "id": 85982,
                        "name": "Buczkowice",
                        "latitude": "49.72858000",
                        "longitude": "19.06908000"
                    },
                    {
                        "id": 85987,
                        "name": "Bujaków",
                        "latitude": "49.85182000",
                        "longitude": "19.19432000"
                    },
                    {
                        "id": 86001,
                        "name": "Bystra",
                        "latitude": "49.76042000",
                        "longitude": "19.05973000"
                    },
                    {
                        "id": 86005,
                        "name": "Bytom",
                        "latitude": "50.34802000",
                        "longitude": "18.93282000"
                    },
                    {
                        "id": 86026,
                        "name": "Chałupki",
                        "latitude": "49.92559000",
                        "longitude": "18.31730000"
                    },
                    {
                        "id": 86028,
                        "name": "Chełm Śląski",
                        "latitude": "50.10825000",
                        "longitude": "19.19552000"
                    },
                    {
                        "id": 86053,
                        "name": "Choroń",
                        "latitude": "50.68178000",
                        "longitude": "19.26058000"
                    },
                    {
                        "id": 86055,
                        "name": "Chorzów",
                        "latitude": "50.30582000",
                        "longitude": "18.97420000"
                    },
                    {
                        "id": 86060,
                        "name": "Chruszczobród",
                        "latitude": "50.41470000",
                        "longitude": "19.32718000"
                    },
                    {
                        "id": 86069,
                        "name": "Chybie",
                        "latitude": "49.90249000",
                        "longitude": "18.82756000"
                    },
                    {
                        "id": 86075,
                        "name": "Ciasna",
                        "latitude": "50.75427000",
                        "longitude": "18.60835000"
                    },
                    {
                        "id": 86093,
                        "name": "Cięcina",
                        "latitude": "49.60220000",
                        "longitude": "19.14102000"
                    },
                    {
                        "id": 86081,
                        "name": "Cielmice",
                        "latitude": "50.08826000",
                        "longitude": "19.01896000"
                    },
                    {
                        "id": 86088,
                        "name": "Cieszyn",
                        "latitude": "49.75133000",
                        "longitude": "18.63213000"
                    },
                    {
                        "id": 86090,
                        "name": "Cisiec",
                        "latitude": "49.59213000",
                        "longitude": "19.10540000"
                    },
                    {
                        "id": 86092,
                        "name": "Cisownica",
                        "latitude": "49.72276000",
                        "longitude": "18.76207000"
                    },
                    {
                        "id": 86098,
                        "name": "Cynków",
                        "latitude": "50.56203000",
                        "longitude": "19.11956000"
                    },
                    {
                        "id": 86100,
                        "name": "Czaniec",
                        "latitude": "49.85071000",
                        "longitude": "19.25354000"
                    },
                    {
                        "id": 86103,
                        "name": "Czarków",
                        "latitude": "50.01833000",
                        "longitude": "18.90678000"
                    },
                    {
                        "id": 86122,
                        "name": "Czechowice-Dziedzice",
                        "latitude": "49.91342000",
                        "longitude": "19.00479000"
                    },
                    {
                        "id": 86123,
                        "name": "Czeladź",
                        "latitude": "50.31542000",
                        "longitude": "19.07824000"
                    },
                    {
                        "id": 86130,
                        "name": "Czernica",
                        "latitude": "50.08391000",
                        "longitude": "18.40068000"
                    },
                    {
                        "id": 86132,
                        "name": "Czernichów",
                        "latitude": "49.75443000",
                        "longitude": "19.20947000"
                    },
                    {
                        "id": 86141,
                        "name": "Czerwionka-Leszczyny",
                        "latitude": "50.15007000",
                        "longitude": "18.67762000"
                    },
                    {
                        "id": 86150,
                        "name": "Częstochowa",
                        "latitude": "50.79646000",
                        "longitude": "19.12409000"
                    },
                    {
                        "id": 86149,
                        "name": "Czyżowice",
                        "latitude": "49.98490000",
                        "longitude": "18.40433000"
                    },
                    {
                        "id": 86240,
                        "name": "Dąbrowa Górnicza",
                        "latitude": "50.33394000",
                        "longitude": "19.20479000"
                    },
                    {
                        "id": 86242,
                        "name": "Dąbrowa Zielona",
                        "latitude": "50.84394000",
                        "longitude": "19.55652000"
                    },
                    {
                        "id": 86256,
                        "name": "Dębowiec",
                        "latitude": "49.81406000",
                        "longitude": "18.72062000"
                    },
                    {
                        "id": 86166,
                        "name": "Dobieszowice",
                        "latitude": "50.39697000",
                        "longitude": "19.01304000"
                    },
                    {
                        "id": 86199,
                        "name": "Drogomyśl",
                        "latitude": "49.86964000",
                        "longitude": "18.75727000"
                    },
                    {
                        "id": 86231,
                        "name": "Dzięgielów",
                        "latitude": "49.72259000",
                        "longitude": "18.70491000"
                    },
                    {
                        "id": 86276,
                        "name": "Frydek",
                        "latitude": "49.99626000",
                        "longitude": "19.07278000"
                    },
                    {
                        "id": 86284,
                        "name": "Gardawice",
                        "latitude": "50.11667000",
                        "longitude": "18.80000000"
                    },
                    {
                        "id": 86287,
                        "name": "Gaszowice",
                        "latitude": "50.10858000",
                        "longitude": "18.43042000"
                    },
                    {
                        "id": 86299,
                        "name": "Gierałtowice",
                        "latitude": "50.22486000",
                        "longitude": "18.73384000"
                    },
                    {
                        "id": 86303,
                        "name": "Gilowice",
                        "latitude": "49.99505000",
                        "longitude": "19.09613000"
                    },
                    {
                        "id": 86307,
                        "name": "Gliwice",
                        "latitude": "50.29761000",
                        "longitude": "18.67658000"
                    },
                    {
                        "id": 86308,
                        "name": "Gniazdów",
                        "latitude": "50.59621000",
                        "longitude": "19.11132000"
                    },
                    {
                        "id": 86317,
                        "name": "Goczałkowice Zdrój",
                        "latitude": "49.94454000",
                        "longitude": "18.96927000"
                    },
                    {
                        "id": 86322,
                        "name": "Godów",
                        "latitude": "49.92481000",
                        "longitude": "18.47830000"
                    },
                    {
                        "id": 86319,
                        "name": "Godziszka",
                        "latitude": "49.71288000",
                        "longitude": "19.07587000"
                    },
                    {
                        "id": 86327,
                        "name": "Goleszów",
                        "latitude": "49.73580000",
                        "longitude": "18.73675000"
                    },
                    {
                        "id": 86356,
                        "name": "Gołkowice",
                        "latitude": "49.91418000",
                        "longitude": "18.51419000"
                    },
                    {
                        "id": 86409,
                        "name": "Góra",
                        "latitude": "49.97971000",
                        "longitude": "19.10471000"
                    },
                    {
                        "id": 86414,
                        "name": "Górki Wielkie",
                        "latitude": "49.77971000",
                        "longitude": "18.83117000"
                    },
                    {
                        "id": 86339,
                        "name": "Gorzyce",
                        "latitude": "49.95945000",
                        "longitude": "18.39884000"
                    },
                    {
                        "id": 86341,
                        "name": "Gorzyczki",
                        "latitude": "49.94912000",
                        "longitude": "18.40330000"
                    },
                    {
                        "id": 86346,
                        "name": "Gostyń",
                        "latitude": "50.10528000",
                        "longitude": "18.88241000"
                    },
                    {
                        "id": 86445,
                        "name": "Hażlach",
                        "latitude": "49.80714000",
                        "longitude": "18.65178000"
                    },
                    {
                        "id": 86448,
                        "name": "Herby",
                        "latitude": "50.75318000",
                        "longitude": "18.88756000"
                    },
                    {
                        "id": 86455,
                        "name": "Huta Stara B",
                        "latitude": "50.73792000",
                        "longitude": "19.13295000"
                    },
                    {
                        "id": 86457,
                        "name": "Imielin",
                        "latitude": "50.14534000",
                        "longitude": "19.18599000"
                    },
                    {
                        "id": 86462,
                        "name": "Istebna",
                        "latitude": "49.56319000",
                        "longitude": "18.90567000"
                    },
                    {
                        "id": 86494,
                        "name": "Jankowice",
                        "latitude": "50.00090000",
                        "longitude": "18.98901000"
                    },
                    {
                        "id": 86495,
                        "name": "Jankowice Rybnickie",
                        "latitude": "50.04479000",
                        "longitude": "18.54707000"
                    },
                    {
                        "id": 86498,
                        "name": "Janowice",
                        "latitude": "49.88496000",
                        "longitude": "19.09376000"
                    },
                    {
                        "id": 86514,
                        "name": "Jasienica",
                        "latitude": "49.81312000",
                        "longitude": "18.92155000"
                    },
                    {
                        "id": 86524,
                        "name": "Jastrząb",
                        "latitude": "50.67019000",
                        "longitude": "19.18170000"
                    },
                    {
                        "id": 86528,
                        "name": "Jastrzębie Zdrój",
                        "latitude": "49.95542000",
                        "longitude": "18.57479000"
                    },
                    {
                        "id": 86529,
                        "name": "Jastrzębie-Zdrój",
                        "latitude": "49.96063000",
                        "longitude": "18.60053000"
                    },
                    {
                        "id": 86535,
                        "name": "Jaworze",
                        "latitude": "49.79351000",
                        "longitude": "18.94790000"
                    },
                    {
                        "id": 86536,
                        "name": "Jaworzno",
                        "latitude": "50.20528000",
                        "longitude": "19.27498000"
                    },
                    {
                        "id": 86538,
                        "name": "Jaworzynka",
                        "latitude": "49.54019000",
                        "longitude": "18.86996000"
                    },
                    {
                        "id": 86547,
                        "name": "Jejkowice",
                        "latitude": "50.10814000",
                        "longitude": "18.46767000"
                    },
                    {
                        "id": 86551,
                        "name": "Jeleśnia",
                        "latitude": "49.64246000",
                        "longitude": "19.32701000"
                    },
                    {
                        "id": 86572,
                        "name": "Juszczyna",
                        "latitude": "49.62984000",
                        "longitude": "19.22032000"
                    },
                    {
                        "id": 86581,
                        "name": "Kaczyce",
                        "latitude": "49.82752000",
                        "longitude": "18.59161000"
                    },
                    {
                        "id": 86583,
                        "name": "Kalej",
                        "latitude": "50.83662000",
                        "longitude": "18.98429000"
                    },
                    {
                        "id": 86584,
                        "name": "Kalety",
                        "latitude": "50.56270000",
                        "longitude": "18.89260000"
                    },
                    {
                        "id": 86589,
                        "name": "Kamesznica",
                        "latitude": "49.56469000",
                        "longitude": "19.02120000"
                    },
                    {
                        "id": 86592,
                        "name": "Kamienica Polska",
                        "latitude": "50.67090000",
                        "longitude": "19.12265000"
                    },
                    {
                        "id": 86606,
                        "name": "Kamyk",
                        "latitude": "50.90179000",
                        "longitude": "19.02875000"
                    },
                    {
                        "id": 86608,
                        "name": "Kaniów",
                        "latitude": "49.94316000",
                        "longitude": "19.05098000"
                    },
                    {
                        "id": 86621,
                        "name": "Katowice",
                        "latitude": "50.25841000",
                        "longitude": "19.02754000"
                    },
                    {
                        "id": 86862,
                        "name": "Kłobuck",
                        "latitude": "50.90081000",
                        "longitude": "18.93674000"
                    },
                    {
                        "id": 86867,
                        "name": "Kłomnice",
                        "latitude": "50.92165000",
                        "longitude": "19.35679000"
                    },
                    {
                        "id": 86658,
                        "name": "Knurów",
                        "latitude": "50.21971000",
                        "longitude": "18.65067000"
                    },
                    {
                        "id": 86660,
                        "name": "Kobiernice",
                        "latitude": "49.85497000",
                        "longitude": "19.21646000"
                    },
                    {
                        "id": 86662,
                        "name": "Kobiór",
                        "latitude": "50.06089000",
                        "longitude": "18.93468000"
                    },
                    {
                        "id": 86670,
                        "name": "Kochanowice",
                        "latitude": "50.70548000",
                        "longitude": "18.74911000"
                    },
                    {
                        "id": 86748,
                        "name": "Kończyce Małe",
                        "latitude": "49.85824000",
                        "longitude": "18.62964000"
                    },
                    {
                        "id": 86749,
                        "name": "Kończyce Wielkie",
                        "latitude": "49.83510000",
                        "longitude": "18.64474000"
                    },
                    {
                        "id": 86690,
                        "name": "Koniaków",
                        "latitude": "49.55066000",
                        "longitude": "18.94910000"
                    },
                    {
                        "id": 86691,
                        "name": "Koniecpol",
                        "latitude": "50.77468000",
                        "longitude": "19.68896000"
                    },
                    {
                        "id": 86694,
                        "name": "Konopiska",
                        "latitude": "50.72695000",
                        "longitude": "19.00781000"
                    },
                    {
                        "id": 86700,
                        "name": "Korbielów",
                        "latitude": "49.56820000",
                        "longitude": "19.35001000"
                    },
                    {
                        "id": 86704,
                        "name": "Kornowac",
                        "latitude": "50.07179000",
                        "longitude": "18.32846000"
                    },
                    {
                        "id": 86753,
                        "name": "Kościelec",
                        "latitude": "50.89713000",
                        "longitude": "19.21560000"
                    },
                    {
                        "id": 86717,
                        "name": "Koszarawa",
                        "latitude": "49.64462000",
                        "longitude": "19.40083000"
                    },
                    {
                        "id": 86720,
                        "name": "Koszęcin",
                        "latitude": "50.63411000",
                        "longitude": "18.84130000"
                    },
                    {
                        "id": 86734,
                        "name": "Koziegłowy",
                        "latitude": "50.60035000",
                        "longitude": "19.16299000"
                    },
                    {
                        "id": 86737,
                        "name": "Kozy",
                        "latitude": "49.84756000",
                        "longitude": "19.14891000"
                    },
                    {
                        "id": 86780,
                        "name": "Kroczyce",
                        "latitude": "50.56176000",
                        "longitude": "19.57000000"
                    },
                    {
                        "id": 86792,
                        "name": "Krupski Młyn",
                        "latitude": "50.57337000",
                        "longitude": "18.62251000"
                    },
                    {
                        "id": 86798,
                        "name": "Kryry",
                        "latitude": "50.01667000",
                        "longitude": "18.80568000"
                    },
                    {
                        "id": 86800,
                        "name": "Krzanowice",
                        "latitude": "50.01822000",
                        "longitude": "18.12251000"
                    },
                    {
                        "id": 86807,
                        "name": "Krzepice",
                        "latitude": "50.97059000",
                        "longitude": "18.72886000"
                    },
                    {
                        "id": 86822,
                        "name": "Krzyżanowice",
                        "latitude": "49.98247000",
                        "longitude": "18.26846000"
                    },
                    {
                        "id": 86824,
                        "name": "Krzyżowa",
                        "latitude": "49.59235000",
                        "longitude": "19.34469000"
                    },
                    {
                        "id": 86825,
                        "name": "Krzyżowice",
                        "latitude": "49.98528000",
                        "longitude": "18.67281000"
                    },
                    {
                        "id": 86830,
                        "name": "Książenice",
                        "latitude": "50.15524000",
                        "longitude": "18.59925000"
                    },
                    {
                        "id": 86846,
                        "name": "Kuźnia Raciborska",
                        "latitude": "50.20058000",
                        "longitude": "18.31146000"
                    },
                    {
                        "id": 86869,
                        "name": "Laliki",
                        "latitude": "49.53446000",
                        "longitude": "19.00549000"
                    },
                    {
                        "id": 86979,
                        "name": "Lędziny",
                        "latitude": "50.14264000",
                        "longitude": "19.13149000"
                    },
                    {
                        "id": 86880,
                        "name": "Lelów",
                        "latitude": "50.68335000",
                        "longitude": "19.62562000"
                    },
                    {
                        "id": 86888,
                        "name": "Leśna",
                        "latitude": "49.67041000",
                        "longitude": "19.12763000"
                    },
                    {
                        "id": 86901,
                        "name": "Ligota",
                        "latitude": "49.89856000",
                        "longitude": "18.95090000"
                    },
                    {
                        "id": 86907,
                        "name": "Lipie",
                        "latitude": "51.01257000",
                        "longitude": "18.79658000"
                    },
                    {
                        "id": 86919,
                        "name": "Lipowa",
                        "latitude": "49.67574000",
                        "longitude": "19.09398000"
                    },
                    {
                        "id": 86948,
                        "name": "Lubliniec",
                        "latitude": "50.66897000",
                        "longitude": "18.68440000"
                    },
                    {
                        "id": 86951,
                        "name": "Lubomia",
                        "latitude": "50.03972000",
                        "longitude": "18.30820000"
                    },
                    {
                        "id": 86975,
                        "name": "Lyski",
                        "latitude": "50.11992000",
                        "longitude": "18.39146000"
                    },
                    {
                        "id": 88774,
                        "name": "Łaziska",
                        "latitude": "49.93570000",
                        "longitude": "18.44707000"
                    },
                    {
                        "id": 88775,
                        "name": "Łaziska Górne",
                        "latitude": "50.14952000",
                        "longitude": "18.84215000"
                    },
                    {
                        "id": 88776,
                        "name": "Łazy",
                        "latitude": "50.42769000",
                        "longitude": "19.39465000"
                    },
                    {
                        "id": 88821,
                        "name": "Łękawica",
                        "latitude": "49.72209000",
                        "longitude": "19.26496000"
                    },
                    {
                        "id": 88780,
                        "name": "Łobodno",
                        "latitude": "50.93079000",
                        "longitude": "18.99090000"
                    },
                    {
                        "id": 88783,
                        "name": "Łodygowice",
                        "latitude": "49.72992000",
                        "longitude": "19.13939000"
                    },
                    {
                        "id": 86997,
                        "name": "Markłowice",
                        "latitude": "50.01695000",
                        "longitude": "18.52098000"
                    },
                    {
                        "id": 87004,
                        "name": "Mazańcowice",
                        "latitude": "49.85802000",
                        "longitude": "18.97708000"
                    },
                    {
                        "id": 87016,
                        "name": "Miasteczko Śląskie",
                        "latitude": "50.50262000",
                        "longitude": "18.93949000"
                    },
                    {
                        "id": 87032,
                        "name": "Miedźna",
                        "latitude": "49.98225000",
                        "longitude": "19.04883000"
                    },
                    {
                        "id": 87031,
                        "name": "Miedzno",
                        "latitude": "50.96994000",
                        "longitude": "18.98111000"
                    },
                    {
                        "id": 87059,
                        "name": "Międzybrodzie Bialskie",
                        "latitude": "49.78747000",
                        "longitude": "19.19741000"
                    },
                    {
                        "id": 87039,
                        "name": "Mierzęcice",
                        "latitude": "50.44504000",
                        "longitude": "19.12934000"
                    },
                    {
                        "id": 87044,
                        "name": "Mikołów",
                        "latitude": "50.17103000",
                        "longitude": "18.90410000"
                    },
                    {
                        "id": 87051,
                        "name": "Milówka",
                        "latitude": "49.55540000",
                        "longitude": "19.09072000"
                    },
                    {
                        "id": 87076,
                        "name": "Mnich",
                        "latitude": "49.88944000",
                        "longitude": "18.80722000"
                    },
                    {
                        "id": 87107,
                        "name": "Mstów",
                        "latitude": "50.82969000",
                        "longitude": "19.28547000"
                    },
                    {
                        "id": 87108,
                        "name": "Mszana",
                        "latitude": "49.96939000",
                        "longitude": "18.52793000"
                    },
                    {
                        "id": 87112,
                        "name": "Murcki",
                        "latitude": "50.20036000",
                        "longitude": "19.04351000"
                    },
                    {
                        "id": 87116,
                        "name": "Mykanów",
                        "latitude": "50.92360000",
                        "longitude": "19.20050000"
                    },
                    {
                        "id": 87121,
                        "name": "Mysłowice",
                        "latitude": "50.20745000",
                        "longitude": "19.16668000"
                    },
                    {
                        "id": 87118,
                        "name": "Myszków",
                        "latitude": "50.57520000",
                        "longitude": "19.32461000"
                    },
                    {
                        "id": 87133,
                        "name": "Nakło",
                        "latitude": "50.43690000",
                        "longitude": "18.91056000"
                    },
                    {
                        "id": 87215,
                        "name": "Nędza",
                        "latitude": "50.16112000",
                        "longitude": "18.31103000"
                    },
                    {
                        "id": 87153,
                        "name": "Niedobczyce",
                        "latitude": "50.06540000",
                        "longitude": "18.49531000"
                    },
                    {
                        "id": 87160,
                        "name": "Niegowonice",
                        "latitude": "50.38909000",
                        "longitude": "19.42263000"
                    },
                    {
                        "id": 87223,
                        "name": "Ochaby",
                        "latitude": "49.84252000",
                        "longitude": "18.76894000"
                    },
                    {
                        "id": 87231,
                        "name": "Ogrodzieniec",
                        "latitude": "50.45177000",
                        "longitude": "19.51987000"
                    },
                    {
                        "id": 87247,
                        "name": "Olsztyn",
                        "latitude": "50.75185000",
                        "longitude": "19.26737000"
                    },
                    {
                        "id": 87253,
                        "name": "Olza",
                        "latitude": "49.95393000",
                        "longitude": "18.33910000"
                    },
                    {
                        "id": 87258,
                        "name": "Opatów",
                        "latitude": "50.95567000",
                        "longitude": "18.81941000"
                    },
                    {
                        "id": 87269,
                        "name": "Ornontowice",
                        "latitude": "50.19377000",
                        "longitude": "18.75435000"
                    },
                    {
                        "id": 87271,
                        "name": "Orzech",
                        "latitude": "50.42744000",
                        "longitude": "18.92275000"
                    },
                    {
                        "id": 87273,
                        "name": "Orzesze",
                        "latitude": "50.15595000",
                        "longitude": "18.77923000"
                    },
                    {
                        "id": 87304,
                        "name": "Ostrowy nad Okszą",
                        "latitude": "50.97799000",
                        "longitude": "19.05355000"
                    },
                    {
                        "id": 87326,
                        "name": "Ożarowice",
                        "latitude": "50.46182000",
                        "longitude": "19.04317000"
                    },
                    {
                        "id": 87341,
                        "name": "Paniówki",
                        "latitude": "50.23139000",
                        "longitude": "18.78104000"
                    },
                    {
                        "id": 87342,
                        "name": "Panki",
                        "latitude": "50.88333000",
                        "longitude": "18.75160000"
                    },
                    {
                        "id": 87357,
                        "name": "Pawłowice",
                        "latitude": "49.96127000",
                        "longitude": "18.71778000"
                    },
                    {
                        "id": 87355,
                        "name": "Pawonków",
                        "latitude": "50.69499000",
                        "longitude": "18.58149000"
                    },
                    {
                        "id": 87366,
                        "name": "Pewel Ślemieńska",
                        "latitude": "49.68968000",
                        "longitude": "19.33431000"
                    },
                    {
                        "id": 87365,
                        "name": "Pewel Wielka",
                        "latitude": "49.67457000",
                        "longitude": "19.37482000"
                    },
                    {
                        "id": 87369,
                        "name": "Piasek",
                        "latitude": "50.01055000",
                        "longitude": "18.94807000"
                    },
                    {
                        "id": 87376,
                        "name": "Piekary Śląskie",
                        "latitude": "50.38017000",
                        "longitude": "18.92653000"
                    },
                    {
                        "id": 87379,
                        "name": "Pielgrzymowice",
                        "latitude": "49.90547000",
                        "longitude": "18.64886000"
                    },
                    {
                        "id": 87382,
                        "name": "Pierściec",
                        "latitude": "49.83339000",
                        "longitude": "18.81409000"
                    },
                    {
                        "id": 87384,
                        "name": "Pietrowice Wielkie",
                        "latitude": "50.08452000",
                        "longitude": "18.09148000"
                    },
                    {
                        "id": 87385,
                        "name": "Pietrzykowice",
                        "latitude": "49.69634000",
                        "longitude": "19.15990000"
                    },
                    {
                        "id": 87388,
                        "name": "Pilchowice",
                        "latitude": "50.21668000",
                        "longitude": "18.56132000"
                    },
                    {
                        "id": 87390,
                        "name": "Pilica",
                        "latitude": "50.46799000",
                        "longitude": "19.65729000"
                    },
                    {
                        "id": 87395,
                        "name": "Pisarzowice",
                        "latitude": "49.88363000",
                        "longitude": "19.14565000"
                    },
                    {
                        "id": 87426,
                        "name": "Pogórze",
                        "latitude": "49.79961000",
                        "longitude": "18.84327000"
                    },
                    {
                        "id": 87422,
                        "name": "Pogrzebień",
                        "latitude": "50.06722000",
                        "longitude": "18.29876000"
                    },
                    {
                        "id": 87423,
                        "name": "Pogwizdów",
                        "latitude": "49.80382000",
                        "longitude": "18.60106000"
                    },
                    {
                        "id": 87779,
                        "name": "Połomia",
                        "latitude": "49.99185000",
                        "longitude": "18.55102000"
                    },
                    {
                        "id": 87446,
                        "name": "Porąbka",
                        "latitude": "49.81716000",
                        "longitude": "19.21835000"
                    },
                    {
                        "id": 87443,
                        "name": "Poraj",
                        "latitude": "50.67797000",
                        "longitude": "19.21509000"
                    },
                    {
                        "id": 87449,
                        "name": "Poręba",
                        "latitude": "50.48831000",
                        "longitude": "19.33903000"
                    },
                    {
                        "id": 87454,
                        "name": "Potok Złoty",
                        "latitude": "50.70676000",
                        "longitude": "19.43091000"
                    },
                    {
                        "id": 87481,
                        "name": "Powiat będziński",
                        "latitude": "50.32924000",
                        "longitude": "19.10419000"
                    },
                    {
                        "id": 87465,
                        "name": "Powiat bielski",
                        "latitude": "49.76175000",
                        "longitude": "19.10660000"
                    },
                    {
                        "id": 87467,
                        "name": "Powiat bieruńsko-lędziński",
                        "latitude": "50.09356000",
                        "longitude": "19.14270000"
                    },
                    {
                        "id": 87489,
                        "name": "Powiat cieszyński",
                        "latitude": "49.72628000",
                        "longitude": "18.79147000"
                    },
                    {
                        "id": 87491,
                        "name": "Powiat częstochowski",
                        "latitude": "50.84118000",
                        "longitude": "19.34045000"
                    },
                    {
                        "id": 87503,
                        "name": "Powiat gliwicki",
                        "latitude": "50.36266000",
                        "longitude": "18.58107000"
                    },
                    {
                        "id": 87562,
                        "name": "Powiat kłobucki",
                        "latitude": "50.93274000",
                        "longitude": "18.87005000"
                    },
                    {
                        "id": 87578,
                        "name": "Powiat lubliniecki",
                        "latitude": "50.67367000",
                        "longitude": "18.79378000"
                    },
                    {
                        "id": 87585,
                        "name": "Powiat mikołowski",
                        "latitude": "50.15133000",
                        "longitude": "18.83689000"
                    },
                    {
                        "id": 87593,
                        "name": "Powiat myszkowski",
                        "latitude": "50.60554000",
                        "longitude": "19.35125000"
                    },
                    {
                        "id": 87648,
                        "name": "Powiat pszczyński",
                        "latitude": "49.98987000",
                        "longitude": "18.88177000"
                    },
                    {
                        "id": 87655,
                        "name": "Powiat raciborski",
                        "latitude": "50.08696000",
                        "longitude": "18.26916000"
                    },
                    {
                        "id": 87663,
                        "name": "Powiat rybnicki",
                        "latitude": "50.10385000",
                        "longitude": "18.46527000"
                    },
                    {
                        "id": 87702,
                        "name": "Powiat tarnogórski",
                        "latitude": "50.47264000",
                        "longitude": "18.86265000"
                    },
                    {
                        "id": 87720,
                        "name": "Powiat wodzisławski",
                        "latitude": "49.99323000",
                        "longitude": "18.42504000"
                    },
                    {
                        "id": 87738,
                        "name": "Powiat zawierciański",
                        "latitude": "50.54225000",
                        "longitude": "19.61192000"
                    },
                    {
                        "id": 87769,
                        "name": "Powiat żywiecki",
                        "latitude": "49.61145000",
                        "longitude": "19.21367000"
                    },
                    {
                        "id": 87793,
                        "name": "Pruchna",
                        "latitude": "49.86527000",
                        "longitude": "18.68191000"
                    },
                    {
                        "id": 87821,
                        "name": "Przyborów",
                        "latitude": "49.62150000",
                        "longitude": "19.38701000"
                    },
                    {
                        "id": 87826,
                        "name": "Przyrów",
                        "latitude": "50.80051000",
                        "longitude": "19.52794000"
                    },
                    {
                        "id": 87827,
                        "name": "Przystajń",
                        "latitude": "50.88495000",
                        "longitude": "18.69169000"
                    },
                    {
                        "id": 87829,
                        "name": "Przyszowice",
                        "latitude": "50.24841000",
                        "longitude": "18.74594000"
                    },
                    {
                        "id": 87838,
                        "name": "Psary",
                        "latitude": "50.61470000",
                        "longitude": "18.96991000"
                    },
                    {
                        "id": 87843,
                        "name": "Pszczyna",
                        "latitude": "49.98037000",
                        "longitude": "18.95382000"
                    },
                    {
                        "id": 87845,
                        "name": "Pszów",
                        "latitude": "50.03994000",
                        "longitude": "18.39472000"
                    },
                    {
                        "id": 87853,
                        "name": "Puńców",
                        "latitude": "49.71842000",
                        "longitude": "18.66157000"
                    },
                    {
                        "id": 87856,
                        "name": "Pyskowice",
                        "latitude": "50.40000000",
                        "longitude": "18.63333000"
                    },
                    {
                        "id": 87872,
                        "name": "Racibórz",
                        "latitude": "50.09195000",
                        "longitude": "18.21928000"
                    },
                    {
                        "id": 87882,
                        "name": "Radlin",
                        "latitude": "50.05020000",
                        "longitude": "18.47626000"
                    },
                    {
                        "id": 87889,
                        "name": "Radostowice",
                        "latitude": "50.00311000",
                        "longitude": "18.88103000"
                    },
                    {
                        "id": 87896,
                        "name": "Radziechowy",
                        "latitude": "49.64651000",
                        "longitude": "19.13115000"
                    },
                    {
                        "id": 87899,
                        "name": "Radzionków",
                        "latitude": "50.40026000",
                        "longitude": "18.90232000"
                    },
                    {
                        "id": 87906,
                        "name": "Rajcza",
                        "latitude": "49.50927000",
                        "longitude": "19.11278000"
                    },
                    {
                        "id": 87913,
                        "name": "Raszczyce",
                        "latitude": "50.12190000",
                        "longitude": "18.29962000"
                    },
                    {
                        "id": 88038,
                        "name": "Rędziny",
                        "latitude": "50.85922000",
                        "longitude": "19.21620000"
                    },
                    {
                        "id": 87948,
                        "name": "Rogów",
                        "latitude": "49.99097000",
                        "longitude": "18.35077000"
                    },
                    {
                        "id": 87945,
                        "name": "Rogoźnik",
                        "latitude": "50.39106000",
                        "longitude": "19.03776000"
                    },
                    {
                        "id": 87959,
                        "name": "Rokitno Szlacheckie",
                        "latitude": "50.43195000",
                        "longitude": "19.43293000"
                    },
                    {
                        "id": 87971,
                        "name": "Ruda Śląska",
                        "latitude": "50.25840000",
                        "longitude": "18.85632000"
                    },
                    {
                        "id": 87979,
                        "name": "Rudnik",
                        "latitude": "50.12729000",
                        "longitude": "18.18598000"
                    },
                    {
                        "id": 87982,
                        "name": "Rudniki",
                        "latitude": "50.52134000",
                        "longitude": "19.43130000"
                    },
                    {
                        "id": 87983,
                        "name": "Rudy",
                        "latitude": "50.19003000",
                        "longitude": "18.45334000"
                    },
                    {
                        "id": 87984,
                        "name": "Rudziczka",
                        "latitude": "50.03608000",
                        "longitude": "18.76225000"
                    },
                    {
                        "id": 87985,
                        "name": "Rudziniec",
                        "latitude": "50.35324000",
                        "longitude": "18.40914000"
                    },
                    {
                        "id": 87991,
                        "name": "Rybarzowice",
                        "latitude": "49.72956000",
                        "longitude": "19.10162000"
                    },
                    {
                        "id": 87994,
                        "name": "Rybnik",
                        "latitude": "50.09713000",
                        "longitude": "18.54179000"
                    },
                    {
                        "id": 87997,
                        "name": "Rycerka Dolna",
                        "latitude": "49.47805000",
                        "longitude": "19.06162000"
                    },
                    {
                        "id": 87998,
                        "name": "Rycerka Górna",
                        "latitude": "49.44436000",
                        "longitude": "19.01596000"
                    },
                    {
                        "id": 88004,
                        "name": "Rydułtowy",
                        "latitude": "50.05857000",
                        "longitude": "18.41703000"
                    },
                    {
                        "id": 88325,
                        "name": "Sączów",
                        "latitude": "50.43520000",
                        "longitude": "19.03038000"
                    },
                    {
                        "id": 88052,
                        "name": "Sarnów",
                        "latitude": "50.37380000",
                        "longitude": "19.15061000"
                    },
                    {
                        "id": 88071,
                        "name": "Siemianowice Śląskie",
                        "latitude": "50.32738000",
                        "longitude": "19.02901000"
                    },
                    {
                        "id": 88089,
                        "name": "Sieraków Śląski",
                        "latitude": "50.80290000",
                        "longitude": "18.57548000"
                    },
                    {
                        "id": 88093,
                        "name": "Siewierz",
                        "latitude": "50.46657000",
                        "longitude": "19.23028000"
                    },
                    {
                        "id": 88108,
                        "name": "Skoczów",
                        "latitude": "49.80089000",
                        "longitude": "18.78770000"
                    },
                    {
                        "id": 88118,
                        "name": "Skrzyszów",
                        "latitude": "49.94873000",
                        "longitude": "18.48879000"
                    },
                    {
                        "id": 88830,
                        "name": "Ślemień",
                        "latitude": "49.71826000",
                        "longitude": "19.36735000"
                    },
                    {
                        "id": 88337,
                        "name": "Sławków",
                        "latitude": "50.29943000",
                        "longitude": "19.38967000"
                    },
                    {
                        "id": 88324,
                        "name": "Sól",
                        "latitude": "49.48764000",
                        "longitude": "19.04171000"
                    },
                    {
                        "id": 88149,
                        "name": "Sopotnia Wielka",
                        "latitude": "49.56853000",
                        "longitude": "19.28289000"
                    },
                    {
                        "id": 88158,
                        "name": "Sośnicowice",
                        "latitude": "50.27214000",
                        "longitude": "18.52982000"
                    },
                    {
                        "id": 88152,
                        "name": "Sosnowiec",
                        "latitude": "50.27119000",
                        "longitude": "19.19463000"
                    },
                    {
                        "id": 88171,
                        "name": "Stanowice",
                        "latitude": "50.13037000",
                        "longitude": "18.67084000"
                    },
                    {
                        "id": 88180,
                        "name": "Starcza",
                        "latitude": "50.66421000",
                        "longitude": "19.04180000"
                    },
                    {
                        "id": 88191,
                        "name": "Starokrzepice",
                        "latitude": "50.94859000",
                        "longitude": "18.65341000"
                    },
                    {
                        "id": 88218,
                        "name": "Strumień",
                        "latitude": "49.92103000",
                        "longitude": "18.76637000"
                    },
                    {
                        "id": 88223,
                        "name": "Strzebiń",
                        "latitude": "50.61647000",
                        "longitude": "18.89794000"
                    },
                    {
                        "id": 88235,
                        "name": "Strzyżowice",
                        "latitude": "50.38725000",
                        "longitude": "19.08038000"
                    },
                    {
                        "id": 88240,
                        "name": "Studzionka",
                        "latitude": "49.96232000",
                        "longitude": "18.77280000"
                    },
                    {
                        "id": 88268,
                        "name": "Suszec",
                        "latitude": "50.02958000",
                        "longitude": "18.79160000"
                    },
                    {
                        "id": 88854,
                        "name": "Świerklaniec",
                        "latitude": "50.44237000",
                        "longitude": "18.93734000"
                    },
                    {
                        "id": 88855,
                        "name": "Świerklany Dolne",
                        "latitude": "50.01827000",
                        "longitude": "18.57702000"
                    },
                    {
                        "id": 88856,
                        "name": "Świerklany Górne",
                        "latitude": "50.02765000",
                        "longitude": "18.59050000"
                    },
                    {
                        "id": 88867,
                        "name": "Świętochłowice",
                        "latitude": "50.29636000",
                        "longitude": "18.91726000"
                    },
                    {
                        "id": 88861,
                        "name": "Świnna",
                        "latitude": "49.65802000",
                        "longitude": "19.25406000"
                    },
                    {
                        "id": 88282,
                        "name": "Syrynia",
                        "latitude": "50.02004000",
                        "longitude": "18.34597000"
                    },
                    {
                        "id": 88295,
                        "name": "Szczekociny",
                        "latitude": "50.62669000",
                        "longitude": "19.82500000"
                    },
                    {
                        "id": 88297,
                        "name": "Szczerbice",
                        "latitude": "50.09416000",
                        "longitude": "18.44896000"
                    },
                    {
                        "id": 88303,
                        "name": "Szczyrk",
                        "latitude": "49.71724000",
                        "longitude": "19.03183000"
                    },
                    {
                        "id": 88364,
                        "name": "Tarnowskie Góry",
                        "latitude": "50.44548000",
                        "longitude": "18.86147000"
                    },
                    {
                        "id": 88386,
                        "name": "Toszek",
                        "latitude": "50.45442000",
                        "longitude": "18.52209000"
                    },
                    {
                        "id": 88392,
                        "name": "Truskolasy",
                        "latitude": "50.86692000",
                        "longitude": "18.82705000"
                    },
                    {
                        "id": 88406,
                        "name": "Trzebinia",
                        "latitude": "49.65024000",
                        "longitude": "19.22264000"
                    },
                    {
                        "id": 88427,
                        "name": "Turza Śląska",
                        "latitude": "49.97231000",
                        "longitude": "18.43781000"
                    },
                    {
                        "id": 88433,
                        "name": "Tworków",
                        "latitude": "50.00559000",
                        "longitude": "18.23576000"
                    },
                    {
                        "id": 88434,
                        "name": "Tworóg",
                        "latitude": "50.53100000",
                        "longitude": "18.71572000"
                    },
                    {
                        "id": 88436,
                        "name": "Tychy",
                        "latitude": "50.13717000",
                        "longitude": "18.96641000"
                    },
                    {
                        "id": 88451,
                        "name": "Ujsoły",
                        "latitude": "49.48290000",
                        "longitude": "19.13801000"
                    },
                    {
                        "id": 88464,
                        "name": "Ustroń",
                        "latitude": "49.72153000",
                        "longitude": "18.80198000"
                    },
                    {
                        "id": 88638,
                        "name": "Węgierska Górka",
                        "latitude": "49.60776000",
                        "longitude": "19.11638000"
                    },
                    {
                        "id": 88510,
                        "name": "Wielowieś",
                        "latitude": "50.50966000",
                        "longitude": "18.61608000"
                    },
                    {
                        "id": 88513,
                        "name": "Wieprz",
                        "latitude": "49.64746000",
                        "longitude": "19.18007000"
                    },
                    {
                        "id": 88527,
                        "name": "Wieszowa",
                        "latitude": "50.38444000",
                        "longitude": "18.75924000"
                    },
                    {
                        "id": 88530,
                        "name": "Wilamowice",
                        "latitude": "49.91701000",
                        "longitude": "19.15237000"
                    },
                    {
                        "id": 88532,
                        "name": "Wilcza",
                        "latitude": "50.18899000",
                        "longitude": "18.59668000"
                    },
                    {
                        "id": 88538,
                        "name": "Wilkowice",
                        "latitude": "49.76282000",
                        "longitude": "19.08973000"
                    },
                    {
                        "id": 88547,
                        "name": "Wisła",
                        "latitude": "49.65629000",
                        "longitude": "18.85910000"
                    },
                    {
                        "id": 88651,
                        "name": "Włodowice",
                        "latitude": "50.55560000",
                        "longitude": "19.45155000"
                    },
                    {
                        "id": 88569,
                        "name": "Wodzisław Śląski",
                        "latitude": "50.00377000",
                        "longitude": "18.47205000"
                    },
                    {
                        "id": 88576,
                        "name": "Wojkowice",
                        "latitude": "50.36509000",
                        "longitude": "19.03652000"
                    },
                    {
                        "id": 88581,
                        "name": "Wola",
                        "latitude": "50.01745000",
                        "longitude": "19.12333000"
                    },
                    {
                        "id": 88603,
                        "name": "Wożniki",
                        "latitude": "50.58934000",
                        "longitude": "19.05991000"
                    },
                    {
                        "id": 88609,
                        "name": "Wręczyca Wielka",
                        "latitude": "50.84589000",
                        "longitude": "18.92086000"
                    },
                    {
                        "id": 88613,
                        "name": "Wyry",
                        "latitude": "50.13296000",
                        "longitude": "18.90052000"
                    },
                    {
                        "id": 88618,
                        "name": "Wysoka",
                        "latitude": "50.42989000",
                        "longitude": "19.35368000"
                    },
                    {
                        "id": 88662,
                        "name": "Zabłocie",
                        "latitude": "49.90282000",
                        "longitude": "18.78147000"
                    },
                    {
                        "id": 88870,
                        "name": "Żabnica",
                        "latitude": "49.58139000",
                        "longitude": "19.15621000"
                    },
                    {
                        "id": 88658,
                        "name": "Zaborze",
                        "latitude": "49.87279000",
                        "longitude": "18.80370000"
                    },
                    {
                        "id": 88659,
                        "name": "Zabrze",
                        "latitude": "50.32492000",
                        "longitude": "18.78576000"
                    },
                    {
                        "id": 88660,
                        "name": "Zabrzeg",
                        "latitude": "49.91619000",
                        "longitude": "18.94292000"
                    },
                    {
                        "id": 88689,
                        "name": "Zamarski",
                        "latitude": "49.78254000",
                        "longitude": "18.66972000"
                    },
                    {
                        "id": 88873,
                        "name": "Żarki",
                        "latitude": "50.62518000",
                        "longitude": "19.36357000"
                    },
                    {
                        "id": 88875,
                        "name": "Żarki-Letnisko",
                        "latitude": "50.62295000",
                        "longitude": "19.27508000"
                    },
                    {
                        "id": 88697,
                        "name": "Zarzecze",
                        "latitude": "49.71932000",
                        "longitude": "19.17526000"
                    },
                    {
                        "id": 88704,
                        "name": "Zawidów",
                        "latitude": "51.02546000",
                        "longitude": "15.06213000"
                    },
                    {
                        "id": 88705,
                        "name": "Zawiercie",
                        "latitude": "50.48766000",
                        "longitude": "19.41679000"
                    },
                    {
                        "id": 88709,
                        "name": "Zbrosławice",
                        "latitude": "50.41612000",
                        "longitude": "18.75443000"
                    },
                    {
                        "id": 88711,
                        "name": "Zbytków",
                        "latitude": "49.92288000",
                        "longitude": "18.72697000"
                    },
                    {
                        "id": 88721,
                        "name": "Zebrzydowice",
                        "latitude": "49.87793000",
                        "longitude": "18.61127000"
                    },
                    {
                        "id": 88885,
                        "name": "Żernica",
                        "latitude": "50.24770000",
                        "longitude": "18.61547000"
                    },
                    {
                        "id": 88890,
                        "name": "Żory",
                        "latitude": "50.04523000",
                        "longitude": "18.70062000"
                    },
                    {
                        "id": 88901,
                        "name": "Żywiec",
                        "latitude": "49.68529000",
                        "longitude": "19.19243000"
                    }
                ]
            },
            {
                "id": 1626,
                "name": "Subcarpathia",
                "iso2": "18",
                "latitude": "50.05747490",
                "longitude": "22.08956910",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85777,
                        "name": "Adamówka",
                        "latitude": "50.25857000",
                        "longitude": "22.69595000"
                    },
                    {
                        "id": 85778,
                        "name": "Albigowa",
                        "latitude": "50.01425000",
                        "longitude": "22.22414000"
                    },
                    {
                        "id": 85789,
                        "name": "Babica",
                        "latitude": "49.93476000",
                        "longitude": "21.87035000"
                    },
                    {
                        "id": 85796,
                        "name": "Baligród",
                        "latitude": "49.33090000",
                        "longitude": "22.28566000"
                    },
                    {
                        "id": 85806,
                        "name": "Baranów Sandomierski",
                        "latitude": "50.49912000",
                        "longitude": "21.54204000"
                    },
                    {
                        "id": 85825,
                        "name": "Besko",
                        "latitude": "49.58757000",
                        "longitude": "21.95292000"
                    },
                    {
                        "id": 85842,
                        "name": "Białobrzegi",
                        "latitude": "50.10252000",
                        "longitude": "22.31907000"
                    },
                    {
                        "id": 85857,
                        "name": "Bieliny",
                        "latitude": "50.44237000",
                        "longitude": "22.30482000"
                    },
                    {
                        "id": 85872,
                        "name": "Bircza",
                        "latitude": "49.69173000",
                        "longitude": "22.47854000"
                    },
                    {
                        "id": 85882,
                        "name": "Blizne",
                        "latitude": "49.75332000",
                        "longitude": "21.97351000"
                    },
                    {
                        "id": 86015,
                        "name": "Błażowa",
                        "latitude": "49.88521000",
                        "longitude": "22.10037000"
                    },
                    {
                        "id": 85898,
                        "name": "Boguchwała",
                        "latitude": "49.98473000",
                        "longitude": "21.94528000"
                    },
                    {
                        "id": 85905,
                        "name": "Bojanów",
                        "latitude": "50.42531000",
                        "longitude": "21.95111000"
                    },
                    {
                        "id": 85924,
                        "name": "Borowa",
                        "latitude": "50.38548000",
                        "longitude": "21.35150000"
                    },
                    {
                        "id": 85967,
                        "name": "Brzeźnica",
                        "latitude": "50.10065000",
                        "longitude": "21.48025000"
                    },
                    {
                        "id": 85970,
                        "name": "Brzostek",
                        "latitude": "49.87954000",
                        "longitude": "21.41102000"
                    },
                    {
                        "id": 85975,
                        "name": "Brzóza Królewska",
                        "latitude": "50.23908000",
                        "longitude": "22.32559000"
                    },
                    {
                        "id": 85976,
                        "name": "Brzóza Stadnicka",
                        "latitude": "50.19965000",
                        "longitude": "22.28233000"
                    },
                    {
                        "id": 85972,
                        "name": "Brzozów",
                        "latitude": "49.69501000",
                        "longitude": "22.01926000"
                    },
                    {
                        "id": 85974,
                        "name": "Brzyska",
                        "latitude": "49.82226000",
                        "longitude": "21.39004000"
                    },
                    {
                        "id": 85992,
                        "name": "Bukowsko",
                        "latitude": "49.48039000",
                        "longitude": "22.06329000"
                    },
                    {
                        "id": 86035,
                        "name": "Chmielnik",
                        "latitude": "49.97386000",
                        "longitude": "22.14535000"
                    },
                    {
                        "id": 86051,
                        "name": "Chorkówka",
                        "latitude": "49.64668000",
                        "longitude": "21.67156000"
                    },
                    {
                        "id": 86068,
                        "name": "Chwałowice",
                        "latitude": "50.76665000",
                        "longitude": "21.88683000"
                    },
                    {
                        "id": 86086,
                        "name": "Cieszanów",
                        "latitude": "50.24564000",
                        "longitude": "23.13163000"
                    },
                    {
                        "id": 86091,
                        "name": "Cisna",
                        "latitude": "49.21328000",
                        "longitude": "22.32795000"
                    },
                    {
                        "id": 86095,
                        "name": "Cmolas",
                        "latitude": "50.29526000",
                        "longitude": "21.74417000"
                    },
                    {
                        "id": 86104,
                        "name": "Czarna",
                        "latitude": "50.06717000",
                        "longitude": "21.25614000"
                    },
                    {
                        "id": 86120,
                        "name": "Czaszyn",
                        "latitude": "49.44854000",
                        "longitude": "22.21650000"
                    },
                    {
                        "id": 86127,
                        "name": "Czermin",
                        "latitude": "50.33911000",
                        "longitude": "21.33356000"
                    },
                    {
                        "id": 86146,
                        "name": "Czudec",
                        "latitude": "49.94487000",
                        "longitude": "21.84134000"
                    },
                    {
                        "id": 86247,
                        "name": "Dębica",
                        "latitude": "50.05146000",
                        "longitude": "21.41141000"
                    },
                    {
                        "id": 86250,
                        "name": "Dębno",
                        "latitude": "50.19811000",
                        "longitude": "22.51837000"
                    },
                    {
                        "id": 86257,
                        "name": "Dębów",
                        "latitude": "50.04490000",
                        "longitude": "22.43614000"
                    },
                    {
                        "id": 86255,
                        "name": "Dębowiec",
                        "latitude": "49.68374000",
                        "longitude": "21.46068000"
                    },
                    {
                        "id": 86258,
                        "name": "Długie",
                        "latitude": "49.57866000",
                        "longitude": "22.04338000"
                    },
                    {
                        "id": 86185,
                        "name": "Domaradz",
                        "latitude": "49.78675000",
                        "longitude": "21.94571000"
                    },
                    {
                        "id": 86204,
                        "name": "Dubiecko",
                        "latitude": "49.82608000",
                        "longitude": "22.39117000"
                    },
                    {
                        "id": 86207,
                        "name": "Dukla",
                        "latitude": "49.55554000",
                        "longitude": "21.68317000"
                    },
                    {
                        "id": 86211,
                        "name": "Dydnia",
                        "latitude": "49.68640000",
                        "longitude": "22.17196000"
                    },
                    {
                        "id": 86213,
                        "name": "Dynów",
                        "latitude": "49.81506000",
                        "longitude": "22.23388000"
                    },
                    {
                        "id": 86229,
                        "name": "Dzików Stary",
                        "latitude": "50.24699000",
                        "longitude": "22.92984000"
                    },
                    {
                        "id": 86228,
                        "name": "Dzikowiec",
                        "latitude": "50.27288000",
                        "longitude": "21.84365000"
                    },
                    {
                        "id": 86274,
                        "name": "Fredropol",
                        "latitude": "49.69578000",
                        "longitude": "22.74625000"
                    },
                    {
                        "id": 86279,
                        "name": "Frysztak",
                        "latitude": "49.84164000",
                        "longitude": "21.60942000"
                    },
                    {
                        "id": 86289,
                        "name": "Gać",
                        "latitude": "50.02693000",
                        "longitude": "22.35898000"
                    },
                    {
                        "id": 86296,
                        "name": "Giedlarowa",
                        "latitude": "50.22689000",
                        "longitude": "22.40593000"
                    },
                    {
                        "id": 86428,
                        "name": "Głogów Małopolski",
                        "latitude": "50.15122000",
                        "longitude": "21.96287000"
                    },
                    {
                        "id": 86433,
                        "name": "Głuchów",
                        "latitude": "50.08171000",
                        "longitude": "22.27135000"
                    },
                    {
                        "id": 86324,
                        "name": "Golcowa",
                        "latitude": "49.77162000",
                        "longitude": "22.02501000"
                    },
                    {
                        "id": 86413,
                        "name": "Górki",
                        "latitude": "49.64385000",
                        "longitude": "22.04304000"
                    },
                    {
                        "id": 86335,
                        "name": "Gorliczyna",
                        "latitude": "50.09217000",
                        "longitude": "22.48764000"
                    },
                    {
                        "id": 86416,
                        "name": "Górno",
                        "latitude": "50.28243000",
                        "longitude": "22.14500000"
                    },
                    {
                        "id": 86338,
                        "name": "Gorzyce",
                        "latitude": "50.12841000",
                        "longitude": "22.57926000"
                    },
                    {
                        "id": 86366,
                        "name": "Grabownica Starzeńska",
                        "latitude": "49.65896000",
                        "longitude": "22.07754000"
                    },
                    {
                        "id": 86403,
                        "name": "Grębów",
                        "latitude": "50.56536000",
                        "longitude": "21.87404000"
                    },
                    {
                        "id": 86377,
                        "name": "Grodzisko Dolne",
                        "latitude": "50.16238000",
                        "longitude": "22.46292000"
                    },
                    {
                        "id": 86378,
                        "name": "Grodzisko Górne",
                        "latitude": "50.18690000",
                        "longitude": "22.43786000"
                    },
                    {
                        "id": 86398,
                        "name": "Grzęska",
                        "latitude": "50.08303000",
                        "longitude": "22.45399000"
                    },
                    {
                        "id": 86406,
                        "name": "Gwoźnica Górna",
                        "latitude": "49.82791000",
                        "longitude": "21.99772000"
                    },
                    {
                        "id": 86438,
                        "name": "Haczów",
                        "latitude": "49.66152000",
                        "longitude": "21.89790000"
                    },
                    {
                        "id": 86441,
                        "name": "Handzlówka",
                        "latitude": "49.99527000",
                        "longitude": "22.22311000"
                    },
                    {
                        "id": 86442,
                        "name": "Harasiuki",
                        "latitude": "50.47515000",
                        "longitude": "22.47288000"
                    },
                    {
                        "id": 86451,
                        "name": "Horyniec-Zdrój",
                        "latitude": "50.19152000",
                        "longitude": "23.36277000"
                    },
                    {
                        "id": 86453,
                        "name": "Humniska",
                        "latitude": "49.67507000",
                        "longitude": "22.05368000"
                    },
                    {
                        "id": 86454,
                        "name": "Husów",
                        "latitude": "49.97971000",
                        "longitude": "22.28645000"
                    },
                    {
                        "id": 86456,
                        "name": "Hyżne",
                        "latitude": "49.91769000",
                        "longitude": "22.18131000"
                    },
                    {
                        "id": 86464,
                        "name": "Iwierzyce",
                        "latitude": "50.02958000",
                        "longitude": "21.75396000"
                    },
                    {
                        "id": 86466,
                        "name": "Iwonicz-Zdrój",
                        "latitude": "49.56319000",
                        "longitude": "21.78992000"
                    },
                    {
                        "id": 86478,
                        "name": "Jabłonica Polska",
                        "latitude": "49.69784000",
                        "longitude": "21.89961000"
                    },
                    {
                        "id": 86479,
                        "name": "Jabłonka",
                        "latitude": "49.69417000",
                        "longitude": "22.11565000"
                    },
                    {
                        "id": 86490,
                        "name": "Jagiełła",
                        "latitude": "50.09460000",
                        "longitude": "22.57261000"
                    },
                    {
                        "id": 86508,
                        "name": "Jarocin",
                        "latitude": "50.56459000",
                        "longitude": "22.32121000"
                    },
                    {
                        "id": 86511,
                        "name": "Jarosław",
                        "latitude": "50.01623000",
                        "longitude": "22.67776000"
                    },
                    {
                        "id": 86515,
                        "name": "Jasienica Rosielna",
                        "latitude": "49.75144000",
                        "longitude": "21.94176000"
                    },
                    {
                        "id": 86519,
                        "name": "Jasionów",
                        "latitude": "49.65841000",
                        "longitude": "21.97678000"
                    },
                    {
                        "id": 86539,
                        "name": "Jaśliska",
                        "latitude": "49.44229000",
                        "longitude": "21.80795000"
                    },
                    {
                        "id": 86530,
                        "name": "Jasło",
                        "latitude": "49.74506000",
                        "longitude": "21.47252000"
                    },
                    {
                        "id": 86532,
                        "name": "Jawornik",
                        "latitude": "49.84640000",
                        "longitude": "21.89404000"
                    },
                    {
                        "id": 86534,
                        "name": "Jawornik Polski",
                        "latitude": "49.89082000",
                        "longitude": "22.28868000"
                    },
                    {
                        "id": 86540,
                        "name": "Jedlicze",
                        "latitude": "49.71749000",
                        "longitude": "21.64886000"
                    },
                    {
                        "id": 86559,
                        "name": "Jeżowe",
                        "latitude": "50.37486000",
                        "longitude": "22.12749000"
                    },
                    {
                        "id": 86562,
                        "name": "Jodłowa",
                        "latitude": "49.87229000",
                        "longitude": "21.27897000"
                    },
                    {
                        "id": 86563,
                        "name": "Jodłówka",
                        "latitude": "49.89430000",
                        "longitude": "22.46653000"
                    },
                    {
                        "id": 86598,
                        "name": "Kamień",
                        "latitude": "50.34064000",
                        "longitude": "22.13539000"
                    },
                    {
                        "id": 86629,
                        "name": "Kańczuga",
                        "latitude": "49.98346000",
                        "longitude": "22.41168000"
                    },
                    {
                        "id": 86855,
                        "name": "Kępie Żaleszańskie",
                        "latitude": "50.63983000",
                        "longitude": "21.88133000"
                    },
                    {
                        "id": 86632,
                        "name": "Kielanówka",
                        "latitude": "50.02616000",
                        "longitude": "21.92905000"
                    },
                    {
                        "id": 86677,
                        "name": "Kolbuszowa",
                        "latitude": "50.24410000",
                        "longitude": "21.77610000"
                    },
                    {
                        "id": 86741,
                        "name": "Kołaczyce",
                        "latitude": "49.80743000",
                        "longitude": "21.43407000"
                    },
                    {
                        "id": 86685,
                        "name": "Komańcza",
                        "latitude": "49.33922000",
                        "longitude": "22.06166000"
                    },
                    {
                        "id": 86747,
                        "name": "Kończyce",
                        "latitude": "50.42575000",
                        "longitude": "22.15376000"
                    },
                    {
                        "id": 86692,
                        "name": "Konieczkowa",
                        "latitude": "49.84208000",
                        "longitude": "21.92820000"
                    },
                    {
                        "id": 86702,
                        "name": "Korczyna",
                        "latitude": "49.71555000",
                        "longitude": "21.80941000"
                    },
                    {
                        "id": 86711,
                        "name": "Kosina",
                        "latitude": "50.07213000",
                        "longitude": "22.32903000"
                    },
                    {
                        "id": 86761,
                        "name": "Kraczkowa",
                        "latitude": "50.03796000",
                        "longitude": "22.16801000"
                    },
                    {
                        "id": 86764,
                        "name": "Kramarzówka",
                        "latitude": "49.86034000",
                        "longitude": "22.50137000"
                    },
                    {
                        "id": 86767,
                        "name": "Krasiczyn",
                        "latitude": "49.77644000",
                        "longitude": "22.65252000"
                    },
                    {
                        "id": 86769,
                        "name": "Krasne",
                        "latitude": "50.05626000",
                        "longitude": "22.08638000"
                    },
                    {
                        "id": 86778,
                        "name": "Krempna",
                        "latitude": "49.51128000",
                        "longitude": "21.50042000"
                    },
                    {
                        "id": 86786,
                        "name": "Krościenko Wyżne",
                        "latitude": "49.67946000",
                        "longitude": "21.82898000"
                    },
                    {
                        "id": 86782,
                        "name": "Krosno",
                        "latitude": "49.68866000",
                        "longitude": "21.77058000"
                    },
                    {
                        "id": 86803,
                        "name": "Krzeczowice",
                        "latitude": "49.98920000",
                        "longitude": "22.46378000"
                    },
                    {
                        "id": 86805,
                        "name": "Krzemienica",
                        "latitude": "50.06210000",
                        "longitude": "22.18054000"
                    },
                    {
                        "id": 86810,
                        "name": "Krzeszów",
                        "latitude": "50.40381000",
                        "longitude": "22.34241000"
                    },
                    {
                        "id": 86818,
                        "name": "Krzywcza",
                        "latitude": "49.79894000",
                        "longitude": "22.54549000"
                    },
                    {
                        "id": 86841,
                        "name": "Kuryłówka",
                        "latitude": "50.29976000",
                        "longitude": "22.46601000"
                    },
                    {
                        "id": 86873,
                        "name": "Laszki",
                        "latitude": "50.02020000",
                        "longitude": "22.89997000"
                    },
                    {
                        "id": 86875,
                        "name": "Lecka",
                        "latitude": "49.87860000",
                        "longitude": "22.01368000"
                    },
                    {
                        "id": 86881,
                        "name": "Lesko",
                        "latitude": "49.47010000",
                        "longitude": "22.33042000"
                    },
                    {
                        "id": 86894,
                        "name": "Leżajsk",
                        "latitude": "50.26257000",
                        "longitude": "22.41932000"
                    },
                    {
                        "id": 86911,
                        "name": "Lipnica",
                        "latitude": "50.28939000",
                        "longitude": "21.88811000"
                    },
                    {
                        "id": 86930,
                        "name": "Lubaczów",
                        "latitude": "50.15700000",
                        "longitude": "23.12339000"
                    },
                    {
                        "id": 86937,
                        "name": "Lubenia",
                        "latitude": "49.93078000",
                        "longitude": "21.92665000"
                    },
                    {
                        "id": 86969,
                        "name": "Lutoryż",
                        "latitude": "49.96712000",
                        "longitude": "21.91240000"
                    },
                    {
                        "id": 86970,
                        "name": "Lutowiska",
                        "latitude": "49.25318000",
                        "longitude": "22.69252000"
                    },
                    {
                        "id": 88777,
                        "name": "Łańcut",
                        "latitude": "50.06871000",
                        "longitude": "22.22912000"
                    },
                    {
                        "id": 88822,
                        "name": "Łęki",
                        "latitude": "49.80996000",
                        "longitude": "21.66023000"
                    },
                    {
                        "id": 88823,
                        "name": "Łęki Dolne",
                        "latitude": "49.97386000",
                        "longitude": "21.24739000"
                    },
                    {
                        "id": 88824,
                        "name": "Łęki Górne",
                        "latitude": "49.97386000",
                        "longitude": "21.17426000"
                    },
                    {
                        "id": 88827,
                        "name": "Łętownia",
                        "latitude": "50.32481000",
                        "longitude": "22.23401000"
                    },
                    {
                        "id": 88789,
                        "name": "Łopuszka Wielka",
                        "latitude": "49.93454000",
                        "longitude": "22.39305000"
                    },
                    {
                        "id": 86981,
                        "name": "Majdan Królewski",
                        "latitude": "50.37935000",
                        "longitude": "21.74615000"
                    },
                    {
                        "id": 86989,
                        "name": "Manasterz",
                        "latitude": "49.93520000",
                        "longitude": "22.34602000"
                    },
                    {
                        "id": 86995,
                        "name": "Markowa",
                        "latitude": "50.02633000",
                        "longitude": "22.33160000"
                    },
                    {
                        "id": 87013,
                        "name": "Medyka",
                        "latitude": "49.80526000",
                        "longitude": "22.92229000"
                    },
                    {
                        "id": 87033,
                        "name": "Miejsce Piastowe",
                        "latitude": "49.63440000",
                        "longitude": "21.78735000"
                    },
                    {
                        "id": 87035,
                        "name": "Mielec",
                        "latitude": "50.28709000",
                        "longitude": "21.42390000"
                    },
                    {
                        "id": 87054,
                        "name": "Mirocin",
                        "latitude": "50.04237000",
                        "longitude": "22.55596000"
                    },
                    {
                        "id": 87139,
                        "name": "Narol",
                        "latitude": "50.34925000",
                        "longitude": "23.32679000"
                    },
                    {
                        "id": 87147,
                        "name": "Niebieszczany",
                        "latitude": "49.50348000",
                        "longitude": "22.15651000"
                    },
                    {
                        "id": 87148,
                        "name": "Niebocko",
                        "latitude": "49.67774000",
                        "longitude": "22.10484000"
                    },
                    {
                        "id": 87150,
                        "name": "Niebylec",
                        "latitude": "49.85669000",
                        "longitude": "21.90348000"
                    },
                    {
                        "id": 87152,
                        "name": "Niechobrz",
                        "latitude": "49.99472000",
                        "longitude": "21.87824000"
                    },
                    {
                        "id": 87158,
                        "name": "Niedźwiada",
                        "latitude": "49.98937000",
                        "longitude": "21.52162000"
                    },
                    {
                        "id": 87165,
                        "name": "Nienadowa",
                        "latitude": "49.82901000",
                        "longitude": "22.42704000"
                    },
                    {
                        "id": 87169,
                        "name": "Nisko",
                        "latitude": "50.51987000",
                        "longitude": "22.13968000"
                    },
                    {
                        "id": 87170,
                        "name": "Niwiska",
                        "latitude": "50.22492000",
                        "longitude": "21.63036000"
                    },
                    {
                        "id": 87171,
                        "name": "Nowa Dęba",
                        "latitude": "50.42974000",
                        "longitude": "21.75078000"
                    },
                    {
                        "id": 87174,
                        "name": "Nowa Sarzyna",
                        "latitude": "50.32086000",
                        "longitude": "22.34456000"
                    },
                    {
                        "id": 87190,
                        "name": "Nowe Sioło",
                        "latitude": "50.23194000",
                        "longitude": "23.15884000"
                    },
                    {
                        "id": 87199,
                        "name": "Nowosielce",
                        "latitude": "50.05747000",
                        "longitude": "22.41056000"
                    },
                    {
                        "id": 87200,
                        "name": "Nowosielce-Gniewosz",
                        "latitude": "49.56842000",
                        "longitude": "22.06947000"
                    },
                    {
                        "id": 87210,
                        "name": "Nowy Żmigród",
                        "latitude": "49.60353000",
                        "longitude": "21.52376000"
                    },
                    {
                        "id": 87211,
                        "name": "Nozdrzec",
                        "latitude": "49.77323000",
                        "longitude": "22.19865000"
                    },
                    {
                        "id": 87229,
                        "name": "Odrzykoń",
                        "latitude": "49.74057000",
                        "longitude": "21.74074000"
                    },
                    {
                        "id": 87239,
                        "name": "Oleszyce",
                        "latitude": "50.16750000",
                        "longitude": "23.03481000"
                    },
                    {
                        "id": 87244,
                        "name": "Olszanica",
                        "latitude": "49.47741000",
                        "longitude": "22.44382000"
                    },
                    {
                        "id": 87275,
                        "name": "Orły",
                        "latitude": "49.87107000",
                        "longitude": "22.80298000"
                    },
                    {
                        "id": 87272,
                        "name": "Orzechówka",
                        "latitude": "49.73080000",
                        "longitude": "21.94519000"
                    },
                    {
                        "id": 87288,
                        "name": "Osiek Jasielski",
                        "latitude": "49.63784000",
                        "longitude": "21.48840000"
                    },
                    {
                        "id": 87308,
                        "name": "Ostrów",
                        "latitude": "49.96812000",
                        "longitude": "22.78710000"
                    },
                    {
                        "id": 87334,
                        "name": "Padew Narodowa",
                        "latitude": "50.43947000",
                        "longitude": "21.50059000"
                    },
                    {
                        "id": 87343,
                        "name": "Pantalowice",
                        "latitude": "49.95210000",
                        "longitude": "22.43563000"
                    },
                    {
                        "id": 87356,
                        "name": "Pawłosiów",
                        "latitude": "49.99533000",
                        "longitude": "22.64763000"
                    },
                    {
                        "id": 87391,
                        "name": "Pilzno",
                        "latitude": "49.97883000",
                        "longitude": "21.29228000"
                    },
                    {
                        "id": 87397,
                        "name": "Piskorowice",
                        "latitude": "50.23579000",
                        "longitude": "22.52867000"
                    },
                    {
                        "id": 87433,
                        "name": "Polańczyk",
                        "latitude": "49.36969000",
                        "longitude": "22.42112000"
                    },
                    {
                        "id": 87778,
                        "name": "Połomia",
                        "latitude": "49.90475000",
                        "longitude": "21.89198000"
                    },
                    {
                        "id": 87444,
                        "name": "Poraż",
                        "latitude": "49.48597000",
                        "longitude": "22.22500000"
                    },
                    {
                        "id": 87468,
                        "name": "Powiat bieszczadzki",
                        "latitude": "49.33681000",
                        "longitude": "22.64451000"
                    },
                    {
                        "id": 87477,
                        "name": "Powiat brzozowski",
                        "latitude": "49.72759000",
                        "longitude": "22.09039000"
                    },
                    {
                        "id": 87497,
                        "name": "Powiat dębicki",
                        "latitude": "49.99923000",
                        "longitude": "21.35398000"
                    },
                    {
                        "id": 87528,
                        "name": "Powiat jarosławski",
                        "latitude": "50.02516000",
                        "longitude": "22.78238000"
                    },
                    {
                        "id": 87529,
                        "name": "Powiat jasielski",
                        "latitude": "49.64263000",
                        "longitude": "21.44637000"
                    },
                    {
                        "id": 87540,
                        "name": "Powiat kolbuszowski",
                        "latitude": "50.31632000",
                        "longitude": "21.81315000"
                    },
                    {
                        "id": 87555,
                        "name": "Powiat krośnieński",
                        "latitude": "49.59959000",
                        "longitude": "21.76943000"
                    },
                    {
                        "id": 87566,
                        "name": "Powiat leski",
                        "latitude": "49.31970000",
                        "longitude": "22.36907000"
                    },
                    {
                        "id": 87568,
                        "name": "Powiat leżajski",
                        "latitude": "50.26159000",
                        "longitude": "22.43828000"
                    },
                    {
                        "id": 87573,
                        "name": "Powiat lubaczowski",
                        "latitude": "50.19585000",
                        "longitude": "23.17328000"
                    },
                    {
                        "id": 87748,
                        "name": "Powiat łańcucki",
                        "latitude": "50.08659000",
                        "longitude": "22.26892000"
                    },
                    {
                        "id": 87584,
                        "name": "Powiat mielecki",
                        "latitude": "50.31387000",
                        "longitude": "21.39136000"
                    },
                    {
                        "id": 87600,
                        "name": "Powiat niżański",
                        "latitude": "50.46411000",
                        "longitude": "22.27645000"
                    },
                    {
                        "id": 87645,
                        "name": "Powiat przemyski",
                        "latitude": "49.76060000",
                        "longitude": "22.67372000"
                    },
                    {
                        "id": 87646,
                        "name": "Powiat przeworski",
                        "latitude": "50.08913000",
                        "longitude": "22.53682000"
                    },
                    {
                        "id": 87662,
                        "name": "Powiat ropczycko-sędziszowski",
                        "latitude": "50.04815000",
                        "longitude": "21.64385000"
                    },
                    {
                        "id": 87666,
                        "name": "Powiat rzeszowski",
                        "latitude": "50.09944000",
                        "longitude": "21.95892000"
                    },
                    {
                        "id": 87668,
                        "name": "Powiat sanocki",
                        "latitude": "49.43001000",
                        "longitude": "22.13619000"
                    },
                    {
                        "id": 87679,
                        "name": "Powiat stalowowolski",
                        "latitude": "50.59103000",
                        "longitude": "22.05203000"
                    },
                    {
                        "id": 87687,
                        "name": "Powiat strzyżowski",
                        "latitude": "49.87698000",
                        "longitude": "21.74949000"
                    },
                    {
                        "id": 87701,
                        "name": "Powiat tarnobrzeski",
                        "latitude": "50.52303000",
                        "longitude": "21.71585000"
                    },
                    {
                        "id": 87794,
                        "name": "Pruchnik",
                        "latitude": "49.90620000",
                        "longitude": "22.51554000"
                    },
                    {
                        "id": 87804,
                        "name": "Przecław",
                        "latitude": "50.19339000",
                        "longitude": "21.48007000"
                    },
                    {
                        "id": 87808,
                        "name": "Przedmieście Dubieckie",
                        "latitude": "49.83710000",
                        "longitude": "22.37177000"
                    },
                    {
                        "id": 87836,
                        "name": "Przędzel",
                        "latitude": "50.49465000",
                        "longitude": "22.21925000"
                    },
                    {
                        "id": 87812,
                        "name": "Przemyśl",
                        "latitude": "49.78498000",
                        "longitude": "22.76728000"
                    },
                    {
                        "id": 87816,
                        "name": "Przeworsk",
                        "latitude": "50.05912000",
                        "longitude": "22.49408000"
                    },
                    {
                        "id": 87823,
                        "name": "Przybyszówka",
                        "latitude": "50.04788000",
                        "longitude": "21.92579000"
                    },
                    {
                        "id": 87857,
                        "name": "Pysznica",
                        "latitude": "50.56999000",
                        "longitude": "22.12913000"
                    },
                    {
                        "id": 87876,
                        "name": "Racławice",
                        "latitude": "50.51370000",
                        "longitude": "22.16552000"
                    },
                    {
                        "id": 87887,
                        "name": "Radomyśl",
                        "latitude": "50.68101000",
                        "longitude": "21.94365000"
                    },
                    {
                        "id": 87888,
                        "name": "Radomyśl Wielki",
                        "latitude": "50.19693000",
                        "longitude": "21.27693000"
                    },
                    {
                        "id": 87893,
                        "name": "Radymno",
                        "latitude": "49.94720000",
                        "longitude": "22.82375000"
                    },
                    {
                        "id": 87910,
                        "name": "Rakszawa",
                        "latitude": "50.16051000",
                        "longitude": "22.23907000"
                    },
                    {
                        "id": 87912,
                        "name": "Raniżów",
                        "latitude": "50.25873000",
                        "longitude": "21.97137000"
                    },
                    {
                        "id": 87950,
                        "name": "Rogóźno",
                        "latitude": "50.07367000",
                        "longitude": "22.37486000"
                    },
                    {
                        "id": 87956,
                        "name": "Rokietnica",
                        "latitude": "49.89983000",
                        "longitude": "22.64171000"
                    },
                    {
                        "id": 87961,
                        "name": "Ropczyce",
                        "latitude": "50.05229000",
                        "longitude": "21.60891000"
                    },
                    {
                        "id": 87963,
                        "name": "Rozbórz",
                        "latitude": "50.05615000",
                        "longitude": "22.54686000"
                    },
                    {
                        "id": 87976,
                        "name": "Rudna Mała",
                        "latitude": "50.09889000",
                        "longitude": "21.96021000"
                    },
                    {
                        "id": 87977,
                        "name": "Rudna Wielka",
                        "latitude": "50.08799000",
                        "longitude": "21.94759000"
                    },
                    {
                        "id": 87981,
                        "name": "Rudnik nad Sanem",
                        "latitude": "50.44152000",
                        "longitude": "22.24856000"
                    },
                    {
                        "id": 88009,
                        "name": "Rymanów",
                        "latitude": "49.57649000",
                        "longitude": "21.86811000"
                    },
                    {
                        "id": 88020,
                        "name": "Rzepedź",
                        "latitude": "49.36997000",
                        "longitude": "22.11174000"
                    },
                    {
                        "id": 88024,
                        "name": "Rzeszów",
                        "latitude": "50.00545000",
                        "longitude": "21.98848000"
                    },
                    {
                        "id": 88049,
                        "name": "Sanok",
                        "latitude": "49.55573000",
                        "longitude": "22.20560000"
                    },
                    {
                        "id": 88329,
                        "name": "Sędziszów Małopolski",
                        "latitude": "50.07069000",
                        "longitude": "21.70062000"
                    },
                    {
                        "id": 88066,
                        "name": "Siedleczka",
                        "latitude": "49.96061000",
                        "longitude": "22.37949000"
                    },
                    {
                        "id": 88068,
                        "name": "Siedliska",
                        "latitude": "49.95409000",
                        "longitude": "21.94742000"
                    },
                    {
                        "id": 88077,
                        "name": "Sieniawa",
                        "latitude": "50.17790000",
                        "longitude": "22.60954000"
                    },
                    {
                        "id": 88092,
                        "name": "Sietesz",
                        "latitude": "49.98622000",
                        "longitude": "22.34671000"
                    },
                    {
                        "id": 88114,
                        "name": "Skołyszyn",
                        "latitude": "49.74955000",
                        "longitude": "21.33665000"
                    },
                    {
                        "id": 88343,
                        "name": "Słotowa",
                        "latitude": "49.94603000",
                        "longitude": "21.29425000"
                    },
                    {
                        "id": 88136,
                        "name": "Sokolniki",
                        "latitude": "50.63803000",
                        "longitude": "21.80649000"
                    },
                    {
                        "id": 88139,
                        "name": "Sokołów Małopolski",
                        "latitude": "50.22909000",
                        "longitude": "22.11968000"
                    },
                    {
                        "id": 88147,
                        "name": "Sonina",
                        "latitude": "50.06089000",
                        "longitude": "22.26551000"
                    },
                    {
                        "id": 88157,
                        "name": "Sośnica",
                        "latitude": "49.90083000",
                        "longitude": "22.87469000"
                    },
                    {
                        "id": 88165,
                        "name": "Stalowa Wola",
                        "latitude": "50.58286000",
                        "longitude": "22.05334000"
                    },
                    {
                        "id": 88178,
                        "name": "Stara Wieś",
                        "latitude": "49.71505000",
                        "longitude": "22.00441000"
                    },
                    {
                        "id": 88186,
                        "name": "Stare Miasto",
                        "latitude": "50.28879000",
                        "longitude": "22.42928000"
                    },
                    {
                        "id": 88210,
                        "name": "Strachocina",
                        "latitude": "49.60815000",
                        "longitude": "22.08836000"
                    },
                    {
                        "id": 88212,
                        "name": "Straszydle",
                        "latitude": "49.90038000",
                        "longitude": "21.98124000"
                    },
                    {
                        "id": 88236,
                        "name": "Strzyżów",
                        "latitude": "49.87074000",
                        "longitude": "21.79413000"
                    },
                    {
                        "id": 88238,
                        "name": "Stubno",
                        "latitude": "49.89806000",
                        "longitude": "22.95602000"
                    },
                    {
                        "id": 88859,
                        "name": "Świlcza",
                        "latitude": "50.07179000",
                        "longitude": "21.89798000"
                    },
                    {
                        "id": 88359,
                        "name": "Tarnobrzeg",
                        "latitude": "50.57304000",
                        "longitude": "21.67937000"
                    },
                    {
                        "id": 88362,
                        "name": "Tarnowiec",
                        "latitude": "49.73108000",
                        "longitude": "21.57663000"
                    },
                    {
                        "id": 88393,
                        "name": "Tryńcza",
                        "latitude": "50.16087000",
                        "longitude": "22.55008000"
                    },
                    {
                        "id": 88394,
                        "name": "Trzciana",
                        "latitude": "50.07190000",
                        "longitude": "21.83850000"
                    },
                    {
                        "id": 88398,
                        "name": "Trzcinica",
                        "latitude": "49.74301000",
                        "longitude": "21.41750000"
                    },
                    {
                        "id": 88409,
                        "name": "Trzebownisko",
                        "latitude": "50.07829000",
                        "longitude": "22.03712000"
                    },
                    {
                        "id": 88428,
                        "name": "Turze Pole",
                        "latitude": "49.66329000",
                        "longitude": "22.00476000"
                    },
                    {
                        "id": 88437,
                        "name": "Tyczyn",
                        "latitude": "49.96384000",
                        "longitude": "22.03398000"
                    },
                    {
                        "id": 88442,
                        "name": "Tyrawa Wołoska",
                        "latitude": "49.57744000",
                        "longitude": "22.36988000"
                    },
                    {
                        "id": 88448,
                        "name": "Uherce Mineralne",
                        "latitude": "49.46455000",
                        "longitude": "22.39829000"
                    },
                    {
                        "id": 88453,
                        "name": "Ulanów",
                        "latitude": "50.49031000",
                        "longitude": "22.26362000"
                    },
                    {
                        "id": 88460,
                        "name": "Urzejowice",
                        "latitude": "50.01182000",
                        "longitude": "22.46189000"
                    },
                    {
                        "id": 88465,
                        "name": "Ustrzyki Dolne",
                        "latitude": "49.43040000",
                        "longitude": "22.59381000"
                    },
                    {
                        "id": 88470,
                        "name": "Wadowice Górne",
                        "latitude": "50.26312000",
                        "longitude": "21.30215000"
                    },
                    {
                        "id": 88492,
                        "name": "Wesoła",
                        "latitude": "49.79977000",
                        "longitude": "22.10029000"
                    },
                    {
                        "id": 88555,
                        "name": "Wiązownica",
                        "latitude": "50.08066000",
                        "longitude": "22.70668000"
                    },
                    {
                        "id": 88508,
                        "name": "Wielkie Oczy",
                        "latitude": "50.02357000",
                        "longitude": "23.16407000"
                    },
                    {
                        "id": 88509,
                        "name": "Wielopole Skrzyńskie",
                        "latitude": "49.94564000",
                        "longitude": "21.61491000"
                    },
                    {
                        "id": 88516,
                        "name": "Wierzawice",
                        "latitude": "50.23623000",
                        "longitude": "22.45090000"
                    },
                    {
                        "id": 88519,
                        "name": "Wierzbna",
                        "latitude": "50.03311000",
                        "longitude": "22.60128000"
                    },
                    {
                        "id": 88564,
                        "name": "Wiśniowa",
                        "latitude": "49.86897000",
                        "longitude": "21.65508000"
                    },
                    {
                        "id": 88571,
                        "name": "Wojaszówka",
                        "latitude": "49.77777000",
                        "longitude": "21.67079000"
                    },
                    {
                        "id": 88592,
                        "name": "Wola Żarczycka",
                        "latitude": "50.29120000",
                        "longitude": "22.25023000"
                    },
                    {
                        "id": 88627,
                        "name": "Wólka Niedźwiedzka",
                        "latitude": "50.24226000",
                        "longitude": "22.18826000"
                    },
                    {
                        "id": 88628,
                        "name": "Wólka Pełkińska",
                        "latitude": "50.09553000",
                        "longitude": "22.62342000"
                    },
                    {
                        "id": 88629,
                        "name": "Wólka Podleśna",
                        "latitude": "50.11785000",
                        "longitude": "22.11213000"
                    },
                    {
                        "id": 88630,
                        "name": "Wólka Tanewska",
                        "latitude": "50.50005000",
                        "longitude": "22.26113000"
                    },
                    {
                        "id": 88615,
                        "name": "Wysoka",
                        "latitude": "50.04474000",
                        "longitude": "22.26002000"
                    },
                    {
                        "id": 88619,
                        "name": "Wysoka Głogowska",
                        "latitude": "50.16019000",
                        "longitude": "22.02124000"
                    },
                    {
                        "id": 88620,
                        "name": "Wysoka Strzyżowska",
                        "latitude": "49.83056000",
                        "longitude": "21.74074000"
                    },
                    {
                        "id": 88669,
                        "name": "Zagórz",
                        "latitude": "49.51457000",
                        "longitude": "22.26706000"
                    },
                    {
                        "id": 88671,
                        "name": "Zagórzyce",
                        "latitude": "50.01690000",
                        "longitude": "21.67517000"
                    },
                    {
                        "id": 88674,
                        "name": "Zaklików",
                        "latitude": "50.75769000",
                        "longitude": "22.10226000"
                    },
                    {
                        "id": 88684,
                        "name": "Zalesie",
                        "latitude": "50.01226000",
                        "longitude": "22.53262000"
                    },
                    {
                        "id": 88687,
                        "name": "Zaleszany",
                        "latitude": "50.64799000",
                        "longitude": "21.89069000"
                    },
                    {
                        "id": 88695,
                        "name": "Zarszyn",
                        "latitude": "49.58178000",
                        "longitude": "22.01283000"
                    },
                    {
                        "id": 88696,
                        "name": "Zarzecze",
                        "latitude": "50.52767000",
                        "longitude": "22.19522000"
                    },
                    {
                        "id": 88718,
                        "name": "Zdziechowice Drugie",
                        "latitude": "50.78478000",
                        "longitude": "22.10999000"
                    },
                    {
                        "id": 88727,
                        "name": "Zgłobień",
                        "latitude": "50.01270000",
                        "longitude": "21.85490000"
                    },
                    {
                        "id": 88732,
                        "name": "Zmiennica",
                        "latitude": "49.67652000",
                        "longitude": "21.96596000"
                    },
                    {
                        "id": 88891,
                        "name": "Żołynia",
                        "latitude": "50.16200000",
                        "longitude": "22.30825000"
                    },
                    {
                        "id": 88893,
                        "name": "Żurawica",
                        "latitude": "49.82348000",
                        "longitude": "22.78925000"
                    },
                    {
                        "id": 88894,
                        "name": "Żurawiczki",
                        "latitude": "50.01370000",
                        "longitude": "22.49949000"
                    },
                    {
                        "id": 88898,
                        "name": "Żyraków",
                        "latitude": "50.08545000",
                        "longitude": "21.39622000"
                    }
                ]
            },
            {
                "id": 1622,
                "name": "Upper Silesia",
                "iso2": "16",
                "latitude": "50.80037610",
                "longitude": "17.93798900",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85792,
                        "name": "Baborów",
                        "latitude": "50.15760000",
                        "longitude": "17.98513000"
                    },
                    {
                        "id": 85833,
                        "name": "Biała",
                        "latitude": "50.38587000",
                        "longitude": "17.66035000"
                    },
                    {
                        "id": 85864,
                        "name": "Bierawa",
                        "latitude": "50.28111000",
                        "longitude": "18.24177000"
                    },
                    {
                        "id": 85865,
                        "name": "Bierdzany",
                        "latitude": "50.81852000",
                        "longitude": "18.15808000"
                    },
                    {
                        "id": 85935,
                        "name": "Branice",
                        "latitude": "50.05108000",
                        "longitude": "17.79399000"
                    },
                    {
                        "id": 85958,
                        "name": "Brzeg",
                        "latitude": "50.86079000",
                        "longitude": "17.46740000"
                    },
                    {
                        "id": 85998,
                        "name": "Byczyna",
                        "latitude": "51.11387000",
                        "longitude": "18.21413000"
                    },
                    {
                        "id": 86037,
                        "name": "Chmielowice",
                        "latitude": "50.64957000",
                        "longitude": "17.86669000"
                    },
                    {
                        "id": 86065,
                        "name": "Chróścice",
                        "latitude": "50.78076000",
                        "longitude": "17.81227000"
                    },
                    {
                        "id": 86059,
                        "name": "Chrościna",
                        "latitude": "50.66578000",
                        "longitude": "17.81759000"
                    },
                    {
                        "id": 86064,
                        "name": "Chrząstowice",
                        "latitude": "50.66622000",
                        "longitude": "18.07294000"
                    },
                    {
                        "id": 86089,
                        "name": "Cisek",
                        "latitude": "50.28232000",
                        "longitude": "18.19988000"
                    },
                    {
                        "id": 86115,
                        "name": "Czarnowąsy",
                        "latitude": "50.72858000",
                        "longitude": "17.89819000"
                    },
                    {
                        "id": 86236,
                        "name": "Dąbrowa",
                        "latitude": "50.68352000",
                        "longitude": "17.74957000"
                    },
                    {
                        "id": 86153,
                        "name": "Dalachów",
                        "latitude": "51.07732000",
                        "longitude": "18.57840000"
                    },
                    {
                        "id": 86259,
                        "name": "Długomiłowice",
                        "latitude": "50.28298000",
                        "longitude": "18.14873000"
                    },
                    {
                        "id": 86173,
                        "name": "Dobrodzień",
                        "latitude": "50.72874000",
                        "longitude": "18.44501000"
                    },
                    {
                        "id": 86177,
                        "name": "Dobrzeń Wielki",
                        "latitude": "50.76844000",
                        "longitude": "17.84652000"
                    },
                    {
                        "id": 86187,
                        "name": "Domaszowice",
                        "latitude": "51.04290000",
                        "longitude": "17.88875000"
                    },
                    {
                        "id": 86221,
                        "name": "Dziergowice",
                        "latitude": "50.24248000",
                        "longitude": "18.28606000"
                    },
                    {
                        "id": 86429,
                        "name": "Głogówek",
                        "latitude": "50.35355000",
                        "longitude": "17.86405000"
                    },
                    {
                        "id": 86431,
                        "name": "Głubczyce",
                        "latitude": "50.20086000",
                        "longitude": "17.82858000"
                    },
                    {
                        "id": 86432,
                        "name": "Głuchołazy",
                        "latitude": "50.31505000",
                        "longitude": "17.38355000"
                    },
                    {
                        "id": 86323,
                        "name": "Gogolin",
                        "latitude": "50.49222000",
                        "longitude": "18.01994000"
                    },
                    {
                        "id": 86412,
                        "name": "Górażdże",
                        "latitude": "50.52903000",
                        "longitude": "18.01003000"
                    },
                    {
                        "id": 86343,
                        "name": "Gorzów Śląski",
                        "latitude": "51.02871000",
                        "longitude": "18.42304000"
                    },
                    {
                        "id": 86373,
                        "name": "Grodków",
                        "latitude": "50.69836000",
                        "longitude": "17.38449000"
                    },
                    {
                        "id": 86470,
                        "name": "Izbicko",
                        "latitude": "50.57163000",
                        "longitude": "18.15585000"
                    },
                    {
                        "id": 86502,
                        "name": "Januszkowice",
                        "latitude": "50.39189000",
                        "longitude": "18.13680000"
                    },
                    {
                        "id": 86552,
                        "name": "Jemielnica",
                        "latitude": "50.54573000",
                        "longitude": "18.37807000"
                    },
                    {
                        "id": 86591,
                        "name": "Kamienica",
                        "latitude": "50.45007000",
                        "longitude": "16.95396000"
                    },
                    {
                        "id": 86597,
                        "name": "Kamiennik",
                        "latitude": "50.57032000",
                        "longitude": "17.14979000"
                    },
                    {
                        "id": 86853,
                        "name": "Kędzierzyn-Koźle",
                        "latitude": "50.34984000",
                        "longitude": "18.22606000"
                    },
                    {
                        "id": 86635,
                        "name": "Kietrz",
                        "latitude": "50.08042000",
                        "longitude": "18.00432000"
                    },
                    {
                        "id": 86653,
                        "name": "Kluczbork",
                        "latitude": "50.97281000",
                        "longitude": "18.21816000"
                    },
                    {
                        "id": 86680,
                        "name": "Kolonowskie",
                        "latitude": "50.65338000",
                        "longitude": "18.38493000"
                    },
                    {
                        "id": 86688,
                        "name": "Komprachcice",
                        "latitude": "50.63678000",
                        "longitude": "17.82635000"
                    },
                    {
                        "id": 86703,
                        "name": "Korfantów",
                        "latitude": "50.48894000",
                        "longitude": "17.59898000"
                    },
                    {
                        "id": 86757,
                        "name": "Koźle",
                        "latitude": "50.33560000",
                        "longitude": "18.14332000"
                    },
                    {
                        "id": 86766,
                        "name": "Krapkowice",
                        "latitude": "50.47515000",
                        "longitude": "17.96539000"
                    },
                    {
                        "id": 86840,
                        "name": "Kup",
                        "latitude": "50.80659000",
                        "longitude": "17.88351000"
                    },
                    {
                        "id": 86892,
                        "name": "Leśnica",
                        "latitude": "50.43083000",
                        "longitude": "18.18684000"
                    },
                    {
                        "id": 86885,
                        "name": "Lewin Brzeski",
                        "latitude": "50.74870000",
                        "longitude": "17.61688000"
                    },
                    {
                        "id": 86959,
                        "name": "Lubrza",
                        "latitude": "50.33631000",
                        "longitude": "17.62636000"
                    },
                    {
                        "id": 86961,
                        "name": "Lubsza",
                        "latitude": "50.91591000",
                        "longitude": "17.52173000"
                    },
                    {
                        "id": 88815,
                        "name": "Łąka Prudnicka",
                        "latitude": "50.31061000",
                        "longitude": "17.52809000"
                    },
                    {
                        "id": 88763,
                        "name": "Łambinowice",
                        "latitude": "50.53869000",
                        "longitude": "17.56096000"
                    },
                    {
                        "id": 88793,
                        "name": "Łosiów",
                        "latitude": "50.79096000",
                        "longitude": "17.56594000"
                    },
                    {
                        "id": 88797,
                        "name": "Łubniany",
                        "latitude": "50.78597000",
                        "longitude": "18.00110000"
                    },
                    {
                        "id": 87097,
                        "name": "Moszczanka",
                        "latitude": "50.30020000",
                        "longitude": "17.49109000"
                    },
                    {
                        "id": 87114,
                        "name": "Murów",
                        "latitude": "50.86307000",
                        "longitude": "17.94557000"
                    },
                    {
                        "id": 87134,
                        "name": "Nakło",
                        "latitude": "50.57975000",
                        "longitude": "18.11817000"
                    },
                    {
                        "id": 87136,
                        "name": "Namysłów",
                        "latitude": "51.07592000",
                        "longitude": "17.72284000"
                    },
                    {
                        "id": 87164,
                        "name": "Niemodlin",
                        "latitude": "50.64200000",
                        "longitude": "17.61932000"
                    },
                    {
                        "id": 87214,
                        "name": "Nysa",
                        "latitude": "50.47379000",
                        "longitude": "17.33437000"
                    },
                    {
                        "id": 87238,
                        "name": "Olesno",
                        "latitude": "50.87698000",
                        "longitude": "18.42094000"
                    },
                    {
                        "id": 87246,
                        "name": "Olszanka",
                        "latitude": "50.79514000",
                        "longitude": "17.47890000"
                    },
                    {
                        "id": 87262,
                        "name": "Opole",
                        "latitude": "50.67211000",
                        "longitude": "17.92533000"
                    },
                    {
                        "id": 87315,
                        "name": "Otmuchów",
                        "latitude": "50.46627000",
                        "longitude": "17.17348000"
                    },
                    {
                        "id": 87320,
                        "name": "Ozimek",
                        "latitude": "50.67944000",
                        "longitude": "18.21370000"
                    },
                    {
                        "id": 87333,
                        "name": "Paczków",
                        "latitude": "50.46395000",
                        "longitude": "17.00658000"
                    },
                    {
                        "id": 87337,
                        "name": "Pakosławice",
                        "latitude": "50.54474000",
                        "longitude": "17.36578000"
                    },
                    {
                        "id": 87359,
                        "name": "Pawłowiczki",
                        "latitude": "50.24660000",
                        "longitude": "18.04865000"
                    },
                    {
                        "id": 87429,
                        "name": "Pokój",
                        "latitude": "50.90265000",
                        "longitude": "17.83751000"
                    },
                    {
                        "id": 87437,
                        "name": "Polska Cerekiew",
                        "latitude": "50.22827000",
                        "longitude": "18.12675000"
                    },
                    {
                        "id": 87442,
                        "name": "Popielów",
                        "latitude": "50.82632000",
                        "longitude": "17.74378000"
                    },
                    {
                        "id": 87475,
                        "name": "Powiat brzeski",
                        "latitude": "50.78930000",
                        "longitude": "17.48499000"
                    },
                    {
                        "id": 87521,
                        "name": "Powiat głubczycki",
                        "latitude": "50.14846000",
                        "longitude": "17.83266000"
                    },
                    {
                        "id": 87559,
                        "name": "Powiat kędzierzyńsko-kozielski",
                        "latitude": "50.29384000",
                        "longitude": "18.16961000"
                    },
                    {
                        "id": 87539,
                        "name": "Powiat kluczborski",
                        "latitude": "50.98576000",
                        "longitude": "18.15258000"
                    },
                    {
                        "id": 87551,
                        "name": "Powiat krapkowicki",
                        "latitude": "50.45263000",
                        "longitude": "17.95768000"
                    },
                    {
                        "id": 87598,
                        "name": "Powiat namysłowski",
                        "latitude": "51.01628000",
                        "longitude": "17.76304000"
                    },
                    {
                        "id": 87608,
                        "name": "Powiat nyski",
                        "latitude": "50.46054000",
                        "longitude": "17.33546000"
                    },
                    {
                        "id": 87611,
                        "name": "Powiat oleski",
                        "latitude": "50.87887000",
                        "longitude": "18.46037000"
                    },
                    {
                        "id": 87618,
                        "name": "Powiat opolski",
                        "latitude": "50.73689000",
                        "longitude": "17.98462000"
                    },
                    {
                        "id": 87642,
                        "name": "Powiat prudnicki",
                        "latitude": "50.40981000",
                        "longitude": "17.73995000"
                    },
                    {
                        "id": 87684,
                        "name": "Powiat strzelecki",
                        "latitude": "50.53057000",
                        "longitude": "18.34597000"
                    },
                    {
                        "id": 87787,
                        "name": "Praszka",
                        "latitude": "51.05375000",
                        "longitude": "18.45317000"
                    },
                    {
                        "id": 87837,
                        "name": "Prószków",
                        "latitude": "50.57670000",
                        "longitude": "17.87143000"
                    },
                    {
                        "id": 87795,
                        "name": "Prudnik",
                        "latitude": "50.32124000",
                        "longitude": "17.57461000"
                    },
                    {
                        "id": 87878,
                        "name": "Racławice Śląskie",
                        "latitude": "50.31204000",
                        "longitude": "17.77528000"
                    },
                    {
                        "id": 87915,
                        "name": "Raszowa",
                        "latitude": "50.39779000",
                        "longitude": "18.17722000"
                    },
                    {
                        "id": 87941,
                        "name": "Reńska Wieś",
                        "latitude": "50.31587000",
                        "longitude": "18.12607000"
                    },
                    {
                        "id": 87967,
                        "name": "Rozwadza",
                        "latitude": "50.43493000",
                        "longitude": "18.09980000"
                    },
                    {
                        "id": 88062,
                        "name": "Sidzina",
                        "latitude": "50.57375000",
                        "longitude": "17.44904000"
                    },
                    {
                        "id": 88097,
                        "name": "Skarbimierz Osiedle",
                        "latitude": "50.84584000",
                        "longitude": "17.41865000"
                    },
                    {
                        "id": 88112,
                        "name": "Skorogoszcz",
                        "latitude": "50.75916000",
                        "longitude": "17.68198000"
                    },
                    {
                        "id": 88113,
                        "name": "Skoroszyce",
                        "latitude": "50.59648000",
                        "longitude": "17.38243000"
                    },
                    {
                        "id": 88336,
                        "name": "Sławięcice",
                        "latitude": "50.37207000",
                        "longitude": "18.32176000"
                    },
                    {
                        "id": 88228,
                        "name": "Strzelce Opolskie",
                        "latitude": "50.51070000",
                        "longitude": "18.30056000"
                    },
                    {
                        "id": 88230,
                        "name": "Strzeleczki",
                        "latitude": "50.46215000",
                        "longitude": "17.85665000"
                    },
                    {
                        "id": 88853,
                        "name": "Świerczów",
                        "latitude": "50.96016000",
                        "longitude": "17.75880000"
                    },
                    {
                        "id": 88366,
                        "name": "Tarnów Opolski",
                        "latitude": "50.57631000",
                        "longitude": "18.08367000"
                    },
                    {
                        "id": 88430,
                        "name": "Tułowice",
                        "latitude": "50.59577000",
                        "longitude": "17.65323000"
                    },
                    {
                        "id": 88431,
                        "name": "Twardawa",
                        "latitude": "50.34349000",
                        "longitude": "17.99097000"
                    },
                    {
                        "id": 88450,
                        "name": "Ujazd",
                        "latitude": "50.38938000",
                        "longitude": "18.34929000"
                    },
                    {
                        "id": 88473,
                        "name": "Walce",
                        "latitude": "50.37322000",
                        "longitude": "18.00427000"
                    },
                    {
                        "id": 88643,
                        "name": "Węgry",
                        "latitude": "50.74319000",
                        "longitude": "18.01741000"
                    },
                    {
                        "id": 88558,
                        "name": "Większyce",
                        "latitude": "50.33659000",
                        "longitude": "18.10221000"
                    },
                    {
                        "id": 88542,
                        "name": "Wilków",
                        "latitude": "51.10158000",
                        "longitude": "17.66284000"
                    },
                    {
                        "id": 88598,
                        "name": "Wołczyn",
                        "latitude": "51.01845000",
                        "longitude": "18.04994000"
                    },
                    {
                        "id": 88701,
                        "name": "Zawadzkie",
                        "latitude": "50.60503000",
                        "longitude": "18.48467000"
                    },
                    {
                        "id": 88719,
                        "name": "Zdzieszowice",
                        "latitude": "50.42482000",
                        "longitude": "18.12349000"
                    },
                    {
                        "id": 88740,
                        "name": "Zębowice",
                        "latitude": "50.76290000",
                        "longitude": "18.34434000"
                    }
                ]
            },
            {
                "id": 1628,
                "name": "Warmia-Masuria",
                "iso2": "28",
                "latitude": "53.86711170",
                "longitude": "20.70278610",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85799,
                        "name": "Banie Mazurskie",
                        "latitude": "54.24662000",
                        "longitude": "22.03617000"
                    },
                    {
                        "id": 85807,
                        "name": "Barciany",
                        "latitude": "54.21993000",
                        "longitude": "21.35347000"
                    },
                    {
                        "id": 85809,
                        "name": "Barczewo",
                        "latitude": "53.83055000",
                        "longitude": "20.69112000"
                    },
                    {
                        "id": 85813,
                        "name": "Bartoszyce",
                        "latitude": "54.25354000",
                        "longitude": "20.80819000"
                    },
                    {
                        "id": 85835,
                        "name": "Biała Piska",
                        "latitude": "53.61191000",
                        "longitude": "22.06321000"
                    },
                    {
                        "id": 85874,
                        "name": "Biskupiec",
                        "latitude": "53.86467000",
                        "longitude": "20.95692000"
                    },
                    {
                        "id": 85877,
                        "name": "Bisztynek",
                        "latitude": "54.08633000",
                        "longitude": "20.90192000"
                    },
                    {
                        "id": 85936,
                        "name": "Braniewo",
                        "latitude": "54.37971000",
                        "longitude": "19.81959000"
                    },
                    {
                        "id": 86145,
                        "name": "Czerwonka",
                        "latitude": "53.91627000",
                        "longitude": "20.89685000"
                    },
                    {
                        "id": 86245,
                        "name": "Dąbrówno",
                        "latitude": "53.43408000",
                        "longitude": "20.03529000"
                    },
                    {
                        "id": 86172,
                        "name": "Dobre Miasto",
                        "latitude": "53.98668000",
                        "longitude": "20.39749000"
                    },
                    {
                        "id": 86214,
                        "name": "Dywity",
                        "latitude": "53.83759000",
                        "longitude": "20.47817000"
                    },
                    {
                        "id": 86216,
                        "name": "Działdowo",
                        "latitude": "53.23958000",
                        "longitude": "20.17004000"
                    },
                    {
                        "id": 86263,
                        "name": "Dźwierzuty",
                        "latitude": "53.70494000",
                        "longitude": "20.96037000"
                    },
                    {
                        "id": 86264,
                        "name": "Elbląg",
                        "latitude": "54.15220000",
                        "longitude": "19.40884000"
                    },
                    {
                        "id": 86265,
                        "name": "Ełk",
                        "latitude": "53.82824000",
                        "longitude": "22.36469000"
                    },
                    {
                        "id": 86275,
                        "name": "Frombork",
                        "latitude": "54.35766000",
                        "longitude": "19.68029000"
                    },
                    {
                        "id": 86301,
                        "name": "Gierłoż",
                        "latitude": "54.08134000",
                        "longitude": "21.49551000"
                    },
                    {
                        "id": 86300,
                        "name": "Gierzwałd",
                        "latitude": "53.54128000",
                        "longitude": "20.08867000"
                    },
                    {
                        "id": 86302,
                        "name": "Gietrzwałd",
                        "latitude": "53.74617000",
                        "longitude": "20.23742000"
                    },
                    {
                        "id": 86305,
                        "name": "Giżycko",
                        "latitude": "54.03811000",
                        "longitude": "21.76441000"
                    },
                    {
                        "id": 86355,
                        "name": "Gołdap",
                        "latitude": "54.30631000",
                        "longitude": "22.30362000"
                    },
                    {
                        "id": 86417,
                        "name": "Górowo Iławeckie",
                        "latitude": "54.28559000",
                        "longitude": "20.48886000"
                    },
                    {
                        "id": 86382,
                        "name": "Gronowo Elbląskie",
                        "latitude": "54.08588000",
                        "longitude": "19.30598000"
                    },
                    {
                        "id": 86383,
                        "name": "Gronowo Górne",
                        "latitude": "54.13863000",
                        "longitude": "19.45988000"
                    },
                    {
                        "id": 86472,
                        "name": "Iława",
                        "latitude": "53.59601000",
                        "longitude": "19.56849000"
                    },
                    {
                        "id": 86474,
                        "name": "Iłowo -Osada",
                        "latitude": "53.16808000",
                        "longitude": "20.29295000"
                    },
                    {
                        "id": 86546,
                        "name": "Jedwabno",
                        "latitude": "53.52990000",
                        "longitude": "20.72657000"
                    },
                    {
                        "id": 86556,
                        "name": "Jeziorany",
                        "latitude": "53.97578000",
                        "longitude": "20.74639000"
                    },
                    {
                        "id": 86567,
                        "name": "Jonkowo",
                        "latitude": "53.82817000",
                        "longitude": "20.31054000"
                    },
                    {
                        "id": 86858,
                        "name": "Kętrzyn",
                        "latitude": "54.07676000",
                        "longitude": "21.37527000"
                    },
                    {
                        "id": 86640,
                        "name": "Kisielice",
                        "latitude": "53.60855000",
                        "longitude": "19.26350000"
                    },
                    {
                        "id": 86706,
                        "name": "Korsze",
                        "latitude": "54.17002000",
                        "longitude": "21.13915000"
                    },
                    {
                        "id": 86707,
                        "name": "Kortowo",
                        "latitude": "53.75731000",
                        "longitude": "20.45620000"
                    },
                    {
                        "id": 86728,
                        "name": "Kowale Oleckie",
                        "latitude": "54.16354000",
                        "longitude": "22.41666000"
                    },
                    {
                        "id": 86738,
                        "name": "Kozłowo",
                        "latitude": "53.30652000",
                        "longitude": "20.29098000"
                    },
                    {
                        "id": 86791,
                        "name": "Kruklanki",
                        "latitude": "54.08855000",
                        "longitude": "21.92227000"
                    },
                    {
                        "id": 86842,
                        "name": "Kurzętnik",
                        "latitude": "53.39858000",
                        "longitude": "19.57858000"
                    },
                    {
                        "id": 86879,
                        "name": "Lelkowo",
                        "latitude": "54.32458000",
                        "longitude": "20.22480000"
                    },
                    {
                        "id": 86899,
                        "name": "Lidzbark",
                        "latitude": "53.26283000",
                        "longitude": "19.82663000"
                    },
                    {
                        "id": 86900,
                        "name": "Lidzbark Warmiński",
                        "latitude": "54.12588000",
                        "longitude": "20.57954000"
                    },
                    {
                        "id": 86934,
                        "name": "Lubawa",
                        "latitude": "53.50428000",
                        "longitude": "19.74966000"
                    },
                    {
                        "id": 86954,
                        "name": "Lubomino",
                        "latitude": "54.06684000",
                        "longitude": "20.23956000"
                    },
                    {
                        "id": 87006,
                        "name": "Małdyty",
                        "latitude": "53.91981000",
                        "longitude": "19.74398000"
                    },
                    {
                        "id": 87042,
                        "name": "Mikołajki",
                        "latitude": "53.80288000",
                        "longitude": "21.57011000"
                    },
                    {
                        "id": 87070,
                        "name": "Miłakowo",
                        "latitude": "54.00923000",
                        "longitude": "20.07125000"
                    },
                    {
                        "id": 87072,
                        "name": "Miłomłyn",
                        "latitude": "53.76449000",
                        "longitude": "19.83800000"
                    },
                    {
                        "id": 87129,
                        "name": "Młynary",
                        "latitude": "54.18690000",
                        "longitude": "19.72149000"
                    },
                    {
                        "id": 87093,
                        "name": "Morąg",
                        "latitude": "53.91711000",
                        "longitude": "19.92602000"
                    },
                    {
                        "id": 87106,
                        "name": "Mrągowo",
                        "latitude": "53.86437000",
                        "longitude": "21.30507000"
                    },
                    {
                        "id": 87146,
                        "name": "Nidzica",
                        "latitude": "53.36052000",
                        "longitude": "20.42749000"
                    },
                    {
                        "id": 87186,
                        "name": "Nowe Miasto Lubawskie",
                        "latitude": "53.42079000",
                        "longitude": "19.59515000"
                    },
                    {
                        "id": 87236,
                        "name": "Olecko",
                        "latitude": "54.03374000",
                        "longitude": "22.50704000"
                    },
                    {
                        "id": 87248,
                        "name": "Olsztyn",
                        "latitude": "53.77657000",
                        "longitude": "20.46657000"
                    },
                    {
                        "id": 87249,
                        "name": "Olsztynek",
                        "latitude": "53.58374000",
                        "longitude": "20.28471000"
                    },
                    {
                        "id": 87268,
                        "name": "Orneta",
                        "latitude": "54.11483000",
                        "longitude": "20.13328000"
                    },
                    {
                        "id": 87274,
                        "name": "Orzysz",
                        "latitude": "53.80967000",
                        "longitude": "21.94811000"
                    },
                    {
                        "id": 87307,
                        "name": "Ostróda",
                        "latitude": "53.69671000",
                        "longitude": "19.96486000"
                    },
                    {
                        "id": 87353,
                        "name": "Pasłęk",
                        "latitude": "54.06160000",
                        "longitude": "19.65932000"
                    },
                    {
                        "id": 87351,
                        "name": "Pasym",
                        "latitude": "53.65069000",
                        "longitude": "20.79188000"
                    },
                    {
                        "id": 87374,
                        "name": "Piecki",
                        "latitude": "53.75759000",
                        "longitude": "21.33914000"
                    },
                    {
                        "id": 87380,
                        "name": "Pieniężno",
                        "latitude": "54.23649000",
                        "longitude": "20.12833000"
                    },
                    {
                        "id": 87398,
                        "name": "Pisz",
                        "latitude": "53.62744000",
                        "longitude": "21.81253000"
                    },
                    {
                        "id": 87459,
                        "name": "Powiat bartoszycki",
                        "latitude": "54.21253000",
                        "longitude": "20.74076000"
                    },
                    {
                        "id": 87472,
                        "name": "Powiat braniewski",
                        "latitude": "54.27782000",
                        "longitude": "20.00630000"
                    },
                    {
                        "id": 87494,
                        "name": "Powiat działdowski",
                        "latitude": "53.28883000",
                        "longitude": "20.04817000"
                    },
                    {
                        "id": 87498,
                        "name": "Powiat elbląski",
                        "latitude": "54.15928000",
                        "longitude": "19.63768000"
                    },
                    {
                        "id": 87499,
                        "name": "Powiat ełcki",
                        "latitude": "53.81673000",
                        "longitude": "22.40465000"
                    },
                    {
                        "id": 87502,
                        "name": "Powiat giżycki",
                        "latitude": "54.01808000",
                        "longitude": "21.82191000"
                    },
                    {
                        "id": 87511,
                        "name": "Powiat gołdapski",
                        "latitude": "54.26090000",
                        "longitude": "22.37192000"
                    },
                    {
                        "id": 87525,
                        "name": "Powiat iławski",
                        "latitude": "53.67477000",
                        "longitude": "19.53792000"
                    },
                    {
                        "id": 87561,
                        "name": "Powiat kętrzyński",
                        "latitude": "54.13651000",
                        "longitude": "21.31217000"
                    },
                    {
                        "id": 87569,
                        "name": "Powiat lidzbarski",
                        "latitude": "54.10581000",
                        "longitude": "20.38045000"
                    },
                    {
                        "id": 87592,
                        "name": "Powiat mrągowski",
                        "latitude": "53.81063000",
                        "longitude": "21.39758000"
                    },
                    {
                        "id": 87599,
                        "name": "Powiat nidzicki",
                        "latitude": "53.37240000",
                        "longitude": "20.49858000"
                    },
                    {
                        "id": 87603,
                        "name": "Powiat nowomiejski",
                        "latitude": "53.43572000",
                        "longitude": "19.54662000"
                    },
                    {
                        "id": 87610,
                        "name": "Powiat olecki",
                        "latitude": "54.05129000",
                        "longitude": "22.41695000"
                    },
                    {
                        "id": 87614,
                        "name": "Powiat olsztyński",
                        "latitude": "53.72922000",
                        "longitude": "20.56641000"
                    },
                    {
                        "id": 87624,
                        "name": "Powiat ostródzki",
                        "latitude": "53.72906000",
                        "longitude": "19.91440000"
                    },
                    {
                        "id": 87634,
                        "name": "Powiat piski",
                        "latitude": "53.68076000",
                        "longitude": "21.85723000"
                    },
                    {
                        "id": 87693,
                        "name": "Powiat szczycieński",
                        "latitude": "53.54176000",
                        "longitude": "21.07034000"
                    },
                    {
                        "id": 87731,
                        "name": "Powiat węgorzewski",
                        "latitude": "54.20728000",
                        "longitude": "21.77861000"
                    },
                    {
                        "id": 87773,
                        "name": "Pozezdrze",
                        "latitude": "54.14147000",
                        "longitude": "21.85970000"
                    },
                    {
                        "id": 87791,
                        "name": "Prostki",
                        "latitude": "53.69901000",
                        "longitude": "22.43183000"
                    },
                    {
                        "id": 87848,
                        "name": "Purda",
                        "latitude": "53.70844000",
                        "longitude": "20.70683000"
                    },
                    {
                        "id": 87939,
                        "name": "Reszel",
                        "latitude": "54.05042000",
                        "longitude": "21.14585000"
                    },
                    {
                        "id": 87965,
                        "name": "Rozogi",
                        "latitude": "53.48549000",
                        "longitude": "21.36223000"
                    },
                    {
                        "id": 87969,
                        "name": "Ruciane-Nida",
                        "latitude": "53.64161000",
                        "longitude": "21.53964000"
                    },
                    {
                        "id": 87996,
                        "name": "Rybno",
                        "latitude": "53.38348000",
                        "longitude": "19.93229000"
                    },
                    {
                        "id": 88011,
                        "name": "Ryn",
                        "latitude": "53.93770000",
                        "longitude": "21.54642000"
                    },
                    {
                        "id": 88332,
                        "name": "Sępopol",
                        "latitude": "54.26903000",
                        "longitude": "21.01453000"
                    },
                    {
                        "id": 88163,
                        "name": "Srokowo",
                        "latitude": "54.21416000",
                        "longitude": "21.52282000"
                    },
                    {
                        "id": 88184,
                        "name": "Stare Juchy",
                        "latitude": "53.92198000",
                        "longitude": "22.17367000"
                    },
                    {
                        "id": 88199,
                        "name": "Stawiguda",
                        "latitude": "53.65720000",
                        "longitude": "20.40041000"
                    },
                    {
                        "id": 88267,
                        "name": "Susz",
                        "latitude": "53.71743000",
                        "longitude": "19.33645000"
                    },
                    {
                        "id": 88276,
                        "name": "Swiętajno",
                        "latitude": "54.00151000",
                        "longitude": "22.31830000"
                    },
                    {
                        "id": 88305,
                        "name": "Szczytno",
                        "latitude": "53.56259000",
                        "longitude": "20.98747000"
                    },
                    {
                        "id": 88377,
                        "name": "Tolkmicko",
                        "latitude": "54.32038000",
                        "longitude": "19.52695000"
                    },
                    {
                        "id": 88641,
                        "name": "Węgorzewo",
                        "latitude": "54.21567000",
                        "longitude": "21.73720000"
                    },
                    {
                        "id": 88498,
                        "name": "Wielbark",
                        "latitude": "53.39858000",
                        "longitude": "20.94629000"
                    },
                    {
                        "id": 88611,
                        "name": "Wydminy",
                        "latitude": "53.98194000",
                        "longitude": "22.03239000"
                    },
                    {
                        "id": 88688,
                        "name": "Zalewo",
                        "latitude": "53.84534000",
                        "longitude": "19.60519000"
                    }
                ]
            },
            {
                "id": 1633,
                "name": "West Pomerania",
                "iso2": "32",
                "latitude": "53.46578910",
                "longitude": "15.18225810",
                "type": "voivodship",
                "cities": [
                    {
                        "id": 85798,
                        "name": "Banie",
                        "latitude": "53.10031000",
                        "longitude": "14.66228000"
                    },
                    {
                        "id": 85811,
                        "name": "Barlinek",
                        "latitude": "52.99464000",
                        "longitude": "15.21864000"
                    },
                    {
                        "id": 85817,
                        "name": "Barwice",
                        "latitude": "53.74490000",
                        "longitude": "16.35530000"
                    },
                    {
                        "id": 85844,
                        "name": "Białogard",
                        "latitude": "54.00696000",
                        "longitude": "15.98751000"
                    },
                    {
                        "id": 85848,
                        "name": "Biały Bór",
                        "latitude": "53.89670000",
                        "longitude": "16.83543000"
                    },
                    {
                        "id": 85856,
                        "name": "Bielice",
                        "latitude": "53.20022000",
                        "longitude": "14.72760000"
                    },
                    {
                        "id": 85868,
                        "name": "Bierzwnik",
                        "latitude": "53.03567000",
                        "longitude": "15.66500000"
                    },
                    {
                        "id": 85884,
                        "name": "Bobolice",
                        "latitude": "53.95508000",
                        "longitude": "16.58893000"
                    },
                    {
                        "id": 85909,
                        "name": "Boleszkowice",
                        "latitude": "52.72493000",
                        "longitude": "14.56901000"
                    },
                    {
                        "id": 85922,
                        "name": "Borne Sulinowo",
                        "latitude": "53.57661000",
                        "longitude": "16.53395000"
                    },
                    {
                        "id": 85950,
                        "name": "Brojce",
                        "latitude": "53.95705000",
                        "longitude": "15.35975000"
                    },
                    {
                        "id": 86019,
                        "name": "Cedynia",
                        "latitude": "52.87931000",
                        "longitude": "14.20249000"
                    },
                    {
                        "id": 86024,
                        "name": "Cerkwica",
                        "latitude": "54.00777000",
                        "longitude": "15.10903000"
                    },
                    {
                        "id": 86040,
                        "name": "Chociwel",
                        "latitude": "53.46696000",
                        "longitude": "15.33342000"
                    },
                    {
                        "id": 86048,
                        "name": "Chojna",
                        "latitude": "52.96389000",
                        "longitude": "14.42797000"
                    },
                    {
                        "id": 86056,
                        "name": "Choszczno",
                        "latitude": "53.16905000",
                        "longitude": "15.42054000"
                    },
                    {
                        "id": 86101,
                        "name": "Czaplinek",
                        "latitude": "53.55775000",
                        "longitude": "16.23333000"
                    },
                    {
                        "id": 86151,
                        "name": "Człopa",
                        "latitude": "53.08856000",
                        "longitude": "16.12098000"
                    },
                    {
                        "id": 86158,
                        "name": "Darłowo",
                        "latitude": "54.42095000",
                        "longitude": "16.41070000"
                    },
                    {
                        "id": 86252,
                        "name": "Dębno",
                        "latitude": "52.73901000",
                        "longitude": "14.69800000"
                    },
                    {
                        "id": 86168,
                        "name": "Dobra",
                        "latitude": "53.58625000",
                        "longitude": "15.30977000"
                    },
                    {
                        "id": 86176,
                        "name": "Dobrzany",
                        "latitude": "53.35914000",
                        "longitude": "15.42886000"
                    },
                    {
                        "id": 86181,
                        "name": "Dolice",
                        "latitude": "53.19081000",
                        "longitude": "15.20267000"
                    },
                    {
                        "id": 86193,
                        "name": "Drawno",
                        "latitude": "53.21986000",
                        "longitude": "15.75946000"
                    },
                    {
                        "id": 86195,
                        "name": "Drawsko Pomorskie",
                        "latitude": "53.53056000",
                        "longitude": "15.80967000"
                    },
                    {
                        "id": 86212,
                        "name": "Dygowo",
                        "latitude": "54.13031000",
                        "longitude": "15.71993000"
                    },
                    {
                        "id": 86230,
                        "name": "Dziwnów",
                        "latitude": "54.02819000",
                        "longitude": "14.76691000"
                    },
                    {
                        "id": 86325,
                        "name": "Golczewo",
                        "latitude": "53.82426000",
                        "longitude": "14.97847000"
                    },
                    {
                        "id": 86326,
                        "name": "Goleniów",
                        "latitude": "53.56392000",
                        "longitude": "14.82854000"
                    },
                    {
                        "id": 86361,
                        "name": "Gościno",
                        "latitude": "54.05123000",
                        "longitude": "15.65256000"
                    },
                    {
                        "id": 86390,
                        "name": "Gryfice",
                        "latitude": "53.91650000",
                        "longitude": "15.20027000"
                    },
                    {
                        "id": 86391,
                        "name": "Gryfino",
                        "latitude": "53.25243000",
                        "longitude": "14.48831000"
                    },
                    {
                        "id": 86395,
                        "name": "Grzmiąca",
                        "latitude": "53.83734000",
                        "longitude": "16.43512000"
                    },
                    {
                        "id": 86397,
                        "name": "Grzybowo",
                        "latitude": "54.15892000",
                        "longitude": "15.48557000"
                    },
                    {
                        "id": 86477,
                        "name": "Ińsko",
                        "latitude": "53.43613000",
                        "longitude": "15.55020000"
                    },
                    {
                        "id": 86587,
                        "name": "Kalisz Pomorski",
                        "latitude": "53.29908000",
                        "longitude": "15.90631000"
                    },
                    {
                        "id": 86601,
                        "name": "Kamień Pomorski",
                        "latitude": "53.96849000",
                        "longitude": "14.77262000"
                    },
                    {
                        "id": 86612,
                        "name": "Karlino",
                        "latitude": "54.03515000",
                        "longitude": "15.87739000"
                    },
                    {
                        "id": 86613,
                        "name": "Karnice",
                        "latitude": "54.03001000",
                        "longitude": "15.05496000"
                    },
                    {
                        "id": 86665,
                        "name": "Kobylanka",
                        "latitude": "53.34492000",
                        "longitude": "14.87143000"
                    },
                    {
                        "id": 86742,
                        "name": "Kołbaskowo",
                        "latitude": "53.33641000",
                        "longitude": "14.43835000"
                    },
                    {
                        "id": 86746,
                        "name": "Kołobrzeg",
                        "latitude": "54.17565000",
                        "longitude": "15.58342000"
                    },
                    {
                        "id": 86716,
                        "name": "Koszalin",
                        "latitude": "54.19438000",
                        "longitude": "16.17222000"
                    },
                    {
                        "id": 86826,
                        "name": "Krzęcin",
                        "latitude": "53.08160000",
                        "longitude": "15.49008000"
                    },
                    {
                        "id": 86906,
                        "name": "Lipiany",
                        "latitude": "53.00336000",
                        "longitude": "14.96919000"
                    },
                    {
                        "id": 88779,
                        "name": "Łobez",
                        "latitude": "53.63918000",
                        "longitude": "15.62129000"
                    },
                    {
                        "id": 88800,
                        "name": "Łubowo",
                        "latitude": "53.58634000",
                        "longitude": "16.39177000"
                    },
                    {
                        "id": 86993,
                        "name": "Marianowo",
                        "latitude": "53.38287000",
                        "longitude": "15.26645000"
                    },
                    {
                        "id": 87000,
                        "name": "Maszewo",
                        "latitude": "53.49615000",
                        "longitude": "15.06166000"
                    },
                    {
                        "id": 87066,
                        "name": "Międzyzdroje",
                        "latitude": "53.92921000",
                        "longitude": "14.45097000"
                    },
                    {
                        "id": 87037,
                        "name": "Mielno",
                        "latitude": "54.26086000",
                        "longitude": "16.06210000"
                    },
                    {
                        "id": 87040,
                        "name": "Mieszkowice",
                        "latitude": "52.78730000",
                        "longitude": "14.49346000"
                    },
                    {
                        "id": 87055,
                        "name": "Mirosławiec",
                        "latitude": "53.34071000",
                        "longitude": "16.08793000"
                    },
                    {
                        "id": 87092,
                        "name": "Moryń",
                        "latitude": "52.85769000",
                        "longitude": "14.39297000"
                    },
                    {
                        "id": 87095,
                        "name": "Mosty",
                        "latitude": "53.54796000",
                        "longitude": "14.95634000"
                    },
                    {
                        "id": 87105,
                        "name": "Mrzeżyno",
                        "latitude": "54.14384000",
                        "longitude": "15.29142000"
                    },
                    {
                        "id": 87124,
                        "name": "Myślibórz",
                        "latitude": "52.92382000",
                        "longitude": "14.86785000"
                    },
                    {
                        "id": 87192,
                        "name": "Nowe Warpno",
                        "latitude": "53.72256000",
                        "longitude": "14.28961000"
                    },
                    {
                        "id": 87194,
                        "name": "Nowogard",
                        "latitude": "53.67437000",
                        "longitude": "15.11630000"
                    },
                    {
                        "id": 87198,
                        "name": "Nowogródek Pomorski",
                        "latitude": "52.91149000",
                        "longitude": "15.02947000"
                    },
                    {
                        "id": 87293,
                        "name": "Osina",
                        "latitude": "53.60473000",
                        "longitude": "15.01230000"
                    },
                    {
                        "id": 87367,
                        "name": "Pełczyce",
                        "latitude": "53.04354000",
                        "longitude": "15.30447000"
                    },
                    {
                        "id": 87866,
                        "name": "Płoty",
                        "latitude": "53.80182000",
                        "longitude": "15.26670000"
                    },
                    {
                        "id": 87411,
                        "name": "Pobierowo",
                        "latitude": "54.06100000",
                        "longitude": "14.93282000"
                    },
                    {
                        "id": 87432,
                        "name": "Polanów",
                        "latitude": "54.11930000",
                        "longitude": "16.68512000"
                    },
                    {
                        "id": 87434,
                        "name": "Police",
                        "latitude": "53.55214000",
                        "longitude": "14.57182000"
                    },
                    {
                        "id": 87777,
                        "name": "Połczyn-Zdrój",
                        "latitude": "53.76424000",
                        "longitude": "16.09574000"
                    },
                    {
                        "id": 87463,
                        "name": "Powiat białogardzki",
                        "latitude": "53.97686000",
                        "longitude": "16.08855000"
                    },
                    {
                        "id": 87486,
                        "name": "Powiat choszczeński",
                        "latitude": "53.14277000",
                        "longitude": "15.62112000"
                    },
                    {
                        "id": 87493,
                        "name": "Powiat drawski",
                        "latitude": "53.44743000",
                        "longitude": "16.02132000"
                    },
                    {
                        "id": 87505,
                        "name": "Powiat goleniowski",
                        "latitude": "53.61035000",
                        "longitude": "14.85421000"
                    },
                    {
                        "id": 87516,
                        "name": "Powiat gryficki",
                        "latitude": "53.94293000",
                        "longitude": "15.19082000"
                    },
                    {
                        "id": 87517,
                        "name": "Powiat gryfiński",
                        "latitude": "53.02298000",
                        "longitude": "14.49912000"
                    },
                    {
                        "id": 87535,
                        "name": "Powiat kamieński",
                        "latitude": "53.91096000",
                        "longitude": "14.74420000"
                    },
                    {
                        "id": 87547,
                        "name": "Powiat kołobrzeski",
                        "latitude": "54.05013000",
                        "longitude": "15.61394000"
                    },
                    {
                        "id": 87545,
                        "name": "Powiat koszaliński",
                        "latitude": "54.10970000",
                        "longitude": "16.30231000"
                    },
                    {
                        "id": 87749,
                        "name": "Powiat łobeski",
                        "latitude": "53.67294000",
                        "longitude": "15.47237000"
                    },
                    {
                        "id": 87595,
                        "name": "Powiat myśliborski",
                        "latitude": "52.85474000",
                        "longitude": "14.88454000"
                    },
                    {
                        "id": 87638,
                        "name": "Powiat policki",
                        "latitude": "53.53114000",
                        "longitude": "14.45104000"
                    },
                    {
                        "id": 87652,
                        "name": "Powiat pyrzycki",
                        "latitude": "53.12558000",
                        "longitude": "14.94045000"
                    },
                    {
                        "id": 87697,
                        "name": "Powiat sławieński",
                        "latitude": "54.37910000",
                        "longitude": "16.53986000"
                    },
                    {
                        "id": 87681,
                        "name": "Powiat stargardzki",
                        "latitude": "53.31520000",
                        "longitude": "15.22684000"
                    },
                    {
                        "id": 87761,
                        "name": "Powiat świdwiński",
                        "latitude": "53.80758000",
                        "longitude": "15.89859000"
                    },
                    {
                        "id": 87692,
                        "name": "Powiat szczecinecki",
                        "latitude": "53.73766000",
                        "longitude": "16.58957000"
                    },
                    {
                        "id": 87715,
                        "name": "Powiat wałecki",
                        "latitude": "53.23633000",
                        "longitude": "16.33851000"
                    },
                    {
                        "id": 87805,
                        "name": "Przecław",
                        "latitude": "53.37447000",
                        "longitude": "14.47251000"
                    },
                    {
                        "id": 87810,
                        "name": "Przelewice",
                        "latitude": "53.10413000",
                        "longitude": "15.07625000"
                    },
                    {
                        "id": 87819,
                        "name": "Przybiernów",
                        "latitude": "53.75780000",
                        "longitude": "14.78529000"
                    },
                    {
                        "id": 87855,
                        "name": "Pyrzyce",
                        "latitude": "53.14620000",
                        "longitude": "14.89257000"
                    },
                    {
                        "id": 88035,
                        "name": "Rąbino",
                        "latitude": "53.86630000",
                        "longitude": "15.94485000"
                    },
                    {
                        "id": 87891,
                        "name": "Radowo Małe",
                        "latitude": "53.66575000",
                        "longitude": "15.44789000"
                    },
                    {
                        "id": 87920,
                        "name": "Recz",
                        "latitude": "53.25989000",
                        "longitude": "15.54713000"
                    },
                    {
                        "id": 87938,
                        "name": "Resko",
                        "latitude": "53.77307000",
                        "longitude": "15.40607000"
                    },
                    {
                        "id": 87940,
                        "name": "Rewal",
                        "latitude": "54.08120000",
                        "longitude": "15.01471000"
                    },
                    {
                        "id": 88010,
                        "name": "Rymań",
                        "latitude": "53.94391000",
                        "longitude": "15.52866000"
                    },
                    {
                        "id": 88059,
                        "name": "Sianów",
                        "latitude": "54.22646000",
                        "longitude": "16.29127000"
                    },
                    {
                        "id": 88339,
                        "name": "Sławno",
                        "latitude": "54.36276000",
                        "longitude": "16.67888000"
                    },
                    {
                        "id": 88340,
                        "name": "Sławoborze",
                        "latitude": "53.88992000",
                        "longitude": "15.70667000"
                    },
                    {
                        "id": 88174,
                        "name": "Stara Dąbrowa",
                        "latitude": "53.42191000",
                        "longitude": "15.14405000"
                    },
                    {
                        "id": 88183,
                        "name": "Stare Czarnowo",
                        "latitude": "53.27861000",
                        "longitude": "14.77906000"
                    },
                    {
                        "id": 88189,
                        "name": "Stargard",
                        "latitude": "53.33672000",
                        "longitude": "15.04990000"
                    },
                    {
                        "id": 88203,
                        "name": "Stepnica",
                        "latitude": "53.65187000",
                        "longitude": "14.62555000"
                    },
                    {
                        "id": 88249,
                        "name": "Suchań",
                        "latitude": "53.28003000",
                        "longitude": "15.32541000"
                    },
                    {
                        "id": 88844,
                        "name": "Świdwin",
                        "latitude": "53.77464000",
                        "longitude": "15.77671000"
                    },
                    {
                        "id": 88858,
                        "name": "Świerzno",
                        "latitude": "53.96497000",
                        "longitude": "14.96544000"
                    },
                    {
                        "id": 88862,
                        "name": "Świnoujście",
                        "latitude": "53.91053000",
                        "longitude": "14.24712000"
                    },
                    {
                        "id": 88293,
                        "name": "Szczecin",
                        "latitude": "53.42894000",
                        "longitude": "14.55302000"
                    },
                    {
                        "id": 88294,
                        "name": "Szczecinek",
                        "latitude": "53.70791000",
                        "longitude": "16.69937000"
                    },
                    {
                        "id": 88400,
                        "name": "Trzcińsko Zdrój",
                        "latitude": "52.96487000",
                        "longitude": "14.60667000"
                    },
                    {
                        "id": 88401,
                        "name": "Trzebiatów",
                        "latitude": "54.06147000",
                        "longitude": "15.26475000"
                    },
                    {
                        "id": 88420,
                        "name": "Tuczno",
                        "latitude": "53.19374000",
                        "longitude": "16.15368000"
                    },
                    {
                        "id": 88435,
                        "name": "Tychowo",
                        "latitude": "53.92774000",
                        "longitude": "16.25771000"
                    },
                    {
                        "id": 88463,
                        "name": "Ustronie Morskie",
                        "latitude": "54.21517000",
                        "longitude": "15.75568000"
                    },
                    {
                        "id": 88488,
                        "name": "Wałcz",
                        "latitude": "53.27787000",
                        "longitude": "16.47122000"
                    },
                    {
                        "id": 88479,
                        "name": "Warnice",
                        "latitude": "53.25376000",
                        "longitude": "14.99402000"
                    },
                    {
                        "id": 88642,
                        "name": "Węgorzyno",
                        "latitude": "53.54101000",
                        "longitude": "15.55964000"
                    },
                    {
                        "id": 88496,
                        "name": "Widuchowa",
                        "latitude": "53.12693000",
                        "longitude": "14.39074000"
                    },
                    {
                        "id": 88525,
                        "name": "Wierzchowo",
                        "latitude": "53.46013000",
                        "longitude": "16.09961000"
                    },
                    {
                        "id": 88596,
                        "name": "Wolin",
                        "latitude": "53.84214000",
                        "longitude": "14.61465000"
                    },
                    {
                        "id": 88742,
                        "name": "Złocieniec",
                        "latitude": "53.53286000",
                        "longitude": "16.01132000"
                    }
                ]
            }
        ]
    },
    {
        "id": 177,
        "name": "Portugal",
        "iso3": "PRT",
        "iso2": "PT",
        "numeric_code": "620",
        "phonecode": "351",
        "capital": "Lisbon",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".pt",
        "native": "Portugal",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Portuguese",
        "timezones": [
            {
                "zoneName": "Atlantic\/Azores",
                "gmtOffset": -3600,
                "gmtOffsetName": "UTC-01:00",
                "abbreviation": "AZOT",
                "tzName": "Azores Standard Time"
            },
            {
                "zoneName": "Atlantic\/Madeira",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "WET",
                "tzName": "Western European Time"
            },
            {
                "zoneName": "Europe\/Lisbon",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "WET",
                "tzName": "Western European Time"
            }
        ],
        "translations": {
            "br": "Portugal",
            "ko": "포르투갈",
            "pt-BR": "Portugal",
            "pt": "Portugal",
            "nl": "Portugal",
            "hr": "Portugal",
            "fa": "پرتغال",
            "de": "Portugal",
            "es": "Portugal",
            "fr": "Portugal",
            "ja": "ポルトガル",
            "it": "Portogallo",
            "zh-CN": "葡萄牙",
            "tr": "Portekiz",
            "ru": "Португалия",
            "uk": "Португалія",
            "pl": "Portugalia"
        },
        "latitude": "39.50000000",
        "longitude": "-8.00000000",
        "emoji": "🇵🇹",
        "emojiU": "U+1F1F5 U+1F1F9",
        "states": [
            {
                "id": 2233,
                "name": "Açores",
                "iso2": "20",
                "latitude": "37.74124880",
                "longitude": "-25.67559440",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 89692,
                        "name": "Água de Pau",
                        "latitude": "37.72142000",
                        "longitude": "-25.51170000"
                    },
                    {
                        "id": 88968,
                        "name": "Angra do Heroísmo",
                        "latitude": "38.65483000",
                        "longitude": "-27.21734000"
                    },
                    {
                        "id": 88969,
                        "name": "Angústias",
                        "latitude": "38.52547000",
                        "longitude": "-28.63132000"
                    },
                    {
                        "id": 88994,
                        "name": "Arrifes",
                        "latitude": "37.76667000",
                        "longitude": "-25.70000000"
                    },
                    {
                        "id": 89037,
                        "name": "Biscoitos",
                        "latitude": "38.78333000",
                        "longitude": "-27.25000000"
                    },
                    {
                        "id": 89057,
                        "name": "Cabouco",
                        "latitude": "37.76667000",
                        "longitude": "-25.56667000"
                    },
                    {
                        "id": 89062,
                        "name": "Cais do Pico",
                        "latitude": "38.52531000",
                        "longitude": "-28.32074000"
                    },
                    {
                        "id": 89069,
                        "name": "Calheta",
                        "latitude": "38.60186000",
                        "longitude": "-28.01792000"
                    },
                    {
                        "id": 89070,
                        "name": "Calheta de São Jorge",
                        "latitude": "38.59767000",
                        "longitude": "-27.91459000"
                    },
                    {
                        "id": 89105,
                        "name": "Castelo Branco",
                        "latitude": "38.52198000",
                        "longitude": "-28.71365000"
                    },
                    {
                        "id": 89131,
                        "name": "Corvo",
                        "latitude": "39.69771000",
                        "longitude": "-31.10550000"
                    },
                    {
                        "id": 89163,
                        "name": "Fajã de Baixo",
                        "latitude": "37.75000000",
                        "longitude": "-25.65000000"
                    },
                    {
                        "id": 89172,
                        "name": "Fenais da Ajuda",
                        "latitude": "37.85128000",
                        "longitude": "-25.32406000"
                    },
                    {
                        "id": 89173,
                        "name": "Fenais da Luz",
                        "latitude": "37.82490000",
                        "longitude": "-25.64229000"
                    },
                    {
                        "id": 89181,
                        "name": "Feteira",
                        "latitude": "38.65429000",
                        "longitude": "-27.14995000"
                    },
                    {
                        "id": 89187,
                        "name": "Fonte Bastardo",
                        "latitude": "38.69201000",
                        "longitude": "-27.07942000"
                    },
                    {
                        "id": 89199,
                        "name": "Furnas",
                        "latitude": "37.77567000",
                        "longitude": "-25.31035000"
                    },
                    {
                        "id": 89223,
                        "name": "Horta",
                        "latitude": "38.53737000",
                        "longitude": "-28.62615000"
                    },
                    {
                        "id": 89228,
                        "name": "Lagoa",
                        "latitude": "37.74486000",
                        "longitude": "-25.57184000"
                    },
                    {
                        "id": 89231,
                        "name": "Lajes",
                        "latitude": "38.76352000",
                        "longitude": "-27.10336000"
                    },
                    {
                        "id": 89232,
                        "name": "Lajes das Flores",
                        "latitude": "39.41619000",
                        "longitude": "-31.21725000"
                    },
                    {
                        "id": 89233,
                        "name": "Lajes do Pico",
                        "latitude": "38.42797000",
                        "longitude": "-28.17402000"
                    },
                    {
                        "id": 89267,
                        "name": "Madalena",
                        "latitude": "38.53642000",
                        "longitude": "-28.52660000"
                    },
                    {
                        "id": 89269,
                        "name": "Maia",
                        "latitude": "37.83247000",
                        "longitude": "-25.38976000"
                    },
                    {
                        "id": 89333,
                        "name": "Mosteiros",
                        "latitude": "37.89017000",
                        "longitude": "-25.81999000"
                    },
                    {
                        "id": 89350,
                        "name": "Nordeste",
                        "latitude": "37.82721000",
                        "longitude": "-25.22863000"
                    },
                    {
                        "id": 89412,
                        "name": "Ponta Delgada",
                        "latitude": "37.74230000",
                        "longitude": "-25.67093000"
                    },
                    {
                        "id": 89413,
                        "name": "Ponta Garça",
                        "latitude": "37.71667000",
                        "longitude": "-25.36667000"
                    },
                    {
                        "id": 89427,
                        "name": "Porto Judeu",
                        "latitude": "38.64814000",
                        "longitude": "-27.11944000"
                    },
                    {
                        "id": 89428,
                        "name": "Porto Martins",
                        "latitude": "38.68146000",
                        "longitude": "-27.05835000"
                    },
                    {
                        "id": 89434,
                        "name": "Povoação",
                        "latitude": "37.76471000",
                        "longitude": "-25.24487000"
                    },
                    {
                        "id": 89437,
                        "name": "Praia da Vitória",
                        "latitude": "38.73333000",
                        "longitude": "-27.06667000"
                    },
                    {
                        "id": 89451,
                        "name": "Rabo de Peixe",
                        "latitude": "37.81022000",
                        "longitude": "-25.58263000"
                    },
                    {
                        "id": 89460,
                        "name": "Relva",
                        "latitude": "37.75271000",
                        "longitude": "-25.71848000"
                    },
                    {
                        "id": 89466,
                        "name": "Ribeira Grande",
                        "latitude": "38.51667000",
                        "longitude": "-28.70000000"
                    },
                    {
                        "id": 89467,
                        "name": "Ribeira Seca",
                        "latitude": "37.81667000",
                        "longitude": "-25.53333000"
                    },
                    {
                        "id": 89469,
                        "name": "Ribeirinha",
                        "latitude": "38.66203000",
                        "longitude": "-27.18093000"
                    },
                    {
                        "id": 89479,
                        "name": "Rosto de Cão",
                        "latitude": "37.75000000",
                        "longitude": "-25.65000000"
                    },
                    {
                        "id": 89494,
                        "name": "Santa Bárbara",
                        "latitude": "38.69608000",
                        "longitude": "-27.33907000"
                    },
                    {
                        "id": 89502,
                        "name": "Santa Cruz da Graciosa",
                        "latitude": "39.04946000",
                        "longitude": "-28.00432000"
                    },
                    {
                        "id": 89501,
                        "name": "Santa Cruz das Flores",
                        "latitude": "39.46984000",
                        "longitude": "-31.18514000"
                    },
                    {
                        "id": 89558,
                        "name": "São Bartolomeu",
                        "latitude": "38.67491000",
                        "longitude": "-27.29349000"
                    },
                    {
                        "id": 89577,
                        "name": "São Mateus",
                        "latitude": "38.65630000",
                        "longitude": "-27.26935000"
                    },
                    {
                        "id": 89586,
                        "name": "São Roque",
                        "latitude": "37.75418000",
                        "longitude": "-25.64127000"
                    },
                    {
                        "id": 89588,
                        "name": "São Roque do Pico",
                        "latitude": "38.51631000",
                        "longitude": "-28.30752000"
                    },
                    {
                        "id": 89589,
                        "name": "São Sebastião",
                        "latitude": "38.66584000",
                        "longitude": "-27.08976000"
                    },
                    {
                        "id": 89592,
                        "name": "São Vicente",
                        "latitude": "37.81829000",
                        "longitude": "-25.66583000"
                    },
                    {
                        "id": 89529,
                        "name": "Senhora do Rosário",
                        "latitude": "37.83333000",
                        "longitude": "-25.15000000"
                    },
                    {
                        "id": 89633,
                        "name": "Velas",
                        "latitude": "38.67995000",
                        "longitude": "-28.15155000"
                    },
                    {
                        "id": 89673,
                        "name": "Vila do Porto",
                        "latitude": "36.97454000",
                        "longitude": "-25.09967000"
                    },
                    {
                        "id": 89650,
                        "name": "Vila Franca do Campo",
                        "latitude": "37.71667000",
                        "longitude": "-25.43333000"
                    }
                ]
            },
            {
                "id": 2235,
                "name": "Aveiro",
                "iso2": "01",
                "latitude": "40.72090230",
                "longitude": "-8.57210160",
                "type": "district",
                "cities": [
                    {
                        "id": 88910,
                        "name": "Aguada de Cima",
                        "latitude": "40.52291000",
                        "longitude": "-8.42700000"
                    },
                    {
                        "id": 89695,
                        "name": "Águeda",
                        "latitude": "40.57720000",
                        "longitude": "-8.44442000"
                    },
                    {
                        "id": 88913,
                        "name": "Albergaria-a-Velha",
                        "latitude": "40.68706000",
                        "longitude": "-8.50399000"
                    },
                    {
                        "id": 88967,
                        "name": "Anadia",
                        "latitude": "40.43841000",
                        "longitude": "-8.43352000"
                    },
                    {
                        "id": 88976,
                        "name": "Aradas",
                        "latitude": "40.62084000",
                        "longitude": "-8.64195000"
                    },
                    {
                        "id": 88980,
                        "name": "Arcos",
                        "latitude": "40.44779000",
                        "longitude": "-8.44171000"
                    },
                    {
                        "id": 88986,
                        "name": "Argoncilhe",
                        "latitude": "41.02541000",
                        "longitude": "-8.53885000"
                    },
                    {
                        "id": 88989,
                        "name": "Arouca",
                        "latitude": "40.92658000",
                        "longitude": "-8.27251000"
                    },
                    {
                        "id": 88993,
                        "name": "Arrifana",
                        "latitude": "40.91565000",
                        "longitude": "-8.49657000"
                    },
                    {
                        "id": 89001,
                        "name": "Avanca",
                        "latitude": "40.80771000",
                        "longitude": "-8.57220000"
                    },
                    {
                        "id": 89003,
                        "name": "Aveiro",
                        "latitude": "40.64427000",
                        "longitude": "-8.64554000"
                    },
                    {
                        "id": 89025,
                        "name": "Beduido",
                        "latitude": "40.76427000",
                        "longitude": "-8.56110000"
                    },
                    {
                        "id": 89048,
                        "name": "Branca",
                        "latitude": "40.76653000",
                        "longitude": "-8.48262000"
                    },
                    {
                        "id": 89106,
                        "name": "Castelo de Paiva",
                        "latitude": "41.03353000",
                        "longitude": "-8.29822000"
                    },
                    {
                        "id": 89129,
                        "name": "Cortegaça",
                        "latitude": "40.94883000",
                        "longitude": "-8.62130000"
                    },
                    {
                        "id": 89137,
                        "name": "Cucujães",
                        "latitude": "40.87413000",
                        "longitude": "-8.50687000"
                    },
                    {
                        "id": 89141,
                        "name": "Eixo",
                        "latitude": "40.62758000",
                        "longitude": "-8.56922000"
                    },
                    {
                        "id": 89147,
                        "name": "Esgueira",
                        "latitude": "40.64899000",
                        "longitude": "-8.62943000"
                    },
                    {
                        "id": 89148,
                        "name": "Esmoriz",
                        "latitude": "40.95773000",
                        "longitude": "-8.62753000"
                    },
                    {
                        "id": 89149,
                        "name": "Espargo",
                        "latitude": "40.92462000",
                        "longitude": "-8.57495000"
                    },
                    {
                        "id": 89150,
                        "name": "Espinho",
                        "latitude": "41.00763000",
                        "longitude": "-8.64125000"
                    },
                    {
                        "id": 89153,
                        "name": "Estarreja",
                        "latitude": "40.75463000",
                        "longitude": "-8.57917000"
                    },
                    {
                        "id": 89170,
                        "name": "Feira",
                        "latitude": "40.92535000",
                        "longitude": "-8.54277000"
                    },
                    {
                        "id": 89185,
                        "name": "Fiães",
                        "latitude": "40.99446000",
                        "longitude": "-8.52537000"
                    },
                    {
                        "id": 89203,
                        "name": "Gafanha da Encarnação",
                        "latitude": "40.61806000",
                        "longitude": "-8.73303000"
                    },
                    {
                        "id": 89204,
                        "name": "Gafanha da Nazaré",
                        "latitude": "40.63621000",
                        "longitude": "-8.71338000"
                    },
                    {
                        "id": 89698,
                        "name": "Ílhavo",
                        "latitude": "40.60188000",
                        "longitude": "-8.67021000"
                    },
                    {
                        "id": 89234,
                        "name": "Lamas",
                        "latitude": "40.98597000",
                        "longitude": "-8.56923000"
                    },
                    {
                        "id": 89246,
                        "name": "Lobão",
                        "latitude": "40.98664000",
                        "longitude": "-8.48566000"
                    },
                    {
                        "id": 89254,
                        "name": "Lourosa",
                        "latitude": "40.98420000",
                        "longitude": "-8.55142000"
                    },
                    {
                        "id": 89257,
                        "name": "Luso",
                        "latitude": "40.38429000",
                        "longitude": "-8.37845000"
                    },
                    {
                        "id": 89263,
                        "name": "Macieira de Cambra",
                        "latitude": "40.85939000",
                        "longitude": "-8.37338000"
                    },
                    {
                        "id": 89287,
                        "name": "Mealhada",
                        "latitude": "40.36273000",
                        "longitude": "-8.44781000"
                    },
                    {
                        "id": 89298,
                        "name": "Milheirós de Poiares",
                        "latitude": "40.92163000",
                        "longitude": "-8.46788000"
                    },
                    {
                        "id": 89334,
                        "name": "Mosteirô",
                        "latitude": "40.89843000",
                        "longitude": "-8.53196000"
                    },
                    {
                        "id": 89338,
                        "name": "Murtosa",
                        "latitude": "40.74301000",
                        "longitude": "-8.64023000"
                    },
                    {
                        "id": 89349,
                        "name": "Nogueira da Regedoura",
                        "latitude": "41.00530000",
                        "longitude": "-8.59195000"
                    },
                    {
                        "id": 89355,
                        "name": "Oiã",
                        "latitude": "40.54264000",
                        "longitude": "-8.53856000"
                    },
                    {
                        "id": 89363,
                        "name": "Oliveira de Azemeis",
                        "latitude": "40.84101000",
                        "longitude": "-8.47555000"
                    },
                    {
                        "id": 89366,
                        "name": "Oliveira do Bairro",
                        "latitude": "40.50977000",
                        "longitude": "-8.56374000"
                    },
                    {
                        "id": 89370,
                        "name": "Oliveirinha",
                        "latitude": "40.60715000",
                        "longitude": "-8.59198000"
                    },
                    {
                        "id": 89374,
                        "name": "Ovar",
                        "latitude": "40.85862000",
                        "longitude": "-8.62513000"
                    },
                    {
                        "id": 89387,
                        "name": "Paços de Brandão",
                        "latitude": "40.97541000",
                        "longitude": "-8.58350000"
                    },
                    {
                        "id": 89379,
                        "name": "Pampilhosa do Botão",
                        "latitude": "40.33580000",
                        "longitude": "-8.42738000"
                    },
                    {
                        "id": 89381,
                        "name": "Pardilhó",
                        "latitude": "40.79925000",
                        "longitude": "-8.62598000"
                    },
                    {
                        "id": 89473,
                        "name": "Rio Meão",
                        "latitude": "40.95775000",
                        "longitude": "-8.57818000"
                    },
                    {
                        "id": 89484,
                        "name": "Salreu",
                        "latitude": "40.73971000",
                        "longitude": "-8.55720000"
                    },
                    {
                        "id": 89492,
                        "name": "Sanfins",
                        "latitude": "40.92979000",
                        "longitude": "-8.52563000"
                    },
                    {
                        "id": 89493,
                        "name": "Sangalhos",
                        "latitude": "40.48678000",
                        "longitude": "-8.46968000"
                    },
                    {
                        "id": 89507,
                        "name": "Santa Maria da Feira",
                        "latitude": "40.96043000",
                        "longitude": "-8.51545000"
                    },
                    {
                        "id": 89564,
                        "name": "São João",
                        "latitude": "40.86802000",
                        "longitude": "-8.60672000"
                    },
                    {
                        "id": 89565,
                        "name": "São João da Madeira",
                        "latitude": "40.90070000",
                        "longitude": "-8.49020000"
                    },
                    {
                        "id": 89570,
                        "name": "São João de Ver",
                        "latitude": "40.95527000",
                        "longitude": "-8.55117000"
                    },
                    {
                        "id": 89587,
                        "name": "São Roque",
                        "latitude": "40.87216000",
                        "longitude": "-8.47149000"
                    },
                    {
                        "id": 89541,
                        "name": "Sever do Vouga",
                        "latitude": "40.73156000",
                        "longitude": "-8.35493000"
                    },
                    {
                        "id": 89542,
                        "name": "Silvalde",
                        "latitude": "40.99205000",
                        "longitude": "-8.62567000"
                    },
                    {
                        "id": 89554,
                        "name": "Souto",
                        "latitude": "40.98496000",
                        "longitude": "-8.62185000"
                    },
                    {
                        "id": 89619,
                        "name": "Vagos",
                        "latitude": "40.49943000",
                        "longitude": "-8.67830000"
                    },
                    {
                        "id": 89625,
                        "name": "Vale de Cambra",
                        "latitude": "40.84500000",
                        "longitude": "-8.36022000"
                    },
                    {
                        "id": 89688,
                        "name": "Válega",
                        "latitude": "40.83629000",
                        "longitude": "-8.58061000"
                    },
                    {
                        "id": 89630,
                        "name": "Valongo",
                        "latitude": "40.61667000",
                        "longitude": "-8.45000000"
                    },
                    {
                        "id": 89645,
                        "name": "Vila Chã",
                        "latitude": "40.86667000",
                        "longitude": "-8.46667000"
                    }
                ]
            },
            {
                "id": 2230,
                "name": "Beja",
                "iso2": "02",
                "latitude": "37.96877860",
                "longitude": "-7.87216000",
                "type": "district",
                "cities": [
                    {
                        "id": 88925,
                        "name": "Aldeia Nova de São Bento",
                        "latitude": "37.92603000",
                        "longitude": "-7.40804000"
                    },
                    {
                        "id": 88944,
                        "name": "Aljustrel",
                        "latitude": "37.87759000",
                        "longitude": "-8.16516000"
                    },
                    {
                        "id": 88949,
                        "name": "Almodôvar",
                        "latitude": "37.49590000",
                        "longitude": "-8.09372000"
                    },
                    {
                        "id": 88950,
                        "name": "Almograve",
                        "latitude": "37.65665000",
                        "longitude": "-8.79214000"
                    },
                    {
                        "id": 88957,
                        "name": "Alvito",
                        "latitude": "38.24653000",
                        "longitude": "-8.05038000"
                    },
                    {
                        "id": 89020,
                        "name": "Barrancos",
                        "latitude": "38.13446000",
                        "longitude": "-6.97604000"
                    },
                    {
                        "id": 89027,
                        "name": "Beja",
                        "latitude": "38.01506000",
                        "longitude": "-7.86323000"
                    },
                    {
                        "id": 89036,
                        "name": "Beringel",
                        "latitude": "38.05656000",
                        "longitude": "-7.98427000"
                    },
                    {
                        "id": 89039,
                        "name": "Boavista dos Pinheiros",
                        "latitude": "37.58058000",
                        "longitude": "-8.66441000"
                    },
                    {
                        "id": 89056,
                        "name": "Cabeça Gorda",
                        "latitude": "37.92401000",
                        "longitude": "-7.79290000"
                    },
                    {
                        "id": 89111,
                        "name": "Castro Verde",
                        "latitude": "37.69828000",
                        "longitude": "-8.08581000"
                    },
                    {
                        "id": 89136,
                        "name": "Cuba",
                        "latitude": "38.21972000",
                        "longitude": "-7.92114000"
                    },
                    {
                        "id": 89176,
                        "name": "Ferreira do Alentejo",
                        "latitude": "38.05000000",
                        "longitude": "-8.03333000"
                    },
                    {
                        "id": 89340,
                        "name": "Mértola",
                        "latitude": "37.65918000",
                        "longitude": "-7.66434000"
                    },
                    {
                        "id": 89299,
                        "name": "Minas de São Domingos",
                        "latitude": "37.67322000",
                        "longitude": "-7.49765000"
                    },
                    {
                        "id": 89335,
                        "name": "Moura",
                        "latitude": "38.14010000",
                        "longitude": "-7.44856000"
                    },
                    {
                        "id": 89346,
                        "name": "Neves",
                        "latitude": "38.02270000",
                        "longitude": "-7.81344000"
                    },
                    {
                        "id": 89352,
                        "name": "Odemira",
                        "latitude": "37.59798000",
                        "longitude": "-8.63972000"
                    },
                    {
                        "id": 89372,
                        "name": "Ourique",
                        "latitude": "37.69156000",
                        "longitude": "-8.31031000"
                    },
                    {
                        "id": 89397,
                        "name": "Penedo Gordo",
                        "latitude": "37.98477000",
                        "longitude": "-7.91651000"
                    },
                    {
                        "id": 89485,
                        "name": "Salvada",
                        "latitude": "37.93771000",
                        "longitude": "-7.77448000"
                    },
                    {
                        "id": 89572,
                        "name": "São Luis",
                        "latitude": "37.71556000",
                        "longitude": "-8.66472000"
                    },
                    {
                        "id": 89590,
                        "name": "São Teotónio",
                        "latitude": "37.51282000",
                        "longitude": "-8.70708000"
                    },
                    {
                        "id": 89533,
                        "name": "Serpa",
                        "latitude": "37.95201000",
                        "longitude": "-7.47534000"
                    },
                    {
                        "id": 89642,
                        "name": "Vidigueira",
                        "latitude": "38.18448000",
                        "longitude": "-7.74469000"
                    },
                    {
                        "id": 89658,
                        "name": "Vila Nova de Milfontes",
                        "latitude": "37.72377000",
                        "longitude": "-8.78278000"
                    },
                    {
                        "id": 89690,
                        "name": "Zambujeira do Mar",
                        "latitude": "37.52799000",
                        "longitude": "-8.78483000"
                    }
                ]
            },
            {
                "id": 2244,
                "name": "Braga",
                "iso2": "03",
                "latitude": "41.55038800",
                "longitude": "-8.42613010",
                "type": "district",
                "cities": [
                    {
                        "id": 88909,
                        "name": "Adaúfe",
                        "latitude": "41.58732000",
                        "longitude": "-8.39817000"
                    },
                    {
                        "id": 88962,
                        "name": "Amares",
                        "latitude": "41.64718000",
                        "longitude": "-8.35558000"
                    },
                    {
                        "id": 88974,
                        "name": "Apúlia",
                        "latitude": "41.48512000",
                        "longitude": "-8.76413000"
                    },
                    {
                        "id": 88975,
                        "name": "Apúlia e Fão",
                        "latitude": "41.51194000",
                        "longitude": "-8.77288000"
                    },
                    {
                        "id": 88979,
                        "name": "Arcos",
                        "latitude": "41.52185000",
                        "longitude": "-8.42151000"
                    },
                    {
                        "id": 88997,
                        "name": "Arões",
                        "latitude": "41.45553000",
                        "longitude": "-8.21419000"
                    },
                    {
                        "id": 89004,
                        "name": "Aveleda",
                        "latitude": "41.52113000",
                        "longitude": "-8.46682000"
                    },
                    {
                        "id": 89018,
                        "name": "Barcelos",
                        "latitude": "41.53174000",
                        "longitude": "-8.61843000"
                    },
                    {
                        "id": 89019,
                        "name": "Barqueiros",
                        "latitude": "41.49111000",
                        "longitude": "-8.73192000"
                    },
                    {
                        "id": 89046,
                        "name": "Braga",
                        "latitude": "41.55032000",
                        "longitude": "-8.42005000"
                    },
                    {
                        "id": 89049,
                        "name": "Brito",
                        "latitude": "41.45821000",
                        "longitude": "-8.36103000"
                    },
                    {
                        "id": 89055,
                        "name": "Cabeceiras de Basto",
                        "latitude": "41.52079000",
                        "longitude": "-7.97198000"
                    },
                    {
                        "id": 89064,
                        "name": "Caldas das Taipas",
                        "latitude": "41.48465000",
                        "longitude": "-8.34850000"
                    },
                    {
                        "id": 89065,
                        "name": "Caldas de Vizela",
                        "latitude": "41.38212000",
                        "longitude": "-8.30890000"
                    },
                    {
                        "id": 89066,
                        "name": "Caldelas",
                        "latitude": "41.67101000",
                        "longitude": "-8.38148000"
                    },
                    {
                        "id": 89067,
                        "name": "Calendário",
                        "latitude": "41.40361000",
                        "longitude": "-8.52967000"
                    },
                    {
                        "id": 89081,
                        "name": "Candoso",
                        "latitude": "41.42768000",
                        "longitude": "-8.32166000"
                    },
                    {
                        "id": 89114,
                        "name": "Celorico de Basto",
                        "latitude": "41.40278000",
                        "longitude": "-8.03346000"
                    },
                    {
                        "id": 89120,
                        "name": "Chavão",
                        "latitude": "41.45235000",
                        "longitude": "-8.60194000"
                    },
                    {
                        "id": 89135,
                        "name": "Cristelo",
                        "latitude": "41.47964000",
                        "longitude": "-8.69785000"
                    },
                    {
                        "id": 89151,
                        "name": "Esporões",
                        "latitude": "41.51006000",
                        "longitude": "-8.41729000"
                    },
                    {
                        "id": 89152,
                        "name": "Esposende",
                        "latitude": "41.53610000",
                        "longitude": "-8.78201000"
                    },
                    {
                        "id": 89160,
                        "name": "Fafe",
                        "latitude": "41.46837000",
                        "longitude": "-8.15863000"
                    },
                    {
                        "id": 89166,
                        "name": "Faria",
                        "latitude": "41.48298000",
                        "longitude": "-8.67152000"
                    },
                    {
                        "id": 89179,
                        "name": "Ferreiros",
                        "latitude": "41.35000000",
                        "longitude": "-8.55000000"
                    },
                    {
                        "id": 89191,
                        "name": "Fradelos",
                        "latitude": "41.36846000",
                        "longitude": "-8.59887000"
                    },
                    {
                        "id": 89196,
                        "name": "Frossos",
                        "latitude": "41.56590000",
                        "longitude": "-8.45134000"
                    },
                    {
                        "id": 89205,
                        "name": "Galegos",
                        "latitude": "41.56268000",
                        "longitude": "-8.57204000"
                    },
                    {
                        "id": 89207,
                        "name": "Gandra",
                        "latitude": "41.52185000",
                        "longitude": "-8.76185000"
                    },
                    {
                        "id": 89212,
                        "name": "Gondizalves",
                        "latitude": "41.54158000",
                        "longitude": "-8.45570000"
                    },
                    {
                        "id": 89216,
                        "name": "Gueral",
                        "latitude": "41.45859000",
                        "longitude": "-8.62946000"
                    },
                    {
                        "id": 89219,
                        "name": "Guimarães",
                        "latitude": "41.44384000",
                        "longitude": "-8.28918000"
                    },
                    {
                        "id": 89220,
                        "name": "Guisande",
                        "latitude": "41.48264000",
                        "longitude": "-8.44564000"
                    },
                    {
                        "id": 89225,
                        "name": "Joane",
                        "latitude": "41.43906000",
                        "longitude": "-8.40846000"
                    },
                    {
                        "id": 89227,
                        "name": "Lago",
                        "latitude": "41.62148000",
                        "longitude": "-8.41258000"
                    },
                    {
                        "id": 89248,
                        "name": "Lordelo",
                        "latitude": "41.37411000",
                        "longitude": "-8.38016000"
                    },
                    {
                        "id": 89264,
                        "name": "Macieira de Rates",
                        "latitude": "41.44092000",
                        "longitude": "-8.63426000"
                    },
                    {
                        "id": 89279,
                        "name": "Marinhas",
                        "latitude": "41.55906000",
                        "longitude": "-8.78297000"
                    },
                    {
                        "id": 89280,
                        "name": "Mariz",
                        "latitude": "41.52823000",
                        "longitude": "-8.67081000"
                    },
                    {
                        "id": 89293,
                        "name": "Merelim",
                        "latitude": "41.58568000",
                        "longitude": "-8.46555000"
                    },
                    {
                        "id": 89330,
                        "name": "Moreira de Conegos",
                        "latitude": "41.38680000",
                        "longitude": "-8.33940000"
                    },
                    {
                        "id": 89343,
                        "name": "Negreiros",
                        "latitude": "41.43552000",
                        "longitude": "-8.61398000"
                    },
                    {
                        "id": 89362,
                        "name": "Oliveira",
                        "latitude": "41.47819000",
                        "longitude": "-8.46965000"
                    },
                    {
                        "id": 89402,
                        "name": "Perelhal",
                        "latitude": "41.53075000",
                        "longitude": "-8.68982000"
                    },
                    {
                        "id": 89415,
                        "name": "Ponte",
                        "latitude": "41.47057000",
                        "longitude": "-8.32990000"
                    },
                    {
                        "id": 89442,
                        "name": "Póvoa de Lanhoso",
                        "latitude": "41.57599000",
                        "longitude": "-8.27008000"
                    },
                    {
                        "id": 89435,
                        "name": "Prado",
                        "latitude": "41.60246000",
                        "longitude": "-8.46297000"
                    },
                    {
                        "id": 89453,
                        "name": "Real",
                        "latitude": "41.55841000",
                        "longitude": "-8.44330000"
                    },
                    {
                        "id": 89458,
                        "name": "Refojos de Basto",
                        "latitude": "41.51318000",
                        "longitude": "-7.99517000"
                    },
                    {
                        "id": 89461,
                        "name": "Rendufe",
                        "latitude": "41.62898000",
                        "longitude": "-8.40858000"
                    },
                    {
                        "id": 89464,
                        "name": "Riba de Ave",
                        "latitude": "41.39648000",
                        "longitude": "-8.38685000"
                    },
                    {
                        "id": 89470,
                        "name": "Ribeirão",
                        "latitude": "41.36081000",
                        "longitude": "-8.56774000"
                    },
                    {
                        "id": 89477,
                        "name": "Ronfe",
                        "latitude": "41.44146000",
                        "longitude": "-8.38412000"
                    },
                    {
                        "id": 89490,
                        "name": "Sande",
                        "latitude": "41.70190000",
                        "longitude": "-8.39246000"
                    },
                    {
                        "id": 89524,
                        "name": "Selho",
                        "latitude": "41.41938000",
                        "longitude": "-8.34599000"
                    },
                    {
                        "id": 89525,
                        "name": "Semelhe",
                        "latitude": "41.55437000",
                        "longitude": "-8.46281000"
                    },
                    {
                        "id": 89536,
                        "name": "Serzedelo",
                        "latitude": "41.40128000",
                        "longitude": "-8.36888000"
                    },
                    {
                        "id": 89537,
                        "name": "Serzedo",
                        "latitude": "41.40502000",
                        "longitude": "-8.22926000"
                    },
                    {
                        "id": 89598,
                        "name": "Tebosa",
                        "latitude": "41.48253000",
                        "longitude": "-8.48399000"
                    },
                    {
                        "id": 89601,
                        "name": "Terras de Bouro",
                        "latitude": "41.73914000",
                        "longitude": "-8.19109000"
                    },
                    {
                        "id": 89618,
                        "name": "Urgeses",
                        "latitude": "41.42720000",
                        "longitude": "-8.29796000"
                    },
                    {
                        "id": 89689,
                        "name": "Várzea",
                        "latitude": "41.51512000",
                        "longitude": "-8.58400000"
                    },
                    {
                        "id": 89644,
                        "name": "Vieira do Minho",
                        "latitude": "41.63557000",
                        "longitude": "-8.13244000"
                    },
                    {
                        "id": 89647,
                        "name": "Vila Cova",
                        "latitude": "41.55107000",
                        "longitude": "-8.71645000"
                    },
                    {
                        "id": 89651,
                        "name": "Vila Frescainha",
                        "latitude": "41.53846000",
                        "longitude": "-8.63971000"
                    },
                    {
                        "id": 89656,
                        "name": "Vila Nova de Famalicão",
                        "latitude": "41.40797000",
                        "longitude": "-8.51978000"
                    },
                    {
                        "id": 89665,
                        "name": "Vila Seca",
                        "latitude": "41.50031000",
                        "longitude": "-8.68525000"
                    },
                    {
                        "id": 89668,
                        "name": "Vila Verde",
                        "latitude": "41.64869000",
                        "longitude": "-8.43628000"
                    },
                    {
                        "id": 89679,
                        "name": "Vilaça",
                        "latitude": "41.51787000",
                        "longitude": "-8.48357000"
                    },
                    {
                        "id": 89676,
                        "name": "Vilar de Figos",
                        "latitude": "41.47555000",
                        "longitude": "-8.65382000"
                    },
                    {
                        "id": 89686,
                        "name": "Vizela",
                        "latitude": "41.37529000",
                        "longitude": "-8.29310000"
                    }
                ]
            },
            {
                "id": 2229,
                "name": "Bragança",
                "iso2": "04",
                "latitude": "41.80616520",
                "longitude": "-6.75674270",
                "type": "district",
                "cities": [
                    {
                        "id": 88934,
                        "name": "Alfândega da Fé",
                        "latitude": "41.34315000",
                        "longitude": "-6.96112000"
                    },
                    {
                        "id": 89030,
                        "name": "Belver",
                        "latitude": "41.24696000",
                        "longitude": "-7.27594000"
                    },
                    {
                        "id": 89047,
                        "name": "Bragança Municipality",
                        "latitude": "41.75608000",
                        "longitude": "-6.75535000"
                    },
                    {
                        "id": 89094,
                        "name": "Carrazeda de Anciães",
                        "latitude": "41.24247000",
                        "longitude": "-7.30721000"
                    },
                    {
                        "id": 89095,
                        "name": "Carrazeda de Ansiães",
                        "latitude": "41.23424000",
                        "longitude": "-7.31129000"
                    },
                    {
                        "id": 89194,
                        "name": "Freixo de Espada à Cinta",
                        "latitude": "41.09033000",
                        "longitude": "-6.80648000"
                    },
                    {
                        "id": 89260,
                        "name": "Macedo de Cavaleiros",
                        "latitude": "41.55132000",
                        "longitude": "-6.93355000"
                    },
                    {
                        "id": 89305,
                        "name": "Miranda do Douro",
                        "latitude": "41.49692000",
                        "longitude": "-6.27308000"
                    },
                    {
                        "id": 89306,
                        "name": "Mirandela",
                        "latitude": "41.50098000",
                        "longitude": "-7.19185000"
                    },
                    {
                        "id": 89307,
                        "name": "Mogadouro",
                        "latitude": "41.34034000",
                        "longitude": "-6.71187000"
                    },
                    {
                        "id": 89487,
                        "name": "Samil",
                        "latitude": "41.77632000",
                        "longitude": "-6.75698000"
                    },
                    {
                        "id": 89526,
                        "name": "Sendim",
                        "latitude": "41.38739000",
                        "longitude": "-6.42625000"
                    },
                    {
                        "id": 89606,
                        "name": "Torre de Moncorvo",
                        "latitude": "41.17454000",
                        "longitude": "-7.05364000"
                    },
                    {
                        "id": 89648,
                        "name": "Vila Flor",
                        "latitude": "41.31429000",
                        "longitude": "-7.15071000"
                    },
                    {
                        "id": 89682,
                        "name": "Vimioso",
                        "latitude": "41.57287000",
                        "longitude": "-6.52087000"
                    },
                    {
                        "id": 89683,
                        "name": "Vinhais",
                        "latitude": "41.83509000",
                        "longitude": "-7.00501000"
                    }
                ]
            },
            {
                "id": 2241,
                "name": "Castelo Branco",
                "iso2": "05",
                "latitude": "39.86313230",
                "longitude": "-7.48141630",
                "type": "district",
                "cities": [
                    {
                        "id": 88926,
                        "name": "Aldeia de Joanes",
                        "latitude": "40.13905000",
                        "longitude": "-7.51694000"
                    },
                    {
                        "id": 89029,
                        "name": "Belmonte",
                        "latitude": "40.36181000",
                        "longitude": "-7.35157000"
                    },
                    {
                        "id": 89104,
                        "name": "Castelo Branco",
                        "latitude": "39.82219000",
                        "longitude": "-7.49087000"
                    },
                    {
                        "id": 89133,
                        "name": "Covilhã",
                        "latitude": "40.28106000",
                        "longitude": "-7.50504000"
                    },
                    {
                        "id": 89198,
                        "name": "Fundão",
                        "latitude": "40.12412000",
                        "longitude": "-7.49542000"
                    },
                    {
                        "id": 89224,
                        "name": "Idanha-A-Nova",
                        "latitude": "39.92957000",
                        "longitude": "-7.23690000"
                    },
                    {
                        "id": 89356,
                        "name": "Oleiros",
                        "latitude": "39.94948000",
                        "longitude": "-7.88592000"
                    },
                    {
                        "id": 89396,
                        "name": "Penamacor",
                        "latitude": "40.15495000",
                        "longitude": "-7.17149000"
                    },
                    {
                        "id": 89440,
                        "name": "Proença-a-Nova",
                        "latitude": "39.75700000",
                        "longitude": "-7.92595000"
                    },
                    {
                        "id": 89535,
                        "name": "Sertã",
                        "latitude": "39.80205000",
                        "longitude": "-8.09589000"
                    },
                    {
                        "id": 89599,
                        "name": "Teixoso",
                        "latitude": "40.31448000",
                        "longitude": "-7.45759000"
                    },
                    {
                        "id": 89670,
                        "name": "Vila de Rei",
                        "latitude": "39.70685000",
                        "longitude": "-8.12836000"
                    },
                    {
                        "id": 89666,
                        "name": "Vila Velha de Ródão",
                        "latitude": "39.68709000",
                        "longitude": "-7.65987000"
                    }
                ]
            },
            {
                "id": 2246,
                "name": "Coimbra",
                "iso2": "06",
                "latitude": "40.20579940",
                "longitude": "-8.41369000",
                "type": "district",
                "cities": [
                    {
                        "id": 88929,
                        "name": "Alfarelos",
                        "latitude": "40.15057000",
                        "longitude": "-8.65326000"
                    },
                    {
                        "id": 88938,
                        "name": "Alhadas",
                        "latitude": "40.18607000",
                        "longitude": "-8.79057000"
                    },
                    {
                        "id": 88972,
                        "name": "Ançã",
                        "latitude": "40.27161000",
                        "longitude": "-8.52090000"
                    },
                    {
                        "id": 88977,
                        "name": "Arazede",
                        "latitude": "40.28627000",
                        "longitude": "-8.64999000"
                    },
                    {
                        "id": 88984,
                        "name": "Arganil",
                        "latitude": "40.21826000",
                        "longitude": "-8.05403000"
                    },
                    {
                        "id": 88998,
                        "name": "Assafarge",
                        "latitude": "40.15895000",
                        "longitude": "-8.43167000"
                    },
                    {
                        "id": 89050,
                        "name": "Buarcos",
                        "latitude": "40.16604000",
                        "longitude": "-8.87680000"
                    },
                    {
                        "id": 89088,
                        "name": "Cantanhede",
                        "latitude": "40.36354000",
                        "longitude": "-8.60549000"
                    },
                    {
                        "id": 89091,
                        "name": "Carapinheira",
                        "latitude": "40.20620000",
                        "longitude": "-8.64810000"
                    },
                    {
                        "id": 89122,
                        "name": "Coimbra",
                        "latitude": "40.20564000",
                        "longitude": "-8.41955000"
                    },
                    {
                        "id": 89126,
                        "name": "Condeixa-a-Nova",
                        "latitude": "40.10639000",
                        "longitude": "-8.49632000"
                    },
                    {
                        "id": 89182,
                        "name": "Figueira da Foz",
                        "latitude": "40.15085000",
                        "longitude": "-8.86179000"
                    },
                    {
                        "id": 89222,
                        "name": "Góis",
                        "latitude": "40.12535000",
                        "longitude": "-8.08340000"
                    },
                    {
                        "id": 89238,
                        "name": "Lavos",
                        "latitude": "40.09363000",
                        "longitude": "-8.82826000"
                    },
                    {
                        "id": 89249,
                        "name": "Lorvão",
                        "latitude": "40.25938000",
                        "longitude": "-8.31683000"
                    },
                    {
                        "id": 89256,
                        "name": "Lousã",
                        "latitude": "40.11673000",
                        "longitude": "-8.24921000"
                    },
                    {
                        "id": 89303,
                        "name": "Mira",
                        "latitude": "40.44559000",
                        "longitude": "-8.73849000"
                    },
                    {
                        "id": 89304,
                        "name": "Miranda do Corvo",
                        "latitude": "40.09318000",
                        "longitude": "-8.33261000"
                    },
                    {
                        "id": 89325,
                        "name": "Montemor-o-Velho",
                        "latitude": "40.19385000",
                        "longitude": "-8.66696000"
                    },
                    {
                        "id": 89368,
                        "name": "Oliveira do Hospital",
                        "latitude": "40.35522000",
                        "longitude": "-7.86481000"
                    },
                    {
                        "id": 89369,
                        "name": "Oliveira do Mondego",
                        "latitude": "40.32305000",
                        "longitude": "-8.22367000"
                    },
                    {
                        "id": 89378,
                        "name": "Pampilhosa da Serra",
                        "latitude": "40.04620000",
                        "longitude": "-7.95182000"
                    },
                    {
                        "id": 89393,
                        "name": "Penacova",
                        "latitude": "40.26884000",
                        "longitude": "-8.28237000"
                    },
                    {
                        "id": 89399,
                        "name": "Penela",
                        "latitude": "40.03333000",
                        "longitude": "-8.38333000"
                    },
                    {
                        "id": 89410,
                        "name": "Poiares",
                        "latitude": "40.21026000",
                        "longitude": "-8.25746000"
                    },
                    {
                        "id": 89497,
                        "name": "Santa Clara",
                        "latitude": "40.19985000",
                        "longitude": "-8.44018000"
                    },
                    {
                        "id": 89516,
                        "name": "Santo António dos Olivais",
                        "latitude": "40.21805000",
                        "longitude": "-8.40523000"
                    },
                    {
                        "id": 89582,
                        "name": "São Pedro de Alva",
                        "latitude": "40.30044000",
                        "longitude": "-8.16623000"
                    },
                    {
                        "id": 89552,
                        "name": "Soure",
                        "latitude": "40.05989000",
                        "longitude": "-8.62605000"
                    },
                    {
                        "id": 89616,
                        "name": "Tábua",
                        "latitude": "40.36207000",
                        "longitude": "-8.02936000"
                    },
                    {
                        "id": 89596,
                        "name": "Tavarede",
                        "latitude": "40.16692000",
                        "longitude": "-8.84568000"
                    },
                    {
                        "id": 89603,
                        "name": "Tocha",
                        "latitude": "40.31308000",
                        "longitude": "-8.75339000"
                    },
                    {
                        "id": 89611,
                        "name": "Travanca",
                        "latitude": "40.32357000",
                        "longitude": "-8.18687000"
                    },
                    {
                        "id": 89660,
                        "name": "Vila Nova de Poiares",
                        "latitude": "40.22129000",
                        "longitude": "-8.24105000"
                    }
                ]
            },
            {
                "id": 2236,
                "name": "Évora",
                "iso2": "07",
                "latitude": "38.57444680",
                "longitude": "-7.90765530",
                "type": "district",
                "cities": [
                    {
                        "id": 88912,
                        "name": "Alandroal",
                        "latitude": "38.62924000",
                        "longitude": "-7.36599000"
                    },
                    {
                        "id": 88990,
                        "name": "Arraiolos",
                        "latitude": "38.76774000",
                        "longitude": "-7.95831000"
                    },
                    {
                        "id": 89043,
                        "name": "Borba",
                        "latitude": "38.80553000",
                        "longitude": "-7.45465000"
                    },
                    {
                        "id": 89157,
                        "name": "Estremoz",
                        "latitude": "38.84996000",
                        "longitude": "-7.60117000"
                    },
                    {
                        "id": 89697,
                        "name": "Évora",
                        "latitude": "38.56667000",
                        "longitude": "-7.90000000"
                    },
                    {
                        "id": 89324,
                        "name": "Montemor-o-Novo",
                        "latitude": "38.67103000",
                        "longitude": "-8.29956000"
                    },
                    {
                        "id": 89328,
                        "name": "Mora",
                        "latitude": "38.92174000",
                        "longitude": "-8.09972000"
                    },
                    {
                        "id": 89336,
                        "name": "Mourão",
                        "latitude": "38.29778000",
                        "longitude": "-7.22230000"
                    },
                    {
                        "id": 89423,
                        "name": "Portel",
                        "latitude": "38.29385000",
                        "longitude": "-7.72762000"
                    },
                    {
                        "id": 89457,
                        "name": "Redondo",
                        "latitude": "38.58010000",
                        "longitude": "-7.59659000"
                    },
                    {
                        "id": 89459,
                        "name": "Reguengos de Monsaraz",
                        "latitude": "38.42529000",
                        "longitude": "-7.53494000"
                    },
                    {
                        "id": 89635,
                        "name": "Vendas Novas",
                        "latitude": "38.63975000",
                        "longitude": "-8.54702000"
                    },
                    {
                        "id": 89639,
                        "name": "Viana do Alentejo",
                        "latitude": "38.33645000",
                        "longitude": "-8.00011000"
                    },
                    {
                        "id": 89669,
                        "name": "Vila Viçosa",
                        "latitude": "38.78790000",
                        "longitude": "-7.41852000"
                    }
                ]
            },
            {
                "id": 2239,
                "name": "Faro",
                "iso2": "08",
                "latitude": "37.01935480",
                "longitude": "-7.93043970",
                "type": "district",
                "cities": [
                    {
                        "id": 88914,
                        "name": "Albufeira",
                        "latitude": "37.08819000",
                        "longitude": "-8.25030000"
                    },
                    {
                        "id": 88919,
                        "name": "Alcantarilha",
                        "latitude": "37.13044000",
                        "longitude": "-8.34623000"
                    },
                    {
                        "id": 88923,
                        "name": "Alcoutim",
                        "latitude": "37.42400000",
                        "longitude": "-7.65456000"
                    },
                    {
                        "id": 88935,
                        "name": "Algoz",
                        "latitude": "37.16301000",
                        "longitude": "-8.30359000"
                    },
                    {
                        "id": 88942,
                        "name": "Aljezur",
                        "latitude": "37.31745000",
                        "longitude": "-8.80147000"
                    },
                    {
                        "id": 88946,
                        "name": "Almancil",
                        "latitude": "37.08686000",
                        "longitude": "-8.03074000"
                    },
                    {
                        "id": 88954,
                        "name": "Altura",
                        "latitude": "37.17560000",
                        "longitude": "-7.50064000"
                    },
                    {
                        "id": 88958,
                        "name": "Alvor",
                        "latitude": "37.12994000",
                        "longitude": "-8.59174000"
                    },
                    {
                        "id": 88988,
                        "name": "Armação de Pêra",
                        "latitude": "37.10256000",
                        "longitude": "-8.35695000"
                    },
                    {
                        "id": 89035,
                        "name": "Bensafrim",
                        "latitude": "37.15583000",
                        "longitude": "-8.73520000"
                    },
                    {
                        "id": 89041,
                        "name": "Boliqueime",
                        "latitude": "37.13718000",
                        "longitude": "-8.15820000"
                    },
                    {
                        "id": 89052,
                        "name": "Cabanas de Tavira",
                        "latitude": "37.13521000",
                        "longitude": "-7.60048000"
                    },
                    {
                        "id": 89100,
                        "name": "Carvoeiro",
                        "latitude": "37.09736000",
                        "longitude": "-8.46846000"
                    },
                    {
                        "id": 89110,
                        "name": "Castro Marim",
                        "latitude": "37.25865000",
                        "longitude": "-7.50732000"
                    },
                    {
                        "id": 89125,
                        "name": "Conceição",
                        "latitude": "37.14789000",
                        "longitude": "-7.60426000"
                    },
                    {
                        "id": 89158,
                        "name": "Estói",
                        "latitude": "37.09503000",
                        "longitude": "-7.89445000"
                    },
                    {
                        "id": 89159,
                        "name": "Estômbar",
                        "latitude": "37.14629000",
                        "longitude": "-8.48505000"
                    },
                    {
                        "id": 89167,
                        "name": "Faro",
                        "latitude": "37.01869000",
                        "longitude": "-7.92716000"
                    },
                    {
                        "id": 89174,
                        "name": "Ferragudo",
                        "latitude": "37.12474000",
                        "longitude": "-8.51915000"
                    },
                    {
                        "id": 89178,
                        "name": "Ferreiras",
                        "latitude": "37.12926000",
                        "longitude": "-8.23759000"
                    },
                    {
                        "id": 89200,
                        "name": "Fuzeta",
                        "latitude": "37.05429000",
                        "longitude": "-7.74699000"
                    },
                    {
                        "id": 89217,
                        "name": "Guia",
                        "latitude": "37.12959000",
                        "longitude": "-8.29963000"
                    },
                    {
                        "id": 89229,
                        "name": "Lagoa",
                        "latitude": "37.10505000",
                        "longitude": "-8.45974000"
                    },
                    {
                        "id": 89230,
                        "name": "Lagos",
                        "latitude": "37.10202000",
                        "longitude": "-8.67422000"
                    },
                    {
                        "id": 89237,
                        "name": "Laranjeiro",
                        "latitude": "37.06799000",
                        "longitude": "-7.80780000"
                    },
                    {
                        "id": 89250,
                        "name": "Loulé",
                        "latitude": "37.14399000",
                        "longitude": "-8.02345000"
                    },
                    {
                        "id": 89259,
                        "name": "Luz",
                        "latitude": "37.09216000",
                        "longitude": "-7.70433000"
                    },
                    {
                        "id": 89273,
                        "name": "Manta Rota",
                        "latitude": "37.16849000",
                        "longitude": "-7.51804000"
                    },
                    {
                        "id": 89281,
                        "name": "Marmelete",
                        "latitude": "37.31014000",
                        "longitude": "-8.66813000"
                    },
                    {
                        "id": 89295,
                        "name": "Mexilhoeira Grande",
                        "latitude": "37.15858000",
                        "longitude": "-8.61487000"
                    },
                    {
                        "id": 89311,
                        "name": "Moncarapacho",
                        "latitude": "37.08360000",
                        "longitude": "-7.78763000"
                    },
                    {
                        "id": 89312,
                        "name": "Monchique",
                        "latitude": "37.31664000",
                        "longitude": "-8.58340000"
                    },
                    {
                        "id": 89321,
                        "name": "Monte Gordo",
                        "latitude": "37.18192000",
                        "longitude": "-7.45225000"
                    },
                    {
                        "id": 89358,
                        "name": "Olhão",
                        "latitude": "37.04509000",
                        "longitude": "-7.81032000"
                    },
                    {
                        "id": 89357,
                        "name": "Olhos de Água",
                        "latitude": "37.09024000",
                        "longitude": "-8.19168000"
                    },
                    {
                        "id": 89375,
                        "name": "Paderne",
                        "latitude": "37.17935000",
                        "longitude": "-8.20150000"
                    },
                    {
                        "id": 89380,
                        "name": "Parchal",
                        "latitude": "37.13827000",
                        "longitude": "-8.51703000"
                    },
                    {
                        "id": 89441,
                        "name": "Pêra",
                        "latitude": "37.12296000",
                        "longitude": "-8.34115000"
                    },
                    {
                        "id": 89421,
                        "name": "Porches",
                        "latitude": "37.12665000",
                        "longitude": "-8.40162000"
                    },
                    {
                        "id": 89424,
                        "name": "Portimão",
                        "latitude": "37.17544000",
                        "longitude": "-8.58420000"
                    },
                    {
                        "id": 89446,
                        "name": "Quarteira",
                        "latitude": "37.06946000",
                        "longitude": "-8.10064000"
                    },
                    {
                        "id": 89482,
                        "name": "Sagres",
                        "latitude": "37.00864000",
                        "longitude": "-8.94311000"
                    },
                    {
                        "id": 89495,
                        "name": "Santa Bárbara de Nexe",
                        "latitude": "37.10619000",
                        "longitude": "-7.96648000"
                    },
                    {
                        "id": 89505,
                        "name": "Santa Luzia",
                        "latitude": "37.10224000",
                        "longitude": "-7.66202000"
                    },
                    {
                        "id": 89559,
                        "name": "São Bartolomeu de Messines",
                        "latitude": "37.25648000",
                        "longitude": "-8.28672000"
                    },
                    {
                        "id": 89560,
                        "name": "São Brás de Alportel",
                        "latitude": "37.19564000",
                        "longitude": "-7.87546000"
                    },
                    {
                        "id": 89574,
                        "name": "São Marcos da Serra",
                        "latitude": "37.36100000",
                        "longitude": "-8.37764000"
                    },
                    {
                        "id": 89528,
                        "name": "Senhora da Luz",
                        "latitude": "37.08771000",
                        "longitude": "-8.72649000"
                    },
                    {
                        "id": 89544,
                        "name": "Silves",
                        "latitude": "37.20343000",
                        "longitude": "-8.33472000"
                    },
                    {
                        "id": 89597,
                        "name": "Tavira",
                        "latitude": "37.12734000",
                        "longitude": "-7.64861000"
                    },
                    {
                        "id": 89614,
                        "name": "Tunes",
                        "latitude": "37.16592000",
                        "longitude": "-8.25919000"
                    },
                    {
                        "id": 89671,
                        "name": "Vila do Bispo",
                        "latitude": "37.08317000",
                        "longitude": "-8.91144000"
                    },
                    {
                        "id": 89653,
                        "name": "Vila Nova De Cacela",
                        "latitude": "37.17391000",
                        "longitude": "-7.53169000"
                    },
                    {
                        "id": 89664,
                        "name": "Vila Real de Santo António",
                        "latitude": "37.19232000",
                        "longitude": "-7.42538000"
                    },
                    {
                        "id": 89674,
                        "name": "Vilamoura",
                        "latitude": "37.08728000",
                        "longitude": "-8.11701000"
                    }
                ]
            },
            {
                "id": 4859,
                "name": "Guarda",
                "iso2": "09",
                "latitude": "40.53859720",
                "longitude": "-7.26757720",
                "type": "district",
                "cities": [
                    {
                        "id": 143297,
                        "name": "Açores",
                        "latitude": "40.64500000",
                        "longitude": "-7.30527778"
                    },
                    {
                        "id": 143238,
                        "name": "Adão",
                        "latitude": "40.45916667",
                        "longitude": "-7.16500000"
                    },
                    {
                        "id": 143239,
                        "name": "Agualva",
                        "latitude": "38.77004444",
                        "longitude": "-9.29881111"
                    },
                    {
                        "id": 143760,
                        "name": "Águas Belas",
                        "latitude": "40.37472222",
                        "longitude": "-7.16694444"
                    },
                    {
                        "id": 143240,
                        "name": "Aguiar da Beira",
                        "latitude": "40.81726000",
                        "longitude": "-7.54431000"
                    },
                    {
                        "id": 143241,
                        "name": "Ajuda",
                        "latitude": "38.70750000",
                        "longitude": "-9.19833333"
                    },
                    {
                        "id": 143242,
                        "name": "Albardo",
                        "latitude": "40.51145000",
                        "longitude": "-7.13028000"
                    },
                    {
                        "id": 143243,
                        "name": "Alcabideche",
                        "latitude": "38.73361111",
                        "longitude": "-9.40916667"
                    },
                    {
                        "id": 143244,
                        "name": "Alcains",
                        "latitude": "39.91540278",
                        "longitude": "-7.46107778"
                    },
                    {
                        "id": 143246,
                        "name": "Alcântara",
                        "latitude": "38.70638889",
                        "longitude": "-9.17416667"
                    },
                    {
                        "id": 143245,
                        "name": "Alcoentre",
                        "latitude": "39.20861111",
                        "longitude": "-8.95944444"
                    },
                    {
                        "id": 143252,
                        "name": "Aldeia da Ponte",
                        "latitude": "40.41348889",
                        "longitude": "-6.86908333"
                    },
                    {
                        "id": 143253,
                        "name": "Aldeia da Ribeira",
                        "latitude": "40.45666667",
                        "longitude": "-6.89777778"
                    },
                    {
                        "id": 143254,
                        "name": "Aldeia de Santo António",
                        "latitude": "40.34305556",
                        "longitude": "-7.13638889"
                    },
                    {
                        "id": 143255,
                        "name": "Aldeia do Bispo",
                        "latitude": "40.32333333",
                        "longitude": "-6.84805556"
                    },
                    {
                        "id": 143247,
                        "name": "Aldeia Galega da Merceana",
                        "latitude": "39.08222222",
                        "longitude": "-9.11194444"
                    },
                    {
                        "id": 143248,
                        "name": "Aldeia Gavinha",
                        "latitude": "39.08444444",
                        "longitude": "-9.09638889"
                    },
                    {
                        "id": 143249,
                        "name": "Aldeia Nova Miranda do Douro",
                        "latitude": "40.72584000",
                        "longitude": "-7.42384000"
                    },
                    {
                        "id": 143250,
                        "name": "Aldeia Velha",
                        "latitude": "40.34333333",
                        "longitude": "-6.86750000"
                    },
                    {
                        "id": 143251,
                        "name": "Aldeia Viçosa",
                        "latitude": "40.57888889",
                        "longitude": "-7.31777778"
                    },
                    {
                        "id": 143256,
                        "name": "Aldeias",
                        "latitude": "40.46861111",
                        "longitude": "-7.59805556"
                    },
                    {
                        "id": 143257,
                        "name": "Alenquer",
                        "latitude": "39.05000000",
                        "longitude": "-9.01666667"
                    },
                    {
                        "id": 143258,
                        "name": "Alfaiates",
                        "latitude": "40.39111111",
                        "longitude": "-6.91333333"
                    },
                    {
                        "id": 143259,
                        "name": "Alfornelos",
                        "latitude": "38.76333333",
                        "longitude": "-9.20638889"
                    },
                    {
                        "id": 143260,
                        "name": "Alfragide",
                        "latitude": "38.73203000",
                        "longitude": "-9.21920000"
                    },
                    {
                        "id": 143265,
                        "name": "Algés",
                        "latitude": "38.69949722",
                        "longitude": "-9.22927222"
                    },
                    {
                        "id": 143261,
                        "name": "Algodres",
                        "latitude": "40.95250000",
                        "longitude": "-7.05472222"
                    },
                    {
                        "id": 143262,
                        "name": "Alguber",
                        "latitude": "39.27583333",
                        "longitude": "-9.01888889"
                    },
                    {
                        "id": 143263,
                        "name": "Algueirão",
                        "latitude": "38.79764000",
                        "longitude": "-9.34370000"
                    },
                    {
                        "id": 143264,
                        "name": "Algueirão–Mem Martins",
                        "latitude": "38.79411389",
                        "longitude": "-9.34510833"
                    },
                    {
                        "id": 143266,
                        "name": "Alhandra",
                        "latitude": "38.92732000",
                        "longitude": "-9.00864000"
                    },
                    {
                        "id": 143267,
                        "name": "Almargem",
                        "latitude": "38.84472222",
                        "longitude": "-9.27305556"
                    },
                    {
                        "id": 143268,
                        "name": "Almargem do Bispo",
                        "latitude": "38.84750000",
                        "longitude": "-9.27138889"
                    },
                    {
                        "id": 143269,
                        "name": "Almeida",
                        "latitude": "40.73070000",
                        "longitude": "-6.90594000"
                    },
                    {
                        "id": 143270,
                        "name": "Almendra",
                        "latitude": "40.99284444",
                        "longitude": "-7.05756944"
                    },
                    {
                        "id": 143271,
                        "name": "Almofala",
                        "latitude": "40.86027778",
                        "longitude": "-6.84861111"
                    },
                    {
                        "id": 143272,
                        "name": "Alto do Pina",
                        "latitude": "38.74027778",
                        "longitude": "-9.12805556"
                    },
                    {
                        "id": 143273,
                        "name": "Alvalade",
                        "latitude": "38.74694444",
                        "longitude": "-9.13611111"
                    },
                    {
                        "id": 143274,
                        "name": "Alvendre",
                        "latitude": "40.58500000",
                        "longitude": "-7.25833333"
                    },
                    {
                        "id": 143275,
                        "name": "Alverca da Beira",
                        "latitude": "40.70055556",
                        "longitude": "-7.21750000"
                    },
                    {
                        "id": 143276,
                        "name": "Alverca do Ribatejo",
                        "latitude": "38.89866111",
                        "longitude": "-9.03947778"
                    },
                    {
                        "id": 143277,
                        "name": "Alvoco da Serra",
                        "latitude": "40.29555556",
                        "longitude": "-7.67027778"
                    },
                    {
                        "id": 143278,
                        "name": "Amadora",
                        "latitude": "38.75000000",
                        "longitude": "-9.23333333"
                    },
                    {
                        "id": 143279,
                        "name": "Ameixoeira",
                        "latitude": "38.78777778",
                        "longitude": "-9.15250000"
                    },
                    {
                        "id": 143280,
                        "name": "Amoreira",
                        "latitude": "40.58805556",
                        "longitude": "-7.01555556"
                    },
                    {
                        "id": 143281,
                        "name": "Anjos",
                        "latitude": "38.72388889",
                        "longitude": "-9.13638889"
                    },
                    {
                        "id": 143282,
                        "name": "Apelação",
                        "latitude": "38.81500000",
                        "longitude": "-9.13249000"
                    },
                    {
                        "id": 143283,
                        "name": "Arcozelo",
                        "latitude": "40.54055556",
                        "longitude": "-7.62722222"
                    },
                    {
                        "id": 143284,
                        "name": "Arranhó",
                        "latitude": "38.95371667",
                        "longitude": "-9.13497778"
                    },
                    {
                        "id": 143285,
                        "name": "Arrifana",
                        "latitude": "40.56972222",
                        "longitude": "-7.21027778"
                    },
                    {
                        "id": 143286,
                        "name": "Arruda Dos Vinhos",
                        "latitude": "38.97172000",
                        "longitude": "-9.08807000"
                    },
                    {
                        "id": 143287,
                        "name": "Atalaia",
                        "latitude": "40.66000000",
                        "longitude": "-7.03305556"
                    },
                    {
                        "id": 143288,
                        "name": "Aveiras de Baixo",
                        "latitude": "39.11138889",
                        "longitude": "-8.86916667"
                    },
                    {
                        "id": 143289,
                        "name": "Aveiras de Cima",
                        "latitude": "39.13769444",
                        "longitude": "-8.89995556"
                    },
                    {
                        "id": 143291,
                        "name": "Avelãs da Ribeira",
                        "latitude": "40.67773000",
                        "longitude": "-7.21492000"
                    },
                    {
                        "id": 143290,
                        "name": "Aveloso",
                        "latitude": "40.93111111",
                        "longitude": "-7.31666667"
                    },
                    {
                        "id": 143292,
                        "name": "Azambuja",
                        "latitude": "39.06666667",
                        "longitude": "-8.86666667"
                    },
                    {
                        "id": 143293,
                        "name": "Azambuja (town)",
                        "latitude": "39.07027778",
                        "longitude": "-8.86833333"
                    },
                    {
                        "id": 143294,
                        "name": "Azenhas do Mar",
                        "latitude": "38.84055556",
                        "longitude": "-9.46000000"
                    },
                    {
                        "id": 143295,
                        "name": "Azevo",
                        "latitude": "40.85166667",
                        "longitude": "-7.13138889"
                    },
                    {
                        "id": 143296,
                        "name": "Azueira",
                        "latitude": "39.00653000",
                        "longitude": "-9.27475000"
                    },
                    {
                        "id": 143298,
                        "name": "Baraçal",
                        "latitude": "40.39357000",
                        "longitude": "-7.08522000"
                    },
                    {
                        "id": 143299,
                        "name": "Barcarena",
                        "latitude": "38.73250000",
                        "longitude": "-9.28000000"
                    },
                    {
                        "id": 143300,
                        "name": "Barreira",
                        "latitude": "40.91111111",
                        "longitude": "-7.18638889"
                    },
                    {
                        "id": 143301,
                        "name": "Beato",
                        "latitude": "38.73472222",
                        "longitude": "-9.10583333"
                    },
                    {
                        "id": 143302,
                        "name": "Belas",
                        "latitude": "38.76666667",
                        "longitude": "-9.26666667"
                    },
                    {
                        "id": 143303,
                        "name": "Bendada",
                        "latitude": "40.37083333",
                        "longitude": "-7.25472222"
                    },
                    {
                        "id": 143304,
                        "name": "Benespera",
                        "latitude": "40.44027778",
                        "longitude": "-7.27638889"
                    },
                    {
                        "id": 143305,
                        "name": "Benfica",
                        "latitude": "38.75111111",
                        "longitude": "-9.20222222"
                    },
                    {
                        "id": 143306,
                        "name": "Bismula",
                        "latitude": "40.44694444",
                        "longitude": "-6.96444444"
                    },
                    {
                        "id": 143307,
                        "name": "Bobadela",
                        "latitude": "38.80663000",
                        "longitude": "-9.09731000"
                    },
                    {
                        "id": 143308,
                        "name": "Bouça Cova",
                        "latitude": "40.70464000",
                        "longitude": "-7.23830000"
                    },
                    {
                        "id": 143309,
                        "name": "Brandoa",
                        "latitude": "38.76611111",
                        "longitude": "-9.21444444"
                    },
                    {
                        "id": 143310,
                        "name": "Bucelas",
                        "latitude": "38.90000000",
                        "longitude": "-9.11666667"
                    },
                    {
                        "id": 143311,
                        "name": "Buraca",
                        "latitude": "38.74222222",
                        "longitude": "-9.20944444"
                    },
                    {
                        "id": 143312,
                        "name": "Cabanas de Torres",
                        "latitude": "39.15631000",
                        "longitude": "-9.06328000"
                    },
                    {
                        "id": 143313,
                        "name": "Cabeça",
                        "latitude": "40.31916667",
                        "longitude": "-7.73527778"
                    },
                    {
                        "id": 143314,
                        "name": "Cacem",
                        "latitude": "38.77042000",
                        "longitude": "-9.30809000"
                    },
                    {
                        "id": 143315,
                        "name": "Cachoeiras",
                        "latitude": "38.98583333",
                        "longitude": "-9.01638889"
                    },
                    {
                        "id": 143316,
                        "name": "Cadafais",
                        "latitude": "39.00444444",
                        "longitude": "-9.00416667"
                    },
                    {
                        "id": 143317,
                        "name": "Cadafaz",
                        "latitude": "40.58472222",
                        "longitude": "-7.36194444"
                    },
                    {
                        "id": 143318,
                        "name": "Cadaval",
                        "latitude": "39.24621000",
                        "longitude": "-9.06738000"
                    },
                    {
                        "id": 143319,
                        "name": "Calhandriz",
                        "latitude": "38.92500000",
                        "longitude": "-9.06777778"
                    },
                    {
                        "id": 143320,
                        "name": "Camarate",
                        "latitude": "38.80358000",
                        "longitude": "-9.12809000"
                    },
                    {
                        "id": 143321,
                        "name": "Campelos",
                        "latitude": "39.20000000",
                        "longitude": "-9.23333333"
                    },
                    {
                        "id": 143322,
                        "name": "Campo Grande",
                        "latitude": "38.75694444",
                        "longitude": "-9.15361111"
                    },
                    {
                        "id": 143323,
                        "name": "Campolide",
                        "latitude": "38.72638889",
                        "longitude": "-9.16333333"
                    },
                    {
                        "id": 143324,
                        "name": "Caneças",
                        "latitude": "38.81666667",
                        "longitude": "-9.23333333"
                    },
                    {
                        "id": 143325,
                        "name": "Carapito",
                        "latitude": "40.76759000",
                        "longitude": "-7.45447000"
                    },
                    {
                        "id": 143326,
                        "name": "Carcavelos",
                        "latitude": "38.69220000",
                        "longitude": "-9.33327000"
                    },
                    {
                        "id": 143327,
                        "name": "Cardosas",
                        "latitude": "38.97722222",
                        "longitude": "-9.04083333"
                    },
                    {
                        "id": 143328,
                        "name": "Carmões",
                        "latitude": "39.05777778",
                        "longitude": "-9.13416667"
                    },
                    {
                        "id": 143329,
                        "name": "Carnaxide",
                        "latitude": "38.72666667",
                        "longitude": "-9.24166667"
                    },
                    {
                        "id": 143330,
                        "name": "Carnicães",
                        "latitude": "40.73333333",
                        "longitude": "-7.31833333"
                    },
                    {
                        "id": 143331,
                        "name": "Carnide",
                        "latitude": "38.76083333",
                        "longitude": "-9.18361111"
                    },
                    {
                        "id": 143332,
                        "name": "Carnota",
                        "latitude": "39.03361111",
                        "longitude": "-9.07166667"
                    },
                    {
                        "id": 143333,
                        "name": "Carragozela",
                        "latitude": "40.40572000",
                        "longitude": "-7.76077000"
                    },
                    {
                        "id": 143334,
                        "name": "Carrapichana",
                        "latitude": "40.56194444",
                        "longitude": "-7.48694444"
                    },
                    {
                        "id": 143335,
                        "name": "Carregado",
                        "latitude": "39.02334000",
                        "longitude": "-8.96450000"
                    },
                    {
                        "id": 143336,
                        "name": "Carvalhal",
                        "latitude": "40.88361111",
                        "longitude": "-7.28361111"
                    },
                    {
                        "id": 143337,
                        "name": "Carvoeira",
                        "latitude": "39.08055556",
                        "longitude": "-9.16222222"
                    },
                    {
                        "id": 143339,
                        "name": "Casal de Cambra",
                        "latitude": "38.80236000",
                        "longitude": "-9.23188000"
                    },
                    {
                        "id": 143340,
                        "name": "Casal de Cinza",
                        "latitude": "40.54416667",
                        "longitude": "-7.16416667"
                    },
                    {
                        "id": 143338,
                        "name": "Casal Vasco",
                        "latitude": "40.63792000",
                        "longitude": "-7.55538000"
                    },
                    {
                        "id": 143341,
                        "name": "Casas do Soeiro",
                        "latitude": "40.61888889",
                        "longitude": "-7.40638889"
                    },
                    {
                        "id": 143342,
                        "name": "Cascais",
                        "latitude": "38.69681000",
                        "longitude": "-9.42147000"
                    },
                    {
                        "id": 143343,
                        "name": "Castanheira",
                        "latitude": "40.57472222",
                        "longitude": "-7.07944444"
                    },
                    {
                        "id": 143344,
                        "name": "Castanheira do Ribatejo",
                        "latitude": "38.98333333",
                        "longitude": "-8.96666667"
                    },
                    {
                        "id": 143345,
                        "name": "Casteição",
                        "latitude": "40.88083333",
                        "longitude": "-7.32583333"
                    },
                    {
                        "id": 143346,
                        "name": "Casteleiro",
                        "latitude": "40.30222222",
                        "longitude": "-7.23166667"
                    },
                    {
                        "id": 143347,
                        "name": "Castelo (Lisbon)",
                        "latitude": "38.71361111",
                        "longitude": "-9.13333333"
                    },
                    {
                        "id": 143348,
                        "name": "Castelo Bom",
                        "latitude": "40.62027778",
                        "longitude": "-6.90055556"
                    },
                    {
                        "id": 143349,
                        "name": "Castelo Melhor",
                        "latitude": "41.02750000",
                        "longitude": "-7.06500000"
                    },
                    {
                        "id": 143350,
                        "name": "Castelo Rodrigo",
                        "latitude": "40.87555556",
                        "longitude": "-6.96388889"
                    },
                    {
                        "id": 143351,
                        "name": "Cativelos",
                        "latitude": "40.53083333",
                        "longitude": "-7.68194444"
                    },
                    {
                        "id": 143352,
                        "name": "Cavadoude",
                        "latitude": "40.58472222",
                        "longitude": "-7.28666667"
                    },
                    {
                        "id": 143353,
                        "name": "Caxias",
                        "latitude": "38.70000000",
                        "longitude": "-9.28333333"
                    },
                    {
                        "id": 143354,
                        "name": "Cedovim",
                        "latitude": "41.03333333",
                        "longitude": "-7.31666667"
                    },
                    {
                        "id": 143355,
                        "name": "Celorico da Beira",
                        "latitude": "40.63333333",
                        "longitude": "-7.40000000"
                    },
                    {
                        "id": 143356,
                        "name": "Cercal",
                        "latitude": "39.23388889",
                        "longitude": "-8.99833333"
                    },
                    {
                        "id": 143357,
                        "name": "Cerdeira",
                        "latitude": "40.51416667",
                        "longitude": "-7.04666667"
                    },
                    {
                        "id": 143358,
                        "name": "Cerejo",
                        "latitude": "40.72944444",
                        "longitude": "-7.22361111"
                    },
                    {
                        "id": 143359,
                        "name": "Charneca",
                        "latitude": "38.78527778",
                        "longitude": "-9.14500000"
                    },
                    {
                        "id": 143361,
                        "name": "Chãs",
                        "latitude": "40.98972222",
                        "longitude": "-7.17027778"
                    },
                    {
                        "id": 143360,
                        "name": "Cheleiros",
                        "latitude": "38.88972222",
                        "longitude": "-9.32888889"
                    },
                    {
                        "id": 143362,
                        "name": "Codesseiro",
                        "latitude": "40.65111111",
                        "longitude": "-7.20500000"
                    },
                    {
                        "id": 143363,
                        "name": "Cogula",
                        "latitude": "40.81277778",
                        "longitude": "-7.26138889"
                    },
                    {
                        "id": 143364,
                        "name": "Colares",
                        "latitude": "38.80206000",
                        "longitude": "-9.46305000"
                    },
                    {
                        "id": 143365,
                        "name": "Coração de Jesus",
                        "latitude": "38.72416667",
                        "longitude": "-9.14500000"
                    },
                    {
                        "id": 143366,
                        "name": "Coriscada",
                        "latitude": "40.86197000",
                        "longitude": "-7.20372000"
                    },
                    {
                        "id": 143367,
                        "name": "Cortiçada",
                        "latitude": "40.76500000",
                        "longitude": "-7.54222222"
                    },
                    {
                        "id": 143368,
                        "name": "Cortiçô",
                        "latitude": "40.66305556",
                        "longitude": "-7.49472222"
                    },
                    {
                        "id": 143369,
                        "name": "Cortiçô da Serra",
                        "latitude": "40.60124000",
                        "longitude": "-7.43426000"
                    },
                    {
                        "id": 143370,
                        "name": "Coruche",
                        "latitude": "40.79361111",
                        "longitude": "-7.54083333"
                    },
                    {
                        "id": 143371,
                        "name": "Corujeira",
                        "latitude": "40.50609000",
                        "longitude": "-7.32803000"
                    },
                    {
                        "id": 143374,
                        "name": "Cótimos",
                        "latitude": "40.82750000",
                        "longitude": "-7.23972222"
                    },
                    {
                        "id": 143372,
                        "name": "Cruz Quebrada - Dafundo",
                        "latitude": "38.70611111",
                        "longitude": "-9.25055556"
                    },
                    {
                        "id": 143373,
                        "name": "Custoias",
                        "latitude": "41.10527778",
                        "longitude": "-7.32083333"
                    },
                    {
                        "id": 143375,
                        "name": "Damaia",
                        "latitude": "38.74527778",
                        "longitude": "-9.21833333"
                    },
                    {
                        "id": 143376,
                        "name": "Dois Portos",
                        "latitude": "39.03840000",
                        "longitude": "-9.18556000"
                    },
                    {
                        "id": 143377,
                        "name": "Dornelas",
                        "latitude": "40.73105000",
                        "longitude": "-7.55894000"
                    },
                    {
                        "id": 143378,
                        "name": "Eirado",
                        "latitude": "40.77333333",
                        "longitude": "-7.49000000"
                    },
                    {
                        "id": 143379,
                        "name": "Encarnação",
                        "latitude": "39.03333333",
                        "longitude": "-9.36805556"
                    },
                    {
                        "id": 143380,
                        "name": "Enxara do Bispo",
                        "latitude": "38.99194444",
                        "longitude": "-9.24083333"
                    },
                    {
                        "id": 143381,
                        "name": "Ericeira",
                        "latitude": "38.96277778",
                        "longitude": "-9.41527778"
                    },
                    {
                        "id": 143382,
                        "name": "Ervas Tenras",
                        "latitude": "40.74055556",
                        "longitude": "-7.18611111"
                    },
                    {
                        "id": 143383,
                        "name": "Ervedosa",
                        "latitude": "40.84694444",
                        "longitude": "-7.17611111"
                    },
                    {
                        "id": 143384,
                        "name": "Escalhão",
                        "latitude": "40.94944444",
                        "longitude": "-6.92611111"
                    },
                    {
                        "id": 143385,
                        "name": "Estoril",
                        "latitude": "38.70571000",
                        "longitude": "-9.39773000"
                    },
                    {
                        "id": 143386,
                        "name": "Faia",
                        "latitude": "40.56055556",
                        "longitude": "-7.31027778"
                    },
                    {
                        "id": 143387,
                        "name": "Falagueira",
                        "latitude": "38.75903000",
                        "longitude": "-9.21988000"
                    },
                    {
                        "id": 143388,
                        "name": "Famalicão",
                        "latitude": "40.44361111",
                        "longitude": "-7.37722222"
                    },
                    {
                        "id": 143389,
                        "name": "Famões",
                        "latitude": "38.78333333",
                        "longitude": "-9.21666667"
                    },
                    {
                        "id": 143390,
                        "name": "Fanhões",
                        "latitude": "38.88111111",
                        "longitude": "-9.15250000"
                    },
                    {
                        "id": 143391,
                        "name": "Fernão Joanes",
                        "latitude": "40.48694444",
                        "longitude": "-7.35527778"
                    },
                    {
                        "id": 143397,
                        "name": "Fiães",
                        "latitude": "40.73305556",
                        "longitude": "-7.37305556"
                    },
                    {
                        "id": 143392,
                        "name": "Figueira de Castelo Rodrigo",
                        "latitude": "40.90000000",
                        "longitude": "-6.96666667"
                    },
                    {
                        "id": 143393,
                        "name": "Figueira do Guincho",
                        "latitude": "38.75000000",
                        "longitude": "-9.46666667"
                    },
                    {
                        "id": 143395,
                        "name": "Figueiró da Granja",
                        "latitude": "40.62805556",
                        "longitude": "-7.49916667"
                    },
                    {
                        "id": 143396,
                        "name": "Figueiró da Serra",
                        "latitude": "40.54055556",
                        "longitude": "-7.48888889"
                    },
                    {
                        "id": 143394,
                        "name": "Figueiros",
                        "latitude": "39.27946000",
                        "longitude": "-9.05083000"
                    },
                    {
                        "id": 143414,
                        "name": "Fóios",
                        "latitude": "40.28666667",
                        "longitude": "-6.89250000"
                    },
                    {
                        "id": 143398,
                        "name": "Folgosinho",
                        "latitude": "40.50944444",
                        "longitude": "-7.51388889"
                    },
                    {
                        "id": 143399,
                        "name": "Folhadosa",
                        "latitude": "40.37944444",
                        "longitude": "-7.78472222"
                    },
                    {
                        "id": 143400,
                        "name": "Fontanelas",
                        "latitude": "38.85000000",
                        "longitude": "-9.43333333"
                    },
                    {
                        "id": 143401,
                        "name": "Fonte Longa",
                        "latitude": "41.01305556",
                        "longitude": "-7.23361111"
                    },
                    {
                        "id": 143402,
                        "name": "Forninhos",
                        "latitude": "40.70472222",
                        "longitude": "-7.55416667"
                    },
                    {
                        "id": 143403,
                        "name": "Forno Telheiro",
                        "latitude": "40.67333333",
                        "longitude": "-7.39777778"
                    },
                    {
                        "id": 143404,
                        "name": "Fornos de Algodres",
                        "latitude": "40.61666667",
                        "longitude": "-7.53333333"
                    },
                    {
                        "id": 143405,
                        "name": "Forte da Casa",
                        "latitude": "38.87391000",
                        "longitude": "-9.05216000"
                    },
                    {
                        "id": 143406,
                        "name": "Freches",
                        "latitude": "40.73166667",
                        "longitude": "-7.34638889"
                    },
                    {
                        "id": 143407,
                        "name": "Freineda",
                        "latitude": "40.58305556",
                        "longitude": "-6.89111111"
                    },
                    {
                        "id": 143408,
                        "name": "Freiria",
                        "latitude": "39.02739000",
                        "longitude": "-9.31995000"
                    },
                    {
                        "id": 143409,
                        "name": "Freixeda do Torrão",
                        "latitude": "40.89027778",
                        "longitude": "-7.03222222"
                    },
                    {
                        "id": 143410,
                        "name": "Freixedas",
                        "latitude": "40.69194444",
                        "longitude": "-7.16305556"
                    },
                    {
                        "id": 143411,
                        "name": "Freixo",
                        "latitude": "40.61861111",
                        "longitude": "-7.01027778"
                    },
                    {
                        "id": 143412,
                        "name": "Freixo de Numão",
                        "latitude": "41.06666667",
                        "longitude": "-7.21666667"
                    },
                    {
                        "id": 143413,
                        "name": "Frielas",
                        "latitude": "38.82583333",
                        "longitude": "-9.14444444"
                    },
                    {
                        "id": 143415,
                        "name": "Gagos",
                        "latitude": "40.58388889",
                        "longitude": "-7.11472222"
                    },
                    {
                        "id": 143416,
                        "name": "Girabolhos",
                        "latitude": "40.50944444",
                        "longitude": "-7.73666667"
                    },
                    {
                        "id": 143417,
                        "name": "Gonçalo",
                        "latitude": "40.41666667",
                        "longitude": "-7.35000000"
                    },
                    {
                        "id": 143418,
                        "name": "Gonçalo Bocas",
                        "latitude": "40.57666667",
                        "longitude": "-7.17750000"
                    },
                    {
                        "id": 143419,
                        "name": "Gouveia",
                        "latitude": "40.50000000",
                        "longitude": "-7.60000000"
                    },
                    {
                        "id": 143423,
                        "name": "Graça",
                        "latitude": "38.71722222",
                        "longitude": "-9.13083333"
                    },
                    {
                        "id": 143420,
                        "name": "Gradil",
                        "latitude": "38.98222222",
                        "longitude": "-9.28083333"
                    },
                    {
                        "id": 143421,
                        "name": "Gradiz",
                        "latitude": "40.85944444",
                        "longitude": "-7.52861111"
                    },
                    {
                        "id": 143422,
                        "name": "Granja",
                        "latitude": "40.75201000",
                        "longitude": "-7.20428000"
                    },
                    {
                        "id": 143424,
                        "name": "Guarda",
                        "latitude": "40.53638889",
                        "longitude": "-7.26833333"
                    },
                    {
                        "id": 143425,
                        "name": "Guilheiro",
                        "latitude": "40.89805556",
                        "longitude": "-7.40972222"
                    },
                    {
                        "id": 143426,
                        "name": "Horta",
                        "latitude": "41.06777778",
                        "longitude": "-7.31055556"
                    },
                    {
                        "id": 143427,
                        "name": "Igreja Nova",
                        "latitude": "38.91694444",
                        "longitude": "-9.31944444"
                    },
                    {
                        "id": 143428,
                        "name": "Infias",
                        "latitude": "40.63000000",
                        "longitude": "-7.53944444"
                    },
                    {
                        "id": 143429,
                        "name": "Jarmelo São Miguel",
                        "latitude": "40.60040000",
                        "longitude": "-7.14915000"
                    },
                    {
                        "id": 143430,
                        "name": "Jarmelo São Pedro",
                        "latitude": "40.59447000",
                        "longitude": "-7.13016000"
                    },
                    {
                        "id": 143431,
                        "name": "João Antão",
                        "latitude": "40.46443000",
                        "longitude": "-7.23940000"
                    },
                    {
                        "id": 143433,
                        "name": "Junça",
                        "latitude": "40.68138889",
                        "longitude": "-6.88555556"
                    },
                    {
                        "id": 143432,
                        "name": "Juncais",
                        "latitude": "40.60944444",
                        "longitude": "-7.50750000"
                    },
                    {
                        "id": 143434,
                        "name": "Lagarinhos",
                        "latitude": "40.48583333",
                        "longitude": "-7.66944444"
                    },
                    {
                        "id": 143435,
                        "name": "Lajeosa",
                        "latitude": "40.34353000",
                        "longitude": "-6.81621000"
                    },
                    {
                        "id": 143436,
                        "name": "Lajeosa do Mondego",
                        "latitude": "40.62750000",
                        "longitude": "-7.33750000"
                    },
                    {
                        "id": 143437,
                        "name": "Lajes",
                        "latitude": "40.48361111",
                        "longitude": "-7.71638889"
                    },
                    {
                        "id": 143438,
                        "name": "Lamas",
                        "latitude": "39.21114000",
                        "longitude": "-9.06151000"
                    },
                    {
                        "id": 143439,
                        "name": "Lamegal",
                        "latitude": "40.66500000",
                        "longitude": "-7.07972222"
                    },
                    {
                        "id": 143440,
                        "name": "Lameiras",
                        "latitude": "40.71138889",
                        "longitude": "-7.10444444"
                    },
                    {
                        "id": 143441,
                        "name": "Lapa",
                        "latitude": "38.71189000",
                        "longitude": "-9.16007000"
                    },
                    {
                        "id": 143442,
                        "name": "Lapa Dos Dinheiros",
                        "latitude": "40.37888889",
                        "longitude": "-7.70944444"
                    },
                    {
                        "id": 143443,
                        "name": "Leomil",
                        "latitude": "40.63527778",
                        "longitude": "-6.96416667"
                    },
                    {
                        "id": 143444,
                        "name": "Linda-a-Velha",
                        "latitude": "38.71446000",
                        "longitude": "-9.24220000"
                    },
                    {
                        "id": 143445,
                        "name": "Linhares (Celorico da Beira)",
                        "latitude": "40.54083333",
                        "longitude": "-7.46111111"
                    },
                    {
                        "id": 143447,
                        "name": "Longroiva",
                        "latitude": "40.98103000",
                        "longitude": "-7.20334000"
                    },
                    {
                        "id": 143448,
                        "name": "Loriga",
                        "latitude": "40.31666667",
                        "longitude": "-7.68333333"
                    },
                    {
                        "id": 143449,
                        "name": "Loures",
                        "latitude": "38.83333333",
                        "longitude": "-9.16666667"
                    },
                    {
                        "id": 143450,
                        "name": "Lourinhã",
                        "latitude": "39.25000000",
                        "longitude": "-9.31666667"
                    },
                    {
                        "id": 143451,
                        "name": "Lousa",
                        "latitude": "38.89171000",
                        "longitude": "-9.20972000"
                    },
                    {
                        "id": 143452,
                        "name": "Lumiar",
                        "latitude": "38.76527778",
                        "longitude": "-9.15861111"
                    },
                    {
                        "id": 143474,
                        "name": "Maçainhas",
                        "latitude": "40.53666667",
                        "longitude": "-7.30250000"
                    },
                    {
                        "id": 143475,
                        "name": "Maçal do Chão",
                        "latitude": "40.69171000",
                        "longitude": "-7.29178000"
                    },
                    {
                        "id": 143453,
                        "name": "Maceira",
                        "latitude": "40.68555556",
                        "longitude": "-7.47166667"
                    },
                    {
                        "id": 143476,
                        "name": "Maçussa",
                        "latitude": "39.19472222",
                        "longitude": "-8.86722222"
                    },
                    {
                        "id": 143454,
                        "name": "Madalena",
                        "latitude": "38.71000000",
                        "longitude": "-9.13472222"
                    },
                    {
                        "id": 143455,
                        "name": "Mafra",
                        "latitude": "38.93333333",
                        "longitude": "-9.33333333"
                    },
                    {
                        "id": 143456,
                        "name": "Malcata",
                        "latitude": "40.29990000",
                        "longitude": "-7.06147000"
                    },
                    {
                        "id": 143457,
                        "name": "Malhada Sorda",
                        "latitude": "40.53638889",
                        "longitude": "-6.91444444"
                    },
                    {
                        "id": 143458,
                        "name": "Malpartida",
                        "latitude": "40.76000000",
                        "longitude": "-6.86666667"
                    },
                    {
                        "id": 143459,
                        "name": "Malveira",
                        "latitude": "38.93059000",
                        "longitude": "-9.26165000"
                    },
                    {
                        "id": 143460,
                        "name": "Mangualde da Serra",
                        "latitude": "40.46638889",
                        "longitude": "-7.62166667"
                    },
                    {
                        "id": 143461,
                        "name": "Manigoto",
                        "latitude": "40.70833333",
                        "longitude": "-7.07583333"
                    },
                    {
                        "id": 143462,
                        "name": "Manique do Intendente",
                        "latitude": "39.22111111",
                        "longitude": "-8.89361111"
                    },
                    {
                        "id": 143463,
                        "name": "Manteigas",
                        "latitude": "40.40000000",
                        "longitude": "-7.53333333"
                    },
                    {
                        "id": 143464,
                        "name": "Manteigas (São Pedro)",
                        "latitude": "40.36611111",
                        "longitude": "-7.54611111"
                    },
                    {
                        "id": 143465,
                        "name": "Marialva",
                        "latitude": "40.91000000",
                        "longitude": "-7.23166667"
                    },
                    {
                        "id": 143466,
                        "name": "Marmeleiro",
                        "latitude": "40.46861111",
                        "longitude": "-7.11416667"
                    },
                    {
                        "id": 143467,
                        "name": "Marteleira",
                        "latitude": "39.21305556",
                        "longitude": "-9.28333333"
                    },
                    {
                        "id": 143503,
                        "name": "Mártires",
                        "latitude": "38.70861111",
                        "longitude": "-9.14166667"
                    },
                    {
                        "id": 143468,
                        "name": "Marvila",
                        "latitude": "38.74527778",
                        "longitude": "-9.10416667"
                    },
                    {
                        "id": 143469,
                        "name": "Massamá",
                        "latitude": "38.75564000",
                        "longitude": "-9.28427000"
                    },
                    {
                        "id": 143470,
                        "name": "Mata de Lobos",
                        "latitude": "40.91691000",
                        "longitude": "-6.88804000"
                    },
                    {
                        "id": 143471,
                        "name": "Matacães",
                        "latitude": "39.09277778",
                        "longitude": "-9.21222222"
                    },
                    {
                        "id": 143472,
                        "name": "Matança",
                        "latitude": "40.67888889",
                        "longitude": "-7.52888889"
                    },
                    {
                        "id": 143473,
                        "name": "Maxial",
                        "latitude": "39.14301000",
                        "longitude": "-9.16898000"
                    },
                    {
                        "id": 143477,
                        "name": "Meca",
                        "latitude": "39.08972222",
                        "longitude": "-9.02555556"
                    },
                    {
                        "id": 143504,
                        "name": "Mêda",
                        "latitude": "40.96666667",
                        "longitude": "-7.26666667"
                    },
                    {
                        "id": 143478,
                        "name": "Meios",
                        "latitude": "40.49361111",
                        "longitude": "-7.35916667"
                    },
                    {
                        "id": 143479,
                        "name": "Melo",
                        "latitude": "40.51944444",
                        "longitude": "-7.53361111"
                    },
                    {
                        "id": 143480,
                        "name": "Mem Martins",
                        "latitude": "38.79443000",
                        "longitude": "-9.34284000"
                    },
                    {
                        "id": 143481,
                        "name": "Mercês",
                        "latitude": "38.71611111",
                        "longitude": "-9.14888889"
                    },
                    {
                        "id": 143482,
                        "name": "Mesquitela",
                        "latitude": "40.58805556",
                        "longitude": "-7.48944444"
                    },
                    {
                        "id": 143483,
                        "name": "Milharado",
                        "latitude": "38.94722222",
                        "longitude": "-9.19916667"
                    },
                    {
                        "id": 143484,
                        "name": "Mina",
                        "latitude": "38.76166667",
                        "longitude": "-9.23611111"
                    },
                    {
                        "id": 143485,
                        "name": "Minhocal",
                        "latitude": "40.68944444",
                        "longitude": "-7.34666667"
                    },
                    {
                        "id": 143486,
                        "name": "Mira-Sintra",
                        "latitude": "38.78417000",
                        "longitude": "-9.30148000"
                    },
                    {
                        "id": 143487,
                        "name": "Miragaia",
                        "latitude": "39.23583333",
                        "longitude": "-9.26500000"
                    },
                    {
                        "id": 143488,
                        "name": "Miuzela",
                        "latitude": "40.51055556",
                        "longitude": "-7.00500000"
                    },
                    {
                        "id": 143489,
                        "name": "Mizarela",
                        "latitude": "40.55746000",
                        "longitude": "-7.34107000"
                    },
                    {
                        "id": 143490,
                        "name": "Moimenta da Serra",
                        "latitude": "40.47359000",
                        "longitude": "-7.63839000"
                    },
                    {
                        "id": 143491,
                        "name": "Moimentinha",
                        "latitude": "40.74555556",
                        "longitude": "-7.22777778"
                    },
                    {
                        "id": 143492,
                        "name": "Moita",
                        "latitude": "40.30000000",
                        "longitude": "-7.19750000"
                    },
                    {
                        "id": 143493,
                        "name": "Moita dos Ferreiros",
                        "latitude": "39.24825000",
                        "longitude": "-9.22355000"
                    },
                    {
                        "id": 143494,
                        "name": "Moledo",
                        "latitude": "39.28388889",
                        "longitude": "-9.25722222"
                    },
                    {
                        "id": 143495,
                        "name": "Monte Abraão",
                        "latitude": "38.75840000",
                        "longitude": "-9.26527000"
                    },
                    {
                        "id": 143496,
                        "name": "Monte Estoril",
                        "latitude": "38.70636000",
                        "longitude": "-9.40595000"
                    },
                    {
                        "id": 143497,
                        "name": "Monte Redondo",
                        "latitude": "39.11500000",
                        "longitude": "-9.20444444"
                    },
                    {
                        "id": 143498,
                        "name": "Montelavar",
                        "latitude": "38.86968000",
                        "longitude": "-9.31581000"
                    },
                    {
                        "id": 143499,
                        "name": "Moreira de Rei",
                        "latitude": "40.83915000",
                        "longitude": "-7.32316000"
                    },
                    {
                        "id": 143505,
                        "name": "Mós",
                        "latitude": "41.11306000",
                        "longitude": "-7.19717000"
                    },
                    {
                        "id": 143500,
                        "name": "Moscavide",
                        "latitude": "38.77929000",
                        "longitude": "-9.10222000"
                    },
                    {
                        "id": 143501,
                        "name": "Murça",
                        "latitude": "41.10055556",
                        "longitude": "-7.23138889"
                    },
                    {
                        "id": 143502,
                        "name": "Muxagata",
                        "latitude": "41.03611111",
                        "longitude": "-7.15000000"
                    },
                    {
                        "id": 143506,
                        "name": "Nabais",
                        "latitude": "40.52000000",
                        "longitude": "-7.55555556"
                    },
                    {
                        "id": 143507,
                        "name": "Nave",
                        "latitude": "40.39821000",
                        "longitude": "-6.96030000"
                    },
                    {
                        "id": 143508,
                        "name": "Nave de Haver",
                        "latitude": "40.52166667",
                        "longitude": "-6.83416667"
                    },
                    {
                        "id": 143509,
                        "name": "Nespereira",
                        "latitude": "40.51722222",
                        "longitude": "-7.60972222"
                    },
                    {
                        "id": 143510,
                        "name": "Nossa Senhora de Fátima",
                        "latitude": "38.73916667",
                        "longitude": "-9.15083333"
                    },
                    {
                        "id": 143511,
                        "name": "Numão",
                        "latitude": "41.09750000",
                        "longitude": "-7.29111111"
                    },
                    {
                        "id": 143512,
                        "name": "Odivelas",
                        "latitude": "38.80000000",
                        "longitude": "-9.18333333"
                    },
                    {
                        "id": 143513,
                        "name": "Odivelas Municipality",
                        "latitude": "38.79705000",
                        "longitude": "-9.19108000"
                    },
                    {
                        "id": 143514,
                        "name": "Oeiras",
                        "latitude": "38.69704444",
                        "longitude": "-9.30165278"
                    },
                    {
                        "id": 143515,
                        "name": "Oeiras e São Julião da Barra",
                        "latitude": "38.69722222",
                        "longitude": "-9.30833333"
                    },
                    {
                        "id": 143516,
                        "name": "Olhalvo",
                        "latitude": "39.09861111",
                        "longitude": "-9.06388889"
                    },
                    {
                        "id": 143517,
                        "name": "Olival de Basto",
                        "latitude": "38.79083333",
                        "longitude": "-9.16722222"
                    },
                    {
                        "id": 143518,
                        "name": "Olival do Basto",
                        "latitude": "38.79083333",
                        "longitude": "-9.16611111"
                    },
                    {
                        "id": 143519,
                        "name": "Ota",
                        "latitude": "39.11000000",
                        "longitude": "-8.98972222"
                    },
                    {
                        "id": 143520,
                        "name": "Outeiro da Cabeça",
                        "latitude": "39.19222222",
                        "longitude": "-9.18222222"
                    },
                    {
                        "id": 143521,
                        "name": "Outeiro de Gatos",
                        "latitude": "40.95222222",
                        "longitude": "-7.30222222"
                    },
                    {
                        "id": 143529,
                        "name": "Paço de Arcos",
                        "latitude": "38.69500000",
                        "longitude": "-9.29361111"
                    },
                    {
                        "id": 143530,
                        "name": "Paços da Serra",
                        "latitude": "40.45972222",
                        "longitude": "-7.65055556"
                    },
                    {
                        "id": 143522,
                        "name": "Painho",
                        "latitude": "39.30222222",
                        "longitude": "-9.04944444"
                    },
                    {
                        "id": 143523,
                        "name": "Pala",
                        "latitude": "40.76305556",
                        "longitude": "-7.15111111"
                    },
                    {
                        "id": 143524,
                        "name": "Palhais",
                        "latitude": "40.81666667",
                        "longitude": "-7.43000000"
                    },
                    {
                        "id": 143525,
                        "name": "Panoias de Cima",
                        "latitude": "40.49777778",
                        "longitude": "-7.23277778"
                    },
                    {
                        "id": 143526,
                        "name": "Parada",
                        "latitude": "40.53972222",
                        "longitude": "-7.03777778"
                    },
                    {
                        "id": 143527,
                        "name": "Paranhos",
                        "latitude": "40.48635000",
                        "longitude": "-7.79454000"
                    },
                    {
                        "id": 143528,
                        "name": "Parede",
                        "latitude": "38.69328000",
                        "longitude": "-9.35695000"
                    },
                    {
                        "id": 143531,
                        "name": "Pega",
                        "latitude": "40.42861111",
                        "longitude": "-7.14444444"
                    },
                    {
                        "id": 143532,
                        "name": "Pena",
                        "latitude": "38.72138889",
                        "longitude": "-9.14000000"
                    },
                    {
                        "id": 143533,
                        "name": "Pena Lobo",
                        "latitude": "40.39277778",
                        "longitude": "-7.20388889"
                    },
                    {
                        "id": 143534,
                        "name": "Pena Verde",
                        "latitude": "40.72833333",
                        "longitude": "-7.50527778"
                    },
                    {
                        "id": 143536,
                        "name": "Penha de Águia",
                        "latitude": "40.86636000",
                        "longitude": "-7.06814000"
                    },
                    {
                        "id": 143535,
                        "name": "Penha de França",
                        "latitude": "38.73000000",
                        "longitude": "-9.13166667"
                    },
                    {
                        "id": 143558,
                        "name": "Pêra do Moço",
                        "latitude": "40.61305556",
                        "longitude": "-7.20972222"
                    },
                    {
                        "id": 143537,
                        "name": "Peral",
                        "latitude": "39.26166667",
                        "longitude": "-9.07444444"
                    },
                    {
                        "id": 143538,
                        "name": "Pereiro",
                        "latitude": "40.73500000",
                        "longitude": "-7.01305556"
                    },
                    {
                        "id": 143539,
                        "name": "Pereiro de Palhacana",
                        "latitude": "39.04277778",
                        "longitude": "-9.10888889"
                    },
                    {
                        "id": 143559,
                        "name": "Pêro Moniz",
                        "latitude": "39.22138889",
                        "longitude": "-9.12361111"
                    },
                    {
                        "id": 143540,
                        "name": "Pero Pinheiro",
                        "latitude": "38.83990000",
                        "longitude": "-9.32066000"
                    },
                    {
                        "id": 143541,
                        "name": "Peva",
                        "latitude": "40.66472222",
                        "longitude": "-6.99083333"
                    },
                    {
                        "id": 143542,
                        "name": "Pinhanços",
                        "latitude": "40.46638889",
                        "longitude": "-7.68305556"
                    },
                    {
                        "id": 143543,
                        "name": "Pinheiro",
                        "latitude": "40.80083333",
                        "longitude": "-7.59833333"
                    },
                    {
                        "id": 143544,
                        "name": "Pinhel",
                        "latitude": "40.78333333",
                        "longitude": "-7.06666667"
                    },
                    {
                        "id": 143560,
                        "name": "Pínzio",
                        "latitude": "40.60250000",
                        "longitude": "-7.06527778"
                    },
                    {
                        "id": 143553,
                        "name": "Poço do Canto",
                        "latitude": "40.99944444",
                        "longitude": "-7.26833333"
                    },
                    {
                        "id": 143545,
                        "name": "Pomares",
                        "latitude": "40.64305556",
                        "longitude": "-7.13805556"
                    },
                    {
                        "id": 143546,
                        "name": "Ponte do Rol",
                        "latitude": "39.09277778",
                        "longitude": "-9.31916667"
                    },
                    {
                        "id": 143547,
                        "name": "Pontinha",
                        "latitude": "38.77700000",
                        "longitude": "-9.20377000"
                    },
                    {
                        "id": 143548,
                        "name": "Portela",
                        "latitude": "38.78277778",
                        "longitude": "-9.11111111"
                    },
                    {
                        "id": 143550,
                        "name": "Porto da Carne",
                        "latitude": "40.60527778",
                        "longitude": "-7.29222222"
                    },
                    {
                        "id": 143549,
                        "name": "Porto Salvo",
                        "latitude": "38.71722222",
                        "longitude": "-9.29916667"
                    },
                    {
                        "id": 143551,
                        "name": "Pousada",
                        "latitude": "40.54722222",
                        "longitude": "-7.12611111"
                    },
                    {
                        "id": 143552,
                        "name": "Pousafoles do Bispo",
                        "latitude": "40.41222222",
                        "longitude": "-7.17916667"
                    },
                    {
                        "id": 143561,
                        "name": "Póvoa de Santa Iria",
                        "latitude": "38.86111111",
                        "longitude": "-9.06444444"
                    },
                    {
                        "id": 143562,
                        "name": "Póvoa de Santo Adrião",
                        "latitude": "38.80016000",
                        "longitude": "-9.16395000"
                    },
                    {
                        "id": 143563,
                        "name": "Póvoa do Concelho",
                        "latitude": "40.75972222",
                        "longitude": "-7.26638889"
                    },
                    {
                        "id": 143554,
                        "name": "Prados",
                        "latitude": "40.56138889",
                        "longitude": "-7.37666667"
                    },
                    {
                        "id": 143555,
                        "name": "Prazeres",
                        "latitude": "38.70888889",
                        "longitude": "-9.16888889"
                    },
                    {
                        "id": 143556,
                        "name": "Prior Velho",
                        "latitude": "38.79194444",
                        "longitude": "-9.12083333"
                    },
                    {
                        "id": 143557,
                        "name": "Prova",
                        "latitude": "40.91250000",
                        "longitude": "-7.34194444"
                    },
                    {
                        "id": 143564,
                        "name": "Quadrazais",
                        "latitude": "40.32472222",
                        "longitude": "-6.99833333"
                    },
                    {
                        "id": 143565,
                        "name": "Queijas",
                        "latitude": "38.72236000",
                        "longitude": "-9.26593000"
                    },
                    {
                        "id": 143566,
                        "name": "Queiriz",
                        "latitude": "40.73596000",
                        "longitude": "-7.44999000"
                    },
                    {
                        "id": 143567,
                        "name": "Queluz",
                        "latitude": "38.75657000",
                        "longitude": "-9.25451000"
                    },
                    {
                        "id": 143569,
                        "name": "Quintã de Pêro Martins",
                        "latitude": "40.88194444",
                        "longitude": "-7.08305556"
                    },
                    {
                        "id": 143568,
                        "name": "Quintas de São Bartolomeu",
                        "latitude": "40.37138889",
                        "longitude": "-7.09861111"
                    },
                    {
                        "id": 143570,
                        "name": "Rabaçal",
                        "latitude": "40.86250000",
                        "longitude": "-7.24941000"
                    },
                    {
                        "id": 143571,
                        "name": "Ramada",
                        "latitude": "38.80361111",
                        "longitude": "-9.19111111"
                    },
                    {
                        "id": 143572,
                        "name": "Ramalhal",
                        "latitude": "39.14472222",
                        "longitude": "-9.23222222"
                    },
                    {
                        "id": 143573,
                        "name": "Ramela",
                        "latitude": "40.47777778",
                        "longitude": "-7.25888889"
                    },
                    {
                        "id": 143574,
                        "name": "Ranhados",
                        "latitude": "40.99527778",
                        "longitude": "-7.32944444"
                    },
                    {
                        "id": 143575,
                        "name": "Rapa",
                        "latitude": "40.58416667",
                        "longitude": "-7.34555556"
                    },
                    {
                        "id": 143576,
                        "name": "Rapoula do Côa",
                        "latitude": "40.42111111",
                        "longitude": "-7.04750000"
                    },
                    {
                        "id": 143577,
                        "name": "Ratoeira",
                        "latitude": "40.64027778",
                        "longitude": "-7.35361111"
                    },
                    {
                        "id": 143578,
                        "name": "Reboleira",
                        "latitude": "38.75083333",
                        "longitude": "-9.23027778"
                    },
                    {
                        "id": 143579,
                        "name": "Reboleiro",
                        "latitude": "40.83250000",
                        "longitude": "-7.41888889"
                    },
                    {
                        "id": 143580,
                        "name": "Rebolosa",
                        "latitude": "40.42361111",
                        "longitude": "-6.91111111"
                    },
                    {
                        "id": 143581,
                        "name": "Reguengo Grande",
                        "latitude": "39.28722222",
                        "longitude": "-9.21472222"
                    },
                    {
                        "id": 143582,
                        "name": "Reigada",
                        "latitude": "40.80444444",
                        "longitude": "-6.94805556"
                    },
                    {
                        "id": 143583,
                        "name": "Rendo",
                        "latitude": "40.37972222",
                        "longitude": "-7.04444444"
                    },
                    {
                        "id": 143584,
                        "name": "Ribafria",
                        "latitude": "39.06194444",
                        "longitude": "-9.09472222"
                    },
                    {
                        "id": 143585,
                        "name": "Ribamar",
                        "latitude": "39.20250000",
                        "longitude": "-9.33250000"
                    },
                    {
                        "id": 143586,
                        "name": "Ribamondego",
                        "latitude": "40.56805556",
                        "longitude": "-7.58138889"
                    },
                    {
                        "id": 143587,
                        "name": "Ribeira Dos Carinhos",
                        "latitude": "40.62138889",
                        "longitude": "-7.14222222"
                    },
                    {
                        "id": 143589,
                        "name": "Rio de Mel",
                        "latitude": "40.80777778",
                        "longitude": "-7.39361111"
                    },
                    {
                        "id": 143590,
                        "name": "Rio de Mouro",
                        "latitude": "38.76889000",
                        "longitude": "-9.33273000"
                    },
                    {
                        "id": 143588,
                        "name": "Rio Torto",
                        "latitude": "40.50916667",
                        "longitude": "-7.65694444"
                    },
                    {
                        "id": 143591,
                        "name": "Rochoso",
                        "latitude": "40.51638889",
                        "longitude": "-7.09333333"
                    },
                    {
                        "id": 143592,
                        "name": "Runa",
                        "latitude": "39.06527778",
                        "longitude": "-9.20888889"
                    },
                    {
                        "id": 143593,
                        "name": "Ruvina",
                        "latitude": "40.41500000",
                        "longitude": "-7.01055556"
                    },
                    {
                        "id": 143594,
                        "name": "Sabugal",
                        "latitude": "40.35000000",
                        "longitude": "-7.08333333"
                    },
                    {
                        "id": 143595,
                        "name": "Sabugueiro",
                        "latitude": "40.40194444",
                        "longitude": "-7.63972222"
                    },
                    {
                        "id": 143596,
                        "name": "Sacavém",
                        "latitude": "38.79442000",
                        "longitude": "-9.10533000"
                    },
                    {
                        "id": 143597,
                        "name": "Sacramento",
                        "latitude": "38.71222222",
                        "longitude": "-9.14000000"
                    },
                    {
                        "id": 143598,
                        "name": "Safurdão",
                        "latitude": "40.63694444",
                        "longitude": "-7.06888889"
                    },
                    {
                        "id": 143599,
                        "name": "Salgueirais",
                        "latitude": "40.57445000",
                        "longitude": "-7.42247000"
                    },
                    {
                        "id": 143600,
                        "name": "Sameice",
                        "latitude": "40.43444444",
                        "longitude": "-7.77611111"
                    },
                    {
                        "id": 143601,
                        "name": "Sameiro",
                        "latitude": "40.40916667",
                        "longitude": "-7.49000000"
                    },
                    {
                        "id": 143602,
                        "name": "Sandomil",
                        "latitude": "40.35805556",
                        "longitude": "-7.78277778"
                    },
                    {
                        "id": 143603,
                        "name": "Santa Bárbara",
                        "latitude": "39.21000000",
                        "longitude": "-9.31388889"
                    },
                    {
                        "id": 143604,
                        "name": "Santa Catarina",
                        "latitude": "38.71138889",
                        "longitude": "-9.14805556"
                    },
                    {
                        "id": 143605,
                        "name": "Santa Comba",
                        "latitude": "40.45055556",
                        "longitude": "-7.71472222"
                    },
                    {
                        "id": 143606,
                        "name": "Santa Engrácia",
                        "latitude": "38.71916667",
                        "longitude": "-9.11972222"
                    },
                    {
                        "id": 143607,
                        "name": "Santa Eufémia",
                        "latitude": "40.79833333",
                        "longitude": "-7.18083333"
                    },
                    {
                        "id": 143608,
                        "name": "Santa Eulália",
                        "latitude": "40.41439000",
                        "longitude": "-7.78717000"
                    },
                    {
                        "id": 143609,
                        "name": "Santa Iria da Azóia",
                        "latitude": "38.84629000",
                        "longitude": "-9.08748000"
                    },
                    {
                        "id": 143610,
                        "name": "Santa Iria de Azoia",
                        "latitude": "38.84638889",
                        "longitude": "-9.08805556"
                    },
                    {
                        "id": 143611,
                        "name": "Santa Isabel",
                        "latitude": "38.71861111",
                        "longitude": "-9.15833333"
                    },
                    {
                        "id": 143612,
                        "name": "Santa Justa",
                        "latitude": "38.71555556",
                        "longitude": "-9.13638889"
                    },
                    {
                        "id": 143613,
                        "name": "Santa Maria",
                        "latitude": "40.42388889",
                        "longitude": "-7.52138889"
                    },
                    {
                        "id": 143614,
                        "name": "Santa Maria de Belém",
                        "latitude": "38.69911000",
                        "longitude": "-9.20867000"
                    },
                    {
                        "id": 143615,
                        "name": "Santa Maria do Castelo e São Miguel",
                        "latitude": "39.10864000",
                        "longitude": "-9.23907000"
                    },
                    {
                        "id": 143616,
                        "name": "Santa Maria dos Olivais",
                        "latitude": "38.76989000",
                        "longitude": "-9.12073000"
                    },
                    {
                        "id": 143617,
                        "name": "Santa Maria e São Miguel",
                        "latitude": "38.80083333",
                        "longitude": "-9.37944444"
                    },
                    {
                        "id": 143618,
                        "name": "Santa Marinha",
                        "latitude": "40.45027778",
                        "longitude": "-7.66333333"
                    },
                    {
                        "id": 143619,
                        "name": "Santana da Azinha",
                        "latitude": "40.47361111",
                        "longitude": "-7.20916667"
                    },
                    {
                        "id": 143620,
                        "name": "Santiago",
                        "latitude": "40.42388889",
                        "longitude": "-7.72916667"
                    },
                    {
                        "id": 143621,
                        "name": "Santiago dos Velhos",
                        "latitude": "38.94166667",
                        "longitude": "-9.10361111"
                    },
                    {
                        "id": 143622,
                        "name": "Santo Antão do Tojal",
                        "latitude": "38.85361111",
                        "longitude": "-9.14305556"
                    },
                    {
                        "id": 143623,
                        "name": "Santo António dos Cavaleiros",
                        "latitude": "38.81166667",
                        "longitude": "-9.16111111"
                    },
                    {
                        "id": 143624,
                        "name": "Santo Condestável",
                        "latitude": "38.71527778",
                        "longitude": "-9.16694444"
                    },
                    {
                        "id": 143625,
                        "name": "Santo Estêvão",
                        "latitude": "39.04222222",
                        "longitude": "-9.01583333"
                    },
                    {
                        "id": 143626,
                        "name": "Santo Estêvão das Galés",
                        "latitude": "38.89008000",
                        "longitude": "-9.25066000"
                    },
                    {
                        "id": 143627,
                        "name": "Santo Isidoro",
                        "latitude": "38.99361111",
                        "longitude": "-9.39861111"
                    },
                    {
                        "id": 143628,
                        "name": "Santo Quintino",
                        "latitude": "39.00611111",
                        "longitude": "-9.14972222"
                    },
                    {
                        "id": 143629,
                        "name": "Santos-o-Velho",
                        "latitude": "38.70694444",
                        "longitude": "-9.15638889"
                    },
                    {
                        "id": 143653,
                        "name": "São Bartolomeu",
                        "latitude": "39.27511000",
                        "longitude": "-9.27885000"
                    },
                    {
                        "id": 143654,
                        "name": "São Bartolomeu dos Galegos",
                        "latitude": "39.27583333",
                        "longitude": "-9.27944444"
                    },
                    {
                        "id": 143655,
                        "name": "São Brás",
                        "latitude": "38.76750000",
                        "longitude": "-9.23305556"
                    },
                    {
                        "id": 143656,
                        "name": "São Cristóvão e São Lourenço",
                        "latitude": "38.71277778",
                        "longitude": "-9.13555556"
                    },
                    {
                        "id": 143657,
                        "name": "São Domingos de Benfica",
                        "latitude": "38.74361111",
                        "longitude": "-9.17000000"
                    },
                    {
                        "id": 143658,
                        "name": "São Domingos de Rana",
                        "latitude": "38.70123000",
                        "longitude": "-9.32760000"
                    },
                    {
                        "id": 143659,
                        "name": "São Francisco Xavier",
                        "latitude": "38.70722222",
                        "longitude": "-9.21722222"
                    },
                    {
                        "id": 143662,
                        "name": "São João",
                        "latitude": "38.72888889",
                        "longitude": "-9.12277778"
                    },
                    {
                        "id": 143664,
                        "name": "São João da Talha",
                        "latitude": "38.82583333",
                        "longitude": "-9.09222222"
                    },
                    {
                        "id": 143665,
                        "name": "São João das Lampas",
                        "latitude": "38.87000000",
                        "longitude": "-9.42111111"
                    },
                    {
                        "id": 143666,
                        "name": "São João de Brito",
                        "latitude": "38.75500000",
                        "longitude": "-9.13777778"
                    },
                    {
                        "id": 143667,
                        "name": "São João de Deus",
                        "latitude": "38.74027778",
                        "longitude": "-9.13777778"
                    },
                    {
                        "id": 143663,
                        "name": "São João Dos Montes",
                        "latitude": "38.95166000",
                        "longitude": "-9.05449000"
                    },
                    {
                        "id": 143660,
                        "name": "São Jorge de Arroios",
                        "latitude": "38.72888889",
                        "longitude": "-9.13888889"
                    },
                    {
                        "id": 143661,
                        "name": "São José",
                        "latitude": "38.71805556",
                        "longitude": "-9.14250000"
                    },
                    {
                        "id": 143668,
                        "name": "São Julião",
                        "latitude": "40.48757000",
                        "longitude": "-7.59498000"
                    },
                    {
                        "id": 143669,
                        "name": "São Julião do Tojal",
                        "latitude": "38.85805556",
                        "longitude": "-9.13555556"
                    },
                    {
                        "id": 143670,
                        "name": "São Mamede",
                        "latitude": "38.72023000",
                        "longitude": "-9.15298000"
                    },
                    {
                        "id": 143671,
                        "name": "São Marcos",
                        "latitude": "38.75624000",
                        "longitude": "-9.29731000"
                    },
                    {
                        "id": 143672,
                        "name": "São Martinho",
                        "latitude": "40.44305556",
                        "longitude": "-7.67194444"
                    },
                    {
                        "id": 143673,
                        "name": "São Miguel",
                        "latitude": "38.71111111",
                        "longitude": "-9.12944444"
                    },
                    {
                        "id": 143674,
                        "name": "São Miguel da Guarda",
                        "latitude": "40.55555556",
                        "longitude": "-7.24611111"
                    },
                    {
                        "id": 143675,
                        "name": "São Miguel de Alcainça",
                        "latitude": "38.92111111",
                        "longitude": "-9.29583333"
                    },
                    {
                        "id": 143676,
                        "name": "São Nicolau",
                        "latitude": "38.70750000",
                        "longitude": "-9.13666667"
                    },
                    {
                        "id": 143677,
                        "name": "São Paio",
                        "latitude": "40.51527778",
                        "longitude": "-7.58222222"
                    },
                    {
                        "id": 143678,
                        "name": "São Paulo",
                        "latitude": "38.70760000",
                        "longitude": "-9.14707000"
                    },
                    {
                        "id": 143679,
                        "name": "São Pedro",
                        "latitude": "40.63222222",
                        "longitude": "-7.38138889"
                    },
                    {
                        "id": 143680,
                        "name": "São Pedro da Cadeira",
                        "latitude": "39.06972222",
                        "longitude": "-9.37166667"
                    },
                    {
                        "id": 143681,
                        "name": "São Pedro de Penaferrim",
                        "latitude": "38.76947000",
                        "longitude": "-9.38963000"
                    },
                    {
                        "id": 143682,
                        "name": "São Pedro de Rio Seco",
                        "latitude": "40.66194444",
                        "longitude": "-6.83916667"
                    },
                    {
                        "id": 143683,
                        "name": "São Romão",
                        "latitude": "40.40194444",
                        "longitude": "-7.71694444"
                    },
                    {
                        "id": 143684,
                        "name": "São Sebastião da Pedreira",
                        "latitude": "38.73083333",
                        "longitude": "-9.14916667"
                    },
                    {
                        "id": 143685,
                        "name": "São Vicente",
                        "latitude": "40.53979000",
                        "longitude": "-7.23536000"
                    },
                    {
                        "id": 143686,
                        "name": "São Vicente de Fora",
                        "latitude": "38.71583333",
                        "longitude": "-9.12416667"
                    },
                    {
                        "id": 143630,
                        "name": "Sapataria",
                        "latitude": "38.97188000",
                        "longitude": "-9.20195000"
                    },
                    {
                        "id": 143631,
                        "name": "Sazes da Beira",
                        "latitude": "40.34888889",
                        "longitude": "-7.73527778"
                    },
                    {
                        "id": 143687,
                        "name": "Sé",
                        "latitude": "40.53861111",
                        "longitude": "-7.26916667"
                    },
                    {
                        "id": 143632,
                        "name": "Sebadelhe",
                        "latitude": "41.05222222",
                        "longitude": "-7.26972222"
                    },
                    {
                        "id": 143633,
                        "name": "Sebadelhe da Serra",
                        "latitude": "40.87111111",
                        "longitude": "-7.39833333"
                    },
                    {
                        "id": 143634,
                        "name": "Seia",
                        "latitude": "40.42027778",
                        "longitude": "-7.70333333"
                    },
                    {
                        "id": 143635,
                        "name": "Seixas",
                        "latitude": "41.11196000",
                        "longitude": "-7.25251000"
                    },
                    {
                        "id": 143636,
                        "name": "Seixo do Côa",
                        "latitude": "40.46305556",
                        "longitude": "-7.02666667"
                    },
                    {
                        "id": 143637,
                        "name": "Sequeira",
                        "latitude": "40.55361111",
                        "longitude": "-7.22583333"
                    },
                    {
                        "id": 143638,
                        "name": "Sequeiros",
                        "latitude": "40.83714000",
                        "longitude": "-7.49803000"
                    },
                    {
                        "id": 143639,
                        "name": "Silveira",
                        "latitude": "39.11111111",
                        "longitude": "-9.36416667"
                    },
                    {
                        "id": 143641,
                        "name": "Sintra (town)",
                        "latitude": "38.81439000",
                        "longitude": "-9.38370000"
                    },
                    {
                        "id": 143643,
                        "name": "Sobral da Abelheira",
                        "latitude": "38.99833333",
                        "longitude": "-9.32916667"
                    },
                    {
                        "id": 143644,
                        "name": "Sobral da Serra",
                        "latitude": "40.61916667",
                        "longitude": "-7.27972222"
                    },
                    {
                        "id": 143645,
                        "name": "Sobral de Monte Agraço",
                        "latitude": "39.01666667",
                        "longitude": "-9.15000000"
                    },
                    {
                        "id": 143642,
                        "name": "Sobral Pichorro",
                        "latitude": "40.69073000",
                        "longitude": "-7.45598000"
                    },
                    {
                        "id": 143646,
                        "name": "Sobralinho",
                        "latitude": "38.91750000",
                        "longitude": "-9.02611111"
                    },
                    {
                        "id": 143647,
                        "name": "Socorro",
                        "latitude": "38.71666667",
                        "longitude": "-9.13444444"
                    },
                    {
                        "id": 143648,
                        "name": "Sortelha",
                        "latitude": "40.33138889",
                        "longitude": "-7.21138889"
                    },
                    {
                        "id": 143649,
                        "name": "Souro Pires",
                        "latitude": "40.74500000",
                        "longitude": "-7.12472222"
                    },
                    {
                        "id": 143650,
                        "name": "Souto",
                        "latitude": "40.35666667",
                        "longitude": "-6.95833333"
                    },
                    {
                        "id": 143652,
                        "name": "Souto de Aguiar da Beira",
                        "latitude": "40.81075000",
                        "longitude": "-7.49244000"
                    },
                    {
                        "id": 143651,
                        "name": "Souto Maior",
                        "latitude": "40.79686000",
                        "longitude": "-7.31410000"
                    },
                    {
                        "id": 143688,
                        "name": "Tamanhos",
                        "latitude": "40.76166667",
                        "longitude": "-7.31555556"
                    },
                    {
                        "id": 143689,
                        "name": "Teixeira",
                        "latitude": "40.25333333",
                        "longitude": "-7.74166667"
                    },
                    {
                        "id": 143690,
                        "name": "Terrenho",
                        "latitude": "40.86611111",
                        "longitude": "-7.35416667"
                    },
                    {
                        "id": 143691,
                        "name": "Terrugem",
                        "latitude": "38.85111111",
                        "longitude": "-9.37472222"
                    },
                    {
                        "id": 143692,
                        "name": "Torre do Terrenho",
                        "latitude": "40.88888889",
                        "longitude": "-7.35944444"
                    },
                    {
                        "id": 143693,
                        "name": "Torres",
                        "latitude": "40.74833333",
                        "longitude": "-7.31916667"
                    },
                    {
                        "id": 143694,
                        "name": "Torres Vedras",
                        "latitude": "39.08333333",
                        "longitude": "-9.26666667"
                    },
                    {
                        "id": 143695,
                        "name": "Torrozelo",
                        "latitude": "40.38611111",
                        "longitude": "-7.76027778"
                    },
                    {
                        "id": 143697,
                        "name": "Touça",
                        "latitude": "41.04722222",
                        "longitude": "-7.23388889"
                    },
                    {
                        "id": 143696,
                        "name": "Tourais",
                        "latitude": "40.47138889",
                        "longitude": "-7.75083333"
                    },
                    {
                        "id": 143698,
                        "name": "Trancoso",
                        "latitude": "40.78330000",
                        "longitude": "-7.35000000"
                    },
                    {
                        "id": 143699,
                        "name": "Travancinha",
                        "latitude": "40.42234000",
                        "longitude": "-7.82175000"
                    },
                    {
                        "id": 143700,
                        "name": "Triana",
                        "latitude": "39.06988000",
                        "longitude": "-8.98660000"
                    },
                    {
                        "id": 143701,
                        "name": "Trinta",
                        "latitude": "40.50444444",
                        "longitude": "-7.35527778"
                    },
                    {
                        "id": 143702,
                        "name": "Turcifal",
                        "latitude": "39.03578000",
                        "longitude": "-9.26017000"
                    },
                    {
                        "id": 143703,
                        "name": "Unhos",
                        "latitude": "38.82583333",
                        "longitude": "-9.12138889"
                    },
                    {
                        "id": 143704,
                        "name": "Valbom",
                        "latitude": "40.78055556",
                        "longitude": "-7.12888889"
                    },
                    {
                        "id": 143705,
                        "name": "Valdujo",
                        "latitude": "40.84500000",
                        "longitude": "-7.26694444"
                    },
                    {
                        "id": 143707,
                        "name": "Vale da Mula",
                        "latitude": "40.70361111",
                        "longitude": "-6.82361111"
                    },
                    {
                        "id": 143708,
                        "name": "Vale de Amoreira",
                        "latitude": "40.41416667",
                        "longitude": "-7.44138889"
                    },
                    {
                        "id": 143709,
                        "name": "Vale de Azares",
                        "latitude": "40.60492000",
                        "longitude": "-7.36421000"
                    },
                    {
                        "id": 143710,
                        "name": "Vale de Espinho",
                        "latitude": "40.29694444",
                        "longitude": "-6.95055556"
                    },
                    {
                        "id": 143711,
                        "name": "Vale de Estrela",
                        "latitude": "40.49944444",
                        "longitude": "-7.30777778"
                    },
                    {
                        "id": 143712,
                        "name": "Vale do Paraíso",
                        "latitude": "39.11555556",
                        "longitude": "-8.88583333"
                    },
                    {
                        "id": 143713,
                        "name": "Vale do Seixo",
                        "latitude": "40.79291000",
                        "longitude": "-7.27266000"
                    },
                    {
                        "id": 143706,
                        "name": "Vale Flor",
                        "latitude": "40.91277778",
                        "longitude": "-7.28222222"
                    },
                    {
                        "id": 143714,
                        "name": "Valezim",
                        "latitude": "40.35889000",
                        "longitude": "-7.70831000"
                    },
                    {
                        "id": 143715,
                        "name": "Valhelhas",
                        "latitude": "40.40722222",
                        "longitude": "-7.40305556"
                    },
                    {
                        "id": 143716,
                        "name": "Valverde",
                        "latitude": "40.78416667",
                        "longitude": "-7.52194444"
                    },
                    {
                        "id": 143759,
                        "name": "Várzea de Meruge",
                        "latitude": "40.39527778",
                        "longitude": "-7.78361111"
                    },
                    {
                        "id": 143717,
                        "name": "Vascoveiro",
                        "latitude": "40.73416667",
                        "longitude": "-7.06972222"
                    },
                    {
                        "id": 143718,
                        "name": "Vela",
                        "latitude": "40.43585000",
                        "longitude": "-7.30369000"
                    },
                    {
                        "id": 143719,
                        "name": "Velosa",
                        "latitude": "40.65250000",
                        "longitude": "-7.29000000"
                    },
                    {
                        "id": 143721,
                        "name": "Venda do Pinheiro",
                        "latitude": "38.92527778",
                        "longitude": "-9.23222222"
                    },
                    {
                        "id": 143720,
                        "name": "Venda Nova",
                        "latitude": "38.75422000",
                        "longitude": "-9.21452000"
                    },
                    {
                        "id": 143722,
                        "name": "Venteira",
                        "latitude": "38.75944444",
                        "longitude": "-9.24111111"
                    },
                    {
                        "id": 143723,
                        "name": "Ventosa",
                        "latitude": "39.12694444",
                        "longitude": "-9.08416667"
                    },
                    {
                        "id": 143724,
                        "name": "Vermelha",
                        "latitude": "39.27277778",
                        "longitude": "-9.10555556"
                    },
                    {
                        "id": 143725,
                        "name": "Vermiosa",
                        "latitude": "40.82722222",
                        "longitude": "-6.87750000"
                    },
                    {
                        "id": 143726,
                        "name": "Vialonga",
                        "latitude": "38.87094000",
                        "longitude": "-9.06823000"
                    },
                    {
                        "id": 143727,
                        "name": "Vide",
                        "latitude": "40.29444444",
                        "longitude": "-7.78416667"
                    },
                    {
                        "id": 143728,
                        "name": "Vide Entre Vinhas",
                        "latitude": "40.59722222",
                        "longitude": "-7.40416667"
                    },
                    {
                        "id": 143729,
                        "name": "Videmonte",
                        "latitude": "40.51388889",
                        "longitude": "-7.39000000"
                    },
                    {
                        "id": 143730,
                        "name": "Vila Boa",
                        "latitude": "40.38305556",
                        "longitude": "-7.00388889"
                    },
                    {
                        "id": 143731,
                        "name": "Vila Boa do Mondego",
                        "latitude": "40.62694444",
                        "longitude": "-7.43777778"
                    },
                    {
                        "id": 143732,
                        "name": "Vila Cortês da Serra",
                        "latitude": "40.55083333",
                        "longitude": "-7.52944444"
                    },
                    {
                        "id": 143733,
                        "name": "Vila Cortês do Mondego",
                        "latitude": "40.60593000",
                        "longitude": "-7.31236000"
                    },
                    {
                        "id": 143734,
                        "name": "Vila Cova à Coelheira",
                        "latitude": "40.38333333",
                        "longitude": "-7.73416667"
                    },
                    {
                        "id": 143750,
                        "name": "Vila do Touro",
                        "latitude": "40.41638889",
                        "longitude": "-7.10555556"
                    },
                    {
                        "id": 143735,
                        "name": "Vila Fernando",
                        "latitude": "40.49472222",
                        "longitude": "-7.15444444"
                    },
                    {
                        "id": 143736,
                        "name": "Vila Franca da Serra",
                        "latitude": "40.58722222",
                        "longitude": "-7.53944444"
                    },
                    {
                        "id": 143737,
                        "name": "Vila Franca das Naves",
                        "latitude": "40.72392000",
                        "longitude": "-7.26206000"
                    },
                    {
                        "id": 143738,
                        "name": "Vila Franca de Xira",
                        "latitude": "38.95000000",
                        "longitude": "-8.98333333"
                    },
                    {
                        "id": 143739,
                        "name": "Vila Franca do Deão",
                        "latitude": "40.65277778",
                        "longitude": "-7.24222222"
                    },
                    {
                        "id": 143740,
                        "name": "Vila Franca do Rosário",
                        "latitude": "38.97472222",
                        "longitude": "-9.25611111"
                    },
                    {
                        "id": 143741,
                        "name": "Vila Garcia",
                        "latitude": "40.79414000",
                        "longitude": "-7.23318000"
                    },
                    {
                        "id": 143742,
                        "name": "Vila Nova da Rainha",
                        "latitude": "39.03722222",
                        "longitude": "-8.93361111"
                    },
                    {
                        "id": 143743,
                        "name": "Vila Nova de Foz Côa",
                        "latitude": "41.08333333",
                        "longitude": "-7.13333333"
                    },
                    {
                        "id": 143744,
                        "name": "Vila Nova de São Pedro",
                        "latitude": "39.21980000",
                        "longitude": "-8.84037000"
                    },
                    {
                        "id": 143745,
                        "name": "Vila Nova de Tazem",
                        "latitude": "40.50250000",
                        "longitude": "-7.70305556"
                    },
                    {
                        "id": 143746,
                        "name": "Vila Ruiva",
                        "latitude": "40.56944444",
                        "longitude": "-7.51416667"
                    },
                    {
                        "id": 143747,
                        "name": "Vila Soeiro do Chão",
                        "latitude": "40.61036000",
                        "longitude": "-7.48202000"
                    },
                    {
                        "id": 143748,
                        "name": "Vila Verde",
                        "latitude": "39.15489000",
                        "longitude": "-9.11512000"
                    },
                    {
                        "id": 143749,
                        "name": "Vila Verde dos Francos",
                        "latitude": "39.15444444",
                        "longitude": "-9.11333333"
                    },
                    {
                        "id": 143751,
                        "name": "Vilar",
                        "latitude": "39.18671000",
                        "longitude": "-9.10687000"
                    },
                    {
                        "id": 143755,
                        "name": "Vilar de Amargo",
                        "latitude": "40.94636000",
                        "longitude": "-7.00157000"
                    },
                    {
                        "id": 143752,
                        "name": "Vilar Formoso",
                        "latitude": "40.61382000",
                        "longitude": "-6.83493000"
                    },
                    {
                        "id": 143753,
                        "name": "Vilar Maior",
                        "latitude": "40.48473000",
                        "longitude": "-6.91999000"
                    },
                    {
                        "id": 143754,
                        "name": "Vilar Torpim",
                        "latitude": "40.82555556",
                        "longitude": "-6.95194444"
                    },
                    {
                        "id": 143756,
                        "name": "Vilares",
                        "latitude": "40.72062000",
                        "longitude": "-7.28348000"
                    },
                    {
                        "id": 143757,
                        "name": "Vimeiro",
                        "latitude": "39.17777778",
                        "longitude": "-9.31777778"
                    },
                    {
                        "id": 143758,
                        "name": "Vinhó",
                        "latitude": "40.49583333",
                        "longitude": "-7.62694444"
                    }
                ]
            },
            {
                "id": 2240,
                "name": "Leiria",
                "iso2": "10",
                "latitude": "39.77095320",
                "longitude": "-8.79218360",
                "type": "district",
                "cities": [
                    {
                        "id": 88905,
                        "name": "A dos Francos",
                        "latitude": "39.32272000",
                        "longitude": "-9.04743000"
                    },
                    {
                        "id": 88920,
                        "name": "Alcobaça",
                        "latitude": "39.55223000",
                        "longitude": "-8.97749000"
                    },
                    {
                        "id": 88930,
                        "name": "Alfeizerão",
                        "latitude": "39.49971000",
                        "longitude": "-9.10341000"
                    },
                    {
                        "id": 88943,
                        "name": "Aljubarrota",
                        "latitude": "39.56715000",
                        "longitude": "-8.92925000"
                    },
                    {
                        "id": 88955,
                        "name": "Alvaiázere",
                        "latitude": "39.81951000",
                        "longitude": "-8.38858000"
                    },
                    {
                        "id": 88959,
                        "name": "Alvorninha",
                        "latitude": "39.38224000",
                        "longitude": "-9.03674000"
                    },
                    {
                        "id": 88964,
                        "name": "Amor",
                        "latitude": "39.80404000",
                        "longitude": "-8.85984000"
                    },
                    {
                        "id": 88970,
                        "name": "Ansião",
                        "latitude": "39.93424000",
                        "longitude": "-8.42045000"
                    },
                    {
                        "id": 89000,
                        "name": "Atouguia da Baleia",
                        "latitude": "39.33814000",
                        "longitude": "-9.32630000"
                    },
                    {
                        "id": 89023,
                        "name": "Batalha",
                        "latitude": "39.66025000",
                        "longitude": "-8.82475000"
                    },
                    {
                        "id": 89033,
                        "name": "Benedita",
                        "latitude": "39.42470000",
                        "longitude": "-8.96996000"
                    },
                    {
                        "id": 89042,
                        "name": "Bombarral",
                        "latitude": "39.26723000",
                        "longitude": "-9.15795000"
                    },
                    {
                        "id": 89063,
                        "name": "Caldas da Rainha",
                        "latitude": "39.40326000",
                        "longitude": "-9.13839000"
                    },
                    {
                        "id": 89090,
                        "name": "Caranguejeira",
                        "latitude": "39.74619000",
                        "longitude": "-8.70740000"
                    },
                    {
                        "id": 89102,
                        "name": "Castanheira de Pêra",
                        "latitude": "40.00717000",
                        "longitude": "-8.21048000"
                    },
                    {
                        "id": 89113,
                        "name": "Cela",
                        "latitude": "39.54075000",
                        "longitude": "-9.03449000"
                    },
                    {
                        "id": 89164,
                        "name": "Famalicão",
                        "latitude": "39.53642000",
                        "longitude": "-9.08308000"
                    },
                    {
                        "id": 89180,
                        "name": "Ferrel",
                        "latitude": "39.36398000",
                        "longitude": "-9.31541000"
                    },
                    {
                        "id": 89184,
                        "name": "Figueiró Dos Vinhos",
                        "latitude": "39.90617000",
                        "longitude": "-8.27753000"
                    },
                    {
                        "id": 89188,
                        "name": "Foz do Arelho",
                        "latitude": "39.43672000",
                        "longitude": "-9.21374000"
                    },
                    {
                        "id": 89241,
                        "name": "Leiria",
                        "latitude": "39.74362000",
                        "longitude": "-8.80705000"
                    },
                    {
                        "id": 89253,
                        "name": "Louriçal",
                        "latitude": "40.00390000",
                        "longitude": "-8.73736000"
                    },
                    {
                        "id": 89261,
                        "name": "Maceira",
                        "latitude": "39.68853000",
                        "longitude": "-8.89423000"
                    },
                    {
                        "id": 89277,
                        "name": "Marinha Grande",
                        "latitude": "39.77681000",
                        "longitude": "-8.95005000"
                    },
                    {
                        "id": 89302,
                        "name": "Mira",
                        "latitude": "39.54315000",
                        "longitude": "-8.71505000"
                    },
                    {
                        "id": 89322,
                        "name": "Monte Real",
                        "latitude": "39.85210000",
                        "longitude": "-8.86349000"
                    },
                    {
                        "id": 89323,
                        "name": "Monte Redondo",
                        "latitude": "39.89930000",
                        "longitude": "-8.83171000"
                    },
                    {
                        "id": 89341,
                        "name": "Nadadouro",
                        "latitude": "39.41927000",
                        "longitude": "-9.19091000"
                    },
                    {
                        "id": 89342,
                        "name": "Nazaré",
                        "latitude": "39.59965000",
                        "longitude": "-9.07162000"
                    },
                    {
                        "id": 89699,
                        "name": "Óbidos",
                        "latitude": "39.35854000",
                        "longitude": "-9.17603000"
                    },
                    {
                        "id": 89385,
                        "name": "Pataias",
                        "latitude": "39.66978000",
                        "longitude": "-8.99580000"
                    },
                    {
                        "id": 89391,
                        "name": "Pedrógão Grande",
                        "latitude": "39.92682000",
                        "longitude": "-8.20093000"
                    },
                    {
                        "id": 89400,
                        "name": "Peniche",
                        "latitude": "39.35580000",
                        "longitude": "-9.38112000"
                    },
                    {
                        "id": 89411,
                        "name": "Pombal",
                        "latitude": "39.90735000",
                        "longitude": "-8.66949000"
                    },
                    {
                        "id": 89433,
                        "name": "Porto de Mós",
                        "latitude": "39.60191000",
                        "longitude": "-8.81839000"
                    },
                    {
                        "id": 89483,
                        "name": "Salir de Matos",
                        "latitude": "39.43186000",
                        "longitude": "-9.09479000"
                    },
                    {
                        "id": 89496,
                        "name": "Santa Catarina da Serra",
                        "latitude": "39.67960000",
                        "longitude": "-8.68679000"
                    },
                    {
                        "id": 89576,
                        "name": "São Martinho do Porto",
                        "latitude": "39.51444000",
                        "longitude": "-9.13111000"
                    },
                    {
                        "id": 89534,
                        "name": "Serra de El-Rei",
                        "latitude": "39.33291000",
                        "longitude": "-9.26843000"
                    },
                    {
                        "id": 89555,
                        "name": "Souto da Carpalhosa",
                        "latitude": "39.84867000",
                        "longitude": "-8.83506000"
                    },
                    {
                        "id": 89615,
                        "name": "Turquel",
                        "latitude": "39.46411000",
                        "longitude": "-8.97743000"
                    },
                    {
                        "id": 89622,
                        "name": "Valado de Frades",
                        "latitude": "39.58432000",
                        "longitude": "-9.02290000"
                    },
                    {
                        "id": 89637,
                        "name": "Vestiaria",
                        "latitude": "39.55271000",
                        "longitude": "-8.99790000"
                    },
                    {
                        "id": 89641,
                        "name": "Vidais",
                        "latitude": "39.36886000",
                        "longitude": "-9.04916000"
                    },
                    {
                        "id": 89643,
                        "name": "Vieira de Leiria",
                        "latitude": "39.86945000",
                        "longitude": "-8.93238000"
                    }
                ]
            },
            {
                "id": 2228,
                "name": "Lisbon",
                "iso2": "11",
                "latitude": "38.72232630",
                "longitude": "-9.13927140",
                "type": "district",
                "cities": [
                    {
                        "id": 88904,
                        "name": "A dos Cunhados",
                        "latitude": "39.15237000",
                        "longitude": "-9.29720000"
                    },
                    {
                        "id": 88908,
                        "name": "Abrigada",
                        "latitude": "39.14416000",
                        "longitude": "-9.01853000"
                    },
                    {
                        "id": 88915,
                        "name": "Alcabideche",
                        "latitude": "38.73366000",
                        "longitude": "-9.40928000"
                    },
                    {
                        "id": 88922,
                        "name": "Alcoentre",
                        "latitude": "39.20857000",
                        "longitude": "-8.95953000"
                    },
                    {
                        "id": 88928,
                        "name": "Alenquer",
                        "latitude": "39.05315000",
                        "longitude": "-9.00928000"
                    },
                    {
                        "id": 88933,
                        "name": "Alfragide",
                        "latitude": "38.73203000",
                        "longitude": "-9.21920000"
                    },
                    {
                        "id": 88937,
                        "name": "Algés",
                        "latitude": "38.70245000",
                        "longitude": "-9.22936000"
                    },
                    {
                        "id": 88936,
                        "name": "Algueirão",
                        "latitude": "38.79764000",
                        "longitude": "-9.34370000"
                    },
                    {
                        "id": 88939,
                        "name": "Alhandra",
                        "latitude": "38.92732000",
                        "longitude": "-9.00864000"
                    },
                    {
                        "id": 88947,
                        "name": "Almargem",
                        "latitude": "38.84485000",
                        "longitude": "-9.27315000"
                    },
                    {
                        "id": 88956,
                        "name": "Alvalade",
                        "latitude": "38.75328000",
                        "longitude": "-9.14397000"
                    },
                    {
                        "id": 88960,
                        "name": "Amadora",
                        "latitude": "38.75382000",
                        "longitude": "-9.23083000"
                    },
                    {
                        "id": 88973,
                        "name": "Apelação",
                        "latitude": "38.81387000",
                        "longitude": "-9.13225000"
                    },
                    {
                        "id": 88991,
                        "name": "Arranhó",
                        "latitude": "38.95378000",
                        "longitude": "-9.13465000"
                    },
                    {
                        "id": 88996,
                        "name": "Arruda dos Vinhos",
                        "latitude": "38.97172000",
                        "longitude": "-9.08807000"
                    },
                    {
                        "id": 89002,
                        "name": "Aveiras de Cima",
                        "latitude": "39.13796000",
                        "longitude": "-8.89932000"
                    },
                    {
                        "id": 89009,
                        "name": "Azambuja",
                        "latitude": "39.07029000",
                        "longitude": "-8.86822000"
                    },
                    {
                        "id": 89017,
                        "name": "Barcarena",
                        "latitude": "38.73245000",
                        "longitude": "-9.28000000"
                    },
                    {
                        "id": 89024,
                        "name": "Beato António",
                        "latitude": "38.73327000",
                        "longitude": "-9.10335000"
                    },
                    {
                        "id": 89028,
                        "name": "Belas",
                        "latitude": "38.77670000",
                        "longitude": "-9.26353000"
                    },
                    {
                        "id": 89034,
                        "name": "Benfica",
                        "latitude": "38.75087000",
                        "longitude": "-9.20282000"
                    },
                    {
                        "id": 89040,
                        "name": "Bobadela",
                        "latitude": "38.80774000",
                        "longitude": "-9.09925000"
                    },
                    {
                        "id": 89051,
                        "name": "Bucelas",
                        "latitude": "38.90193000",
                        "longitude": "-9.11885000"
                    },
                    {
                        "id": 89053,
                        "name": "Cabanas de Torres",
                        "latitude": "39.15581000",
                        "longitude": "-9.06588000"
                    },
                    {
                        "id": 89059,
                        "name": "Cacém",
                        "latitude": "38.76698000",
                        "longitude": "-9.29793000"
                    },
                    {
                        "id": 89060,
                        "name": "Cadafais",
                        "latitude": "39.00461000",
                        "longitude": "-9.00419000"
                    },
                    {
                        "id": 89061,
                        "name": "Cadaval",
                        "latitude": "39.24621000",
                        "longitude": "-9.06738000"
                    },
                    {
                        "id": 89072,
                        "name": "Camarate",
                        "latitude": "38.80358000",
                        "longitude": "-9.12809000"
                    },
                    {
                        "id": 89075,
                        "name": "Campelos",
                        "latitude": "39.19678000",
                        "longitude": "-9.23519000"
                    },
                    {
                        "id": 89083,
                        "name": "Caneças",
                        "latitude": "38.81321000",
                        "longitude": "-9.22679000"
                    },
                    {
                        "id": 89092,
                        "name": "Carcavelos",
                        "latitude": "38.69105000",
                        "longitude": "-9.32215000"
                    },
                    {
                        "id": 89093,
                        "name": "Carnaxide",
                        "latitude": "38.72706000",
                        "longitude": "-9.24671000"
                    },
                    {
                        "id": 89096,
                        "name": "Carregado",
                        "latitude": "39.02362000",
                        "longitude": "-8.97692000"
                    },
                    {
                        "id": 89101,
                        "name": "Cascais",
                        "latitude": "38.69681000",
                        "longitude": "-9.42147000"
                    },
                    {
                        "id": 89103,
                        "name": "Castanheira do Ribatejo",
                        "latitude": "38.99298000",
                        "longitude": "-8.97346000"
                    },
                    {
                        "id": 89112,
                        "name": "Caxias",
                        "latitude": "38.70314000",
                        "longitude": "-9.27666000"
                    },
                    {
                        "id": 89117,
                        "name": "Charneca",
                        "latitude": "38.78351000",
                        "longitude": "-9.14348000"
                    },
                    {
                        "id": 89123,
                        "name": "Colares",
                        "latitude": "38.79921000",
                        "longitude": "-9.44691000"
                    },
                    {
                        "id": 89144,
                        "name": "Ericeira",
                        "latitude": "38.96275000",
                        "longitude": "-9.41563000"
                    },
                    {
                        "id": 89155,
                        "name": "Estoril",
                        "latitude": "38.70571000",
                        "longitude": "-9.39773000"
                    },
                    {
                        "id": 89165,
                        "name": "Famões",
                        "latitude": "38.78804000",
                        "longitude": "-9.21033000"
                    },
                    {
                        "id": 89186,
                        "name": "Fontanelas",
                        "latitude": "38.84806000",
                        "longitude": "-9.43942000"
                    },
                    {
                        "id": 89244,
                        "name": "Linda-a-Velha",
                        "latitude": "38.71446000",
                        "longitude": "-9.24220000"
                    },
                    {
                        "id": 89245,
                        "name": "Lisbon",
                        "latitude": "38.72635000",
                        "longitude": "-9.14843000"
                    },
                    {
                        "id": 89251,
                        "name": "Loures",
                        "latitude": "38.83091000",
                        "longitude": "-9.16845000"
                    },
                    {
                        "id": 89252,
                        "name": "Lourinhã",
                        "latitude": "39.24745000",
                        "longitude": "-9.31194000"
                    },
                    {
                        "id": 89268,
                        "name": "Mafra",
                        "latitude": "38.94107000",
                        "longitude": "-9.32636000"
                    },
                    {
                        "id": 89271,
                        "name": "Malveira",
                        "latitude": "38.93213000",
                        "longitude": "-9.25779000"
                    },
                    {
                        "id": 89283,
                        "name": "Massamá",
                        "latitude": "38.75279000",
                        "longitude": "-9.28110000"
                    },
                    {
                        "id": 89288,
                        "name": "Meca",
                        "latitude": "39.08178000",
                        "longitude": "-9.03459000"
                    },
                    {
                        "id": 89292,
                        "name": "Mem Martins",
                        "latitude": "38.79443000",
                        "longitude": "-9.34284000"
                    },
                    {
                        "id": 89296,
                        "name": "Milharado",
                        "latitude": "38.94732000",
                        "longitude": "-9.19914000"
                    },
                    {
                        "id": 89310,
                        "name": "Moita dos Ferreiros",
                        "latitude": "39.24825000",
                        "longitude": "-9.22355000"
                    },
                    {
                        "id": 89320,
                        "name": "Monte Estoril",
                        "latitude": "38.70636000",
                        "longitude": "-9.40595000"
                    },
                    {
                        "id": 89332,
                        "name": "Moscavide e Portela",
                        "latitude": "38.77929000",
                        "longitude": "-9.10222000"
                    },
                    {
                        "id": 89353,
                        "name": "Odivelas",
                        "latitude": "38.79269000",
                        "longitude": "-9.18380000"
                    },
                    {
                        "id": 89354,
                        "name": "Oeiras",
                        "latitude": "38.71371000",
                        "longitude": "-9.26832000"
                    },
                    {
                        "id": 89359,
                        "name": "Olivais",
                        "latitude": "38.76994000",
                        "longitude": "-9.10674000"
                    },
                    {
                        "id": 89361,
                        "name": "Olival do Basto",
                        "latitude": "38.79079000",
                        "longitude": "-9.16621000"
                    },
                    {
                        "id": 89371,
                        "name": "Ota",
                        "latitude": "39.11199000",
                        "longitude": "-8.99105000"
                    },
                    {
                        "id": 89386,
                        "name": "Paço de Arcos",
                        "latitude": "38.69569000",
                        "longitude": "-9.29143000"
                    },
                    {
                        "id": 89382,
                        "name": "Parede",
                        "latitude": "38.69282000",
                        "longitude": "-9.35412000"
                    },
                    {
                        "id": 89403,
                        "name": "Pero Pinheiro",
                        "latitude": "38.85783000",
                        "longitude": "-9.32352000"
                    },
                    {
                        "id": 89419,
                        "name": "Pontinha",
                        "latitude": "38.76771000",
                        "longitude": "-9.19935000"
                    },
                    {
                        "id": 89430,
                        "name": "Porto Salvo",
                        "latitude": "38.72293000",
                        "longitude": "-9.30473000"
                    },
                    {
                        "id": 89443,
                        "name": "Póvoa de Santa Iria",
                        "latitude": "38.86101000",
                        "longitude": "-9.06453000"
                    },
                    {
                        "id": 89444,
                        "name": "Póvoa de Santo Adrião",
                        "latitude": "38.80000000",
                        "longitude": "-9.16667000"
                    },
                    {
                        "id": 89439,
                        "name": "Prior Velho",
                        "latitude": "38.79174000",
                        "longitude": "-9.12119000"
                    },
                    {
                        "id": 89447,
                        "name": "Queijas",
                        "latitude": "38.71925000",
                        "longitude": "-9.26255000"
                    },
                    {
                        "id": 89448,
                        "name": "Queluz",
                        "latitude": "38.75657000",
                        "longitude": "-9.25451000"
                    },
                    {
                        "id": 89452,
                        "name": "Ramada",
                        "latitude": "38.80368000",
                        "longitude": "-9.18770000"
                    },
                    {
                        "id": 89476,
                        "name": "Rio de Mouro",
                        "latitude": "38.76613000",
                        "longitude": "-9.32804000"
                    },
                    {
                        "id": 89481,
                        "name": "Sacavém",
                        "latitude": "38.79202000",
                        "longitude": "-9.10801000"
                    },
                    {
                        "id": 89504,
                        "name": "Santa Iria da Azóia",
                        "latitude": "38.84110000",
                        "longitude": "-9.09908000"
                    },
                    {
                        "id": 89514,
                        "name": "Santo Antão do Tojal",
                        "latitude": "38.85151000",
                        "longitude": "-9.13975000"
                    },
                    {
                        "id": 89517,
                        "name": "Santo Isidoro",
                        "latitude": "38.99593000",
                        "longitude": "-9.39940000"
                    },
                    {
                        "id": 89520,
                        "name": "Santos-o-Velho",
                        "latitude": "38.70690000",
                        "longitude": "-9.15611000"
                    },
                    {
                        "id": 89557,
                        "name": "São Bartolomeu",
                        "latitude": "39.27511000",
                        "longitude": "-9.27885000"
                    },
                    {
                        "id": 89561,
                        "name": "São Domingos de Rana",
                        "latitude": "38.70194000",
                        "longitude": "-9.34083000"
                    },
                    {
                        "id": 89567,
                        "name": "São João da Talha",
                        "latitude": "38.82378000",
                        "longitude": "-9.09719000"
                    },
                    {
                        "id": 89568,
                        "name": "São João das Lampas",
                        "latitude": "38.87376000",
                        "longitude": "-9.39842000"
                    },
                    {
                        "id": 89571,
                        "name": "São João dos Montes",
                        "latitude": "38.93944000",
                        "longitude": "-9.01892000"
                    },
                    {
                        "id": 89580,
                        "name": "São Pedro da Cadeira",
                        "latitude": "39.06983000",
                        "longitude": "-9.37174000"
                    },
                    {
                        "id": 89543,
                        "name": "Silveira",
                        "latitude": "39.11120000",
                        "longitude": "-9.36430000"
                    },
                    {
                        "id": 89546,
                        "name": "Sintra",
                        "latitude": "38.81439000",
                        "longitude": "-9.38370000"
                    },
                    {
                        "id": 89548,
                        "name": "Sobral de Monte Agraço",
                        "latitude": "39.01958000",
                        "longitude": "-9.15081000"
                    },
                    {
                        "id": 89549,
                        "name": "Sobralinho",
                        "latitude": "38.91703000",
                        "longitude": "-9.02656000"
                    },
                    {
                        "id": 89602,
                        "name": "Terrugem",
                        "latitude": "38.70647000",
                        "longitude": "-9.28693000"
                    },
                    {
                        "id": 89608,
                        "name": "Torres Vedras",
                        "latitude": "39.09109000",
                        "longitude": "-9.25860000"
                    },
                    {
                        "id": 89617,
                        "name": "Unhos",
                        "latitude": "38.81958000",
                        "longitude": "-9.12007000"
                    },
                    {
                        "id": 89634,
                        "name": "Venda do Pinheiro",
                        "latitude": "38.92365000",
                        "longitude": "-9.23178000"
                    },
                    {
                        "id": 89636,
                        "name": "Ventosa",
                        "latitude": "39.12696000",
                        "longitude": "-9.08423000"
                    },
                    {
                        "id": 89638,
                        "name": "Vialonga",
                        "latitude": "38.87206000",
                        "longitude": "-9.07805000"
                    },
                    {
                        "id": 89649,
                        "name": "Vila Franca de Xira",
                        "latitude": "38.92137000",
                        "longitude": "-9.03220000"
                    },
                    {
                        "id": 89667,
                        "name": "Vila Verde",
                        "latitude": "39.15489000",
                        "longitude": "-9.11512000"
                    },
                    {
                        "id": 89681,
                        "name": "Vimeiro",
                        "latitude": "39.17768000",
                        "longitude": "-9.31702000"
                    }
                ]
            },
            {
                "id": 2231,
                "name": "Madeira",
                "iso2": "30",
                "latitude": "32.76070740",
                "longitude": "-16.95947230",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 89693,
                        "name": "Água de Pena",
                        "latitude": "32.70143000",
                        "longitude": "-16.77874000"
                    },
                    {
                        "id": 88978,
                        "name": "Arco da Calheta",
                        "latitude": "32.71502000",
                        "longitude": "-17.14974000"
                    },
                    {
                        "id": 89038,
                        "name": "Boaventura",
                        "latitude": "32.81846000",
                        "longitude": "-16.97268000"
                    },
                    {
                        "id": 89068,
                        "name": "Calheta",
                        "latitude": "32.71667000",
                        "longitude": "-17.18333000"
                    },
                    {
                        "id": 89071,
                        "name": "Camacha",
                        "latitude": "32.67919000",
                        "longitude": "-16.84462000"
                    },
                    {
                        "id": 89139,
                        "name": "Câmara de Lobos",
                        "latitude": "32.65043000",
                        "longitude": "-16.97718000"
                    },
                    {
                        "id": 89074,
                        "name": "Campanário",
                        "latitude": "32.66578000",
                        "longitude": "-17.03576000"
                    },
                    {
                        "id": 89084,
                        "name": "Canhas",
                        "latitude": "32.69465000",
                        "longitude": "-17.09867000"
                    },
                    {
                        "id": 89086,
                        "name": "Caniçal",
                        "latitude": "32.73834000",
                        "longitude": "-16.73836000"
                    },
                    {
                        "id": 89087,
                        "name": "Caniço",
                        "latitude": "32.65078000",
                        "longitude": "-16.83749000"
                    },
                    {
                        "id": 89138,
                        "name": "Curral das Freiras",
                        "latitude": "32.72029000",
                        "longitude": "-16.96993000"
                    },
                    {
                        "id": 89156,
                        "name": "Estreito da Calheta",
                        "latitude": "32.73704000",
                        "longitude": "-17.18674000"
                    },
                    {
                        "id": 89161,
                        "name": "Faial",
                        "latitude": "32.78333000",
                        "longitude": "-16.85000000"
                    },
                    {
                        "id": 89162,
                        "name": "Fajã da Ovelha",
                        "latitude": "32.77457000",
                        "longitude": "-17.23412000"
                    },
                    {
                        "id": 89197,
                        "name": "Funchal",
                        "latitude": "32.66568000",
                        "longitude": "-16.92547000"
                    },
                    {
                        "id": 89262,
                        "name": "Machico",
                        "latitude": "32.71620000",
                        "longitude": "-16.76758000"
                    },
                    {
                        "id": 89351,
                        "name": "Nossa Senhora do Monte",
                        "latitude": "32.66667000",
                        "longitude": "-16.90000000"
                    },
                    {
                        "id": 89414,
                        "name": "Ponta do Sol",
                        "latitude": "32.67980000",
                        "longitude": "-17.10000000"
                    },
                    {
                        "id": 89432,
                        "name": "Porto da Cruz",
                        "latitude": "32.76667000",
                        "longitude": "-16.83333000"
                    },
                    {
                        "id": 89429,
                        "name": "Porto Moniz",
                        "latitude": "32.86681000",
                        "longitude": "-17.16667000"
                    },
                    {
                        "id": 89431,
                        "name": "Porto Santo",
                        "latitude": "33.07145000",
                        "longitude": "-16.34304000"
                    },
                    {
                        "id": 89465,
                        "name": "Ribeira Brava",
                        "latitude": "32.67483000",
                        "longitude": "-17.06288000"
                    },
                    {
                        "id": 89499,
                        "name": "Santa Cruz",
                        "latitude": "32.68806000",
                        "longitude": "-16.79388000"
                    },
                    {
                        "id": 89509,
                        "name": "Santana",
                        "latitude": "32.80000000",
                        "longitude": "-16.88333000"
                    },
                    {
                        "id": 89563,
                        "name": "São Jorge",
                        "latitude": "32.81667000",
                        "longitude": "-16.90000000"
                    },
                    {
                        "id": 89575,
                        "name": "São Martinho",
                        "latitude": "32.64480000",
                        "longitude": "-16.93843000"
                    },
                    {
                        "id": 89585,
                        "name": "São Roque",
                        "latitude": "32.66667000",
                        "longitude": "-16.91667000"
                    },
                    {
                        "id": 89591,
                        "name": "São Vicente",
                        "latitude": "32.79673000",
                        "longitude": "-17.04323000"
                    }
                ]
            },
            {
                "id": 2232,
                "name": "Portalegre",
                "iso2": "12",
                "latitude": "39.29670860",
                "longitude": "-7.42847550",
                "type": "district",
                "cities": [
                    {
                        "id": 88953,
                        "name": "Alter do Chão",
                        "latitude": "39.23098000",
                        "longitude": "-7.74430000"
                    },
                    {
                        "id": 88995,
                        "name": "Arronches",
                        "latitude": "39.12242000",
                        "longitude": "-7.28619000"
                    },
                    {
                        "id": 88999,
                        "name": "Atalaia",
                        "latitude": "39.45551000",
                        "longitude": "-7.87295000"
                    },
                    {
                        "id": 89008,
                        "name": "Avis",
                        "latitude": "39.06448000",
                        "longitude": "-7.89560000"
                    },
                    {
                        "id": 89078,
                        "name": "Campo Maior",
                        "latitude": "39.02935000",
                        "longitude": "-7.06479000"
                    },
                    {
                        "id": 89107,
                        "name": "Castelo de Vide",
                        "latitude": "39.41624000",
                        "longitude": "-7.45680000"
                    },
                    {
                        "id": 89134,
                        "name": "Crato",
                        "latitude": "39.28657000",
                        "longitude": "-7.64408000"
                    },
                    {
                        "id": 89142,
                        "name": "Elvas",
                        "latitude": "38.88150000",
                        "longitude": "-7.16282000"
                    },
                    {
                        "id": 89195,
                        "name": "Fronteira",
                        "latitude": "39.07179000",
                        "longitude": "-7.61052000"
                    },
                    {
                        "id": 89208,
                        "name": "Gavião",
                        "latitude": "39.44462000",
                        "longitude": "-7.89532000"
                    },
                    {
                        "id": 89282,
                        "name": "Marvão",
                        "latitude": "39.39377000",
                        "longitude": "-7.37663000"
                    },
                    {
                        "id": 89314,
                        "name": "Monforte",
                        "latitude": "39.04960000",
                        "longitude": "-7.44428000"
                    },
                    {
                        "id": 89319,
                        "name": "Montargil",
                        "latitude": "39.07771000",
                        "longitude": "-8.17044000"
                    },
                    {
                        "id": 89347,
                        "name": "Nisa",
                        "latitude": "39.51828000",
                        "longitude": "-7.67496000"
                    },
                    {
                        "id": 89418,
                        "name": "Ponte de Sor",
                        "latitude": "39.21441000",
                        "longitude": "-8.05420000"
                    },
                    {
                        "id": 89422,
                        "name": "Portalegre",
                        "latitude": "39.29740000",
                        "longitude": "-7.41538000"
                    },
                    {
                        "id": 89513,
                        "name": "Santo André",
                        "latitude": "39.05532000",
                        "longitude": "-8.24414000"
                    },
                    {
                        "id": 89553,
                        "name": "Sousel",
                        "latitude": "38.96685000",
                        "longitude": "-7.71788000"
                    },
                    {
                        "id": 89624,
                        "name": "Vale da Amoreira",
                        "latitude": "39.06969000",
                        "longitude": "-7.69849000"
                    }
                ]
            },
            {
                "id": 2243,
                "name": "Porto",
                "iso2": "13",
                "latitude": "41.14766290",
                "longitude": "-8.60789730",
                "type": "district",
                "cities": [
                    {
                        "id": 89691,
                        "name": "Água Longa",
                        "latitude": "41.24972000",
                        "longitude": "-8.49285000"
                    },
                    {
                        "id": 89694,
                        "name": "Águas Santas",
                        "latitude": "41.21017000",
                        "longitude": "-8.57599000"
                    },
                    {
                        "id": 88911,
                        "name": "Aguçadoura",
                        "latitude": "41.43116000",
                        "longitude": "-8.77844000"
                    },
                    {
                        "id": 88931,
                        "name": "Alfena",
                        "latitude": "41.23671000",
                        "longitude": "-8.52454000"
                    },
                    {
                        "id": 88951,
                        "name": "Alpendurada",
                        "latitude": "41.08944000",
                        "longitude": "-8.24643000"
                    },
                    {
                        "id": 88961,
                        "name": "Amarante",
                        "latitude": "41.27271000",
                        "longitude": "-8.08245000"
                    },
                    {
                        "id": 88966,
                        "name": "Amorim",
                        "latitude": "41.40503000",
                        "longitude": "-8.75046000"
                    },
                    {
                        "id": 88971,
                        "name": "Anta",
                        "latitude": "41.26634000",
                        "longitude": "-8.62844000"
                    },
                    {
                        "id": 88982,
                        "name": "Arcozelo",
                        "latitude": "41.06187000",
                        "longitude": "-8.63192000"
                    },
                    {
                        "id": 88985,
                        "name": "Argivai",
                        "latitude": "41.37744000",
                        "longitude": "-8.72987000"
                    },
                    {
                        "id": 89696,
                        "name": "Árvore",
                        "latitude": "41.33922000",
                        "longitude": "-8.71806000"
                    },
                    {
                        "id": 89005,
                        "name": "Aver-o-Mar",
                        "latitude": "41.40607000",
                        "longitude": "-8.77958000"
                    },
                    {
                        "id": 89006,
                        "name": "Aves",
                        "latitude": "41.37034000",
                        "longitude": "-8.41010000"
                    },
                    {
                        "id": 89007,
                        "name": "Avintes",
                        "latitude": "41.10711000",
                        "longitude": "-8.55131000"
                    },
                    {
                        "id": 89011,
                        "name": "Azenha",
                        "latitude": "41.07651000",
                        "longitude": "-8.62468000"
                    },
                    {
                        "id": 89013,
                        "name": "Baguim do Monte",
                        "latitude": "41.19203000",
                        "longitude": "-8.54118000"
                    },
                    {
                        "id": 89014,
                        "name": "Baião",
                        "latitude": "41.16384000",
                        "longitude": "-8.03581000"
                    },
                    {
                        "id": 89015,
                        "name": "Balazar",
                        "latitude": "41.40435000",
                        "longitude": "-8.62386000"
                    },
                    {
                        "id": 89016,
                        "name": "Baltar",
                        "latitude": "41.19272000",
                        "longitude": "-8.38768000"
                    },
                    {
                        "id": 89022,
                        "name": "Barrosas",
                        "latitude": "41.35534000",
                        "longitude": "-8.29943000"
                    },
                    {
                        "id": 89026,
                        "name": "Beiriz de Baixo",
                        "latitude": "41.39727000",
                        "longitude": "-8.72385000"
                    },
                    {
                        "id": 89045,
                        "name": "Bougado",
                        "latitude": "41.33979000",
                        "longitude": "-8.55180000"
                    },
                    {
                        "id": 89077,
                        "name": "Campo",
                        "latitude": "41.18516000",
                        "longitude": "-8.46493000"
                    },
                    {
                        "id": 89082,
                        "name": "Canelas",
                        "latitude": "41.08333000",
                        "longitude": "-8.60000000"
                    },
                    {
                        "id": 89085,
                        "name": "Canidelo",
                        "latitude": "41.12314000",
                        "longitude": "-8.64654000"
                    },
                    {
                        "id": 89099,
                        "name": "Carvalhosa",
                        "latitude": "41.30057000",
                        "longitude": "-8.36080000"
                    },
                    {
                        "id": 89108,
                        "name": "Castelões de Cepeda",
                        "latitude": "41.20265000",
                        "longitude": "-8.33516000"
                    },
                    {
                        "id": 89145,
                        "name": "Ermesinde",
                        "latitude": "41.21653000",
                        "longitude": "-8.55318000"
                    },
                    {
                        "id": 89154,
                        "name": "Estela",
                        "latitude": "41.44944000",
                        "longitude": "-8.75166000"
                    },
                    {
                        "id": 89202,
                        "name": "Fânzeres",
                        "latitude": "41.16754000",
                        "longitude": "-8.52981000"
                    },
                    {
                        "id": 89171,
                        "name": "Felgueiras",
                        "latitude": "41.34774000",
                        "longitude": "-8.20808000"
                    },
                    {
                        "id": 89175,
                        "name": "Ferreira",
                        "latitude": "41.26718000",
                        "longitude": "-8.34434000"
                    },
                    {
                        "id": 89183,
                        "name": "Figueiró",
                        "latitude": "41.29922000",
                        "longitude": "-8.16779000"
                    },
                    {
                        "id": 89189,
                        "name": "Foz do Douro",
                        "latitude": "41.15119000",
                        "longitude": "-8.67125000"
                    },
                    {
                        "id": 89190,
                        "name": "Foz do Sousa",
                        "latitude": "41.09668000",
                        "longitude": "-8.50184000"
                    },
                    {
                        "id": 89192,
                        "name": "Frazão",
                        "latitude": "41.25866000",
                        "longitude": "-8.40014000"
                    },
                    {
                        "id": 89193,
                        "name": "Freamunde",
                        "latitude": "41.28835000",
                        "longitude": "-8.33533000"
                    },
                    {
                        "id": 89206,
                        "name": "Gandra",
                        "latitude": "41.20116000",
                        "longitude": "-8.43376000"
                    },
                    {
                        "id": 89209,
                        "name": "Gemunde",
                        "latitude": "41.26766000",
                        "longitude": "-8.64515000"
                    },
                    {
                        "id": 89213,
                        "name": "Gondomar",
                        "latitude": "41.12015000",
                        "longitude": "-8.49595000"
                    },
                    {
                        "id": 89214,
                        "name": "Grijó",
                        "latitude": "41.02836000",
                        "longitude": "-8.58017000"
                    },
                    {
                        "id": 89218,
                        "name": "Guifões",
                        "latitude": "41.19748000",
                        "longitude": "-8.66899000"
                    },
                    {
                        "id": 89221,
                        "name": "Gulpilhares",
                        "latitude": "41.08292000",
                        "longitude": "-8.62679000"
                    },
                    {
                        "id": 89226,
                        "name": "Jovim",
                        "latitude": "41.11102000",
                        "longitude": "-8.51903000"
                    },
                    {
                        "id": 89239,
                        "name": "Lavra",
                        "latitude": "41.25935000",
                        "longitude": "-8.71849000"
                    },
                    {
                        "id": 89242,
                        "name": "Leça da Palmeira",
                        "latitude": "41.19100000",
                        "longitude": "-8.70027000"
                    },
                    {
                        "id": 89243,
                        "name": "Leça do Bailio",
                        "latitude": "41.21201000",
                        "longitude": "-8.63422000"
                    },
                    {
                        "id": 89247,
                        "name": "Lordelo",
                        "latitude": "41.23451000",
                        "longitude": "-8.40297000"
                    },
                    {
                        "id": 89255,
                        "name": "Lousada",
                        "latitude": "41.28355000",
                        "longitude": "-8.27437000"
                    },
                    {
                        "id": 89258,
                        "name": "Lustosa",
                        "latitude": "41.34081000",
                        "longitude": "-8.31715000"
                    },
                    {
                        "id": 89266,
                        "name": "Madalena",
                        "latitude": "41.21616000",
                        "longitude": "-8.33451000"
                    },
                    {
                        "id": 89270,
                        "name": "Maia",
                        "latitude": "41.24254000",
                        "longitude": "-8.60257000"
                    },
                    {
                        "id": 89274,
                        "name": "Marco de Canaveses",
                        "latitude": "41.15545000",
                        "longitude": "-8.16954000"
                    },
                    {
                        "id": 89275,
                        "name": "Marco de Canavezes",
                        "latitude": "41.18389000",
                        "longitude": "-8.14864000"
                    },
                    {
                        "id": 89276,
                        "name": "Margaride",
                        "latitude": "41.36478000",
                        "longitude": "-8.19999000"
                    },
                    {
                        "id": 89284,
                        "name": "Matosinhos",
                        "latitude": "41.18207000",
                        "longitude": "-8.68908000"
                    },
                    {
                        "id": 89289,
                        "name": "Meinedo",
                        "latitude": "41.24827000",
                        "longitude": "-8.25807000"
                    },
                    {
                        "id": 89291,
                        "name": "Melres",
                        "latitude": "41.06989000",
                        "longitude": "-8.40091000"
                    },
                    {
                        "id": 89297,
                        "name": "Milheirós",
                        "latitude": "41.21478000",
                        "longitude": "-8.58837000"
                    },
                    {
                        "id": 89301,
                        "name": "Mindelo",
                        "latitude": "41.31527000",
                        "longitude": "-8.72124000"
                    },
                    {
                        "id": 89329,
                        "name": "Moreira",
                        "latitude": "41.05600000",
                        "longitude": "-8.38939000"
                    },
                    {
                        "id": 89344,
                        "name": "Negrelos",
                        "latitude": "41.34946000",
                        "longitude": "-8.40145000"
                    },
                    {
                        "id": 89348,
                        "name": "Nogueira",
                        "latitude": "41.24246000",
                        "longitude": "-8.58685000"
                    },
                    {
                        "id": 89360,
                        "name": "Olival",
                        "latitude": "41.05024000",
                        "longitude": "-8.54416000"
                    },
                    {
                        "id": 89367,
                        "name": "Oliveira do Douro",
                        "latitude": "41.12466000",
                        "longitude": "-8.58463000"
                    },
                    {
                        "id": 89388,
                        "name": "Paços de Ferreira",
                        "latitude": "41.28964000",
                        "longitude": "-8.37584000"
                    },
                    {
                        "id": 89383,
                        "name": "Paredes",
                        "latitude": "41.20501000",
                        "longitude": "-8.37506000"
                    },
                    {
                        "id": 89389,
                        "name": "Pedroso",
                        "latitude": "41.41103000",
                        "longitude": "-8.74897000"
                    },
                    {
                        "id": 89390,
                        "name": "Pedrouços",
                        "latitude": "41.18880000",
                        "longitude": "-8.58624000"
                    },
                    {
                        "id": 89394,
                        "name": "Penafiel",
                        "latitude": "41.20931000",
                        "longitude": "-8.26996000"
                    },
                    {
                        "id": 89401,
                        "name": "Perafita",
                        "latitude": "41.18252000",
                        "longitude": "-8.25450000"
                    },
                    {
                        "id": 89404,
                        "name": "Perozinho",
                        "latitude": "41.06513000",
                        "longitude": "-8.58531000"
                    },
                    {
                        "id": 89425,
                        "name": "Porto",
                        "latitude": "41.14961000",
                        "longitude": "-8.61099000"
                    },
                    {
                        "id": 89445,
                        "name": "Póvoa de Varzim",
                        "latitude": "41.38344000",
                        "longitude": "-8.76364000"
                    },
                    {
                        "id": 89455,
                        "name": "Rebordões",
                        "latitude": "41.35509000",
                        "longitude": "-8.42355000"
                    },
                    {
                        "id": 89454,
                        "name": "Rebordosa",
                        "latitude": "41.22405000",
                        "longitude": "-8.40669000"
                    },
                    {
                        "id": 89456,
                        "name": "Recarei",
                        "latitude": "41.15356000",
                        "longitude": "-8.41178000"
                    },
                    {
                        "id": 89472,
                        "name": "Rio Mau",
                        "latitude": "41.40422000",
                        "longitude": "-8.67994000"
                    },
                    {
                        "id": 89474,
                        "name": "Rio Tinto",
                        "latitude": "41.17872000",
                        "longitude": "-8.55953000"
                    },
                    {
                        "id": 89491,
                        "name": "Sandim",
                        "latitude": "41.03508000",
                        "longitude": "-8.50700000"
                    },
                    {
                        "id": 89503,
                        "name": "Santa Cruz do Bispo",
                        "latitude": "41.21462000",
                        "longitude": "-8.67406000"
                    },
                    {
                        "id": 89518,
                        "name": "Santo Izidoro",
                        "latitude": "41.21083000",
                        "longitude": "-8.14224000"
                    },
                    {
                        "id": 89519,
                        "name": "Santo Tirso",
                        "latitude": "41.33014000",
                        "longitude": "-8.43827000"
                    },
                    {
                        "id": 89562,
                        "name": "São Félix da Marinha",
                        "latitude": "41.03555000",
                        "longitude": "-8.62259000"
                    },
                    {
                        "id": 89573,
                        "name": "São Mamede de Infesta",
                        "latitude": "41.19183000",
                        "longitude": "-8.61105000"
                    },
                    {
                        "id": 89579,
                        "name": "São Miguel do Couto",
                        "latitude": "41.33167000",
                        "longitude": "-8.46185000"
                    },
                    {
                        "id": 89581,
                        "name": "São Pedro da Cova",
                        "latitude": "41.14331000",
                        "longitude": "-8.50033000"
                    },
                    {
                        "id": 89584,
                        "name": "São Romão do Coronado",
                        "latitude": "41.28544000",
                        "longitude": "-8.56320000"
                    },
                    {
                        "id": 89527,
                        "name": "Senhora da Hora",
                        "latitude": "41.18641000",
                        "longitude": "-8.65172000"
                    },
                    {
                        "id": 89530,
                        "name": "Sermonde",
                        "latitude": "41.04712000",
                        "longitude": "-8.58449000"
                    },
                    {
                        "id": 89532,
                        "name": "Seroa",
                        "latitude": "41.26511000",
                        "longitude": "-8.42892000"
                    },
                    {
                        "id": 89538,
                        "name": "Serzedo",
                        "latitude": "41.05105000",
                        "longitude": "-8.61605000"
                    },
                    {
                        "id": 89547,
                        "name": "Sobrado",
                        "latitude": "41.21041000",
                        "longitude": "-8.45488000"
                    },
                    {
                        "id": 89600,
                        "name": "Telões",
                        "latitude": "41.31054000",
                        "longitude": "-8.11101000"
                    },
                    {
                        "id": 89613,
                        "name": "Trofa",
                        "latitude": "41.30646000",
                        "longitude": "-8.57640000"
                    },
                    {
                        "id": 89620,
                        "name": "Vairão",
                        "latitude": "41.33290000",
                        "longitude": "-8.66657000"
                    },
                    {
                        "id": 89621,
                        "name": "Valadares",
                        "latitude": "41.14737000",
                        "longitude": "-7.98120000"
                    },
                    {
                        "id": 89623,
                        "name": "Valbom",
                        "latitude": "41.12921000",
                        "longitude": "-8.56199000"
                    },
                    {
                        "id": 89631,
                        "name": "Valongo",
                        "latitude": "41.20797000",
                        "longitude": "-8.50086000"
                    },
                    {
                        "id": 89672,
                        "name": "Vila do Conde",
                        "latitude": "41.35326000",
                        "longitude": "-8.74516000"
                    },
                    {
                        "id": 89652,
                        "name": "Vila Meã",
                        "latitude": "41.25116000",
                        "longitude": "-8.18397000"
                    },
                    {
                        "id": 89655,
                        "name": "Vila Nova da Telha",
                        "latitude": "41.07170000",
                        "longitude": "-8.64146000"
                    },
                    {
                        "id": 89657,
                        "name": "Vila Nova de Gaia",
                        "latitude": "41.12401000",
                        "longitude": "-8.61241000"
                    },
                    {
                        "id": 89675,
                        "name": "Vilar de Andorinho",
                        "latitude": "41.10574000",
                        "longitude": "-8.58622000"
                    },
                    {
                        "id": 89677,
                        "name": "Vilar do Paraíso",
                        "latitude": "41.08974000",
                        "longitude": "-8.62110000"
                    },
                    {
                        "id": 89678,
                        "name": "Vilarinho",
                        "latitude": "41.35955000",
                        "longitude": "-8.33123000"
                    },
                    {
                        "id": 89685,
                        "name": "Vizela",
                        "latitude": "41.38242000",
                        "longitude": "-8.24887000"
                    }
                ]
            },
            {
                "id": 2238,
                "name": "Santarém",
                "iso2": "14",
                "latitude": "39.23666870",
                "longitude": "-8.68599440",
                "type": "district",
                "cities": [
                    {
                        "id": 88906,
                        "name": "Abrantes",
                        "latitude": "39.46667000",
                        "longitude": "-8.20000000"
                    },
                    {
                        "id": 88916,
                        "name": "Alcanede",
                        "latitude": "39.41501000",
                        "longitude": "-8.82189000"
                    },
                    {
                        "id": 88917,
                        "name": "Alcanena",
                        "latitude": "39.45900000",
                        "longitude": "-8.66892000"
                    },
                    {
                        "id": 88918,
                        "name": "Alcanhões",
                        "latitude": "39.29603000",
                        "longitude": "-8.65847000"
                    },
                    {
                        "id": 88932,
                        "name": "Alferrarede",
                        "latitude": "39.48333000",
                        "longitude": "-8.16667000"
                    },
                    {
                        "id": 88948,
                        "name": "Almeirim",
                        "latitude": "39.20837000",
                        "longitude": "-8.62635000"
                    },
                    {
                        "id": 88952,
                        "name": "Alpiarça",
                        "latitude": "39.25712000",
                        "longitude": "-8.58187000"
                    },
                    {
                        "id": 88963,
                        "name": "Amiães de Baixo",
                        "latitude": "39.44296000",
                        "longitude": "-8.73358000"
                    },
                    {
                        "id": 89012,
                        "name": "Azinhaga",
                        "latitude": "39.34877000",
                        "longitude": "-8.53005000"
                    },
                    {
                        "id": 89031,
                        "name": "Bemfica",
                        "latitude": "39.14325000",
                        "longitude": "-8.68717000"
                    },
                    {
                        "id": 89032,
                        "name": "Benavente",
                        "latitude": "38.90800000",
                        "longitude": "-8.76898000"
                    },
                    {
                        "id": 89098,
                        "name": "Cartaxo",
                        "latitude": "39.15377000",
                        "longitude": "-8.81373000"
                    },
                    {
                        "id": 89116,
                        "name": "Chamusca",
                        "latitude": "39.29900000",
                        "longitude": "-8.39933000"
                    },
                    {
                        "id": 89127,
                        "name": "Constância",
                        "latitude": "39.45718000",
                        "longitude": "-8.30368000"
                    },
                    {
                        "id": 89130,
                        "name": "Coruche",
                        "latitude": "38.95950000",
                        "longitude": "-8.52745000"
                    },
                    {
                        "id": 89143,
                        "name": "Entroncamento",
                        "latitude": "39.46667000",
                        "longitude": "-8.46667000"
                    },
                    {
                        "id": 89201,
                        "name": "Fátima",
                        "latitude": "39.62071000",
                        "longitude": "-8.65237000"
                    },
                    {
                        "id": 89169,
                        "name": "Fazendas de Almeirim",
                        "latitude": "39.17553000",
                        "longitude": "-8.56927000"
                    },
                    {
                        "id": 89177,
                        "name": "Ferreira do Zêzere",
                        "latitude": "39.72303000",
                        "longitude": "-8.31661000"
                    },
                    {
                        "id": 89211,
                        "name": "Golegã",
                        "latitude": "39.38683000",
                        "longitude": "-8.50591000"
                    },
                    {
                        "id": 89285,
                        "name": "Mação",
                        "latitude": "39.59331000",
                        "longitude": "-7.99772000"
                    },
                    {
                        "id": 89265,
                        "name": "Madalena",
                        "latitude": "39.57133000",
                        "longitude": "-8.44635000"
                    },
                    {
                        "id": 89278,
                        "name": "Marinhais",
                        "latitude": "39.04730000",
                        "longitude": "-8.70236000"
                    },
                    {
                        "id": 89300,
                        "name": "Minde",
                        "latitude": "39.51631000",
                        "longitude": "-8.68799000"
                    },
                    {
                        "id": 89315,
                        "name": "Monsanto",
                        "latitude": "39.46203000",
                        "longitude": "-8.71180000"
                    },
                    {
                        "id": 89317,
                        "name": "Montalvinho",
                        "latitude": "39.48333000",
                        "longitude": "-8.30000000"
                    },
                    {
                        "id": 89318,
                        "name": "Montalvo",
                        "latitude": "39.48333000",
                        "longitude": "-8.30000000"
                    },
                    {
                        "id": 89373,
                        "name": "Ourém",
                        "latitude": "39.66179000",
                        "longitude": "-8.57895000"
                    },
                    {
                        "id": 89376,
                        "name": "Paialvo",
                        "latitude": "39.56399000",
                        "longitude": "-8.46835000"
                    },
                    {
                        "id": 89392,
                        "name": "Pego",
                        "latitude": "39.46146000",
                        "longitude": "-8.14955000"
                    },
                    {
                        "id": 89408,
                        "name": "Pinheiro Grande",
                        "latitude": "39.39212000",
                        "longitude": "-8.43410000"
                    },
                    {
                        "id": 89409,
                        "name": "Poceirão",
                        "latitude": "38.83095000",
                        "longitude": "-8.79365000"
                    },
                    {
                        "id": 89420,
                        "name": "Pontével",
                        "latitude": "39.14945000",
                        "longitude": "-8.83880000"
                    },
                    {
                        "id": 89438,
                        "name": "Praia do Ribatejo",
                        "latitude": "39.46667000",
                        "longitude": "-8.35000000"
                    },
                    {
                        "id": 89463,
                        "name": "Riachos",
                        "latitude": "39.44472000",
                        "longitude": "-8.51420000"
                    },
                    {
                        "id": 89471,
                        "name": "Rio Maior",
                        "latitude": "39.34288000",
                        "longitude": "-8.93806000"
                    },
                    {
                        "id": 89486,
                        "name": "Salvaterra de Magos",
                        "latitude": "39.04482000",
                        "longitude": "-8.68903000"
                    },
                    {
                        "id": 89488,
                        "name": "Samora Correia",
                        "latitude": "38.93709000",
                        "longitude": "-8.87178000"
                    },
                    {
                        "id": 89506,
                        "name": "Santa Margarida da Coutada",
                        "latitude": "39.45000000",
                        "longitude": "-8.31667000"
                    },
                    {
                        "id": 89510,
                        "name": "Santarém",
                        "latitude": "39.23333000",
                        "longitude": "-8.68333000"
                    },
                    {
                        "id": 89578,
                        "name": "São Miguel de Rio Torto",
                        "latitude": "39.43333000",
                        "longitude": "-8.21667000"
                    },
                    {
                        "id": 89593,
                        "name": "São Vicente do Paul",
                        "latitude": "39.34946000",
                        "longitude": "-8.62221000"
                    },
                    {
                        "id": 89521,
                        "name": "Sardoal",
                        "latitude": "39.55643000",
                        "longitude": "-8.14323000"
                    },
                    {
                        "id": 89604,
                        "name": "Tomar",
                        "latitude": "39.60199000",
                        "longitude": "-8.40924000"
                    },
                    {
                        "id": 89607,
                        "name": "Torres Novas",
                        "latitude": "39.49160000",
                        "longitude": "-8.54796000"
                    },
                    {
                        "id": 89610,
                        "name": "Tramagal",
                        "latitude": "39.45000000",
                        "longitude": "-8.25000000"
                    },
                    {
                        "id": 89626,
                        "name": "Vale de Figueira",
                        "latitude": "39.30569000",
                        "longitude": "-8.62876000"
                    },
                    {
                        "id": 89627,
                        "name": "Vale de Santarém",
                        "latitude": "39.19052000",
                        "longitude": "-8.72735000"
                    },
                    {
                        "id": 89646,
                        "name": "Vila Chã de Ourique",
                        "latitude": "39.17219000",
                        "longitude": "-8.76658000"
                    },
                    {
                        "id": 89654,
                        "name": "Vila Nova da Barquinha",
                        "latitude": "39.46081000",
                        "longitude": "-8.43588000"
                    }
                ]
            },
            {
                "id": 2242,
                "name": "Setúbal",
                "iso2": "15",
                "latitude": "38.52409330",
                "longitude": "-8.89258760",
                "type": "district",
                "cities": [
                    {
                        "id": 88924,
                        "name": "Alcácer do Sal",
                        "latitude": "38.37326000",
                        "longitude": "-8.51444000"
                    },
                    {
                        "id": 88921,
                        "name": "Alcochete",
                        "latitude": "38.73827000",
                        "longitude": "-8.97936000"
                    },
                    {
                        "id": 88927,
                        "name": "Aldeia de Paio Pires",
                        "latitude": "38.61667000",
                        "longitude": "-9.08333000"
                    },
                    {
                        "id": 88940,
                        "name": "Alhos Vedros",
                        "latitude": "38.65486000",
                        "longitude": "-9.02368000"
                    },
                    {
                        "id": 88945,
                        "name": "Almada",
                        "latitude": "38.67902000",
                        "longitude": "-9.15690000"
                    },
                    {
                        "id": 88965,
                        "name": "Amora",
                        "latitude": "38.62961000",
                        "longitude": "-9.11557000"
                    },
                    {
                        "id": 88992,
                        "name": "Arrentela",
                        "latitude": "38.62500000",
                        "longitude": "-9.10151000"
                    },
                    {
                        "id": 89010,
                        "name": "Azeitão",
                        "latitude": "38.51919000",
                        "longitude": "-9.01390000"
                    },
                    {
                        "id": 89021,
                        "name": "Barreiro",
                        "latitude": "38.66314000",
                        "longitude": "-9.07240000"
                    },
                    {
                        "id": 89058,
                        "name": "Cacilhas",
                        "latitude": "38.68638000",
                        "longitude": "-9.14938000"
                    },
                    {
                        "id": 89089,
                        "name": "Caparica",
                        "latitude": "38.66179000",
                        "longitude": "-9.20032000"
                    },
                    {
                        "id": 89115,
                        "name": "Cercal",
                        "latitude": "37.80129000",
                        "longitude": "-8.67400000"
                    },
                    {
                        "id": 89118,
                        "name": "Charneca de Caparica",
                        "latitude": "38.62032000",
                        "longitude": "-9.19426000"
                    },
                    {
                        "id": 89124,
                        "name": "Comporta",
                        "latitude": "38.38059000",
                        "longitude": "-8.78608000"
                    },
                    {
                        "id": 89128,
                        "name": "Corroios",
                        "latitude": "38.64004000",
                        "longitude": "-9.15080000"
                    },
                    {
                        "id": 89132,
                        "name": "Costa de Caparica",
                        "latitude": "38.64458000",
                        "longitude": "-9.23556000"
                    },
                    {
                        "id": 89215,
                        "name": "Grândola",
                        "latitude": "38.18999000",
                        "longitude": "-8.61197000"
                    },
                    {
                        "id": 89236,
                        "name": "Laranjeira",
                        "latitude": "38.65599000",
                        "longitude": "-9.15376000"
                    },
                    {
                        "id": 89240,
                        "name": "Lavradio",
                        "latitude": "38.66808000",
                        "longitude": "-9.05204000"
                    },
                    {
                        "id": 89309,
                        "name": "Moita",
                        "latitude": "38.65854000",
                        "longitude": "-9.01040000"
                    },
                    {
                        "id": 89326,
                        "name": "Montijo",
                        "latitude": "38.72990000",
                        "longitude": "-8.69364000"
                    },
                    {
                        "id": 89377,
                        "name": "Palmela",
                        "latitude": "38.56902000",
                        "longitude": "-8.90126000"
                    },
                    {
                        "id": 89406,
                        "name": "Piedade",
                        "latitude": "38.67005000",
                        "longitude": "-9.15852000"
                    },
                    {
                        "id": 89407,
                        "name": "Pinhal Novo",
                        "latitude": "38.63106000",
                        "longitude": "-8.91376000"
                    },
                    {
                        "id": 89426,
                        "name": "Porto Covo",
                        "latitude": "37.85256000",
                        "longitude": "-8.79018000"
                    },
                    {
                        "id": 89436,
                        "name": "Pragal",
                        "latitude": "38.67459000",
                        "longitude": "-9.16981000"
                    },
                    {
                        "id": 89450,
                        "name": "Quinta do Anjo",
                        "latitude": "38.56753000",
                        "longitude": "-8.94228000"
                    },
                    {
                        "id": 89449,
                        "name": "Quinta Do Conde",
                        "latitude": "38.56528000",
                        "longitude": "-9.04316000"
                    },
                    {
                        "id": 89478,
                        "name": "Rosairinho",
                        "latitude": "38.67734000",
                        "longitude": "-9.00836000"
                    },
                    {
                        "id": 89489,
                        "name": "Samouco",
                        "latitude": "38.72035000",
                        "longitude": "-9.00471000"
                    },
                    {
                        "id": 89511,
                        "name": "Santiago do Cacém",
                        "latitude": "38.02502000",
                        "longitude": "-8.67577000"
                    },
                    {
                        "id": 89512,
                        "name": "Santo André",
                        "latitude": "38.06078000",
                        "longitude": "-8.78220000"
                    },
                    {
                        "id": 89515,
                        "name": "Santo António da Charneca",
                        "latitude": "38.62561000",
                        "longitude": "-9.03043000"
                    },
                    {
                        "id": 89522,
                        "name": "Sarilhos Pequenos",
                        "latitude": "38.68176000",
                        "longitude": "-8.98231000"
                    },
                    {
                        "id": 89523,
                        "name": "Seixal",
                        "latitude": "38.61173000",
                        "longitude": "-9.10371000"
                    },
                    {
                        "id": 89539,
                        "name": "Sesimbra",
                        "latitude": "38.49486000",
                        "longitude": "-9.12011000"
                    },
                    {
                        "id": 89540,
                        "name": "Setúbal",
                        "latitude": "38.52440000",
                        "longitude": "-8.88820000"
                    },
                    {
                        "id": 89545,
                        "name": "Sines",
                        "latitude": "37.95622000",
                        "longitude": "-8.86979000"
                    },
                    {
                        "id": 89550,
                        "name": "Sobreda",
                        "latitude": "38.64961000",
                        "longitude": "-9.18977000"
                    },
                    {
                        "id": 89609,
                        "name": "Trafaria",
                        "latitude": "38.67222000",
                        "longitude": "-9.23268000"
                    }
                ]
            },
            {
                "id": 2245,
                "name": "Viana do Castelo",
                "iso2": "16",
                "latitude": "41.69180460",
                "longitude": "-8.83445100",
                "type": "district",
                "cities": [
                    {
                        "id": 88981,
                        "name": "Arcos de Valdevez",
                        "latitude": "41.84668000",
                        "longitude": "-8.41905000"
                    },
                    {
                        "id": 89073,
                        "name": "Caminha",
                        "latitude": "41.84647000",
                        "longitude": "-8.80133000"
                    },
                    {
                        "id": 89290,
                        "name": "Melgaço",
                        "latitude": "42.08067000",
                        "longitude": "-8.24844000"
                    },
                    {
                        "id": 89327,
                        "name": "Monção",
                        "latitude": "42.07892000",
                        "longitude": "-8.48076000"
                    },
                    {
                        "id": 89384,
                        "name": "Paredes de Coura",
                        "latitude": "41.90995000",
                        "longitude": "-8.57034000"
                    },
                    {
                        "id": 89416,
                        "name": "Ponte da Barca",
                        "latitude": "41.80669000",
                        "longitude": "-8.31014000"
                    },
                    {
                        "id": 89417,
                        "name": "Ponte de Lima",
                        "latitude": "41.74682000",
                        "longitude": "-8.57637000"
                    },
                    {
                        "id": 89629,
                        "name": "Valença",
                        "latitude": "42.02821000",
                        "longitude": "-8.63388000"
                    },
                    {
                        "id": 89640,
                        "name": "Viana do Castelo",
                        "latitude": "41.69371000",
                        "longitude": "-8.83456000"
                    }
                ]
            },
            {
                "id": 2234,
                "name": "Vila Real",
                "iso2": "17",
                "latitude": "41.30035270",
                "longitude": "-7.74572740",
                "type": "district",
                "cities": [
                    {
                        "id": 88941,
                        "name": "Alijó",
                        "latitude": "41.28447000",
                        "longitude": "-7.48545000"
                    },
                    {
                        "id": 89044,
                        "name": "Boticas",
                        "latitude": "41.68939000",
                        "longitude": "-7.66914000"
                    },
                    {
                        "id": 89119,
                        "name": "Chaves",
                        "latitude": "41.73961000",
                        "longitude": "-7.45030000"
                    },
                    {
                        "id": 89168,
                        "name": "Favaios",
                        "latitude": "41.26876000",
                        "longitude": "-7.50465000"
                    },
                    {
                        "id": 89210,
                        "name": "Godim",
                        "latitude": "41.17104000",
                        "longitude": "-7.80303000"
                    },
                    {
                        "id": 89294,
                        "name": "Mesão Frio",
                        "latitude": "41.16190000",
                        "longitude": "-7.87284000"
                    },
                    {
                        "id": 89313,
                        "name": "Mondim de Basto",
                        "latitude": "41.41347000",
                        "longitude": "-7.95479000"
                    },
                    {
                        "id": 89316,
                        "name": "Montalegre",
                        "latitude": "41.83180000",
                        "longitude": "-7.78999000"
                    },
                    {
                        "id": 89339,
                        "name": "Murça",
                        "latitude": "41.41825000",
                        "longitude": "-7.45121000"
                    },
                    {
                        "id": 89405,
                        "name": "Peso da Régua",
                        "latitude": "41.19157000",
                        "longitude": "-7.83668000"
                    },
                    {
                        "id": 89468,
                        "name": "Ribeira de Pena",
                        "latitude": "41.51021000",
                        "longitude": "-7.79673000"
                    },
                    {
                        "id": 89480,
                        "name": "Sabrosa",
                        "latitude": "41.26702000",
                        "longitude": "-7.57601000"
                    },
                    {
                        "id": 89500,
                        "name": "Santa Cruz",
                        "latitude": "41.76007000",
                        "longitude": "-7.46834000"
                    },
                    {
                        "id": 89508,
                        "name": "Santa Marta de Penaguião",
                        "latitude": "41.20991000",
                        "longitude": "-7.78386000"
                    },
                    {
                        "id": 89551,
                        "name": "Sobreira",
                        "latitude": "41.52371000",
                        "longitude": "-7.80234000"
                    },
                    {
                        "id": 89632,
                        "name": "Valpaços",
                        "latitude": "41.62082000",
                        "longitude": "-7.33607000"
                    },
                    {
                        "id": 89661,
                        "name": "Vila Pouca de Aguiar",
                        "latitude": "41.52079000",
                        "longitude": "-7.63671000"
                    },
                    {
                        "id": 89663,
                        "name": "Vila Real",
                        "latitude": "41.30021000",
                        "longitude": "-7.73985000"
                    },
                    {
                        "id": 89680,
                        "name": "Vilela",
                        "latitude": "41.22511000",
                        "longitude": "-7.60338000"
                    }
                ]
            },
            {
                "id": 2237,
                "name": "Viseu",
                "iso2": "18",
                "latitude": "40.65884240",
                "longitude": "-7.91475600",
                "type": "district",
                "cities": [
                    {
                        "id": 88907,
                        "name": "Abraveses",
                        "latitude": "40.68137000",
                        "longitude": "-7.92102000"
                    },
                    {
                        "id": 88987,
                        "name": "Armamar",
                        "latitude": "41.09718000",
                        "longitude": "-7.68553000"
                    },
                    {
                        "id": 89054,
                        "name": "Cabanas de Viriato",
                        "latitude": "40.47662000",
                        "longitude": "-7.97445000"
                    },
                    {
                        "id": 89076,
                        "name": "Campo",
                        "latitude": "40.71086000",
                        "longitude": "-7.91445000"
                    },
                    {
                        "id": 89079,
                        "name": "Campo de Besteiros",
                        "latitude": "40.55655000",
                        "longitude": "-8.13432000"
                    },
                    {
                        "id": 89080,
                        "name": "Canas de Senhorim",
                        "latitude": "40.50012000",
                        "longitude": "-7.89874000"
                    },
                    {
                        "id": 89097,
                        "name": "Carregal do Sal",
                        "latitude": "40.45007000",
                        "longitude": "-7.99819000"
                    },
                    {
                        "id": 89109,
                        "name": "Castro Daire",
                        "latitude": "40.92279000",
                        "longitude": "-7.93878000"
                    },
                    {
                        "id": 89121,
                        "name": "Cinfães",
                        "latitude": "41.03986000",
                        "longitude": "-8.11218000"
                    },
                    {
                        "id": 89146,
                        "name": "Ervedosa do Douro",
                        "latitude": "41.16626000",
                        "longitude": "-7.47305000"
                    },
                    {
                        "id": 89235,
                        "name": "Lamego",
                        "latitude": "41.10229000",
                        "longitude": "-7.81025000"
                    },
                    {
                        "id": 89272,
                        "name": "Mangualde",
                        "latitude": "40.60425000",
                        "longitude": "-7.76115000"
                    },
                    {
                        "id": 89308,
                        "name": "Moimenta da Beira",
                        "latitude": "40.97134000",
                        "longitude": "-7.62959000"
                    },
                    {
                        "id": 89331,
                        "name": "Mortágua",
                        "latitude": "40.39434000",
                        "longitude": "-8.25811000"
                    },
                    {
                        "id": 89345,
                        "name": "Nelas",
                        "latitude": "40.53216000",
                        "longitude": "-7.85152000"
                    },
                    {
                        "id": 89365,
                        "name": "Oliveira de Frades",
                        "latitude": "40.73357000",
                        "longitude": "-8.17481000"
                    },
                    {
                        "id": 89395,
                        "name": "Penalva do Castelo",
                        "latitude": "40.66791000",
                        "longitude": "-7.66015000"
                    },
                    {
                        "id": 89398,
                        "name": "Penedono",
                        "latitude": "40.98875000",
                        "longitude": "-7.39386000"
                    },
                    {
                        "id": 89462,
                        "name": "Resende",
                        "latitude": "41.07688000",
                        "longitude": "-7.95123000"
                    },
                    {
                        "id": 89475,
                        "name": "Rio de Loba",
                        "latitude": "40.66596000",
                        "longitude": "-7.87781000"
                    },
                    {
                        "id": 89498,
                        "name": "Santa Comba Dão",
                        "latitude": "40.40442000",
                        "longitude": "-8.11380000"
                    },
                    {
                        "id": 89566,
                        "name": "São João da Pesqueira",
                        "latitude": "41.14805000",
                        "longitude": "-7.40489000"
                    },
                    {
                        "id": 89569,
                        "name": "São João de Areias",
                        "latitude": "40.38722000",
                        "longitude": "-8.06783000"
                    },
                    {
                        "id": 89583,
                        "name": "São Pedro do Sul",
                        "latitude": "40.80073000",
                        "longitude": "-8.09023000"
                    },
                    {
                        "id": 89556,
                        "name": "Sátão",
                        "latitude": "40.76246000",
                        "longitude": "-7.67600000"
                    },
                    {
                        "id": 89531,
                        "name": "Sernancelhe",
                        "latitude": "40.92097000",
                        "longitude": "-7.51226000"
                    },
                    {
                        "id": 89594,
                        "name": "Tabuaço",
                        "latitude": "41.09555000",
                        "longitude": "-7.56735000"
                    },
                    {
                        "id": 89595,
                        "name": "Tarouca",
                        "latitude": "41.02651000",
                        "longitude": "-7.74998000"
                    },
                    {
                        "id": 89605,
                        "name": "Tondela",
                        "latitude": "40.54052000",
                        "longitude": "-8.10040000"
                    },
                    {
                        "id": 89612,
                        "name": "Treixedo",
                        "latitude": "40.43246000",
                        "longitude": "-8.09428000"
                    },
                    {
                        "id": 89659,
                        "name": "Vila Nova de Paiva",
                        "latitude": "40.86590000",
                        "longitude": "-7.76127000"
                    },
                    {
                        "id": 89684,
                        "name": "Viseu",
                        "latitude": "40.67450000",
                        "longitude": "-7.91721000"
                    },
                    {
                        "id": 89687,
                        "name": "Vouzela",
                        "latitude": "40.68944000",
                        "longitude": "-8.11360000"
                    }
                ]
            }
        ]
    },
    {
        "id": 178,
        "name": "Puerto Rico",
        "iso3": "PRI",
        "iso2": "PR",
        "numeric_code": "630",
        "phonecode": "1",
        "capital": "San Juan",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".pr",
        "native": "Puerto Rico",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Puerto Rican",
        "timezones": [
            {
                "zoneName": "America\/Puerto_Rico",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": null,
        "latitude": "18.25000000",
        "longitude": "-66.50000000",
        "emoji": "🇵🇷",
        "emojiU": "U+1F1F5 U+1F1F7",
        "states": [
            {
                "id": 5134,
                "name": "Adjuntas",
                "iso2": "001",
                "latitude": "18.16348480",
                "longitude": "-66.72315800",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153549,
                        "name": "Adjuntas",
                        "latitude": "18.16348480",
                        "longitude": "-66.72315800"
                    }
                ]
            },
            {
                "id": 5135,
                "name": "Aguada",
                "iso2": "003",
                "latitude": "18.38015790",
                "longitude": "-67.18870400",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153550,
                        "name": "Aguada",
                        "latitude": "18.38015790",
                        "longitude": "-67.18870400"
                    }
                ]
            },
            {
                "id": 5136,
                "name": "Aguadilla",
                "iso2": "005",
                "latitude": "18.42744540",
                "longitude": "-67.15406980",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153551,
                        "name": "Aguadilla",
                        "latitude": "18.42744540",
                        "longitude": "-67.15406980"
                    }
                ]
            },
            {
                "id": 5137,
                "name": "Aguas Buenas",
                "iso2": "007",
                "latitude": "18.25689890",
                "longitude": "-66.10294420",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153552,
                        "name": "Aguas Buenas",
                        "latitude": "18.25689890",
                        "longitude": "-66.10294420"
                    }
                ]
            },
            {
                "id": 5138,
                "name": "Aibonito",
                "iso2": "009",
                "latitude": "18.13995940",
                "longitude": "-66.26600160",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153553,
                        "name": "Aibonito",
                        "latitude": "18.13995940",
                        "longitude": "-66.26600160"
                    }
                ]
            },
            {
                "id": 5139,
                "name": "Añasco",
                "iso2": "011",
                "latitude": "18.28544760",
                "longitude": "-67.14029350",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153554,
                        "name": "Añasco",
                        "latitude": "18.28544760",
                        "longitude": "-67.14029350"
                    }
                ]
            },
            {
                "id": 5140,
                "name": "Arecibo",
                "iso2": "013",
                "latitude": "18.47051370",
                "longitude": "-66.72184720",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153555,
                        "name": "Arecibo",
                        "latitude": "18.47051370",
                        "longitude": "-66.72184720"
                    }
                ]
            },
            {
                "id": 5081,
                "name": "Arecibo",
                "iso2": "AR",
                "latitude": "18.47055556",
                "longitude": "-66.72083333",
                "type": "region",
                "cities": []
            },
            {
                "id": 5141,
                "name": "Arroyo",
                "iso2": "015",
                "latitude": "17.99642200",
                "longitude": "-66.09248790",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153556,
                        "name": "Arroyo",
                        "latitude": "17.99642200",
                        "longitude": "-66.09248790"
                    }
                ]
            },
            {
                "id": 5142,
                "name": "Barceloneta",
                "iso2": "017",
                "latitude": "41.38010610",
                "longitude": "2.18969570",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153557,
                        "name": "Barceloneta",
                        "latitude": "41.38010610",
                        "longitude": "2.18969570"
                    }
                ]
            },
            {
                "id": 5143,
                "name": "Barranquitas",
                "iso2": "019",
                "latitude": "18.18662420",
                "longitude": "-66.30628020",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153558,
                        "name": "Barranquitas",
                        "latitude": "18.18662420",
                        "longitude": "-66.30628020"
                    }
                ]
            },
            {
                "id": 5076,
                "name": "Bayamon",
                "iso2": "BY",
                "latitude": "18.17777778",
                "longitude": "-66.11333333",
                "type": "region",
                "cities": []
            },
            {
                "id": 5144,
                "name": "Bayamón",
                "iso2": "021",
                "latitude": "18.38939600",
                "longitude": "-66.16532240",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153559,
                        "name": "Bayamón",
                        "latitude": "18.38939600",
                        "longitude": "-66.16532240"
                    }
                ]
            },
            {
                "id": 5145,
                "name": "Cabo Rojo",
                "iso2": "023",
                "latitude": "18.08662650",
                "longitude": "-67.14573470",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153560,
                        "name": "Cabo Rojo",
                        "latitude": "18.08662650",
                        "longitude": "-67.14573470"
                    }
                ]
            },
            {
                "id": 5079,
                "name": "Caguas",
                "iso2": "CG",
                "latitude": "18.23333333",
                "longitude": "-66.03333333",
                "type": "region",
                "cities": []
            },
            {
                "id": 5146,
                "name": "Caguas",
                "iso2": "025",
                "latitude": "18.23879950",
                "longitude": "-66.03524900",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153561,
                        "name": "Caguas",
                        "latitude": "18.23879950",
                        "longitude": "-66.03524900"
                    }
                ]
            },
            {
                "id": 5147,
                "name": "Camuy",
                "iso2": "027",
                "latitude": "18.48383300",
                "longitude": "-66.84489940",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153562,
                        "name": "Camuy",
                        "latitude": "18.48383300",
                        "longitude": "-66.84489940"
                    }
                ]
            },
            {
                "id": 5148,
                "name": "Canóvanas",
                "iso2": "029",
                "latitude": "18.37487480",
                "longitude": "-65.89975330",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153563,
                        "name": "Canóvanas",
                        "latitude": "18.37487480",
                        "longitude": "-65.89975330"
                    }
                ]
            },
            {
                "id": 5077,
                "name": "Carolina",
                "iso2": "CL",
                "latitude": "18.38888889",
                "longitude": "-65.96666667",
                "type": "region",
                "cities": []
            },
            {
                "id": 5149,
                "name": "Carolina",
                "iso2": "031",
                "latitude": "18.36808770",
                "longitude": "-66.04247340",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153564,
                        "name": "Carolina",
                        "latitude": "18.36808770",
                        "longitude": "-66.04247340"
                    }
                ]
            },
            {
                "id": 5150,
                "name": "Cataño",
                "iso2": "033",
                "latitude": "18.44653550",
                "longitude": "-66.13557750",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153565,
                        "name": "Cataño",
                        "latitude": "18.44653550",
                        "longitude": "-66.13557750"
                    }
                ]
            },
            {
                "id": 5151,
                "name": "Cayey",
                "iso2": "035",
                "latitude": "18.11190510",
                "longitude": "-66.16600000",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153566,
                        "name": "Cayey",
                        "latitude": "18.11190510",
                        "longitude": "-66.16600000"
                    }
                ]
            },
            {
                "id": 5152,
                "name": "Ceiba",
                "iso2": "037",
                "latitude": "18.24751770",
                "longitude": "-65.90849530",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153567,
                        "name": "Ceiba",
                        "latitude": "18.24751770",
                        "longitude": "-65.90849530"
                    }
                ]
            },
            {
                "id": 5153,
                "name": "Ciales",
                "iso2": "039",
                "latitude": "18.33606220",
                "longitude": "-66.46878230",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153568,
                        "name": "Ciales",
                        "latitude": "18.33606220",
                        "longitude": "-66.46878230"
                    }
                ]
            },
            {
                "id": 5154,
                "name": "Cidra",
                "iso2": "041",
                "latitude": "18.17579140",
                "longitude": "-66.16127790",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153569,
                        "name": "Cidra",
                        "latitude": "18.17579140",
                        "longitude": "-66.16127790"
                    }
                ]
            },
            {
                "id": 5155,
                "name": "Coamo",
                "iso2": "043",
                "latitude": "18.07996160",
                "longitude": "-66.35794730",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153570,
                        "name": "Coamo",
                        "latitude": "18.07996160",
                        "longitude": "-66.35794730"
                    }
                ]
            },
            {
                "id": 5156,
                "name": "Comerío",
                "iso2": "045",
                "latitude": "18.21920010",
                "longitude": "-66.22560220",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153571,
                        "name": "Comerío",
                        "latitude": "18.21920010",
                        "longitude": "-66.22560220"
                    }
                ]
            },
            {
                "id": 5157,
                "name": "Corozal",
                "iso2": "047",
                "latitude": "18.40308020",
                "longitude": "-88.39675360",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153572,
                        "name": "Corozal",
                        "latitude": "18.40308020",
                        "longitude": "-88.39675360"
                    }
                ]
            },
            {
                "id": 5158,
                "name": "Culebra",
                "iso2": "049",
                "latitude": "18.31039400",
                "longitude": "-65.30307050",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153573,
                        "name": "Culebra",
                        "latitude": "18.31039400",
                        "longitude": "-65.30307050"
                    }
                ]
            },
            {
                "id": 5159,
                "name": "Dorado",
                "iso2": "051",
                "latitude": "43.14805560",
                "longitude": "-77.57722220",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153574,
                        "name": "Dorado",
                        "latitude": "43.14805560",
                        "longitude": "-77.57722220"
                    }
                ]
            },
            {
                "id": 5160,
                "name": "Fajardo",
                "iso2": "053",
                "latitude": "18.32521480",
                "longitude": "-65.65393560",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153575,
                        "name": "Fajardo",
                        "latitude": "18.32521480",
                        "longitude": "-65.65393560"
                    }
                ]
            },
            {
                "id": 5161,
                "name": "Florida",
                "iso2": "054",
                "latitude": "18.37570160",
                "longitude": "-66.60225590",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153576,
                        "name": "Florida",
                        "latitude": "27.66482740",
                        "longitude": "-81.51575350"
                    }
                ]
            },
            {
                "id": 5162,
                "name": "Guánica",
                "iso2": "055",
                "latitude": "17.97251450",
                "longitude": "-66.90862640",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153577,
                        "name": "Guánica",
                        "latitude": "17.97251450",
                        "longitude": "-66.90862640"
                    }
                ]
            },
            {
                "id": 5163,
                "name": "Guayama",
                "iso2": "057",
                "latitude": "17.98413280",
                "longitude": "-66.11377670",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153578,
                        "name": "Guayama",
                        "latitude": "17.98413280",
                        "longitude": "-66.11377670"
                    }
                ]
            },
            {
                "id": 5164,
                "name": "Guayanilla",
                "iso2": "059",
                "latitude": "18.01913140",
                "longitude": "-66.79184200",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153579,
                        "name": "Guayanilla",
                        "latitude": "18.01913140",
                        "longitude": "-66.79184200"
                    }
                ]
            },
            {
                "id": 5080,
                "name": "Guaynabo",
                "iso2": "GN",
                "latitude": "18.36666667",
                "longitude": "-66.10000000",
                "type": "region",
                "cities": []
            },
            {
                "id": 5165,
                "name": "Guaynabo",
                "iso2": "061",
                "latitude": "18.36129540",
                "longitude": "-66.11029570",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153580,
                        "name": "Guaynabo",
                        "latitude": "18.36129540",
                        "longitude": "-66.11029570"
                    }
                ]
            },
            {
                "id": 5166,
                "name": "Gurabo",
                "iso2": "063",
                "latitude": "18.25439870",
                "longitude": "-65.97294210",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153581,
                        "name": "Gurabo",
                        "latitude": "18.25439870",
                        "longitude": "-65.97294210"
                    }
                ]
            },
            {
                "id": 5167,
                "name": "Hatillo",
                "iso2": "065",
                "latitude": "18.42846420",
                "longitude": "-66.78753210",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153582,
                        "name": "Hatillo",
                        "latitude": "18.42846420",
                        "longitude": "-66.78753210"
                    }
                ]
            },
            {
                "id": 5168,
                "name": "Hormigueros",
                "iso2": "067",
                "latitude": "18.13346380",
                "longitude": "-67.11281230",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153583,
                        "name": "Hormigueros",
                        "latitude": "18.13346380",
                        "longitude": "-67.11281230"
                    }
                ]
            },
            {
                "id": 5169,
                "name": "Humacao",
                "iso2": "069",
                "latitude": "18.15157360",
                "longitude": "-65.82485290",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153584,
                        "name": "Humacao",
                        "latitude": "18.15157360",
                        "longitude": "-65.82485290"
                    }
                ]
            },
            {
                "id": 5170,
                "name": "Isabela",
                "iso2": "071",
                "latitude": "18.44583340",
                "longitude": "-67.17710600",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153585,
                        "name": "Isabela",
                        "latitude": "16.97537580",
                        "longitude": "121.81070790"
                    }
                ]
            },
            {
                "id": 5171,
                "name": "Jayuya",
                "iso2": "073",
                "latitude": "18.21856740",
                "longitude": "-66.59156170",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153586,
                        "name": "Jayuya",
                        "latitude": "18.21856740",
                        "longitude": "-66.59156170"
                    }
                ]
            },
            {
                "id": 5172,
                "name": "Juana Díaz",
                "iso2": "075",
                "latitude": "18.05343720",
                "longitude": "-66.50750790",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153587,
                        "name": "Juana Díaz",
                        "latitude": "18.05343720",
                        "longitude": "-66.50750790"
                    }
                ]
            },
            {
                "id": 5173,
                "name": "Juncos",
                "iso2": "077",
                "latitude": "18.22745580",
                "longitude": "-65.92099700",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153588,
                        "name": "Juncos",
                        "latitude": "18.22745580",
                        "longitude": "-65.92099700"
                    }
                ]
            },
            {
                "id": 5174,
                "name": "Lajas",
                "iso2": "079",
                "latitude": "18.04996200",
                "longitude": "-67.05934490",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153589,
                        "name": "Lajas",
                        "latitude": "18.04996200",
                        "longitude": "-67.05934490"
                    }
                ]
            },
            {
                "id": 5175,
                "name": "Lares",
                "iso2": "081",
                "latitude": "34.02508020",
                "longitude": "-118.45945930",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153590,
                        "name": "Lares",
                        "latitude": "34.02508020",
                        "longitude": "-118.45945930"
                    }
                ]
            },
            {
                "id": 5176,
                "name": "Las Marías",
                "iso2": "083",
                "latitude": "35.83822380",
                "longitude": "-78.61035660",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153591,
                        "name": "Las Marías",
                        "latitude": "35.83822380",
                        "longitude": "-78.61035660"
                    }
                ]
            },
            {
                "id": 5177,
                "name": "Las Piedras",
                "iso2": "085",
                "latitude": "18.18557530",
                "longitude": "-65.87362450",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153592,
                        "name": "Las Piedras",
                        "latitude": "18.18557530",
                        "longitude": "-65.87362450"
                    }
                ]
            },
            {
                "id": 5178,
                "name": "Loíza",
                "iso2": "087",
                "latitude": "18.43299040",
                "longitude": "-65.87836000",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153593,
                        "name": "Loíza",
                        "latitude": "18.43299040",
                        "longitude": "-65.87836000"
                    }
                ]
            },
            {
                "id": 5179,
                "name": "Luquillo",
                "iso2": "089",
                "latitude": "18.37245070",
                "longitude": "-65.71655110",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153594,
                        "name": "Luquillo",
                        "latitude": "18.37245070",
                        "longitude": "-65.71655110"
                    }
                ]
            },
            {
                "id": 5180,
                "name": "Manatí",
                "iso2": "091",
                "latitude": "18.41812150",
                "longitude": "-66.52627830",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153595,
                        "name": "Manatí",
                        "latitude": "18.41812150",
                        "longitude": "-66.52627830"
                    }
                ]
            },
            {
                "id": 5181,
                "name": "Maricao",
                "iso2": "093",
                "latitude": "18.18079020",
                "longitude": "-66.97990010",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153596,
                        "name": "Maricao",
                        "latitude": "18.18079020",
                        "longitude": "-66.97990010"
                    }
                ]
            },
            {
                "id": 5182,
                "name": "Maunabo",
                "iso2": "095",
                "latitude": "18.00718850",
                "longitude": "-65.89932890",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153597,
                        "name": "Maunabo",
                        "latitude": "18.00718850",
                        "longitude": "-65.89932890"
                    }
                ]
            },
            {
                "id": 5083,
                "name": "Mayagüez",
                "iso2": "MG",
                "latitude": "18.20111111",
                "longitude": "-67.13972222",
                "type": "region",
                "cities": []
            },
            {
                "id": 5183,
                "name": "Mayagüez",
                "iso2": "097",
                "latitude": "18.20134520",
                "longitude": "-67.14515490",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153598,
                        "name": "Mayagüez",
                        "latitude": "18.20134520",
                        "longitude": "-67.14515490"
                    }
                ]
            },
            {
                "id": 5184,
                "name": "Moca",
                "iso2": "099",
                "latitude": "18.39679290",
                "longitude": "-67.14790350",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153599,
                        "name": "Moca",
                        "latitude": "18.39679290",
                        "longitude": "-67.14790350"
                    }
                ]
            },
            {
                "id": 5185,
                "name": "Morovis",
                "iso2": "101",
                "latitude": "18.32578500",
                "longitude": "-66.40655920",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153600,
                        "name": "Morovis",
                        "latitude": "18.32578500",
                        "longitude": "-66.40655920"
                    }
                ]
            },
            {
                "id": 5186,
                "name": "Naguabo",
                "iso2": "103",
                "latitude": "18.21162470",
                "longitude": "-65.73488410",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153601,
                        "name": "Naguabo",
                        "latitude": "18.21162470",
                        "longitude": "-65.73488410"
                    }
                ]
            },
            {
                "id": 5187,
                "name": "Naranjito",
                "iso2": "105",
                "latitude": "18.30078610",
                "longitude": "-66.24489040",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153602,
                        "name": "Naranjito",
                        "latitude": "18.30078610",
                        "longitude": "-66.24489040"
                    }
                ]
            },
            {
                "id": 5188,
                "name": "Orocovis",
                "iso2": "107",
                "latitude": "18.22692240",
                "longitude": "-66.39116860",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153603,
                        "name": "Orocovis",
                        "latitude": "18.22692240",
                        "longitude": "-66.39116860"
                    }
                ]
            },
            {
                "id": 5189,
                "name": "Patillas",
                "iso2": "109",
                "latitude": "18.00373810",
                "longitude": "-66.01340590",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153604,
                        "name": "Patillas",
                        "latitude": "18.00373810",
                        "longitude": "-66.01340590"
                    }
                ]
            },
            {
                "id": 5190,
                "name": "Peñuelas",
                "iso2": "111",
                "latitude": "18.06335770",
                "longitude": "-66.72738960",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153605,
                        "name": "Peñuelas",
                        "latitude": "18.06335770",
                        "longitude": "-66.72738960"
                    }
                ]
            },
            {
                "id": 5078,
                "name": "Ponce",
                "iso2": "PO",
                "latitude": "18.00000000",
                "longitude": "-66.61666667",
                "type": "region",
                "cities": []
            },
            {
                "id": 5191,
                "name": "Ponce",
                "iso2": "113",
                "latitude": "18.01107680",
                "longitude": "-66.61406160",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153606,
                        "name": "Ponce",
                        "latitude": "18.01107680",
                        "longitude": "-66.61406160"
                    }
                ]
            },
            {
                "id": 5192,
                "name": "Quebradillas",
                "iso2": "115",
                "latitude": "18.47383300",
                "longitude": "-66.93851200",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153607,
                        "name": "Quebradillas",
                        "latitude": "18.47383300",
                        "longitude": "-66.93851200"
                    }
                ]
            },
            {
                "id": 5193,
                "name": "Rincón",
                "iso2": "117",
                "latitude": "18.34015140",
                "longitude": "-67.24994590",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153608,
                        "name": "Rincón",
                        "latitude": "18.34015140",
                        "longitude": "-67.24994590"
                    }
                ]
            },
            {
                "id": 5194,
                "name": "Río Grande",
                "iso2": "119",
                "latitude": "28.81063826",
                "longitude": "-101.83538780",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153609,
                        "name": "Río Grande",
                        "latitude": "28.81063826",
                        "longitude": "-101.83538780"
                    }
                ]
            },
            {
                "id": 5195,
                "name": "Sabana Grande",
                "iso2": "121",
                "latitude": "18.07773920",
                "longitude": "-66.96045490",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153610,
                        "name": "Sabana Grande",
                        "latitude": "18.07773920",
                        "longitude": "-66.96045490"
                    }
                ]
            },
            {
                "id": 5196,
                "name": "Salinas",
                "iso2": "123",
                "latitude": "18.00472110",
                "longitude": "-66.41885240",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153611,
                        "name": "Salinas",
                        "latitude": "36.67773720",
                        "longitude": "-121.65550130"
                    }
                ]
            },
            {
                "id": 5197,
                "name": "San Germán",
                "iso2": "125",
                "latitude": "18.08070820",
                "longitude": "-67.04110960",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153612,
                        "name": "San Germán",
                        "latitude": "18.08070820",
                        "longitude": "-67.04110960"
                    }
                ]
            },
            {
                "id": 5198,
                "name": "San Juan",
                "iso2": "127",
                "latitude": "18.46320300",
                "longitude": "-66.11475710",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153613,
                        "name": "San Juan",
                        "latitude": "18.46320300",
                        "longitude": "-66.11475710"
                    }
                ]
            },
            {
                "id": 5075,
                "name": "San Juan",
                "iso2": "SJ",
                "latitude": "18.45000000",
                "longitude": "-66.06666667",
                "type": "region",
                "cities": []
            },
            {
                "id": 5199,
                "name": "San Lorenzo",
                "iso2": "129",
                "latitude": "18.18869120",
                "longitude": "-65.97658620",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153614,
                        "name": "San Lorenzo",
                        "latitude": "18.18869120",
                        "longitude": "-65.97658620"
                    }
                ]
            },
            {
                "id": 5200,
                "name": "San Sebastián",
                "iso2": "131",
                "latitude": "43.31833400",
                "longitude": "-1.98123130",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153615,
                        "name": "San Sebastián",
                        "latitude": "43.31833400",
                        "longitude": "-1.98123130"
                    }
                ]
            },
            {
                "id": 5201,
                "name": "Santa Isabel",
                "iso2": "133",
                "latitude": "17.96607750",
                "longitude": "-66.40489200",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153616,
                        "name": "Santa Isabel",
                        "latitude": "17.96607750",
                        "longitude": "-66.40489200"
                    }
                ]
            },
            {
                "id": 5202,
                "name": "Toa Alta",
                "iso2": "135",
                "latitude": "18.38828230",
                "longitude": "-66.24822370",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153617,
                        "name": "Toa Alta",
                        "latitude": "18.38828230",
                        "longitude": "-66.24822370"
                    }
                ]
            },
            {
                "id": 5082,
                "name": "Toa Baja",
                "iso2": "TB",
                "latitude": "18.44388900",
                "longitude": "-66.25972200",
                "type": "region",
                "cities": []
            },
            {
                "id": 5203,
                "name": "Toa Baja",
                "iso2": "137",
                "latitude": "18.44447090",
                "longitude": "-66.25432930",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153618,
                        "name": "Toa Baja",
                        "latitude": "18.44447090",
                        "longitude": "-66.25432930"
                    }
                ]
            },
            {
                "id": 5084,
                "name": "Trujillo Alto",
                "iso2": "TA",
                "latitude": "18.36277800",
                "longitude": "-66.01750000",
                "type": "region",
                "cities": []
            },
            {
                "id": 5204,
                "name": "Trujillo Alto",
                "iso2": "139",
                "latitude": "18.35467190",
                "longitude": "-66.00738760",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153619,
                        "name": "Trujillo Alto",
                        "latitude": "18.35467190",
                        "longitude": "-66.00738760"
                    }
                ]
            },
            {
                "id": 5205,
                "name": "Utuado",
                "iso2": "141",
                "latitude": "18.26550950",
                "longitude": "-66.70045190",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153620,
                        "name": "Utuado",
                        "latitude": "18.26550950",
                        "longitude": "-66.70045190"
                    }
                ]
            },
            {
                "id": 5206,
                "name": "Vega Alta",
                "iso2": "143",
                "latitude": "18.41217030",
                "longitude": "-66.33128050",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153621,
                        "name": "Vega Alta",
                        "latitude": "18.41217030",
                        "longitude": "-66.33128050"
                    }
                ]
            },
            {
                "id": 5207,
                "name": "Vega Baja",
                "iso2": "145",
                "latitude": "18.44614590",
                "longitude": "-66.40419670",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153622,
                        "name": "Vega Baja",
                        "latitude": "18.44614590",
                        "longitude": "-66.40419670"
                    }
                ]
            },
            {
                "id": 5208,
                "name": "Vieques",
                "iso2": "147",
                "latitude": "18.12628540",
                "longitude": "-65.44009850",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153623,
                        "name": "Vieques",
                        "latitude": "18.12628540",
                        "longitude": "-65.44009850"
                    }
                ]
            },
            {
                "id": 5209,
                "name": "Villalba",
                "iso2": "149",
                "latitude": "18.12175540",
                "longitude": "-66.49857870",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153624,
                        "name": "Villalba",
                        "latitude": "18.12175540",
                        "longitude": "-66.49857870"
                    }
                ]
            },
            {
                "id": 5210,
                "name": "Yabucoa",
                "iso2": "151",
                "latitude": "18.05052010",
                "longitude": "-65.87932880",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153625,
                        "name": "Yabucoa",
                        "latitude": "18.05052010",
                        "longitude": "-65.87932880"
                    }
                ]
            },
            {
                "id": 5211,
                "name": "Yauco",
                "iso2": "153",
                "latitude": "18.03496400",
                "longitude": "-66.84989830",
                "type": "municipality",
                "cities": [
                    {
                        "id": 153626,
                        "name": "Yauco",
                        "latitude": "18.03496400",
                        "longitude": "-66.84989830"
                    }
                ]
            }
        ]
    },
    {
        "id": 179,
        "name": "Qatar",
        "iso3": "QAT",
        "iso2": "QA",
        "numeric_code": "634",
        "phonecode": "974",
        "capital": "Doha",
        "currency": "QAR",
        "currency_name": "Qatari riyal",
        "currency_symbol": "ق.ر",
        "tld": ".qa",
        "native": "قطر",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Qatari",
        "timezones": [
            {
                "zoneName": "Asia\/Qatar",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "br": "Qatar",
            "ko": "카타르",
            "pt-BR": "Catar",
            "pt": "Catar",
            "nl": "Qatar",
            "hr": "Katar",
            "fa": "قطر",
            "de": "Katar",
            "es": "Catar",
            "fr": "Qatar",
            "ja": "カタール",
            "it": "Qatar",
            "zh-CN": "卡塔尔",
            "tr": "Katar",
            "ru": "Катар",
            "uk": "Катар",
            "pl": "Katar"
        },
        "latitude": "25.50000000",
        "longitude": "51.25000000",
        "emoji": "🇶🇦",
        "emojiU": "U+1F1F6 U+1F1E6",
        "states": [
            {
                "id": 3182,
                "name": "Al Daayen",
                "iso2": "ZA",
                "latitude": "25.57845590",
                "longitude": "51.48213870",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 3183,
                "name": "Al Khor",
                "iso2": "KH",
                "latitude": "25.68040780",
                "longitude": "51.49685020",
                "type": "municipality",
                "cities": [
                    {
                        "id": 89856,
                        "name": "Al Ghuwayrīyah",
                        "latitude": "25.82882000",
                        "longitude": "51.24567000"
                    },
                    {
                        "id": 89858,
                        "name": "Al Khawr",
                        "latitude": "25.68389000",
                        "longitude": "51.50583000"
                    }
                ]
            },
            {
                "id": 3177,
                "name": "Al Rayyan",
                "iso2": "RA",
                "latitude": "25.25225510",
                "longitude": "51.43887130",
                "type": "municipality",
                "cities": [
                    {
                        "id": 89861,
                        "name": "Ar Rayyān",
                        "latitude": "25.29194000",
                        "longitude": "51.42444000"
                    },
                    {
                        "id": 89869,
                        "name": "Umm Bāb",
                        "latitude": "25.21417000",
                        "longitude": "50.80722000"
                    }
                ]
            },
            {
                "id": 3179,
                "name": "Al Wakrah",
                "iso2": "WA",
                "latitude": "25.16593140",
                "longitude": "51.59755240",
                "type": "municipality",
                "cities": [
                    {
                        "id": 89859,
                        "name": "Al Wakrah",
                        "latitude": "25.17151000",
                        "longitude": "51.60337000"
                    },
                    {
                        "id": 89860,
                        "name": "Al Wukayr",
                        "latitude": "25.15107000",
                        "longitude": "51.53718000"
                    },
                    {
                        "id": 89868,
                        "name": "Musay‘īd",
                        "latitude": "24.99226000",
                        "longitude": "51.55067000"
                    }
                ]
            },
            {
                "id": 3178,
                "name": "Al-Shahaniya",
                "iso2": "SH",
                "latitude": "25.41063860",
                "longitude": "51.18460250",
                "type": "municipality",
                "cities": [
                    {
                        "id": 89857,
                        "name": "Al Jumaylīyah",
                        "latitude": "25.61068000",
                        "longitude": "51.09108000"
                    },
                    {
                        "id": 89863,
                        "name": "Ash Shīḩānīyah",
                        "latitude": "25.37088000",
                        "longitude": "51.22264000"
                    },
                    {
                        "id": 89865,
                        "name": "Dukhān",
                        "latitude": "25.42485000",
                        "longitude": "50.78227000"
                    }
                ]
            },
            {
                "id": 3181,
                "name": "Doha",
                "iso2": "DA",
                "latitude": "25.28544730",
                "longitude": "51.53103980",
                "type": "municipality",
                "cities": [
                    {
                        "id": 89864,
                        "name": "Doha",
                        "latitude": "25.28545000",
                        "longitude": "51.53096000"
                    }
                ]
            },
            {
                "id": 3180,
                "name": "Madinat ash Shamal",
                "iso2": "MS",
                "latitude": "26.11827430",
                "longitude": "51.21572650",
                "type": "municipality",
                "cities": [
                    {
                        "id": 89862,
                        "name": "Ar Ruways",
                        "latitude": "26.13978000",
                        "longitude": "51.21493000"
                    },
                    {
                        "id": 89866,
                        "name": "Fuwayriţ",
                        "latitude": "26.02565000",
                        "longitude": "51.36971000"
                    },
                    {
                        "id": 89867,
                        "name": "Madīnat ash Shamāl",
                        "latitude": "26.12933000",
                        "longitude": "51.20090000"
                    }
                ]
            },
            {
                "id": 3184,
                "name": "Umm Salal",
                "iso2": "US",
                "latitude": "25.48752420",
                "longitude": "51.39656800",
                "type": "municipality",
                "cities": [
                    {
                        "id": 89870,
                        "name": "Umm Şalāl Muḩammad",
                        "latitude": "25.41524000",
                        "longitude": "51.40647000"
                    }
                ]
            }
        ]
    },
    {
        "id": 180,
        "name": "Reunion",
        "iso3": "REU",
        "iso2": "RE",
        "numeric_code": "638",
        "phonecode": "262",
        "capital": "Saint-Denis",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".re",
        "native": "La Réunion",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Reunionese, Reunionnais",
        "timezones": [
            {
                "zoneName": "Indian\/Reunion",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "RET",
                "tzName": "Réunion Time"
            }
        ],
        "translations": {
            "br": "Reünion",
            "ko": "레위니옹",
            "pt-BR": "Reunião",
            "pt": "Reunião",
            "nl": "Réunion",
            "hr": "Réunion",
            "fa": "رئونیون",
            "de": "Réunion",
            "es": "Reunión",
            "fr": "Réunion",
            "ja": "レユニオン",
            "it": "Riunione",
            "zh-CN": "留尼汪岛",
            "tr": "Réunion",
            "ru": "Воссоединение",
            "uk": "Возз'єднання",
            "pl": "Reunion"
        },
        "latitude": "-21.15000000",
        "longitude": "55.50000000",
        "emoji": "🇷🇪",
        "emojiU": "U+1F1F7 U+1F1EA",
        "states": [
            {
                "id": 5436,
                "name": "Saint-Benoît",
                "iso2": "01",
                "latitude": "-21.08100290",
                "longitude": "55.31052890",
                "type": "district",
                "cities": [
                    {
                        "id": 155014,
                        "name": "Bras-Panon",
                        "latitude": "-21.03158160",
                        "longitude": "55.54416340"
                    },
                    {
                        "id": 155015,
                        "name": "La Plaine-des-Palmistes",
                        "latitude": "-21.15295070",
                        "longitude": "55.56180140"
                    },
                    {
                        "id": 155016,
                        "name": "Saint-André",
                        "latitude": "-20.95677270",
                        "longitude": "55.55486740"
                    },
                    {
                        "id": 155017,
                        "name": "Saint-Benoît",
                        "latitude": "-21.08859460",
                        "longitude": "55.46640760"
                    },
                    {
                        "id": 155018,
                        "name": "Sainte-Rose",
                        "latitude": "-21.17782890",
                        "longitude": "55.65939810"
                    },
                    {
                        "id": 155019,
                        "name": "Salazie",
                        "latitude": "-21.05240970",
                        "longitude": "55.43213370"
                    }
                ]
            },
            {
                "id": 5437,
                "name": "Saint-Denis",
                "iso2": "02",
                "latitude": "-20.94334700",
                "longitude": "55.34628380",
                "type": "district",
                "cities": [
                    {
                        "id": 155020,
                        "name": "Saint-Denis",
                        "latitude": "-20.96456720",
                        "longitude": "55.41835300"
                    },
                    {
                        "id": 155021,
                        "name": "Sainte-Marie",
                        "latitude": "-20.94628420",
                        "longitude": "55.44095870"
                    },
                    {
                        "id": 155022,
                        "name": "Sainte-Suzanne",
                        "latitude": "-20.95063790",
                        "longitude": "55.51114750"
                    }
                ]
            },
            {
                "id": 5438,
                "name": "Saint-Paul",
                "iso2": "03",
                "latitude": "-21.07249890",
                "longitude": "55.17584580",
                "type": "district",
                "cities": [
                    {
                        "id": 155024,
                        "name": "La Possession",
                        "latitude": "-20.99667150",
                        "longitude": "55.30941960"
                    },
                    {
                        "id": 155023,
                        "name": "Le Port",
                        "latitude": "-20.94599810",
                        "longitude": "55.26258390"
                    },
                    {
                        "id": 155027,
                        "name": "Les Trois-Bassins",
                        "latitude": "-21.11380650",
                        "longitude": "55.25534670"
                    },
                    {
                        "id": 155025,
                        "name": "Saint-Leu",
                        "latitude": "-21.18153740",
                        "longitude": "55.26075530"
                    },
                    {
                        "id": 155026,
                        "name": "Saint-Paul",
                        "latitude": "-21.03656340",
                        "longitude": "55.17542230"
                    }
                ]
            },
            {
                "id": 5439,
                "name": "Saint-Pierre",
                "iso2": "04",
                "latitude": "-21.23731130",
                "longitude": "55.23495980",
                "type": "district",
                "cities": [
                    {
                        "id": 155029,
                        "name": "Cilaos",
                        "latitude": "-21.14026750",
                        "longitude": "55.37314150"
                    },
                    {
                        "id": 155030,
                        "name": "Entre-Deux",
                        "latitude": "-21.21073870",
                        "longitude": "55.41125940"
                    },
                    {
                        "id": 155031,
                        "name": "L'Étang-Salé",
                        "latitude": "-21.23474080",
                        "longitude": "55.31636860"
                    },
                    {
                        "id": 155037,
                        "name": "Le Tampon",
                        "latitude": "-21.22500920",
                        "longitude": "55.48765410"
                    },
                    {
                        "id": 155028,
                        "name": "Les Avirons",
                        "latitude": "-21.20186830",
                        "longitude": "55.32166090"
                    },
                    {
                        "id": 155032,
                        "name": "Petite-Île",
                        "latitude": "-21.33296780",
                        "longitude": "55.52942050"
                    },
                    {
                        "id": 155033,
                        "name": "Saint-Joseph",
                        "latitude": "-21.29211860",
                        "longitude": "55.56161730"
                    },
                    {
                        "id": 155034,
                        "name": "Saint-Louis",
                        "latitude": "-21.22548290",
                        "longitude": "55.34004400"
                    },
                    {
                        "id": 155035,
                        "name": "Saint-Philippe",
                        "latitude": "-21.30837500",
                        "longitude": "55.66118340"
                    },
                    {
                        "id": 155036,
                        "name": "Saint-Pierre",
                        "latitude": "-21.30893030",
                        "longitude": "55.33953130"
                    }
                ]
            }
        ]
    },
    {
        "id": 181,
        "name": "Romania",
        "iso3": "ROU",
        "iso2": "RO",
        "numeric_code": "642",
        "phonecode": "40",
        "capital": "Bucharest",
        "currency": "RON",
        "currency_name": "Romanian leu",
        "currency_symbol": "lei",
        "tld": ".ro",
        "native": "România",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Romanian",
        "timezones": [
            {
                "zoneName": "Europe\/Bucharest",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Roumania",
            "ko": "루마니아",
            "pt-BR": "Romênia",
            "pt": "Roménia",
            "nl": "Roemenië",
            "hr": "Rumunjska",
            "fa": "رومانی",
            "de": "Rumänien",
            "es": "Rumania",
            "fr": "Roumanie",
            "ja": "ルーマニア",
            "it": "Romania",
            "zh-CN": "罗马尼亚",
            "tr": "Romanya",
            "ru": "Румыния",
            "uk": "Румунія",
            "pl": "Rumunia"
        },
        "latitude": "46.00000000",
        "longitude": "25.00000000",
        "emoji": "🇷🇴",
        "emojiU": "U+1F1F7 U+1F1F4",
        "states": [
            {
                "id": 4724,
                "name": "Alba",
                "iso2": "AB",
                "latitude": "44.70091530",
                "longitude": "8.03569110",
                "type": "department",
                "cities": [
                    {
                        "id": 89874,
                        "name": "Abrud",
                        "latitude": "46.27406000",
                        "longitude": "23.06339000"
                    },
                    {
                        "id": 89875,
                        "name": "Abrud-Sat",
                        "latitude": "46.28166000",
                        "longitude": "23.06098000"
                    },
                    {
                        "id": 89907,
                        "name": "Aiud",
                        "latitude": "46.31006000",
                        "longitude": "23.72128000"
                    },
                    {
                        "id": 89908,
                        "name": "Aiudul de Sus",
                        "latitude": "46.31653000",
                        "longitude": "23.69053000"
                    },
                    {
                        "id": 89910,
                        "name": "Alba Iulia",
                        "latitude": "46.06667000",
                        "longitude": "23.58333000"
                    },
                    {
                        "id": 89911,
                        "name": "Albac",
                        "latitude": "46.45246000",
                        "longitude": "22.95164000"
                    },
                    {
                        "id": 89937,
                        "name": "Almaşu Mare",
                        "latitude": "46.11014000",
                        "longitude": "23.11721000"
                    },
                    {
                        "id": 89992,
                        "name": "Arieşeni",
                        "latitude": "46.47641000",
                        "longitude": "22.75741000"
                    },
                    {
                        "id": 90006,
                        "name": "Avram Iancu",
                        "latitude": "46.38333000",
                        "longitude": "22.78333000"
                    },
                    {
                        "id": 90032,
                        "name": "Baia de Arieş",
                        "latitude": "46.38045000",
                        "longitude": "23.28115000"
                    },
                    {
                        "id": 90504,
                        "name": "Bălcaciu",
                        "latitude": "46.19122000",
                        "longitude": "24.06139000"
                    },
                    {
                        "id": 90545,
                        "name": "Bărăbanț",
                        "latitude": "46.09930000",
                        "longitude": "23.58487000"
                    },
                    {
                        "id": 90109,
                        "name": "Berghin",
                        "latitude": "46.07782000",
                        "longitude": "23.73742000"
                    },
                    {
                        "id": 90132,
                        "name": "Biia",
                        "latitude": "46.23097000",
                        "longitude": "24.00461000"
                    },
                    {
                        "id": 90143,
                        "name": "Bistra",
                        "latitude": "46.37820000",
                        "longitude": "23.10081000"
                    },
                    {
                        "id": 90156,
                        "name": "Blaj",
                        "latitude": "46.17508000",
                        "longitude": "23.91578000"
                    },
                    {
                        "id": 90161,
                        "name": "Blândiana",
                        "latitude": "45.97943000",
                        "longitude": "23.38543000"
                    },
                    {
                        "id": 90159,
                        "name": "Blideşti",
                        "latitude": "46.30000000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 90344,
                        "name": "Bucerdea-Grânoasă",
                        "latitude": "46.20000000",
                        "longitude": "23.83333000"
                    },
                    {
                        "id": 90350,
                        "name": "Bucium",
                        "latitude": "46.26402000",
                        "longitude": "23.17910000"
                    },
                    {
                        "id": 93791,
                        "name": "Câlnic",
                        "latitude": "45.88333000",
                        "longitude": "23.66667000"
                    },
                    {
                        "id": 93796,
                        "name": "Câmpeni",
                        "latitude": "46.36667000",
                        "longitude": "23.05000000"
                    },
                    {
                        "id": 90614,
                        "name": "Cenade",
                        "latitude": "46.05000000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 90625,
                        "name": "Cergău Mare",
                        "latitude": "46.09869000",
                        "longitude": "23.92284000"
                    },
                    {
                        "id": 90626,
                        "name": "Cergău Mic",
                        "latitude": "46.08333000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 90642,
                        "name": "Ceru-Băcăinţi",
                        "latitude": "45.98333000",
                        "longitude": "23.25000000"
                    },
                    {
                        "id": 90649,
                        "name": "Cetatea de Baltă",
                        "latitude": "46.24794000",
                        "longitude": "24.17244000"
                    },
                    {
                        "id": 90746,
                        "name": "Ciugud",
                        "latitude": "46.05000000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 90750,
                        "name": "Ciumbrud",
                        "latitude": "46.30810000",
                        "longitude": "23.76222000"
                    },
                    {
                        "id": 90759,
                        "name": "Ciuruleasa",
                        "latitude": "46.25000000",
                        "longitude": "23.03333000"
                    },
                    {
                        "id": 90837,
                        "name": "Comuna Albac",
                        "latitude": "46.45246000",
                        "longitude": "22.95027000"
                    },
                    {
                        "id": 90857,
                        "name": "Comuna Almaşu Mare",
                        "latitude": "46.10877000",
                        "longitude": "23.12038000"
                    },
                    {
                        "id": 90892,
                        "name": "Comuna Arieşeni",
                        "latitude": "46.47659000",
                        "longitude": "22.75535000"
                    },
                    {
                        "id": 90905,
                        "name": "Comuna Avram Iancu",
                        "latitude": "46.38333000",
                        "longitude": "22.78333000"
                    },
                    {
                        "id": 90968,
                        "name": "Comuna Berghin",
                        "latitude": "46.07484000",
                        "longitude": "23.73768000"
                    },
                    {
                        "id": 90995,
                        "name": "Comuna Bistra",
                        "latitude": "46.37856000",
                        "longitude": "23.10150000"
                    },
                    {
                        "id": 91005,
                        "name": "Comuna Blândiana",
                        "latitude": "45.98146000",
                        "longitude": "23.38543000"
                    },
                    {
                        "id": 91125,
                        "name": "Comuna Bucerdea-Grânoasă",
                        "latitude": "46.20878000",
                        "longitude": "23.85614000"
                    },
                    {
                        "id": 91129,
                        "name": "Comuna Bucium",
                        "latitude": "46.26131000",
                        "longitude": "23.15742000"
                    },
                    {
                        "id": 91540,
                        "name": "Comuna Câlnic",
                        "latitude": "45.87305000",
                        "longitude": "23.64329000"
                    },
                    {
                        "id": 91281,
                        "name": "Comuna Cenade",
                        "latitude": "46.08045000",
                        "longitude": "24.01382000"
                    },
                    {
                        "id": 91289,
                        "name": "Comuna Cergău",
                        "latitude": "46.09314000",
                        "longitude": "23.94597000"
                    },
                    {
                        "id": 91299,
                        "name": "Comuna Ceru-Băcăinţi",
                        "latitude": "46.00117000",
                        "longitude": "23.26983000"
                    },
                    {
                        "id": 91305,
                        "name": "Comuna Cetatea de Baltă",
                        "latitude": "46.21619000",
                        "longitude": "24.16716000"
                    },
                    {
                        "id": 91367,
                        "name": "Comuna Ciugud",
                        "latitude": "46.06526000",
                        "longitude": "23.62794000"
                    },
                    {
                        "id": 91377,
                        "name": "Comuna Ciuruleasa",
                        "latitude": "46.24481000",
                        "longitude": "23.01644000"
                    },
                    {
                        "id": 91516,
                        "name": "Comuna Crăciunelu de Jos",
                        "latitude": "46.17285000",
                        "longitude": "23.83585000"
                    },
                    {
                        "id": 91495,
                        "name": "Comuna Cricău",
                        "latitude": "46.18689000",
                        "longitude": "23.55309000"
                    },
                    {
                        "id": 91533,
                        "name": "Comuna Cut",
                        "latitude": "45.93972000",
                        "longitude": "23.66719000"
                    },
                    {
                        "id": 91601,
                        "name": "Comuna Daia Română",
                        "latitude": "46.00709000",
                        "longitude": "23.66816000"
                    },
                    {
                        "id": 91668,
                        "name": "Comuna Doştat",
                        "latitude": "45.96143000",
                        "longitude": "23.83313000"
                    },
                    {
                        "id": 91825,
                        "name": "Comuna Fărău",
                        "latitude": "46.32999000",
                        "longitude": "24.04335000"
                    },
                    {
                        "id": 91829,
                        "name": "Comuna Galda de Jos",
                        "latitude": "46.21776000",
                        "longitude": "23.56918000"
                    },
                    {
                        "id": 91965,
                        "name": "Comuna Gârbova",
                        "latitude": "45.85277000",
                        "longitude": "23.68693000"
                    },
                    {
                        "id": 91971,
                        "name": "Comuna Gârda de Sus",
                        "latitude": "46.46719000",
                        "longitude": "22.81519000"
                    },
                    {
                        "id": 92014,
                        "name": "Comuna Hopârta",
                        "latitude": "46.33134000",
                        "longitude": "23.90340000"
                    },
                    {
                        "id": 92015,
                        "name": "Comuna Horea",
                        "latitude": "46.50058000",
                        "longitude": "22.94915000"
                    },
                    {
                        "id": 92066,
                        "name": "Comuna Ighiu",
                        "latitude": "46.14854000",
                        "longitude": "23.51232000"
                    },
                    {
                        "id": 93494,
                        "name": "Comuna Întregalde",
                        "latitude": "46.24908000",
                        "longitude": "23.39213000"
                    },
                    {
                        "id": 92121,
                        "name": "Comuna Jidvei",
                        "latitude": "46.23083000",
                        "longitude": "24.11475000"
                    },
                    {
                        "id": 92176,
                        "name": "Comuna Livezile",
                        "latitude": "46.37559000",
                        "longitude": "23.58563000"
                    },
                    {
                        "id": 92183,
                        "name": "Comuna Lopadea Nouă",
                        "latitude": "46.27782000",
                        "longitude": "23.84975000"
                    },
                    {
                        "id": 92205,
                        "name": "Comuna Lunca Mureşului",
                        "latitude": "46.42943000",
                        "longitude": "23.93272000"
                    },
                    {
                        "id": 92216,
                        "name": "Comuna Lupşa",
                        "latitude": "46.34891000",
                        "longitude": "23.20455000"
                    },
                    {
                        "id": 92262,
                        "name": "Comuna Meteş",
                        "latitude": "46.10543000",
                        "longitude": "23.41707000"
                    },
                    {
                        "id": 92278,
                        "name": "Comuna Mihalţ",
                        "latitude": "46.17641000",
                        "longitude": "23.73841000"
                    },
                    {
                        "id": 92303,
                        "name": "Comuna Mirăslău",
                        "latitude": "46.38660000",
                        "longitude": "23.69329000"
                    },
                    {
                        "id": 92317,
                        "name": "Comuna Mogoş",
                        "latitude": "46.28356000",
                        "longitude": "23.31873000"
                    },
                    {
                        "id": 92453,
                        "name": "Comuna Noşlac",
                        "latitude": "46.41300000",
                        "longitude": "23.97668000"
                    },
                    {
                        "id": 92480,
                        "name": "Comuna Ocoliş",
                        "latitude": "46.49636000",
                        "longitude": "23.46581000"
                    },
                    {
                        "id": 92487,
                        "name": "Comuna Ohaba",
                        "latitude": "46.08263000",
                        "longitude": "23.80106000"
                    },
                    {
                        "id": 92572,
                        "name": "Comuna Pianu",
                        "latitude": "45.87127000",
                        "longitude": "23.49549000"
                    },
                    {
                        "id": 92634,
                        "name": "Comuna Poiana Vadului",
                        "latitude": "46.40457000",
                        "longitude": "22.87080000"
                    },
                    {
                        "id": 92651,
                        "name": "Comuna Ponor",
                        "latitude": "46.32065000",
                        "longitude": "23.40376000"
                    },
                    {
                        "id": 92666,
                        "name": "Comuna Poşaga",
                        "latitude": "46.45354000",
                        "longitude": "23.36115000"
                    },
                    {
                        "id": 92842,
                        "name": "Comuna Rădeşti",
                        "latitude": "46.24931000",
                        "longitude": "23.74444000"
                    },
                    {
                        "id": 92822,
                        "name": "Comuna Râmeţ",
                        "latitude": "46.31564000",
                        "longitude": "23.52602000"
                    },
                    {
                        "id": 92821,
                        "name": "Comuna Râmetea",
                        "latitude": "46.43815000",
                        "longitude": "23.56579000"
                    },
                    {
                        "id": 92799,
                        "name": "Comuna Roşia de Secaş",
                        "latitude": "46.04807000",
                        "longitude": "23.85329000"
                    },
                    {
                        "id": 92798,
                        "name": "Comuna Roşia Montană",
                        "latitude": "46.30991000",
                        "longitude": "23.08697000"
                    },
                    {
                        "id": 93096,
                        "name": "Comuna Sălciua",
                        "latitude": "46.38261000",
                        "longitude": "23.41526000"
                    },
                    {
                        "id": 93076,
                        "name": "Comuna Sãliştea",
                        "latitude": "45.91425000",
                        "longitude": "23.41294000"
                    },
                    {
                        "id": 93049,
                        "name": "Comuna Sâncel",
                        "latitude": "46.21176000",
                        "longitude": "23.94791000"
                    },
                    {
                        "id": 93067,
                        "name": "Comuna Sântimbru",
                        "latitude": "46.12974000",
                        "longitude": "23.66899000"
                    },
                    {
                        "id": 93112,
                        "name": "Comuna Săsciori",
                        "latitude": "45.85629000",
                        "longitude": "23.56898000"
                    },
                    {
                        "id": 92905,
                        "name": "Comuna Scărişoara",
                        "latitude": "46.46072000",
                        "longitude": "22.88166000"
                    },
                    {
                        "id": 93512,
                        "name": "Comuna Şibot",
                        "latitude": "45.94093000",
                        "longitude": "23.32226000"
                    },
                    {
                        "id": 92972,
                        "name": "Comuna Sohodol",
                        "latitude": "46.32748000",
                        "longitude": "22.99414000"
                    },
                    {
                        "id": 93540,
                        "name": "Comuna Şona",
                        "latitude": "46.25089000",
                        "longitude": "24.00259000"
                    },
                    {
                        "id": 93545,
                        "name": "Comuna Şpring",
                        "latitude": "45.96833000",
                        "longitude": "23.73449000"
                    },
                    {
                        "id": 93003,
                        "name": "Comuna Stremţ",
                        "latitude": "46.25606000",
                        "longitude": "23.59340000"
                    },
                    {
                        "id": 93558,
                        "name": "Comuna Şugag",
                        "latitude": "45.74780000",
                        "longitude": "23.59957000"
                    },
                    {
                        "id": 93274,
                        "name": "Comuna Unirea",
                        "latitude": "46.41948000",
                        "longitude": "23.76260000"
                    },
                    {
                        "id": 93293,
                        "name": "Comuna Vadu Moţilor",
                        "latitude": "46.40910000",
                        "longitude": "22.95532000"
                    },
                    {
                        "id": 93308,
                        "name": "Comuna Valea Lungă",
                        "latitude": "46.13355000",
                        "longitude": "24.08280000"
                    },
                    {
                        "id": 93354,
                        "name": "Comuna Vidra",
                        "latitude": "46.37067000",
                        "longitude": "22.92726000"
                    },
                    {
                        "id": 93368,
                        "name": "Comuna Vinţu de Jos",
                        "latitude": "46.02229000",
                        "longitude": "23.45647000"
                    },
                    {
                        "id": 93751,
                        "name": "Crăciunelu de Jos",
                        "latitude": "46.18333000",
                        "longitude": "23.83333000"
                    },
                    {
                        "id": 93717,
                        "name": "Cricău",
                        "latitude": "46.18333000",
                        "longitude": "23.56667000"
                    },
                    {
                        "id": 93765,
                        "name": "Cugir",
                        "latitude": "45.83651000",
                        "longitude": "23.36998000"
                    },
                    {
                        "id": 93780,
                        "name": "Cut",
                        "latitude": "45.93972000",
                        "longitude": "23.66719000"
                    },
                    {
                        "id": 93889,
                        "name": "Daia Română",
                        "latitude": "46.01667000",
                        "longitude": "23.66667000"
                    },
                    {
                        "id": 93947,
                        "name": "Dobra",
                        "latitude": "45.76913000",
                        "longitude": "23.64218000"
                    },
                    {
                        "id": 94008,
                        "name": "Doştat",
                        "latitude": "45.96667000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 94268,
                        "name": "Fărău",
                        "latitude": "46.33333000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 94151,
                        "name": "Feisa",
                        "latitude": "46.22608000",
                        "longitude": "24.14492000"
                    },
                    {
                        "id": 94157,
                        "name": "Feneș",
                        "latitude": "46.10431000",
                        "longitude": "23.29511000"
                    },
                    {
                        "id": 94276,
                        "name": "Galda de Jos",
                        "latitude": "46.18333000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 94483,
                        "name": "Gârbova",
                        "latitude": "45.86667000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 94489,
                        "name": "Gârda de Sus",
                        "latitude": "46.45000000",
                        "longitude": "22.81667000"
                    },
                    {
                        "id": 94556,
                        "name": "Hopârta",
                        "latitude": "46.32134000",
                        "longitude": "23.87244000"
                    },
                    {
                        "id": 94557,
                        "name": "Horea",
                        "latitude": "46.50246000",
                        "longitude": "22.95034000"
                    },
                    {
                        "id": 94647,
                        "name": "Ighiel",
                        "latitude": "46.14680000",
                        "longitude": "23.47968000"
                    },
                    {
                        "id": 94648,
                        "name": "Ighiu",
                        "latitude": "46.15000000",
                        "longitude": "23.51667000"
                    },
                    {
                        "id": 94671,
                        "name": "Intregalde",
                        "latitude": "46.25000000",
                        "longitude": "23.41667000"
                    },
                    {
                        "id": 94710,
                        "name": "Izvoarele",
                        "latitude": "46.17011000",
                        "longitude": "23.90377000"
                    },
                    {
                        "id": 94733,
                        "name": "Jidvei",
                        "latitude": "46.21667000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 94758,
                        "name": "Lancrăm",
                        "latitude": "45.98708000",
                        "longitude": "23.55665000"
                    },
                    {
                        "id": 94823,
                        "name": "Livezile",
                        "latitude": "46.35000000",
                        "longitude": "23.63333000"
                    },
                    {
                        "id": 94832,
                        "name": "Lopadea Nouă",
                        "latitude": "46.29090000",
                        "longitude": "23.81901000"
                    },
                    {
                        "id": 94868,
                        "name": "Lunca Mureşului",
                        "latitude": "46.43333000",
                        "longitude": "23.90000000"
                    },
                    {
                        "id": 94886,
                        "name": "Lupşa",
                        "latitude": "46.36667000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 94962,
                        "name": "Meteş",
                        "latitude": "46.10000000",
                        "longitude": "23.41667000"
                    },
                    {
                        "id": 94967,
                        "name": "Micești",
                        "latitude": "46.10141000",
                        "longitude": "23.55573000"
                    },
                    {
                        "id": 94985,
                        "name": "Mihalţ",
                        "latitude": "46.15000000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 95025,
                        "name": "Mirăslău",
                        "latitude": "46.36667000",
                        "longitude": "23.71667000"
                    },
                    {
                        "id": 95056,
                        "name": "Mogoș",
                        "latitude": "46.27554000",
                        "longitude": "23.28038000"
                    },
                    {
                        "id": 95106,
                        "name": "Municipiul Aiud",
                        "latitude": "46.30440000",
                        "longitude": "23.69751000"
                    },
                    {
                        "id": 95107,
                        "name": "Municipiul Alba Iulia",
                        "latitude": "46.06346000",
                        "longitude": "23.57494000"
                    },
                    {
                        "id": 95114,
                        "name": "Municipiul Blaj",
                        "latitude": "46.15084000",
                        "longitude": "23.91041000"
                    },
                    {
                        "id": 95179,
                        "name": "Municipiul Sebeş",
                        "latitude": "45.94237000",
                        "longitude": "23.57681000"
                    },
                    {
                        "id": 95358,
                        "name": "Noşlac",
                        "latitude": "46.40000000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 95382,
                        "name": "Oarda",
                        "latitude": "46.03333000",
                        "longitude": "23.56667000"
                    },
                    {
                        "id": 95395,
                        "name": "Ocna Mureş",
                        "latitude": "46.38333000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 95402,
                        "name": "Ocoliş",
                        "latitude": "46.48333000",
                        "longitude": "23.46667000"
                    },
                    {
                        "id": 95417,
                        "name": "Ohaba",
                        "latitude": "46.06667000",
                        "longitude": "23.78333000"
                    },
                    {
                        "id": 95626,
                        "name": "Oraş abrud",
                        "latitude": "46.27409000",
                        "longitude": "23.06129000"
                    },
                    {
                        "id": 95456,
                        "name": "Oraş Baia de Arieş",
                        "latitude": "46.37933000",
                        "longitude": "23.29903000"
                    },
                    {
                        "id": 95503,
                        "name": "Oraş Câmpeni",
                        "latitude": "46.38493000",
                        "longitude": "23.04553000"
                    },
                    {
                        "id": 95501,
                        "name": "Oraş Cugir",
                        "latitude": "45.81371000",
                        "longitude": "23.40740000"
                    },
                    {
                        "id": 95556,
                        "name": "Oraş Ocna Mureş",
                        "latitude": "46.38475000",
                        "longitude": "23.84070000"
                    },
                    {
                        "id": 95602,
                        "name": "Oraş Teiuş",
                        "latitude": "46.20959000",
                        "longitude": "23.70812000"
                    },
                    {
                        "id": 95624,
                        "name": "Oraş Zlatna",
                        "latitude": "46.13753000",
                        "longitude": "23.20215000"
                    },
                    {
                        "id": 95750,
                        "name": "Petrești",
                        "latitude": "45.92102000",
                        "longitude": "23.56083000"
                    },
                    {
                        "id": 95766,
                        "name": "Pianu de Jos",
                        "latitude": "45.93528000",
                        "longitude": "23.48912000"
                    },
                    {
                        "id": 95767,
                        "name": "Pianu de Sus",
                        "latitude": "45.90000000",
                        "longitude": "23.48333000"
                    },
                    {
                        "id": 95883,
                        "name": "Poiana Vadului",
                        "latitude": "46.40000000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 95896,
                        "name": "Poienile-Mogoş",
                        "latitude": "46.28333000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 95906,
                        "name": "Ponor",
                        "latitude": "46.33333000",
                        "longitude": "23.41667000"
                    },
                    {
                        "id": 95936,
                        "name": "Poşaga de Sus",
                        "latitude": "46.46667000",
                        "longitude": "23.38333000"
                    },
                    {
                        "id": 96195,
                        "name": "Rădeşti",
                        "latitude": "46.26667000",
                        "longitude": "23.71667000"
                    },
                    {
                        "id": 96214,
                        "name": "Războieni-Cetate",
                        "latitude": "46.41335000",
                        "longitude": "23.87158000"
                    },
                    {
                        "id": 96094,
                        "name": "Rimetea",
                        "latitude": "46.45000000",
                        "longitude": "23.56667000"
                    },
                    {
                        "id": 96129,
                        "name": "Roşia de Secaş",
                        "latitude": "46.05000000",
                        "longitude": "23.88333000"
                    },
                    {
                        "id": 96136,
                        "name": "Roșia Montană",
                        "latitude": "46.30669000",
                        "longitude": "23.13373000"
                    },
                    {
                        "id": 106013,
                        "name": "Sălciua de Sus",
                        "latitude": "46.40000000",
                        "longitude": "23.41667000"
                    },
                    {
                        "id": 106020,
                        "name": "Săliștea",
                        "latitude": "45.90744000",
                        "longitude": "23.39789000"
                    },
                    {
                        "id": 106019,
                        "name": "Săliştea-Deal",
                        "latitude": "45.90000000",
                        "longitude": "23.40000000"
                    },
                    {
                        "id": 96523,
                        "name": "Sâncel",
                        "latitude": "46.20000000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 96525,
                        "name": "Sâncrai",
                        "latitude": "46.29394000",
                        "longitude": "23.75209000"
                    },
                    {
                        "id": 105979,
                        "name": "Sântimbru",
                        "latitude": "46.13333000",
                        "longitude": "23.65000000"
                    },
                    {
                        "id": 97114,
                        "name": "Șard",
                        "latitude": "46.12814000",
                        "longitude": "23.53520000"
                    },
                    {
                        "id": 106039,
                        "name": "Săsciori",
                        "latitude": "45.86667000",
                        "longitude": "23.58333000"
                    },
                    {
                        "id": 96296,
                        "name": "Scărişoara",
                        "latitude": "46.46667000",
                        "longitude": "22.85000000"
                    },
                    {
                        "id": 96302,
                        "name": "Sebeş",
                        "latitude": "45.95646000",
                        "longitude": "23.57100000"
                    },
                    {
                        "id": 96303,
                        "name": "Sebeșel",
                        "latitude": "45.88771000",
                        "longitude": "23.56606000"
                    },
                    {
                        "id": 97042,
                        "name": "Şibot",
                        "latitude": "45.95000000",
                        "longitude": "23.33333000"
                    },
                    {
                        "id": 96403,
                        "name": "Sohodol",
                        "latitude": "46.35581000",
                        "longitude": "23.02923000"
                    },
                    {
                        "id": 97070,
                        "name": "Şona",
                        "latitude": "46.21667000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 97076,
                        "name": "Şpring",
                        "latitude": "45.96667000",
                        "longitude": "23.78333000"
                    },
                    {
                        "id": 96453,
                        "name": "Stremţ",
                        "latitude": "46.21667000",
                        "longitude": "23.63333000"
                    },
                    {
                        "id": 97090,
                        "name": "Şugag",
                        "latitude": "45.76667000",
                        "longitude": "23.63333000"
                    },
                    {
                        "id": 106072,
                        "name": "Teiuş",
                        "latitude": "46.20000000",
                        "longitude": "23.68333000"
                    },
                    {
                        "id": 97137,
                        "name": "Țelna",
                        "latitude": "46.15902000",
                        "longitude": "23.50099000"
                    },
                    {
                        "id": 106111,
                        "name": "Tiur",
                        "latitude": "46.16009000",
                        "longitude": "23.88927000"
                    },
                    {
                        "id": 96641,
                        "name": "Uioara de Jos",
                        "latitude": "46.37087000",
                        "longitude": "23.83863000"
                    },
                    {
                        "id": 96668,
                        "name": "Unirea",
                        "latitude": "46.40387000",
                        "longitude": "23.81314000"
                    },
                    {
                        "id": 96698,
                        "name": "Vadu Moţilor",
                        "latitude": "46.40000000",
                        "longitude": "22.96667000"
                    },
                    {
                        "id": 96729,
                        "name": "Valea Lungă Alba Romania",
                        "latitude": "46.12592000",
                        "longitude": "24.04541000"
                    },
                    {
                        "id": 96794,
                        "name": "Veseuș",
                        "latitude": "46.27456000",
                        "longitude": "24.14276000"
                    },
                    {
                        "id": 96797,
                        "name": "Veza",
                        "latitude": "46.16747000",
                        "longitude": "23.92470000"
                    },
                    {
                        "id": 96808,
                        "name": "Vidra",
                        "latitude": "46.36758000",
                        "longitude": "22.88811000"
                    },
                    {
                        "id": 96831,
                        "name": "Vinerea",
                        "latitude": "45.88632000",
                        "longitude": "23.35289000"
                    },
                    {
                        "id": 96837,
                        "name": "Vințu de Jos",
                        "latitude": "45.99462000",
                        "longitude": "23.48612000"
                    },
                    {
                        "id": 96915,
                        "name": "Vurpăr",
                        "latitude": "46.00000000",
                        "longitude": "23.46667000"
                    },
                    {
                        "id": 96998,
                        "name": "Zlatna",
                        "latitude": "46.10633000",
                        "longitude": "23.23162000"
                    }
                ]
            },
            {
                "id": 4739,
                "name": "Arad",
                "iso2": "AR",
                "latitude": "46.22836510",
                "longitude": "21.65978190",
                "type": "department",
                "cities": [
                    {
                        "id": 89880,
                        "name": "Adea",
                        "latitude": "46.55511000",
                        "longitude": "21.58433000"
                    },
                    {
                        "id": 89902,
                        "name": "Agrișu Mare",
                        "latitude": "46.27243000",
                        "longitude": "21.75558000"
                    },
                    {
                        "id": 89935,
                        "name": "Almaş",
                        "latitude": "46.28333000",
                        "longitude": "22.23333000"
                    },
                    {
                        "id": 89955,
                        "name": "Andrei Șaguna",
                        "latitude": "46.28810000",
                        "longitude": "21.39175000"
                    },
                    {
                        "id": 89970,
                        "name": "Apateu",
                        "latitude": "46.61667000",
                        "longitude": "21.78333000"
                    },
                    {
                        "id": 89977,
                        "name": "Arad",
                        "latitude": "46.18333000",
                        "longitude": "21.31667000"
                    },
                    {
                        "id": 89980,
                        "name": "Archiş",
                        "latitude": "46.48333000",
                        "longitude": "22.05000000"
                    },
                    {
                        "id": 90454,
                        "name": "Bârsa",
                        "latitude": "46.38333000",
                        "longitude": "22.06667000"
                    },
                    {
                        "id": 90460,
                        "name": "Bârzava",
                        "latitude": "46.11667000",
                        "longitude": "21.98333000"
                    },
                    {
                        "id": 90069,
                        "name": "Bata",
                        "latitude": "46.01667000",
                        "longitude": "22.03333000"
                    },
                    {
                        "id": 90090,
                        "name": "Beliu",
                        "latitude": "46.48333000",
                        "longitude": "21.98333000"
                    },
                    {
                        "id": 90139,
                        "name": "Birchiş",
                        "latitude": "45.96667000",
                        "longitude": "22.16667000"
                    },
                    {
                        "id": 90176,
                        "name": "Bocsig",
                        "latitude": "46.41667000",
                        "longitude": "21.95000000"
                    },
                    {
                        "id": 90279,
                        "name": "Brazii",
                        "latitude": "46.23333000",
                        "longitude": "22.33333000"
                    },
                    {
                        "id": 90426,
                        "name": "Buteni",
                        "latitude": "46.31667000",
                        "longitude": "22.11667000"
                    },
                    {
                        "id": 90568,
                        "name": "Caporal Alexa",
                        "latitude": "46.33793000",
                        "longitude": "21.58316000"
                    },
                    {
                        "id": 93866,
                        "name": "Cărand",
                        "latitude": "46.45000000",
                        "longitude": "22.08333000"
                    },
                    {
                        "id": 90627,
                        "name": "Cermei",
                        "latitude": "46.55000000",
                        "longitude": "21.85000000"
                    },
                    {
                        "id": 90657,
                        "name": "Chereluș",
                        "latitude": "46.46860000",
                        "longitude": "21.70706000"
                    },
                    {
                        "id": 90658,
                        "name": "Chesinț",
                        "latitude": "46.04973000",
                        "longitude": "21.57944000"
                    },
                    {
                        "id": 90664,
                        "name": "Chier",
                        "latitude": "46.34199000",
                        "longitude": "21.82488000"
                    },
                    {
                        "id": 90683,
                        "name": "Chisindia",
                        "latitude": "46.28333000",
                        "longitude": "22.10000000"
                    },
                    {
                        "id": 90687,
                        "name": "Chişineu-Criş",
                        "latitude": "46.52509000",
                        "longitude": "21.51844000"
                    },
                    {
                        "id": 90704,
                        "name": "Cintei",
                        "latitude": "46.44434000",
                        "longitude": "21.56556000"
                    },
                    {
                        "id": 90855,
                        "name": "Comuna Almaş",
                        "latitude": "46.28480000",
                        "longitude": "22.23173000"
                    },
                    {
                        "id": 90877,
                        "name": "Comuna Apateu",
                        "latitude": "46.62598000",
                        "longitude": "21.82530000"
                    },
                    {
                        "id": 90884,
                        "name": "Comuna Archiş",
                        "latitude": "46.48333000",
                        "longitude": "22.09663000"
                    },
                    {
                        "id": 91191,
                        "name": "Comuna Bârsa",
                        "latitude": "46.38410000",
                        "longitude": "22.04459000"
                    },
                    {
                        "id": 91197,
                        "name": "Comuna Bârzava",
                        "latitude": "46.09910000",
                        "longitude": "22.06096000"
                    },
                    {
                        "id": 90939,
                        "name": "Comuna Bata",
                        "latitude": "45.99641000",
                        "longitude": "22.07805000"
                    },
                    {
                        "id": 90954,
                        "name": "Comuna Beliu",
                        "latitude": "46.52965000",
                        "longitude": "21.99566000"
                    },
                    {
                        "id": 90992,
                        "name": "Comuna Birchiş",
                        "latitude": "45.96987000",
                        "longitude": "22.16845000"
                    },
                    {
                        "id": 91015,
                        "name": "Comuna Bocsig",
                        "latitude": "46.41893000",
                        "longitude": "21.98424000"
                    },
                    {
                        "id": 91087,
                        "name": "Comuna Brazii",
                        "latitude": "46.22177000",
                        "longitude": "22.32613000"
                    },
                    {
                        "id": 91174,
                        "name": "Comuna Buteni",
                        "latitude": "46.33119000",
                        "longitude": "22.11472000"
                    },
                    {
                        "id": 91586,
                        "name": "Comuna Cărand",
                        "latitude": "46.45551000",
                        "longitude": "22.05755000"
                    },
                    {
                        "id": 91290,
                        "name": "Comuna Cermei",
                        "latitude": "46.55433000",
                        "longitude": "21.87084000"
                    },
                    {
                        "id": 91326,
                        "name": "Comuna Chisindia",
                        "latitude": "46.26509000",
                        "longitude": "22.08572000"
                    },
                    {
                        "id": 91412,
                        "name": "Comuna Conop",
                        "latitude": "46.10401000",
                        "longitude": "21.88047000"
                    },
                    {
                        "id": 91467,
                        "name": "Comuna Covăsinţ",
                        "latitude": "46.20571000",
                        "longitude": "21.60944000"
                    },
                    {
                        "id": 91485,
                        "name": "Comuna Craiva",
                        "latitude": "46.59969000",
                        "longitude": "21.97908000"
                    },
                    {
                        "id": 91621,
                        "name": "Comuna Dezna",
                        "latitude": "46.40997000",
                        "longitude": "22.22726000"
                    },
                    {
                        "id": 91625,
                        "name": "Comuna Dieci",
                        "latitude": "46.32071000",
                        "longitude": "22.22373000"
                    },
                    {
                        "id": 91666,
                        "name": "Comuna Dorobanți",
                        "latitude": "46.35022000",
                        "longitude": "21.24441000"
                    },
                    {
                        "id": 91810,
                        "name": "Comuna Fântânele",
                        "latitude": "46.12441000",
                        "longitude": "21.38111000"
                    },
                    {
                        "id": 91758,
                        "name": "Comuna Felnac",
                        "latitude": "46.12223000",
                        "longitude": "21.16704000"
                    },
                    {
                        "id": 91787,
                        "name": "Comuna Frumuşeni",
                        "latitude": "46.10180000",
                        "longitude": "21.45836000"
                    },
                    {
                        "id": 91861,
                        "name": "Comuna Ghioroc",
                        "latitude": "46.15322000",
                        "longitude": "21.59651000"
                    },
                    {
                        "id": 91943,
                        "name": "Comuna Grăniceri",
                        "latitude": "46.50539000",
                        "longitude": "21.33672000"
                    },
                    {
                        "id": 91957,
                        "name": "Comuna Gurahonţ",
                        "latitude": "46.29220000",
                        "longitude": "22.33506000"
                    },
                    {
                        "id": 92039,
                        "name": "Comuna Hălmăgel",
                        "latitude": "46.27662000",
                        "longitude": "22.63180000"
                    },
                    {
                        "id": 92038,
                        "name": "Comuna Hălmagiu",
                        "latitude": "46.27536000",
                        "longitude": "22.58183000"
                    },
                    {
                        "id": 92046,
                        "name": "Comuna Hăşmaş",
                        "latitude": "46.52217000",
                        "longitude": "22.07003000"
                    },
                    {
                        "id": 92067,
                        "name": "Comuna Igneşti",
                        "latitude": "46.43388000",
                        "longitude": "22.18227000"
                    },
                    {
                        "id": 92092,
                        "name": "Comuna Iratoşu",
                        "latitude": "46.29414000",
                        "longitude": "21.18750000"
                    },
                    {
                        "id": 92173,
                        "name": "Comuna Livada",
                        "latitude": "46.21924000",
                        "longitude": "21.38746000"
                    },
                    {
                        "id": 92227,
                        "name": "Comuna Macea",
                        "latitude": "46.40094000",
                        "longitude": "21.33187000"
                    },
                    {
                        "id": 92310,
                        "name": "Comuna Mişca",
                        "latitude": "46.62016000",
                        "longitude": "21.65353000"
                    },
                    {
                        "id": 92329,
                        "name": "Comuna Moneasa",
                        "latitude": "46.44443000",
                        "longitude": "22.25323000"
                    },
                    {
                        "id": 92493,
                        "name": "Comuna Olari",
                        "latitude": "46.38673000",
                        "longitude": "21.54522000"
                    },
                    {
                        "id": 92728,
                        "name": "Comuna Păuliş",
                        "latitude": "46.12506000",
                        "longitude": "21.60246000"
                    },
                    {
                        "id": 92546,
                        "name": "Comuna Peregu Mare",
                        "latitude": "46.23377000",
                        "longitude": "20.90612000"
                    },
                    {
                        "id": 92566,
                        "name": "Comuna Petriş",
                        "latitude": "46.06770000",
                        "longitude": "22.39523000"
                    },
                    {
                        "id": 92584,
                        "name": "Comuna Pilu",
                        "latitude": "46.59727000",
                        "longitude": "21.34711000"
                    },
                    {
                        "id": 92593,
                        "name": "Comuna Pleşcuţa",
                        "latitude": "46.28315000",
                        "longitude": "22.43178000"
                    },
                    {
                        "id": 93496,
                        "name": "Comuna Şagu",
                        "latitude": "46.04254000",
                        "longitude": "21.34239000"
                    },
                    {
                        "id": 93118,
                        "name": "Comuna Săvârşin",
                        "latitude": "46.02527000",
                        "longitude": "22.26514000"
                    },
                    {
                        "id": 92916,
                        "name": "Comuna Secusigiu",
                        "latitude": "46.09260000",
                        "longitude": "21.00295000"
                    },
                    {
                        "id": 93503,
                        "name": "Comuna Şeitin",
                        "latitude": "46.10858000",
                        "longitude": "20.84464000"
                    },
                    {
                        "id": 92920,
                        "name": "Comuna Seleuş",
                        "latitude": "46.37886000",
                        "longitude": "21.74875000"
                    },
                    {
                        "id": 92921,
                        "name": "Comuna Semlac",
                        "latitude": "46.11260000",
                        "longitude": "20.93210000"
                    },
                    {
                        "id": 93508,
                        "name": "Comuna Şepreuş",
                        "latitude": "46.57125000",
                        "longitude": "21.73417000"
                    },
                    {
                        "id": 93513,
                        "name": "Comuna Şicula",
                        "latitude": "46.45723000",
                        "longitude": "21.75137000"
                    },
                    {
                        "id": 93519,
                        "name": "Comuna Şilindia",
                        "latitude": "46.33611000",
                        "longitude": "21.93488000"
                    },
                    {
                        "id": 93520,
                        "name": "Comuna Şimand",
                        "latitude": "46.42400000",
                        "longitude": "21.45145000"
                    },
                    {
                        "id": 92941,
                        "name": "Comuna Sintea Mare",
                        "latitude": "46.51684000",
                        "longitude": "21.60800000"
                    },
                    {
                        "id": 93529,
                        "name": "Comuna Şiria",
                        "latitude": "46.28470000",
                        "longitude": "21.65419000"
                    },
                    {
                        "id": 93533,
                        "name": "Comuna Şiştarovăţ",
                        "latitude": "45.98649000",
                        "longitude": "21.75589000"
                    },
                    {
                        "id": 92968,
                        "name": "Comuna Socodor",
                        "latitude": "46.51010000",
                        "longitude": "21.44128000"
                    },
                    {
                        "id": 93535,
                        "name": "Comuna Şofronea",
                        "latitude": "46.26814000",
                        "longitude": "21.29059000"
                    },
                    {
                        "id": 93230,
                        "name": "Comuna Târnova",
                        "latitude": "46.29054000",
                        "longitude": "21.80388000"
                    },
                    {
                        "id": 93128,
                        "name": "Comuna Tauţ",
                        "latitude": "46.26383000",
                        "longitude": "21.96747000"
                    },
                    {
                        "id": 93288,
                        "name": "Comuna Ususău",
                        "latitude": "46.06781000",
                        "longitude": "21.81490000"
                    },
                    {
                        "id": 93465,
                        "name": "Comuna Vărădia de Mureş",
                        "latitude": "46.04619000",
                        "longitude": "22.15651000"
                    },
                    {
                        "id": 93441,
                        "name": "Comuna Vârfurile",
                        "latitude": "46.33689000",
                        "longitude": "22.51984000"
                    },
                    {
                        "id": 93365,
                        "name": "Comuna Vinga",
                        "latitude": "46.02249000",
                        "longitude": "21.15244000"
                    },
                    {
                        "id": 93383,
                        "name": "Comuna Vladimirescu",
                        "latitude": "46.16509000",
                        "longitude": "21.40411000"
                    },
                    {
                        "id": 93484,
                        "name": "Comuna Zăbrani",
                        "latitude": "46.06310000",
                        "longitude": "21.58529000"
                    },
                    {
                        "id": 93485,
                        "name": "Comuna Zădăreni",
                        "latitude": "46.13077000",
                        "longitude": "21.20866000"
                    },
                    {
                        "id": 93488,
                        "name": "Comuna Zărand",
                        "latitude": "46.43911000",
                        "longitude": "21.56909000"
                    },
                    {
                        "id": 93474,
                        "name": "Comuna Zerind",
                        "latitude": "46.63087000",
                        "longitude": "21.50777000"
                    },
                    {
                        "id": 93477,
                        "name": "Comuna Zimandu Nou",
                        "latitude": "46.27496000",
                        "longitude": "21.39162000"
                    },
                    {
                        "id": 93592,
                        "name": "Conop",
                        "latitude": "46.10186000",
                        "longitude": "21.87970000"
                    },
                    {
                        "id": 93682,
                        "name": "Covăsinţ",
                        "latitude": "46.20000000",
                        "longitude": "21.60000000"
                    },
                    {
                        "id": 93705,
                        "name": "Craiva",
                        "latitude": "46.58333000",
                        "longitude": "21.96667000"
                    },
                    {
                        "id": 93776,
                        "name": "Curtici",
                        "latitude": "46.35000000",
                        "longitude": "21.30000000"
                    },
                    {
                        "id": 93782,
                        "name": "Cuvin",
                        "latitude": "46.17001000",
                        "longitude": "21.59360000"
                    },
                    {
                        "id": 93932,
                        "name": "Dezna",
                        "latitude": "46.40000000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 93936,
                        "name": "Dieci",
                        "latitude": "46.31667000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 93996,
                        "name": "Dorgoş",
                        "latitude": "46.05000000",
                        "longitude": "21.83333000"
                    },
                    {
                        "id": 94003,
                        "name": "Dorobanți",
                        "latitude": "46.35022000",
                        "longitude": "21.24441000"
                    },
                    {
                        "id": 94029,
                        "name": "Drauț",
                        "latitude": "46.26048000",
                        "longitude": "21.80924000"
                    },
                    {
                        "id": 94238,
                        "name": "Fântânele",
                        "latitude": "46.12370000",
                        "longitude": "21.38420000"
                    },
                    {
                        "id": 94156,
                        "name": "Felnac",
                        "latitude": "46.11667000",
                        "longitude": "21.15000000"
                    },
                    {
                        "id": 94214,
                        "name": "Frumușeni",
                        "latitude": "46.10252000",
                        "longitude": "21.46167000"
                    },
                    {
                        "id": 94281,
                        "name": "Galșa",
                        "latitude": "46.28810000",
                        "longitude": "21.65137000"
                    },
                    {
                        "id": 94333,
                        "name": "Ghioroc",
                        "latitude": "46.15000000",
                        "longitude": "21.58333000"
                    },
                    {
                        "id": 94444,
                        "name": "Grăniceri",
                        "latitude": "46.51667000",
                        "longitude": "21.30000000"
                    },
                    {
                        "id": 94468,
                        "name": "Gurahonţ",
                        "latitude": "46.26667000",
                        "longitude": "22.35000000"
                    },
                    {
                        "id": 94470,
                        "name": "Gurba",
                        "latitude": "46.46756000",
                        "longitude": "21.78789000"
                    },
                    {
                        "id": 94600,
                        "name": "Hălmăgel",
                        "latitude": "46.26667000",
                        "longitude": "22.61667000"
                    },
                    {
                        "id": 94599,
                        "name": "Hălmagiu",
                        "latitude": "46.26667000",
                        "longitude": "22.58333000"
                    },
                    {
                        "id": 94610,
                        "name": "Hășmaș",
                        "latitude": "46.50000000",
                        "longitude": "22.08333000"
                    },
                    {
                        "id": 94561,
                        "name": "Horia",
                        "latitude": "46.20847000",
                        "longitude": "21.46287000"
                    },
                    {
                        "id": 94650,
                        "name": "Igneşti",
                        "latitude": "46.40000000",
                        "longitude": "22.16667000"
                    },
                    {
                        "id": 94667,
                        "name": "Ineu",
                        "latitude": "46.43372000",
                        "longitude": "21.84048000"
                    },
                    {
                        "id": 94686,
                        "name": "Iratoşu",
                        "latitude": "46.31667000",
                        "longitude": "21.20000000"
                    },
                    {
                        "id": 94804,
                        "name": "Lipova",
                        "latitude": "46.09085000",
                        "longitude": "21.69628000"
                    },
                    {
                        "id": 94814,
                        "name": "Livada",
                        "latitude": "46.22284000",
                        "longitude": "21.38403000"
                    },
                    {
                        "id": 94903,
                        "name": "Macea",
                        "latitude": "46.38333000",
                        "longitude": "21.30000000"
                    },
                    {
                        "id": 95230,
                        "name": "Măderat",
                        "latitude": "46.29493000",
                        "longitude": "21.71137000"
                    },
                    {
                        "id": 94908,
                        "name": "Mailat",
                        "latitude": "46.04189000",
                        "longitude": "21.10702000"
                    },
                    {
                        "id": 95264,
                        "name": "Mănăștur",
                        "latitude": "46.00949000",
                        "longitude": "21.13362000"
                    },
                    {
                        "id": 95215,
                        "name": "Mândruloc",
                        "latitude": "46.14863000",
                        "longitude": "21.46570000"
                    },
                    {
                        "id": 95226,
                        "name": "Mâsca",
                        "latitude": "46.30000000",
                        "longitude": "21.68333000"
                    },
                    {
                        "id": 95035,
                        "name": "Mișca",
                        "latitude": "46.60280000",
                        "longitude": "21.59998000"
                    },
                    {
                        "id": 95068,
                        "name": "Moneasa",
                        "latitude": "46.45000000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 95109,
                        "name": "Municipiul Arad",
                        "latitude": "46.17745000",
                        "longitude": "21.31348000"
                    },
                    {
                        "id": 95296,
                        "name": "Nadab",
                        "latitude": "46.48195000",
                        "longitude": "21.51178000"
                    },
                    {
                        "id": 95297,
                        "name": "Nadăș",
                        "latitude": "46.22490000",
                        "longitude": "21.95036000"
                    },
                    {
                        "id": 95367,
                        "name": "Nădlac",
                        "latitude": "46.16667000",
                        "longitude": "20.75000000"
                    },
                    {
                        "id": 95332,
                        "name": "Neudorf",
                        "latitude": "46.06960000",
                        "longitude": "21.61899000"
                    },
                    {
                        "id": 95424,
                        "name": "Olari",
                        "latitude": "46.38333000",
                        "longitude": "21.55000000"
                    },
                    {
                        "id": 95492,
                        "name": "Oraş Chişineu-Criş",
                        "latitude": "46.52178000",
                        "longitude": "21.51295000"
                    },
                    {
                        "id": 95502,
                        "name": "Oraş Curtici",
                        "latitude": "46.34358000",
                        "longitude": "21.31051000"
                    },
                    {
                        "id": 95534,
                        "name": "Oraş Ineu",
                        "latitude": "46.42709000",
                        "longitude": "21.84185000"
                    },
                    {
                        "id": 95538,
                        "name": "Oraş Lipova",
                        "latitude": "46.09061000",
                        "longitude": "21.69465000"
                    },
                    {
                        "id": 95553,
                        "name": "Oraş Nãdlac",
                        "latitude": "46.16664000",
                        "longitude": "20.74871000"
                    },
                    {
                        "id": 95575,
                        "name": "Oraş Pâncota",
                        "latitude": "46.31205000",
                        "longitude": "21.70163000"
                    },
                    {
                        "id": 95597,
                        "name": "Oraş Sântana",
                        "latitude": "46.34622000",
                        "longitude": "21.50402000"
                    },
                    {
                        "id": 95585,
                        "name": "Oraş Sebiş",
                        "latitude": "46.38771000",
                        "longitude": "22.15480000"
                    },
                    {
                        "id": 95994,
                        "name": "Pâncota",
                        "latitude": "46.33333000",
                        "longitude": "21.70000000"
                    },
                    {
                        "id": 96032,
                        "name": "Păuliş",
                        "latitude": "46.11667000",
                        "longitude": "21.58333000"
                    },
                    {
                        "id": 95722,
                        "name": "Pecica",
                        "latitude": "46.16667000",
                        "longitude": "21.06667000"
                    },
                    {
                        "id": 95725,
                        "name": "Peregu Mare",
                        "latitude": "46.23333000",
                        "longitude": "20.90000000"
                    },
                    {
                        "id": 95726,
                        "name": "Peregu Mic",
                        "latitude": "46.25021000",
                        "longitude": "20.94885000"
                    },
                    {
                        "id": 95753,
                        "name": "Petriş",
                        "latitude": "46.05000000",
                        "longitude": "22.38333000"
                    },
                    {
                        "id": 95793,
                        "name": "Pilu",
                        "latitude": "46.56667000",
                        "longitude": "21.35000000"
                    },
                    {
                        "id": 95811,
                        "name": "Pleşcuţa",
                        "latitude": "46.30000000",
                        "longitude": "22.43333000"
                    },
                    {
                        "id": 96051,
                        "name": "Radna",
                        "latitude": "46.09444000",
                        "longitude": "21.68732000"
                    },
                    {
                        "id": 97028,
                        "name": "Şagu",
                        "latitude": "46.05000000",
                        "longitude": "21.28333000"
                    },
                    {
                        "id": 96521,
                        "name": "Sâmbăteni",
                        "latitude": "46.14110000",
                        "longitude": "21.52689000"
                    },
                    {
                        "id": 96532,
                        "name": "Sânmartin",
                        "latitude": "46.41653000",
                        "longitude": "21.34821000"
                    },
                    {
                        "id": 96544,
                        "name": "Sânpetru German",
                        "latitude": "46.11327000",
                        "longitude": "21.04932000"
                    },
                    {
                        "id": 105976,
                        "name": "Sântana",
                        "latitude": "46.35000000",
                        "longitude": "21.50000000"
                    },
                    {
                        "id": 96254,
                        "name": "Satu Mare",
                        "latitude": "46.06628000",
                        "longitude": "20.95826000"
                    },
                    {
                        "id": 106048,
                        "name": "Săvârşin",
                        "latitude": "46.01667000",
                        "longitude": "22.23333000"
                    },
                    {
                        "id": 96304,
                        "name": "Sebiş",
                        "latitude": "46.36667000",
                        "longitude": "22.11667000"
                    },
                    {
                        "id": 96317,
                        "name": "Secusigiu",
                        "latitude": "46.08333000",
                        "longitude": "20.98333000"
                    },
                    {
                        "id": 97034,
                        "name": "Şeitin",
                        "latitude": "46.10000000",
                        "longitude": "20.85000000"
                    },
                    {
                        "id": 96324,
                        "name": "Seleuş",
                        "latitude": "46.38333000",
                        "longitude": "21.71667000"
                    },
                    {
                        "id": 96325,
                        "name": "Semlac",
                        "latitude": "46.11667000",
                        "longitude": "20.93333000"
                    },
                    {
                        "id": 97116,
                        "name": "Șepreuș",
                        "latitude": "46.57125000",
                        "longitude": "21.73417000"
                    },
                    {
                        "id": 97121,
                        "name": "Șiclău",
                        "latitude": "46.49124000",
                        "longitude": "21.36834000"
                    },
                    {
                        "id": 97043,
                        "name": "Şicula",
                        "latitude": "46.43333000",
                        "longitude": "21.75000000"
                    },
                    {
                        "id": 97048,
                        "name": "Şilindia",
                        "latitude": "46.35000000",
                        "longitude": "21.91667000"
                    },
                    {
                        "id": 97049,
                        "name": "Şimand",
                        "latitude": "46.43333000",
                        "longitude": "21.45000000"
                    },
                    {
                        "id": 96356,
                        "name": "Sintea Mare",
                        "latitude": "46.51667000",
                        "longitude": "21.60000000"
                    },
                    {
                        "id": 97058,
                        "name": "Şiria",
                        "latitude": "46.26667000",
                        "longitude": "21.63333000"
                    },
                    {
                        "id": 97062,
                        "name": "Şiştarovăţ",
                        "latitude": "46.01667000",
                        "longitude": "21.73333000"
                    },
                    {
                        "id": 96396,
                        "name": "Socodor",
                        "latitude": "46.51667000",
                        "longitude": "21.43333000"
                    },
                    {
                        "id": 97064,
                        "name": "Şofronea",
                        "latitude": "46.26667000",
                        "longitude": "21.30000000"
                    },
                    {
                        "id": 96595,
                        "name": "Târnova",
                        "latitude": "46.31667000",
                        "longitude": "21.80000000"
                    },
                    {
                        "id": 106063,
                        "name": "Tauţ",
                        "latitude": "46.28333000",
                        "longitude": "21.91667000"
                    },
                    {
                        "id": 97140,
                        "name": "Țipar",
                        "latitude": "46.47563000",
                        "longitude": "21.63431000"
                    },
                    {
                        "id": 96564,
                        "name": "Turnu",
                        "latitude": "46.25764000",
                        "longitude": "21.12657000"
                    },
                    {
                        "id": 96691,
                        "name": "Ususău",
                        "latitude": "46.07063000",
                        "longitude": "21.81371000"
                    },
                    {
                        "id": 96932,
                        "name": "Vânători",
                        "latitude": "46.62456000",
                        "longitude": "21.67332000"
                    },
                    {
                        "id": 96973,
                        "name": "Vărădia de Mureş",
                        "latitude": "46.01667000",
                        "longitude": "22.15000000"
                    },
                    {
                        "id": 96940,
                        "name": "Vârfurile",
                        "latitude": "46.31667000",
                        "longitude": "22.51667000"
                    },
                    {
                        "id": 96832,
                        "name": "Vinga",
                        "latitude": "46.01667000",
                        "longitude": "21.20000000"
                    },
                    {
                        "id": 96857,
                        "name": "Vladimirescu",
                        "latitude": "46.16628000",
                        "longitude": "21.40102000"
                    },
                    {
                        "id": 97009,
                        "name": "Zăbrani",
                        "latitude": "46.06667000",
                        "longitude": "21.55000000"
                    },
                    {
                        "id": 97010,
                        "name": "Zădăreni",
                        "latitude": "46.13274000",
                        "longitude": "21.21821000"
                    },
                    {
                        "id": 97014,
                        "name": "Zărand",
                        "latitude": "46.40000000",
                        "longitude": "21.65000000"
                    },
                    {
                        "id": 96989,
                        "name": "Zerind",
                        "latitude": "46.61667000",
                        "longitude": "21.51667000"
                    },
                    {
                        "id": 96993,
                        "name": "Zimandu Nou",
                        "latitude": "46.28333000",
                        "longitude": "21.40000000"
                    }
                ]
            },
            {
                "id": 4722,
                "name": "Arges",
                "iso2": "AG",
                "latitude": "45.07225270",
                "longitude": "24.81427260",
                "type": "department",
                "cities": [
                    {
                        "id": 89914,
                        "name": "Albeşti",
                        "latitude": "45.30955000",
                        "longitude": "25.00780000"
                    },
                    {
                        "id": 89919,
                        "name": "Albeştii Pământeni",
                        "latitude": "45.21667000",
                        "longitude": "24.66667000"
                    },
                    {
                        "id": 89921,
                        "name": "Albeștii Ungureni",
                        "latitude": "45.22529000",
                        "longitude": "24.67254000"
                    },
                    {
                        "id": 89923,
                        "name": "Albota",
                        "latitude": "44.78333000",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 89924,
                        "name": "Albota de Jos",
                        "latitude": "44.76667000",
                        "longitude": "24.83333000"
                    },
                    {
                        "id": 89964,
                        "name": "Aninoasa",
                        "latitude": "45.18333000",
                        "longitude": "24.93333000"
                    },
                    {
                        "id": 89985,
                        "name": "Arefu",
                        "latitude": "45.33333000",
                        "longitude": "24.60000000"
                    },
                    {
                        "id": 89988,
                        "name": "Argeșelu",
                        "latitude": "44.92740000",
                        "longitude": "24.87115000"
                    },
                    {
                        "id": 90467,
                        "name": "Băbana",
                        "latitude": "44.90000000",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 90483,
                        "name": "Bădești",
                        "latitude": "45.17157000",
                        "longitude": "24.86064000"
                    },
                    {
                        "id": 90487,
                        "name": "Băiculeşti",
                        "latitude": "45.06667000",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 90501,
                        "name": "Băjești",
                        "latitude": "45.02615000",
                        "longitude": "24.94006000"
                    },
                    {
                        "id": 90512,
                        "name": "Bălileşti",
                        "latitude": "45.06667000",
                        "longitude": "24.93333000"
                    },
                    {
                        "id": 90548,
                        "name": "Bărăști",
                        "latitude": "45.25369000",
                        "longitude": "24.59651000"
                    },
                    {
                        "id": 90449,
                        "name": "Bârla",
                        "latitude": "44.42606000",
                        "longitude": "24.77743000"
                    },
                    {
                        "id": 90451,
                        "name": "Bârlogu",
                        "latitude": "44.62658000",
                        "longitude": "25.08066000"
                    },
                    {
                        "id": 90073,
                        "name": "Başcov",
                        "latitude": "44.90000000",
                        "longitude": "24.81667000"
                    },
                    {
                        "id": 90086,
                        "name": "Beleţi",
                        "latitude": "44.90000000",
                        "longitude": "25.08333000"
                    },
                    {
                        "id": 90102,
                        "name": "Berevoeşti",
                        "latitude": "45.23333000",
                        "longitude": "24.91667000"
                    },
                    {
                        "id": 90185,
                        "name": "Bogaţi",
                        "latitude": "44.86667000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 90242,
                        "name": "Boteni",
                        "latitude": "45.18333000",
                        "longitude": "25.11667000"
                    },
                    {
                        "id": 90257,
                        "name": "Boţeşti",
                        "latitude": "45.01667000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 90262,
                        "name": "Bradu",
                        "latitude": "44.78333000",
                        "longitude": "24.90000000"
                    },
                    {
                        "id": 90326,
                        "name": "Brăduleţ",
                        "latitude": "45.28333000",
                        "longitude": "24.76667000"
                    },
                    {
                        "id": 90367,
                        "name": "Bucșenești",
                        "latitude": "45.30096000",
                        "longitude": "24.65841000"
                    },
                    {
                        "id": 90368,
                        "name": "Bucșenești-Lotași",
                        "latitude": "45.01307000",
                        "longitude": "24.96845000"
                    },
                    {
                        "id": 90378,
                        "name": "Budeasa Mică",
                        "latitude": "44.95000000",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 90392,
                        "name": "Bughea de Jos",
                        "latitude": "45.26667000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 90394,
                        "name": "Bughea de Sus",
                        "latitude": "45.29812000",
                        "longitude": "25.03284000"
                    },
                    {
                        "id": 90434,
                        "name": "Buzoeşti",
                        "latitude": "44.58333000",
                        "longitude": "24.91667000"
                    },
                    {
                        "id": 93832,
                        "name": "Căldăraru",
                        "latitude": "44.45000000",
                        "longitude": "24.95000000"
                    },
                    {
                        "id": 93838,
                        "name": "Călineşti",
                        "latitude": "44.81667000",
                        "longitude": "25.05000000"
                    },
                    {
                        "id": 93800,
                        "name": "Câmpulung",
                        "latitude": "45.26667000",
                        "longitude": "25.05000000"
                    },
                    {
                        "id": 93864,
                        "name": "Căpățânenii Pământeni",
                        "latitude": "45.31667000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 90571,
                        "name": "Capu Piscului",
                        "latitude": "45.17999000",
                        "longitude": "24.97679000"
                    },
                    {
                        "id": 93876,
                        "name": "Căteasca",
                        "latitude": "44.76667000",
                        "longitude": "25.08333000"
                    },
                    {
                        "id": 90617,
                        "name": "Ceparii Pământeni",
                        "latitude": "45.21667000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 90650,
                        "name": "Cetăţeni",
                        "latitude": "45.20000000",
                        "longitude": "25.18333000"
                    },
                    {
                        "id": 90699,
                        "name": "Cicănești",
                        "latitude": "45.24601000",
                        "longitude": "24.60526000"
                    },
                    {
                        "id": 90718,
                        "name": "Ciofrângeni",
                        "latitude": "45.08333000",
                        "longitude": "24.53333000"
                    },
                    {
                        "id": 90721,
                        "name": "Ciomăgeşti",
                        "latitude": "44.83333000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 90748,
                        "name": "Ciulnița",
                        "latitude": "44.78769000",
                        "longitude": "25.15388000"
                    },
                    {
                        "id": 90784,
                        "name": "Cocu",
                        "latitude": "44.86667000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 90796,
                        "name": "Colibași",
                        "latitude": "44.93544000",
                        "longitude": "24.90905000"
                    },
                    {
                        "id": 90844,
                        "name": "Comuna Albeștii de Argeș",
                        "latitude": "45.21667000",
                        "longitude": "24.66667000"
                    },
                    {
                        "id": 90845,
                        "name": "Comuna Albeștii de Muscel",
                        "latitude": "45.31667000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 90846,
                        "name": "Comuna Albota",
                        "latitude": "44.78287000",
                        "longitude": "24.81838000"
                    },
                    {
                        "id": 90872,
                        "name": "Comuna Aninoasa",
                        "latitude": "45.20222000",
                        "longitude": "24.91206000"
                    },
                    {
                        "id": 90888,
                        "name": "Comuna Arefu",
                        "latitude": "45.33142000",
                        "longitude": "24.62944000"
                    },
                    {
                        "id": 91199,
                        "name": "Comuna Băbana",
                        "latitude": "44.87539000",
                        "longitude": "24.71918000"
                    },
                    {
                        "id": 91206,
                        "name": "Comuna Băiculeşti",
                        "latitude": "45.06017000",
                        "longitude": "24.67331000"
                    },
                    {
                        "id": 91217,
                        "name": "Comuna Bălileşti",
                        "latitude": "45.07981000",
                        "longitude": "24.93943000"
                    },
                    {
                        "id": 91188,
                        "name": "Comuna Bârla",
                        "latitude": "44.42636000",
                        "longitude": "24.77949000"
                    },
                    {
                        "id": 90942,
                        "name": "Comuna Başcov",
                        "latitude": "44.89295000",
                        "longitude": "24.78532000"
                    },
                    {
                        "id": 90951,
                        "name": "Comuna Beleţi-Negreşti",
                        "latitude": "44.94651000",
                        "longitude": "25.08603000"
                    },
                    {
                        "id": 90963,
                        "name": "Comuna Berevoeşti",
                        "latitude": "45.25327000",
                        "longitude": "24.94292000"
                    },
                    {
                        "id": 91020,
                        "name": "Comuna Bogaţi",
                        "latitude": "44.87344000",
                        "longitude": "25.15045000"
                    },
                    {
                        "id": 91059,
                        "name": "Comuna Boteni",
                        "latitude": "45.17937000",
                        "longitude": "25.13073000"
                    },
                    {
                        "id": 91071,
                        "name": "Comuna Boţeşti",
                        "latitude": "45.00704000",
                        "longitude": "25.14723000"
                    },
                    {
                        "id": 91073,
                        "name": "Comuna Bradu",
                        "latitude": "44.78333000",
                        "longitude": "24.90000000"
                    },
                    {
                        "id": 91115,
                        "name": "Comuna Brăduleţ",
                        "latitude": "45.27502000",
                        "longitude": "24.77372000"
                    },
                    {
                        "id": 91144,
                        "name": "Comuna Budeasa",
                        "latitude": "44.95042000",
                        "longitude": "24.80254000"
                    },
                    {
                        "id": 91152,
                        "name": "Comuna Bughea de Jos",
                        "latitude": "45.27404000",
                        "longitude": "25.00324000"
                    },
                    {
                        "id": 91153,
                        "name": "Comuna Bughea de Sus",
                        "latitude": "45.29812000",
                        "longitude": "25.03284000"
                    },
                    {
                        "id": 91180,
                        "name": "Comuna Buzoeşti",
                        "latitude": "44.60205000",
                        "longitude": "24.91856000"
                    },
                    {
                        "id": 91570,
                        "name": "Comuna Căldăraru",
                        "latitude": "44.45395000",
                        "longitude": "24.94263000"
                    },
                    {
                        "id": 91572,
                        "name": "Comuna Călineşti",
                        "latitude": "44.85650000",
                        "longitude": "25.01968000"
                    },
                    {
                        "id": 91592,
                        "name": "Comuna Căteasca",
                        "latitude": "44.77056000",
                        "longitude": "25.03633000"
                    },
                    {
                        "id": 91283,
                        "name": "Comuna Cepari",
                        "latitude": "45.20564000",
                        "longitude": "24.53064000"
                    },
                    {
                        "id": 91306,
                        "name": "Comuna Cetăţeni",
                        "latitude": "45.19234000",
                        "longitude": "25.20789000"
                    },
                    {
                        "id": 91335,
                        "name": "Comuna Cicănești",
                        "latitude": "45.24577000",
                        "longitude": "24.60629000"
                    },
                    {
                        "id": 91348,
                        "name": "Comuna Ciofrângeni",
                        "latitude": "45.10277000",
                        "longitude": "24.53704000"
                    },
                    {
                        "id": 91352,
                        "name": "Comuna Ciomăgeşti",
                        "latitude": "44.85656000",
                        "longitude": "24.47229000"
                    },
                    {
                        "id": 91391,
                        "name": "Comuna Cocu",
                        "latitude": "44.87429000",
                        "longitude": "24.65112000"
                    },
                    {
                        "id": 91424,
                        "name": "Comuna Corbeni",
                        "latitude": "45.29597000",
                        "longitude": "24.66207000"
                    },
                    {
                        "id": 91425,
                        "name": "Comuna Corbi",
                        "latitude": "45.25572000",
                        "longitude": "24.81611000"
                    },
                    {
                        "id": 91475,
                        "name": "Comuna Coşeşti",
                        "latitude": "45.06431000",
                        "longitude": "24.87202000"
                    },
                    {
                        "id": 91465,
                        "name": "Comuna Cotmeana",
                        "latitude": "45.00518000",
                        "longitude": "24.62021000"
                    },
                    {
                        "id": 91518,
                        "name": "Comuna Cuca",
                        "latitude": "44.95654000",
                        "longitude": "24.50636000"
                    },
                    {
                        "id": 91726,
                        "name": "Comuna Dâmbovicioara",
                        "latitude": "45.43452000",
                        "longitude": "25.22737000"
                    },
                    {
                        "id": 91743,
                        "name": "Comuna Dărmăneşti",
                        "latitude": "45.00656000",
                        "longitude": "24.90224000"
                    },
                    {
                        "id": 91606,
                        "name": "Comuna Davideşti",
                        "latitude": "45.00694000",
                        "longitude": "25.03599000"
                    },
                    {
                        "id": 91637,
                        "name": "Comuna Dobreşti",
                        "latitude": "44.94992000",
                        "longitude": "25.11907000"
                    },
                    {
                        "id": 91659,
                        "name": "Comuna Domneşti",
                        "latitude": "45.20562000",
                        "longitude": "24.83945000"
                    },
                    {
                        "id": 91686,
                        "name": "Comuna Drăganu",
                        "latitude": "44.93761000",
                        "longitude": "24.70301000"
                    },
                    {
                        "id": 91676,
                        "name": "Comuna Dragoslavele",
                        "latitude": "45.33451000",
                        "longitude": "25.17010000"
                    },
                    {
                        "id": 91888,
                        "name": "Comuna Godeni",
                        "latitude": "45.22311000",
                        "longitude": "24.97842000"
                    },
                    {
                        "id": 92032,
                        "name": "Comuna Hârseşti",
                        "latitude": "44.51091000",
                        "longitude": "24.78294000"
                    },
                    {
                        "id": 92033,
                        "name": "Comuna Hârtieşti",
                        "latitude": "45.12629000",
                        "longitude": "25.11343000"
                    },
                    {
                        "id": 92109,
                        "name": "Comuna Izvoru",
                        "latitude": "44.49414000",
                        "longitude": "25.06470000"
                    },
                    {
                        "id": 92152,
                        "name": "Comuna Leordeni",
                        "latitude": "44.79117000",
                        "longitude": "25.16299000"
                    },
                    {
                        "id": 92154,
                        "name": "Comuna Lereşti",
                        "latitude": "45.32789000",
                        "longitude": "25.06951000"
                    },
                    {
                        "id": 92203,
                        "name": "Comuna Lunca Corbului",
                        "latitude": "44.68361000",
                        "longitude": "24.76056000"
                    },
                    {
                        "id": 92399,
                        "name": "Comuna Mălureni",
                        "latitude": "45.04780000",
                        "longitude": "24.77875000"
                    },
                    {
                        "id": 92416,
                        "name": "Comuna Mărăcineni",
                        "latitude": "44.90857000",
                        "longitude": "24.87484000"
                    },
                    {
                        "id": 92261,
                        "name": "Comuna Merișani",
                        "latitude": "44.96674000",
                        "longitude": "24.74482000"
                    },
                    {
                        "id": 92264,
                        "name": "Comuna Miceşti",
                        "latitude": "44.97367000",
                        "longitude": "24.85577000"
                    },
                    {
                        "id": 92281,
                        "name": "Comuna Mihăeşti",
                        "latitude": "45.11563000",
                        "longitude": "25.01938000"
                    },
                    {
                        "id": 92294,
                        "name": "Comuna Mioarele",
                        "latitude": "45.23396000",
                        "longitude": "25.10045000"
                    },
                    {
                        "id": 92302,
                        "name": "Comuna Miroşi",
                        "latitude": "44.40316000",
                        "longitude": "24.95170000"
                    },
                    {
                        "id": 92335,
                        "name": "Comuna Morărești",
                        "latitude": "45.00760000",
                        "longitude": "24.56079000"
                    },
                    {
                        "id": 92349,
                        "name": "Comuna Moşoaia",
                        "latitude": "44.83013000",
                        "longitude": "24.79957000"
                    },
                    {
                        "id": 92345,
                        "name": "Comuna Mozăceni",
                        "latitude": "44.56366000",
                        "longitude": "25.17492000"
                    },
                    {
                        "id": 92365,
                        "name": "Comuna Mușătești",
                        "latitude": "45.21667000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 92430,
                        "name": "Comuna Negraşi",
                        "latitude": "44.61441000",
                        "longitude": "25.12404000"
                    },
                    {
                        "id": 92456,
                        "name": "Comuna Nucşoara",
                        "latitude": "45.33798000",
                        "longitude": "24.78943000"
                    },
                    {
                        "id": 92468,
                        "name": "Comuna Oarja",
                        "latitude": "44.75730000",
                        "longitude": "24.96935000"
                    },
                    {
                        "id": 92582,
                        "name": "Comuna Pietroşani",
                        "latitude": "45.15375000",
                        "longitude": "24.84439000"
                    },
                    {
                        "id": 92628,
                        "name": "Comuna Poiana Lacului",
                        "latitude": "44.81199000",
                        "longitude": "24.71296000"
                    },
                    {
                        "id": 92637,
                        "name": "Comuna Poienarii de Argeş",
                        "latitude": "45.06667000",
                        "longitude": "24.53333000"
                    },
                    {
                        "id": 92638,
                        "name": "Comuna Poienarii de Muscel",
                        "latitude": "45.21667000",
                        "longitude": "25.05000000"
                    },
                    {
                        "id": 92652,
                        "name": "Comuna Popeşti",
                        "latitude": "44.44521000",
                        "longitude": "25.09114000"
                    },
                    {
                        "id": 92673,
                        "name": "Comuna Priboieni",
                        "latitude": "44.87728000",
                        "longitude": "25.08680000"
                    },
                    {
                        "id": 92819,
                        "name": "Comuna Râca",
                        "latitude": "44.44216000",
                        "longitude": "25.03671000"
                    },
                    {
                        "id": 92851,
                        "name": "Comuna Răteşti",
                        "latitude": "44.71690000",
                        "longitude": "25.15858000"
                    },
                    {
                        "id": 92755,
                        "name": "Comuna Recea",
                        "latitude": "44.54264000",
                        "longitude": "25.02738000"
                    },
                    {
                        "id": 92776,
                        "name": "Comuna Rociu",
                        "latitude": "44.66838000",
                        "longitude": "25.02014000"
                    },
                    {
                        "id": 92806,
                        "name": "Comuna Rucăr",
                        "latitude": "45.41607000",
                        "longitude": "25.17338000"
                    },
                    {
                        "id": 93100,
                        "name": "Comuna Sălătrucu",
                        "latitude": "45.29098000",
                        "longitude": "24.52523000"
                    },
                    {
                        "id": 93104,
                        "name": "Comuna Săpata",
                        "latitude": "44.72789000",
                        "longitude": "24.75280000"
                    },
                    {
                        "id": 92890,
                        "name": "Comuna Schitu-Goleşti",
                        "latitude": "45.18630000",
                        "longitude": "25.00576000"
                    },
                    {
                        "id": 92954,
                        "name": "Comuna Slobozia",
                        "latitude": "44.52197000",
                        "longitude": "25.24092000"
                    },
                    {
                        "id": 93012,
                        "name": "Comuna Stâlpeni",
                        "latitude": "45.05665000",
                        "longitude": "24.99307000"
                    },
                    {
                        "id": 93550,
                        "name": "Comuna Ştefan cel Mare",
                        "latitude": "44.49197000",
                        "longitude": "25.24710000"
                    },
                    {
                        "id": 92992,
                        "name": "Comuna Stoeneşti",
                        "latitude": "45.26432000",
                        "longitude": "25.17674000"
                    },
                    {
                        "id": 92999,
                        "name": "Comuna Stolnici",
                        "latitude": "44.58075000",
                        "longitude": "24.77335000"
                    },
                    {
                        "id": 93559,
                        "name": "Comuna Şuici",
                        "latitude": "45.24454000",
                        "longitude": "24.53621000"
                    },
                    {
                        "id": 93041,
                        "name": "Comuna Suseni",
                        "latitude": "44.70861000",
                        "longitude": "24.96437000"
                    },
                    {
                        "id": 93133,
                        "name": "Comuna Teiu",
                        "latitude": "44.64225000",
                        "longitude": "25.14110000"
                    },
                    {
                        "id": 93151,
                        "name": "Comuna Tigveni",
                        "latitude": "45.15588000",
                        "longitude": "24.55094000"
                    },
                    {
                        "id": 93580,
                        "name": "Comuna Țițești",
                        "latitude": "45.01146000",
                        "longitude": "24.97898000"
                    },
                    {
                        "id": 93252,
                        "name": "Comuna Uda",
                        "latitude": "44.87591000",
                        "longitude": "24.58582000"
                    },
                    {
                        "id": 93267,
                        "name": "Comuna Ungheni",
                        "latitude": "44.51166000",
                        "longitude": "24.95186000"
                    },
                    {
                        "id": 93303,
                        "name": "Comuna Valea Danului",
                        "latitude": "45.18962000",
                        "longitude": "24.61959000"
                    },
                    {
                        "id": 93306,
                        "name": "Comuna Valea Iaşului",
                        "latitude": "45.19677000",
                        "longitude": "24.70094000"
                    },
                    {
                        "id": 93315,
                        "name": "Comuna Valea Mare-Pravăţ",
                        "latitude": "45.28900000",
                        "longitude": "25.10567000"
                    },
                    {
                        "id": 93338,
                        "name": "Comuna Vedea",
                        "latitude": "44.77735000",
                        "longitude": "24.64677000"
                    },
                    {
                        "id": 93391,
                        "name": "Comuna Vlădeşti",
                        "latitude": "45.14344000",
                        "longitude": "24.93634000"
                    },
                    {
                        "id": 93418,
                        "name": "Comuna Vultureşti",
                        "latitude": "45.05999000",
                        "longitude": "25.07370000"
                    },
                    {
                        "id": 93598,
                        "name": "Conțești",
                        "latitude": "44.98494000",
                        "longitude": "25.01032000"
                    },
                    {
                        "id": 93613,
                        "name": "Corbeni",
                        "latitude": "45.30000000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 93614,
                        "name": "Corbi",
                        "latitude": "45.28333000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 93644,
                        "name": "Cornățel",
                        "latitude": "44.57972000",
                        "longitude": "24.95487000"
                    },
                    {
                        "id": 93691,
                        "name": "Coşeşti",
                        "latitude": "45.06667000",
                        "longitude": "24.86667000"
                    },
                    {
                        "id": 93661,
                        "name": "Costeşti",
                        "latitude": "44.66667000",
                        "longitude": "24.88333000"
                    },
                    {
                        "id": 93673,
                        "name": "Cotenești",
                        "latitude": "45.23462000",
                        "longitude": "25.18617000"
                    },
                    {
                        "id": 93675,
                        "name": "Cotmeana",
                        "latitude": "44.96667000",
                        "longitude": "24.61667000"
                    },
                    {
                        "id": 93757,
                        "name": "Cuca",
                        "latitude": "44.95000000",
                        "longitude": "24.51667000"
                    },
                    {
                        "id": 93774,
                        "name": "Curtea de Argeş",
                        "latitude": "45.13422000",
                        "longitude": "24.67409000"
                    },
                    {
                        "id": 94105,
                        "name": "Dâmbovicioara",
                        "latitude": "45.45000000",
                        "longitude": "25.23333000"
                    },
                    {
                        "id": 94133,
                        "name": "Dărmăneşti",
                        "latitude": "45.01667000",
                        "longitude": "24.90000000"
                    },
                    {
                        "id": 93898,
                        "name": "Davideşti",
                        "latitude": "45.01667000",
                        "longitude": "25.03333000"
                    },
                    {
                        "id": 93955,
                        "name": "Dobreşti",
                        "latitude": "44.96667000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 93968,
                        "name": "Dobrotu",
                        "latitude": "45.20633000",
                        "longitude": "24.65859000"
                    },
                    {
                        "id": 93989,
                        "name": "Domneşti",
                        "latitude": "45.20000000",
                        "longitude": "24.83333000"
                    },
                    {
                        "id": 94036,
                        "name": "Drăganu-Olteni",
                        "latitude": "44.93333000",
                        "longitude": "24.71667000"
                    },
                    {
                        "id": 94039,
                        "name": "Drăghici",
                        "latitude": "45.12865000",
                        "longitude": "25.04508000"
                    },
                    {
                        "id": 94021,
                        "name": "Dragoslavele",
                        "latitude": "45.34801000",
                        "longitude": "25.16925000"
                    },
                    {
                        "id": 94254,
                        "name": "Făgetu",
                        "latitude": "44.90616000",
                        "longitude": "24.91159000"
                    },
                    {
                        "id": 94508,
                        "name": "Gălășești",
                        "latitude": "44.95593000",
                        "longitude": "24.78602000"
                    },
                    {
                        "id": 94286,
                        "name": "Geamăna",
                        "latitude": "44.82005000",
                        "longitude": "24.89109000"
                    },
                    {
                        "id": 94368,
                        "name": "Godeni",
                        "latitude": "45.23333000",
                        "longitude": "24.98333000"
                    },
                    {
                        "id": 94378,
                        "name": "Golești",
                        "latitude": "44.83970000",
                        "longitude": "24.96530000"
                    },
                    {
                        "id": 94384,
                        "name": "Gorganu",
                        "latitude": "44.84241000",
                        "longitude": "25.03838000"
                    },
                    {
                        "id": 94589,
                        "name": "Hârseşti",
                        "latitude": "44.53333000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 94590,
                        "name": "Hârtieşti",
                        "latitude": "45.11667000",
                        "longitude": "25.10000000"
                    },
                    {
                        "id": 94575,
                        "name": "Humele",
                        "latitude": "44.52612000",
                        "longitude": "24.97714000"
                    },
                    {
                        "id": 94715,
                        "name": "Izvoru",
                        "latitude": "44.49414000",
                        "longitude": "25.06470000"
                    },
                    {
                        "id": 94720,
                        "name": "Izvoru de Sus",
                        "latitude": "44.81667000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 94750,
                        "name": "Jugur",
                        "latitude": "45.19255000",
                        "longitude": "25.08493000"
                    },
                    {
                        "id": 94754,
                        "name": "Jupânești",
                        "latitude": "45.06667000",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 94902,
                        "name": "Lăzărești",
                        "latitude": "45.15659000",
                        "longitude": "24.99540000"
                    },
                    {
                        "id": 94771,
                        "name": "Leicești",
                        "latitude": "45.09586000",
                        "longitude": "24.86108000"
                    },
                    {
                        "id": 94779,
                        "name": "Leordeni",
                        "latitude": "44.78333000",
                        "longitude": "25.11667000"
                    },
                    {
                        "id": 94781,
                        "name": "Lereşti",
                        "latitude": "45.33333000",
                        "longitude": "25.06667000"
                    },
                    {
                        "id": 94818,
                        "name": "Livezeni",
                        "latitude": "45.03838000",
                        "longitude": "24.97676000"
                    },
                    {
                        "id": 94864,
                        "name": "Lunca Corbului",
                        "latitude": "44.68391000",
                        "longitude": "24.75855000"
                    },
                    {
                        "id": 95254,
                        "name": "Mălureni",
                        "latitude": "45.10000000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 95284,
                        "name": "Mărăcineni",
                        "latitude": "44.90000000",
                        "longitude": "24.88333000"
                    },
                    {
                        "id": 94926,
                        "name": "Mareș",
                        "latitude": "44.77824000",
                        "longitude": "24.79005000"
                    },
                    {
                        "id": 95224,
                        "name": "Mârţeşti",
                        "latitude": "44.71667000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 95295,
                        "name": "Mățău",
                        "latitude": "45.23565000",
                        "longitude": "25.08286000"
                    },
                    {
                        "id": 94959,
                        "name": "Merişani",
                        "latitude": "44.96820000",
                        "longitude": "24.74327000"
                    },
                    {
                        "id": 94965,
                        "name": "Miceşti",
                        "latitude": "44.95000000",
                        "longitude": "24.86667000"
                    },
                    {
                        "id": 94988,
                        "name": "Mihăeşti",
                        "latitude": "45.11667000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 95011,
                        "name": "Mioveni",
                        "latitude": "44.95905000",
                        "longitude": "24.94198000"
                    },
                    {
                        "id": 95024,
                        "name": "Miroşi",
                        "latitude": "44.41667000",
                        "longitude": "24.93333000"
                    },
                    {
                        "id": 95075,
                        "name": "Morăreşti",
                        "latitude": "45.01667000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 95091,
                        "name": "Moşoaia",
                        "latitude": "44.81667000",
                        "longitude": "24.76667000"
                    },
                    {
                        "id": 95087,
                        "name": "Mozăceni",
                        "latitude": "44.56667000",
                        "longitude": "25.16667000"
                    },
                    {
                        "id": 95132,
                        "name": "Municipiul Câmpulung",
                        "latitude": "45.26691000",
                        "longitude": "25.04419000"
                    },
                    {
                        "id": 95129,
                        "name": "Municipiul Curtea de Argeș",
                        "latitude": "45.13840000",
                        "longitude": "24.67512000"
                    },
                    {
                        "id": 95169,
                        "name": "Municipiul Piteşti",
                        "latitude": "44.85782000",
                        "longitude": "24.87133000"
                    },
                    {
                        "id": 95211,
                        "name": "Mușătești",
                        "latitude": "45.21651000",
                        "longitude": "24.77941000"
                    },
                    {
                        "id": 95313,
                        "name": "Negraşi",
                        "latitude": "44.60000000",
                        "longitude": "25.11667000"
                    },
                    {
                        "id": 95362,
                        "name": "Nucşoara",
                        "latitude": "45.33333000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 95383,
                        "name": "Oarja",
                        "latitude": "44.76053000",
                        "longitude": "24.97596000"
                    },
                    {
                        "id": 95384,
                        "name": "Oarja Sat",
                        "latitude": "44.76429000",
                        "longitude": "24.97141000"
                    },
                    {
                        "id": 95412,
                        "name": "Oeștii Pământeni",
                        "latitude": "45.25241000",
                        "longitude": "24.65658000"
                    },
                    {
                        "id": 95638,
                        "name": "Oraș Costeşti",
                        "latitude": "44.66667000",
                        "longitude": "24.88333000"
                    },
                    {
                        "id": 95642,
                        "name": "Oraș Mioveni",
                        "latitude": "44.95897000",
                        "longitude": "24.94274000"
                    },
                    {
                        "id": 95652,
                        "name": "Oraș Ştefăneşti",
                        "latitude": "44.86667000",
                        "longitude": "24.93333000"
                    },
                    {
                        "id": 95646,
                        "name": "Oraș Topoloveni",
                        "latitude": "44.81667000",
                        "longitude": "25.08333000"
                    },
                    {
                        "id": 96025,
                        "name": "Pătuleni",
                        "latitude": "44.73247000",
                        "longitude": "25.16495000"
                    },
                    {
                        "id": 95749,
                        "name": "Petrești",
                        "latitude": "45.04364000",
                        "longitude": "24.88989000"
                    },
                    {
                        "id": 95788,
                        "name": "Pietroşani",
                        "latitude": "45.18333000",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 95803,
                        "name": "Piteşti",
                        "latitude": "44.85000000",
                        "longitude": "24.86667000"
                    },
                    {
                        "id": 95875,
                        "name": "Poiana Lacului",
                        "latitude": "44.81667000",
                        "longitude": "24.73333000"
                    },
                    {
                        "id": 95886,
                        "name": "Poienari",
                        "latitude": "45.21667000",
                        "longitude": "25.05000000"
                    },
                    {
                        "id": 95908,
                        "name": "Popeşti",
                        "latitude": "44.44181000",
                        "longitude": "25.10007000"
                    },
                    {
                        "id": 95948,
                        "name": "Priboieni",
                        "latitude": "44.88333000",
                        "longitude": "25.08333000"
                    },
                    {
                        "id": 95985,
                        "name": "Purcăreni",
                        "latitude": "44.96847000",
                        "longitude": "24.88736000"
                    },
                    {
                        "id": 96164,
                        "name": "Râca",
                        "latitude": "44.43426000",
                        "longitude": "25.04333000"
                    },
                    {
                        "id": 96046,
                        "name": "Racovița",
                        "latitude": "44.97081000",
                        "longitude": "24.97582000"
                    },
                    {
                        "id": 96197,
                        "name": "Rădești",
                        "latitude": "45.07184000",
                        "longitude": "25.00207000"
                    },
                    {
                        "id": 96210,
                        "name": "Răteşti",
                        "latitude": "44.73333000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 96071,
                        "name": "Recea",
                        "latitude": "44.53333000",
                        "longitude": "25.01667000"
                    },
                    {
                        "id": 96089,
                        "name": "Retevoiești",
                        "latitude": "45.14016000",
                        "longitude": "24.83797000"
                    },
                    {
                        "id": 96098,
                        "name": "Rociu",
                        "latitude": "44.66667000",
                        "longitude": "25.03333000"
                    },
                    {
                        "id": 96144,
                        "name": "Rucăr",
                        "latitude": "45.40000000",
                        "longitude": "25.16667000"
                    },
                    {
                        "id": 106023,
                        "name": "Sălătrucu",
                        "latitude": "45.33333000",
                        "longitude": "24.51667000"
                    },
                    {
                        "id": 96274,
                        "name": "Schitu-Goleşti",
                        "latitude": "45.20000000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 97118,
                        "name": "Șerbănești",
                        "latitude": "44.68142000",
                        "longitude": "24.99236000"
                    },
                    {
                        "id": 97117,
                        "name": "Șerboeni",
                        "latitude": "44.63818000",
                        "longitude": "24.89355000"
                    },
                    {
                        "id": 96382,
                        "name": "Slănic",
                        "latitude": "45.23108000",
                        "longitude": "24.89411000"
                    },
                    {
                        "id": 96369,
                        "name": "Slobozia",
                        "latitude": "44.52527000",
                        "longitude": "25.24263000"
                    },
                    {
                        "id": 96468,
                        "name": "Stâlpeni",
                        "latitude": "45.05000000",
                        "longitude": "24.96667000"
                    },
                    {
                        "id": 97082,
                        "name": "Ştefan cel Mare",
                        "latitude": "44.49283000",
                        "longitude": "25.24418000"
                    },
                    {
                        "id": 97084,
                        "name": "Ştefăneşti",
                        "latitude": "44.86506000",
                        "longitude": "24.94961000"
                    },
                    {
                        "id": 96433,
                        "name": "Stoeneşti",
                        "latitude": "45.25000000",
                        "longitude": "25.16667000"
                    },
                    {
                        "id": 96443,
                        "name": "Stolnici",
                        "latitude": "44.56667000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 96460,
                        "name": "Strâmbeni",
                        "latitude": "44.46897000",
                        "longitude": "24.97315000"
                    },
                    {
                        "id": 96455,
                        "name": "Stroești",
                        "latitude": "45.12953000",
                        "longitude": "24.79418000"
                    },
                    {
                        "id": 97091,
                        "name": "Şuici",
                        "latitude": "45.25000000",
                        "longitude": "24.53333000"
                    },
                    {
                        "id": 96509,
                        "name": "Surdulești",
                        "latitude": "44.39217000",
                        "longitude": "24.95798000"
                    },
                    {
                        "id": 96511,
                        "name": "Suseni",
                        "latitude": "44.71667000",
                        "longitude": "24.95000000"
                    },
                    {
                        "id": 106071,
                        "name": "Teiu",
                        "latitude": "44.66667000",
                        "longitude": "25.10000000"
                    },
                    {
                        "id": 106096,
                        "name": "Tigveni",
                        "latitude": "45.13333000",
                        "longitude": "24.58333000"
                    },
                    {
                        "id": 106108,
                        "name": "Titeşti",
                        "latitude": "45.01667000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 106133,
                        "name": "Toplița",
                        "latitude": "45.09022000",
                        "longitude": "24.73236000"
                    },
                    {
                        "id": 106136,
                        "name": "Topoloveni",
                        "latitude": "44.81667000",
                        "longitude": "25.08333000"
                    },
                    {
                        "id": 96571,
                        "name": "Tutana",
                        "latitude": "45.04286000",
                        "longitude": "24.65122000"
                    },
                    {
                        "id": 96635,
                        "name": "Uda",
                        "latitude": "44.91667000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 96655,
                        "name": "Ungheni",
                        "latitude": "44.50000000",
                        "longitude": "24.96667000"
                    },
                    {
                        "id": 96713,
                        "name": "Valea Caselor",
                        "latitude": "45.35000000",
                        "longitude": "25.16667000"
                    },
                    {
                        "id": 96722,
                        "name": "Valea Danului",
                        "latitude": "45.18333000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 96726,
                        "name": "Valea Iaşului",
                        "latitude": "45.18333000",
                        "longitude": "24.71667000"
                    },
                    {
                        "id": 96738,
                        "name": "Valea Mare Pravăț",
                        "latitude": "45.29171000",
                        "longitude": "25.09250000"
                    },
                    {
                        "id": 96739,
                        "name": "Valea Mare-Podgoria",
                        "latitude": "44.88513000",
                        "longitude": "24.90613000"
                    },
                    {
                        "id": 96745,
                        "name": "Valea Popii",
                        "latitude": "45.09253000",
                        "longitude": "25.02240000"
                    },
                    {
                        "id": 96964,
                        "name": "Văleni-Podgoria",
                        "latitude": "44.85755000",
                        "longitude": "24.98930000"
                    },
                    {
                        "id": 96782,
                        "name": "Vedea",
                        "latitude": "44.78333000",
                        "longitude": "24.61667000"
                    },
                    {
                        "id": 96867,
                        "name": "Vlădești",
                        "latitude": "45.15000000",
                        "longitude": "24.91667000"
                    },
                    {
                        "id": 96882,
                        "name": "Voinești",
                        "latitude": "45.30007000",
                        "longitude": "25.07225000"
                    },
                    {
                        "id": 96899,
                        "name": "Vrănești",
                        "latitude": "44.84595000",
                        "longitude": "25.00716000"
                    },
                    {
                        "id": 96912,
                        "name": "Vulturești",
                        "latitude": "45.06618000",
                        "longitude": "25.08347000"
                    }
                ]
            },
            {
                "id": 4744,
                "name": "Bacău",
                "iso2": "BC",
                "latitude": "46.32581840",
                "longitude": "26.66237800",
                "type": "department",
                "cities": [
                    {
                        "id": 89904,
                        "name": "Agăş",
                        "latitude": "46.48333000",
                        "longitude": "26.21667000"
                    },
                    {
                        "id": 89968,
                        "name": "Apa Asău",
                        "latitude": "46.48747000",
                        "longitude": "26.37888000"
                    },
                    {
                        "id": 89982,
                        "name": "Ardeoani",
                        "latitude": "46.53333000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 89993,
                        "name": "Arini",
                        "latitude": "46.35000000",
                        "longitude": "27.18333000"
                    },
                    {
                        "id": 90002,
                        "name": "Asău",
                        "latitude": "46.43333000",
                        "longitude": "26.40000000"
                    },
                    {
                        "id": 90025,
                        "name": "Bacău",
                        "latitude": "46.56718000",
                        "longitude": "26.91384000"
                    },
                    {
                        "id": 90477,
                        "name": "Băcioiu",
                        "latitude": "46.31431000",
                        "longitude": "27.15745000"
                    },
                    {
                        "id": 90040,
                        "name": "Balcani",
                        "latitude": "46.63333000",
                        "longitude": "26.55000000"
                    },
                    {
                        "id": 90059,
                        "name": "Barați",
                        "latitude": "46.57569000",
                        "longitude": "26.87118000"
                    },
                    {
                        "id": 90457,
                        "name": "Bârsăneşti",
                        "latitude": "46.33333000",
                        "longitude": "26.70000000"
                    },
                    {
                        "id": 90108,
                        "name": "Berești",
                        "latitude": "46.20329000",
                        "longitude": "27.14476000"
                    },
                    {
                        "id": 90104,
                        "name": "Bereşti-Bistriţa",
                        "latitude": "46.71667000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 90106,
                        "name": "Bereşti-Tazlău",
                        "latitude": "46.46667000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 90119,
                        "name": "Berzunţi",
                        "latitude": "46.40000000",
                        "longitude": "26.63333000"
                    },
                    {
                        "id": 90133,
                        "name": "Bijghir",
                        "latitude": "46.60185000",
                        "longitude": "27.01859000"
                    },
                    {
                        "id": 90164,
                        "name": "Blăgeşti",
                        "latitude": "46.68333000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 90193,
                        "name": "Bogdăneşti",
                        "latitude": "46.21667000",
                        "longitude": "26.68333000"
                    },
                    {
                        "id": 90218,
                        "name": "Bolătău",
                        "latitude": "46.63345000",
                        "longitude": "26.40149000"
                    },
                    {
                        "id": 90216,
                        "name": "Bolovăniș",
                        "latitude": "46.61633000",
                        "longitude": "26.05263000"
                    },
                    {
                        "id": 90341,
                        "name": "Brătești",
                        "latitude": "46.32540000",
                        "longitude": "26.64333000"
                    },
                    {
                        "id": 90342,
                        "name": "Brătila",
                        "latitude": "46.32348000",
                        "longitude": "26.77442000"
                    },
                    {
                        "id": 90317,
                        "name": "Brusturoasa",
                        "latitude": "46.51667000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 90355,
                        "name": "Buciumi",
                        "latitude": "46.20230000",
                        "longitude": "26.78445000"
                    },
                    {
                        "id": 90369,
                        "name": "Bucșești",
                        "latitude": "46.48381000",
                        "longitude": "26.58230000"
                    },
                    {
                        "id": 90373,
                        "name": "Buda",
                        "latitude": "46.67111000",
                        "longitude": "26.71953000"
                    },
                    {
                        "id": 90396,
                        "name": "Buhoci",
                        "latitude": "46.56667000",
                        "longitude": "27.01667000"
                    },
                    {
                        "id": 90397,
                        "name": "Buhuşi",
                        "latitude": "46.71667000",
                        "longitude": "26.70000000"
                    },
                    {
                        "id": 93829,
                        "name": "Căiuți",
                        "latitude": "46.18057000",
                        "longitude": "26.92571000"
                    },
                    {
                        "id": 93828,
                        "name": "Căiuţi-Sat",
                        "latitude": "46.18333000",
                        "longitude": "26.93333000"
                    },
                    {
                        "id": 90573,
                        "name": "Caraclău",
                        "latitude": "46.30696000",
                        "longitude": "26.71641000"
                    },
                    {
                        "id": 93815,
                        "name": "Cârligi",
                        "latitude": "46.76583000",
                        "longitude": "26.85053000"
                    },
                    {
                        "id": 90595,
                        "name": "Caşin",
                        "latitude": "46.20000000",
                        "longitude": "26.75000000"
                    },
                    {
                        "id": 90624,
                        "name": "Cerdac",
                        "latitude": "46.23794000",
                        "longitude": "26.51638000"
                    },
                    {
                        "id": 90637,
                        "name": "Cernu",
                        "latitude": "46.46999000",
                        "longitude": "26.58477000"
                    },
                    {
                        "id": 90734,
                        "name": "Cireșoaia",
                        "latitude": "46.24816000",
                        "longitude": "26.54929000"
                    },
                    {
                        "id": 90745,
                        "name": "Ciugheș",
                        "latitude": "46.52220000",
                        "longitude": "26.11970000"
                    },
                    {
                        "id": 90765,
                        "name": "Cleja",
                        "latitude": "46.41667000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 90797,
                        "name": "Coloneşti",
                        "latitude": "46.56667000",
                        "longitude": "27.30000000"
                    },
                    {
                        "id": 93587,
                        "name": "Comăneşti",
                        "latitude": "46.42135000",
                        "longitude": "26.43645000"
                    },
                    {
                        "id": 90834,
                        "name": "Comuna Agăş",
                        "latitude": "46.46458000",
                        "longitude": "26.22962000"
                    },
                    {
                        "id": 90886,
                        "name": "Comuna Ardeoani",
                        "latitude": "46.52183000",
                        "longitude": "26.60165000"
                    },
                    {
                        "id": 90900,
                        "name": "Comuna Asău",
                        "latitude": "46.46495000",
                        "longitude": "26.37497000"
                    },
                    {
                        "id": 90924,
                        "name": "Comuna Balcani",
                        "latitude": "46.64108000",
                        "longitude": "26.54412000"
                    },
                    {
                        "id": 91194,
                        "name": "Comuna Bârsăneşti",
                        "latitude": "46.33290000",
                        "longitude": "26.68192000"
                    },
                    {
                        "id": 90965,
                        "name": "Comuna Bereşti-Bistriţa",
                        "latitude": "46.70870000",
                        "longitude": "26.85648000"
                    },
                    {
                        "id": 90967,
                        "name": "Comuna Bereşti-Tazlău",
                        "latitude": "46.48302000",
                        "longitude": "26.67877000"
                    },
                    {
                        "id": 90977,
                        "name": "Comuna Berzunţi",
                        "latitude": "46.41360000",
                        "longitude": "26.62237000"
                    },
                    {
                        "id": 91006,
                        "name": "Comuna Blăgeşti",
                        "latitude": "46.68668000",
                        "longitude": "26.64835000"
                    },
                    {
                        "id": 91028,
                        "name": "Comuna Bogdăneşti",
                        "latitude": "46.21790000",
                        "longitude": "26.69950000"
                    },
                    {
                        "id": 91108,
                        "name": "Comuna Brusturoasa",
                        "latitude": "46.51898000",
                        "longitude": "26.19352000"
                    },
                    {
                        "id": 91132,
                        "name": "Comuna Buciumi",
                        "latitude": "46.21353000",
                        "longitude": "26.78584000"
                    },
                    {
                        "id": 91154,
                        "name": "Comuna Buhoci",
                        "latitude": "46.56581000",
                        "longitude": "27.00824000"
                    },
                    {
                        "id": 91569,
                        "name": "Comuna Căiuţi",
                        "latitude": "46.17987000",
                        "longitude": "26.91633000"
                    },
                    {
                        "id": 91379,
                        "name": "Comuna Cleja",
                        "latitude": "46.40183000",
                        "longitude": "26.92104000"
                    },
                    {
                        "id": 91400,
                        "name": "Comuna Coloneşti",
                        "latitude": "46.60471000",
                        "longitude": "27.26584000"
                    },
                    {
                        "id": 91422,
                        "name": "Comuna Corbasca",
                        "latitude": "46.29728000",
                        "longitude": "27.13675000"
                    },
                    {
                        "id": 91482,
                        "name": "Comuna Coţofăneşti",
                        "latitude": "46.14808000",
                        "longitude": "26.98644000"
                    },
                    {
                        "id": 91734,
                        "name": "Comuna Dămieneşti",
                        "latitude": "46.74310000",
                        "longitude": "27.00649000"
                    },
                    {
                        "id": 91608,
                        "name": "Comuna Dealu Morii",
                        "latitude": "46.30877000",
                        "longitude": "27.29511000"
                    },
                    {
                        "id": 91651,
                        "name": "Comuna Dofteana",
                        "latitude": "46.32282000",
                        "longitude": "26.53081000"
                    },
                    {
                        "id": 91753,
                        "name": "Comuna Faraoani",
                        "latitude": "46.43375000",
                        "longitude": "26.89835000"
                    },
                    {
                        "id": 91762,
                        "name": "Comuna Filipeni",
                        "latitude": "46.53357000",
                        "longitude": "27.19114000"
                    },
                    {
                        "id": 91763,
                        "name": "Comuna Filipeşti",
                        "latitude": "46.76821000",
                        "longitude": "26.89338000"
                    },
                    {
                        "id": 91979,
                        "name": "Comuna Găiceana",
                        "latitude": "46.35060000",
                        "longitude": "27.22154000"
                    },
                    {
                        "id": 91974,
                        "name": "Comuna Gârleni",
                        "latitude": "46.66251000",
                        "longitude": "26.78819000"
                    },
                    {
                        "id": 91855,
                        "name": "Comuna Ghimeş-Făget",
                        "latitude": "46.60483000",
                        "longitude": "26.05354000"
                    },
                    {
                        "id": 91869,
                        "name": "Comuna Gioseni",
                        "latitude": "46.42925000",
                        "longitude": "26.99239000"
                    },
                    {
                        "id": 91886,
                        "name": "Comuna Glăvăneşti",
                        "latitude": "46.26329000",
                        "longitude": "27.38778000"
                    },
                    {
                        "id": 91955,
                        "name": "Comuna Gura Văii",
                        "latitude": "46.27305000",
                        "longitude": "26.82312000"
                    },
                    {
                        "id": 91994,
                        "name": "Comuna Helegiu",
                        "latitude": "46.34967000",
                        "longitude": "26.76690000"
                    },
                    {
                        "id": 91996,
                        "name": "Comuna Hemeiuşi",
                        "latitude": "46.61927000",
                        "longitude": "26.85729000"
                    },
                    {
                        "id": 92016,
                        "name": "Comuna Horgeşti",
                        "latitude": "46.39837000",
                        "longitude": "27.05603000"
                    },
                    {
                        "id": 92029,
                        "name": "Comuna Huruieşti",
                        "latitude": "46.25297000",
                        "longitude": "27.23828000"
                    },
                    {
                        "id": 92097,
                        "name": "Comuna Iteşti",
                        "latitude": "46.67368000",
                        "longitude": "26.85555000"
                    },
                    {
                        "id": 92110,
                        "name": "Comuna Izvoru Berheciului",
                        "latitude": "46.57693000",
                        "longitude": "27.22842000"
                    },
                    {
                        "id": 92158,
                        "name": "Comuna Letea Veche",
                        "latitude": "46.54236000",
                        "longitude": "26.96869000"
                    },
                    {
                        "id": 92167,
                        "name": "Comuna Lipova",
                        "latitude": "46.72016000",
                        "longitude": "27.23238000"
                    },
                    {
                        "id": 92175,
                        "name": "Comuna Livezi",
                        "latitude": "46.39932000",
                        "longitude": "26.72438000"
                    },
                    {
                        "id": 92195,
                        "name": "Comuna Luizi-Cãlugãra",
                        "latitude": "46.53604000",
                        "longitude": "26.84012000"
                    },
                    {
                        "id": 92387,
                        "name": "Comuna Măgireşti",
                        "latitude": "46.50965000",
                        "longitude": "26.53727000"
                    },
                    {
                        "id": 92388,
                        "name": "Comuna Măgura",
                        "latitude": "46.56065000",
                        "longitude": "26.83900000"
                    },
                    {
                        "id": 92369,
                        "name": "Comuna Mânăstirea Caşin",
                        "latitude": "46.19394000",
                        "longitude": "26.72923000"
                    },
                    {
                        "id": 92408,
                        "name": "Comuna Mărgineni",
                        "latitude": "46.59779000",
                        "longitude": "26.80505000"
                    },
                    {
                        "id": 92336,
                        "name": "Comuna Motoşeni",
                        "latitude": "46.32779000",
                        "longitude": "27.41721000"
                    },
                    {
                        "id": 92433,
                        "name": "Comuna Negri",
                        "latitude": "46.70500000",
                        "longitude": "26.97216000"
                    },
                    {
                        "id": 92442,
                        "name": "Comuna Nicolae Bălcescu",
                        "latitude": "46.46687000",
                        "longitude": "26.88837000"
                    },
                    {
                        "id": 92482,
                        "name": "Comuna Odobeşti",
                        "latitude": "46.66902000",
                        "longitude": "27.13224000"
                    },
                    {
                        "id": 92490,
                        "name": "Comuna Oituz",
                        "latitude": "46.19045000",
                        "longitude": "26.56043000"
                    },
                    {
                        "id": 92500,
                        "name": "Comuna Onceşti",
                        "latitude": "46.47537000",
                        "longitude": "27.25835000"
                    },
                    {
                        "id": 92507,
                        "name": "Comuna Orbeni",
                        "latitude": "46.26934000",
                        "longitude": "27.01872000"
                    },
                    {
                        "id": 92530,
                        "name": "Comuna Palanca",
                        "latitude": "46.50647000",
                        "longitude": "26.11239000"
                    },
                    {
                        "id": 92719,
                        "name": "Comuna Pănceşti",
                        "latitude": "46.36459000",
                        "longitude": "27.11377000"
                    },
                    {
                        "id": 92536,
                        "name": "Comuna Parava",
                        "latitude": "46.30993000",
                        "longitude": "26.96787000"
                    },
                    {
                        "id": 92705,
                        "name": "Comuna Pârgăreşti",
                        "latitude": "46.24414000",
                        "longitude": "26.65017000"
                    },
                    {
                        "id": 92539,
                        "name": "Comuna Parincea",
                        "latitude": "46.47841000",
                        "longitude": "27.12877000"
                    },
                    {
                        "id": 92706,
                        "name": "Comuna Pârjol",
                        "latitude": "46.59014000",
                        "longitude": "26.60903000"
                    },
                    {
                        "id": 92596,
                        "name": "Comuna Plopana",
                        "latitude": "46.66549000",
                        "longitude": "27.24403000"
                    },
                    {
                        "id": 92616,
                        "name": "Comuna Podu Turcului",
                        "latitude": "46.19703000",
                        "longitude": "27.38796000"
                    },
                    {
                        "id": 92617,
                        "name": "Comuna Poduri",
                        "latitude": "46.47888000",
                        "longitude": "26.56593000"
                    },
                    {
                        "id": 92689,
                        "name": "Comuna Prăjeşti",
                        "latitude": "46.65469000",
                        "longitude": "26.97631000"
                    },
                    {
                        "id": 92840,
                        "name": "Comuna Răcăciuni",
                        "latitude": "46.35011000",
                        "longitude": "26.96705000"
                    },
                    {
                        "id": 92835,
                        "name": "Comuna Răchitoasa",
                        "latitude": "46.44772000",
                        "longitude": "27.36875000"
                    },
                    {
                        "id": 92733,
                        "name": "Comuna Racova",
                        "latitude": "46.69790000",
                        "longitude": "26.78097000"
                    },
                    {
                        "id": 92805,
                        "name": "Comuna Roşiori",
                        "latitude": "46.72620000",
                        "longitude": "27.10446000"
                    },
                    {
                        "id": 93102,
                        "name": "Comuna Sănduleni",
                        "latitude": "46.45082000",
                        "longitude": "26.74185000"
                    },
                    {
                        "id": 93106,
                        "name": "Comuna Sărata",
                        "latitude": "46.49582000",
                        "longitude": "26.86916000"
                    },
                    {
                        "id": 92878,
                        "name": "Comuna Sascut",
                        "latitude": "46.19288000",
                        "longitude": "27.09163000"
                    },
                    {
                        "id": 93114,
                        "name": "Comuna Săuceşti",
                        "latitude": "46.65781000",
                        "longitude": "26.93368000"
                    },
                    {
                        "id": 92894,
                        "name": "Comuna Scorţeni",
                        "latitude": "46.58037000",
                        "longitude": "26.68543000"
                    },
                    {
                        "id": 92913,
                        "name": "Comuna Secuieni",
                        "latitude": "46.65329000",
                        "longitude": "27.09674000"
                    },
                    {
                        "id": 92974,
                        "name": "Comuna Solonţ",
                        "latitude": "46.56929000",
                        "longitude": "26.53863000"
                    },
                    {
                        "id": 93020,
                        "name": "Comuna Stănişeşti",
                        "latitude": "46.42760000",
                        "longitude": "27.31055000"
                    },
                    {
                        "id": 93546,
                        "name": "Comuna Ştefan Cel Mare",
                        "latitude": "46.20645000",
                        "longitude": "26.85488000"
                    },
                    {
                        "id": 93006,
                        "name": "Comuna Strugari",
                        "latitude": "46.52715000",
                        "longitude": "26.73578000"
                    },
                    {
                        "id": 93122,
                        "name": "Comuna Tamaşi",
                        "latitude": "46.48841000",
                        "longitude": "26.99549000"
                    },
                    {
                        "id": 93224,
                        "name": "Comuna Târgu Trotuş",
                        "latitude": "46.26789000",
                        "longitude": "26.67587000"
                    },
                    {
                        "id": 93247,
                        "name": "Comuna Tătărăşti",
                        "latitude": "46.22823000",
                        "longitude": "27.19631000"
                    },
                    {
                        "id": 93187,
                        "name": "Comuna Traian",
                        "latitude": "46.64706000",
                        "longitude": "27.03533000"
                    },
                    {
                        "id": 93272,
                        "name": "Comuna Ungureni",
                        "latitude": "46.54522000",
                        "longitude": "27.10680000"
                    },
                    {
                        "id": 93282,
                        "name": "Comuna Urecheşti",
                        "latitude": "46.12425000",
                        "longitude": "27.07070000"
                    },
                    {
                        "id": 93322,
                        "name": "Comuna Valea Seacă",
                        "latitude": "46.24851000",
                        "longitude": "27.04535000"
                    },
                    {
                        "id": 93417,
                        "name": "Comuna Vultureni",
                        "latitude": "46.41385000",
                        "longitude": "27.23668000"
                    },
                    {
                        "id": 93473,
                        "name": "Comuna Zemeş",
                        "latitude": "46.59171000",
                        "longitude": "26.43381000"
                    },
                    {
                        "id": 93611,
                        "name": "Corbasca",
                        "latitude": "46.28333000",
                        "longitude": "27.16667000"
                    },
                    {
                        "id": 93695,
                        "name": "Coţofăneşti",
                        "latitude": "46.15000000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 93678,
                        "name": "Cotumba",
                        "latitude": "46.49743000",
                        "longitude": "26.19112000"
                    },
                    {
                        "id": 93760,
                        "name": "Cucuieți",
                        "latitude": "46.32731000",
                        "longitude": "26.55504000"
                    },
                    {
                        "id": 94119,
                        "name": "Dămieneşti",
                        "latitude": "46.73333000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 94120,
                        "name": "Dămoc",
                        "latitude": "46.46667000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 94131,
                        "name": "Dărmăneşti",
                        "latitude": "46.36667000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 93905,
                        "name": "Dealu Morii",
                        "latitude": "46.31667000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 93916,
                        "name": "Deleni",
                        "latitude": "46.35360000",
                        "longitude": "26.77628000"
                    },
                    {
                        "id": 93979,
                        "name": "Dofteana",
                        "latitude": "46.31667000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 94014,
                        "name": "Dragomir",
                        "latitude": "46.41373000",
                        "longitude": "26.63163000"
                    },
                    {
                        "id": 94047,
                        "name": "Drăgugești",
                        "latitude": "46.36796000",
                        "longitude": "26.77433000"
                    },
                    {
                        "id": 94079,
                        "name": "Dumbrava",
                        "latitude": "46.30969000",
                        "longitude": "26.89087000"
                    },
                    {
                        "id": 94252,
                        "name": "Făget",
                        "latitude": "46.58891000",
                        "longitude": "26.05349000"
                    },
                    {
                        "id": 94150,
                        "name": "Faraoaní",
                        "latitude": "46.43333000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 94158,
                        "name": "Ferestrău-Oituz",
                        "latitude": "46.20249000",
                        "longitude": "26.57629000"
                    },
                    {
                        "id": 94174,
                        "name": "Filipeni",
                        "latitude": "46.53333000",
                        "longitude": "27.18333000"
                    },
                    {
                        "id": 94175,
                        "name": "Filipeşti",
                        "latitude": "46.75000000",
                        "longitude": "26.88333000"
                    },
                    {
                        "id": 94208,
                        "name": "Frumoasa",
                        "latitude": "46.66298000",
                        "longitude": "26.54196000"
                    },
                    {
                        "id": 94213,
                        "name": "Frumușelu",
                        "latitude": "46.27796000",
                        "longitude": "27.35203000"
                    },
                    {
                        "id": 94230,
                        "name": "Fundu Răcăciuni",
                        "latitude": "46.35864000",
                        "longitude": "26.88987000"
                    },
                    {
                        "id": 94500,
                        "name": "Găiceana",
                        "latitude": "46.33333000",
                        "longitude": "27.21667000"
                    },
                    {
                        "id": 94274,
                        "name": "Galbeni",
                        "latitude": "46.45661000",
                        "longitude": "26.94664000"
                    },
                    {
                        "id": 94492,
                        "name": "Gârleni",
                        "latitude": "46.66667000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 94493,
                        "name": "Gârlenii de Sus",
                        "latitude": "46.65414000",
                        "longitude": "26.79491000"
                    },
                    {
                        "id": 94517,
                        "name": "Găzărie",
                        "latitude": "46.48928000",
                        "longitude": "26.51877000"
                    },
                    {
                        "id": 94300,
                        "name": "Gheorghe Doja",
                        "latitude": "46.37831000",
                        "longitude": "26.96248000"
                    },
                    {
                        "id": 94323,
                        "name": "Ghimeș",
                        "latitude": "46.56821000",
                        "longitude": "26.08886000"
                    },
                    {
                        "id": 94322,
                        "name": "Ghimeş-Făget",
                        "latitude": "46.58333000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 94345,
                        "name": "Gioseni",
                        "latitude": "46.42925000",
                        "longitude": "26.99239000"
                    },
                    {
                        "id": 94366,
                        "name": "Glăvăneşti",
                        "latitude": "46.25000000",
                        "longitude": "27.38333000"
                    },
                    {
                        "id": 94465,
                        "name": "Gura Văii",
                        "latitude": "46.27234000",
                        "longitude": "26.82604000"
                    },
                    {
                        "id": 94596,
                        "name": "Hăghiac",
                        "latitude": "46.31200000",
                        "longitude": "26.51841000"
                    },
                    {
                        "id": 94527,
                        "name": "Helegiu",
                        "latitude": "46.35000000",
                        "longitude": "26.75000000"
                    },
                    {
                        "id": 94529,
                        "name": "Hemeiuș",
                        "latitude": "46.62643000",
                        "longitude": "26.85440000"
                    },
                    {
                        "id": 94551,
                        "name": "Holt",
                        "latitude": "46.57856000",
                        "longitude": "26.97499000"
                    },
                    {
                        "id": 94559,
                        "name": "Horgeşti",
                        "latitude": "46.43333000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 94583,
                        "name": "Huruiești",
                        "latitude": "46.26667000",
                        "longitude": "27.25000000"
                    },
                    {
                        "id": 94694,
                        "name": "Iteşti",
                        "latitude": "46.65309000",
                        "longitude": "26.87256000"
                    },
                    {
                        "id": 94716,
                        "name": "Izvoru Berheciului",
                        "latitude": "46.58333000",
                        "longitude": "27.21667000"
                    },
                    {
                        "id": 94894,
                        "name": "Lăpoș",
                        "latitude": "46.39363000",
                        "longitude": "26.46245000"
                    },
                    {
                        "id": 94761,
                        "name": "Larga",
                        "latitude": "46.35060000",
                        "longitude": "26.53321000"
                    },
                    {
                        "id": 94784,
                        "name": "Lespezi",
                        "latitude": "46.66493000",
                        "longitude": "26.76882000"
                    },
                    {
                        "id": 94788,
                        "name": "Letea Veche",
                        "latitude": "46.55000000",
                        "longitude": "26.95000000"
                    },
                    {
                        "id": 94796,
                        "name": "Lilieci",
                        "latitude": "46.62861000",
                        "longitude": "26.87176000"
                    },
                    {
                        "id": 94803,
                        "name": "Lipova",
                        "latitude": "46.71667000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 94820,
                        "name": "Livezi",
                        "latitude": "46.40639000",
                        "longitude": "26.73613000"
                    },
                    {
                        "id": 94821,
                        "name": "Livezi-Vale",
                        "latitude": "46.41667000",
                        "longitude": "26.73333000"
                    },
                    {
                        "id": 94841,
                        "name": "Ludași",
                        "latitude": "46.61962000",
                        "longitude": "26.57926000"
                    },
                    {
                        "id": 94848,
                        "name": "Luizi-Călugăra",
                        "latitude": "46.53333000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 95238,
                        "name": "Măgireşti",
                        "latitude": "46.51667000",
                        "longitude": "26.55000000"
                    },
                    {
                        "id": 95241,
                        "name": "Măgura",
                        "latitude": "46.56667000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 95218,
                        "name": "Mânăstirea Caşin",
                        "latitude": "46.15000000",
                        "longitude": "26.68333000"
                    },
                    {
                        "id": 95269,
                        "name": "Mărgineni",
                        "latitude": "46.58760000",
                        "longitude": "26.85095000"
                    },
                    {
                        "id": 95271,
                        "name": "Mărgineni-Munteni",
                        "latitude": "46.60000000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 95058,
                        "name": "Moineşti",
                        "latitude": "46.47523000",
                        "longitude": "26.48907000"
                    },
                    {
                        "id": 95077,
                        "name": "Motoşeni",
                        "latitude": "46.33333000",
                        "longitude": "27.38333000"
                    },
                    {
                        "id": 95110,
                        "name": "Municipiul Bacãu",
                        "latitude": "46.56854000",
                        "longitude": "26.91135000"
                    },
                    {
                        "id": 95157,
                        "name": "Municipiul Moineşti",
                        "latitude": "46.47428000",
                        "longitude": "26.48804000"
                    },
                    {
                        "id": 95162,
                        "name": "Municipiul Oneşti",
                        "latitude": "46.25000000",
                        "longitude": "26.75000000"
                    },
                    {
                        "id": 95319,
                        "name": "Negri",
                        "latitude": "46.70000000",
                        "longitude": "26.96667000"
                    },
                    {
                        "id": 95338,
                        "name": "Nicolae Bălcescu",
                        "latitude": "46.46667000",
                        "longitude": "26.91667000"
                    },
                    {
                        "id": 95408,
                        "name": "Odobești",
                        "latitude": "46.67608000",
                        "longitude": "27.14983000"
                    },
                    {
                        "id": 95420,
                        "name": "Oituz",
                        "latitude": "46.20000000",
                        "longitude": "26.61667000"
                    },
                    {
                        "id": 95436,
                        "name": "Onceşti",
                        "latitude": "46.46667000",
                        "longitude": "27.25000000"
                    },
                    {
                        "id": 95439,
                        "name": "Onesti",
                        "latitude": "46.25000000",
                        "longitude": "26.75000000"
                    },
                    {
                        "id": 95476,
                        "name": "Oraş Buhuşi",
                        "latitude": "46.71845000",
                        "longitude": "26.69952000"
                    },
                    {
                        "id": 95496,
                        "name": "Oraş Comãneşti",
                        "latitude": "46.42348000",
                        "longitude": "26.42796000"
                    },
                    {
                        "id": 95513,
                        "name": "Oraş Dãrmãneşti",
                        "latitude": "46.37559000",
                        "longitude": "26.47673000"
                    },
                    {
                        "id": 95591,
                        "name": "Oraş Slãnic-Moldova",
                        "latitude": "46.22320000",
                        "longitude": "26.47774000"
                    },
                    {
                        "id": 95609,
                        "name": "Oraş Târgu Ocna",
                        "latitude": "46.27988000",
                        "longitude": "26.61129000"
                    },
                    {
                        "id": 95667,
                        "name": "Orășa",
                        "latitude": "46.42225000",
                        "longitude": "26.74370000"
                    },
                    {
                        "id": 95655,
                        "name": "Orbeni",
                        "latitude": "46.28333000",
                        "longitude": "27.01667000"
                    },
                    {
                        "id": 95671,
                        "name": "Osebiți",
                        "latitude": "46.53839000",
                        "longitude": "26.83946000"
                    },
                    {
                        "id": 95697,
                        "name": "Palanca",
                        "latitude": "46.53333000",
                        "longitude": "26.11667000"
                    },
                    {
                        "id": 96016,
                        "name": "Pănceşti",
                        "latitude": "46.33333000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 95710,
                        "name": "Parava",
                        "latitude": "46.30000000",
                        "longitude": "27.00000000"
                    },
                    {
                        "id": 95999,
                        "name": "Pârgăreşti",
                        "latitude": "46.25000000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 95714,
                        "name": "Parincea",
                        "latitude": "46.48333000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 96000,
                        "name": "Pârjol",
                        "latitude": "46.58333000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 95816,
                        "name": "Plopana",
                        "latitude": "46.68333000",
                        "longitude": "27.21667000"
                    },
                    {
                        "id": 95824,
                        "name": "Plopu",
                        "latitude": "46.39256000",
                        "longitude": "26.50268000"
                    },
                    {
                        "id": 95851,
                        "name": "Podu Turcului",
                        "latitude": "46.20000000",
                        "longitude": "27.38333000"
                    },
                    {
                        "id": 95852,
                        "name": "Poduri",
                        "latitude": "46.46667000",
                        "longitude": "26.53333000"
                    },
                    {
                        "id": 95866,
                        "name": "Poiana",
                        "latitude": "46.69819000",
                        "longitude": "27.01765000"
                    },
                    {
                        "id": 95971,
                        "name": "Prăjești",
                        "latitude": "46.65469000",
                        "longitude": "26.97631000"
                    },
                    {
                        "id": 95961,
                        "name": "Prohozești",
                        "latitude": "46.48155000",
                        "longitude": "26.55170000"
                    },
                    {
                        "id": 95987,
                        "name": "Pustiana",
                        "latitude": "46.58990000",
                        "longitude": "26.63083000"
                    },
                    {
                        "id": 96190,
                        "name": "Răcăciuni",
                        "latitude": "46.33333000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 96191,
                        "name": "Răcăuți",
                        "latitude": "46.22476000",
                        "longitude": "26.78723000"
                    },
                    {
                        "id": 96186,
                        "name": "Răchitoasa",
                        "latitude": "46.43333000",
                        "longitude": "27.36667000"
                    },
                    {
                        "id": 96040,
                        "name": "Racova",
                        "latitude": "46.70000000",
                        "longitude": "26.75000000"
                    },
                    {
                        "id": 96133,
                        "name": "Roşiori",
                        "latitude": "46.71667000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 106025,
                        "name": "Sănduleni",
                        "latitude": "46.45000000",
                        "longitude": "26.73333000"
                    },
                    {
                        "id": 106030,
                        "name": "Sărata",
                        "latitude": "46.50249000",
                        "longitude": "26.86857000"
                    },
                    {
                        "id": 96249,
                        "name": "Sascut",
                        "latitude": "46.20000000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 96250,
                        "name": "Sascut-Sat",
                        "latitude": "46.18727000",
                        "longitude": "27.06851000"
                    },
                    {
                        "id": 96257,
                        "name": "Satu Nou",
                        "latitude": "46.24447000",
                        "longitude": "26.65343000"
                    },
                    {
                        "id": 106043,
                        "name": "Săucești",
                        "latitude": "46.61853000",
                        "longitude": "26.94141000"
                    },
                    {
                        "id": 96272,
                        "name": "Schitu Frumoasa",
                        "latitude": "46.63541000",
                        "longitude": "26.48761000"
                    },
                    {
                        "id": 96281,
                        "name": "Scorţeni",
                        "latitude": "46.55000000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 96287,
                        "name": "Scurta",
                        "latitude": "46.26133000",
                        "longitude": "27.01548000"
                    },
                    {
                        "id": 96316,
                        "name": "Secuieni",
                        "latitude": "46.65000000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 96383,
                        "name": "Slănic-Moldova",
                        "latitude": "46.22308000",
                        "longitude": "26.47413000"
                    },
                    {
                        "id": 96372,
                        "name": "Slobozia",
                        "latitude": "46.47495000",
                        "longitude": "27.31111000"
                    },
                    {
                        "id": 96407,
                        "name": "Solonţ",
                        "latitude": "46.55000000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 96410,
                        "name": "Somușca",
                        "latitude": "46.40147000",
                        "longitude": "26.91189000"
                    },
                    {
                        "id": 96481,
                        "name": "Stănişeşti",
                        "latitude": "46.43333000",
                        "longitude": "27.30000000"
                    },
                    {
                        "id": 97077,
                        "name": "Ştefan Cel Mare",
                        "latitude": "46.20526000",
                        "longitude": "26.85488000"
                    },
                    {
                        "id": 97131,
                        "name": "Ștefan Vodă",
                        "latitude": "46.31692000",
                        "longitude": "26.51250000"
                    },
                    {
                        "id": 96448,
                        "name": "Straja",
                        "latitude": "46.43989000",
                        "longitude": "26.36258000"
                    },
                    {
                        "id": 96458,
                        "name": "Strugari",
                        "latitude": "46.53333000",
                        "longitude": "26.71667000"
                    },
                    {
                        "id": 106055,
                        "name": "Tamaşi",
                        "latitude": "46.48333000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 96587,
                        "name": "Târgu Ocna",
                        "latitude": "46.27899000",
                        "longitude": "26.61301000"
                    },
                    {
                        "id": 96589,
                        "name": "Târgu Trotuş",
                        "latitude": "46.26667000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 96622,
                        "name": "Tătărăști",
                        "latitude": "46.21667000",
                        "longitude": "27.20000000"
                    },
                    {
                        "id": 106149,
                        "name": "Traian",
                        "latitude": "46.63333000",
                        "longitude": "27.03333000"
                    },
                    {
                        "id": 96563,
                        "name": "Turluianu",
                        "latitude": "46.45298000",
                        "longitude": "26.64607000"
                    },
                    {
                        "id": 96570,
                        "name": "Tuta",
                        "latitude": "46.25643000",
                        "longitude": "26.69103000"
                    },
                    {
                        "id": 96661,
                        "name": "Ungureni",
                        "latitude": "46.52283000",
                        "longitude": "27.11186000"
                    },
                    {
                        "id": 96676,
                        "name": "Urecheşti",
                        "latitude": "46.13333000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 96920,
                        "name": "Vâlcele",
                        "latitude": "46.29801000",
                        "longitude": "26.60005000"
                    },
                    {
                        "id": 96710,
                        "name": "Valea Arinilor",
                        "latitude": "46.49793000",
                        "longitude": "26.50918000"
                    },
                    {
                        "id": 96766,
                        "name": "Valea lui Ion",
                        "latitude": "46.70350000",
                        "longitude": "26.62499000"
                    },
                    {
                        "id": 96754,
                        "name": "Valea Seacă",
                        "latitude": "46.24281000",
                        "longitude": "27.04594000"
                    },
                    {
                        "id": 96768,
                        "name": "Valea Șoșii",
                        "latitude": "46.46180000",
                        "longitude": "26.54992000"
                    },
                    {
                        "id": 96790,
                        "name": "Vermești",
                        "latitude": "46.42172000",
                        "longitude": "26.47660000"
                    },
                    {
                        "id": 96793,
                        "name": "Verșești",
                        "latitude": "46.44904000",
                        "longitude": "26.70183000"
                    },
                    {
                        "id": 96824,
                        "name": "Viișoara",
                        "latitude": "46.28325000",
                        "longitude": "26.66187000"
                    },
                    {
                        "id": 96908,
                        "name": "Vultureni",
                        "latitude": "46.36667000",
                        "longitude": "27.28333000"
                    },
                    {
                        "id": 96987,
                        "name": "Zemeş",
                        "latitude": "46.58333000",
                        "longitude": "26.41667000"
                    }
                ]
            },
            {
                "id": 4723,
                "name": "Bihor",
                "iso2": "BH",
                "latitude": "47.01575160",
                "longitude": "22.17226600",
                "type": "department",
                "cities": [
                    {
                        "id": 89873,
                        "name": "Abram",
                        "latitude": "47.31667000",
                        "longitude": "22.38333000"
                    },
                    {
                        "id": 89876,
                        "name": "Abrămuţ",
                        "latitude": "47.31667000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 89922,
                        "name": "Albiș",
                        "latitude": "47.39024000",
                        "longitude": "22.24528000"
                    },
                    {
                        "id": 89930,
                        "name": "Aleşd",
                        "latitude": "47.06667000",
                        "longitude": "22.41667000"
                    },
                    {
                        "id": 89939,
                        "name": "Alparea",
                        "latitude": "47.03054000",
                        "longitude": "22.04812000"
                    },
                    {
                        "id": 90015,
                        "name": "Aştileu",
                        "latitude": "47.03333000",
                        "longitude": "22.38333000"
                    },
                    {
                        "id": 90005,
                        "name": "Auşeu",
                        "latitude": "47.03333000",
                        "longitude": "22.50000000"
                    },
                    {
                        "id": 90007,
                        "name": "Avram Iancu",
                        "latitude": "46.66944000",
                        "longitude": "21.52417000"
                    },
                    {
                        "id": 90039,
                        "name": "Balc",
                        "latitude": "47.28333000",
                        "longitude": "22.53333000"
                    },
                    {
                        "id": 90513,
                        "name": "Bălnaca",
                        "latitude": "46.94384000",
                        "longitude": "22.57206000"
                    },
                    {
                        "id": 90071,
                        "name": "Batăr",
                        "latitude": "46.70000000",
                        "longitude": "21.81667000"
                    },
                    {
                        "id": 90083,
                        "name": "Beiuş",
                        "latitude": "46.66667000",
                        "longitude": "22.35000000"
                    },
                    {
                        "id": 90123,
                        "name": "Beznea",
                        "latitude": "46.95967000",
                        "longitude": "22.61954000"
                    },
                    {
                        "id": 90131,
                        "name": "Biharia",
                        "latitude": "47.15000000",
                        "longitude": "21.91667000"
                    },
                    {
                        "id": 90145,
                        "name": "Bistra",
                        "latitude": "47.25478000",
                        "longitude": "22.42295000"
                    },
                    {
                        "id": 90196,
                        "name": "Bogei",
                        "latitude": "47.26550000",
                        "longitude": "22.36079000"
                    },
                    {
                        "id": 90203,
                        "name": "Boianu Mare",
                        "latitude": "47.38333000",
                        "longitude": "22.53333000"
                    },
                    {
                        "id": 90231,
                        "name": "Borod",
                        "latitude": "46.98333000",
                        "longitude": "22.63333000"
                    },
                    {
                        "id": 90237,
                        "name": "Borş",
                        "latitude": "47.11667000",
                        "longitude": "21.81667000"
                    },
                    {
                        "id": 90274,
                        "name": "Bratca",
                        "latitude": "46.93333000",
                        "longitude": "22.61667000"
                    },
                    {
                        "id": 90316,
                        "name": "Brusturi",
                        "latitude": "47.15000000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 90387,
                        "name": "Budureasa",
                        "latitude": "46.66667000",
                        "longitude": "22.50000000"
                    },
                    {
                        "id": 90388,
                        "name": "Buduslău",
                        "latitude": "47.40000000",
                        "longitude": "22.26667000"
                    },
                    {
                        "id": 90404,
                        "name": "Bulz",
                        "latitude": "46.91667000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 90414,
                        "name": "Bunteşti",
                        "latitude": "46.61667000",
                        "longitude": "22.46667000"
                    },
                    {
                        "id": 90423,
                        "name": "Burzuc",
                        "latitude": "47.15552000",
                        "longitude": "22.17096000"
                    },
                    {
                        "id": 93823,
                        "name": "Căbeşti",
                        "latitude": "46.76667000",
                        "longitude": "22.36667000"
                    },
                    {
                        "id": 90560,
                        "name": "Cadea",
                        "latitude": "47.31185000",
                        "longitude": "22.06225000"
                    },
                    {
                        "id": 93830,
                        "name": "Călacea",
                        "latitude": "46.67687000",
                        "longitude": "21.93292000"
                    },
                    {
                        "id": 93794,
                        "name": "Câmpani",
                        "latitude": "46.51415000",
                        "longitude": "22.52186000"
                    },
                    {
                        "id": 93795,
                        "name": "Câmpani de Pomezeu",
                        "latitude": "46.80000000",
                        "longitude": "22.31667000"
                    },
                    {
                        "id": 93862,
                        "name": "Căpâlna",
                        "latitude": "46.73333000",
                        "longitude": "22.10000000"
                    },
                    {
                        "id": 93869,
                        "name": "Cărpinet",
                        "latitude": "46.45000000",
                        "longitude": "22.48333000"
                    },
                    {
                        "id": 90606,
                        "name": "Cefa",
                        "latitude": "46.91667000",
                        "longitude": "21.73333000"
                    },
                    {
                        "id": 90611,
                        "name": "Ceica",
                        "latitude": "46.85000000",
                        "longitude": "22.18333000"
                    },
                    {
                        "id": 90646,
                        "name": "Cetariu",
                        "latitude": "47.13333000",
                        "longitude": "22.01667000"
                    },
                    {
                        "id": 90656,
                        "name": "Cherechiu",
                        "latitude": "47.38333000",
                        "longitude": "22.13333000"
                    },
                    {
                        "id": 90660,
                        "name": "Cheșereu",
                        "latitude": "47.42779000",
                        "longitude": "22.11416000"
                    },
                    {
                        "id": 90661,
                        "name": "Cheț",
                        "latitude": "47.41943000",
                        "longitude": "22.33877000"
                    },
                    {
                        "id": 90688,
                        "name": "Chişlaz",
                        "latitude": "47.28333000",
                        "longitude": "22.23333000"
                    },
                    {
                        "id": 90751,
                        "name": "Ciumeghiu",
                        "latitude": "46.73333000",
                        "longitude": "21.58333000"
                    },
                    {
                        "id": 90760,
                        "name": "Ciutelec",
                        "latitude": "47.26200000",
                        "longitude": "22.38690000"
                    },
                    {
                        "id": 90778,
                        "name": "Cociuba Mare",
                        "latitude": "46.73333000",
                        "longitude": "22.00000000"
                    },
                    {
                        "id": 90818,
                        "name": "Comuna Abram",
                        "latitude": "47.32443000",
                        "longitude": "22.42023000"
                    },
                    {
                        "id": 90819,
                        "name": "Comuna Abrămuţ",
                        "latitude": "47.33346000",
                        "longitude": "22.25607000"
                    },
                    {
                        "id": 90911,
                        "name": "Comuna Aştileu",
                        "latitude": "47.02217000",
                        "longitude": "22.38444000"
                    },
                    {
                        "id": 90903,
                        "name": "Comuna Auşeu",
                        "latitude": "47.04398000",
                        "longitude": "22.50835000"
                    },
                    {
                        "id": 90904,
                        "name": "Comuna Avram Iancu",
                        "latitude": "46.66944000",
                        "longitude": "21.52417000"
                    },
                    {
                        "id": 90923,
                        "name": "Comuna Balc",
                        "latitude": "47.31135000",
                        "longitude": "22.49954000"
                    },
                    {
                        "id": 90940,
                        "name": "Comuna Batăr",
                        "latitude": "46.71431000",
                        "longitude": "21.79161000"
                    },
                    {
                        "id": 90986,
                        "name": "Comuna Biharia",
                        "latitude": "47.16001000",
                        "longitude": "21.93299000"
                    },
                    {
                        "id": 91033,
                        "name": "Comuna Boianu Mare",
                        "latitude": "47.37481000",
                        "longitude": "22.52507000"
                    },
                    {
                        "id": 91052,
                        "name": "Comuna Borod",
                        "latitude": "47.00503000",
                        "longitude": "22.60907000"
                    },
                    {
                        "id": 91056,
                        "name": "Comuna Borş",
                        "latitude": "47.13073000",
                        "longitude": "21.83139000"
                    },
                    {
                        "id": 91082,
                        "name": "Comuna Bratca",
                        "latitude": "46.91794000",
                        "longitude": "22.61825000"
                    },
                    {
                        "id": 91106,
                        "name": "Comuna Brusturi",
                        "latitude": "47.14410000",
                        "longitude": "22.26514000"
                    },
                    {
                        "id": 91149,
                        "name": "Comuna Budureasa",
                        "latitude": "46.66968000",
                        "longitude": "22.46418000"
                    },
                    {
                        "id": 91150,
                        "name": "Comuna Buduslău",
                        "latitude": "47.39559000",
                        "longitude": "22.25387000"
                    },
                    {
                        "id": 91159,
                        "name": "Comuna Bulz",
                        "latitude": "46.85280000",
                        "longitude": "22.66659000"
                    },
                    {
                        "id": 91168,
                        "name": "Comuna Bunteşti",
                        "latitude": "46.60703000",
                        "longitude": "22.50202000"
                    },
                    {
                        "id": 91566,
                        "name": "Comuna Căbeşti",
                        "latitude": "46.76593000",
                        "longitude": "22.37157000"
                    },
                    {
                        "id": 91542,
                        "name": "Comuna Câmpani",
                        "latitude": "46.52443000",
                        "longitude": "22.52744000"
                    },
                    {
                        "id": 91565,
                        "name": "Comuna Cãpâlna",
                        "latitude": "46.73682000",
                        "longitude": "22.11114000"
                    },
                    {
                        "id": 91589,
                        "name": "Comuna Cărpinet",
                        "latitude": "46.44163000",
                        "longitude": "22.48917000"
                    },
                    {
                        "id": 91275,
                        "name": "Comuna Cefa",
                        "latitude": "46.90898000",
                        "longitude": "21.69410000"
                    },
                    {
                        "id": 91278,
                        "name": "Comuna Ceica",
                        "latitude": "46.86444000",
                        "longitude": "22.18165000"
                    },
                    {
                        "id": 91303,
                        "name": "Comuna Cetariu",
                        "latitude": "47.15015000",
                        "longitude": "22.05458000"
                    },
                    {
                        "id": 91309,
                        "name": "Comuna Cherechiu",
                        "latitude": "47.39930000",
                        "longitude": "22.13550000"
                    },
                    {
                        "id": 91329,
                        "name": "Comuna Chişlaz",
                        "latitude": "47.26657000",
                        "longitude": "22.23300000"
                    },
                    {
                        "id": 91370,
                        "name": "Comuna Ciumeghiu",
                        "latitude": "46.71025000",
                        "longitude": "21.62604000"
                    },
                    {
                        "id": 91387,
                        "name": "Comuna Cociuba Mare",
                        "latitude": "46.72899000",
                        "longitude": "22.03966000"
                    },
                    {
                        "id": 91417,
                        "name": "Comuna Copăcel",
                        "latitude": "46.97234000",
                        "longitude": "22.16731000"
                    },
                    {
                        "id": 91507,
                        "name": "Comuna Criștioru de Jos",
                        "latitude": "46.42333000",
                        "longitude": "22.56565000"
                    },
                    {
                        "id": 91532,
                        "name": "Comuna Curăţele",
                        "latitude": "46.70310000",
                        "longitude": "22.43719000"
                    },
                    {
                        "id": 91531,
                        "name": "Comuna Curtuişeni",
                        "latitude": "47.53247000",
                        "longitude": "22.22961000"
                    },
                    {
                        "id": 91615,
                        "name": "Comuna Derna",
                        "latitude": "47.20800000",
                        "longitude": "22.28821000"
                    },
                    {
                        "id": 91628,
                        "name": "Comuna Diosig",
                        "latitude": "47.29561000",
                        "longitude": "21.99354000"
                    },
                    {
                        "id": 91635,
                        "name": "Comuna Dobreşti",
                        "latitude": "46.84465000",
                        "longitude": "22.26931000"
                    },
                    {
                        "id": 91700,
                        "name": "Comuna Drăgăneşti",
                        "latitude": "46.63469000",
                        "longitude": "22.40824000"
                    },
                    {
                        "id": 91687,
                        "name": "Comuna Drăgeşti",
                        "latitude": "46.90374000",
                        "longitude": "22.12533000"
                    },
                    {
                        "id": 91766,
                        "name": "Comuna Finiş",
                        "latitude": "46.64312000",
                        "longitude": "22.27621000"
                    },
                    {
                        "id": 91839,
                        "name": "Comuna Gepiu",
                        "latitude": "46.91616000",
                        "longitude": "21.78903000"
                    },
                    {
                        "id": 91870,
                        "name": "Comuna Girişu de Criş",
                        "latitude": "47.07118000",
                        "longitude": "21.76861000"
                    },
                    {
                        "id": 92000,
                        "name": "Comuna Hidişelu De Sus",
                        "latitude": "46.92893000",
                        "longitude": "22.02467000"
                    },
                    {
                        "id": 92010,
                        "name": "Comuna Holod",
                        "latitude": "46.79584000",
                        "longitude": "22.11471000"
                    },
                    {
                        "id": 92030,
                        "name": "Comuna Husasău de Tinca",
                        "latitude": "46.84896000",
                        "longitude": "21.91914000"
                    },
                    {
                        "id": 92080,
                        "name": "Comuna Ineu",
                        "latitude": "47.09119000",
                        "longitude": "22.10816000"
                    },
                    {
                        "id": 92226,
                        "name": "Comuna Lăzăreni",
                        "latitude": "46.85956000",
                        "longitude": "22.06685000"
                    },
                    {
                        "id": 92142,
                        "name": "Comuna Lazuri de Beiuş",
                        "latitude": "46.59381000",
                        "longitude": "22.39675000"
                    },
                    {
                        "id": 92193,
                        "name": "Comuna Lugaşu De Jos",
                        "latitude": "47.06992000",
                        "longitude": "22.32929000"
                    },
                    {
                        "id": 92198,
                        "name": "Comuna Lunca",
                        "latitude": "46.51645000",
                        "longitude": "22.45486000"
                    },
                    {
                        "id": 92384,
                        "name": "Comuna Mădăraş",
                        "latitude": "46.84296000",
                        "longitude": "21.72080000"
                    },
                    {
                        "id": 92386,
                        "name": "Comuna Măgeşti",
                        "latitude": "47.00929000",
                        "longitude": "22.45330000"
                    },
                    {
                        "id": 92452,
                        "name": "Comuna Nojorid",
                        "latitude": "46.97144000",
                        "longitude": "21.87747000"
                    },
                    {
                        "id": 92495,
                        "name": "Comuna Olcea",
                        "latitude": "46.66090000",
                        "longitude": "21.98452000"
                    },
                    {
                        "id": 92525,
                        "name": "Comuna Oşorhei",
                        "latitude": "47.02748000",
                        "longitude": "22.04490000"
                    },
                    {
                        "id": 92531,
                        "name": "Comuna Paleu",
                        "latitude": "47.10762000",
                        "longitude": "21.97748000"
                    },
                    {
                        "id": 92578,
                        "name": "Comuna Pietroasa",
                        "latitude": "46.58383000",
                        "longitude": "22.63371000"
                    },
                    {
                        "id": 92610,
                        "name": "Comuna Pocola",
                        "latitude": "46.69894000",
                        "longitude": "22.29593000"
                    },
                    {
                        "id": 92647,
                        "name": "Comuna Pomezeu",
                        "latitude": "46.79113000",
                        "longitude": "22.30018000"
                    },
                    {
                        "id": 92653,
                        "name": "Comuna Popeşti",
                        "latitude": "47.22088000",
                        "longitude": "22.41515000"
                    },
                    {
                        "id": 92834,
                        "name": "Comuna Răbăgani",
                        "latitude": "46.75432000",
                        "longitude": "22.24302000"
                    },
                    {
                        "id": 92763,
                        "name": "Comuna Remetea",
                        "latitude": "46.72956000",
                        "longitude": "22.35276000"
                    },
                    {
                        "id": 92771,
                        "name": "Comuna Rieni",
                        "latitude": "46.56878000",
                        "longitude": "22.44508000"
                    },
                    {
                        "id": 92795,
                        "name": "Comuna Roşia",
                        "latitude": "46.79896000",
                        "longitude": "22.40529000"
                    },
                    {
                        "id": 92803,
                        "name": "Comuna Roşiori",
                        "latitude": "47.25579000",
                        "longitude": "21.96166000"
                    },
                    {
                        "id": 93085,
                        "name": "Comuna Săcădat",
                        "latitude": "47.04710000",
                        "longitude": "22.15892000"
                    },
                    {
                        "id": 93091,
                        "name": "Comuna Sălacea",
                        "latitude": "47.44844000",
                        "longitude": "22.27208000"
                    },
                    {
                        "id": 93092,
                        "name": "Comuna Sălard",
                        "latitude": "47.23151000",
                        "longitude": "22.02068000"
                    },
                    {
                        "id": 93046,
                        "name": "Comuna Sâmbăta",
                        "latitude": "46.79819000",
                        "longitude": "22.20489000"
                    },
                    {
                        "id": 93054,
                        "name": "Comuna Sâniob",
                        "latitude": "47.24558000",
                        "longitude": "22.12533000"
                    },
                    {
                        "id": 93056,
                        "name": "Comuna Sânmartin",
                        "latitude": "46.99058000",
                        "longitude": "21.98565000"
                    },
                    {
                        "id": 93061,
                        "name": "Comuna Sânnicolau-Român",
                        "latitude": "46.96414000",
                        "longitude": "21.71886000"
                    },
                    {
                        "id": 93066,
                        "name": "Comuna Sântandrei",
                        "latitude": "47.06498000",
                        "longitude": "21.83947000"
                    },
                    {
                        "id": 93072,
                        "name": "Comuna Sârbi",
                        "latitude": "47.19030000",
                        "longitude": "22.13789000"
                    },
                    {
                        "id": 93521,
                        "name": "Comuna Şimian",
                        "latitude": "47.46477000",
                        "longitude": "22.05881000"
                    },
                    {
                        "id": 93527,
                        "name": "Comuna Şinteu",
                        "latitude": "47.14585000",
                        "longitude": "22.50629000"
                    },
                    {
                        "id": 93537,
                        "name": "Comuna Şoimi",
                        "latitude": "46.67063000",
                        "longitude": "22.13427000"
                    },
                    {
                        "id": 92983,
                        "name": "Comuna Spinuş",
                        "latitude": "47.20209000",
                        "longitude": "22.20217000"
                    },
                    {
                        "id": 93561,
                        "name": "Comuna Şuncuiuş",
                        "latitude": "46.92521000",
                        "longitude": "22.53323000"
                    },
                    {
                        "id": 93033,
                        "name": "Comuna Suplacu de Barcău",
                        "latitude": "47.24335000",
                        "longitude": "22.49235000"
                    },
                    {
                        "id": 93234,
                        "name": "Comuna Tãmãşeu",
                        "latitude": "47.22096000",
                        "longitude": "21.90399000"
                    },
                    {
                        "id": 93239,
                        "name": "Comuna Tărcaia",
                        "latitude": "46.61041000",
                        "longitude": "22.36364000"
                    },
                    {
                        "id": 93125,
                        "name": "Comuna Tarcea",
                        "latitude": "47.45767000",
                        "longitude": "22.18937000"
                    },
                    {
                        "id": 93250,
                        "name": "Comuna Tăuteu",
                        "latitude": "47.28131000",
                        "longitude": "22.35612000"
                    },
                    {
                        "id": 93569,
                        "name": "Comuna Ţeţchea",
                        "latitude": "47.03659000",
                        "longitude": "22.29798000"
                    },
                    {
                        "id": 93153,
                        "name": "Comuna Tileagd",
                        "latitude": "47.06556000",
                        "longitude": "22.20707000"
                    },
                    {
                        "id": 93156,
                        "name": "Comuna Tinca",
                        "latitude": "46.76310000",
                        "longitude": "21.93640000"
                    },
                    {
                        "id": 93161,
                        "name": "Comuna Toboliu",
                        "latitude": "47.04042000",
                        "longitude": "21.70320000"
                    },
                    {
                        "id": 93203,
                        "name": "Comuna Tulca",
                        "latitude": "46.78881000",
                        "longitude": "21.79763000"
                    },
                    {
                        "id": 93255,
                        "name": "Comuna Uileacu de Beiuş",
                        "latitude": "46.70215000",
                        "longitude": "22.22417000"
                    },
                    {
                        "id": 93290,
                        "name": "Comuna Vadu Crişului",
                        "latitude": "46.97192000",
                        "longitude": "22.50274000"
                    },
                    {
                        "id": 93438,
                        "name": "Comuna Vârciorog",
                        "latitude": "46.96551000",
                        "longitude": "22.29681000"
                    },
                    {
                        "id": 93360,
                        "name": "Comuna Viişoara",
                        "latitude": "47.38333000",
                        "longitude": "22.45000000"
                    },
                    {
                        "id": 93602,
                        "name": "Copăcel",
                        "latitude": "46.98333000",
                        "longitude": "22.16667000"
                    },
                    {
                        "id": 93625,
                        "name": "Cordău",
                        "latitude": "46.95000000",
                        "longitude": "21.98333000"
                    },
                    {
                        "id": 93736,
                        "name": "Criştioru de Jos",
                        "latitude": "46.41937000",
                        "longitude": "22.53457000"
                    },
                    {
                        "id": 93755,
                        "name": "Cubulcut",
                        "latitude": "47.32270000",
                        "longitude": "22.18648000"
                    },
                    {
                        "id": 93779,
                        "name": "Curăţele",
                        "latitude": "46.70000000",
                        "longitude": "22.41667000"
                    },
                    {
                        "id": 93778,
                        "name": "Curtuișeni",
                        "latitude": "47.54633000",
                        "longitude": "22.20263000"
                    },
                    {
                        "id": 93787,
                        "name": "Cuzap",
                        "latitude": "47.20288000",
                        "longitude": "22.41523000"
                    },
                    {
                        "id": 93922,
                        "name": "Derna",
                        "latitude": "47.20000000",
                        "longitude": "22.30000000"
                    },
                    {
                        "id": 93938,
                        "name": "Diosig",
                        "latitude": "47.30000000",
                        "longitude": "22.00000000"
                    },
                    {
                        "id": 93953,
                        "name": "Dobreşti",
                        "latitude": "46.85000000",
                        "longitude": "22.30000000"
                    },
                    {
                        "id": 94059,
                        "name": "Drăgăneşti",
                        "latitude": "46.61667000",
                        "longitude": "22.38333000"
                    },
                    {
                        "id": 94037,
                        "name": "Drăgeşti",
                        "latitude": "46.88333000",
                        "longitude": "22.13333000"
                    },
                    {
                        "id": 94178,
                        "name": "Finiş",
                        "latitude": "46.63333000",
                        "longitude": "22.31667000"
                    },
                    {
                        "id": 94195,
                        "name": "Foglaş",
                        "latitude": "47.25000000",
                        "longitude": "22.53333000"
                    },
                    {
                        "id": 94199,
                        "name": "Forău",
                        "latitude": "46.71070000",
                        "longitude": "22.20113000"
                    },
                    {
                        "id": 94280,
                        "name": "Galoșpetreu",
                        "latitude": "47.48345000",
                        "longitude": "22.21730000"
                    },
                    {
                        "id": 94294,
                        "name": "Gepiu",
                        "latitude": "46.93034000",
                        "longitude": "21.79016000"
                    },
                    {
                        "id": 94319,
                        "name": "Ghighișeni",
                        "latitude": "46.55141000",
                        "longitude": "22.43148000"
                    },
                    {
                        "id": 94332,
                        "name": "Ghiorac",
                        "latitude": "46.71340000",
                        "longitude": "21.68309000"
                    },
                    {
                        "id": 94346,
                        "name": "Girișu de Criș",
                        "latitude": "47.06416000",
                        "longitude": "21.76108000"
                    },
                    {
                        "id": 94427,
                        "name": "Groși",
                        "latitude": "47.04525000",
                        "longitude": "22.47965000"
                    },
                    {
                        "id": 94471,
                        "name": "Gurbediu",
                        "latitude": "46.79379000",
                        "longitude": "21.86480000"
                    },
                    {
                        "id": 94535,
                        "name": "Hidişelu de Sus",
                        "latitude": "46.95000000",
                        "longitude": "22.05000000"
                    },
                    {
                        "id": 94550,
                        "name": "Holod",
                        "latitude": "46.78333000",
                        "longitude": "22.13333000"
                    },
                    {
                        "id": 94569,
                        "name": "Hotar",
                        "latitude": "47.01967000",
                        "longitude": "22.28515000"
                    },
                    {
                        "id": 94584,
                        "name": "Husasău de Tinca",
                        "latitude": "46.81667000",
                        "longitude": "21.91667000"
                    },
                    {
                        "id": 94622,
                        "name": "Ianoșda",
                        "latitude": "46.83791000",
                        "longitude": "21.80778000"
                    },
                    {
                        "id": 94668,
                        "name": "Ineu",
                        "latitude": "47.08333000",
                        "longitude": "22.11667000"
                    },
                    {
                        "id": 94901,
                        "name": "Lăzăreni",
                        "latitude": "46.86667000",
                        "longitude": "22.06667000"
                    },
                    {
                        "id": 94767,
                        "name": "Lazuri de Beiuş",
                        "latitude": "46.58333000",
                        "longitude": "22.40000000"
                    },
                    {
                        "id": 94815,
                        "name": "Livada de Bihor",
                        "latitude": "47.01039000",
                        "longitude": "21.80836000"
                    },
                    {
                        "id": 94845,
                        "name": "Lugaşu de Jos",
                        "latitude": "47.06667000",
                        "longitude": "22.35000000"
                    },
                    {
                        "id": 94854,
                        "name": "Lunca",
                        "latitude": "46.51667000",
                        "longitude": "22.46667000"
                    },
                    {
                        "id": 94878,
                        "name": "Luncșoara",
                        "latitude": "47.03663000",
                        "longitude": "22.54213000"
                    },
                    {
                        "id": 95234,
                        "name": "Mădăraş",
                        "latitude": "46.83333000",
                        "longitude": "21.68333000"
                    },
                    {
                        "id": 95237,
                        "name": "Măgeşti",
                        "latitude": "47.01667000",
                        "longitude": "22.45000000"
                    },
                    {
                        "id": 94928,
                        "name": "Marghita",
                        "latitude": "47.35000000",
                        "longitude": "22.33333000"
                    },
                    {
                        "id": 94963,
                        "name": "Meziad",
                        "latitude": "46.74090000",
                        "longitude": "22.42846000"
                    },
                    {
                        "id": 94974,
                        "name": "Mihai Bravu",
                        "latitude": "47.25780000",
                        "longitude": "21.93811000"
                    },
                    {
                        "id": 95036,
                        "name": "Mișca",
                        "latitude": "47.26291000",
                        "longitude": "22.25914000"
                    },
                    {
                        "id": 95112,
                        "name": "Municipiul Beiuş",
                        "latitude": "46.68074000",
                        "longitude": "22.34566000"
                    },
                    {
                        "id": 95153,
                        "name": "Municipiul Marghita",
                        "latitude": "47.34534000",
                        "longitude": "22.33452000"
                    },
                    {
                        "id": 95163,
                        "name": "Municipiul Oradea",
                        "latitude": "47.05353000",
                        "longitude": "21.93633000"
                    },
                    {
                        "id": 95177,
                        "name": "Municipiul Salonta",
                        "latitude": "46.80283000",
                        "longitude": "21.66415000"
                    },
                    {
                        "id": 95354,
                        "name": "Nojorid",
                        "latitude": "46.98333000",
                        "longitude": "21.88333000"
                    },
                    {
                        "id": 95360,
                        "name": "Nucet",
                        "latitude": "46.48732000",
                        "longitude": "22.55850000"
                    },
                    {
                        "id": 95426,
                        "name": "Olcea",
                        "latitude": "46.68333000",
                        "longitude": "21.98333000"
                    },
                    {
                        "id": 95445,
                        "name": "Oradea",
                        "latitude": "47.04580000",
                        "longitude": "21.91833000"
                    },
                    {
                        "id": 95635,
                        "name": "Oraș Aleşd",
                        "latitude": "47.08772000",
                        "longitude": "22.41384000"
                    },
                    {
                        "id": 95552,
                        "name": "Oraş Nucet",
                        "latitude": "46.48496000",
                        "longitude": "22.58901000"
                    },
                    {
                        "id": 95598,
                        "name": "Oraş Sãcueni",
                        "latitude": "47.32996000",
                        "longitude": "22.11802000"
                    },
                    {
                        "id": 95631,
                        "name": "Oraş Ştei",
                        "latitude": "46.53767000",
                        "longitude": "22.45795000"
                    },
                    {
                        "id": 95614,
                        "name": "Oraş Valea Lui Mihai",
                        "latitude": "47.52099000",
                        "longitude": "22.13196000"
                    },
                    {
                        "id": 95615,
                        "name": "Oraş Vaşcãu",
                        "latitude": "46.47493000",
                        "longitude": "22.46292000"
                    },
                    {
                        "id": 95691,
                        "name": "Oșorhei",
                        "latitude": "47.03333000",
                        "longitude": "22.05000000"
                    },
                    {
                        "id": 96005,
                        "name": "Pădurea Neagră",
                        "latitude": "47.16554000",
                        "longitude": "22.41323000"
                    },
                    {
                        "id": 95701,
                        "name": "Paleu",
                        "latitude": "47.11531000",
                        "longitude": "21.95929000"
                    },
                    {
                        "id": 95764,
                        "name": "Peștiș",
                        "latitude": "47.07252000",
                        "longitude": "22.41226000"
                    },
                    {
                        "id": 95745,
                        "name": "Petreu",
                        "latitude": "47.33738000",
                        "longitude": "22.29607000"
                    },
                    {
                        "id": 95784,
                        "name": "Pietroasa",
                        "latitude": "46.58333000",
                        "longitude": "22.55000000"
                    },
                    {
                        "id": 95840,
                        "name": "Pocola",
                        "latitude": "46.68333000",
                        "longitude": "22.28333000"
                    },
                    {
                        "id": 95902,
                        "name": "Pomezeu",
                        "latitude": "46.78333000",
                        "longitude": "22.28333000"
                    },
                    {
                        "id": 95911,
                        "name": "Popeşti",
                        "latitude": "47.23333000",
                        "longitude": "22.41667000"
                    },
                    {
                        "id": 96181,
                        "name": "Răbăgani",
                        "latitude": "46.75000000",
                        "longitude": "22.23333000"
                    },
                    {
                        "id": 96082,
                        "name": "Remetea",
                        "latitude": "46.73333000",
                        "longitude": "22.35000000"
                    },
                    {
                        "id": 96093,
                        "name": "Rieni",
                        "latitude": "46.57485000",
                        "longitude": "22.44584000"
                    },
                    {
                        "id": 96127,
                        "name": "Roşia",
                        "latitude": "46.80000000",
                        "longitude": "22.40000000"
                    },
                    {
                        "id": 96138,
                        "name": "Roșiori",
                        "latitude": "47.25677000",
                        "longitude": "21.95209000"
                    },
                    {
                        "id": 105999,
                        "name": "Săcădat",
                        "latitude": "47.03333000",
                        "longitude": "22.15000000"
                    },
                    {
                        "id": 105997,
                        "name": "Săcueni",
                        "latitude": "47.35000000",
                        "longitude": "22.10000000"
                    },
                    {
                        "id": 106005,
                        "name": "Sălacea",
                        "latitude": "47.46667000",
                        "longitude": "22.31667000"
                    },
                    {
                        "id": 106006,
                        "name": "Sălard",
                        "latitude": "47.21667000",
                        "longitude": "22.05000000"
                    },
                    {
                        "id": 96236,
                        "name": "Salonta",
                        "latitude": "46.80000000",
                        "longitude": "21.65000000"
                    },
                    {
                        "id": 96519,
                        "name": "Sâmbăta",
                        "latitude": "46.80173000",
                        "longitude": "22.20357000"
                    },
                    {
                        "id": 96531,
                        "name": "Sâniob",
                        "latitude": "47.26461000",
                        "longitude": "22.12778000"
                    },
                    {
                        "id": 96541,
                        "name": "Sânnicolau Român",
                        "latitude": "46.96101000",
                        "longitude": "21.71466000"
                    },
                    {
                        "id": 105977,
                        "name": "Sântandrei",
                        "latitude": "47.06615000",
                        "longitude": "21.85352000"
                    },
                    {
                        "id": 105980,
                        "name": "Sântion",
                        "latitude": "47.09634000",
                        "longitude": "21.83660000"
                    },
                    {
                        "id": 105984,
                        "name": "Sârbi",
                        "latitude": "47.19315000",
                        "longitude": "22.12215000"
                    },
                    {
                        "id": 97123,
                        "name": "Șilindru",
                        "latitude": "47.43725000",
                        "longitude": "22.04683000"
                    },
                    {
                        "id": 97050,
                        "name": "Şimian",
                        "latitude": "47.48333000",
                        "longitude": "22.10000000"
                    },
                    {
                        "id": 105987,
                        "name": "Sînmartin",
                        "latitude": "47.00726000",
                        "longitude": "21.97418000"
                    },
                    {
                        "id": 97056,
                        "name": "Şinteu",
                        "latitude": "47.15000000",
                        "longitude": "22.48333000"
                    },
                    {
                        "id": 97066,
                        "name": "Şoimi",
                        "latitude": "46.68333000",
                        "longitude": "22.11667000"
                    },
                    {
                        "id": 96416,
                        "name": "Spinuş",
                        "latitude": "47.20000000",
                        "longitude": "22.20000000"
                    },
                    {
                        "id": 97134,
                        "name": "Ștei",
                        "latitude": "46.53333000",
                        "longitude": "22.45000000"
                    },
                    {
                        "id": 97093,
                        "name": "Şuncuiuş",
                        "latitude": "46.93333000",
                        "longitude": "22.53333000"
                    },
                    {
                        "id": 96502,
                        "name": "Suplacu de Barcău",
                        "latitude": "47.25729000",
                        "longitude": "22.53195000"
                    },
                    {
                        "id": 106054,
                        "name": "Talpoș",
                        "latitude": "46.69124000",
                        "longitude": "21.80335000"
                    },
                    {
                        "id": 96605,
                        "name": "Tămașda",
                        "latitude": "46.64453000",
                        "longitude": "21.55685000"
                    },
                    {
                        "id": 96608,
                        "name": "Tămășeu",
                        "latitude": "47.22116000",
                        "longitude": "21.92760000"
                    },
                    {
                        "id": 96610,
                        "name": "Tărcaia",
                        "latitude": "46.63333000",
                        "longitude": "22.36667000"
                    },
                    {
                        "id": 106059,
                        "name": "Tarcea",
                        "latitude": "47.45000000",
                        "longitude": "22.18333000"
                    },
                    {
                        "id": 96631,
                        "name": "Tășad",
                        "latitude": "46.93773000",
                        "longitude": "22.12516000"
                    },
                    {
                        "id": 96626,
                        "name": "Tăut",
                        "latitude": "46.71990000",
                        "longitude": "21.83845000"
                    },
                    {
                        "id": 96627,
                        "name": "Tăuteu",
                        "latitude": "47.26667000",
                        "longitude": "22.33333000"
                    },
                    {
                        "id": 106099,
                        "name": "Tileagd",
                        "latitude": "47.06667000",
                        "longitude": "22.20000000"
                    },
                    {
                        "id": 106103,
                        "name": "Tinca",
                        "latitude": "46.77529000",
                        "longitude": "21.93300000"
                    },
                    {
                        "id": 106112,
                        "name": "Toboliu",
                        "latitude": "47.04182000",
                        "longitude": "21.71946000"
                    },
                    {
                        "id": 106172,
                        "name": "Tulca",
                        "latitude": "46.78333000",
                        "longitude": "21.78333000"
                    },
                    {
                        "id": 96640,
                        "name": "Uileacu de Beiuș",
                        "latitude": "46.68532000",
                        "longitude": "22.22148000"
                    },
                    {
                        "id": 96695,
                        "name": "Vadu Crişului",
                        "latitude": "46.98333000",
                        "longitude": "22.51667000"
                    },
                    {
                        "id": 96767,
                        "name": "Valea lui Mihai",
                        "latitude": "47.51667000",
                        "longitude": "22.15000000"
                    },
                    {
                        "id": 96936,
                        "name": "Vârciorog",
                        "latitude": "46.96667000",
                        "longitude": "22.30000000"
                    },
                    {
                        "id": 96977,
                        "name": "Vășad",
                        "latitude": "47.51860000",
                        "longitude": "22.25660000"
                    },
                    {
                        "id": 96779,
                        "name": "Vaşcău",
                        "latitude": "46.46667000",
                        "longitude": "22.46667000"
                    },
                    {
                        "id": 96823,
                        "name": "Viişoara",
                        "latitude": "47.38333000",
                        "longitude": "22.45000000"
                    },
                    {
                        "id": 96833,
                        "name": "Vintere",
                        "latitude": "46.76883000",
                        "longitude": "22.14652000"
                    },
                    {
                        "id": 96886,
                        "name": "Voivozi",
                        "latitude": "47.21562000",
                        "longitude": "22.39024000"
                    }
                ]
            },
            {
                "id": 4733,
                "name": "Bistrița-Năsăud",
                "iso2": "BN",
                "latitude": "47.24861070",
                "longitude": "24.53228140",
                "type": "department",
                "cities": [
                    {
                        "id": 89899,
                        "name": "Agrieș",
                        "latitude": "47.40022000",
                        "longitude": "24.13491000"
                    },
                    {
                        "id": 89961,
                        "name": "Anieș",
                        "latitude": "47.41347000",
                        "longitude": "24.76853000"
                    },
                    {
                        "id": 90080,
                        "name": "Beclean",
                        "latitude": "47.18333000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 90129,
                        "name": "Bichigiu",
                        "latitude": "47.42522000",
                        "longitude": "24.33893000"
                    },
                    {
                        "id": 90147,
                        "name": "Bistriţa",
                        "latitude": "47.13316000",
                        "longitude": "24.50011000"
                    },
                    {
                        "id": 90148,
                        "name": "Bistriţa Bârgăului",
                        "latitude": "47.21667000",
                        "longitude": "24.76667000"
                    },
                    {
                        "id": 90268,
                        "name": "Braniştea",
                        "latitude": "47.16667000",
                        "longitude": "24.06667000"
                    },
                    {
                        "id": 90284,
                        "name": "Breaza",
                        "latitude": "47.35108000",
                        "longitude": "24.06220000"
                    },
                    {
                        "id": 90376,
                        "name": "Budacu de Jos",
                        "latitude": "47.08333000",
                        "longitude": "24.51667000"
                    },
                    {
                        "id": 90377,
                        "name": "Budacu de Sus",
                        "latitude": "47.06118000",
                        "longitude": "24.65752000"
                    },
                    {
                        "id": 90383,
                        "name": "Budeşti",
                        "latitude": "46.88333000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 93827,
                        "name": "Căianu Mic",
                        "latitude": "47.23333000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 90671,
                        "name": "Chiochiş",
                        "latitude": "46.98333000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 90686,
                        "name": "Chiuza",
                        "latitude": "47.23333000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 90695,
                        "name": "Ciceu-Giurgeşti",
                        "latitude": "47.25000000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 90696,
                        "name": "Ciceu-Mihăiești",
                        "latitude": "47.18568000",
                        "longitude": "23.97480000"
                    },
                    {
                        "id": 90735,
                        "name": "Cireșoaia",
                        "latitude": "47.14265000",
                        "longitude": "24.06217000"
                    },
                    {
                        "id": 90777,
                        "name": "Cociu",
                        "latitude": "47.19926000",
                        "longitude": "24.23238000"
                    },
                    {
                        "id": 90998,
                        "name": "Comuna Bistriţa Bârgăului",
                        "latitude": "47.19026000",
                        "longitude": "24.83429000"
                    },
                    {
                        "id": 91077,
                        "name": "Comuna Braniştea",
                        "latitude": "47.16250000",
                        "longitude": "24.07815000"
                    },
                    {
                        "id": 91143,
                        "name": "Comuna Budacu de Jos",
                        "latitude": "47.08214000",
                        "longitude": "24.51840000"
                    },
                    {
                        "id": 91146,
                        "name": "Comuna Budeşti",
                        "latitude": "46.83403000",
                        "longitude": "24.23802000"
                    },
                    {
                        "id": 91568,
                        "name": "Comuna Căianu",
                        "latitude": "47.25389000",
                        "longitude": "24.13440000"
                    },
                    {
                        "id": 91317,
                        "name": "Comuna Chiochiş",
                        "latitude": "46.98381000",
                        "longitude": "24.18318000"
                    },
                    {
                        "id": 91328,
                        "name": "Comuna Chiuza",
                        "latitude": "47.24007000",
                        "longitude": "24.24001000"
                    },
                    {
                        "id": 91331,
                        "name": "Comuna Ciceu-Giurgeşti",
                        "latitude": "47.26529000",
                        "longitude": "24.00380000"
                    },
                    {
                        "id": 91332,
                        "name": "Comuna Ciceu-Mihăieşti",
                        "latitude": "47.21738000",
                        "longitude": "23.95696000"
                    },
                    {
                        "id": 91472,
                        "name": "Comuna Coşbuc",
                        "latitude": "47.36544000",
                        "longitude": "24.39220000"
                    },
                    {
                        "id": 91722,
                        "name": "Comuna Dumitra",
                        "latitude": "47.21675000",
                        "longitude": "24.43434000"
                    },
                    {
                        "id": 91724,
                        "name": "Comuna Dumitriţa",
                        "latitude": "47.06781000",
                        "longitude": "24.63503000"
                    },
                    {
                        "id": 91755,
                        "name": "Comuna Feldru",
                        "latitude": "47.27796000",
                        "longitude": "24.56415000"
                    },
                    {
                        "id": 91827,
                        "name": "Comuna Galaţii Bistriţei",
                        "latitude": "46.99307000",
                        "longitude": "24.42153000"
                    },
                    {
                        "id": 92075,
                        "name": "Comuna Ilva Mare",
                        "latitude": "47.35100000",
                        "longitude": "24.89630000"
                    },
                    {
                        "id": 92076,
                        "name": "Comuna Ilva Mică",
                        "latitude": "47.30760000",
                        "longitude": "24.66035000"
                    },
                    {
                        "id": 92131,
                        "name": "Comuna Josenii Bârgăului",
                        "latitude": "47.21238000",
                        "longitude": "24.66351000"
                    },
                    {
                        "id": 92143,
                        "name": "Comuna Lechinţa",
                        "latitude": "47.01983000",
                        "longitude": "24.32605000"
                    },
                    {
                        "id": 92160,
                        "name": "Comuna Leşu",
                        "latitude": "47.31077000",
                        "longitude": "24.76369000"
                    },
                    {
                        "id": 92177,
                        "name": "Comuna Livezile",
                        "latitude": "47.17744000",
                        "longitude": "24.63595000"
                    },
                    {
                        "id": 92204,
                        "name": "Comuna Lunca Ilvei",
                        "latitude": "47.36409000",
                        "longitude": "24.97106000"
                    },
                    {
                        "id": 92391,
                        "name": "Comuna Măgura Ilvei",
                        "latitude": "47.36625000",
                        "longitude": "24.82185000"
                    },
                    {
                        "id": 92395,
                        "name": "Comuna Măieru",
                        "latitude": "47.40738000",
                        "longitude": "24.75680000"
                    },
                    {
                        "id": 92412,
                        "name": "Comuna Mărişelu",
                        "latitude": "47.01066000",
                        "longitude": "24.51260000"
                    },
                    {
                        "id": 92247,
                        "name": "Comuna Matei",
                        "latitude": "46.99930000",
                        "longitude": "24.26029000"
                    },
                    {
                        "id": 92265,
                        "name": "Comuna Miceştii de Câmpie",
                        "latitude": "46.84309000",
                        "longitude": "24.31568000"
                    },
                    {
                        "id": 92287,
                        "name": "Comuna Milas",
                        "latitude": "46.82249000",
                        "longitude": "24.43371000"
                    },
                    {
                        "id": 92330,
                        "name": "Comuna Monor",
                        "latitude": "46.95475000",
                        "longitude": "24.70106000"
                    },
                    {
                        "id": 92436,
                        "name": "Comuna Negrileşti",
                        "latitude": "47.31054000",
                        "longitude": "24.05557000"
                    },
                    {
                        "id": 92448,
                        "name": "Comuna Nimigea",
                        "latitude": "47.24697000",
                        "longitude": "24.30623000"
                    },
                    {
                        "id": 92458,
                        "name": "Comuna Nuşeni",
                        "latitude": "47.09063000",
                        "longitude": "24.17525000"
                    },
                    {
                        "id": 92540,
                        "name": "Comuna Parva",
                        "latitude": "47.39601000",
                        "longitude": "24.54218000"
                    },
                    {
                        "id": 92568,
                        "name": "Comuna Petru Rareş",
                        "latitude": "47.19221000",
                        "longitude": "24.00731000"
                    },
                    {
                        "id": 92624,
                        "name": "Comuna Poiana  Ilvei",
                        "latitude": "47.35749000",
                        "longitude": "24.74104000"
                    },
                    {
                        "id": 92686,
                        "name": "Comuna Prundu Bârgăului",
                        "latitude": "47.22154000",
                        "longitude": "24.72450000"
                    },
                    {
                        "id": 92854,
                        "name": "Comuna Războeni-Cetate",
                        "latitude": "47.11072000",
                        "longitude": "24.62878000"
                    },
                    {
                        "id": 92750,
                        "name": "Comuna Rebra",
                        "latitude": "47.32588000",
                        "longitude": "24.49984000"
                    },
                    {
                        "id": 92752,
                        "name": "Comuna Rebrişoara",
                        "latitude": "47.31994000",
                        "longitude": "24.46568000"
                    },
                    {
                        "id": 92777,
                        "name": "Comuna Rodna",
                        "latitude": "47.45140000",
                        "longitude": "24.82366000"
                    },
                    {
                        "id": 92784,
                        "name": "Comuna Romuli",
                        "latitude": "47.56247000",
                        "longitude": "24.42897000"
                    },
                    {
                        "id": 92813,
                        "name": "Comuna Runcu Salvei",
                        "latitude": "47.34382000",
                        "longitude": "24.32529000"
                    },
                    {
                        "id": 92868,
                        "name": "Comuna Salva",
                        "latitude": "47.30586000",
                        "longitude": "24.35557000"
                    },
                    {
                        "id": 93059,
                        "name": "Comuna Sânmihaiu de Câmpie",
                        "latitude": "46.89640000",
                        "longitude": "24.34323000"
                    },
                    {
                        "id": 93499,
                        "name": "Comuna Şanţ",
                        "latitude": "47.45266000",
                        "longitude": "24.91842000"
                    },
                    {
                        "id": 93514,
                        "name": "Comuna Şieu",
                        "latitude": "47.01244000",
                        "longitude": "24.62425000"
                    },
                    {
                        "id": 93516,
                        "name": "Comuna Şieu-Măgheruş",
                        "latitude": "47.08975000",
                        "longitude": "24.37651000"
                    },
                    {
                        "id": 93517,
                        "name": "Comuna Şieu-Odorhei",
                        "latitude": "47.13288000",
                        "longitude": "24.26856000"
                    },
                    {
                        "id": 93518,
                        "name": "Comuna Şieuţ",
                        "latitude": "46.99880000",
                        "longitude": "24.67935000"
                    },
                    {
                        "id": 92929,
                        "name": "Comuna Silivaşu De Câmpie",
                        "latitude": "46.78127000",
                        "longitude": "24.29155000"
                    },
                    {
                        "id": 93526,
                        "name": "Comuna Şintereag",
                        "latitude": "47.16796000",
                        "longitude": "24.31655000"
                    },
                    {
                        "id": 92981,
                        "name": "Comuna Spermezeu",
                        "latitude": "47.30000000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 93227,
                        "name": "Comuna Târlişua",
                        "latitude": "47.40584000",
                        "longitude": "24.16514000"
                    },
                    {
                        "id": 93131,
                        "name": "Comuna Teaca",
                        "latitude": "46.91151000",
                        "longitude": "24.47653000"
                    },
                    {
                        "id": 93135,
                        "name": "Comuna Telciu",
                        "latitude": "47.45070000",
                        "longitude": "24.39396000"
                    },
                    {
                        "id": 93152,
                        "name": "Comuna Tiha Bârgăului",
                        "latitude": "47.23676000",
                        "longitude": "24.87913000"
                    },
                    {
                        "id": 93283,
                        "name": "Comuna Uriu",
                        "latitude": "47.21202000",
                        "longitude": "24.07755000"
                    },
                    {
                        "id": 93284,
                        "name": "Comuna Urmeniş",
                        "latitude": "46.79559000",
                        "longitude": "24.35923000"
                    },
                    {
                        "id": 93469,
                        "name": "Comuna Zagra",
                        "latitude": "47.37083000",
                        "longitude": "24.26057000"
                    },
                    {
                        "id": 93629,
                        "name": "Cormaia",
                        "latitude": "47.36667000",
                        "longitude": "24.68333000"
                    },
                    {
                        "id": 93688,
                        "name": "Coşbuc",
                        "latitude": "47.36540000",
                        "longitude": "24.39115000"
                    },
                    {
                        "id": 93721,
                        "name": "Cristeștii Ciceului",
                        "latitude": "47.19326000",
                        "longitude": "24.09605000"
                    },
                    {
                        "id": 93957,
                        "name": "Dobric",
                        "latitude": "47.24690000",
                        "longitude": "24.12777000"
                    },
                    {
                        "id": 94097,
                        "name": "Dumitra",
                        "latitude": "47.21667000",
                        "longitude": "24.48333000"
                    },
                    {
                        "id": 94100,
                        "name": "Dumitrița",
                        "latitude": "47.07143000",
                        "longitude": "24.62579000"
                    },
                    {
                        "id": 94153,
                        "name": "Feldru",
                        "latitude": "47.28333000",
                        "longitude": "24.60000000"
                    },
                    {
                        "id": 94216,
                        "name": "Frunzi",
                        "latitude": "46.90000000",
                        "longitude": "24.33333000"
                    },
                    {
                        "id": 94273,
                        "name": "Galaţii Bistriţei",
                        "latitude": "46.98333000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 94661,
                        "name": "Ilva Mare",
                        "latitude": "47.36667000",
                        "longitude": "24.90000000"
                    },
                    {
                        "id": 94662,
                        "name": "Ilva Mică",
                        "latitude": "47.31667000",
                        "longitude": "24.66667000"
                    },
                    {
                        "id": 94749,
                        "name": "Josenii Bârgăului",
                        "latitude": "47.21667000",
                        "longitude": "24.68333000"
                    },
                    {
                        "id": 94768,
                        "name": "Lechinţa",
                        "latitude": "47.01667000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 94790,
                        "name": "Leşu",
                        "latitude": "47.31667000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 94825,
                        "name": "Livezile",
                        "latitude": "47.18333000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 94865,
                        "name": "Lunca Ilvei",
                        "latitude": "47.36667000",
                        "longitude": "24.98333000"
                    },
                    {
                        "id": 94867,
                        "name": "Lunca Leșului",
                        "latitude": "47.30943000",
                        "longitude": "24.77602000"
                    },
                    {
                        "id": 95242,
                        "name": "Măgura Ilvei",
                        "latitude": "47.38333000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 95249,
                        "name": "Măieru",
                        "latitude": "47.40000000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 95277,
                        "name": "Mărişelu",
                        "latitude": "47.01667000",
                        "longitude": "24.51667000"
                    },
                    {
                        "id": 94936,
                        "name": "Matei",
                        "latitude": "46.98333000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 94966,
                        "name": "Miceştii de Câmpie",
                        "latitude": "46.86667000",
                        "longitude": "24.31667000"
                    },
                    {
                        "id": 94999,
                        "name": "Mijlocenii Bârgăului",
                        "latitude": "47.21592000",
                        "longitude": "24.68936000"
                    },
                    {
                        "id": 95000,
                        "name": "Milaş",
                        "latitude": "46.81667000",
                        "longitude": "24.43333000"
                    },
                    {
                        "id": 95069,
                        "name": "Monor",
                        "latitude": "46.96667000",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 95113,
                        "name": "Municipiul Bistriţa",
                        "latitude": "47.13499000",
                        "longitude": "24.49115000"
                    },
                    {
                        "id": 95376,
                        "name": "Năsăud",
                        "latitude": "47.28333000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 95322,
                        "name": "Negrilești",
                        "latitude": "47.27068000",
                        "longitude": "24.04936000"
                    },
                    {
                        "id": 95328,
                        "name": "Nepos",
                        "latitude": "47.27750000",
                        "longitude": "24.53320000"
                    },
                    {
                        "id": 95345,
                        "name": "Nimigea de Jos",
                        "latitude": "47.25357000",
                        "longitude": "24.30084000"
                    },
                    {
                        "id": 95346,
                        "name": "Nimigea de Sus",
                        "latitude": "47.28333000",
                        "longitude": "24.31667000"
                    },
                    {
                        "id": 95365,
                        "name": "Nuşeni",
                        "latitude": "47.10000000",
                        "longitude": "24.20000000"
                    },
                    {
                        "id": 95401,
                        "name": "Ocnița",
                        "latitude": "46.86266000",
                        "longitude": "24.48677000"
                    },
                    {
                        "id": 95460,
                        "name": "Oraş Beclean",
                        "latitude": "47.16124000",
                        "longitude": "24.17385000"
                    },
                    {
                        "id": 95554,
                        "name": "Oraş Nãsãud",
                        "latitude": "47.27491000",
                        "longitude": "24.41483000"
                    },
                    {
                        "id": 95595,
                        "name": "Oraş Sângeorz-Bãi",
                        "latitude": "47.37780000",
                        "longitude": "24.66979000"
                    },
                    {
                        "id": 95715,
                        "name": "Parva",
                        "latitude": "47.40000000",
                        "longitude": "24.55000000"
                    },
                    {
                        "id": 95754,
                        "name": "Petriș",
                        "latitude": "47.10301000",
                        "longitude": "24.62314000"
                    },
                    {
                        "id": 95874,
                        "name": "Poiana Ilvei",
                        "latitude": "47.35749000",
                        "longitude": "24.74104000"
                    },
                    {
                        "id": 95967,
                        "name": "Prundu Bârgăului",
                        "latitude": "47.21975000",
                        "longitude": "24.74123000"
                    },
                    {
                        "id": 96204,
                        "name": "Răpănaşu",
                        "latitude": "47.38333000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 96064,
                        "name": "Rebra",
                        "latitude": "47.31667000",
                        "longitude": "24.50000000"
                    },
                    {
                        "id": 96066,
                        "name": "Rebrişoara",
                        "latitude": "47.28333000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 96088,
                        "name": "Reteag",
                        "latitude": "47.19582000",
                        "longitude": "24.01862000"
                    },
                    {
                        "id": 96099,
                        "name": "Rodna",
                        "latitude": "47.41667000",
                        "longitude": "24.81667000"
                    },
                    {
                        "id": 96108,
                        "name": "Romuli",
                        "latitude": "47.53333000",
                        "longitude": "24.43333000"
                    },
                    {
                        "id": 96155,
                        "name": "Runcu Salvei",
                        "latitude": "47.34382000",
                        "longitude": "24.32529000"
                    },
                    {
                        "id": 96237,
                        "name": "Salva",
                        "latitude": "47.30000000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 96529,
                        "name": "Sângeorz-Băi",
                        "latitude": "47.36850000",
                        "longitude": "24.67212000"
                    },
                    {
                        "id": 96536,
                        "name": "Sânmihaiu de Câmpie",
                        "latitude": "46.89257000",
                        "longitude": "24.33589000"
                    },
                    {
                        "id": 97113,
                        "name": "Șanț",
                        "latitude": "47.45000000",
                        "longitude": "24.90000000"
                    },
                    {
                        "id": 97044,
                        "name": "Şieu",
                        "latitude": "47.01667000",
                        "longitude": "24.60000000"
                    },
                    {
                        "id": 97045,
                        "name": "Şieu-Măgheruş",
                        "latitude": "47.08333000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 97046,
                        "name": "Şieu-Odorhei",
                        "latitude": "47.15194000",
                        "longitude": "24.29159000"
                    },
                    {
                        "id": 97047,
                        "name": "Şieuţ",
                        "latitude": "46.98333000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 96338,
                        "name": "Silivașu de Câmpie",
                        "latitude": "46.78333000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 97055,
                        "name": "Şintereag",
                        "latitude": "47.18333000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 96415,
                        "name": "Spermezeu",
                        "latitude": "47.30000000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 96513,
                        "name": "Susenii Bârgăului",
                        "latitude": "47.22311000",
                        "longitude": "24.70730000"
                    },
                    {
                        "id": 96592,
                        "name": "Târlişua",
                        "latitude": "47.38333000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 106066,
                        "name": "Teaca",
                        "latitude": "46.91667000",
                        "longitude": "24.51667000"
                    },
                    {
                        "id": 106076,
                        "name": "Telcișor",
                        "latitude": "47.46000000",
                        "longitude": "24.45158000"
                    },
                    {
                        "id": 106075,
                        "name": "Telciu",
                        "latitude": "47.43333000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 106097,
                        "name": "Tiha Bârgăului",
                        "latitude": "47.23333000",
                        "longitude": "24.76667000"
                    },
                    {
                        "id": 96560,
                        "name": "Tureac",
                        "latitude": "47.22967000",
                        "longitude": "24.80589000"
                    },
                    {
                        "id": 96667,
                        "name": "Unirea",
                        "latitude": "47.16060000",
                        "longitude": "24.53078000"
                    },
                    {
                        "id": 96678,
                        "name": "Uriu",
                        "latitude": "47.20000000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 96682,
                        "name": "Urmeniş",
                        "latitude": "46.76667000",
                        "longitude": "24.36667000"
                    },
                    {
                        "id": 96712,
                        "name": "Valea Borcutului",
                        "latitude": "47.37483000",
                        "longitude": "24.65293000"
                    },
                    {
                        "id": 96817,
                        "name": "Viile Tecii",
                        "latitude": "46.93333000",
                        "longitude": "24.48333000"
                    },
                    {
                        "id": 96825,
                        "name": "Viișoara",
                        "latitude": "47.10332000",
                        "longitude": "24.44949000"
                    },
                    {
                        "id": 96980,
                        "name": "Zagra",
                        "latitude": "47.33333000",
                        "longitude": "24.28333000"
                    }
                ]
            },
            {
                "id": 4740,
                "name": "Botoșani",
                "iso2": "BT",
                "latitude": "47.89240420",
                "longitude": "26.75917810",
                "type": "department",
                "cities": [
                    {
                        "id": 89889,
                        "name": "Adășeni",
                        "latitude": "48.06920000",
                        "longitude": "26.93789000"
                    },
                    {
                        "id": 89909,
                        "name": "Alba",
                        "latitude": "48.15859000",
                        "longitude": "26.47736000"
                    },
                    {
                        "id": 89916,
                        "name": "Albeşti",
                        "latitude": "47.70000000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 90009,
                        "name": "Avrămeni",
                        "latitude": "48.01667000",
                        "longitude": "26.95000000"
                    },
                    {
                        "id": 90035,
                        "name": "Bajura",
                        "latitude": "48.20119000",
                        "longitude": "26.53987000"
                    },
                    {
                        "id": 90517,
                        "name": "Băluşeni",
                        "latitude": "47.66667000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 90057,
                        "name": "Baranca",
                        "latitude": "48.19651000",
                        "longitude": "26.47893000"
                    },
                    {
                        "id": 90160,
                        "name": "Blândeşti",
                        "latitude": "47.70000000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 90173,
                        "name": "Bobulești",
                        "latitude": "47.75135000",
                        "longitude": "27.22697000"
                    },
                    {
                        "id": 90248,
                        "name": "Botoşani",
                        "latitude": "47.75000000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 90328,
                        "name": "Brăeşti",
                        "latitude": "47.86667000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 90296,
                        "name": "Brehuiești",
                        "latitude": "47.70194000",
                        "longitude": "26.54472000"
                    },
                    {
                        "id": 90307,
                        "name": "Broscăuţi",
                        "latitude": "47.95000000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 90343,
                        "name": "Bucecea",
                        "latitude": "47.76667000",
                        "longitude": "26.43333000"
                    },
                    {
                        "id": 90359,
                        "name": "Bucovineni",
                        "latitude": "47.85000000",
                        "longitude": "26.33333000"
                    },
                    {
                        "id": 93849,
                        "name": "Călăraşi",
                        "latitude": "47.61667000",
                        "longitude": "27.26667000"
                    },
                    {
                        "id": 93806,
                        "name": "Cândeşti",
                        "latitude": "47.93333000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 93881,
                        "name": "Cătămărești-Deal",
                        "latitude": "47.76999000",
                        "longitude": "26.59897000"
                    },
                    {
                        "id": 90826,
                        "name": "Comuna Adăşeni",
                        "latitude": "48.06287000",
                        "longitude": "26.95205000"
                    },
                    {
                        "id": 90839,
                        "name": "Comuna Albeşti",
                        "latitude": "47.68387000",
                        "longitude": "27.08704000"
                    },
                    {
                        "id": 90906,
                        "name": "Comuna Avrămeni",
                        "latitude": "48.02439000",
                        "longitude": "26.95734000"
                    },
                    {
                        "id": 91220,
                        "name": "Comuna Băluşeni",
                        "latitude": "47.67758000",
                        "longitude": "26.77855000"
                    },
                    {
                        "id": 91004,
                        "name": "Comuna Blândeşti",
                        "latitude": "47.71218000",
                        "longitude": "26.89193000"
                    },
                    {
                        "id": 91119,
                        "name": "Comuna Brăeşti",
                        "latitude": "47.84903000",
                        "longitude": "26.45715000"
                    },
                    {
                        "id": 91102,
                        "name": "Comuna Broscăuţi",
                        "latitude": "47.95596000",
                        "longitude": "26.46648000"
                    },
                    {
                        "id": 91576,
                        "name": "Comuna Călăraşi",
                        "latitude": "47.60340000",
                        "longitude": "27.27766000"
                    },
                    {
                        "id": 91547,
                        "name": "Comuna Cândeşti",
                        "latitude": "47.92325000",
                        "longitude": "26.22050000"
                    },
                    {
                        "id": 91411,
                        "name": "Comuna Conceşti",
                        "latitude": "48.14676000",
                        "longitude": "26.57937000"
                    },
                    {
                        "id": 91421,
                        "name": "Comuna Copălău",
                        "latitude": "47.61120000",
                        "longitude": "26.86778000"
                    },
                    {
                        "id": 93582,
                        "name": "Comună Cordăreni",
                        "latitude": "48.00420000",
                        "longitude": "26.59106000"
                    },
                    {
                        "id": 91433,
                        "name": "Comuna Corlăteni",
                        "latitude": "47.93121000",
                        "longitude": "26.58515000"
                    },
                    {
                        "id": 91441,
                        "name": "Comuna Corni",
                        "latitude": "47.64025000",
                        "longitude": "26.60869000"
                    },
                    {
                        "id": 91479,
                        "name": "Comuna Coşula",
                        "latitude": "47.61915000",
                        "longitude": "26.78553000"
                    },
                    {
                        "id": 91483,
                        "name": "Comuna Coţuşca",
                        "latitude": "48.12109000",
                        "longitude": "26.87179000"
                    },
                    {
                        "id": 91497,
                        "name": "Comuna Cristeşti",
                        "latitude": "47.61482000",
                        "longitude": "26.71546000"
                    },
                    {
                        "id": 91500,
                        "name": "Comuna Cristineşti",
                        "latitude": "48.10199000",
                        "longitude": "26.36951000"
                    },
                    {
                        "id": 91529,
                        "name": "Comuna Curteşti",
                        "latitude": "47.70275000",
                        "longitude": "26.64109000"
                    },
                    {
                        "id": 91727,
                        "name": "Comuna Dângeni",
                        "latitude": "47.84762000",
                        "longitude": "26.94817000"
                    },
                    {
                        "id": 91616,
                        "name": "Comuna Dersca",
                        "latitude": "47.98958000",
                        "longitude": "26.21496000"
                    },
                    {
                        "id": 91627,
                        "name": "Comuna Dimăcheni",
                        "latitude": "47.91832000",
                        "longitude": "26.54362000"
                    },
                    {
                        "id": 91646,
                        "name": "Comuna Dobârceni",
                        "latitude": "47.83289000",
                        "longitude": "27.07611000"
                    },
                    {
                        "id": 91696,
                        "name": "Comuna Drăguşeni",
                        "latitude": "48.03290000",
                        "longitude": "26.81987000"
                    },
                    {
                        "id": 91725,
                        "name": "Comuna Durneşti",
                        "latitude": "47.76992000",
                        "longitude": "27.09406000"
                    },
                    {
                        "id": 91788,
                        "name": "Comuna Frumuşica",
                        "latitude": "47.52602000",
                        "longitude": "26.87967000"
                    },
                    {
                        "id": 91838,
                        "name": "Comuna George Enescu",
                        "latitude": "48.03617000",
                        "longitude": "26.51437000"
                    },
                    {
                        "id": 91901,
                        "name": "Comuna Gorbăneşti",
                        "latitude": "47.77450000",
                        "longitude": "26.88143000"
                    },
                    {
                        "id": 92041,
                        "name": "Comuna Hăneşti",
                        "latitude": "47.91987000",
                        "longitude": "27.01151000"
                    },
                    {
                        "id": 91993,
                        "name": "Comuna Havârna",
                        "latitude": "48.05683000",
                        "longitude": "26.68314000"
                    },
                    {
                        "id": 92001,
                        "name": "Comuna Hilişeu-Horia",
                        "latitude": "48.01336000",
                        "longitude": "26.29685000"
                    },
                    {
                        "id": 92003,
                        "name": "Comuna Hlipiceni",
                        "latitude": "47.60401000",
                        "longitude": "27.17080000"
                    },
                    {
                        "id": 92026,
                        "name": "Comuna Hudeşti",
                        "latitude": "48.15280000",
                        "longitude": "26.50102000"
                    },
                    {
                        "id": 92058,
                        "name": "Comuna Ibăneşti",
                        "latitude": "48.04435000",
                        "longitude": "26.40450000"
                    },
                    {
                        "id": 92151,
                        "name": "Comuna Leorda",
                        "latitude": "47.81862000",
                        "longitude": "26.45408000"
                    },
                    {
                        "id": 92187,
                        "name": "Comuna Lozna",
                        "latitude": "47.94410000",
                        "longitude": "26.28694000"
                    },
                    {
                        "id": 92199,
                        "name": "Comuna Lunca",
                        "latitude": "47.62751000",
                        "longitude": "26.99240000"
                    },
                    {
                        "id": 92239,
                        "name": "Comuna Manoleasa",
                        "latitude": "48.00852000",
                        "longitude": "27.07951000"
                    },
                    {
                        "id": 92272,
                        "name": "Comuna Mihai Eminescu",
                        "latitude": "47.76632000",
                        "longitude": "26.56267000"
                    },
                    {
                        "id": 92283,
                        "name": "Comuna Mihăileni",
                        "latitude": "47.95552000",
                        "longitude": "26.16204000"
                    },
                    {
                        "id": 92286,
                        "name": "Comuna Mihălăşeni",
                        "latitude": "47.87956000",
                        "longitude": "27.09620000"
                    },
                    {
                        "id": 92291,
                        "name": "Comuna Mileanca",
                        "latitude": "48.09121000",
                        "longitude": "26.72965000"
                    },
                    {
                        "id": 92306,
                        "name": "Comuna Mitoc",
                        "latitude": "48.11288000",
                        "longitude": "27.00423000"
                    },
                    {
                        "id": 92447,
                        "name": "Comuna Nicşeni",
                        "latitude": "47.86170000",
                        "longitude": "26.66023000"
                    },
                    {
                        "id": 92717,
                        "name": "Comuna Păltiniş",
                        "latitude": "48.23494000",
                        "longitude": "26.68555000"
                    },
                    {
                        "id": 92649,
                        "name": "Comuna Pomârla",
                        "latitude": "48.06225000",
                        "longitude": "26.32090000"
                    },
                    {
                        "id": 92688,
                        "name": "Comuna Prăjeni",
                        "latitude": "47.49577000",
                        "longitude": "27.02386000"
                    },
                    {
                        "id": 92838,
                        "name": "Comuna Răchiţi",
                        "latitude": "47.77282000",
                        "longitude": "26.68847000"
                    },
                    {
                        "id": 92831,
                        "name": "Comuna Rãdãuţi-Prut",
                        "latitude": "48.22492000",
                        "longitude": "26.81304000"
                    },
                    {
                        "id": 92853,
                        "name": "Comuna Răuseni",
                        "latitude": "47.55941000",
                        "longitude": "27.22551000"
                    },
                    {
                        "id": 92772,
                        "name": "Comuna Ripiceni",
                        "latitude": "47.91899000",
                        "longitude": "27.13958000"
                    },
                    {
                        "id": 92781,
                        "name": "Comuna Roma",
                        "latitude": "47.84497000",
                        "longitude": "26.57084000"
                    },
                    {
                        "id": 92786,
                        "name": "Comuna Româneşti",
                        "latitude": "47.70860000",
                        "longitude": "27.23491000"
                    },
                    {
                        "id": 92871,
                        "name": "Comuna Santa Mare",
                        "latitude": "47.63308000",
                        "longitude": "27.30260000"
                    },
                    {
                        "id": 93507,
                        "name": "Comuna Şendriceni",
                        "latitude": "47.94657000",
                        "longitude": "26.32957000"
                    },
                    {
                        "id": 93022,
                        "name": "Comuna Stăuceni",
                        "latitude": "47.72142000",
                        "longitude": "26.77471000"
                    },
                    {
                        "id": 93556,
                        "name": "Comuna Ştiubieni",
                        "latitude": "47.97903000",
                        "longitude": "26.76420000"
                    },
                    {
                        "id": 93030,
                        "name": "Comuna Suharău",
                        "latitude": "48.11697000",
                        "longitude": "26.44743000"
                    },
                    {
                        "id": 93032,
                        "name": "Comuna Suliţa",
                        "latitude": "47.63723000",
                        "longitude": "26.93510000"
                    },
                    {
                        "id": 93162,
                        "name": "Comuna Todireni",
                        "latitude": "47.61386000",
                        "longitude": "27.10122000"
                    },
                    {
                        "id": 93197,
                        "name": "Comuna Truşeşti",
                        "latitude": "47.78058000",
                        "longitude": "26.98911000"
                    },
                    {
                        "id": 93200,
                        "name": "Comuna Tudora",
                        "latitude": "47.50773000",
                        "longitude": "26.63397000"
                    },
                    {
                        "id": 93271,
                        "name": "Comuna Ungureni",
                        "latitude": "47.90384000",
                        "longitude": "26.76051000"
                    },
                    {
                        "id": 93278,
                        "name": "Comuna Unţeni",
                        "latitude": "47.81164000",
                        "longitude": "26.77886000"
                    },
                    {
                        "id": 93450,
                        "name": "Comuna Văculeşti",
                        "latitude": "47.88229000",
                        "longitude": "26.38590000"
                    },
                    {
                        "id": 93439,
                        "name": "Comuna Vârfu Câmpului",
                        "latitude": "47.86108000",
                        "longitude": "26.31529000"
                    },
                    {
                        "id": 93362,
                        "name": "Comuna Viişoara",
                        "latitude": "48.16752000",
                        "longitude": "26.74267000"
                    },
                    {
                        "id": 93385,
                        "name": "Comuna Vlădeni",
                        "latitude": "47.72216000",
                        "longitude": "26.50880000"
                    },
                    {
                        "id": 93393,
                        "name": "Comuna Vlăsineşti",
                        "latitude": "47.93988000",
                        "longitude": "26.91901000"
                    },
                    {
                        "id": 93405,
                        "name": "Comuna Vorniceni",
                        "latitude": "47.96004000",
                        "longitude": "26.64699000"
                    },
                    {
                        "id": 93406,
                        "name": "Comuna Vorona",
                        "latitude": "47.57859000",
                        "longitude": "26.61380000"
                    },
                    {
                        "id": 93589,
                        "name": "Conceşti",
                        "latitude": "48.16667000",
                        "longitude": "26.55000000"
                    },
                    {
                        "id": 93608,
                        "name": "Copălău",
                        "latitude": "47.61667000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 93624,
                        "name": "Cordăreni",
                        "latitude": "47.98333000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 93626,
                        "name": "Corlăteni",
                        "latitude": "47.93333000",
                        "longitude": "26.55000000"
                    },
                    {
                        "id": 93636,
                        "name": "Corni",
                        "latitude": "47.65000000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 93663,
                        "name": "Costești",
                        "latitude": "47.80032000",
                        "longitude": "26.67584000"
                    },
                    {
                        "id": 93699,
                        "name": "Coșula",
                        "latitude": "47.62570000",
                        "longitude": "26.77827000"
                    },
                    {
                        "id": 93696,
                        "name": "Coţuşca",
                        "latitude": "48.13333000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 93718,
                        "name": "Cristeşti",
                        "latitude": "47.63333000",
                        "longitude": "26.73333000"
                    },
                    {
                        "id": 93724,
                        "name": "Cristineşti",
                        "latitude": "48.10000000",
                        "longitude": "26.38333000"
                    },
                    {
                        "id": 93775,
                        "name": "Curteşti",
                        "latitude": "47.71667000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 94108,
                        "name": "Dângeni",
                        "latitude": "47.85000000",
                        "longitude": "26.96667000"
                    },
                    {
                        "id": 93894,
                        "name": "Darabani",
                        "latitude": "48.18333000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 93923,
                        "name": "Dersca",
                        "latitude": "47.98333000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 93937,
                        "name": "Dimăcheni",
                        "latitude": "47.91139000",
                        "longitude": "26.54560000"
                    },
                    {
                        "id": 93972,
                        "name": "Dobârceni",
                        "latitude": "47.81667000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 94002,
                        "name": "Dorobanți",
                        "latitude": "47.88234000",
                        "longitude": "26.64723000"
                    },
                    {
                        "id": 94006,
                        "name": "Dorohoi",
                        "latitude": "47.95000000",
                        "longitude": "26.40000000"
                    },
                    {
                        "id": 94010,
                        "name": "Dracșani",
                        "latitude": "47.62945000",
                        "longitude": "26.93029000"
                    },
                    {
                        "id": 94049,
                        "name": "Drăguşeni",
                        "latitude": "48.01667000",
                        "longitude": "26.81667000"
                    },
                    {
                        "id": 94030,
                        "name": "Draxini",
                        "latitude": "47.65000000",
                        "longitude": "26.81667000"
                    },
                    {
                        "id": 94093,
                        "name": "Dumbrăvița",
                        "latitude": "48.01900000",
                        "longitude": "26.42724000"
                    },
                    {
                        "id": 94094,
                        "name": "Dumeni",
                        "latitude": "48.00724000",
                        "longitude": "26.54287000"
                    },
                    {
                        "id": 94102,
                        "name": "Durneşti",
                        "latitude": "47.76667000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 94191,
                        "name": "Flămânzi",
                        "latitude": "47.55000000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 94211,
                        "name": "Frumuşica",
                        "latitude": "47.53333000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 94293,
                        "name": "George Enescu",
                        "latitude": "48.03333000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 94383,
                        "name": "Gorbăneşti",
                        "latitude": "47.78333000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 94603,
                        "name": "Hăneşti",
                        "latitude": "47.91667000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 94524,
                        "name": "Havârna",
                        "latitude": "48.06667000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 94536,
                        "name": "Hilişeu-Horia",
                        "latitude": "48.03333000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 94538,
                        "name": "Hlipiceni",
                        "latitude": "47.60000000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 94571,
                        "name": "Hudeşti",
                        "latitude": "48.15000000",
                        "longitude": "26.50000000"
                    },
                    {
                        "id": 94614,
                        "name": "Iacobeni",
                        "latitude": "47.86115000",
                        "longitude": "26.91304000"
                    },
                    {
                        "id": 94632,
                        "name": "Ibăneşti",
                        "latitude": "48.06667000",
                        "longitude": "26.36667000"
                    },
                    {
                        "id": 94638,
                        "name": "Icușeni",
                        "latitude": "47.59269000",
                        "longitude": "26.59605000"
                    },
                    {
                        "id": 94680,
                        "name": "Ionășeni",
                        "latitude": "47.73029000",
                        "longitude": "26.99329000"
                    },
                    {
                        "id": 94745,
                        "name": "Joldești",
                        "latitude": "47.56004000",
                        "longitude": "26.57705000"
                    },
                    {
                        "id": 94778,
                        "name": "Leorda",
                        "latitude": "47.81667000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 94836,
                        "name": "Lozna",
                        "latitude": "47.95144000",
                        "longitude": "26.27723000"
                    },
                    {
                        "id": 94859,
                        "name": "Lunca",
                        "latitude": "47.61667000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 95214,
                        "name": "Mândrești",
                        "latitude": "47.73333000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 94923,
                        "name": "Manoleasa",
                        "latitude": "47.98333000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 94993,
                        "name": "Mihăileni",
                        "latitude": "47.96667000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 94997,
                        "name": "Mihălăşeni",
                        "latitude": "47.88333000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 95004,
                        "name": "Mileanca",
                        "latitude": "48.08333000",
                        "longitude": "26.70000000"
                    },
                    {
                        "id": 95010,
                        "name": "Miorcani",
                        "latitude": "48.20223000",
                        "longitude": "26.85279000"
                    },
                    {
                        "id": 95030,
                        "name": "Mitoc",
                        "latitude": "48.10000000",
                        "longitude": "27.03333000"
                    },
                    {
                        "id": 95037,
                        "name": "Mlenăuți",
                        "latitude": "48.12663000",
                        "longitude": "26.48961000"
                    },
                    {
                        "id": 95115,
                        "name": "Municipiul Botoşani",
                        "latitude": "47.73984000",
                        "longitude": "26.67156000"
                    },
                    {
                        "id": 95137,
                        "name": "Municipiul Dorohoi",
                        "latitude": "47.96772000",
                        "longitude": "26.41685000"
                    },
                    {
                        "id": 95333,
                        "name": "Nicolae Bălcescu",
                        "latitude": "47.56664000",
                        "longitude": "26.89629000"
                    },
                    {
                        "id": 95344,
                        "name": "Nicşeni",
                        "latitude": "47.86667000",
                        "longitude": "26.63333000"
                    },
                    {
                        "id": 95438,
                        "name": "Oneaga",
                        "latitude": "47.57626000",
                        "longitude": "26.73244000"
                    },
                    {
                        "id": 95473,
                        "name": "Oraş Bucecea",
                        "latitude": "47.77741000",
                        "longitude": "26.43966000"
                    },
                    {
                        "id": 95507,
                        "name": "Oraş Darabani",
                        "latitude": "48.17429000",
                        "longitude": "26.61519000"
                    },
                    {
                        "id": 95518,
                        "name": "Oraş Flãmânzi",
                        "latitude": "47.56193000",
                        "longitude": "26.90381000"
                    },
                    {
                        "id": 95600,
                        "name": "Oraş Sãveni",
                        "latitude": "47.95998000",
                        "longitude": "26.86677000"
                    },
                    {
                        "id": 95630,
                        "name": "Oraş Ştefãneşti",
                        "latitude": "47.78834000",
                        "longitude": "27.20601000"
                    },
                    {
                        "id": 95668,
                        "name": "Orășeni-Deal",
                        "latitude": "47.67597000",
                        "longitude": "26.67671000"
                    },
                    {
                        "id": 95664,
                        "name": "Oroftiana",
                        "latitude": "48.17758000",
                        "longitude": "26.34856000"
                    },
                    {
                        "id": 96006,
                        "name": "Pădureni",
                        "latitude": "47.97434000",
                        "longitude": "26.31672000"
                    },
                    {
                        "id": 96014,
                        "name": "Păltiniş",
                        "latitude": "48.21667000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 95863,
                        "name": "Poiana",
                        "latitude": "47.60149000",
                        "longitude": "26.60826000"
                    },
                    {
                        "id": 95904,
                        "name": "Pomârla",
                        "latitude": "48.06667000",
                        "longitude": "26.31667000"
                    },
                    {
                        "id": 95970,
                        "name": "Prăjeni",
                        "latitude": "47.51667000",
                        "longitude": "27.01667000"
                    },
                    {
                        "id": 96188,
                        "name": "Răchiţi",
                        "latitude": "47.76667000",
                        "longitude": "26.68333000"
                    },
                    {
                        "id": 96202,
                        "name": "Rădăuți-Prut",
                        "latitude": "48.23333000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 96194,
                        "name": "Rădeni",
                        "latitude": "47.51186000",
                        "longitude": "26.89249000"
                    },
                    {
                        "id": 96212,
                        "name": "Răuseni",
                        "latitude": "47.56667000",
                        "longitude": "27.20000000"
                    },
                    {
                        "id": 96078,
                        "name": "Rediu",
                        "latitude": "48.23075000",
                        "longitude": "26.77841000"
                    },
                    {
                        "id": 96095,
                        "name": "Ripiceni",
                        "latitude": "47.95000000",
                        "longitude": "27.13333000"
                    },
                    {
                        "id": 96104,
                        "name": "Roma",
                        "latitude": "47.83333000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 96113,
                        "name": "Românești",
                        "latitude": "47.73141000",
                        "longitude": "27.24027000"
                    },
                    {
                        "id": 96139,
                        "name": "Roșiori",
                        "latitude": "47.76095000",
                        "longitude": "26.72167000"
                    },
                    {
                        "id": 96240,
                        "name": "Santa Mare",
                        "latitude": "47.61667000",
                        "longitude": "27.35000000"
                    },
                    {
                        "id": 96242,
                        "name": "Sarafinești",
                        "latitude": "47.61708000",
                        "longitude": "26.60740000"
                    },
                    {
                        "id": 105985,
                        "name": "Sârbi",
                        "latitude": "47.94268000",
                        "longitude": "26.91818000"
                    },
                    {
                        "id": 106046,
                        "name": "Săveni",
                        "latitude": "47.95000000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 97038,
                        "name": "Şendriceni",
                        "latitude": "47.95171000",
                        "longitude": "26.32817000"
                    },
                    {
                        "id": 96472,
                        "name": "Stâncești",
                        "latitude": "47.75000000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 96483,
                        "name": "Stăuceni",
                        "latitude": "47.71667000",
                        "longitude": "26.75000000"
                    },
                    {
                        "id": 97133,
                        "name": "Ștefănești",
                        "latitude": "47.79169000",
                        "longitude": "27.20053000"
                    },
                    {
                        "id": 97086,
                        "name": "Ştefăneşti-Sat",
                        "latitude": "47.78333000",
                        "longitude": "27.18333000"
                    },
                    {
                        "id": 97088,
                        "name": "Ştiubieni",
                        "latitude": "47.96667000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 96444,
                        "name": "Storeşti",
                        "latitude": "47.55000000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 96464,
                        "name": "Străteni",
                        "latitude": "47.93677000",
                        "longitude": "26.29664000"
                    },
                    {
                        "id": 96456,
                        "name": "Stroiești",
                        "latitude": "47.61042000",
                        "longitude": "26.96562000"
                    },
                    {
                        "id": 96496,
                        "name": "Suharău",
                        "latitude": "48.13333000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 96500,
                        "name": "Sulița",
                        "latitude": "47.65000000",
                        "longitude": "26.91667000"
                    },
                    {
                        "id": 97135,
                        "name": "Șupitca",
                        "latitude": "47.60941000",
                        "longitude": "26.78359000"
                    },
                    {
                        "id": 106113,
                        "name": "Tocileni",
                        "latitude": "47.71104000",
                        "longitude": "26.78657000"
                    },
                    {
                        "id": 106114,
                        "name": "Todireni",
                        "latitude": "47.61667000",
                        "longitude": "27.11667000"
                    },
                    {
                        "id": 106162,
                        "name": "Truşeşti",
                        "latitude": "47.76667000",
                        "longitude": "27.01667000"
                    },
                    {
                        "id": 106166,
                        "name": "Tudor Vladimirescu",
                        "latitude": "47.68635000",
                        "longitude": "27.17211000"
                    },
                    {
                        "id": 106168,
                        "name": "Tudora",
                        "latitude": "47.51667000",
                        "longitude": "26.63333000"
                    },
                    {
                        "id": 96662,
                        "name": "Ungureni",
                        "latitude": "47.88176000",
                        "longitude": "26.79899000"
                    },
                    {
                        "id": 96663,
                        "name": "Ungureni-Jianu",
                        "latitude": "47.88333000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 96671,
                        "name": "Unţeni",
                        "latitude": "47.80000000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 96950,
                        "name": "Văculeşti",
                        "latitude": "47.88333000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 96938,
                        "name": "Vârfu Câmpului",
                        "latitude": "47.84566000",
                        "longitude": "26.33056000"
                    },
                    {
                        "id": 96804,
                        "name": "Victoria",
                        "latitude": "47.61018000",
                        "longitude": "27.16730000"
                    },
                    {
                        "id": 96821,
                        "name": "Viişoara",
                        "latitude": "48.16667000",
                        "longitude": "26.73333000"
                    },
                    {
                        "id": 96863,
                        "name": "Vlădeni",
                        "latitude": "47.71667000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 96864,
                        "name": "Vlădeni-Deal",
                        "latitude": "47.52250000",
                        "longitude": "26.87295000"
                    },
                    {
                        "id": 96872,
                        "name": "Vlăsineşti",
                        "latitude": "47.93333000",
                        "longitude": "26.88333000"
                    },
                    {
                        "id": 96891,
                        "name": "Vorniceni",
                        "latitude": "47.98333000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 96892,
                        "name": "Vorona",
                        "latitude": "47.57714000",
                        "longitude": "26.63078000"
                    },
                    {
                        "id": 96893,
                        "name": "Vorona Teodoru",
                        "latitude": "47.55000000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 96999,
                        "name": "Zlătunoaia",
                        "latitude": "47.65026000",
                        "longitude": "27.00743000"
                    }
                ]
            },
            {
                "id": 4736,
                "name": "Braila",
                "iso2": "BR",
                "latitude": "45.26524630",
                "longitude": "27.95947140",
                "type": "department",
                "cities": [
                    {
                        "id": 90042,
                        "name": "Baldovinești",
                        "latitude": "45.32182000",
                        "longitude": "27.91107000"
                    },
                    {
                        "id": 90547,
                        "name": "Bărăganul",
                        "latitude": "44.80000000",
                        "longitude": "27.51667000"
                    },
                    {
                        "id": 90115,
                        "name": "Berteştii de Jos",
                        "latitude": "44.83333000",
                        "longitude": "27.75000000"
                    },
                    {
                        "id": 90224,
                        "name": "Bordei Verde",
                        "latitude": "45.08333000",
                        "longitude": "27.56667000"
                    },
                    {
                        "id": 90334,
                        "name": "Brăila",
                        "latitude": "45.27152000",
                        "longitude": "27.97429000"
                    },
                    {
                        "id": 90594,
                        "name": "Cazasu",
                        "latitude": "45.27172000",
                        "longitude": "27.89011000"
                    },
                    {
                        "id": 90681,
                        "name": "Chiscani",
                        "latitude": "45.18333000",
                        "longitude": "27.93333000"
                    },
                    {
                        "id": 90709,
                        "name": "Ciocile",
                        "latitude": "44.81667000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 90733,
                        "name": "Cireşu",
                        "latitude": "44.95000000",
                        "longitude": "27.35000000"
                    },
                    {
                        "id": 91243,
                        "name": "Comuna Bărăganul",
                        "latitude": "44.81068000",
                        "longitude": "27.51515000"
                    },
                    {
                        "id": 90973,
                        "name": "Comuna Berteştii de Jos",
                        "latitude": "44.83024000",
                        "longitude": "27.72008000"
                    },
                    {
                        "id": 91047,
                        "name": "Comuna Bordei Verde",
                        "latitude": "45.03225000",
                        "longitude": "27.57088000"
                    },
                    {
                        "id": 91269,
                        "name": "Comuna Cazasu",
                        "latitude": "45.27172000",
                        "longitude": "27.89011000"
                    },
                    {
                        "id": 91324,
                        "name": "Comuna Chiscani",
                        "latitude": "45.20880000",
                        "longitude": "27.91776000"
                    },
                    {
                        "id": 91342,
                        "name": "Comuna Ciocile",
                        "latitude": "44.82211000",
                        "longitude": "27.25180000"
                    },
                    {
                        "id": 91359,
                        "name": "Comuna Cireşu",
                        "latitude": "44.95368000",
                        "longitude": "27.37901000"
                    },
                    {
                        "id": 91706,
                        "name": "Comuna Dudeşti",
                        "latitude": "44.87624000",
                        "longitude": "27.44325000"
                    },
                    {
                        "id": 91781,
                        "name": "Comuna Frecãţei",
                        "latitude": "44.85977000",
                        "longitude": "28.08422000"
                    },
                    {
                        "id": 91828,
                        "name": "Comuna Galbenu",
                        "latitude": "45.19252000",
                        "longitude": "27.16669000"
                    },
                    {
                        "id": 91836,
                        "name": "Comuna Gemenele",
                        "latitude": "45.28931000",
                        "longitude": "27.65637000"
                    },
                    {
                        "id": 91941,
                        "name": "Comuna Grădiştea",
                        "latitude": "45.24832000",
                        "longitude": "27.38192000"
                    },
                    {
                        "id": 91924,
                        "name": "Comuna Gropeni",
                        "latitude": "45.07328000",
                        "longitude": "27.88606000"
                    },
                    {
                        "id": 92126,
                        "name": "Comuna Jirlău",
                        "latitude": "45.15314000",
                        "longitude": "27.20900000"
                    },
                    {
                        "id": 92405,
                        "name": "Comuna Măraşu",
                        "latitude": "45.00807000",
                        "longitude": "27.98062000"
                    },
                    {
                        "id": 92422,
                        "name": "Comuna Măxineni",
                        "latitude": "45.41803000",
                        "longitude": "27.66470000"
                    },
                    {
                        "id": 92295,
                        "name": "Comuna Mircea Vodă",
                        "latitude": "45.12889000",
                        "longitude": "27.38258000"
                    },
                    {
                        "id": 92339,
                        "name": "Comuna Movila Miresii",
                        "latitude": "45.19574000",
                        "longitude": "27.60368000"
                    },
                    {
                        "id": 92737,
                        "name": "Comuna Racoviţa",
                        "latitude": "45.30627000",
                        "longitude": "27.46720000"
                    },
                    {
                        "id": 92823,
                        "name": "Comuna Râmnicelu",
                        "latitude": "45.29786000",
                        "longitude": "27.51338000"
                    },
                    {
                        "id": 92782,
                        "name": "Comuna Romanu",
                        "latitude": "45.31818000",
                        "longitude": "27.74046000"
                    },
                    {
                        "id": 92804,
                        "name": "Comuna Roşiori",
                        "latitude": "44.84097000",
                        "longitude": "27.34129000"
                    },
                    {
                        "id": 92866,
                        "name": "Comuna Salcia Tudor",
                        "latitude": "45.40260000",
                        "longitude": "27.50380000"
                    },
                    {
                        "id": 92893,
                        "name": "Comuna Scorţaru Nou",
                        "latitude": "45.34905000",
                        "longitude": "27.61478000"
                    },
                    {
                        "id": 92932,
                        "name": "Comuna Siliştea",
                        "latitude": "45.35263000",
                        "longitude": "27.82592000"
                    },
                    {
                        "id": 93015,
                        "name": "Comuna Stăncuţa",
                        "latitude": "44.88885000",
                        "longitude": "27.79614000"
                    },
                    {
                        "id": 93038,
                        "name": "Comuna Surdila-Găiseanca",
                        "latitude": "45.09893000",
                        "longitude": "27.33491000"
                    },
                    {
                        "id": 93037,
                        "name": "Comuna Surdila-Greci",
                        "latitude": "45.07288000",
                        "longitude": "27.26840000"
                    },
                    {
                        "id": 93565,
                        "name": "Comuna Şuţeşti",
                        "latitude": "45.22101000",
                        "longitude": "27.47067000"
                    },
                    {
                        "id": 93148,
                        "name": "Comuna Tichileşti",
                        "latitude": "45.14822000",
                        "longitude": "27.89059000"
                    },
                    {
                        "id": 93189,
                        "name": "Comuna Traian",
                        "latitude": "45.15355000",
                        "longitude": "27.69170000"
                    },
                    {
                        "id": 93199,
                        "name": "Comuna Tudor Vladimirescu",
                        "latitude": "45.22537000",
                        "longitude": "27.75299000"
                    },
                    {
                        "id": 93202,
                        "name": "Comuna Tufeşti",
                        "latitude": "44.98719000",
                        "longitude": "27.80256000"
                    },
                    {
                        "id": 93264,
                        "name": "Comuna Ulmu",
                        "latitude": "44.94821000",
                        "longitude": "27.29836000"
                    },
                    {
                        "id": 93277,
                        "name": "Comuna Unirea",
                        "latitude": "45.10592000",
                        "longitude": "27.77613000"
                    },
                    {
                        "id": 93454,
                        "name": "Comuna Vădeni",
                        "latitude": "45.33745000",
                        "longitude": "27.90589000"
                    },
                    {
                        "id": 93352,
                        "name": "Comuna Victoria",
                        "latitude": "44.79568000",
                        "longitude": "27.67036000"
                    },
                    {
                        "id": 93374,
                        "name": "Comuna Vişani",
                        "latitude": "45.18495000",
                        "longitude": "27.30611000"
                    },
                    {
                        "id": 93373,
                        "name": "Comuna Viziru",
                        "latitude": "45.02027000",
                        "longitude": "27.73217000"
                    },
                    {
                        "id": 93491,
                        "name": "Comuna Zăvoaia",
                        "latitude": "44.95276000",
                        "longitude": "27.45613000"
                    },
                    {
                        "id": 93621,
                        "name": "Corbu Nou",
                        "latitude": "45.40996000",
                        "longitude": "27.59191000"
                    },
                    {
                        "id": 93785,
                        "name": "Cuza Vodă",
                        "latitude": "44.92513000",
                        "longitude": "27.73273000"
                    },
                    {
                        "id": 93908,
                        "name": "Dedulești",
                        "latitude": "45.14679000",
                        "longitude": "27.38907000"
                    },
                    {
                        "id": 94069,
                        "name": "Dudeşti",
                        "latitude": "44.90000000",
                        "longitude": "27.43333000"
                    },
                    {
                        "id": 94269,
                        "name": "Făurei",
                        "latitude": "45.08333000",
                        "longitude": "27.26667000"
                    },
                    {
                        "id": 94205,
                        "name": "Frecăţei",
                        "latitude": "44.90000000",
                        "longitude": "28.11667000"
                    },
                    {
                        "id": 94275,
                        "name": "Galbenu",
                        "latitude": "45.21667000",
                        "longitude": "27.16667000"
                    },
                    {
                        "id": 94289,
                        "name": "Gemenele",
                        "latitude": "45.28333000",
                        "longitude": "27.61667000"
                    },
                    {
                        "id": 94440,
                        "name": "Grădiştea",
                        "latitude": "45.26667000",
                        "longitude": "27.38333000"
                    },
                    {
                        "id": 94419,
                        "name": "Gropeni",
                        "latitude": "45.07547000",
                        "longitude": "27.87969000"
                    },
                    {
                        "id": 94620,
                        "name": "Ianca",
                        "latitude": "45.13333000",
                        "longitude": "27.45000000"
                    },
                    {
                        "id": 97024,
                        "name": "Însurăţei",
                        "latitude": "44.91667000",
                        "longitude": "27.60000000"
                    },
                    {
                        "id": 94740,
                        "name": "Jirlău",
                        "latitude": "45.16667000",
                        "longitude": "27.16667000"
                    },
                    {
                        "id": 94751,
                        "name": "Jugureanu",
                        "latitude": "44.94313000",
                        "longitude": "27.27878000"
                    },
                    {
                        "id": 94756,
                        "name": "Lacu Sărat",
                        "latitude": "45.21867000",
                        "longitude": "27.88764000"
                    },
                    {
                        "id": 94759,
                        "name": "Lanurile",
                        "latitude": "45.04149000",
                        "longitude": "27.74916000"
                    },
                    {
                        "id": 95265,
                        "name": "Măraşu",
                        "latitude": "44.85000000",
                        "longitude": "27.96667000"
                    },
                    {
                        "id": 95293,
                        "name": "Măxineni",
                        "latitude": "45.40000000",
                        "longitude": "27.63333000"
                    },
                    {
                        "id": 94977,
                        "name": "Mihai Bravu",
                        "latitude": "44.78469000",
                        "longitude": "27.72144000"
                    },
                    {
                        "id": 95013,
                        "name": "Mircea Vodă",
                        "latitude": "45.11667000",
                        "longitude": "27.38333000"
                    },
                    {
                        "id": 95081,
                        "name": "Movila Miresii",
                        "latitude": "45.21667000",
                        "longitude": "27.60000000"
                    },
                    {
                        "id": 95118,
                        "name": "Municipiul Brãila",
                        "latitude": "45.27190000",
                        "longitude": "27.97500000"
                    },
                    {
                        "id": 95522,
                        "name": "Oraş Fãurei",
                        "latitude": "45.08534000",
                        "longitude": "27.27155000"
                    },
                    {
                        "id": 95533,
                        "name": "Oraş Ianca",
                        "latitude": "45.11446000",
                        "longitude": "27.50205000"
                    },
                    {
                        "id": 95627,
                        "name": "Oraş Însurãţei",
                        "latitude": "44.91928000",
                        "longitude": "27.64433000"
                    },
                    {
                        "id": 95739,
                        "name": "Perișoru",
                        "latitude": "45.11268000",
                        "longitude": "27.49817000"
                    },
                    {
                        "id": 95822,
                        "name": "Plopu",
                        "latitude": "45.14847000",
                        "longitude": "27.51387000"
                    },
                    {
                        "id": 96041,
                        "name": "Racoviţa",
                        "latitude": "45.30000000",
                        "longitude": "27.45000000"
                    },
                    {
                        "id": 96168,
                        "name": "Râmnicelu",
                        "latitude": "45.28333000",
                        "longitude": "27.53333000"
                    },
                    {
                        "id": 96106,
                        "name": "Romanu",
                        "latitude": "45.28333000",
                        "longitude": "27.73333000"
                    },
                    {
                        "id": 96132,
                        "name": "Roşiori",
                        "latitude": "44.80000000",
                        "longitude": "27.38333000"
                    },
                    {
                        "id": 96234,
                        "name": "Salcia Tudor",
                        "latitude": "45.36667000",
                        "longitude": "27.51667000"
                    },
                    {
                        "id": 96279,
                        "name": "Scorţaru Nou",
                        "latitude": "45.31667000",
                        "longitude": "27.60000000"
                    },
                    {
                        "id": 96283,
                        "name": "Scorțaru Vechi",
                        "latitude": "45.21886000",
                        "longitude": "27.75489000"
                    },
                    {
                        "id": 96340,
                        "name": "Siliştea",
                        "latitude": "45.30000000",
                        "longitude": "27.85000000"
                    },
                    {
                        "id": 96417,
                        "name": "Spiru Haret",
                        "latitude": "44.86715000",
                        "longitude": "27.74463000"
                    },
                    {
                        "id": 96476,
                        "name": "Stăncuţa",
                        "latitude": "44.90000000",
                        "longitude": "27.83333000"
                    },
                    {
                        "id": 96507,
                        "name": "Surdila-Găiseanca",
                        "latitude": "45.06667000",
                        "longitude": "27.33333000"
                    },
                    {
                        "id": 96506,
                        "name": "Surdila-Greci",
                        "latitude": "45.06667000",
                        "longitude": "27.26667000"
                    },
                    {
                        "id": 97097,
                        "name": "Şuţeşti",
                        "latitude": "45.21667000",
                        "longitude": "27.43333000"
                    },
                    {
                        "id": 96615,
                        "name": "Tătaru",
                        "latitude": "44.84482000",
                        "longitude": "27.43376000"
                    },
                    {
                        "id": 106093,
                        "name": "Tichileşti",
                        "latitude": "45.11667000",
                        "longitude": "27.90000000"
                    },
                    {
                        "id": 106145,
                        "name": "Traian",
                        "latitude": "45.18333000",
                        "longitude": "27.73333000"
                    },
                    {
                        "id": 106164,
                        "name": "Tudor Vladimirescu",
                        "latitude": "45.21667000",
                        "longitude": "27.80000000"
                    },
                    {
                        "id": 106171,
                        "name": "Tufeşti",
                        "latitude": "45.05000000",
                        "longitude": "27.81667000"
                    },
                    {
                        "id": 96650,
                        "name": "Ulmu",
                        "latitude": "44.95000000",
                        "longitude": "27.31667000"
                    },
                    {
                        "id": 96669,
                        "name": "Unirea",
                        "latitude": "45.11667000",
                        "longitude": "27.81667000"
                    },
                    {
                        "id": 96680,
                        "name": "Urleasca",
                        "latitude": "45.13697000",
                        "longitude": "27.64736000"
                    },
                    {
                        "id": 96954,
                        "name": "Vădeni",
                        "latitude": "45.36667000",
                        "longitude": "27.93333000"
                    },
                    {
                        "id": 96719,
                        "name": "Valea Cânepii",
                        "latitude": "45.08333000",
                        "longitude": "27.81667000"
                    },
                    {
                        "id": 96806,
                        "name": "Victoria",
                        "latitude": "44.81667000",
                        "longitude": "27.61667000"
                    },
                    {
                        "id": 96846,
                        "name": "Vişani",
                        "latitude": "45.15000000",
                        "longitude": "27.28333000"
                    },
                    {
                        "id": 96844,
                        "name": "Viziru",
                        "latitude": "45.01667000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 97021,
                        "name": "Zăvoaia",
                        "latitude": "44.95000000",
                        "longitude": "27.48333000"
                    }
                ]
            },
            {
                "id": 4759,
                "name": "Brașov",
                "iso2": "BV",
                "latitude": "45.77818440",
                "longitude": "25.22258000",
                "type": "department",
                "cities": [
                    {
                        "id": 89877,
                        "name": "Acriș",
                        "latitude": "45.63673000",
                        "longitude": "25.99247000"
                    },
                    {
                        "id": 89971,
                        "name": "Apaţa",
                        "latitude": "45.95000000",
                        "longitude": "25.51667000"
                    },
                    {
                        "id": 90004,
                        "name": "Augustin",
                        "latitude": "46.04613000",
                        "longitude": "25.55333000"
                    },
                    {
                        "id": 90079,
                        "name": "Beclean",
                        "latitude": "45.83119000",
                        "longitude": "24.92180000"
                    },
                    {
                        "id": 90179,
                        "name": "Bod",
                        "latitude": "45.76667000",
                        "longitude": "25.65000000"
                    },
                    {
                        "id": 90266,
                        "name": "Bran",
                        "latitude": "45.51667000",
                        "longitude": "25.35000000"
                    },
                    {
                        "id": 90281,
                        "name": "Braşov",
                        "latitude": "45.64861000",
                        "longitude": "25.60613000"
                    },
                    {
                        "id": 90386,
                        "name": "Budila",
                        "latitude": "45.66667000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 90409,
                        "name": "Buneşti",
                        "latitude": "46.10000000",
                        "longitude": "25.05000000"
                    },
                    {
                        "id": 90596,
                        "name": "Caţa",
                        "latitude": "46.08333000",
                        "longitude": "25.26667000"
                    },
                    {
                        "id": 90703,
                        "name": "Cincu",
                        "latitude": "45.91667000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 90785,
                        "name": "Codlea",
                        "latitude": "45.70000000",
                        "longitude": "25.45000000"
                    },
                    {
                        "id": 90799,
                        "name": "Colonia Bod",
                        "latitude": "45.75588000",
                        "longitude": "25.59960000"
                    },
                    {
                        "id": 90805,
                        "name": "Comana de Jos",
                        "latitude": "45.91375000",
                        "longitude": "25.23129000"
                    },
                    {
                        "id": 90806,
                        "name": "Comana de Sus",
                        "latitude": "45.90000000",
                        "longitude": "25.26667000"
                    },
                    {
                        "id": 90878,
                        "name": "Comuna Apaţa",
                        "latitude": "45.95043000",
                        "longitude": "25.53312000"
                    },
                    {
                        "id": 90902,
                        "name": "Comuna Augustin",
                        "latitude": "46.04613000",
                        "longitude": "25.55333000"
                    },
                    {
                        "id": 90947,
                        "name": "Comuna Beclean",
                        "latitude": "45.83119000",
                        "longitude": "24.92317000"
                    },
                    {
                        "id": 91017,
                        "name": "Comuna Bod",
                        "latitude": "45.75987000",
                        "longitude": "25.62077000"
                    },
                    {
                        "id": 91076,
                        "name": "Comuna Bran",
                        "latitude": "45.51412000",
                        "longitude": "25.37289000"
                    },
                    {
                        "id": 91148,
                        "name": "Comuna Budila",
                        "latitude": "45.67432000",
                        "longitude": "25.80793000"
                    },
                    {
                        "id": 91165,
                        "name": "Comuna Buneşti",
                        "latitude": "46.10042000",
                        "longitude": "25.05528000"
                    },
                    {
                        "id": 91270,
                        "name": "Comuna Caţa",
                        "latitude": "46.13174000",
                        "longitude": "25.26977000"
                    },
                    {
                        "id": 91338,
                        "name": "Comuna Cincu",
                        "latitude": "45.90712000",
                        "longitude": "24.77333000"
                    },
                    {
                        "id": 91405,
                        "name": "Comuna Comana",
                        "latitude": "45.91357000",
                        "longitude": "25.22080000"
                    },
                    {
                        "id": 91498,
                        "name": "Comuna Cristian",
                        "latitude": "45.62474000",
                        "longitude": "25.48292000"
                    },
                    {
                        "id": 91503,
                        "name": "Comuna Crizbav",
                        "latitude": "45.82070000",
                        "longitude": "25.46739000"
                    },
                    {
                        "id": 91693,
                        "name": "Comuna Drăguş",
                        "latitude": "45.76146000",
                        "longitude": "24.77906000"
                    },
                    {
                        "id": 91718,
                        "name": "Comuna Dumbrăviţa",
                        "latitude": "45.76667000",
                        "longitude": "25.43333000"
                    },
                    {
                        "id": 91754,
                        "name": "Comuna Feldioara",
                        "latitude": "45.82829000",
                        "longitude": "25.57459000"
                    },
                    {
                        "id": 91798,
                        "name": "Comuna Fundata",
                        "latitude": "45.44615000",
                        "longitude": "25.27775000"
                    },
                    {
                        "id": 92037,
                        "name": "Comuna Hălchiu",
                        "latitude": "45.76743000",
                        "longitude": "25.52991000"
                    },
                    {
                        "id": 92043,
                        "name": "Comuna Hărman",
                        "latitude": "45.73727000",
                        "longitude": "25.70451000"
                    },
                    {
                        "id": 92035,
                        "name": "Comuna Hârşeni",
                        "latitude": "45.73420000",
                        "longitude": "25.02404000"
                    },
                    {
                        "id": 92007,
                        "name": "Comuna Hoghiz",
                        "latitude": "45.96602000",
                        "longitude": "25.32168000"
                    },
                    {
                        "id": 92008,
                        "name": "Comuna Holbav",
                        "latitude": "45.65922000",
                        "longitude": "25.38744000"
                    },
                    {
                        "id": 92013,
                        "name": "Comuna Homorod",
                        "latitude": "46.07260000",
                        "longitude": "25.33464000"
                    },
                    {
                        "id": 92119,
                        "name": "Comuna Jibert",
                        "latitude": "46.00173000",
                        "longitude": "25.07355000"
                    },
                    {
                        "id": 92171,
                        "name": "Comuna Lisa",
                        "latitude": "45.72760000",
                        "longitude": "24.86876000"
                    },
                    {
                        "id": 92376,
                        "name": "Comuna Mãieruş",
                        "latitude": "45.89358000",
                        "longitude": "25.49705000"
                    },
                    {
                        "id": 92366,
                        "name": "Comuna Mândra",
                        "latitude": "45.81219000",
                        "longitude": "25.03262000"
                    },
                    {
                        "id": 92322,
                        "name": "Comuna Moieciu",
                        "latitude": "45.48848000",
                        "longitude": "25.30962000"
                    },
                    {
                        "id": 92511,
                        "name": "Comuna Ormeniş",
                        "latitude": "46.00473000",
                        "longitude": "25.55683000"
                    },
                    {
                        "id": 92708,
                        "name": "Comuna Pârâu",
                        "latitude": "45.85139000",
                        "longitude": "25.21584000"
                    },
                    {
                        "id": 92630,
                        "name": "Comuna Poiana Mărului (Brașov)",
                        "latitude": "45.60462000",
                        "longitude": "25.30927000"
                    },
                    {
                        "id": 92671,
                        "name": "Comuna Prejmer",
                        "latitude": "45.73164000",
                        "longitude": "25.78673000"
                    },
                    {
                        "id": 92739,
                        "name": "Comuna Racoş",
                        "latitude": "46.02051000",
                        "longitude": "25.39563000"
                    },
                    {
                        "id": 92753,
                        "name": "Comuna Recea",
                        "latitude": "45.74312000",
                        "longitude": "24.94086000"
                    },
                    {
                        "id": 93047,
                        "name": "Comuna Sâmbăta de Sus",
                        "latitude": "45.72698000",
                        "longitude": "24.81067000"
                    },
                    {
                        "id": 93063,
                        "name": "Comuna Sânpetru",
                        "latitude": "45.71082000",
                        "longitude": "25.63678000"
                    },
                    {
                        "id": 93511,
                        "name": "Comuna Şercaia",
                        "latitude": "45.83002000",
                        "longitude": "25.14114000"
                    },
                    {
                        "id": 93524,
                        "name": "Comuna Şinca Nouă",
                        "latitude": "45.69667000",
                        "longitude": "25.22177000"
                    },
                    {
                        "id": 93525,
                        "name": "Comuna Şinca Veche",
                        "latitude": "45.75892000",
                        "longitude": "25.15578000"
                    },
                    {
                        "id": 93534,
                        "name": "Comuna Şoarş",
                        "latitude": "45.92871000",
                        "longitude": "24.92764000"
                    },
                    {
                        "id": 93240,
                        "name": "Comuna Tărlungeni",
                        "latitude": "45.64579000",
                        "longitude": "25.77368000"
                    },
                    {
                        "id": 93138,
                        "name": "Comuna Teliu",
                        "latitude": "45.69856000",
                        "longitude": "25.85590000"
                    },
                    {
                        "id": 93149,
                        "name": "Comuna Ticuşu Vechi",
                        "latitude": "45.92823000",
                        "longitude": "25.09346000"
                    },
                    {
                        "id": 93251,
                        "name": "Comuna Ucea de Jos",
                        "latitude": "45.77980000",
                        "longitude": "24.68477000"
                    },
                    {
                        "id": 93269,
                        "name": "Comuna Ungra",
                        "latitude": "45.97828000",
                        "longitude": "25.21859000"
                    },
                    {
                        "id": 93333,
                        "name": "Comuna Vama Buzăului",
                        "latitude": "45.60258000",
                        "longitude": "25.97991000"
                    },
                    {
                        "id": 93380,
                        "name": "Comuna Viştea de Jos",
                        "latitude": "45.77201000",
                        "longitude": "24.75237000"
                    },
                    {
                        "id": 93395,
                        "name": "Comuna Voila",
                        "latitude": "45.81815000",
                        "longitude": "24.84060000"
                    },
                    {
                        "id": 93412,
                        "name": "Comuna Vulcan",
                        "latitude": "45.64960000",
                        "longitude": "25.41671000"
                    },
                    {
                        "id": 93723,
                        "name": "Cristian",
                        "latitude": "45.61667000",
                        "longitude": "25.46667000"
                    },
                    {
                        "id": 93730,
                        "name": "Crivina",
                        "latitude": "45.58333000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 93732,
                        "name": "Crizbav",
                        "latitude": "45.81515000",
                        "longitude": "25.46718000"
                    },
                    {
                        "id": 93758,
                        "name": "Cuciulata",
                        "latitude": "45.94389000",
                        "longitude": "25.27541000"
                    },
                    {
                        "id": 94052,
                        "name": "Drăguș",
                        "latitude": "45.76146000",
                        "longitude": "24.77906000"
                    },
                    {
                        "id": 94088,
                        "name": "Dumbrăviţa",
                        "latitude": "45.76667000",
                        "longitude": "25.43333000"
                    },
                    {
                        "id": 94256,
                        "name": "Făgăraș",
                        "latitude": "45.85000000",
                        "longitude": "24.96667000"
                    },
                    {
                        "id": 94152,
                        "name": "Feldioara",
                        "latitude": "45.81667000",
                        "longitude": "25.60000000"
                    },
                    {
                        "id": 94183,
                        "name": "Fișer",
                        "latitude": "46.07912000",
                        "longitude": "25.15103000"
                    },
                    {
                        "id": 94224,
                        "name": "Fundata",
                        "latitude": "45.45000000",
                        "longitude": "25.30000000"
                    },
                    {
                        "id": 94321,
                        "name": "Ghimbav",
                        "latitude": "45.66667000",
                        "longitude": "25.50000000"
                    },
                    {
                        "id": 94598,
                        "name": "Hălchiu",
                        "latitude": "45.76667000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 94605,
                        "name": "Hărman",
                        "latitude": "45.71667000",
                        "longitude": "25.68333000"
                    },
                    {
                        "id": 94593,
                        "name": "Hârşeni",
                        "latitude": "45.75000000",
                        "longitude": "25.01667000"
                    },
                    {
                        "id": 94547,
                        "name": "Hoghiz",
                        "latitude": "45.98333000",
                        "longitude": "25.30000000"
                    },
                    {
                        "id": 94548,
                        "name": "Holbav",
                        "latitude": "45.65922000",
                        "longitude": "25.38744000"
                    },
                    {
                        "id": 94553,
                        "name": "Homorod",
                        "latitude": "46.05000000",
                        "longitude": "25.26667000"
                    },
                    {
                        "id": 94728,
                        "name": "Jibert",
                        "latitude": "46.00000000",
                        "longitude": "25.06667000"
                    },
                    {
                        "id": 94809,
                        "name": "Lisa",
                        "latitude": "45.71667000",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 95250,
                        "name": "Măieruş",
                        "latitude": "45.90000000",
                        "longitude": "25.53333000"
                    },
                    {
                        "id": 95212,
                        "name": "Mândra",
                        "latitude": "45.81667000",
                        "longitude": "25.05000000"
                    },
                    {
                        "id": 95047,
                        "name": "Moeciu de Jos",
                        "latitude": "45.48333000",
                        "longitude": "25.31667000"
                    },
                    {
                        "id": 95057,
                        "name": "Moieciu de Jos",
                        "latitude": "45.50313000",
                        "longitude": "25.33719000"
                    },
                    {
                        "id": 95102,
                        "name": "Municipiul  Codlea",
                        "latitude": "45.69944000",
                        "longitude": "25.44778000"
                    },
                    {
                        "id": 95117,
                        "name": "Municipiul Braşov",
                        "latitude": "45.65053000",
                        "longitude": "25.60913000"
                    },
                    {
                        "id": 95142,
                        "name": "Municipiul Fãgãraş",
                        "latitude": "45.84098000",
                        "longitude": "24.97348000"
                    },
                    {
                        "id": 95185,
                        "name": "Municipiul Sãcele",
                        "latitude": "45.61772000",
                        "longitude": "25.69890000"
                    },
                    {
                        "id": 95524,
                        "name": "Oraş Ghimbav",
                        "latitude": "45.66397000",
                        "longitude": "25.50836000"
                    },
                    {
                        "id": 95573,
                        "name": "Oraş Predeal",
                        "latitude": "45.49679000",
                        "longitude": "25.58778000"
                    },
                    {
                        "id": 95581,
                        "name": "Oraş Râşnov",
                        "latitude": "45.59108000",
                        "longitude": "25.46393000"
                    },
                    {
                        "id": 95580,
                        "name": "Oraş Rupea",
                        "latitude": "46.05903000",
                        "longitude": "25.18717000"
                    },
                    {
                        "id": 95617,
                        "name": "Oraş Victoria",
                        "latitude": "45.72968000",
                        "longitude": "24.70280000"
                    },
                    {
                        "id": 95625,
                        "name": "Oraş Zãrneşti",
                        "latitude": "45.55650000",
                        "longitude": "25.35205000"
                    },
                    {
                        "id": 95662,
                        "name": "Ormeniş",
                        "latitude": "46.01667000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 96002,
                        "name": "Pârâu",
                        "latitude": "45.85000000",
                        "longitude": "25.18333000"
                    },
                    {
                        "id": 95740,
                        "name": "Perșani",
                        "latitude": "45.78160000",
                        "longitude": "25.21285000"
                    },
                    {
                        "id": 95879,
                        "name": "Poiana Mărului (Brașov)",
                        "latitude": "45.60000000",
                        "longitude": "25.30000000"
                    },
                    {
                        "id": 95942,
                        "name": "Predeal",
                        "latitude": "45.50000000",
                        "longitude": "25.56667000"
                    },
                    {
                        "id": 95944,
                        "name": "Prejmer",
                        "latitude": "45.71667000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 95984,
                        "name": "Purcăreni",
                        "latitude": "45.64476000",
                        "longitude": "25.79129000"
                    },
                    {
                        "id": 96048,
                        "name": "Racoș",
                        "latitude": "46.02524000",
                        "longitude": "25.41075000"
                    },
                    {
                        "id": 96178,
                        "name": "Râşnov",
                        "latitude": "45.58333000",
                        "longitude": "25.45000000"
                    },
                    {
                        "id": 96069,
                        "name": "Recea",
                        "latitude": "45.71334000",
                        "longitude": "24.93152000"
                    },
                    {
                        "id": 96156,
                        "name": "Rupea",
                        "latitude": "46.03333000",
                        "longitude": "25.21667000"
                    },
                    {
                        "id": 105992,
                        "name": "Săcele",
                        "latitude": "45.61674000",
                        "longitude": "25.71101000"
                    },
                    {
                        "id": 96520,
                        "name": "Sâmbăta de Sus",
                        "latitude": "45.76178000",
                        "longitude": "24.82053000"
                    },
                    {
                        "id": 96543,
                        "name": "Sânpetru",
                        "latitude": "45.71082000",
                        "longitude": "25.63678000"
                    },
                    {
                        "id": 97040,
                        "name": "Şercaia",
                        "latitude": "45.83333000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 97125,
                        "name": "Șimon",
                        "latitude": "45.48484000",
                        "longitude": "25.35664000"
                    },
                    {
                        "id": 97126,
                        "name": "Șinca Nouă",
                        "latitude": "45.69457000",
                        "longitude": "25.24348000"
                    },
                    {
                        "id": 97054,
                        "name": "Şinca Veche",
                        "latitude": "45.76667000",
                        "longitude": "25.16667000"
                    },
                    {
                        "id": 97063,
                        "name": "Şoarş",
                        "latitude": "45.92859000",
                        "longitude": "24.92867000"
                    },
                    {
                        "id": 96401,
                        "name": "Sohodol",
                        "latitude": "45.52829000",
                        "longitude": "25.40244000"
                    },
                    {
                        "id": 96612,
                        "name": "Tărlungeni",
                        "latitude": "45.63333000",
                        "longitude": "25.75000000"
                    },
                    {
                        "id": 106081,
                        "name": "Teliu",
                        "latitude": "45.69856000",
                        "longitude": "25.85590000"
                    },
                    {
                        "id": 106094,
                        "name": "Ticuşu Vechi",
                        "latitude": "45.93333000",
                        "longitude": "25.10000000"
                    },
                    {
                        "id": 106119,
                        "name": "Tohanu Nou",
                        "latitude": "45.55208000",
                        "longitude": "25.38622000"
                    },
                    {
                        "id": 96549,
                        "name": "Tunelu-Teliu",
                        "latitude": "45.70000000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 96632,
                        "name": "Ucea de Jos",
                        "latitude": "45.78410000",
                        "longitude": "24.67097000"
                    },
                    {
                        "id": 96633,
                        "name": "Ucea de Sus",
                        "latitude": "45.75000000",
                        "longitude": "24.68333000"
                    },
                    {
                        "id": 96656,
                        "name": "Ungra",
                        "latitude": "45.98333000",
                        "longitude": "25.26667000"
                    },
                    {
                        "id": 96772,
                        "name": "Vama Buzăului",
                        "latitude": "45.59668000",
                        "longitude": "25.99359000"
                    },
                    {
                        "id": 96803,
                        "name": "Victoria",
                        "latitude": "45.72968000",
                        "longitude": "24.70280000"
                    },
                    {
                        "id": 96839,
                        "name": "Viscri",
                        "latitude": "46.05522000",
                        "longitude": "25.09389000"
                    },
                    {
                        "id": 96854,
                        "name": "Viștea de Jos",
                        "latitude": "45.79582000",
                        "longitude": "24.72380000"
                    },
                    {
                        "id": 96876,
                        "name": "Voila",
                        "latitude": "45.81839000",
                        "longitude": "24.84215000"
                    },
                    {
                        "id": 96900,
                        "name": "Vulcan",
                        "latitude": "45.63333000",
                        "longitude": "25.41667000"
                    },
                    {
                        "id": 97016,
                        "name": "Zărnești",
                        "latitude": "45.56093000",
                        "longitude": "25.31787000"
                    },
                    {
                        "id": 96997,
                        "name": "Zizin",
                        "latitude": "45.63697000",
                        "longitude": "25.77898000"
                    }
                ]
            },
            {
                "id": 4730,
                "name": "Bucharest",
                "iso2": "B",
                "latitude": "44.42676740",
                "longitude": "26.10253840",
                "type": "municipality",
                "cities": [
                    {
                        "id": 90347,
                        "name": "Bucharest",
                        "latitude": "44.43225000",
                        "longitude": "26.10626000"
                    },
                    {
                        "id": 96307,
                        "name": "Sector 1",
                        "latitude": "44.49239000",
                        "longitude": "26.04831000"
                    },
                    {
                        "id": 96308,
                        "name": "Sector 2",
                        "latitude": "44.45280000",
                        "longitude": "26.13321000"
                    },
                    {
                        "id": 96309,
                        "name": "Sector 3",
                        "latitude": "44.42340000",
                        "longitude": "26.16874000"
                    },
                    {
                        "id": 96310,
                        "name": "Sector 4",
                        "latitude": "44.37571000",
                        "longitude": "26.12085000"
                    },
                    {
                        "id": 96311,
                        "name": "Sector 5",
                        "latitude": "44.38808000",
                        "longitude": "26.07144000"
                    },
                    {
                        "id": 96312,
                        "name": "Sector 6",
                        "latitude": "44.43579000",
                        "longitude": "26.01649000"
                    }
                ]
            },
            {
                "id": 4756,
                "name": "Buzău",
                "iso2": "BZ",
                "latitude": "45.33509120",
                "longitude": "26.71075780",
                "type": "department",
                "cities": [
                    {
                        "id": 89948,
                        "name": "Amara",
                        "latitude": "45.24866000",
                        "longitude": "27.29244000"
                    },
                    {
                        "id": 89949,
                        "name": "Amaru",
                        "latitude": "44.93333000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 90469,
                        "name": "Băbeni",
                        "latitude": "45.44635000",
                        "longitude": "26.97875000"
                    },
                    {
                        "id": 90019,
                        "name": "Babeţi",
                        "latitude": "45.31667000",
                        "longitude": "26.38333000"
                    },
                    {
                        "id": 90522,
                        "name": "Bălăceanu",
                        "latitude": "45.26667000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 90047,
                        "name": "Balta Albă",
                        "latitude": "45.30423000",
                        "longitude": "27.28557000"
                    },
                    {
                        "id": 90462,
                        "name": "Bâsca Chiojdului",
                        "latitude": "45.37120000",
                        "longitude": "26.18355000"
                    },
                    {
                        "id": 90463,
                        "name": "Bâsca Rozilei",
                        "latitude": "45.45387000",
                        "longitude": "26.33714000"
                    },
                    {
                        "id": 90464,
                        "name": "Bâscenii de Jos",
                        "latitude": "45.24708000",
                        "longitude": "26.32122000"
                    },
                    {
                        "id": 90465,
                        "name": "Bâscenii de Sus",
                        "latitude": "45.26662000",
                        "longitude": "26.27073000"
                    },
                    {
                        "id": 90075,
                        "name": "Beceni",
                        "latitude": "45.38333000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 90097,
                        "name": "Berca",
                        "latitude": "45.28333000",
                        "longitude": "26.68333000"
                    },
                    {
                        "id": 90142,
                        "name": "Bisoca",
                        "latitude": "45.53333000",
                        "longitude": "26.70000000"
                    },
                    {
                        "id": 90165,
                        "name": "Blăjani",
                        "latitude": "45.31667000",
                        "longitude": "26.81667000"
                    },
                    {
                        "id": 90169,
                        "name": "Boboc",
                        "latitude": "45.19570000",
                        "longitude": "26.98136000"
                    },
                    {
                        "id": 90211,
                        "name": "Boldu",
                        "latitude": "45.33333000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 90253,
                        "name": "Bozioru",
                        "latitude": "45.38333000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 90321,
                        "name": "Brădeanu",
                        "latitude": "44.93333000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 90330,
                        "name": "Brăeşti",
                        "latitude": "45.43333000",
                        "longitude": "26.50000000"
                    },
                    {
                        "id": 90285,
                        "name": "Breaza",
                        "latitude": "45.10000000",
                        "longitude": "26.53333000"
                    },
                    {
                        "id": 90374,
                        "name": "Buda",
                        "latitude": "45.50000000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 90421,
                        "name": "Burueneşti",
                        "latitude": "45.31667000",
                        "longitude": "26.35000000"
                    },
                    {
                        "id": 90435,
                        "name": "Buzău",
                        "latitude": "45.15000000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 90558,
                        "name": "C.a. Rosetti",
                        "latitude": "45.04622000",
                        "longitude": "27.16640000"
                    },
                    {
                        "id": 93834,
                        "name": "Căldărăști",
                        "latitude": "44.89375000",
                        "longitude": "27.03400000"
                    },
                    {
                        "id": 90566,
                        "name": "Calvini",
                        "latitude": "45.25000000",
                        "longitude": "26.30000000"
                    },
                    {
                        "id": 93856,
                        "name": "Căneşti",
                        "latitude": "45.40000000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 93865,
                        "name": "Căpățânești",
                        "latitude": "45.18333000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 90597,
                        "name": "Cașoca",
                        "latitude": "45.48914000",
                        "longitude": "26.26706000"
                    },
                    {
                        "id": 93877,
                        "name": "Cătina",
                        "latitude": "45.30000000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 90638,
                        "name": "Cernăteşti",
                        "latitude": "45.26667000",
                        "longitude": "26.76667000"
                    },
                    {
                        "id": 90668,
                        "name": "Chiliile",
                        "latitude": "45.45000000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 90674,
                        "name": "Chiojdu",
                        "latitude": "45.35000000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 90701,
                        "name": "Cilibia",
                        "latitude": "45.06667000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 90736,
                        "name": "Cislău",
                        "latitude": "45.25000000",
                        "longitude": "26.36667000"
                    },
                    {
                        "id": 90776,
                        "name": "Cochirleanca",
                        "latitude": "45.21667000",
                        "longitude": "27.03333000"
                    },
                    {
                        "id": 90802,
                        "name": "Colţi",
                        "latitude": "45.38333000",
                        "longitude": "26.38333000"
                    },
                    {
                        "id": 90863,
                        "name": "Comuna Amaru",
                        "latitude": "44.93770000",
                        "longitude": "26.59991000"
                    },
                    {
                        "id": 91223,
                        "name": "Comuna Bălăceanu",
                        "latitude": "45.24656000",
                        "longitude": "27.13604000"
                    },
                    {
                        "id": 90929,
                        "name": "Comuna Balta Albă",
                        "latitude": "45.26376000",
                        "longitude": "27.30558000"
                    },
                    {
                        "id": 90944,
                        "name": "Comuna Beceni",
                        "latitude": "45.38456000",
                        "longitude": "26.76978000"
                    },
                    {
                        "id": 90959,
                        "name": "Comuna Berca",
                        "latitude": "45.30098000",
                        "longitude": "26.65989000"
                    },
                    {
                        "id": 90994,
                        "name": "Comuna Bisoca",
                        "latitude": "45.54340000",
                        "longitude": "26.70591000"
                    },
                    {
                        "id": 91008,
                        "name": "Comuna Blăjani",
                        "latitude": "45.29964000",
                        "longitude": "26.81716000"
                    },
                    {
                        "id": 91039,
                        "name": "Comuna Boldu",
                        "latitude": "45.32267000",
                        "longitude": "27.24313000"
                    },
                    {
                        "id": 91067,
                        "name": "Comuna Bozioru",
                        "latitude": "45.38987000",
                        "longitude": "26.46770000"
                    },
                    {
                        "id": 91111,
                        "name": "Comuna Brădeanu",
                        "latitude": "44.89367000",
                        "longitude": "26.86105000"
                    },
                    {
                        "id": 91117,
                        "name": "Comuna Brăeşti",
                        "latitude": "45.44253000",
                        "longitude": "26.49487000"
                    },
                    {
                        "id": 91089,
                        "name": "Comuna Breaza",
                        "latitude": "45.09183000",
                        "longitude": "26.53240000"
                    },
                    {
                        "id": 91142,
                        "name": "Comuna Buda",
                        "latitude": "45.50907000",
                        "longitude": "26.90434000"
                    },
                    {
                        "id": 91251,
                        "name": "Comuna C.A. Rosetti",
                        "latitude": "45.03678000",
                        "longitude": "27.16722000"
                    },
                    {
                        "id": 91255,
                        "name": "Comuna Calvini",
                        "latitude": "45.24906000",
                        "longitude": "26.29982000"
                    },
                    {
                        "id": 91582,
                        "name": "Comuna Căneşti",
                        "latitude": "45.39711000",
                        "longitude": "26.60889000"
                    },
                    {
                        "id": 91593,
                        "name": "Comuna Cătina",
                        "latitude": "45.28747000",
                        "longitude": "26.24479000"
                    },
                    {
                        "id": 91296,
                        "name": "Comuna Cernăteşti",
                        "latitude": "45.29838000",
                        "longitude": "26.76260000"
                    },
                    {
                        "id": 91315,
                        "name": "Comuna Chiliile",
                        "latitude": "45.44784000",
                        "longitude": "26.59441000"
                    },
                    {
                        "id": 91320,
                        "name": "Comuna Chiojdu",
                        "latitude": "45.36671000",
                        "longitude": "26.21840000"
                    },
                    {
                        "id": 91336,
                        "name": "Comuna Cilibia",
                        "latitude": "45.05219000",
                        "longitude": "27.04337000"
                    },
                    {
                        "id": 91361,
                        "name": "Comuna Cislău",
                        "latitude": "45.22578000",
                        "longitude": "26.37954000"
                    },
                    {
                        "id": 91386,
                        "name": "Comuna Cochirleanca",
                        "latitude": "45.20146000",
                        "longitude": "27.01126000"
                    },
                    {
                        "id": 91402,
                        "name": "Comuna Colţi",
                        "latitude": "45.39105000",
                        "longitude": "26.40723000"
                    },
                    {
                        "id": 91455,
                        "name": "Comuna Costeşti",
                        "latitude": "45.06179000",
                        "longitude": "26.77321000"
                    },
                    {
                        "id": 91468,
                        "name": "Comuna Cozieni",
                        "latitude": "45.33240000",
                        "longitude": "26.49410000"
                    },
                    {
                        "id": 91773,
                        "name": "Comuna Florica",
                        "latitude": "44.90802000",
                        "longitude": "26.76627000"
                    },
                    {
                        "id": 91981,
                        "name": "Comuna Gălbinaşi",
                        "latitude": "45.07439000",
                        "longitude": "26.94363000"
                    },
                    {
                        "id": 91849,
                        "name": "Comuna Gherăseni",
                        "latitude": "45.02443000",
                        "longitude": "26.80069000"
                    },
                    {
                        "id": 91845,
                        "name": "Comuna Ghergheasa",
                        "latitude": "45.28915000",
                        "longitude": "27.19182000"
                    },
                    {
                        "id": 91882,
                        "name": "Comuna Glodeanu-Sărat",
                        "latitude": "44.87601000",
                        "longitude": "26.65897000"
                    },
                    {
                        "id": 91881,
                        "name": "Comuna Glodeanu-Siliştea",
                        "latitude": "44.83956000",
                        "longitude": "26.76757000"
                    },
                    {
                        "id": 91912,
                        "name": "Comuna Greabănu",
                        "latitude": "45.38794000",
                        "longitude": "26.96628000"
                    },
                    {
                        "id": 91952,
                        "name": "Comuna Gura Teghii",
                        "latitude": "45.50703000",
                        "longitude": "26.43441000"
                    },
                    {
                        "id": 92138,
                        "name": "Comuna Largu",
                        "latitude": "44.97448000",
                        "longitude": "27.16261000"
                    },
                    {
                        "id": 92184,
                        "name": "Comuna Lopătari",
                        "latitude": "45.48774000",
                        "longitude": "26.55233000"
                    },
                    {
                        "id": 92189,
                        "name": "Comuna Luciu",
                        "latitude": "44.97510000",
                        "longitude": "27.05781000"
                    },
                    {
                        "id": 92389,
                        "name": "Comuna Măgura",
                        "latitude": "45.26962000",
                        "longitude": "26.55104000"
                    },
                    {
                        "id": 92367,
                        "name": "Comuna Mânzăleşti",
                        "latitude": "45.50414000",
                        "longitude": "26.64561000"
                    },
                    {
                        "id": 92417,
                        "name": "Comuna Mărăcineni",
                        "latitude": "45.18902000",
                        "longitude": "26.79393000"
                    },
                    {
                        "id": 92409,
                        "name": "Comuna Mărgăriteşti",
                        "latitude": "45.43496000",
                        "longitude": "26.83619000"
                    },
                    {
                        "id": 92255,
                        "name": "Comuna Merei",
                        "latitude": "45.13102000",
                        "longitude": "26.66127000"
                    },
                    {
                        "id": 92285,
                        "name": "Comuna Mihăileşti",
                        "latitude": "44.92518000",
                        "longitude": "26.67330000"
                    },
                    {
                        "id": 92338,
                        "name": "Comuna Movila Banului",
                        "latitude": "44.97607000",
                        "longitude": "26.70299000"
                    },
                    {
                        "id": 92361,
                        "name": "Comuna Murgeşti",
                        "latitude": "45.40612000",
                        "longitude": "26.88883000"
                    },
                    {
                        "id": 92461,
                        "name": "Comuna Năeni",
                        "latitude": "45.09968000",
                        "longitude": "26.48944000"
                    },
                    {
                        "id": 92484,
                        "name": "Comuna Odăile",
                        "latitude": "45.38458000",
                        "longitude": "26.53966000"
                    },
                    {
                        "id": 92528,
                        "name": "Comuna Padina",
                        "latitude": "44.87082000",
                        "longitude": "27.11566000"
                    },
                    {
                        "id": 92720,
                        "name": "Comuna Pănătău",
                        "latitude": "45.30516000",
                        "longitude": "26.39159000"
                    },
                    {
                        "id": 92538,
                        "name": "Comuna Pardoşi",
                        "latitude": "45.44989000",
                        "longitude": "26.87934000"
                    },
                    {
                        "id": 92707,
                        "name": "Comuna Pârscov",
                        "latitude": "45.30760000",
                        "longitude": "26.55283000"
                    },
                    {
                        "id": 92580,
                        "name": "Comuna Pietroasele",
                        "latitude": "45.10357000",
                        "longitude": "26.59143000"
                    },
                    {
                        "id": 92614,
                        "name": "Comuna Podgoria",
                        "latitude": "45.45591000",
                        "longitude": "27.00626000"
                    },
                    {
                        "id": 92667,
                        "name": "Comuna Poşta Câlnãu",
                        "latitude": "45.24683000",
                        "longitude": "26.86785000"
                    },
                    {
                        "id": 92695,
                        "name": "Comuna Puieşti",
                        "latitude": "45.39338000",
                        "longitude": "27.20850000"
                    },
                    {
                        "id": 92738,
                        "name": "Comuna Racoviţeni",
                        "latitude": "45.35025000",
                        "longitude": "26.89919000"
                    },
                    {
                        "id": 92824,
                        "name": "Comuna Râmnicelu",
                        "latitude": "45.37840000",
                        "longitude": "27.13293000"
                    },
                    {
                        "id": 92774,
                        "name": "Comuna Robeasca",
                        "latitude": "45.14246000",
                        "longitude": "27.14697000"
                    },
                    {
                        "id": 92818,
                        "name": "Comuna Ruşeţu",
                        "latitude": "44.94214000",
                        "longitude": "27.21863000"
                    },
                    {
                        "id": 93089,
                        "name": "Comuna Săgeata",
                        "latitude": "45.10063000",
                        "longitude": "27.02496000"
                    },
                    {
                        "id": 93090,
                        "name": "Comuna Săhăteni",
                        "latitude": "45.02238000",
                        "longitude": "26.56344000"
                    },
                    {
                        "id": 93105,
                        "name": "Comuna Săpoca",
                        "latitude": "45.22290000",
                        "longitude": "26.75175000"
                    },
                    {
                        "id": 93108,
                        "name": "Comuna Săruleşti",
                        "latitude": "45.48304000",
                        "longitude": "26.77864000"
                    },
                    {
                        "id": 92896,
                        "name": "Comuna Scorţoasa",
                        "latitude": "45.36204000",
                        "longitude": "26.66176000"
                    },
                    {
                        "id": 92900,
                        "name": "Comuna Scutelnici",
                        "latitude": "44.83964000",
                        "longitude": "26.93747000"
                    },
                    {
                        "id": 92944,
                        "name": "Comuna Siriu",
                        "latitude": "45.50872000",
                        "longitude": "26.24470000"
                    },
                    {
                        "id": 92962,
                        "name": "Comuna Smeeni",
                        "latitude": "44.98816000",
                        "longitude": "26.91261000"
                    },
                    {
                        "id": 93013,
                        "name": "Comuna Stâlpu",
                        "latitude": "45.08519000",
                        "longitude": "26.70839000"
                    },
                    {
                        "id": 93576,
                        "name": "Comuna Ţinteşti",
                        "latitude": "45.07280000",
                        "longitude": "26.85786000"
                    },
                    {
                        "id": 93159,
                        "name": "Comuna Tisãu",
                        "latitude": "45.19337000",
                        "longitude": "26.57321000"
                    },
                    {
                        "id": 93176,
                        "name": "Comuna Topliceni",
                        "latitude": "45.44104000",
                        "longitude": "26.98210000"
                    },
                    {
                        "id": 93261,
                        "name": "Comuna Ulmeni",
                        "latitude": "45.06881000",
                        "longitude": "26.62364000"
                    },
                    {
                        "id": 93273,
                        "name": "Comuna Unguriu",
                        "latitude": "45.27963000",
                        "longitude": "26.64103000"
                    },
                    {
                        "id": 93294,
                        "name": "Comuna Vadu Paşii",
                        "latitude": "45.15743000",
                        "longitude": "26.88249000"
                    },
                    {
                        "id": 93428,
                        "name": "Comuna Vâlcelele",
                        "latitude": "45.34430000",
                        "longitude": "27.34937000"
                    },
                    {
                        "id": 93320,
                        "name": "Comuna Valea Râmnicului",
                        "latitude": "45.36174000",
                        "longitude": "27.04675000"
                    },
                    {
                        "id": 93324,
                        "name": "Comuna Valea Sălciei",
                        "latitude": "45.48818000",
                        "longitude": "26.82912000"
                    },
                    {
                        "id": 93346,
                        "name": "Comuna Verneşti",
                        "latitude": "45.20804000",
                        "longitude": "26.69650000"
                    },
                    {
                        "id": 93367,
                        "name": "Comuna Vintilă Vodă",
                        "latitude": "45.45461000",
                        "longitude": "26.72385000"
                    },
                    {
                        "id": 93369,
                        "name": "Comuna Vipereşti",
                        "latitude": "45.24643000",
                        "longitude": "26.44527000"
                    },
                    {
                        "id": 93489,
                        "name": "Comuna Zărneşti",
                        "latitude": "45.30951000",
                        "longitude": "26.88100000"
                    },
                    {
                        "id": 93476,
                        "name": "Comuna Ziduri",
                        "latitude": "45.28211000",
                        "longitude": "27.05974000"
                    },
                    {
                        "id": 93620,
                        "name": "Corbu",
                        "latitude": "45.32108000",
                        "longitude": "26.24936000"
                    },
                    {
                        "id": 93659,
                        "name": "Costeşti",
                        "latitude": "45.05000000",
                        "longitude": "26.76667000"
                    },
                    {
                        "id": 93700,
                        "name": "Coțatcu",
                        "latitude": "45.46643000",
                        "longitude": "27.01486000"
                    },
                    {
                        "id": 93684,
                        "name": "Cozieni",
                        "latitude": "45.33333000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 94106,
                        "name": "Dâmbroca",
                        "latitude": "45.12328000",
                        "longitude": "26.95578000"
                    },
                    {
                        "id": 94136,
                        "name": "Dăscălești",
                        "latitude": "45.40626000",
                        "longitude": "27.25039000"
                    },
                    {
                        "id": 93909,
                        "name": "Dedulești",
                        "latitude": "45.47003000",
                        "longitude": "26.96737000"
                    },
                    {
                        "id": 94189,
                        "name": "Florica",
                        "latitude": "44.90802000",
                        "longitude": "26.76627000"
                    },
                    {
                        "id": 94228,
                        "name": "Fundeni",
                        "latitude": "45.29141000",
                        "longitude": "26.88028000"
                    },
                    {
                        "id": 94234,
                        "name": "Furtunești",
                        "latitude": "45.45940000",
                        "longitude": "26.39760000"
                    },
                    {
                        "id": 94503,
                        "name": "Gălbinaşi",
                        "latitude": "45.08333000",
                        "longitude": "26.91667000"
                    },
                    {
                        "id": 94515,
                        "name": "Găvănești",
                        "latitude": "45.08825000",
                        "longitude": "27.06499000"
                    },
                    {
                        "id": 94313,
                        "name": "Gherăseni",
                        "latitude": "45.02589000",
                        "longitude": "26.79128000"
                    },
                    {
                        "id": 94305,
                        "name": "Ghergheasa",
                        "latitude": "45.26667000",
                        "longitude": "27.20000000"
                    },
                    {
                        "id": 94361,
                        "name": "Glodeanu-Sărat",
                        "latitude": "44.86667000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 94360,
                        "name": "Glodeanu-Siliştea",
                        "latitude": "44.83333000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 94442,
                        "name": "Grăjdana",
                        "latitude": "45.20865000",
                        "longitude": "26.63114000"
                    },
                    {
                        "id": 94404,
                        "name": "Grebănu",
                        "latitude": "45.38333000",
                        "longitude": "26.96667000"
                    },
                    {
                        "id": 94405,
                        "name": "Greceanca",
                        "latitude": "45.07863000",
                        "longitude": "26.54468000"
                    },
                    {
                        "id": 94432,
                        "name": "Grunji",
                        "latitude": "45.50000000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 94461,
                        "name": "Gura Teghii",
                        "latitude": "45.48333000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 94714,
                        "name": "Izvoru",
                        "latitude": "45.19249000",
                        "longitude": "26.59154000"
                    },
                    {
                        "id": 94719,
                        "name": "Izvoru Dulce",
                        "latitude": "45.34178000",
                        "longitude": "26.77730000"
                    },
                    {
                        "id": 94762,
                        "name": "Largu",
                        "latitude": "44.96667000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 94799,
                        "name": "Limpeziș",
                        "latitude": "44.95357000",
                        "longitude": "26.70490000"
                    },
                    {
                        "id": 94801,
                        "name": "Lipia",
                        "latitude": "45.13970000",
                        "longitude": "26.73505000"
                    },
                    {
                        "id": 94833,
                        "name": "Lopătari",
                        "latitude": "45.48333000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 94838,
                        "name": "Luciu",
                        "latitude": "44.96667000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 94858,
                        "name": "Lunca",
                        "latitude": "45.00494000",
                        "longitude": "27.21335000"
                    },
                    {
                        "id": 94866,
                        "name": "Lunca Jariștei",
                        "latitude": "45.48231000",
                        "longitude": "26.25483000"
                    },
                    {
                        "id": 94870,
                        "name": "Lunca Priporului",
                        "latitude": "45.43909000",
                        "longitude": "26.30869000"
                    },
                    {
                        "id": 95240,
                        "name": "Măgura",
                        "latitude": "45.26667000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 95216,
                        "name": "Mânzăleşti",
                        "latitude": "45.50000000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 95285,
                        "name": "Mărăcineni",
                        "latitude": "45.20000000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 95274,
                        "name": "Mărgăriteşti",
                        "latitude": "45.43333000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 95283,
                        "name": "Mărunțișu",
                        "latitude": "45.28610000",
                        "longitude": "26.35421000"
                    },
                    {
                        "id": 95288,
                        "name": "Mătești",
                        "latitude": "45.21339000",
                        "longitude": "26.75607000"
                    },
                    {
                        "id": 94939,
                        "name": "Maxenu",
                        "latitude": "45.05162000",
                        "longitude": "26.85498000"
                    },
                    {
                        "id": 94950,
                        "name": "Merei",
                        "latitude": "45.13333000",
                        "longitude": "26.68333000"
                    },
                    {
                        "id": 94994,
                        "name": "Mihăileşti",
                        "latitude": "44.91667000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 95080,
                        "name": "Movila Banului",
                        "latitude": "44.98333000",
                        "longitude": "26.68333000"
                    },
                    {
                        "id": 95119,
                        "name": "Municipiul Buzău",
                        "latitude": "45.15046000",
                        "longitude": "26.82136000"
                    },
                    {
                        "id": 95174,
                        "name": "Municipiul Râmnicu Sãrat",
                        "latitude": "45.38324000",
                        "longitude": "27.05162000"
                    },
                    {
                        "id": 95207,
                        "name": "Murgeşti",
                        "latitude": "45.40000000",
                        "longitude": "26.88333000"
                    },
                    {
                        "id": 95369,
                        "name": "Năeni",
                        "latitude": "45.10000000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 95325,
                        "name": "Nehoiu",
                        "latitude": "45.41667000",
                        "longitude": "26.30000000"
                    },
                    {
                        "id": 95411,
                        "name": "Odăile",
                        "latitude": "45.38333000",
                        "longitude": "26.55000000"
                    },
                    {
                        "id": 95551,
                        "name": "Oraş Nehoiu",
                        "latitude": "45.41538000",
                        "longitude": "26.32089000"
                    },
                    {
                        "id": 95576,
                        "name": "Oraş Pãtârlagele",
                        "latitude": "45.32035000",
                        "longitude": "26.34539000"
                    },
                    {
                        "id": 95570,
                        "name": "Oraş Pogoanele",
                        "latitude": "44.90555000",
                        "longitude": "27.01183000"
                    },
                    {
                        "id": 95656,
                        "name": "Oreavu",
                        "latitude": "45.36826000",
                        "longitude": "27.02301000"
                    },
                    {
                        "id": 95694,
                        "name": "Padina",
                        "latitude": "44.83333000",
                        "longitude": "27.11667000"
                    },
                    {
                        "id": 96012,
                        "name": "Păltineni",
                        "latitude": "45.39596000",
                        "longitude": "26.32334000"
                    },
                    {
                        "id": 96018,
                        "name": "Pănătău",
                        "latitude": "45.32113000",
                        "longitude": "26.39442000"
                    },
                    {
                        "id": 95712,
                        "name": "Pardoşi",
                        "latitude": "45.36667000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 96001,
                        "name": "Pârscov",
                        "latitude": "45.28333000",
                        "longitude": "26.55000000"
                    },
                    {
                        "id": 96026,
                        "name": "Pătârlagele",
                        "latitude": "45.32081000",
                        "longitude": "26.36134000"
                    },
                    {
                        "id": 95785,
                        "name": "Pietroasele",
                        "latitude": "45.10000000",
                        "longitude": "26.56667000"
                    },
                    {
                        "id": 95787,
                        "name": "Pietrosu",
                        "latitude": "45.05928000",
                        "longitude": "26.75827000"
                    },
                    {
                        "id": 95810,
                        "name": "Plevna",
                        "latitude": "45.37815000",
                        "longitude": "27.01310000"
                    },
                    {
                        "id": 95846,
                        "name": "Podgoria",
                        "latitude": "45.41667000",
                        "longitude": "27.01667000"
                    },
                    {
                        "id": 95855,
                        "name": "Pogoanele",
                        "latitude": "44.91667000",
                        "longitude": "27.00000000"
                    },
                    {
                        "id": 95856,
                        "name": "Pogonele",
                        "latitude": "45.08645000",
                        "longitude": "26.86454000"
                    },
                    {
                        "id": 95937,
                        "name": "Poşta Câlnău",
                        "latitude": "45.23333000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 95934,
                        "name": "Potoceni",
                        "latitude": "45.19660000",
                        "longitude": "26.77649000"
                    },
                    {
                        "id": 95980,
                        "name": "Puieștii de Jos",
                        "latitude": "45.40267000",
                        "longitude": "27.22013000"
                    },
                    {
                        "id": 96045,
                        "name": "Racoviţeni",
                        "latitude": "45.36667000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 96167,
                        "name": "Râmnicelu",
                        "latitude": "45.36381000",
                        "longitude": "27.11121000"
                    },
                    {
                        "id": 96170,
                        "name": "Râmnicu Sărat",
                        "latitude": "45.38333000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 96097,
                        "name": "Robeasca",
                        "latitude": "45.16667000",
                        "longitude": "27.13333000"
                    },
                    {
                        "id": 96143,
                        "name": "Rubla",
                        "latitude": "45.35300000",
                        "longitude": "27.07525000"
                    },
                    {
                        "id": 96163,
                        "name": "Ruşeţu",
                        "latitude": "44.95000000",
                        "longitude": "27.21667000"
                    },
                    {
                        "id": 106003,
                        "name": "Săgeata",
                        "latitude": "45.10000000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 106004,
                        "name": "Săhăteni",
                        "latitude": "45.03333000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 106009,
                        "name": "Sălcioara",
                        "latitude": "45.30874000",
                        "longitude": "27.17692000"
                    },
                    {
                        "id": 106027,
                        "name": "Săpoca",
                        "latitude": "45.25000000",
                        "longitude": "26.75000000"
                    },
                    {
                        "id": 106034,
                        "name": "Săruleşti",
                        "latitude": "45.50000000",
                        "longitude": "26.75000000"
                    },
                    {
                        "id": 96282,
                        "name": "Scorţoasa",
                        "latitude": "45.36403000",
                        "longitude": "26.66116000"
                    },
                    {
                        "id": 96289,
                        "name": "Scurtești",
                        "latitude": "45.13829000",
                        "longitude": "26.90397000"
                    },
                    {
                        "id": 96291,
                        "name": "Scutelnici",
                        "latitude": "44.85000000",
                        "longitude": "26.91667000"
                    },
                    {
                        "id": 96386,
                        "name": "Smeeni",
                        "latitude": "44.98333000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 96469,
                        "name": "Stâlpu",
                        "latitude": "45.08333000",
                        "longitude": "26.71667000"
                    },
                    {
                        "id": 96475,
                        "name": "Stăncești",
                        "latitude": "45.12665000",
                        "longitude": "26.92319000"
                    },
                    {
                        "id": 96494,
                        "name": "Sudiți",
                        "latitude": "45.26890000",
                        "longitude": "26.87183000"
                    },
                    {
                        "id": 96599,
                        "name": "Tăbărăști",
                        "latitude": "45.07948000",
                        "longitude": "26.91943000"
                    },
                    {
                        "id": 97108,
                        "name": "Ţinteşti",
                        "latitude": "45.06667000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 106131,
                        "name": "Topliceni",
                        "latitude": "45.41667000",
                        "longitude": "27.00000000"
                    },
                    {
                        "id": 96645,
                        "name": "Ulmeni",
                        "latitude": "45.06667000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 96664,
                        "name": "Unguriu",
                        "latitude": "45.27933000",
                        "longitude": "26.63208000"
                    },
                    {
                        "id": 96699,
                        "name": "Vadu Paşii",
                        "latitude": "45.16667000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 96702,
                        "name": "Vadu Sorești",
                        "latitude": "45.31500000",
                        "longitude": "26.87748000"
                    },
                    {
                        "id": 96921,
                        "name": "Vâlcele",
                        "latitude": "45.08692000",
                        "longitude": "26.63353000"
                    },
                    {
                        "id": 96923,
                        "name": "Vâlcelele",
                        "latitude": "45.34430000",
                        "longitude": "27.34937000"
                    },
                    {
                        "id": 96747,
                        "name": "Valea Părului",
                        "latitude": "45.36374000",
                        "longitude": "26.77706000"
                    },
                    {
                        "id": 96750,
                        "name": "Valea Râmnicului",
                        "latitude": "45.36395000",
                        "longitude": "27.04197000"
                    },
                    {
                        "id": 96751,
                        "name": "Valea Salciei",
                        "latitude": "45.49622000",
                        "longitude": "26.82361000"
                    },
                    {
                        "id": 96791,
                        "name": "Verneşti",
                        "latitude": "45.21667000",
                        "longitude": "26.73333000"
                    },
                    {
                        "id": 96836,
                        "name": "Vintilă Vodă",
                        "latitude": "45.46667000",
                        "longitude": "26.71667000"
                    },
                    {
                        "id": 96834,
                        "name": "Vintileanca",
                        "latitude": "44.98500000",
                        "longitude": "26.58005000"
                    },
                    {
                        "id": 96838,
                        "name": "Vipereşti",
                        "latitude": "45.23333000",
                        "longitude": "26.46667000"
                    },
                    {
                        "id": 97015,
                        "name": "Zărneşti",
                        "latitude": "45.30000000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 97017,
                        "name": "Zărneștii de Slănic",
                        "latitude": "45.27708000",
                        "longitude": "26.75549000"
                    },
                    {
                        "id": 96991,
                        "name": "Ziduri",
                        "latitude": "45.30000000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 97002,
                        "name": "Zorești",
                        "latitude": "45.18177000",
                        "longitude": "26.70291000"
                    }
                ]
            },
            {
                "id": 4732,
                "name": "Călărași",
                "iso2": "CL",
                "latitude": "44.36587150",
                "longitude": "26.75486070",
                "type": "department",
                "cities": [
                    {
                        "id": 89927,
                        "name": "Alexandru Odobescu",
                        "latitude": "44.26667000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 89975,
                        "name": "Aprozi",
                        "latitude": "44.26616000",
                        "longitude": "26.50213000"
                    },
                    {
                        "id": 90085,
                        "name": "Belciugatele",
                        "latitude": "44.48333000",
                        "longitude": "26.43333000"
                    },
                    {
                        "id": 90221,
                        "name": "Borcea",
                        "latitude": "44.33333000",
                        "longitude": "27.75000000"
                    },
                    {
                        "id": 90382,
                        "name": "Budeşti",
                        "latitude": "44.23472000",
                        "longitude": "26.46583000"
                    },
                    {
                        "id": 93848,
                        "name": "Călăraşi",
                        "latitude": "44.20510000",
                        "longitude": "27.31356000"
                    },
                    {
                        "id": 93874,
                        "name": "Căscioarele",
                        "latitude": "44.12611000",
                        "longitude": "26.46972000"
                    },
                    {
                        "id": 90598,
                        "name": "Ceacu",
                        "latitude": "44.26530000",
                        "longitude": "27.25213000"
                    },
                    {
                        "id": 90679,
                        "name": "Chirnogi",
                        "latitude": "44.11667000",
                        "longitude": "26.56667000"
                    },
                    {
                        "id": 90682,
                        "name": "Chiselet",
                        "latitude": "44.18333000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 90714,
                        "name": "Ciocăneşti",
                        "latitude": "44.20000000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 90779,
                        "name": "Coconi",
                        "latitude": "44.24769000",
                        "longitude": "26.88409000"
                    },
                    {
                        "id": 90849,
                        "name": "Comuna Alexandru Odobescu",
                        "latitude": "44.27254000",
                        "longitude": "27.09402000"
                    },
                    {
                        "id": 90950,
                        "name": "Comuna Belciugatele",
                        "latitude": "44.51160000",
                        "longitude": "26.44556000"
                    },
                    {
                        "id": 91046,
                        "name": "Comuna Borcea",
                        "latitude": "44.32356000",
                        "longitude": "27.71808000"
                    },
                    {
                        "id": 91591,
                        "name": "Comuna Căscioarele",
                        "latitude": "44.12731000",
                        "longitude": "26.46960000"
                    },
                    {
                        "id": 91322,
                        "name": "Comuna Chirnogi",
                        "latitude": "44.11064000",
                        "longitude": "26.57747000"
                    },
                    {
                        "id": 91325,
                        "name": "Comuna Chiselet",
                        "latitude": "44.16868000",
                        "longitude": "26.85603000"
                    },
                    {
                        "id": 91345,
                        "name": "Comuna Ciocăneşti",
                        "latitude": "44.19701000",
                        "longitude": "27.06530000"
                    },
                    {
                        "id": 91502,
                        "name": "Comuna Crivăţ",
                        "latitude": "44.19338000",
                        "longitude": "26.43846000"
                    },
                    {
                        "id": 91527,
                        "name": "Comuna Curcani",
                        "latitude": "44.20208000",
                        "longitude": "26.57632000"
                    },
                    {
                        "id": 91535,
                        "name": "Comuna Cuza Vodă",
                        "latitude": "44.26730000",
                        "longitude": "27.27113000"
                    },
                    {
                        "id": 91622,
                        "name": "Comuna Dichiseni",
                        "latitude": "44.23056000",
                        "longitude": "27.53466000"
                    },
                    {
                        "id": 91660,
                        "name": "Comuna Dor Mărunt",
                        "latitude": "44.44116000",
                        "longitude": "26.99417000"
                    },
                    {
                        "id": 91665,
                        "name": "Comuna Dorobanţu",
                        "latitude": "44.22324000",
                        "longitude": "26.95219000"
                    },
                    {
                        "id": 91670,
                        "name": "Comuna Dragalina",
                        "latitude": "44.44479000",
                        "longitude": "27.37537000"
                    },
                    {
                        "id": 91677,
                        "name": "Comuna Dragoş Vodă",
                        "latitude": "44.44836000",
                        "longitude": "27.15382000"
                    },
                    {
                        "id": 91792,
                        "name": "Comuna Frăsinet",
                        "latitude": "44.30798000",
                        "longitude": "26.82463000"
                    },
                    {
                        "id": 91786,
                        "name": "Comuna Frumuşani",
                        "latitude": "44.31716000",
                        "longitude": "26.30967000"
                    },
                    {
                        "id": 91799,
                        "name": "Comuna Fundeni",
                        "latitude": "44.38325000",
                        "longitude": "26.34968000"
                    },
                    {
                        "id": 91980,
                        "name": "Comuna Gălbinaşi",
                        "latitude": "44.31724000",
                        "longitude": "26.41941000"
                    },
                    {
                        "id": 91939,
                        "name": "Comuna Grădiştea",
                        "latitude": "44.21945000",
                        "longitude": "27.16160000"
                    },
                    {
                        "id": 91959,
                        "name": "Comuna Gurbăneşti",
                        "latitude": "44.37540000",
                        "longitude": "26.69277000"
                    },
                    {
                        "id": 92068,
                        "name": "Comuna Ileana",
                        "latitude": "44.52732000",
                        "longitude": "26.68993000"
                    },
                    {
                        "id": 92078,
                        "name": "Comuna Independenţa",
                        "latitude": "44.27922000",
                        "longitude": "27.16053000"
                    },
                    {
                        "id": 92117,
                        "name": "Comuna Jegălia",
                        "latitude": "44.29436000",
                        "longitude": "27.64286000"
                    },
                    {
                        "id": 92144,
                        "name": "Comuna Lehliu",
                        "latitude": "44.48828000",
                        "longitude": "26.82729000"
                    },
                    {
                        "id": 92194,
                        "name": "Comuna Luica",
                        "latitude": "44.24126000",
                        "longitude": "26.60071000"
                    },
                    {
                        "id": 92217,
                        "name": "Comuna Lupşanu",
                        "latitude": "44.38075000",
                        "longitude": "26.94842000"
                    },
                    {
                        "id": 92368,
                        "name": "Comuna Mânăstirea",
                        "latitude": "44.23953000",
                        "longitude": "26.87940000"
                    },
                    {
                        "id": 92308,
                        "name": "Comuna Mitreni",
                        "latitude": "44.16339000",
                        "longitude": "26.61454000"
                    },
                    {
                        "id": 92315,
                        "name": "Comuna Modelu",
                        "latitude": "44.19661000",
                        "longitude": "27.38960000"
                    },
                    {
                        "id": 92425,
                        "name": "Comuna Nana",
                        "latitude": "44.26771000",
                        "longitude": "26.59199000"
                    },
                    {
                        "id": 92441,
                        "name": "Comuna Nicolae Bălcescu",
                        "latitude": "44.44506000",
                        "longitude": "26.75839000"
                    },
                    {
                        "id": 92556,
                        "name": "Comuna Perişoru",
                        "latitude": "44.43266000",
                        "longitude": "27.50197000"
                    },
                    {
                        "id": 92606,
                        "name": "Comuna Plătăreşti",
                        "latitude": "44.34476000",
                        "longitude": "26.38255000"
                    },
                    {
                        "id": 92744,
                        "name": "Comuna Radovanu",
                        "latitude": "44.17671000",
                        "longitude": "26.53259000"
                    },
                    {
                        "id": 92791,
                        "name": "Comuna Roseţi",
                        "latitude": "44.21435000",
                        "longitude": "27.45085000"
                    },
                    {
                        "id": 93109,
                        "name": "Comuna Săruleşti",
                        "latitude": "44.41289000",
                        "longitude": "26.61657000"
                    },
                    {
                        "id": 92971,
                        "name": "Comuna Sohatu",
                        "latitude": "44.35549000",
                        "longitude": "26.52161000"
                    },
                    {
                        "id": 93539,
                        "name": "Comuna Şoldanu",
                        "latitude": "44.22675000",
                        "longitude": "26.51224000"
                    },
                    {
                        "id": 92980,
                        "name": "Comuna Spanţov",
                        "latitude": "44.13110000",
                        "longitude": "26.78896000"
                    },
                    {
                        "id": 93547,
                        "name": "Comuna Ştefan Cel Mare",
                        "latitude": "44.42593000",
                        "longitude": "27.63963000"
                    },
                    {
                        "id": 93548,
                        "name": "Comuna Ştefan Vodă",
                        "latitude": "44.33097000",
                        "longitude": "27.32505000"
                    },
                    {
                        "id": 93233,
                        "name": "Comuna Tãmãdãu Mare",
                        "latitude": "44.45951000",
                        "longitude": "26.57622000"
                    },
                    {
                        "id": 93260,
                        "name": "Comuna Ulmeni",
                        "latitude": "44.14587000",
                        "longitude": "26.72793000"
                    },
                    {
                        "id": 93265,
                        "name": "Comuna Ulmu",
                        "latitude": "44.28725000",
                        "longitude": "26.91814000"
                    },
                    {
                        "id": 93275,
                        "name": "Comuna Unirea",
                        "latitude": "44.25119000",
                        "longitude": "27.58278000"
                    },
                    {
                        "id": 93429,
                        "name": "Comuna Vâlcelele",
                        "latitude": "44.37457000",
                        "longitude": "27.16661000"
                    },
                    {
                        "id": 93298,
                        "name": "Comuna Valea Argovei",
                        "latitude": "44.34829000",
                        "longitude": "26.78180000"
                    },
                    {
                        "id": 93335,
                        "name": "Comuna Vasilaţi",
                        "latitude": "44.29143000",
                        "longitude": "26.42151000"
                    },
                    {
                        "id": 93381,
                        "name": "Comuna Vlad Ţepeş",
                        "latitude": "44.34482000",
                        "longitude": "27.08505000"
                    },
                    {
                        "id": 93593,
                        "name": "Constantin Brâncoveanu",
                        "latitude": "44.47842000",
                        "longitude": "27.41274000"
                    },
                    {
                        "id": 93731,
                        "name": "Crivăț",
                        "latitude": "44.19338000",
                        "longitude": "26.43846000"
                    },
                    {
                        "id": 93772,
                        "name": "Curcani",
                        "latitude": "44.20000000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 93784,
                        "name": "Cuza Vodă",
                        "latitude": "44.26667000",
                        "longitude": "27.26667000"
                    },
                    {
                        "id": 94103,
                        "name": "Dâlga-Gară",
                        "latitude": "44.43333000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 93933,
                        "name": "Dichiseni",
                        "latitude": "44.23333000",
                        "longitude": "27.53333000"
                    },
                    {
                        "id": 93995,
                        "name": "Dor Mărunt",
                        "latitude": "44.45000000",
                        "longitude": "26.91667000"
                    },
                    {
                        "id": 94001,
                        "name": "Dorobanţu",
                        "latitude": "44.21667000",
                        "longitude": "26.95000000"
                    },
                    {
                        "id": 94011,
                        "name": "Dragalina",
                        "latitude": "44.43333000",
                        "longitude": "27.31667000"
                    },
                    {
                        "id": 94023,
                        "name": "Dragoș Vodă",
                        "latitude": "44.43333000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 94025,
                        "name": "Drajna Nouă",
                        "latitude": "44.42262000",
                        "longitude": "27.38007000"
                    },
                    {
                        "id": 94217,
                        "name": "Frăsinet",
                        "latitude": "44.31667000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 94210,
                        "name": "Frumuşani",
                        "latitude": "44.29611000",
                        "longitude": "26.32556000"
                    },
                    {
                        "id": 94225,
                        "name": "Fundeni",
                        "latitude": "44.38333000",
                        "longitude": "26.35000000"
                    },
                    {
                        "id": 94231,
                        "name": "Fundulea",
                        "latitude": "44.46667000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 94504,
                        "name": "Gălbinași",
                        "latitude": "44.31724000",
                        "longitude": "26.41941000"
                    },
                    {
                        "id": 94477,
                        "name": "Gâldău",
                        "latitude": "44.30544000",
                        "longitude": "27.66972000"
                    },
                    {
                        "id": 94437,
                        "name": "Grădiştea",
                        "latitude": "44.23333000",
                        "longitude": "27.21667000"
                    },
                    {
                        "id": 94472,
                        "name": "Gurbăneşti",
                        "latitude": "44.38333000",
                        "longitude": "26.70000000"
                    },
                    {
                        "id": 94645,
                        "name": "Iezeru",
                        "latitude": "44.28617000",
                        "longitude": "27.62447000"
                    },
                    {
                        "id": 94654,
                        "name": "Ileana",
                        "latitude": "44.51667000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 94666,
                        "name": "Independenţa",
                        "latitude": "44.28333000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 94725,
                        "name": "Jegălia",
                        "latitude": "44.30000000",
                        "longitude": "27.63333000"
                    },
                    {
                        "id": 94769,
                        "name": "Lehliu",
                        "latitude": "44.46667000",
                        "longitude": "26.81667000"
                    },
                    {
                        "id": 94770,
                        "name": "Lehliu-Gară",
                        "latitude": "44.43333000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 94847,
                        "name": "Luica",
                        "latitude": "44.23333000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 94887,
                        "name": "Lupşanu",
                        "latitude": "44.38333000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 95217,
                        "name": "Mânăstirea",
                        "latitude": "44.21667000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 94979,
                        "name": "Mihai Viteazu",
                        "latitude": "44.34864000",
                        "longitude": "27.07361000"
                    },
                    {
                        "id": 95032,
                        "name": "Mitreni",
                        "latitude": "44.16667000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 95046,
                        "name": "Modelu",
                        "latitude": "44.19574000",
                        "longitude": "27.38720000"
                    },
                    {
                        "id": 95134,
                        "name": "Municipiul Călăraşi",
                        "latitude": "44.20000000",
                        "longitude": "27.33333000"
                    },
                    {
                        "id": 95161,
                        "name": "Municipiul Olteniţa",
                        "latitude": "44.09204000",
                        "longitude": "26.64183000"
                    },
                    {
                        "id": 95301,
                        "name": "Nana",
                        "latitude": "44.26667000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 95307,
                        "name": "Negoești",
                        "latitude": "44.23065000",
                        "longitude": "26.50151000"
                    },
                    {
                        "id": 95336,
                        "name": "Nicolae Bălcescu",
                        "latitude": "44.45000000",
                        "longitude": "26.76667000"
                    },
                    {
                        "id": 95433,
                        "name": "Olteniţa",
                        "latitude": "44.08333000",
                        "longitude": "26.63333000"
                    },
                    {
                        "id": 95474,
                        "name": "Oraş Budeşti",
                        "latitude": "44.24766000",
                        "longitude": "26.45099000"
                    },
                    {
                        "id": 95520,
                        "name": "Oraş Fundulea",
                        "latitude": "44.46456000",
                        "longitude": "26.49901000"
                    },
                    {
                        "id": 95537,
                        "name": "Oraş Lehliu Garã",
                        "latitude": "44.42178000",
                        "longitude": "26.86167000"
                    },
                    {
                        "id": 95737,
                        "name": "Perişoru",
                        "latitude": "44.45000000",
                        "longitude": "27.55000000"
                    },
                    {
                        "id": 95834,
                        "name": "Plătăreşti",
                        "latitude": "44.35000000",
                        "longitude": "26.36667000"
                    },
                    {
                        "id": 95927,
                        "name": "Potcoava",
                        "latitude": "44.26332000",
                        "longitude": "27.13223000"
                    },
                    {
                        "id": 95960,
                        "name": "Progresu",
                        "latitude": "44.35886000",
                        "longitude": "26.46110000"
                    },
                    {
                        "id": 96055,
                        "name": "Radovanu",
                        "latitude": "44.20000000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 96056,
                        "name": "Radu Vodă",
                        "latitude": "44.38563000",
                        "longitude": "26.92541000"
                    },
                    {
                        "id": 96060,
                        "name": "Rasa",
                        "latitude": "44.21404000",
                        "longitude": "27.14717000"
                    },
                    {
                        "id": 96217,
                        "name": "Răzvani",
                        "latitude": "44.42114000",
                        "longitude": "26.88092000"
                    },
                    {
                        "id": 96118,
                        "name": "Roseţi",
                        "latitude": "44.21482000",
                        "longitude": "27.44848000"
                    },
                    {
                        "id": 106028,
                        "name": "Săpunari",
                        "latitude": "44.50141000",
                        "longitude": "26.83665000"
                    },
                    {
                        "id": 106033,
                        "name": "Săruleşti",
                        "latitude": "44.41667000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 106035,
                        "name": "Sărulești-Gară",
                        "latitude": "44.44444000",
                        "longitude": "26.65780000"
                    },
                    {
                        "id": 96400,
                        "name": "Sohatu",
                        "latitude": "44.31667000",
                        "longitude": "26.50000000"
                    },
                    {
                        "id": 97068,
                        "name": "Şoldanu",
                        "latitude": "44.21667000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 96413,
                        "name": "Spanţov",
                        "latitude": "44.11667000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 96422,
                        "name": "Stancea",
                        "latitude": "44.13680000",
                        "longitude": "26.81226000"
                    },
                    {
                        "id": 97132,
                        "name": "Ștefan cel Mare",
                        "latitude": "44.42639000",
                        "longitude": "27.64556000"
                    },
                    {
                        "id": 97078,
                        "name": "Ştefan Vodă",
                        "latitude": "44.31667000",
                        "longitude": "27.31667000"
                    },
                    {
                        "id": 96501,
                        "name": "Sultana",
                        "latitude": "44.26062000",
                        "longitude": "26.85424000"
                    },
                    {
                        "id": 96606,
                        "name": "Tămădău Mare",
                        "latitude": "44.46667000",
                        "longitude": "26.55000000"
                    },
                    {
                        "id": 96647,
                        "name": "Ulmeni",
                        "latitude": "44.15000000",
                        "longitude": "26.71667000"
                    },
                    {
                        "id": 96651,
                        "name": "Ulmu",
                        "latitude": "44.26667000",
                        "longitude": "26.91667000"
                    },
                    {
                        "id": 96666,
                        "name": "Unirea",
                        "latitude": "44.26667000",
                        "longitude": "27.63333000"
                    },
                    {
                        "id": 96922,
                        "name": "Vâlcelele",
                        "latitude": "44.38834000",
                        "longitude": "27.15022000"
                    },
                    {
                        "id": 96708,
                        "name": "Valea Argovei",
                        "latitude": "44.35000000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 96749,
                        "name": "Valea Roșie",
                        "latitude": "44.17755000",
                        "longitude": "26.63457000"
                    },
                    {
                        "id": 96975,
                        "name": "Vărăști",
                        "latitude": "44.21244000",
                        "longitude": "26.97188000"
                    },
                    {
                        "id": 96775,
                        "name": "Vasilaţi",
                        "latitude": "44.28778000",
                        "longitude": "26.44750000"
                    },
                    {
                        "id": 96855,
                        "name": "Vlad Ţepeş",
                        "latitude": "44.35000000",
                        "longitude": "27.08333000"
                    }
                ]
            },
            {
                "id": 4753,
                "name": "Caraș-Severin",
                "iso2": "CS",
                "latitude": "45.11396460",
                "longitude": "22.07409930",
                "type": "department",
                "cities": [
                    {
                        "id": 89962,
                        "name": "Anina",
                        "latitude": "45.07944000",
                        "longitude": "21.85694000"
                    },
                    {
                        "id": 89995,
                        "name": "Armeniş",
                        "latitude": "45.20000000",
                        "longitude": "22.31667000"
                    },
                    {
                        "id": 90491,
                        "name": "Băile Herculane",
                        "latitude": "44.87972000",
                        "longitude": "22.41250000"
                    },
                    {
                        "id": 90535,
                        "name": "Bănia",
                        "latitude": "44.89583000",
                        "longitude": "22.04472000"
                    },
                    {
                        "id": 90555,
                        "name": "Băuţar",
                        "latitude": "45.51667000",
                        "longitude": "22.56667000"
                    },
                    {
                        "id": 90113,
                        "name": "Berlişte",
                        "latitude": "44.98667000",
                        "longitude": "21.46306000"
                    },
                    {
                        "id": 90117,
                        "name": "Berzasca",
                        "latitude": "44.64712000",
                        "longitude": "21.95428000"
                    },
                    {
                        "id": 90118,
                        "name": "Berzovia",
                        "latitude": "45.42611000",
                        "longitude": "21.62806000"
                    },
                    {
                        "id": 90178,
                        "name": "Bocşa",
                        "latitude": "45.37333000",
                        "longitude": "21.70917000"
                    },
                    {
                        "id": 90217,
                        "name": "Bolvașnița",
                        "latitude": "45.34558000",
                        "longitude": "22.31012000"
                    },
                    {
                        "id": 90229,
                        "name": "Borlova",
                        "latitude": "45.36738000",
                        "longitude": "22.35200000"
                    },
                    {
                        "id": 90254,
                        "name": "Bozovici",
                        "latitude": "44.93889000",
                        "longitude": "22.00167000"
                    },
                    {
                        "id": 90292,
                        "name": "Brebu",
                        "latitude": "45.42028000",
                        "longitude": "21.99250000"
                    },
                    {
                        "id": 90295,
                        "name": "Brebu Nou",
                        "latitude": "45.23333000",
                        "longitude": "22.13333000"
                    },
                    {
                        "id": 90348,
                        "name": "Buchin",
                        "latitude": "45.36667000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 90362,
                        "name": "Bucoşniţa",
                        "latitude": "45.30000000",
                        "longitude": "22.26667000"
                    },
                    {
                        "id": 90358,
                        "name": "Bucova",
                        "latitude": "45.50906000",
                        "longitude": "22.63731000"
                    },
                    {
                        "id": 93792,
                        "name": "Câlnic",
                        "latitude": "45.33844000",
                        "longitude": "21.85754000"
                    },
                    {
                        "id": 90575,
                        "name": "Caransebeş",
                        "latitude": "45.41667000",
                        "longitude": "22.21667000"
                    },
                    {
                        "id": 90578,
                        "name": "Caraşova",
                        "latitude": "45.19861000",
                        "longitude": "21.87000000"
                    },
                    {
                        "id": 93867,
                        "name": "Cărbunari",
                        "latitude": "44.83444000",
                        "longitude": "21.74417000"
                    },
                    {
                        "id": 90697,
                        "name": "Ciclova-Română",
                        "latitude": "45.01361000",
                        "longitude": "21.71917000"
                    },
                    {
                        "id": 90741,
                        "name": "Ciuchici",
                        "latitude": "44.94139000",
                        "longitude": "21.61000000"
                    },
                    {
                        "id": 90744,
                        "name": "Ciudanoviţa",
                        "latitude": "45.14472000",
                        "longitude": "21.79778000"
                    },
                    {
                        "id": 90769,
                        "name": "Clocotici",
                        "latitude": "45.24495000",
                        "longitude": "21.83467000"
                    },
                    {
                        "id": 90894,
                        "name": "Comuna Armeniş",
                        "latitude": "45.21901000",
                        "longitude": "22.35198000"
                    },
                    {
                        "id": 91233,
                        "name": "Comuna Bănia",
                        "latitude": "44.87200000",
                        "longitude": "22.02747000"
                    },
                    {
                        "id": 91248,
                        "name": "Comuna Băuţar",
                        "latitude": "45.53016000",
                        "longitude": "22.57848000"
                    },
                    {
                        "id": 90971,
                        "name": "Comuna Berlişte",
                        "latitude": "44.99004000",
                        "longitude": "21.46920000"
                    },
                    {
                        "id": 90975,
                        "name": "Comuna Berzasca",
                        "latitude": "44.64845000",
                        "longitude": "21.98580000"
                    },
                    {
                        "id": 90976,
                        "name": "Comuna Berzovia",
                        "latitude": "45.40777000",
                        "longitude": "21.60233000"
                    },
                    {
                        "id": 91043,
                        "name": "Comuna Bolvaşniţa",
                        "latitude": "45.33634000",
                        "longitude": "22.33110000"
                    },
                    {
                        "id": 91068,
                        "name": "Comuna Bozovici",
                        "latitude": "44.97815000",
                        "longitude": "21.97965000"
                    },
                    {
                        "id": 91092,
                        "name": "Comuna Brebu",
                        "latitude": "45.40358000",
                        "longitude": "22.01842000"
                    },
                    {
                        "id": 91094,
                        "name": "Comuna Brebu Nou",
                        "latitude": "45.23062000",
                        "longitude": "22.11809000"
                    },
                    {
                        "id": 91127,
                        "name": "Comuna Buchin",
                        "latitude": "45.34756000",
                        "longitude": "22.20877000"
                    },
                    {
                        "id": 91137,
                        "name": "Comuna Bucoşniţa",
                        "latitude": "45.30652000",
                        "longitude": "22.26856000"
                    },
                    {
                        "id": 91260,
                        "name": "Comuna Caraşova",
                        "latitude": "45.21545000",
                        "longitude": "21.88149000"
                    },
                    {
                        "id": 91587,
                        "name": "Comuna Cărbunari",
                        "latitude": "44.83985000",
                        "longitude": "21.74178000"
                    },
                    {
                        "id": 91333,
                        "name": "Comuna Ciclova Română",
                        "latitude": "44.97477000",
                        "longitude": "21.71425000"
                    },
                    {
                        "id": 91363,
                        "name": "Comuna Ciuchici",
                        "latitude": "44.93914000",
                        "longitude": "21.61419000"
                    },
                    {
                        "id": 91366,
                        "name": "Comuna Ciudanoviţa",
                        "latitude": "45.15308000",
                        "longitude": "21.75402000"
                    },
                    {
                        "id": 91413,
                        "name": "Comuna Constantin Daicoviciu",
                        "latitude": "45.51458000",
                        "longitude": "22.16374000"
                    },
                    {
                        "id": 91418,
                        "name": "Comuna Copăcele",
                        "latitude": "45.48036000",
                        "longitude": "22.08720000"
                    },
                    {
                        "id": 91435,
                        "name": "Comuna Cornea",
                        "latitude": "45.01953000",
                        "longitude": "22.31903000"
                    },
                    {
                        "id": 91436,
                        "name": "Comuna Cornereva",
                        "latitude": "45.06968000",
                        "longitude": "22.44671000"
                    },
                    {
                        "id": 91602,
                        "name": "Comuna Dalboşeţ",
                        "latitude": "44.84425000",
                        "longitude": "21.93495000"
                    },
                    {
                        "id": 91649,
                        "name": "Comuna Doclin",
                        "latitude": "45.32370000",
                        "longitude": "21.64622000"
                    },
                    {
                        "id": 91652,
                        "name": "Comuna Dognecea",
                        "latitude": "45.24797000",
                        "longitude": "21.72574000"
                    },
                    {
                        "id": 91657,
                        "name": "Comuna Domaşnea",
                        "latitude": "45.07577000",
                        "longitude": "22.33693000"
                    },
                    {
                        "id": 91747,
                        "name": "Comuna Eftimie Murgu",
                        "latitude": "44.87744000",
                        "longitude": "22.09522000"
                    },
                    {
                        "id": 91751,
                        "name": "Comuna Ezeriş",
                        "latitude": "45.38982000",
                        "longitude": "21.91754000"
                    },
                    {
                        "id": 91812,
                        "name": "Comuna Fârliug",
                        "latitude": "45.50025000",
                        "longitude": "21.85355000"
                    },
                    {
                        "id": 91778,
                        "name": "Comuna Forotic",
                        "latitude": "45.23159000",
                        "longitude": "21.57890000"
                    },
                    {
                        "id": 91976,
                        "name": "Comuna Gârnic",
                        "latitude": "44.75521000",
                        "longitude": "21.77168000"
                    },
                    {
                        "id": 91879,
                        "name": "Comuna Glimboca",
                        "latitude": "45.49499000",
                        "longitude": "22.32194000"
                    },
                    {
                        "id": 91905,
                        "name": "Comuna Goruia",
                        "latitude": "45.18298000",
                        "longitude": "21.77054000"
                    },
                    {
                        "id": 91936,
                        "name": "Comuna Grădinari",
                        "latitude": "45.10488000",
                        "longitude": "21.60576000"
                    },
                    {
                        "id": 92049,
                        "name": "Comuna Iablaniţa",
                        "latitude": "44.97480000",
                        "longitude": "22.29180000"
                    },
                    {
                        "id": 92223,
                        "name": "Comuna Lăpuşnicel",
                        "latitude": "44.98679000",
                        "longitude": "22.20710000"
                    },
                    {
                        "id": 92224,
                        "name": "Comuna Lăpuşnicu Mare",
                        "latitude": "44.88519000",
                        "longitude": "21.93321000"
                    },
                    {
                        "id": 92209,
                        "name": "Comuna Luncaviţa",
                        "latitude": "45.08520000",
                        "longitude": "22.25352000"
                    },
                    {
                        "id": 92214,
                        "name": "Comuna Lupac",
                        "latitude": "45.25215000",
                        "longitude": "21.80835000"
                    },
                    {
                        "id": 92241,
                        "name": "Comuna Marga",
                        "latitude": "45.51489000",
                        "longitude": "22.51537000"
                    },
                    {
                        "id": 92421,
                        "name": "Comuna Măureni",
                        "latitude": "45.43170000",
                        "longitude": "21.51348000"
                    },
                    {
                        "id": 92251,
                        "name": "Comuna Mehadia",
                        "latitude": "44.95509000",
                        "longitude": "22.37181000"
                    },
                    {
                        "id": 92252,
                        "name": "Comuna Mehadica",
                        "latitude": "45.03894000",
                        "longitude": "22.26476000"
                    },
                    {
                        "id": 92423,
                        "name": "Comuna Naidaş",
                        "latitude": "44.87584000",
                        "longitude": "21.56807000"
                    },
                    {
                        "id": 92471,
                        "name": "Comuna Obreja",
                        "latitude": "45.46873000",
                        "longitude": "22.25570000"
                    },
                    {
                        "id": 92477,
                        "name": "Comuna Ocna De Fier",
                        "latitude": "45.34195000",
                        "longitude": "21.77503000"
                    },
                    {
                        "id": 92711,
                        "name": "Comuna Pãltiniş",
                        "latitude": "45.40607000",
                        "longitude": "22.11233000"
                    },
                    {
                        "id": 92559,
                        "name": "Comuna Pescari",
                        "latitude": "44.67286000",
                        "longitude": "21.70092000"
                    },
                    {
                        "id": 92644,
                        "name": "Comuna Pojejena",
                        "latitude": "44.78437000",
                        "longitude": "21.53365000"
                    },
                    {
                        "id": 92674,
                        "name": "Comuna Prigor",
                        "latitude": "44.94774000",
                        "longitude": "22.12896000"
                    },
                    {
                        "id": 92841,
                        "name": "Comuna Răcăşdia",
                        "latitude": "44.99767000",
                        "longitude": "21.58786000"
                    },
                    {
                        "id": 92746,
                        "name": "Comuna Ramna",
                        "latitude": "45.46530000",
                        "longitude": "21.72257000"
                    },
                    {
                        "id": 92815,
                        "name": "Comuna Rusca Montană",
                        "latitude": "45.60042000",
                        "longitude": "22.43638000"
                    },
                    {
                        "id": 92857,
                        "name": "Comuna Sacu",
                        "latitude": "45.57152000",
                        "longitude": "22.11048000"
                    },
                    {
                        "id": 92877,
                        "name": "Comuna Sasca Montană",
                        "latitude": "44.90394000",
                        "longitude": "21.70167000"
                    },
                    {
                        "id": 92926,
                        "name": "Comuna Sicheviţa",
                        "latitude": "44.70616000",
                        "longitude": "21.82910000"
                    },
                    {
                        "id": 92948,
                        "name": "Comuna Slatina-Timiş",
                        "latitude": "45.26064000",
                        "longitude": "22.31807000"
                    },
                    {
                        "id": 92969,
                        "name": "Comuna Socol",
                        "latitude": "44.85334000",
                        "longitude": "21.41782000"
                    },
                    {
                        "id": 93541,
                        "name": "Comuna Şopotu Nou",
                        "latitude": "44.79650000",
                        "longitude": "21.85135000"
                    },
                    {
                        "id": 93229,
                        "name": "Comuna Târnova",
                        "latitude": "45.33274000",
                        "longitude": "21.96849000"
                    },
                    {
                        "id": 93141,
                        "name": "Comuna Teregova",
                        "latitude": "45.14536000",
                        "longitude": "22.31192000"
                    },
                    {
                        "id": 93150,
                        "name": "Comuna Ticvaniu Mare",
                        "latitude": "45.15901000",
                        "longitude": "21.65596000"
                    },
                    {
                        "id": 93175,
                        "name": "Comuna Topleţ",
                        "latitude": "44.80454000",
                        "longitude": "22.39102000"
                    },
                    {
                        "id": 93216,
                        "name": "Comuna Turnu Rueni",
                        "latitude": "45.39767000",
                        "longitude": "22.31756000"
                    },
                    {
                        "id": 93461,
                        "name": "Comuna Văliug",
                        "latitude": "45.22643000",
                        "longitude": "22.03169000"
                    },
                    {
                        "id": 93464,
                        "name": "Comuna Vărădia",
                        "latitude": "45.07166000",
                        "longitude": "21.54036000"
                    },
                    {
                        "id": 93345,
                        "name": "Comuna Vermeş",
                        "latitude": "45.52216000",
                        "longitude": "21.62988000"
                    },
                    {
                        "id": 93409,
                        "name": "Comuna Vrani",
                        "latitude": "45.02799000",
                        "longitude": "21.48549000"
                    },
                    {
                        "id": 93492,
                        "name": "Comuna Zăvoi",
                        "latitude": "45.49706000",
                        "longitude": "22.44346000"
                    },
                    {
                        "id": 93480,
                        "name": "Comuna Zorlenţu Mare",
                        "latitude": "45.46419000",
                        "longitude": "21.98155000"
                    },
                    {
                        "id": 93594,
                        "name": "Constantin Daicoviciu",
                        "latitude": "45.55000000",
                        "longitude": "22.15000000"
                    },
                    {
                        "id": 93603,
                        "name": "Copăcele",
                        "latitude": "45.50000000",
                        "longitude": "22.10000000"
                    },
                    {
                        "id": 93630,
                        "name": "Cornea",
                        "latitude": "45.03333000",
                        "longitude": "22.31667000"
                    },
                    {
                        "id": 93631,
                        "name": "Cornereva",
                        "latitude": "45.06667000",
                        "longitude": "22.41667000"
                    },
                    {
                        "id": 93642,
                        "name": "Cornuțel",
                        "latitude": "45.43489000",
                        "longitude": "22.09556000"
                    },
                    {
                        "id": 93649,
                        "name": "Coronini",
                        "latitude": "44.68004000",
                        "longitude": "21.68552000"
                    },
                    {
                        "id": 93890,
                        "name": "Dalboșeț",
                        "latitude": "44.86399000",
                        "longitude": "21.95854000"
                    },
                    {
                        "id": 93975,
                        "name": "Doclin",
                        "latitude": "45.29694000",
                        "longitude": "21.65389000"
                    },
                    {
                        "id": 93980,
                        "name": "Dognecea",
                        "latitude": "45.27417000",
                        "longitude": "21.75694000"
                    },
                    {
                        "id": 93988,
                        "name": "Domaşnea",
                        "latitude": "45.08333000",
                        "longitude": "22.31667000"
                    },
                    {
                        "id": 94139,
                        "name": "Eftimie Murgu",
                        "latitude": "44.90028000",
                        "longitude": "22.09278000"
                    },
                    {
                        "id": 94146,
                        "name": "Ezeriş",
                        "latitude": "45.41083000",
                        "longitude": "21.88583000"
                    },
                    {
                        "id": 94245,
                        "name": "Fârliug",
                        "latitude": "45.48833000",
                        "longitude": "21.84944000"
                    },
                    {
                        "id": 94182,
                        "name": "Fizeș",
                        "latitude": "45.36403000",
                        "longitude": "21.59517000"
                    },
                    {
                        "id": 94198,
                        "name": "Forotic",
                        "latitude": "45.23028000",
                        "longitude": "21.58750000"
                    },
                    {
                        "id": 94495,
                        "name": "Gârnic",
                        "latitude": "44.78639000",
                        "longitude": "21.79444000"
                    },
                    {
                        "id": 94311,
                        "name": "Gherteniș",
                        "latitude": "45.43315000",
                        "longitude": "21.58126000"
                    },
                    {
                        "id": 94357,
                        "name": "Glimboca",
                        "latitude": "45.48333000",
                        "longitude": "22.31667000"
                    },
                    {
                        "id": 94389,
                        "name": "Goruia",
                        "latitude": "45.18722000",
                        "longitude": "21.77917000"
                    },
                    {
                        "id": 94436,
                        "name": "Grădinari",
                        "latitude": "45.11861000",
                        "longitude": "21.59889000"
                    },
                    {
                        "id": 94411,
                        "name": "Greoni",
                        "latitude": "45.08901000",
                        "longitude": "21.61731000"
                    },
                    {
                        "id": 94613,
                        "name": "Iablaniţa",
                        "latitude": "44.95028000",
                        "longitude": "22.31417000"
                    },
                    {
                        "id": 94897,
                        "name": "Lăpuşnicel",
                        "latitude": "44.98306000",
                        "longitude": "22.22694000"
                    },
                    {
                        "id": 94898,
                        "name": "Lăpuşnicu Mare",
                        "latitude": "44.91306000",
                        "longitude": "21.94417000"
                    },
                    {
                        "id": 94812,
                        "name": "Liubcova",
                        "latitude": "44.65885000",
                        "longitude": "21.89559000"
                    },
                    {
                        "id": 94875,
                        "name": "Luncaviţa",
                        "latitude": "45.08333000",
                        "longitude": "22.26667000"
                    },
                    {
                        "id": 94883,
                        "name": "Lupac",
                        "latitude": "45.28000000",
                        "longitude": "21.81278000"
                    },
                    {
                        "id": 94927,
                        "name": "Marga",
                        "latitude": "45.50000000",
                        "longitude": "22.51667000"
                    },
                    {
                        "id": 95281,
                        "name": "Măru",
                        "latitude": "45.47586000",
                        "longitude": "22.45039000"
                    },
                    {
                        "id": 95292,
                        "name": "Măureni",
                        "latitude": "45.40389000",
                        "longitude": "21.50250000"
                    },
                    {
                        "id": 94945,
                        "name": "Mehadia",
                        "latitude": "44.90083000",
                        "longitude": "22.36694000"
                    },
                    {
                        "id": 94946,
                        "name": "Mehadica",
                        "latitude": "45.03333000",
                        "longitude": "22.26667000"
                    },
                    {
                        "id": 95061,
                        "name": "Moldova Nouă",
                        "latitude": "44.73750000",
                        "longitude": "21.66694000"
                    },
                    {
                        "id": 95124,
                        "name": "Municipiul Caransebeş",
                        "latitude": "45.43476000",
                        "longitude": "22.20358000"
                    },
                    {
                        "id": 95171,
                        "name": "Municipiul Reşiţa",
                        "latitude": "45.29838000",
                        "longitude": "21.91192000"
                    },
                    {
                        "id": 95198,
                        "name": "Muntele Mic",
                        "latitude": "45.38333000",
                        "longitude": "22.33333000"
                    },
                    {
                        "id": 95298,
                        "name": "Naidăș",
                        "latitude": "44.88108000",
                        "longitude": "21.59061000"
                    },
                    {
                        "id": 95387,
                        "name": "Obreja",
                        "latitude": "45.48333000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 95449,
                        "name": "Oraş Anina",
                        "latitude": "45.07683000",
                        "longitude": "21.85213000"
                    },
                    {
                        "id": 95483,
                        "name": "Oraş Bãile Herculane",
                        "latitude": "44.87326000",
                        "longitude": "22.41613000"
                    },
                    {
                        "id": 95464,
                        "name": "Oraş Bocşa",
                        "latitude": "45.37570000",
                        "longitude": "21.71483000"
                    },
                    {
                        "id": 95560,
                        "name": "Oraş Oraviţa",
                        "latitude": "45.05918000",
                        "longitude": "21.70739000"
                    },
                    {
                        "id": 95563,
                        "name": "Oraş Oţelu Roşu",
                        "latitude": "45.51638000",
                        "longitude": "22.38135000"
                    },
                    {
                        "id": 95446,
                        "name": "Oraviţa",
                        "latitude": "45.03250000",
                        "longitude": "21.68944000"
                    },
                    {
                        "id": 95690,
                        "name": "Oţelu Roşu",
                        "latitude": "45.53333000",
                        "longitude": "22.36667000"
                    },
                    {
                        "id": 95695,
                        "name": "Padina Matei",
                        "latitude": "44.75843000",
                        "longitude": "21.75067000"
                    },
                    {
                        "id": 96013,
                        "name": "Păltiniş",
                        "latitude": "45.43333000",
                        "longitude": "22.15000000"
                    },
                    {
                        "id": 95757,
                        "name": "Petroșnița",
                        "latitude": "45.32351000",
                        "longitude": "22.25920000"
                    },
                    {
                        "id": 95832,
                        "name": "Plugova",
                        "latitude": "44.96250000",
                        "longitude": "22.35864000"
                    },
                    {
                        "id": 95897,
                        "name": "Pojejena",
                        "latitude": "44.77417000",
                        "longitude": "21.57917000"
                    },
                    {
                        "id": 95951,
                        "name": "Prigor",
                        "latitude": "44.93833000",
                        "longitude": "22.11333000"
                    },
                    {
                        "id": 96192,
                        "name": "Răcăşdia",
                        "latitude": "44.99306000",
                        "longitude": "21.61806000"
                    },
                    {
                        "id": 96058,
                        "name": "Ramna",
                        "latitude": "45.43833000",
                        "longitude": "21.68833000"
                    },
                    {
                        "id": 96091,
                        "name": "Reşiţa",
                        "latitude": "45.30083000",
                        "longitude": "21.88917000"
                    },
                    {
                        "id": 96158,
                        "name": "Rusca",
                        "latitude": "45.14517000",
                        "longitude": "22.33859000"
                    },
                    {
                        "id": 96159,
                        "name": "Rusca Montană",
                        "latitude": "45.56741000",
                        "longitude": "22.45816000"
                    },
                    {
                        "id": 96222,
                        "name": "Sacu",
                        "latitude": "45.56667000",
                        "longitude": "22.11667000"
                    },
                    {
                        "id": 96248,
                        "name": "Sasca Montană",
                        "latitude": "44.88546000",
                        "longitude": "21.70915000"
                    },
                    {
                        "id": 96334,
                        "name": "Sicheviţa",
                        "latitude": "44.73500000",
                        "longitude": "21.84861000"
                    },
                    {
                        "id": 96363,
                        "name": "Slatina-Timiş",
                        "latitude": "45.25000000",
                        "longitude": "22.28333000"
                    },
                    {
                        "id": 96397,
                        "name": "Socol",
                        "latitude": "44.86083000",
                        "longitude": "21.37028000"
                    },
                    {
                        "id": 97071,
                        "name": "Şopotu Nou",
                        "latitude": "44.84194000",
                        "longitude": "21.86278000"
                    },
                    {
                        "id": 96424,
                        "name": "Steierdorf",
                        "latitude": "45.06359000",
                        "longitude": "21.85216000"
                    },
                    {
                        "id": 96596,
                        "name": "Târnova",
                        "latitude": "45.34250000",
                        "longitude": "22.00611000"
                    },
                    {
                        "id": 106084,
                        "name": "Teregova",
                        "latitude": "45.15000000",
                        "longitude": "22.28333000"
                    },
                    {
                        "id": 106095,
                        "name": "Ticvaniu Mare",
                        "latitude": "45.13528000",
                        "longitude": "21.63806000"
                    },
                    {
                        "id": 106130,
                        "name": "Topleţ",
                        "latitude": "44.79722000",
                        "longitude": "22.39444000"
                    },
                    {
                        "id": 96567,
                        "name": "Turnu Ruieni",
                        "latitude": "45.39070000",
                        "longitude": "22.33557000"
                    },
                    {
                        "id": 96711,
                        "name": "Valea Bolvașnița",
                        "latitude": "44.94602000",
                        "longitude": "22.39019000"
                    },
                    {
                        "id": 96967,
                        "name": "Văliug",
                        "latitude": "45.23333000",
                        "longitude": "22.03333000"
                    },
                    {
                        "id": 96972,
                        "name": "Vărădia",
                        "latitude": "45.07833000",
                        "longitude": "21.54694000"
                    },
                    {
                        "id": 96937,
                        "name": "Vârciorova",
                        "latitude": "45.32710000",
                        "longitude": "22.35208000"
                    },
                    {
                        "id": 96786,
                        "name": "Verendin",
                        "latitude": "45.07755000",
                        "longitude": "22.23917000"
                    },
                    {
                        "id": 96789,
                        "name": "Vermeş",
                        "latitude": "45.52056000",
                        "longitude": "21.65972000"
                    },
                    {
                        "id": 96896,
                        "name": "Vrani",
                        "latitude": "45.03833000",
                        "longitude": "21.49250000"
                    },
                    {
                        "id": 97022,
                        "name": "Zăvoi",
                        "latitude": "45.51667000",
                        "longitude": "22.41667000"
                    },
                    {
                        "id": 97005,
                        "name": "Zorlenţu Mare",
                        "latitude": "45.45056000",
                        "longitude": "21.95611000"
                    }
                ]
            },
            {
                "id": 4734,
                "name": "Cluj",
                "iso2": "CJ",
                "latitude": "46.79417970",
                "longitude": "23.61214920",
                "type": "department",
                "cities": [
                    {
                        "id": 89894,
                        "name": "Aghireșu",
                        "latitude": "46.87209000",
                        "longitude": "23.23773000"
                    },
                    {
                        "id": 89895,
                        "name": "Aghireșu-Fabrici",
                        "latitude": "46.86690000",
                        "longitude": "23.27129000"
                    },
                    {
                        "id": 89906,
                        "name": "Aiton",
                        "latitude": "46.68333000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 89941,
                        "name": "Aluniş",
                        "latitude": "47.03333000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 89969,
                        "name": "Apahida",
                        "latitude": "46.81667000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 90014,
                        "name": "Aşchileu Dorna",
                        "latitude": "46.98333000",
                        "longitude": "23.48333000"
                    },
                    {
                        "id": 90022,
                        "name": "Baciu",
                        "latitude": "46.80000000",
                        "longitude": "23.51667000"
                    },
                    {
                        "id": 90496,
                        "name": "Băişoara",
                        "latitude": "46.58333000",
                        "longitude": "23.46667000"
                    },
                    {
                        "id": 90091,
                        "name": "Beliş",
                        "latitude": "46.65000000",
                        "longitude": "23.03333000"
                    },
                    {
                        "id": 90174,
                        "name": "Bobâlna",
                        "latitude": "47.14385000",
                        "longitude": "23.64461000"
                    },
                    {
                        "id": 90192,
                        "name": "Bogdăneşti",
                        "latitude": "46.63333000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 90219,
                        "name": "Bonțida",
                        "latitude": "46.91550000",
                        "longitude": "23.81475000"
                    },
                    {
                        "id": 90239,
                        "name": "Borşa",
                        "latitude": "46.93333000",
                        "longitude": "23.66667000"
                    },
                    {
                        "id": 90430,
                        "name": "Buza",
                        "latitude": "46.90000000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 93825,
                        "name": "Căianu",
                        "latitude": "46.78460000",
                        "longitude": "23.91850000"
                    },
                    {
                        "id": 93826,
                        "name": "Căianu Mic",
                        "latitude": "46.78333000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 93851,
                        "name": "Călăraşi",
                        "latitude": "46.48333000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 93852,
                        "name": "Călăţele",
                        "latitude": "46.76667000",
                        "longitude": "23.01667000"
                    },
                    {
                        "id": 93854,
                        "name": "Cămăraşu",
                        "latitude": "46.78333000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 93797,
                        "name": "Câmpia Turzii",
                        "latitude": "46.55000000",
                        "longitude": "23.88333000"
                    },
                    {
                        "id": 93861,
                        "name": "Căpuşu Mare",
                        "latitude": "46.78333000",
                        "longitude": "23.30000000"
                    },
                    {
                        "id": 93885,
                        "name": "Căşeiu",
                        "latitude": "47.18333000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 93822,
                        "name": "Câţcău",
                        "latitude": "47.20000000",
                        "longitude": "23.78333000"
                    },
                    {
                        "id": 93879,
                        "name": "Cătina",
                        "latitude": "46.85000000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 90602,
                        "name": "Ceanu Mare",
                        "latitude": "46.66667000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 90669,
                        "name": "Chinteni",
                        "latitude": "46.86667000",
                        "longitude": "23.53333000"
                    },
                    {
                        "id": 90685,
                        "name": "Chiuiești",
                        "latitude": "47.29686000",
                        "longitude": "23.87553000"
                    },
                    {
                        "id": 90740,
                        "name": "Ciucea",
                        "latitude": "46.95000000",
                        "longitude": "22.81667000"
                    },
                    {
                        "id": 90758,
                        "name": "Ciurila",
                        "latitude": "46.65000000",
                        "longitude": "23.55000000"
                    },
                    {
                        "id": 90771,
                        "name": "Cluj-Napoca",
                        "latitude": "46.76667000",
                        "longitude": "23.60000000"
                    },
                    {
                        "id": 90790,
                        "name": "Cojocna",
                        "latitude": "46.75000000",
                        "longitude": "23.83333000"
                    },
                    {
                        "id": 90830,
                        "name": "Comuna Aghireşu",
                        "latitude": "46.87785000",
                        "longitude": "23.25320000"
                    },
                    {
                        "id": 90836,
                        "name": "Comuna Aiton",
                        "latitude": "46.68275000",
                        "longitude": "23.71608000"
                    },
                    {
                        "id": 90860,
                        "name": "Comuna Aluniş",
                        "latitude": "47.05595000",
                        "longitude": "23.74365000"
                    },
                    {
                        "id": 90876,
                        "name": "Comuna Apahida",
                        "latitude": "46.78296000",
                        "longitude": "23.74433000"
                    },
                    {
                        "id": 90910,
                        "name": "Comuna Aşchileu",
                        "latitude": "46.98498000",
                        "longitude": "23.48468000"
                    },
                    {
                        "id": 90914,
                        "name": "Comuna Baciu",
                        "latitude": "46.82010000",
                        "longitude": "23.49036000"
                    },
                    {
                        "id": 91208,
                        "name": "Comuna Băişoara",
                        "latitude": "46.58331000",
                        "longitude": "23.39349000"
                    },
                    {
                        "id": 90955,
                        "name": "Comuna Beliş",
                        "latitude": "46.65246000",
                        "longitude": "22.95213000"
                    },
                    {
                        "id": 91013,
                        "name": "Comuna Bobâlna",
                        "latitude": "47.13319000",
                        "longitude": "23.65163000"
                    },
                    {
                        "id": 91044,
                        "name": "Comuna Bonţida",
                        "latitude": "46.90036000",
                        "longitude": "23.82228000"
                    },
                    {
                        "id": 91057,
                        "name": "Comuna Borşa",
                        "latitude": "46.92402000",
                        "longitude": "23.64940000"
                    },
                    {
                        "id": 91178,
                        "name": "Comuna Buza",
                        "latitude": "46.90492000",
                        "longitude": "24.18041000"
                    },
                    {
                        "id": 91567,
                        "name": "Comuna Căianu",
                        "latitude": "46.80670000",
                        "longitude": "23.90883000"
                    },
                    {
                        "id": 91578,
                        "name": "Comuna Călăraşi",
                        "latitude": "46.49376000",
                        "longitude": "23.85359000"
                    },
                    {
                        "id": 91579,
                        "name": "Comuna Călăţele",
                        "latitude": "46.76282000",
                        "longitude": "23.03046000"
                    },
                    {
                        "id": 91580,
                        "name": "Comuna Cămăraşu",
                        "latitude": "46.78695000",
                        "longitude": "24.11369000"
                    },
                    {
                        "id": 91564,
                        "name": "Comuna Cãpuşu Mare",
                        "latitude": "46.78746000",
                        "longitude": "23.23462000"
                    },
                    {
                        "id": 91598,
                        "name": "Comuna Căşeiu",
                        "latitude": "47.23810000",
                        "longitude": "23.86404000"
                    },
                    {
                        "id": 91558,
                        "name": "Comuna Câţcău",
                        "latitude": "47.23058000",
                        "longitude": "23.79331000"
                    },
                    {
                        "id": 91594,
                        "name": "Comuna Cătina",
                        "latitude": "46.85179000",
                        "longitude": "24.16497000"
                    },
                    {
                        "id": 91273,
                        "name": "Comuna Ceanu Mare",
                        "latitude": "46.65324000",
                        "longitude": "23.94586000"
                    },
                    {
                        "id": 91316,
                        "name": "Comuna Chinteni",
                        "latitude": "46.88822000",
                        "longitude": "23.55319000"
                    },
                    {
                        "id": 91327,
                        "name": "Comuna Chiuieşti",
                        "latitude": "47.32292000",
                        "longitude": "23.92016000"
                    },
                    {
                        "id": 91362,
                        "name": "Comuna Ciucea",
                        "latitude": "46.95981000",
                        "longitude": "22.84363000"
                    },
                    {
                        "id": 91376,
                        "name": "Comuna Ciurila",
                        "latitude": "46.63372000",
                        "longitude": "23.53979000"
                    },
                    {
                        "id": 91395,
                        "name": "Comuna Cojocna",
                        "latitude": "46.72137000",
                        "longitude": "23.83949000"
                    },
                    {
                        "id": 91438,
                        "name": "Comuna Corneşti",
                        "latitude": "47.02811000",
                        "longitude": "23.68500000"
                    },
                    {
                        "id": 91537,
                        "name": "Comuna Cuzdrioara",
                        "latitude": "47.18274000",
                        "longitude": "23.93248000"
                    },
                    {
                        "id": 91731,
                        "name": "Comuna Dăbâca",
                        "latitude": "46.96989000",
                        "longitude": "23.69456000"
                    },
                    {
                        "id": 91756,
                        "name": "Comuna Feleacu",
                        "latitude": "46.70345000",
                        "longitude": "23.64021000"
                    },
                    {
                        "id": 91769,
                        "name": "Comuna Fizeşu Gherlii",
                        "latitude": "46.99442000",
                        "longitude": "23.94727000"
                    },
                    {
                        "id": 91770,
                        "name": "Comuna Floreşti",
                        "latitude": "46.73375000",
                        "longitude": "23.47861000"
                    },
                    {
                        "id": 91780,
                        "name": "Comuna Frata",
                        "latitude": "46.69878000",
                        "longitude": "24.05385000"
                    },
                    {
                        "id": 91967,
                        "name": "Comuna Gârbãu",
                        "latitude": "46.84059000",
                        "longitude": "23.37049000"
                    },
                    {
                        "id": 91835,
                        "name": "Comuna Geaca",
                        "latitude": "46.88141000",
                        "longitude": "24.06256000"
                    },
                    {
                        "id": 91868,
                        "name": "Comuna Gilău",
                        "latitude": "46.72607000",
                        "longitude": "23.34909000"
                    },
                    {
                        "id": 92055,
                        "name": "Comuna Iara",
                        "latitude": "46.54268000",
                        "longitude": "23.52749000"
                    },
                    {
                        "id": 92059,
                        "name": "Comuna Iclod",
                        "latitude": "46.99174000",
                        "longitude": "23.81618000"
                    },
                    {
                        "id": 92112,
                        "name": "Comuna Izvoru Crişului",
                        "latitude": "46.84542000",
                        "longitude": "23.10025000"
                    },
                    {
                        "id": 92120,
                        "name": "Comuna Jichişu De Jos",
                        "latitude": "47.12028000",
                        "longitude": "23.76788000"
                    },
                    {
                        "id": 92132,
                        "name": "Comuna Jucu",
                        "latitude": "46.84958000",
                        "longitude": "23.80953000"
                    },
                    {
                        "id": 92197,
                        "name": "Comuna Luna",
                        "latitude": "46.47522000",
                        "longitude": "23.94928000"
                    },
                    {
                        "id": 92375,
                        "name": "Comuna Mãguri-Rãcãtãu",
                        "latitude": "46.63948000",
                        "longitude": "23.19485000"
                    },
                    {
                        "id": 92371,
                        "name": "Comuna Mânăstireni",
                        "latitude": "46.79131000",
                        "longitude": "23.09871000"
                    },
                    {
                        "id": 92410,
                        "name": "Comuna Mărgău",
                        "latitude": "46.75677000",
                        "longitude": "22.94429000"
                    },
                    {
                        "id": 92411,
                        "name": "Comuna Mărişel",
                        "latitude": "46.68422000",
                        "longitude": "23.11466000"
                    },
                    {
                        "id": 92263,
                        "name": "Comuna Mica",
                        "latitude": "47.14436000",
                        "longitude": "23.97593000"
                    },
                    {
                        "id": 92273,
                        "name": "Comuna Mihai Viteazu",
                        "latitude": "46.53477000",
                        "longitude": "23.71595000"
                    },
                    {
                        "id": 92293,
                        "name": "Comuna Mintiu Gherlii",
                        "latitude": "47.07323000",
                        "longitude": "23.92731000"
                    },
                    {
                        "id": 92314,
                        "name": "Comuna Mociu",
                        "latitude": "46.79232000",
                        "longitude": "24.02853000"
                    },
                    {
                        "id": 92325,
                        "name": "Comuna Moldoveneşti",
                        "latitude": "46.47350000",
                        "longitude": "23.68905000"
                    },
                    {
                        "id": 92431,
                        "name": "Comuna Negreni",
                        "latitude": "46.95224000",
                        "longitude": "22.75835000"
                    },
                    {
                        "id": 92710,
                        "name": "Comuna Pãlatca",
                        "latitude": "46.87358000",
                        "longitude": "23.98288000"
                    },
                    {
                        "id": 92535,
                        "name": "Comuna Panticeu",
                        "latitude": "47.04079000",
                        "longitude": "23.55639000"
                    },
                    {
                        "id": 92564,
                        "name": "Comuna Petreştii De Jos",
                        "latitude": "46.58162000",
                        "longitude": "23.62191000"
                    },
                    {
                        "id": 92602,
                        "name": "Comuna Ploscoş",
                        "latitude": "46.66066000",
                        "longitude": "23.84322000"
                    },
                    {
                        "id": 92640,
                        "name": "Comuna Poieni",
                        "latitude": "46.88361000",
                        "longitude": "22.86041000"
                    },
                    {
                        "id": 92829,
                        "name": "Comuna Râșca",
                        "latitude": "46.73082000",
                        "longitude": "23.15413000"
                    },
                    {
                        "id": 92756,
                        "name": "Comuna Recea Cristur",
                        "latitude": "47.12155000",
                        "longitude": "23.54554000"
                    },
                    {
                        "id": 93074,
                        "name": "Comuna Sãcuieu",
                        "latitude": "46.81600000",
                        "longitude": "22.86010000"
                    },
                    {
                        "id": 93050,
                        "name": "Comuna Sâncraiu",
                        "latitude": "46.83410000",
                        "longitude": "22.99135000"
                    },
                    {
                        "id": 93103,
                        "name": "Comuna Sănduleşti",
                        "latitude": "46.58887000",
                        "longitude": "23.73049000"
                    },
                    {
                        "id": 93060,
                        "name": "Comuna Sânmărtin",
                        "latitude": "47.00708000",
                        "longitude": "24.07336000"
                    },
                    {
                        "id": 93062,
                        "name": "Comuna Sânpaul",
                        "latitude": "46.89597000",
                        "longitude": "23.41731000"
                    },
                    {
                        "id": 93119,
                        "name": "Comuna Săvădisla",
                        "latitude": "46.66540000",
                        "longitude": "23.44808000"
                    },
                    {
                        "id": 92925,
                        "name": "Comuna Sic",
                        "latitude": "46.93134000",
                        "longitude": "23.89615000"
                    },
                    {
                        "id": 93023,
                        "name": "Comuna Suatu",
                        "latitude": "46.75372000",
                        "longitude": "23.95820000"
                    },
                    {
                        "id": 93567,
                        "name": "Comuna Ţaga",
                        "latitude": "46.95100000",
                        "longitude": "24.02605000"
                    },
                    {
                        "id": 93194,
                        "name": "Comuna Tritenii De Jos",
                        "latitude": "46.58735000",
                        "longitude": "24.00139000"
                    },
                    {
                        "id": 93213,
                        "name": "Comuna Tureni",
                        "latitude": "46.63917000",
                        "longitude": "23.67684000"
                    },
                    {
                        "id": 93270,
                        "name": "Comuna Unguraş",
                        "latitude": "47.11667000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 93289,
                        "name": "Comuna Vad",
                        "latitude": "47.20634000",
                        "longitude": "23.71403000"
                    },
                    {
                        "id": 93307,
                        "name": "Comuna Valea Ierii",
                        "latitude": "46.64086000",
                        "longitude": "23.31997000"
                    },
                    {
                        "id": 93358,
                        "name": "Comuna Viişoara",
                        "latitude": "46.55377000",
                        "longitude": "23.93583000"
                    },
                    {
                        "id": 93416,
                        "name": "Comuna Vultureni",
                        "latitude": "46.95597000",
                        "longitude": "23.56762000"
                    },
                    {
                        "id": 93605,
                        "name": "Copăceni",
                        "latitude": "46.59675000",
                        "longitude": "23.73886000"
                    },
                    {
                        "id": 93634,
                        "name": "Corneşti",
                        "latitude": "47.03333000",
                        "longitude": "23.68333000"
                    },
                    {
                        "id": 93788,
                        "name": "Cuzdrioara",
                        "latitude": "47.16667000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 94115,
                        "name": "Dăbâca",
                        "latitude": "46.98333000",
                        "longitude": "23.66667000"
                    },
                    {
                        "id": 93910,
                        "name": "Dej",
                        "latitude": "47.15000000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 93931,
                        "name": "Dezmir",
                        "latitude": "46.76475000",
                        "longitude": "23.72451000"
                    },
                    {
                        "id": 94154,
                        "name": "Feleacu",
                        "latitude": "46.71667000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 94181,
                        "name": "Fizeşu Gherlii",
                        "latitude": "47.01667000",
                        "longitude": "23.98333000"
                    },
                    {
                        "id": 94185,
                        "name": "Floreşti",
                        "latitude": "46.74574000",
                        "longitude": "23.49375000"
                    },
                    {
                        "id": 94202,
                        "name": "Frata",
                        "latitude": "46.70000000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 94485,
                        "name": "Gârbău",
                        "latitude": "46.83305000",
                        "longitude": "23.35240000"
                    },
                    {
                        "id": 94285,
                        "name": "Geaca",
                        "latitude": "46.86667000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 94304,
                        "name": "Gheorghieni",
                        "latitude": "46.71393000",
                        "longitude": "23.68853000"
                    },
                    {
                        "id": 94308,
                        "name": "Gherla",
                        "latitude": "47.03333000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 94344,
                        "name": "Gilău",
                        "latitude": "46.73245000",
                        "longitude": "23.36174000"
                    },
                    {
                        "id": 94572,
                        "name": "Huedin",
                        "latitude": "46.86667000",
                        "longitude": "23.05000000"
                    },
                    {
                        "id": 94624,
                        "name": "Iara",
                        "latitude": "46.55000000",
                        "longitude": "23.51667000"
                    },
                    {
                        "id": 94634,
                        "name": "Iclod",
                        "latitude": "46.98333000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 94718,
                        "name": "Izvoru Crişului",
                        "latitude": "46.83333000",
                        "longitude": "23.10000000"
                    },
                    {
                        "id": 94731,
                        "name": "Jichişu de Jos",
                        "latitude": "47.11667000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 94851,
                        "name": "Luna",
                        "latitude": "46.50659000",
                        "longitude": "23.91959000"
                    },
                    {
                        "id": 94852,
                        "name": "Luna de Sus",
                        "latitude": "46.74313000",
                        "longitude": "23.43539000"
                    },
                    {
                        "id": 94874,
                        "name": "Luncani",
                        "latitude": "46.47274000",
                        "longitude": "23.95095000"
                    },
                    {
                        "id": 95246,
                        "name": "Măguri",
                        "latitude": "46.62849000",
                        "longitude": "23.10294000"
                    },
                    {
                        "id": 95247,
                        "name": "Măguri-Răcătău",
                        "latitude": "46.64500000",
                        "longitude": "23.19700000"
                    },
                    {
                        "id": 95219,
                        "name": "Mânăstireni",
                        "latitude": "46.76667000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 95275,
                        "name": "Mărgău",
                        "latitude": "46.75000000",
                        "longitude": "22.96667000"
                    },
                    {
                        "id": 95276,
                        "name": "Mărişel",
                        "latitude": "46.65000000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 94948,
                        "name": "Mera",
                        "latitude": "46.81525000",
                        "longitude": "23.45405000"
                    },
                    {
                        "id": 94964,
                        "name": "Mica",
                        "latitude": "47.13333000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 94980,
                        "name": "Mihai Viteazu",
                        "latitude": "46.53333000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 95009,
                        "name": "Mintiu Gherlii",
                        "latitude": "47.05000000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 95045,
                        "name": "Mociu",
                        "latitude": "46.80000000",
                        "longitude": "24.03333000"
                    },
                    {
                        "id": 95063,
                        "name": "Moldoveneşti",
                        "latitude": "46.50000000",
                        "longitude": "23.65000000"
                    },
                    {
                        "id": 95130,
                        "name": "Municipiul Câmpia Turzii",
                        "latitude": "46.54417000",
                        "longitude": "23.88472000"
                    },
                    {
                        "id": 95126,
                        "name": "Municipiul Cluj-Napoca",
                        "latitude": "46.77791000",
                        "longitude": "23.60512000"
                    },
                    {
                        "id": 95135,
                        "name": "Municipiul Dej",
                        "latitude": "47.12783000",
                        "longitude": "23.87504000"
                    },
                    {
                        "id": 95146,
                        "name": "Municipiul Gherla",
                        "latitude": "47.01431000",
                        "longitude": "23.88134000"
                    },
                    {
                        "id": 95189,
                        "name": "Municipiul Turda",
                        "latitude": "46.57456000",
                        "longitude": "23.78574000"
                    },
                    {
                        "id": 95314,
                        "name": "Negreni",
                        "latitude": "46.95378000",
                        "longitude": "22.76347000"
                    },
                    {
                        "id": 95347,
                        "name": "Nireș",
                        "latitude": "47.11499000",
                        "longitude": "23.98092000"
                    },
                    {
                        "id": 95394,
                        "name": "Ocna Dejului",
                        "latitude": "47.11581000",
                        "longitude": "23.85934000"
                    },
                    {
                        "id": 95530,
                        "name": "Oraş Huedin",
                        "latitude": "46.87204000",
                        "longitude": "23.03935000"
                    },
                    {
                        "id": 96010,
                        "name": "Pădureni",
                        "latitude": "46.59316000",
                        "longitude": "24.02700000"
                    },
                    {
                        "id": 96011,
                        "name": "Pălatca",
                        "latitude": "46.85000000",
                        "longitude": "23.98333000"
                    },
                    {
                        "id": 95709,
                        "name": "Panticeu",
                        "latitude": "47.03333000",
                        "longitude": "23.56667000"
                    },
                    {
                        "id": 95748,
                        "name": "Petreştii de Jos",
                        "latitude": "46.58333000",
                        "longitude": "23.65000000"
                    },
                    {
                        "id": 95828,
                        "name": "Ploscoș",
                        "latitude": "46.64303000",
                        "longitude": "23.84663000"
                    },
                    {
                        "id": 95891,
                        "name": "Poieni",
                        "latitude": "46.91880000",
                        "longitude": "22.85826000"
                    },
                    {
                        "id": 96179,
                        "name": "Râșca",
                        "latitude": "46.73967000",
                        "longitude": "23.10625000"
                    },
                    {
                        "id": 96205,
                        "name": "Răscruci",
                        "latitude": "46.90569000",
                        "longitude": "23.76860000"
                    },
                    {
                        "id": 96072,
                        "name": "Recea Cristur",
                        "latitude": "47.06667000",
                        "longitude": "23.53333000"
                    },
                    {
                        "id": 96150,
                        "name": "Rugășești",
                        "latitude": "47.23147000",
                        "longitude": "23.87326000"
                    },
                    {
                        "id": 105998,
                        "name": "Săcuieu",
                        "latitude": "46.82335000",
                        "longitude": "22.88824000"
                    },
                    {
                        "id": 96526,
                        "name": "Sâncraiu",
                        "latitude": "46.83333000",
                        "longitude": "22.98333000"
                    },
                    {
                        "id": 106026,
                        "name": "Sănduleşti",
                        "latitude": "46.58333000",
                        "longitude": "23.71667000"
                    },
                    {
                        "id": 96537,
                        "name": "Sânmărghita",
                        "latitude": "47.15649000",
                        "longitude": "23.99461000"
                    },
                    {
                        "id": 96538,
                        "name": "Sânmărtin",
                        "latitude": "46.90000000",
                        "longitude": "23.56667000"
                    },
                    {
                        "id": 96539,
                        "name": "Sânnicoară",
                        "latitude": "46.78990000",
                        "longitude": "23.72570000"
                    },
                    {
                        "id": 96542,
                        "name": "Sânpaul",
                        "latitude": "46.88333000",
                        "longitude": "23.41667000"
                    },
                    {
                        "id": 106049,
                        "name": "Săvădisla",
                        "latitude": "46.68333000",
                        "longitude": "23.45000000"
                    },
                    {
                        "id": 96333,
                        "name": "Sic",
                        "latitude": "46.93333000",
                        "longitude": "23.88333000"
                    },
                    {
                        "id": 96411,
                        "name": "Soporu de Câmpie",
                        "latitude": "46.69618000",
                        "longitude": "24.00658000"
                    },
                    {
                        "id": 96485,
                        "name": "Suatu",
                        "latitude": "46.76667000",
                        "longitude": "23.96667000"
                    },
                    {
                        "id": 96487,
                        "name": "Suceagu",
                        "latitude": "46.78432000",
                        "longitude": "23.46511000"
                    },
                    {
                        "id": 97099,
                        "name": "Ţaga",
                        "latitude": "46.95000000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 106158,
                        "name": "Tritenii de Jos",
                        "latitude": "46.58333000",
                        "longitude": "24.00000000"
                    },
                    {
                        "id": 106159,
                        "name": "Tritenii de Sus",
                        "latitude": "46.60544000",
                        "longitude": "23.99849000"
                    },
                    {
                        "id": 96558,
                        "name": "Turda",
                        "latitude": "46.56667000",
                        "longitude": "23.78333000"
                    },
                    {
                        "id": 96561,
                        "name": "Tureni",
                        "latitude": "46.62934000",
                        "longitude": "23.70240000"
                    },
                    {
                        "id": 96657,
                        "name": "Unguraş",
                        "latitude": "47.11667000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 96672,
                        "name": "Urca",
                        "latitude": "46.54885000",
                        "longitude": "23.96187000"
                    },
                    {
                        "id": 96694,
                        "name": "Vad",
                        "latitude": "47.20000000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 96704,
                        "name": "Vaida-Cămăraș",
                        "latitude": "46.82823000",
                        "longitude": "23.94724000"
                    },
                    {
                        "id": 96727,
                        "name": "Valea Ierii",
                        "latitude": "46.65000000",
                        "longitude": "23.35000000"
                    },
                    {
                        "id": 96820,
                        "name": "Viişoara",
                        "latitude": "46.55000000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 96907,
                        "name": "Vultureni",
                        "latitude": "46.96667000",
                        "longitude": "23.56667000"
                    }
                ]
            },
            {
                "id": 4737,
                "name": "Constanța",
                "iso2": "CT",
                "latitude": "44.21298700",
                "longitude": "28.25500550",
                "type": "department",
                "cities": [
                    {
                        "id": 89872,
                        "name": "23 August",
                        "latitude": "43.91667000",
                        "longitude": "28.58333000"
                    },
                    {
                        "id": 89879,
                        "name": "Adamclisi",
                        "latitude": "44.08333000",
                        "longitude": "27.95000000"
                    },
                    {
                        "id": 89896,
                        "name": "Agigea",
                        "latitude": "44.09258000",
                        "longitude": "28.61079000"
                    },
                    {
                        "id": 89917,
                        "name": "Albeşti",
                        "latitude": "43.80000000",
                        "longitude": "28.41667000"
                    },
                    {
                        "id": 89931,
                        "name": "Aliman",
                        "latitude": "44.18333000",
                        "longitude": "27.85000000"
                    },
                    {
                        "id": 89950,
                        "name": "Amzacea",
                        "latitude": "43.95000000",
                        "longitude": "28.40000000"
                    },
                    {
                        "id": 90532,
                        "name": "Băneasa",
                        "latitude": "44.06667000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 90546,
                        "name": "Bărăganu",
                        "latitude": "44.08939000",
                        "longitude": "28.41980000"
                    },
                    {
                        "id": 90584,
                        "name": "Castelu",
                        "latitude": "44.25000000",
                        "longitude": "28.33333000"
                    },
                    {
                        "id": 90623,
                        "name": "Cerchezu",
                        "latitude": "43.81667000",
                        "longitude": "28.10000000"
                    },
                    {
                        "id": 90630,
                        "name": "Cernavodă",
                        "latitude": "44.33957000",
                        "longitude": "28.03273000"
                    },
                    {
                        "id": 90678,
                        "name": "Chirnogeni",
                        "latitude": "43.90000000",
                        "longitude": "28.23333000"
                    },
                    {
                        "id": 90705,
                        "name": "Ciobanu",
                        "latitude": "44.71759000",
                        "longitude": "27.98698000"
                    },
                    {
                        "id": 90711,
                        "name": "Ciocârlia",
                        "latitude": "44.10000000",
                        "longitude": "28.28333000"
                    },
                    {
                        "id": 90712,
                        "name": "Ciocârlia de Sus",
                        "latitude": "44.11712000",
                        "longitude": "28.33402000"
                    },
                    {
                        "id": 90775,
                        "name": "Cobadin",
                        "latitude": "44.08333000",
                        "longitude": "28.21667000"
                    },
                    {
                        "id": 90787,
                        "name": "Cogealac",
                        "latitude": "44.55000000",
                        "longitude": "28.56667000"
                    },
                    {
                        "id": 90804,
                        "name": "Comana",
                        "latitude": "43.90000000",
                        "longitude": "28.31667000"
                    },
                    {
                        "id": 90817,
                        "name": "Comuna 23 August",
                        "latitude": "43.91938000",
                        "longitude": "28.55437000"
                    },
                    {
                        "id": 90821,
                        "name": "Comuna Adamclisi",
                        "latitude": "44.11447000",
                        "longitude": "27.94990000"
                    },
                    {
                        "id": 90831,
                        "name": "Comuna Agigea",
                        "latitude": "44.09654000",
                        "longitude": "28.62684000"
                    },
                    {
                        "id": 90842,
                        "name": "Comuna Albeşti",
                        "latitude": "43.80863000",
                        "longitude": "28.40325000"
                    },
                    {
                        "id": 90852,
                        "name": "Comuna Aliman",
                        "latitude": "44.18430000",
                        "longitude": "27.83697000"
                    },
                    {
                        "id": 90864,
                        "name": "Comuna Amzacea",
                        "latitude": "43.95983000",
                        "longitude": "28.32122000"
                    },
                    {
                        "id": 91242,
                        "name": "Comuna Bărăganu",
                        "latitude": "44.07931000",
                        "longitude": "28.39887000"
                    },
                    {
                        "id": 91264,
                        "name": "Comuna Castelu",
                        "latitude": "44.25846000",
                        "longitude": "28.36908000"
                    },
                    {
                        "id": 91288,
                        "name": "Comuna Cerchezu",
                        "latitude": "43.84984000",
                        "longitude": "28.08444000"
                    },
                    {
                        "id": 91321,
                        "name": "Comuna Chirnogeni",
                        "latitude": "43.94216000",
                        "longitude": "28.22195000"
                    },
                    {
                        "id": 91339,
                        "name": "Comuna Ciobanu",
                        "latitude": "44.71771000",
                        "longitude": "27.98904000"
                    },
                    {
                        "id": 91344,
                        "name": "Comuna Ciocârlia",
                        "latitude": "44.11098000",
                        "longitude": "28.31161000"
                    },
                    {
                        "id": 91384,
                        "name": "Comuna Cobadin",
                        "latitude": "44.02574000",
                        "longitude": "28.16695000"
                    },
                    {
                        "id": 91393,
                        "name": "Comuna Cogealac",
                        "latitude": "44.57661000",
                        "longitude": "28.52244000"
                    },
                    {
                        "id": 91403,
                        "name": "Comuna Comana",
                        "latitude": "43.89963000",
                        "longitude": "28.35491000"
                    },
                    {
                        "id": 91429,
                        "name": "Comuna Corbu",
                        "latitude": "44.40319000",
                        "longitude": "28.67797000"
                    },
                    {
                        "id": 91459,
                        "name": "Comuna Costineşti",
                        "latitude": "43.94780000",
                        "longitude": "28.63284000"
                    },
                    {
                        "id": 91508,
                        "name": "Comuna Crucea",
                        "latitude": "44.55046000",
                        "longitude": "28.20592000"
                    },
                    {
                        "id": 91524,
                        "name": "Comuna Cumpăna",
                        "latitude": "44.10747000",
                        "longitude": "28.51226000"
                    },
                    {
                        "id": 91534,
                        "name": "Comuna Cuza Voda",
                        "latitude": "44.28773000",
                        "longitude": "28.31005000"
                    },
                    {
                        "id": 91609,
                        "name": "Comuna Deleni",
                        "latitude": "44.06175000",
                        "longitude": "28.02263000"
                    },
                    {
                        "id": 93583,
                        "name": "Comună Dobromir",
                        "latitude": "44.01813000",
                        "longitude": "27.83888000"
                    },
                    {
                        "id": 91716,
                        "name": "Comuna Dumbrăveni",
                        "latitude": "43.93127000",
                        "longitude": "27.99112000"
                    },
                    {
                        "id": 91806,
                        "name": "Comuna Fântânele",
                        "latitude": "44.61278000",
                        "longitude": "28.57655000"
                    },
                    {
                        "id": 91975,
                        "name": "Comuna Gârliciu",
                        "latitude": "44.77933000",
                        "longitude": "28.09461000"
                    },
                    {
                        "id": 91860,
                        "name": "Comuna Ghindăreşti",
                        "latitude": "44.63520000",
                        "longitude": "28.03193000"
                    },
                    {
                        "id": 91935,
                        "name": "Comuna Grădina",
                        "latitude": "44.52298000",
                        "longitude": "28.44846000"
                    },
                    {
                        "id": 92017,
                        "name": "Comuna Horia",
                        "latitude": "44.63551000",
                        "longitude": "28.12034000"
                    },
                    {
                        "id": 92079,
                        "name": "Comuna Independenţa",
                        "latitude": "43.96020000",
                        "longitude": "28.06290000"
                    },
                    {
                        "id": 92081,
                        "name": "Comuna Ion Corvin",
                        "latitude": "44.10717000",
                        "longitude": "27.80268000"
                    },
                    {
                        "id": 92094,
                        "name": "Comuna Istria",
                        "latitude": "44.55487000",
                        "longitude": "28.68155000"
                    },
                    {
                        "id": 92165,
                        "name": "Comuna Limanu",
                        "latitude": "43.78024000",
                        "longitude": "28.53931000"
                    },
                    {
                        "id": 92166,
                        "name": "Comuna Lipniţa",
                        "latitude": "44.09073000",
                        "longitude": "27.56683000"
                    },
                    {
                        "id": 92196,
                        "name": "Comuna Lumina",
                        "latitude": "44.32756000",
                        "longitude": "28.54709000"
                    },
                    {
                        "id": 92258,
                        "name": "Comuna Mereni",
                        "latitude": "44.01545000",
                        "longitude": "28.33559000"
                    },
                    {
                        "id": 92274,
                        "name": "Comuna Mihai Viteazu",
                        "latitude": "44.63727000",
                        "longitude": "28.70460000"
                    },
                    {
                        "id": 92277,
                        "name": "Comuna Mihail Kogălniceanu",
                        "latitude": "44.40479000",
                        "longitude": "28.51919000"
                    },
                    {
                        "id": 92296,
                        "name": "Comuna Mircea Vodă",
                        "latitude": "44.30137000",
                        "longitude": "28.18647000"
                    },
                    {
                        "id": 92440,
                        "name": "Comuna Nicolae Bălcescu",
                        "latitude": "44.39829000",
                        "longitude": "28.35323000"
                    },
                    {
                        "id": 92498,
                        "name": "Comuna Oltina",
                        "latitude": "44.13879000",
                        "longitude": "27.64881000"
                    },
                    {
                        "id": 92518,
                        "name": "Comuna Ostrov",
                        "latitude": "44.08152000",
                        "longitude": "27.42046000"
                    },
                    {
                        "id": 92534,
                        "name": "Comuna Pantelimon",
                        "latitude": "44.60047000",
                        "longitude": "28.36014000"
                    },
                    {
                        "id": 92544,
                        "name": "Comuna Pecineaga",
                        "latitude": "43.88676000",
                        "longitude": "28.51012000"
                    },
                    {
                        "id": 92570,
                        "name": "Comuna Peştera",
                        "latitude": "44.18951000",
                        "longitude": "28.10722000"
                    },
                    {
                        "id": 92607,
                        "name": "Comuna Poarta Albă",
                        "latitude": "44.21622000",
                        "longitude": "28.41904000"
                    },
                    {
                        "id": 92748,
                        "name": "Comuna Rasova",
                        "latitude": "44.25918000",
                        "longitude": "27.96962000"
                    },
                    {
                        "id": 93082,
                        "name": "Comuna Săcele",
                        "latitude": "44.48866000",
                        "longitude": "28.66382000"
                    },
                    {
                        "id": 92867,
                        "name": "Comuna Saligny",
                        "latitude": "44.28318000",
                        "longitude": "28.08929000"
                    },
                    {
                        "id": 92873,
                        "name": "Comuna Saraiu",
                        "latitude": "44.71747000",
                        "longitude": "28.14732000"
                    },
                    {
                        "id": 92919,
                        "name": "Comuna Seimeni",
                        "latitude": "44.40184000",
                        "longitude": "28.08756000"
                    },
                    {
                        "id": 92931,
                        "name": "Comuna Siliştea",
                        "latitude": "44.42359000",
                        "longitude": "28.20967000"
                    },
                    {
                        "id": 93225,
                        "name": "Comuna Târguşor",
                        "latitude": "44.47713000",
                        "longitude": "28.38821000"
                    },
                    {
                        "id": 93173,
                        "name": "Comuna Topalu",
                        "latitude": "44.52116000",
                        "longitude": "28.07081000"
                    },
                    {
                        "id": 93181,
                        "name": "Comuna Topraisar",
                        "latitude": "44.03126000",
                        "longitude": "28.48845000"
                    },
                    {
                        "id": 93183,
                        "name": "Comuna Tortoman",
                        "latitude": "44.34569000",
                        "longitude": "28.26562000"
                    },
                    {
                        "id": 93220,
                        "name": "Comuna Tuzla",
                        "latitude": "44.00158000",
                        "longitude": "28.63874000"
                    },
                    {
                        "id": 93330,
                        "name": "Comuna Valu lui Traian",
                        "latitude": "44.16386000",
                        "longitude": "28.46526000"
                    },
                    {
                        "id": 93423,
                        "name": "Comuna Vulturu",
                        "latitude": "44.64806000",
                        "longitude": "28.27294000"
                    },
                    {
                        "id": 93595,
                        "name": "Constanţa",
                        "latitude": "44.18073000",
                        "longitude": "28.63432000"
                    },
                    {
                        "id": 93618,
                        "name": "Corbu",
                        "latitude": "44.38333000",
                        "longitude": "28.65000000"
                    },
                    {
                        "id": 93667,
                        "name": "Costineşti",
                        "latitude": "43.95000000",
                        "longitude": "28.63333000"
                    },
                    {
                        "id": 93741,
                        "name": "Crucea",
                        "latitude": "44.53333000",
                        "longitude": "28.23333000"
                    },
                    {
                        "id": 93768,
                        "name": "Culmea",
                        "latitude": "44.25759000",
                        "longitude": "28.46643000"
                    },
                    {
                        "id": 93769,
                        "name": "Cumpăna",
                        "latitude": "44.11667000",
                        "longitude": "28.56667000"
                    },
                    {
                        "id": 93783,
                        "name": "Cuza Vodă",
                        "latitude": "44.28773000",
                        "longitude": "28.31005000"
                    },
                    {
                        "id": 93913,
                        "name": "Deleni",
                        "latitude": "44.10000000",
                        "longitude": "28.01667000"
                    },
                    {
                        "id": 93962,
                        "name": "Dobromir",
                        "latitude": "44.01667000",
                        "longitude": "27.78333000"
                    },
                    {
                        "id": 94004,
                        "name": "Dorobanțu",
                        "latitude": "44.41035000",
                        "longitude": "28.32687000"
                    },
                    {
                        "id": 94074,
                        "name": "Dulcești",
                        "latitude": "43.90506000",
                        "longitude": "28.54796000"
                    },
                    {
                        "id": 94083,
                        "name": "Dumbrăveni",
                        "latitude": "43.93333000",
                        "longitude": "27.98333000"
                    },
                    {
                        "id": 94101,
                        "name": "Dunăreni",
                        "latitude": "44.20463000",
                        "longitude": "27.79058000"
                    },
                    {
                        "id": 94137,
                        "name": "Eforie Nord",
                        "latitude": "44.06530000",
                        "longitude": "28.63211000"
                    },
                    {
                        "id": 94138,
                        "name": "Eforie Sud",
                        "latitude": "44.02294000",
                        "longitude": "28.64943000"
                    },
                    {
                        "id": 94248,
                        "name": "Făclia",
                        "latitude": "44.28039000",
                        "longitude": "28.10583000"
                    },
                    {
                        "id": 94239,
                        "name": "Fântânele",
                        "latitude": "44.61278000",
                        "longitude": "28.57655000"
                    },
                    {
                        "id": 94494,
                        "name": "Gârliciu",
                        "latitude": "44.76667000",
                        "longitude": "28.08333000"
                    },
                    {
                        "id": 94329,
                        "name": "Ghindăreşti",
                        "latitude": "44.65000000",
                        "longitude": "28.03333000"
                    },
                    {
                        "id": 94433,
                        "name": "Grădina",
                        "latitude": "44.55520000",
                        "longitude": "28.43236000"
                    },
                    {
                        "id": 94594,
                        "name": "Hârşova",
                        "latitude": "44.68555000",
                        "longitude": "27.95009000"
                    },
                    {
                        "id": 94560,
                        "name": "Horia",
                        "latitude": "44.63333000",
                        "longitude": "28.11667000"
                    },
                    {
                        "id": 94664,
                        "name": "Independenţa",
                        "latitude": "43.96667000",
                        "longitude": "28.08333000"
                    },
                    {
                        "id": 94673,
                        "name": "Ion Corvin",
                        "latitude": "44.11667000",
                        "longitude": "27.80000000"
                    },
                    {
                        "id": 94692,
                        "name": "Istria",
                        "latitude": "44.56667000",
                        "longitude": "28.71667000"
                    },
                    {
                        "id": 94798,
                        "name": "Limanu",
                        "latitude": "43.80000000",
                        "longitude": "28.53333000"
                    },
                    {
                        "id": 94802,
                        "name": "Lipniţa",
                        "latitude": "44.10000000",
                        "longitude": "27.60000000"
                    },
                    {
                        "id": 94849,
                        "name": "Lumina",
                        "latitude": "44.28333000",
                        "longitude": "28.56667000"
                    },
                    {
                        "id": 94920,
                        "name": "Mamaia-Sat",
                        "latitude": "44.31159000",
                        "longitude": "28.62546000"
                    },
                    {
                        "id": 94922,
                        "name": "Mangalia",
                        "latitude": "43.80000000",
                        "longitude": "28.58333000"
                    },
                    {
                        "id": 94942,
                        "name": "Medgidia",
                        "latitude": "44.25000000",
                        "longitude": "28.28333000"
                    },
                    {
                        "id": 94952,
                        "name": "Mereni",
                        "latitude": "44.05000000",
                        "longitude": "28.36667000"
                    },
                    {
                        "id": 94978,
                        "name": "Mihai Viteazu",
                        "latitude": "44.63333000",
                        "longitude": "28.68333000"
                    },
                    {
                        "id": 94984,
                        "name": "Mihail Kogălniceanu",
                        "latitude": "44.36798000",
                        "longitude": "28.46000000"
                    },
                    {
                        "id": 95012,
                        "name": "Mircea Vodă",
                        "latitude": "44.28333000",
                        "longitude": "28.16667000"
                    },
                    {
                        "id": 95094,
                        "name": "Moșneni",
                        "latitude": "43.93487000",
                        "longitude": "28.53132000"
                    },
                    {
                        "id": 95127,
                        "name": "Municipiul Constanţa",
                        "latitude": "44.21414000",
                        "longitude": "28.61862000"
                    },
                    {
                        "id": 95152,
                        "name": "Municipiul Mangalia",
                        "latitude": "43.85085000",
                        "longitude": "28.59780000"
                    },
                    {
                        "id": 95154,
                        "name": "Municipiul Medgidia",
                        "latitude": "44.22795000",
                        "longitude": "28.26801000"
                    },
                    {
                        "id": 95204,
                        "name": "Murfatlar",
                        "latitude": "44.18333000",
                        "longitude": "28.41667000"
                    },
                    {
                        "id": 95377,
                        "name": "Năvodari",
                        "latitude": "44.31667000",
                        "longitude": "28.60000000"
                    },
                    {
                        "id": 95324,
                        "name": "Negru Vodă",
                        "latitude": "43.81667000",
                        "longitude": "28.20000000"
                    },
                    {
                        "id": 95337,
                        "name": "Nicolae Bălcescu",
                        "latitude": "44.38333000",
                        "longitude": "28.38333000"
                    },
                    {
                        "id": 95348,
                        "name": "Nisipari",
                        "latitude": "44.25964000",
                        "longitude": "28.39840000"
                    },
                    {
                        "id": 95364,
                        "name": "Nuntași",
                        "latitude": "44.53755000",
                        "longitude": "28.64880000"
                    },
                    {
                        "id": 95434,
                        "name": "Oltina",
                        "latitude": "44.16667000",
                        "longitude": "27.66667000"
                    },
                    {
                        "id": 95488,
                        "name": "Oraş Bãneasa",
                        "latitude": "44.05008000",
                        "longitude": "27.71430000"
                    },
                    {
                        "id": 95490,
                        "name": "Oraş Cernavodã",
                        "latitude": "44.34331000",
                        "longitude": "28.03694000"
                    },
                    {
                        "id": 95514,
                        "name": "Oraş Eforie",
                        "latitude": "44.04431000",
                        "longitude": "28.64529000"
                    },
                    {
                        "id": 95532,
                        "name": "Oraş Hârşova",
                        "latitude": "44.68721000",
                        "longitude": "27.94785000"
                    },
                    {
                        "id": 95544,
                        "name": "Oraş Murfatlar",
                        "latitude": "44.17090000",
                        "longitude": "28.38185000"
                    },
                    {
                        "id": 95555,
                        "name": "Oraş Nãvodari",
                        "latitude": "44.30511000",
                        "longitude": "28.61407000"
                    },
                    {
                        "id": 95550,
                        "name": "Oraş Negru Vodã",
                        "latitude": "43.79534000",
                        "longitude": "28.28041000"
                    },
                    {
                        "id": 95562,
                        "name": "Oraş Ovidiu",
                        "latitude": "44.23828000",
                        "longitude": "28.53210000"
                    },
                    {
                        "id": 95601,
                        "name": "Oraş Techirghiol",
                        "latitude": "44.05497000",
                        "longitude": "28.59539000"
                    },
                    {
                        "id": 95676,
                        "name": "Ostrov",
                        "latitude": "44.11667000",
                        "longitude": "27.36667000"
                    },
                    {
                        "id": 95686,
                        "name": "Ovidiu",
                        "latitude": "44.25800000",
                        "longitude": "28.56083000"
                    },
                    {
                        "id": 95700,
                        "name": "Palazu Mare",
                        "latitude": "44.22902000",
                        "longitude": "28.60114000"
                    },
                    {
                        "id": 95707,
                        "name": "Pantelimon",
                        "latitude": "44.54589000",
                        "longitude": "28.33094000"
                    },
                    {
                        "id": 95708,
                        "name": "Pantelimon de Jos",
                        "latitude": "44.56667000",
                        "longitude": "28.38333000"
                    },
                    {
                        "id": 95723,
                        "name": "Pecineaga",
                        "latitude": "43.90000000",
                        "longitude": "28.50000000"
                    },
                    {
                        "id": 95759,
                        "name": "Peştera",
                        "latitude": "44.18333000",
                        "longitude": "28.13333000"
                    },
                    {
                        "id": 95769,
                        "name": "Piatra",
                        "latitude": "44.40492000",
                        "longitude": "28.56143000"
                    },
                    {
                        "id": 95780,
                        "name": "Pietreni",
                        "latitude": "44.09609000",
                        "longitude": "28.06833000"
                    },
                    {
                        "id": 95818,
                        "name": "Plopeni",
                        "latitude": "43.95089000",
                        "longitude": "28.19452000"
                    },
                    {
                        "id": 95836,
                        "name": "Poarta Albă",
                        "latitude": "44.21667000",
                        "longitude": "28.40000000"
                    },
                    {
                        "id": 96061,
                        "name": "Rasova",
                        "latitude": "44.24616000",
                        "longitude": "27.93466000"
                    },
                    {
                        "id": 105993,
                        "name": "Săcele",
                        "latitude": "44.48333000",
                        "longitude": "28.65000000"
                    },
                    {
                        "id": 96235,
                        "name": "Saligny",
                        "latitude": "44.28111000",
                        "longitude": "28.09092000"
                    },
                    {
                        "id": 96243,
                        "name": "Saraiu",
                        "latitude": "44.71667000",
                        "longitude": "28.15000000"
                    },
                    {
                        "id": 96260,
                        "name": "Satu Nou",
                        "latitude": "44.26918000",
                        "longitude": "28.22579000"
                    },
                    {
                        "id": 96271,
                        "name": "Schitu",
                        "latitude": "43.94279000",
                        "longitude": "28.62829000"
                    },
                    {
                        "id": 96322,
                        "name": "Seimeni",
                        "latitude": "44.38333000",
                        "longitude": "28.06667000"
                    },
                    {
                        "id": 96341,
                        "name": "Siliştea",
                        "latitude": "44.40000000",
                        "longitude": "28.16667000"
                    },
                    {
                        "id": 96348,
                        "name": "Siminoc",
                        "latitude": "44.16866000",
                        "longitude": "28.35277000"
                    },
                    {
                        "id": 96590,
                        "name": "Târguşor",
                        "latitude": "44.45000000",
                        "longitude": "28.41667000"
                    },
                    {
                        "id": 106061,
                        "name": "Tariverde",
                        "latitude": "44.56268000",
                        "longitude": "28.60245000"
                    },
                    {
                        "id": 106068,
                        "name": "Techirghiol",
                        "latitude": "44.05000000",
                        "longitude": "28.60000000"
                    },
                    {
                        "id": 106127,
                        "name": "Topalu",
                        "latitude": "44.54381000",
                        "longitude": "28.04575000"
                    },
                    {
                        "id": 106139,
                        "name": "Topraisar",
                        "latitude": "44.01667000",
                        "longitude": "28.45000000"
                    },
                    {
                        "id": 106141,
                        "name": "Tortoman",
                        "latitude": "44.35000000",
                        "longitude": "28.21667000"
                    },
                    {
                        "id": 96573,
                        "name": "Tuzla",
                        "latitude": "44.00000000",
                        "longitude": "28.63333000"
                    },
                    {
                        "id": 96721,
                        "name": "Valea Dacilor",
                        "latitude": "44.19495000",
                        "longitude": "28.31776000"
                    },
                    {
                        "id": 96769,
                        "name": "Valu lui Traian",
                        "latitude": "44.16667000",
                        "longitude": "28.46667000"
                    },
                    {
                        "id": 96815,
                        "name": "Viile",
                        "latitude": "44.16200000",
                        "longitude": "27.75769000"
                    },
                    {
                        "id": 96828,
                        "name": "Viișoara",
                        "latitude": "44.07758000",
                        "longitude": "28.19424000"
                    },
                    {
                        "id": 96913,
                        "name": "Vulturu",
                        "latitude": "44.65000000",
                        "longitude": "28.26667000"
                    }
                ]
            },
            {
                "id": 4754,
                "name": "Covasna",
                "iso2": "CV",
                "latitude": "45.94263470",
                "longitude": "25.89189840",
                "type": "department",
                "cities": [
                    {
                        "id": 89905,
                        "name": "Aita Mare",
                        "latitude": "45.96667000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 89976,
                        "name": "Araci",
                        "latitude": "45.81187000",
                        "longitude": "25.65482000"
                    },
                    {
                        "id": 89981,
                        "name": "Arcuș",
                        "latitude": "45.90077000",
                        "longitude": "25.77673000"
                    },
                    {
                        "id": 90058,
                        "name": "Baraolt",
                        "latitude": "46.07514000",
                        "longitude": "25.60029000"
                    },
                    {
                        "id": 90060,
                        "name": "Barcani",
                        "latitude": "45.70000000",
                        "longitude": "26.08333000"
                    },
                    {
                        "id": 90556,
                        "name": "Băţanii Mari",
                        "latitude": "46.08333000",
                        "longitude": "25.68333000"
                    },
                    {
                        "id": 90087,
                        "name": "Belin",
                        "latitude": "45.93333000",
                        "longitude": "25.56667000"
                    },
                    {
                        "id": 90088,
                        "name": "Belin-Vale",
                        "latitude": "45.93237000",
                        "longitude": "25.60878000"
                    },
                    {
                        "id": 90155,
                        "name": "Bixad",
                        "latitude": "46.10000000",
                        "longitude": "25.86667000"
                    },
                    {
                        "id": 90183,
                        "name": "Bodoc",
                        "latitude": "45.95000000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 90233,
                        "name": "Boroşneu Mare",
                        "latitude": "45.81667000",
                        "longitude": "26.00000000"
                    },
                    {
                        "id": 90327,
                        "name": "Brăduţ",
                        "latitude": "46.13333000",
                        "longitude": "25.61667000"
                    },
                    {
                        "id": 90276,
                        "name": "Brateş",
                        "latitude": "45.83333000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 90304,
                        "name": "Breţcu",
                        "latitude": "46.05000000",
                        "longitude": "26.30000000"
                    },
                    {
                        "id": 93857,
                        "name": "Căpeni",
                        "latitude": "46.04111000",
                        "longitude": "25.57858000"
                    },
                    {
                        "id": 90587,
                        "name": "Catalina",
                        "latitude": "45.96667000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 90629,
                        "name": "Cernat",
                        "latitude": "45.95000000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 90663,
                        "name": "Chichiş",
                        "latitude": "45.78333000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 90809,
                        "name": "Comandău",
                        "latitude": "45.76667000",
                        "longitude": "26.26667000"
                    },
                    {
                        "id": 90835,
                        "name": "Comuna Aita Mare",
                        "latitude": "45.97126000",
                        "longitude": "25.58824000"
                    },
                    {
                        "id": 90885,
                        "name": "Comuna Arcuş",
                        "latitude": "45.90077000",
                        "longitude": "25.77673000"
                    },
                    {
                        "id": 90936,
                        "name": "Comuna Barcani",
                        "latitude": "45.70483000",
                        "longitude": "26.06393000"
                    },
                    {
                        "id": 91249,
                        "name": "Comuna Băţani",
                        "latitude": "46.09167000",
                        "longitude": "25.71930000"
                    },
                    {
                        "id": 90952,
                        "name": "Comuna Belin",
                        "latitude": "45.93361000",
                        "longitude": "25.59126000"
                    },
                    {
                        "id": 91001,
                        "name": "Comuna Bixad",
                        "latitude": "46.10225000",
                        "longitude": "25.86344000"
                    },
                    {
                        "id": 91019,
                        "name": "Comuna Bodoc",
                        "latitude": "45.96190000",
                        "longitude": "25.84149000"
                    },
                    {
                        "id": 91053,
                        "name": "Comuna Boroşneu Mare",
                        "latitude": "45.81010000",
                        "longitude": "26.01568000"
                    },
                    {
                        "id": 91116,
                        "name": "Comuna Brăduţ",
                        "latitude": "46.12574000",
                        "longitude": "25.60329000"
                    },
                    {
                        "id": 91084,
                        "name": "Comuna Brateş",
                        "latitude": "45.83992000",
                        "longitude": "26.07887000"
                    },
                    {
                        "id": 91100,
                        "name": "Comuna Breţcu",
                        "latitude": "46.04444000",
                        "longitude": "26.32887000"
                    },
                    {
                        "id": 91266,
                        "name": "Comuna Catalina",
                        "latitude": "45.93736000",
                        "longitude": "26.12250000"
                    },
                    {
                        "id": 93581,
                        "name": "Comună Cernat",
                        "latitude": "45.96650000",
                        "longitude": "26.01955000"
                    },
                    {
                        "id": 91312,
                        "name": "Comuna Chichiş",
                        "latitude": "45.76781000",
                        "longitude": "25.81378000"
                    },
                    {
                        "id": 91406,
                        "name": "Comuna Comandău",
                        "latitude": "45.76179000",
                        "longitude": "26.27776000"
                    },
                    {
                        "id": 91603,
                        "name": "Comuna Dalnic",
                        "latitude": "45.92242000",
                        "longitude": "25.98741000"
                    },
                    {
                        "id": 91647,
                        "name": "Comuna Dobârlău",
                        "latitude": "45.73410000",
                        "longitude": "25.88112000"
                    },
                    {
                        "id": 91750,
                        "name": "Comuna Estelnic",
                        "latitude": "46.12537000",
                        "longitude": "26.20544000"
                    },
                    {
                        "id": 91841,
                        "name": "Comuna Ghelinţa",
                        "latitude": "45.93491000",
                        "longitude": "26.22068000"
                    },
                    {
                        "id": 91851,
                        "name": "Comuna Ghidfalău",
                        "latitude": "45.89956000",
                        "longitude": "25.86399000"
                    },
                    {
                        "id": 92036,
                        "name": "Comuna Hăghig",
                        "latitude": "45.85362000",
                        "longitude": "25.59501000"
                    },
                    {
                        "id": 92071,
                        "name": "Comuna Ilieni",
                        "latitude": "45.80054000",
                        "longitude": "25.76436000"
                    },
                    {
                        "id": 92149,
                        "name": "Comuna Lemnia",
                        "latitude": "46.07078000",
                        "longitude": "26.27277000"
                    },
                    {
                        "id": 92233,
                        "name": "Comuna Malnaş",
                        "latitude": "46.01995000",
                        "longitude": "25.82705000"
                    },
                    {
                        "id": 92256,
                        "name": "Comuna Mereni",
                        "latitude": "46.08496000",
                        "longitude": "26.23460000"
                    },
                    {
                        "id": 92266,
                        "name": "Comuna Micfalău",
                        "latitude": "46.05342000",
                        "longitude": "25.83737000"
                    },
                    {
                        "id": 92311,
                        "name": "Comuna Moacşa",
                        "latitude": "45.87883000",
                        "longitude": "25.95270000"
                    },
                    {
                        "id": 92491,
                        "name": "Comuna Ojdula",
                        "latitude": "45.97871000",
                        "longitude": "26.24773000"
                    },
                    {
                        "id": 92523,
                        "name": "Comuna Ozun",
                        "latitude": "45.78331000",
                        "longitude": "25.88260000"
                    },
                    {
                        "id": 92621,
                        "name": "Comuna Poian",
                        "latitude": "46.07731000",
                        "longitude": "26.17423000"
                    },
                    {
                        "id": 92757,
                        "name": "Comuna Reci",
                        "latitude": "45.81913000",
                        "longitude": "25.95552000"
                    },
                    {
                        "id": 93070,
                        "name": "Comuna Sânzieni",
                        "latitude": "46.06458000",
                        "longitude": "26.11790000"
                    },
                    {
                        "id": 92946,
                        "name": "Comuna Sita Buzăului",
                        "latitude": "45.61959000",
                        "longitude": "26.10621000"
                    },
                    {
                        "id": 93214,
                        "name": "Comuna Turia",
                        "latitude": "46.02927000",
                        "longitude": "26.03953000"
                    },
                    {
                        "id": 93426,
                        "name": "Comuna Vâlcele",
                        "latitude": "45.81736000",
                        "longitude": "25.67925000"
                    },
                    {
                        "id": 93301,
                        "name": "Comuna Valea Crişului",
                        "latitude": "45.92372000",
                        "longitude": "25.78483000"
                    },
                    {
                        "id": 93311,
                        "name": "Comuna Valea Mare",
                        "latitude": "45.76389000",
                        "longitude": "26.01435000"
                    },
                    {
                        "id": 93442,
                        "name": "Comuna Vârghiş",
                        "latitude": "46.12737000",
                        "longitude": "25.55901000"
                    },
                    {
                        "id": 93483,
                        "name": "Comuna Zăbala",
                        "latitude": "45.89141000",
                        "longitude": "26.13251000"
                    },
                    {
                        "id": 93468,
                        "name": "Comuna Zagon",
                        "latitude": "45.77961000",
                        "longitude": "26.12897000"
                    },
                    {
                        "id": 93680,
                        "name": "Covasna",
                        "latitude": "45.85000000",
                        "longitude": "26.18333000"
                    },
                    {
                        "id": 93891,
                        "name": "Dalnic",
                        "latitude": "45.92242000",
                        "longitude": "25.98741000"
                    },
                    {
                        "id": 93973,
                        "name": "Dobârlău",
                        "latitude": "45.73333000",
                        "longitude": "25.88333000"
                    },
                    {
                        "id": 93945,
                        "name": "Doboșeni",
                        "latitude": "46.12431000",
                        "longitude": "25.59347000"
                    },
                    {
                        "id": 94145,
                        "name": "Estelnic",
                        "latitude": "46.10445000",
                        "longitude": "26.21262000"
                    },
                    {
                        "id": 94170,
                        "name": "Filia",
                        "latitude": "46.14409000",
                        "longitude": "25.62140000"
                    },
                    {
                        "id": 94190,
                        "name": "Floroaia",
                        "latitude": "45.69497000",
                        "longitude": "26.01563000"
                    },
                    {
                        "id": 94299,
                        "name": "Ghelinţa",
                        "latitude": "45.95000000",
                        "longitude": "26.23333000"
                    },
                    {
                        "id": 94316,
                        "name": "Ghidfalău",
                        "latitude": "45.90000000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 94597,
                        "name": "Hăghig",
                        "latitude": "45.83333000",
                        "longitude": "25.58333000"
                    },
                    {
                        "id": 94530,
                        "name": "Herculian",
                        "latitude": "46.13402000",
                        "longitude": "25.70977000"
                    },
                    {
                        "id": 94657,
                        "name": "Ilieni",
                        "latitude": "45.80000000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 97026,
                        "name": "Întorsura Buzăului",
                        "latitude": "45.68333000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 94776,
                        "name": "Lemnia",
                        "latitude": "46.05000000",
                        "longitude": "26.26667000"
                    },
                    {
                        "id": 94879,
                        "name": "Lunga",
                        "latitude": "46.01822000",
                        "longitude": "26.21208000"
                    },
                    {
                        "id": 94913,
                        "name": "Malnaş",
                        "latitude": "46.01667000",
                        "longitude": "25.83333000"
                    },
                    {
                        "id": 94951,
                        "name": "Mereni",
                        "latitude": "46.07924000",
                        "longitude": "26.23597000"
                    },
                    {
                        "id": 94968,
                        "name": "Micfalău",
                        "latitude": "46.05342000",
                        "longitude": "25.83737000"
                    },
                    {
                        "id": 95038,
                        "name": "Moacşa",
                        "latitude": "45.86667000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 95180,
                        "name": "Municipiul Sfântu Gheorghe",
                        "latitude": "45.83806000",
                        "longitude": "25.79730000"
                    },
                    {
                        "id": 95193,
                        "name": "Municipiul Târgu Secuiesc",
                        "latitude": "46.00589000",
                        "longitude": "26.17155000"
                    },
                    {
                        "id": 95421,
                        "name": "Ojdula",
                        "latitude": "45.98333000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 95458,
                        "name": "Oraş Baraolt",
                        "latitude": "46.06250000",
                        "longitude": "25.60505000"
                    },
                    {
                        "id": 95499,
                        "name": "Oraş Covasna",
                        "latitude": "45.83527000",
                        "longitude": "26.16637000"
                    },
                    {
                        "id": 95628,
                        "name": "Oraş Întorsura Buzãului",
                        "latitude": "45.68539000",
                        "longitude": "26.01260000"
                    },
                    {
                        "id": 95687,
                        "name": "Ozun",
                        "latitude": "45.80000000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 96019,
                        "name": "Păpăuți",
                        "latitude": "45.78333000",
                        "longitude": "26.13333000"
                    },
                    {
                        "id": 95859,
                        "name": "Poian",
                        "latitude": "46.06667000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 96073,
                        "name": "Reci",
                        "latitude": "45.85000000",
                        "longitude": "25.93333000"
                    },
                    {
                        "id": 105982,
                        "name": "Sânzieni",
                        "latitude": "46.05000000",
                        "longitude": "26.13333000"
                    },
                    {
                        "id": 96330,
                        "name": "Sfântu Gheorghe",
                        "latitude": "45.86667000",
                        "longitude": "25.78333000"
                    },
                    {
                        "id": 96360,
                        "name": "Sita Buzăului",
                        "latitude": "45.65000000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 96588,
                        "name": "Târgu Secuiesc",
                        "latitude": "46.00000000",
                        "longitude": "26.13333000"
                    },
                    {
                        "id": 96562,
                        "name": "Turia",
                        "latitude": "46.03333000",
                        "longitude": "26.05000000"
                    },
                    {
                        "id": 96918,
                        "name": "Vâlcele",
                        "latitude": "45.85000000",
                        "longitude": "25.68333000"
                    },
                    {
                        "id": 96717,
                        "name": "Valea Crişului",
                        "latitude": "45.91667000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 96735,
                        "name": "Valea Mare",
                        "latitude": "45.76667000",
                        "longitude": "26.00000000"
                    },
                    {
                        "id": 96941,
                        "name": "Vârghiş",
                        "latitude": "46.13333000",
                        "longitude": "25.53333000"
                    },
                    {
                        "id": 97008,
                        "name": "Zăbala",
                        "latitude": "45.90000000",
                        "longitude": "26.18333000"
                    },
                    {
                        "id": 96979,
                        "name": "Zagon",
                        "latitude": "45.76667000",
                        "longitude": "26.11667000"
                    }
                ]
            },
            {
                "id": 4745,
                "name": "Dâmbovița",
                "iso2": "DB",
                "latitude": "44.92898930",
                "longitude": "25.42538500",
                "type": "department",
                "cities": [
                    {
                        "id": 89886,
                        "name": "Adânca",
                        "latitude": "44.92250000",
                        "longitude": "25.61005000"
                    },
                    {
                        "id": 89966,
                        "name": "Aninoasa",
                        "latitude": "44.96667000",
                        "longitude": "25.43333000"
                    },
                    {
                        "id": 90481,
                        "name": "Bădeni",
                        "latitude": "45.15272000",
                        "longitude": "25.40263000"
                    },
                    {
                        "id": 90440,
                        "name": "Bâldana",
                        "latitude": "44.60300000",
                        "longitude": "25.77836000"
                    },
                    {
                        "id": 90509,
                        "name": "Băleni Sârbi",
                        "latitude": "44.81667000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 90516,
                        "name": "Bălteni",
                        "latitude": "44.66488000",
                        "longitude": "25.69339000"
                    },
                    {
                        "id": 90538,
                        "name": "Bărbuleţu",
                        "latitude": "45.13333000",
                        "longitude": "25.30000000"
                    },
                    {
                        "id": 90122,
                        "name": "Bezdead",
                        "latitude": "45.15000000",
                        "longitude": "25.51667000"
                    },
                    {
                        "id": 90136,
                        "name": "Bilciureşti",
                        "latitude": "44.73333000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 90335,
                        "name": "Brăneşti",
                        "latitude": "45.03333000",
                        "longitude": "25.41667000"
                    },
                    {
                        "id": 90269,
                        "name": "Braniştea",
                        "latitude": "44.68333000",
                        "longitude": "25.58333000"
                    },
                    {
                        "id": 90301,
                        "name": "Brezoaele",
                        "latitude": "44.58333000",
                        "longitude": "25.73333000"
                    },
                    {
                        "id": 90302,
                        "name": "Brezoaia",
                        "latitude": "44.55683000",
                        "longitude": "25.78527000"
                    },
                    {
                        "id": 90312,
                        "name": "Broșteni",
                        "latitude": "44.72053000",
                        "longitude": "25.50935000"
                    },
                    {
                        "id": 90354,
                        "name": "Buciumeni",
                        "latitude": "45.15000000",
                        "longitude": "25.45000000"
                    },
                    {
                        "id": 90366,
                        "name": "Bucşani",
                        "latitude": "44.86667000",
                        "longitude": "25.65000000"
                    },
                    {
                        "id": 90412,
                        "name": "Bungetu",
                        "latitude": "44.84323000",
                        "longitude": "25.53816000"
                    },
                    {
                        "id": 90427,
                        "name": "Butimanu",
                        "latitude": "44.68333000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 93808,
                        "name": "Cândeşti Vale",
                        "latitude": "45.08333000",
                        "longitude": "25.21667000"
                    },
                    {
                        "id": 93860,
                        "name": "Căprioru",
                        "latitude": "44.98236000",
                        "longitude": "25.28116000"
                    },
                    {
                        "id": 90593,
                        "name": "Cazaci",
                        "latitude": "44.80152000",
                        "longitude": "25.55405000"
                    },
                    {
                        "id": 90713,
                        "name": "Ciocănari",
                        "latitude": "44.69770000",
                        "longitude": "25.97717000"
                    },
                    {
                        "id": 90715,
                        "name": "Ciocăneşti",
                        "latitude": "44.60000000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 90789,
                        "name": "Cojasca",
                        "latitude": "44.71667000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 90791,
                        "name": "Colacu",
                        "latitude": "44.66895000",
                        "longitude": "25.75881000"
                    },
                    {
                        "id": 90813,
                        "name": "Comişani",
                        "latitude": "44.88333000",
                        "longitude": "25.58333000"
                    },
                    {
                        "id": 90874,
                        "name": "Comuna Aninoasa",
                        "latitude": "44.96863000",
                        "longitude": "25.43802000"
                    },
                    {
                        "id": 91214,
                        "name": "Comuna Băleni Sârbi",
                        "latitude": "44.82017000",
                        "longitude": "25.64756000"
                    },
                    {
                        "id": 91237,
                        "name": "Comuna Bărbuleţu",
                        "latitude": "45.14196000",
                        "longitude": "25.29771000"
                    },
                    {
                        "id": 90980,
                        "name": "Comuna Bezdead",
                        "latitude": "45.13705000",
                        "longitude": "25.49476000"
                    },
                    {
                        "id": 90989,
                        "name": "Comuna Bilciureşti",
                        "latitude": "44.74770000",
                        "longitude": "25.80621000"
                    },
                    {
                        "id": 91122,
                        "name": "Comuna Brăneşti",
                        "latitude": "45.03430000",
                        "longitude": "25.42253000"
                    },
                    {
                        "id": 91079,
                        "name": "Comuna Braniştea",
                        "latitude": "44.68134000",
                        "longitude": "25.58387000"
                    },
                    {
                        "id": 91099,
                        "name": "Comuna Brezoaele",
                        "latitude": "44.56647000",
                        "longitude": "25.76664000"
                    },
                    {
                        "id": 91130,
                        "name": "Comuna Buciumeni",
                        "latitude": "45.15902000",
                        "longitude": "25.46392000"
                    },
                    {
                        "id": 91140,
                        "name": "Comuna Bucşani",
                        "latitude": "44.85270000",
                        "longitude": "25.64561000"
                    },
                    {
                        "id": 91175,
                        "name": "Comuna Butimanu",
                        "latitude": "44.68680000",
                        "longitude": "25.90535000"
                    },
                    {
                        "id": 91548,
                        "name": "Comuna Cândeşti Vale",
                        "latitude": "45.06660000",
                        "longitude": "25.20455000"
                    },
                    {
                        "id": 91346,
                        "name": "Comuna Ciocăneşti",
                        "latitude": "44.62136000",
                        "longitude": "25.84490000"
                    },
                    {
                        "id": 91385,
                        "name": "Comuna Cobia de Sus",
                        "latitude": "44.81197000",
                        "longitude": "25.33463000"
                    },
                    {
                        "id": 91394,
                        "name": "Comuna Cojasca",
                        "latitude": "44.71855000",
                        "longitude": "25.85566000"
                    },
                    {
                        "id": 91408,
                        "name": "Comuna Comişani",
                        "latitude": "44.87528000",
                        "longitude": "25.57009000"
                    },
                    {
                        "id": 91414,
                        "name": "Comuna Conţeşti",
                        "latitude": "44.67875000",
                        "longitude": "25.67330000"
                    },
                    {
                        "id": 91426,
                        "name": "Comuna Corbii Mari",
                        "latitude": "44.55671000",
                        "longitude": "25.48060000"
                    },
                    {
                        "id": 91444,
                        "name": "Comuna Cornăţelu",
                        "latitude": "44.73080000",
                        "longitude": "25.68640000"
                    },
                    {
                        "id": 91439,
                        "name": "Comuna Corneşti",
                        "latitude": "44.77121000",
                        "longitude": "25.88722000"
                    },
                    {
                        "id": 91458,
                        "name": "Comuna Costeştii din Vale",
                        "latitude": "44.64096000",
                        "longitude": "25.50153000"
                    },
                    {
                        "id": 91515,
                        "name": "Comuna Crângurile",
                        "latitude": "44.74277000",
                        "longitude": "25.24062000"
                    },
                    {
                        "id": 91489,
                        "name": "Comuna Crevedia",
                        "latitude": "44.59787000",
                        "longitude": "25.92260000"
                    },
                    {
                        "id": 91745,
                        "name": "Comuna Dărmăneşti",
                        "latitude": "44.92476000",
                        "longitude": "25.76145000"
                    },
                    {
                        "id": 91632,
                        "name": "Comuna Dobra",
                        "latitude": "44.79586000",
                        "longitude": "25.71297000"
                    },
                    {
                        "id": 91653,
                        "name": "Comuna Doiceşti",
                        "latitude": "44.99144000",
                        "longitude": "25.40073000"
                    },
                    {
                        "id": 91671,
                        "name": "Comuna Dragodana",
                        "latitude": "44.75892000",
                        "longitude": "25.38433000"
                    },
                    {
                        "id": 91673,
                        "name": "Comuna Dragomireşti",
                        "latitude": "44.89354000",
                        "longitude": "25.36611000"
                    },
                    {
                        "id": 91767,
                        "name": "Comuna Finta",
                        "latitude": "44.79370000",
                        "longitude": "25.79926000"
                    },
                    {
                        "id": 91883,
                        "name": "Comuna Glodeni",
                        "latitude": "45.01930000",
                        "longitude": "25.45913000"
                    },
                    {
                        "id": 91947,
                        "name": "Comuna Gura Foii",
                        "latitude": "44.75712000",
                        "longitude": "25.29852000"
                    },
                    {
                        "id": 91949,
                        "name": "Comuna Gura Ocniţei",
                        "latitude": "44.93449000",
                        "longitude": "25.57419000"
                    },
                    {
                        "id": 91956,
                        "name": "Comuna Gura Şuţii",
                        "latitude": "44.76161000",
                        "longitude": "25.47575000"
                    },
                    {
                        "id": 92027,
                        "name": "Comuna Hulubeşti",
                        "latitude": "44.84204000",
                        "longitude": "25.26253000"
                    },
                    {
                        "id": 92047,
                        "name": "Comuna I. L. Caragiale",
                        "latitude": "44.92189000",
                        "longitude": "25.68409000"
                    },
                    {
                        "id": 92063,
                        "name": "Comuna Iedera",
                        "latitude": "45.03333000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 92188,
                        "name": "Comuna Lucieni",
                        "latitude": "44.84766000",
                        "longitude": "25.41990000"
                    },
                    {
                        "id": 92190,
                        "name": "Comuna Ludeşti",
                        "latitude": "44.90396000",
                        "longitude": "25.22557000"
                    },
                    {
                        "id": 92213,
                        "name": "Comuna Lunguleţu",
                        "latitude": "44.61601000",
                        "longitude": "25.64340000"
                    },
                    {
                        "id": 92237,
                        "name": "Comuna Malu cu Flori",
                        "latitude": "45.15617000",
                        "longitude": "25.22589000"
                    },
                    {
                        "id": 92403,
                        "name": "Comuna Măneşti",
                        "latitude": "44.95033000",
                        "longitude": "25.30034000"
                    },
                    {
                        "id": 92420,
                        "name": "Comuna Mătăsaru",
                        "latitude": "44.67584000",
                        "longitude": "25.44365000"
                    },
                    {
                        "id": 92318,
                        "name": "Comuna Mogoşani",
                        "latitude": "44.68319000",
                        "longitude": "25.38774000"
                    },
                    {
                        "id": 92332,
                        "name": "Comuna Moroeni",
                        "latitude": "45.23406000",
                        "longitude": "25.44468000"
                    },
                    {
                        "id": 92333,
                        "name": "Comuna Morteni",
                        "latitude": "44.66221000",
                        "longitude": "25.25208000"
                    },
                    {
                        "id": 92352,
                        "name": "Comuna Moţãieni",
                        "latitude": "45.10631000",
                        "longitude": "25.41045000"
                    },
                    {
                        "id": 92445,
                        "name": "Comuna Niculeşti",
                        "latitude": "44.68664000",
                        "longitude": "25.96350000"
                    },
                    {
                        "id": 92454,
                        "name": "Comuna Nucet",
                        "latitude": "44.80328000",
                        "longitude": "25.55434000"
                    },
                    {
                        "id": 92479,
                        "name": "Comuna Ocniţa",
                        "latitude": "44.99011000",
                        "longitude": "25.55591000"
                    },
                    {
                        "id": 92481,
                        "name": "Comuna Odobeşti",
                        "latitude": "44.59883000",
                        "longitude": "25.54082000"
                    },
                    {
                        "id": 92557,
                        "name": "Comuna Perşinari",
                        "latitude": "44.80185000",
                        "longitude": "25.49880000"
                    },
                    {
                        "id": 92563,
                        "name": "Comuna Petreşti",
                        "latitude": "44.66761000",
                        "longitude": "25.31458000"
                    },
                    {
                        "id": 92576,
                        "name": "Comuna Pietrari",
                        "latitude": "45.10034000",
                        "longitude": "25.29356000"
                    },
                    {
                        "id": 92583,
                        "name": "Comuna Pietroşiţa",
                        "latitude": "45.18773000",
                        "longitude": "25.42828000"
                    },
                    {
                        "id": 92623,
                        "name": "Comuna Poiana",
                        "latitude": "44.57429000",
                        "longitude": "25.67684000"
                    },
                    {
                        "id": 92665,
                        "name": "Comuna Potlogi",
                        "latitude": "44.57362000",
                        "longitude": "25.60164000"
                    },
                    {
                        "id": 92681,
                        "name": "Comuna Produleşti",
                        "latitude": "44.70336000",
                        "longitude": "25.50466000"
                    },
                    {
                        "id": 92690,
                        "name": "Comuna Pucheni",
                        "latitude": "45.18211000",
                        "longitude": "25.26926000"
                    },
                    {
                        "id": 92732,
                        "name": "Comuna Raciu",
                        "latitude": "44.81644000",
                        "longitude": "25.43460000"
                    },
                    {
                        "id": 92847,
                        "name": "Comuna Răscăeţi",
                        "latitude": "44.59760000",
                        "longitude": "25.25621000"
                    },
                    {
                        "id": 92825,
                        "name": "Comuna Râu Alb",
                        "latitude": "45.14850000",
                        "longitude": "25.33714000"
                    },
                    {
                        "id": 92833,
                        "name": "Comuna Rãzvad",
                        "latitude": "44.93588000",
                        "longitude": "25.52914000"
                    },
                    {
                        "id": 92811,
                        "name": "Comuna Runcu",
                        "latitude": "45.17702000",
                        "longitude": "25.38533000"
                    },
                    {
                        "id": 93094,
                        "name": "Comuna Sălcioara",
                        "latitude": "44.73645000",
                        "longitude": "25.57411000"
                    },
                    {
                        "id": 93504,
                        "name": "Comuna Şelaru",
                        "latitude": "44.48705000",
                        "longitude": "25.31294000"
                    },
                    {
                        "id": 92957,
                        "name": "Comuna Slobozia Moara",
                        "latitude": "44.59865000",
                        "longitude": "25.73126000"
                    },
                    {
                        "id": 93544,
                        "name": "Comuna Şotânga",
                        "latitude": "44.98544000",
                        "longitude": "25.38254000"
                    },
                    {
                        "id": 93241,
                        "name": "Comuna Tărtăşeşti",
                        "latitude": "44.57674000",
                        "longitude": "25.82134000"
                    },
                    {
                        "id": 93244,
                        "name": "Comuna Tătărani",
                        "latitude": "45.00067000",
                        "longitude": "25.27998000"
                    },
                    {
                        "id": 93258,
                        "name": "Comuna Ulieşti",
                        "latitude": "44.60160000",
                        "longitude": "25.40770000"
                    },
                    {
                        "id": 93262,
                        "name": "Comuna Ulmi",
                        "latitude": "44.89030000",
                        "longitude": "25.44376000"
                    },
                    {
                        "id": 93452,
                        "name": "Comuna Văcăreşti",
                        "latitude": "44.84041000",
                        "longitude": "25.51989000"
                    },
                    {
                        "id": 93309,
                        "name": "Comuna Valea Lungă",
                        "latitude": "45.06978000",
                        "longitude": "25.56993000"
                    },
                    {
                        "id": 93313,
                        "name": "Comuna Valea Mare",
                        "latitude": "44.79383000",
                        "longitude": "25.23292000"
                    },
                    {
                        "id": 93460,
                        "name": "Comuna Văleni-Dâmboviţa",
                        "latitude": "45.17593000",
                        "longitude": "25.17678000"
                    },
                    {
                        "id": 93440,
                        "name": "Comuna Vârfuri",
                        "latitude": "45.09555000",
                        "longitude": "25.50712000"
                    },
                    {
                        "id": 93376,
                        "name": "Comuna Vişina",
                        "latitude": "44.60194000",
                        "longitude": "25.35218000"
                    },
                    {
                        "id": 93379,
                        "name": "Comuna Vişineşti",
                        "latitude": "45.11256000",
                        "longitude": "25.56815000"
                    },
                    {
                        "id": 93387,
                        "name": "Comuna Vlădeni",
                        "latitude": "44.87550000",
                        "longitude": "25.77318000"
                    },
                    {
                        "id": 93398,
                        "name": "Comuna Voineşti",
                        "latitude": "45.06986000",
                        "longitude": "25.26072000"
                    },
                    {
                        "id": 93413,
                        "name": "Comuna Vulcana Băi",
                        "latitude": "45.07910000",
                        "longitude": "25.38219000"
                    },
                    {
                        "id": 93414,
                        "name": "Comuna Vulcana-Pandele",
                        "latitude": "45.02165000",
                        "longitude": "25.39888000"
                    },
                    {
                        "id": 93597,
                        "name": "Conțești",
                        "latitude": "44.68518000",
                        "longitude": "25.63879000"
                    },
                    {
                        "id": 93615,
                        "name": "Corbii Mari",
                        "latitude": "44.55000000",
                        "longitude": "25.50000000"
                    },
                    {
                        "id": 93643,
                        "name": "Cornăţelu",
                        "latitude": "44.75000000",
                        "longitude": "25.66667000"
                    },
                    {
                        "id": 93635,
                        "name": "Corneşti",
                        "latitude": "44.78333000",
                        "longitude": "25.86667000"
                    },
                    {
                        "id": 93666,
                        "name": "Costeștii din Deal",
                        "latitude": "44.68132000",
                        "longitude": "25.48938000"
                    },
                    {
                        "id": 93662,
                        "name": "Costeştii din Vale",
                        "latitude": "44.65000000",
                        "longitude": "25.48333000"
                    },
                    {
                        "id": 93749,
                        "name": "Crângurile de Sus",
                        "latitude": "44.76667000",
                        "longitude": "25.23333000"
                    },
                    {
                        "id": 93710,
                        "name": "Crevedia",
                        "latitude": "44.60000000",
                        "longitude": "25.93333000"
                    },
                    {
                        "id": 93738,
                        "name": "Croitori",
                        "latitude": "44.57512000",
                        "longitude": "25.41356000"
                    },
                    {
                        "id": 93739,
                        "name": "Crovu",
                        "latitude": "44.58947000",
                        "longitude": "25.53684000"
                    },
                    {
                        "id": 94104,
                        "name": "Dâmbovicioara",
                        "latitude": "44.67569000",
                        "longitude": "25.55374000"
                    },
                    {
                        "id": 94132,
                        "name": "Dărmăneşti",
                        "latitude": "44.91667000",
                        "longitude": "25.78333000"
                    },
                    {
                        "id": 94113,
                        "name": "Dârza",
                        "latitude": "44.60175000",
                        "longitude": "25.94956000"
                    },
                    {
                        "id": 93903,
                        "name": "Dealu Frumos",
                        "latitude": "45.18575000",
                        "longitude": "25.41329000"
                    },
                    {
                        "id": 93904,
                        "name": "Dealu Mare",
                        "latitude": "45.16072000",
                        "longitude": "25.44871000"
                    },
                    {
                        "id": 93907,
                        "name": "Decindeni",
                        "latitude": "44.91234000",
                        "longitude": "25.32607000"
                    },
                    {
                        "id": 93948,
                        "name": "Dobra",
                        "latitude": "44.78333000",
                        "longitude": "25.71667000"
                    },
                    {
                        "id": 93981,
                        "name": "Doiceşti",
                        "latitude": "44.98333000",
                        "longitude": "25.40000000"
                    },
                    {
                        "id": 94055,
                        "name": "Drăgăești Ungureni",
                        "latitude": "44.94557000",
                        "longitude": "25.31048000"
                    },
                    {
                        "id": 94012,
                        "name": "Dragodana",
                        "latitude": "44.73333000",
                        "longitude": "25.35000000"
                    },
                    {
                        "id": 94013,
                        "name": "Dragodănești",
                        "latitude": "45.05552000",
                        "longitude": "25.23631000"
                    },
                    {
                        "id": 94018,
                        "name": "Dragomireşti",
                        "latitude": "44.91667000",
                        "longitude": "25.33333000"
                    },
                    {
                        "id": 94243,
                        "name": "Fântânele",
                        "latitude": "44.71667000",
                        "longitude": "25.86667000"
                    },
                    {
                        "id": 94164,
                        "name": "Fieni",
                        "latitude": "45.13333000",
                        "longitude": "25.41667000"
                    },
                    {
                        "id": 94166,
                        "name": "Fierbinți",
                        "latitude": "44.50747000",
                        "longitude": "25.28760000"
                    },
                    {
                        "id": 94179,
                        "name": "Finta Mare",
                        "latitude": "44.80000000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 94496,
                        "name": "Găeşti",
                        "latitude": "44.71667000",
                        "longitude": "25.31667000"
                    },
                    {
                        "id": 94288,
                        "name": "Gemenea Brătulești",
                        "latitude": "45.10839000",
                        "longitude": "25.23155000"
                    },
                    {
                        "id": 94296,
                        "name": "Gheboaia",
                        "latitude": "44.80203000",
                        "longitude": "25.74875000"
                    },
                    {
                        "id": 94297,
                        "name": "Gheboieni",
                        "latitude": "44.98701000",
                        "longitude": "25.30670000"
                    },
                    {
                        "id": 94330,
                        "name": "Ghinești",
                        "latitude": "44.74774000",
                        "longitude": "25.55300000"
                    },
                    {
                        "id": 94336,
                        "name": "Ghirdoveni",
                        "latitude": "44.94059000",
                        "longitude": "25.67368000"
                    },
                    {
                        "id": 94359,
                        "name": "Glod",
                        "latitude": "45.24163000",
                        "longitude": "25.44994000"
                    },
                    {
                        "id": 94362,
                        "name": "Glodeni",
                        "latitude": "45.01667000",
                        "longitude": "25.46667000"
                    },
                    {
                        "id": 94386,
                        "name": "Gorgota",
                        "latitude": "44.97626000",
                        "longitude": "25.50837000"
                    },
                    {
                        "id": 94407,
                        "name": "Greci",
                        "latitude": "44.66132000",
                        "longitude": "25.34346000"
                    },
                    {
                        "id": 94424,
                        "name": "Grozăvești",
                        "latitude": "44.56882000",
                        "longitude": "25.45360000"
                    },
                    {
                        "id": 94449,
                        "name": "Gulia",
                        "latitude": "44.54687000",
                        "longitude": "25.87304000"
                    },
                    {
                        "id": 94453,
                        "name": "Gura Foii",
                        "latitude": "44.75000000",
                        "longitude": "25.28333000"
                    },
                    {
                        "id": 94456,
                        "name": "Gura Ocniței",
                        "latitude": "44.94166000",
                        "longitude": "25.56846000"
                    },
                    {
                        "id": 94467,
                        "name": "Gura Şuţii",
                        "latitude": "44.75000000",
                        "longitude": "25.51667000"
                    },
                    {
                        "id": 94464,
                        "name": "Gura Vulcanei",
                        "latitude": "45.02442000",
                        "longitude": "25.39596000"
                    },
                    {
                        "id": 94595,
                        "name": "Hăbeni",
                        "latitude": "44.85629000",
                        "longitude": "25.62873000"
                    },
                    {
                        "id": 94573,
                        "name": "Hulubeşti",
                        "latitude": "44.83333000",
                        "longitude": "25.23333000"
                    },
                    {
                        "id": 94612,
                        "name": "I. L. Caragiale",
                        "latitude": "44.90963000",
                        "longitude": "25.70251000"
                    },
                    {
                        "id": 94626,
                        "name": "Iazu",
                        "latitude": "44.71764000",
                        "longitude": "25.83119000"
                    },
                    {
                        "id": 94631,
                        "name": "Ibrianu",
                        "latitude": "44.77509000",
                        "longitude": "25.84375000"
                    },
                    {
                        "id": 94641,
                        "name": "Iedera de Jos",
                        "latitude": "45.03333000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 94642,
                        "name": "Iedera de Sus",
                        "latitude": "45.04174000",
                        "longitude": "25.63084000"
                    },
                    {
                        "id": 94679,
                        "name": "Ionești",
                        "latitude": "44.69374000",
                        "longitude": "25.27780000"
                    },
                    {
                        "id": 94705,
                        "name": "Izvoarele",
                        "latitude": "45.03333000",
                        "longitude": "25.26667000"
                    },
                    {
                        "id": 94889,
                        "name": "Lăculețe",
                        "latitude": "45.01837000",
                        "longitude": "25.43108000"
                    },
                    {
                        "id": 94765,
                        "name": "Lazuri",
                        "latitude": "44.87859000",
                        "longitude": "25.54964000"
                    },
                    {
                        "id": 94837,
                        "name": "Lucieni",
                        "latitude": "44.85000000",
                        "longitude": "25.43333000"
                    },
                    {
                        "id": 94842,
                        "name": "Ludeşti",
                        "latitude": "44.86667000",
                        "longitude": "25.23333000"
                    },
                    {
                        "id": 94856,
                        "name": "Lunca",
                        "latitude": "45.20022000",
                        "longitude": "25.44351000"
                    },
                    {
                        "id": 94882,
                        "name": "Lunguleţu",
                        "latitude": "44.61667000",
                        "longitude": "25.65000000"
                    },
                    {
                        "id": 94919,
                        "name": "Malu cu Flori",
                        "latitude": "45.15000000",
                        "longitude": "25.20000000"
                    },
                    {
                        "id": 95259,
                        "name": "Măneşti",
                        "latitude": "44.96667000",
                        "longitude": "25.28333000"
                    },
                    {
                        "id": 95266,
                        "name": "Mărcești",
                        "latitude": "44.80537000",
                        "longitude": "25.70951000"
                    },
                    {
                        "id": 95273,
                        "name": "Mărginenii de Sus",
                        "latitude": "44.93172000",
                        "longitude": "25.75228000"
                    },
                    {
                        "id": 95291,
                        "name": "Mătăsaru",
                        "latitude": "44.71667000",
                        "longitude": "25.41667000"
                    },
                    {
                        "id": 94938,
                        "name": "Mavrodin",
                        "latitude": "44.64919000",
                        "longitude": "25.71731000"
                    },
                    {
                        "id": 94998,
                        "name": "Mija",
                        "latitude": "44.91356000",
                        "longitude": "25.67585000"
                    },
                    {
                        "id": 95052,
                        "name": "Mogoşani",
                        "latitude": "44.68333000",
                        "longitude": "25.40000000"
                    },
                    {
                        "id": 95071,
                        "name": "Moreni",
                        "latitude": "44.98301000",
                        "longitude": "25.64415000"
                    },
                    {
                        "id": 95072,
                        "name": "Moroeni",
                        "latitude": "45.21667000",
                        "longitude": "25.43333000"
                    },
                    {
                        "id": 95073,
                        "name": "Morteni",
                        "latitude": "44.66667000",
                        "longitude": "25.23333000"
                    },
                    {
                        "id": 95097,
                        "name": "Moțăieni",
                        "latitude": "45.10000000",
                        "longitude": "25.41667000"
                    },
                    {
                        "id": 95158,
                        "name": "Municipiul Moreni",
                        "latitude": "44.98010000",
                        "longitude": "25.64381000"
                    },
                    {
                        "id": 95191,
                        "name": "Municipiul Târgovişte",
                        "latitude": "44.92616000",
                        "longitude": "25.45498000"
                    },
                    {
                        "id": 95342,
                        "name": "Niculești",
                        "latitude": "44.68266000",
                        "longitude": "25.94221000"
                    },
                    {
                        "id": 95359,
                        "name": "Nucet",
                        "latitude": "44.78333000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 95400,
                        "name": "Ocniţa",
                        "latitude": "44.98333000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 95405,
                        "name": "Odaia Turcului",
                        "latitude": "44.69777000",
                        "longitude": "25.45082000"
                    },
                    {
                        "id": 95406,
                        "name": "Odobeşti",
                        "latitude": "44.61667000",
                        "longitude": "25.56667000"
                    },
                    {
                        "id": 95515,
                        "name": "Oraş Fieni",
                        "latitude": "45.13054000",
                        "longitude": "25.41094000"
                    },
                    {
                        "id": 95526,
                        "name": "Oraş Gãeşti",
                        "latitude": "44.72003000",
                        "longitude": "25.32040000"
                    },
                    {
                        "id": 95574,
                        "name": "Oraş Pucioasa",
                        "latitude": "45.07570000",
                        "longitude": "25.43335000"
                    },
                    {
                        "id": 95582,
                        "name": "Oraş Rãcari",
                        "latitude": "44.66037000",
                        "longitude": "25.74703000"
                    },
                    {
                        "id": 95604,
                        "name": "Oraş Titu",
                        "latitude": "44.65747000",
                        "longitude": "25.55549000"
                    },
                    {
                        "id": 95741,
                        "name": "Perșinari",
                        "latitude": "44.80185000",
                        "longitude": "25.49880000"
                    },
                    {
                        "id": 95746,
                        "name": "Petreşti",
                        "latitude": "44.65000000",
                        "longitude": "25.33333000"
                    },
                    {
                        "id": 95774,
                        "name": "Picior de Munte",
                        "latitude": "44.78247000",
                        "longitude": "25.39047000"
                    },
                    {
                        "id": 95776,
                        "name": "Pietrari",
                        "latitude": "45.09377000",
                        "longitude": "25.29289000"
                    },
                    {
                        "id": 95790,
                        "name": "Pietroşiţa",
                        "latitude": "45.18333000",
                        "longitude": "25.43333000"
                    },
                    {
                        "id": 95801,
                        "name": "Pitaru",
                        "latitude": "44.59061000",
                        "longitude": "25.58407000"
                    },
                    {
                        "id": 95865,
                        "name": "Poiana",
                        "latitude": "44.56667000",
                        "longitude": "25.68333000"
                    },
                    {
                        "id": 95933,
                        "name": "Potlogi",
                        "latitude": "44.55000000",
                        "longitude": "25.58333000"
                    },
                    {
                        "id": 95949,
                        "name": "Priboiu",
                        "latitude": "45.03006000",
                        "longitude": "25.25790000"
                    },
                    {
                        "id": 95959,
                        "name": "Produleşti",
                        "latitude": "44.70000000",
                        "longitude": "25.50000000"
                    },
                    {
                        "id": 95972,
                        "name": "Pucheni",
                        "latitude": "45.18333000",
                        "longitude": "25.28333000"
                    },
                    {
                        "id": 95975,
                        "name": "Pucioasa",
                        "latitude": "45.07807000",
                        "longitude": "25.43232000"
                    },
                    {
                        "id": 96182,
                        "name": "Răcari",
                        "latitude": "44.63333000",
                        "longitude": "25.73333000"
                    },
                    {
                        "id": 96039,
                        "name": "Raciu",
                        "latitude": "44.81791000",
                        "longitude": "25.44106000"
                    },
                    {
                        "id": 96047,
                        "name": "Racovița",
                        "latitude": "44.83927000",
                        "longitude": "25.62082000"
                    },
                    {
                        "id": 96172,
                        "name": "Râncăciov",
                        "latitude": "44.88872000",
                        "longitude": "25.35778000"
                    },
                    {
                        "id": 96206,
                        "name": "Răscăeți",
                        "latitude": "44.59221000",
                        "longitude": "25.26990000"
                    },
                    {
                        "id": 96174,
                        "name": "Râu Alb de Jos",
                        "latitude": "45.13653000",
                        "longitude": "25.34745000"
                    },
                    {
                        "id": 96216,
                        "name": "Răzvad",
                        "latitude": "44.93333000",
                        "longitude": "25.53333000"
                    },
                    {
                        "id": 96111,
                        "name": "Românești",
                        "latitude": "44.56667000",
                        "longitude": "25.61667000"
                    },
                    {
                        "id": 96153,
                        "name": "Runcu",
                        "latitude": "45.18333000",
                        "longitude": "25.38333000"
                    },
                    {
                        "id": 105996,
                        "name": "Săcueni",
                        "latitude": "44.91077000",
                        "longitude": "25.57223000"
                    },
                    {
                        "id": 106011,
                        "name": "Sălcioara",
                        "latitude": "44.71667000",
                        "longitude": "25.58333000"
                    },
                    {
                        "id": 106016,
                        "name": "Sălcuța",
                        "latitude": "44.64374000",
                        "longitude": "25.58103000"
                    },
                    {
                        "id": 106040,
                        "name": "Săteni",
                        "latitude": "44.97129000",
                        "longitude": "25.41683000"
                    },
                    {
                        "id": 96266,
                        "name": "Scheiu de Jos",
                        "latitude": "44.93460000",
                        "longitude": "25.19986000"
                    },
                    {
                        "id": 96267,
                        "name": "Scheiu de Sus",
                        "latitude": "44.95602000",
                        "longitude": "25.19317000"
                    },
                    {
                        "id": 97035,
                        "name": "Şelaru",
                        "latitude": "44.47667000",
                        "longitude": "25.29997000"
                    },
                    {
                        "id": 96326,
                        "name": "Serdanu",
                        "latitude": "44.62732000",
                        "longitude": "25.63124000"
                    },
                    {
                        "id": 96376,
                        "name": "Slobozia Moara",
                        "latitude": "44.60000000",
                        "longitude": "25.71667000"
                    },
                    {
                        "id": 97074,
                        "name": "Şotânga",
                        "latitude": "44.98333000",
                        "longitude": "25.36667000"
                    },
                    {
                        "id": 96414,
                        "name": "Speriețeni",
                        "latitude": "44.76611000",
                        "longitude": "25.45223000"
                    },
                    {
                        "id": 96512,
                        "name": "Suseni Socetu",
                        "latitude": "44.75618000",
                        "longitude": "25.79829000"
                    },
                    {
                        "id": 96580,
                        "name": "Târgovişte",
                        "latitude": "44.92543000",
                        "longitude": "25.45670000"
                    },
                    {
                        "id": 96613,
                        "name": "Tărtăşeşti",
                        "latitude": "44.57722000",
                        "longitude": "25.81278000"
                    },
                    {
                        "id": 96617,
                        "name": "Tătărani",
                        "latitude": "45.00000000",
                        "longitude": "25.26667000"
                    },
                    {
                        "id": 106074,
                        "name": "Teiș",
                        "latitude": "44.96285000",
                        "longitude": "25.40280000"
                    },
                    {
                        "id": 106091,
                        "name": "Tețcoiu",
                        "latitude": "44.68188000",
                        "longitude": "25.43846000"
                    },
                    {
                        "id": 106110,
                        "name": "Titu",
                        "latitude": "44.65000000",
                        "longitude": "25.53333000"
                    },
                    {
                        "id": 96643,
                        "name": "Ulieşti",
                        "latitude": "44.58333000",
                        "longitude": "25.41667000"
                    },
                    {
                        "id": 96649,
                        "name": "Ulmi",
                        "latitude": "44.90000000",
                        "longitude": "25.50000000"
                    },
                    {
                        "id": 96658,
                        "name": "Ungureni",
                        "latitude": "44.57804000",
                        "longitude": "25.50006000"
                    },
                    {
                        "id": 96686,
                        "name": "Urziceanca",
                        "latitude": "44.63052000",
                        "longitude": "25.84240000"
                    },
                    {
                        "id": 96952,
                        "name": "Văcăreşti",
                        "latitude": "44.85000000",
                        "longitude": "25.48333000"
                    },
                    {
                        "id": 96728,
                        "name": "Valea Leurzii",
                        "latitude": "45.16186000",
                        "longitude": "25.48533000"
                    },
                    {
                        "id": 96730,
                        "name": "Valea Lungă Ogrea",
                        "latitude": "45.05978000",
                        "longitude": "25.59024000"
                    },
                    {
                        "id": 96731,
                        "name": "Valea Lungă-Cricov",
                        "latitude": "45.06528000",
                        "longitude": "25.58793000"
                    },
                    {
                        "id": 96734,
                        "name": "Valea Mare",
                        "latitude": "44.78333000",
                        "longitude": "25.23333000"
                    },
                    {
                        "id": 96765,
                        "name": "Valea Voievozilor",
                        "latitude": "44.93805000",
                        "longitude": "25.48518000"
                    },
                    {
                        "id": 96963,
                        "name": "Văleni-Dâmbovița",
                        "latitude": "45.16667000",
                        "longitude": "25.18333000"
                    },
                    {
                        "id": 96939,
                        "name": "Vârfuri",
                        "latitude": "45.10000000",
                        "longitude": "25.51667000"
                    },
                    {
                        "id": 96813,
                        "name": "Viforâta",
                        "latitude": "44.96011000",
                        "longitude": "25.45796000"
                    },
                    {
                        "id": 96826,
                        "name": "Viișoara",
                        "latitude": "44.88116000",
                        "longitude": "25.42730000"
                    },
                    {
                        "id": 96849,
                        "name": "Vişina",
                        "latitude": "44.58333000",
                        "longitude": "25.33333000"
                    },
                    {
                        "id": 96851,
                        "name": "Vişineşti",
                        "latitude": "45.10000000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 96845,
                        "name": "Vizurești",
                        "latitude": "44.64040000",
                        "longitude": "25.80740000"
                    },
                    {
                        "id": 96861,
                        "name": "Vlădeni",
                        "latitude": "44.87550000",
                        "longitude": "25.77318000"
                    },
                    {
                        "id": 96871,
                        "name": "Vlăsceni",
                        "latitude": "44.58522000",
                        "longitude": "25.59931000"
                    },
                    {
                        "id": 96879,
                        "name": "Voineşti",
                        "latitude": "45.06667000",
                        "longitude": "25.25000000"
                    },
                    {
                        "id": 96902,
                        "name": "Vulcana Băi",
                        "latitude": "45.07982000",
                        "longitude": "25.38219000"
                    },
                    {
                        "id": 96903,
                        "name": "Vulcana de Sus",
                        "latitude": "45.10125000",
                        "longitude": "25.35826000"
                    },
                    {
                        "id": 96904,
                        "name": "Vulcana-Pandele",
                        "latitude": "45.01558000",
                        "longitude": "25.39319000"
                    },
                    {
                        "id": 97023,
                        "name": "Zăvoiu",
                        "latitude": "44.66038000",
                        "longitude": "25.40350000"
                    },
                    {
                        "id": 96992,
                        "name": "Zidurile",
                        "latitude": "44.58176000",
                        "longitude": "25.55458000"
                    }
                ]
            },
            {
                "id": 4742,
                "name": "Dolj",
                "iso2": "DJ",
                "latitude": "44.16230220",
                "longitude": "23.63250540",
                "type": "department",
                "cities": [
                    {
                        "id": 89890,
                        "name": "Afumaţi",
                        "latitude": "44.00000000",
                        "longitude": "23.46667000"
                    },
                    {
                        "id": 89938,
                        "name": "Almăj",
                        "latitude": "44.45000000",
                        "longitude": "23.71667000"
                    },
                    {
                        "id": 89952,
                        "name": "Amărăştii de Jos",
                        "latitude": "43.95000000",
                        "longitude": "24.16667000"
                    },
                    {
                        "id": 89953,
                        "name": "Amărăştii de Sus",
                        "latitude": "43.98333000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 89972,
                        "name": "Apele Vii",
                        "latitude": "44.06667000",
                        "longitude": "24.06667000"
                    },
                    {
                        "id": 89987,
                        "name": "Argetoaia",
                        "latitude": "44.51667000",
                        "longitude": "23.36667000"
                    },
                    {
                        "id": 90484,
                        "name": "Bădoși",
                        "latitude": "44.14723000",
                        "longitude": "23.88974000"
                    },
                    {
                        "id": 90494,
                        "name": "Băileşti",
                        "latitude": "44.01667000",
                        "longitude": "23.35000000"
                    },
                    {
                        "id": 90442,
                        "name": "Bâlta",
                        "latitude": "44.53564000",
                        "longitude": "23.47019000"
                    },
                    {
                        "id": 90446,
                        "name": "Bârca",
                        "latitude": "43.96667000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 90067,
                        "name": "Basarabi",
                        "latitude": "44.00561000",
                        "longitude": "23.00915000"
                    },
                    {
                        "id": 90076,
                        "name": "Bechet",
                        "latitude": "43.78188000",
                        "longitude": "23.95706000"
                    },
                    {
                        "id": 90146,
                        "name": "Bistreț",
                        "latitude": "43.90000000",
                        "longitude": "23.50000000"
                    },
                    {
                        "id": 90249,
                        "name": "Botoşeşti-Paia",
                        "latitude": "44.40000000",
                        "longitude": "23.26667000"
                    },
                    {
                        "id": 90250,
                        "name": "Boureni",
                        "latitude": "44.01589000",
                        "longitude": "23.43393000"
                    },
                    {
                        "id": 90258,
                        "name": "Brabeți",
                        "latitude": "43.96098000",
                        "longitude": "24.01339000"
                    },
                    {
                        "id": 90259,
                        "name": "Brabova",
                        "latitude": "44.36667000",
                        "longitude": "23.43333000"
                    },
                    {
                        "id": 90324,
                        "name": "Brădeşti",
                        "latitude": "44.48333000",
                        "longitude": "23.63333000"
                    },
                    {
                        "id": 90265,
                        "name": "Braloştiţa",
                        "latitude": "44.50000000",
                        "longitude": "23.51667000"
                    },
                    {
                        "id": 90277,
                        "name": "Bratovoești",
                        "latitude": "44.13333000",
                        "longitude": "23.90000000"
                    },
                    {
                        "id": 90282,
                        "name": "Breasta",
                        "latitude": "44.33333000",
                        "longitude": "23.68333000"
                    },
                    {
                        "id": 90360,
                        "name": "Bucovăţ",
                        "latitude": "44.30000000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 90405,
                        "name": "Bulzeşti",
                        "latitude": "44.53333000",
                        "longitude": "23.88333000"
                    },
                    {
                        "id": 90562,
                        "name": "Calafat",
                        "latitude": "43.99069000",
                        "longitude": "22.93328000"
                    },
                    {
                        "id": 93850,
                        "name": "Călăraşi",
                        "latitude": "43.80000000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 90565,
                        "name": "Calopăr",
                        "latitude": "44.16502000",
                        "longitude": "23.76060000"
                    },
                    {
                        "id": 90577,
                        "name": "Caraula",
                        "latitude": "44.18333000",
                        "longitude": "23.25000000"
                    },
                    {
                        "id": 93809,
                        "name": "Cârcea",
                        "latitude": "44.26917000",
                        "longitude": "23.90007000"
                    },
                    {
                        "id": 93817,
                        "name": "Cârna",
                        "latitude": "43.88613000",
                        "longitude": "23.60153000"
                    },
                    {
                        "id": 90581,
                        "name": "Carpen",
                        "latitude": "44.33333000",
                        "longitude": "23.25000000"
                    },
                    {
                        "id": 90585,
                        "name": "Castranova",
                        "latitude": "44.11667000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 90586,
                        "name": "Castrele Traiane",
                        "latitude": "44.22865000",
                        "longitude": "23.13921000"
                    },
                    {
                        "id": 90589,
                        "name": "Catane",
                        "latitude": "43.92671000",
                        "longitude": "23.41178000"
                    },
                    {
                        "id": 90612,
                        "name": "Celaru",
                        "latitude": "44.05000000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 90644,
                        "name": "Cerăt",
                        "latitude": "44.06667000",
                        "longitude": "23.66667000"
                    },
                    {
                        "id": 90639,
                        "name": "Cernăteşti",
                        "latitude": "44.45000000",
                        "longitude": "23.43333000"
                    },
                    {
                        "id": 90631,
                        "name": "Cernele",
                        "latitude": "44.33363000",
                        "longitude": "23.74140000"
                    },
                    {
                        "id": 90647,
                        "name": "Cetate",
                        "latitude": "44.10000000",
                        "longitude": "23.05000000"
                    },
                    {
                        "id": 90727,
                        "name": "Cioroiași",
                        "latitude": "44.08333000",
                        "longitude": "23.45000000"
                    },
                    {
                        "id": 90755,
                        "name": "Ciupercenii Noi",
                        "latitude": "43.90972000",
                        "longitude": "22.94833000"
                    },
                    {
                        "id": 90756,
                        "name": "Ciupercenii Vechi",
                        "latitude": "43.94512000",
                        "longitude": "22.89469000"
                    },
                    {
                        "id": 90764,
                        "name": "Cleanov",
                        "latitude": "44.35288000",
                        "longitude": "23.21032000"
                    },
                    {
                        "id": 90815,
                        "name": "Comoșteni",
                        "latitude": "43.87405000",
                        "longitude": "23.86356000"
                    },
                    {
                        "id": 90827,
                        "name": "Comuna Afumaţi",
                        "latitude": "43.99793000",
                        "longitude": "23.44386000"
                    },
                    {
                        "id": 90858,
                        "name": "Comuna Almãj",
                        "latitude": "44.44093000",
                        "longitude": "23.70915000"
                    },
                    {
                        "id": 90866,
                        "name": "Comuna Amărăştii de Jos",
                        "latitude": "43.92611000",
                        "longitude": "24.16076000"
                    },
                    {
                        "id": 90867,
                        "name": "Comuna Amărăştii de Sus",
                        "latitude": "43.98588000",
                        "longitude": "24.16715000"
                    },
                    {
                        "id": 90879,
                        "name": "Comuna Apele Vii",
                        "latitude": "44.06658000",
                        "longitude": "24.06611000"
                    },
                    {
                        "id": 90889,
                        "name": "Comuna Argetoaia",
                        "latitude": "44.50920000",
                        "longitude": "23.37593000"
                    },
                    {
                        "id": 91185,
                        "name": "Comuna Bârca",
                        "latitude": "43.96954000",
                        "longitude": "23.61782000"
                    },
                    {
                        "id": 90997,
                        "name": "Comuna Bistreţ",
                        "latitude": "43.90162000",
                        "longitude": "23.52291000"
                    },
                    {
                        "id": 91065,
                        "name": "Comuna Botoşeşti-Paia",
                        "latitude": "44.40390000",
                        "longitude": "23.26381000"
                    },
                    {
                        "id": 91072,
                        "name": "Comuna Brabova",
                        "latitude": "44.35864000",
                        "longitude": "23.39816000"
                    },
                    {
                        "id": 91114,
                        "name": "Comuna Brădeşti",
                        "latitude": "44.51766000",
                        "longitude": "23.61747000"
                    },
                    {
                        "id": 91075,
                        "name": "Comuna Braloştiţa",
                        "latitude": "44.50483000",
                        "longitude": "23.49123000"
                    },
                    {
                        "id": 91085,
                        "name": "Comuna Bratovoeşti",
                        "latitude": "44.13725000",
                        "longitude": "23.91445000"
                    },
                    {
                        "id": 91088,
                        "name": "Comuna Breasta",
                        "latitude": "44.34924000",
                        "longitude": "23.67073000"
                    },
                    {
                        "id": 91136,
                        "name": "Comuna Bucovăţ",
                        "latitude": "44.29453000",
                        "longitude": "23.69512000"
                    },
                    {
                        "id": 91160,
                        "name": "Comuna Bulzeşti",
                        "latitude": "44.59126000",
                        "longitude": "23.87180000"
                    },
                    {
                        "id": 91577,
                        "name": "Comuna Călăraşi",
                        "latitude": "43.78416000",
                        "longitude": "24.04076000"
                    },
                    {
                        "id": 91254,
                        "name": "Comuna Calopăru",
                        "latitude": "44.15560000",
                        "longitude": "23.75966000"
                    },
                    {
                        "id": 91259,
                        "name": "Comuna Caraula",
                        "latitude": "44.19287000",
                        "longitude": "23.25298000"
                    },
                    {
                        "id": 91549,
                        "name": "Comuna Cârcea",
                        "latitude": "44.26856000",
                        "longitude": "23.89801000"
                    },
                    {
                        "id": 91554,
                        "name": "Comuna Cârna",
                        "latitude": "43.88613000",
                        "longitude": "23.60153000"
                    },
                    {
                        "id": 91262,
                        "name": "Comuna Carpen",
                        "latitude": "44.34169000",
                        "longitude": "23.26059000"
                    },
                    {
                        "id": 91265,
                        "name": "Comuna Castranova",
                        "latitude": "44.12778000",
                        "longitude": "24.01240000"
                    },
                    {
                        "id": 91267,
                        "name": "Comuna Catane",
                        "latitude": "43.92584000",
                        "longitude": "23.41332000"
                    },
                    {
                        "id": 91279,
                        "name": "Comuna Celaru",
                        "latitude": "44.04192000",
                        "longitude": "24.11972000"
                    },
                    {
                        "id": 91301,
                        "name": "Comuna Cerãt",
                        "latitude": "44.07358000",
                        "longitude": "23.67078000"
                    },
                    {
                        "id": 91295,
                        "name": "Comuna Cernăteşti",
                        "latitude": "44.44315000",
                        "longitude": "23.47578000"
                    },
                    {
                        "id": 91304,
                        "name": "Comuna Cetate",
                        "latitude": "44.09894000",
                        "longitude": "23.06370000"
                    },
                    {
                        "id": 91355,
                        "name": "Comuna Cioroiaşi",
                        "latitude": "44.08624000",
                        "longitude": "23.45207000"
                    },
                    {
                        "id": 91374,
                        "name": "Comuna Ciupercenii Noi",
                        "latitude": "43.92186000",
                        "longitude": "22.95877000"
                    },
                    {
                        "id": 91477,
                        "name": "Comuna Coşoveni",
                        "latitude": "44.24628000",
                        "longitude": "23.93612000"
                    },
                    {
                        "id": 91480,
                        "name": "Comuna Coţofenii din Dos",
                        "latitude": "44.41282000",
                        "longitude": "23.64369000"
                    },
                    {
                        "id": 91481,
                        "name": "Comuna Coţofenii din Faţă",
                        "latitude": "44.45275000",
                        "longitude": "23.67053000"
                    },
                    {
                        "id": 91741,
                        "name": "Comuna Dăneţi",
                        "latitude": "43.97750000",
                        "longitude": "24.04015000"
                    },
                    {
                        "id": 91617,
                        "name": "Comuna Desa",
                        "latitude": "43.87038000",
                        "longitude": "23.03236000"
                    },
                    {
                        "id": 91629,
                        "name": "Comuna Dioşti",
                        "latitude": "44.12923000",
                        "longitude": "24.17156000"
                    },
                    {
                        "id": 91636,
                        "name": "Comuna Dobreşti",
                        "latitude": "43.96771000",
                        "longitude": "23.95341000"
                    },
                    {
                        "id": 91643,
                        "name": "Comuna Dobroteşti",
                        "latitude": "43.96749000",
                        "longitude": "24.12835000"
                    },
                    {
                        "id": 91692,
                        "name": "Comuna Drăgoteşti",
                        "latitude": "44.25774000",
                        "longitude": "24.08138000"
                    },
                    {
                        "id": 91685,
                        "name": "Comuna Drãnic",
                        "latitude": "44.05601000",
                        "longitude": "23.84033000"
                    },
                    {
                        "id": 91815,
                        "name": "Comuna Fãrcaş",
                        "latitude": "44.61267000",
                        "longitude": "23.74081000"
                    },
                    {
                        "id": 91831,
                        "name": "Comuna Galicea Mare",
                        "latitude": "44.09805000",
                        "longitude": "23.30967000"
                    },
                    {
                        "id": 91832,
                        "name": "Comuna Galiciuica",
                        "latitude": "44.10189000",
                        "longitude": "23.38921000"
                    },
                    {
                        "id": 91963,
                        "name": "Comuna Gângiova",
                        "latitude": "43.88621000",
                        "longitude": "23.86161000"
                    },
                    {
                        "id": 91844,
                        "name": "Comuna Gherceşti",
                        "latitude": "44.38567000",
                        "longitude": "23.92481000"
                    },
                    {
                        "id": 91852,
                        "name": "Comuna Ghidici",
                        "latitude": "43.88899000",
                        "longitude": "23.19454000"
                    },
                    {
                        "id": 91858,
                        "name": "Comuna Ghindeni",
                        "latitude": "44.21223000",
                        "longitude": "23.92336000"
                    },
                    {
                        "id": 91867,
                        "name": "Comuna Gighera",
                        "latitude": "43.84806000",
                        "longitude": "23.80590000"
                    },
                    {
                        "id": 91873,
                        "name": "Comuna Giubega",
                        "latitude": "44.12821000",
                        "longitude": "23.41164000"
                    },
                    {
                        "id": 91877,
                        "name": "Comuna Giurgiţa",
                        "latitude": "44.00721000",
                        "longitude": "23.63050000"
                    },
                    {
                        "id": 91891,
                        "name": "Comuna Gogoşu",
                        "latitude": "44.41717000",
                        "longitude": "23.37842000"
                    },
                    {
                        "id": 91894,
                        "name": "Comuna Goicea",
                        "latitude": "43.92623000",
                        "longitude": "23.61845000"
                    },
                    {
                        "id": 91895,
                        "name": "Comuna Goieşti",
                        "latitude": "44.48627000",
                        "longitude": "23.75375000"
                    },
                    {
                        "id": 91914,
                        "name": "Comuna Greceşti",
                        "latitude": "44.45468000",
                        "longitude": "23.26394000"
                    },
                    {
                        "id": 93493,
                        "name": "Comuna Întorsura",
                        "latitude": "44.11226000",
                        "longitude": "23.57574000"
                    },
                    {
                        "id": 92113,
                        "name": "Comuna Işalniţa",
                        "latitude": "44.39390000",
                        "longitude": "23.73711000"
                    },
                    {
                        "id": 92102,
                        "name": "Comuna Izvoare",
                        "latitude": "44.15000000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 92159,
                        "name": "Comuna Leu",
                        "latitude": "44.17207000",
                        "longitude": "24.04971000"
                    },
                    {
                        "id": 92168,
                        "name": "Comuna Lipovu",
                        "latitude": "44.11342000",
                        "longitude": "23.62736000"
                    },
                    {
                        "id": 92378,
                        "name": "Comuna Măceşu de Jos",
                        "latitude": "43.87966000",
                        "longitude": "23.68954000"
                    },
                    {
                        "id": 92379,
                        "name": "Comuna Măceşu de Sus",
                        "latitude": "43.91667000",
                        "longitude": "23.71126000"
                    },
                    {
                        "id": 92228,
                        "name": "Comuna Maglavit",
                        "latitude": "44.04339000",
                        "longitude": "23.09854000"
                    },
                    {
                        "id": 92236,
                        "name": "Comuna Malu Mare",
                        "latitude": "44.23844000",
                        "longitude": "23.85570000"
                    },
                    {
                        "id": 92374,
                        "name": "Comuna Mârşani",
                        "latitude": "44.01157000",
                        "longitude": "24.01919000"
                    },
                    {
                        "id": 92253,
                        "name": "Comuna Melineşti",
                        "latitude": "44.56310000",
                        "longitude": "23.69530000"
                    },
                    {
                        "id": 92305,
                        "name": "Comuna Mischii",
                        "latitude": "44.42093000",
                        "longitude": "23.86238000"
                    },
                    {
                        "id": 92353,
                        "name": "Comuna Moţăţei",
                        "latitude": "44.08454000",
                        "longitude": "23.18856000"
                    },
                    {
                        "id": 92360,
                        "name": "Comuna Murgaşi",
                        "latitude": "44.54342000",
                        "longitude": "23.82994000"
                    },
                    {
                        "id": 92428,
                        "name": "Comuna Negoi",
                        "latitude": "43.91396000",
                        "longitude": "23.37288000"
                    },
                    {
                        "id": 92512,
                        "name": "Comuna Orodel",
                        "latitude": "44.26414000",
                        "longitude": "23.27390000"
                    },
                    {
                        "id": 92520,
                        "name": "Comuna Ostroveni",
                        "latitude": "43.82121000",
                        "longitude": "23.90789000"
                    },
                    {
                        "id": 92555,
                        "name": "Comuna Perişor",
                        "latitude": "44.15843000",
                        "longitude": "23.49214000"
                    },
                    {
                        "id": 92575,
                        "name": "Comuna Pieleşti",
                        "latitude": "44.35632000",
                        "longitude": "23.97570000"
                    },
                    {
                        "id": 92588,
                        "name": "Comuna Piscu Vechi",
                        "latitude": "43.89938000",
                        "longitude": "23.16364000"
                    },
                    {
                        "id": 92592,
                        "name": "Comuna Pleniţa",
                        "latitude": "44.22532000",
                        "longitude": "23.16364000"
                    },
                    {
                        "id": 92594,
                        "name": "Comuna Pleşoi",
                        "latitude": "44.35380000",
                        "longitude": "23.54284000"
                    },
                    {
                        "id": 92611,
                        "name": "Comuna Podari",
                        "latitude": "44.24394000",
                        "longitude": "23.79217000"
                    },
                    {
                        "id": 92629,
                        "name": "Comuna Poiana Mare",
                        "latitude": "43.92040000",
                        "longitude": "23.06271000"
                    },
                    {
                        "id": 92670,
                        "name": "Comuna Predeşti",
                        "latitude": "44.34640000",
                        "longitude": "23.58506000"
                    },
                    {
                        "id": 92743,
                        "name": "Comuna Radovan",
                        "latitude": "44.17687000",
                        "longitude": "23.58518000"
                    },
                    {
                        "id": 92749,
                        "name": "Comuna Rast",
                        "latitude": "43.88713000",
                        "longitude": "23.28409000"
                    },
                    {
                        "id": 92775,
                        "name": "Comuna Robăneşti",
                        "latitude": "44.30356000",
                        "longitude": "24.00582000"
                    },
                    {
                        "id": 92780,
                        "name": "Comuna Rojişte",
                        "latitude": "44.02515000",
                        "longitude": "23.91865000"
                    },
                    {
                        "id": 92858,
                        "name": "Comuna Sadova",
                        "latitude": "43.88749000",
                        "longitude": "23.94622000"
                    },
                    {
                        "id": 93097,
                        "name": "Comuna Sălcuţa",
                        "latitude": "44.22948000",
                        "longitude": "23.45454000"
                    },
                    {
                        "id": 92904,
                        "name": "Comuna Scăeşti",
                        "latitude": "44.46591000",
                        "longitude": "23.54822000"
                    },
                    {
                        "id": 92909,
                        "name": "Comuna Seaca de Câmp",
                        "latitude": "43.92824000",
                        "longitude": "23.19955000"
                    },
                    {
                        "id": 92910,
                        "name": "Comuna Seaca de Pădure",
                        "latitude": "44.37108000",
                        "longitude": "23.32359000"
                    },
                    {
                        "id": 92912,
                        "name": "Comuna Secu",
                        "latitude": "44.47854000",
                        "longitude": "23.29525000"
                    },
                    {
                        "id": 92933,
                        "name": "Comuna Siliştea Crucii",
                        "latitude": "44.04488000",
                        "longitude": "23.48194000"
                    },
                    {
                        "id": 93523,
                        "name": "Comuna Şimnicu de Sus",
                        "latitude": "44.41283000",
                        "longitude": "23.78863000"
                    },
                    {
                        "id": 92977,
                        "name": "Comuna Sopot",
                        "latitude": "44.39061000",
                        "longitude": "23.51252000"
                    },
                    {
                        "id": 93232,
                        "name": "Comuna Tãlpaş",
                        "latitude": "44.68256000",
                        "longitude": "23.74391000"
                    },
                    {
                        "id": 93132,
                        "name": "Comuna Teasc",
                        "latitude": "44.17820000",
                        "longitude": "23.86390000"
                    },
                    {
                        "id": 93143,
                        "name": "Comuna Terpeziţa",
                        "latitude": "44.30631000",
                        "longitude": "23.49202000"
                    },
                    {
                        "id": 93145,
                        "name": "Comuna Teslui",
                        "latitude": "44.20534000",
                        "longitude": "24.15241000"
                    },
                    {
                        "id": 93577,
                        "name": "Comuna Ţuglui",
                        "latitude": "44.20034000",
                        "longitude": "23.82296000"
                    },
                    {
                        "id": 93276,
                        "name": "Comuna Unirea",
                        "latitude": "44.15811000",
                        "longitude": "23.17936000"
                    },
                    {
                        "id": 93287,
                        "name": "Comuna Urzicuţa",
                        "latitude": "44.01485000",
                        "longitude": "23.56956000"
                    },
                    {
                        "id": 93323,
                        "name": "Comuna Valea Stanciului",
                        "latitude": "43.98333000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 93446,
                        "name": "Comuna Vârtop",
                        "latitude": "44.20873000",
                        "longitude": "23.34831000"
                    },
                    {
                        "id": 93447,
                        "name": "Comuna Vârvoru de Jos",
                        "latitude": "44.24458000",
                        "longitude": "23.60636000"
                    },
                    {
                        "id": 93341,
                        "name": "Comuna Vela",
                        "latitude": "44.28526000",
                        "longitude": "23.37887000"
                    },
                    {
                        "id": 93342,
                        "name": "Comuna Verbiţa",
                        "latitude": "44.29305000",
                        "longitude": "23.17886000"
                    },
                    {
                        "id": 93692,
                        "name": "Coşoveni",
                        "latitude": "44.25000000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 93694,
                        "name": "Coţofenii din Dos",
                        "latitude": "44.43333000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 93701,
                        "name": "Coțofenii din Față",
                        "latitude": "44.45971000",
                        "longitude": "23.65688000"
                    },
                    {
                        "id": 93704,
                        "name": "Craiova",
                        "latitude": "44.31667000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 94114,
                        "name": "Dăbuleni",
                        "latitude": "43.80000000",
                        "longitude": "24.08333000"
                    },
                    {
                        "id": 94129,
                        "name": "Dăneţi",
                        "latitude": "43.98333000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 93925,
                        "name": "Desa",
                        "latitude": "43.86667000",
                        "longitude": "23.03333000"
                    },
                    {
                        "id": 93939,
                        "name": "Dioşti",
                        "latitude": "44.11667000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 93954,
                        "name": "Dobreşti",
                        "latitude": "43.96667000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 93958,
                        "name": "Dobridor",
                        "latitude": "44.11866000",
                        "longitude": "23.16969000"
                    },
                    {
                        "id": 93966,
                        "name": "Dobrotești",
                        "latitude": "43.96141000",
                        "longitude": "24.12405000"
                    },
                    {
                        "id": 94045,
                        "name": "Drăgoteşti",
                        "latitude": "44.25000000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 94065,
                        "name": "Drănic",
                        "latitude": "44.05519000",
                        "longitude": "23.84678000"
                    },
                    {
                        "id": 94250,
                        "name": "Făcăi",
                        "latitude": "44.27356000",
                        "longitude": "23.82029000"
                    },
                    {
                        "id": 94263,
                        "name": "Fărcaș",
                        "latitude": "44.60000000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 94171,
                        "name": "Filiaşi",
                        "latitude": "44.55000000",
                        "longitude": "23.51667000"
                    },
                    {
                        "id": 94203,
                        "name": "Fratoștița",
                        "latitude": "44.58671000",
                        "longitude": "23.57044000"
                    },
                    {
                        "id": 94278,
                        "name": "Galicea Mare",
                        "latitude": "44.10000000",
                        "longitude": "23.30000000"
                    },
                    {
                        "id": 94279,
                        "name": "Galiciuica",
                        "latitude": "44.10324000",
                        "longitude": "23.39067000"
                    },
                    {
                        "id": 94480,
                        "name": "Gângiova",
                        "latitude": "43.90000000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 94317,
                        "name": "Ghidici",
                        "latitude": "43.89103000",
                        "longitude": "23.19454000"
                    },
                    {
                        "id": 94327,
                        "name": "Ghindeni",
                        "latitude": "44.21223000",
                        "longitude": "23.92336000"
                    },
                    {
                        "id": 94338,
                        "name": "Ghizdăvești",
                        "latitude": "44.05757000",
                        "longitude": "24.10811000"
                    },
                    {
                        "id": 94343,
                        "name": "Gighera",
                        "latitude": "43.85000000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 94349,
                        "name": "Giubega",
                        "latitude": "44.12740000",
                        "longitude": "23.40757000"
                    },
                    {
                        "id": 94354,
                        "name": "Giurgiţa",
                        "latitude": "44.01667000",
                        "longitude": "23.63333000"
                    },
                    {
                        "id": 94373,
                        "name": "Gogoşu",
                        "latitude": "44.41667000",
                        "longitude": "23.36667000"
                    },
                    {
                        "id": 94375,
                        "name": "Goicea",
                        "latitude": "43.91667000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 94376,
                        "name": "Goiești",
                        "latitude": "44.48333000",
                        "longitude": "23.76667000"
                    },
                    {
                        "id": 94406,
                        "name": "Greceşti",
                        "latitude": "44.45000000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 94579,
                        "name": "Hunia",
                        "latitude": "44.05532000",
                        "longitude": "23.09893000"
                    },
                    {
                        "id": 97025,
                        "name": "Întorsura",
                        "latitude": "44.11226000",
                        "longitude": "23.57574000"
                    },
                    {
                        "id": 94721,
                        "name": "Işalniţa",
                        "latitude": "44.40000000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 94702,
                        "name": "Izvoare",
                        "latitude": "44.14773000",
                        "longitude": "23.29582000"
                    },
                    {
                        "id": 94789,
                        "name": "Leu",
                        "latitude": "44.18333000",
                        "longitude": "24.00000000"
                    },
                    {
                        "id": 94805,
                        "name": "Lipovu",
                        "latitude": "44.10000000",
                        "longitude": "23.63333000"
                    },
                    {
                        "id": 94827,
                        "name": "Lișteava",
                        "latitude": "43.83418000",
                        "longitude": "23.92022000"
                    },
                    {
                        "id": 95227,
                        "name": "Măceşu de Jos",
                        "latitude": "43.88333000",
                        "longitude": "23.71667000"
                    },
                    {
                        "id": 95228,
                        "name": "Măceşu de Sus",
                        "latitude": "43.91667000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 94904,
                        "name": "Maglavit",
                        "latitude": "44.03333000",
                        "longitude": "23.10000000"
                    },
                    {
                        "id": 94916,
                        "name": "Malu Mare",
                        "latitude": "44.24182000",
                        "longitude": "23.85321000"
                    },
                    {
                        "id": 95223,
                        "name": "Mârşani",
                        "latitude": "44.01667000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 94947,
                        "name": "Melineşti",
                        "latitude": "44.56667000",
                        "longitude": "23.71667000"
                    },
                    {
                        "id": 95027,
                        "name": "Mischii",
                        "latitude": "44.38333000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 95048,
                        "name": "Mofleni",
                        "latitude": "44.30220000",
                        "longitude": "23.75848000"
                    },
                    {
                        "id": 95093,
                        "name": "Moţăţei",
                        "latitude": "44.08333000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 95121,
                        "name": "Municipiul Bãileşti",
                        "latitude": "44.02121000",
                        "longitude": "23.34475000"
                    },
                    {
                        "id": 95122,
                        "name": "Municipiul Calafat",
                        "latitude": "43.98979000",
                        "longitude": "22.93130000"
                    },
                    {
                        "id": 95128,
                        "name": "Municipiul Craiova",
                        "latitude": "44.31943000",
                        "longitude": "23.80875000"
                    },
                    {
                        "id": 95205,
                        "name": "Murgași",
                        "latitude": "44.49968000",
                        "longitude": "23.86698000"
                    },
                    {
                        "id": 95305,
                        "name": "Nedeia",
                        "latitude": "43.84992000",
                        "longitude": "23.77643000"
                    },
                    {
                        "id": 95308,
                        "name": "Negoi",
                        "latitude": "43.91396000",
                        "longitude": "23.37288000"
                    },
                    {
                        "id": 95310,
                        "name": "Negoiești",
                        "latitude": "44.53584000",
                        "longitude": "23.72690000"
                    },
                    {
                        "id": 95403,
                        "name": "Ocolna",
                        "latitude": "43.87917000",
                        "longitude": "24.13405000"
                    },
                    {
                        "id": 95459,
                        "name": "Oraş Bechet",
                        "latitude": "43.78301000",
                        "longitude": "23.95870000"
                    },
                    {
                        "id": 95512,
                        "name": "Oraş Dãbuleni",
                        "latitude": "43.78047000",
                        "longitude": "24.08653000"
                    },
                    {
                        "id": 95517,
                        "name": "Oraş Filiaşi",
                        "latitude": "44.56847000",
                        "longitude": "23.55164000"
                    },
                    {
                        "id": 95586,
                        "name": "Oraş Segarcea",
                        "latitude": "44.09434000",
                        "longitude": "23.74197000"
                    },
                    {
                        "id": 95663,
                        "name": "Orodel",
                        "latitude": "44.23333000",
                        "longitude": "23.23333000"
                    },
                    {
                        "id": 95678,
                        "name": "Ostroveni",
                        "latitude": "43.80000000",
                        "longitude": "23.90000000"
                    },
                    {
                        "id": 95692,
                        "name": "Padea",
                        "latitude": "44.02128000",
                        "longitude": "23.86827000"
                    },
                    {
                        "id": 95738,
                        "name": "Perișor",
                        "latitude": "44.14331000",
                        "longitude": "23.47509000"
                    },
                    {
                        "id": 95775,
                        "name": "Pieleştí",
                        "latitude": "44.33333000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 95798,
                        "name": "Piscu Nou",
                        "latitude": "43.92400000",
                        "longitude": "23.17917000"
                    },
                    {
                        "id": 95799,
                        "name": "Piscu Sadovei",
                        "latitude": "43.87729000",
                        "longitude": "23.93687000"
                    },
                    {
                        "id": 95800,
                        "name": "Piscu Vechi",
                        "latitude": "43.90000000",
                        "longitude": "23.16667000"
                    },
                    {
                        "id": 95809,
                        "name": "Pleniţa",
                        "latitude": "44.21667000",
                        "longitude": "23.18333000"
                    },
                    {
                        "id": 95813,
                        "name": "Pleșoi",
                        "latitude": "44.35077000",
                        "longitude": "23.53345000"
                    },
                    {
                        "id": 95842,
                        "name": "Podari",
                        "latitude": "44.25000000",
                        "longitude": "23.78333000"
                    },
                    {
                        "id": 95876,
                        "name": "Poiana Mare",
                        "latitude": "43.91667000",
                        "longitude": "23.06667000"
                    },
                    {
                        "id": 95918,
                        "name": "Popoveni",
                        "latitude": "44.28800000",
                        "longitude": "23.78208000"
                    },
                    {
                        "id": 95940,
                        "name": "Prapor",
                        "latitude": "43.94487000",
                        "longitude": "24.17475000"
                    },
                    {
                        "id": 95941,
                        "name": "Preajba",
                        "latitude": "44.26511000",
                        "longitude": "23.85024000"
                    },
                    {
                        "id": 95943,
                        "name": "Predeşti",
                        "latitude": "44.35000000",
                        "longitude": "23.60000000"
                    },
                    {
                        "id": 95992,
                        "name": "Puțuri",
                        "latitude": "44.13835000",
                        "longitude": "24.01017000"
                    },
                    {
                        "id": 96183,
                        "name": "Răcarii de Sus",
                        "latitude": "44.53539000",
                        "longitude": "23.55746000"
                    },
                    {
                        "id": 96052,
                        "name": "Radomir",
                        "latitude": "44.12115000",
                        "longitude": "24.16832000"
                    },
                    {
                        "id": 96054,
                        "name": "Radovan",
                        "latitude": "44.16667000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 96062,
                        "name": "Rast",
                        "latitude": "43.88333000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 96103,
                        "name": "Rojiște",
                        "latitude": "44.06683000",
                        "longitude": "23.93898000"
                    },
                    {
                        "id": 96225,
                        "name": "Sadova",
                        "latitude": "43.90000000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 96233,
                        "name": "Salcia",
                        "latitude": "44.48195000",
                        "longitude": "23.44645000"
                    },
                    {
                        "id": 106014,
                        "name": "Sălcuţa",
                        "latitude": "44.25000000",
                        "longitude": "23.43333000"
                    },
                    {
                        "id": 106031,
                        "name": "Sărata",
                        "latitude": "43.77436000",
                        "longitude": "24.03351000"
                    },
                    {
                        "id": 96261,
                        "name": "Satu Nou Calopăr",
                        "latitude": "44.16667000",
                        "longitude": "23.76667000"
                    },
                    {
                        "id": 96295,
                        "name": "Scăeşti",
                        "latitude": "44.46667000",
                        "longitude": "23.58333000"
                    },
                    {
                        "id": 96300,
                        "name": "Seaca de Câmp",
                        "latitude": "43.93333000",
                        "longitude": "23.21667000"
                    },
                    {
                        "id": 96301,
                        "name": "Seaca de Pădure",
                        "latitude": "44.36611000",
                        "longitude": "23.30587000"
                    },
                    {
                        "id": 96313,
                        "name": "Secu",
                        "latitude": "44.46667000",
                        "longitude": "23.30000000"
                    },
                    {
                        "id": 96314,
                        "name": "Secui",
                        "latitude": "44.19186000",
                        "longitude": "23.86319000"
                    },
                    {
                        "id": 96319,
                        "name": "Segarcea",
                        "latitude": "44.10000000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 96331,
                        "name": "Sfârcea",
                        "latitude": "44.48613000",
                        "longitude": "23.54661000"
                    },
                    {
                        "id": 96342,
                        "name": "Siliştea Crucii",
                        "latitude": "44.03333000",
                        "longitude": "23.48333000"
                    },
                    {
                        "id": 97053,
                        "name": "Şimnicu de Sus",
                        "latitude": "44.38333000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 96389,
                        "name": "Smârdan",
                        "latitude": "43.93382000",
                        "longitude": "22.96592000"
                    },
                    {
                        "id": 96412,
                        "name": "Sopot",
                        "latitude": "44.41667000",
                        "longitude": "23.50000000"
                    },
                    {
                        "id": 96603,
                        "name": "Tălpaș",
                        "latitude": "44.68227000",
                        "longitude": "23.74553000"
                    },
                    {
                        "id": 106067,
                        "name": "Teasc",
                        "latitude": "44.16454000",
                        "longitude": "23.86461000"
                    },
                    {
                        "id": 106086,
                        "name": "Terpeziţa",
                        "latitude": "44.29191000",
                        "longitude": "23.50559000"
                    },
                    {
                        "id": 106088,
                        "name": "Teslui",
                        "latitude": "44.20559000",
                        "longitude": "24.15482000"
                    },
                    {
                        "id": 97109,
                        "name": "Ţuglui",
                        "latitude": "44.18333000",
                        "longitude": "23.81667000"
                    },
                    {
                        "id": 96670,
                        "name": "Unirea",
                        "latitude": "44.15000000",
                        "longitude": "23.18333000"
                    },
                    {
                        "id": 96689,
                        "name": "Urzicuţa",
                        "latitude": "44.01667000",
                        "longitude": "23.55000000"
                    },
                    {
                        "id": 96756,
                        "name": "Valea Stanciului",
                        "latitude": "43.98333000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 96947,
                        "name": "Vârtop",
                        "latitude": "44.20682000",
                        "longitude": "23.34869000"
                    },
                    {
                        "id": 96948,
                        "name": "Vârvoru de Jos",
                        "latitude": "44.24415000",
                        "longitude": "23.60790000"
                    },
                    {
                        "id": 96784,
                        "name": "Vela",
                        "latitude": "44.28333000",
                        "longitude": "23.41667000"
                    },
                    {
                        "id": 96785,
                        "name": "Verbiţa",
                        "latitude": "44.30000000",
                        "longitude": "23.16667000"
                    },
                    {
                        "id": 97012,
                        "name": "Zănoaga",
                        "latitude": "44.15511000",
                        "longitude": "24.09832000"
                    },
                    {
                        "id": 97020,
                        "name": "Zăval",
                        "latitude": "43.84717000",
                        "longitude": "23.84208000"
                    }
                ]
            },
            {
                "id": 4747,
                "name": "Galați",
                "iso2": "GL",
                "latitude": "45.78005690",
                "longitude": "27.82515760",
                "type": "department",
                "cities": [
                    {
                        "id": 90519,
                        "name": "Bălăbănești",
                        "latitude": "46.09546000",
                        "longitude": "27.72206000"
                    },
                    {
                        "id": 90525,
                        "name": "Bălăşeşti",
                        "latitude": "46.10000000",
                        "longitude": "27.66667000"
                    },
                    {
                        "id": 90508,
                        "name": "Băleni",
                        "latitude": "45.81667000",
                        "longitude": "27.83333000"
                    },
                    {
                        "id": 90043,
                        "name": "Balintești",
                        "latitude": "46.02937000",
                        "longitude": "27.92201000"
                    },
                    {
                        "id": 90530,
                        "name": "Băneasa",
                        "latitude": "45.93333000",
                        "longitude": "27.93333000"
                    },
                    {
                        "id": 90061,
                        "name": "Barcea",
                        "latitude": "45.75000000",
                        "longitude": "27.46667000"
                    },
                    {
                        "id": 90107,
                        "name": "Berești",
                        "latitude": "46.10000000",
                        "longitude": "27.88333000"
                    },
                    {
                        "id": 90105,
                        "name": "Bereşti-Sat",
                        "latitude": "46.10000000",
                        "longitude": "27.88333000"
                    },
                    {
                        "id": 90162,
                        "name": "Blânzi",
                        "latitude": "45.93575000",
                        "longitude": "27.65063000"
                    },
                    {
                        "id": 90332,
                        "name": "Brăhășești",
                        "latitude": "46.03333000",
                        "longitude": "27.36667000"
                    },
                    {
                        "id": 90331,
                        "name": "Brăhăşeştii de Sus",
                        "latitude": "46.05000000",
                        "longitude": "27.35000000"
                    },
                    {
                        "id": 90270,
                        "name": "Braniştea",
                        "latitude": "45.45000000",
                        "longitude": "27.85000000"
                    },
                    {
                        "id": 90346,
                        "name": "Bucești",
                        "latitude": "45.65250000",
                        "longitude": "27.53008000"
                    },
                    {
                        "id": 90353,
                        "name": "Buciumeni",
                        "latitude": "46.00000000",
                        "longitude": "27.30000000"
                    },
                    {
                        "id": 90591,
                        "name": "Cavadineşti",
                        "latitude": "46.06667000",
                        "longitude": "28.01694000"
                    },
                    {
                        "id": 90645,
                        "name": "Cerţeşti",
                        "latitude": "46.01667000",
                        "longitude": "27.61667000"
                    },
                    {
                        "id": 90675,
                        "name": "Chiraftei",
                        "latitude": "45.77220000",
                        "longitude": "28.02716000"
                    },
                    {
                        "id": 90730,
                        "name": "Ciorăști",
                        "latitude": "46.11380000",
                        "longitude": "27.45311000"
                    },
                    {
                        "id": 90763,
                        "name": "Cișmele",
                        "latitude": "45.51634000",
                        "longitude": "27.92975000"
                    },
                    {
                        "id": 91221,
                        "name": "Comuna Bălăbăneşti",
                        "latitude": "46.07623000",
                        "longitude": "27.75375000"
                    },
                    {
                        "id": 91226,
                        "name": "Comuna Bălăşeşti",
                        "latitude": "46.09003000",
                        "longitude": "27.65844000"
                    },
                    {
                        "id": 91213,
                        "name": "Comuna Băleni",
                        "latitude": "45.80942000",
                        "longitude": "27.85020000"
                    },
                    {
                        "id": 91230,
                        "name": "Comuna Băneasa",
                        "latitude": "45.93008000",
                        "longitude": "27.97963000"
                    },
                    {
                        "id": 90937,
                        "name": "Comuna Barcea",
                        "latitude": "45.74744000",
                        "longitude": "27.46265000"
                    },
                    {
                        "id": 90966,
                        "name": "Comuna Bereşti-Meria",
                        "latitude": "46.10362000",
                        "longitude": "27.92288000"
                    },
                    {
                        "id": 91120,
                        "name": "Comuna Brăhăşeşti",
                        "latitude": "46.06160000",
                        "longitude": "27.36196000"
                    },
                    {
                        "id": 91078,
                        "name": "Comuna Braniştea",
                        "latitude": "45.44141000",
                        "longitude": "27.83240000"
                    },
                    {
                        "id": 91131,
                        "name": "Comuna Buciumeni",
                        "latitude": "45.97702000",
                        "longitude": "27.31922000"
                    },
                    {
                        "id": 91268,
                        "name": "Comuna Cavadineşti",
                        "latitude": "46.08040000",
                        "longitude": "28.01638000"
                    },
                    {
                        "id": 91302,
                        "name": "Comuna Cerţeşti",
                        "latitude": "46.01758000",
                        "longitude": "27.62321000"
                    },
                    {
                        "id": 91440,
                        "name": "Comuna Corni",
                        "latitude": "45.86922000",
                        "longitude": "27.77693000"
                    },
                    {
                        "id": 91445,
                        "name": "Comuna Corod",
                        "latitude": "45.93693000",
                        "longitude": "27.65150000"
                    },
                    {
                        "id": 91449,
                        "name": "Comuna Cosmeşti",
                        "latitude": "45.84926000",
                        "longitude": "27.31605000"
                    },
                    {
                        "id": 91453,
                        "name": "Comuna Costache Negri",
                        "latitude": "45.70518000",
                        "longitude": "27.72342000"
                    },
                    {
                        "id": 91519,
                        "name": "Comuna Cuca",
                        "latitude": "45.73246000",
                        "longitude": "27.89396000"
                    },
                    {
                        "id": 91521,
                        "name": "Comuna Cudalbi",
                        "latitude": "45.77622000",
                        "longitude": "27.68604000"
                    },
                    {
                        "id": 91536,
                        "name": "Comuna Cuza Vodă",
                        "latitude": "45.59595000",
                        "longitude": "27.79267000"
                    },
                    {
                        "id": 91698,
                        "name": "Comuna Drăgăneşti",
                        "latitude": "45.79281000",
                        "longitude": "27.46438000"
                    },
                    {
                        "id": 91695,
                        "name": "Comuna Drăguşeni",
                        "latitude": "46.00203000",
                        "longitude": "27.73297000"
                    },
                    {
                        "id": 91814,
                        "name": "Comuna Fârţăneşti",
                        "latitude": "45.79843000",
                        "longitude": "27.96950000"
                    },
                    {
                        "id": 91777,
                        "name": "Comuna Folteşti",
                        "latitude": "45.72301000",
                        "longitude": "28.06995000"
                    },
                    {
                        "id": 91789,
                        "name": "Comuna Frumuşiţa",
                        "latitude": "45.65593000",
                        "longitude": "28.06631000"
                    },
                    {
                        "id": 91800,
                        "name": "Comuna Fundeni",
                        "latitude": "45.56736000",
                        "longitude": "27.55104000"
                    },
                    {
                        "id": 91853,
                        "name": "Comuna Ghidigeni",
                        "latitude": "46.03356000",
                        "longitude": "27.49210000"
                    },
                    {
                        "id": 91893,
                        "name": "Comuna Gohor",
                        "latitude": "46.01539000",
                        "longitude": "27.42653000"
                    },
                    {
                        "id": 91922,
                        "name": "Comuna Griviţa",
                        "latitude": "45.70040000",
                        "longitude": "27.64104000"
                    },
                    {
                        "id": 92077,
                        "name": "Comuna Independenţa",
                        "latitude": "45.47466000",
                        "longitude": "27.76025000"
                    },
                    {
                        "id": 92098,
                        "name": "Comuna Iveşti",
                        "latitude": "45.66843000",
                        "longitude": "27.52467000"
                    },
                    {
                        "id": 92129,
                        "name": "Comuna Jorăşti",
                        "latitude": "45.98544000",
                        "longitude": "27.87215000"
                    },
                    {
                        "id": 92164,
                        "name": "Comuna Lieşti",
                        "latitude": "45.62018000",
                        "longitude": "27.54132000"
                    },
                    {
                        "id": 92418,
                        "name": "Comuna Măstăcani",
                        "latitude": "45.76700000",
                        "longitude": "28.04175000"
                    },
                    {
                        "id": 92245,
                        "name": "Comuna Matca",
                        "latitude": "45.85686000",
                        "longitude": "27.53660000"
                    },
                    {
                        "id": 92340,
                        "name": "Comuna Movileni",
                        "latitude": "45.76584000",
                        "longitude": "27.37587000"
                    },
                    {
                        "id": 92356,
                        "name": "Comuna Munteni",
                        "latitude": "45.91503000",
                        "longitude": "27.44242000"
                    },
                    {
                        "id": 92462,
                        "name": "Comuna Nămoloasa",
                        "latitude": "45.52383000",
                        "longitude": "27.56307000"
                    },
                    {
                        "id": 92434,
                        "name": "Comuna Negrileşti",
                        "latitude": "45.94768000",
                        "longitude": "27.48018000"
                    },
                    {
                        "id": 92444,
                        "name": "Comuna Nicoreşti",
                        "latitude": "45.93603000",
                        "longitude": "27.29735000"
                    },
                    {
                        "id": 92467,
                        "name": "Comuna Oancea",
                        "latitude": "45.90648000",
                        "longitude": "28.11118000"
                    },
                    {
                        "id": 92543,
                        "name": "Comuna Pechea",
                        "latitude": "45.64303000",
                        "longitude": "27.82756000"
                    },
                    {
                        "id": 92587,
                        "name": "Comuna Piscu",
                        "latitude": "45.51681000",
                        "longitude": "27.71645000"
                    },
                    {
                        "id": 92622,
                        "name": "Comuna Poiana",
                        "latitude": "45.99554000",
                        "longitude": "27.26693000"
                    },
                    {
                        "id": 92676,
                        "name": "Comuna Priponeşti",
                        "latitude": "46.10150000",
                        "longitude": "27.43939000"
                    },
                    {
                        "id": 92843,
                        "name": "Comuna Rădeşti",
                        "latitude": "46.08312000",
                        "longitude": "27.79606000"
                    },
                    {
                        "id": 92760,
                        "name": "Comuna Rediu",
                        "latitude": "45.72065000",
                        "longitude": "27.84647000"
                    },
                    {
                        "id": 92903,
                        "name": "Comuna Scânteieşti",
                        "latitude": "45.68833000",
                        "longitude": "28.00432000"
                    },
                    {
                        "id": 92885,
                        "name": "Comuna Schela",
                        "latitude": "45.51810000",
                        "longitude": "27.85229000"
                    },
                    {
                        "id": 93506,
                        "name": "Comuna Şendreni",
                        "latitude": "45.41320000",
                        "longitude": "27.92253000"
                    },
                    {
                        "id": 92956,
                        "name": "Comuna Slobozia Conachi",
                        "latitude": "45.56430000",
                        "longitude": "27.77143000"
                    },
                    {
                        "id": 92964,
                        "name": "Comuna Smârdan",
                        "latitude": "45.49694000",
                        "longitude": "27.93554000"
                    },
                    {
                        "id": 92963,
                        "name": "Comuna Smulţi",
                        "latitude": "45.93246000",
                        "longitude": "27.75488000"
                    },
                    {
                        "id": 93025,
                        "name": "Comuna Suceveni",
                        "latitude": "45.99495000",
                        "longitude": "28.05748000"
                    },
                    {
                        "id": 93031,
                        "name": "Comuna Suhurlui",
                        "latitude": "45.72873000",
                        "longitude": "27.82678000"
                    },
                    {
                        "id": 93568,
                        "name": "Comuna Ţepu",
                        "latitude": "45.97734000",
                        "longitude": "27.37677000"
                    },
                    {
                        "id": 93198,
                        "name": "Comuna Tudor Vladimirescu",
                        "latitude": "45.56466000",
                        "longitude": "27.65075000"
                    },
                    {
                        "id": 93206,
                        "name": "Comuna Tuluceşti",
                        "latitude": "45.59242000",
                        "longitude": "28.05239000"
                    },
                    {
                        "id": 93266,
                        "name": "Comuna Umbrăreşti",
                        "latitude": "45.71386000",
                        "longitude": "27.45893000"
                    },
                    {
                        "id": 93317,
                        "name": "Comuna Valea Mãrului",
                        "latitude": "45.85934000",
                        "longitude": "27.69554000"
                    },
                    {
                        "id": 93434,
                        "name": "Comuna Vânători",
                        "latitude": "45.52597000",
                        "longitude": "28.00892000"
                    },
                    {
                        "id": 93443,
                        "name": "Comuna Vârlezi",
                        "latitude": "45.92244000",
                        "longitude": "27.82966000"
                    },
                    {
                        "id": 93390,
                        "name": "Comuna Vlădeşti",
                        "latitude": "45.81991000",
                        "longitude": "28.08845000"
                    },
                    {
                        "id": 93637,
                        "name": "Corni",
                        "latitude": "45.85000000",
                        "longitude": "27.76667000"
                    },
                    {
                        "id": 93646,
                        "name": "Corod",
                        "latitude": "45.90000000",
                        "longitude": "27.61667000"
                    },
                    {
                        "id": 93652,
                        "name": "Cosmeşti",
                        "latitude": "45.87017000",
                        "longitude": "27.31115000"
                    },
                    {
                        "id": 93654,
                        "name": "Cosmeștii-Vale",
                        "latitude": "45.86931000",
                        "longitude": "27.28771000"
                    },
                    {
                        "id": 93657,
                        "name": "Costache Negri",
                        "latitude": "45.70000000",
                        "longitude": "27.71667000"
                    },
                    {
                        "id": 93754,
                        "name": "Crăiești",
                        "latitude": "45.94314000",
                        "longitude": "27.81136000"
                    },
                    {
                        "id": 93756,
                        "name": "Cuca",
                        "latitude": "45.73333000",
                        "longitude": "27.88333000"
                    },
                    {
                        "id": 93763,
                        "name": "Cudalbi",
                        "latitude": "45.78333000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 93786,
                        "name": "Cuza Vodă",
                        "latitude": "45.59595000",
                        "longitude": "27.79267000"
                    },
                    {
                        "id": 94058,
                        "name": "Drăgăneşti",
                        "latitude": "45.78333000",
                        "longitude": "27.46667000"
                    },
                    {
                        "id": 94048,
                        "name": "Drăguşeni",
                        "latitude": "45.96667000",
                        "longitude": "27.75000000"
                    },
                    {
                        "id": 94242,
                        "name": "Fântânele",
                        "latitude": "45.70152000",
                        "longitude": "28.00354000"
                    },
                    {
                        "id": 94246,
                        "name": "Fârţăneşti",
                        "latitude": "45.81667000",
                        "longitude": "27.98333000"
                    },
                    {
                        "id": 94197,
                        "name": "Folteşti",
                        "latitude": "45.75000000",
                        "longitude": "28.05000000"
                    },
                    {
                        "id": 94212,
                        "name": "Frumuşiţa",
                        "latitude": "45.66667000",
                        "longitude": "28.06667000"
                    },
                    {
                        "id": 94227,
                        "name": "Fundeni",
                        "latitude": "45.54123000",
                        "longitude": "27.54056000"
                    },
                    {
                        "id": 94232,
                        "name": "Furcenii Noi",
                        "latitude": "45.81118000",
                        "longitude": "27.33954000"
                    },
                    {
                        "id": 94272,
                        "name": "Galaţi",
                        "latitude": "45.43687000",
                        "longitude": "28.05028000"
                    },
                    {
                        "id": 94511,
                        "name": "Gănești",
                        "latitude": "46.08970000",
                        "longitude": "27.99337000"
                    },
                    {
                        "id": 94318,
                        "name": "Ghidigeni",
                        "latitude": "46.05000000",
                        "longitude": "27.50000000"
                    },
                    {
                        "id": 94374,
                        "name": "Gohor",
                        "latitude": "46.06667000",
                        "longitude": "27.40000000"
                    },
                    {
                        "id": 94417,
                        "name": "Griviţa",
                        "latitude": "45.71667000",
                        "longitude": "27.65000000"
                    },
                    {
                        "id": 94523,
                        "name": "Hanu Conachi",
                        "latitude": "45.58650000",
                        "longitude": "27.59481000"
                    },
                    {
                        "id": 94665,
                        "name": "Independenţa",
                        "latitude": "45.48333000",
                        "longitude": "27.75000000"
                    },
                    {
                        "id": 94696,
                        "name": "Iveşti",
                        "latitude": "45.68333000",
                        "longitude": "27.51667000"
                    },
                    {
                        "id": 94746,
                        "name": "Jorăşti",
                        "latitude": "45.98333000",
                        "longitude": "27.86667000"
                    },
                    {
                        "id": 94795,
                        "name": "Lieşti",
                        "latitude": "45.61667000",
                        "longitude": "27.51667000"
                    },
                    {
                        "id": 95213,
                        "name": "Mândrești",
                        "latitude": "45.88333000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 95287,
                        "name": "Măstăcani",
                        "latitude": "45.78333000",
                        "longitude": "28.03333000"
                    },
                    {
                        "id": 94934,
                        "name": "Matca",
                        "latitude": "45.85000000",
                        "longitude": "27.53333000"
                    },
                    {
                        "id": 95076,
                        "name": "Moscu",
                        "latitude": "45.90260000",
                        "longitude": "27.93120000"
                    },
                    {
                        "id": 95084,
                        "name": "Movileni",
                        "latitude": "45.76154000",
                        "longitude": "27.37184000"
                    },
                    {
                        "id": 95144,
                        "name": "Municipiul Galaţi",
                        "latitude": "45.44078000",
                        "longitude": "28.04118000"
                    },
                    {
                        "id": 95186,
                        "name": "Municipiul Tecuci",
                        "latitude": "45.85155000",
                        "longitude": "27.42826000"
                    },
                    {
                        "id": 95200,
                        "name": "Munteni",
                        "latitude": "45.93333000",
                        "longitude": "27.43333000"
                    },
                    {
                        "id": 95370,
                        "name": "Nămoloasa",
                        "latitude": "45.53610000",
                        "longitude": "27.55226000"
                    },
                    {
                        "id": 95371,
                        "name": "Nămoloasa-Sat",
                        "latitude": "45.53333000",
                        "longitude": "27.58333000"
                    },
                    {
                        "id": 95323,
                        "name": "Negrilești",
                        "latitude": "45.95729000",
                        "longitude": "27.48085000"
                    },
                    {
                        "id": 95341,
                        "name": "Nicoreşti",
                        "latitude": "45.93223000",
                        "longitude": "27.30866000"
                    },
                    {
                        "id": 95379,
                        "name": "Oancea",
                        "latitude": "45.91667000",
                        "longitude": "28.10000000"
                    },
                    {
                        "id": 95404,
                        "name": "Odaia Manolache",
                        "latitude": "45.54897000",
                        "longitude": "27.99057000"
                    },
                    {
                        "id": 95462,
                        "name": "Oraş Bereşti",
                        "latitude": "46.09648000",
                        "longitude": "27.88623000"
                    },
                    {
                        "id": 95647,
                        "name": "Oraș Târgu Bujor",
                        "latitude": "45.87398000",
                        "longitude": "27.92304000"
                    },
                    {
                        "id": 95721,
                        "name": "Pechea",
                        "latitude": "45.63333000",
                        "longitude": "27.80000000"
                    },
                    {
                        "id": 95797,
                        "name": "Piscu",
                        "latitude": "45.50000000",
                        "longitude": "27.73333000"
                    },
                    {
                        "id": 95847,
                        "name": "Podoleni",
                        "latitude": "45.74830000",
                        "longitude": "27.44661000"
                    },
                    {
                        "id": 95867,
                        "name": "Poiana",
                        "latitude": "45.99228000",
                        "longitude": "27.25609000"
                    },
                    {
                        "id": 95953,
                        "name": "Priponeşti",
                        "latitude": "46.08333000",
                        "longitude": "27.43333000"
                    },
                    {
                        "id": 96196,
                        "name": "Rădești",
                        "latitude": "46.07263000",
                        "longitude": "27.78936000"
                    },
                    {
                        "id": 96079,
                        "name": "Rediu",
                        "latitude": "45.71667000",
                        "longitude": "27.83333000"
                    },
                    {
                        "id": 96294,
                        "name": "Scânteiești",
                        "latitude": "45.68333000",
                        "longitude": "27.98333000"
                    },
                    {
                        "id": 96268,
                        "name": "Schela",
                        "latitude": "45.50000000",
                        "longitude": "27.81667000"
                    },
                    {
                        "id": 97037,
                        "name": "Şendreni",
                        "latitude": "45.40000000",
                        "longitude": "27.91667000"
                    },
                    {
                        "id": 97130,
                        "name": "Șivița",
                        "latitude": "45.61285000",
                        "longitude": "28.05757000"
                    },
                    {
                        "id": 96375,
                        "name": "Slobozia Conachi",
                        "latitude": "45.58333000",
                        "longitude": "27.78333000"
                    },
                    {
                        "id": 96390,
                        "name": "Smârdan",
                        "latitude": "45.48333000",
                        "longitude": "27.93333000"
                    },
                    {
                        "id": 96388,
                        "name": "Smulţi",
                        "latitude": "45.93333000",
                        "longitude": "27.75000000"
                    },
                    {
                        "id": 96489,
                        "name": "Suceveni",
                        "latitude": "46.01222000",
                        "longitude": "28.01806000"
                    },
                    {
                        "id": 96498,
                        "name": "Suhurlui",
                        "latitude": "45.72873000",
                        "longitude": "27.82678000"
                    },
                    {
                        "id": 96604,
                        "name": "Tălpigi",
                        "latitude": "46.00796000",
                        "longitude": "27.47247000"
                    },
                    {
                        "id": 96581,
                        "name": "Târgu Bujor",
                        "latitude": "45.86667000",
                        "longitude": "27.90000000"
                    },
                    {
                        "id": 106069,
                        "name": "Tecuci",
                        "latitude": "45.84973000",
                        "longitude": "27.43441000"
                    },
                    {
                        "id": 97100,
                        "name": "Ţepu",
                        "latitude": "45.96667000",
                        "longitude": "27.36667000"
                    },
                    {
                        "id": 106118,
                        "name": "Toflea",
                        "latitude": "46.06372000",
                        "longitude": "27.33411000"
                    },
                    {
                        "id": 106165,
                        "name": "Tudor Vladimirescu",
                        "latitude": "45.56667000",
                        "longitude": "27.65000000"
                    },
                    {
                        "id": 96547,
                        "name": "Tuluceşti",
                        "latitude": "45.56667000",
                        "longitude": "28.03333000"
                    },
                    {
                        "id": 96652,
                        "name": "Umbrăreşti",
                        "latitude": "45.71667000",
                        "longitude": "27.46667000"
                    },
                    {
                        "id": 96654,
                        "name": "Umbrărești-Deal",
                        "latitude": "45.70000000",
                        "longitude": "27.46667000"
                    },
                    {
                        "id": 96659,
                        "name": "Ungureni",
                        "latitude": "45.91307000",
                        "longitude": "27.47000000"
                    },
                    {
                        "id": 96743,
                        "name": "Valea Mărului",
                        "latitude": "45.83866000",
                        "longitude": "27.69138000"
                    },
                    {
                        "id": 96931,
                        "name": "Vânători",
                        "latitude": "45.53333000",
                        "longitude": "28.01667000"
                    },
                    {
                        "id": 96942,
                        "name": "Vârlezi",
                        "latitude": "45.90000000",
                        "longitude": "27.85000000"
                    },
                    {
                        "id": 96814,
                        "name": "Viile",
                        "latitude": "45.80691000",
                        "longitude": "27.94748000"
                    },
                    {
                        "id": 96865,
                        "name": "Vlădeşti",
                        "latitude": "45.85000000",
                        "longitude": "28.08333000"
                    }
                ]
            },
            {
                "id": 4726,
                "name": "Giurgiu",
                "iso2": "GR",
                "latitude": "43.90370760",
                "longitude": "25.96992650",
                "type": "department",
                "cities": [
                    {
                        "id": 89885,
                        "name": "Adunații-Copăceni",
                        "latitude": "44.25413000",
                        "longitude": "26.04929000"
                    },
                    {
                        "id": 90439,
                        "name": "Bâcu",
                        "latitude": "44.48259000",
                        "longitude": "25.88904000"
                    },
                    {
                        "id": 90531,
                        "name": "Băneasa",
                        "latitude": "44.04611000",
                        "longitude": "26.06417000"
                    },
                    {
                        "id": 90213,
                        "name": "Bolintin Deal",
                        "latitude": "44.45917000",
                        "longitude": "25.82111000"
                    },
                    {
                        "id": 90214,
                        "name": "Bolintin Vale",
                        "latitude": "44.44889000",
                        "longitude": "25.75778000"
                    },
                    {
                        "id": 90339,
                        "name": "Brăniștari",
                        "latitude": "44.17626000",
                        "longitude": "26.05953000"
                    },
                    {
                        "id": 90271,
                        "name": "Braniștea",
                        "latitude": "43.96315000",
                        "longitude": "26.03812000"
                    },
                    {
                        "id": 90365,
                        "name": "Bucşani",
                        "latitude": "44.37611000",
                        "longitude": "25.65528000"
                    },
                    {
                        "id": 90401,
                        "name": "Bulbucata",
                        "latitude": "44.28333000",
                        "longitude": "25.80333000"
                    },
                    {
                        "id": 90429,
                        "name": "Buturugeni",
                        "latitude": "44.36528000",
                        "longitude": "25.83528000"
                    },
                    {
                        "id": 93845,
                        "name": "Călugăreni",
                        "latitude": "44.17167000",
                        "longitude": "25.99556000"
                    },
                    {
                        "id": 93803,
                        "name": "Câmpurelu",
                        "latitude": "44.23392000",
                        "longitude": "26.18719000"
                    },
                    {
                        "id": 90582,
                        "name": "Cartojani",
                        "latitude": "44.43221000",
                        "longitude": "25.48994000"
                    },
                    {
                        "id": 93873,
                        "name": "Căscioarele",
                        "latitude": "44.49911000",
                        "longitude": "25.63817000"
                    },
                    {
                        "id": 90648,
                        "name": "Cetatea",
                        "latitude": "43.95105000",
                        "longitude": "25.93450000"
                    },
                    {
                        "id": 90677,
                        "name": "Chiriacu",
                        "latitude": "44.05036000",
                        "longitude": "25.77726000"
                    },
                    {
                        "id": 90766,
                        "name": "Clejani",
                        "latitude": "44.31972000",
                        "longitude": "25.69944000"
                    },
                    {
                        "id": 90795,
                        "name": "Colibaşi",
                        "latitude": "44.20222000",
                        "longitude": "26.19472000"
                    },
                    {
                        "id": 90803,
                        "name": "Comana",
                        "latitude": "44.17056000",
                        "longitude": "26.14500000"
                    },
                    {
                        "id": 90823,
                        "name": "Comuna Adunaţii-Copăceni",
                        "latitude": "44.25847000",
                        "longitude": "26.06477000"
                    },
                    {
                        "id": 91231,
                        "name": "Comuna Băneasa",
                        "latitude": "44.03785000",
                        "longitude": "26.06071000"
                    },
                    {
                        "id": 91041,
                        "name": "Comuna Bolintin Deal",
                        "latitude": "44.44593000",
                        "longitude": "25.82301000"
                    },
                    {
                        "id": 91141,
                        "name": "Comuna Bucşani",
                        "latitude": "44.35805000",
                        "longitude": "25.65081000"
                    },
                    {
                        "id": 91158,
                        "name": "Comuna Bulbucata",
                        "latitude": "44.29537000",
                        "longitude": "25.82284000"
                    },
                    {
                        "id": 91177,
                        "name": "Comuna Buturugeni",
                        "latitude": "44.34661000",
                        "longitude": "25.83382000"
                    },
                    {
                        "id": 91575,
                        "name": "Comuna Călugăreni",
                        "latitude": "44.16412000",
                        "longitude": "25.99392000"
                    },
                    {
                        "id": 91380,
                        "name": "Comuna Clejani",
                        "latitude": "44.31582000",
                        "longitude": "25.73560000"
                    },
                    {
                        "id": 91398,
                        "name": "Comuna Colibaşi",
                        "latitude": "44.21838000",
                        "longitude": "26.19239000"
                    },
                    {
                        "id": 91404,
                        "name": "Comuna Comana",
                        "latitude": "44.17965000",
                        "longitude": "26.14905000"
                    },
                    {
                        "id": 91452,
                        "name": "Comuna Cosoba",
                        "latitude": "44.52268000",
                        "longitude": "25.81903000"
                    },
                    {
                        "id": 91490,
                        "name": "Comuna Crevedia Mare",
                        "latitude": "44.43670000",
                        "longitude": "25.61050000"
                    },
                    {
                        "id": 91600,
                        "name": "Comuna Daia",
                        "latitude": "43.99944000",
                        "longitude": "25.99228000"
                    },
                    {
                        "id": 93585,
                        "name": "Comună Floreşti-Stoeneşti",
                        "latitude": "44.49152000",
                        "longitude": "25.71140000"
                    },
                    {
                        "id": 91794,
                        "name": "Comuna Frăteşti",
                        "latitude": "43.95495000",
                        "longitude": "25.96212000"
                    },
                    {
                        "id": 91977,
                        "name": "Comuna Gãiseni",
                        "latitude": "44.51633000",
                        "longitude": "25.63261000"
                    },
                    {
                        "id": 91987,
                        "name": "Comuna Găujani",
                        "latitude": "43.73995000",
                        "longitude": "25.71079000"
                    },
                    {
                        "id": 91856,
                        "name": "Comuna Ghimpaţi",
                        "latitude": "44.19231000",
                        "longitude": "25.78360000"
                    },
                    {
                        "id": 91890,
                        "name": "Comuna Gogoşari",
                        "latitude": "43.86611000",
                        "longitude": "25.68497000"
                    },
                    {
                        "id": 91909,
                        "name": "Comuna Goştinari",
                        "latitude": "44.17765000",
                        "longitude": "26.23792000"
                    },
                    {
                        "id": 91907,
                        "name": "Comuna Gostinu",
                        "latitude": "43.99738000",
                        "longitude": "26.12297000"
                    },
                    {
                        "id": 91937,
                        "name": "Comuna Grădinari",
                        "latitude": "44.39546000",
                        "longitude": "25.81702000"
                    },
                    {
                        "id": 91913,
                        "name": "Comuna Greaca",
                        "latitude": "44.12591000",
                        "longitude": "26.33371000"
                    },
                    {
                        "id": 91998,
                        "name": "Comuna Herăşti",
                        "latitude": "44.21077000",
                        "longitude": "26.36678000"
                    },
                    {
                        "id": 92025,
                        "name": "Comuna Hotarele",
                        "latitude": "44.17536000",
                        "longitude": "26.37078000"
                    },
                    {
                        "id": 92064,
                        "name": "Comuna Iepureşti",
                        "latitude": "44.26376000",
                        "longitude": "25.88040000"
                    },
                    {
                        "id": 92096,
                        "name": "Comuna Isvoarele",
                        "latitude": "44.16855000",
                        "longitude": "26.29673000"
                    },
                    {
                        "id": 92103,
                        "name": "Comuna Izvoarele",
                        "latitude": "44.04869000",
                        "longitude": "25.80326000"
                    },
                    {
                        "id": 92128,
                        "name": "Comuna Joiţa",
                        "latitude": "44.49002000",
                        "longitude": "25.87205000"
                    },
                    {
                        "id": 92157,
                        "name": "Comuna Letca Nouă",
                        "latitude": "44.23326000",
                        "longitude": "25.70941000"
                    },
                    {
                        "id": 92235,
                        "name": "Comuna Malu",
                        "latitude": "43.81518000",
                        "longitude": "25.81863000"
                    },
                    {
                        "id": 92373,
                        "name": "Comuna Mârşa",
                        "latitude": "44.37355000",
                        "longitude": "25.55974000"
                    },
                    {
                        "id": 92270,
                        "name": "Comuna Mihai Bravu",
                        "latitude": "44.14129000",
                        "longitude": "26.05812000"
                    },
                    {
                        "id": 92486,
                        "name": "Comuna Ogrezeni",
                        "latitude": "44.39727000",
                        "longitude": "25.77888000"
                    },
                    {
                        "id": 92489,
                        "name": "Comuna Oinacu",
                        "latitude": "43.95609000",
                        "longitude": "26.03403000"
                    },
                    {
                        "id": 92685,
                        "name": "Comuna Prundu",
                        "latitude": "44.08334000",
                        "longitude": "26.21210000"
                    },
                    {
                        "id": 92700,
                        "name": "Comuna Putineiu",
                        "latitude": "43.90072000",
                        "longitude": "25.78225000"
                    },
                    {
                        "id": 92850,
                        "name": "Comuna Răsuceni",
                        "latitude": "44.08416000",
                        "longitude": "25.68758000"
                    },
                    {
                        "id": 92773,
                        "name": "Comuna Roata De Jos",
                        "latitude": "44.41388000",
                        "longitude": "25.53061000"
                    },
                    {
                        "id": 93079,
                        "name": "Comuna Săbăreni",
                        "latitude": "44.50185000",
                        "longitude": "25.88820000"
                    },
                    {
                        "id": 92888,
                        "name": "Comuna Schitu",
                        "latitude": "44.14574000",
                        "longitude": "25.84240000"
                    },
                    {
                        "id": 92940,
                        "name": "Comuna Singureni",
                        "latitude": "44.22975000",
                        "longitude": "25.95363000"
                    },
                    {
                        "id": 92952,
                        "name": "Comuna Slobozia",
                        "latitude": "43.85671000",
                        "longitude": "25.91074000"
                    },
                    {
                        "id": 93016,
                        "name": "Comuna Stăneşti",
                        "latitude": "43.93344000",
                        "longitude": "25.87967000"
                    },
                    {
                        "id": 92994,
                        "name": "Comuna Stoeneşti",
                        "latitude": "44.14164000",
                        "longitude": "25.89349000"
                    },
                    {
                        "id": 93180,
                        "name": "Comuna Toporu",
                        "latitude": "43.99588000",
                        "longitude": "25.64737000"
                    },
                    {
                        "id": 93263,
                        "name": "Comuna Ulmi",
                        "latitude": "44.49340000",
                        "longitude": "25.76687000"
                    },
                    {
                        "id": 93305,
                        "name": "Comuna Valea Dragului",
                        "latitude": "44.21135000",
                        "longitude": "26.30682000"
                    },
                    {
                        "id": 93437,
                        "name": "Comuna Vânătorii Mici",
                        "latitude": "44.49072000",
                        "longitude": "25.56116000"
                    },
                    {
                        "id": 93466,
                        "name": "Comuna Vărăşti",
                        "latitude": "44.24616000",
                        "longitude": "26.25221000"
                    },
                    {
                        "id": 93339,
                        "name": "Comuna Vedea",
                        "latitude": "43.78217000",
                        "longitude": "25.78860000"
                    },
                    {
                        "id": 93600,
                        "name": "Copaciu",
                        "latitude": "44.18178000",
                        "longitude": "25.76921000"
                    },
                    {
                        "id": 93656,
                        "name": "Cosoba",
                        "latitude": "44.52268000",
                        "longitude": "25.81903000"
                    },
                    {
                        "id": 93711,
                        "name": "Crevedia Mare",
                        "latitude": "44.42917000",
                        "longitude": "25.62556000"
                    },
                    {
                        "id": 93761,
                        "name": "Cucuruzu",
                        "latitude": "44.08020000",
                        "longitude": "25.73242000"
                    },
                    {
                        "id": 93888,
                        "name": "Daia",
                        "latitude": "44.00000000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 94135,
                        "name": "Dărăști-Vlașca",
                        "latitude": "44.29401000",
                        "longitude": "26.01119000"
                    },
                    {
                        "id": 93899,
                        "name": "Dealu",
                        "latitude": "44.39938000",
                        "longitude": "25.64857000"
                    },
                    {
                        "id": 93952,
                        "name": "Dobreni",
                        "latitude": "44.25430000",
                        "longitude": "26.21344000"
                    },
                    {
                        "id": 94148,
                        "name": "Falaștoaca",
                        "latitude": "44.19098000",
                        "longitude": "26.18475000"
                    },
                    {
                        "id": 94187,
                        "name": "Florești",
                        "latitude": "44.51313000",
                        "longitude": "25.69658000"
                    },
                    {
                        "id": 94219,
                        "name": "Frăteşti",
                        "latitude": "43.96667000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 94502,
                        "name": "Găiseni",
                        "latitude": "44.51500000",
                        "longitude": "25.64528000"
                    },
                    {
                        "id": 94514,
                        "name": "Găujani",
                        "latitude": "43.73333000",
                        "longitude": "25.70000000"
                    },
                    {
                        "id": 94325,
                        "name": "Ghimpați",
                        "latitude": "44.19586000",
                        "longitude": "25.78336000"
                    },
                    {
                        "id": 94353,
                        "name": "Giurgiu",
                        "latitude": "43.88664000",
                        "longitude": "25.96270000"
                    },
                    {
                        "id": 94371,
                        "name": "Gogoşari",
                        "latitude": "43.86667000",
                        "longitude": "25.70000000"
                    },
                    {
                        "id": 94393,
                        "name": "Gostinari",
                        "latitude": "44.18624000",
                        "longitude": "26.22807000"
                    },
                    {
                        "id": 94396,
                        "name": "Goştinari-Văcăreşti",
                        "latitude": "44.18333000",
                        "longitude": "26.21667000"
                    },
                    {
                        "id": 94394,
                        "name": "Gostinu",
                        "latitude": "44.00000000",
                        "longitude": "26.11667000"
                    },
                    {
                        "id": 94435,
                        "name": "Grădinari",
                        "latitude": "44.39222000",
                        "longitude": "25.81556000"
                    },
                    {
                        "id": 94441,
                        "name": "Grădiștea",
                        "latitude": "44.21062000",
                        "longitude": "26.16547000"
                    },
                    {
                        "id": 94402,
                        "name": "Greaca",
                        "latitude": "44.10944000",
                        "longitude": "26.33944000"
                    },
                    {
                        "id": 94533,
                        "name": "Herăști",
                        "latitude": "44.21174000",
                        "longitude": "26.35903000"
                    },
                    {
                        "id": 94570,
                        "name": "Hotarele",
                        "latitude": "44.17250000",
                        "longitude": "26.37028000"
                    },
                    {
                        "id": 94574,
                        "name": "Hulubești",
                        "latitude": "44.16748000",
                        "longitude": "25.94146000"
                    },
                    {
                        "id": 94636,
                        "name": "Icoana",
                        "latitude": "44.49309000",
                        "longitude": "25.74623000"
                    },
                    {
                        "id": 94643,
                        "name": "Iepureşti",
                        "latitude": "44.25806000",
                        "longitude": "25.88222000"
                    },
                    {
                        "id": 94707,
                        "name": "Izvoarele",
                        "latitude": "44.03389000",
                        "longitude": "25.77472000"
                    },
                    {
                        "id": 94744,
                        "name": "Joiţa",
                        "latitude": "44.49417000",
                        "longitude": "25.85389000"
                    },
                    {
                        "id": 94786,
                        "name": "Letca Nouă",
                        "latitude": "44.23496000",
                        "longitude": "25.74262000"
                    },
                    {
                        "id": 94787,
                        "name": "Letca Veche",
                        "latitude": "44.19911000",
                        "longitude": "25.68681000"
                    },
                    {
                        "id": 94915,
                        "name": "Malu",
                        "latitude": "43.81518000",
                        "longitude": "25.81863000"
                    },
                    {
                        "id": 94918,
                        "name": "Malu Spart",
                        "latitude": "44.44391000",
                        "longitude": "25.71758000"
                    },
                    {
                        "id": 95222,
                        "name": "Mârşa",
                        "latitude": "44.37417000",
                        "longitude": "25.55694000"
                    },
                    {
                        "id": 94976,
                        "name": "Mihai Bravu",
                        "latitude": "44.14056000",
                        "longitude": "26.06278000"
                    },
                    {
                        "id": 94981,
                        "name": "Mihai Vodă",
                        "latitude": "44.43916000",
                        "longitude": "25.81957000"
                    },
                    {
                        "id": 94995,
                        "name": "Mihăileşti",
                        "latitude": "44.32667000",
                        "longitude": "25.90833000"
                    },
                    {
                        "id": 95003,
                        "name": "Milcovățu",
                        "latitude": "44.26570000",
                        "longitude": "25.69882000"
                    },
                    {
                        "id": 95147,
                        "name": "Municipiul Giurgiu",
                        "latitude": "43.89051000",
                        "longitude": "25.96609000"
                    },
                    {
                        "id": 95299,
                        "name": "Naipu",
                        "latitude": "44.15187000",
                        "longitude": "25.76175000"
                    },
                    {
                        "id": 95356,
                        "name": "Novaci",
                        "latitude": "44.30109000",
                        "longitude": "25.98632000"
                    },
                    {
                        "id": 95416,
                        "name": "Ogrezeni",
                        "latitude": "44.41972000",
                        "longitude": "25.76833000"
                    },
                    {
                        "id": 95419,
                        "name": "Oinacu",
                        "latitude": "43.95000000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 95466,
                        "name": "Oraş Bolintin-Vale",
                        "latitude": "44.44356000",
                        "longitude": "25.73930000"
                    },
                    {
                        "id": 95541,
                        "name": "Oraş Mihãileşti",
                        "latitude": "44.31666000",
                        "longitude": "25.94103000"
                    },
                    {
                        "id": 96009,
                        "name": "Pădureni",
                        "latitude": "44.34576000",
                        "longitude": "25.80469000"
                    },
                    {
                        "id": 95699,
                        "name": "Palanca",
                        "latitude": "44.47575000",
                        "longitude": "25.72565000"
                    },
                    {
                        "id": 95779,
                        "name": "Pietrele",
                        "latitude": "44.06258000",
                        "longitude": "26.12019000"
                    },
                    {
                        "id": 95782,
                        "name": "Pietrișu",
                        "latitude": "43.72508000",
                        "longitude": "25.67464000"
                    },
                    {
                        "id": 95826,
                        "name": "Plopșoru",
                        "latitude": "44.01190000",
                        "longitude": "25.99306000"
                    },
                    {
                        "id": 95913,
                        "name": "Popești",
                        "latitude": "44.30444000",
                        "longitude": "25.96370000"
                    },
                    {
                        "id": 95966,
                        "name": "Prundu",
                        "latitude": "44.09472000",
                        "longitude": "26.22694000"
                    },
                    {
                        "id": 95978,
                        "name": "Puieni",
                        "latitude": "44.07675000",
                        "longitude": "26.19114000"
                    },
                    {
                        "id": 95988,
                        "name": "Putineiu",
                        "latitude": "43.90000000",
                        "longitude": "25.73333000"
                    },
                    {
                        "id": 96209,
                        "name": "Răsuceni",
                        "latitude": "44.09167000",
                        "longitude": "25.66389000"
                    },
                    {
                        "id": 96086,
                        "name": "Remuș",
                        "latitude": "43.94295000",
                        "longitude": "25.98039000"
                    },
                    {
                        "id": 96096,
                        "name": "Roata de Jos",
                        "latitude": "44.41083000",
                        "longitude": "25.54333000"
                    },
                    {
                        "id": 105989,
                        "name": "Săbăreni",
                        "latitude": "44.50185000",
                        "longitude": "25.88820000"
                    },
                    {
                        "id": 96223,
                        "name": "Sadina",
                        "latitude": "44.41143000",
                        "longitude": "25.52953000"
                    },
                    {
                        "id": 96270,
                        "name": "Schitu",
                        "latitude": "44.14083000",
                        "longitude": "25.83667000"
                    },
                    {
                        "id": 96355,
                        "name": "Singureni",
                        "latitude": "44.23361000",
                        "longitude": "25.94333000"
                    },
                    {
                        "id": 96370,
                        "name": "Slobozia",
                        "latitude": "43.85000000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 96477,
                        "name": "Stăneşti",
                        "latitude": "43.91667000",
                        "longitude": "25.83333000"
                    },
                    {
                        "id": 96435,
                        "name": "Stoeneşti",
                        "latitude": "44.14444000",
                        "longitude": "25.89500000"
                    },
                    {
                        "id": 96579,
                        "name": "Tântava",
                        "latitude": "44.41511000",
                        "longitude": "25.82450000"
                    },
                    {
                        "id": 106138,
                        "name": "Toporu",
                        "latitude": "44.01056000",
                        "longitude": "25.65278000"
                    },
                    {
                        "id": 106153,
                        "name": "Trestieni",
                        "latitude": "44.50449000",
                        "longitude": "25.75789000"
                    },
                    {
                        "id": 96648,
                        "name": "Ulmi",
                        "latitude": "44.48667000",
                        "longitude": "25.78028000"
                    },
                    {
                        "id": 96693,
                        "name": "Uzunu",
                        "latitude": "44.14716000",
                        "longitude": "25.96719000"
                    },
                    {
                        "id": 96723,
                        "name": "Valea Dragului",
                        "latitude": "44.21222000",
                        "longitude": "26.30361000"
                    },
                    {
                        "id": 96934,
                        "name": "Vânătorii Mari",
                        "latitude": "44.48898000",
                        "longitude": "25.54548000"
                    },
                    {
                        "id": 96935,
                        "name": "Vânătorii Mici",
                        "latitude": "44.49028000",
                        "longitude": "25.55889000"
                    },
                    {
                        "id": 96974,
                        "name": "Vărăşti",
                        "latitude": "44.23778000",
                        "longitude": "26.24861000"
                    },
                    {
                        "id": 96783,
                        "name": "Vedea",
                        "latitude": "43.78333000",
                        "longitude": "25.78333000"
                    },
                    {
                        "id": 96811,
                        "name": "Vieru",
                        "latitude": "43.88787000",
                        "longitude": "25.80974000"
                    },
                    {
                        "id": 96856,
                        "name": "Vlad Țepeș",
                        "latitude": "44.13282000",
                        "longitude": "26.13355000"
                    },
                    {
                        "id": 97003,
                        "name": "Zorile",
                        "latitude": "44.37864000",
                        "longitude": "25.80678000"
                    }
                ]
            },
            {
                "id": 4750,
                "name": "Gorj",
                "iso2": "GJ",
                "latitude": "44.94855950",
                "longitude": "23.24270790",
                "type": "department",
                "cities": [
                    {
                        "id": 89912,
                        "name": "Albeni",
                        "latitude": "45.03333000",
                        "longitude": "23.60000000"
                    },
                    {
                        "id": 89932,
                        "name": "Alimpeşti",
                        "latitude": "45.08333000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 89954,
                        "name": "Andreești",
                        "latitude": "44.78948000",
                        "longitude": "23.55099000"
                    },
                    {
                        "id": 89963,
                        "name": "Aninoasa",
                        "latitude": "44.75000000",
                        "longitude": "23.48333000"
                    },
                    {
                        "id": 89979,
                        "name": "Arcani",
                        "latitude": "45.08333000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 90034,
                        "name": "Baia de Fier",
                        "latitude": "45.16667000",
                        "longitude": "23.76667000"
                    },
                    {
                        "id": 90506,
                        "name": "Bălcești",
                        "latitude": "45.10516000",
                        "longitude": "23.63290000"
                    },
                    {
                        "id": 90510,
                        "name": "Băleşti",
                        "latitude": "45.01667000",
                        "longitude": "23.21667000"
                    },
                    {
                        "id": 90441,
                        "name": "Bâlta",
                        "latitude": "45.11791000",
                        "longitude": "23.10220000"
                    },
                    {
                        "id": 90443,
                        "name": "Bâlteni",
                        "latitude": "44.86919000",
                        "longitude": "23.27311000"
                    },
                    {
                        "id": 90541,
                        "name": "Bărbăteşti",
                        "latitude": "44.86667000",
                        "longitude": "23.50000000"
                    },
                    {
                        "id": 90094,
                        "name": "Bengești",
                        "latitude": "45.06667000",
                        "longitude": "23.60000000"
                    },
                    {
                        "id": 90112,
                        "name": "Berleşti",
                        "latitude": "44.91667000",
                        "longitude": "23.66667000"
                    },
                    {
                        "id": 90208,
                        "name": "Bolboşi",
                        "latitude": "44.75000000",
                        "longitude": "23.21667000"
                    },
                    {
                        "id": 90236,
                        "name": "Borăscu",
                        "latitude": "44.70000000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 90336,
                        "name": "Brăneşti",
                        "latitude": "44.65000000",
                        "longitude": "23.46667000"
                    },
                    {
                        "id": 90407,
                        "name": "Bumbeşti-Jiu",
                        "latitude": "45.16667000",
                        "longitude": "23.40000000"
                    },
                    {
                        "id": 90424,
                        "name": "Bustuchin",
                        "latitude": "44.96667000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 93793,
                        "name": "Câlnic",
                        "latitude": "44.95000000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 93859,
                        "name": "Căpreni",
                        "latitude": "44.75000000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 93871,
                        "name": "Cărpiniș",
                        "latitude": "45.18407000",
                        "longitude": "23.58052000"
                    },
                    {
                        "id": 93880,
                        "name": "Cătunele",
                        "latitude": "44.86442000",
                        "longitude": "22.90707000"
                    },
                    {
                        "id": 90605,
                        "name": "Ceauru",
                        "latitude": "45.01175000",
                        "longitude": "23.20211000"
                    },
                    {
                        "id": 90753,
                        "name": "Ciuperceni",
                        "latitude": "44.93333000",
                        "longitude": "23.01667000"
                    },
                    {
                        "id": 90770,
                        "name": "Cloșani",
                        "latitude": "45.06897000",
                        "longitude": "22.80250000"
                    },
                    {
                        "id": 90781,
                        "name": "Cocoreni",
                        "latitude": "44.82772000",
                        "longitude": "23.31405000"
                    },
                    {
                        "id": 90838,
                        "name": "Comuna Albeni",
                        "latitude": "45.01363000",
                        "longitude": "23.60208000"
                    },
                    {
                        "id": 90853,
                        "name": "Comuna Alimpeşti",
                        "latitude": "45.10542000",
                        "longitude": "23.79651000"
                    },
                    {
                        "id": 90873,
                        "name": "Comuna Aninoasa",
                        "latitude": "44.74836000",
                        "longitude": "23.47372000"
                    },
                    {
                        "id": 90883,
                        "name": "Comuna Arcani",
                        "latitude": "45.07232000",
                        "longitude": "23.14108000"
                    },
                    {
                        "id": 90919,
                        "name": "Comuna Baia de Fier",
                        "latitude": "45.17402000",
                        "longitude": "23.74152000"
                    },
                    {
                        "id": 91225,
                        "name": "Comuna Bălăneşti",
                        "latitude": "45.09028000",
                        "longitude": "23.44674000"
                    },
                    {
                        "id": 91216,
                        "name": "Comuna Băleşti",
                        "latitude": "45.01898000",
                        "longitude": "23.18145000"
                    },
                    {
                        "id": 91182,
                        "name": "Comuna Bâlteni",
                        "latitude": "44.86667000",
                        "longitude": "23.26736000"
                    },
                    {
                        "id": 91238,
                        "name": "Comuna Bărbăteşti",
                        "latitude": "44.85916000",
                        "longitude": "23.50760000"
                    },
                    {
                        "id": 90958,
                        "name": "Comuna Bengeşti-Ciocadia",
                        "latitude": "45.09845000",
                        "longitude": "23.60621000"
                    },
                    {
                        "id": 91037,
                        "name": "Comuna Bolboşi",
                        "latitude": "44.73740000",
                        "longitude": "23.22157000"
                    },
                    {
                        "id": 91055,
                        "name": "Comuna Borăscu",
                        "latitude": "44.70105000",
                        "longitude": "23.26739000"
                    },
                    {
                        "id": 91121,
                        "name": "Comuna Brăneşti",
                        "latitude": "44.66555000",
                        "longitude": "23.47213000"
                    },
                    {
                        "id": 91162,
                        "name": "Comuna Bumbeşti-Piţic",
                        "latitude": "45.12413000",
                        "longitude": "23.70348000"
                    },
                    {
                        "id": 91172,
                        "name": "Comuna Bustuchin",
                        "latitude": "44.96835000",
                        "longitude": "23.70347000"
                    },
                    {
                        "id": 91541,
                        "name": "Comuna Câlnic",
                        "latitude": "44.94202000",
                        "longitude": "23.06292000"
                    },
                    {
                        "id": 91584,
                        "name": "Comuna Căpreni",
                        "latitude": "44.74439000",
                        "longitude": "23.62033000"
                    },
                    {
                        "id": 91595,
                        "name": "Comuna Cătunele",
                        "latitude": "44.83902000",
                        "longitude": "22.92465000"
                    },
                    {
                        "id": 91372,
                        "name": "Comuna Ciuperceni",
                        "latitude": "44.92800000",
                        "longitude": "22.99173000"
                    },
                    {
                        "id": 91486,
                        "name": "Comuna Crasna",
                        "latitude": "45.17065000",
                        "longitude": "23.55625000"
                    },
                    {
                        "id": 91511,
                        "name": "Comuna Crușeț",
                        "latitude": "44.63848000",
                        "longitude": "23.67247000"
                    },
                    {
                        "id": 91736,
                        "name": "Comuna Dănciuleşti",
                        "latitude": "44.77004000",
                        "longitude": "23.76023000"
                    },
                    {
                        "id": 91739,
                        "name": "Comuna Dăneşti",
                        "latitude": "44.96735000",
                        "longitude": "23.34390000"
                    },
                    {
                        "id": 91691,
                        "name": "Comuna Drăgoteşti",
                        "latitude": "44.79957000",
                        "longitude": "23.16192000"
                    },
                    {
                        "id": 91684,
                        "name": "Comuna Drãguţeşti",
                        "latitude": "44.96370000",
                        "longitude": "23.23480000"
                    },
                    {
                        "id": 91816,
                        "name": "Comuna Fãrcãşeşti",
                        "latitude": "44.87069000",
                        "longitude": "23.19279000"
                    },
                    {
                        "id": 91884,
                        "name": "Comuna Glogova",
                        "latitude": "44.91623000",
                        "longitude": "22.90810000"
                    },
                    {
                        "id": 91889,
                        "name": "Comuna Godineşti",
                        "latitude": "44.97634000",
                        "longitude": "22.96093000"
                    },
                    {
                        "id": 92028,
                        "name": "Comuna Hurezani",
                        "latitude": "44.80305000",
                        "longitude": "23.63617000"
                    },
                    {
                        "id": 92086,
                        "name": "Comuna Ioneşti",
                        "latitude": "44.61636000",
                        "longitude": "23.42688000"
                    },
                    {
                        "id": 92134,
                        "name": "Comuna Jupâneşti",
                        "latitude": "44.91241000",
                        "longitude": "23.52325000"
                    },
                    {
                        "id": 92147,
                        "name": "Comuna Leleşti",
                        "latitude": "45.09875000",
                        "longitude": "23.19761000"
                    },
                    {
                        "id": 92162,
                        "name": "Comuna Licurici",
                        "latitude": "44.87544000",
                        "longitude": "23.62641000"
                    },
                    {
                        "id": 92182,
                        "name": "Comuna Logreşti-Moşteni",
                        "latitude": "44.88848000",
                        "longitude": "23.71256000"
                    },
                    {
                        "id": 92419,
                        "name": "Comuna Mătăsari",
                        "latitude": "44.85764000",
                        "longitude": "23.06819000"
                    },
                    {
                        "id": 92364,
                        "name": "Comuna Muşeteşti",
                        "latitude": "45.15231000",
                        "longitude": "23.45022000"
                    },
                    {
                        "id": 92429,
                        "name": "Comuna Negomir",
                        "latitude": "44.78593000",
                        "longitude": "23.22744000"
                    },
                    {
                        "id": 92527,
                        "name": "Comuna Padeş",
                        "latitude": "45.05089000",
                        "longitude": "22.80954000"
                    },
                    {
                        "id": 92571,
                        "name": "Comuna Peştişani",
                        "latitude": "45.07061000",
                        "longitude": "23.04902000"
                    },
                    {
                        "id": 92600,
                        "name": "Comuna Plopşoru",
                        "latitude": "44.73869000",
                        "longitude": "23.39053000"
                    },
                    {
                        "id": 92646,
                        "name": "Comuna Polovragi",
                        "latitude": "45.17196000",
                        "longitude": "23.82134000"
                    },
                    {
                        "id": 92675,
                        "name": "Comuna Prigoria",
                        "latitude": "45.05711000",
                        "longitude": "23.68453000"
                    },
                    {
                        "id": 92797,
                        "name": "Comuna Roşia De Amaradia",
                        "latitude": "45.04419000",
                        "longitude": "23.75991000"
                    },
                    {
                        "id": 92810,
                        "name": "Comuna Runcu",
                        "latitude": "45.12041000",
                        "longitude": "23.13974000"
                    },
                    {
                        "id": 93083,
                        "name": "Comuna Săcelu",
                        "latitude": "45.10648000",
                        "longitude": "23.53717000"
                    },
                    {
                        "id": 92869,
                        "name": "Comuna Samarineşti",
                        "latitude": "44.77152000",
                        "longitude": "23.04889000"
                    },
                    {
                        "id": 93115,
                        "name": "Comuna Săuleşti",
                        "latitude": "44.81247000",
                        "longitude": "23.48767000"
                    },
                    {
                        "id": 92886,
                        "name": "Comuna Schela",
                        "latitude": "45.15883000",
                        "longitude": "23.32395000"
                    },
                    {
                        "id": 92891,
                        "name": "Comuna Scoarţa",
                        "latitude": "45.02872000",
                        "longitude": "23.47131000"
                    },
                    {
                        "id": 92951,
                        "name": "Comuna Slivileşti",
                        "latitude": "44.79198000",
                        "longitude": "23.10761000"
                    },
                    {
                        "id": 93017,
                        "name": "Comuna Stăneşti",
                        "latitude": "45.13050000",
                        "longitude": "23.25328000"
                    },
                    {
                        "id": 92987,
                        "name": "Comuna Stejari",
                        "latitude": "44.77359000",
                        "longitude": "23.70567000"
                    },
                    {
                        "id": 92997,
                        "name": "Comuna Stoina",
                        "latitude": "44.67998000",
                        "longitude": "23.64563000"
                    },
                    {
                        "id": 93579,
                        "name": "Comuna Ţânţăreni",
                        "latitude": "44.61874000",
                        "longitude": "23.54285000"
                    },
                    {
                        "id": 93137,
                        "name": "Comuna Teleşti",
                        "latitude": "44.98175000",
                        "longitude": "23.10843000"
                    },
                    {
                        "id": 93209,
                        "name": "Comuna Turburea",
                        "latitude": "44.68249000",
                        "longitude": "23.53171000"
                    },
                    {
                        "id": 93210,
                        "name": "Comuna Turcineşti",
                        "latitude": "45.12744000",
                        "longitude": "23.30333000"
                    },
                    {
                        "id": 93279,
                        "name": "Comuna Urdari",
                        "latitude": "44.79934000",
                        "longitude": "23.29600000"
                    },
                    {
                        "id": 93456,
                        "name": "Comuna Văgiuleşti",
                        "latitude": "44.72980000",
                        "longitude": "23.10113000"
                    },
                    {
                        "id": 93382,
                        "name": "Comuna Vladimir",
                        "latitude": "44.82235000",
                        "longitude": "23.55520000"
                    },
                    {
                        "id": 93664,
                        "name": "Costești",
                        "latitude": "44.73264000",
                        "longitude": "23.44491000"
                    },
                    {
                        "id": 93681,
                        "name": "Covrigi",
                        "latitude": "44.73825000",
                        "longitude": "23.14921000"
                    },
                    {
                        "id": 93706,
                        "name": "Crasna",
                        "latitude": "45.16667000",
                        "longitude": "23.50000000"
                    },
                    {
                        "id": 93744,
                        "name": "Crușeț",
                        "latitude": "44.63333000",
                        "longitude": "23.66667000"
                    },
                    {
                        "id": 94124,
                        "name": "Dănciuleşti",
                        "latitude": "44.73333000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 94127,
                        "name": "Dăneşti",
                        "latitude": "44.96667000",
                        "longitude": "23.33333000"
                    },
                    {
                        "id": 93960,
                        "name": "Dobrița",
                        "latitude": "45.13504000",
                        "longitude": "23.17406000"
                    },
                    {
                        "id": 94046,
                        "name": "Drăgoteşti",
                        "latitude": "44.80000000",
                        "longitude": "23.16667000"
                    },
                    {
                        "id": 94051,
                        "name": "Drăguţeşti",
                        "latitude": "44.96667000",
                        "longitude": "23.23333000"
                    },
                    {
                        "id": 94265,
                        "name": "Fărcăşeşti",
                        "latitude": "44.86667000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 94188,
                        "name": "Florești",
                        "latitude": "44.61918000",
                        "longitude": "23.52838000"
                    },
                    {
                        "id": 94364,
                        "name": "Glogova",
                        "latitude": "44.92806000",
                        "longitude": "22.90667000"
                    },
                    {
                        "id": 94369,
                        "name": "Godineşti",
                        "latitude": "45.00000000",
                        "longitude": "22.96667000"
                    },
                    {
                        "id": 94581,
                        "name": "Hurezani",
                        "latitude": "44.80000000",
                        "longitude": "23.65000000"
                    },
                    {
                        "id": 94677,
                        "name": "Ioneşti",
                        "latitude": "44.61667000",
                        "longitude": "23.43333000"
                    },
                    {
                        "id": 94753,
                        "name": "Jupâneşti",
                        "latitude": "44.90000000",
                        "longitude": "23.53333000"
                    },
                    {
                        "id": 94774,
                        "name": "Leleşti",
                        "latitude": "45.10000000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 94793,
                        "name": "Licurici",
                        "latitude": "44.91667000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 94829,
                        "name": "Logreşti",
                        "latitude": "44.90000000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 94830,
                        "name": "Logrești Moșteni",
                        "latitude": "44.90663000",
                        "longitude": "23.70480000"
                    },
                    {
                        "id": 95290,
                        "name": "Mătăsari",
                        "latitude": "44.85000000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 95078,
                        "name": "Motru",
                        "latitude": "44.80333000",
                        "longitude": "22.97194000"
                    },
                    {
                        "id": 95159,
                        "name": "Municipiul Motru",
                        "latitude": "44.81422000",
                        "longitude": "22.98229000"
                    },
                    {
                        "id": 95192,
                        "name": "Municipiul Târgu Jiu",
                        "latitude": "45.05278000",
                        "longitude": "23.27708000"
                    },
                    {
                        "id": 95210,
                        "name": "Muşeteşti",
                        "latitude": "45.15000000",
                        "longitude": "23.46667000"
                    },
                    {
                        "id": 95311,
                        "name": "Negomir",
                        "latitude": "44.83333000",
                        "longitude": "23.16667000"
                    },
                    {
                        "id": 95357,
                        "name": "Novaci",
                        "latitude": "45.16462000",
                        "longitude": "23.66839000"
                    },
                    {
                        "id": 95477,
                        "name": "Oraş Bumbeşti-Jiu",
                        "latitude": "45.14429000",
                        "longitude": "23.38185000"
                    },
                    {
                        "id": 95578,
                        "name": "Oraş Rovinari",
                        "latitude": "44.93857000",
                        "longitude": "23.15598000"
                    },
                    {
                        "id": 95606,
                        "name": "Oraş Târgu Cãrbuneşti",
                        "latitude": "44.96550000",
                        "longitude": "23.49567000"
                    },
                    {
                        "id": 95632,
                        "name": "Oraş Ţicleni",
                        "latitude": "44.88344000",
                        "longitude": "23.38921000"
                    },
                    {
                        "id": 95603,
                        "name": "Oraş Tismana",
                        "latitude": "45.04464000",
                        "longitude": "22.93803000"
                    },
                    {
                        "id": 95605,
                        "name": "Oraş Turceni",
                        "latitude": "44.71779000",
                        "longitude": "23.35419000"
                    },
                    {
                        "id": 95693,
                        "name": "Padeş",
                        "latitude": "45.01667000",
                        "longitude": "22.85000000"
                    },
                    {
                        "id": 95763,
                        "name": "Peșteana de Jos",
                        "latitude": "44.83333000",
                        "longitude": "23.26974000"
                    },
                    {
                        "id": 95762,
                        "name": "Peșteana Jiu",
                        "latitude": "44.84695000",
                        "longitude": "23.30401000"
                    },
                    {
                        "id": 95760,
                        "name": "Peştişani",
                        "latitude": "45.06667000",
                        "longitude": "23.03333000"
                    },
                    {
                        "id": 95796,
                        "name": "Piscoiu",
                        "latitude": "44.85211000",
                        "longitude": "23.75387000"
                    },
                    {
                        "id": 95825,
                        "name": "Plopşoru",
                        "latitude": "44.78333000",
                        "longitude": "23.35000000"
                    },
                    {
                        "id": 95830,
                        "name": "Ploștina",
                        "latitude": "44.82398000",
                        "longitude": "22.98791000"
                    },
                    {
                        "id": 95839,
                        "name": "Pociovaliștea",
                        "latitude": "45.15315000",
                        "longitude": "23.64392000"
                    },
                    {
                        "id": 95841,
                        "name": "Pocruia",
                        "latitude": "45.04470000",
                        "longitude": "22.92495000"
                    },
                    {
                        "id": 95861,
                        "name": "Poiana",
                        "latitude": "44.65174000",
                        "longitude": "23.53148000"
                    },
                    {
                        "id": 95898,
                        "name": "Pojogeni",
                        "latitude": "44.99119000",
                        "longitude": "23.48425000"
                    },
                    {
                        "id": 95901,
                        "name": "Polovragi",
                        "latitude": "45.18333000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 95952,
                        "name": "Prigoria",
                        "latitude": "45.06667000",
                        "longitude": "23.68333000"
                    },
                    {
                        "id": 96128,
                        "name": "Roşia de Amaradia",
                        "latitude": "45.05000000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 96122,
                        "name": "Rovinari",
                        "latitude": "44.91667000",
                        "longitude": "23.18333000"
                    },
                    {
                        "id": 96154,
                        "name": "Runcu",
                        "latitude": "45.11667000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 105994,
                        "name": "Săcelu",
                        "latitude": "45.10000000",
                        "longitude": "23.53333000"
                    },
                    {
                        "id": 96238,
                        "name": "Samarineşti",
                        "latitude": "44.75000000",
                        "longitude": "23.05000000"
                    },
                    {
                        "id": 96517,
                        "name": "Sâmbotin",
                        "latitude": "45.13333000",
                        "longitude": "23.33333000"
                    },
                    {
                        "id": 106044,
                        "name": "Săuleşti",
                        "latitude": "44.80000000",
                        "longitude": "23.48333000"
                    },
                    {
                        "id": 96276,
                        "name": "Scoarţa",
                        "latitude": "45.01667000",
                        "longitude": "23.45000000"
                    },
                    {
                        "id": 96367,
                        "name": "Slivileşti",
                        "latitude": "44.78333000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 96402,
                        "name": "Sohodol",
                        "latitude": "45.05531000",
                        "longitude": "22.88194000"
                    },
                    {
                        "id": 96478,
                        "name": "Stăneşti",
                        "latitude": "45.11667000",
                        "longitude": "23.25000000"
                    },
                    {
                        "id": 96425,
                        "name": "Stejari",
                        "latitude": "44.76667000",
                        "longitude": "23.68333000"
                    },
                    {
                        "id": 96430,
                        "name": "Sterpoaia",
                        "latitude": "44.79058000",
                        "longitude": "23.43601000"
                    },
                    {
                        "id": 96440,
                        "name": "Stoina",
                        "latitude": "44.68333000",
                        "longitude": "23.63333000"
                    },
                    {
                        "id": 97111,
                        "name": "Ţânţăreni",
                        "latitude": "44.60000000",
                        "longitude": "23.48333000"
                    },
                    {
                        "id": 96582,
                        "name": "Târgu Cărbuneşti",
                        "latitude": "44.95000000",
                        "longitude": "23.51667000"
                    },
                    {
                        "id": 96584,
                        "name": "Târgu Jiu",
                        "latitude": "45.05000000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 106080,
                        "name": "Teleşti",
                        "latitude": "45.00000000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 97104,
                        "name": "Ţicleni",
                        "latitude": "44.88333000",
                        "longitude": "23.40000000"
                    },
                    {
                        "id": 106107,
                        "name": "Tismana",
                        "latitude": "45.05000000",
                        "longitude": "22.96667000"
                    },
                    {
                        "id": 96552,
                        "name": "Turburea",
                        "latitude": "44.71667000",
                        "longitude": "23.51667000"
                    },
                    {
                        "id": 96553,
                        "name": "Turceni",
                        "latitude": "44.68333000",
                        "longitude": "23.36667000"
                    },
                    {
                        "id": 96555,
                        "name": "Turcineşti",
                        "latitude": "45.10000000",
                        "longitude": "23.33333000"
                    },
                    {
                        "id": 96673,
                        "name": "Urdari",
                        "latitude": "44.80000000",
                        "longitude": "23.30000000"
                    },
                    {
                        "id": 96957,
                        "name": "Văgiuleşti",
                        "latitude": "44.71667000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 96737,
                        "name": "Valea Mare",
                        "latitude": "45.11263000",
                        "longitude": "23.08004000"
                    },
                    {
                        "id": 96812,
                        "name": "Vierșani",
                        "latitude": "44.87875000",
                        "longitude": "23.53120000"
                    },
                    {
                        "id": 96869,
                        "name": "Vlăduleni",
                        "latitude": "44.88857000",
                        "longitude": "23.23727000"
                    },
                    {
                        "id": 96884,
                        "name": "Voiteștii din Vale",
                        "latitude": "45.08746000",
                        "longitude": "23.42145000"
                    }
                ]
            },
            {
                "id": 4749,
                "name": "Harghita",
                "iso2": "HR",
                "latitude": "46.49285070",
                "longitude": "25.64566960",
                "type": "department",
                "cities": [
                    {
                        "id": 90003,
                        "name": "Atid",
                        "latitude": "46.45000000",
                        "longitude": "25.05000000"
                    },
                    {
                        "id": 90010,
                        "name": "Avrămeşti",
                        "latitude": "46.33333000",
                        "longitude": "25.01667000"
                    },
                    {
                        "id": 90493,
                        "name": "Băile Tuşnad",
                        "latitude": "46.15000000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 90503,
                        "name": "Bălan",
                        "latitude": "46.65050000",
                        "longitude": "25.80834000"
                    },
                    {
                        "id": 90054,
                        "name": "Bancu",
                        "latitude": "46.30291000",
                        "longitude": "25.94422000"
                    },
                    {
                        "id": 90134,
                        "name": "Bilbor",
                        "latitude": "47.05000000",
                        "longitude": "25.51667000"
                    },
                    {
                        "id": 90234,
                        "name": "Borsec",
                        "latitude": "46.95000000",
                        "longitude": "25.56667000"
                    },
                    {
                        "id": 90323,
                        "name": "Brădeşti",
                        "latitude": "46.35000000",
                        "longitude": "25.35000000"
                    },
                    {
                        "id": 93863,
                        "name": "Căpâlniţa",
                        "latitude": "46.36667000",
                        "longitude": "25.51667000"
                    },
                    {
                        "id": 93820,
                        "name": "Cârţa",
                        "latitude": "46.53333000",
                        "longitude": "25.75000000"
                    },
                    {
                        "id": 90694,
                        "name": "Ciceu",
                        "latitude": "46.41328000",
                        "longitude": "25.78204000"
                    },
                    {
                        "id": 90739,
                        "name": "Ciucani",
                        "latitude": "46.25701000",
                        "longitude": "25.94744000"
                    },
                    {
                        "id": 90742,
                        "name": "Ciucsângeorgiu",
                        "latitude": "46.31667000",
                        "longitude": "25.95000000"
                    },
                    {
                        "id": 90749,
                        "name": "Ciumani",
                        "latitude": "46.68333000",
                        "longitude": "25.51667000"
                    },
                    {
                        "id": 90901,
                        "name": "Comuna Atid",
                        "latitude": "46.45844000",
                        "longitude": "25.04357000"
                    },
                    {
                        "id": 90907,
                        "name": "Comuna Avrămeşti",
                        "latitude": "46.36400000",
                        "longitude": "25.03223000"
                    },
                    {
                        "id": 90987,
                        "name": "Comuna Bilbor",
                        "latitude": "47.05615000",
                        "longitude": "25.49989000"
                    },
                    {
                        "id": 91113,
                        "name": "Comuna Brădeşti",
                        "latitude": "46.35788000",
                        "longitude": "25.35195000"
                    },
                    {
                        "id": 91585,
                        "name": "Comuna Căpâlniţa",
                        "latitude": "46.36047000",
                        "longitude": "25.51515000"
                    },
                    {
                        "id": 91555,
                        "name": "Comuna Cârţa",
                        "latitude": "46.54068000",
                        "longitude": "25.76275000"
                    },
                    {
                        "id": 91330,
                        "name": "Comuna Ciceu",
                        "latitude": "46.41271000",
                        "longitude": "25.76585000"
                    },
                    {
                        "id": 91364,
                        "name": "Comuna Ciucsângeorgiu",
                        "latitude": "46.33942000",
                        "longitude": "25.99860000"
                    },
                    {
                        "id": 91369,
                        "name": "Comuna Ciumani",
                        "latitude": "46.67821000",
                        "longitude": "25.51825000"
                    },
                    {
                        "id": 91430,
                        "name": "Comuna Corbu",
                        "latitude": "46.99559000",
                        "longitude": "25.65696000"
                    },
                    {
                        "id": 91448,
                        "name": "Comuna Corund",
                        "latitude": "46.48060000",
                        "longitude": "25.20070000"
                    },
                    {
                        "id": 91469,
                        "name": "Comuna Cozmeni",
                        "latitude": "46.20934000",
                        "longitude": "25.94274000"
                    },
                    {
                        "id": 91740,
                        "name": "Comuna Dăneşti",
                        "latitude": "46.51712000",
                        "longitude": "25.74989000"
                    },
                    {
                        "id": 91728,
                        "name": "Comuna Dârjiu",
                        "latitude": "46.20378000",
                        "longitude": "25.17462000"
                    },
                    {
                        "id": 91607,
                        "name": "Comuna Dealu",
                        "latitude": "46.37070000",
                        "longitude": "25.30599000"
                    },
                    {
                        "id": 91630,
                        "name": "Comuna Ditrău",
                        "latitude": "46.84564000",
                        "longitude": "25.52740000"
                    },
                    {
                        "id": 91757,
                        "name": "Comuna Feliceni",
                        "latitude": "46.27909000",
                        "longitude": "25.27430000"
                    },
                    {
                        "id": 91784,
                        "name": "Comuna Frumoasa",
                        "latitude": "46.44683000",
                        "longitude": "25.86759000"
                    },
                    {
                        "id": 91983,
                        "name": "Comuna Gălăuţaş",
                        "latitude": "46.90028000",
                        "longitude": "25.39118000"
                    },
                    {
                        "id": 92130,
                        "name": "Comuna Joseni",
                        "latitude": "46.69525000",
                        "longitude": "25.46114000"
                    },
                    {
                        "id": 92225,
                        "name": "Comuna Lăzarea",
                        "latitude": "46.76626000",
                        "longitude": "25.53875000"
                    },
                    {
                        "id": 92148,
                        "name": "Comuna Leliceni",
                        "latitude": "46.34900000",
                        "longitude": "25.84911000"
                    },
                    {
                        "id": 92192,
                        "name": "Comuna Lueta",
                        "latitude": "46.28724000",
                        "longitude": "25.53719000"
                    },
                    {
                        "id": 92206,
                        "name": "Comuna Lunca de Jos",
                        "latitude": "46.59868000",
                        "longitude": "25.96582000"
                    },
                    {
                        "id": 92207,
                        "name": "Comuna Lunca de Sus",
                        "latitude": "46.51853000",
                        "longitude": "25.95575000"
                    },
                    {
                        "id": 92215,
                        "name": "Comuna Lupeni",
                        "latitude": "46.39565000",
                        "longitude": "25.21905000"
                    },
                    {
                        "id": 92383,
                        "name": "Comuna Mădăraş",
                        "latitude": "46.49472000",
                        "longitude": "25.74750000"
                    },
                    {
                        "id": 92414,
                        "name": "Comuna Mărtiniş",
                        "latitude": "46.22996000",
                        "longitude": "25.38756000"
                    },
                    {
                        "id": 92259,
                        "name": "Comuna Mereşti",
                        "latitude": "46.23458000",
                        "longitude": "25.46099000"
                    },
                    {
                        "id": 92282,
                        "name": "Comuna Mihăileni",
                        "latitude": "46.48874000",
                        "longitude": "25.83027000"
                    },
                    {
                        "id": 92355,
                        "name": "Comuna Mugeni",
                        "latitude": "46.26544000",
                        "longitude": "25.19498000"
                    },
                    {
                        "id": 92476,
                        "name": "Comuna Ocland",
                        "latitude": "46.16242000",
                        "longitude": "25.42557000"
                    },
                    {
                        "id": 92712,
                        "name": "Comuna Pãuleni-Ciuc",
                        "latitude": "46.40073000",
                        "longitude": "25.84076000"
                    },
                    {
                        "id": 92605,
                        "name": "Comuna Plãieşii De Jos",
                        "latitude": "46.21626000",
                        "longitude": "26.09436000"
                    },
                    {
                        "id": 92662,
                        "name": "Comuna Porumbeni",
                        "latitude": "46.27415000",
                        "longitude": "25.12006000"
                    },
                    {
                        "id": 92668,
                        "name": "Comuna Praid",
                        "latitude": "46.54844000",
                        "longitude": "25.14717000"
                    },
                    {
                        "id": 92740,
                        "name": "Comuna Racu",
                        "latitude": "46.45397000",
                        "longitude": "25.77098000"
                    },
                    {
                        "id": 92764,
                        "name": "Comuna Remetea",
                        "latitude": "46.81908000",
                        "longitude": "25.42286000"
                    },
                    {
                        "id": 93080,
                        "name": "Comuna Săcel",
                        "latitude": "46.32872000",
                        "longitude": "24.91795000"
                    },
                    {
                        "id": 93051,
                        "name": "Comuna Sâncrăieni",
                        "latitude": "46.30575000",
                        "longitude": "25.84590000"
                    },
                    {
                        "id": 93052,
                        "name": "Comuna Sândominic",
                        "latitude": "46.57933000",
                        "longitude": "25.79305000"
                    },
                    {
                        "id": 93055,
                        "name": "Comuna Sânmartin",
                        "latitude": "46.26368000",
                        "longitude": "25.95348000"
                    },
                    {
                        "id": 93065,
                        "name": "Comuna Sânsimion",
                        "latitude": "46.25015000",
                        "longitude": "25.89196000"
                    },
                    {
                        "id": 93068,
                        "name": "Comuna Sântimbru",
                        "latitude": "46.27664000",
                        "longitude": "25.81054000"
                    },
                    {
                        "id": 93107,
                        "name": "Comuna Sărmaş",
                        "latitude": "46.88680000",
                        "longitude": "25.44289000"
                    },
                    {
                        "id": 92880,
                        "name": "Comuna Satu Mare",
                        "latitude": "46.34082000",
                        "longitude": "25.38378000"
                    },
                    {
                        "id": 92915,
                        "name": "Comuna Secuieni",
                        "latitude": "46.27623000",
                        "longitude": "24.96946000"
                    },
                    {
                        "id": 92927,
                        "name": "Comuna Siculeni",
                        "latitude": "46.43537000",
                        "longitude": "25.75409000"
                    },
                    {
                        "id": 92937,
                        "name": "Comuna Simoneşti",
                        "latitude": "46.35466000",
                        "longitude": "25.11325000"
                    },
                    {
                        "id": 93024,
                        "name": "Comuna Subcetate",
                        "latitude": "46.85645000",
                        "longitude": "25.40652000"
                    },
                    {
                        "id": 93040,
                        "name": "Comuna Suseni",
                        "latitude": "46.64350000",
                        "longitude": "25.56479000"
                    },
                    {
                        "id": 93166,
                        "name": "Comuna Tomeşti",
                        "latitude": "46.55617000",
                        "longitude": "25.77922000"
                    },
                    {
                        "id": 93204,
                        "name": "Comuna Tulgheş",
                        "latitude": "46.92544000",
                        "longitude": "25.75328000"
                    },
                    {
                        "id": 93221,
                        "name": "Comuna Tuşnad",
                        "latitude": "46.20745000",
                        "longitude": "25.90305000"
                    },
                    {
                        "id": 93257,
                        "name": "Comuna Ulieş",
                        "latitude": "46.21153000",
                        "longitude": "25.27048000"
                    },
                    {
                        "id": 93467,
                        "name": "Comuna Vărşag",
                        "latitude": "46.53155000",
                        "longitude": "25.33900000"
                    },
                    {
                        "id": 93408,
                        "name": "Comuna Voşlãbeni",
                        "latitude": "46.63582000",
                        "longitude": "25.65282000"
                    },
                    {
                        "id": 93475,
                        "name": "Comuna Zetea",
                        "latitude": "46.46047000",
                        "longitude": "25.42823000"
                    },
                    {
                        "id": 93619,
                        "name": "Corbu",
                        "latitude": "46.98333000",
                        "longitude": "25.70000000"
                    },
                    {
                        "id": 93651,
                        "name": "Corund",
                        "latitude": "46.46667000",
                        "longitude": "25.18333000"
                    },
                    {
                        "id": 93685,
                        "name": "Cozmeni",
                        "latitude": "46.22678000",
                        "longitude": "25.94209000"
                    },
                    {
                        "id": 93727,
                        "name": "Cristuru Secuiesc",
                        "latitude": "46.28333000",
                        "longitude": "25.03333000"
                    },
                    {
                        "id": 94128,
                        "name": "Dăneşti",
                        "latitude": "46.51667000",
                        "longitude": "25.75000000"
                    },
                    {
                        "id": 94109,
                        "name": "Dârjiu",
                        "latitude": "46.20000000",
                        "longitude": "25.20000000"
                    },
                    {
                        "id": 93900,
                        "name": "Dealu",
                        "latitude": "46.40000000",
                        "longitude": "25.30000000"
                    },
                    {
                        "id": 93941,
                        "name": "Ditrău",
                        "latitude": "46.81667000",
                        "longitude": "25.51667000"
                    },
                    {
                        "id": 94140,
                        "name": "Eliseni",
                        "latitude": "46.29235000",
                        "longitude": "24.93724000"
                    },
                    {
                        "id": 94155,
                        "name": "Feliceni",
                        "latitude": "46.26667000",
                        "longitude": "25.26667000"
                    },
                    {
                        "id": 94172,
                        "name": "Filiaș",
                        "latitude": "46.27075000",
                        "longitude": "25.02120000"
                    },
                    {
                        "id": 94206,
                        "name": "Frumoasa",
                        "latitude": "46.45000000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 94506,
                        "name": "Gălăuţaş",
                        "latitude": "46.91667000",
                        "longitude": "25.43333000"
                    },
                    {
                        "id": 94303,
                        "name": "Gheorgheni",
                        "latitude": "46.72292000",
                        "longitude": "25.60055000"
                    },
                    {
                        "id": 94545,
                        "name": "Hodoșa",
                        "latitude": "46.86558000",
                        "longitude": "25.44620000"
                    },
                    {
                        "id": 94663,
                        "name": "Imper",
                        "latitude": "46.21667000",
                        "longitude": "26.10000000"
                    },
                    {
                        "id": 94669,
                        "name": "Ineu",
                        "latitude": "46.54530000",
                        "longitude": "25.76357000"
                    },
                    {
                        "id": 94748,
                        "name": "Joseni",
                        "latitude": "46.70000000",
                        "longitude": "25.50000000"
                    },
                    {
                        "id": 94900,
                        "name": "Lăzarea",
                        "latitude": "46.75000000",
                        "longitude": "25.53333000"
                    },
                    {
                        "id": 94775,
                        "name": "Leliceni",
                        "latitude": "46.34713000",
                        "longitude": "25.84782000"
                    },
                    {
                        "id": 94844,
                        "name": "Lueta",
                        "latitude": "46.26667000",
                        "longitude": "25.48333000"
                    },
                    {
                        "id": 94871,
                        "name": "Lunca de Jos",
                        "latitude": "46.56667000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 94872,
                        "name": "Lunca de Sus",
                        "latitude": "46.53333000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 94885,
                        "name": "Lupeni",
                        "latitude": "46.38333000",
                        "longitude": "25.21667000"
                    },
                    {
                        "id": 95235,
                        "name": "Mădăraș",
                        "latitude": "46.49472000",
                        "longitude": "25.74750000"
                    },
                    {
                        "id": 95280,
                        "name": "Mărtiniş",
                        "latitude": "46.23333000",
                        "longitude": "25.38333000"
                    },
                    {
                        "id": 94955,
                        "name": "Mereşti",
                        "latitude": "46.23333000",
                        "longitude": "25.45000000"
                    },
                    {
                        "id": 94973,
                        "name": "Miercurea-Ciuc",
                        "latitude": "46.35000000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 94992,
                        "name": "Mihăileni",
                        "latitude": "46.46667000",
                        "longitude": "25.81667000"
                    },
                    {
                        "id": 95028,
                        "name": "Misentea",
                        "latitude": "46.32714000",
                        "longitude": "25.89506000"
                    },
                    {
                        "id": 95099,
                        "name": "Mugeni",
                        "latitude": "46.25000000",
                        "longitude": "25.21667000"
                    },
                    {
                        "id": 95104,
                        "name": "Municipiul  Topliţa",
                        "latitude": "46.93701000",
                        "longitude": "25.36052000"
                    },
                    {
                        "id": 95145,
                        "name": "Municipiul Gheorgheni",
                        "latitude": "46.72268000",
                        "longitude": "25.59917000"
                    },
                    {
                        "id": 95156,
                        "name": "Municipiul Miercurea Ciuc",
                        "latitude": "46.36091000",
                        "longitude": "25.79985000"
                    },
                    {
                        "id": 95160,
                        "name": "Municipiul Odorheiu Secuiesc",
                        "latitude": "46.30646000",
                        "longitude": "25.29551000"
                    },
                    {
                        "id": 95340,
                        "name": "Nicolești",
                        "latitude": "46.43918000",
                        "longitude": "25.84446000"
                    },
                    {
                        "id": 95393,
                        "name": "Ocland",
                        "latitude": "46.16667000",
                        "longitude": "25.41667000"
                    },
                    {
                        "id": 95397,
                        "name": "Ocna de Jos",
                        "latitude": "46.52635000",
                        "longitude": "25.12945000"
                    },
                    {
                        "id": 95398,
                        "name": "Ocna de Sus",
                        "latitude": "46.52729000",
                        "longitude": "25.15131000"
                    },
                    {
                        "id": 95410,
                        "name": "Odorheiu Secuiesc",
                        "latitude": "46.30000000",
                        "longitude": "25.30000000"
                    },
                    {
                        "id": 95485,
                        "name": "Oraş Bãile Tuşnad",
                        "latitude": "46.14707000",
                        "longitude": "25.86013000"
                    },
                    {
                        "id": 95486,
                        "name": "Oraş Bãlan",
                        "latitude": "46.65740000",
                        "longitude": "25.80554000"
                    },
                    {
                        "id": 95467,
                        "name": "Oraş Borsec",
                        "latitude": "46.96551000",
                        "longitude": "25.56173000"
                    },
                    {
                        "id": 95500,
                        "name": "Oraş Cristuru Secuiesc",
                        "latitude": "46.28390000",
                        "longitude": "25.04583000"
                    },
                    {
                        "id": 95620,
                        "name": "Oraş Vlãhiţa",
                        "latitude": "46.37412000",
                        "longitude": "25.57625000"
                    },
                    {
                        "id": 96028,
                        "name": "Păuleni-Ciuc",
                        "latitude": "46.40000000",
                        "longitude": "25.83333000"
                    },
                    {
                        "id": 95923,
                        "name": "Porumbenii Mari",
                        "latitude": "46.27549000",
                        "longitude": "25.13620000"
                    },
                    {
                        "id": 95938,
                        "name": "Praid",
                        "latitude": "46.55000000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 96049,
                        "name": "Racu",
                        "latitude": "46.45178000",
                        "longitude": "25.76060000"
                    },
                    {
                        "id": 96081,
                        "name": "Remetea",
                        "latitude": "46.78333000",
                        "longitude": "25.45000000"
                    },
                    {
                        "id": 105991,
                        "name": "Săcel",
                        "latitude": "46.30000000",
                        "longitude": "24.93333000"
                    },
                    {
                        "id": 96524,
                        "name": "Sâncrai",
                        "latitude": "46.36667000",
                        "longitude": "25.31667000"
                    },
                    {
                        "id": 96527,
                        "name": "Sâncrăieni",
                        "latitude": "46.31439000",
                        "longitude": "25.83941000"
                    },
                    {
                        "id": 96528,
                        "name": "Sândominic",
                        "latitude": "46.58400000",
                        "longitude": "25.78028000"
                    },
                    {
                        "id": 96533,
                        "name": "Sânmartin",
                        "latitude": "46.26667000",
                        "longitude": "25.93333000"
                    },
                    {
                        "id": 96546,
                        "name": "Sânsimion",
                        "latitude": "46.25000000",
                        "longitude": "25.88333000"
                    },
                    {
                        "id": 105978,
                        "name": "Sântimbru",
                        "latitude": "46.28126000",
                        "longitude": "25.85439000"
                    },
                    {
                        "id": 106032,
                        "name": "Sărmaş",
                        "latitude": "46.88333000",
                        "longitude": "25.46667000"
                    },
                    {
                        "id": 96255,
                        "name": "Satu Mare",
                        "latitude": "46.34082000",
                        "longitude": "25.38378000"
                    },
                    {
                        "id": 96335,
                        "name": "Siculeni",
                        "latitude": "46.41667000",
                        "longitude": "25.75000000"
                    },
                    {
                        "id": 96349,
                        "name": "Simoneşti",
                        "latitude": "46.33333000",
                        "longitude": "25.10000000"
                    },
                    {
                        "id": 96486,
                        "name": "Subcetate",
                        "latitude": "46.85000000",
                        "longitude": "25.45000000"
                    },
                    {
                        "id": 96510,
                        "name": "Suseni",
                        "latitude": "46.66667000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 96625,
                        "name": "Tăureni",
                        "latitude": "46.26667000",
                        "longitude": "25.25000000"
                    },
                    {
                        "id": 106123,
                        "name": "Tomești",
                        "latitude": "46.55617000",
                        "longitude": "25.77922000"
                    },
                    {
                        "id": 106174,
                        "name": "Tulgheş",
                        "latitude": "46.95000000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 96574,
                        "name": "Tuşnad",
                        "latitude": "46.20000000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 96575,
                        "name": "Tușnadu Nou",
                        "latitude": "46.19364000",
                        "longitude": "25.88757000"
                    },
                    {
                        "id": 96707,
                        "name": "Vale",
                        "latitude": "46.94910000",
                        "longitude": "25.37869000"
                    },
                    {
                        "id": 96748,
                        "name": "Valea Rece",
                        "latitude": "46.62082000",
                        "longitude": "25.95827000"
                    },
                    {
                        "id": 96757,
                        "name": "Valea Strâmbă",
                        "latitude": "46.69429000",
                        "longitude": "25.59956000"
                    },
                    {
                        "id": 96976,
                        "name": "Vărşag",
                        "latitude": "46.51667000",
                        "longitude": "25.35000000"
                    },
                    {
                        "id": 96870,
                        "name": "Vlăhiţa",
                        "latitude": "46.35000000",
                        "longitude": "25.51667000"
                    },
                    {
                        "id": 96895,
                        "name": "Voșlăbeni",
                        "latitude": "46.65000000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 96988,
                        "name": "Zencani",
                        "latitude": "46.92700000",
                        "longitude": "25.33411000"
                    },
                    {
                        "id": 96990,
                        "name": "Zetea",
                        "latitude": "46.38333000",
                        "longitude": "25.36667000"
                    }
                ]
            },
            {
                "id": 4721,
                "name": "Hunedoara",
                "iso2": "HD",
                "latitude": "45.79363800",
                "longitude": "22.99759930",
                "type": "department",
                "cities": [
                    {
                        "id": 89965,
                        "name": "Aninoasa",
                        "latitude": "45.40924000",
                        "longitude": "23.31505000"
                    },
                    {
                        "id": 90476,
                        "name": "Băcia",
                        "latitude": "45.80000000",
                        "longitude": "23.01667000"
                    },
                    {
                        "id": 90033,
                        "name": "Baia de Criş",
                        "latitude": "46.16667000",
                        "longitude": "22.71667000"
                    },
                    {
                        "id": 90497,
                        "name": "Băiţa",
                        "latitude": "46.03333000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 90051,
                        "name": "Balşa",
                        "latitude": "46.03333000",
                        "longitude": "23.11667000"
                    },
                    {
                        "id": 90537,
                        "name": "Băniţa",
                        "latitude": "45.45000000",
                        "longitude": "23.26667000"
                    },
                    {
                        "id": 90063,
                        "name": "Baru",
                        "latitude": "45.47218000",
                        "longitude": "23.16271000"
                    },
                    {
                        "id": 90064,
                        "name": "Baru Mic",
                        "latitude": "45.46667000",
                        "longitude": "23.15000000"
                    },
                    {
                        "id": 90066,
                        "name": "Barza",
                        "latitude": "46.11990000",
                        "longitude": "22.85695000"
                    },
                    {
                        "id": 90553,
                        "name": "Bătrâna",
                        "latitude": "45.78333000",
                        "longitude": "22.58333000"
                    },
                    {
                        "id": 90111,
                        "name": "Beriu",
                        "latitude": "45.78333000",
                        "longitude": "23.18333000"
                    },
                    {
                        "id": 90167,
                        "name": "Blăjeni",
                        "latitude": "46.23333000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 90255,
                        "name": "Boşorod",
                        "latitude": "45.68333000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 90260,
                        "name": "Brad",
                        "latitude": "46.13333000",
                        "longitude": "22.78333000"
                    },
                    {
                        "id": 90338,
                        "name": "Brănişca",
                        "latitude": "45.91667000",
                        "longitude": "22.78333000"
                    },
                    {
                        "id": 90278,
                        "name": "Brazi",
                        "latitude": "45.48716000",
                        "longitude": "22.84040000"
                    },
                    {
                        "id": 90298,
                        "name": "Bretea Română",
                        "latitude": "45.66085000",
                        "longitude": "23.01739000"
                    },
                    {
                        "id": 90345,
                        "name": "Buceş",
                        "latitude": "46.18333000",
                        "longitude": "22.93333000"
                    },
                    {
                        "id": 90351,
                        "name": "Bucium-Orlea",
                        "latitude": "45.58333000",
                        "longitude": "22.96667000"
                    },
                    {
                        "id": 90364,
                        "name": "Bucureşci",
                        "latitude": "46.13333000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 90406,
                        "name": "Bulzeștii de Sus",
                        "latitude": "46.30070000",
                        "longitude": "22.76118000"
                    },
                    {
                        "id": 90413,
                        "name": "Bunila",
                        "latitude": "45.70000000",
                        "longitude": "22.66667000"
                    },
                    {
                        "id": 90418,
                        "name": "Burjuc",
                        "latitude": "45.95000000",
                        "longitude": "22.48333000"
                    },
                    {
                        "id": 93831,
                        "name": "Călan",
                        "latitude": "45.73333000",
                        "longitude": "22.98333000"
                    },
                    {
                        "id": 93811,
                        "name": "Cârjiţi",
                        "latitude": "45.85000000",
                        "longitude": "22.83333000"
                    },
                    {
                        "id": 93875,
                        "name": "Căstău",
                        "latitude": "45.81465000",
                        "longitude": "23.21173000"
                    },
                    {
                        "id": 90622,
                        "name": "Cerbăl",
                        "latitude": "45.78333000",
                        "longitude": "22.71667000"
                    },
                    {
                        "id": 90640,
                        "name": "Certeju de Sus",
                        "latitude": "45.96667000",
                        "longitude": "22.96667000"
                    },
                    {
                        "id": 91205,
                        "name": "Comuna Băcia",
                        "latitude": "45.80832000",
                        "longitude": "23.02530000"
                    },
                    {
                        "id": 90918,
                        "name": "Comuna Baia de Criş",
                        "latitude": "46.18227000",
                        "longitude": "22.70027000"
                    },
                    {
                        "id": 91209,
                        "name": "Comuna Băiţa",
                        "latitude": "46.02424000",
                        "longitude": "22.89087000"
                    },
                    {
                        "id": 90932,
                        "name": "Comuna Balşa",
                        "latitude": "46.04738000",
                        "longitude": "23.06886000"
                    },
                    {
                        "id": 91235,
                        "name": "Comuna Băniţa",
                        "latitude": "45.45636000",
                        "longitude": "23.23214000"
                    },
                    {
                        "id": 90938,
                        "name": "Comuna Baru",
                        "latitude": "45.47912000",
                        "longitude": "23.15132000"
                    },
                    {
                        "id": 91246,
                        "name": "Comuna Bătrâna",
                        "latitude": "45.80901000",
                        "longitude": "22.58859000"
                    },
                    {
                        "id": 90970,
                        "name": "Comuna Beriu",
                        "latitude": "45.76347000",
                        "longitude": "23.23126000"
                    },
                    {
                        "id": 91010,
                        "name": "Comuna Blăjeni",
                        "latitude": "46.25491000",
                        "longitude": "22.90335000"
                    },
                    {
                        "id": 91069,
                        "name": "Comuna Boşorod",
                        "latitude": "45.63805000",
                        "longitude": "23.12990000"
                    },
                    {
                        "id": 91124,
                        "name": "Comuna Brănişca",
                        "latitude": "45.97185000",
                        "longitude": "22.76723000"
                    },
                    {
                        "id": 91096,
                        "name": "Comuna Bretea Română",
                        "latitude": "45.66021000",
                        "longitude": "23.01665000"
                    },
                    {
                        "id": 91126,
                        "name": "Comuna Buceş",
                        "latitude": "46.19130000",
                        "longitude": "22.97718000"
                    },
                    {
                        "id": 91139,
                        "name": "Comuna Bucureşci",
                        "latitude": "46.12392000",
                        "longitude": "22.93047000"
                    },
                    {
                        "id": 91161,
                        "name": "Comuna Bulzeştii De Sus",
                        "latitude": "46.29383000",
                        "longitude": "22.77766000"
                    },
                    {
                        "id": 91167,
                        "name": "Comuna Bunila",
                        "latitude": "45.69454000",
                        "longitude": "22.65763000"
                    },
                    {
                        "id": 91170,
                        "name": "Comuna Burjuc",
                        "latitude": "45.97100000",
                        "longitude": "22.50164000"
                    },
                    {
                        "id": 91550,
                        "name": "Comuna Cârjiţi",
                        "latitude": "45.84678000",
                        "longitude": "22.83467000"
                    },
                    {
                        "id": 91287,
                        "name": "Comuna Cerbăl",
                        "latitude": "45.78603000",
                        "longitude": "22.68059000"
                    },
                    {
                        "id": 91297,
                        "name": "Comuna Certeju de Sus",
                        "latitude": "45.97437000",
                        "longitude": "22.98863000"
                    },
                    {
                        "id": 91505,
                        "name": "Comuna Crişcior",
                        "latitude": "46.12326000",
                        "longitude": "22.86590000"
                    },
                    {
                        "id": 91613,
                        "name": "Comuna Densuş",
                        "latitude": "45.56403000",
                        "longitude": "22.77805000"
                    },
                    {
                        "id": 91633,
                        "name": "Comuna Dobra",
                        "latitude": "45.88654000",
                        "longitude": "22.58817000"
                    },
                    {
                        "id": 91837,
                        "name": "Comuna General Berthelot",
                        "latitude": "45.61164000",
                        "longitude": "22.88795000"
                    },
                    {
                        "id": 91840,
                        "name": "Comuna Ghelari",
                        "latitude": "45.71810000",
                        "longitude": "22.77414000"
                    },
                    {
                        "id": 91958,
                        "name": "Comuna Gurasada",
                        "latitude": "45.98515000",
                        "longitude": "22.58854000"
                    },
                    {
                        "id": 92045,
                        "name": "Comuna Hărău",
                        "latitude": "45.90555000",
                        "longitude": "22.98136000"
                    },
                    {
                        "id": 92070,
                        "name": "Comuna Ilia",
                        "latitude": "45.94059000",
                        "longitude": "22.67861000"
                    },
                    {
                        "id": 92218,
                        "name": "Comuna Lãpugiu De Jos",
                        "latitude": "45.89222000",
                        "longitude": "22.45747000"
                    },
                    {
                        "id": 92146,
                        "name": "Comuna Lelese",
                        "latitude": "45.73754000",
                        "longitude": "22.68923000"
                    },
                    {
                        "id": 92202,
                        "name": "Comuna Lunca Cernii De Jos",
                        "latitude": "45.64302000",
                        "longitude": "22.58438000"
                    },
                    {
                        "id": 92210,
                        "name": "Comuna Luncoiu De Jos",
                        "latitude": "46.06807000",
                        "longitude": "22.79112000"
                    },
                    {
                        "id": 92413,
                        "name": "Comuna Mărtineşti",
                        "latitude": "45.79278000",
                        "longitude": "23.11998000"
                    },
                    {
                        "id": 92513,
                        "name": "Comuna Orăştioara de Sus",
                        "latitude": "45.70150000",
                        "longitude": "23.18208000"
                    },
                    {
                        "id": 92561,
                        "name": "Comuna Pestişu Mic",
                        "latitude": "45.80178000",
                        "longitude": "22.83551000"
                    },
                    {
                        "id": 92693,
                        "name": "Comuna Pui",
                        "latitude": "45.51086000",
                        "longitude": "23.08463000"
                    },
                    {
                        "id": 92836,
                        "name": "Comuna Răchitova",
                        "latitude": "45.60982000",
                        "longitude": "22.76739000"
                    },
                    {
                        "id": 92747,
                        "name": "Comuna Rapoltu Mare",
                        "latitude": "45.87904000",
                        "longitude": "23.11543000"
                    },
                    {
                        "id": 92827,
                        "name": "Comuna Râu de Mori",
                        "latitude": "45.50717000",
                        "longitude": "22.86463000"
                    },
                    {
                        "id": 92770,
                        "name": "Comuna Ribiţa",
                        "latitude": "46.20595000",
                        "longitude": "22.79638000"
                    },
                    {
                        "id": 92783,
                        "name": "Comuna Romos",
                        "latitude": "45.82922000",
                        "longitude": "23.30902000"
                    },
                    {
                        "id": 93075,
                        "name": "Comuna Sãlaşu De Sus",
                        "latitude": "45.50425000",
                        "longitude": "22.97422000"
                    },
                    {
                        "id": 93069,
                        "name": "Comuna Sântămăria-Orlea",
                        "latitude": "45.58333000",
                        "longitude": "22.96667000"
                    },
                    {
                        "id": 92876,
                        "name": "Comuna Sarmizegetusa",
                        "latitude": "45.50996000",
                        "longitude": "22.76955000"
                    },
                    {
                        "id": 93538,
                        "name": "Comuna Şoimuş",
                        "latitude": "45.94589000",
                        "longitude": "22.86298000"
                    },
                    {
                        "id": 93139,
                        "name": "Comuna Teliucu Inferior",
                        "latitude": "45.69866000",
                        "longitude": "22.87925000"
                    },
                    {
                        "id": 93167,
                        "name": "Comuna Tomeşti",
                        "latitude": "46.22454000",
                        "longitude": "22.67017000"
                    },
                    {
                        "id": 93177,
                        "name": "Comuna Topliţa",
                        "latitude": "45.66897000",
                        "longitude": "22.77399000"
                    },
                    {
                        "id": 93184,
                        "name": "Comuna Toteşti",
                        "latitude": "45.57137000",
                        "longitude": "22.89023000"
                    },
                    {
                        "id": 93212,
                        "name": "Comuna Turdaş",
                        "latitude": "45.84766000",
                        "longitude": "23.13189000"
                    },
                    {
                        "id": 93462,
                        "name": "Comuna Vălişoara",
                        "latitude": "46.02285000",
                        "longitude": "22.82527000"
                    },
                    {
                        "id": 93337,
                        "name": "Comuna Vaţa De Jos",
                        "latitude": "46.18432000",
                        "longitude": "22.58002000"
                    },
                    {
                        "id": 93349,
                        "name": "Comuna Veţel",
                        "latitude": "45.87424000",
                        "longitude": "22.76738000"
                    },
                    {
                        "id": 93407,
                        "name": "Comuna Vorţa",
                        "latitude": "46.03672000",
                        "longitude": "22.67226000"
                    },
                    {
                        "id": 93471,
                        "name": "Comuna Zam",
                        "latitude": "46.04580000",
                        "longitude": "22.48786000"
                    },
                    {
                        "id": 93734,
                        "name": "Crişcior",
                        "latitude": "46.11667000",
                        "longitude": "22.86667000"
                    },
                    {
                        "id": 93726,
                        "name": "Cristur",
                        "latitude": "45.82936000",
                        "longitude": "22.94323000"
                    },
                    {
                        "id": 93919,
                        "name": "Densuş",
                        "latitude": "45.58333000",
                        "longitude": "22.80000000"
                    },
                    {
                        "id": 93928,
                        "name": "Deva",
                        "latitude": "45.88333000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 93949,
                        "name": "Dobra",
                        "latitude": "45.91667000",
                        "longitude": "22.56667000"
                    },
                    {
                        "id": 94291,
                        "name": "General Berthelot",
                        "latitude": "45.61667000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 94292,
                        "name": "Geoagiu",
                        "latitude": "45.91667000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 94298,
                        "name": "Ghelari",
                        "latitude": "45.71667000",
                        "longitude": "22.78333000"
                    },
                    {
                        "id": 94469,
                        "name": "Gurasada",
                        "latitude": "45.95483000",
                        "longitude": "22.59491000"
                    },
                    {
                        "id": 94608,
                        "name": "Hărău",
                        "latitude": "45.90000000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 94609,
                        "name": "Hărțăgani",
                        "latitude": "46.05012000",
                        "longitude": "22.92183000"
                    },
                    {
                        "id": 94525,
                        "name": "Haţeg",
                        "latitude": "45.61667000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 94578,
                        "name": "Hunedoara",
                        "latitude": "45.75000000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 94656,
                        "name": "Ilia",
                        "latitude": "45.93333000",
                        "longitude": "22.65000000"
                    },
                    {
                        "id": 94689,
                        "name": "Iscroni",
                        "latitude": "45.37794000",
                        "longitude": "23.34201000"
                    },
                    {
                        "id": 94743,
                        "name": "Jiu-Paroșeni",
                        "latitude": "45.36175000",
                        "longitude": "23.26044000"
                    },
                    {
                        "id": 94895,
                        "name": "Lăpugiu de Jos",
                        "latitude": "45.88333000",
                        "longitude": "22.48333000"
                    },
                    {
                        "id": 94773,
                        "name": "Lelese",
                        "latitude": "45.73333000",
                        "longitude": "22.70000000"
                    },
                    {
                        "id": 94862,
                        "name": "Lunca Cernii de Jos",
                        "latitude": "45.63333000",
                        "longitude": "22.61667000"
                    },
                    {
                        "id": 94877,
                        "name": "Luncoiu de Jos",
                        "latitude": "46.10000000",
                        "longitude": "22.76667000"
                    },
                    {
                        "id": 94884,
                        "name": "Lupeni",
                        "latitude": "45.36029000",
                        "longitude": "23.23832000"
                    },
                    {
                        "id": 95279,
                        "name": "Mărtineşti",
                        "latitude": "45.81667000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 95103,
                        "name": "Municipiul  Lupeni",
                        "latitude": "45.35654000",
                        "longitude": "23.22162000"
                    },
                    {
                        "id": 95105,
                        "name": "Municipiul  Vulcan",
                        "latitude": "45.37985000",
                        "longitude": "23.27480000"
                    },
                    {
                        "id": 95116,
                        "name": "Municipiul Brad",
                        "latitude": "46.14073000",
                        "longitude": "22.81284000"
                    },
                    {
                        "id": 95136,
                        "name": "Municipiul Deva",
                        "latitude": "45.84644000",
                        "longitude": "22.93123000"
                    },
                    {
                        "id": 95148,
                        "name": "Municipiul Hunedoara",
                        "latitude": "45.76512000",
                        "longitude": "22.87538000"
                    },
                    {
                        "id": 95164,
                        "name": "Municipiul Orãştie",
                        "latitude": "45.83841000",
                        "longitude": "23.19885000"
                    },
                    {
                        "id": 95167,
                        "name": "Municipiul Petroşani",
                        "latitude": "45.41963000",
                        "longitude": "23.35692000"
                    },
                    {
                        "id": 95450,
                        "name": "Oraş Aninoasa",
                        "latitude": "45.39316000",
                        "longitude": "23.33020000"
                    },
                    {
                        "id": 95504,
                        "name": "Oraş Cãlan",
                        "latitude": "45.73940000",
                        "longitude": "23.01035000"
                    },
                    {
                        "id": 95523,
                        "name": "Oraş Geoagiu",
                        "latitude": "45.94835000",
                        "longitude": "23.20022000"
                    },
                    {
                        "id": 95528,
                        "name": "Oraş Haţeg",
                        "latitude": "45.62512000",
                        "longitude": "22.92275000"
                    },
                    {
                        "id": 95566,
                        "name": "Oraş Petrila",
                        "latitude": "45.45352000",
                        "longitude": "23.43697000"
                    },
                    {
                        "id": 95587,
                        "name": "Oraş Simeria",
                        "latitude": "45.85296000",
                        "longitude": "23.00748000"
                    },
                    {
                        "id": 95612,
                        "name": "Oraş Uricani",
                        "latitude": "45.31733000",
                        "longitude": "23.08005000"
                    },
                    {
                        "id": 95665,
                        "name": "Orăştie",
                        "latitude": "45.83333000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 95666,
                        "name": "Orăştioara de Sus",
                        "latitude": "45.73333000",
                        "longitude": "23.16667000"
                    },
                    {
                        "id": 95765,
                        "name": "Peștișu Mare",
                        "latitude": "45.80192000",
                        "longitude": "22.92704000"
                    },
                    {
                        "id": 95761,
                        "name": "Peştişu Mic",
                        "latitude": "45.80000000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 95752,
                        "name": "Petrila",
                        "latitude": "45.45000000",
                        "longitude": "23.41667000"
                    },
                    {
                        "id": 95756,
                        "name": "Petroşani",
                        "latitude": "45.41667000",
                        "longitude": "23.36667000"
                    },
                    {
                        "id": 95950,
                        "name": "Pricaz",
                        "latitude": "45.85929000",
                        "longitude": "23.17266000"
                    },
                    {
                        "id": 95977,
                        "name": "Pui",
                        "latitude": "45.51667000",
                        "longitude": "23.10000000"
                    },
                    {
                        "id": 96187,
                        "name": "Răchitova",
                        "latitude": "45.60000000",
                        "longitude": "22.75000000"
                    },
                    {
                        "id": 96059,
                        "name": "Rapoltu Mare",
                        "latitude": "45.86667000",
                        "longitude": "23.06667000"
                    },
                    {
                        "id": 96176,
                        "name": "Râu de Mori",
                        "latitude": "45.48333000",
                        "longitude": "22.85000000"
                    },
                    {
                        "id": 96092,
                        "name": "Ribiţa",
                        "latitude": "46.18333000",
                        "longitude": "22.76667000"
                    },
                    {
                        "id": 96107,
                        "name": "Romos",
                        "latitude": "45.83333000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 106007,
                        "name": "Sălaşu de Sus",
                        "latitude": "45.51667000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 105981,
                        "name": "Sântămăria-Orlea",
                        "latitude": "45.58874000",
                        "longitude": "22.97042000"
                    },
                    {
                        "id": 96247,
                        "name": "Sarmizegetusa",
                        "latitude": "45.51667000",
                        "longitude": "22.78333000"
                    },
                    {
                        "id": 96346,
                        "name": "Simeria",
                        "latitude": "45.85000000",
                        "longitude": "23.01667000"
                    },
                    {
                        "id": 97067,
                        "name": "Şoimuş",
                        "latitude": "45.91667000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 106082,
                        "name": "Teliucu Inferior",
                        "latitude": "45.71667000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 106122,
                        "name": "Tomeşti",
                        "latitude": "46.21667000",
                        "longitude": "22.65000000"
                    },
                    {
                        "id": 106132,
                        "name": "Topliţa",
                        "latitude": "45.68333000",
                        "longitude": "22.78333000"
                    },
                    {
                        "id": 106142,
                        "name": "Toteşti",
                        "latitude": "45.56667000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 96559,
                        "name": "Turdaş",
                        "latitude": "45.85000000",
                        "longitude": "23.11667000"
                    },
                    {
                        "id": 96677,
                        "name": "Uricani",
                        "latitude": "45.33731000",
                        "longitude": "23.15240000"
                    },
                    {
                        "id": 96968,
                        "name": "Vălişoara",
                        "latitude": "46.05000000",
                        "longitude": "22.85000000"
                    },
                    {
                        "id": 96780,
                        "name": "Vaţa de Jos",
                        "latitude": "46.18333000",
                        "longitude": "22.60000000"
                    },
                    {
                        "id": 96798,
                        "name": "Veţel",
                        "latitude": "45.90000000",
                        "longitude": "22.81667000"
                    },
                    {
                        "id": 96894,
                        "name": "Vorţa",
                        "latitude": "46.01667000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 96901,
                        "name": "Vulcan",
                        "latitude": "45.38333000",
                        "longitude": "23.26667000"
                    },
                    {
                        "id": 96983,
                        "name": "Zam",
                        "latitude": "46.00000000",
                        "longitude": "22.45000000"
                    },
                    {
                        "id": 96985,
                        "name": "Zdrapți",
                        "latitude": "46.15612000",
                        "longitude": "22.86954000"
                    }
                ]
            },
            {
                "id": 4743,
                "name": "Ialomița",
                "iso2": "IL",
                "latitude": "44.60313300",
                "longitude": "27.37899140",
                "type": "department",
                "cities": [
                    {
                        "id": 89887,
                        "name": "Adâncata",
                        "latitude": "44.76667000",
                        "longitude": "26.43333000"
                    },
                    {
                        "id": 89915,
                        "name": "Albeşti",
                        "latitude": "44.53333000",
                        "longitude": "27.13333000"
                    },
                    {
                        "id": 89929,
                        "name": "Alexeni",
                        "latitude": "44.68333000",
                        "longitude": "26.70000000"
                    },
                    {
                        "id": 89947,
                        "name": "Amara",
                        "latitude": "44.61667000",
                        "longitude": "27.31667000"
                    },
                    {
                        "id": 89959,
                        "name": "Andrăşeşti",
                        "latitude": "44.56667000",
                        "longitude": "27.13333000"
                    },
                    {
                        "id": 89996,
                        "name": "Armăşeşti",
                        "latitude": "44.75000000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 90012,
                        "name": "Axintele",
                        "latitude": "44.60000000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 90038,
                        "name": "Balaciu",
                        "latitude": "44.63333000",
                        "longitude": "26.88333000"
                    },
                    {
                        "id": 90539,
                        "name": "Bărbulești",
                        "latitude": "44.72629000",
                        "longitude": "26.59929000"
                    },
                    {
                        "id": 90542,
                        "name": "Bărcăneşti",
                        "latitude": "44.63333000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 90235,
                        "name": "Borănești",
                        "latitude": "44.66069000",
                        "longitude": "26.60505000"
                    },
                    {
                        "id": 90227,
                        "name": "Borduşani",
                        "latitude": "44.48333000",
                        "longitude": "27.90000000"
                    },
                    {
                        "id": 90313,
                        "name": "Broșteni",
                        "latitude": "44.67192000",
                        "longitude": "26.74787000"
                    },
                    {
                        "id": 90363,
                        "name": "Bucu",
                        "latitude": "44.60532000",
                        "longitude": "27.49337000"
                    },
                    {
                        "id": 90390,
                        "name": "Buești",
                        "latitude": "44.54473000",
                        "longitude": "27.18729000"
                    },
                    {
                        "id": 90403,
                        "name": "Buliga",
                        "latitude": "44.35731000",
                        "longitude": "27.79225000"
                    },
                    {
                        "id": 93884,
                        "name": "Căzăneşti",
                        "latitude": "44.61667000",
                        "longitude": "27.01667000"
                    },
                    {
                        "id": 90607,
                        "name": "Cegani",
                        "latitude": "44.46279000",
                        "longitude": "27.90175000"
                    },
                    {
                        "id": 90710,
                        "name": "Ciocârlia",
                        "latitude": "44.80000000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 90707,
                        "name": "Ciochina",
                        "latitude": "44.58333000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 90747,
                        "name": "Ciulniţa",
                        "latitude": "44.53333000",
                        "longitude": "27.35000000"
                    },
                    {
                        "id": 90780,
                        "name": "Cocora",
                        "latitude": "44.73333000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 90794,
                        "name": "Colelia",
                        "latitude": "44.76112000",
                        "longitude": "27.00693000"
                    },
                    {
                        "id": 90825,
                        "name": "Comuna Adâncata",
                        "latitude": "44.76691000",
                        "longitude": "26.43010000"
                    },
                    {
                        "id": 90840,
                        "name": "Comuna Albeşti",
                        "latitude": "44.53575000",
                        "longitude": "27.12464000"
                    },
                    {
                        "id": 90851,
                        "name": "Comuna Alexeni",
                        "latitude": "44.67966000",
                        "longitude": "26.71064000"
                    },
                    {
                        "id": 90871,
                        "name": "Comuna Andrăşeşti",
                        "latitude": "44.57648000",
                        "longitude": "27.12438000"
                    },
                    {
                        "id": 90895,
                        "name": "Comuna Armăşeşti",
                        "latitude": "44.76397000",
                        "longitude": "26.57999000"
                    },
                    {
                        "id": 90909,
                        "name": "Comuna Axintele",
                        "latitude": "44.58688000",
                        "longitude": "26.78809000"
                    },
                    {
                        "id": 90922,
                        "name": "Comuna Balaciu",
                        "latitude": "44.60985000",
                        "longitude": "26.88277000"
                    },
                    {
                        "id": 91236,
                        "name": "Comuna Bărbuleşti",
                        "latitude": "44.72629000",
                        "longitude": "26.59929000"
                    },
                    {
                        "id": 91240,
                        "name": "Comuna Bărcăneşti",
                        "latitude": "44.63517000",
                        "longitude": "26.66786000"
                    },
                    {
                        "id": 91054,
                        "name": "Comuna Borăneşti",
                        "latitude": "44.66355000",
                        "longitude": "26.59486000"
                    },
                    {
                        "id": 91049,
                        "name": "Comuna Borduşani",
                        "latitude": "44.47236000",
                        "longitude": "27.90315000"
                    },
                    {
                        "id": 91138,
                        "name": "Comuna Bucu",
                        "latitude": "44.60663000",
                        "longitude": "27.49432000"
                    },
                    {
                        "id": 91151,
                        "name": "Comuna Bueşti",
                        "latitude": "44.54473000",
                        "longitude": "27.18729000"
                    },
                    {
                        "id": 91343,
                        "name": "Comuna Ciocârlia",
                        "latitude": "44.78828000",
                        "longitude": "26.67002000"
                    },
                    {
                        "id": 91341,
                        "name": "Comuna Ciochina",
                        "latitude": "44.57524000",
                        "longitude": "27.02475000"
                    },
                    {
                        "id": 91368,
                        "name": "Comuna Ciulniţa",
                        "latitude": "44.51976000",
                        "longitude": "27.28461000"
                    },
                    {
                        "id": 91388,
                        "name": "Comuna Cocora",
                        "latitude": "44.73752000",
                        "longitude": "27.04760000"
                    },
                    {
                        "id": 91397,
                        "name": "Comuna Colelia",
                        "latitude": "44.76112000",
                        "longitude": "27.00693000"
                    },
                    {
                        "id": 91462,
                        "name": "Comuna Cosâmbeşti",
                        "latitude": "44.56104000",
                        "longitude": "27.45846000"
                    },
                    {
                        "id": 91474,
                        "name": "Comuna Coşereni",
                        "latitude": "44.68540000",
                        "longitude": "26.56101000"
                    },
                    {
                        "id": 91689,
                        "name": "Comuna Drăgoeşti",
                        "latitude": "44.58767000",
                        "longitude": "26.52057000"
                    },
                    {
                        "id": 91680,
                        "name": "Comuna Dridu",
                        "latitude": "44.70391000",
                        "longitude": "26.45311000"
                    },
                    {
                        "id": 91818,
                        "name": "Comuna Făcăeni",
                        "latitude": "44.56878000",
                        "longitude": "27.88087000"
                    },
                    {
                        "id": 91966,
                        "name": "Comuna Gârbovi",
                        "latitude": "44.78651000",
                        "longitude": "26.76960000"
                    },
                    {
                        "id": 91842,
                        "name": "Comuna Gheorghe Doja",
                        "latitude": "44.61333000",
                        "longitude": "27.18388000"
                    },
                    {
                        "id": 91843,
                        "name": "Comuna Gheorghe Lazăr",
                        "latitude": "44.63278000",
                        "longitude": "27.45815000"
                    },
                    {
                        "id": 91876,
                        "name": "Comuna Giurgeni",
                        "latitude": "44.74435000",
                        "longitude": "27.85638000"
                    },
                    {
                        "id": 91917,
                        "name": "Comuna Grindu",
                        "latitude": "44.77212000",
                        "longitude": "26.90952000"
                    },
                    {
                        "id": 91921,
                        "name": "Comuna Griviţa",
                        "latitude": "44.72969000",
                        "longitude": "27.32227000"
                    },
                    {
                        "id": 91948,
                        "name": "Comuna Gura Ialomiţei",
                        "latitude": "44.73165000",
                        "longitude": "27.74035000"
                    },
                    {
                        "id": 92084,
                        "name": "Comuna Ion Roată",
                        "latitude": "44.66757000",
                        "longitude": "26.76803000"
                    },
                    {
                        "id": 92124,
                        "name": "Comuna Jilavele",
                        "latitude": "44.77522000",
                        "longitude": "26.52478000"
                    },
                    {
                        "id": 92230,
                        "name": "Comuna Maia",
                        "latitude": "44.73616000",
                        "longitude": "26.40151000"
                    },
                    {
                        "id": 92238,
                        "name": "Comuna Manasia",
                        "latitude": "44.70648000",
                        "longitude": "26.67346000"
                    },
                    {
                        "id": 92406,
                        "name": "Comuna Mărculeşti",
                        "latitude": "44.56698000",
                        "longitude": "27.51562000"
                    },
                    {
                        "id": 92276,
                        "name": "Comuna Mihail Kogălniceanu",
                        "latitude": "44.66216000",
                        "longitude": "27.73430000"
                    },
                    {
                        "id": 92292,
                        "name": "Comuna Miloşeşti",
                        "latitude": "44.75820000",
                        "longitude": "27.20338000"
                    },
                    {
                        "id": 92326,
                        "name": "Comuna Moldoveni",
                        "latitude": "44.71425000",
                        "longitude": "26.51879000"
                    },
                    {
                        "id": 92337,
                        "name": "Comuna Movila",
                        "latitude": "44.53747000",
                        "longitude": "27.71771000"
                    },
                    {
                        "id": 92343,
                        "name": "Comuna Moviliţa",
                        "latitude": "44.61784000",
                        "longitude": "26.48006000"
                    },
                    {
                        "id": 92357,
                        "name": "Comuna Munteni Buzău",
                        "latitude": "44.63838000",
                        "longitude": "26.97288000"
                    },
                    {
                        "id": 92485,
                        "name": "Comuna Ograda",
                        "latitude": "44.61457000",
                        "longitude": "27.57047000"
                    },
                    {
                        "id": 92551,
                        "name": "Comuna Perieţi",
                        "latitude": "44.57191000",
                        "longitude": "27.26027000"
                    },
                    {
                        "id": 92591,
                        "name": "Comuna Platoneşti",
                        "latitude": "44.60713000",
                        "longitude": "27.68637000"
                    },
                    {
                        "id": 92845,
                        "name": "Comuna Răduleşti",
                        "latitude": "44.77609000",
                        "longitude": "26.33987000"
                    },
                    {
                        "id": 92769,
                        "name": "Comuna Reviga",
                        "latitude": "44.69251000",
                        "longitude": "27.10866000"
                    },
                    {
                        "id": 92802,
                        "name": "Comuna Roşiori",
                        "latitude": "44.61265000",
                        "longitude": "26.53496000"
                    },
                    {
                        "id": 93095,
                        "name": "Comuna Sălcioara",
                        "latitude": "44.53755000",
                        "longitude": "26.90312000"
                    },
                    {
                        "id": 93111,
                        "name": "Comuna Sărăţeni",
                        "latitude": "44.63422000",
                        "longitude": "26.92686000"
                    },
                    {
                        "id": 93116,
                        "name": "Comuna Săveni",
                        "latitude": "44.60868000",
                        "longitude": "27.62061000"
                    },
                    {
                        "id": 92902,
                        "name": "Comuna Scânteia",
                        "latitude": "44.73262000",
                        "longitude": "27.44334000"
                    },
                    {
                        "id": 92923,
                        "name": "Comuna Sfântu Gheorghe",
                        "latitude": "44.64735000",
                        "longitude": "26.84315000"
                    },
                    {
                        "id": 92942,
                        "name": "Comuna Sinteşti",
                        "latitude": "44.56260000",
                        "longitude": "26.41162000"
                    },
                    {
                        "id": 92953,
                        "name": "Comuna Slobozia",
                        "latitude": "44.57437000",
                        "longitude": "27.38755000"
                    },
                    {
                        "id": 92990,
                        "name": "Comuna Stelnica",
                        "latitude": "44.42585000",
                        "longitude": "27.88823000"
                    },
                    {
                        "id": 93028,
                        "name": "Comuna Sudiţi",
                        "latitude": "44.57135000",
                        "longitude": "27.58215000"
                    },
                    {
                        "id": 93185,
                        "name": "Comuna Traian",
                        "latitude": "44.76350000",
                        "longitude": "27.34337000"
                    },
                    {
                        "id": 93300,
                        "name": "Comuna Valea Ciorii",
                        "latitude": "44.71456000",
                        "longitude": "27.53979000"
                    },
                    {
                        "id": 93318,
                        "name": "Comuna Valea Măcrişului",
                        "latitude": "44.73554000",
                        "longitude": "26.83515000"
                    },
                    {
                        "id": 93386,
                        "name": "Comuna Vlădeni",
                        "latitude": "44.60652000",
                        "longitude": "27.85120000"
                    },
                    {
                        "id": 93590,
                        "name": "Condeești",
                        "latitude": "44.62761000",
                        "longitude": "26.69147000"
                    },
                    {
                        "id": 93671,
                        "name": "Cosâmbeşti",
                        "latitude": "44.55929000",
                        "longitude": "27.43441000"
                    },
                    {
                        "id": 93690,
                        "name": "Coşereni",
                        "latitude": "44.68333000",
                        "longitude": "26.56667000"
                    },
                    {
                        "id": 94043,
                        "name": "Drăgoești",
                        "latitude": "44.56786000",
                        "longitude": "26.53950000"
                    },
                    {
                        "id": 94042,
                        "name": "Drăgoeşti-Snagov",
                        "latitude": "44.56667000",
                        "longitude": "26.53333000"
                    },
                    {
                        "id": 94031,
                        "name": "Dridu",
                        "latitude": "44.70000000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 94249,
                        "name": "Făcăeni",
                        "latitude": "44.56667000",
                        "longitude": "27.90000000"
                    },
                    {
                        "id": 94160,
                        "name": "Feteşti",
                        "latitude": "44.38333000",
                        "longitude": "27.83333000"
                    },
                    {
                        "id": 94162,
                        "name": "Fetești-Gară",
                        "latitude": "44.41960000",
                        "longitude": "27.82536000"
                    },
                    {
                        "id": 94165,
                        "name": "Fierbinţi-Târg",
                        "latitude": "44.70000000",
                        "longitude": "26.35000000"
                    },
                    {
                        "id": 94167,
                        "name": "Fierbinții de Jos",
                        "latitude": "44.69523000",
                        "longitude": "26.39629000"
                    },
                    {
                        "id": 94168,
                        "name": "Fierbinții de Sus",
                        "latitude": "44.68186000",
                        "longitude": "26.40200000"
                    },
                    {
                        "id": 94484,
                        "name": "Gârbovi",
                        "latitude": "44.78333000",
                        "longitude": "26.76667000"
                    },
                    {
                        "id": 94301,
                        "name": "Gheorghe Doja",
                        "latitude": "44.61622000",
                        "longitude": "27.18740000"
                    },
                    {
                        "id": 94302,
                        "name": "Gheorghe Lazăr",
                        "latitude": "44.63333000",
                        "longitude": "27.45000000"
                    },
                    {
                        "id": 94352,
                        "name": "Giurgeni",
                        "latitude": "44.76667000",
                        "longitude": "27.88333000"
                    },
                    {
                        "id": 94412,
                        "name": "Grindu",
                        "latitude": "44.76667000",
                        "longitude": "26.91667000"
                    },
                    {
                        "id": 94415,
                        "name": "Griviţa",
                        "latitude": "44.73333000",
                        "longitude": "27.28333000"
                    },
                    {
                        "id": 94455,
                        "name": "Gura Ialomiței",
                        "latitude": "44.71608000",
                        "longitude": "27.75310000"
                    },
                    {
                        "id": 94627,
                        "name": "Iazu",
                        "latitude": "44.73120000",
                        "longitude": "27.42074000"
                    },
                    {
                        "id": 94676,
                        "name": "Ion Roată",
                        "latitude": "44.66667000",
                        "longitude": "26.76667000"
                    },
                    {
                        "id": 94737,
                        "name": "Jilavele",
                        "latitude": "44.76667000",
                        "longitude": "26.53333000"
                    },
                    {
                        "id": 94890,
                        "name": "Lăcusteni",
                        "latitude": "44.60715000",
                        "longitude": "27.67569000"
                    },
                    {
                        "id": 94839,
                        "name": "Luciu",
                        "latitude": "44.74722000",
                        "longitude": "27.72760000"
                    },
                    {
                        "id": 94907,
                        "name": "Maia",
                        "latitude": "44.73616000",
                        "longitude": "26.40151000"
                    },
                    {
                        "id": 94917,
                        "name": "Malu Roșu",
                        "latitude": "44.78088000",
                        "longitude": "26.57945000"
                    },
                    {
                        "id": 94921,
                        "name": "Manasia",
                        "latitude": "44.70000000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 95267,
                        "name": "Mărculești",
                        "latitude": "44.56698000",
                        "longitude": "27.51562000"
                    },
                    {
                        "id": 94983,
                        "name": "Mihail Kogălniceanu",
                        "latitude": "44.68333000",
                        "longitude": "27.73333000"
                    },
                    {
                        "id": 95006,
                        "name": "Miloşeşti",
                        "latitude": "44.73333000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 95064,
                        "name": "Moldoveni",
                        "latitude": "44.71425000",
                        "longitude": "26.51879000"
                    },
                    {
                        "id": 95079,
                        "name": "Movila",
                        "latitude": "44.55000000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 95086,
                        "name": "Moviliţa",
                        "latitude": "44.65000000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 95140,
                        "name": "Municipiul Feteşti",
                        "latitude": "44.38608000",
                        "longitude": "27.82483000"
                    },
                    {
                        "id": 95194,
                        "name": "Municipiul Urziceni",
                        "latitude": "44.71842000",
                        "longitude": "26.64187000"
                    },
                    {
                        "id": 95201,
                        "name": "Munteni Buzău",
                        "latitude": "44.63333000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 95414,
                        "name": "Ograda",
                        "latitude": "44.61457000",
                        "longitude": "27.57047000"
                    },
                    {
                        "id": 95448,
                        "name": "Oraş Amara",
                        "latitude": "44.61793000",
                        "longitude": "27.33411000"
                    },
                    {
                        "id": 95506,
                        "name": "Oraş Cãzãneşti",
                        "latitude": "44.62514000",
                        "longitude": "27.01697000"
                    },
                    {
                        "id": 95516,
                        "name": "Oraş Fierbinţi-Târg",
                        "latitude": "44.68292000",
                        "longitude": "26.38324000"
                    },
                    {
                        "id": 95633,
                        "name": "Oraş Ţãndãrei",
                        "latitude": "44.64491000",
                        "longitude": "27.65196000"
                    },
                    {
                        "id": 95717,
                        "name": "Patru Frați",
                        "latitude": "44.73672000",
                        "longitude": "26.47059000"
                    },
                    {
                        "id": 95732,
                        "name": "Perieţi",
                        "latitude": "44.55000000",
                        "longitude": "27.21667000"
                    },
                    {
                        "id": 95806,
                        "name": "Platonești",
                        "latitude": "44.60712000",
                        "longitude": "27.69706000"
                    },
                    {
                        "id": 96200,
                        "name": "Rădulești",
                        "latitude": "44.76667000",
                        "longitude": "26.35000000"
                    },
                    {
                        "id": 96063,
                        "name": "Rași",
                        "latitude": "44.53534000",
                        "longitude": "26.92485000"
                    },
                    {
                        "id": 96090,
                        "name": "Reviga",
                        "latitude": "44.71667000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 96140,
                        "name": "Roșiori",
                        "latitude": "44.61265000",
                        "longitude": "26.53496000"
                    },
                    {
                        "id": 96123,
                        "name": "Rovine",
                        "latitude": "44.69540000",
                        "longitude": "27.09364000"
                    },
                    {
                        "id": 106012,
                        "name": "Sălcioara",
                        "latitude": "44.53333000",
                        "longitude": "26.88333000"
                    },
                    {
                        "id": 106037,
                        "name": "Sărățeni",
                        "latitude": "44.63422000",
                        "longitude": "26.92686000"
                    },
                    {
                        "id": 106045,
                        "name": "Săveni",
                        "latitude": "44.60000000",
                        "longitude": "27.65000000"
                    },
                    {
                        "id": 96293,
                        "name": "Scânteia",
                        "latitude": "44.73404000",
                        "longitude": "27.46593000"
                    },
                    {
                        "id": 96329,
                        "name": "Sfântu Gheorghe",
                        "latitude": "44.65000000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 96353,
                        "name": "Sineşti",
                        "latitude": "44.56667000",
                        "longitude": "26.38333000"
                    },
                    {
                        "id": 96373,
                        "name": "Slobozia",
                        "latitude": "44.56470000",
                        "longitude": "27.36330000"
                    },
                    {
                        "id": 96387,
                        "name": "Smirna",
                        "latitude": "44.72405000",
                        "longitude": "27.35478000"
                    },
                    {
                        "id": 96429,
                        "name": "Stelnica",
                        "latitude": "44.41667000",
                        "longitude": "27.88333000"
                    },
                    {
                        "id": 96493,
                        "name": "Sudiţi",
                        "latitude": "44.58333000",
                        "longitude": "27.60000000"
                    },
                    {
                        "id": 97112,
                        "name": "Ţăndărei",
                        "latitude": "44.65000000",
                        "longitude": "27.66667000"
                    },
                    {
                        "id": 106144,
                        "name": "Traian",
                        "latitude": "44.76350000",
                        "longitude": "27.34337000"
                    },
                    {
                        "id": 96688,
                        "name": "Urziceni",
                        "latitude": "44.71667000",
                        "longitude": "26.63333000"
                    },
                    {
                        "id": 96715,
                        "name": "Valea Ciorii",
                        "latitude": "44.71667000",
                        "longitude": "27.56667000"
                    },
                    {
                        "id": 96742,
                        "name": "Valea Măcrișului",
                        "latitude": "44.74379000",
                        "longitude": "26.83015000"
                    },
                    {
                        "id": 96860,
                        "name": "Vlădeni",
                        "latitude": "44.61667000",
                        "longitude": "27.88333000"
                    },
                    {
                        "id": 96858,
                        "name": "Vlașca",
                        "latitude": "44.39664000",
                        "longitude": "27.84865000"
                    }
                ]
            },
            {
                "id": 4735,
                "name": "Iași",
                "iso2": "IS",
                "latitude": "47.26796530",
                "longitude": "27.21856620",
                "type": "department",
                "cities": [
                    {
                        "id": 89926,
                        "name": "Alexandru I. Cuza",
                        "latitude": "47.13333000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 89958,
                        "name": "Andrieşeni",
                        "latitude": "47.53333000",
                        "longitude": "27.28333000"
                    },
                    {
                        "id": 89997,
                        "name": "Aroneanu",
                        "latitude": "47.20000000",
                        "longitude": "27.60000000"
                    },
                    {
                        "id": 90480,
                        "name": "Bădeni",
                        "latitude": "47.40581000",
                        "longitude": "26.94898000"
                    },
                    {
                        "id": 90052,
                        "name": "Balș",
                        "latitude": "47.29628000",
                        "longitude": "26.97856000"
                    },
                    {
                        "id": 90526,
                        "name": "Bălţaţi",
                        "latitude": "47.21667000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 90453,
                        "name": "Bârnova",
                        "latitude": "47.06667000",
                        "longitude": "27.61667000"
                    },
                    {
                        "id": 90084,
                        "name": "Belceşti",
                        "latitude": "47.30000000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 90152,
                        "name": "Bivolari",
                        "latitude": "47.53333000",
                        "longitude": "27.43333000"
                    },
                    {
                        "id": 90201,
                        "name": "Bohotin",
                        "latitude": "46.93914000",
                        "longitude": "27.97782000"
                    },
                    {
                        "id": 90232,
                        "name": "Borosoaia",
                        "latitude": "47.46300000",
                        "longitude": "27.09862000"
                    },
                    {
                        "id": 90241,
                        "name": "Bosia",
                        "latitude": "47.21696000",
                        "longitude": "27.76707000"
                    },
                    {
                        "id": 90251,
                        "name": "Boureni",
                        "latitude": "47.26497000",
                        "longitude": "26.97672000"
                    },
                    {
                        "id": 90325,
                        "name": "Brădicești",
                        "latitude": "46.84810000",
                        "longitude": "27.90270000"
                    },
                    {
                        "id": 90329,
                        "name": "Brăeşti",
                        "latitude": "47.15000000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 90340,
                        "name": "Brătești",
                        "latitude": "47.19135000",
                        "longitude": "26.68580000"
                    },
                    {
                        "id": 90289,
                        "name": "Breazu",
                        "latitude": "47.21343000",
                        "longitude": "27.51815000"
                    },
                    {
                        "id": 90375,
                        "name": "Buda",
                        "latitude": "47.40318000",
                        "longitude": "26.67835000"
                    },
                    {
                        "id": 90389,
                        "name": "Budăi",
                        "latitude": "47.21773000",
                        "longitude": "27.22282000"
                    },
                    {
                        "id": 90395,
                        "name": "Buhalnița",
                        "latitude": "47.37892000",
                        "longitude": "26.91547000"
                    },
                    {
                        "id": 90425,
                        "name": "Butea",
                        "latitude": "47.06667000",
                        "longitude": "26.91667000"
                    },
                    {
                        "id": 90433,
                        "name": "Buznea",
                        "latitude": "47.19515000",
                        "longitude": "27.01572000"
                    },
                    {
                        "id": 93812,
                        "name": "Cârjoaia",
                        "latitude": "47.34032000",
                        "longitude": "26.90863000"
                    },
                    {
                        "id": 93818,
                        "name": "Cârniceni",
                        "latitude": "47.33942000",
                        "longitude": "27.50508000"
                    },
                    {
                        "id": 90618,
                        "name": "Cepleniţa",
                        "latitude": "47.38333000",
                        "longitude": "27.01667000"
                    },
                    {
                        "id": 90689,
                        "name": "Chișcăreni",
                        "latitude": "47.46974000",
                        "longitude": "27.19626000"
                    },
                    {
                        "id": 90719,
                        "name": "Ciohorăni",
                        "latitude": "47.13520000",
                        "longitude": "26.68955000"
                    },
                    {
                        "id": 90728,
                        "name": "Ciorteşti",
                        "latitude": "46.90000000",
                        "longitude": "27.83333000"
                    },
                    {
                        "id": 90757,
                        "name": "Ciurea",
                        "latitude": "47.05000000",
                        "longitude": "27.56667000"
                    },
                    {
                        "id": 90773,
                        "name": "Coarnele Caprei",
                        "latitude": "47.38333000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 90788,
                        "name": "Cogeasca",
                        "latitude": "47.16644000",
                        "longitude": "27.38537000"
                    },
                    {
                        "id": 90811,
                        "name": "Comarna",
                        "latitude": "47.05000000",
                        "longitude": "27.78333000"
                    },
                    {
                        "id": 90848,
                        "name": "Comuna Alexandru I. Cuza",
                        "latitude": "47.14424000",
                        "longitude": "26.85449000"
                    },
                    {
                        "id": 90870,
                        "name": "Comuna Andrieşeni",
                        "latitude": "47.51112000",
                        "longitude": "27.29502000"
                    },
                    {
                        "id": 90896,
                        "name": "Comuna Aroneanu",
                        "latitude": "47.21584000",
                        "longitude": "27.60632000"
                    },
                    {
                        "id": 90931,
                        "name": "Comuna Balş",
                        "latitude": "47.29219000",
                        "longitude": "26.96028000"
                    },
                    {
                        "id": 91227,
                        "name": "Comuna Bălţaţi",
                        "latitude": "47.23366000",
                        "longitude": "27.11866000"
                    },
                    {
                        "id": 91190,
                        "name": "Comuna Bârnova",
                        "latitude": "47.08669000",
                        "longitude": "27.62635000"
                    },
                    {
                        "id": 90949,
                        "name": "Comuna Belceşti",
                        "latitude": "47.30581000",
                        "longitude": "27.08747000"
                    },
                    {
                        "id": 90999,
                        "name": "Comuna Bivolari",
                        "latitude": "47.52988000",
                        "longitude": "27.42726000"
                    },
                    {
                        "id": 91118,
                        "name": "Comuna Brăeşti",
                        "latitude": "47.16318000",
                        "longitude": "27.09031000"
                    },
                    {
                        "id": 91173,
                        "name": "Comuna Butea",
                        "latitude": "47.08386000",
                        "longitude": "26.93552000"
                    },
                    {
                        "id": 91284,
                        "name": "Comuna Cepleniţa",
                        "latitude": "47.37581000",
                        "longitude": "26.92597000"
                    },
                    {
                        "id": 91349,
                        "name": "Comuna Ciohorãni",
                        "latitude": "47.13520000",
                        "longitude": "26.68955000"
                    },
                    {
                        "id": 91356,
                        "name": "Comuna Ciorteşti",
                        "latitude": "46.91766000",
                        "longitude": "27.84749000"
                    },
                    {
                        "id": 91375,
                        "name": "Comuna Ciurea",
                        "latitude": "47.06150000",
                        "longitude": "27.57572000"
                    },
                    {
                        "id": 91382,
                        "name": "Comuna Coarnele Caprei",
                        "latitude": "47.40195000",
                        "longitude": "27.09699000"
                    },
                    {
                        "id": 91407,
                        "name": "Comuna Comarna",
                        "latitude": "47.07004000",
                        "longitude": "27.78668000"
                    },
                    {
                        "id": 91457,
                        "name": "Comuna Costeşti",
                        "latitude": "47.24224000",
                        "longitude": "26.91751000"
                    },
                    {
                        "id": 91461,
                        "name": "Comuna Costuleni",
                        "latitude": "47.01055000",
                        "longitude": "27.85829000"
                    },
                    {
                        "id": 91466,
                        "name": "Comuna Cotnari",
                        "latitude": "47.35813000",
                        "longitude": "26.91687000"
                    },
                    {
                        "id": 91471,
                        "name": "Comuna Cozmeşti",
                        "latitude": "46.86032000",
                        "longitude": "28.01297000"
                    },
                    {
                        "id": 91496,
                        "name": "Comuna Cristeşti",
                        "latitude": "47.27821000",
                        "longitude": "26.58525000"
                    },
                    {
                        "id": 91520,
                        "name": "Comuna Cucuteni",
                        "latitude": "47.27587000",
                        "longitude": "26.92807000"
                    },
                    {
                        "id": 91599,
                        "name": "Comuna Dagâţa",
                        "latitude": "46.94469000",
                        "longitude": "27.19147000"
                    },
                    {
                        "id": 91611,
                        "name": "Comuna Deleni",
                        "latitude": "47.47458000",
                        "longitude": "26.89451000"
                    },
                    {
                        "id": 91644,
                        "name": "Comuna Dobrovăţ",
                        "latitude": "46.96335000",
                        "longitude": "27.72245000"
                    },
                    {
                        "id": 91655,
                        "name": "Comuna Dolheşti",
                        "latitude": "46.86958000",
                        "longitude": "27.90652000"
                    },
                    {
                        "id": 91697,
                        "name": "Comuna Drăguşeni",
                        "latitude": "46.89432000",
                        "longitude": "27.49491000"
                    },
                    {
                        "id": 91720,
                        "name": "Comuna Dumeşti",
                        "latitude": "47.17668000",
                        "longitude": "27.33470000"
                    },
                    {
                        "id": 91749,
                        "name": "Comuna Erbiceni",
                        "latitude": "47.25219000",
                        "longitude": "27.24756000"
                    },
                    {
                        "id": 91807,
                        "name": "Comuna Fântânele",
                        "latitude": "47.41498000",
                        "longitude": "27.18066000"
                    },
                    {
                        "id": 91774,
                        "name": "Comuna Focuri",
                        "latitude": "47.35113000",
                        "longitude": "27.20200000"
                    },
                    {
                        "id": 91899,
                        "name": "Comuna Golãieşti",
                        "latitude": "47.26355000",
                        "longitude": "27.69515000"
                    },
                    {
                        "id": 91900,
                        "name": "Comuna Gorban",
                        "latitude": "46.90059000",
                        "longitude": "28.07017000"
                    },
                    {
                        "id": 91910,
                        "name": "Comuna Grajduri",
                        "latitude": "46.97069000",
                        "longitude": "27.55569000"
                    },
                    {
                        "id": 91925,
                        "name": "Comuna Gropniţa",
                        "latitude": "47.36874000",
                        "longitude": "27.26376000"
                    },
                    {
                        "id": 91927,
                        "name": "Comuna Grozeşti",
                        "latitude": "47.01001000",
                        "longitude": "28.02507000"
                    },
                    {
                        "id": 92040,
                        "name": "Comuna Hălăuceşti",
                        "latitude": "47.10593000",
                        "longitude": "26.80967000"
                    },
                    {
                        "id": 92044,
                        "name": "Comuna Hărmăneşti",
                        "latitude": "47.27087000",
                        "longitude": "26.81322000"
                    },
                    {
                        "id": 91995,
                        "name": "Comuna Heleşteni",
                        "latitude": "47.19295000",
                        "longitude": "26.88060000"
                    },
                    {
                        "id": 92009,
                        "name": "Comuna Holboca",
                        "latitude": "47.17512000",
                        "longitude": "27.68235000"
                    },
                    {
                        "id": 92020,
                        "name": "Comuna Horleşti",
                        "latitude": "47.11718000",
                        "longitude": "27.40856000"
                    },
                    {
                        "id": 92083,
                        "name": "Comuna Ion Neculce",
                        "latitude": "47.20159000",
                        "longitude": "27.03221000"
                    },
                    {
                        "id": 92089,
                        "name": "Comuna Ipatele",
                        "latitude": "46.90390000",
                        "longitude": "27.43762000"
                    },
                    {
                        "id": 92155,
                        "name": "Comuna Lespezi",
                        "latitude": "47.34957000",
                        "longitude": "26.68807000"
                    },
                    {
                        "id": 92161,
                        "name": "Comuna Leţcani",
                        "latitude": "47.18012000",
                        "longitude": "27.41296000"
                    },
                    {
                        "id": 92211,
                        "name": "Comuna Lungani",
                        "latitude": "47.17564000",
                        "longitude": "27.15749000"
                    },
                    {
                        "id": 92382,
                        "name": "Comuna Mădârjac",
                        "latitude": "47.04094000",
                        "longitude": "27.27716000"
                    },
                    {
                        "id": 92297,
                        "name": "Comuna Mirceşti",
                        "latitude": "47.05486000",
                        "longitude": "26.83945000"
                    },
                    {
                        "id": 92299,
                        "name": "Comuna Mironeasa",
                        "latitude": "46.99869000",
                        "longitude": "27.42519000"
                    },
                    {
                        "id": 92300,
                        "name": "Comuna Miroslava",
                        "latitude": "47.13047000",
                        "longitude": "27.51039000"
                    },
                    {
                        "id": 92301,
                        "name": "Comuna Mirosloveşti",
                        "latitude": "47.13966000",
                        "longitude": "26.64648000"
                    },
                    {
                        "id": 92319,
                        "name": "Comuna Mogoşeşti",
                        "latitude": "47.04200000",
                        "longitude": "27.48492000"
                    },
                    {
                        "id": 92320,
                        "name": "Comuna Mogoşeşti-Siret",
                        "latitude": "47.13190000",
                        "longitude": "26.77101000"
                    },
                    {
                        "id": 92347,
                        "name": "Comuna Moşna",
                        "latitude": "46.92189000",
                        "longitude": "27.95956000"
                    },
                    {
                        "id": 92351,
                        "name": "Comuna Moţca",
                        "latitude": "47.22407000",
                        "longitude": "26.61632000"
                    },
                    {
                        "id": 92341,
                        "name": "Comuna Movileni",
                        "latitude": "47.32032000",
                        "longitude": "27.38016000"
                    },
                    {
                        "id": 92526,
                        "name": "Comuna Oţeleni",
                        "latitude": "47.08566000",
                        "longitude": "27.02730000"
                    },
                    {
                        "id": 92604,
                        "name": "Comuna Plugari",
                        "latitude": "47.47732000",
                        "longitude": "27.11577000"
                    },
                    {
                        "id": 92654,
                        "name": "Comuna Popeşti",
                        "latitude": "47.13704000",
                        "longitude": "27.26169000"
                    },
                    {
                        "id": 92658,
                        "name": "Comuna Popricani",
                        "latitude": "47.26750000",
                        "longitude": "27.52729000"
                    },
                    {
                        "id": 92679,
                        "name": "Comuna Prisăcani",
                        "latitude": "47.07015000",
                        "longitude": "27.90795000"
                    },
                    {
                        "id": 92680,
                        "name": "Comuna Probota",
                        "latitude": "47.38792000",
                        "longitude": "27.49446000"
                    },
                    {
                        "id": 92837,
                        "name": "Comuna Răchiţeni",
                        "latitude": "47.05163000",
                        "longitude": "26.90504000"
                    },
                    {
                        "id": 92844,
                        "name": "Comuna Răducăneni",
                        "latitude": "46.95541000",
                        "longitude": "27.97344000"
                    },
                    {
                        "id": 92761,
                        "name": "Comuna Rediu-Tătar",
                        "latitude": "47.23169000",
                        "longitude": "27.48747000"
                    },
                    {
                        "id": 92787,
                        "name": "Comuna Româneşti",
                        "latitude": "47.27171000",
                        "longitude": "27.35819000"
                    },
                    {
                        "id": 92794,
                        "name": "Comuna Roşcani",
                        "latitude": "47.44259000",
                        "longitude": "27.41778000"
                    },
                    {
                        "id": 92808,
                        "name": "Comuna Ruginoasa",
                        "latitude": "47.25259000",
                        "longitude": "26.85589000"
                    },
                    {
                        "id": 92901,
                        "name": "Comuna Scânteia",
                        "latitude": "46.92408000",
                        "longitude": "27.58855000"
                    },
                    {
                        "id": 92884,
                        "name": "Comuna Scheia",
                        "latitude": "46.93950000",
                        "longitude": "27.49765000"
                    },
                    {
                        "id": 92889,
                        "name": "Comuna Schitu-Duca",
                        "latitude": "47.00255000",
                        "longitude": "27.76703000"
                    },
                    {
                        "id": 92892,
                        "name": "Comuna Scobinţi",
                        "latitude": "47.40529000",
                        "longitude": "26.89850000"
                    },
                    {
                        "id": 92939,
                        "name": "Comuna Sineşti",
                        "latitude": "47.12117000",
                        "longitude": "27.18745000"
                    },
                    {
                        "id": 93528,
                        "name": "Comuna Şipote",
                        "latitude": "47.46038000",
                        "longitude": "27.22592000"
                    },
                    {
                        "id": 92943,
                        "name": "Comuna Sireţel",
                        "latitude": "47.41840000",
                        "longitude": "26.73381000"
                    },
                    {
                        "id": 92998,
                        "name": "Comuna Stolniceni-Prăjescu",
                        "latitude": "47.18563000",
                        "longitude": "26.73525000"
                    },
                    {
                        "id": 93007,
                        "name": "Comuna Strunga",
                        "latitude": "47.16021000",
                        "longitude": "26.94400000"
                    },
                    {
                        "id": 93124,
                        "name": "Comuna Tansa",
                        "latitude": "46.90812000",
                        "longitude": "27.24808000"
                    },
                    {
                        "id": 93245,
                        "name": "Comuna Tătăruşi",
                        "latitude": "47.34254000",
                        "longitude": "26.58590000"
                    },
                    {
                        "id": 93570,
                        "name": "Comuna Ţibana",
                        "latitude": "46.98685000",
                        "longitude": "27.32607000"
                    },
                    {
                        "id": 93572,
                        "name": "Comuna Ţibăneşti",
                        "latitude": "46.91757000",
                        "longitude": "27.33547000"
                    },
                    {
                        "id": 93574,
                        "name": "Comuna Ţigănaşi",
                        "latitude": "47.34867000",
                        "longitude": "27.45588000"
                    },
                    {
                        "id": 93165,
                        "name": "Comuna Todireşti",
                        "latitude": "47.32137000",
                        "longitude": "26.87743000"
                    },
                    {
                        "id": 93168,
                        "name": "Comuna Tomeşti",
                        "latitude": "47.11704000",
                        "longitude": "27.70476000"
                    },
                    {
                        "id": 93193,
                        "name": "Comuna Trifeşti",
                        "latitude": "47.44992000",
                        "longitude": "27.53175000"
                    },
                    {
                        "id": 93578,
                        "name": "Comuna Ţuţora",
                        "latitude": "47.12578000",
                        "longitude": "27.79866000"
                    },
                    {
                        "id": 93268,
                        "name": "Comuna Ungheni",
                        "latitude": "47.20176000",
                        "longitude": "27.74664000"
                    },
                    {
                        "id": 93310,
                        "name": "Comuna Valea Lupului",
                        "latitude": "47.17920000",
                        "longitude": "27.49965000"
                    },
                    {
                        "id": 93321,
                        "name": "Comuna Valea Seacă",
                        "latitude": "47.28840000",
                        "longitude": "26.66455000"
                    },
                    {
                        "id": 93432,
                        "name": "Comuna Vânãtori",
                        "latitude": "47.33379000",
                        "longitude": "26.76404000"
                    },
                    {
                        "id": 93353,
                        "name": "Comuna Victoria",
                        "latitude": "47.30749000",
                        "longitude": "27.60170000"
                    },
                    {
                        "id": 93388,
                        "name": "Comuna Vlădeni",
                        "latitude": "47.43756000",
                        "longitude": "27.33560000"
                    },
                    {
                        "id": 93399,
                        "name": "Comuna Voineşti",
                        "latitude": "47.07509000",
                        "longitude": "27.42151000"
                    },
                    {
                        "id": 93599,
                        "name": "Conțești",
                        "latitude": "47.30960000",
                        "longitude": "26.65605000"
                    },
                    {
                        "id": 93650,
                        "name": "Coropceni",
                        "latitude": "46.94193000",
                        "longitude": "27.83710000"
                    },
                    {
                        "id": 93665,
                        "name": "Costești",
                        "latitude": "47.23428000",
                        "longitude": "26.92622000"
                    },
                    {
                        "id": 93669,
                        "name": "Costuleni",
                        "latitude": "47.03333000",
                        "longitude": "27.85000000"
                    },
                    {
                        "id": 93676,
                        "name": "Cotnari",
                        "latitude": "47.35000000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 93679,
                        "name": "Covasna",
                        "latitude": "47.00255000",
                        "longitude": "27.85106000"
                    },
                    {
                        "id": 93683,
                        "name": "Cozia",
                        "latitude": "47.00319000",
                        "longitude": "27.89434000"
                    },
                    {
                        "id": 93686,
                        "name": "Cozmeşti",
                        "latitude": "46.88333000",
                        "longitude": "27.98333000"
                    },
                    {
                        "id": 93719,
                        "name": "Cristeşti",
                        "latitude": "47.26667000",
                        "longitude": "26.56667000"
                    },
                    {
                        "id": 93728,
                        "name": "Crivești",
                        "latitude": "47.32430000",
                        "longitude": "26.78240000"
                    },
                    {
                        "id": 93742,
                        "name": "Crucea",
                        "latitude": "47.16567000",
                        "longitude": "27.17093000"
                    },
                    {
                        "id": 93762,
                        "name": "Cucuteni",
                        "latitude": "47.28333000",
                        "longitude": "26.93333000"
                    },
                    {
                        "id": 93887,
                        "name": "Dagâţa",
                        "latitude": "46.93333000",
                        "longitude": "27.18333000"
                    },
                    {
                        "id": 93892,
                        "name": "Dancu",
                        "latitude": "47.15417000",
                        "longitude": "27.66623000"
                    },
                    {
                        "id": 93915,
                        "name": "Deleni",
                        "latitude": "47.46667000",
                        "longitude": "26.88333000"
                    },
                    {
                        "id": 93969,
                        "name": "Dobrovăţ",
                        "latitude": "46.95000000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 93983,
                        "name": "Dolheşti",
                        "latitude": "46.86667000",
                        "longitude": "27.90000000"
                    },
                    {
                        "id": 93993,
                        "name": "Domnița",
                        "latitude": "47.02091000",
                        "longitude": "27.33500000"
                    },
                    {
                        "id": 94053,
                        "name": "Drăgușeni",
                        "latitude": "46.90116000",
                        "longitude": "27.51260000"
                    },
                    {
                        "id": 94076,
                        "name": "Dumbrava",
                        "latitude": "47.07578000",
                        "longitude": "27.55174000"
                    },
                    {
                        "id": 94091,
                        "name": "Dumbrăvița",
                        "latitude": "47.25483000",
                        "longitude": "26.84169000"
                    },
                    {
                        "id": 94096,
                        "name": "Dumeşti",
                        "latitude": "47.18333000",
                        "longitude": "27.35000000"
                    },
                    {
                        "id": 94144,
                        "name": "Erbiceni",
                        "latitude": "47.26667000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 94241,
                        "name": "Fântânele",
                        "latitude": "47.41498000",
                        "longitude": "27.18066000"
                    },
                    {
                        "id": 94266,
                        "name": "Fărcășeni",
                        "latitude": "47.15987000",
                        "longitude": "26.89615000"
                    },
                    {
                        "id": 94161,
                        "name": "Fetești",
                        "latitude": "47.40932000",
                        "longitude": "26.90885000"
                    },
                    {
                        "id": 94192,
                        "name": "Focuri",
                        "latitude": "47.35000000",
                        "longitude": "27.21667000"
                    },
                    {
                        "id": 94481,
                        "name": "Gârbești",
                        "latitude": "46.98333000",
                        "longitude": "27.30000000"
                    },
                    {
                        "id": 94363,
                        "name": "Glodenii Gândului",
                        "latitude": "46.95158000",
                        "longitude": "27.29938000"
                    },
                    {
                        "id": 94370,
                        "name": "Goești",
                        "latitude": "47.15654000",
                        "longitude": "27.13659000"
                    },
                    {
                        "id": 94380,
                        "name": "Golăiești",
                        "latitude": "47.23333000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 94382,
                        "name": "Gorban",
                        "latitude": "46.87611000",
                        "longitude": "28.07889000"
                    },
                    {
                        "id": 94391,
                        "name": "Goruni",
                        "latitude": "47.10389000",
                        "longitude": "27.71854000"
                    },
                    {
                        "id": 94400,
                        "name": "Grajduri",
                        "latitude": "46.96667000",
                        "longitude": "27.51667000"
                    },
                    {
                        "id": 94420,
                        "name": "Gropniţa",
                        "latitude": "47.35000000",
                        "longitude": "27.25000000"
                    },
                    {
                        "id": 94422,
                        "name": "Grozeşti",
                        "latitude": "46.99083000",
                        "longitude": "28.05056000"
                    },
                    {
                        "id": 94602,
                        "name": "Hălăuceşti",
                        "latitude": "47.10000000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 94588,
                        "name": "Hârlău",
                        "latitude": "47.43333000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 94606,
                        "name": "Hărmăneasa",
                        "latitude": "47.20000000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 94607,
                        "name": "Hărmăneștii Vechi",
                        "latitude": "47.27732000",
                        "longitude": "26.81394000"
                    },
                    {
                        "id": 94591,
                        "name": "Hârtoape",
                        "latitude": "47.32164000",
                        "longitude": "26.72459000"
                    },
                    {
                        "id": 94526,
                        "name": "Heci",
                        "latitude": "47.34325000",
                        "longitude": "26.66226000"
                    },
                    {
                        "id": 94528,
                        "name": "Heleșteni",
                        "latitude": "47.20303000",
                        "longitude": "26.87755000"
                    },
                    {
                        "id": 94544,
                        "name": "Hodora",
                        "latitude": "47.33712000",
                        "longitude": "27.01970000"
                    },
                    {
                        "id": 94549,
                        "name": "Holboca",
                        "latitude": "47.15000000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 94564,
                        "name": "Horleşti",
                        "latitude": "47.11667000",
                        "longitude": "27.36667000"
                    },
                    {
                        "id": 94630,
                        "name": "Iaşi",
                        "latitude": "47.16667000",
                        "longitude": "27.60000000"
                    },
                    {
                        "id": 94628,
                        "name": "Iazu Nou",
                        "latitude": "47.48272000",
                        "longitude": "27.20913000"
                    },
                    {
                        "id": 94675,
                        "name": "Ion Neculce",
                        "latitude": "47.20344000",
                        "longitude": "27.05268000"
                    },
                    {
                        "id": 94683,
                        "name": "Ipatele",
                        "latitude": "46.91667000",
                        "longitude": "27.41667000"
                    },
                    {
                        "id": 94695,
                        "name": "Iugani",
                        "latitude": "47.04431000",
                        "longitude": "26.82891000"
                    },
                    {
                        "id": 94706,
                        "name": "Izvoarele",
                        "latitude": "47.04241000",
                        "longitude": "26.90230000"
                    },
                    {
                        "id": 94782,
                        "name": "Lespezi",
                        "latitude": "47.36667000",
                        "longitude": "26.70000000"
                    },
                    {
                        "id": 94791,
                        "name": "Leţcani",
                        "latitude": "47.18333000",
                        "longitude": "27.41667000"
                    },
                    {
                        "id": 94810,
                        "name": "Liteni",
                        "latitude": "47.30169000",
                        "longitude": "27.03837000"
                    },
                    {
                        "id": 94853,
                        "name": "Lunca",
                        "latitude": "47.28144000",
                        "longitude": "26.73708000"
                    },
                    {
                        "id": 94863,
                        "name": "Lunca Cetățuii",
                        "latitude": "47.09660000",
                        "longitude": "27.56319000"
                    },
                    {
                        "id": 94880,
                        "name": "Lungani",
                        "latitude": "47.18333000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 95232,
                        "name": "Mădârjac",
                        "latitude": "47.04994000",
                        "longitude": "27.26182000"
                    },
                    {
                        "id": 95261,
                        "name": "Mănăstirea",
                        "latitude": "46.95000000",
                        "longitude": "27.20000000"
                    },
                    {
                        "id": 94940,
                        "name": "Maxut",
                        "latitude": "47.44040000",
                        "longitude": "26.89204000"
                    },
                    {
                        "id": 95014,
                        "name": "Mirceşti",
                        "latitude": "47.08333000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 95019,
                        "name": "Mironeasa",
                        "latitude": "46.96667000",
                        "longitude": "27.41667000"
                    },
                    {
                        "id": 95021,
                        "name": "Miroslava",
                        "latitude": "47.15000000",
                        "longitude": "27.51667000"
                    },
                    {
                        "id": 95022,
                        "name": "Miroslovești",
                        "latitude": "47.15000000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 95053,
                        "name": "Mogoşeşti",
                        "latitude": "47.03333000",
                        "longitude": "27.53333000"
                    },
                    {
                        "id": 95054,
                        "name": "Mogoşeşti-Siret",
                        "latitude": "47.13333000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 95088,
                        "name": "Moşna",
                        "latitude": "46.91667000",
                        "longitude": "27.95000000"
                    },
                    {
                        "id": 95092,
                        "name": "Moţca",
                        "latitude": "47.25000000",
                        "longitude": "26.61667000"
                    },
                    {
                        "id": 95083,
                        "name": "Movileni",
                        "latitude": "47.31667000",
                        "longitude": "27.35000000"
                    },
                    {
                        "id": 95100,
                        "name": "Muncelu de Sus",
                        "latitude": "47.12384000",
                        "longitude": "26.73518000"
                    },
                    {
                        "id": 95150,
                        "name": "Municipiul Iaşi",
                        "latitude": "47.16184000",
                        "longitude": "27.58451000"
                    },
                    {
                        "id": 95166,
                        "name": "Municipiul Paşcani",
                        "latitude": "47.24736000",
                        "longitude": "26.71235000"
                    },
                    {
                        "id": 95199,
                        "name": "Munteni",
                        "latitude": "47.31530000",
                        "longitude": "27.13839000"
                    },
                    {
                        "id": 95531,
                        "name": "Oraş Hârlãu",
                        "latitude": "47.43153000",
                        "longitude": "26.87774000"
                    },
                    {
                        "id": 95569,
                        "name": "Oraş Podu Iloaiei",
                        "latitude": "47.20807000",
                        "longitude": "27.26548000"
                    },
                    {
                        "id": 95607,
                        "name": "Oraş Târgu Frumos",
                        "latitude": "47.20788000",
                        "longitude": "27.01196000"
                    },
                    {
                        "id": 95674,
                        "name": "Osoi",
                        "latitude": "47.09479000",
                        "longitude": "27.80091000"
                    },
                    {
                        "id": 95689,
                        "name": "Oţeleni",
                        "latitude": "47.08333000",
                        "longitude": "27.03333000"
                    },
                    {
                        "id": 95998,
                        "name": "Pârcovaci",
                        "latitude": "47.43586000",
                        "longitude": "26.85075000"
                    },
                    {
                        "id": 95718,
                        "name": "Paşcani",
                        "latitude": "47.24690000",
                        "longitude": "26.72291000"
                    },
                    {
                        "id": 96036,
                        "name": "Păușești",
                        "latitude": "47.15810000",
                        "longitude": "27.32594000"
                    },
                    {
                        "id": 95730,
                        "name": "Perieni",
                        "latitude": "47.38469000",
                        "longitude": "27.47453000"
                    },
                    {
                        "id": 95786,
                        "name": "Pietrosu",
                        "latitude": "47.34118000",
                        "longitude": "26.60817000"
                    },
                    {
                        "id": 95831,
                        "name": "Plugari",
                        "latitude": "47.48333000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 95849,
                        "name": "Podolenii de Sus",
                        "latitude": "46.85716000",
                        "longitude": "28.01545000"
                    },
                    {
                        "id": 95850,
                        "name": "Podu Iloaiei",
                        "latitude": "47.21667000",
                        "longitude": "27.26667000"
                    },
                    {
                        "id": 95862,
                        "name": "Poiana",
                        "latitude": "47.49299000",
                        "longitude": "26.86387000"
                    },
                    {
                        "id": 95877,
                        "name": "Poiana Mărului",
                        "latitude": "47.37951000",
                        "longitude": "26.89243000"
                    },
                    {
                        "id": 95893,
                        "name": "Poienile",
                        "latitude": "46.93333000",
                        "longitude": "27.18333000"
                    },
                    {
                        "id": 95909,
                        "name": "Popeşti",
                        "latitude": "47.15000000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 95919,
                        "name": "Popricani",
                        "latitude": "47.30000000",
                        "longitude": "27.51667000"
                    },
                    {
                        "id": 95956,
                        "name": "Prisăcani",
                        "latitude": "47.08333000",
                        "longitude": "27.88333000"
                    },
                    {
                        "id": 95957,
                        "name": "Probota",
                        "latitude": "47.38333000",
                        "longitude": "27.50000000"
                    },
                    {
                        "id": 96185,
                        "name": "Răchiteni",
                        "latitude": "47.05347000",
                        "longitude": "26.91730000"
                    },
                    {
                        "id": 96199,
                        "name": "Răducăneni",
                        "latitude": "46.95000000",
                        "longitude": "27.93333000"
                    },
                    {
                        "id": 96213,
                        "name": "Războieni",
                        "latitude": "47.21754000",
                        "longitude": "27.05039000"
                    },
                    {
                        "id": 96075,
                        "name": "Rediu",
                        "latitude": "47.21667000",
                        "longitude": "27.50000000"
                    },
                    {
                        "id": 96110,
                        "name": "Româneşti",
                        "latitude": "47.28333000",
                        "longitude": "27.31667000"
                    },
                    {
                        "id": 96134,
                        "name": "Roșcani",
                        "latitude": "47.45581000",
                        "longitude": "27.40021000"
                    },
                    {
                        "id": 96148,
                        "name": "Ruginoasa",
                        "latitude": "47.25000000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 96259,
                        "name": "Satu Nou",
                        "latitude": "47.32147000",
                        "longitude": "27.09555000"
                    },
                    {
                        "id": 96292,
                        "name": "Scânteia",
                        "latitude": "46.91667000",
                        "longitude": "27.56667000"
                    },
                    {
                        "id": 96265,
                        "name": "Scheia",
                        "latitude": "47.11725000",
                        "longitude": "26.88153000"
                    },
                    {
                        "id": 96273,
                        "name": "Schitu-Duca",
                        "latitude": "47.03333000",
                        "longitude": "27.76667000"
                    },
                    {
                        "id": 96277,
                        "name": "Scobinţi",
                        "latitude": "47.38333000",
                        "longitude": "26.93333000"
                    },
                    {
                        "id": 96352,
                        "name": "Sineşti",
                        "latitude": "47.11667000",
                        "longitude": "27.18333000"
                    },
                    {
                        "id": 97057,
                        "name": "Şipote",
                        "latitude": "47.46667000",
                        "longitude": "27.21667000"
                    },
                    {
                        "id": 96359,
                        "name": "Sireţel",
                        "latitude": "47.40000000",
                        "longitude": "26.73333000"
                    },
                    {
                        "id": 96371,
                        "name": "Slobozia",
                        "latitude": "47.05758000",
                        "longitude": "27.41446000"
                    },
                    {
                        "id": 96395,
                        "name": "Soci",
                        "latitude": "47.18573000",
                        "longitude": "26.64446000"
                    },
                    {
                        "id": 96399,
                        "name": "Sodomeni",
                        "latitude": "47.22233000",
                        "longitude": "26.68805000"
                    },
                    {
                        "id": 96431,
                        "name": "Sticlăria",
                        "latitude": "47.40115000",
                        "longitude": "26.83797000"
                    },
                    {
                        "id": 96442,
                        "name": "Stolniceni-Prăjescu",
                        "latitude": "47.19858000",
                        "longitude": "26.74810000"
                    },
                    {
                        "id": 96445,
                        "name": "Stornești",
                        "latitude": "47.11667000",
                        "longitude": "27.18333000"
                    },
                    {
                        "id": 96459,
                        "name": "Strunga",
                        "latitude": "47.16667000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 96497,
                        "name": "Suhuleț",
                        "latitude": "46.90368000",
                        "longitude": "27.25849000"
                    },
                    {
                        "id": 106050,
                        "name": "Tabăra",
                        "latitude": "47.57395000",
                        "longitude": "27.41213000"
                    },
                    {
                        "id": 106058,
                        "name": "Tansa",
                        "latitude": "46.91667000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 96583,
                        "name": "Târgu Frumos",
                        "latitude": "47.20000000",
                        "longitude": "27.00000000"
                    },
                    {
                        "id": 96620,
                        "name": "Tătăruşi",
                        "latitude": "47.35000000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 97101,
                        "name": "Ţibana",
                        "latitude": "46.98333000",
                        "longitude": "27.33333000"
                    },
                    {
                        "id": 97103,
                        "name": "Ţibăneşti",
                        "latitude": "46.91667000",
                        "longitude": "27.33333000"
                    },
                    {
                        "id": 97106,
                        "name": "Ţigănaşi",
                        "latitude": "47.33333000",
                        "longitude": "27.46667000"
                    },
                    {
                        "id": 106115,
                        "name": "Todireşti",
                        "latitude": "47.31667000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 106121,
                        "name": "Tomeşti",
                        "latitude": "47.11667000",
                        "longitude": "27.68333000"
                    },
                    {
                        "id": 106129,
                        "name": "Topile",
                        "latitude": "47.26340000",
                        "longitude": "26.66883000"
                    },
                    {
                        "id": 106143,
                        "name": "Totoești",
                        "latitude": "47.25107000",
                        "longitude": "27.28879000"
                    },
                    {
                        "id": 106156,
                        "name": "Trifeşti",
                        "latitude": "47.45000000",
                        "longitude": "27.51667000"
                    },
                    {
                        "id": 97110,
                        "name": "Ţuţora",
                        "latitude": "47.13333000",
                        "longitude": "27.78333000"
                    },
                    {
                        "id": 96634,
                        "name": "Uda",
                        "latitude": "47.33645000",
                        "longitude": "26.57165000"
                    },
                    {
                        "id": 96732,
                        "name": "Valea Lupului",
                        "latitude": "47.17920000",
                        "longitude": "27.49965000"
                    },
                    {
                        "id": 96753,
                        "name": "Valea Seacă",
                        "latitude": "47.29219000",
                        "longitude": "26.66876000"
                    },
                    {
                        "id": 96930,
                        "name": "Vânători",
                        "latitude": "47.23333000",
                        "longitude": "27.53333000"
                    },
                    {
                        "id": 96792,
                        "name": "Verșeni",
                        "latitude": "47.11294000",
                        "longitude": "26.64341000"
                    },
                    {
                        "id": 96805,
                        "name": "Victoria",
                        "latitude": "47.28333000",
                        "longitude": "27.58333000"
                    },
                    {
                        "id": 96862,
                        "name": "Vlădeni",
                        "latitude": "47.41667000",
                        "longitude": "27.33333000"
                    },
                    {
                        "id": 96881,
                        "name": "Voineşti",
                        "latitude": "47.06667000",
                        "longitude": "27.41667000"
                    },
                    {
                        "id": 96978,
                        "name": "Zagavia",
                        "latitude": "47.41911000",
                        "longitude": "26.89790000"
                    },
                    {
                        "id": 97001,
                        "name": "Zmeu",
                        "latitude": "47.19161000",
                        "longitude": "27.17917000"
                    }
                ]
            },
            {
                "id": 4725,
                "name": "Ilfov",
                "iso2": "IF",
                "latitude": "44.53554800",
                "longitude": "26.23248860",
                "type": "department",
                "cities": [
                    {
                        "id": 89871,
                        "name": "1 Decembrie",
                        "latitude": "44.29083000",
                        "longitude": "26.05806000"
                    },
                    {
                        "id": 89891,
                        "name": "Afumaţi",
                        "latitude": "44.51667000",
                        "longitude": "26.26667000"
                    },
                    {
                        "id": 89943,
                        "name": "Alunișu",
                        "latitude": "44.33883000",
                        "longitude": "26.05837000"
                    },
                    {
                        "id": 90521,
                        "name": "Bălăceanca",
                        "latitude": "44.39249000",
                        "longitude": "26.29009000"
                    },
                    {
                        "id": 90045,
                        "name": "Baloteşti",
                        "latitude": "44.61667000",
                        "longitude": "26.11667000"
                    },
                    {
                        "id": 90099,
                        "name": "Berceni",
                        "latitude": "44.31417000",
                        "longitude": "26.18556000"
                    },
                    {
                        "id": 90264,
                        "name": "Bragadiru",
                        "latitude": "44.37111000",
                        "longitude": "25.97750000"
                    },
                    {
                        "id": 90337,
                        "name": "Brăneşti",
                        "latitude": "44.45000000",
                        "longitude": "26.33333000"
                    },
                    {
                        "id": 90352,
                        "name": "Buciumeni",
                        "latitude": "44.54975000",
                        "longitude": "25.96419000"
                    },
                    {
                        "id": 90391,
                        "name": "Buftea",
                        "latitude": "44.56139000",
                        "longitude": "25.94889000"
                    },
                    {
                        "id": 90416,
                        "name": "Buriaș",
                        "latitude": "44.73304000",
                        "longitude": "25.98053000"
                    },
                    {
                        "id": 93824,
                        "name": "Căciulați",
                        "latitude": "44.62741000",
                        "longitude": "26.17255000"
                    },
                    {
                        "id": 93833,
                        "name": "Căldăraru",
                        "latitude": "44.41307000",
                        "longitude": "26.26313000"
                    },
                    {
                        "id": 93886,
                        "name": "Cățelu",
                        "latitude": "44.40292000",
                        "longitude": "26.21975000"
                    },
                    {
                        "id": 90635,
                        "name": "Cernica",
                        "latitude": "44.41667000",
                        "longitude": "26.28333000"
                    },
                    {
                        "id": 90662,
                        "name": "Chiajna",
                        "latitude": "44.46000000",
                        "longitude": "25.97333000"
                    },
                    {
                        "id": 90684,
                        "name": "Chitila",
                        "latitude": "44.50806000",
                        "longitude": "25.98222000"
                    },
                    {
                        "id": 90717,
                        "name": "Ciofliceni",
                        "latitude": "44.68122000",
                        "longitude": "26.11923000"
                    },
                    {
                        "id": 90720,
                        "name": "Ciolpani",
                        "latitude": "44.73333000",
                        "longitude": "26.08333000"
                    },
                    {
                        "id": 90726,
                        "name": "Ciorogârla",
                        "latitude": "44.44250000",
                        "longitude": "25.88333000"
                    },
                    {
                        "id": 90767,
                        "name": "Clinceni",
                        "latitude": "44.37333000",
                        "longitude": "25.95472000"
                    },
                    {
                        "id": 90816,
                        "name": "Comuna 1 Decembrie",
                        "latitude": "44.28869000",
                        "longitude": "26.06178000"
                    },
                    {
                        "id": 90828,
                        "name": "Comuna Afumaţi",
                        "latitude": "44.52501000",
                        "longitude": "26.24943000"
                    },
                    {
                        "id": 90927,
                        "name": "Comuna Baloteşti",
                        "latitude": "44.62026000",
                        "longitude": "26.08664000"
                    },
                    {
                        "id": 90961,
                        "name": "Comuna Berceni",
                        "latitude": "44.30887000",
                        "longitude": "26.19051000"
                    },
                    {
                        "id": 91123,
                        "name": "Comuna Brăneşti",
                        "latitude": "44.45362000",
                        "longitude": "26.34995000"
                    },
                    {
                        "id": 91293,
                        "name": "Comuna Cernica",
                        "latitude": "44.39343000",
                        "longitude": "26.28992000"
                    },
                    {
                        "id": 91311,
                        "name": "Comuna Chiajna",
                        "latitude": "44.45499000",
                        "longitude": "25.99345000"
                    },
                    {
                        "id": 91350,
                        "name": "Comuna Ciolpani",
                        "latitude": "44.72603000",
                        "longitude": "26.10193000"
                    },
                    {
                        "id": 91354,
                        "name": "Comuna Ciorogârla",
                        "latitude": "44.43222000",
                        "longitude": "25.87861000"
                    },
                    {
                        "id": 91381,
                        "name": "Comuna Clinceni",
                        "latitude": "44.37639000",
                        "longitude": "25.92445000"
                    },
                    {
                        "id": 91420,
                        "name": "Comuna Copăceni",
                        "latitude": "44.26297000",
                        "longitude": "26.09374000"
                    },
                    {
                        "id": 91423,
                        "name": "Comuna Corbeanca",
                        "latitude": "44.59671000",
                        "longitude": "26.03241000"
                    },
                    {
                        "id": 91437,
                        "name": "Comuna Cornetu",
                        "latitude": "44.34286000",
                        "longitude": "25.92489000"
                    },
                    {
                        "id": 91746,
                        "name": "Comuna Dărăşti-Ilfov",
                        "latitude": "44.30912000",
                        "longitude": "26.02139000"
                    },
                    {
                        "id": 91605,
                        "name": "Comuna Dascălu Creaţa",
                        "latitude": "44.60008000",
                        "longitude": "26.24201000"
                    },
                    {
                        "id": 91658,
                        "name": "Comuna Domneşti",
                        "latitude": "44.39058000",
                        "longitude": "25.89492000"
                    },
                    {
                        "id": 91675,
                        "name": "Comuna Dragomireşti-Vale",
                        "latitude": "44.47555000",
                        "longitude": "25.93164000"
                    },
                    {
                        "id": 91801,
                        "name": "Comuna Fundeni-Dobroeşti",
                        "latitude": "44.45455000",
                        "longitude": "26.18368000"
                    },
                    {
                        "id": 91985,
                        "name": "Comuna Găneasa",
                        "latitude": "44.49447000",
                        "longitude": "26.29923000"
                    },
                    {
                        "id": 91880,
                        "name": "Comuna Glina",
                        "latitude": "44.38546000",
                        "longitude": "26.24582000"
                    },
                    {
                        "id": 91938,
                        "name": "Comuna Grădiştea",
                        "latitude": "44.66557000",
                        "longitude": "26.31448000"
                    },
                    {
                        "id": 91931,
                        "name": "Comuna Gruiu",
                        "latitude": "44.72648000",
                        "longitude": "26.22133000"
                    },
                    {
                        "id": 92123,
                        "name": "Comuna Jilava",
                        "latitude": "44.32863000",
                        "longitude": "26.07754000"
                    },
                    {
                        "id": 92313,
                        "name": "Comuna Moara Vlãsiei",
                        "latitude": "44.63416000",
                        "longitude": "26.18935000"
                    },
                    {
                        "id": 92321,
                        "name": "Comuna Mogoşoaia",
                        "latitude": "44.52903000",
                        "longitude": "26.00178000"
                    },
                    {
                        "id": 92455,
                        "name": "Comuna Nuci",
                        "latitude": "44.70910000",
                        "longitude": "26.31770000"
                    },
                    {
                        "id": 92553,
                        "name": "Comuna Periş",
                        "latitude": "44.70859000",
                        "longitude": "26.01472000"
                    },
                    {
                        "id": 92569,
                        "name": "Comuna Petrăchioaia",
                        "latitude": "44.57953000",
                        "longitude": "26.31114000"
                    },
                    {
                        "id": 92967,
                        "name": "Comuna Snagov",
                        "latitude": "44.68481000",
                        "longitude": "26.12384000"
                    },
                    {
                        "id": 93554,
                        "name": "Comuna Ştefãneştii De Jos",
                        "latitude": "44.53333000",
                        "longitude": "26.18333000"
                    },
                    {
                        "id": 93207,
                        "name": "Comuna Tunari",
                        "latitude": "44.56797000",
                        "longitude": "26.13908000"
                    },
                    {
                        "id": 93355,
                        "name": "Comuna Vidra",
                        "latitude": "44.28107000",
                        "longitude": "26.14310000"
                    },
                    {
                        "id": 93607,
                        "name": "Copăceni",
                        "latitude": "44.26297000",
                        "longitude": "26.09374000"
                    },
                    {
                        "id": 93612,
                        "name": "Corbeanca",
                        "latitude": "44.60000000",
                        "longitude": "26.05000000"
                    },
                    {
                        "id": 93633,
                        "name": "Cornetu",
                        "latitude": "44.34167000",
                        "longitude": "25.94083000"
                    },
                    {
                        "id": 93714,
                        "name": "Crețești",
                        "latitude": "44.28238000",
                        "longitude": "26.13530000"
                    },
                    {
                        "id": 94134,
                        "name": "Dărăşti-Ilfov",
                        "latitude": "44.30889000",
                        "longitude": "26.01833000"
                    },
                    {
                        "id": 94112,
                        "name": "Dârvari",
                        "latitude": "44.42108000",
                        "longitude": "25.87989000"
                    },
                    {
                        "id": 93897,
                        "name": "Dascălu",
                        "latitude": "44.60000000",
                        "longitude": "26.23333000"
                    },
                    {
                        "id": 93961,
                        "name": "Dobroeşti",
                        "latitude": "44.45000000",
                        "longitude": "26.18333000"
                    },
                    {
                        "id": 93991,
                        "name": "Domnești",
                        "latitude": "44.39919000",
                        "longitude": "25.91618000"
                    },
                    {
                        "id": 93990,
                        "name": "Domneşti-Sârbi",
                        "latitude": "44.38333000",
                        "longitude": "25.91667000"
                    },
                    {
                        "id": 94020,
                        "name": "Dragomirești-Deal",
                        "latitude": "44.46240000",
                        "longitude": "25.94478000"
                    },
                    {
                        "id": 94019,
                        "name": "Dragomireşti-Vale",
                        "latitude": "44.47500000",
                        "longitude": "25.93500000"
                    },
                    {
                        "id": 94226,
                        "name": "Fundeni",
                        "latitude": "44.45892000",
                        "longitude": "26.16565000"
                    },
                    {
                        "id": 94510,
                        "name": "Găneasa",
                        "latitude": "44.48333000",
                        "longitude": "26.28333000"
                    },
                    {
                        "id": 94309,
                        "name": "Ghermănești",
                        "latitude": "44.68829000",
                        "longitude": "26.14962000"
                    },
                    {
                        "id": 94358,
                        "name": "Glina",
                        "latitude": "44.38333000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 94438,
                        "name": "Grădiştea",
                        "latitude": "44.66667000",
                        "longitude": "26.28333000"
                    },
                    {
                        "id": 94430,
                        "name": "Gruiu",
                        "latitude": "44.73333000",
                        "longitude": "26.23333000"
                    },
                    {
                        "id": 94690,
                        "name": "Islaz",
                        "latitude": "44.46117000",
                        "longitude": "26.38724000"
                    },
                    {
                        "id": 94736,
                        "name": "Jilava",
                        "latitude": "44.33333000",
                        "longitude": "26.07806000"
                    },
                    {
                        "id": 94800,
                        "name": "Lipia",
                        "latitude": "44.71003000",
                        "longitude": "26.26445000"
                    },
                    {
                        "id": 95243,
                        "name": "Măgurele",
                        "latitude": "44.35000000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 94958,
                        "name": "Merii Petchii",
                        "latitude": "44.73532000",
                        "longitude": "26.30054000"
                    },
                    {
                        "id": 95043,
                        "name": "Moara Vlăsiei",
                        "latitude": "44.64090000",
                        "longitude": "26.20616000"
                    },
                    {
                        "id": 95055,
                        "name": "Mogoşoaia",
                        "latitude": "44.52917000",
                        "longitude": "26.00000000"
                    },
                    {
                        "id": 95361,
                        "name": "Nuci",
                        "latitude": "44.71667000",
                        "longitude": "26.30000000"
                    },
                    {
                        "id": 95431,
                        "name": "Olteni",
                        "latitude": "44.39307000",
                        "longitude": "25.95021000"
                    },
                    {
                        "id": 95469,
                        "name": "Oraş Bragadiru",
                        "latitude": "44.36998000",
                        "longitude": "25.97871000"
                    },
                    {
                        "id": 95475,
                        "name": "Oraş Buftea",
                        "latitude": "44.55475000",
                        "longitude": "25.95628000"
                    },
                    {
                        "id": 95491,
                        "name": "Oraş Chitila",
                        "latitude": "44.49053000",
                        "longitude": "25.97847000"
                    },
                    {
                        "id": 95546,
                        "name": "Oraş Mãgurele",
                        "latitude": "44.33925000",
                        "longitude": "26.01403000"
                    },
                    {
                        "id": 95561,
                        "name": "Oraş Otopeni",
                        "latitude": "44.54217000",
                        "longitude": "26.06526000"
                    },
                    {
                        "id": 95565,
                        "name": "Oraş Pantelimon",
                        "latitude": "44.45235000",
                        "longitude": "26.20684000"
                    },
                    {
                        "id": 95571,
                        "name": "Oraş Popeşti Leordeni",
                        "latitude": "44.38005000",
                        "longitude": "26.17134000"
                    },
                    {
                        "id": 95684,
                        "name": "Otopeni",
                        "latitude": "44.55000000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 95706,
                        "name": "Pantelimon",
                        "latitude": "44.45000000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 95735,
                        "name": "Periş",
                        "latitude": "44.68472000",
                        "longitude": "26.01389000"
                    },
                    {
                        "id": 95758,
                        "name": "Petrăchioaia",
                        "latitude": "44.58099000",
                        "longitude": "26.31269000"
                    },
                    {
                        "id": 95802,
                        "name": "Piteasca",
                        "latitude": "44.49339000",
                        "longitude": "26.33025000"
                    },
                    {
                        "id": 95912,
                        "name": "Popeşti-Leordeni",
                        "latitude": "44.38333000",
                        "longitude": "26.16667000"
                    },
                    {
                        "id": 96142,
                        "name": "Roșu",
                        "latitude": "44.45025000",
                        "longitude": "26.01122000"
                    },
                    {
                        "id": 96146,
                        "name": "Rudeni",
                        "latitude": "44.47242000",
                        "longitude": "25.97325000"
                    },
                    {
                        "id": 96345,
                        "name": "Siliștea Snagovului",
                        "latitude": "44.73920000",
                        "longitude": "26.17942000"
                    },
                    {
                        "id": 96357,
                        "name": "Sintești",
                        "latitude": "44.30046000",
                        "longitude": "26.12126000"
                    },
                    {
                        "id": 96393,
                        "name": "Snagov",
                        "latitude": "44.70000000",
                        "longitude": "26.18333000"
                    },
                    {
                        "id": 97087,
                        "name": "Ştefăneştii de Jos",
                        "latitude": "44.53333000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 106056,
                        "name": "Tamași",
                        "latitude": "44.58438000",
                        "longitude": "26.00724000"
                    },
                    {
                        "id": 96578,
                        "name": "Tânganu",
                        "latitude": "44.40628000",
                        "longitude": "26.31262000"
                    },
                    {
                        "id": 96548,
                        "name": "Tunari",
                        "latitude": "44.55000000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 96943,
                        "name": "Vârteju",
                        "latitude": "44.35606000",
                        "longitude": "25.99183000"
                    },
                    {
                        "id": 96809,
                        "name": "Vidra",
                        "latitude": "44.26056000",
                        "longitude": "26.16972000"
                    },
                    {
                        "id": 96889,
                        "name": "Voluntari",
                        "latitude": "44.49002000",
                        "longitude": "26.17338000"
                    },
                    {
                        "id": 96890,
                        "name": "Voluntari City",
                        "latitude": "44.49023000",
                        "longitude": "26.18439000"
                    }
                ]
            },
            {
                "id": 4760,
                "name": "Maramureș",
                "iso2": "MM",
                "latitude": "47.66463660",
                "longitude": "22.69259330",
                "type": "department",
                "cities": [
                    {
                        "id": 89984,
                        "name": "Ardusat",
                        "latitude": "47.65000000",
                        "longitude": "23.36667000"
                    },
                    {
                        "id": 146723,
                        "name": "Arduzel",
                        "latitude": "47.44804500",
                        "longitude": "23.26686200"
                    },
                    {
                        "id": 146724,
                        "name": "Arieșu de Câmp",
                        "latitude": "47.63977000",
                        "longitude": "23.39872600"
                    },
                    {
                        "id": 146725,
                        "name": "Arieșu de Pădure",
                        "latitude": "47.58623800",
                        "longitude": "23.47910600"
                    },
                    {
                        "id": 89994,
                        "name": "Ariniş",
                        "latitude": "47.50000000",
                        "longitude": "23.23333000"
                    },
                    {
                        "id": 146726,
                        "name": "Aspra",
                        "latitude": "47.45021000",
                        "longitude": "23.63817900"
                    },
                    {
                        "id": 146727,
                        "name": "Asuaju de Jos",
                        "latitude": "47.54051900",
                        "longitude": "23.22298700"
                    },
                    {
                        "id": 90001,
                        "name": "Asuaju de Sus",
                        "latitude": "47.56667000",
                        "longitude": "23.18333000"
                    },
                    {
                        "id": 146728,
                        "name": "Baba",
                        "latitude": "47.34026800",
                        "longitude": "23.74561100"
                    },
                    {
                        "id": 90029,
                        "name": "Baia Mare",
                        "latitude": "47.65729000",
                        "longitude": "23.56808000"
                    },
                    {
                        "id": 90030,
                        "name": "Baia Sprie",
                        "latitude": "47.66189000",
                        "longitude": "23.69215000"
                    },
                    {
                        "id": 90488,
                        "name": "Băile Borșa",
                        "latitude": "47.68416000",
                        "longitude": "24.71391000"
                    },
                    {
                        "id": 90500,
                        "name": "Băița",
                        "latitude": "47.70614000",
                        "longitude": "23.49326000"
                    },
                    {
                        "id": 90498,
                        "name": "Băiţa de sub Codru",
                        "latitude": "47.53333000",
                        "longitude": "23.15000000"
                    },
                    {
                        "id": 90495,
                        "name": "Băiuţ",
                        "latitude": "47.61667000",
                        "longitude": "24.00000000"
                    },
                    {
                        "id": 146742,
                        "name": "Bârgău",
                        "latitude": "47.68343800",
                        "longitude": "23.39971200"
                    },
                    {
                        "id": 90455,
                        "name": "Bârsana",
                        "latitude": "47.81667000",
                        "longitude": "24.06667000"
                    },
                    {
                        "id": 90550,
                        "name": "Băseşti",
                        "latitude": "47.48333000",
                        "longitude": "23.15000000"
                    },
                    {
                        "id": 90096,
                        "name": "Berbești",
                        "latitude": "47.84865000",
                        "longitude": "23.93448000"
                    },
                    {
                        "id": 146729,
                        "name": "Berchez",
                        "latitude": "47.51892400",
                        "longitude": "23.50569300"
                    },
                    {
                        "id": 146730,
                        "name": "Berința",
                        "latitude": "47.54066900",
                        "longitude": "23.67692900"
                    },
                    {
                        "id": 90125,
                        "name": "Bicaz",
                        "latitude": "47.46667000",
                        "longitude": "23.03333000"
                    },
                    {
                        "id": 90144,
                        "name": "Bistra",
                        "latitude": "47.86667000",
                        "longitude": "24.20000000"
                    },
                    {
                        "id": 146731,
                        "name": "Blidari",
                        "latitude": "47.77970000",
                        "longitude": "23.61370400"
                    },
                    {
                        "id": 146732,
                        "name": "Bocicoel",
                        "latitude": "47.69861111",
                        "longitude": "24.31916667"
                    },
                    {
                        "id": 90175,
                        "name": "Bocicoiu Mare",
                        "latitude": "47.96667000",
                        "longitude": "24.00000000"
                    },
                    {
                        "id": 90187,
                        "name": "Bogdan Vodă",
                        "latitude": "47.69197000",
                        "longitude": "24.26605000"
                    },
                    {
                        "id": 146733,
                        "name": "Boiereni",
                        "latitude": "47.38885900",
                        "longitude": "23.93048300"
                    },
                    {
                        "id": 90205,
                        "name": "Boiu Mare",
                        "latitude": "47.40000000",
                        "longitude": "23.58333000"
                    },
                    {
                        "id": 146734,
                        "name": "Bontăieni",
                        "latitude": "47.61221500",
                        "longitude": "23.72160000"
                    },
                    {
                        "id": 90222,
                        "name": "Borcut",
                        "latitude": "47.48200000",
                        "longitude": "23.84071000"
                    },
                    {
                        "id": 90238,
                        "name": "Borşa",
                        "latitude": "47.65527000",
                        "longitude": "24.66328000"
                    },
                    {
                        "id": 90245,
                        "name": "Botiza",
                        "latitude": "47.66667000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 146735,
                        "name": "Bozânta Mare",
                        "latitude": "47.63965800",
                        "longitude": "23.44165500"
                    },
                    {
                        "id": 146736,
                        "name": "Bozânta Mică",
                        "latitude": "47.63641400",
                        "longitude": "23.42235700"
                    },
                    {
                        "id": 90290,
                        "name": "Breb",
                        "latitude": "47.74854000",
                        "longitude": "23.90494000"
                    },
                    {
                        "id": 146737,
                        "name": "Brebeni",
                        "latitude": "47.50358200",
                        "longitude": "23.78135600"
                    },
                    {
                        "id": 146738,
                        "name": "Buciumi",
                        "latitude": "47.47032600",
                        "longitude": "23.48925800"
                    },
                    {
                        "id": 90381,
                        "name": "Budeşti",
                        "latitude": "47.73333000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 146741,
                        "name": "Bușag",
                        "latitude": "47.65871500",
                        "longitude": "23.42775200"
                    },
                    {
                        "id": 146739,
                        "name": "Buteasa",
                        "latitude": "47.44830300",
                        "longitude": "23.54987800"
                    },
                    {
                        "id": 146740,
                        "name": "Buzești",
                        "latitude": "47.60844900",
                        "longitude": "23.35416900"
                    },
                    {
                        "id": 93839,
                        "name": "Călineşti",
                        "latitude": "47.78423000",
                        "longitude": "23.96961000"
                    },
                    {
                        "id": 93802,
                        "name": "Câmpulung la Tisa",
                        "latitude": "47.98651000",
                        "longitude": "23.77263000"
                    },
                    {
                        "id": 146761,
                        "name": "Cărbunari",
                        "latitude": "47.57515600",
                        "longitude": "23.64403400"
                    },
                    {
                        "id": 146762,
                        "name": "Cărpiniș",
                        "latitude": "47.57555500",
                        "longitude": "23.70336500"
                    },
                    {
                        "id": 146763,
                        "name": "Cătălina",
                        "latitude": "47.60383500",
                        "longitude": "23.54459100"
                    },
                    {
                        "id": 90592,
                        "name": "Cavnic",
                        "latitude": "47.66667000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 90633,
                        "name": "Cerneşti",
                        "latitude": "47.51667000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 146743,
                        "name": "Cetățele",
                        "latitude": "47.59880900",
                        "longitude": "23.73945000"
                    },
                    {
                        "id": 146744,
                        "name": "Chechiș",
                        "latitude": "47.58441400",
                        "longitude": "23.60388500"
                    },
                    {
                        "id": 90654,
                        "name": "Chelința",
                        "latitude": "47.45311000",
                        "longitude": "23.31799000"
                    },
                    {
                        "id": 146745,
                        "name": "Chiuzbaia",
                        "latitude": "47.69954800",
                        "longitude": "23.68056000"
                    },
                    {
                        "id": 90698,
                        "name": "Cicârlău",
                        "latitude": "47.69155000",
                        "longitude": "23.40380000"
                    },
                    {
                        "id": 146746,
                        "name": "Ciocotiș",
                        "latitude": "47.55666000",
                        "longitude": "23.79649900"
                    },
                    {
                        "id": 146747,
                        "name": "Ciolt",
                        "latitude": "47.48385400",
                        "longitude": "23.50944300"
                    },
                    {
                        "id": 146748,
                        "name": "Ciuta",
                        "latitude": "47.44713800",
                        "longitude": "22.98833000"
                    },
                    {
                        "id": 90774,
                        "name": "Coaș",
                        "latitude": "47.53957000",
                        "longitude": "23.58584000"
                    },
                    {
                        "id": 146749,
                        "name": "Codru Butesii",
                        "latitude": "47.46817900",
                        "longitude": "23.60146300"
                    },
                    {
                        "id": 90801,
                        "name": "Coltău",
                        "latitude": "47.59837000",
                        "longitude": "23.52459000"
                    },
                    {
                        "id": 146750,
                        "name": "Colțirea",
                        "latitude": "47.60996100",
                        "longitude": "23.40519700"
                    },
                    {
                        "id": 90887,
                        "name": "Comuna Ardusat",
                        "latitude": "47.63241000",
                        "longitude": "23.39156000"
                    },
                    {
                        "id": 90893,
                        "name": "Comuna Ariniş",
                        "latitude": "47.50757000",
                        "longitude": "23.22435000"
                    },
                    {
                        "id": 90899,
                        "name": "Comuna Asuaju de Sus",
                        "latitude": "47.55000000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 91210,
                        "name": "Comuna Băiţa de sub Codru",
                        "latitude": "47.53333000",
                        "longitude": "23.15000000"
                    },
                    {
                        "id": 91207,
                        "name": "Comuna Băiuţ",
                        "latitude": "47.60191000",
                        "longitude": "24.00180000"
                    },
                    {
                        "id": 91192,
                        "name": "Comuna Bârsana",
                        "latitude": "47.81500000",
                        "longitude": "24.05731000"
                    },
                    {
                        "id": 91244,
                        "name": "Comuna Băseşti",
                        "latitude": "47.49608000",
                        "longitude": "23.10786000"
                    },
                    {
                        "id": 90982,
                        "name": "Comuna Bicaz",
                        "latitude": "47.46241000",
                        "longitude": "23.01474000"
                    },
                    {
                        "id": 90996,
                        "name": "Comuna Bistra",
                        "latitude": "47.86860000",
                        "longitude": "24.19291000"
                    },
                    {
                        "id": 91014,
                        "name": "Comuna Bocicoiu Mare",
                        "latitude": "47.94673000",
                        "longitude": "24.01121000"
                    },
                    {
                        "id": 91022,
                        "name": "Comuna Bogdan Vodă",
                        "latitude": "47.69480000",
                        "longitude": "24.29548000"
                    },
                    {
                        "id": 91034,
                        "name": "Comuna Boiu Mare",
                        "latitude": "47.40202000",
                        "longitude": "23.59965000"
                    },
                    {
                        "id": 91062,
                        "name": "Comuna Botiza",
                        "latitude": "47.66818000",
                        "longitude": "24.15035000"
                    },
                    {
                        "id": 91145,
                        "name": "Comuna Budeşti",
                        "latitude": "47.74615000",
                        "longitude": "23.94569000"
                    },
                    {
                        "id": 91571,
                        "name": "Comuna Călineşti",
                        "latitude": "47.78502000",
                        "longitude": "23.97011000"
                    },
                    {
                        "id": 91544,
                        "name": "Comuna Câmpulung la Tisa",
                        "latitude": "47.98651000",
                        "longitude": "23.77263000"
                    },
                    {
                        "id": 91292,
                        "name": "Comuna Cerneşti",
                        "latitude": "47.53576000",
                        "longitude": "23.78366000"
                    },
                    {
                        "id": 91334,
                        "name": "Comuna Cicârlău",
                        "latitude": "47.70582000",
                        "longitude": "23.38142000"
                    },
                    {
                        "id": 91383,
                        "name": "Comuna Coaş",
                        "latitude": "47.51282000",
                        "longitude": "23.60046000"
                    },
                    {
                        "id": 91401,
                        "name": "Comuna Coltãu",
                        "latitude": "47.60118000",
                        "longitude": "23.53450000"
                    },
                    {
                        "id": 91416,
                        "name": "Comuna Copalnic Mănăştur",
                        "latitude": "47.52250000",
                        "longitude": "23.68782000"
                    },
                    {
                        "id": 91446,
                        "name": "Comuna Coroieni",
                        "latitude": "47.36635000",
                        "longitude": "23.77764000"
                    },
                    {
                        "id": 91526,
                        "name": "Comuna Cupşeni",
                        "latitude": "47.53255000",
                        "longitude": "23.94243000"
                    },
                    {
                        "id": 91618,
                        "name": "Comuna Deseşti",
                        "latitude": "47.77004000",
                        "longitude": "23.85900000"
                    },
                    {
                        "id": 91719,
                        "name": "Comuna Dumbrăviţa",
                        "latitude": "47.60118000",
                        "longitude": "23.65726000"
                    },
                    {
                        "id": 91822,
                        "name": "Comuna Fărcaşa",
                        "latitude": "47.59482000",
                        "longitude": "23.34826000"
                    },
                    {
                        "id": 91972,
                        "name": "Comuna Gârdani",
                        "latitude": "47.55135000",
                        "longitude": "23.30880000"
                    },
                    {
                        "id": 91874,
                        "name": "Comuna Giuleşti",
                        "latitude": "47.82215000",
                        "longitude": "23.92994000"
                    },
                    {
                        "id": 91928,
                        "name": "Comuna Groşi",
                        "latitude": "47.61193000",
                        "longitude": "23.58661000"
                    },
                    {
                        "id": 91929,
                        "name": "Comuna Groşii Ţibleşului",
                        "latitude": "47.48983000",
                        "longitude": "24.06368000"
                    },
                    {
                        "id": 92065,
                        "name": "Comuna Ieud",
                        "latitude": "47.67739000",
                        "longitude": "24.23378000"
                    },
                    {
                        "id": 92221,
                        "name": "Comuna Lăpuş",
                        "latitude": "47.49363000",
                        "longitude": "24.00646000"
                    },
                    {
                        "id": 92153,
                        "name": "Comuna Leordina",
                        "latitude": "47.78306000",
                        "longitude": "24.26401000"
                    },
                    {
                        "id": 92298,
                        "name": "Comuna Mireşu Mare",
                        "latitude": "47.50011000",
                        "longitude": "23.36420000"
                    },
                    {
                        "id": 92323,
                        "name": "Comuna Moisei",
                        "latitude": "47.65612000",
                        "longitude": "24.53988000"
                    },
                    {
                        "id": 92469,
                        "name": "Comuna Oarţa De Jos",
                        "latitude": "47.45000000",
                        "longitude": "23.10000000"
                    },
                    {
                        "id": 92478,
                        "name": "Comuna Ocna Şugatag",
                        "latitude": "47.77493000",
                        "longitude": "23.91268000"
                    },
                    {
                        "id": 92499,
                        "name": "Comuna Onceşti",
                        "latitude": "47.84814000",
                        "longitude": "23.98183000"
                    },
                    {
                        "id": 92567,
                        "name": "Comuna Petrova",
                        "latitude": "47.83003000",
                        "longitude": "24.21603000"
                    },
                    {
                        "id": 92643,
                        "name": "Comuna Poienile de sub Munte",
                        "latitude": "47.82371000",
                        "longitude": "24.43674000"
                    },
                    {
                        "id": 92642,
                        "name": "Comuna Poienile Izei",
                        "latitude": "47.70309000",
                        "longitude": "24.11276000"
                    },
                    {
                        "id": 92754,
                        "name": "Comuna Recea",
                        "latitude": "47.63108000",
                        "longitude": "23.48610000"
                    },
                    {
                        "id": 92765,
                        "name": "Comuna Remetea Chioarului",
                        "latitude": "47.52129000",
                        "longitude": "23.52891000"
                    },
                    {
                        "id": 92767,
                        "name": "Comuna Remeţi",
                        "latitude": "47.99630000",
                        "longitude": "23.58741000"
                    },
                    {
                        "id": 92768,
                        "name": "Comuna Repedea",
                        "latitude": "47.83212000",
                        "longitude": "24.40142000"
                    },
                    {
                        "id": 92789,
                        "name": "Comuna Rona de Jos",
                        "latitude": "47.91667000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 92790,
                        "name": "Comuna Rona de Sus",
                        "latitude": "47.90184000",
                        "longitude": "24.03877000"
                    },
                    {
                        "id": 92793,
                        "name": "Comuna Rozavlea",
                        "latitude": "47.73791000",
                        "longitude": "24.20116000"
                    },
                    {
                        "id": 92817,
                        "name": "Comuna Ruşcova",
                        "latitude": "47.79289000",
                        "longitude": "24.28546000"
                    },
                    {
                        "id": 93087,
                        "name": "Comuna Săcălăşeni",
                        "latitude": "47.57041000",
                        "longitude": "23.57207000"
                    },
                    {
                        "id": 93081,
                        "name": "Comuna Săcel",
                        "latitude": "47.63690000",
                        "longitude": "24.43508000"
                    },
                    {
                        "id": 93098,
                        "name": "Comuna Sălsig",
                        "latitude": "47.51934000",
                        "longitude": "23.30270000"
                    },
                    {
                        "id": 93077,
                        "name": "Comuna Sãpânţa",
                        "latitude": "47.96933000",
                        "longitude": "23.69818000"
                    },
                    {
                        "id": 93110,
                        "name": "Comuna Sărăsău",
                        "latitude": "47.95000000",
                        "longitude": "23.81667000"
                    },
                    {
                        "id": 92882,
                        "name": "Comuna Satulung",
                        "latitude": "47.57189000",
                        "longitude": "23.41978000"
                    },
                    {
                        "id": 93515,
                        "name": "Comuna Şieu",
                        "latitude": "47.72462000",
                        "longitude": "24.22389000"
                    },
                    {
                        "id": 93532,
                        "name": "Comuna Şişeşti",
                        "latitude": "47.61329000",
                        "longitude": "23.74104000"
                    },
                    {
                        "id": 93008,
                        "name": "Comuna Strâmtura",
                        "latitude": "47.75156000",
                        "longitude": "24.10267000"
                    },
                    {
                        "id": 93027,
                        "name": "Comuna Suciu de Sus",
                        "latitude": "47.44309000",
                        "longitude": "24.04303000"
                    },
                    {
                        "id": 93291,
                        "name": "Comuna Vadu Izei",
                        "latitude": "47.88131000",
                        "longitude": "23.96081000"
                    },
                    {
                        "id": 93299,
                        "name": "Comuna Valea Chioarului",
                        "latitude": "47.40706000",
                        "longitude": "23.46101000"
                    },
                    {
                        "id": 93363,
                        "name": "Comuna Vima Micã",
                        "latitude": "47.41766000",
                        "longitude": "23.68841000"
                    },
                    {
                        "id": 93375,
                        "name": "Comuna Vişeu de Jos",
                        "latitude": "47.72760000",
                        "longitude": "24.36306000"
                    },
                    {
                        "id": 146751,
                        "name": "Copalnic",
                        "latitude": "47.52041800",
                        "longitude": "23.65562700"
                    },
                    {
                        "id": 93601,
                        "name": "Copalnic Mănăştur",
                        "latitude": "47.50000000",
                        "longitude": "23.68333000"
                    },
                    {
                        "id": 146752,
                        "name": "Cornești",
                        "latitude": "47.81675500",
                        "longitude": "23.96811700"
                    },
                    {
                        "id": 146753,
                        "name": "Corni",
                        "latitude": "47.47831800",
                        "longitude": "23.01904200"
                    },
                    {
                        "id": 93647,
                        "name": "Coroieni",
                        "latitude": "47.36667000",
                        "longitude": "23.76667000"
                    },
                    {
                        "id": 146754,
                        "name": "Coruia",
                        "latitude": "47.56334800",
                        "longitude": "23.59653000"
                    },
                    {
                        "id": 146755,
                        "name": "Costeni",
                        "latitude": "47.53705400",
                        "longitude": "23.91464600"
                    },
                    {
                        "id": 146756,
                        "name": "Coștiui",
                        "latitude": "47.87931200",
                        "longitude": "24.03031700"
                    },
                    {
                        "id": 93752,
                        "name": "Crăciunești",
                        "latitude": "47.95551000",
                        "longitude": "23.98267000"
                    },
                    {
                        "id": 93708,
                        "name": "Crasna Vișeului",
                        "latitude": "47.82869000",
                        "longitude": "24.23000000"
                    },
                    {
                        "id": 146757,
                        "name": "Cufoaia",
                        "latitude": "47.47924400",
                        "longitude": "23.80338200"
                    },
                    {
                        "id": 146758,
                        "name": "Culcea",
                        "latitude": "47.56609000",
                        "longitude": "23.55536200"
                    },
                    {
                        "id": 93771,
                        "name": "Cupşeni",
                        "latitude": "47.55000000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 146759,
                        "name": "Curtuiușu Mare",
                        "latitude": "47.42743300",
                        "longitude": "23.44777200"
                    },
                    {
                        "id": 146760,
                        "name": "Curtuiușu Mic",
                        "latitude": "47.54299300",
                        "longitude": "23.62531100"
                    },
                    {
                        "id": 94122,
                        "name": "Dămăcușeni",
                        "latitude": "47.45709000",
                        "longitude": "23.90914000"
                    },
                    {
                        "id": 146770,
                        "name": "Dănești",
                        "latitude": "47.61980900",
                        "longitude": "23.73249900"
                    },
                    {
                        "id": 146771,
                        "name": "Dăneștii Chioarului",
                        "latitude": "47.55381600",
                        "longitude": "23.34478400"
                    },
                    {
                        "id": 146764,
                        "name": "Dealu Corbului",
                        "latitude": "47.44966500",
                        "longitude": "23.68523300"
                    },
                    {
                        "id": 146765,
                        "name": "Dealu Mare",
                        "latitude": "47.36026500",
                        "longitude": "23.81520600"
                    },
                    {
                        "id": 93926,
                        "name": "Deseşti",
                        "latitude": "47.76667000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 146766,
                        "name": "Dobricu Lăpușului",
                        "latitude": "47.49748400",
                        "longitude": "23.90800600"
                    },
                    {
                        "id": 146767,
                        "name": "Drăghia",
                        "latitude": "47.35166300",
                        "longitude": "23.77478400"
                    },
                    {
                        "id": 94016,
                        "name": "Dragomireşti",
                        "latitude": "47.66839000",
                        "longitude": "24.29111000"
                    },
                    {
                        "id": 146768,
                        "name": "Dumbrava",
                        "latitude": "47.49324800",
                        "longitude": "23.87236300"
                    },
                    {
                        "id": 94089,
                        "name": "Dumbrăviţa",
                        "latitude": "47.60000000",
                        "longitude": "23.65000000"
                    },
                    {
                        "id": 146769,
                        "name": "Durușa",
                        "latitude": "47.41291400",
                        "longitude": "23.46473400"
                    },
                    {
                        "id": 146779,
                        "name": "Fânațe",
                        "latitude": "47.53463800",
                        "longitude": "23.75791900"
                    },
                    {
                        "id": 146780,
                        "name": "Fântânele",
                        "latitude": "47.41135100",
                        "longitude": "23.82600000"
                    },
                    {
                        "id": 94261,
                        "name": "Fărcaşa",
                        "latitude": "47.58333000",
                        "longitude": "23.33333000"
                    },
                    {
                        "id": 146781,
                        "name": "Făurești",
                        "latitude": "47.56319400",
                        "longitude": "23.75004900"
                    },
                    {
                        "id": 146772,
                        "name": "Ferești",
                        "latitude": "47.83055556",
                        "longitude": "23.94916667"
                    },
                    {
                        "id": 146773,
                        "name": "Fericea",
                        "latitude": "47.40662600",
                        "longitude": "23.39370000"
                    },
                    {
                        "id": 146774,
                        "name": "Fersig",
                        "latitude": "47.54049300",
                        "longitude": "23.38371200"
                    },
                    {
                        "id": 146775,
                        "name": "Finteușu Mare",
                        "latitude": "47.54000600",
                        "longitude": "23.46451200"
                    },
                    {
                        "id": 146776,
                        "name": "Finteușu Mic",
                        "latitude": "47.56778800",
                        "longitude": "23.45390100"
                    },
                    {
                        "id": 146777,
                        "name": "Firiza",
                        "latitude": "47.74889200",
                        "longitude": "23.60494900"
                    },
                    {
                        "id": 146778,
                        "name": "Frâncenii Boiului",
                        "latitude": "47.39969200",
                        "longitude": "23.61791000"
                    },
                    {
                        "id": 94490,
                        "name": "Gârdani",
                        "latitude": "47.55135000",
                        "longitude": "23.30880000"
                    },
                    {
                        "id": 94350,
                        "name": "Giuleşti",
                        "latitude": "47.81667000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 146782,
                        "name": "Glod",
                        "latitude": "47.72711800",
                        "longitude": "24.08322500"
                    },
                    {
                        "id": 146783,
                        "name": "Groape",
                        "latitude": "47.44449000",
                        "longitude": "23.72530100"
                    },
                    {
                        "id": 94425,
                        "name": "Groşi",
                        "latitude": "47.61667000",
                        "longitude": "23.61667000"
                    },
                    {
                        "id": 94428,
                        "name": "Groșii Țibleșului",
                        "latitude": "47.48983000",
                        "longitude": "24.06368000"
                    },
                    {
                        "id": 146784,
                        "name": "Handalu Ilbei",
                        "latitude": "47.73549800",
                        "longitude": "23.36451000"
                    },
                    {
                        "id": 146788,
                        "name": "Hărnicești",
                        "latitude": "47.78213200",
                        "longitude": "23.88658900"
                    },
                    {
                        "id": 146785,
                        "name": "Hideaga",
                        "latitude": "47.59132500",
                        "longitude": "23.42202000"
                    },
                    {
                        "id": 146786,
                        "name": "Hoteni",
                        "latitude": "47.77191500",
                        "longitude": "23.89993300"
                    },
                    {
                        "id": 146787,
                        "name": "Hovrila",
                        "latitude": "47.45969700",
                        "longitude": "23.50842200"
                    },
                    {
                        "id": 94617,
                        "name": "Iadăra",
                        "latitude": "47.47927000",
                        "longitude": "23.39893000"
                    },
                    {
                        "id": 94623,
                        "name": "Iapa",
                        "latitude": "47.92513000",
                        "longitude": "23.82539000"
                    },
                    {
                        "id": 94644,
                        "name": "Ieud",
                        "latitude": "47.67796000",
                        "longitude": "24.23399000"
                    },
                    {
                        "id": 94653,
                        "name": "Ilba",
                        "latitude": "47.71280000",
                        "longitude": "23.35765000"
                    },
                    {
                        "id": 146789,
                        "name": "Inău",
                        "latitude": "47.51733400",
                        "longitude": "23.82483400"
                    },
                    {
                        "id": 146856,
                        "name": "Întrerâuri",
                        "latitude": "47.48607300",
                        "longitude": "23.61508700"
                    },
                    {
                        "id": 146790,
                        "name": "Izvoarele",
                        "latitude": "47.75338480",
                        "longitude": "23.71439510"
                    },
                    {
                        "id": 146791,
                        "name": "Jugăstreni",
                        "latitude": "47.39527000",
                        "longitude": "23.66424800"
                    },
                    {
                        "id": 94896,
                        "name": "Lăpuş",
                        "latitude": "47.50000000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 94899,
                        "name": "Lăpușel",
                        "latitude": "47.61830000",
                        "longitude": "23.47913000"
                    },
                    {
                        "id": 146792,
                        "name": "Larga",
                        "latitude": "47.45200800",
                        "longitude": "24.10506800"
                    },
                    {
                        "id": 146795,
                        "name": "Lăschia",
                        "latitude": "47.54331800",
                        "longitude": "23.73214200"
                    },
                    {
                        "id": 146793,
                        "name": "Lazu Baciului",
                        "latitude": "47.90513100",
                        "longitude": "23.92052200"
                    },
                    {
                        "id": 94780,
                        "name": "Leordina",
                        "latitude": "47.78333000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 94792,
                        "name": "Libotin",
                        "latitude": "47.50541000",
                        "longitude": "23.96833000"
                    },
                    {
                        "id": 146794,
                        "name": "Lucăcești",
                        "latitude": "47.53995600",
                        "longitude": "23.33550400"
                    },
                    {
                        "id": 94873,
                        "name": "Lunca la Tisa",
                        "latitude": "47.95213000",
                        "longitude": "24.05216000"
                    },
                    {
                        "id": 146800,
                        "name": "Măgureni",
                        "latitude": "47.48671600",
                        "longitude": "23.74353500"
                    },
                    {
                        "id": 146801,
                        "name": "Mănăstirea",
                        "latitude": "47.80299200",
                        "longitude": "23.92222100"
                    },
                    {
                        "id": 95220,
                        "name": "Mânău",
                        "latitude": "47.48179000",
                        "longitude": "23.26247000"
                    },
                    {
                        "id": 94924,
                        "name": "Mara",
                        "latitude": "47.75552000",
                        "longitude": "23.83126000"
                    },
                    {
                        "id": 146796,
                        "name": "Merișor",
                        "latitude": "47.66090600",
                        "longitude": "23.41025800"
                    },
                    {
                        "id": 146797,
                        "name": "Mesteacăn",
                        "latitude": "47.38124200",
                        "longitude": "23.52177700"
                    },
                    {
                        "id": 95016,
                        "name": "Mireşu Mare",
                        "latitude": "47.50000000",
                        "longitude": "23.33333000"
                    },
                    {
                        "id": 146798,
                        "name": "Mocira",
                        "latitude": "47.62295000",
                        "longitude": "23.52506000"
                    },
                    {
                        "id": 146799,
                        "name": "Mogoșești",
                        "latitude": "47.58681000",
                        "longitude": "23.40365200"
                    },
                    {
                        "id": 95059,
                        "name": "Moisei",
                        "latitude": "47.65562000",
                        "longitude": "24.54011000"
                    },
                    {
                        "id": 146803,
                        "name": "Nănești",
                        "latitude": "47.83812000",
                        "longitude": "24.01104900"
                    },
                    {
                        "id": 146802,
                        "name": "Negreia",
                        "latitude": "47.63538800",
                        "longitude": "23.74406500"
                    },
                    {
                        "id": 95351,
                        "name": "Nistru",
                        "latitude": "47.72088000",
                        "longitude": "23.45495000"
                    },
                    {
                        "id": 95385,
                        "name": "Oarţa de Jos",
                        "latitude": "47.45827000",
                        "longitude": "23.12742000"
                    },
                    {
                        "id": 146804,
                        "name": "Oarța de Sus",
                        "latitude": "47.46793300",
                        "longitude": "23.07767300"
                    },
                    {
                        "id": 95399,
                        "name": "Ocna Şugatag",
                        "latitude": "47.78333000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 146805,
                        "name": "Ocoliș",
                        "latitude": "47.60203400",
                        "longitude": "23.57926900"
                    },
                    {
                        "id": 146806,
                        "name": "Odești",
                        "latitude": "47.51595000",
                        "longitude": "23.09587300"
                    },
                    {
                        "id": 95437,
                        "name": "Oncești",
                        "latitude": "47.84814000",
                        "longitude": "23.98183000"
                    },
                    {
                        "id": 146807,
                        "name": "Orțița",
                        "latitude": "47.46262000",
                        "longitude": "23.09427500"
                    },
                    {
                        "id": 146808,
                        "name": "Peteritea",
                        "latitude": "47.42291100",
                        "longitude": "23.74368400"
                    },
                    {
                        "id": 95755,
                        "name": "Petrova",
                        "latitude": "47.82981000",
                        "longitude": "24.21533000"
                    },
                    {
                        "id": 146809,
                        "name": "Piatra",
                        "latitude": "47.99565500",
                        "longitude": "23.53842100"
                    },
                    {
                        "id": 146810,
                        "name": "Plopiș",
                        "latitude": "47.58962200",
                        "longitude": "23.77273700"
                    },
                    {
                        "id": 146811,
                        "name": "Poiana Botizii",
                        "latitude": "47.59333700",
                        "longitude": "24.02531400"
                    },
                    {
                        "id": 95895,
                        "name": "Poienile de sub Munte",
                        "latitude": "47.81667000",
                        "longitude": "24.43333000"
                    },
                    {
                        "id": 95894,
                        "name": "Poienile Izei",
                        "latitude": "47.70000000",
                        "longitude": "24.11667000"
                    },
                    {
                        "id": 146812,
                        "name": "Posta",
                        "latitude": "47.54781300",
                        "longitude": "23.49390200"
                    },
                    {
                        "id": 146813,
                        "name": "Preluca Nouă",
                        "latitude": "47.46697200",
                        "longitude": "23.65150800"
                    },
                    {
                        "id": 146814,
                        "name": "Preluca Veche",
                        "latitude": "47.46941300",
                        "longitude": "23.70789700"
                    },
                    {
                        "id": 146815,
                        "name": "Pribilești",
                        "latitude": "47.56523000",
                        "longitude": "23.37328400"
                    },
                    {
                        "id": 146816,
                        "name": "Prislop",
                        "latitude": "47.41155400",
                        "longitude": "23.55339400"
                    },
                    {
                        "id": 146824,
                        "name": "Răzoare",
                        "latitude": "47.44440600",
                        "longitude": "23.77943200"
                    },
                    {
                        "id": 96070,
                        "name": "Recea",
                        "latitude": "47.63333000",
                        "longitude": "23.51667000"
                    },
                    {
                        "id": 146817,
                        "name": "Remecioara",
                        "latitude": "47.51397700",
                        "longitude": "23.55886000"
                    },
                    {
                        "id": 96083,
                        "name": "Remetea Chioarului",
                        "latitude": "47.53333000",
                        "longitude": "23.55000000"
                    },
                    {
                        "id": 96085,
                        "name": "Remeţi",
                        "latitude": "47.98333000",
                        "longitude": "23.63333000"
                    },
                    {
                        "id": 146818,
                        "name": "Remeți pe Someș",
                        "latitude": "47.48143500",
                        "longitude": "23.33929800"
                    },
                    {
                        "id": 96087,
                        "name": "Repedea",
                        "latitude": "47.83333000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 146819,
                        "name": "Rodina",
                        "latitude": "47.51826800",
                        "longitude": "23.25352900"
                    },
                    {
                        "id": 96102,
                        "name": "Rogoz",
                        "latitude": "47.46749000",
                        "longitude": "23.93214000"
                    },
                    {
                        "id": 146820,
                        "name": "Rohia",
                        "latitude": "47.40612600",
                        "longitude": "23.85804000"
                    },
                    {
                        "id": 146821,
                        "name": "Românești",
                        "latitude": "47.40336300",
                        "longitude": "23.64537600"
                    },
                    {
                        "id": 96116,
                        "name": "Rona de Jos",
                        "latitude": "47.91667000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 96117,
                        "name": "Rona de Sus",
                        "latitude": "47.90000000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 96124,
                        "name": "Rozavlea",
                        "latitude": "47.73333000",
                        "longitude": "24.21667000"
                    },
                    {
                        "id": 146822,
                        "name": "Rus",
                        "latitude": "47.61292400",
                        "longitude": "23.66938300"
                    },
                    {
                        "id": 96160,
                        "name": "Ruscova",
                        "latitude": "47.79289000",
                        "longitude": "24.28546000"
                    },
                    {
                        "id": 146823,
                        "name": "Rușor",
                        "latitude": "47.50440500",
                        "longitude": "23.71101800"
                    },
                    {
                        "id": 146834,
                        "name": "Săbișa",
                        "latitude": "47.72946200",
                        "longitude": "23.32900600"
                    },
                    {
                        "id": 106001,
                        "name": "Săcălășeni",
                        "latitude": "47.58180000",
                        "longitude": "23.56432000"
                    },
                    {
                        "id": 105990,
                        "name": "Săcel",
                        "latitude": "47.63333000",
                        "longitude": "24.43333000"
                    },
                    {
                        "id": 146835,
                        "name": "Săliște",
                        "latitude": "47.49595700",
                        "longitude": "23.11222500"
                    },
                    {
                        "id": 95645,
                        "name": "Săliştea de Sus",
                        "latitude": "47.66019000",
                        "longitude": "24.35336000"
                    },
                    {
                        "id": 146836,
                        "name": "Sălnița",
                        "latitude": "47.41159000",
                        "longitude": "23.67218900"
                    },
                    {
                        "id": 106021,
                        "name": "Sălsig",
                        "latitude": "47.53333000",
                        "longitude": "23.30000000"
                    },
                    {
                        "id": 146833,
                        "name": "Sâlța",
                        "latitude": "47.73740700",
                        "longitude": "24.17945100"
                    },
                    {
                        "id": 106029,
                        "name": "Săpânţa",
                        "latitude": "47.96667000",
                        "longitude": "23.70000000"
                    },
                    {
                        "id": 96244,
                        "name": "Sarasău",
                        "latitude": "47.95510000",
                        "longitude": "23.82874000"
                    },
                    {
                        "id": 105986,
                        "name": "Sârbi",
                        "latitude": "47.76184000",
                        "longitude": "23.94490000"
                    },
                    {
                        "id": 106038,
                        "name": "Săsar",
                        "latitude": "47.64406000",
                        "longitude": "23.49869000"
                    },
                    {
                        "id": 96251,
                        "name": "Sat-Șugatag",
                        "latitude": "47.79796000",
                        "longitude": "23.90637000"
                    },
                    {
                        "id": 146825,
                        "name": "Satu Nou de Jos",
                        "latitude": "47.61620400",
                        "longitude": "23.56850000"
                    },
                    {
                        "id": 146826,
                        "name": "Satu Nou de Sus",
                        "latitude": "47.63847400",
                        "longitude": "23.63476500"
                    },
                    {
                        "id": 96262,
                        "name": "Satulung",
                        "latitude": "47.56667000",
                        "longitude": "23.43333000"
                    },
                    {
                        "id": 95644,
                        "name": "Seini",
                        "latitude": "47.75000000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 97122,
                        "name": "Șieu",
                        "latitude": "47.72462000",
                        "longitude": "24.22389000"
                    },
                    {
                        "id": 95182,
                        "name": "Sighetu Marmaţiei",
                        "latitude": "47.91914000",
                        "longitude": "23.88679000"
                    },
                    {
                        "id": 146857,
                        "name": "Șindrești",
                        "latitude": "47.60659500",
                        "longitude": "23.69513300"
                    },
                    {
                        "id": 97129,
                        "name": "Șisești",
                        "latitude": "47.63506000",
                        "longitude": "23.70794000"
                    },
                    {
                        "id": 146827,
                        "name": "Slătioara",
                        "latitude": "47.75186300",
                        "longitude": "24.08980000"
                    },
                    {
                        "id": 95651,
                        "name": "Şomcuta Mare",
                        "latitude": "47.51667000",
                        "longitude": "23.46667000"
                    },
                    {
                        "id": 146828,
                        "name": "Someș-Uileac",
                        "latitude": "47.45918200",
                        "longitude": "23.22755400"
                    },
                    {
                        "id": 146829,
                        "name": "Stejera",
                        "latitude": "47.44189900",
                        "longitude": "23.42443800"
                    },
                    {
                        "id": 146830,
                        "name": "Stoiceni",
                        "latitude": "47.51121300",
                        "longitude": "23.88079900"
                    },
                    {
                        "id": 146832,
                        "name": "Strâmbu-Băiuț",
                        "latitude": "47.59839500",
                        "longitude": "23.98257400"
                    },
                    {
                        "id": 96461,
                        "name": "Strâmtura",
                        "latitude": "47.78333000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 146831,
                        "name": "Stremț",
                        "latitude": "47.49183600",
                        "longitude": "23.07710300"
                    },
                    {
                        "id": 96491,
                        "name": "Suciu de Jos",
                        "latitude": "47.44584000",
                        "longitude": "23.98250000"
                    },
                    {
                        "id": 96492,
                        "name": "Suciu de Sus",
                        "latitude": "47.43333000",
                        "longitude": "24.03333000"
                    },
                    {
                        "id": 146858,
                        "name": "Șugău",
                        "latitude": "47.88362700",
                        "longitude": "23.90900900"
                    },
                    {
                        "id": 97136,
                        "name": "Șurdești",
                        "latitude": "47.60215000",
                        "longitude": "23.76899000"
                    },
                    {
                        "id": 146840,
                        "name": "Tămaia",
                        "latitude": "47.59353500",
                        "longitude": "23.36340400"
                    },
                    {
                        "id": 146841,
                        "name": "Tămășești",
                        "latitude": "47.50343400",
                        "longitude": "23.18904200"
                    },
                    {
                        "id": 95648,
                        "name": "Târgu Lăpuş",
                        "latitude": "47.46124000",
                        "longitude": "23.85353000"
                    },
                    {
                        "id": 96628,
                        "name": "Tăuții de Sus",
                        "latitude": "47.65665000",
                        "longitude": "23.65841000"
                    },
                    {
                        "id": 95649,
                        "name": "Tăuţii-Măgherăuş",
                        "latitude": "47.72129000",
                        "longitude": "23.48601000"
                    },
                    {
                        "id": 146837,
                        "name": "Teceu Mic",
                        "latitude": "48.00305000",
                        "longitude": "23.58080500"
                    },
                    {
                        "id": 146859,
                        "name": "Țicău",
                        "latitude": "47.44566300",
                        "longitude": "23.30722800"
                    },
                    {
                        "id": 106106,
                        "name": "Tisa",
                        "latitude": "47.94844000",
                        "longitude": "23.95768000"
                    },
                    {
                        "id": 146855,
                        "name": "tohat",
                        "latitude": "47.49475700",
                        "longitude": "23.30669100"
                    },
                    {
                        "id": 146838,
                        "name": "Trestia",
                        "latitude": "47.56474400",
                        "longitude": "23.79368500"
                    },
                    {
                        "id": 146839,
                        "name": "Tulghieș",
                        "latitude": "47.50091000",
                        "longitude": "23.37081400"
                    },
                    {
                        "id": 95611,
                        "name": "Ulmeni",
                        "latitude": "47.46209000",
                        "longitude": "23.27925000"
                    },
                    {
                        "id": 146842,
                        "name": "Ulmoasa",
                        "latitude": "47.73242300",
                        "longitude": "23.53324100"
                    },
                    {
                        "id": 146843,
                        "name": "Unguraș",
                        "latitude": "47.62904400",
                        "longitude": "23.67893300"
                    },
                    {
                        "id": 96660,
                        "name": "Ungureni",
                        "latitude": "47.54631000",
                        "longitude": "23.95241000"
                    },
                    {
                        "id": 146844,
                        "name": "Urmeniș",
                        "latitude": "47.52357200",
                        "longitude": "23.19626000"
                    },
                    {
                        "id": 146845,
                        "name": "Vad",
                        "latitude": "47.52145800",
                        "longitude": "23.71161400"
                    },
                    {
                        "id": 96696,
                        "name": "Vadu Izei",
                        "latitude": "47.88821000",
                        "longitude": "23.93209000"
                    },
                    {
                        "id": 96714,
                        "name": "Valea Chioarului",
                        "latitude": "47.43333000",
                        "longitude": "23.48333000"
                    },
                    {
                        "id": 146846,
                        "name": "Valea Cufundoasă",
                        "latitude": "47.94086600",
                        "longitude": "23.92678900"
                    },
                    {
                        "id": 146847,
                        "name": "Valea Hotarului",
                        "latitude": "47.93119500",
                        "longitude": "23.84362600"
                    },
                    {
                        "id": 146848,
                        "name": "Valea Neagră",
                        "latitude": "47.76631800",
                        "longitude": "23.62108600"
                    },
                    {
                        "id": 146849,
                        "name": "Valea Stejarului",
                        "latitude": "47.87441400",
                        "longitude": "23.98952800"
                    },
                    {
                        "id": 96764,
                        "name": "Valea Vișeului",
                        "latitude": "47.91203000",
                        "longitude": "24.15842000"
                    },
                    {
                        "id": 96959,
                        "name": "Văleni",
                        "latitude": "47.78559000",
                        "longitude": "24.01625000"
                    },
                    {
                        "id": 146853,
                        "name": "Vălenii Lăpușului",
                        "latitude": "47.40572900",
                        "longitude": "23.78592100"
                    },
                    {
                        "id": 96966,
                        "name": "Vălenii Șomcutei",
                        "latitude": "47.47291000",
                        "longitude": "23.45138000"
                    },
                    {
                        "id": 146854,
                        "name": "Vărai",
                        "latitude": "47.38618500",
                        "longitude": "23.45107600"
                    },
                    {
                        "id": 146850,
                        "name": "Vicea",
                        "latitude": "47.45094800",
                        "longitude": "23.24101100"
                    },
                    {
                        "id": 146851,
                        "name": "Viile Apei",
                        "latitude": "47.78109100",
                        "longitude": "23.29103500"
                    },
                    {
                        "id": 146852,
                        "name": "Vima Mare",
                        "latitude": "47.38170200",
                        "longitude": "23.70853400"
                    },
                    {
                        "id": 96829,
                        "name": "Vima Mică",
                        "latitude": "47.40000000",
                        "longitude": "23.71667000"
                    },
                    {
                        "id": 96847,
                        "name": "Vişeu de Jos",
                        "latitude": "47.72558000",
                        "longitude": "24.36613000"
                    },
                    {
                        "id": 96852,
                        "name": "Vișeu de Mijloc",
                        "latitude": "47.71562000",
                        "longitude": "24.40661000"
                    },
                    {
                        "id": 95619,
                        "name": "Vişeu De Sus",
                        "latitude": "47.71493000",
                        "longitude": "24.41707000"
                    }
                ]
            },
            {
                "id": 4751,
                "name": "Mehedinți",
                "iso2": "MH",
                "latitude": "44.55150530",
                "longitude": "22.90441570",
                "type": "department",
                "cities": [
                    {
                        "id": 90438,
                        "name": "Bâcleș",
                        "latitude": "44.48333000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 90031,
                        "name": "Baia de Aramă",
                        "latitude": "44.99929000",
                        "longitude": "22.80784000"
                    },
                    {
                        "id": 90036,
                        "name": "Bala",
                        "latitude": "44.88389000",
                        "longitude": "22.83333000"
                    },
                    {
                        "id": 90523,
                        "name": "Bălăciţa",
                        "latitude": "44.38333000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 90046,
                        "name": "Balta",
                        "latitude": "44.88694000",
                        "longitude": "22.63694000"
                    },
                    {
                        "id": 90049,
                        "name": "Balta Verde",
                        "latitude": "44.34411000",
                        "longitude": "22.59878000"
                    },
                    {
                        "id": 90444,
                        "name": "Bâlvăneşti",
                        "latitude": "44.79750000",
                        "longitude": "22.68028000"
                    },
                    {
                        "id": 90149,
                        "name": "Bistrița",
                        "latitude": "44.58511000",
                        "longitude": "22.78762000"
                    },
                    {
                        "id": 90272,
                        "name": "Braniștea",
                        "latitude": "44.24201000",
                        "longitude": "22.97354000"
                    },
                    {
                        "id": 90299,
                        "name": "Brezniţa Ocol",
                        "latitude": "44.66667000",
                        "longitude": "22.61833000"
                    },
                    {
                        "id": 90300,
                        "name": "Brezniţa-Motru",
                        "latitude": "44.56667000",
                        "longitude": "23.21667000"
                    },
                    {
                        "id": 90310,
                        "name": "Broşteni",
                        "latitude": "44.76083000",
                        "longitude": "22.97944000"
                    },
                    {
                        "id": 90417,
                        "name": "Burila Mare",
                        "latitude": "44.45278000",
                        "longitude": "22.57361000"
                    },
                    {
                        "id": 90428,
                        "name": "Butoieşti",
                        "latitude": "44.58333000",
                        "longitude": "23.36667000"
                    },
                    {
                        "id": 93883,
                        "name": "Căzăneşti",
                        "latitude": "44.72333000",
                        "longitude": "22.89056000"
                    },
                    {
                        "id": 90634,
                        "name": "Cerneți",
                        "latitude": "44.63476000",
                        "longitude": "22.70931000"
                    },
                    {
                        "id": 90708,
                        "name": "Ciochiuța",
                        "latitude": "44.60306000",
                        "longitude": "23.11698000"
                    },
                    {
                        "id": 90725,
                        "name": "Cioroboreni",
                        "latitude": "44.38877000",
                        "longitude": "22.76326000"
                    },
                    {
                        "id": 90732,
                        "name": "Cireşu",
                        "latitude": "44.82333000",
                        "longitude": "22.53806000"
                    },
                    {
                        "id": 90808,
                        "name": "Comanda",
                        "latitude": "44.64863000",
                        "longitude": "23.16413000"
                    },
                    {
                        "id": 91181,
                        "name": "Comuna Bâcleş",
                        "latitude": "44.48031000",
                        "longitude": "23.12207000"
                    },
                    {
                        "id": 90920,
                        "name": "Comuna Bala",
                        "latitude": "44.89479000",
                        "longitude": "22.83235000"
                    },
                    {
                        "id": 91224,
                        "name": "Comuna Bălăciţa",
                        "latitude": "44.39040000",
                        "longitude": "23.12095000"
                    },
                    {
                        "id": 90928,
                        "name": "Comuna Balta",
                        "latitude": "44.90652000",
                        "longitude": "22.61789000"
                    },
                    {
                        "id": 91183,
                        "name": "Comuna Bâlvăneşti",
                        "latitude": "44.79756000",
                        "longitude": "22.68313000"
                    },
                    {
                        "id": 91080,
                        "name": "Comuna Braniştea",
                        "latitude": "44.23768000",
                        "longitude": "22.96793000"
                    },
                    {
                        "id": 91097,
                        "name": "Comuna Brezniţa Ocol",
                        "latitude": "44.69266000",
                        "longitude": "22.60992000"
                    },
                    {
                        "id": 91098,
                        "name": "Comuna Brezniţa-Motru",
                        "latitude": "44.55668000",
                        "longitude": "23.24187000"
                    },
                    {
                        "id": 91103,
                        "name": "Comuna Broşteni",
                        "latitude": "44.74698000",
                        "longitude": "22.99083000"
                    },
                    {
                        "id": 91169,
                        "name": "Comuna Burila Mare",
                        "latitude": "44.47835000",
                        "longitude": "22.54915000"
                    },
                    {
                        "id": 91176,
                        "name": "Comuna Butoieşti",
                        "latitude": "44.57037000",
                        "longitude": "23.37587000"
                    },
                    {
                        "id": 91597,
                        "name": "Comuna Căzăneşti",
                        "latitude": "44.70475000",
                        "longitude": "22.90575000"
                    },
                    {
                        "id": 91360,
                        "name": "Comuna Cireşu",
                        "latitude": "44.81995000",
                        "longitude": "22.54058000"
                    },
                    {
                        "id": 91431,
                        "name": "Comuna Corcova",
                        "latitude": "44.67794000",
                        "longitude": "23.07843000"
                    },
                    {
                        "id": 91434,
                        "name": "Comuna Corlăţel",
                        "latitude": "44.38101000",
                        "longitude": "22.92847000"
                    },
                    {
                        "id": 91522,
                        "name": "Comuna Cujmir",
                        "latitude": "44.19723000",
                        "longitude": "22.93125000"
                    },
                    {
                        "id": 91730,
                        "name": "Comuna Dârvari",
                        "latitude": "44.18184000",
                        "longitude": "23.06648000"
                    },
                    {
                        "id": 91619,
                        "name": "Comuna Devesel",
                        "latitude": "44.48787000",
                        "longitude": "22.67669000"
                    },
                    {
                        "id": 91704,
                        "name": "Comuna Dubova",
                        "latitude": "44.57284000",
                        "longitude": "22.18226000"
                    },
                    {
                        "id": 91712,
                        "name": "Comuna Dumbrava",
                        "latitude": "44.52117000",
                        "longitude": "23.13564000"
                    },
                    {
                        "id": 91752,
                        "name": "Comuna Eşelniţa",
                        "latitude": "44.69905000",
                        "longitude": "22.36577000"
                    },
                    {
                        "id": 91772,
                        "name": "Comuna Floreşti",
                        "latitude": "44.79545000",
                        "longitude": "22.90986000"
                    },
                    {
                        "id": 91973,
                        "name": "Comuna Gârla Mare",
                        "latitude": "44.21087000",
                        "longitude": "22.77696000"
                    },
                    {
                        "id": 91887,
                        "name": "Comuna Godeanu",
                        "latitude": "44.80808000",
                        "longitude": "22.60870000"
                    },
                    {
                        "id": 91892,
                        "name": "Comuna Gogoşu",
                        "latitude": "44.37930000",
                        "longitude": "22.57357000"
                    },
                    {
                        "id": 91916,
                        "name": "Comuna Greci",
                        "latitude": "44.57162000",
                        "longitude": "23.10745000"
                    },
                    {
                        "id": 91926,
                        "name": "Comuna Grozeşti",
                        "latitude": "44.63649000",
                        "longitude": "23.33206000"
                    },
                    {
                        "id": 91930,
                        "name": "Comuna Gruia",
                        "latitude": "44.28593000",
                        "longitude": "22.72949000"
                    },
                    {
                        "id": 92002,
                        "name": "Comuna Hinova",
                        "latitude": "44.54565000",
                        "longitude": "22.77675000"
                    },
                    {
                        "id": 92031,
                        "name": "Comuna Husnicioara",
                        "latitude": "44.66283000",
                        "longitude": "22.83939000"
                    },
                    {
                        "id": 92074,
                        "name": "Comuna Ilovăt",
                        "latitude": "44.81543000",
                        "longitude": "22.73749000"
                    },
                    {
                        "id": 92073,
                        "name": "Comuna Iloviţa",
                        "latitude": "44.78026000",
                        "longitude": "22.49234000"
                    },
                    {
                        "id": 92095,
                        "name": "Comuna Isverna",
                        "latitude": "44.96572000",
                        "longitude": "22.67037000"
                    },
                    {
                        "id": 92111,
                        "name": "Comuna Izvoru Bârzii",
                        "latitude": "44.70830000",
                        "longitude": "22.67003000"
                    },
                    {
                        "id": 92118,
                        "name": "Comuna Jiana",
                        "latitude": "44.39156000",
                        "longitude": "22.71076000"
                    },
                    {
                        "id": 92179,
                        "name": "Comuna Livezile",
                        "latitude": "44.54482000",
                        "longitude": "22.86644000"
                    },
                    {
                        "id": 92234,
                        "name": "Comuna Malovãţ",
                        "latitude": "44.72156000",
                        "longitude": "22.74546000"
                    },
                    {
                        "id": 92474,
                        "name": "Comuna Obârşia De Câmp",
                        "latitude": "44.17507000",
                        "longitude": "22.97076000"
                    },
                    {
                        "id": 92475,
                        "name": "Comuna Obârşia-Cloşani",
                        "latitude": "45.01667000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 92503,
                        "name": "Comuna Oprişor",
                        "latitude": "44.30105000",
                        "longitude": "23.08646000"
                    },
                    {
                        "id": 92529,
                        "name": "Comuna Padina",
                        "latitude": "44.43776000",
                        "longitude": "23.01426000"
                    },
                    {
                        "id": 92724,
                        "name": "Comuna Pătulele",
                        "latitude": "44.34984000",
                        "longitude": "22.80368000"
                    },
                    {
                        "id": 92612,
                        "name": "Comuna Podeni",
                        "latitude": "44.89218000",
                        "longitude": "22.55503000"
                    },
                    {
                        "id": 92650,
                        "name": "Comuna Ponoarele",
                        "latitude": "44.97347000",
                        "longitude": "22.75676000"
                    },
                    {
                        "id": 92659,
                        "name": "Comuna Poroina Mare",
                        "latitude": "44.49516000",
                        "longitude": "22.94161000"
                    },
                    {
                        "id": 92678,
                        "name": "Comuna Pristol",
                        "latitude": "44.22080000",
                        "longitude": "22.71200000"
                    },
                    {
                        "id": 92687,
                        "name": "Comuna Prunişor",
                        "latitude": "44.60030000",
                        "longitude": "22.90476000"
                    },
                    {
                        "id": 92697,
                        "name": "Comuna Punghina",
                        "latitude": "44.29534000",
                        "longitude": "22.96318000"
                    },
                    {
                        "id": 92779,
                        "name": "Comuna Rogova",
                        "latitude": "44.47076000",
                        "longitude": "22.82951000"
                    },
                    {
                        "id": 92865,
                        "name": "Comuna Salcia",
                        "latitude": "44.14124000",
                        "longitude": "22.93048000"
                    },
                    {
                        "id": 92935,
                        "name": "Comuna Simian",
                        "latitude": "44.62736000",
                        "longitude": "22.74227000"
                    },
                    {
                        "id": 92945,
                        "name": "Comuna Siseşti",
                        "latitude": "44.77146000",
                        "longitude": "22.83754000"
                    },
                    {
                        "id": 92978,
                        "name": "Comuna Sovarna",
                        "latitude": "44.84837000",
                        "longitude": "22.81235000"
                    },
                    {
                        "id": 93014,
                        "name": "Comuna Stângăceaua",
                        "latitude": "44.60024000",
                        "longitude": "23.29263000"
                    },
                    {
                        "id": 93043,
                        "name": "Comuna Sviniţa",
                        "latitude": "44.50013000",
                        "longitude": "22.10488000"
                    },
                    {
                        "id": 93223,
                        "name": "Comuna Tâmna",
                        "latitude": "44.56147000",
                        "longitude": "23.00793000"
                    },
                    {
                        "id": 93433,
                        "name": "Comuna Vânători",
                        "latitude": "44.24781000",
                        "longitude": "22.92979000"
                    },
                    {
                        "id": 93431,
                        "name": "Comuna Vânjuleţ",
                        "latitude": "44.43124000",
                        "longitude": "22.80212000"
                    },
                    {
                        "id": 93384,
                        "name": "Comuna Vlădaia",
                        "latitude": "44.36108000",
                        "longitude": "23.03758000"
                    },
                    {
                        "id": 93403,
                        "name": "Comuna Voloiac",
                        "latitude": "44.63241000",
                        "longitude": "23.05948000"
                    },
                    {
                        "id": 93410,
                        "name": "Comuna Vrata",
                        "latitude": "44.19197000",
                        "longitude": "22.84928000"
                    },
                    {
                        "id": 93622,
                        "name": "Corcova",
                        "latitude": "44.70000000",
                        "longitude": "23.05000000"
                    },
                    {
                        "id": 93628,
                        "name": "Corlăţel",
                        "latitude": "44.39861000",
                        "longitude": "22.93306000"
                    },
                    {
                        "id": 93766,
                        "name": "Cujmir",
                        "latitude": "44.20667000",
                        "longitude": "22.92667000"
                    },
                    {
                        "id": 94123,
                        "name": "Dănceu",
                        "latitude": "44.36416000",
                        "longitude": "22.72098000"
                    },
                    {
                        "id": 94111,
                        "name": "Dârvari",
                        "latitude": "44.20000000",
                        "longitude": "23.05000000"
                    },
                    {
                        "id": 93929,
                        "name": "Devesel",
                        "latitude": "44.46889000",
                        "longitude": "22.66722000"
                    },
                    {
                        "id": 94032,
                        "name": "Drobeta-Turnu Severin",
                        "latitude": "44.62693000",
                        "longitude": "22.65288000"
                    },
                    {
                        "id": 94066,
                        "name": "Dubova",
                        "latitude": "44.61667000",
                        "longitude": "22.26667000"
                    },
                    {
                        "id": 94068,
                        "name": "Dudașu",
                        "latitude": "44.65253000",
                        "longitude": "22.69683000"
                    },
                    {
                        "id": 94082,
                        "name": "Dumbrava de Sus",
                        "latitude": "44.51667000",
                        "longitude": "23.11667000"
                    },
                    {
                        "id": 94147,
                        "name": "Eşelniţa",
                        "latitude": "44.69917000",
                        "longitude": "22.36222000"
                    },
                    {
                        "id": 94184,
                        "name": "Floreşti",
                        "latitude": "44.76306000",
                        "longitude": "22.94778000"
                    },
                    {
                        "id": 94491,
                        "name": "Gârla-Mare",
                        "latitude": "44.20917000",
                        "longitude": "22.77500000"
                    },
                    {
                        "id": 94290,
                        "name": "Gemeni",
                        "latitude": "44.17265000",
                        "longitude": "23.08251000"
                    },
                    {
                        "id": 94367,
                        "name": "Godeanu",
                        "latitude": "44.80111000",
                        "longitude": "22.60861000"
                    },
                    {
                        "id": 94372,
                        "name": "Gogoşu",
                        "latitude": "44.37389000",
                        "longitude": "22.59306000"
                    },
                    {
                        "id": 94408,
                        "name": "Greci",
                        "latitude": "44.55000000",
                        "longitude": "23.11667000"
                    },
                    {
                        "id": 94423,
                        "name": "Grozeşti",
                        "latitude": "44.65000000",
                        "longitude": "23.31667000"
                    },
                    {
                        "id": 94429,
                        "name": "Gruia",
                        "latitude": "44.26750000",
                        "longitude": "22.70472000"
                    },
                    {
                        "id": 94466,
                        "name": "Gura Văii",
                        "latitude": "44.66732000",
                        "longitude": "22.55646000"
                    },
                    {
                        "id": 94475,
                        "name": "Gvardinița",
                        "latitude": "44.39505000",
                        "longitude": "23.14635000"
                    },
                    {
                        "id": 94520,
                        "name": "Halânga",
                        "latitude": "44.68116000",
                        "longitude": "22.69037000"
                    },
                    {
                        "id": 94537,
                        "name": "Hinova",
                        "latitude": "44.54056000",
                        "longitude": "22.77694000"
                    },
                    {
                        "id": 94585,
                        "name": "Husnicioara",
                        "latitude": "44.67806000",
                        "longitude": "22.84250000"
                    },
                    {
                        "id": 94660,
                        "name": "Ilovăț",
                        "latitude": "44.81197000",
                        "longitude": "22.76333000"
                    },
                    {
                        "id": 94659,
                        "name": "Iloviţa",
                        "latitude": "44.75639000",
                        "longitude": "22.47278000"
                    },
                    {
                        "id": 94693,
                        "name": "Isverna",
                        "latitude": "44.97972000",
                        "longitude": "22.62917000"
                    },
                    {
                        "id": 94700,
                        "name": "Izimșa",
                        "latitude": "44.17819000",
                        "longitude": "22.95649000"
                    },
                    {
                        "id": 94709,
                        "name": "Izvoarele",
                        "latitude": "44.30958000",
                        "longitude": "22.66348000"
                    },
                    {
                        "id": 94717,
                        "name": "Izvoru Bârzii",
                        "latitude": "44.70667000",
                        "longitude": "22.67417000"
                    },
                    {
                        "id": 94726,
                        "name": "Jiana",
                        "latitude": "44.40184000",
                        "longitude": "22.71278000"
                    },
                    {
                        "id": 94727,
                        "name": "Jiana Veche",
                        "latitude": "44.39083000",
                        "longitude": "22.66861000"
                    },
                    {
                        "id": 94732,
                        "name": "Jidoștița",
                        "latitude": "44.71582000",
                        "longitude": "22.59311000"
                    },
                    {
                        "id": 94741,
                        "name": "Jirov",
                        "latitude": "44.67098000",
                        "longitude": "23.08693000"
                    },
                    {
                        "id": 94822,
                        "name": "Livezile",
                        "latitude": "44.51222000",
                        "longitude": "22.86333000"
                    },
                    {
                        "id": 94914,
                        "name": "Malovăţ",
                        "latitude": "44.70444000",
                        "longitude": "22.73111000"
                    },
                    {
                        "id": 95138,
                        "name": "Municipiul Drobeta-Turnu Severin",
                        "latitude": "44.64287000",
                        "longitude": "22.60669000"
                    },
                    {
                        "id": 95165,
                        "name": "Municipiul Orşova",
                        "latitude": "44.72520000",
                        "longitude": "22.39771000"
                    },
                    {
                        "id": 95334,
                        "name": "Nicolae Bălcescu",
                        "latitude": "44.37427000",
                        "longitude": "22.85837000"
                    },
                    {
                        "id": 95391,
                        "name": "Obârșia de Câmp",
                        "latitude": "44.17222000",
                        "longitude": "22.98000000"
                    },
                    {
                        "id": 95390,
                        "name": "Obârşia-Cloşani",
                        "latitude": "45.01667000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 95443,
                        "name": "Oprişor",
                        "latitude": "44.28333000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 95454,
                        "name": "Oraş Baia De Aramã",
                        "latitude": "45.00366000",
                        "longitude": "22.80709000"
                    },
                    {
                        "id": 95593,
                        "name": "Oraş Strehaia",
                        "latitude": "44.62360000",
                        "longitude": "23.18792000"
                    },
                    {
                        "id": 95621,
                        "name": "Oraş Vânju Mare",
                        "latitude": "44.42326000",
                        "longitude": "22.87340000"
                    },
                    {
                        "id": 95657,
                        "name": "Orevița Mare",
                        "latitude": "44.45715000",
                        "longitude": "22.91317000"
                    },
                    {
                        "id": 95669,
                        "name": "Orşova",
                        "latitude": "44.72299000",
                        "longitude": "22.39619000"
                    },
                    {
                        "id": 95680,
                        "name": "Ostrovu Mare",
                        "latitude": "44.37931000",
                        "longitude": "22.51581000"
                    },
                    {
                        "id": 95696,
                        "name": "Padina Mică",
                        "latitude": "44.42722000",
                        "longitude": "22.99250000"
                    },
                    {
                        "id": 96024,
                        "name": "Pătulele",
                        "latitude": "44.34528000",
                        "longitude": "22.77278000"
                    },
                    {
                        "id": 95843,
                        "name": "Podeni",
                        "latitude": "44.88139000",
                        "longitude": "22.54333000"
                    },
                    {
                        "id": 95905,
                        "name": "Ponoarele",
                        "latitude": "44.97389000",
                        "longitude": "22.76444000"
                    },
                    {
                        "id": 95920,
                        "name": "Poroina Mare",
                        "latitude": "44.49528000",
                        "longitude": "22.93639000"
                    },
                    {
                        "id": 95955,
                        "name": "Pristol",
                        "latitude": "44.22472000",
                        "longitude": "22.70917000"
                    },
                    {
                        "id": 95968,
                        "name": "Prunişor",
                        "latitude": "44.60944000",
                        "longitude": "22.91528000"
                    },
                    {
                        "id": 95982,
                        "name": "Punghina",
                        "latitude": "44.28194000",
                        "longitude": "22.93472000"
                    },
                    {
                        "id": 96068,
                        "name": "Recea",
                        "latitude": "44.31949000",
                        "longitude": "22.91659000"
                    },
                    {
                        "id": 96101,
                        "name": "Rogova",
                        "latitude": "44.47167000",
                        "longitude": "22.80667000"
                    },
                    {
                        "id": 96137,
                        "name": "Roșiori",
                        "latitude": "44.25633000",
                        "longitude": "22.92838000"
                    },
                    {
                        "id": 96232,
                        "name": "Salcia",
                        "latitude": "44.14083000",
                        "longitude": "22.92778000"
                    },
                    {
                        "id": 97051,
                        "name": "Şimian",
                        "latitude": "44.61417000",
                        "longitude": "22.70722000"
                    },
                    {
                        "id": 97061,
                        "name": "Şişeşti",
                        "latitude": "44.77750000",
                        "longitude": "22.83944000"
                    },
                    {
                        "id": 97075,
                        "name": "Şovarna",
                        "latitude": "44.85361000",
                        "longitude": "22.79250000"
                    },
                    {
                        "id": 96473,
                        "name": "Stângăceaua",
                        "latitude": "44.60896000",
                        "longitude": "23.31273000"
                    },
                    {
                        "id": 96449,
                        "name": "Strehaia",
                        "latitude": "44.61667000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 96515,
                        "name": "Sviniţa",
                        "latitude": "44.49972000",
                        "longitude": "22.10611000"
                    },
                    {
                        "id": 96577,
                        "name": "Tâmna",
                        "latitude": "44.56667000",
                        "longitude": "23.01667000"
                    },
                    {
                        "id": 96928,
                        "name": "Vânători",
                        "latitude": "44.24278000",
                        "longitude": "22.92889000"
                    },
                    {
                        "id": 96926,
                        "name": "Vânju-Mare",
                        "latitude": "44.42528000",
                        "longitude": "22.86972000"
                    },
                    {
                        "id": 96927,
                        "name": "Vânjuleţ",
                        "latitude": "44.44111000",
                        "longitude": "22.79250000"
                    },
                    {
                        "id": 96859,
                        "name": "Vlădaia",
                        "latitude": "44.35000000",
                        "longitude": "23.03333000"
                    },
                    {
                        "id": 96887,
                        "name": "Voloiac",
                        "latitude": "44.61667000",
                        "longitude": "23.10000000"
                    },
                    {
                        "id": 96897,
                        "name": "Vrata",
                        "latitude": "44.19197000",
                        "longitude": "22.84928000"
                    }
                ]
            },
            {
                "id": 4915,
                "name": "Mureș",
                "iso2": "MS",
                "latitude": "46.60075560",
                "longitude": "23.32239140",
                "type": "department",
                "cities": [
                    {
                        "id": 146225,
                        "name": "Abuș",
                        "latitude": "46.35000000",
                        "longitude": "24.38333333"
                    },
                    {
                        "id": 146226,
                        "name": "Acățari",
                        "latitude": "46.48333333",
                        "longitude": "24.63333333"
                    },
                    {
                        "id": 146230,
                        "name": "Adămuș",
                        "latitude": "46.30000000",
                        "longitude": "24.23000000"
                    },
                    {
                        "id": 146227,
                        "name": "Adrian",
                        "latitude": "46.78209200",
                        "longitude": "24.83324200"
                    },
                    {
                        "id": 146228,
                        "name": "Adrianu Mare",
                        "latitude": "46.49357300",
                        "longitude": "24.80324400"
                    },
                    {
                        "id": 146229,
                        "name": "Adrianu Mic",
                        "latitude": "46.50082100",
                        "longitude": "24.79051400"
                    },
                    {
                        "id": 146231,
                        "name": "Agrișteu",
                        "latitude": "46.39172800",
                        "longitude": "24.68379600"
                    },
                    {
                        "id": 146232,
                        "name": "Albești",
                        "latitude": "46.23000000",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 146233,
                        "name": "Aluniș",
                        "latitude": "46.90000000",
                        "longitude": "24.82000000"
                    },
                    {
                        "id": 146234,
                        "name": "Andreneasa",
                        "latitude": "46.96784300",
                        "longitude": "25.02423500"
                    },
                    {
                        "id": 146235,
                        "name": "Angofa",
                        "latitude": "46.18658200",
                        "longitude": "24.78418000"
                    },
                    {
                        "id": 146236,
                        "name": "Apalina",
                        "latitude": "46.75231300",
                        "longitude": "24.69275500"
                    },
                    {
                        "id": 146237,
                        "name": "Apold",
                        "latitude": "46.12777778",
                        "longitude": "24.81805556"
                    },
                    {
                        "id": 146238,
                        "name": "Archita",
                        "latitude": "46.18194444",
                        "longitude": "25.08750000"
                    },
                    {
                        "id": 146239,
                        "name": "Arșița",
                        "latitude": "46.78587400",
                        "longitude": "24.99858500"
                    },
                    {
                        "id": 146242,
                        "name": "Ațintiș",
                        "latitude": "46.43000000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 146240,
                        "name": "Aurel Vlaicu",
                        "latitude": "46.17787000",
                        "longitude": "24.82072000"
                    },
                    {
                        "id": 146241,
                        "name": "Avrămești",
                        "latitude": "46.53620800",
                        "longitude": "24.09928400"
                    },
                    {
                        "id": 146282,
                        "name": "Băgaciu",
                        "latitude": "46.27000000",
                        "longitude": "24.37000000"
                    },
                    {
                        "id": 146243,
                        "name": "Bahnea",
                        "latitude": "46.37000000",
                        "longitude": "24.48000000"
                    },
                    {
                        "id": 146283,
                        "name": "Băița",
                        "latitude": "46.83635200",
                        "longitude": "24.52999700"
                    },
                    {
                        "id": 146284,
                        "name": "Băla",
                        "latitude": "46.72000000",
                        "longitude": "24.50000000"
                    },
                    {
                        "id": 146285,
                        "name": "Bălăușeri",
                        "latitude": "46.40000000",
                        "longitude": "24.68333333"
                    },
                    {
                        "id": 146244,
                        "name": "Balda",
                        "latitude": "46.73352800",
                        "longitude": "24.14361600"
                    },
                    {
                        "id": 146245,
                        "name": "Band",
                        "latitude": "46.58333333",
                        "longitude": "24.38333333"
                    },
                    {
                        "id": 146278,
                        "name": "Bâra",
                        "latitude": "46.57221300",
                        "longitude": "24.87262000"
                    },
                    {
                        "id": 146286,
                        "name": "Bărboși",
                        "latitude": "46.58087200",
                        "longitude": "24.18193500"
                    },
                    {
                        "id": 146287,
                        "name": "Bărdești",
                        "latitude": "46.59451300",
                        "longitude": "24.51309400"
                    },
                    {
                        "id": 146279,
                        "name": "Bârlibaș",
                        "latitude": "46.68896500",
                        "longitude": "24.24549400"
                    },
                    {
                        "id": 146280,
                        "name": "Bârlibășoaia",
                        "latitude": "46.29336500",
                        "longitude": "24.83495500"
                    },
                    {
                        "id": 146281,
                        "name": "Bârza",
                        "latitude": "46.55000000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 146246,
                        "name": "Batoș",
                        "latitude": "46.88611111",
                        "longitude": "24.65555556"
                    },
                    {
                        "id": 146247,
                        "name": "Bedeni",
                        "latitude": "46.46760600",
                        "longitude": "24.78337400"
                    },
                    {
                        "id": 146248,
                        "name": "Beica de Jos",
                        "latitude": "46.73423000",
                        "longitude": "24.79671000"
                    },
                    {
                        "id": 146249,
                        "name": "Beica de Sus",
                        "latitude": "46.73795400",
                        "longitude": "24.82270100"
                    },
                    {
                        "id": 146250,
                        "name": "Bereni",
                        "latitude": "46.55000000",
                        "longitude": "24.86666667"
                    },
                    {
                        "id": 146251,
                        "name": "Berghia",
                        "latitude": "46.53964600",
                        "longitude": "24.42961400"
                    },
                    {
                        "id": 146252,
                        "name": "Bernadea",
                        "latitude": "46.37406800",
                        "longitude": "24.45846600"
                    },
                    {
                        "id": 146253,
                        "name": "Beu",
                        "latitude": "46.57393000",
                        "longitude": "24.71942400"
                    },
                    {
                        "id": 146254,
                        "name": "Bezid",
                        "latitude": "46.40639300",
                        "longitude": "24.92238400"
                    },
                    {
                        "id": 146255,
                        "name": "Bicașu",
                        "latitude": "46.81066200",
                        "longitude": "24.95608700"
                    },
                    {
                        "id": 146256,
                        "name": "Bichiș",
                        "latitude": "46.36666667",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 146257,
                        "name": "Bistra Mureșului",
                        "latitude": "46.96093200",
                        "longitude": "24.90505900"
                    },
                    {
                        "id": 146258,
                        "name": "Blidireasa",
                        "latitude": "46.76394400",
                        "longitude": "25.03065100"
                    },
                    {
                        "id": 146259,
                        "name": "Bobohalma",
                        "latitude": "46.35142200",
                        "longitude": "24.23505000"
                    },
                    {
                        "id": 146260,
                        "name": "Bogata",
                        "latitude": "46.45640800",
                        "longitude": "24.11961700"
                    },
                    {
                        "id": 146261,
                        "name": "Boiu",
                        "latitude": "46.26570300",
                        "longitude": "24.87482300"
                    },
                    {
                        "id": 146262,
                        "name": "Bolintineni",
                        "latitude": "46.49245700",
                        "longitude": "24.71309300"
                    },
                    {
                        "id": 146263,
                        "name": "Bologaia",
                        "latitude": "46.63685600",
                        "longitude": "24.25876800"
                    },
                    {
                        "id": 146264,
                        "name": "Bord",
                        "latitude": "46.39368900",
                        "longitude": "24.22694000"
                    },
                    {
                        "id": 146265,
                        "name": "Bordoșiu",
                        "latitude": "46.39629600",
                        "longitude": "24.78414100"
                    },
                    {
                        "id": 146266,
                        "name": "Borzia",
                        "latitude": "46.96974200",
                        "longitude": "24.93240200"
                    },
                    {
                        "id": 146267,
                        "name": "Botei",
                        "latitude": "46.63939700",
                        "longitude": "24.13197800"
                    },
                    {
                        "id": 146268,
                        "name": "Botez",
                        "latitude": "46.38674600",
                        "longitude": "24.02429900"
                    },
                    {
                        "id": 146269,
                        "name": "Botorca",
                        "latitude": "46.28231800",
                        "longitude": "24.30157300"
                    },
                    {
                        "id": 146270,
                        "name": "Bozed",
                        "latitude": "46.68735700",
                        "longitude": "24.46226000"
                    },
                    {
                        "id": 146271,
                        "name": "Bozeni",
                        "latitude": "46.53212400",
                        "longitude": "24.67124300"
                    },
                    {
                        "id": 146274,
                        "name": "Brădețelu",
                        "latitude": "46.75538900",
                        "longitude": "25.05171000"
                    },
                    {
                        "id": 146273,
                        "name": "Brâncovenești",
                        "latitude": "46.87000000",
                        "longitude": "24.77000000"
                    },
                    {
                        "id": 146272,
                        "name": "Breaza",
                        "latitude": "46.77000000",
                        "longitude": "24.63000000"
                    },
                    {
                        "id": 146275,
                        "name": "Budiu Mic",
                        "latitude": "46.50920600",
                        "longitude": "24.58480700"
                    },
                    {
                        "id": 146276,
                        "name": "Bujor",
                        "latitude": "46.65534000",
                        "longitude": "24.17342200"
                    },
                    {
                        "id": 146277,
                        "name": "Bujor-Hodaie",
                        "latitude": "46.64494700",
                        "longitude": "24.16832800"
                    },
                    {
                        "id": 146345,
                        "name": "Căciulata",
                        "latitude": "46.71513500",
                        "longitude": "24.40602300"
                    },
                    {
                        "id": 146346,
                        "name": "Căcuciu",
                        "latitude": "46.72559400",
                        "longitude": "24.84986700"
                    },
                    {
                        "id": 146347,
                        "name": "Călimănești",
                        "latitude": "46.41332500",
                        "longitude": "24.73270900"
                    },
                    {
                        "id": 146348,
                        "name": "Călugăreni",
                        "latitude": "46.62981900",
                        "longitude": "24.87772300"
                    },
                    {
                        "id": 146349,
                        "name": "Călușeri",
                        "latitude": "46.60637300",
                        "longitude": "24.73717300"
                    },
                    {
                        "id": 146342,
                        "name": "Câmpenița",
                        "latitude": "46.65121100",
                        "longitude": "24.48733800"
                    },
                    {
                        "id": 146343,
                        "name": "Câmpu Cetății",
                        "latitude": "46.67042700",
                        "longitude": "25.01397300"
                    },
                    {
                        "id": 146344,
                        "name": "Cându",
                        "latitude": "46.59917700",
                        "longitude": "24.88790900"
                    },
                    {
                        "id": 146352,
                        "name": "Căpâlna de Sus",
                        "latitude": "46.37846300",
                        "longitude": "24.43502000"
                    },
                    {
                        "id": 146350,
                        "name": "Căpeți",
                        "latitude": "46.63147000",
                        "longitude": "25.07876000"
                    },
                    {
                        "id": 146351,
                        "name": "Căpușu de Câmpie",
                        "latitude": "46.54226300",
                        "longitude": "24.31414200"
                    },
                    {
                        "id": 146288,
                        "name": "Cașva",
                        "latitude": "46.78193600",
                        "longitude": "24.87788000"
                    },
                    {
                        "id": 146289,
                        "name": "Cecălaca",
                        "latitude": "46.39449200",
                        "longitude": "24.04013200"
                    },
                    {
                        "id": 146290,
                        "name": "Ceie",
                        "latitude": "46.46406600",
                        "longitude": "24.98427000"
                    },
                    {
                        "id": 146291,
                        "name": "Cerghid",
                        "latitude": "46.41450900",
                        "longitude": "24.44602000"
                    },
                    {
                        "id": 146292,
                        "name": "Cerghizel",
                        "latitude": "46.44451000",
                        "longitude": "24.44687800"
                    },
                    {
                        "id": 146293,
                        "name": "Ceuaș",
                        "latitude": "46.34277778",
                        "longitude": "24.44305556"
                    },
                    {
                        "id": 146294,
                        "name": "Ceuașu de Câmpie",
                        "latitude": "46.64293200",
                        "longitude": "24.51387100"
                    },
                    {
                        "id": 146295,
                        "name": "Chendu",
                        "latitude": "46.39086900",
                        "longitude": "24.73045000"
                    },
                    {
                        "id": 146296,
                        "name": "Chețani",
                        "latitude": "46.47000000",
                        "longitude": "24.03000000"
                    },
                    {
                        "id": 146297,
                        "name": "Chibed",
                        "latitude": "46.52944444",
                        "longitude": "24.96333333"
                    },
                    {
                        "id": 146298,
                        "name": "Chiheru de Jos",
                        "latitude": "46.68700200",
                        "longitude": "24.88163600"
                    },
                    {
                        "id": 146299,
                        "name": "Chiheru de Sus",
                        "latitude": "46.68134800",
                        "longitude": "24.90359800"
                    },
                    {
                        "id": 146300,
                        "name": "Chinari",
                        "latitude": "46.60525700",
                        "longitude": "24.58969100"
                    },
                    {
                        "id": 146301,
                        "name": "Chinciuș",
                        "latitude": "46.35235400",
                        "longitude": "24.18323300"
                    },
                    {
                        "id": 146302,
                        "name": "Chirileu",
                        "latitude": "46.47664400",
                        "longitude": "24.38296500"
                    },
                    {
                        "id": 146303,
                        "name": "Chisălița",
                        "latitude": "46.56809100",
                        "longitude": "24.31475700"
                    },
                    {
                        "id": 146304,
                        "name": "Ciba",
                        "latitude": "46.47922600",
                        "longitude": "24.56806300"
                    },
                    {
                        "id": 146305,
                        "name": "Cibu",
                        "latitude": "46.37903800",
                        "longitude": "24.80370800"
                    },
                    {
                        "id": 146306,
                        "name": "Cinta",
                        "latitude": "46.46022000",
                        "longitude": "24.55103800"
                    },
                    {
                        "id": 146307,
                        "name": "Cioarga",
                        "latitude": "46.49385600",
                        "longitude": "24.07296500"
                    },
                    {
                        "id": 146308,
                        "name": "Ciobotani",
                        "latitude": "46.95037600",
                        "longitude": "25.26872900"
                    },
                    {
                        "id": 146309,
                        "name": "Cipaieni",
                        "latitude": "46.53242900",
                        "longitude": "24.16726100"
                    },
                    {
                        "id": 146310,
                        "name": "Cipău",
                        "latitude": "46.44875700",
                        "longitude": "24.27785900"
                    },
                    {
                        "id": 146311,
                        "name": "Ciretea",
                        "latitude": "46.60623600",
                        "longitude": "24.17041800"
                    },
                    {
                        "id": 146312,
                        "name": "Cirhagău",
                        "latitude": "46.66041500",
                        "longitude": "24.10686800"
                    },
                    {
                        "id": 146313,
                        "name": "Ciulea",
                        "latitude": "46.66667800",
                        "longitude": "24.26355200"
                    },
                    {
                        "id": 146314,
                        "name": "Ciurgău",
                        "latitude": "46.50132300",
                        "longitude": "24.10504400"
                    },
                    {
                        "id": 146315,
                        "name": "Cloașterf",
                        "latitude": "46.14655300",
                        "longitude": "24.99720400"
                    },
                    {
                        "id": 146316,
                        "name": "Coasta Grindului",
                        "latitude": "46.49549800",
                        "longitude": "23.98263600"
                    },
                    {
                        "id": 146317,
                        "name": "Coasta Mare",
                        "latitude": "46.69290700",
                        "longitude": "24.36331000"
                    },
                    {
                        "id": 146318,
                        "name": "Comori",
                        "latitude": "46.73580300",
                        "longitude": "24.89690600"
                    },
                    {
                        "id": 146319,
                        "name": "Comuna Coroisânmartin",
                        "latitude": "46.40376000",
                        "longitude": "24.59766000"
                    },
                    {
                        "id": 146320,
                        "name": "Comuna Ibănești Pădure",
                        "latitude": "46.76302000",
                        "longitude": "25.03118000"
                    },
                    {
                        "id": 146321,
                        "name": "Comuna Rușii Munți",
                        "latitude": "46.91988000",
                        "longitude": "24.83521000"
                    },
                    {
                        "id": 146322,
                        "name": "Corbești",
                        "latitude": "46.42943000",
                        "longitude": "24.59075500"
                    },
                    {
                        "id": 146323,
                        "name": "Cordoș",
                        "latitude": "46.51284700",
                        "longitude": "24.02304400"
                    },
                    {
                        "id": 146324,
                        "name": "Cornești",
                        "latitude": "46.29222222",
                        "longitude": "24.21277778"
                    },
                    {
                        "id": 146325,
                        "name": "Coroi",
                        "latitude": "46.40909900",
                        "longitude": "24.63389100"
                    },
                    {
                        "id": 146326,
                        "name": "Corunca",
                        "latitude": "46.51666667",
                        "longitude": "24.61666667"
                    },
                    {
                        "id": 146327,
                        "name": "Cotorinau",
                        "latitude": "46.72378800",
                        "longitude": "24.37166200"
                    },
                    {
                        "id": 146328,
                        "name": "Cotuș",
                        "latitude": "46.57562100",
                        "longitude": "24.67169900"
                    },
                    {
                        "id": 146329,
                        "name": "Cozma",
                        "latitude": "46.80707200",
                        "longitude": "24.52253200"
                    },
                    {
                        "id": 146332,
                        "name": "Crăciunești",
                        "latitude": "46.47930000",
                        "longitude": "24.58234000"
                    },
                    {
                        "id": 146333,
                        "name": "Crăiești",
                        "latitude": "46.29628000",
                        "longitude": "24.19674800"
                    },
                    {
                        "id": 146331,
                        "name": "Criș",
                        "latitude": "46.14388889",
                        "longitude": "24.69388889"
                    },
                    {
                        "id": 146330,
                        "name": "Cristești",
                        "latitude": "46.50000000",
                        "longitude": "24.48333333"
                    },
                    {
                        "id": 146334,
                        "name": "Cucerdea",
                        "latitude": "46.40222222",
                        "longitude": "24.26583333"
                    },
                    {
                        "id": 146335,
                        "name": "Cuci",
                        "latitude": "46.47000000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 146336,
                        "name": "Cuieșd",
                        "latitude": "46.60168200",
                        "longitude": "24.47811600"
                    },
                    {
                        "id": 146337,
                        "name": "Culpiu",
                        "latitude": "46.63960800",
                        "longitude": "24.43258000"
                    },
                    {
                        "id": 146338,
                        "name": "Cund",
                        "latitude": "46.27278100",
                        "longitude": "24.51228800"
                    },
                    {
                        "id": 146339,
                        "name": "Curețe",
                        "latitude": "46.74116800",
                        "longitude": "24.43177000"
                    },
                    {
                        "id": 146340,
                        "name": "Curteni",
                        "latitude": "46.59436100",
                        "longitude": "24.57501100"
                    },
                    {
                        "id": 146341,
                        "name": "Cuștelnic",
                        "latitude": "46.33896200",
                        "longitude": "24.31176800"
                    },
                    {
                        "id": 146353,
                        "name": "Daia",
                        "latitude": "46.14444444",
                        "longitude": "24.89861111"
                    },
                    {
                        "id": 146354,
                        "name": "Dalu",
                        "latitude": "46.54544100",
                        "longitude": "24.08882800"
                    },
                    {
                        "id": 146374,
                        "name": "Dâmbău",
                        "latitude": "46.31997900",
                        "longitude": "24.23443000"
                    },
                    {
                        "id": 146373,
                        "name": "Dâmbu",
                        "latitude": "46.74256000",
                        "longitude": "24.26858500"
                    },
                    {
                        "id": 146375,
                        "name": "Dămieni",
                        "latitude": "46.62612200",
                        "longitude": "24.86071400"
                    },
                    {
                        "id": 146355,
                        "name": "Daneș",
                        "latitude": "46.22111111",
                        "longitude": "24.70472222"
                    },
                    {
                        "id": 146376,
                        "name": "Dătășeni",
                        "latitude": "46.47474800",
                        "longitude": "24.17485200"
                    },
                    {
                        "id": 146356,
                        "name": "Deag",
                        "latitude": "46.38918500",
                        "longitude": "24.19220400"
                    },
                    {
                        "id": 146357,
                        "name": "Deaj",
                        "latitude": "46.34710800",
                        "longitude": "24.40206500"
                    },
                    {
                        "id": 146358,
                        "name": "Deda",
                        "latitude": "46.93333333",
                        "longitude": "24.90000000"
                    },
                    {
                        "id": 146359,
                        "name": "Dedrad",
                        "latitude": "46.81666667",
                        "longitude": "24.66666667"
                    },
                    {
                        "id": 146360,
                        "name": "Deleni",
                        "latitude": "46.26340300",
                        "longitude": "24.34119000"
                    },
                    {
                        "id": 146361,
                        "name": "Dileu Nou",
                        "latitude": "46.46326500",
                        "longitude": "24.33267600"
                    },
                    {
                        "id": 146362,
                        "name": "Dileu Vechi",
                        "latitude": "46.47109000",
                        "longitude": "24.30987500"
                    },
                    {
                        "id": 146363,
                        "name": "Dobra",
                        "latitude": "46.58142400",
                        "longitude": "24.23734900"
                    },
                    {
                        "id": 146365,
                        "name": "Drăculea Bandului",
                        "latitude": "46.62041700",
                        "longitude": "24.33844200"
                    },
                    {
                        "id": 146364,
                        "name": "Drojdii",
                        "latitude": "46.54596600",
                        "longitude": "24.85711100"
                    },
                    {
                        "id": 146366,
                        "name": "Dubiștea de Pădure",
                        "latitude": "46.77679100",
                        "longitude": "24.96515100"
                    },
                    {
                        "id": 146367,
                        "name": "Dulcea",
                        "latitude": "46.75769000",
                        "longitude": "25.03246700"
                    },
                    {
                        "id": 146368,
                        "name": "Dumbrava",
                        "latitude": "46.94206800",
                        "longitude": "24.80491400"
                    },
                    {
                        "id": 146369,
                        "name": "Dumbrăvioara",
                        "latitude": "46.64096000",
                        "longitude": "24.63796700"
                    },
                    {
                        "id": 146370,
                        "name": "Dumitreni",
                        "latitude": "46.40092600",
                        "longitude": "24.75854800"
                    },
                    {
                        "id": 146371,
                        "name": "Dumitreștii",
                        "latitude": "46.52174500",
                        "longitude": "24.78759200"
                    },
                    {
                        "id": 146372,
                        "name": "După Deal",
                        "latitude": "46.51740800",
                        "longitude": "24.24629600"
                    },
                    {
                        "id": 146377,
                        "name": "Ercea",
                        "latitude": "46.73081400",
                        "longitude": "24.51057400"
                    },
                    {
                        "id": 146378,
                        "name": "Eremieni",
                        "latitude": "46.53641900",
                        "longitude": "24.87158200"
                    },
                    {
                        "id": 146379,
                        "name": "Eremitu",
                        "latitude": "46.66666667",
                        "longitude": "24.93333333"
                    },
                    {
                        "id": 146380,
                        "name": "Ernei",
                        "latitude": "46.60000000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 146391,
                        "name": "Fânațe",
                        "latitude": "46.53239000",
                        "longitude": "24.21537200"
                    },
                    {
                        "id": 146392,
                        "name": "Fânațele Mădărașului",
                        "latitude": "46.62596200",
                        "longitude": "24.36273200"
                    },
                    {
                        "id": 146393,
                        "name": "Fânațele Socolului",
                        "latitude": "46.79298700",
                        "longitude": "24.48803200"
                    },
                    {
                        "id": 146394,
                        "name": "Fântâna Babii",
                        "latitude": "46.67742200",
                        "longitude": "24.33776400"
                    },
                    {
                        "id": 146395,
                        "name": "Fântânele",
                        "latitude": "46.41666667",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 146396,
                        "name": "Fărăgău",
                        "latitude": "46.77000000",
                        "longitude": "24.52000000"
                    },
                    {
                        "id": 146381,
                        "name": "Feleag",
                        "latitude": "46.24110000",
                        "longitude": "25.01418800"
                    },
                    {
                        "id": 146382,
                        "name": "Filea",
                        "latitude": "46.94179700",
                        "longitude": "24.88375500"
                    },
                    {
                        "id": 146383,
                        "name": "Filitelnic",
                        "latitude": "46.36694444",
                        "longitude": "24.66611111"
                    },
                    {
                        "id": 146384,
                        "name": "Filpișu Mare",
                        "latitude": "46.75332700",
                        "longitude": "24.58749800"
                    },
                    {
                        "id": 146385,
                        "name": "Filpișu Mic",
                        "latitude": "46.78219700",
                        "longitude": "24.60124800"
                    },
                    {
                        "id": 146386,
                        "name": "Fițcău",
                        "latitude": "46.89908200",
                        "longitude": "24.87000200"
                    },
                    {
                        "id": 146387,
                        "name": "Foi",
                        "latitude": "46.47996100",
                        "longitude": "24.59973400"
                    },
                    {
                        "id": 146388,
                        "name": "Frunzeni",
                        "latitude": "46.81445800",
                        "longitude": "24.56796900"
                    },
                    {
                        "id": 146390,
                        "name": "Fundătura",
                        "latitude": "46.54329000",
                        "longitude": "24.04357400"
                    },
                    {
                        "id": 146389,
                        "name": "Fundoaia",
                        "latitude": "46.82762500",
                        "longitude": "24.90466000"
                    },
                    {
                        "id": 146418,
                        "name": "Găiești",
                        "latitude": "46.42549700",
                        "longitude": "24.67088000"
                    },
                    {
                        "id": 146420,
                        "name": "Gălăoaia",
                        "latitude": "46.97086700",
                        "longitude": "24.91824900"
                    },
                    {
                        "id": 146421,
                        "name": "Gălățeni",
                        "latitude": "46.47319700",
                        "longitude": "24.70785400"
                    },
                    {
                        "id": 146419,
                        "name": "Gălești",
                        "latitude": "46.51666667",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 146417,
                        "name": "Gâmbuț",
                        "latitude": "46.35242400",
                        "longitude": "24.06523300"
                    },
                    {
                        "id": 146422,
                        "name": "Gănești",
                        "latitude": "46.33000000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 146397,
                        "name": "Gaura Sângerului",
                        "latitude": "46.60031700",
                        "longitude": "24.12539700"
                    },
                    {
                        "id": 146398,
                        "name": "Gheja",
                        "latitude": "46.44494800",
                        "longitude": "24.06135900"
                    },
                    {
                        "id": 146399,
                        "name": "Gheorghe Doja",
                        "latitude": "46.46666667",
                        "longitude": "24.50000000"
                    },
                    {
                        "id": 146400,
                        "name": "Ghidașteu",
                        "latitude": "46.55460300",
                        "longitude": "24.26810100"
                    },
                    {
                        "id": 146401,
                        "name": "Ghindari",
                        "latitude": "46.50000000",
                        "longitude": "24.91666667"
                    },
                    {
                        "id": 146402,
                        "name": "Ghinești",
                        "latitude": "46.49611100",
                        "longitude": "24.86619200"
                    },
                    {
                        "id": 146403,
                        "name": "Giuluș",
                        "latitude": "46.40126200",
                        "longitude": "24.31114300"
                    },
                    {
                        "id": 146404,
                        "name": "Giurgiș",
                        "latitude": "46.51705900",
                        "longitude": "23.96957900"
                    },
                    {
                        "id": 146406,
                        "name": "Glăjărie",
                        "latitude": "46.83271000",
                        "longitude": "24.93285000"
                    },
                    {
                        "id": 146405,
                        "name": "Glodeni",
                        "latitude": "46.65000000",
                        "longitude": "24.60000000"
                    },
                    {
                        "id": 146407,
                        "name": "Gogan",
                        "latitude": "46.30491700",
                        "longitude": "24.51711900"
                    },
                    {
                        "id": 146408,
                        "name": "Goreni",
                        "latitude": "46.85458100",
                        "longitude": "24.65413800"
                    },
                    {
                        "id": 146409,
                        "name": "Gornești",
                        "latitude": "46.66666667",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 146415,
                        "name": "Grădini",
                        "latitude": "46.61474400",
                        "longitude": "24.09034300"
                    },
                    {
                        "id": 146414,
                        "name": "Grâușorul",
                        "latitude": "46.59913400",
                        "longitude": "24.83048600"
                    },
                    {
                        "id": 146410,
                        "name": "Grebenișu de Câmpie",
                        "latitude": "46.60000000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 146411,
                        "name": "Grindeni",
                        "latitude": "46.50005900",
                        "longitude": "23.99692300"
                    },
                    {
                        "id": 146412,
                        "name": "Groapa Rădăii",
                        "latitude": "46.65809200",
                        "longitude": "24.23434300"
                    },
                    {
                        "id": 146413,
                        "name": "Gruișor",
                        "latitude": "46.45273900",
                        "longitude": "24.61717000"
                    },
                    {
                        "id": 146416,
                        "name": "Gurghiu",
                        "latitude": "46.76666667",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 146423,
                        "name": "Habic",
                        "latitude": "46.70796000",
                        "longitude": "24.79060100"
                    },
                    {
                        "id": 146431,
                        "name": "Hădăreni",
                        "latitude": "46.46698400",
                        "longitude": "23.98373800"
                    },
                    {
                        "id": 146424,
                        "name": "Hagău",
                        "latitude": "46.71628100",
                        "longitude": "24.37286100"
                    },
                    {
                        "id": 146432,
                        "name": "Hărănglab",
                        "latitude": "46.30475800",
                        "longitude": "24.41535300"
                    },
                    {
                        "id": 146433,
                        "name": "Hărțău",
                        "latitude": "46.57732800",
                        "longitude": "24.47862300"
                    },
                    {
                        "id": 146425,
                        "name": "Herepea",
                        "latitude": "46.33074300",
                        "longitude": "24.15515700"
                    },
                    {
                        "id": 146426,
                        "name": "Herghelia",
                        "latitude": "46.63106000",
                        "longitude": "24.47818800"
                    },
                    {
                        "id": 146427,
                        "name": "Hetiur",
                        "latitude": "46.26813000",
                        "longitude": "24.76680100"
                    },
                    {
                        "id": 146428,
                        "name": "Hodac",
                        "latitude": "46.77447700",
                        "longitude": "24.92232400"
                    },
                    {
                        "id": 146429,
                        "name": "Hodaia",
                        "latitude": "46.77367600",
                        "longitude": "24.47928200"
                    },
                    {
                        "id": 146430,
                        "name": "Hodoșa",
                        "latitude": "46.63333333",
                        "longitude": "24.81666667"
                    },
                    {
                        "id": 146434,
                        "name": "Iara de Mureș",
                        "latitude": "46.66148400",
                        "longitude": "24.73055600"
                    },
                    {
                        "id": 146435,
                        "name": "Ibănești-Pădure",
                        "latitude": "46.75919300",
                        "longitude": "24.98359200"
                    },
                    {
                        "id": 146436,
                        "name": "Icland",
                        "latitude": "46.61196900",
                        "longitude": "24.69337700"
                    },
                    {
                        "id": 146437,
                        "name": "Iclandu Mare",
                        "latitude": "46.52810400",
                        "longitude": "24.26536500"
                    },
                    {
                        "id": 146438,
                        "name": "Iclănzel",
                        "latitude": "46.53000000",
                        "longitude": "24.28000000"
                    },
                    {
                        "id": 146440,
                        "name": "Ideciu de Jos",
                        "latitude": "46.80000000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 146441,
                        "name": "Idicel-Pădure",
                        "latitude": "46.85463900",
                        "longitude": "24.85723300"
                    },
                    {
                        "id": 146442,
                        "name": "Idiciu",
                        "latitude": "46.27625000",
                        "longitude": "24.46105000"
                    },
                    {
                        "id": 146443,
                        "name": "Idrifaia",
                        "latitude": "46.38758400",
                        "longitude": "24.46444400"
                    },
                    {
                        "id": 146444,
                        "name": "Iernut",
                        "latitude": "46.45333333",
                        "longitude": "24.23333333"
                    },
                    {
                        "id": 146445,
                        "name": "Iernuțeni",
                        "latitude": "46.76386600",
                        "longitude": "24.71919100"
                    },
                    {
                        "id": 146446,
                        "name": "Ihod",
                        "latitude": "46.63494800",
                        "longitude": "24.79898600"
                    },
                    {
                        "id": 146447,
                        "name": "Ilieni",
                        "latitude": "46.46370800",
                        "longitude": "24.53021400"
                    },
                    {
                        "id": 146448,
                        "name": "Ilieși",
                        "latitude": "46.58255100",
                        "longitude": "25.12801700"
                    },
                    {
                        "id": 146449,
                        "name": "Ilioara",
                        "latitude": "46.64585000",
                        "longitude": "24.74758800"
                    },
                    {
                        "id": 146450,
                        "name": "Iod",
                        "latitude": "46.97336800",
                        "longitude": "24.97719600"
                    },
                    {
                        "id": 146451,
                        "name": "Isla",
                        "latitude": "46.62475600",
                        "longitude": "24.78563700"
                    },
                    {
                        "id": 146453,
                        "name": "Iștan-Tău",
                        "latitude": "46.65015200",
                        "longitude": "24.30310400"
                    },
                    {
                        "id": 146454,
                        "name": "Iștihaza",
                        "latitude": "46.39267900",
                        "longitude": "24.10524100"
                    },
                    {
                        "id": 146452,
                        "name": "Ivănești",
                        "latitude": "46.54204500",
                        "longitude": "24.67634700"
                    },
                    {
                        "id": 146455,
                        "name": "Jabenița",
                        "latitude": "46.78259000",
                        "longitude": "24.79395400"
                    },
                    {
                        "id": 146456,
                        "name": "Jacodu",
                        "latitude": "46.32780000",
                        "longitude": "24.83030000"
                    },
                    {
                        "id": 146457,
                        "name": "Jacu",
                        "latitude": "46.32157900",
                        "longitude": "24.81406500"
                    },
                    {
                        "id": 146478,
                        "name": "Lăpușna",
                        "latitude": "46.76794900",
                        "longitude": "25.21501800"
                    },
                    {
                        "id": 146458,
                        "name": "Larga",
                        "latitude": "46.71971100",
                        "longitude": "24.18108000"
                    },
                    {
                        "id": 146479,
                        "name": "Lăscud",
                        "latitude": "46.39182100",
                        "longitude": "24.35564600"
                    },
                    {
                        "id": 146459,
                        "name": "Laslău Mare",
                        "latitude": "46.38420800",
                        "longitude": "24.54075600"
                    },
                    {
                        "id": 146460,
                        "name": "Laslău Mic",
                        "latitude": "46.36777778",
                        "longitude": "24.55500000"
                    },
                    {
                        "id": 146480,
                        "name": "Lăureni",
                        "latitude": "46.54272000",
                        "longitude": "24.73292800"
                    },
                    {
                        "id": 146461,
                        "name": "Lechincioara",
                        "latitude": "46.66570200",
                        "longitude": "24.42008900"
                    },
                    {
                        "id": 146462,
                        "name": "Lechința",
                        "latitude": "46.47375600",
                        "longitude": "24.22653500"
                    },
                    {
                        "id": 146463,
                        "name": "Lefaia",
                        "latitude": "46.74793000",
                        "longitude": "24.47041800"
                    },
                    {
                        "id": 146464,
                        "name": "Leniș",
                        "latitude": "46.72792900",
                        "longitude": "24.42005400"
                    },
                    {
                        "id": 146465,
                        "name": "Leordeni",
                        "latitude": "46.47107700",
                        "longitude": "24.48631800"
                    },
                    {
                        "id": 146466,
                        "name": "Leorința",
                        "latitude": "46.60825000",
                        "longitude": "24.22974100"
                    },
                    {
                        "id": 146467,
                        "name": "Leorința-Șăulia",
                        "latitude": "46.61897300",
                        "longitude": "24.21220900"
                    },
                    {
                        "id": 146468,
                        "name": "Lepindea",
                        "latitude": "46.32888500",
                        "longitude": "24.47545900"
                    },
                    {
                        "id": 146469,
                        "name": "Linț",
                        "latitude": "46.53319700",
                        "longitude": "24.00205700"
                    },
                    {
                        "id": 146470,
                        "name": "Livezeni",
                        "latitude": "46.55000000",
                        "longitude": "24.63333333"
                    },
                    {
                        "id": 146471,
                        "name": "Logig",
                        "latitude": "46.87945600",
                        "longitude": "24.57377600"
                    },
                    {
                        "id": 146472,
                        "name": "Loțu",
                        "latitude": "46.40028800",
                        "longitude": "24.89633600"
                    },
                    {
                        "id": 146473,
                        "name": "Luduș",
                        "latitude": "46.47777778",
                        "longitude": "24.09611111"
                    },
                    {
                        "id": 146474,
                        "name": "Luieriu",
                        "latitude": "46.84547800",
                        "longitude": "24.72105100"
                    },
                    {
                        "id": 146475,
                        "name": "Lunca",
                        "latitude": "46.84925500",
                        "longitude": "24.57591800"
                    },
                    {
                        "id": 146476,
                        "name": "Lunca Bradului",
                        "latitude": "46.95000000",
                        "longitude": "25.10000000"
                    },
                    {
                        "id": 146477,
                        "name": "Lunca Mureșului",
                        "latitude": "46.87459900",
                        "longitude": "24.79073300"
                    },
                    {
                        "id": 146508,
                        "name": "Măcicășești",
                        "latitude": "46.63959400",
                        "longitude": "24.23585700"
                    },
                    {
                        "id": 146509,
                        "name": "Mădăraș",
                        "latitude": "46.60000000",
                        "longitude": "24.43333333"
                    },
                    {
                        "id": 146510,
                        "name": "Mădărășeni",
                        "latitude": "46.50305556",
                        "longitude": "24.25666667"
                    },
                    {
                        "id": 146511,
                        "name": "Măgherani",
                        "latitude": "46.56666667",
                        "longitude": "24.90000000"
                    },
                    {
                        "id": 146512,
                        "name": "Măgheruș",
                        "latitude": "46.32166667",
                        "longitude": "24.68722222"
                    },
                    {
                        "id": 146481,
                        "name": "Maia",
                        "latitude": "46.58118100",
                        "longitude": "24.84818400"
                    },
                    {
                        "id": 146482,
                        "name": "Maiad",
                        "latitude": "46.51967000",
                        "longitude": "24.71485000"
                    },
                    {
                        "id": 146483,
                        "name": "Maiorești",
                        "latitude": "46.90787200",
                        "longitude": "24.81060000"
                    },
                    {
                        "id": 146513,
                        "name": "Mălăești",
                        "latitude": "46.62793400",
                        "longitude": "24.09674800"
                    },
                    {
                        "id": 146484,
                        "name": "Maldaoci",
                        "latitude": "46.41133400",
                        "longitude": "24.03977300"
                    },
                    {
                        "id": 146485,
                        "name": "Malea",
                        "latitude": "46.58268900",
                        "longitude": "24.19079500"
                    },
                    {
                        "id": 146515,
                        "name": "Mărășești",
                        "latitude": "46.59302200",
                        "longitude": "24.35327500"
                    },
                    {
                        "id": 146514,
                        "name": "Mărculeni",
                        "latitude": "46.59712800",
                        "longitude": "24.86524000"
                    },
                    {
                        "id": 146516,
                        "name": "Mătrici",
                        "latitude": "46.65278900",
                        "longitude": "24.90256400"
                    },
                    {
                        "id": 146486,
                        "name": "Merișor",
                        "latitude": "46.69921400",
                        "longitude": "24.54977700"
                    },
                    {
                        "id": 146487,
                        "name": "Merișoru",
                        "latitude": "46.57026200",
                        "longitude": "24.21403300"
                    },
                    {
                        "id": 146488,
                        "name": "Meștera",
                        "latitude": "46.96845800",
                        "longitude": "25.19289400"
                    },
                    {
                        "id": 146489,
                        "name": "Mica",
                        "latitude": "46.36804600",
                        "longitude": "24.41240500"
                    },
                    {
                        "id": 146490,
                        "name": "Miercurea Nirajului",
                        "latitude": "46.53000000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 146491,
                        "name": "Mihai Viteazu",
                        "latitude": "46.15526900",
                        "longitude": "25.02788100"
                    },
                    {
                        "id": 146492,
                        "name": "Miheșu de Câmpie",
                        "latitude": "46.68000000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 146493,
                        "name": "Milășel",
                        "latitude": "46.74269900",
                        "longitude": "24.45249900"
                    },
                    {
                        "id": 146494,
                        "name": "Mirigioaia",
                        "latitude": "46.80204700",
                        "longitude": "24.92823500"
                    },
                    {
                        "id": 146495,
                        "name": "Mitrești",
                        "latitude": "46.58449300",
                        "longitude": "24.80146800"
                    },
                    {
                        "id": 146496,
                        "name": "Moara de Jos",
                        "latitude": "46.56450400",
                        "longitude": "24.09194200"
                    },
                    {
                        "id": 146497,
                        "name": "Mogoaia",
                        "latitude": "46.67027100",
                        "longitude": "24.23240700"
                    },
                    {
                        "id": 146498,
                        "name": "Moișa",
                        "latitude": "46.68456000",
                        "longitude": "24.52819500"
                    },
                    {
                        "id": 146501,
                        "name": "Morăreni",
                        "latitude": "46.92435800",
                        "longitude": "24.83138600"
                    },
                    {
                        "id": 146499,
                        "name": "Morești",
                        "latitude": "46.48937800",
                        "longitude": "24.43994000"
                    },
                    {
                        "id": 146500,
                        "name": "Moruț",
                        "latitude": "46.74355500",
                        "longitude": "24.19908400"
                    },
                    {
                        "id": 146502,
                        "name": "Moșuni",
                        "latitude": "46.56914500",
                        "longitude": "24.74331100"
                    },
                    {
                        "id": 146503,
                        "name": "Mura Mare",
                        "latitude": "46.65696600",
                        "longitude": "24.78016600"
                    },
                    {
                        "id": 146504,
                        "name": "Mura Mică",
                        "latitude": "46.64909100",
                        "longitude": "24.76523800"
                    },
                    {
                        "id": 146505,
                        "name": "Mureni",
                        "latitude": "46.23041000",
                        "longitude": "24.98921200"
                    },
                    {
                        "id": 146506,
                        "name": "Mureșeni",
                        "latitude": "46.52327600",
                        "longitude": "24.52160800"
                    },
                    {
                        "id": 146507,
                        "name": "Murgești",
                        "latitude": "46.48087900",
                        "longitude": "24.65516400"
                    },
                    {
                        "id": 146518,
                        "name": "Nadășa",
                        "latitude": "46.70274700",
                        "longitude": "24.81713700"
                    },
                    {
                        "id": 146517,
                        "name": "Nadeș",
                        "latitude": "46.32138889",
                        "longitude": "24.71916667"
                    },
                    {
                        "id": 146519,
                        "name": "Nandra",
                        "latitude": "46.38300400",
                        "longitude": "24.07663700"
                    },
                    {
                        "id": 146520,
                        "name": "Nazna",
                        "latitude": "46.53552000",
                        "longitude": "24.50210000"
                    },
                    {
                        "id": 146521,
                        "name": "Neagra",
                        "latitude": "46.97229600",
                        "longitude": "25.14685300"
                    },
                    {
                        "id": 146522,
                        "name": "Neaua",
                        "latitude": "46.48333333",
                        "longitude": "24.83333333"
                    },
                    {
                        "id": 146523,
                        "name": "Negrenii de Câmpie",
                        "latitude": "46.64561200",
                        "longitude": "24.28743200"
                    },
                    {
                        "id": 146524,
                        "name": "Nicolești",
                        "latitude": "46.47705500",
                        "longitude": "24.55574600"
                    },
                    {
                        "id": 146525,
                        "name": "Nima Milășelului",
                        "latitude": "46.72838700",
                        "longitude": "24.44362800"
                    },
                    {
                        "id": 146526,
                        "name": "Nima Râciului",
                        "latitude": "46.70365200",
                        "longitude": "24.44356700"
                    },
                    {
                        "id": 146527,
                        "name": "Oarba de Mureș",
                        "latitude": "46.46325400",
                        "longitude": "24.29078300"
                    },
                    {
                        "id": 146528,
                        "name": "Obârșie",
                        "latitude": "46.74781600",
                        "longitude": "24.39270800"
                    },
                    {
                        "id": 146529,
                        "name": "Odrihei",
                        "latitude": "46.40458500",
                        "longitude": "24.56771400"
                    },
                    {
                        "id": 146530,
                        "name": "Ogra",
                        "latitude": "46.43000000",
                        "longitude": "24.32000000"
                    },
                    {
                        "id": 146531,
                        "name": "Onuca",
                        "latitude": "46.72629700",
                        "longitude": "24.58120400"
                    },
                    {
                        "id": 146532,
                        "name": "Ormeniș",
                        "latitude": "46.32852600",
                        "longitude": "24.54506000"
                    },
                    {
                        "id": 146533,
                        "name": "Oroiu",
                        "latitude": "46.54309200",
                        "longitude": "24.35470000"
                    },
                    {
                        "id": 146534,
                        "name": "Orosia",
                        "latitude": "46.45651100",
                        "longitude": "24.14050800"
                    },
                    {
                        "id": 146535,
                        "name": "Orșova",
                        "latitude": "46.75153400",
                        "longitude": "24.90642800"
                    },
                    {
                        "id": 146536,
                        "name": "Ozd",
                        "latitude": "46.35726900",
                        "longitude": "24.12032200"
                    },
                    {
                        "id": 146555,
                        "name": "Păcureni",
                        "latitude": "46.66185500",
                        "longitude": "24.55651500"
                    },
                    {
                        "id": 146556,
                        "name": "Pădurea",
                        "latitude": "46.63298200",
                        "longitude": "24.17731400"
                    },
                    {
                        "id": 146557,
                        "name": "Pădureni",
                        "latitude": "46.64053200",
                        "longitude": "24.71624700"
                    },
                    {
                        "id": 146558,
                        "name": "Păingeni",
                        "latitude": "46.68003300",
                        "longitude": "24.56196300"
                    },
                    {
                        "id": 146559,
                        "name": "Pănet",
                        "latitude": "46.55000000",
                        "longitude": "24.46666667"
                    },
                    {
                        "id": 146537,
                        "name": "Papiu Ilarian",
                        "latitude": "46.55932100",
                        "longitude": "24.20059000"
                    },
                    {
                        "id": 146553,
                        "name": "Pârâu Crucii",
                        "latitude": "46.70860800",
                        "longitude": "24.35673000"
                    },
                    {
                        "id": 146554,
                        "name": "Pârâu Mare",
                        "latitude": "46.76387600",
                        "longitude": "25.00424200"
                    },
                    {
                        "id": 146560,
                        "name": "Păsăreni",
                        "latitude": "46.48333333",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 146561,
                        "name": "Păucișoara",
                        "latitude": "46.35088900",
                        "longitude": "24.35118800"
                    },
                    {
                        "id": 146562,
                        "name": "Păuloaia",
                        "latitude": "46.80427800",
                        "longitude": "24.88358100"
                    },
                    {
                        "id": 146538,
                        "name": "Periș",
                        "latitude": "46.69422300",
                        "longitude": "24.66336800"
                    },
                    {
                        "id": 146539,
                        "name": "Petea",
                        "latitude": "46.51038700",
                        "longitude": "24.34575400"
                    },
                    {
                        "id": 146540,
                        "name": "Petelea",
                        "latitude": "46.73000000",
                        "longitude": "24.72000000"
                    },
                    {
                        "id": 146541,
                        "name": "Petrilaca",
                        "latitude": "46.41111200",
                        "longitude": "24.14594500"
                    },
                    {
                        "id": 146542,
                        "name": "Petrilaca de Mureș",
                        "latitude": "46.68921400",
                        "longitude": "24.75298500"
                    },
                    {
                        "id": 146543,
                        "name": "Pietriș",
                        "latitude": "46.93593700",
                        "longitude": "24.84407800"
                    },
                    {
                        "id": 146544,
                        "name": "Pipea",
                        "latitude": "46.32523500",
                        "longitude": "24.77454600"
                    },
                    {
                        "id": 146545,
                        "name": "Poarta",
                        "latitude": "46.73516700",
                        "longitude": "24.56146700"
                    },
                    {
                        "id": 146546,
                        "name": "Poduri",
                        "latitude": "46.63458400",
                        "longitude": "24.06107200"
                    },
                    {
                        "id": 146547,
                        "name": "Pogăceaua",
                        "latitude": "46.68000000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 146548,
                        "name": "Poienița",
                        "latitude": "46.55562300",
                        "longitude": "24.67008400"
                    },
                    {
                        "id": 146549,
                        "name": "Porumbac",
                        "latitude": "46.48110300",
                        "longitude": "24.26471900"
                    },
                    {
                        "id": 146550,
                        "name": "Porumbeni",
                        "latitude": "46.63684000",
                        "longitude": "24.54680400"
                    },
                    {
                        "id": 146551,
                        "name": "Pripoare",
                        "latitude": "46.52467900",
                        "longitude": "24.19844400"
                    },
                    {
                        "id": 146552,
                        "name": "Pusta",
                        "latitude": "46.67812300",
                        "longitude": "24.35814900"
                    },
                    {
                        "id": 146563,
                        "name": "Racameț",
                        "latitude": "46.51306800",
                        "longitude": "24.24043900"
                    },
                    {
                        "id": 146573,
                        "name": "Râciu",
                        "latitude": "46.68000000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 146564,
                        "name": "Ranta",
                        "latitude": "46.48492400",
                        "longitude": "24.13149500"
                    },
                    {
                        "id": 146574,
                        "name": "Râpa de Jos",
                        "latitude": "46.94084800",
                        "longitude": "24.76608000"
                    },
                    {
                        "id": 146575,
                        "name": "Răstolița",
                        "latitude": "46.98000000",
                        "longitude": "25.03000000"
                    },
                    {
                        "id": 146576,
                        "name": "Răzoare",
                        "latitude": "46.69243000",
                        "longitude": "24.19386000"
                    },
                    {
                        "id": 146565,
                        "name": "Recea",
                        "latitude": "46.46500600",
                        "longitude": "24.41671800"
                    },
                    {
                        "id": 146182,
                        "name": "Reghin",
                        "latitude": "46.77238770",
                        "longitude": "24.66945610"
                    },
                    {
                        "id": 146566,
                        "name": "Remetea",
                        "latitude": "46.57294300",
                        "longitude": "24.52136900"
                    },
                    {
                        "id": 146567,
                        "name": "Rigmani",
                        "latitude": "46.50898800",
                        "longitude": "24.83835000"
                    },
                    {
                        "id": 146568,
                        "name": "Rora",
                        "latitude": "46.22606400",
                        "longitude": "24.74332800"
                    },
                    {
                        "id": 146571,
                        "name": "Roșiori",
                        "latitude": "46.51433400",
                        "longitude": "24.09475600"
                    },
                    {
                        "id": 146569,
                        "name": "Roteni",
                        "latitude": "46.45874900",
                        "longitude": "24.68182600"
                    },
                    {
                        "id": 146570,
                        "name": "Roua",
                        "latitude": "46.38236300",
                        "longitude": "24.82890600"
                    },
                    {
                        "id": 146572,
                        "name": "Rușii-Munți",
                        "latitude": "46.91667000",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 146618,
                        "name": "Săbed",
                        "latitude": "46.66449900",
                        "longitude": "24.44631900"
                    },
                    {
                        "id": 146620,
                        "name": "Săcădat",
                        "latitude": "46.62453400",
                        "longitude": "25.06206000"
                    },
                    {
                        "id": 146619,
                        "name": "Săcalu de Pădure",
                        "latitude": "46.88368600",
                        "longitude": "24.71133700"
                    },
                    {
                        "id": 146621,
                        "name": "Săcăreni",
                        "latitude": "46.59987700",
                        "longitude": "24.69729600"
                    },
                    {
                        "id": 146702,
                        "name": "Șaeș",
                        "latitude": "46.15277778",
                        "longitude": "24.76944444"
                    },
                    {
                        "id": 146622,
                        "name": "Sălard",
                        "latitude": "46.95145600",
                        "longitude": "25.07545400"
                    },
                    {
                        "id": 146623,
                        "name": "Sălașuri",
                        "latitude": "46.37551400",
                        "longitude": "24.77606700"
                    },
                    {
                        "id": 146624,
                        "name": "Sălcud",
                        "latitude": "46.40755500",
                        "longitude": "24.17140700"
                    },
                    {
                        "id": 146598,
                        "name": "Sâmbriaș",
                        "latitude": "46.66180800",
                        "longitude": "24.82884000"
                    },
                    {
                        "id": 146599,
                        "name": "Sâncraiu de Mureș",
                        "latitude": "46.55000000",
                        "longitude": "24.52000000"
                    },
                    {
                        "id": 146703,
                        "name": "Șandru",
                        "latitude": "46.53733300",
                        "longitude": "24.21063300"
                    },
                    {
                        "id": 146600,
                        "name": "Sângeorgiu de Câmpie",
                        "latitude": "46.72695300",
                        "longitude": "24.29665200"
                    },
                    {
                        "id": 146601,
                        "name": "Sângeorgiu de Mureș",
                        "latitude": "46.57643400",
                        "longitude": "24.60420700"
                    },
                    {
                        "id": 146602,
                        "name": "Sângeorgiu de Pădure",
                        "latitude": "46.43027778",
                        "longitude": "24.84166667"
                    },
                    {
                        "id": 146603,
                        "name": "Sânger",
                        "latitude": "46.55000000",
                        "longitude": "24.13000000"
                    },
                    {
                        "id": 146604,
                        "name": "Sângeru de Pădure",
                        "latitude": "46.64071800",
                        "longitude": "24.66506300"
                    },
                    {
                        "id": 146605,
                        "name": "Sâniacob",
                        "latitude": "46.42354300",
                        "longitude": "24.13191600"
                    },
                    {
                        "id": 146606,
                        "name": "Sânișor",
                        "latitude": "46.55017300",
                        "longitude": "24.70070400"
                    },
                    {
                        "id": 146608,
                        "name": "Sânmărghita",
                        "latitude": "46.48157100",
                        "longitude": "24.37233200"
                    },
                    {
                        "id": 146609,
                        "name": "Sânmărtinu de Câmpie",
                        "latitude": "46.72812200",
                        "longitude": "24.40843300"
                    },
                    {
                        "id": 146607,
                        "name": "Sânmihai de Pădure",
                        "latitude": "46.72888900",
                        "longitude": "24.87474000"
                    },
                    {
                        "id": 146610,
                        "name": "Sânpaul",
                        "latitude": "46.45000000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 146611,
                        "name": "Sânpetru de Câmpie",
                        "latitude": "46.72000000",
                        "longitude": "24.27000000"
                    },
                    {
                        "id": 146612,
                        "name": "Sânsimion",
                        "latitude": "46.49549400",
                        "longitude": "24.83458500"
                    },
                    {
                        "id": 146613,
                        "name": "Sântana de Mureș",
                        "latitude": "46.57611111",
                        "longitude": "24.55416667"
                    },
                    {
                        "id": 146614,
                        "name": "Sântioana",
                        "latitude": "46.28367500",
                        "longitude": "24.55132300"
                    },
                    {
                        "id": 146615,
                        "name": "Sântioana de Mureș",
                        "latitude": "46.51465700",
                        "longitude": "24.45714100"
                    },
                    {
                        "id": 146616,
                        "name": "Sântu",
                        "latitude": "46.80168000",
                        "longitude": "24.60074400"
                    },
                    {
                        "id": 146617,
                        "name": "Sânvăsii",
                        "latitude": "46.49573400",
                        "longitude": "24.74002600"
                    },
                    {
                        "id": 146704,
                        "name": "Șapartoc",
                        "latitude": "46.23333333",
                        "longitude": "24.85000000"
                    },
                    {
                        "id": 146627,
                        "name": "Sărățeni",
                        "latitude": "46.56233333",
                        "longitude": "25.00891667"
                    },
                    {
                        "id": 146705,
                        "name": "Șardu Nirajului",
                        "latitude": "46.54426000",
                        "longitude": "24.75285600"
                    },
                    {
                        "id": 146626,
                        "name": "Sărmășel",
                        "latitude": "46.76062500",
                        "longitude": "24.17885400"
                    },
                    {
                        "id": 146625,
                        "name": "Sărmașu",
                        "latitude": "46.75361111",
                        "longitude": "24.16666667"
                    },
                    {
                        "id": 146577,
                        "name": "Saschiz",
                        "latitude": "46.18333333",
                        "longitude": "24.96666667"
                    },
                    {
                        "id": 146578,
                        "name": "Satu Nou",
                        "latitude": "46.45681300",
                        "longitude": "24.51225400"
                    },
                    {
                        "id": 146717,
                        "name": "Șăulia",
                        "latitude": "46.63000000",
                        "longitude": "24.22000000"
                    },
                    {
                        "id": 146718,
                        "name": "Șăulița",
                        "latitude": "46.66267700",
                        "longitude": "24.21505400"
                    },
                    {
                        "id": 146719,
                        "name": "Șăușa",
                        "latitude": "46.50376200",
                        "longitude": "24.39614600"
                    },
                    {
                        "id": 146579,
                        "name": "Scurta",
                        "latitude": "46.66065800",
                        "longitude": "24.24954500"
                    },
                    {
                        "id": 146580,
                        "name": "Sebeș",
                        "latitude": "46.93202200",
                        "longitude": "24.86438100"
                    },
                    {
                        "id": 146581,
                        "name": "Seleuș",
                        "latitude": "46.36280300",
                        "longitude": "24.58870800"
                    },
                    {
                        "id": 146582,
                        "name": "Senereuș",
                        "latitude": "46.33231500",
                        "longitude": "24.64704100"
                    },
                    {
                        "id": 146706,
                        "name": "Șerbeni",
                        "latitude": "46.71475400",
                        "longitude": "24.86647900"
                    },
                    {
                        "id": 146583,
                        "name": "Seuca",
                        "latitude": "46.33060600",
                        "longitude": "24.32907100"
                    },
                    {
                        "id": 146707,
                        "name": "Șeulia de Mureș",
                        "latitude": "46.41588800",
                        "longitude": "24.24719600"
                    },
                    {
                        "id": 146584,
                        "name": "Sfântu Gheorghe",
                        "latitude": "46.45355000",
                        "longitude": "24.26593500"
                    },
                    {
                        "id": 146585,
                        "name": "Sicele",
                        "latitude": "46.69435400",
                        "longitude": "24.29203800"
                    },
                    {
                        "id": 146586,
                        "name": "Sighișoara",
                        "latitude": "46.21694444",
                        "longitude": "24.79111111"
                    },
                    {
                        "id": 146708,
                        "name": "Șilea Nirajului",
                        "latitude": "46.59887300",
                        "longitude": "24.92319300"
                    },
                    {
                        "id": 146709,
                        "name": "Șincai",
                        "latitude": "46.66341000",
                        "longitude": "24.37640000"
                    },
                    {
                        "id": 146710,
                        "name": "Șincai-Fânațe",
                        "latitude": "46.65494100",
                        "longitude": "24.33687400"
                    },
                    {
                        "id": 146711,
                        "name": "Șoard",
                        "latitude": "46.26301500",
                        "longitude": "24.92628200"
                    },
                    {
                        "id": 146587,
                        "name": "Socolu de Câmpie",
                        "latitude": "46.79141500",
                        "longitude": "24.51575300"
                    },
                    {
                        "id": 146712,
                        "name": "Șoimuș",
                        "latitude": "46.39387700",
                        "longitude": "24.58703200"
                    },
                    {
                        "id": 146588,
                        "name": "Solocma",
                        "latitude": "46.47591700",
                        "longitude": "24.99525900"
                    },
                    {
                        "id": 146589,
                        "name": "Solovăstru",
                        "latitude": "46.77000000",
                        "longitude": "24.77000000"
                    },
                    {
                        "id": 146713,
                        "name": "Șomoștelnic",
                        "latitude": "46.39175000",
                        "longitude": "24.38529700"
                    },
                    {
                        "id": 146714,
                        "name": "Șoromiclea",
                        "latitude": "46.26024500",
                        "longitude": "24.77110000"
                    },
                    {
                        "id": 146590,
                        "name": "Sovata",
                        "latitude": "46.59611111",
                        "longitude": "25.07444444"
                    },
                    {
                        "id": 146593,
                        "name": "Stânceni",
                        "latitude": "46.98000000",
                        "longitude": "25.23000000"
                    },
                    {
                        "id": 146715,
                        "name": "Ștefanca",
                        "latitude": "46.68570600",
                        "longitude": "24.23161500"
                    },
                    {
                        "id": 146716,
                        "name": "Ștefăneaca",
                        "latitude": "46.61190300",
                        "longitude": "24.11069200"
                    },
                    {
                        "id": 146592,
                        "name": "Stejărenii",
                        "latitude": "46.15367200",
                        "longitude": "24.72434500"
                    },
                    {
                        "id": 146591,
                        "name": "Stejeriș",
                        "latitude": "46.47889700",
                        "longitude": "24.61642100"
                    },
                    {
                        "id": 146594,
                        "name": "Sub Pădure",
                        "latitude": "46.37013700",
                        "longitude": "24.32634000"
                    },
                    {
                        "id": 146595,
                        "name": "Suplac",
                        "latitude": "46.38333333",
                        "longitude": "24.51666667"
                    },
                    {
                        "id": 146596,
                        "name": "Suseni",
                        "latitude": "46.81437100",
                        "longitude": "24.73169500"
                    },
                    {
                        "id": 146597,
                        "name": "Suveica",
                        "latitude": "46.43351900",
                        "longitude": "24.71653800"
                    },
                    {
                        "id": 146645,
                        "name": "Tăblășeni",
                        "latitude": "46.51762600",
                        "longitude": "24.30666900"
                    },
                    {
                        "id": 146642,
                        "name": "Tâmpa",
                        "latitude": "46.53019200",
                        "longitude": "24.76634600"
                    },
                    {
                        "id": 146643,
                        "name": "Târgu Mureș",
                        "latitude": "46.54972222",
                        "longitude": "24.55972222"
                    },
                    {
                        "id": 146644,
                        "name": "Târnăveni",
                        "latitude": "46.32628000",
                        "longitude": "24.28540000"
                    },
                    {
                        "id": 146646,
                        "name": "Tău",
                        "latitude": "46.59441600",
                        "longitude": "24.15418800"
                    },
                    {
                        "id": 146647,
                        "name": "Tăureni",
                        "latitude": "46.58333333",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 146628,
                        "name": "Teleac",
                        "latitude": "46.67222222",
                        "longitude": "24.79166667"
                    },
                    {
                        "id": 146720,
                        "name": "Țigmandru",
                        "latitude": "46.35000000",
                        "longitude": "24.71666667"
                    },
                    {
                        "id": 146721,
                        "name": "Țiptelnic",
                        "latitude": "46.58462100",
                        "longitude": "24.41422800"
                    },
                    {
                        "id": 146629,
                        "name": "Tireu",
                        "latitude": "46.76660800",
                        "longitude": "24.99456200"
                    },
                    {
                        "id": 146630,
                        "name": "Tirimia",
                        "latitude": "46.44927300",
                        "longitude": "24.49162200"
                    },
                    {
                        "id": 146631,
                        "name": "Tirimioara",
                        "latitude": "46.45462800",
                        "longitude": "24.54789400"
                    },
                    {
                        "id": 146632,
                        "name": "Tisieu",
                        "latitude": "46.76559400",
                        "longitude": "25.01258300"
                    },
                    {
                        "id": 146633,
                        "name": "Titiana",
                        "latitude": "46.73168900",
                        "longitude": "24.18650000"
                    },
                    {
                        "id": 146634,
                        "name": "Toaca",
                        "latitude": "46.79860900",
                        "longitude": "24.96550400"
                    },
                    {
                        "id": 146635,
                        "name": "Tofalău",
                        "latitude": "46.58706100",
                        "longitude": "24.65770500"
                    },
                    {
                        "id": 146636,
                        "name": "Toldal",
                        "latitude": "46.70509200",
                        "longitude": "24.58155000"
                    },
                    {
                        "id": 146637,
                        "name": "Tonciu",
                        "latitude": "46.78025200",
                        "longitude": "24.55201300"
                    },
                    {
                        "id": 146722,
                        "name": "Țopa",
                        "latitude": "46.25444700",
                        "longitude": "24.88161900"
                    },
                    {
                        "id": 146638,
                        "name": "Torba",
                        "latitude": "46.54745800",
                        "longitude": "24.88758400"
                    },
                    {
                        "id": 146639,
                        "name": "Trei Sate",
                        "latitude": "46.47630600",
                        "longitude": "24.89778900"
                    },
                    {
                        "id": 146640,
                        "name": "Troița",
                        "latitude": "46.48442300",
                        "longitude": "24.76977400"
                    },
                    {
                        "id": 146641,
                        "name": "Tușinu",
                        "latitude": "46.73331200",
                        "longitude": "24.22759300"
                    },
                    {
                        "id": 146648,
                        "name": "Uila",
                        "latitude": "46.93055556",
                        "longitude": "24.61805556"
                    },
                    {
                        "id": 146649,
                        "name": "Ulieș",
                        "latitude": "46.73348000",
                        "longitude": "24.33354800"
                    },
                    {
                        "id": 146650,
                        "name": "Ungheni",
                        "latitude": "46.48583333",
                        "longitude": "24.46083333"
                    },
                    {
                        "id": 146651,
                        "name": "Uricea",
                        "latitude": "46.78384900",
                        "longitude": "24.98407300"
                    },
                    {
                        "id": 146652,
                        "name": "Urisiu de Jos",
                        "latitude": "46.71085300",
                        "longitude": "24.89609000"
                    },
                    {
                        "id": 146653,
                        "name": "Urisiu de Sus",
                        "latitude": "46.70622300",
                        "longitude": "24.91108700"
                    },
                    {
                        "id": 146654,
                        "name": "Ursoaia",
                        "latitude": "46.54948600",
                        "longitude": "24.22471300"
                    },
                    {
                        "id": 146690,
                        "name": "Vădaș",
                        "latitude": "46.45589800",
                        "longitude": "24.81939400"
                    },
                    {
                        "id": 146655,
                        "name": "Vadu",
                        "latitude": "46.60812200",
                        "longitude": "24.78187700"
                    },
                    {
                        "id": 146656,
                        "name": "Vaidacuta",
                        "latitude": "46.41906200",
                        "longitude": "24.52626400"
                    },
                    {
                        "id": 146657,
                        "name": "Vaideiu",
                        "latitude": "46.49534200",
                        "longitude": "24.32084000"
                    },
                    {
                        "id": 146658,
                        "name": "Valea",
                        "latitude": "46.56328700",
                        "longitude": "24.79691400"
                    },
                    {
                        "id": 146659,
                        "name": "Valea Albeștiului",
                        "latitude": "46.21461700",
                        "longitude": "24.84833800"
                    },
                    {
                        "id": 146660,
                        "name": "Valea Dăii",
                        "latitude": "46.22569300",
                        "longitude": "24.89612400"
                    },
                    {
                        "id": 146661,
                        "name": "Valea Frăției",
                        "latitude": "46.64504900",
                        "longitude": "24.06656500"
                    },
                    {
                        "id": 146662,
                        "name": "Valea Glodului",
                        "latitude": "46.64699400",
                        "longitude": "24.08480800"
                    },
                    {
                        "id": 146663,
                        "name": "Valea Iclandului",
                        "latitude": "46.53439200",
                        "longitude": "24.25391100"
                    },
                    {
                        "id": 146664,
                        "name": "Valea Izvoarelor",
                        "latitude": "46.43855300",
                        "longitude": "24.37597400"
                    },
                    {
                        "id": 146665,
                        "name": "Valea Largă",
                        "latitude": "46.62000000",
                        "longitude": "24.07000000"
                    },
                    {
                        "id": 146666,
                        "name": "Valea Mare",
                        "latitude": "46.63761900",
                        "longitude": "24.30019400"
                    },
                    {
                        "id": 146667,
                        "name": "Valea Pădurii",
                        "latitude": "46.61968600",
                        "longitude": "24.05370200"
                    },
                    {
                        "id": 146668,
                        "name": "Valea Rece",
                        "latitude": "46.57106800",
                        "longitude": "24.33606500"
                    },
                    {
                        "id": 146671,
                        "name": "Valea Sânmărtinului",
                        "latitude": "46.74316600",
                        "longitude": "24.33757900"
                    },
                    {
                        "id": 146672,
                        "name": "Valea Sânpetrului",
                        "latitude": "46.62258200",
                        "longitude": "24.28666100"
                    },
                    {
                        "id": 146676,
                        "name": "Valea Șapartocului",
                        "latitude": "46.20599700",
                        "longitude": "24.84857400"
                    },
                    {
                        "id": 146669,
                        "name": "Valea Sasului",
                        "latitude": "46.82271600",
                        "longitude": "24.48454000"
                    },
                    {
                        "id": 146670,
                        "name": "Valea Seacă",
                        "latitude": "46.74536500",
                        "longitude": "24.40752500"
                    },
                    {
                        "id": 146677,
                        "name": "Valea Șurii",
                        "latitude": "46.63676400",
                        "longitude": "24.05260900"
                    },
                    {
                        "id": 146673,
                        "name": "Valea Ulieșului",
                        "latitude": "46.73656700",
                        "longitude": "24.36880600"
                    },
                    {
                        "id": 146674,
                        "name": "Valea Ungurului",
                        "latitude": "46.80499200",
                        "longitude": "24.48055400"
                    },
                    {
                        "id": 146675,
                        "name": "Valea Urieșului",
                        "latitude": "46.63004600",
                        "longitude": "24.08490200"
                    },
                    {
                        "id": 146691,
                        "name": "Văleni",
                        "latitude": "46.66275900",
                        "longitude": "24.27123700"
                    },
                    {
                        "id": 146692,
                        "name": "Vălenii",
                        "latitude": "46.44691400",
                        "longitude": "24.64708600"
                    },
                    {
                        "id": 146693,
                        "name": "Vălenii de Mureș",
                        "latitude": "46.89274400",
                        "longitude": "24.79792600"
                    },
                    {
                        "id": 146694,
                        "name": "Vălișoara",
                        "latitude": "46.53172600",
                        "longitude": "24.19993200"
                    },
                    {
                        "id": 146695,
                        "name": "Vălureni",
                        "latitude": "46.50021400",
                        "longitude": "24.54600700"
                    },
                    {
                        "id": 146689,
                        "name": "Vânători",
                        "latitude": "46.24113400",
                        "longitude": "24.92259400"
                    },
                    {
                        "id": 146696,
                        "name": "Vărgata",
                        "latitude": "46.56666667",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 146697,
                        "name": "Vătava",
                        "latitude": "46.96109300",
                        "longitude": "24.76506800"
                    },
                    {
                        "id": 146678,
                        "name": "Venchi",
                        "latitude": "46.24552300",
                        "longitude": "24.74306200"
                    },
                    {
                        "id": 146679,
                        "name": "Veța",
                        "latitude": "46.56007300",
                        "longitude": "24.72308300"
                    },
                    {
                        "id": 146680,
                        "name": "Vețca",
                        "latitude": "46.35000000",
                        "longitude": "24.78333333"
                    },
                    {
                        "id": 146681,
                        "name": "Vidrasău",
                        "latitude": "46.47483400",
                        "longitude": "24.41266200"
                    },
                    {
                        "id": 146682,
                        "name": "Viforoasa",
                        "latitude": "46.43189400",
                        "longitude": "24.80981600"
                    },
                    {
                        "id": 146683,
                        "name": "Viilor",
                        "latitude": "46.23755800",
                        "longitude": "24.80933300"
                    },
                    {
                        "id": 146684,
                        "name": "Viișoara",
                        "latitude": "46.28000000",
                        "longitude": "24.60000000"
                    },
                    {
                        "id": 146685,
                        "name": "Vișinelu",
                        "latitude": "46.73790000",
                        "longitude": "24.10240000"
                    },
                    {
                        "id": 146686,
                        "name": "Voiniceni",
                        "latitude": "46.61371800",
                        "longitude": "24.52496800"
                    },
                    {
                        "id": 146687,
                        "name": "Voivodeni",
                        "latitude": "46.70000000",
                        "longitude": "24.63333333"
                    },
                    {
                        "id": 146688,
                        "name": "Vulcan",
                        "latitude": "46.14891700",
                        "longitude": "24.85367000"
                    },
                    {
                        "id": 146698,
                        "name": "Zagăr",
                        "latitude": "46.35083333",
                        "longitude": "24.61638889"
                    },
                    {
                        "id": 146701,
                        "name": "Zăpodea",
                        "latitude": "46.54057000",
                        "longitude": "24.11751200"
                    },
                    {
                        "id": 146699,
                        "name": "Zau de Câmpie",
                        "latitude": "46.60000000",
                        "longitude": "24.13000000"
                    },
                    {
                        "id": 146700,
                        "name": "Zimți",
                        "latitude": "46.75979000",
                        "longitude": "25.04912200"
                    }
                ]
            },
            {
                "id": 4731,
                "name": "Neamț",
                "iso2": "NT",
                "latitude": "46.97586850",
                "longitude": "26.38187640",
                "type": "department",
                "cities": [
                    {
                        "id": 89882,
                        "name": "Adjudeni",
                        "latitude": "47.01408000",
                        "longitude": "26.94903000"
                    },
                    {
                        "id": 89892,
                        "name": "Agapia",
                        "latitude": "47.16667000",
                        "longitude": "26.28333000"
                    },
                    {
                        "id": 90026,
                        "name": "Bahna",
                        "latitude": "46.78333000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 90527,
                        "name": "Bălţăteşti",
                        "latitude": "47.11667000",
                        "longitude": "26.30000000"
                    },
                    {
                        "id": 90518,
                        "name": "Bălușești",
                        "latitude": "46.81591000",
                        "longitude": "26.99885000"
                    },
                    {
                        "id": 90445,
                        "name": "Bâra",
                        "latitude": "47.03333000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 90543,
                        "name": "Bărcăneşti",
                        "latitude": "46.71667000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 90448,
                        "name": "Bârgăuani",
                        "latitude": "46.98333000",
                        "longitude": "26.63333000"
                    },
                    {
                        "id": 90062,
                        "name": "Barticești",
                        "latitude": "47.06324000",
                        "longitude": "26.79254000"
                    },
                    {
                        "id": 90126,
                        "name": "Bicaz",
                        "latitude": "46.91667000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 90127,
                        "name": "Bicaz-Chei",
                        "latitude": "46.81667000",
                        "longitude": "25.88333000"
                    },
                    {
                        "id": 90128,
                        "name": "Bicazu Ardelean",
                        "latitude": "46.85000000",
                        "longitude": "25.93333000"
                    },
                    {
                        "id": 90151,
                        "name": "Bistrița",
                        "latitude": "46.94856000",
                        "longitude": "26.29598000"
                    },
                    {
                        "id": 90170,
                        "name": "Boboiești",
                        "latitude": "47.25370000",
                        "longitude": "26.03749000"
                    },
                    {
                        "id": 90180,
                        "name": "Bodeşti",
                        "latitude": "47.03333000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 90182,
                        "name": "Bodeștii de Jos",
                        "latitude": "47.02752000",
                        "longitude": "26.44483000"
                    },
                    {
                        "id": 90198,
                        "name": "Boghicea",
                        "latitude": "47.05414000",
                        "longitude": "27.06935000"
                    },
                    {
                        "id": 90220,
                        "name": "Borca",
                        "latitude": "47.18333000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 90228,
                        "name": "Borleşti",
                        "latitude": "46.76667000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 90243,
                        "name": "Botești",
                        "latitude": "47.05200000",
                        "longitude": "26.74863000"
                    },
                    {
                        "id": 90252,
                        "name": "Bozieni",
                        "latitude": "46.83333000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 90315,
                        "name": "Brusturi",
                        "latitude": "47.28333000",
                        "longitude": "26.38333000"
                    },
                    {
                        "id": 90384,
                        "name": "Budești",
                        "latitude": "46.94084000",
                        "longitude": "26.71177000"
                    },
                    {
                        "id": 90422,
                        "name": "Buruienești",
                        "latitude": "46.99595000",
                        "longitude": "26.97732000"
                    },
                    {
                        "id": 93807,
                        "name": "Cândeşti",
                        "latitude": "46.71667000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 90599,
                        "name": "Ceahlău",
                        "latitude": "47.05000000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 90667,
                        "name": "Chilii",
                        "latitude": "46.80254000",
                        "longitude": "27.03394000"
                    },
                    {
                        "id": 90670,
                        "name": "Chintinici",
                        "latitude": "46.82754000",
                        "longitude": "26.49339000"
                    },
                    {
                        "id": 90829,
                        "name": "Comuna Agapia",
                        "latitude": "47.16196000",
                        "longitude": "26.29545000"
                    },
                    {
                        "id": 90847,
                        "name": "Comuna Alexandru Cel Bun",
                        "latitude": "46.93988000",
                        "longitude": "26.26849000"
                    },
                    {
                        "id": 90915,
                        "name": "Comuna Bahna",
                        "latitude": "46.77860000",
                        "longitude": "26.79742000"
                    },
                    {
                        "id": 91229,
                        "name": "Comuna Bălţăteşti",
                        "latitude": "47.13076000",
                        "longitude": "26.30187000"
                    },
                    {
                        "id": 91184,
                        "name": "Comuna Bâra",
                        "latitude": "47.01319000",
                        "longitude": "27.04016000"
                    },
                    {
                        "id": 91187,
                        "name": "Comuna Bârgãuani",
                        "latitude": "46.97877000",
                        "longitude": "26.64589000"
                    },
                    {
                        "id": 90983,
                        "name": "Comuna Bicaz Chei",
                        "latitude": "46.83435000",
                        "longitude": "25.87234000"
                    },
                    {
                        "id": 90984,
                        "name": "Comuna Bicazu Ardelean",
                        "latitude": "46.86884000",
                        "longitude": "25.92570000"
                    },
                    {
                        "id": 91018,
                        "name": "Comuna Bodeşti-Precista",
                        "latitude": "47.03819000",
                        "longitude": "26.43790000"
                    },
                    {
                        "id": 91031,
                        "name": "Comuna Boghicea",
                        "latitude": "47.06025000",
                        "longitude": "27.11082000"
                    },
                    {
                        "id": 91045,
                        "name": "Comuna Borca",
                        "latitude": "47.19099000",
                        "longitude": "25.78140000"
                    },
                    {
                        "id": 91050,
                        "name": "Comuna Borleşti",
                        "latitude": "46.78934000",
                        "longitude": "26.49080000"
                    },
                    {
                        "id": 91060,
                        "name": "Comuna Boteşti",
                        "latitude": "47.06415000",
                        "longitude": "26.75969000"
                    },
                    {
                        "id": 91066,
                        "name": "Comuna Bozieni",
                        "latitude": "46.84446000",
                        "longitude": "27.15282000"
                    },
                    {
                        "id": 91107,
                        "name": "Comuna Brusturi-Drăgăneşti",
                        "latitude": "47.29579000",
                        "longitude": "26.35443000"
                    },
                    {
                        "id": 91546,
                        "name": "Comuna Cândeşti",
                        "latitude": "46.71667000",
                        "longitude": "26.58333000"
                    },
                    {
                        "id": 91271,
                        "name": "Comuna Ceahlău",
                        "latitude": "47.04488000",
                        "longitude": "25.95955000"
                    },
                    {
                        "id": 91432,
                        "name": "Comuna Cordun",
                        "latitude": "46.97290000",
                        "longitude": "26.86265000"
                    },
                    {
                        "id": 91460,
                        "name": "Comuna Costişa",
                        "latitude": "46.75818000",
                        "longitude": "26.64623000"
                    },
                    {
                        "id": 91517,
                        "name": "Comuna Crăcăoani",
                        "latitude": "47.09597000",
                        "longitude": "26.25865000"
                    },
                    {
                        "id": 91735,
                        "name": "Comuna Dămuc",
                        "latitude": "46.75621000",
                        "longitude": "25.89219000"
                    },
                    {
                        "id": 91634,
                        "name": "Comuna Dobreni",
                        "latitude": "46.99482000",
                        "longitude": "26.40941000"
                    },
                    {
                        "id": 91648,
                        "name": "Comuna Dochia",
                        "latitude": "46.91740000",
                        "longitude": "26.58485000"
                    },
                    {
                        "id": 91656,
                        "name": "Comuna Doljeşti",
                        "latitude": "47.02806000",
                        "longitude": "26.97557000"
                    },
                    {
                        "id": 91701,
                        "name": "Comuna Drăgăneşti",
                        "latitude": "47.31204000",
                        "longitude": "26.41550000"
                    },
                    {
                        "id": 91674,
                        "name": "Comuna Dragomireşti",
                        "latitude": "47.02798000",
                        "longitude": "26.57536000"
                    },
                    {
                        "id": 91709,
                        "name": "Comuna Dulceşti",
                        "latitude": "46.98346000",
                        "longitude": "26.78062000"
                    },
                    {
                        "id": 91713,
                        "name": "Comuna Dumbrava Roşie",
                        "latitude": "46.88535000",
                        "longitude": "26.44117000"
                    },
                    {
                        "id": 91823,
                        "name": "Comuna Fărcaşa",
                        "latitude": "47.15272000",
                        "longitude": "25.84880000"
                    },
                    {
                        "id": 91817,
                        "name": "Comuna Fãurei",
                        "latitude": "46.91528000",
                        "longitude": "26.71834000"
                    },
                    {
                        "id": 91961,
                        "name": "Comuna Gâdinţi",
                        "latitude": "46.93708000",
                        "longitude": "27.00588000"
                    },
                    {
                        "id": 91969,
                        "name": "Comuna Gârcina",
                        "latitude": "46.99222000",
                        "longitude": "26.32820000"
                    },
                    {
                        "id": 91848,
                        "name": "Comuna Gherăeşti",
                        "latitude": "47.03620000",
                        "longitude": "26.82009000"
                    },
                    {
                        "id": 91859,
                        "name": "Comuna Ghindăoani",
                        "latitude": "47.10983000",
                        "longitude": "26.33909000"
                    },
                    {
                        "id": 91872,
                        "name": "Comuna Girov",
                        "latitude": "46.94918000",
                        "longitude": "26.48244000"
                    },
                    {
                        "id": 91919,
                        "name": "Comuna Grinţieş",
                        "latitude": "47.02472000",
                        "longitude": "25.87636000"
                    },
                    {
                        "id": 91932,
                        "name": "Comuna Grumăzeşti",
                        "latitude": "47.14727000",
                        "longitude": "26.38641000"
                    },
                    {
                        "id": 91992,
                        "name": "Comuna Hangu",
                        "latitude": "47.03525000",
                        "longitude": "26.06400000"
                    },
                    {
                        "id": 92019,
                        "name": "Comuna Horia",
                        "latitude": "46.90639000",
                        "longitude": "26.93891000"
                    },
                    {
                        "id": 92061,
                        "name": "Comuna Icuseşti",
                        "latitude": "46.79894000",
                        "longitude": "26.99076000"
                    },
                    {
                        "id": 92082,
                        "name": "Comuna Ion Creangă",
                        "latitude": "46.86069000",
                        "longitude": "27.00358000"
                    },
                    {
                        "id": 92407,
                        "name": "Comuna Mărgineni",
                        "latitude": "46.89237000",
                        "longitude": "26.65742000"
                    },
                    {
                        "id": 92327,
                        "name": "Comuna Moldoveni",
                        "latitude": "46.82131000",
                        "longitude": "26.78791000"
                    },
                    {
                        "id": 92432,
                        "name": "Comuna Negreşti",
                        "latitude": "47.04779000",
                        "longitude": "26.35005000"
                    },
                    {
                        "id": 92501,
                        "name": "Comuna Oniceni",
                        "latitude": "46.78926000",
                        "longitude": "27.16336000"
                    },
                    {
                        "id": 92703,
                        "name": "Comuna Pânceşti",
                        "latitude": "46.90170000",
                        "longitude": "27.16879000"
                    },
                    {
                        "id": 92704,
                        "name": "Comuna Pângăraţi",
                        "latitude": "46.93333000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 92722,
                        "name": "Comuna Păstrăveni",
                        "latitude": "47.15940000",
                        "longitude": "26.57615000"
                    },
                    {
                        "id": 92565,
                        "name": "Comuna Petricani",
                        "latitude": "47.15304000",
                        "longitude": "26.44114000"
                    },
                    {
                        "id": 92574,
                        "name": "Comuna Piatra Şoimului",
                        "latitude": "46.82443000",
                        "longitude": "26.41848000"
                    },
                    {
                        "id": 92585,
                        "name": "Comuna Pipirig",
                        "latitude": "47.22800000",
                        "longitude": "26.08483000"
                    },
                    {
                        "id": 92615,
                        "name": "Comuna Podoleni",
                        "latitude": "46.81772000",
                        "longitude": "26.63280000"
                    },
                    {
                        "id": 92633,
                        "name": "Comuna Poiana Teiului",
                        "latitude": "47.11403000",
                        "longitude": "25.92517000"
                    },
                    {
                        "id": 92635,
                        "name": "Comuna Poienari",
                        "latitude": "46.88625000",
                        "longitude": "27.11966000"
                    },
                    {
                        "id": 92852,
                        "name": "Comuna Răuceşti",
                        "latitude": "47.26151000",
                        "longitude": "26.41170000"
                    },
                    {
                        "id": 92832,
                        "name": "Comuna Rãzboieni",
                        "latitude": "47.07424000",
                        "longitude": "26.56150000"
                    },
                    {
                        "id": 92759,
                        "name": "Comuna Rediu",
                        "latitude": "46.75000000",
                        "longitude": "26.56667000"
                    },
                    {
                        "id": 92788,
                        "name": "Comuna Români",
                        "latitude": "46.80242000",
                        "longitude": "26.69945000"
                    },
                    {
                        "id": 92809,
                        "name": "Comuna Ruginoasa",
                        "latitude": "46.97447000",
                        "longitude": "26.70674000"
                    },
                    {
                        "id": 93078,
                        "name": "Comuna Săbăoani",
                        "latitude": "47.00187000",
                        "longitude": "26.88525000"
                    },
                    {
                        "id": 92862,
                        "name": "Comuna Sagna",
                        "latitude": "46.96806000",
                        "longitude": "27.01670000"
                    },
                    {
                        "id": 93117,
                        "name": "Comuna Săvineşti",
                        "latitude": "46.86469000",
                        "longitude": "26.48400000"
                    },
                    {
                        "id": 92914,
                        "name": "Comuna Secuieni",
                        "latitude": "46.86853000",
                        "longitude": "26.81062000"
                    },
                    {
                        "id": 93021,
                        "name": "Comuna Stăniţa",
                        "latitude": "47.01216000",
                        "longitude": "27.13704000"
                    },
                    {
                        "id": 93551,
                        "name": "Comuna Ştefan cel Mare",
                        "latitude": "46.98599000",
                        "longitude": "26.51293000"
                    },
                    {
                        "id": 93237,
                        "name": "Comuna Tămăşeni",
                        "latitude": "47.00327000",
                        "longitude": "26.95087000"
                    },
                    {
                        "id": 93126,
                        "name": "Comuna Tarcău",
                        "latitude": "46.82269000",
                        "longitude": "26.16264000"
                    },
                    {
                        "id": 93130,
                        "name": "Comuna Taşca",
                        "latitude": "46.88991000",
                        "longitude": "26.01069000"
                    },
                    {
                        "id": 93129,
                        "name": "Comuna Tazlău",
                        "latitude": "46.72098000",
                        "longitude": "26.47003000"
                    },
                    {
                        "id": 93571,
                        "name": "Comuna Ţibucani",
                        "latitude": "47.11856000",
                        "longitude": "26.57350000"
                    },
                    {
                        "id": 93155,
                        "name": "Comuna Timişeşti",
                        "latitude": "47.22939000",
                        "longitude": "26.51982000"
                    },
                    {
                        "id": 93192,
                        "name": "Comuna Trifeşti",
                        "latitude": "46.90906000",
                        "longitude": "26.83311000"
                    },
                    {
                        "id": 93208,
                        "name": "Comuna Tupilaţi",
                        "latitude": "47.08147000",
                        "longitude": "26.64158000"
                    },
                    {
                        "id": 93280,
                        "name": "Comuna Urecheni",
                        "latitude": "47.17764000",
                        "longitude": "26.53424000"
                    },
                    {
                        "id": 93327,
                        "name": "Comuna Valea Ursului",
                        "latitude": "46.79452000",
                        "longitude": "27.08166000"
                    },
                    {
                        "id": 93458,
                        "name": "Comuna Văleni",
                        "latitude": "47.02964000",
                        "longitude": "26.71532000"
                    },
                    {
                        "id": 93436,
                        "name": "Comuna Vânători Neamţ",
                        "latitude": "47.23534000",
                        "longitude": "26.27700000"
                    },
                    {
                        "id": 93486,
                        "name": "Comuna Zăneşti",
                        "latitude": "46.82573000",
                        "longitude": "26.56213000"
                    },
                    {
                        "id": 93623,
                        "name": "Cordun",
                        "latitude": "46.95000000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 93668,
                        "name": "Costişa",
                        "latitude": "46.75000000",
                        "longitude": "26.65000000"
                    },
                    {
                        "id": 93677,
                        "name": "Cotu Vameș",
                        "latitude": "46.90600000",
                        "longitude": "26.95535000"
                    },
                    {
                        "id": 93753,
                        "name": "Crăcăoani",
                        "latitude": "47.09836000",
                        "longitude": "26.31111000"
                    },
                    {
                        "id": 93702,
                        "name": "Cracăul Negru",
                        "latitude": "47.09363000",
                        "longitude": "26.24061000"
                    },
                    {
                        "id": 93764,
                        "name": "Cuejdiu",
                        "latitude": "46.99040000",
                        "longitude": "26.29455000"
                    },
                    {
                        "id": 93781,
                        "name": "Cut",
                        "latitude": "46.88258000",
                        "longitude": "26.41928000"
                    },
                    {
                        "id": 94121,
                        "name": "Dămuc",
                        "latitude": "46.80000000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 93951,
                        "name": "Dobreni",
                        "latitude": "46.98333000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 93974,
                        "name": "Dochia",
                        "latitude": "46.90731000",
                        "longitude": "26.56763000"
                    },
                    {
                        "id": 93976,
                        "name": "Dodeni",
                        "latitude": "46.92587000",
                        "longitude": "26.09277000"
                    },
                    {
                        "id": 93984,
                        "name": "Dolhești",
                        "latitude": "47.21189000",
                        "longitude": "26.06738000"
                    },
                    {
                        "id": 93987,
                        "name": "Doljeşti",
                        "latitude": "47.03333000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 94063,
                        "name": "Drăgănești",
                        "latitude": "47.30886000",
                        "longitude": "26.40551000"
                    },
                    {
                        "id": 94015,
                        "name": "Dragomireşti",
                        "latitude": "47.01667000",
                        "longitude": "26.53333000"
                    },
                    {
                        "id": 94073,
                        "name": "Dulceşti",
                        "latitude": "46.96667000",
                        "longitude": "26.76667000"
                    },
                    {
                        "id": 94080,
                        "name": "Dumbrava",
                        "latitude": "47.21620000",
                        "longitude": "26.46309000"
                    },
                    {
                        "id": 94081,
                        "name": "Dumbrava Roşie",
                        "latitude": "46.88333000",
                        "longitude": "26.43333000"
                    },
                    {
                        "id": 94260,
                        "name": "Fărcaşa",
                        "latitude": "47.16667000",
                        "longitude": "25.83333000"
                    },
                    {
                        "id": 94270,
                        "name": "Făurei",
                        "latitude": "46.91667000",
                        "longitude": "26.68333000"
                    },
                    {
                        "id": 94173,
                        "name": "Filioara",
                        "latitude": "47.16040000",
                        "longitude": "26.27920000"
                    },
                    {
                        "id": 94476,
                        "name": "Gâdinţi",
                        "latitude": "46.93333000",
                        "longitude": "27.01667000"
                    },
                    {
                        "id": 94487,
                        "name": "Gârcina",
                        "latitude": "46.97691000",
                        "longitude": "26.34573000"
                    },
                    {
                        "id": 94312,
                        "name": "Gherăeşti",
                        "latitude": "47.01667000",
                        "longitude": "26.81667000"
                    },
                    {
                        "id": 94328,
                        "name": "Ghindăoani",
                        "latitude": "47.10983000",
                        "longitude": "26.33909000"
                    },
                    {
                        "id": 94348,
                        "name": "Girov",
                        "latitude": "46.95000000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 94397,
                        "name": "Goșmani",
                        "latitude": "46.83620000",
                        "longitude": "26.71522000"
                    },
                    {
                        "id": 94414,
                        "name": "Grinţieş",
                        "latitude": "47.05000000",
                        "longitude": "25.86667000"
                    },
                    {
                        "id": 94431,
                        "name": "Grumăzeşti",
                        "latitude": "47.13333000",
                        "longitude": "26.36667000"
                    },
                    {
                        "id": 94522,
                        "name": "Hangu",
                        "latitude": "47.05000000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 94539,
                        "name": "Hlăpești",
                        "latitude": "47.03817000",
                        "longitude": "26.59842000"
                    },
                    {
                        "id": 94541,
                        "name": "Hociungi",
                        "latitude": "46.81311000",
                        "longitude": "26.77596000"
                    },
                    {
                        "id": 94563,
                        "name": "Horia",
                        "latitude": "46.90698000",
                        "longitude": "26.91919000"
                    },
                    {
                        "id": 94577,
                        "name": "Humulești",
                        "latitude": "47.19846000",
                        "longitude": "26.35273000"
                    },
                    {
                        "id": 94637,
                        "name": "Icuseşti",
                        "latitude": "46.80000000",
                        "longitude": "26.93333000"
                    },
                    {
                        "id": 94674,
                        "name": "Ion Creangă",
                        "latitude": "46.87029000",
                        "longitude": "26.98023000"
                    },
                    {
                        "id": 94703,
                        "name": "Izvoare",
                        "latitude": "46.74699000",
                        "longitude": "26.80221000"
                    },
                    {
                        "id": 94850,
                        "name": "Luminiș",
                        "latitude": "46.81332000",
                        "longitude": "26.45275000"
                    },
                    {
                        "id": 94855,
                        "name": "Lunca",
                        "latitude": "47.22765000",
                        "longitude": "26.29979000"
                    },
                    {
                        "id": 95268,
                        "name": "Mărgineni",
                        "latitude": "46.90000000",
                        "longitude": "26.63333000"
                    },
                    {
                        "id": 94933,
                        "name": "Mastacăn",
                        "latitude": "46.78918000",
                        "longitude": "26.48677000"
                    },
                    {
                        "id": 95018,
                        "name": "Miron Costin",
                        "latitude": "46.92030000",
                        "longitude": "26.80567000"
                    },
                    {
                        "id": 95066,
                        "name": "Moldoveni",
                        "latitude": "46.83333000",
                        "longitude": "26.76667000"
                    },
                    {
                        "id": 95168,
                        "name": "Municipiul Piatra-Neamţ",
                        "latitude": "46.92336000",
                        "longitude": "26.37380000"
                    },
                    {
                        "id": 95172,
                        "name": "Municipiul Roman",
                        "latitude": "46.92973000",
                        "longitude": "26.93678000"
                    },
                    {
                        "id": 95318,
                        "name": "Negrești",
                        "latitude": "47.02938000",
                        "longitude": "26.37958000"
                    },
                    {
                        "id": 95326,
                        "name": "Nemțișor",
                        "latitude": "47.23962000",
                        "longitude": "26.27209000"
                    },
                    {
                        "id": 95349,
                        "name": "Nisiporești",
                        "latitude": "47.07720000",
                        "longitude": "26.73791000"
                    },
                    {
                        "id": 95380,
                        "name": "Oanțu",
                        "latitude": "46.90970000",
                        "longitude": "26.19887000"
                    },
                    {
                        "id": 95413,
                        "name": "Oglinzi",
                        "latitude": "47.25055000",
                        "longitude": "26.35026000"
                    },
                    {
                        "id": 95441,
                        "name": "Oniceni",
                        "latitude": "46.81667000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 95463,
                        "name": "Oraş Bicaz",
                        "latitude": "46.94890000",
                        "longitude": "26.07982000"
                    },
                    {
                        "id": 95579,
                        "name": "Oraş Roznov",
                        "latitude": "46.83850000",
                        "longitude": "26.51277000"
                    },
                    {
                        "id": 95608,
                        "name": "Oraş Târgu Neamţ",
                        "latitude": "47.19698000",
                        "longitude": "26.36414000"
                    },
                    {
                        "id": 95993,
                        "name": "Pânceşti",
                        "latitude": "46.90296000",
                        "longitude": "27.15314000"
                    },
                    {
                        "id": 95996,
                        "name": "Pângărăcior",
                        "latitude": "46.93333000",
                        "longitude": "26.21667000"
                    },
                    {
                        "id": 95995,
                        "name": "Pângăraţi",
                        "latitude": "46.93333000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 96022,
                        "name": "Păstrăveni",
                        "latitude": "47.16667000",
                        "longitude": "26.56667000"
                    },
                    {
                        "id": 95751,
                        "name": "Petricani",
                        "latitude": "47.16667000",
                        "longitude": "26.46667000"
                    },
                    {
                        "id": 95771,
                        "name": "Piatra Neamţ",
                        "latitude": "46.91667000",
                        "longitude": "26.33333000"
                    },
                    {
                        "id": 95773,
                        "name": "Piatra Şoimului",
                        "latitude": "46.83333000",
                        "longitude": "26.43333000"
                    },
                    {
                        "id": 95792,
                        "name": "Pildești",
                        "latitude": "46.99675000",
                        "longitude": "26.82558000"
                    },
                    {
                        "id": 95794,
                        "name": "Pipirig",
                        "latitude": "47.25000000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 95848,
                        "name": "Podoleni",
                        "latitude": "46.80000000",
                        "longitude": "26.61667000"
                    },
                    {
                        "id": 95872,
                        "name": "Poiana Crăcăoani",
                        "latitude": "47.06667000",
                        "longitude": "26.31667000"
                    },
                    {
                        "id": 95882,
                        "name": "Poiana Teiului",
                        "latitude": "47.10000000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 95885,
                        "name": "Poienari",
                        "latitude": "46.88777000",
                        "longitude": "27.12765000"
                    },
                    {
                        "id": 95890,
                        "name": "Poieni",
                        "latitude": "46.83333000",
                        "longitude": "26.35000000"
                    },
                    {
                        "id": 95900,
                        "name": "Poloboc",
                        "latitude": "46.76109000",
                        "longitude": "26.54975000"
                    },
                    {
                        "id": 96193,
                        "name": "Rădeni",
                        "latitude": "47.14260000",
                        "longitude": "26.53703000"
                    },
                    {
                        "id": 96211,
                        "name": "Răuceşti",
                        "latitude": "47.25000000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 96215,
                        "name": "Războienii de Jos",
                        "latitude": "47.06887000",
                        "longitude": "26.56374000"
                    },
                    {
                        "id": 96076,
                        "name": "Rediu",
                        "latitude": "46.75598000",
                        "longitude": "26.56254000"
                    },
                    {
                        "id": 96105,
                        "name": "Roman",
                        "latitude": "46.92119000",
                        "longitude": "26.92646000"
                    },
                    {
                        "id": 96115,
                        "name": "Români",
                        "latitude": "46.78333000",
                        "longitude": "26.68333000"
                    },
                    {
                        "id": 96120,
                        "name": "Rotunda",
                        "latitude": "47.02210000",
                        "longitude": "26.96266000"
                    },
                    {
                        "id": 96125,
                        "name": "Roznov",
                        "latitude": "46.83333000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 96149,
                        "name": "Ruginoasa",
                        "latitude": "46.98622000",
                        "longitude": "26.70635000"
                    },
                    {
                        "id": 96161,
                        "name": "Ruseni",
                        "latitude": "46.79841000",
                        "longitude": "26.53943000"
                    },
                    {
                        "id": 105988,
                        "name": "Săbăoani",
                        "latitude": "47.01667000",
                        "longitude": "26.85000000"
                    },
                    {
                        "id": 96219,
                        "name": "Sabasa",
                        "latitude": "47.20174000",
                        "longitude": "25.81760000"
                    },
                    {
                        "id": 96228,
                        "name": "Sagna",
                        "latitude": "46.98333000",
                        "longitude": "27.01667000"
                    },
                    {
                        "id": 106047,
                        "name": "Săvineşti",
                        "latitude": "46.85000000",
                        "longitude": "26.46667000"
                    },
                    {
                        "id": 96315,
                        "name": "Secuieni",
                        "latitude": "46.85000000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 96343,
                        "name": "Siliștea",
                        "latitude": "46.77781000",
                        "longitude": "26.69303000"
                    },
                    {
                        "id": 96368,
                        "name": "Slobozia",
                        "latitude": "46.84892000",
                        "longitude": "26.53344000"
                    },
                    {
                        "id": 96471,
                        "name": "Stânca",
                        "latitude": "47.23069000",
                        "longitude": "26.13139000"
                    },
                    {
                        "id": 96482,
                        "name": "Stăniţa",
                        "latitude": "47.01667000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 97080,
                        "name": "Ştefan cel Mare",
                        "latitude": "46.98482000",
                        "longitude": "26.51070000"
                    },
                    {
                        "id": 96427,
                        "name": "Stejaru",
                        "latitude": "46.91888000",
                        "longitude": "26.18023000"
                    },
                    {
                        "id": 96607,
                        "name": "Tămăşeni",
                        "latitude": "46.98333000",
                        "longitude": "26.93333000"
                    },
                    {
                        "id": 106060,
                        "name": "Tarcău",
                        "latitude": "46.86667000",
                        "longitude": "26.13333000"
                    },
                    {
                        "id": 96586,
                        "name": "Târgu Neamţ",
                        "latitude": "47.20000000",
                        "longitude": "26.36667000"
                    },
                    {
                        "id": 106065,
                        "name": "Taşca",
                        "latitude": "46.90000000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 106064,
                        "name": "Tazlău",
                        "latitude": "46.71667000",
                        "longitude": "26.46667000"
                    },
                    {
                        "id": 106077,
                        "name": "Telec",
                        "latitude": "46.87979000",
                        "longitude": "25.87775000"
                    },
                    {
                        "id": 97102,
                        "name": "Ţibucani",
                        "latitude": "47.10000000",
                        "longitude": "26.53333000"
                    },
                    {
                        "id": 106101,
                        "name": "Timişeşti",
                        "latitude": "47.23333000",
                        "longitude": "26.55000000"
                    },
                    {
                        "id": 97141,
                        "name": "Țolici",
                        "latitude": "47.11840000",
                        "longitude": "26.44841000"
                    },
                    {
                        "id": 106134,
                        "name": "Topolița",
                        "latitude": "47.16787000",
                        "longitude": "26.38345000"
                    },
                    {
                        "id": 106146,
                        "name": "Traian",
                        "latitude": "46.83335000",
                        "longitude": "26.57655000"
                    },
                    {
                        "id": 106155,
                        "name": "Trifeşti",
                        "latitude": "46.91667000",
                        "longitude": "26.81667000"
                    },
                    {
                        "id": 96550,
                        "name": "Tupilaţi",
                        "latitude": "47.06667000",
                        "longitude": "26.63333000"
                    },
                    {
                        "id": 96674,
                        "name": "Urecheni",
                        "latitude": "47.16667000",
                        "longitude": "26.51667000"
                    },
                    {
                        "id": 96955,
                        "name": "Vădurele",
                        "latitude": "46.72958000",
                        "longitude": "26.57173000"
                    },
                    {
                        "id": 96709,
                        "name": "Valea Arini",
                        "latitude": "47.12694000",
                        "longitude": "26.29377000"
                    },
                    {
                        "id": 96755,
                        "name": "Valea Seacă",
                        "latitude": "47.13944000",
                        "longitude": "26.29956000"
                    },
                    {
                        "id": 96761,
                        "name": "Valea Ursului",
                        "latitude": "46.81667000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 96960,
                        "name": "Văleni",
                        "latitude": "46.90291000",
                        "longitude": "26.38945000"
                    },
                    {
                        "id": 96933,
                        "name": "Vânători-Neamţ",
                        "latitude": "47.20000000",
                        "longitude": "26.31667000"
                    },
                    {
                        "id": 96818,
                        "name": "Viişoara",
                        "latitude": "46.93333000",
                        "longitude": "26.23333000"
                    },
                    {
                        "id": 97011,
                        "name": "Zăneşti",
                        "latitude": "46.81667000",
                        "longitude": "26.55000000"
                    }
                ]
            },
            {
                "id": 4738,
                "name": "Olt",
                "iso2": "OT",
                "latitude": "44.20079700",
                "longitude": "24.50229810",
                "type": "department",
                "cities": [
                    {
                        "id": 89933,
                        "name": "Alimănești",
                        "latitude": "44.25693000",
                        "longitude": "24.53895000"
                    },
                    {
                        "id": 89942,
                        "name": "Alunișu",
                        "latitude": "44.71667000",
                        "longitude": "24.55000000"
                    },
                    {
                        "id": 90472,
                        "name": "Băbiciu",
                        "latitude": "44.03333000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 90021,
                        "name": "Bacea",
                        "latitude": "44.39824000",
                        "longitude": "24.63759000"
                    },
                    {
                        "id": 90524,
                        "name": "Bălănești",
                        "latitude": "44.24970000",
                        "longitude": "24.48216000"
                    },
                    {
                        "id": 90041,
                        "name": "Baldovineşti",
                        "latitude": "44.38333000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 90050,
                        "name": "Balş",
                        "latitude": "44.35000000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 90515,
                        "name": "Bălteni",
                        "latitude": "44.44883000",
                        "longitude": "24.53247000"
                    },
                    {
                        "id": 90549,
                        "name": "Bărăștii de Vede",
                        "latitude": "44.71601000",
                        "longitude": "24.65919000"
                    },
                    {
                        "id": 90065,
                        "name": "Barza",
                        "latitude": "44.33333000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 90140,
                        "name": "Bircii",
                        "latitude": "44.51673000",
                        "longitude": "24.60324000"
                    },
                    {
                        "id": 90168,
                        "name": "Bobiceşti",
                        "latitude": "44.38333000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 90320,
                        "name": "Brâncoveni",
                        "latitude": "44.31667000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 90267,
                        "name": "Braneț",
                        "latitude": "44.32576000",
                        "longitude": "24.17792000"
                    },
                    {
                        "id": 90273,
                        "name": "Brastavățu",
                        "latitude": "43.90634000",
                        "longitude": "24.40784000"
                    },
                    {
                        "id": 90291,
                        "name": "Brebeni",
                        "latitude": "44.36667000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 90349,
                        "name": "Bucinişu",
                        "latitude": "43.95000000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 90437,
                        "name": "Bușca",
                        "latitude": "44.11166000",
                        "longitude": "24.80238000"
                    },
                    {
                        "id": 93841,
                        "name": "Călinești",
                        "latitude": "44.07727000",
                        "longitude": "24.68796000"
                    },
                    {
                        "id": 93847,
                        "name": "Călui",
                        "latitude": "44.45297000",
                        "longitude": "24.06360000"
                    },
                    {
                        "id": 90572,
                        "name": "Caracal",
                        "latitude": "44.11667000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 93816,
                        "name": "Cârlogani",
                        "latitude": "44.51667000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 90590,
                        "name": "Catanele",
                        "latitude": "44.38199000",
                        "longitude": "24.56145000"
                    },
                    {
                        "id": 90616,
                        "name": "Cepari",
                        "latitude": "44.49733000",
                        "longitude": "24.17122000"
                    },
                    {
                        "id": 90651,
                        "name": "Cezieni",
                        "latitude": "44.18333000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 90702,
                        "name": "Cilieni",
                        "latitude": "43.90000000",
                        "longitude": "24.61667000"
                    },
                    {
                        "id": 90798,
                        "name": "Coloneşti",
                        "latitude": "44.65000000",
                        "longitude": "24.66667000"
                    },
                    {
                        "id": 90807,
                        "name": "Comanca",
                        "latitude": "44.07790000",
                        "longitude": "24.35863000"
                    },
                    {
                        "id": 90810,
                        "name": "Comani",
                        "latitude": "44.18286000",
                        "longitude": "24.49160000"
                    },
                    {
                        "id": 91201,
                        "name": "Comuna Băbiciu",
                        "latitude": "44.03230000",
                        "longitude": "24.56533000"
                    },
                    {
                        "id": 90925,
                        "name": "Comuna Baldovineşti",
                        "latitude": "44.39195000",
                        "longitude": "24.03898000"
                    },
                    {
                        "id": 91218,
                        "name": "Comuna Bălteni",
                        "latitude": "44.44883000",
                        "longitude": "24.53247000"
                    },
                    {
                        "id": 91198,
                        "name": "Comuna Bãrãşti",
                        "latitude": "44.70852000",
                        "longitude": "24.64470000"
                    },
                    {
                        "id": 91196,
                        "name": "Comuna Bârza",
                        "latitude": "44.32693000",
                        "longitude": "24.15990000"
                    },
                    {
                        "id": 91011,
                        "name": "Comuna Bobiceşti",
                        "latitude": "44.39321000",
                        "longitude": "24.14215000"
                    },
                    {
                        "id": 91110,
                        "name": "Comuna Brâncoveni",
                        "latitude": "44.31488000",
                        "longitude": "24.32941000"
                    },
                    {
                        "id": 91081,
                        "name": "Comuna Brastavăţu",
                        "latitude": "43.91553000",
                        "longitude": "24.41135000"
                    },
                    {
                        "id": 91091,
                        "name": "Comuna Brebeni",
                        "latitude": "44.35956000",
                        "longitude": "24.44360000"
                    },
                    {
                        "id": 91128,
                        "name": "Comuna Bucinişu",
                        "latitude": "43.94202000",
                        "longitude": "24.25463000"
                    },
                    {
                        "id": 91562,
                        "name": "Comuna Cãlui",
                        "latitude": "44.45600000",
                        "longitude": "24.04953000"
                    },
                    {
                        "id": 91553,
                        "name": "Comuna Cârlogani",
                        "latitude": "44.51990000",
                        "longitude": "24.16007000"
                    },
                    {
                        "id": 91307,
                        "name": "Comuna Cezieni",
                        "latitude": "44.18245000",
                        "longitude": "24.26846000"
                    },
                    {
                        "id": 91337,
                        "name": "Comuna Cilieni",
                        "latitude": "43.90206000",
                        "longitude": "24.61470000"
                    },
                    {
                        "id": 91399,
                        "name": "Comuna Coloneşti",
                        "latitude": "44.62345000",
                        "longitude": "24.67666000"
                    },
                    {
                        "id": 91428,
                        "name": "Comuna Corbu",
                        "latitude": "44.45514000",
                        "longitude": "24.71639000"
                    },
                    {
                        "id": 91463,
                        "name": "Comuna Coteana",
                        "latitude": "44.30133000",
                        "longitude": "24.46638000"
                    },
                    {
                        "id": 91512,
                        "name": "Comuna Crâmpoia",
                        "latitude": "44.30513000",
                        "longitude": "24.72742000"
                    },
                    {
                        "id": 91525,
                        "name": "Comuna Cungrea",
                        "latitude": "44.68497000",
                        "longitude": "24.39274000"
                    },
                    {
                        "id": 91530,
                        "name": "Comuna Curtişoara",
                        "latitude": "44.48175000",
                        "longitude": "24.34214000"
                    },
                    {
                        "id": 91737,
                        "name": "Comuna Dăneasa",
                        "latitude": "44.11390000",
                        "longitude": "24.56597000"
                    },
                    {
                        "id": 91620,
                        "name": "Comuna Deveselu",
                        "latitude": "44.06569000",
                        "longitude": "24.37351000"
                    },
                    {
                        "id": 91638,
                        "name": "Comuna Dobreţu",
                        "latitude": "44.49164000",
                        "longitude": "23.95302000"
                    },
                    {
                        "id": 91640,
                        "name": "Comuna Dobrosloveni",
                        "latitude": "44.17356000",
                        "longitude": "24.36558000"
                    },
                    {
                        "id": 91641,
                        "name": "Comuna Dobroteasa",
                        "latitude": "44.77107000",
                        "longitude": "24.32810000"
                    },
                    {
                        "id": 91645,
                        "name": "Comuna Dobrun",
                        "latitude": "44.25323000",
                        "longitude": "24.23299000"
                    },
                    {
                        "id": 91688,
                        "name": "Comuna Drăghiceni",
                        "latitude": "44.12694000",
                        "longitude": "24.25611000"
                    },
                    {
                        "id": 91819,
                        "name": "Comuna Făgeţelu",
                        "latitude": "44.78429000",
                        "longitude": "24.54421000"
                    },
                    {
                        "id": 91821,
                        "name": "Comuna Fălcoiu",
                        "latitude": "44.23774000",
                        "longitude": "24.37601000"
                    },
                    {
                        "id": 91824,
                        "name": "Comuna Fărcaşele",
                        "latitude": "44.15057000",
                        "longitude": "24.43283000"
                    },
                    {
                        "id": 91986,
                        "name": "Comuna Găneasa",
                        "latitude": "44.42129000",
                        "longitude": "24.26774000"
                    },
                    {
                        "id": 91970,
                        "name": "Comuna Gârcov",
                        "latitude": "43.77342000",
                        "longitude": "24.62709000"
                    },
                    {
                        "id": 91988,
                        "name": "Comuna Găvăneşti",
                        "latitude": "44.41403000",
                        "longitude": "24.00867000"
                    },
                    {
                        "id": 91857,
                        "name": "Comuna Ghimpeţeni",
                        "latitude": "44.29002000",
                        "longitude": "24.78303000"
                    },
                    {
                        "id": 91878,
                        "name": "Comuna Giuvărăşti",
                        "latitude": "43.79412000",
                        "longitude": "24.68729000"
                    },
                    {
                        "id": 91906,
                        "name": "Comuna Gostavăţu",
                        "latitude": "44.08028000",
                        "longitude": "24.53283000"
                    },
                    {
                        "id": 91933,
                        "name": "Comuna Grãdinari",
                        "latitude": "44.56736000",
                        "longitude": "24.27761000"
                    },
                    {
                        "id": 91934,
                        "name": "Comuna Grãdinile",
                        "latitude": "43.94973000",
                        "longitude": "24.39228000"
                    },
                    {
                        "id": 91923,
                        "name": "Comuna Grojdibodu",
                        "latitude": "43.75562000",
                        "longitude": "24.26073000"
                    },
                    {
                        "id": 91950,
                        "name": "Comuna Gura Padinii",
                        "latitude": "43.76276000",
                        "longitude": "24.31690000"
                    },
                    {
                        "id": 92053,
                        "name": "Comuna Ianca",
                        "latitude": "43.77472000",
                        "longitude": "24.19165000"
                    },
                    {
                        "id": 92054,
                        "name": "Comuna Iancu Jianu",
                        "latitude": "44.51807000",
                        "longitude": "24.01257000"
                    },
                    {
                        "id": 92060,
                        "name": "Comuna Icoana",
                        "latitude": "44.40682000",
                        "longitude": "24.72551000"
                    },
                    {
                        "id": 92090,
                        "name": "Comuna Ipotesti",
                        "latitude": "44.32529000",
                        "longitude": "24.40089000"
                    },
                    {
                        "id": 92101,
                        "name": "Comuna Izbiceni",
                        "latitude": "43.82418000",
                        "longitude": "24.66415000"
                    },
                    {
                        "id": 92104,
                        "name": "Comuna Izvoarele",
                        "latitude": "44.25958000",
                        "longitude": "24.53144000"
                    },
                    {
                        "id": 92145,
                        "name": "Comuna Leleasca",
                        "latitude": "44.75768000",
                        "longitude": "24.43708000"
                    },
                    {
                        "id": 92415,
                        "name": "Comuna Mărunţei",
                        "latitude": "44.23679000",
                        "longitude": "24.46583000"
                    },
                    {
                        "id": 92279,
                        "name": "Comuna Mihăeşti",
                        "latitude": "44.11870000",
                        "longitude": "24.79663000"
                    },
                    {
                        "id": 92289,
                        "name": "Comuna Milcov",
                        "latitude": "44.37396000",
                        "longitude": "24.38004000"
                    },
                    {
                        "id": 92334,
                        "name": "Comuna Morunglav",
                        "latitude": "44.47266000",
                        "longitude": "24.11686000"
                    },
                    {
                        "id": 92342,
                        "name": "Comuna Movileni",
                        "latitude": "44.38368000",
                        "longitude": "24.64075000"
                    },
                    {
                        "id": 92443,
                        "name": "Comuna Nicolae Titulescu",
                        "latitude": "44.27008000",
                        "longitude": "24.75897000"
                    },
                    {
                        "id": 92473,
                        "name": "Comuna Obârşia",
                        "latitude": "43.89063000",
                        "longitude": "24.32188000"
                    },
                    {
                        "id": 92470,
                        "name": "Comuna Oboga",
                        "latitude": "44.42448000",
                        "longitude": "24.08724000"
                    },
                    {
                        "id": 92502,
                        "name": "Comuna Oporelu",
                        "latitude": "44.58682000",
                        "longitude": "24.42410000"
                    },
                    {
                        "id": 92504,
                        "name": "Comuna Optaşi-Mãgura",
                        "latitude": "44.57944000",
                        "longitude": "24.65183000"
                    },
                    {
                        "id": 92509,
                        "name": "Comuna Orlea",
                        "latitude": "43.75430000",
                        "longitude": "24.36775000"
                    },
                    {
                        "id": 92515,
                        "name": "Comuna Osica de Jos",
                        "latitude": "44.23800000",
                        "longitude": "24.29502000"
                    },
                    {
                        "id": 92516,
                        "name": "Comuna Osica de Sus",
                        "latitude": "44.27268000",
                        "longitude": "24.33730000"
                    },
                    {
                        "id": 92709,
                        "name": "Comuna Pârşcoveni",
                        "latitude": "44.29678000",
                        "longitude": "24.21836000"
                    },
                    {
                        "id": 92552,
                        "name": "Comuna Perieţi",
                        "latitude": "44.40468000",
                        "longitude": "24.55611000"
                    },
                    {
                        "id": 92595,
                        "name": "Comuna Pleşoiu",
                        "latitude": "44.48165000",
                        "longitude": "24.24212000"
                    },
                    {
                        "id": 92608,
                        "name": "Comuna Poboru",
                        "latitude": "44.68335000",
                        "longitude": "24.48678000"
                    },
                    {
                        "id": 92677,
                        "name": "Comuna Priseaca",
                        "latitude": "44.51206000",
                        "longitude": "24.43787000"
                    },
                    {
                        "id": 92742,
                        "name": "Comuna Radomireşti",
                        "latitude": "44.11049000",
                        "longitude": "24.67816000"
                    },
                    {
                        "id": 92758,
                        "name": "Comuna Redea",
                        "latitude": "44.04157000",
                        "longitude": "24.30677000"
                    },
                    {
                        "id": 92792,
                        "name": "Comuna Rotunda",
                        "latitude": "43.98427000",
                        "longitude": "24.31402000"
                    },
                    {
                        "id": 92816,
                        "name": "Comuna Rusăneşti",
                        "latitude": "43.94385000",
                        "longitude": "24.59498000"
                    },
                    {
                        "id": 93045,
                        "name": "Comuna Sâmbureşti",
                        "latitude": "44.81131000",
                        "longitude": "24.39922000"
                    },
                    {
                        "id": 93073,
                        "name": "Comuna Sârbii-Măgura",
                        "latitude": "44.52730000",
                        "longitude": "24.69585000"
                    },
                    {
                        "id": 92906,
                        "name": "Comuna Scărişoara",
                        "latitude": "43.98528000",
                        "longitude": "24.58333000"
                    },
                    {
                        "id": 92887,
                        "name": "Comuna Schitu",
                        "latitude": "44.35679000",
                        "longitude": "24.55926000"
                    },
                    {
                        "id": 92907,
                        "name": "Comuna Seaca",
                        "latitude": "44.15159000",
                        "longitude": "24.76149000"
                    },
                    {
                        "id": 93509,
                        "name": "Comuna Şerbăneşti",
                        "latitude": "44.33607000",
                        "longitude": "24.68782000"
                    },
                    {
                        "id": 92961,
                        "name": "Comuna Slătioara",
                        "latitude": "44.41545000",
                        "longitude": "24.32082000"
                    },
                    {
                        "id": 93542,
                        "name": "Comuna Şopârliţa",
                        "latitude": "44.27705000",
                        "longitude": "24.27743000"
                    },
                    {
                        "id": 92982,
                        "name": "Comuna Spineni",
                        "latitude": "44.71808000",
                        "longitude": "24.55897000"
                    },
                    {
                        "id": 92984,
                        "name": "Comuna Sprâncenata",
                        "latitude": "44.06110000",
                        "longitude": "24.63984000"
                    },
                    {
                        "id": 93549,
                        "name": "Comuna Ştefan cel Mare",
                        "latitude": "43.81174000",
                        "longitude": "24.22262000"
                    },
                    {
                        "id": 92991,
                        "name": "Comuna Stoeneşti",
                        "latitude": "44.11675000",
                        "longitude": "24.49720000"
                    },
                    {
                        "id": 92995,
                        "name": "Comuna Stoicăneşti",
                        "latitude": "44.18568000",
                        "longitude": "24.64267000"
                    },
                    {
                        "id": 93002,
                        "name": "Comuna Strejeşti",
                        "latitude": "44.52733000",
                        "longitude": "24.27036000"
                    },
                    {
                        "id": 93010,
                        "name": "Comuna Studina",
                        "latitude": "43.96784000",
                        "longitude": "24.42136000"
                    },
                    {
                        "id": 93243,
                        "name": "Comuna Tătuleşti",
                        "latitude": "44.66386000",
                        "longitude": "24.61405000"
                    },
                    {
                        "id": 93144,
                        "name": "Comuna Teslui",
                        "latitude": "44.51316000",
                        "longitude": "24.35600000"
                    },
                    {
                        "id": 93147,
                        "name": "Comuna Tia Mare",
                        "latitude": "43.86417000",
                        "longitude": "24.63883000"
                    },
                    {
                        "id": 93174,
                        "name": "Comuna Topana",
                        "latitude": "44.84319000",
                        "longitude": "24.52827000"
                    },
                    {
                        "id": 93186,
                        "name": "Comuna Traian",
                        "latitude": "44.02337000",
                        "longitude": "24.45586000"
                    },
                    {
                        "id": 93201,
                        "name": "Comuna Tufeni",
                        "latitude": "44.34718000",
                        "longitude": "24.78986000"
                    },
                    {
                        "id": 93285,
                        "name": "Comuna Urzica",
                        "latitude": "43.86055000",
                        "longitude": "24.27497000"
                    },
                    {
                        "id": 93453,
                        "name": "Comuna Vădastra",
                        "latitude": "43.86497000",
                        "longitude": "24.38069000"
                    },
                    {
                        "id": 93455,
                        "name": "Comuna Vădăstriţa",
                        "latitude": "43.84531000",
                        "longitude": "24.34017000"
                    },
                    {
                        "id": 93427,
                        "name": "Comuna Vâlcele",
                        "latitude": "44.28923000",
                        "longitude": "24.54968000"
                    },
                    {
                        "id": 93312,
                        "name": "Comuna Valea Mare",
                        "latitude": "44.44188000",
                        "longitude": "24.46120000"
                    },
                    {
                        "id": 93459,
                        "name": "Comuna Văleni",
                        "latitude": "44.21882000",
                        "longitude": "24.79748000"
                    },
                    {
                        "id": 93344,
                        "name": "Comuna Verguleasa",
                        "latitude": "44.64128000",
                        "longitude": "24.34234000"
                    },
                    {
                        "id": 93377,
                        "name": "Comuna Vişina",
                        "latitude": "43.86618000",
                        "longitude": "24.45469000"
                    },
                    {
                        "id": 93378,
                        "name": "Comuna Vişina Nouă",
                        "latitude": "43.87434000",
                        "longitude": "24.41820000"
                    },
                    {
                        "id": 93370,
                        "name": "Comuna Vitomireşti",
                        "latitude": "44.85194000",
                        "longitude": "24.37704000"
                    },
                    {
                        "id": 93392,
                        "name": "Comuna Vlădila",
                        "latitude": "44.00114000",
                        "longitude": "24.40993000"
                    },
                    {
                        "id": 93396,
                        "name": "Comuna Voineasa",
                        "latitude": "44.28949000",
                        "longitude": "24.15529000"
                    },
                    {
                        "id": 93415,
                        "name": "Comuna Vulpeni",
                        "latitude": "44.45854000",
                        "longitude": "23.92718000"
                    },
                    {
                        "id": 93419,
                        "name": "Comuna Vultureşti",
                        "latitude": "44.72993000",
                        "longitude": "24.33354000"
                    },
                    {
                        "id": 93610,
                        "name": "Corabia",
                        "latitude": "43.77513000",
                        "longitude": "24.50146000"
                    },
                    {
                        "id": 93617,
                        "name": "Corbu",
                        "latitude": "44.48333000",
                        "longitude": "24.71667000"
                    },
                    {
                        "id": 93672,
                        "name": "Coteana",
                        "latitude": "44.30000000",
                        "longitude": "24.46667000"
                    },
                    {
                        "id": 93750,
                        "name": "Crăciunei",
                        "latitude": "44.14575000",
                        "longitude": "24.66309000"
                    },
                    {
                        "id": 93746,
                        "name": "Crâmpoia",
                        "latitude": "44.30215000",
                        "longitude": "24.74513000"
                    },
                    {
                        "id": 93745,
                        "name": "Crușovu",
                        "latitude": "43.92473000",
                        "longitude": "24.41486000"
                    },
                    {
                        "id": 93770,
                        "name": "Cungrea",
                        "latitude": "44.66667000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 93777,
                        "name": "Curtişoara",
                        "latitude": "44.50000000",
                        "longitude": "24.33333000"
                    },
                    {
                        "id": 94125,
                        "name": "Dăneasa",
                        "latitude": "44.15000000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 93912,
                        "name": "Dejești",
                        "latitude": "44.83093000",
                        "longitude": "24.35648000"
                    },
                    {
                        "id": 93930,
                        "name": "Deveselu",
                        "latitude": "44.06667000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 93943,
                        "name": "Doanca",
                        "latitude": "43.84870000",
                        "longitude": "24.64949000"
                    },
                    {
                        "id": 93956,
                        "name": "Dobreţu",
                        "latitude": "44.50000000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 93963,
                        "name": "Dobrosloveni",
                        "latitude": "44.18333000",
                        "longitude": "24.36667000"
                    },
                    {
                        "id": 93964,
                        "name": "Dobroteasa",
                        "latitude": "44.78333000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 93967,
                        "name": "Dobrotinet",
                        "latitude": "44.47957000",
                        "longitude": "24.34730000"
                    },
                    {
                        "id": 93970,
                        "name": "Dobrun",
                        "latitude": "44.26667000",
                        "longitude": "24.21667000"
                    },
                    {
                        "id": 94061,
                        "name": "Drăgăneşti-Olt",
                        "latitude": "44.16667000",
                        "longitude": "24.53333000"
                    },
                    {
                        "id": 94038,
                        "name": "Drăghiceni",
                        "latitude": "44.13333000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 94028,
                        "name": "Dranovățu",
                        "latitude": "44.43619000",
                        "longitude": "24.27894000"
                    },
                    {
                        "id": 94098,
                        "name": "Dumitrești",
                        "latitude": "44.68370000",
                        "longitude": "24.31628000"
                    },
                    {
                        "id": 94255,
                        "name": "Făgeţelu",
                        "latitude": "44.78333000",
                        "longitude": "24.53333000"
                    },
                    {
                        "id": 94258,
                        "name": "Fălcoiu",
                        "latitude": "44.23333000",
                        "longitude": "24.36667000"
                    },
                    {
                        "id": 94262,
                        "name": "Fărcaşele",
                        "latitude": "44.15000000",
                        "longitude": "24.43333000"
                    },
                    {
                        "id": 94264,
                        "name": "Fărcașu de Jos",
                        "latitude": "44.13539000",
                        "longitude": "24.45901000"
                    },
                    {
                        "id": 94509,
                        "name": "Găneasa",
                        "latitude": "44.41667000",
                        "longitude": "24.28333000"
                    },
                    {
                        "id": 94488,
                        "name": "Gârcov",
                        "latitude": "43.75910000",
                        "longitude": "24.61577000"
                    },
                    {
                        "id": 94516,
                        "name": "Găvănești",
                        "latitude": "44.41724000",
                        "longitude": "24.01654000"
                    },
                    {
                        "id": 94324,
                        "name": "Ghimpați",
                        "latitude": "44.15359000",
                        "longitude": "24.42698000"
                    },
                    {
                        "id": 94326,
                        "name": "Ghimpețeni",
                        "latitude": "44.28101000",
                        "longitude": "24.77458000"
                    },
                    {
                        "id": 94331,
                        "name": "Ghioca",
                        "latitude": "44.31667000",
                        "longitude": "24.73333000"
                    },
                    {
                        "id": 94356,
                        "name": "Giuvărăşti",
                        "latitude": "43.80000000",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 94392,
                        "name": "Gostavăţu",
                        "latitude": "44.08333000",
                        "longitude": "24.53333000"
                    },
                    {
                        "id": 94434,
                        "name": "Grădinari",
                        "latitude": "44.56667000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 94410,
                        "name": "Greci",
                        "latitude": "44.33025000",
                        "longitude": "24.55923000"
                    },
                    {
                        "id": 94418,
                        "name": "Grojdibodu",
                        "latitude": "43.75000000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 94421,
                        "name": "Gropșani",
                        "latitude": "44.44072000",
                        "longitude": "23.97047000"
                    },
                    {
                        "id": 94452,
                        "name": "Gura Căluiu",
                        "latitude": "44.45903000",
                        "longitude": "24.03547000"
                    },
                    {
                        "id": 94457,
                        "name": "Gura Padinii",
                        "latitude": "43.75704000",
                        "longitude": "24.31615000"
                    },
                    {
                        "id": 94619,
                        "name": "Ianca",
                        "latitude": "43.78333000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 94621,
                        "name": "Iancu Jianu",
                        "latitude": "44.50000000",
                        "longitude": "24.03333000"
                    },
                    {
                        "id": 94635,
                        "name": "Icoana",
                        "latitude": "44.41667000",
                        "longitude": "24.71667000"
                    },
                    {
                        "id": 94685,
                        "name": "Ipotești",
                        "latitude": "44.32529000",
                        "longitude": "24.40089000"
                    },
                    {
                        "id": 94699,
                        "name": "Izbiceni",
                        "latitude": "43.83333000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 94704,
                        "name": "Izvoarele",
                        "latitude": "44.26667000",
                        "longitude": "24.51667000"
                    },
                    {
                        "id": 94734,
                        "name": "Jieni",
                        "latitude": "43.95095000",
                        "longitude": "24.59349000"
                    },
                    {
                        "id": 94772,
                        "name": "Leleasca",
                        "latitude": "44.78333000",
                        "longitude": "24.43333000"
                    },
                    {
                        "id": 95270,
                        "name": "Mărgineni Slobozia",
                        "latitude": "44.53121000",
                        "longitude": "24.55675000"
                    },
                    {
                        "id": 95282,
                        "name": "Mărunţei",
                        "latitude": "44.20000000",
                        "longitude": "24.46667000"
                    },
                    {
                        "id": 94989,
                        "name": "Mihăeşti",
                        "latitude": "44.13333000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 95074,
                        "name": "Morunglav",
                        "latitude": "44.46667000",
                        "longitude": "24.11667000"
                    },
                    {
                        "id": 95082,
                        "name": "Movileni",
                        "latitude": "44.36667000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 95123,
                        "name": "Municipiul Caracal",
                        "latitude": "44.11273000",
                        "longitude": "24.35089000"
                    },
                    {
                        "id": 95183,
                        "name": "Municipiul Slatina",
                        "latitude": "44.44276000",
                        "longitude": "24.36745000"
                    },
                    {
                        "id": 95315,
                        "name": "Negreni",
                        "latitude": "44.56848000",
                        "longitude": "24.59535000"
                    },
                    {
                        "id": 95339,
                        "name": "Nicolae Titulescu",
                        "latitude": "44.30000000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 95389,
                        "name": "Obârşia",
                        "latitude": "43.88333000",
                        "longitude": "24.33333000"
                    },
                    {
                        "id": 95386,
                        "name": "Oboga",
                        "latitude": "44.41667000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 95425,
                        "name": "Olari",
                        "latitude": "44.30783000",
                        "longitude": "24.20857000"
                    },
                    {
                        "id": 95442,
                        "name": "Oporelu",
                        "latitude": "44.60000000",
                        "longitude": "24.41667000"
                    },
                    {
                        "id": 95444,
                        "name": "Optaşi",
                        "latitude": "44.58333000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 95457,
                        "name": "Oraş Balş",
                        "latitude": "44.36546000",
                        "longitude": "24.11321000"
                    },
                    {
                        "id": 95498,
                        "name": "Oraş Corabia",
                        "latitude": "43.80248000",
                        "longitude": "24.47028000"
                    },
                    {
                        "id": 95510,
                        "name": "Oraş Drãgãneşti-Olt",
                        "latitude": "44.17618000",
                        "longitude": "24.50836000"
                    },
                    {
                        "id": 95567,
                        "name": "Oraş Piatra-Olt",
                        "latitude": "44.37560000",
                        "longitude": "24.28332000"
                    },
                    {
                        "id": 95572,
                        "name": "Oraş Potcoava",
                        "latitude": "44.47992000",
                        "longitude": "24.64172000"
                    },
                    {
                        "id": 95584,
                        "name": "Oraş Scorniceşti",
                        "latitude": "44.56790000",
                        "longitude": "24.55394000"
                    },
                    {
                        "id": 95659,
                        "name": "Orlea",
                        "latitude": "43.75000000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 95660,
                        "name": "Orlea Nouă",
                        "latitude": "43.75522000",
                        "longitude": "24.35834000"
                    },
                    {
                        "id": 95672,
                        "name": "Osica de Jos",
                        "latitude": "44.24439000",
                        "longitude": "24.27926000"
                    },
                    {
                        "id": 95673,
                        "name": "Osica de Sus",
                        "latitude": "44.25000000",
                        "longitude": "24.31667000"
                    },
                    {
                        "id": 96003,
                        "name": "Pârşcoveni",
                        "latitude": "44.30000000",
                        "longitude": "24.23333000"
                    },
                    {
                        "id": 95733,
                        "name": "Perieţi",
                        "latitude": "44.40000000",
                        "longitude": "24.55000000"
                    },
                    {
                        "id": 95768,
                        "name": "Piatra",
                        "latitude": "44.36054000",
                        "longitude": "24.29557000"
                    },
                    {
                        "id": 95772,
                        "name": "Piatra Olt",
                        "latitude": "44.36667000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 95812,
                        "name": "Pleşoiu",
                        "latitude": "44.46667000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 95837,
                        "name": "Poboru",
                        "latitude": "44.66667000",
                        "longitude": "24.50000000"
                    },
                    {
                        "id": 95928,
                        "name": "Potcoava",
                        "latitude": "44.48333000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 95929,
                        "name": "Potcoava Fălcoeni",
                        "latitude": "44.49484000",
                        "longitude": "24.61650000"
                    },
                    {
                        "id": 95930,
                        "name": "Potelu",
                        "latitude": "43.76577000",
                        "longitude": "24.20535000"
                    },
                    {
                        "id": 95932,
                        "name": "Potlogeni",
                        "latitude": "43.87995000",
                        "longitude": "24.63092000"
                    },
                    {
                        "id": 95954,
                        "name": "Priseaca",
                        "latitude": "44.51667000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 96053,
                        "name": "Radomireşti",
                        "latitude": "44.11667000",
                        "longitude": "24.68333000"
                    },
                    {
                        "id": 96074,
                        "name": "Redea",
                        "latitude": "44.05000000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 96121,
                        "name": "Rotunda",
                        "latitude": "43.98333000",
                        "longitude": "24.31667000"
                    },
                    {
                        "id": 96162,
                        "name": "Rusăneşti",
                        "latitude": "43.93333000",
                        "longitude": "24.60000000"
                    },
                    {
                        "id": 96518,
                        "name": "Sâmbureşti",
                        "latitude": "44.80000000",
                        "longitude": "24.41667000"
                    },
                    {
                        "id": 96297,
                        "name": "Scărişoara",
                        "latitude": "44.00000000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 96269,
                        "name": "Schitu",
                        "latitude": "44.35000000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 96278,
                        "name": "Scorniceşti",
                        "latitude": "44.56667000",
                        "longitude": "24.55000000"
                    },
                    {
                        "id": 96298,
                        "name": "Seaca",
                        "latitude": "44.16667000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 97039,
                        "name": "Şerbăneşti",
                        "latitude": "44.33333000",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 96354,
                        "name": "Sinești",
                        "latitude": "44.46777000",
                        "longitude": "24.66585000"
                    },
                    {
                        "id": 96361,
                        "name": "Slatina",
                        "latitude": "44.43333000",
                        "longitude": "24.36667000"
                    },
                    {
                        "id": 96384,
                        "name": "Slătioara",
                        "latitude": "44.40000000",
                        "longitude": "24.31667000"
                    },
                    {
                        "id": 96385,
                        "name": "Slăveni",
                        "latitude": "44.08558000",
                        "longitude": "24.52843000"
                    },
                    {
                        "id": 97072,
                        "name": "Şopârliţa",
                        "latitude": "44.28333000",
                        "longitude": "24.28333000"
                    },
                    {
                        "id": 96418,
                        "name": "Sprâncenata",
                        "latitude": "44.08333000",
                        "longitude": "24.63333000"
                    },
                    {
                        "id": 96484,
                        "name": "Stăvaru",
                        "latitude": "43.86445000",
                        "longitude": "24.25902000"
                    },
                    {
                        "id": 97079,
                        "name": "Ştefan cel Mare",
                        "latitude": "43.81124000",
                        "longitude": "24.22039000"
                    },
                    {
                        "id": 96432,
                        "name": "Stoeneşti",
                        "latitude": "44.11667000",
                        "longitude": "24.50000000"
                    },
                    {
                        "id": 96438,
                        "name": "Stoicăneşti",
                        "latitude": "44.18333000",
                        "longitude": "24.63333000"
                    },
                    {
                        "id": 96450,
                        "name": "Strejeşti",
                        "latitude": "44.53333000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 96451,
                        "name": "Strejeștii de Sus",
                        "latitude": "44.54389000",
                        "longitude": "24.22772000"
                    },
                    {
                        "id": 96465,
                        "name": "Studina",
                        "latitude": "43.96667000",
                        "longitude": "24.41667000"
                    },
                    {
                        "id": 96466,
                        "name": "Studinița",
                        "latitude": "43.97691000",
                        "longitude": "24.42668000"
                    },
                    {
                        "id": 96616,
                        "name": "Tătuleşti",
                        "latitude": "44.63333000",
                        "longitude": "24.63333000"
                    },
                    {
                        "id": 106087,
                        "name": "Teslui",
                        "latitude": "44.51667000",
                        "longitude": "24.36667000"
                    },
                    {
                        "id": 106092,
                        "name": "Tia Mare",
                        "latitude": "43.86667000",
                        "longitude": "24.63333000"
                    },
                    {
                        "id": 106128,
                        "name": "Topana",
                        "latitude": "44.81667000",
                        "longitude": "24.51667000"
                    },
                    {
                        "id": 106150,
                        "name": "Traian",
                        "latitude": "44.01667000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 106170,
                        "name": "Tufeni",
                        "latitude": "44.36667000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 96683,
                        "name": "Ursa",
                        "latitude": "43.78783000",
                        "longitude": "24.63787000"
                    },
                    {
                        "id": 96685,
                        "name": "Urzica",
                        "latitude": "43.85670000",
                        "longitude": "24.28952000"
                    },
                    {
                        "id": 96953,
                        "name": "Vădastra",
                        "latitude": "43.86667000",
                        "longitude": "24.36667000"
                    },
                    {
                        "id": 96956,
                        "name": "Vădăstriţa",
                        "latitude": "43.85000000",
                        "longitude": "24.33333000"
                    },
                    {
                        "id": 96919,
                        "name": "Vâlcele",
                        "latitude": "44.28263000",
                        "longitude": "24.54376000"
                    },
                    {
                        "id": 96924,
                        "name": "Vâlcelele de Sus",
                        "latitude": "44.28461000",
                        "longitude": "24.55821000"
                    },
                    {
                        "id": 96733,
                        "name": "Valea Mare",
                        "latitude": "44.46667000",
                        "longitude": "24.43333000"
                    },
                    {
                        "id": 96740,
                        "name": "Valea Merilor",
                        "latitude": "44.47169000",
                        "longitude": "24.65611000"
                    },
                    {
                        "id": 96961,
                        "name": "Văleni",
                        "latitude": "44.23333000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 96788,
                        "name": "Verguleasa",
                        "latitude": "44.65000000",
                        "longitude": "24.31667000"
                    },
                    {
                        "id": 96850,
                        "name": "Vişina",
                        "latitude": "43.86667000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 96853,
                        "name": "Vișina Nouă",
                        "latitude": "43.87434000",
                        "longitude": "24.41820000"
                    },
                    {
                        "id": 96842,
                        "name": "Vitănești",
                        "latitude": "44.52730000",
                        "longitude": "24.69585000"
                    },
                    {
                        "id": 96840,
                        "name": "Vitomireşti",
                        "latitude": "44.86667000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 96868,
                        "name": "Vlădila",
                        "latitude": "44.00000000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 96878,
                        "name": "Voineasa",
                        "latitude": "44.28333000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 96906,
                        "name": "Vulpeni",
                        "latitude": "44.46667000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 96909,
                        "name": "Vultureşti",
                        "latitude": "44.73333000",
                        "longitude": "24.31667000"
                    }
                ]
            },
            {
                "id": 4729,
                "name": "Prahova",
                "iso2": "PH",
                "latitude": "45.08919060",
                "longitude": "26.08293130",
                "type": "department",
                "cities": [
                    {
                        "id": 89884,
                        "name": "Adunaţi",
                        "latitude": "45.13333000",
                        "longitude": "25.61667000"
                    },
                    {
                        "id": 89920,
                        "name": "Albești-Muru",
                        "latitude": "44.94440000",
                        "longitude": "26.20899000"
                    },
                    {
                        "id": 89918,
                        "name": "Albeşti-Paleologu",
                        "latitude": "44.95000000",
                        "longitude": "26.21667000"
                    },
                    {
                        "id": 89940,
                        "name": "Aluniş",
                        "latitude": "45.20000000",
                        "longitude": "25.86667000"
                    },
                    {
                        "id": 89974,
                        "name": "Apostolache",
                        "latitude": "45.13333000",
                        "longitude": "26.26667000"
                    },
                    {
                        "id": 89991,
                        "name": "Ariceștii Zeletin",
                        "latitude": "45.22221000",
                        "longitude": "26.17957000"
                    },
                    {
                        "id": 89990,
                        "name": "Ariceştii-Rahtivani",
                        "latitude": "44.95000000",
                        "longitude": "25.83333000"
                    },
                    {
                        "id": 90013,
                        "name": "Azuga",
                        "latitude": "45.45000000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 90017,
                        "name": "Baba Ana",
                        "latitude": "44.96667000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 90486,
                        "name": "Băicoi",
                        "latitude": "45.03333000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 90048,
                        "name": "Balta Doamnei",
                        "latitude": "44.75000000",
                        "longitude": "26.16667000"
                    },
                    {
                        "id": 90528,
                        "name": "Bălțești",
                        "latitude": "45.10965000",
                        "longitude": "26.12937000"
                    },
                    {
                        "id": 90533,
                        "name": "Băneşti",
                        "latitude": "45.10000000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 90544,
                        "name": "Bărcăneşti",
                        "latitude": "44.88333000",
                        "longitude": "26.05000000"
                    },
                    {
                        "id": 90552,
                        "name": "Bătești",
                        "latitude": "44.84830000",
                        "longitude": "26.04031000"
                    },
                    {
                        "id": 90554,
                        "name": "Bătrâni",
                        "latitude": "45.31425000",
                        "longitude": "26.15091000"
                    },
                    {
                        "id": 90098,
                        "name": "Berceni",
                        "latitude": "44.93333000",
                        "longitude": "26.11667000"
                    },
                    {
                        "id": 90114,
                        "name": "Bertea",
                        "latitude": "45.23333000",
                        "longitude": "25.86667000"
                    },
                    {
                        "id": 90158,
                        "name": "Blejoi",
                        "latitude": "45.00000000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 90171,
                        "name": "Bobolia",
                        "latitude": "45.09395000",
                        "longitude": "25.74259000"
                    },
                    {
                        "id": 90209,
                        "name": "Boldeşti",
                        "latitude": "44.86597000",
                        "longitude": "26.54906000"
                    },
                    {
                        "id": 90210,
                        "name": "Boldeşti-Scăeni",
                        "latitude": "45.03333000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 90225,
                        "name": "Bordenii Mari",
                        "latitude": "45.08951000",
                        "longitude": "25.86964000"
                    },
                    {
                        "id": 90280,
                        "name": "Brazii de Sus",
                        "latitude": "44.86667000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 90283,
                        "name": "Breaza",
                        "latitude": "45.18333000",
                        "longitude": "25.66667000"
                    },
                    {
                        "id": 90287,
                        "name": "Breaza de Jos",
                        "latitude": "45.17125000",
                        "longitude": "25.67571000"
                    },
                    {
                        "id": 90288,
                        "name": "Breaza de Sus",
                        "latitude": "45.19879000",
                        "longitude": "25.65578000"
                    },
                    {
                        "id": 90294,
                        "name": "Brebu Mânăstirei",
                        "latitude": "45.18333000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 90293,
                        "name": "Brebu Megieșesc",
                        "latitude": "45.16774000",
                        "longitude": "25.77474000"
                    },
                    {
                        "id": 90357,
                        "name": "Bucov",
                        "latitude": "44.96667000",
                        "longitude": "26.08333000"
                    },
                    {
                        "id": 90371,
                        "name": "Buda",
                        "latitude": "44.82443000",
                        "longitude": "26.18522000"
                    },
                    {
                        "id": 90393,
                        "name": "Bughea de Jos",
                        "latitude": "45.17985000",
                        "longitude": "26.02044000"
                    },
                    {
                        "id": 90436,
                        "name": "Buşteni",
                        "latitude": "45.40000000",
                        "longitude": "25.53333000"
                    },
                    {
                        "id": 93846,
                        "name": "Călugăreni",
                        "latitude": "45.08333000",
                        "longitude": "26.38333000"
                    },
                    {
                        "id": 93798,
                        "name": "Câmpina",
                        "latitude": "45.12619000",
                        "longitude": "25.73496000"
                    },
                    {
                        "id": 93868,
                        "name": "Cărbuneşti",
                        "latitude": "45.23333000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 93878,
                        "name": "Cătina",
                        "latitude": "45.00984000",
                        "longitude": "25.78395000"
                    },
                    {
                        "id": 90619,
                        "name": "Ceptura de Jos",
                        "latitude": "45.02088000",
                        "longitude": "26.32722000"
                    },
                    {
                        "id": 90620,
                        "name": "Ceptura de Sus",
                        "latitude": "45.01667000",
                        "longitude": "26.31667000"
                    },
                    {
                        "id": 90621,
                        "name": "Ceraşu",
                        "latitude": "45.31667000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 90672,
                        "name": "Chiojdeanca",
                        "latitude": "45.16667000",
                        "longitude": "26.26667000"
                    },
                    {
                        "id": 90692,
                        "name": "Chițorani",
                        "latitude": "44.97458000",
                        "longitude": "26.11895000"
                    },
                    {
                        "id": 90723,
                        "name": "Cioranii de Jos",
                        "latitude": "44.81667000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 90724,
                        "name": "Cioranii de Sus",
                        "latitude": "44.83923000",
                        "longitude": "26.39473000"
                    },
                    {
                        "id": 90772,
                        "name": "Coada Izvorului",
                        "latitude": "44.85766000",
                        "longitude": "25.81851000"
                    },
                    {
                        "id": 90782,
                        "name": "Cocorăștii Colț",
                        "latitude": "44.83425000",
                        "longitude": "25.89937000"
                    },
                    {
                        "id": 90783,
                        "name": "Cocorăștii Mislii",
                        "latitude": "45.08528000",
                        "longitude": "25.92206000"
                    },
                    {
                        "id": 90793,
                        "name": "Colceag",
                        "latitude": "44.95000000",
                        "longitude": "26.35000000"
                    },
                    {
                        "id": 90812,
                        "name": "Comarnic",
                        "latitude": "45.25000000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 90822,
                        "name": "Comuna Adunaţi",
                        "latitude": "45.18832000",
                        "longitude": "25.60181000"
                    },
                    {
                        "id": 90843,
                        "name": "Comuna Albeşti-Paleologu",
                        "latitude": "44.93431000",
                        "longitude": "26.23302000"
                    },
                    {
                        "id": 90859,
                        "name": "Comuna Aluniş",
                        "latitude": "45.20105000",
                        "longitude": "25.89661000"
                    },
                    {
                        "id": 90881,
                        "name": "Comuna Apostolache",
                        "latitude": "45.12123000",
                        "longitude": "26.26537000"
                    },
                    {
                        "id": 90890,
                        "name": "Comuna Ariceştii Zeletin",
                        "latitude": "45.21513000",
                        "longitude": "26.16879000"
                    },
                    {
                        "id": 90891,
                        "name": "Comuna Ariceştii-Rahtivani",
                        "latitude": "44.94512000",
                        "longitude": "25.86208000"
                    },
                    {
                        "id": 90913,
                        "name": "Comuna Baba Ana",
                        "latitude": "44.97508000",
                        "longitude": "26.48588000"
                    },
                    {
                        "id": 90930,
                        "name": "Comuna Balta Doamnei",
                        "latitude": "44.75775000",
                        "longitude": "26.19465000"
                    },
                    {
                        "id": 91228,
                        "name": "Comuna Bălţeşti",
                        "latitude": "45.10390000",
                        "longitude": "26.13040000"
                    },
                    {
                        "id": 91232,
                        "name": "Comuna Băneşti",
                        "latitude": "45.09491000",
                        "longitude": "25.77837000"
                    },
                    {
                        "id": 91241,
                        "name": "Comuna Bărcăneşti",
                        "latitude": "44.87705000",
                        "longitude": "26.06672000"
                    },
                    {
                        "id": 91247,
                        "name": "Comuna Bătrâni",
                        "latitude": "45.31425000",
                        "longitude": "26.15091000"
                    },
                    {
                        "id": 90960,
                        "name": "Comuna Berceni",
                        "latitude": "44.92376000",
                        "longitude": "26.10532000"
                    },
                    {
                        "id": 90972,
                        "name": "Comuna Bertea",
                        "latitude": "45.24083000",
                        "longitude": "25.84545000"
                    },
                    {
                        "id": 91003,
                        "name": "Comuna Blejoi",
                        "latitude": "44.98262000",
                        "longitude": "26.01881000"
                    },
                    {
                        "id": 91038,
                        "name": "Comuna Boldeşti-Gradiştea",
                        "latitude": "44.87645000",
                        "longitude": "26.53482000"
                    },
                    {
                        "id": 91086,
                        "name": "Comuna Brazi",
                        "latitude": "44.85425000",
                        "longitude": "26.00323000"
                    },
                    {
                        "id": 91093,
                        "name": "Comuna Brebu",
                        "latitude": "45.19406000",
                        "longitude": "25.77737000"
                    },
                    {
                        "id": 91134,
                        "name": "Comuna Bucov",
                        "latitude": "44.98443000",
                        "longitude": "26.10303000"
                    },
                    {
                        "id": 91574,
                        "name": "Comuna Călugăreni",
                        "latitude": "45.07998000",
                        "longitude": "26.39176000"
                    },
                    {
                        "id": 91588,
                        "name": "Comuna Cărbuneşti",
                        "latitude": "45.23050000",
                        "longitude": "26.19703000"
                    },
                    {
                        "id": 91285,
                        "name": "Comuna Ceptura",
                        "latitude": "45.04633000",
                        "longitude": "26.31341000"
                    },
                    {
                        "id": 91286,
                        "name": "Comuna Ceraşu",
                        "latitude": "45.32940000",
                        "longitude": "26.03874000"
                    },
                    {
                        "id": 91318,
                        "name": "Comuna Chiojdeanca",
                        "latitude": "45.16695000",
                        "longitude": "26.27617000"
                    },
                    {
                        "id": 91353,
                        "name": "Comuna Ciorani",
                        "latitude": "44.82997000",
                        "longitude": "26.40405000"
                    },
                    {
                        "id": 91389,
                        "name": "Comuna Cocorãştii Mislii",
                        "latitude": "45.08525000",
                        "longitude": "25.94139000"
                    },
                    {
                        "id": 91390,
                        "name": "Comuna Cocorăştii-Colţ",
                        "latitude": "44.83780000",
                        "longitude": "25.89752000"
                    },
                    {
                        "id": 91396,
                        "name": "Comuna Colceag",
                        "latitude": "44.93743000",
                        "longitude": "26.36442000"
                    },
                    {
                        "id": 91442,
                        "name": "Comuna Cornu",
                        "latitude": "45.16336000",
                        "longitude": "25.70295000"
                    },
                    {
                        "id": 91451,
                        "name": "Comuna Cosminele",
                        "latitude": "45.16600000",
                        "longitude": "25.89523000"
                    },
                    {
                        "id": 91699,
                        "name": "Comuna Drăgăneşti",
                        "latitude": "44.82739000",
                        "longitude": "26.30273000"
                    },
                    {
                        "id": 91679,
                        "name": "Comuna Drajna de Sus",
                        "latitude": "45.24352000",
                        "longitude": "26.07601000"
                    },
                    {
                        "id": 91711,
                        "name": "Comuna Dumbrava",
                        "latitude": "44.86266000",
                        "longitude": "26.21463000"
                    },
                    {
                        "id": 91714,
                        "name": "Comuna Dumbrãveşti",
                        "latitude": "45.09234000",
                        "longitude": "25.99862000"
                    },
                    {
                        "id": 91805,
                        "name": "Comuna Fântânele",
                        "latitude": "45.02536000",
                        "longitude": "26.36398000"
                    },
                    {
                        "id": 91764,
                        "name": "Comuna Filipeştii de Pădure",
                        "latitude": "44.99423000",
                        "longitude": "25.73606000"
                    },
                    {
                        "id": 91765,
                        "name": "Comuna Filipeştii de Târg",
                        "latitude": "44.94799000",
                        "longitude": "25.79812000"
                    },
                    {
                        "id": 91771,
                        "name": "Comuna Floreşti",
                        "latitude": "45.02718000",
                        "longitude": "25.78536000"
                    },
                    {
                        "id": 91797,
                        "name": "Comuna Fulga",
                        "latitude": "44.88905000",
                        "longitude": "26.44410000"
                    },
                    {
                        "id": 91847,
                        "name": "Comuna Gherghiţa",
                        "latitude": "44.79902000",
                        "longitude": "26.27275000"
                    },
                    {
                        "id": 91902,
                        "name": "Comuna Gorgota",
                        "latitude": "44.78404000",
                        "longitude": "26.07726000"
                    },
                    {
                        "id": 91903,
                        "name": "Comuna Gornet",
                        "latitude": "45.13642000",
                        "longitude": "26.08054000"
                    },
                    {
                        "id": 91904,
                        "name": "Comuna Gornet-Cricov",
                        "latitude": "45.09016000",
                        "longitude": "26.26009000"
                    },
                    {
                        "id": 91953,
                        "name": "Comuna Gura Vadului",
                        "latitude": "45.05357000",
                        "longitude": "26.44168000"
                    },
                    {
                        "id": 91954,
                        "name": "Comuna Gura Vitioarei",
                        "latitude": "45.14951000",
                        "longitude": "26.03308000"
                    },
                    {
                        "id": 92087,
                        "name": "Comuna Iordãcheanu",
                        "latitude": "45.04671000",
                        "longitude": "26.22605000"
                    },
                    {
                        "id": 92105,
                        "name": "Comuna Izvoarele",
                        "latitude": "45.27102000",
                        "longitude": "26.00931000"
                    },
                    {
                        "id": 92133,
                        "name": "Comuna Jugureni",
                        "latitude": "45.10156000",
                        "longitude": "26.42231000"
                    },
                    {
                        "id": 92137,
                        "name": "Comuna Lapoş",
                        "latitude": "45.15075000",
                        "longitude": "26.42796000"
                    },
                    {
                        "id": 92170,
                        "name": "Comuna Lipăneşti",
                        "latitude": "45.05799000",
                        "longitude": "26.02213000"
                    },
                    {
                        "id": 92392,
                        "name": "Comuna Măgurele",
                        "latitude": "45.09476000",
                        "longitude": "26.04955000"
                    },
                    {
                        "id": 92393,
                        "name": "Comuna Măgureni",
                        "latitude": "45.05203000",
                        "longitude": "25.76233000"
                    },
                    {
                        "id": 92401,
                        "name": "Comuna Măneciu",
                        "latitude": "45.33711000",
                        "longitude": "25.98547000"
                    },
                    {
                        "id": 92402,
                        "name": "Comuna Măneşti",
                        "latitude": "44.86043000",
                        "longitude": "25.83461000"
                    },
                    {
                        "id": 92494,
                        "name": "Comuna Olari",
                        "latitude": "44.79262000",
                        "longitude": "26.20498000"
                    },
                    {
                        "id": 92714,
                        "name": "Comuna Păcureţi",
                        "latitude": "45.14696000",
                        "longitude": "26.13997000"
                    },
                    {
                        "id": 92727,
                        "name": "Comuna Păuleşti",
                        "latitude": "45.00549000",
                        "longitude": "25.96991000"
                    },
                    {
                        "id": 92599,
                        "name": "Comuna Plopu",
                        "latitude": "45.02686000",
                        "longitude": "26.14227000"
                    },
                    {
                        "id": 92613,
                        "name": "Comuna Podenii Noi",
                        "latitude": "45.10423000",
                        "longitude": "26.19023000"
                    },
                    {
                        "id": 92627,
                        "name": "Comuna Poiana Câmpina",
                        "latitude": "45.12079000",
                        "longitude": "25.71905000"
                    },
                    {
                        "id": 92636,
                        "name": "Comuna Poienarii Burchii",
                        "latitude": "44.74995000",
                        "longitude": "25.99784000"
                    },
                    {
                        "id": 92664,
                        "name": "Comuna Poseşti",
                        "latitude": "45.27519000",
                        "longitude": "26.14944000"
                    },
                    {
                        "id": 92669,
                        "name": "Comuna Predeal-Sărari",
                        "latitude": "45.18891000",
                        "longitude": "26.10613000"
                    },
                    {
                        "id": 92682,
                        "name": "Comuna Proviţa de Jos",
                        "latitude": "45.11190000",
                        "longitude": "25.67791000"
                    },
                    {
                        "id": 92683,
                        "name": "Comuna Proviţa de Sus",
                        "latitude": "45.13604000",
                        "longitude": "25.63454000"
                    },
                    {
                        "id": 92691,
                        "name": "Comuna Puchenii Mari",
                        "latitude": "44.82386000",
                        "longitude": "26.07697000"
                    },
                    {
                        "id": 92820,
                        "name": "Comuna Râfov",
                        "latitude": "44.85001000",
                        "longitude": "26.20573000"
                    },
                    {
                        "id": 92863,
                        "name": "Comuna Salcia",
                        "latitude": "45.18323000",
                        "longitude": "26.32600000"
                    },
                    {
                        "id": 93093,
                        "name": "Comuna Sălciile",
                        "latitude": "44.81651000",
                        "longitude": "26.49246000"
                    },
                    {
                        "id": 93053,
                        "name": "Comuna Sângeru",
                        "latitude": "45.14325000",
                        "longitude": "26.35389000"
                    },
                    {
                        "id": 92895,
                        "name": "Comuna Scorţeni",
                        "latitude": "45.08876000",
                        "longitude": "25.84712000"
                    },
                    {
                        "id": 92917,
                        "name": "Comuna Secăria",
                        "latitude": "45.27498000",
                        "longitude": "25.68457000"
                    },
                    {
                        "id": 93531,
                        "name": "Comuna Şirna",
                        "latitude": "44.80011000",
                        "longitude": "25.94156000"
                    },
                    {
                        "id": 93536,
                        "name": "Comuna Şoimari",
                        "latitude": "45.16940000",
                        "longitude": "26.20968000"
                    },
                    {
                        "id": 93543,
                        "name": "Comuna Şotrile",
                        "latitude": "45.21183000",
                        "longitude": "25.71909000"
                    },
                    {
                        "id": 92986,
                        "name": "Comuna Starchiojd",
                        "latitude": "45.32851000",
                        "longitude": "26.17417000"
                    },
                    {
                        "id": 93553,
                        "name": "Comuna Ştefeşti",
                        "latitude": "45.24234000",
                        "longitude": "25.89879000"
                    },
                    {
                        "id": 93036,
                        "name": "Comuna Surani",
                        "latitude": "45.19425000",
                        "longitude": "26.17335000"
                    },
                    {
                        "id": 93120,
                        "name": "Comuna Talea",
                        "latitude": "45.22413000",
                        "longitude": "25.56381000"
                    },
                    {
                        "id": 93226,
                        "name": "Comuna Târgşoru Vechi",
                        "latitude": "44.87977000",
                        "longitude": "25.93082000"
                    },
                    {
                        "id": 93242,
                        "name": "Comuna Tătaru",
                        "latitude": "45.10405000",
                        "longitude": "26.31980000"
                    },
                    {
                        "id": 93134,
                        "name": "Comuna Teişani",
                        "latitude": "45.22003000",
                        "longitude": "26.01022000"
                    },
                    {
                        "id": 93136,
                        "name": "Comuna Telega",
                        "latitude": "45.14270000",
                        "longitude": "25.81441000"
                    },
                    {
                        "id": 93157,
                        "name": "Comuna Tinosu",
                        "latitude": "44.81699000",
                        "longitude": "26.00982000"
                    },
                    {
                        "id": 93171,
                        "name": "Comuna Tomşani",
                        "latitude": "44.94941000",
                        "longitude": "26.29586000"
                    },
                    {
                        "id": 93295,
                        "name": "Comuna Vadu Săpat",
                        "latitude": "45.04023000",
                        "longitude": "26.38868000"
                    },
                    {
                        "id": 93430,
                        "name": "Comuna Vâlcăneşti",
                        "latitude": "45.12377000",
                        "longitude": "25.94382000"
                    },
                    {
                        "id": 93302,
                        "name": "Comuna Valea Călugărească",
                        "latitude": "44.95527000",
                        "longitude": "26.16122000"
                    },
                    {
                        "id": 93304,
                        "name": "Comuna Valea Doftanei",
                        "latitude": "45.32105000",
                        "longitude": "25.72546000"
                    },
                    {
                        "id": 93463,
                        "name": "Comuna Vărbilău",
                        "latitude": "45.16492000",
                        "longitude": "25.95984000"
                    },
                    {
                        "id": 93591,
                        "name": "Conduratu",
                        "latitude": "44.97236000",
                        "longitude": "26.43365000"
                    },
                    {
                        "id": 93627,
                        "name": "Corlătești",
                        "latitude": "44.91341000",
                        "longitude": "26.08726000"
                    },
                    {
                        "id": 93640,
                        "name": "Cornu de Jos",
                        "latitude": "45.15665000",
                        "longitude": "25.70452000"
                    },
                    {
                        "id": 93641,
                        "name": "Cornu de Sus",
                        "latitude": "45.16667000",
                        "longitude": "25.70000000"
                    },
                    {
                        "id": 93655,
                        "name": "Cosmina de Jos",
                        "latitude": "45.15000000",
                        "longitude": "25.88333000"
                    },
                    {
                        "id": 93729,
                        "name": "Crivina",
                        "latitude": "44.78636000",
                        "longitude": "26.05604000"
                    },
                    {
                        "id": 94107,
                        "name": "Dâmbu",
                        "latitude": "45.04533000",
                        "longitude": "25.88854000"
                    },
                    {
                        "id": 93942,
                        "name": "Dițești",
                        "latitude": "44.97990000",
                        "longitude": "25.72655000"
                    },
                    {
                        "id": 93978,
                        "name": "Doftana",
                        "latitude": "45.15000000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 94056,
                        "name": "Drăgăneasa",
                        "latitude": "45.10467000",
                        "longitude": "25.68138000"
                    },
                    {
                        "id": 94057,
                        "name": "Drăgăneşti",
                        "latitude": "44.81667000",
                        "longitude": "26.30000000"
                    },
                    {
                        "id": 94026,
                        "name": "Drajna de Jos",
                        "latitude": "45.21667000",
                        "longitude": "26.05000000"
                    },
                    {
                        "id": 94027,
                        "name": "Drajna de Sus",
                        "latitude": "45.25709000",
                        "longitude": "26.07388000"
                    },
                    {
                        "id": 94077,
                        "name": "Dumbrava",
                        "latitude": "44.88333000",
                        "longitude": "26.18333000"
                    },
                    {
                        "id": 94087,
                        "name": "Dumbrăveşti",
                        "latitude": "45.08333000",
                        "longitude": "26.00000000"
                    },
                    {
                        "id": 94253,
                        "name": "Făgetu",
                        "latitude": "45.13668000",
                        "longitude": "26.02018000"
                    },
                    {
                        "id": 94240,
                        "name": "Fântânele",
                        "latitude": "45.00700000",
                        "longitude": "26.37720000"
                    },
                    {
                        "id": 94176,
                        "name": "Filipeştii de Pădure",
                        "latitude": "45.00000000",
                        "longitude": "25.75000000"
                    },
                    {
                        "id": 94177,
                        "name": "Filipeştii de Târg",
                        "latitude": "44.98333000",
                        "longitude": "25.78333000"
                    },
                    {
                        "id": 94186,
                        "name": "Floreşti",
                        "latitude": "45.05000000",
                        "longitude": "25.78333000"
                    },
                    {
                        "id": 94222,
                        "name": "Fulga de Jos",
                        "latitude": "44.88152000",
                        "longitude": "26.44258000"
                    },
                    {
                        "id": 94223,
                        "name": "Fulga de Sus",
                        "latitude": "44.90000000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 94497,
                        "name": "Găgeni",
                        "latitude": "45.02164000",
                        "longitude": "25.94585000"
                    },
                    {
                        "id": 94295,
                        "name": "Gheaba",
                        "latitude": "45.30916000",
                        "longitude": "26.00626000"
                    },
                    {
                        "id": 94307,
                        "name": "Gherghiţa",
                        "latitude": "44.80000000",
                        "longitude": "26.26667000"
                    },
                    {
                        "id": 94335,
                        "name": "Ghioșești",
                        "latitude": "45.24235000",
                        "longitude": "25.62671000"
                    },
                    {
                        "id": 94385,
                        "name": "Gorgota",
                        "latitude": "44.78333000",
                        "longitude": "26.08333000"
                    },
                    {
                        "id": 94387,
                        "name": "Gornet",
                        "latitude": "45.11667000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 94388,
                        "name": "Gornet-Cricov",
                        "latitude": "45.08333000",
                        "longitude": "26.26667000"
                    },
                    {
                        "id": 94390,
                        "name": "Goruna",
                        "latitude": "45.08696000",
                        "longitude": "25.94202000"
                    },
                    {
                        "id": 94399,
                        "name": "Gradiștea",
                        "latitude": "44.88803000",
                        "longitude": "26.51520000"
                    },
                    {
                        "id": 94426,
                        "name": "Groșani",
                        "latitude": "45.24822000",
                        "longitude": "25.94795000"
                    },
                    {
                        "id": 94450,
                        "name": "Gura Beliei",
                        "latitude": "45.21064000",
                        "longitude": "25.64946000"
                    },
                    {
                        "id": 94462,
                        "name": "Gura Vadului",
                        "latitude": "45.05000000",
                        "longitude": "26.46667000"
                    },
                    {
                        "id": 94463,
                        "name": "Gura Viţioarei",
                        "latitude": "45.15000000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 94555,
                        "name": "Homorâciu",
                        "latitude": "45.26940000",
                        "longitude": "26.01634000"
                    },
                    {
                        "id": 94670,
                        "name": "Inotești",
                        "latitude": "44.96146000",
                        "longitude": "26.35782000"
                    },
                    {
                        "id": 94681,
                        "name": "Iordăcheanu",
                        "latitude": "45.04392000",
                        "longitude": "26.23920000"
                    },
                    {
                        "id": 94712,
                        "name": "Izvoarele",
                        "latitude": "45.28376000",
                        "longitude": "26.00119000"
                    },
                    {
                        "id": 94752,
                        "name": "Jugureni",
                        "latitude": "45.10000000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 94760,
                        "name": "Lapoș",
                        "latitude": "45.15197000",
                        "longitude": "26.41911000"
                    },
                    {
                        "id": 94797,
                        "name": "Liliești",
                        "latitude": "45.03458000",
                        "longitude": "25.88554000"
                    },
                    {
                        "id": 94807,
                        "name": "Lipăneşti",
                        "latitude": "45.05000000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 94816,
                        "name": "Livadea",
                        "latitude": "45.18663000",
                        "longitude": "25.92805000"
                    },
                    {
                        "id": 94831,
                        "name": "Loloiasca",
                        "latitude": "44.96808000",
                        "longitude": "26.29141000"
                    },
                    {
                        "id": 94869,
                        "name": "Lunca Prahovei",
                        "latitude": "45.04714000",
                        "longitude": "25.77161000"
                    },
                    {
                        "id": 94905,
                        "name": "Magula",
                        "latitude": "44.93185000",
                        "longitude": "26.30114000"
                    },
                    {
                        "id": 95244,
                        "name": "Măgurele",
                        "latitude": "45.10000000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 95245,
                        "name": "Măgureni",
                        "latitude": "45.06667000",
                        "longitude": "25.73333000"
                    },
                    {
                        "id": 95257,
                        "name": "Măneciu-Ungureni",
                        "latitude": "45.31667000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 95258,
                        "name": "Măneşti",
                        "latitude": "44.86667000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 95272,
                        "name": "Mărginenii de Jos",
                        "latitude": "44.95910000",
                        "longitude": "25.75989000"
                    },
                    {
                        "id": 94957,
                        "name": "Meri",
                        "latitude": "44.83366000",
                        "longitude": "26.30863000"
                    },
                    {
                        "id": 95008,
                        "name": "Minieri",
                        "latitude": "44.98372000",
                        "longitude": "25.76083000"
                    },
                    {
                        "id": 95017,
                        "name": "Mireșu Mare",
                        "latitude": "45.13508000",
                        "longitude": "26.37714000"
                    },
                    {
                        "id": 95023,
                        "name": "Miroslăvești",
                        "latitude": "44.80383000",
                        "longitude": "26.08689000"
                    },
                    {
                        "id": 95029,
                        "name": "Mislea",
                        "latitude": "45.09668000",
                        "longitude": "25.82444000"
                    },
                    {
                        "id": 95034,
                        "name": "Mizil",
                        "latitude": "45.01667000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 95044,
                        "name": "Moceşti",
                        "latitude": "45.05000000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 95131,
                        "name": "Municipiul Câmpina",
                        "latitude": "45.12619000",
                        "longitude": "25.73496000"
                    },
                    {
                        "id": 95170,
                        "name": "Municipiul Ploieşti",
                        "latitude": "44.94281000",
                        "longitude": "26.02116000"
                    },
                    {
                        "id": 95306,
                        "name": "Nedelea",
                        "latitude": "44.97191000",
                        "longitude": "25.81647000"
                    },
                    {
                        "id": 95309,
                        "name": "Negoiești",
                        "latitude": "44.87393000",
                        "longitude": "25.98160000"
                    },
                    {
                        "id": 95392,
                        "name": "Ocina de Sus",
                        "latitude": "45.20060000",
                        "longitude": "25.59882000"
                    },
                    {
                        "id": 95415,
                        "name": "Ogretin",
                        "latitude": "45.26483000",
                        "longitude": "26.09169000"
                    },
                    {
                        "id": 95423,
                        "name": "Olari",
                        "latitude": "44.78482000",
                        "longitude": "26.21728000"
                    },
                    {
                        "id": 95428,
                        "name": "Ologeni",
                        "latitude": "44.73370000",
                        "longitude": "25.95059000"
                    },
                    {
                        "id": 95452,
                        "name": "Oraş Azuga",
                        "latitude": "45.44512000",
                        "longitude": "25.55616000"
                    },
                    {
                        "id": 95481,
                        "name": "Oraş Bãicoi",
                        "latitude": "45.04160000",
                        "longitude": "25.86964000"
                    },
                    {
                        "id": 95465,
                        "name": "Oraş Boldeşti-Scãeni",
                        "latitude": "45.02458000",
                        "longitude": "26.04574000"
                    },
                    {
                        "id": 95470,
                        "name": "Oraş Breaza",
                        "latitude": "45.18710000",
                        "longitude": "25.65851000"
                    },
                    {
                        "id": 95479,
                        "name": "Oraş Buşteni",
                        "latitude": "45.40570000",
                        "longitude": "25.53969000"
                    },
                    {
                        "id": 95495,
                        "name": "Oraş Comarnic",
                        "latitude": "45.24962000",
                        "longitude": "25.63859000"
                    },
                    {
                        "id": 95543,
                        "name": "Oraş Mizil",
                        "latitude": "45.00844000",
                        "longitude": "26.44410000"
                    },
                    {
                        "id": 95568,
                        "name": "Oraş Plopeni",
                        "latitude": "45.04406000",
                        "longitude": "25.95304000"
                    },
                    {
                        "id": 95588,
                        "name": "Oraş Sinaia",
                        "latitude": "45.34842000",
                        "longitude": "25.54937000"
                    },
                    {
                        "id": 95590,
                        "name": "Oraş Slãnic",
                        "latitude": "45.23029000",
                        "longitude": "25.94753000"
                    },
                    {
                        "id": 95613,
                        "name": "Oraş Urlaţi",
                        "latitude": "44.99692000",
                        "longitude": "26.24377000"
                    },
                    {
                        "id": 95622,
                        "name": "Oraş Vãlenii De Munte",
                        "latitude": "45.18771000",
                        "longitude": "26.03885000"
                    },
                    {
                        "id": 95679,
                        "name": "Ostrovu",
                        "latitude": "45.20351000",
                        "longitude": "25.90345000"
                    },
                    {
                        "id": 96004,
                        "name": "Păcureţi",
                        "latitude": "45.15000000",
                        "longitude": "26.13333000"
                    },
                    {
                        "id": 95698,
                        "name": "Palanca",
                        "latitude": "44.81562000",
                        "longitude": "26.19995000"
                    },
                    {
                        "id": 95705,
                        "name": "Pantazi",
                        "latitude": "44.93492000",
                        "longitude": "26.14020000"
                    },
                    {
                        "id": 95713,
                        "name": "Parepa-Rușani",
                        "latitude": "44.90577000",
                        "longitude": "26.35478000"
                    },
                    {
                        "id": 96029,
                        "name": "Păuleşti",
                        "latitude": "45.00000000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 95742,
                        "name": "Perșunari",
                        "latitude": "45.05682000",
                        "longitude": "26.44784000"
                    },
                    {
                        "id": 95781,
                        "name": "Pietriceaua",
                        "latitude": "45.21910000",
                        "longitude": "25.80859000"
                    },
                    {
                        "id": 95791,
                        "name": "Pietroșani",
                        "latitude": "44.83963000",
                        "longitude": "26.10382000"
                    },
                    {
                        "id": 95807,
                        "name": "Pleașa",
                        "latitude": "45.00583000",
                        "longitude": "26.07211000"
                    },
                    {
                        "id": 95814,
                        "name": "Ploieşti",
                        "latitude": "44.95000000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 95815,
                        "name": "Ploieștiori",
                        "latitude": "44.98157000",
                        "longitude": "26.01795000"
                    },
                    {
                        "id": 95819,
                        "name": "Plopeni",
                        "latitude": "45.06552000",
                        "longitude": "25.98114000"
                    },
                    {
                        "id": 95823,
                        "name": "Plopu",
                        "latitude": "45.01667000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 95844,
                        "name": "Podenii Noi",
                        "latitude": "45.11667000",
                        "longitude": "26.16667000"
                    },
                    {
                        "id": 95845,
                        "name": "Podenii Vechi",
                        "latitude": "45.08939000",
                        "longitude": "26.11584000"
                    },
                    {
                        "id": 95864,
                        "name": "Poiana",
                        "latitude": "45.24536000",
                        "longitude": "25.66302000"
                    },
                    {
                        "id": 95873,
                        "name": "Poiana Câmpina",
                        "latitude": "45.13333000",
                        "longitude": "25.68333000"
                    },
                    {
                        "id": 95870,
                        "name": "Poiana Copăceni",
                        "latitude": "45.16392000",
                        "longitude": "26.06918000"
                    },
                    {
                        "id": 95884,
                        "name": "Poiana Țapului",
                        "latitude": "45.39344000",
                        "longitude": "25.54066000"
                    },
                    {
                        "id": 95887,
                        "name": "Poienarii Apostoli",
                        "latitude": "44.77204000",
                        "longitude": "26.05388000"
                    },
                    {
                        "id": 95888,
                        "name": "Poienarii Burchii",
                        "latitude": "44.75000000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 95915,
                        "name": "Popești",
                        "latitude": "44.86076000",
                        "longitude": "25.99557000"
                    },
                    {
                        "id": 95925,
                        "name": "Posada",
                        "latitude": "45.28714000",
                        "longitude": "25.61882000"
                    },
                    {
                        "id": 95926,
                        "name": "Poseștii-Pământeni",
                        "latitude": "45.26667000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 95931,
                        "name": "Potigrafu",
                        "latitude": "44.78504000",
                        "longitude": "26.10014000"
                    },
                    {
                        "id": 95969,
                        "name": "Prăjani",
                        "latitude": "45.20422000",
                        "longitude": "25.95151000"
                    },
                    {
                        "id": 95962,
                        "name": "Proviţa de Jos",
                        "latitude": "45.11667000",
                        "longitude": "25.65000000"
                    },
                    {
                        "id": 95963,
                        "name": "Proviţa de Sus",
                        "latitude": "45.13333000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 95973,
                        "name": "Puchenii Mari",
                        "latitude": "44.81667000",
                        "longitude": "26.08333000"
                    },
                    {
                        "id": 95974,
                        "name": "Puchenii Moșneni",
                        "latitude": "44.81213000",
                        "longitude": "26.08701000"
                    },
                    {
                        "id": 96038,
                        "name": "Rachieri",
                        "latitude": "44.95438000",
                        "longitude": "26.12841000"
                    },
                    {
                        "id": 96165,
                        "name": "Râfov",
                        "latitude": "44.86667000",
                        "longitude": "26.13333000"
                    },
                    {
                        "id": 96112,
                        "name": "Românești",
                        "latitude": "44.86667000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 96231,
                        "name": "Salcia",
                        "latitude": "45.18333000",
                        "longitude": "26.33333000"
                    },
                    {
                        "id": 106008,
                        "name": "Sălciile",
                        "latitude": "44.81667000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 96530,
                        "name": "Sângeru",
                        "latitude": "45.13333000",
                        "longitude": "26.35000000"
                    },
                    {
                        "id": 96275,
                        "name": "Schiulești",
                        "latitude": "45.28471000",
                        "longitude": "25.95403000"
                    },
                    {
                        "id": 96280,
                        "name": "Scorţeni",
                        "latitude": "45.10000000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 96288,
                        "name": "Scurtești",
                        "latitude": "45.23759000",
                        "longitude": "25.90264000"
                    },
                    {
                        "id": 96318,
                        "name": "Secăria",
                        "latitude": "45.28333000",
                        "longitude": "25.68333000"
                    },
                    {
                        "id": 96306,
                        "name": "Seciu",
                        "latitude": "45.03275000",
                        "longitude": "26.06474000"
                    },
                    {
                        "id": 96350,
                        "name": "Sinaia",
                        "latitude": "45.35000000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 97128,
                        "name": "Șipotu",
                        "latitude": "45.04076000",
                        "longitude": "26.01714000"
                    },
                    {
                        "id": 97060,
                        "name": "Şirna",
                        "latitude": "44.80000000",
                        "longitude": "25.95000000"
                    },
                    {
                        "id": 96381,
                        "name": "Slănic",
                        "latitude": "45.25000000",
                        "longitude": "25.93333000"
                    },
                    {
                        "id": 96380,
                        "name": "Slon",
                        "latitude": "45.35521000",
                        "longitude": "26.04189000"
                    },
                    {
                        "id": 97065,
                        "name": "Şoimari",
                        "latitude": "45.18333000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 97073,
                        "name": "Şotrile",
                        "latitude": "45.21667000",
                        "longitude": "25.71667000"
                    },
                    {
                        "id": 96423,
                        "name": "Starchiojd",
                        "latitude": "45.31667000",
                        "longitude": "26.18333000"
                    },
                    {
                        "id": 97083,
                        "name": "Ştefeşti",
                        "latitude": "45.21667000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 96436,
                        "name": "Stoenești",
                        "latitude": "44.92422000",
                        "longitude": "25.85881000"
                    },
                    {
                        "id": 96452,
                        "name": "Strejnicu",
                        "latitude": "44.91676000",
                        "longitude": "25.95109000"
                    },
                    {
                        "id": 96505,
                        "name": "Surani",
                        "latitude": "45.20000000",
                        "longitude": "26.16667000"
                    },
                    {
                        "id": 106051,
                        "name": "Talea",
                        "latitude": "45.22564000",
                        "longitude": "25.56433000"
                    },
                    {
                        "id": 96591,
                        "name": "Târgşoru Vechi",
                        "latitude": "44.86667000",
                        "longitude": "25.91667000"
                    },
                    {
                        "id": 96611,
                        "name": "Tăriceni",
                        "latitude": "44.79624000",
                        "longitude": "25.96958000"
                    },
                    {
                        "id": 96618,
                        "name": "Tătărani",
                        "latitude": "44.89763000",
                        "longitude": "26.03509000"
                    },
                    {
                        "id": 96614,
                        "name": "Tătaru",
                        "latitude": "45.10000000",
                        "longitude": "26.33333000"
                    },
                    {
                        "id": 106073,
                        "name": "Teişani",
                        "latitude": "45.23333000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 106078,
                        "name": "Telega",
                        "latitude": "45.13333000",
                        "longitude": "25.78333000"
                    },
                    {
                        "id": 106090,
                        "name": "Teșila",
                        "latitude": "45.30352000",
                        "longitude": "25.72324000"
                    },
                    {
                        "id": 106104,
                        "name": "Tinosu",
                        "latitude": "44.81667000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 97139,
                        "name": "Țintea",
                        "latitude": "45.03403000",
                        "longitude": "25.90460000"
                    },
                    {
                        "id": 106126,
                        "name": "Tomşani",
                        "latitude": "44.95000000",
                        "longitude": "26.28333000"
                    },
                    {
                        "id": 106163,
                        "name": "Trăisteni",
                        "latitude": "45.33857000",
                        "longitude": "25.72767000"
                    },
                    {
                        "id": 106169,
                        "name": "Tufeni",
                        "latitude": "45.05790000",
                        "longitude": "25.83976000"
                    },
                    {
                        "id": 96679,
                        "name": "Urlaţi",
                        "latitude": "44.98333000",
                        "longitude": "26.23333000"
                    },
                    {
                        "id": 96681,
                        "name": "Urleta",
                        "latitude": "45.08732000",
                        "longitude": "25.79354000"
                    },
                    {
                        "id": 96700,
                        "name": "Vadu Părului",
                        "latitude": "44.93132000",
                        "longitude": "26.20940000"
                    },
                    {
                        "id": 96703,
                        "name": "Vadu Săpat",
                        "latitude": "45.03973000",
                        "longitude": "26.38700000"
                    },
                    {
                        "id": 96925,
                        "name": "Vâlcăneşti",
                        "latitude": "45.11667000",
                        "longitude": "25.93333000"
                    },
                    {
                        "id": 96720,
                        "name": "Valea Călugărească",
                        "latitude": "44.96667000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 96718,
                        "name": "Valea Cucului",
                        "latitude": "45.06525000",
                        "longitude": "26.22793000"
                    },
                    {
                        "id": 96724,
                        "name": "Valea Dulce",
                        "latitude": "45.11428000",
                        "longitude": "26.20787000"
                    },
                    {
                        "id": 96760,
                        "name": "Valea Târsei",
                        "latitude": "45.17711000",
                        "longitude": "25.63323000"
                    },
                    {
                        "id": 96965,
                        "name": "Vălenii de Munte",
                        "latitude": "45.18333000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 96970,
                        "name": "Vărbila",
                        "latitude": "45.04654000",
                        "longitude": "26.19691000"
                    },
                    {
                        "id": 96971,
                        "name": "Vărbilău",
                        "latitude": "45.18333000",
                        "longitude": "25.95000000"
                    },
                    {
                        "id": 96774,
                        "name": "Varnița",
                        "latitude": "44.80679000",
                        "longitude": "25.94530000"
                    }
                ]
            },
            {
                "id": 4741,
                "name": "Sălaj",
                "iso2": "SJ",
                "latitude": "47.20908130",
                "longitude": "23.21219010",
                "type": "department",
                "cities": [
                    {
                        "id": 89893,
                        "name": "Aghireș",
                        "latitude": "47.16164000",
                        "longitude": "23.01764000"
                    },
                    {
                        "id": 89900,
                        "name": "Agrij",
                        "latitude": "47.06685000",
                        "longitude": "23.09918000"
                    },
                    {
                        "id": 89936,
                        "name": "Almaşu",
                        "latitude": "46.94546000",
                        "longitude": "23.12965000"
                    },
                    {
                        "id": 90468,
                        "name": "Băbeni",
                        "latitude": "47.30000000",
                        "longitude": "23.40000000"
                    },
                    {
                        "id": 90502,
                        "name": "Bălan",
                        "latitude": "47.15599000",
                        "longitude": "23.31213000"
                    },
                    {
                        "id": 90536,
                        "name": "Bănişor",
                        "latitude": "47.10431000",
                        "longitude": "22.83731000"
                    },
                    {
                        "id": 90093,
                        "name": "Benesat",
                        "latitude": "47.41049000",
                        "longitude": "23.28904000"
                    },
                    {
                        "id": 90172,
                        "name": "Bobota",
                        "latitude": "47.38333000",
                        "longitude": "22.76667000"
                    },
                    {
                        "id": 90177,
                        "name": "Bocşa",
                        "latitude": "47.29390000",
                        "longitude": "22.91405000"
                    },
                    {
                        "id": 90199,
                        "name": "Boghiș",
                        "latitude": "47.15512000",
                        "longitude": "22.73880000"
                    },
                    {
                        "id": 90356,
                        "name": "Buciumi",
                        "latitude": "47.03333000",
                        "longitude": "23.06667000"
                    },
                    {
                        "id": 90567,
                        "name": "Camăr",
                        "latitude": "47.30000000",
                        "longitude": "22.61667000"
                    },
                    {
                        "id": 90576,
                        "name": "Carastelec",
                        "latitude": "47.30000000",
                        "longitude": "22.70000000"
                    },
                    {
                        "id": 90609,
                        "name": "Cehei",
                        "latitude": "47.25632000",
                        "longitude": "22.77507000"
                    },
                    {
                        "id": 90610,
                        "name": "Cehu Silvaniei",
                        "latitude": "47.41177000",
                        "longitude": "23.17489000"
                    },
                    {
                        "id": 90655,
                        "name": "Chendrea",
                        "latitude": "47.12236000",
                        "longitude": "23.29904000"
                    },
                    {
                        "id": 90665,
                        "name": "Chieşd",
                        "latitude": "47.38333000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 90762,
                        "name": "Cizer",
                        "latitude": "47.06667000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 90832,
                        "name": "Comuna Agrij",
                        "latitude": "47.06784000",
                        "longitude": "23.09764000"
                    },
                    {
                        "id": 90856,
                        "name": "Comuna Almaşu",
                        "latitude": "46.95000000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 91200,
                        "name": "Comuna Băbeni",
                        "latitude": "47.30000000",
                        "longitude": "23.40000000"
                    },
                    {
                        "id": 91211,
                        "name": "Comuna Bălan",
                        "latitude": "47.15768000",
                        "longitude": "23.31187000"
                    },
                    {
                        "id": 91234,
                        "name": "Comuna Bănişor",
                        "latitude": "47.10215000",
                        "longitude": "22.83646000"
                    },
                    {
                        "id": 90957,
                        "name": "Comuna Benesat",
                        "latitude": "47.41667000",
                        "longitude": "23.30000000"
                    },
                    {
                        "id": 91012,
                        "name": "Comuna Bobota",
                        "latitude": "47.38333000",
                        "longitude": "22.76667000"
                    },
                    {
                        "id": 91016,
                        "name": "Comuna Bocşa",
                        "latitude": "47.30332000",
                        "longitude": "22.91241000"
                    },
                    {
                        "id": 91032,
                        "name": "Comuna Boghiş",
                        "latitude": "47.15611000",
                        "longitude": "22.72706000"
                    },
                    {
                        "id": 91133,
                        "name": "Comuna Buciumi",
                        "latitude": "47.03476000",
                        "longitude": "23.02546000"
                    },
                    {
                        "id": 91256,
                        "name": "Comuna Camăr",
                        "latitude": "47.31728000",
                        "longitude": "22.62815000"
                    },
                    {
                        "id": 91258,
                        "name": "Comuna Carastelec",
                        "latitude": "47.30714000",
                        "longitude": "22.68062000"
                    },
                    {
                        "id": 91277,
                        "name": "Comuna Cehu Silvaniei",
                        "latitude": "47.41293000",
                        "longitude": "23.17660000"
                    },
                    {
                        "id": 91313,
                        "name": "Comuna Chieşd",
                        "latitude": "47.36505000",
                        "longitude": "22.89296000"
                    },
                    {
                        "id": 91378,
                        "name": "Comuna Cizer",
                        "latitude": "47.06684000",
                        "longitude": "22.88129000"
                    },
                    {
                        "id": 91473,
                        "name": "Comuna Coşeiu",
                        "latitude": "47.33189000",
                        "longitude": "23.01282000"
                    },
                    {
                        "id": 91487,
                        "name": "Comuna Crasna",
                        "latitude": "47.16191000",
                        "longitude": "22.82979000"
                    },
                    {
                        "id": 91488,
                        "name": "Comuna Creaca",
                        "latitude": "47.19490000",
                        "longitude": "23.22760000"
                    },
                    {
                        "id": 91506,
                        "name": "Comuna Crişeni",
                        "latitude": "47.25028000",
                        "longitude": "23.06965000"
                    },
                    {
                        "id": 91501,
                        "name": "Comuna Cristolţ",
                        "latitude": "47.21231000",
                        "longitude": "23.43745000"
                    },
                    {
                        "id": 91538,
                        "name": "Comuna Cuzăplac",
                        "latitude": "46.94651000",
                        "longitude": "23.21895000"
                    },
                    {
                        "id": 91639,
                        "name": "Comuna Dobrin",
                        "latitude": "47.30812000",
                        "longitude": "23.11367000"
                    },
                    {
                        "id": 91678,
                        "name": "Comuna Dragu",
                        "latitude": "47.03493000",
                        "longitude": "23.41089000"
                    },
                    {
                        "id": 91761,
                        "name": "Comuna Fildu De Jos",
                        "latitude": "46.91837000",
                        "longitude": "23.01591000"
                    },
                    {
                        "id": 91962,
                        "name": "Comuna Gâlgău",
                        "latitude": "47.27667000",
                        "longitude": "23.68763000"
                    },
                    {
                        "id": 91964,
                        "name": "Comuna Gârbou",
                        "latitude": "47.15447000",
                        "longitude": "23.43522000"
                    },
                    {
                        "id": 91990,
                        "name": "Comuna Halmăşd",
                        "latitude": "47.15903000",
                        "longitude": "22.59664000"
                    },
                    {
                        "id": 91997,
                        "name": "Comuna Hereclean",
                        "latitude": "47.26297000",
                        "longitude": "23.00704000"
                    },
                    {
                        "id": 91999,
                        "name": "Comuna Hida",
                        "latitude": "47.07831000",
                        "longitude": "23.33841000"
                    },
                    {
                        "id": 92021,
                        "name": "Comuna Horoatu Crasnei",
                        "latitude": "47.09729000",
                        "longitude": "22.92131000"
                    },
                    {
                        "id": 92069,
                        "name": "Comuna Ileanda",
                        "latitude": "47.34501000",
                        "longitude": "23.60827000"
                    },
                    {
                        "id": 92088,
                        "name": "Comuna Ip",
                        "latitude": "47.22138000",
                        "longitude": "22.62406000"
                    },
                    {
                        "id": 92156,
                        "name": "Comuna Letca",
                        "latitude": "47.34948000",
                        "longitude": "23.42865000"
                    },
                    {
                        "id": 92186,
                        "name": "Comuna Lozna",
                        "latitude": "47.31510000",
                        "longitude": "23.48507000"
                    },
                    {
                        "id": 92385,
                        "name": "Comuna Măerişte",
                        "latitude": "47.29893000",
                        "longitude": "22.75444000"
                    },
                    {
                        "id": 92240,
                        "name": "Comuna Marca",
                        "latitude": "47.23495000",
                        "longitude": "22.55089000"
                    },
                    {
                        "id": 93586,
                        "name": "Comună Meseşenii de Jos",
                        "latitude": "47.14568000",
                        "longitude": "22.99133000"
                    },
                    {
                        "id": 92304,
                        "name": "Comuna Mirşid",
                        "latitude": "47.23132000",
                        "longitude": "23.14308000"
                    },
                    {
                        "id": 92464,
                        "name": "Comuna Năpradea",
                        "latitude": "47.34497000",
                        "longitude": "23.31603000"
                    },
                    {
                        "id": 92459,
                        "name": "Comuna Nuşfalău",
                        "latitude": "47.21355000",
                        "longitude": "22.70784000"
                    },
                    {
                        "id": 92549,
                        "name": "Comuna Pericei",
                        "latitude": "47.24643000",
                        "longitude": "22.87644000"
                    },
                    {
                        "id": 92598,
                        "name": "Comuna Plopiş",
                        "latitude": "47.11425000",
                        "longitude": "22.64240000"
                    },
                    {
                        "id": 92625,
                        "name": "Comuna Poiana Blenchii",
                        "latitude": "47.30626000",
                        "longitude": "23.76012000"
                    },
                    {
                        "id": 92785,
                        "name": "Comuna Românaşi",
                        "latitude": "47.11470000",
                        "longitude": "23.17627000"
                    },
                    {
                        "id": 92814,
                        "name": "Comuna Rus",
                        "latitude": "47.27800000",
                        "longitude": "23.57813000"
                    },
                    {
                        "id": 93044,
                        "name": "Comuna Sâg",
                        "latitude": "47.07041000",
                        "longitude": "22.78671000"
                    },
                    {
                        "id": 93101,
                        "name": "Comuna Sălăţig",
                        "latitude": "47.35417000",
                        "longitude": "23.15585000"
                    },
                    {
                        "id": 93497,
                        "name": "Comuna Şamşud",
                        "latitude": "47.33234000",
                        "longitude": "22.95373000"
                    },
                    {
                        "id": 93057,
                        "name": "Comuna Sânmihaiu Almaşului",
                        "latitude": "47.03822000",
                        "longitude": "23.21448000"
                    },
                    {
                        "id": 93566,
                        "name": "Comuna Şărmăşag",
                        "latitude": "47.33342000",
                        "longitude": "22.81988000"
                    },
                    {
                        "id": 93522,
                        "name": "Comuna Şimişna",
                        "latitude": "47.21179000",
                        "longitude": "23.61546000"
                    },
                    {
                        "id": 92975,
                        "name": "Comuna Someş-Odorhei",
                        "latitude": "47.32846000",
                        "longitude": "23.22294000"
                    },
                    {
                        "id": 93039,
                        "name": "Comuna Surduc",
                        "latitude": "47.24433000",
                        "longitude": "23.37313000"
                    },
                    {
                        "id": 93191,
                        "name": "Comuna Treznea",
                        "latitude": "47.09432000",
                        "longitude": "23.10166000"
                    },
                    {
                        "id": 93297,
                        "name": "Comuna Valcãu De Jos",
                        "latitude": "47.10960000",
                        "longitude": "22.73662000"
                    },
                    {
                        "id": 93448,
                        "name": "Comuna Vârşolţ",
                        "latitude": "47.19711000",
                        "longitude": "22.94529000"
                    },
                    {
                        "id": 93470,
                        "name": "Comuna Zalha",
                        "latitude": "47.19786000",
                        "longitude": "23.53139000"
                    },
                    {
                        "id": 93478,
                        "name": "Comuna Zimbor",
                        "latitude": "46.98887000",
                        "longitude": "23.29029000"
                    },
                    {
                        "id": 93689,
                        "name": "Coşeiu",
                        "latitude": "47.31667000",
                        "longitude": "22.98333000"
                    },
                    {
                        "id": 93707,
                        "name": "Crasna",
                        "latitude": "47.16667000",
                        "longitude": "22.90000000"
                    },
                    {
                        "id": 93709,
                        "name": "Creaca",
                        "latitude": "47.20000000",
                        "longitude": "23.25000000"
                    },
                    {
                        "id": 93735,
                        "name": "Crişeni",
                        "latitude": "47.23333000",
                        "longitude": "23.05000000"
                    },
                    {
                        "id": 93725,
                        "name": "Cristolţ",
                        "latitude": "47.20000000",
                        "longitude": "23.43333000"
                    },
                    {
                        "id": 93789,
                        "name": "Cuzăplac",
                        "latitude": "46.96667000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 93911,
                        "name": "Deja",
                        "latitude": "47.35537000",
                        "longitude": "23.18300000"
                    },
                    {
                        "id": 93924,
                        "name": "Derșida",
                        "latitude": "47.38810000",
                        "longitude": "22.80170000"
                    },
                    {
                        "id": 93940,
                        "name": "Dioșod",
                        "latitude": "47.29238000",
                        "longitude": "23.02099000"
                    },
                    {
                        "id": 93959,
                        "name": "Dobrin",
                        "latitude": "47.28333000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 94024,
                        "name": "Dragu",
                        "latitude": "47.01667000",
                        "longitude": "23.40000000"
                    },
                    {
                        "id": 94169,
                        "name": "Fildu de Jos",
                        "latitude": "46.93333000",
                        "longitude": "23.06667000"
                    },
                    {
                        "id": 94478,
                        "name": "Gâlgău",
                        "latitude": "47.28183000",
                        "longitude": "23.70157000"
                    },
                    {
                        "id": 94479,
                        "name": "Gâlgău Almaşului",
                        "latitude": "47.20000000",
                        "longitude": "23.33333000"
                    },
                    {
                        "id": 94482,
                        "name": "Gârbou",
                        "latitude": "47.15000000",
                        "longitude": "23.43333000"
                    },
                    {
                        "id": 94355,
                        "name": "Giurtelecu Șimleului",
                        "latitude": "47.29680000",
                        "longitude": "22.79557000"
                    },
                    {
                        "id": 94519,
                        "name": "Halmăşd",
                        "latitude": "47.15000000",
                        "longitude": "22.61667000"
                    },
                    {
                        "id": 94531,
                        "name": "Hereclean",
                        "latitude": "47.25000000",
                        "longitude": "23.01667000"
                    },
                    {
                        "id": 94534,
                        "name": "Hida",
                        "latitude": "47.06667000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 94565,
                        "name": "Horoatu Crasnei",
                        "latitude": "47.13333000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 94655,
                        "name": "Ileanda",
                        "latitude": "47.33333000",
                        "longitude": "23.63333000"
                    },
                    {
                        "id": 94682,
                        "name": "Ip",
                        "latitude": "47.23333000",
                        "longitude": "22.65000000"
                    },
                    {
                        "id": 94730,
                        "name": "Jibou",
                        "latitude": "47.25896000",
                        "longitude": "23.25651000"
                    },
                    {
                        "id": 94785,
                        "name": "Letca",
                        "latitude": "47.33333000",
                        "longitude": "23.45000000"
                    },
                    {
                        "id": 94835,
                        "name": "Lozna",
                        "latitude": "47.31667000",
                        "longitude": "23.46667000"
                    },
                    {
                        "id": 95236,
                        "name": "Măerişte",
                        "latitude": "47.31667000",
                        "longitude": "22.80000000"
                    },
                    {
                        "id": 94909,
                        "name": "Mal",
                        "latitude": "47.06979000",
                        "longitude": "22.81441000"
                    },
                    {
                        "id": 94925,
                        "name": "Marca",
                        "latitude": "47.21667000",
                        "longitude": "22.56667000"
                    },
                    {
                        "id": 94931,
                        "name": "Marin",
                        "latitude": "47.12754000",
                        "longitude": "22.81055000"
                    },
                    {
                        "id": 94961,
                        "name": "Meseşenii de Jos",
                        "latitude": "47.15000000",
                        "longitude": "22.98333000"
                    },
                    {
                        "id": 95026,
                        "name": "Mirşid",
                        "latitude": "47.23333000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 95197,
                        "name": "Municipiul Zalãu",
                        "latitude": "47.16633000",
                        "longitude": "23.09660000"
                    },
                    {
                        "id": 95373,
                        "name": "Năpradea",
                        "latitude": "47.36667000",
                        "longitude": "23.31667000"
                    },
                    {
                        "id": 95366,
                        "name": "Nuşfalău",
                        "latitude": "47.20000000",
                        "longitude": "22.73333000"
                    },
                    {
                        "id": 95640,
                        "name": "Oraș Jibou",
                        "latitude": "47.26001000",
                        "longitude": "23.25488000"
                    },
                    {
                        "id": 95629,
                        "name": "Oraş Şimleu Silvaniei",
                        "latitude": "47.23018000",
                        "longitude": "22.79440000"
                    },
                    {
                        "id": 95719,
                        "name": "Peceiu",
                        "latitude": "47.12415000",
                        "longitude": "22.86238000"
                    },
                    {
                        "id": 95729,
                        "name": "Pericei",
                        "latitude": "47.23333000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 95821,
                        "name": "Plopiş",
                        "latitude": "47.13333000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 95868,
                        "name": "Poiana Blenchii",
                        "latitude": "47.30000000",
                        "longitude": "23.75000000"
                    },
                    {
                        "id": 95986,
                        "name": "Pusta",
                        "latitude": "47.24596000",
                        "longitude": "22.72374000"
                    },
                    {
                        "id": 96109,
                        "name": "Românaşi",
                        "latitude": "47.10000000",
                        "longitude": "23.18333000"
                    },
                    {
                        "id": 96157,
                        "name": "Rus",
                        "latitude": "47.28333000",
                        "longitude": "23.60000000"
                    },
                    {
                        "id": 96516,
                        "name": "Sâg",
                        "latitude": "47.07545000",
                        "longitude": "22.78084000"
                    },
                    {
                        "id": 106024,
                        "name": "Sălăţig",
                        "latitude": "47.36667000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 97029,
                        "name": "Şamşud",
                        "latitude": "47.35000000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 96534,
                        "name": "Sânmihaiu Almaşului",
                        "latitude": "47.01667000",
                        "longitude": "23.30000000"
                    },
                    {
                        "id": 97098,
                        "name": "Şărmăşag",
                        "latitude": "47.35000000",
                        "longitude": "22.83333000"
                    },
                    {
                        "id": 97124,
                        "name": "Șimișna",
                        "latitude": "47.23202000",
                        "longitude": "23.62370000"
                    },
                    {
                        "id": 97052,
                        "name": "Şimleu Silvaniei",
                        "latitude": "47.23333000",
                        "longitude": "22.80000000"
                    },
                    {
                        "id": 96408,
                        "name": "Someş-Odorhei",
                        "latitude": "47.31667000",
                        "longitude": "23.26667000"
                    },
                    {
                        "id": 96474,
                        "name": "Stârciu",
                        "latitude": "47.08747000",
                        "longitude": "22.91998000"
                    },
                    {
                        "id": 96508,
                        "name": "Surduc",
                        "latitude": "47.25000000",
                        "longitude": "23.35000000"
                    },
                    {
                        "id": 106098,
                        "name": "Tihău",
                        "latitude": "47.22724000",
                        "longitude": "23.32964000"
                    },
                    {
                        "id": 106154,
                        "name": "Treznea",
                        "latitude": "47.10000000",
                        "longitude": "23.11667000"
                    },
                    {
                        "id": 96706,
                        "name": "Valcău de Jos",
                        "latitude": "47.11667000",
                        "longitude": "22.73333000"
                    },
                    {
                        "id": 96949,
                        "name": "Vârşolţ",
                        "latitude": "47.20000000",
                        "longitude": "22.93333000"
                    },
                    {
                        "id": 96982,
                        "name": "Zalău",
                        "latitude": "47.20000000",
                        "longitude": "23.05000000"
                    },
                    {
                        "id": 96981,
                        "name": "Zalha",
                        "latitude": "47.18333000",
                        "longitude": "23.53333000"
                    },
                    {
                        "id": 97019,
                        "name": "Zăuan",
                        "latitude": "47.22495000",
                        "longitude": "22.66328000"
                    },
                    {
                        "id": 96994,
                        "name": "Zimbor",
                        "latitude": "47.00000000",
                        "longitude": "23.26667000"
                    }
                ]
            },
            {
                "id": 4746,
                "name": "Satu Mare",
                "iso2": "SM",
                "latitude": "47.76689050",
                "longitude": "22.92413770",
                "type": "department",
                "cities": [
                    {
                        "id": 89878,
                        "name": "Acâş",
                        "latitude": "47.53333000",
                        "longitude": "22.78333000"
                    },
                    {
                        "id": 89901,
                        "name": "Agriș",
                        "latitude": "47.88075000",
                        "longitude": "23.00340000"
                    },
                    {
                        "id": 89957,
                        "name": "Andrid",
                        "latitude": "47.51667000",
                        "longitude": "22.35000000"
                    },
                    {
                        "id": 89967,
                        "name": "Apa",
                        "latitude": "47.76667000",
                        "longitude": "23.20000000"
                    },
                    {
                        "id": 89983,
                        "name": "Ardud",
                        "latitude": "47.63333000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 90020,
                        "name": "Babța",
                        "latitude": "47.45778000",
                        "longitude": "22.94283000"
                    },
                    {
                        "id": 90458,
                        "name": "Bârsău de Sus",
                        "latitude": "47.60000000",
                        "longitude": "23.21667000"
                    },
                    {
                        "id": 90551,
                        "name": "Bătarci",
                        "latitude": "48.03333000",
                        "longitude": "23.16667000"
                    },
                    {
                        "id": 90092,
                        "name": "Beltiug",
                        "latitude": "47.55000000",
                        "longitude": "22.85000000"
                    },
                    {
                        "id": 90116,
                        "name": "Berveni",
                        "latitude": "47.75000000",
                        "longitude": "22.46667000"
                    },
                    {
                        "id": 90154,
                        "name": "Bixad",
                        "latitude": "47.93333000",
                        "longitude": "23.40000000"
                    },
                    {
                        "id": 90190,
                        "name": "Bogdand",
                        "latitude": "47.41667000",
                        "longitude": "22.93333000"
                    },
                    {
                        "id": 90204,
                        "name": "Boinești",
                        "latitude": "47.91567000",
                        "longitude": "23.35117000"
                    },
                    {
                        "id": 90244,
                        "name": "Botiz",
                        "latitude": "47.83333000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 93840,
                        "name": "Călineşti-Oaş",
                        "latitude": "47.90000000",
                        "longitude": "23.30000000"
                    },
                    {
                        "id": 93855,
                        "name": "Cămărzana",
                        "latitude": "48.00000000",
                        "longitude": "23.31667000"
                    },
                    {
                        "id": 93853,
                        "name": "Cămin",
                        "latitude": "47.72836000",
                        "longitude": "22.47987000"
                    },
                    {
                        "id": 93858,
                        "name": "Căpleni",
                        "latitude": "47.71667000",
                        "longitude": "22.50000000"
                    },
                    {
                        "id": 93872,
                        "name": "Cărășeu",
                        "latitude": "47.74126000",
                        "longitude": "23.09798000"
                    },
                    {
                        "id": 90580,
                        "name": "Carei",
                        "latitude": "47.68333000",
                        "longitude": "22.46667000"
                    },
                    {
                        "id": 93882,
                        "name": "Căuaş",
                        "latitude": "47.56667000",
                        "longitude": "22.55000000"
                    },
                    {
                        "id": 90608,
                        "name": "Cehal",
                        "latitude": "47.38333000",
                        "longitude": "22.60000000"
                    },
                    {
                        "id": 90641,
                        "name": "Certeze",
                        "latitude": "47.90000000",
                        "longitude": "23.46667000"
                    },
                    {
                        "id": 90700,
                        "name": "Cidreag",
                        "latitude": "47.98677000",
                        "longitude": "22.96395000"
                    },
                    {
                        "id": 90752,
                        "name": "Ciumești",
                        "latitude": "47.66382000",
                        "longitude": "22.34069000"
                    },
                    {
                        "id": 90820,
                        "name": "Comuna Acâş",
                        "latitude": "47.53143000",
                        "longitude": "22.74106000"
                    },
                    {
                        "id": 90833,
                        "name": "Comuna Agriş",
                        "latitude": "47.87377000",
                        "longitude": "23.00343000"
                    },
                    {
                        "id": 90869,
                        "name": "Comuna Andrid",
                        "latitude": "47.51720000",
                        "longitude": "22.34688000"
                    },
                    {
                        "id": 90875,
                        "name": "Comuna Apa",
                        "latitude": "47.74934000",
                        "longitude": "23.18966000"
                    },
                    {
                        "id": 91195,
                        "name": "Comuna Bârsău",
                        "latitude": "47.59376000",
                        "longitude": "23.24257000"
                    },
                    {
                        "id": 91245,
                        "name": "Comuna Bătarci",
                        "latitude": "48.04054000",
                        "longitude": "23.14274000"
                    },
                    {
                        "id": 90956,
                        "name": "Comuna Beltiug",
                        "latitude": "47.56523000",
                        "longitude": "22.85452000"
                    },
                    {
                        "id": 90974,
                        "name": "Comuna Berveni",
                        "latitude": "47.74896000",
                        "longitude": "22.47553000"
                    },
                    {
                        "id": 91000,
                        "name": "Comuna Bixad",
                        "latitude": "47.92031000",
                        "longitude": "23.37337000"
                    },
                    {
                        "id": 91025,
                        "name": "Comuna Bogdand",
                        "latitude": "47.41824000",
                        "longitude": "22.92868000"
                    },
                    {
                        "id": 91061,
                        "name": "Comuna Botiz",
                        "latitude": "47.83285000",
                        "longitude": "22.94865000"
                    },
                    {
                        "id": 91559,
                        "name": "Comuna Cãlineşti-Oaş",
                        "latitude": "47.90340000",
                        "longitude": "23.27351000"
                    },
                    {
                        "id": 91581,
                        "name": "Comuna Cămărzana",
                        "latitude": "47.99435000",
                        "longitude": "23.30874000"
                    },
                    {
                        "id": 91563,
                        "name": "Comuna Cãmin",
                        "latitude": "47.72836000",
                        "longitude": "22.47987000"
                    },
                    {
                        "id": 91583,
                        "name": "Comuna Căpleni",
                        "latitude": "47.70942000",
                        "longitude": "22.50637000"
                    },
                    {
                        "id": 91596,
                        "name": "Comuna Căuaş",
                        "latitude": "47.57998000",
                        "longitude": "22.55546000"
                    },
                    {
                        "id": 91276,
                        "name": "Comuna Cehal",
                        "latitude": "47.38440000",
                        "longitude": "22.59613000"
                    },
                    {
                        "id": 91298,
                        "name": "Comuna Certeze",
                        "latitude": "47.92014000",
                        "longitude": "23.47350000"
                    },
                    {
                        "id": 91371,
                        "name": "Comuna Ciumeşti",
                        "latitude": "47.66308000",
                        "longitude": "22.33452000"
                    },
                    {
                        "id": 91484,
                        "name": "Comuna Craidorolţ",
                        "latitude": "47.59793000",
                        "longitude": "22.69883000"
                    },
                    {
                        "id": 91510,
                        "name": "Comuna Crucişor",
                        "latitude": "47.65949000",
                        "longitude": "23.24776000"
                    },
                    {
                        "id": 91523,
                        "name": "Comuna Culciu",
                        "latitude": "47.75246000",
                        "longitude": "23.05593000"
                    },
                    {
                        "id": 91631,
                        "name": "Comuna Doba",
                        "latitude": "47.74588000",
                        "longitude": "22.68383000"
                    },
                    {
                        "id": 91667,
                        "name": "Comuna Dorolţ",
                        "latitude": "47.84524000",
                        "longitude": "22.78642000"
                    },
                    {
                        "id": 91776,
                        "name": "Comuna Foieni",
                        "latitude": "47.70000000",
                        "longitude": "22.38333000"
                    },
                    {
                        "id": 91850,
                        "name": "Comuna Gherţa Mică",
                        "latitude": "47.93724000",
                        "longitude": "23.22169000"
                    },
                    {
                        "id": 91989,
                        "name": "Comuna Halmeu",
                        "latitude": "47.97833000",
                        "longitude": "23.05362000"
                    },
                    {
                        "id": 92005,
                        "name": "Comuna Hodod",
                        "latitude": "47.39870000",
                        "longitude": "23.04633000"
                    },
                    {
                        "id": 92012,
                        "name": "Comuna Homoroade",
                        "latitude": "47.63896000",
                        "longitude": "23.06593000"
                    },
                    {
                        "id": 92141,
                        "name": "Comuna Lazuri",
                        "latitude": "47.89143000",
                        "longitude": "22.87213000"
                    },
                    {
                        "id": 92250,
                        "name": "Comuna Medieşu Aurit",
                        "latitude": "47.79451000",
                        "longitude": "23.15360000"
                    },
                    {
                        "id": 92268,
                        "name": "Comuna Micula",
                        "latitude": "47.91687000",
                        "longitude": "22.93652000"
                    },
                    {
                        "id": 92316,
                        "name": "Comuna Moftinu",
                        "latitude": "47.68333000",
                        "longitude": "22.60000000"
                    },
                    {
                        "id": 92483,
                        "name": "Comuna Odoreu",
                        "latitude": "47.79427000",
                        "longitude": "22.99639000"
                    },
                    {
                        "id": 92505,
                        "name": "Comuna Oraşu Nou",
                        "latitude": "47.83470000",
                        "longitude": "23.30211000"
                    },
                    {
                        "id": 92713,
                        "name": "Comuna Pãuleşti",
                        "latitude": "47.74992000",
                        "longitude": "22.94743000"
                    },
                    {
                        "id": 92562,
                        "name": "Comuna Petreşti",
                        "latitude": "47.58993000",
                        "longitude": "22.35972000"
                    },
                    {
                        "id": 92586,
                        "name": "Comuna Pir",
                        "latitude": "47.46650000",
                        "longitude": "22.39380000"
                    },
                    {
                        "id": 92590,
                        "name": "Comuna Pişcolt",
                        "latitude": "47.59761000",
                        "longitude": "22.27498000"
                    },
                    {
                        "id": 92648,
                        "name": "Comuna Pomi",
                        "latitude": "47.68071000",
                        "longitude": "23.32362000"
                    },
                    {
                        "id": 92663,
                        "name": "Comuna Porumbeşti",
                        "latitude": "47.98491000",
                        "longitude": "22.97236000"
                    },
                    {
                        "id": 92741,
                        "name": "Comuna Racşa",
                        "latitude": "47.82068000",
                        "longitude": "23.33247000"
                    },
                    {
                        "id": 93088,
                        "name": "Comuna Săcăşeni",
                        "latitude": "47.46964000",
                        "longitude": "22.68273000"
                    },
                    {
                        "id": 92870,
                        "name": "Comuna Sanislău",
                        "latitude": "47.63116000",
                        "longitude": "22.33109000"
                    },
                    {
                        "id": 92872,
                        "name": "Comuna Santău",
                        "latitude": "47.51152000",
                        "longitude": "22.47327000"
                    },
                    {
                        "id": 93113,
                        "name": "Comuna Săuca",
                        "latitude": "47.46041000",
                        "longitude": "22.48621000"
                    },
                    {
                        "id": 92970,
                        "name": "Comuna Socond",
                        "latitude": "47.54018000",
                        "longitude": "22.98135000"
                    },
                    {
                        "id": 93034,
                        "name": "Comuna Supur",
                        "latitude": "47.45826000",
                        "longitude": "22.80767000"
                    },
                    {
                        "id": 93127,
                        "name": "Comuna Tarna Mare",
                        "latitude": "48.08356000",
                        "longitude": "23.19491000"
                    },
                    {
                        "id": 93231,
                        "name": "Comuna Târşolţ",
                        "latitude": "47.95000000",
                        "longitude": "23.35000000"
                    },
                    {
                        "id": 93140,
                        "name": "Comuna Terebeşti",
                        "latitude": "47.67823000",
                        "longitude": "22.74226000"
                    },
                    {
                        "id": 93158,
                        "name": "Comuna Tiream",
                        "latitude": "47.58553000",
                        "longitude": "22.43993000"
                    },
                    {
                        "id": 93218,
                        "name": "Comuna Turţ",
                        "latitude": "47.98018000",
                        "longitude": "23.20968000"
                    },
                    {
                        "id": 93217,
                        "name": "Comuna Turulung",
                        "latitude": "47.92351000",
                        "longitude": "23.10382000"
                    },
                    {
                        "id": 93286,
                        "name": "Comuna Urziceni",
                        "latitude": "47.73286000",
                        "longitude": "22.40181000"
                    },
                    {
                        "id": 93329,
                        "name": "Comuna Valea Vinului",
                        "latitude": "47.69553000",
                        "longitude": "23.18488000"
                    },
                    {
                        "id": 93331,
                        "name": "Comuna Vama",
                        "latitude": "47.84354000",
                        "longitude": "23.39660000"
                    },
                    {
                        "id": 93347,
                        "name": "Comuna Vetiş",
                        "latitude": "47.79292000",
                        "longitude": "22.75623000"
                    },
                    {
                        "id": 93357,
                        "name": "Comuna Viile Satu Mare",
                        "latitude": "47.66667000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 93703,
                        "name": "Craidorolţ",
                        "latitude": "47.61667000",
                        "longitude": "22.70000000"
                    },
                    {
                        "id": 93743,
                        "name": "Crucişor",
                        "latitude": "47.68333000",
                        "longitude": "23.25000000"
                    },
                    {
                        "id": 93767,
                        "name": "Culciu Mic",
                        "latitude": "47.76667000",
                        "longitude": "23.03333000"
                    },
                    {
                        "id": 93893,
                        "name": "Dara",
                        "latitude": "47.81636000",
                        "longitude": "22.75216000"
                    },
                    {
                        "id": 93906,
                        "name": "Decebal",
                        "latitude": "47.76630000",
                        "longitude": "22.75603000"
                    },
                    {
                        "id": 93944,
                        "name": "Doba",
                        "latitude": "47.73333000",
                        "longitude": "22.71667000"
                    },
                    {
                        "id": 93946,
                        "name": "Dobra",
                        "latitude": "47.49477000",
                        "longitude": "22.82762000"
                    },
                    {
                        "id": 93994,
                        "name": "Domănești",
                        "latitude": "47.71071000",
                        "longitude": "22.58975000"
                    },
                    {
                        "id": 94007,
                        "name": "Dorolţ",
                        "latitude": "47.85000000",
                        "longitude": "22.81667000"
                    },
                    {
                        "id": 94054,
                        "name": "Drăgușeni",
                        "latitude": "47.90541000",
                        "longitude": "23.07780000"
                    },
                    {
                        "id": 94078,
                        "name": "Dumbrava",
                        "latitude": "47.84418000",
                        "longitude": "23.08060000"
                    },
                    {
                        "id": 94196,
                        "name": "Foieni",
                        "latitude": "47.70000000",
                        "longitude": "22.38333000"
                    },
                    {
                        "id": 94315,
                        "name": "Gherța Mare",
                        "latitude": "47.96884000",
                        "longitude": "23.20853000"
                    },
                    {
                        "id": 94314,
                        "name": "Gherţa Mică",
                        "latitude": "47.93333000",
                        "longitude": "23.23333000"
                    },
                    {
                        "id": 94518,
                        "name": "Halmeu",
                        "latitude": "47.96667000",
                        "longitude": "23.01667000"
                    },
                    {
                        "id": 94542,
                        "name": "Hodod",
                        "latitude": "47.40000000",
                        "longitude": "23.03333000"
                    },
                    {
                        "id": 94554,
                        "name": "Homorodu de Jos",
                        "latitude": "47.66667000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 94586,
                        "name": "Huta Certeze",
                        "latitude": "47.92583000",
                        "longitude": "23.48715000"
                    },
                    {
                        "id": 94672,
                        "name": "Iojib",
                        "latitude": "47.81617000",
                        "longitude": "23.15603000"
                    },
                    {
                        "id": 94766,
                        "name": "Lazuri",
                        "latitude": "47.85000000",
                        "longitude": "22.86667000"
                    },
                    {
                        "id": 94813,
                        "name": "Livada",
                        "latitude": "47.86667000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 94840,
                        "name": "Lucăceni",
                        "latitude": "47.74194000",
                        "longitude": "22.47819000"
                    },
                    {
                        "id": 95233,
                        "name": "Mădăras",
                        "latitude": "47.68403000",
                        "longitude": "22.86554000"
                    },
                    {
                        "id": 94944,
                        "name": "Medieşu Aurit",
                        "latitude": "47.78333000",
                        "longitude": "23.15000000"
                    },
                    {
                        "id": 94970,
                        "name": "Micula",
                        "latitude": "47.90000000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 95049,
                        "name": "Moftinu Mare",
                        "latitude": "47.66667000",
                        "longitude": "22.66667000"
                    },
                    {
                        "id": 95050,
                        "name": "Moftinu Mic",
                        "latitude": "47.68669000",
                        "longitude": "22.60054000"
                    },
                    {
                        "id": 95060,
                        "name": "Moișeni",
                        "latitude": "47.92798000",
                        "longitude": "23.46833000"
                    },
                    {
                        "id": 95125,
                        "name": "Municipiul Carei",
                        "latitude": "47.68203000",
                        "longitude": "22.46635000"
                    },
                    {
                        "id": 95178,
                        "name": "Municipiul Satu Mare",
                        "latitude": "47.76514000",
                        "longitude": "22.83565000"
                    },
                    {
                        "id": 95317,
                        "name": "Negreşti-Oaş",
                        "latitude": "47.86667000",
                        "longitude": "23.43333000"
                    },
                    {
                        "id": 95381,
                        "name": "Oar",
                        "latitude": "47.80569000",
                        "longitude": "22.73085000"
                    },
                    {
                        "id": 95409,
                        "name": "Odoreu",
                        "latitude": "47.80000000",
                        "longitude": "23.00000000"
                    },
                    {
                        "id": 95636,
                        "name": "Oraș Ardud",
                        "latitude": "47.63333000",
                        "longitude": "22.88333000"
                    },
                    {
                        "id": 95641,
                        "name": "Oraș Livada",
                        "latitude": "47.86667000",
                        "longitude": "23.13333000"
                    },
                    {
                        "id": 95549,
                        "name": "Oraş Negreşti-Oaş",
                        "latitude": "47.86801000",
                        "longitude": "23.41816000"
                    },
                    {
                        "id": 95650,
                        "name": "Oraș Tăşnad",
                        "latitude": "47.48333000",
                        "longitude": "22.58333000"
                    },
                    {
                        "id": 95634,
                        "name": "Oraşu Nou",
                        "latitude": "47.83333000",
                        "longitude": "23.28333000"
                    },
                    {
                        "id": 96030,
                        "name": "Păuleşti",
                        "latitude": "47.78333000",
                        "longitude": "22.91667000"
                    },
                    {
                        "id": 95747,
                        "name": "Petreşti",
                        "latitude": "47.60000000",
                        "longitude": "22.36667000"
                    },
                    {
                        "id": 95795,
                        "name": "Pir",
                        "latitude": "47.46667000",
                        "longitude": "22.36667000"
                    },
                    {
                        "id": 95805,
                        "name": "Pişcolt",
                        "latitude": "47.58333000",
                        "longitude": "22.30000000"
                    },
                    {
                        "id": 95869,
                        "name": "Poiana Codrului",
                        "latitude": "47.62667000",
                        "longitude": "23.25056000"
                    },
                    {
                        "id": 95903,
                        "name": "Pomi",
                        "latitude": "47.70000000",
                        "longitude": "23.31667000"
                    },
                    {
                        "id": 95924,
                        "name": "Porumbești",
                        "latitude": "47.98305000",
                        "longitude": "22.98076000"
                    },
                    {
                        "id": 95935,
                        "name": "Potău",
                        "latitude": "47.75673000",
                        "longitude": "23.12090000"
                    },
                    {
                        "id": 96050,
                        "name": "Racşa",
                        "latitude": "47.82068000",
                        "longitude": "23.33247000"
                    },
                    {
                        "id": 106002,
                        "name": "Săcăşeni",
                        "latitude": "47.48333000",
                        "longitude": "22.68333000"
                    },
                    {
                        "id": 96239,
                        "name": "Sanislău",
                        "latitude": "47.63333000",
                        "longitude": "22.33333000"
                    },
                    {
                        "id": 96241,
                        "name": "Santău",
                        "latitude": "47.51667000",
                        "longitude": "22.51667000"
                    },
                    {
                        "id": 106036,
                        "name": "Sărăuad",
                        "latitude": "47.47944000",
                        "longitude": "22.62559000"
                    },
                    {
                        "id": 106041,
                        "name": "Sătmărel",
                        "latitude": "47.73470000",
                        "longitude": "22.79536000"
                    },
                    {
                        "id": 96256,
                        "name": "Satu Mare",
                        "latitude": "47.79926000",
                        "longitude": "22.86255000"
                    },
                    {
                        "id": 106042,
                        "name": "Săuca",
                        "latitude": "47.46667000",
                        "longitude": "22.48333000"
                    },
                    {
                        "id": 96398,
                        "name": "Socond",
                        "latitude": "47.56667000",
                        "longitude": "22.95000000"
                    },
                    {
                        "id": 96470,
                        "name": "Stâna",
                        "latitude": "47.50757000",
                        "longitude": "22.96423000"
                    },
                    {
                        "id": 96503,
                        "name": "Supuru de Jos",
                        "latitude": "47.46667000",
                        "longitude": "22.80000000"
                    },
                    {
                        "id": 106062,
                        "name": "Tarna Mare",
                        "latitude": "48.09175000",
                        "longitude": "23.19369000"
                    },
                    {
                        "id": 96597,
                        "name": "Târşolţ",
                        "latitude": "47.95000000",
                        "longitude": "23.35000000"
                    },
                    {
                        "id": 96598,
                        "name": "Târşolţel",
                        "latitude": "47.95000000",
                        "longitude": "23.35000000"
                    },
                    {
                        "id": 96630,
                        "name": "Tăşnad",
                        "latitude": "47.48333000",
                        "longitude": "22.58333000"
                    },
                    {
                        "id": 106083,
                        "name": "Terebeşti",
                        "latitude": "47.68333000",
                        "longitude": "22.71667000"
                    },
                    {
                        "id": 106105,
                        "name": "Tiream",
                        "latitude": "47.61667000",
                        "longitude": "22.46667000"
                    },
                    {
                        "id": 106157,
                        "name": "Trip",
                        "latitude": "47.92450000",
                        "longitude": "23.37648000"
                    },
                    {
                        "id": 96551,
                        "name": "Tur",
                        "latitude": "47.88231000",
                        "longitude": "23.39045000"
                    },
                    {
                        "id": 96569,
                        "name": "Turţ",
                        "latitude": "47.98333000",
                        "longitude": "23.21667000"
                    },
                    {
                        "id": 96568,
                        "name": "Turulung",
                        "latitude": "47.93333000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 96687,
                        "name": "Urziceni",
                        "latitude": "47.73333000",
                        "longitude": "22.40000000"
                    },
                    {
                        "id": 96752,
                        "name": "Valea Seacă",
                        "latitude": "48.08080000",
                        "longitude": "23.16489000"
                    },
                    {
                        "id": 96763,
                        "name": "Valea Vinului",
                        "latitude": "47.71667000",
                        "longitude": "23.18333000"
                    },
                    {
                        "id": 96770,
                        "name": "Vama",
                        "latitude": "47.83333000",
                        "longitude": "23.40000000"
                    },
                    {
                        "id": 96795,
                        "name": "Vetiş",
                        "latitude": "47.80000000",
                        "longitude": "22.76667000"
                    },
                    {
                        "id": 96816,
                        "name": "Viile Satu Mare",
                        "latitude": "47.66667000",
                        "longitude": "22.95000000"
                    }
                ]
            },
            {
                "id": 4755,
                "name": "Sibiu",
                "iso2": "SB",
                "latitude": "45.92691060",
                "longitude": "24.22548070",
                "type": "department",
                "cities": [
                    {
                        "id": 89903,
                        "name": "Agârbiciu",
                        "latitude": "46.06764000",
                        "longitude": "24.19386000"
                    },
                    {
                        "id": 89898,
                        "name": "Agnita",
                        "latitude": "45.96667000",
                        "longitude": "24.61667000"
                    },
                    {
                        "id": 89945,
                        "name": "Alămor",
                        "latitude": "45.93003000",
                        "longitude": "23.99370000"
                    },
                    {
                        "id": 89934,
                        "name": "Alma",
                        "latitude": "46.21359000",
                        "longitude": "24.48037000"
                    },
                    {
                        "id": 89946,
                        "name": "Alțâna",
                        "latitude": "45.93333000",
                        "longitude": "24.46667000"
                    },
                    {
                        "id": 89973,
                        "name": "Apoldu de Jos",
                        "latitude": "45.86667000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 89998,
                        "name": "Arpaşu de Jos",
                        "latitude": "45.78333000",
                        "longitude": "24.61667000"
                    },
                    {
                        "id": 89999,
                        "name": "Arpașu de Sus",
                        "latitude": "45.73436000",
                        "longitude": "24.61906000"
                    },
                    {
                        "id": 90016,
                        "name": "Aţel",
                        "latitude": "46.15000000",
                        "longitude": "24.46667000"
                    },
                    {
                        "id": 90008,
                        "name": "Avrig",
                        "latitude": "45.71667000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 90011,
                        "name": "Axente Sever",
                        "latitude": "46.10000000",
                        "longitude": "24.21667000"
                    },
                    {
                        "id": 90447,
                        "name": "Bârghiş",
                        "latitude": "45.98333000",
                        "longitude": "24.53333000"
                    },
                    {
                        "id": 90072,
                        "name": "Bazna",
                        "latitude": "46.20000000",
                        "longitude": "24.28333000"
                    },
                    {
                        "id": 90130,
                        "name": "Biertan",
                        "latitude": "46.13333000",
                        "longitude": "24.51667000"
                    },
                    {
                        "id": 90166,
                        "name": "Blăjel",
                        "latitude": "46.21667000",
                        "longitude": "24.31667000"
                    },
                    {
                        "id": 90202,
                        "name": "Boian",
                        "latitude": "46.20159000",
                        "longitude": "24.22862000"
                    },
                    {
                        "id": 90207,
                        "name": "Boița",
                        "latitude": "45.63454000",
                        "longitude": "24.26037000"
                    },
                    {
                        "id": 90322,
                        "name": "Brădeni",
                        "latitude": "46.08333000",
                        "longitude": "24.83333000"
                    },
                    {
                        "id": 90261,
                        "name": "Bradu",
                        "latitude": "45.72221000",
                        "longitude": "24.33234000"
                    },
                    {
                        "id": 90275,
                        "name": "Brateiu",
                        "latitude": "46.16667000",
                        "longitude": "24.41667000"
                    },
                    {
                        "id": 90314,
                        "name": "Bruiu",
                        "latitude": "45.86667000",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 93819,
                        "name": "Cârţa",
                        "latitude": "45.78333000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 93821,
                        "name": "Cârţişoara",
                        "latitude": "45.71667000",
                        "longitude": "24.58333000"
                    },
                    {
                        "id": 90680,
                        "name": "Chirpăr",
                        "latitude": "45.90000000",
                        "longitude": "24.60000000"
                    },
                    {
                        "id": 90737,
                        "name": "Cisnădie",
                        "latitude": "45.71667000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 90854,
                        "name": "Comuna Alma",
                        "latitude": "46.22726000",
                        "longitude": "24.46825000"
                    },
                    {
                        "id": 90862,
                        "name": "Comuna Alțâna",
                        "latitude": "45.95534000",
                        "longitude": "24.46144000"
                    },
                    {
                        "id": 90880,
                        "name": "Comuna Apoldu de Jos",
                        "latitude": "45.89598000",
                        "longitude": "23.85036000"
                    },
                    {
                        "id": 90897,
                        "name": "Comuna Arpaşu de Jos",
                        "latitude": "45.77314000",
                        "longitude": "24.60870000"
                    },
                    {
                        "id": 90912,
                        "name": "Comuna Aţel",
                        "latitude": "46.15465000",
                        "longitude": "24.48297000"
                    },
                    {
                        "id": 90908,
                        "name": "Comuna Axente Sever",
                        "latitude": "46.07315000",
                        "longitude": "24.22535000"
                    },
                    {
                        "id": 91186,
                        "name": "Comuna Bârghiş",
                        "latitude": "46.01126000",
                        "longitude": "24.50431000"
                    },
                    {
                        "id": 90941,
                        "name": "Comuna Bazna",
                        "latitude": "46.21384000",
                        "longitude": "24.26438000"
                    },
                    {
                        "id": 90985,
                        "name": "Comuna Biertan",
                        "latitude": "46.12456000",
                        "longitude": "24.51945000"
                    },
                    {
                        "id": 91009,
                        "name": "Comuna Blăjel",
                        "latitude": "46.22436000",
                        "longitude": "24.34108000"
                    },
                    {
                        "id": 91036,
                        "name": "Comuna Boiţa",
                        "latitude": "45.57905000",
                        "longitude": "24.24651000"
                    },
                    {
                        "id": 91112,
                        "name": "Comuna Brădeni",
                        "latitude": "46.06701000",
                        "longitude": "24.86289000"
                    },
                    {
                        "id": 91083,
                        "name": "Comuna Brateiu",
                        "latitude": "46.15361000",
                        "longitude": "24.42007000"
                    },
                    {
                        "id": 91105,
                        "name": "Comuna Bruiu",
                        "latitude": "45.86350000",
                        "longitude": "24.70341000"
                    },
                    {
                        "id": 91556,
                        "name": "Comuna Cârţa",
                        "latitude": "45.80033000",
                        "longitude": "24.56371000"
                    },
                    {
                        "id": 91557,
                        "name": "Comuna Cârţişoara",
                        "latitude": "45.72704000",
                        "longitude": "24.57985000"
                    },
                    {
                        "id": 91323,
                        "name": "Comuna Chirpăr",
                        "latitude": "45.90545000",
                        "longitude": "24.61093000"
                    },
                    {
                        "id": 91499,
                        "name": "Comuna Cristian",
                        "latitude": "45.78444000",
                        "longitude": "24.02995000"
                    },
                    {
                        "id": 91729,
                        "name": "Comuna Dârlos",
                        "latitude": "46.20795000",
                        "longitude": "24.39737000"
                    },
                    {
                        "id": 91951,
                        "name": "Comuna Gura Râului",
                        "latitude": "45.73012000",
                        "longitude": "23.98417000"
                    },
                    {
                        "id": 92006,
                        "name": "Comuna Hoghilag",
                        "latitude": "46.21941000",
                        "longitude": "24.61559000"
                    },
                    {
                        "id": 92051,
                        "name": "Comuna Iacobeni",
                        "latitude": "46.04440000",
                        "longitude": "24.75456000"
                    },
                    {
                        "id": 92125,
                        "name": "Comuna Jina",
                        "latitude": "45.78593000",
                        "longitude": "23.67793000"
                    },
                    {
                        "id": 92139,
                        "name": "Comuna Laslea",
                        "latitude": "46.14966000",
                        "longitude": "24.63839000"
                    },
                    {
                        "id": 92181,
                        "name": "Comuna Loamneş",
                        "latitude": "45.95467000",
                        "longitude": "24.04197000"
                    },
                    {
                        "id": 92191,
                        "name": "Comuna Ludoş",
                        "latitude": "45.93336000",
                        "longitude": "23.90070000"
                    },
                    {
                        "id": 92244,
                        "name": "Comuna Marpod",
                        "latitude": "45.87101000",
                        "longitude": "24.51544000"
                    },
                    {
                        "id": 92260,
                        "name": "Comuna Merghindeal",
                        "latitude": "45.97533000",
                        "longitude": "24.71324000"
                    },
                    {
                        "id": 92269,
                        "name": "Comuna Micăsasa",
                        "latitude": "46.10607000",
                        "longitude": "24.13264000"
                    },
                    {
                        "id": 92284,
                        "name": "Comuna Mihăileni",
                        "latitude": "45.99998000",
                        "longitude": "24.36621000"
                    },
                    {
                        "id": 92346,
                        "name": "Comuna Moşna",
                        "latitude": "46.07534000",
                        "longitude": "24.42509000"
                    },
                    {
                        "id": 92451,
                        "name": "Comuna Nocrich",
                        "latitude": "45.87075000",
                        "longitude": "24.43314000"
                    },
                    {
                        "id": 92508,
                        "name": "Comuna Orlat",
                        "latitude": "45.75550000",
                        "longitude": "23.96855000"
                    },
                    {
                        "id": 92725,
                        "name": "Comuna Păuca",
                        "latitude": "46.00209000",
                        "longitude": "23.91696000"
                    },
                    {
                        "id": 92631,
                        "name": "Comuna Poiana Sibiului",
                        "latitude": "45.80920000",
                        "longitude": "23.73095000"
                    },
                    {
                        "id": 92657,
                        "name": "Comuna Poplaca",
                        "latitude": "45.72815000",
                        "longitude": "24.05380000"
                    },
                    {
                        "id": 92661,
                        "name": "Comuna Porumbacu de Jos",
                        "latitude": "45.75078000",
                        "longitude": "24.49551000"
                    },
                    {
                        "id": 92735,
                        "name": "Comuna Racoviţa",
                        "latitude": "45.66604000",
                        "longitude": "24.35142000"
                    },
                    {
                        "id": 92855,
                        "name": "Comuna Răşinari",
                        "latitude": "45.69761000",
                        "longitude": "24.07378000"
                    },
                    {
                        "id": 92826,
                        "name": "Comuna Râu Sadului",
                        "latitude": "45.62401000",
                        "longitude": "24.06132000"
                    },
                    {
                        "id": 92796,
                        "name": "Comuna Roşia",
                        "latitude": "45.80385000",
                        "longitude": "24.31786000"
                    },
                    {
                        "id": 92860,
                        "name": "Comuna Sadu",
                        "latitude": "45.67199000",
                        "longitude": "24.18393000"
                    },
                    {
                        "id": 93501,
                        "name": "Comuna Şeica Mare",
                        "latitude": "45.99998000",
                        "longitude": "24.23909000"
                    },
                    {
                        "id": 93502,
                        "name": "Comuna Şeica Mică",
                        "latitude": "46.04202000",
                        "longitude": "24.09567000"
                    },
                    {
                        "id": 93505,
                        "name": "Comuna Şelimbăr",
                        "latitude": "45.75141000",
                        "longitude": "24.21985000"
                    },
                    {
                        "id": 92950,
                        "name": "Comuna Slimnic",
                        "latitude": "45.94465000",
                        "longitude": "24.19777000"
                    },
                    {
                        "id": 93562,
                        "name": "Comuna Şura Mare",
                        "latitude": "45.85917000",
                        "longitude": "24.18477000"
                    },
                    {
                        "id": 93563,
                        "name": "Comuna Şura Mică",
                        "latitude": "45.82485000",
                        "longitude": "24.04210000"
                    },
                    {
                        "id": 93228,
                        "name": "Comuna Târnava",
                        "latitude": "46.13752000",
                        "longitude": "24.29756000"
                    },
                    {
                        "id": 93154,
                        "name": "Comuna Tilişca",
                        "latitude": "45.80131000",
                        "longitude": "23.81411000"
                    },
                    {
                        "id": 93215,
                        "name": "Comuna Turnu Roşu",
                        "latitude": "45.64667000",
                        "longitude": "24.31762000"
                    },
                    {
                        "id": 93328,
                        "name": "Comuna Valea Viilor",
                        "latitude": "46.07141000",
                        "longitude": "24.31223000"
                    },
                    {
                        "id": 93424,
                        "name": "Comuna Vurpăr",
                        "latitude": "45.89672000",
                        "longitude": "24.34315000"
                    },
                    {
                        "id": 93609,
                        "name": "Copşa Mică",
                        "latitude": "46.11667000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 93722,
                        "name": "Cristian",
                        "latitude": "45.78333000",
                        "longitude": "24.03333000"
                    },
                    {
                        "id": 94110,
                        "name": "Dârlos",
                        "latitude": "46.18333000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 94084,
                        "name": "Dumbrăveni",
                        "latitude": "46.23333000",
                        "longitude": "24.56667000"
                    },
                    {
                        "id": 94459,
                        "name": "Gura Râului",
                        "latitude": "45.73333000",
                        "longitude": "23.98333000"
                    },
                    {
                        "id": 94546,
                        "name": "Hoghilag",
                        "latitude": "46.23333000",
                        "longitude": "24.61667000"
                    },
                    {
                        "id": 94616,
                        "name": "Iacobeni",
                        "latitude": "46.05000000",
                        "longitude": "24.71667000"
                    },
                    {
                        "id": 94649,
                        "name": "Ighișu Nou",
                        "latitude": "46.11121000",
                        "longitude": "24.34920000"
                    },
                    {
                        "id": 94739,
                        "name": "Jina",
                        "latitude": "45.78333000",
                        "longitude": "23.68333000"
                    },
                    {
                        "id": 94763,
                        "name": "Laslea",
                        "latitude": "46.21667000",
                        "longitude": "24.65000000"
                    },
                    {
                        "id": 94828,
                        "name": "Loamneş",
                        "latitude": "45.93333000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 94843,
                        "name": "Ludoş",
                        "latitude": "45.91667000",
                        "longitude": "23.90000000"
                    },
                    {
                        "id": 95256,
                        "name": "Mălâncrav",
                        "latitude": "46.11003000",
                        "longitude": "24.64810000"
                    },
                    {
                        "id": 94932,
                        "name": "Marpod",
                        "latitude": "45.86667000",
                        "longitude": "24.50000000"
                    },
                    {
                        "id": 95225,
                        "name": "Mârșa",
                        "latitude": "45.70002000",
                        "longitude": "24.37046000"
                    },
                    {
                        "id": 94943,
                        "name": "Mediaş",
                        "latitude": "46.16667000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 94956,
                        "name": "Merghindeal",
                        "latitude": "45.96667000",
                        "longitude": "24.73333000"
                    },
                    {
                        "id": 94971,
                        "name": "Micăsasa",
                        "latitude": "46.08333000",
                        "longitude": "24.11667000"
                    },
                    {
                        "id": 94972,
                        "name": "Miercurea Sibiului",
                        "latitude": "45.88333000",
                        "longitude": "23.80000000"
                    },
                    {
                        "id": 94991,
                        "name": "Mihăileni",
                        "latitude": "45.98333000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 95089,
                        "name": "Moşna",
                        "latitude": "46.08333000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 95155,
                        "name": "Municipiul Mediaş",
                        "latitude": "46.13663000",
                        "longitude": "24.35377000"
                    },
                    {
                        "id": 95181,
                        "name": "Municipiul Sibiu",
                        "latitude": "45.79383000",
                        "longitude": "24.13533000"
                    },
                    {
                        "id": 95353,
                        "name": "Nocrich",
                        "latitude": "45.90000000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 95355,
                        "name": "Nou",
                        "latitude": "45.83333000",
                        "longitude": "24.28333000"
                    },
                    {
                        "id": 95396,
                        "name": "Ocna Sibiului",
                        "latitude": "45.88333000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 95447,
                        "name": "Oraş Agnita",
                        "latitude": "45.98952000",
                        "longitude": "24.61458000"
                    },
                    {
                        "id": 95451,
                        "name": "Oraş Avrig",
                        "latitude": "45.73797000",
                        "longitude": "24.38713000"
                    },
                    {
                        "id": 95494,
                        "name": "Oraş Cisnãdie",
                        "latitude": "45.70924000",
                        "longitude": "24.13284000"
                    },
                    {
                        "id": 95497,
                        "name": "Oraş Copşa Micã",
                        "latitude": "46.11651000",
                        "longitude": "24.25517000"
                    },
                    {
                        "id": 95511,
                        "name": "Oraş Dumbrãveni",
                        "latitude": "46.22258000",
                        "longitude": "24.55274000"
                    },
                    {
                        "id": 95540,
                        "name": "Oraş Miercurea Sibiului",
                        "latitude": "45.86247000",
                        "longitude": "23.79766000"
                    },
                    {
                        "id": 95557,
                        "name": "Oraş Ocna Sibiului",
                        "latitude": "45.88311000",
                        "longitude": "24.00095000"
                    },
                    {
                        "id": 95599,
                        "name": "Oraş Sãlişte",
                        "latitude": "45.78967000",
                        "longitude": "23.89532000"
                    },
                    {
                        "id": 95610,
                        "name": "Oraş Tãlmaciu",
                        "latitude": "45.66751000",
                        "longitude": "24.25357000"
                    },
                    {
                        "id": 95658,
                        "name": "Orlat",
                        "latitude": "45.75000000",
                        "longitude": "23.96667000"
                    },
                    {
                        "id": 96027,
                        "name": "Păuca",
                        "latitude": "46.01667000",
                        "longitude": "23.90000000"
                    },
                    {
                        "id": 95880,
                        "name": "Poiana Sibiului",
                        "latitude": "45.80000000",
                        "longitude": "23.73333000"
                    },
                    {
                        "id": 95916,
                        "name": "Poplaca",
                        "latitude": "45.71667000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 95922,
                        "name": "Porumbacu de Jos",
                        "latitude": "45.75000000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 96044,
                        "name": "Racoviţa",
                        "latitude": "45.68333000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 96218,
                        "name": "Răşinari",
                        "latitude": "45.70000000",
                        "longitude": "24.06667000"
                    },
                    {
                        "id": 96175,
                        "name": "Râu Sadului",
                        "latitude": "45.61667000",
                        "longitude": "24.06667000"
                    },
                    {
                        "id": 96126,
                        "name": "Roşia",
                        "latitude": "45.81667000",
                        "longitude": "24.31667000"
                    },
                    {
                        "id": 96151,
                        "name": "Ruja",
                        "latitude": "46.01175000",
                        "longitude": "24.65048000"
                    },
                    {
                        "id": 96226,
                        "name": "Sadu",
                        "latitude": "45.66667000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 106017,
                        "name": "Sălişte",
                        "latitude": "45.79633000",
                        "longitude": "23.88677000"
                    },
                    {
                        "id": 97115,
                        "name": "Șaroș pe Târnave",
                        "latitude": "46.20000000",
                        "longitude": "24.55000000"
                    },
                    {
                        "id": 97041,
                        "name": "Şeíca Mare",
                        "latitude": "46.01667000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 97033,
                        "name": "Şeica Mică",
                        "latitude": "46.05000000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 97036,
                        "name": "Şelimbăr",
                        "latitude": "45.76667000",
                        "longitude": "24.20000000"
                    },
                    {
                        "id": 96332,
                        "name": "Sibiu",
                        "latitude": "45.80000000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 96366,
                        "name": "Slimnic",
                        "latitude": "45.91667000",
                        "longitude": "24.16667000"
                    },
                    {
                        "id": 97094,
                        "name": "Şura Mare",
                        "latitude": "45.85000000",
                        "longitude": "24.16667000"
                    },
                    {
                        "id": 97095,
                        "name": "Şura Mică",
                        "latitude": "45.83333000",
                        "longitude": "24.06667000"
                    },
                    {
                        "id": 96602,
                        "name": "Tălmăcel",
                        "latitude": "45.64712000",
                        "longitude": "24.24270000"
                    },
                    {
                        "id": 96601,
                        "name": "Tălmaciu",
                        "latitude": "45.66714000",
                        "longitude": "24.26464000"
                    },
                    {
                        "id": 96593,
                        "name": "Târnava",
                        "latitude": "46.13975000",
                        "longitude": "24.28926000"
                    },
                    {
                        "id": 106100,
                        "name": "Tilişca",
                        "latitude": "45.80000000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 96566,
                        "name": "Turnu Roşu",
                        "latitude": "45.63333000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 96762,
                        "name": "Valea Viilor",
                        "latitude": "46.08333000",
                        "longitude": "24.28333000"
                    },
                    {
                        "id": 96799,
                        "name": "Veștem",
                        "latitude": "45.71752000",
                        "longitude": "24.23958000"
                    },
                    {
                        "id": 96916,
                        "name": "Vurpăr",
                        "latitude": "45.90000000",
                        "longitude": "24.35000000"
                    }
                ]
            },
            {
                "id": 4720,
                "name": "Suceava",
                "iso2": "SV",
                "latitude": "47.55055480",
                "longitude": "25.74106200",
                "type": "department",
                "cities": [
                    {
                        "id": 89888,
                        "name": "Adâncata",
                        "latitude": "47.73333000",
                        "longitude": "26.30000000"
                    },
                    {
                        "id": 89978,
                        "name": "Arbore",
                        "latitude": "47.73333000",
                        "longitude": "25.93333000"
                    },
                    {
                        "id": 89986,
                        "name": "Argel",
                        "latitude": "47.76136000",
                        "longitude": "25.47049000"
                    },
                    {
                        "id": 89989,
                        "name": "Arghira",
                        "latitude": "47.45412000",
                        "longitude": "26.47250000"
                    },
                    {
                        "id": 90482,
                        "name": "Bădeuți",
                        "latitude": "47.80277000",
                        "longitude": "25.98387000"
                    },
                    {
                        "id": 90028,
                        "name": "Baia",
                        "latitude": "47.41667000",
                        "longitude": "26.21667000"
                    },
                    {
                        "id": 90499,
                        "name": "Băișești",
                        "latitude": "47.48024000",
                        "longitude": "26.11115000"
                    },
                    {
                        "id": 90520,
                        "name": "Bălăceana",
                        "latitude": "47.64338000",
                        "longitude": "26.04764000"
                    },
                    {
                        "id": 90507,
                        "name": "Bălcăuţi",
                        "latitude": "47.89149000",
                        "longitude": "26.07279000"
                    },
                    {
                        "id": 90534,
                        "name": "Bănești",
                        "latitude": "47.58946000",
                        "longitude": "26.52335000"
                    },
                    {
                        "id": 90068,
                        "name": "Basarabi",
                        "latitude": "47.45370000",
                        "longitude": "26.43972000"
                    },
                    {
                        "id": 90100,
                        "name": "Berchișești",
                        "latitude": "47.52306000",
                        "longitude": "26.03207000"
                    },
                    {
                        "id": 90135,
                        "name": "Bilca",
                        "latitude": "47.91667000",
                        "longitude": "25.75000000"
                    },
                    {
                        "id": 90153,
                        "name": "Bivolărie",
                        "latitude": "47.91464000",
                        "longitude": "25.65525000"
                    },
                    {
                        "id": 90184,
                        "name": "Bogata",
                        "latitude": "47.40789000",
                        "longitude": "26.18655000"
                    },
                    {
                        "id": 90191,
                        "name": "Bogdăneşti",
                        "latitude": "47.36667000",
                        "longitude": "26.28333000"
                    },
                    {
                        "id": 90230,
                        "name": "Boroaia",
                        "latitude": "47.35000000",
                        "longitude": "26.33333000"
                    },
                    {
                        "id": 90240,
                        "name": "Bosanci",
                        "latitude": "47.58333000",
                        "longitude": "26.31667000"
                    },
                    {
                        "id": 90247,
                        "name": "Botoşana",
                        "latitude": "47.68333000",
                        "longitude": "25.95000000"
                    },
                    {
                        "id": 90333,
                        "name": "Brăiești",
                        "latitude": "47.49673000",
                        "longitude": "26.07182000"
                    },
                    {
                        "id": 90286,
                        "name": "Breaza",
                        "latitude": "47.61502000",
                        "longitude": "25.31816000"
                    },
                    {
                        "id": 90305,
                        "name": "Brodina",
                        "latitude": "47.88333000",
                        "longitude": "25.41667000"
                    },
                    {
                        "id": 90308,
                        "name": "Broşteni",
                        "latitude": "47.23333000",
                        "longitude": "25.70000000"
                    },
                    {
                        "id": 90370,
                        "name": "Bucșoaia",
                        "latitude": "47.53972000",
                        "longitude": "25.81118000"
                    },
                    {
                        "id": 90379,
                        "name": "Budeni",
                        "latitude": "47.41383000",
                        "longitude": "26.65927000"
                    },
                    {
                        "id": 90411,
                        "name": "Bunești",
                        "latitude": "47.52501000",
                        "longitude": "26.28826000"
                    },
                    {
                        "id": 90419,
                        "name": "Burla",
                        "latitude": "47.79033000",
                        "longitude": "25.92696000"
                    },
                    {
                        "id": 90420,
                        "name": "Bursuceni",
                        "latitude": "47.65097000",
                        "longitude": "26.47530000"
                    },
                    {
                        "id": 90559,
                        "name": "Cacica",
                        "latitude": "47.63333000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 90561,
                        "name": "Cajvana",
                        "latitude": "47.70000000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 90563,
                        "name": "Calafindeşti",
                        "latitude": "47.85000000",
                        "longitude": "26.11667000"
                    },
                    {
                        "id": 93842,
                        "name": "Călinești",
                        "latitude": "47.80329000",
                        "longitude": "26.15345000"
                    },
                    {
                        "id": 93801,
                        "name": "Câmpulung Moldovenesc",
                        "latitude": "47.53333000",
                        "longitude": "25.56667000"
                    },
                    {
                        "id": 90570,
                        "name": "Capu Câmpului",
                        "latitude": "47.50822000",
                        "longitude": "25.97959000"
                    },
                    {
                        "id": 90569,
                        "name": "Capu Codrului",
                        "latitude": "47.53117000",
                        "longitude": "25.98724000"
                    },
                    {
                        "id": 93813,
                        "name": "Cârlibaba",
                        "latitude": "47.58333000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 90716,
                        "name": "Ciocănești",
                        "latitude": "47.48107000",
                        "longitude": "25.27912000"
                    },
                    {
                        "id": 90731,
                        "name": "Ciprian Porumbescu",
                        "latitude": "47.56667000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 90768,
                        "name": "Clit",
                        "latitude": "47.75396000",
                        "longitude": "25.85691000"
                    },
                    {
                        "id": 90792,
                        "name": "Colacu",
                        "latitude": "47.53830000",
                        "longitude": "25.37211000"
                    },
                    {
                        "id": 93588,
                        "name": "Comănești",
                        "latitude": "47.66939000",
                        "longitude": "25.98836000"
                    },
                    {
                        "id": 90824,
                        "name": "Comuna Adâncata",
                        "latitude": "47.73678000",
                        "longitude": "26.30819000"
                    },
                    {
                        "id": 90882,
                        "name": "Comuna Arbore",
                        "latitude": "47.74775000",
                        "longitude": "25.90345000"
                    },
                    {
                        "id": 90916,
                        "name": "Comuna Baia",
                        "latitude": "47.41311000",
                        "longitude": "26.20278000"
                    },
                    {
                        "id": 91222,
                        "name": "Comuna Bălăceana",
                        "latitude": "47.64338000",
                        "longitude": "26.04764000"
                    },
                    {
                        "id": 91212,
                        "name": "Comuna Bălcăuţi",
                        "latitude": "47.90436000",
                        "longitude": "26.08665000"
                    },
                    {
                        "id": 90962,
                        "name": "Comuna Berchişeşti",
                        "latitude": "47.53260000",
                        "longitude": "26.04276000"
                    },
                    {
                        "id": 90988,
                        "name": "Comuna Bilca",
                        "latitude": "47.91826000",
                        "longitude": "25.75457000"
                    },
                    {
                        "id": 91026,
                        "name": "Comuna Bogdăneşti",
                        "latitude": "47.36671000",
                        "longitude": "26.27386000"
                    },
                    {
                        "id": 91051,
                        "name": "Comuna Boroaia",
                        "latitude": "47.34226000",
                        "longitude": "26.33043000"
                    },
                    {
                        "id": 91058,
                        "name": "Comuna Bosanci",
                        "latitude": "47.57503000",
                        "longitude": "26.29582000"
                    },
                    {
                        "id": 91064,
                        "name": "Comuna Botoşana",
                        "latitude": "47.68759000",
                        "longitude": "25.94337000"
                    },
                    {
                        "id": 91090,
                        "name": "Comuna Breaza",
                        "latitude": "47.62436000",
                        "longitude": "25.33172000"
                    },
                    {
                        "id": 91101,
                        "name": "Comuna Brodina",
                        "latitude": "47.85147000",
                        "longitude": "25.39262000"
                    },
                    {
                        "id": 91164,
                        "name": "Comuna Buneşti",
                        "latitude": "47.51793000",
                        "longitude": "26.29717000"
                    },
                    {
                        "id": 91171,
                        "name": "Comuna Burla",
                        "latitude": "47.79033000",
                        "longitude": "25.92696000"
                    },
                    {
                        "id": 91252,
                        "name": "Comuna Cacica",
                        "latitude": "47.65553000",
                        "longitude": "25.86673000"
                    },
                    {
                        "id": 91253,
                        "name": "Comuna Calafindeşti",
                        "latitude": "47.86578000",
                        "longitude": "26.11598000"
                    },
                    {
                        "id": 91257,
                        "name": "Comuna Capu Câmpului",
                        "latitude": "47.50822000",
                        "longitude": "25.97959000"
                    },
                    {
                        "id": 91551,
                        "name": "Comuna Cârlibaba",
                        "latitude": "47.58546000",
                        "longitude": "25.09425000"
                    },
                    {
                        "id": 91347,
                        "name": "Comuna Ciocăneşti",
                        "latitude": "47.50083000",
                        "longitude": "25.24673000"
                    },
                    {
                        "id": 91358,
                        "name": "Comuna Ciprian Porumbescu",
                        "latitude": "47.56842000",
                        "longitude": "26.06397000"
                    },
                    {
                        "id": 91410,
                        "name": "Comuna Comăneşti",
                        "latitude": "47.66932000",
                        "longitude": "25.98661000"
                    },
                    {
                        "id": 91443,
                        "name": "Comuna Cornu Luncii",
                        "latitude": "47.45743000",
                        "longitude": "26.14122000"
                    },
                    {
                        "id": 91476,
                        "name": "Comuna Coşna",
                        "latitude": "47.37343000",
                        "longitude": "25.16889000"
                    },
                    {
                        "id": 91509,
                        "name": "Comuna Crucea",
                        "latitude": "47.37472000",
                        "longitude": "25.59262000"
                    },
                    {
                        "id": 91744,
                        "name": "Comuna Dărmăneşti",
                        "latitude": "47.75967000",
                        "longitude": "26.12677000"
                    },
                    {
                        "id": 91654,
                        "name": "Comuna Dolheşti",
                        "latitude": "47.43720000",
                        "longitude": "26.52383000"
                    },
                    {
                        "id": 91661,
                        "name": "Comuna Dorna Cândrenilor",
                        "latitude": "47.34594000",
                        "longitude": "25.23735000"
                    },
                    {
                        "id": 91662,
                        "name": "Comuna Dorna-Arini",
                        "latitude": "47.35928000",
                        "longitude": "25.44383000"
                    },
                    {
                        "id": 91663,
                        "name": "Comuna Dorneşti",
                        "latitude": "47.88982000",
                        "longitude": "25.99415000"
                    },
                    {
                        "id": 91683,
                        "name": "Comuna Drãgoieşti",
                        "latitude": "47.53507000",
                        "longitude": "26.09178000"
                    },
                    {
                        "id": 91694,
                        "name": "Comuna Drăguşeni",
                        "latitude": "47.31170000",
                        "longitude": "26.52284000"
                    },
                    {
                        "id": 91715,
                        "name": "Comuna Dumbrăveni",
                        "latitude": "47.66802000",
                        "longitude": "26.40699000"
                    },
                    {
                        "id": 91804,
                        "name": "Comuna Fântâna Mare",
                        "latitude": "47.40000000",
                        "longitude": "26.30000000"
                    },
                    {
                        "id": 91809,
                        "name": "Comuna Fântânele",
                        "latitude": "47.58499000",
                        "longitude": "26.52036000"
                    },
                    {
                        "id": 91779,
                        "name": "Comuna Forăşti",
                        "latitude": "47.36386000",
                        "longitude": "26.46174000"
                    },
                    {
                        "id": 91795,
                        "name": "Comuna Frătăuţii Noi",
                        "latitude": "47.92568000",
                        "longitude": "25.87372000"
                    },
                    {
                        "id": 91796,
                        "name": "Comuna Frătăuţii Vechi",
                        "latitude": "47.90465000",
                        "longitude": "25.90303000"
                    },
                    {
                        "id": 91785,
                        "name": "Comuna Frumosu",
                        "latitude": "47.61834000",
                        "longitude": "25.63529000"
                    },
                    {
                        "id": 91802,
                        "name": "Comuna Fundu Moldovei",
                        "latitude": "47.55496000",
                        "longitude": "25.33346000"
                    },
                    {
                        "id": 91982,
                        "name": "Comuna Gălăneşti",
                        "latitude": "47.91587000",
                        "longitude": "25.82894000"
                    },
                    {
                        "id": 91942,
                        "name": "Comuna Grămeşti",
                        "latitude": "47.89744000",
                        "longitude": "26.14496000"
                    },
                    {
                        "id": 91944,
                        "name": "Comuna Grăniceşti",
                        "latitude": "47.77658000",
                        "longitude": "26.06857000"
                    },
                    {
                        "id": 92042,
                        "name": "Comuna Hănţeşti",
                        "latitude": "47.76696000",
                        "longitude": "26.34232000"
                    },
                    {
                        "id": 92034,
                        "name": "Comuna Hârtop",
                        "latitude": "47.49000000",
                        "longitude": "26.37226000"
                    },
                    {
                        "id": 92022,
                        "name": "Comuna Horodnic De Jos",
                        "latitude": "47.86092000",
                        "longitude": "25.83243000"
                    },
                    {
                        "id": 92023,
                        "name": "Comuna Horodnic De Sus",
                        "latitude": "47.83186000",
                        "longitude": "25.83687000"
                    },
                    {
                        "id": 92024,
                        "name": "Comuna Horodniceni",
                        "latitude": "47.51356000",
                        "longitude": "26.17276000"
                    },
                    {
                        "id": 92050,
                        "name": "Comuna Iacobeni",
                        "latitude": "47.44112000",
                        "longitude": "25.32431000"
                    },
                    {
                        "id": 92056,
                        "name": "Comuna Iaslovăţ",
                        "latitude": "47.75862000",
                        "longitude": "25.97742000"
                    },
                    {
                        "id": 92072,
                        "name": "Comuna Ilişeşti",
                        "latitude": "47.61665000",
                        "longitude": "26.05520000"
                    },
                    {
                        "id": 92091,
                        "name": "Comuna Ipoteşti",
                        "latitude": "47.62828000",
                        "longitude": "26.29797000"
                    },
                    {
                        "id": 92108,
                        "name": "Comuna Izvoarele Sucevei",
                        "latitude": "47.75766000",
                        "longitude": "25.19406000"
                    },
                    {
                        "id": 92398,
                        "name": "Comuna Mălini",
                        "latitude": "47.40321000",
                        "longitude": "26.01485000"
                    },
                    {
                        "id": 92370,
                        "name": "Comuna Mânăstirea Humorului",
                        "latitude": "47.62839000",
                        "longitude": "25.82206000"
                    },
                    {
                        "id": 92243,
                        "name": "Comuna Marginea",
                        "latitude": "47.80927000",
                        "longitude": "25.82296000"
                    },
                    {
                        "id": 92307,
                        "name": "Comuna Mitocu Dragomirnei",
                        "latitude": "47.73475000",
                        "longitude": "26.23992000"
                    },
                    {
                        "id": 92312,
                        "name": "Comuna Moara",
                        "latitude": "47.58038000",
                        "longitude": "26.19565000"
                    },
                    {
                        "id": 92324,
                        "name": "Comuna Moldova Suliţa",
                        "latitude": "47.67897000",
                        "longitude": "25.25421000"
                    },
                    {
                        "id": 92328,
                        "name": "Comuna Moldoviţa",
                        "latitude": "47.72325000",
                        "longitude": "25.50689000"
                    },
                    {
                        "id": 92363,
                        "name": "Comuna Muşeniţa",
                        "latitude": "47.96020000",
                        "longitude": "25.98110000"
                    },
                    {
                        "id": 92517,
                        "name": "Comuna Ostra",
                        "latitude": "47.40480000",
                        "longitude": "25.75594000"
                    },
                    {
                        "id": 92718,
                        "name": "Comuna Păltinoasa",
                        "latitude": "47.54101000",
                        "longitude": "25.97138000"
                    },
                    {
                        "id": 92533,
                        "name": "Comuna Panaci",
                        "latitude": "47.19584000",
                        "longitude": "25.43169000"
                    },
                    {
                        "id": 92721,
                        "name": "Comuna Părteştii de Jos",
                        "latitude": "47.62306000",
                        "longitude": "25.96689000"
                    },
                    {
                        "id": 92723,
                        "name": "Comuna Pătrăuţi",
                        "latitude": "47.72097000",
                        "longitude": "26.18841000"
                    },
                    {
                        "id": 92632,
                        "name": "Comuna Poiana Stampei",
                        "latitude": "47.31118000",
                        "longitude": "25.12932000"
                    },
                    {
                        "id": 92641,
                        "name": "Comuna Poieni-Solca",
                        "latitude": "47.68626000",
                        "longitude": "25.89374000"
                    },
                    {
                        "id": 92645,
                        "name": "Comuna Pojorâta",
                        "latitude": "47.50476000",
                        "longitude": "25.42180000"
                    },
                    {
                        "id": 92672,
                        "name": "Comuna Preuteşti",
                        "latitude": "47.45479000",
                        "longitude": "26.42181000"
                    },
                    {
                        "id": 92701,
                        "name": "Comuna Putna",
                        "latitude": "47.88518000",
                        "longitude": "25.60374000"
                    },
                    {
                        "id": 92846,
                        "name": "Comuna Rădăşeni",
                        "latitude": "47.48804000",
                        "longitude": "26.24924000"
                    },
                    {
                        "id": 92828,
                        "name": "Comuna Râşca",
                        "latitude": "47.36821000",
                        "longitude": "26.18987000"
                    },
                    {
                        "id": 92859,
                        "name": "Comuna Sadova",
                        "latitude": "47.54248000",
                        "longitude": "25.50380000"
                    },
                    {
                        "id": 93500,
                        "name": "Comuna Şaru Dornei",
                        "latitude": "47.26471000",
                        "longitude": "25.33324000"
                    },
                    {
                        "id": 92881,
                        "name": "Comuna Satu Mare",
                        "latitude": "47.82377000",
                        "longitude": "26.01339000"
                    },
                    {
                        "id": 92883,
                        "name": "Comuna Scheia",
                        "latitude": "47.65030000",
                        "longitude": "26.18094000"
                    },
                    {
                        "id": 93510,
                        "name": "Comuna Şerbăuţi",
                        "latitude": "47.81507000",
                        "longitude": "26.14677000"
                    },
                    {
                        "id": 92936,
                        "name": "Comuna Siminicea",
                        "latitude": "47.70926000",
                        "longitude": "26.39132000"
                    },
                    {
                        "id": 92947,
                        "name": "Comuna Slatina",
                        "latitude": "47.43630000",
                        "longitude": "25.97797000"
                    },
                    {
                        "id": 93001,
                        "name": "Comuna Straja",
                        "latitude": "47.91825000",
                        "longitude": "25.55275000"
                    },
                    {
                        "id": 93005,
                        "name": "Comuna Stroieşti",
                        "latitude": "47.61943000",
                        "longitude": "26.12741000"
                    },
                    {
                        "id": 93011,
                        "name": "Comuna Stulpicani",
                        "latitude": "47.43327000",
                        "longitude": "25.75705000"
                    },
                    {
                        "id": 93026,
                        "name": "Comuna Suceviţa",
                        "latitude": "47.79051000",
                        "longitude": "25.74000000"
                    },
                    {
                        "id": 93164,
                        "name": "Comuna Todireşti",
                        "latitude": "47.70451000",
                        "longitude": "26.07762000"
                    },
                    {
                        "id": 93254,
                        "name": "Comuna Udeşti",
                        "latitude": "47.57154000",
                        "longitude": "26.40955000"
                    },
                    {
                        "id": 93259,
                        "name": "Comuna Ulma",
                        "latitude": "47.86322000",
                        "longitude": "25.26467000"
                    },
                    {
                        "id": 93292,
                        "name": "Comuna Vadu Moldovei",
                        "latitude": "47.38595000",
                        "longitude": "26.40022000"
                    },
                    {
                        "id": 93316,
                        "name": "Comuna Valea Moldovei",
                        "latitude": "47.48067000",
                        "longitude": "26.01535000"
                    },
                    {
                        "id": 93332,
                        "name": "Comuna Vama",
                        "latitude": "47.56354000",
                        "longitude": "25.69089000"
                    },
                    {
                        "id": 93336,
                        "name": "Comuna Vatra Moldoviţei",
                        "latitude": "47.66396000",
                        "longitude": "25.57802000"
                    },
                    {
                        "id": 93343,
                        "name": "Comuna Vereşti",
                        "latitude": "47.62500000",
                        "longitude": "26.46426000"
                    },
                    {
                        "id": 93350,
                        "name": "Comuna Vicovu de Jos",
                        "latitude": "47.90112000",
                        "longitude": "25.72659000"
                    },
                    {
                        "id": 93402,
                        "name": "Comuna Voitinel",
                        "latitude": "47.88366000",
                        "longitude": "25.75735000"
                    },
                    {
                        "id": 93404,
                        "name": "Comuna Volovăţ",
                        "latitude": "47.80726000",
                        "longitude": "25.89558000"
                    },
                    {
                        "id": 93421,
                        "name": "Comuna Vultureşti",
                        "latitude": "47.52041000",
                        "longitude": "26.40961000"
                    },
                    {
                        "id": 93472,
                        "name": "Comuna Zamostea",
                        "latitude": "47.86610000",
                        "longitude": "26.20328000"
                    },
                    {
                        "id": 93481,
                        "name": "Comuna Zvoriştea",
                        "latitude": "47.81813000",
                        "longitude": "26.28635000"
                    },
                    {
                        "id": 93639,
                        "name": "Cornu Luncii",
                        "latitude": "47.46667000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 93645,
                        "name": "Corocăiești",
                        "latitude": "47.63333000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 93698,
                        "name": "Coșna",
                        "latitude": "47.37098000",
                        "longitude": "25.18133000"
                    },
                    {
                        "id": 93670,
                        "name": "Costâna",
                        "latitude": "47.69265000",
                        "longitude": "26.11900000"
                    },
                    {
                        "id": 93740,
                        "name": "Crucea",
                        "latitude": "47.35000000",
                        "longitude": "25.61667000"
                    },
                    {
                        "id": 94130,
                        "name": "Dărmăneşti",
                        "latitude": "47.73333000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 93918,
                        "name": "Demacușa",
                        "latitude": "47.69717000",
                        "longitude": "25.50499000"
                    },
                    {
                        "id": 93982,
                        "name": "Dolhasca",
                        "latitude": "47.43333000",
                        "longitude": "26.60000000"
                    },
                    {
                        "id": 93985,
                        "name": "Dolheștii Mici",
                        "latitude": "47.43633000",
                        "longitude": "26.55178000"
                    },
                    {
                        "id": 93986,
                        "name": "Dolheștii-Mari",
                        "latitude": "47.45020000",
                        "longitude": "26.51326000"
                    },
                    {
                        "id": 93997,
                        "name": "Dorna Cândrenilor",
                        "latitude": "47.35000000",
                        "longitude": "25.25000000"
                    },
                    {
                        "id": 93998,
                        "name": "Dorna-Arini",
                        "latitude": "47.33832000",
                        "longitude": "25.40740000"
                    },
                    {
                        "id": 93999,
                        "name": "Dorneşti",
                        "latitude": "47.87174000",
                        "longitude": "26.00430000"
                    },
                    {
                        "id": 94044,
                        "name": "Drăgoiești",
                        "latitude": "47.55000000",
                        "longitude": "26.08333000"
                    },
                    {
                        "id": 94050,
                        "name": "Drăguşeni",
                        "latitude": "47.28333000",
                        "longitude": "26.48333000"
                    },
                    {
                        "id": 94085,
                        "name": "Dumbrăveni",
                        "latitude": "47.65000000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 94092,
                        "name": "Dumbrăvița",
                        "latitude": "47.39845000",
                        "longitude": "26.34578000"
                    },
                    {
                        "id": 94149,
                        "name": "Falcău",
                        "latitude": "47.91087000",
                        "longitude": "25.46908000"
                    },
                    {
                        "id": 94259,
                        "name": "Fălticeni",
                        "latitude": "47.45000000",
                        "longitude": "26.30000000"
                    },
                    {
                        "id": 94235,
                        "name": "Fântâna Mare",
                        "latitude": "47.41432000",
                        "longitude": "26.30015000"
                    },
                    {
                        "id": 94236,
                        "name": "Fântânele",
                        "latitude": "47.57463000",
                        "longitude": "26.53277000"
                    },
                    {
                        "id": 94200,
                        "name": "Forăşti",
                        "latitude": "47.35000000",
                        "longitude": "26.46667000"
                    },
                    {
                        "id": 94201,
                        "name": "Frasin",
                        "latitude": "47.53333000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 94220,
                        "name": "Frătăuţii Noi",
                        "latitude": "47.94257000",
                        "longitude": "25.84465000"
                    },
                    {
                        "id": 94221,
                        "name": "Frătăuţii Vechi",
                        "latitude": "47.90000000",
                        "longitude": "25.88333000"
                    },
                    {
                        "id": 94209,
                        "name": "Frumosu",
                        "latitude": "47.61667000",
                        "longitude": "25.65000000"
                    },
                    {
                        "id": 94229,
                        "name": "Fundu Moldovei",
                        "latitude": "47.53333000",
                        "longitude": "25.40000000"
                    },
                    {
                        "id": 94501,
                        "name": "Găinești",
                        "latitude": "47.41968000",
                        "longitude": "25.91809000"
                    },
                    {
                        "id": 94505,
                        "name": "Gălăneşti",
                        "latitude": "47.91667000",
                        "longitude": "25.80000000"
                    },
                    {
                        "id": 94443,
                        "name": "Grămeşti",
                        "latitude": "47.91667000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 94445,
                        "name": "Grăniceşti",
                        "latitude": "47.81667000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 94448,
                        "name": "Gulia",
                        "latitude": "47.41203000",
                        "longitude": "26.60854000"
                    },
                    {
                        "id": 94454,
                        "name": "Gura Humorului",
                        "latitude": "47.55000000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 94458,
                        "name": "Gura Putnei",
                        "latitude": "47.89951000",
                        "longitude": "25.59510000"
                    },
                    {
                        "id": 94604,
                        "name": "Hănțești",
                        "latitude": "47.75507000",
                        "longitude": "26.37366000"
                    },
                    {
                        "id": 94592,
                        "name": "Hârtop",
                        "latitude": "47.49000000",
                        "longitude": "26.37226000"
                    },
                    {
                        "id": 94532,
                        "name": "Herla",
                        "latitude": "47.44286000",
                        "longitude": "26.01254000"
                    },
                    {
                        "id": 94566,
                        "name": "Horodnic de Jos",
                        "latitude": "47.86523000",
                        "longitude": "25.81856000"
                    },
                    {
                        "id": 94567,
                        "name": "Horodnic de Sus",
                        "latitude": "47.84012000",
                        "longitude": "25.82354000"
                    },
                    {
                        "id": 94568,
                        "name": "Horodniceni",
                        "latitude": "47.53333000",
                        "longitude": "26.16667000"
                    },
                    {
                        "id": 94576,
                        "name": "Humoreni",
                        "latitude": "47.66667000",
                        "longitude": "25.98333000"
                    },
                    {
                        "id": 94582,
                        "name": "Hurjuieni",
                        "latitude": "47.91667000",
                        "longitude": "25.81667000"
                    },
                    {
                        "id": 94615,
                        "name": "Iacobeni",
                        "latitude": "47.43333000",
                        "longitude": "25.31667000"
                    },
                    {
                        "id": 94625,
                        "name": "Iaslovăț",
                        "latitude": "47.75862000",
                        "longitude": "25.97742000"
                    },
                    {
                        "id": 94658,
                        "name": "Ilișești",
                        "latitude": "47.60878000",
                        "longitude": "26.05061000"
                    },
                    {
                        "id": 94684,
                        "name": "Ipoteşti",
                        "latitude": "47.61667000",
                        "longitude": "26.28333000"
                    },
                    {
                        "id": 94713,
                        "name": "Izvoarele Sucevei",
                        "latitude": "47.75000000",
                        "longitude": "25.18333000"
                    },
                    {
                        "id": 94893,
                        "name": "Lămășeni",
                        "latitude": "47.49322000",
                        "longitude": "26.22806000"
                    },
                    {
                        "id": 94811,
                        "name": "Liteni",
                        "latitude": "47.56667000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 95253,
                        "name": "Mălini",
                        "latitude": "47.46667000",
                        "longitude": "26.08333000"
                    },
                    {
                        "id": 95262,
                        "name": "Mănăstirea Humorului",
                        "latitude": "47.60000000",
                        "longitude": "25.86667000"
                    },
                    {
                        "id": 94930,
                        "name": "Marginea",
                        "latitude": "47.81667000",
                        "longitude": "25.81667000"
                    },
                    {
                        "id": 95278,
                        "name": "Măriței",
                        "latitude": "47.75270000",
                        "longitude": "26.14626000"
                    },
                    {
                        "id": 95294,
                        "name": "Măzănăești",
                        "latitude": "47.52795000",
                        "longitude": "26.08401000"
                    },
                    {
                        "id": 94990,
                        "name": "Mihăiești",
                        "latitude": "47.51563000",
                        "longitude": "26.21734000"
                    },
                    {
                        "id": 94986,
                        "name": "Mihoveni",
                        "latitude": "47.67994000",
                        "longitude": "26.18220000"
                    },
                    {
                        "id": 95005,
                        "name": "Milişăuţi",
                        "latitude": "47.78333000",
                        "longitude": "26.00000000"
                    },
                    {
                        "id": 95020,
                        "name": "Mironu",
                        "latitude": "47.48799000",
                        "longitude": "26.00952000"
                    },
                    {
                        "id": 95031,
                        "name": "Mitocu Dragomirnei",
                        "latitude": "47.73333000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 95039,
                        "name": "Moara Carp",
                        "latitude": "47.56667000",
                        "longitude": "26.23333000"
                    },
                    {
                        "id": 95042,
                        "name": "Moara Nica",
                        "latitude": "47.60086000",
                        "longitude": "26.22262000"
                    },
                    {
                        "id": 95062,
                        "name": "Moldova Suliţa",
                        "latitude": "47.68333000",
                        "longitude": "25.25000000"
                    },
                    {
                        "id": 95067,
                        "name": "Moldoviţa",
                        "latitude": "47.68333000",
                        "longitude": "25.53333000"
                    },
                    {
                        "id": 95133,
                        "name": "Municipiul Câmpulung Moldovenesc",
                        "latitude": "47.52981000",
                        "longitude": "25.55975000"
                    },
                    {
                        "id": 95143,
                        "name": "Municipiul Fãlticeni",
                        "latitude": "47.46189000",
                        "longitude": "26.31668000"
                    },
                    {
                        "id": 95176,
                        "name": "Municipiul Rãdãuţi",
                        "latitude": "47.85090000",
                        "longitude": "25.91570000"
                    },
                    {
                        "id": 95184,
                        "name": "Municipiul Suceava",
                        "latitude": "47.67457000",
                        "longitude": "26.28109000"
                    },
                    {
                        "id": 95196,
                        "name": "Municipiul Vatra Dornei",
                        "latitude": "47.34443000",
                        "longitude": "25.33391000"
                    },
                    {
                        "id": 95209,
                        "name": "Muşeniţa",
                        "latitude": "47.96667000",
                        "longitude": "26.00000000"
                    },
                    {
                        "id": 95303,
                        "name": "Neagra Șarului",
                        "latitude": "47.23907000",
                        "longitude": "25.32923000"
                    },
                    {
                        "id": 95312,
                        "name": "Negostina",
                        "latitude": "47.92282000",
                        "longitude": "26.08209000"
                    },
                    {
                        "id": 95320,
                        "name": "Negrileasa",
                        "latitude": "47.42348000",
                        "longitude": "25.81617000"
                    },
                    {
                        "id": 95440,
                        "name": "Oniceni",
                        "latitude": "47.32441000",
                        "longitude": "26.46217000"
                    },
                    {
                        "id": 95472,
                        "name": "Oraş Broşteni",
                        "latitude": "47.23673000",
                        "longitude": "25.70028000"
                    },
                    {
                        "id": 95489,
                        "name": "Oraş Cajvana",
                        "latitude": "47.71394000",
                        "longitude": "25.99186000"
                    },
                    {
                        "id": 95509,
                        "name": "Oraş Dolhasca",
                        "latitude": "47.41790000",
                        "longitude": "26.61083000"
                    },
                    {
                        "id": 95519,
                        "name": "Oraş Frasin",
                        "latitude": "47.51236000",
                        "longitude": "25.79977000"
                    },
                    {
                        "id": 95525,
                        "name": "Oraş Gura Humorului",
                        "latitude": "47.54191000",
                        "longitude": "25.87765000"
                    },
                    {
                        "id": 95539,
                        "name": "Oraş Liteni",
                        "latitude": "47.51068000",
                        "longitude": "26.53599000"
                    },
                    {
                        "id": 95542,
                        "name": "Oraş Milişãuţi",
                        "latitude": "47.78361000",
                        "longitude": "26.01317000"
                    },
                    {
                        "id": 95583,
                        "name": "Oraş Salcea",
                        "latitude": "47.64509000",
                        "longitude": "26.35842000"
                    },
                    {
                        "id": 95589,
                        "name": "Oraş Siret",
                        "latitude": "47.94798000",
                        "longitude": "26.06875000"
                    },
                    {
                        "id": 95592,
                        "name": "Oraş Solca",
                        "latitude": "47.70078000",
                        "longitude": "25.83488000"
                    },
                    {
                        "id": 95616,
                        "name": "Oraş Vicovu De Sus",
                        "latitude": "47.92071000",
                        "longitude": "25.65842000"
                    },
                    {
                        "id": 95675,
                        "name": "Ostra",
                        "latitude": "47.40000000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 96015,
                        "name": "Păltinoasa",
                        "latitude": "47.55000000",
                        "longitude": "25.95000000"
                    },
                    {
                        "id": 95703,
                        "name": "Panaci",
                        "latitude": "47.26667000",
                        "longitude": "25.38333000"
                    },
                    {
                        "id": 95997,
                        "name": "Pâraie",
                        "latitude": "47.46299000",
                        "longitude": "26.06608000"
                    },
                    {
                        "id": 96020,
                        "name": "Părhăuți",
                        "latitude": "47.71057000",
                        "longitude": "26.09012000"
                    },
                    {
                        "id": 96021,
                        "name": "Părteştii de Jos",
                        "latitude": "47.63333000",
                        "longitude": "25.96667000"
                    },
                    {
                        "id": 96023,
                        "name": "Pătrăuţi",
                        "latitude": "47.71667000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 95835,
                        "name": "Plăvălari",
                        "latitude": "47.56832000",
                        "longitude": "26.35925000"
                    },
                    {
                        "id": 95817,
                        "name": "Plopeni",
                        "latitude": "47.65874000",
                        "longitude": "26.33913000"
                    },
                    {
                        "id": 95833,
                        "name": "Plutonița",
                        "latitude": "47.48081000",
                        "longitude": "25.79145000"
                    },
                    {
                        "id": 95878,
                        "name": "Poiana Mărului",
                        "latitude": "47.41188000",
                        "longitude": "26.04077000"
                    },
                    {
                        "id": 95881,
                        "name": "Poiana Stampei",
                        "latitude": "47.31667000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 95892,
                        "name": "Poieni-Solca",
                        "latitude": "47.68626000",
                        "longitude": "25.89374000"
                    },
                    {
                        "id": 95899,
                        "name": "Pojorâta",
                        "latitude": "47.51667000",
                        "longitude": "25.45000000"
                    },
                    {
                        "id": 95945,
                        "name": "Prelipca",
                        "latitude": "47.61085000",
                        "longitude": "26.35414000"
                    },
                    {
                        "id": 95946,
                        "name": "Preuteşti",
                        "latitude": "47.45000000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 95958,
                        "name": "Probota",
                        "latitude": "47.37584000",
                        "longitude": "26.62415000"
                    },
                    {
                        "id": 95990,
                        "name": "Putna",
                        "latitude": "47.86667000",
                        "longitude": "25.61667000"
                    },
                    {
                        "id": 96203,
                        "name": "Rădăşeni",
                        "latitude": "47.46667000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 96201,
                        "name": "Rădăuți",
                        "latitude": "47.85000000",
                        "longitude": "25.91667000"
                    },
                    {
                        "id": 96177,
                        "name": "Râşca",
                        "latitude": "47.36667000",
                        "longitude": "26.23333000"
                    },
                    {
                        "id": 96135,
                        "name": "Roșcani",
                        "latitude": "47.53346000",
                        "longitude": "26.54909000"
                    },
                    {
                        "id": 96119,
                        "name": "Rotunda",
                        "latitude": "47.48745000",
                        "longitude": "26.52466000"
                    },
                    {
                        "id": 96224,
                        "name": "Sadova",
                        "latitude": "47.53333000",
                        "longitude": "25.50000000"
                    },
                    {
                        "id": 96229,
                        "name": "Salcea",
                        "latitude": "47.65000000",
                        "longitude": "26.36667000"
                    },
                    {
                        "id": 97031,
                        "name": "Şaru Dornei",
                        "latitude": "47.28333000",
                        "longitude": "25.35000000"
                    },
                    {
                        "id": 96253,
                        "name": "Satu Mare",
                        "latitude": "47.83333000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 96264,
                        "name": "Scheia",
                        "latitude": "47.65000000",
                        "longitude": "26.23333000"
                    },
                    {
                        "id": 97119,
                        "name": "Șerbănești",
                        "latitude": "47.81014000",
                        "longitude": "26.31922000"
                    },
                    {
                        "id": 97120,
                        "name": "Șerbăuți",
                        "latitude": "47.82684000",
                        "longitude": "26.14009000"
                    },
                    {
                        "id": 96347,
                        "name": "Siminicea",
                        "latitude": "47.70000000",
                        "longitude": "26.40000000"
                    },
                    {
                        "id": 96358,
                        "name": "Siret",
                        "latitude": "47.95000000",
                        "longitude": "26.06667000"
                    },
                    {
                        "id": 96362,
                        "name": "Slatina",
                        "latitude": "47.45000000",
                        "longitude": "26.01667000"
                    },
                    {
                        "id": 96404,
                        "name": "Solca",
                        "latitude": "47.70000000",
                        "longitude": "25.85000000"
                    },
                    {
                        "id": 96406,
                        "name": "Soloneț",
                        "latitude": "47.68682000",
                        "longitude": "26.03222000"
                    },
                    {
                        "id": 96421,
                        "name": "Stamate",
                        "latitude": "47.60598000",
                        "longitude": "26.51698000"
                    },
                    {
                        "id": 96447,
                        "name": "Straja",
                        "latitude": "47.91667000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 96462,
                        "name": "Strâmtura",
                        "latitude": "47.58082000",
                        "longitude": "25.68144000"
                    },
                    {
                        "id": 96457,
                        "name": "Stroiești",
                        "latitude": "47.61667000",
                        "longitude": "26.13333000"
                    },
                    {
                        "id": 96467,
                        "name": "Stulpicani",
                        "latitude": "47.46667000",
                        "longitude": "25.76667000"
                    },
                    {
                        "id": 96488,
                        "name": "Suceava",
                        "latitude": "47.63333000",
                        "longitude": "26.25000000"
                    },
                    {
                        "id": 96490,
                        "name": "Suceviţa",
                        "latitude": "47.78333000",
                        "longitude": "25.71667000"
                    },
                    {
                        "id": 97138,
                        "name": "Țibeni",
                        "latitude": "47.81618000",
                        "longitude": "26.02438000"
                    },
                    {
                        "id": 106116,
                        "name": "Todireşti",
                        "latitude": "47.70000000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 96638,
                        "name": "Udeşti",
                        "latitude": "47.56667000",
                        "longitude": "26.41667000"
                    },
                    {
                        "id": 96644,
                        "name": "Ulma",
                        "latitude": "47.88333000",
                        "longitude": "25.30000000"
                    },
                    {
                        "id": 96697,
                        "name": "Vadu Moldovei",
                        "latitude": "47.38333000",
                        "longitude": "26.36667000"
                    },
                    {
                        "id": 96741,
                        "name": "Valea Moldovei",
                        "latitude": "47.46667000",
                        "longitude": "26.03333000"
                    },
                    {
                        "id": 96771,
                        "name": "Vama",
                        "latitude": "47.56667000",
                        "longitude": "25.68333000"
                    },
                    {
                        "id": 96969,
                        "name": "Văratec",
                        "latitude": "47.63988000",
                        "longitude": "26.40312000"
                    },
                    {
                        "id": 96777,
                        "name": "Vatra Dornei",
                        "latitude": "47.35000000",
                        "longitude": "25.36667000"
                    },
                    {
                        "id": 96778,
                        "name": "Vatra Moldoviţei",
                        "latitude": "47.65000000",
                        "longitude": "25.56667000"
                    },
                    {
                        "id": 96787,
                        "name": "Vereşti",
                        "latitude": "47.60000000",
                        "longitude": "26.43333000"
                    },
                    {
                        "id": 96800,
                        "name": "Vicovu de Jos",
                        "latitude": "47.90000000",
                        "longitude": "25.73333000"
                    },
                    {
                        "id": 96801,
                        "name": "Vicovu de Sus",
                        "latitude": "47.93333000",
                        "longitude": "25.68333000"
                    },
                    {
                        "id": 96875,
                        "name": "Voievodeasa",
                        "latitude": "47.79953000",
                        "longitude": "25.74939000"
                    },
                    {
                        "id": 96885,
                        "name": "Voitinel",
                        "latitude": "47.88366000",
                        "longitude": "25.75735000"
                    },
                    {
                        "id": 96888,
                        "name": "Volovăţ",
                        "latitude": "47.81667000",
                        "longitude": "25.90000000"
                    },
                    {
                        "id": 96911,
                        "name": "Vultureşti",
                        "latitude": "47.51667000",
                        "longitude": "26.45000000"
                    },
                    {
                        "id": 96984,
                        "name": "Zamostea",
                        "latitude": "47.86667000",
                        "longitude": "26.20000000"
                    },
                    {
                        "id": 97006,
                        "name": "Zvoriştea",
                        "latitude": "47.83333000",
                        "longitude": "26.28333000"
                    }
                ]
            },
            {
                "id": 4728,
                "name": "Teleorman",
                "iso2": "TR",
                "latitude": "44.01604910",
                "longitude": "25.29866280",
                "type": "department",
                "cities": [
                    {
                        "id": 89925,
                        "name": "Alexandria",
                        "latitude": "43.98333000",
                        "longitude": "25.33333000"
                    },
                    {
                        "id": 90473,
                        "name": "Băbăiţa",
                        "latitude": "44.16667000",
                        "longitude": "25.38333000"
                    },
                    {
                        "id": 90478,
                        "name": "Băcălești",
                        "latitude": "44.05997000",
                        "longitude": "24.81636000"
                    },
                    {
                        "id": 90023,
                        "name": "Baciu",
                        "latitude": "44.33152000",
                        "longitude": "25.44429000"
                    },
                    {
                        "id": 90485,
                        "name": "Băduleasa",
                        "latitude": "43.92286000",
                        "longitude": "24.98274000"
                    },
                    {
                        "id": 90037,
                        "name": "Balaci",
                        "latitude": "44.35000000",
                        "longitude": "24.91667000"
                    },
                    {
                        "id": 90529,
                        "name": "Băneasa",
                        "latitude": "43.93975000",
                        "longitude": "24.94997000"
                    },
                    {
                        "id": 90466,
                        "name": "Bâscoveni",
                        "latitude": "44.24444000",
                        "longitude": "25.35998000"
                    },
                    {
                        "id": 90078,
                        "name": "Beciu",
                        "latitude": "44.00429000",
                        "longitude": "24.66571000"
                    },
                    {
                        "id": 90082,
                        "name": "Beiu",
                        "latitude": "43.87352000",
                        "longitude": "25.45548000"
                    },
                    {
                        "id": 90121,
                        "name": "Beuca",
                        "latitude": "44.25200000",
                        "longitude": "24.96637000"
                    },
                    {
                        "id": 90157,
                        "name": "Blejeşti",
                        "latitude": "44.30000000",
                        "longitude": "25.46667000"
                    },
                    {
                        "id": 90189,
                        "name": "Bogdana",
                        "latitude": "43.93333000",
                        "longitude": "25.08333000"
                    },
                    {
                        "id": 90246,
                        "name": "Botoroaga",
                        "latitude": "44.14833000",
                        "longitude": "25.54472000"
                    },
                    {
                        "id": 90263,
                        "name": "Bragadiru",
                        "latitude": "43.76667000",
                        "longitude": "25.51667000"
                    },
                    {
                        "id": 90318,
                        "name": "Brânceni",
                        "latitude": "43.88333000",
                        "longitude": "25.40000000"
                    },
                    {
                        "id": 90319,
                        "name": "Brâncoveanca",
                        "latitude": "43.94075000",
                        "longitude": "24.69336000"
                    },
                    {
                        "id": 90398,
                        "name": "Bujoreni",
                        "latitude": "44.11667000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 90400,
                        "name": "Bujoru",
                        "latitude": "43.71667000",
                        "longitude": "25.56667000"
                    },
                    {
                        "id": 90431,
                        "name": "Buzescu",
                        "latitude": "44.01667000",
                        "longitude": "25.23333000"
                    },
                    {
                        "id": 93837,
                        "name": "Călineşti",
                        "latitude": "44.08333000",
                        "longitude": "25.23333000"
                    },
                    {
                        "id": 93843,
                        "name": "Călmăţuiu",
                        "latitude": "43.96667000",
                        "longitude": "24.86667000"
                    },
                    {
                        "id": 93844,
                        "name": "Călmățuiu de Sus",
                        "latitude": "44.02632000",
                        "longitude": "24.81230000"
                    },
                    {
                        "id": 90564,
                        "name": "Calomfirești",
                        "latitude": "43.91736000",
                        "longitude": "25.35801000"
                    },
                    {
                        "id": 90632,
                        "name": "Cernetu",
                        "latitude": "43.90727000",
                        "longitude": "25.45688000"
                    },
                    {
                        "id": 90643,
                        "name": "Cervenia",
                        "latitude": "43.83333000",
                        "longitude": "25.46667000"
                    },
                    {
                        "id": 90738,
                        "name": "Ciuani",
                        "latitude": "44.23333000",
                        "longitude": "25.65000000"
                    },
                    {
                        "id": 90754,
                        "name": "Ciuperceni",
                        "latitude": "43.76667000",
                        "longitude": "24.95000000"
                    },
                    {
                        "id": 91202,
                        "name": "Comuna Băbăiţa",
                        "latitude": "44.13909000",
                        "longitude": "25.39156000"
                    },
                    {
                        "id": 90921,
                        "name": "Comuna Balaci",
                        "latitude": "44.35188000",
                        "longitude": "24.90962000"
                    },
                    {
                        "id": 90946,
                        "name": "Comuna Beciu",
                        "latitude": "44.01272000",
                        "longitude": "24.66163000"
                    },
                    {
                        "id": 90979,
                        "name": "Comuna Beuca",
                        "latitude": "44.26595000",
                        "longitude": "24.97928000"
                    },
                    {
                        "id": 91002,
                        "name": "Comuna Blejeşti",
                        "latitude": "44.30317000",
                        "longitude": "25.45269000"
                    },
                    {
                        "id": 91024,
                        "name": "Comuna Bogdana",
                        "latitude": "43.92860000",
                        "longitude": "25.08358000"
                    },
                    {
                        "id": 91063,
                        "name": "Comuna Botoroaga",
                        "latitude": "44.14997000",
                        "longitude": "25.55171000"
                    },
                    {
                        "id": 91074,
                        "name": "Comuna Bragadiru",
                        "latitude": "43.76059000",
                        "longitude": "25.51984000"
                    },
                    {
                        "id": 91109,
                        "name": "Comuna Brânceni",
                        "latitude": "43.87792000",
                        "longitude": "25.39711000"
                    },
                    {
                        "id": 91156,
                        "name": "Comuna Bujoreni",
                        "latitude": "44.12054000",
                        "longitude": "25.65152000"
                    },
                    {
                        "id": 91157,
                        "name": "Comuna Bujoru",
                        "latitude": "43.71092000",
                        "longitude": "25.56315000"
                    },
                    {
                        "id": 91179,
                        "name": "Comuna Buzescu",
                        "latitude": "44.01081000",
                        "longitude": "25.22886000"
                    },
                    {
                        "id": 91573,
                        "name": "Comuna Călineşti",
                        "latitude": "44.11002000",
                        "longitude": "25.21305000"
                    },
                    {
                        "id": 91560,
                        "name": "Comuna Cãlmãţuiu",
                        "latitude": "43.96083000",
                        "longitude": "24.85612000"
                    },
                    {
                        "id": 91561,
                        "name": "Comuna Cãlmãţuiu De Sus",
                        "latitude": "44.04404000",
                        "longitude": "24.81582000"
                    },
                    {
                        "id": 91300,
                        "name": "Comuna Cervenia",
                        "latitude": "43.83585000",
                        "longitude": "25.46050000"
                    },
                    {
                        "id": 91351,
                        "name": "Comuna Ciolăneşti",
                        "latitude": "44.31372000",
                        "longitude": "25.08333000"
                    },
                    {
                        "id": 91373,
                        "name": "Comuna Ciuperceni",
                        "latitude": "43.75115000",
                        "longitude": "24.94397000"
                    },
                    {
                        "id": 91415,
                        "name": "Comuna Conţeşti",
                        "latitude": "43.79183000",
                        "longitude": "25.49530000"
                    },
                    {
                        "id": 91450,
                        "name": "Comuna Cosmeşti",
                        "latitude": "44.30661000",
                        "longitude": "25.38602000"
                    },
                    {
                        "id": 91513,
                        "name": "Comuna Crângeni",
                        "latitude": "44.01370000",
                        "longitude": "24.80845000"
                    },
                    {
                        "id": 91514,
                        "name": "Comuna Crângu",
                        "latitude": "43.84490000",
                        "longitude": "25.08121000"
                    },
                    {
                        "id": 91491,
                        "name": "Comuna Crevenicu",
                        "latitude": "44.24508000",
                        "longitude": "25.57385000"
                    },
                    {
                        "id": 91624,
                        "name": "Comuna Dideşti",
                        "latitude": "44.22331000",
                        "longitude": "24.88878000"
                    },
                    {
                        "id": 91642,
                        "name": "Comuna Dobroteşti",
                        "latitude": "44.26466000",
                        "longitude": "24.88097000"
                    },
                    {
                        "id": 91669,
                        "name": "Comuna Dracea",
                        "latitude": "43.87177000",
                        "longitude": "25.03182000"
                    },
                    {
                        "id": 91682,
                        "name": "Comuna Drãcşenei",
                        "latitude": "44.20715000",
                        "longitude": "25.00370000"
                    },
                    {
                        "id": 91702,
                        "name": "Comuna Drăgăneşti de Vede",
                        "latitude": "44.13081000",
                        "longitude": "25.04870000"
                    },
                    {
                        "id": 91703,
                        "name": "Comuna Drăgăneşti-Vlaşca",
                        "latitude": "44.09517000",
                        "longitude": "25.54848000"
                    },
                    {
                        "id": 91808,
                        "name": "Comuna Fântânele",
                        "latitude": "43.72104000",
                        "longitude": "25.29265000"
                    },
                    {
                        "id": 91793,
                        "name": "Comuna Frăsinet",
                        "latitude": "44.18808000",
                        "longitude": "25.37818000"
                    },
                    {
                        "id": 91783,
                        "name": "Comuna Frumoasa",
                        "latitude": "43.80298000",
                        "longitude": "25.46311000"
                    },
                    {
                        "id": 91803,
                        "name": "Comuna Furculeşti",
                        "latitude": "43.86572000",
                        "longitude": "25.13980000"
                    },
                    {
                        "id": 91984,
                        "name": "Comuna Gălăţeni",
                        "latitude": "44.22491000",
                        "longitude": "25.36466000"
                    },
                    {
                        "id": 91911,
                        "name": "Comuna Gratia",
                        "latitude": "44.43382000",
                        "longitude": "25.44103000"
                    },
                    {
                        "id": 92093,
                        "name": "Comuna Islaz",
                        "latitude": "43.75179000",
                        "longitude": "24.74381000"
                    },
                    {
                        "id": 92106,
                        "name": "Comuna Izvoarele",
                        "latitude": "43.82717000",
                        "longitude": "25.39459000"
                    },
                    {
                        "id": 92172,
                        "name": "Comuna Lisa",
                        "latitude": "43.77230000",
                        "longitude": "25.14919000"
                    },
                    {
                        "id": 92180,
                        "name": "Comuna Liţa",
                        "latitude": "43.79545000",
                        "longitude": "24.82157000"
                    },
                    {
                        "id": 92200,
                        "name": "Comuna Lunca",
                        "latitude": "43.85788000",
                        "longitude": "24.78610000"
                    },
                    {
                        "id": 92390,
                        "name": "Comuna Măgura",
                        "latitude": "44.04054000",
                        "longitude": "25.39590000"
                    },
                    {
                        "id": 92396,
                        "name": "Comuna Măldăeni",
                        "latitude": "44.12658000",
                        "longitude": "24.92327000"
                    },
                    {
                        "id": 92372,
                        "name": "Comuna Mârzãneşti",
                        "latitude": "43.93154000",
                        "longitude": "25.46230000"
                    },
                    {
                        "id": 92248,
                        "name": "Comuna Mavrodin",
                        "latitude": "44.03559000",
                        "longitude": "25.24088000"
                    },
                    {
                        "id": 92257,
                        "name": "Comuna Mereni",
                        "latitude": "44.22879000",
                        "longitude": "25.64434000"
                    },
                    {
                        "id": 92350,
                        "name": "Comuna Moşteni",
                        "latitude": "44.19787000",
                        "longitude": "25.50854000"
                    },
                    {
                        "id": 92426,
                        "name": "Comuna Nanov",
                        "latitude": "43.99171000",
                        "longitude": "25.28894000"
                    },
                    {
                        "id": 92466,
                        "name": "Comuna Năsturelu",
                        "latitude": "43.66634000",
                        "longitude": "25.43856000"
                    },
                    {
                        "id": 92427,
                        "name": "Comuna Necşeşti",
                        "latitude": "44.26085000",
                        "longitude": "25.13225000"
                    },
                    {
                        "id": 92437,
                        "name": "Comuna Nenciuleşti",
                        "latitude": "44.03860000",
                        "longitude": "25.18551000"
                    },
                    {
                        "id": 92497,
                        "name": "Comuna Olteni",
                        "latitude": "44.18976000",
                        "longitude": "25.27800000"
                    },
                    {
                        "id": 92506,
                        "name": "Comuna Orbeasca",
                        "latitude": "44.11606000",
                        "longitude": "25.32708000"
                    },
                    {
                        "id": 92547,
                        "name": "Comuna Peretu",
                        "latitude": "44.04372000",
                        "longitude": "25.09285000"
                    },
                    {
                        "id": 92573,
                        "name": "Comuna Piatra",
                        "latitude": "43.81058000",
                        "longitude": "25.16777000"
                    },
                    {
                        "id": 92581,
                        "name": "Comuna Pietroşani",
                        "latitude": "43.71364000",
                        "longitude": "25.63998000"
                    },
                    {
                        "id": 92597,
                        "name": "Comuna Plopii Slăviţeşti",
                        "latitude": "43.96098000",
                        "longitude": "24.68525000"
                    },
                    {
                        "id": 92601,
                        "name": "Comuna Plosca",
                        "latitude": "44.02338000",
                        "longitude": "25.14920000"
                    },
                    {
                        "id": 92618,
                        "name": "Comuna Poeni",
                        "latitude": "44.43297000",
                        "longitude": "25.33868000"
                    },
                    {
                        "id": 92660,
                        "name": "Comuna Poroschia",
                        "latitude": "43.92887000",
                        "longitude": "25.35760000"
                    },
                    {
                        "id": 92698,
                        "name": "Comuna Purani",
                        "latitude": "44.36509000",
                        "longitude": "25.41322000"
                    },
                    {
                        "id": 92699,
                        "name": "Comuna Putineiu",
                        "latitude": "43.91429000",
                        "longitude": "24.96969000"
                    },
                    {
                        "id": 92830,
                        "name": "Comuna Rãdoieşti",
                        "latitude": "44.14377000",
                        "longitude": "25.15357000"
                    },
                    {
                        "id": 92848,
                        "name": "Comuna Răsmireşti",
                        "latitude": "43.99981000",
                        "longitude": "25.57118000"
                    },
                    {
                        "id": 93084,
                        "name": "Comuna Săceni",
                        "latitude": "44.23310000",
                        "longitude": "25.06073000"
                    },
                    {
                        "id": 92861,
                        "name": "Comuna Saelele",
                        "latitude": "43.85274000",
                        "longitude": "24.73838000"
                    },
                    {
                        "id": 92864,
                        "name": "Comuna Salcia",
                        "latitude": "43.94157000",
                        "longitude": "24.92663000"
                    },
                    {
                        "id": 93071,
                        "name": "Comuna Sârbeni",
                        "latitude": "44.46667000",
                        "longitude": "25.38333000"
                    },
                    {
                        "id": 92897,
                        "name": "Comuna Scrioaştea",
                        "latitude": "44.16453000",
                        "longitude": "24.95299000"
                    },
                    {
                        "id": 92899,
                        "name": "Comuna Scurtu Mare",
                        "latitude": "44.35259000",
                        "longitude": "25.25895000"
                    },
                    {
                        "id": 92908,
                        "name": "Comuna Seaca",
                        "latitude": "43.74933000",
                        "longitude": "25.07423000"
                    },
                    {
                        "id": 92918,
                        "name": "Comuna Segarcea Vale",
                        "latitude": "43.82417000",
                        "longitude": "24.81422000"
                    },
                    {
                        "id": 92922,
                        "name": "Comuna Sfinţeşti",
                        "latitude": "44.18824000",
                        "longitude": "25.10389000"
                    },
                    {
                        "id": 92930,
                        "name": "Comuna Siliştea",
                        "latitude": "44.37398000",
                        "longitude": "25.35104000"
                    },
                    {
                        "id": 92934,
                        "name": "Comuna Siliștea Gumești",
                        "latitude": "44.38028000",
                        "longitude": "25.01389000"
                    },
                    {
                        "id": 92959,
                        "name": "Comuna Slobozia-Mândra",
                        "latitude": "43.91576000",
                        "longitude": "24.69914000"
                    },
                    {
                        "id": 92966,
                        "name": "Comuna Smârdioasa",
                        "latitude": "43.83939000",
                        "longitude": "25.44190000"
                    },
                    {
                        "id": 92989,
                        "name": "Comuna Stejaru",
                        "latitude": "44.17715000",
                        "longitude": "24.88208000"
                    },
                    {
                        "id": 93000,
                        "name": "Comuna Storobăneasa",
                        "latitude": "43.87974000",
                        "longitude": "25.45622000"
                    },
                    {
                        "id": 93029,
                        "name": "Comuna Suhaia",
                        "latitude": "43.73953000",
                        "longitude": "25.25291000"
                    },
                    {
                        "id": 93121,
                        "name": "Comuna Talpa",
                        "latitude": "44.28070000",
                        "longitude": "25.30919000"
                    },
                    {
                        "id": 93248,
                        "name": "Comuna Tătărăştii de Jos",
                        "latitude": "44.36960000",
                        "longitude": "25.19385000"
                    },
                    {
                        "id": 93249,
                        "name": "Comuna Tătărăştii de Sus",
                        "latitude": "44.40857000",
                        "longitude": "25.13146000"
                    },
                    {
                        "id": 93575,
                        "name": "Comuna Ţigăneşti",
                        "latitude": "43.90141000",
                        "longitude": "25.37804000"
                    },
                    {
                        "id": 93188,
                        "name": "Comuna Traian",
                        "latitude": "43.76720000",
                        "longitude": "25.00494000"
                    },
                    {
                        "id": 93195,
                        "name": "Comuna Trivalea-Moşteni",
                        "latitude": "44.26200000",
                        "longitude": "25.24082000"
                    },
                    {
                        "id": 93196,
                        "name": "Comuna Troianul",
                        "latitude": "44.00415000",
                        "longitude": "25.02400000"
                    },
                    {
                        "id": 93253,
                        "name": "Comuna Uda-Clocociov",
                        "latitude": "43.88385000",
                        "longitude": "24.71908000"
                    },
                    {
                        "id": 93445,
                        "name": "Comuna Vârtoape",
                        "latitude": "44.19981000",
                        "longitude": "25.19797000"
                    },
                    {
                        "id": 93340,
                        "name": "Comuna Vedea",
                        "latitude": "44.09436000",
                        "longitude": "25.07495000"
                    },
                    {
                        "id": 93359,
                        "name": "Comuna Viişoara",
                        "latitude": "43.77985000",
                        "longitude": "25.17520000"
                    },
                    {
                        "id": 93371,
                        "name": "Comuna Vităneşti",
                        "latitude": "43.99272000",
                        "longitude": "25.45246000"
                    },
                    {
                        "id": 93482,
                        "name": "Comuna Zâmbreasca",
                        "latitude": "44.30350000",
                        "longitude": "24.99847000"
                    },
                    {
                        "id": 93596,
                        "name": "Conţeşti",
                        "latitude": "43.80000000",
                        "longitude": "25.48333000"
                    },
                    {
                        "id": 93653,
                        "name": "Cosmeşti",
                        "latitude": "44.30000000",
                        "longitude": "25.38333000"
                    },
                    {
                        "id": 93747,
                        "name": "Crângeni",
                        "latitude": "44.03333000",
                        "longitude": "24.78333000"
                    },
                    {
                        "id": 93748,
                        "name": "Crângu",
                        "latitude": "43.84611000",
                        "longitude": "25.07350000"
                    },
                    {
                        "id": 93712,
                        "name": "Crevenicu",
                        "latitude": "44.24083000",
                        "longitude": "25.58861000"
                    },
                    {
                        "id": 93759,
                        "name": "Cucueți",
                        "latitude": "44.18432000",
                        "longitude": "24.94826000"
                    },
                    {
                        "id": 93921,
                        "name": "Deparați",
                        "latitude": "44.28116000",
                        "longitude": "25.22151000"
                    },
                    {
                        "id": 93935,
                        "name": "Didești",
                        "latitude": "44.21667000",
                        "longitude": "24.88333000"
                    },
                    {
                        "id": 93950,
                        "name": "Dobreni",
                        "latitude": "44.41667000",
                        "longitude": "25.11667000"
                    },
                    {
                        "id": 93965,
                        "name": "Dobroteşti",
                        "latitude": "44.28333000",
                        "longitude": "24.88333000"
                    },
                    {
                        "id": 94009,
                        "name": "Dracea",
                        "latitude": "43.84914000",
                        "longitude": "25.05194000"
                    },
                    {
                        "id": 94034,
                        "name": "Drăcşani",
                        "latitude": "44.21667000",
                        "longitude": "24.98333000"
                    },
                    {
                        "id": 94035,
                        "name": "Drăcșenei",
                        "latitude": "44.22676000",
                        "longitude": "24.98542000"
                    },
                    {
                        "id": 94060,
                        "name": "Drăgăneşti de Vede",
                        "latitude": "44.13333000",
                        "longitude": "25.05000000"
                    },
                    {
                        "id": 94062,
                        "name": "Drăgăneşti-Vlaşca",
                        "latitude": "44.10139000",
                        "longitude": "25.59806000"
                    },
                    {
                        "id": 94040,
                        "name": "Drăghinești",
                        "latitude": "44.43093000",
                        "longitude": "25.42608000"
                    },
                    {
                        "id": 94072,
                        "name": "Dudu",
                        "latitude": "43.97897000",
                        "longitude": "24.67786000"
                    },
                    {
                        "id": 94237,
                        "name": "Fântânele",
                        "latitude": "43.72104000",
                        "longitude": "25.29265000"
                    },
                    {
                        "id": 94218,
                        "name": "Frăsinet",
                        "latitude": "44.18038000",
                        "longitude": "25.38238000"
                    },
                    {
                        "id": 94207,
                        "name": "Frumoasa",
                        "latitude": "43.80000000",
                        "longitude": "25.46667000"
                    },
                    {
                        "id": 94233,
                        "name": "Furculești",
                        "latitude": "43.87202000",
                        "longitude": "25.14285000"
                    },
                    {
                        "id": 94507,
                        "name": "Gălăţeni",
                        "latitude": "44.21667000",
                        "longitude": "25.35000000"
                    },
                    {
                        "id": 94512,
                        "name": "Gărăgău",
                        "latitude": "44.23186000",
                        "longitude": "25.18920000"
                    },
                    {
                        "id": 94401,
                        "name": "Gratia",
                        "latitude": "44.43333000",
                        "longitude": "25.45000000"
                    },
                    {
                        "id": 94473,
                        "name": "Guruieni",
                        "latitude": "44.05845000",
                        "longitude": "25.39656000"
                    },
                    {
                        "id": 94691,
                        "name": "Islaz",
                        "latitude": "43.72006000",
                        "longitude": "24.76436000"
                    },
                    {
                        "id": 94711,
                        "name": "Izvoarele",
                        "latitude": "43.81667000",
                        "longitude": "25.38333000"
                    },
                    {
                        "id": 94888,
                        "name": "Lăceni",
                        "latitude": "44.08466000",
                        "longitude": "25.33270000"
                    },
                    {
                        "id": 94808,
                        "name": "Lisa",
                        "latitude": "43.80000000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 94826,
                        "name": "Liţa",
                        "latitude": "43.80000000",
                        "longitude": "24.81667000"
                    },
                    {
                        "id": 94860,
                        "name": "Lunca",
                        "latitude": "43.83333000",
                        "longitude": "24.76667000"
                    },
                    {
                        "id": 95239,
                        "name": "Măgura",
                        "latitude": "44.03333000",
                        "longitude": "25.40000000"
                    },
                    {
                        "id": 95251,
                        "name": "Măldăeni",
                        "latitude": "44.11667000",
                        "longitude": "24.93333000"
                    },
                    {
                        "id": 95221,
                        "name": "Mârzăneşti",
                        "latitude": "43.93333000",
                        "longitude": "25.46667000"
                    },
                    {
                        "id": 94937,
                        "name": "Mavrodin",
                        "latitude": "44.03333000",
                        "longitude": "25.25000000"
                    },
                    {
                        "id": 94953,
                        "name": "Merenii de Jos",
                        "latitude": "44.23214000",
                        "longitude": "25.64346000"
                    },
                    {
                        "id": 94954,
                        "name": "Merenii de Sus",
                        "latitude": "44.22839000",
                        "longitude": "25.62103000"
                    },
                    {
                        "id": 94960,
                        "name": "Merișani",
                        "latitude": "44.25190000",
                        "longitude": "24.87550000"
                    },
                    {
                        "id": 95065,
                        "name": "Moldoveni",
                        "latitude": "43.77772000",
                        "longitude": "24.72802000"
                    },
                    {
                        "id": 95096,
                        "name": "Moșteni",
                        "latitude": "44.19787000",
                        "longitude": "25.50854000"
                    },
                    {
                        "id": 95108,
                        "name": "Municipiul Alexandria",
                        "latitude": "43.96967000",
                        "longitude": "25.33272000"
                    },
                    {
                        "id": 95173,
                        "name": "Municipiul Roșiorii de Vede",
                        "latitude": "44.11368000",
                        "longitude": "24.98722000"
                    },
                    {
                        "id": 95190,
                        "name": "Municipiul Turnu Magurele",
                        "latitude": "43.74646000",
                        "longitude": "24.86893000"
                    },
                    {
                        "id": 95302,
                        "name": "Nanov",
                        "latitude": "44.00000000",
                        "longitude": "25.30000000"
                    },
                    {
                        "id": 95375,
                        "name": "Năsturelu",
                        "latitude": "43.66667000",
                        "longitude": "25.46667000"
                    },
                    {
                        "id": 95378,
                        "name": "Năvodari",
                        "latitude": "43.74208000",
                        "longitude": "25.09410000"
                    },
                    {
                        "id": 95304,
                        "name": "Necşeşti",
                        "latitude": "44.25000000",
                        "longitude": "25.15000000"
                    },
                    {
                        "id": 95327,
                        "name": "Nenciulești",
                        "latitude": "44.03486000",
                        "longitude": "25.20061000"
                    },
                    {
                        "id": 95429,
                        "name": "Olteanca",
                        "latitude": "43.83047000",
                        "longitude": "24.79597000"
                    },
                    {
                        "id": 95432,
                        "name": "Olteni",
                        "latitude": "44.18333000",
                        "longitude": "25.28333000"
                    },
                    {
                        "id": 95618,
                        "name": "Oraş Videle",
                        "latitude": "44.27660000",
                        "longitude": "25.57844000"
                    },
                    {
                        "id": 95623,
                        "name": "Oraş Zimnicea",
                        "latitude": "43.65660000",
                        "longitude": "25.36603000"
                    },
                    {
                        "id": 95653,
                        "name": "Orbeasca de Jos",
                        "latitude": "44.12177000",
                        "longitude": "25.32952000"
                    },
                    {
                        "id": 95654,
                        "name": "Orbeasca de Sus",
                        "latitude": "44.15000000",
                        "longitude": "25.31667000"
                    },
                    {
                        "id": 95727,
                        "name": "Peretu",
                        "latitude": "44.05000000",
                        "longitude": "25.08333000"
                    },
                    {
                        "id": 95734,
                        "name": "Perii Broșteni",
                        "latitude": "44.20336000",
                        "longitude": "25.26377000"
                    },
                    {
                        "id": 95770,
                        "name": "Piatra",
                        "latitude": "43.81667000",
                        "longitude": "25.16667000"
                    },
                    {
                        "id": 95789,
                        "name": "Pietroşani",
                        "latitude": "43.71383000",
                        "longitude": "25.64409000"
                    },
                    {
                        "id": 95808,
                        "name": "Pleașov",
                        "latitude": "43.84971000",
                        "longitude": "24.74886000"
                    },
                    {
                        "id": 95820,
                        "name": "Plopii Slăviţeştí",
                        "latitude": "43.96667000",
                        "longitude": "24.68333000"
                    },
                    {
                        "id": 95827,
                        "name": "Plosca",
                        "latitude": "44.03333000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 95853,
                        "name": "Poeni",
                        "latitude": "44.40000000",
                        "longitude": "25.33333000"
                    },
                    {
                        "id": 95860,
                        "name": "Poiana",
                        "latitude": "43.74192000",
                        "longitude": "24.95244000"
                    },
                    {
                        "id": 95917,
                        "name": "Poporogi",
                        "latitude": "44.36667000",
                        "longitude": "25.18333000"
                    },
                    {
                        "id": 95921,
                        "name": "Poroschia",
                        "latitude": "43.93333000",
                        "longitude": "25.36667000"
                    },
                    {
                        "id": 95965,
                        "name": "Prundu",
                        "latitude": "43.82394000",
                        "longitude": "24.69196000"
                    },
                    {
                        "id": 95983,
                        "name": "Purani",
                        "latitude": "43.97989000",
                        "longitude": "25.43656000"
                    },
                    {
                        "id": 95989,
                        "name": "Putineiu",
                        "latitude": "43.90000000",
                        "longitude": "24.96667000"
                    },
                    {
                        "id": 96198,
                        "name": "Rădoiești-Deal",
                        "latitude": "44.15000000",
                        "longitude": "25.13333000"
                    },
                    {
                        "id": 96207,
                        "name": "Răsmireşti",
                        "latitude": "43.98333000",
                        "longitude": "25.55000000"
                    },
                    {
                        "id": 96141,
                        "name": "Roșiorii de Vede",
                        "latitude": "44.11667000",
                        "longitude": "24.98333000"
                    },
                    {
                        "id": 105995,
                        "name": "Săceni",
                        "latitude": "44.23333000",
                        "longitude": "25.06667000"
                    },
                    {
                        "id": 96227,
                        "name": "Saelele",
                        "latitude": "43.85577000",
                        "longitude": "24.72789000"
                    },
                    {
                        "id": 96230,
                        "name": "Salcia",
                        "latitude": "43.95000000",
                        "longitude": "24.91667000"
                    },
                    {
                        "id": 105983,
                        "name": "Sârbeni",
                        "latitude": "44.46667000",
                        "longitude": "25.38333000"
                    },
                    {
                        "id": 96284,
                        "name": "Scrioaştea",
                        "latitude": "44.15000000",
                        "longitude": "24.95000000"
                    },
                    {
                        "id": 96290,
                        "name": "Scurtu Mare",
                        "latitude": "44.35000000",
                        "longitude": "25.26667000"
                    },
                    {
                        "id": 96299,
                        "name": "Seaca",
                        "latitude": "43.75000000",
                        "longitude": "25.06667000"
                    },
                    {
                        "id": 96320,
                        "name": "Segarcea Vale",
                        "latitude": "43.81667000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 96321,
                        "name": "Segarcea-Deal",
                        "latitude": "43.82548000",
                        "longitude": "24.84020000"
                    },
                    {
                        "id": 96327,
                        "name": "Sfinţeşti",
                        "latitude": "44.18333000",
                        "longitude": "25.10000000"
                    },
                    {
                        "id": 96339,
                        "name": "Siliştea",
                        "latitude": "44.38333000",
                        "longitude": "25.35000000"
                    },
                    {
                        "id": 96344,
                        "name": "Siliștea Gumești",
                        "latitude": "44.38333000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 96379,
                        "name": "Slobozia-Mândra",
                        "latitude": "43.91667000",
                        "longitude": "24.70000000"
                    },
                    {
                        "id": 96392,
                        "name": "Smârdioasa",
                        "latitude": "43.85000000",
                        "longitude": "25.43333000"
                    },
                    {
                        "id": 96394,
                        "name": "Socetu",
                        "latitude": "44.19502000",
                        "longitude": "24.85421000"
                    },
                    {
                        "id": 96420,
                        "name": "Spătărei",
                        "latitude": "43.88848000",
                        "longitude": "25.13650000"
                    },
                    {
                        "id": 96428,
                        "name": "Stejaru",
                        "latitude": "44.18333000",
                        "longitude": "24.88333000"
                    },
                    {
                        "id": 96446,
                        "name": "Storobăneasa",
                        "latitude": "43.88333000",
                        "longitude": "25.45000000"
                    },
                    {
                        "id": 96495,
                        "name": "Suhaia",
                        "latitude": "43.73333000",
                        "longitude": "25.25000000"
                    },
                    {
                        "id": 106052,
                        "name": "Talpa-Ogrăzile",
                        "latitude": "44.28726000",
                        "longitude": "25.29328000"
                    },
                    {
                        "id": 106053,
                        "name": "Talpa-Trivalea",
                        "latitude": "44.28333000",
                        "longitude": "25.28333000"
                    },
                    {
                        "id": 96594,
                        "name": "Târnava",
                        "latitude": "44.14440000",
                        "longitude": "25.56347000"
                    },
                    {
                        "id": 96623,
                        "name": "Tătărăștii de Jos",
                        "latitude": "44.37501000",
                        "longitude": "25.17721000"
                    },
                    {
                        "id": 96624,
                        "name": "Tătărăștii de Sus",
                        "latitude": "44.40768000",
                        "longitude": "25.12192000"
                    },
                    {
                        "id": 106070,
                        "name": "Tecuci",
                        "latitude": "44.34179000",
                        "longitude": "24.85966000"
                    },
                    {
                        "id": 106079,
                        "name": "Teleormanu",
                        "latitude": "43.96271000",
                        "longitude": "25.45876000"
                    },
                    {
                        "id": 97107,
                        "name": "Ţigăneşti",
                        "latitude": "43.90000000",
                        "longitude": "25.36667000"
                    },
                    {
                        "id": 106148,
                        "name": "Traian",
                        "latitude": "43.76667000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 106160,
                        "name": "Trivalea-Moşteni",
                        "latitude": "44.26667000",
                        "longitude": "25.23333000"
                    },
                    {
                        "id": 106161,
                        "name": "Troianul",
                        "latitude": "44.00000000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 106167,
                        "name": "Tudor Vladimirescu",
                        "latitude": "43.94761000",
                        "longitude": "24.90616000"
                    },
                    {
                        "id": 96565,
                        "name": "Turnu Măgurele",
                        "latitude": "43.74690000",
                        "longitude": "24.86846000"
                    },
                    {
                        "id": 96636,
                        "name": "Uda-Clocociov",
                        "latitude": "43.88791000",
                        "longitude": "24.71437000"
                    },
                    {
                        "id": 96637,
                        "name": "Uda-Paciurea",
                        "latitude": "43.87979000",
                        "longitude": "24.72379000"
                    },
                    {
                        "id": 96639,
                        "name": "Udupu",
                        "latitude": "44.39657000",
                        "longitude": "25.14488000"
                    },
                    {
                        "id": 96716,
                        "name": "Valea Cireșului",
                        "latitude": "44.16699000",
                        "longitude": "25.56437000"
                    },
                    {
                        "id": 96746,
                        "name": "Valea Părului",
                        "latitude": "43.91727000",
                        "longitude": "25.46589000"
                    },
                    {
                        "id": 96945,
                        "name": "Vârtoapele de Jos",
                        "latitude": "44.18333000",
                        "longitude": "25.20000000"
                    },
                    {
                        "id": 96946,
                        "name": "Vârtoapele de Sus",
                        "latitude": "44.19182000",
                        "longitude": "25.20025000"
                    },
                    {
                        "id": 96781,
                        "name": "Vedea",
                        "latitude": "44.08333000",
                        "longitude": "25.06667000"
                    },
                    {
                        "id": 96807,
                        "name": "Videle",
                        "latitude": "44.27806000",
                        "longitude": "25.52444000"
                    },
                    {
                        "id": 96822,
                        "name": "Viişoara",
                        "latitude": "43.78333000",
                        "longitude": "25.16667000"
                    },
                    {
                        "id": 96841,
                        "name": "Vităneşti",
                        "latitude": "44.00000000",
                        "longitude": "25.41667000"
                    },
                    {
                        "id": 97007,
                        "name": "Zâmbreasca",
                        "latitude": "44.31667000",
                        "longitude": "24.98333000"
                    },
                    {
                        "id": 96995,
                        "name": "Zimnicea",
                        "latitude": "43.65638000",
                        "longitude": "25.36454000"
                    },
                    {
                        "id": 96996,
                        "name": "Zimnicele",
                        "latitude": "43.66126000",
                        "longitude": "25.41291000"
                    }
                ]
            },
            {
                "id": 4748,
                "name": "Timiș",
                "iso2": "TM",
                "latitude": "45.81389020",
                "longitude": "21.33310550",
                "type": "department",
                "cities": [
                    {
                        "id": 90024,
                        "name": "Bacova",
                        "latitude": "45.66410000",
                        "longitude": "21.55238000"
                    },
                    {
                        "id": 90044,
                        "name": "Balinţ",
                        "latitude": "45.81250000",
                        "longitude": "21.85361000"
                    },
                    {
                        "id": 90055,
                        "name": "Banloc",
                        "latitude": "45.38742000",
                        "longitude": "21.13581000"
                    },
                    {
                        "id": 90056,
                        "name": "Bara",
                        "latitude": "45.89472000",
                        "longitude": "21.87194000"
                    },
                    {
                        "id": 90452,
                        "name": "Bârna",
                        "latitude": "45.71667000",
                        "longitude": "22.05000000"
                    },
                    {
                        "id": 90074,
                        "name": "Beba Veche",
                        "latitude": "46.13333000",
                        "longitude": "20.31667000"
                    },
                    {
                        "id": 90077,
                        "name": "Becicherecu Mic",
                        "latitude": "45.82917000",
                        "longitude": "21.05139000"
                    },
                    {
                        "id": 90089,
                        "name": "Belinţ",
                        "latitude": "45.75500000",
                        "longitude": "21.76028000"
                    },
                    {
                        "id": 90101,
                        "name": "Beregsău Mare",
                        "latitude": "45.75921000",
                        "longitude": "21.02666000"
                    },
                    {
                        "id": 90120,
                        "name": "Bethausen",
                        "latitude": "45.83306000",
                        "longitude": "21.95278000"
                    },
                    {
                        "id": 90137,
                        "name": "Biled",
                        "latitude": "45.88639000",
                        "longitude": "20.95889000"
                    },
                    {
                        "id": 90141,
                        "name": "Birda",
                        "latitude": "45.42996000",
                        "longitude": "21.34359000"
                    },
                    {
                        "id": 90186,
                        "name": "Bogda",
                        "latitude": "45.97833000",
                        "longitude": "21.57250000"
                    },
                    {
                        "id": 90212,
                        "name": "Boldur",
                        "latitude": "45.69417000",
                        "longitude": "21.77667000"
                    },
                    {
                        "id": 90297,
                        "name": "Brestovăț",
                        "latitude": "45.87342000",
                        "longitude": "21.68201000"
                    },
                    {
                        "id": 90361,
                        "name": "Bucovăț",
                        "latitude": "45.75569000",
                        "longitude": "21.38324000"
                    },
                    {
                        "id": 90402,
                        "name": "Bulgăruș",
                        "latitude": "45.91947000",
                        "longitude": "20.82219000"
                    },
                    {
                        "id": 90432,
                        "name": "Buziaş",
                        "latitude": "45.64917000",
                        "longitude": "21.60361000"
                    },
                    {
                        "id": 90574,
                        "name": "Carani",
                        "latitude": "45.91095000",
                        "longitude": "21.15686000"
                    },
                    {
                        "id": 93870,
                        "name": "Cărpiniş",
                        "latitude": "45.78722000",
                        "longitude": "20.90417000"
                    },
                    {
                        "id": 90613,
                        "name": "Cenad",
                        "latitude": "46.13333000",
                        "longitude": "20.58333000"
                    },
                    {
                        "id": 90615,
                        "name": "Cenei",
                        "latitude": "45.71583000",
                        "longitude": "20.90389000"
                    },
                    {
                        "id": 90652,
                        "name": "Checea",
                        "latitude": "45.75298000",
                        "longitude": "20.83596000"
                    },
                    {
                        "id": 90659,
                        "name": "Chevereşu Mare",
                        "latitude": "45.66694000",
                        "longitude": "21.49083000"
                    },
                    {
                        "id": 90690,
                        "name": "Chișoda",
                        "latitude": "45.70380000",
                        "longitude": "21.21437000"
                    },
                    {
                        "id": 90693,
                        "name": "Ciacova",
                        "latitude": "45.50806000",
                        "longitude": "21.12861000"
                    },
                    {
                        "id": 90800,
                        "name": "Colonia Fabricii",
                        "latitude": "45.76620000",
                        "longitude": "22.31463000"
                    },
                    {
                        "id": 90814,
                        "name": "Comloşu Mare",
                        "latitude": "45.89056000",
                        "longitude": "20.62722000"
                    },
                    {
                        "id": 90926,
                        "name": "Comuna Balinţ",
                        "latitude": "45.82290000",
                        "longitude": "21.85841000"
                    },
                    {
                        "id": 90934,
                        "name": "Comuna Banloc",
                        "latitude": "45.38603000",
                        "longitude": "21.13203000"
                    },
                    {
                        "id": 90935,
                        "name": "Comuna Bara",
                        "latitude": "45.91096000",
                        "longitude": "21.90440000"
                    },
                    {
                        "id": 91189,
                        "name": "Comuna Bârna",
                        "latitude": "45.71642000",
                        "longitude": "22.06530000"
                    },
                    {
                        "id": 90943,
                        "name": "Comuna Beba Veche",
                        "latitude": "46.13503000",
                        "longitude": "20.36289000"
                    },
                    {
                        "id": 90945,
                        "name": "Comuna Becicherecu Mic",
                        "latitude": "45.83475000",
                        "longitude": "21.05195000"
                    },
                    {
                        "id": 90953,
                        "name": "Comuna Belinţ",
                        "latitude": "45.77023000",
                        "longitude": "21.77550000"
                    },
                    {
                        "id": 90978,
                        "name": "Comuna Bethausen",
                        "latitude": "45.82505000",
                        "longitude": "21.96054000"
                    },
                    {
                        "id": 90990,
                        "name": "Comuna Biled",
                        "latitude": "45.88760000",
                        "longitude": "20.96214000"
                    },
                    {
                        "id": 90993,
                        "name": "Comuna Birda",
                        "latitude": "45.41265000",
                        "longitude": "21.33733000"
                    },
                    {
                        "id": 91021,
                        "name": "Comuna Bogda",
                        "latitude": "45.97025000",
                        "longitude": "21.56964000"
                    },
                    {
                        "id": 91040,
                        "name": "Comuna Boldur",
                        "latitude": "45.70016000",
                        "longitude": "21.76225000"
                    },
                    {
                        "id": 91095,
                        "name": "Comuna Brestovăţ",
                        "latitude": "45.87818000",
                        "longitude": "21.67986000"
                    },
                    {
                        "id": 91135,
                        "name": "Comuna Bucovăţ",
                        "latitude": "45.75309000",
                        "longitude": "21.40277000"
                    },
                    {
                        "id": 91590,
                        "name": "Comuna Cărpiniş",
                        "latitude": "45.80603000",
                        "longitude": "20.91452000"
                    },
                    {
                        "id": 91280,
                        "name": "Comuna Cenad",
                        "latitude": "46.13371000",
                        "longitude": "20.58001000"
                    },
                    {
                        "id": 91282,
                        "name": "Comuna Cenei",
                        "latitude": "45.72608000",
                        "longitude": "20.92561000"
                    },
                    {
                        "id": 91308,
                        "name": "Comuna Checea",
                        "latitude": "45.75298000",
                        "longitude": "20.83596000"
                    },
                    {
                        "id": 91310,
                        "name": "Comuna Chevereşu Mare",
                        "latitude": "45.66230000",
                        "longitude": "21.47888000"
                    },
                    {
                        "id": 91409,
                        "name": "Comuna Comloşu Mare",
                        "latitude": "45.87549000",
                        "longitude": "20.62938000"
                    },
                    {
                        "id": 91478,
                        "name": "Comuna Coşteiu",
                        "latitude": "45.75242000",
                        "longitude": "21.88756000"
                    },
                    {
                        "id": 91494,
                        "name": "Comuna Criciova",
                        "latitude": "45.64454000",
                        "longitude": "22.06260000"
                    },
                    {
                        "id": 91528,
                        "name": "Comuna Curtea",
                        "latitude": "45.84453000",
                        "longitude": "22.32658000"
                    },
                    {
                        "id": 91604,
                        "name": "Comuna Darova",
                        "latitude": "45.63081000",
                        "longitude": "21.76709000"
                    },
                    {
                        "id": 91614,
                        "name": "Comuna Denta",
                        "latitude": "45.35950000",
                        "longitude": "21.28331000"
                    },
                    {
                        "id": 91707,
                        "name": "Comuna Dudeştii Noi",
                        "latitude": "45.83989000",
                        "longitude": "21.10215000"
                    },
                    {
                        "id": 91708,
                        "name": "Comuna Dudeştii Vechi",
                        "latitude": "46.08562000",
                        "longitude": "20.44521000"
                    },
                    {
                        "id": 91710,
                        "name": "Comuna Dumbrava",
                        "latitude": "45.81746000",
                        "longitude": "22.12550000"
                    },
                    {
                        "id": 91717,
                        "name": "Comuna Dumbrăviţa",
                        "latitude": "45.80011000",
                        "longitude": "21.24648000"
                    },
                    {
                        "id": 91811,
                        "name": "Comuna Fârdea",
                        "latitude": "45.74895000",
                        "longitude": "22.19779000"
                    },
                    {
                        "id": 91760,
                        "name": "Comuna Fibiş",
                        "latitude": "45.97280000",
                        "longitude": "21.42355000"
                    },
                    {
                        "id": 91775,
                        "name": "Comuna Foeni",
                        "latitude": "45.48613000",
                        "longitude": "20.87810000"
                    },
                    {
                        "id": 91834,
                        "name": "Comuna Gavojdia",
                        "latitude": "45.61284000",
                        "longitude": "22.02471000"
                    },
                    {
                        "id": 91854,
                        "name": "Comuna Ghilad",
                        "latitude": "45.46633000",
                        "longitude": "21.06467000"
                    },
                    {
                        "id": 91863,
                        "name": "Comuna Ghiroda",
                        "latitude": "45.78494000",
                        "longitude": "21.30245000"
                    },
                    {
                        "id": 91864,
                        "name": "Comuna Ghizela",
                        "latitude": "45.82641000",
                        "longitude": "21.75048000"
                    },
                    {
                        "id": 91865,
                        "name": "Comuna Giarmata",
                        "latitude": "45.84218000",
                        "longitude": "21.28918000"
                    },
                    {
                        "id": 91866,
                        "name": "Comuna Giera",
                        "latitude": "45.42060000",
                        "longitude": "20.94696000"
                    },
                    {
                        "id": 91871,
                        "name": "Comuna Giroc",
                        "latitude": "45.70020000",
                        "longitude": "21.22641000"
                    },
                    {
                        "id": 91875,
                        "name": "Comuna Giulvăz",
                        "latitude": "45.52522000",
                        "longitude": "20.98501000"
                    },
                    {
                        "id": 91908,
                        "name": "Comuna Gottlob",
                        "latitude": "45.93916000",
                        "longitude": "20.68384000"
                    },
                    {
                        "id": 92062,
                        "name": "Comuna Iecea Mare",
                        "latitude": "45.85074000",
                        "longitude": "20.89310000"
                    },
                    {
                        "id": 92114,
                        "name": "Comuna Jamu Mare",
                        "latitude": "45.26768000",
                        "longitude": "21.44318000"
                    },
                    {
                        "id": 92116,
                        "name": "Comuna Jebel",
                        "latitude": "45.56020000",
                        "longitude": "21.21805000"
                    },
                    {
                        "id": 92150,
                        "name": "Comuna Lenauheim",
                        "latitude": "45.89042000",
                        "longitude": "20.78901000"
                    },
                    {
                        "id": 92163,
                        "name": "Comuna Liebling",
                        "latitude": "45.57121000",
                        "longitude": "21.33526000"
                    },
                    {
                        "id": 92178,
                        "name": "Comuna Livezile",
                        "latitude": "45.40994000",
                        "longitude": "21.06179000"
                    },
                    {
                        "id": 92185,
                        "name": "Comuna Lovrin",
                        "latitude": "45.96943000",
                        "longitude": "20.76953000"
                    },
                    {
                        "id": 92404,
                        "name": "Comuna Mănăştiur",
                        "latitude": "45.86808000",
                        "longitude": "22.05329000"
                    },
                    {
                        "id": 92242,
                        "name": "Comuna Margina",
                        "latitude": "45.86159000",
                        "longitude": "22.27233000"
                    },
                    {
                        "id": 92249,
                        "name": "Comuna Maşloc",
                        "latitude": "45.99637000",
                        "longitude": "21.45484000"
                    },
                    {
                        "id": 92331,
                        "name": "Comuna Moraviţa",
                        "latitude": "45.28025000",
                        "longitude": "21.25570000"
                    },
                    {
                        "id": 92348,
                        "name": "Comuna Moşniţa Nouã",
                        "latitude": "45.71397000",
                        "longitude": "21.32403000"
                    },
                    {
                        "id": 92460,
                        "name": "Comuna Nădrag",
                        "latitude": "45.65064000",
                        "longitude": "22.15383000"
                    },
                    {
                        "id": 92450,
                        "name": "Comuna Niţchidorf",
                        "latitude": "45.57379000",
                        "longitude": "21.52266000"
                    },
                    {
                        "id": 92488,
                        "name": "Comuna Ohaba Lungă",
                        "latitude": "45.91812000",
                        "longitude": "21.99094000"
                    },
                    {
                        "id": 92514,
                        "name": "Comuna Orţişoara",
                        "latitude": "45.95206000",
                        "longitude": "21.22370000"
                    },
                    {
                        "id": 92521,
                        "name": "Comuna Otelec",
                        "latitude": "45.59079000",
                        "longitude": "20.85648000"
                    },
                    {
                        "id": 92715,
                        "name": "Comuna Pădureni",
                        "latitude": "45.60039000",
                        "longitude": "21.21773000"
                    },
                    {
                        "id": 92541,
                        "name": "Comuna Parţa",
                        "latitude": "45.62888000",
                        "longitude": "21.13877000"
                    },
                    {
                        "id": 92545,
                        "name": "Comuna Peciu Nou",
                        "latitude": "45.62070000",
                        "longitude": "21.00816000"
                    },
                    {
                        "id": 92548,
                        "name": "Comuna Periam",
                        "latitude": "46.04394000",
                        "longitude": "20.87517000"
                    },
                    {
                        "id": 92558,
                        "name": "Comuna Pesac",
                        "latitude": "45.99590000",
                        "longitude": "20.83522000"
                    },
                    {
                        "id": 92579,
                        "name": "Comuna Pietroasa",
                        "latitude": "45.82012000",
                        "longitude": "22.41805000"
                    },
                    {
                        "id": 92589,
                        "name": "Comuna Pişchia",
                        "latitude": "45.90460000",
                        "longitude": "21.40241000"
                    },
                    {
                        "id": 92734,
                        "name": "Comuna Racoviţa",
                        "latitude": "45.70441000",
                        "longitude": "21.63935000"
                    },
                    {
                        "id": 92766,
                        "name": "Comuna Remetea Mare",
                        "latitude": "45.81036000",
                        "longitude": "21.39893000"
                    },
                    {
                        "id": 93086,
                        "name": "Comuna Săcălaz",
                        "latitude": "45.75681000",
                        "longitude": "21.03903000"
                    },
                    {
                        "id": 92856,
                        "name": "Comuna Sacoşu Turcesc",
                        "latitude": "45.63526000",
                        "longitude": "21.39828000"
                    },
                    {
                        "id": 93495,
                        "name": "Comuna Şag",
                        "latitude": "45.65184000",
                        "longitude": "21.16933000"
                    },
                    {
                        "id": 93048,
                        "name": "Comuna Sânandrei",
                        "latitude": "45.86677000",
                        "longitude": "21.18623000"
                    },
                    {
                        "id": 93498,
                        "name": "Comuna Şandra",
                        "latitude": "45.91878000",
                        "longitude": "20.87801000"
                    },
                    {
                        "id": 93058,
                        "name": "Comuna Sânmihaiu Român",
                        "latitude": "45.71002000",
                        "longitude": "21.08352000"
                    },
                    {
                        "id": 93064,
                        "name": "Comuna Sânpetru Mare",
                        "latitude": "46.07994000",
                        "longitude": "20.80148000"
                    },
                    {
                        "id": 92874,
                        "name": "Comuna Saravale",
                        "latitude": "46.06929000",
                        "longitude": "20.74085000"
                    },
                    {
                        "id": 92879,
                        "name": "Comuna Satchinez",
                        "latitude": "45.93933000",
                        "longitude": "21.07597000"
                    },
                    {
                        "id": 92911,
                        "name": "Comuna Secaş",
                        "latitude": "45.90501000",
                        "longitude": "21.80832000"
                    },
                    {
                        "id": 93557,
                        "name": "Comuna Ştiuca",
                        "latitude": "45.56283000",
                        "longitude": "21.97988000"
                    },
                    {
                        "id": 93142,
                        "name": "Comuna Teremia Mare",
                        "latitude": "45.95401000",
                        "longitude": "20.52908000"
                    },
                    {
                        "id": 93169,
                        "name": "Comuna Tomeşti",
                        "latitude": "45.76670000",
                        "longitude": "22.30974000"
                    },
                    {
                        "id": 93170,
                        "name": "Comuna Tomnatic",
                        "latitude": "45.98857000",
                        "longitude": "20.66186000"
                    },
                    {
                        "id": 93179,
                        "name": "Comuna Topolovãţu Mare",
                        "latitude": "45.78363000",
                        "longitude": "21.63784000"
                    },
                    {
                        "id": 93182,
                        "name": "Comuna Tormac",
                        "latitude": "45.52140000",
                        "longitude": "21.47648000"
                    },
                    {
                        "id": 93190,
                        "name": "Comuna Traian Vuia",
                        "latitude": "45.78754000",
                        "longitude": "22.04595000"
                    },
                    {
                        "id": 93256,
                        "name": "Comuna Uivar",
                        "latitude": "45.65085000",
                        "longitude": "20.90281000"
                    },
                    {
                        "id": 93457,
                        "name": "Comuna Vălcani",
                        "latitude": "46.00357000",
                        "longitude": "20.39865000"
                    },
                    {
                        "id": 93334,
                        "name": "Comuna Variaş",
                        "latitude": "46.01491000",
                        "longitude": "21.01965000"
                    },
                    {
                        "id": 93351,
                        "name": "Comuna Victor Vlad Delamarina",
                        "latitude": "45.61227000",
                        "longitude": "21.87572000"
                    },
                    {
                        "id": 93401,
                        "name": "Comuna Voiteg",
                        "latitude": "45.48472000",
                        "longitude": "21.26977000"
                    },
                    {
                        "id": 93693,
                        "name": "Coşteiu",
                        "latitude": "45.74111000",
                        "longitude": "21.84917000"
                    },
                    {
                        "id": 93716,
                        "name": "Criciova",
                        "latitude": "45.63333000",
                        "longitude": "22.06667000"
                    },
                    {
                        "id": 93773,
                        "name": "Curtea",
                        "latitude": "45.81667000",
                        "longitude": "22.30000000"
                    },
                    {
                        "id": 93895,
                        "name": "Darova",
                        "latitude": "45.64200000",
                        "longitude": "21.77333000"
                    },
                    {
                        "id": 93896,
                        "name": "Darova Nouă",
                        "latitude": "45.63333000",
                        "longitude": "21.76667000"
                    },
                    {
                        "id": 93920,
                        "name": "Denta",
                        "latitude": "45.35389000",
                        "longitude": "21.24917000"
                    },
                    {
                        "id": 93927,
                        "name": "Deta",
                        "latitude": "45.38889000",
                        "longitude": "21.22444000"
                    },
                    {
                        "id": 94071,
                        "name": "Dudeștii Noi",
                        "latitude": "45.83989000",
                        "longitude": "21.10215000"
                    },
                    {
                        "id": 94070,
                        "name": "Dudeştii Vechi",
                        "latitude": "46.05000000",
                        "longitude": "20.48333000"
                    },
                    {
                        "id": 94075,
                        "name": "Dumbrava",
                        "latitude": "45.81667000",
                        "longitude": "22.11667000"
                    },
                    {
                        "id": 94090,
                        "name": "Dumbrăviţa",
                        "latitude": "45.79694000",
                        "longitude": "21.24250000"
                    },
                    {
                        "id": 94251,
                        "name": "Făget",
                        "latitude": "45.85000000",
                        "longitude": "22.18333000"
                    },
                    {
                        "id": 94244,
                        "name": "Fârdea",
                        "latitude": "45.73333000",
                        "longitude": "22.16667000"
                    },
                    {
                        "id": 94163,
                        "name": "Fibiș",
                        "latitude": "45.97280000",
                        "longitude": "21.42355000"
                    },
                    {
                        "id": 94194,
                        "name": "Foeni",
                        "latitude": "45.49861000",
                        "longitude": "20.87583000"
                    },
                    {
                        "id": 94513,
                        "name": "Gătaia",
                        "latitude": "45.43111000",
                        "longitude": "21.43000000"
                    },
                    {
                        "id": 94284,
                        "name": "Gavojdia",
                        "latitude": "45.61667000",
                        "longitude": "22.01667000"
                    },
                    {
                        "id": 94287,
                        "name": "Gelu",
                        "latitude": "46.00591000",
                        "longitude": "21.06002000"
                    },
                    {
                        "id": 94320,
                        "name": "Ghilad",
                        "latitude": "45.46501000",
                        "longitude": "21.13824000"
                    },
                    {
                        "id": 94337,
                        "name": "Ghiroda",
                        "latitude": "45.76389000",
                        "longitude": "21.30028000"
                    },
                    {
                        "id": 94339,
                        "name": "Ghizela",
                        "latitude": "45.82417000",
                        "longitude": "21.73722000"
                    },
                    {
                        "id": 94340,
                        "name": "Giarmata",
                        "latitude": "45.83833000",
                        "longitude": "21.31083000"
                    },
                    {
                        "id": 94341,
                        "name": "Giarmata-Vii",
                        "latitude": "45.79960000",
                        "longitude": "21.30026000"
                    },
                    {
                        "id": 94342,
                        "name": "Giera",
                        "latitude": "45.40722000",
                        "longitude": "20.99222000"
                    },
                    {
                        "id": 94347,
                        "name": "Giroc",
                        "latitude": "45.69417000",
                        "longitude": "21.23583000"
                    },
                    {
                        "id": 94351,
                        "name": "Giulvăz",
                        "latitude": "45.54889000",
                        "longitude": "20.98444000"
                    },
                    {
                        "id": 94395,
                        "name": "Gottlob",
                        "latitude": "45.93600000",
                        "longitude": "20.71168000"
                    },
                    {
                        "id": 94398,
                        "name": "Grabăț",
                        "latitude": "45.87861000",
                        "longitude": "20.74238000"
                    },
                    {
                        "id": 94543,
                        "name": "Hodoni",
                        "latitude": "45.90646000",
                        "longitude": "21.08851000"
                    },
                    {
                        "id": 94639,
                        "name": "Iecea Mare",
                        "latitude": "45.85074000",
                        "longitude": "20.89310000"
                    },
                    {
                        "id": 94640,
                        "name": "Iecea Mică",
                        "latitude": "45.82147000",
                        "longitude": "20.92322000"
                    },
                    {
                        "id": 94652,
                        "name": "Igriș",
                        "latitude": "46.11313000",
                        "longitude": "20.78496000"
                    },
                    {
                        "id": 94701,
                        "name": "Izvin",
                        "latitude": "45.80034000",
                        "longitude": "21.46066000"
                    },
                    {
                        "id": 94722,
                        "name": "Jamu Mare",
                        "latitude": "45.25417000",
                        "longitude": "21.41694000"
                    },
                    {
                        "id": 94724,
                        "name": "Jebel",
                        "latitude": "45.55556000",
                        "longitude": "21.21361000"
                    },
                    {
                        "id": 94738,
                        "name": "Jimbolia",
                        "latitude": "45.79139000",
                        "longitude": "20.71722000"
                    },
                    {
                        "id": 94777,
                        "name": "Lenauheim",
                        "latitude": "45.87194000",
                        "longitude": "20.79944000"
                    },
                    {
                        "id": 94794,
                        "name": "Liebling",
                        "latitude": "45.57750000",
                        "longitude": "21.32167000"
                    },
                    {
                        "id": 94824,
                        "name": "Livezile",
                        "latitude": "45.39026000",
                        "longitude": "21.05794000"
                    },
                    {
                        "id": 94834,
                        "name": "Lovrin",
                        "latitude": "45.96806000",
                        "longitude": "20.77028000"
                    },
                    {
                        "id": 94846,
                        "name": "Lugoj",
                        "latitude": "45.68861000",
                        "longitude": "21.90306000"
                    },
                    {
                        "id": 95263,
                        "name": "Mănăştiur",
                        "latitude": "45.81667000",
                        "longitude": "22.06667000"
                    },
                    {
                        "id": 94929,
                        "name": "Margina",
                        "latitude": "45.85841000",
                        "longitude": "22.26654000"
                    },
                    {
                        "id": 94941,
                        "name": "Maşloc",
                        "latitude": "45.99806000",
                        "longitude": "21.44972000"
                    },
                    {
                        "id": 95070,
                        "name": "Moraviţa",
                        "latitude": "45.25583000",
                        "longitude": "21.27028000"
                    },
                    {
                        "id": 95090,
                        "name": "Moşniţa Nouă",
                        "latitude": "45.71722000",
                        "longitude": "21.32528000"
                    },
                    {
                        "id": 95095,
                        "name": "Moșnița Veche",
                        "latitude": "45.73549000",
                        "longitude": "21.33396000"
                    },
                    {
                        "id": 95151,
                        "name": "Municipiul Lugoj",
                        "latitude": "45.67678000",
                        "longitude": "21.95988000"
                    },
                    {
                        "id": 95187,
                        "name": "Municipiul Timişoara",
                        "latitude": "45.75641000",
                        "longitude": "21.22974000"
                    },
                    {
                        "id": 95368,
                        "name": "Nădrag",
                        "latitude": "45.65000000",
                        "longitude": "22.18333000"
                    },
                    {
                        "id": 95331,
                        "name": "Nerău",
                        "latitude": "45.96929000",
                        "longitude": "20.56070000"
                    },
                    {
                        "id": 95352,
                        "name": "Niţchidorf",
                        "latitude": "45.58333000",
                        "longitude": "21.53333000"
                    },
                    {
                        "id": 95418,
                        "name": "Ohaba Lungă",
                        "latitude": "45.90740000",
                        "longitude": "21.98535000"
                    },
                    {
                        "id": 95478,
                        "name": "Oraş Buziaş",
                        "latitude": "45.64035000",
                        "longitude": "21.58934000"
                    },
                    {
                        "id": 95493,
                        "name": "Oraş Ciacova",
                        "latitude": "45.53242000",
                        "longitude": "21.10558000"
                    },
                    {
                        "id": 95508,
                        "name": "Oraş Deta",
                        "latitude": "45.40518000",
                        "longitude": "21.24829000"
                    },
                    {
                        "id": 95521,
                        "name": "Oraş Fãget",
                        "latitude": "45.85770000",
                        "longitude": "22.17610000"
                    },
                    {
                        "id": 95527,
                        "name": "Oraş Gãtaia",
                        "latitude": "45.37402000",
                        "longitude": "21.40796000"
                    },
                    {
                        "id": 95536,
                        "name": "Oraş Jimbolia",
                        "latitude": "45.79226000",
                        "longitude": "20.71997000"
                    },
                    {
                        "id": 95577,
                        "name": "Oraş Recaş",
                        "latitude": "45.82646000",
                        "longitude": "21.52629000"
                    },
                    {
                        "id": 95596,
                        "name": "Oraş Sânnicolau Mare",
                        "latitude": "46.07292000",
                        "longitude": "20.62281000"
                    },
                    {
                        "id": 95670,
                        "name": "Orţişoara",
                        "latitude": "45.96361000",
                        "longitude": "21.19833000"
                    },
                    {
                        "id": 95681,
                        "name": "Otelec",
                        "latitude": "45.61478000",
                        "longitude": "20.84952000"
                    },
                    {
                        "id": 96008,
                        "name": "Pădureni",
                        "latitude": "45.60039000",
                        "longitude": "21.21773000"
                    },
                    {
                        "id": 95716,
                        "name": "Parța",
                        "latitude": "45.62888000",
                        "longitude": "21.13877000"
                    },
                    {
                        "id": 95724,
                        "name": "Peciu Nou",
                        "latitude": "45.60639000",
                        "longitude": "21.05778000"
                    },
                    {
                        "id": 95728,
                        "name": "Periam",
                        "latitude": "46.05000000",
                        "longitude": "20.86667000"
                    },
                    {
                        "id": 95743,
                        "name": "Pesac",
                        "latitude": "45.99590000",
                        "longitude": "20.83522000"
                    },
                    {
                        "id": 95783,
                        "name": "Pietroasa",
                        "latitude": "45.83333000",
                        "longitude": "22.40000000"
                    },
                    {
                        "id": 95804,
                        "name": "Pişchia",
                        "latitude": "45.90306000",
                        "longitude": "21.33722000"
                    },
                    {
                        "id": 96184,
                        "name": "Răchita",
                        "latitude": "45.83827000",
                        "longitude": "22.10615000"
                    },
                    {
                        "id": 96043,
                        "name": "Racoviţa",
                        "latitude": "45.69833000",
                        "longitude": "21.63583000"
                    },
                    {
                        "id": 96067,
                        "name": "Recaş",
                        "latitude": "45.79889000",
                        "longitude": "21.50083000"
                    },
                    {
                        "id": 96084,
                        "name": "Remetea Mare",
                        "latitude": "45.77944000",
                        "longitude": "21.37611000"
                    },
                    {
                        "id": 106000,
                        "name": "Săcălaz",
                        "latitude": "45.75833000",
                        "longitude": "21.11222000"
                    },
                    {
                        "id": 96221,
                        "name": "Sacoșu Mare",
                        "latitude": "45.58503000",
                        "longitude": "21.72958000"
                    },
                    {
                        "id": 96220,
                        "name": "Sacoşu Turcesc",
                        "latitude": "45.65194000",
                        "longitude": "21.42889000"
                    },
                    {
                        "id": 97027,
                        "name": "Şag",
                        "latitude": "45.64861000",
                        "longitude": "21.17556000"
                    },
                    {
                        "id": 96522,
                        "name": "Sânandrei",
                        "latitude": "45.85306000",
                        "longitude": "21.16806000"
                    },
                    {
                        "id": 97030,
                        "name": "Şandra",
                        "latitude": "45.92500000",
                        "longitude": "20.89028000"
                    },
                    {
                        "id": 96535,
                        "name": "Sânmihaiu Român",
                        "latitude": "45.70444000",
                        "longitude": "21.08889000"
                    },
                    {
                        "id": 96540,
                        "name": "Sânnicolau Mare",
                        "latitude": "46.08333000",
                        "longitude": "20.63333000"
                    },
                    {
                        "id": 96545,
                        "name": "Sânpetru Mare",
                        "latitude": "46.04515000",
                        "longitude": "20.81834000"
                    },
                    {
                        "id": 96245,
                        "name": "Saravale",
                        "latitude": "46.06929000",
                        "longitude": "20.74085000"
                    },
                    {
                        "id": 96252,
                        "name": "Satchinez",
                        "latitude": "45.93750000",
                        "longitude": "21.04056000"
                    },
                    {
                        "id": 96285,
                        "name": "Sculia",
                        "latitude": "45.44429000",
                        "longitude": "21.43225000"
                    },
                    {
                        "id": 96305,
                        "name": "Secaş",
                        "latitude": "45.88500000",
                        "longitude": "21.81917000"
                    },
                    {
                        "id": 97089,
                        "name": "Ştiuca",
                        "latitude": "45.57139000",
                        "longitude": "21.97667000"
                    },
                    {
                        "id": 106085,
                        "name": "Teremia Mare",
                        "latitude": "45.93528000",
                        "longitude": "20.52500000"
                    },
                    {
                        "id": 106102,
                        "name": "Timişoara",
                        "latitude": "45.75372000",
                        "longitude": "21.22571000"
                    },
                    {
                        "id": 106120,
                        "name": "Tomeşti",
                        "latitude": "45.78333000",
                        "longitude": "22.30000000"
                    },
                    {
                        "id": 106124,
                        "name": "Tomnatic",
                        "latitude": "45.98857000",
                        "longitude": "20.66186000"
                    },
                    {
                        "id": 106137,
                        "name": "Topolovăţu Mare",
                        "latitude": "45.77389000",
                        "longitude": "21.61889000"
                    },
                    {
                        "id": 106140,
                        "name": "Tormac",
                        "latitude": "45.52083000",
                        "longitude": "21.49361000"
                    },
                    {
                        "id": 106151,
                        "name": "Traian Vuia",
                        "latitude": "45.80000000",
                        "longitude": "22.06667000"
                    },
                    {
                        "id": 96642,
                        "name": "Uivar",
                        "latitude": "45.65806000",
                        "longitude": "20.90583000"
                    },
                    {
                        "id": 96684,
                        "name": "Urseni",
                        "latitude": "45.69269000",
                        "longitude": "21.30993000"
                    },
                    {
                        "id": 96692,
                        "name": "Utvin",
                        "latitude": "45.71298000",
                        "longitude": "21.13011000"
                    },
                    {
                        "id": 96958,
                        "name": "Vălcani",
                        "latitude": "46.00357000",
                        "longitude": "20.39865000"
                    },
                    {
                        "id": 96773,
                        "name": "Variaş",
                        "latitude": "46.01667000",
                        "longitude": "20.95000000"
                    },
                    {
                        "id": 96802,
                        "name": "Victor Vlad Delamarina",
                        "latitude": "45.64056000",
                        "longitude": "21.89278000"
                    },
                    {
                        "id": 96883,
                        "name": "Voiteg",
                        "latitude": "45.46889000",
                        "longitude": "21.23917000"
                    }
                ]
            },
            {
                "id": 4727,
                "name": "Tulcea",
                "iso2": "TL",
                "latitude": "45.04505650",
                "longitude": "29.03249120",
                "type": "department",
                "cities": [
                    {
                        "id": 89897,
                        "name": "Agighiol",
                        "latitude": "45.03362000",
                        "longitude": "28.87628000"
                    },
                    {
                        "id": 90018,
                        "name": "Babadag",
                        "latitude": "44.90000000",
                        "longitude": "28.71667000"
                    },
                    {
                        "id": 90027,
                        "name": "Baia",
                        "latitude": "44.71667000",
                        "longitude": "28.66667000"
                    },
                    {
                        "id": 90081,
                        "name": "Beidaud",
                        "latitude": "44.71667000",
                        "longitude": "28.56667000"
                    },
                    {
                        "id": 90124,
                        "name": "Beștepe",
                        "latitude": "45.09241000",
                        "longitude": "29.01478000"
                    },
                    {
                        "id": 90557,
                        "name": "C.A. Rosetti",
                        "latitude": "45.30000000",
                        "longitude": "29.56667000"
                    },
                    {
                        "id": 90579,
                        "name": "Carcaliu",
                        "latitude": "45.18333000",
                        "longitude": "28.15000000"
                    },
                    {
                        "id": 90583,
                        "name": "Casimcea",
                        "latitude": "44.73333000",
                        "longitude": "28.36667000"
                    },
                    {
                        "id": 90588,
                        "name": "Cataloi",
                        "latitude": "45.09581000",
                        "longitude": "28.72856000"
                    },
                    {
                        "id": 90600,
                        "name": "Ceamurlia de Jos",
                        "latitude": "44.73333000",
                        "longitude": "28.71667000"
                    },
                    {
                        "id": 90601,
                        "name": "Ceamurlia de Sus",
                        "latitude": "44.76373000",
                        "longitude": "28.60881000"
                    },
                    {
                        "id": 90604,
                        "name": "Ceatalchioi",
                        "latitude": "45.28333000",
                        "longitude": "28.78333000"
                    },
                    {
                        "id": 90628,
                        "name": "Cerna",
                        "latitude": "45.08333000",
                        "longitude": "28.31667000"
                    },
                    {
                        "id": 90666,
                        "name": "Chilia Veche",
                        "latitude": "45.41667000",
                        "longitude": "29.28333000"
                    },
                    {
                        "id": 90743,
                        "name": "Ciucurova",
                        "latitude": "44.93333000",
                        "longitude": "28.48333000"
                    },
                    {
                        "id": 90917,
                        "name": "Comuna Baia",
                        "latitude": "44.75708000",
                        "longitude": "28.64028000"
                    },
                    {
                        "id": 90948,
                        "name": "Comuna Beidaud",
                        "latitude": "44.72132000",
                        "longitude": "28.53265000"
                    },
                    {
                        "id": 90981,
                        "name": "Comuna Beştepe",
                        "latitude": "45.11243000",
                        "longitude": "29.02425000"
                    },
                    {
                        "id": 91250,
                        "name": "Comuna C.A. Rosetti",
                        "latitude": "45.30207000",
                        "longitude": "29.57289000"
                    },
                    {
                        "id": 91261,
                        "name": "Comuna Carcaliu",
                        "latitude": "45.18688000",
                        "longitude": "28.14870000"
                    },
                    {
                        "id": 91263,
                        "name": "Comuna Casimcea",
                        "latitude": "44.76276000",
                        "longitude": "28.33156000"
                    },
                    {
                        "id": 91272,
                        "name": "Comuna Ceamurlia de Jos",
                        "latitude": "44.73731000",
                        "longitude": "28.75115000"
                    },
                    {
                        "id": 91274,
                        "name": "Comuna Ceatalchioi",
                        "latitude": "45.27904000",
                        "longitude": "28.78323000"
                    },
                    {
                        "id": 91291,
                        "name": "Comuna Cerna",
                        "latitude": "45.04007000",
                        "longitude": "28.31668000"
                    },
                    {
                        "id": 91314,
                        "name": "Comuna Chilia Veche",
                        "latitude": "45.37799000",
                        "longitude": "29.21511000"
                    },
                    {
                        "id": 91365,
                        "name": "Comuna Ciucurova",
                        "latitude": "44.91355000",
                        "longitude": "28.47111000"
                    },
                    {
                        "id": 91504,
                        "name": "Comuna Crişan",
                        "latitude": "45.16093000",
                        "longitude": "29.34258000"
                    },
                    {
                        "id": 91732,
                        "name": "Comuna Dăeni",
                        "latitude": "44.84533000",
                        "longitude": "28.13218000"
                    },
                    {
                        "id": 91664,
                        "name": "Comuna Dorobanţu",
                        "latitude": "44.94874000",
                        "longitude": "28.30073000"
                    },
                    {
                        "id": 91782,
                        "name": "Comuna Frecăţei",
                        "latitude": "45.11808000",
                        "longitude": "28.64492000"
                    },
                    {
                        "id": 91915,
                        "name": "Comuna Greci",
                        "latitude": "45.19132000",
                        "longitude": "28.23854000"
                    },
                    {
                        "id": 91918,
                        "name": "Comuna Grindu",
                        "latitude": "45.40829000",
                        "longitude": "28.20031000"
                    },
                    {
                        "id": 91991,
                        "name": "Comuna Hamcearca",
                        "latitude": "45.11559000",
                        "longitude": "28.39383000"
                    },
                    {
                        "id": 92018,
                        "name": "Comuna Horia",
                        "latitude": "45.03655000",
                        "longitude": "28.45947000"
                    },
                    {
                        "id": 92048,
                        "name": "Comuna I.C.Brãtianu",
                        "latitude": "45.40648000",
                        "longitude": "28.05332000"
                    },
                    {
                        "id": 92107,
                        "name": "Comuna Izvoarele",
                        "latitude": "45.03932000",
                        "longitude": "28.53351000"
                    },
                    {
                        "id": 92122,
                        "name": "Comuna Jijila",
                        "latitude": "45.32554000",
                        "longitude": "28.15710000"
                    },
                    {
                        "id": 92135,
                        "name": "Comuna Jurilovca",
                        "latitude": "44.77261000",
                        "longitude": "28.86906000"
                    },
                    {
                        "id": 92208,
                        "name": "Comuna Luncaviţa",
                        "latitude": "45.28653000",
                        "longitude": "28.30029000"
                    },
                    {
                        "id": 92229,
                        "name": "Comuna Mahmudia",
                        "latitude": "45.08582000",
                        "longitude": "29.08775000"
                    },
                    {
                        "id": 92232,
                        "name": "Comuna Maliuc",
                        "latitude": "45.18330000",
                        "longitude": "29.04828000"
                    },
                    {
                        "id": 92271,
                        "name": "Comuna Mihai Bravu",
                        "latitude": "44.95974000",
                        "longitude": "28.65504000"
                    },
                    {
                        "id": 92275,
                        "name": "Comuna Mihail Kogălniceanu",
                        "latitude": "45.02225000",
                        "longitude": "28.72861000"
                    },
                    {
                        "id": 92362,
                        "name": "Comuna Murighiol",
                        "latitude": "45.02504000",
                        "longitude": "29.15177000"
                    },
                    {
                        "id": 92424,
                        "name": "Comuna Nalbant",
                        "latitude": "45.04119000",
                        "longitude": "28.59827000"
                    },
                    {
                        "id": 92446,
                        "name": "Comuna Niculiţel",
                        "latitude": "45.18251000",
                        "longitude": "28.48139000"
                    },
                    {
                        "id": 92457,
                        "name": "Comuna Nufăru",
                        "latitude": "45.14333000",
                        "longitude": "28.92452000"
                    },
                    {
                        "id": 92519,
                        "name": "Comuna Ostrov",
                        "latitude": "44.91052000",
                        "longitude": "28.14640000"
                    },
                    {
                        "id": 92537,
                        "name": "Comuna Pardina",
                        "latitude": "45.30780000",
                        "longitude": "28.95691000"
                    },
                    {
                        "id": 92542,
                        "name": "Comuna Peceneaga",
                        "latitude": "45.00849000",
                        "longitude": "28.14872000"
                    },
                    {
                        "id": 92875,
                        "name": "Comuna Sarichioi",
                        "latitude": "44.92129000",
                        "longitude": "28.81870000"
                    },
                    {
                        "id": 92924,
                        "name": "Comuna Sfântu Gheorghe",
                        "latitude": "44.89654000",
                        "longitude": "29.59357000"
                    },
                    {
                        "id": 92949,
                        "name": "Comuna Slava Cercheză",
                        "latitude": "44.87578000",
                        "longitude": "28.58134000"
                    },
                    {
                        "id": 92965,
                        "name": "Comuna Smârdan",
                        "latitude": "45.28462000",
                        "longitude": "28.00599000"
                    },
                    {
                        "id": 92976,
                        "name": "Comuna Somova",
                        "latitude": "45.18861000",
                        "longitude": "28.65673000"
                    },
                    {
                        "id": 92988,
                        "name": "Comuna Stejaru",
                        "latitude": "44.78528000",
                        "longitude": "28.53996000"
                    },
                    {
                        "id": 93178,
                        "name": "Comuna Topolog",
                        "latitude": "44.86083000",
                        "longitude": "28.34320000"
                    },
                    {
                        "id": 93211,
                        "name": "Comuna Turcoaia",
                        "latitude": "45.10923000",
                        "longitude": "28.18806000"
                    },
                    {
                        "id": 93451,
                        "name": "Comuna Văcăreni",
                        "latitude": "45.32463000",
                        "longitude": "28.19504000"
                    },
                    {
                        "id": 93319,
                        "name": "Comuna Valea Nucarilor",
                        "latitude": "45.03206000",
                        "longitude": "28.91994000"
                    },
                    {
                        "id": 93326,
                        "name": "Comuna Valea Teilor",
                        "latitude": "45.11150000",
                        "longitude": "28.48801000"
                    },
                    {
                        "id": 93733,
                        "name": "Crişan",
                        "latitude": "44.96667000",
                        "longitude": "29.46667000"
                    },
                    {
                        "id": 94116,
                        "name": "Dăeni",
                        "latitude": "44.83333000",
                        "longitude": "28.11667000"
                    },
                    {
                        "id": 94000,
                        "name": "Dorobanţu",
                        "latitude": "44.95000000",
                        "longitude": "28.26667000"
                    },
                    {
                        "id": 94142,
                        "name": "Enisala",
                        "latitude": "44.87956000",
                        "longitude": "28.81872000"
                    },
                    {
                        "id": 94204,
                        "name": "Frecăţei",
                        "latitude": "45.10000000",
                        "longitude": "28.66667000"
                    },
                    {
                        "id": 94283,
                        "name": "Garvăn",
                        "latitude": "45.34710000",
                        "longitude": "28.16187000"
                    },
                    {
                        "id": 94409,
                        "name": "Greci",
                        "latitude": "45.18333000",
                        "longitude": "28.23333000"
                    },
                    {
                        "id": 94413,
                        "name": "Grindu",
                        "latitude": "45.40000000",
                        "longitude": "28.21667000"
                    },
                    {
                        "id": 94521,
                        "name": "Hamcearca",
                        "latitude": "45.11667000",
                        "longitude": "28.36667000"
                    },
                    {
                        "id": 94562,
                        "name": "Horia",
                        "latitude": "45.01667000",
                        "longitude": "28.45000000"
                    },
                    {
                        "id": 94611,
                        "name": "I. C. Brătianu",
                        "latitude": "45.40581000",
                        "longitude": "28.05381000"
                    },
                    {
                        "id": 94629,
                        "name": "Iazurile",
                        "latitude": "45.02162000",
                        "longitude": "28.94281000"
                    },
                    {
                        "id": 94688,
                        "name": "Isaccea",
                        "latitude": "45.26667000",
                        "longitude": "28.46667000"
                    },
                    {
                        "id": 94708,
                        "name": "Izvoarele",
                        "latitude": "45.03333000",
                        "longitude": "28.53333000"
                    },
                    {
                        "id": 94735,
                        "name": "Jijila",
                        "latitude": "45.30000000",
                        "longitude": "28.15000000"
                    },
                    {
                        "id": 94755,
                        "name": "Jurilovca",
                        "latitude": "44.76667000",
                        "longitude": "28.86667000"
                    },
                    {
                        "id": 94857,
                        "name": "Lunca",
                        "latitude": "44.73288000",
                        "longitude": "28.77495000"
                    },
                    {
                        "id": 94876,
                        "name": "Luncaviţa",
                        "latitude": "45.28333000",
                        "longitude": "28.26667000"
                    },
                    {
                        "id": 95229,
                        "name": "Măcin",
                        "latitude": "45.24371000",
                        "longitude": "28.13564000"
                    },
                    {
                        "id": 94906,
                        "name": "Mahmudia",
                        "latitude": "45.08333000",
                        "longitude": "29.08333000"
                    },
                    {
                        "id": 94911,
                        "name": "Malcoci",
                        "latitude": "45.13851000",
                        "longitude": "28.88824000"
                    },
                    {
                        "id": 94912,
                        "name": "Maliuc",
                        "latitude": "45.17678000",
                        "longitude": "29.11334000"
                    },
                    {
                        "id": 94975,
                        "name": "Mihai Bravu",
                        "latitude": "44.95000000",
                        "longitude": "28.65000000"
                    },
                    {
                        "id": 94982,
                        "name": "Mihail Kogălniceanu",
                        "latitude": "45.03333000",
                        "longitude": "28.73333000"
                    },
                    {
                        "id": 95007,
                        "name": "Mineri",
                        "latitude": "45.16472000",
                        "longitude": "28.71573000"
                    },
                    {
                        "id": 95188,
                        "name": "Municipiul Tulcea",
                        "latitude": "45.18325000",
                        "longitude": "28.79298000"
                    },
                    {
                        "id": 95208,
                        "name": "Murighiol",
                        "latitude": "45.03333000",
                        "longitude": "29.16667000"
                    },
                    {
                        "id": 95300,
                        "name": "Nalbant",
                        "latitude": "45.05000000",
                        "longitude": "28.61667000"
                    },
                    {
                        "id": 95335,
                        "name": "Nicolae Bălcescu",
                        "latitude": "44.99714000",
                        "longitude": "28.58757000"
                    },
                    {
                        "id": 95343,
                        "name": "Niculiţel",
                        "latitude": "45.18333000",
                        "longitude": "28.48333000"
                    },
                    {
                        "id": 95363,
                        "name": "Nufăru",
                        "latitude": "45.15000000",
                        "longitude": "28.91667000"
                    },
                    {
                        "id": 95453,
                        "name": "Oraş Babadag",
                        "latitude": "44.89092000",
                        "longitude": "28.71858000"
                    },
                    {
                        "id": 95535,
                        "name": "Oraş Isaccea",
                        "latitude": "45.26900000",
                        "longitude": "28.40446000"
                    },
                    {
                        "id": 95545,
                        "name": "Oraş Mãcin",
                        "latitude": "45.24736000",
                        "longitude": "28.13830000"
                    },
                    {
                        "id": 95594,
                        "name": "Oraş Sulina",
                        "latitude": "45.15608000",
                        "longitude": "29.65197000"
                    },
                    {
                        "id": 95677,
                        "name": "Ostrov",
                        "latitude": "44.93333000",
                        "longitude": "28.15000000"
                    },
                    {
                        "id": 95711,
                        "name": "Pardina",
                        "latitude": "45.30000000",
                        "longitude": "28.96667000"
                    },
                    {
                        "id": 95720,
                        "name": "Peceneaga",
                        "latitude": "45.01667000",
                        "longitude": "28.13333000"
                    },
                    {
                        "id": 96037,
                        "name": "Rachelu",
                        "latitude": "45.28667000",
                        "longitude": "28.32349000"
                    },
                    {
                        "id": 106010,
                        "name": "Sălcioara",
                        "latitude": "44.76667000",
                        "longitude": "28.88333000"
                    },
                    {
                        "id": 96246,
                        "name": "Sarichioi",
                        "latitude": "44.95000000",
                        "longitude": "28.85000000"
                    },
                    {
                        "id": 96328,
                        "name": "Sfântu Gheorghe",
                        "latitude": "44.89600000",
                        "longitude": "29.59294000"
                    },
                    {
                        "id": 96364,
                        "name": "Slava Cercheză",
                        "latitude": "44.90128000",
                        "longitude": "28.54753000"
                    },
                    {
                        "id": 96365,
                        "name": "Slava Rusă",
                        "latitude": "44.85029000",
                        "longitude": "28.60557000"
                    },
                    {
                        "id": 96391,
                        "name": "Smârdan",
                        "latitude": "45.28670000",
                        "longitude": "28.00368000"
                    },
                    {
                        "id": 96409,
                        "name": "Somova",
                        "latitude": "45.18333000",
                        "longitude": "28.66667000"
                    },
                    {
                        "id": 96426,
                        "name": "Stejaru",
                        "latitude": "44.76667000",
                        "longitude": "28.55000000"
                    },
                    {
                        "id": 96499,
                        "name": "Sulina",
                        "latitude": "45.15564000",
                        "longitude": "29.65403000"
                    },
                    {
                        "id": 106135,
                        "name": "Topolog",
                        "latitude": "44.88333000",
                        "longitude": "28.36667000"
                    },
                    {
                        "id": 106147,
                        "name": "Traian",
                        "latitude": "45.02876000",
                        "longitude": "28.23518000"
                    },
                    {
                        "id": 106173,
                        "name": "Tulcea",
                        "latitude": "45.17870000",
                        "longitude": "28.80501000"
                    },
                    {
                        "id": 96556,
                        "name": "Turcoaia",
                        "latitude": "45.11667000",
                        "longitude": "28.18333000"
                    },
                    {
                        "id": 96557,
                        "name": "Turda",
                        "latitude": "44.97501000",
                        "longitude": "28.62402000"
                    },
                    {
                        "id": 96951,
                        "name": "Văcăreni",
                        "latitude": "45.32415000",
                        "longitude": "28.19512000"
                    },
                    {
                        "id": 96744,
                        "name": "Valea Nucarilor",
                        "latitude": "45.03333000",
                        "longitude": "28.93333000"
                    },
                    {
                        "id": 96759,
                        "name": "Valea Teilor",
                        "latitude": "45.11150000",
                        "longitude": "28.48801000"
                    },
                    {
                        "id": 96986,
                        "name": "Zebil",
                        "latitude": "44.94600000",
                        "longitude": "28.76873000"
                    }
                ]
            },
            {
                "id": 4757,
                "name": "Vâlcea",
                "iso2": "VL",
                "latitude": "45.07980510",
                "longitude": "24.08352830",
                "type": "department",
                "cities": [
                    {
                        "id": 89944,
                        "name": "Alunu",
                        "latitude": "45.01667000",
                        "longitude": "23.81667000"
                    },
                    {
                        "id": 89951,
                        "name": "Amărăşti",
                        "latitude": "44.76667000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 90470,
                        "name": "Băbeni",
                        "latitude": "44.96667000",
                        "longitude": "24.23333000"
                    },
                    {
                        "id": 90471,
                        "name": "Băbeni-Oltețu",
                        "latitude": "44.61404000",
                        "longitude": "23.97798000"
                    },
                    {
                        "id": 90490,
                        "name": "Băile Govora",
                        "latitude": "45.08333000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 90492,
                        "name": "Băile Olăneşti",
                        "latitude": "45.20000000",
                        "longitude": "24.23333000"
                    },
                    {
                        "id": 90505,
                        "name": "Bălceşti",
                        "latitude": "44.61667000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 90540,
                        "name": "Bărbăteşti",
                        "latitude": "45.18333000",
                        "longitude": "24.11667000"
                    },
                    {
                        "id": 90070,
                        "name": "Batârăşti",
                        "latitude": "44.81667000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 90095,
                        "name": "Berbeşti",
                        "latitude": "44.98333000",
                        "longitude": "23.88333000"
                    },
                    {
                        "id": 90110,
                        "name": "Berislăveşti",
                        "latitude": "45.25000000",
                        "longitude": "24.41667000"
                    },
                    {
                        "id": 90150,
                        "name": "Bistrița",
                        "latitude": "45.18612000",
                        "longitude": "24.04010000"
                    },
                    {
                        "id": 90181,
                        "name": "Bodești",
                        "latitude": "45.14167000",
                        "longitude": "24.11549000"
                    },
                    {
                        "id": 90206,
                        "name": "Boişoara",
                        "latitude": "45.43333000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 90303,
                        "name": "Brezoi",
                        "latitude": "45.33797000",
                        "longitude": "24.24863000"
                    },
                    {
                        "id": 90380,
                        "name": "Budeşti",
                        "latitude": "45.05000000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 90399,
                        "name": "Bujoreni",
                        "latitude": "45.13333000",
                        "longitude": "24.35000000"
                    },
                    {
                        "id": 90408,
                        "name": "Buneşti",
                        "latitude": "45.11667000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 93790,
                        "name": "Câinenii Mici",
                        "latitude": "45.48333000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 93835,
                        "name": "Călimăneşti",
                        "latitude": "45.23333000",
                        "longitude": "24.33333000"
                    },
                    {
                        "id": 93836,
                        "name": "Călina",
                        "latitude": "44.70205000",
                        "longitude": "24.25439000"
                    },
                    {
                        "id": 90636,
                        "name": "Cernişoara",
                        "latitude": "45.03333000",
                        "longitude": "23.98333000"
                    },
                    {
                        "id": 90653,
                        "name": "Cheia",
                        "latitude": "45.18306000",
                        "longitude": "24.21666000"
                    },
                    {
                        "id": 90861,
                        "name": "Comuna Alunu",
                        "latitude": "45.00954000",
                        "longitude": "23.81760000"
                    },
                    {
                        "id": 90865,
                        "name": "Comuna Amărăşti",
                        "latitude": "44.76107000",
                        "longitude": "24.14382000"
                    },
                    {
                        "id": 91239,
                        "name": "Comuna Bărbăteşti",
                        "latitude": "45.14154000",
                        "longitude": "24.10933000"
                    },
                    {
                        "id": 90969,
                        "name": "Comuna Berislăveşti",
                        "latitude": "45.26406000",
                        "longitude": "24.43785000"
                    },
                    {
                        "id": 91035,
                        "name": "Comuna Boişoara",
                        "latitude": "45.44232000",
                        "longitude": "24.37462000"
                    },
                    {
                        "id": 91147,
                        "name": "Comuna Budeşti",
                        "latitude": "45.04714000",
                        "longitude": "24.36603000"
                    },
                    {
                        "id": 91155,
                        "name": "Comuna Bujoreni",
                        "latitude": "45.16235000",
                        "longitude": "24.36593000"
                    },
                    {
                        "id": 91163,
                        "name": "Comuna Buneşti",
                        "latitude": "45.10202000",
                        "longitude": "24.21397000"
                    },
                    {
                        "id": 91539,
                        "name": "Comuna Câineni",
                        "latitude": "45.49499000",
                        "longitude": "24.30885000"
                    },
                    {
                        "id": 91294,
                        "name": "Comuna Cernişoara",
                        "latitude": "45.03432000",
                        "longitude": "24.00487000"
                    },
                    {
                        "id": 91419,
                        "name": "Comuna Copăceni",
                        "latitude": "44.98223000",
                        "longitude": "23.98164000"
                    },
                    {
                        "id": 91456,
                        "name": "Comuna Costeşti",
                        "latitude": "45.16936000",
                        "longitude": "24.05813000"
                    },
                    {
                        "id": 91492,
                        "name": "Comuna Creţeni",
                        "latitude": "44.70571000",
                        "longitude": "24.18009000"
                    },
                    {
                        "id": 91733,
                        "name": "Comuna Dăeşti",
                        "latitude": "45.18584000",
                        "longitude": "24.39337000"
                    },
                    {
                        "id": 91742,
                        "name": "Comuna Dănicei",
                        "latitude": "44.91181000",
                        "longitude": "24.44503000"
                    },
                    {
                        "id": 91623,
                        "name": "Comuna Diculeşti",
                        "latitude": "44.60974000",
                        "longitude": "23.98795000"
                    },
                    {
                        "id": 91690,
                        "name": "Comuna Drăgoeşti",
                        "latitude": "44.80393000",
                        "longitude": "24.29400000"
                    },
                    {
                        "id": 91813,
                        "name": "Comuna Fârtãţeşti",
                        "latitude": "44.77577000",
                        "longitude": "23.98080000"
                    },
                    {
                        "id": 91826,
                        "name": "Comuna Făureşti",
                        "latitude": "44.57351000",
                        "longitude": "24.00871000"
                    },
                    {
                        "id": 91791,
                        "name": "Comuna Frânceşti-Mânăstireni",
                        "latitude": "45.02358000",
                        "longitude": "24.16794000"
                    },
                    {
                        "id": 91830,
                        "name": "Comuna Galicea",
                        "latitude": "44.94428000",
                        "longitude": "24.29633000"
                    },
                    {
                        "id": 91862,
                        "name": "Comuna Ghioroiu",
                        "latitude": "44.67868000",
                        "longitude": "23.84740000"
                    },
                    {
                        "id": 91885,
                        "name": "Comuna Glăvile",
                        "latitude": "44.80423000",
                        "longitude": "24.12255000"
                    },
                    {
                        "id": 91897,
                        "name": "Comuna Goleşti",
                        "latitude": "45.11370000",
                        "longitude": "24.47395000"
                    },
                    {
                        "id": 91940,
                        "name": "Comuna Grădiştea",
                        "latitude": "44.89929000",
                        "longitude": "23.81621000"
                    },
                    {
                        "id": 91960,
                        "name": "Comuna Guşoeni",
                        "latitude": "44.72134000",
                        "longitude": "24.12696000"
                    },
                    {
                        "id": 92085,
                        "name": "Comuna Ioneşti",
                        "latitude": "44.85429000",
                        "longitude": "24.23134000"
                    },
                    {
                        "id": 92219,
                        "name": "Comuna Lăcusteni",
                        "latitude": "44.70863000",
                        "longitude": "23.89214000"
                    },
                    {
                        "id": 92220,
                        "name": "Comuna Lădeşti",
                        "latitude": "44.87014000",
                        "longitude": "24.04350000"
                    },
                    {
                        "id": 92136,
                        "name": "Comuna Laloşu",
                        "latitude": "44.53046000",
                        "longitude": "24.04689000"
                    },
                    {
                        "id": 92222,
                        "name": "Comuna Lăpuşata",
                        "latitude": "44.92591000",
                        "longitude": "24.00976000"
                    },
                    {
                        "id": 92174,
                        "name": "Comuna Livezi",
                        "latitude": "44.83700000",
                        "longitude": "23.83209000"
                    },
                    {
                        "id": 92212,
                        "name": "Comuna Lungeşti",
                        "latitude": "44.60271000",
                        "longitude": "24.17894000"
                    },
                    {
                        "id": 92380,
                        "name": "Comuna Măciuca",
                        "latitude": "44.75807000",
                        "longitude": "24.02408000"
                    },
                    {
                        "id": 92381,
                        "name": "Comuna Mădulari-Beica",
                        "latitude": "44.67820000",
                        "longitude": "24.10121000"
                    },
                    {
                        "id": 92231,
                        "name": "Comuna Malaia",
                        "latitude": "45.36429000",
                        "longitude": "24.04456000"
                    },
                    {
                        "id": 92397,
                        "name": "Comuna Măldăreşti",
                        "latitude": "45.10258000",
                        "longitude": "24.00613000"
                    },
                    {
                        "id": 92246,
                        "name": "Comuna Mateeşti",
                        "latitude": "45.06784000",
                        "longitude": "23.85490000"
                    },
                    {
                        "id": 92280,
                        "name": "Comuna Mihăeşti",
                        "latitude": "45.03282000",
                        "longitude": "24.24501000"
                    },
                    {
                        "id": 92288,
                        "name": "Comuna Milcoiu",
                        "latitude": "45.04046000",
                        "longitude": "24.46786000"
                    },
                    {
                        "id": 92309,
                        "name": "Comuna Mitrofani",
                        "latitude": "44.75104000",
                        "longitude": "24.20272000"
                    },
                    {
                        "id": 92354,
                        "name": "Comuna Muereasca",
                        "latitude": "45.20364000",
                        "longitude": "24.29726000"
                    },
                    {
                        "id": 92439,
                        "name": "Comuna Nicolae Bãlcescu",
                        "latitude": "44.98760000",
                        "longitude": "24.41990000"
                    },
                    {
                        "id": 92492,
                        "name": "Comuna Olanu",
                        "latitude": "44.87416000",
                        "longitude": "24.29169000"
                    },
                    {
                        "id": 92510,
                        "name": "Comuna Orleşti",
                        "latitude": "44.78125000",
                        "longitude": "24.24623000"
                    },
                    {
                        "id": 92522,
                        "name": "Comuna Oteşani",
                        "latitude": "45.04807000",
                        "longitude": "24.03989000"
                    },
                    {
                        "id": 92730,
                        "name": "Comuna Păuşeşti",
                        "latitude": "45.07341000",
                        "longitude": "24.13552000"
                    },
                    {
                        "id": 92731,
                        "name": "Comuna Păuşeşti-Măglaşi",
                        "latitude": "45.14165000",
                        "longitude": "24.24474000"
                    },
                    {
                        "id": 92554,
                        "name": "Comuna Perişani",
                        "latitude": "45.37925000",
                        "longitude": "24.40776000"
                    },
                    {
                        "id": 92560,
                        "name": "Comuna Pesceana",
                        "latitude": "44.88169000",
                        "longitude": "24.12797000"
                    },
                    {
                        "id": 92577,
                        "name": "Comuna Pietrari",
                        "latitude": "45.11586000",
                        "longitude": "24.10242000"
                    },
                    {
                        "id": 92656,
                        "name": "Comuna Popeşti",
                        "latitude": "44.97908000",
                        "longitude": "24.11014000"
                    },
                    {
                        "id": 92684,
                        "name": "Comuna Prundeni",
                        "latitude": "44.73460000",
                        "longitude": "24.24863000"
                    },
                    {
                        "id": 92736,
                        "name": "Comuna Racoviţa",
                        "latitude": "45.41200000",
                        "longitude": "24.31792000"
                    },
                    {
                        "id": 92778,
                        "name": "Comuna Roeşti",
                        "latitude": "44.92016000",
                        "longitude": "24.07793000"
                    },
                    {
                        "id": 92801,
                        "name": "Comuna Roşiile",
                        "latitude": "44.88537000",
                        "longitude": "23.92438000"
                    },
                    {
                        "id": 92812,
                        "name": "Comuna Runcu",
                        "latitude": "45.18685000",
                        "longitude": "24.45979000"
                    },
                    {
                        "id": 93099,
                        "name": "Comuna Sălătrucel",
                        "latitude": "45.26684000",
                        "longitude": "24.38921000"
                    },
                    {
                        "id": 92898,
                        "name": "Comuna Scundu",
                        "latitude": "44.84880000",
                        "longitude": "24.17981000"
                    },
                    {
                        "id": 92938,
                        "name": "Comuna Sineşti",
                        "latitude": "44.93231000",
                        "longitude": "23.83951000"
                    },
                    {
                        "id": 93530,
                        "name": "Comuna Şirineasa",
                        "latitude": "44.93871000",
                        "longitude": "24.18570000"
                    },
                    {
                        "id": 92960,
                        "name": "Comuna Slătioara",
                        "latitude": "45.12396000",
                        "longitude": "23.88581000"
                    },
                    {
                        "id": 93018,
                        "name": "Comuna Stăneşti",
                        "latitude": "44.81359000",
                        "longitude": "24.04264000"
                    },
                    {
                        "id": 93555,
                        "name": "Comuna Ştefăneşti",
                        "latitude": "44.60541000",
                        "longitude": "24.23338000"
                    },
                    {
                        "id": 92993,
                        "name": "Comuna Stoeneşti",
                        "latitude": "45.14715000",
                        "longitude": "24.16337000"
                    },
                    {
                        "id": 92996,
                        "name": "Comuna Stoileşti",
                        "latitude": "44.91463000",
                        "longitude": "24.35992000"
                    },
                    {
                        "id": 93004,
                        "name": "Comuna Stroeşti",
                        "latitude": "45.07519000",
                        "longitude": "23.92645000"
                    },
                    {
                        "id": 93564,
                        "name": "Comuna Şuşani",
                        "latitude": "44.61009000",
                        "longitude": "24.10021000"
                    },
                    {
                        "id": 93042,
                        "name": "Comuna Suteşti",
                        "latitude": "44.67103000",
                        "longitude": "24.21893000"
                    },
                    {
                        "id": 93146,
                        "name": "Comuna Tetoiu",
                        "latitude": "44.78374000",
                        "longitude": "23.91735000"
                    },
                    {
                        "id": 93160,
                        "name": "Comuna Titeşti",
                        "latitude": "45.41971000",
                        "longitude": "24.39323000"
                    },
                    {
                        "id": 93172,
                        "name": "Comuna Tomşani",
                        "latitude": "45.09606000",
                        "longitude": "24.06020000"
                    },
                    {
                        "id": 93296,
                        "name": "Comuna Vaideeni",
                        "latitude": "45.17322000",
                        "longitude": "23.88622000"
                    },
                    {
                        "id": 93314,
                        "name": "Comuna Valea Mare",
                        "latitude": "44.67374000",
                        "longitude": "24.00055000"
                    },
                    {
                        "id": 93389,
                        "name": "Comuna Vlădeşti",
                        "latitude": "45.13574000",
                        "longitude": "24.30181000"
                    },
                    {
                        "id": 93394,
                        "name": "Comuna Voiceşti",
                        "latitude": "44.59651000",
                        "longitude": "24.29980000"
                    },
                    {
                        "id": 93397,
                        "name": "Comuna Voineasa",
                        "latitude": "45.41128000",
                        "longitude": "23.97611000"
                    },
                    {
                        "id": 93490,
                        "name": "Comuna Zătreni",
                        "latitude": "44.77069000",
                        "longitude": "23.84320000"
                    },
                    {
                        "id": 93604,
                        "name": "Copăcelu",
                        "latitude": "45.06762000",
                        "longitude": "24.31161000"
                    },
                    {
                        "id": 93606,
                        "name": "Copăceni",
                        "latitude": "45.00000000",
                        "longitude": "23.98333000"
                    },
                    {
                        "id": 93697,
                        "name": "Coșani",
                        "latitude": "45.00788000",
                        "longitude": "24.19188000"
                    },
                    {
                        "id": 93658,
                        "name": "Costeşti",
                        "latitude": "45.15000000",
                        "longitude": "24.06667000"
                    },
                    {
                        "id": 93713,
                        "name": "Creţeni",
                        "latitude": "44.68333000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 94117,
                        "name": "Dăeşti",
                        "latitude": "44.96667000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 93901,
                        "name": "Dealu Aluniș",
                        "latitude": "44.98252000",
                        "longitude": "23.86749000"
                    },
                    {
                        "id": 93902,
                        "name": "Dealu Dănicei",
                        "latitude": "44.90000000",
                        "longitude": "24.43333000"
                    },
                    {
                        "id": 93934,
                        "name": "Diculești",
                        "latitude": "44.59351000",
                        "longitude": "23.98968000"
                    },
                    {
                        "id": 93971,
                        "name": "Dobrușa",
                        "latitude": "44.62642000",
                        "longitude": "24.20779000"
                    },
                    {
                        "id": 94064,
                        "name": "Drăgăşani",
                        "latitude": "44.65000000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 94041,
                        "name": "Drăgoeşti",
                        "latitude": "44.81667000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 94267,
                        "name": "Fărtăţeşti",
                        "latitude": "44.78333000",
                        "longitude": "24.00000000"
                    },
                    {
                        "id": 94271,
                        "name": "Făureşti",
                        "latitude": "44.56667000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 94277,
                        "name": "Galicea",
                        "latitude": "44.91667000",
                        "longitude": "24.28333000"
                    },
                    {
                        "id": 94334,
                        "name": "Ghioroiu",
                        "latitude": "44.70000000",
                        "longitude": "23.83333000"
                    },
                    {
                        "id": 94365,
                        "name": "Glăvile",
                        "latitude": "44.81667000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 94381,
                        "name": "Goranu",
                        "latitude": "45.10523000",
                        "longitude": "24.38431000"
                    },
                    {
                        "id": 94439,
                        "name": "Grădiştea",
                        "latitude": "44.86667000",
                        "longitude": "23.81667000"
                    },
                    {
                        "id": 94403,
                        "name": "Greblești",
                        "latitude": "45.47514000",
                        "longitude": "24.31182000"
                    },
                    {
                        "id": 94460,
                        "name": "Gura Suhașului",
                        "latitude": "45.08803000",
                        "longitude": "24.29886000"
                    },
                    {
                        "id": 94474,
                        "name": "Guşoeni",
                        "latitude": "44.73333000",
                        "longitude": "24.11667000"
                    },
                    {
                        "id": 94558,
                        "name": "Horezu",
                        "latitude": "45.15000000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 94651,
                        "name": "Igoiu",
                        "latitude": "45.04824000",
                        "longitude": "23.80835000"
                    },
                    {
                        "id": 94678,
                        "name": "Ioneşti",
                        "latitude": "44.85000000",
                        "longitude": "24.23333000"
                    },
                    {
                        "id": 94729,
                        "name": "Jiblea Veche",
                        "latitude": "45.24360000",
                        "longitude": "24.35163000"
                    },
                    {
                        "id": 94891,
                        "name": "Lăcusteni",
                        "latitude": "44.69544000",
                        "longitude": "23.89984000"
                    },
                    {
                        "id": 94892,
                        "name": "Lădeşti",
                        "latitude": "44.88333000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 94757,
                        "name": "Laloşu",
                        "latitude": "44.55000000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 94817,
                        "name": "Livadia",
                        "latitude": "45.20546000",
                        "longitude": "24.24192000"
                    },
                    {
                        "id": 94819,
                        "name": "Livezi",
                        "latitude": "44.84029000",
                        "longitude": "23.82505000"
                    },
                    {
                        "id": 94881,
                        "name": "Lungeşti",
                        "latitude": "44.56667000",
                        "longitude": "24.18333000"
                    },
                    {
                        "id": 95231,
                        "name": "Mădulari",
                        "latitude": "45.03333000",
                        "longitude": "24.00000000"
                    },
                    {
                        "id": 94910,
                        "name": "Malaia",
                        "latitude": "45.35000000",
                        "longitude": "24.03333000"
                    },
                    {
                        "id": 95252,
                        "name": "Măldăreşti",
                        "latitude": "45.11667000",
                        "longitude": "24.00000000"
                    },
                    {
                        "id": 95260,
                        "name": "Mănăilești",
                        "latitude": "45.02464000",
                        "longitude": "24.12451000"
                    },
                    {
                        "id": 94935,
                        "name": "Mateeşti",
                        "latitude": "45.06667000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 94987,
                        "name": "Mihăeşti",
                        "latitude": "45.03333000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 95001,
                        "name": "Milcoiu",
                        "latitude": "45.05000000",
                        "longitude": "24.46667000"
                    },
                    {
                        "id": 95033,
                        "name": "Mitrofani",
                        "latitude": "44.73268000",
                        "longitude": "24.20910000"
                    },
                    {
                        "id": 95051,
                        "name": "Mogești",
                        "latitude": "45.11667000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 95098,
                        "name": "Muereasca",
                        "latitude": "45.18333000",
                        "longitude": "24.33333000"
                    },
                    {
                        "id": 95139,
                        "name": "Municipiul Drãgãşani",
                        "latitude": "44.64414000",
                        "longitude": "24.24632000"
                    },
                    {
                        "id": 95175,
                        "name": "Municipiul Râmnicu Vâlcea",
                        "latitude": "45.09448000",
                        "longitude": "24.35215000"
                    },
                    {
                        "id": 95435,
                        "name": "Olănești",
                        "latitude": "45.18209000",
                        "longitude": "24.25990000"
                    },
                    {
                        "id": 95422,
                        "name": "Olanu",
                        "latitude": "44.86667000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 95480,
                        "name": "Oraş Bãbeni",
                        "latitude": "44.97023000",
                        "longitude": "24.22555000"
                    },
                    {
                        "id": 95482,
                        "name": "Oraş Bãile Govora",
                        "latitude": "45.08174000",
                        "longitude": "24.18246000"
                    },
                    {
                        "id": 95484,
                        "name": "Oraş Bãile Olãneşti",
                        "latitude": "45.20059000",
                        "longitude": "24.23416000"
                    },
                    {
                        "id": 95487,
                        "name": "Oraş Bãlceşti",
                        "latitude": "44.62941000",
                        "longitude": "23.94052000"
                    },
                    {
                        "id": 95461,
                        "name": "Oraş Berbeşti",
                        "latitude": "44.99915000",
                        "longitude": "23.88013000"
                    },
                    {
                        "id": 95471,
                        "name": "Oraş Brezoi",
                        "latitude": "45.35088000",
                        "longitude": "24.25681000"
                    },
                    {
                        "id": 95505,
                        "name": "Oraş Cãlimãneşti",
                        "latitude": "45.24252000",
                        "longitude": "24.34375000"
                    },
                    {
                        "id": 95529,
                        "name": "Oraş Horezu",
                        "latitude": "45.16962000",
                        "longitude": "23.98448000"
                    },
                    {
                        "id": 95558,
                        "name": "Oraş Ocnele Mari",
                        "latitude": "45.08904000",
                        "longitude": "24.28162000"
                    },
                    {
                        "id": 95661,
                        "name": "Orleşti",
                        "latitude": "44.80000000",
                        "longitude": "24.21667000"
                    },
                    {
                        "id": 95683,
                        "name": "Oteşani",
                        "latitude": "45.06667000",
                        "longitude": "24.03333000"
                    },
                    {
                        "id": 95682,
                        "name": "Otetelișu",
                        "latitude": "44.63839000",
                        "longitude": "23.95917000"
                    },
                    {
                        "id": 95685,
                        "name": "Oveselu",
                        "latitude": "44.75000000",
                        "longitude": "24.01667000"
                    },
                    {
                        "id": 96034,
                        "name": "Păuşeşti",
                        "latitude": "45.07358000",
                        "longitude": "24.13473000"
                    },
                    {
                        "id": 96035,
                        "name": "Păuşeşti-Măglaşi",
                        "latitude": "45.13333000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 95736,
                        "name": "Perişani",
                        "latitude": "45.38333000",
                        "longitude": "24.40000000"
                    },
                    {
                        "id": 95744,
                        "name": "Pesceana",
                        "latitude": "44.88333000",
                        "longitude": "24.15000000"
                    },
                    {
                        "id": 95777,
                        "name": "Pietrari",
                        "latitude": "45.10000000",
                        "longitude": "24.13333000"
                    },
                    {
                        "id": 95778,
                        "name": "Pietrarii de Sus",
                        "latitude": "45.11697000",
                        "longitude": "24.09336000"
                    },
                    {
                        "id": 95910,
                        "name": "Popeşti",
                        "latitude": "44.98333000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 95939,
                        "name": "Prajila",
                        "latitude": "45.08270000",
                        "longitude": "24.16949000"
                    },
                    {
                        "id": 95964,
                        "name": "Prundeni",
                        "latitude": "44.73333000",
                        "longitude": "24.26667000"
                    },
                    {
                        "id": 96042,
                        "name": "Racoviţa",
                        "latitude": "45.41667000",
                        "longitude": "24.31667000"
                    },
                    {
                        "id": 96166,
                        "name": "Râmești",
                        "latitude": "44.56667000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 96171,
                        "name": "Râmnicu Vâlcea",
                        "latitude": "45.10000000",
                        "longitude": "24.36667000"
                    },
                    {
                        "id": 96100,
                        "name": "Roeşti",
                        "latitude": "44.91667000",
                        "longitude": "24.08333000"
                    },
                    {
                        "id": 96114,
                        "name": "Români",
                        "latitude": "44.97310000",
                        "longitude": "24.20513000"
                    },
                    {
                        "id": 96131,
                        "name": "Roşiile",
                        "latitude": "44.86667000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 96152,
                        "name": "Runcu",
                        "latitude": "45.16667000",
                        "longitude": "24.45000000"
                    },
                    {
                        "id": 106022,
                        "name": "Sălătrucel",
                        "latitude": "45.25000000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 96286,
                        "name": "Scundu",
                        "latitude": "44.83333000",
                        "longitude": "24.20000000"
                    },
                    {
                        "id": 96351,
                        "name": "Sineşti",
                        "latitude": "44.95000000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 97059,
                        "name": "Şirineasa",
                        "latitude": "44.93333000",
                        "longitude": "24.20000000"
                    },
                    {
                        "id": 96479,
                        "name": "Stănești",
                        "latitude": "44.81667000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 97085,
                        "name": "Ştefăneşti",
                        "latitude": "44.61667000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 96434,
                        "name": "Stoeneşti",
                        "latitude": "45.11667000",
                        "longitude": "24.16667000"
                    },
                    {
                        "id": 96439,
                        "name": "Stoileşti",
                        "latitude": "44.90000000",
                        "longitude": "24.38333000"
                    },
                    {
                        "id": 96441,
                        "name": "Stolniceni",
                        "latitude": "45.03948000",
                        "longitude": "24.30640000"
                    },
                    {
                        "id": 96454,
                        "name": "Stroeşti",
                        "latitude": "45.08333000",
                        "longitude": "23.90000000"
                    },
                    {
                        "id": 97096,
                        "name": "Şuşani",
                        "latitude": "44.58333000",
                        "longitude": "24.10000000"
                    },
                    {
                        "id": 96514,
                        "name": "Sutești",
                        "latitude": "44.66851000",
                        "longitude": "24.21476000"
                    },
                    {
                        "id": 106089,
                        "name": "Tetoiu",
                        "latitude": "44.75000000",
                        "longitude": "23.91667000"
                    },
                    {
                        "id": 106109,
                        "name": "Titești",
                        "latitude": "45.41971000",
                        "longitude": "24.39323000"
                    },
                    {
                        "id": 106125,
                        "name": "Tomşani",
                        "latitude": "45.11667000",
                        "longitude": "24.05000000"
                    },
                    {
                        "id": 96554,
                        "name": "Turcești",
                        "latitude": "45.04023000",
                        "longitude": "23.86574000"
                    },
                    {
                        "id": 96690,
                        "name": "Urși",
                        "latitude": "44.99404000",
                        "longitude": "24.08895000"
                    },
                    {
                        "id": 96705,
                        "name": "Vaideeni",
                        "latitude": "45.16667000",
                        "longitude": "23.93333000"
                    },
                    {
                        "id": 96736,
                        "name": "Valea Mare",
                        "latitude": "44.66667000",
                        "longitude": "24.00000000"
                    },
                    {
                        "id": 96866,
                        "name": "Vlădeşti",
                        "latitude": "45.11667000",
                        "longitude": "24.30000000"
                    },
                    {
                        "id": 96874,
                        "name": "Voiceşti",
                        "latitude": "44.60000000",
                        "longitude": "24.28333000"
                    },
                    {
                        "id": 96877,
                        "name": "Voineasa",
                        "latitude": "45.41667000",
                        "longitude": "23.95000000"
                    },
                    {
                        "id": 97018,
                        "name": "Zătreni",
                        "latitude": "44.76667000",
                        "longitude": "23.85000000"
                    },
                    {
                        "id": 97000,
                        "name": "Zlătărei",
                        "latitude": "44.63057000",
                        "longitude": "24.25788000"
                    }
                ]
            },
            {
                "id": 4752,
                "name": "Vaslui",
                "iso2": "VS",
                "latitude": "46.46310590",
                "longitude": "27.73980310",
                "type": "department",
                "cities": [
                    {
                        "id": 89913,
                        "name": "Albeşti",
                        "latitude": "46.50000000",
                        "longitude": "27.86667000"
                    },
                    {
                        "id": 89928,
                        "name": "Alexandru Vlăhuţă",
                        "latitude": "46.41667000",
                        "longitude": "27.63333000"
                    },
                    {
                        "id": 90000,
                        "name": "Arsura",
                        "latitude": "46.81333000",
                        "longitude": "28.02222000"
                    },
                    {
                        "id": 90474,
                        "name": "Băcani",
                        "latitude": "46.33333000",
                        "longitude": "27.66667000"
                    },
                    {
                        "id": 90475,
                        "name": "Băceşti",
                        "latitude": "46.85000000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 90479,
                        "name": "Bădeana",
                        "latitude": "46.15000000",
                        "longitude": "27.58333000"
                    },
                    {
                        "id": 90489,
                        "name": "Băile Drânceni",
                        "latitude": "46.81361000",
                        "longitude": "28.10083000"
                    },
                    {
                        "id": 90514,
                        "name": "Bălteni",
                        "latitude": "46.66667000",
                        "longitude": "27.61667000"
                    },
                    {
                        "id": 90053,
                        "name": "Banca",
                        "latitude": "46.30000000",
                        "longitude": "27.80000000"
                    },
                    {
                        "id": 90450,
                        "name": "Bârlad",
                        "latitude": "46.23175000",
                        "longitude": "27.66907000"
                    },
                    {
                        "id": 90461,
                        "name": "Bârzești",
                        "latitude": "46.75000000",
                        "longitude": "27.55000000"
                    },
                    {
                        "id": 90103,
                        "name": "Berezeni",
                        "latitude": "46.37611000",
                        "longitude": "28.14778000"
                    },
                    {
                        "id": 90163,
                        "name": "Blăgeşti",
                        "latitude": "46.13722000",
                        "longitude": "28.01306000"
                    },
                    {
                        "id": 90188,
                        "name": "Bogdana",
                        "latitude": "46.52668000",
                        "longitude": "27.63278000"
                    },
                    {
                        "id": 90194,
                        "name": "Bogdănești",
                        "latitude": "46.44965000",
                        "longitude": "27.72679000"
                    },
                    {
                        "id": 90195,
                        "name": "Bogdăniţa",
                        "latitude": "46.45000000",
                        "longitude": "27.68333000"
                    },
                    {
                        "id": 90256,
                        "name": "Boţeşti",
                        "latitude": "46.80000000",
                        "longitude": "27.88333000"
                    },
                    {
                        "id": 90306,
                        "name": "Brodoc",
                        "latitude": "46.65090000",
                        "longitude": "27.67669000"
                    },
                    {
                        "id": 90372,
                        "name": "Buda",
                        "latitude": "46.76231000",
                        "longitude": "27.42113000"
                    },
                    {
                        "id": 90410,
                        "name": "Buneşti",
                        "latitude": "46.83333000",
                        "longitude": "27.96667000"
                    },
                    {
                        "id": 93810,
                        "name": "Cârja",
                        "latitude": "46.14878000",
                        "longitude": "28.11012000"
                    },
                    {
                        "id": 90676,
                        "name": "Chircești",
                        "latitude": "46.84629000",
                        "longitude": "27.84920000"
                    },
                    {
                        "id": 90691,
                        "name": "Chițoc",
                        "latitude": "46.59545000",
                        "longitude": "27.67450000"
                    },
                    {
                        "id": 90706,
                        "name": "Ciocani",
                        "latitude": "46.26044000",
                        "longitude": "27.55994000"
                    },
                    {
                        "id": 90786,
                        "name": "Codăeşti",
                        "latitude": "46.86667000",
                        "longitude": "27.75000000"
                    },
                    {
                        "id": 90841,
                        "name": "Comuna Albeşti",
                        "latitude": "46.49850000",
                        "longitude": "27.85167000"
                    },
                    {
                        "id": 90850,
                        "name": "Comuna Alexandru Vlăhuţă",
                        "latitude": "46.44973000",
                        "longitude": "27.62420000"
                    },
                    {
                        "id": 90898,
                        "name": "Comuna Arsura",
                        "latitude": "46.79618000",
                        "longitude": "28.03896000"
                    },
                    {
                        "id": 91203,
                        "name": "Comuna Băcani",
                        "latitude": "46.33768000",
                        "longitude": "27.67905000"
                    },
                    {
                        "id": 91204,
                        "name": "Comuna Băceşti",
                        "latitude": "46.83325000",
                        "longitude": "27.23668000"
                    },
                    {
                        "id": 91219,
                        "name": "Comuna Bălteni",
                        "latitude": "46.67554000",
                        "longitude": "27.61019000"
                    },
                    {
                        "id": 90933,
                        "name": "Comuna Banca",
                        "latitude": "46.34406000",
                        "longitude": "27.82091000"
                    },
                    {
                        "id": 90964,
                        "name": "Comuna Berezeni",
                        "latitude": "46.39654000",
                        "longitude": "28.11570000"
                    },
                    {
                        "id": 91007,
                        "name": "Comuna Blăgeşti",
                        "latitude": "46.14130000",
                        "longitude": "27.99695000"
                    },
                    {
                        "id": 91023,
                        "name": "Comuna Bogdana",
                        "latitude": "46.55124000",
                        "longitude": "27.61516000"
                    },
                    {
                        "id": 91027,
                        "name": "Comuna Bogdăneşti",
                        "latitude": "46.43700000",
                        "longitude": "27.72015000"
                    },
                    {
                        "id": 91029,
                        "name": "Comuna Bogdăniţa",
                        "latitude": "46.44752000",
                        "longitude": "27.67505000"
                    },
                    {
                        "id": 91070,
                        "name": "Comuna Boţeşti",
                        "latitude": "46.79630000",
                        "longitude": "27.88467000"
                    },
                    {
                        "id": 91166,
                        "name": "Comuna Bunești Averești",
                        "latitude": "46.79810000",
                        "longitude": "27.97722000"
                    },
                    {
                        "id": 91340,
                        "name": "Comuna Ciocani",
                        "latitude": "46.25393000",
                        "longitude": "27.56957000"
                    },
                    {
                        "id": 91392,
                        "name": "Comuna Codăeşti",
                        "latitude": "46.88029000",
                        "longitude": "27.75360000"
                    },
                    {
                        "id": 91447,
                        "name": "Comuna Coroieşti",
                        "latitude": "46.28891000",
                        "longitude": "27.49249000"
                    },
                    {
                        "id": 91454,
                        "name": "Comuna Costeşti",
                        "latitude": "46.47971000",
                        "longitude": "27.76360000"
                    },
                    {
                        "id": 91470,
                        "name": "Comuna Cozmeşti",
                        "latitude": "46.73024000",
                        "longitude": "27.49753000"
                    },
                    {
                        "id": 91493,
                        "name": "Comuna Creţeşti",
                        "latitude": "46.63508000",
                        "longitude": "27.96827000"
                    },
                    {
                        "id": 91738,
                        "name": "Comuna Dăneşti",
                        "latitude": "46.83967000",
                        "longitude": "27.65905000"
                    },
                    {
                        "id": 91610,
                        "name": "Comuna Deleni",
                        "latitude": "46.53486000",
                        "longitude": "27.75726000"
                    },
                    {
                        "id": 91612,
                        "name": "Comuna Deleşti",
                        "latitude": "46.69163000",
                        "longitude": "27.55152000"
                    },
                    {
                        "id": 91626,
                        "name": "Comuna Dimitrie Cantemir",
                        "latitude": "46.52932000",
                        "longitude": "28.05059000"
                    },
                    {
                        "id": 91650,
                        "name": "Comuna Dodeşti",
                        "latitude": "46.35165000",
                        "longitude": "27.91789000"
                    },
                    {
                        "id": 91672,
                        "name": "Comuna Dragomireşti",
                        "latitude": "46.61861000",
                        "longitude": "27.35794000"
                    },
                    {
                        "id": 91681,
                        "name": "Comuna Drânceni",
                        "latitude": "46.79614000",
                        "longitude": "28.12092000"
                    },
                    {
                        "id": 91705,
                        "name": "Comuna Duda  Epureni",
                        "latitude": "46.72477000",
                        "longitude": "28.04647000"
                    },
                    {
                        "id": 91721,
                        "name": "Comuna Dumeşti",
                        "latitude": "46.84347000",
                        "longitude": "27.30041000"
                    },
                    {
                        "id": 91748,
                        "name": "Comuna Epureni",
                        "latitude": "46.24228000",
                        "longitude": "27.89582000"
                    },
                    {
                        "id": 91820,
                        "name": "Comuna Fălciu",
                        "latitude": "46.29370000",
                        "longitude": "28.10324000"
                    },
                    {
                        "id": 91759,
                        "name": "Comuna Fereşti",
                        "latitude": "46.78179000",
                        "longitude": "27.70093000"
                    },
                    {
                        "id": 91790,
                        "name": "Comuna Fruntişeni",
                        "latitude": "46.19806000",
                        "longitude": "27.77368000"
                    },
                    {
                        "id": 91978,
                        "name": "Comuna Găgeşti",
                        "latitude": "46.33311000",
                        "longitude": "27.98026000"
                    },
                    {
                        "id": 91968,
                        "name": "Comuna Gârceni",
                        "latitude": "46.75136000",
                        "longitude": "27.27964000"
                    },
                    {
                        "id": 91846,
                        "name": "Comuna Ghergheşti",
                        "latitude": "46.52167000",
                        "longitude": "27.52404000"
                    },
                    {
                        "id": 91920,
                        "name": "Comuna Griviţa",
                        "latitude": "46.16827000",
                        "longitude": "27.68223000"
                    },
                    {
                        "id": 92004,
                        "name": "Comuna Hoceni",
                        "latitude": "46.54027000",
                        "longitude": "27.98196000"
                    },
                    {
                        "id": 92052,
                        "name": "Comuna Iana",
                        "latitude": "46.40438000",
                        "longitude": "27.55265000"
                    },
                    {
                        "id": 92057,
                        "name": "Comuna Ibăneşti",
                        "latitude": "46.40507000",
                        "longitude": "27.62043000"
                    },
                    {
                        "id": 92100,
                        "name": "Comuna Ivăneşti",
                        "latitude": "46.66216000",
                        "longitude": "27.44465000"
                    },
                    {
                        "id": 92099,
                        "name": "Comuna Iveşti",
                        "latitude": "46.19492000",
                        "longitude": "27.53670000"
                    },
                    {
                        "id": 92140,
                        "name": "Comuna Laza",
                        "latitude": "46.65239000",
                        "longitude": "27.59843000"
                    },
                    {
                        "id": 92169,
                        "name": "Comuna Lipovăţ",
                        "latitude": "46.56352000",
                        "longitude": "27.69270000"
                    },
                    {
                        "id": 92201,
                        "name": "Comuna Lunca Banului",
                        "latitude": "46.56640000",
                        "longitude": "28.19790000"
                    },
                    {
                        "id": 92400,
                        "name": "Comuna Măluşteni",
                        "latitude": "46.17587000",
                        "longitude": "27.91546000"
                    },
                    {
                        "id": 92267,
                        "name": "Comuna Micleşti",
                        "latitude": "46.82203000",
                        "longitude": "27.84215000"
                    },
                    {
                        "id": 92358,
                        "name": "Comuna Muntenii de Jos",
                        "latitude": "46.60405000",
                        "longitude": "27.76949000"
                    },
                    {
                        "id": 92359,
                        "name": "Comuna Muntenii de Sus",
                        "latitude": "46.69288000",
                        "longitude": "27.76320000"
                    },
                    {
                        "id": 92496,
                        "name": "Comuna Olteneşti",
                        "latitude": "46.58438000",
                        "longitude": "27.90180000"
                    },
                    {
                        "id": 92524,
                        "name": "Comuna Oşeşti",
                        "latitude": "46.76376000",
                        "longitude": "27.44832000"
                    },
                    {
                        "id": 92716,
                        "name": "Comuna Pădureni",
                        "latitude": "46.59285000",
                        "longitude": "28.09127000"
                    },
                    {
                        "id": 92550,
                        "name": "Comuna Perieni",
                        "latitude": "46.30407000",
                        "longitude": "27.61323000"
                    },
                    {
                        "id": 92609,
                        "name": "Comuna Pochidia",
                        "latitude": "46.05233000",
                        "longitude": "27.58450000"
                    },
                    {
                        "id": 92619,
                        "name": "Comuna Pogana",
                        "latitude": "46.33546000",
                        "longitude": "27.55360000"
                    },
                    {
                        "id": 92620,
                        "name": "Comuna Pogoneşti",
                        "latitude": "46.14748000",
                        "longitude": "27.52665000"
                    },
                    {
                        "id": 92639,
                        "name": "Comuna Poieneşti",
                        "latitude": "46.57978000",
                        "longitude": "27.54608000"
                    },
                    {
                        "id": 92694,
                        "name": "Comuna Puieşti",
                        "latitude": "46.44541000",
                        "longitude": "27.46214000"
                    },
                    {
                        "id": 92696,
                        "name": "Comuna Pungeşti",
                        "latitude": "46.70274000",
                        "longitude": "27.38157000"
                    },
                    {
                        "id": 92702,
                        "name": "Comuna Puşcaşi",
                        "latitude": "46.62530000",
                        "longitude": "27.62563000"
                    },
                    {
                        "id": 92745,
                        "name": "Comuna Rafaila",
                        "latitude": "46.80064000",
                        "longitude": "27.36236000"
                    },
                    {
                        "id": 92751,
                        "name": "Comuna Rebricea",
                        "latitude": "46.87229000",
                        "longitude": "27.57250000"
                    },
                    {
                        "id": 92800,
                        "name": "Comuna Roşieşti",
                        "latitude": "46.45107000",
                        "longitude": "27.89202000"
                    },
                    {
                        "id": 92973,
                        "name": "Comuna Soleşti",
                        "latitude": "46.77174000",
                        "longitude": "27.80613000"
                    },
                    {
                        "id": 93019,
                        "name": "Comuna Stănileşti",
                        "latitude": "46.65030000",
                        "longitude": "28.16151000"
                    },
                    {
                        "id": 93552,
                        "name": "Comuna Ştefan cel Mare",
                        "latitude": "46.71562000",
                        "longitude": "27.62941000"
                    },
                    {
                        "id": 93560,
                        "name": "Comuna Şuletea",
                        "latitude": "46.30607000",
                        "longitude": "27.90413000"
                    },
                    {
                        "id": 93236,
                        "name": "Comuna Tăcuta",
                        "latitude": "46.93630000",
                        "longitude": "27.66505000"
                    },
                    {
                        "id": 93123,
                        "name": "Comuna Tanacu",
                        "latitude": "46.68721000",
                        "longitude": "27.82443000"
                    },
                    {
                        "id": 93246,
                        "name": "Comuna Tătărăni",
                        "latitude": "46.70894000",
                        "longitude": "27.95602000"
                    },
                    {
                        "id": 93163,
                        "name": "Comuna Todireşti",
                        "latitude": "46.84897000",
                        "longitude": "27.38756000"
                    },
                    {
                        "id": 93219,
                        "name": "Comuna Tutova",
                        "latitude": "46.11223000",
                        "longitude": "27.57244000"
                    },
                    {
                        "id": 93449,
                        "name": "Comuna Vãleni",
                        "latitude": "46.73091000",
                        "longitude": "27.75925000"
                    },
                    {
                        "id": 93348,
                        "name": "Comuna Vetrişoaia",
                        "latitude": "46.45742000",
                        "longitude": "28.21799000"
                    },
                    {
                        "id": 93361,
                        "name": "Comuna Viişoara",
                        "latitude": "46.37992000",
                        "longitude": "27.86070000"
                    },
                    {
                        "id": 93364,
                        "name": "Comuna Vinderei",
                        "latitude": "46.14349000",
                        "longitude": "27.80566000"
                    },
                    {
                        "id": 93400,
                        "name": "Comuna Voineşti",
                        "latitude": "46.55578000",
                        "longitude": "27.43315000"
                    },
                    {
                        "id": 93420,
                        "name": "Comuna Vultureşti",
                        "latitude": "46.80254000",
                        "longitude": "27.53258000"
                    },
                    {
                        "id": 93425,
                        "name": "Comuna Vutcani",
                        "latitude": "46.44575000",
                        "longitude": "27.97366000"
                    },
                    {
                        "id": 93487,
                        "name": "Comuna Zăpodeni",
                        "latitude": "46.76642000",
                        "longitude": "27.64160000"
                    },
                    {
                        "id": 93479,
                        "name": "Comuna Zorleni",
                        "latitude": "46.25078000",
                        "longitude": "27.73866000"
                    },
                    {
                        "id": 93638,
                        "name": "Corni-Albești",
                        "latitude": "46.51813000",
                        "longitude": "27.87171000"
                    },
                    {
                        "id": 93648,
                        "name": "Coroieşti",
                        "latitude": "46.25000000",
                        "longitude": "27.48333000"
                    },
                    {
                        "id": 93660,
                        "name": "Costeşti",
                        "latitude": "46.50000000",
                        "longitude": "27.75000000"
                    },
                    {
                        "id": 93687,
                        "name": "Cozmești",
                        "latitude": "46.73375000",
                        "longitude": "27.50164000"
                    },
                    {
                        "id": 93715,
                        "name": "Crețești",
                        "latitude": "46.63333000",
                        "longitude": "27.95000000"
                    },
                    {
                        "id": 94126,
                        "name": "Dăneşti",
                        "latitude": "46.85000000",
                        "longitude": "27.66667000"
                    },
                    {
                        "id": 93914,
                        "name": "Deleni",
                        "latitude": "46.55000000",
                        "longitude": "27.75000000"
                    },
                    {
                        "id": 93917,
                        "name": "Deleşti",
                        "latitude": "46.70000000",
                        "longitude": "27.55000000"
                    },
                    {
                        "id": 93977,
                        "name": "Dodești",
                        "latitude": "46.35455000",
                        "longitude": "27.89311000"
                    },
                    {
                        "id": 94017,
                        "name": "Dragomireşti",
                        "latitude": "46.63333000",
                        "longitude": "27.35000000"
                    },
                    {
                        "id": 94033,
                        "name": "Drânceni",
                        "latitude": "46.80146000",
                        "longitude": "28.13264000"
                    },
                    {
                        "id": 94067,
                        "name": "Duda",
                        "latitude": "46.75250000",
                        "longitude": "28.03722000"
                    },
                    {
                        "id": 94095,
                        "name": "Dumeşti",
                        "latitude": "46.85000000",
                        "longitude": "27.28333000"
                    },
                    {
                        "id": 94141,
                        "name": "Emil Racoviță",
                        "latitude": "46.87147000",
                        "longitude": "27.67937000"
                    },
                    {
                        "id": 94143,
                        "name": "Epureni",
                        "latitude": "46.70769000",
                        "longitude": "28.03829000"
                    },
                    {
                        "id": 94257,
                        "name": "Fălciu",
                        "latitude": "46.29611000",
                        "longitude": "28.14083000"
                    },
                    {
                        "id": 94247,
                        "name": "Fâstâci",
                        "latitude": "46.73058000",
                        "longitude": "27.44901000"
                    },
                    {
                        "id": 94159,
                        "name": "Ferești",
                        "latitude": "46.78179000",
                        "longitude": "27.70093000"
                    },
                    {
                        "id": 94215,
                        "name": "Fruntișeni",
                        "latitude": "46.20634000",
                        "longitude": "27.76904000"
                    },
                    {
                        "id": 94498,
                        "name": "Găgeşti",
                        "latitude": "46.33333000",
                        "longitude": "27.96667000"
                    },
                    {
                        "id": 94486,
                        "name": "Gârceni",
                        "latitude": "46.76667000",
                        "longitude": "27.28333000"
                    },
                    {
                        "id": 94306,
                        "name": "Ghergheşti",
                        "latitude": "46.50000000",
                        "longitude": "27.51667000"
                    },
                    {
                        "id": 94310,
                        "name": "Ghermănești",
                        "latitude": "46.82998000",
                        "longitude": "28.08105000"
                    },
                    {
                        "id": 94416,
                        "name": "Griviţa",
                        "latitude": "46.15000000",
                        "longitude": "27.65000000"
                    },
                    {
                        "id": 94447,
                        "name": "Gugești",
                        "latitude": "46.76342000",
                        "longitude": "27.90050000"
                    },
                    {
                        "id": 94601,
                        "name": "Hălărești",
                        "latitude": "46.39447000",
                        "longitude": "27.55614000"
                    },
                    {
                        "id": 94540,
                        "name": "Hoceni",
                        "latitude": "46.53917000",
                        "longitude": "28.00667000"
                    },
                    {
                        "id": 94580,
                        "name": "Hurdugi",
                        "latitude": "46.50778000",
                        "longitude": "28.05472000"
                    },
                    {
                        "id": 94587,
                        "name": "Huşi",
                        "latitude": "46.67361000",
                        "longitude": "28.05944000"
                    },
                    {
                        "id": 94618,
                        "name": "Iana",
                        "latitude": "46.38333000",
                        "longitude": "27.55000000"
                    },
                    {
                        "id": 94633,
                        "name": "Ibănești",
                        "latitude": "46.39482000",
                        "longitude": "27.62548000"
                    },
                    {
                        "id": 94698,
                        "name": "Ivănești",
                        "latitude": "46.63481000",
                        "longitude": "27.46048000"
                    },
                    {
                        "id": 94697,
                        "name": "Iveşti",
                        "latitude": "46.18333000",
                        "longitude": "27.53333000"
                    },
                    {
                        "id": 94764,
                        "name": "Laza",
                        "latitude": "46.65000000",
                        "longitude": "27.58333000"
                    },
                    {
                        "id": 94806,
                        "name": "Lipovăţ",
                        "latitude": "46.56667000",
                        "longitude": "27.70000000"
                    },
                    {
                        "id": 94861,
                        "name": "Lunca Banului",
                        "latitude": "46.59500000",
                        "longitude": "28.16833000"
                    },
                    {
                        "id": 95255,
                        "name": "Măluşteni",
                        "latitude": "46.18333000",
                        "longitude": "27.91667000"
                    },
                    {
                        "id": 94969,
                        "name": "Micleşti",
                        "latitude": "46.81667000",
                        "longitude": "27.83333000"
                    },
                    {
                        "id": 95040,
                        "name": "Moara Domnească",
                        "latitude": "46.71448000",
                        "longitude": "27.75890000"
                    },
                    {
                        "id": 95041,
                        "name": "Moara Grecilor",
                        "latitude": "46.67145000",
                        "longitude": "27.74569000"
                    },
                    {
                        "id": 95120,
                        "name": "Municipiul Bârlad",
                        "latitude": "46.22579000",
                        "longitude": "27.67070000"
                    },
                    {
                        "id": 95149,
                        "name": "Municipiul Huşi",
                        "latitude": "46.67320000",
                        "longitude": "28.05952000"
                    },
                    {
                        "id": 95195,
                        "name": "Municipiul Vaslui",
                        "latitude": "46.64683000",
                        "longitude": "27.73872000"
                    },
                    {
                        "id": 95202,
                        "name": "Muntenii de Jos",
                        "latitude": "46.61667000",
                        "longitude": "27.76667000"
                    },
                    {
                        "id": 95203,
                        "name": "Muntenii de Sus",
                        "latitude": "46.68968000",
                        "longitude": "27.77763000"
                    },
                    {
                        "id": 95206,
                        "name": "Murgeni",
                        "latitude": "46.20444000",
                        "longitude": "28.01972000"
                    },
                    {
                        "id": 95316,
                        "name": "Negreşti",
                        "latitude": "46.83333000",
                        "longitude": "27.43333000"
                    },
                    {
                        "id": 95430,
                        "name": "Olteneşti",
                        "latitude": "46.58333000",
                        "longitude": "27.90000000"
                    },
                    {
                        "id": 95643,
                        "name": "Oraș Murgeni",
                        "latitude": "46.20160000",
                        "longitude": "28.00424000"
                    },
                    {
                        "id": 95548,
                        "name": "Oraş Negreşti",
                        "latitude": "46.83188000",
                        "longitude": "27.47810000"
                    },
                    {
                        "id": 95688,
                        "name": "Oşeşti",
                        "latitude": "46.76667000",
                        "longitude": "27.46667000"
                    },
                    {
                        "id": 96007,
                        "name": "Pădureni",
                        "latitude": "46.62192000",
                        "longitude": "28.08258000"
                    },
                    {
                        "id": 95731,
                        "name": "Perieni",
                        "latitude": "46.30000000",
                        "longitude": "27.61667000"
                    },
                    {
                        "id": 95838,
                        "name": "Pochidia",
                        "latitude": "46.04318000",
                        "longitude": "27.58746000"
                    },
                    {
                        "id": 95854,
                        "name": "Pogana",
                        "latitude": "46.31667000",
                        "longitude": "27.56667000"
                    },
                    {
                        "id": 95858,
                        "name": "Pogănești",
                        "latitude": "46.69237000",
                        "longitude": "28.16779000"
                    },
                    {
                        "id": 95857,
                        "name": "Pogonești",
                        "latitude": "46.15229000",
                        "longitude": "27.53225000"
                    },
                    {
                        "id": 95889,
                        "name": "Poieneşti",
                        "latitude": "46.61667000",
                        "longitude": "27.53333000"
                    },
                    {
                        "id": 95907,
                        "name": "Popeni",
                        "latitude": "46.24667000",
                        "longitude": "27.80520000"
                    },
                    {
                        "id": 95947,
                        "name": "Pribești",
                        "latitude": "46.91001000",
                        "longitude": "27.79659000"
                    },
                    {
                        "id": 95979,
                        "name": "Puieşti",
                        "latitude": "46.41667000",
                        "longitude": "27.50000000"
                    },
                    {
                        "id": 95981,
                        "name": "Pungeşti",
                        "latitude": "46.70000000",
                        "longitude": "27.33333000"
                    },
                    {
                        "id": 95991,
                        "name": "Pușcași",
                        "latitude": "46.62154000",
                        "longitude": "27.64503000"
                    },
                    {
                        "id": 96057,
                        "name": "Rafaila",
                        "latitude": "46.80064000",
                        "longitude": "27.36236000"
                    },
                    {
                        "id": 96173,
                        "name": "Rânzești",
                        "latitude": "46.22101000",
                        "longitude": "28.09468000"
                    },
                    {
                        "id": 96180,
                        "name": "Râșești",
                        "latitude": "46.77219000",
                        "longitude": "28.14273000"
                    },
                    {
                        "id": 96065,
                        "name": "Rebricea",
                        "latitude": "46.86667000",
                        "longitude": "27.55000000"
                    },
                    {
                        "id": 96077,
                        "name": "Rediu",
                        "latitude": "46.63374000",
                        "longitude": "27.69439000"
                    },
                    {
                        "id": 96130,
                        "name": "Roşieşti",
                        "latitude": "46.43333000",
                        "longitude": "27.88333000"
                    },
                    {
                        "id": 96258,
                        "name": "Satu Nou",
                        "latitude": "46.69608000",
                        "longitude": "27.74876000"
                    },
                    {
                        "id": 96263,
                        "name": "Sauca",
                        "latitude": "46.65268000",
                        "longitude": "27.60523000"
                    },
                    {
                        "id": 96405,
                        "name": "Soleşti",
                        "latitude": "46.76667000",
                        "longitude": "27.78333000"
                    },
                    {
                        "id": 96480,
                        "name": "Stănileşti",
                        "latitude": "46.61833000",
                        "longitude": "28.17139000"
                    },
                    {
                        "id": 97081,
                        "name": "Ştefan cel Mare",
                        "latitude": "46.71668000",
                        "longitude": "27.62873000"
                    },
                    {
                        "id": 97092,
                        "name": "Şuletea",
                        "latitude": "46.28333000",
                        "longitude": "27.90000000"
                    },
                    {
                        "id": 96600,
                        "name": "Tăcuta",
                        "latitude": "46.91667000",
                        "longitude": "27.68333000"
                    },
                    {
                        "id": 106057,
                        "name": "Tanacu",
                        "latitude": "46.68333000",
                        "longitude": "27.81667000"
                    },
                    {
                        "id": 96621,
                        "name": "Tătărăni",
                        "latitude": "46.69422000",
                        "longitude": "27.96443000"
                    },
                    {
                        "id": 106117,
                        "name": "Todireşti",
                        "latitude": "46.85000000",
                        "longitude": "27.36667000"
                    },
                    {
                        "id": 106152,
                        "name": "Trestiana",
                        "latitude": "46.20000000",
                        "longitude": "27.65000000"
                    },
                    {
                        "id": 96572,
                        "name": "Tutova",
                        "latitude": "46.11667000",
                        "longitude": "27.55000000"
                    },
                    {
                        "id": 96725,
                        "name": "Valea Grecului",
                        "latitude": "46.71985000",
                        "longitude": "28.10123000"
                    },
                    {
                        "id": 96962,
                        "name": "Văleni",
                        "latitude": "46.59278000",
                        "longitude": "28.06250000"
                    },
                    {
                        "id": 96776,
                        "name": "Vaslui",
                        "latitude": "46.63333000",
                        "longitude": "27.73333000"
                    },
                    {
                        "id": 96796,
                        "name": "Vetrişoaia",
                        "latitude": "46.43000000",
                        "longitude": "28.20833000"
                    },
                    {
                        "id": 96819,
                        "name": "Viişoara",
                        "latitude": "46.38333000",
                        "longitude": "27.88333000"
                    },
                    {
                        "id": 96830,
                        "name": "Vinderei",
                        "latitude": "46.15000000",
                        "longitude": "27.80000000"
                    },
                    {
                        "id": 96880,
                        "name": "Voineşti",
                        "latitude": "46.56667000",
                        "longitude": "27.41667000"
                    },
                    {
                        "id": 96910,
                        "name": "Vultureşti",
                        "latitude": "46.81667000",
                        "longitude": "27.53333000"
                    },
                    {
                        "id": 96917,
                        "name": "Vutcani",
                        "latitude": "46.46667000",
                        "longitude": "27.96667000"
                    },
                    {
                        "id": 97013,
                        "name": "Zăpodeni",
                        "latitude": "46.75000000",
                        "longitude": "27.65000000"
                    },
                    {
                        "id": 97004,
                        "name": "Zorleni",
                        "latitude": "46.26667000",
                        "longitude": "27.71667000"
                    }
                ]
            },
            {
                "id": 4758,
                "name": "Vrancea",
                "iso2": "VN",
                "latitude": "45.81348760",
                "longitude": "27.06575310",
                "type": "department",
                "cities": [
                    {
                        "id": 89881,
                        "name": "Adjud",
                        "latitude": "46.10000000",
                        "longitude": "27.16667000"
                    },
                    {
                        "id": 89883,
                        "name": "Adjudu Vechi",
                        "latitude": "46.13485000",
                        "longitude": "27.18891000"
                    },
                    {
                        "id": 89956,
                        "name": "Andreiaşu de Jos",
                        "latitude": "45.75000000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 89960,
                        "name": "Anghelești",
                        "latitude": "46.07875000",
                        "longitude": "27.06459000"
                    },
                    {
                        "id": 90511,
                        "name": "Băleşti",
                        "latitude": "45.43333000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 90456,
                        "name": "Bârseşti",
                        "latitude": "45.91667000",
                        "longitude": "26.73333000"
                    },
                    {
                        "id": 90138,
                        "name": "Biliești",
                        "latitude": "45.72106000",
                        "longitude": "27.34879000"
                    },
                    {
                        "id": 90197,
                        "name": "Bogheşti",
                        "latitude": "46.16667000",
                        "longitude": "27.40000000"
                    },
                    {
                        "id": 90200,
                        "name": "Bogza",
                        "latitude": "45.50798000",
                        "longitude": "27.19773000"
                    },
                    {
                        "id": 90215,
                        "name": "Boloteşti",
                        "latitude": "45.83333000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 90223,
                        "name": "Bordeasca Veche",
                        "latitude": "45.54447000",
                        "longitude": "27.31730000"
                    },
                    {
                        "id": 90226,
                        "name": "Bordeşti",
                        "latitude": "45.55000000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 90309,
                        "name": "Broşteni",
                        "latitude": "45.75000000",
                        "longitude": "27.03333000"
                    },
                    {
                        "id": 90385,
                        "name": "Budești",
                        "latitude": "45.62779000",
                        "longitude": "27.05669000"
                    },
                    {
                        "id": 90415,
                        "name": "Burca",
                        "latitude": "45.91224000",
                        "longitude": "26.94905000"
                    },
                    {
                        "id": 93799,
                        "name": "Câmpineanca",
                        "latitude": "45.71166000",
                        "longitude": "27.12832000"
                    },
                    {
                        "id": 93804,
                        "name": "Câmpuri",
                        "latitude": "46.01535000",
                        "longitude": "26.78802000"
                    },
                    {
                        "id": 93805,
                        "name": "Câmpurile de Jos",
                        "latitude": "46.01667000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 93814,
                        "name": "Cârligele",
                        "latitude": "45.68333000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 90603,
                        "name": "Ceardac",
                        "latitude": "45.66967000",
                        "longitude": "27.16611000"
                    },
                    {
                        "id": 90673,
                        "name": "Chiojdeni",
                        "latitude": "45.55000000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 90722,
                        "name": "Ciorani",
                        "latitude": "45.98824000",
                        "longitude": "27.21614000"
                    },
                    {
                        "id": 90729,
                        "name": "Ciorăşti",
                        "latitude": "45.43333000",
                        "longitude": "27.30000000"
                    },
                    {
                        "id": 90761,
                        "name": "Ciușlea",
                        "latitude": "45.78761000",
                        "longitude": "27.30644000"
                    },
                    {
                        "id": 90868,
                        "name": "Comuna Andreiaşu de Jos",
                        "latitude": "45.73669000",
                        "longitude": "26.82752000"
                    },
                    {
                        "id": 91215,
                        "name": "Comuna Băleşti",
                        "latitude": "45.44034000",
                        "longitude": "27.23703000"
                    },
                    {
                        "id": 91193,
                        "name": "Comuna Bârseşti",
                        "latitude": "45.90724000",
                        "longitude": "26.74716000"
                    },
                    {
                        "id": 90991,
                        "name": "Comuna Bilieşti",
                        "latitude": "45.72106000",
                        "longitude": "27.34879000"
                    },
                    {
                        "id": 91030,
                        "name": "Comuna Bogheşti",
                        "latitude": "46.16211000",
                        "longitude": "27.41871000"
                    },
                    {
                        "id": 91042,
                        "name": "Comuna Boloteşti",
                        "latitude": "45.84099000",
                        "longitude": "27.04117000"
                    },
                    {
                        "id": 91048,
                        "name": "Comuna Bordeşti",
                        "latitude": "45.54715000",
                        "longitude": "27.04104000"
                    },
                    {
                        "id": 91104,
                        "name": "Comuna Broşteni",
                        "latitude": "45.76566000",
                        "longitude": "27.01305000"
                    },
                    {
                        "id": 91543,
                        "name": "Comuna Câmpineanca",
                        "latitude": "45.70838000",
                        "longitude": "27.13191000"
                    },
                    {
                        "id": 91545,
                        "name": "Comuna Câmpuri",
                        "latitude": "46.03618000",
                        "longitude": "26.75425000"
                    },
                    {
                        "id": 91552,
                        "name": "Comuna Cârligele",
                        "latitude": "45.67723000",
                        "longitude": "27.06031000"
                    },
                    {
                        "id": 91319,
                        "name": "Comuna Chiojdeni",
                        "latitude": "45.56113000",
                        "longitude": "26.84389000"
                    },
                    {
                        "id": 91357,
                        "name": "Comuna Ciorăşti",
                        "latitude": "45.43869000",
                        "longitude": "27.30952000"
                    },
                    {
                        "id": 91427,
                        "name": "Comuna Corbiţa",
                        "latitude": "46.16325000",
                        "longitude": "27.30861000"
                    },
                    {
                        "id": 91464,
                        "name": "Comuna Coteşti",
                        "latitude": "45.63689000",
                        "longitude": "27.07546000"
                    },
                    {
                        "id": 93584,
                        "name": "Comună Dumbrăveni",
                        "latitude": "45.55416000",
                        "longitude": "27.09037000"
                    },
                    {
                        "id": 91723,
                        "name": "Comuna Dumitreşti",
                        "latitude": "45.57715000",
                        "longitude": "26.90728000"
                    },
                    {
                        "id": 91768,
                        "name": "Comuna Fitioneşti",
                        "latitude": "45.96655000",
                        "longitude": "27.06953000"
                    },
                    {
                        "id": 91833,
                        "name": "Comuna Garoafa",
                        "latitude": "45.79812000",
                        "longitude": "27.25010000"
                    },
                    {
                        "id": 91896,
                        "name": "Comuna Goleşti",
                        "latitude": "45.66603000",
                        "longitude": "27.16708000"
                    },
                    {
                        "id": 91898,
                        "name": "Comuna Gologanu",
                        "latitude": "45.60979000",
                        "longitude": "27.27091000"
                    },
                    {
                        "id": 91945,
                        "name": "Comuna Gugeşti",
                        "latitude": "45.57982000",
                        "longitude": "27.14370000"
                    },
                    {
                        "id": 91946,
                        "name": "Comuna Gura Caliţei",
                        "latitude": "45.61357000",
                        "longitude": "26.97284000"
                    },
                    {
                        "id": 92011,
                        "name": "Comuna Homocea",
                        "latitude": "46.15796000",
                        "longitude": "27.23108000"
                    },
                    {
                        "id": 92115,
                        "name": "Comuna Jariştea",
                        "latitude": "45.79987000",
                        "longitude": "27.04257000"
                    },
                    {
                        "id": 92127,
                        "name": "Comuna Jitia",
                        "latitude": "45.58480000",
                        "longitude": "26.74876000"
                    },
                    {
                        "id": 92394,
                        "name": "Comuna Măicăneşti",
                        "latitude": "45.50067000",
                        "longitude": "27.46121000"
                    },
                    {
                        "id": 92254,
                        "name": "Comuna Mera",
                        "latitude": "45.77327000",
                        "longitude": "26.93423000"
                    },
                    {
                        "id": 92290,
                        "name": "Comuna Milcovul",
                        "latitude": "45.65207000",
                        "longitude": "27.25928000"
                    },
                    {
                        "id": 92344,
                        "name": "Comuna Moviliţa",
                        "latitude": "45.95750000",
                        "longitude": "27.10487000"
                    },
                    {
                        "id": 92463,
                        "name": "Comuna Năneşti",
                        "latitude": "45.57801000",
                        "longitude": "27.49988000"
                    },
                    {
                        "id": 92465,
                        "name": "Comuna Năruja",
                        "latitude": "45.82308000",
                        "longitude": "26.76617000"
                    },
                    {
                        "id": 92435,
                        "name": "Comuna Negrileşti",
                        "latitude": "45.93697000",
                        "longitude": "26.70635000"
                    },
                    {
                        "id": 92438,
                        "name": "Comuna Nereju",
                        "latitude": "45.70833000",
                        "longitude": "26.69794000"
                    },
                    {
                        "id": 92449,
                        "name": "Comuna Nistoreşti",
                        "latitude": "45.81578000",
                        "longitude": "26.67728000"
                    },
                    {
                        "id": 92472,
                        "name": "Comuna Obrejiţa",
                        "latitude": "45.50102000",
                        "longitude": "27.08974000"
                    },
                    {
                        "id": 92532,
                        "name": "Comuna Paltin",
                        "latitude": "45.77918000",
                        "longitude": "26.74770000"
                    },
                    {
                        "id": 92726,
                        "name": "Comuna Păuleşti",
                        "latitude": "45.88712000",
                        "longitude": "26.68703000"
                    },
                    {
                        "id": 92729,
                        "name": "Comuna Păuneşti",
                        "latitude": "46.04066000",
                        "longitude": "27.10336000"
                    },
                    {
                        "id": 92603,
                        "name": "Comuna Ploscuţeni",
                        "latitude": "46.06103000",
                        "longitude": "27.26595000"
                    },
                    {
                        "id": 92626,
                        "name": "Comuna Poiana Cristei",
                        "latitude": "45.66882000",
                        "longitude": "26.97125000"
                    },
                    {
                        "id": 92655,
                        "name": "Comuna Popeşti",
                        "latitude": "45.58983000",
                        "longitude": "27.06560000"
                    },
                    {
                        "id": 92692,
                        "name": "Comuna Pufeşti",
                        "latitude": "46.01111000",
                        "longitude": "27.20901000"
                    },
                    {
                        "id": 92839,
                        "name": "Comuna Răcoasa",
                        "latitude": "45.99786000",
                        "longitude": "26.88548000"
                    },
                    {
                        "id": 92849,
                        "name": "Comuna Răstoaca",
                        "latitude": "45.66083000",
                        "longitude": "27.28723000"
                    },
                    {
                        "id": 92762,
                        "name": "Comuna Reghiu",
                        "latitude": "45.79672000",
                        "longitude": "26.83648000"
                    },
                    {
                        "id": 92807,
                        "name": "Comuna Rugineşti",
                        "latitude": "46.07885000",
                        "longitude": "27.11803000"
                    },
                    {
                        "id": 92928,
                        "name": "Comuna Sihlea",
                        "latitude": "45.49398000",
                        "longitude": "27.15629000"
                    },
                    {
                        "id": 92955,
                        "name": "Comuna Slobozia Bradului",
                        "latitude": "45.49203000",
                        "longitude": "27.03977000"
                    },
                    {
                        "id": 92958,
                        "name": "Comuna Slobozia-Ciorăşti",
                        "latitude": "45.60606000",
                        "longitude": "27.21399000"
                    },
                    {
                        "id": 92979,
                        "name": "Comuna Soveja",
                        "latitude": "45.99705000",
                        "longitude": "26.65351000"
                    },
                    {
                        "id": 92985,
                        "name": "Comuna Spulber",
                        "latitude": "45.74654000",
                        "longitude": "26.73925000"
                    },
                    {
                        "id": 93009,
                        "name": "Comuna Străoane",
                        "latitude": "45.92895000",
                        "longitude": "27.04359000"
                    },
                    {
                        "id": 93035,
                        "name": "Comuna Suraia",
                        "latitude": "45.68066000",
                        "longitude": "27.38419000"
                    },
                    {
                        "id": 93222,
                        "name": "Comuna Tâmboeşti",
                        "latitude": "45.51792000",
                        "longitude": "27.04555000"
                    },
                    {
                        "id": 93238,
                        "name": "Comuna Tănăsoaia",
                        "latitude": "46.10161000",
                        "longitude": "27.37982000"
                    },
                    {
                        "id": 93235,
                        "name": "Comuna Tãtãranu",
                        "latitude": "45.51621000",
                        "longitude": "27.30930000"
                    },
                    {
                        "id": 93573,
                        "name": "Comuna Ţifeşti",
                        "latitude": "45.85329000",
                        "longitude": "27.10387000"
                    },
                    {
                        "id": 93205,
                        "name": "Comuna Tulnici",
                        "latitude": "45.93283000",
                        "longitude": "26.60452000"
                    },
                    {
                        "id": 93281,
                        "name": "Comuna Urecheşti",
                        "latitude": "45.60181000",
                        "longitude": "27.07141000"
                    },
                    {
                        "id": 93325,
                        "name": "Comuna Valea Sării",
                        "latitude": "45.87892000",
                        "longitude": "26.80823000"
                    },
                    {
                        "id": 93435,
                        "name": "Comuna Vânători",
                        "latitude": "45.73875000",
                        "longitude": "27.26951000"
                    },
                    {
                        "id": 93444,
                        "name": "Comuna Vârteşcoiu",
                        "latitude": "45.72465000",
                        "longitude": "27.06471000"
                    },
                    {
                        "id": 93356,
                        "name": "Comuna Vidra",
                        "latitude": "45.91420000",
                        "longitude": "26.90506000"
                    },
                    {
                        "id": 93366,
                        "name": "Comuna Vintileasca",
                        "latitude": "45.62970000",
                        "longitude": "26.72608000"
                    },
                    {
                        "id": 93372,
                        "name": "Comuna Vizantea-Livezi",
                        "latitude": "45.96233000",
                        "longitude": "26.81347000"
                    },
                    {
                        "id": 93411,
                        "name": "Comuna Vrâncioaia",
                        "latitude": "45.87169000",
                        "longitude": "26.70971000"
                    },
                    {
                        "id": 93422,
                        "name": "Comuna Vulturu",
                        "latitude": "45.60783000",
                        "longitude": "27.42281000"
                    },
                    {
                        "id": 93616,
                        "name": "Corbiţa",
                        "latitude": "46.15000000",
                        "longitude": "27.30000000"
                    },
                    {
                        "id": 93632,
                        "name": "Cornetu",
                        "latitude": "45.50456000",
                        "longitude": "27.05305000"
                    },
                    {
                        "id": 93674,
                        "name": "Coteşti",
                        "latitude": "45.65000000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 93992,
                        "name": "Domnești-Târg",
                        "latitude": "46.01667000",
                        "longitude": "27.18333000"
                    },
                    {
                        "id": 94022,
                        "name": "Dragosloveni",
                        "latitude": "46.00000000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 94086,
                        "name": "Dumbrăveni",
                        "latitude": "45.53333000",
                        "longitude": "27.11667000"
                    },
                    {
                        "id": 94099,
                        "name": "Dumitrești",
                        "latitude": "45.55243000",
                        "longitude": "26.92727000"
                    },
                    {
                        "id": 94180,
                        "name": "Fitioneşti",
                        "latitude": "45.98333000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 94193,
                        "name": "Focșani",
                        "latitude": "45.70000000",
                        "longitude": "27.18333000"
                    },
                    {
                        "id": 94499,
                        "name": "Găgești",
                        "latitude": "45.85598000",
                        "longitude": "27.05540000"
                    },
                    {
                        "id": 94282,
                        "name": "Garoafa",
                        "latitude": "45.78333000",
                        "longitude": "27.20000000"
                    },
                    {
                        "id": 94377,
                        "name": "Goleşti",
                        "latitude": "45.66667000",
                        "longitude": "27.13333000"
                    },
                    {
                        "id": 94379,
                        "name": "Gologanu",
                        "latitude": "45.60979000",
                        "longitude": "27.27091000"
                    },
                    {
                        "id": 94446,
                        "name": "Gugeşti",
                        "latitude": "45.56667000",
                        "longitude": "27.13333000"
                    },
                    {
                        "id": 94451,
                        "name": "Gura Caliţei",
                        "latitude": "45.58333000",
                        "longitude": "27.01667000"
                    },
                    {
                        "id": 94552,
                        "name": "Homocea",
                        "latitude": "46.13333000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 94646,
                        "name": "Igești",
                        "latitude": "45.82043000",
                        "longitude": "27.18253000"
                    },
                    {
                        "id": 94687,
                        "name": "Irești",
                        "latitude": "45.92993000",
                        "longitude": "26.94393000"
                    },
                    {
                        "id": 94723,
                        "name": "Jariştea",
                        "latitude": "45.78333000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 94742,
                        "name": "Jitia",
                        "latitude": "45.58333000",
                        "longitude": "26.71667000"
                    },
                    {
                        "id": 94747,
                        "name": "Jorăști",
                        "latitude": "45.71477000",
                        "longitude": "27.26335000"
                    },
                    {
                        "id": 94783,
                        "name": "Lespezi",
                        "latitude": "46.16027000",
                        "longitude": "27.24065000"
                    },
                    {
                        "id": 95248,
                        "name": "Măicăneşti",
                        "latitude": "45.50000000",
                        "longitude": "27.50000000"
                    },
                    {
                        "id": 95286,
                        "name": "Mărășești",
                        "latitude": "45.88333000",
                        "longitude": "27.23333000"
                    },
                    {
                        "id": 95289,
                        "name": "Mătăcina",
                        "latitude": "45.88333000",
                        "longitude": "26.80000000"
                    },
                    {
                        "id": 94949,
                        "name": "Mera",
                        "latitude": "45.76667000",
                        "longitude": "26.95000000"
                    },
                    {
                        "id": 94996,
                        "name": "Mihălceni",
                        "latitude": "45.44493000",
                        "longitude": "27.30466000"
                    },
                    {
                        "id": 95002,
                        "name": "Milcovul",
                        "latitude": "45.65000000",
                        "longitude": "27.25000000"
                    },
                    {
                        "id": 95015,
                        "name": "Mirceștii Noi",
                        "latitude": "45.75072000",
                        "longitude": "27.27260000"
                    },
                    {
                        "id": 95085,
                        "name": "Moviliţa",
                        "latitude": "45.95000000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 95101,
                        "name": "Municipiul  Adjud",
                        "latitude": "46.11464000",
                        "longitude": "27.19284000"
                    },
                    {
                        "id": 95141,
                        "name": "Municipiul Focşani",
                        "latitude": "45.69004000",
                        "longitude": "27.22774000"
                    },
                    {
                        "id": 95372,
                        "name": "Năneşti",
                        "latitude": "45.55000000",
                        "longitude": "27.50000000"
                    },
                    {
                        "id": 95374,
                        "name": "Năruja",
                        "latitude": "45.83333000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 95321,
                        "name": "Negrilești",
                        "latitude": "45.93697000",
                        "longitude": "26.70635000"
                    },
                    {
                        "id": 95329,
                        "name": "Nereju",
                        "latitude": "45.71667000",
                        "longitude": "26.71667000"
                    },
                    {
                        "id": 95330,
                        "name": "Nereju Mic",
                        "latitude": "45.70618000",
                        "longitude": "26.69641000"
                    },
                    {
                        "id": 95350,
                        "name": "Nistoreşti",
                        "latitude": "45.83333000",
                        "longitude": "26.73333000"
                    },
                    {
                        "id": 95388,
                        "name": "Obrejița",
                        "latitude": "45.50102000",
                        "longitude": "27.08974000"
                    },
                    {
                        "id": 95407,
                        "name": "Odobeşti",
                        "latitude": "45.76667000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 95427,
                        "name": "Oleșești",
                        "latitude": "45.84781000",
                        "longitude": "27.10097000"
                    },
                    {
                        "id": 95547,
                        "name": "Oraş Mãrãşeşti",
                        "latitude": "45.90446000",
                        "longitude": "27.22305000"
                    },
                    {
                        "id": 95559,
                        "name": "Oraş Odobeşti",
                        "latitude": "45.75011000",
                        "longitude": "27.08754000"
                    },
                    {
                        "id": 95564,
                        "name": "Oraş Panciu",
                        "latitude": "45.90661000",
                        "longitude": "27.09358000"
                    },
                    {
                        "id": 95702,
                        "name": "Paltin",
                        "latitude": "45.78333000",
                        "longitude": "26.71667000"
                    },
                    {
                        "id": 95704,
                        "name": "Panciu",
                        "latitude": "45.90000000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 96031,
                        "name": "Păulești",
                        "latitude": "45.89154000",
                        "longitude": "26.68914000"
                    },
                    {
                        "id": 96033,
                        "name": "Păuneşti",
                        "latitude": "46.03333000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 95829,
                        "name": "Ploscuțeni",
                        "latitude": "46.07859000",
                        "longitude": "27.27032000"
                    },
                    {
                        "id": 95871,
                        "name": "Poiana Cristei",
                        "latitude": "45.65000000",
                        "longitude": "26.98333000"
                    },
                    {
                        "id": 95914,
                        "name": "Popești",
                        "latitude": "45.59533000",
                        "longitude": "27.07916000"
                    },
                    {
                        "id": 95976,
                        "name": "Pufeşti",
                        "latitude": "46.00000000",
                        "longitude": "27.20000000"
                    },
                    {
                        "id": 96189,
                        "name": "Răcoasa",
                        "latitude": "46.00000000",
                        "longitude": "26.88333000"
                    },
                    {
                        "id": 96169,
                        "name": "Râmniceni",
                        "latitude": "45.51322000",
                        "longitude": "27.44843000"
                    },
                    {
                        "id": 96208,
                        "name": "Răstoaca",
                        "latitude": "45.66083000",
                        "longitude": "27.28723000"
                    },
                    {
                        "id": 96080,
                        "name": "Reghiu",
                        "latitude": "45.78333000",
                        "longitude": "26.83333000"
                    },
                    {
                        "id": 96145,
                        "name": "Rucăreni",
                        "latitude": "45.99438000",
                        "longitude": "26.65496000"
                    },
                    {
                        "id": 96147,
                        "name": "Rugineşti",
                        "latitude": "46.06667000",
                        "longitude": "27.11667000"
                    },
                    {
                        "id": 96337,
                        "name": "Sihlea",
                        "latitude": "45.50000000",
                        "longitude": "27.11667000"
                    },
                    {
                        "id": 97127,
                        "name": "Șindrilari",
                        "latitude": "45.79083000",
                        "longitude": "26.87947000"
                    },
                    {
                        "id": 96374,
                        "name": "Slobozia Bradului",
                        "latitude": "45.50000000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 96378,
                        "name": "Slobozia-Câmpineanca",
                        "latitude": "45.70000000",
                        "longitude": "27.13333000"
                    },
                    {
                        "id": 96377,
                        "name": "Slobozia-Ciorăşti",
                        "latitude": "45.61667000",
                        "longitude": "27.20000000"
                    },
                    {
                        "id": 96419,
                        "name": "Spulber",
                        "latitude": "45.75186000",
                        "longitude": "26.76080000"
                    },
                    {
                        "id": 96463,
                        "name": "Străoane",
                        "latitude": "45.93333000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 96504,
                        "name": "Suraia",
                        "latitude": "45.68333000",
                        "longitude": "27.40000000"
                    },
                    {
                        "id": 96576,
                        "name": "Tâmboeşti",
                        "latitude": "45.51667000",
                        "longitude": "27.05000000"
                    },
                    {
                        "id": 96609,
                        "name": "Tănăsoaia",
                        "latitude": "46.10000000",
                        "longitude": "27.36667000"
                    },
                    {
                        "id": 96619,
                        "name": "Tătăranu",
                        "latitude": "45.51667000",
                        "longitude": "27.31667000"
                    },
                    {
                        "id": 97105,
                        "name": "Ţifeşti",
                        "latitude": "45.85000000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 106175,
                        "name": "Tulnici",
                        "latitude": "45.91667000",
                        "longitude": "26.66667000"
                    },
                    {
                        "id": 96665,
                        "name": "Unirea",
                        "latitude": "45.74020000",
                        "longitude": "27.10741000"
                    },
                    {
                        "id": 96675,
                        "name": "Urecheşti",
                        "latitude": "45.60000000",
                        "longitude": "27.06667000"
                    },
                    {
                        "id": 96701,
                        "name": "Vadu Roșca",
                        "latitude": "45.63864000",
                        "longitude": "27.45716000"
                    },
                    {
                        "id": 96758,
                        "name": "Valea Sării",
                        "latitude": "45.87686000",
                        "longitude": "26.79873000"
                    },
                    {
                        "id": 96929,
                        "name": "Vânători",
                        "latitude": "45.73333000",
                        "longitude": "27.25000000"
                    },
                    {
                        "id": 96944,
                        "name": "Vârteşcoiu",
                        "latitude": "45.73333000",
                        "longitude": "27.08333000"
                    },
                    {
                        "id": 96810,
                        "name": "Vidra",
                        "latitude": "45.91667000",
                        "longitude": "26.90000000"
                    },
                    {
                        "id": 96827,
                        "name": "Viișoara",
                        "latitude": "46.05160000",
                        "longitude": "27.09593000"
                    },
                    {
                        "id": 96835,
                        "name": "Vintileasca",
                        "latitude": "45.60000000",
                        "longitude": "26.73333000"
                    },
                    {
                        "id": 96843,
                        "name": "Vizantea-Mânăstirească",
                        "latitude": "45.98333000",
                        "longitude": "26.78333000"
                    },
                    {
                        "id": 96873,
                        "name": "Voetin",
                        "latitude": "45.44370000",
                        "longitude": "27.14587000"
                    },
                    {
                        "id": 96898,
                        "name": "Vrâncioaia",
                        "latitude": "45.85000000",
                        "longitude": "26.73333000"
                    },
                    {
                        "id": 96905,
                        "name": "Vulcăneasa",
                        "latitude": "45.77388000",
                        "longitude": "26.90981000"
                    },
                    {
                        "id": 96914,
                        "name": "Vulturu",
                        "latitude": "45.61667000",
                        "longitude": "27.41667000"
                    }
                ]
            }
        ]
    },
    {
        "id": 182,
        "name": "Russia",
        "iso3": "RUS",
        "iso2": "RU",
        "numeric_code": "643",
        "phonecode": "7",
        "capital": "Moscow",
        "currency": "RUB",
        "currency_name": "Russian ruble",
        "currency_symbol": "₽",
        "tld": ".ru",
        "native": "Россия",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Russian",
        "timezones": [
            {
                "zoneName": "Asia\/Anadyr",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "ANAT",
                "tzName": "Anadyr Time[4"
            },
            {
                "zoneName": "Asia\/Barnaul",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "KRAT",
                "tzName": "Krasnoyarsk Time"
            },
            {
                "zoneName": "Asia\/Chita",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "YAKT",
                "tzName": "Yakutsk Time"
            },
            {
                "zoneName": "Asia\/Irkutsk",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "IRKT",
                "tzName": "Irkutsk Time"
            },
            {
                "zoneName": "Asia\/Kamchatka",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "PETT",
                "tzName": "Kamchatka Time"
            },
            {
                "zoneName": "Asia\/Khandyga",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "YAKT",
                "tzName": "Yakutsk Time"
            },
            {
                "zoneName": "Asia\/Krasnoyarsk",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "KRAT",
                "tzName": "Krasnoyarsk Time"
            },
            {
                "zoneName": "Asia\/Magadan",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "MAGT",
                "tzName": "Magadan Time"
            },
            {
                "zoneName": "Asia\/Novokuznetsk",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "KRAT",
                "tzName": "Krasnoyarsk Time"
            },
            {
                "zoneName": "Asia\/Novosibirsk",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "NOVT",
                "tzName": "Novosibirsk Time"
            },
            {
                "zoneName": "Asia\/Omsk",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "OMST",
                "tzName": "Omsk Time"
            },
            {
                "zoneName": "Asia\/Sakhalin",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "SAKT",
                "tzName": "Sakhalin Island Time"
            },
            {
                "zoneName": "Asia\/Srednekolymsk",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "SRET",
                "tzName": "Srednekolymsk Time"
            },
            {
                "zoneName": "Asia\/Tomsk",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "MSD+3",
                "tzName": "Moscow Daylight Time+3"
            },
            {
                "zoneName": "Asia\/Ust-Nera",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "VLAT",
                "tzName": "Vladivostok Time"
            },
            {
                "zoneName": "Asia\/Vladivostok",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "VLAT",
                "tzName": "Vladivostok Time"
            },
            {
                "zoneName": "Asia\/Yakutsk",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "YAKT",
                "tzName": "Yakutsk Time"
            },
            {
                "zoneName": "Asia\/Yekaterinburg",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "YEKT",
                "tzName": "Yekaterinburg Time"
            },
            {
                "zoneName": "Europe\/Astrakhan",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "SAMT",
                "tzName": "Samara Time"
            },
            {
                "zoneName": "Europe\/Kaliningrad",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            },
            {
                "zoneName": "Europe\/Kirov",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "MSK",
                "tzName": "Moscow Time"
            },
            {
                "zoneName": "Europe\/Moscow",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "MSK",
                "tzName": "Moscow Time"
            },
            {
                "zoneName": "Europe\/Samara",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "SAMT",
                "tzName": "Samara Time"
            },
            {
                "zoneName": "Europe\/Saratov",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "MSD",
                "tzName": "Moscow Daylight Time+4"
            },
            {
                "zoneName": "Europe\/Ulyanovsk",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "SAMT",
                "tzName": "Samara Time"
            },
            {
                "zoneName": "Europe\/Volgograd",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "MSK",
                "tzName": "Moscow Standard Time"
            }
        ],
        "translations": {
            "br": "Rusia",
            "ko": "러시아",
            "pt-BR": "Rússia",
            "pt": "Rússia",
            "nl": "Rusland",
            "hr": "Rusija",
            "fa": "روسیه",
            "de": "Russland",
            "es": "Rusia",
            "fr": "Russie",
            "ja": "ロシア連邦",
            "it": "Russia",
            "zh-CN": "俄罗斯联邦",
            "tr": "Rusya",
            "ru": "Россия",
            "uk": "Росія",
            "pl": "Rosja"
        },
        "latitude": "60.00000000",
        "longitude": "100.00000000",
        "emoji": "🇷🇺",
        "emojiU": "U+1F1F7 U+1F1FA",
        "states": [
            {
                "id": 1852,
                "name": "Adygea",
                "iso2": "AD",
                "latitude": "44.82291550",
                "longitude": "40.17544630",
                "type": "republic",
                "cities": [
                    {
                        "id": 97476,
                        "name": "Abadzekhskaya",
                        "latitude": "44.39389000",
                        "longitude": "40.22139000"
                    },
                    {
                        "id": 97506,
                        "name": "Adygeysk",
                        "latitude": "44.88414000",
                        "longitude": "39.19071000"
                    },
                    {
                        "id": 97507,
                        "name": "Adygeysk Republican Urban Okrug",
                        "latitude": "44.87850000",
                        "longitude": "39.19167000"
                    },
                    {
                        "id": 97871,
                        "name": "Beloye",
                        "latitude": "45.04832000",
                        "longitude": "39.65143000"
                    },
                    {
                        "id": 97953,
                        "name": "Blechepsin",
                        "latitude": "44.82028000",
                        "longitude": "40.50028000"
                    },
                    {
                        "id": 98309,
                        "name": "Dondukovskaya",
                        "latitude": "44.88190000",
                        "longitude": "40.36271000"
                    },
                    {
                        "id": 98395,
                        "name": "Enem",
                        "latitude": "44.92640000",
                        "longitude": "38.90584000"
                    },
                    {
                        "id": 98486,
                        "name": "Giaginskaya",
                        "latitude": "44.86208000",
                        "longitude": "40.07195000"
                    },
                    {
                        "id": 98487,
                        "name": "Giaginskiy Rayon",
                        "latitude": "44.83333000",
                        "longitude": "40.16667000"
                    },
                    {
                        "id": 98816,
                        "name": "Kamennomostskiy",
                        "latitude": "44.28910000",
                        "longitude": "40.18800000"
                    },
                    {
                        "id": 98961,
                        "name": "Khanskaya",
                        "latitude": "44.67702000",
                        "longitude": "39.96160000"
                    },
                    {
                        "id": 98974,
                        "name": "Khatukay",
                        "latitude": "45.19074000",
                        "longitude": "39.66320000"
                    },
                    {
                        "id": 98988,
                        "name": "Khodz’",
                        "latitude": "44.51020000",
                        "longitude": "40.71420000"
                    },
                    {
                        "id": 99227,
                        "name": "Koshekhabl’",
                        "latitude": "44.89722000",
                        "longitude": "40.51194000"
                    },
                    {
                        "id": 99228,
                        "name": "Koshekhabl’skiy Rayon",
                        "latitude": "44.83333000",
                        "longitude": "40.50000000"
                    },
                    {
                        "id": 99315,
                        "name": "Krasnogvardeyskiy Rayon",
                        "latitude": "45.08333000",
                        "longitude": "39.75000000"
                    },
                    {
                        "id": 99317,
                        "name": "Krasnogvardeyskoye",
                        "latitude": "45.12780000",
                        "longitude": "39.57246000"
                    },
                    {
                        "id": 99503,
                        "name": "Kuzhorskaya",
                        "latitude": "44.67512000",
                        "longitude": "40.31032000"
                    },
                    {
                        "id": 99819,
                        "name": "Maykop",
                        "latitude": "44.60778000",
                        "longitude": "40.10583000"
                    },
                    {
                        "id": 99820,
                        "name": "Maykop Republican Urban Okrug",
                        "latitude": "44.61100000",
                        "longitude": "40.12344000"
                    },
                    {
                        "id": 99821,
                        "name": "Maykopskiy Rayon",
                        "latitude": "44.33333000",
                        "longitude": "40.25000000"
                    },
                    {
                        "id": 100065,
                        "name": "Natyrbovo",
                        "latitude": "44.73000000",
                        "longitude": "40.62639000"
                    },
                    {
                        "id": 100768,
                        "name": "Ponezhukay",
                        "latitude": "44.88761000",
                        "longitude": "39.38551000"
                    },
                    {
                        "id": 101339,
                        "name": "Shovgenovskiy",
                        "latitude": "45.01028000",
                        "longitude": "40.22500000"
                    },
                    {
                        "id": 101340,
                        "name": "Shovgenovskiy Rayon",
                        "latitude": "45.00000000",
                        "longitude": "40.16667000"
                    },
                    {
                        "id": 101742,
                        "name": "Takhtamukay",
                        "latitude": "44.92150000",
                        "longitude": "38.99583000"
                    },
                    {
                        "id": 101743,
                        "name": "Takhtamukayskiy Rayon",
                        "latitude": "44.97433000",
                        "longitude": "38.80548000"
                    },
                    {
                        "id": 101844,
                        "name": "Teuchezhskiy Rayon",
                        "latitude": "44.91667000",
                        "longitude": "39.33333000"
                    },
                    {
                        "id": 101867,
                        "name": "Tlyustenkhabl’",
                        "latitude": "44.98200000",
                        "longitude": "39.09773000"
                    },
                    {
                        "id": 102458,
                        "name": "Yablonovskiy",
                        "latitude": "44.98901000",
                        "longitude": "38.94324000"
                    }
                ]
            },
            {
                "id": 1911,
                "name": "Altai",
                "iso2": "ALT",
                "latitude": "51.79362980",
                "longitude": "82.67585960",
                "type": "administrative territory",
                "cities": [
                    {
                        "id": 97586,
                        "name": "Aleysk",
                        "latitude": "52.49260000",
                        "longitude": "82.78220000"
                    },
                    {
                        "id": 97587,
                        "name": "Aleyskiy Rayon",
                        "latitude": "52.41667000",
                        "longitude": "82.75000000"
                    },
                    {
                        "id": 97603,
                        "name": "Altayskoye",
                        "latitude": "51.95333000",
                        "longitude": "85.33250000"
                    },
                    {
                        "id": 97641,
                        "name": "Anton’yevka",
                        "latitude": "51.99610000",
                        "longitude": "83.97400000"
                    },
                    {
                        "id": 97726,
                        "name": "Aya",
                        "latitude": "51.94532000",
                        "longitude": "85.80168000"
                    },
                    {
                        "id": 97795,
                        "name": "Barnaul",
                        "latitude": "53.36056000",
                        "longitude": "83.76361000"
                    },
                    {
                        "id": 97796,
                        "name": "Barnaul Urban Okrug",
                        "latitude": "53.33087000",
                        "longitude": "83.64441000"
                    },
                    {
                        "id": 97808,
                        "name": "Bastan",
                        "latitude": "51.85889000",
                        "longitude": "79.47444000"
                    },
                    {
                        "id": 97823,
                        "name": "Bayevo",
                        "latitude": "53.27065000",
                        "longitude": "80.77921000"
                    },
                    {
                        "id": 97827,
                        "name": "Bayunovskiye Klyuchi",
                        "latitude": "53.32806000",
                        "longitude": "84.18222000"
                    },
                    {
                        "id": 97856,
                        "name": "Belokurikha",
                        "latitude": "51.99590000",
                        "longitude": "84.98960000"
                    },
                    {
                        "id": 97868,
                        "name": "Beloyarsk",
                        "latitude": "53.44610000",
                        "longitude": "83.90480000"
                    },
                    {
                        "id": 97905,
                        "name": "Berëzovka",
                        "latitude": "52.35111000",
                        "longitude": "85.82722000"
                    },
                    {
                        "id": 97942,
                        "name": "Biysk",
                        "latitude": "52.53639000",
                        "longitude": "85.20722000"
                    },
                    {
                        "id": 97947,
                        "name": "Blagoveshchenka",
                        "latitude": "52.83333000",
                        "longitude": "79.86667000"
                    },
                    {
                        "id": 97956,
                        "name": "Bobrovka",
                        "latitude": "53.18361000",
                        "longitude": "83.87639000"
                    },
                    {
                        "id": 98036,
                        "name": "Borovikha",
                        "latitude": "53.50720000",
                        "longitude": "83.83790000"
                    },
                    {
                        "id": 98082,
                        "name": "Burla",
                        "latitude": "53.33620000",
                        "longitude": "78.33010000"
                    },
                    {
                        "id": 98102,
                        "name": "Bystryanka",
                        "latitude": "52.28611000",
                        "longitude": "85.82833000"
                    },
                    {
                        "id": 98103,
                        "name": "Bystryy Istok",
                        "latitude": "52.37100000",
                        "longitude": "84.38730000"
                    },
                    {
                        "id": 98120,
                        "name": "Charyshskoye",
                        "latitude": "51.39780000",
                        "longitude": "83.55980000"
                    },
                    {
                        "id": 98149,
                        "name": "Cheremnoye",
                        "latitude": "53.16972000",
                        "longitude": "83.21333000"
                    },
                    {
                        "id": 98454,
                        "name": "Gal’bshtadt",
                        "latitude": "53.22640000",
                        "longitude": "78.98450000"
                    },
                    {
                        "id": 98515,
                        "name": "Gon’ba",
                        "latitude": "53.41720000",
                        "longitude": "83.57470000"
                    },
                    {
                        "id": 98537,
                        "name": "Gornyak",
                        "latitude": "50.99417000",
                        "longitude": "81.46611000"
                    },
                    {
                        "id": 98590,
                        "name": "Grishkovka",
                        "latitude": "53.14870000",
                        "longitude": "78.75100000"
                    },
                    {
                        "id": 98680,
                        "name": "Inya",
                        "latitude": "53.50440000",
                        "longitude": "82.67120000"
                    },
                    {
                        "id": 98796,
                        "name": "Kalmanka",
                        "latitude": "52.89917000",
                        "longitude": "83.54333000"
                    },
                    {
                        "id": 98797,
                        "name": "Kalmanskiy Rayon",
                        "latitude": "53.00000000",
                        "longitude": "83.50000000"
                    },
                    {
                        "id": 98824,
                        "name": "Kamen’-na-Obi",
                        "latitude": "53.78840000",
                        "longitude": "81.34230000"
                    },
                    {
                        "id": 98950,
                        "name": "Khabarskiy Rayon",
                        "latitude": "53.58333000",
                        "longitude": "79.50000000"
                    },
                    {
                        "id": 98951,
                        "name": "Khabary",
                        "latitude": "53.62588000",
                        "longitude": "79.53450000"
                    },
                    {
                        "id": 99111,
                        "name": "Klyuchi",
                        "latitude": "52.25303000",
                        "longitude": "79.16868000"
                    },
                    {
                        "id": 99231,
                        "name": "Kosikha",
                        "latitude": "53.36167000",
                        "longitude": "84.58222000"
                    },
                    {
                        "id": 99232,
                        "name": "Kosikhinskiy Rayon",
                        "latitude": "53.41667000",
                        "longitude": "84.58333000"
                    },
                    {
                        "id": 99311,
                        "name": "Krasnogorskoye",
                        "latitude": "52.29530000",
                        "longitude": "86.19790000"
                    },
                    {
                        "id": 99333,
                        "name": "Krasnoshchekovo",
                        "latitude": "51.67083000",
                        "longitude": "82.72889000"
                    },
                    {
                        "id": 99379,
                        "name": "Krasnyy Yar",
                        "latitude": "52.35750000",
                        "longitude": "85.33806000"
                    },
                    {
                        "id": 99403,
                        "name": "Krutikha",
                        "latitude": "53.95990000",
                        "longitude": "81.20930000"
                    },
                    {
                        "id": 99437,
                        "name": "Kulunda",
                        "latitude": "52.56600000",
                        "longitude": "78.93850000"
                    },
                    {
                        "id": 99438,
                        "name": "Kulundinskiy Rayon",
                        "latitude": "52.58333000",
                        "longitude": "79.00000000"
                    },
                    {
                        "id": 99481,
                        "name": "Kur’inskiy Rayon",
                        "latitude": "51.41667000",
                        "longitude": "82.41667000"
                    },
                    {
                        "id": 99484,
                        "name": "Kusak",
                        "latitude": "53.22380000",
                        "longitude": "78.93370000"
                    },
                    {
                        "id": 99523,
                        "name": "Kytmanovo",
                        "latitude": "53.45930000",
                        "longitude": "85.44790000"
                    },
                    {
                        "id": 99556,
                        "name": "Lebyazh’ye",
                        "latitude": "53.24361000",
                        "longitude": "83.65333000"
                    },
                    {
                        "id": 99600,
                        "name": "Lesnoye",
                        "latitude": "52.46926000",
                        "longitude": "85.25547000"
                    },
                    {
                        "id": 99650,
                        "name": "Logovskoye",
                        "latitude": "53.49430000",
                        "longitude": "84.20160000"
                    },
                    {
                        "id": 99655,
                        "name": "Loktevskiy Rayon",
                        "latitude": "51.00000000",
                        "longitude": "81.58333000"
                    },
                    {
                        "id": 99757,
                        "name": "Malinovoye Ozero",
                        "latitude": "51.67528000",
                        "longitude": "79.78250000"
                    },
                    {
                        "id": 99765,
                        "name": "Malougrenevo",
                        "latitude": "52.55680000",
                        "longitude": "85.33908000"
                    },
                    {
                        "id": 99779,
                        "name": "Mamontovo",
                        "latitude": "52.70550000",
                        "longitude": "81.62440000"
                    },
                    {
                        "id": 99780,
                        "name": "Mamontovskiy Rayon",
                        "latitude": "52.66667000",
                        "longitude": "81.75000000"
                    },
                    {
                        "id": 99805,
                        "name": "Martynovo",
                        "latitude": "53.26667000",
                        "longitude": "85.88333000"
                    },
                    {
                        "id": 99902,
                        "name": "Mikhaylovskiy Rayon",
                        "latitude": "51.75000000",
                        "longitude": "79.66667000"
                    },
                    {
                        "id": 99906,
                        "name": "Mikhaylovskoye",
                        "latitude": "51.82389000",
                        "longitude": "79.71722000"
                    },
                    {
                        "id": 100047,
                        "name": "Nagornyy",
                        "latitude": "52.79590000",
                        "longitude": "83.54980000"
                    },
                    {
                        "id": 100053,
                        "name": "Nalobikha",
                        "latitude": "53.20090000",
                        "longitude": "84.60000000"
                    },
                    {
                        "id": 100064,
                        "name": "Natsional’nyy Rayon Nemetskiy",
                        "latitude": "53.25000000",
                        "longitude": "79.00000000"
                    },
                    {
                        "id": 100066,
                        "name": "Nauchnyy Gorodok",
                        "latitude": "53.42030000",
                        "longitude": "83.52100000"
                    },
                    {
                        "id": 100135,
                        "name": "Nikolayevka",
                        "latitude": "51.92556000",
                        "longitude": "79.41583000"
                    },
                    {
                        "id": 100214,
                        "name": "Novichikha",
                        "latitude": "52.20400000",
                        "longitude": "81.38770000"
                    },
                    {
                        "id": 100215,
                        "name": "Novichikhinskiy Rayon",
                        "latitude": "52.16667000",
                        "longitude": "81.41667000"
                    },
                    {
                        "id": 100216,
                        "name": "Novikovo",
                        "latitude": "52.62231000",
                        "longitude": "85.96392000"
                    },
                    {
                        "id": 100224,
                        "name": "Novoaltaysk",
                        "latitude": "53.39170000",
                        "longitude": "83.93630000"
                    },
                    {
                        "id": 100304,
                        "name": "Novosilikatnyy",
                        "latitude": "53.30972000",
                        "longitude": "83.62389000"
                    },
                    {
                        "id": 100318,
                        "name": "Novotyryshkino",
                        "latitude": "52.08330000",
                        "longitude": "84.90890000"
                    },
                    {
                        "id": 100363,
                        "name": "Novyye Zori",
                        "latitude": "53.24778000",
                        "longitude": "83.42500000"
                    },
                    {
                        "id": 100538,
                        "name": "Pankrushikha",
                        "latitude": "53.83194000",
                        "longitude": "80.34056000"
                    },
                    {
                        "id": 100539,
                        "name": "Pankrushikhinskiy Rayon",
                        "latitude": "53.83333000",
                        "longitude": "80.33333000"
                    },
                    {
                        "id": 100573,
                        "name": "Pavlovsk",
                        "latitude": "53.31861000",
                        "longitude": "82.98222000"
                    },
                    {
                        "id": 100582,
                        "name": "Pavlovskiy Rayon",
                        "latitude": "53.25000000",
                        "longitude": "83.00000000"
                    },
                    {
                        "id": 100620,
                        "name": "Pervomayskiy",
                        "latitude": "52.91730000",
                        "longitude": "81.66240000"
                    },
                    {
                        "id": 100623,
                        "name": "Pervomayskiy Rayon",
                        "latitude": "53.41667000",
                        "longitude": "84.08333000"
                    },
                    {
                        "id": 100628,
                        "name": "Pervomayskoye",
                        "latitude": "52.59888000",
                        "longitude": "85.25769000"
                    },
                    {
                        "id": 100655,
                        "name": "Petropavlovskiy Rayon",
                        "latitude": "52.16667000",
                        "longitude": "84.25000000"
                    },
                    {
                        "id": 100656,
                        "name": "Petropavlovskoye",
                        "latitude": "52.07120000",
                        "longitude": "84.10700000"
                    },
                    {
                        "id": 100732,
                        "name": "Podsosnovo",
                        "latitude": "53.37210000",
                        "longitude": "78.91840000"
                    },
                    {
                        "id": 100786,
                        "name": "Pospelikha",
                        "latitude": "51.95000000",
                        "longitude": "81.76667000"
                    },
                    {
                        "id": 100787,
                        "name": "Pospelikhinskiy Rayon",
                        "latitude": "51.83333000",
                        "longitude": "81.66667000"
                    },
                    {
                        "id": 100954,
                        "name": "Rebrikha",
                        "latitude": "53.07333000",
                        "longitude": "82.34083000"
                    },
                    {
                        "id": 100955,
                        "name": "Rebrikhinskiy Rayon",
                        "latitude": "53.00000000",
                        "longitude": "82.25000000"
                    },
                    {
                        "id": 100973,
                        "name": "Rodino",
                        "latitude": "52.49783000",
                        "longitude": "80.20294000"
                    },
                    {
                        "id": 100974,
                        "name": "Rodinskiy Rayon",
                        "latitude": "52.50000000",
                        "longitude": "80.33333000"
                    },
                    {
                        "id": 100989,
                        "name": "Romanovo",
                        "latitude": "52.61820000",
                        "longitude": "81.22710000"
                    },
                    {
                        "id": 100991,
                        "name": "Romanovskiy Rayon",
                        "latitude": "52.58333000",
                        "longitude": "81.16667000"
                    },
                    {
                        "id": 101019,
                        "name": "Rubtsovsk",
                        "latitude": "51.51473000",
                        "longitude": "81.20613000"
                    },
                    {
                        "id": 101020,
                        "name": "Rubtsovskiy Rayon",
                        "latitude": "51.50000000",
                        "longitude": "81.33333000"
                    },
                    {
                        "id": 101101,
                        "name": "Sannikovo",
                        "latitude": "53.34480000",
                        "longitude": "83.97490000"
                    },
                    {
                        "id": 101201,
                        "name": "Severka",
                        "latitude": "52.13333000",
                        "longitude": "79.28333000"
                    },
                    {
                        "id": 101236,
                        "name": "Shakhi",
                        "latitude": "53.33610000",
                        "longitude": "83.36240000"
                    },
                    {
                        "id": 101290,
                        "name": "Shelabolikha",
                        "latitude": "53.41310000",
                        "longitude": "82.61670000"
                    },
                    {
                        "id": 101291,
                        "name": "Shelabolikhinskiy Rayon",
                        "latitude": "53.41667000",
                        "longitude": "82.25000000"
                    },
                    {
                        "id": 101324,
                        "name": "Shipunovo",
                        "latitude": "52.15820000",
                        "longitude": "82.21730000"
                    },
                    {
                        "id": 101325,
                        "name": "Shipunovskiy Rayon",
                        "latitude": "52.33333000",
                        "longitude": "82.08333000"
                    },
                    {
                        "id": 101342,
                        "name": "Shubenka",
                        "latitude": "52.65510000",
                        "longitude": "85.09858000"
                    },
                    {
                        "id": 101345,
                        "name": "Shul’gin Log",
                        "latitude": "52.16985000",
                        "longitude": "85.85573000"
                    },
                    {
                        "id": 101367,
                        "name": "Sibirskiy",
                        "latitude": "53.57770000",
                        "longitude": "83.75770000"
                    },
                    {
                        "id": 101399,
                        "name": "Slavgorod",
                        "latitude": "52.99780000",
                        "longitude": "78.64490000"
                    },
                    {
                        "id": 101400,
                        "name": "Slavgorodskoye",
                        "latitude": "53.02140000",
                        "longitude": "78.64350000"
                    },
                    {
                        "id": 101417,
                        "name": "Smolenskiy Rayon",
                        "latitude": "52.16667000",
                        "longitude": "84.91667000"
                    },
                    {
                        "id": 101418,
                        "name": "Smolenskoye",
                        "latitude": "52.30447000",
                        "longitude": "85.07850000"
                    },
                    {
                        "id": 101437,
                        "name": "Sokolovo",
                        "latitude": "52.53180000",
                        "longitude": "84.78960000"
                    },
                    {
                        "id": 101464,
                        "name": "Soloneshenskiy Rayon",
                        "latitude": "51.66667000",
                        "longitude": "84.50000000"
                    },
                    {
                        "id": 101465,
                        "name": "Soloneshnoye",
                        "latitude": "51.65440000",
                        "longitude": "84.31970000"
                    },
                    {
                        "id": 101468,
                        "name": "Solton",
                        "latitude": "52.84290000",
                        "longitude": "86.47870000"
                    },
                    {
                        "id": 101469,
                        "name": "Soltonskiy Rayon",
                        "latitude": "52.83333000",
                        "longitude": "86.50000000"
                    },
                    {
                        "id": 101478,
                        "name": "Sorokino",
                        "latitude": "53.75000000",
                        "longitude": "84.91667000"
                    },
                    {
                        "id": 101518,
                        "name": "Sovetskoye",
                        "latitude": "52.28556000",
                        "longitude": "85.41424000"
                    },
                    {
                        "id": 101550,
                        "name": "Srostki",
                        "latitude": "52.42090000",
                        "longitude": "85.69923000"
                    },
                    {
                        "id": 101551,
                        "name": "Stan-Bekhtemir",
                        "latitude": "52.60665000",
                        "longitude": "85.62619000"
                    },
                    {
                        "id": 101571,
                        "name": "Staroaleyskoye",
                        "latitude": "51.00611000",
                        "longitude": "82.00000000"
                    },
                    {
                        "id": 101574,
                        "name": "Starobelokurikha",
                        "latitude": "52.05206000",
                        "longitude": "85.08765000"
                    },
                    {
                        "id": 101608,
                        "name": "Staryy Togul",
                        "latitude": "53.42910000",
                        "longitude": "85.90060000"
                    },
                    {
                        "id": 101636,
                        "name": "Stukovo",
                        "latitude": "53.21278000",
                        "longitude": "83.33778000"
                    },
                    {
                        "id": 101722,
                        "name": "Sychëvka",
                        "latitude": "52.05120000",
                        "longitude": "84.77880000"
                    },
                    {
                        "id": 101739,
                        "name": "Tabuny",
                        "latitude": "52.77730000",
                        "longitude": "78.78960000"
                    },
                    {
                        "id": 101757,
                        "name": "Tal’menka",
                        "latitude": "53.81830000",
                        "longitude": "83.56770000"
                    },
                    {
                        "id": 101758,
                        "name": "Tal’menskiy Rayon",
                        "latitude": "53.75000000",
                        "longitude": "83.41667000"
                    },
                    {
                        "id": 101870,
                        "name": "Togul",
                        "latitude": "53.46700000",
                        "longitude": "85.91280000"
                    },
                    {
                        "id": 101871,
                        "name": "Togul’skiy Rayon",
                        "latitude": "53.66667000",
                        "longitude": "86.08333000"
                    },
                    {
                        "id": 101893,
                        "name": "Topchikha",
                        "latitude": "52.81920000",
                        "longitude": "83.11850000"
                    },
                    {
                        "id": 101896,
                        "name": "Topol’noye",
                        "latitude": "51.51050000",
                        "longitude": "84.48130000"
                    },
                    {
                        "id": 101924,
                        "name": "Troitskoye",
                        "latitude": "52.98220000",
                        "longitude": "84.68000000"
                    },
                    {
                        "id": 101940,
                        "name": "Tselinnoye",
                        "latitude": "53.07822000",
                        "longitude": "85.65363000"
                    },
                    {
                        "id": 102006,
                        "name": "Tyumentsevo",
                        "latitude": "53.32240000",
                        "longitude": "81.49800000"
                    },
                    {
                        "id": 102007,
                        "name": "Tyumentsevskiy Rayon",
                        "latitude": "53.25000000",
                        "longitude": "81.50000000"
                    },
                    {
                        "id": 102038,
                        "name": "Uglovskoye",
                        "latitude": "51.35570000",
                        "longitude": "80.19420000"
                    },
                    {
                        "id": 102117,
                        "name": "Ust’-Charyshskaya Pristan’",
                        "latitude": "52.39340000",
                        "longitude": "83.66350000"
                    },
                    {
                        "id": 102120,
                        "name": "Ust’-Isha",
                        "latitude": "52.18201000",
                        "longitude": "85.96757000"
                    },
                    {
                        "id": 102124,
                        "name": "Ust’-Kalmanka",
                        "latitude": "52.12070000",
                        "longitude": "83.30500000"
                    },
                    {
                        "id": 102143,
                        "name": "Ust’yanka",
                        "latitude": "53.45270000",
                        "longitude": "78.74250000"
                    },
                    {
                        "id": 102148,
                        "name": "Usyatskoye",
                        "latitude": "52.56806000",
                        "longitude": "85.76085000"
                    },
                    {
                        "id": 102231,
                        "name": "Verkh-Katunskoye",
                        "latitude": "52.45000000",
                        "longitude": "85.43162000"
                    },
                    {
                        "id": 102233,
                        "name": "Verkh-Suetka",
                        "latitude": "53.30401000",
                        "longitude": "80.04675000"
                    },
                    {
                        "id": 102251,
                        "name": "Verkhniy Bekhtemir",
                        "latitude": "52.76582000",
                        "longitude": "85.91011000"
                    },
                    {
                        "id": 102287,
                        "name": "Veseloyarsk",
                        "latitude": "51.28737000",
                        "longitude": "81.10703000"
                    },
                    {
                        "id": 102331,
                        "name": "Vlasikha",
                        "latitude": "53.29722000",
                        "longitude": "83.57417000"
                    },
                    {
                        "id": 102340,
                        "name": "Volchikha",
                        "latitude": "52.01356000",
                        "longitude": "80.35715000"
                    },
                    {
                        "id": 102341,
                        "name": "Volchikhinskiy Rayon",
                        "latitude": "52.08333000",
                        "longitude": "80.50000000"
                    },
                    {
                        "id": 102504,
                        "name": "Yarovoye",
                        "latitude": "52.92730000",
                        "longitude": "78.58000000"
                    },
                    {
                        "id": 102526,
                        "name": "Yegor’yevskiy Rayon",
                        "latitude": "51.75000000",
                        "longitude": "81.00000000"
                    },
                    {
                        "id": 102552,
                        "name": "Yel’tsovskiy Rayon",
                        "latitude": "53.25000000",
                        "longitude": "86.41667000"
                    },
                    {
                        "id": 102618,
                        "name": "Yuzhnyy",
                        "latitude": "53.25417000",
                        "longitude": "83.69361000"
                    },
                    {
                        "id": 102638,
                        "name": "Zalesovo",
                        "latitude": "53.99389000",
                        "longitude": "84.74306000"
                    },
                    {
                        "id": 102658,
                        "name": "Zarinsk",
                        "latitude": "53.70740000",
                        "longitude": "84.94930000"
                    },
                    {
                        "id": 102659,
                        "name": "Zarinskiy Rayon",
                        "latitude": "53.91667000",
                        "longitude": "85.33333000"
                    },
                    {
                        "id": 102662,
                        "name": "Zarya",
                        "latitude": "52.59696000",
                        "longitude": "85.17570000"
                    },
                    {
                        "id": 102667,
                        "name": "Zaton",
                        "latitude": "53.29361000",
                        "longitude": "83.80722000"
                    },
                    {
                        "id": 102682,
                        "name": "Zav’yalovo",
                        "latitude": "52.83805000",
                        "longitude": "80.91970000"
                    },
                    {
                        "id": 102684,
                        "name": "Zav’yalovskiy Rayon",
                        "latitude": "52.91667000",
                        "longitude": "81.00000000"
                    },
                    {
                        "id": 102752,
                        "name": "Zmeinogorsk",
                        "latitude": "51.15776000",
                        "longitude": "82.19534000"
                    },
                    {
                        "id": 102769,
                        "name": "Zonal’noye",
                        "latitude": "52.66650000",
                        "longitude": "84.93310000"
                    },
                    {
                        "id": 102776,
                        "name": "Zudilovo",
                        "latitude": "53.49270000",
                        "longitude": "83.89370000"
                    }
                ]
            },
            {
                "id": 1876,
                "name": "Altai",
                "iso2": "AL",
                "latitude": "50.61819240",
                "longitude": "86.21993080",
                "type": "republic",
                "cities": [
                    {
                        "id": 97548,
                        "name": "Aktash",
                        "latitude": "50.30000000",
                        "longitude": "87.73333000"
                    },
                    {
                        "id": 97684,
                        "name": "Artybash",
                        "latitude": "51.79278000",
                        "longitude": "87.27611000"
                    },
                    {
                        "id": 97876,
                        "name": "Belyashi",
                        "latitude": "49.70900000",
                        "longitude": "87.42300000"
                    },
                    {
                        "id": 98141,
                        "name": "Chemal",
                        "latitude": "51.41111000",
                        "longitude": "86.00500000"
                    },
                    {
                        "id": 98158,
                        "name": "Cherga",
                        "latitude": "51.56889000",
                        "longitude": "85.56250000"
                    },
                    {
                        "id": 98212,
                        "name": "Choya",
                        "latitude": "52.01080000",
                        "longitude": "86.54670000"
                    },
                    {
                        "id": 98384,
                        "name": "Elekmonar",
                        "latitude": "51.45889000",
                        "longitude": "85.98778000"
                    },
                    {
                        "id": 98529,
                        "name": "Gorno-Altaysk",
                        "latitude": "51.96056000",
                        "longitude": "85.91892000"
                    },
                    {
                        "id": 98679,
                        "name": "Inya",
                        "latitude": "50.45611000",
                        "longitude": "86.62667000"
                    },
                    {
                        "id": 98684,
                        "name": "Iogach",
                        "latitude": "51.78167000",
                        "longitude": "87.26306000"
                    },
                    {
                        "id": 99226,
                        "name": "Kosh-Agach",
                        "latitude": "49.99273000",
                        "longitude": "88.67598000"
                    },
                    {
                        "id": 99787,
                        "name": "Manzherok",
                        "latitude": "51.83028000",
                        "longitude": "85.77500000"
                    },
                    {
                        "id": 99824,
                        "name": "Mayma",
                        "latitude": "52.01577000",
                        "longitude": "85.90963000"
                    },
                    {
                        "id": 99825,
                        "name": "Mayminskiy Rayon",
                        "latitude": "51.83333000",
                        "longitude": "86.00000000"
                    },
                    {
                        "id": 100448,
                        "name": "Onguday",
                        "latitude": "50.75000000",
                        "longitude": "86.15000000"
                    },
                    {
                        "id": 100449,
                        "name": "Ongudayskiy Rayon",
                        "latitude": "50.66667000",
                        "longitude": "86.50000000"
                    },
                    {
                        "id": 101282,
                        "name": "Shebalino",
                        "latitude": "51.29167000",
                        "longitude": "85.67722000"
                    },
                    {
                        "id": 101283,
                        "name": "Shebalinskiy Rayon",
                        "latitude": "51.33333000",
                        "longitude": "85.50000000"
                    },
                    {
                        "id": 101502,
                        "name": "Souzga",
                        "latitude": "51.88722000",
                        "longitude": "85.84944000"
                    },
                    {
                        "id": 101785,
                        "name": "Tashanta",
                        "latitude": "49.71573000",
                        "longitude": "89.19425000"
                    },
                    {
                        "id": 101980,
                        "name": "Turochak",
                        "latitude": "52.25760000",
                        "longitude": "87.12240000"
                    },
                    {
                        "id": 102127,
                        "name": "Ust’-Kan",
                        "latitude": "50.92760000",
                        "longitude": "84.76100000"
                    },
                    {
                        "id": 102131,
                        "name": "Ust’-Koksa",
                        "latitude": "50.26960000",
                        "longitude": "85.61080000"
                    },
                    {
                        "id": 102132,
                        "name": "Ust’-Koksinskiy Rayon",
                        "latitude": "50.16667000",
                        "longitude": "85.58333000"
                    },
                    {
                        "id": 102141,
                        "name": "Ust’-Ulagan",
                        "latitude": "50.63258000",
                        "longitude": "87.96046000"
                    }
                ]
            },
            {
                "id": 1858,
                "name": "Amur",
                "iso2": "AMU",
                "latitude": "54.60350650",
                "longitude": "127.48017210",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97666,
                        "name": "Arkhara",
                        "latitude": "49.42447000",
                        "longitude": "130.08569000"
                    },
                    {
                        "id": 97667,
                        "name": "Arkharinskiy Rayon",
                        "latitude": "49.50000000",
                        "longitude": "130.66667000"
                    },
                    {
                        "id": 97853,
                        "name": "Belogorsk",
                        "latitude": "50.91644000",
                        "longitude": "128.47726000"
                    },
                    {
                        "id": 97854,
                        "name": "Belogorskiy Rayon",
                        "latitude": "50.75000000",
                        "longitude": "128.50000000"
                    },
                    {
                        "id": 97949,
                        "name": "Blagoveshchensk",
                        "latitude": "50.27961000",
                        "longitude": "127.54050000"
                    },
                    {
                        "id": 97950,
                        "name": "Blagoveshchenskiy Rayon",
                        "latitude": "50.75000000",
                        "longitude": "127.50000000"
                    },
                    {
                        "id": 98079,
                        "name": "Bureya",
                        "latitude": "49.81212000",
                        "longitude": "129.81278000"
                    },
                    {
                        "id": 98080,
                        "name": "Bureyskiy Rayon",
                        "latitude": "50.00000000",
                        "longitude": "130.00000000"
                    },
                    {
                        "id": 98383,
                        "name": "Ekimchan",
                        "latitude": "53.06972000",
                        "longitude": "132.94011000"
                    },
                    {
                        "id": 98546,
                        "name": "Gorod Blagoveshchensk",
                        "latitude": "50.40000000",
                        "longitude": "127.60000000"
                    },
                    {
                        "id": 98554,
                        "name": "Gorod Raychikhinsk",
                        "latitude": "49.75000000",
                        "longitude": "129.41667000"
                    },
                    {
                        "id": 98733,
                        "name": "Ivanovskiy Rayon",
                        "latitude": "50.45611000",
                        "longitude": "127.99778000"
                    },
                    {
                        "id": 99187,
                        "name": "Konstantinovka",
                        "latitude": "49.61876000",
                        "longitude": "127.99025000"
                    },
                    {
                        "id": 99193,
                        "name": "Konstantinovskiy Rayon",
                        "latitude": "49.75000000",
                        "longitude": "128.16667000"
                    },
                    {
                        "id": 99735,
                        "name": "Magdagachi",
                        "latitude": "53.45398000",
                        "longitude": "125.80932000"
                    },
                    {
                        "id": 99736,
                        "name": "Magdagachinskiy Rayon",
                        "latitude": "53.33333000",
                        "longitude": "126.00000000"
                    },
                    {
                        "id": 99837,
                        "name": "Mazanovskiy Rayon",
                        "latitude": "52.16667000",
                        "longitude": "129.50000000"
                    },
                    {
                        "id": 99904,
                        "name": "Mikhaylovskiy Rayon",
                        "latitude": "49.75000000",
                        "longitude": "128.75000000"
                    },
                    {
                        "id": 100117,
                        "name": "Never",
                        "latitude": "53.97946000",
                        "longitude": "124.15777000"
                    },
                    {
                        "id": 100232,
                        "name": "Novobureyskiy",
                        "latitude": "49.79695000",
                        "longitude": "129.87443000"
                    },
                    {
                        "id": 100287,
                        "name": "Novoraychikhinsk",
                        "latitude": "49.78423000",
                        "longitude": "129.59051000"
                    },
                    {
                        "id": 100414,
                        "name": "Oktyabr’skiy Rayon",
                        "latitude": "50.33333000",
                        "longitude": "129.00000000"
                    },
                    {
                        "id": 100514,
                        "name": "Ovsyanka",
                        "latitude": "53.57868000",
                        "longitude": "126.89623000"
                    },
                    {
                        "id": 100797,
                        "name": "Poyarkovo",
                        "latitude": "49.62678000",
                        "longitude": "128.65352000"
                    },
                    {
                        "id": 100946,
                        "name": "Raychikhinsk",
                        "latitude": "49.78998000",
                        "longitude": "129.40992000"
                    },
                    {
                        "id": 100992,
                        "name": "Romnenskiy Rayon",
                        "latitude": "51.00000000",
                        "longitude": "130.00000000"
                    },
                    {
                        "id": 100993,
                        "name": "Romny",
                        "latitude": "50.72070000",
                        "longitude": "129.29122000"
                    },
                    {
                        "id": 101150,
                        "name": "Selemdzhinskiy Rayon",
                        "latitude": "52.50000000",
                        "longitude": "132.00000000"
                    },
                    {
                        "id": 101194,
                        "name": "Seryshevo",
                        "latitude": "51.09391000",
                        "longitude": "128.38258000"
                    },
                    {
                        "id": 101195,
                        "name": "Seryshevskiy Rayon",
                        "latitude": "51.16667000",
                        "longitude": "128.50000000"
                    },
                    {
                        "id": 101318,
                        "name": "Shimanovsk",
                        "latitude": "52.00575000",
                        "longitude": "127.67756000"
                    },
                    {
                        "id": 101319,
                        "name": "Shimanovskiy Rayon",
                        "latitude": "52.16667000",
                        "longitude": "127.50000000"
                    },
                    {
                        "id": 101330,
                        "name": "Shirokiy",
                        "latitude": "49.75907000",
                        "longitude": "129.51988000"
                    },
                    {
                        "id": 101383,
                        "name": "Sivaki",
                        "latitude": "52.63430000",
                        "longitude": "126.74777000"
                    },
                    {
                        "id": 101392,
                        "name": "Skovorodino",
                        "latitude": "53.98473000",
                        "longitude": "123.94030000"
                    },
                    {
                        "id": 101393,
                        "name": "Skovorodinskiy Rayon",
                        "latitude": "53.83333000",
                        "longitude": "123.50000000"
                    },
                    {
                        "id": 101467,
                        "name": "Solovjevsk",
                        "latitude": "54.23333000",
                        "longitude": "124.43333000"
                    },
                    {
                        "id": 101541,
                        "name": "Srednebelaya",
                        "latitude": "50.65854000",
                        "longitude": "128.00932000"
                    },
                    {
                        "id": 101712,
                        "name": "Svobodnenskiy Rayon",
                        "latitude": "51.50000000",
                        "longitude": "127.83333000"
                    },
                    {
                        "id": 101714,
                        "name": "Svobodnyy",
                        "latitude": "51.37525000",
                        "longitude": "128.14097000"
                    },
                    {
                        "id": 101744,
                        "name": "Takhtamygda",
                        "latitude": "54.11031000",
                        "longitude": "123.60802000"
                    },
                    {
                        "id": 101746,
                        "name": "Talakan",
                        "latitude": "50.26378000",
                        "longitude": "130.26755000"
                    },
                    {
                        "id": 101749,
                        "name": "Taldan",
                        "latitude": "53.68981000",
                        "longitude": "124.81490000"
                    },
                    {
                        "id": 101763,
                        "name": "Tambovka",
                        "latitude": "50.09968000",
                        "longitude": "128.05724000"
                    },
                    {
                        "id": 101764,
                        "name": "Tambovskiy Rayon",
                        "latitude": "50.08333000",
                        "longitude": "128.00000000"
                    },
                    {
                        "id": 101875,
                        "name": "Tokur",
                        "latitude": "53.13531000",
                        "longitude": "132.88996000"
                    },
                    {
                        "id": 101950,
                        "name": "Tsiolkovskiy",
                        "latitude": "51.76694000",
                        "longitude": "128.11472000"
                    },
                    {
                        "id": 101991,
                        "name": "Tygda",
                        "latitude": "53.11169000",
                        "longitude": "126.32907000"
                    },
                    {
                        "id": 101993,
                        "name": "Tynda",
                        "latitude": "55.15600000",
                        "longitude": "124.72479000"
                    },
                    {
                        "id": 101994,
                        "name": "Tyndinskiy Rayon",
                        "latitude": "55.33333000",
                        "longitude": "123.50000000"
                    },
                    {
                        "id": 102089,
                        "name": "Urusha",
                        "latitude": "54.05303000",
                        "longitude": "122.88561000"
                    },
                    {
                        "id": 102095,
                        "name": "Ushumun",
                        "latitude": "52.78633000",
                        "longitude": "126.53767000"
                    },
                    {
                        "id": 102528,
                        "name": "Yekaterinoslavka",
                        "latitude": "50.37344000",
                        "longitude": "129.10957000"
                    },
                    {
                        "id": 102570,
                        "name": "Yerofey Pavlovich",
                        "latitude": "53.96305000",
                        "longitude": "121.95805000"
                    },
                    {
                        "id": 102673,
                        "name": "Zavitinsk",
                        "latitude": "50.11118000",
                        "longitude": "129.44156000"
                    },
                    {
                        "id": 102674,
                        "name": "Zavitinskiy Rayon",
                        "latitude": "50.16667000",
                        "longitude": "129.50000000"
                    },
                    {
                        "id": 102708,
                        "name": "Zeya",
                        "latitude": "53.73601000",
                        "longitude": "127.25700000"
                    },
                    {
                        "id": 102709,
                        "name": "Zeyskiy Rayon",
                        "latitude": "54.50000000",
                        "longitude": "128.50000000"
                    }
                ]
            },
            {
                "id": 1849,
                "name": "Arkhangelsk",
                "iso2": "ARK",
                "latitude": "64.54585490",
                "longitude": "40.55057690",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97664,
                        "name": "Arkhangel’sk",
                        "latitude": "64.54010000",
                        "longitude": "40.54330000"
                    },
                    {
                        "id": 97903,
                        "name": "Berëznik",
                        "latitude": "62.85200000",
                        "longitude": "42.70710000"
                    },
                    {
                        "id": 98153,
                        "name": "Cheremushskiy",
                        "latitude": "61.27306000",
                        "longitude": "47.26361000"
                    },
                    {
                        "id": 98358,
                        "name": "Dvinskoy",
                        "latitude": "62.15190000",
                        "longitude": "45.11840000"
                    },
                    {
                        "id": 98655,
                        "name": "Il’insko-Podomskoye",
                        "latitude": "61.11444000",
                        "longitude": "47.97861000"
                    },
                    {
                        "id": 98646,
                        "name": "Ileza",
                        "latitude": "61.05328000",
                        "longitude": "43.90021000"
                    },
                    {
                        "id": 98698,
                        "name": "Isakogorka",
                        "latitude": "64.44600000",
                        "longitude": "40.65310000"
                    },
                    {
                        "id": 98809,
                        "name": "Kamenka",
                        "latitude": "65.88350000",
                        "longitude": "44.12720000"
                    },
                    {
                        "id": 98879,
                        "name": "Kargopol’",
                        "latitude": "61.50359000",
                        "longitude": "38.94860000"
                    },
                    {
                        "id": 98880,
                        "name": "Kargopol’skiy Rayon",
                        "latitude": "61.33333000",
                        "longitude": "39.00000000"
                    },
                    {
                        "id": 98884,
                        "name": "Karpogory",
                        "latitude": "64.00189000",
                        "longitude": "44.44513000"
                    },
                    {
                        "id": 98909,
                        "name": "Katunino",
                        "latitude": "64.38620000",
                        "longitude": "40.62980000"
                    },
                    {
                        "id": 98964,
                        "name": "Kharitonovo",
                        "latitude": "61.40092000",
                        "longitude": "47.49779000"
                    },
                    {
                        "id": 98994,
                        "name": "Kholmogorskiy Rayon",
                        "latitude": "64.08333000",
                        "longitude": "41.66667000"
                    },
                    {
                        "id": 98995,
                        "name": "Kholmogory",
                        "latitude": "64.22290000",
                        "longitude": "41.65600000"
                    },
                    {
                        "id": 99088,
                        "name": "Kizema",
                        "latitude": "61.11304000",
                        "longitude": "44.83017000"
                    },
                    {
                        "id": 99126,
                        "name": "Kodino",
                        "latitude": "63.71976000",
                        "longitude": "39.64465000"
                    },
                    {
                        "id": 99197,
                        "name": "Konëvo",
                        "latitude": "62.11745000",
                        "longitude": "39.33131000"
                    },
                    {
                        "id": 99186,
                        "name": "Konosha",
                        "latitude": "60.97360000",
                        "longitude": "40.25700000"
                    },
                    {
                        "id": 99221,
                        "name": "Koryazhma",
                        "latitude": "61.31433000",
                        "longitude": "47.16914000"
                    },
                    {
                        "id": 99246,
                        "name": "Kotlas",
                        "latitude": "61.25745000",
                        "longitude": "46.64963000"
                    },
                    {
                        "id": 99247,
                        "name": "Kotlasskiy Rayon",
                        "latitude": "61.16667000",
                        "longitude": "46.33333000"
                    },
                    {
                        "id": 99297,
                        "name": "Krasnoborsk",
                        "latitude": "61.55978000",
                        "longitude": "45.93396000"
                    },
                    {
                        "id": 99435,
                        "name": "Kuloy",
                        "latitude": "61.03049000",
                        "longitude": "42.49252000"
                    },
                    {
                        "id": 99580,
                        "name": "Lenskiy Rayon",
                        "latitude": "62.00000000",
                        "longitude": "48.66667000"
                    },
                    {
                        "id": 99588,
                        "name": "Leshukonskiy Rayon",
                        "latitude": "65.00000000",
                        "longitude": "47.00000000"
                    },
                    {
                        "id": 99589,
                        "name": "Leshukonskoye",
                        "latitude": "64.89770000",
                        "longitude": "45.76550000"
                    },
                    {
                        "id": 99675,
                        "name": "Loyga",
                        "latitude": "61.07845000",
                        "longitude": "44.60750000"
                    },
                    {
                        "id": 99689,
                        "name": "Lukovetskiy",
                        "latitude": "64.29560000",
                        "longitude": "41.92110000"
                    },
                    {
                        "id": 99876,
                        "name": "Mezen’",
                        "latitude": "65.84010000",
                        "longitude": "44.25420000"
                    },
                    {
                        "id": 99875,
                        "name": "Mezenskiy Rayon",
                        "latitude": "65.75000000",
                        "longitude": "44.00000000"
                    },
                    {
                        "id": 99924,
                        "name": "Mirnyy",
                        "latitude": "61.33289000",
                        "longitude": "44.53598000"
                    },
                    {
                        "id": 100240,
                        "name": "Novodvinsk",
                        "latitude": "64.41650000",
                        "longitude": "40.81220000"
                    },
                    {
                        "id": 100374,
                        "name": "Nyandoma",
                        "latitude": "61.66560000",
                        "longitude": "40.20130000"
                    },
                    {
                        "id": 100375,
                        "name": "Nyandomskiy Rayon",
                        "latitude": "62.00000000",
                        "longitude": "40.66667000"
                    },
                    {
                        "id": 100407,
                        "name": "Oksovskiy",
                        "latitude": "62.60623000",
                        "longitude": "39.89845000"
                    },
                    {
                        "id": 100446,
                        "name": "Onega",
                        "latitude": "63.90692000",
                        "longitude": "38.11112000"
                    },
                    {
                        "id": 100447,
                        "name": "Onezhskiy Rayon",
                        "latitude": "63.33333000",
                        "longitude": "38.00000000"
                    },
                    {
                        "id": 100675,
                        "name": "Pinega",
                        "latitude": "64.69969000",
                        "longitude": "43.39016000"
                    },
                    {
                        "id": 100677,
                        "name": "Pinezhskiy Rayon",
                        "latitude": "64.66667000",
                        "longitude": "43.00000000"
                    },
                    {
                        "id": 100701,
                        "name": "Plesetsk",
                        "latitude": "62.70804000",
                        "longitude": "40.29159000"
                    },
                    {
                        "id": 100734,
                        "name": "Podyuga",
                        "latitude": "61.09500000",
                        "longitude": "40.86472000"
                    },
                    {
                        "id": 100834,
                        "name": "Primorskiy Rayon",
                        "latitude": "65.00000000",
                        "longitude": "41.00000000"
                    },
                    {
                        "id": 100845,
                        "name": "Privodino",
                        "latitude": "61.07599000",
                        "longitude": "46.50238000"
                    },
                    {
                        "id": 100890,
                        "name": "Puksoozero",
                        "latitude": "62.59030000",
                        "longitude": "40.60660000"
                    },
                    {
                        "id": 100972,
                        "name": "Rochegda",
                        "latitude": "62.66780000",
                        "longitude": "43.41330000"
                    },
                    {
                        "id": 101089,
                        "name": "Samoded",
                        "latitude": "63.60830000",
                        "longitude": "40.51110000"
                    },
                    {
                        "id": 101217,
                        "name": "Severodvinsk",
                        "latitude": "64.56350000",
                        "longitude": "39.83020000"
                    },
                    {
                        "id": 101243,
                        "name": "Shalakusha",
                        "latitude": "62.22472000",
                        "longitude": "40.25389000"
                    },
                    {
                        "id": 101256,
                        "name": "Shangaly",
                        "latitude": "61.12842000",
                        "longitude": "43.33427000"
                    },
                    {
                        "id": 101300,
                        "name": "Shenkursk",
                        "latitude": "62.10910000",
                        "longitude": "42.89595000"
                    },
                    {
                        "id": 101301,
                        "name": "Shenkurskiy Rayon",
                        "latitude": "62.25000000",
                        "longitude": "42.41667000"
                    },
                    {
                        "id": 101323,
                        "name": "Shipitsyno",
                        "latitude": "61.28056000",
                        "longitude": "46.52083000"
                    },
                    {
                        "id": 101474,
                        "name": "Sol’vychegodsk",
                        "latitude": "61.33046000",
                        "longitude": "46.91559000"
                    },
                    {
                        "id": 101448,
                        "name": "Solginskiy",
                        "latitude": "61.05000000",
                        "longitude": "41.34278000"
                    },
                    {
                        "id": 102022,
                        "name": "Udimskiy",
                        "latitude": "61.14171000",
                        "longitude": "45.91443000"
                    },
                    {
                        "id": 102074,
                        "name": "Urdoma",
                        "latitude": "61.75335000",
                        "longitude": "48.54420000"
                    },
                    {
                        "id": 102138,
                        "name": "Ust’-Shonosha",
                        "latitude": "61.15310000",
                        "longitude": "41.34300000"
                    },
                    {
                        "id": 102144,
                        "name": "Ust’yanskiy Rayon",
                        "latitude": "61.33333000",
                        "longitude": "43.66667000"
                    },
                    {
                        "id": 102162,
                        "name": "Uyemskiy",
                        "latitude": "64.47430000",
                        "longitude": "40.85240000"
                    },
                    {
                        "id": 102203,
                        "name": "Vas’kovo",
                        "latitude": "64.41220000",
                        "longitude": "40.46390000"
                    },
                    {
                        "id": 102221,
                        "name": "Vel’sk",
                        "latitude": "61.07006000",
                        "longitude": "42.09830000"
                    },
                    {
                        "id": 102222,
                        "name": "Vel’skiy Rayon",
                        "latitude": "61.00000000",
                        "longitude": "42.00000000"
                    },
                    {
                        "id": 102274,
                        "name": "Verkhnyaya Toyma",
                        "latitude": "62.23470000",
                        "longitude": "45.00090000"
                    },
                    {
                        "id": 102360,
                        "name": "Voloshka",
                        "latitude": "61.33139000",
                        "longitude": "40.08583000"
                    },
                    {
                        "id": 102427,
                        "name": "Vychegodskiy",
                        "latitude": "61.24702000",
                        "longitude": "46.89842000"
                    },
                    {
                        "id": 102462,
                        "name": "Yagry",
                        "latitude": "64.59417000",
                        "longitude": "39.81028000"
                    },
                    {
                        "id": 102494,
                        "name": "Yarensk",
                        "latitude": "62.16755000",
                        "longitude": "49.09162000"
                    },
                    {
                        "id": 102557,
                        "name": "Yemetsk",
                        "latitude": "63.47191000",
                        "longitude": "41.78023000"
                    },
                    {
                        "id": 102558,
                        "name": "Yemtsa",
                        "latitude": "63.07337000",
                        "longitude": "40.33285000"
                    },
                    {
                        "id": 102575,
                        "name": "Yertsevo",
                        "latitude": "60.79660000",
                        "longitude": "40.08600000"
                    }
                ]
            },
            {
                "id": 1866,
                "name": "Astrakhan",
                "iso2": "AST",
                "latitude": "46.13211660",
                "longitude": "48.06101150",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97530,
                        "name": "Akhtubinsk",
                        "latitude": "48.27955000",
                        "longitude": "46.17217000"
                    },
                    {
                        "id": 97531,
                        "name": "Akhtubinskiy Rayon",
                        "latitude": "48.16667000",
                        "longitude": "46.25000000"
                    },
                    {
                        "id": 97539,
                        "name": "Aksarayskiy",
                        "latitude": "46.79244000",
                        "longitude": "48.01188000"
                    },
                    {
                        "id": 97706,
                        "name": "Astrakhan",
                        "latitude": "46.34968000",
                        "longitude": "48.04076000"
                    },
                    {
                        "id": 98228,
                        "name": "Chyorny Yar",
                        "latitude": "48.06242000",
                        "longitude": "46.10911000"
                    },
                    {
                        "id": 98640,
                        "name": "Ikryanoye",
                        "latitude": "46.09323000",
                        "longitude": "47.73078000"
                    },
                    {
                        "id": 98831,
                        "name": "Kamyzyak",
                        "latitude": "46.10995000",
                        "longitude": "48.07364000"
                    },
                    {
                        "id": 98849,
                        "name": "Kapustin Yar",
                        "latitude": "48.58175000",
                        "longitude": "45.74481000"
                    },
                    {
                        "id": 98867,
                        "name": "Karalat",
                        "latitude": "45.91555000",
                        "longitude": "48.30683000"
                    },
                    {
                        "id": 98963,
                        "name": "Kharabali",
                        "latitude": "47.41958000",
                        "longitude": "47.25678000"
                    },
                    {
                        "id": 99067,
                        "name": "Kirovskiy",
                        "latitude": "45.84639000",
                        "longitude": "48.12472000"
                    },
                    {
                        "id": 99347,
                        "name": "Krasnoyarskiy Rayon",
                        "latitude": "46.83333000",
                        "longitude": "48.25000000"
                    },
                    {
                        "id": 99377,
                        "name": "Krasnyy Yar",
                        "latitude": "46.53314000",
                        "longitude": "48.34559000"
                    },
                    {
                        "id": 99382,
                        "name": "Krasnyye Barrikady",
                        "latitude": "46.20450000",
                        "longitude": "47.85350000"
                    },
                    {
                        "id": 99628,
                        "name": "Liman",
                        "latitude": "45.78457000",
                        "longitude": "47.22405000"
                    },
                    {
                        "id": 99629,
                        "name": "Limanskiy Rayon",
                        "latitude": "45.83333000",
                        "longitude": "47.25000000"
                    },
                    {
                        "id": 99792,
                        "name": "Marfino",
                        "latitude": "46.40852000",
                        "longitude": "48.71398000"
                    },
                    {
                        "id": 100002,
                        "name": "Mumra",
                        "latitude": "45.77251000",
                        "longitude": "47.65398000"
                    },
                    {
                        "id": 100038,
                        "name": "Nachalovo",
                        "latitude": "46.33800000",
                        "longitude": "48.20128000"
                    },
                    {
                        "id": 100058,
                        "name": "Narimanov",
                        "latitude": "46.69270000",
                        "longitude": "47.84980000"
                    },
                    {
                        "id": 100163,
                        "name": "Nizhniy Baskunchak",
                        "latitude": "48.21978000",
                        "longitude": "46.83105000"
                    },
                    {
                        "id": 100456,
                        "name": "Oranzherei",
                        "latitude": "45.84756000",
                        "longitude": "47.56635000"
                    },
                    {
                        "id": 100752,
                        "name": "Poldnëvoye",
                        "latitude": "45.85568000",
                        "longitude": "47.95241000"
                    },
                    {
                        "id": 100849,
                        "name": "Privolzhskiy Rayon",
                        "latitude": "46.25000000",
                        "longitude": "48.16667000"
                    },
                    {
                        "id": 101129,
                        "name": "Sasykoli",
                        "latitude": "47.55153000",
                        "longitude": "46.99679000"
                    },
                    {
                        "id": 101386,
                        "name": "Sizyy Bugor",
                        "latitude": "46.21343000",
                        "longitude": "48.50462000"
                    },
                    {
                        "id": 101471,
                        "name": "Solyanka",
                        "latitude": "46.38890000",
                        "longitude": "48.01755000"
                    },
                    {
                        "id": 101583,
                        "name": "Starokucherganovka",
                        "latitude": "46.32476000",
                        "longitude": "47.95550000"
                    },
                    {
                        "id": 101762,
                        "name": "Tambovka",
                        "latitude": "47.31528000",
                        "longitude": "47.37773000"
                    },
                    {
                        "id": 101931,
                        "name": "Trudfront",
                        "latitude": "45.93460000",
                        "longitude": "47.66929000"
                    },
                    {
                        "id": 101968,
                        "name": "Tumak",
                        "latitude": "46.23436000",
                        "longitude": "48.50627000"
                    },
                    {
                        "id": 102156,
                        "name": "Uvary",
                        "latitude": "46.04575000",
                        "longitude": "48.03558000"
                    },
                    {
                        "id": 102250,
                        "name": "Verkhniy Baskunchak",
                        "latitude": "48.22564000",
                        "longitude": "46.72169000"
                    },
                    {
                        "id": 102343,
                        "name": "Volgo-Kaspiyskiy",
                        "latitude": "46.20306000",
                        "longitude": "47.91869000"
                    },
                    {
                        "id": 102352,
                        "name": "Volodarskiy",
                        "latitude": "46.40134000",
                        "longitude": "48.54093000"
                    },
                    {
                        "id": 102472,
                        "name": "Yaksatovo",
                        "latitude": "46.24343000",
                        "longitude": "48.01514000"
                    },
                    {
                        "id": 102482,
                        "name": "Yandyki",
                        "latitude": "45.76913000",
                        "longitude": "47.12577000"
                    },
                    {
                        "id": 102562,
                        "name": "Yenotayevka",
                        "latitude": "47.24559000",
                        "longitude": "47.02814000"
                    },
                    {
                        "id": 102706,
                        "name": "Zenzeli",
                        "latitude": "45.92407000",
                        "longitude": "47.04739000"
                    },
                    {
                        "id": 102759,
                        "name": "Znamensk",
                        "latitude": "48.58420000",
                        "longitude": "45.73380000"
                    }
                ]
            },
            {
                "id": 1854,
                "name": "Bashkortostan",
                "iso2": "BA",
                "latitude": "54.23121720",
                "longitude": "56.16452570",
                "type": "republic",
                "cities": [
                    {
                        "id": 97492,
                        "name": "Abzakovo",
                        "latitude": "53.82861000",
                        "longitude": "58.59333000"
                    },
                    {
                        "id": 97493,
                        "name": "Abzelilovskiy Rayon",
                        "latitude": "53.41667000",
                        "longitude": "58.50000000"
                    },
                    {
                        "id": 97516,
                        "name": "Agidel’",
                        "latitude": "55.90770000",
                        "longitude": "53.93550000"
                    },
                    {
                        "id": 97552,
                        "name": "Ak”yar",
                        "latitude": "51.85905000",
                        "longitude": "58.22136000"
                    },
                    {
                        "id": 97535,
                        "name": "Akhunovo",
                        "latitude": "54.20790000",
                        "longitude": "59.60170000"
                    },
                    {
                        "id": 97538,
                        "name": "Aksakovo",
                        "latitude": "54.03333000",
                        "longitude": "54.15000000"
                    },
                    {
                        "id": 97610,
                        "name": "Al’sheyevskiy Rayon",
                        "latitude": "54.00000000",
                        "longitude": "55.00000000"
                    },
                    {
                        "id": 97577,
                        "name": "Alekseyevka",
                        "latitude": "54.85000000",
                        "longitude": "55.23333000"
                    },
                    {
                        "id": 97616,
                        "name": "Amzya",
                        "latitude": "56.23460000",
                        "longitude": "54.38500000"
                    },
                    {
                        "id": 97692,
                        "name": "Asanovo",
                        "latitude": "54.89418000",
                        "longitude": "55.49083000"
                    },
                    {
                        "id": 97702,
                        "name": "Askino",
                        "latitude": "56.09013000",
                        "longitude": "56.57831000"
                    },
                    {
                        "id": 97703,
                        "name": "Askinskiy Rayon",
                        "latitude": "56.08333000",
                        "longitude": "56.58333000"
                    },
                    {
                        "id": 97721,
                        "name": "Avdon",
                        "latitude": "54.66667000",
                        "longitude": "55.71667000"
                    },
                    {
                        "id": 97757,
                        "name": "Bakalinskiy Rayon",
                        "latitude": "55.16667000",
                        "longitude": "53.75000000"
                    },
                    {
                        "id": 97758,
                        "name": "Bakaly",
                        "latitude": "55.17889000",
                        "longitude": "53.80278000"
                    },
                    {
                        "id": 97826,
                        "name": "Baymak",
                        "latitude": "52.59333000",
                        "longitude": "58.32250000"
                    },
                    {
                        "id": 97833,
                        "name": "Bedeyeva Polyana",
                        "latitude": "55.32345000",
                        "longitude": "56.38882000"
                    },
                    {
                        "id": 97846,
                        "name": "Belebey",
                        "latitude": "54.11667000",
                        "longitude": "54.11667000"
                    },
                    {
                        "id": 97864,
                        "name": "Beloretsk",
                        "latitude": "53.96306000",
                        "longitude": "58.39806000"
                    },
                    {
                        "id": 97865,
                        "name": "Beloretskiy Rayon",
                        "latitude": "54.00000000",
                        "longitude": "58.00000000"
                    },
                    {
                        "id": 97937,
                        "name": "Birsk",
                        "latitude": "55.42111000",
                        "longitude": "55.54278000"
                    },
                    {
                        "id": 97943,
                        "name": "Bizhbulyak",
                        "latitude": "53.69670000",
                        "longitude": "54.26420000"
                    },
                    {
                        "id": 97948,
                        "name": "Blagoveshchensk",
                        "latitude": "55.03500000",
                        "longitude": "55.97806000"
                    },
                    {
                        "id": 98075,
                        "name": "Bulgakovo",
                        "latitude": "54.49680000",
                        "longitude": "55.88430000"
                    },
                    {
                        "id": 98077,
                        "name": "Burayevo",
                        "latitude": "55.84069000",
                        "longitude": "55.40834000"
                    },
                    {
                        "id": 98081,
                        "name": "Buribay",
                        "latitude": "51.96167000",
                        "longitude": "58.15917000"
                    },
                    {
                        "id": 98094,
                        "name": "Buzdyak",
                        "latitude": "54.58333000",
                        "longitude": "54.55000000"
                    },
                    {
                        "id": 98095,
                        "name": "Buzdyakskiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "54.50000000"
                    },
                    {
                        "id": 98137,
                        "name": "Chekmagush",
                        "latitude": "55.13194000",
                        "longitude": "54.65556000"
                    },
                    {
                        "id": 98193,
                        "name": "Chesnokovka",
                        "latitude": "54.61242000",
                        "longitude": "55.94575000"
                    },
                    {
                        "id": 98198,
                        "name": "Chishmy",
                        "latitude": "54.57648000",
                        "longitude": "55.37642000"
                    },
                    {
                        "id": 98249,
                        "name": "Davlekanovo",
                        "latitude": "54.22145000",
                        "longitude": "55.03434000"
                    },
                    {
                        "id": 98282,
                        "name": "Dmitriyevka",
                        "latitude": "54.75000000",
                        "longitude": "55.33333000"
                    },
                    {
                        "id": 98357,
                        "name": "Duvan",
                        "latitude": "55.69497000",
                        "longitude": "57.90237000"
                    },
                    {
                        "id": 98366,
                        "name": "Dyurtyuli",
                        "latitude": "55.49106000",
                        "longitude": "54.86883000"
                    },
                    {
                        "id": 98443,
                        "name": "Fëdorovskiy Rayon",
                        "latitude": "53.08333000",
                        "longitude": "55.25000000"
                    },
                    {
                        "id": 98632,
                        "name": "Iglino",
                        "latitude": "54.83244000",
                        "longitude": "56.41264000"
                    },
                    {
                        "id": 98682,
                        "name": "Inzer",
                        "latitude": "54.21670000",
                        "longitude": "57.55560000"
                    },
                    {
                        "id": 98705,
                        "name": "Ishimbay",
                        "latitude": "53.45446000",
                        "longitude": "56.04149000"
                    },
                    {
                        "id": 98722,
                        "name": "Isyangulovo",
                        "latitude": "52.18584000",
                        "longitude": "56.58043000"
                    },
                    {
                        "id": 98762,
                        "name": "Kabakovo",
                        "latitude": "54.53690000",
                        "longitude": "56.15170000"
                    },
                    {
                        "id": 98800,
                        "name": "Kaltasy",
                        "latitude": "55.96926000",
                        "longitude": "54.80321000"
                    },
                    {
                        "id": 98839,
                        "name": "Kandry",
                        "latitude": "54.56667000",
                        "longitude": "54.11667000"
                    },
                    {
                        "id": 98864,
                        "name": "Karaidel’",
                        "latitude": "55.83373000",
                        "longitude": "56.90692000"
                    },
                    {
                        "id": 98882,
                        "name": "Karmaskaly",
                        "latitude": "54.37090000",
                        "longitude": "56.18370000"
                    },
                    {
                        "id": 98975,
                        "name": "Khaybullinskiy Rayon",
                        "latitude": "52.00000000",
                        "longitude": "58.25000000"
                    },
                    {
                        "id": 99054,
                        "name": "Kirgiz-Miyaki",
                        "latitude": "53.63240000",
                        "longitude": "54.79790000"
                    },
                    {
                        "id": 99280,
                        "name": "Krasnaya Gorka",
                        "latitude": "55.19617000",
                        "longitude": "56.66727000"
                    },
                    {
                        "id": 99324,
                        "name": "Krasnokholmskiy",
                        "latitude": "55.98729000",
                        "longitude": "55.04659000"
                    },
                    {
                        "id": 99364,
                        "name": "Krasnyy Klyuch",
                        "latitude": "55.38625000",
                        "longitude": "56.65287000"
                    },
                    {
                        "id": 99420,
                        "name": "Kudeyevskiy",
                        "latitude": "54.87583000",
                        "longitude": "56.75667000"
                    },
                    {
                        "id": 99440,
                        "name": "Kumertau",
                        "latitude": "52.76667000",
                        "longitude": "55.78333000"
                    },
                    {
                        "id": 99487,
                        "name": "Kushnarënkovo",
                        "latitude": "55.10500000",
                        "longitude": "55.35083000"
                    },
                    {
                        "id": 99659,
                        "name": "Lomovka",
                        "latitude": "53.91944000",
                        "longitude": "58.36722000"
                    },
                    {
                        "id": 99737,
                        "name": "Maginsk",
                        "latitude": "55.76338000",
                        "longitude": "56.96583000"
                    },
                    {
                        "id": 99818,
                        "name": "Mayachnyy",
                        "latitude": "52.68390000",
                        "longitude": "55.68500000"
                    },
                    {
                        "id": 99839,
                        "name": "Mechetlinskiy Rayon",
                        "latitude": "55.91667000",
                        "longitude": "58.25000000"
                    },
                    {
                        "id": 99855,
                        "name": "Meleuz",
                        "latitude": "52.96467000",
                        "longitude": "55.93277000"
                    },
                    {
                        "id": 99872,
                        "name": "Mesyagutovo",
                        "latitude": "55.53028000",
                        "longitude": "58.25278000"
                    },
                    {
                        "id": 99877,
                        "name": "Mezgor'e",
                        "latitude": "54.04976000",
                        "longitude": "57.81713000"
                    },
                    {
                        "id": 99897,
                        "name": "Mikhaylovka",
                        "latitude": "54.80500000",
                        "longitude": "55.89193000"
                    },
                    {
                        "id": 99916,
                        "name": "Mindyak",
                        "latitude": "54.02310000",
                        "longitude": "58.78910000"
                    },
                    {
                        "id": 99928,
                        "name": "Mishkino",
                        "latitude": "53.99970000",
                        "longitude": "59.10640000"
                    },
                    {
                        "id": 99930,
                        "name": "Mishkinskiy Rayon",
                        "latitude": "55.58333000",
                        "longitude": "56.00000000"
                    },
                    {
                        "id": 99933,
                        "name": "Miyakinskiy Rayon",
                        "latitude": "53.58333000",
                        "longitude": "54.83333000"
                    },
                    {
                        "id": 99988,
                        "name": "Mrakovo",
                        "latitude": "52.71611000",
                        "longitude": "56.62444000"
                    },
                    {
                        "id": 100017,
                        "name": "Mursalimkino",
                        "latitude": "55.03790000",
                        "longitude": "58.55850000"
                    },
                    {
                        "id": 100086,
                        "name": "Neftekamsk",
                        "latitude": "56.09200000",
                        "longitude": "54.26610000"
                    },
                    {
                        "id": 100140,
                        "name": "Nikolo-Berëzovka",
                        "latitude": "56.12422000",
                        "longitude": "54.15573000"
                    },
                    {
                        "id": 100159,
                        "name": "Nizhnetroitskiy",
                        "latitude": "54.33852000",
                        "longitude": "53.68329000"
                    },
                    {
                        "id": 100227,
                        "name": "Novobelokatay",
                        "latitude": "55.70620000",
                        "longitude": "58.95490000"
                    },
                    {
                        "id": 100369,
                        "name": "Nurimanovskiy Rayon",
                        "latitude": "54.75000000",
                        "longitude": "56.66667000"
                    },
                    {
                        "id": 100411,
                        "name": "Oktyabr’skiy",
                        "latitude": "54.48147000",
                        "longitude": "53.47103000"
                    },
                    {
                        "id": 100567,
                        "name": "Pavlovka",
                        "latitude": "55.42094000",
                        "longitude": "56.55426000"
                    },
                    {
                        "id": 100853,
                        "name": "Priyutovo",
                        "latitude": "53.90000000",
                        "longitude": "53.93333000"
                    },
                    {
                        "id": 100948,
                        "name": "Rayevskiy",
                        "latitude": "54.06580000",
                        "longitude": "54.94680000"
                    },
                    {
                        "id": 101078,
                        "name": "Salavat",
                        "latitude": "53.38365000",
                        "longitude": "55.90773000"
                    },
                    {
                        "id": 101164,
                        "name": "Semiletka",
                        "latitude": "55.36028000",
                        "longitude": "54.61528000"
                    },
                    {
                        "id": 101173,
                        "name": "Serafimovskiy",
                        "latitude": "54.42408000",
                        "longitude": "53.79640000"
                    },
                    {
                        "id": 101234,
                        "name": "Shafranovo",
                        "latitude": "53.96667000",
                        "longitude": "54.76667000"
                    },
                    {
                        "id": 101258,
                        "name": "Sharan",
                        "latitude": "54.81667000",
                        "longitude": "54.00000000"
                    },
                    {
                        "id": 101366,
                        "name": "Sibay",
                        "latitude": "52.71806000",
                        "longitude": "58.66583000"
                    },
                    {
                        "id": 101573,
                        "name": "Starobaltachevo",
                        "latitude": "56.00170000",
                        "longitude": "55.92800000"
                    },
                    {
                        "id": 101595,
                        "name": "Starosubkhangulovo",
                        "latitude": "53.10310000",
                        "longitude": "57.44230000"
                    },
                    {
                        "id": 101618,
                        "name": "Sterlibashevo",
                        "latitude": "53.43755000",
                        "longitude": "55.25780000"
                    },
                    {
                        "id": 101619,
                        "name": "Sterlitamak",
                        "latitude": "53.62462000",
                        "longitude": "55.95015000"
                    },
                    {
                        "id": 101640,
                        "name": "Subkhankulovo",
                        "latitude": "54.55741000",
                        "longitude": "53.81153000"
                    },
                    {
                        "id": 101822,
                        "name": "Temyasovo",
                        "latitude": "52.99333000",
                        "longitude": "58.10139000"
                    },
                    {
                        "id": 101862,
                        "name": "Tirlyanskiy",
                        "latitude": "54.21090000",
                        "longitude": "58.58060000"
                    },
                    {
                        "id": 101876,
                        "name": "Tolbazy",
                        "latitude": "54.02408000",
                        "longitude": "55.88248000"
                    },
                    {
                        "id": 101959,
                        "name": "Tubinskiy",
                        "latitude": "52.88917000",
                        "longitude": "58.22250000"
                    },
                    {
                        "id": 101964,
                        "name": "Tukan",
                        "latitude": "53.84090000",
                        "longitude": "57.45520000"
                    },
                    {
                        "id": 101986,
                        "name": "Tuymazy",
                        "latitude": "54.60666000",
                        "longitude": "53.70970000"
                    },
                    {
                        "id": 102013,
                        "name": "Uchaly",
                        "latitude": "54.35806000",
                        "longitude": "59.43611000"
                    },
                    {
                        "id": 102025,
                        "name": "Ufa",
                        "latitude": "54.74306000",
                        "longitude": "55.96779000"
                    },
                    {
                        "id": 102049,
                        "name": "Ulu-Telyak",
                        "latitude": "54.91570000",
                        "longitude": "56.98270000"
                    },
                    {
                        "id": 102050,
                        "name": "Ulukulevo",
                        "latitude": "54.43550000",
                        "longitude": "56.32210000"
                    },
                    {
                        "id": 102080,
                        "name": "Urman",
                        "latitude": "54.88314000",
                        "longitude": "56.87417000"
                    },
                    {
                        "id": 102246,
                        "name": "Verkhneyarkeyevo",
                        "latitude": "55.45046000",
                        "longitude": "54.31455000"
                    },
                    {
                        "id": 102249,
                        "name": "Verkhniy Avzyan",
                        "latitude": "53.52889000",
                        "longitude": "57.53722000"
                    },
                    {
                        "id": 102261,
                        "name": "Verkhniye Kigi",
                        "latitude": "55.40833000",
                        "longitude": "58.60444000"
                    },
                    {
                        "id": 102264,
                        "name": "Verkhniye Tatyshly",
                        "latitude": "56.29117000",
                        "longitude": "55.85750000"
                    },
                    {
                        "id": 102394,
                        "name": "Voskresenskoye",
                        "latitude": "53.12336000",
                        "longitude": "56.14664000"
                    },
                    {
                        "id": 102480,
                        "name": "Yanaul",
                        "latitude": "56.27510000",
                        "longitude": "54.93380000"
                    },
                    {
                        "id": 102481,
                        "name": "Yanaul’skiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "54.91667000"
                    },
                    {
                        "id": 102520,
                        "name": "Yazykovo",
                        "latitude": "55.21988000",
                        "longitude": "56.13532000"
                    },
                    {
                        "id": 102565,
                        "name": "Yermekeyevo",
                        "latitude": "54.07614000",
                        "longitude": "53.67125000"
                    },
                    {
                        "id": 102567,
                        "name": "Yermolayevo",
                        "latitude": "52.71667000",
                        "longitude": "55.80000000"
                    },
                    {
                        "id": 102592,
                        "name": "Yumaguzino",
                        "latitude": "52.90412000",
                        "longitude": "56.39329000"
                    },
                    {
                        "id": 102747,
                        "name": "Zilair",
                        "latitude": "52.23320000",
                        "longitude": "57.43920000"
                    },
                    {
                        "id": 102749,
                        "name": "Zirgan",
                        "latitude": "53.22220000",
                        "longitude": "55.91850000"
                    }
                ]
            },
            {
                "id": 1903,
                "name": "Belgorod",
                "iso2": "BEL",
                "latitude": "50.71069260",
                "longitude": "37.75333770",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97579,
                        "name": "Alekseyevka",
                        "latitude": "50.63090000",
                        "longitude": "38.69030000"
                    },
                    {
                        "id": 97837,
                        "name": "Bekhteyevka",
                        "latitude": "50.80758000",
                        "longitude": "37.21789000"
                    },
                    {
                        "id": 97848,
                        "name": "Belgorod",
                        "latitude": "50.61074000",
                        "longitude": "36.58015000"
                    },
                    {
                        "id": 97849,
                        "name": "Belgorodskiy Rayon",
                        "latitude": "50.50000000",
                        "longitude": "36.50000000"
                    },
                    {
                        "id": 97914,
                        "name": "Bessonovka",
                        "latitude": "50.52644000",
                        "longitude": "36.30107000"
                    },
                    {
                        "id": 98028,
                        "name": "Borisovka",
                        "latitude": "50.60155000",
                        "longitude": "36.01549000"
                    },
                    {
                        "id": 98029,
                        "name": "Borisovskiy Rayon",
                        "latitude": "50.58333000",
                        "longitude": "36.00000000"
                    },
                    {
                        "id": 98178,
                        "name": "Chernyanka",
                        "latitude": "50.94095000",
                        "longitude": "37.80693000"
                    },
                    {
                        "id": 98179,
                        "name": "Chernyanskiy Rayon",
                        "latitude": "51.00000000",
                        "longitude": "37.91667000"
                    },
                    {
                        "id": 98507,
                        "name": "Golovchino",
                        "latitude": "50.53410000",
                        "longitude": "35.79700000"
                    },
                    {
                        "id": 98577,
                        "name": "Grayvoron",
                        "latitude": "50.47670000",
                        "longitude": "35.67730000"
                    },
                    {
                        "id": 98578,
                        "name": "Grayvoronskiy Rayon",
                        "latitude": "50.50000000",
                        "longitude": "35.66667000"
                    },
                    {
                        "id": 98603,
                        "name": "Gubkin",
                        "latitude": "51.28167000",
                        "longitude": "37.54583000"
                    },
                    {
                        "id": 98647,
                        "name": "Ilovka",
                        "latitude": "50.70530000",
                        "longitude": "38.63700000"
                    },
                    {
                        "id": 98739,
                        "name": "Ivnya",
                        "latitude": "51.06294000",
                        "longitude": "36.13426000"
                    },
                    {
                        "id": 98740,
                        "name": "Ivnyanskiy Rayon",
                        "latitude": "51.00000000",
                        "longitude": "36.25000000"
                    },
                    {
                        "id": 99212,
                        "name": "Korocha",
                        "latitude": "50.81320000",
                        "longitude": "37.18598000"
                    },
                    {
                        "id": 99213,
                        "name": "Korochanskiy Rayon",
                        "latitude": "50.83333000",
                        "longitude": "37.25000000"
                    },
                    {
                        "id": 99286,
                        "name": "Krasnaya Yaruga",
                        "latitude": "50.80083000",
                        "longitude": "35.65833000"
                    },
                    {
                        "id": 99288,
                        "name": "Krasnenskiy Rayon",
                        "latitude": "50.91667000",
                        "longitude": "38.58333000"
                    },
                    {
                        "id": 99314,
                        "name": "Krasnogvardeyskiy Rayon",
                        "latitude": "50.66667000",
                        "longitude": "38.33333000"
                    },
                    {
                        "id": 99318,
                        "name": "Krasnogvardeyskoye",
                        "latitude": "50.64920000",
                        "longitude": "38.40360000"
                    },
                    {
                        "id": 99348,
                        "name": "Krasnoyaruzhskiy Rayon",
                        "latitude": "50.83333000",
                        "longitude": "35.50000000"
                    },
                    {
                        "id": 99350,
                        "name": "Krasnoye",
                        "latitude": "50.92970000",
                        "longitude": "38.68170000"
                    },
                    {
                        "id": 99643,
                        "name": "Livenka",
                        "latitude": "50.44910000",
                        "longitude": "38.29590000"
                    },
                    {
                        "id": 99810,
                        "name": "Maslova Pristan’",
                        "latitude": "50.45758000",
                        "longitude": "36.72038000"
                    },
                    {
                        "id": 99831,
                        "name": "Mayskiy",
                        "latitude": "50.51988000",
                        "longitude": "36.45878000"
                    },
                    {
                        "id": 100210,
                        "name": "Novaya Tavolzhanka",
                        "latitude": "50.35123000",
                        "longitude": "36.82980000"
                    },
                    {
                        "id": 100276,
                        "name": "Novooskol’skiy Rayon",
                        "latitude": "50.75000000",
                        "longitude": "37.83333000"
                    },
                    {
                        "id": 100348,
                        "name": "Novyy Oskol",
                        "latitude": "50.76330000",
                        "longitude": "37.86402000"
                    },
                    {
                        "id": 100857,
                        "name": "Prokhorovka",
                        "latitude": "51.03741000",
                        "longitude": "36.73252000"
                    },
                    {
                        "id": 100858,
                        "name": "Prokhorovskiy Rayon",
                        "latitude": "51.00447000",
                        "longitude": "36.74875000"
                    },
                    {
                        "id": 100864,
                        "name": "Proletarskiy",
                        "latitude": "50.79139000",
                        "longitude": "35.77306000"
                    },
                    {
                        "id": 100911,
                        "name": "Pyatnitskoye",
                        "latitude": "50.42330000",
                        "longitude": "37.82730000"
                    },
                    {
                        "id": 100932,
                        "name": "Rakitnoye",
                        "latitude": "50.83890000",
                        "longitude": "35.85150000"
                    },
                    {
                        "id": 100933,
                        "name": "Rakityanskiy Rayon",
                        "latitude": "50.83333000",
                        "longitude": "35.91667000"
                    },
                    {
                        "id": 100952,
                        "name": "Razumnoye",
                        "latitude": "50.53439000",
                        "longitude": "36.68462000"
                    },
                    {
                        "id": 100984,
                        "name": "Rogovatoye",
                        "latitude": "51.23000000",
                        "longitude": "38.38180000"
                    },
                    {
                        "id": 101010,
                        "name": "Roven’skiy Rayon",
                        "latitude": "50.00000000",
                        "longitude": "39.00000000"
                    },
                    {
                        "id": 101208,
                        "name": "Severnyy",
                        "latitude": "50.67704000",
                        "longitude": "36.55324000"
                    },
                    {
                        "id": 101284,
                        "name": "Shebekino",
                        "latitude": "50.40967000",
                        "longitude": "36.91360000"
                    },
                    {
                        "id": 101285,
                        "name": "Shebekinskiy Rayon",
                        "latitude": "50.50000000",
                        "longitude": "37.00000000"
                    },
                    {
                        "id": 101390,
                        "name": "Skorodnoye",
                        "latitude": "51.07101000",
                        "longitude": "37.22756000"
                    },
                    {
                        "id": 101607,
                        "name": "Staryy Oskol",
                        "latitude": "51.29667000",
                        "longitude": "37.84167000"
                    },
                    {
                        "id": 101631,
                        "name": "Stroitel’",
                        "latitude": "50.78543000",
                        "longitude": "36.48310000"
                    },
                    {
                        "id": 101883,
                        "name": "Tomarovka",
                        "latitude": "50.68338000",
                        "longitude": "36.23309000"
                    },
                    {
                        "id": 101917,
                        "name": "Troitskiy",
                        "latitude": "51.35880000",
                        "longitude": "37.52530000"
                    },
                    {
                        "id": 102073,
                        "name": "Urazovo",
                        "latitude": "50.08360000",
                        "longitude": "38.03950000"
                    },
                    {
                        "id": 102183,
                        "name": "Valuyki",
                        "latitude": "50.20350000",
                        "longitude": "38.10670000"
                    },
                    {
                        "id": 102184,
                        "name": "Valuyskiy Rayon",
                        "latitude": "50.16667000",
                        "longitude": "38.00000000"
                    },
                    {
                        "id": 102299,
                        "name": "Veydelevka",
                        "latitude": "50.15210000",
                        "longitude": "38.44920000"
                    },
                    {
                        "id": 102358,
                        "name": "Volokonovka",
                        "latitude": "50.48270000",
                        "longitude": "37.85630000"
                    },
                    {
                        "id": 102359,
                        "name": "Volokonovskiy Rayon",
                        "latitude": "50.50000000",
                        "longitude": "37.83333000"
                    },
                    {
                        "id": 102467,
                        "name": "Yakovlevo",
                        "latitude": "50.86033000",
                        "longitude": "36.44784000"
                    },
                    {
                        "id": 102469,
                        "name": "Yakovlevskiy Rayon",
                        "latitude": "50.83333000",
                        "longitude": "36.41667000"
                    },
                    {
                        "id": 102665,
                        "name": "Zasosna",
                        "latitude": "50.63070000",
                        "longitude": "38.39650000"
                    }
                ]
            },
            {
                "id": 1867,
                "name": "Bryansk",
                "iso2": "BRY",
                "latitude": "53.04085990",
                "longitude": "33.26909000",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97606,
                        "name": "Altukhovo",
                        "latitude": "52.67559000",
                        "longitude": "34.36703000"
                    },
                    {
                        "id": 97659,
                        "name": "Ardon’",
                        "latitude": "52.73524000",
                        "longitude": "32.30857000"
                    },
                    {
                        "id": 97882,
                        "name": "Belyye Berega",
                        "latitude": "53.20851000",
                        "longitude": "34.66405000"
                    },
                    {
                        "id": 98051,
                        "name": "Brasovskiy Rayon",
                        "latitude": "52.66667000",
                        "longitude": "34.75000000"
                    },
                    {
                        "id": 98060,
                        "name": "Bryansk",
                        "latitude": "53.25209000",
                        "longitude": "34.37167000"
                    },
                    {
                        "id": 98061,
                        "name": "Bryanskiy Rayon",
                        "latitude": "53.25000000",
                        "longitude": "34.41667000"
                    },
                    {
                        "id": 98104,
                        "name": "Bytosh’",
                        "latitude": "53.81861000",
                        "longitude": "34.09116000"
                    },
                    {
                        "id": 98226,
                        "name": "Churovichi",
                        "latitude": "52.16930000",
                        "longitude": "31.99260000"
                    },
                    {
                        "id": 98295,
                        "name": "Dobrun’",
                        "latitude": "53.18512000",
                        "longitude": "34.24625000"
                    },
                    {
                        "id": 98345,
                        "name": "Dubrovka",
                        "latitude": "53.69070000",
                        "longitude": "33.50710000"
                    },
                    {
                        "id": 98346,
                        "name": "Dubrovskiy Rayon",
                        "latitude": "53.66667000",
                        "longitude": "33.41667000"
                    },
                    {
                        "id": 98362,
                        "name": "Dyat’kovo",
                        "latitude": "53.59782000",
                        "longitude": "34.33825000"
                    },
                    {
                        "id": 98363,
                        "name": "Dyat’kovskiy Rayon",
                        "latitude": "53.66667000",
                        "longitude": "34.25000000"
                    },
                    {
                        "id": 98498,
                        "name": "Glinishchevo",
                        "latitude": "53.30416000",
                        "longitude": "34.06523000"
                    },
                    {
                        "id": 98520,
                        "name": "Gordeyevka",
                        "latitude": "52.95690000",
                        "longitude": "31.97030000"
                    },
                    {
                        "id": 98521,
                        "name": "Gordeyevskiy Rayon",
                        "latitude": "52.91667000",
                        "longitude": "31.91667000"
                    },
                    {
                        "id": 98547,
                        "name": "Gorod Bryansk",
                        "latitude": "53.25000000",
                        "longitude": "34.41667000"
                    },
                    {
                        "id": 98550,
                        "name": "Gorod Dyat’kovo",
                        "latitude": "53.60000000",
                        "longitude": "34.35000000"
                    },
                    {
                        "id": 98729,
                        "name": "Ivanovka",
                        "latitude": "53.34694000",
                        "longitude": "34.21917000"
                    },
                    {
                        "id": 98743,
                        "name": "Ivot",
                        "latitude": "53.67556000",
                        "longitude": "34.18722000"
                    },
                    {
                        "id": 98859,
                        "name": "Karachev",
                        "latitude": "53.12292000",
                        "longitude": "34.98517000"
                    },
                    {
                        "id": 99098,
                        "name": "Kletnya",
                        "latitude": "53.38967000",
                        "longitude": "33.21714000"
                    },
                    {
                        "id": 99099,
                        "name": "Kletnyanskiy Rayon",
                        "latitude": "53.33333000",
                        "longitude": "33.16667000"
                    },
                    {
                        "id": 99101,
                        "name": "Klimovo",
                        "latitude": "52.38053000",
                        "longitude": "32.19233000"
                    },
                    {
                        "id": 99103,
                        "name": "Klimovskiy Rayon",
                        "latitude": "52.25000000",
                        "longitude": "32.16667000"
                    },
                    {
                        "id": 99106,
                        "name": "Klintsovskiy Rayon",
                        "latitude": "52.75000000",
                        "longitude": "32.16667000"
                    },
                    {
                        "id": 99107,
                        "name": "Klintsy",
                        "latitude": "52.76019000",
                        "longitude": "32.23935000"
                    },
                    {
                        "id": 99130,
                        "name": "Kokino",
                        "latitude": "52.49640000",
                        "longitude": "34.78080000"
                    },
                    {
                        "id": 99131,
                        "name": "Kokorevka",
                        "latitude": "52.58740000",
                        "longitude": "34.26920000"
                    },
                    {
                        "id": 99158,
                        "name": "Komarichi",
                        "latitude": "52.41510000",
                        "longitude": "34.79050000"
                    },
                    {
                        "id": 99159,
                        "name": "Komarichskiy Rayon",
                        "latitude": "52.41667000",
                        "longitude": "34.75000000"
                    },
                    {
                        "id": 99223,
                        "name": "Korzhovka-Golubovka",
                        "latitude": "52.76742000",
                        "longitude": "32.35362000"
                    },
                    {
                        "id": 99277,
                        "name": "Krasnaya Gora",
                        "latitude": "52.99950000",
                        "longitude": "31.60230000"
                    },
                    {
                        "id": 99308,
                        "name": "Krasnogorskiy Rayon",
                        "latitude": "53.00000000",
                        "longitude": "31.50000000"
                    },
                    {
                        "id": 99654,
                        "name": "Lokot’",
                        "latitude": "52.56500000",
                        "longitude": "34.57760000"
                    },
                    {
                        "id": 99661,
                        "name": "Lopandino",
                        "latitude": "52.46660000",
                        "longitude": "34.81630000"
                    },
                    {
                        "id": 99719,
                        "name": "Lyubokhna",
                        "latitude": "53.50332000",
                        "longitude": "34.38847000"
                    },
                    {
                        "id": 99720,
                        "name": "Lyubovsho",
                        "latitude": "52.98510000",
                        "longitude": "31.54220000"
                    },
                    {
                        "id": 99887,
                        "name": "Mglin",
                        "latitude": "53.05907000",
                        "longitude": "32.84753000"
                    },
                    {
                        "id": 99888,
                        "name": "Mglinskiy Rayon",
                        "latitude": "53.16667000",
                        "longitude": "32.83333000"
                    },
                    {
                        "id": 100071,
                        "name": "Navlinskiy Rayon",
                        "latitude": "52.83333000",
                        "longitude": "34.41667000"
                    },
                    {
                        "id": 100072,
                        "name": "Navlya",
                        "latitude": "52.82544000",
                        "longitude": "34.49960000"
                    },
                    {
                        "id": 100114,
                        "name": "Net’inka",
                        "latitude": "53.34778000",
                        "longitude": "34.19111000"
                    },
                    {
                        "id": 100337,
                        "name": "Novozybkov",
                        "latitude": "52.53960000",
                        "longitude": "31.92750000"
                    },
                    {
                        "id": 100338,
                        "name": "Novozybkovskiy Rayon",
                        "latitude": "52.58333000",
                        "longitude": "31.83333000"
                    },
                    {
                        "id": 100349,
                        "name": "Novyy Ropsk",
                        "latitude": "52.29781000",
                        "longitude": "32.31206000"
                    },
                    {
                        "id": 100706,
                        "name": "Pochep",
                        "latitude": "52.93360000",
                        "longitude": "33.44640000"
                    },
                    {
                        "id": 100707,
                        "name": "Pochepskiy Rayon",
                        "latitude": "52.91667000",
                        "longitude": "33.50000000"
                    },
                    {
                        "id": 100735,
                        "name": "Pogar",
                        "latitude": "52.55399000",
                        "longitude": "33.25907000"
                    },
                    {
                        "id": 100736,
                        "name": "Pogarskiy Rayon",
                        "latitude": "52.50000000",
                        "longitude": "33.25000000"
                    },
                    {
                        "id": 100907,
                        "name": "Putëvka",
                        "latitude": "53.25833000",
                        "longitude": "34.28778000"
                    },
                    {
                        "id": 100924,
                        "name": "Raditsa-Krylovka",
                        "latitude": "53.31712000",
                        "longitude": "34.35742000"
                    },
                    {
                        "id": 100982,
                        "name": "Rognedino",
                        "latitude": "53.80147000",
                        "longitude": "33.55760000"
                    },
                    {
                        "id": 100983,
                        "name": "Rognedinskiy Rayon",
                        "latitude": "53.83333000",
                        "longitude": "33.66667000"
                    },
                    {
                        "id": 101058,
                        "name": "Rzhanitsa",
                        "latitude": "53.42844000",
                        "longitude": "33.92297000"
                    },
                    {
                        "id": 101063,
                        "name": "Sachkovichi",
                        "latitude": "52.34590000",
                        "longitude": "32.22460000"
                    },
                    {
                        "id": 101161,
                        "name": "Sel’tso",
                        "latitude": "53.36831000",
                        "longitude": "34.10328000"
                    },
                    {
                        "id": 101198,
                        "name": "Seshcha",
                        "latitude": "53.73610000",
                        "longitude": "33.33870000"
                    },
                    {
                        "id": 101224,
                        "name": "Sevsk",
                        "latitude": "52.14910000",
                        "longitude": "34.49260000"
                    },
                    {
                        "id": 101225,
                        "name": "Sevskiy Rayon",
                        "latitude": "52.08333000",
                        "longitude": "34.41667000"
                    },
                    {
                        "id": 101612,
                        "name": "Star’",
                        "latitude": "53.62362000",
                        "longitude": "34.15183000"
                    },
                    {
                        "id": 101577,
                        "name": "Starodub",
                        "latitude": "52.58444000",
                        "longitude": "32.76333000"
                    },
                    {
                        "id": 101578,
                        "name": "Starodubskiy Rayon",
                        "latitude": "52.50000000",
                        "longitude": "32.75000000"
                    },
                    {
                        "id": 101671,
                        "name": "Suponevo",
                        "latitude": "53.20492000",
                        "longitude": "34.29597000"
                    },
                    {
                        "id": 101673,
                        "name": "Surazh",
                        "latitude": "53.01747000",
                        "longitude": "32.39178000"
                    },
                    {
                        "id": 101674,
                        "name": "Surazhskiy Rayon",
                        "latitude": "53.08333000",
                        "longitude": "32.41667000"
                    },
                    {
                        "id": 101694,
                        "name": "Suzëmka",
                        "latitude": "52.31834000",
                        "longitude": "34.07899000"
                    },
                    {
                        "id": 101692,
                        "name": "Suzemskiy Rayon",
                        "latitude": "52.41667000",
                        "longitude": "34.16667000"
                    },
                    {
                        "id": 101697,
                        "name": "Sven’",
                        "latitude": "53.18222000",
                        "longitude": "34.55111000"
                    },
                    {
                        "id": 101928,
                        "name": "Trubchevsk",
                        "latitude": "52.57980000",
                        "longitude": "33.76440000"
                    },
                    {
                        "id": 101929,
                        "name": "Trubchevskiy Rayon",
                        "latitude": "52.58333000",
                        "longitude": "33.75000000"
                    },
                    {
                        "id": 102058,
                        "name": "Unecha",
                        "latitude": "52.84591000",
                        "longitude": "32.67394000"
                    },
                    {
                        "id": 102059,
                        "name": "Unechskiy Rayon",
                        "latitude": "52.83333000",
                        "longitude": "32.83333000"
                    },
                    {
                        "id": 102430,
                        "name": "Vygonichi",
                        "latitude": "53.09855000",
                        "longitude": "34.06728000"
                    },
                    {
                        "id": 102431,
                        "name": "Vygonichskiy Rayon",
                        "latitude": "53.08333000",
                        "longitude": "34.00000000"
                    },
                    {
                        "id": 102440,
                        "name": "Vyshkov",
                        "latitude": "52.47640000",
                        "longitude": "31.68730000"
                    },
                    {
                        "id": 102640,
                        "name": "Zamishevo",
                        "latitude": "52.53950000",
                        "longitude": "32.01290000"
                    },
                    {
                        "id": 102686,
                        "name": "Zaymishche",
                        "latitude": "52.72640000",
                        "longitude": "32.23340000"
                    },
                    {
                        "id": 102735,
                        "name": "Zhiryatino",
                        "latitude": "53.22280000",
                        "longitude": "33.73060000"
                    },
                    {
                        "id": 102736,
                        "name": "Zhiryatinskiy Rayon",
                        "latitude": "53.25000000",
                        "longitude": "33.58333000"
                    },
                    {
                        "id": 102741,
                        "name": "Zhukovka",
                        "latitude": "53.53395000",
                        "longitude": "33.72798000"
                    },
                    {
                        "id": 102744,
                        "name": "Zhukovskiy Rayon",
                        "latitude": "53.50000000",
                        "longitude": "33.83333000"
                    },
                    {
                        "id": 102751,
                        "name": "Zlynka",
                        "latitude": "52.42670000",
                        "longitude": "31.73780000"
                    }
                ]
            },
            {
                "id": 1842,
                "name": "Buryatia",
                "iso2": "BU",
                "latitude": "54.83311460",
                "longitude": "112.40605300",
                "type": "republic",
                "cities": [
                    {
                        "id": 97745,
                        "name": "Babushkin",
                        "latitude": "51.71222000",
                        "longitude": "105.86472000"
                    },
                    {
                        "id": 97753,
                        "name": "Bagdarin",
                        "latitude": "54.43333000",
                        "longitude": "113.60000000"
                    },
                    {
                        "id": 97794,
                        "name": "Barguzin",
                        "latitude": "53.61875000",
                        "longitude": "109.63904000"
                    },
                    {
                        "id": 97822,
                        "name": "Bayangol",
                        "latitude": "50.69770000",
                        "longitude": "103.46560000"
                    },
                    {
                        "id": 97925,
                        "name": "Bichura",
                        "latitude": "50.58806000",
                        "longitude": "107.60222000"
                    },
                    {
                        "id": 98011,
                        "name": "Bol’shoy Kunaley",
                        "latitude": "51.43203000",
                        "longitude": "107.60890000"
                    },
                    {
                        "id": 98377,
                        "name": "Dzhida",
                        "latitude": "50.67722000",
                        "longitude": "106.18056000"
                    },
                    {
                        "id": 98620,
                        "name": "Gusinoozyorsk",
                        "latitude": "51.28333000",
                        "longitude": "106.50000000"
                    },
                    {
                        "id": 98621,
                        "name": "Gusinoye Ozero",
                        "latitude": "51.11444000",
                        "longitude": "106.26139000"
                    },
                    {
                        "id": 98652,
                        "name": "Il’inka",
                        "latitude": "52.11944000",
                        "longitude": "107.27083000"
                    },
                    {
                        "id": 98659,
                        "name": "Il’ka",
                        "latitude": "51.72114000",
                        "longitude": "108.52169000"
                    },
                    {
                        "id": 98718,
                        "name": "Istok",
                        "latitude": "52.09528000",
                        "longitude": "106.24750000"
                    },
                    {
                        "id": 98741,
                        "name": "Ivolginsk",
                        "latitude": "51.74919000",
                        "longitude": "107.28374000"
                    },
                    {
                        "id": 98742,
                        "name": "Ivolginskiy Rayon",
                        "latitude": "51.83333000",
                        "longitude": "107.33333000"
                    },
                    {
                        "id": 98764,
                        "name": "Kabansk",
                        "latitude": "52.04861000",
                        "longitude": "106.65278000"
                    },
                    {
                        "id": 99000,
                        "name": "Kholtoson",
                        "latitude": "50.29810000",
                        "longitude": "103.30970000"
                    },
                    {
                        "id": 99003,
                        "name": "Khonkholoy",
                        "latitude": "51.13186000",
                        "longitude": "108.22515000"
                    },
                    {
                        "id": 99005,
                        "name": "Khorinsk",
                        "latitude": "52.16631000",
                        "longitude": "109.77626000"
                    },
                    {
                        "id": 99031,
                        "name": "Kichera",
                        "latitude": "55.93874000",
                        "longitude": "110.10122000"
                    },
                    {
                        "id": 99089,
                        "name": "Kizhinga",
                        "latitude": "51.84760000",
                        "longitude": "109.90795000"
                    },
                    {
                        "id": 99418,
                        "name": "Kudara-Somon",
                        "latitude": "50.15472000",
                        "longitude": "107.40139000"
                    },
                    {
                        "id": 99478,
                        "name": "Kurumkan",
                        "latitude": "54.32093000",
                        "longitude": "110.30651000"
                    },
                    {
                        "id": 99516,
                        "name": "Kyakhta",
                        "latitude": "50.35737000",
                        "longitude": "106.45033000"
                    },
                    {
                        "id": 99519,
                        "name": "Kyren",
                        "latitude": "51.68280000",
                        "longitude": "102.14080000"
                    },
                    {
                        "id": 99998,
                        "name": "Mukhorshibir’",
                        "latitude": "51.04986000",
                        "longitude": "107.82997000"
                    },
                    {
                        "id": 99997,
                        "name": "Mukhorshibirskiy Rayon",
                        "latitude": "51.08333000",
                        "longitude": "107.75000000"
                    },
                    {
                        "id": 100024,
                        "name": "Muyskiy Rayon",
                        "latitude": "56.33333000",
                        "longitude": "115.00000000"
                    },
                    {
                        "id": 100069,
                        "name": "Naushki",
                        "latitude": "50.38278000",
                        "longitude": "106.10556000"
                    },
                    {
                        "id": 100145,
                        "name": "Nikol’sk",
                        "latitude": "51.18867000",
                        "longitude": "108.32187000"
                    },
                    {
                        "id": 100138,
                        "name": "Nikolayevskiy",
                        "latitude": "51.65526000",
                        "longitude": "107.80068000"
                    },
                    {
                        "id": 100150,
                        "name": "Nizhneangarsk",
                        "latitude": "55.79326000",
                        "longitude": "109.58029000"
                    },
                    {
                        "id": 100175,
                        "name": "Nizhniy Sayantuy",
                        "latitude": "51.73751000",
                        "longitude": "107.51308000"
                    },
                    {
                        "id": 100200,
                        "name": "Novaya Bryan’",
                        "latitude": "51.71699000",
                        "longitude": "108.27014000"
                    },
                    {
                        "id": 100251,
                        "name": "Novokizhinginsk",
                        "latitude": "51.61620000",
                        "longitude": "109.60265000"
                    },
                    {
                        "id": 100351,
                        "name": "Novyy Uoyan",
                        "latitude": "56.15722000",
                        "longitude": "111.70556000"
                    },
                    {
                        "id": 100355,
                        "name": "Novyy Zagan",
                        "latitude": "51.02858000",
                        "longitude": "107.76376000"
                    },
                    {
                        "id": 100404,
                        "name": "Okino-Klyuchi",
                        "latitude": "50.59389000",
                        "longitude": "107.10944000"
                    },
                    {
                        "id": 100405,
                        "name": "Okinskiy Rayon",
                        "latitude": "52.50000000",
                        "longitude": "100.50000000"
                    },
                    {
                        "id": 100451,
                        "name": "Onokhoy",
                        "latitude": "51.92859000",
                        "longitude": "108.06693000"
                    },
                    {
                        "id": 100469,
                        "name": "Orlik",
                        "latitude": "52.51780000",
                        "longitude": "99.82500000"
                    },
                    {
                        "id": 100651,
                        "name": "Petropavlovka",
                        "latitude": "50.61140000",
                        "longitude": "105.31960000"
                    },
                    {
                        "id": 100816,
                        "name": "Pribaykal’skiy Rayon",
                        "latitude": "52.50000000",
                        "longitude": "108.00000000"
                    },
                    {
                        "id": 100957,
                        "name": "Rechka-Vydrino",
                        "latitude": "51.48920000",
                        "longitude": "104.84290000"
                    },
                    {
                        "id": 101072,
                        "name": "Sagan-Nur",
                        "latitude": "51.34360000",
                        "longitude": "108.44490000"
                    },
                    {
                        "id": 101151,
                        "name": "Selenduma",
                        "latitude": "50.91306000",
                        "longitude": "106.24056000"
                    },
                    {
                        "id": 101152,
                        "name": "Selenginskiy Rayon",
                        "latitude": "51.16667000",
                        "longitude": "106.33333000"
                    },
                    {
                        "id": 101211,
                        "name": "Severo-Baykal’skiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "111.50000000"
                    },
                    {
                        "id": 101216,
                        "name": "Severobaykal’sk",
                        "latitude": "55.63695000",
                        "longitude": "109.32297000"
                    },
                    {
                        "id": 101220,
                        "name": "Severomuysk",
                        "latitude": "56.14806000",
                        "longitude": "113.42667000"
                    },
                    {
                        "id": 101257,
                        "name": "Sharalday",
                        "latitude": "51.02528000",
                        "longitude": "107.64487000"
                    },
                    {
                        "id": 101434,
                        "name": "Sokol",
                        "latitude": "51.80036000",
                        "longitude": "107.44437000"
                    },
                    {
                        "id": 101492,
                        "name": "Sosnovo-Ozerskoye",
                        "latitude": "52.52466000",
                        "longitude": "111.54124000"
                    },
                    {
                        "id": 101500,
                        "name": "Sotnikovo",
                        "latitude": "51.88448000",
                        "longitude": "107.48250000"
                    },
                    {
                        "id": 101745,
                        "name": "Taksimo",
                        "latitude": "56.34162000",
                        "longitude": "114.90048000"
                    },
                    {
                        "id": 101766,
                        "name": "Tankhoy",
                        "latitude": "51.55683000",
                        "longitude": "105.12620000"
                    },
                    {
                        "id": 101772,
                        "name": "Tarbagatay",
                        "latitude": "51.48195000",
                        "longitude": "107.36158000"
                    },
                    {
                        "id": 101796,
                        "name": "Tataurovo",
                        "latitude": "52.14182000",
                        "longitude": "107.44054000"
                    },
                    {
                        "id": 101978,
                        "name": "Turka",
                        "latitude": "52.94920000",
                        "longitude": "108.22170000"
                    },
                    {
                        "id": 101983,
                        "name": "Turuntayevo",
                        "latitude": "52.20203000",
                        "longitude": "107.64484000"
                    },
                    {
                        "id": 102044,
                        "name": "Ulan-Ude",
                        "latitude": "51.82721000",
                        "longitude": "107.60627000"
                    },
                    {
                        "id": 102115,
                        "name": "Ust’-Barguzin",
                        "latitude": "53.41116000",
                        "longitude": "109.03103000"
                    },
                    {
                        "id": 102428,
                        "name": "Vydrino",
                        "latitude": "51.46300000",
                        "longitude": "104.64250000"
                    },
                    {
                        "id": 102630,
                        "name": "Zaigrayevo",
                        "latitude": "51.83487000",
                        "longitude": "108.26700000"
                    },
                    {
                        "id": 102633,
                        "name": "Zakamensk",
                        "latitude": "50.37410000",
                        "longitude": "103.28630000"
                    },
                    {
                        "id": 102655,
                        "name": "Zarechnyy",
                        "latitude": "51.84928000",
                        "longitude": "107.52100000"
                    },
                    {
                        "id": 102723,
                        "name": "Zhemchug",
                        "latitude": "51.68610000",
                        "longitude": "102.45900000"
                    }
                ]
            },
            {
                "id": 1893,
                "name": "Chechen",
                "iso2": "CE",
                "latitude": "43.40233010",
                "longitude": "45.71874680",
                "type": "republic",
                "cities": [
                    {
                        "id": 97499,
                        "name": "Achkhoy-Martan",
                        "latitude": "43.18997000",
                        "longitude": "45.28373000"
                    },
                    {
                        "id": 97500,
                        "name": "Achkhoy-Martanovskiy Rayon",
                        "latitude": "43.08333000",
                        "longitude": "45.25000000"
                    },
                    {
                        "id": 97593,
                        "name": "Alkhan-Kala",
                        "latitude": "43.25861000",
                        "longitude": "45.53917000"
                    },
                    {
                        "id": 97594,
                        "name": "Alkhan-Yurt",
                        "latitude": "43.23179000",
                        "longitude": "45.57228000"
                    },
                    {
                        "id": 97595,
                        "name": "Alkhazurovo",
                        "latitude": "43.06390000",
                        "longitude": "45.65134000"
                    },
                    {
                        "id": 97597,
                        "name": "Alleroy",
                        "latitude": "43.21711000",
                        "longitude": "46.28209000"
                    },
                    {
                        "id": 97601,
                        "name": "Alpatovo",
                        "latitude": "43.70280000",
                        "longitude": "45.24154000"
                    },
                    {
                        "id": 97662,
                        "name": "Argun",
                        "latitude": "43.29713000",
                        "longitude": "45.87454000"
                    },
                    {
                        "id": 97705,
                        "name": "Assinovskaya",
                        "latitude": "43.24167000",
                        "longitude": "45.18194000"
                    },
                    {
                        "id": 97725,
                        "name": "Avtury",
                        "latitude": "43.16345000",
                        "longitude": "46.00152000"
                    },
                    {
                        "id": 97749,
                        "name": "Bachi-Yurt",
                        "latitude": "43.22417000",
                        "longitude": "46.19423000"
                    },
                    {
                        "id": 97787,
                        "name": "Bamut",
                        "latitude": "43.15986000",
                        "longitude": "45.19734000"
                    },
                    {
                        "id": 97847,
                        "name": "Belgatoy",
                        "latitude": "43.18995000",
                        "longitude": "45.83082000"
                    },
                    {
                        "id": 97886,
                        "name": "Benoy-Yurt",
                        "latitude": "43.69305000",
                        "longitude": "45.05025000"
                    },
                    {
                        "id": 98045,
                        "name": "Borzoy",
                        "latitude": "42.84147000",
                        "longitude": "45.62746000"
                    },
                    {
                        "id": 98130,
                        "name": "Chechen-Aul",
                        "latitude": "43.20000000",
                        "longitude": "45.78889000"
                    },
                    {
                        "id": 98196,
                        "name": "Chiri-Yurt",
                        "latitude": "43.08869000",
                        "longitude": "45.74323000"
                    },
                    {
                        "id": 98333,
                        "name": "Duba-Yurt",
                        "latitude": "43.03534000",
                        "longitude": "45.73046000"
                    },
                    {
                        "id": 98365,
                        "name": "Dyshne-Vedeno",
                        "latitude": "42.96435000",
                        "longitude": "46.11578000"
                    },
                    {
                        "id": 98373,
                        "name": "Dzhalka",
                        "latitude": "43.31860000",
                        "longitude": "45.98787000"
                    },
                    {
                        "id": 98388,
                        "name": "Elin-Yurt",
                        "latitude": "43.67306000",
                        "longitude": "44.95889000"
                    },
                    {
                        "id": 98397,
                        "name": "Engel’-Yurt",
                        "latitude": "43.32633000",
                        "longitude": "46.36048000"
                    },
                    {
                        "id": 98473,
                        "name": "Gekhi",
                        "latitude": "43.16354000",
                        "longitude": "45.47238000"
                    },
                    {
                        "id": 98484,
                        "name": "Germenchuk",
                        "latitude": "43.18570000",
                        "longitude": "45.92100000"
                    },
                    {
                        "id": 98485,
                        "name": "Gerzel’-Aul",
                        "latitude": "43.24728000",
                        "longitude": "46.40249000"
                    },
                    {
                        "id": 98516,
                        "name": "Goragorskiy",
                        "latitude": "43.50020000",
                        "longitude": "45.08574000"
                    },
                    {
                        "id": 98573,
                        "name": "Goyty",
                        "latitude": "43.16417000",
                        "longitude": "45.62278000"
                    },
                    {
                        "id": 98582,
                        "name": "Grebenskaya",
                        "latitude": "43.53086000",
                        "longitude": "46.37174000"
                    },
                    {
                        "id": 98593,
                        "name": "Groznenskiy Rayon",
                        "latitude": "43.33333000",
                        "longitude": "45.50000000"
                    },
                    {
                        "id": 98594,
                        "name": "Groznyy",
                        "latitude": "43.31195000",
                        "longitude": "45.68895000"
                    },
                    {
                        "id": 98606,
                        "name": "Gudermes",
                        "latitude": "43.35071000",
                        "longitude": "46.10925000"
                    },
                    {
                        "id": 98607,
                        "name": "Gudermesskiy Rayon",
                        "latitude": "43.33333000",
                        "longitude": "46.16667000"
                    },
                    {
                        "id": 98644,
                        "name": "Ilaskhan-Yurt",
                        "latitude": "43.27910000",
                        "longitude": "46.10229000"
                    },
                    {
                        "id": 98702,
                        "name": "Ishcherskaya",
                        "latitude": "43.71359000",
                        "longitude": "45.13371000"
                    },
                    {
                        "id": 98707,
                        "name": "Ishkhoy-Yurt",
                        "latitude": "43.21278000",
                        "longitude": "46.38936000"
                    },
                    {
                        "id": 98724,
                        "name": "Itum-Kali",
                        "latitude": "42.73552000",
                        "longitude": "45.57574000"
                    },
                    {
                        "id": 98725,
                        "name": "Itum-Kalinskiy Rayon",
                        "latitude": "42.73611000",
                        "longitude": "45.57250000"
                    },
                    {
                        "id": 98794,
                        "name": "Kalinovskaya",
                        "latitude": "43.57383000",
                        "longitude": "45.52090000"
                    },
                    {
                        "id": 98876,
                        "name": "Kargalinskaya",
                        "latitude": "43.74381000",
                        "longitude": "46.47821000"
                    },
                    {
                        "id": 98911,
                        "name": "Katyr-Yurt",
                        "latitude": "43.17164000",
                        "longitude": "45.36991000"
                    },
                    {
                        "id": 98956,
                        "name": "Khambi-Irze",
                        "latitude": "43.23502000",
                        "longitude": "45.45302000"
                    },
                    {
                        "id": 98960,
                        "name": "Khankala",
                        "latitude": "43.30212000",
                        "longitude": "45.75564000"
                    },
                    {
                        "id": 99429,
                        "name": "Kulary",
                        "latitude": "43.23972000",
                        "longitude": "45.50417000"
                    },
                    {
                        "id": 99456,
                        "name": "Kurchaloy",
                        "latitude": "43.20184000",
                        "longitude": "46.08810000"
                    },
                    {
                        "id": 99537,
                        "name": "Lakha Nëvre",
                        "latitude": "43.62271000",
                        "longitude": "45.33969000"
                    },
                    {
                        "id": 99541,
                        "name": "Lakkha Nëvre",
                        "latitude": "43.61033000",
                        "longitude": "45.24542000"
                    },
                    {
                        "id": 99804,
                        "name": "Martan-Chu",
                        "latitude": "43.06366000",
                        "longitude": "45.56217000"
                    },
                    {
                        "id": 99829,
                        "name": "Mayrtup",
                        "latitude": "43.20348000",
                        "longitude": "46.13215000"
                    },
                    {
                        "id": 99871,
                        "name": "Mesker-Yurt",
                        "latitude": "43.25147000",
                        "longitude": "45.90716000"
                    },
                    {
                        "id": 100041,
                        "name": "Nadterechnyy Rayon",
                        "latitude": "43.58333000",
                        "longitude": "45.25000000"
                    },
                    {
                        "id": 100067,
                        "name": "Naurskaya",
                        "latitude": "43.65075000",
                        "longitude": "45.31173000"
                    },
                    {
                        "id": 100068,
                        "name": "Naurskiy Rayon",
                        "latitude": "43.66667000",
                        "longitude": "45.50000000"
                    },
                    {
                        "id": 100189,
                        "name": "Nogamerzin-Yurt",
                        "latitude": "43.65361000",
                        "longitude": "44.88889000"
                    },
                    {
                        "id": 100356,
                        "name": "Novyye Atagi",
                        "latitude": "43.13528000",
                        "longitude": "45.77306000"
                    },
                    {
                        "id": 100365,
                        "name": "Nozhay-Yurt",
                        "latitude": "43.09290000",
                        "longitude": "46.37868000"
                    },
                    {
                        "id": 100366,
                        "name": "Nozhay-Yurtovskiy Rayon",
                        "latitude": "43.08333000",
                        "longitude": "46.41667000"
                    },
                    {
                        "id": 100516,
                        "name": "Oyskhara",
                        "latitude": "43.26402000",
                        "longitude": "46.24803000"
                    },
                    {
                        "id": 100615,
                        "name": "Pervomayskaya",
                        "latitude": "43.40331000",
                        "longitude": "45.52343000"
                    },
                    {
                        "id": 100654,
                        "name": "Petropavlovskaya",
                        "latitude": "43.37944000",
                        "longitude": "45.82611000"
                    },
                    {
                        "id": 100820,
                        "name": "Prigorodnoye",
                        "latitude": "43.25303000",
                        "longitude": "45.75808000"
                    },
                    {
                        "id": 101000,
                        "name": "Roshni-Chu",
                        "latitude": "43.08954000",
                        "longitude": "45.45435000"
                    },
                    {
                        "id": 101087,
                        "name": "Samashki",
                        "latitude": "43.28935000",
                        "longitude": "45.29786000"
                    },
                    {
                        "id": 101186,
                        "name": "Sernovodsk",
                        "latitude": "43.31277000",
                        "longitude": "45.15969000"
                    },
                    {
                        "id": 101196,
                        "name": "Serzhen’-Yurt",
                        "latitude": "43.12265000",
                        "longitude": "45.98583000"
                    },
                    {
                        "id": 101227,
                        "name": "Shaami-Yurt",
                        "latitude": "43.22647000",
                        "longitude": "45.38815000"
                    },
                    {
                        "id": 101244,
                        "name": "Shalazhi",
                        "latitude": "43.09476000",
                        "longitude": "45.35898000"
                    },
                    {
                        "id": 101245,
                        "name": "Shali",
                        "latitude": "43.14806000",
                        "longitude": "45.90194000"
                    },
                    {
                        "id": 101246,
                        "name": "Shalinskiy Rayon",
                        "latitude": "43.16667000",
                        "longitude": "45.91667000"
                    },
                    {
                        "id": 101269,
                        "name": "Shatoy",
                        "latitude": "42.87143000",
                        "longitude": "45.68865000"
                    },
                    {
                        "id": 101365,
                        "name": "Shëlkovskaya",
                        "latitude": "43.50804000",
                        "longitude": "46.34016000"
                    },
                    {
                        "id": 101292,
                        "name": "Shelkovskiy Rayon",
                        "latitude": "43.58333000",
                        "longitude": "46.00000000"
                    },
                    {
                        "id": 101566,
                        "name": "Staraya Sunzha",
                        "latitude": "43.33542000",
                        "longitude": "45.74377000"
                    },
                    {
                        "id": 101610,
                        "name": "Staryye Atagi",
                        "latitude": "43.12028000",
                        "longitude": "45.74056000"
                    },
                    {
                        "id": 101880,
                        "name": "Tolstoy-Yurt",
                        "latitude": "43.44548000",
                        "longitude": "45.77901000"
                    },
                    {
                        "id": 101943,
                        "name": "Tsentoroy",
                        "latitude": "43.00658000",
                        "longitude": "46.22235000"
                    },
                    {
                        "id": 101953,
                        "name": "Tsotsin-Yurt",
                        "latitude": "43.24206000",
                        "longitude": "46.00013000"
                    },
                    {
                        "id": 102087,
                        "name": "Urus-Martan",
                        "latitude": "43.13053000",
                        "longitude": "45.53791000"
                    },
                    {
                        "id": 102088,
                        "name": "Urus-Martanovskiy Rayon",
                        "latitude": "43.08333000",
                        "longitude": "45.58333000"
                    },
                    {
                        "id": 102182,
                        "name": "Valerik",
                        "latitude": "43.17972000",
                        "longitude": "45.40806000"
                    },
                    {
                        "id": 102208,
                        "name": "Vedeno",
                        "latitude": "42.96892000",
                        "longitude": "46.09611000"
                    },
                    {
                        "id": 102209,
                        "name": "Vedenskiy Rayon",
                        "latitude": "43.00000000",
                        "longitude": "46.08333000"
                    },
                    {
                        "id": 102474,
                        "name": "Yalkhoy-Mokhk",
                        "latitude": "43.10528000",
                        "longitude": "46.19045000"
                    },
                    {
                        "id": 102634,
                        "name": "Zakan-Yurt",
                        "latitude": "43.26224000",
                        "longitude": "45.42307000"
                    },
                    {
                        "id": 102642,
                        "name": "Zandak",
                        "latitude": "43.05710000",
                        "longitude": "46.45566000"
                    },
                    {
                        "id": 102761,
                        "name": "Znamenskoye",
                        "latitude": "43.67898000",
                        "longitude": "45.12867000"
                    }
                ]
            },
            {
                "id": 1845,
                "name": "Chelyabinsk",
                "iso2": "CHE",
                "latitude": "54.43194220",
                "longitude": "60.87889630",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97513,
                        "name": "Agapovka",
                        "latitude": "53.29730000",
                        "longitude": "59.13480000"
                    },
                    {
                        "id": 97514,
                        "name": "Agapovskiy Rayon",
                        "latitude": "53.33333000",
                        "longitude": "59.33333000"
                    },
                    {
                        "id": 97660,
                        "name": "Argayash",
                        "latitude": "55.48880000",
                        "longitude": "60.87670000"
                    },
                    {
                        "id": 97696,
                        "name": "Asha",
                        "latitude": "54.99730000",
                        "longitude": "57.27220000"
                    },
                    {
                        "id": 97698,
                        "name": "Ashinskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "57.50000000"
                    },
                    {
                        "id": 97756,
                        "name": "Bakal",
                        "latitude": "54.94170000",
                        "longitude": "58.80830000"
                    },
                    {
                        "id": 97832,
                        "name": "Bazhovo",
                        "latitude": "55.05955000",
                        "longitude": "61.60445000"
                    },
                    {
                        "id": 97889,
                        "name": "Berdyaush",
                        "latitude": "55.16190000",
                        "longitude": "59.14640000"
                    },
                    {
                        "id": 97957,
                        "name": "Bobrovka",
                        "latitude": "54.04700000",
                        "longitude": "61.74550000"
                    },
                    {
                        "id": 98054,
                        "name": "Bredy",
                        "latitude": "52.41528000",
                        "longitude": "60.34111000"
                    },
                    {
                        "id": 98057,
                        "name": "Brodokalmak",
                        "latitude": "55.57480000",
                        "longitude": "62.08200000"
                    },
                    {
                        "id": 98125,
                        "name": "Chebarkul’",
                        "latitude": "54.97490000",
                        "longitude": "60.36330000"
                    },
                    {
                        "id": 98126,
                        "name": "Chebarkul’skiy Rayon",
                        "latitude": "54.83333000",
                        "longitude": "60.50000000"
                    },
                    {
                        "id": 98140,
                        "name": "Chelyabinsk",
                        "latitude": "55.15402000",
                        "longitude": "61.42915000"
                    },
                    {
                        "id": 98151,
                        "name": "Cheremshanka",
                        "latitude": "56.11920000",
                        "longitude": "60.26804000"
                    },
                    {
                        "id": 98192,
                        "name": "Chesma",
                        "latitude": "53.81111000",
                        "longitude": "60.65333000"
                    },
                    {
                        "id": 98299,
                        "name": "Dolgoderevenskoye",
                        "latitude": "55.34444000",
                        "longitude": "61.34444000"
                    },
                    {
                        "id": 98421,
                        "name": "Fershampenuaz",
                        "latitude": "53.52020000",
                        "longitude": "59.81170000"
                    },
                    {
                        "id": 98536,
                        "name": "Gornyak",
                        "latitude": "55.13446000",
                        "longitude": "61.68268000"
                    },
                    {
                        "id": 98549,
                        "name": "Gorod Chelyabinsk",
                        "latitude": "55.16553000",
                        "longitude": "61.41673000"
                    },
                    {
                        "id": 98834,
                        "name": "Kanashevo",
                        "latitude": "55.21690000",
                        "longitude": "62.06340000"
                    },
                    {
                        "id": 98853,
                        "name": "Karabash",
                        "latitude": "55.48080000",
                        "longitude": "60.21570000"
                    },
                    {
                        "id": 98887,
                        "name": "Kartalinskiy Rayon",
                        "latitude": "53.00000000",
                        "longitude": "60.50000000"
                    },
                    {
                        "id": 98888,
                        "name": "Kartaly",
                        "latitude": "53.05285000",
                        "longitude": "60.64903000"
                    },
                    {
                        "id": 98899,
                        "name": "Kasli",
                        "latitude": "55.89090000",
                        "longitude": "60.76160000"
                    },
                    {
                        "id": 98906,
                        "name": "Katav-Ivanovsk",
                        "latitude": "54.75306000",
                        "longitude": "58.19556000"
                    },
                    {
                        "id": 98907,
                        "name": "Katav-Ivanovskiy Rayon",
                        "latitude": "54.75000000",
                        "longitude": "58.25000000"
                    },
                    {
                        "id": 99092,
                        "name": "Kizil’skiy Rayon",
                        "latitude": "52.75000000",
                        "longitude": "59.41667000"
                    },
                    {
                        "id": 99199,
                        "name": "Kopeysk",
                        "latitude": "55.11722000",
                        "longitude": "61.62823000"
                    },
                    {
                        "id": 99207,
                        "name": "Korkino",
                        "latitude": "54.89130000",
                        "longitude": "61.39690000"
                    },
                    {
                        "id": 99257,
                        "name": "Koyelga",
                        "latitude": "54.65224000",
                        "longitude": "60.90490000"
                    },
                    {
                        "id": 99306,
                        "name": "Krasnogorskiy",
                        "latitude": "54.60250000",
                        "longitude": "61.23100000"
                    },
                    {
                        "id": 99398,
                        "name": "Kropachëvo",
                        "latitude": "55.01120000",
                        "longitude": "57.98960000"
                    },
                    {
                        "id": 99445,
                        "name": "Kunashak",
                        "latitude": "55.70320000",
                        "longitude": "61.54980000"
                    },
                    {
                        "id": 99483,
                        "name": "Kusa",
                        "latitude": "55.33833000",
                        "longitude": "59.44056000"
                    },
                    {
                        "id": 99521,
                        "name": "Kyshtym",
                        "latitude": "55.71400000",
                        "longitude": "60.55280000"
                    },
                    {
                        "id": 99568,
                        "name": "Leninsk",
                        "latitude": "54.90306000",
                        "longitude": "59.86750000"
                    },
                    {
                        "id": 99652,
                        "name": "Lokomotivnyy",
                        "latitude": "53.01180000",
                        "longitude": "60.56840000"
                    },
                    {
                        "id": 99738,
                        "name": "Magnitka",
                        "latitude": "55.34750000",
                        "longitude": "59.69611000"
                    },
                    {
                        "id": 99739,
                        "name": "Magnitogorsk",
                        "latitude": "53.41861000",
                        "longitude": "59.04722000"
                    },
                    {
                        "id": 99883,
                        "name": "Mezhevoy",
                        "latitude": "55.17111000",
                        "longitude": "58.78139000"
                    },
                    {
                        "id": 99889,
                        "name": "Miass",
                        "latitude": "55.04500000",
                        "longitude": "60.10833000"
                    },
                    {
                        "id": 99890,
                        "name": "Miasskoye",
                        "latitude": "55.27840000",
                        "longitude": "61.89050000"
                    },
                    {
                        "id": 100020,
                        "name": "Muslyumovo",
                        "latitude": "55.61330000",
                        "longitude": "61.62600000"
                    },
                    {
                        "id": 100045,
                        "name": "Nagaybakskiy Rayon",
                        "latitude": "53.58333000",
                        "longitude": "59.75000000"
                    },
                    {
                        "id": 100177,
                        "name": "Nizhniy Ufaley",
                        "latitude": "55.91528000",
                        "longitude": "59.98417000"
                    },
                    {
                        "id": 100244,
                        "name": "Novogornyy",
                        "latitude": "55.63000000",
                        "longitude": "60.79190000"
                    },
                    {
                        "id": 100306,
                        "name": "Novosineglazovskiy",
                        "latitude": "55.03928000",
                        "longitude": "61.37680000"
                    },
                    {
                        "id": 100376,
                        "name": "Nyazepetrovsk",
                        "latitude": "56.05306000",
                        "longitude": "59.60278000"
                    },
                    {
                        "id": 100377,
                        "name": "Nyazepetrovskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "59.58333000"
                    },
                    {
                        "id": 100413,
                        "name": "Oktyabr’skiy Rayon",
                        "latitude": "54.41667000",
                        "longitude": "62.75000000"
                    },
                    {
                        "id": 100519,
                        "name": "Ozersk",
                        "latitude": "55.75556000",
                        "longitude": "60.70278000"
                    },
                    {
                        "id": 100550,
                        "name": "Parizh",
                        "latitude": "53.29740000",
                        "longitude": "60.10050000"
                    },
                    {
                        "id": 100694,
                        "name": "Plast",
                        "latitude": "54.36914000",
                        "longitude": "60.81361000"
                    },
                    {
                        "id": 100754,
                        "name": "Poletayevo",
                        "latitude": "55.03360000",
                        "longitude": "61.11380000"
                    },
                    {
                        "id": 100789,
                        "name": "Potanino",
                        "latitude": "55.17860000",
                        "longitude": "61.62220000"
                    },
                    {
                        "id": 100999,
                        "name": "Roshchino",
                        "latitude": "55.31012000",
                        "longitude": "61.26363000"
                    },
                    {
                        "id": 101012,
                        "name": "Roza",
                        "latitude": "54.91630000",
                        "longitude": "61.45860000"
                    },
                    {
                        "id": 101118,
                        "name": "Sargazy",
                        "latitude": "55.02064000",
                        "longitude": "61.24985000"
                    },
                    {
                        "id": 101132,
                        "name": "Satka",
                        "latitude": "55.04250000",
                        "longitude": "59.04000000"
                    },
                    {
                        "id": 101133,
                        "name": "Satkinskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "59.00000000"
                    },
                    {
                        "id": 101154,
                        "name": "Selezyan",
                        "latitude": "54.90583000",
                        "longitude": "61.82444000"
                    },
                    {
                        "id": 101370,
                        "name": "Sim",
                        "latitude": "54.99300000",
                        "longitude": "57.69820000"
                    },
                    {
                        "id": 101423,
                        "name": "Snezhinsk",
                        "latitude": "56.08500000",
                        "longitude": "60.73139000"
                    },
                    {
                        "id": 101496,
                        "name": "Sosnovskiy Rayon",
                        "latitude": "55.25000000",
                        "longitude": "61.16667000"
                    },
                    {
                        "id": 101581,
                        "name": "Starokamyshinsk",
                        "latitude": "55.03912000",
                        "longitude": "61.58778000"
                    },
                    {
                        "id": 101729,
                        "name": "Syrostan",
                        "latitude": "55.06340000",
                        "longitude": "59.90020000"
                    },
                    {
                        "id": 101803,
                        "name": "Tayginka",
                        "latitude": "55.62440000",
                        "longitude": "60.50760000"
                    },
                    {
                        "id": 101859,
                        "name": "Timiryazevskiy",
                        "latitude": "54.92917000",
                        "longitude": "60.76250000"
                    },
                    {
                        "id": 101935,
                        "name": "Trëkhgornyy",
                        "latitude": "54.81500000",
                        "longitude": "58.45917000"
                    },
                    {
                        "id": 101914,
                        "name": "Troitsk",
                        "latitude": "54.09790000",
                        "longitude": "61.57730000"
                    },
                    {
                        "id": 101975,
                        "name": "Turgoyak",
                        "latitude": "55.15000000",
                        "longitude": "60.11833000"
                    },
                    {
                        "id": 101999,
                        "name": "Tyubuk",
                        "latitude": "56.05521000",
                        "longitude": "60.94050000"
                    },
                    {
                        "id": 102114,
                        "name": "Ust’-Bagaryak",
                        "latitude": "56.13278000",
                        "longitude": "61.84722000"
                    },
                    {
                        "id": 102129,
                        "name": "Ust’-Katav",
                        "latitude": "54.93660000",
                        "longitude": "58.17570000"
                    },
                    {
                        "id": 102158,
                        "name": "Uvel’skiy",
                        "latitude": "54.44460000",
                        "longitude": "61.35740000"
                    },
                    {
                        "id": 102159,
                        "name": "Uvel’skiy Rayon",
                        "latitude": "54.50000000",
                        "longitude": "61.50000000"
                    },
                    {
                        "id": 102163,
                        "name": "Uyskiy Rayon",
                        "latitude": "54.33333000",
                        "longitude": "60.08333000"
                    },
                    {
                        "id": 102164,
                        "name": "Uyskoye",
                        "latitude": "54.37750000",
                        "longitude": "60.00472000"
                    },
                    {
                        "id": 102176,
                        "name": "Vakhrushevo",
                        "latitude": "55.23170000",
                        "longitude": "61.71730000"
                    },
                    {
                        "id": 102192,
                        "name": "Varna",
                        "latitude": "53.38194000",
                        "longitude": "60.97472000"
                    },
                    {
                        "id": 102195,
                        "name": "Varnenskiy Rayon",
                        "latitude": "53.25000000",
                        "longitude": "61.08333000"
                    },
                    {
                        "id": 102217,
                        "name": "Velikopetrovka",
                        "latitude": "53.25042000",
                        "longitude": "60.48606000"
                    },
                    {
                        "id": 102242,
                        "name": "Verkhneural’sk",
                        "latitude": "53.87694000",
                        "longitude": "59.21056000"
                    },
                    {
                        "id": 102258,
                        "name": "Verkhniy Ufaley",
                        "latitude": "56.05560000",
                        "longitude": "60.23970000"
                    },
                    {
                        "id": 102318,
                        "name": "Vishnëvogorsk",
                        "latitude": "55.99130000",
                        "longitude": "60.65790000"
                    },
                    {
                        "id": 102423,
                        "name": "Vyazovaya",
                        "latitude": "54.90500000",
                        "longitude": "58.35611000"
                    },
                    {
                        "id": 102553,
                        "name": "Yemanzhelinka",
                        "latitude": "54.80100000",
                        "longitude": "61.29890000"
                    },
                    {
                        "id": 102554,
                        "name": "Yemanzhelinsk",
                        "latitude": "54.75472000",
                        "longitude": "61.32083000"
                    },
                    {
                        "id": 102578,
                        "name": "Yetkul’",
                        "latitude": "54.82210000",
                        "longitude": "61.58800000"
                    },
                    {
                        "id": 102601,
                        "name": "Yuryuzan’",
                        "latitude": "54.86333000",
                        "longitude": "58.42194000"
                    },
                    {
                        "id": 102617,
                        "name": "Yuzhnoural’sk",
                        "latitude": "54.44180000",
                        "longitude": "61.25360000"
                    },
                    {
                        "id": 102719,
                        "name": "Zheleznodorozhnyy",
                        "latitude": "55.10183000",
                        "longitude": "61.54926000"
                    },
                    {
                        "id": 102750,
                        "name": "Zlatoust",
                        "latitude": "55.17111000",
                        "longitude": "59.65083000"
                    }
                ]
            },
            {
                "id": 1859,
                "name": "Chukotka",
                "iso2": "CHU",
                "latitude": "65.62983550",
                "longitude": "171.69521590",
                "type": "autonomous district",
                "cities": [
                    {
                        "id": 97618,
                        "name": "Anadyr",
                        "latitude": "64.73424000",
                        "longitude": "177.51030000"
                    },
                    {
                        "id": 97619,
                        "name": "Anadyrskiy Rayon",
                        "latitude": "65.00000000",
                        "longitude": "173.00000000"
                    },
                    {
                        "id": 97897,
                        "name": "Beringovskiy",
                        "latitude": "63.06101000",
                        "longitude": "179.35046000"
                    },
                    {
                        "id": 97928,
                        "name": "Bilibino",
                        "latitude": "68.05464000",
                        "longitude": "166.43721000"
                    },
                    {
                        "id": 98381,
                        "name": "Egvekinot",
                        "latitude": "66.32166000",
                        "longitude": "-179.12198000"
                    },
                    {
                        "id": 99547,
                        "name": "Lavrentiya",
                        "latitude": "65.58604000",
                        "longitude": "-171.02082000"
                    },
                    {
                        "id": 99664,
                        "name": "Lorino",
                        "latitude": "65.50306000",
                        "longitude": "-171.70387000"
                    },
                    {
                        "id": 100669,
                        "name": "Pevek",
                        "latitude": "69.70287000",
                        "longitude": "170.29993000"
                    },
                    {
                        "id": 100872,
                        "name": "Provideniya",
                        "latitude": "64.42289000",
                        "longitude": "-173.22641000"
                    },
                    {
                        "id": 100873,
                        "name": "Providenskiy Rayon",
                        "latitude": "65.25000000",
                        "longitude": "-175.00000000"
                    }
                ]
            },
            {
                "id": 1914,
                "name": "Chuvash",
                "iso2": "CU",
                "latitude": "55.55959920",
                "longitude": "46.92835350",
                "type": "republic",
                "cities": [
                    {
                        "id": 97560,
                        "name": "Alatyr’",
                        "latitude": "54.84210000",
                        "longitude": "46.58130000"
                    },
                    {
                        "id": 97559,
                        "name": "Alatyrskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "46.75000000"
                    },
                    {
                        "id": 97590,
                        "name": "Alikovo",
                        "latitude": "55.73827000",
                        "longitude": "46.75493000"
                    },
                    {
                        "id": 97591,
                        "name": "Alikovskiy Rayon",
                        "latitude": "55.75000000",
                        "longitude": "46.75000000"
                    },
                    {
                        "id": 97714,
                        "name": "Atlashevo",
                        "latitude": "56.01235000",
                        "longitude": "47.55615000"
                    },
                    {
                        "id": 97815,
                        "name": "Batyrevo",
                        "latitude": "55.06750000",
                        "longitude": "47.61111000"
                    },
                    {
                        "id": 97816,
                        "name": "Batyrevskiy Rayon",
                        "latitude": "55.08333000",
                        "longitude": "47.50000000"
                    },
                    {
                        "id": 98070,
                        "name": "Buinsk",
                        "latitude": "55.19500000",
                        "longitude": "47.06080000"
                    },
                    {
                        "id": 98127,
                        "name": "Cheboksarskiy Rayon",
                        "latitude": "56.08333000",
                        "longitude": "47.25000000"
                    },
                    {
                        "id": 98128,
                        "name": "Cheboksary",
                        "latitude": "56.13222000",
                        "longitude": "47.25194000"
                    },
                    {
                        "id": 98626,
                        "name": "Ibresi",
                        "latitude": "55.30110000",
                        "longitude": "47.03800000"
                    },
                    {
                        "id": 98627,
                        "name": "Ibresinskiy Rayon",
                        "latitude": "55.25000000",
                        "longitude": "47.00000000"
                    },
                    {
                        "id": 98708,
                        "name": "Ishley",
                        "latitude": "56.02317000",
                        "longitude": "47.05054000"
                    },
                    {
                        "id": 98833,
                        "name": "Kanash",
                        "latitude": "55.50962000",
                        "longitude": "47.49127000"
                    },
                    {
                        "id": 98835,
                        "name": "Kanashskiy Rayon",
                        "latitude": "55.50000000",
                        "longitude": "47.41667000"
                    },
                    {
                        "id": 99076,
                        "name": "Kirya",
                        "latitude": "55.08102000",
                        "longitude": "46.86091000"
                    },
                    {
                        "id": 99168,
                        "name": "Komsomol'skoye",
                        "latitude": "55.25667000",
                        "longitude": "47.54608000"
                    },
                    {
                        "id": 99176,
                        "name": "Komsomol’skiy Rayon",
                        "latitude": "55.25000000",
                        "longitude": "47.50000000"
                    },
                    {
                        "id": 99266,
                        "name": "Kozlovka",
                        "latitude": "55.84284000",
                        "longitude": "48.24920000"
                    },
                    {
                        "id": 99269,
                        "name": "Kozlovskiy Rayon",
                        "latitude": "55.83333000",
                        "longitude": "48.16667000"
                    },
                    {
                        "id": 99294,
                        "name": "Krasnoarmeyskiy Rayon",
                        "latitude": "55.75000000",
                        "longitude": "47.16667000"
                    },
                    {
                        "id": 99295,
                        "name": "Krasnoarmeyskoye",
                        "latitude": "55.76813000",
                        "longitude": "47.17244000"
                    },
                    {
                        "id": 99299,
                        "name": "Krasnochetayskiy Rayon",
                        "latitude": "55.66667000",
                        "longitude": "46.25000000"
                    },
                    {
                        "id": 99383,
                        "name": "Krasnyye Chetai",
                        "latitude": "55.68871000",
                        "longitude": "46.13865000"
                    },
                    {
                        "id": 99424,
                        "name": "Kugesi",
                        "latitude": "56.02895000",
                        "longitude": "47.29255000"
                    },
                    {
                        "id": 99796,
                        "name": "Mariinskiy Posad",
                        "latitude": "56.11497000",
                        "longitude": "47.71805000"
                    },
                    {
                        "id": 99797,
                        "name": "Mariinsko-Posadskiy Rayon",
                        "latitude": "55.91667000",
                        "longitude": "47.83333000"
                    },
                    {
                        "id": 99962,
                        "name": "Morgaushi",
                        "latitude": "55.96430000",
                        "longitude": "46.77430000"
                    },
                    {
                        "id": 99963,
                        "name": "Morgaushskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "46.75000000"
                    },
                    {
                        "id": 100233,
                        "name": "Novocheboksarsk",
                        "latitude": "56.11095000",
                        "longitude": "47.47755000"
                    },
                    {
                        "id": 100361,
                        "name": "Novyye Lapsary",
                        "latitude": "56.06850000",
                        "longitude": "47.21420000"
                    },
                    {
                        "id": 100775,
                        "name": "Poretskiy Rayon",
                        "latitude": "55.16667000",
                        "longitude": "46.41667000"
                    },
                    {
                        "id": 100776,
                        "name": "Poretskoye",
                        "latitude": "55.19742000",
                        "longitude": "46.32908000"
                    },
                    {
                        "id": 101296,
                        "name": "Shemursha",
                        "latitude": "54.88663000",
                        "longitude": "47.51893000"
                    },
                    {
                        "id": 101297,
                        "name": "Shemurshinskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "47.50000000"
                    },
                    {
                        "id": 101311,
                        "name": "Shikhazany",
                        "latitude": "55.56047000",
                        "longitude": "47.39297000"
                    },
                    {
                        "id": 101346,
                        "name": "Shumerlinskiy Rayon",
                        "latitude": "55.50000000",
                        "longitude": "46.50000000"
                    },
                    {
                        "id": 101347,
                        "name": "Shumerlya",
                        "latitude": "55.50050000",
                        "longitude": "46.41288000"
                    },
                    {
                        "id": 101951,
                        "name": "Tsivil’sk",
                        "latitude": "55.86974000",
                        "longitude": "47.47874000"
                    },
                    {
                        "id": 101952,
                        "name": "Tsivil’skiy Rayon",
                        "latitude": "55.83333000",
                        "longitude": "47.50000000"
                    },
                    {
                        "id": 102081,
                        "name": "Urmarskiy Rayon",
                        "latitude": "55.66667000",
                        "longitude": "47.91667000"
                    },
                    {
                        "id": 102082,
                        "name": "Urmary",
                        "latitude": "55.67894000",
                        "longitude": "47.94396000"
                    },
                    {
                        "id": 102416,
                        "name": "Vurnarskiy Rayon",
                        "latitude": "55.50000000",
                        "longitude": "46.91667000"
                    },
                    {
                        "id": 102417,
                        "name": "Vurnary",
                        "latitude": "55.49044000",
                        "longitude": "46.96479000"
                    },
                    {
                        "id": 102459,
                        "name": "Yadrin",
                        "latitude": "55.94052000",
                        "longitude": "46.20622000"
                    },
                    {
                        "id": 102460,
                        "name": "Yadrinskiy Rayon",
                        "latitude": "55.91667000",
                        "longitude": "46.33333000"
                    },
                    {
                        "id": 102476,
                        "name": "Yal’chikskiy Rayon",
                        "latitude": "55.16667000",
                        "longitude": "47.91667000"
                    },
                    {
                        "id": 102487,
                        "name": "Yantikovo",
                        "latitude": "55.82158000",
                        "longitude": "47.91036000"
                    },
                    {
                        "id": 102488,
                        "name": "Yantikovskiy Rayon",
                        "latitude": "55.50000000",
                        "longitude": "47.83333000"
                    }
                ]
            },
            {
                "id": 1850,
                "name": "Dagestan",
                "iso2": "DA",
                "latitude": "42.14318860",
                "longitude": "47.09497990",
                "type": "republic",
                "cities": [
                    {
                        "id": 97497,
                        "name": "Achisu",
                        "latitude": "42.65197000",
                        "longitude": "47.68282000"
                    },
                    {
                        "id": 97502,
                        "name": "Adil’-Yangiyurt",
                        "latitude": "43.56328000",
                        "longitude": "46.58462000"
                    },
                    {
                        "id": 97524,
                        "name": "Agul’skiy Rayon",
                        "latitude": "41.83333000",
                        "longitude": "47.58333000"
                    },
                    {
                        "id": 97525,
                        "name": "Agvali",
                        "latitude": "42.53853000",
                        "longitude": "46.11967000"
                    },
                    {
                        "id": 97532,
                        "name": "Akhty",
                        "latitude": "41.45968000",
                        "longitude": "47.73123000"
                    },
                    {
                        "id": 97533,
                        "name": "Akhtynskiy Rayon",
                        "latitude": "41.33333000",
                        "longitude": "47.58333000"
                    },
                    {
                        "id": 97536,
                        "name": "Akhvakhskiy Rayon",
                        "latitude": "42.58333000",
                        "longitude": "46.33333000"
                    },
                    {
                        "id": 97537,
                        "name": "Aknada",
                        "latitude": "42.40155000",
                        "longitude": "46.17228000"
                    },
                    {
                        "id": 97541,
                        "name": "Aksay",
                        "latitude": "43.37254000",
                        "longitude": "46.44497000"
                    },
                    {
                        "id": 97550,
                        "name": "Akusha",
                        "latitude": "42.26885000",
                        "longitude": "47.34114000"
                    },
                    {
                        "id": 97551,
                        "name": "Akushinskiy Rayon",
                        "latitude": "42.16667000",
                        "longitude": "47.33333000"
                    },
                    {
                        "id": 97624,
                        "name": "Andi",
                        "latitude": "42.78359000",
                        "longitude": "46.26171000"
                    },
                    {
                        "id": 97639,
                        "name": "Ansalta",
                        "latitude": "42.68941000",
                        "longitude": "46.11782000"
                    },
                    {
                        "id": 97697,
                        "name": "Ashil’ta",
                        "latitude": "42.77042000",
                        "longitude": "46.72992000"
                    },
                    {
                        "id": 97739,
                        "name": "Babayurt",
                        "latitude": "43.60020000",
                        "longitude": "46.77888000"
                    },
                    {
                        "id": 97740,
                        "name": "Babayurtovskiy Rayon",
                        "latitude": "43.58333000",
                        "longitude": "47.00000000"
                    },
                    {
                        "id": 97786,
                        "name": "Bammatyurt",
                        "latitude": "43.34576000",
                        "longitude": "46.60819000"
                    },
                    {
                        "id": 97820,
                        "name": "Bavtugay",
                        "latitude": "43.16808000",
                        "longitude": "46.83415000"
                    },
                    {
                        "id": 97850,
                        "name": "Belidzhi",
                        "latitude": "41.89184000",
                        "longitude": "48.41247000"
                    },
                    {
                        "id": 97922,
                        "name": "Bezhta",
                        "latitude": "42.13380000",
                        "longitude": "46.12828000"
                    },
                    {
                        "id": 98048,
                        "name": "Botashyurt",
                        "latitude": "43.30801000",
                        "longitude": "46.50991000"
                    },
                    {
                        "id": 98049,
                        "name": "Botayurt",
                        "latitude": "43.31865000",
                        "longitude": "46.68371000"
                    },
                    {
                        "id": 98050,
                        "name": "Botlikhskiy Rayon",
                        "latitude": "42.75000000",
                        "longitude": "46.25000000"
                    },
                    {
                        "id": 98085,
                        "name": "Burtunay",
                        "latitude": "42.98860000",
                        "longitude": "46.63034000"
                    },
                    {
                        "id": 98091,
                        "name": "Buynaksk",
                        "latitude": "42.81900000",
                        "longitude": "47.11920000"
                    },
                    {
                        "id": 98092,
                        "name": "Buynakskiy Rayon",
                        "latitude": "42.83333000",
                        "longitude": "47.16667000"
                    },
                    {
                        "id": 98119,
                        "name": "Charodinskiy Rayon",
                        "latitude": "42.16667000",
                        "longitude": "46.75000000"
                    },
                    {
                        "id": 98195,
                        "name": "Chinar",
                        "latitude": "42.10798000",
                        "longitude": "48.14321000"
                    },
                    {
                        "id": 98197,
                        "name": "Chirkey",
                        "latitude": "42.96131000",
                        "longitude": "46.97866000"
                    },
                    {
                        "id": 98210,
                        "name": "Chontaul",
                        "latitude": "43.30481000",
                        "longitude": "46.85967000"
                    },
                    {
                        "id": 98232,
                        "name": "Dagestanskiye Ogni",
                        "latitude": "42.11589000",
                        "longitude": "48.19204000"
                    },
                    {
                        "id": 98234,
                        "name": "Dakhadayevskiy Rayon",
                        "latitude": "42.08333000",
                        "longitude": "47.58333000"
                    },
                    {
                        "id": 98265,
                        "name": "Derbent",
                        "latitude": "42.06779000",
                        "longitude": "48.28987000"
                    },
                    {
                        "id": 98266,
                        "name": "Derbentskiy Rayon",
                        "latitude": "42.08333000",
                        "longitude": "48.16667000"
                    },
                    {
                        "id": 98298,
                        "name": "Dokuzparinskiy Rayon",
                        "latitude": "42.33333000",
                        "longitude": "47.91667000"
                    },
                    {
                        "id": 98317,
                        "name": "Dorgeli",
                        "latitude": "42.66700000",
                        "longitude": "47.29435000"
                    },
                    {
                        "id": 98330,
                        "name": "Druzhba",
                        "latitude": "42.24200000",
                        "longitude": "48.00145000"
                    },
                    {
                        "id": 98335,
                        "name": "Dubki",
                        "latitude": "43.02116000",
                        "longitude": "46.83746000"
                    },
                    {
                        "id": 98364,
                        "name": "Dylym",
                        "latitude": "43.07099000",
                        "longitude": "46.63454000"
                    },
                    {
                        "id": 98394,
                        "name": "Endirey",
                        "latitude": "43.16316000",
                        "longitude": "46.65401000"
                    },
                    {
                        "id": 98400,
                        "name": "Erpeli",
                        "latitude": "42.80584000",
                        "longitude": "46.97732000"
                    },
                    {
                        "id": 98447,
                        "name": "Gagatli",
                        "latitude": "42.80130000",
                        "longitude": "46.29162000"
                    },
                    {
                        "id": 98456,
                        "name": "Gaptsakh",
                        "latitude": "41.45174000",
                        "longitude": "47.93027000"
                    },
                    {
                        "id": 98472,
                        "name": "Gedzhukh",
                        "latitude": "42.12786000",
                        "longitude": "48.06474000"
                    },
                    {
                        "id": 98479,
                        "name": "Gereykhanovskoye",
                        "latitude": "41.70110000",
                        "longitude": "48.28113000"
                    },
                    {
                        "id": 98480,
                        "name": "Gerga",
                        "latitude": "42.34645000",
                        "longitude": "47.96333000"
                    },
                    {
                        "id": 98481,
                        "name": "Gergebil’",
                        "latitude": "42.50472000",
                        "longitude": "47.06611000"
                    },
                    {
                        "id": 98482,
                        "name": "Gergebil’skiy Rayon",
                        "latitude": "42.50000000",
                        "longitude": "47.00000000"
                    },
                    {
                        "id": 98490,
                        "name": "Gimry",
                        "latitude": "42.75974000",
                        "longitude": "46.83959000"
                    },
                    {
                        "id": 98602,
                        "name": "Gubden",
                        "latitude": "42.56808000",
                        "longitude": "47.56579000"
                    },
                    {
                        "id": 98610,
                        "name": "Gumbetovskiy Rayon",
                        "latitude": "42.83333000",
                        "longitude": "46.50000000"
                    },
                    {
                        "id": 98613,
                        "name": "Gunib",
                        "latitude": "42.38758000",
                        "longitude": "46.96509000"
                    },
                    {
                        "id": 98614,
                        "name": "Gunibskiy Rayon",
                        "latitude": "42.41667000",
                        "longitude": "46.83333000"
                    },
                    {
                        "id": 98615,
                        "name": "Gurbuki",
                        "latitude": "42.61128000",
                        "longitude": "47.60067000"
                    },
                    {
                        "id": 98691,
                        "name": "Irganay",
                        "latitude": "42.64650000",
                        "longitude": "46.91154000"
                    },
                    {
                        "id": 98744,
                        "name": "Izberbash",
                        "latitude": "42.56955000",
                        "longitude": "47.86447000"
                    },
                    {
                        "id": 98775,
                        "name": "Kafyr-Kumukh",
                        "latitude": "42.83754000",
                        "longitude": "47.15412000"
                    },
                    {
                        "id": 98786,
                        "name": "Kalininaul",
                        "latitude": "43.07121000",
                        "longitude": "46.56679000"
                    },
                    {
                        "id": 98854,
                        "name": "Karabudakhkent",
                        "latitude": "42.70870000",
                        "longitude": "47.56735000"
                    },
                    {
                        "id": 98855,
                        "name": "Karabudakhkentskiy Rayon",
                        "latitude": "42.66667000",
                        "longitude": "47.50000000"
                    },
                    {
                        "id": 98868,
                        "name": "Karamakhi",
                        "latitude": "42.61934000",
                        "longitude": "47.26017000"
                    },
                    {
                        "id": 98870,
                        "name": "Karata",
                        "latitude": "42.59486000",
                        "longitude": "46.33930000"
                    },
                    {
                        "id": 98900,
                        "name": "Kaspiysk",
                        "latitude": "42.88165000",
                        "longitude": "47.63919000"
                    },
                    {
                        "id": 98905,
                        "name": "Kasumkent",
                        "latitude": "41.67725000",
                        "longitude": "48.14601000"
                    },
                    {
                        "id": 98915,
                        "name": "Kayakent",
                        "latitude": "42.38736000",
                        "longitude": "47.90301000"
                    },
                    {
                        "id": 98916,
                        "name": "Kayakentskiy Rayon",
                        "latitude": "42.33333000",
                        "longitude": "47.91667000"
                    },
                    {
                        "id": 98919,
                        "name": "Kaytagskiy Rayon",
                        "latitude": "42.08333000",
                        "longitude": "47.83333000"
                    },
                    {
                        "id": 98931,
                        "name": "Kazbekovskiy Rayon",
                        "latitude": "43.00000000",
                        "longitude": "46.66667000"
                    },
                    {
                        "id": 98954,
                        "name": "Khadzhalmakhi",
                        "latitude": "42.42000000",
                        "longitude": "47.18206000"
                    },
                    {
                        "id": 98955,
                        "name": "Khamamatyurt",
                        "latitude": "43.60809000",
                        "longitude": "46.50060000"
                    },
                    {
                        "id": 98970,
                        "name": "Khasavyurt",
                        "latitude": "43.25090000",
                        "longitude": "46.58766000"
                    },
                    {
                        "id": 98971,
                        "name": "Khasavyurtovskiy Rayon",
                        "latitude": "43.33333000",
                        "longitude": "46.66667000"
                    },
                    {
                        "id": 98976,
                        "name": "Khazar",
                        "latitude": "41.99740000",
                        "longitude": "48.33325000"
                    },
                    {
                        "id": 98977,
                        "name": "Khebda",
                        "latitude": "42.44423000",
                        "longitude": "46.55172000"
                    },
                    {
                        "id": 98984,
                        "name": "Khiv",
                        "latitude": "41.75428000",
                        "longitude": "47.93063000"
                    },
                    {
                        "id": 98985,
                        "name": "Khivskiy Rayon",
                        "latitude": "41.75000000",
                        "longitude": "47.91667000"
                    },
                    {
                        "id": 99016,
                        "name": "Khuchni",
                        "latitude": "41.94986000",
                        "longitude": "47.94854000"
                    },
                    {
                        "id": 99019,
                        "name": "Khunzakh",
                        "latitude": "42.54240000",
                        "longitude": "46.70689000"
                    },
                    {
                        "id": 99020,
                        "name": "Khunzakhskiy Rayon",
                        "latitude": "42.58333000",
                        "longitude": "46.66667000"
                    },
                    {
                        "id": 99079,
                        "name": "Kishcha",
                        "latitude": "42.17677000",
                        "longitude": "47.58117000"
                    },
                    {
                        "id": 99090,
                        "name": "Kizilyurt",
                        "latitude": "43.18830000",
                        "longitude": "46.88511000"
                    },
                    {
                        "id": 99091,
                        "name": "Kizilyurtovskiy Rayon",
                        "latitude": "43.25000000",
                        "longitude": "46.91667000"
                    },
                    {
                        "id": 99094,
                        "name": "Kizlyar",
                        "latitude": "43.84712000",
                        "longitude": "46.71445000"
                    },
                    {
                        "id": 99095,
                        "name": "Kizlyarskiy Rayon",
                        "latitude": "44.00000000",
                        "longitude": "47.00000000"
                    },
                    {
                        "id": 99124,
                        "name": "Kochubey",
                        "latitude": "44.38611000",
                        "longitude": "46.58250000"
                    },
                    {
                        "id": 99133,
                        "name": "Kokrek",
                        "latitude": "43.23639000",
                        "longitude": "46.72665000"
                    },
                    {
                        "id": 99173,
                        "name": "Komsomol’skiy",
                        "latitude": "43.97833000",
                        "longitude": "46.69852000"
                    },
                    {
                        "id": 99208,
                        "name": "Korkmaskala",
                        "latitude": "43.02379000",
                        "longitude": "47.29436000"
                    },
                    {
                        "id": 99236,
                        "name": "Kostek",
                        "latitude": "43.34387000",
                        "longitude": "46.85411000"
                    },
                    {
                        "id": 99414,
                        "name": "Kubachi",
                        "latitude": "42.08598000",
                        "longitude": "47.60338000"
                    },
                    {
                        "id": 99432,
                        "name": "Kuli",
                        "latitude": "42.01845000",
                        "longitude": "47.24342000"
                    },
                    {
                        "id": 99433,
                        "name": "Kulinskiy Rayon",
                        "latitude": "42.00000000",
                        "longitude": "47.25000000"
                    },
                    {
                        "id": 99442,
                        "name": "Kumukh",
                        "latitude": "42.17036000",
                        "longitude": "47.11606000"
                    },
                    {
                        "id": 99453,
                        "name": "Kurakh",
                        "latitude": "41.58491000",
                        "longitude": "47.78306000"
                    },
                    {
                        "id": 99454,
                        "name": "Kurakhskiy Rayon",
                        "latitude": "41.58333000",
                        "longitude": "47.75000000"
                    },
                    {
                        "id": 99464,
                        "name": "Kurkent",
                        "latitude": "41.71199000",
                        "longitude": "48.11531000"
                    },
                    {
                        "id": 99480,
                        "name": "Kurush",
                        "latitude": "41.28413000",
                        "longitude": "47.83454000"
                    },
                    {
                        "id": 99517,
                        "name": "Kyakhulay",
                        "latitude": "42.96839000",
                        "longitude": "47.48301000"
                    },
                    {
                        "id": 99542,
                        "name": "Lakskiy Rayon",
                        "latitude": "42.16667000",
                        "longitude": "47.08333000"
                    },
                    {
                        "id": 99563,
                        "name": "Leninaul",
                        "latitude": "43.09138000",
                        "longitude": "46.57434000"
                    },
                    {
                        "id": 99565,
                        "name": "Leninkent",
                        "latitude": "42.96895000",
                        "longitude": "47.35202000"
                    },
                    {
                        "id": 99612,
                        "name": "Levashi",
                        "latitude": "42.43036000",
                        "longitude": "47.32148000"
                    },
                    {
                        "id": 99613,
                        "name": "Levashinskiy Rayon",
                        "latitude": "42.41667000",
                        "longitude": "47.33333000"
                    },
                    {
                        "id": 99694,
                        "name": "Lutkun",
                        "latitude": "41.48084000",
                        "longitude": "47.68578000"
                    },
                    {
                        "id": 99729,
                        "name": "Madzhalis",
                        "latitude": "42.12167000",
                        "longitude": "47.83333000"
                    },
                    {
                        "id": 99732,
                        "name": "Magaramkent",
                        "latitude": "41.61586000",
                        "longitude": "48.34797000"
                    },
                    {
                        "id": 99733,
                        "name": "Magaramkentskiy Rayon",
                        "latitude": "41.66667000",
                        "longitude": "48.33333000"
                    },
                    {
                        "id": 99743,
                        "name": "Makhachkala",
                        "latitude": "42.97638000",
                        "longitude": "47.50236000"
                    },
                    {
                        "id": 99776,
                        "name": "Mamedkala",
                        "latitude": "42.16757000",
                        "longitude": "48.11671000"
                    },
                    {
                        "id": 99781,
                        "name": "Manas",
                        "latitude": "42.72749000",
                        "longitude": "47.67846000"
                    },
                    {
                        "id": 99782,
                        "name": "Manaskent",
                        "latitude": "42.74020000",
                        "longitude": "47.69140000"
                    },
                    {
                        "id": 99891,
                        "name": "Miatli",
                        "latitude": "43.08173000",
                        "longitude": "46.82860000"
                    },
                    {
                        "id": 99931,
                        "name": "Miskindzha",
                        "latitude": "41.42402000",
                        "longitude": "47.84669000"
                    },
                    {
                        "id": 99994,
                        "name": "Mugi",
                        "latitude": "42.29944000",
                        "longitude": "47.42077000"
                    },
                    {
                        "id": 100022,
                        "name": "Mutsalaul",
                        "latitude": "43.27548000",
                        "longitude": "46.73078000"
                    },
                    {
                        "id": 100036,
                        "name": "Myurego",
                        "latitude": "42.41087000",
                        "longitude": "47.69304000"
                    },
                    {
                        "id": 100161,
                        "name": "Nizhneye Kazanishche",
                        "latitude": "42.76369000",
                        "longitude": "47.16027000"
                    },
                    {
                        "id": 100166,
                        "name": "Nizhniy Dzhengutay",
                        "latitude": "42.70008000",
                        "longitude": "47.24488000"
                    },
                    {
                        "id": 100190,
                        "name": "Nogayskiy Rayon",
                        "latitude": "44.50000000",
                        "longitude": "46.00000000"
                    },
                    {
                        "id": 100207,
                        "name": "Novaya Maka",
                        "latitude": "41.77173000",
                        "longitude": "48.36149000"
                    },
                    {
                        "id": 100242,
                        "name": "Novogagatli",
                        "latitude": "43.45677000",
                        "longitude": "46.48175000"
                    },
                    {
                        "id": 100247,
                        "name": "Novokayakent",
                        "latitude": "42.39368000",
                        "longitude": "47.98608000"
                    },
                    {
                        "id": 100261,
                        "name": "Novolakskiy Rayon",
                        "latitude": "43.16667000",
                        "longitude": "46.50000000"
                    },
                    {
                        "id": 100262,
                        "name": "Novolakskoye",
                        "latitude": "43.11952000",
                        "longitude": "46.48281000"
                    },
                    {
                        "id": 100342,
                        "name": "Novyy Chirkey",
                        "latitude": "43.16205000",
                        "longitude": "47.05585000"
                    },
                    {
                        "id": 100345,
                        "name": "Novyy Khushet",
                        "latitude": "42.89941000",
                        "longitude": "47.56040000"
                    },
                    {
                        "id": 100346,
                        "name": "Novyy Kostek",
                        "latitude": "43.33530000",
                        "longitude": "46.82466000"
                    },
                    {
                        "id": 100350,
                        "name": "Novyy Sulak",
                        "latitude": "43.18126000",
                        "longitude": "46.82630000"
                    },
                    {
                        "id": 100368,
                        "name": "Nuradilovo",
                        "latitude": "43.28447000",
                        "longitude": "46.45763000"
                    },
                    {
                        "id": 100544,
                        "name": "Paraul",
                        "latitude": "42.74193000",
                        "longitude": "47.35531000"
                    },
                    {
                        "id": 100626,
                        "name": "Pervomayskoye",
                        "latitude": "43.91904000",
                        "longitude": "46.71019000"
                    },
                    {
                        "id": 100746,
                        "name": "Pokrovskoye",
                        "latitude": "43.28872000",
                        "longitude": "46.66527000"
                    },
                    {
                        "id": 101035,
                        "name": "Rutul",
                        "latitude": "41.53566000",
                        "longitude": "47.42391000"
                    },
                    {
                        "id": 101036,
                        "name": "Rutul’skiy Rayon",
                        "latitude": "41.66667000",
                        "longitude": "47.25000000"
                    },
                    {
                        "id": 101062,
                        "name": "Sabnova",
                        "latitude": "42.06316000",
                        "longitude": "48.25326000"
                    },
                    {
                        "id": 101093,
                        "name": "Samur",
                        "latitude": "41.82527000",
                        "longitude": "48.48597000"
                    },
                    {
                        "id": 101184,
                        "name": "Sergokala",
                        "latitude": "42.45468000",
                        "longitude": "47.66119000"
                    },
                    {
                        "id": 101185,
                        "name": "Sergokalinskiy Rayon",
                        "latitude": "42.33333000",
                        "longitude": "47.58333000"
                    },
                    {
                        "id": 101252,
                        "name": "Shamil’kala",
                        "latitude": "42.68581000",
                        "longitude": "46.86393000"
                    },
                    {
                        "id": 101253,
                        "name": "Shamil’skiy Rayon",
                        "latitude": "42.41667000",
                        "longitude": "46.50000000"
                    },
                    {
                        "id": 101254,
                        "name": "Shamkhal",
                        "latitude": "43.05958000",
                        "longitude": "47.33732000"
                    },
                    {
                        "id": 101255,
                        "name": "Shamkhal-Termen",
                        "latitude": "43.03389000",
                        "longitude": "47.31053000"
                    },
                    {
                        "id": 101381,
                        "name": "Siukh",
                        "latitude": "42.59990000",
                        "longitude": "46.54462000"
                    },
                    {
                        "id": 101456,
                        "name": "Solnechnoye",
                        "latitude": "43.27600000",
                        "longitude": "46.50697000"
                    },
                    {
                        "id": 101659,
                        "name": "Sulak",
                        "latitude": "43.27342000",
                        "longitude": "47.51463000"
                    },
                    {
                        "id": 101660,
                        "name": "Suleyman-Stal’skiy Rayon",
                        "latitude": "41.66667000",
                        "longitude": "48.08333000"
                    },
                    {
                        "id": 101731,
                        "name": "Syrtych",
                        "latitude": "41.83388000",
                        "longitude": "48.22901000"
                    },
                    {
                        "id": 101737,
                        "name": "Tabasaranskiy Rayon",
                        "latitude": "41.91667000",
                        "longitude": "48.00000000"
                    },
                    {
                        "id": 101775,
                        "name": "Tarki",
                        "latitude": "42.94423000",
                        "longitude": "47.49527000"
                    },
                    {
                        "id": 101780,
                        "name": "Tarumovka",
                        "latitude": "44.07606000",
                        "longitude": "46.53613000"
                    },
                    {
                        "id": 101781,
                        "name": "Tarumovskiy Rayon",
                        "latitude": "44.41667000",
                        "longitude": "46.66667000"
                    },
                    {
                        "id": 101813,
                        "name": "Temiraul",
                        "latitude": "43.25322000",
                        "longitude": "46.82540000"
                    },
                    {
                        "id": 101828,
                        "name": "Terekli-Mekteb",
                        "latitude": "44.16710000",
                        "longitude": "45.86975000"
                    },
                    {
                        "id": 101865,
                        "name": "Tlyarata",
                        "latitude": "42.10408000",
                        "longitude": "46.35590000"
                    },
                    {
                        "id": 101866,
                        "name": "Tlyaratinskiy Rayon",
                        "latitude": "42.08333000",
                        "longitude": "46.41667000"
                    },
                    {
                        "id": 101910,
                        "name": "Tpig",
                        "latitude": "41.78007000",
                        "longitude": "47.58896000"
                    },
                    {
                        "id": 101954,
                        "name": "Tsumadinskiy Rayon",
                        "latitude": "42.50000000",
                        "longitude": "46.08333000"
                    },
                    {
                        "id": 101955,
                        "name": "Tsuntinskiy Rayon",
                        "latitude": "42.16667000",
                        "longitude": "46.00000000"
                    },
                    {
                        "id": 101956,
                        "name": "Tsurib",
                        "latitude": "42.23680000",
                        "longitude": "46.83073000"
                    },
                    {
                        "id": 101998,
                        "name": "Tyube",
                        "latitude": "43.04926000",
                        "longitude": "47.30742000"
                    },
                    {
                        "id": 102015,
                        "name": "Uchkent",
                        "latitude": "43.11427000",
                        "longitude": "47.08255000"
                    },
                    {
                        "id": 102047,
                        "name": "Ulluaya",
                        "latitude": "42.37377000",
                        "longitude": "47.37451000"
                    },
                    {
                        "id": 102048,
                        "name": "Ullubiyaul",
                        "latitude": "42.59689000",
                        "longitude": "47.71825000"
                    },
                    {
                        "id": 102063,
                        "name": "Untsukul’",
                        "latitude": "42.71149000",
                        "longitude": "46.78663000"
                    },
                    {
                        "id": 102064,
                        "name": "Untsukul’skiy Rayon",
                        "latitude": "42.66667000",
                        "longitude": "46.83333000"
                    },
                    {
                        "id": 102078,
                        "name": "Urkarakh",
                        "latitude": "42.16297000",
                        "longitude": "47.63068000"
                    },
                    {
                        "id": 102079,
                        "name": "Urma",
                        "latitude": "42.53894000",
                        "longitude": "47.28639000"
                    },
                    {
                        "id": 102097,
                        "name": "Usisha",
                        "latitude": "42.25111000",
                        "longitude": "47.39278000"
                    },
                    {
                        "id": 102146,
                        "name": "Usukhchay",
                        "latitude": "41.42245000",
                        "longitude": "47.91318000"
                    },
                    {
                        "id": 102149,
                        "name": "Utamysh",
                        "latitude": "42.40718000",
                        "longitude": "47.75109000"
                    },
                    {
                        "id": 102152,
                        "name": "Utsmiyurt",
                        "latitude": "43.53481000",
                        "longitude": "46.46952000"
                    },
                    {
                        "id": 102210,
                        "name": "Velikent",
                        "latitude": "42.18762000",
                        "longitude": "48.06366000"
                    },
                    {
                        "id": 102248,
                        "name": "Verkhneye Kazanishche",
                        "latitude": "42.73547000",
                        "longitude": "47.13780000"
                    },
                    {
                        "id": 102616,
                        "name": "Yuzhno-Sukhokumsk",
                        "latitude": "44.65811000",
                        "longitude": "45.64360000"
                    },
                    {
                        "id": 102775,
                        "name": "Zubutli-Miatli",
                        "latitude": "43.19886000",
                        "longitude": "46.81241000"
                    }
                ]
            },
            {
                "id": 1884,
                "name": "Ingushetia",
                "iso2": "IN",
                "latitude": "43.40516980",
                "longitude": "44.82029990",
                "type": "republic",
                "cities": [
                    {
                        "id": 97589,
                        "name": "Ali-Yurt",
                        "latitude": "43.14250000",
                        "longitude": "44.85250000"
                    },
                    {
                        "id": 97592,
                        "name": "Alkhan-Churt",
                        "latitude": "43.35194000",
                        "longitude": "44.78694000"
                    },
                    {
                        "id": 98235,
                        "name": "Dalakovo",
                        "latitude": "43.23759000",
                        "longitude": "44.58964000"
                    },
                    {
                        "id": 98374,
                        "name": "Dzhayrakh",
                        "latitude": "42.82043000",
                        "longitude": "44.68139000"
                    },
                    {
                        "id": 98375,
                        "name": "Dzhayrakhskiy Rayon",
                        "latitude": "42.80749000",
                        "longitude": "44.91760000"
                    },
                    {
                        "id": 98382,
                        "name": "Ekazhevo",
                        "latitude": "43.21222000",
                        "longitude": "44.82306000"
                    },
                    {
                        "id": 98449,
                        "name": "Galashki",
                        "latitude": "43.11740000",
                        "longitude": "44.99055000"
                    },
                    {
                        "id": 98847,
                        "name": "Kantyshevo",
                        "latitude": "43.22824000",
                        "longitude": "44.63322000"
                    },
                    {
                        "id": 98856,
                        "name": "Karabulak",
                        "latitude": "43.30513000",
                        "longitude": "44.89949000"
                    },
                    {
                        "id": 99734,
                        "name": "Magas",
                        "latitude": "43.22257000",
                        "longitude": "44.77261000"
                    },
                    {
                        "id": 99754,
                        "name": "Malgobek",
                        "latitude": "43.51118000",
                        "longitude": "44.58821000"
                    },
                    {
                        "id": 99755,
                        "name": "Malgobekskiy Rayon",
                        "latitude": "43.50000000",
                        "longitude": "44.58333000"
                    },
                    {
                        "id": 100078,
                        "name": "Nazran’",
                        "latitude": "43.22597000",
                        "longitude": "44.77323000"
                    },
                    {
                        "id": 100077,
                        "name": "Nazranovskiy Rayon",
                        "latitude": "43.25000000",
                        "longitude": "44.83333000"
                    },
                    {
                        "id": 100112,
                        "name": "Nesterovskaya",
                        "latitude": "43.23861000",
                        "longitude": "45.05028000"
                    },
                    {
                        "id": 100178,
                        "name": "Nizhniye Achaluki",
                        "latitude": "43.40280000",
                        "longitude": "44.75908000"
                    },
                    {
                        "id": 100878,
                        "name": "Psedakh",
                        "latitude": "43.46722000",
                        "longitude": "44.56917000"
                    },
                    {
                        "id": 101073,
                        "name": "Sagopshi",
                        "latitude": "43.48515000",
                        "longitude": "44.59063000"
                    },
                    {
                        "id": 101605,
                        "name": "Staryy Malgobek",
                        "latitude": "43.54437000",
                        "longitude": "44.59592000"
                    },
                    {
                        "id": 101666,
                        "name": "Sunzha",
                        "latitude": "43.31950000",
                        "longitude": "45.04911000"
                    },
                    {
                        "id": 101668,
                        "name": "Sunzhenskiy Rayon",
                        "latitude": "43.33333000",
                        "longitude": "45.08333000"
                    },
                    {
                        "id": 101677,
                        "name": "Surkhakhi",
                        "latitude": "43.18750000",
                        "longitude": "44.90194000"
                    },
                    {
                        "id": 101916,
                        "name": "Troitskaya",
                        "latitude": "43.30664000",
                        "longitude": "44.98395000"
                    },
                    {
                        "id": 102260,
                        "name": "Verkhniye Achaluki",
                        "latitude": "43.34694000",
                        "longitude": "44.69750000"
                    },
                    {
                        "id": 102409,
                        "name": "Voznesenskaya",
                        "latitude": "43.54379000",
                        "longitude": "44.74614000"
                    }
                ]
            },
            {
                "id": 1880,
                "name": "Irkutsk",
                "iso2": "IRK",
                "latitude": "52.28548340",
                "longitude": "104.28902220",
                "type": "administrative region",
                "cities": []
            },
            {
                "id": 1864,
                "name": "Ivanovo",
                "iso2": "IVA",
                "latitude": "57.10568540",
                "longitude": "41.48300840",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97669,
                        "name": "Arkhipovka",
                        "latitude": "56.66292000",
                        "longitude": "41.25434000"
                    },
                    {
                        "id": 97972,
                        "name": "Bogorodskoye",
                        "latitude": "57.04695000",
                        "longitude": "41.01354000"
                    },
                    {
                        "id": 98352,
                        "name": "Dulyapino",
                        "latitude": "57.25783000",
                        "longitude": "40.81471000"
                    },
                    {
                        "id": 98442,
                        "name": "Furmanov",
                        "latitude": "57.25363000",
                        "longitude": "41.10849000"
                    },
                    {
                        "id": 98461,
                        "name": "Gavrilov Posad",
                        "latitude": "56.55930000",
                        "longitude": "40.12100000"
                    },
                    {
                        "id": 98658,
                        "name": "Il’inskoye-Khovanskoye",
                        "latitude": "56.97180000",
                        "longitude": "39.76840000"
                    },
                    {
                        "id": 98731,
                        "name": "Ivanovo",
                        "latitude": "56.99719000",
                        "longitude": "40.97139000"
                    },
                    {
                        "id": 98732,
                        "name": "Ivanovskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "41.00000000"
                    },
                    {
                        "id": 98812,
                        "name": "Kamenka",
                        "latitude": "57.39214000",
                        "longitude": "41.79383000"
                    },
                    {
                        "id": 98826,
                        "name": "Kaminskiy",
                        "latitude": "57.15159000",
                        "longitude": "41.47318000"
                    },
                    {
                        "id": 99048,
                        "name": "Kineshemskiy Rayon",
                        "latitude": "57.33333000",
                        "longitude": "42.33333000"
                    },
                    {
                        "id": 99049,
                        "name": "Kineshma",
                        "latitude": "57.43914000",
                        "longitude": "42.12894000"
                    },
                    {
                        "id": 99083,
                        "name": "Kitovo",
                        "latitude": "56.86586000",
                        "longitude": "41.28246000"
                    },
                    {
                        "id": 99129,
                        "name": "Kokhma",
                        "latitude": "56.93487000",
                        "longitude": "41.09150000"
                    },
                    {
                        "id": 99138,
                        "name": "Kolobovo",
                        "latitude": "56.70199000",
                        "longitude": "41.34173000"
                    },
                    {
                        "id": 99172,
                        "name": "Komsomol’sk",
                        "latitude": "57.02913000",
                        "longitude": "40.37266000"
                    },
                    {
                        "id": 99175,
                        "name": "Komsomol’skiy Rayon",
                        "latitude": "57.08333000",
                        "longitude": "40.41667000"
                    },
                    {
                        "id": 99506,
                        "name": "Kuznechikha",
                        "latitude": "57.21607000",
                        "longitude": "42.33477000"
                    },
                    {
                        "id": 99619,
                        "name": "Lezhnevo",
                        "latitude": "56.77508000",
                        "longitude": "40.89174000"
                    },
                    {
                        "id": 99620,
                        "name": "Lezhnevskiy Rayon",
                        "latitude": "56.75000000",
                        "longitude": "40.91667000"
                    },
                    {
                        "id": 99683,
                        "name": "Lukh",
                        "latitude": "57.01242000",
                        "longitude": "42.25838000"
                    },
                    {
                        "id": 99686,
                        "name": "Lukhskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "42.41667000"
                    },
                    {
                        "id": 99800,
                        "name": "Markovo",
                        "latitude": "57.01850000",
                        "longitude": "40.49465000"
                    },
                    {
                        "id": 100073,
                        "name": "Navoloki",
                        "latitude": "57.46572000",
                        "longitude": "41.96344000"
                    },
                    {
                        "id": 100109,
                        "name": "Nerl’",
                        "latitude": "56.66285000",
                        "longitude": "40.38931000"
                    },
                    {
                        "id": 100220,
                        "name": "Novo-Talitsy",
                        "latitude": "57.00392000",
                        "longitude": "40.85936000"
                    },
                    {
                        "id": 100281,
                        "name": "Novopistsovo",
                        "latitude": "57.32177000",
                        "longitude": "41.85310000"
                    },
                    {
                        "id": 100333,
                        "name": "Novoye Leushino",
                        "latitude": "56.80732000",
                        "longitude": "40.51443000"
                    },
                    {
                        "id": 100359,
                        "name": "Novyye Gorki",
                        "latitude": "56.72535000",
                        "longitude": "41.06014000"
                    },
                    {
                        "id": 100529,
                        "name": "Palekh",
                        "latitude": "56.80256000",
                        "longitude": "41.85508000"
                    },
                    {
                        "id": 100530,
                        "name": "Palekhskiy Rayon",
                        "latitude": "56.83333000",
                        "longitude": "42.00000000"
                    },
                    {
                        "id": 100643,
                        "name": "Pestyaki",
                        "latitude": "56.70860000",
                        "longitude": "42.66954000"
                    },
                    {
                        "id": 100644,
                        "name": "Pestyakovskiy Rayon",
                        "latitude": "56.58333000",
                        "longitude": "42.66667000"
                    },
                    {
                        "id": 100663,
                        "name": "Petrovskiy",
                        "latitude": "56.64210000",
                        "longitude": "40.32026000"
                    },
                    {
                        "id": 100685,
                        "name": "Pistsovo",
                        "latitude": "57.17904000",
                        "longitude": "40.52983000"
                    },
                    {
                        "id": 100705,
                        "name": "Plës",
                        "latitude": "57.45862000",
                        "longitude": "41.51579000"
                    },
                    {
                        "id": 100846,
                        "name": "Privolzhsk",
                        "latitude": "57.38698000",
                        "longitude": "41.28666000"
                    },
                    {
                        "id": 100850,
                        "name": "Privolzhskiy Rayon",
                        "latitude": "57.33333000",
                        "longitude": "41.33333000"
                    },
                    {
                        "id": 100885,
                        "name": "Puchezh",
                        "latitude": "56.97878000",
                        "longitude": "43.16761000"
                    },
                    {
                        "id": 100886,
                        "name": "Puchezhskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "43.00000000"
                    },
                    {
                        "id": 100977,
                        "name": "Rodniki",
                        "latitude": "57.10513000",
                        "longitude": "41.73048000"
                    },
                    {
                        "id": 100980,
                        "name": "Rodnikovskiy Rayon",
                        "latitude": "57.08333000",
                        "longitude": "41.75000000"
                    },
                    {
                        "id": 101135,
                        "name": "Savino",
                        "latitude": "56.59285000",
                        "longitude": "41.21814000"
                    },
                    {
                        "id": 101137,
                        "name": "Savinskiy Rayon",
                        "latitude": "56.58333000",
                        "longitude": "41.33333000"
                    },
                    {
                        "id": 101360,
                        "name": "Shuya",
                        "latitude": "56.84865000",
                        "longitude": "41.38833000"
                    },
                    {
                        "id": 101362,
                        "name": "Shuyskiy Rayon",
                        "latitude": "56.83333000",
                        "longitude": "41.50000000"
                    },
                    {
                        "id": 101568,
                        "name": "Staraya Vichuga",
                        "latitude": "57.26833000",
                        "longitude": "41.87873000"
                    },
                    {
                        "id": 101753,
                        "name": "Talitsy",
                        "latitude": "56.52801000",
                        "longitude": "42.33230000"
                    },
                    {
                        "id": 101847,
                        "name": "Teykovo",
                        "latitude": "56.85796000",
                        "longitude": "40.53692000"
                    },
                    {
                        "id": 101848,
                        "name": "Teykovskiy Rayon",
                        "latitude": "56.75000000",
                        "longitude": "40.50000000"
                    },
                    {
                        "id": 102240,
                        "name": "Verkhnelandekhovskiy Rayon",
                        "latitude": "56.83333000",
                        "longitude": "42.58333000"
                    },
                    {
                        "id": 102254,
                        "name": "Verkhniy Landekh",
                        "latitude": "56.83971000",
                        "longitude": "42.59730000"
                    },
                    {
                        "id": 102300,
                        "name": "Vichuga",
                        "latitude": "57.21276000",
                        "longitude": "41.93012000"
                    },
                    {
                        "id": 102301,
                        "name": "Vichugskiy Rayon",
                        "latitude": "57.25000000",
                        "longitude": "42.00000000"
                    },
                    {
                        "id": 102605,
                        "name": "Yur’yevets",
                        "latitude": "57.32007000",
                        "longitude": "43.10410000"
                    },
                    {
                        "id": 102606,
                        "name": "Yur’yevetskiy Rayon",
                        "latitude": "57.25000000",
                        "longitude": "42.83333000"
                    },
                    {
                        "id": 102612,
                        "name": "Yuzha",
                        "latitude": "56.58306000",
                        "longitude": "42.01222000"
                    },
                    {
                        "id": 102622,
                        "name": "Yuzhskiy Rayon",
                        "latitude": "56.58333000",
                        "longitude": "42.00000000"
                    },
                    {
                        "id": 102652,
                        "name": "Zarechnyy",
                        "latitude": "57.46931000",
                        "longitude": "42.28431000"
                    },
                    {
                        "id": 102678,
                        "name": "Zavolzhsk",
                        "latitude": "57.48230000",
                        "longitude": "42.13779000"
                    },
                    {
                        "id": 102679,
                        "name": "Zavolzhskiy Rayon",
                        "latitude": "57.50000000",
                        "longitude": "42.08333000"
                    }
                ]
            },
            {
                "id": 1835,
                "name": "Jewish",
                "iso2": "YEV",
                "latitude": "48.48081470",
                "longitude": "131.76573670",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 97615,
                        "name": "Amurzet",
                        "latitude": "47.69541000",
                        "longitude": "131.09493000"
                    },
                    {
                        "id": 97742,
                        "name": "Babstovo",
                        "latitude": "48.11853000",
                        "longitude": "132.47913000"
                    },
                    {
                        "id": 97932,
                        "name": "Bira",
                        "latitude": "49.00135000",
                        "longitude": "132.46826000"
                    },
                    {
                        "id": 97933,
                        "name": "Birakan",
                        "latitude": "48.99302000",
                        "longitude": "131.72026000"
                    },
                    {
                        "id": 97935,
                        "name": "Birobidzhan",
                        "latitude": "48.79284000",
                        "longitude": "132.92386000"
                    },
                    {
                        "id": 97936,
                        "name": "Birobidzhanskiy Rayon",
                        "latitude": "48.50000000",
                        "longitude": "132.75000000"
                    },
                    {
                        "id": 98760,
                        "name": "Izvestkovyy",
                        "latitude": "48.98043000",
                        "longitude": "131.55274000"
                    },
                    {
                        "id": 98982,
                        "name": "Khingansk",
                        "latitude": "49.12821000",
                        "longitude": "131.19322000"
                    },
                    {
                        "id": 99439,
                        "name": "Kul’dur",
                        "latitude": "49.20465000",
                        "longitude": "131.63840000"
                    },
                    {
                        "id": 99574,
                        "name": "Leninskiy Rayon",
                        "latitude": "48.16667000",
                        "longitude": "132.25000000"
                    },
                    {
                        "id": 99578,
                        "name": "Leninskoye",
                        "latitude": "47.93501000",
                        "longitude": "132.62025000"
                    },
                    {
                        "id": 99660,
                        "name": "Londoko",
                        "latitude": "49.01805000",
                        "longitude": "131.99142000"
                    },
                    {
                        "id": 100385,
                        "name": "Obluchenskiy Rayon",
                        "latitude": "49.00000000",
                        "longitude": "132.00000000"
                    },
                    {
                        "id": 100415,
                        "name": "Oktyabr’skiy Rayon",
                        "latitude": "48.16667000",
                        "longitude": "131.41667000"
                    },
                    {
                        "id": 100813,
                        "name": "Priamurskiy",
                        "latitude": "48.52716000",
                        "longitude": "134.90359000"
                    },
                    {
                        "id": 101411,
                        "name": "Smidovich",
                        "latitude": "48.59647000",
                        "longitude": "133.80866000"
                    },
                    {
                        "id": 101412,
                        "name": "Smidovichskiy Rayon",
                        "latitude": "48.50000000",
                        "longitude": "134.00000000"
                    },
                    {
                        "id": 102349,
                        "name": "Volochayevka Vtoraya",
                        "latitude": "48.56695000",
                        "longitude": "134.58232000"
                    }
                ]
            },
            {
                "id": 1892,
                "name": "Kabardino-Balkar",
                "iso2": "KB",
                "latitude": "43.39324690",
                "longitude": "43.56284980",
                "type": "republic",
                "cities": [
                    {
                        "id": 97571,
                        "name": "Aleksandrovskaya",
                        "latitude": "43.48333000",
                        "longitude": "43.65000000"
                    },
                    {
                        "id": 97604,
                        "name": "Altud",
                        "latitude": "43.72194000",
                        "longitude": "43.86583000"
                    },
                    {
                        "id": 97661,
                        "name": "Argudan",
                        "latitude": "43.42139000",
                        "longitude": "43.91583000"
                    },
                    {
                        "id": 97720,
                        "name": "Aushiger",
                        "latitude": "43.39611000",
                        "longitude": "43.73167000"
                    },
                    {
                        "id": 97743,
                        "name": "Babugent",
                        "latitude": "43.27942000",
                        "longitude": "43.55020000"
                    },
                    {
                        "id": 97762,
                        "name": "Baksan",
                        "latitude": "43.68806000",
                        "longitude": "43.53694000"
                    },
                    {
                        "id": 97763,
                        "name": "Baksanenok",
                        "latitude": "43.68972000",
                        "longitude": "43.65472000"
                    },
                    {
                        "id": 97764,
                        "name": "Baksanskiy Rayon",
                        "latitude": "43.75000000",
                        "longitude": "43.50000000"
                    },
                    {
                        "id": 97844,
                        "name": "Belaya Rechka",
                        "latitude": "43.43806000",
                        "longitude": "43.53500000"
                    },
                    {
                        "id": 98099,
                        "name": "Bylym",
                        "latitude": "43.46500000",
                        "longitude": "43.03889000"
                    },
                    {
                        "id": 98132,
                        "name": "Chegem",
                        "latitude": "43.28333000",
                        "longitude": "43.13333000"
                    },
                    {
                        "id": 98133,
                        "name": "Chegem Vtoroy",
                        "latitude": "43.59583000",
                        "longitude": "43.59944000"
                    },
                    {
                        "id": 98146,
                        "name": "Cherekskiy Rayon",
                        "latitude": "43.25000000",
                        "longitude": "43.50000000"
                    },
                    {
                        "id": 98272,
                        "name": "Deyskoye",
                        "latitude": "43.47546000",
                        "longitude": "44.16182000"
                    },
                    {
                        "id": 98348,
                        "name": "Dugulubgey",
                        "latitude": "43.66250000",
                        "longitude": "43.53694000"
                    },
                    {
                        "id": 98390,
                        "name": "El’brus",
                        "latitude": "43.25771000",
                        "longitude": "42.64435000"
                    },
                    {
                        "id": 98391,
                        "name": "El’brusskiy Rayon",
                        "latitude": "43.41667000",
                        "longitude": "42.83333000"
                    },
                    {
                        "id": 98483,
                        "name": "Germenchik",
                        "latitude": "43.59389000",
                        "longitude": "43.76611000"
                    },
                    {
                        "id": 98611,
                        "name": "Gundelen",
                        "latitude": "43.59750000",
                        "longitude": "43.17194000"
                    },
                    {
                        "id": 98713,
                        "name": "Islamey",
                        "latitude": "43.67556000",
                        "longitude": "43.45500000"
                    },
                    {
                        "id": 98777,
                        "name": "Kakhun",
                        "latitude": "43.54306000",
                        "longitude": "43.87639000"
                    },
                    {
                        "id": 98811,
                        "name": "Kamenka",
                        "latitude": "43.53333000",
                        "longitude": "43.51667000"
                    },
                    {
                        "id": 98817,
                        "name": "Kamennomostskoye",
                        "latitude": "43.73722000",
                        "longitude": "43.05139000"
                    },
                    {
                        "id": 98860,
                        "name": "Karagach",
                        "latitude": "43.80528000",
                        "longitude": "43.77500000"
                    },
                    {
                        "id": 98896,
                        "name": "Kashkhatau",
                        "latitude": "43.31848000",
                        "longitude": "43.60804000"
                    },
                    {
                        "id": 98940,
                        "name": "Kenzhe",
                        "latitude": "43.50167000",
                        "longitude": "43.55722000"
                    },
                    {
                        "id": 99080,
                        "name": "Kishpek",
                        "latitude": "43.65500000",
                        "longitude": "43.64083000"
                    },
                    {
                        "id": 99249,
                        "name": "Kotlyarevskaya",
                        "latitude": "43.57344000",
                        "longitude": "44.06134000"
                    },
                    {
                        "id": 99413,
                        "name": "Kuba-Taba",
                        "latitude": "43.77611000",
                        "longitude": "43.44278000"
                    },
                    {
                        "id": 99524,
                        "name": "Kyzburun Pervyy",
                        "latitude": "43.65167000",
                        "longitude": "43.39500000"
                    },
                    {
                        "id": 99559,
                        "name": "Lechinkay",
                        "latitude": "43.56472000",
                        "longitude": "43.43278000"
                    },
                    {
                        "id": 99590,
                        "name": "Leskenskiy rayon",
                        "latitude": "43.35556000",
                        "longitude": "43.94139000"
                    },
                    {
                        "id": 99759,
                        "name": "Malka",
                        "latitude": "43.80389000",
                        "longitude": "43.32417000"
                    },
                    {
                        "id": 99834,
                        "name": "Mayskiy Rayon",
                        "latitude": "43.66667000",
                        "longitude": "44.08333000"
                    },
                    {
                        "id": 100054,
                        "name": "Nal’chik",
                        "latitude": "43.49806000",
                        "longitude": "43.61889000"
                    },
                    {
                        "id": 100061,
                        "name": "Nartan",
                        "latitude": "43.51083000",
                        "longitude": "43.69944000"
                    },
                    {
                        "id": 100062,
                        "name": "Nartkala",
                        "latitude": "43.55750000",
                        "longitude": "43.85083000"
                    },
                    {
                        "id": 100165,
                        "name": "Nizhniy Cherek",
                        "latitude": "43.51306000",
                        "longitude": "43.91389000"
                    },
                    {
                        "id": 100170,
                        "name": "Nizhniy Kurkuzhin",
                        "latitude": "43.74833000",
                        "longitude": "43.34972000"
                    },
                    {
                        "id": 100693,
                        "name": "Planovskoye",
                        "latitude": "43.39846000",
                        "longitude": "44.19490000"
                    },
                    {
                        "id": 100828,
                        "name": "Primalkinskoye",
                        "latitude": "43.74667000",
                        "longitude": "44.00833000"
                    },
                    {
                        "id": 100855,
                        "name": "Prokhladnenskiy Rayon",
                        "latitude": "43.83333000",
                        "longitude": "44.00000000"
                    },
                    {
                        "id": 100856,
                        "name": "Prokhladnyy",
                        "latitude": "43.75741000",
                        "longitude": "44.02970000"
                    },
                    {
                        "id": 100883,
                        "name": "Psygansu",
                        "latitude": "43.41944000",
                        "longitude": "43.79361000"
                    },
                    {
                        "id": 101119,
                        "name": "Sarmakovo",
                        "latitude": "43.74556000",
                        "longitude": "43.20028000"
                    },
                    {
                        "id": 101248,
                        "name": "Shalushka",
                        "latitude": "43.53250000",
                        "longitude": "43.56611000"
                    },
                    {
                        "id": 101446,
                        "name": "Soldatskaya",
                        "latitude": "43.81806000",
                        "longitude": "43.81583000"
                    },
                    {
                        "id": 101604,
                        "name": "Staryy Cherek",
                        "latitude": "43.47139000",
                        "longitude": "43.84694000"
                    },
                    {
                        "id": 101609,
                        "name": "Staryy Urukh",
                        "latitude": "43.34041000",
                        "longitude": "44.01868000"
                    },
                    {
                        "id": 101827,
                        "name": "Terek",
                        "latitude": "43.48333000",
                        "longitude": "44.13611000"
                    },
                    {
                        "id": 101838,
                        "name": "Terskiy Rayon",
                        "latitude": "43.58333000",
                        "longitude": "44.25000000"
                    },
                    {
                        "id": 101840,
                        "name": "Terskol",
                        "latitude": "43.25680000",
                        "longitude": "42.51481000"
                    },
                    {
                        "id": 101997,
                        "name": "Tyrnyauz",
                        "latitude": "43.38278000",
                        "longitude": "42.91833000"
                    },
                    {
                        "id": 102086,
                        "name": "Urukh",
                        "latitude": "43.29335000",
                        "longitude": "44.02647000"
                    },
                    {
                        "id": 102092,
                        "name": "Urvan’",
                        "latitude": "43.49222000",
                        "longitude": "43.76056000"
                    },
                    {
                        "id": 102091,
                        "name": "Urvanskiy Rayon",
                        "latitude": "43.41667000",
                        "longitude": "43.91667000"
                    },
                    {
                        "id": 102253,
                        "name": "Verkhniy Kurkuzhin",
                        "latitude": "43.69556000",
                        "longitude": "43.27472000"
                    },
                    {
                        "id": 102265,
                        "name": "Verkhnyaya Balkariya",
                        "latitude": "43.12545000",
                        "longitude": "43.45687000"
                    },
                    {
                        "id": 102373,
                        "name": "Vol’nyy Aul",
                        "latitude": "43.47861000",
                        "longitude": "43.62750000"
                    },
                    {
                        "id": 102639,
                        "name": "Zalukokoazhe",
                        "latitude": "43.90389000",
                        "longitude": "43.21556000"
                    },
                    {
                        "id": 102687,
                        "name": "Zayukovo",
                        "latitude": "43.61611000",
                        "longitude": "43.33389000"
                    },
                    {
                        "id": 102711,
                        "name": "Zhankhoteko",
                        "latitude": "43.56417000",
                        "longitude": "43.21056000"
                    },
                    {
                        "id": 102724,
                        "name": "Zhemtala",
                        "latitude": "43.28408000",
                        "longitude": "43.65586000"
                    },
                    {
                        "id": 102768,
                        "name": "Zol’skiy Rayon",
                        "latitude": "43.75000000",
                        "longitude": "42.91667000"
                    }
                ]
            },
            {
                "id": 1902,
                "name": "Kaliningrad",
                "iso2": "KGD",
                "latitude": "54.71042640",
                "longitude": "20.45221440",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97755,
                        "name": "Bagrationovsk",
                        "latitude": "54.38714000",
                        "longitude": "20.64372000"
                    },
                    {
                        "id": 97784,
                        "name": "Baltiysk",
                        "latitude": "54.65455000",
                        "longitude": "19.90929000"
                    },
                    {
                        "id": 97989,
                        "name": "Bol'shoe Isakovo",
                        "latitude": "54.71774000",
                        "longitude": "20.60284000"
                    },
                    {
                        "id": 98177,
                        "name": "Chernyakhovsk",
                        "latitude": "54.63345000",
                        "longitude": "21.81557000"
                    },
                    {
                        "id": 98316,
                        "name": "Donskoye",
                        "latitude": "54.93842000",
                        "longitude": "19.96821000"
                    },
                    {
                        "id": 98616,
                        "name": "Gur’yevsk",
                        "latitude": "54.77323000",
                        "longitude": "20.60521000"
                    },
                    {
                        "id": 98618,
                        "name": "Gusev",
                        "latitude": "54.59222000",
                        "longitude": "22.19972000"
                    },
                    {
                        "id": 98624,
                        "name": "Gvardeysk",
                        "latitude": "54.64772000",
                        "longitude": "21.06513000"
                    },
                    {
                        "id": 98787,
                        "name": "Kaliningrad",
                        "latitude": "54.70649000",
                        "longitude": "20.51095000"
                    },
                    {
                        "id": 99013,
                        "name": "Khrabrovo",
                        "latitude": "54.89709000",
                        "longitude": "20.58035000"
                    },
                    {
                        "id": 99356,
                        "name": "Krasnoznamensk",
                        "latitude": "54.94222000",
                        "longitude": "22.48972000"
                    },
                    {
                        "id": 99534,
                        "name": "Ladushkin",
                        "latitude": "54.57025000",
                        "longitude": "20.17099000"
                    },
                    {
                        "id": 99769,
                        "name": "Maloye Isakovo",
                        "latitude": "54.73269000",
                        "longitude": "20.58413000"
                    },
                    {
                        "id": 99777,
                        "name": "Mamonovo",
                        "latitude": "54.46427000",
                        "longitude": "19.93801000"
                    },
                    {
                        "id": 100100,
                        "name": "Neman",
                        "latitude": "55.03111000",
                        "longitude": "22.02639000"
                    },
                    {
                        "id": 100101,
                        "name": "Nemanskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "22.00000000"
                    },
                    {
                        "id": 100111,
                        "name": "Nesterov",
                        "latitude": "54.63056000",
                        "longitude": "22.57139000"
                    },
                    {
                        "id": 100113,
                        "name": "Nesterovskiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "22.58333000"
                    },
                    {
                        "id": 100507,
                        "name": "Otradnoye",
                        "latitude": "54.94114000",
                        "longitude": "20.11397000"
                    },
                    {
                        "id": 100524,
                        "name": "Ozërsk",
                        "latitude": "54.41056000",
                        "longitude": "22.01167000"
                    },
                    {
                        "id": 100520,
                        "name": "Ozerskiy Rayon",
                        "latitude": "54.41667000",
                        "longitude": "22.00000000"
                    },
                    {
                        "id": 100680,
                        "name": "Pionerskiy",
                        "latitude": "54.95083000",
                        "longitude": "20.22748000"
                    },
                    {
                        "id": 100753,
                        "name": "Polessk",
                        "latitude": "54.86205000",
                        "longitude": "21.10279000"
                    },
                    {
                        "id": 100802,
                        "name": "Pravdinsk",
                        "latitude": "54.44289000",
                        "longitude": "21.01785000"
                    },
                    {
                        "id": 100830,
                        "name": "Primorsk",
                        "latitude": "54.73905000",
                        "longitude": "20.00553000"
                    },
                    {
                        "id": 101402,
                        "name": "Slavsk",
                        "latitude": "55.04250000",
                        "longitude": "21.67704000"
                    },
                    {
                        "id": 101403,
                        "name": "Slavskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "21.66667000"
                    },
                    {
                        "id": 101504,
                        "name": "Sovetsk",
                        "latitude": "55.08392000",
                        "longitude": "21.87851000"
                    },
                    {
                        "id": 101701,
                        "name": "Svetlogorsk",
                        "latitude": "54.93987000",
                        "longitude": "20.15479000"
                    },
                    {
                        "id": 101705,
                        "name": "Svetlyy",
                        "latitude": "54.67501000",
                        "longitude": "20.13473000"
                    },
                    {
                        "id": 102350,
                        "name": "Volochayevskoye",
                        "latitude": "54.70034000",
                        "longitude": "20.21966000"
                    },
                    {
                        "id": 102456,
                        "name": "Vzmorye",
                        "latitude": "54.69606000",
                        "longitude": "20.23613000"
                    },
                    {
                        "id": 102486,
                        "name": "Yantarnyy",
                        "latitude": "54.87102000",
                        "longitude": "19.94016000"
                    },
                    {
                        "id": 102619,
                        "name": "Yuzhnyy",
                        "latitude": "54.54837000",
                        "longitude": "20.59843000"
                    },
                    {
                        "id": 102699,
                        "name": "Zelenogradsk",
                        "latitude": "54.95893000",
                        "longitude": "20.47668000"
                    },
                    {
                        "id": 102718,
                        "name": "Zheleznodorozhnyy",
                        "latitude": "54.36013000",
                        "longitude": "21.30597000"
                    },
                    {
                        "id": 102758,
                        "name": "Znamensk",
                        "latitude": "54.61403000",
                        "longitude": "21.22722000"
                    }
                ]
            },
            {
                "id": 1883,
                "name": "Kalmykia",
                "iso2": "KL",
                "latitude": "46.18671760",
                "longitude": "45.00000000",
                "type": "republic",
                "cities": [
                    {
                        "id": 97680,
                        "name": "Arshan’",
                        "latitude": "46.27320000",
                        "longitude": "44.22000000"
                    },
                    {
                        "id": 98389,
                        "name": "Elista",
                        "latitude": "46.30778000",
                        "longitude": "44.25583000"
                    },
                    {
                        "id": 98562,
                        "name": "Gorodoviki",
                        "latitude": "46.13528000",
                        "longitude": "41.96556000"
                    },
                    {
                        "id": 98563,
                        "name": "Gorodovikovsk",
                        "latitude": "46.08785000",
                        "longitude": "41.93353000"
                    },
                    {
                        "id": 98636,
                        "name": "Iki-Burul",
                        "latitude": "45.82083000",
                        "longitude": "44.64722000"
                    },
                    {
                        "id": 98637,
                        "name": "Iki-Burul’skiy Rayon",
                        "latitude": "45.83333000",
                        "longitude": "44.66667000"
                    },
                    {
                        "id": 98901,
                        "name": "Kaspiyskiy",
                        "latitude": "45.39288000",
                        "longitude": "47.37073000"
                    },
                    {
                        "id": 99174,
                        "name": "Komsomol’skiy",
                        "latitude": "45.33000000",
                        "longitude": "46.04280000"
                    },
                    {
                        "id": 99773,
                        "name": "Malyye Derbety",
                        "latitude": "47.95472000",
                        "longitude": "44.68083000"
                    },
                    {
                        "id": 100852,
                        "name": "Priyutnoye",
                        "latitude": "46.10111000",
                        "longitude": "43.50722000"
                    },
                    {
                        "id": 101065,
                        "name": "Sadovoye",
                        "latitude": "47.77720000",
                        "longitude": "44.52080000"
                    },
                    {
                        "id": 101123,
                        "name": "Sarpinskiy Rayon",
                        "latitude": "47.83333000",
                        "longitude": "44.83333000"
                    },
                    {
                        "id": 101516,
                        "name": "Sovetskoye",
                        "latitude": "47.30868000",
                        "longitude": "44.52162000"
                    },
                    {
                        "id": 101921,
                        "name": "Troitskoye",
                        "latitude": "46.42060000",
                        "longitude": "44.25910000"
                    },
                    {
                        "id": 101936,
                        "name": "Tsagan Aman",
                        "latitude": "47.56390000",
                        "longitude": "46.72180000"
                    },
                    {
                        "id": 102508,
                        "name": "Yashalta",
                        "latitude": "46.33950000",
                        "longitude": "42.27620000"
                    },
                    {
                        "id": 102509,
                        "name": "Yashaltinskiy Rayon",
                        "latitude": "46.25000000",
                        "longitude": "42.50000000"
                    },
                    {
                        "id": 102511,
                        "name": "Yashkul’",
                        "latitude": "46.17110000",
                        "longitude": "45.34350000"
                    }
                ]
            },
            {
                "id": 1844,
                "name": "Kaluga",
                "iso2": "KLU",
                "latitude": "54.38726660",
                "longitude": "35.18890940",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97746,
                        "name": "Babynino",
                        "latitude": "54.39385000",
                        "longitude": "35.77013000"
                    },
                    {
                        "id": 97747,
                        "name": "Babyninskiy Rayon",
                        "latitude": "54.41667000",
                        "longitude": "35.75000000"
                    },
                    {
                        "id": 97766,
                        "name": "Balabanovo",
                        "latitude": "55.18161000",
                        "longitude": "36.66060000"
                    },
                    {
                        "id": 97801,
                        "name": "Baryatino",
                        "latitude": "54.31206000",
                        "longitude": "34.52096000"
                    },
                    {
                        "id": 97802,
                        "name": "Baryatinskiy Rayon",
                        "latitude": "54.33333000",
                        "longitude": "34.58333000"
                    },
                    {
                        "id": 97866,
                        "name": "Belousovo",
                        "latitude": "55.09499000",
                        "longitude": "36.67320000"
                    },
                    {
                        "id": 97916,
                        "name": "Betlitsa",
                        "latitude": "54.00946000",
                        "longitude": "33.95875000"
                    },
                    {
                        "id": 98040,
                        "name": "Borovsk",
                        "latitude": "55.20639000",
                        "longitude": "36.48611000"
                    },
                    {
                        "id": 98042,
                        "name": "Borovskiy Rayon",
                        "latitude": "55.16667000",
                        "longitude": "36.50000000"
                    },
                    {
                        "id": 98268,
                        "name": "Deshovki",
                        "latitude": "54.00333000",
                        "longitude": "35.78771000"
                    },
                    {
                        "id": 98270,
                        "name": "Detchino",
                        "latitude": "54.80923000",
                        "longitude": "36.30750000"
                    },
                    {
                        "id": 98354,
                        "name": "Duminichi",
                        "latitude": "53.93446000",
                        "longitude": "35.10993000"
                    },
                    {
                        "id": 98355,
                        "name": "Duminichskiy Rayon",
                        "latitude": "53.91667000",
                        "longitude": "35.00000000"
                    },
                    {
                        "id": 98359,
                        "name": "Dvortsy",
                        "latitude": "54.61677000",
                        "longitude": "35.99740000"
                    },
                    {
                        "id": 98369,
                        "name": "Dzerzhinskiy Rayon",
                        "latitude": "54.75000000",
                        "longitude": "35.75000000"
                    },
                    {
                        "id": 98422,
                        "name": "Ferzikovo",
                        "latitude": "54.51913000",
                        "longitude": "36.75671000"
                    },
                    {
                        "id": 98423,
                        "name": "Ferzikovskiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "36.58333000"
                    },
                    {
                        "id": 98755,
                        "name": "Iznoski",
                        "latitude": "54.98806000",
                        "longitude": "35.31083000"
                    },
                    {
                        "id": 98756,
                        "name": "Iznoskovskiy rayon",
                        "latitude": "54.99026000",
                        "longitude": "35.30961000"
                    },
                    {
                        "id": 98802,
                        "name": "Kaluga",
                        "latitude": "54.52930000",
                        "longitude": "36.27542000"
                    },
                    {
                        "id": 99025,
                        "name": "Khvastovichi",
                        "latitude": "53.46942000",
                        "longitude": "35.09409000"
                    },
                    {
                        "id": 99026,
                        "name": "Khvastovichskiy Rayon",
                        "latitude": "53.50000000",
                        "longitude": "35.16667000"
                    },
                    {
                        "id": 99060,
                        "name": "Kirov",
                        "latitude": "54.06686000",
                        "longitude": "34.29955000"
                    },
                    {
                        "id": 99072,
                        "name": "Kirovskiy Rayon",
                        "latitude": "54.08333000",
                        "longitude": "34.41667000"
                    },
                    {
                        "id": 99183,
                        "name": "Kondrovo",
                        "latitude": "54.80639000",
                        "longitude": "35.92778000"
                    },
                    {
                        "id": 99260,
                        "name": "Kozel’sk",
                        "latitude": "54.03746000",
                        "longitude": "35.77159000"
                    },
                    {
                        "id": 99261,
                        "name": "Kozel’skiy Rayon",
                        "latitude": "54.00000000",
                        "longitude": "35.83333000"
                    },
                    {
                        "id": 99388,
                        "name": "Kremenki",
                        "latitude": "54.88626000",
                        "longitude": "37.11955000"
                    },
                    {
                        "id": 99421,
                        "name": "Kudinovo",
                        "latitude": "54.99939000",
                        "longitude": "36.25331000"
                    },
                    {
                        "id": 99472,
                        "name": "Kurovskoye",
                        "latitude": "54.54299000",
                        "longitude": "36.00262000"
                    },
                    {
                        "id": 99495,
                        "name": "Kuybyshevskiy Rayon",
                        "latitude": "54.08333000",
                        "longitude": "33.91667000"
                    },
                    {
                        "id": 99724,
                        "name": "Lyudinovo",
                        "latitude": "53.86639000",
                        "longitude": "34.44778000"
                    },
                    {
                        "id": 99725,
                        "name": "Lyudinovskiy Rayon",
                        "latitude": "53.91667000",
                        "longitude": "34.50000000"
                    },
                    {
                        "id": 99767,
                        "name": "Maloyaroslavets",
                        "latitude": "55.01457000",
                        "longitude": "36.47185000"
                    },
                    {
                        "id": 99768,
                        "name": "Maloyaroslavetskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "36.50000000"
                    },
                    {
                        "id": 99850,
                        "name": "Medyn’",
                        "latitude": "54.96917000",
                        "longitude": "35.85861000"
                    },
                    {
                        "id": 99849,
                        "name": "Medynskiy Rayon",
                        "latitude": "55.08333000",
                        "longitude": "35.83333000"
                    },
                    {
                        "id": 99869,
                        "name": "Meshchovsk",
                        "latitude": "54.32444000",
                        "longitude": "35.28083000"
                    },
                    {
                        "id": 99870,
                        "name": "Meshchovskiy Rayon",
                        "latitude": "54.33333000",
                        "longitude": "35.41667000"
                    },
                    {
                        "id": 99970,
                        "name": "Mosal’sk",
                        "latitude": "54.48806000",
                        "longitude": "34.98167000"
                    },
                    {
                        "id": 99971,
                        "name": "Mosal’skiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "34.83333000"
                    },
                    {
                        "id": 99991,
                        "name": "Mstikhino",
                        "latitude": "54.55947000",
                        "longitude": "36.12777000"
                    },
                    {
                        "id": 100027,
                        "name": "Myatlevo",
                        "latitude": "54.89693000",
                        "longitude": "35.67619000"
                    },
                    {
                        "id": 100132,
                        "name": "Nikola-Lenivets",
                        "latitude": "54.74943000",
                        "longitude": "35.60133000"
                    },
                    {
                        "id": 100386,
                        "name": "Obninsk",
                        "latitude": "55.09681000",
                        "longitude": "36.61006000"
                    },
                    {
                        "id": 100601,
                        "name": "Peremyshl’",
                        "latitude": "54.26313000",
                        "longitude": "36.16063000"
                    },
                    {
                        "id": 100602,
                        "name": "Peremyshl’skiy Rayon",
                        "latitude": "54.25000000",
                        "longitude": "36.08333000"
                    },
                    {
                        "id": 100756,
                        "name": "Polotnyanyy Zavod",
                        "latitude": "54.72139000",
                        "longitude": "35.96611000"
                    },
                    {
                        "id": 100912,
                        "name": "Pyatovskiy",
                        "latitude": "54.68908000",
                        "longitude": "36.05634000"
                    },
                    {
                        "id": 101178,
                        "name": "Seredeyskiy",
                        "latitude": "54.05071000",
                        "longitude": "35.23183000"
                    },
                    {
                        "id": 101482,
                        "name": "Sosenskiy",
                        "latitude": "54.05899000",
                        "longitude": "35.96228000"
                    },
                    {
                        "id": 101522,
                        "name": "Spas-Demensk",
                        "latitude": "54.41222000",
                        "longitude": "34.02257000"
                    },
                    {
                        "id": 101523,
                        "name": "Spas-Demenskiy Rayon",
                        "latitude": "54.41667000",
                        "longitude": "34.00000000"
                    },
                    {
                        "id": 101649,
                        "name": "Sukhinichi",
                        "latitude": "54.09989000",
                        "longitude": "35.34254000"
                    },
                    {
                        "id": 101650,
                        "name": "Sukhinichskiy Rayon",
                        "latitude": "54.08333000",
                        "longitude": "35.33333000"
                    },
                    {
                        "id": 101782,
                        "name": "Tarusa",
                        "latitude": "54.72436000",
                        "longitude": "37.17272000"
                    },
                    {
                        "id": 101783,
                        "name": "Tarusskiy Rayon",
                        "latitude": "54.66667000",
                        "longitude": "37.00000000"
                    },
                    {
                        "id": 101908,
                        "name": "Tovarkovo",
                        "latitude": "54.67617000",
                        "longitude": "35.93860000"
                    },
                    {
                        "id": 102054,
                        "name": "Ul’yanovskiy Rayon",
                        "latitude": "53.66667000",
                        "longitude": "35.66667000"
                    },
                    {
                        "id": 102385,
                        "name": "Vorotynsk",
                        "latitude": "54.42828000",
                        "longitude": "36.04646000"
                    },
                    {
                        "id": 102445,
                        "name": "Vysokinichi",
                        "latitude": "54.90928000",
                        "longitude": "36.93148000"
                    },
                    {
                        "id": 102568,
                        "name": "Yermolino",
                        "latitude": "55.19489000",
                        "longitude": "36.59513000"
                    },
                    {
                        "id": 102590,
                        "name": "Yukhnov",
                        "latitude": "54.74444000",
                        "longitude": "35.22972000"
                    },
                    {
                        "id": 102591,
                        "name": "Yukhnovskiy Rayon",
                        "latitude": "54.75000000",
                        "longitude": "35.25000000"
                    },
                    {
                        "id": 102657,
                        "name": "Zarech’ye",
                        "latitude": "53.73078000",
                        "longitude": "35.63246000"
                    },
                    {
                        "id": 102731,
                        "name": "Zhiletovo",
                        "latitude": "54.69216000",
                        "longitude": "36.02225000"
                    },
                    {
                        "id": 102738,
                        "name": "Zhizdra",
                        "latitude": "53.74596000",
                        "longitude": "34.73951000"
                    },
                    {
                        "id": 102739,
                        "name": "Zhizdrinskiy Rayon",
                        "latitude": "53.66667000",
                        "longitude": "34.75000000"
                    },
                    {
                        "id": 102742,
                        "name": "Zhukovo",
                        "latitude": "55.03178000",
                        "longitude": "36.74402000"
                    },
                    {
                        "id": 102745,
                        "name": "Zhukovskiy Rayon",
                        "latitude": "55.08333000",
                        "longitude": "36.75000000"
                    }
                ]
            },
            {
                "id": 1865,
                "name": "Kamchatka",
                "iso2": "KAM",
                "latitude": "61.43439810",
                "longitude": "166.78841310",
                "type": "administrative territory",
                "cities": [
                    {
                        "id": 97585,
                        "name": "Aleutskiy Rayon",
                        "latitude": "55.21667000",
                        "longitude": "165.98333000"
                    },
                    {
                        "id": 97715,
                        "name": "Atlasovo",
                        "latitude": "55.60650000",
                        "longitude": "159.64266000"
                    },
                    {
                        "id": 98100,
                        "name": "Bystrinskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "158.50000000"
                    },
                    {
                        "id": 98404,
                        "name": "Esso",
                        "latitude": "55.92738000",
                        "longitude": "158.70708000"
                    },
                    {
                        "id": 98863,
                        "name": "Karaginsky District",
                        "latitude": "58.00000000",
                        "longitude": "159.83333000"
                    },
                    {
                        "id": 99112,
                        "name": "Klyuchi",
                        "latitude": "56.32035000",
                        "longitude": "160.84541000"
                    },
                    {
                        "id": 99270,
                        "name": "Kozyrëvsk",
                        "latitude": "56.04860000",
                        "longitude": "159.87150000"
                    },
                    {
                        "id": 99914,
                        "name": "Mil’kovo",
                        "latitude": "54.69610000",
                        "longitude": "158.62067000"
                    },
                    {
                        "id": 99915,
                        "name": "Mil’kovskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "159.00000000"
                    },
                    {
                        "id": 100430,
                        "name": "Olyutorskiy Rayon",
                        "latitude": "61.00000000",
                        "longitude": "169.00000000"
                    },
                    {
                        "id": 100489,
                        "name": "Ossora",
                        "latitude": "59.24781000",
                        "longitude": "163.07034000"
                    },
                    {
                        "id": 100518,
                        "name": "Ozernovskiy",
                        "latitude": "51.49604000",
                        "longitude": "156.50102000"
                    },
                    {
                        "id": 100527,
                        "name": "Palana",
                        "latitude": "59.08384000",
                        "longitude": "159.95630000"
                    },
                    {
                        "id": 100543,
                        "name": "Paratunka",
                        "latitude": "52.96202000",
                        "longitude": "158.25723000"
                    },
                    {
                        "id": 100596,
                        "name": "Penzhinskiy Rayon",
                        "latitude": "63.00000000",
                        "longitude": "167.00000000"
                    },
                    {
                        "id": 100652,
                        "name": "Petropavlovsk-Kamchatsky",
                        "latitude": "53.04444000",
                        "longitude": "158.65076000"
                    },
                    {
                        "id": 101428,
                        "name": "Sobolevskiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "156.50000000"
                    },
                    {
                        "id": 101849,
                        "name": "Tigil’",
                        "latitude": "57.75979000",
                        "longitude": "158.68161000"
                    },
                    {
                        "id": 101850,
                        "name": "Tigil’skiy Rayon",
                        "latitude": "57.76046000",
                        "longitude": "158.68687000"
                    },
                    {
                        "id": 101856,
                        "name": "Tilichiki",
                        "latitude": "60.42795000",
                        "longitude": "166.05764000"
                    },
                    {
                        "id": 102116,
                        "name": "Ust’-Bol’sheretskiy Rayon",
                        "latitude": "52.66667000",
                        "longitude": "157.00000000"
                    },
                    {
                        "id": 102125,
                        "name": "Ust’-Kamchatsk Staryy",
                        "latitude": "56.22778000",
                        "longitude": "162.47778000"
                    },
                    {
                        "id": 102126,
                        "name": "Ust’-Kamchatskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "161.00000000"
                    },
                    {
                        "id": 102308,
                        "name": "Vilyuchinsk",
                        "latitude": "52.93110000",
                        "longitude": "158.40469000"
                    },
                    {
                        "id": 102544,
                        "name": "Yelizovo",
                        "latitude": "53.18909000",
                        "longitude": "158.38135000"
                    },
                    {
                        "id": 102545,
                        "name": "Yelizovskiy Rayon",
                        "latitude": "53.66667000",
                        "longitude": "159.00000000"
                    }
                ]
            },
            {
                "id": 1869,
                "name": "Karachay-Cherkess",
                "iso2": "KC",
                "latitude": "43.88451430",
                "longitude": "41.73039390",
                "type": "republic",
                "cities": [
                    {
                        "id": 97505,
                        "name": "Adyge-Khabl’",
                        "latitude": "44.33434000",
                        "longitude": "41.93922000"
                    },
                    {
                        "id": 97588,
                        "name": "Ali-Berdukovskiy",
                        "latitude": "43.98952000",
                        "longitude": "41.74212000"
                    },
                    {
                        "id": 97911,
                        "name": "Besleney",
                        "latitude": "44.24050000",
                        "longitude": "41.73870000"
                    },
                    {
                        "id": 98160,
                        "name": "Cherkessk",
                        "latitude": "44.22333000",
                        "longitude": "42.05778000"
                    },
                    {
                        "id": 98328,
                        "name": "Druzhba",
                        "latitude": "44.19530000",
                        "longitude": "42.01700000"
                    },
                    {
                        "id": 98638,
                        "name": "Ikon-Khalk",
                        "latitude": "44.30510000",
                        "longitude": "41.91420000"
                    },
                    {
                        "id": 98714,
                        "name": "Ispravnaya",
                        "latitude": "44.06820000",
                        "longitude": "41.61020000"
                    },
                    {
                        "id": 98857,
                        "name": "Karachayevsk",
                        "latitude": "43.77399000",
                        "longitude": "41.91419000"
                    },
                    {
                        "id": 98858,
                        "name": "Karachayevskiy Rayon",
                        "latitude": "43.50000000",
                        "longitude": "42.00000000"
                    },
                    {
                        "id": 98873,
                        "name": "Kardonikskaya",
                        "latitude": "43.86577000",
                        "longitude": "41.71432000"
                    },
                    {
                        "id": 98914,
                        "name": "Kavkazskiy",
                        "latitude": "44.26720000",
                        "longitude": "42.23470000"
                    },
                    {
                        "id": 98952,
                        "name": "Khabez",
                        "latitude": "44.04340000",
                        "longitude": "41.77200000"
                    },
                    {
                        "id": 99366,
                        "name": "Krasnyy Kurgan",
                        "latitude": "43.94222000",
                        "longitude": "42.61083000"
                    },
                    {
                        "id": 99443,
                        "name": "Kumysh",
                        "latitude": "43.88334000",
                        "longitude": "41.89323000"
                    },
                    {
                        "id": 99458,
                        "name": "Kurdzhinovo",
                        "latitude": "43.98838000",
                        "longitude": "40.95519000"
                    },
                    {
                        "id": 99528,
                        "name": "Kyzyl-Oktyabr’skiy",
                        "latitude": "43.82570000",
                        "longitude": "41.78605000"
                    },
                    {
                        "id": 99763,
                        "name": "Malokarachayevskiy Rayon",
                        "latitude": "43.75000000",
                        "longitude": "42.50000000"
                    },
                    {
                        "id": 99841,
                        "name": "Mednogorskiy",
                        "latitude": "43.91780000",
                        "longitude": "41.18255000"
                    },
                    {
                        "id": 100162,
                        "name": "Nizhniy Arkhyz",
                        "latitude": "43.67817000",
                        "longitude": "41.45977000"
                    },
                    {
                        "id": 100344,
                        "name": "Novyy Karachay",
                        "latitude": "43.82076000",
                        "longitude": "41.90322000"
                    },
                    {
                        "id": 100460,
                        "name": "Ordzhonikidzevskiy",
                        "latitude": "43.84233000",
                        "longitude": "41.89636000"
                    },
                    {
                        "id": 100624,
                        "name": "Pervomayskoye",
                        "latitude": "43.93847000",
                        "longitude": "42.47600000"
                    },
                    {
                        "id": 100805,
                        "name": "Pravokubanskiy",
                        "latitude": "43.91721000",
                        "longitude": "41.88413000"
                    },
                    {
                        "id": 100809,
                        "name": "Pregradnaya",
                        "latitude": "43.95395000",
                        "longitude": "41.18910000"
                    },
                    {
                        "id": 100825,
                        "name": "Prikubanskiy Rayon",
                        "latitude": "44.08333000",
                        "longitude": "42.00000000"
                    },
                    {
                        "id": 100884,
                        "name": "Psyzh",
                        "latitude": "44.23306000",
                        "longitude": "42.01833000"
                    },
                    {
                        "id": 101125,
                        "name": "Sary-Tyuz",
                        "latitude": "43.90181000",
                        "longitude": "41.89523000"
                    },
                    {
                        "id": 101623,
                        "name": "Storozhevaya",
                        "latitude": "43.87886000",
                        "longitude": "41.45143000"
                    },
                    {
                        "id": 101830,
                        "name": "Tereze",
                        "latitude": "43.93608000",
                        "longitude": "42.44340000"
                    },
                    {
                        "id": 102014,
                        "name": "Uchkeken",
                        "latitude": "43.93778000",
                        "longitude": "42.51167000"
                    },
                    {
                        "id": 102016,
                        "name": "Uchkulan",
                        "latitude": "43.45705000",
                        "longitude": "42.09643000"
                    },
                    {
                        "id": 102019,
                        "name": "Udarnyy",
                        "latitude": "44.34917000",
                        "longitude": "42.50528000"
                    },
                    {
                        "id": 102119,
                        "name": "Ust’-Dzheguta",
                        "latitude": "44.08340000",
                        "longitude": "41.97630000"
                    },
                    {
                        "id": 102689,
                        "name": "Zelenchukskaya",
                        "latitude": "43.85804000",
                        "longitude": "41.58940000"
                    }
                ]
            },
            {
                "id": 1841,
                "name": "Karelia",
                "iso2": "KR",
                "latitude": "63.15587020",
                "longitude": "32.99055520",
                "type": "republic",
                "cities": [
                    {
                        "id": 97857,
                        "name": "Belomorsk",
                        "latitude": "64.52322000",
                        "longitude": "34.76680000"
                    },
                    {
                        "id": 98038,
                        "name": "Borovoy",
                        "latitude": "64.61210000",
                        "longitude": "32.24968000"
                    },
                    {
                        "id": 98223,
                        "name": "Chupa",
                        "latitude": "66.27001000",
                        "longitude": "33.05486000"
                    },
                    {
                        "id": 98405,
                        "name": "Essoyla",
                        "latitude": "61.86983000",
                        "longitude": "33.14901000"
                    },
                    {
                        "id": 98492,
                        "name": "Girvas",
                        "latitude": "62.47962000",
                        "longitude": "33.68482000"
                    },
                    {
                        "id": 98782,
                        "name": "Kalevala",
                        "latitude": "65.19873000",
                        "longitude": "31.18999000"
                    },
                    {
                        "id": 98939,
                        "name": "Kem’",
                        "latitude": "64.95546000",
                        "longitude": "34.57929000"
                    },
                    {
                        "id": 98965,
                        "name": "Kharlu",
                        "latitude": "61.80000000",
                        "longitude": "30.95000000"
                    },
                    {
                        "id": 98978,
                        "name": "Khelyulya",
                        "latitude": "61.74900000",
                        "longitude": "30.66473000"
                    },
                    {
                        "id": 99181,
                        "name": "Kondopoga",
                        "latitude": "62.20565000",
                        "longitude": "34.26138000"
                    },
                    {
                        "id": 99240,
                        "name": "Kostomuksha",
                        "latitude": "64.57100000",
                        "longitude": "30.57667000"
                    },
                    {
                        "id": 99515,
                        "name": "Kvartsitnyy",
                        "latitude": "61.49321000",
                        "longitude": "35.02888000"
                    },
                    {
                        "id": 99538,
                        "name": "Lakhdenpokh’ya",
                        "latitude": "61.51981000",
                        "longitude": "30.19917000"
                    },
                    {
                        "id": 99560,
                        "name": "Ledmozero",
                        "latitude": "64.25444000",
                        "longitude": "32.02789000"
                    },
                    {
                        "id": 99671,
                        "name": "Loukhi",
                        "latitude": "66.07616000",
                        "longitude": "33.04745000"
                    },
                    {
                        "id": 99706,
                        "name": "Lyaskelya",
                        "latitude": "61.76322000",
                        "longitude": "31.00616000"
                    },
                    {
                        "id": 99814,
                        "name": "Matrosy",
                        "latitude": "61.78042000",
                        "longitude": "33.81283000"
                    },
                    {
                        "id": 99848,
                        "name": "Medvezh’yegorsk",
                        "latitude": "62.91713000",
                        "longitude": "34.45689000"
                    },
                    {
                        "id": 100023,
                        "name": "Muyezerskiy",
                        "latitude": "63.95758000",
                        "longitude": "31.98738000"
                    },
                    {
                        "id": 100042,
                        "name": "Nadvoitsy",
                        "latitude": "63.86667000",
                        "longitude": "34.31667000"
                    },
                    {
                        "id": 100424,
                        "name": "Olonets",
                        "latitude": "60.98475000",
                        "longitude": "32.96976000"
                    },
                    {
                        "id": 100665,
                        "name": "Petrozavodsk",
                        "latitude": "61.78491000",
                        "longitude": "34.34691000"
                    },
                    {
                        "id": 100674,
                        "name": "Pindushi",
                        "latitude": "62.91519000",
                        "longitude": "34.57996000"
                    },
                    {
                        "id": 100688,
                        "name": "Pitkyaranta",
                        "latitude": "61.57340000",
                        "longitude": "31.47915000"
                    },
                    {
                        "id": 100689,
                        "name": "Pitkyarantskiy Rayon",
                        "latitude": "61.58333000",
                        "longitude": "31.50000000"
                    },
                    {
                        "id": 100780,
                        "name": "Porosozero",
                        "latitude": "62.71912000",
                        "longitude": "32.72703000"
                    },
                    {
                        "id": 100792,
                        "name": "Povenets",
                        "latitude": "62.84870000",
                        "longitude": "34.82621000"
                    },
                    {
                        "id": 100837,
                        "name": "Prionezhskiy Rayon",
                        "latitude": "61.50000000",
                        "longitude": "34.33333000"
                    },
                    {
                        "id": 100876,
                        "name": "Pryazha",
                        "latitude": "61.69258000",
                        "longitude": "33.62159000"
                    },
                    {
                        "id": 100888,
                        "name": "Pudozh",
                        "latitude": "61.80415000",
                        "longitude": "36.52770000"
                    },
                    {
                        "id": 100908,
                        "name": "Pyaozerskiy",
                        "latitude": "65.76870000",
                        "longitude": "31.08925000"
                    },
                    {
                        "id": 100920,
                        "name": "Rabocheostrovsk",
                        "latitude": "64.98547000",
                        "longitude": "34.76611000"
                    },
                    {
                        "id": 101028,
                        "name": "Ruskeala",
                        "latitude": "61.93333000",
                        "longitude": "30.58333000"
                    },
                    {
                        "id": 101080,
                        "name": "Salmi",
                        "latitude": "61.36971000",
                        "longitude": "31.85185000"
                    },
                    {
                        "id": 101149,
                        "name": "Segezha",
                        "latitude": "63.74147000",
                        "longitude": "34.32218000"
                    },
                    {
                        "id": 101250,
                        "name": "Shal’skiy",
                        "latitude": "61.79698000",
                        "longitude": "36.01680000"
                    },
                    {
                        "id": 101294,
                        "name": "Sheltozero",
                        "latitude": "61.36667000",
                        "longitude": "35.36667000"
                    },
                    {
                        "id": 101353,
                        "name": "Shun’ga",
                        "latitude": "62.60263000",
                        "longitude": "34.94680000"
                    },
                    {
                        "id": 101361,
                        "name": "Shuya",
                        "latitude": "61.95251000",
                        "longitude": "34.23271000"
                    },
                    {
                        "id": 101481,
                        "name": "Sortaval’skiy Rayon",
                        "latitude": "61.75000000",
                        "longitude": "30.66667000"
                    },
                    {
                        "id": 101480,
                        "name": "Sortavala",
                        "latitude": "61.71233000",
                        "longitude": "30.70953000"
                    },
                    {
                        "id": 101656,
                        "name": "Sukkozero",
                        "latitude": "63.17018000",
                        "longitude": "32.34436000"
                    },
                    {
                        "id": 101669,
                        "name": "Suoyarvi",
                        "latitude": "62.08333000",
                        "longitude": "32.35000000"
                    },
                    {
                        "id": 101670,
                        "name": "Suoyarvskiy Rayon",
                        "latitude": "62.25000000",
                        "longitude": "32.25000000"
                    },
                    {
                        "id": 102419,
                        "name": "Vyartsilya",
                        "latitude": "62.17645000",
                        "longitude": "30.69296000"
                    },
                    {
                        "id": 102485,
                        "name": "Yanis’yarvi",
                        "latitude": "61.89127000",
                        "longitude": "30.94849000"
                    },
                    {
                        "id": 102484,
                        "name": "Yanishpole",
                        "latitude": "62.11095000",
                        "longitude": "34.27013000"
                    },
                    {
                        "id": 102608,
                        "name": "Yushkozero",
                        "latitude": "64.75162000",
                        "longitude": "32.10255000"
                    }
                ]
            },
            {
                "id": 1897,
                "name": "Kemerovo",
                "iso2": "KEM",
                "latitude": "54.75746480",
                "longitude": "87.40552880",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97477,
                        "name": "Abagur",
                        "latitude": "53.73080000",
                        "longitude": "87.25260000"
                    },
                    {
                        "id": 97646,
                        "name": "Anzhero-Sudzhensk",
                        "latitude": "56.08100000",
                        "longitude": "86.02850000"
                    },
                    {
                        "id": 97685,
                        "name": "Artyshta",
                        "latitude": "54.12220000",
                        "longitude": "86.29090000"
                    },
                    {
                        "id": 97748,
                        "name": "Bachatskiy",
                        "latitude": "54.29270000",
                        "longitude": "86.12850000"
                    },
                    {
                        "id": 97806,
                        "name": "Barzas",
                        "latitude": "55.72912000",
                        "longitude": "86.32233000"
                    },
                    {
                        "id": 97852,
                        "name": "Belogorsk",
                        "latitude": "55.01778000",
                        "longitude": "88.48972000"
                    },
                    {
                        "id": 97867,
                        "name": "Belovo",
                        "latitude": "54.41650000",
                        "longitude": "86.29760000"
                    },
                    {
                        "id": 97907,
                        "name": "Berëzovskiy",
                        "latitude": "55.60000000",
                        "longitude": "86.20000000"
                    },
                    {
                        "id": 98039,
                        "name": "Borovoy",
                        "latitude": "55.43333000",
                        "longitude": "86.08333000"
                    },
                    {
                        "id": 98199,
                        "name": "Chistogorskiy",
                        "latitude": "53.98350000",
                        "longitude": "87.38430000"
                    },
                    {
                        "id": 98576,
                        "name": "Gramoteino",
                        "latitude": "54.53680000",
                        "longitude": "86.38390000"
                    },
                    {
                        "id": 98617,
                        "name": "Gur’yevsk",
                        "latitude": "54.28333000",
                        "longitude": "85.93333000"
                    },
                    {
                        "id": 98677,
                        "name": "Inskoy",
                        "latitude": "54.42970000",
                        "longitude": "86.44000000"
                    },
                    {
                        "id": 98723,
                        "name": "Itatskiy",
                        "latitude": "56.07000000",
                        "longitude": "89.03694000"
                    },
                    {
                        "id": 98749,
                        "name": "Izhmorskiy",
                        "latitude": "56.19239000",
                        "longitude": "86.64161000"
                    },
                    {
                        "id": 98799,
                        "name": "Kaltan",
                        "latitude": "53.53470000",
                        "longitude": "87.24570000"
                    },
                    {
                        "id": 98862,
                        "name": "Karagayla",
                        "latitude": "54.17200000",
                        "longitude": "86.55210000"
                    },
                    {
                        "id": 98921,
                        "name": "Kaz",
                        "latitude": "52.91130000",
                        "longitude": "87.31050000"
                    },
                    {
                        "id": 98933,
                        "name": "Kedrovka",
                        "latitude": "55.53333000",
                        "longitude": "86.05000000"
                    },
                    {
                        "id": 98937,
                        "name": "Kemerovo",
                        "latitude": "55.33333000",
                        "longitude": "86.08333000"
                    },
                    {
                        "id": 99078,
                        "name": "Kiselëvsk",
                        "latitude": "53.99000000",
                        "longitude": "86.66210000"
                    },
                    {
                        "id": 99272,
                        "name": "Krapivinskiy",
                        "latitude": "54.99920000",
                        "longitude": "86.81330000"
                    },
                    {
                        "id": 99298,
                        "name": "Krasnobrodskiy",
                        "latitude": "54.15810000",
                        "longitude": "86.44860000"
                    },
                    {
                        "id": 99307,
                        "name": "Krasnogorskiy",
                        "latitude": "54.54710000",
                        "longitude": "86.28100000"
                    },
                    {
                        "id": 99352,
                        "name": "Krasnoye",
                        "latitude": "54.60680000",
                        "longitude": "85.38990000"
                    },
                    {
                        "id": 99499,
                        "name": "Kuzedeyevo",
                        "latitude": "53.33080000",
                        "longitude": "87.20190000"
                    },
                    {
                        "id": 99569,
                        "name": "Leninsk-Kuznetskiy Rayon",
                        "latitude": "54.66667000",
                        "longitude": "86.00000000"
                    },
                    {
                        "id": 99570,
                        "name": "Leninsk-Kuznetsky",
                        "latitude": "54.65670000",
                        "longitude": "86.17370000"
                    },
                    {
                        "id": 99639,
                        "name": "Listvyagi",
                        "latitude": "53.67720000",
                        "longitude": "86.95100000"
                    },
                    {
                        "id": 99795,
                        "name": "Mariinsk",
                        "latitude": "56.21389000",
                        "longitude": "87.74722000"
                    },
                    {
                        "id": 99880,
                        "name": "Mezhdurechensk",
                        "latitude": "53.69417000",
                        "longitude": "88.06028000"
                    },
                    {
                        "id": 100003,
                        "name": "Mundybash",
                        "latitude": "53.21100000",
                        "longitude": "87.29830000"
                    },
                    {
                        "id": 100033,
                        "name": "Myski",
                        "latitude": "53.70900000",
                        "longitude": "87.80140000"
                    },
                    {
                        "id": 100131,
                        "name": "Nikitinskiy",
                        "latitude": "54.58450000",
                        "longitude": "86.01150000"
                    },
                    {
                        "id": 100257,
                        "name": "Novokuznetsk",
                        "latitude": "53.75570000",
                        "longitude": "87.10990000"
                    },
                    {
                        "id": 100258,
                        "name": "Novokuznetskiy Rayon",
                        "latitude": "53.75000000",
                        "longitude": "87.08333000"
                    },
                    {
                        "id": 100279,
                        "name": "Novopesterevo",
                        "latitude": "54.44290000",
                        "longitude": "85.74010000"
                    },
                    {
                        "id": 100487,
                        "name": "Osinniki",
                        "latitude": "53.62390000",
                        "longitude": "87.35980000"
                    },
                    {
                        "id": 100679,
                        "name": "Pioner",
                        "latitude": "55.31660000",
                        "longitude": "85.95080000"
                    },
                    {
                        "id": 100703,
                        "name": "Plotnikovo",
                        "latitude": "55.02472000",
                        "longitude": "85.94361000"
                    },
                    {
                        "id": 100764,
                        "name": "Polysayevo",
                        "latitude": "54.60120000",
                        "longitude": "86.24590000"
                    },
                    {
                        "id": 100842,
                        "name": "Pritomskiy",
                        "latitude": "53.77240000",
                        "longitude": "87.60820000"
                    },
                    {
                        "id": 100859,
                        "name": "Prokop’yevsk",
                        "latitude": "53.90590000",
                        "longitude": "86.71900000"
                    },
                    {
                        "id": 100860,
                        "name": "Prokop’yevskiy Rayon",
                        "latitude": "54.00000000",
                        "longitude": "86.66667000"
                    },
                    {
                        "id": 100866,
                        "name": "Promyshlennaya",
                        "latitude": "54.91590000",
                        "longitude": "85.63850000"
                    },
                    {
                        "id": 100867,
                        "name": "Promyshlennovskiy",
                        "latitude": "55.48333000",
                        "longitude": "86.20000000"
                    },
                    {
                        "id": 101023,
                        "name": "Rudnichnyy",
                        "latitude": "56.08469000",
                        "longitude": "86.24988000"
                    },
                    {
                        "id": 101077,
                        "name": "Salair",
                        "latitude": "54.23120000",
                        "longitude": "85.79720000"
                    },
                    {
                        "id": 101305,
                        "name": "Sheregesh",
                        "latitude": "52.92090000",
                        "longitude": "87.98690000"
                    },
                    {
                        "id": 101490,
                        "name": "Sosnovka",
                        "latitude": "53.66760000",
                        "longitude": "87.15270000"
                    },
                    {
                        "id": 101527,
                        "name": "Spassk",
                        "latitude": "52.74700000",
                        "longitude": "87.75450000"
                    },
                    {
                        "id": 101572,
                        "name": "Starobachaty",
                        "latitude": "54.24250000",
                        "longitude": "86.20720000"
                    },
                    {
                        "id": 101590,
                        "name": "Staropesterevo",
                        "latitude": "54.50010000",
                        "longitude": "86.40940000"
                    },
                    {
                        "id": 101684,
                        "name": "Suslovo",
                        "latitude": "56.21667000",
                        "longitude": "88.11667000"
                    },
                    {
                        "id": 101788,
                        "name": "Tashtagol",
                        "latitude": "52.76570000",
                        "longitude": "87.88940000"
                    },
                    {
                        "id": 101789,
                        "name": "Tashtagol’skiy Rayon",
                        "latitude": "52.78333000",
                        "longitude": "87.88333000"
                    },
                    {
                        "id": 101802,
                        "name": "Tayga",
                        "latitude": "56.06402000",
                        "longitude": "85.62238000"
                    },
                    {
                        "id": 101806,
                        "name": "Tayzhina",
                        "latitude": "53.66790000",
                        "longitude": "87.43620000"
                    },
                    {
                        "id": 101815,
                        "name": "Temirtau",
                        "latitude": "53.13770000",
                        "longitude": "87.45380000"
                    },
                    {
                        "id": 101864,
                        "name": "Tisul’",
                        "latitude": "55.76173000",
                        "longitude": "88.31228000"
                    },
                    {
                        "id": 101894,
                        "name": "Topki",
                        "latitude": "55.27690000",
                        "longitude": "85.61630000"
                    },
                    {
                        "id": 101930,
                        "name": "Trudarmeyskiy",
                        "latitude": "54.13200000",
                        "longitude": "86.40980000"
                    },
                    {
                        "id": 101990,
                        "name": "Tyazhinskiy",
                        "latitude": "56.11607000",
                        "longitude": "88.52279000"
                    },
                    {
                        "id": 102085,
                        "name": "Ursk",
                        "latitude": "54.45417000",
                        "longitude": "85.40028000"
                    },
                    {
                        "id": 102230,
                        "name": "Verkh-Chebula",
                        "latitude": "56.03062000",
                        "longitude": "87.62215000"
                    },
                    {
                        "id": 102463,
                        "name": "Yagunovo",
                        "latitude": "55.24645000",
                        "longitude": "86.01097000"
                    },
                    {
                        "id": 102464,
                        "name": "Yagunovskiy",
                        "latitude": "55.28280000",
                        "longitude": "85.97800000"
                    },
                    {
                        "id": 102510,
                        "name": "Yashkino",
                        "latitude": "55.87360000",
                        "longitude": "85.42650000"
                    },
                    {
                        "id": 102517,
                        "name": "Yaya",
                        "latitude": "56.20600000",
                        "longitude": "86.44000000"
                    },
                    {
                        "id": 102593,
                        "name": "Yurga",
                        "latitude": "55.72306000",
                        "longitude": "84.88611000"
                    },
                    {
                        "id": 102595,
                        "name": "Yurginskiy Rayon",
                        "latitude": "55.75000000",
                        "longitude": "84.75000000"
                    },
                    {
                        "id": 102697,
                        "name": "Zelenogorskiy",
                        "latitude": "55.03333000",
                        "longitude": "87.00000000"
                    }
                ]
            },
            {
                "id": 1873,
                "name": "Khabarovsk",
                "iso2": "KHA",
                "latitude": "50.58884310",
                "longitude": "135.00000000",
                "type": "administrative territory",
                "cities": [
                    {
                        "id": 97614,
                        "name": "Amursk",
                        "latitude": "50.23685000",
                        "longitude": "136.88136000"
                    },
                    {
                        "id": 97727,
                        "name": "Ayan",
                        "latitude": "56.46314000",
                        "longitude": "138.17777000"
                    },
                    {
                        "id": 97908,
                        "name": "Berëzovyy",
                        "latitude": "51.66897000",
                        "longitude": "135.66584000"
                    },
                    {
                        "id": 97926,
                        "name": "Bikin",
                        "latitude": "46.81293000",
                        "longitude": "134.25012000"
                    },
                    {
                        "id": 97927,
                        "name": "Bikinskiy Rayon",
                        "latitude": "47.00000000",
                        "longitude": "134.25000000"
                    },
                    {
                        "id": 97974,
                        "name": "Bogorodskoye",
                        "latitude": "52.37397000",
                        "longitude": "140.43579000"
                    },
                    {
                        "id": 98131,
                        "name": "Chegdomyn",
                        "latitude": "51.12853000",
                        "longitude": "133.00827000"
                    },
                    {
                        "id": 98221,
                        "name": "Chumikan",
                        "latitude": "54.71857000",
                        "longitude": "135.31630000"
                    },
                    {
                        "id": 98253,
                        "name": "De-Kastri",
                        "latitude": "51.47543000",
                        "longitude": "140.76986000"
                    },
                    {
                        "id": 98525,
                        "name": "Gorin",
                        "latitude": "51.19861000",
                        "longitude": "136.66216000"
                    },
                    {
                        "id": 98542,
                        "name": "Gornyy",
                        "latitude": "50.76344000",
                        "longitude": "136.44951000"
                    },
                    {
                        "id": 98665,
                        "name": "Imeni Poliny Osipenko",
                        "latitude": "52.42270000",
                        "longitude": "136.48692000"
                    },
                    {
                        "id": 98948,
                        "name": "Khabarovsk",
                        "latitude": "48.48271000",
                        "longitude": "135.08379000"
                    },
                    {
                        "id": 98949,
                        "name": "Khabarovsk Vtoroy",
                        "latitude": "48.43776000",
                        "longitude": "135.13329000"
                    },
                    {
                        "id": 99004,
                        "name": "Khor",
                        "latitude": "47.88696000",
                        "longitude": "134.94630000"
                    },
                    {
                        "id": 99021,
                        "name": "Khurba",
                        "latitude": "50.40657000",
                        "longitude": "136.88276000"
                    },
                    {
                        "id": 99115,
                        "name": "Knyaze-Volkonskoye",
                        "latitude": "48.46547000",
                        "longitude": "135.45582000"
                    },
                    {
                        "id": 99171,
                        "name": "Komsomolsk-on-Amur",
                        "latitude": "50.55034000",
                        "longitude": "137.00995000"
                    },
                    {
                        "id": 99206,
                        "name": "Korfovskiy",
                        "latitude": "48.22259000",
                        "longitude": "135.05966000"
                    },
                    {
                        "id": 99548,
                        "name": "Lazarev",
                        "latitude": "52.22307000",
                        "longitude": "141.51265000"
                    },
                    {
                        "id": 99585,
                        "name": "Lermontovka",
                        "latitude": "47.14795000",
                        "longitude": "134.33477000"
                    },
                    {
                        "id": 99641,
                        "name": "Litovko",
                        "latitude": "49.23754000",
                        "longitude": "135.17401000"
                    },
                    {
                        "id": 99668,
                        "name": "Lososina",
                        "latitude": "48.99652000",
                        "longitude": "140.31462000"
                    },
                    {
                        "id": 99740,
                        "name": "Mago",
                        "latitude": "53.25851000",
                        "longitude": "140.18269000"
                    },
                    {
                        "id": 99833,
                        "name": "Mayskiy",
                        "latitude": "48.99887000",
                        "longitude": "140.20976000"
                    },
                    {
                        "id": 99936,
                        "name": "Mnogovershinnyy",
                        "latitude": "53.93345000",
                        "longitude": "139.92740000"
                    },
                    {
                        "id": 99996,
                        "name": "Mukhen",
                        "latitude": "48.19672000",
                        "longitude": "136.12691000"
                    },
                    {
                        "id": 100092,
                        "name": "Nekrasovka",
                        "latitude": "48.35208000",
                        "longitude": "135.23221000"
                    },
                    {
                        "id": 100136,
                        "name": "Nikolayevsk-on-Amure",
                        "latitude": "53.14657000",
                        "longitude": "140.72287000"
                    },
                    {
                        "id": 100353,
                        "name": "Novyy Urgal",
                        "latitude": "51.07089000",
                        "longitude": "132.60075000"
                    },
                    {
                        "id": 100403,
                        "name": "Okhotsk",
                        "latitude": "59.36200000",
                        "longitude": "143.21468000"
                    },
                    {
                        "id": 101155,
                        "name": "Selikhino",
                        "latitude": "50.36832000",
                        "longitude": "137.50163000"
                    },
                    {
                        "id": 101459,
                        "name": "Solnechnyy",
                        "latitude": "50.72367000",
                        "longitude": "136.63831000"
                    },
                    {
                        "id": 101508,
                        "name": "Sovetskaya Gavan’",
                        "latitude": "48.97215000",
                        "longitude": "140.28919000"
                    },
                    {
                        "id": 101895,
                        "name": "Topolëvo",
                        "latitude": "48.50264000",
                        "longitude": "135.17611000"
                    },
                    {
                        "id": 101996,
                        "name": "Tyrma",
                        "latitude": "50.04770000",
                        "longitude": "132.15011000"
                    },
                    {
                        "id": 102186,
                        "name": "Vanino",
                        "latitude": "49.09848000",
                        "longitude": "140.25313000"
                    },
                    {
                        "id": 102421,
                        "name": "Vyazemskiy",
                        "latitude": "47.53757000",
                        "longitude": "134.75556000"
                    },
                    {
                        "id": 102447,
                        "name": "Vysokogornyy",
                        "latitude": "50.09885000",
                        "longitude": "139.12284000"
                    },
                    {
                        "id": 102671,
                        "name": "Zavety Il’icha",
                        "latitude": "49.03737000",
                        "longitude": "140.26989000"
                    }
                ]
            },
            {
                "id": 1877,
                "name": "Khakassia",
                "iso2": "KK",
                "latitude": "53.04522810",
                "longitude": "90.39821450",
                "type": "republic",
                "cities": [
                    {
                        "id": 97478,
                        "name": "Abakan",
                        "latitude": "53.71556000",
                        "longitude": "91.42917000"
                    },
                    {
                        "id": 97479,
                        "name": "Abakan Gorod",
                        "latitude": "53.71667000",
                        "longitude": "91.43333000"
                    },
                    {
                        "id": 97484,
                        "name": "Abaza",
                        "latitude": "52.65500000",
                        "longitude": "90.09278000"
                    },
                    {
                        "id": 97602,
                        "name": "Altayskiy Rayon",
                        "latitude": "53.50000000",
                        "longitude": "91.50000000"
                    },
                    {
                        "id": 97704,
                        "name": "Askiz",
                        "latitude": "53.13194000",
                        "longitude": "90.52639000"
                    },
                    {
                        "id": 97880,
                        "name": "Belyy Yar",
                        "latitude": "53.60389000",
                        "longitude": "91.39028000"
                    },
                    {
                        "id": 97917,
                        "name": "Beya",
                        "latitude": "53.05333000",
                        "longitude": "90.91389000"
                    },
                    {
                        "id": 97941,
                        "name": "Biskamzha",
                        "latitude": "53.44972000",
                        "longitude": "89.52722000"
                    },
                    {
                        "id": 97979,
                        "name": "Bograd",
                        "latitude": "54.23444000",
                        "longitude": "90.83278000"
                    },
                    {
                        "id": 97980,
                        "name": "Bogradskiy Rayon",
                        "latitude": "54.33333000",
                        "longitude": "91.00000000"
                    },
                    {
                        "id": 98191,
                        "name": "Cherëmushki",
                        "latitude": "52.85576000",
                        "longitude": "91.41672000"
                    },
                    {
                        "id": 98170,
                        "name": "Chernogorsk",
                        "latitude": "53.82361000",
                        "longitude": "91.28417000"
                    },
                    {
                        "id": 99165,
                        "name": "Kommunar",
                        "latitude": "54.34835000",
                        "longitude": "89.28297000"
                    },
                    {
                        "id": 99827,
                        "name": "Mayna",
                        "latitude": "53.00639000",
                        "longitude": "91.48361000"
                    },
                    {
                        "id": 100730,
                        "name": "Podsineye",
                        "latitude": "53.66583000",
                        "longitude": "91.53639000"
                    },
                    {
                        "id": 101139,
                        "name": "Sayanogorsk",
                        "latitude": "53.08750000",
                        "longitude": "91.39972000"
                    },
                    {
                        "id": 101326,
                        "name": "Shira",
                        "latitude": "54.49111000",
                        "longitude": "89.95306000"
                    },
                    {
                        "id": 101479,
                        "name": "Sorsk",
                        "latitude": "54.00333000",
                        "longitude": "90.24667000"
                    },
                    {
                        "id": 101790,
                        "name": "Tashtyp",
                        "latitude": "52.79542000",
                        "longitude": "89.89477000"
                    },
                    {
                        "id": 101963,
                        "name": "Tuim",
                        "latitude": "54.33949000",
                        "longitude": "89.94586000"
                    },
                    {
                        "id": 102113,
                        "name": "Ust’-Abakan",
                        "latitude": "53.83651000",
                        "longitude": "91.39077000"
                    },
                    {
                        "id": 102284,
                        "name": "Vershina Tei",
                        "latitude": "53.26858000",
                        "longitude": "89.56008000"
                    }
                ]
            },
            {
                "id": 1838,
                "name": "Khanty-Mansi",
                "iso2": "KHM",
                "latitude": "62.22870620",
                "longitude": "70.64100570",
                "type": "autonomous district",
                "cities": [
                    {
                        "id": 97519,
                        "name": "Agirish",
                        "latitude": "61.92472000",
                        "longitude": "63.02306000"
                    },
                    {
                        "id": 97625,
                        "name": "Andra",
                        "latitude": "62.51472000",
                        "longitude": "65.88778000"
                    },
                    {
                        "id": 97797,
                        "name": "Barsovo",
                        "latitude": "61.16667000",
                        "longitude": "73.16667000"
                    },
                    {
                        "id": 97869,
                        "name": "Beloyarskiy",
                        "latitude": "63.71194000",
                        "longitude": "66.67222000"
                    },
                    {
                        "id": 97906,
                        "name": "Berëzovo",
                        "latitude": "63.93806000",
                        "longitude": "65.04194000"
                    },
                    {
                        "id": 98417,
                        "name": "Fedorovskiy",
                        "latitude": "61.60630000",
                        "longitude": "73.71415000"
                    },
                    {
                        "id": 98531,
                        "name": "Gornopravdinsk",
                        "latitude": "60.05000000",
                        "longitude": "69.90000000"
                    },
                    {
                        "id": 98635,
                        "name": "Igrim",
                        "latitude": "63.19060000",
                        "longitude": "64.41620000"
                    },
                    {
                        "id": 98750,
                        "name": "Izluchinsk",
                        "latitude": "60.97944000",
                        "longitude": "76.92421000"
                    },
                    {
                        "id": 98962,
                        "name": "Khanty-Mansiysk",
                        "latitude": "61.00417000",
                        "longitude": "69.00194000"
                    },
                    {
                        "id": 99017,
                        "name": "Khulimsunt",
                        "latitude": "62.86333000",
                        "longitude": "61.64361000"
                    },
                    {
                        "id": 99128,
                        "name": "Kogalym",
                        "latitude": "62.26537000",
                        "longitude": "74.47906000"
                    },
                    {
                        "id": 99167,
                        "name": "Kommunisticheskiy",
                        "latitude": "61.67889000",
                        "longitude": "64.48194000"
                    },
                    {
                        "id": 99179,
                        "name": "Kondinskoye",
                        "latitude": "59.64806000",
                        "longitude": "67.41000000"
                    },
                    {
                        "id": 99441,
                        "name": "Kuminskiy",
                        "latitude": "58.66667000",
                        "longitude": "66.56667000"
                    },
                    {
                        "id": 99544,
                        "name": "Langepas",
                        "latitude": "61.25439000",
                        "longitude": "75.21240000"
                    },
                    {
                        "id": 99653,
                        "name": "Lokosovo",
                        "latitude": "61.13333000",
                        "longitude": "74.81667000"
                    },
                    {
                        "id": 99705,
                        "name": "Lyantor",
                        "latitude": "61.61945000",
                        "longitude": "72.15546000"
                    },
                    {
                        "id": 99758,
                        "name": "Malinovskiy",
                        "latitude": "61.19528000",
                        "longitude": "62.83972000"
                    },
                    {
                        "id": 99851,
                        "name": "Megion",
                        "latitude": "61.02960000",
                        "longitude": "76.11360000"
                    },
                    {
                        "id": 99881,
                        "name": "Mezhdurechenskiy",
                        "latitude": "59.60000000",
                        "longitude": "65.93333000"
                    },
                    {
                        "id": 99968,
                        "name": "Mortka",
                        "latitude": "59.33222000",
                        "longitude": "66.02139000"
                    },
                    {
                        "id": 100088,
                        "name": "Nefteyugansk",
                        "latitude": "61.09979000",
                        "longitude": "72.60349000"
                    },
                    {
                        "id": 100158,
                        "name": "Nizhnesortymskiy",
                        "latitude": "62.43965000",
                        "longitude": "71.76029000"
                    },
                    {
                        "id": 100160,
                        "name": "Nizhnevartovsk",
                        "latitude": "60.93440000",
                        "longitude": "76.55310000"
                    },
                    {
                        "id": 100221,
                        "name": "Novoagansk",
                        "latitude": "61.94490000",
                        "longitude": "76.66250000"
                    },
                    {
                        "id": 100373,
                        "name": "Nyagan",
                        "latitude": "62.14056000",
                        "longitude": "65.39361000"
                    },
                    {
                        "id": 100681,
                        "name": "Pionerskiy",
                        "latitude": "61.19472000",
                        "longitude": "62.86889000"
                    },
                    {
                        "id": 100739,
                        "name": "Pokachi",
                        "latitude": "61.71982000",
                        "longitude": "75.36827000"
                    },
                    {
                        "id": 100798,
                        "name": "Poykovskiy",
                        "latitude": "61.23333000",
                        "longitude": "73.33333000"
                    },
                    {
                        "id": 100836,
                        "name": "Priob’ye",
                        "latitude": "62.52056000",
                        "longitude": "65.59639000"
                    },
                    {
                        "id": 100917,
                        "name": "Pyt-Yakh",
                        "latitude": "60.74985000",
                        "longitude": "72.85824000"
                    },
                    {
                        "id": 100927,
                        "name": "Raduzhny",
                        "latitude": "62.09611000",
                        "longitude": "77.47500000"
                    },
                    {
                        "id": 101030,
                        "name": "Russkinskiye",
                        "latitude": "62.15380000",
                        "longitude": "73.60102000"
                    },
                    {
                        "id": 101082,
                        "name": "Salym",
                        "latitude": "60.06250000",
                        "longitude": "71.47889000"
                    },
                    {
                        "id": 101109,
                        "name": "Saranpaul’",
                        "latitude": "64.26102000",
                        "longitude": "60.90233000"
                    },
                    {
                        "id": 101307,
                        "name": "Sherkaly",
                        "latitude": "62.75806000",
                        "longitude": "65.47528000"
                    },
                    {
                        "id": 101375,
                        "name": "Singapay",
                        "latitude": "61.15452000",
                        "longitude": "72.66072000"
                    },
                    {
                        "id": 101452,
                        "name": "Solnechniy",
                        "latitude": "61.27944000",
                        "longitude": "73.18139000"
                    },
                    {
                        "id": 101511,
                        "name": "Sovetskiy",
                        "latitude": "61.36139000",
                        "longitude": "63.58417000"
                    },
                    {
                        "id": 101676,
                        "name": "Surgut",
                        "latitude": "61.25000000",
                        "longitude": "73.41667000"
                    },
                    {
                        "id": 102071,
                        "name": "Uray",
                        "latitude": "60.13044000",
                        "longitude": "64.78896000"
                    },
                    {
                        "id": 102588,
                        "name": "Yugorsk",
                        "latitude": "61.31226000",
                        "longitude": "63.33067000"
                    },
                    {
                        "id": 102691,
                        "name": "Zelenoborsk",
                        "latitude": "61.47088000",
                        "longitude": "64.04344000"
                    }
                ]
            },
            {
                "id": 1890,
                "name": "Kirov",
                "iso2": "KIR",
                "latitude": "58.41985290",
                "longitude": "50.20972480",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97508,
                        "name": "Afanas’yevskiy Rayon",
                        "latitude": "58.83333000",
                        "longitude": "53.25000000"
                    },
                    {
                        "id": 97653,
                        "name": "Arbazh",
                        "latitude": "57.68041000",
                        "longitude": "48.30647000"
                    },
                    {
                        "id": 97671,
                        "name": "Arkul’",
                        "latitude": "57.28085000",
                        "longitude": "50.04400000"
                    },
                    {
                        "id": 97843,
                        "name": "Belaya Kholunitsa",
                        "latitude": "58.84000000",
                        "longitude": "50.85278000"
                    },
                    {
                        "id": 97861,
                        "name": "Belorechensk",
                        "latitude": "58.77251000",
                        "longitude": "52.29357000"
                    },
                    {
                        "id": 97973,
                        "name": "Bogorodskoye",
                        "latitude": "57.82849000",
                        "longitude": "50.74856000"
                    },
                    {
                        "id": 98229,
                        "name": "Chërnaya Kholunitsa",
                        "latitude": "58.85115000",
                        "longitude": "51.71545000"
                    },
                    {
                        "id": 98247,
                        "name": "Darovskoy",
                        "latitude": "58.76999000",
                        "longitude": "47.95642000"
                    },
                    {
                        "id": 98263,
                        "name": "Dem’yanovo",
                        "latitude": "60.35111000",
                        "longitude": "47.08417000"
                    },
                    {
                        "id": 98344,
                        "name": "Dubrovka",
                        "latitude": "59.22866000",
                        "longitude": "51.15578000"
                    },
                    {
                        "id": 98412,
                        "name": "Falënki",
                        "latitude": "58.36127000",
                        "longitude": "51.59461000"
                    },
                    {
                        "id": 98413,
                        "name": "Falënskiy Rayon",
                        "latitude": "58.33333000",
                        "longitude": "51.58333000"
                    },
                    {
                        "id": 99037,
                        "name": "Kiknur",
                        "latitude": "57.30341000",
                        "longitude": "47.20105000"
                    },
                    {
                        "id": 99038,
                        "name": "Kiknurskiy Rayon",
                        "latitude": "57.33333000",
                        "longitude": "47.16667000"
                    },
                    {
                        "id": 99041,
                        "name": "Kil’mez’",
                        "latitude": "56.94389000",
                        "longitude": "51.06500000"
                    },
                    {
                        "id": 99059,
                        "name": "Kirov",
                        "latitude": "58.59665000",
                        "longitude": "49.66007000"
                    },
                    {
                        "id": 99062,
                        "name": "Kirovo-Chepetsk",
                        "latitude": "58.55386000",
                        "longitude": "50.03986000"
                    },
                    {
                        "id": 99063,
                        "name": "Kirovo-Chepetskiy Rayon",
                        "latitude": "58.50000000",
                        "longitude": "50.00000000"
                    },
                    {
                        "id": 99073,
                        "name": "Kirs",
                        "latitude": "59.33882000",
                        "longitude": "52.24467000"
                    },
                    {
                        "id": 99233,
                        "name": "Kosino",
                        "latitude": "58.41272000",
                        "longitude": "51.27819000"
                    },
                    {
                        "id": 99239,
                        "name": "Kostino",
                        "latitude": "58.90966000",
                        "longitude": "53.26907000"
                    },
                    {
                        "id": 99244,
                        "name": "Kotel’nich",
                        "latitude": "58.30890000",
                        "longitude": "48.34800000"
                    },
                    {
                        "id": 99282,
                        "name": "Krasnaya Polyana",
                        "latitude": "56.24204000",
                        "longitude": "51.14425000"
                    },
                    {
                        "id": 99444,
                        "name": "Kumëny",
                        "latitude": "58.10887000",
                        "longitude": "49.91614000"
                    },
                    {
                        "id": 99543,
                        "name": "Lal’sk",
                        "latitude": "60.74146000",
                        "longitude": "47.58617000"
                    },
                    {
                        "id": 99577,
                        "name": "Leninskoye",
                        "latitude": "58.31637000",
                        "longitude": "47.08856000"
                    },
                    {
                        "id": 99593,
                        "name": "Lesnoy",
                        "latitude": "59.78100000",
                        "longitude": "52.12838000"
                    },
                    {
                        "id": 99601,
                        "name": "Lesnyye Polyany",
                        "latitude": "59.00314000",
                        "longitude": "52.41802000"
                    },
                    {
                        "id": 99695,
                        "name": "Luza",
                        "latitude": "60.63081000",
                        "longitude": "47.25118000"
                    },
                    {
                        "id": 99699,
                        "name": "Luzskiy Rayon",
                        "latitude": "60.58333000",
                        "longitude": "47.25000000"
                    },
                    {
                        "id": 99704,
                        "name": "Lyangasovo",
                        "latitude": "58.51759000",
                        "longitude": "49.44718000"
                    },
                    {
                        "id": 99760,
                        "name": "Malmyzh",
                        "latitude": "56.52050000",
                        "longitude": "50.68180000"
                    },
                    {
                        "id": 99761,
                        "name": "Malmyzhskiy Rayon",
                        "latitude": "56.58333000",
                        "longitude": "50.91667000"
                    },
                    {
                        "id": 99803,
                        "name": "Maromitsa",
                        "latitude": "59.86828000",
                        "longitude": "48.01227000"
                    },
                    {
                        "id": 99844,
                        "name": "Medvedok",
                        "latitude": "57.38913000",
                        "longitude": "50.03510000"
                    },
                    {
                        "id": 99925,
                        "name": "Mirnyy",
                        "latitude": "58.49333000",
                        "longitude": "47.65389000"
                    },
                    {
                        "id": 100005,
                        "name": "Murashi",
                        "latitude": "59.39990000",
                        "longitude": "48.96150000"
                    },
                    {
                        "id": 100006,
                        "name": "Murashinskiy Rayon",
                        "latitude": "59.33333000",
                        "longitude": "48.75000000"
                    },
                    {
                        "id": 100018,
                        "name": "Murygino",
                        "latitude": "58.73831000",
                        "longitude": "49.45822000"
                    },
                    {
                        "id": 100048,
                        "name": "Nagorsk",
                        "latitude": "59.31722000",
                        "longitude": "50.80778000"
                    },
                    {
                        "id": 100049,
                        "name": "Nagorskiy Rayon",
                        "latitude": "59.50000000",
                        "longitude": "50.83333000"
                    },
                    {
                        "id": 100099,
                        "name": "Nema",
                        "latitude": "57.50675000",
                        "longitude": "50.50115000"
                    },
                    {
                        "id": 100103,
                        "name": "Nemskiy Rayon",
                        "latitude": "57.50000000",
                        "longitude": "50.66667000"
                    },
                    {
                        "id": 100154,
                        "name": "Nizhneivkino",
                        "latitude": "58.19398000",
                        "longitude": "49.52137000"
                    },
                    {
                        "id": 100196,
                        "name": "Nolinsk",
                        "latitude": "57.55962000",
                        "longitude": "49.93629000"
                    },
                    {
                        "id": 100197,
                        "name": "Nolinskiy Rayon",
                        "latitude": "57.58333000",
                        "longitude": "49.91667000"
                    },
                    {
                        "id": 100445,
                        "name": "Omutninsk",
                        "latitude": "58.67001000",
                        "longitude": "52.19320000"
                    },
                    {
                        "id": 100453,
                        "name": "Oparino",
                        "latitude": "59.85179000",
                        "longitude": "48.27826000"
                    },
                    {
                        "id": 100467,
                        "name": "Orichevskiy Rayon",
                        "latitude": "58.25000000",
                        "longitude": "48.75000000"
                    },
                    {
                        "id": 100468,
                        "name": "Orichi",
                        "latitude": "58.40356000",
                        "longitude": "49.05719000"
                    },
                    {
                        "id": 100470,
                        "name": "Orlov",
                        "latitude": "58.53946000",
                        "longitude": "48.89173000"
                    },
                    {
                        "id": 100475,
                        "name": "Orlovskiy Rayon",
                        "latitude": "58.66306000",
                        "longitude": "48.74222000"
                    },
                    {
                        "id": 100559,
                        "name": "Pasegovo",
                        "latitude": "58.50602000",
                        "longitude": "49.51383000"
                    },
                    {
                        "id": 100635,
                        "name": "Peskovka",
                        "latitude": "59.04478000",
                        "longitude": "52.36057000"
                    },
                    {
                        "id": 100678,
                        "name": "Pinyug",
                        "latitude": "60.25095000",
                        "longitude": "47.78425000"
                    },
                    {
                        "id": 100690,
                        "name": "Pizhanka",
                        "latitude": "57.46042000",
                        "longitude": "48.54200000"
                    },
                    {
                        "id": 100691,
                        "name": "Pizhanskiy Rayon",
                        "latitude": "57.41667000",
                        "longitude": "48.50000000"
                    },
                    {
                        "id": 100726,
                        "name": "Podosinovets",
                        "latitude": "60.27758000",
                        "longitude": "47.06587000"
                    },
                    {
                        "id": 100727,
                        "name": "Podosinovskiy Rayon",
                        "latitude": "60.16667000",
                        "longitude": "47.33333000"
                    },
                    {
                        "id": 100930,
                        "name": "Raduzhnyy",
                        "latitude": "58.49899000",
                        "longitude": "49.64347000"
                    },
                    {
                        "id": 101022,
                        "name": "Rudnichnyy",
                        "latitude": "59.61702000",
                        "longitude": "52.47033000"
                    },
                    {
                        "id": 101095,
                        "name": "Sanchursk",
                        "latitude": "56.94125000",
                        "longitude": "47.24987000"
                    },
                    {
                        "id": 101096,
                        "name": "Sanchurskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "47.33333000"
                    },
                    {
                        "id": 101228,
                        "name": "Shabalinskiy Rayon",
                        "latitude": "58.33333000",
                        "longitude": "46.91667000"
                    },
                    {
                        "id": 101409,
                        "name": "Slobodskoy",
                        "latitude": "58.73222000",
                        "longitude": "50.17722000"
                    },
                    {
                        "id": 101410,
                        "name": "Slobodskoy Rayon",
                        "latitude": "58.75000000",
                        "longitude": "50.25000000"
                    },
                    {
                        "id": 101487,
                        "name": "Sosnovka",
                        "latitude": "56.25496000",
                        "longitude": "51.28419000"
                    },
                    {
                        "id": 101503,
                        "name": "Sovetsk",
                        "latitude": "57.58475000",
                        "longitude": "48.95844000"
                    },
                    {
                        "id": 101513,
                        "name": "Sovetskiy Rayon",
                        "latitude": "57.58333000",
                        "longitude": "49.00000000"
                    },
                    {
                        "id": 101521,
                        "name": "Sozimskiy",
                        "latitude": "59.74178000",
                        "longitude": "52.24821000"
                    },
                    {
                        "id": 101629,
                        "name": "Strizhi",
                        "latitude": "58.45758000",
                        "longitude": "49.28667000"
                    },
                    {
                        "id": 101637,
                        "name": "Stulovo",
                        "latitude": "58.72250000",
                        "longitude": "50.14389000"
                    },
                    {
                        "id": 101662,
                        "name": "Suna",
                        "latitude": "57.83379000",
                        "longitude": "50.05884000"
                    },
                    {
                        "id": 101663,
                        "name": "Sunskiy Rayon",
                        "latitude": "57.83333000",
                        "longitude": "50.00000000"
                    },
                    {
                        "id": 101696,
                        "name": "Svecha",
                        "latitude": "58.27849000",
                        "longitude": "47.51636000"
                    },
                    {
                        "id": 101704,
                        "name": "Svetlopolyansk",
                        "latitude": "59.41836000",
                        "longitude": "52.36045000"
                    },
                    {
                        "id": 101898,
                        "name": "Torfyanoy",
                        "latitude": "58.49160000",
                        "longitude": "49.19786000"
                    },
                    {
                        "id": 101987,
                        "name": "Tuzha",
                        "latitude": "57.60615000",
                        "longitude": "47.93597000"
                    },
                    {
                        "id": 102060,
                        "name": "Uni",
                        "latitude": "57.75100000",
                        "longitude": "51.49130000"
                    },
                    {
                        "id": 102061,
                        "name": "Uninskiy Rayon",
                        "latitude": "57.66667000",
                        "longitude": "51.50000000"
                    },
                    {
                        "id": 102094,
                        "name": "Urzhum",
                        "latitude": "57.11412000",
                        "longitude": "49.99956000"
                    },
                    {
                        "id": 102177,
                        "name": "Vakhrushi",
                        "latitude": "58.68472000",
                        "longitude": "50.02611000"
                    },
                    {
                        "id": 102276,
                        "name": "Verkhoshizhem’ye",
                        "latitude": "58.01097000",
                        "longitude": "49.10384000"
                    },
                    {
                        "id": 102398,
                        "name": "Vostochnyy",
                        "latitude": "58.78811000",
                        "longitude": "52.24513000"
                    },
                    {
                        "id": 102420,
                        "name": "Vyatskiye Polyany",
                        "latitude": "56.22602000",
                        "longitude": "51.06557000"
                    },
                    {
                        "id": 102491,
                        "name": "Yaransk",
                        "latitude": "57.30331000",
                        "longitude": "47.88611000"
                    },
                    {
                        "id": 102492,
                        "name": "Yaranskiy Rayon",
                        "latitude": "57.16667000",
                        "longitude": "48.00000000"
                    },
                    {
                        "id": 102602,
                        "name": "Yur’yanskiy Rayon",
                        "latitude": "59.00000000",
                        "longitude": "49.25000000"
                    },
                    {
                        "id": 102777,
                        "name": "Zuyevka",
                        "latitude": "58.40503000",
                        "longitude": "51.13355000"
                    }
                ]
            },
            {
                "id": 1899,
                "name": "Komi",
                "iso2": "KO",
                "latitude": "63.86305390",
                "longitude": "54.83126900",
                "type": "republic",
                "cities": [
                    {
                        "id": 97729,
                        "name": "Aykino",
                        "latitude": "62.22481000",
                        "longitude": "49.99222000"
                    },
                    {
                        "id": 97952,
                        "name": "Blagoyevo",
                        "latitude": "63.42310000",
                        "longitude": "47.96460000"
                    },
                    {
                        "id": 98037,
                        "name": "Borovoy",
                        "latitude": "63.23005000",
                        "longitude": "52.89031000"
                    },
                    {
                        "id": 98410,
                        "name": "Ezhva",
                        "latitude": "61.81281000",
                        "longitude": "50.72834000"
                    },
                    {
                        "id": 98678,
                        "name": "Inta",
                        "latitude": "66.03169000",
                        "longitude": "60.16594000"
                    },
                    {
                        "id": 98748,
                        "name": "Izhma",
                        "latitude": "65.00833000",
                        "longitude": "53.91128000"
                    },
                    {
                        "id": 99116,
                        "name": "Knyazhpogostskiy Rayon",
                        "latitude": "62.58333000",
                        "longitude": "50.91667000"
                    },
                    {
                        "id": 99220,
                        "name": "Kortkeros",
                        "latitude": "61.81056000",
                        "longitude": "51.58056000"
                    },
                    {
                        "id": 99234,
                        "name": "Koslan",
                        "latitude": "63.45641000",
                        "longitude": "48.89891000"
                    },
                    {
                        "id": 99258,
                        "name": "Koygorodok",
                        "latitude": "60.44498000",
                        "longitude": "50.99680000"
                    },
                    {
                        "id": 99259,
                        "name": "Koygorodskiy Rayon",
                        "latitude": "60.41667000",
                        "longitude": "51.00000000"
                    },
                    {
                        "id": 99265,
                        "name": "Kozhva",
                        "latitude": "65.10727000",
                        "longitude": "57.04590000"
                    },
                    {
                        "id": 99606,
                        "name": "Letka",
                        "latitude": "59.60111000",
                        "longitude": "49.42321000"
                    },
                    {
                        "id": 99878,
                        "name": "Mezhdurechensk",
                        "latitude": "63.24556000",
                        "longitude": "48.55333000"
                    },
                    {
                        "id": 99909,
                        "name": "Mikun’",
                        "latitude": "62.35472000",
                        "longitude": "50.07714000"
                    },
                    {
                        "id": 99960,
                        "name": "Mordino",
                        "latitude": "61.35327000",
                        "longitude": "51.89574000"
                    },
                    {
                        "id": 100174,
                        "name": "Nizhniy Odes",
                        "latitude": "63.64451000",
                        "longitude": "54.85598000"
                    },
                    {
                        "id": 100552,
                        "name": "Parma",
                        "latitude": "66.00000000",
                        "longitude": "57.70000000"
                    },
                    {
                        "id": 100587,
                        "name": "Pechora",
                        "latitude": "65.14717000",
                        "longitude": "57.22439000"
                    },
                    {
                        "id": 100827,
                        "name": "Priluzskiy Rayon",
                        "latitude": "60.33333000",
                        "longitude": "49.33333000"
                    },
                    {
                        "id": 100868,
                        "name": "Promyshlennyy",
                        "latitude": "67.58333000",
                        "longitude": "63.91667000"
                    },
                    {
                        "id": 100904,
                        "name": "Puteyets",
                        "latitude": "65.17157000",
                        "longitude": "57.09101000"
                    },
                    {
                        "id": 101148,
                        "name": "Sedkyrkeshch",
                        "latitude": "61.75000000",
                        "longitude": "50.91667000"
                    },
                    {
                        "id": 101343,
                        "name": "Shudayag",
                        "latitude": "63.52665000",
                        "longitude": "53.60582000"
                    },
                    {
                        "id": 101371,
                        "name": "Sindor",
                        "latitude": "62.86286000",
                        "longitude": "51.89051000"
                    },
                    {
                        "id": 101484,
                        "name": "Sosnogorsk",
                        "latitude": "63.60229000",
                        "longitude": "53.88175000"
                    },
                    {
                        "id": 101512,
                        "name": "Sovetskiy",
                        "latitude": "67.48333000",
                        "longitude": "64.41667000"
                    },
                    {
                        "id": 101724,
                        "name": "Syktyvkar",
                        "latitude": "61.66400000",
                        "longitude": "50.81500000"
                    },
                    {
                        "id": 101728,
                        "name": "Synya",
                        "latitude": "65.37185000",
                        "longitude": "58.03874000"
                    },
                    {
                        "id": 101919,
                        "name": "Troitsko-Pechorsk",
                        "latitude": "62.70836000",
                        "longitude": "56.19643000"
                    },
                    {
                        "id": 101920,
                        "name": "Troitsko-Pechorskiy Rayon",
                        "latitude": "62.66667000",
                        "longitude": "56.25000000"
                    },
                    {
                        "id": 101941,
                        "name": "Tsementnozavodskiy",
                        "latitude": "67.62834000",
                        "longitude": "64.08965000"
                    },
                    {
                        "id": 102043,
                        "name": "Ukhta",
                        "latitude": "63.56705000",
                        "longitude": "53.68348000"
                    },
                    {
                        "id": 102096,
                        "name": "Usinsk",
                        "latitude": "65.99389000",
                        "longitude": "57.52806000"
                    },
                    {
                        "id": 102100,
                        "name": "Usogorsk",
                        "latitude": "63.41064000",
                        "longitude": "48.68722000"
                    },
                    {
                        "id": 102110,
                        "name": "Ust-Tsilma",
                        "latitude": "65.44104000",
                        "longitude": "52.14978000"
                    },
                    {
                        "id": 102134,
                        "name": "Ust’-Kulom",
                        "latitude": "61.68636000",
                        "longitude": "53.69020000"
                    },
                    {
                        "id": 102140,
                        "name": "Ust’-Tsilemskiy Rayon",
                        "latitude": "65.41667000",
                        "longitude": "52.16667000"
                    },
                    {
                        "id": 102266,
                        "name": "Verkhnyaya Inta",
                        "latitude": "65.98115000",
                        "longitude": "60.30945000"
                    },
                    {
                        "id": 102268,
                        "name": "Verkhnyaya Maksakovka",
                        "latitude": "61.63504000",
                        "longitude": "50.96740000"
                    },
                    {
                        "id": 102323,
                        "name": "Vizinga",
                        "latitude": "61.07493000",
                        "longitude": "50.10311000"
                    },
                    {
                        "id": 102334,
                        "name": "Vodnyy",
                        "latitude": "63.50464000",
                        "longitude": "53.40947000"
                    },
                    {
                        "id": 102376,
                        "name": "Vorgashor",
                        "latitude": "67.58355000",
                        "longitude": "63.79399000"
                    },
                    {
                        "id": 102377,
                        "name": "Vorkuta",
                        "latitude": "67.49884000",
                        "longitude": "64.05253000"
                    },
                    {
                        "id": 102405,
                        "name": "Voyvozh",
                        "latitude": "62.89198000",
                        "longitude": "54.96346000"
                    },
                    {
                        "id": 102415,
                        "name": "Vuktyl",
                        "latitude": "63.85667000",
                        "longitude": "57.30944000"
                    },
                    {
                        "id": 102493,
                        "name": "Yarega",
                        "latitude": "63.43543000",
                        "longitude": "53.57650000"
                    },
                    {
                        "id": 102559,
                        "name": "Yemva",
                        "latitude": "62.58999000",
                        "longitude": "50.85939000"
                    },
                    {
                        "id": 102648,
                        "name": "Zapolyarnyy",
                        "latitude": "67.49552000",
                        "longitude": "63.73275000"
                    },
                    {
                        "id": 102690,
                        "name": "Zelenets",
                        "latitude": "61.88485000",
                        "longitude": "50.74892000"
                    },
                    {
                        "id": 102726,
                        "name": "Zheshart",
                        "latitude": "62.07314000",
                        "longitude": "49.57335000"
                    }
                ]
            },
            {
                "id": 1910,
                "name": "Kostroma",
                "iso2": "KOS",
                "latitude": "58.55010690",
                "longitude": "43.95411020",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97642,
                        "name": "Antropovo",
                        "latitude": "58.39876000",
                        "longitude": "43.00659000"
                    },
                    {
                        "id": 97643,
                        "name": "Antropovskiy Rayon",
                        "latitude": "58.16667000",
                        "longitude": "43.00000000"
                    },
                    {
                        "id": 97978,
                        "name": "Bogovarovo",
                        "latitude": "58.97849000",
                        "longitude": "47.02462000"
                    },
                    {
                        "id": 98090,
                        "name": "Buy",
                        "latitude": "58.48067000",
                        "longitude": "41.53699000"
                    },
                    {
                        "id": 98093,
                        "name": "Buyskiy Rayon",
                        "latitude": "58.50000000",
                        "longitude": "41.50000000"
                    },
                    {
                        "id": 98203,
                        "name": "Chistyye Bory",
                        "latitude": "58.36472000",
                        "longitude": "41.62778000"
                    },
                    {
                        "id": 98218,
                        "name": "Chukhloma",
                        "latitude": "58.75375000",
                        "longitude": "42.68318000"
                    },
                    {
                        "id": 98450,
                        "name": "Galich",
                        "latitude": "58.37884000",
                        "longitude": "42.34633000"
                    },
                    {
                        "id": 98451,
                        "name": "Galichskiy Rayon",
                        "latitude": "58.33333000",
                        "longitude": "42.25000000"
                    },
                    {
                        "id": 98478,
                        "name": "Georgiyevskoye",
                        "latitude": "58.73101000",
                        "longitude": "45.02404000"
                    },
                    {
                        "id": 98773,
                        "name": "Kadyy",
                        "latitude": "57.78704000",
                        "longitude": "43.19029000"
                    },
                    {
                        "id": 98774,
                        "name": "Kadyyskiy Rayon",
                        "latitude": "57.75000000",
                        "longitude": "43.25000000"
                    },
                    {
                        "id": 99140,
                        "name": "Kologriv",
                        "latitude": "58.82748000",
                        "longitude": "44.31777000"
                    },
                    {
                        "id": 99235,
                        "name": "Kosmynino",
                        "latitude": "57.58183000",
                        "longitude": "40.76434000"
                    },
                    {
                        "id": 99241,
                        "name": "Kostroma",
                        "latitude": "57.76647000",
                        "longitude": "40.92686000"
                    },
                    {
                        "id": 99242,
                        "name": "Kostromskoy Rayon",
                        "latitude": "57.83333000",
                        "longitude": "41.00000000"
                    },
                    {
                        "id": 99332,
                        "name": "Krasnosel’skiy Rayon",
                        "latitude": "57.58333000",
                        "longitude": "41.33333000"
                    },
                    {
                        "id": 99354,
                        "name": "Krasnoye-na-Volge",
                        "latitude": "57.51483000",
                        "longitude": "41.23900000"
                    },
                    {
                        "id": 99742,
                        "name": "Makar’yev",
                        "latitude": "57.88501000",
                        "longitude": "43.80490000"
                    },
                    {
                        "id": 99785,
                        "name": "Manturovo",
                        "latitude": "58.32889000",
                        "longitude": "44.76406000"
                    },
                    {
                        "id": 99786,
                        "name": "Manturovskiy Rayon",
                        "latitude": "58.25000000",
                        "longitude": "44.75000000"
                    },
                    {
                        "id": 100107,
                        "name": "Nerekhta",
                        "latitude": "57.45881000",
                        "longitude": "40.57471000"
                    },
                    {
                        "id": 100108,
                        "name": "Nerekhtskiy Rayon",
                        "latitude": "57.41667000",
                        "longitude": "40.75000000"
                    },
                    {
                        "id": 100122,
                        "name": "Neya",
                        "latitude": "58.29719000",
                        "longitude": "43.86808000"
                    },
                    {
                        "id": 100123,
                        "name": "Neyskiy Rayon",
                        "latitude": "58.30000000",
                        "longitude": "43.90000000"
                    },
                    {
                        "id": 100499,
                        "name": "Ostrovskiy Rayon",
                        "latitude": "57.66667000",
                        "longitude": "42.25000000"
                    },
                    {
                        "id": 100500,
                        "name": "Ostrovskoye",
                        "latitude": "57.80574000",
                        "longitude": "42.24332000"
                    },
                    {
                        "id": 100545,
                        "name": "Parfen’yevo",
                        "latitude": "58.48396000",
                        "longitude": "43.40876000"
                    },
                    {
                        "id": 100546,
                        "name": "Parfen’yevskiy Rayon",
                        "latitude": "58.66667000",
                        "longitude": "43.50000000"
                    },
                    {
                        "id": 100564,
                        "name": "Pavino",
                        "latitude": "59.11390000",
                        "longitude": "46.14142000"
                    },
                    {
                        "id": 100766,
                        "name": "Ponazyrevo",
                        "latitude": "58.35784000",
                        "longitude": "46.31421000"
                    },
                    {
                        "id": 100767,
                        "name": "Ponazyrevskiy Rayon",
                        "latitude": "58.70000000",
                        "longitude": "46.31667000"
                    },
                    {
                        "id": 100915,
                        "name": "Pyshchug",
                        "latitude": "58.88726000",
                        "longitude": "45.71341000"
                    },
                    {
                        "id": 101265,
                        "name": "Shar’inskiy Rayon",
                        "latitude": "58.50000000",
                        "longitude": "45.58333000"
                    },
                    {
                        "id": 101266,
                        "name": "Shar’ya",
                        "latitude": "58.36909000",
                        "longitude": "45.51558000"
                    },
                    {
                        "id": 101449,
                        "name": "Soligalich",
                        "latitude": "59.07960000",
                        "longitude": "42.28526000"
                    },
                    {
                        "id": 101450,
                        "name": "Soligalichskiy Rayon",
                        "latitude": "59.00000000",
                        "longitude": "42.25000000"
                    },
                    {
                        "id": 101642,
                        "name": "Sudislavl’",
                        "latitude": "57.88175000",
                        "longitude": "41.70829000"
                    },
                    {
                        "id": 101643,
                        "name": "Sudislavskiy Rayon",
                        "latitude": "57.83333000",
                        "longitude": "41.66667000"
                    },
                    {
                        "id": 101682,
                        "name": "Susanino",
                        "latitude": "58.14881000",
                        "longitude": "41.59483000"
                    },
                    {
                        "id": 102296,
                        "name": "Vetluzhskiy",
                        "latitude": "58.39016000",
                        "longitude": "45.46543000"
                    },
                    {
                        "id": 102335,
                        "name": "Vokhma",
                        "latitude": "58.93030000",
                        "longitude": "46.75859000"
                    },
                    {
                        "id": 102336,
                        "name": "Vokhomskiy Rayon",
                        "latitude": "58.91667000",
                        "longitude": "46.58333000"
                    },
                    {
                        "id": 102345,
                        "name": "Volgorechensk",
                        "latitude": "57.43931000",
                        "longitude": "41.15553000"
                    }
                ]
            },
            {
                "id": 1891,
                "name": "Krasnodar",
                "iso2": "KDA",
                "latitude": "45.64152890",
                "longitude": "39.70559770",
                "type": "administrative territory",
                "cities": [
                    {
                        "id": 97486,
                        "name": "Abinsk",
                        "latitude": "44.86803000",
                        "longitude": "38.15728000"
                    },
                    {
                        "id": 97487,
                        "name": "Abinskiy Rayon",
                        "latitude": "44.83402000",
                        "longitude": "38.27891000"
                    },
                    {
                        "id": 97490,
                        "name": "Abrau-Dyurso",
                        "latitude": "44.69973000",
                        "longitude": "37.60098000"
                    },
                    {
                        "id": 97503,
                        "name": "Adler",
                        "latitude": "43.42896000",
                        "longitude": "39.92391000"
                    },
                    {
                        "id": 97509,
                        "name": "Afipskiy",
                        "latitude": "44.90005000",
                        "longitude": "38.84265000"
                    },
                    {
                        "id": 97520,
                        "name": "Agoy",
                        "latitude": "44.14660000",
                        "longitude": "39.03730000"
                    },
                    {
                        "id": 97521,
                        "name": "Agronom",
                        "latitude": "45.14021000",
                        "longitude": "39.19484000"
                    },
                    {
                        "id": 97529,
                        "name": "Akhtanizovskaya",
                        "latitude": "45.32128000",
                        "longitude": "37.10071000"
                    },
                    {
                        "id": 97534,
                        "name": "Akhtyrskiy",
                        "latitude": "44.85460000",
                        "longitude": "38.30310000"
                    },
                    {
                        "id": 97580,
                        "name": "Alekseyevskaya",
                        "latitude": "45.77167000",
                        "longitude": "40.15528000"
                    },
                    {
                        "id": 97620,
                        "name": "Anapa",
                        "latitude": "44.89084000",
                        "longitude": "37.32390000"
                    },
                    {
                        "id": 97621,
                        "name": "Anapskaya",
                        "latitude": "44.89671000",
                        "longitude": "37.38600000"
                    },
                    {
                        "id": 97623,
                        "name": "Anastasiyevskaya",
                        "latitude": "45.21576000",
                        "longitude": "37.89258000"
                    },
                    {
                        "id": 97651,
                        "name": "Apsheronsk",
                        "latitude": "44.46472000",
                        "longitude": "39.73417000"
                    },
                    {
                        "id": 97668,
                        "name": "Arkhipo-Osipovka",
                        "latitude": "44.37194000",
                        "longitude": "38.52972000"
                    },
                    {
                        "id": 97673,
                        "name": "Armavir",
                        "latitude": "44.98920000",
                        "longitude": "41.12340000"
                    },
                    {
                        "id": 97708,
                        "name": "Atamanskaya",
                        "latitude": "46.17730000",
                        "longitude": "39.63580000"
                    },
                    {
                        "id": 97736,
                        "name": "Azovskaya",
                        "latitude": "44.79083000",
                        "longitude": "38.62639000"
                    },
                    {
                        "id": 97814,
                        "name": "Baturinskaya",
                        "latitude": "45.79267000",
                        "longitude": "39.37065000"
                    },
                    {
                        "id": 97840,
                        "name": "Belaya Glina",
                        "latitude": "46.07802000",
                        "longitude": "40.86651000"
                    },
                    {
                        "id": 97862,
                        "name": "Belorechensk",
                        "latitude": "44.77127000",
                        "longitude": "39.87879000"
                    },
                    {
                        "id": 97863,
                        "name": "Belorechenskiy Rayon",
                        "latitude": "44.79923000",
                        "longitude": "39.72061000"
                    },
                    {
                        "id": 97872,
                        "name": "Belozërnyy",
                        "latitude": "45.06433000",
                        "longitude": "38.67901000"
                    },
                    {
                        "id": 97893,
                        "name": "Berezanskaya",
                        "latitude": "45.70562000",
                        "longitude": "39.59324000"
                    },
                    {
                        "id": 97912,
                        "name": "Besleneyevskaya",
                        "latitude": "44.23100000",
                        "longitude": "40.72500000"
                    },
                    {
                        "id": 97913,
                        "name": "Besskorbnaya",
                        "latitude": "44.64470000",
                        "longitude": "41.31100000"
                    },
                    {
                        "id": 97951,
                        "name": "Blagovetschenskaya",
                        "latitude": "45.05530000",
                        "longitude": "37.13276000"
                    },
                    {
                        "id": 98062,
                        "name": "Bryukhovetskaya",
                        "latitude": "45.80603000",
                        "longitude": "38.99959000"
                    },
                    {
                        "id": 98111,
                        "name": "Chamlykskaya",
                        "latitude": "44.71583000",
                        "longitude": "40.87861000"
                    },
                    {
                        "id": 98138,
                        "name": "Chelbasskaya",
                        "latitude": "45.97924000",
                        "longitude": "39.37186000"
                    },
                    {
                        "id": 98173,
                        "name": "Chernomorskiy",
                        "latitude": "44.85056000",
                        "longitude": "38.49361000"
                    },
                    {
                        "id": 98174,
                        "name": "Chernoyerkovskaya",
                        "latitude": "45.43306000",
                        "longitude": "37.76861000"
                    },
                    {
                        "id": 98233,
                        "name": "Dagomys",
                        "latitude": "43.66974000",
                        "longitude": "39.66863000"
                    },
                    {
                        "id": 98277,
                        "name": "Dinskaya",
                        "latitude": "45.21516000",
                        "longitude": "39.22650000"
                    },
                    {
                        "id": 98280,
                        "name": "Divnomorskoye",
                        "latitude": "44.50170000",
                        "longitude": "38.13420000"
                    },
                    {
                        "id": 98283,
                        "name": "Dmitriyevskaya",
                        "latitude": "45.65639000",
                        "longitude": "40.76528000"
                    },
                    {
                        "id": 98289,
                        "name": "Dneprovskaya",
                        "latitude": "45.62359000",
                        "longitude": "38.80807000"
                    },
                    {
                        "id": 98304,
                        "name": "Dolzhanskaya",
                        "latitude": "46.63369000",
                        "longitude": "37.80246000"
                    },
                    {
                        "id": 98360,
                        "name": "Dvubratskiy",
                        "latitude": "45.23888000",
                        "longitude": "39.80499000"
                    },
                    {
                        "id": 98378,
                        "name": "Dzhiginka",
                        "latitude": "45.13300000",
                        "longitude": "37.33825000"
                    },
                    {
                        "id": 98379,
                        "name": "Dzhubga",
                        "latitude": "44.32110000",
                        "longitude": "38.70730000"
                    },
                    {
                        "id": 98414,
                        "name": "Fastovetskaya",
                        "latitude": "45.91889000",
                        "longitude": "40.15889000"
                    },
                    {
                        "id": 98466,
                        "name": "Gayduk",
                        "latitude": "44.78489000",
                        "longitude": "37.70050000"
                    },
                    {
                        "id": 98474,
                        "name": "Gelendzhik",
                        "latitude": "44.56220000",
                        "longitude": "38.08480000"
                    },
                    {
                        "id": 98491,
                        "name": "Girey",
                        "latitude": "45.40120000",
                        "longitude": "40.65870000"
                    },
                    {
                        "id": 98494,
                        "name": "Glafirovka",
                        "latitude": "46.76378000",
                        "longitude": "38.40785000"
                    },
                    {
                        "id": 98502,
                        "name": "Glubokiy",
                        "latitude": "44.94673000",
                        "longitude": "41.01845000"
                    },
                    {
                        "id": 98510,
                        "name": "Golubitskaya",
                        "latitude": "45.32566000",
                        "longitude": "37.27020000"
                    },
                    {
                        "id": 98533,
                        "name": "Gornoye Loo",
                        "latitude": "43.71294000",
                        "longitude": "39.60492000"
                    },
                    {
                        "id": 98570,
                        "name": "Goryachiy Klyuch",
                        "latitude": "44.63083000",
                        "longitude": "39.13000000"
                    },
                    {
                        "id": 98571,
                        "name": "Gostagayevskaya",
                        "latitude": "45.02284000",
                        "longitude": "37.50511000"
                    },
                    {
                        "id": 98592,
                        "name": "Grivenskaya",
                        "latitude": "45.64730000",
                        "longitude": "38.17597000"
                    },
                    {
                        "id": 98605,
                        "name": "Gubskaya",
                        "latitude": "44.31639000",
                        "longitude": "40.63583000"
                    },
                    {
                        "id": 98609,
                        "name": "Gul’kevichi",
                        "latitude": "45.35383000",
                        "longitude": "40.69465000"
                    },
                    {
                        "id": 98649,
                        "name": "Il’ich",
                        "latitude": "45.42488000",
                        "longitude": "36.77402000"
                    },
                    {
                        "id": 98660,
                        "name": "Il’skiy",
                        "latitude": "44.84222000",
                        "longitude": "38.56686000"
                    },
                    {
                        "id": 98692,
                        "name": "Irkliyevskaya",
                        "latitude": "45.85635000",
                        "longitude": "39.65381000"
                    },
                    {
                        "id": 98765,
                        "name": "Kabardinka",
                        "latitude": "44.65139000",
                        "longitude": "37.94278000"
                    },
                    {
                        "id": 98789,
                        "name": "Kalininskaya",
                        "latitude": "45.48440000",
                        "longitude": "38.66221000"
                    },
                    {
                        "id": 98798,
                        "name": "Kalnibolotskaya",
                        "latitude": "46.00583000",
                        "longitude": "40.45682000"
                    },
                    {
                        "id": 98828,
                        "name": "Kamyshevatskaya",
                        "latitude": "46.41316000",
                        "longitude": "37.95632000"
                    },
                    {
                        "id": 98840,
                        "name": "Kanelovskaya",
                        "latitude": "46.58960000",
                        "longitude": "39.19440000"
                    },
                    {
                        "id": 98841,
                        "name": "Kanevskaya",
                        "latitude": "46.08490000",
                        "longitude": "38.95960000"
                    },
                    {
                        "id": 98913,
                        "name": "Kavkazskaya",
                        "latitude": "45.44530000",
                        "longitude": "40.67650000"
                    },
                    {
                        "id": 98928,
                        "name": "Kazanskaya",
                        "latitude": "45.41060000",
                        "longitude": "40.43610000"
                    },
                    {
                        "id": 98953,
                        "name": "Khadyzhensk",
                        "latitude": "44.42580000",
                        "longitude": "39.53620000"
                    },
                    {
                        "id": 98997,
                        "name": "Kholmskiy",
                        "latitude": "44.84694000",
                        "longitude": "38.38500000"
                    },
                    {
                        "id": 99009,
                        "name": "Khosta",
                        "latitude": "43.51484000",
                        "longitude": "39.86825000"
                    },
                    {
                        "id": 99082,
                        "name": "Kislyakovskaya",
                        "latitude": "46.44170000",
                        "longitude": "39.67500000"
                    },
                    {
                        "id": 99086,
                        "name": "Kiyevskoye",
                        "latitude": "45.03829000",
                        "longitude": "37.88829000"
                    },
                    {
                        "id": 99185,
                        "name": "Konokovo",
                        "latitude": "44.86160000",
                        "longitude": "41.32660000"
                    },
                    {
                        "id": 99191,
                        "name": "Konstantinovskaya",
                        "latitude": "44.83528000",
                        "longitude": "40.72694000"
                    },
                    {
                        "id": 99195,
                        "name": "Kontenko",
                        "latitude": "45.35806000",
                        "longitude": "36.83222000"
                    },
                    {
                        "id": 99198,
                        "name": "Kopanskaya",
                        "latitude": "46.27785000",
                        "longitude": "38.47955000"
                    },
                    {
                        "id": 99203,
                        "name": "Korenovsk",
                        "latitude": "45.46899000",
                        "longitude": "39.45136000"
                    },
                    {
                        "id": 99222,
                        "name": "Korzhevskiy",
                        "latitude": "45.19414000",
                        "longitude": "37.71949000"
                    },
                    {
                        "id": 99251,
                        "name": "Kovalevskoye",
                        "latitude": "45.19417000",
                        "longitude": "40.97611000"
                    },
                    {
                        "id": 99283,
                        "name": "Krasnaya Polyana",
                        "latitude": "43.67952000",
                        "longitude": "40.20403000"
                    },
                    {
                        "id": 99292,
                        "name": "Krasnoarmeyskaya",
                        "latitude": "45.36614000",
                        "longitude": "38.21171000"
                    },
                    {
                        "id": 99300,
                        "name": "Krasnodar",
                        "latitude": "45.04484000",
                        "longitude": "38.97603000"
                    },
                    {
                        "id": 99351,
                        "name": "Krasnoye",
                        "latitude": "46.73730000",
                        "longitude": "39.56450000"
                    },
                    {
                        "id": 99399,
                        "name": "Kropotkin",
                        "latitude": "45.43750000",
                        "longitude": "40.57556000"
                    },
                    {
                        "id": 99405,
                        "name": "Krylovskaya",
                        "latitude": "46.31944000",
                        "longitude": "39.97111000"
                    },
                    {
                        "id": 99406,
                        "name": "Krylovskiy Rayon",
                        "latitude": "46.33333000",
                        "longitude": "39.96667000"
                    },
                    {
                        "id": 99408,
                        "name": "Krymsk",
                        "latitude": "44.92934000",
                        "longitude": "37.99117000"
                    },
                    {
                        "id": 99409,
                        "name": "Krymskiy Rayon",
                        "latitude": "44.90532000",
                        "longitude": "37.80526000"
                    },
                    {
                        "id": 99415,
                        "name": "Kubanskiy",
                        "latitude": "45.92917000",
                        "longitude": "40.58056000"
                    },
                    {
                        "id": 99417,
                        "name": "Kuchugury",
                        "latitude": "45.40702000",
                        "longitude": "36.95586000"
                    },
                    {
                        "id": 99419,
                        "name": "Kudepsta",
                        "latitude": "43.49547000",
                        "longitude": "39.89294000"
                    },
                    {
                        "id": 99460,
                        "name": "Kurganinsk",
                        "latitude": "44.88000000",
                        "longitude": "40.59861000"
                    },
                    {
                        "id": 99485,
                        "name": "Kushchëvskaya",
                        "latitude": "46.55990000",
                        "longitude": "39.63210000"
                    },
                    {
                        "id": 99530,
                        "name": "Labinsk",
                        "latitude": "44.63417000",
                        "longitude": "40.73556000"
                    },
                    {
                        "id": 99533,
                        "name": "Ladozhskaya",
                        "latitude": "45.30902000",
                        "longitude": "39.93803000"
                    },
                    {
                        "id": 99549,
                        "name": "Lazarevskoye",
                        "latitude": "43.90886000",
                        "longitude": "39.33137000"
                    },
                    {
                        "id": 99562,
                        "name": "Lenina",
                        "latitude": "46.06667000",
                        "longitude": "39.78333000"
                    },
                    {
                        "id": 99564,
                        "name": "Leningradskaya",
                        "latitude": "46.32140000",
                        "longitude": "39.38770000"
                    },
                    {
                        "id": 99587,
                        "name": "Lermontovo",
                        "latitude": "44.30380000",
                        "longitude": "38.75720000"
                    },
                    {
                        "id": 99672,
                        "name": "Lovlinskaya",
                        "latitude": "45.51611000",
                        "longitude": "40.24000000"
                    },
                    {
                        "id": 99822,
                        "name": "Maykopskoye",
                        "latitude": "45.39361000",
                        "longitude": "40.76583000"
                    },
                    {
                        "id": 99845,
                        "name": "Medvedovskaya",
                        "latitude": "45.45151000",
                        "longitude": "39.02485000"
                    },
                    {
                        "id": 99901,
                        "name": "Mikhaylovskaya",
                        "latitude": "44.99472000",
                        "longitude": "40.59639000"
                    },
                    {
                        "id": 99926,
                        "name": "Mirskoy",
                        "latitude": "45.54390000",
                        "longitude": "40.39980000"
                    },
                    {
                        "id": 99981,
                        "name": "Mostovskiy Rayon",
                        "latitude": "44.27503000",
                        "longitude": "40.64588000"
                    },
                    {
                        "id": 99982,
                        "name": "Mostovskoy",
                        "latitude": "44.41222000",
                        "longitude": "40.79361000"
                    },
                    {
                        "id": 100032,
                        "name": "Myskhako",
                        "latitude": "44.65917000",
                        "longitude": "37.76611000"
                    },
                    {
                        "id": 100081,
                        "name": "Nebug",
                        "latitude": "44.17170000",
                        "longitude": "39.00260000"
                    },
                    {
                        "id": 100083,
                        "name": "Neftegorsk",
                        "latitude": "44.36580000",
                        "longitude": "39.70780000"
                    },
                    {
                        "id": 100093,
                        "name": "Nekrasovskaya",
                        "latitude": "45.14468000",
                        "longitude": "39.74868000"
                    },
                    {
                        "id": 100223,
                        "name": "Novoalekseyevskaya",
                        "latitude": "44.81889000",
                        "longitude": "40.93389000"
                    },
                    {
                        "id": 100229,
                        "name": "Novobeysugskaya",
                        "latitude": "45.47195000",
                        "longitude": "39.88614000"
                    },
                    {
                        "id": 100237,
                        "name": "Novoderevyankovskaya",
                        "latitude": "46.32312000",
                        "longitude": "38.74724000"
                    },
                    {
                        "id": 100238,
                        "name": "Novodmitriyevskaya",
                        "latitude": "44.83276000",
                        "longitude": "38.87847000"
                    },
                    {
                        "id": 100241,
                        "name": "Novodzhereliyevskaya",
                        "latitude": "45.77373000",
                        "longitude": "38.67227000"
                    },
                    {
                        "id": 100252,
                        "name": "Novokorsunskaya",
                        "latitude": "45.64080000",
                        "longitude": "39.14641000"
                    },
                    {
                        "id": 100254,
                        "name": "Novokubansk",
                        "latitude": "45.11700000",
                        "longitude": "41.02670000"
                    },
                    {
                        "id": 100255,
                        "name": "Novokubanskiy Rayon",
                        "latitude": "45.08798000",
                        "longitude": "41.04466000"
                    },
                    {
                        "id": 100260,
                        "name": "Novolabinskaya",
                        "latitude": "45.10956000",
                        "longitude": "39.89399000"
                    },
                    {
                        "id": 100263,
                        "name": "Novoleushkovskaya",
                        "latitude": "45.99560000",
                        "longitude": "39.99210000"
                    },
                    {
                        "id": 100265,
                        "name": "Novomalorossiyskaya",
                        "latitude": "45.63483000",
                        "longitude": "39.89481000"
                    },
                    {
                        "id": 100267,
                        "name": "Novomikhaylovskiy",
                        "latitude": "44.26260000",
                        "longitude": "38.85850000"
                    },
                    {
                        "id": 100268,
                        "name": "Novominskaya",
                        "latitude": "46.31630000",
                        "longitude": "38.95860000"
                    },
                    {
                        "id": 100270,
                        "name": "Novomyshastovskaya",
                        "latitude": "45.19909000",
                        "longitude": "38.58272000"
                    },
                    {
                        "id": 100282,
                        "name": "Novoplatnirovskaya",
                        "latitude": "46.10650000",
                        "longitude": "39.41910000"
                    },
                    {
                        "id": 100286,
                        "name": "Novopokrovskaya",
                        "latitude": "45.95139000",
                        "longitude": "40.70056000"
                    },
                    {
                        "id": 100288,
                        "name": "Novorossiysk",
                        "latitude": "44.72439000",
                        "longitude": "37.76752000"
                    },
                    {
                        "id": 100289,
                        "name": "Novorozhdestvenskaya",
                        "latitude": "45.86057000",
                        "longitude": "39.94968000"
                    },
                    {
                        "id": 100299,
                        "name": "Novoshcherbinovskaya",
                        "latitude": "46.47669000",
                        "longitude": "38.64757000"
                    },
                    {
                        "id": 100314,
                        "name": "Novotitarovskaya",
                        "latitude": "45.23756000",
                        "longitude": "38.98059000"
                    },
                    {
                        "id": 100319,
                        "name": "Novoukrainskiy",
                        "latitude": "44.89420000",
                        "longitude": "38.04886000"
                    },
                    {
                        "id": 100320,
                        "name": "Novoukrainskoye",
                        "latitude": "45.37833000",
                        "longitude": "40.52972000"
                    },
                    {
                        "id": 100327,
                        "name": "Novovelichkovskaya",
                        "latitude": "45.27638000",
                        "longitude": "38.84165000"
                    },
                    {
                        "id": 100432,
                        "name": "Ol’ginka",
                        "latitude": "44.20750000",
                        "longitude": "38.89111000"
                    },
                    {
                        "id": 100435,
                        "name": "Ol’ginskaya",
                        "latitude": "45.94610000",
                        "longitude": "38.54864000"
                    },
                    {
                        "id": 100483,
                        "name": "Orël-Izumrud",
                        "latitude": "43.46005000",
                        "longitude": "39.92377000"
                    },
                    {
                        "id": 100504,
                        "name": "Otradnaya",
                        "latitude": "44.39333000",
                        "longitude": "41.52056000"
                    },
                    {
                        "id": 100509,
                        "name": "Otrado-Kubanskoye",
                        "latitude": "45.24417000",
                        "longitude": "40.84083000"
                    },
                    {
                        "id": 100551,
                        "name": "Parkovyy",
                        "latitude": "45.83306000",
                        "longitude": "40.14556000"
                    },
                    {
                        "id": 100562,
                        "name": "Pashkovskiy",
                        "latitude": "45.02366000",
                        "longitude": "39.10436000"
                    },
                    {
                        "id": 100574,
                        "name": "Pavlovskaya",
                        "latitude": "46.13770000",
                        "longitude": "39.78320000"
                    },
                    {
                        "id": 100579,
                        "name": "Pavlovskiy Rayon",
                        "latitude": "46.08978000",
                        "longitude": "39.73150000"
                    },
                    {
                        "id": 100597,
                        "name": "Peredovaya",
                        "latitude": "44.11722000",
                        "longitude": "41.47556000"
                    },
                    {
                        "id": 100603,
                        "name": "Perepravnaya",
                        "latitude": "44.33660000",
                        "longitude": "40.78490000"
                    },
                    {
                        "id": 100610,
                        "name": "Pereyaslovskaya",
                        "latitude": "45.84121000",
                        "longitude": "39.02379000"
                    },
                    {
                        "id": 100653,
                        "name": "Petropavlovskaya",
                        "latitude": "45.08189000",
                        "longitude": "40.45125000"
                    },
                    {
                        "id": 100662,
                        "name": "Petrovskaya",
                        "latitude": "45.43139000",
                        "longitude": "37.95500000"
                    },
                    {
                        "id": 100696,
                        "name": "Plastunovskaya",
                        "latitude": "45.29432000",
                        "longitude": "39.26505000"
                    },
                    {
                        "id": 100697,
                        "name": "Platnirovskaya",
                        "latitude": "45.39531000",
                        "longitude": "39.38420000"
                    },
                    {
                        "id": 100773,
                        "name": "Poputnaya",
                        "latitude": "44.51250000",
                        "longitude": "41.43920000"
                    },
                    {
                        "id": 100824,
                        "name": "Prikubanskiy",
                        "latitude": "45.00150000",
                        "longitude": "41.17950000"
                    },
                    {
                        "id": 100835,
                        "name": "Primorsko-Akhtarsk",
                        "latitude": "46.04970000",
                        "longitude": "38.17470000"
                    },
                    {
                        "id": 100854,
                        "name": "Prochnookopskaya",
                        "latitude": "45.06660000",
                        "longitude": "41.11750000"
                    },
                    {
                        "id": 100877,
                        "name": "Psebay",
                        "latitude": "44.12340000",
                        "longitude": "40.81070000"
                    },
                    {
                        "id": 100879,
                        "name": "Pshada",
                        "latitude": "44.47000000",
                        "longitude": "38.39960000"
                    },
                    {
                        "id": 100880,
                        "name": "Pshekhskaya",
                        "latitude": "44.69597000",
                        "longitude": "39.79665000"
                    },
                    {
                        "id": 100947,
                        "name": "Rayevskaya",
                        "latitude": "44.83571000",
                        "longitude": "37.55577000"
                    },
                    {
                        "id": 100979,
                        "name": "Rodnikovskaya",
                        "latitude": "44.76444000",
                        "longitude": "40.66556000"
                    },
                    {
                        "id": 100985,
                        "name": "Rogovskaya",
                        "latitude": "45.73117000",
                        "longitude": "38.73960000"
                    },
                    {
                        "id": 101042,
                        "name": "Ryazanskaya",
                        "latitude": "44.95528000",
                        "longitude": "39.58894000"
                    },
                    {
                        "id": 101115,
                        "name": "Saratovskaya",
                        "latitude": "44.70752000",
                        "longitude": "39.22156000"
                    },
                    {
                        "id": 101223,
                        "name": "Severskaya",
                        "latitude": "44.85407000",
                        "longitude": "38.67686000"
                    },
                    {
                        "id": 101229,
                        "name": "Shabel’skoye",
                        "latitude": "46.85275000",
                        "longitude": "38.47278000"
                    },
                    {
                        "id": 101287,
                        "name": "Shedok",
                        "latitude": "44.21790000",
                        "longitude": "40.84870000"
                    },
                    {
                        "id": 101303,
                        "name": "Shepsi",
                        "latitude": "44.03550000",
                        "longitude": "39.14740000"
                    },
                    {
                        "id": 101328,
                        "name": "Shirochanka",
                        "latitude": "46.64968000",
                        "longitude": "38.39782000"
                    },
                    {
                        "id": 101335,
                        "name": "Shkurinskaya",
                        "latitude": "46.58580000",
                        "longitude": "39.35990000"
                    },
                    {
                        "id": 101405,
                        "name": "Slavyansk-na-Kubani",
                        "latitude": "45.25580000",
                        "longitude": "38.12560000"
                    },
                    {
                        "id": 101406,
                        "name": "Slavyansky rayon",
                        "latitude": "45.41667000",
                        "longitude": "37.75000000"
                    },
                    {
                        "id": 101416,
                        "name": "Smolenskaya",
                        "latitude": "44.78636000",
                        "longitude": "38.80333000"
                    },
                    {
                        "id": 101429,
                        "name": "Sochi",
                        "latitude": "43.59917000",
                        "longitude": "39.72569000"
                    },
                    {
                        "id": 101439,
                        "name": "Sokolovskoye",
                        "latitude": "45.25833000",
                        "longitude": "40.67972000"
                    },
                    {
                        "id": 101506,
                        "name": "Sovetskaya",
                        "latitude": "44.77694000",
                        "longitude": "41.17222000"
                    },
                    {
                        "id": 101519,
                        "name": "Sovkhoznyy",
                        "latitude": "45.29462000",
                        "longitude": "38.11384000"
                    },
                    {
                        "id": 101540,
                        "name": "Spokoynaya",
                        "latitude": "44.24680000",
                        "longitude": "41.40150000"
                    },
                    {
                        "id": 101564,
                        "name": "Staraya Stanitsa",
                        "latitude": "45.00980000",
                        "longitude": "41.15120000"
                    },
                    {
                        "id": 101576,
                        "name": "Staroderevyankovskaya",
                        "latitude": "46.12760000",
                        "longitude": "38.96740000"
                    },
                    {
                        "id": 101580,
                        "name": "Starodzhereliyevskaya",
                        "latitude": "45.47599000",
                        "longitude": "38.29680000"
                    },
                    {
                        "id": 101582,
                        "name": "Starokorsunskaya",
                        "latitude": "45.05727000",
                        "longitude": "39.31611000"
                    },
                    {
                        "id": 101585,
                        "name": "Staroleushkovskaya",
                        "latitude": "45.98666000",
                        "longitude": "39.75987000"
                    },
                    {
                        "id": 101586,
                        "name": "Starominskaya",
                        "latitude": "46.53000000",
                        "longitude": "39.04972000"
                    },
                    {
                        "id": 101587,
                        "name": "Staromyshastovskaya",
                        "latitude": "45.34329000",
                        "longitude": "39.07608000"
                    },
                    {
                        "id": 101588,
                        "name": "Staronizhestebliyevskaya",
                        "latitude": "45.38315000",
                        "longitude": "38.44304000"
                    },
                    {
                        "id": 101594,
                        "name": "Staroshcherbinovskaya",
                        "latitude": "46.63110000",
                        "longitude": "38.67420000"
                    },
                    {
                        "id": 101597,
                        "name": "Starotitarovskaya",
                        "latitude": "45.21938000",
                        "longitude": "37.15476000"
                    },
                    {
                        "id": 101599,
                        "name": "Starovelichkovskaya",
                        "latitude": "45.42884000",
                        "longitude": "38.73261000"
                    },
                    {
                        "id": 101626,
                        "name": "Strelka",
                        "latitude": "45.20633000",
                        "longitude": "37.28650000"
                    },
                    {
                        "id": 101655,
                        "name": "Sukko",
                        "latitude": "44.79945000",
                        "longitude": "37.42145000"
                    },
                    {
                        "id": 101760,
                        "name": "Taman’",
                        "latitude": "45.21170000",
                        "longitude": "36.71609000"
                    },
                    {
                        "id": 101808,
                        "name": "Tbilisskaya",
                        "latitude": "45.36333000",
                        "longitude": "40.19000000"
                    },
                    {
                        "id": 101814,
                        "name": "Temirgoyevskaya",
                        "latitude": "45.11414000",
                        "longitude": "40.28027000"
                    },
                    {
                        "id": 101816,
                        "name": "Temizhbekskaya",
                        "latitude": "45.44556000",
                        "longitude": "40.84500000"
                    },
                    {
                        "id": 101820,
                        "name": "Temruksky rayon",
                        "latitude": "45.25000000",
                        "longitude": "37.25000000"
                    },
                    {
                        "id": 101821,
                        "name": "Temryuk",
                        "latitude": "45.27055000",
                        "longitude": "37.38716000"
                    },
                    {
                        "id": 101832,
                        "name": "Ternevskaya",
                        "latitude": "45.85130000",
                        "longitude": "40.41250000"
                    },
                    {
                        "id": 101851,
                        "name": "Tikhoretsk",
                        "latitude": "45.85472000",
                        "longitude": "40.12528000"
                    },
                    {
                        "id": 101852,
                        "name": "Tikhoretskiy Rayon",
                        "latitude": "45.73846000",
                        "longitude": "40.27549000"
                    },
                    {
                        "id": 101858,
                        "name": "Timashëvsk",
                        "latitude": "45.61694000",
                        "longitude": "38.94528000"
                    },
                    {
                        "id": 101915,
                        "name": "Troitskaya",
                        "latitude": "45.13493000",
                        "longitude": "38.12544000"
                    },
                    {
                        "id": 101932,
                        "name": "Trudobelikovskiy",
                        "latitude": "45.26853000",
                        "longitude": "38.15376000"
                    },
                    {
                        "id": 101946,
                        "name": "Tsibanobalka",
                        "latitude": "44.98034000",
                        "longitude": "37.34384000"
                    },
                    {
                        "id": 101957,
                        "name": "Tuapse",
                        "latitude": "44.10530000",
                        "longitude": "39.08020000"
                    },
                    {
                        "id": 101958,
                        "name": "Tuapsinskiy Rayon",
                        "latitude": "44.25000000",
                        "longitude": "39.08333000"
                    },
                    {
                        "id": 102023,
                        "name": "Udobnaya",
                        "latitude": "44.19320000",
                        "longitude": "41.55290000"
                    },
                    {
                        "id": 102065,
                        "name": "Upornaya",
                        "latitude": "44.39140000",
                        "longitude": "41.01960000"
                    },
                    {
                        "id": 102103,
                        "name": "Uspenskaya",
                        "latitude": "45.76448000",
                        "longitude": "41.06696000"
                    },
                    {
                        "id": 102104,
                        "name": "Uspenskoye",
                        "latitude": "44.83110000",
                        "longitude": "41.39270000"
                    },
                    {
                        "id": 102135,
                        "name": "Ust’-Labinsk",
                        "latitude": "45.21077000",
                        "longitude": "39.68914000"
                    },
                    {
                        "id": 102187,
                        "name": "Vardane",
                        "latitude": "43.73179000",
                        "longitude": "39.55428000"
                    },
                    {
                        "id": 102188,
                        "name": "Varenikovskaya",
                        "latitude": "45.12085000",
                        "longitude": "37.64171000"
                    },
                    {
                        "id": 102202,
                        "name": "Vasyurinskaya",
                        "latitude": "45.11809000",
                        "longitude": "39.42399000"
                    },
                    {
                        "id": 102219,
                        "name": "Velikovechnoye",
                        "latitude": "44.93402000",
                        "longitude": "39.75499000"
                    },
                    {
                        "id": 102225,
                        "name": "Ventsy",
                        "latitude": "45.37639000",
                        "longitude": "40.83583000"
                    },
                    {
                        "id": 102236,
                        "name": "Verkhnebakanskiy",
                        "latitude": "44.84917000",
                        "longitude": "37.65722000"
                    },
                    {
                        "id": 102313,
                        "name": "Vinogradnyy",
                        "latitude": "45.05610000",
                        "longitude": "37.32125000"
                    },
                    {
                        "id": 102322,
                        "name": "Vityazevo",
                        "latitude": "45.00130000",
                        "longitude": "37.28211000"
                    },
                    {
                        "id": 102328,
                        "name": "Vladimirskaya",
                        "latitude": "44.54550000",
                        "longitude": "40.79330000"
                    },
                    {
                        "id": 102382,
                        "name": "Vorontsovka",
                        "latitude": "46.65290000",
                        "longitude": "38.07870000"
                    },
                    {
                        "id": 102408,
                        "name": "Voznesenskaya",
                        "latitude": "44.55270000",
                        "longitude": "41.03180000"
                    },
                    {
                        "id": 102436,
                        "name": "Vyselki",
                        "latitude": "45.58128000",
                        "longitude": "39.66409000"
                    },
                    {
                        "id": 102437,
                        "name": "Vyselkovskiy Rayon",
                        "latitude": "45.66667000",
                        "longitude": "39.75000000"
                    },
                    {
                        "id": 102439,
                        "name": "Vyshestebliyevskaya",
                        "latitude": "45.19611000",
                        "longitude": "37.01806000"
                    },
                    {
                        "id": 102450,
                        "name": "Vysokoye",
                        "latitude": "43.46304000",
                        "longitude": "39.96701000"
                    },
                    {
                        "id": 102500,
                        "name": "Yaroslavskaya",
                        "latitude": "44.61056000",
                        "longitude": "40.46417000"
                    },
                    {
                        "id": 102507,
                        "name": "Yasenskaya",
                        "latitude": "46.35920000",
                        "longitude": "38.26900000"
                    },
                    {
                        "id": 102542,
                        "name": "Yelizavetinskaya",
                        "latitude": "45.04616000",
                        "longitude": "38.79491000"
                    },
                    {
                        "id": 102579,
                        "name": "Yeysk",
                        "latitude": "46.70550000",
                        "longitude": "38.27390000"
                    },
                    {
                        "id": 102580,
                        "name": "Yeyskoye Ukrepleniye",
                        "latitude": "46.70630000",
                        "longitude": "38.61210000"
                    },
                    {
                        "id": 102600,
                        "name": "Yurovka",
                        "latitude": "45.11470000",
                        "longitude": "37.41882000"
                    },
                    {
                        "id": 102620,
                        "name": "Yuzhnyy",
                        "latitude": "45.00250000",
                        "longitude": "40.47472000"
                    },
                    {
                        "id": 102670,
                        "name": "Zavetnyy",
                        "latitude": "44.93160000",
                        "longitude": "41.13730000"
                    }
                ]
            },
            {
                "id": 1840,
                "name": "Krasnoyarsk",
                "iso2": "KYA",
                "latitude": "64.24797580",
                "longitude": "95.11041760",
                "type": "administrative territory",
                "cities": [
                    {
                        "id": 97481,
                        "name": "Aban",
                        "latitude": "56.67870000",
                        "longitude": "96.06580000"
                    },
                    {
                        "id": 97482,
                        "name": "Abanskiy Rayon",
                        "latitude": "56.83333000",
                        "longitude": "96.00000000"
                    },
                    {
                        "id": 97495,
                        "name": "Achinsk",
                        "latitude": "56.26940000",
                        "longitude": "90.49930000"
                    },
                    {
                        "id": 97496,
                        "name": "Achinskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "90.50000000"
                    },
                    {
                        "id": 97517,
                        "name": "Aginskoye",
                        "latitude": "55.25860000",
                        "longitude": "94.90790000"
                    },
                    {
                        "id": 97768,
                        "name": "Balakhta",
                        "latitude": "55.38425000",
                        "longitude": "91.61872000"
                    },
                    {
                        "id": 97769,
                        "name": "Balakhtinskiy Rayon",
                        "latitude": "55.50000000",
                        "longitude": "91.50000000"
                    },
                    {
                        "id": 97825,
                        "name": "Baykit",
                        "latitude": "61.67694000",
                        "longitude": "96.37917000"
                    },
                    {
                        "id": 97904,
                        "name": "Berëzovka",
                        "latitude": "56.03044000",
                        "longitude": "93.11164000"
                    },
                    {
                        "id": 97896,
                        "name": "Berezovskiy rayon",
                        "latitude": "56.03446000",
                        "longitude": "93.13866000"
                    },
                    {
                        "id": 97934,
                        "name": "Birilyusskiy Rayon",
                        "latitude": "57.25000000",
                        "longitude": "90.75000000"
                    },
                    {
                        "id": 97976,
                        "name": "Bogotol",
                        "latitude": "56.20778000",
                        "longitude": "89.53417000"
                    },
                    {
                        "id": 97977,
                        "name": "Bogotol’skiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "89.75000000"
                    },
                    {
                        "id": 97981,
                        "name": "Boguchanskiy Rayon",
                        "latitude": "58.50000000",
                        "longitude": "97.50000000"
                    },
                    {
                        "id": 97982,
                        "name": "Boguchany",
                        "latitude": "58.38139000",
                        "longitude": "97.45306000"
                    },
                    {
                        "id": 98004,
                        "name": "Bol’shemurtinskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "93.00000000"
                    },
                    {
                        "id": 98007,
                        "name": "Bol’sheuluyskiy Rayon",
                        "latitude": "56.66667000",
                        "longitude": "90.75000000"
                    },
                    {
                        "id": 98020,
                        "name": "Bor",
                        "latitude": "61.60111000",
                        "longitude": "90.01806000"
                    },
                    {
                        "id": 98030,
                        "name": "Borodino",
                        "latitude": "55.90610000",
                        "longitude": "94.90790000"
                    },
                    {
                        "id": 98222,
                        "name": "Chunoyar",
                        "latitude": "57.44830000",
                        "longitude": "97.32860000"
                    },
                    {
                        "id": 98275,
                        "name": "Dikson",
                        "latitude": "73.50819000",
                        "longitude": "80.52918000"
                    },
                    {
                        "id": 98279,
                        "name": "Divnogorsk",
                        "latitude": "55.95810000",
                        "longitude": "92.37260000"
                    },
                    {
                        "id": 98334,
                        "name": "Dubinino",
                        "latitude": "55.61917000",
                        "longitude": "89.09111000"
                    },
                    {
                        "id": 98347,
                        "name": "Dudinka",
                        "latitude": "69.40583000",
                        "longitude": "86.17778000"
                    },
                    {
                        "id": 98370,
                        "name": "Dzerzhinskoye",
                        "latitude": "56.83444000",
                        "longitude": "95.22833000"
                    },
                    {
                        "id": 98407,
                        "name": "Evenkiyskiy District",
                        "latitude": "65.00000000",
                        "longitude": "98.00000000"
                    },
                    {
                        "id": 98426,
                        "name": "Filimonovo",
                        "latitude": "56.20111000",
                        "longitude": "95.46111000"
                    },
                    {
                        "id": 98628,
                        "name": "Idrinskiy Rayon",
                        "latitude": "54.50000000",
                        "longitude": "92.50000000"
                    },
                    {
                        "id": 98629,
                        "name": "Idrinskoye",
                        "latitude": "54.37083000",
                        "longitude": "92.13583000"
                    },
                    {
                        "id": 98631,
                        "name": "Igarka",
                        "latitude": "67.46550000",
                        "longitude": "86.60270000"
                    },
                    {
                        "id": 98650,
                        "name": "Il’ichevo",
                        "latitude": "53.27889000",
                        "longitude": "91.84028000"
                    },
                    {
                        "id": 98642,
                        "name": "Ilanskiy",
                        "latitude": "56.23250000",
                        "longitude": "96.06520000"
                    },
                    {
                        "id": 98643,
                        "name": "Ilanskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "96.08333000"
                    },
                    {
                        "id": 98687,
                        "name": "Irbeyskiy Rayon",
                        "latitude": "55.41667000",
                        "longitude": "96.00000000"
                    },
                    {
                        "id": 98688,
                        "name": "Irbeyskoye",
                        "latitude": "55.63960000",
                        "longitude": "95.45150000"
                    },
                    {
                        "id": 98693,
                        "name": "Irsha",
                        "latitude": "55.92730000",
                        "longitude": "94.79990000"
                    },
                    {
                        "id": 98844,
                        "name": "Kansk",
                        "latitude": "56.20167000",
                        "longitude": "95.71750000"
                    },
                    {
                        "id": 98845,
                        "name": "Kanskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "95.25000000"
                    },
                    {
                        "id": 98871,
                        "name": "Karatuzskoye",
                        "latitude": "53.60722000",
                        "longitude": "92.86667000"
                    },
                    {
                        "id": 98920,
                        "name": "Kayyerkan",
                        "latitude": "69.37861000",
                        "longitude": "87.74389000"
                    },
                    {
                        "id": 98922,
                        "name": "Kazachinskiy Rayon",
                        "latitude": "57.66667000",
                        "longitude": "93.41667000"
                    },
                    {
                        "id": 98923,
                        "name": "Kazachinskoye",
                        "latitude": "57.70040000",
                        "longitude": "93.28090000"
                    },
                    {
                        "id": 98936,
                        "name": "Kedrovyy",
                        "latitude": "56.28232000",
                        "longitude": "91.53760000"
                    },
                    {
                        "id": 98972,
                        "name": "Khatanga",
                        "latitude": "71.98002000",
                        "longitude": "102.47111000"
                    },
                    {
                        "id": 99127,
                        "name": "Kodinsk",
                        "latitude": "58.60629000",
                        "longitude": "99.17398000"
                    },
                    {
                        "id": 99230,
                        "name": "Koshurnikovo",
                        "latitude": "54.16667000",
                        "longitude": "93.30000000"
                    },
                    {
                        "id": 99321,
                        "name": "Krasnokamensk",
                        "latitude": "54.33389000",
                        "longitude": "93.25944000"
                    },
                    {
                        "id": 99336,
                        "name": "Krasnoturansk",
                        "latitude": "54.31861000",
                        "longitude": "91.56389000"
                    },
                    {
                        "id": 99343,
                        "name": "Krasnoyarsk",
                        "latitude": "56.01839000",
                        "longitude": "92.86717000"
                    },
                    {
                        "id": 99452,
                        "name": "Kuragino",
                        "latitude": "53.88785000",
                        "longitude": "92.68152000"
                    },
                    {
                        "id": 99604,
                        "name": "Lesosibirsk",
                        "latitude": "58.23583000",
                        "longitude": "92.48278000"
                    },
                    {
                        "id": 99783,
                        "name": "Manskiy Rayon",
                        "latitude": "55.41667000",
                        "longitude": "93.66667000"
                    },
                    {
                        "id": 99788,
                        "name": "Manzya",
                        "latitude": "58.49222000",
                        "longitude": "96.26167000"
                    },
                    {
                        "id": 99918,
                        "name": "Minusinsk",
                        "latitude": "53.71028000",
                        "longitude": "91.68750000"
                    },
                    {
                        "id": 99919,
                        "name": "Minusinskiy Rayon",
                        "latitude": "53.75000000",
                        "longitude": "92.00000000"
                    },
                    {
                        "id": 99983,
                        "name": "Motygino",
                        "latitude": "58.18401000",
                        "longitude": "94.69339000"
                    },
                    {
                        "id": 100075,
                        "name": "Nazarovo",
                        "latitude": "56.01040000",
                        "longitude": "90.40110000"
                    },
                    {
                        "id": 100076,
                        "name": "Nazarovskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "90.62500000"
                    },
                    {
                        "id": 100153,
                        "name": "Nizhneingashskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "97.00000000"
                    },
                    {
                        "id": 100167,
                        "name": "Nizhniy Ingash",
                        "latitude": "56.20030000",
                        "longitude": "96.53730000"
                    },
                    {
                        "id": 100185,
                        "name": "Nizhnyaya Poyma",
                        "latitude": "56.16430000",
                        "longitude": "97.20650000"
                    },
                    {
                        "id": 100198,
                        "name": "Norilsk",
                        "latitude": "69.35350000",
                        "longitude": "88.20270000"
                    },
                    {
                        "id": 100230,
                        "name": "Novobirilyussy",
                        "latitude": "56.95260000",
                        "longitude": "90.68070000"
                    },
                    {
                        "id": 100236,
                        "name": "Novochernorechenskiy",
                        "latitude": "56.26658000",
                        "longitude": "91.09234000"
                    },
                    {
                        "id": 100513,
                        "name": "Ovsyanka",
                        "latitude": "55.95830000",
                        "longitude": "92.57200000"
                    },
                    {
                        "id": 100556,
                        "name": "Partizanskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "94.16667000"
                    },
                    {
                        "id": 100557,
                        "name": "Partizanskoye",
                        "latitude": "55.49720000",
                        "longitude": "94.39220000"
                    },
                    {
                        "id": 100684,
                        "name": "Pirovskoye",
                        "latitude": "57.63012000",
                        "longitude": "92.26373000"
                    },
                    {
                        "id": 100808,
                        "name": "Predivinsk",
                        "latitude": "57.06310000",
                        "longitude": "93.43740000"
                    },
                    {
                        "id": 100945,
                        "name": "Rassvet",
                        "latitude": "56.99900000",
                        "longitude": "91.47240000"
                    },
                    {
                        "id": 100949,
                        "name": "Razdolinsk",
                        "latitude": "58.42111000",
                        "longitude": "94.66583000"
                    },
                    {
                        "id": 101140,
                        "name": "Sayansk",
                        "latitude": "54.15000000",
                        "longitude": "91.88500000"
                    },
                    {
                        "id": 101141,
                        "name": "Sayanskiy Rayon",
                        "latitude": "54.75000000",
                        "longitude": "95.00000000"
                    },
                    {
                        "id": 101213,
                        "name": "Severo-Yeniseyskiy",
                        "latitude": "60.37552000",
                        "longitude": "93.03017000"
                    },
                    {
                        "id": 101214,
                        "name": "Severo-Yeniseyskiy Rayon",
                        "latitude": "60.00000000",
                        "longitude": "93.25000000"
                    },
                    {
                        "id": 101247,
                        "name": "Shalinskoye",
                        "latitude": "55.71940000",
                        "longitude": "93.75890000"
                    },
                    {
                        "id": 101263,
                        "name": "Sharypovo",
                        "latitude": "55.54028000",
                        "longitude": "89.20083000"
                    },
                    {
                        "id": 101264,
                        "name": "Sharypovskiy Rayon",
                        "latitude": "55.50000000",
                        "longitude": "89.25000000"
                    },
                    {
                        "id": 101356,
                        "name": "Shushenskiy Rayon",
                        "latitude": "53.41667000",
                        "longitude": "91.50000000"
                    },
                    {
                        "id": 101357,
                        "name": "Shushenskoye",
                        "latitude": "53.32500000",
                        "longitude": "91.93556000"
                    },
                    {
                        "id": 101425,
                        "name": "Snezhnogorsk",
                        "latitude": "68.09306000",
                        "longitude": "87.74000000"
                    },
                    {
                        "id": 101457,
                        "name": "Solnechnyy",
                        "latitude": "56.11583000",
                        "longitude": "92.92528000"
                    },
                    {
                        "id": 101494,
                        "name": "Sosnovoborsk",
                        "latitude": "56.12170000",
                        "longitude": "93.33850000"
                    },
                    {
                        "id": 101627,
                        "name": "Strelka",
                        "latitude": "58.07278000",
                        "longitude": "93.03444000"
                    },
                    {
                        "id": 101652,
                        "name": "Sukhobuzimskoye",
                        "latitude": "56.50000000",
                        "longitude": "93.27278000"
                    },
                    {
                        "id": 101702,
                        "name": "Svetlogorsk",
                        "latitude": "66.93762000",
                        "longitude": "88.35265000"
                    },
                    {
                        "id": 101754,
                        "name": "Talnakh",
                        "latitude": "69.48650000",
                        "longitude": "88.39720000"
                    },
                    {
                        "id": 101767,
                        "name": "Tanzybey",
                        "latitude": "53.13265000",
                        "longitude": "92.94335000"
                    },
                    {
                        "id": 101784,
                        "name": "Taseyevo",
                        "latitude": "57.21457000",
                        "longitude": "94.89393000"
                    },
                    {
                        "id": 101804,
                        "name": "Taymyrsky Dolgano-Nenetsky District",
                        "latitude": "72.00000000",
                        "longitude": "95.00000000"
                    },
                    {
                        "id": 101846,
                        "name": "Teya",
                        "latitude": "60.37202000",
                        "longitude": "92.62956000"
                    },
                    {
                        "id": 101861,
                        "name": "Tinskoy",
                        "latitude": "56.15130000",
                        "longitude": "96.91730000"
                    },
                    {
                        "id": 101972,
                        "name": "Tura",
                        "latitude": "64.27769000",
                        "longitude": "100.21849000"
                    },
                    {
                        "id": 101982,
                        "name": "Turukhansk",
                        "latitude": "65.79479000",
                        "longitude": "87.95006000"
                    },
                    {
                        "id": 102001,
                        "name": "Tyukhtet",
                        "latitude": "56.53939000",
                        "longitude": "89.31221000"
                    },
                    {
                        "id": 102069,
                        "name": "Ural",
                        "latitude": "55.90520000",
                        "longitude": "94.75370000"
                    },
                    {
                        "id": 102160,
                        "name": "Uyar",
                        "latitude": "55.81180000",
                        "longitude": "94.32470000"
                    },
                    {
                        "id": 102161,
                        "name": "Uyarskiy Rayon",
                        "latitude": "55.83333000",
                        "longitude": "94.25000000"
                    },
                    {
                        "id": 102165,
                        "name": "Uzhur",
                        "latitude": "55.31246000",
                        "longitude": "89.83301000"
                    },
                    {
                        "id": 102185,
                        "name": "Vanavara",
                        "latitude": "60.34679000",
                        "longitude": "102.28434000"
                    },
                    {
                        "id": 102555,
                        "name": "Yemel’yanovo",
                        "latitude": "56.16776000",
                        "longitude": "92.67539000"
                    },
                    {
                        "id": 102556,
                        "name": "Yemel’yanovskiy Rayon",
                        "latitude": "56.41667000",
                        "longitude": "92.75000000"
                    },
                    {
                        "id": 102560,
                        "name": "Yeniseysk",
                        "latitude": "58.44937000",
                        "longitude": "92.17968000"
                    },
                    {
                        "id": 102561,
                        "name": "Yeniseyskiy Rayon",
                        "latitude": "60.00000000",
                        "longitude": "89.00000000"
                    },
                    {
                        "id": 102564,
                        "name": "Yermakovskoye",
                        "latitude": "53.27545000",
                        "longitude": "92.40021000"
                    },
                    {
                        "id": 102696,
                        "name": "Zelenogorsk",
                        "latitude": "56.11240000",
                        "longitude": "94.59850000"
                    },
                    {
                        "id": 102703,
                        "name": "Zelënyy Bor",
                        "latitude": "53.62178000",
                        "longitude": "91.61528000"
                    },
                    {
                        "id": 102721,
                        "name": "Zheleznogorsk",
                        "latitude": "56.25111000",
                        "longitude": "93.53194000"
                    },
                    {
                        "id": 102786,
                        "name": "Zykovo",
                        "latitude": "55.95503000",
                        "longitude": "93.16093000"
                    }
                ]
            },
            {
                "id": 1915,
                "name": "Kurgan",
                "iso2": "KGN",
                "latitude": "55.44815480",
                "longitude": "65.11809750",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97875,
                        "name": "Belozërskoye",
                        "latitude": "55.82139000",
                        "longitude": "65.58417000"
                    },
                    {
                        "id": 98236,
                        "name": "Dalmatovo",
                        "latitude": "56.26000000",
                        "longitude": "62.93620000"
                    },
                    {
                        "id": 98504,
                        "name": "Glyadyanskoye",
                        "latitude": "54.90750000",
                        "longitude": "65.08833000"
                    },
                    {
                        "id": 98639,
                        "name": "Ikovka",
                        "latitude": "55.60889000",
                        "longitude": "64.93750000"
                    },
                    {
                        "id": 98908,
                        "name": "Kataysk",
                        "latitude": "56.28900000",
                        "longitude": "62.58410000"
                    },
                    {
                        "id": 98945,
                        "name": "Ketovo",
                        "latitude": "55.35500000",
                        "longitude": "65.32583000"
                    },
                    {
                        "id": 99371,
                        "name": "Krasnyy Oktyabr’",
                        "latitude": "55.65667000",
                        "longitude": "64.81333000"
                    },
                    {
                        "id": 99459,
                        "name": "Kurgan",
                        "latitude": "55.45000000",
                        "longitude": "65.33333000"
                    },
                    {
                        "id": 99477,
                        "name": "Kurtamysh",
                        "latitude": "54.91028000",
                        "longitude": "64.43194000"
                    },
                    {
                        "id": 99557,
                        "name": "Lebyazh’ye",
                        "latitude": "55.26889000",
                        "longitude": "66.49472000"
                    },
                    {
                        "id": 99558,
                        "name": "Lebyazh’yevskiy Rayon",
                        "latitude": "55.33333000",
                        "longitude": "66.50000000"
                    },
                    {
                        "id": 99592,
                        "name": "Lesnikovo",
                        "latitude": "55.28222000",
                        "longitude": "65.31750000"
                    },
                    {
                        "id": 99748,
                        "name": "Makushino",
                        "latitude": "55.21028000",
                        "longitude": "67.24417000"
                    },
                    {
                        "id": 99929,
                        "name": "Mishkino",
                        "latitude": "55.33889000",
                        "longitude": "63.91750000"
                    },
                    {
                        "id": 99944,
                        "name": "Mokrousovo",
                        "latitude": "55.81028000",
                        "longitude": "66.76528000"
                    },
                    {
                        "id": 99945,
                        "name": "Mokrousovskiy Rayon",
                        "latitude": "55.75000000",
                        "longitude": "67.00000000"
                    },
                    {
                        "id": 100666,
                        "name": "Petukhovo",
                        "latitude": "55.06917000",
                        "longitude": "67.90194000"
                    },
                    {
                        "id": 100758,
                        "name": "Polovinnoye",
                        "latitude": "54.79139000",
                        "longitude": "65.98639000"
                    },
                    {
                        "id": 100870,
                        "name": "Prosvet",
                        "latitude": "55.57028000",
                        "longitude": "65.08250000"
                    },
                    {
                        "id": 101067,
                        "name": "Safakulevo",
                        "latitude": "54.99010000",
                        "longitude": "62.54420000"
                    },
                    {
                        "id": 101068,
                        "name": "Safakulevskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "62.50000000"
                    },
                    {
                        "id": 101233,
                        "name": "Shadrinsk",
                        "latitude": "56.08520000",
                        "longitude": "63.63350000"
                    },
                    {
                        "id": 101270,
                        "name": "Shatrovo",
                        "latitude": "56.51970000",
                        "longitude": "64.63200000"
                    },
                    {
                        "id": 101349,
                        "name": "Shumikha",
                        "latitude": "55.22611000",
                        "longitude": "63.29611000"
                    },
                    {
                        "id": 101351,
                        "name": "Shumikhinskiy Rayon",
                        "latitude": "55.25000000",
                        "longitude": "63.25000000"
                    },
                    {
                        "id": 101939,
                        "name": "Tselinnoye",
                        "latitude": "54.50111000",
                        "longitude": "63.67361000"
                    },
                    {
                        "id": 102189,
                        "name": "Vargashi",
                        "latitude": "55.35556000",
                        "longitude": "65.84667000"
                    },
                    {
                        "id": 102190,
                        "name": "Vargashinskiy Rayon",
                        "latitude": "55.33333000",
                        "longitude": "65.91667000"
                    },
                    {
                        "id": 102418,
                        "name": "Vvedenskoye",
                        "latitude": "55.47426000",
                        "longitude": "65.08449000"
                    },
                    {
                        "id": 102594,
                        "name": "Yurgamysh",
                        "latitude": "55.37454000",
                        "longitude": "64.46222000"
                    },
                    {
                        "id": 102782,
                        "name": "Zverinogolovskoye",
                        "latitude": "54.45397000",
                        "longitude": "64.85242000"
                    }
                ]
            },
            {
                "id": 1855,
                "name": "Kursk",
                "iso2": "KRS",
                "latitude": "51.76340260",
                "longitude": "35.38118120",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97839,
                        "name": "Belaya",
                        "latitude": "51.05444000",
                        "longitude": "35.71611000"
                    },
                    {
                        "id": 98147,
                        "name": "Cheremisinovo",
                        "latitude": "51.88550000",
                        "longitude": "37.26460000"
                    },
                    {
                        "id": 98148,
                        "name": "Cheremisinovskiy Rayon",
                        "latitude": "51.91667000",
                        "longitude": "37.16667000"
                    },
                    {
                        "id": 98168,
                        "name": "Chernitsyno",
                        "latitude": "51.50739000",
                        "longitude": "36.05101000"
                    },
                    {
                        "id": 98415,
                        "name": "Fatezh",
                        "latitude": "52.08910000",
                        "longitude": "35.86320000"
                    },
                    {
                        "id": 98416,
                        "name": "Fatezhskiy Rayon",
                        "latitude": "52.00000000",
                        "longitude": "35.75000000"
                    },
                    {
                        "id": 98503,
                        "name": "Glushkovo",
                        "latitude": "51.33917000",
                        "longitude": "34.63278000"
                    },
                    {
                        "id": 98565,
                        "name": "Gorshechenskiy Rayon",
                        "latitude": "51.50000000",
                        "longitude": "38.00000000"
                    },
                    {
                        "id": 98566,
                        "name": "Gorshechnoye",
                        "latitude": "51.52440000",
                        "longitude": "38.03650000"
                    },
                    {
                        "id": 98727,
                        "name": "Ivanino",
                        "latitude": "51.64340000",
                        "longitude": "35.57690000"
                    },
                    {
                        "id": 98903,
                        "name": "Kastorenskiy Rayon",
                        "latitude": "51.75000000",
                        "longitude": "38.16667000"
                    },
                    {
                        "id": 98904,
                        "name": "Kastornoye",
                        "latitude": "51.83340000",
                        "longitude": "38.13020000"
                    },
                    {
                        "id": 99001,
                        "name": "Khomutovka",
                        "latitude": "51.92070000",
                        "longitude": "34.56190000"
                    },
                    {
                        "id": 99068,
                        "name": "Kirovskiy",
                        "latitude": "51.41667000",
                        "longitude": "36.66667000"
                    },
                    {
                        "id": 99196,
                        "name": "Konyshevka",
                        "latitude": "51.84180000",
                        "longitude": "35.29410000"
                    },
                    {
                        "id": 99204,
                        "name": "Korenëvo",
                        "latitude": "51.41190000",
                        "longitude": "34.90800000"
                    },
                    {
                        "id": 99410,
                        "name": "Kshenskiy",
                        "latitude": "51.84083000",
                        "longitude": "37.71361000"
                    },
                    {
                        "id": 99457,
                        "name": "Kurchatov",
                        "latitude": "51.66010000",
                        "longitude": "35.65210000"
                    },
                    {
                        "id": 99474,
                        "name": "Kursk",
                        "latitude": "51.73733000",
                        "longitude": "36.18735000"
                    },
                    {
                        "id": 99476,
                        "name": "Kurskiy Rayon",
                        "latitude": "51.75000000",
                        "longitude": "36.16667000"
                    },
                    {
                        "id": 99726,
                        "name": "L’govskiy",
                        "latitude": "51.63069000",
                        "longitude": "35.27750000"
                    },
                    {
                        "id": 99727,
                        "name": "L’govskiy Rayon",
                        "latitude": "51.58333000",
                        "longitude": "35.25000000"
                    },
                    {
                        "id": 99784,
                        "name": "Manturovo",
                        "latitude": "51.45470000",
                        "longitude": "37.12820000"
                    },
                    {
                        "id": 99846,
                        "name": "Medvenskiy Rayon",
                        "latitude": "51.41667000",
                        "longitude": "36.11667000"
                    },
                    {
                        "id": 99896,
                        "name": "Mikhaylovka",
                        "latitude": "52.23170000",
                        "longitude": "35.37670000"
                    },
                    {
                        "id": 100389,
                        "name": "Oboyan’",
                        "latitude": "51.20981000",
                        "longitude": "36.27919000"
                    },
                    {
                        "id": 100388,
                        "name": "Oboyanskiy Rayon",
                        "latitude": "51.25000000",
                        "longitude": "36.16667000"
                    },
                    {
                        "id": 100427,
                        "name": "Olym",
                        "latitude": "51.67980000",
                        "longitude": "38.17580000"
                    },
                    {
                        "id": 100613,
                        "name": "Pervoavgustovskiy",
                        "latitude": "52.22640000",
                        "longitude": "35.05520000"
                    },
                    {
                        "id": 100770,
                        "name": "Ponyri Vtoryye",
                        "latitude": "52.27994000",
                        "longitude": "36.22461000"
                    },
                    {
                        "id": 100841,
                        "name": "Pristen’",
                        "latitude": "51.23551000",
                        "longitude": "36.69594000"
                    },
                    {
                        "id": 100840,
                        "name": "Pristenskiy Rayon",
                        "latitude": "51.25000000",
                        "longitude": "36.75000000"
                    },
                    {
                        "id": 100875,
                        "name": "Pryamitsyno",
                        "latitude": "51.65610000",
                        "longitude": "35.93140000"
                    },
                    {
                        "id": 101055,
                        "name": "Ryl’sk",
                        "latitude": "51.56550000",
                        "longitude": "34.68220000"
                    },
                    {
                        "id": 101278,
                        "name": "Shchigry",
                        "latitude": "51.87555000",
                        "longitude": "36.90432000"
                    },
                    {
                        "id": 101461,
                        "name": "Solntsevo",
                        "latitude": "51.41853000",
                        "longitude": "36.74990000"
                    },
                    {
                        "id": 101462,
                        "name": "Solntsevskiy Rayon",
                        "latitude": "51.50000000",
                        "longitude": "36.75000000"
                    },
                    {
                        "id": 101515,
                        "name": "Sovetskiy Rayon",
                        "latitude": "51.83333000",
                        "longitude": "37.58333000"
                    },
                    {
                        "id": 101647,
                        "name": "Sudzha",
                        "latitude": "51.19760000",
                        "longitude": "35.27260000"
                    },
                    {
                        "id": 101857,
                        "name": "Tim",
                        "latitude": "51.62222000",
                        "longitude": "37.12444000"
                    },
                    {
                        "id": 102383,
                        "name": "Voroshnëvo",
                        "latitude": "51.65278000",
                        "longitude": "36.01722000"
                    },
                    {
                        "id": 102720,
                        "name": "Zheleznogorsk",
                        "latitude": "52.33100000",
                        "longitude": "35.37110000"
                    },
                    {
                        "id": 102765,
                        "name": "Zolotukhino",
                        "latitude": "52.08420000",
                        "longitude": "36.37777000"
                    },
                    {
                        "id": 102766,
                        "name": "Zolotukhinskiy Rayon",
                        "latitude": "52.08333000",
                        "longitude": "36.50000000"
                    }
                ]
            },
            {
                "id": 1896,
                "name": "Leningrad",
                "iso2": "LEN",
                "latitude": "60.07932080",
                "longitude": "31.89266450",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97512,
                        "name": "Agalatovo",
                        "latitude": "60.21950000",
                        "longitude": "30.27388000"
                    },
                    {
                        "id": 97528,
                        "name": "Akademicheskoe",
                        "latitude": "60.01375000",
                        "longitude": "30.39471000"
                    },
                    {
                        "id": 97635,
                        "name": "Annino",
                        "latitude": "59.77056000",
                        "longitude": "30.05611000"
                    },
                    {
                        "id": 97835,
                        "name": "Begunitsy",
                        "latitude": "59.58552000",
                        "longitude": "29.31757000"
                    },
                    {
                        "id": 97986,
                        "name": "Boksitogorsk",
                        "latitude": "59.47405000",
                        "longitude": "33.84853000"
                    },
                    {
                        "id": 97987,
                        "name": "Boksitogorskiy Rayon",
                        "latitude": "59.50000000",
                        "longitude": "34.00000000"
                    },
                    {
                        "id": 97999,
                        "name": "Bol’shaya Izhora",
                        "latitude": "59.93796000",
                        "longitude": "29.57721000"
                    },
                    {
                        "id": 98027,
                        "name": "Borisova Griva",
                        "latitude": "60.08936000",
                        "longitude": "30.97727000"
                    },
                    {
                        "id": 98064,
                        "name": "Budogoshch’",
                        "latitude": "59.28158000",
                        "longitude": "32.47074000"
                    },
                    {
                        "id": 98066,
                        "name": "Bugry",
                        "latitude": "60.07121000",
                        "longitude": "30.39225000"
                    },
                    {
                        "id": 98165,
                        "name": "Chernaya Rechka",
                        "latitude": "59.98594000",
                        "longitude": "30.30338000"
                    },
                    {
                        "id": 98332,
                        "name": "Druzhnaya Gorka",
                        "latitude": "59.28018000",
                        "longitude": "30.12709000"
                    },
                    {
                        "id": 98444,
                        "name": "Fëdorovskoye",
                        "latitude": "59.66306000",
                        "longitude": "30.53222000"
                    },
                    {
                        "id": 98428,
                        "name": "Finlyandskiy",
                        "latitude": "59.96824000",
                        "longitude": "30.36415000"
                    },
                    {
                        "id": 98434,
                        "name": "Fornosovo",
                        "latitude": "59.56889000",
                        "longitude": "30.55444000"
                    },
                    {
                        "id": 98457,
                        "name": "Garbolovo",
                        "latitude": "60.34127000",
                        "longitude": "30.49551000"
                    },
                    {
                        "id": 98460,
                        "name": "Gatchina",
                        "latitude": "59.57639000",
                        "longitude": "30.12833000"
                    },
                    {
                        "id": 98497,
                        "name": "Glebychevo",
                        "latitude": "60.43868000",
                        "longitude": "28.71826000"
                    },
                    {
                        "id": 98519,
                        "name": "Gorbunki",
                        "latitude": "59.81307000",
                        "longitude": "29.98478000"
                    },
                    {
                        "id": 98568,
                        "name": "Gorskaya",
                        "latitude": "60.04640000",
                        "longitude": "29.97137000"
                    },
                    {
                        "id": 98572,
                        "name": "Gostilitsy",
                        "latitude": "59.74832000",
                        "longitude": "29.62205000"
                    },
                    {
                        "id": 98651,
                        "name": "Il’ichëvo",
                        "latitude": "60.26808000",
                        "longitude": "29.75230000"
                    },
                    {
                        "id": 98663,
                        "name": "Imeni Morozova",
                        "latitude": "59.97572000",
                        "longitude": "31.03762000"
                    },
                    {
                        "id": 98667,
                        "name": "Imeni Sverdlova",
                        "latitude": "59.79611000",
                        "longitude": "30.66583000"
                    },
                    {
                        "id": 98716,
                        "name": "Issad",
                        "latitude": "60.06743000",
                        "longitude": "32.34331000"
                    },
                    {
                        "id": 98726,
                        "name": "Ivangorod",
                        "latitude": "59.37155000",
                        "longitude": "28.21625000"
                    },
                    {
                        "id": 98790,
                        "name": "Kalininskiy",
                        "latitude": "59.99675000",
                        "longitude": "30.38990000"
                    },
                    {
                        "id": 98813,
                        "name": "Kamenka",
                        "latitude": "60.44639000",
                        "longitude": "29.08290000"
                    },
                    {
                        "id": 98815,
                        "name": "Kamennogorsk",
                        "latitude": "60.95451000",
                        "longitude": "29.13391000"
                    },
                    {
                        "id": 99022,
                        "name": "Khvalovo",
                        "latitude": "59.94774000",
                        "longitude": "32.73723000"
                    },
                    {
                        "id": 99036,
                        "name": "Kikerino",
                        "latitude": "59.46466000",
                        "longitude": "29.62729000"
                    },
                    {
                        "id": 99050,
                        "name": "Kingisepp",
                        "latitude": "59.37331000",
                        "longitude": "28.61343000"
                    },
                    {
                        "id": 99051,
                        "name": "Kingiseppskiy Rayon",
                        "latitude": "59.50000000",
                        "longitude": "28.50000000"
                    },
                    {
                        "id": 99052,
                        "name": "Kipen’",
                        "latitude": "59.67407000",
                        "longitude": "29.84977000"
                    },
                    {
                        "id": 99057,
                        "name": "Kirishi",
                        "latitude": "59.44712000",
                        "longitude": "32.02049000"
                    },
                    {
                        "id": 99065,
                        "name": "Kirovsk",
                        "latitude": "59.88101000",
                        "longitude": "30.99507000"
                    },
                    {
                        "id": 99071,
                        "name": "Kirovskiy Rayon",
                        "latitude": "59.83333000",
                        "longitude": "31.00000000"
                    },
                    {
                        "id": 99117,
                        "name": "Kobrinskoye",
                        "latitude": "59.42250000",
                        "longitude": "30.12389000"
                    },
                    {
                        "id": 99137,
                        "name": "Kolchanovo",
                        "latitude": "60.01647000",
                        "longitude": "32.58837000"
                    },
                    {
                        "id": 99150,
                        "name": "Koltushi",
                        "latitude": "59.92969000",
                        "longitude": "30.64465000"
                    },
                    {
                        "id": 99164,
                        "name": "Kommunar",
                        "latitude": "59.62056000",
                        "longitude": "30.39000000"
                    },
                    {
                        "id": 99200,
                        "name": "Kopor’ye",
                        "latitude": "59.71067000",
                        "longitude": "29.03488000"
                    },
                    {
                        "id": 99211,
                        "name": "Korobitsyno",
                        "latitude": "60.51523000",
                        "longitude": "29.72437000"
                    },
                    {
                        "id": 99360,
                        "name": "Krasnyy Bor",
                        "latitude": "59.68194000",
                        "longitude": "30.66806000"
                    },
                    {
                        "id": 99390,
                        "name": "Krestovskiy ostrov",
                        "latitude": "59.97091000",
                        "longitude": "30.25789000"
                    },
                    {
                        "id": 99469,
                        "name": "Kurortnyy",
                        "latitude": "60.16562000",
                        "longitude": "29.90800000"
                    },
                    {
                        "id": 99498,
                        "name": "Kuyvozi",
                        "latitude": "60.31931000",
                        "longitude": "30.43631000"
                    },
                    {
                        "id": 99507,
                        "name": "Kuznechnoye",
                        "latitude": "61.11530000",
                        "longitude": "29.87535000"
                    },
                    {
                        "id": 99555,
                        "name": "Lebyazh’ye",
                        "latitude": "59.96124000",
                        "longitude": "29.41487000"
                    },
                    {
                        "id": 99576,
                        "name": "Leninskoye",
                        "latitude": "60.22021000",
                        "longitude": "29.84711000"
                    },
                    {
                        "id": 99591,
                        "name": "Leskolovo",
                        "latitude": "60.26341000",
                        "longitude": "30.45462000"
                    },
                    {
                        "id": 99603,
                        "name": "Lesogorskiy",
                        "latitude": "61.04549000",
                        "longitude": "28.92938000"
                    },
                    {
                        "id": 99648,
                        "name": "Lodeynopol’skiy Rayon",
                        "latitude": "60.50000000",
                        "longitude": "33.75000000"
                    },
                    {
                        "id": 99649,
                        "name": "Lodeynoye Pole",
                        "latitude": "60.72600000",
                        "longitude": "33.55306000"
                    },
                    {
                        "id": 99658,
                        "name": "Lomonosovskiy Rayon",
                        "latitude": "59.89721000",
                        "longitude": "29.73994000"
                    },
                    {
                        "id": 99680,
                        "name": "Luga",
                        "latitude": "58.73722000",
                        "longitude": "29.84528000"
                    },
                    {
                        "id": 99693,
                        "name": "Luppolovo",
                        "latitude": "60.15402000",
                        "longitude": "30.28034000"
                    },
                    {
                        "id": 99697,
                        "name": "Luzhskiy Rayon",
                        "latitude": "58.75000000",
                        "longitude": "29.75000000"
                    },
                    {
                        "id": 99712,
                        "name": "Lyuban’",
                        "latitude": "59.35000000",
                        "longitude": "31.21667000"
                    },
                    {
                        "id": 99770,
                        "name": "Maloye Verevo",
                        "latitude": "59.61361000",
                        "longitude": "30.17278000"
                    },
                    {
                        "id": 99798,
                        "name": "Mariyenburg",
                        "latitude": "59.57139000",
                        "longitude": "30.06472000"
                    },
                    {
                        "id": 99885,
                        "name": "Mga",
                        "latitude": "59.75000000",
                        "longitude": "31.06667000"
                    },
                    {
                        "id": 99893,
                        "name": "Michurinskoye",
                        "latitude": "60.56420000",
                        "longitude": "29.86232000"
                    },
                    {
                        "id": 99989,
                        "name": "Mshinskaya",
                        "latitude": "59.01500000",
                        "longitude": "29.94333000"
                    },
                    {
                        "id": 100008,
                        "name": "Murino",
                        "latitude": "60.04796000",
                        "longitude": "30.45204000"
                    },
                    {
                        "id": 100146,
                        "name": "Nikol’skoye",
                        "latitude": "59.70056000",
                        "longitude": "30.78472000"
                    },
                    {
                        "id": 100204,
                        "name": "Novaya Ladoga",
                        "latitude": "60.10246000",
                        "longitude": "32.30191000"
                    },
                    {
                        "id": 100332,
                        "name": "Novoye Devyatkino",
                        "latitude": "60.06364000",
                        "longitude": "30.48328000"
                    },
                    {
                        "id": 100372,
                        "name": "Nurma",
                        "latitude": "59.55000000",
                        "longitude": "31.01667000"
                    },
                    {
                        "id": 100434,
                        "name": "Ol’gino",
                        "latitude": "59.83702000",
                        "longitude": "29.92266000"
                    },
                    {
                        "id": 100485,
                        "name": "Osel’ki",
                        "latitude": "60.20503000",
                        "longitude": "30.49667000"
                    },
                    {
                        "id": 100506,
                        "name": "Otradnoye",
                        "latitude": "59.77750000",
                        "longitude": "30.81806000"
                    },
                    {
                        "id": 100553,
                        "name": "Parnas",
                        "latitude": "60.06964000",
                        "longitude": "30.34870000"
                    },
                    {
                        "id": 100560,
                        "name": "Pasha",
                        "latitude": "60.39546000",
                        "longitude": "33.04308000"
                    },
                    {
                        "id": 100569,
                        "name": "Pavlovo",
                        "latitude": "59.80861000",
                        "longitude": "30.89667000"
                    },
                    {
                        "id": 100625,
                        "name": "Pervomayskoye",
                        "latitude": "60.35922000",
                        "longitude": "29.74240000"
                    },
                    {
                        "id": 100671,
                        "name": "Pikalëvo",
                        "latitude": "59.51833000",
                        "longitude": "34.16639000"
                    },
                    {
                        "id": 100729,
                        "name": "Podporozh’ye",
                        "latitude": "60.91124000",
                        "longitude": "34.17064000"
                    },
                    {
                        "id": 100728,
                        "name": "Podporozhskiy Rayon",
                        "latitude": "61.00000000",
                        "longitude": "34.50000000"
                    },
                    {
                        "id": 100826,
                        "name": "Priladozhskiy",
                        "latitude": "59.85000000",
                        "longitude": "31.48333000"
                    },
                    {
                        "id": 100831,
                        "name": "Primorsk",
                        "latitude": "60.36593000",
                        "longitude": "28.60737000"
                    },
                    {
                        "id": 100839,
                        "name": "Priozërsk",
                        "latitude": "61.03928000",
                        "longitude": "30.12907000"
                    },
                    {
                        "id": 100838,
                        "name": "Priozersky",
                        "latitude": "61.03901000",
                        "longitude": "30.13515000"
                    },
                    {
                        "id": 100987,
                        "name": "Romanovka",
                        "latitude": "60.04430000",
                        "longitude": "30.71400000"
                    },
                    {
                        "id": 100998,
                        "name": "Roshchino",
                        "latitude": "60.25191000",
                        "longitude": "29.60850000"
                    },
                    {
                        "id": 101013,
                        "name": "Rozhdestveno",
                        "latitude": "59.31812000",
                        "longitude": "29.94594000"
                    },
                    {
                        "id": 101034,
                        "name": "Russko-Vysotskoye",
                        "latitude": "59.69963000",
                        "longitude": "29.94404000"
                    },
                    {
                        "id": 101041,
                        "name": "Ryabovo",
                        "latitude": "59.40000000",
                        "longitude": "31.13333000"
                    },
                    {
                        "id": 101047,
                        "name": "Rybatskoye",
                        "latitude": "59.83930000",
                        "longitude": "30.49873000"
                    },
                    {
                        "id": 101091,
                        "name": "Sampsonievskiy",
                        "latitude": "59.98499000",
                        "longitude": "30.34295000"
                    },
                    {
                        "id": 101102,
                        "name": "Sapernoye",
                        "latitude": "60.71418000",
                        "longitude": "29.95525000"
                    },
                    {
                        "id": 101167,
                        "name": "Semiozerje",
                        "latitude": "60.32018000",
                        "longitude": "29.29705000"
                    },
                    {
                        "id": 101193,
                        "name": "Sertolovo",
                        "latitude": "60.14440000",
                        "longitude": "30.20165000"
                    },
                    {
                        "id": 101274,
                        "name": "Shcheglovo",
                        "latitude": "60.02839000",
                        "longitude": "30.75289000"
                    },
                    {
                        "id": 101336,
                        "name": "Shlissel’burg",
                        "latitude": "59.94730000",
                        "longitude": "31.03845000"
                    },
                    {
                        "id": 101377,
                        "name": "Sinyavino",
                        "latitude": "59.90781000",
                        "longitude": "31.07110000"
                    },
                    {
                        "id": 101379,
                        "name": "Sista-Palkino",
                        "latitude": "59.80042000",
                        "longitude": "28.91049000"
                    },
                    {
                        "id": 101385,
                        "name": "Siverskiy",
                        "latitude": "59.35444000",
                        "longitude": "30.07833000"
                    },
                    {
                        "id": 101397,
                        "name": "Slantsevskiy Rayon",
                        "latitude": "59.08333000",
                        "longitude": "28.25000000"
                    },
                    {
                        "id": 101398,
                        "name": "Slantsy",
                        "latitude": "59.11817000",
                        "longitude": "28.09137000"
                    },
                    {
                        "id": 101491,
                        "name": "Sosnovo",
                        "latitude": "60.55145000",
                        "longitude": "30.21441000"
                    },
                    {
                        "id": 101498,
                        "name": "Sosnovyy Bor",
                        "latitude": "59.89960000",
                        "longitude": "29.08574000"
                    },
                    {
                        "id": 101509,
                        "name": "Sovetskiy",
                        "latitude": "60.53945000",
                        "longitude": "28.67756000"
                    },
                    {
                        "id": 101556,
                        "name": "Staraya",
                        "latitude": "59.92749000",
                        "longitude": "30.62765000"
                    },
                    {
                        "id": 101561,
                        "name": "Staraya Ladoga",
                        "latitude": "59.99872000",
                        "longitude": "32.29413000"
                    },
                    {
                        "id": 101699,
                        "name": "Svetlanovskiy",
                        "latitude": "60.00276000",
                        "longitude": "30.33051000"
                    },
                    {
                        "id": 101709,
                        "name": "Svetogorsk",
                        "latitude": "61.11213000",
                        "longitude": "28.86321000"
                    },
                    {
                        "id": 101719,
                        "name": "Syas’stroy",
                        "latitude": "60.13669000",
                        "longitude": "32.56906000"
                    },
                    {
                        "id": 101805,
                        "name": "Taytsy",
                        "latitude": "59.66444000",
                        "longitude": "30.11472000"
                    },
                    {
                        "id": 101853,
                        "name": "Tikhvin",
                        "latitude": "59.64511000",
                        "longitude": "33.52937000"
                    },
                    {
                        "id": 101854,
                        "name": "Tikhvinskiy Rayon",
                        "latitude": "59.75000000",
                        "longitude": "33.33333000"
                    },
                    {
                        "id": 101874,
                        "name": "Toksovo",
                        "latitude": "60.15323000",
                        "longitude": "30.51646000"
                    },
                    {
                        "id": 101877,
                        "name": "Tolmachevo",
                        "latitude": "58.85973000",
                        "longitude": "29.91091000"
                    },
                    {
                        "id": 101903,
                        "name": "Tosnenskiy Rayon",
                        "latitude": "59.41667000",
                        "longitude": "31.00000000"
                    },
                    {
                        "id": 101904,
                        "name": "Tosno",
                        "latitude": "59.54000000",
                        "longitude": "30.87750000"
                    },
                    {
                        "id": 102020,
                        "name": "Udel’naya",
                        "latitude": "60.01636000",
                        "longitude": "30.31815000"
                    },
                    {
                        "id": 102053,
                        "name": "Ul’yanovka",
                        "latitude": "59.63944000",
                        "longitude": "30.76472000"
                    },
                    {
                        "id": 102062,
                        "name": "Untolovo",
                        "latitude": "60.01220000",
                        "longitude": "30.20897000"
                    },
                    {
                        "id": 102136,
                        "name": "Ust’-Luga",
                        "latitude": "59.66755000",
                        "longitude": "28.28713000"
                    },
                    {
                        "id": 102200,
                        "name": "Vaskelovo",
                        "latitude": "60.39571000",
                        "longitude": "30.35419000"
                    },
                    {
                        "id": 102207,
                        "name": "Vazhiny",
                        "latitude": "60.96444000",
                        "longitude": "34.02222000"
                    },
                    {
                        "id": 102262,
                        "name": "Verkhniye Osel’ki",
                        "latitude": "60.24948000",
                        "longitude": "30.44938000"
                    },
                    {
                        "id": 102288,
                        "name": "Veshchevo",
                        "latitude": "60.73107000",
                        "longitude": "29.18305000"
                    },
                    {
                        "id": 102312,
                        "name": "Vinnitsy",
                        "latitude": "60.62867000",
                        "longitude": "34.77302000"
                    },
                    {
                        "id": 102320,
                        "name": "Vistino",
                        "latitude": "59.77558000",
                        "longitude": "28.47708000"
                    },
                    {
                        "id": 102346,
                        "name": "Volkhov",
                        "latitude": "59.92580000",
                        "longitude": "32.33819000"
                    },
                    {
                        "id": 102348,
                        "name": "Volkhovskiy rayon",
                        "latitude": "59.75000000",
                        "longitude": "32.50000000"
                    },
                    {
                        "id": 102361,
                        "name": "Volosovo",
                        "latitude": "59.44525000",
                        "longitude": "29.48911000"
                    },
                    {
                        "id": 102362,
                        "name": "Volosovskiy Rayon",
                        "latitude": "59.42105000",
                        "longitude": "29.47705000"
                    },
                    {
                        "id": 102404,
                        "name": "Voyskovitsy",
                        "latitude": "59.53266000",
                        "longitude": "29.93620000"
                    },
                    {
                        "id": 102411,
                        "name": "Voznesen’ye",
                        "latitude": "61.01060000",
                        "longitude": "35.47813000"
                    },
                    {
                        "id": 102413,
                        "name": "Vsevolozhsk",
                        "latitude": "60.01512000",
                        "longitude": "30.67314000"
                    },
                    {
                        "id": 102414,
                        "name": "Vsevolozhskiy Rayon",
                        "latitude": "60.16667000",
                        "longitude": "30.50000000"
                    },
                    {
                        "id": 102426,
                        "name": "Vyborg",
                        "latitude": "60.70763000",
                        "longitude": "28.75283000"
                    },
                    {
                        "id": 102435,
                        "name": "Vyritsa",
                        "latitude": "59.40778000",
                        "longitude": "30.34806000"
                    },
                    {
                        "id": 102451,
                        "name": "Vysotsk",
                        "latitude": "60.62879000",
                        "longitude": "28.57048000"
                    },
                    {
                        "id": 102468,
                        "name": "Yakovlevo",
                        "latitude": "60.29409000",
                        "longitude": "29.48800000"
                    },
                    {
                        "id": 102483,
                        "name": "Yanino-1",
                        "latitude": "59.94808000",
                        "longitude": "30.55914000"
                    },
                    {
                        "id": 102498,
                        "name": "Yaroslavichi",
                        "latitude": "60.49275000",
                        "longitude": "34.50806000"
                    },
                    {
                        "id": 102522,
                        "name": "Yefimovskiy",
                        "latitude": "59.49639000",
                        "longitude": "34.67222000"
                    },
                    {
                        "id": 102541,
                        "name": "Yelizavetino",
                        "latitude": "59.49173000",
                        "longitude": "29.78153000"
                    }
                ]
            },
            {
                "id": 1889,
                "name": "Lipetsk",
                "iso2": "LIP",
                "latitude": "52.52647020",
                "longitude": "39.20322690",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 98010,
                        "name": "Bol’shoy Khomutets",
                        "latitude": "52.78285000",
                        "longitude": "39.87214000"
                    },
                    {
                        "id": 98023,
                        "name": "Borinskoye",
                        "latitude": "52.45690000",
                        "longitude": "39.37130000"
                    },
                    {
                        "id": 98116,
                        "name": "Chaplygin",
                        "latitude": "53.24319000",
                        "longitude": "39.96288000"
                    },
                    {
                        "id": 98117,
                        "name": "Chaplyginskiy Rayon",
                        "latitude": "53.25000000",
                        "longitude": "40.00000000"
                    },
                    {
                        "id": 98244,
                        "name": "Dankov",
                        "latitude": "53.25155000",
                        "longitude": "39.15553000"
                    },
                    {
                        "id": 98245,
                        "name": "Dankovskiy Rayon",
                        "latitude": "53.25000000",
                        "longitude": "39.16667000"
                    },
                    {
                        "id": 98291,
                        "name": "Dobrinka",
                        "latitude": "52.16528000",
                        "longitude": "40.47306000"
                    },
                    {
                        "id": 98292,
                        "name": "Dobrinskiy Rayon",
                        "latitude": "52.16667000",
                        "longitude": "40.50000000"
                    },
                    {
                        "id": 98293,
                        "name": "Dobrovskiy Rayon",
                        "latitude": "52.83333000",
                        "longitude": "39.83333000"
                    },
                    {
                        "id": 98294,
                        "name": "Dobroye",
                        "latitude": "52.86780000",
                        "longitude": "39.81090000"
                    },
                    {
                        "id": 98301,
                        "name": "Dolgorukovo",
                        "latitude": "52.31945000",
                        "longitude": "38.34527000"
                    },
                    {
                        "id": 98302,
                        "name": "Dolgorukovskiy Rayon",
                        "latitude": "52.33333000",
                        "longitude": "38.33333000"
                    },
                    {
                        "id": 98315,
                        "name": "Donskoye",
                        "latitude": "52.61740000",
                        "longitude": "38.97380000"
                    },
                    {
                        "id": 98596,
                        "name": "Gryazi",
                        "latitude": "52.49657000",
                        "longitude": "39.93593000"
                    },
                    {
                        "id": 98597,
                        "name": "Gryazinskiy Rayon",
                        "latitude": "52.50000000",
                        "longitude": "39.91667000"
                    },
                    {
                        "id": 98751,
                        "name": "Izmalkovo",
                        "latitude": "52.68870000",
                        "longitude": "37.96398000"
                    },
                    {
                        "id": 98752,
                        "name": "Izmalkovskiy Rayon",
                        "latitude": "52.66667000",
                        "longitude": "38.00000000"
                    },
                    {
                        "id": 98784,
                        "name": "Kalikino",
                        "latitude": "52.94930000",
                        "longitude": "39.82690000"
                    },
                    {
                        "id": 98925,
                        "name": "Kazaki",
                        "latitude": "52.62484000",
                        "longitude": "38.26488000"
                    },
                    {
                        "id": 98932,
                        "name": "Kazinka",
                        "latitude": "52.53817000",
                        "longitude": "39.82164000"
                    },
                    {
                        "id": 98986,
                        "name": "Khlevenskiy Rayon",
                        "latitude": "52.16667000",
                        "longitude": "39.08333000"
                    },
                    {
                        "id": 98987,
                        "name": "Khlevnoye",
                        "latitude": "52.19512000",
                        "longitude": "39.09316000"
                    },
                    {
                        "id": 99289,
                        "name": "Krasninskiy Rayon",
                        "latitude": "52.83333000",
                        "longitude": "38.75000000"
                    },
                    {
                        "id": 99349,
                        "name": "Krasnoye",
                        "latitude": "52.86449000",
                        "longitude": "38.79353000"
                    },
                    {
                        "id": 99512,
                        "name": "Kuz’minskiye Otverzhki",
                        "latitude": "52.69574000",
                        "longitude": "39.47036000"
                    },
                    {
                        "id": 99554,
                        "name": "Lebedyan’",
                        "latitude": "53.01942000",
                        "longitude": "39.16639000"
                    },
                    {
                        "id": 99553,
                        "name": "Lebedyanskiy Rayon",
                        "latitude": "53.00000000",
                        "longitude": "39.16667000"
                    },
                    {
                        "id": 99609,
                        "name": "Lev Tolstoy",
                        "latitude": "53.21344000",
                        "longitude": "39.44604000"
                    },
                    {
                        "id": 99610,
                        "name": "Lev-Tolstovskiy Rayon",
                        "latitude": "53.25000000",
                        "longitude": "39.50000000"
                    },
                    {
                        "id": 99632,
                        "name": "Lipetsk",
                        "latitude": "52.60311000",
                        "longitude": "39.57076000"
                    },
                    {
                        "id": 99633,
                        "name": "Lipetskiy Rayon",
                        "latitude": "52.58333000",
                        "longitude": "39.58333000"
                    },
                    {
                        "id": 100664,
                        "name": "Petrovskiy",
                        "latitude": "52.24159000",
                        "longitude": "40.64976000"
                    },
                    {
                        "id": 100700,
                        "name": "Plekhanovo",
                        "latitude": "52.63822000",
                        "longitude": "39.84729000"
                    },
                    {
                        "id": 100819,
                        "name": "Prigorodka",
                        "latitude": "52.04472000",
                        "longitude": "39.71238000"
                    },
                    {
                        "id": 101552,
                        "name": "Stanovlyanskiy Rayon",
                        "latitude": "52.83333000",
                        "longitude": "38.33333000"
                    },
                    {
                        "id": 101553,
                        "name": "Stanovoye",
                        "latitude": "52.76384000",
                        "longitude": "38.35818000"
                    },
                    {
                        "id": 101730,
                        "name": "Syrskoye",
                        "latitude": "52.57437000",
                        "longitude": "39.49660000"
                    },
                    {
                        "id": 101825,
                        "name": "Terbunskiy Rayon",
                        "latitude": "52.16667000",
                        "longitude": "38.25000000"
                    },
                    {
                        "id": 101826,
                        "name": "Terbuny",
                        "latitude": "52.14930000",
                        "longitude": "38.28340000"
                    },
                    {
                        "id": 102099,
                        "name": "Usman’",
                        "latitude": "52.04662000",
                        "longitude": "39.72880000"
                    },
                    {
                        "id": 102098,
                        "name": "Usmanskiy Rayon",
                        "latitude": "52.00000000",
                        "longitude": "39.75000000"
                    },
                    {
                        "id": 102365,
                        "name": "Volovo",
                        "latitude": "52.02659000",
                        "longitude": "37.88540000"
                    },
                    {
                        "id": 102367,
                        "name": "Volovskiy Rayon",
                        "latitude": "52.00000000",
                        "longitude": "37.91667000"
                    },
                    {
                        "id": 102538,
                        "name": "Yelets",
                        "latitude": "52.62366000",
                        "longitude": "38.50169000"
                    },
                    {
                        "id": 102539,
                        "name": "Yeletskiy Rayon",
                        "latitude": "52.58333000",
                        "longitude": "38.50000000"
                    },
                    {
                        "id": 102626,
                        "name": "Zadonsk",
                        "latitude": "52.39040000",
                        "longitude": "38.92610000"
                    },
                    {
                        "id": 102627,
                        "name": "Zadonskiy Rayon",
                        "latitude": "52.41667000",
                        "longitude": "38.91667000"
                    }
                ]
            },
            {
                "id": 1839,
                "name": "Magadan",
                "iso2": "MAG",
                "latitude": "62.66434170",
                "longitude": "153.91499100",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97672,
                        "name": "Arman’",
                        "latitude": "59.66994000",
                        "longitude": "150.13164000"
                    },
                    {
                        "id": 98349,
                        "name": "Dukat",
                        "latitude": "62.57231000",
                        "longitude": "155.34988000"
                    },
                    {
                        "id": 98409,
                        "name": "Evensk",
                        "latitude": "61.91722000",
                        "longitude": "159.23348000"
                    },
                    {
                        "id": 98552,
                        "name": "Gorod Magadan",
                        "latitude": "59.56029000",
                        "longitude": "150.79843000"
                    },
                    {
                        "id": 98999,
                        "name": "Kholodnyy",
                        "latitude": "62.71333000",
                        "longitude": "147.91361000"
                    },
                    {
                        "id": 99730,
                        "name": "Magadan",
                        "latitude": "59.56380000",
                        "longitude": "150.80347000"
                    },
                    {
                        "id": 100028,
                        "name": "Myaundzha",
                        "latitude": "63.04996000",
                        "longitude": "147.18438000"
                    },
                    {
                        "id": 100439,
                        "name": "Ol’skiy Rayon",
                        "latitude": "60.00000000",
                        "longitude": "153.00000000"
                    },
                    {
                        "id": 100419,
                        "name": "Ola",
                        "latitude": "59.57823000",
                        "longitude": "151.29819000"
                    },
                    {
                        "id": 100441,
                        "name": "Omsukchan",
                        "latitude": "62.51575000",
                        "longitude": "155.79038000"
                    },
                    {
                        "id": 100442,
                        "name": "Omsukchanskiy Rayon",
                        "latitude": "63.00000000",
                        "longitude": "156.33333000"
                    },
                    {
                        "id": 100476,
                        "name": "Orotukan",
                        "latitude": "62.26423000",
                        "longitude": "151.67153000"
                    },
                    {
                        "id": 100528,
                        "name": "Palatka",
                        "latitude": "60.10183000",
                        "longitude": "150.93433000"
                    },
                    {
                        "id": 101226,
                        "name": "Seymchan",
                        "latitude": "62.93373000",
                        "longitude": "152.39109000"
                    },
                    {
                        "id": 101372,
                        "name": "Sinegor'ye",
                        "latitude": "62.08782000",
                        "longitude": "150.52162000"
                    },
                    {
                        "id": 101435,
                        "name": "Sokol",
                        "latitude": "59.91834000",
                        "longitude": "150.74956000"
                    },
                    {
                        "id": 101542,
                        "name": "Srednekanskiy Rayon",
                        "latitude": "64.00000000",
                        "longitude": "153.50000000"
                    },
                    {
                        "id": 101685,
                        "name": "Susuman",
                        "latitude": "62.78075000",
                        "longitude": "148.15396000"
                    },
                    {
                        "id": 101748,
                        "name": "Talaya",
                        "latitude": "61.37038000",
                        "longitude": "152.76878000"
                    },
                    {
                        "id": 102068,
                        "name": "Uptar",
                        "latitude": "59.89923000",
                        "longitude": "150.87376000"
                    },
                    {
                        "id": 102137,
                        "name": "Ust’-Omchug",
                        "latitude": "61.13336000",
                        "longitude": "149.63283000"
                    },
                    {
                        "id": 102461,
                        "name": "Yagodnoye",
                        "latitude": "62.52406000",
                        "longitude": "149.62827000"
                    }
                ]
            },
            {
                "id": 1870,
                "name": "Mari El",
                "iso2": "ME",
                "latitude": "56.43845700",
                "longitude": "47.96077580",
                "type": "republic",
                "cities": [
                    {
                        "id": 98530,
                        "name": "Gornomariyskiy Rayon",
                        "latitude": "56.41667000",
                        "longitude": "46.75000000"
                    },
                    {
                        "id": 99039,
                        "name": "Kilemarskiy Rayon",
                        "latitude": "56.75000000",
                        "longitude": "46.91667000"
                    },
                    {
                        "id": 99040,
                        "name": "Kilemary",
                        "latitude": "56.77825000",
                        "longitude": "46.86594000"
                    },
                    {
                        "id": 99271,
                        "name": "Koz’modem’yansk",
                        "latitude": "56.34190000",
                        "longitude": "46.56353000"
                    },
                    {
                        "id": 99305,
                        "name": "Krasnogorskiy",
                        "latitude": "56.15250000",
                        "longitude": "48.32583000"
                    },
                    {
                        "id": 99500,
                        "name": "Kuzhener",
                        "latitude": "56.81111000",
                        "longitude": "48.91278000"
                    },
                    {
                        "id": 99501,
                        "name": "Kuzhenerskiy Rayon",
                        "latitude": "56.75000000",
                        "longitude": "49.00000000"
                    },
                    {
                        "id": 99793,
                        "name": "Mari-Turek",
                        "latitude": "56.78946000",
                        "longitude": "49.62349000"
                    },
                    {
                        "id": 99794,
                        "name": "Mari-Turekskiy Rayon",
                        "latitude": "56.75000000",
                        "longitude": "49.83333000"
                    },
                    {
                        "id": 99842,
                        "name": "Medvedevo",
                        "latitude": "56.63388000",
                        "longitude": "47.80405000"
                    },
                    {
                        "id": 99843,
                        "name": "Medvedevskiy Rayon",
                        "latitude": "56.66667000",
                        "longitude": "47.75000000"
                    },
                    {
                        "id": 99937,
                        "name": "Mochalishche",
                        "latitude": "56.33060000",
                        "longitude": "48.35470000"
                    },
                    {
                        "id": 99964,
                        "name": "Morki",
                        "latitude": "56.43028000",
                        "longitude": "48.99472000"
                    },
                    {
                        "id": 99965,
                        "name": "Morkinskiy Rayon",
                        "latitude": "56.50000000",
                        "longitude": "49.00000000"
                    },
                    {
                        "id": 100315,
                        "name": "Novotor”yal’skiy Rayon",
                        "latitude": "57.08333000",
                        "longitude": "48.66667000"
                    },
                    {
                        "id": 100478,
                        "name": "Orshanka",
                        "latitude": "56.91607000",
                        "longitude": "47.89335000"
                    },
                    {
                        "id": 100479,
                        "name": "Orshanskiy Rayon",
                        "latitude": "56.91667000",
                        "longitude": "47.91667000"
                    },
                    {
                        "id": 100541,
                        "name": "Paran’ga",
                        "latitude": "56.70389000",
                        "longitude": "49.40472000"
                    },
                    {
                        "id": 100542,
                        "name": "Paran’ginskiy Rayon",
                        "latitude": "56.66667000",
                        "longitude": "49.41667000"
                    },
                    {
                        "id": 100765,
                        "name": "Pomary",
                        "latitude": "55.96815000",
                        "longitude": "48.35072000"
                    },
                    {
                        "id": 100848,
                        "name": "Privolzhskiy",
                        "latitude": "55.96135000",
                        "longitude": "48.41512000"
                    },
                    {
                        "id": 101188,
                        "name": "Sernur",
                        "latitude": "56.93333000",
                        "longitude": "49.15361000"
                    },
                    {
                        "id": 101189,
                        "name": "Sernurskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "49.25000000"
                    },
                    {
                        "id": 101510,
                        "name": "Sovetskiy",
                        "latitude": "56.75833000",
                        "longitude": "48.47611000"
                    },
                    {
                        "id": 101514,
                        "name": "Sovetskiy Rayon",
                        "latitude": "56.66667000",
                        "longitude": "48.50000000"
                    },
                    {
                        "id": 101678,
                        "name": "Surok",
                        "latitude": "56.44694000",
                        "longitude": "48.12139000"
                    },
                    {
                        "id": 101683,
                        "name": "Suslonger",
                        "latitude": "56.31556000",
                        "longitude": "48.25306000"
                    },
                    {
                        "id": 102306,
                        "name": "Vilovatovo",
                        "latitude": "56.17240000",
                        "longitude": "46.60134000"
                    },
                    {
                        "id": 102369,
                        "name": "Volzhsk",
                        "latitude": "55.86638000",
                        "longitude": "48.35940000"
                    },
                    {
                        "id": 102371,
                        "name": "Volzhskiy Rayon",
                        "latitude": "56.08333000",
                        "longitude": "48.58333000"
                    },
                    {
                        "id": 102581,
                        "name": "Yoshkar-Ola",
                        "latitude": "56.63877000",
                        "longitude": "47.89078000"
                    },
                    {
                        "id": 102597,
                        "name": "Yurino",
                        "latitude": "56.29417000",
                        "longitude": "46.30392000"
                    },
                    {
                        "id": 102598,
                        "name": "Yurinskiy Rayon",
                        "latitude": "56.30000000",
                        "longitude": "46.30000000"
                    },
                    {
                        "id": 102779,
                        "name": "Zvenigovo",
                        "latitude": "55.97539000",
                        "longitude": "48.01304000"
                    },
                    {
                        "id": 102780,
                        "name": "Zvenigovskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "47.75000000"
                    }
                ]
            },
            {
                "id": 1898,
                "name": "Mordovia",
                "iso2": "MO",
                "latitude": "54.23694410",
                "longitude": "44.06839700",
                "type": "republic",
                "cities": [
                    {
                        "id": 97654,
                        "name": "Ardatov",
                        "latitude": "54.84767000",
                        "longitude": "46.23878000"
                    },
                    {
                        "id": 97656,
                        "name": "Ardatovskiy Rayon",
                        "latitude": "54.83333000",
                        "longitude": "46.25000000"
                    },
                    {
                        "id": 97709,
                        "name": "Atemar",
                        "latitude": "54.18097000",
                        "longitude": "45.40909000"
                    },
                    {
                        "id": 97717,
                        "name": "Atyashevo",
                        "latitude": "54.56443000",
                        "longitude": "46.06905000"
                    },
                    {
                        "id": 97718,
                        "name": "Atyashevskiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "46.08333000"
                    },
                    {
                        "id": 97719,
                        "name": "Atyur’yevskiy Rayon",
                        "latitude": "54.33333000",
                        "longitude": "43.41667000"
                    },
                    {
                        "id": 97792,
                        "name": "Barashevo",
                        "latitude": "54.53250000",
                        "longitude": "42.87917000"
                    },
                    {
                        "id": 98002,
                        "name": "Bol’shebereznikovskiy Rayon",
                        "latitude": "54.16667000",
                        "longitude": "45.83333000"
                    },
                    {
                        "id": 98112,
                        "name": "Chamzinka",
                        "latitude": "54.40188000",
                        "longitude": "45.78387000"
                    },
                    {
                        "id": 98113,
                        "name": "Chamzinskiy Rayon",
                        "latitude": "54.41667000",
                        "longitude": "45.75000000"
                    },
                    {
                        "id": 98675,
                        "name": "Insar",
                        "latitude": "53.86531000",
                        "longitude": "44.37382000"
                    },
                    {
                        "id": 98676,
                        "name": "Insarskiy Rayon",
                        "latitude": "53.83333000",
                        "longitude": "44.41667000"
                    },
                    {
                        "id": 98770,
                        "name": "Kadoshkino",
                        "latitude": "54.02570000",
                        "longitude": "44.41910000"
                    },
                    {
                        "id": 98938,
                        "name": "Kemlya",
                        "latitude": "54.69630000",
                        "longitude": "45.24240000"
                    },
                    {
                        "id": 99122,
                        "name": "Kochkurovo",
                        "latitude": "54.03576000",
                        "longitude": "45.41845000"
                    },
                    {
                        "id": 99123,
                        "name": "Kochkurovskiy Rayon",
                        "latitude": "54.00000000",
                        "longitude": "45.41667000"
                    },
                    {
                        "id": 99256,
                        "name": "Kovylkino",
                        "latitude": "54.03876000",
                        "longitude": "43.91385000"
                    },
                    {
                        "id": 99334,
                        "name": "Krasnoslobodsk",
                        "latitude": "54.42530000",
                        "longitude": "43.78963000"
                    },
                    {
                        "id": 99335,
                        "name": "Krasnoslobodskiy Rayon",
                        "latitude": "54.41667000",
                        "longitude": "43.75000000"
                    },
                    {
                        "id": 99583,
                        "name": "Lepley",
                        "latitude": "54.30920000",
                        "longitude": "42.85990000"
                    },
                    {
                        "id": 99685,
                        "name": "Lukhovka",
                        "latitude": "54.14844000",
                        "longitude": "45.25728000"
                    },
                    {
                        "id": 99702,
                        "name": "Lyambir’",
                        "latitude": "54.28172000",
                        "longitude": "45.12494000"
                    },
                    {
                        "id": 99701,
                        "name": "Lyambirskiy Rayon",
                        "latitude": "54.33333000",
                        "longitude": "45.25000000"
                    },
                    {
                        "id": 100133,
                        "name": "Nikolayevka",
                        "latitude": "54.14510000",
                        "longitude": "45.14440000"
                    },
                    {
                        "id": 100558,
                        "name": "Partsa",
                        "latitude": "54.36530000",
                        "longitude": "42.86170000"
                    },
                    {
                        "id": 100994,
                        "name": "Romodanovo",
                        "latitude": "54.42753000",
                        "longitude": "45.32962000"
                    },
                    {
                        "id": 100995,
                        "name": "Romodanovskiy Rayon",
                        "latitude": "54.41667000",
                        "longitude": "45.33333000"
                    },
                    {
                        "id": 101038,
                        "name": "Ruzayevka",
                        "latitude": "54.06387000",
                        "longitude": "44.95090000"
                    },
                    {
                        "id": 101039,
                        "name": "Ruzayevskiy Rayon",
                        "latitude": "54.08333000",
                        "longitude": "44.83333000"
                    },
                    {
                        "id": 101110,
                        "name": "Saransk",
                        "latitude": "54.18380000",
                        "longitude": "45.17490000"
                    },
                    {
                        "id": 101327,
                        "name": "Shiringushi",
                        "latitude": "53.84851000",
                        "longitude": "42.76759000"
                    },
                    {
                        "id": 101489,
                        "name": "Sosnovka",
                        "latitude": "54.71161000",
                        "longitude": "43.29774000"
                    },
                    {
                        "id": 101593,
                        "name": "Staroshaygovskiy Rayon",
                        "latitude": "54.33333000",
                        "longitude": "44.50000000"
                    },
                    {
                        "id": 101794,
                        "name": "Tatarskaya Pishlya",
                        "latitude": "54.06085000",
                        "longitude": "44.89978000"
                    },
                    {
                        "id": 101818,
                        "name": "Temnikov",
                        "latitude": "54.63023000",
                        "longitude": "43.21483000"
                    },
                    {
                        "id": 101819,
                        "name": "Temnikovskiy Rayon",
                        "latitude": "54.66667000",
                        "longitude": "43.16667000"
                    },
                    {
                        "id": 101823,
                        "name": "Ten’gushevo",
                        "latitude": "54.76861000",
                        "longitude": "42.71889000"
                    },
                    {
                        "id": 101824,
                        "name": "Ten’gushevskiy Rayon",
                        "latitude": "54.66667000",
                        "longitude": "42.75000000"
                    },
                    {
                        "id": 101897,
                        "name": "Torbeyevo",
                        "latitude": "54.07972000",
                        "longitude": "43.24732000"
                    },
                    {
                        "id": 101974,
                        "name": "Turgenevo",
                        "latitude": "54.84555000",
                        "longitude": "46.32968000"
                    },
                    {
                        "id": 102018,
                        "name": "Udarnyy",
                        "latitude": "54.34090000",
                        "longitude": "42.86110000"
                    },
                    {
                        "id": 102056,
                        "name": "Umet",
                        "latitude": "54.11611000",
                        "longitude": "42.69750000"
                    },
                    {
                        "id": 102438,
                        "name": "Vysha",
                        "latitude": "53.84768000",
                        "longitude": "42.37766000"
                    },
                    {
                        "id": 102516,
                        "name": "Yavas",
                        "latitude": "54.41590000",
                        "longitude": "42.84910000"
                    },
                    {
                        "id": 102550,
                        "name": "Yel’nikovskiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "43.83333000"
                    },
                    {
                        "id": 102770,
                        "name": "Zubova Polyana",
                        "latitude": "54.07710000",
                        "longitude": "42.83720000"
                    },
                    {
                        "id": 102772,
                        "name": "Zubovo-Polyanskiy Rayon",
                        "latitude": "54.00000000",
                        "longitude": "42.75000000"
                    },
                    {
                        "id": 102785,
                        "name": "Zykovo",
                        "latitude": "54.06853000",
                        "longitude": "45.08633000"
                    }
                ]
            },
            {
                "id": 1882,
                "name": "Moscow",
                "iso2": "MOS",
                "latitude": "55.34039600",
                "longitude": "38.29176510",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97553,
                        "name": "Alabushevo",
                        "latitude": "56.01667000",
                        "longitude": "37.15000000"
                    },
                    {
                        "id": 97578,
                        "name": "Alekseyevka",
                        "latitude": "55.63000000",
                        "longitude": "37.80000000"
                    },
                    {
                        "id": 97628,
                        "name": "Andreyevka",
                        "latitude": "55.98028000",
                        "longitude": "37.13500000"
                    },
                    {
                        "id": 97630,
                        "name": "Andreyevskoye",
                        "latitude": "55.55487000",
                        "longitude": "37.92566000"
                    },
                    {
                        "id": 97636,
                        "name": "Annino",
                        "latitude": "55.58316000",
                        "longitude": "37.26019000"
                    },
                    {
                        "id": 97650,
                        "name": "Aprelevka",
                        "latitude": "55.55194000",
                        "longitude": "37.08010000"
                    },
                    {
                        "id": 97665,
                        "name": "Arkhangel’skoye",
                        "latitude": "55.85486000",
                        "longitude": "35.32873000"
                    },
                    {
                        "id": 97699,
                        "name": "Ashitkovo",
                        "latitude": "55.45173000",
                        "longitude": "38.59518000"
                    },
                    {
                        "id": 97700,
                        "name": "Ashukino",
                        "latitude": "56.16667000",
                        "longitude": "37.95000000"
                    },
                    {
                        "id": 97710,
                        "name": "Ateptsevo",
                        "latitude": "55.32364000",
                        "longitude": "36.75002000"
                    },
                    {
                        "id": 97722,
                        "name": "Avsyunino",
                        "latitude": "55.56516000",
                        "longitude": "39.12324000"
                    },
                    {
                        "id": 97723,
                        "name": "Avtopoligon",
                        "latitude": "56.34984000",
                        "longitude": "37.32296000"
                    },
                    {
                        "id": 97760,
                        "name": "Bakhchivandzhi",
                        "latitude": "55.88333000",
                        "longitude": "38.08333000"
                    },
                    {
                        "id": 97765,
                        "name": "Baksheyevo",
                        "latitude": "55.70860000",
                        "longitude": "39.87666000"
                    },
                    {
                        "id": 97773,
                        "name": "Balashikha",
                        "latitude": "55.80945000",
                        "longitude": "37.95806000"
                    },
                    {
                        "id": 97774,
                        "name": "Balashikha Urban Okrug",
                        "latitude": "55.83333000",
                        "longitude": "38.00000000"
                    },
                    {
                        "id": 97800,
                        "name": "Barvikha",
                        "latitude": "55.74212000",
                        "longitude": "37.27926000"
                    },
                    {
                        "id": 97803,
                        "name": "Barybino",
                        "latitude": "55.26768000",
                        "longitude": "37.89333000"
                    },
                    {
                        "id": 97858,
                        "name": "Beloomut",
                        "latitude": "54.94478000",
                        "longitude": "39.33941000"
                    },
                    {
                        "id": 97860,
                        "name": "Beloozërskiy",
                        "latitude": "55.45978000",
                        "longitude": "38.44358000"
                    },
                    {
                        "id": 97883,
                        "name": "Belyye Stolby",
                        "latitude": "55.33136000",
                        "longitude": "37.85400000"
                    },
                    {
                        "id": 97931,
                        "name": "Biorki",
                        "latitude": "55.05280000",
                        "longitude": "38.60873000"
                    },
                    {
                        "id": 97939,
                        "name": "Biryulëvo Zapadnoye",
                        "latitude": "55.58766000",
                        "longitude": "37.64282000"
                    },
                    {
                        "id": 97970,
                        "name": "Bogorodskoye",
                        "latitude": "56.55000000",
                        "longitude": "37.88333000"
                    },
                    {
                        "id": 97988,
                        "name": "Bol'shiye Vyazëmy",
                        "latitude": "55.62058000",
                        "longitude": "36.97620000"
                    },
                    {
                        "id": 98000,
                        "name": "Bol’shaya Setun’",
                        "latitude": "55.71667000",
                        "longitude": "37.41667000"
                    },
                    {
                        "id": 98013,
                        "name": "Bol’shoye Gryzlovo",
                        "latitude": "54.80033000",
                        "longitude": "37.63939000"
                    },
                    {
                        "id": 97998,
                        "name": "Bolshevo",
                        "latitude": "55.93486000",
                        "longitude": "37.83002000"
                    },
                    {
                        "id": 98053,
                        "name": "Bratovshchina",
                        "latitude": "56.05000000",
                        "longitude": "37.88333000"
                    },
                    {
                        "id": 98058,
                        "name": "Bronnitsy",
                        "latitude": "55.42112000",
                        "longitude": "38.26188000"
                    },
                    {
                        "id": 98063,
                        "name": "Budenovetc",
                        "latitude": "56.37975000",
                        "longitude": "37.62774000"
                    },
                    {
                        "id": 98098,
                        "name": "Bykovo",
                        "latitude": "55.63614000",
                        "longitude": "38.08027000"
                    },
                    {
                        "id": 98121,
                        "name": "Chashnikovo",
                        "latitude": "56.03333000",
                        "longitude": "37.16667000"
                    },
                    {
                        "id": 98135,
                        "name": "Chekhov",
                        "latitude": "55.14770000",
                        "longitude": "37.47728000"
                    },
                    {
                        "id": 98161,
                        "name": "Cherkizovo",
                        "latitude": "55.97583000",
                        "longitude": "37.78750000"
                    },
                    {
                        "id": 98169,
                        "name": "Chernogolovka",
                        "latitude": "56.00000000",
                        "longitude": "38.36667000"
                    },
                    {
                        "id": 98187,
                        "name": "Cherusti",
                        "latitude": "55.54976000",
                        "longitude": "40.01071000"
                    },
                    {
                        "id": 98207,
                        "name": "Chkalovskiy",
                        "latitude": "55.89534000",
                        "longitude": "38.07763000"
                    },
                    {
                        "id": 98211,
                        "name": "Chornoye",
                        "latitude": "55.74611000",
                        "longitude": "38.06889000"
                    },
                    {
                        "id": 98224,
                        "name": "Chupryakovo",
                        "latitude": "55.55282000",
                        "longitude": "36.62721000"
                    },
                    {
                        "id": 98243,
                        "name": "Danki",
                        "latitude": "54.91806000",
                        "longitude": "37.57009000"
                    },
                    {
                        "id": 98252,
                        "name": "Davydovo",
                        "latitude": "55.60859000",
                        "longitude": "38.86109000"
                    },
                    {
                        "id": 98255,
                        "name": "Dedenëvo",
                        "latitude": "56.24283000",
                        "longitude": "37.51769000"
                    },
                    {
                        "id": 98257,
                        "name": "Dedovsk",
                        "latitude": "55.86861000",
                        "longitude": "37.12222000"
                    },
                    {
                        "id": 98260,
                        "name": "Demikhovo",
                        "latitude": "55.79685000",
                        "longitude": "38.88404000"
                    },
                    {
                        "id": 98285,
                        "name": "Dmitrov",
                        "latitude": "56.34485000",
                        "longitude": "37.52041000"
                    },
                    {
                        "id": 98287,
                        "name": "Dmitrovskiy Pogost",
                        "latitude": "55.31333000",
                        "longitude": "39.83358000"
                    },
                    {
                        "id": 98288,
                        "name": "Dmitrovskiy Rayon",
                        "latitude": "56.35000000",
                        "longitude": "37.58333000"
                    },
                    {
                        "id": 98300,
                        "name": "Dolgoprudnyy",
                        "latitude": "55.94958000",
                        "longitude": "37.50183000"
                    },
                    {
                        "id": 98307,
                        "name": "Domodedovo",
                        "latitude": "55.44130000",
                        "longitude": "37.75367000"
                    },
                    {
                        "id": 98308,
                        "name": "Domodedovskiy Rayon",
                        "latitude": "55.41667000",
                        "longitude": "37.75000000"
                    },
                    {
                        "id": 98320,
                        "name": "Dorogomilovo",
                        "latitude": "55.75000000",
                        "longitude": "37.56667000"
                    },
                    {
                        "id": 98321,
                        "name": "Dorokhovo",
                        "latitude": "55.55056000",
                        "longitude": "36.37444000"
                    },
                    {
                        "id": 98325,
                        "name": "Drezna",
                        "latitude": "55.74208000",
                        "longitude": "38.84753000"
                    },
                    {
                        "id": 98329,
                        "name": "Druzhba",
                        "latitude": "55.88603000",
                        "longitude": "37.74267000"
                    },
                    {
                        "id": 98337,
                        "name": "Dubna",
                        "latitude": "56.73333000",
                        "longitude": "37.16667000"
                    },
                    {
                        "id": 98343,
                        "name": "Dubrovitsy",
                        "latitude": "55.43969000",
                        "longitude": "37.48670000"
                    },
                    {
                        "id": 98368,
                        "name": "Dzerzhinskiy",
                        "latitude": "55.62945000",
                        "longitude": "37.85654000"
                    },
                    {
                        "id": 98371,
                        "name": "Dzerzhinsky",
                        "latitude": "55.62737000",
                        "longitude": "37.85803000"
                    },
                    {
                        "id": 98385,
                        "name": "Elektrogorsk",
                        "latitude": "55.88431000",
                        "longitude": "38.78640000"
                    },
                    {
                        "id": 98386,
                        "name": "Elektrostal’",
                        "latitude": "55.78959000",
                        "longitude": "38.44671000"
                    },
                    {
                        "id": 98387,
                        "name": "Elektrougli",
                        "latitude": "55.72445000",
                        "longitude": "38.20908000"
                    },
                    {
                        "id": 98418,
                        "name": "Fedurnovo",
                        "latitude": "55.75488000",
                        "longitude": "38.04696000"
                    },
                    {
                        "id": 98424,
                        "name": "Fili",
                        "latitude": "55.74819000",
                        "longitude": "37.47969000"
                    },
                    {
                        "id": 98425,
                        "name": "Filimonki",
                        "latitude": "55.55794000",
                        "longitude": "37.34719000"
                    },
                    {
                        "id": 98431,
                        "name": "Firsanovka",
                        "latitude": "55.95361000",
                        "longitude": "37.24083000"
                    },
                    {
                        "id": 98435,
                        "name": "Fosforitnyy",
                        "latitude": "55.32892000",
                        "longitude": "38.89509000"
                    },
                    {
                        "id": 98439,
                        "name": "Fryanovo",
                        "latitude": "56.13333000",
                        "longitude": "38.45000000"
                    },
                    {
                        "id": 98440,
                        "name": "Fryazevo",
                        "latitude": "55.73321000",
                        "longitude": "38.46458000"
                    },
                    {
                        "id": 98441,
                        "name": "Fryazino",
                        "latitude": "55.96056000",
                        "longitude": "38.04556000"
                    },
                    {
                        "id": 98506,
                        "name": "Golitsyno",
                        "latitude": "55.60928000",
                        "longitude": "36.98212000"
                    },
                    {
                        "id": 98527,
                        "name": "Gorki Vtoryye",
                        "latitude": "55.72565000",
                        "longitude": "37.16350000"
                    },
                    {
                        "id": 98528,
                        "name": "Gorki-Leninskiye",
                        "latitude": "55.50855000",
                        "longitude": "37.77618000"
                    },
                    {
                        "id": 98567,
                        "name": "Gorshkovo",
                        "latitude": "56.37561000",
                        "longitude": "37.41240000"
                    },
                    {
                        "id": 98583,
                        "name": "Grebnevo",
                        "latitude": "55.95074000",
                        "longitude": "38.07973000"
                    },
                    {
                        "id": 98625,
                        "name": "Gzhel’",
                        "latitude": "55.61008000",
                        "longitude": "38.39399000"
                    },
                    {
                        "id": 98641,
                        "name": "Iksha",
                        "latitude": "56.17204000",
                        "longitude": "37.49842000"
                    },
                    {
                        "id": 98653,
                        "name": "Il’inskiy",
                        "latitude": "55.61902000",
                        "longitude": "38.11818000"
                    },
                    {
                        "id": 98654,
                        "name": "Il’inskiy Pogost",
                        "latitude": "55.47785000",
                        "longitude": "38.90906000"
                    },
                    {
                        "id": 98657,
                        "name": "Il’inskoye",
                        "latitude": "55.24917000",
                        "longitude": "37.95805000"
                    },
                    {
                        "id": 98668,
                        "name": "Imeni Tsyurupy",
                        "latitude": "55.49567000",
                        "longitude": "38.65064000"
                    },
                    {
                        "id": 98671,
                        "name": "Imeni Vorovskogo",
                        "latitude": "55.73190000",
                        "longitude": "38.32368000"
                    },
                    {
                        "id": 98720,
                        "name": "Istra",
                        "latitude": "55.91997000",
                        "longitude": "36.86867000"
                    },
                    {
                        "id": 98721,
                        "name": "Istrinskiy Rayon",
                        "latitude": "55.88333000",
                        "longitude": "36.93333000"
                    },
                    {
                        "id": 98736,
                        "name": "Ivanteyevka",
                        "latitude": "55.97111000",
                        "longitude": "37.92083000"
                    },
                    {
                        "id": 98754,
                        "name": "Izmaylovo",
                        "latitude": "55.78677000",
                        "longitude": "37.80165000"
                    },
                    {
                        "id": 98763,
                        "name": "Kabanovo",
                        "latitude": "55.74815000",
                        "longitude": "38.93511000"
                    },
                    {
                        "id": 98881,
                        "name": "Karinskoye",
                        "latitude": "55.70969000",
                        "longitude": "36.68903000"
                    },
                    {
                        "id": 98893,
                        "name": "Kashira",
                        "latitude": "54.84444000",
                        "longitude": "38.16694000"
                    },
                    {
                        "id": 98902,
                        "name": "Kastanayevo",
                        "latitude": "55.71667000",
                        "longitude": "37.50000000"
                    },
                    {
                        "id": 98942,
                        "name": "Kerva",
                        "latitude": "55.61167000",
                        "longitude": "39.57665000"
                    },
                    {
                        "id": 98980,
                        "name": "Khimki",
                        "latitude": "55.89704000",
                        "longitude": "37.42969000"
                    },
                    {
                        "id": 98981,
                        "name": "Khimki Urban Okrug",
                        "latitude": "55.91667000",
                        "longitude": "37.41667000"
                    },
                    {
                        "id": 99006,
                        "name": "Khorlovo",
                        "latitude": "55.33270000",
                        "longitude": "38.81365000"
                    },
                    {
                        "id": 99008,
                        "name": "Khoroshëvo-Mnevniki",
                        "latitude": "55.78363000",
                        "longitude": "37.47137000"
                    },
                    {
                        "id": 99010,
                        "name": "Khot'kovo",
                        "latitude": "56.25699000",
                        "longitude": "37.99544000"
                    },
                    {
                        "id": 99035,
                        "name": "Kievskiy",
                        "latitude": "55.42999000",
                        "longitude": "36.86660000"
                    },
                    {
                        "id": 99102,
                        "name": "Klimovsk",
                        "latitude": "55.36352000",
                        "longitude": "37.52984000"
                    },
                    {
                        "id": 99104,
                        "name": "Klin",
                        "latitude": "56.33333000",
                        "longitude": "36.73333000"
                    },
                    {
                        "id": 99105,
                        "name": "Klinskiy Rayon",
                        "latitude": "56.41667000",
                        "longitude": "36.83333000"
                    },
                    {
                        "id": 100783,
                        "name": "Klyazminskoe Reservoir",
                        "latitude": "55.99507000",
                        "longitude": "37.67199000"
                    },
                    {
                        "id": 99141,
                        "name": "Kolomenskiy Rayon",
                        "latitude": "55.08333000",
                        "longitude": "38.75000000"
                    },
                    {
                        "id": 99143,
                        "name": "Kolomna",
                        "latitude": "55.07944000",
                        "longitude": "38.77833000"
                    },
                    {
                        "id": 99152,
                        "name": "Kolyubakino",
                        "latitude": "55.66800000",
                        "longitude": "36.53234000"
                    },
                    {
                        "id": 99166,
                        "name": "Kommunarka",
                        "latitude": "55.56952000",
                        "longitude": "37.48932000"
                    },
                    {
                        "id": 99184,
                        "name": "Konobeyevo",
                        "latitude": "55.40776000",
                        "longitude": "38.66261000"
                    },
                    {
                        "id": 99188,
                        "name": "Konstantinovo",
                        "latitude": "56.55000000",
                        "longitude": "38.03333000"
                    },
                    {
                        "id": 99201,
                        "name": "Koptëvo",
                        "latitude": "55.81667000",
                        "longitude": "37.51667000"
                    },
                    {
                        "id": 99205,
                        "name": "Korenëvo",
                        "latitude": "55.67194000",
                        "longitude": "38.00778000"
                    },
                    {
                        "id": 99214,
                        "name": "Korolev",
                        "latitude": "55.91417000",
                        "longitude": "37.82556000"
                    },
                    {
                        "id": 99215,
                        "name": "Korolyov",
                        "latitude": "55.91732000",
                        "longitude": "37.81786000"
                    },
                    {
                        "id": 99238,
                        "name": "Kostino",
                        "latitude": "56.03333000",
                        "longitude": "37.91667000"
                    },
                    {
                        "id": 99243,
                        "name": "Kostrovo",
                        "latitude": "55.89429000",
                        "longitude": "36.69491000"
                    },
                    {
                        "id": 99245,
                        "name": "Kotel’niki",
                        "latitude": "55.63546000",
                        "longitude": "37.84450000"
                    },
                    {
                        "id": 99264,
                        "name": "Kozhukhovo",
                        "latitude": "55.70000000",
                        "longitude": "37.66667000"
                    },
                    {
                        "id": 99276,
                        "name": "Kraskovo",
                        "latitude": "55.64972000",
                        "longitude": "37.98778000"
                    },
                    {
                        "id": 99285,
                        "name": "Krasnaya Poyma",
                        "latitude": "55.00138000",
                        "longitude": "39.07997000"
                    },
                    {
                        "id": 99291,
                        "name": "Krasnoarmeysk",
                        "latitude": "56.10000000",
                        "longitude": "38.13333000"
                    },
                    {
                        "id": 99303,
                        "name": "Krasnogorsk",
                        "latitude": "55.82036000",
                        "longitude": "37.33017000"
                    },
                    {
                        "id": 99309,
                        "name": "Krasnogorskiy Rayon",
                        "latitude": "55.83333000",
                        "longitude": "37.33333000"
                    },
                    {
                        "id": 99355,
                        "name": "Krasnozavodsk",
                        "latitude": "56.45000000",
                        "longitude": "38.21667000"
                    },
                    {
                        "id": 99357,
                        "name": "Krasnoznamensk",
                        "latitude": "55.59944000",
                        "longitude": "37.03861000"
                    },
                    {
                        "id": 99374,
                        "name": "Krasnyy Tkach",
                        "latitude": "55.47210000",
                        "longitude": "39.08017000"
                    },
                    {
                        "id": 99386,
                        "name": "Kratovo",
                        "latitude": "55.59728000",
                        "longitude": "38.17743000"
                    },
                    {
                        "id": 99394,
                        "name": "Krivtsovo",
                        "latitude": "56.15000000",
                        "longitude": "36.88333000"
                    },
                    {
                        "id": 99416,
                        "name": "Kubinka",
                        "latitude": "55.57957000",
                        "longitude": "36.70392000"
                    },
                    {
                        "id": 99449,
                        "name": "Kupavna",
                        "latitude": "55.74576000",
                        "longitude": "38.13136000"
                    },
                    {
                        "id": 99461,
                        "name": "Kurilovo",
                        "latitude": "55.37271000",
                        "longitude": "37.37703000"
                    },
                    {
                        "id": 99471,
                        "name": "Kurovskoye",
                        "latitude": "55.58183000",
                        "longitude": "38.91994000"
                    },
                    {
                        "id": 99489,
                        "name": "Kuskovo",
                        "latitude": "55.73423000",
                        "longitude": "37.82616000"
                    },
                    {
                        "id": 99728,
                        "name": "L’vovskiy",
                        "latitude": "55.31872000",
                        "longitude": "37.52337000"
                    },
                    {
                        "id": 99573,
                        "name": "Leninskiy Rayon",
                        "latitude": "55.41667000",
                        "longitude": "37.58333000"
                    },
                    {
                        "id": 99575,
                        "name": "Leninskiye Gory",
                        "latitude": "55.70000000",
                        "longitude": "37.56667000"
                    },
                    {
                        "id": 99595,
                        "name": "Lesnoy",
                        "latitude": "56.06667000",
                        "longitude": "37.91667000"
                    },
                    {
                        "id": 99597,
                        "name": "Lesnoy Gorodok",
                        "latitude": "55.63893000",
                        "longitude": "37.20829000"
                    },
                    {
                        "id": 99602,
                        "name": "Lesnyye Polyany",
                        "latitude": "55.96667000",
                        "longitude": "37.86667000"
                    },
                    {
                        "id": 99616,
                        "name": "Levoberezhnyy",
                        "latitude": "55.85000000",
                        "longitude": "37.48333000"
                    },
                    {
                        "id": 99627,
                        "name": "Likino-Dulevo",
                        "latitude": "55.70830000",
                        "longitude": "38.95420000"
                    },
                    {
                        "id": 99646,
                        "name": "Lobnya",
                        "latitude": "56.00972000",
                        "longitude": "37.48194000"
                    },
                    {
                        "id": 99663,
                        "name": "Lopatinskiy",
                        "latitude": "55.34101000",
                        "longitude": "38.72366000"
                    },
                    {
                        "id": 99666,
                        "name": "Losino-Petrovskiy",
                        "latitude": "55.86959000",
                        "longitude": "38.20065000"
                    },
                    {
                        "id": 99669,
                        "name": "Lotoshino",
                        "latitude": "56.23489000",
                        "longitude": "35.64273000"
                    },
                    {
                        "id": 99670,
                        "name": "Lotoshinskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "35.66667000"
                    },
                    {
                        "id": 99676,
                        "name": "Lozhki",
                        "latitude": "56.09387000",
                        "longitude": "37.10873000"
                    },
                    {
                        "id": 99681,
                        "name": "Lugovaya",
                        "latitude": "56.05000000",
                        "longitude": "37.48333000"
                    },
                    {
                        "id": 99684,
                        "name": "Lukhovitsy",
                        "latitude": "54.97661000",
                        "longitude": "39.04440000"
                    },
                    {
                        "id": 99711,
                        "name": "Lytkarino",
                        "latitude": "55.58271000",
                        "longitude": "37.90516000"
                    },
                    {
                        "id": 99713,
                        "name": "Lyuberetskiy Rayon",
                        "latitude": "55.66667000",
                        "longitude": "37.91667000"
                    },
                    {
                        "id": 99714,
                        "name": "Lyubertsy",
                        "latitude": "55.67719000",
                        "longitude": "37.89322000"
                    },
                    {
                        "id": 99721,
                        "name": "Lyubuchany",
                        "latitude": "55.25088000",
                        "longitude": "37.54988000"
                    },
                    {
                        "id": 99749,
                        "name": "Malakhovka",
                        "latitude": "55.64776000",
                        "longitude": "38.02486000"
                    },
                    {
                        "id": 99750,
                        "name": "Malaya Dubna",
                        "latitude": "55.87783000",
                        "longitude": "38.95423000"
                    },
                    {
                        "id": 99756,
                        "name": "Malino",
                        "latitude": "55.11195000",
                        "longitude": "38.17384000"
                    },
                    {
                        "id": 99772,
                        "name": "Malyshevo",
                        "latitude": "55.49450000",
                        "longitude": "38.35356000"
                    },
                    {
                        "id": 99778,
                        "name": "Mamontovka",
                        "latitude": "55.98083000",
                        "longitude": "37.81972000"
                    },
                    {
                        "id": 99791,
                        "name": "Marfino",
                        "latitude": "55.70267000",
                        "longitude": "37.38322000"
                    },
                    {
                        "id": 99847,
                        "name": "Medvezh’i Ozëra",
                        "latitude": "55.86935000",
                        "longitude": "37.98613000"
                    },
                    {
                        "id": 99856,
                        "name": "Melikhovo",
                        "latitude": "55.11440000",
                        "longitude": "37.64827000"
                    },
                    {
                        "id": 99861,
                        "name": "Mendeleyevo",
                        "latitude": "56.03333000",
                        "longitude": "37.21667000"
                    },
                    {
                        "id": 99868,
                        "name": "Meshcherino",
                        "latitude": "55.19567000",
                        "longitude": "38.36002000"
                    },
                    {
                        "id": 99907,
                        "name": "Mikhnëvo",
                        "latitude": "55.12747000",
                        "longitude": "37.95451000"
                    },
                    {
                        "id": 99908,
                        "name": "Mikulino",
                        "latitude": "56.45188000",
                        "longitude": "35.60685000"
                    },
                    {
                        "id": 99927,
                        "name": "Misheronskiy",
                        "latitude": "55.71927000",
                        "longitude": "39.73835000"
                    },
                    {
                        "id": 99953,
                        "name": "Molokovo",
                        "latitude": "55.56186000",
                        "longitude": "37.86492000"
                    },
                    {
                        "id": 99959,
                        "name": "Monino",
                        "latitude": "55.84244000",
                        "longitude": "38.19362000"
                    },
                    {
                        "id": 99980,
                        "name": "Mosrentgen",
                        "latitude": "55.61970000",
                        "longitude": "37.46402000"
                    },
                    {
                        "id": 99985,
                        "name": "Mozhaysk",
                        "latitude": "55.50194000",
                        "longitude": "36.02722000"
                    },
                    {
                        "id": 99986,
                        "name": "Mozhayskiy Rayon",
                        "latitude": "55.50000000",
                        "longitude": "36.00000000"
                    },
                    {
                        "id": 100004,
                        "name": "Muranovo",
                        "latitude": "56.18333000",
                        "longitude": "37.90000000"
                    },
                    {
                        "id": 100034,
                        "name": "Mytishchi",
                        "latitude": "55.91163000",
                        "longitude": "37.73076000"
                    },
                    {
                        "id": 100035,
                        "name": "Mytishchi Urban Okrug",
                        "latitude": "56.00000000",
                        "longitude": "37.66667000"
                    },
                    {
                        "id": 100051,
                        "name": "Nakhabino",
                        "latitude": "55.84854000",
                        "longitude": "37.17789000"
                    },
                    {
                        "id": 100059,
                        "name": "Naro-Fominsk",
                        "latitude": "55.38752000",
                        "longitude": "36.73307000"
                    },
                    {
                        "id": 100074,
                        "name": "Nazar'yevo",
                        "latitude": "55.67417000",
                        "longitude": "37.04028000"
                    },
                    {
                        "id": 100094,
                        "name": "Nekrasovskiy",
                        "latitude": "56.09349000",
                        "longitude": "37.49934000"
                    },
                    {
                        "id": 100102,
                        "name": "Nemchinovka",
                        "latitude": "55.72288000",
                        "longitude": "37.36086000"
                    },
                    {
                        "id": 100139,
                        "name": "Nikolina Gora",
                        "latitude": "55.73433000",
                        "longitude": "37.04364000"
                    },
                    {
                        "id": 100191,
                        "name": "Noginsk",
                        "latitude": "55.86647000",
                        "longitude": "38.44380000"
                    },
                    {
                        "id": 100192,
                        "name": "Noginsk-9",
                        "latitude": "56.06681000",
                        "longitude": "38.50013000"
                    },
                    {
                        "id": 100193,
                        "name": "Noginskiy Rayon",
                        "latitude": "55.91667000",
                        "longitude": "38.41667000"
                    },
                    {
                        "id": 100218,
                        "name": "Novo-Nikol’skoye",
                        "latitude": "56.56667000",
                        "longitude": "37.53333000"
                    },
                    {
                        "id": 100246,
                        "name": "Novoivanovskoye",
                        "latitude": "55.70381000",
                        "longitude": "37.36510000"
                    },
                    {
                        "id": 100280,
                        "name": "Novopetrovskoye",
                        "latitude": "55.99278000",
                        "longitude": "36.47194000"
                    },
                    {
                        "id": 100283,
                        "name": "Novopodrezkovo",
                        "latitude": "55.93972000",
                        "longitude": "37.34417000"
                    },
                    {
                        "id": 100307,
                        "name": "Novosin’kovo",
                        "latitude": "56.37737000",
                        "longitude": "37.32871000"
                    },
                    {
                        "id": 100331,
                        "name": "Novoye",
                        "latitude": "55.63104000",
                        "longitude": "38.92001000"
                    },
                    {
                        "id": 100341,
                        "name": "Novyy Byt",
                        "latitude": "55.05857000",
                        "longitude": "37.61348000"
                    },
                    {
                        "id": 100367,
                        "name": "Nudol’",
                        "latitude": "56.10000000",
                        "longitude": "36.51667000"
                    },
                    {
                        "id": 100387,
                        "name": "Obolensk",
                        "latitude": "54.97741000",
                        "longitude": "37.22449000"
                    },
                    {
                        "id": 100391,
                        "name": "Obukhovo",
                        "latitude": "55.83278000",
                        "longitude": "38.27250000"
                    },
                    {
                        "id": 100398,
                        "name": "Odintsovo",
                        "latitude": "55.67798000",
                        "longitude": "37.27773000"
                    },
                    {
                        "id": 100399,
                        "name": "Odintsovskiy Rayon",
                        "latitude": "55.66667000",
                        "longitude": "36.91667000"
                    },
                    {
                        "id": 100412,
                        "name": "Oktyabr’skiy",
                        "latitude": "55.60806000",
                        "longitude": "37.97738000"
                    },
                    {
                        "id": 100418,
                        "name": "Ol'yavidovo",
                        "latitude": "56.50330000",
                        "longitude": "37.75160000"
                    },
                    {
                        "id": 100452,
                        "name": "Opalikha",
                        "latitude": "55.82593000",
                        "longitude": "37.25278000"
                    },
                    {
                        "id": 100463,
                        "name": "Orekhovo-Zuyevo",
                        "latitude": "55.80672000",
                        "longitude": "38.96178000"
                    },
                    {
                        "id": 100464,
                        "name": "Orekhovo-Zuyevskiy Rayon",
                        "latitude": "55.75000000",
                        "longitude": "39.00000000"
                    },
                    {
                        "id": 100481,
                        "name": "Orud’yevo",
                        "latitude": "56.43333000",
                        "longitude": "37.53333000"
                    },
                    {
                        "id": 100493,
                        "name": "Ostashëvo",
                        "latitude": "55.85896000",
                        "longitude": "35.86948000"
                    },
                    {
                        "id": 100501,
                        "name": "Ostrovtsy",
                        "latitude": "55.58750000",
                        "longitude": "38.00556000"
                    },
                    {
                        "id": 100525,
                        "name": "Ozëry",
                        "latitude": "54.85998000",
                        "longitude": "38.55062000"
                    },
                    {
                        "id": 100521,
                        "name": "Ozherel’ye",
                        "latitude": "54.79197000",
                        "longitude": "38.26559000"
                    },
                    {
                        "id": 100522,
                        "name": "Ozyory Urban Okrug",
                        "latitude": "54.83333000",
                        "longitude": "38.58333000"
                    },
                    {
                        "id": 100575,
                        "name": "Pavlovskaya Sloboda",
                        "latitude": "55.81517000",
                        "longitude": "37.08246000"
                    },
                    {
                        "id": 100577,
                        "name": "Pavlovskiy Posad",
                        "latitude": "55.78187000",
                        "longitude": "38.65025000"
                    },
                    {
                        "id": 100583,
                        "name": "Pavshino",
                        "latitude": "55.81667000",
                        "longitude": "37.35000000"
                    },
                    {
                        "id": 100606,
                        "name": "Peresvet",
                        "latitude": "56.42302000",
                        "longitude": "38.17612000"
                    },
                    {
                        "id": 100619,
                        "name": "Pervomayskiy",
                        "latitude": "55.06696000",
                        "longitude": "38.66489000"
                    },
                    {
                        "id": 100632,
                        "name": "Peshki",
                        "latitude": "56.13333000",
                        "longitude": "37.06667000"
                    },
                    {
                        "id": 100634,
                        "name": "Peski",
                        "latitude": "55.21626000",
                        "longitude": "38.76262000"
                    },
                    {
                        "id": 100657,
                        "name": "Petrovo-Dal’neye",
                        "latitude": "55.74679000",
                        "longitude": "37.17347000"
                    },
                    {
                        "id": 100661,
                        "name": "Petrovskaya",
                        "latitude": "55.55000000",
                        "longitude": "37.78333000"
                    },
                    {
                        "id": 100683,
                        "name": "Pirogovskiy",
                        "latitude": "55.97806000",
                        "longitude": "37.73361000"
                    },
                    {
                        "id": 100724,
                        "name": "Podolsk",
                        "latitude": "55.42419000",
                        "longitude": "37.55472000"
                    },
                    {
                        "id": 100725,
                        "name": "Podosinki",
                        "latitude": "56.20837000",
                        "longitude": "37.54741000"
                    },
                    {
                        "id": 100772,
                        "name": "Popovo",
                        "latitude": "55.07523000",
                        "longitude": "37.66727000"
                    },
                    {
                        "id": 100788,
                        "name": "Posëlok Mar’ino",
                        "latitude": "55.55000000",
                        "longitude": "37.32000000"
                    },
                    {
                        "id": 100790,
                        "name": "Povarovo",
                        "latitude": "56.06667000",
                        "longitude": "37.05000000"
                    },
                    {
                        "id": 100791,
                        "name": "Povedniki",
                        "latitude": "55.97000000",
                        "longitude": "37.60000000"
                    },
                    {
                        "id": 100803,
                        "name": "Pravdinskiy",
                        "latitude": "56.06034000",
                        "longitude": "37.86266000"
                    },
                    {
                        "id": 100865,
                        "name": "Proletarskiy",
                        "latitude": "55.02219000",
                        "longitude": "37.39019000"
                    },
                    {
                        "id": 100871,
                        "name": "Protvino",
                        "latitude": "54.86821000",
                        "longitude": "37.21583000"
                    },
                    {
                        "id": 100894,
                        "name": "Purshevo",
                        "latitude": "55.72124000",
                        "longitude": "38.03277000"
                    },
                    {
                        "id": 100895,
                        "name": "Pushchino",
                        "latitude": "54.83373000",
                        "longitude": "37.61138000"
                    },
                    {
                        "id": 100898,
                        "name": "Pushkino",
                        "latitude": "56.01722000",
                        "longitude": "37.86667000"
                    },
                    {
                        "id": 100900,
                        "name": "Pushkinskiy Rayon",
                        "latitude": "55.98633000",
                        "longitude": "37.86122000"
                    },
                    {
                        "id": 100925,
                        "name": "Radovitskiy",
                        "latitude": "55.12820000",
                        "longitude": "39.79560000"
                    },
                    {
                        "id": 100926,
                        "name": "Radumlya",
                        "latitude": "56.06901000",
                        "longitude": "37.14979000"
                    },
                    {
                        "id": 100928,
                        "name": "Raduzhnyy",
                        "latitude": "55.13680000",
                        "longitude": "38.72803000"
                    },
                    {
                        "id": 100931,
                        "name": "Rakhmanovo",
                        "latitude": "55.74401000",
                        "longitude": "38.61124000"
                    },
                    {
                        "id": 100935,
                        "name": "Ramenskiy Rayon",
                        "latitude": "55.56667000",
                        "longitude": "38.23333000"
                    },
                    {
                        "id": 100936,
                        "name": "Ramenskoye",
                        "latitude": "55.56694000",
                        "longitude": "38.23028000"
                    },
                    {
                        "id": 100953,
                        "name": "Razvilka",
                        "latitude": "55.59209000",
                        "longitude": "37.74085000"
                    },
                    {
                        "id": 100956,
                        "name": "Rechitsy",
                        "latitude": "55.59754000",
                        "longitude": "38.47134000"
                    },
                    {
                        "id": 100965,
                        "name": "Reshetnikovo",
                        "latitude": "56.45000000",
                        "longitude": "36.56667000"
                    },
                    {
                        "id": 100967,
                        "name": "Reutov",
                        "latitude": "55.76111000",
                        "longitude": "37.85750000"
                    },
                    {
                        "id": 100978,
                        "name": "Rodniki",
                        "latitude": "55.65204000",
                        "longitude": "38.06685000"
                    },
                    {
                        "id": 100981,
                        "name": "Rogachëvo",
                        "latitude": "56.43333000",
                        "longitude": "37.16667000"
                    },
                    {
                        "id": 100997,
                        "name": "Roshal’",
                        "latitude": "55.66853000",
                        "longitude": "39.87488000"
                    },
                    {
                        "id": 101014,
                        "name": "Rozhdestveno",
                        "latitude": "55.85444000",
                        "longitude": "37.04935000"
                    },
                    {
                        "id": 101027,
                        "name": "Rumyantsevo",
                        "latitude": "55.97278000",
                        "longitude": "36.53417000"
                    },
                    {
                        "id": 101037,
                        "name": "Ruza",
                        "latitude": "55.69898000",
                        "longitude": "36.19522000"
                    },
                    {
                        "id": 101040,
                        "name": "Ruzskiy Rayon",
                        "latitude": "55.70000000",
                        "longitude": "36.25000000"
                    },
                    {
                        "id": 101054,
                        "name": "Rybnoye",
                        "latitude": "56.41349000",
                        "longitude": "37.62180000"
                    },
                    {
                        "id": 101059,
                        "name": "Rzhavki",
                        "latitude": "56.00000000",
                        "longitude": "37.25000000"
                    },
                    {
                        "id": 101081,
                        "name": "Saltykovka",
                        "latitude": "55.76679000",
                        "longitude": "37.93533000"
                    },
                    {
                        "id": 101136,
                        "name": "Savinskaya",
                        "latitude": "55.37013000",
                        "longitude": "39.99233000"
                    },
                    {
                        "id": 101138,
                        "name": "Savvinskaya Sloboda",
                        "latitude": "55.72343000",
                        "longitude": "36.80347000"
                    },
                    {
                        "id": 101160,
                        "name": "Selyatino",
                        "latitude": "55.51514000",
                        "longitude": "36.97746000"
                    },
                    {
                        "id": 101170,
                        "name": "Semënovskoye",
                        "latitude": "55.68333000",
                        "longitude": "37.55000000"
                    },
                    {
                        "id": 101168,
                        "name": "Semkhoz",
                        "latitude": "56.28333000",
                        "longitude": "38.06667000"
                    },
                    {
                        "id": 101175,
                        "name": "Serebryano-Prudskiy Rayon",
                        "latitude": "54.50000000",
                        "longitude": "38.66667000"
                    },
                    {
                        "id": 101177,
                        "name": "Serebryanyye Prudy",
                        "latitude": "54.46923000",
                        "longitude": "38.72095000"
                    },
                    {
                        "id": 101182,
                        "name": "Sergiyev Posad",
                        "latitude": "56.30000000",
                        "longitude": "38.13333000"
                    },
                    {
                        "id": 101183,
                        "name": "Sergiyevo-Posadskiy Rayon",
                        "latitude": "56.33333000",
                        "longitude": "38.16667000"
                    },
                    {
                        "id": 101191,
                        "name": "Serpukhov",
                        "latitude": "54.91578000",
                        "longitude": "37.41114000"
                    },
                    {
                        "id": 101192,
                        "name": "Serpukhovskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "37.41667000"
                    },
                    {
                        "id": 101207,
                        "name": "Severnyy",
                        "latitude": "56.73333000",
                        "longitude": "37.65000000"
                    },
                    {
                        "id": 101232,
                        "name": "Shaburnovo",
                        "latitude": "56.55000000",
                        "longitude": "37.93333000"
                    },
                    {
                        "id": 101237,
                        "name": "Shakhovskaya",
                        "latitude": "56.03147000",
                        "longitude": "35.50697000"
                    },
                    {
                        "id": 101238,
                        "name": "Shakhovskoy Rayon",
                        "latitude": "56.00192000",
                        "longitude": "35.49537000"
                    },
                    {
                        "id": 101272,
                        "name": "Shatura",
                        "latitude": "55.57253000",
                        "longitude": "39.53682000"
                    },
                    {
                        "id": 101273,
                        "name": "Shaturtorf",
                        "latitude": "55.56711000",
                        "longitude": "39.42129000"
                    },
                    {
                        "id": 101275,
                        "name": "Shchelkovo",
                        "latitude": "55.92497000",
                        "longitude": "37.97218000"
                    },
                    {
                        "id": 101281,
                        "name": "Shchëlkovskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "38.16667000"
                    },
                    {
                        "id": 101299,
                        "name": "Shemëtovo",
                        "latitude": "56.52764000",
                        "longitude": "38.07518000"
                    },
                    {
                        "id": 101306,
                        "name": "Sheremet’yevskiy",
                        "latitude": "55.97583000",
                        "longitude": "37.49417000"
                    },
                    {
                        "id": 101308,
                        "name": "Shevlyakovo",
                        "latitude": "56.39733000",
                        "longitude": "36.85973000"
                    },
                    {
                        "id": 101332,
                        "name": "Shishkin Les",
                        "latitude": "55.41057000",
                        "longitude": "37.18853000"
                    },
                    {
                        "id": 101387,
                        "name": "Skhodnya",
                        "latitude": "55.94806000",
                        "longitude": "37.29778000"
                    },
                    {
                        "id": 101388,
                        "name": "Skolkovo",
                        "latitude": "55.68784000",
                        "longitude": "37.36836000"
                    },
                    {
                        "id": 101391,
                        "name": "Skoropuskovskiy",
                        "latitude": "56.36667000",
                        "longitude": "38.16667000"
                    },
                    {
                        "id": 101422,
                        "name": "Snegiri",
                        "latitude": "55.88867000",
                        "longitude": "37.02421000"
                    },
                    {
                        "id": 101430,
                        "name": "Sofrino",
                        "latitude": "56.15000000",
                        "longitude": "37.93333000"
                    },
                    {
                        "id": 101453,
                        "name": "Solnechnogorsk",
                        "latitude": "56.18333000",
                        "longitude": "36.98333000"
                    },
                    {
                        "id": 101454,
                        "name": "Solnechnogorskiy Rayon",
                        "latitude": "56.08333000",
                        "longitude": "37.08333000"
                    },
                    {
                        "id": 101525,
                        "name": "Spas-Zaulok",
                        "latitude": "56.48333000",
                        "longitude": "36.56667000"
                    },
                    {
                        "id": 101560,
                        "name": "Staraya Kupavna",
                        "latitude": "55.80799000",
                        "longitude": "38.18050000"
                    },
                    {
                        "id": 101622,
                        "name": "Stolbovaya",
                        "latitude": "55.25021000",
                        "longitude": "37.49249000"
                    },
                    {
                        "id": 101632,
                        "name": "Stromyn’",
                        "latitude": "56.04347000",
                        "longitude": "38.48318000"
                    },
                    {
                        "id": 101638,
                        "name": "Stupino",
                        "latitude": "54.90083000",
                        "longitude": "38.07083000"
                    },
                    {
                        "id": 101639,
                        "name": "Stupinskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "38.08333000"
                    },
                    {
                        "id": 101695,
                        "name": "Svatkovo",
                        "latitude": "56.38333000",
                        "longitude": "38.21667000"
                    },
                    {
                        "id": 101698,
                        "name": "Sverdlovskiy",
                        "latitude": "55.90968000",
                        "longitude": "38.14978000"
                    },
                    {
                        "id": 101723,
                        "name": "Sychëvo",
                        "latitude": "55.06196000",
                        "longitude": "38.71384000"
                    },
                    {
                        "id": 101750,
                        "name": "Taldom",
                        "latitude": "56.73333000",
                        "longitude": "37.53333000"
                    },
                    {
                        "id": 101751,
                        "name": "Taldomskiy Rayon",
                        "latitude": "56.75000000",
                        "longitude": "37.58333000"
                    },
                    {
                        "id": 101769,
                        "name": "Tarasovka",
                        "latitude": "55.95722000",
                        "longitude": "37.84333000"
                    },
                    {
                        "id": 101841,
                        "name": "Teryayevo",
                        "latitude": "56.16974000",
                        "longitude": "36.12545000"
                    },
                    {
                        "id": 101884,
                        "name": "Tomilino",
                        "latitude": "55.65619000",
                        "longitude": "37.94713000"
                    },
                    {
                        "id": 101922,
                        "name": "Troitskoye",
                        "latitude": "55.30000000",
                        "longitude": "38.53333000"
                    },
                    {
                        "id": 101960,
                        "name": "Tuchkovo",
                        "latitude": "55.60111000",
                        "longitude": "36.46806000"
                    },
                    {
                        "id": 101961,
                        "name": "Tugolesskiy Bor",
                        "latitude": "55.55051000",
                        "longitude": "39.82422000"
                    },
                    {
                        "id": 102021,
                        "name": "Udel’naya",
                        "latitude": "55.62536000",
                        "longitude": "38.00285000"
                    },
                    {
                        "id": 102154,
                        "name": "Uvarovka",
                        "latitude": "55.52778000",
                        "longitude": "35.60611000"
                    },
                    {
                        "id": 102167,
                        "name": "Uzunovo",
                        "latitude": "54.53858000",
                        "longitude": "38.61734000"
                    },
                    {
                        "id": 102227,
                        "name": "Verbilki",
                        "latitude": "56.53333000",
                        "longitude": "37.60000000"
                    },
                    {
                        "id": 102229,
                        "name": "Vereya",
                        "latitude": "55.34472000",
                        "longitude": "36.17194000"
                    },
                    {
                        "id": 102302,
                        "name": "Vidnoye",
                        "latitude": "55.55239000",
                        "longitude": "37.70967000"
                    },
                    {
                        "id": 102314,
                        "name": "Vinogradovo",
                        "latitude": "56.93333000",
                        "longitude": "37.55000000"
                    },
                    {
                        "id": 102317,
                        "name": "Vishnyakovskiye Dachi",
                        "latitude": "55.76470000",
                        "longitude": "38.13334000"
                    },
                    {
                        "id": 102332,
                        "name": "Vniissok",
                        "latitude": "55.65639000",
                        "longitude": "37.21194000"
                    },
                    {
                        "id": 102353,
                        "name": "Volodarskogo",
                        "latitude": "55.50349000",
                        "longitude": "37.94174000"
                    },
                    {
                        "id": 102356,
                        "name": "Volokolamsk",
                        "latitude": "56.03361000",
                        "longitude": "35.96944000"
                    },
                    {
                        "id": 102357,
                        "name": "Volokolamskiy Rayon",
                        "latitude": "56.08886000",
                        "longitude": "35.99248000"
                    },
                    {
                        "id": 102388,
                        "name": "Voskresensk",
                        "latitude": "55.31733000",
                        "longitude": "38.65264000"
                    },
                    {
                        "id": 102390,
                        "name": "Voskresenskiy Rayon",
                        "latitude": "55.33333000",
                        "longitude": "38.75000000"
                    },
                    {
                        "id": 102402,
                        "name": "Vostryakovo",
                        "latitude": "55.66667000",
                        "longitude": "37.45000000"
                    },
                    {
                        "id": 102449,
                        "name": "Vysokovsk",
                        "latitude": "56.31667000",
                        "longitude": "36.55000000"
                    },
                    {
                        "id": 102465,
                        "name": "Yakhroma",
                        "latitude": "56.30000000",
                        "longitude": "37.48333000"
                    },
                    {
                        "id": 102471,
                        "name": "Yakovlevskoye",
                        "latitude": "55.44194000",
                        "longitude": "37.94806000"
                    },
                    {
                        "id": 102477,
                        "name": "Yam",
                        "latitude": "55.48785000",
                        "longitude": "37.74458000"
                    },
                    {
                        "id": 102479,
                        "name": "Yamkino",
                        "latitude": "55.92088000",
                        "longitude": "38.40417000"
                    },
                    {
                        "id": 102497,
                        "name": "Yaropolets",
                        "latitude": "56.13333000",
                        "longitude": "35.83317000"
                    },
                    {
                        "id": 102525,
                        "name": "Yegor’yevsk",
                        "latitude": "55.38283000",
                        "longitude": "39.03233000"
                    },
                    {
                        "id": 102549,
                        "name": "Yel’digino",
                        "latitude": "56.11667000",
                        "longitude": "37.81667000"
                    },
                    {
                        "id": 102569,
                        "name": "Yermolino",
                        "latitude": "56.14887000",
                        "longitude": "37.49112000"
                    },
                    {
                        "id": 102573,
                        "name": "Yershovo",
                        "latitude": "55.76911000",
                        "longitude": "36.85929000"
                    },
                    {
                        "id": 102583,
                        "name": "Yubileyny",
                        "latitude": "55.93333000",
                        "longitude": "37.83333000"
                    },
                    {
                        "id": 102628,
                        "name": "Zagoryanskiy",
                        "latitude": "55.93250000",
                        "longitude": "37.95806000"
                    },
                    {
                        "id": 102649,
                        "name": "Zaprudnya",
                        "latitude": "56.56667000",
                        "longitude": "37.43333000"
                    },
                    {
                        "id": 102650,
                        "name": "Zaraysk",
                        "latitude": "54.76050000",
                        "longitude": "38.87841000"
                    },
                    {
                        "id": 102656,
                        "name": "Zarech’ye",
                        "latitude": "55.68667000",
                        "longitude": "37.39240000"
                    },
                    {
                        "id": 102663,
                        "name": "Zarya",
                        "latitude": "55.75533000",
                        "longitude": "38.09578000"
                    },
                    {
                        "id": 102700,
                        "name": "Zelenogradskiy",
                        "latitude": "56.10000000",
                        "longitude": "37.91667000"
                    },
                    {
                        "id": 102715,
                        "name": "Zhavoronki",
                        "latitude": "55.64943000",
                        "longitude": "37.10101000"
                    },
                    {
                        "id": 102717,
                        "name": "Zheleznodorozhnyy",
                        "latitude": "55.74400000",
                        "longitude": "38.01684000"
                    },
                    {
                        "id": 102732,
                        "name": "Zhilëvo",
                        "latitude": "55.01408000",
                        "longitude": "38.01106000"
                    },
                    {
                        "id": 102737,
                        "name": "Zhitnevo",
                        "latitude": "55.34233000",
                        "longitude": "37.91464000"
                    },
                    {
                        "id": 102740,
                        "name": "Zhukovka",
                        "latitude": "56.48333000",
                        "longitude": "37.51667000"
                    },
                    {
                        "id": 102743,
                        "name": "Zhukovskiy",
                        "latitude": "55.59528000",
                        "longitude": "38.12028000"
                    },
                    {
                        "id": 102778,
                        "name": "Zvenigorod",
                        "latitude": "55.73401000",
                        "longitude": "36.85918000"
                    }
                ]
            },
            {
                "id": 1901,
                "name": "Moscow",
                "iso2": "MOW",
                "latitude": "55.75582600",
                "longitude": "37.61729990",
                "type": "autonomous city",
                "cities": [
                    {
                        "id": 97605,
                        "name": "Altuf’yevskiy",
                        "latitude": "55.88333000",
                        "longitude": "37.58333000"
                    },
                    {
                        "id": 97613,
                        "name": "Amin’yevo",
                        "latitude": "55.70000000",
                        "longitude": "37.46667000"
                    },
                    {
                        "id": 97634,
                        "name": "Annino",
                        "latitude": "55.58333000",
                        "longitude": "37.60000000"
                    },
                    {
                        "id": 97744,
                        "name": "Babushkin",
                        "latitude": "55.86931000",
                        "longitude": "37.72966000"
                    },
                    {
                        "id": 97924,
                        "name": "Bibirevo",
                        "latitude": "55.88333000",
                        "longitude": "37.60000000"
                    },
                    {
                        "id": 97938,
                        "name": "Biryulëvo",
                        "latitude": "55.58635000",
                        "longitude": "37.67781000"
                    },
                    {
                        "id": 97971,
                        "name": "Bogorodskoye",
                        "latitude": "55.81353000",
                        "longitude": "37.71617000"
                    },
                    {
                        "id": 98052,
                        "name": "Brateyevo",
                        "latitude": "55.63755000",
                        "longitude": "37.76438000"
                    },
                    {
                        "id": 98190,
                        "name": "Cherëmushki",
                        "latitude": "55.66473000",
                        "longitude": "37.56135000"
                    },
                    {
                        "id": 98185,
                        "name": "Chertanovo Yuzhnoye",
                        "latitude": "55.59072000",
                        "longitude": "37.59519000"
                    },
                    {
                        "id": 98250,
                        "name": "Davydkovo",
                        "latitude": "55.71815000",
                        "longitude": "37.47271000"
                    },
                    {
                        "id": 98514,
                        "name": "Gol’yanovo",
                        "latitude": "55.82299000",
                        "longitude": "37.81306000"
                    },
                    {
                        "id": 98509,
                        "name": "Golovinskiy",
                        "latitude": "55.85381000",
                        "longitude": "37.49604000"
                    },
                    {
                        "id": 98735,
                        "name": "Ivanovskoye",
                        "latitude": "55.76667000",
                        "longitude": "37.83333000"
                    },
                    {
                        "id": 98848,
                        "name": "Kapotnya",
                        "latitude": "55.63806000",
                        "longitude": "37.79306000"
                    },
                    {
                        "id": 99132,
                        "name": "Kokoshkino",
                        "latitude": "55.59769000",
                        "longitude": "37.16950000"
                    },
                    {
                        "id": 99142,
                        "name": "Kolomenskoye",
                        "latitude": "55.66667000",
                        "longitude": "37.68333000"
                    },
                    {
                        "id": 99248,
                        "name": "Kotlovka",
                        "latitude": "55.65928000",
                        "longitude": "37.60404000"
                    },
                    {
                        "id": 99262,
                        "name": "Kozeyevo",
                        "latitude": "55.86667000",
                        "longitude": "37.61667000"
                    },
                    {
                        "id": 99281,
                        "name": "Krasnaya Pahra",
                        "latitude": "55.43223000",
                        "longitude": "37.26966000"
                    },
                    {
                        "id": 99482,
                        "name": "Kur’yanovo",
                        "latitude": "55.65000000",
                        "longitude": "37.70000000"
                    },
                    {
                        "id": 99511,
                        "name": "Kuz’minki",
                        "latitude": "55.70000000",
                        "longitude": "37.80000000"
                    },
                    {
                        "id": 99561,
                        "name": "Lefortovo",
                        "latitude": "55.76667000",
                        "longitude": "37.70000000"
                    },
                    {
                        "id": 99582,
                        "name": "Leonovo",
                        "latitude": "55.85000000",
                        "longitude": "37.65000000"
                    },
                    {
                        "id": 99621,
                        "name": "Lianozovo",
                        "latitude": "55.89783000",
                        "longitude": "37.58680000"
                    },
                    {
                        "id": 99622,
                        "name": "Likhobory",
                        "latitude": "55.85000000",
                        "longitude": "37.56667000"
                    },
                    {
                        "id": 99529,
                        "name": "LMS",
                        "latitude": "55.31425000",
                        "longitude": "37.18546000"
                    },
                    {
                        "id": 99696,
                        "name": "Luzhniki",
                        "latitude": "55.71599000",
                        "longitude": "37.55376000"
                    },
                    {
                        "id": 99718,
                        "name": "Lyublino",
                        "latitude": "55.67738000",
                        "longitude": "37.76005000"
                    },
                    {
                        "id": 99808,
                        "name": "Mar’ino",
                        "latitude": "55.65000000",
                        "longitude": "37.71667000"
                    },
                    {
                        "id": 99817,
                        "name": "Matveyevskoye",
                        "latitude": "55.71112000",
                        "longitude": "37.47502000"
                    },
                    {
                        "id": 99874,
                        "name": "Metrogorodok",
                        "latitude": "55.80961000",
                        "longitude": "37.78739000"
                    },
                    {
                        "id": 99894,
                        "name": "Mikhalkovo",
                        "latitude": "55.68333000",
                        "longitude": "37.43333000"
                    },
                    {
                        "id": 99972,
                        "name": "Moscow",
                        "latitude": "55.75222000",
                        "longitude": "37.61556000"
                    },
                    {
                        "id": 99977,
                        "name": "Moskovskiy",
                        "latitude": "55.59911000",
                        "longitude": "37.35495000"
                    },
                    {
                        "id": 100046,
                        "name": "Nagornyy",
                        "latitude": "55.65000000",
                        "longitude": "37.61667000"
                    },
                    {
                        "id": 100091,
                        "name": "Nekrasovka",
                        "latitude": "55.69328000",
                        "longitude": "37.91148000"
                    },
                    {
                        "id": 100147,
                        "name": "Nikol’skoye",
                        "latitude": "55.68333000",
                        "longitude": "37.48333000"
                    },
                    {
                        "id": 100148,
                        "name": "Nikulino",
                        "latitude": "55.66943000",
                        "longitude": "37.46598000"
                    },
                    {
                        "id": 100219,
                        "name": "Novo-Peredelkino",
                        "latitude": "55.64528000",
                        "longitude": "37.33583000"
                    },
                    {
                        "id": 100243,
                        "name": "Novogireyevo",
                        "latitude": "55.75378000",
                        "longitude": "37.81885000"
                    },
                    {
                        "id": 100250,
                        "name": "Novokhovrino",
                        "latitude": "55.86667000",
                        "longitude": "37.50000000"
                    },
                    {
                        "id": 100259,
                        "name": "Novokuz’minki",
                        "latitude": "55.71667000",
                        "longitude": "37.78333000"
                    },
                    {
                        "id": 100328,
                        "name": "Novovladykino",
                        "latitude": "55.85000000",
                        "longitude": "37.58333000"
                    },
                    {
                        "id": 100358,
                        "name": "Novyye Cherëmushki",
                        "latitude": "55.70000000",
                        "longitude": "37.58333000"
                    },
                    {
                        "id": 100360,
                        "name": "Novyye Kuz’minki",
                        "latitude": "55.70000000",
                        "longitude": "37.75000000"
                    },
                    {
                        "id": 100395,
                        "name": "Ochakovo-Matveyevskoye",
                        "latitude": "55.68432000",
                        "longitude": "37.44654000"
                    },
                    {
                        "id": 100461,
                        "name": "Orekhovo-Borisovo",
                        "latitude": "55.61252000",
                        "longitude": "37.72639000"
                    },
                    {
                        "id": 100462,
                        "name": "Orekhovo-Borisovo Severnoye",
                        "latitude": "55.61667000",
                        "longitude": "37.68333000"
                    },
                    {
                        "id": 100490,
                        "name": "Ostankinskiy",
                        "latitude": "55.82957000",
                        "longitude": "37.61604000"
                    },
                    {
                        "id": 100505,
                        "name": "Otradnoye",
                        "latitude": "55.86667000",
                        "longitude": "37.60000000"
                    },
                    {
                        "id": 100750,
                        "name": "Pokrovskoye-Streshnëvo",
                        "latitude": "55.80797000",
                        "longitude": "37.45814000"
                    },
                    {
                        "id": 100812,
                        "name": "Presnenskiy",
                        "latitude": "55.75000000",
                        "longitude": "37.55000000"
                    },
                    {
                        "id": 100934,
                        "name": "Ramenki",
                        "latitude": "55.70000000",
                        "longitude": "37.50000000"
                    },
                    {
                        "id": 101005,
                        "name": "Rostokino",
                        "latitude": "55.83333000",
                        "longitude": "37.66667000"
                    },
                    {
                        "id": 101018,
                        "name": "Rublëvo",
                        "latitude": "55.78514000",
                        "longitude": "37.35481000"
                    },
                    {
                        "id": 101043,
                        "name": "Ryazanskiy",
                        "latitude": "55.73333000",
                        "longitude": "37.76667000"
                    },
                    {
                        "id": 101200,
                        "name": "Setun’",
                        "latitude": "55.71667000",
                        "longitude": "37.41667000"
                    },
                    {
                        "id": 101206,
                        "name": "Severnyy",
                        "latitude": "55.93583000",
                        "longitude": "37.54889000"
                    },
                    {
                        "id": 101277,
                        "name": "Shcherbinka",
                        "latitude": "55.49972000",
                        "longitude": "37.55972000"
                    },
                    {
                        "id": 101279,
                        "name": "Shchukino",
                        "latitude": "55.80000000",
                        "longitude": "37.45000000"
                    },
                    {
                        "id": 101408,
                        "name": "Slobodka",
                        "latitude": "55.86667000",
                        "longitude": "37.58333000"
                    },
                    {
                        "id": 101432,
                        "name": "Sokol",
                        "latitude": "55.80000000",
                        "longitude": "37.51667000"
                    },
                    {
                        "id": 101441,
                        "name": "Sokol’niki",
                        "latitude": "55.80202000",
                        "longitude": "37.67159000"
                    },
                    {
                        "id": 101460,
                        "name": "Solntsevo",
                        "latitude": "55.63711000",
                        "longitude": "37.38115000"
                    },
                    {
                        "id": 101630,
                        "name": "Strogino",
                        "latitude": "55.81838000",
                        "longitude": "37.41224000"
                    },
                    {
                        "id": 101710,
                        "name": "Sviblovo",
                        "latitude": "55.85000000",
                        "longitude": "37.63333000"
                    },
                    {
                        "id": 101741,
                        "name": "Taganskiy",
                        "latitude": "55.73333000",
                        "longitude": "37.66667000"
                    },
                    {
                        "id": 101812,
                        "name": "Tekstil’shchiki",
                        "latitude": "55.70033000",
                        "longitude": "37.74271000"
                    },
                    {
                        "id": 101879,
                        "name": "Tolstopal’tsevo",
                        "latitude": "55.61026000",
                        "longitude": "37.21834000"
                    },
                    {
                        "id": 101912,
                        "name": "Troitsk",
                        "latitude": "55.48498000",
                        "longitude": "37.30736000"
                    },
                    {
                        "id": 101926,
                        "name": "Troparëvo",
                        "latitude": "55.65625000",
                        "longitude": "37.48496000"
                    },
                    {
                        "id": 101937,
                        "name": "Tsaritsyno",
                        "latitude": "55.62540000",
                        "longitude": "37.65032000"
                    },
                    {
                        "id": 101945,
                        "name": "Tsentral’nyy Administrativnyy Okrug",
                        "latitude": "55.74943000",
                        "longitude": "37.62371000"
                    },
                    {
                        "id": 101995,
                        "name": "Tyoply Stan",
                        "latitude": "55.62047000",
                        "longitude": "37.49338000"
                    },
                    {
                        "id": 102174,
                        "name": "Vagonoremont",
                        "latitude": "55.90000000",
                        "longitude": "37.55000000"
                    },
                    {
                        "id": 102204,
                        "name": "Vatutinki",
                        "latitude": "55.49650000",
                        "longitude": "37.32988000"
                    },
                    {
                        "id": 102205,
                        "name": "Vatutino",
                        "latitude": "55.88441000",
                        "longitude": "37.69055000"
                    },
                    {
                        "id": 102291,
                        "name": "Veshnyaki",
                        "latitude": "55.72393000",
                        "longitude": "37.81952000"
                    },
                    {
                        "id": 102333,
                        "name": "Vnukovo",
                        "latitude": "55.61194000",
                        "longitude": "37.29611000"
                    },
                    {
                        "id": 102379,
                        "name": "Vorob’yovo",
                        "latitude": "55.71667000",
                        "longitude": "37.53333000"
                    },
                    {
                        "id": 102395,
                        "name": "Vostochnoe Degunino",
                        "latitude": "55.88010000",
                        "longitude": "37.55758000"
                    },
                    {
                        "id": 102397,
                        "name": "Vostochnyy",
                        "latitude": "55.81667000",
                        "longitude": "37.86667000"
                    },
                    {
                        "id": 102432,
                        "name": "Vykhino-Zhulebino",
                        "latitude": "55.70196000",
                        "longitude": "37.81178000"
                    },
                    {
                        "id": 102501,
                        "name": "Yaroslavskiy",
                        "latitude": "55.88333000",
                        "longitude": "37.71667000"
                    },
                    {
                        "id": 102506,
                        "name": "Yasenevo",
                        "latitude": "55.60686000",
                        "longitude": "37.51991000"
                    },
                    {
                        "id": 102629,
                        "name": "Zagor’ye",
                        "latitude": "55.57657000",
                        "longitude": "37.66709000"
                    },
                    {
                        "id": 102641,
                        "name": "Zamoskvorech’ye",
                        "latitude": "55.73333000",
                        "longitude": "37.63333000"
                    },
                    {
                        "id": 102698,
                        "name": "Zelenograd",
                        "latitude": "55.98250000",
                        "longitude": "37.18139000"
                    },
                    {
                        "id": 102746,
                        "name": "Zhulebino",
                        "latitude": "55.70000000",
                        "longitude": "37.85000000"
                    },
                    {
                        "id": 102784,
                        "name": "Zyablikovo",
                        "latitude": "55.61667000",
                        "longitude": "37.76667000"
                    },
                    {
                        "id": 102791,
                        "name": "Zyuzino",
                        "latitude": "55.65608000",
                        "longitude": "37.56846000"
                    }
                ]
            },
            {
                "id": 1843,
                "name": "Murmansk",
                "iso2": "MUR",
                "latitude": "67.84426740",
                "longitude": "35.08841020",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97488,
                        "name": "Abram Mys",
                        "latitude": "68.97839000",
                        "longitude": "33.01926000"
                    },
                    {
                        "id": 97511,
                        "name": "Afrikanda",
                        "latitude": "67.44289000",
                        "longitude": "32.78279000"
                    },
                    {
                        "id": 97556,
                        "name": "Alakurtti",
                        "latitude": "66.96720000",
                        "longitude": "30.34905000"
                    },
                    {
                        "id": 97649,
                        "name": "Apatity",
                        "latitude": "67.56414000",
                        "longitude": "33.40310000"
                    },
                    {
                        "id": 98445,
                        "name": "Gadzhiyevo",
                        "latitude": "69.25506000",
                        "longitude": "33.33616000"
                    },
                    {
                        "id": 98837,
                        "name": "Kandalaksha",
                        "latitude": "67.16200000",
                        "longitude": "32.41229000"
                    },
                    {
                        "id": 98838,
                        "name": "Kandalakshskiy rayon",
                        "latitude": "67.16622000",
                        "longitude": "32.44606000"
                    },
                    {
                        "id": 99064,
                        "name": "Kirovsk",
                        "latitude": "67.61475000",
                        "longitude": "33.67274000"
                    },
                    {
                        "id": 99156,
                        "name": "Kol’skiy Rayon",
                        "latitude": "68.50000000",
                        "longitude": "32.00000000"
                    },
                    {
                        "id": 99136,
                        "name": "Kola",
                        "latitude": "68.88062000",
                        "longitude": "33.01842000"
                    },
                    {
                        "id": 99252,
                        "name": "Kovdor",
                        "latitude": "67.56616000",
                        "longitude": "30.47576000"
                    },
                    {
                        "id": 99253,
                        "name": "Kovdorskiy Rayon",
                        "latitude": "67.56667000",
                        "longitude": "30.40000000"
                    },
                    {
                        "id": 99673,
                        "name": "Lovozero",
                        "latitude": "68.00638000",
                        "longitude": "35.01589000"
                    },
                    {
                        "id": 99674,
                        "name": "Lovozerskiy Rayon",
                        "latitude": "68.00000000",
                        "longitude": "36.00000000"
                    },
                    {
                        "id": 99950,
                        "name": "Molochnyy",
                        "latitude": "68.85389000",
                        "longitude": "33.02046000"
                    },
                    {
                        "id": 99957,
                        "name": "Monchegorsk",
                        "latitude": "67.93972000",
                        "longitude": "32.87389000"
                    },
                    {
                        "id": 100009,
                        "name": "Murmansk",
                        "latitude": "68.97917000",
                        "longitude": "33.09251000"
                    },
                    {
                        "id": 100010,
                        "name": "Murmashi",
                        "latitude": "68.81542000",
                        "longitude": "32.81147000"
                    },
                    {
                        "id": 100130,
                        "name": "Nikel",
                        "latitude": "69.41285000",
                        "longitude": "30.22198000"
                    },
                    {
                        "id": 100420,
                        "name": "Olenegorsk",
                        "latitude": "68.14320000",
                        "longitude": "33.25287000"
                    },
                    {
                        "id": 100497,
                        "name": "Ostrovnoy",
                        "latitude": "68.05306000",
                        "longitude": "39.51306000"
                    },
                    {
                        "id": 100584,
                        "name": "Pechenga",
                        "latitude": "69.52587000",
                        "longitude": "31.17027000"
                    },
                    {
                        "id": 100585,
                        "name": "Pechengskiy Rayon",
                        "latitude": "69.00000000",
                        "longitude": "30.00000000"
                    },
                    {
                        "id": 100762,
                        "name": "Polyarnyy",
                        "latitude": "69.19889000",
                        "longitude": "33.44778000"
                    },
                    {
                        "id": 100763,
                        "name": "Polyarnyye Zori",
                        "latitude": "67.36611000",
                        "longitude": "32.49806000"
                    },
                    {
                        "id": 100796,
                        "name": "Poyakonda",
                        "latitude": "66.59428000",
                        "longitude": "32.82088000"
                    },
                    {
                        "id": 100968,
                        "name": "Revda",
                        "latitude": "67.93710000",
                        "longitude": "34.56149000"
                    },
                    {
                        "id": 101002,
                        "name": "Roslyakovo",
                        "latitude": "69.04303000",
                        "longitude": "33.19906000"
                    },
                    {
                        "id": 101069,
                        "name": "Safonovo",
                        "latitude": "69.06043000",
                        "longitude": "33.29523000"
                    },
                    {
                        "id": 101218,
                        "name": "Severomorsk",
                        "latitude": "69.06889000",
                        "longitude": "33.41622000"
                    },
                    {
                        "id": 101219,
                        "name": "Severomorsk-3",
                        "latitude": "68.87862000",
                        "longitude": "33.72631000"
                    },
                    {
                        "id": 101338,
                        "name": "Shonguy",
                        "latitude": "68.75261000",
                        "longitude": "33.14595000"
                    },
                    {
                        "id": 101424,
                        "name": "Snezhnogorsk",
                        "latitude": "69.19333000",
                        "longitude": "33.25314000"
                    },
                    {
                        "id": 101831,
                        "name": "Teribërka",
                        "latitude": "69.16088000",
                        "longitude": "35.14527000"
                    },
                    {
                        "id": 101839,
                        "name": "Terskiy Rayon",
                        "latitude": "66.91667000",
                        "longitude": "35.00000000"
                    },
                    {
                        "id": 102055,
                        "name": "Umba",
                        "latitude": "66.68706000",
                        "longitude": "34.34291000"
                    },
                    {
                        "id": 102241,
                        "name": "Verkhnetulomskiy",
                        "latitude": "68.60727000",
                        "longitude": "31.79621000"
                    },
                    {
                        "id": 102303,
                        "name": "Vidyayevo",
                        "latitude": "69.31914000",
                        "longitude": "32.80488000"
                    },
                    {
                        "id": 102446,
                        "name": "Vysokiy",
                        "latitude": "68.13583000",
                        "longitude": "33.41917000"
                    },
                    {
                        "id": 102645,
                        "name": "Zaozërsk",
                        "latitude": "69.40052000",
                        "longitude": "32.44761000"
                    },
                    {
                        "id": 102647,
                        "name": "Zapolyarnyy",
                        "latitude": "69.41541000",
                        "longitude": "30.81355000"
                    },
                    {
                        "id": 102692,
                        "name": "Zelenoborskiy",
                        "latitude": "66.84500000",
                        "longitude": "32.36222000"
                    }
                ]
            },
            {
                "id": 1836,
                "name": "Nenets",
                "iso2": "NEN",
                "latitude": "67.60783370",
                "longitude": "57.63383310",
                "type": "autonomous city",
                "cities": [
                    {
                        "id": 98710,
                        "name": "Iskateley",
                        "latitude": "67.68026000",
                        "longitude": "53.15117000"
                    },
                    {
                        "id": 100057,
                        "name": "Nar'yan-Mar",
                        "latitude": "67.63869000",
                        "longitude": "53.00371000"
                    }
                ]
            },
            {
                "id": 1857,
                "name": "Nizhny Novgorod",
                "iso2": "NIZ",
                "latitude": "55.79951590",
                "longitude": "44.02967690",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97510,
                        "name": "Afonino",
                        "latitude": "56.26201000",
                        "longitude": "44.09503000"
                    },
                    {
                        "id": 97691,
                        "name": "Ar’ya",
                        "latitude": "57.49146000",
                        "longitude": "45.96691000"
                    },
                    {
                        "id": 97655,
                        "name": "Ardatov",
                        "latitude": "55.24205000",
                        "longitude": "43.09699000"
                    },
                    {
                        "id": 97657,
                        "name": "Ardatovskiy Rayon",
                        "latitude": "55.25000000",
                        "longitude": "43.08333000"
                    },
                    {
                        "id": 97688,
                        "name": "Arzamas",
                        "latitude": "55.39485000",
                        "longitude": "43.83992000"
                    },
                    {
                        "id": 97689,
                        "name": "Arzamasskiy Rayon",
                        "latitude": "55.33333000",
                        "longitude": "43.75000000"
                    },
                    {
                        "id": 97741,
                        "name": "Babino",
                        "latitude": "56.22564000",
                        "longitude": "43.62380000"
                    },
                    {
                        "id": 97954,
                        "name": "Blizhne-Pesochnoye",
                        "latitude": "55.34560000",
                        "longitude": "42.10150000"
                    },
                    {
                        "id": 97968,
                        "name": "Bogorodsk",
                        "latitude": "56.10513000",
                        "longitude": "43.51294000"
                    },
                    {
                        "id": 97969,
                        "name": "Bogorodskiy Rayon",
                        "latitude": "56.08333000",
                        "longitude": "43.50000000"
                    },
                    {
                        "id": 98003,
                        "name": "Bol’sheboldinskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "45.25000000"
                    },
                    {
                        "id": 98012,
                        "name": "Bol’shoye Boldino",
                        "latitude": "55.00588000",
                        "longitude": "45.31419000"
                    },
                    {
                        "id": 98014,
                        "name": "Bol’shoye Kozino",
                        "latitude": "56.40397000",
                        "longitude": "43.71424000"
                    },
                    {
                        "id": 98015,
                        "name": "Bol’shoye Murashkino",
                        "latitude": "55.78261000",
                        "longitude": "44.77541000"
                    },
                    {
                        "id": 98019,
                        "name": "Bor",
                        "latitude": "56.35808000",
                        "longitude": "44.07477000"
                    },
                    {
                        "id": 98021,
                        "name": "Bor Urban Okrug",
                        "latitude": "56.35325000",
                        "longitude": "44.09010000"
                    },
                    {
                        "id": 98078,
                        "name": "Burevestnik",
                        "latitude": "56.14403000",
                        "longitude": "43.78832000"
                    },
                    {
                        "id": 98087,
                        "name": "Buturlino",
                        "latitude": "55.56673000",
                        "longitude": "44.89738000"
                    },
                    {
                        "id": 98175,
                        "name": "Chernukha",
                        "latitude": "55.59739000",
                        "longitude": "43.75560000"
                    },
                    {
                        "id": 98202,
                        "name": "Chistoye",
                        "latitude": "56.53753000",
                        "longitude": "43.00445000"
                    },
                    {
                        "id": 98206,
                        "name": "Chkalovsk",
                        "latitude": "56.76776000",
                        "longitude": "43.25135000"
                    },
                    {
                        "id": 98239,
                        "name": "Dal’nekonstantinovskiy Rayon",
                        "latitude": "55.83333000",
                        "longitude": "44.08333000"
                    },
                    {
                        "id": 98240,
                        "name": "Dal’neye Konstantinovo",
                        "latitude": "55.81025000",
                        "longitude": "44.09595000"
                    },
                    {
                        "id": 98278,
                        "name": "Diveyevo",
                        "latitude": "55.04329000",
                        "longitude": "43.24178000"
                    },
                    {
                        "id": 98322,
                        "name": "Doschatoye",
                        "latitude": "55.38860000",
                        "longitude": "42.10320000"
                    },
                    {
                        "id": 98367,
                        "name": "Dzerzhinsk",
                        "latitude": "56.24143000",
                        "longitude": "43.45539000"
                    },
                    {
                        "id": 98436,
                        "name": "Frolishchi",
                        "latitude": "56.42177000",
                        "longitude": "42.65187000"
                    },
                    {
                        "id": 98448,
                        "name": "Gagino",
                        "latitude": "55.23142000",
                        "longitude": "45.03386000"
                    },
                    {
                        "id": 98488,
                        "name": "Gidrotorf",
                        "latitude": "56.47562000",
                        "longitude": "43.53813000"
                    },
                    {
                        "id": 98517,
                        "name": "Gorbatov",
                        "latitude": "56.13110000",
                        "longitude": "43.06363000"
                    },
                    {
                        "id": 98518,
                        "name": "Gorbatovka",
                        "latitude": "56.25716000",
                        "longitude": "43.74577000"
                    },
                    {
                        "id": 98558,
                        "name": "Gorodets",
                        "latitude": "56.65493000",
                        "longitude": "43.47273000"
                    },
                    {
                        "id": 98559,
                        "name": "Gorodetskiy Rayon",
                        "latitude": "56.75000000",
                        "longitude": "43.75000000"
                    },
                    {
                        "id": 98585,
                        "name": "Gremyachevo",
                        "latitude": "55.39193000",
                        "longitude": "43.02734000"
                    },
                    {
                        "id": 98648,
                        "name": "Ilyinogorsk",
                        "latitude": "56.22775000",
                        "longitude": "42.95385000"
                    },
                    {
                        "id": 98662,
                        "name": "Imeni M. I. Kalinina",
                        "latitude": "56.17926000",
                        "longitude": "44.33098000"
                    },
                    {
                        "id": 98666,
                        "name": "Imeni Stepana Razina",
                        "latitude": "54.89320000",
                        "longitude": "44.29627000"
                    },
                    {
                        "id": 99114,
                        "name": "Knyaginino",
                        "latitude": "55.82278000",
                        "longitude": "45.03489000"
                    },
                    {
                        "id": 99254,
                        "name": "Kovernino",
                        "latitude": "57.12818000",
                        "longitude": "43.81350000"
                    },
                    {
                        "id": 99279,
                        "name": "Krasnaya Gorka",
                        "latitude": "55.38666000",
                        "longitude": "46.10925000"
                    },
                    {
                        "id": 99330,
                        "name": "Krasnooktyabr’skiy Rayon",
                        "latitude": "55.33333000",
                        "longitude": "45.58333000"
                    },
                    {
                        "id": 99381,
                        "name": "Krasnyye Baki",
                        "latitude": "57.13100000",
                        "longitude": "45.15992000"
                    },
                    {
                        "id": 99411,
                        "name": "Kstovo",
                        "latitude": "56.14733000",
                        "longitude": "44.19787000"
                    },
                    {
                        "id": 99430,
                        "name": "Kulebaki",
                        "latitude": "55.41333000",
                        "longitude": "42.53250000"
                    },
                    {
                        "id": 99630,
                        "name": "Linda",
                        "latitude": "56.61571000",
                        "longitude": "44.09544000"
                    },
                    {
                        "id": 99687,
                        "name": "Lukino",
                        "latitude": "56.44183000",
                        "longitude": "43.62932000"
                    },
                    {
                        "id": 99690,
                        "name": "Lukoyanov",
                        "latitude": "55.02772000",
                        "longitude": "44.47865000"
                    },
                    {
                        "id": 99691,
                        "name": "Lukoyanovskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "44.50000000"
                    },
                    {
                        "id": 99707,
                        "name": "Lyskovo",
                        "latitude": "56.03282000",
                        "longitude": "45.04220000"
                    },
                    {
                        "id": 99999,
                        "name": "Mukhtolovo",
                        "latitude": "55.46751000",
                        "longitude": "43.19973000"
                    },
                    {
                        "id": 100000,
                        "name": "Mulino",
                        "latitude": "56.28923000",
                        "longitude": "42.92005000"
                    },
                    {
                        "id": 100070,
                        "name": "Navashino",
                        "latitude": "55.54410000",
                        "longitude": "42.19680000"
                    },
                    {
                        "id": 100089,
                        "name": "Neklyudovo",
                        "latitude": "56.41421000",
                        "longitude": "43.97721000"
                    },
                    {
                        "id": 100173,
                        "name": "Nizhniy Novgorod",
                        "latitude": "56.32867000",
                        "longitude": "44.00205000"
                    },
                    {
                        "id": 100199,
                        "name": "Novaya Balakhna",
                        "latitude": "56.48989000",
                        "longitude": "43.60114000"
                    },
                    {
                        "id": 100308,
                        "name": "Novosmolinskiy",
                        "latitude": "56.28410000",
                        "longitude": "43.05071000"
                    },
                    {
                        "id": 100533,
                        "name": "Pamyat’ Parizhskoy Kommuny",
                        "latitude": "56.10480000",
                        "longitude": "44.49520000"
                    },
                    {
                        "id": 100570,
                        "name": "Pavlovo",
                        "latitude": "55.96860000",
                        "longitude": "43.09120000"
                    },
                    {
                        "id": 100578,
                        "name": "Pavlovskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "43.00000000"
                    },
                    {
                        "id": 100609,
                        "name": "Perevoz",
                        "latitude": "55.59613000",
                        "longitude": "44.54461000"
                    },
                    {
                        "id": 100614,
                        "name": "Pervomaysk",
                        "latitude": "54.86890000",
                        "longitude": "43.80272000"
                    },
                    {
                        "id": 100616,
                        "name": "Pervomayskiy",
                        "latitude": "56.61474000",
                        "longitude": "43.35825000"
                    },
                    {
                        "id": 100630,
                        "name": "Pervoye Maya",
                        "latitude": "56.16403000",
                        "longitude": "44.71955000"
                    },
                    {
                        "id": 100672,
                        "name": "Pil’na",
                        "latitude": "55.55394000",
                        "longitude": "45.92194000"
                    },
                    {
                        "id": 100673,
                        "name": "Pil’ninskiy Rayon",
                        "latitude": "55.58333000",
                        "longitude": "45.91667000"
                    },
                    {
                        "id": 100692,
                        "name": "Pizhma",
                        "latitude": "57.86418000",
                        "longitude": "47.11714000"
                    },
                    {
                        "id": 100708,
                        "name": "Pochinki",
                        "latitude": "54.69875000",
                        "longitude": "44.86678000"
                    },
                    {
                        "id": 100709,
                        "name": "Pochinkovskiy Rayon",
                        "latitude": "54.66667000",
                        "longitude": "44.83333000"
                    },
                    {
                        "id": 100723,
                        "name": "Podnov’ye",
                        "latitude": "56.30610000",
                        "longitude": "44.09244000"
                    },
                    {
                        "id": 100874,
                        "name": "Prudy",
                        "latitude": "57.57380000",
                        "longitude": "46.27176000"
                    },
                    {
                        "id": 100891,
                        "name": "Purekh",
                        "latitude": "56.64684000",
                        "longitude": "43.06772000"
                    },
                    {
                        "id": 100914,
                        "name": "Pyra",
                        "latitude": "56.29527000",
                        "longitude": "43.35274000"
                    },
                    {
                        "id": 100921,
                        "name": "Rabotki",
                        "latitude": "56.04147000",
                        "longitude": "44.60265000"
                    },
                    {
                        "id": 100964,
                        "name": "Reshetikha",
                        "latitude": "56.21566000",
                        "longitude": "43.28802000"
                    },
                    {
                        "id": 101122,
                        "name": "Sarov",
                        "latitude": "54.93583000",
                        "longitude": "43.32352000"
                    },
                    {
                        "id": 101131,
                        "name": "Satis",
                        "latitude": "54.92290000",
                        "longitude": "43.22977000"
                    },
                    {
                        "id": 101134,
                        "name": "Savasleyka",
                        "latitude": "55.46060000",
                        "longitude": "42.32070000"
                    },
                    {
                        "id": 101145,
                        "name": "Sechenovo",
                        "latitude": "55.22444000",
                        "longitude": "45.89056000"
                    },
                    {
                        "id": 101146,
                        "name": "Sechenovskiy Rayon",
                        "latitude": "55.16667000",
                        "longitude": "45.91667000"
                    },
                    {
                        "id": 101169,
                        "name": "Semënov",
                        "latitude": "56.78749000",
                        "longitude": "44.49297000"
                    },
                    {
                        "id": 101179,
                        "name": "Sergach",
                        "latitude": "55.53079000",
                        "longitude": "45.46611000"
                    },
                    {
                        "id": 101180,
                        "name": "Sergachskiy Rayon",
                        "latitude": "55.58333000",
                        "longitude": "45.50000000"
                    },
                    {
                        "id": 101242,
                        "name": "Shakhun’ya",
                        "latitude": "57.67579000",
                        "longitude": "46.61136000"
                    },
                    {
                        "id": 101259,
                        "name": "Sharanga",
                        "latitude": "57.17749000",
                        "longitude": "46.53956000"
                    },
                    {
                        "id": 101260,
                        "name": "Sharangskiy Rayon",
                        "latitude": "57.08333000",
                        "longitude": "46.41667000"
                    },
                    {
                        "id": 101268,
                        "name": "Shatki",
                        "latitude": "55.18874000",
                        "longitude": "44.12486000"
                    },
                    {
                        "id": 101320,
                        "name": "Shimorskoye",
                        "latitude": "55.32810000",
                        "longitude": "42.02560000"
                    },
                    {
                        "id": 101380,
                        "name": "Sitniki",
                        "latitude": "56.45529000",
                        "longitude": "44.06658000"
                    },
                    {
                        "id": 101419,
                        "name": "Smolino",
                        "latitude": "56.27526000",
                        "longitude": "43.09109000"
                    },
                    {
                        "id": 101443,
                        "name": "Sokol’skoye",
                        "latitude": "57.14122000",
                        "longitude": "43.15895000"
                    },
                    {
                        "id": 101495,
                        "name": "Sosnovskiy Rayon",
                        "latitude": "55.75000000",
                        "longitude": "43.25000000"
                    },
                    {
                        "id": 101497,
                        "name": "Sosnovskoye",
                        "latitude": "55.80549000",
                        "longitude": "43.16791000"
                    },
                    {
                        "id": 101530,
                        "name": "Spasskiy Rayon",
                        "latitude": "55.83333000",
                        "longitude": "45.75000000"
                    },
                    {
                        "id": 101533,
                        "name": "Spasskoye",
                        "latitude": "55.86048000",
                        "longitude": "45.69695000"
                    },
                    {
                        "id": 101651,
                        "name": "Sukhobezvodnoye",
                        "latitude": "57.04913000",
                        "longitude": "44.88909000"
                    },
                    {
                        "id": 101679,
                        "name": "Surovatikha",
                        "latitude": "55.76516000",
                        "longitude": "43.89845000"
                    },
                    {
                        "id": 101720,
                        "name": "Syava",
                        "latitude": "58.01457000",
                        "longitude": "46.32216000"
                    },
                    {
                        "id": 101773,
                        "name": "Taremskoye",
                        "latitude": "55.92889000",
                        "longitude": "43.04433000"
                    },
                    {
                        "id": 101889,
                        "name": "Tonkino",
                        "latitude": "57.37257000",
                        "longitude": "46.46294000"
                    },
                    {
                        "id": 101891,
                        "name": "Tonshayevo",
                        "latitude": "57.73598000",
                        "longitude": "47.01265000"
                    },
                    {
                        "id": 101944,
                        "name": "Tsentral’nyy",
                        "latitude": "56.29700000",
                        "longitude": "42.78869000"
                    },
                    {
                        "id": 101969,
                        "name": "Tumbotino",
                        "latitude": "55.99926000",
                        "longitude": "43.02359000"
                    },
                    {
                        "id": 102072,
                        "name": "Urazovka",
                        "latitude": "55.40126000",
                        "longitude": "45.61860000"
                    },
                    {
                        "id": 102076,
                        "name": "Uren’",
                        "latitude": "57.45516000",
                        "longitude": "45.78522000"
                    },
                    {
                        "id": 102168,
                        "name": "Vacha",
                        "latitude": "55.80350000",
                        "longitude": "42.77090000"
                    },
                    {
                        "id": 102169,
                        "name": "Vachskiy Rayon",
                        "latitude": "55.75000000",
                        "longitude": "42.75000000"
                    },
                    {
                        "id": 102170,
                        "name": "Vad",
                        "latitude": "55.53009000",
                        "longitude": "44.21137000"
                    },
                    {
                        "id": 102178,
                        "name": "Vakhtan",
                        "latitude": "57.96592000",
                        "longitude": "46.68886000"
                    },
                    {
                        "id": 102193,
                        "name": "Varnavino",
                        "latitude": "57.40351000",
                        "longitude": "45.09164000"
                    },
                    {
                        "id": 102194,
                        "name": "Varnavinskiy Rayon",
                        "latitude": "57.50000000",
                        "longitude": "44.91667000"
                    },
                    {
                        "id": 102197,
                        "name": "Vasil’sursk",
                        "latitude": "56.13139000",
                        "longitude": "46.01600000"
                    },
                    {
                        "id": 102295,
                        "name": "Vetluga",
                        "latitude": "57.85574000",
                        "longitude": "45.78102000"
                    },
                    {
                        "id": 102297,
                        "name": "Vetluzhskiy",
                        "latitude": "57.17355000",
                        "longitude": "45.12272000"
                    },
                    {
                        "id": 102298,
                        "name": "Vetluzhskiy Rayon",
                        "latitude": "57.75000000",
                        "longitude": "45.58333000"
                    },
                    {
                        "id": 102307,
                        "name": "Vilya",
                        "latitude": "55.24556000",
                        "longitude": "42.20889000"
                    },
                    {
                        "id": 102329,
                        "name": "Vladimirskoye",
                        "latitude": "56.82002000",
                        "longitude": "45.11843000"
                    },
                    {
                        "id": 102351,
                        "name": "Volodarsk",
                        "latitude": "56.23105000",
                        "longitude": "43.18767000"
                    },
                    {
                        "id": 102384,
                        "name": "Vorotynets",
                        "latitude": "56.06028000",
                        "longitude": "45.86330000"
                    },
                    {
                        "id": 102387,
                        "name": "Vorsma",
                        "latitude": "55.99062000",
                        "longitude": "43.27249000"
                    },
                    {
                        "id": 102389,
                        "name": "Voskresenskiy Rayon",
                        "latitude": "56.75000000",
                        "longitude": "45.50000000"
                    },
                    {
                        "id": 102393,
                        "name": "Voskresenskoye",
                        "latitude": "56.83806000",
                        "longitude": "45.43167000"
                    },
                    {
                        "id": 102410,
                        "name": "Voznesenskoye",
                        "latitude": "54.89000000",
                        "longitude": "42.75694000"
                    },
                    {
                        "id": 102433,
                        "name": "Vyksa",
                        "latitude": "55.31750000",
                        "longitude": "42.17444000"
                    },
                    {
                        "id": 102455,
                        "name": "Vyyezdnoye",
                        "latitude": "55.38154000",
                        "longitude": "43.78638000"
                    },
                    {
                        "id": 102586,
                        "name": "Yuganets",
                        "latitude": "56.25080000",
                        "longitude": "43.23069000"
                    },
                    {
                        "id": 102680,
                        "name": "Zavolzh’ye",
                        "latitude": "56.64051000",
                        "longitude": "43.39446000"
                    },
                    {
                        "id": 102702,
                        "name": "Zelyony Gorod",
                        "latitude": "56.17833000",
                        "longitude": "44.07440000"
                    }
                ]
            },
            {
                "id": 1853,
                "name": "North Ossetia-Alania",
                "iso2": "SE",
                "latitude": "43.04513020",
                "longitude": "44.28709720",
                "type": "republic",
                "cities": [
                    {
                        "id": 97554,
                        "name": "Alagir",
                        "latitude": "43.04222000",
                        "longitude": "44.22222000"
                    },
                    {
                        "id": 97555,
                        "name": "Alagirskiy Rayon",
                        "latitude": "42.83333000",
                        "longitude": "44.08333000"
                    },
                    {
                        "id": 97658,
                        "name": "Ardon",
                        "latitude": "43.17720000",
                        "longitude": "44.29702000"
                    },
                    {
                        "id": 97670,
                        "name": "Arkhonskaya",
                        "latitude": "43.11000000",
                        "longitude": "44.51250000"
                    },
                    {
                        "id": 97910,
                        "name": "Beslan",
                        "latitude": "43.19217000",
                        "longitude": "44.54313000"
                    },
                    {
                        "id": 98163,
                        "name": "Chermen",
                        "latitude": "43.15186000",
                        "longitude": "44.71231000"
                    },
                    {
                        "id": 98194,
                        "name": "Chikola",
                        "latitude": "43.19055000",
                        "longitude": "43.92093000"
                    },
                    {
                        "id": 98230,
                        "name": "Dachnoye",
                        "latitude": "43.08468000",
                        "longitude": "44.73580000"
                    },
                    {
                        "id": 98273,
                        "name": "Digora",
                        "latitude": "43.15806000",
                        "longitude": "44.15694000"
                    },
                    {
                        "id": 98274,
                        "name": "Digorskiy Rayon",
                        "latitude": "43.16667000",
                        "longitude": "44.08333000"
                    },
                    {
                        "id": 98493,
                        "name": "Gizel’",
                        "latitude": "43.04000000",
                        "longitude": "44.57083000"
                    },
                    {
                        "id": 98686,
                        "name": "Irafskiy Rayon",
                        "latitude": "43.00000000",
                        "longitude": "43.75000000"
                    },
                    {
                        "id": 98807,
                        "name": "Kambileyevskoye",
                        "latitude": "43.07858000",
                        "longitude": "44.75216000"
                    },
                    {
                        "id": 98875,
                        "name": "Kardzhin",
                        "latitude": "43.27368000",
                        "longitude": "44.29075000"
                    },
                    {
                        "id": 99018,
                        "name": "Khumalag",
                        "latitude": "43.24031000",
                        "longitude": "44.47521000"
                    },
                    {
                        "id": 99070,
                        "name": "Kirovskiy Rayon",
                        "latitude": "43.33333000",
                        "longitude": "44.33333000"
                    },
                    {
                        "id": 99093,
                        "name": "Kizlyar",
                        "latitude": "43.70379000",
                        "longitude": "44.59440000"
                    },
                    {
                        "id": 99905,
                        "name": "Mikhaylovskoye",
                        "latitude": "43.09972000",
                        "longitude": "44.63164000"
                    },
                    {
                        "id": 99934,
                        "name": "Mizur",
                        "latitude": "42.85376000",
                        "longitude": "44.06393000"
                    },
                    {
                        "id": 99984,
                        "name": "Mozdok",
                        "latitude": "43.74359000",
                        "longitude": "44.65177000"
                    },
                    {
                        "id": 100194,
                        "name": "Nogir",
                        "latitude": "43.08162000",
                        "longitude": "44.63650000"
                    },
                    {
                        "id": 100565,
                        "name": "Pavlodol’skaya",
                        "latitude": "43.71923000",
                        "longitude": "44.47815000"
                    },
                    {
                        "id": 100804,
                        "name": "Pravoberezhnyy Rayon",
                        "latitude": "43.16667000",
                        "longitude": "44.66667000"
                    },
                    {
                        "id": 100822,
                        "name": "Prigorodnyy Rayon",
                        "latitude": "43.08333000",
                        "longitude": "44.83333000"
                    },
                    {
                        "id": 101667,
                        "name": "Sunzha",
                        "latitude": "43.05862000",
                        "longitude": "44.82281000"
                    },
                    {
                        "id": 101779,
                        "name": "Tarskoye",
                        "latitude": "42.96606000",
                        "longitude": "44.77540000"
                    },
                    {
                        "id": 101837,
                        "name": "Terskaya",
                        "latitude": "43.72376000",
                        "longitude": "44.72442000"
                    },
                    {
                        "id": 101923,
                        "name": "Troitskoye",
                        "latitude": "43.76219000",
                        "longitude": "44.68415000"
                    },
                    {
                        "id": 102252,
                        "name": "Verkhniy Fiagdon",
                        "latitude": "42.83454000",
                        "longitude": "44.30604000"
                    },
                    {
                        "id": 102325,
                        "name": "Vladikavkaz",
                        "latitude": "43.03667000",
                        "longitude": "44.66778000"
                    },
                    {
                        "id": 102754,
                        "name": "Zmeyskaya",
                        "latitude": "43.33617000",
                        "longitude": "44.15733000"
                    }
                ]
            },
            {
                "id": 1834,
                "name": "Novgorod",
                "iso2": "NGR",
                "latitude": "58.24275520",
                "longitude": "32.56651900",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97812,
                        "name": "Batetskiy",
                        "latitude": "58.64610000",
                        "longitude": "30.30268000"
                    },
                    {
                        "id": 97813,
                        "name": "Batetskiy Rayon",
                        "latitude": "58.58333000",
                        "longitude": "30.50000000"
                    },
                    {
                        "id": 98034,
                        "name": "Borovichi",
                        "latitude": "58.38778000",
                        "longitude": "33.91546000"
                    },
                    {
                        "id": 98035,
                        "name": "Borovichskiy Rayon",
                        "latitude": "58.50000000",
                        "longitude": "34.00000000"
                    },
                    {
                        "id": 98214,
                        "name": "Chudovo",
                        "latitude": "59.11667000",
                        "longitude": "31.68333000"
                    },
                    {
                        "id": 98215,
                        "name": "Chudovskiy Rayon",
                        "latitude": "59.16667000",
                        "longitude": "31.83333000"
                    },
                    {
                        "id": 98261,
                        "name": "Demyansk",
                        "latitude": "57.64301000",
                        "longitude": "32.46600000"
                    },
                    {
                        "id": 98262,
                        "name": "Demyanskiy Rayon",
                        "latitude": "57.58333000",
                        "longitude": "32.75000000"
                    },
                    {
                        "id": 98992,
                        "name": "Kholm",
                        "latitude": "59.26667000",
                        "longitude": "32.85000000"
                    },
                    {
                        "id": 98998,
                        "name": "Kholmskiy Rayon",
                        "latitude": "57.08333000",
                        "longitude": "31.33333000"
                    },
                    {
                        "id": 99029,
                        "name": "Khvoynaya",
                        "latitude": "58.90000000",
                        "longitude": "34.53333000"
                    },
                    {
                        "id": 99030,
                        "name": "Khvoyninskiy Rayon",
                        "latitude": "58.91667000",
                        "longitude": "34.50000000"
                    },
                    {
                        "id": 99301,
                        "name": "Krasnofarfornyy",
                        "latitude": "59.13640000",
                        "longitude": "31.85023000"
                    },
                    {
                        "id": 99387,
                        "name": "Krechevitsy",
                        "latitude": "58.61703000",
                        "longitude": "31.40101000"
                    },
                    {
                        "id": 99389,
                        "name": "Krestetskiy Rayon",
                        "latitude": "58.25000000",
                        "longitude": "32.50000000"
                    },
                    {
                        "id": 99391,
                        "name": "Kresttsy",
                        "latitude": "58.24520000",
                        "longitude": "32.51647000"
                    },
                    {
                        "id": 99434,
                        "name": "Kulotino",
                        "latitude": "58.45000000",
                        "longitude": "33.38333000"
                    },
                    {
                        "id": 99722,
                        "name": "Lyubytino",
                        "latitude": "58.81222000",
                        "longitude": "33.39222000"
                    },
                    {
                        "id": 99723,
                        "name": "Lyubytinskiy Rayon",
                        "latitude": "58.83333000",
                        "longitude": "33.50000000"
                    },
                    {
                        "id": 99753,
                        "name": "Malaya Vishera",
                        "latitude": "58.84538000",
                        "longitude": "32.22218000"
                    },
                    {
                        "id": 99766,
                        "name": "Malovisherskiy Rayon",
                        "latitude": "58.75000000",
                        "longitude": "32.50000000"
                    },
                    {
                        "id": 99789,
                        "name": "Marevo",
                        "latitude": "57.31461000",
                        "longitude": "32.08045000"
                    },
                    {
                        "id": 99790,
                        "name": "Marevskiy Rayon",
                        "latitude": "57.33333000",
                        "longitude": "32.25000000"
                    },
                    {
                        "id": 99973,
                        "name": "Moshenskoy Rayon",
                        "latitude": "58.50000000",
                        "longitude": "34.75000000"
                    },
                    {
                        "id": 99974,
                        "name": "Moshenskoye",
                        "latitude": "58.51016000",
                        "longitude": "34.59108000"
                    },
                    {
                        "id": 100080,
                        "name": "Nebolchi",
                        "latitude": "59.12393000",
                        "longitude": "33.34537000"
                    },
                    {
                        "id": 100213,
                        "name": "Novgorodskiy Rayon",
                        "latitude": "58.75000000",
                        "longitude": "31.25000000"
                    },
                    {
                        "id": 100416,
                        "name": "Okulovka",
                        "latitude": "58.40083000",
                        "longitude": "33.29083000"
                    },
                    {
                        "id": 100417,
                        "name": "Okulovskiy Rayon",
                        "latitude": "58.41667000",
                        "longitude": "33.25000000"
                    },
                    {
                        "id": 100454,
                        "name": "Opechenskiy Posad",
                        "latitude": "58.27510000",
                        "longitude": "34.11731000"
                    },
                    {
                        "id": 100537,
                        "name": "Pankovka",
                        "latitude": "58.50004000",
                        "longitude": "31.19990000"
                    },
                    {
                        "id": 100547,
                        "name": "Parfino",
                        "latitude": "57.97306000",
                        "longitude": "31.64806000"
                    },
                    {
                        "id": 100548,
                        "name": "Parfinskiy Rayon",
                        "latitude": "58.00000000",
                        "longitude": "31.66667000"
                    },
                    {
                        "id": 100638,
                        "name": "Pestovo",
                        "latitude": "58.59382000",
                        "longitude": "35.80244000"
                    },
                    {
                        "id": 100639,
                        "name": "Pestovskiy Rayon",
                        "latitude": "58.66667000",
                        "longitude": "35.66667000"
                    },
                    {
                        "id": 100712,
                        "name": "Poddor’ye",
                        "latitude": "57.46947000",
                        "longitude": "31.11561000"
                    },
                    {
                        "id": 100711,
                        "name": "Poddorskiy Rayon",
                        "latitude": "57.41667000",
                        "longitude": "31.25000000"
                    },
                    {
                        "id": 100862,
                        "name": "Proletariy",
                        "latitude": "58.43423000",
                        "longitude": "31.70462000"
                    },
                    {
                        "id": 101321,
                        "name": "Shimsk",
                        "latitude": "58.21201000",
                        "longitude": "30.71269000"
                    },
                    {
                        "id": 101322,
                        "name": "Shimskiy Rayon",
                        "latitude": "58.21667000",
                        "longitude": "30.71667000"
                    },
                    {
                        "id": 101473,
                        "name": "Sol’tsy",
                        "latitude": "58.12387000",
                        "longitude": "30.32377000"
                    },
                    {
                        "id": 101447,
                        "name": "Soletskiy Rayon",
                        "latitude": "58.08333000",
                        "longitude": "30.25000000"
                    },
                    {
                        "id": 101563,
                        "name": "Staraya Russa",
                        "latitude": "57.99439000",
                        "longitude": "31.36081000"
                    },
                    {
                        "id": 101592,
                        "name": "Starorusskiy Rayon",
                        "latitude": "58.00000000",
                        "longitude": "31.41667000"
                    },
                    {
                        "id": 102036,
                        "name": "Uglovka",
                        "latitude": "58.23917000",
                        "longitude": "33.51083000"
                    },
                    {
                        "id": 102151,
                        "name": "Utorgosh",
                        "latitude": "58.28127000",
                        "longitude": "30.25344000"
                    },
                    {
                        "id": 102179,
                        "name": "Valday",
                        "latitude": "57.97826000",
                        "longitude": "33.24737000"
                    },
                    {
                        "id": 102180,
                        "name": "Valdayskiy Rayon",
                        "latitude": "57.91667000",
                        "longitude": "33.25000000"
                    },
                    {
                        "id": 102211,
                        "name": "Velikiy Novgorod",
                        "latitude": "58.52131000",
                        "longitude": "31.27104000"
                    },
                    {
                        "id": 102347,
                        "name": "Volkhovskiy",
                        "latitude": "58.58000000",
                        "longitude": "31.31641000"
                    },
                    {
                        "id": 102363,
                        "name": "Volot",
                        "latitude": "57.92778000",
                        "longitude": "30.70250000"
                    },
                    {
                        "id": 102364,
                        "name": "Volotovskiy Rayon",
                        "latitude": "57.83333000",
                        "longitude": "30.66667000"
                    },
                    {
                        "id": 102521,
                        "name": "Yedrovo",
                        "latitude": "57.91306000",
                        "longitude": "33.62028000"
                    },
                    {
                        "id": 102660,
                        "name": "Zarubino",
                        "latitude": "58.73500000",
                        "longitude": "33.47556000"
                    }
                ]
            },
            {
                "id": 1888,
                "name": "Novosibirsk",
                "iso2": "NVS",
                "latitude": "54.98326930",
                "longitude": "82.89638310",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97527,
                        "name": "Akademgorodok",
                        "latitude": "54.85230000",
                        "longitude": "83.10600000"
                    },
                    {
                        "id": 97751,
                        "name": "Bagan",
                        "latitude": "54.10014000",
                        "longitude": "77.66462000"
                    },
                    {
                        "id": 97790,
                        "name": "Barabinsk",
                        "latitude": "55.35709000",
                        "longitude": "78.35697000"
                    },
                    {
                        "id": 97805,
                        "name": "Baryshevo",
                        "latitude": "54.95640000",
                        "longitude": "83.18220000"
                    },
                    {
                        "id": 97888,
                        "name": "Berdsk",
                        "latitude": "54.75510000",
                        "longitude": "83.09670000"
                    },
                    {
                        "id": 97997,
                        "name": "Bolotnoye",
                        "latitude": "55.67167000",
                        "longitude": "84.39806000"
                    },
                    {
                        "id": 98114,
                        "name": "Chany",
                        "latitude": "55.31205000",
                        "longitude": "76.76468000"
                    },
                    {
                        "id": 98154,
                        "name": "Cherepanovo",
                        "latitude": "54.22220000",
                        "longitude": "83.38100000"
                    },
                    {
                        "id": 98219,
                        "name": "Chulym",
                        "latitude": "55.09972000",
                        "longitude": "80.95722000"
                    },
                    {
                        "id": 98318,
                        "name": "Dorogino",
                        "latitude": "54.35980000",
                        "longitude": "83.31980000"
                    },
                    {
                        "id": 98342,
                        "name": "Dubrovino",
                        "latitude": "55.47180000",
                        "longitude": "83.29070000"
                    },
                    {
                        "id": 98541,
                        "name": "Gornyy",
                        "latitude": "55.11530000",
                        "longitude": "83.90590000"
                    },
                    {
                        "id": 98711,
                        "name": "Iskitim",
                        "latitude": "54.63660000",
                        "longitude": "83.30450000"
                    },
                    {
                        "id": 98712,
                        "name": "Iskitimskiy Rayon",
                        "latitude": "54.66667000",
                        "longitude": "83.25000000"
                    },
                    {
                        "id": 98869,
                        "name": "Karasuk",
                        "latitude": "53.73772000",
                        "longitude": "78.04026000"
                    },
                    {
                        "id": 98878,
                        "name": "Kargat",
                        "latitude": "55.19556000",
                        "longitude": "80.28111000"
                    },
                    {
                        "id": 99119,
                        "name": "Kochenëvo",
                        "latitude": "55.02180000",
                        "longitude": "82.20200000"
                    },
                    {
                        "id": 99121,
                        "name": "Kochki",
                        "latitude": "54.33583000",
                        "longitude": "80.48056000"
                    },
                    {
                        "id": 99157,
                        "name": "Kol’tsovo",
                        "latitude": "54.93760000",
                        "longitude": "83.18250000"
                    },
                    {
                        "id": 99153,
                        "name": "Kolyvan’",
                        "latitude": "55.30530000",
                        "longitude": "82.73910000"
                    },
                    {
                        "id": 99329,
                        "name": "Krasnoobsk",
                        "latitude": "54.91980000",
                        "longitude": "82.99090000"
                    },
                    {
                        "id": 99358,
                        "name": "Krasnozërskoye",
                        "latitude": "53.98277000",
                        "longitude": "79.23735000"
                    },
                    {
                        "id": 99392,
                        "name": "Krivodanovka",
                        "latitude": "55.08810000",
                        "longitude": "82.65510000"
                    },
                    {
                        "id": 99422,
                        "name": "Kudryashovskiy",
                        "latitude": "55.09740000",
                        "longitude": "82.77420000"
                    },
                    {
                        "id": 99451,
                        "name": "Kupino",
                        "latitude": "54.36635000",
                        "longitude": "77.29805000"
                    },
                    {
                        "id": 99493,
                        "name": "Kuybyshev",
                        "latitude": "55.44753000",
                        "longitude": "78.32181000"
                    },
                    {
                        "id": 99520,
                        "name": "Kyshtovka",
                        "latitude": "56.55498000",
                        "longitude": "76.62713000"
                    },
                    {
                        "id": 99631,
                        "name": "Linëvo",
                        "latitude": "54.45890000",
                        "longitude": "83.37640000"
                    },
                    {
                        "id": 99640,
                        "name": "Listvyanskiy",
                        "latitude": "54.43990000",
                        "longitude": "83.49840000"
                    },
                    {
                        "id": 99812,
                        "name": "Maslyanino",
                        "latitude": "54.34361000",
                        "longitude": "84.21111000"
                    },
                    {
                        "id": 99813,
                        "name": "Maslyaninskiy Rayon",
                        "latitude": "54.50000000",
                        "longitude": "84.50000000"
                    },
                    {
                        "id": 99938,
                        "name": "Mochishche",
                        "latitude": "55.15860000",
                        "longitude": "83.12290000"
                    },
                    {
                        "id": 99975,
                        "name": "Moshkovo",
                        "latitude": "55.30530000",
                        "longitude": "83.61040000"
                    },
                    {
                        "id": 99976,
                        "name": "Moshkovskiy Rayon",
                        "latitude": "55.30000000",
                        "longitude": "83.61667000"
                    },
                    {
                        "id": 100264,
                        "name": "Novolugovoye",
                        "latitude": "54.97920000",
                        "longitude": "83.11380000"
                    },
                    {
                        "id": 100302,
                        "name": "Novosibirsk",
                        "latitude": "55.04150000",
                        "longitude": "82.93460000"
                    },
                    {
                        "id": 100303,
                        "name": "Novosibirskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "83.00000000"
                    },
                    {
                        "id": 100394,
                        "name": "Ob’",
                        "latitude": "54.98720000",
                        "longitude": "82.71660000"
                    },
                    {
                        "id": 100458,
                        "name": "Ordynskiy Rayon",
                        "latitude": "54.33333000",
                        "longitude": "81.66667000"
                    },
                    {
                        "id": 100459,
                        "name": "Ordynskoye",
                        "latitude": "54.36560000",
                        "longitude": "81.89940000"
                    },
                    {
                        "id": 100757,
                        "name": "Polovinnoye",
                        "latitude": "53.75671000",
                        "longitude": "79.24327000"
                    },
                    {
                        "id": 100861,
                        "name": "Prokudskoye",
                        "latitude": "55.00890000",
                        "longitude": "82.45740000"
                    },
                    {
                        "id": 101066,
                        "name": "Sadovyy",
                        "latitude": "55.13610000",
                        "longitude": "82.96590000"
                    },
                    {
                        "id": 101205,
                        "name": "Severnoye",
                        "latitude": "56.34912000",
                        "longitude": "78.36189000"
                    },
                    {
                        "id": 101209,
                        "name": "Severnyy Rayon",
                        "latitude": "56.33333000",
                        "longitude": "78.50000000"
                    },
                    {
                        "id": 101444,
                        "name": "Sokur",
                        "latitude": "55.20930000",
                        "longitude": "83.31900000"
                    },
                    {
                        "id": 101555,
                        "name": "Stantsionno-Oyashinskiy",
                        "latitude": "55.46640000",
                        "longitude": "83.82450000"
                    },
                    {
                        "id": 101693,
                        "name": "Suzun",
                        "latitude": "53.78410000",
                        "longitude": "82.31160000"
                    },
                    {
                        "id": 101786,
                        "name": "Tashara",
                        "latitude": "55.51950000",
                        "longitude": "83.50940000"
                    },
                    {
                        "id": 101792,
                        "name": "Tatarsk",
                        "latitude": "55.21903000",
                        "longitude": "75.98283000"
                    },
                    {
                        "id": 101795,
                        "name": "Tatarskiy Rayon",
                        "latitude": "55.25000000",
                        "longitude": "76.00000000"
                    },
                    {
                        "id": 101869,
                        "name": "Toguchin",
                        "latitude": "55.23528000",
                        "longitude": "84.38583000"
                    },
                    {
                        "id": 101878,
                        "name": "Tolmachëvo",
                        "latitude": "54.98240000",
                        "longitude": "82.73630000"
                    },
                    {
                        "id": 102012,
                        "name": "Ubinskoye",
                        "latitude": "55.30675000",
                        "longitude": "79.68016000"
                    },
                    {
                        "id": 102139,
                        "name": "Ust’-Tarka",
                        "latitude": "55.56715000",
                        "longitude": "75.70500000"
                    },
                    {
                        "id": 102224,
                        "name": "Vengerovo",
                        "latitude": "55.68485000",
                        "longitude": "76.74707000"
                    },
                    {
                        "id": 102234,
                        "name": "Verkh-Tula",
                        "latitude": "54.88390000",
                        "longitude": "82.77620000"
                    },
                    {
                        "id": 102496,
                        "name": "Yarkovo",
                        "latitude": "54.80560000",
                        "longitude": "82.59890000"
                    },
                    {
                        "id": 102688,
                        "name": "Zdvinsk",
                        "latitude": "54.70206000",
                        "longitude": "78.66105000"
                    }
                ]
            },
            {
                "id": 1846,
                "name": "Omsk",
                "iso2": "OMS",
                "latitude": "55.05546690",
                "longitude": "73.31673420",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97735,
                        "name": "Azovo",
                        "latitude": "54.69972000",
                        "longitude": "73.02367000"
                    },
                    {
                        "id": 97891,
                        "name": "Beregovoy",
                        "latitude": "55.17301000",
                        "longitude": "73.21984000"
                    },
                    {
                        "id": 98005,
                        "name": "Bol’sherech’ye",
                        "latitude": "56.09252000",
                        "longitude": "74.62716000"
                    },
                    {
                        "id": 98162,
                        "name": "Cherlak",
                        "latitude": "54.15500000",
                        "longitude": "74.80550000"
                    },
                    {
                        "id": 98694,
                        "name": "Irtyshskiy",
                        "latitude": "54.81426000",
                        "longitude": "73.58722000"
                    },
                    {
                        "id": 98779,
                        "name": "Kalachinsk",
                        "latitude": "55.05286000",
                        "longitude": "74.57511000"
                    },
                    {
                        "id": 99145,
                        "name": "Kolosovka",
                        "latitude": "56.46779000",
                        "longitude": "73.61096000"
                    },
                    {
                        "id": 99209,
                        "name": "Kormilovka",
                        "latitude": "55.00264000",
                        "longitude": "74.10281000"
                    },
                    {
                        "id": 99342,
                        "name": "Krasnoyarka",
                        "latitude": "55.33333000",
                        "longitude": "73.11667000"
                    },
                    {
                        "id": 99380,
                        "name": "Krasnyy Yar",
                        "latitude": "55.24242000",
                        "longitude": "72.92635000"
                    },
                    {
                        "id": 99402,
                        "name": "Krutaya Gorka",
                        "latitude": "55.36493000",
                        "longitude": "73.22310000"
                    },
                    {
                        "id": 99404,
                        "name": "Krutinka",
                        "latitude": "56.00550000",
                        "longitude": "71.51131000"
                    },
                    {
                        "id": 99698,
                        "name": "Luzino",
                        "latitude": "54.94811000",
                        "longitude": "73.03531000"
                    },
                    {
                        "id": 99717,
                        "name": "Lyubinskiy",
                        "latitude": "55.15421000",
                        "longitude": "72.69247000"
                    },
                    {
                        "id": 100014,
                        "name": "Muromtsevo",
                        "latitude": "56.37238000",
                        "longitude": "75.24175000"
                    },
                    {
                        "id": 100016,
                        "name": "Muromtsevskiy Rayon",
                        "latitude": "56.41667000",
                        "longitude": "75.50000000"
                    },
                    {
                        "id": 100079,
                        "name": "Nazyvayevsk",
                        "latitude": "55.56975000",
                        "longitude": "71.35294000"
                    },
                    {
                        "id": 100184,
                        "name": "Nizhnyaya Omka",
                        "latitude": "55.43375000",
                        "longitude": "74.94256000"
                    },
                    {
                        "id": 100272,
                        "name": "Novoomskiy",
                        "latitude": "54.84152000",
                        "longitude": "73.30174000"
                    },
                    {
                        "id": 100326,
                        "name": "Novovarshavka",
                        "latitude": "54.17210000",
                        "longitude": "74.69460000"
                    },
                    {
                        "id": 100397,
                        "name": "Odesskoye",
                        "latitude": "54.21500000",
                        "longitude": "72.96510000"
                    },
                    {
                        "id": 100406,
                        "name": "Okoneshnikovo",
                        "latitude": "54.83767000",
                        "longitude": "75.08343000"
                    },
                    {
                        "id": 100440,
                        "name": "Omsk",
                        "latitude": "54.99244000",
                        "longitude": "73.36859000"
                    },
                    {
                        "id": 100566,
                        "name": "Pavlogradka",
                        "latitude": "54.20240000",
                        "longitude": "73.55920000"
                    },
                    {
                        "id": 100759,
                        "name": "Poltavka",
                        "latitude": "54.36629000",
                        "longitude": "71.76319000"
                    },
                    {
                        "id": 101008,
                        "name": "Rostovka",
                        "latitude": "55.38420000",
                        "longitude": "71.88913000"
                    },
                    {
                        "id": 101029,
                        "name": "Russkaya Polyana",
                        "latitude": "53.77944000",
                        "longitude": "73.88056000"
                    },
                    {
                        "id": 101117,
                        "name": "Sargatskoye",
                        "latitude": "55.61006000",
                        "longitude": "73.49716000"
                    },
                    {
                        "id": 101147,
                        "name": "Sedel’nikovskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "75.50000000"
                    },
                    {
                        "id": 101304,
                        "name": "Sherbakul’",
                        "latitude": "54.63159000",
                        "longitude": "72.39635000"
                    },
                    {
                        "id": 101768,
                        "name": "Tara",
                        "latitude": "56.89436000",
                        "longitude": "74.37096000"
                    },
                    {
                        "id": 101801,
                        "name": "Tavricheskoye",
                        "latitude": "54.58508000",
                        "longitude": "73.63950000"
                    },
                    {
                        "id": 101845,
                        "name": "Tevriz",
                        "latitude": "57.50900000",
                        "longitude": "72.40420000"
                    },
                    {
                        "id": 101913,
                        "name": "Troitsk",
                        "latitude": "55.70128000",
                        "longitude": "72.23369000"
                    },
                    {
                        "id": 102000,
                        "name": "Tyukalinsk",
                        "latitude": "55.87321000",
                        "longitude": "72.19673000"
                    },
                    {
                        "id": 102121,
                        "name": "Ust’-Ishim",
                        "latitude": "57.69350000",
                        "longitude": "71.16650000"
                    },
                    {
                        "id": 102324,
                        "name": "Vkhodnoy",
                        "latitude": "54.95181000",
                        "longitude": "73.17108000"
                    },
                    {
                        "id": 102763,
                        "name": "Znamenskoye",
                        "latitude": "57.12806000",
                        "longitude": "73.82821000"
                    }
                ]
            },
            {
                "id": 1886,
                "name": "Orenburg",
                "iso2": "ORE",
                "latitude": "51.76340260",
                "longitude": "54.61881880",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97485,
                        "name": "Abdulino",
                        "latitude": "53.70000000",
                        "longitude": "53.66667000"
                    },
                    {
                        "id": 97501,
                        "name": "Adamovka",
                        "latitude": "51.52230000",
                        "longitude": "59.93960000"
                    },
                    {
                        "id": 97557,
                        "name": "Alandskoye",
                        "latitude": "52.22611000",
                        "longitude": "59.79389000"
                    },
                    {
                        "id": 97695,
                        "name": "Asekeyevo",
                        "latitude": "53.57425000",
                        "longitude": "52.79724000"
                    },
                    {
                        "id": 97877,
                        "name": "Belyayevka",
                        "latitude": "51.39742000",
                        "longitude": "56.41667000"
                    },
                    {
                        "id": 98069,
                        "name": "Buguruslan",
                        "latitude": "53.65540000",
                        "longitude": "52.44200000"
                    },
                    {
                        "id": 98096,
                        "name": "Buzuluk",
                        "latitude": "52.78070000",
                        "longitude": "52.26350000"
                    },
                    {
                        "id": 98305,
                        "name": "Dombarovskiy",
                        "latitude": "50.75870000",
                        "longitude": "59.53860000"
                    },
                    {
                        "id": 98396,
                        "name": "Energetik",
                        "latitude": "51.74450000",
                        "longitude": "58.79340000"
                    },
                    {
                        "id": 98465,
                        "name": "Gay",
                        "latitude": "51.46660000",
                        "longitude": "58.45520000"
                    },
                    {
                        "id": 98645,
                        "name": "Ilek",
                        "latitude": "51.52709000",
                        "longitude": "53.38306000"
                    },
                    {
                        "id": 98872,
                        "name": "Kardailovo",
                        "latitude": "51.53861000",
                        "longitude": "53.90417000"
                    },
                    {
                        "id": 99149,
                        "name": "Koltubanovskiy",
                        "latitude": "52.94070000",
                        "longitude": "52.02690000"
                    },
                    {
                        "id": 99312,
                        "name": "Krasnogvardeyets",
                        "latitude": "52.68040000",
                        "longitude": "52.36350000"
                    },
                    {
                        "id": 99323,
                        "name": "Krasnokholm",
                        "latitude": "51.59787000",
                        "longitude": "54.15670000"
                    },
                    {
                        "id": 99345,
                        "name": "Krasnoyarskiy",
                        "latitude": "51.96500000",
                        "longitude": "59.89667000"
                    },
                    {
                        "id": 99365,
                        "name": "Krasnyy Kommunar",
                        "latitude": "51.96436000",
                        "longitude": "55.36680000"
                    },
                    {
                        "id": 99467,
                        "name": "Kurmanayevka",
                        "latitude": "52.50930000",
                        "longitude": "52.06750000"
                    },
                    {
                        "id": 99490,
                        "name": "Kuvandyk",
                        "latitude": "51.47810000",
                        "longitude": "57.35520000"
                    },
                    {
                        "id": 99513,
                        "name": "Kvarkeno",
                        "latitude": "52.08333000",
                        "longitude": "59.72500000"
                    },
                    {
                        "id": 99514,
                        "name": "Kvarkenskiy Rayon",
                        "latitude": "52.16667000",
                        "longitude": "59.50000000"
                    },
                    {
                        "id": 99816,
                        "name": "Matveyevka",
                        "latitude": "52.15000000",
                        "longitude": "56.18333000"
                    },
                    {
                        "id": 99840,
                        "name": "Mednogorsk",
                        "latitude": "51.41280000",
                        "longitude": "57.59500000"
                    },
                    {
                        "id": 100127,
                        "name": "Nezhinka",
                        "latitude": "51.76760000",
                        "longitude": "55.36940000"
                    },
                    {
                        "id": 100157,
                        "name": "Nizhnepavlovka",
                        "latitude": "51.71324000",
                        "longitude": "54.80146000"
                    },
                    {
                        "id": 100274,
                        "name": "Novoorsk",
                        "latitude": "51.38100000",
                        "longitude": "58.98130000"
                    },
                    {
                        "id": 100275,
                        "name": "Novoorskiy Rayon",
                        "latitude": "51.50000000",
                        "longitude": "59.00000000"
                    },
                    {
                        "id": 100290,
                        "name": "Novorudnyy",
                        "latitude": "51.50260000",
                        "longitude": "58.18730000"
                    },
                    {
                        "id": 100296,
                        "name": "Novosergiyevka",
                        "latitude": "52.09340000",
                        "longitude": "53.65280000"
                    },
                    {
                        "id": 100316,
                        "name": "Novotroitsk",
                        "latitude": "51.20301000",
                        "longitude": "58.32665000"
                    },
                    {
                        "id": 100465,
                        "name": "Orenburg",
                        "latitude": "51.77270000",
                        "longitude": "55.09880000"
                    },
                    {
                        "id": 100480,
                        "name": "Orsk",
                        "latitude": "51.20487000",
                        "longitude": "58.56685000"
                    },
                    {
                        "id": 100608,
                        "name": "Perevolotskiy",
                        "latitude": "51.87633000",
                        "longitude": "54.19378000"
                    },
                    {
                        "id": 100702,
                        "name": "Pleshanovo",
                        "latitude": "52.83333000",
                        "longitude": "53.48333000"
                    },
                    {
                        "id": 100718,
                        "name": "Podgorodnyaya Pokrovka",
                        "latitude": "51.82808000",
                        "longitude": "54.98740000"
                    },
                    {
                        "id": 100821,
                        "name": "Prigorodnyy",
                        "latitude": "51.76608000",
                        "longitude": "55.26648000"
                    },
                    {
                        "id": 101076,
                        "name": "Sakmara",
                        "latitude": "51.98438000",
                        "longitude": "55.33380000"
                    },
                    {
                        "id": 101106,
                        "name": "Saraktash",
                        "latitude": "51.78771000",
                        "longitude": "56.36091000"
                    },
                    {
                        "id": 101107,
                        "name": "Saraktashskiy Rayon",
                        "latitude": "51.83333000",
                        "longitude": "56.41667000"
                    },
                    {
                        "id": 101204,
                        "name": "Severnoye",
                        "latitude": "54.09347000",
                        "longitude": "52.54393000"
                    },
                    {
                        "id": 101262,
                        "name": "Sharlyk",
                        "latitude": "52.91667000",
                        "longitude": "54.75000000"
                    },
                    {
                        "id": 101317,
                        "name": "Shil’da",
                        "latitude": "51.81430000",
                        "longitude": "59.77440000"
                    },
                    {
                        "id": 101472,
                        "name": "Sol’-Iletsk",
                        "latitude": "51.16310000",
                        "longitude": "54.99176000"
                    },
                    {
                        "id": 101477,
                        "name": "Sorochinsk",
                        "latitude": "52.43380000",
                        "longitude": "53.15830000"
                    },
                    {
                        "id": 101557,
                        "name": "Staraya Akkermanovka",
                        "latitude": "51.24669000",
                        "longitude": "58.23908000"
                    },
                    {
                        "id": 101708,
                        "name": "Svetlyy",
                        "latitude": "50.81833000",
                        "longitude": "60.85194000"
                    },
                    {
                        "id": 101787,
                        "name": "Tashla",
                        "latitude": "51.77157000",
                        "longitude": "52.74270000"
                    },
                    {
                        "id": 101793,
                        "name": "Tatarskaya Kargala",
                        "latitude": "51.94952000",
                        "longitude": "55.17314000"
                    },
                    {
                        "id": 101906,
                        "name": "Totskoye",
                        "latitude": "52.52478000",
                        "longitude": "52.76228000"
                    },
                    {
                        "id": 102004,
                        "name": "Tyul’gan",
                        "latitude": "52.34049000",
                        "longitude": "56.16604000"
                    },
                    {
                        "id": 102515,
                        "name": "Yasnyy",
                        "latitude": "51.03330000",
                        "longitude": "59.87420000"
                    },
                    {
                        "id": 102540,
                        "name": "Yelizavetinka",
                        "latitude": "51.76732000",
                        "longitude": "59.74245000"
                    }
                ]
            },
            {
                "id": 1908,
                "name": "Oryol",
                "iso2": "ORL",
                "latitude": "52.78564140",
                "longitude": "36.92423440",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97991,
                        "name": "Bolkhov",
                        "latitude": "53.44295000",
                        "longitude": "36.00546000"
                    },
                    {
                        "id": 97992,
                        "name": "Bolkhovskiy Rayon",
                        "latitude": "53.41667000",
                        "longitude": "36.00000000"
                    },
                    {
                        "id": 98286,
                        "name": "Dmitrovsk-Orlovskiy",
                        "latitude": "52.50500000",
                        "longitude": "35.14640000"
                    },
                    {
                        "id": 98496,
                        "name": "Glazunovka",
                        "latitude": "52.50057000",
                        "longitude": "36.31997000"
                    },
                    {
                        "id": 99002,
                        "name": "Khomutovo",
                        "latitude": "52.85386000",
                        "longitude": "37.43880000"
                    },
                    {
                        "id": 99011,
                        "name": "Khotynets",
                        "latitude": "53.12860000",
                        "longitude": "35.39660000"
                    },
                    {
                        "id": 99148,
                        "name": "Kolpny",
                        "latitude": "52.22823000",
                        "longitude": "37.03683000"
                    },
                    {
                        "id": 99219,
                        "name": "Korsakovo",
                        "latitude": "53.26767000",
                        "longitude": "37.35689000"
                    },
                    {
                        "id": 99287,
                        "name": "Krasnaya Zarya",
                        "latitude": "52.78250000",
                        "longitude": "37.68056000"
                    },
                    {
                        "id": 99396,
                        "name": "Kromy",
                        "latitude": "52.68762000",
                        "longitude": "35.76665000"
                    },
                    {
                        "id": 99644,
                        "name": "Livny",
                        "latitude": "52.42534000",
                        "longitude": "37.60689000"
                    },
                    {
                        "id": 99762,
                        "name": "Maloarkhangel’sk",
                        "latitude": "52.40024000",
                        "longitude": "36.50332000"
                    },
                    {
                        "id": 99992,
                        "name": "Mtsensk",
                        "latitude": "53.27657000",
                        "longitude": "36.57334000"
                    },
                    {
                        "id": 100063,
                        "name": "Naryshkino",
                        "latitude": "52.96778000",
                        "longitude": "35.72677000"
                    },
                    {
                        "id": 100305,
                        "name": "Novosil’",
                        "latitude": "52.97387000",
                        "longitude": "37.04048000"
                    },
                    {
                        "id": 100482,
                        "name": "Orël",
                        "latitude": "52.96508000",
                        "longitude": "36.07849000"
                    },
                    {
                        "id": 100748,
                        "name": "Pokrovskoye",
                        "latitude": "52.60968000",
                        "longitude": "36.87124000"
                    },
                    {
                        "id": 101230,
                        "name": "Shablykino",
                        "latitude": "52.85661000",
                        "longitude": "35.19637000"
                    },
                    {
                        "id": 101483,
                        "name": "Soskovo",
                        "latitude": "52.74752000",
                        "longitude": "35.38277000"
                    },
                    {
                        "id": 101535,
                        "name": "Spasskoye-Lutovinovo",
                        "latitude": "53.37012000",
                        "longitude": "36.62297000"
                    },
                    {
                        "id": 101927,
                        "name": "Trosna",
                        "latitude": "52.44460000",
                        "longitude": "35.77910000"
                    },
                    {
                        "id": 102280,
                        "name": "Verkhov’ye",
                        "latitude": "52.81165000",
                        "longitude": "37.24215000"
                    },
                    {
                        "id": 102442,
                        "name": "Vyshneye Dolgoye",
                        "latitude": "52.06302000",
                        "longitude": "37.40518000"
                    },
                    {
                        "id": 102637,
                        "name": "Zalegoshch’",
                        "latitude": "52.89890000",
                        "longitude": "36.89093000"
                    },
                    {
                        "id": 102755,
                        "name": "Zmiyëvka",
                        "latitude": "52.66697000",
                        "longitude": "36.37426000"
                    },
                    {
                        "id": 102757,
                        "name": "Znamenka",
                        "latitude": "52.89789000",
                        "longitude": "35.97703000"
                    },
                    {
                        "id": 102762,
                        "name": "Znamenskoye",
                        "latitude": "53.27869000",
                        "longitude": "35.69055000"
                    }
                ]
            },
            {
                "id": 1909,
                "name": "Penza",
                "iso2": "PNZ",
                "latitude": "53.14121050",
                "longitude": "44.09400480",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97807,
                        "name": "Bashmakovo",
                        "latitude": "53.21329000",
                        "longitude": "43.03420000"
                    },
                    {
                        "id": 97838,
                        "name": "Bekovo",
                        "latitude": "52.46632000",
                        "longitude": "43.71199000"
                    },
                    {
                        "id": 97851,
                        "name": "Belinskiy",
                        "latitude": "52.96474000",
                        "longitude": "43.41647000"
                    },
                    {
                        "id": 97915,
                        "name": "Bessonovka",
                        "latitude": "53.30968000",
                        "longitude": "45.04069000"
                    },
                    {
                        "id": 97975,
                        "name": "Bogoslovka",
                        "latitude": "53.20837000",
                        "longitude": "44.80133000"
                    },
                    {
                        "id": 98106,
                        "name": "Chaadayevka",
                        "latitude": "53.14270000",
                        "longitude": "45.91220000"
                    },
                    {
                        "id": 98142,
                        "name": "Chemodanovka",
                        "latitude": "53.23162000",
                        "longitude": "45.24738000"
                    },
                    {
                        "id": 98560,
                        "name": "Gorodishche",
                        "latitude": "53.27750000",
                        "longitude": "45.70170000"
                    },
                    {
                        "id": 98574,
                        "name": "Grabovo",
                        "latitude": "53.38751000",
                        "longitude": "45.06395000"
                    },
                    {
                        "id": 98673,
                        "name": "Inderka",
                        "latitude": "53.24846000",
                        "longitude": "46.25823000"
                    },
                    {
                        "id": 98715,
                        "name": "Issa",
                        "latitude": "53.87049000",
                        "longitude": "44.85781000"
                    },
                    {
                        "id": 98717,
                        "name": "Issinskiy Rayon",
                        "latitude": "53.83333000",
                        "longitude": "45.00000000"
                    },
                    {
                        "id": 98836,
                        "name": "Kanayevka",
                        "latitude": "53.10783000",
                        "longitude": "45.56144000"
                    },
                    {
                        "id": 99151,
                        "name": "Kolyshley",
                        "latitude": "52.70050000",
                        "longitude": "44.53670000"
                    },
                    {
                        "id": 99180,
                        "name": "Kondol’",
                        "latitude": "52.81889000",
                        "longitude": "45.05798000"
                    },
                    {
                        "id": 99508,
                        "name": "Kuznetsk",
                        "latitude": "53.11675000",
                        "longitude": "46.60037000"
                    },
                    {
                        "id": 99509,
                        "name": "Kuznetskiy Rayon",
                        "latitude": "53.08333000",
                        "longitude": "46.58333000"
                    },
                    {
                        "id": 99586,
                        "name": "Lermontovo",
                        "latitude": "52.99277000",
                        "longitude": "43.66141000"
                    },
                    {
                        "id": 99662,
                        "name": "Lopatino",
                        "latitude": "52.61949000",
                        "longitude": "45.81184000"
                    },
                    {
                        "id": 99692,
                        "name": "Lunino",
                        "latitude": "53.59176000",
                        "longitude": "45.22709000"
                    },
                    {
                        "id": 99744,
                        "name": "Makhalino",
                        "latitude": "53.08543000",
                        "longitude": "46.22108000"
                    },
                    {
                        "id": 99752,
                        "name": "Malaya Serdoba",
                        "latitude": "52.46610000",
                        "longitude": "44.95120000"
                    },
                    {
                        "id": 99946,
                        "name": "Mokshan",
                        "latitude": "53.43650000",
                        "longitude": "44.61322000"
                    },
                    {
                        "id": 100060,
                        "name": "Narovchat",
                        "latitude": "53.87654000",
                        "longitude": "43.69458000"
                    },
                    {
                        "id": 100118,
                        "name": "Neverkino",
                        "latitude": "52.78541000",
                        "longitude": "46.74174000"
                    },
                    {
                        "id": 100119,
                        "name": "Neverkinskiy Rayon",
                        "latitude": "52.75000000",
                        "longitude": "46.66667000"
                    },
                    {
                        "id": 100144,
                        "name": "Nikol’sk",
                        "latitude": "53.71886000",
                        "longitude": "46.07118000"
                    },
                    {
                        "id": 100171,
                        "name": "Nizhniy Lomov",
                        "latitude": "53.53041000",
                        "longitude": "43.67663000"
                    },
                    {
                        "id": 100526,
                        "name": "Pachelma",
                        "latitude": "53.24426000",
                        "longitude": "43.35205000"
                    },
                    {
                        "id": 100595,
                        "name": "Penza",
                        "latitude": "53.20066000",
                        "longitude": "45.00464000"
                    },
                    {
                        "id": 100738,
                        "name": "Poim",
                        "latitude": "53.02639000",
                        "longitude": "43.18721000"
                    },
                    {
                        "id": 100782,
                        "name": "Poselki",
                        "latitude": "53.13236000",
                        "longitude": "46.50307000"
                    },
                    {
                        "id": 101033,
                        "name": "Russkiy Kameshkir",
                        "latitude": "52.85955000",
                        "longitude": "46.08861000"
                    },
                    {
                        "id": 101174,
                        "name": "Serdobsk",
                        "latitude": "52.45861000",
                        "longitude": "44.21689000"
                    },
                    {
                        "id": 101298,
                        "name": "Shemysheyka",
                        "latitude": "52.89196000",
                        "longitude": "45.39282000"
                    },
                    {
                        "id": 101493,
                        "name": "Sosnovoborsk",
                        "latitude": "53.29066000",
                        "longitude": "46.24849000"
                    },
                    {
                        "id": 101526,
                        "name": "Spassk",
                        "latitude": "53.92559000",
                        "longitude": "43.18394000"
                    },
                    {
                        "id": 101547,
                        "name": "Srednyaya Yelyuzan’",
                        "latitude": "53.02410000",
                        "longitude": "45.95290000"
                    },
                    {
                        "id": 101672,
                        "name": "Sura",
                        "latitude": "53.88786000",
                        "longitude": "45.74192000"
                    },
                    {
                        "id": 101680,
                        "name": "Sursk",
                        "latitude": "53.07542000",
                        "longitude": "45.68461000"
                    },
                    {
                        "id": 101759,
                        "name": "Tamala",
                        "latitude": "52.54097000",
                        "longitude": "43.25145000"
                    },
                    {
                        "id": 102171,
                        "name": "Vadinsk",
                        "latitude": "53.69157000",
                        "longitude": "43.05744000"
                    },
                    {
                        "id": 102255,
                        "name": "Verkhniy Lomov",
                        "latitude": "53.46778000",
                        "longitude": "43.55111000"
                    },
                    {
                        "id": 102283,
                        "name": "Verkhozim",
                        "latitude": "52.71221000",
                        "longitude": "45.41803000"
                    },
                    {
                        "id": 102651,
                        "name": "Zarechnyy",
                        "latitude": "53.20356000",
                        "longitude": "45.19227000"
                    },
                    {
                        "id": 102664,
                        "name": "Zasechnoye",
                        "latitude": "53.10920000",
                        "longitude": "45.07936000"
                    },
                    {
                        "id": 102704,
                        "name": "Zemetchino",
                        "latitude": "53.49730000",
                        "longitude": "42.61632000"
                    }
                ]
            },
            {
                "id": 1871,
                "name": "Perm",
                "iso2": "PER",
                "latitude": "58.82319290",
                "longitude": "56.58724810",
                "type": "administrative territory",
                "cities": [
                    {
                        "id": 97568,
                        "name": "Aleksandrovsk",
                        "latitude": "59.15810000",
                        "longitude": "57.56950000"
                    },
                    {
                        "id": 97793,
                        "name": "Barda",
                        "latitude": "56.92870000",
                        "longitude": "55.59620000"
                    },
                    {
                        "id": 97895,
                        "name": "Berezniki",
                        "latitude": "59.40910000",
                        "longitude": "56.82040000"
                    },
                    {
                        "id": 97900,
                        "name": "Bershet’",
                        "latitude": "57.73090000",
                        "longitude": "56.37830000"
                    },
                    {
                        "id": 98122,
                        "name": "Chastyye",
                        "latitude": "57.28876000",
                        "longitude": "54.97278000"
                    },
                    {
                        "id": 98123,
                        "name": "Chaykovskaya",
                        "latitude": "58.12880000",
                        "longitude": "55.53520000"
                    },
                    {
                        "id": 98124,
                        "name": "Chaykovskiy",
                        "latitude": "56.76864000",
                        "longitude": "54.11484000"
                    },
                    {
                        "id": 98145,
                        "name": "Cherdyn’",
                        "latitude": "60.40295000",
                        "longitude": "56.47868000"
                    },
                    {
                        "id": 98164,
                        "name": "Chermoz",
                        "latitude": "58.78130000",
                        "longitude": "56.15770000"
                    },
                    {
                        "id": 98176,
                        "name": "Chernushka",
                        "latitude": "56.50722000",
                        "longitude": "56.07661000"
                    },
                    {
                        "id": 98227,
                        "name": "Chusovoy",
                        "latitude": "58.30130000",
                        "longitude": "57.81310000"
                    },
                    {
                        "id": 98296,
                        "name": "Dobryanka",
                        "latitude": "58.46440000",
                        "longitude": "56.41270000"
                    },
                    {
                        "id": 98420,
                        "name": "Ferma",
                        "latitude": "57.90160000",
                        "longitude": "56.30640000"
                    },
                    {
                        "id": 98427,
                        "name": "Filippovka",
                        "latitude": "57.43730000",
                        "longitude": "57.01934000"
                    },
                    {
                        "id": 98432,
                        "name": "Foki",
                        "latitude": "56.69300000",
                        "longitude": "54.34985000"
                    },
                    {
                        "id": 98437,
                        "name": "Froly",
                        "latitude": "57.92140000",
                        "longitude": "56.27280000"
                    },
                    {
                        "id": 98455,
                        "name": "Gamovo",
                        "latitude": "57.86520000",
                        "longitude": "56.10560000"
                    },
                    {
                        "id": 98467,
                        "name": "Gayny",
                        "latitude": "60.30707000",
                        "longitude": "54.32412000"
                    },
                    {
                        "id": 98534,
                        "name": "Gornozavodsk",
                        "latitude": "58.37583000",
                        "longitude": "58.32111000"
                    },
                    {
                        "id": 98586,
                        "name": "Gremyachinsk",
                        "latitude": "58.56030000",
                        "longitude": "57.85100000"
                    },
                    {
                        "id": 98601,
                        "name": "Gubakha",
                        "latitude": "58.83862000",
                        "longitude": "57.55325000"
                    },
                    {
                        "id": 98792,
                        "name": "Kalino",
                        "latitude": "58.25040000",
                        "longitude": "57.60850000"
                    },
                    {
                        "id": 98861,
                        "name": "Karagay",
                        "latitude": "58.26669000",
                        "longitude": "54.93678000"
                    },
                    {
                        "id": 98941,
                        "name": "Kerchevskiy",
                        "latitude": "59.94560000",
                        "longitude": "56.29590000"
                    },
                    {
                        "id": 99087,
                        "name": "Kizel",
                        "latitude": "59.04709000",
                        "longitude": "57.64767000"
                    },
                    {
                        "id": 99120,
                        "name": "Kochevo",
                        "latitude": "59.59740000",
                        "longitude": "54.31470000"
                    },
                    {
                        "id": 99160,
                        "name": "Komarikhinskiy",
                        "latitude": "58.09790000",
                        "longitude": "57.11630000"
                    },
                    {
                        "id": 99182,
                        "name": "Kondratovo",
                        "latitude": "57.98040000",
                        "longitude": "56.10660000"
                    },
                    {
                        "id": 99224,
                        "name": "Kosa",
                        "latitude": "59.94490000",
                        "longitude": "54.98950000"
                    },
                    {
                        "id": 99322,
                        "name": "Krasnokamsk",
                        "latitude": "58.07960000",
                        "longitude": "55.75520000"
                    },
                    {
                        "id": 99340,
                        "name": "Krasnovishersk",
                        "latitude": "60.40783000",
                        "longitude": "57.08199000"
                    },
                    {
                        "id": 99423,
                        "name": "Kudymkar",
                        "latitude": "59.01306000",
                        "longitude": "54.65556000"
                    },
                    {
                        "id": 99428,
                        "name": "Kukushtan",
                        "latitude": "57.64640000",
                        "longitude": "56.49520000"
                    },
                    {
                        "id": 99436,
                        "name": "Kultayevo",
                        "latitude": "57.89480000",
                        "longitude": "55.93780000"
                    },
                    {
                        "id": 99446,
                        "name": "Kungur",
                        "latitude": "57.43680000",
                        "longitude": "56.95930000"
                    },
                    {
                        "id": 99497,
                        "name": "Kuyeda",
                        "latitude": "56.43110000",
                        "longitude": "55.58861000"
                    },
                    {
                        "id": 99645,
                        "name": "Lobanovo",
                        "latitude": "57.85950000",
                        "longitude": "56.30260000"
                    },
                    {
                        "id": 99703,
                        "name": "Lyamino",
                        "latitude": "58.28390000",
                        "longitude": "57.72500000"
                    },
                    {
                        "id": 99710,
                        "name": "Lys’va",
                        "latitude": "58.10861000",
                        "longitude": "57.80528000"
                    },
                    {
                        "id": 99823,
                        "name": "Maykor",
                        "latitude": "59.00470000",
                        "longitude": "55.87840000"
                    },
                    {
                        "id": 99860,
                        "name": "Mendeleyevo",
                        "latitude": "58.16976000",
                        "longitude": "54.99634000"
                    },
                    {
                        "id": 100362,
                        "name": "Novyye Lyady",
                        "latitude": "58.05520000",
                        "longitude": "56.61040000"
                    },
                    {
                        "id": 100379,
                        "name": "Nyrob",
                        "latitude": "60.73300000",
                        "longitude": "56.72024000"
                    },
                    {
                        "id": 100380,
                        "name": "Nytva",
                        "latitude": "57.94370000",
                        "longitude": "55.33960000"
                    },
                    {
                        "id": 100396,
                        "name": "Ochër",
                        "latitude": "57.89035000",
                        "longitude": "54.72019000"
                    },
                    {
                        "id": 100402,
                        "name": "Okhansk",
                        "latitude": "57.72030000",
                        "longitude": "55.38820000"
                    },
                    {
                        "id": 100457,
                        "name": "Orda",
                        "latitude": "57.19509000",
                        "longitude": "56.90908000"
                    },
                    {
                        "id": 100484,
                        "name": "Osa",
                        "latitude": "57.28300000",
                        "longitude": "55.45890000"
                    },
                    {
                        "id": 100511,
                        "name": "Overyata",
                        "latitude": "58.08417000",
                        "longitude": "55.86694000"
                    },
                    {
                        "id": 100561,
                        "name": "Pashiya",
                        "latitude": "58.43240000",
                        "longitude": "58.25620000"
                    },
                    {
                        "id": 100576,
                        "name": "Pavlovskiy",
                        "latitude": "57.84240000",
                        "longitude": "54.84357000"
                    },
                    {
                        "id": 100611,
                        "name": "Perm",
                        "latitude": "58.01046000",
                        "longitude": "56.25017000"
                    },
                    {
                        "id": 100751,
                        "name": "Polazna",
                        "latitude": "58.29220000",
                        "longitude": "56.41560000"
                    },
                    {
                        "id": 100799,
                        "name": "Pozhva",
                        "latitude": "59.09120000",
                        "longitude": "56.09010000"
                    },
                    {
                        "id": 101111,
                        "name": "Sarany",
                        "latitude": "58.50000000",
                        "longitude": "58.88333000"
                    },
                    {
                        "id": 101124,
                        "name": "Sars",
                        "latitude": "56.55017000",
                        "longitude": "57.13658000"
                    },
                    {
                        "id": 101210,
                        "name": "Severnyy-Kospashskiy",
                        "latitude": "59.08970000",
                        "longitude": "57.80390000"
                    },
                    {
                        "id": 101239,
                        "name": "Shakhta",
                        "latitude": "59.09050000",
                        "longitude": "57.65750000"
                    },
                    {
                        "id": 101331,
                        "name": "Shirokovskiy",
                        "latitude": "58.84110000",
                        "longitude": "57.78500000"
                    },
                    {
                        "id": 101350,
                        "name": "Shumikhinskiy",
                        "latitude": "58.74480000",
                        "longitude": "57.69260000"
                    },
                    {
                        "id": 101382,
                        "name": "Siva",
                        "latitude": "58.38204000",
                        "longitude": "54.38037000"
                    },
                    {
                        "id": 101433,
                        "name": "Sokol",
                        "latitude": "57.91460000",
                        "longitude": "56.04560000"
                    },
                    {
                        "id": 101451,
                        "name": "Solikamsk",
                        "latitude": "59.63160000",
                        "longitude": "56.76850000"
                    },
                    {
                        "id": 101658,
                        "name": "Suksun",
                        "latitude": "57.14310000",
                        "longitude": "57.39490000"
                    },
                    {
                        "id": 101725,
                        "name": "Sylva",
                        "latitude": "58.03270000",
                        "longitude": "56.77130000"
                    },
                    {
                        "id": 102009,
                        "name": "Tëplaya Gora",
                        "latitude": "58.52444000",
                        "longitude": "59.07278000"
                    },
                    {
                        "id": 102032,
                        "name": "Ugleural’skiy",
                        "latitude": "58.94430000",
                        "longitude": "57.59370000"
                    },
                    {
                        "id": 102041,
                        "name": "Uinskoye",
                        "latitude": "56.88174000",
                        "longitude": "56.58135000"
                    },
                    {
                        "id": 102101,
                        "name": "Usol’ye",
                        "latitude": "59.42190000",
                        "longitude": "56.68620000"
                    },
                    {
                        "id": 102123,
                        "name": "Ust’-Kachka",
                        "latitude": "58.00380000",
                        "longitude": "55.67210000"
                    },
                    {
                        "id": 102130,
                        "name": "Ust’-Kishert’",
                        "latitude": "57.36540000",
                        "longitude": "57.24950000"
                    },
                    {
                        "id": 102228,
                        "name": "Vereshchagino",
                        "latitude": "58.07894000",
                        "longitude": "54.65570000"
                    },
                    {
                        "id": 102237,
                        "name": "Verkhnechusovskiye Gorodki",
                        "latitude": "58.16710000",
                        "longitude": "57.10860000"
                    },
                    {
                        "id": 102518,
                        "name": "Yayva",
                        "latitude": "59.33470000",
                        "longitude": "57.25920000"
                    },
                    {
                        "id": 102547,
                        "name": "Yelovo",
                        "latitude": "57.05381000",
                        "longitude": "54.92070000"
                    },
                    {
                        "id": 102584,
                        "name": "Yubileynyy",
                        "latitude": "58.77940000",
                        "longitude": "57.78220000"
                    },
                    {
                        "id": 102585,
                        "name": "Yug",
                        "latitude": "57.72930000",
                        "longitude": "56.17200000"
                    },
                    {
                        "id": 102587,
                        "name": "Yugo-Kamskiy",
                        "latitude": "57.70260000",
                        "longitude": "55.59040000"
                    },
                    {
                        "id": 102599,
                        "name": "Yurla",
                        "latitude": "59.32510000",
                        "longitude": "54.32780000"
                    },
                    {
                        "id": 102609,
                        "name": "Yus’vinskiy Rayon",
                        "latitude": "59.08333000",
                        "longitude": "55.25000000"
                    },
                    {
                        "id": 102621,
                        "name": "Yuzhnyy-Kospashskiy",
                        "latitude": "58.97250000",
                        "longitude": "57.75900000"
                    },
                    {
                        "id": 102783,
                        "name": "Zvëzdnyy",
                        "latitude": "57.73250000",
                        "longitude": "56.31472000"
                    },
                    {
                        "id": 102789,
                        "name": "Zyukayka",
                        "latitude": "58.20416000",
                        "longitude": "54.70784000"
                    }
                ]
            },
            {
                "id": 1833,
                "name": "Primorsky",
                "iso2": "PRI",
                "latitude": "45.05256410",
                "longitude": "135.00000000",
                "type": "administrative territory",
                "cities": [
                    {
                        "id": 97644,
                        "name": "Anuchino",
                        "latitude": "43.96571000",
                        "longitude": "133.05846000"
                    },
                    {
                        "id": 97645,
                        "name": "Anuchinskiy Rayon",
                        "latitude": "44.00000000",
                        "longitude": "133.00000000"
                    },
                    {
                        "id": 97678,
                        "name": "Arsen’yev",
                        "latitude": "44.15254000",
                        "longitude": "133.27791000"
                    },
                    {
                        "id": 97686,
                        "name": "Artëm",
                        "latitude": "43.35950000",
                        "longitude": "132.18887000"
                    },
                    {
                        "id": 97789,
                        "name": "Barabash",
                        "latitude": "43.19948000",
                        "longitude": "131.49185000"
                    },
                    {
                        "id": 97946,
                        "name": "Blagodatnoye",
                        "latitude": "44.32285000",
                        "longitude": "132.09050000"
                    },
                    {
                        "id": 98008,
                        "name": "Bol’shoy Kamen’",
                        "latitude": "43.11283000",
                        "longitude": "132.35400000"
                    },
                    {
                        "id": 98166,
                        "name": "Chernigovka",
                        "latitude": "44.34216000",
                        "longitude": "132.56937000"
                    },
                    {
                        "id": 98167,
                        "name": "Chernigovskiy Rayon",
                        "latitude": "44.33333000",
                        "longitude": "132.58333000"
                    },
                    {
                        "id": 98182,
                        "name": "Chernyshëvka",
                        "latitude": "44.19971000",
                        "longitude": "133.13193000"
                    },
                    {
                        "id": 98208,
                        "name": "Chkalovskoye",
                        "latitude": "44.83808000",
                        "longitude": "133.04332000"
                    },
                    {
                        "id": 98217,
                        "name": "Chuguyevka",
                        "latitude": "44.16652000",
                        "longitude": "133.86495000"
                    },
                    {
                        "id": 98237,
                        "name": "Dalnegorsk",
                        "latitude": "44.55745000",
                        "longitude": "135.62090000"
                    },
                    {
                        "id": 98238,
                        "name": "Dalnerechensk",
                        "latitude": "45.93149000",
                        "longitude": "133.73906000"
                    },
                    {
                        "id": 98323,
                        "name": "Dostoyevka",
                        "latitude": "44.32554000",
                        "longitude": "133.48134000"
                    },
                    {
                        "id": 98356,
                        "name": "Dunay",
                        "latitude": "42.87881000",
                        "longitude": "132.33521000"
                    },
                    {
                        "id": 98392,
                        "name": "Emar",
                        "latitude": "43.20417000",
                        "longitude": "132.15643000"
                    },
                    {
                        "id": 98433,
                        "name": "Fokino",
                        "latitude": "42.97429000",
                        "longitude": "132.40574000"
                    },
                    {
                        "id": 98532,
                        "name": "Gornorechenskiy",
                        "latitude": "44.26555000",
                        "longitude": "135.11465000"
                    },
                    {
                        "id": 98545,
                        "name": "Gornyye Klyuchi",
                        "latitude": "45.24221000",
                        "longitude": "133.50601000"
                    },
                    {
                        "id": 98580,
                        "name": "Grazhdanka",
                        "latitude": "44.21630000",
                        "longitude": "133.17706000"
                    },
                    {
                        "id": 98730,
                        "name": "Ivanovka",
                        "latitude": "43.96879000",
                        "longitude": "132.48331000"
                    },
                    {
                        "id": 98823,
                        "name": "Kamen’-Rybolov",
                        "latitude": "44.74520000",
                        "longitude": "132.04650000"
                    },
                    {
                        "id": 98814,
                        "name": "Kamenka",
                        "latitude": "44.45865000",
                        "longitude": "136.01403000"
                    },
                    {
                        "id": 98912,
                        "name": "Kavalerovo",
                        "latitude": "44.27221000",
                        "longitude": "135.05227000"
                    },
                    {
                        "id": 98969,
                        "name": "Khasanskiy Rayon",
                        "latitude": "42.75000000",
                        "longitude": "131.00000000"
                    },
                    {
                        "id": 99007,
                        "name": "Khorol’",
                        "latitude": "44.42631000",
                        "longitude": "132.07638000"
                    },
                    {
                        "id": 99069,
                        "name": "Kirovskiy",
                        "latitude": "45.09272000",
                        "longitude": "133.50084000"
                    },
                    {
                        "id": 99113,
                        "name": "Knevichi",
                        "latitude": "43.39975000",
                        "longitude": "132.18808000"
                    },
                    {
                        "id": 99275,
                        "name": "Kraskino",
                        "latitude": "42.71071000",
                        "longitude": "130.78126000"
                    },
                    {
                        "id": 99331,
                        "name": "Krasnorechenskiy",
                        "latitude": "44.62807000",
                        "longitude": "135.35262000"
                    },
                    {
                        "id": 99550,
                        "name": "Lazo",
                        "latitude": "43.38563000",
                        "longitude": "133.90610000"
                    },
                    {
                        "id": 99551,
                        "name": "Lazovskiy Rayon",
                        "latitude": "43.25000000",
                        "longitude": "134.00000000"
                    },
                    {
                        "id": 99605,
                        "name": "Lesozavodsk",
                        "latitude": "45.47885000",
                        "longitude": "133.42825000"
                    },
                    {
                        "id": 99635,
                        "name": "Lipovtsy",
                        "latitude": "44.20018000",
                        "longitude": "131.72373000"
                    },
                    {
                        "id": 99642,
                        "name": "Livadiya",
                        "latitude": "42.86820000",
                        "longitude": "132.67367000"
                    },
                    {
                        "id": 99678,
                        "name": "Luchegorsk",
                        "latitude": "46.47656000",
                        "longitude": "134.19532000"
                    },
                    {
                        "id": 99679,
                        "name": "Luchki",
                        "latitude": "44.28613000",
                        "longitude": "132.25975000"
                    },
                    {
                        "id": 99700,
                        "name": "Lyalichi",
                        "latitude": "44.07352000",
                        "longitude": "132.38991000"
                    },
                    {
                        "id": 99898,
                        "name": "Mikhaylovka",
                        "latitude": "43.93283000",
                        "longitude": "132.00911000"
                    },
                    {
                        "id": 99903,
                        "name": "Mikhaylovskiy Rayon",
                        "latitude": "44.00000000",
                        "longitude": "132.00000000"
                    },
                    {
                        "id": 99935,
                        "name": "Mnogoudobnoye",
                        "latitude": "43.46802000",
                        "longitude": "132.46675000"
                    },
                    {
                        "id": 99955,
                        "name": "Monastyrishche",
                        "latitude": "44.19641000",
                        "longitude": "132.50223000"
                    },
                    {
                        "id": 100040,
                        "name": "Nadezhdinskiy Rayon",
                        "latitude": "43.41667000",
                        "longitude": "132.00000000"
                    },
                    {
                        "id": 100052,
                        "name": "Nakhodka",
                        "latitude": "42.81384000",
                        "longitude": "132.87348000"
                    },
                    {
                        "id": 100271,
                        "name": "Novonikol’sk",
                        "latitude": "43.85518000",
                        "longitude": "131.86257000"
                    },
                    {
                        "id": 100285,
                        "name": "Novopokrovka",
                        "latitude": "45.85296000",
                        "longitude": "134.50035000"
                    },
                    {
                        "id": 100298,
                        "name": "Novoshakhtinskiy",
                        "latitude": "44.02576000",
                        "longitude": "132.16583000"
                    },
                    {
                        "id": 100312,
                        "name": "Novosysoyevka",
                        "latitude": "44.23470000",
                        "longitude": "133.36420000"
                    },
                    {
                        "id": 100339,
                        "name": "Novyy",
                        "latitude": "43.36438000",
                        "longitude": "132.02109000"
                    },
                    {
                        "id": 100431,
                        "name": "Ol’ga",
                        "latitude": "43.74735000",
                        "longitude": "135.29090000"
                    },
                    {
                        "id": 100555,
                        "name": "Partizansk",
                        "latitude": "43.12165000",
                        "longitude": "133.12347000"
                    },
                    {
                        "id": 100695,
                        "name": "Plastun",
                        "latitude": "44.76077000",
                        "longitude": "136.28048000"
                    },
                    {
                        "id": 100737,
                        "name": "Pogranichnyy",
                        "latitude": "44.40970000",
                        "longitude": "131.37780000"
                    },
                    {
                        "id": 100743,
                        "name": "Pokrovka",
                        "latitude": "43.95331000",
                        "longitude": "131.63443000"
                    },
                    {
                        "id": 100771,
                        "name": "Popova",
                        "latitude": "42.96096000",
                        "longitude": "131.72494000"
                    },
                    {
                        "id": 100811,
                        "name": "Preobrazheniye",
                        "latitude": "42.90117000",
                        "longitude": "133.90430000"
                    },
                    {
                        "id": 100832,
                        "name": "Primorskiy",
                        "latitude": "43.09962000",
                        "longitude": "131.58938000"
                    },
                    {
                        "id": 100905,
                        "name": "Putyatin",
                        "latitude": "42.86179000",
                        "longitude": "132.41564000"
                    },
                    {
                        "id": 100950,
                        "name": "Razdol’noye",
                        "latitude": "43.53894000",
                        "longitude": "131.89691000"
                    },
                    {
                        "id": 100966,
                        "name": "Rettikhovka",
                        "latitude": "44.17038000",
                        "longitude": "132.77083000"
                    },
                    {
                        "id": 100988,
                        "name": "Romanovka",
                        "latitude": "43.23294000",
                        "longitude": "132.45714000"
                    },
                    {
                        "id": 101021,
                        "name": "Rudnaya Pristan’",
                        "latitude": "44.35812000",
                        "longitude": "135.81478000"
                    },
                    {
                        "id": 101026,
                        "name": "Rudnyy",
                        "latitude": "44.27759000",
                        "longitude": "134.96106000"
                    },
                    {
                        "id": 101031,
                        "name": "Russkiy",
                        "latitude": "43.02240000",
                        "longitude": "131.86010000"
                    },
                    {
                        "id": 101181,
                        "name": "Sergeyevka",
                        "latitude": "43.34909000",
                        "longitude": "133.35972000"
                    },
                    {
                        "id": 101333,
                        "name": "Shkotovo",
                        "latitude": "43.32092000",
                        "longitude": "132.35433000"
                    },
                    {
                        "id": 101334,
                        "name": "Shkotovskiy Rayon",
                        "latitude": "43.33333000",
                        "longitude": "132.58333000"
                    },
                    {
                        "id": 101341,
                        "name": "Shtykovo",
                        "latitude": "43.38918000",
                        "longitude": "132.36129000"
                    },
                    {
                        "id": 101384,
                        "name": "Sivakovka",
                        "latitude": "44.47838000",
                        "longitude": "132.36718000"
                    },
                    {
                        "id": 101404,
                        "name": "Slavyanka",
                        "latitude": "42.86413000",
                        "longitude": "131.38820000"
                    },
                    {
                        "id": 101420,
                        "name": "Smolyaninovo",
                        "latitude": "43.28801000",
                        "longitude": "132.45586000"
                    },
                    {
                        "id": 101528,
                        "name": "Spassk-Dal’niy",
                        "latitude": "44.59884000",
                        "longitude": "132.82593000"
                    },
                    {
                        "id": 101532,
                        "name": "Spasskiy Rayon",
                        "latitude": "44.50000000",
                        "longitude": "133.00000000"
                    },
                    {
                        "id": 101534,
                        "name": "Spasskoye",
                        "latitude": "44.61215000",
                        "longitude": "132.80007000"
                    },
                    {
                        "id": 101700,
                        "name": "Svetlaya",
                        "latitude": "46.54217000",
                        "longitude": "138.32973000"
                    },
                    {
                        "id": 101800,
                        "name": "Tavrichanka",
                        "latitude": "43.32551000",
                        "longitude": "131.86264000"
                    },
                    {
                        "id": 101833,
                        "name": "Terney",
                        "latitude": "45.05278000",
                        "longitude": "136.60881000"
                    },
                    {
                        "id": 101933,
                        "name": "Trudovoye",
                        "latitude": "43.29823000",
                        "longitude": "132.06877000"
                    },
                    {
                        "id": 102030,
                        "name": "Uglekamensk",
                        "latitude": "43.21996000",
                        "longitude": "133.23177000"
                    },
                    {
                        "id": 102037,
                        "name": "Uglovoye",
                        "latitude": "43.32807000",
                        "longitude": "132.08832000"
                    },
                    {
                        "id": 102105,
                        "name": "Ussuriysk",
                        "latitude": "43.80291000",
                        "longitude": "131.94578000"
                    },
                    {
                        "id": 102327,
                        "name": "Vladimiro-Aleksandrovskoye",
                        "latitude": "42.89134000",
                        "longitude": "133.07801000"
                    },
                    {
                        "id": 102330,
                        "name": "Vladivostok",
                        "latitude": "43.10562000",
                        "longitude": "131.87353000"
                    },
                    {
                        "id": 102372,
                        "name": "Vol’no-Nadezhdinskoye",
                        "latitude": "43.37496000",
                        "longitude": "131.99675000"
                    },
                    {
                        "id": 102338,
                        "name": "Volchanets",
                        "latitude": "42.91388000",
                        "longitude": "132.76222000"
                    },
                    {
                        "id": 102400,
                        "name": "Vostok",
                        "latitude": "46.45148000",
                        "longitude": "135.82738000"
                    },
                    {
                        "id": 102406,
                        "name": "Vozdvizhenka",
                        "latitude": "43.89413000",
                        "longitude": "131.94589000"
                    },
                    {
                        "id": 102412,
                        "name": "Vrangel’",
                        "latitude": "42.73021000",
                        "longitude": "133.08322000"
                    },
                    {
                        "id": 102466,
                        "name": "Yakovlevka",
                        "latitude": "44.42588000",
                        "longitude": "133.47406000"
                    },
                    {
                        "id": 102470,
                        "name": "Yakovlevskiy Rayon",
                        "latitude": "44.41667000",
                        "longitude": "133.50000000"
                    },
                    {
                        "id": 102502,
                        "name": "Yaroslavskiy",
                        "latitude": "44.18578000",
                        "longitude": "132.22862000"
                    },
                    {
                        "id": 102530,
                        "name": "Yekaterinovka",
                        "latitude": "42.92525000",
                        "longitude": "133.04922000"
                    },
                    {
                        "id": 102661,
                        "name": "Zarubino",
                        "latitude": "42.63257000",
                        "longitude": "131.09005000"
                    },
                    {
                        "id": 102677,
                        "name": "Zavodskoy",
                        "latitude": "43.46242000",
                        "longitude": "132.28494000"
                    },
                    {
                        "id": 102712,
                        "name": "Zharikovo",
                        "latitude": "44.58800000",
                        "longitude": "131.72770000"
                    }
                ]
            },
            {
                "id": 1863,
                "name": "Pskov",
                "iso2": "PSK",
                "latitude": "56.77085990",
                "longitude": "29.09400900",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97919,
                        "name": "Bezhanitsy",
                        "latitude": "56.97669000",
                        "longitude": "29.89065000"
                    },
                    {
                        "id": 98256,
                        "name": "Dedovichi",
                        "latitude": "57.55166000",
                        "longitude": "29.95018000"
                    },
                    {
                        "id": 98290,
                        "name": "Dno",
                        "latitude": "57.82772000",
                        "longitude": "29.96368000"
                    },
                    {
                        "id": 98470,
                        "name": "Gdov",
                        "latitude": "58.74424000",
                        "longitude": "27.81977000"
                    },
                    {
                        "id": 98471,
                        "name": "Gdovskiy Rayon",
                        "latitude": "58.75000000",
                        "longitude": "28.00000000"
                    },
                    {
                        "id": 98630,
                        "name": "Idritsa",
                        "latitude": "56.33157000",
                        "longitude": "28.89884000"
                    },
                    {
                        "id": 98745,
                        "name": "Izborsk",
                        "latitude": "57.70757000",
                        "longitude": "27.86291000"
                    },
                    {
                        "id": 99302,
                        "name": "Krasnogorodsk",
                        "latitude": "56.83568000",
                        "longitude": "28.28224000"
                    },
                    {
                        "id": 99368,
                        "name": "Krasnyy Luch",
                        "latitude": "57.06676000",
                        "longitude": "30.09032000"
                    },
                    {
                        "id": 99448,
                        "name": "Kun’inskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "31.00000000"
                    },
                    {
                        "id": 99651,
                        "name": "Loknya",
                        "latitude": "56.82998000",
                        "longitude": "30.14665000"
                    },
                    {
                        "id": 100115,
                        "name": "Nevel’",
                        "latitude": "56.02094000",
                        "longitude": "29.92844000"
                    },
                    {
                        "id": 100291,
                        "name": "Novorzhev",
                        "latitude": "57.02942000",
                        "longitude": "29.33378000"
                    },
                    {
                        "id": 100292,
                        "name": "Novorzhevskiy Rayon",
                        "latitude": "57.08333000",
                        "longitude": "29.41667000"
                    },
                    {
                        "id": 100309,
                        "name": "Novosokol’nicheskiy Rayon",
                        "latitude": "56.41667000",
                        "longitude": "30.00000000"
                    },
                    {
                        "id": 100310,
                        "name": "Novosokol’niki",
                        "latitude": "56.34634000",
                        "longitude": "30.15778000"
                    },
                    {
                        "id": 100343,
                        "name": "Novyy Izborsk",
                        "latitude": "57.77079000",
                        "longitude": "27.97306000"
                    },
                    {
                        "id": 100455,
                        "name": "Opochka",
                        "latitude": "56.71357000",
                        "longitude": "28.66388000"
                    },
                    {
                        "id": 100496,
                        "name": "Ostrov",
                        "latitude": "57.34395000",
                        "longitude": "28.35368000"
                    },
                    {
                        "id": 100498,
                        "name": "Ostrovskiy Rayon",
                        "latitude": "57.25000000",
                        "longitude": "28.33333000"
                    },
                    {
                        "id": 100531,
                        "name": "Palkino",
                        "latitude": "57.54089000",
                        "longitude": "28.01257000"
                    },
                    {
                        "id": 100532,
                        "name": "Palkinskiy Rayon",
                        "latitude": "57.50000000",
                        "longitude": "28.00000000"
                    },
                    {
                        "id": 100588,
                        "name": "Pechorskiy Rayon",
                        "latitude": "57.75000000",
                        "longitude": "27.75000000"
                    },
                    {
                        "id": 100589,
                        "name": "Pechory",
                        "latitude": "57.81642000",
                        "longitude": "27.61190000"
                    },
                    {
                        "id": 100704,
                        "name": "Plyussa",
                        "latitude": "58.43078000",
                        "longitude": "29.36537000"
                    },
                    {
                        "id": 100777,
                        "name": "Porkhov",
                        "latitude": "57.76502000",
                        "longitude": "29.55612000"
                    },
                    {
                        "id": 100778,
                        "name": "Porkhovskiy Rayon",
                        "latitude": "57.75000000",
                        "longitude": "29.50000000"
                    },
                    {
                        "id": 100881,
                        "name": "Pskov",
                        "latitude": "57.81360000",
                        "longitude": "28.34960000"
                    },
                    {
                        "id": 100882,
                        "name": "Pskovskiy Rayon",
                        "latitude": "57.75000000",
                        "longitude": "28.25000000"
                    },
                    {
                        "id": 100899,
                        "name": "Pushkino-Gorskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "28.75000000"
                    },
                    {
                        "id": 100901,
                        "name": "Pushkinskiye Gory",
                        "latitude": "57.02085000",
                        "longitude": "28.91030000"
                    },
                    {
                        "id": 100902,
                        "name": "Pustoshka",
                        "latitude": "56.33547000",
                        "longitude": "29.36901000"
                    },
                    {
                        "id": 100903,
                        "name": "Pustoshkinskiy Rayon",
                        "latitude": "56.41667000",
                        "longitude": "29.41667000"
                    },
                    {
                        "id": 100918,
                        "name": "Pytalovo",
                        "latitude": "57.06791000",
                        "longitude": "27.91384000"
                    },
                    {
                        "id": 100919,
                        "name": "Pytalovskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "28.00000000"
                    },
                    {
                        "id": 101143,
                        "name": "Sebezh",
                        "latitude": "56.28511000",
                        "longitude": "28.48187000"
                    },
                    {
                        "id": 101144,
                        "name": "Sebezhskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "28.50000000"
                    },
                    {
                        "id": 101197,
                        "name": "Serëdka",
                        "latitude": "58.15838000",
                        "longitude": "28.18576000"
                    },
                    {
                        "id": 101633,
                        "name": "Strugi-Krasnyye",
                        "latitude": "58.26754000",
                        "longitude": "29.11137000"
                    },
                    {
                        "id": 101634,
                        "name": "Strugo-Krasnenskiy Rayon",
                        "latitude": "58.33333000",
                        "longitude": "29.00000000"
                    },
                    {
                        "id": 102147,
                        "name": "Usvyaty",
                        "latitude": "55.74556000",
                        "longitude": "30.75333000"
                    },
                    {
                        "id": 102213,
                        "name": "Velikiye Luki",
                        "latitude": "56.34000000",
                        "longitude": "30.54517000"
                    },
                    {
                        "id": 102215,
                        "name": "Velikolukskiy Rayon",
                        "latitude": "56.50000000",
                        "longitude": "30.58333000"
                    },
                    {
                        "id": 102425,
                        "name": "Vybor",
                        "latitude": "57.22716000",
                        "longitude": "29.16630000"
                    }
                ]
            },
            {
                "id": 1837,
                "name": "Rostov",
                "iso2": "ROS",
                "latitude": "47.68532470",
                "longitude": "41.82589520",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97542,
                        "name": "Aksay",
                        "latitude": "47.25838000",
                        "longitude": "39.86675000"
                    },
                    {
                        "id": 97598,
                        "name": "Almaznyy",
                        "latitude": "48.04476000",
                        "longitude": "40.04501000"
                    },
                    {
                        "id": 97622,
                        "name": "Anastasiyevka",
                        "latitude": "47.56072000",
                        "longitude": "38.52837000"
                    },
                    {
                        "id": 97731,
                        "name": "Ayutinskiy",
                        "latitude": "47.78228000",
                        "longitude": "40.14763000"
                    },
                    {
                        "id": 97734,
                        "name": "Azov",
                        "latitude": "47.10779000",
                        "longitude": "39.41648000"
                    },
                    {
                        "id": 97752,
                        "name": "Bagayevskaya",
                        "latitude": "47.32411000",
                        "longitude": "40.38791000"
                    },
                    {
                        "id": 97811,
                        "name": "Bataysk",
                        "latitude": "47.13975000",
                        "longitude": "39.75181000"
                    },
                    {
                        "id": 97842,
                        "name": "Belaya Kalitva",
                        "latitude": "48.18585000",
                        "longitude": "40.77424000"
                    },
                    {
                        "id": 97985,
                        "name": "Bokovskaya",
                        "latitude": "49.22899000",
                        "longitude": "41.83060000"
                    },
                    {
                        "id": 98101,
                        "name": "Bystrogorskiy",
                        "latitude": "48.20813000",
                        "longitude": "41.14097000"
                    },
                    {
                        "id": 98110,
                        "name": "Chaltyr",
                        "latitude": "47.28477000",
                        "longitude": "39.48232000"
                    },
                    {
                        "id": 98186,
                        "name": "Chertkovo",
                        "latitude": "49.38451000",
                        "longitude": "40.14723000"
                    },
                    {
                        "id": 98310,
                        "name": "Donetsk",
                        "latitude": "48.33962000",
                        "longitude": "39.95948000"
                    },
                    {
                        "id": 98311,
                        "name": "Donskoy",
                        "latitude": "47.41404000",
                        "longitude": "40.25742000"
                    },
                    {
                        "id": 98340,
                        "name": "Dubovskoye",
                        "latitude": "47.41420000",
                        "longitude": "42.76970000"
                    },
                    {
                        "id": 98489,
                        "name": "Gigant",
                        "latitude": "46.50665000",
                        "longitude": "41.34185000"
                    },
                    {
                        "id": 98501,
                        "name": "Glubokiy",
                        "latitude": "48.52716000",
                        "longitude": "40.33144000"
                    },
                    {
                        "id": 98538,
                        "name": "Gornyatskiy",
                        "latitude": "48.29649000",
                        "longitude": "40.92404000"
                    },
                    {
                        "id": 98540,
                        "name": "Gornyy",
                        "latitude": "47.81592000",
                        "longitude": "40.20363000"
                    },
                    {
                        "id": 98595,
                        "name": "Grushevskaya",
                        "latitude": "47.44056000",
                        "longitude": "39.95111000"
                    },
                    {
                        "id": 98608,
                        "name": "Gukovo",
                        "latitude": "48.06212000",
                        "longitude": "39.93550000"
                    },
                    {
                        "id": 98612,
                        "name": "Gundorovskiy",
                        "latitude": "46.78047000",
                        "longitude": "41.89680000"
                    },
                    {
                        "id": 98776,
                        "name": "Kagal’nitskaya",
                        "latitude": "46.88056000",
                        "longitude": "40.14657000"
                    },
                    {
                        "id": 98785,
                        "name": "Kalinin",
                        "latitude": "47.24678000",
                        "longitude": "39.51088000"
                    },
                    {
                        "id": 98818,
                        "name": "Kamenolomni",
                        "latitude": "47.66853000",
                        "longitude": "40.20510000"
                    },
                    {
                        "id": 98819,
                        "name": "Kamensk-Shakhtinskiy",
                        "latitude": "48.31779000",
                        "longitude": "40.25948000"
                    },
                    {
                        "id": 98890,
                        "name": "Kashary",
                        "latitude": "49.04001000",
                        "longitude": "41.00557000"
                    },
                    {
                        "id": 98927,
                        "name": "Kazanskaya",
                        "latitude": "49.79333000",
                        "longitude": "41.14667000"
                    },
                    {
                        "id": 99066,
                        "name": "Kirovskaya",
                        "latitude": "46.97480000",
                        "longitude": "40.04020000"
                    },
                    {
                        "id": 99134,
                        "name": "Koksovyy",
                        "latitude": "48.19742000",
                        "longitude": "40.64325000"
                    },
                    {
                        "id": 99189,
                        "name": "Konstantinovsk",
                        "latitude": "47.58278000",
                        "longitude": "41.09222000"
                    },
                    {
                        "id": 99284,
                        "name": "Krasnaya Polyana",
                        "latitude": "46.11293000",
                        "longitude": "41.50157000"
                    },
                    {
                        "id": 99293,
                        "name": "Krasnoarmeyskiy",
                        "latitude": "47.01140000",
                        "longitude": "42.20720000"
                    },
                    {
                        "id": 99341,
                        "name": "Krasnovka",
                        "latitude": "48.81769000",
                        "longitude": "40.09226000"
                    },
                    {
                        "id": 99344,
                        "name": "Krasnoyarskaya",
                        "latitude": "47.65010000",
                        "longitude": "42.04430000"
                    },
                    {
                        "id": 99373,
                        "name": "Krasnyy Sulin",
                        "latitude": "47.89221000",
                        "longitude": "40.07037000"
                    },
                    {
                        "id": 99385,
                        "name": "Krasyukovskaya",
                        "latitude": "47.55222000",
                        "longitude": "40.10885000"
                    },
                    {
                        "id": 99395,
                        "name": "Krivyanskaya",
                        "latitude": "47.39689000",
                        "longitude": "40.16680000"
                    },
                    {
                        "id": 99407,
                        "name": "Krym",
                        "latitude": "47.30025000",
                        "longitude": "39.51637000"
                    },
                    {
                        "id": 99431,
                        "name": "Kuleshovka",
                        "latitude": "47.07802000",
                        "longitude": "39.55794000"
                    },
                    {
                        "id": 99494,
                        "name": "Kuybyshevo",
                        "latitude": "47.81228000",
                        "longitude": "38.90731000"
                    },
                    {
                        "id": 99607,
                        "name": "Letnik",
                        "latitude": "46.01100000",
                        "longitude": "41.26570000"
                    },
                    {
                        "id": 99625,
                        "name": "Likhovskoy",
                        "latitude": "48.15188000",
                        "longitude": "40.17925000"
                    },
                    {
                        "id": 99626,
                        "name": "Likhoy",
                        "latitude": "48.12662000",
                        "longitude": "40.20556000"
                    },
                    {
                        "id": 99806,
                        "name": "Martynovskiy Rayon",
                        "latitude": "47.24867000",
                        "longitude": "41.49792000"
                    },
                    {
                        "id": 99809,
                        "name": "Masalovka",
                        "latitude": "48.40372000",
                        "longitude": "40.26064000"
                    },
                    {
                        "id": 99815,
                        "name": "Matveyev Kurgan",
                        "latitude": "47.56450000",
                        "longitude": "38.86947000"
                    },
                    {
                        "id": 99832,
                        "name": "Mayskiy",
                        "latitude": "47.69600000",
                        "longitude": "40.10259000"
                    },
                    {
                        "id": 99838,
                        "name": "Mechetinskaya",
                        "latitude": "46.77130000",
                        "longitude": "40.45597000"
                    },
                    {
                        "id": 99857,
                        "name": "Melikhovskaya",
                        "latitude": "47.48106000",
                        "longitude": "40.48669000"
                    },
                    {
                        "id": 99910,
                        "name": "Millerovo",
                        "latitude": "48.92265000",
                        "longitude": "40.39673000"
                    },
                    {
                        "id": 99912,
                        "name": "Milyutinskaya",
                        "latitude": "48.62788000",
                        "longitude": "41.66788000"
                    },
                    {
                        "id": 99913,
                        "name": "Milyutinskiy Rayon",
                        "latitude": "48.66550000",
                        "longitude": "41.74981000"
                    },
                    {
                        "id": 99966,
                        "name": "Morozovsk",
                        "latitude": "48.35502000",
                        "longitude": "41.82627000"
                    },
                    {
                        "id": 100082,
                        "name": "Nedvigovka",
                        "latitude": "47.26873000",
                        "longitude": "39.34880000"
                    },
                    {
                        "id": 100137,
                        "name": "Nikolayevskaya",
                        "latitude": "47.61391000",
                        "longitude": "41.50230000"
                    },
                    {
                        "id": 100226,
                        "name": "Novobataysk",
                        "latitude": "46.89806000",
                        "longitude": "39.78194000"
                    },
                    {
                        "id": 100228,
                        "name": "Novobessergenovka",
                        "latitude": "47.18465000",
                        "longitude": "38.84625000"
                    },
                    {
                        "id": 100235,
                        "name": "Novocherkassk",
                        "latitude": "47.42096000",
                        "longitude": "40.09185000"
                    },
                    {
                        "id": 100297,
                        "name": "Novoshakhtinsk",
                        "latitude": "47.76037000",
                        "longitude": "39.93335000"
                    },
                    {
                        "id": 100354,
                        "name": "Novyy Yegorlyk",
                        "latitude": "46.39270000",
                        "longitude": "41.87162000"
                    },
                    {
                        "id": 100384,
                        "name": "Oblivskaya",
                        "latitude": "48.53616000",
                        "longitude": "42.50138000"
                    },
                    {
                        "id": 100436,
                        "name": "Ol’ginskaya",
                        "latitude": "47.18794000",
                        "longitude": "39.94925000"
                    },
                    {
                        "id": 100473,
                        "name": "Orlovskiy",
                        "latitude": "46.87139000",
                        "longitude": "42.05917000"
                    },
                    {
                        "id": 100612,
                        "name": "Persianovka",
                        "latitude": "47.52972000",
                        "longitude": "39.41833000"
                    },
                    {
                        "id": 100631,
                        "name": "Peschanokopskoye",
                        "latitude": "46.19517000",
                        "longitude": "41.08143000"
                    },
                    {
                        "id": 100633,
                        "name": "Peshkovo",
                        "latitude": "47.01867000",
                        "longitude": "39.38845000"
                    },
                    {
                        "id": 100747,
                        "name": "Pokrovskoye",
                        "latitude": "47.41570000",
                        "longitude": "38.89706000"
                    },
                    {
                        "id": 100781,
                        "name": "Port-Katon",
                        "latitude": "46.87900000",
                        "longitude": "38.75600000"
                    },
                    {
                        "id": 100829,
                        "name": "Primorka",
                        "latitude": "47.28395000",
                        "longitude": "39.06408000"
                    },
                    {
                        "id": 100863,
                        "name": "Proletarsk",
                        "latitude": "46.70289000",
                        "longitude": "41.72717000"
                    },
                    {
                        "id": 100944,
                        "name": "Rassvet",
                        "latitude": "46.83333000",
                        "longitude": "40.75000000"
                    },
                    {
                        "id": 100960,
                        "name": "Remontnoye",
                        "latitude": "46.56140000",
                        "longitude": "43.65010000"
                    },
                    {
                        "id": 100975,
                        "name": "Rodionovo-Nesvetaiskoye",
                        "latitude": "47.60000000",
                        "longitude": "39.70000000"
                    },
                    {
                        "id": 100976,
                        "name": "Rodionovo-Nesvetayskaya",
                        "latitude": "47.61033000",
                        "longitude": "39.71212000"
                    },
                    {
                        "id": 100990,
                        "name": "Romanovskaya",
                        "latitude": "47.54260000",
                        "longitude": "42.02850000"
                    },
                    {
                        "id": 101007,
                        "name": "Rostov-na-Donu",
                        "latitude": "47.23135000",
                        "longitude": "39.72328000"
                    },
                    {
                        "id": 101083,
                        "name": "Sal’sk",
                        "latitude": "46.47470000",
                        "longitude": "41.54114000"
                    },
                    {
                        "id": 101086,
                        "name": "Samarskoye",
                        "latitude": "46.93700000",
                        "longitude": "39.68810000"
                    },
                    {
                        "id": 101088,
                        "name": "Sambek",
                        "latitude": "47.74306000",
                        "longitude": "39.83083000"
                    },
                    {
                        "id": 101097,
                        "name": "Sandata",
                        "latitude": "46.27081000",
                        "longitude": "41.75834000"
                    },
                    {
                        "id": 101163,
                        "name": "Semikarakorsk",
                        "latitude": "47.51675000",
                        "longitude": "40.80577000"
                    },
                    {
                        "id": 101241,
                        "name": "Shakhty",
                        "latitude": "47.70911000",
                        "longitude": "40.21443000"
                    },
                    {
                        "id": 101337,
                        "name": "Sholokhovskiy",
                        "latitude": "48.28071000",
                        "longitude": "41.04592000"
                    },
                    {
                        "id": 101374,
                        "name": "Sinegorskiy",
                        "latitude": "48.01389000",
                        "longitude": "40.84468000"
                    },
                    {
                        "id": 101378,
                        "name": "Sinyavskoye",
                        "latitude": "47.27703000",
                        "longitude": "39.27888000"
                    },
                    {
                        "id": 101438,
                        "name": "Sokolovo-Kundryuchenskiy",
                        "latitude": "47.83536000",
                        "longitude": "39.94711000"
                    },
                    {
                        "id": 101507,
                        "name": "Sovetskaya",
                        "latitude": "49.00912000",
                        "longitude": "42.12178000"
                    },
                    {
                        "id": 101565,
                        "name": "Staraya Stanitsa",
                        "latitude": "48.34579000",
                        "longitude": "40.29376000"
                    },
                    {
                        "id": 101575,
                        "name": "Starocherkasskaya",
                        "latitude": "47.24077000",
                        "longitude": "40.04186000"
                    },
                    {
                        "id": 101740,
                        "name": "Taganrog",
                        "latitude": "47.23617000",
                        "longitude": "38.89688000"
                    },
                    {
                        "id": 101756,
                        "name": "Talovyy",
                        "latitude": "47.80765000",
                        "longitude": "40.10943000"
                    },
                    {
                        "id": 101765,
                        "name": "Tanais",
                        "latitude": "47.26837000",
                        "longitude": "39.33425000"
                    },
                    {
                        "id": 101770,
                        "name": "Tarasovskiy",
                        "latitude": "48.72727000",
                        "longitude": "40.36267000"
                    },
                    {
                        "id": 101798,
                        "name": "Tatsinskiy",
                        "latitude": "48.19677000",
                        "longitude": "41.27558000"
                    },
                    {
                        "id": 101938,
                        "name": "Tselina",
                        "latitude": "46.53381000",
                        "longitude": "41.03284000"
                    },
                    {
                        "id": 101949,
                        "name": "Tsimlyansk",
                        "latitude": "47.64611000",
                        "longitude": "42.10194000"
                    },
                    {
                        "id": 102028,
                        "name": "Uglegorskiy",
                        "latitude": "48.24274000",
                        "longitude": "41.25310000"
                    },
                    {
                        "id": 102031,
                        "name": "Uglerodovskiy",
                        "latitude": "48.14558000",
                        "longitude": "40.06352000"
                    },
                    {
                        "id": 102118,
                        "name": "Ust’-Donetskiy",
                        "latitude": "47.64189000",
                        "longitude": "40.87182000"
                    },
                    {
                        "id": 102292,
                        "name": "Vesëlyy",
                        "latitude": "47.09338000",
                        "longitude": "40.74220000"
                    },
                    {
                        "id": 102289,
                        "name": "Veshenskaya",
                        "latitude": "49.63033000",
                        "longitude": "41.73340000"
                    },
                    {
                        "id": 102344,
                        "name": "Volgodonsk",
                        "latitude": "47.51361000",
                        "longitude": "42.15139000"
                    },
                    {
                        "id": 102524,
                        "name": "Yegorlykskaya",
                        "latitude": "46.56564000",
                        "longitude": "40.65621000"
                    },
                    {
                        "id": 102668,
                        "name": "Zavetnoye",
                        "latitude": "47.11944000",
                        "longitude": "43.89028000"
                    },
                    {
                        "id": 102707,
                        "name": "Zernograd",
                        "latitude": "46.84518000",
                        "longitude": "40.30834000"
                    },
                    {
                        "id": 102734,
                        "name": "Zhirnov",
                        "latitude": "48.17089000",
                        "longitude": "41.12608000"
                    },
                    {
                        "id": 102748,
                        "name": "Zimovniki",
                        "latitude": "47.14740000",
                        "longitude": "42.47210000"
                    },
                    {
                        "id": 102781,
                        "name": "Zverevo",
                        "latitude": "48.02108000",
                        "longitude": "40.12282000"
                    }
                ]
            },
            {
                "id": 1905,
                "name": "Ryazan",
                "iso2": "RYA",
                "latitude": "54.38759640",
                "longitude": "41.25956610",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97564,
                        "name": "Aleksandro-Nevskiy",
                        "latitude": "53.47510000",
                        "longitude": "40.20950000"
                    },
                    {
                        "id": 97754,
                        "name": "Bagramovo",
                        "latitude": "54.72337000",
                        "longitude": "39.45186000"
                    },
                    {
                        "id": 98213,
                        "name": "Chuchkovo",
                        "latitude": "54.26931000",
                        "longitude": "41.44648000"
                    },
                    {
                        "id": 98623,
                        "name": "Gus’-Zheleznyy",
                        "latitude": "55.05811000",
                        "longitude": "41.16556000"
                    },
                    {
                        "id": 98747,
                        "name": "Izhevskoye",
                        "latitude": "54.55700000",
                        "longitude": "40.87530000"
                    },
                    {
                        "id": 98769,
                        "name": "Kadom",
                        "latitude": "54.55917000",
                        "longitude": "42.46750000"
                    },
                    {
                        "id": 98897,
                        "name": "Kasimov",
                        "latitude": "54.94111000",
                        "longitude": "41.39528000"
                    },
                    {
                        "id": 98898,
                        "name": "Kasimovskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "41.41667000"
                    },
                    {
                        "id": 99058,
                        "name": "Kiritsy",
                        "latitude": "54.28620000",
                        "longitude": "40.35720000"
                    },
                    {
                        "id": 99097,
                        "name": "Klepikovskiy Rayon",
                        "latitude": "55.08333000",
                        "longitude": "40.08333000"
                    },
                    {
                        "id": 99202,
                        "name": "Korablino",
                        "latitude": "53.91639000",
                        "longitude": "40.01333000"
                    },
                    {
                        "id": 99545,
                        "name": "Lashma",
                        "latitude": "54.93210000",
                        "longitude": "41.14379000"
                    },
                    {
                        "id": 99594,
                        "name": "Lesnoy",
                        "latitude": "54.21250000",
                        "longitude": "40.47130000"
                    },
                    {
                        "id": 99895,
                        "name": "Mikhaylov",
                        "latitude": "54.22980000",
                        "longitude": "39.02690000"
                    },
                    {
                        "id": 99911,
                        "name": "Miloslavskoye",
                        "latitude": "53.58152000",
                        "longitude": "39.43992000"
                    },
                    {
                        "id": 100011,
                        "name": "Murmino",
                        "latitude": "54.60430000",
                        "longitude": "40.05490000"
                    },
                    {
                        "id": 100266,
                        "name": "Novomichurinsk",
                        "latitude": "54.03840000",
                        "longitude": "39.74790000"
                    },
                    {
                        "id": 100409,
                        "name": "Oktyabr’skiy",
                        "latitude": "54.22675000",
                        "longitude": "38.89402000"
                    },
                    {
                        "id": 100563,
                        "name": "Pavelets",
                        "latitude": "53.78833000",
                        "longitude": "39.24601000"
                    },
                    {
                        "id": 100686,
                        "name": "Pitelino",
                        "latitude": "54.57768000",
                        "longitude": "41.81448000"
                    },
                    {
                        "id": 100761,
                        "name": "Polyany",
                        "latitude": "54.71801000",
                        "longitude": "39.82932000"
                    },
                    {
                        "id": 100869,
                        "name": "Pronsk",
                        "latitude": "54.10480000",
                        "longitude": "39.60920000"
                    },
                    {
                        "id": 100906,
                        "name": "Putyatino",
                        "latitude": "54.15998000",
                        "longitude": "41.11690000"
                    },
                    {
                        "id": 101045,
                        "name": "Ryazan’",
                        "latitude": "54.62690000",
                        "longitude": "39.69160000"
                    },
                    {
                        "id": 101044,
                        "name": "Ryazanskiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "39.75000000"
                    },
                    {
                        "id": 101046,
                        "name": "Ryazhsk",
                        "latitude": "53.70380000",
                        "longitude": "40.11090000"
                    },
                    {
                        "id": 101052,
                        "name": "Rybnovskiy Rayon",
                        "latitude": "54.75000000",
                        "longitude": "39.50000000"
                    },
                    {
                        "id": 101053,
                        "name": "Rybnoye",
                        "latitude": "54.72774000",
                        "longitude": "39.51731000"
                    },
                    {
                        "id": 101103,
                        "name": "Sapozhok",
                        "latitude": "53.94194000",
                        "longitude": "40.68056000"
                    },
                    {
                        "id": 101105,
                        "name": "Sarai",
                        "latitude": "53.74577000",
                        "longitude": "41.02126000"
                    },
                    {
                        "id": 101128,
                        "name": "Sasovo",
                        "latitude": "54.35369000",
                        "longitude": "41.91986000"
                    },
                    {
                        "id": 101271,
                        "name": "Shatsk",
                        "latitude": "54.02576000",
                        "longitude": "41.71191000"
                    },
                    {
                        "id": 101315,
                        "name": "Shilovo",
                        "latitude": "54.32040000",
                        "longitude": "40.87400000"
                    },
                    {
                        "id": 101389,
                        "name": "Skopin",
                        "latitude": "53.82486000",
                        "longitude": "39.55053000"
                    },
                    {
                        "id": 101466,
                        "name": "Solotcha",
                        "latitude": "54.78970000",
                        "longitude": "39.83336000"
                    },
                    {
                        "id": 101524,
                        "name": "Spas-Klepiki",
                        "latitude": "55.13472000",
                        "longitude": "40.17673000"
                    },
                    {
                        "id": 101529,
                        "name": "Spassk-Ryazanskiy",
                        "latitude": "54.40400000",
                        "longitude": "40.37620000"
                    },
                    {
                        "id": 101603,
                        "name": "Starozhilovo",
                        "latitude": "54.22540000",
                        "longitude": "39.91600000"
                    },
                    {
                        "id": 101727,
                        "name": "Syntul",
                        "latitude": "55.00327000",
                        "longitude": "41.29711000"
                    },
                    {
                        "id": 101967,
                        "name": "Tuma",
                        "latitude": "55.14798000",
                        "longitude": "40.55374000"
                    },
                    {
                        "id": 102042,
                        "name": "Ukholovo",
                        "latitude": "53.79290000",
                        "longitude": "40.48920000"
                    },
                    {
                        "id": 102305,
                        "name": "Vilenka",
                        "latitude": "54.26930000",
                        "longitude": "38.91663000"
                    },
                    {
                        "id": 102478,
                        "name": "Yambirno",
                        "latitude": "54.12310000",
                        "longitude": "42.09110000"
                    },
                    {
                        "id": 102537,
                        "name": "Yelat’ma",
                        "latitude": "54.96750000",
                        "longitude": "41.75083000"
                    },
                    {
                        "id": 102566,
                        "name": "Yermish’",
                        "latitude": "54.76778000",
                        "longitude": "42.27111000"
                    },
                    {
                        "id": 102635,
                        "name": "Zakharovo",
                        "latitude": "54.36600000",
                        "longitude": "39.27920000"
                    },
                    {
                        "id": 102636,
                        "name": "Zakharovskiy Rayon",
                        "latitude": "54.41667000",
                        "longitude": "39.25000000"
                    },
                    {
                        "id": 102653,
                        "name": "Zarechnyy",
                        "latitude": "53.73060000",
                        "longitude": "39.59437000"
                    }
                ]
            },
            {
                "id": 1879,
                "name": "Saint Petersburg",
                "iso2": "SPE",
                "latitude": "59.93105840",
                "longitude": "30.36090960",
                "type": "autonomous city",
                "cities": [
                    {
                        "id": 97504,
                        "name": "Admiralteisky",
                        "latitude": "59.90839000",
                        "longitude": "30.28484000"
                    },
                    {
                        "id": 97570,
                        "name": "Aleksandrovskaya",
                        "latitude": "59.73083000",
                        "longitude": "30.33222000"
                    },
                    {
                        "id": 97724,
                        "name": "Avtovo",
                        "latitude": "59.87167000",
                        "longitude": "30.26583000"
                    },
                    {
                        "id": 97859,
                        "name": "Beloostrov",
                        "latitude": "60.15118000",
                        "longitude": "30.00151000"
                    },
                    {
                        "id": 98105,
                        "name": "Centralniy",
                        "latitude": "59.93111000",
                        "longitude": "30.36072000"
                    },
                    {
                        "id": 98231,
                        "name": "Dachnoye",
                        "latitude": "59.84167000",
                        "longitude": "30.25583000"
                    },
                    {
                        "id": 98438,
                        "name": "Frunzenskiy Rayon",
                        "latitude": "59.87190000",
                        "longitude": "30.37891000"
                    },
                    {
                        "id": 98523,
                        "name": "Gorelovo",
                        "latitude": "59.77234000",
                        "longitude": "30.13455000"
                    },
                    {
                        "id": 98579,
                        "name": "Grazhdanka",
                        "latitude": "60.03587000",
                        "longitude": "30.40518000"
                    },
                    {
                        "id": 99144,
                        "name": "Kolomyagi",
                        "latitude": "60.02427000",
                        "longitude": "30.28491000"
                    },
                    {
                        "id": 99147,
                        "name": "Kolpino",
                        "latitude": "59.75069000",
                        "longitude": "30.58856000"
                    },
                    {
                        "id": 99161,
                        "name": "Komarovo",
                        "latitude": "60.18660000",
                        "longitude": "29.80865000"
                    },
                    {
                        "id": 99162,
                        "name": "Komendantsky aerodrom",
                        "latitude": "60.00448000",
                        "longitude": "30.27523000"
                    },
                    {
                        "id": 99319,
                        "name": "Krasnogvargeisky",
                        "latitude": "59.97305000",
                        "longitude": "30.47607000"
                    },
                    {
                        "id": 99353,
                        "name": "Krasnoye Selo",
                        "latitude": "59.73833000",
                        "longitude": "30.08944000"
                    },
                    {
                        "id": 99397,
                        "name": "Kronshtadt",
                        "latitude": "59.99541000",
                        "longitude": "29.76668000"
                    },
                    {
                        "id": 99450,
                        "name": "Kupchino",
                        "latitude": "59.85278000",
                        "longitude": "30.35667000"
                    },
                    {
                        "id": 99470,
                        "name": "Kurortnyy Rayon",
                        "latitude": "60.17601000",
                        "longitude": "29.87389000"
                    },
                    {
                        "id": 99486,
                        "name": "Kushelevka",
                        "latitude": "59.99333000",
                        "longitude": "30.36389000"
                    },
                    {
                        "id": 99539,
                        "name": "Lakhtinskiy",
                        "latitude": "59.99521000",
                        "longitude": "30.14717000"
                    },
                    {
                        "id": 99614,
                        "name": "Levashovo",
                        "latitude": "60.10369000",
                        "longitude": "30.20683000"
                    },
                    {
                        "id": 99636,
                        "name": "Lisiy Nos",
                        "latitude": "60.01686000",
                        "longitude": "30.02008000"
                    },
                    {
                        "id": 99657,
                        "name": "Lomonosov",
                        "latitude": "59.90612000",
                        "longitude": "29.77253000"
                    },
                    {
                        "id": 99873,
                        "name": "Metallostroy",
                        "latitude": "59.80083000",
                        "longitude": "30.54778000"
                    },
                    {
                        "id": 99951,
                        "name": "Molodezhnoye",
                        "latitude": "60.19803000",
                        "longitude": "29.51597000"
                    },
                    {
                        "id": 100203,
                        "name": "Novaya Derevnya",
                        "latitude": "59.98748000",
                        "longitude": "30.28682000"
                    },
                    {
                        "id": 100392,
                        "name": "Obukhovo",
                        "latitude": "59.84389000",
                        "longitude": "30.45111000"
                    },
                    {
                        "id": 100433,
                        "name": "Ol’gino",
                        "latitude": "60.00928000",
                        "longitude": "30.11559000"
                    },
                    {
                        "id": 100517,
                        "name": "Ozerki",
                        "latitude": "60.03947000",
                        "longitude": "30.31128000"
                    },
                    {
                        "id": 100549,
                        "name": "Pargolovo",
                        "latitude": "60.08120000",
                        "longitude": "30.27626000"
                    },
                    {
                        "id": 100571,
                        "name": "Pavlovsk",
                        "latitude": "59.68333000",
                        "longitude": "30.43472000"
                    },
                    {
                        "id": 100637,
                        "name": "Pesochnyy",
                        "latitude": "60.12295000",
                        "longitude": "30.16404000"
                    },
                    {
                        "id": 100645,
                        "name": "Peterhof",
                        "latitude": "59.88333000",
                        "longitude": "29.90000000"
                    },
                    {
                        "id": 100647,
                        "name": "Petro-Slavyanka",
                        "latitude": "59.80222000",
                        "longitude": "30.50694000"
                    },
                    {
                        "id": 100648,
                        "name": "Petrodvorets",
                        "latitude": "59.89565000",
                        "longitude": "29.80145000"
                    },
                    {
                        "id": 100649,
                        "name": "Petrogradka",
                        "latitude": "59.96567000",
                        "longitude": "30.31154000"
                    },
                    {
                        "id": 100769,
                        "name": "Pontonnyy",
                        "latitude": "59.78667000",
                        "longitude": "30.61528000"
                    },
                    {
                        "id": 100833,
                        "name": "Primorskiy Rayon",
                        "latitude": "59.99624000",
                        "longitude": "30.24090000"
                    },
                    {
                        "id": 100896,
                        "name": "Pushkin",
                        "latitude": "59.71417000",
                        "longitude": "30.39642000"
                    },
                    {
                        "id": 100951,
                        "name": "Razliv",
                        "latitude": "60.07919000",
                        "longitude": "29.97206000"
                    },
                    {
                        "id": 100961,
                        "name": "Repino",
                        "latitude": "60.17217000",
                        "longitude": "29.86908000"
                    },
                    {
                        "id": 101074,
                        "name": "Saint Petersburg",
                        "latitude": "59.93863000",
                        "longitude": "30.31413000"
                    },
                    {
                        "id": 101104,
                        "name": "Sapërnyy",
                        "latitude": "59.77611000",
                        "longitude": "30.66139000"
                    },
                    {
                        "id": 101199,
                        "name": "Sestroretsk",
                        "latitude": "60.09801000",
                        "longitude": "29.96378000"
                    },
                    {
                        "id": 101355,
                        "name": "Shushary",
                        "latitude": "59.80917000",
                        "longitude": "30.38167000"
                    },
                    {
                        "id": 101359,
                        "name": "Shuvalovo",
                        "latitude": "60.04903000",
                        "longitude": "30.29360000"
                    },
                    {
                        "id": 101455,
                        "name": "Solnechnoye",
                        "latitude": "60.15612000",
                        "longitude": "29.94753000"
                    },
                    {
                        "id": 101485,
                        "name": "Sosnovaya Polyana",
                        "latitude": "59.83528000",
                        "longitude": "30.14667000"
                    },
                    {
                        "id": 101486,
                        "name": "Sosnovka",
                        "latitude": "60.01667000",
                        "longitude": "30.35000000"
                    },
                    {
                        "id": 101558,
                        "name": "Staraya Derevnya",
                        "latitude": "59.98834000",
                        "longitude": "30.24296000"
                    },
                    {
                        "id": 101624,
                        "name": "Strel'na",
                        "latitude": "59.85189000",
                        "longitude": "30.03611000"
                    },
                    {
                        "id": 101774,
                        "name": "Tarkhovka",
                        "latitude": "60.06687000",
                        "longitude": "29.97435000"
                    },
                    {
                        "id": 101989,
                        "name": "Tyarlevo",
                        "latitude": "59.70777000",
                        "longitude": "30.44543000"
                    },
                    {
                        "id": 102077,
                        "name": "Uritsk",
                        "latitude": "59.83889000",
                        "longitude": "30.17528000"
                    },
                    {
                        "id": 102122,
                        "name": "Ust’-Izhora",
                        "latitude": "59.81194000",
                        "longitude": "30.58139000"
                    },
                    {
                        "id": 102196,
                        "name": "Vasileostrovskiy Rayon",
                        "latitude": "59.93971000",
                        "longitude": "30.26115000"
                    },
                    {
                        "id": 102201,
                        "name": "Vasyl'evsky Ostrov",
                        "latitude": "59.94091000",
                        "longitude": "30.25377000"
                    },
                    {
                        "id": 102695,
                        "name": "Zelenogorsk",
                        "latitude": "60.19968000",
                        "longitude": "29.70183000"
                    }
                ]
            },
            {
                "id": 1848,
                "name": "Sakha",
                "iso2": "SA",
                "latitude": "66.76134510",
                "longitude": "124.12375300",
                "type": "republic",
                "cities": [
                    {
                        "id": 97491,
                        "name": "Abyysky District",
                        "latitude": "68.33333000",
                        "longitude": "146.00000000"
                    },
                    {
                        "id": 97561,
                        "name": "Aldan",
                        "latitude": "58.61021000",
                        "longitude": "125.39613000"
                    },
                    {
                        "id": 97596,
                        "name": "Allaikhovskiy Rayon",
                        "latitude": "71.00000000",
                        "longitude": "148.00000000"
                    },
                    {
                        "id": 97599,
                        "name": "Almaznyy",
                        "latitude": "62.44917000",
                        "longitude": "114.32778000"
                    },
                    {
                        "id": 97612,
                        "name": "Amga",
                        "latitude": "60.90009000",
                        "longitude": "131.97882000"
                    },
                    {
                        "id": 97617,
                        "name": "Anabarskiy Rayon",
                        "latitude": "72.50000000",
                        "longitude": "116.00000000"
                    },
                    {
                        "id": 97728,
                        "name": "Aykhal",
                        "latitude": "65.93381000",
                        "longitude": "111.48340000"
                    },
                    {
                        "id": 97809,
                        "name": "Batagay",
                        "latitude": "67.65653000",
                        "longitude": "134.63962000"
                    },
                    {
                        "id": 97810,
                        "name": "Batagay-Alyta",
                        "latitude": "67.79846000",
                        "longitude": "130.40119000"
                    },
                    {
                        "id": 97841,
                        "name": "Belaya Gora",
                        "latitude": "68.53805000",
                        "longitude": "146.18583000"
                    },
                    {
                        "id": 97887,
                        "name": "Berdigestyakh",
                        "latitude": "62.09842000",
                        "longitude": "126.69573000"
                    },
                    {
                        "id": 97898,
                        "name": "Berkakit",
                        "latitude": "56.57456000",
                        "longitude": "124.77635000"
                    },
                    {
                        "id": 98032,
                        "name": "Borogontsy",
                        "latitude": "62.67060000",
                        "longitude": "131.16344000"
                    },
                    {
                        "id": 98076,
                        "name": "Bulunskiy Rayon",
                        "latitude": "71.00000000",
                        "longitude": "126.00000000"
                    },
                    {
                        "id": 98181,
                        "name": "Chernyshevskiy",
                        "latitude": "63.01601000",
                        "longitude": "112.46901000"
                    },
                    {
                        "id": 98184,
                        "name": "Cherskiy",
                        "latitude": "68.75325000",
                        "longitude": "161.33197000"
                    },
                    {
                        "id": 98209,
                        "name": "Chokurdakh",
                        "latitude": "70.61897000",
                        "longitude": "147.89730000"
                    },
                    {
                        "id": 98220,
                        "name": "Chul’man",
                        "latitude": "56.84735000",
                        "longitude": "124.90812000"
                    },
                    {
                        "id": 98225,
                        "name": "Churapcha",
                        "latitude": "61.99858000",
                        "longitude": "132.43341000"
                    },
                    {
                        "id": 98264,
                        "name": "Deputatsky",
                        "latitude": "69.30958000",
                        "longitude": "139.97571000"
                    },
                    {
                        "id": 98376,
                        "name": "Dzhebariki-Khaya",
                        "latitude": "62.21084000",
                        "longitude": "135.84876000"
                    },
                    {
                        "id": 98408,
                        "name": "Eveno-Bytantaysky National District",
                        "latitude": "67.82428000",
                        "longitude": "130.44617000"
                    },
                    {
                        "id": 98543,
                        "name": "Gornyy Rayon",
                        "latitude": "62.33333000",
                        "longitude": "126.00000000"
                    },
                    {
                        "id": 98842,
                        "name": "Kangalassy",
                        "latitude": "62.34824000",
                        "longitude": "129.96471000"
                    },
                    {
                        "id": 98958,
                        "name": "Khandyga",
                        "latitude": "62.65333000",
                        "longitude": "135.56670000"
                    },
                    {
                        "id": 98973,
                        "name": "Khatassy",
                        "latitude": "61.90638000",
                        "longitude": "129.63302000"
                    },
                    {
                        "id": 99118,
                        "name": "Kobyayskiy Rayon",
                        "latitude": "64.00000000",
                        "longitude": "127.00000000"
                    },
                    {
                        "id": 99522,
                        "name": "Kysyl-Syr",
                        "latitude": "63.89482000",
                        "longitude": "122.76540000"
                    },
                    {
                        "id": 99552,
                        "name": "Lebedinyy",
                        "latitude": "58.48844000",
                        "longitude": "125.49415000"
                    },
                    {
                        "id": 99572,
                        "name": "Leninskiy",
                        "latitude": "58.57141000",
                        "longitude": "125.43918000"
                    },
                    {
                        "id": 99579,
                        "name": "Lensk",
                        "latitude": "60.72528000",
                        "longitude": "114.92778000"
                    },
                    {
                        "id": 99731,
                        "name": "Magan",
                        "latitude": "62.10746000",
                        "longitude": "129.53184000"
                    },
                    {
                        "id": 99799,
                        "name": "Markha",
                        "latitude": "62.11454000",
                        "longitude": "129.74403000"
                    },
                    {
                        "id": 99836,
                        "name": "Mayya",
                        "latitude": "61.73824000",
                        "longitude": "130.28161000"
                    },
                    {
                        "id": 99920,
                        "name": "Mirninskiy Rayon",
                        "latitude": "62.50000000",
                        "longitude": "113.88333000"
                    },
                    {
                        "id": 99921,
                        "name": "Mirny",
                        "latitude": "62.53528000",
                        "longitude": "113.96111000"
                    },
                    {
                        "id": 99942,
                        "name": "Mokhsogollokh",
                        "latitude": "61.39619000",
                        "longitude": "128.93810000"
                    },
                    {
                        "id": 99954,
                        "name": "Momsky District",
                        "latitude": "66.00000000",
                        "longitude": "144.00000000"
                    },
                    {
                        "id": 100055,
                        "name": "Namskiy Rayon",
                        "latitude": "63.00000000",
                        "longitude": "129.41667000"
                    },
                    {
                        "id": 100056,
                        "name": "Namtsy",
                        "latitude": "62.71959000",
                        "longitude": "129.66722000"
                    },
                    {
                        "id": 100110,
                        "name": "Neryungri",
                        "latitude": "56.66637000",
                        "longitude": "124.63825000"
                    },
                    {
                        "id": 100126,
                        "name": "Nezhdaninskoe",
                        "latitude": "62.50523000",
                        "longitude": "139.05104000"
                    },
                    {
                        "id": 100164,
                        "name": "Nizhniy Bestyakh",
                        "latitude": "61.96202000",
                        "longitude": "129.91245000"
                    },
                    {
                        "id": 100169,
                        "name": "Nizhniy Kuranakh",
                        "latitude": "58.82380000",
                        "longitude": "125.52278000"
                    },
                    {
                        "id": 100382,
                        "name": "Nyurba",
                        "latitude": "63.28417000",
                        "longitude": "118.33194000"
                    },
                    {
                        "id": 100383,
                        "name": "Nyurbinsky District",
                        "latitude": "63.25000000",
                        "longitude": "118.41667000"
                    },
                    {
                        "id": 100422,
                        "name": "Olenyok",
                        "latitude": "68.50472000",
                        "longitude": "112.44850000"
                    },
                    {
                        "id": 100423,
                        "name": "Olenyoksky District",
                        "latitude": "68.32018000",
                        "longitude": "112.59338000"
                    },
                    {
                        "id": 100428,
                        "name": "Olyokminsk",
                        "latitude": "60.37430000",
                        "longitude": "120.42030000"
                    },
                    {
                        "id": 100429,
                        "name": "Olyokminsky District",
                        "latitude": "59.00000000",
                        "longitude": "121.00000000"
                    },
                    {
                        "id": 100515,
                        "name": "Oymyakonskiy District",
                        "latitude": "63.00000000",
                        "longitude": "144.00000000"
                    },
                    {
                        "id": 100591,
                        "name": "Peleduy",
                        "latitude": "59.62889000",
                        "longitude": "112.74056000"
                    },
                    {
                        "id": 100745,
                        "name": "Pokrovsk",
                        "latitude": "61.47768000",
                        "longitude": "129.13699000"
                    },
                    {
                        "id": 101100,
                        "name": "Sangar",
                        "latitude": "63.92301000",
                        "longitude": "127.47135000"
                    },
                    {
                        "id": 101127,
                        "name": "Saskylakh",
                        "latitude": "71.96347000",
                        "longitude": "114.09199000"
                    },
                    {
                        "id": 101176,
                        "name": "Serebryanyy Bor",
                        "latitude": "56.67076000",
                        "longitude": "124.83754000"
                    },
                    {
                        "id": 101458,
                        "name": "Solnechnyy",
                        "latitude": "60.30217000",
                        "longitude": "137.55563000"
                    },
                    {
                        "id": 101543,
                        "name": "Srednekolymsk",
                        "latitude": "67.45659000",
                        "longitude": "153.70246000"
                    },
                    {
                        "id": 101544,
                        "name": "Srednekolymsky District",
                        "latitude": "68.00000000",
                        "longitude": "153.00000000"
                    },
                    {
                        "id": 101664,
                        "name": "Suntar",
                        "latitude": "62.14444000",
                        "longitude": "117.63194000"
                    },
                    {
                        "id": 101665,
                        "name": "Suntarskiy District",
                        "latitude": "63.00000000",
                        "longitude": "115.00000000"
                    },
                    {
                        "id": 101736,
                        "name": "Tabaga",
                        "latitude": "61.85502000",
                        "longitude": "129.60022000"
                    },
                    {
                        "id": 101855,
                        "name": "Tiksi",
                        "latitude": "71.69002000",
                        "longitude": "128.86467000"
                    },
                    {
                        "id": 101885,
                        "name": "Tommot",
                        "latitude": "58.95717000",
                        "longitude": "126.29158000"
                    },
                    {
                        "id": 101886,
                        "name": "Tomponskiy District",
                        "latitude": "62.75000000",
                        "longitude": "135.41667000"
                    },
                    {
                        "id": 102017,
                        "name": "Udachny",
                        "latitude": "66.42989000",
                        "longitude": "112.40210000"
                    },
                    {
                        "id": 102106,
                        "name": "Ust-Aldansky District",
                        "latitude": "63.00000000",
                        "longitude": "132.00000000"
                    },
                    {
                        "id": 102107,
                        "name": "Ust-Kuyga",
                        "latitude": "70.00208000",
                        "longitude": "135.54876000"
                    },
                    {
                        "id": 102108,
                        "name": "Ust-Maya",
                        "latitude": "60.41553000",
                        "longitude": "134.54405000"
                    },
                    {
                        "id": 102109,
                        "name": "Ust-Nera",
                        "latitude": "64.56968000",
                        "longitude": "143.23700000"
                    },
                    {
                        "id": 102142,
                        "name": "Ust’-Yanskiy Rayon",
                        "latitude": "69.33333000",
                        "longitude": "139.91667000"
                    },
                    {
                        "id": 102239,
                        "name": "Verkhnekolymsky District",
                        "latitude": "65.75000000",
                        "longitude": "150.83333000"
                    },
                    {
                        "id": 102244,
                        "name": "Verkhnevilyuysk",
                        "latitude": "63.44578000",
                        "longitude": "120.30739000"
                    },
                    {
                        "id": 102245,
                        "name": "Verkhnevilyuysky District",
                        "latitude": "63.00000000",
                        "longitude": "120.50000000"
                    },
                    {
                        "id": 102281,
                        "name": "Verkhoyansk",
                        "latitude": "67.55387000",
                        "longitude": "133.38976000"
                    },
                    {
                        "id": 102282,
                        "name": "Verkhoyansky District",
                        "latitude": "68.00000000",
                        "longitude": "136.00000000"
                    },
                    {
                        "id": 102309,
                        "name": "Vilyuysk",
                        "latitude": "63.74683000",
                        "longitude": "121.63339000"
                    },
                    {
                        "id": 102310,
                        "name": "Vilyuyskiy Rayon",
                        "latitude": "64.00000000",
                        "longitude": "123.00000000"
                    },
                    {
                        "id": 102311,
                        "name": "Vilyuysky District",
                        "latitude": "63.76398000",
                        "longitude": "121.65436000"
                    },
                    {
                        "id": 102321,
                        "name": "Vitim",
                        "latitude": "59.44326000",
                        "longitude": "112.56993000"
                    },
                    {
                        "id": 102473,
                        "name": "Yakutsk",
                        "latitude": "61.97382000",
                        "longitude": "129.75403000"
                    },
                    {
                        "id": 102582,
                        "name": "Ytyk-Kyuyël’",
                        "latitude": "62.36119000",
                        "longitude": "133.56044000"
                    },
                    {
                        "id": 102714,
                        "name": "Zhatay",
                        "latitude": "62.15975000",
                        "longitude": "129.82843000"
                    },
                    {
                        "id": 102727,
                        "name": "Zhigansk",
                        "latitude": "66.76601000",
                        "longitude": "123.37418000"
                    },
                    {
                        "id": 102728,
                        "name": "Zhigansky District",
                        "latitude": "66.75000000",
                        "longitude": "123.25000000"
                    },
                    {
                        "id": 102787,
                        "name": "Zyryanka",
                        "latitude": "65.73489000",
                        "longitude": "150.89429000"
                    }
                ]
            },
            {
                "id": 1875,
                "name": "Sakhalin",
                "iso2": "SAK",
                "latitude": "50.69098480",
                "longitude": "142.95056890",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97569,
                        "name": "Aleksandrovsk-Sakhalinskiy",
                        "latitude": "50.89926000",
                        "longitude": "142.16215000"
                    },
                    {
                        "id": 97632,
                        "name": "Aniva",
                        "latitude": "46.71492000",
                        "longitude": "142.52866000"
                    },
                    {
                        "id": 98047,
                        "name": "Boshnyakovo",
                        "latitude": "49.64572000",
                        "longitude": "142.17047000"
                    },
                    {
                        "id": 98097,
                        "name": "Bykov",
                        "latitude": "47.32099000",
                        "longitude": "142.56226000"
                    },
                    {
                        "id": 98136,
                        "name": "Chekhov",
                        "latitude": "47.44984000",
                        "longitude": "141.99064000"
                    },
                    {
                        "id": 98303,
                        "name": "Dolinsk",
                        "latitude": "47.32946000",
                        "longitude": "142.79291000"
                    },
                    {
                        "id": 98459,
                        "name": "Gastello",
                        "latitude": "49.10056000",
                        "longitude": "142.95917000"
                    },
                    {
                        "id": 98535,
                        "name": "Gornozavodsk",
                        "latitude": "46.55984000",
                        "longitude": "141.84358000"
                    },
                    {
                        "id": 98996,
                        "name": "Kholmsk",
                        "latitude": "47.04737000",
                        "longitude": "142.05048000"
                    },
                    {
                        "id": 99218,
                        "name": "Korsakov",
                        "latitude": "46.63420000",
                        "longitude": "142.77722000"
                    },
                    {
                        "id": 99304,
                        "name": "Krasnogorsk",
                        "latitude": "48.41728000",
                        "longitude": "142.08686000"
                    },
                    {
                        "id": 99463,
                        "name": "Kuril’sk",
                        "latitude": "45.22686000",
                        "longitude": "147.87767000"
                    },
                    {
                        "id": 99462,
                        "name": "Kurilsky District",
                        "latitude": "46.00000000",
                        "longitude": "150.00000000"
                    },
                    {
                        "id": 99581,
                        "name": "Leonidovo",
                        "latitude": "49.28619000",
                        "longitude": "142.86975000"
                    },
                    {
                        "id": 99741,
                        "name": "Makarov",
                        "latitude": "48.62698000",
                        "longitude": "142.77999000"
                    },
                    {
                        "id": 99886,
                        "name": "Mgachi",
                        "latitude": "51.04834000",
                        "longitude": "142.26821000"
                    },
                    {
                        "id": 100116,
                        "name": "Nevel’sk",
                        "latitude": "46.67902000",
                        "longitude": "141.85629000"
                    },
                    {
                        "id": 100195,
                        "name": "Nogliki",
                        "latitude": "51.79917000",
                        "longitude": "143.13871000"
                    },
                    {
                        "id": 100401,
                        "name": "Okha",
                        "latitude": "53.58991000",
                        "longitude": "142.95313000"
                    },
                    {
                        "id": 100503,
                        "name": "Otrada",
                        "latitude": "44.06832000",
                        "longitude": "145.86454000"
                    },
                    {
                        "id": 100779,
                        "name": "Poronaysk",
                        "latitude": "49.22188000",
                        "longitude": "143.09694000"
                    },
                    {
                        "id": 100801,
                        "name": "Pravda",
                        "latitude": "46.93972000",
                        "longitude": "142.00426000"
                    },
                    {
                        "id": 101212,
                        "name": "Severo-Kuril’sk",
                        "latitude": "50.67531000",
                        "longitude": "156.12695000"
                    },
                    {
                        "id": 101240,
                        "name": "Shakhtersk",
                        "latitude": "49.17175000",
                        "longitude": "142.13640000"
                    },
                    {
                        "id": 101286,
                        "name": "Shebunino",
                        "latitude": "46.43010000",
                        "longitude": "141.85699000"
                    },
                    {
                        "id": 101312,
                        "name": "Shikotan",
                        "latitude": "43.79916000",
                        "longitude": "146.72164000"
                    },
                    {
                        "id": 101373,
                        "name": "Sinegorsk",
                        "latitude": "47.17278000",
                        "longitude": "142.51577000"
                    },
                    {
                        "id": 101413,
                        "name": "Smirnykh",
                        "latitude": "49.74596000",
                        "longitude": "142.83716000"
                    },
                    {
                        "id": 101436,
                        "name": "Sokol",
                        "latitude": "47.24464000",
                        "longitude": "142.75167000"
                    },
                    {
                        "id": 101882,
                        "name": "Tomari",
                        "latitude": "47.76482000",
                        "longitude": "142.07106000"
                    },
                    {
                        "id": 101925,
                        "name": "Troitskoye",
                        "latitude": "46.92493000",
                        "longitude": "142.64532000"
                    },
                    {
                        "id": 101970,
                        "name": "Tungor",
                        "latitude": "53.39121000",
                        "longitude": "142.95755000"
                    },
                    {
                        "id": 101992,
                        "name": "Tymovskoye",
                        "latitude": "50.84925000",
                        "longitude": "142.66520000"
                    },
                    {
                        "id": 102027,
                        "name": "Uglegorsk",
                        "latitude": "49.08047000",
                        "longitude": "142.06449000"
                    },
                    {
                        "id": 102029,
                        "name": "Uglegorskiy Rayon",
                        "latitude": "49.08333000",
                        "longitude": "142.08333000"
                    },
                    {
                        "id": 102033,
                        "name": "Uglezavodsk",
                        "latitude": "47.32332000",
                        "longitude": "142.63317000"
                    },
                    {
                        "id": 102175,
                        "name": "Vakhrushev",
                        "latitude": "48.99035000",
                        "longitude": "142.95303000"
                    },
                    {
                        "id": 102401,
                        "name": "Vostok",
                        "latitude": "48.97715000",
                        "longitude": "142.91556000"
                    },
                    {
                        "id": 102457,
                        "name": "Yablochnyy",
                        "latitude": "47.15200000",
                        "longitude": "142.05678000"
                    },
                    {
                        "id": 102613,
                        "name": "Yuzhno-Kurilsk",
                        "latitude": "44.02734000",
                        "longitude": "145.86146000"
                    },
                    {
                        "id": 102614,
                        "name": "Yuzhno-Kurilsky District",
                        "latitude": "44.59242000",
                        "longitude": "146.77048000"
                    },
                    {
                        "id": 102615,
                        "name": "Yuzhno-Sakhalinsk",
                        "latitude": "46.95407000",
                        "longitude": "142.73603000"
                    }
                ]
            },
            {
                "id": 1862,
                "name": "Samara",
                "iso2": "SAM",
                "latitude": "53.41838390",
                "longitude": "50.47255280",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97761,
                        "name": "Bakhilovo",
                        "latitude": "53.40110000",
                        "longitude": "49.63600000"
                    },
                    {
                        "id": 97772,
                        "name": "Balasheyka",
                        "latitude": "53.28410000",
                        "longitude": "48.08510000"
                    },
                    {
                        "id": 97902,
                        "name": "Berëza",
                        "latitude": "53.51833000",
                        "longitude": "50.13967000"
                    },
                    {
                        "id": 97918,
                        "name": "Bezenchuk",
                        "latitude": "52.98200000",
                        "longitude": "49.43330000"
                    },
                    {
                        "id": 97962,
                        "name": "Bogatoye",
                        "latitude": "53.06010000",
                        "longitude": "51.33250000"
                    },
                    {
                        "id": 97963,
                        "name": "Bogatyr’",
                        "latitude": "53.42980000",
                        "longitude": "49.94550000"
                    },
                    {
                        "id": 98043,
                        "name": "Borskoye",
                        "latitude": "53.03333000",
                        "longitude": "51.71667000"
                    },
                    {
                        "id": 98115,
                        "name": "Chapayevsk",
                        "latitude": "52.97710000",
                        "longitude": "49.70860000"
                    },
                    {
                        "id": 98139,
                        "name": "Chelno-Vershiny",
                        "latitude": "54.41480000",
                        "longitude": "51.08594000"
                    },
                    {
                        "id": 98341,
                        "name": "Dubovyy Umët",
                        "latitude": "52.97629000",
                        "longitude": "50.28569000"
                    },
                    {
                        "id": 98475,
                        "name": "Georgiyevka",
                        "latitude": "53.27438000",
                        "longitude": "50.99848000"
                    },
                    {
                        "id": 98697,
                        "name": "Isakly",
                        "latitude": "54.13333000",
                        "longitude": "51.53333000"
                    },
                    {
                        "id": 98829,
                        "name": "Kamyshla",
                        "latitude": "54.11693000",
                        "longitude": "52.14262000"
                    },
                    {
                        "id": 99015,
                        "name": "Khryashchevka",
                        "latitude": "53.81190000",
                        "longitude": "49.09160000"
                    },
                    {
                        "id": 99028,
                        "name": "Khvorostyanka",
                        "latitude": "52.60960000",
                        "longitude": "48.95970000"
                    },
                    {
                        "id": 99045,
                        "name": "Kinel’",
                        "latitude": "53.22571000",
                        "longitude": "50.62907000"
                    },
                    {
                        "id": 99046,
                        "name": "Kinel’-Cherkassy",
                        "latitude": "53.47060000",
                        "longitude": "51.47431000"
                    },
                    {
                        "id": 99047,
                        "name": "Kinel’skiy Rayon",
                        "latitude": "53.16667000",
                        "longitude": "50.75000000"
                    },
                    {
                        "id": 99108,
                        "name": "Klyavlino",
                        "latitude": "54.26491000",
                        "longitude": "52.02674000"
                    },
                    {
                        "id": 99229,
                        "name": "Koshki",
                        "latitude": "54.20914000",
                        "longitude": "50.46767000"
                    },
                    {
                        "id": 99296,
                        "name": "Krasnoarmeyskoye",
                        "latitude": "52.71994000",
                        "longitude": "50.03122000"
                    },
                    {
                        "id": 99346,
                        "name": "Krasnoyarskiy Rayon",
                        "latitude": "53.50000000",
                        "longitude": "50.50000000"
                    },
                    {
                        "id": 99376,
                        "name": "Krasnyy Yar",
                        "latitude": "53.49988000",
                        "longitude": "50.39312000"
                    },
                    {
                        "id": 99400,
                        "name": "Krotovka",
                        "latitude": "53.28580000",
                        "longitude": "51.16860000"
                    },
                    {
                        "id": 99479,
                        "name": "Kurumoch",
                        "latitude": "53.48963000",
                        "longitude": "50.03748000"
                    },
                    {
                        "id": 99835,
                        "name": "Mayskoye",
                        "latitude": "52.27244000",
                        "longitude": "50.03383000"
                    },
                    {
                        "id": 99879,
                        "name": "Mezhdurechensk",
                        "latitude": "53.26650000",
                        "longitude": "49.11160000"
                    },
                    {
                        "id": 99923,
                        "name": "Mirnyy",
                        "latitude": "53.50642000",
                        "longitude": "50.27658000"
                    },
                    {
                        "id": 100084,
                        "name": "Neftegorsk",
                        "latitude": "52.80200000",
                        "longitude": "51.16600000"
                    },
                    {
                        "id": 100085,
                        "name": "Neftegorskiy Rayon",
                        "latitude": "52.83333000",
                        "longitude": "50.83333000"
                    },
                    {
                        "id": 100256,
                        "name": "Novokuybyshevsk",
                        "latitude": "53.09590000",
                        "longitude": "49.94620000"
                    },
                    {
                        "id": 100295,
                        "name": "Novosemeykino",
                        "latitude": "53.37056000",
                        "longitude": "50.35428000"
                    },
                    {
                        "id": 100340,
                        "name": "Novyy Buyan",
                        "latitude": "53.68611000",
                        "longitude": "50.04691000"
                    },
                    {
                        "id": 100390,
                        "name": "Obsharovka",
                        "latitude": "53.12500000",
                        "longitude": "48.85306000"
                    },
                    {
                        "id": 100408,
                        "name": "Oktyabr’sk",
                        "latitude": "53.16722000",
                        "longitude": "48.70056000"
                    },
                    {
                        "id": 100486,
                        "name": "Osinki",
                        "latitude": "52.84320000",
                        "longitude": "49.51320000"
                    },
                    {
                        "id": 100508,
                        "name": "Otradnyy",
                        "latitude": "53.37596000",
                        "longitude": "51.34520000"
                    },
                    {
                        "id": 100607,
                        "name": "Perevoloki",
                        "latitude": "53.24580000",
                        "longitude": "49.17930000"
                    },
                    {
                        "id": 100640,
                        "name": "Pestravka",
                        "latitude": "52.39820000",
                        "longitude": "49.96100000"
                    },
                    {
                        "id": 100646,
                        "name": "Petra-Dubrava",
                        "latitude": "53.29613000",
                        "longitude": "50.36554000"
                    },
                    {
                        "id": 100731,
                        "name": "Podsolnechnoye",
                        "latitude": "53.15000000",
                        "longitude": "52.01910000"
                    },
                    {
                        "id": 100733,
                        "name": "Podstepki",
                        "latitude": "53.51510000",
                        "longitude": "49.13550000"
                    },
                    {
                        "id": 100740,
                        "name": "Pokhvistnevo",
                        "latitude": "53.65237000",
                        "longitude": "52.12738000"
                    },
                    {
                        "id": 100793,
                        "name": "Povolzhskiy",
                        "latitude": "53.58540000",
                        "longitude": "49.76290000"
                    },
                    {
                        "id": 100817,
                        "name": "Pribrezhnyy",
                        "latitude": "53.48662000",
                        "longitude": "49.85836000"
                    },
                    {
                        "id": 100996,
                        "name": "Roschinskiy",
                        "latitude": "53.05111000",
                        "longitude": "50.49667000"
                    },
                    {
                        "id": 101015,
                        "name": "Rozhdestveno",
                        "latitude": "53.23745000",
                        "longitude": "50.05971000"
                    },
                    {
                        "id": 101085,
                        "name": "Samara",
                        "latitude": "53.20007000",
                        "longitude": "50.15000000"
                    },
                    {
                        "id": 101187,
                        "name": "Sernovodsk",
                        "latitude": "53.92293000",
                        "longitude": "51.25704000"
                    },
                    {
                        "id": 101302,
                        "name": "Shentala",
                        "latitude": "54.45000000",
                        "longitude": "51.48333000"
                    },
                    {
                        "id": 101309,
                        "name": "Shigony",
                        "latitude": "53.38750000",
                        "longitude": "48.67770000"
                    },
                    {
                        "id": 101421,
                        "name": "Smyshlyayevka",
                        "latitude": "53.23913000",
                        "longitude": "50.39072000"
                    },
                    {
                        "id": 101536,
                        "name": "Spiridonovka",
                        "latitude": "53.09248000",
                        "longitude": "50.64621000"
                    },
                    {
                        "id": 101653,
                        "name": "Sukhodol",
                        "latitude": "53.90063000",
                        "longitude": "51.21170000"
                    },
                    {
                        "id": 101675,
                        "name": "Surgut",
                        "latitude": "53.92498000",
                        "longitude": "51.20348000"
                    },
                    {
                        "id": 101735,
                        "name": "Syzran’",
                        "latitude": "53.15850000",
                        "longitude": "48.46810000"
                    },
                    {
                        "id": 101881,
                        "name": "Tol’yatti",
                        "latitude": "53.53030000",
                        "longitude": "49.34610000"
                    },
                    {
                        "id": 102150,
                        "name": "Utevka",
                        "latitude": "52.90350000",
                        "longitude": "50.94950000"
                    },
                    {
                        "id": 102191,
                        "name": "Varlamovo",
                        "latitude": "53.18970000",
                        "longitude": "48.42260000"
                    },
                    {
                        "id": 102370,
                        "name": "Volzhskiy",
                        "latitude": "53.43058000",
                        "longitude": "50.11900000"
                    },
                    {
                        "id": 102546,
                        "name": "Yelkhovka",
                        "latitude": "53.86668000",
                        "longitude": "50.28319000"
                    },
                    {
                        "id": 102729,
                        "name": "Zhigulevsk",
                        "latitude": "53.39972000",
                        "longitude": "49.49528000"
                    },
                    {
                        "id": 102730,
                        "name": "Zhiguli",
                        "latitude": "53.35790000",
                        "longitude": "49.30100000"
                    },
                    {
                        "id": 102767,
                        "name": "Zol’noye",
                        "latitude": "53.44210000",
                        "longitude": "49.79780000"
                    }
                ]
            },
            {
                "id": 1887,
                "name": "Saratov",
                "iso2": "SAR",
                "latitude": "51.83692630",
                "longitude": "46.75393970",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97566,
                        "name": "Aleksandrov Gay",
                        "latitude": "50.14704000",
                        "longitude": "48.57037000"
                    },
                    {
                        "id": 97576,
                        "name": "Alekseyevka",
                        "latitude": "52.30583000",
                        "longitude": "48.02611000"
                    },
                    {
                        "id": 97663,
                        "name": "Arkadak",
                        "latitude": "51.93261000",
                        "longitude": "43.49779000"
                    },
                    {
                        "id": 97712,
                        "name": "Atkarsk",
                        "latitude": "51.87185000",
                        "longitude": "45.00775000"
                    },
                    {
                        "id": 97713,
                        "name": "Atkarskiy Rayon",
                        "latitude": "51.91667000",
                        "longitude": "45.00000000"
                    },
                    {
                        "id": 97771,
                        "name": "Balakovo",
                        "latitude": "52.02782000",
                        "longitude": "47.80070000"
                    },
                    {
                        "id": 97775,
                        "name": "Balashov",
                        "latitude": "51.55020000",
                        "longitude": "43.16670000"
                    },
                    {
                        "id": 97782,
                        "name": "Baltay",
                        "latitude": "52.46525000",
                        "longitude": "46.63081000"
                    },
                    {
                        "id": 97783,
                        "name": "Baltayskiy Rayon",
                        "latitude": "52.50000000",
                        "longitude": "46.66667000"
                    },
                    {
                        "id": 97828,
                        "name": "Bazarno-Karabulakskiy Rayon",
                        "latitude": "52.33333000",
                        "longitude": "46.33333000"
                    },
                    {
                        "id": 97829,
                        "name": "Bazarnyy Karabulak",
                        "latitude": "52.26833000",
                        "longitude": "46.41444000"
                    },
                    {
                        "id": 98009,
                        "name": "Bol’shoy Karay",
                        "latitude": "51.60542000",
                        "longitude": "42.69006000"
                    },
                    {
                        "id": 98159,
                        "name": "Cherkasskoye",
                        "latitude": "52.42895000",
                        "longitude": "47.21048000"
                    },
                    {
                        "id": 98267,
                        "name": "Dergachi",
                        "latitude": "51.23280000",
                        "longitude": "48.76590000"
                    },
                    {
                        "id": 98350,
                        "name": "Dukhovnitskoye",
                        "latitude": "52.48280000",
                        "longitude": "48.21370000"
                    },
                    {
                        "id": 98398,
                        "name": "Engel’s",
                        "latitude": "51.48389000",
                        "longitude": "46.10528000"
                    },
                    {
                        "id": 98399,
                        "name": "Engel’sskiy Rayon",
                        "latitude": "51.50000000",
                        "longitude": "46.16667000"
                    },
                    {
                        "id": 98539,
                        "name": "Gornyy",
                        "latitude": "51.75780000",
                        "longitude": "48.54130000"
                    },
                    {
                        "id": 98737,
                        "name": "Ivanteyevka",
                        "latitude": "52.26670000",
                        "longitude": "49.10550000"
                    },
                    {
                        "id": 98788,
                        "name": "Kalininsk",
                        "latitude": "51.50000000",
                        "longitude": "44.47580000"
                    },
                    {
                        "id": 98821,
                        "name": "Kamenskiy",
                        "latitude": "50.88547000",
                        "longitude": "45.48801000"
                    },
                    {
                        "id": 99023,
                        "name": "Khvalynsk",
                        "latitude": "52.49060000",
                        "longitude": "48.10580000"
                    },
                    {
                        "id": 99024,
                        "name": "Khvalynskiy Rayon",
                        "latitude": "52.50000000",
                        "longitude": "47.91667000"
                    },
                    {
                        "id": 99027,
                        "name": "Khvatovka",
                        "latitude": "52.35236000",
                        "longitude": "46.56282000"
                    },
                    {
                        "id": 99210,
                        "name": "Kormëzhka",
                        "latitude": "51.90050000",
                        "longitude": "48.01630000"
                    },
                    {
                        "id": 99290,
                        "name": "Krasnoarmeysk",
                        "latitude": "51.02389000",
                        "longitude": "45.69694000"
                    },
                    {
                        "id": 99367,
                        "name": "Krasnyy Kut",
                        "latitude": "50.95000000",
                        "longitude": "46.96667000"
                    },
                    {
                        "id": 99369,
                        "name": "Krasnyy Oktyabr’",
                        "latitude": "51.54018000",
                        "longitude": "45.70382000"
                    },
                    {
                        "id": 99375,
                        "name": "Krasnyy Yar",
                        "latitude": "51.62917000",
                        "longitude": "46.42167000"
                    },
                    {
                        "id": 99709,
                        "name": "Lysyye Gory",
                        "latitude": "51.55063000",
                        "longitude": "44.84144000"
                    },
                    {
                        "id": 99801,
                        "name": "Marks",
                        "latitude": "51.71111000",
                        "longitude": "46.74861000"
                    },
                    {
                        "id": 99802,
                        "name": "Marksovskiy Rayon",
                        "latitude": "51.66667000",
                        "longitude": "46.83333000"
                    },
                    {
                        "id": 99943,
                        "name": "Mokrous",
                        "latitude": "51.23730000",
                        "longitude": "47.51370000"
                    },
                    {
                        "id": 100325,
                        "name": "Novouzensk",
                        "latitude": "50.45917000",
                        "longitude": "48.14306000"
                    },
                    {
                        "id": 100357,
                        "name": "Novyye Burasy",
                        "latitude": "52.13236000",
                        "longitude": "46.07144000"
                    },
                    {
                        "id": 100600,
                        "name": "Perelyub",
                        "latitude": "51.86292000",
                        "longitude": "50.35412000"
                    },
                    {
                        "id": 100658,
                        "name": "Petrovsk",
                        "latitude": "52.30639000",
                        "longitude": "45.39167000"
                    },
                    {
                        "id": 100676,
                        "name": "Pinerovka",
                        "latitude": "51.56200000",
                        "longitude": "43.06890000"
                    },
                    {
                        "id": 100687,
                        "name": "Piterka",
                        "latitude": "50.68030000",
                        "longitude": "47.44539000"
                    },
                    {
                        "id": 100721,
                        "name": "Podlesnoye",
                        "latitude": "51.81610000",
                        "longitude": "47.00900000"
                    },
                    {
                        "id": 100847,
                        "name": "Privolzhskiy",
                        "latitude": "51.40944000",
                        "longitude": "46.04833000"
                    },
                    {
                        "id": 100851,
                        "name": "Privolzhskoye",
                        "latitude": "51.69194000",
                        "longitude": "46.72361000"
                    },
                    {
                        "id": 100889,
                        "name": "Pugachev",
                        "latitude": "52.01333000",
                        "longitude": "48.80250000"
                    },
                    {
                        "id": 100897,
                        "name": "Pushkino",
                        "latitude": "51.23500000",
                        "longitude": "46.97417000"
                    },
                    {
                        "id": 100962,
                        "name": "Repnoye",
                        "latitude": "51.59210000",
                        "longitude": "43.18610000"
                    },
                    {
                        "id": 100986,
                        "name": "Romanovka",
                        "latitude": "51.74427000",
                        "longitude": "42.75270000"
                    },
                    {
                        "id": 101011,
                        "name": "Rovnoye",
                        "latitude": "50.77650000",
                        "longitude": "46.05085000"
                    },
                    {
                        "id": 101017,
                        "name": "Rtishchevo",
                        "latitude": "52.26041000",
                        "longitude": "43.78745000"
                    },
                    {
                        "id": 101090,
                        "name": "Samoylovka",
                        "latitude": "51.18400000",
                        "longitude": "43.70810000"
                    },
                    {
                        "id": 101114,
                        "name": "Saratov",
                        "latitude": "51.54056000",
                        "longitude": "46.00861000"
                    },
                    {
                        "id": 101116,
                        "name": "Saratovskiy Rayon",
                        "latitude": "51.75000000",
                        "longitude": "46.16667000"
                    },
                    {
                        "id": 101172,
                        "name": "Sennoy",
                        "latitude": "52.15090000",
                        "longitude": "46.96309000"
                    },
                    {
                        "id": 101310,
                        "name": "Shikhany",
                        "latitude": "52.11776000",
                        "longitude": "47.19860000"
                    },
                    {
                        "id": 101348,
                        "name": "Shumeyka",
                        "latitude": "51.56361000",
                        "longitude": "46.24833000"
                    },
                    {
                        "id": 101376,
                        "name": "Sinodskoye",
                        "latitude": "51.99180000",
                        "longitude": "46.67009000"
                    },
                    {
                        "id": 101440,
                        "name": "Sokolovyy",
                        "latitude": "51.56857000",
                        "longitude": "45.83312000"
                    },
                    {
                        "id": 101517,
                        "name": "Sovetskoye",
                        "latitude": "51.44255000",
                        "longitude": "46.74240000"
                    },
                    {
                        "id": 101611,
                        "name": "Staryye Ozinki",
                        "latitude": "51.17860000",
                        "longitude": "49.67690000"
                    },
                    {
                        "id": 101616,
                        "name": "Stepnoye",
                        "latitude": "51.37972000",
                        "longitude": "46.84917000"
                    },
                    {
                        "id": 101706,
                        "name": "Svetlyy",
                        "latitude": "51.67370000",
                        "longitude": "45.63054000"
                    },
                    {
                        "id": 101713,
                        "name": "Svobodnyy",
                        "latitude": "52.33039000",
                        "longitude": "46.37122000"
                    },
                    {
                        "id": 101797,
                        "name": "Tatishchevo",
                        "latitude": "51.67028000",
                        "longitude": "45.59528000"
                    },
                    {
                        "id": 101836,
                        "name": "Tersa",
                        "latitude": "52.08671000",
                        "longitude": "47.53936000"
                    },
                    {
                        "id": 101979,
                        "name": "Turki",
                        "latitude": "51.98703000",
                        "longitude": "43.27310000"
                    },
                    {
                        "id": 102374,
                        "name": "Vol’sk",
                        "latitude": "52.04541000",
                        "longitude": "47.37993000"
                    },
                    {
                        "id": 102375,
                        "name": "Vol’skiy Rayon",
                        "latitude": "52.08333000",
                        "longitude": "47.25000000"
                    },
                    {
                        "id": 102391,
                        "name": "Voskresenskiy Rayon",
                        "latitude": "51.84139000",
                        "longitude": "46.90250000"
                    },
                    {
                        "id": 102392,
                        "name": "Voskresenskoye",
                        "latitude": "51.82478000",
                        "longitude": "46.93508000"
                    },
                    {
                        "id": 102529,
                        "name": "Yekaterinovka",
                        "latitude": "52.05083000",
                        "longitude": "44.34515000"
                    },
                    {
                        "id": 102548,
                        "name": "Yelshanka",
                        "latitude": "51.81389000",
                        "longitude": "46.39972000"
                    },
                    {
                        "id": 102572,
                        "name": "Yershov",
                        "latitude": "51.35130000",
                        "longitude": "48.27660000"
                    }
                ]
            },
            {
                "id": 1885,
                "name": "Smolensk",
                "iso2": "SMO",
                "latitude": "54.98829940",
                "longitude": "32.66773780",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 98259,
                        "name": "Demidov",
                        "latitude": "55.27063000",
                        "longitude": "31.51497000"
                    },
                    {
                        "id": 98269,
                        "name": "Desnogorsk",
                        "latitude": "54.15077000",
                        "longitude": "33.28151000"
                    },
                    {
                        "id": 98319,
                        "name": "Dorogobuzh",
                        "latitude": "54.91500000",
                        "longitude": "33.29722000"
                    },
                    {
                        "id": 98351,
                        "name": "Dukhovshchina",
                        "latitude": "55.19190000",
                        "longitude": "32.41110000"
                    },
                    {
                        "id": 98446,
                        "name": "Gagarin",
                        "latitude": "55.55291000",
                        "longitude": "34.99537000"
                    },
                    {
                        "id": 98499,
                        "name": "Glinka",
                        "latitude": "54.64043000",
                        "longitude": "32.87811000"
                    },
                    {
                        "id": 98511,
                        "name": "Golynki",
                        "latitude": "54.86964000",
                        "longitude": "31.38609000"
                    },
                    {
                        "id": 98874,
                        "name": "Kardymovo",
                        "latitude": "54.89016000",
                        "longitude": "32.43111000"
                    },
                    {
                        "id": 98910,
                        "name": "Katyn'",
                        "latitude": "54.77455000",
                        "longitude": "31.69041000"
                    },
                    {
                        "id": 98983,
                        "name": "Khislavichi",
                        "latitude": "54.18714000",
                        "longitude": "32.15817000"
                    },
                    {
                        "id": 98993,
                        "name": "Kholm-Zhirkovskiy",
                        "latitude": "55.51889000",
                        "longitude": "33.47306000"
                    },
                    {
                        "id": 99956,
                        "name": "Monastyrshchina",
                        "latitude": "54.34961000",
                        "longitude": "31.83795000"
                    },
                    {
                        "id": 100239,
                        "name": "Novodugino",
                        "latitude": "55.63052000",
                        "longitude": "34.28423000"
                    },
                    {
                        "id": 100494,
                        "name": "Oster",
                        "latitude": "54.01700000",
                        "longitude": "32.80190000"
                    },
                    {
                        "id": 100523,
                        "name": "Ozërnyy",
                        "latitude": "55.58020000",
                        "longitude": "32.41270000"
                    },
                    {
                        "id": 100586,
                        "name": "Pechersk",
                        "latitude": "54.85355000",
                        "longitude": "32.03154000"
                    },
                    {
                        "id": 100710,
                        "name": "Pochinok",
                        "latitude": "54.40685000",
                        "longitude": "32.44067000"
                    },
                    {
                        "id": 101001,
                        "name": "Roslavl’",
                        "latitude": "53.95278000",
                        "longitude": "32.86389000"
                    },
                    {
                        "id": 101025,
                        "name": "Rudnya",
                        "latitude": "54.94698000",
                        "longitude": "31.09340000"
                    },
                    {
                        "id": 101070,
                        "name": "Safonovo",
                        "latitude": "55.11087000",
                        "longitude": "33.23292000"
                    },
                    {
                        "id": 101071,
                        "name": "Safonovskiy Rayon",
                        "latitude": "55.16667000",
                        "longitude": "33.16667000"
                    },
                    {
                        "id": 101267,
                        "name": "Shatalovo",
                        "latitude": "54.33400000",
                        "longitude": "32.44650000"
                    },
                    {
                        "id": 101352,
                        "name": "Shumyachi",
                        "latitude": "53.85833000",
                        "longitude": "32.42417000"
                    },
                    {
                        "id": 101415,
                        "name": "Smolensk",
                        "latitude": "54.78180000",
                        "longitude": "32.04010000"
                    },
                    {
                        "id": 101620,
                        "name": "Stodolishche",
                        "latitude": "54.18594000",
                        "longitude": "32.64925000"
                    },
                    {
                        "id": 101721,
                        "name": "Sychëvka",
                        "latitude": "55.82515000",
                        "longitude": "34.27361000"
                    },
                    {
                        "id": 101747,
                        "name": "Talashkino",
                        "latitude": "54.65471000",
                        "longitude": "32.18325000"
                    },
                    {
                        "id": 102008,
                        "name": "Tëmkino",
                        "latitude": "55.10917000",
                        "longitude": "35.01389000"
                    },
                    {
                        "id": 102040,
                        "name": "Ugra",
                        "latitude": "54.77775000",
                        "longitude": "34.32674000"
                    },
                    {
                        "id": 102220,
                        "name": "Velizh",
                        "latitude": "55.60564000",
                        "longitude": "31.19673000"
                    },
                    {
                        "id": 102238,
                        "name": "Verkhnedneprovskiy",
                        "latitude": "54.98131000",
                        "longitude": "33.34573000"
                    },
                    {
                        "id": 102424,
                        "name": "Vyaz’ma",
                        "latitude": "55.21039000",
                        "longitude": "34.29508000"
                    },
                    {
                        "id": 102505,
                        "name": "Yartsevo",
                        "latitude": "55.06667000",
                        "longitude": "32.69639000"
                    },
                    {
                        "id": 102531,
                        "name": "Yekimovichi",
                        "latitude": "54.11285000",
                        "longitude": "33.29648000"
                    },
                    {
                        "id": 102551,
                        "name": "Yel’nya",
                        "latitude": "54.57864000",
                        "longitude": "33.18373000"
                    },
                    {
                        "id": 102571,
                        "name": "Yershichi",
                        "latitude": "53.67250000",
                        "longitude": "32.75417000"
                    }
                ]
            },
            {
                "id": 1868,
                "name": "Stavropol",
                "iso2": "STA",
                "latitude": "44.66809930",
                "longitude": "43.52021400",
                "type": "administrative territory",
                "cities": [
                    {
                        "id": 97494,
                        "name": "Achikulak",
                        "latitude": "44.55167000",
                        "longitude": "44.83778000"
                    },
                    {
                        "id": 97562,
                        "name": "Aleksandriya",
                        "latitude": "45.09472000",
                        "longitude": "43.24556000"
                    },
                    {
                        "id": 97563,
                        "name": "Aleksandriyskaya",
                        "latitude": "44.22722000",
                        "longitude": "43.34528000"
                    },
                    {
                        "id": 97574,
                        "name": "Aleksandrovskoye",
                        "latitude": "44.71417000",
                        "longitude": "43.00083000"
                    },
                    {
                        "id": 97631,
                        "name": "Andzhiyevskiy",
                        "latitude": "44.23889000",
                        "longitude": "43.08556000"
                    },
                    {
                        "id": 97690,
                        "name": "Arzgir",
                        "latitude": "45.37278000",
                        "longitude": "44.22056000"
                    },
                    {
                        "id": 97767,
                        "name": "Balakhonovskoye",
                        "latitude": "44.77670000",
                        "longitude": "41.78420000"
                    },
                    {
                        "id": 97799,
                        "name": "Barsukovskaya",
                        "latitude": "44.76320000",
                        "longitude": "41.81910000"
                    },
                    {
                        "id": 97836,
                        "name": "Bekeshevskaya",
                        "latitude": "44.11389000",
                        "longitude": "42.42694000"
                    },
                    {
                        "id": 97909,
                        "name": "Beshpagir",
                        "latitude": "45.02167000",
                        "longitude": "42.38083000"
                    },
                    {
                        "id": 97923,
                        "name": "Bezopasnoye",
                        "latitude": "45.64833000",
                        "longitude": "41.93603000"
                    },
                    {
                        "id": 97944,
                        "name": "Blagodarnyy",
                        "latitude": "45.09778000",
                        "longitude": "43.43639000"
                    },
                    {
                        "id": 97945,
                        "name": "Blagodatnoye",
                        "latitude": "45.39972000",
                        "longitude": "42.58667000"
                    },
                    {
                        "id": 98022,
                        "name": "Borgustanskaya",
                        "latitude": "44.05470000",
                        "longitude": "42.52880000"
                    },
                    {
                        "id": 98065,
                        "name": "Budënnovsk",
                        "latitude": "44.78389000",
                        "longitude": "44.16583000"
                    },
                    {
                        "id": 98083,
                        "name": "Burlatskoye",
                        "latitude": "45.05639000",
                        "longitude": "43.63500000"
                    },
                    {
                        "id": 98172,
                        "name": "Chernolesskoye",
                        "latitude": "44.71556000",
                        "longitude": "43.71333000"
                    },
                    {
                        "id": 98281,
                        "name": "Divnoye",
                        "latitude": "45.90889000",
                        "longitude": "43.35472000"
                    },
                    {
                        "id": 98284,
                        "name": "Dmitriyevskoye",
                        "latitude": "45.80529000",
                        "longitude": "41.89667000"
                    },
                    {
                        "id": 98313,
                        "name": "Donskoye",
                        "latitude": "45.45518000",
                        "longitude": "41.97411000"
                    },
                    {
                        "id": 98380,
                        "name": "Edissiya",
                        "latitude": "44.05111000",
                        "longitude": "44.54083000"
                    },
                    {
                        "id": 98406,
                        "name": "Etoka",
                        "latitude": "43.91944000",
                        "longitude": "43.04833000"
                    },
                    {
                        "id": 98453,
                        "name": "Galyugayevskaya",
                        "latitude": "43.69694000",
                        "longitude": "44.93444000"
                    },
                    {
                        "id": 98476,
                        "name": "Georgiyevsk",
                        "latitude": "44.15194000",
                        "longitude": "43.46972000"
                    },
                    {
                        "id": 98477,
                        "name": "Georgiyevskaya",
                        "latitude": "44.11139000",
                        "longitude": "43.49222000"
                    },
                    {
                        "id": 98505,
                        "name": "Gofitskoye",
                        "latitude": "45.07917000",
                        "longitude": "43.04639000"
                    },
                    {
                        "id": 98569,
                        "name": "Goryachevodskiy",
                        "latitude": "44.02361000",
                        "longitude": "43.09222000"
                    },
                    {
                        "id": 98581,
                        "name": "Grazhdanskoye",
                        "latitude": "44.23000000",
                        "longitude": "42.76980000"
                    },
                    {
                        "id": 98584,
                        "name": "Grecheskoye",
                        "latitude": "44.43053000",
                        "longitude": "43.00830000"
                    },
                    {
                        "id": 98589,
                        "name": "Grigoropolisskaya",
                        "latitude": "45.29722000",
                        "longitude": "41.05667000"
                    },
                    {
                        "id": 98674,
                        "name": "Inozemtsevo",
                        "latitude": "44.09264000",
                        "longitude": "43.09113000"
                    },
                    {
                        "id": 98685,
                        "name": "Ipatovo",
                        "latitude": "45.71806000",
                        "longitude": "42.90361000"
                    },
                    {
                        "id": 98690,
                        "name": "Irgakly",
                        "latitude": "44.36111000",
                        "longitude": "44.75556000"
                    },
                    {
                        "id": 98734,
                        "name": "Ivanovskoye",
                        "latitude": "44.57950000",
                        "longitude": "41.87640000"
                    },
                    {
                        "id": 98757,
                        "name": "Izobil’nyy",
                        "latitude": "45.37092000",
                        "longitude": "41.70839000"
                    },
                    {
                        "id": 98795,
                        "name": "Kalinovskoye",
                        "latitude": "44.86350000",
                        "longitude": "42.96220000"
                    },
                    {
                        "id": 98843,
                        "name": "Kangly",
                        "latitude": "44.25444000",
                        "longitude": "43.03083000"
                    },
                    {
                        "id": 98850,
                        "name": "Kara-Tyube",
                        "latitude": "44.63361000",
                        "longitude": "45.43694000"
                    },
                    {
                        "id": 98917,
                        "name": "Kayasula",
                        "latitude": "44.32500000",
                        "longitude": "45.00000000"
                    },
                    {
                        "id": 98946,
                        "name": "Kevsala",
                        "latitude": "45.79833000",
                        "longitude": "42.69028000"
                    },
                    {
                        "id": 99081,
                        "name": "Kislovodsk",
                        "latitude": "43.91333000",
                        "longitude": "42.72083000"
                    },
                    {
                        "id": 99125,
                        "name": "Kochubeyevskoye",
                        "latitude": "44.64417000",
                        "longitude": "41.84528000"
                    },
                    {
                        "id": 99169,
                        "name": "Komsomolets",
                        "latitude": "44.01972000",
                        "longitude": "43.56972000"
                    },
                    {
                        "id": 99190,
                        "name": "Konstantinovskaya",
                        "latitude": "44.04556000",
                        "longitude": "43.15833000"
                    },
                    {
                        "id": 99194,
                        "name": "Konstantinovskoye",
                        "latitude": "45.29917000",
                        "longitude": "42.63667000"
                    },
                    {
                        "id": 99316,
                        "name": "Krasnogvardeyskoye",
                        "latitude": "45.84604000",
                        "longitude": "41.51885000"
                    },
                    {
                        "id": 99326,
                        "name": "Krasnokumskoye",
                        "latitude": "44.17806000",
                        "longitude": "43.50194000"
                    },
                    {
                        "id": 99401,
                        "name": "Kruglolesskoye",
                        "latitude": "44.65889000",
                        "longitude": "42.81417000"
                    },
                    {
                        "id": 99473,
                        "name": "Kursavka",
                        "latitude": "44.45640000",
                        "longitude": "42.50930000"
                    },
                    {
                        "id": 99475,
                        "name": "Kurskaya",
                        "latitude": "44.05000000",
                        "longitude": "44.45000000"
                    },
                    {
                        "id": 99532,
                        "name": "Ladovskaya Balka",
                        "latitude": "45.62965000",
                        "longitude": "41.40231000"
                    },
                    {
                        "id": 99584,
                        "name": "Lermontov",
                        "latitude": "44.10667000",
                        "longitude": "42.97333000"
                    },
                    {
                        "id": 99608,
                        "name": "Letnyaya Stavka",
                        "latitude": "45.43056000",
                        "longitude": "43.44722000"
                    },
                    {
                        "id": 99617,
                        "name": "Levokumka",
                        "latitude": "44.23167000",
                        "longitude": "43.15000000"
                    },
                    {
                        "id": 99618,
                        "name": "Levokumskoye",
                        "latitude": "44.82194000",
                        "longitude": "44.66056000"
                    },
                    {
                        "id": 99708,
                        "name": "Lysogorskaya",
                        "latitude": "44.10639000",
                        "longitude": "43.27556000"
                    },
                    {
                        "id": 99899,
                        "name": "Mikhaylovsk",
                        "latitude": "45.12833000",
                        "longitude": "42.02556000"
                    },
                    {
                        "id": 99917,
                        "name": "Mineralnye Vody",
                        "latitude": "44.21028000",
                        "longitude": "43.13528000"
                    },
                    {
                        "id": 99979,
                        "name": "Moskovskoye",
                        "latitude": "45.28420000",
                        "longitude": "41.91030000"
                    },
                    {
                        "id": 100039,
                        "name": "Nadezhda",
                        "latitude": "44.10000000",
                        "longitude": "44.60000000"
                    },
                    {
                        "id": 100050,
                        "name": "Nagutskoye",
                        "latitude": "44.44150000",
                        "longitude": "42.87620000"
                    },
                    {
                        "id": 100087,
                        "name": "Neftekumsk",
                        "latitude": "44.75583000",
                        "longitude": "44.99250000"
                    },
                    {
                        "id": 100120,
                        "name": "Nevinnomyssk",
                        "latitude": "44.63330000",
                        "longitude": "41.94440000"
                    },
                    {
                        "id": 100128,
                        "name": "Nezhinskiy",
                        "latitude": "43.92833000",
                        "longitude": "42.68556000"
                    },
                    {
                        "id": 100129,
                        "name": "Nezlobnaya",
                        "latitude": "44.11806000",
                        "longitude": "43.40278000"
                    },
                    {
                        "id": 100149,
                        "name": "Niny",
                        "latitude": "44.48778000",
                        "longitude": "43.94889000"
                    },
                    {
                        "id": 100222,
                        "name": "Novoaleksandrovsk",
                        "latitude": "45.49480000",
                        "longitude": "41.22075000"
                    },
                    {
                        "id": 100231,
                        "name": "Novoblagodarnoye",
                        "latitude": "44.14333000",
                        "longitude": "42.87500000"
                    },
                    {
                        "id": 100278,
                        "name": "Novopavlovsk",
                        "latitude": "43.96222000",
                        "longitude": "43.63417000"
                    },
                    {
                        "id": 100294,
                        "name": "Novoselitskoye",
                        "latitude": "44.75083000",
                        "longitude": "43.43694000"
                    },
                    {
                        "id": 100313,
                        "name": "Novoterskiy",
                        "latitude": "44.14861000",
                        "longitude": "43.09250000"
                    },
                    {
                        "id": 100317,
                        "name": "Novotroitskaya",
                        "latitude": "45.32667000",
                        "longitude": "41.52528000"
                    },
                    {
                        "id": 100334,
                        "name": "Novozavedennoye",
                        "latitude": "44.26278000",
                        "longitude": "43.63806000"
                    },
                    {
                        "id": 100471,
                        "name": "Orlovka",
                        "latitude": "44.69139000",
                        "longitude": "44.17444000"
                    },
                    {
                        "id": 100502,
                        "name": "Otkaznoye",
                        "latitude": "44.32639000",
                        "longitude": "43.86083000"
                    },
                    {
                        "id": 100512,
                        "name": "Ovoshchi",
                        "latitude": "45.36639000",
                        "longitude": "43.32333000"
                    },
                    {
                        "id": 100590,
                        "name": "Pelagiada",
                        "latitude": "45.20639000",
                        "longitude": "42.02361000"
                    },
                    {
                        "id": 100715,
                        "name": "Podgornaya",
                        "latitude": "44.20306000",
                        "longitude": "43.42972000"
                    },
                    {
                        "id": 100720,
                        "name": "Podkumskiy",
                        "latitude": "44.07556000",
                        "longitude": "43.21028000"
                    },
                    {
                        "id": 100741,
                        "name": "Pokoynoye",
                        "latitude": "44.80972000",
                        "longitude": "44.25167000"
                    },
                    {
                        "id": 100800,
                        "name": "Praskoveya",
                        "latitude": "44.74444000",
                        "longitude": "44.20306000"
                    },
                    {
                        "id": 100806,
                        "name": "Pravokumskoye",
                        "latitude": "44.76944000",
                        "longitude": "44.64722000"
                    },
                    {
                        "id": 100810,
                        "name": "Pregradnoye",
                        "latitude": "45.82183000",
                        "longitude": "41.74692000"
                    },
                    {
                        "id": 100909,
                        "name": "Pyatigorsk",
                        "latitude": "44.04861000",
                        "longitude": "43.05944000"
                    },
                    {
                        "id": 100910,
                        "name": "Pyatigorskiy",
                        "latitude": "43.97417000",
                        "longitude": "43.25833000"
                    },
                    {
                        "id": 100941,
                        "name": "Rasshevatskaya",
                        "latitude": "45.57480000",
                        "longitude": "41.03496000"
                    },
                    {
                        "id": 101056,
                        "name": "Ryzdvyanyy",
                        "latitude": "45.26560000",
                        "longitude": "41.83890000"
                    },
                    {
                        "id": 101203,
                        "name": "Severnoye",
                        "latitude": "44.83194000",
                        "longitude": "42.85833000"
                    },
                    {
                        "id": 101445,
                        "name": "Soldato-Aleksandrovskoye",
                        "latitude": "44.26528000",
                        "longitude": "43.75611000"
                    },
                    {
                        "id": 101463,
                        "name": "Solomenskoye",
                        "latitude": "44.21667000",
                        "longitude": "44.35278000"
                    },
                    {
                        "id": 101470,
                        "name": "Soluno-Dmitriyevskoye",
                        "latitude": "44.40740000",
                        "longitude": "42.72400000"
                    },
                    {
                        "id": 101501,
                        "name": "Sotnikovskoye",
                        "latitude": "45.00389000",
                        "longitude": "43.77722000"
                    },
                    {
                        "id": 101505,
                        "name": "Sovetskaya",
                        "latitude": "44.02667000",
                        "longitude": "44.05000000"
                    },
                    {
                        "id": 101539,
                        "name": "Spitsevka",
                        "latitude": "45.12306000",
                        "longitude": "42.51250000"
                    },
                    {
                        "id": 101579,
                        "name": "Starodubskoye",
                        "latitude": "44.56306000",
                        "longitude": "44.01528000"
                    },
                    {
                        "id": 101589,
                        "name": "Staropavlovskaya",
                        "latitude": "43.84889000",
                        "longitude": "43.63278000"
                    },
                    {
                        "id": 101613,
                        "name": "Stavropol’",
                        "latitude": "45.04280000",
                        "longitude": "41.97340000"
                    },
                    {
                        "id": 101617,
                        "name": "Stepnoye",
                        "latitude": "44.27083000",
                        "longitude": "44.58500000"
                    },
                    {
                        "id": 101648,
                        "name": "Sukhaya Buyvola",
                        "latitude": "45.15333000",
                        "longitude": "42.99556000"
                    },
                    {
                        "id": 101688,
                        "name": "Suvorovskaya",
                        "latitude": "44.19010000",
                        "longitude": "42.65950000"
                    },
                    {
                        "id": 101703,
                        "name": "Svetlograd",
                        "latitude": "45.33528000",
                        "longitude": "42.85472000"
                    },
                    {
                        "id": 101716,
                        "name": "Svobody",
                        "latitude": "44.02556000",
                        "longitude": "43.05028000"
                    },
                    {
                        "id": 101791,
                        "name": "Tatarka",
                        "latitude": "44.95889000",
                        "longitude": "41.95171000"
                    },
                    {
                        "id": 101817,
                        "name": "Temizhbekskaya",
                        "latitude": "45.45078000",
                        "longitude": "41.03866000"
                    },
                    {
                        "id": 101863,
                        "name": "Tishchenskoye",
                        "latitude": "45.46056000",
                        "longitude": "41.67382000"
                    },
                    {
                        "id": 101934,
                        "name": "Trunovskoye",
                        "latitude": "45.48778000",
                        "longitude": "42.13583000"
                    },
                    {
                        "id": 102083,
                        "name": "Urozhaynoye",
                        "latitude": "44.78833000",
                        "longitude": "44.92278000"
                    },
                    {
                        "id": 102315,
                        "name": "Vinsady",
                        "latitude": "44.08083000",
                        "longitude": "42.96528000"
                    },
                    {
                        "id": 102396,
                        "name": "Vostochny",
                        "latitude": "44.31494000",
                        "longitude": "44.19637000"
                    },
                    {
                        "id": 102452,
                        "name": "Vysotskoye",
                        "latitude": "45.02500000",
                        "longitude": "42.90639000"
                    },
                    {
                        "id": 102512,
                        "name": "Yasnaya Polyana",
                        "latitude": "44.02250000",
                        "longitude": "42.75390000"
                    },
                    {
                        "id": 102543,
                        "name": "Yelizavetinskoye",
                        "latitude": "45.00722000",
                        "longitude": "43.34944000"
                    },
                    {
                        "id": 102576,
                        "name": "Yessentuki",
                        "latitude": "44.04444000",
                        "longitude": "42.86056000"
                    },
                    {
                        "id": 102577,
                        "name": "Yessentukskaya",
                        "latitude": "44.03280000",
                        "longitude": "42.88130000"
                    },
                    {
                        "id": 102611,
                        "name": "Yutsa",
                        "latitude": "43.95639000",
                        "longitude": "43.01278000"
                    },
                    {
                        "id": 102666,
                        "name": "Zaterechnyy",
                        "latitude": "44.79306000",
                        "longitude": "45.20972000"
                    },
                    {
                        "id": 102669,
                        "name": "Zavetnoye",
                        "latitude": "44.74920000",
                        "longitude": "41.59950000"
                    },
                    {
                        "id": 102701,
                        "name": "Zelenokumsk",
                        "latitude": "44.40694000",
                        "longitude": "43.88056000"
                    },
                    {
                        "id": 102722,
                        "name": "Zheleznovodsk",
                        "latitude": "44.13944000",
                        "longitude": "43.01972000"
                    },
                    {
                        "id": 102753,
                        "name": "Zmeyka",
                        "latitude": "44.14278000",
                        "longitude": "43.12083000"
                    }
                ]
            },
            {
                "id": 1894,
                "name": "Sverdlovsk",
                "iso2": "SVE",
                "latitude": "56.84309930",
                "longitude": "60.64540860",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97498,
                        "name": "Achit",
                        "latitude": "56.79850000",
                        "longitude": "57.89940000"
                    },
                    {
                        "id": 97558,
                        "name": "Alapayevsk",
                        "latitude": "57.85158000",
                        "longitude": "61.69627000"
                    },
                    {
                        "id": 97652,
                        "name": "Aramil",
                        "latitude": "56.69770000",
                        "longitude": "60.83690000"
                    },
                    {
                        "id": 97687,
                        "name": "Artëmovskiy",
                        "latitude": "57.35550000",
                        "longitude": "61.86865000"
                    },
                    {
                        "id": 97683,
                        "name": "Arti",
                        "latitude": "56.42344000",
                        "longitude": "58.53276000"
                    },
                    {
                        "id": 97693,
                        "name": "Asbest",
                        "latitude": "57.00993000",
                        "longitude": "61.45776000"
                    },
                    {
                        "id": 97694,
                        "name": "Asbestovskiy",
                        "latitude": "57.75574000",
                        "longitude": "61.39672000"
                    },
                    {
                        "id": 97711,
                        "name": "Atig",
                        "latitude": "56.69307000",
                        "longitude": "59.42271000"
                    },
                    {
                        "id": 97732,
                        "name": "Azanka",
                        "latitude": "58.04012000",
                        "longitude": "64.78927000"
                    },
                    {
                        "id": 97788,
                        "name": "Baraba",
                        "latitude": "56.75000000",
                        "longitude": "61.76667000"
                    },
                    {
                        "id": 97791,
                        "name": "Baranchinskiy",
                        "latitude": "58.16170000",
                        "longitude": "59.69910000"
                    },
                    {
                        "id": 97824,
                        "name": "Baykalovo",
                        "latitude": "57.39811000",
                        "longitude": "63.76841000"
                    },
                    {
                        "id": 97870,
                        "name": "Beloyarskiy",
                        "latitude": "56.75840000",
                        "longitude": "61.41430000"
                    },
                    {
                        "id": 97901,
                        "name": "Beryozovsky",
                        "latitude": "56.90830000",
                        "longitude": "60.80190000"
                    },
                    {
                        "id": 97929,
                        "name": "Bilimbay",
                        "latitude": "56.96889000",
                        "longitude": "59.81490000"
                    },
                    {
                        "id": 97940,
                        "name": "Bisert’",
                        "latitude": "56.86174000",
                        "longitude": "59.05231000"
                    },
                    {
                        "id": 97958,
                        "name": "Bobrovskiy",
                        "latitude": "56.67320000",
                        "longitude": "60.98070000"
                    },
                    {
                        "id": 97965,
                        "name": "Bogdanovich",
                        "latitude": "56.78028000",
                        "longitude": "62.04944000"
                    },
                    {
                        "id": 98074,
                        "name": "Bulanash",
                        "latitude": "57.27825000",
                        "longitude": "61.99650000"
                    },
                    {
                        "id": 98086,
                        "name": "Butka",
                        "latitude": "56.71788000",
                        "longitude": "63.78661000"
                    },
                    {
                        "id": 98189,
                        "name": "Cherëmukhovo",
                        "latitude": "60.34842000",
                        "longitude": "59.98507000"
                    },
                    {
                        "id": 98171,
                        "name": "Chernoistochinsk",
                        "latitude": "57.73639000",
                        "longitude": "59.87194000"
                    },
                    {
                        "id": 98258,
                        "name": "Degtyarsk",
                        "latitude": "56.70400000",
                        "longitude": "60.08790000"
                    },
                    {
                        "id": 98331,
                        "name": "Druzhinino",
                        "latitude": "56.78945000",
                        "longitude": "59.51428000"
                    },
                    {
                        "id": 98361,
                        "name": "Dvurechensk",
                        "latitude": "56.59820000",
                        "longitude": "61.09530000"
                    },
                    {
                        "id": 98458,
                        "name": "Gari",
                        "latitude": "59.43075000",
                        "longitude": "62.34967000"
                    },
                    {
                        "id": 98544,
                        "name": "Gornyy Shchit",
                        "latitude": "56.68815000",
                        "longitude": "60.51947000"
                    },
                    {
                        "id": 98598,
                        "name": "Gryaznovskoye",
                        "latitude": "56.78250000",
                        "longitude": "61.70530000"
                    },
                    {
                        "id": 98689,
                        "name": "Irbit",
                        "latitude": "57.67052000",
                        "longitude": "63.07100000"
                    },
                    {
                        "id": 98696,
                        "name": "Is",
                        "latitude": "58.79090000",
                        "longitude": "59.71790000"
                    },
                    {
                        "id": 98701,
                        "name": "Iset’",
                        "latitude": "56.97790000",
                        "longitude": "60.37180000"
                    },
                    {
                        "id": 98719,
                        "name": "Istok",
                        "latitude": "56.79086000",
                        "longitude": "60.77889000"
                    },
                    {
                        "id": 98738,
                        "name": "Ivdel’",
                        "latitude": "60.69111000",
                        "longitude": "60.42056000"
                    },
                    {
                        "id": 98759,
                        "name": "Izumrud",
                        "latitude": "57.07881000",
                        "longitude": "61.39932000"
                    },
                    {
                        "id": 98766,
                        "name": "Kachkanar",
                        "latitude": "58.70020000",
                        "longitude": "59.48390000"
                    },
                    {
                        "id": 98793,
                        "name": "Kalinovo",
                        "latitude": "57.13170000",
                        "longitude": "60.14640000"
                    },
                    {
                        "id": 98820,
                        "name": "Kamensk-Ural’skiy",
                        "latitude": "56.41850000",
                        "longitude": "61.93290000"
                    },
                    {
                        "id": 98830,
                        "name": "Kamyshlov",
                        "latitude": "56.84278000",
                        "longitude": "62.71111000"
                    },
                    {
                        "id": 98883,
                        "name": "Karpinsk",
                        "latitude": "59.77030000",
                        "longitude": "59.99640000"
                    },
                    {
                        "id": 98885,
                        "name": "Karpushikha",
                        "latitude": "57.50167000",
                        "longitude": "59.89556000"
                    },
                    {
                        "id": 98934,
                        "name": "Kedrovoye",
                        "latitude": "57.15760000",
                        "longitude": "60.56980000"
                    },
                    {
                        "id": 99061,
                        "name": "Kirovgrad",
                        "latitude": "57.42972000",
                        "longitude": "60.05972000"
                    },
                    {
                        "id": 99109,
                        "name": "Klyuchevsk",
                        "latitude": "57.12160000",
                        "longitude": "60.94140000"
                    },
                    {
                        "id": 99313,
                        "name": "Krasnogvardeyskiy",
                        "latitude": "57.37928000",
                        "longitude": "62.31952000"
                    },
                    {
                        "id": 99337,
                        "name": "Krasnotur’insk",
                        "latitude": "59.76660000",
                        "longitude": "60.20860000"
                    },
                    {
                        "id": 99338,
                        "name": "Krasnoufimsk",
                        "latitude": "56.60585000",
                        "longitude": "57.76686000"
                    },
                    {
                        "id": 99339,
                        "name": "Krasnoural’sk",
                        "latitude": "58.36380000",
                        "longitude": "60.04070000"
                    },
                    {
                        "id": 99488,
                        "name": "Kushva",
                        "latitude": "58.29056000",
                        "longitude": "59.75917000"
                    },
                    {
                        "id": 99505,
                        "name": "Kuzino",
                        "latitude": "57.02240000",
                        "longitude": "59.44120000"
                    },
                    {
                        "id": 99596,
                        "name": "Lesnoy",
                        "latitude": "57.61980000",
                        "longitude": "63.07840000"
                    },
                    {
                        "id": 99615,
                        "name": "Levikha",
                        "latitude": "57.58361000",
                        "longitude": "59.90028000"
                    },
                    {
                        "id": 99647,
                        "name": "Lobva",
                        "latitude": "59.18538000",
                        "longitude": "60.51846000"
                    },
                    {
                        "id": 99667,
                        "name": "Losinyy",
                        "latitude": "57.13862000",
                        "longitude": "61.06663000"
                    },
                    {
                        "id": 99682,
                        "name": "Lugovskoy",
                        "latitude": "56.95849000",
                        "longitude": "64.52897000"
                    },
                    {
                        "id": 99771,
                        "name": "Malysheva",
                        "latitude": "57.11851000",
                        "longitude": "61.40345000"
                    },
                    {
                        "id": 99807,
                        "name": "Martyush",
                        "latitude": "56.40000000",
                        "longitude": "61.88194000"
                    },
                    {
                        "id": 99900,
                        "name": "Mikhaylovsk",
                        "latitude": "56.43583000",
                        "longitude": "59.12000000"
                    },
                    {
                        "id": 99958,
                        "name": "Monetnyy",
                        "latitude": "57.04720000",
                        "longitude": "60.87940000"
                    },
                    {
                        "id": 100121,
                        "name": "Nev’yansk",
                        "latitude": "57.49530000",
                        "longitude": "60.21120000"
                    },
                    {
                        "id": 100124,
                        "name": "Neyvo-Rudyanka",
                        "latitude": "57.34440000",
                        "longitude": "60.13430000"
                    },
                    {
                        "id": 100125,
                        "name": "Neyvo-Shaytanskiy",
                        "latitude": "57.72860000",
                        "longitude": "61.24956000"
                    },
                    {
                        "id": 100141,
                        "name": "Nikolo-Pavlovskoye",
                        "latitude": "57.78306000",
                        "longitude": "60.05778000"
                    },
                    {
                        "id": 100179,
                        "name": "Nizhniye Sergi",
                        "latitude": "56.66139000",
                        "longitude": "59.30333000"
                    },
                    {
                        "id": 100181,
                        "name": "Nizhny Tagil",
                        "latitude": "57.91944000",
                        "longitude": "59.96500000"
                    },
                    {
                        "id": 100182,
                        "name": "Nizhnyaya Irga",
                        "latitude": "56.86690000",
                        "longitude": "57.42200000"
                    },
                    {
                        "id": 100186,
                        "name": "Nizhnyaya Salda",
                        "latitude": "58.07756000",
                        "longitude": "60.72020000"
                    },
                    {
                        "id": 100188,
                        "name": "Nizhnyaya Tura",
                        "latitude": "58.62930000",
                        "longitude": "59.81180000"
                    },
                    {
                        "id": 100206,
                        "name": "Novaya Lyalya",
                        "latitude": "59.05503000",
                        "longitude": "60.59899000"
                    },
                    {
                        "id": 100225,
                        "name": "Novoasbest",
                        "latitude": "57.74225000",
                        "longitude": "60.28773000"
                    },
                    {
                        "id": 100322,
                        "name": "Novoural’sk",
                        "latitude": "57.24389000",
                        "longitude": "60.08389000"
                    },
                    {
                        "id": 100324,
                        "name": "Novoutkinsk",
                        "latitude": "56.99295000",
                        "longitude": "59.55714000"
                    },
                    {
                        "id": 100393,
                        "name": "Obukhovskoye",
                        "latitude": "56.83450000",
                        "longitude": "62.61200000"
                    },
                    {
                        "id": 100510,
                        "name": "Ous",
                        "latitude": "60.90583000",
                        "longitude": "61.51861000"
                    },
                    {
                        "id": 100592,
                        "name": "Pelym",
                        "latitude": "61.01083000",
                        "longitude": "61.99778000"
                    },
                    {
                        "id": 100629,
                        "name": "Pervoural’sk",
                        "latitude": "56.90528000",
                        "longitude": "59.94361000"
                    },
                    {
                        "id": 100650,
                        "name": "Petrokamenskoye",
                        "latitude": "57.71600000",
                        "longitude": "60.64840000"
                    },
                    {
                        "id": 100749,
                        "name": "Pokrovskoye",
                        "latitude": "56.47040000",
                        "longitude": "61.60920000"
                    },
                    {
                        "id": 100755,
                        "name": "Polevskoy",
                        "latitude": "56.44222000",
                        "longitude": "60.18778000"
                    },
                    {
                        "id": 100760,
                        "name": "Polunochnoye",
                        "latitude": "60.86972000",
                        "longitude": "60.41528000"
                    },
                    {
                        "id": 100916,
                        "name": "Pyshma",
                        "latitude": "56.95226000",
                        "longitude": "63.25129000"
                    },
                    {
                        "id": 100959,
                        "name": "Reftinskiy",
                        "latitude": "57.09013000",
                        "longitude": "61.67692000"
                    },
                    {
                        "id": 100969,
                        "name": "Revda",
                        "latitude": "56.80097000",
                        "longitude": "59.93028000"
                    },
                    {
                        "id": 100971,
                        "name": "Rezh",
                        "latitude": "57.37005000",
                        "longitude": "61.40428000"
                    },
                    {
                        "id": 101024,
                        "name": "Rudnichnyy",
                        "latitude": "59.70118000",
                        "longitude": "60.28817000"
                    },
                    {
                        "id": 101108,
                        "name": "Sarana",
                        "latitude": "56.47728000",
                        "longitude": "57.72586000"
                    },
                    {
                        "id": 101190,
                        "name": "Serov",
                        "latitude": "59.60334000",
                        "longitude": "60.57870000"
                    },
                    {
                        "id": 101202,
                        "name": "Severka",
                        "latitude": "56.86880000",
                        "longitude": "60.30150000"
                    },
                    {
                        "id": 101221,
                        "name": "Severoural’sk",
                        "latitude": "60.15328000",
                        "longitude": "59.95205000"
                    },
                    {
                        "id": 101231,
                        "name": "Shabrovskiy",
                        "latitude": "56.63597000",
                        "longitude": "60.58065000"
                    },
                    {
                        "id": 101249,
                        "name": "Shalya",
                        "latitude": "57.24710000",
                        "longitude": "58.72980000"
                    },
                    {
                        "id": 101251,
                        "name": "Shamary",
                        "latitude": "57.34340000",
                        "longitude": "58.21988000"
                    },
                    {
                        "id": 101276,
                        "name": "Shchelkun",
                        "latitude": "56.30338000",
                        "longitude": "60.94831000"
                    },
                    {
                        "id": 101329,
                        "name": "Shirokaya Rechka",
                        "latitude": "56.79858000",
                        "longitude": "60.48522000"
                    },
                    {
                        "id": 101358,
                        "name": "Shuvakish",
                        "latitude": "56.91870000",
                        "longitude": "60.47727000"
                    },
                    {
                        "id": 101499,
                        "name": "Sos’va",
                        "latitude": "59.17662000",
                        "longitude": "61.85579000"
                    },
                    {
                        "id": 101520,
                        "name": "Sovkhoznyy",
                        "latitude": "56.55990000",
                        "longitude": "61.42600000"
                    },
                    {
                        "id": 101545,
                        "name": "Sredneuralsk",
                        "latitude": "56.98921000",
                        "longitude": "60.46662000"
                    },
                    {
                        "id": 101591,
                        "name": "Staropyshminsk",
                        "latitude": "56.93867000",
                        "longitude": "60.90295000"
                    },
                    {
                        "id": 101598,
                        "name": "Staroutkinsk",
                        "latitude": "57.23017000",
                        "longitude": "59.33483000"
                    },
                    {
                        "id": 101654,
                        "name": "Sukhoy Log",
                        "latitude": "56.90940000",
                        "longitude": "62.02960000"
                    },
                    {
                        "id": 101715,
                        "name": "Svobodnyy",
                        "latitude": "58.03972000",
                        "longitude": "60.39611000"
                    },
                    {
                        "id": 101726,
                        "name": "Sylva",
                        "latitude": "57.30920000",
                        "longitude": "58.77340000"
                    },
                    {
                        "id": 101733,
                        "name": "Sysert’",
                        "latitude": "56.50243000",
                        "longitude": "60.81917000"
                    },
                    {
                        "id": 101732,
                        "name": "Sysertskiy Rayon",
                        "latitude": "56.50000000",
                        "longitude": "60.75000000"
                    },
                    {
                        "id": 101738,
                        "name": "Tabory",
                        "latitude": "58.51982000",
                        "longitude": "64.54947000"
                    },
                    {
                        "id": 101752,
                        "name": "Talitsa",
                        "latitude": "57.01095000",
                        "longitude": "63.73254000"
                    },
                    {
                        "id": 101799,
                        "name": "Tavda",
                        "latitude": "58.04254000",
                        "longitude": "65.27258000"
                    },
                    {
                        "id": 101911,
                        "name": "Tretiy Severnyy",
                        "latitude": "60.20861000",
                        "longitude": "59.96111000"
                    },
                    {
                        "id": 101918,
                        "name": "Troitskiy",
                        "latitude": "57.06028000",
                        "longitude": "63.74811000"
                    },
                    {
                        "id": 101942,
                        "name": "Tsementnyy",
                        "latitude": "57.46930000",
                        "longitude": "60.15360000"
                    },
                    {
                        "id": 101962,
                        "name": "Tugulym",
                        "latitude": "57.05906000",
                        "longitude": "64.64251000"
                    },
                    {
                        "id": 101976,
                        "name": "Turinsk",
                        "latitude": "58.04575000",
                        "longitude": "63.69605000"
                    },
                    {
                        "id": 101977,
                        "name": "Turinskaya Sloboda",
                        "latitude": "57.62320000",
                        "longitude": "64.38575000"
                    },
                    {
                        "id": 102026,
                        "name": "Ufimskiy",
                        "latitude": "56.70840000",
                        "longitude": "58.05170000"
                    },
                    {
                        "id": 102070,
                        "name": "Uralets",
                        "latitude": "57.66140000",
                        "longitude": "59.64970000"
                    },
                    {
                        "id": 102181,
                        "name": "Valerianovsk",
                        "latitude": "58.76080000",
                        "longitude": "59.55960000"
                    },
                    {
                        "id": 102232,
                        "name": "Verkh-Neyvinskiy",
                        "latitude": "57.27013000",
                        "longitude": "60.13762000"
                    },
                    {
                        "id": 102247,
                        "name": "Verkhneye Dubrovo",
                        "latitude": "56.75280000",
                        "longitude": "61.04680000"
                    },
                    {
                        "id": 102257,
                        "name": "Verkhniy Tagil",
                        "latitude": "57.37330000",
                        "longitude": "59.95560000"
                    },
                    {
                        "id": 102263,
                        "name": "Verkhniye Sergi",
                        "latitude": "56.64694000",
                        "longitude": "59.55556000"
                    },
                    {
                        "id": 102269,
                        "name": "Verkhnyaya Pyshma",
                        "latitude": "56.97047000",
                        "longitude": "60.58219000"
                    },
                    {
                        "id": 102270,
                        "name": "Verkhnyaya Salda",
                        "latitude": "58.04874000",
                        "longitude": "60.55949000"
                    },
                    {
                        "id": 102271,
                        "name": "Verkhnyaya Sinyachikha",
                        "latitude": "57.97604000",
                        "longitude": "61.66733000"
                    },
                    {
                        "id": 102272,
                        "name": "Verkhnyaya Sysert’",
                        "latitude": "56.44012000",
                        "longitude": "60.75563000"
                    },
                    {
                        "id": 102275,
                        "name": "Verkhnyaya Tura",
                        "latitude": "58.36083000",
                        "longitude": "59.80667000"
                    },
                    {
                        "id": 102277,
                        "name": "Verkhotur’ye",
                        "latitude": "58.86271000",
                        "longitude": "60.80536000"
                    },
                    {
                        "id": 102319,
                        "name": "Visim",
                        "latitude": "57.64880000",
                        "longitude": "59.50140000"
                    },
                    {
                        "id": 102339,
                        "name": "Volchansk",
                        "latitude": "59.93780000",
                        "longitude": "60.08100000"
                    },
                    {
                        "id": 102399,
                        "name": "Vostochnyy",
                        "latitude": "58.79991000",
                        "longitude": "61.81391000"
                    },
                    {
                        "id": 102527,
                        "name": "Yekaterinburg",
                        "latitude": "56.85190000",
                        "longitude": "60.61220000"
                    },
                    {
                        "id": 102534,
                        "name": "Yelanskiy",
                        "latitude": "56.84190000",
                        "longitude": "62.50140000"
                    },
                    {
                        "id": 102623,
                        "name": "Yëlkino",
                        "latitude": "58.69220000",
                        "longitude": "59.83200000"
                    },
                    {
                        "id": 102574,
                        "name": "Yertarskiy",
                        "latitude": "56.79016000",
                        "longitude": "64.29952000"
                    },
                    {
                        "id": 102607,
                        "name": "Yushala",
                        "latitude": "57.07611000",
                        "longitude": "64.26011000"
                    },
                    {
                        "id": 102654,
                        "name": "Zarechnyy",
                        "latitude": "56.81100000",
                        "longitude": "61.32540000"
                    },
                    {
                        "id": 102676,
                        "name": "Zavodouspenskoye",
                        "latitude": "56.86256000",
                        "longitude": "65.01553000"
                    },
                    {
                        "id": 102685,
                        "name": "Zaykovo",
                        "latitude": "57.56130000",
                        "longitude": "62.75681000"
                    },
                    {
                        "id": 102790,
                        "name": "Zyuzel’skiy",
                        "latitude": "56.48560000",
                        "longitude": "60.13310000"
                    }
                ]
            },
            {
                "id": 1878,
                "name": "Tambov",
                "iso2": "TAM",
                "latitude": "52.64165890",
                "longitude": "41.42164510",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97984,
                        "name": "Bokino",
                        "latitude": "52.63744000",
                        "longitude": "41.45968000"
                    },
                    {
                        "id": 98018,
                        "name": "Bondarskiy Rayon",
                        "latitude": "53.00000000",
                        "longitude": "42.00000000"
                    },
                    {
                        "id": 98314,
                        "name": "Donskoye",
                        "latitude": "52.77495000",
                        "longitude": "41.47759000"
                    },
                    {
                        "id": 98464,
                        "name": "Gavrilovka Vtoraya",
                        "latitude": "52.87697000",
                        "longitude": "42.76633000"
                    },
                    {
                        "id": 98524,
                        "name": "Goreloye",
                        "latitude": "52.93697000",
                        "longitude": "41.50435000"
                    },
                    {
                        "id": 98683,
                        "name": "Inzhavino",
                        "latitude": "52.31847000",
                        "longitude": "42.49369000"
                    },
                    {
                        "id": 99074,
                        "name": "Kirsanov",
                        "latitude": "52.65494000",
                        "longitude": "42.72236000"
                    },
                    {
                        "id": 99075,
                        "name": "Kirsanovskiy Rayon",
                        "latitude": "52.61667000",
                        "longitude": "42.55000000"
                    },
                    {
                        "id": 99170,
                        "name": "Komsomolets",
                        "latitude": "52.76860000",
                        "longitude": "41.28683000"
                    },
                    {
                        "id": 99250,
                        "name": "Kotovsk",
                        "latitude": "52.58666000",
                        "longitude": "41.50210000"
                    },
                    {
                        "id": 99892,
                        "name": "Michurinsk",
                        "latitude": "52.89780000",
                        "longitude": "40.49070000"
                    },
                    {
                        "id": 99961,
                        "name": "Mordovo",
                        "latitude": "52.08340000",
                        "longitude": "40.77000000"
                    },
                    {
                        "id": 99967,
                        "name": "Morshansk",
                        "latitude": "53.44354000",
                        "longitude": "41.81065000"
                    },
                    {
                        "id": 99993,
                        "name": "Muchkapskiy",
                        "latitude": "51.85133000",
                        "longitude": "42.47175000"
                    },
                    {
                        "id": 100205,
                        "name": "Novaya Lyada",
                        "latitude": "52.71309000",
                        "longitude": "41.63872000"
                    },
                    {
                        "id": 100284,
                        "name": "Novopokrovka",
                        "latitude": "52.13310000",
                        "longitude": "40.87830000"
                    },
                    {
                        "id": 100618,
                        "name": "Pervomayskiy",
                        "latitude": "53.24850000",
                        "longitude": "40.28710000"
                    },
                    {
                        "id": 100670,
                        "name": "Pichayevo",
                        "latitude": "53.23627000",
                        "longitude": "42.20323000"
                    },
                    {
                        "id": 100698,
                        "name": "Platonovka",
                        "latitude": "52.71058000",
                        "longitude": "41.95199000"
                    },
                    {
                        "id": 100744,
                        "name": "Pokrovo-Prigorodnoye",
                        "latitude": "52.68405000",
                        "longitude": "41.41752000"
                    },
                    {
                        "id": 100942,
                        "name": "Rasskazovo",
                        "latitude": "52.65599000",
                        "longitude": "41.88461000"
                    },
                    {
                        "id": 100943,
                        "name": "Rasskazovskiy Rayon",
                        "latitude": "52.58333000",
                        "longitude": "41.91667000"
                    },
                    {
                        "id": 101057,
                        "name": "Rzhaksa",
                        "latitude": "52.13384000",
                        "longitude": "42.02640000"
                    },
                    {
                        "id": 101092,
                        "name": "Sampurskiy Rayon",
                        "latitude": "52.25000000",
                        "longitude": "41.66667000"
                    },
                    {
                        "id": 101130,
                        "name": "Satinka",
                        "latitude": "52.37923000",
                        "longitude": "41.68192000"
                    },
                    {
                        "id": 101153,
                        "name": "Selezni",
                        "latitude": "52.80415000",
                        "longitude": "41.23961000"
                    },
                    {
                        "id": 101488,
                        "name": "Sosnovka",
                        "latitude": "53.23593000",
                        "longitude": "41.36859000"
                    },
                    {
                        "id": 101602,
                        "name": "Staroyur’yevo",
                        "latitude": "53.31611000",
                        "longitude": "40.70806000"
                    },
                    {
                        "id": 101761,
                        "name": "Tambov",
                        "latitude": "52.73169000",
                        "longitude": "41.44326000"
                    },
                    {
                        "id": 101873,
                        "name": "Tokarevskiy Rayon",
                        "latitude": "52.00000000",
                        "longitude": "41.25000000"
                    },
                    {
                        "id": 102155,
                        "name": "Uvarovo",
                        "latitude": "51.98486000",
                        "longitude": "42.26147000"
                    },
                    {
                        "id": 102681,
                        "name": "Zavoronezhskoye",
                        "latitude": "52.88010000",
                        "longitude": "40.55260000"
                    },
                    {
                        "id": 102725,
                        "name": "Zherdevka",
                        "latitude": "51.84861000",
                        "longitude": "41.46056000"
                    },
                    {
                        "id": 102756,
                        "name": "Znamenka",
                        "latitude": "52.41670000",
                        "longitude": "41.43108000"
                    },
                    {
                        "id": 102760,
                        "name": "Znamenskiy Rayon",
                        "latitude": "52.33333000",
                        "longitude": "41.33333000"
                    }
                ]
            },
            {
                "id": 1861,
                "name": "Tatarstan",
                "iso2": "TA",
                "latitude": "55.18023640",
                "longitude": "50.72639450",
                "type": "republic",
                "cities": [
                    {
                        "id": 97522,
                        "name": "Agryz",
                        "latitude": "56.52034000",
                        "longitude": "52.99422000"
                    },
                    {
                        "id": 97523,
                        "name": "Agryzskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "52.83333000"
                    },
                    {
                        "id": 97545,
                        "name": "Aksubayevskiy Rayon",
                        "latitude": "54.83333000",
                        "longitude": "50.83333000"
                    },
                    {
                        "id": 97546,
                        "name": "Aktanysh",
                        "latitude": "55.72156000",
                        "longitude": "54.08293000"
                    },
                    {
                        "id": 97547,
                        "name": "Aktanyshskiy Rayon",
                        "latitude": "55.75000000",
                        "longitude": "53.83333000"
                    },
                    {
                        "id": 97549,
                        "name": "Aktyubinskiy",
                        "latitude": "54.81372000",
                        "longitude": "52.80559000"
                    },
                    {
                        "id": 97607,
                        "name": "Al’keyevskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "50.00000000"
                    },
                    {
                        "id": 97608,
                        "name": "Al’met’yevsk",
                        "latitude": "54.90442000",
                        "longitude": "52.31540000"
                    },
                    {
                        "id": 97609,
                        "name": "Al’met’yevskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "52.41667000"
                    },
                    {
                        "id": 97581,
                        "name": "Alekseyevskiy Rayon",
                        "latitude": "55.16667000",
                        "longitude": "50.00000000"
                    },
                    {
                        "id": 97582,
                        "name": "Alekseyevskoye",
                        "latitude": "55.30706000",
                        "longitude": "50.11353000"
                    },
                    {
                        "id": 97647,
                        "name": "Apastovo",
                        "latitude": "55.20293000",
                        "longitude": "48.51091000"
                    },
                    {
                        "id": 97648,
                        "name": "Apastovskiy Rayon",
                        "latitude": "55.25000000",
                        "longitude": "48.50000000"
                    },
                    {
                        "id": 97681,
                        "name": "Arsk",
                        "latitude": "56.09151000",
                        "longitude": "49.87783000"
                    },
                    {
                        "id": 97682,
                        "name": "Arskiy Rayon",
                        "latitude": "56.16667000",
                        "longitude": "49.91667000"
                    },
                    {
                        "id": 97716,
                        "name": "Atninskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "49.41667000"
                    },
                    {
                        "id": 97730,
                        "name": "Aysha",
                        "latitude": "55.87035000",
                        "longitude": "48.63187000"
                    },
                    {
                        "id": 97733,
                        "name": "Aznakayevskiy Rayon",
                        "latitude": "54.91667000",
                        "longitude": "53.00000000"
                    },
                    {
                        "id": 97780,
                        "name": "Baltasi",
                        "latitude": "56.34620000",
                        "longitude": "50.20620000"
                    },
                    {
                        "id": 97781,
                        "name": "Baltasinskiy Rayon",
                        "latitude": "56.33333000",
                        "longitude": "50.25000000"
                    },
                    {
                        "id": 97818,
                        "name": "Bavlinskiy Rayon",
                        "latitude": "54.25000000",
                        "longitude": "53.25000000"
                    },
                    {
                        "id": 97819,
                        "name": "Bavly",
                        "latitude": "54.39304000",
                        "longitude": "53.26023000"
                    },
                    {
                        "id": 97831,
                        "name": "Bazarnyye Mataki",
                        "latitude": "54.88333000",
                        "longitude": "49.93333000"
                    },
                    {
                        "id": 97930,
                        "name": "Bilyarsk",
                        "latitude": "54.98358000",
                        "longitude": "50.38671000"
                    },
                    {
                        "id": 97964,
                        "name": "Bogatyye Saby",
                        "latitude": "56.01020000",
                        "longitude": "50.44830000"
                    },
                    {
                        "id": 97990,
                        "name": "Bolgar",
                        "latitude": "54.95000000",
                        "longitude": "49.06667000"
                    },
                    {
                        "id": 98067,
                        "name": "Bugul’ma",
                        "latitude": "54.53780000",
                        "longitude": "52.79850000"
                    },
                    {
                        "id": 98068,
                        "name": "Bugul’minskiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "52.91667000"
                    },
                    {
                        "id": 98071,
                        "name": "Buinsk",
                        "latitude": "54.97119000",
                        "longitude": "48.29184000"
                    },
                    {
                        "id": 98072,
                        "name": "Buinskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "48.25000000"
                    },
                    {
                        "id": 98150,
                        "name": "Cheremshan",
                        "latitude": "54.66667000",
                        "longitude": "51.50000000"
                    },
                    {
                        "id": 98152,
                        "name": "Cheremshanskiy Rayon",
                        "latitude": "54.75000000",
                        "longitude": "51.50000000"
                    },
                    {
                        "id": 98200,
                        "name": "Chistopol’",
                        "latitude": "55.36311000",
                        "longitude": "50.64244000"
                    },
                    {
                        "id": 98201,
                        "name": "Chistopol’skiy Rayon",
                        "latitude": "55.33333000",
                        "longitude": "50.75000000"
                    },
                    {
                        "id": 98327,
                        "name": "Drozhzhanovskiy Rayon",
                        "latitude": "54.75000000",
                        "longitude": "47.58333000"
                    },
                    {
                        "id": 98372,
                        "name": "Dzhalil’",
                        "latitude": "55.02390000",
                        "longitude": "52.73580000"
                    },
                    {
                        "id": 98548,
                        "name": "Gorod Buinsk",
                        "latitude": "54.96694000",
                        "longitude": "48.28500000"
                    },
                    {
                        "id": 98551,
                        "name": "Gorod Kazan’",
                        "latitude": "55.75000000",
                        "longitude": "49.13333000"
                    },
                    {
                        "id": 98553,
                        "name": "Gorod Nizhnekamsk",
                        "latitude": "55.63333000",
                        "longitude": "51.81667000"
                    },
                    {
                        "id": 98555,
                        "name": "Gorod Yelabuga",
                        "latitude": "55.75000000",
                        "longitude": "52.06667000"
                    },
                    {
                        "id": 98556,
                        "name": "Gorod Zainsk",
                        "latitude": "55.31667000",
                        "longitude": "52.05000000"
                    },
                    {
                        "id": 98557,
                        "name": "Gorod Zelënodol’sk",
                        "latitude": "55.83333000",
                        "longitude": "48.50000000"
                    },
                    {
                        "id": 98827,
                        "name": "Kamsko-Ust’inskiy Rayon",
                        "latitude": "55.16667000",
                        "longitude": "49.00000000"
                    },
                    {
                        "id": 98852,
                        "name": "Karabash",
                        "latitude": "54.69300000",
                        "longitude": "52.58359000"
                    },
                    {
                        "id": 98918,
                        "name": "Kaybitskiy Rayon",
                        "latitude": "55.41667000",
                        "longitude": "48.16667000"
                    },
                    {
                        "id": 98926,
                        "name": "Kazan",
                        "latitude": "55.78874000",
                        "longitude": "49.12214000"
                    },
                    {
                        "id": 99425,
                        "name": "Kukmor",
                        "latitude": "56.18550000",
                        "longitude": "50.89440000"
                    },
                    {
                        "id": 99426,
                        "name": "Kukmorskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "50.66667000"
                    },
                    {
                        "id": 99496,
                        "name": "Kuybyshevskiy Zaton",
                        "latitude": "55.15930000",
                        "longitude": "49.17010000"
                    },
                    {
                        "id": 99535,
                        "name": "Laishevo",
                        "latitude": "55.40464000",
                        "longitude": "49.55037000"
                    },
                    {
                        "id": 99536,
                        "name": "Laishevskiy Rayon",
                        "latitude": "55.50000000",
                        "longitude": "49.58333000"
                    },
                    {
                        "id": 99566,
                        "name": "Leninogorsk",
                        "latitude": "54.60256000",
                        "longitude": "52.46087000"
                    },
                    {
                        "id": 99567,
                        "name": "Leninogorskiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "52.08333000"
                    },
                    {
                        "id": 99677,
                        "name": "Lubyany",
                        "latitude": "56.03780000",
                        "longitude": "51.40001000"
                    },
                    {
                        "id": 99774,
                        "name": "Mamadysh",
                        "latitude": "55.71525000",
                        "longitude": "51.40797000"
                    },
                    {
                        "id": 99775,
                        "name": "Mamadyshskiy Rayon",
                        "latitude": "55.66667000",
                        "longitude": "51.25000000"
                    },
                    {
                        "id": 99863,
                        "name": "Mendeleyevsk",
                        "latitude": "55.90819000",
                        "longitude": "52.29047000"
                    },
                    {
                        "id": 99865,
                        "name": "Mendeleyevskiy Rayon",
                        "latitude": "55.91667000",
                        "longitude": "52.33333000"
                    },
                    {
                        "id": 99866,
                        "name": "Menzelinsk",
                        "latitude": "55.72706000",
                        "longitude": "53.10258000"
                    },
                    {
                        "id": 99867,
                        "name": "Menzelinskiy Rayon",
                        "latitude": "55.75000000",
                        "longitude": "53.00000000"
                    },
                    {
                        "id": 100019,
                        "name": "Muslyumovo",
                        "latitude": "55.30333000",
                        "longitude": "53.19472000"
                    },
                    {
                        "id": 100021,
                        "name": "Muslyumovskiy Rayon",
                        "latitude": "55.25000000",
                        "longitude": "53.25000000"
                    },
                    {
                        "id": 100037,
                        "name": "Naberezhnyye Chelny",
                        "latitude": "55.72545000",
                        "longitude": "52.41122000"
                    },
                    {
                        "id": 100155,
                        "name": "Nizhnekamsk",
                        "latitude": "55.63657000",
                        "longitude": "51.82447000"
                    },
                    {
                        "id": 100156,
                        "name": "Nizhnekamskiy Rayon",
                        "latitude": "55.41667000",
                        "longitude": "51.58333000"
                    },
                    {
                        "id": 100180,
                        "name": "Nizhniye Vyazovyye",
                        "latitude": "55.79877000",
                        "longitude": "48.52476000"
                    },
                    {
                        "id": 100183,
                        "name": "Nizhnyaya Maktama",
                        "latitude": "54.86356000",
                        "longitude": "52.42810000"
                    },
                    {
                        "id": 100300,
                        "name": "Novosheshminsk",
                        "latitude": "55.06513000",
                        "longitude": "51.23376000"
                    },
                    {
                        "id": 100301,
                        "name": "Novosheshminskiy Rayon",
                        "latitude": "55.08333000",
                        "longitude": "51.25000000"
                    },
                    {
                        "id": 100370,
                        "name": "Nurlat",
                        "latitude": "54.42766000",
                        "longitude": "50.80511000"
                    },
                    {
                        "id": 100371,
                        "name": "Nurlatskiy rayon",
                        "latitude": "54.50000000",
                        "longitude": "50.75000000"
                    },
                    {
                        "id": 100488,
                        "name": "Osinovo",
                        "latitude": "55.88090000",
                        "longitude": "48.88100000"
                    },
                    {
                        "id": 100641,
                        "name": "Pestrechinskiy Rayon",
                        "latitude": "55.75000000",
                        "longitude": "49.75000000"
                    },
                    {
                        "id": 100642,
                        "name": "Pestretsy",
                        "latitude": "55.75313000",
                        "longitude": "49.65454000"
                    },
                    {
                        "id": 101032,
                        "name": "Russkiy Aktash",
                        "latitude": "55.03840000",
                        "longitude": "52.12140000"
                    },
                    {
                        "id": 101050,
                        "name": "Rybnaya Sloboda",
                        "latitude": "55.46129000",
                        "longitude": "50.14090000"
                    },
                    {
                        "id": 101051,
                        "name": "Rybno-Slobodskiy Rayon",
                        "latitude": "55.58333000",
                        "longitude": "50.16667000"
                    },
                    {
                        "id": 101061,
                        "name": "Sabinskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "50.50000000"
                    },
                    {
                        "id": 101120,
                        "name": "Sarmanovo",
                        "latitude": "55.25529000",
                        "longitude": "52.58907000"
                    },
                    {
                        "id": 101121,
                        "name": "Sarmanovskiy Rayon",
                        "latitude": "55.25000000",
                        "longitude": "52.58333000"
                    },
                    {
                        "id": 101295,
                        "name": "Shemordan",
                        "latitude": "56.18560000",
                        "longitude": "50.39720000"
                    },
                    {
                        "id": 101344,
                        "name": "Shugurovo",
                        "latitude": "54.50828000",
                        "longitude": "52.13265000"
                    },
                    {
                        "id": 101531,
                        "name": "Spasskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "49.50000000"
                    },
                    {
                        "id": 101600,
                        "name": "Staroye Arakchino",
                        "latitude": "55.80410000",
                        "longitude": "48.97090000"
                    },
                    {
                        "id": 101601,
                        "name": "Staroye Drozhzhanoye",
                        "latitude": "54.72657000",
                        "longitude": "47.56766000"
                    },
                    {
                        "id": 101621,
                        "name": "Stolbishchi",
                        "latitude": "55.64679000",
                        "longitude": "49.21595000"
                    },
                    {
                        "id": 101711,
                        "name": "Sviyazhsk",
                        "latitude": "55.77329000",
                        "longitude": "48.66051000"
                    },
                    {
                        "id": 101842,
                        "name": "Tetyushi",
                        "latitude": "54.93821000",
                        "longitude": "48.83656000"
                    },
                    {
                        "id": 101843,
                        "name": "Tetyushskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "48.75000000"
                    },
                    {
                        "id": 101965,
                        "name": "Tukayevskiy Rayon",
                        "latitude": "55.66667000",
                        "longitude": "52.25000000"
                    },
                    {
                        "id": 102002,
                        "name": "Tyulyachi",
                        "latitude": "55.89125000",
                        "longitude": "50.23992000"
                    },
                    {
                        "id": 102003,
                        "name": "Tyulyachinskiy Rayon",
                        "latitude": "55.91667000",
                        "longitude": "50.25000000"
                    },
                    {
                        "id": 102090,
                        "name": "Urussu",
                        "latitude": "54.59812000",
                        "longitude": "53.46313000"
                    },
                    {
                        "id": 102198,
                        "name": "Vasil’yevo",
                        "latitude": "55.83595000",
                        "longitude": "48.65820000"
                    },
                    {
                        "id": 102243,
                        "name": "Verkhneuslonskiy Rayon",
                        "latitude": "55.66667000",
                        "longitude": "48.75000000"
                    },
                    {
                        "id": 102259,
                        "name": "Verkhniy Uslon",
                        "latitude": "55.77010000",
                        "longitude": "48.98230000"
                    },
                    {
                        "id": 102444,
                        "name": "Vysokaya Gora",
                        "latitude": "55.91278000",
                        "longitude": "49.30167000"
                    },
                    {
                        "id": 102448,
                        "name": "Vysokogorskiy Rayon",
                        "latitude": "55.90000000",
                        "longitude": "49.31667000"
                    },
                    {
                        "id": 102532,
                        "name": "Yelabuga",
                        "latitude": "55.76127000",
                        "longitude": "52.06493000"
                    },
                    {
                        "id": 102533,
                        "name": "Yelabuzhskiy Rayon",
                        "latitude": "55.83333000",
                        "longitude": "51.83333000"
                    },
                    {
                        "id": 102610,
                        "name": "Yutazinskiy Rayon",
                        "latitude": "54.66667000",
                        "longitude": "53.50000000"
                    },
                    {
                        "id": 102631,
                        "name": "Zainsk",
                        "latitude": "55.31950000",
                        "longitude": "52.06942000"
                    },
                    {
                        "id": 102632,
                        "name": "Zainskiy Rayon",
                        "latitude": "55.30000000",
                        "longitude": "52.00000000"
                    },
                    {
                        "id": 102694,
                        "name": "Zelenodol’skiy Rayon",
                        "latitude": "55.91667000",
                        "longitude": "48.75000000"
                    },
                    {
                        "id": 102693,
                        "name": "Zelenodolsk",
                        "latitude": "55.84376000",
                        "longitude": "48.51784000"
                    }
                ]
            },
            {
                "id": 1872,
                "name": "Tomsk",
                "iso2": "TOM",
                "latitude": "58.89698820",
                "longitude": "82.67655000",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97575,
                        "name": "Aleksandrovskoye",
                        "latitude": "56.74083000",
                        "longitude": "85.39056000"
                    },
                    {
                        "id": 97701,
                        "name": "Asino",
                        "latitude": "56.99987000",
                        "longitude": "86.14393000"
                    },
                    {
                        "id": 97759,
                        "name": "Bakchar",
                        "latitude": "57.01861000",
                        "longitude": "82.07111000"
                    },
                    {
                        "id": 97881,
                        "name": "Belyy Yar",
                        "latitude": "58.44472000",
                        "longitude": "85.04250000"
                    },
                    {
                        "id": 97961,
                        "name": "Bogashevo",
                        "latitude": "56.36798000",
                        "longitude": "85.14414000"
                    },
                    {
                        "id": 98801,
                        "name": "Kaltay",
                        "latitude": "56.27917000",
                        "longitude": "84.87861000"
                    },
                    {
                        "id": 98877,
                        "name": "Kargasok",
                        "latitude": "59.05556000",
                        "longitude": "80.85722000"
                    },
                    {
                        "id": 98935,
                        "name": "Kedrovyy",
                        "latitude": "57.51972000",
                        "longitude": "79.51556000"
                    },
                    {
                        "id": 99146,
                        "name": "Kolpashevo",
                        "latitude": "58.31306000",
                        "longitude": "82.90889000"
                    },
                    {
                        "id": 99263,
                        "name": "Kozhevnikovo",
                        "latitude": "56.25889000",
                        "longitude": "83.97139000"
                    },
                    {
                        "id": 99378,
                        "name": "Krasnyy Yar",
                        "latitude": "57.12750000",
                        "longitude": "84.53028000"
                    },
                    {
                        "id": 99393,
                        "name": "Krivosheino",
                        "latitude": "57.34306000",
                        "longitude": "83.92611000"
                    },
                    {
                        "id": 99859,
                        "name": "Mel’nikovo",
                        "latitude": "56.55738000",
                        "longitude": "84.08350000"
                    },
                    {
                        "id": 99947,
                        "name": "Molchanovo",
                        "latitude": "57.58167000",
                        "longitude": "83.76917000"
                    },
                    {
                        "id": 99948,
                        "name": "Molchanovskiy Rayon",
                        "latitude": "57.75000000",
                        "longitude": "84.33333000"
                    },
                    {
                        "id": 99969,
                        "name": "Moryakovskiy Zaton",
                        "latitude": "56.69448000",
                        "longitude": "84.65145000"
                    },
                    {
                        "id": 100540,
                        "name": "Parabel’",
                        "latitude": "58.69778000",
                        "longitude": "81.48250000"
                    },
                    {
                        "id": 100627,
                        "name": "Pervomayskoye",
                        "latitude": "57.07610000",
                        "longitude": "86.23130000"
                    },
                    {
                        "id": 100717,
                        "name": "Podgornoye",
                        "latitude": "57.78861000",
                        "longitude": "82.65194000"
                    },
                    {
                        "id": 101094,
                        "name": "Samus’",
                        "latitude": "56.74482000",
                        "longitude": "84.70422000"
                    },
                    {
                        "id": 101222,
                        "name": "Seversk",
                        "latitude": "56.60056000",
                        "longitude": "84.88639000"
                    },
                    {
                        "id": 101628,
                        "name": "Strezhevoy",
                        "latitude": "60.73330000",
                        "longitude": "77.58890000"
                    },
                    {
                        "id": 101707,
                        "name": "Svetlyy",
                        "latitude": "56.91667000",
                        "longitude": "85.96667000"
                    },
                    {
                        "id": 101810,
                        "name": "Tegul’det",
                        "latitude": "57.30679000",
                        "longitude": "88.16004000"
                    },
                    {
                        "id": 101811,
                        "name": "Tegul’detskiy Rayon",
                        "latitude": "57.50000000",
                        "longitude": "88.16667000"
                    },
                    {
                        "id": 101860,
                        "name": "Timiryazevskoye",
                        "latitude": "56.48988000",
                        "longitude": "84.87795000"
                    },
                    {
                        "id": 101872,
                        "name": "Togur",
                        "latitude": "58.36310000",
                        "longitude": "82.82650000"
                    },
                    {
                        "id": 101887,
                        "name": "Tomsk",
                        "latitude": "56.49771000",
                        "longitude": "84.97437000"
                    },
                    {
                        "id": 101888,
                        "name": "Tomskiy Rayon",
                        "latitude": "56.50000000",
                        "longitude": "84.66667000"
                    },
                    {
                        "id": 102788,
                        "name": "Zyryanskoye",
                        "latitude": "56.83058000",
                        "longitude": "86.62734000"
                    }
                ]
            },
            {
                "id": 1895,
                "name": "Tula",
                "iso2": "TUL",
                "latitude": "54.16376800",
                "longitude": "37.56495070",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97515,
                        "name": "Ageyevo",
                        "latitude": "54.15883000",
                        "longitude": "36.46927000"
                    },
                    {
                        "id": 97583,
                        "name": "Aleksin",
                        "latitude": "54.50503000",
                        "longitude": "37.06740000"
                    },
                    {
                        "id": 97584,
                        "name": "Aleksinskiy Rayon",
                        "latitude": "54.50000000",
                        "longitude": "37.08333000"
                    },
                    {
                        "id": 97679,
                        "name": "Arsen’yevo",
                        "latitude": "53.73893000",
                        "longitude": "36.66429000"
                    },
                    {
                        "id": 97798,
                        "name": "Barsuki",
                        "latitude": "54.26548000",
                        "longitude": "37.48746000"
                    },
                    {
                        "id": 97834,
                        "name": "Begichevskiy",
                        "latitude": "53.79605000",
                        "longitude": "38.25498000"
                    },
                    {
                        "id": 97884,
                        "name": "Belëv",
                        "latitude": "53.81194000",
                        "longitude": "36.13194000"
                    },
                    {
                        "id": 97967,
                        "name": "Bogoroditsk",
                        "latitude": "53.77166000",
                        "longitude": "38.12408000"
                    },
                    {
                        "id": 98017,
                        "name": "Bol’shoye Skuratovo",
                        "latitude": "53.43852000",
                        "longitude": "36.84085000"
                    },
                    {
                        "id": 97996,
                        "name": "Bolokhovo",
                        "latitude": "54.08378000",
                        "longitude": "37.82895000"
                    },
                    {
                        "id": 98031,
                        "name": "Borodinskiy",
                        "latitude": "53.99859000",
                        "longitude": "37.81792000"
                    },
                    {
                        "id": 98059,
                        "name": "Brusyanka",
                        "latitude": "53.98492000",
                        "longitude": "38.03593000"
                    },
                    {
                        "id": 98134,
                        "name": "Chekalin",
                        "latitude": "54.09685000",
                        "longitude": "36.24499000"
                    },
                    {
                        "id": 98155,
                        "name": "Cherepet’",
                        "latitude": "54.11784000",
                        "longitude": "36.37877000"
                    },
                    {
                        "id": 98183,
                        "name": "Chern’",
                        "latitude": "53.45232000",
                        "longitude": "36.91450000"
                    },
                    {
                        "id": 98312,
                        "name": "Donskoy",
                        "latitude": "53.97106000",
                        "longitude": "38.33627000"
                    },
                    {
                        "id": 98338,
                        "name": "Dubna",
                        "latitude": "54.15416000",
                        "longitude": "36.96173000"
                    },
                    {
                        "id": 98339,
                        "name": "Dubovka",
                        "latitude": "53.95223000",
                        "longitude": "38.06276000"
                    },
                    {
                        "id": 98522,
                        "name": "Gorelki",
                        "latitude": "54.25617000",
                        "longitude": "37.61080000"
                    },
                    {
                        "id": 98591,
                        "name": "Gritsovskiy",
                        "latitude": "54.13761000",
                        "longitude": "38.16043000"
                    },
                    {
                        "id": 98808,
                        "name": "Kamenetskiy",
                        "latitude": "54.01353000",
                        "longitude": "38.22115000"
                    },
                    {
                        "id": 98924,
                        "name": "Kazachka",
                        "latitude": "53.36440000",
                        "longitude": "38.06940000"
                    },
                    {
                        "id": 98959,
                        "name": "Khanino",
                        "latitude": "54.21100000",
                        "longitude": "36.62292000"
                    },
                    {
                        "id": 99042,
                        "name": "Kimovsk",
                        "latitude": "53.97164000",
                        "longitude": "38.53186000"
                    },
                    {
                        "id": 99053,
                        "name": "Kireyevsk",
                        "latitude": "53.93361000",
                        "longitude": "37.92792000"
                    },
                    {
                        "id": 99225,
                        "name": "Kosaya Gora",
                        "latitude": "54.11896000",
                        "longitude": "37.54459000"
                    },
                    {
                        "id": 99273,
                        "name": "Krapivna",
                        "latitude": "53.94235000",
                        "longitude": "37.15744000"
                    },
                    {
                        "id": 99465,
                        "name": "Kurkino",
                        "latitude": "53.42567000",
                        "longitude": "38.65824000"
                    },
                    {
                        "id": 99571,
                        "name": "Leninskiy",
                        "latitude": "54.28768000",
                        "longitude": "37.45926000"
                    },
                    {
                        "id": 99656,
                        "name": "Lomintsevskiy",
                        "latitude": "53.98548000",
                        "longitude": "37.66471000"
                    },
                    {
                        "id": 99830,
                        "name": "Mayskiy",
                        "latitude": "53.96216000",
                        "longitude": "38.21165000"
                    },
                    {
                        "id": 99864,
                        "name": "Mendeleyevskiy",
                        "latitude": "54.13745000",
                        "longitude": "37.58742000"
                    },
                    {
                        "id": 100245,
                        "name": "Novogurovskiy",
                        "latitude": "54.46782000",
                        "longitude": "37.33709000"
                    },
                    {
                        "id": 100269,
                        "name": "Novomoskovsk",
                        "latitude": "54.01050000",
                        "longitude": "38.28460000"
                    },
                    {
                        "id": 100400,
                        "name": "Odoyev",
                        "latitude": "53.93933000",
                        "longitude": "36.68639000"
                    },
                    {
                        "id": 100554,
                        "name": "Partizan",
                        "latitude": "53.95017000",
                        "longitude": "38.09801000"
                    },
                    {
                        "id": 100617,
                        "name": "Pervomayskiy",
                        "latitude": "54.04482000",
                        "longitude": "37.50875000"
                    },
                    {
                        "id": 100699,
                        "name": "Plavsk",
                        "latitude": "53.70944000",
                        "longitude": "37.29194000"
                    },
                    {
                        "id": 100722,
                        "name": "Podlesnyy",
                        "latitude": "53.94003000",
                        "longitude": "38.26872000"
                    },
                    {
                        "id": 100843,
                        "name": "Priupskiy",
                        "latitude": "53.90960000",
                        "longitude": "37.73600000"
                    },
                    {
                        "id": 100970,
                        "name": "Revyakino",
                        "latitude": "54.36517000",
                        "longitude": "37.66249000"
                    },
                    {
                        "id": 101016,
                        "name": "Rozhdestvenskiy",
                        "latitude": "54.29570000",
                        "longitude": "37.57019000"
                    },
                    {
                        "id": 101215,
                        "name": "Severo-Zadonsk",
                        "latitude": "54.03481000",
                        "longitude": "38.40172000"
                    },
                    {
                        "id": 101280,
                        "name": "Shchëkino",
                        "latitude": "54.00513000",
                        "longitude": "37.52194000"
                    },
                    {
                        "id": 101364,
                        "name": "Shvartsevskiy",
                        "latitude": "54.09174000",
                        "longitude": "37.99053000"
                    },
                    {
                        "id": 101394,
                        "name": "Skuratovskiy",
                        "latitude": "54.10152000",
                        "longitude": "37.60384000"
                    },
                    {
                        "id": 101401,
                        "name": "Slavniy",
                        "latitude": "53.54654000",
                        "longitude": "36.47387000"
                    },
                    {
                        "id": 101687,
                        "name": "Suvorov",
                        "latitude": "54.12230000",
                        "longitude": "36.49657000"
                    },
                    {
                        "id": 101689,
                        "name": "Suvorovskiy Rayon",
                        "latitude": "54.16667000",
                        "longitude": "36.58333000"
                    },
                    {
                        "id": 102010,
                        "name": "Tëplo-Ogarëvskiy Rayon",
                        "latitude": "53.58333000",
                        "longitude": "37.66667000"
                    },
                    {
                        "id": 102011,
                        "name": "Tëploye",
                        "latitude": "53.62022000",
                        "longitude": "37.59026000"
                    },
                    {
                        "id": 101909,
                        "name": "Tovarkovskiy",
                        "latitude": "53.68217000",
                        "longitude": "38.20920000"
                    },
                    {
                        "id": 101966,
                        "name": "Tula",
                        "latitude": "54.19609000",
                        "longitude": "37.61822000"
                    },
                    {
                        "id": 102166,
                        "name": "Uzlovaya",
                        "latitude": "53.98179000",
                        "longitude": "38.17118000"
                    },
                    {
                        "id": 102226,
                        "name": "Venëv",
                        "latitude": "54.35533000",
                        "longitude": "38.26843000"
                    },
                    {
                        "id": 102223,
                        "name": "Venevskiy Rayon",
                        "latitude": "54.25000000",
                        "longitude": "38.25000000"
                    },
                    {
                        "id": 102366,
                        "name": "Volovo",
                        "latitude": "53.55831000",
                        "longitude": "38.00285000"
                    },
                    {
                        "id": 102513,
                        "name": "Yasnogorsk",
                        "latitude": "54.48082000",
                        "longitude": "37.69854000"
                    },
                    {
                        "id": 102514,
                        "name": "Yasnogorskiy Rayon",
                        "latitude": "54.50000000",
                        "longitude": "37.75000000"
                    },
                    {
                        "id": 102523,
                        "name": "Yefremov",
                        "latitude": "53.14806000",
                        "longitude": "38.09924000"
                    },
                    {
                        "id": 102563,
                        "name": "Yepifan’",
                        "latitude": "53.82526000",
                        "longitude": "38.55181000"
                    },
                    {
                        "id": 102643,
                        "name": "Zaokskiy",
                        "latitude": "54.73227000",
                        "longitude": "37.40539000"
                    },
                    {
                        "id": 102644,
                        "name": "Zaokskiy Rayon",
                        "latitude": "54.66667000",
                        "longitude": "37.50000000"
                    },
                    {
                        "id": 102716,
                        "name": "Zhdankovskiy",
                        "latitude": "53.75321000",
                        "longitude": "38.17951000"
                    }
                ]
            },
            {
                "id": 1900,
                "name": "Tuva",
                "iso2": "TY",
                "latitude": "51.88726690",
                "longitude": "95.62601720",
                "type": "republic",
                "cities": [
                    {
                        "id": 97526,
                        "name": "Ak-Dovurak",
                        "latitude": "51.18333000",
                        "longitude": "90.60000000"
                    },
                    {
                        "id": 97779,
                        "name": "Balgazyn",
                        "latitude": "51.00000000",
                        "longitude": "95.20000000"
                    },
                    {
                        "id": 97821,
                        "name": "Bay-Khaak",
                        "latitude": "51.16105000",
                        "longitude": "94.46371000"
                    },
                    {
                        "id": 98107,
                        "name": "Chadan",
                        "latitude": "51.28333000",
                        "longitude": "91.58333000"
                    },
                    {
                        "id": 98403,
                        "name": "Erzin",
                        "latitude": "50.26000000",
                        "longitude": "95.16230000"
                    },
                    {
                        "id": 98761,
                        "name": "Kaa-Khem",
                        "latitude": "51.68333000",
                        "longitude": "94.73333000"
                    },
                    {
                        "id": 98957,
                        "name": "Khandagayty",
                        "latitude": "50.73333000",
                        "longitude": "92.05000000"
                    },
                    {
                        "id": 99012,
                        "name": "Khovu-Aksy",
                        "latitude": "51.13294000",
                        "longitude": "93.71286000"
                    },
                    {
                        "id": 99447,
                        "name": "Kungurtug",
                        "latitude": "50.59944000",
                        "longitude": "97.52278000"
                    },
                    {
                        "id": 99525,
                        "name": "Kyzyl",
                        "latitude": "51.71081000",
                        "longitude": "94.45338000"
                    },
                    {
                        "id": 99526,
                        "name": "Kyzyl-Khaya",
                        "latitude": "50.04986000",
                        "longitude": "89.87821000"
                    },
                    {
                        "id": 99527,
                        "name": "Kyzyl-Mazhalyk",
                        "latitude": "51.14594000",
                        "longitude": "90.58080000"
                    },
                    {
                        "id": 99995,
                        "name": "Mugur-Aksy",
                        "latitude": "50.38072000",
                        "longitude": "90.43739000"
                    },
                    {
                        "id": 101084,
                        "name": "Samagaltay",
                        "latitude": "50.60220000",
                        "longitude": "95.00470000"
                    },
                    {
                        "id": 101126,
                        "name": "Saryg-Sep",
                        "latitude": "51.49074000",
                        "longitude": "95.56081000"
                    },
                    {
                        "id": 101235,
                        "name": "Shagonar",
                        "latitude": "51.53400000",
                        "longitude": "92.93164000"
                    },
                    {
                        "id": 101657,
                        "name": "Sukpak",
                        "latitude": "51.66667000",
                        "longitude": "94.63333000"
                    },
                    {
                        "id": 101686,
                        "name": "Sut-Khol’",
                        "latitude": "51.40698000",
                        "longitude": "91.29244000"
                    },
                    {
                        "id": 101809,
                        "name": "Teeli",
                        "latitude": "51.01398000",
                        "longitude": "90.20535000"
                    },
                    {
                        "id": 101892,
                        "name": "Toora-Khem",
                        "latitude": "52.46556000",
                        "longitude": "96.11796000"
                    },
                    {
                        "id": 101973,
                        "name": "Turan",
                        "latitude": "52.14490000",
                        "longitude": "93.91887000"
                    }
                ]
            },
            {
                "id": 1860,
                "name": "Tver",
                "iso2": "TVE",
                "latitude": "57.00216540",
                "longitude": "33.98531420",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97626,
                        "name": "Andreapol’",
                        "latitude": "56.65134000",
                        "longitude": "32.26640000"
                    },
                    {
                        "id": 97627,
                        "name": "Andreapol’skiy Rayon",
                        "latitude": "56.66667000",
                        "longitude": "32.25000000"
                    },
                    {
                        "id": 97885,
                        "name": "Bel’skiy Rayon",
                        "latitude": "55.83333000",
                        "longitude": "33.08333000"
                    },
                    {
                        "id": 97878,
                        "name": "Belyy",
                        "latitude": "55.84020000",
                        "longitude": "32.94190000"
                    },
                    {
                        "id": 97879,
                        "name": "Belyy Gorodok",
                        "latitude": "56.96500000",
                        "longitude": "37.51250000"
                    },
                    {
                        "id": 97894,
                        "name": "Berezayka",
                        "latitude": "57.98833000",
                        "longitude": "33.90361000"
                    },
                    {
                        "id": 97899,
                        "name": "Bernovo",
                        "latitude": "56.68633000",
                        "longitude": "34.70357000"
                    },
                    {
                        "id": 97920,
                        "name": "Bezhetsk",
                        "latitude": "57.78506000",
                        "longitude": "36.69651000"
                    },
                    {
                        "id": 97921,
                        "name": "Bezhetskiy Rayon",
                        "latitude": "57.76667000",
                        "longitude": "36.58333000"
                    },
                    {
                        "id": 97993,
                        "name": "Bologovskiy Rayon",
                        "latitude": "57.91667000",
                        "longitude": "34.00000000"
                    },
                    {
                        "id": 97994,
                        "name": "Bologoye",
                        "latitude": "57.88585000",
                        "longitude": "34.04876000"
                    },
                    {
                        "id": 97995,
                        "name": "Bologoye-4",
                        "latitude": "57.90000000",
                        "longitude": "33.65000000"
                    },
                    {
                        "id": 98393,
                        "name": "Emmaus",
                        "latitude": "56.78055000",
                        "longitude": "36.11500000"
                    },
                    {
                        "id": 98429,
                        "name": "Firovo",
                        "latitude": "57.48135000",
                        "longitude": "33.70211000"
                    },
                    {
                        "id": 98430,
                        "name": "Firovskiy Rayon",
                        "latitude": "57.48333000",
                        "longitude": "33.70000000"
                    },
                    {
                        "id": 98561,
                        "name": "Gorodnya",
                        "latitude": "56.70550000",
                        "longitude": "36.31793000"
                    },
                    {
                        "id": 98656,
                        "name": "Il’inskoye",
                        "latitude": "56.96667000",
                        "longitude": "37.18333000"
                    },
                    {
                        "id": 98758,
                        "name": "Izoplit",
                        "latitude": "56.62558000",
                        "longitude": "36.22198000"
                    },
                    {
                        "id": 98781,
                        "name": "Kalashnikovo",
                        "latitude": "57.28237000",
                        "longitude": "35.22617000"
                    },
                    {
                        "id": 98791,
                        "name": "Kalininskiy Rayon",
                        "latitude": "56.75958000",
                        "longitude": "35.98945000"
                    },
                    {
                        "id": 98803,
                        "name": "Kalyazin",
                        "latitude": "57.24028000",
                        "longitude": "37.84333000"
                    },
                    {
                        "id": 98804,
                        "name": "Kalyazinskiy Rayon",
                        "latitude": "57.25000000",
                        "longitude": "37.83333000"
                    },
                    {
                        "id": 98891,
                        "name": "Kashin",
                        "latitude": "57.35917000",
                        "longitude": "37.60806000"
                    },
                    {
                        "id": 98892,
                        "name": "Kashinskiy Rayon",
                        "latitude": "57.41667000",
                        "longitude": "37.58333000"
                    },
                    {
                        "id": 98943,
                        "name": "Kesova Gora",
                        "latitude": "57.58361000",
                        "longitude": "37.29222000"
                    },
                    {
                        "id": 98944,
                        "name": "Kesovogorskiy Rayon",
                        "latitude": "57.58333000",
                        "longitude": "37.33333000"
                    },
                    {
                        "id": 99043,
                        "name": "Kimrskiy Rayon",
                        "latitude": "56.91667000",
                        "longitude": "37.33333000"
                    },
                    {
                        "id": 99044,
                        "name": "Kimry",
                        "latitude": "56.86667000",
                        "longitude": "37.35000000"
                    },
                    {
                        "id": 99177,
                        "name": "Konakovo",
                        "latitude": "56.70000000",
                        "longitude": "36.76667000"
                    },
                    {
                        "id": 99178,
                        "name": "Konakovskiy Rayon",
                        "latitude": "56.66667000",
                        "longitude": "36.83333000"
                    },
                    {
                        "id": 99268,
                        "name": "Kozlovo",
                        "latitude": "56.50977000",
                        "longitude": "36.27326000"
                    },
                    {
                        "id": 99325,
                        "name": "Krasnokholmskiy Rayon",
                        "latitude": "58.08333000",
                        "longitude": "37.16667000"
                    },
                    {
                        "id": 99328,
                        "name": "Krasnomayskiy",
                        "latitude": "57.61941000",
                        "longitude": "34.40987000"
                    },
                    {
                        "id": 99363,
                        "name": "Krasnyy Kholm",
                        "latitude": "58.06070000",
                        "longitude": "37.12032000"
                    },
                    {
                        "id": 99491,
                        "name": "Kuvshinovo",
                        "latitude": "57.02953000",
                        "longitude": "34.17252000"
                    },
                    {
                        "id": 99492,
                        "name": "Kuvshinovskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "34.16667000"
                    },
                    {
                        "id": 99502,
                        "name": "Kuzhenkino",
                        "latitude": "57.76111000",
                        "longitude": "33.95083000"
                    },
                    {
                        "id": 99598,
                        "name": "Lesnoy Rayon",
                        "latitude": "58.25000000",
                        "longitude": "35.50000000"
                    },
                    {
                        "id": 99599,
                        "name": "Lesnoye",
                        "latitude": "58.28406000",
                        "longitude": "35.51584000"
                    },
                    {
                        "id": 99623,
                        "name": "Likhoslavl’",
                        "latitude": "57.12747000",
                        "longitude": "35.46404000"
                    },
                    {
                        "id": 99624,
                        "name": "Likhoslavl’skiy Rayon",
                        "latitude": "57.16667000",
                        "longitude": "35.41667000"
                    },
                    {
                        "id": 99746,
                        "name": "Maksatikha",
                        "latitude": "57.79695000",
                        "longitude": "35.88254000"
                    },
                    {
                        "id": 99747,
                        "name": "Maksatikhinskiy Rayon",
                        "latitude": "57.83333000",
                        "longitude": "35.91667000"
                    },
                    {
                        "id": 99952,
                        "name": "Molokovo",
                        "latitude": "58.16611000",
                        "longitude": "36.76278000"
                    },
                    {
                        "id": 100098,
                        "name": "Nelidovo",
                        "latitude": "56.22107000",
                        "longitude": "32.77738000"
                    },
                    {
                        "id": 100335,
                        "name": "Novozavidovskiy",
                        "latitude": "56.55000000",
                        "longitude": "36.43333000"
                    },
                    {
                        "id": 100421,
                        "name": "Olenino",
                        "latitude": "56.20917000",
                        "longitude": "33.48888000"
                    },
                    {
                        "id": 100477,
                        "name": "Orsha",
                        "latitude": "56.91196000",
                        "longitude": "36.22862000"
                    },
                    {
                        "id": 100491,
                        "name": "Ostashkov",
                        "latitude": "57.14667000",
                        "longitude": "33.10753000"
                    },
                    {
                        "id": 100492,
                        "name": "Ostashkovskiy Rayon",
                        "latitude": "57.16667000",
                        "longitude": "33.25000000"
                    },
                    {
                        "id": 100593,
                        "name": "Peno",
                        "latitude": "56.92624000",
                        "longitude": "32.74262000"
                    },
                    {
                        "id": 100594,
                        "name": "Penovskiy Rayon",
                        "latitude": "56.91667000",
                        "longitude": "32.75000000"
                    },
                    {
                        "id": 100922,
                        "name": "Radchenko",
                        "latitude": "56.68027000",
                        "longitude": "36.37178000"
                    },
                    {
                        "id": 100937,
                        "name": "Rameshki",
                        "latitude": "57.34390000",
                        "longitude": "36.04535000"
                    },
                    {
                        "id": 100938,
                        "name": "Rameshkovskiy Rayon",
                        "latitude": "57.33333000",
                        "longitude": "36.08333000"
                    },
                    {
                        "id": 100958,
                        "name": "Redkino",
                        "latitude": "56.64754000",
                        "longitude": "36.29674000"
                    },
                    {
                        "id": 101060,
                        "name": "Rzhev",
                        "latitude": "56.26241000",
                        "longitude": "34.32817000"
                    },
                    {
                        "id": 101075,
                        "name": "Sakharovo",
                        "latitude": "56.89949000",
                        "longitude": "36.05015000"
                    },
                    {
                        "id": 101098,
                        "name": "Sandovo",
                        "latitude": "58.46022000",
                        "longitude": "36.41277000"
                    },
                    {
                        "id": 101099,
                        "name": "Sandovskiy Rayon",
                        "latitude": "58.41667000",
                        "longitude": "36.41667000"
                    },
                    {
                        "id": 101156,
                        "name": "Selishche",
                        "latitude": "56.88794000",
                        "longitude": "33.26914000"
                    },
                    {
                        "id": 101157,
                        "name": "Selizharovo",
                        "latitude": "56.85188000",
                        "longitude": "33.44869000"
                    },
                    {
                        "id": 101158,
                        "name": "Selizharovskiy Rayon",
                        "latitude": "56.83333000",
                        "longitude": "33.41667000"
                    },
                    {
                        "id": 101476,
                        "name": "Sonkovo",
                        "latitude": "57.77816000",
                        "longitude": "37.15707000"
                    },
                    {
                        "id": 101537,
                        "name": "Spirovo",
                        "latitude": "57.41905000",
                        "longitude": "34.97658000"
                    },
                    {
                        "id": 101538,
                        "name": "Spirovskiy Rayon",
                        "latitude": "57.41667000",
                        "longitude": "35.00000000"
                    },
                    {
                        "id": 101554,
                        "name": "Stantsia Staritsa",
                        "latitude": "56.53224000",
                        "longitude": "34.77287000"
                    },
                    {
                        "id": 101567,
                        "name": "Staraya Toropa",
                        "latitude": "56.28012000",
                        "longitude": "31.67018000"
                    },
                    {
                        "id": 101569,
                        "name": "Staritsa",
                        "latitude": "56.50752000",
                        "longitude": "34.93544000"
                    },
                    {
                        "id": 101570,
                        "name": "Staritskiy Rayon",
                        "latitude": "56.50000000",
                        "longitude": "34.91667000"
                    },
                    {
                        "id": 101899,
                        "name": "Toropets",
                        "latitude": "56.49779000",
                        "longitude": "31.63528000"
                    },
                    {
                        "id": 101900,
                        "name": "Toropetskiy Rayon",
                        "latitude": "56.58333000",
                        "longitude": "31.50000000"
                    },
                    {
                        "id": 101901,
                        "name": "Torzhok",
                        "latitude": "57.04360000",
                        "longitude": "34.96221000"
                    },
                    {
                        "id": 101902,
                        "name": "Torzhokskiy Rayon",
                        "latitude": "57.08333000",
                        "longitude": "35.00000000"
                    },
                    {
                        "id": 101988,
                        "name": "Tver",
                        "latitude": "56.85836000",
                        "longitude": "35.90057000"
                    },
                    {
                        "id": 102024,
                        "name": "Udomlya",
                        "latitude": "57.87944000",
                        "longitude": "34.99250000"
                    },
                    {
                        "id": 102199,
                        "name": "Vasil’yevskiy Mokh",
                        "latitude": "57.01316000",
                        "longitude": "35.91897000"
                    },
                    {
                        "id": 102216,
                        "name": "Velikooktyabr’skiy",
                        "latitude": "57.43333000",
                        "longitude": "33.81595000"
                    },
                    {
                        "id": 102293,
                        "name": "Ves’yegonsk",
                        "latitude": "58.66398000",
                        "longitude": "37.26040000"
                    },
                    {
                        "id": 102294,
                        "name": "Ves’yegonskiy Rayon",
                        "latitude": "58.66667000",
                        "longitude": "37.16667000"
                    },
                    {
                        "id": 102429,
                        "name": "Vydropuzhsk",
                        "latitude": "57.36470000",
                        "longitude": "34.84287000"
                    },
                    {
                        "id": 102434,
                        "name": "Vypolzovo",
                        "latitude": "57.87667000",
                        "longitude": "33.69861000"
                    },
                    {
                        "id": 102441,
                        "name": "Vyshnevolotskiy Rayon",
                        "latitude": "57.58333000",
                        "longitude": "34.58333000"
                    },
                    {
                        "id": 102443,
                        "name": "Vyshniy Volochëk",
                        "latitude": "57.59125000",
                        "longitude": "34.56453000"
                    },
                    {
                        "id": 102646,
                        "name": "Zapadnaya Dvina",
                        "latitude": "56.25901000",
                        "longitude": "32.07454000"
                    },
                    {
                        "id": 102672,
                        "name": "Zavidovo",
                        "latitude": "56.53333000",
                        "longitude": "36.53333000"
                    },
                    {
                        "id": 102713,
                        "name": "Zharkovskiy",
                        "latitude": "55.84900000",
                        "longitude": "32.26970000"
                    },
                    {
                        "id": 102773,
                        "name": "Zubtsov",
                        "latitude": "56.17533000",
                        "longitude": "34.58935000"
                    },
                    {
                        "id": 102774,
                        "name": "Zubtsovskiy Rayon",
                        "latitude": "56.16667000",
                        "longitude": "34.58333000"
                    }
                ]
            },
            {
                "id": 1907,
                "name": "Tyumen",
                "iso2": "TYU",
                "latitude": "56.96343870",
                "longitude": "66.94827800",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97480,
                        "name": "Abalak",
                        "latitude": "58.12861000",
                        "longitude": "68.59444000"
                    },
                    {
                        "id": 97483,
                        "name": "Abatskoye",
                        "latitude": "56.28748000",
                        "longitude": "70.45553000"
                    },
                    {
                        "id": 97640,
                        "name": "Antipino",
                        "latitude": "57.10679000",
                        "longitude": "65.75755000"
                    },
                    {
                        "id": 97674,
                        "name": "Armizonskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "67.58333000"
                    },
                    {
                        "id": 97675,
                        "name": "Armizonskoye",
                        "latitude": "55.94611000",
                        "longitude": "67.67361000"
                    },
                    {
                        "id": 97676,
                        "name": "Aromashevo",
                        "latitude": "56.86018000",
                        "longitude": "68.63754000"
                    },
                    {
                        "id": 97890,
                        "name": "Berdyuzhskiy Rayon",
                        "latitude": "55.83333000",
                        "longitude": "68.58333000"
                    },
                    {
                        "id": 97960,
                        "name": "Bogandinskiy",
                        "latitude": "56.89375000",
                        "longitude": "65.89378000"
                    },
                    {
                        "id": 98041,
                        "name": "Borovskiy",
                        "latitude": "57.04096000",
                        "longitude": "65.72018000"
                    },
                    {
                        "id": 98188,
                        "name": "Chervishevo",
                        "latitude": "56.94635000",
                        "longitude": "65.42782000"
                    },
                    {
                        "id": 98512,
                        "name": "Golyshmanovo",
                        "latitude": "56.39790000",
                        "longitude": "68.37279000"
                    },
                    {
                        "id": 98513,
                        "name": "Golyshmanovskiy Rayon",
                        "latitude": "56.41667000",
                        "longitude": "68.41667000"
                    },
                    {
                        "id": 98695,
                        "name": "Irtyshskiy",
                        "latitude": "58.33333000",
                        "longitude": "68.13333000"
                    },
                    {
                        "id": 98699,
                        "name": "Isetskiy Rayon",
                        "latitude": "56.50000000",
                        "longitude": "65.41667000"
                    },
                    {
                        "id": 98700,
                        "name": "Isetskoye",
                        "latitude": "56.48580000",
                        "longitude": "65.32260000"
                    },
                    {
                        "id": 98704,
                        "name": "Ishim",
                        "latitude": "56.11281000",
                        "longitude": "69.49015000"
                    },
                    {
                        "id": 98706,
                        "name": "Ishimskiy Rayon",
                        "latitude": "56.16667000",
                        "longitude": "69.41667000"
                    },
                    {
                        "id": 98929,
                        "name": "Kazanskiy Rayon",
                        "latitude": "55.58333000",
                        "longitude": "69.41667000"
                    },
                    {
                        "id": 98930,
                        "name": "Kazanskoye",
                        "latitude": "55.64477000",
                        "longitude": "69.23500000"
                    },
                    {
                        "id": 99858,
                        "name": "Melioratorov",
                        "latitude": "57.21065000",
                        "longitude": "65.60774000"
                    },
                    {
                        "id": 99862,
                        "name": "Mendeleyevo",
                        "latitude": "58.16667000",
                        "longitude": "68.30000000"
                    },
                    {
                        "id": 99978,
                        "name": "Moskovskiy",
                        "latitude": "57.11108000",
                        "longitude": "65.42298000"
                    },
                    {
                        "id": 100187,
                        "name": "Nizhnyaya Tavda",
                        "latitude": "57.67306000",
                        "longitude": "66.17250000"
                    },
                    {
                        "id": 100212,
                        "name": "Novaya Zaimka",
                        "latitude": "56.48571000",
                        "longitude": "66.92413000"
                    },
                    {
                        "id": 100293,
                        "name": "Novoseleznëvo",
                        "latitude": "55.68207000",
                        "longitude": "69.20562000"
                    },
                    {
                        "id": 100443,
                        "name": "Omutinskiy",
                        "latitude": "56.47453000",
                        "longitude": "67.67087000"
                    },
                    {
                        "id": 100444,
                        "name": "Omutinskiy Rayon",
                        "latitude": "56.41667000",
                        "longitude": "67.58333000"
                    },
                    {
                        "id": 100450,
                        "name": "Onokhino",
                        "latitude": "56.92501000",
                        "longitude": "65.53940000"
                    },
                    {
                        "id": 101395,
                        "name": "Sladkovo",
                        "latitude": "55.52835000",
                        "longitude": "70.33854000"
                    },
                    {
                        "id": 101396,
                        "name": "Sladkovskiy Rayon",
                        "latitude": "55.66667000",
                        "longitude": "70.16667000"
                    },
                    {
                        "id": 101661,
                        "name": "Sumkino",
                        "latitude": "58.11083000",
                        "longitude": "68.32444000"
                    },
                    {
                        "id": 101868,
                        "name": "Tobol’sk",
                        "latitude": "58.19807000",
                        "longitude": "68.25457000"
                    },
                    {
                        "id": 101981,
                        "name": "Turtas",
                        "latitude": "58.93867000",
                        "longitude": "69.13393000"
                    },
                    {
                        "id": 102005,
                        "name": "Tyumen",
                        "latitude": "57.15222000",
                        "longitude": "65.52722000"
                    },
                    {
                        "id": 102066,
                        "name": "Uporovo",
                        "latitude": "56.31093000",
                        "longitude": "66.26926000"
                    },
                    {
                        "id": 102067,
                        "name": "Uporovskiy Rayon",
                        "latitude": "56.16667000",
                        "longitude": "66.33333000"
                    },
                    {
                        "id": 102102,
                        "name": "Uspenka",
                        "latitude": "56.80158000",
                        "longitude": "69.22702000"
                    },
                    {
                        "id": 102157,
                        "name": "Uvat",
                        "latitude": "59.14227000",
                        "longitude": "68.88881000"
                    },
                    {
                        "id": 102172,
                        "name": "Vagay",
                        "latitude": "57.93566000",
                        "longitude": "69.01953000"
                    },
                    {
                        "id": 102173,
                        "name": "Vagayskiy Rayon",
                        "latitude": "57.58333000",
                        "longitude": "69.16667000"
                    },
                    {
                        "id": 102304,
                        "name": "Vikulovo",
                        "latitude": "56.81667000",
                        "longitude": "70.61069000"
                    },
                    {
                        "id": 102316,
                        "name": "Vinzili",
                        "latitude": "56.95938000",
                        "longitude": "65.77080000"
                    },
                    {
                        "id": 102475,
                        "name": "Yalutorovsk",
                        "latitude": "56.65358000",
                        "longitude": "66.30057000"
                    },
                    {
                        "id": 102495,
                        "name": "Yarkovo",
                        "latitude": "57.40386000",
                        "longitude": "67.06390000"
                    },
                    {
                        "id": 102596,
                        "name": "Yurginskoye",
                        "latitude": "56.81888000",
                        "longitude": "67.39211000"
                    },
                    {
                        "id": 102675,
                        "name": "Zavodoukovsk",
                        "latitude": "56.50420000",
                        "longitude": "66.55153000"
                    }
                ]
            },
            {
                "id": 1913,
                "name": "Udmurt",
                "iso2": "UD",
                "latitude": "57.06702180",
                "longitude": "53.02779480",
                "type": "republic",
                "cities": [
                    {
                        "id": 97600,
                        "name": "Alnashi",
                        "latitude": "56.18738000",
                        "longitude": "52.47919000"
                    },
                    {
                        "id": 97778,
                        "name": "Balezino",
                        "latitude": "57.97870000",
                        "longitude": "53.01380000"
                    },
                    {
                        "id": 98254,
                        "name": "Debesy",
                        "latitude": "57.65150000",
                        "longitude": "53.80890000"
                    },
                    {
                        "id": 98411,
                        "name": "Fakel",
                        "latitude": "57.63100000",
                        "longitude": "53.02510000"
                    },
                    {
                        "id": 98495,
                        "name": "Glazov",
                        "latitude": "58.13930000",
                        "longitude": "52.65800000"
                    },
                    {
                        "id": 98575,
                        "name": "Grakhovo",
                        "latitude": "56.05017000",
                        "longitude": "51.96758000"
                    },
                    {
                        "id": 98634,
                        "name": "Igra",
                        "latitude": "57.55490000",
                        "longitude": "53.05440000"
                    },
                    {
                        "id": 98746,
                        "name": "Izhevsk",
                        "latitude": "56.84976000",
                        "longitude": "53.20448000"
                    },
                    {
                        "id": 98805,
                        "name": "Kama",
                        "latitude": "56.30512000",
                        "longitude": "54.09361000"
                    },
                    {
                        "id": 98806,
                        "name": "Kambarka",
                        "latitude": "56.26660000",
                        "longitude": "54.20560000"
                    },
                    {
                        "id": 98865,
                        "name": "Karakulino",
                        "latitude": "56.01200000",
                        "longitude": "53.70669000"
                    },
                    {
                        "id": 98866,
                        "name": "Karakulinskiy Rayon",
                        "latitude": "56.08333000",
                        "longitude": "53.66667000"
                    },
                    {
                        "id": 98947,
                        "name": "Kez",
                        "latitude": "57.89570000",
                        "longitude": "53.71320000"
                    },
                    {
                        "id": 98990,
                        "name": "Khokhryaki",
                        "latitude": "56.91561000",
                        "longitude": "53.32210000"
                    },
                    {
                        "id": 99084,
                        "name": "Kiyasovo",
                        "latitude": "56.34907000",
                        "longitude": "53.12439000"
                    },
                    {
                        "id": 99085,
                        "name": "Kiyasovskiy Rayon",
                        "latitude": "56.33333000",
                        "longitude": "53.16667000"
                    },
                    {
                        "id": 99096,
                        "name": "Kizner",
                        "latitude": "56.27489000",
                        "longitude": "51.50800000"
                    },
                    {
                        "id": 99310,
                        "name": "Krasnogorskoye",
                        "latitude": "57.70470000",
                        "longitude": "52.49990000"
                    },
                    {
                        "id": 99751,
                        "name": "Malaya Purga",
                        "latitude": "56.55666000",
                        "longitude": "53.00434000"
                    },
                    {
                        "id": 99764,
                        "name": "Malopurginskiy Rayon",
                        "latitude": "56.55766000",
                        "longitude": "53.03476000"
                    },
                    {
                        "id": 99987,
                        "name": "Mozhga",
                        "latitude": "56.44469000",
                        "longitude": "52.22763000"
                    },
                    {
                        "id": 100682,
                        "name": "Pirogovo",
                        "latitude": "56.77959000",
                        "longitude": "53.14954000"
                    },
                    {
                        "id": 100887,
                        "name": "Pudem",
                        "latitude": "58.30470000",
                        "longitude": "52.16730000"
                    },
                    {
                        "id": 100913,
                        "name": "Pychas",
                        "latitude": "56.50332000",
                        "longitude": "52.44088000"
                    },
                    {
                        "id": 101112,
                        "name": "Sarapul",
                        "latitude": "56.47633000",
                        "longitude": "53.79782000"
                    },
                    {
                        "id": 101113,
                        "name": "Sarapul’skiy Rayon",
                        "latitude": "56.50000000",
                        "longitude": "53.75000000"
                    },
                    {
                        "id": 101159,
                        "name": "Selty",
                        "latitude": "57.31320000",
                        "longitude": "52.13450000"
                    },
                    {
                        "id": 101261,
                        "name": "Sharkan",
                        "latitude": "57.29885000",
                        "longitude": "53.87122000"
                    },
                    {
                        "id": 101368,
                        "name": "Sigayevo",
                        "latitude": "56.42163000",
                        "longitude": "53.77566000"
                    },
                    {
                        "id": 101734,
                        "name": "Syumsi",
                        "latitude": "57.11108000",
                        "longitude": "51.61494000"
                    },
                    {
                        "id": 102153,
                        "name": "Uva",
                        "latitude": "56.99081000",
                        "longitude": "52.18517000"
                    },
                    {
                        "id": 102206,
                        "name": "Vavozh",
                        "latitude": "56.77513000",
                        "longitude": "51.93098000"
                    },
                    {
                        "id": 102403,
                        "name": "Votkinsk",
                        "latitude": "57.04865000",
                        "longitude": "53.98717000"
                    },
                    {
                        "id": 102489,
                        "name": "Yar",
                        "latitude": "58.24580000",
                        "longitude": "52.10540000"
                    },
                    {
                        "id": 102589,
                        "name": "Yukamenskoye",
                        "latitude": "57.88780000",
                        "longitude": "52.24500000"
                    },
                    {
                        "id": 102683,
                        "name": "Zav’yalovskiy Rayon",
                        "latitude": "56.83333000",
                        "longitude": "53.08333000"
                    }
                ]
            },
            {
                "id": 1856,
                "name": "Ulyanovsk",
                "iso2": "ULY",
                "latitude": "53.97933570",
                "longitude": "47.77624250",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97804,
                        "name": "Barysh",
                        "latitude": "53.65533000",
                        "longitude": "47.11229000"
                    },
                    {
                        "id": 97830,
                        "name": "Bazarnyy Syzgan",
                        "latitude": "53.75117000",
                        "longitude": "46.75354000"
                    },
                    {
                        "id": 98143,
                        "name": "Cherdaklinskiy Rayon",
                        "latitude": "54.25000000",
                        "longitude": "48.83333000"
                    },
                    {
                        "id": 98144,
                        "name": "Cherdakly",
                        "latitude": "54.35940000",
                        "longitude": "48.84497000"
                    },
                    {
                        "id": 98216,
                        "name": "Chufarovo",
                        "latitude": "54.09630000",
                        "longitude": "47.33670000"
                    },
                    {
                        "id": 98276,
                        "name": "Dimitrovgrad",
                        "latitude": "54.21386000",
                        "longitude": "49.61838000"
                    },
                    {
                        "id": 98500,
                        "name": "Glotovka",
                        "latitude": "53.94906000",
                        "longitude": "46.70422000"
                    },
                    {
                        "id": 98633,
                        "name": "Ignatovka",
                        "latitude": "53.94787000",
                        "longitude": "47.65360000"
                    },
                    {
                        "id": 98669,
                        "name": "Imeni Vladimira Il’icha Lenina",
                        "latitude": "53.56422000",
                        "longitude": "46.98010000"
                    },
                    {
                        "id": 98681,
                        "name": "Inza",
                        "latitude": "53.85672000",
                        "longitude": "46.35622000"
                    },
                    {
                        "id": 98703,
                        "name": "Isheyevka",
                        "latitude": "54.42789000",
                        "longitude": "48.26675000"
                    },
                    {
                        "id": 98753,
                        "name": "Izmaylovo",
                        "latitude": "53.72114000",
                        "longitude": "47.24581000"
                    },
                    {
                        "id": 98832,
                        "name": "Kanadey",
                        "latitude": "53.16786000",
                        "longitude": "47.52644000"
                    },
                    {
                        "id": 98886,
                        "name": "Karsun",
                        "latitude": "54.19941000",
                        "longitude": "46.98270000"
                    },
                    {
                        "id": 99362,
                        "name": "Krasnyy Gulyay",
                        "latitude": "54.02821000",
                        "longitude": "48.33327000"
                    },
                    {
                        "id": 99510,
                        "name": "Kuzovatovo",
                        "latitude": "53.54681000",
                        "longitude": "47.68659000"
                    },
                    {
                        "id": 99826,
                        "name": "Mayna",
                        "latitude": "54.11350000",
                        "longitude": "47.62310000"
                    },
                    {
                        "id": 99828,
                        "name": "Maynskiy Rayon",
                        "latitude": "54.16667000",
                        "longitude": "47.66667000"
                    },
                    {
                        "id": 99922,
                        "name": "Mirnyy",
                        "latitude": "54.36607000",
                        "longitude": "48.72939000"
                    },
                    {
                        "id": 100001,
                        "name": "Mullovka",
                        "latitude": "54.20000000",
                        "longitude": "49.40000000"
                    },
                    {
                        "id": 100134,
                        "name": "Nikolayevka",
                        "latitude": "53.12570000",
                        "longitude": "47.20410000"
                    },
                    {
                        "id": 100208,
                        "name": "Novaya Malykla",
                        "latitude": "54.20000000",
                        "longitude": "49.95000000"
                    },
                    {
                        "id": 100209,
                        "name": "Novaya Mayna",
                        "latitude": "54.15000000",
                        "longitude": "49.75000000"
                    },
                    {
                        "id": 100234,
                        "name": "Novocheremshansk",
                        "latitude": "54.35714000",
                        "longitude": "50.16662000"
                    },
                    {
                        "id": 100311,
                        "name": "Novospasskoye",
                        "latitude": "53.14683000",
                        "longitude": "47.75138000"
                    },
                    {
                        "id": 100321,
                        "name": "Novoul’yanovsk",
                        "latitude": "54.14961000",
                        "longitude": "48.38907000"
                    },
                    {
                        "id": 100568,
                        "name": "Pavlovka",
                        "latitude": "52.68966000",
                        "longitude": "47.14046000"
                    },
                    {
                        "id": 100581,
                        "name": "Pavlovskiy Rayon",
                        "latitude": "52.66667000",
                        "longitude": "47.08333000"
                    },
                    {
                        "id": 100923,
                        "name": "Radishchevo",
                        "latitude": "52.85459000",
                        "longitude": "47.87644000"
                    },
                    {
                        "id": 101171,
                        "name": "Sengiley",
                        "latitude": "53.96222000",
                        "longitude": "48.79444000"
                    },
                    {
                        "id": 101369,
                        "name": "Silikatnyy",
                        "latitude": "53.98957000",
                        "longitude": "48.32749000"
                    },
                    {
                        "id": 101559,
                        "name": "Staraya Kulatka",
                        "latitude": "52.72778000",
                        "longitude": "47.61788000"
                    },
                    {
                        "id": 101562,
                        "name": "Staraya Mayna",
                        "latitude": "54.60417000",
                        "longitude": "48.93056000"
                    },
                    {
                        "id": 101584,
                        "name": "Starokulatkinskiy Rayon",
                        "latitude": "52.75000000",
                        "longitude": "47.50000000"
                    },
                    {
                        "id": 101596,
                        "name": "Starotimoshkino",
                        "latitude": "53.71908000",
                        "longitude": "47.53116000"
                    },
                    {
                        "id": 101681,
                        "name": "Surskoye",
                        "latitude": "54.48210000",
                        "longitude": "46.72140000"
                    },
                    {
                        "id": 101829,
                        "name": "Teren’gul’skiy Rayon",
                        "latitude": "53.75000000",
                        "longitude": "48.25000000"
                    },
                    {
                        "id": 101947,
                        "name": "Tsil’na",
                        "latitude": "54.59533000",
                        "longitude": "48.14140000"
                    },
                    {
                        "id": 101948,
                        "name": "Tsil’ninskiy Rayon",
                        "latitude": "54.58333000",
                        "longitude": "48.00000000"
                    },
                    {
                        "id": 102051,
                        "name": "Ulyanovsk",
                        "latitude": "54.32824000",
                        "longitude": "48.38657000"
                    },
                    {
                        "id": 102052,
                        "name": "Ulyanovskiy Rayon",
                        "latitude": "54.33528000",
                        "longitude": "48.01694000"
                    },
                    {
                        "id": 102057,
                        "name": "Undory",
                        "latitude": "54.60849000",
                        "longitude": "48.39276000"
                    },
                    {
                        "id": 102290,
                        "name": "Veshkayma",
                        "latitude": "54.04720000",
                        "longitude": "47.13000000"
                    },
                    {
                        "id": 102519,
                        "name": "Yazykovo",
                        "latitude": "54.29220000",
                        "longitude": "47.38910000"
                    },
                    {
                        "id": 102710,
                        "name": "Zhadovka",
                        "latitude": "53.57464000",
                        "longitude": "46.94985000"
                    }
                ]
            },
            {
                "id": 1881,
                "name": "Vladimir",
                "iso2": "VLA",
                "latitude": "56.15534650",
                "longitude": "40.59266850",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97565,
                        "name": "Aleksandrov",
                        "latitude": "56.39516000",
                        "longitude": "38.71216000"
                    },
                    {
                        "id": 97572,
                        "name": "Aleksandrovskiy Rayon",
                        "latitude": "56.41667000",
                        "longitude": "38.58333000"
                    },
                    {
                        "id": 97629,
                        "name": "Andreyevo",
                        "latitude": "55.94650000",
                        "longitude": "41.15050000"
                    },
                    {
                        "id": 97638,
                        "name": "Anopino",
                        "latitude": "55.69809000",
                        "longitude": "40.66707000"
                    },
                    {
                        "id": 97677,
                        "name": "Arsaki",
                        "latitude": "56.38333000",
                        "longitude": "38.48333000"
                    },
                    {
                        "id": 97770,
                        "name": "Balakirevo",
                        "latitude": "56.50588000",
                        "longitude": "38.84324000"
                    },
                    {
                        "id": 97817,
                        "name": "Bavleny",
                        "latitude": "56.39448000",
                        "longitude": "39.56504000"
                    },
                    {
                        "id": 97845,
                        "name": "Belaya Rechka",
                        "latitude": "56.28491000",
                        "longitude": "39.40665000"
                    },
                    {
                        "id": 97966,
                        "name": "Bogolyubovo",
                        "latitude": "56.19052000",
                        "longitude": "40.52313000"
                    },
                    {
                        "id": 98297,
                        "name": "Dobryatino",
                        "latitude": "55.50550000",
                        "longitude": "41.31950000"
                    },
                    {
                        "id": 98452,
                        "name": "Galitsy",
                        "latitude": "56.17759000",
                        "longitude": "42.84588000"
                    },
                    {
                        "id": 98508,
                        "name": "Golovino",
                        "latitude": "55.96128000",
                        "longitude": "40.42511000"
                    },
                    {
                        "id": 98564,
                        "name": "Gorokhovets",
                        "latitude": "56.20152000",
                        "longitude": "42.69351000"
                    },
                    {
                        "id": 98622,
                        "name": "Gus’-Khrustal’nyy",
                        "latitude": "55.61113000",
                        "longitude": "40.65186000"
                    },
                    {
                        "id": 98619,
                        "name": "Gusevskiy",
                        "latitude": "55.66199000",
                        "longitude": "40.56267000"
                    },
                    {
                        "id": 98670,
                        "name": "Imeni Vorovskogo",
                        "latitude": "55.72370000",
                        "longitude": "41.11900000"
                    },
                    {
                        "id": 98728,
                        "name": "Ivanishchi",
                        "latitude": "55.77417000",
                        "longitude": "40.42731000"
                    },
                    {
                        "id": 98825,
                        "name": "Kameshkovo",
                        "latitude": "56.35305000",
                        "longitude": "41.00941000"
                    },
                    {
                        "id": 98851,
                        "name": "Karabanovo",
                        "latitude": "56.31667000",
                        "longitude": "38.70000000"
                    },
                    {
                        "id": 99034,
                        "name": "Kideksha",
                        "latitude": "56.42381000",
                        "longitude": "40.52146000"
                    },
                    {
                        "id": 99077,
                        "name": "Kirzhach",
                        "latitude": "56.15273000",
                        "longitude": "38.85509000"
                    },
                    {
                        "id": 99154,
                        "name": "Kol’chugino",
                        "latitude": "56.29929000",
                        "longitude": "39.38304000"
                    },
                    {
                        "id": 99155,
                        "name": "Kol’chuginskiy Rayon",
                        "latitude": "56.25000000",
                        "longitude": "39.41667000"
                    },
                    {
                        "id": 99163,
                        "name": "Kommunar",
                        "latitude": "56.11222000",
                        "longitude": "40.44666000"
                    },
                    {
                        "id": 99237,
                        "name": "Kosterevo",
                        "latitude": "55.92990000",
                        "longitude": "39.61438000"
                    },
                    {
                        "id": 99255,
                        "name": "Kovrov",
                        "latitude": "56.35722000",
                        "longitude": "41.31917000"
                    },
                    {
                        "id": 99278,
                        "name": "Krasnaya Gorbatka",
                        "latitude": "55.87030000",
                        "longitude": "41.76410000"
                    },
                    {
                        "id": 99359,
                        "name": "Krasnyy Bogatyr’",
                        "latitude": "56.01453000",
                        "longitude": "41.12958000"
                    },
                    {
                        "id": 99370,
                        "name": "Krasnyy Oktyabr’",
                        "latitude": "56.11667000",
                        "longitude": "38.88333000"
                    },
                    {
                        "id": 99466,
                        "name": "Kurlovo",
                        "latitude": "55.43252000",
                        "longitude": "40.48539000"
                    },
                    {
                        "id": 99540,
                        "name": "Lakinsk",
                        "latitude": "56.01931000",
                        "longitude": "39.94848000"
                    },
                    {
                        "id": 99688,
                        "name": "Luknovo",
                        "latitude": "56.18045000",
                        "longitude": "42.03987000"
                    },
                    {
                        "id": 99852,
                        "name": "Melekhovo",
                        "latitude": "56.27730000",
                        "longitude": "41.29346000"
                    },
                    {
                        "id": 99853,
                        "name": "Melenki",
                        "latitude": "55.33430000",
                        "longitude": "41.62950000"
                    },
                    {
                        "id": 99854,
                        "name": "Melenkovskiy Rayon",
                        "latitude": "55.33333000",
                        "longitude": "41.50000000"
                    },
                    {
                        "id": 99884,
                        "name": "Mezinovskiy",
                        "latitude": "55.50420000",
                        "longitude": "40.35932000"
                    },
                    {
                        "id": 99990,
                        "name": "Mstera",
                        "latitude": "56.37889000",
                        "longitude": "41.92000000"
                    },
                    {
                        "id": 100012,
                        "name": "Murom",
                        "latitude": "55.57500000",
                        "longitude": "42.04260000"
                    },
                    {
                        "id": 100013,
                        "name": "Muromskiy Rayon",
                        "latitude": "55.58333000",
                        "longitude": "41.91667000"
                    },
                    {
                        "id": 100015,
                        "name": "Muromtsevo",
                        "latitude": "55.93096000",
                        "longitude": "40.90738000"
                    },
                    {
                        "id": 100142,
                        "name": "Nikologory",
                        "latitude": "56.14130000",
                        "longitude": "41.99218000"
                    },
                    {
                        "id": 100217,
                        "name": "Novki",
                        "latitude": "56.36386000",
                        "longitude": "41.08655000"
                    },
                    {
                        "id": 100330,
                        "name": "Novovyazniki",
                        "latitude": "56.19750000",
                        "longitude": "42.17111000"
                    },
                    {
                        "id": 100410,
                        "name": "Oktyabr’skiy",
                        "latitude": "56.21887000",
                        "longitude": "42.04069000"
                    },
                    {
                        "id": 100466,
                        "name": "Orgtrud",
                        "latitude": "56.18320000",
                        "longitude": "40.61490000"
                    },
                    {
                        "id": 100667,
                        "name": "Petushinskiy Rayon",
                        "latitude": "55.91667000",
                        "longitude": "40.00000000"
                    },
                    {
                        "id": 100668,
                        "name": "Petushki",
                        "latitude": "55.92639000",
                        "longitude": "39.46104000"
                    },
                    {
                        "id": 100742,
                        "name": "Pokrov",
                        "latitude": "55.91797000",
                        "longitude": "39.17242000"
                    },
                    {
                        "id": 100929,
                        "name": "Raduzhnyy",
                        "latitude": "56.00380000",
                        "longitude": "40.33905000"
                    },
                    {
                        "id": 101426,
                        "name": "Sobinka",
                        "latitude": "55.98553000",
                        "longitude": "40.01111000"
                    },
                    {
                        "id": 101427,
                        "name": "Sobinskiy Rayon",
                        "latitude": "56.16667000",
                        "longitude": "40.00000000"
                    },
                    {
                        "id": 101614,
                        "name": "Stavrovo",
                        "latitude": "56.13311000",
                        "longitude": "40.01295000"
                    },
                    {
                        "id": 101615,
                        "name": "Stepantsevo",
                        "latitude": "56.13143000",
                        "longitude": "41.70320000"
                    },
                    {
                        "id": 101635,
                        "name": "Strunino",
                        "latitude": "56.37328000",
                        "longitude": "38.58321000"
                    },
                    {
                        "id": 101644,
                        "name": "Sudogda",
                        "latitude": "55.95394000",
                        "longitude": "40.86291000"
                    },
                    {
                        "id": 101645,
                        "name": "Sudogodskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "41.00000000"
                    },
                    {
                        "id": 101690,
                        "name": "Suzdal’",
                        "latitude": "56.42274000",
                        "longitude": "40.44668000"
                    },
                    {
                        "id": 101691,
                        "name": "Suzdal’skiy Rayon",
                        "latitude": "56.08333000",
                        "longitude": "40.50000000"
                    },
                    {
                        "id": 102084,
                        "name": "Urshel’skiy",
                        "latitude": "55.67833000",
                        "longitude": "40.21692000"
                    },
                    {
                        "id": 102214,
                        "name": "Velikodvorskiy",
                        "latitude": "55.24996000",
                        "longitude": "40.66780000"
                    },
                    {
                        "id": 102326,
                        "name": "Vladimir",
                        "latitude": "56.13655000",
                        "longitude": "40.39658000"
                    },
                    {
                        "id": 102386,
                        "name": "Vorsha",
                        "latitude": "56.04910000",
                        "longitude": "40.07966000"
                    },
                    {
                        "id": 102422,
                        "name": "Vyazniki",
                        "latitude": "56.24057000",
                        "longitude": "42.15563000"
                    },
                    {
                        "id": 102603,
                        "name": "Yur’yev-Pol’skiy",
                        "latitude": "56.50339000",
                        "longitude": "39.67911000"
                    },
                    {
                        "id": 102604,
                        "name": "Yur’yev-Pol’skiy Rayon",
                        "latitude": "56.58333000",
                        "longitude": "39.58333000"
                    },
                    {
                        "id": 102764,
                        "name": "Zolotkovo",
                        "latitude": "55.52810000",
                        "longitude": "41.10530000"
                    }
                ]
            },
            {
                "id": 4916,
                "name": "Volgograd Oblast",
                "iso2": "VGG",
                "latitude": "49.25873930",
                "longitude": "39.81544630",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 146860,
                        "name": "Alimov-Lyubimovsky",
                        "latitude": "50.26631944",
                        "longitude": "42.75618611"
                    },
                    {
                        "id": 146861,
                        "name": "Amochayevsky",
                        "latitude": "50.70363889",
                        "longitude": "42.42831944"
                    },
                    {
                        "id": 146862,
                        "name": "Antipovka",
                        "latitude": "49.83000000",
                        "longitude": "45.31222222"
                    },
                    {
                        "id": 146863,
                        "name": "Archedino-Chernushinsky",
                        "latitude": "49.87194444",
                        "longitude": "44.16388889"
                    },
                    {
                        "id": 146864,
                        "name": "Archedinskaya",
                        "latitude": "49.89305556",
                        "longitude": "43.11250000"
                    },
                    {
                        "id": 146865,
                        "name": "Beluzhino-Koldairov",
                        "latitude": "49.28033200",
                        "longitude": "43.71795500"
                    },
                    {
                        "id": 146866,
                        "name": "Bereslavka",
                        "latitude": "48.61190900",
                        "longitude": "44.05960700"
                    },
                    {
                        "id": 146867,
                        "name": "Bobrovsky 2-y",
                        "latitude": "49.48820000",
                        "longitude": "42.75470000"
                    },
                    {
                        "id": 146868,
                        "name": "Burnatsky",
                        "latitude": "50.42997222",
                        "longitude": "42.95563056"
                    },
                    {
                        "id": 146869,
                        "name": "Buyerak-Popovsky",
                        "latitude": "49.55060000",
                        "longitude": "42.61350000"
                    },
                    {
                        "id": 146870,
                        "name": "Bykovo Volgograd Oblast",
                        "latitude": "49.76444444",
                        "longitude": "45.39138889"
                    },
                    {
                        "id": 146871,
                        "name": "Chernyshkovsky",
                        "latitude": "48.42111111",
                        "longitude": "42.23333333"
                    },
                    {
                        "id": 146872,
                        "name": "Chiganaki 1-ye",
                        "latitude": "49.78505833",
                        "longitude": "42.72091944"
                    },
                    {
                        "id": 146873,
                        "name": "Chiganaki 2-ye",
                        "latitude": "49.76481389",
                        "longitude": "42.70378889"
                    },
                    {
                        "id": 146874,
                        "name": "Danilovka Volgograd Oblast",
                        "latitude": "50.36666667",
                        "longitude": "44.11666667"
                    },
                    {
                        "id": 146875,
                        "name": "Dubovka",
                        "latitude": "49.05000000",
                        "longitude": "44.83333333"
                    },
                    {
                        "id": 146876,
                        "name": "Elton",
                        "latitude": "49.12722222",
                        "longitude": "46.84694444"
                    },
                    {
                        "id": 146877,
                        "name": "Fastov",
                        "latitude": "49.07411000",
                        "longitude": "44.20814000"
                    },
                    {
                        "id": 146878,
                        "name": "Frolovo",
                        "latitude": "49.77138889",
                        "longitude": "43.66222222"
                    },
                    {
                        "id": 146879,
                        "name": "Glubokovsky",
                        "latitude": "49.46330000",
                        "longitude": "42.90550000"
                    },
                    {
                        "id": 146880,
                        "name": "Gorbatovsky",
                        "latitude": "49.35910000",
                        "longitude": "42.04060000"
                    },
                    {
                        "id": 146881,
                        "name": "Gornaya Polyana",
                        "latitude": "48.50138889",
                        "longitude": "45.11944444"
                    },
                    {
                        "id": 146882,
                        "name": "Gorodishche Volgograd Oblast",
                        "latitude": "48.80000000",
                        "longitude": "44.48333333"
                    },
                    {
                        "id": 146883,
                        "name": "Ilovlya",
                        "latitude": "49.30333333",
                        "longitude": "43.97972222"
                    },
                    {
                        "id": 146884,
                        "name": "Kalach-na-Donu",
                        "latitude": "48.68333333",
                        "longitude": "43.53333333"
                    },
                    {
                        "id": 146885,
                        "name": "Kamyshin",
                        "latitude": "50.08333333",
                        "longitude": "45.40000000"
                    },
                    {
                        "id": 146886,
                        "name": "Karpovsky",
                        "latitude": "50.32108056",
                        "longitude": "42.58680278"
                    },
                    {
                        "id": 146887,
                        "name": "Kletskaya",
                        "latitude": "49.31472222",
                        "longitude": "43.06194444"
                    },
                    {
                        "id": 146888,
                        "name": "Kolotsky",
                        "latitude": "49.25952000",
                        "longitude": "43.99259000"
                    },
                    {
                        "id": 146889,
                        "name": "Kotelnikovo",
                        "latitude": "47.63333333",
                        "longitude": "43.13333333"
                    },
                    {
                        "id": 146890,
                        "name": "Kotovo",
                        "latitude": "50.31666667",
                        "longitude": "44.80000000"
                    },
                    {
                        "id": 146891,
                        "name": "Krasnoslobodsk",
                        "latitude": "48.70000000",
                        "longitude": "44.56666667"
                    },
                    {
                        "id": 146892,
                        "name": "Krasny Yar Volgograd Oblast",
                        "latitude": "50.69638889",
                        "longitude": "44.72805556"
                    },
                    {
                        "id": 146893,
                        "name": "Kumylzhenskaya",
                        "latitude": "49.88083333",
                        "longitude": "42.58972222"
                    },
                    {
                        "id": 146894,
                        "name": "Leninsk",
                        "latitude": "48.70000000",
                        "longitude": "45.20000000"
                    },
                    {
                        "id": 146895,
                        "name": "Log",
                        "latitude": "49.48444444",
                        "longitude": "43.86138889"
                    },
                    {
                        "id": 146896,
                        "name": "Medveditsky",
                        "latitude": "50.78527778",
                        "longitude": "44.71277778"
                    },
                    {
                        "id": 146897,
                        "name": "Mikhaylovka",
                        "latitude": "50.06666667",
                        "longitude": "43.23333333"
                    },
                    {
                        "id": 146898,
                        "name": "Mikhaylovka Urban Okrug",
                        "latitude": "50.06666667",
                        "longitude": "43.23333333"
                    },
                    {
                        "id": 146899,
                        "name": "Mitkin",
                        "latitude": "49.74354167",
                        "longitude": "42.25430833"
                    },
                    {
                        "id": 146900,
                        "name": "Nekhayevskaya",
                        "latitude": "50.40861111",
                        "longitude": "41.74944444"
                    },
                    {
                        "id": 146901,
                        "name": "Nikolayevsk",
                        "latitude": "50.01666667",
                        "longitude": "45.45000000"
                    },
                    {
                        "id": 146902,
                        "name": "Nizhny Chir",
                        "latitude": "48.35972222",
                        "longitude": "43.08638889"
                    },
                    {
                        "id": 146903,
                        "name": "Novoanninsky",
                        "latitude": "50.51666667",
                        "longitude": "42.66666667"
                    },
                    {
                        "id": 146904,
                        "name": "Novonikolayevsky Volgograd Oblast",
                        "latitude": "50.96666670",
                        "longitude": "42.36666670"
                    },
                    {
                        "id": 146905,
                        "name": "Novonikolskoe",
                        "latitude": "49.19397500",
                        "longitude": "45.01108611"
                    },
                    {
                        "id": 146906,
                        "name": "Novy Rogachik",
                        "latitude": "48.67694444",
                        "longitude": "44.06083333"
                    },
                    {
                        "id": 146907,
                        "name": "Oktyabrsky",
                        "latitude": "48.65555556",
                        "longitude": "43.79555556"
                    },
                    {
                        "id": 146908,
                        "name": "Olkhovka Volgograd Oblast",
                        "latitude": "49.85444444",
                        "longitude": "44.56333333"
                    },
                    {
                        "id": 146909,
                        "name": "Otruba",
                        "latitude": "50.04300000",
                        "longitude": "43.12150000"
                    },
                    {
                        "id": 146910,
                        "name": "Pallasovka",
                        "latitude": "50.05000000",
                        "longitude": "46.88333333"
                    },
                    {
                        "id": 146911,
                        "name": "Petrov Val",
                        "latitude": "50.13333333",
                        "longitude": "45.21666667"
                    },
                    {
                        "id": 146912,
                        "name": "Poltavsky",
                        "latitude": "50.37360000",
                        "longitude": "43.07290000"
                    },
                    {
                        "id": 146913,
                        "name": "Popovsky",
                        "latitude": "50.60229722",
                        "longitude": "42.41745278"
                    },
                    {
                        "id": 146914,
                        "name": "Preobrazhenskaya Volgograd Oblast",
                        "latitude": "50.74083333",
                        "longitude": "43.05194444"
                    },
                    {
                        "id": 146915,
                        "name": "Primorsk",
                        "latitude": "49.26527778",
                        "longitude": "45.02888889"
                    },
                    {
                        "id": 146916,
                        "name": "Repino",
                        "latitude": "48.55252000",
                        "longitude": "44.79595000"
                    },
                    {
                        "id": 146917,
                        "name": "Rogachev",
                        "latitude": "50.66952222",
                        "longitude": "42.41200556"
                    },
                    {
                        "id": 146918,
                        "name": "Rubyozhny",
                        "latitude": "49.81750000",
                        "longitude": "44.05027778"
                    },
                    {
                        "id": 146919,
                        "name": "Rudnya Volgograd Oblast",
                        "latitude": "50.79805556",
                        "longitude": "44.56000000"
                    },
                    {
                        "id": 146920,
                        "name": "Russko-Osinovsky",
                        "latitude": "49.97500000",
                        "longitude": "44.10305556"
                    },
                    {
                        "id": 146921,
                        "name": "Samoylovsky",
                        "latitude": "49.87533056",
                        "longitude": "42.39540556"
                    },
                    {
                        "id": 146922,
                        "name": "Satarovsky",
                        "latitude": "50.27939722",
                        "longitude": "42.59351944"
                    },
                    {
                        "id": 146923,
                        "name": "Savinka",
                        "latitude": "50.07848000",
                        "longitude": "47.09936000"
                    },
                    {
                        "id": 146924,
                        "name": "Sebrovo",
                        "latitude": "50.09810000",
                        "longitude": "43.29760000"
                    },
                    {
                        "id": 146925,
                        "name": "Serafimovich",
                        "latitude": "49.58333333",
                        "longitude": "42.73333333"
                    },
                    {
                        "id": 146926,
                        "name": "Shirokov",
                        "latitude": "49.12103000",
                        "longitude": "44.26507000"
                    },
                    {
                        "id": 146927,
                        "name": "Slashchyovskaya",
                        "latitude": "49.86000000",
                        "longitude": "42.33611111"
                    },
                    {
                        "id": 146928,
                        "name": "Sovetsky District",
                        "latitude": "48.66666667",
                        "longitude": "44.45000000"
                    },
                    {
                        "id": 146929,
                        "name": "Srednyaya Akhtuba",
                        "latitude": "48.71111111",
                        "longitude": "44.86403000"
                    },
                    {
                        "id": 146930,
                        "name": "Staraya Poltavka",
                        "latitude": "50.47861111",
                        "longitude": "46.48222222"
                    },
                    {
                        "id": 146931,
                        "name": "Surovikino",
                        "latitude": "48.60000000",
                        "longitude": "42.85000000"
                    },
                    {
                        "id": 146932,
                        "name": "Svetly Yar",
                        "latitude": "48.47472222",
                        "longitude": "44.78083333"
                    },
                    {
                        "id": 146933,
                        "name": "Tochilkin",
                        "latitude": "49.73334722",
                        "longitude": "42.69625278"
                    },
                    {
                        "id": 146934,
                        "name": "Uryupinsk",
                        "latitude": "50.80000000",
                        "longitude": "42.01666667"
                    },
                    {
                        "id": 146935,
                        "name": "Vodstroy",
                        "latitude": "48.84593056",
                        "longitude": "44.55466667"
                    },
                    {
                        "id": 146936,
                        "name": "Volgograd",
                        "latitude": "48.70000000",
                        "longitude": "44.48333333"
                    },
                    {
                        "id": 146937,
                        "name": "Volzhsky",
                        "latitude": "48.78333333",
                        "longitude": "44.76666667"
                    },
                    {
                        "id": 146938,
                        "name": "Voroshilovskiy District Volgograd",
                        "latitude": "48.70000000",
                        "longitude": "44.46666667"
                    },
                    {
                        "id": 146939,
                        "name": "Yelan",
                        "latitude": "50.94611111",
                        "longitude": "43.73638889"
                    },
                    {
                        "id": 146940,
                        "name": "Zaplavnoye",
                        "latitude": "48.70472222",
                        "longitude": "45.02277778"
                    },
                    {
                        "id": 146941,
                        "name": "Zhirnovsk",
                        "latitude": "50.98333333",
                        "longitude": "44.76666667"
                    }
                ]
            },
            {
                "id": 1874,
                "name": "Vologda",
                "iso2": "VLG",
                "latitude": "59.87067110",
                "longitude": "40.65554110",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97737,
                        "name": "Babayevo",
                        "latitude": "59.39360000",
                        "longitude": "35.93710000"
                    },
                    {
                        "id": 97738,
                        "name": "Babayevskiy Rayon",
                        "latitude": "59.50000000",
                        "longitude": "36.00000000"
                    },
                    {
                        "id": 97873,
                        "name": "Belozërsk",
                        "latitude": "60.02880000",
                        "longitude": "37.80840000"
                    },
                    {
                        "id": 97874,
                        "name": "Belozërskiy Rayon",
                        "latitude": "59.91667000",
                        "longitude": "37.25000000"
                    },
                    {
                        "id": 98108,
                        "name": "Chagoda",
                        "latitude": "59.16400000",
                        "longitude": "35.32850000"
                    },
                    {
                        "id": 98109,
                        "name": "Chagodoshchenskiy Rayon",
                        "latitude": "59.00000000",
                        "longitude": "35.41667000"
                    },
                    {
                        "id": 98129,
                        "name": "Chebsara",
                        "latitude": "59.20016000",
                        "longitude": "38.83556000"
                    },
                    {
                        "id": 98156,
                        "name": "Cherepovets",
                        "latitude": "59.13333000",
                        "longitude": "37.90000000"
                    },
                    {
                        "id": 98157,
                        "name": "Cherepovetskiy Rayon",
                        "latitude": "59.33333000",
                        "longitude": "37.91667000"
                    },
                    {
                        "id": 98419,
                        "name": "Ferapontovo",
                        "latitude": "59.95425000",
                        "longitude": "38.56745000"
                    },
                    {
                        "id": 98526,
                        "name": "Goritsy",
                        "latitude": "59.86949000",
                        "longitude": "38.26016000"
                    },
                    {
                        "id": 98599,
                        "name": "Gryazovets",
                        "latitude": "58.88000000",
                        "longitude": "40.25250000"
                    },
                    {
                        "id": 98600,
                        "name": "Gryazovetskiy Rayon",
                        "latitude": "58.91667000",
                        "longitude": "40.75000000"
                    },
                    {
                        "id": 98661,
                        "name": "Imeni Babushkina",
                        "latitude": "59.75727000",
                        "longitude": "43.12847000"
                    },
                    {
                        "id": 98672,
                        "name": "Imeni Zhelyabova",
                        "latitude": "58.95440000",
                        "longitude": "36.59560000"
                    },
                    {
                        "id": 98768,
                        "name": "Kadnikov",
                        "latitude": "59.50218000",
                        "longitude": "40.33803000"
                    },
                    {
                        "id": 98771,
                        "name": "Kaduy",
                        "latitude": "59.20000000",
                        "longitude": "37.15000000"
                    },
                    {
                        "id": 98772,
                        "name": "Kaduyskiy Rayon",
                        "latitude": "59.33333000",
                        "longitude": "37.00000000"
                    },
                    {
                        "id": 98966,
                        "name": "Kharovsk",
                        "latitude": "59.96425000",
                        "longitude": "40.19121000"
                    },
                    {
                        "id": 98967,
                        "name": "Kharovskiy Rayon",
                        "latitude": "60.08333000",
                        "longitude": "40.25000000"
                    },
                    {
                        "id": 98989,
                        "name": "Khokhlovo",
                        "latitude": "59.14923000",
                        "longitude": "37.39978000"
                    },
                    {
                        "id": 99032,
                        "name": "Kichmengskiy Gorodok",
                        "latitude": "59.98164000",
                        "longitude": "45.78543000"
                    },
                    {
                        "id": 99033,
                        "name": "Kichmengsko-Gorodetskiy Rayon",
                        "latitude": "60.00000000",
                        "longitude": "46.00000000"
                    },
                    {
                        "id": 99055,
                        "name": "Kirillov",
                        "latitude": "59.86299000",
                        "longitude": "38.38128000"
                    },
                    {
                        "id": 99056,
                        "name": "Kirillovskiy Rayon",
                        "latitude": "60.00000000",
                        "longitude": "38.58333000"
                    },
                    {
                        "id": 99274,
                        "name": "Krasavino",
                        "latitude": "60.96225000",
                        "longitude": "46.48321000"
                    },
                    {
                        "id": 99504,
                        "name": "Kuzino",
                        "latitude": "59.77665000",
                        "longitude": "38.31040000"
                    },
                    {
                        "id": 99634,
                        "name": "Lipin Bor",
                        "latitude": "60.26300000",
                        "longitude": "37.97850000"
                    },
                    {
                        "id": 99882,
                        "name": "Mezhdurechenskiy Rayon",
                        "latitude": "59.25000000",
                        "longitude": "41.00000000"
                    },
                    {
                        "id": 99949,
                        "name": "Molochnoye",
                        "latitude": "59.29166000",
                        "longitude": "39.67868000"
                    },
                    {
                        "id": 100026,
                        "name": "Myaksa",
                        "latitude": "58.88890000",
                        "longitude": "38.19380000"
                    },
                    {
                        "id": 100097,
                        "name": "Nelazskoye",
                        "latitude": "59.18919000",
                        "longitude": "37.63963000"
                    },
                    {
                        "id": 100143,
                        "name": "Nikol’sk",
                        "latitude": "59.53531000",
                        "longitude": "45.45743000"
                    },
                    {
                        "id": 100381,
                        "name": "Nyuksenitsa",
                        "latitude": "60.41159000",
                        "longitude": "44.23309000"
                    },
                    {
                        "id": 101142,
                        "name": "Sazonovo",
                        "latitude": "59.09190000",
                        "longitude": "35.22680000"
                    },
                    {
                        "id": 101288,
                        "name": "Sheksna",
                        "latitude": "59.20998000",
                        "longitude": "38.51066000"
                    },
                    {
                        "id": 101289,
                        "name": "Sheksninskiy Rayon",
                        "latitude": "59.25000000",
                        "longitude": "38.58333000"
                    },
                    {
                        "id": 101363,
                        "name": "Shuyskoye",
                        "latitude": "59.37356000",
                        "longitude": "41.03047000"
                    },
                    {
                        "id": 101431,
                        "name": "Sokol",
                        "latitude": "59.46167000",
                        "longitude": "40.12056000"
                    },
                    {
                        "id": 101442,
                        "name": "Sokol’skiy Rayon",
                        "latitude": "59.50000000",
                        "longitude": "40.33333000"
                    },
                    {
                        "id": 101641,
                        "name": "Suda",
                        "latitude": "59.15254000",
                        "longitude": "37.55820000"
                    },
                    {
                        "id": 101717,
                        "name": "Syamzha",
                        "latitude": "60.01577000",
                        "longitude": "41.06139000"
                    },
                    {
                        "id": 101718,
                        "name": "Syamzhenskiy Rayon",
                        "latitude": "60.00000000",
                        "longitude": "41.25000000"
                    },
                    {
                        "id": 101777,
                        "name": "Tarnogskiy Gorodok",
                        "latitude": "60.49972000",
                        "longitude": "43.57611000"
                    },
                    {
                        "id": 101778,
                        "name": "Tarnogskiy Rayon",
                        "latitude": "60.50000000",
                        "longitude": "43.50000000"
                    },
                    {
                        "id": 101890,
                        "name": "Tonshalovo",
                        "latitude": "59.19483000",
                        "longitude": "37.94746000"
                    },
                    {
                        "id": 101907,
                        "name": "Tot’ma",
                        "latitude": "59.97375000",
                        "longitude": "42.76487000"
                    },
                    {
                        "id": 101905,
                        "name": "Totemskiy Rayon",
                        "latitude": "59.75000000",
                        "longitude": "42.50000000"
                    },
                    {
                        "id": 102133,
                        "name": "Ust’-Kubinskiy Rayon",
                        "latitude": "59.91667000",
                        "longitude": "39.50000000"
                    },
                    {
                        "id": 102145,
                        "name": "Ust’ye",
                        "latitude": "59.63043000",
                        "longitude": "39.73596000"
                    },
                    {
                        "id": 102111,
                        "name": "Ustyuzhenskiy Rayon",
                        "latitude": "58.83333000",
                        "longitude": "36.50000000"
                    },
                    {
                        "id": 102112,
                        "name": "Ustyuzhna",
                        "latitude": "58.83940000",
                        "longitude": "36.43210000"
                    },
                    {
                        "id": 102212,
                        "name": "Velikiy Ustyug",
                        "latitude": "60.76186000",
                        "longitude": "46.31352000"
                    },
                    {
                        "id": 102218,
                        "name": "Velikoustyugskiy Rayon",
                        "latitude": "60.75000000",
                        "longitude": "46.00000000"
                    },
                    {
                        "id": 102279,
                        "name": "Verkhovazh’ye",
                        "latitude": "60.74717000",
                        "longitude": "42.04652000"
                    },
                    {
                        "id": 102278,
                        "name": "Verkhovazhskiy Rayon",
                        "latitude": "60.58333000",
                        "longitude": "42.25000000"
                    },
                    {
                        "id": 102337,
                        "name": "Vokhtoga",
                        "latitude": "58.80949000",
                        "longitude": "41.06245000"
                    },
                    {
                        "id": 102354,
                        "name": "Vologda",
                        "latitude": "59.22390000",
                        "longitude": "39.88398000"
                    },
                    {
                        "id": 102355,
                        "name": "Vologodskiy Rayon",
                        "latitude": "59.16667000",
                        "longitude": "39.75000000"
                    },
                    {
                        "id": 102407,
                        "name": "Vozhega",
                        "latitude": "60.47246000",
                        "longitude": "40.22134000"
                    },
                    {
                        "id": 102453,
                        "name": "Vytegorskiy Rayon",
                        "latitude": "61.00000000",
                        "longitude": "36.50000000"
                    },
                    {
                        "id": 102454,
                        "name": "Vytegra",
                        "latitude": "61.00636000",
                        "longitude": "36.44811000"
                    },
                    {
                        "id": 102771,
                        "name": "Zubovo",
                        "latitude": "60.31810000",
                        "longitude": "36.97090000"
                    }
                ]
            },
            {
                "id": 1906,
                "name": "Voronezh",
                "iso2": "VOR",
                "latitude": "50.85897130",
                "longitude": "39.86443740",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97489,
                        "name": "Abramovka",
                        "latitude": "51.18860000",
                        "longitude": "41.02020000"
                    },
                    {
                        "id": 97633,
                        "name": "Anna",
                        "latitude": "51.48420000",
                        "longitude": "40.42990000"
                    },
                    {
                        "id": 97637,
                        "name": "Anninskiy Rayon",
                        "latitude": "51.41667000",
                        "longitude": "40.25000000"
                    },
                    {
                        "id": 97855,
                        "name": "Belogor’ye",
                        "latitude": "50.49040000",
                        "longitude": "40.00950000"
                    },
                    {
                        "id": 97955,
                        "name": "Bobrov",
                        "latitude": "51.09611000",
                        "longitude": "40.03333000"
                    },
                    {
                        "id": 97959,
                        "name": "Bobrovskiy Rayon",
                        "latitude": "51.25000000",
                        "longitude": "40.00000000"
                    },
                    {
                        "id": 97983,
                        "name": "Boguchar",
                        "latitude": "49.93577000",
                        "longitude": "40.54500000"
                    },
                    {
                        "id": 98024,
                        "name": "Borisoglebsk",
                        "latitude": "51.36713000",
                        "longitude": "42.08494000"
                    },
                    {
                        "id": 98088,
                        "name": "Buturlinovka",
                        "latitude": "50.82389000",
                        "longitude": "40.60917000"
                    },
                    {
                        "id": 98089,
                        "name": "Buturlinovskiy Rayon",
                        "latitude": "50.83333000",
                        "longitude": "40.66667000"
                    },
                    {
                        "id": 98251,
                        "name": "Davydovka",
                        "latitude": "51.15781000",
                        "longitude": "39.42915000"
                    },
                    {
                        "id": 98271,
                        "name": "Devitsa",
                        "latitude": "51.63520000",
                        "longitude": "38.94500000"
                    },
                    {
                        "id": 98324,
                        "name": "Drakino",
                        "latitude": "51.13898000",
                        "longitude": "39.40215000"
                    },
                    {
                        "id": 98401,
                        "name": "Ertil’",
                        "latitude": "51.84056000",
                        "longitude": "40.80556000"
                    },
                    {
                        "id": 98402,
                        "name": "Ertil’skiy Rayon",
                        "latitude": "51.75000000",
                        "longitude": "40.75000000"
                    },
                    {
                        "id": 98587,
                        "name": "Gribanovskiy",
                        "latitude": "51.45792000",
                        "longitude": "41.97637000"
                    },
                    {
                        "id": 98588,
                        "name": "Gribanovskiy Rayon",
                        "latitude": "51.50000000",
                        "longitude": "42.00000000"
                    },
                    {
                        "id": 98664,
                        "name": "Imeni Pervogo Maya",
                        "latitude": "50.88997000",
                        "longitude": "39.59190000"
                    },
                    {
                        "id": 98778,
                        "name": "Kalach",
                        "latitude": "50.42580000",
                        "longitude": "41.02610000"
                    },
                    {
                        "id": 98810,
                        "name": "Kamenka",
                        "latitude": "51.32230000",
                        "longitude": "42.76780000"
                    },
                    {
                        "id": 98822,
                        "name": "Kamenskiy Rayon",
                        "latitude": "51.31667000",
                        "longitude": "42.76667000"
                    },
                    {
                        "id": 98846,
                        "name": "Kantemirovka",
                        "latitude": "49.70887000",
                        "longitude": "39.85922000"
                    },
                    {
                        "id": 98894,
                        "name": "Kashirskiy Rayon",
                        "latitude": "51.41667000",
                        "longitude": "39.61667000"
                    },
                    {
                        "id": 98895,
                        "name": "Kashirskoye",
                        "latitude": "51.41945000",
                        "longitude": "39.61248000"
                    },
                    {
                        "id": 99014,
                        "name": "Khrenovoye",
                        "latitude": "51.12000000",
                        "longitude": "40.28889000"
                    },
                    {
                        "id": 99139,
                        "name": "Kolodeznyy",
                        "latitude": "51.33333000",
                        "longitude": "39.18333000"
                    },
                    {
                        "id": 99217,
                        "name": "Korotoyak",
                        "latitude": "50.98665000",
                        "longitude": "39.17677000"
                    },
                    {
                        "id": 99267,
                        "name": "Kozlovka",
                        "latitude": "50.86222000",
                        "longitude": "40.45556000"
                    },
                    {
                        "id": 99327,
                        "name": "Krasnolesnyy",
                        "latitude": "51.88072000",
                        "longitude": "39.58772000"
                    },
                    {
                        "id": 99546,
                        "name": "Latnaya",
                        "latitude": "51.65860000",
                        "longitude": "38.90110000"
                    },
                    {
                        "id": 99637,
                        "name": "Liski",
                        "latitude": "50.98405000",
                        "longitude": "39.51545000"
                    },
                    {
                        "id": 99638,
                        "name": "Liskinskiy Rayon",
                        "latitude": "50.91667000",
                        "longitude": "39.50000000"
                    },
                    {
                        "id": 99665,
                        "name": "Losevo",
                        "latitude": "50.67667000",
                        "longitude": "40.04500000"
                    },
                    {
                        "id": 99811,
                        "name": "Maslovka",
                        "latitude": "51.55346000",
                        "longitude": "39.23573000"
                    },
                    {
                        "id": 99932,
                        "name": "Mitrofanovka",
                        "latitude": "49.97083000",
                        "longitude": "39.69389000"
                    },
                    {
                        "id": 100151,
                        "name": "Nizhnedevitsk",
                        "latitude": "51.54190000",
                        "longitude": "38.36570000"
                    },
                    {
                        "id": 100152,
                        "name": "Nizhnedevitskiy Rayon",
                        "latitude": "51.50000000",
                        "longitude": "38.41667000"
                    },
                    {
                        "id": 100168,
                        "name": "Nizhniy Kislyay",
                        "latitude": "50.84970000",
                        "longitude": "40.17190000"
                    },
                    {
                        "id": 100172,
                        "name": "Nizhniy Mamon",
                        "latitude": "50.19370000",
                        "longitude": "40.50830000"
                    },
                    {
                        "id": 100202,
                        "name": "Novaya Chigla",
                        "latitude": "51.22333000",
                        "longitude": "40.47806000"
                    },
                    {
                        "id": 100211,
                        "name": "Novaya Usman’",
                        "latitude": "51.64177000",
                        "longitude": "39.40863000"
                    },
                    {
                        "id": 100249,
                        "name": "Novokhopërsk",
                        "latitude": "51.09690000",
                        "longitude": "41.62520000"
                    },
                    {
                        "id": 100248,
                        "name": "Novokhoperskiy Rayon",
                        "latitude": "51.08333000",
                        "longitude": "41.58333000"
                    },
                    {
                        "id": 100323,
                        "name": "Novousmanskiy Rayon",
                        "latitude": "51.58333000",
                        "longitude": "39.41667000"
                    },
                    {
                        "id": 100329,
                        "name": "Novovoronezh",
                        "latitude": "51.30719000",
                        "longitude": "39.21732000"
                    },
                    {
                        "id": 100336,
                        "name": "Novozhivotinnoye",
                        "latitude": "51.88770000",
                        "longitude": "39.16894000"
                    },
                    {
                        "id": 100437,
                        "name": "Ol’khovatka",
                        "latitude": "50.28308000",
                        "longitude": "39.28715000"
                    },
                    {
                        "id": 100438,
                        "name": "Ol’khovatskiy Rayon",
                        "latitude": "50.25000000",
                        "longitude": "39.25000000"
                    },
                    {
                        "id": 100472,
                        "name": "Orlovo",
                        "latitude": "51.75397000",
                        "longitude": "39.58731000"
                    },
                    {
                        "id": 100495,
                        "name": "Ostrogozhsk",
                        "latitude": "50.86640000",
                        "longitude": "39.07561000"
                    },
                    {
                        "id": 100535,
                        "name": "Panino",
                        "latitude": "51.64670000",
                        "longitude": "40.13460000"
                    },
                    {
                        "id": 100536,
                        "name": "Paninskiy Rayon",
                        "latitude": "51.66667000",
                        "longitude": "40.16667000"
                    },
                    {
                        "id": 100572,
                        "name": "Pavlovsk",
                        "latitude": "50.45778000",
                        "longitude": "40.10806000"
                    },
                    {
                        "id": 100580,
                        "name": "Pavlovskiy Rayon",
                        "latitude": "50.41667000",
                        "longitude": "40.16667000"
                    },
                    {
                        "id": 100598,
                        "name": "Pereleshino",
                        "latitude": "51.73760000",
                        "longitude": "40.13880000"
                    },
                    {
                        "id": 100599,
                        "name": "Pereleshinskiy",
                        "latitude": "51.71480000",
                        "longitude": "40.19530000"
                    },
                    {
                        "id": 100713,
                        "name": "Podgorenskiy",
                        "latitude": "50.40498000",
                        "longitude": "39.64295000"
                    },
                    {
                        "id": 100714,
                        "name": "Podgorenskiy Rayon",
                        "latitude": "50.50000000",
                        "longitude": "39.58333000"
                    },
                    {
                        "id": 100716,
                        "name": "Podgornoye",
                        "latitude": "51.73504000",
                        "longitude": "39.14961000"
                    },
                    {
                        "id": 100719,
                        "name": "Podkletnoye",
                        "latitude": "51.58993000",
                        "longitude": "39.46230000"
                    },
                    {
                        "id": 100794,
                        "name": "Povorino",
                        "latitude": "51.19450000",
                        "longitude": "42.24570000"
                    },
                    {
                        "id": 100795,
                        "name": "Povorinskiy Rayon",
                        "latitude": "51.18333000",
                        "longitude": "42.20000000"
                    },
                    {
                        "id": 100818,
                        "name": "Pridonskoy",
                        "latitude": "51.68406000",
                        "longitude": "39.07270000"
                    },
                    {
                        "id": 100940,
                        "name": "Ramon’",
                        "latitude": "51.91569000",
                        "longitude": "39.33609000"
                    },
                    {
                        "id": 100939,
                        "name": "Ramonskiy Rayon",
                        "latitude": "51.91667000",
                        "longitude": "39.33333000"
                    },
                    {
                        "id": 100963,
                        "name": "Rep’yevskiy Rayon",
                        "latitude": "51.16667000",
                        "longitude": "38.66667000"
                    },
                    {
                        "id": 101004,
                        "name": "Rossosh’",
                        "latitude": "51.12090000",
                        "longitude": "38.51160000"
                    },
                    {
                        "id": 101003,
                        "name": "Rossoshanskiy Rayon",
                        "latitude": "50.16667000",
                        "longitude": "39.58333000"
                    },
                    {
                        "id": 101064,
                        "name": "Sadovoye",
                        "latitude": "51.53111000",
                        "longitude": "40.50194000"
                    },
                    {
                        "id": 101165,
                        "name": "Semiluki",
                        "latitude": "51.68525000",
                        "longitude": "39.02787000"
                    },
                    {
                        "id": 101166,
                        "name": "Semilukskiy Rayon",
                        "latitude": "51.66667000",
                        "longitude": "39.00000000"
                    },
                    {
                        "id": 101316,
                        "name": "Shilovo",
                        "latitude": "51.54583000",
                        "longitude": "39.08917000"
                    },
                    {
                        "id": 101407,
                        "name": "Sloboda",
                        "latitude": "51.14210000",
                        "longitude": "40.30210000"
                    },
                    {
                        "id": 101475,
                        "name": "Somovo",
                        "latitude": "51.74098000",
                        "longitude": "39.36655000"
                    },
                    {
                        "id": 101546,
                        "name": "Sredniy Ikorets",
                        "latitude": "51.06749000",
                        "longitude": "39.75838000"
                    },
                    {
                        "id": 101625,
                        "name": "Strelitsa",
                        "latitude": "51.60830000",
                        "longitude": "38.91020000"
                    },
                    {
                        "id": 101755,
                        "name": "Talovaya",
                        "latitude": "51.11444000",
                        "longitude": "40.73000000"
                    },
                    {
                        "id": 101834,
                        "name": "Ternovka",
                        "latitude": "51.67803000",
                        "longitude": "41.63750000"
                    },
                    {
                        "id": 101835,
                        "name": "Ternovskiy Rayon",
                        "latitude": "51.66667000",
                        "longitude": "41.25000000"
                    },
                    {
                        "id": 102039,
                        "name": "Uglyanets",
                        "latitude": "51.81908000",
                        "longitude": "39.59606000"
                    },
                    {
                        "id": 102093,
                        "name": "Uryv-Pokrovka",
                        "latitude": "51.11590000",
                        "longitude": "39.16394000"
                    },
                    {
                        "id": 102256,
                        "name": "Verkhniy Mamon",
                        "latitude": "50.16350000",
                        "longitude": "40.38320000"
                    },
                    {
                        "id": 102267,
                        "name": "Verkhnyaya Khava",
                        "latitude": "51.84045000",
                        "longitude": "39.94134000"
                    },
                    {
                        "id": 102273,
                        "name": "Verkhnyaya Tishanka",
                        "latitude": "51.32389000",
                        "longitude": "40.53278000"
                    },
                    {
                        "id": 102368,
                        "name": "Volya",
                        "latitude": "51.76510000",
                        "longitude": "39.54040000"
                    },
                    {
                        "id": 102378,
                        "name": "Vorob’yevskiy Rayon",
                        "latitude": "50.65000000",
                        "longitude": "40.93333000"
                    },
                    {
                        "id": 102380,
                        "name": "Voronezh",
                        "latitude": "51.67204000",
                        "longitude": "39.18430000"
                    },
                    {
                        "id": 102381,
                        "name": "Vorontsovka",
                        "latitude": "50.61320000",
                        "longitude": "40.35490000"
                    },
                    {
                        "id": 102535,
                        "name": "Yelan’-Koleno",
                        "latitude": "51.15230000",
                        "longitude": "41.23060000"
                    },
                    {
                        "id": 102536,
                        "name": "Yelan’-Kolenovskiy",
                        "latitude": "51.16320000",
                        "longitude": "41.15100000"
                    },
                    {
                        "id": 102625,
                        "name": "Zabolotovka",
                        "latitude": "50.27799000",
                        "longitude": "39.31439000"
                    },
                    {
                        "id": 102705,
                        "name": "Zemlyansk",
                        "latitude": "51.90410000",
                        "longitude": "38.73340000"
                    }
                ]
            },
            {
                "id": 1847,
                "name": "Yamalo-Nenets",
                "iso2": "YAN",
                "latitude": "66.06530570",
                "longitude": "76.93451930",
                "type": "autonomous district",
                "cities": [
                    {
                        "id": 97540,
                        "name": "Aksarka",
                        "latitude": "66.56056000",
                        "longitude": "67.79750000"
                    },
                    {
                        "id": 98604,
                        "name": "Gubkinskiy",
                        "latitude": "64.43400000",
                        "longitude": "76.50261000"
                    },
                    {
                        "id": 98968,
                        "name": "Kharp",
                        "latitude": "66.80139000",
                        "longitude": "65.80806000"
                    },
                    {
                        "id": 99216,
                        "name": "Korotchaevo",
                        "latitude": "65.91028000",
                        "longitude": "78.20917000"
                    },
                    {
                        "id": 99531,
                        "name": "Labytnangi",
                        "latitude": "66.65722000",
                        "longitude": "66.41833000"
                    },
                    {
                        "id": 100007,
                        "name": "Muravlenko",
                        "latitude": "63.78977000",
                        "longitude": "74.52301000"
                    },
                    {
                        "id": 100025,
                        "name": "Muzhi",
                        "latitude": "65.40030000",
                        "longitude": "64.70278000"
                    },
                    {
                        "id": 100029,
                        "name": "Mys-Kamennyy",
                        "latitude": "68.45972000",
                        "longitude": "73.59028000"
                    },
                    {
                        "id": 100043,
                        "name": "Nadym",
                        "latitude": "65.53333000",
                        "longitude": "72.51667000"
                    },
                    {
                        "id": 100044,
                        "name": "Nadymskiy Rayon",
                        "latitude": "66.00000000",
                        "longitude": "73.00000000"
                    },
                    {
                        "id": 100352,
                        "name": "Novyy Urengoy",
                        "latitude": "66.08333000",
                        "longitude": "76.63333000"
                    },
                    {
                        "id": 100364,
                        "name": "Noyabrsk",
                        "latitude": "63.19309000",
                        "longitude": "75.43728000"
                    },
                    {
                        "id": 100378,
                        "name": "Nyda",
                        "latitude": "66.62472000",
                        "longitude": "72.92278000"
                    },
                    {
                        "id": 100534,
                        "name": "Pangody",
                        "latitude": "65.85002000",
                        "longitude": "74.48593000"
                    },
                    {
                        "id": 100844,
                        "name": "Priural’skiy Rayon",
                        "latitude": "66.66667000",
                        "longitude": "67.66667000"
                    },
                    {
                        "id": 100892,
                        "name": "Purovskiy Rayon",
                        "latitude": "64.66667000",
                        "longitude": "78.00000000"
                    },
                    {
                        "id": 100893,
                        "name": "Purpe",
                        "latitude": "64.48028000",
                        "longitude": "76.68972000"
                    },
                    {
                        "id": 101079,
                        "name": "Salekhard",
                        "latitude": "66.53000000",
                        "longitude": "66.60194000"
                    },
                    {
                        "id": 101354,
                        "name": "Shuryshkarskiy Rayon",
                        "latitude": "65.33333000",
                        "longitude": "64.00000000"
                    },
                    {
                        "id": 101606,
                        "name": "Staryy Nadym",
                        "latitude": "65.61182000",
                        "longitude": "72.68417000"
                    },
                    {
                        "id": 101776,
                        "name": "Tarko-Sale",
                        "latitude": "64.91611000",
                        "longitude": "77.77457000"
                    },
                    {
                        "id": 101807,
                        "name": "Tazovskiy",
                        "latitude": "67.47150000",
                        "longitude": "78.71620000"
                    },
                    {
                        "id": 102075,
                        "name": "Urengoy",
                        "latitude": "65.96550000",
                        "longitude": "78.36929000"
                    },
                    {
                        "id": 102490,
                        "name": "Yar-Sale",
                        "latitude": "66.86540000",
                        "longitude": "70.83784000"
                    }
                ]
            },
            {
                "id": 1851,
                "name": "Yaroslavl",
                "iso2": "YAR",
                "latitude": "57.89915230",
                "longitude": "38.83886330",
                "type": "administrative region",
                "cities": [
                    {
                        "id": 97892,
                        "name": "Berendeyevo",
                        "latitude": "56.60078000",
                        "longitude": "39.02173000"
                    },
                    {
                        "id": 98006,
                        "name": "Bol’shesel’skiy Rayon",
                        "latitude": "57.66667000",
                        "longitude": "39.00000000"
                    },
                    {
                        "id": 98016,
                        "name": "Bol’shoye Selo",
                        "latitude": "57.71774000",
                        "longitude": "38.93341000"
                    },
                    {
                        "id": 98025,
                        "name": "Borisoglebskiy",
                        "latitude": "57.25860000",
                        "longitude": "39.15080000"
                    },
                    {
                        "id": 98026,
                        "name": "Borisoglebskiy Rayon",
                        "latitude": "57.33333000",
                        "longitude": "39.00000000"
                    },
                    {
                        "id": 98033,
                        "name": "Borok",
                        "latitude": "58.06532000",
                        "longitude": "38.23620000"
                    },
                    {
                        "id": 98055,
                        "name": "Breytovo",
                        "latitude": "58.29925000",
                        "longitude": "37.86172000"
                    },
                    {
                        "id": 98056,
                        "name": "Breytovskiy Rayon",
                        "latitude": "58.25000000",
                        "longitude": "37.75000000"
                    },
                    {
                        "id": 98084,
                        "name": "Burmakino",
                        "latitude": "57.41663000",
                        "longitude": "40.23687000"
                    },
                    {
                        "id": 98241,
                        "name": "Danilov",
                        "latitude": "58.19080000",
                        "longitude": "40.17171000"
                    },
                    {
                        "id": 98242,
                        "name": "Danilovskiy Rayon",
                        "latitude": "58.16667000",
                        "longitude": "40.08333000"
                    },
                    {
                        "id": 98336,
                        "name": "Dubki",
                        "latitude": "57.30000000",
                        "longitude": "40.25000000"
                    },
                    {
                        "id": 98462,
                        "name": "Gavrilov-Yam",
                        "latitude": "57.30185000",
                        "longitude": "39.85331000"
                    },
                    {
                        "id": 98463,
                        "name": "Gavrilov-Yamskiy Rayon",
                        "latitude": "57.33333000",
                        "longitude": "39.75000000"
                    },
                    {
                        "id": 98709,
                        "name": "Ishnya",
                        "latitude": "57.19070000",
                        "longitude": "39.36004000"
                    },
                    {
                        "id": 99192,
                        "name": "Konstantinovskiy",
                        "latitude": "57.83005000",
                        "longitude": "39.58989000"
                    },
                    {
                        "id": 99372,
                        "name": "Krasnyy Profintern",
                        "latitude": "57.74459000",
                        "longitude": "40.43501000"
                    },
                    {
                        "id": 99384,
                        "name": "Krasnyye Tkachi",
                        "latitude": "57.49259000",
                        "longitude": "39.75629000"
                    },
                    {
                        "id": 99427,
                        "name": "Kukoboy",
                        "latitude": "58.70089000",
                        "longitude": "39.91427000"
                    },
                    {
                        "id": 99455,
                        "name": "Kurba",
                        "latitude": "57.56097000",
                        "longitude": "39.49810000"
                    },
                    {
                        "id": 99611,
                        "name": "Levashevo",
                        "latitude": "57.64451000",
                        "longitude": "40.52401000"
                    },
                    {
                        "id": 99715,
                        "name": "Lyubim",
                        "latitude": "58.36250000",
                        "longitude": "40.68433000"
                    },
                    {
                        "id": 99716,
                        "name": "Lyubimskiy Rayon",
                        "latitude": "58.33333000",
                        "longitude": "40.75000000"
                    },
                    {
                        "id": 100030,
                        "name": "Myshkin",
                        "latitude": "57.78973000",
                        "longitude": "38.45448000"
                    },
                    {
                        "id": 100031,
                        "name": "Myshkinskiy Rayon",
                        "latitude": "57.83333000",
                        "longitude": "38.41667000"
                    },
                    {
                        "id": 100090,
                        "name": "Nekouzskiy Rayon",
                        "latitude": "58.00000000",
                        "longitude": "38.00000000"
                    },
                    {
                        "id": 100095,
                        "name": "Nekrasovskiy Rayon",
                        "latitude": "57.66667000",
                        "longitude": "40.41667000"
                    },
                    {
                        "id": 100096,
                        "name": "Nekrasovskoye",
                        "latitude": "57.67663000",
                        "longitude": "40.36567000"
                    },
                    {
                        "id": 100347,
                        "name": "Novyy Nekouz",
                        "latitude": "57.90286000",
                        "longitude": "38.07004000"
                    },
                    {
                        "id": 100604,
                        "name": "Pereslavl’-Zalesskiy",
                        "latitude": "56.73934000",
                        "longitude": "38.85626000"
                    },
                    {
                        "id": 100605,
                        "name": "Pereslavskiy Rayon",
                        "latitude": "56.75000000",
                        "longitude": "38.83333000"
                    },
                    {
                        "id": 100622,
                        "name": "Pervomayskiy Rayon",
                        "latitude": "58.66667000",
                        "longitude": "39.75000000"
                    },
                    {
                        "id": 100636,
                        "name": "Pesochnoye",
                        "latitude": "58.00597000",
                        "longitude": "39.17717000"
                    },
                    {
                        "id": 100659,
                        "name": "Petrovsk",
                        "latitude": "57.01039000",
                        "longitude": "39.26928000"
                    },
                    {
                        "id": 100774,
                        "name": "Porech’ye-Rybnoye",
                        "latitude": "57.09805000",
                        "longitude": "39.38354000"
                    },
                    {
                        "id": 100785,
                        "name": "Poshekhon’ye",
                        "latitude": "58.49928000",
                        "longitude": "39.13531000"
                    },
                    {
                        "id": 100784,
                        "name": "Poshekhonskiy Rayon",
                        "latitude": "58.66667000",
                        "longitude": "39.08333000"
                    },
                    {
                        "id": 100807,
                        "name": "Prechistoye",
                        "latitude": "58.42068000",
                        "longitude": "40.34017000"
                    },
                    {
                        "id": 101006,
                        "name": "Rostov",
                        "latitude": "57.19140000",
                        "longitude": "39.41394000"
                    },
                    {
                        "id": 101009,
                        "name": "Rostovskiy Rayon",
                        "latitude": "57.16667000",
                        "longitude": "39.50000000"
                    },
                    {
                        "id": 101048,
                        "name": "Rybinsk",
                        "latitude": "58.04460000",
                        "longitude": "38.84259000"
                    },
                    {
                        "id": 101049,
                        "name": "Rybinskiy Rayon",
                        "latitude": "58.00000000",
                        "longitude": "39.00000000"
                    },
                    {
                        "id": 101162,
                        "name": "Semibratovo",
                        "latitude": "57.30461000",
                        "longitude": "39.53688000"
                    },
                    {
                        "id": 101646,
                        "name": "Sudoverf’",
                        "latitude": "58.11696000",
                        "longitude": "38.64175000"
                    },
                    {
                        "id": 101971,
                        "name": "Tunoshna",
                        "latitude": "57.54589000",
                        "longitude": "40.12543000"
                    },
                    {
                        "id": 101984,
                        "name": "Tutayev",
                        "latitude": "57.88529000",
                        "longitude": "39.54060000"
                    },
                    {
                        "id": 101985,
                        "name": "Tutayevskiy Rayon",
                        "latitude": "57.91667000",
                        "longitude": "39.58333000"
                    },
                    {
                        "id": 102034,
                        "name": "Uglich",
                        "latitude": "57.52750000",
                        "longitude": "38.33167000"
                    },
                    {
                        "id": 102035,
                        "name": "Uglichskiy Rayon",
                        "latitude": "57.50000000",
                        "longitude": "38.41667000"
                    },
                    {
                        "id": 102342,
                        "name": "Volga",
                        "latitude": "57.95157000",
                        "longitude": "38.38785000"
                    },
                    {
                        "id": 102499,
                        "name": "Yaroslavl",
                        "latitude": "57.62987000",
                        "longitude": "39.87368000"
                    },
                    {
                        "id": 102503,
                        "name": "Yaroslavskiy Rayon",
                        "latitude": "57.58333000",
                        "longitude": "40.00000000"
                    }
                ]
            },
            {
                "id": 1904,
                "name": "Zabaykalsky",
                "iso2": "ZAB",
                "latitude": "53.09287710",
                "longitude": "116.96765610",
                "type": "administrative territory",
                "cities": [
                    {
                        "id": 97518,
                        "name": "Aginskoye",
                        "latitude": "51.10000000",
                        "longitude": "114.53000000"
                    },
                    {
                        "id": 97543,
                        "name": "Aksha",
                        "latitude": "50.28139000",
                        "longitude": "113.28667000"
                    },
                    {
                        "id": 97544,
                        "name": "Akshinskiy Rayon",
                        "latitude": "50.25000000",
                        "longitude": "113.25000000"
                    },
                    {
                        "id": 97567,
                        "name": "Aleksandrovo-Zavodskiy Rayon",
                        "latitude": "50.91667000",
                        "longitude": "117.95000000"
                    },
                    {
                        "id": 97573,
                        "name": "Aleksandrovskiy Zavod",
                        "latitude": "50.92525000",
                        "longitude": "117.93773000"
                    },
                    {
                        "id": 97611,
                        "name": "Amazar",
                        "latitude": "53.86033000",
                        "longitude": "120.87925000"
                    },
                    {
                        "id": 97707,
                        "name": "Atamanovka",
                        "latitude": "51.93333000",
                        "longitude": "113.63333000"
                    },
                    {
                        "id": 97750,
                        "name": "Bada",
                        "latitude": "51.39100000",
                        "longitude": "109.86145000"
                    },
                    {
                        "id": 97776,
                        "name": "Baley",
                        "latitude": "51.58166000",
                        "longitude": "116.63395000"
                    },
                    {
                        "id": 97777,
                        "name": "Baleyskiy Rayon",
                        "latitude": "51.50000000",
                        "longitude": "117.00000000"
                    },
                    {
                        "id": 97785,
                        "name": "Balyaga",
                        "latitude": "51.15293000",
                        "longitude": "108.92767000"
                    },
                    {
                        "id": 98001,
                        "name": "Bol’shaya Tura",
                        "latitude": "51.61642000",
                        "longitude": "114.11242000"
                    },
                    {
                        "id": 98044,
                        "name": "Borzinskiy Rayon",
                        "latitude": "50.16667000",
                        "longitude": "117.33333000"
                    },
                    {
                        "id": 98046,
                        "name": "Borzya",
                        "latitude": "50.38333000",
                        "longitude": "116.51667000"
                    },
                    {
                        "id": 98073,
                        "name": "Bukachacha",
                        "latitude": "52.98333000",
                        "longitude": "116.91667000"
                    },
                    {
                        "id": 98118,
                        "name": "Chara",
                        "latitude": "56.90639000",
                        "longitude": "118.26306000"
                    },
                    {
                        "id": 98180,
                        "name": "Chernyshevsk",
                        "latitude": "52.52209000",
                        "longitude": "117.01712000"
                    },
                    {
                        "id": 98204,
                        "name": "Chita",
                        "latitude": "52.03171000",
                        "longitude": "113.50087000"
                    },
                    {
                        "id": 98205,
                        "name": "Chitinskiy Rayon",
                        "latitude": "52.00000000",
                        "longitude": "113.50024000"
                    },
                    {
                        "id": 98246,
                        "name": "Darasun",
                        "latitude": "51.65940000",
                        "longitude": "113.97515000"
                    },
                    {
                        "id": 98248,
                        "name": "Dauriya",
                        "latitude": "49.93333000",
                        "longitude": "116.86667000"
                    },
                    {
                        "id": 98306,
                        "name": "Domna",
                        "latitude": "51.89712000",
                        "longitude": "113.15730000"
                    },
                    {
                        "id": 98326,
                        "name": "Drovyanaya",
                        "latitude": "51.57620000",
                        "longitude": "113.04078000"
                    },
                    {
                        "id": 98353,
                        "name": "Dul’durga",
                        "latitude": "50.67611000",
                        "longitude": "113.59306000"
                    },
                    {
                        "id": 98468,
                        "name": "Gazimuro-Zavodskiy Rayon",
                        "latitude": "51.55000000",
                        "longitude": "118.36667000"
                    },
                    {
                        "id": 98469,
                        "name": "Gazimurskiy Zavod",
                        "latitude": "51.55352000",
                        "longitude": "118.34460000"
                    },
                    {
                        "id": 98767,
                        "name": "Kadaya",
                        "latitude": "50.93254000",
                        "longitude": "119.29468000"
                    },
                    {
                        "id": 98780,
                        "name": "Kalanguy",
                        "latitude": "51.01667000",
                        "longitude": "116.51667000"
                    },
                    {
                        "id": 98783,
                        "name": "Kalga",
                        "latitude": "50.92538000",
                        "longitude": "118.89958000"
                    },
                    {
                        "id": 98889,
                        "name": "Karymskoye",
                        "latitude": "51.61667000",
                        "longitude": "114.35000000"
                    },
                    {
                        "id": 98979,
                        "name": "Khilok",
                        "latitude": "51.36777000",
                        "longitude": "110.46804000"
                    },
                    {
                        "id": 98991,
                        "name": "Kholbon",
                        "latitude": "51.88333000",
                        "longitude": "116.25000000"
                    },
                    {
                        "id": 99100,
                        "name": "Klichka",
                        "latitude": "50.44570000",
                        "longitude": "117.99600000"
                    },
                    {
                        "id": 99110,
                        "name": "Klyuchevskiy",
                        "latitude": "53.53360000",
                        "longitude": "119.45269000"
                    },
                    {
                        "id": 99135,
                        "name": "Kokuy",
                        "latitude": "52.20634000",
                        "longitude": "117.55412000"
                    },
                    {
                        "id": 99320,
                        "name": "Krasnokamensk",
                        "latitude": "50.09790000",
                        "longitude": "118.03690000"
                    },
                    {
                        "id": 99361,
                        "name": "Krasnyy Chikoy",
                        "latitude": "50.36321000",
                        "longitude": "108.75445000"
                    },
                    {
                        "id": 99412,
                        "name": "Kuanda",
                        "latitude": "56.31611000",
                        "longitude": "116.08056000"
                    },
                    {
                        "id": 99468,
                        "name": "Kurort-Darasun",
                        "latitude": "51.19905000",
                        "longitude": "113.71599000"
                    },
                    {
                        "id": 99518,
                        "name": "Kyra",
                        "latitude": "49.57903000",
                        "longitude": "111.97638000"
                    },
                    {
                        "id": 99745,
                        "name": "Makkaveyevo",
                        "latitude": "51.75325000",
                        "longitude": "113.94540000"
                    },
                    {
                        "id": 99939,
                        "name": "Mogocha",
                        "latitude": "53.73417000",
                        "longitude": "119.76515000"
                    },
                    {
                        "id": 99940,
                        "name": "Mogoytuy",
                        "latitude": "51.28333000",
                        "longitude": "114.91667000"
                    },
                    {
                        "id": 99941,
                        "name": "Mogzon",
                        "latitude": "51.74060000",
                        "longitude": "111.96555000"
                    },
                    {
                        "id": 100104,
                        "name": "Nerchinsk",
                        "latitude": "51.98333000",
                        "longitude": "116.58333000"
                    },
                    {
                        "id": 100105,
                        "name": "Nerchinskiy Zavod",
                        "latitude": "51.30829000",
                        "longitude": "119.61597000"
                    },
                    {
                        "id": 100106,
                        "name": "Nerchinsko-Zavodskiy Rayon",
                        "latitude": "51.31667000",
                        "longitude": "119.60000000"
                    },
                    {
                        "id": 100176,
                        "name": "Nizhniy Tsasuchey",
                        "latitude": "50.51667000",
                        "longitude": "115.13333000"
                    },
                    {
                        "id": 100201,
                        "name": "Novaya Chara",
                        "latitude": "56.81639000",
                        "longitude": "118.29861000"
                    },
                    {
                        "id": 100253,
                        "name": "Novokruchininskiy",
                        "latitude": "51.78360000",
                        "longitude": "113.77591000"
                    },
                    {
                        "id": 100273,
                        "name": "Novoorlovsk",
                        "latitude": "51.07549000",
                        "longitude": "114.72610000"
                    },
                    {
                        "id": 100277,
                        "name": "Novopavlovka",
                        "latitude": "51.21724000",
                        "longitude": "109.21305000"
                    },
                    {
                        "id": 100425,
                        "name": "Olovyannaya",
                        "latitude": "50.95000000",
                        "longitude": "115.56667000"
                    },
                    {
                        "id": 100426,
                        "name": "Olovyanninskiy Rayon",
                        "latitude": "51.00000000",
                        "longitude": "116.16667000"
                    },
                    {
                        "id": 100474,
                        "name": "Orlovskiy",
                        "latitude": "51.03333000",
                        "longitude": "114.83333000"
                    },
                    {
                        "id": 100621,
                        "name": "Pervomayskiy",
                        "latitude": "51.67013000",
                        "longitude": "115.62543000"
                    },
                    {
                        "id": 100660,
                        "name": "Petrovsk-Zabaykal’skiy",
                        "latitude": "51.27530000",
                        "longitude": "108.84301000"
                    },
                    {
                        "id": 100814,
                        "name": "Priargunsk",
                        "latitude": "50.36910000",
                        "longitude": "119.10120000"
                    },
                    {
                        "id": 100815,
                        "name": "Priargunskiy Rayon",
                        "latitude": "50.75000000",
                        "longitude": "118.50000000"
                    },
                    {
                        "id": 100823,
                        "name": "Priiskovyy",
                        "latitude": "51.93333000",
                        "longitude": "116.63333000"
                    },
                    {
                        "id": 101293,
                        "name": "Shelopugino",
                        "latitude": "51.65286000",
                        "longitude": "117.56303000"
                    },
                    {
                        "id": 101313,
                        "name": "Shilka",
                        "latitude": "51.85000000",
                        "longitude": "116.03333000"
                    },
                    {
                        "id": 101314,
                        "name": "Shilkinskiy Rayon",
                        "latitude": "52.00000000",
                        "longitude": "115.66667000"
                    },
                    {
                        "id": 101414,
                        "name": "Smolenka",
                        "latitude": "52.13523000",
                        "longitude": "113.49740000"
                    },
                    {
                        "id": 101548,
                        "name": "Sretensk",
                        "latitude": "52.24780000",
                        "longitude": "117.70835000"
                    },
                    {
                        "id": 101549,
                        "name": "Sretenskiy Rayon",
                        "latitude": "52.33333000",
                        "longitude": "117.83333000"
                    },
                    {
                        "id": 101771,
                        "name": "Tarbagatay",
                        "latitude": "51.17559000",
                        "longitude": "109.09484000"
                    },
                    {
                        "id": 102045,
                        "name": "Uletovskiy Rayon",
                        "latitude": "51.00000000",
                        "longitude": "112.00000000"
                    },
                    {
                        "id": 102046,
                        "name": "Ulety",
                        "latitude": "51.35589000",
                        "longitude": "112.48430000"
                    },
                    {
                        "id": 102128,
                        "name": "Ust’-Karsk",
                        "latitude": "52.70206000",
                        "longitude": "118.80163000"
                    },
                    {
                        "id": 102235,
                        "name": "Verkh-Usugli",
                        "latitude": "52.70000000",
                        "longitude": "115.16667000"
                    },
                    {
                        "id": 102285,
                        "name": "Vershino-Darasunskiy",
                        "latitude": "52.36604000",
                        "longitude": "115.52661000"
                    },
                    {
                        "id": 102286,
                        "name": "Vershino-Shakhtaminskiy",
                        "latitude": "51.30024000",
                        "longitude": "117.88762000"
                    },
                    {
                        "id": 102624,
                        "name": "Zabaykal’sk",
                        "latitude": "49.65130000",
                        "longitude": "117.32557000"
                    },
                    {
                        "id": 102733,
                        "name": "Zhireken",
                        "latitude": "52.82657000",
                        "longitude": "117.30725000"
                    }
                ]
            }
        ]
    },
    {
        "id": 183,
        "name": "Rwanda",
        "iso3": "RWA",
        "iso2": "RW",
        "numeric_code": "646",
        "phonecode": "250",
        "capital": "Kigali",
        "currency": "RWF",
        "currency_name": "Rwandan franc",
        "currency_symbol": "FRw",
        "tld": ".rw",
        "native": "Rwanda",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Rwandan",
        "timezones": [
            {
                "zoneName": "Africa\/Kigali",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "br": "Rwanda",
            "ko": "르완다",
            "pt-BR": "Ruanda",
            "pt": "Ruanda",
            "nl": "Rwanda",
            "hr": "Ruanda",
            "fa": "رواندا",
            "de": "Ruanda",
            "es": "Ruanda",
            "fr": "Rwanda",
            "ja": "ルワンダ",
            "it": "Ruanda",
            "zh-CN": "卢旺达",
            "tr": "Ruanda",
            "ru": "Руанда",
            "uk": "Руанда",
            "pl": "Rwanda"
        },
        "latitude": "-2.00000000",
        "longitude": "30.00000000",
        "emoji": "🇷🇼",
        "emojiU": "U+1F1F7 U+1F1FC",
        "states": [
            {
                "id": 261,
                "name": "Eastern",
                "iso2": "02",
                "latitude": "-1.74244510",
                "longitude": "29.76886980",
                "type": "province",
                "cities": [
                    {
                        "id": 102798,
                        "name": "Kibungo",
                        "latitude": "-2.15970000",
                        "longitude": "30.54270000"
                    },
                    {
                        "id": 102803,
                        "name": "Rwamagana",
                        "latitude": "-1.94870000",
                        "longitude": "30.43470000"
                    }
                ]
            },
            {
                "id": 262,
                "name": "Kigali",
                "iso2": "01",
                "latitude": "-1.92976260",
                "longitude": "29.96243320",
                "type": "city",
                "cities": [
                    {
                        "id": 102800,
                        "name": "Kigali",
                        "latitude": "-1.94995000",
                        "longitude": "30.05885000"
                    }
                ]
            },
            {
                "id": 263,
                "name": "Northern",
                "iso2": "03",
                "latitude": "-1.61085290",
                "longitude": "29.53320660",
                "type": "province",
                "cities": [
                    {
                        "id": 102793,
                        "name": "Byumba",
                        "latitude": "-1.57630000",
                        "longitude": "30.06750000"
                    },
                    {
                        "id": 102801,
                        "name": "Musanze",
                        "latitude": "-1.49984000",
                        "longitude": "29.63497000"
                    }
                ]
            },
            {
                "id": 259,
                "name": "Southern",
                "iso2": "05",
                "latitude": "-2.28552020",
                "longitude": "29.31307560",
                "type": "province",
                "cities": [
                    {
                        "id": 102792,
                        "name": "Butare",
                        "latitude": "-2.59667000",
                        "longitude": "29.73944000"
                    },
                    {
                        "id": 102795,
                        "name": "Eglise Catholique Centrale GIKO",
                        "latitude": "-1.93653000",
                        "longitude": "29.80610000"
                    },
                    {
                        "id": 102797,
                        "name": "Gitarama",
                        "latitude": "-2.07444000",
                        "longitude": "29.75667000"
                    },
                    {
                        "id": 102802,
                        "name": "Nzega",
                        "latitude": "-2.47900000",
                        "longitude": "29.55640000"
                    }
                ]
            },
            {
                "id": 260,
                "name": "Western",
                "iso2": "04",
                "latitude": "-2.12500570",
                "longitude": "28.60901170",
                "type": "province",
                "cities": [
                    {
                        "id": 102794,
                        "name": "Cyangugu",
                        "latitude": "-2.48460000",
                        "longitude": "28.90750000"
                    },
                    {
                        "id": 102796,
                        "name": "Gisenyi",
                        "latitude": "-1.70278000",
                        "longitude": "29.25639000"
                    },
                    {
                        "id": 102799,
                        "name": "Kibuye",
                        "latitude": "-2.06028000",
                        "longitude": "29.34778000"
                    }
                ]
            }
        ]
    },
    {
        "id": 184,
        "name": "Saint Helena",
        "iso3": "SHN",
        "iso2": "SH",
        "numeric_code": "654",
        "phonecode": "290",
        "capital": "Jamestown",
        "currency": "SHP",
        "currency_name": "Saint Helena pound",
        "currency_symbol": "£",
        "tld": ".sh",
        "native": "Saint Helena",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Saint Helenian",
        "timezones": [
            {
                "zoneName": "Atlantic\/St_Helena",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Saint Helena, Ascension ha Tristan da Cunha",
            "ko": "세인트헬레나",
            "pt-BR": "Santa Helena",
            "pt": "Santa Helena",
            "nl": "Sint-Helena",
            "hr": "Sveta Helena",
            "fa": "سنت هلنا، اسنشن و تریستان دا کونا",
            "de": "Sankt Helena",
            "es": "Santa Helena",
            "fr": "Sainte-Hélène",
            "ja": "セントヘレナ・アセンションおよびトリスタンダクーニャ",
            "it": "Sant'Elena",
            "zh-CN": "圣赫勒拿",
            "tr": "Saint Helena",
            "ru": "Святая Елена",
            "uk": "Свята Єлена",
            "pl": "Święta Helena"
        },
        "latitude": "-15.95000000",
        "longitude": "-5.70000000",
        "emoji": "🇸🇭",
        "emojiU": "U+1F1F8 U+1F1ED",
        "states": [
            {
                "id": 5440,
                "name": "Alarm Forest",
                "iso2": "01",
                "latitude": "-15.94671440",
                "longitude": "-5.72447520",
                "type": "district",
                "cities": []
            },
            {
                "id": 5441,
                "name": "Blue Hill",
                "iso2": "02",
                "latitude": "-15.98354720",
                "longitude": "-5.79656520",
                "type": "district",
                "cities": []
            },
            {
                "id": 5442,
                "name": "Half Tree Hollow",
                "iso2": "03",
                "latitude": "-15.93468450",
                "longitude": "-5.73134770",
                "type": "district",
                "cities": []
            },
            {
                "id": 5443,
                "name": "Jamestown",
                "iso2": "04",
                "latitude": "-15.92883080",
                "longitude": "-5.72033380",
                "type": "district",
                "cities": []
            },
            {
                "id": 5444,
                "name": "Levelwood",
                "iso2": "05",
                "latitude": "-15.97475430",
                "longitude": "-5.70960800",
                "type": "district",
                "cities": []
            },
            {
                "id": 5445,
                "name": "Longwood",
                "iso2": "06",
                "latitude": "-15.94458630",
                "longitude": "-5.69502720",
                "type": "district",
                "cities": []
            },
            {
                "id": 5447,
                "name": "Saint Paul's",
                "iso2": "08",
                "latitude": "-15.98695810",
                "longitude": "-5.78096580",
                "type": "district",
                "cities": []
            },
            {
                "id": 5446,
                "name": "Sandy Bay",
                "iso2": "07",
                "latitude": "-15.99187410",
                "longitude": "-5.73991510",
                "type": "district",
                "cities": []
            }
        ]
    },
    {
        "id": 185,
        "name": "Saint Kitts and Nevis",
        "iso3": "KNA",
        "iso2": "KN",
        "numeric_code": "659",
        "phonecode": "1",
        "capital": "Basseterre",
        "currency": "XCD",
        "currency_name": "Eastern Caribbean dollar",
        "currency_symbol": "$",
        "tld": ".kn",
        "native": "Saint Kitts and Nevis",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Kittitian or Nevisian",
        "timezones": [
            {
                "zoneName": "America\/St_Kitts",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Saint Kitts ha Nevis",
            "ko": "세인트키츠 네비스",
            "pt-BR": "São Cristóvão e Neves",
            "pt": "São Cristóvão e Neves",
            "nl": "Saint Kitts en Nevis",
            "hr": "Sveti Kristof i Nevis",
            "fa": "سنت کیتس و نویس",
            "de": "St. Kitts und Nevis",
            "es": "San Cristóbal y Nieves",
            "fr": "Saint-Christophe-et-Niévès",
            "ja": "セントクリストファー・ネイビス",
            "it": "Saint Kitts e Nevis",
            "zh-CN": "圣基茨和尼维斯",
            "tr": "Saint Kitts Ve Nevis",
            "ru": "Сент-Китс и Невис",
            "uk": "Сент-Кітс і Невіс",
            "pl": "Saint Kitts i Nevis"
        },
        "latitude": "17.33333333",
        "longitude": "-62.75000000",
        "emoji": "🇰🇳",
        "emojiU": "U+1F1F0 U+1F1F3",
        "states": [
            {
                "id": 3833,
                "name": "Christ Church Nichola Town",
                "iso2": "01",
                "latitude": "17.36048120",
                "longitude": "-62.76178370",
                "type": "parish",
                "cities": [
                    {
                        "id": 65176,
                        "name": "Nicola Town",
                        "latitude": "17.37956000",
                        "longitude": "-62.75318000"
                    }
                ]
            },
            {
                "id": 3832,
                "name": "Nevis",
                "iso2": "N",
                "latitude": "17.15535580",
                "longitude": "-62.57960260",
                "type": "state",
                "cities": []
            },
            {
                "id": 3836,
                "name": "Saint Anne Sandy Point",
                "iso2": "02",
                "latitude": "17.37253330",
                "longitude": "-62.84411330",
                "type": "parish",
                "cities": [
                    {
                        "id": 65178,
                        "name": "Sandy Point Town",
                        "latitude": "17.35908000",
                        "longitude": "-62.84858000"
                    }
                ]
            },
            {
                "id": 5348,
                "name": "Saint George Basseterre",
                "iso2": "03",
                "latitude": "17.26710110",
                "longitude": "-62.76930010",
                "type": "parish",
                "cities": []
            },
            {
                "id": 3837,
                "name": "Saint George Gingerland",
                "iso2": "04",
                "latitude": "17.12577590",
                "longitude": "-62.56198110",
                "type": "parish",
                "cities": [
                    {
                        "id": 65172,
                        "name": "Market Shop",
                        "latitude": "17.13218000",
                        "longitude": "-62.57267000"
                    }
                ]
            },
            {
                "id": 3835,
                "name": "Saint James Windward",
                "iso2": "05",
                "latitude": "17.17696330",
                "longitude": "-62.57960260",
                "type": "parish",
                "cities": [
                    {
                        "id": 65175,
                        "name": "Newcastle",
                        "latitude": "17.20000000",
                        "longitude": "-62.58333000"
                    }
                ]
            },
            {
                "id": 3845,
                "name": "Saint John Capisterre",
                "iso2": "06",
                "latitude": "17.38103410",
                "longitude": "-62.79118330",
                "type": "parish",
                "cities": [
                    {
                        "id": 65170,
                        "name": "Dieppe Bay Town",
                        "latitude": "17.41473000",
                        "longitude": "-62.81390000"
                    }
                ]
            },
            {
                "id": 3840,
                "name": "Saint John Figtree",
                "iso2": "07",
                "latitude": "17.11557480",
                "longitude": "-62.60310040",
                "type": "parish",
                "cities": [
                    {
                        "id": 65171,
                        "name": "Fig Tree",
                        "latitude": "17.12623000",
                        "longitude": "-62.60265000"
                    }
                ]
            },
            {
                "id": 3841,
                "name": "Saint Kitts",
                "iso2": "K",
                "latitude": "17.34337960",
                "longitude": "-62.75590430",
                "type": "state",
                "cities": []
            },
            {
                "id": 3844,
                "name": "Saint Mary Cayon",
                "iso2": "08",
                "latitude": "17.34620710",
                "longitude": "-62.73826710",
                "type": "parish",
                "cities": [
                    {
                        "id": 65167,
                        "name": "Cayon",
                        "latitude": "17.35000000",
                        "longitude": "-62.73333000"
                    }
                ]
            },
            {
                "id": 3834,
                "name": "Saint Paul Capisterre",
                "iso2": "09",
                "latitude": "17.40166830",
                "longitude": "-62.82573320",
                "type": "parish",
                "cities": [
                    {
                        "id": 65177,
                        "name": "Saint Paul’s",
                        "latitude": "17.40605000",
                        "longitude": "-62.83562000"
                    }
                ]
            },
            {
                "id": 3838,
                "name": "Saint Paul Charlestown",
                "iso2": "10",
                "latitude": "17.13462970",
                "longitude": "-62.61338160",
                "type": "parish",
                "cities": [
                    {
                        "id": 65168,
                        "name": "Charlestown",
                        "latitude": "17.13333000",
                        "longitude": "-62.61667000"
                    }
                ]
            },
            {
                "id": 3831,
                "name": "Saint Peter Basseterre",
                "iso2": "11",
                "latitude": "17.31029110",
                "longitude": "-62.71475330",
                "type": "parish",
                "cities": [
                    {
                        "id": 65174,
                        "name": "Monkey Hill",
                        "latitude": "17.32327000",
                        "longitude": "-62.72914000"
                    }
                ]
            },
            {
                "id": 3839,
                "name": "Saint Thomas Lowland",
                "iso2": "12",
                "latitude": "17.16505130",
                "longitude": "-62.60897530",
                "type": "parish",
                "cities": [
                    {
                        "id": 65169,
                        "name": "Cotton Ground",
                        "latitude": "17.16667000",
                        "longitude": "-62.61667000"
                    }
                ]
            },
            {
                "id": 3842,
                "name": "Saint Thomas Middle Island",
                "iso2": "13",
                "latitude": "17.33488130",
                "longitude": "-62.80882510",
                "type": "parish",
                "cities": [
                    {
                        "id": 65173,
                        "name": "Middle Island",
                        "latitude": "17.32590000",
                        "longitude": "-62.81055000"
                    }
                ]
            },
            {
                "id": 3843,
                "name": "Trinity Palmetto Point",
                "iso2": "15",
                "latitude": "17.30635190",
                "longitude": "-62.76178370",
                "type": "parish",
                "cities": [
                    {
                        "id": 65179,
                        "name": "Trinity",
                        "latitude": "17.30037000",
                        "longitude": "-62.77584000"
                    }
                ]
            }
        ]
    },
    {
        "id": 186,
        "name": "Saint Lucia",
        "iso3": "LCA",
        "iso2": "LC",
        "numeric_code": "662",
        "phonecode": "1",
        "capital": "Castries",
        "currency": "XCD",
        "currency_name": "Eastern Caribbean dollar",
        "currency_symbol": "$",
        "tld": ".lc",
        "native": "Saint Lucia",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Saint Lucian",
        "timezones": [
            {
                "zoneName": "America\/St_Lucia",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Santez-Lusia",
            "ko": "세인트루시아",
            "pt-BR": "Santa Lúcia",
            "pt": "Santa Lúcia",
            "nl": "Saint Lucia",
            "hr": "Sveta Lucija",
            "fa": "سنت لوسیا",
            "de": "Saint Lucia",
            "es": "Santa Lucía",
            "fr": "Saint-Lucie",
            "ja": "セントルシア",
            "it": "Santa Lucia",
            "zh-CN": "圣卢西亚",
            "tr": "Saint Lucia",
            "ru": "Сент-Люсия",
            "uk": "Сент-Люсія",
            "pl": "Saint Lucia"
        },
        "latitude": "13.88333333",
        "longitude": "-60.96666666",
        "emoji": "🇱🇨",
        "emojiU": "U+1F1F1 U+1F1E8",
        "states": [
            {
                "id": 3757,
                "name": "Anse la Raye",
                "iso2": "01",
                "latitude": "13.94594240",
                "longitude": "-61.03694680",
                "type": "district",
                "cities": [
                    {
                        "id": 65965,
                        "name": "Anse La Raye",
                        "latitude": "13.94619000",
                        "longitude": "-61.03879000"
                    },
                    {
                        "id": 65969,
                        "name": "Au Tabor",
                        "latitude": "13.94540000",
                        "longitude": "-61.04112000"
                    },
                    {
                        "id": 65970,
                        "name": "Au Tabor Hill",
                        "latitude": "13.94457000",
                        "longitude": "-61.03559000"
                    },
                    {
                        "id": 66019,
                        "name": "Bois D'Inde",
                        "latitude": "13.94148000",
                        "longitude": "-61.00966000"
                    },
                    {
                        "id": 66037,
                        "name": "Caico\/Millet",
                        "latitude": "13.91948000",
                        "longitude": "-60.99264000"
                    },
                    {
                        "id": 66040,
                        "name": "Canaries",
                        "latitude": "13.90224000",
                        "longitude": "-61.06459000"
                    },
                    {
                        "id": 66064,
                        "name": "Champen Estate",
                        "latitude": "13.93575000",
                        "longitude": "-61.02991000"
                    },
                    {
                        "id": 66112,
                        "name": "Derriere Lagoon",
                        "latitude": "13.94168000",
                        "longitude": "-61.01891000"
                    },
                    {
                        "id": 66128,
                        "name": "Durandeau",
                        "latitude": "13.92277000",
                        "longitude": "-60.99512000"
                    },
                    {
                        "id": 66132,
                        "name": "Enbar Pwin",
                        "latitude": "13.91175000",
                        "longitude": "-60.99266000"
                    },
                    {
                        "id": 66198,
                        "name": "Jacmel",
                        "latitude": "13.94796000",
                        "longitude": "-61.01297000"
                    },
                    {
                        "id": 66200,
                        "name": "Jean Baptiste",
                        "latitude": "13.94704000",
                        "longitude": "-61.01578000"
                    },
                    {
                        "id": 66231,
                        "name": "La Trielle",
                        "latitude": "13.94014000",
                        "longitude": "-60.99729000"
                    },
                    {
                        "id": 66260,
                        "name": "Massacre",
                        "latitude": "13.94872000",
                        "longitude": "-61.03544000"
                    },
                    {
                        "id": 66266,
                        "name": "Millet",
                        "latitude": "13.90985000",
                        "longitude": "-60.98884000"
                    },
                    {
                        "id": 66294,
                        "name": "Morne Ciseaux",
                        "latitude": "13.93597000",
                        "longitude": "-61.00330000"
                    },
                    {
                        "id": 66296,
                        "name": "Morne D'Or",
                        "latitude": "13.94931000",
                        "longitude": "-61.00601000"
                    },
                    {
                        "id": 66365,
                        "name": "Roseau Valley",
                        "latitude": "13.95317000",
                        "longitude": "-61.02676000"
                    },
                    {
                        "id": 66381,
                        "name": "St Lawrence",
                        "latitude": "13.93852000",
                        "longitude": "-61.02503000"
                    },
                    {
                        "id": 66382,
                        "name": "St Lawrence Estate",
                        "latitude": "13.94236000",
                        "longitude": "-61.04248000"
                    },
                    {
                        "id": 66392,
                        "name": "Tete Chemin",
                        "latitude": "13.89092000",
                        "longitude": "-60.99785000"
                    },
                    {
                        "id": 66416,
                        "name": "Vanard",
                        "latitude": "13.93558000",
                        "longitude": "-60.99363000"
                    },
                    {
                        "id": 66417,
                        "name": "Venus",
                        "latitude": "13.91558000",
                        "longitude": "-61.01676000"
                    },
                    {
                        "id": 66427,
                        "name": "Village",
                        "latitude": "13.93939000",
                        "longitude": "-61.04150000"
                    },
                    {
                        "id": 66429,
                        "name": "Village\/Petite Bourgh",
                        "latitude": "13.93801000",
                        "longitude": "-61.04184000"
                    }
                ]
            },
            {
                "id": 3761,
                "name": "Canaries",
                "iso2": "12",
                "latitude": "13.90400240",
                "longitude": "-61.07187140",
                "type": "district",
                "cities": [
                    {
                        "id": 65962,
                        "name": "Anse Cochon",
                        "latitude": "13.92261000",
                        "longitude": "-61.05250000"
                    },
                    {
                        "id": 65963,
                        "name": "Anse Galet",
                        "latitude": "13.93221000",
                        "longitude": "-61.04290000"
                    },
                    {
                        "id": 65966,
                        "name": "Anse La Verdue",
                        "latitude": "13.90964000",
                        "longitude": "-61.04755000"
                    },
                    {
                        "id": 66006,
                        "name": "Belvedere",
                        "latitude": "13.89122000",
                        "longitude": "-61.05550000"
                    },
                    {
                        "id": 66063,
                        "name": "Chalon",
                        "latitude": "13.92018000",
                        "longitude": "-61.04412000"
                    },
                    {
                        "id": 66359,
                        "name": "Riverside Road",
                        "latitude": "13.89408000",
                        "longitude": "-61.04989000"
                    },
                    {
                        "id": 66397,
                        "name": "Theodrine",
                        "latitude": "13.92878000",
                        "longitude": "-61.04972000"
                    },
                    {
                        "id": 66428,
                        "name": "Village",
                        "latitude": "13.90526000",
                        "longitude": "-61.06108000"
                    }
                ]
            },
            {
                "id": 3758,
                "name": "Castries",
                "iso2": "02",
                "latitude": "14.01010940",
                "longitude": "-60.98746870",
                "type": "district",
                "cities": [
                    {
                        "id": 65956,
                        "name": "Active Hill",
                        "latitude": "14.01940000",
                        "longitude": "-60.97767000"
                    },
                    {
                        "id": 65957,
                        "name": "Agard Lands\/Morne Dudon",
                        "latitude": "14.00768000",
                        "longitude": "-60.96462000"
                    },
                    {
                        "id": 65958,
                        "name": "Almondale",
                        "latitude": "14.01848000",
                        "longitude": "-60.96162000"
                    },
                    {
                        "id": 65972,
                        "name": "Aurendel Hill",
                        "latitude": "14.00069000",
                        "longitude": "-60.98670000"
                    },
                    {
                        "id": 65973,
                        "name": "Babonneau Proper",
                        "latitude": "14.00535000",
                        "longitude": "-60.94640000"
                    },
                    {
                        "id": 65974,
                        "name": "Bagatelle",
                        "latitude": "13.99797000",
                        "longitude": "-60.98156000"
                    },
                    {
                        "id": 65975,
                        "name": "Balata",
                        "latitude": "14.01471000",
                        "longitude": "-60.95167000"
                    },
                    {
                        "id": 65979,
                        "name": "Banannes Bay",
                        "latitude": "14.01087000",
                        "longitude": "-61.00135000"
                    },
                    {
                        "id": 65983,
                        "name": "Barnard Hill",
                        "latitude": "14.01423000",
                        "longitude": "-60.98924000"
                    },
                    {
                        "id": 65985,
                        "name": "Barre Denis",
                        "latitude": "13.96809000",
                        "longitude": "-60.99073000"
                    },
                    {
                        "id": 65986,
                        "name": "Barre Duchaussee",
                        "latitude": "13.96190000",
                        "longitude": "-60.99678000"
                    },
                    {
                        "id": 65987,
                        "name": "Barre St.Joseph",
                        "latitude": "13.97247000",
                        "longitude": "-61.01829000"
                    },
                    {
                        "id": 65996,
                        "name": "Belair",
                        "latitude": "13.95283000",
                        "longitude": "-60.99747000"
                    },
                    {
                        "id": 65998,
                        "name": "Bella Rosa",
                        "latitude": "14.00777000",
                        "longitude": "-60.99628000"
                    },
                    {
                        "id": 66008,
                        "name": "Bexon",
                        "latitude": "13.96077000",
                        "longitude": "-60.97497000"
                    },
                    {
                        "id": 66009,
                        "name": "Bisee",
                        "latitude": "14.02429000",
                        "longitude": "-60.97445000"
                    },
                    {
                        "id": 66010,
                        "name": "Bishop'S Gap",
                        "latitude": "14.00019000",
                        "longitude": "-60.98498000"
                    },
                    {
                        "id": 66011,
                        "name": "Bissee",
                        "latitude": "14.02255000",
                        "longitude": "-60.97489000"
                    },
                    {
                        "id": 66013,
                        "name": "Black Mallet",
                        "latitude": "14.00457000",
                        "longitude": "-60.98811000"
                    },
                    {
                        "id": 66015,
                        "name": "Bocage",
                        "latitude": "14.00199000",
                        "longitude": "-60.96954000"
                    },
                    {
                        "id": 66018,
                        "name": "Bois Catchet",
                        "latitude": "14.00399000",
                        "longitude": "-60.99437000"
                    },
                    {
                        "id": 66025,
                        "name": "Bois Patat",
                        "latitude": "14.00892000",
                        "longitude": "-60.98214000"
                    },
                    {
                        "id": 66033,
                        "name": "Cabiche\/Babonneau",
                        "latitude": "14.00583000",
                        "longitude": "-60.95432000"
                    },
                    {
                        "id": 66035,
                        "name": "Cacoa\/Babonneau",
                        "latitude": "13.98875000",
                        "longitude": "-60.95113000"
                    },
                    {
                        "id": 66038,
                        "name": "Calvary",
                        "latitude": "14.01391000",
                        "longitude": "-60.98664000"
                    },
                    {
                        "id": 66052,
                        "name": "Capital Hill",
                        "latitude": "13.99307000",
                        "longitude": "-60.99097000"
                    },
                    {
                        "id": 66053,
                        "name": "Carellie",
                        "latitude": "14.01889000",
                        "longitude": "-60.96851000"
                    },
                    {
                        "id": 66056,
                        "name": "Castries",
                        "latitude": "13.99570000",
                        "longitude": "-61.00614000"
                    },
                    {
                        "id": 66060,
                        "name": "Cedars",
                        "latitude": "14.00601000",
                        "longitude": "-60.98232000"
                    },
                    {
                        "id": 66065,
                        "name": "Chase Gardens",
                        "latitude": "14.01481000",
                        "longitude": "-60.97395000"
                    },
                    {
                        "id": 66066,
                        "name": "Chassin\/Babonneau",
                        "latitude": "13.99100000",
                        "longitude": "-60.92187000"
                    },
                    {
                        "id": 66070,
                        "name": "Choppin Ridge\/Sarot",
                        "latitude": "13.95597000",
                        "longitude": "-60.98624000"
                    },
                    {
                        "id": 66072,
                        "name": "Ciceron",
                        "latitude": "13.99296000",
                        "longitude": "-61.00878000"
                    },
                    {
                        "id": 66073,
                        "name": "City",
                        "latitude": "14.00946000",
                        "longitude": "-60.99027000"
                    },
                    {
                        "id": 66074,
                        "name": "City Gate\/La Clery",
                        "latitude": "14.02124000",
                        "longitude": "-60.98149000"
                    },
                    {
                        "id": 66078,
                        "name": "Conway\/Waterfront",
                        "latitude": "14.01389000",
                        "longitude": "-60.99055000"
                    },
                    {
                        "id": 66080,
                        "name": "Coolie Town",
                        "latitude": "13.95684000",
                        "longitude": "-61.01437000"
                    },
                    {
                        "id": 66085,
                        "name": "Coubaril",
                        "latitude": "14.00223000",
                        "longitude": "-61.00919000"
                    },
                    {
                        "id": 66087,
                        "name": "Crownlands\/Marc",
                        "latitude": "13.95174000",
                        "longitude": "-60.97150000"
                    },
                    {
                        "id": 66088,
                        "name": "Cul De Sac",
                        "latitude": "13.98084000",
                        "longitude": "-61.00645000"
                    },
                    {
                        "id": 66091,
                        "name": "Darling Road",
                        "latitude": "14.01355000",
                        "longitude": "-60.98779000"
                    },
                    {
                        "id": 66095,
                        "name": "Deglos",
                        "latitude": "13.97727000",
                        "longitude": "-60.97329000"
                    },
                    {
                        "id": 66106,
                        "name": "Derierre Fort\/Old Victoria Road",
                        "latitude": "13.99474000",
                        "longitude": "-60.98513000"
                    },
                    {
                        "id": 66124,
                        "name": "Dubrassay",
                        "latitude": "13.98382000",
                        "longitude": "-60.97154000"
                    },
                    {
                        "id": 66131,
                        "name": "En Pois Doux\/Babonneau",
                        "latitude": "13.98853000",
                        "longitude": "-60.94099000"
                    },
                    {
                        "id": 66133,
                        "name": "Entrepot",
                        "latitude": "13.99978000",
                        "longitude": "-60.97953000"
                    },
                    {
                        "id": 66139,
                        "name": "Faux A Chaud",
                        "latitude": "14.00878000",
                        "longitude": "-60.99558000"
                    },
                    {
                        "id": 66140,
                        "name": "Ferrand",
                        "latitude": "13.98684000",
                        "longitude": "-60.98494000"
                    },
                    {
                        "id": 66141,
                        "name": "Floissac\/Marc",
                        "latitude": "13.96283000",
                        "longitude": "-60.95880000"
                    },
                    {
                        "id": 66142,
                        "name": "Fond Assau\/Babonneau",
                        "latitude": "13.99491000",
                        "longitude": "-60.93626000"
                    },
                    {
                        "id": 66146,
                        "name": "Fond Canie",
                        "latitude": "13.99195000",
                        "longitude": "-60.95954000"
                    },
                    {
                        "id": 66154,
                        "name": "Forestiere",
                        "latitude": "13.97775000",
                        "longitude": "-60.95766000"
                    },
                    {
                        "id": 66160,
                        "name": "George Charles Boulevard",
                        "latitude": "14.00499000",
                        "longitude": "-60.98673000"
                    },
                    {
                        "id": 66162,
                        "name": "Girard",
                        "latitude": "14.00004000",
                        "longitude": "-60.95960000"
                    },
                    {
                        "id": 66164,
                        "name": "Goergeville",
                        "latitude": "14.01311000",
                        "longitude": "-60.98446000"
                    },
                    {
                        "id": 66166,
                        "name": "Goodlands",
                        "latitude": "13.99121000",
                        "longitude": "-60.99840000"
                    },
                    {
                        "id": 66182,
                        "name": "Grass Street",
                        "latitude": "14.00706000",
                        "longitude": "-60.98763000"
                    },
                    {
                        "id": 66183,
                        "name": "Green Gold",
                        "latitude": "13.99603000",
                        "longitude": "-60.95284000"
                    },
                    {
                        "id": 66187,
                        "name": "Guesneau",
                        "latitude": "13.99084000",
                        "longitude": "-60.96486000"
                    },
                    {
                        "id": 66190,
                        "name": "Hill 20\/Babonneau",
                        "latitude": "13.99941000",
                        "longitude": "-60.94988000"
                    },
                    {
                        "id": 66191,
                        "name": "Hillcrest Gardens",
                        "latitude": "14.01115000",
                        "longitude": "-60.97083000"
                    },
                    {
                        "id": 66194,
                        "name": "Hospital Road",
                        "latitude": "14.00914000",
                        "longitude": "-60.99906000"
                    },
                    {
                        "id": 66195,
                        "name": "Independence City",
                        "latitude": "14.00199000",
                        "longitude": "-60.97879000"
                    },
                    {
                        "id": 66201,
                        "name": "John Compton Highway",
                        "latitude": "14.01909000",
                        "longitude": "-60.99110000"
                    },
                    {
                        "id": 66204,
                        "name": "L'Anse Road",
                        "latitude": "14.01875000",
                        "longitude": "-60.98799000"
                    },
                    {
                        "id": 66207,
                        "name": "La Carierre",
                        "latitude": "14.01806000",
                        "longitude": "-60.98723000"
                    },
                    {
                        "id": 66209,
                        "name": "La Clery",
                        "latitude": "14.01846000",
                        "longitude": "-60.98422000"
                    },
                    {
                        "id": 66212,
                        "name": "La Croix Maingot",
                        "latitude": "13.96569000",
                        "longitude": "-61.00582000"
                    },
                    {
                        "id": 66218,
                        "name": "La Pansee",
                        "latitude": "14.01368000",
                        "longitude": "-60.98187000"
                    },
                    {
                        "id": 66229,
                        "name": "La Toc",
                        "latitude": "14.00824000",
                        "longitude": "-61.00404000"
                    },
                    {
                        "id": 66232,
                        "name": "Labayee",
                        "latitude": "13.94044000",
                        "longitude": "-60.97316000"
                    },
                    {
                        "id": 66235,
                        "name": "Lastic Hill",
                        "latitude": "14.00755000",
                        "longitude": "-60.98321000"
                    },
                    {
                        "id": 66238,
                        "name": "Leslie Land",
                        "latitude": "14.00752000",
                        "longitude": "-60.98674000"
                    },
                    {
                        "id": 66250,
                        "name": "Marc",
                        "latitude": "13.95688000",
                        "longitude": "-60.95724000"
                    },
                    {
                        "id": 66251,
                        "name": "Marchand",
                        "latitude": "14.00415000",
                        "longitude": "-60.98532000"
                    },
                    {
                        "id": 66252,
                        "name": "Marigot",
                        "latitude": "13.96212000",
                        "longitude": "-61.02205000"
                    },
                    {
                        "id": 66262,
                        "name": "Maynard Hill",
                        "latitude": "14.00314000",
                        "longitude": "-60.98966000"
                    },
                    {
                        "id": 66263,
                        "name": "Miami\/Bexon",
                        "latitude": "13.92295000",
                        "longitude": "-60.96945000"
                    },
                    {
                        "id": 66288,
                        "name": "Monkey Town Ciceron",
                        "latitude": "13.98885000",
                        "longitude": "-61.00615000"
                    },
                    {
                        "id": 66291,
                        "name": "Morne Assau\/Babonneau",
                        "latitude": "13.99079000",
                        "longitude": "-60.93241000"
                    },
                    {
                        "id": 66297,
                        "name": "Morne Dudon",
                        "latitude": "14.01194000",
                        "longitude": "-60.96378000"
                    },
                    {
                        "id": 66304,
                        "name": "Morne Road",
                        "latitude": "14.00544000",
                        "longitude": "-60.99693000"
                    },
                    {
                        "id": 66305,
                        "name": "Morne Rouge\/Marc",
                        "latitude": "13.95838000",
                        "longitude": "-60.96972000"
                    },
                    {
                        "id": 66311,
                        "name": "Mount Pleasant",
                        "latitude": "14.01494000",
                        "longitude": "-60.98576000"
                    },
                    {
                        "id": 66316,
                        "name": "New Village",
                        "latitude": "14.01104000",
                        "longitude": "-60.98456000"
                    },
                    {
                        "id": 66318,
                        "name": "Odsan",
                        "latitude": "13.97479000",
                        "longitude": "-60.98319000"
                    },
                    {
                        "id": 66325,
                        "name": "Parker'S Hill",
                        "latitude": "14.00378000",
                        "longitude": "-60.99049000"
                    },
                    {
                        "id": 66327,
                        "name": "Patterson'S Gap",
                        "latitude": "14.00655000",
                        "longitude": "-60.98473000"
                    },
                    {
                        "id": 66328,
                        "name": "Pavee",
                        "latitude": "14.00282000",
                        "longitude": "-60.99191000"
                    },
                    {
                        "id": 66329,
                        "name": "Peart'S Gap",
                        "latitude": "14.01035000",
                        "longitude": "-60.98598000"
                    },
                    {
                        "id": 66330,
                        "name": "Perou",
                        "latitude": "13.95960000",
                        "longitude": "-61.00726000"
                    },
                    {
                        "id": 66338,
                        "name": "Pointe Seraphine",
                        "latitude": "14.01575000",
                        "longitude": "-60.99305000"
                    },
                    {
                        "id": 66342,
                        "name": "Quarte Chemins",
                        "latitude": "13.99136000",
                        "longitude": "-60.97630000"
                    },
                    {
                        "id": 66346,
                        "name": "Ravine Chabot",
                        "latitude": "14.00051000",
                        "longitude": "-60.97617000"
                    },
                    {
                        "id": 66348,
                        "name": "Ravine Poisson",
                        "latitude": "13.93156000",
                        "longitude": "-60.96849000"
                    },
                    {
                        "id": 66349,
                        "name": "Ravine Touterelle",
                        "latitude": "14.00325000",
                        "longitude": "-60.98806000"
                    },
                    {
                        "id": 66353,
                        "name": "Resinard\/Babonneau",
                        "latitude": "14.00289000",
                        "longitude": "-60.94200000"
                    },
                    {
                        "id": 66361,
                        "name": "Rock Hall",
                        "latitude": "14.00009000",
                        "longitude": "-60.98928000"
                    },
                    {
                        "id": 66364,
                        "name": "Rose Hill",
                        "latitude": "14.00816000",
                        "longitude": "-60.98560000"
                    },
                    {
                        "id": 66369,
                        "name": "San Soucis",
                        "latitude": "14.01695000",
                        "longitude": "-60.98985000"
                    },
                    {
                        "id": 66370,
                        "name": "Sand De Feu",
                        "latitude": "13.92781000",
                        "longitude": "-60.98026000"
                    },
                    {
                        "id": 66372,
                        "name": "Sarot",
                        "latitude": "13.94212000",
                        "longitude": "-60.98489000"
                    },
                    {
                        "id": 66387,
                        "name": "Summersdale",
                        "latitude": "14.02582000",
                        "longitude": "-60.97644000"
                    },
                    {
                        "id": 66388,
                        "name": "Sunbilt",
                        "latitude": "14.00561000",
                        "longitude": "-60.97922000"
                    },
                    {
                        "id": 66389,
                        "name": "Sunny Acres",
                        "latitude": "14.02810000",
                        "longitude": "-60.97361000"
                    },
                    {
                        "id": 66390,
                        "name": "Talvern",
                        "latitude": "13.99578000",
                        "longitude": "-60.94410000"
                    },
                    {
                        "id": 66391,
                        "name": "Tapion",
                        "latitude": "14.01383000",
                        "longitude": "-61.00489000"
                    },
                    {
                        "id": 66396,
                        "name": "The Morne",
                        "latitude": "13.99778000",
                        "longitude": "-60.99620000"
                    },
                    {
                        "id": 66399,
                        "name": "Ti Colon",
                        "latitude": "13.97071000",
                        "longitude": "-61.00229000"
                    },
                    {
                        "id": 66402,
                        "name": "Ti Rocher",
                        "latitude": "13.99490000",
                        "longitude": "-60.97110000"
                    },
                    {
                        "id": 66407,
                        "name": "Trois Piton",
                        "latitude": "13.98890000",
                        "longitude": "-60.97259000"
                    },
                    {
                        "id": 66408,
                        "name": "Trou Cochan\/Marc",
                        "latitude": "13.94220000",
                        "longitude": "-60.96199000"
                    },
                    {
                        "id": 66409,
                        "name": "Trou Florent\/Marc",
                        "latitude": "13.94525000",
                        "longitude": "-60.95382000"
                    },
                    {
                        "id": 66410,
                        "name": "Trou Rouge",
                        "latitude": "14.00602000",
                        "longitude": "-60.98950000"
                    },
                    {
                        "id": 66419,
                        "name": "Vide Bouteille",
                        "latitude": "14.02439000",
                        "longitude": "-60.98066000"
                    },
                    {
                        "id": 66423,
                        "name": "Vigie",
                        "latitude": "14.02053000",
                        "longitude": "-60.99611000"
                    },
                    {
                        "id": 66432,
                        "name": "Waterworks",
                        "latitude": "14.00498000",
                        "longitude": "-60.97635000"
                    },
                    {
                        "id": 66434,
                        "name": "Wilton'S Yard\/Grave Yard",
                        "latitude": "14.00968000",
                        "longitude": "-60.98639000"
                    },
                    {
                        "id": 66435,
                        "name": "Yorke Hill",
                        "latitude": "14.01694000",
                        "longitude": "-60.97919000"
                    }
                ]
            },
            {
                "id": 3760,
                "name": "Choiseul",
                "iso2": "03",
                "latitude": "13.77501540",
                "longitude": "-61.04859100",
                "type": "district",
                "cities": [
                    {
                        "id": 66000,
                        "name": "Belle Vue",
                        "latitude": "13.80510000",
                        "longitude": "-61.03615000"
                    },
                    {
                        "id": 66023,
                        "name": "Bois Dinde",
                        "latitude": "13.80463000",
                        "longitude": "-61.04952000"
                    },
                    {
                        "id": 66036,
                        "name": "Caffiere",
                        "latitude": "13.78409000",
                        "longitude": "-61.03554000"
                    },
                    {
                        "id": 66061,
                        "name": "Cedars\/Chu Tigre",
                        "latitude": "13.76995000",
                        "longitude": "-61.04716000"
                    },
                    {
                        "id": 66069,
                        "name": "Choiseul",
                        "latitude": "13.77273000",
                        "longitude": "-61.04931000"
                    },
                    {
                        "id": 66071,
                        "name": "Christian Hill",
                        "latitude": "13.77354000",
                        "longitude": "-61.04694000"
                    },
                    {
                        "id": 66090,
                        "name": "Dacretin",
                        "latitude": "13.79617000",
                        "longitude": "-61.03574000"
                    },
                    {
                        "id": 66094,
                        "name": "Debreuil",
                        "latitude": "13.79033000",
                        "longitude": "-61.02585000"
                    },
                    {
                        "id": 66097,
                        "name": "Delcer",
                        "latitude": "13.80121000",
                        "longitude": "-61.05892000"
                    },
                    {
                        "id": 66113,
                        "name": "Derriere Morne",
                        "latitude": "13.80916000",
                        "longitude": "-61.05101000"
                    },
                    {
                        "id": 66125,
                        "name": "Dugard",
                        "latitude": "13.80386000",
                        "longitude": "-61.02831000"
                    },
                    {
                        "id": 66127,
                        "name": "Dupre",
                        "latitude": "13.79435000",
                        "longitude": "-61.02947000"
                    },
                    {
                        "id": 66136,
                        "name": "Esperance",
                        "latitude": "13.80775000",
                        "longitude": "-61.05331000"
                    },
                    {
                        "id": 66155,
                        "name": "Franciou",
                        "latitude": "13.80400000",
                        "longitude": "-61.05448000"
                    },
                    {
                        "id": 66197,
                        "name": "Industry",
                        "latitude": "13.79127000",
                        "longitude": "-61.05992000"
                    },
                    {
                        "id": 66213,
                        "name": "La Fargue",
                        "latitude": "13.77197000",
                        "longitude": "-61.04124000"
                    },
                    {
                        "id": 66223,
                        "name": "La Pointe",
                        "latitude": "13.79443000",
                        "longitude": "-61.06497000"
                    },
                    {
                        "id": 66234,
                        "name": "Lamaze",
                        "latitude": "13.80649000",
                        "longitude": "-61.01906000"
                    },
                    {
                        "id": 66236,
                        "name": "Le Riche",
                        "latitude": "13.78365000",
                        "longitude": "-61.04815000"
                    },
                    {
                        "id": 66246,
                        "name": "Mailly Motete",
                        "latitude": "13.81788000",
                        "longitude": "-61.02772000"
                    },
                    {
                        "id": 66259,
                        "name": "Martin",
                        "latitude": "13.78941000",
                        "longitude": "-61.04542000"
                    },
                    {
                        "id": 66286,
                        "name": "Mongouge",
                        "latitude": "13.80301000",
                        "longitude": "-61.04524000"
                    },
                    {
                        "id": 66289,
                        "name": "Monzie",
                        "latitude": "13.80669000",
                        "longitude": "-61.02297000"
                    },
                    {
                        "id": 66299,
                        "name": "Morne Jacques",
                        "latitude": "13.81162000",
                        "longitude": "-61.03165000"
                    },
                    {
                        "id": 66306,
                        "name": "Morne Sion",
                        "latitude": "13.79246000",
                        "longitude": "-61.05467000"
                    },
                    {
                        "id": 66309,
                        "name": "Motete",
                        "latitude": "13.81325000",
                        "longitude": "-61.02320000"
                    },
                    {
                        "id": 66314,
                        "name": "New Field\/Fiette",
                        "latitude": "13.78815000",
                        "longitude": "-61.05216000"
                    },
                    {
                        "id": 66340,
                        "name": "Ponyon",
                        "latitude": "13.79639000",
                        "longitude": "-61.04360000"
                    },
                    {
                        "id": 66345,
                        "name": "Raveneau",
                        "latitude": "13.81018000",
                        "longitude": "-61.04642000"
                    },
                    {
                        "id": 66354,
                        "name": "Reunion",
                        "latitude": "13.77861000",
                        "longitude": "-61.04531000"
                    },
                    {
                        "id": 66358,
                        "name": "River Doree",
                        "latitude": "13.76769000",
                        "longitude": "-61.03646000"
                    },
                    {
                        "id": 66360,
                        "name": "Roblot",
                        "latitude": "13.80323000",
                        "longitude": "-61.02297000"
                    },
                    {
                        "id": 66374,
                        "name": "Sauzay",
                        "latitude": "13.77743000",
                        "longitude": "-61.03368000"
                    },
                    {
                        "id": 66376,
                        "name": "Savannesgeorge\/Constitution",
                        "latitude": "13.77855000",
                        "longitude": "-61.05139000"
                    },
                    {
                        "id": 66418,
                        "name": "Victoria",
                        "latitude": "13.81116000",
                        "longitude": "-61.03963000"
                    },
                    {
                        "id": 66424,
                        "name": "Village",
                        "latitude": "13.77464000",
                        "longitude": "-61.05020000"
                    }
                ]
            },
            {
                "id": 3767,
                "name": "Dauphin",
                "iso2": "04",
                "latitude": "14.01033960",
                "longitude": "-60.91909880",
                "type": "district",
                "cities": []
            },
            {
                "id": 3756,
                "name": "Dennery",
                "iso2": "05",
                "latitude": "13.92673930",
                "longitude": "-60.91909880",
                "type": "district",
                "cities": [
                    {
                        "id": 65960,
                        "name": "Anse Canot",
                        "latitude": "13.90871000",
                        "longitude": "-60.90440000"
                    },
                    {
                        "id": 65967,
                        "name": "Athens",
                        "latitude": "13.90574000",
                        "longitude": "-60.89184000"
                    },
                    {
                        "id": 65968,
                        "name": "Au Leon",
                        "latitude": "13.95245000",
                        "longitude": "-60.90456000"
                    },
                    {
                        "id": 65982,
                        "name": "Bara Bara",
                        "latitude": "13.95911000",
                        "longitude": "-60.93414000"
                    },
                    {
                        "id": 65988,
                        "name": "Bazile",
                        "latitude": "13.91082000",
                        "longitude": "-60.92430000"
                    },
                    {
                        "id": 66005,
                        "name": "Belmont",
                        "latitude": "13.95044000",
                        "longitude": "-60.93276000"
                    },
                    {
                        "id": 66024,
                        "name": "Bois Joli",
                        "latitude": "13.92020000",
                        "longitude": "-60.91409000"
                    },
                    {
                        "id": 66029,
                        "name": "Bordelais",
                        "latitude": "13.89552000",
                        "longitude": "-60.90092000"
                    },
                    {
                        "id": 66030,
                        "name": "Bosquet D'Or",
                        "latitude": "13.92886000",
                        "longitude": "-60.91127000"
                    },
                    {
                        "id": 66096,
                        "name": "Delaide",
                        "latitude": "13.92993000",
                        "longitude": "-60.90584000"
                    },
                    {
                        "id": 66099,
                        "name": "Dennery",
                        "latitude": "13.91409000",
                        "longitude": "-60.89132000"
                    },
                    {
                        "id": 66100,
                        "name": "Dennery By Pass",
                        "latitude": "13.91164000",
                        "longitude": "-60.89454000"
                    },
                    {
                        "id": 66101,
                        "name": "Dennery By Pass\/Green Mountain",
                        "latitude": "13.91094000",
                        "longitude": "-60.89810000"
                    },
                    {
                        "id": 66102,
                        "name": "Dennery By Pass\/Rocky Lane",
                        "latitude": "13.91443000",
                        "longitude": "-60.90017000"
                    },
                    {
                        "id": 66103,
                        "name": "Dennery By Pass\/White Rock Gardens",
                        "latitude": "13.91424000",
                        "longitude": "-60.89333000"
                    },
                    {
                        "id": 66104,
                        "name": "Dennery Village",
                        "latitude": "13.91099000",
                        "longitude": "-60.89122000"
                    },
                    {
                        "id": 66108,
                        "name": "Derniere Riviere",
                        "latitude": "13.95679000",
                        "longitude": "-60.92578000"
                    },
                    {
                        "id": 66109,
                        "name": "Derniere Riviere\/Fond Maricient",
                        "latitude": "13.95130000",
                        "longitude": "-60.92218000"
                    },
                    {
                        "id": 66110,
                        "name": "Derniere Riviere\/Mardi Gras\/Morne Caca Cochon",
                        "latitude": "13.96288000",
                        "longitude": "-60.92029000"
                    },
                    {
                        "id": 66111,
                        "name": "Derniere Riviere\/Morne Panache",
                        "latitude": "13.95252000",
                        "longitude": "-60.92919000"
                    },
                    {
                        "id": 66117,
                        "name": "Despinoze",
                        "latitude": "13.94971000",
                        "longitude": "-60.91182000"
                    },
                    {
                        "id": 66123,
                        "name": "Dubonnaire",
                        "latitude": "13.92808000",
                        "longitude": "-60.92336000"
                    },
                    {
                        "id": 66156,
                        "name": "Gadette",
                        "latitude": "13.95937000",
                        "longitude": "-60.91029000"
                    },
                    {
                        "id": 66170,
                        "name": "Grande Ravine",
                        "latitude": "13.94263000",
                        "longitude": "-60.93404000"
                    },
                    {
                        "id": 66171,
                        "name": "Grande Riviere",
                        "latitude": "13.93306000",
                        "longitude": "-60.93239000"
                    },
                    {
                        "id": 66173,
                        "name": "Grande Riviere\/Des Branch",
                        "latitude": "13.93383000",
                        "longitude": "-60.93499000"
                    },
                    {
                        "id": 66174,
                        "name": "Grande Riviere\/En Leur Morne\/Discompere",
                        "latitude": "13.93223000",
                        "longitude": "-60.93461000"
                    },
                    {
                        "id": 66175,
                        "name": "Grande Riviere\/Funier",
                        "latitude": "13.93240000",
                        "longitude": "-60.93305000"
                    },
                    {
                        "id": 66177,
                        "name": "Grande Riviere\/Morne Caca Cochon",
                        "latitude": "13.92960000",
                        "longitude": "-60.93794000"
                    },
                    {
                        "id": 66208,
                        "name": "La Caye",
                        "latitude": "13.93290000",
                        "longitude": "-60.90434000"
                    },
                    {
                        "id": 66220,
                        "name": "La Pelle",
                        "latitude": "13.94096000",
                        "longitude": "-60.90569000"
                    },
                    {
                        "id": 66224,
                        "name": "La Pointe",
                        "latitude": "13.91525000",
                        "longitude": "-60.88830000"
                    },
                    {
                        "id": 66226,
                        "name": "La Ressource",
                        "latitude": "13.94293000",
                        "longitude": "-60.91585000"
                    },
                    {
                        "id": 66242,
                        "name": "Lumiere",
                        "latitude": "13.93928000",
                        "longitude": "-60.88889000"
                    },
                    {
                        "id": 66303,
                        "name": "Morne Panache",
                        "latitude": "13.92167000",
                        "longitude": "-60.93654000"
                    },
                    {
                        "id": 66355,
                        "name": "Riche Fond",
                        "latitude": "13.93644000",
                        "longitude": "-60.92026000"
                    },
                    {
                        "id": 66356,
                        "name": "Riche Fond\/La Belle Vie",
                        "latitude": "13.93782000",
                        "longitude": "-60.92908000"
                    },
                    {
                        "id": 66357,
                        "name": "Riche Fond\/New Village",
                        "latitude": "13.93648000",
                        "longitude": "-60.92394000"
                    },
                    {
                        "id": 66384,
                        "name": "St. Joseph Estate",
                        "latitude": "13.90066000",
                        "longitude": "-60.91444000"
                    },
                    {
                        "id": 66395,
                        "name": "Thamazo",
                        "latitude": "13.93245000",
                        "longitude": "-60.94786000"
                    }
                ]
            },
            {
                "id": 3766,
                "name": "Gros Islet",
                "iso2": "06",
                "latitude": "14.08435780",
                "longitude": "-60.94527940",
                "type": "district",
                "cities": [
                    {
                        "id": 65993,
                        "name": "Beausejour",
                        "latitude": "14.07647000",
                        "longitude": "-60.93780000"
                    },
                    {
                        "id": 65994,
                        "name": "Beausejour\/Fostin'S Development",
                        "latitude": "14.07445000",
                        "longitude": "-60.92929000"
                    },
                    {
                        "id": 65995,
                        "name": "Beausejour\/Ndc",
                        "latitude": "14.07733000",
                        "longitude": "-60.92683000"
                    },
                    {
                        "id": 65997,
                        "name": "Bella Rosa",
                        "latitude": "14.07711000",
                        "longitude": "-60.94568000"
                    },
                    {
                        "id": 66001,
                        "name": "Belle Vue",
                        "latitude": "14.08470000",
                        "longitude": "-60.94342000"
                    },
                    {
                        "id": 66003,
                        "name": "Belle Vue Estate",
                        "latitude": "14.08840000",
                        "longitude": "-60.94613000"
                    },
                    {
                        "id": 66016,
                        "name": "Boguis",
                        "latitude": "14.01548000",
                        "longitude": "-60.92089000"
                    },
                    {
                        "id": 66017,
                        "name": "Boguis\/Desa Blond",
                        "latitude": "14.01057000",
                        "longitude": "-60.92565000"
                    },
                    {
                        "id": 66021,
                        "name": "Bois D'Orange",
                        "latitude": "14.05803000",
                        "longitude": "-60.95992000"
                    },
                    {
                        "id": 66022,
                        "name": "Bois D'Ornange\/Trouya",
                        "latitude": "14.06198000",
                        "longitude": "-60.96914000"
                    },
                    {
                        "id": 66027,
                        "name": "Bonneterre",
                        "latitude": "14.06994000",
                        "longitude": "-60.94146000"
                    },
                    {
                        "id": 66028,
                        "name": "Bonneterre Gardens",
                        "latitude": "14.06737000",
                        "longitude": "-60.93393000"
                    },
                    {
                        "id": 66043,
                        "name": "Cap Estate",
                        "latitude": "14.09410000",
                        "longitude": "-60.93592000"
                    },
                    {
                        "id": 66044,
                        "name": "Cap Estate\/Becune Point",
                        "latitude": "14.09270000",
                        "longitude": "-60.95161000"
                    },
                    {
                        "id": 66045,
                        "name": "Cap Estate\/Caribbean Park",
                        "latitude": "14.10019000",
                        "longitude": "-60.92446000"
                    },
                    {
                        "id": 66046,
                        "name": "Cap Estate\/Golf Park",
                        "latitude": "14.09998000",
                        "longitude": "-60.93705000"
                    },
                    {
                        "id": 66047,
                        "name": "Cap Estate\/Lower Saline Point",
                        "latitude": "14.10515000",
                        "longitude": "-60.94310000"
                    },
                    {
                        "id": 66048,
                        "name": "Cap Estate\/Mon Du Cap",
                        "latitude": "14.10554000",
                        "longitude": "-60.93758000"
                    },
                    {
                        "id": 66049,
                        "name": "Cap Estate\/Ranch Site",
                        "latitude": "14.10437000",
                        "longitude": "-60.93360000"
                    },
                    {
                        "id": 66050,
                        "name": "Cap Estate\/Saddlec Back",
                        "latitude": "14.10023000",
                        "longitude": "-60.94246000"
                    },
                    {
                        "id": 66051,
                        "name": "Cap Estate\/Upper Saline Point",
                        "latitude": "14.10740000",
                        "longitude": "-60.94487000"
                    },
                    {
                        "id": 66055,
                        "name": "Cas En Bas",
                        "latitude": "14.08328000",
                        "longitude": "-60.93209000"
                    },
                    {
                        "id": 66058,
                        "name": "Caye Manje'",
                        "latitude": "14.06629000",
                        "longitude": "-60.93560000"
                    },
                    {
                        "id": 66082,
                        "name": "Corinth",
                        "latitude": "14.04710000",
                        "longitude": "-60.96046000"
                    },
                    {
                        "id": 66083,
                        "name": "Corinth Estate",
                        "latitude": "14.04336000",
                        "longitude": "-60.95388000"
                    },
                    {
                        "id": 66084,
                        "name": "Corinth\/La Bel Lair",
                        "latitude": "14.04469000",
                        "longitude": "-60.94484000"
                    },
                    {
                        "id": 66092,
                        "name": "Dauphin",
                        "latitude": "14.05647000",
                        "longitude": "-60.90188000"
                    },
                    {
                        "id": 66114,
                        "name": "Des Barras",
                        "latitude": "13.99949000",
                        "longitude": "-60.90166000"
                    },
                    {
                        "id": 66115,
                        "name": "Des Barras\/Cacolie",
                        "latitude": "14.01687000",
                        "longitude": "-60.90097000"
                    },
                    {
                        "id": 66118,
                        "name": "Desrameaux",
                        "latitude": "14.03681000",
                        "longitude": "-60.92697000"
                    },
                    {
                        "id": 66157,
                        "name": "Garrand",
                        "latitude": "14.00424000",
                        "longitude": "-60.93270000"
                    },
                    {
                        "id": 66169,
                        "name": "Grand Riviere",
                        "latitude": "14.03546000",
                        "longitude": "-60.95152000"
                    },
                    {
                        "id": 66172,
                        "name": "Grande Riviere\/Assou Canal",
                        "latitude": "14.03975000",
                        "longitude": "-60.95121000"
                    },
                    {
                        "id": 66176,
                        "name": "Grande Riviere\/Ingle Woods",
                        "latitude": "14.03091000",
                        "longitude": "-60.95592000"
                    },
                    {
                        "id": 66178,
                        "name": "Grande Riviere\/Morne Serpent",
                        "latitude": "14.03509000",
                        "longitude": "-60.96060000"
                    },
                    {
                        "id": 66179,
                        "name": "Grande Riviere\/Norbert",
                        "latitude": "14.04317000",
                        "longitude": "-60.94933000"
                    },
                    {
                        "id": 66180,
                        "name": "Grande Riviere\/Piat",
                        "latitude": "14.03926000",
                        "longitude": "-60.94361000"
                    },
                    {
                        "id": 66181,
                        "name": "Grande Riviere\/White Rock",
                        "latitude": "14.03618000",
                        "longitude": "-60.95556000"
                    },
                    {
                        "id": 66184,
                        "name": "Gros Islet",
                        "latitude": "14.06667000",
                        "longitude": "-60.95000000"
                    },
                    {
                        "id": 66185,
                        "name": "Gros Islet Town",
                        "latitude": "14.08080000",
                        "longitude": "-60.95312000"
                    },
                    {
                        "id": 66186,
                        "name": "Gros Islet\/Edge Water",
                        "latitude": "14.07912000",
                        "longitude": "-60.94973000"
                    },
                    {
                        "id": 66206,
                        "name": "L'Hermitage",
                        "latitude": "14.06521000",
                        "longitude": "-60.93967000"
                    },
                    {
                        "id": 66211,
                        "name": "La Croix Chabourgh",
                        "latitude": "14.01147000",
                        "longitude": "-60.94025000"
                    },
                    {
                        "id": 66214,
                        "name": "La Guerre",
                        "latitude": "14.02191000",
                        "longitude": "-60.92491000"
                    },
                    {
                        "id": 66215,
                        "name": "La Guerre\/Chicken Back Street",
                        "latitude": "14.02387000",
                        "longitude": "-60.93108000"
                    },
                    {
                        "id": 66253,
                        "name": "Marisule",
                        "latitude": "14.04621000",
                        "longitude": "-60.97063000"
                    },
                    {
                        "id": 66254,
                        "name": "Marisule\/Bon Air",
                        "latitude": "14.05062000",
                        "longitude": "-60.97124000"
                    },
                    {
                        "id": 66255,
                        "name": "Marisule\/East Winds",
                        "latitude": "14.05407000",
                        "longitude": "-60.96849000"
                    },
                    {
                        "id": 66256,
                        "name": "Marisule\/La Brellotte",
                        "latitude": "14.05710000",
                        "longitude": "-60.97183000"
                    },
                    {
                        "id": 66257,
                        "name": "Marisule\/Top Of The World",
                        "latitude": "14.04385000",
                        "longitude": "-60.96885000"
                    },
                    {
                        "id": 66258,
                        "name": "Marquis Estate",
                        "latitude": "14.02960000",
                        "longitude": "-60.90732000"
                    },
                    {
                        "id": 66261,
                        "name": "Massade",
                        "latitude": "14.08292000",
                        "longitude": "-60.94946000"
                    },
                    {
                        "id": 66269,
                        "name": "Monchy",
                        "latitude": "14.05502000",
                        "longitude": "-60.92623000"
                    },
                    {
                        "id": 66270,
                        "name": "Monchy\/Careffe",
                        "latitude": "14.05930000",
                        "longitude": "-60.95069000"
                    },
                    {
                        "id": 66271,
                        "name": "Monchy\/Cletus Village",
                        "latitude": "14.05137000",
                        "longitude": "-60.92380000"
                    },
                    {
                        "id": 66272,
                        "name": "Monchy\/La Borne",
                        "latitude": "14.04628000",
                        "longitude": "-60.91961000"
                    },
                    {
                        "id": 66273,
                        "name": "Monchy\/La Borne\/Sans Souci",
                        "latitude": "14.04504000",
                        "longitude": "-60.89961000"
                    },
                    {
                        "id": 66274,
                        "name": "Monchy\/La Retraite",
                        "latitude": "14.06421000",
                        "longitude": "-60.94564000"
                    },
                    {
                        "id": 66275,
                        "name": "Monchy\/Lafeuillee",
                        "latitude": "14.05950000",
                        "longitude": "-60.94086000"
                    },
                    {
                        "id": 66276,
                        "name": "Monchy\/Lawi Fwen",
                        "latitude": "14.05802000",
                        "longitude": "-60.92906000"
                    },
                    {
                        "id": 66277,
                        "name": "Monchy\/Malgretoute",
                        "latitude": "14.04108000",
                        "longitude": "-60.91912000"
                    },
                    {
                        "id": 66278,
                        "name": "Monchy\/Moulin A Vent",
                        "latitude": "14.06283000",
                        "longitude": "-60.95025000"
                    },
                    {
                        "id": 66279,
                        "name": "Monchy\/Ravine Macock",
                        "latitude": "14.04789000",
                        "longitude": "-60.92511000"
                    },
                    {
                        "id": 66280,
                        "name": "Monchy\/Riviere Mitan",
                        "latitude": "14.04987000",
                        "longitude": "-60.94029000"
                    },
                    {
                        "id": 66281,
                        "name": "Monchy\/Ti Dauphin",
                        "latitude": "14.04081000",
                        "longitude": "-60.93225000"
                    },
                    {
                        "id": 66282,
                        "name": "Monchy\/Vieux Sucreic",
                        "latitude": "14.04996000",
                        "longitude": "-60.94992000"
                    },
                    {
                        "id": 66283,
                        "name": "Monchy\/Vieux Sucreic\/Bois D'Inde",
                        "latitude": "14.05613000",
                        "longitude": "-60.95151000"
                    },
                    {
                        "id": 66284,
                        "name": "Monchy\/Vieux Sucreic\/Careffe",
                        "latitude": "14.05652000",
                        "longitude": "-60.94948000"
                    },
                    {
                        "id": 66285,
                        "name": "Mongiraud",
                        "latitude": "14.06287000",
                        "longitude": "-60.95722000"
                    },
                    {
                        "id": 66287,
                        "name": "Monier",
                        "latitude": "14.02951000",
                        "longitude": "-60.94098000"
                    },
                    {
                        "id": 66295,
                        "name": "Morne Citon",
                        "latitude": "14.03004000",
                        "longitude": "-60.92813000"
                    },
                    {
                        "id": 66320,
                        "name": "Paix Bouche",
                        "latitude": "14.01755000",
                        "longitude": "-60.93852000"
                    },
                    {
                        "id": 66333,
                        "name": "Pigeon Island",
                        "latitude": "14.08965000",
                        "longitude": "-60.95724000"
                    },
                    {
                        "id": 66336,
                        "name": "Plateau",
                        "latitude": "14.02612000",
                        "longitude": "-60.93474000"
                    },
                    {
                        "id": 66350,
                        "name": "Reduit",
                        "latitude": "14.06829000",
                        "longitude": "-60.96145000"
                    },
                    {
                        "id": 66351,
                        "name": "Reduit Orchard",
                        "latitude": "14.06594000",
                        "longitude": "-60.95340000"
                    },
                    {
                        "id": 66352,
                        "name": "Reduit Park",
                        "latitude": "14.06622000",
                        "longitude": "-60.95560000"
                    },
                    {
                        "id": 66362,
                        "name": "Rodney Bay",
                        "latitude": "14.07292000",
                        "longitude": "-60.95443000"
                    },
                    {
                        "id": 66363,
                        "name": "Rodney Heights",
                        "latitude": "14.06731000",
                        "longitude": "-60.94906000"
                    },
                    {
                        "id": 66412,
                        "name": "Union",
                        "latitude": "14.02907000",
                        "longitude": "-60.96480000"
                    },
                    {
                        "id": 66413,
                        "name": "Union Terrace",
                        "latitude": "14.02654000",
                        "longitude": "-60.95710000"
                    },
                    {
                        "id": 66415,
                        "name": "Union\/Ti Morne",
                        "latitude": "14.02283000",
                        "longitude": "-60.95272000"
                    }
                ]
            },
            {
                "id": 3759,
                "name": "Laborie",
                "iso2": "07",
                "latitude": "13.75227830",
                "longitude": "-60.99328890",
                "type": "district",
                "cities": [
                    {
                        "id": 65959,
                        "name": "Annus",
                        "latitude": "13.77449000",
                        "longitude": "-61.00511000"
                    },
                    {
                        "id": 65976,
                        "name": "Balca",
                        "latitude": "13.77117000",
                        "longitude": "-61.02389000"
                    },
                    {
                        "id": 65977,
                        "name": "Balca\/En Leur Ba",
                        "latitude": "13.77638000",
                        "longitude": "-61.01931000"
                    },
                    {
                        "id": 65978,
                        "name": "Balembouche",
                        "latitude": "13.75992000",
                        "longitude": "-61.02840000"
                    },
                    {
                        "id": 65980,
                        "name": "Banse",
                        "latitude": "13.79211000",
                        "longitude": "-60.99282000"
                    },
                    {
                        "id": 65981,
                        "name": "Banse La Grace",
                        "latitude": "13.78150000",
                        "longitude": "-60.99840000"
                    },
                    {
                        "id": 66026,
                        "name": "Bongalo",
                        "latitude": "13.76666000",
                        "longitude": "-61.02991000"
                    },
                    {
                        "id": 66089,
                        "name": "Daban",
                        "latitude": "13.80490000",
                        "longitude": "-61.00435000"
                    },
                    {
                        "id": 66143,
                        "name": "Fond Berange",
                        "latitude": "13.78238000",
                        "longitude": "-61.00346000"
                    },
                    {
                        "id": 66158,
                        "name": "Gayabois",
                        "latitude": "13.78643000",
                        "longitude": "-61.01835000"
                    },
                    {
                        "id": 66159,
                        "name": "Gentil",
                        "latitude": "13.76816000",
                        "longitude": "-60.98877000"
                    },
                    {
                        "id": 66161,
                        "name": "Getrine",
                        "latitude": "13.78192000",
                        "longitude": "-61.00741000"
                    },
                    {
                        "id": 66163,
                        "name": "Giraud",
                        "latitude": "13.79254000",
                        "longitude": "-61.00843000"
                    },
                    {
                        "id": 66188,
                        "name": "H'Erelle",
                        "latitude": "13.75599000",
                        "longitude": "-60.98698000"
                    },
                    {
                        "id": 66203,
                        "name": "Kennedy Highway\/Laborie Bypass",
                        "latitude": "13.75380000",
                        "longitude": "-60.99594000"
                    },
                    {
                        "id": 66216,
                        "name": "La Haut",
                        "latitude": "13.79207000",
                        "longitude": "-61.00014000"
                    },
                    {
                        "id": 66221,
                        "name": "La Perle",
                        "latitude": "13.76483000",
                        "longitude": "-61.02088000"
                    },
                    {
                        "id": 66233,
                        "name": "Laborie",
                        "latitude": "13.75000000",
                        "longitude": "-60.98333000"
                    },
                    {
                        "id": 66241,
                        "name": "Londonderry",
                        "latitude": "13.77623000",
                        "longitude": "-61.01362000"
                    },
                    {
                        "id": 66243,
                        "name": "Macdomel",
                        "latitude": "13.77497000",
                        "longitude": "-60.98508000"
                    },
                    {
                        "id": 66298,
                        "name": "Morne Gomier",
                        "latitude": "13.76552000",
                        "longitude": "-60.99524000"
                    },
                    {
                        "id": 66302,
                        "name": "Morne Le Blanc",
                        "latitude": "13.75868000",
                        "longitude": "-60.99913000"
                    },
                    {
                        "id": 66319,
                        "name": "Olibo",
                        "latitude": "13.77628000",
                        "longitude": "-60.99931000"
                    },
                    {
                        "id": 66324,
                        "name": "Parc Estate",
                        "latitude": "13.79639000",
                        "longitude": "-61.01613000"
                    },
                    {
                        "id": 66331,
                        "name": "Piaye",
                        "latitude": "13.75628000",
                        "longitude": "-61.02279000"
                    },
                    {
                        "id": 66368,
                        "name": "Saltibus",
                        "latitude": "13.81211000",
                        "longitude": "-61.00982000"
                    },
                    {
                        "id": 66371,
                        "name": "Saphire",
                        "latitude": "13.75670000",
                        "longitude": "-61.01209000"
                    },
                    {
                        "id": 66393,
                        "name": "Tete Morne",
                        "latitude": "13.76160000",
                        "longitude": "-61.03397000"
                    },
                    {
                        "id": 66426,
                        "name": "Village",
                        "latitude": "13.74927000",
                        "longitude": "-60.99375000"
                    },
                    {
                        "id": 66431,
                        "name": "Warwick\/Daban",
                        "latitude": "13.81084000",
                        "longitude": "-61.00047000"
                    }
                ]
            },
            {
                "id": 3762,
                "name": "Micoud",
                "iso2": "08",
                "latitude": "13.82118710",
                "longitude": "-60.90019340",
                "type": "district",
                "cities": [
                    {
                        "id": 65964,
                        "name": "Anse Ger",
                        "latitude": "13.79567000",
                        "longitude": "-60.91567000"
                    },
                    {
                        "id": 65991,
                        "name": "Beauchamp",
                        "latitude": "13.81778000",
                        "longitude": "-60.91528000"
                    },
                    {
                        "id": 66014,
                        "name": "Blanchard",
                        "latitude": "13.80616000",
                        "longitude": "-60.94630000"
                    },
                    {
                        "id": 66041,
                        "name": "Canelles",
                        "latitude": "13.78515000",
                        "longitude": "-60.91789000"
                    },
                    {
                        "id": 66059,
                        "name": "Cazuca",
                        "latitude": "13.80002000",
                        "longitude": "-60.90481000"
                    },
                    {
                        "id": 66068,
                        "name": "Chique\/Blanchard",
                        "latitude": "13.80120000",
                        "longitude": "-60.94970000"
                    },
                    {
                        "id": 66079,
                        "name": "Coolie Town",
                        "latitude": "13.85429000",
                        "longitude": "-60.91380000"
                    },
                    {
                        "id": 66098,
                        "name": "Delomel",
                        "latitude": "13.80338000",
                        "longitude": "-60.92927000"
                    },
                    {
                        "id": 66116,
                        "name": "Des Blanchard",
                        "latitude": "13.81155000",
                        "longitude": "-60.93423000"
                    },
                    {
                        "id": 66119,
                        "name": "Desruisseaux",
                        "latitude": "13.79640000",
                        "longitude": "-60.93540000"
                    },
                    {
                        "id": 66126,
                        "name": "Dugard",
                        "latitude": "13.81090000",
                        "longitude": "-60.91415000"
                    },
                    {
                        "id": 66134,
                        "name": "Escap",
                        "latitude": "13.83031000",
                        "longitude": "-60.89673000"
                    },
                    {
                        "id": 66148,
                        "name": "Fond D'Lor\/Dugard",
                        "latitude": "13.81069000",
                        "longitude": "-60.92119000"
                    },
                    {
                        "id": 66150,
                        "name": "Fond Estate",
                        "latitude": "13.84243000",
                        "longitude": "-60.91862000"
                    },
                    {
                        "id": 66153,
                        "name": "Fond\/Desruisseaux",
                        "latitude": "13.79421000",
                        "longitude": "-60.94128000"
                    },
                    {
                        "id": 66165,
                        "name": "Gomier",
                        "latitude": "13.81485000",
                        "longitude": "-60.95252000"
                    },
                    {
                        "id": 66167,
                        "name": "Gouette",
                        "latitude": "13.80650000",
                        "longitude": "-60.93964000"
                    },
                    {
                        "id": 66192,
                        "name": "Honeymoon Beach",
                        "latitude": "13.77746000",
                        "longitude": "-60.90493000"
                    },
                    {
                        "id": 66205,
                        "name": "L'Eau Mineau",
                        "latitude": "13.80672000",
                        "longitude": "-60.92103000"
                    },
                    {
                        "id": 66210,
                        "name": "La Courville",
                        "latitude": "13.81056000",
                        "longitude": "-60.92766000"
                    },
                    {
                        "id": 66222,
                        "name": "La Pointe",
                        "latitude": "13.84593000",
                        "longitude": "-60.89332000"
                    },
                    {
                        "id": 66228,
                        "name": "La Tille",
                        "latitude": "13.82744000",
                        "longitude": "-60.91716000"
                    },
                    {
                        "id": 66239,
                        "name": "Lezy",
                        "latitude": "13.80372000",
                        "longitude": "-60.93906000"
                    },
                    {
                        "id": 66240,
                        "name": "Lombard",
                        "latitude": "13.85772000",
                        "longitude": "-60.91510000"
                    },
                    {
                        "id": 66245,
                        "name": "Mahaut",
                        "latitude": "13.84391000",
                        "longitude": "-60.95397000"
                    },
                    {
                        "id": 66247,
                        "name": "Malgretoute",
                        "latitude": "13.84199000",
                        "longitude": "-60.90411000"
                    },
                    {
                        "id": 66249,
                        "name": "Mamiku",
                        "latitude": "13.86744000",
                        "longitude": "-60.90184000"
                    },
                    {
                        "id": 66264,
                        "name": "Micoud",
                        "latitude": "13.81667000",
                        "longitude": "-60.90000000"
                    },
                    {
                        "id": 66268,
                        "name": "Mon Repos",
                        "latitude": "13.85865000",
                        "longitude": "-60.89591000"
                    },
                    {
                        "id": 66290,
                        "name": "Moreau",
                        "latitude": "13.82676000",
                        "longitude": "-60.94238000"
                    },
                    {
                        "id": 66308,
                        "name": "Morne Vient",
                        "latitude": "13.80646000",
                        "longitude": "-60.95241000"
                    },
                    {
                        "id": 66312,
                        "name": "Myette Gardens",
                        "latitude": "13.81862000",
                        "longitude": "-60.90440000"
                    },
                    {
                        "id": 66315,
                        "name": "New Village",
                        "latitude": "13.82446000",
                        "longitude": "-60.89864000"
                    },
                    {
                        "id": 66321,
                        "name": "Paix Bouche",
                        "latitude": "13.81556000",
                        "longitude": "-60.94073000"
                    },
                    {
                        "id": 66323,
                        "name": "Palmiste Estate",
                        "latitude": "13.85377000",
                        "longitude": "-60.96007000"
                    },
                    {
                        "id": 66326,
                        "name": "Patience",
                        "latitude": "13.85000000",
                        "longitude": "-60.90874000"
                    },
                    {
                        "id": 66334,
                        "name": "Planard",
                        "latitude": "13.80521000",
                        "longitude": "-60.91540000"
                    },
                    {
                        "id": 66341,
                        "name": "Praslin",
                        "latitude": "13.87545000",
                        "longitude": "-60.89717000"
                    },
                    {
                        "id": 66344,
                        "name": "Rameau",
                        "latitude": "13.83055000",
                        "longitude": "-60.92375000"
                    },
                    {
                        "id": 66367,
                        "name": "Saint Marie Road",
                        "latitude": "13.85444000",
                        "longitude": "-60.91803000"
                    },
                    {
                        "id": 66373,
                        "name": "Saut",
                        "latitude": "13.81272000",
                        "longitude": "-60.94375000"
                    },
                    {
                        "id": 66375,
                        "name": "Savannes",
                        "latitude": "13.77098000",
                        "longitude": "-60.92017000"
                    },
                    {
                        "id": 66379,
                        "name": "St Helen Estate",
                        "latitude": "13.78735000",
                        "longitude": "-60.90726000"
                    },
                    {
                        "id": 66401,
                        "name": "Ti Riviere",
                        "latitude": "13.83006000",
                        "longitude": "-60.93774000"
                    },
                    {
                        "id": 66403,
                        "name": "Ti Rocher",
                        "latitude": "13.81734000",
                        "longitude": "-60.92858000"
                    },
                    {
                        "id": 66411,
                        "name": "Troumassee",
                        "latitude": "13.80892000",
                        "longitude": "-60.90341000"
                    },
                    {
                        "id": 66425,
                        "name": "Village",
                        "latitude": "13.81904000",
                        "longitude": "-60.89692000"
                    },
                    {
                        "id": 66430,
                        "name": "Volet",
                        "latitude": "13.82626000",
                        "longitude": "-60.90789000"
                    }
                ]
            },
            {
                "id": 3765,
                "name": "Praslin",
                "iso2": "09",
                "latitude": "13.87523920",
                "longitude": "-60.89946630",
                "type": "district",
                "cities": []
            },
            {
                "id": 3764,
                "name": "Soufrière",
                "iso2": "10",
                "latitude": "13.85709860",
                "longitude": "-61.05732480",
                "type": "district",
                "cities": [
                    {
                        "id": 65961,
                        "name": "Anse Chastanet",
                        "latitude": "13.86426000",
                        "longitude": "-61.07016000"
                    },
                    {
                        "id": 65984,
                        "name": "Barons Drive\/Coin De L'Anse",
                        "latitude": "13.85138000",
                        "longitude": "-61.05939000"
                    },
                    {
                        "id": 65990,
                        "name": "Beasejour\/Myers Bridge",
                        "latitude": "13.82147000",
                        "longitude": "-61.03396000"
                    },
                    {
                        "id": 65999,
                        "name": "Belle Plaine",
                        "latitude": "13.82700000",
                        "longitude": "-61.03127000"
                    },
                    {
                        "id": 66004,
                        "name": "Bellefond",
                        "latitude": "13.82753000",
                        "longitude": "-61.04269000"
                    },
                    {
                        "id": 66007,
                        "name": "Belvedere",
                        "latitude": "13.83440000",
                        "longitude": "-61.01771000"
                    },
                    {
                        "id": 66020,
                        "name": "Bois D'Inde",
                        "latitude": "13.83650000",
                        "longitude": "-61.03491000"
                    },
                    {
                        "id": 66031,
                        "name": "Bouton",
                        "latitude": "13.87936000",
                        "longitude": "-61.06449000"
                    },
                    {
                        "id": 66039,
                        "name": "Calvary\/Calvaire",
                        "latitude": "13.85035000",
                        "longitude": "-61.05620000"
                    },
                    {
                        "id": 66062,
                        "name": "Cenac",
                        "latitude": "13.87207000",
                        "longitude": "-61.04243000"
                    },
                    {
                        "id": 66067,
                        "name": "Chateau Belair",
                        "latitude": "13.81830000",
                        "longitude": "-61.05350000"
                    },
                    {
                        "id": 66076,
                        "name": "Colombette",
                        "latitude": "13.86861000",
                        "longitude": "-61.04990000"
                    },
                    {
                        "id": 66077,
                        "name": "Compar",
                        "latitude": "13.83586000",
                        "longitude": "-61.05934000"
                    },
                    {
                        "id": 66086,
                        "name": "Cresslands",
                        "latitude": "13.85999000",
                        "longitude": "-61.04032000"
                    },
                    {
                        "id": 66120,
                        "name": "Deville",
                        "latitude": "13.81372000",
                        "longitude": "-61.05049000"
                    },
                    {
                        "id": 66121,
                        "name": "Diamond\/Diamond Estate",
                        "latitude": "13.85168000",
                        "longitude": "-61.04352000"
                    },
                    {
                        "id": 66137,
                        "name": "Esperance",
                        "latitude": "13.84562000",
                        "longitude": "-61.03713000"
                    },
                    {
                        "id": 66138,
                        "name": "Etangs",
                        "latitude": "13.81902000",
                        "longitude": "-61.04056000"
                    },
                    {
                        "id": 66144,
                        "name": "Fond Bernier",
                        "latitude": "13.85845000",
                        "longitude": "-61.05949000"
                    },
                    {
                        "id": 66145,
                        "name": "Fond Cacoa",
                        "latitude": "13.85442000",
                        "longitude": "-61.05077000"
                    },
                    {
                        "id": 66149,
                        "name": "Fond Doux",
                        "latitude": "13.82096000",
                        "longitude": "-61.04952000"
                    },
                    {
                        "id": 66151,
                        "name": "Fond Gens Libre",
                        "latitude": "13.80791000",
                        "longitude": "-61.06259000"
                    },
                    {
                        "id": 66199,
                        "name": "Jalousie",
                        "latitude": "13.82811000",
                        "longitude": "-61.05891000"
                    },
                    {
                        "id": 66217,
                        "name": "La Haut",
                        "latitude": "13.86276000",
                        "longitude": "-61.05584000"
                    },
                    {
                        "id": 66219,
                        "name": "La Pearle",
                        "latitude": "13.85740000",
                        "longitude": "-61.04760000"
                    },
                    {
                        "id": 66237,
                        "name": "Lenny Hill",
                        "latitude": "13.85059000",
                        "longitude": "-61.05906000"
                    },
                    {
                        "id": 66248,
                        "name": "Malgretoute",
                        "latitude": "13.84233000",
                        "longitude": "-61.05998000"
                    },
                    {
                        "id": 66265,
                        "name": "Migny",
                        "latitude": "13.84166000",
                        "longitude": "-61.01808000"
                    },
                    {
                        "id": 66267,
                        "name": "Mocha",
                        "latitude": "13.83117000",
                        "longitude": "-61.02503000"
                    },
                    {
                        "id": 66292,
                        "name": "Morne Bonin",
                        "latitude": "13.83174000",
                        "longitude": "-61.03285000"
                    },
                    {
                        "id": 66300,
                        "name": "Morne La Croix",
                        "latitude": "13.81762000",
                        "longitude": "-61.06146000"
                    },
                    {
                        "id": 66301,
                        "name": "Morne Lastic\/Desruisseaux",
                        "latitude": "13.86628000",
                        "longitude": "-61.05894000"
                    },
                    {
                        "id": 66313,
                        "name": "New Development",
                        "latitude": "13.86176000",
                        "longitude": "-61.04791000"
                    },
                    {
                        "id": 66322,
                        "name": "Palmiste",
                        "latitude": "13.85843000",
                        "longitude": "-61.05575000"
                    },
                    {
                        "id": 66335,
                        "name": "Plat Pays",
                        "latitude": "13.84085000",
                        "longitude": "-61.05571000"
                    },
                    {
                        "id": 66343,
                        "name": "Rabot",
                        "latitude": "13.83380000",
                        "longitude": "-61.04540000"
                    },
                    {
                        "id": 66347,
                        "name": "Ravine Claire",
                        "latitude": "13.85262000",
                        "longitude": "-61.02892000"
                    },
                    {
                        "id": 66366,
                        "name": "Ruby Estate",
                        "latitude": "13.85812000",
                        "longitude": "-61.04983000"
                    },
                    {
                        "id": 66378,
                        "name": "Soufrière",
                        "latitude": "13.85616000",
                        "longitude": "-61.05660000"
                    },
                    {
                        "id": 66377,
                        "name": "Soufriere Estate",
                        "latitude": "13.85174000",
                        "longitude": "-61.05420000"
                    },
                    {
                        "id": 66383,
                        "name": "St Phillip",
                        "latitude": "13.84432000",
                        "longitude": "-61.02766000"
                    },
                    {
                        "id": 66385,
                        "name": "Stonefield",
                        "latitude": "13.84513000",
                        "longitude": "-61.05990000"
                    },
                    {
                        "id": 66386,
                        "name": "Sulphur Springs",
                        "latitude": "13.84002000",
                        "longitude": "-61.04512000"
                    },
                    {
                        "id": 66398,
                        "name": "Ti Boug",
                        "latitude": "13.83744000",
                        "longitude": "-61.02460000"
                    },
                    {
                        "id": 66400,
                        "name": "Ti Delcer",
                        "latitude": "13.83386000",
                        "longitude": "-61.06410000"
                    },
                    {
                        "id": 66404,
                        "name": "Toraille",
                        "latitude": "13.85704000",
                        "longitude": "-61.03296000"
                    },
                    {
                        "id": 66405,
                        "name": "Town",
                        "latitude": "13.85491000",
                        "longitude": "-61.05764000"
                    },
                    {
                        "id": 66414,
                        "name": "Union Vale",
                        "latitude": "13.81103000",
                        "longitude": "-61.05686000"
                    },
                    {
                        "id": 66436,
                        "name": "Zenon",
                        "latitude": "13.85953000",
                        "longitude": "-61.03394000"
                    }
                ]
            },
            {
                "id": 3763,
                "name": "Vieux Fort",
                "iso2": "11",
                "latitude": "13.72060800",
                "longitude": "-60.94964330",
                "type": "district",
                "cities": [
                    {
                        "id": 65971,
                        "name": "Augier",
                        "latitude": "13.76669000",
                        "longitude": "-60.98063000"
                    },
                    {
                        "id": 65989,
                        "name": "Beane Field",
                        "latitude": "13.73976000",
                        "longitude": "-60.94741000"
                    },
                    {
                        "id": 65992,
                        "name": "Beausejour",
                        "latitude": "13.75229000",
                        "longitude": "-60.95519000"
                    },
                    {
                        "id": 66002,
                        "name": "Belle Vue",
                        "latitude": "13.79218000",
                        "longitude": "-60.95379000"
                    },
                    {
                        "id": 66012,
                        "name": "Black Bay",
                        "latitude": "13.74330000",
                        "longitude": "-60.98272000"
                    },
                    {
                        "id": 66032,
                        "name": "Bruceville\/Shanty Town",
                        "latitude": "13.72558000",
                        "longitude": "-60.94907000"
                    },
                    {
                        "id": 66034,
                        "name": "Cacoa",
                        "latitude": "13.77889000",
                        "longitude": "-60.93862000"
                    },
                    {
                        "id": 66042,
                        "name": "Cantonement",
                        "latitude": "13.75665000",
                        "longitude": "-60.97662000"
                    },
                    {
                        "id": 66054,
                        "name": "Carierre",
                        "latitude": "13.78514000",
                        "longitude": "-60.96721000"
                    },
                    {
                        "id": 66057,
                        "name": "Catin",
                        "latitude": "13.77694000",
                        "longitude": "-60.97973000"
                    },
                    {
                        "id": 66075,
                        "name": "Cocoa Dan",
                        "latitude": "13.73087000",
                        "longitude": "-60.97195000"
                    },
                    {
                        "id": 66081,
                        "name": "Coolie Town",
                        "latitude": "13.76911000",
                        "longitude": "-60.96680000"
                    },
                    {
                        "id": 66093,
                        "name": "De Mailly",
                        "latitude": "13.79649000",
                        "longitude": "-60.94938000"
                    },
                    {
                        "id": 66105,
                        "name": "Derierre Bois",
                        "latitude": "13.76807000",
                        "longitude": "-60.97725000"
                    },
                    {
                        "id": 66107,
                        "name": "Derierre Morne",
                        "latitude": "13.74126000",
                        "longitude": "-60.96057000"
                    },
                    {
                        "id": 66122,
                        "name": "Docamel\/La Resource",
                        "latitude": "13.74202000",
                        "longitude": "-60.95604000"
                    },
                    {
                        "id": 66129,
                        "name": "Eau Piquant\/St Urbain",
                        "latitude": "13.76025000",
                        "longitude": "-60.94012000"
                    },
                    {
                        "id": 66130,
                        "name": "En Bamboo",
                        "latitude": "13.78155000",
                        "longitude": "-60.94763000"
                    },
                    {
                        "id": 66135,
                        "name": "Esperance",
                        "latitude": "13.78854000",
                        "longitude": "-60.96108000"
                    },
                    {
                        "id": 66147,
                        "name": "Fond Capeche",
                        "latitude": "13.77449000",
                        "longitude": "-60.94835000"
                    },
                    {
                        "id": 66152,
                        "name": "Fond Sabot",
                        "latitude": "13.77659000",
                        "longitude": "-60.95546000"
                    },
                    {
                        "id": 66168,
                        "name": "Grace",
                        "latitude": "13.77678000",
                        "longitude": "-60.96637000"
                    },
                    {
                        "id": 66189,
                        "name": "Hewanorra Orchard",
                        "latitude": "13.74486000",
                        "longitude": "-60.97284000"
                    },
                    {
                        "id": 66193,
                        "name": "Hope Estate",
                        "latitude": "13.76477000",
                        "longitude": "-60.95831000"
                    },
                    {
                        "id": 66196,
                        "name": "Industrial Estate",
                        "latitude": "13.74096000",
                        "longitude": "-60.97393000"
                    },
                    {
                        "id": 66202,
                        "name": "Joyeux",
                        "latitude": "13.78313000",
                        "longitude": "-60.96068000"
                    },
                    {
                        "id": 66225,
                        "name": "La Resource",
                        "latitude": "13.74799000",
                        "longitude": "-60.96237000"
                    },
                    {
                        "id": 66227,
                        "name": "La Retraite",
                        "latitude": "13.75944000",
                        "longitude": "-60.96632000"
                    },
                    {
                        "id": 66230,
                        "name": "La Tourney\/Cedar Heights",
                        "latitude": "13.74114000",
                        "longitude": "-60.96517000"
                    },
                    {
                        "id": 66244,
                        "name": "Maganier",
                        "latitude": "13.79450000",
                        "longitude": "-60.98513000"
                    },
                    {
                        "id": 66293,
                        "name": "Morne Cayenne",
                        "latitude": "13.78349000",
                        "longitude": "-60.95506000"
                    },
                    {
                        "id": 66307,
                        "name": "Morne Vert",
                        "latitude": "13.77899000",
                        "longitude": "-60.97617000"
                    },
                    {
                        "id": 66310,
                        "name": "Moule A Chique",
                        "latitude": "13.71458000",
                        "longitude": "-60.94835000"
                    },
                    {
                        "id": 66317,
                        "name": "Obrier",
                        "latitude": "13.76831000",
                        "longitude": "-60.97313000"
                    },
                    {
                        "id": 66332,
                        "name": "Pierrot",
                        "latitude": "13.76857000",
                        "longitude": "-60.94381000"
                    },
                    {
                        "id": 66337,
                        "name": "Plut",
                        "latitude": "13.77417000",
                        "longitude": "-60.96076000"
                    },
                    {
                        "id": 66339,
                        "name": "Pomme",
                        "latitude": "13.75792000",
                        "longitude": "-60.98147000"
                    },
                    {
                        "id": 66380,
                        "name": "St Jude'S Highway",
                        "latitude": "13.75867000",
                        "longitude": "-60.97360000"
                    },
                    {
                        "id": 66394,
                        "name": "Tete Morne\/Morne Andrew",
                        "latitude": "13.77114000",
                        "longitude": "-60.95194000"
                    },
                    {
                        "id": 66406,
                        "name": "Town",
                        "latitude": "13.72835000",
                        "longitude": "-60.95408000"
                    },
                    {
                        "id": 66420,
                        "name": "Vieux Fort",
                        "latitude": "13.71667000",
                        "longitude": "-60.95000000"
                    },
                    {
                        "id": 66421,
                        "name": "Vieux Fort\/Laborie Highway",
                        "latitude": "13.73197000",
                        "longitude": "-60.95477000"
                    },
                    {
                        "id": 66422,
                        "name": "Vige'",
                        "latitude": "13.78692000",
                        "longitude": "-60.93550000"
                    },
                    {
                        "id": 66433,
                        "name": "Westall Group\/The Mangue",
                        "latitude": "13.72707000",
                        "longitude": "-60.95312000"
                    }
                ]
            }
        ]
    },
    {
        "id": 187,
        "name": "Saint Pierre and Miquelon",
        "iso3": "SPM",
        "iso2": "PM",
        "numeric_code": "666",
        "phonecode": "508",
        "capital": "Saint-Pierre",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".pm",
        "native": "Saint-Pierre-et-Miquelon",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Northern America",
        "subregion_id": 6,
        "nationality": "Saint-Pierrais or Miquelonnais",
        "timezones": [
            {
                "zoneName": "America\/Miquelon",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "PMDT",
                "tzName": "Pierre & Miquelon Daylight Time"
            }
        ],
        "translations": {
            "br": "Sant-Pêr-ha-Mikelon",
            "ko": "생피에르 미클롱",
            "pt-BR": "Saint-Pierre e Miquelon",
            "pt": "São Pedro e Miquelon",
            "nl": "Saint Pierre en Miquelon",
            "hr": "Sveti Petar i Mikelon",
            "fa": "سن پیر و میکلن",
            "de": "Saint-Pierre und Miquelon",
            "es": "San Pedro y Miquelón",
            "fr": "Saint-Pierre-et-Miquelon",
            "ja": "サンピエール島・ミクロン島",
            "it": "Saint-Pierre e Miquelon",
            "zh-CN": "圣皮埃尔和密克隆",
            "tr": "Saint Pierre Ve Miquelon",
            "ru": "Сен-Пьер и Микелон",
            "uk": "Сен-П'єр і Мікелон",
            "pl": "Saint-Pierre i Miquelon"
        },
        "latitude": "46.83333333",
        "longitude": "-56.33333333",
        "emoji": "🇵🇲",
        "emojiU": "U+1F1F5 U+1F1F2",
        "states": []
    },
    {
        "id": 188,
        "name": "Saint Vincent and the Grenadines",
        "iso3": "VCT",
        "iso2": "VC",
        "numeric_code": "670",
        "phonecode": "1",
        "capital": "Kingstown",
        "currency": "XCD",
        "currency_name": "Eastern Caribbean dollar",
        "currency_symbol": "$",
        "tld": ".vc",
        "native": "Saint Vincent and the Grenadines",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Saint Vincentian, Vincentian",
        "timezones": [
            {
                "zoneName": "America\/St_Vincent",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Sant-Visant hag ar Grenadinez",
            "ko": "세인트빈센트 그레나딘",
            "pt-BR": "São Vicente e Granadinas",
            "pt": "São Vicente e Granadinas",
            "nl": "Saint Vincent en de Grenadines",
            "hr": "Sveti Vincent i Grenadini",
            "fa": "سنت وینسنت و گرنادین‌ها",
            "de": "Saint Vincent und die Grenadinen",
            "es": "San Vicente y Granadinas",
            "fr": "Saint-Vincent-et-les-Grenadines",
            "ja": "セントビンセントおよびグレナディーン諸島",
            "it": "Saint Vincent e Grenadine",
            "zh-CN": "圣文森特和格林纳丁斯",
            "tr": "Saint Vincent Ve Grenadinler",
            "ru": "Сент-Винсент и Гренадины",
            "uk": "Сент-Вінсент і Гренадини",
            "pl": "Saint Vincent i Grenadyny"
        },
        "latitude": "13.25000000",
        "longitude": "-61.20000000",
        "emoji": "🇻🇨",
        "emojiU": "U+1F1FB U+1F1E8",
        "states": [
            {
                "id": 3389,
                "name": "Charlotte",
                "iso2": "01",
                "latitude": "13.21754510",
                "longitude": "-61.16362440",
                "type": "parish",
                "cities": [
                    {
                        "id": 130030,
                        "name": "Biabou",
                        "latitude": "13.19430000",
                        "longitude": "-61.13904000"
                    },
                    {
                        "id": 130031,
                        "name": "Byera Village",
                        "latitude": "13.25636000",
                        "longitude": "-61.11954000"
                    },
                    {
                        "id": 130033,
                        "name": "Georgetown",
                        "latitude": "13.28054000",
                        "longitude": "-61.11850000"
                    }
                ]
            },
            {
                "id": 3388,
                "name": "Grenadines",
                "iso2": "06",
                "latitude": "13.01229650",
                "longitude": "-61.22773010",
                "type": "parish",
                "cities": [
                    {
                        "id": 130037,
                        "name": "Port Elizabeth",
                        "latitude": "13.01102000",
                        "longitude": "-61.23548000"
                    }
                ]
            },
            {
                "id": 3386,
                "name": "Saint Andrew",
                "iso2": "02",
                "latitude": "43.02429990",
                "longitude": "-81.20250000",
                "type": "parish",
                "cities": [
                    {
                        "id": 130036,
                        "name": "Layou",
                        "latitude": "13.20175000",
                        "longitude": "-61.27014000"
                    }
                ]
            },
            {
                "id": 3387,
                "name": "Saint David",
                "iso2": "03",
                "latitude": "43.85230950",
                "longitude": "-79.52366540",
                "type": "parish",
                "cities": [
                    {
                        "id": 130032,
                        "name": "Chateaubelair",
                        "latitude": "13.29069000",
                        "longitude": "-61.24043000"
                    }
                ]
            },
            {
                "id": 3384,
                "name": "Saint George",
                "iso2": "04",
                "latitude": "42.95760900",
                "longitude": "-81.32670500",
                "type": "parish",
                "cities": [
                    {
                        "id": 130034,
                        "name": "Kingstown",
                        "latitude": "13.15527000",
                        "longitude": "-61.22742000"
                    },
                    {
                        "id": 130035,
                        "name": "Kingstown Park",
                        "latitude": "13.15924000",
                        "longitude": "-61.23161000"
                    }
                ]
            },
            {
                "id": 3385,
                "name": "Saint Patrick",
                "iso2": "05",
                "latitude": "39.75091860",
                "longitude": "-94.84505560",
                "type": "parish",
                "cities": [
                    {
                        "id": 130029,
                        "name": "Barrouallie",
                        "latitude": "13.23676000",
                        "longitude": "-61.27275000"
                    }
                ]
            }
        ]
    },
    {
        "id": 189,
        "name": "Saint-Barthelemy",
        "iso3": "BLM",
        "iso2": "BL",
        "numeric_code": "652",
        "phonecode": "590",
        "capital": "Gustavia",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".bl",
        "native": "Saint-Barthélemy",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Barthelemois",
        "timezones": [
            {
                "zoneName": "America\/St_Barthelemy",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Saint-Barthélemy",
            "ko": "생바르텔레미",
            "pt-BR": "São Bartolomeu",
            "pt": "São Bartolomeu",
            "nl": "Saint Barthélemy",
            "hr": "Saint Barthélemy",
            "fa": "سن-بارتلمی",
            "de": "Saint-Barthélemy",
            "es": "San Bartolomé",
            "fr": "Saint-Barthélemy",
            "ja": "サン・バルテルミー",
            "it": "Antille Francesi",
            "zh-CN": "圣巴泰勒米",
            "tr": "Saint Barthélemy",
            "ru": "Сен-Бартелеми",
            "uk": "Сен-Бартелемі",
            "pl": "Saint-Barthelemy"
        },
        "latitude": "18.50000000",
        "longitude": "-63.41666666",
        "emoji": "🇧🇱",
        "emojiU": "U+1F1E7 U+1F1F1",
        "states": []
    },
    {
        "id": 190,
        "name": "Saint-Martin (French part)",
        "iso3": "MAF",
        "iso2": "MF",
        "numeric_code": "663",
        "phonecode": "590",
        "capital": "Marigot",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".mf",
        "native": "Saint-Martin",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Saint-Martinoise",
        "timezones": [
            {
                "zoneName": "America\/Marigot",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Saint-Martin",
            "ko": "세인트마틴 섬",
            "pt-BR": "Saint Martin",
            "pt": "Ilha São Martinho",
            "nl": "Saint-Martin",
            "hr": "Sveti Martin",
            "fa": "سینت مارتن",
            "de": "Saint Martin",
            "es": "Saint Martin",
            "fr": "Saint-Martin",
            "ja": "サン・マルタン（フランス領）",
            "it": "Saint Martin",
            "zh-CN": "密克罗尼西亚",
            "tr": "Saint Martin",
            "ru": "Сен-Мартен (французская часть)",
            "uk": "Сен-Мартен (французька частина)",
            "pl": "Saint-Martin (część francuska)"
        },
        "latitude": "18.08333333",
        "longitude": "-63.95000000",
        "emoji": "🇲🇫",
        "emojiU": "U+1F1F2 U+1F1EB",
        "states": []
    },
    {
        "id": 191,
        "name": "Samoa",
        "iso3": "WSM",
        "iso2": "WS",
        "numeric_code": "882",
        "phonecode": "685",
        "capital": "Apia",
        "currency": "WST",
        "currency_name": "Samoan tālā",
        "currency_symbol": "SAT",
        "tld": ".ws",
        "native": "Samoa",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Polynesia",
        "subregion_id": 22,
        "nationality": "Samoan",
        "timezones": [
            {
                "zoneName": "Pacific\/Apia",
                "gmtOffset": 50400,
                "gmtOffsetName": "UTC+14:00",
                "abbreviation": "WST",
                "tzName": "West Samoa Time"
            }
        ],
        "translations": {
            "br": "Samoa",
            "ko": "사모아",
            "pt-BR": "Samoa",
            "pt": "Samoa",
            "nl": "Samoa",
            "hr": "Samoa",
            "fa": "ساموآ",
            "de": "Samoa",
            "es": "Samoa",
            "fr": "Samoa",
            "ja": "サモア",
            "it": "Samoa",
            "zh-CN": "萨摩亚",
            "tr": "Samoa",
            "ru": "Самоа",
            "uk": "Самоа",
            "pl": "Samoa"
        },
        "latitude": "-13.58333333",
        "longitude": "-172.33333333",
        "emoji": "🇼🇸",
        "emojiU": "U+1F1FC U+1F1F8",
        "states": [
            {
                "id": 4763,
                "name": "A'ana",
                "iso2": "AA",
                "latitude": "-13.89841800",
                "longitude": "-171.97529950",
                "type": "district",
                "cities": [
                    {
                        "id": 130647,
                        "name": "Fasito‘outa",
                        "latitude": "-13.81163000",
                        "longitude": "-171.94063000"
                    },
                    {
                        "id": 130649,
                        "name": "Leulumoega",
                        "latitude": "-13.82297000",
                        "longitude": "-171.96127000"
                    },
                    {
                        "id": 130655,
                        "name": "Nofoali‘i",
                        "latitude": "-13.82170000",
                        "longitude": "-171.95873000"
                    },
                    {
                        "id": 130658,
                        "name": "Satapuala",
                        "latitude": "-13.83535000",
                        "longitude": "-171.97963000"
                    }
                ]
            },
            {
                "id": 4761,
                "name": "Aiga-i-le-Tai",
                "iso2": "AL",
                "latitude": "-13.85137910",
                "longitude": "-172.03254010",
                "type": "district",
                "cities": [
                    {
                        "id": 130654,
                        "name": "Mulifanua",
                        "latitude": "-13.83183000",
                        "longitude": "-172.03602000"
                    }
                ]
            },
            {
                "id": 4765,
                "name": "Atua",
                "iso2": "AT",
                "latitude": "-13.97870530",
                "longitude": "-171.62542830",
                "type": "district",
                "cities": [
                    {
                        "id": 130646,
                        "name": "Falefa",
                        "latitude": "-13.88695000",
                        "longitude": "-171.58805000"
                    },
                    {
                        "id": 130650,
                        "name": "Lotofagā",
                        "latitude": "-13.97643000",
                        "longitude": "-171.85781000"
                    },
                    {
                        "id": 130651,
                        "name": "Lufilufi",
                        "latitude": "-13.87449000",
                        "longitude": "-171.59857000"
                    },
                    {
                        "id": 130659,
                        "name": "Solosolo",
                        "latitude": "-13.87504000",
                        "longitude": "-171.64181000"
                    }
                ]
            },
            {
                "id": 4764,
                "name": "Fa'asaleleaga",
                "iso2": "FA",
                "latitude": "-13.63076380",
                "longitude": "-172.23659810",
                "type": "district",
                "cities": []
            },
            {
                "id": 4769,
                "name": "Gaga'emauga",
                "iso2": "GE",
                "latitude": "-13.54286660",
                "longitude": "-172.36688700",
                "type": "district",
                "cities": []
            },
            {
                "id": 4771,
                "name": "Gaga'ifomauga",
                "iso2": "GI",
                "latitude": "-13.54680070",
                "longitude": "-172.49693310",
                "type": "district",
                "cities": [
                    {
                        "id": 130653,
                        "name": "Matavai",
                        "latitude": "-14.03208000",
                        "longitude": "-171.64768000"
                    },
                    {
                        "id": 130656,
                        "name": "Safotu",
                        "latitude": "-13.45132000",
                        "longitude": "-172.40177000"
                    }
                ]
            },
            {
                "id": 4767,
                "name": "Palauli",
                "iso2": "PA",
                "latitude": "-13.72945790",
                "longitude": "-172.45361150",
                "type": "district",
                "cities": [
                    {
                        "id": 130648,
                        "name": "Gataivai",
                        "latitude": "-13.77360000",
                        "longitude": "-172.38802000"
                    },
                    {
                        "id": 130661,
                        "name": "Vailoa",
                        "latitude": "-13.75551000",
                        "longitude": "-172.30698000"
                    }
                ]
            },
            {
                "id": 4762,
                "name": "Satupa'itea",
                "iso2": "SA",
                "latitude": "-13.65382140",
                "longitude": "-172.61592710",
                "type": "district",
                "cities": []
            },
            {
                "id": 4770,
                "name": "Tuamasaga",
                "iso2": "TU",
                "latitude": "-13.91635920",
                "longitude": "-171.82243620",
                "type": "district",
                "cities": [
                    {
                        "id": 130643,
                        "name": "Afega",
                        "latitude": "-13.79726000",
                        "longitude": "-171.85308000"
                    },
                    {
                        "id": 130644,
                        "name": "Apia",
                        "latitude": "-13.83333000",
                        "longitude": "-171.76666000"
                    },
                    {
                        "id": 130652,
                        "name": "Malie",
                        "latitude": "-13.80044000",
                        "longitude": "-171.84690000"
                    },
                    {
                        "id": 130660,
                        "name": "Vailima",
                        "latitude": "-13.86417000",
                        "longitude": "-171.76126000"
                    },
                    {
                        "id": 130662,
                        "name": "Vaiusu",
                        "latitude": "-13.82678000",
                        "longitude": "-171.79333000"
                    }
                ]
            },
            {
                "id": 4768,
                "name": "Va'a-o-Fonoti",
                "iso2": "VF",
                "latitude": "-13.94709030",
                "longitude": "-171.54318720",
                "type": "district",
                "cities": [
                    {
                        "id": 130657,
                        "name": "Samamea",
                        "latitude": "-13.93375000",
                        "longitude": "-171.53122000"
                    }
                ]
            },
            {
                "id": 4766,
                "name": "Vaisigano",
                "iso2": "VS",
                "latitude": "-13.54138270",
                "longitude": "-172.70233830",
                "type": "district",
                "cities": [
                    {
                        "id": 130645,
                        "name": "Asau",
                        "latitude": "-13.51963000",
                        "longitude": "-172.63784000"
                    }
                ]
            }
        ]
    },
    {
        "id": 192,
        "name": "San Marino",
        "iso3": "SMR",
        "iso2": "SM",
        "numeric_code": "674",
        "phonecode": "378",
        "capital": "San Marino",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".sm",
        "native": "San Marino",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Sammarinese",
        "timezones": [
            {
                "zoneName": "Europe\/San_Marino",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "San Marino",
            "ko": "산마리노",
            "pt-BR": "San Marino",
            "pt": "São Marinho",
            "nl": "San Marino",
            "hr": "San Marino",
            "fa": "سان مارینو",
            "de": "San Marino",
            "es": "San Marino",
            "fr": "Saint-Marin",
            "ja": "サンマリノ",
            "it": "San Marino",
            "zh-CN": "圣马力诺",
            "tr": "San Marino",
            "ru": "Сан-Марино",
            "uk": "Сан-Марино",
            "pl": "San Marino"
        },
        "latitude": "43.76666666",
        "longitude": "12.41666666",
        "emoji": "🇸🇲",
        "emojiU": "U+1F1F8 U+1F1F2",
        "states": [
            {
                "id": 59,
                "name": "Acquaviva",
                "iso2": "01",
                "latitude": "41.86715970",
                "longitude": "14.74694790",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104693,
                        "name": "Acquaviva",
                        "latitude": "43.94593000",
                        "longitude": "12.41850000"
                    }
                ]
            },
            {
                "id": 61,
                "name": "Borgo Maggiore",
                "iso2": "06",
                "latitude": "43.95748820",
                "longitude": "12.45525460",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104694,
                        "name": "Borgo Maggiore",
                        "latitude": "43.94193000",
                        "longitude": "12.44738000"
                    }
                ]
            },
            {
                "id": 60,
                "name": "Chiesanuova",
                "iso2": "02",
                "latitude": "45.42261720",
                "longitude": "7.65038540",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104699,
                        "name": "Poggio di Chiesanuova",
                        "latitude": "43.90451000",
                        "longitude": "12.42142000"
                    }
                ]
            },
            {
                "id": 64,
                "name": "Domagnano",
                "iso2": "03",
                "latitude": "43.95019290",
                "longitude": "12.46815370",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104695,
                        "name": "Domagnano",
                        "latitude": "43.94961000",
                        "longitude": "12.46828000"
                    }
                ]
            },
            {
                "id": 62,
                "name": "Faetano",
                "iso2": "04",
                "latitude": "43.93489670",
                "longitude": "12.48965540",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104696,
                        "name": "Faetano",
                        "latitude": "43.92831000",
                        "longitude": "12.49798000"
                    }
                ]
            },
            {
                "id": 66,
                "name": "Fiorentino",
                "iso2": "05",
                "latitude": "43.90783370",
                "longitude": "12.45812090",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104697,
                        "name": "Fiorentino",
                        "latitude": "43.91001000",
                        "longitude": "12.45738000"
                    }
                ]
            },
            {
                "id": 63,
                "name": "Montegiardino",
                "iso2": "08",
                "latitude": "43.90529990",
                "longitude": "12.48105420",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104698,
                        "name": "Monte Giardino",
                        "latitude": "43.90878000",
                        "longitude": "12.48201000"
                    }
                ]
            },
            {
                "id": 58,
                "name": "San Marino",
                "iso2": "07",
                "latitude": "43.94236000",
                "longitude": "12.45777700",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104700,
                        "name": "San Marino",
                        "latitude": "43.93667000",
                        "longitude": "12.44639000"
                    }
                ]
            },
            {
                "id": 65,
                "name": "Serravalle",
                "iso2": "09",
                "latitude": "44.72320840",
                "longitude": "8.85740050",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104701,
                        "name": "Serravalle",
                        "latitude": "43.96897000",
                        "longitude": "12.48167000"
                    }
                ]
            }
        ]
    },
    {
        "id": 193,
        "name": "Sao Tome and Principe",
        "iso3": "STP",
        "iso2": "ST",
        "numeric_code": "678",
        "phonecode": "239",
        "capital": "Sao Tome",
        "currency": "STN",
        "currency_name": "Dobra",
        "currency_symbol": "Db",
        "tld": ".st",
        "native": "São Tomé e Príncipe",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Middle Africa",
        "subregion_id": 2,
        "nationality": "Sao Tomean",
        "timezones": [
            {
                "zoneName": "Africa\/Sao_Tome",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "São Tomé ha Príncipe",
            "ko": "상투메 프린시페",
            "pt-BR": "São Tomé e Príncipe",
            "pt": "São Tomé e Príncipe",
            "nl": "Sao Tomé en Principe",
            "hr": "Sveti Toma i Princip",
            "fa": "کواترو دو فرویرو",
            "de": "São Tomé und Príncipe",
            "es": "Santo Tomé y Príncipe",
            "fr": "Sao Tomé-et-Principe",
            "ja": "サントメ・プリンシペ",
            "it": "São Tomé e Príncipe",
            "zh-CN": "圣多美和普林西比",
            "tr": "Sao Tome Ve Prinsipe",
            "ru": "Сан-Томе и Принсипи",
            "uk": "Сан-Томе і Принсіпі",
            "pl": "Wyspy Świętego Tomasza i Książęca"
        },
        "latitude": "1.00000000",
        "longitude": "7.00000000",
        "emoji": "🇸🇹",
        "emojiU": "U+1F1F8 U+1F1F9",
        "states": [
            {
                "id": 270,
                "name": "Príncipe",
                "iso2": "P",
                "latitude": "1.61393810",
                "longitude": "7.40569280",
                "type": "province",
                "cities": [
                    {
                        "id": 104837,
                        "name": "Santo António",
                        "latitude": "1.63943000",
                        "longitude": "7.41951000"
                    }
                ]
            },
            {
                "id": 271,
                "name": "São Tomé",
                "iso2": "S",
                "latitude": "0.33019240",
                "longitude": "6.73334300",
                "type": "province",
                "cities": [
                    {
                        "id": 104835,
                        "name": "Cantagalo District",
                        "latitude": "0.21667000",
                        "longitude": "6.70000000"
                    },
                    {
                        "id": 104836,
                        "name": "Caué District",
                        "latitude": "0.13415000",
                        "longitude": "6.63825000"
                    },
                    {
                        "id": 104838,
                        "name": "São Tomé",
                        "latitude": "0.33654000",
                        "longitude": "6.72732000"
                    },
                    {
                        "id": 104839,
                        "name": "Trindade",
                        "latitude": "0.29667000",
                        "longitude": "6.68139000"
                    }
                ]
            }
        ]
    },
    {
        "id": 194,
        "name": "Saudi Arabia",
        "iso3": "SAU",
        "iso2": "SA",
        "numeric_code": "682",
        "phonecode": "966",
        "capital": "Riyadh",
        "currency": "SAR",
        "currency_name": "Saudi riyal",
        "currency_symbol": "﷼",
        "tld": ".sa",
        "native": "المملكة العربية السعودية",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Saudi, Saudi Arabian",
        "timezones": [
            {
                "zoneName": "Asia\/Riyadh",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "br": "Arabia Saoudat",
            "ko": "사우디아라비아",
            "pt-BR": "Arábia Saudita",
            "pt": "Arábia Saudita",
            "nl": "Saoedi-Arabië",
            "hr": "Saudijska Arabija",
            "fa": "عربستان سعودی",
            "de": "Saudi-Arabien",
            "es": "Arabia Saudí",
            "fr": "Arabie Saoudite",
            "ja": "サウジアラビア",
            "it": "Arabia Saudita",
            "zh-CN": "沙特阿拉伯",
            "tr": "Suudi Arabistan",
            "ru": "Саудовская Аравия",
            "uk": "Саудівська Аравія",
            "pl": "Arabia Saudyjska"
        },
        "latitude": "25.00000000",
        "longitude": "45.00000000",
        "emoji": "🇸🇦",
        "emojiU": "U+1F1F8 U+1F1E6",
        "states": [
            {
                "id": 2853,
                "name": "'Asir",
                "iso2": "14",
                "latitude": "19.09690620",
                "longitude": "42.86378750",
                "type": "region",
                "cities": [
                    {
                        "id": 102804,
                        "name": "Abha",
                        "latitude": "18.21639000",
                        "longitude": "42.50528000"
                    },
                    {
                        "id": 102827,
                        "name": "Al Majāridah",
                        "latitude": "19.12361000",
                        "longitude": "41.91111000"
                    },
                    {
                        "id": 148594,
                        "name": "Al Qahab",
                        "latitude": "18.92560000",
                        "longitude": "41.95500000"
                    },
                    {
                        "id": 102861,
                        "name": "Khamis Mushait",
                        "latitude": "18.30000000",
                        "longitude": "42.73333000"
                    },
                    {
                        "id": 148596,
                        "name": "Ma`riyah",
                        "latitude": "18.85000000",
                        "longitude": "41.96670000"
                    },
                    {
                        "id": 148597,
                        "name": "Mifa",
                        "latitude": "18.89170000",
                        "longitude": "41.96330000"
                    },
                    {
                        "id": 148598,
                        "name": "Munayzir",
                        "latitude": "18.94640000",
                        "longitude": "41.91640000"
                    },
                    {
                        "id": 102882,
                        "name": "Tabālah",
                        "latitude": "19.95000000",
                        "longitude": "42.40000000"
                    }
                ]
            },
            {
                "id": 2859,
                "name": "Al Bahah",
                "iso2": "11",
                "latitude": "20.27227390",
                "longitude": "41.44125100",
                "type": "region",
                "cities": [
                    {
                        "id": 102815,
                        "name": "Al Bahah",
                        "latitude": "20.01288000",
                        "longitude": "41.46767000"
                    },
                    {
                        "id": 102829,
                        "name": "Al Mindak",
                        "latitude": "20.15880000",
                        "longitude": "41.28337000"
                    },
                    {
                        "id": 148708,
                        "name": "Hajrah",
                        "latitude": "20.23333333",
                        "longitude": "41.05000000"
                    }
                ]
            },
            {
                "id": 2857,
                "name": "Al Jawf",
                "iso2": "12",
                "latitude": "29.88735600",
                "longitude": "39.32062410",
                "type": "region",
                "cities": [
                    {
                        "id": 148588,
                        "name": "Al Isawiyah",
                        "latitude": "30.71681000",
                        "longitude": "37.97767000"
                    },
                    {
                        "id": 148589,
                        "name": "Al-Haditha",
                        "latitude": "31.45601100",
                        "longitude": "37.14814000"
                    },
                    {
                        "id": 148590,
                        "name": "Halat Ammar",
                        "latitude": "29.15944444",
                        "longitude": "36.07500000"
                    },
                    {
                        "id": 102872,
                        "name": "Qurayyat",
                        "latitude": "31.33176000",
                        "longitude": "37.34282000"
                    },
                    {
                        "id": 102877,
                        "name": "Sakakah",
                        "latitude": "29.96974000",
                        "longitude": "40.20641000"
                    },
                    {
                        "id": 102896,
                        "name": "Şuwayr",
                        "latitude": "30.11713000",
                        "longitude": "40.38925000"
                    },
                    {
                        "id": 148591,
                        "name": "Tabarjal",
                        "latitude": "30.50000000",
                        "longitude": "38.21670000"
                    },
                    {
                        "id": 102898,
                        "name": "Ţubarjal",
                        "latitude": "30.49987000",
                        "longitude": "38.21603000"
                    }
                ]
            },
            {
                "id": 2851,
                "name": "Al Madinah",
                "iso2": "03",
                "latitude": "24.84039770",
                "longitude": "39.32062410",
                "type": "region",
                "cities": [
                    {
                        "id": 148866,
                        "name": "`Ajmiyah",
                        "latitude": "24.21670000",
                        "longitude": "38.50000000"
                    },
                    {
                        "id": 148867,
                        "name": "`Alya'",
                        "latitude": "23.82360000",
                        "longitude": "38.88330000"
                    },
                    {
                        "id": 148868,
                        "name": "`Ushash",
                        "latitude": "23.50000000",
                        "longitude": "38.91670000"
                    },
                    {
                        "id": 148869,
                        "name": "`Ushayrah",
                        "latitude": "24.01860000",
                        "longitude": "39.67310000"
                    },
                    {
                        "id": 148804,
                        "name": "Abū Shayţānah",
                        "latitude": "23.86670000",
                        "longitude": "38.36670000"
                    },
                    {
                        "id": 148803,
                        "name": "Abyar 'Ali",
                        "latitude": "24.41666667",
                        "longitude": "39.55000000"
                    },
                    {
                        "id": 148805,
                        "name": "Ad Dulu`",
                        "latitude": "24.76670000",
                        "longitude": "39.53330000"
                    },
                    {
                        "id": 148823,
                        "name": "Al `Awali",
                        "latitude": "24.45000000",
                        "longitude": "39.61670000"
                    },
                    {
                        "id": 148824,
                        "name": "Al `Uqul",
                        "latitude": "24.50000000",
                        "longitude": "39.81670000"
                    },
                    {
                        "id": 148806,
                        "name": "Al Akhal",
                        "latitude": "23.31560000",
                        "longitude": "39.85940000"
                    },
                    {
                        "id": 148807,
                        "name": "Al Bardiyah",
                        "latitude": "24.04390000",
                        "longitude": "39.60610000"
                    },
                    {
                        "id": 148808,
                        "name": "Al Biqa'",
                        "latitude": "24.38861111",
                        "longitude": "38.59888889"
                    },
                    {
                        "id": 148809,
                        "name": "Al Bustan",
                        "latitude": "23.27830000",
                        "longitude": "39.24280000"
                    },
                    {
                        "id": 148810,
                        "name": "Al Faqirah",
                        "latitude": "23.42170000",
                        "longitude": "39.70970000"
                    },
                    {
                        "id": 148811,
                        "name": "Al Furaysh",
                        "latitude": "24.22000000",
                        "longitude": "39.28140000"
                    },
                    {
                        "id": 148813,
                        "name": "Al Jabriyah",
                        "latitude": "24.25000000",
                        "longitude": "38.51670000"
                    },
                    {
                        "id": 148814,
                        "name": "Al Jissah",
                        "latitude": "23.33330000",
                        "longitude": "40.30000000"
                    },
                    {
                        "id": 148815,
                        "name": "Al Kharma'",
                        "latitude": "23.90000000",
                        "longitude": "38.90000000"
                    },
                    {
                        "id": 148817,
                        "name": "Al Malbanah",
                        "latitude": "23.18330000",
                        "longitude": "39.51670000"
                    },
                    {
                        "id": 148818,
                        "name": "Al Mufrihat",
                        "latitude": "24.35000000",
                        "longitude": "39.41670000"
                    },
                    {
                        "id": 148819,
                        "name": "Al Multasa",
                        "latitude": "24.08330000",
                        "longitude": "38.15000000"
                    },
                    {
                        "id": 148820,
                        "name": "Al Musayjid",
                        "latitude": "24.08330000",
                        "longitude": "39.10000000"
                    },
                    {
                        "id": 148822,
                        "name": "Al Wuday",
                        "latitude": "24.17890000",
                        "longitude": "39.54810000"
                    },
                    {
                        "id": 148825,
                        "name": "Al-Jafr",
                        "latitude": "25.41666667",
                        "longitude": "49.61666667"
                    },
                    {
                        "id": 102839,
                        "name": "Al-Ula",
                        "latitude": "26.60853000",
                        "longitude": "37.92316000"
                    },
                    {
                        "id": 148827,
                        "name": "As Sadayir",
                        "latitude": "24.25000000",
                        "longitude": "39.18330000"
                    },
                    {
                        "id": 148828,
                        "name": "As Safra'",
                        "latitude": "24.01277778",
                        "longitude": "38.92277778"
                    },
                    {
                        "id": 148829,
                        "name": "As Sumariyah",
                        "latitude": "24.92140000",
                        "longitude": "39.61780000"
                    },
                    {
                        "id": 148830,
                        "name": "As Suwayriqiyah",
                        "latitude": "23.35000000",
                        "longitude": "40.31670000"
                    },
                    {
                        "id": 148831,
                        "name": "Ash Shufayyah",
                        "latitude": "23.81670000",
                        "longitude": "39.15000000"
                    },
                    {
                        "id": 148832,
                        "name": "Asira",
                        "latitude": "24.33330000",
                        "longitude": "38.63330000"
                    },
                    {
                        "id": 148833,
                        "name": "Baq`a'",
                        "latitude": "24.21666667",
                        "longitude": "38.71666667"
                    },
                    {
                        "id": 148834,
                        "name": "Bartiyah",
                        "latitude": "24.28330000",
                        "longitude": "38.58330000"
                    },
                    {
                        "id": 148835,
                        "name": "Bi'r al Mashi",
                        "latitude": "24.21666667",
                        "longitude": "39.55000000"
                    },
                    {
                        "id": 148836,
                        "name": "Birkah",
                        "latitude": "23.82030000",
                        "longitude": "38.85970000"
                    },
                    {
                        "id": 148839,
                        "name": "Far`",
                        "latitude": "23.81670000",
                        "longitude": "38.86670000"
                    },
                    {
                        "id": 148840,
                        "name": "Fiji",
                        "latitude": "24.26666667",
                        "longitude": "38.56666667"
                    },
                    {
                        "id": 148841,
                        "name": "Harthiyah",
                        "latitude": "24.25000000",
                        "longitude": "38.55000000"
                    },
                    {
                        "id": 148843,
                        "name": "Haylat Radi al Baham",
                        "latitude": "24.08390000",
                        "longitude": "39.72500000"
                    },
                    {
                        "id": 148844,
                        "name": "Husayniyah",
                        "latitude": "23.86666667",
                        "longitude": "38.90000000"
                    },
                    {
                        "id": 148845,
                        "name": "Jadidah",
                        "latitude": "23.81670000",
                        "longitude": "38.83330000"
                    },
                    {
                        "id": 148846,
                        "name": "Khayf Fadil",
                        "latitude": "24.26670000",
                        "longitude": "38.56670000"
                    },
                    {
                        "id": 148847,
                        "name": "Madsus",
                        "latitude": "24.35000000",
                        "longitude": "38.55000000"
                    },
                    {
                        "id": 148848,
                        "name": "Mahattat al Hafah",
                        "latitude": "23.75000000",
                        "longitude": "39.30000000"
                    },
                    {
                        "id": 148849,
                        "name": "Maqrah",
                        "latitude": "24.41670000",
                        "longitude": "38.70000000"
                    },
                    {
                        "id": 148850,
                        "name": "Maqshush",
                        "latitude": "23.58330000",
                        "longitude": "38.60000000"
                    },
                    {
                        "id": 148851,
                        "name": "Masahili",
                        "latitude": "24.03330000",
                        "longitude": "38.23330000"
                    },
                    {
                        "id": 148853,
                        "name": "Mawarah",
                        "latitude": "24.20000000",
                        "longitude": "38.43330000"
                    },
                    {
                        "id": 102865,
                        "name": "Medina",
                        "latitude": "24.46861000",
                        "longitude": "39.61417000"
                    },
                    {
                        "id": 148854,
                        "name": "Milhah",
                        "latitude": "24.05000000",
                        "longitude": "38.30000000"
                    },
                    {
                        "id": 148855,
                        "name": "Nujayl",
                        "latitude": "24.26670000",
                        "longitude": "38.65000000"
                    },
                    {
                        "id": 148856,
                        "name": "Qaba'",
                        "latitude": "24.40000000",
                        "longitude": "39.65000000"
                    },
                    {
                        "id": 148858,
                        "name": "Rayyis",
                        "latitude": "23.56670000",
                        "longitude": "38.60000000"
                    },
                    {
                        "id": 148859,
                        "name": "Sha`tha'",
                        "latitude": "24.23333333",
                        "longitude": "38.53333333"
                    },
                    {
                        "id": 148860,
                        "name": "Sidi Hamzah",
                        "latitude": "24.50000000",
                        "longitude": "39.61670000"
                    },
                    {
                        "id": 148861,
                        "name": "Suq Suwayq",
                        "latitude": "24.36670000",
                        "longitude": "38.45000000"
                    },
                    {
                        "id": 148862,
                        "name": "Suqubiya",
                        "latitude": "24.23330000",
                        "longitude": "38.50000000"
                    },
                    {
                        "id": 148863,
                        "name": "Suwadah",
                        "latitude": "24.03330000",
                        "longitude": "38.20000000"
                    },
                    {
                        "id": 148865,
                        "name": "Wasitah",
                        "latitude": "23.88330000",
                        "longitude": "38.90000000"
                    },
                    {
                        "id": 102892,
                        "name": "Yanbu",
                        "latitude": "24.08954000",
                        "longitude": "38.06180000"
                    }
                ]
            },
            {
                "id": 2861,
                "name": "Al-Qassim",
                "iso2": "05",
                "latitude": "26.20782600",
                "longitude": "43.48373800",
                "type": "region",
                "cities": [
                    {
                        "id": 102810,
                        "name": "Adh Dhibiyah",
                        "latitude": "26.02700000",
                        "longitude": "43.15700000"
                    },
                    {
                        "id": 102817,
                        "name": "Al Bukayrīyah",
                        "latitude": "26.13915000",
                        "longitude": "43.65782000"
                    },
                    {
                        "id": 102818,
                        "name": "Al Fuwayliq",
                        "latitude": "26.44360000",
                        "longitude": "43.25164000"
                    },
                    {
                        "id": 102830,
                        "name": "Al Mithnab",
                        "latitude": "25.86012000",
                        "longitude": "44.22228000"
                    },
                    {
                        "id": 148575,
                        "name": "Al Thybiyah",
                        "latitude": "26.02700000",
                        "longitude": "43.15700000"
                    },
                    {
                        "id": 102841,
                        "name": "Ar Rass",
                        "latitude": "25.86944000",
                        "longitude": "43.49730000"
                    },
                    {
                        "id": 148577,
                        "name": "Buraidah",
                        "latitude": "26.33333333",
                        "longitude": "43.96666667"
                    },
                    {
                        "id": 102850,
                        "name": "Buraydah",
                        "latitude": "26.32599000",
                        "longitude": "43.97497000"
                    },
                    {
                        "id": 148578,
                        "name": "Dukhnah",
                        "latitude": "25.35621000",
                        "longitude": "43.62268000"
                    },
                    {
                        "id": 148580,
                        "name": "Qiba",
                        "latitude": "27.40285000",
                        "longitude": "44.32770000"
                    },
                    {
                        "id": 102883,
                        "name": "Tanūmah",
                        "latitude": "27.10000000",
                        "longitude": "44.13333000"
                    },
                    {
                        "id": 102891,
                        "name": "Wed Alnkil",
                        "latitude": "25.42670000",
                        "longitude": "42.83430000"
                    }
                ]
            },
            {
                "id": 2856,
                "name": "Eastern Province",
                "iso2": "04",
                "latitude": "24.04399320",
                "longitude": "45.65892250",
                "type": "region",
                "cities": [
                    {
                        "id": 102805,
                        "name": "Abqaiq",
                        "latitude": "25.93402000",
                        "longitude": "49.66880000"
                    },
                    {
                        "id": 102814,
                        "name": "Al Awjām",
                        "latitude": "26.56324000",
                        "longitude": "49.94331000"
                    },
                    {
                        "id": 102816,
                        "name": "Al Baţţālīyah",
                        "latitude": "25.43333000",
                        "longitude": "49.63333000"
                    },
                    {
                        "id": 102820,
                        "name": "Al Hufūf",
                        "latitude": "25.36467000",
                        "longitude": "49.58764000"
                    },
                    {
                        "id": 102821,
                        "name": "Al Jafr",
                        "latitude": "25.37736000",
                        "longitude": "49.72154000"
                    },
                    {
                        "id": 102823,
                        "name": "Al Jubayl",
                        "latitude": "27.01740000",
                        "longitude": "49.62251000"
                    },
                    {
                        "id": 102825,
                        "name": "Al Khafjī",
                        "latitude": "28.43905000",
                        "longitude": "48.49132000"
                    },
                    {
                        "id": 102828,
                        "name": "Al Markaz",
                        "latitude": "25.40000000",
                        "longitude": "49.73333000"
                    },
                    {
                        "id": 102831,
                        "name": "Al Mubarraz",
                        "latitude": "25.40768000",
                        "longitude": "49.59028000"
                    },
                    {
                        "id": 102832,
                        "name": "Al Munayzilah",
                        "latitude": "25.38333000",
                        "longitude": "49.66667000"
                    },
                    {
                        "id": 102834,
                        "name": "Al Muţayrifī",
                        "latitude": "25.47878000",
                        "longitude": "49.55824000"
                    },
                    {
                        "id": 102837,
                        "name": "Al Qārah",
                        "latitude": "25.41667000",
                        "longitude": "49.66667000"
                    },
                    {
                        "id": 102835,
                        "name": "Al Qaţīf",
                        "latitude": "26.56542000",
                        "longitude": "50.00890000"
                    },
                    {
                        "id": 102836,
                        "name": "Al Qurayn",
                        "latitude": "25.48333000",
                        "longitude": "49.60000000"
                    },
                    {
                        "id": 148560,
                        "name": "Al Ubaylah",
                        "latitude": "21.98417000",
                        "longitude": "50.93966000"
                    },
                    {
                        "id": 148561,
                        "name": "Al-Awamiyah",
                        "latitude": "26.58333300",
                        "longitude": "49.98333300"
                    },
                    {
                        "id": 148562,
                        "name": "Al-Awjam",
                        "latitude": "26.55830000",
                        "longitude": "49.95030000"
                    },
                    {
                        "id": 148563,
                        "name": "Al-Mubarraz",
                        "latitude": "25.44160000",
                        "longitude": "49.66420000"
                    },
                    {
                        "id": 102843,
                        "name": "As Saffānīyah",
                        "latitude": "27.97083000",
                        "longitude": "48.73000000"
                    },
                    {
                        "id": 102848,
                        "name": "Aţ Ţaraf",
                        "latitude": "25.36232000",
                        "longitude": "49.72757000"
                    },
                    {
                        "id": 102846,
                        "name": "At Tūbī",
                        "latitude": "26.55778000",
                        "longitude": "49.99167000"
                    },
                    {
                        "id": 102851,
                        "name": "Dammam",
                        "latitude": "26.43442000",
                        "longitude": "50.10326000"
                    },
                    {
                        "id": 102852,
                        "name": "Dhahran",
                        "latitude": "26.28864000",
                        "longitude": "50.11396000"
                    },
                    {
                        "id": 148564,
                        "name": "Ha'il ",
                        "latitude": "27.51666667",
                        "longitude": "41.68333333"
                    },
                    {
                        "id": 102857,
                        "name": "Hafar Al-Batin",
                        "latitude": "28.43279000",
                        "longitude": "45.97077000"
                    },
                    {
                        "id": 148565,
                        "name": "Haradh",
                        "latitude": "24.14555556",
                        "longitude": "49.06527778"
                    },
                    {
                        "id": 102860,
                        "name": "Julayjilah",
                        "latitude": "25.50000000",
                        "longitude": "49.60000000"
                    },
                    {
                        "id": 102862,
                        "name": "Khobar",
                        "latitude": "26.27944000",
                        "longitude": "50.20833000"
                    },
                    {
                        "id": 102868,
                        "name": "Mulayjah",
                        "latitude": "27.27103000",
                        "longitude": "48.42419000"
                    },
                    {
                        "id": 148568,
                        "name": "Nariyah",
                        "latitude": "27.46990000",
                        "longitude": "48.48440000"
                    },
                    {
                        "id": 102870,
                        "name": "Qaisumah",
                        "latitude": "28.31117000",
                        "longitude": "46.12729000"
                    },
                    {
                        "id": 102873,
                        "name": "Raḩīmah",
                        "latitude": "26.70791000",
                        "longitude": "50.06194000"
                    },
                    {
                        "id": 102895,
                        "name": "Şafwá",
                        "latitude": "26.64970000",
                        "longitude": "49.95522000"
                    },
                    {
                        "id": 148571,
                        "name": "Sayhāt",
                        "latitude": "26.47500000",
                        "longitude": "50.04166667"
                    },
                    {
                        "id": 102888,
                        "name": "Tārūt",
                        "latitude": "26.57330000",
                        "longitude": "50.04028000"
                    },
                    {
                        "id": 148573,
                        "name": "Udhailiyah",
                        "latitude": "25.13330000",
                        "longitude": "49.30000000"
                    },
                    {
                        "id": 102890,
                        "name": "Umm as Sāhik",
                        "latitude": "26.65361000",
                        "longitude": "49.91639000"
                    },
                    {
                        "id": 148574,
                        "name": "Uqair",
                        "latitude": "25.64310000",
                        "longitude": "50.21440000"
                    }
                ]
            },
            {
                "id": 2855,
                "name": "Ha'il",
                "iso2": "06",
                "latitude": "27.70761430",
                "longitude": "41.91964710",
                "type": "region",
                "cities": [
                    {
                        "id": 148582,
                        "name": "Jubbah",
                        "latitude": "28.00620000",
                        "longitude": "40.94160000"
                    },
                    {
                        "id": 148583,
                        "name": "Mawqaq",
                        "latitude": "27.38398000",
                        "longitude": "41.17635000"
                    },
                    {
                        "id": 148584,
                        "name": "Qufar",
                        "latitude": "27.41534000",
                        "longitude": "41.61903000"
                    },
                    {
                        "id": 148585,
                        "name": "Simira",
                        "latitude": "26.49418000",
                        "longitude": "42.12494000"
                    }
                ]
            },
            {
                "id": 2858,
                "name": "Jizan",
                "iso2": "09",
                "latitude": "17.17381760",
                "longitude": "42.70761070",
                "type": "region",
                "cities": [
                    {
                        "id": 102806,
                        "name": "Abū ‘Arīsh",
                        "latitude": "16.96887000",
                        "longitude": "42.83251000"
                    },
                    {
                        "id": 148745,
                        "name": "Abu Radif",
                        "latitude": "16.61860000",
                        "longitude": "43.13110000"
                    },
                    {
                        "id": 102807,
                        "name": "Ad Darb",
                        "latitude": "17.72285000",
                        "longitude": "42.25261000"
                    },
                    {
                        "id": 148746,
                        "name": "Ad Dur`iyah",
                        "latitude": "16.58420000",
                        "longitude": "42.84310000"
                    },
                    {
                        "id": 148747,
                        "name": "Adh Dhagharir",
                        "latitude": "16.67780000",
                        "longitude": "42.95920000"
                    },
                    {
                        "id": 148775,
                        "name": "Al `Ulayin",
                        "latitude": "17.15000000",
                        "longitude": "43.17080000"
                    },
                    {
                        "id": 148776,
                        "name": "Al `Usaylah",
                        "latitude": "16.92030000",
                        "longitude": "42.73530000"
                    },
                    {
                        "id": 148748,
                        "name": "Al Badawi",
                        "latitude": "16.63330000",
                        "longitude": "42.86500000"
                    },
                    {
                        "id": 148749,
                        "name": "Al Hadrur",
                        "latitude": "16.54360000",
                        "longitude": "42.86720000"
                    },
                    {
                        "id": 148750,
                        "name": "Al Hanashah",
                        "latitude": "16.55810000",
                        "longitude": "42.76530000"
                    },
                    {
                        "id": 148751,
                        "name": "Al Harani",
                        "latitude": "16.77500000",
                        "longitude": "42.90970000"
                    },
                    {
                        "id": 148752,
                        "name": "Al Hasamah",
                        "latitude": "16.68333333",
                        "longitude": "42.92694444"
                    },
                    {
                        "id": 148753,
                        "name": "Al Hijfar",
                        "latitude": "16.54440000",
                        "longitude": "42.84720000"
                    },
                    {
                        "id": 148754,
                        "name": "Al Jadi",
                        "latitude": "16.64500000",
                        "longitude": "42.99470000"
                    },
                    {
                        "id": 102822,
                        "name": "Al Jarādīyah",
                        "latitude": "16.57946000",
                        "longitude": "42.91240000"
                    },
                    {
                        "id": 148755,
                        "name": "Al Jawah",
                        "latitude": "16.95670000",
                        "longitude": "43.02970000"
                    },
                    {
                        "id": 148756,
                        "name": "Al Jirbah",
                        "latitude": "16.92640000",
                        "longitude": "42.88610000"
                    },
                    {
                        "id": 148757,
                        "name": "Al Karbus",
                        "latitude": "16.87330000",
                        "longitude": "42.63170000"
                    },
                    {
                        "id": 148758,
                        "name": "Al Kawahilah",
                        "latitude": "16.96140000",
                        "longitude": "42.67250000"
                    },
                    {
                        "id": 148759,
                        "name": "Al Khadra' Jizan",
                        "latitude": "16.58583333",
                        "longitude": "42.96333333"
                    },
                    {
                        "id": 148760,
                        "name": "Al Kharabah Jizan",
                        "latitude": "16.75580000",
                        "longitude": "42.95470000"
                    },
                    {
                        "id": 148761,
                        "name": "Al Kharadilah",
                        "latitude": "16.92720000",
                        "longitude": "42.62640000"
                    },
                    {
                        "id": 148762,
                        "name": "Al Khashabiyah",
                        "latitude": "16.94030000",
                        "longitude": "42.64310000"
                    },
                    {
                        "id": 148763,
                        "name": "Al Khubah",
                        "latitude": "16.78860000",
                        "longitude": "43.22190000"
                    },
                    {
                        "id": 148764,
                        "name": "Al Kirs",
                        "latitude": "16.57720000",
                        "longitude": "42.94750000"
                    },
                    {
                        "id": 148765,
                        "name": "Al Luqiyah",
                        "latitude": "16.66060000",
                        "longitude": "43.04000000"
                    },
                    {
                        "id": 148766,
                        "name": "Al Ma`ayin",
                        "latitude": "16.61080000",
                        "longitude": "43.14720000"
                    },
                    {
                        "id": 148767,
                        "name": "Al Madaya",
                        "latitude": "16.76970000",
                        "longitude": "42.73110000"
                    },
                    {
                        "id": 148768,
                        "name": "Al Mali",
                        "latitude": "16.79530000",
                        "longitude": "42.95360000"
                    },
                    {
                        "id": 148769,
                        "name": "Al Mayasam",
                        "latitude": "16.94780000",
                        "longitude": "42.72110000"
                    },
                    {
                        "id": 148770,
                        "name": "Al Qa'im",
                        "latitude": "16.71944444",
                        "longitude": "42.97666667"
                    },
                    {
                        "id": 148771,
                        "name": "Al Quful",
                        "latitude": "16.67330000",
                        "longitude": "43.07890000"
                    },
                    {
                        "id": 148772,
                        "name": "Al Qurayb",
                        "latitude": "16.97500000",
                        "longitude": "42.72530000"
                    },
                    {
                        "id": 148773,
                        "name": "Al Quwah",
                        "latitude": "16.79940000",
                        "longitude": "43.22500000"
                    },
                    {
                        "id": 148774,
                        "name": "Al Wasili",
                        "latitude": "16.94690000",
                        "longitude": "42.69030000"
                    },
                    {
                        "id": 148777,
                        "name": "An Najamiyah",
                        "latitude": "16.56470000",
                        "longitude": "42.94390000"
                    },
                    {
                        "id": 148778,
                        "name": "Ar Rukubah",
                        "latitude": "16.62220000",
                        "longitude": "42.96750000"
                    },
                    {
                        "id": 148779,
                        "name": "Ash Shuqayq",
                        "latitude": "17.70305556",
                        "longitude": "42.02944444"
                    },
                    {
                        "id": 148780,
                        "name": "Bakhshat Yamani",
                        "latitude": "16.89860000",
                        "longitude": "42.59890000"
                    },
                    {
                        "id": 102854,
                        "name": "Farasān",
                        "latitude": "16.70222000",
                        "longitude": "42.11833000"
                    },
                    {
                        "id": 148781,
                        "name": "Ghawiyah",
                        "latitude": "16.56500000",
                        "longitude": "43.11080000"
                    },
                    {
                        "id": 148782,
                        "name": "Hamayyah",
                        "latitude": "16.98940000",
                        "longitude": "43.16030000"
                    },
                    {
                        "id": 148783,
                        "name": "Hamdah",
                        "latitude": "16.76190000",
                        "longitude": "42.92220000"
                    },
                    {
                        "id": 102859,
                        "name": "Jizan",
                        "latitude": "16.88917000",
                        "longitude": "42.55111000"
                    },
                    {
                        "id": 148784,
                        "name": "Juha Saudi Arabia",
                        "latitude": "16.66940000",
                        "longitude": "42.89220000"
                    },
                    {
                        "id": 148785,
                        "name": "Ka`lul",
                        "latitude": "16.89750000",
                        "longitude": "42.84670000"
                    },
                    {
                        "id": 148786,
                        "name": "Khabath Sa`id",
                        "latitude": "16.99780000",
                        "longitude": "42.73220000"
                    },
                    {
                        "id": 148787,
                        "name": "Khalfah",
                        "latitude": "16.55470000",
                        "longitude": "43.08940000"
                    },
                    {
                        "id": 148788,
                        "name": "Khatib Saudi Arabia",
                        "latitude": "16.89610000",
                        "longitude": "41.85750000"
                    },
                    {
                        "id": 148789,
                        "name": "Khumsiyah",
                        "latitude": "16.77140000",
                        "longitude": "42.80190000"
                    },
                    {
                        "id": 148790,
                        "name": "Khushaym",
                        "latitude": "16.88000000",
                        "longitude": "43.13720000"
                    },
                    {
                        "id": 148791,
                        "name": "Mahatah",
                        "latitude": "16.83330000",
                        "longitude": "43.16670000"
                    },
                    {
                        "id": 148792,
                        "name": "Malgocta",
                        "latitude": "16.99777778",
                        "longitude": "42.67388889"
                    },
                    {
                        "id": 102866,
                        "name": "Mislīyah",
                        "latitude": "17.45988000",
                        "longitude": "42.55720000"
                    },
                    {
                        "id": 102867,
                        "name": "Mizhirah",
                        "latitude": "16.82611000",
                        "longitude": "42.73333000"
                    },
                    {
                        "id": 148793,
                        "name": "Mukambal",
                        "latitude": "16.59360000",
                        "longitude": "43.03280000"
                    },
                    {
                        "id": 148794,
                        "name": "Mundaraq",
                        "latitude": "16.75420000",
                        "longitude": "43.14890000"
                    },
                    {
                        "id": 148795,
                        "name": "Muwassam",
                        "latitude": "16.41670000",
                        "longitude": "42.82580000"
                    },
                    {
                        "id": 148796,
                        "name": "Qitabir",
                        "latitude": "17.33330000",
                        "longitude": "43.25000000"
                    },
                    {
                        "id": 148797,
                        "name": "Quwayda'",
                        "latitude": "16.73333333",
                        "longitude": "42.89027778"
                    },
                    {
                        "id": 148798,
                        "name": "Rahwan",
                        "latitude": "16.83330000",
                        "longitude": "43.21670000"
                    },
                    {
                        "id": 148799,
                        "name": "Rawkhah",
                        "latitude": "16.94780000",
                        "longitude": "42.79330000"
                    },
                    {
                        "id": 102894,
                        "name": "Şabyā",
                        "latitude": "17.14950000",
                        "longitude": "42.62537000"
                    },
                    {
                        "id": 148800,
                        "name": "Sadiliyah",
                        "latitude": "16.92640000",
                        "longitude": "42.83000000"
                    },
                    {
                        "id": 148801,
                        "name": "Salamah",
                        "latitude": "16.97530000",
                        "longitude": "42.75640000"
                    },
                    {
                        "id": 102897,
                        "name": "Şāmitah",
                        "latitude": "16.59601000",
                        "longitude": "42.94435000"
                    }
                ]
            },
            {
                "id": 2850,
                "name": "Makkah",
                "iso2": "02",
                "latitude": "21.52355840",
                "longitude": "41.91964710",
                "type": "region",
                "cities": [
                    {
                        "id": 148874,
                        "name": "Abu `Urwah",
                        "latitude": "21.65000000",
                        "longitude": "39.70000000"
                    },
                    {
                        "id": 148871,
                        "name": "Abu Hisani",
                        "latitude": "21.73060000",
                        "longitude": "39.78330000"
                    },
                    {
                        "id": 148872,
                        "name": "Abu Qirfah",
                        "latitude": "21.76670000",
                        "longitude": "39.68330000"
                    },
                    {
                        "id": 148873,
                        "name": "Abu Shu`ayb",
                        "latitude": "21.58330000",
                        "longitude": "39.70000000"
                    },
                    {
                        "id": 148875,
                        "name": "Ad Dabbah",
                        "latitude": "21.71670000",
                        "longitude": "39.83330000"
                    },
                    {
                        "id": 148876,
                        "name": "Ad Dawh",
                        "latitude": "21.77220000",
                        "longitude": "39.70140000"
                    },
                    {
                        "id": 148877,
                        "name": "Ad Dur",
                        "latitude": "21.81670000",
                        "longitude": "39.76670000"
                    },
                    {
                        "id": 148935,
                        "name": "Al Ābār",
                        "latitude": "21.09810000",
                        "longitude": "39.91030000"
                    },
                    {
                        "id": 148878,
                        "name": "Al Adl",
                        "latitude": "21.44361000",
                        "longitude": "39.85611000"
                    },
                    {
                        "id": 148879,
                        "name": "Al Ashraf",
                        "latitude": "21.52360000",
                        "longitude": "39.61670000"
                    },
                    {
                        "id": 148880,
                        "name": "Al Balad",
                        "latitude": "21.48780000",
                        "longitude": "39.19360000"
                    },
                    {
                        "id": 148881,
                        "name": "Al Barabir",
                        "latitude": "21.52030000",
                        "longitude": "39.63250000"
                    },
                    {
                        "id": 148882,
                        "name": "Al Bi'ar",
                        "latitude": "22.64972222",
                        "longitude": "39.67027778"
                    },
                    {
                        "id": 148883,
                        "name": "Al Birk",
                        "latitude": "18.21631000",
                        "longitude": "41.53593000"
                    },
                    {
                        "id": 148884,
                        "name": "Al Buraykah",
                        "latitude": "21.78610000",
                        "longitude": "39.71670000"
                    },
                    {
                        "id": 148885,
                        "name": "Al Fawwarah",
                        "latitude": "21.83280000",
                        "longitude": "40.16110000"
                    },
                    {
                        "id": 148886,
                        "name": "Al Faydah",
                        "latitude": "21.98440000",
                        "longitude": "39.38470000"
                    },
                    {
                        "id": 148887,
                        "name": "Al Fazz",
                        "latitude": "21.98330000",
                        "longitude": "39.52220000"
                    },
                    {
                        "id": 148888,
                        "name": "Al Gharith",
                        "latitude": "21.60000000",
                        "longitude": "41.88330000"
                    },
                    {
                        "id": 148889,
                        "name": "Al Ghassalah",
                        "latitude": "21.45000000",
                        "longitude": "39.86670000"
                    },
                    {
                        "id": 148890,
                        "name": "Al Ghulah",
                        "latitude": "21.95000000",
                        "longitude": "39.31670000"
                    },
                    {
                        "id": 102819,
                        "name": "Al Hadā",
                        "latitude": "21.36753000",
                        "longitude": "40.28694000"
                    },
                    {
                        "id": 148891,
                        "name": "Al Halaqah",
                        "latitude": "21.35000000",
                        "longitude": "40.45000000"
                    },
                    {
                        "id": 148892,
                        "name": "Al Hamimah",
                        "latitude": "21.51670000",
                        "longitude": "39.63330000"
                    },
                    {
                        "id": 148893,
                        "name": "Al Harra' Makkah",
                        "latitude": "21.95000000",
                        "longitude": "39.48333333"
                    },
                    {
                        "id": 148894,
                        "name": "Al Hawiyah",
                        "latitude": "21.42415000",
                        "longitude": "40.49303000"
                    },
                    {
                        "id": 148895,
                        "name": "Al Iskan",
                        "latitude": "21.40000000",
                        "longitude": "39.78330000"
                    },
                    {
                        "id": 148896,
                        "name": "Al Jadidah",
                        "latitude": "21.67030000",
                        "longitude": "40.12640000"
                    },
                    {
                        "id": 148897,
                        "name": "Al Jami`ah",
                        "latitude": "21.46670000",
                        "longitude": "39.25000000"
                    },
                    {
                        "id": 148898,
                        "name": "Al Jid`",
                        "latitude": "21.93330000",
                        "longitude": "39.58330000"
                    },
                    {
                        "id": 148899,
                        "name": "Al Ju`ranah",
                        "latitude": "21.56670000",
                        "longitude": "39.95000000"
                    },
                    {
                        "id": 102824,
                        "name": "Al Jumūm",
                        "latitude": "21.61694000",
                        "longitude": "39.69806000"
                    },
                    {
                        "id": 148900,
                        "name": "Al Khadra' Makkah",
                        "latitude": "21.46777778",
                        "longitude": "39.90472222"
                    },
                    {
                        "id": 148901,
                        "name": "Al Khalas",
                        "latitude": "21.70000000",
                        "longitude": "39.80000000"
                    },
                    {
                        "id": 148902,
                        "name": "Al Khamrah",
                        "latitude": "22.43330000",
                        "longitude": "39.46670000"
                    },
                    {
                        "id": 148903,
                        "name": "Al Khaydar",
                        "latitude": "21.46940000",
                        "longitude": "40.63060000"
                    },
                    {
                        "id": 148904,
                        "name": "Al Khayf",
                        "latitude": "21.68330000",
                        "longitude": "39.73330000"
                    },
                    {
                        "id": 148905,
                        "name": "Al Khulasah",
                        "latitude": "21.68330000",
                        "longitude": "39.91670000"
                    },
                    {
                        "id": 148906,
                        "name": "Al Kidwah",
                        "latitude": "21.78330000",
                        "longitude": "39.68330000"
                    },
                    {
                        "id": 148907,
                        "name": "Al Kura`",
                        "latitude": "21.80000000",
                        "longitude": "39.13330000"
                    },
                    {
                        "id": 148908,
                        "name": "Al Ma`rash",
                        "latitude": "21.13330000",
                        "longitude": "40.60000000"
                    },
                    {
                        "id": 148909,
                        "name": "Al Madiq Makkah",
                        "latitude": "21.67580000",
                        "longitude": "40.13080000"
                    },
                    {
                        "id": 148910,
                        "name": "Al Maghal",
                        "latitude": "21.96670000",
                        "longitude": "39.55000000"
                    },
                    {
                        "id": 148911,
                        "name": "Al Mahjar",
                        "latitude": "21.43330000",
                        "longitude": "39.20000000"
                    },
                    {
                        "id": 148913,
                        "name": "Al Maqrah",
                        "latitude": "21.26670000",
                        "longitude": "39.95000000"
                    },
                    {
                        "id": 148914,
                        "name": "Al Masarrah",
                        "latitude": "21.36670000",
                        "longitude": "40.46670000"
                    },
                    {
                        "id": 148915,
                        "name": "Al Masfalah",
                        "latitude": "21.41670000",
                        "longitude": "39.81670000"
                    },
                    {
                        "id": 148916,
                        "name": "Al Mashayikh",
                        "latitude": "21.35000000",
                        "longitude": "40.33330000"
                    },
                    {
                        "id": 148917,
                        "name": "Al Mathnah",
                        "latitude": "21.26666667",
                        "longitude": "40.38333333"
                    },
                    {
                        "id": 148918,
                        "name": "Al Mubarak",
                        "latitude": "21.70000000",
                        "longitude": "39.90000000"
                    },
                    {
                        "id": 148919,
                        "name": "Al Mudawwarah",
                        "latitude": "21.26670000",
                        "longitude": "39.96670000"
                    },
                    {
                        "id": 148920,
                        "name": "Al Mulayha'",
                        "latitude": "21.80000000",
                        "longitude": "40.35000000"
                    },
                    {
                        "id": 148921,
                        "name": "Al Mundassah",
                        "latitude": "21.63330000",
                        "longitude": "39.74860000"
                    },
                    {
                        "id": 148922,
                        "name": "Al Muqayti`",
                        "latitude": "21.54860000",
                        "longitude": "39.78610000"
                    },
                    {
                        "id": 148923,
                        "name": "Al Muqr",
                        "latitude": "22.00000000",
                        "longitude": "39.38330000"
                    },
                    {
                        "id": 102833,
                        "name": "Al Muwayh",
                        "latitude": "22.43333000",
                        "longitude": "41.75829000"
                    },
                    {
                        "id": 148924,
                        "name": "Al Qadimah",
                        "latitude": "22.35000000",
                        "longitude": "39.15000000"
                    },
                    {
                        "id": 148926,
                        "name": "Al Qararah",
                        "latitude": "21.42890000",
                        "longitude": "39.82810000"
                    },
                    {
                        "id": 148927,
                        "name": "Al Qaryat",
                        "latitude": "21.46670000",
                        "longitude": "39.20000000"
                    },
                    {
                        "id": 148928,
                        "name": "Al Qawba`iyah",
                        "latitude": "21.66670000",
                        "longitude": "39.98330000"
                    },
                    {
                        "id": 148929,
                        "name": "Al Qirshan",
                        "latitude": "21.56670000",
                        "longitude": "39.70000000"
                    },
                    {
                        "id": 148930,
                        "name": "Al Qu`tubah",
                        "latitude": "21.93330000",
                        "longitude": "40.36670000"
                    },
                    {
                        "id": 148931,
                        "name": "Al Qufayf",
                        "latitude": "21.83330000",
                        "longitude": "40.45000000"
                    },
                    {
                        "id": 148932,
                        "name": "Al Qushashiyah",
                        "latitude": "21.43330000",
                        "longitude": "39.83330000"
                    },
                    {
                        "id": 148933,
                        "name": "Al Ukhaydir",
                        "latitude": "21.93330000",
                        "longitude": "40.01670000"
                    },
                    {
                        "id": 148934,
                        "name": "Al Waht",
                        "latitude": "21.23330000",
                        "longitude": "40.35000000"
                    },
                    {
                        "id": 148936,
                        "name": "Ar Rabwah as Sufla",
                        "latitude": "21.95530000",
                        "longitude": "39.43670000"
                    },
                    {
                        "id": 148937,
                        "name": "Ar Rafah",
                        "latitude": "21.51670000",
                        "longitude": "40.20000000"
                    },
                    {
                        "id": 148938,
                        "name": "Ar Rawdah ash Shamaliyah",
                        "latitude": "21.73330000",
                        "longitude": "39.96670000"
                    },
                    {
                        "id": 148939,
                        "name": "Ar Rudaymah",
                        "latitude": "21.76670000",
                        "longitude": "39.68330000"
                    },
                    {
                        "id": 148940,
                        "name": "Arya`",
                        "latitude": "21.08560000",
                        "longitude": "40.62390000"
                    },
                    {
                        "id": 148941,
                        "name": "As Sadr",
                        "latitude": "21.51890000",
                        "longitude": "40.19750000"
                    },
                    {
                        "id": 148942,
                        "name": "As Samd ash Shamali",
                        "latitude": "21.67500000",
                        "longitude": "39.75000000"
                    },
                    {
                        "id": 148943,
                        "name": "As Sayl al Kabir",
                        "latitude": "21.62640000",
                        "longitude": "40.41530000"
                    },
                    {
                        "id": 148944,
                        "name": "As Sayl as Saghir",
                        "latitude": "21.50640000",
                        "longitude": "40.48220000"
                    },
                    {
                        "id": 148945,
                        "name": "As Sifyani",
                        "latitude": "21.47560000",
                        "longitude": "39.84310000"
                    },
                    {
                        "id": 148946,
                        "name": "As Sudayrah Makkah",
                        "latitude": "21.36190000",
                        "longitude": "40.85470000"
                    },
                    {
                        "id": 148947,
                        "name": "As Suwadah",
                        "latitude": "21.13390000",
                        "longitude": "40.51170000"
                    },
                    {
                        "id": 102845,
                        "name": "Ash Shafā",
                        "latitude": "21.07210000",
                        "longitude": "40.31185000"
                    },
                    {
                        "id": 148948,
                        "name": "Ash Shajwah",
                        "latitude": "21.66440000",
                        "longitude": "40.01140000"
                    },
                    {
                        "id": 148949,
                        "name": "Ash Shamiyah",
                        "latitude": "21.84110000",
                        "longitude": "39.52440000"
                    },
                    {
                        "id": 148950,
                        "name": "Ash Shara'i`",
                        "latitude": "21.46305556",
                        "longitude": "39.94611111"
                    },
                    {
                        "id": 148951,
                        "name": "Ash Shaybi",
                        "latitude": "21.69580000",
                        "longitude": "39.94170000"
                    },
                    {
                        "id": 148952,
                        "name": "Ash Shi`b",
                        "latitude": "21.96890000",
                        "longitude": "39.48610000"
                    },
                    {
                        "id": 148953,
                        "name": "Ash Shishah",
                        "latitude": "21.35030000",
                        "longitude": "39.89190000"
                    },
                    {
                        "id": 148954,
                        "name": "Ash Shumaysi",
                        "latitude": "21.58330000",
                        "longitude": "39.68330000"
                    },
                    {
                        "id": 148955,
                        "name": "Ash Shuwaybit",
                        "latitude": "21.37970000",
                        "longitude": "40.51940000"
                    },
                    {
                        "id": 148956,
                        "name": "At Tan`im",
                        "latitude": "21.48250000",
                        "longitude": "39.80500000"
                    },
                    {
                        "id": 148957,
                        "name": "At Tarfa'",
                        "latitude": "21.70638889",
                        "longitude": "39.87138889"
                    },
                    {
                        "id": 148958,
                        "name": "At Turqi",
                        "latitude": "21.94920000",
                        "longitude": "39.41310000"
                    },
                    {
                        "id": 148959,
                        "name": "Az Zaymah",
                        "latitude": "21.61860000",
                        "longitude": "40.11330000"
                    },
                    {
                        "id": 148960,
                        "name": "Az Zilal",
                        "latitude": "21.48890000",
                        "longitude": "39.59420000"
                    },
                    {
                        "id": 148961,
                        "name": "Az Zughbah",
                        "latitude": "21.71670000",
                        "longitude": "39.94580000"
                    },
                    {
                        "id": 148962,
                        "name": "Az Zurra`",
                        "latitude": "21.91060000",
                        "longitude": "39.40000000"
                    },
                    {
                        "id": 148963,
                        "name": "Az Zuwayb",
                        "latitude": "21.91670000",
                        "longitude": "39.96940000"
                    },
                    {
                        "id": 148964,
                        "name": "Bahrat al Qadimah",
                        "latitude": "21.41330000",
                        "longitude": "39.49390000"
                    },
                    {
                        "id": 148965,
                        "name": "Bahwil",
                        "latitude": "22.42940000",
                        "longitude": "39.42940000"
                    },
                    {
                        "id": 148966,
                        "name": "Baranah",
                        "latitude": "21.55420000",
                        "longitude": "39.82220000"
                    },
                    {
                        "id": 148967,
                        "name": "Barzah",
                        "latitude": "21.98000000",
                        "longitude": "39.67560000"
                    },
                    {
                        "id": 148968,
                        "name": "Bashm",
                        "latitude": "21.48220000",
                        "longitude": "39.82080000"
                    },
                    {
                        "id": 148969,
                        "name": "Buraykah",
                        "latitude": "22.34440000",
                        "longitude": "39.32000000"
                    },
                    {
                        "id": 148970,
                        "name": "Burayman",
                        "latitude": "21.63750000",
                        "longitude": "39.22640000"
                    },
                    {
                        "id": 148971,
                        "name": "CITY GHRAN",
                        "latitude": "21.97380000",
                        "longitude": "39.36820000"
                    },
                    {
                        "id": 148972,
                        "name": "Dabyah",
                        "latitude": "22.42470000",
                        "longitude": "39.44610000"
                    },
                    {
                        "id": 148973,
                        "name": "Dahaban",
                        "latitude": "21.93333333",
                        "longitude": "39.11666667"
                    },
                    {
                        "id": 148974,
                        "name": "Dughaybjah",
                        "latitude": "22.59030000",
                        "longitude": "41.35970000"
                    },
                    {
                        "id": 148975,
                        "name": "Fayd",
                        "latitude": "21.91720000",
                        "longitude": "39.38830000"
                    },
                    {
                        "id": 102855,
                        "name": "Ghran",
                        "latitude": "21.98027000",
                        "longitude": "39.36521000"
                    },
                    {
                        "id": 148976,
                        "name": "Hadda'",
                        "latitude": "21.45027778",
                        "longitude": "39.55444444"
                    },
                    {
                        "id": 148977,
                        "name": "Haddat ash Sham",
                        "latitude": "21.79670000",
                        "longitude": "39.68330000"
                    },
                    {
                        "id": 148978,
                        "name": "Hadhah",
                        "latitude": "21.65250000",
                        "longitude": "40.01420000"
                    },
                    {
                        "id": 148979,
                        "name": "Hajur",
                        "latitude": "23.01780000",
                        "longitude": "39.73030000"
                    },
                    {
                        "id": 148980,
                        "name": "Halamah",
                        "latitude": "21.95420000",
                        "longitude": "39.70280000"
                    },
                    {
                        "id": 148981,
                        "name": "Husnah",
                        "latitude": "21.80000000",
                        "longitude": "39.59166667"
                    },
                    {
                        "id": 148982,
                        "name": "Jarwal",
                        "latitude": "21.43330000",
                        "longitude": "39.81670000"
                    },
                    {
                        "id": 102858,
                        "name": "Jeddah",
                        "latitude": "21.54238000",
                        "longitude": "39.19797000"
                    },
                    {
                        "id": 148983,
                        "name": "Julayyil",
                        "latitude": "21.95830000",
                        "longitude": "39.75830000"
                    },
                    {
                        "id": 148985,
                        "name": "Khumrah",
                        "latitude": "21.37280000",
                        "longitude": "39.22610000"
                    },
                    {
                        "id": 148986,
                        "name": "Kulakh",
                        "latitude": "21.29640000",
                        "longitude": "40.79690000"
                    },
                    {
                        "id": 148988,
                        "name": "Madrakah",
                        "latitude": "21.97970000",
                        "longitude": "39.98750000"
                    },
                    {
                        "id": 148989,
                        "name": "Mafruq",
                        "latitude": "21.52220000",
                        "longitude": "40.17940000"
                    },
                    {
                        "id": 148990,
                        "name": "Malakan",
                        "latitude": "21.21580000",
                        "longitude": "39.95030000"
                    },
                    {
                        "id": 148991,
                        "name": "Mashajji",
                        "latitude": "21.73890000",
                        "longitude": "39.96670000"
                    },
                    {
                        "id": 148992,
                        "name": "Masihat Mahd al Hayl",
                        "latitude": "21.94170000",
                        "longitude": "39.88610000"
                    },
                    {
                        "id": 148993,
                        "name": "Maskar",
                        "latitude": "21.75000000",
                        "longitude": "40.31640000"
                    },
                    {
                        "id": 148994,
                        "name": "Matiyah",
                        "latitude": "21.54170000",
                        "longitude": "39.81940000"
                    },
                    {
                        "id": 102864,
                        "name": "Mecca",
                        "latitude": "21.42664000",
                        "longitude": "39.82563000"
                    },
                    {
                        "id": 148996,
                        "name": "Mina",
                        "latitude": "21.41333333",
                        "longitude": "39.89333333"
                    },
                    {
                        "id": 148998,
                        "name": "Murshidiyah",
                        "latitude": "21.48890000",
                        "longitude": "39.79440000"
                    },
                    {
                        "id": 148999,
                        "name": "Mushrif",
                        "latitude": "22.62920000",
                        "longitude": "41.35670000"
                    },
                    {
                        "id": 149000,
                        "name": "Nughayshiyah",
                        "latitude": "21.21670000",
                        "longitude": "40.75000000"
                    },
                    {
                        "id": 149001,
                        "name": "Nuzlat al Faqin",
                        "latitude": "22.00000000",
                        "longitude": "39.41670000"
                    },
                    {
                        "id": 149002,
                        "name": "Qiya",
                        "latitude": "21.06670000",
                        "longitude": "41.01670000"
                    },
                    {
                        "id": 149003,
                        "name": "Quwayzah",
                        "latitude": "21.49030000",
                        "longitude": "39.27670000"
                    },
                    {
                        "id": 102875,
                        "name": "Rābigh",
                        "latitude": "22.79856000",
                        "longitude": "39.03493000"
                    },
                    {
                        "id": 149004,
                        "name": "Rabwah Ghran",
                        "latitude": "21.98330000",
                        "longitude": "39.41670000"
                    },
                    {
                        "id": 149005,
                        "name": "Raqiyah",
                        "latitude": "21.76670000",
                        "longitude": "40.35000000"
                    },
                    {
                        "id": 149006,
                        "name": "Sabuhah",
                        "latitude": "21.58330000",
                        "longitude": "40.11670000"
                    },
                    {
                        "id": 149007,
                        "name": "Shi`b `amir",
                        "latitude": "21.43330000",
                        "longitude": "39.83330000"
                    },
                    {
                        "id": 149008,
                        "name": "Shira`ayn",
                        "latitude": "21.28330000",
                        "longitude": "40.78330000"
                    },
                    {
                        "id": 149009,
                        "name": "Sulaym",
                        "latitude": "22.58330000",
                        "longitude": "39.63330000"
                    },
                    {
                        "id": 149010,
                        "name": "Sumaymah",
                        "latitude": "21.25000000",
                        "longitude": "39.16670000"
                    },
                    {
                        "id": 149011,
                        "name": "Suways",
                        "latitude": "21.95000000",
                        "longitude": "39.96670000"
                    },
                    {
                        "id": 102884,
                        "name": "Ta'if",
                        "latitude": "21.27028000",
                        "longitude": "40.41583000"
                    },
                    {
                        "id": 149013,
                        "name": "Tharwah",
                        "latitude": "21.51670000",
                        "longitude": "39.61670000"
                    },
                    {
                        "id": 149014,
                        "name": "Thuwal",
                        "latitude": "22.28333333",
                        "longitude": "39.10000000"
                    },
                    {
                        "id": 102886,
                        "name": "Turabah",
                        "latitude": "21.21406000",
                        "longitude": "41.63310000"
                    },
                    {
                        "id": 149015,
                        "name": "Usfan",
                        "latitude": "21.92306000",
                        "longitude": "39.35594000"
                    },
                    {
                        "id": 149016,
                        "name": "Wadi al Jalil",
                        "latitude": "21.46670000",
                        "longitude": "39.85000000"
                    }
                ]
            },
            {
                "id": 2860,
                "name": "Najran",
                "iso2": "10",
                "latitude": "18.35146640",
                "longitude": "45.60071080",
                "type": "region",
                "cities": [
                    {
                        "id": 102869,
                        "name": "Najrān",
                        "latitude": "17.49326000",
                        "longitude": "44.12766000"
                    }
                ]
            },
            {
                "id": 2854,
                "name": "Northern Borders",
                "iso2": "08",
                "latitude": "30.07991620",
                "longitude": "42.86378750",
                "type": "region",
                "cities": [
                    {
                        "id": 102842,
                        "name": "Arar",
                        "latitude": "30.97531000",
                        "longitude": "41.03808000"
                    },
                    {
                        "id": 148586,
                        "name": "Nisab",
                        "latitude": "29.19274000",
                        "longitude": "44.71598000"
                    },
                    {
                        "id": 102887,
                        "name": "Turaif",
                        "latitude": "31.67252000",
                        "longitude": "38.66374000"
                    },
                    {
                        "id": 148587,
                        "name": "Umm Radamah",
                        "latitude": "28.67985000",
                        "longitude": "44.69549000"
                    }
                ]
            },
            {
                "id": 2849,
                "name": "Riyadh",
                "iso2": "01",
                "latitude": "22.75543850",
                "longitude": "46.20915470",
                "type": "region",
                "cities": [
                    {
                        "id": 102808,
                        "name": "Ad Dawādimī",
                        "latitude": "24.50772000",
                        "longitude": "44.39237000"
                    },
                    {
                        "id": 102809,
                        "name": "Ad Dilam",
                        "latitude": "23.99104000",
                        "longitude": "47.16181000"
                    },
                    {
                        "id": 102811,
                        "name": "Afif",
                        "latitude": "23.90650000",
                        "longitude": "42.91724000"
                    },
                    {
                        "id": 102812,
                        "name": "Ain AlBaraha",
                        "latitude": "24.75806000",
                        "longitude": "43.77389000"
                    },
                    {
                        "id": 102813,
                        "name": "Al Arţāwīyah",
                        "latitude": "26.50387000",
                        "longitude": "45.34813000"
                    },
                    {
                        "id": 149017,
                        "name": "Al Bir",
                        "latitude": "25.30000000",
                        "longitude": "45.96670000"
                    },
                    {
                        "id": 149018,
                        "name": "Al Hair",
                        "latitude": "24.39072000",
                        "longitude": "46.98677000"
                    },
                    {
                        "id": 149019,
                        "name": "Al Jurayfah",
                        "latitude": "25.52932000",
                        "longitude": "45.25644000"
                    },
                    {
                        "id": 102826,
                        "name": "Al Kharj",
                        "latitude": "24.15541000",
                        "longitude": "47.33457000"
                    },
                    {
                        "id": 149020,
                        "name": "Ar Rayn",
                        "latitude": "23.54995000",
                        "longitude": "45.50463000"
                    },
                    {
                        "id": 149021,
                        "name": "As Salamiyah",
                        "latitude": "24.20154000",
                        "longitude": "47.28872000"
                    },
                    {
                        "id": 102844,
                        "name": "As Sulayyil",
                        "latitude": "20.46067000",
                        "longitude": "45.57792000"
                    },
                    {
                        "id": 102847,
                        "name": "Az Zulfī",
                        "latitude": "26.29945000",
                        "longitude": "44.81542000"
                    },
                    {
                        "id": 149022,
                        "name": "Dawadmi",
                        "latitude": "24.50772000",
                        "longitude": "44.39237000"
                    },
                    {
                        "id": 149023,
                        "name": "Diriyah",
                        "latitude": "24.75187000",
                        "longitude": "46.53874000"
                    },
                    {
                        "id": 149024,
                        "name": "Harmah",
                        "latitude": "25.91666667",
                        "longitude": "45.33333333"
                    },
                    {
                        "id": 149025,
                        "name": "Jalajil",
                        "latitude": "25.66666667",
                        "longitude": "45.45000000"
                    },
                    {
                        "id": 149026,
                        "name": "Layla",
                        "latitude": "22.28330000",
                        "longitude": "46.73330000"
                    },
                    {
                        "id": 149027,
                        "name": "Manfuha",
                        "latitude": "24.59611111",
                        "longitude": "46.72722222"
                    },
                    {
                        "id": 102863,
                        "name": "Marāt",
                        "latitude": "25.07064000",
                        "longitude": "45.45775000"
                    },
                    {
                        "id": 149028,
                        "name": "Najan",
                        "latitude": "24.07746000",
                        "longitude": "47.16590000"
                    },
                    {
                        "id": 102874,
                        "name": "Riyadh",
                        "latitude": "24.68773000",
                        "longitude": "46.72185000"
                    },
                    {
                        "id": 102880,
                        "name": "Sājir",
                        "latitude": "25.18251000",
                        "longitude": "44.59964000"
                    },
                    {
                        "id": 102893,
                        "name": "shokhaibٍ",
                        "latitude": "24.49023000",
                        "longitude": "46.26871000"
                    },
                    {
                        "id": 102885,
                        "name": "Tumayr",
                        "latitude": "25.70347000",
                        "longitude": "45.86835000"
                    }
                ]
            },
            {
                "id": 2852,
                "name": "Tabuk",
                "iso2": "07",
                "latitude": "28.24533350",
                "longitude": "37.63866220",
                "type": "region",
                "cities": [
                    {
                        "id": 102838,
                        "name": "Al Wajh",
                        "latitude": "26.24551000",
                        "longitude": "36.45249000"
                    },
                    {
                        "id": 102853,
                        "name": "Duba",
                        "latitude": "27.35134000",
                        "longitude": "35.69014000"
                    },
                    {
                        "id": 102881,
                        "name": "Tabuk",
                        "latitude": "28.39980000",
                        "longitude": "36.57151000"
                    },
                    {
                        "id": 102889,
                        "name": "Umm Lajj",
                        "latitude": "25.02126000",
                        "longitude": "37.26850000"
                    }
                ]
            }
        ]
    },
    {
        "id": 195,
        "name": "Senegal",
        "iso3": "SEN",
        "iso2": "SN",
        "numeric_code": "686",
        "phonecode": "221",
        "capital": "Dakar",
        "currency": "XOF",
        "currency_name": "West African CFA franc",
        "currency_symbol": "CFA",
        "tld": ".sn",
        "native": "Sénégal",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Senegalese",
        "timezones": [
            {
                "zoneName": "Africa\/Dakar",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Senegal",
            "ko": "세네갈",
            "pt-BR": "Senegal",
            "pt": "Senegal",
            "nl": "Senegal",
            "hr": "Senegal",
            "fa": "سنگال",
            "de": "Senegal",
            "es": "Senegal",
            "fr": "Sénégal",
            "ja": "セネガル",
            "it": "Senegal",
            "zh-CN": "塞内加尔",
            "tr": "Senegal",
            "ru": "Сенегал",
            "uk": "Сенегал",
            "pl": "Senegal"
        },
        "latitude": "14.00000000",
        "longitude": "-14.00000000",
        "emoji": "🇸🇳",
        "emojiU": "U+1F1F8 U+1F1F3",
        "states": [
            {
                "id": 473,
                "name": "Dakar",
                "iso2": "DK",
                "latitude": "14.71667700",
                "longitude": "-17.46768610",
                "type": "region",
                "cities": [
                    {
                        "id": 104704,
                        "name": "Dakar",
                        "latitude": "14.69370000",
                        "longitude": "-17.44406000"
                    },
                    {
                        "id": 104705,
                        "name": "Dakar Department",
                        "latitude": "14.71403000",
                        "longitude": "-17.45534000"
                    },
                    {
                        "id": 104716,
                        "name": "Guédiawaye Department",
                        "latitude": "14.77610000",
                        "longitude": "-17.39560000"
                    },
                    {
                        "id": 104737,
                        "name": "Mermoz Boabab",
                        "latitude": "14.70649000",
                        "longitude": "-17.47581000"
                    },
                    {
                        "id": 104744,
                        "name": "N’diareme limamoulaye",
                        "latitude": "14.78148000",
                        "longitude": "-17.38410000"
                    },
                    {
                        "id": 104748,
                        "name": "Pikine",
                        "latitude": "14.76457000",
                        "longitude": "-17.39071000"
                    },
                    {
                        "id": 104749,
                        "name": "Pikine Department",
                        "latitude": "14.76515000",
                        "longitude": "-17.35198000"
                    },
                    {
                        "id": 104756,
                        "name": "Rufisque Department",
                        "latitude": "14.74339000",
                        "longitude": "-17.19841000"
                    }
                ]
            },
            {
                "id": 480,
                "name": "Diourbel Region",
                "iso2": "DB",
                "latitude": "14.72830850",
                "longitude": "-16.25221430",
                "type": "region",
                "cities": [
                    {
                        "id": 104734,
                        "name": "Mbacké",
                        "latitude": "14.80828000",
                        "longitude": "-15.86454000"
                    },
                    {
                        "id": 104735,
                        "name": "Mbaké",
                        "latitude": "14.79032000",
                        "longitude": "-15.90803000"
                    },
                    {
                        "id": 104769,
                        "name": "Tiébo",
                        "latitude": "14.63333000",
                        "longitude": "-16.23333000"
                    },
                    {
                        "id": 104770,
                        "name": "Touba",
                        "latitude": "14.85000000",
                        "longitude": "-15.88333000"
                    }
                ]
            },
            {
                "id": 479,
                "name": "Fatick",
                "iso2": "FK",
                "latitude": "14.33901670",
                "longitude": "-16.41114250",
                "type": "region",
                "cities": [
                    {
                        "id": 104708,
                        "name": "Diofior",
                        "latitude": "14.18333000",
                        "longitude": "-16.66667000"
                    },
                    {
                        "id": 104710,
                        "name": "Fatick Department",
                        "latitude": "14.25909000",
                        "longitude": "-16.49884000"
                    },
                    {
                        "id": 104711,
                        "name": "Foundiougne",
                        "latitude": "14.13333000",
                        "longitude": "-16.46667000"
                    },
                    {
                        "id": 104715,
                        "name": "Guinguinéo",
                        "latitude": "14.26667000",
                        "longitude": "-15.95000000"
                    },
                    {
                        "id": 104747,
                        "name": "Passi",
                        "latitude": "13.98333000",
                        "longitude": "-16.26667000"
                    },
                    {
                        "id": 104751,
                        "name": "Pourham",
                        "latitude": "14.35000000",
                        "longitude": "-16.41667000"
                    },
                    {
                        "id": 104759,
                        "name": "Sokone",
                        "latitude": "13.88333000",
                        "longitude": "-16.36667000"
                    }
                ]
            },
            {
                "id": 475,
                "name": "Kaffrine",
                "iso2": "KA",
                "latitude": "14.10520200",
                "longitude": "-15.54157550",
                "type": "region",
                "cities": [
                    {
                        "id": 104719,
                        "name": "Kaffrine",
                        "latitude": "14.10594000",
                        "longitude": "-15.55080000"
                    },
                    {
                        "id": 104726,
                        "name": "Koungheul",
                        "latitude": "13.98333000",
                        "longitude": "-14.80000000"
                    }
                ]
            },
            {
                "id": 483,
                "name": "Kaolack",
                "iso2": "KL",
                "latitude": "14.16520830",
                "longitude": "-16.07577490",
                "type": "region",
                "cities": [
                    {
                        "id": 104712,
                        "name": "Gandiaye",
                        "latitude": "14.23333000",
                        "longitude": "-16.26667000"
                    },
                    {
                        "id": 104721,
                        "name": "Kaolack",
                        "latitude": "14.15197000",
                        "longitude": "-16.07259000"
                    },
                    {
                        "id": 104741,
                        "name": "Ndofane",
                        "latitude": "13.91667000",
                        "longitude": "-15.93333000"
                    },
                    {
                        "id": 104743,
                        "name": "Nioro du Rip",
                        "latitude": "13.75000000",
                        "longitude": "-15.80000000"
                    }
                ]
            },
            {
                "id": 481,
                "name": "Kédougou",
                "iso2": "KE",
                "latitude": "12.56046070",
                "longitude": "-12.17470770",
                "type": "region",
                "cities": [
                    {
                        "id": 104709,
                        "name": "Département de Salémata",
                        "latitude": "12.59971000",
                        "longitude": "-12.77619000"
                    },
                    {
                        "id": 104727,
                        "name": "Kédougou",
                        "latitude": "12.55561000",
                        "longitude": "-12.18076000"
                    },
                    {
                        "id": 104728,
                        "name": "Kédougou Department",
                        "latitude": "12.81716000",
                        "longitude": "-12.17834000"
                    },
                    {
                        "id": 104758,
                        "name": "Saraya",
                        "latitude": "13.00150000",
                        "longitude": "-11.79627000"
                    }
                ]
            },
            {
                "id": 474,
                "name": "Kolda",
                "iso2": "KD",
                "latitude": "12.91074950",
                "longitude": "-14.95056710",
                "type": "region",
                "cities": [
                    {
                        "id": 104724,
                        "name": "Kolda",
                        "latitude": "12.89390000",
                        "longitude": "-14.94125000"
                    },
                    {
                        "id": 104725,
                        "name": "Kolda Department",
                        "latitude": "12.88300000",
                        "longitude": "-14.95000000"
                    },
                    {
                        "id": 104731,
                        "name": "Marsassoum",
                        "latitude": "12.82750000",
                        "longitude": "-15.98056000"
                    },
                    {
                        "id": 104771,
                        "name": "Vélingara",
                        "latitude": "13.15000000",
                        "longitude": "-14.11667000"
                    }
                ]
            },
            {
                "id": 485,
                "name": "Louga",
                "iso2": "LG",
                "latitude": "15.61417680",
                "longitude": "-16.22868000",
                "type": "region",
                "cities": [
                    {
                        "id": 104706,
                        "name": "Dara",
                        "latitude": "15.34844000",
                        "longitude": "-15.47993000"
                    },
                    {
                        "id": 104717,
                        "name": "Guéoul",
                        "latitude": "15.48333000",
                        "longitude": "-16.35000000"
                    },
                    {
                        "id": 104729,
                        "name": "Linguere Department",
                        "latitude": "15.35900000",
                        "longitude": "-15.15800000"
                    },
                    {
                        "id": 104730,
                        "name": "Louga",
                        "latitude": "15.61867000",
                        "longitude": "-16.22436000"
                    },
                    {
                        "id": 104739,
                        "name": "Ndibène Dahra",
                        "latitude": "15.33380000",
                        "longitude": "-15.47660000"
                    }
                ]
            },
            {
                "id": 476,
                "name": "Matam",
                "iso2": "MT",
                "latitude": "15.66002250",
                "longitude": "-13.25769060",
                "type": "region",
                "cities": [
                    {
                        "id": 104707,
                        "name": "Diawara",
                        "latitude": "15.02196000",
                        "longitude": "-12.54374000"
                    },
                    {
                        "id": 104720,
                        "name": "Kanel",
                        "latitude": "15.49160000",
                        "longitude": "-13.17627000"
                    },
                    {
                        "id": 104732,
                        "name": "Matam",
                        "latitude": "15.65587000",
                        "longitude": "-13.25544000"
                    },
                    {
                        "id": 104733,
                        "name": "Matam Department",
                        "latitude": "15.73191000",
                        "longitude": "-13.63393000"
                    },
                    {
                        "id": 104745,
                        "name": "Ouro Sogui",
                        "latitude": "15.60588000",
                        "longitude": "-13.32230000"
                    },
                    {
                        "id": 104753,
                        "name": "Ranérou",
                        "latitude": "15.30000000",
                        "longitude": "-13.96667000"
                    },
                    {
                        "id": 104761,
                        "name": "Sémé",
                        "latitude": "15.19422000",
                        "longitude": "-12.94482000"
                    },
                    {
                        "id": 104772,
                        "name": "Waoundé",
                        "latitude": "15.26367000",
                        "longitude": "-12.86821000"
                    }
                ]
            },
            {
                "id": 477,
                "name": "Saint-Louis",
                "iso2": "SL",
                "latitude": "16.08252540",
                "longitude": "-17.74907780",
                "type": "region",
                "cities": [
                    {
                        "id": 104713,
                        "name": "Goléré",
                        "latitude": "16.25575000",
                        "longitude": "-14.10165000"
                    },
                    {
                        "id": 104740,
                        "name": "Ndioum",
                        "latitude": "16.51293000",
                        "longitude": "-14.64706000"
                    },
                    {
                        "id": 104750,
                        "name": "Polel Diaoubé",
                        "latitude": "15.26667000",
                        "longitude": "-13.00000000"
                    },
                    {
                        "id": 104754,
                        "name": "Richard-Toll",
                        "latitude": "16.46250000",
                        "longitude": "-15.70083000"
                    },
                    {
                        "id": 104755,
                        "name": "Rosso",
                        "latitude": "16.42028000",
                        "longitude": "-15.79834000"
                    },
                    {
                        "id": 104757,
                        "name": "Saint-Louis",
                        "latitude": "16.01793000",
                        "longitude": "-16.48962000"
                    }
                ]
            },
            {
                "id": 482,
                "name": "Sédhiou",
                "iso2": "SE",
                "latitude": "12.70460400",
                "longitude": "-15.55623040",
                "type": "region",
                "cities": [
                    {
                        "id": 104714,
                        "name": "Goudomp Department",
                        "latitude": "12.57778000",
                        "longitude": "-15.87222000"
                    },
                    {
                        "id": 104760,
                        "name": "Sédhiou",
                        "latitude": "12.70806000",
                        "longitude": "-15.55694000"
                    }
                ]
            },
            {
                "id": 486,
                "name": "Tambacounda Region",
                "iso2": "TC",
                "latitude": "13.56190110",
                "longitude": "-13.17403480",
                "type": "region",
                "cities": [
                    {
                        "id": 104762,
                        "name": "Tambacounda",
                        "latitude": "13.77073000",
                        "longitude": "-13.66734000"
                    },
                    {
                        "id": 104763,
                        "name": "Tambacounda Department",
                        "latitude": "13.60500000",
                        "longitude": "-13.64700000"
                    }
                ]
            },
            {
                "id": 484,
                "name": "Thiès Region",
                "iso2": "TH",
                "latitude": "14.79100520",
                "longitude": "-16.93586040",
                "type": "region",
                "cities": [
                    {
                        "id": 104718,
                        "name": "Joal-Fadiout",
                        "latitude": "14.16667000",
                        "longitude": "-16.83333000"
                    },
                    {
                        "id": 104722,
                        "name": "Kayar",
                        "latitude": "14.91893000",
                        "longitude": "-17.11978000"
                    },
                    {
                        "id": 104723,
                        "name": "Khombole",
                        "latitude": "14.76667000",
                        "longitude": "-16.70000000"
                    },
                    {
                        "id": 104736,
                        "name": "Mbour",
                        "latitude": "14.40569000",
                        "longitude": "-16.85559000"
                    },
                    {
                        "id": 104738,
                        "name": "Mékhé",
                        "latitude": "15.10970000",
                        "longitude": "-16.62180000"
                    },
                    {
                        "id": 104742,
                        "name": "Nguékhokh",
                        "latitude": "14.51255000",
                        "longitude": "-17.00447000"
                    },
                    {
                        "id": 104752,
                        "name": "Pout",
                        "latitude": "14.77099000",
                        "longitude": "-17.06107000"
                    },
                    {
                        "id": 104764,
                        "name": "Thiès",
                        "latitude": "14.73004000",
                        "longitude": "-16.86974000"
                    },
                    {
                        "id": 104765,
                        "name": "Thiès Nones",
                        "latitude": "14.78333000",
                        "longitude": "-16.96667000"
                    },
                    {
                        "id": 104766,
                        "name": "Tiadiaye",
                        "latitude": "14.41667000",
                        "longitude": "-16.70000000"
                    },
                    {
                        "id": 104768,
                        "name": "Tivaouane",
                        "latitude": "15.08519000",
                        "longitude": "-16.71058000"
                    },
                    {
                        "id": 104773,
                        "name": "Warang",
                        "latitude": "14.37349000",
                        "longitude": "-16.94366000"
                    }
                ]
            },
            {
                "id": 478,
                "name": "Ziguinchor",
                "iso2": "ZG",
                "latitude": "12.56414790",
                "longitude": "-16.26398250",
                "type": "region",
                "cities": [
                    {
                        "id": 104702,
                        "name": "Adéane",
                        "latitude": "12.63000000",
                        "longitude": "-16.01694000"
                    },
                    {
                        "id": 104703,
                        "name": "Bignona",
                        "latitude": "12.81028000",
                        "longitude": "-16.22639000"
                    },
                    {
                        "id": 104746,
                        "name": "Oussouye",
                        "latitude": "12.48500000",
                        "longitude": "-16.54694000"
                    },
                    {
                        "id": 104767,
                        "name": "Tionk Essil",
                        "latitude": "12.78556000",
                        "longitude": "-16.52167000"
                    },
                    {
                        "id": 104774,
                        "name": "Ziguinchor",
                        "latitude": "12.56801000",
                        "longitude": "-16.27326000"
                    }
                ]
            }
        ]
    },
    {
        "id": 196,
        "name": "Serbia",
        "iso3": "SRB",
        "iso2": "RS",
        "numeric_code": "688",
        "phonecode": "381",
        "capital": "Belgrade",
        "currency": "RSD",
        "currency_name": "Serbian dinar",
        "currency_symbol": "din",
        "tld": ".rs",
        "native": "Србија",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Serbian",
        "timezones": [
            {
                "zoneName": "Europe\/Belgrade",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Serbia",
            "ko": "세르비아",
            "pt-BR": "Sérvia",
            "pt": "Sérvia",
            "nl": "Servië",
            "hr": "Srbija",
            "fa": "صربستان",
            "de": "Serbien",
            "es": "Serbia",
            "fr": "Serbie",
            "ja": "セルビア",
            "it": "Serbia",
            "zh-CN": "塞尔维亚",
            "tr": "Sirbistan",
            "ru": "Сербия",
            "uk": "Сербія",
            "pl": "Serbia"
        },
        "latitude": "44.00000000",
        "longitude": "21.00000000",
        "emoji": "🇷🇸",
        "emojiU": "U+1F1F7 U+1F1F8",
        "states": [
            {
                "id": 3728,
                "name": "Belgrade",
                "iso2": "00",
                "latitude": "44.78656800",
                "longitude": "20.44892160",
                "type": "city",
                "cities": [
                    {
                        "id": 97160,
                        "name": "Barič",
                        "latitude": "44.65070000",
                        "longitude": "20.25941000"
                    },
                    {
                        "id": 97174,
                        "name": "Bečmen",
                        "latitude": "44.77983000",
                        "longitude": "20.20577000"
                    },
                    {
                        "id": 97193,
                        "name": "Dobanovci",
                        "latitude": "44.82631000",
                        "longitude": "20.22487000"
                    },
                    {
                        "id": 97270,
                        "name": "Lazarevac",
                        "latitude": "44.38534000",
                        "longitude": "20.25570000"
                    },
                    {
                        "id": 97286,
                        "name": "Mala Moštanica",
                        "latitude": "44.63834000",
                        "longitude": "20.30600000"
                    },
                    {
                        "id": 97319,
                        "name": "Obrenovac",
                        "latitude": "44.65486000",
                        "longitude": "20.20017000"
                    },
                    {
                        "id": 97326,
                        "name": "Ostružnica",
                        "latitude": "44.72769000",
                        "longitude": "20.31845000"
                    },
                    {
                        "id": 97327,
                        "name": "Ovča",
                        "latitude": "44.88349000",
                        "longitude": "20.53336000"
                    },
                    {
                        "id": 97368,
                        "name": "Rušanj",
                        "latitude": "44.68477000",
                        "longitude": "20.44993000"
                    },
                    {
                        "id": 97390,
                        "name": "Sremčica",
                        "latitude": "44.67653000",
                        "longitude": "20.39232000"
                    },
                    {
                        "id": 97399,
                        "name": "Stepojevac",
                        "latitude": "44.51278000",
                        "longitude": "20.29500000"
                    },
                    {
                        "id": 97400,
                        "name": "Stubline",
                        "latitude": "44.57476000",
                        "longitude": "20.13477000"
                    },
                    {
                        "id": 97404,
                        "name": "Surčin",
                        "latitude": "44.79306000",
                        "longitude": "20.28028000"
                    },
                    {
                        "id": 97406,
                        "name": "Tabanović",
                        "latitude": "44.82018000",
                        "longitude": "19.64128000"
                    },
                    {
                        "id": 97419,
                        "name": "Ugrinovci",
                        "latitude": "44.87635000",
                        "longitude": "20.18763000"
                    },
                    {
                        "id": 97421,
                        "name": "Umka",
                        "latitude": "44.67806000",
                        "longitude": "20.30472000"
                    },
                    {
                        "id": 97428,
                        "name": "Velika Moštanica",
                        "latitude": "44.66486000",
                        "longitude": "20.35395000"
                    },
                    {
                        "id": 97439,
                        "name": "Vranić",
                        "latitude": "44.60237000",
                        "longitude": "20.32872000"
                    },
                    {
                        "id": 97446,
                        "name": "Zemun",
                        "latitude": "44.84580000",
                        "longitude": "20.40116000"
                    },
                    {
                        "id": 97451,
                        "name": "Zvečka",
                        "latitude": "44.64025000",
                        "longitude": "20.16432000"
                    }
                ]
            },
            {
                "id": 3717,
                "name": "Bor",
                "iso2": "14",
                "latitude": "44.06989180",
                "longitude": "22.09850860",
                "type": "district",
                "cities": [
                    {
                        "id": 97182,
                        "name": "Bor",
                        "latitude": "44.36667000",
                        "longitude": "22.25000000"
                    },
                    {
                        "id": 97197,
                        "name": "Donji Milanovac",
                        "latitude": "44.46593000",
                        "longitude": "22.15170000"
                    },
                    {
                        "id": 155038,
                        "name": "Kladovo",
                        "latitude": "44.60439890",
                        "longitude": "22.50819420"
                    },
                    {
                        "id": 97284,
                        "name": "Majdanpek",
                        "latitude": "44.42525470",
                        "longitude": "21.80927330"
                    },
                    {
                        "id": 97301,
                        "name": "Negotin",
                        "latitude": "44.21816180",
                        "longitude": "22.45162060"
                    }
                ]
            },
            {
                "id": 3732,
                "name": "Braničevo",
                "iso2": "11",
                "latitude": "44.69822460",
                "longitude": "21.54467750",
                "type": "district",
                "cities": [
                    {
                        "id": 97210,
                        "name": "Golubac",
                        "latitude": "44.63552160",
                        "longitude": "21.59525590"
                    },
                    {
                        "id": 97245,
                        "name": "Klenje",
                        "latitude": "44.80794000",
                        "longitude": "19.43508000"
                    },
                    {
                        "id": 155042,
                        "name": "Kučevo",
                        "latitude": "44.48938750",
                        "longitude": "21.63499770"
                    },
                    {
                        "id": 155043,
                        "name": "Malo Crniće",
                        "latitude": "44.54013980",
                        "longitude": "21.19802620"
                    },
                    {
                        "id": 155044,
                        "name": "Petrovac na Mlavi",
                        "latitude": "44.35397370",
                        "longitude": "21.28050670"
                    },
                    {
                        "id": 97343,
                        "name": "Požarevac",
                        "latitude": "44.62133000",
                        "longitude": "21.18782000"
                    },
                    {
                        "id": 97352,
                        "name": "Radenka",
                        "latitude": "44.58345000",
                        "longitude": "21.76469000"
                    },
                    {
                        "id": 97469,
                        "name": "Ševica",
                        "latitude": "44.50883000",
                        "longitude": "21.72296000"
                    },
                    {
                        "id": 155039,
                        "name": "Veliko Gradište",
                        "latitude": "44.75196410",
                        "longitude": "21.46282130"
                    },
                    {
                        "id": 155040,
                        "name": "Žabari",
                        "latitude": "44.38522130",
                        "longitude": "21.04498720"
                    },
                    {
                        "id": 155041,
                        "name": "Žagubica",
                        "latitude": "44.15544450",
                        "longitude": "21.69317990"
                    }
                ]
            },
            {
                "id": 3716,
                "name": "Central Banat",
                "iso2": "02",
                "latitude": "45.47884850",
                "longitude": "20.60825220",
                "type": "district",
                "cities": [
                    {
                        "id": 97146,
                        "name": "Aradac",
                        "latitude": "45.38346000",
                        "longitude": "20.30137000"
                    },
                    {
                        "id": 97152,
                        "name": "Banatski Despotovac",
                        "latitude": "45.36606000",
                        "longitude": "20.66407000"
                    },
                    {
                        "id": 97153,
                        "name": "Banatski Dvor",
                        "latitude": "45.51866000",
                        "longitude": "20.51146000"
                    },
                    {
                        "id": 97155,
                        "name": "Banatsko Karađorđevo",
                        "latitude": "45.58693000",
                        "longitude": "20.56421000"
                    },
                    {
                        "id": 97171,
                        "name": "Belo Blato",
                        "latitude": "45.27278000",
                        "longitude": "20.37500000"
                    },
                    {
                        "id": 97185,
                        "name": "Bočar",
                        "latitude": "45.76994000",
                        "longitude": "20.28390000"
                    },
                    {
                        "id": 97180,
                        "name": "Boka",
                        "latitude": "45.35540000",
                        "longitude": "20.82987000"
                    },
                    {
                        "id": 97184,
                        "name": "Botoš",
                        "latitude": "45.30837000",
                        "longitude": "20.63514000"
                    },
                    {
                        "id": 97459,
                        "name": "Čenta",
                        "latitude": "45.10814000",
                        "longitude": "20.38947000"
                    },
                    {
                        "id": 97460,
                        "name": "Čestereg",
                        "latitude": "45.56361000",
                        "longitude": "20.53194000"
                    },
                    {
                        "id": 97204,
                        "name": "Ečka",
                        "latitude": "45.32328000",
                        "longitude": "20.44294000"
                    },
                    {
                        "id": 97203,
                        "name": "Elemir",
                        "latitude": "45.44263000",
                        "longitude": "20.30003000"
                    },
                    {
                        "id": 97205,
                        "name": "Farkaždin",
                        "latitude": "45.19172000",
                        "longitude": "20.47239000"
                    },
                    {
                        "id": 97219,
                        "name": "Hetin",
                        "latitude": "45.66202000",
                        "longitude": "20.79138000"
                    },
                    {
                        "id": 97232,
                        "name": "Jarkovac",
                        "latitude": "45.26985000",
                        "longitude": "20.76078000"
                    },
                    {
                        "id": 97234,
                        "name": "Jaša Tomić",
                        "latitude": "45.44725000",
                        "longitude": "20.85546000"
                    },
                    {
                        "id": 97243,
                        "name": "Klek",
                        "latitude": "45.42254000",
                        "longitude": "20.48049000"
                    },
                    {
                        "id": 97246,
                        "name": "Knićanin",
                        "latitude": "45.18675000",
                        "longitude": "20.31900000"
                    },
                    {
                        "id": 97250,
                        "name": "Konak",
                        "latitude": "45.31575000",
                        "longitude": "20.91468000"
                    },
                    {
                        "id": 97257,
                        "name": "Krajišnik",
                        "latitude": "45.45283000",
                        "longitude": "20.72976000"
                    },
                    {
                        "id": 97264,
                        "name": "Kumane",
                        "latitude": "45.53946000",
                        "longitude": "20.22902000"
                    },
                    {
                        "id": 97271,
                        "name": "Lazarevo",
                        "latitude": "45.38893000",
                        "longitude": "20.53999000"
                    },
                    {
                        "id": 97282,
                        "name": "Lukićevo",
                        "latitude": "45.33815000",
                        "longitude": "20.49895000"
                    },
                    {
                        "id": 97293,
                        "name": "Međa",
                        "latitude": "45.53815000",
                        "longitude": "20.80677000"
                    },
                    {
                        "id": 97291,
                        "name": "Melenci",
                        "latitude": "45.51680000",
                        "longitude": "20.31961000"
                    },
                    {
                        "id": 97294,
                        "name": "Mihajlovo",
                        "latitude": "45.47085000",
                        "longitude": "20.41508000"
                    },
                    {
                        "id": 97302,
                        "name": "Neuzina",
                        "latitude": "45.34460000",
                        "longitude": "20.71418000"
                    },
                    {
                        "id": 97307,
                        "name": "Nova Crnja",
                        "latitude": "45.68712540",
                        "longitude": "20.51005280"
                    },
                    {
                        "id": 155045,
                        "name": "Novi Bečej",
                        "latitude": "45.59435150",
                        "longitude": "20.18852580"
                    },
                    {
                        "id": 97310,
                        "name": "Novi Itebej",
                        "latitude": "45.55918000",
                        "longitude": "20.70030000"
                    },
                    {
                        "id": 97317,
                        "name": "Novo Miloševo",
                        "latitude": "45.71916000",
                        "longitude": "20.30364000"
                    },
                    {
                        "id": 97322,
                        "name": "Orlovat",
                        "latitude": "45.24171000",
                        "longitude": "20.58089000"
                    },
                    {
                        "id": 97333,
                        "name": "Perlez",
                        "latitude": "45.20813000",
                        "longitude": "20.38197000"
                    },
                    {
                        "id": 97354,
                        "name": "Radojevo",
                        "latitude": "45.74617000",
                        "longitude": "20.78917000"
                    },
                    {
                        "id": 97358,
                        "name": "Ravni Topolovac",
                        "latitude": "45.46082000",
                        "longitude": "20.56939000"
                    },
                    {
                        "id": 97379,
                        "name": "Sečanj",
                        "latitude": "45.32387000",
                        "longitude": "20.67233210"
                    },
                    {
                        "id": 97391,
                        "name": "Srpska Crnja",
                        "latitude": "45.72538000",
                        "longitude": "20.69008000"
                    },
                    {
                        "id": 97392,
                        "name": "Srpski Itebej",
                        "latitude": "45.56715000",
                        "longitude": "20.71350000"
                    },
                    {
                        "id": 97393,
                        "name": "Stajićevo",
                        "latitude": "45.29489000",
                        "longitude": "20.45845000"
                    },
                    {
                        "id": 97405,
                        "name": "Sutjeska",
                        "latitude": "45.38312000",
                        "longitude": "20.69620000"
                    },
                    {
                        "id": 97407,
                        "name": "Taraš",
                        "latitude": "45.46737000",
                        "longitude": "20.19867000"
                    },
                    {
                        "id": 97410,
                        "name": "Toba",
                        "latitude": "45.68943000",
                        "longitude": "20.55714000"
                    },
                    {
                        "id": 97411,
                        "name": "Tomaševac",
                        "latitude": "45.26855000",
                        "longitude": "20.62272000"
                    },
                    {
                        "id": 97413,
                        "name": "Torak",
                        "latitude": "45.50928000",
                        "longitude": "20.60900000"
                    },
                    {
                        "id": 97414,
                        "name": "Torda",
                        "latitude": "45.58423000",
                        "longitude": "20.45900000"
                    },
                    {
                        "id": 97438,
                        "name": "Vojvoda Stepa",
                        "latitude": "45.68537000",
                        "longitude": "20.65536000"
                    },
                    {
                        "id": 97474,
                        "name": "Žitište",
                        "latitude": "45.54150190",
                        "longitude": "20.29310490"
                    },
                    {
                        "id": 97450,
                        "name": "Zrenjanin",
                        "latitude": "45.38361000",
                        "longitude": "20.38194000"
                    }
                ]
            },
            {
                "id": 3715,
                "name": "Jablanica",
                "iso2": "23",
                "latitude": "42.94815600",
                "longitude": "21.81293210",
                "type": "district",
                "cities": [
                    {
                        "id": 155046,
                        "name": "Bojnik",
                        "latitude": "43.03962330",
                        "longitude": "21.50229300"
                    },
                    {
                        "id": 155050,
                        "name": "Crna Trava",
                        "latitude": "42.81226490",
                        "longitude": "22.26885720"
                    },
                    {
                        "id": 97239,
                        "name": "Kamenica",
                        "latitude": "44.34300000",
                        "longitude": "19.72333000"
                    },
                    {
                        "id": 155048,
                        "name": "Lebane",
                        "latitude": "42.92312940",
                        "longitude": "21.71589360"
                    },
                    {
                        "id": 97272,
                        "name": "Leskovac",
                        "latitude": "42.99806000",
                        "longitude": "21.94611000"
                    },
                    {
                        "id": 155049,
                        "name": "Medveđa",
                        "latitude": "42.83278560",
                        "longitude": "21.53388900"
                    },
                    {
                        "id": 155047,
                        "name": "Vlasotince",
                        "latitude": "42.96648980",
                        "longitude": "22.09399660"
                    }
                ]
            },
            {
                "id": 3724,
                "name": "Kolubara",
                "iso2": "09",
                "latitude": "44.35098110",
                "longitude": "20.00043050",
                "type": "district",
                "cities": [
                    {
                        "id": 97212,
                        "name": "Gornja Bukovica",
                        "latitude": "44.33987000",
                        "longitude": "19.81368000"
                    },
                    {
                        "id": 97238,
                        "name": "Joševa",
                        "latitude": "44.58772000",
                        "longitude": "19.40967000"
                    },
                    {
                        "id": 155051,
                        "name": "Lajkovac",
                        "latitude": "44.36809950",
                        "longitude": "20.14110360"
                    },
                    {
                        "id": 97276,
                        "name": "Ljig",
                        "latitude": "44.22281040",
                        "longitude": "20.21389960"
                    },
                    {
                        "id": 155052,
                        "name": "Mionica",
                        "latitude": "44.25595280",
                        "longitude": "20.05966170"
                    },
                    {
                        "id": 97323,
                        "name": "Osečina",
                        "latitude": "44.37202670",
                        "longitude": "19.57926740"
                    },
                    {
                        "id": 155053,
                        "name": "Ub",
                        "latitude": "44.45594110",
                        "longitude": "20.04489880"
                    },
                    {
                        "id": 97425,
                        "name": "Valjevo",
                        "latitude": "44.27513000",
                        "longitude": "19.89821000"
                    }
                ]
            },
            {
                "id": 3719,
                "name": "Mačva",
                "iso2": "08",
                "latitude": "44.59253140",
                "longitude": "19.50822460",
                "type": "district",
                "cities": [
                    {
                        "id": 97149,
                        "name": "Badovinci",
                        "latitude": "44.78534000",
                        "longitude": "19.37146000"
                    },
                    {
                        "id": 97157,
                        "name": "Banovo Polje",
                        "latitude": "44.91040000",
                        "longitude": "19.44916000"
                    },
                    {
                        "id": 97172,
                        "name": "Belotić",
                        "latitude": "44.81782000",
                        "longitude": "19.54801000"
                    },
                    {
                        "id": 97177,
                        "name": "Bogatić",
                        "latitude": "44.84997410",
                        "longitude": "19.40134990"
                    },
                    {
                        "id": 97179,
                        "name": "Bogosavac",
                        "latitude": "44.71799000",
                        "longitude": "19.59533000"
                    },
                    {
                        "id": 97186,
                        "name": "Brdarica",
                        "latitude": "44.55376000",
                        "longitude": "19.77150000"
                    },
                    {
                        "id": 97187,
                        "name": "Bukor",
                        "latitude": "44.49523000",
                        "longitude": "19.57116000"
                    },
                    {
                        "id": 97462,
                        "name": "Čokešina",
                        "latitude": "44.65319000",
                        "longitude": "19.39016000"
                    },
                    {
                        "id": 97190,
                        "name": "Crna Bara",
                        "latitude": "44.87374000",
                        "longitude": "19.39480000"
                    },
                    {
                        "id": 97195,
                        "name": "Dobrić",
                        "latitude": "44.70224000",
                        "longitude": "19.57931000"
                    },
                    {
                        "id": 97196,
                        "name": "Donji Dobrić",
                        "latitude": "44.61183000",
                        "longitude": "19.33109000"
                    },
                    {
                        "id": 97199,
                        "name": "Draginje",
                        "latitude": "44.53302000",
                        "longitude": "19.76250000"
                    },
                    {
                        "id": 97209,
                        "name": "Glušci",
                        "latitude": "44.89021000",
                        "longitude": "19.54913000"
                    },
                    {
                        "id": 97227,
                        "name": "Jadranska Lešnica",
                        "latitude": "44.59730000",
                        "longitude": "19.35209000"
                    },
                    {
                        "id": 97235,
                        "name": "Jelenča",
                        "latitude": "44.72700000",
                        "longitude": "19.73500000"
                    },
                    {
                        "id": 97237,
                        "name": "Jevremovac",
                        "latitude": "44.72172000",
                        "longitude": "19.66364000"
                    },
                    {
                        "id": 155054,
                        "name": "Koceljeva",
                        "latitude": "44.46299340",
                        "longitude": "19.78680540"
                    },
                    {
                        "id": 97254,
                        "name": "Kozjak",
                        "latitude": "45.18264000",
                        "longitude": "20.86381000"
                    },
                    {
                        "id": 97260,
                        "name": "Krupanj",
                        "latitude": "44.36556000",
                        "longitude": "19.36194000"
                    },
                    {
                        "id": 97273,
                        "name": "Lešnica",
                        "latitude": "44.65250000",
                        "longitude": "19.31000000"
                    },
                    {
                        "id": 97274,
                        "name": "Lipnički Šor",
                        "latitude": "44.58058000",
                        "longitude": "19.26572000"
                    },
                    {
                        "id": 97275,
                        "name": "Lipolist",
                        "latitude": "44.69783000",
                        "longitude": "19.50101000"
                    },
                    {
                        "id": 97277,
                        "name": "Ljubovija",
                        "latitude": "44.18944000",
                        "longitude": "19.37667000"
                    },
                    {
                        "id": 97289,
                        "name": "Mačva",
                        "latitude": "44.61472000",
                        "longitude": "19.47222000"
                    },
                    {
                        "id": 97285,
                        "name": "Majur",
                        "latitude": "44.77105000",
                        "longitude": "19.65512000"
                    },
                    {
                        "id": 97287,
                        "name": "Mali Zvornik",
                        "latitude": "44.37344000",
                        "longitude": "19.10651000"
                    },
                    {
                        "id": 97292,
                        "name": "Metković",
                        "latitude": "44.85617000",
                        "longitude": "19.54654000"
                    },
                    {
                        "id": 97318,
                        "name": "Novo Selo",
                        "latitude": "44.67041000",
                        "longitude": "19.34495000"
                    },
                    {
                        "id": 97334,
                        "name": "Petkovica",
                        "latitude": "44.66627000",
                        "longitude": "19.43923000"
                    },
                    {
                        "id": 97340,
                        "name": "Pocerski Pričinović",
                        "latitude": "44.72222000",
                        "longitude": "19.70722000"
                    },
                    {
                        "id": 97362,
                        "name": "Ribari",
                        "latitude": "44.70961000",
                        "longitude": "19.42472000"
                    },
                    {
                        "id": 97366,
                        "name": "Rumska",
                        "latitude": "44.57261000",
                        "longitude": "19.58988000"
                    },
                    {
                        "id": 97465,
                        "name": "Šabac",
                        "latitude": "44.74667000",
                        "longitude": "19.69000000"
                    },
                    {
                        "id": 97371,
                        "name": "Salaš Crnobarski",
                        "latitude": "44.82843000",
                        "longitude": "19.39437000"
                    },
                    {
                        "id": 97468,
                        "name": "Ševarice",
                        "latitude": "44.86704000",
                        "longitude": "19.66006000"
                    },
                    {
                        "id": 97380,
                        "name": "Sinošević",
                        "latitude": "44.61503000",
                        "longitude": "19.63601000"
                    },
                    {
                        "id": 97471,
                        "name": "Štitar",
                        "latitude": "44.79415000",
                        "longitude": "19.59529000"
                    },
                    {
                        "id": 97416,
                        "name": "Tršić",
                        "latitude": "44.49502000",
                        "longitude": "19.26490000"
                    },
                    {
                        "id": 97423,
                        "name": "Uzveće",
                        "latitude": "44.87861000",
                        "longitude": "19.60356000"
                    },
                    {
                        "id": 97434,
                        "name": "Vladimirci",
                        "latitude": "44.61472000",
                        "longitude": "19.78528000"
                    },
                    {
                        "id": 97449,
                        "name": "Zminjak",
                        "latitude": "44.75711000",
                        "longitude": "19.47070000"
                    }
                ]
            },
            {
                "id": 3727,
                "name": "Moravica",
                "iso2": "17",
                "latitude": "43.84147000",
                "longitude": "20.29049870",
                "type": "district",
                "cities": [
                    {
                        "id": 97457,
                        "name": "Čačak",
                        "latitude": "43.89139000",
                        "longitude": "20.34972000"
                    },
                    {
                        "id": 97214,
                        "name": "Gornji Milanovac",
                        "latitude": "44.02603000",
                        "longitude": "20.46152000"
                    },
                    {
                        "id": 155055,
                        "name": "Ivanjica",
                        "latitude": "43.58366500",
                        "longitude": "20.21556940"
                    },
                    {
                        "id": 155056,
                        "name": "Lučani",
                        "latitude": "43.85854930",
                        "longitude": "20.11661750"
                    },
                    {
                        "id": 97347,
                        "name": "Prislonica",
                        "latitude": "43.95223000",
                        "longitude": "20.43521000"
                    }
                ]
            },
            {
                "id": 3722,
                "name": "Nišava",
                "iso2": "20",
                "latitude": "43.37389020",
                "longitude": "21.93223310",
                "type": "district",
                "cities": [
                    {
                        "id": 97143,
                        "name": "Aleksandrovo",
                        "latitude": "45.63755000",
                        "longitude": "20.59288000"
                    },
                    {
                        "id": 155057,
                        "name": "Aleksinac",
                        "latitude": "43.55255480",
                        "longitude": "21.63113320"
                    },
                    {
                        "id": 155059,
                        "name": "Doljevac",
                        "latitude": "43.22262650",
                        "longitude": "21.76288330"
                    },
                    {
                        "id": 155058,
                        "name": "Gadžin Han",
                        "latitude": "43.23053490",
                        "longitude": "22.01312530"
                    },
                    {
                        "id": 155060,
                        "name": "Merošina",
                        "latitude": "43.30158010",
                        "longitude": "21.52993050"
                    },
                    {
                        "id": 97305,
                        "name": "Niš",
                        "latitude": "43.32472000",
                        "longitude": "21.90333000"
                    },
                    {
                        "id": 155061,
                        "name": "Ražanj",
                        "latitude": "43.70924730",
                        "longitude": "21.41131260"
                    },
                    {
                        "id": 155062,
                        "name": "Svrljig",
                        "latitude": "43.46937580",
                        "longitude": "21.80472770"
                    }
                ]
            },
            {
                "id": 3714,
                "name": "North Bačka",
                "iso2": "01",
                "latitude": "45.98033940",
                "longitude": "19.59070010",
                "type": "district",
                "cities": [
                    {
                        "id": 97162,
                        "name": "Bačka Topola",
                        "latitude": "45.81516000",
                        "longitude": "19.63180000"
                    },
                    {
                        "id": 97259,
                        "name": "Krivaja",
                        "latitude": "44.55021000",
                        "longitude": "19.59153000"
                    },
                    {
                        "id": 155063,
                        "name": "Mali Iđoš",
                        "latitude": "45.71406240",
                        "longitude": "19.58678580"
                    },
                    {
                        "id": 97401,
                        "name": "Subotica",
                        "latitude": "46.10000000",
                        "longitude": "19.66667000"
                    }
                ]
            },
            {
                "id": 3736,
                "name": "North Banat",
                "iso2": "03",
                "latitude": "45.90683900",
                "longitude": "19.99934170",
                "type": "district",
                "cities": [
                    {
                        "id": 155064,
                        "name": "Ada",
                        "latitude": "45.78604090",
                        "longitude": "19.84788560"
                    },
                    {
                        "id": 97142,
                        "name": "Adorjan",
                        "latitude": "46.00333000",
                        "longitude": "20.04007000"
                    },
                    {
                        "id": 97151,
                        "name": "Banatska Topola",
                        "latitude": "45.67248000",
                        "longitude": "20.46530000"
                    },
                    {
                        "id": 97156,
                        "name": "Banatsko Veliko Selo",
                        "latitude": "45.81961000",
                        "longitude": "20.60772000"
                    },
                    {
                        "id": 97167,
                        "name": "Bašaid",
                        "latitude": "45.64102000",
                        "longitude": "20.41434000"
                    },
                    {
                        "id": 97461,
                        "name": "Čoka",
                        "latitude": "45.94250000",
                        "longitude": "20.14333000"
                    },
                    {
                        "id": 97213,
                        "name": "Gornji Breg",
                        "latitude": "45.91995000",
                        "longitude": "20.01766000"
                    },
                    {
                        "id": 97233,
                        "name": "Jazovo",
                        "latitude": "45.89876000",
                        "longitude": "20.22130000"
                    },
                    {
                        "id": 97240,
                        "name": "Kanjiža",
                        "latitude": "46.06667000",
                        "longitude": "20.05000000"
                    },
                    {
                        "id": 97241,
                        "name": "Kikinda",
                        "latitude": "45.82972000",
                        "longitude": "20.46528000"
                    },
                    {
                        "id": 97296,
                        "name": "Mokrin",
                        "latitude": "45.93362000",
                        "longitude": "20.41215000"
                    },
                    {
                        "id": 97297,
                        "name": "Mol",
                        "latitude": "45.76457000",
                        "longitude": "20.13286000"
                    },
                    {
                        "id": 97300,
                        "name": "Nakovo",
                        "latitude": "45.87503000",
                        "longitude": "20.56709000"
                    },
                    {
                        "id": 97312,
                        "name": "Novi Kneževac",
                        "latitude": "46.05000000",
                        "longitude": "20.10000000"
                    },
                    {
                        "id": 97313,
                        "name": "Novi Kozarci",
                        "latitude": "45.78241000",
                        "longitude": "20.62289000"
                    },
                    {
                        "id": 97325,
                        "name": "Ostojićevo",
                        "latitude": "45.88863000",
                        "longitude": "20.16642000"
                    },
                    {
                        "id": 97328,
                        "name": "Padej",
                        "latitude": "45.82756000",
                        "longitude": "20.16279000"
                    },
                    {
                        "id": 97367,
                        "name": "Rusko Selo",
                        "latitude": "45.76291000",
                        "longitude": "20.57117000"
                    },
                    {
                        "id": 97369,
                        "name": "Sajan",
                        "latitude": "45.84227000",
                        "longitude": "20.27815000"
                    },
                    {
                        "id": 97375,
                        "name": "Sanad",
                        "latitude": "45.97596000",
                        "longitude": "20.10816000"
                    },
                    {
                        "id": 97378,
                        "name": "Senta",
                        "latitude": "45.92750000",
                        "longitude": "20.07722000"
                    },
                    {
                        "id": 97408,
                        "name": "Tiszahegyes",
                        "latitude": "45.82648000",
                        "longitude": "20.31791000"
                    }
                ]
            },
            {
                "id": 3721,
                "name": "Pčinja",
                "iso2": "24",
                "latitude": "42.58363620",
                "longitude": "22.14302150",
                "type": "district",
                "cities": [
                    {
                        "id": 97176,
                        "name": "Biljača",
                        "latitude": "42.35518000",
                        "longitude": "21.74781000"
                    },
                    {
                        "id": 155065,
                        "name": "Bosilegrad",
                        "latitude": "42.50233740",
                        "longitude": "22.41940440"
                    },
                    {
                        "id": 155066,
                        "name": "Bujanovac",
                        "latitude": "42.45675480",
                        "longitude": "21.74726470"
                    },
                    {
                        "id": 97295,
                        "name": "Miratovac",
                        "latitude": "42.25846000",
                        "longitude": "21.66456000"
                    },
                    {
                        "id": 155068,
                        "name": "Preševo",
                        "latitude": "42.31581340",
                        "longitude": "21.57144860"
                    },
                    {
                        "id": 97355,
                        "name": "Radovnica",
                        "latitude": "42.43364000",
                        "longitude": "22.22861000"
                    },
                    {
                        "id": 97356,
                        "name": "Rajince",
                        "latitude": "42.37870000",
                        "longitude": "21.69591000"
                    },
                    {
                        "id": 97373,
                        "name": "Samoljica",
                        "latitude": "42.38445000",
                        "longitude": "21.73708000"
                    },
                    {
                        "id": 155069,
                        "name": "Surdulica",
                        "latitude": "42.69008190",
                        "longitude": "22.15599050"
                    },
                    {
                        "id": 155070,
                        "name": "Trgovište",
                        "latitude": "42.35659850",
                        "longitude": "22.02351020"
                    },
                    {
                        "id": 155067,
                        "name": "Vladičin Han",
                        "latitude": "42.70738320",
                        "longitude": "22.04413920"
                    },
                    {
                        "id": 97440,
                        "name": "Vranje",
                        "latitude": "42.55139000",
                        "longitude": "21.90028000"
                    },
                    {
                        "id": 97475,
                        "name": "Žujince",
                        "latitude": "42.31568000",
                        "longitude": "21.70212000"
                    }
                ]
            },
            {
                "id": 3712,
                "name": "Pirot",
                "iso2": "22",
                "latitude": "43.08740360",
                "longitude": "22.59830440",
                "type": "district",
                "cities": [
                    {
                        "id": 155071,
                        "name": "Babušnica",
                        "latitude": "43.06573340",
                        "longitude": "22.38719690"
                    },
                    {
                        "id": 155072,
                        "name": "Bela Palanka",
                        "latitude": "43.21421070",
                        "longitude": "22.29898440"
                    },
                    {
                        "id": 155073,
                        "name": "Dimitrovgrad",
                        "latitude": "43.02140830",
                        "longitude": "22.73950980"
                    },
                    {
                        "id": 97337,
                        "name": "Pirot",
                        "latitude": "43.17528000",
                        "longitude": "22.59278000"
                    },
                    {
                        "id": 97402,
                        "name": "Sumulicë",
                        "latitude": "42.38682000",
                        "longitude": "21.73400000"
                    }
                ]
            },
            {
                "id": 3741,
                "name": "Podunavlje",
                "iso2": "10",
                "latitude": "44.47291560",
                "longitude": "20.99014260",
                "type": "district",
                "cities": [
                    {
                        "id": 97281,
                        "name": "Lugavčina",
                        "latitude": "44.52314000",
                        "longitude": "21.07083000"
                    },
                    {
                        "id": 97382,
                        "name": "Smederevo",
                        "latitude": "44.66436000",
                        "longitude": "20.92763000"
                    },
                    {
                        "id": 97383,
                        "name": "Smederevska Palanka",
                        "latitude": "44.36548000",
                        "longitude": "20.95885000"
                    },
                    {
                        "id": 155074,
                        "name": "Velika Plana",
                        "latitude": "44.32578760",
                        "longitude": "20.97032280"
                    }
                ]
            },
            {
                "id": 3737,
                "name": "Pomoravlje",
                "iso2": "13",
                "latitude": "43.95913790",
                "longitude": "21.27135300",
                "type": "district",
                "cities": [
                    {
                        "id": 97455,
                        "name": "Ćuprija",
                        "latitude": "43.92750000",
                        "longitude": "21.37000000"
                    },
                    {
                        "id": 155075,
                        "name": "Despotovac",
                        "latitude": "44.09472620",
                        "longitude": "21.39913490"
                    },
                    {
                        "id": 97200,
                        "name": "Drenovac",
                        "latitude": "44.86649000",
                        "longitude": "19.70943000"
                    },
                    {
                        "id": 97201,
                        "name": "Dublje",
                        "latitude": "44.80117000",
                        "longitude": "19.50902000"
                    },
                    {
                        "id": 97202,
                        "name": "Duboka",
                        "latitude": "44.52223000",
                        "longitude": "21.76030000"
                    },
                    {
                        "id": 97215,
                        "name": "Grabovac",
                        "latitude": "44.60049000",
                        "longitude": "20.08539000"
                    },
                    {
                        "id": 97228,
                        "name": "Jagodina",
                        "latitude": "43.97713000",
                        "longitude": "21.26121000"
                    },
                    {
                        "id": 97331,
                        "name": "Paraćin",
                        "latitude": "43.86083000",
                        "longitude": "21.40778000"
                    },
                    {
                        "id": 155076,
                        "name": "Rekovac",
                        "latitude": "43.86577250",
                        "longitude": "21.02877540"
                    },
                    {
                        "id": 155077,
                        "name": "Svilajnac",
                        "latitude": "44.24526320",
                        "longitude": "21.15803640"
                    }
                ]
            },
            {
                "id": 3720,
                "name": "Rasina",
                "iso2": "19",
                "latitude": "43.52635250",
                "longitude": "21.15881780",
                "type": "district",
                "cities": [
                    {
                        "id": 155078,
                        "name": "Aleksandrovac",
                        "latitude": "43.45989420",
                        "longitude": "21.03087890"
                    },
                    {
                        "id": 155079,
                        "name": "Brus",
                        "latitude": "43.38376200",
                        "longitude": "21.00656730"
                    },
                    {
                        "id": 97454,
                        "name": "Ćićevac",
                        "latitude": "43.71882000",
                        "longitude": "21.44085000"
                    },
                    {
                        "id": 97261,
                        "name": "Kruševac",
                        "latitude": "43.58000000",
                        "longitude": "21.33389000"
                    },
                    {
                        "id": 97415,
                        "name": "Trstenik",
                        "latitude": "43.61694000",
                        "longitude": "21.00250000"
                    },
                    {
                        "id": 155080,
                        "name": "Varvarin",
                        "latitude": "43.72306940",
                        "longitude": "21.34098520"
                    }
                ]
            },
            {
                "id": 3725,
                "name": "Raška",
                "iso2": "18",
                "latitude": "43.33734610",
                "longitude": "20.57340050",
                "type": "district",
                "cities": [
                    {
                        "id": 97231,
                        "name": "Jarebice",
                        "latitude": "44.53995000",
                        "longitude": "19.42418000"
                    },
                    {
                        "id": 97258,
                        "name": "Kraljevo",
                        "latitude": "43.72583000",
                        "longitude": "20.68944000"
                    },
                    {
                        "id": 97314,
                        "name": "Novi Pazar",
                        "latitude": "43.13667000",
                        "longitude": "20.51222000"
                    },
                    {
                        "id": 97361,
                        "name": "Raška",
                        "latitude": "43.26694000",
                        "longitude": "20.65278000"
                    },
                    {
                        "id": 97418,
                        "name": "Tutin",
                        "latitude": "42.99028000",
                        "longitude": "20.33139000"
                    },
                    {
                        "id": 97443,
                        "name": "Vrnjačka Banja",
                        "latitude": "43.62725000",
                        "longitude": "20.89634000"
                    }
                ]
            },
            {
                "id": 3711,
                "name": "South Bačka",
                "iso2": "06",
                "latitude": "45.48903440",
                "longitude": "19.69761870",
                "type": "district",
                "cities": [
                    {
                        "id": 155081,
                        "name": "Bač",
                        "latitude": "45.35619150",
                        "longitude": "19.14208630"
                    },
                    {
                        "id": 97161,
                        "name": "Bačka Palanka",
                        "latitude": "45.24966000",
                        "longitude": "19.39664000"
                    },
                    {
                        "id": 97164,
                        "name": "Bački Petrovac",
                        "latitude": "45.36056000",
                        "longitude": "19.59167000"
                    },
                    {
                        "id": 97165,
                        "name": "Bačko Gradište",
                        "latitude": "45.53271000",
                        "longitude": "20.03082000"
                    },
                    {
                        "id": 97166,
                        "name": "Bačko Petrovo Selo",
                        "latitude": "45.70681000",
                        "longitude": "20.07928000"
                    },
                    {
                        "id": 97173,
                        "name": "Bečej",
                        "latitude": "45.61632000",
                        "longitude": "20.03331000"
                    },
                    {
                        "id": 155082,
                        "name": "Beočin",
                        "latitude": "45.19420630",
                        "longitude": "19.68125510"
                    },
                    {
                        "id": 97458,
                        "name": "Čelarevo",
                        "latitude": "45.26999000",
                        "longitude": "19.52484000"
                    },
                    {
                        "id": 97464,
                        "name": "Čurug",
                        "latitude": "45.47221000",
                        "longitude": "20.06861000"
                    },
                    {
                        "id": 97192,
                        "name": "Despotovo",
                        "latitude": "45.45983000",
                        "longitude": "19.52653000"
                    },
                    {
                        "id": 97453,
                        "name": "Ðurđevo",
                        "latitude": "45.32591000",
                        "longitude": "20.06532000"
                    },
                    {
                        "id": 97207,
                        "name": "Gardinovci",
                        "latitude": "45.20359000",
                        "longitude": "20.13558000"
                    },
                    {
                        "id": 97208,
                        "name": "Gložan",
                        "latitude": "45.27954000",
                        "longitude": "19.56838000"
                    },
                    {
                        "id": 97242,
                        "name": "Kisač",
                        "latitude": "45.35421000",
                        "longitude": "19.72975000"
                    },
                    {
                        "id": 97252,
                        "name": "Kovilj",
                        "latitude": "45.23422000",
                        "longitude": "20.02327000"
                    },
                    {
                        "id": 97263,
                        "name": "Kulpin",
                        "latitude": "45.40240000",
                        "longitude": "19.58814000"
                    },
                    {
                        "id": 97279,
                        "name": "Lok",
                        "latitude": "45.21583000",
                        "longitude": "20.21222000"
                    },
                    {
                        "id": 97283,
                        "name": "Maglić",
                        "latitude": "45.36248000",
                        "longitude": "19.53211000"
                    },
                    {
                        "id": 97299,
                        "name": "Mošorin",
                        "latitude": "45.30196000",
                        "longitude": "20.16919000"
                    },
                    {
                        "id": 97315,
                        "name": "Novi Sad",
                        "latitude": "45.25167000",
                        "longitude": "19.83694000"
                    },
                    {
                        "id": 97320,
                        "name": "Obrovac",
                        "latitude": "45.32106000",
                        "longitude": "19.35048000"
                    },
                    {
                        "id": 97335,
                        "name": "Petrovaradin",
                        "latitude": "45.24667000",
                        "longitude": "19.87944000"
                    },
                    {
                        "id": 97360,
                        "name": "Ravno Selo",
                        "latitude": "45.44967000",
                        "longitude": "19.62097000"
                    },
                    {
                        "id": 97365,
                        "name": "Rumenka",
                        "latitude": "45.29400000",
                        "longitude": "19.74306000"
                    },
                    {
                        "id": 97466,
                        "name": "Šajkaš",
                        "latitude": "45.27315000",
                        "longitude": "20.09051000"
                    },
                    {
                        "id": 155083,
                        "name": "Srbobran",
                        "latitude": "45.59515130",
                        "longitude": "19.71831060"
                    },
                    {
                        "id": 97389,
                        "name": "Sremski Karlovci",
                        "latitude": "45.20285000",
                        "longitude": "19.93373000"
                    },
                    {
                        "id": 97398,
                        "name": "Stepanovićevo",
                        "latitude": "45.41369000",
                        "longitude": "19.70000000"
                    },
                    {
                        "id": 155084,
                        "name": "Temerin",
                        "latitude": "45.42817430",
                        "longitude": "19.81379480"
                    },
                    {
                        "id": 97409,
                        "name": "Titel",
                        "latitude": "45.20611000",
                        "longitude": "20.29444000"
                    },
                    {
                        "id": 97417,
                        "name": "Turija",
                        "latitude": "44.52273000",
                        "longitude": "21.63945000"
                    },
                    {
                        "id": 97431,
                        "name": "Veternik",
                        "latitude": "45.25446000",
                        "longitude": "19.75880000"
                    },
                    {
                        "id": 97432,
                        "name": "Vilovo",
                        "latitude": "45.24859000",
                        "longitude": "20.15521000"
                    },
                    {
                        "id": 97441,
                        "name": "Vrbas",
                        "latitude": "45.57139000",
                        "longitude": "19.64083000"
                    },
                    {
                        "id": 97473,
                        "name": "Žabalj",
                        "latitude": "45.37222000",
                        "longitude": "20.06389000"
                    },
                    {
                        "id": 97448,
                        "name": "Zmajevo",
                        "latitude": "45.45408000",
                        "longitude": "19.69050000"
                    }
                ]
            },
            {
                "id": 3713,
                "name": "South Banat",
                "iso2": "04",
                "latitude": "45.00274570",
                "longitude": "21.05425090",
                "type": "district",
                "cities": [
                    {
                        "id": 97144,
                        "name": "Alibunar",
                        "latitude": "45.08083000",
                        "longitude": "20.96583000"
                    },
                    {
                        "id": 97154,
                        "name": "Banatski Karlovac",
                        "latitude": "45.04987000",
                        "longitude": "21.01800000"
                    },
                    {
                        "id": 97158,
                        "name": "Baranda",
                        "latitude": "45.08459000",
                        "longitude": "20.44264000"
                    },
                    {
                        "id": 97159,
                        "name": "Barice",
                        "latitude": "45.18189000",
                        "longitude": "21.08279000"
                    },
                    {
                        "id": 97168,
                        "name": "Bela Crkva",
                        "latitude": "44.89750000",
                        "longitude": "21.41722000"
                    },
                    {
                        "id": 97189,
                        "name": "Crepaja",
                        "latitude": "45.00984000",
                        "longitude": "20.63702000"
                    },
                    {
                        "id": 97191,
                        "name": "Debeljača",
                        "latitude": "45.07070000",
                        "longitude": "20.60153000"
                    },
                    {
                        "id": 97194,
                        "name": "Dobrica",
                        "latitude": "45.21339000",
                        "longitude": "20.84995000"
                    },
                    {
                        "id": 97217,
                        "name": "Gudurica",
                        "latitude": "45.16816000",
                        "longitude": "21.44264000"
                    },
                    {
                        "id": 97218,
                        "name": "Hajdučica",
                        "latitude": "45.25010000",
                        "longitude": "20.96016000"
                    },
                    {
                        "id": 97221,
                        "name": "Idvor",
                        "latitude": "45.18895000",
                        "longitude": "20.51442000"
                    },
                    {
                        "id": 97222,
                        "name": "Ilandža",
                        "latitude": "45.16897000",
                        "longitude": "20.92008000"
                    },
                    {
                        "id": 97225,
                        "name": "Izbište",
                        "latitude": "45.02253000",
                        "longitude": "21.18388000"
                    },
                    {
                        "id": 97229,
                        "name": "Janošik",
                        "latitude": "45.17141000",
                        "longitude": "21.00658000"
                    },
                    {
                        "id": 97236,
                        "name": "Jermenovci",
                        "latitude": "45.18635000",
                        "longitude": "21.04550000"
                    },
                    {
                        "id": 97251,
                        "name": "Kovačica",
                        "latitude": "45.11167000",
                        "longitude": "20.62139000"
                    },
                    {
                        "id": 97253,
                        "name": "Kovin",
                        "latitude": "44.74750000",
                        "longitude": "20.97611000"
                    },
                    {
                        "id": 97267,
                        "name": "Kuštilj",
                        "latitude": "45.03487000",
                        "longitude": "21.37989000"
                    },
                    {
                        "id": 97280,
                        "name": "Lokve",
                        "latitude": "45.15198000",
                        "longitude": "21.03073000"
                    },
                    {
                        "id": 97288,
                        "name": "Margita",
                        "latitude": "45.21598000",
                        "longitude": "21.17527000"
                    },
                    {
                        "id": 97304,
                        "name": "Nikolinci",
                        "latitude": "45.05245000",
                        "longitude": "21.06695000"
                    },
                    {
                        "id": 97321,
                        "name": "Opovo",
                        "latitude": "45.05222000",
                        "longitude": "20.43028000"
                    },
                    {
                        "id": 97329,
                        "name": "Padina",
                        "latitude": "45.11988000",
                        "longitude": "20.72860000"
                    },
                    {
                        "id": 97330,
                        "name": "Pančevo",
                        "latitude": "44.87177000",
                        "longitude": "20.64167000"
                    },
                    {
                        "id": 97332,
                        "name": "Pavliš",
                        "latitude": "45.10569000",
                        "longitude": "21.23952000"
                    },
                    {
                        "id": 97338,
                        "name": "Plandište",
                        "latitude": "45.22722000",
                        "longitude": "21.12167000"
                    },
                    {
                        "id": 97370,
                        "name": "Sakule",
                        "latitude": "45.14667000",
                        "longitude": "20.48619000"
                    },
                    {
                        "id": 97374,
                        "name": "Samoš",
                        "latitude": "45.20255000",
                        "longitude": "20.77392000"
                    },
                    {
                        "id": 97376,
                        "name": "Sefkerin",
                        "latitude": "45.00501000",
                        "longitude": "20.48256000"
                    },
                    {
                        "id": 97377,
                        "name": "Seleuš",
                        "latitude": "45.12770000",
                        "longitude": "20.91461000"
                    },
                    {
                        "id": 97397,
                        "name": "Stari Lec",
                        "latitude": "45.28401000",
                        "longitude": "20.96433000"
                    },
                    {
                        "id": 97420,
                        "name": "Uljma",
                        "latitude": "45.04213000",
                        "longitude": "21.15393000"
                    },
                    {
                        "id": 97422,
                        "name": "Uzdin",
                        "latitude": "45.20512000",
                        "longitude": "20.62342000"
                    },
                    {
                        "id": 97427,
                        "name": "Velika Greda",
                        "latitude": "45.24376000",
                        "longitude": "21.03498000"
                    },
                    {
                        "id": 97429,
                        "name": "Veliki Gaj",
                        "latitude": "45.28849000",
                        "longitude": "21.17057000"
                    },
                    {
                        "id": 97430,
                        "name": "Veliko Središte",
                        "latitude": "45.17919000",
                        "longitude": "21.40353000"
                    },
                    {
                        "id": 97435,
                        "name": "Vladimirovac",
                        "latitude": "45.03122000",
                        "longitude": "20.86566000"
                    },
                    {
                        "id": 97436,
                        "name": "Vlajkovac",
                        "latitude": "45.07207000",
                        "longitude": "21.19945000"
                    },
                    {
                        "id": 97444,
                        "name": "Vršac",
                        "latitude": "45.11667000",
                        "longitude": "21.30361000"
                    }
                ]
            },
            {
                "id": 3740,
                "name": "Srem",
                "iso2": "07",
                "latitude": "45.00291710",
                "longitude": "19.80137730",
                "type": "district",
                "cities": [
                    {
                        "id": 97169,
                        "name": "Belegiš",
                        "latitude": "45.01920000",
                        "longitude": "20.33323000"
                    },
                    {
                        "id": 97175,
                        "name": "Beška",
                        "latitude": "45.13092000",
                        "longitude": "20.06698000"
                    },
                    {
                        "id": 97183,
                        "name": "Bosut",
                        "latitude": "44.92977000",
                        "longitude": "19.36086000"
                    },
                    {
                        "id": 97188,
                        "name": "Buđanovci",
                        "latitude": "44.89388000",
                        "longitude": "19.86344000"
                    },
                    {
                        "id": 97463,
                        "name": "Čortanovci",
                        "latitude": "45.15460000",
                        "longitude": "20.01851000"
                    },
                    {
                        "id": 97211,
                        "name": "Golubinci",
                        "latitude": "44.98533000",
                        "longitude": "20.06339000"
                    },
                    {
                        "id": 97216,
                        "name": "Grabovci",
                        "latitude": "44.76496000",
                        "longitude": "19.84489000"
                    },
                    {
                        "id": 97220,
                        "name": "Hrtkovci",
                        "latitude": "44.88155000",
                        "longitude": "19.76374000"
                    },
                    {
                        "id": 97223,
                        "name": "Inđija",
                        "latitude": "45.04816000",
                        "longitude": "20.08165000"
                    },
                    {
                        "id": 97224,
                        "name": "Irig",
                        "latitude": "45.05230000",
                        "longitude": "19.84448000"
                    },
                    {
                        "id": 97230,
                        "name": "Jarak",
                        "latitude": "44.91843000",
                        "longitude": "19.75477000"
                    },
                    {
                        "id": 97244,
                        "name": "Klenak",
                        "latitude": "44.78846000",
                        "longitude": "19.71004000"
                    },
                    {
                        "id": 97262,
                        "name": "Krčedin",
                        "latitude": "45.13871000",
                        "longitude": "20.13308000"
                    },
                    {
                        "id": 97278,
                        "name": "Ljukovo",
                        "latitude": "45.02604000",
                        "longitude": "20.02737000"
                    },
                    {
                        "id": 97290,
                        "name": "Mačvanska Mitrovica",
                        "latitude": "44.96739000",
                        "longitude": "19.59314000"
                    },
                    {
                        "id": 97303,
                        "name": "Nikinci",
                        "latitude": "44.85017000",
                        "longitude": "19.82321000"
                    },
                    {
                        "id": 97308,
                        "name": "Nova Pazova",
                        "latitude": "44.94366000",
                        "longitude": "20.21931000"
                    },
                    {
                        "id": 97309,
                        "name": "Novi Banovci",
                        "latitude": "44.95691000",
                        "longitude": "20.28076000"
                    },
                    {
                        "id": 97311,
                        "name": "Novi Karlovci",
                        "latitude": "45.07636000",
                        "longitude": "20.17948000"
                    },
                    {
                        "id": 97316,
                        "name": "Novi Slankamen",
                        "latitude": "45.12554000",
                        "longitude": "20.23914000"
                    },
                    {
                        "id": 97336,
                        "name": "Pećinci",
                        "latitude": "44.90889000",
                        "longitude": "19.96639000"
                    },
                    {
                        "id": 97339,
                        "name": "Platičevo",
                        "latitude": "44.82213000",
                        "longitude": "19.79487000"
                    },
                    {
                        "id": 97350,
                        "name": "Putinci",
                        "latitude": "44.99259000",
                        "longitude": "19.97102000"
                    },
                    {
                        "id": 97353,
                        "name": "Radenković",
                        "latitude": "44.92191000",
                        "longitude": "19.49543000"
                    },
                    {
                        "id": 97359,
                        "name": "Ravnje",
                        "latitude": "44.94326000",
                        "longitude": "19.42280000"
                    },
                    {
                        "id": 97364,
                        "name": "Ruma",
                        "latitude": "45.00806000",
                        "longitude": "19.82222000"
                    },
                    {
                        "id": 97372,
                        "name": "Salaš Noćajski",
                        "latitude": "44.94722000",
                        "longitude": "19.58611000"
                    },
                    {
                        "id": 97467,
                        "name": "Šašinci",
                        "latitude": "44.96514000",
                        "longitude": "19.74151000"
                    },
                    {
                        "id": 155085,
                        "name": "Šid",
                        "latitude": "45.14969220",
                        "longitude": "19.12844990"
                    },
                    {
                        "id": 97470,
                        "name": "Šimanovci",
                        "latitude": "44.87393000",
                        "longitude": "20.09175000"
                    },
                    {
                        "id": 97388,
                        "name": "Sremska Mitrovica",
                        "latitude": "44.97639000",
                        "longitude": "19.61222000"
                    },
                    {
                        "id": 97395,
                        "name": "Stara Pazova",
                        "latitude": "44.98500000",
                        "longitude": "20.16083000"
                    },
                    {
                        "id": 97396,
                        "name": "Stari Banovci",
                        "latitude": "44.98420000",
                        "longitude": "20.28382000"
                    },
                    {
                        "id": 97403,
                        "name": "Surduk",
                        "latitude": "45.07118000",
                        "longitude": "20.32510000"
                    },
                    {
                        "id": 97433,
                        "name": "Višnjićevo",
                        "latitude": "44.96731000",
                        "longitude": "19.28993000"
                    },
                    {
                        "id": 97437,
                        "name": "Vojka",
                        "latitude": "44.93713000",
                        "longitude": "20.15236000"
                    },
                    {
                        "id": 97442,
                        "name": "Vrdnik",
                        "latitude": "45.12174000",
                        "longitude": "19.79227000"
                    }
                ]
            },
            {
                "id": 3734,
                "name": "Šumadija",
                "iso2": "12",
                "latitude": "44.20506780",
                "longitude": "20.78565650",
                "type": "district",
                "cities": [
                    {
                        "id": 97147,
                        "name": "Aranđelovac",
                        "latitude": "44.30694000",
                        "longitude": "20.56000000"
                    },
                    {
                        "id": 155086,
                        "name": "Batočina",
                        "latitude": "44.15465720",
                        "longitude": "21.02491300"
                    },
                    {
                        "id": 155087,
                        "name": "Knić",
                        "latitude": "43.92755740",
                        "longitude": "20.67905830"
                    },
                    {
                        "id": 97256,
                        "name": "Kragujevac",
                        "latitude": "44.01667000",
                        "longitude": "20.91667000"
                    },
                    {
                        "id": 97269,
                        "name": "Lapovo",
                        "latitude": "44.18424000",
                        "longitude": "21.09727000"
                    },
                    {
                        "id": 155088,
                        "name": "Rača",
                        "latitude": "44.23344940",
                        "longitude": "20.96074500"
                    },
                    {
                        "id": 97385,
                        "name": "Sokolovo Brdo",
                        "latitude": "43.13694000",
                        "longitude": "19.80556000"
                    },
                    {
                        "id": 155089,
                        "name": "Topola",
                        "latitude": "44.25204890",
                        "longitude": "20.66863050"
                    }
                ]
            },
            {
                "id": 3718,
                "name": "Toplica",
                "iso2": "21",
                "latitude": "43.19065920",
                "longitude": "21.34077620",
                "type": "district",
                "cities": [
                    {
                        "id": 155090,
                        "name": "Blace",
                        "latitude": "43.29874190",
                        "longitude": "21.24844850"
                    },
                    {
                        "id": 97452,
                        "name": "Ðurići",
                        "latitude": "43.82533000",
                        "longitude": "19.41233000"
                    },
                    {
                        "id": 97265,
                        "name": "Kupinovo",
                        "latitude": "44.70708000",
                        "longitude": "20.04959000"
                    },
                    {
                        "id": 155092,
                        "name": "Kuršumlija",
                        "latitude": "43.13784280",
                        "longitude": "21.24309210"
                    },
                    {
                        "id": 97349,
                        "name": "Prokuplje",
                        "latitude": "43.23417000",
                        "longitude": "21.58806000"
                    },
                    {
                        "id": 155091,
                        "name": "Žitorađa",
                        "latitude": "43.18492750",
                        "longitude": "21.61641320"
                    }
                ]
            },
            {
                "id": 3733,
                "name": "Vojvodina",
                "iso2": "VO",
                "latitude": "45.26086510",
                "longitude": "19.83193380",
                "type": "province",
                "cities": []
            },
            {
                "id": 3726,
                "name": "West Bačka",
                "iso2": "05",
                "latitude": "45.73553850",
                "longitude": "19.18973640",
                "type": "district",
                "cities": [
                    {
                        "id": 97145,
                        "name": "Apatin",
                        "latitude": "45.67260000",
                        "longitude": "18.97800000"
                    },
                    {
                        "id": 97163,
                        "name": "Bački Breg",
                        "latitude": "45.92034000",
                        "longitude": "18.92944000"
                    },
                    {
                        "id": 97178,
                        "name": "Bogojevo",
                        "latitude": "45.53015000",
                        "longitude": "19.13022000"
                    },
                    {
                        "id": 97198,
                        "name": "Doroslovo",
                        "latitude": "45.60699000",
                        "longitude": "19.18868000"
                    },
                    {
                        "id": 97206,
                        "name": "Gakovo",
                        "latitude": "45.90078000",
                        "longitude": "19.06138000"
                    },
                    {
                        "id": 97249,
                        "name": "Kolut",
                        "latitude": "45.89292000",
                        "longitude": "18.92760000"
                    },
                    {
                        "id": 155093,
                        "name": "Kula",
                        "latitude": "45.60706310",
                        "longitude": "19.46056640"
                    },
                    {
                        "id": 97266,
                        "name": "Kupusina",
                        "latitude": "45.73759000",
                        "longitude": "19.01082000"
                    },
                    {
                        "id": 155094,
                        "name": "Odžaci",
                        "latitude": "45.50206560",
                        "longitude": "19.20487140"
                    },
                    {
                        "id": 97345,
                        "name": "Prigrevica",
                        "latitude": "45.67636000",
                        "longitude": "19.08809000"
                    },
                    {
                        "id": 97363,
                        "name": "Riđica",
                        "latitude": "45.99088000",
                        "longitude": "19.10635000"
                    },
                    {
                        "id": 97386,
                        "name": "Sombor",
                        "latitude": "45.77417000",
                        "longitude": "19.11222000"
                    },
                    {
                        "id": 97387,
                        "name": "Sonta",
                        "latitude": "45.59427000",
                        "longitude": "19.09719000"
                    },
                    {
                        "id": 97394,
                        "name": "Stanišić",
                        "latitude": "45.93895000",
                        "longitude": "19.16709000"
                    }
                ]
            },
            {
                "id": 3731,
                "name": "Zaječar",
                "iso2": "15",
                "latitude": "43.90150480",
                "longitude": "22.27380110",
                "type": "district",
                "cities": [
                    {
                        "id": 155095,
                        "name": "Boljevac",
                        "latitude": "43.83114320",
                        "longitude": "21.92158620"
                    },
                    {
                        "id": 97181,
                        "name": "Boljevci",
                        "latitude": "44.72355000",
                        "longitude": "20.22348000"
                    },
                    {
                        "id": 97247,
                        "name": "Knjazevac",
                        "latitude": "43.56634000",
                        "longitude": "22.25701000"
                    },
                    {
                        "id": 155096,
                        "name": "Sokobanja",
                        "latitude": "43.63431460",
                        "longitude": "21.82442590"
                    },
                    {
                        "id": 97445,
                        "name": "Zaječar",
                        "latitude": "43.69917000",
                        "longitude": "21.98778000"
                    }
                ]
            },
            {
                "id": 3729,
                "name": "Zlatibor",
                "iso2": "16",
                "latitude": "43.64541700",
                "longitude": "19.71014550",
                "type": "district",
                "cities": [
                    {
                        "id": 97148,
                        "name": "Arilje",
                        "latitude": "43.75306000",
                        "longitude": "20.09556000"
                    },
                    {
                        "id": 97150,
                        "name": "Bajina Bašta",
                        "latitude": "43.97083000",
                        "longitude": "19.56750000"
                    },
                    {
                        "id": 97456,
                        "name": "Čajetina",
                        "latitude": "43.74977000",
                        "longitude": "19.71273000"
                    },
                    {
                        "id": 155097,
                        "name": "Kosjerić",
                        "latitude": "43.99992150",
                        "longitude": "19.89156760"
                    },
                    {
                        "id": 155098,
                        "name": "Nova Varoš",
                        "latitude": "43.46568110",
                        "longitude": "19.76736470"
                    },
                    {
                        "id": 97324,
                        "name": "Osječenik",
                        "latitude": "43.14528000",
                        "longitude": "19.85889000"
                    },
                    {
                        "id": 155099,
                        "name": "Požega",
                        "latitude": "43.84033580",
                        "longitude": "19.99691900"
                    },
                    {
                        "id": 97344,
                        "name": "Priboj",
                        "latitude": "43.58306000",
                        "longitude": "19.52519000"
                    },
                    {
                        "id": 97346,
                        "name": "Prijepolje",
                        "latitude": "43.38996000",
                        "longitude": "19.64870000"
                    },
                    {
                        "id": 97381,
                        "name": "Sjenica",
                        "latitude": "43.27306000",
                        "longitude": "19.99944000"
                    },
                    {
                        "id": 97424,
                        "name": "Užice",
                        "latitude": "43.85861000",
                        "longitude": "19.84878000"
                    }
                ]
            }
        ]
    },
    {
        "id": 197,
        "name": "Seychelles",
        "iso3": "SYC",
        "iso2": "SC",
        "numeric_code": "690",
        "phonecode": "248",
        "capital": "Victoria",
        "currency": "SCR",
        "currency_name": "Seychellois rupee",
        "currency_symbol": "SRe",
        "tld": ".sc",
        "native": "Seychelles",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Seychellois",
        "timezones": [
            {
                "zoneName": "Indian\/Mahe",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "SCT",
                "tzName": "Seychelles Time"
            }
        ],
        "translations": {
            "br": "Sechelez",
            "ko": "세이셸",
            "pt-BR": "Seicheles",
            "pt": "Seicheles",
            "nl": "Seychellen",
            "hr": "Sejšeli",
            "fa": "سیشل",
            "de": "Seychellen",
            "es": "Seychelles",
            "fr": "Seychelles",
            "ja": "セーシェル",
            "it": "Seychelles",
            "zh-CN": "塞舌尔",
            "tr": "Seyşeller",
            "ru": "Сейшельские острова",
            "uk": "Сейшельські острови",
            "pl": "Seszele"
        },
        "latitude": "-4.58333333",
        "longitude": "55.66666666",
        "emoji": "🇸🇨",
        "emojiU": "U+1F1F8 U+1F1E8",
        "states": [
            {
                "id": 513,
                "name": "Anse Boileau",
                "iso2": "02",
                "latitude": "-4.70472680",
                "longitude": "55.48593630",
                "type": "district",
                "cities": [
                    {
                        "id": 102906,
                        "name": "Anse Boileau",
                        "latitude": "-4.71667000",
                        "longitude": "55.48333000"
                    }
                ]
            },
            {
                "id": 502,
                "name": "Anse Royale",
                "iso2": "05",
                "latitude": "-4.74079880",
                "longitude": "55.50810120",
                "type": "district",
                "cities": [
                    {
                        "id": 102907,
                        "name": "Anse Royale",
                        "latitude": "-4.73333000",
                        "longitude": "55.51667000"
                    }
                ]
            },
            {
                "id": 506,
                "name": "Anse-aux-Pins",
                "iso2": "01",
                "latitude": "-4.69004430",
                "longitude": "55.51502890",
                "type": "district",
                "cities": []
            },
            {
                "id": 508,
                "name": "Au Cap",
                "iso2": "04",
                "latitude": "-4.70597230",
                "longitude": "55.50810120",
                "type": "district",
                "cities": []
            },
            {
                "id": 497,
                "name": "Baie Lazare",
                "iso2": "06",
                "latitude": "-4.74825250",
                "longitude": "55.48593630",
                "type": "district",
                "cities": []
            },
            {
                "id": 514,
                "name": "Baie Sainte Anne",
                "iso2": "07",
                "latitude": "47.05259000",
                "longitude": "-64.95245790",
                "type": "district",
                "cities": []
            },
            {
                "id": 512,
                "name": "Beau Vallon",
                "iso2": "08",
                "latitude": "-4.62109670",
                "longitude": "55.42778020",
                "type": "district",
                "cities": [
                    {
                        "id": 102908,
                        "name": "Beau Vallon",
                        "latitude": "-4.62091000",
                        "longitude": "55.43015000"
                    }
                ]
            },
            {
                "id": 515,
                "name": "Bel Air",
                "iso2": "09",
                "latitude": "34.10024550",
                "longitude": "-118.45946300",
                "type": "district",
                "cities": []
            },
            {
                "id": 505,
                "name": "Bel Ombre",
                "iso2": "10",
                "latitude": "-20.50100950",
                "longitude": "57.42596240",
                "type": "district",
                "cities": [
                    {
                        "id": 102909,
                        "name": "Bel Ombre",
                        "latitude": "-4.61667000",
                        "longitude": "55.41667000"
                    }
                ]
            },
            {
                "id": 517,
                "name": "Cascade",
                "iso2": "11",
                "latitude": "44.51628210",
                "longitude": "-116.04179830",
                "type": "district",
                "cities": [
                    {
                        "id": 102910,
                        "name": "Cascade",
                        "latitude": "-4.66667000",
                        "longitude": "55.50000000"
                    }
                ]
            },
            {
                "id": 503,
                "name": "Glacis",
                "iso2": "12",
                "latitude": "47.11573030",
                "longitude": "-70.30281830",
                "type": "district",
                "cities": []
            },
            {
                "id": 500,
                "name": "Grand'Anse Mahé",
                "iso2": "13",
                "latitude": "-4.67739200",
                "longitude": "55.46377700",
                "type": "district",
                "cities": []
            },
            {
                "id": 504,
                "name": "Grand'Anse Praslin",
                "iso2": "14",
                "latitude": "-4.31762190",
                "longitude": "55.70783630",
                "type": "district",
                "cities": []
            },
            {
                "id": 495,
                "name": "La Digue",
                "iso2": "15",
                "latitude": "49.76669220",
                "longitude": "-97.15466290",
                "type": "district",
                "cities": []
            },
            {
                "id": 516,
                "name": "La Rivière Anglaise",
                "iso2": "16",
                "latitude": "-4.61061500",
                "longitude": "55.45408410",
                "type": "district",
                "cities": [
                    {
                        "id": 102913,
                        "name": "Victoria",
                        "latitude": "-4.62001000",
                        "longitude": "55.45501000"
                    }
                ]
            },
            {
                "id": 499,
                "name": "Les Mamelles",
                "iso2": "24",
                "latitude": "38.82505050",
                "longitude": "-90.48345170",
                "type": "district",
                "cities": []
            },
            {
                "id": 494,
                "name": "Mont Buxton",
                "iso2": "17",
                "latitude": "-4.61666670",
                "longitude": "55.44577680",
                "type": "district",
                "cities": []
            },
            {
                "id": 498,
                "name": "Mont Fleuri",
                "iso2": "18",
                "latitude": "-4.63565430",
                "longitude": "55.45546880",
                "type": "district",
                "cities": []
            },
            {
                "id": 511,
                "name": "Plaisance",
                "iso2": "19",
                "latitude": "45.60709500",
                "longitude": "-75.11427450",
                "type": "district",
                "cities": []
            },
            {
                "id": 510,
                "name": "Pointe La Rue",
                "iso2": "20",
                "latitude": "-4.68048900",
                "longitude": "55.51918570",
                "type": "district",
                "cities": []
            },
            {
                "id": 507,
                "name": "Port Glaud",
                "iso2": "21",
                "latitude": "-4.64885230",
                "longitude": "55.41947530",
                "type": "district",
                "cities": [
                    {
                        "id": 102911,
                        "name": "Port Glaud",
                        "latitude": "-4.66667000",
                        "longitude": "55.41667000"
                    }
                ]
            },
            {
                "id": 501,
                "name": "Roche Caiman",
                "iso2": "25",
                "latitude": "-4.63960280",
                "longitude": "55.46793150",
                "type": "district",
                "cities": []
            },
            {
                "id": 496,
                "name": "Saint Louis",
                "iso2": "22",
                "latitude": "-4.62438050",
                "longitude": "55.43010160",
                "type": "district",
                "cities": []
            },
            {
                "id": 509,
                "name": "Takamaka",
                "iso2": "23",
                "latitude": "37.96459170",
                "longitude": "-1.22177270",
                "type": "district",
                "cities": [
                    {
                        "id": 102912,
                        "name": "Takamaka",
                        "latitude": "-4.76667000",
                        "longitude": "55.50000000"
                    }
                ]
            }
        ]
    },
    {
        "id": 198,
        "name": "Sierra Leone",
        "iso3": "SLE",
        "iso2": "SL",
        "numeric_code": "694",
        "phonecode": "232",
        "capital": "Freetown",
        "currency": "SLL",
        "currency_name": "Sierra Leonean leone",
        "currency_symbol": "Le",
        "tld": ".sl",
        "native": "Sierra Leone",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Sierra Leonean",
        "timezones": [
            {
                "zoneName": "Africa\/Freetown",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Sierra Leone",
            "ko": "시에라리온",
            "pt-BR": "Serra Leoa",
            "pt": "Serra Leoa",
            "nl": "Sierra Leone",
            "hr": "Sijera Leone",
            "fa": "سیرالئون",
            "de": "Sierra Leone",
            "es": "Sierra Leone",
            "fr": "Sierra Leone",
            "ja": "シエラレオネ",
            "it": "Sierra Leone",
            "zh-CN": "塞拉利昂",
            "tr": "Sierra Leone",
            "ru": "Сьерра-Леоне",
            "uk": "Сьєрра-Леоне",
            "pl": "Sierra Leone"
        },
        "latitude": "8.50000000",
        "longitude": "-11.50000000",
        "emoji": "🇸🇱",
        "emojiU": "U+1F1F8 U+1F1F1",
        "states": [
            {
                "id": 914,
                "name": "Eastern",
                "iso2": "E",
                "latitude": "8.21016010",
                "longitude": "-11.59218090",
                "type": "province",
                "cities": [
                    {
                        "id": 104606,
                        "name": "Barma",
                        "latitude": "8.34959000",
                        "longitude": "-11.33059000"
                    },
                    {
                        "id": 104609,
                        "name": "Blama",
                        "latitude": "7.87481000",
                        "longitude": "-11.34548000"
                    },
                    {
                        "id": 104612,
                        "name": "Boajibu",
                        "latitude": "8.18763000",
                        "longitude": "-11.34026000"
                    },
                    {
                        "id": 104617,
                        "name": "Buedu",
                        "latitude": "8.27960000",
                        "longitude": "-10.37135000"
                    },
                    {
                        "id": 104620,
                        "name": "Bunumbu",
                        "latitude": "8.17421000",
                        "longitude": "-10.86432000"
                    },
                    {
                        "id": 104621,
                        "name": "Daru",
                        "latitude": "7.98976000",
                        "longitude": "-10.84223000"
                    },
                    {
                        "id": 104627,
                        "name": "Giehun",
                        "latitude": "7.88405000",
                        "longitude": "-11.04908000"
                    },
                    {
                        "id": 104628,
                        "name": "Gorahun",
                        "latitude": "7.46439000",
                        "longitude": "-11.23952000"
                    },
                    {
                        "id": 104629,
                        "name": "Hangha",
                        "latitude": "7.93974000",
                        "longitude": "-11.14132000"
                    },
                    {
                        "id": 104631,
                        "name": "Jojoima",
                        "latitude": "7.87815000",
                        "longitude": "-10.78976000"
                    },
                    {
                        "id": 104633,
                        "name": "Kailahun",
                        "latitude": "8.27890000",
                        "longitude": "-10.57300000"
                    },
                    {
                        "id": 104634,
                        "name": "Kailahun District",
                        "latitude": "8.10768000",
                        "longitude": "-10.75146000"
                    },
                    {
                        "id": 104638,
                        "name": "Kayima",
                        "latitude": "8.88790000",
                        "longitude": "-11.15932000"
                    },
                    {
                        "id": 104639,
                        "name": "Kenema",
                        "latitude": "7.87687000",
                        "longitude": "-11.19025000"
                    },
                    {
                        "id": 104640,
                        "name": "Kenema District",
                        "latitude": "7.95171000",
                        "longitude": "-11.19004000"
                    },
                    {
                        "id": 104642,
                        "name": "Koidu",
                        "latitude": "8.64387000",
                        "longitude": "-10.97140000"
                    },
                    {
                        "id": 104645,
                        "name": "Kono District",
                        "latitude": "8.70687000",
                        "longitude": "-10.93368000"
                    },
                    {
                        "id": 104647,
                        "name": "Koyima",
                        "latitude": "8.70552000",
                        "longitude": "-11.02241000"
                    },
                    {
                        "id": 104658,
                        "name": "Manowa",
                        "latitude": "8.17392000",
                        "longitude": "-10.74834000"
                    },
                    {
                        "id": 104662,
                        "name": "Mobai",
                        "latitude": "7.99343000",
                        "longitude": "-10.75355000"
                    },
                    {
                        "id": 104664,
                        "name": "Motema",
                        "latitude": "8.61427000",
                        "longitude": "-11.01252000"
                    },
                    {
                        "id": 104668,
                        "name": "Panguma",
                        "latitude": "8.18507000",
                        "longitude": "-11.13290000"
                    },
                    {
                        "id": 104669,
                        "name": "Pendembu",
                        "latitude": "8.09807000",
                        "longitude": "-10.69429000"
                    },
                    {
                        "id": 104677,
                        "name": "Segbwema",
                        "latitude": "7.99471000",
                        "longitude": "-10.95020000"
                    },
                    {
                        "id": 104680,
                        "name": "Simbakoro",
                        "latitude": "8.61243000",
                        "longitude": "-11.00755000"
                    },
                    {
                        "id": 104682,
                        "name": "Tefeya",
                        "latitude": "8.70395000",
                        "longitude": "-11.21260000"
                    },
                    {
                        "id": 104684,
                        "name": "Tombodu",
                        "latitude": "8.13526000",
                        "longitude": "-10.61960000"
                    },
                    {
                        "id": 104685,
                        "name": "Tombu",
                        "latitude": "8.53991000",
                        "longitude": "-10.73132000"
                    },
                    {
                        "id": 104689,
                        "name": "Wima",
                        "latitude": "8.30052000",
                        "longitude": "-11.20455000"
                    },
                    {
                        "id": 104690,
                        "name": "Yengema",
                        "latitude": "8.71441000",
                        "longitude": "-11.17057000"
                    }
                ]
            },
            {
                "id": 911,
                "name": "Northern",
                "iso2": "N",
                "latitude": "9.11775710",
                "longitude": "-12.93301530",
                "type": "province",
                "cities": [
                    {
                        "id": 104603,
                        "name": "Alikalia",
                        "latitude": "9.15356000",
                        "longitude": "-11.38712000"
                    },
                    {
                        "id": 104607,
                        "name": "Bindi",
                        "latitude": "9.91376000",
                        "longitude": "-11.44669000"
                    },
                    {
                        "id": 104608,
                        "name": "Binkolo",
                        "latitude": "8.95225000",
                        "longitude": "-11.98029000"
                    },
                    {
                        "id": 104613,
                        "name": "Bombali District",
                        "latitude": "9.28444000",
                        "longitude": "-12.16449000"
                    },
                    {
                        "id": 104618,
                        "name": "Bumbuna",
                        "latitude": "9.04466000",
                        "longitude": "-11.74576000"
                    },
                    {
                        "id": 104625,
                        "name": "Gberia Fotombu",
                        "latitude": "9.87852000",
                        "longitude": "-11.16548000"
                    },
                    {
                        "id": 104632,
                        "name": "Kabala",
                        "latitude": "9.58893000",
                        "longitude": "-11.55256000"
                    },
                    {
                        "id": 104635,
                        "name": "Kamakwie",
                        "latitude": "9.49689000",
                        "longitude": "-12.24061000"
                    },
                    {
                        "id": 104636,
                        "name": "Kambia",
                        "latitude": "9.12504000",
                        "longitude": "-12.91816000"
                    },
                    {
                        "id": 104637,
                        "name": "Kassiri",
                        "latitude": "8.93814000",
                        "longitude": "-13.11541000"
                    },
                    {
                        "id": 104643,
                        "name": "Koinadugu District",
                        "latitude": "9.50991000",
                        "longitude": "-11.34601000"
                    },
                    {
                        "id": 104644,
                        "name": "Konakridee",
                        "latitude": "8.69778000",
                        "longitude": "-13.23917000"
                    },
                    {
                        "id": 104648,
                        "name": "Kukuna",
                        "latitude": "9.39841000",
                        "longitude": "-12.66476000"
                    },
                    {
                        "id": 104650,
                        "name": "Loma",
                        "latitude": "9.75931000",
                        "longitude": "-12.03383000"
                    },
                    {
                        "id": 104651,
                        "name": "Lunsar",
                        "latitude": "8.68439000",
                        "longitude": "-12.53499000"
                    },
                    {
                        "id": 104652,
                        "name": "Magburaka",
                        "latitude": "8.72306000",
                        "longitude": "-11.94880000"
                    },
                    {
                        "id": 104653,
                        "name": "Makali",
                        "latitude": "8.62964000",
                        "longitude": "-11.66168000"
                    },
                    {
                        "id": 104654,
                        "name": "Makeni",
                        "latitude": "8.88605000",
                        "longitude": "-12.04417000"
                    },
                    {
                        "id": 104655,
                        "name": "Mambolo",
                        "latitude": "8.91860000",
                        "longitude": "-13.03674000"
                    },
                    {
                        "id": 104657,
                        "name": "Mange",
                        "latitude": "8.92262000",
                        "longitude": "-12.85688000"
                    },
                    {
                        "id": 104659,
                        "name": "Masaka",
                        "latitude": "8.66492000",
                        "longitude": "-11.80260000"
                    },
                    {
                        "id": 104660,
                        "name": "Masingbi",
                        "latitude": "8.78197000",
                        "longitude": "-11.95171000"
                    },
                    {
                        "id": 104661,
                        "name": "Masoyila",
                        "latitude": "8.61119000",
                        "longitude": "-13.19101000"
                    },
                    {
                        "id": 104670,
                        "name": "Pepel",
                        "latitude": "8.58611000",
                        "longitude": "-13.05444000"
                    },
                    {
                        "id": 104674,
                        "name": "Rokupr",
                        "latitude": "8.67121000",
                        "longitude": "-12.38497000"
                    },
                    {
                        "id": 104676,
                        "name": "Sawkta",
                        "latitude": "8.63230000",
                        "longitude": "-13.20250000"
                    },
                    {
                        "id": 104678,
                        "name": "Seidu",
                        "latitude": "9.01801000",
                        "longitude": "-10.59496000"
                    },
                    {
                        "id": 104683,
                        "name": "Tintafor",
                        "latitude": "8.62667000",
                        "longitude": "-13.21500000"
                    },
                    {
                        "id": 104687,
                        "name": "Tonkolili District",
                        "latitude": "8.61885000",
                        "longitude": "-11.84173000"
                    },
                    {
                        "id": 104691,
                        "name": "Yonibana",
                        "latitude": "8.44347000",
                        "longitude": "-12.23929000"
                    }
                ]
            },
            {
                "id": 912,
                "name": "Southern",
                "iso2": "S",
                "latitude": "7.70540930",
                "longitude": "-13.42507660",
                "type": "province",
                "cities": [
                    {
                        "id": 104604,
                        "name": "Baiima",
                        "latitude": "8.10826000",
                        "longitude": "-11.84772000"
                    },
                    {
                        "id": 104605,
                        "name": "Baoma",
                        "latitude": "7.99344000",
                        "longitude": "-11.71468000"
                    },
                    {
                        "id": 104610,
                        "name": "Bo",
                        "latitude": "7.96472000",
                        "longitude": "-11.73833000"
                    },
                    {
                        "id": 104611,
                        "name": "Bo District",
                        "latitude": "7.98877000",
                        "longitude": "-11.67340000"
                    },
                    {
                        "id": 104614,
                        "name": "Bomi",
                        "latitude": "7.24611000",
                        "longitude": "-11.52583000"
                    },
                    {
                        "id": 104615,
                        "name": "Bonthe",
                        "latitude": "7.52639000",
                        "longitude": "-12.50500000"
                    },
                    {
                        "id": 104616,
                        "name": "Bonthe District",
                        "latitude": "7.51622000",
                        "longitude": "-12.33591000"
                    },
                    {
                        "id": 104619,
                        "name": "Bumpe",
                        "latitude": "7.89209000",
                        "longitude": "-11.90541000"
                    },
                    {
                        "id": 104622,
                        "name": "Foindu",
                        "latitude": "7.40906000",
                        "longitude": "-11.54328000"
                    },
                    {
                        "id": 104624,
                        "name": "Gandorhun",
                        "latitude": "7.55502000",
                        "longitude": "-11.69260000"
                    },
                    {
                        "id": 104626,
                        "name": "Gbewebu",
                        "latitude": "7.55091000",
                        "longitude": "-11.60750000"
                    },
                    {
                        "id": 104646,
                        "name": "Koribundu",
                        "latitude": "7.70952000",
                        "longitude": "-11.69354000"
                    },
                    {
                        "id": 104649,
                        "name": "Largo",
                        "latitude": "8.27903000",
                        "longitude": "-12.15780000"
                    },
                    {
                        "id": 104656,
                        "name": "Mamboma",
                        "latitude": "8.08742000",
                        "longitude": "-11.68841000"
                    },
                    {
                        "id": 104663,
                        "name": "Mogbwemo",
                        "latitude": "7.76237000",
                        "longitude": "-12.30864000"
                    },
                    {
                        "id": 104665,
                        "name": "Moyamba",
                        "latitude": "8.15898000",
                        "longitude": "-12.43168000"
                    },
                    {
                        "id": 104666,
                        "name": "Moyamba District",
                        "latitude": "8.06290000",
                        "longitude": "-12.44401000"
                    },
                    {
                        "id": 104667,
                        "name": "Palima",
                        "latitude": "8.11996000",
                        "longitude": "-11.50702000"
                    },
                    {
                        "id": 104671,
                        "name": "Potoru",
                        "latitude": "7.50596000",
                        "longitude": "-11.47897000"
                    },
                    {
                        "id": 104672,
                        "name": "Pujehun",
                        "latitude": "7.35806000",
                        "longitude": "-11.72083000"
                    },
                    {
                        "id": 104673,
                        "name": "Pujehun District",
                        "latitude": "7.31855000",
                        "longitude": "-11.57920000"
                    },
                    {
                        "id": 104675,
                        "name": "Rotifunk",
                        "latitude": "8.22591000",
                        "longitude": "-12.67760000"
                    },
                    {
                        "id": 104679,
                        "name": "Serabu",
                        "latitude": "7.79311000",
                        "longitude": "-12.05294000"
                    },
                    {
                        "id": 104681,
                        "name": "Sumbuya",
                        "latitude": "7.64789000",
                        "longitude": "-11.96060000"
                    },
                    {
                        "id": 104686,
                        "name": "Tongole",
                        "latitude": "7.45092000",
                        "longitude": "-11.90071000"
                    },
                    {
                        "id": 104692,
                        "name": "Zimmi",
                        "latitude": "7.31356000",
                        "longitude": "-11.30818000"
                    }
                ]
            },
            {
                "id": 913,
                "name": "Western",
                "iso2": "W",
                "latitude": "8.29678710",
                "longitude": "-13.26997610",
                "type": "area",
                "cities": [
                    {
                        "id": 104623,
                        "name": "Freetown",
                        "latitude": "8.48714000",
                        "longitude": "-13.23560000"
                    },
                    {
                        "id": 104630,
                        "name": "Hastings",
                        "latitude": "8.37994000",
                        "longitude": "-13.13693000"
                    },
                    {
                        "id": 104641,
                        "name": "Kent",
                        "latitude": "8.33333000",
                        "longitude": "-13.06667000"
                    },
                    {
                        "id": 104688,
                        "name": "Waterloo",
                        "latitude": "8.33890000",
                        "longitude": "-13.07091000"
                    }
                ]
            }
        ]
    },
    {
        "id": 199,
        "name": "Singapore",
        "iso3": "SGP",
        "iso2": "SG",
        "numeric_code": "702",
        "phonecode": "65",
        "capital": "Singapur",
        "currency": "SGD",
        "currency_name": "Singapore dollar",
        "currency_symbol": "$",
        "tld": ".sg",
        "native": "Singapore",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Singaporean",
        "timezones": [
            {
                "zoneName": "Asia\/Singapore",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "SGT",
                "tzName": "Singapore Time"
            }
        ],
        "translations": {
            "br": "Singapour",
            "ko": "싱가포르",
            "pt-BR": "Singapura",
            "pt": "Singapura",
            "nl": "Singapore",
            "hr": "Singapur",
            "fa": "سنگاپور",
            "de": "Singapur",
            "es": "Singapur",
            "fr": "Singapour",
            "ja": "シンガポール",
            "it": "Singapore",
            "zh-CN": "新加坡",
            "tr": "Singapur",
            "ru": "Сингапур",
            "uk": "Сінгапур",
            "pl": "Singapur"
        },
        "latitude": "1.36666666",
        "longitude": "103.80000000",
        "emoji": "🇸🇬",
        "emojiU": "U+1F1F8 U+1F1EC",
        "states": [
            {
                "id": 4651,
                "name": "Central Singapore",
                "iso2": "01",
                "latitude": "1.28840000",
                "longitude": "103.85350000",
                "type": "district",
                "cities": [
                    {
                        "id": 153462,
                        "name": "Bukit Timah",
                        "latitude": "1.32940000",
                        "longitude": "103.80210000"
                    },
                    {
                        "id": 153466,
                        "name": "Downtown Core",
                        "latitude": "1.27800000",
                        "longitude": "103.85200000"
                    },
                    {
                        "id": 153463,
                        "name": "Geylang",
                        "latitude": "1.31820000",
                        "longitude": "103.88710000"
                    },
                    {
                        "id": 153467,
                        "name": "Kallang",
                        "latitude": "1.31060000",
                        "longitude": "103.86600000"
                    },
                    {
                        "id": 153459,
                        "name": "Marine Parade",
                        "latitude": "1.30300000",
                        "longitude": "103.90720000"
                    },
                    {
                        "id": 153461,
                        "name": "Novena",
                        "latitude": "1.32010000",
                        "longitude": "103.84390000"
                    },
                    {
                        "id": 153464,
                        "name": "Orchard Road",
                        "latitude": "1.30360000",
                        "longitude": "103.83180000"
                    },
                    {
                        "id": 153468,
                        "name": "Outram",
                        "latitude": "1.28190000",
                        "longitude": "103.83900000"
                    },
                    {
                        "id": 153465,
                        "name": "Rochor",
                        "latitude": "1.30490000",
                        "longitude": "103.85200000"
                    },
                    {
                        "id": 104057,
                        "name": "Singapore",
                        "latitude": "1.28967000",
                        "longitude": "103.85007000"
                    },
                    {
                        "id": 153460,
                        "name": "Tanjong Pagar",
                        "latitude": "1.27640000",
                        "longitude": "103.84340000"
                    },
                    {
                        "id": 153469,
                        "name": "Toa Payoh",
                        "latitude": "1.33540000",
                        "longitude": "103.84970000"
                    }
                ]
            },
            {
                "id": 4649,
                "name": "North East",
                "iso2": "02",
                "latitude": "1.38240000",
                "longitude": "103.89720000",
                "type": "district",
                "cities": [
                    {
                        "id": 153475,
                        "name": "Ang Mo Kio",
                        "latitude": "1.36980000",
                        "longitude": "103.84610000"
                    },
                    {
                        "id": 153472,
                        "name": "Hougang",
                        "latitude": "1.37360000",
                        "longitude": "103.88670000"
                    },
                    {
                        "id": 153474,
                        "name": "Punggol",
                        "latitude": "1.40510000",
                        "longitude": "103.90230000"
                    },
                    {
                        "id": 153471,
                        "name": "Sengkang",
                        "latitude": "1.39010000",
                        "longitude": "103.89520000"
                    },
                    {
                        "id": 153473,
                        "name": "Serangoon",
                        "latitude": "1.34960000",
                        "longitude": "103.87370000"
                    }
                ]
            },
            {
                "id": 4653,
                "name": "North West",
                "iso2": "03",
                "latitude": "1.41800000",
                "longitude": "103.82750000",
                "type": "district",
                "cities": [
                    {
                        "id": 153476,
                        "name": "Sembawang",
                        "latitude": "1.44910000",
                        "longitude": "103.82010000"
                    },
                    {
                        "id": 104058,
                        "name": "Woodlands",
                        "latitude": "1.43801000",
                        "longitude": "103.78877000"
                    },
                    {
                        "id": 153470,
                        "name": "Yishun",
                        "latitude": "1.42930000",
                        "longitude": "103.83550000"
                    }
                ]
            },
            {
                "id": 4650,
                "name": "South East",
                "iso2": "04",
                "latitude": "1.35710000",
                "longitude": "103.70040000",
                "type": "district",
                "cities": [
                    {
                        "id": 153478,
                        "name": "Bedok",
                        "latitude": "1.32360000",
                        "longitude": "103.92730000"
                    },
                    {
                        "id": 153479,
                        "name": "Pasir Ris",
                        "latitude": "1.37390000",
                        "longitude": "103.94930000"
                    },
                    {
                        "id": 153477,
                        "name": "Tampines",
                        "latitude": "1.35470000",
                        "longitude": "103.94370000"
                    }
                ]
            },
            {
                "id": 4652,
                "name": "South West",
                "iso2": "05",
                "latitude": "1.35710000",
                "longitude": "103.94510000",
                "type": "district",
                "cities": [
                    {
                        "id": 153481,
                        "name": "Bukit Batok",
                        "latitude": "1.34960000",
                        "longitude": "103.75280000"
                    },
                    {
                        "id": 153482,
                        "name": "Bukit Panjang",
                        "latitude": "1.37860000",
                        "longitude": "103.76260000"
                    },
                    {
                        "id": 153480,
                        "name": "Jurong West",
                        "latitude": "1.33960000",
                        "longitude": "103.70730000"
                    }
                ]
            }
        ]
    },
    {
        "id": 250,
        "name": "Sint Maarten (Dutch part)",
        "iso3": "SXM",
        "iso2": "SX",
        "numeric_code": "534",
        "phonecode": "1721",
        "capital": "Philipsburg",
        "currency": "ANG",
        "currency_name": "Netherlands Antillean guilder",
        "currency_symbol": "ƒ",
        "tld": ".sx",
        "native": "Sint Maarten",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Sint Maarten",
        "timezones": [
            {
                "zoneName": "America\/Anguilla",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Sint Maarten",
            "ko": "신트마르턴",
            "pt-BR": "Sint Maarten",
            "pt": "São Martinho",
            "nl": "Sint Maarten",
            "fa": "سینت مارتن",
            "de": "Sint Maarten (niederl. Teil)",
            "fr": "Saint Martin (partie néerlandaise)",
            "it": "Saint Martin (parte olandese)",
            "zh-CN": "圣马丁岛（荷兰部分）",
            "tr": "Sint Maarten",
            "ru": "Синт-Мартен (голландская часть)",
            "uk": "Сінт-Мартен (голландська частина)",
            "pl": "Sint Maarten (część niderlandzka)"
        },
        "latitude": "18.03333300",
        "longitude": "-63.05000000",
        "emoji": "🇸🇽",
        "emojiU": "U+1F1F8 U+1F1FD",
        "states": []
    },
    {
        "id": 200,
        "name": "Slovakia",
        "iso3": "SVK",
        "iso2": "SK",
        "numeric_code": "703",
        "phonecode": "421",
        "capital": "Bratislava",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".sk",
        "native": "Slovensko",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Slovak",
        "timezones": [
            {
                "zoneName": "Europe\/Bratislava",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Slovakia",
            "ko": "슬로바키아",
            "pt-BR": "Eslováquia",
            "pt": "Eslováquia",
            "nl": "Slowakije",
            "hr": "Slovačka",
            "fa": "اسلواکی",
            "de": "Slowakei",
            "es": "República Eslovaca",
            "fr": "Slovaquie",
            "ja": "スロバキア",
            "it": "Slovacchia",
            "zh-CN": "斯洛伐克",
            "tr": "Slovakya",
            "ru": "Словакия",
            "uk": "Словаччина",
            "pl": "Słowacja"
        },
        "latitude": "48.66666666",
        "longitude": "19.50000000",
        "emoji": "🇸🇰",
        "emojiU": "U+1F1F8 U+1F1F0",
        "states": [
            {
                "id": 4352,
                "name": "Banská Bystrica",
                "iso2": "BC",
                "latitude": "48.53124990",
                "longitude": "19.38287400",
                "type": "region",
                "cities": [
                    {
                        "id": 104370,
                        "name": "Banská Bystrica",
                        "latitude": "48.73946000",
                        "longitude": "19.15349000"
                    },
                    {
                        "id": 104371,
                        "name": "Banská Štiavnica",
                        "latitude": "48.44858000",
                        "longitude": "18.91003000"
                    },
                    {
                        "id": 104376,
                        "name": "Brezno",
                        "latitude": "48.80431000",
                        "longitude": "19.63631000"
                    },
                    {
                        "id": 104589,
                        "name": "Čierny Balog",
                        "latitude": "48.74722000",
                        "longitude": "19.65125000"
                    },
                    {
                        "id": 104381,
                        "name": "Detva",
                        "latitude": "48.56082000",
                        "longitude": "19.41954000"
                    },
                    {
                        "id": 104385,
                        "name": "Dudince",
                        "latitude": "48.17135000",
                        "longitude": "18.88782000"
                    },
                    {
                        "id": 104388,
                        "name": "Fiľakovo",
                        "latitude": "48.26757000",
                        "longitude": "19.82473000"
                    },
                    {
                        "id": 104397,
                        "name": "Hriňová",
                        "latitude": "48.57787000",
                        "longitude": "19.52574000"
                    },
                    {
                        "id": 104398,
                        "name": "HrochoťSlovakia",
                        "latitude": "48.65567000",
                        "longitude": "19.31284000"
                    },
                    {
                        "id": 104408,
                        "name": "Kováčová",
                        "latitude": "48.60148000",
                        "longitude": "19.10252000"
                    },
                    {
                        "id": 104415,
                        "name": "Kremnica",
                        "latitude": "48.70519000",
                        "longitude": "18.91834000"
                    },
                    {
                        "id": 104417,
                        "name": "Krupina",
                        "latitude": "48.35540000",
                        "longitude": "19.06474000"
                    },
                    {
                        "id": 104426,
                        "name": "Lučenec",
                        "latitude": "48.33249000",
                        "longitude": "19.66708000"
                    },
                    {
                        "id": 104440,
                        "name": "Nová Baňa",
                        "latitude": "48.42305000",
                        "longitude": "18.64037000"
                    },
                    {
                        "id": 104447,
                        "name": "Okres Banská Bystrica",
                        "latitude": "48.73333000",
                        "longitude": "19.15000000"
                    },
                    {
                        "id": 104448,
                        "name": "Okres Banská Štiavnica",
                        "latitude": "48.44961000",
                        "longitude": "18.90820000"
                    },
                    {
                        "id": 104455,
                        "name": "Okres Brezno",
                        "latitude": "48.80000000",
                        "longitude": "19.75000000"
                    },
                    {
                        "id": 104458,
                        "name": "Okres Detva",
                        "latitude": "48.55985000",
                        "longitude": "19.42044000"
                    },
                    {
                        "id": 104469,
                        "name": "Okres Krupina",
                        "latitude": "48.35736000",
                        "longitude": "19.06334000"
                    },
                    {
                        "id": 104474,
                        "name": "Okres Lučenec",
                        "latitude": "48.33333000",
                        "longitude": "19.66667000"
                    },
                    {
                        "id": 104487,
                        "name": "Okres Poltár",
                        "latitude": "48.42895000",
                        "longitude": "19.79488000"
                    },
                    {
                        "id": 104493,
                        "name": "Okres Revúca",
                        "latitude": "48.68300000",
                        "longitude": "20.11568000"
                    },
                    {
                        "id": 104512,
                        "name": "Okres Veľký Krtíš",
                        "latitude": "48.20000000",
                        "longitude": "19.35000000"
                    },
                    {
                        "id": 104518,
                        "name": "Okres Žarnovica",
                        "latitude": "48.48438000",
                        "longitude": "18.72076000"
                    },
                    {
                        "id": 104519,
                        "name": "Okres Žiar nad Hronom",
                        "latitude": "48.58333000",
                        "longitude": "18.86667000"
                    },
                    {
                        "id": 104515,
                        "name": "Okres Zvolen",
                        "latitude": "48.58333000",
                        "longitude": "19.13333000"
                    },
                    {
                        "id": 104527,
                        "name": "Poltár",
                        "latitude": "48.43094000",
                        "longitude": "19.79408000"
                    },
                    {
                        "id": 104535,
                        "name": "Revúca",
                        "latitude": "48.68346000",
                        "longitude": "20.11734000"
                    },
                    {
                        "id": 104536,
                        "name": "Rimavská Sobota",
                        "latitude": "48.38284000",
                        "longitude": "20.02239000"
                    },
                    {
                        "id": 104559,
                        "name": "Svätý Anton",
                        "latitude": "48.41923000",
                        "longitude": "18.94010000"
                    },
                    {
                        "id": 104562,
                        "name": "Tisovec",
                        "latitude": "48.67738000",
                        "longitude": "19.94364000"
                    },
                    {
                        "id": 104573,
                        "name": "Veľký Krtíš",
                        "latitude": "48.21059000",
                        "longitude": "19.35043000"
                    },
                    {
                        "id": 104597,
                        "name": "Žarnovica",
                        "latitude": "48.48123000",
                        "longitude": "18.71565000"
                    },
                    {
                        "id": 104601,
                        "name": "Žiar nad Hronom",
                        "latitude": "48.59184000",
                        "longitude": "18.84958000"
                    },
                    {
                        "id": 104585,
                        "name": "Zvolen",
                        "latitude": "48.57442000",
                        "longitude": "19.15324000"
                    }
                ]
            },
            {
                "id": 4356,
                "name": "Bratislava",
                "iso2": "BL",
                "latitude": "48.31183040",
                "longitude": "17.19732990",
                "type": "region",
                "cities": [
                    {
                        "id": 104374,
                        "name": "Bratislava",
                        "latitude": "48.14816000",
                        "longitude": "17.10674000"
                    },
                    {
                        "id": 104375,
                        "name": "Bratislava - Vajnory",
                        "latitude": "48.20563000",
                        "longitude": "17.20759000"
                    },
                    {
                        "id": 104386,
                        "name": "Dunajská Lužná",
                        "latitude": "48.08347000",
                        "longitude": "17.26072000"
                    },
                    {
                        "id": 104403,
                        "name": "Ivanka pri Dunaji",
                        "latitude": "48.18675000",
                        "longitude": "17.25540000"
                    },
                    {
                        "id": 104428,
                        "name": "Malacky",
                        "latitude": "48.43604000",
                        "longitude": "17.02188000"
                    },
                    {
                        "id": 104429,
                        "name": "Marianka",
                        "latitude": "48.24903000",
                        "longitude": "17.06400000"
                    },
                    {
                        "id": 104434,
                        "name": "Modra",
                        "latitude": "48.33397000",
                        "longitude": "17.30711000"
                    },
                    {
                        "id": 104450,
                        "name": "Okres Bratislava I",
                        "latitude": "48.14653000",
                        "longitude": "17.10584000"
                    },
                    {
                        "id": 104451,
                        "name": "Okres Bratislava II",
                        "latitude": "48.15280000",
                        "longitude": "17.17764000"
                    },
                    {
                        "id": 104452,
                        "name": "Okres Bratislava III",
                        "latitude": "48.18543000",
                        "longitude": "17.13790000"
                    },
                    {
                        "id": 104453,
                        "name": "Okres Bratislava IV",
                        "latitude": "48.22787000",
                        "longitude": "16.99722000"
                    },
                    {
                        "id": 104454,
                        "name": "Okres Bratislava V",
                        "latitude": "48.11122000",
                        "longitude": "17.09444000"
                    },
                    {
                        "id": 104475,
                        "name": "Okres Malacky",
                        "latitude": "48.43458000",
                        "longitude": "17.02166000"
                    },
                    {
                        "id": 104485,
                        "name": "Okres Pezinok",
                        "latitude": "48.28785000",
                        "longitude": "17.26799000"
                    },
                    {
                        "id": 104497,
                        "name": "Okres Senec",
                        "latitude": "48.22187000",
                        "longitude": "17.40328000"
                    },
                    {
                        "id": 104524,
                        "name": "Pezinok",
                        "latitude": "48.28986000",
                        "longitude": "17.26664000"
                    },
                    {
                        "id": 104540,
                        "name": "Senec",
                        "latitude": "48.21951000",
                        "longitude": "17.40043000"
                    },
                    {
                        "id": 104555,
                        "name": "Stupava",
                        "latitude": "48.27474000",
                        "longitude": "17.03173000"
                    },
                    {
                        "id": 104560,
                        "name": "Svätý Jur",
                        "latitude": "48.25216000",
                        "longitude": "17.21539000"
                    },
                    {
                        "id": 104576,
                        "name": "Vinosady",
                        "latitude": "48.31142000",
                        "longitude": "17.29042000"
                    }
                ]
            },
            {
                "id": 4353,
                "name": "Košice",
                "iso2": "KI",
                "latitude": "48.63757370",
                "longitude": "21.08342250",
                "type": "region",
                "cities": [
                    {
                        "id": 104588,
                        "name": "Čierna nad Tisou",
                        "latitude": "48.41704000",
                        "longitude": "22.08865000"
                    },
                    {
                        "id": 104382,
                        "name": "Dobšiná",
                        "latitude": "48.82073000",
                        "longitude": "20.36988000"
                    },
                    {
                        "id": 104392,
                        "name": "Gelnica",
                        "latitude": "48.85584000",
                        "longitude": "20.93713000"
                    },
                    {
                        "id": 104404,
                        "name": "Kavečany",
                        "latitude": "48.77592000",
                        "longitude": "21.20587000"
                    },
                    {
                        "id": 104409,
                        "name": "Košice",
                        "latitude": "48.71395000",
                        "longitude": "21.25808000"
                    },
                    {
                        "id": 104410,
                        "name": "Košice I",
                        "latitude": "48.72914000",
                        "longitude": "21.25004000"
                    },
                    {
                        "id": 104411,
                        "name": "Košice II",
                        "latitude": "48.69753000",
                        "longitude": "21.22273000"
                    },
                    {
                        "id": 104412,
                        "name": "Košice III",
                        "latitude": "48.73242000",
                        "longitude": "21.29047000"
                    },
                    {
                        "id": 104413,
                        "name": "Košice IV",
                        "latitude": "48.68691000",
                        "longitude": "21.26570000"
                    },
                    {
                        "id": 104416,
                        "name": "Krompachy",
                        "latitude": "48.91447000",
                        "longitude": "20.87514000"
                    },
                    {
                        "id": 104431,
                        "name": "Medzev",
                        "latitude": "48.70041000",
                        "longitude": "20.89367000"
                    },
                    {
                        "id": 104433,
                        "name": "Michalovce",
                        "latitude": "48.75434000",
                        "longitude": "21.91950000"
                    },
                    {
                        "id": 104435,
                        "name": "Moldava nad Bodvou",
                        "latitude": "48.61428000",
                        "longitude": "20.99957000"
                    },
                    {
                        "id": 104462,
                        "name": "Okres Gelnica",
                        "latitude": "48.85207000",
                        "longitude": "20.93385000"
                    },
                    {
                        "id": 104468,
                        "name": "Okres Kosice-okolie",
                        "latitude": "48.77897000",
                        "longitude": "21.41373000"
                    },
                    {
                        "id": 104478,
                        "name": "Okres Michalovce",
                        "latitude": "48.75000000",
                        "longitude": "21.93333000"
                    },
                    {
                        "id": 104494,
                        "name": "Okres Rožňava",
                        "latitude": "48.66667000",
                        "longitude": "20.53333000"
                    },
                    {
                        "id": 104501,
                        "name": "Okres Sobrance",
                        "latitude": "48.74247000",
                        "longitude": "22.18197000"
                    },
                    {
                        "id": 104502,
                        "name": "Okres Spišská Nová Ves",
                        "latitude": "48.95000000",
                        "longitude": "20.56667000"
                    },
                    {
                        "id": 104507,
                        "name": "Okres Trebišov",
                        "latitude": "48.63333000",
                        "longitude": "21.71667000"
                    },
                    {
                        "id": 104537,
                        "name": "Rožňava",
                        "latitude": "48.66009000",
                        "longitude": "20.53758000"
                    },
                    {
                        "id": 104542,
                        "name": "Sečovce",
                        "latitude": "48.70074000",
                        "longitude": "21.66104000"
                    },
                    {
                        "id": 104547,
                        "name": "Sobrance",
                        "latitude": "48.74455000",
                        "longitude": "22.18136000"
                    },
                    {
                        "id": 104549,
                        "name": "Spišská Nová Ves",
                        "latitude": "48.94464000",
                        "longitude": "20.56153000"
                    },
                    {
                        "id": 104554,
                        "name": "Strážske",
                        "latitude": "48.87350000",
                        "longitude": "21.83668000"
                    },
                    {
                        "id": 104565,
                        "name": "Trebišov",
                        "latitude": "48.62858000",
                        "longitude": "21.71954000"
                    },
                    {
                        "id": 104575,
                        "name": "Vinné",
                        "latitude": "48.80965000",
                        "longitude": "21.96757000"
                    },
                    {
                        "id": 104599,
                        "name": "Žehra",
                        "latitude": "48.97960000",
                        "longitude": "20.79170000"
                    }
                ]
            },
            {
                "id": 4357,
                "name": "Nitra",
                "iso2": "NI",
                "latitude": "48.01437650",
                "longitude": "18.54165040",
                "type": "region",
                "cities": [
                    {
                        "id": 104400,
                        "name": "Hurbanovo",
                        "latitude": "47.86984000",
                        "longitude": "18.19233000"
                    },
                    {
                        "id": 104406,
                        "name": "Kolárovo",
                        "latitude": "47.92294000",
                        "longitude": "17.98467000"
                    },
                    {
                        "id": 104407,
                        "name": "Komárno",
                        "latitude": "47.76356000",
                        "longitude": "18.12263000"
                    },
                    {
                        "id": 104421,
                        "name": "Levice",
                        "latitude": "48.21563000",
                        "longitude": "18.60705000"
                    },
                    {
                        "id": 104438,
                        "name": "Nitra",
                        "latitude": "48.30763000",
                        "longitude": "18.08453000"
                    },
                    {
                        "id": 104445,
                        "name": "Nové Zámky",
                        "latitude": "47.98544000",
                        "longitude": "18.16195000"
                    },
                    {
                        "id": 104467,
                        "name": "Okres Komárno",
                        "latitude": "47.76667000",
                        "longitude": "18.13333000"
                    },
                    {
                        "id": 104471,
                        "name": "Okres Levice",
                        "latitude": "48.21667000",
                        "longitude": "18.60000000"
                    },
                    {
                        "id": 104481,
                        "name": "Okres Nitra",
                        "latitude": "48.31667000",
                        "longitude": "18.08333000"
                    },
                    {
                        "id": 104483,
                        "name": "Okres Nové Zámky",
                        "latitude": "47.98333000",
                        "longitude": "18.16667000"
                    },
                    {
                        "id": 104517,
                        "name": "Okres Šaľa",
                        "latitude": "48.14770000",
                        "longitude": "17.87306000"
                    },
                    {
                        "id": 104506,
                        "name": "Okres Topoľčany",
                        "latitude": "48.56667000",
                        "longitude": "18.18333000"
                    },
                    {
                        "id": 104514,
                        "name": "Okres Zlaté Moravce",
                        "latitude": "48.38294000",
                        "longitude": "18.39842000"
                    },
                    {
                        "id": 104591,
                        "name": "Šahy",
                        "latitude": "48.07408000",
                        "longitude": "18.94946000"
                    },
                    {
                        "id": 104593,
                        "name": "Šaľa",
                        "latitude": "48.15127000",
                        "longitude": "17.88062000"
                    },
                    {
                        "id": 104595,
                        "name": "Štúrovo",
                        "latitude": "47.79495000",
                        "longitude": "18.71750000"
                    },
                    {
                        "id": 104596,
                        "name": "Šurany",
                        "latitude": "48.08613000",
                        "longitude": "18.18447000"
                    },
                    {
                        "id": 104558,
                        "name": "Svodín",
                        "latitude": "47.91054000",
                        "longitude": "18.49967000"
                    },
                    {
                        "id": 104563,
                        "name": "Tlmače",
                        "latitude": "48.28926000",
                        "longitude": "18.53152000"
                    },
                    {
                        "id": 104564,
                        "name": "Topoľčany",
                        "latitude": "48.56361000",
                        "longitude": "18.16712000"
                    },
                    {
                        "id": 104580,
                        "name": "Vráble",
                        "latitude": "48.24371000",
                        "longitude": "18.30846000"
                    },
                    {
                        "id": 104600,
                        "name": "Želiezovce",
                        "latitude": "48.05075000",
                        "longitude": "18.65421000"
                    },
                    {
                        "id": 104584,
                        "name": "Zlaté Moravce",
                        "latitude": "48.38553000",
                        "longitude": "18.40063000"
                    }
                ]
            },
            {
                "id": 4354,
                "name": "Prešov",
                "iso2": "PV",
                "latitude": "49.17167730",
                "longitude": "21.37420010",
                "type": "region",
                "cities": [
                    {
                        "id": 104372,
                        "name": "Bardejov",
                        "latitude": "49.29175000",
                        "longitude": "21.27271000"
                    },
                    {
                        "id": 104380,
                        "name": "Chlmec",
                        "latitude": "48.88628000",
                        "longitude": "21.93930000"
                    },
                    {
                        "id": 104393,
                        "name": "Giraltovce",
                        "latitude": "49.11398000",
                        "longitude": "21.51731000"
                    },
                    {
                        "id": 104399,
                        "name": "Humenné",
                        "latitude": "48.93707000",
                        "longitude": "21.91625000"
                    },
                    {
                        "id": 104405,
                        "name": "Kežmarok",
                        "latitude": "49.13571000",
                        "longitude": "20.43352000"
                    },
                    {
                        "id": 104422,
                        "name": "Levoča",
                        "latitude": "49.02173000",
                        "longitude": "20.59212000"
                    },
                    {
                        "id": 104423,
                        "name": "Lipany",
                        "latitude": "49.15376000",
                        "longitude": "20.96382000"
                    },
                    {
                        "id": 104590,
                        "name": "Ľubica",
                        "latitude": "49.11667000",
                        "longitude": "20.45000000"
                    },
                    {
                        "id": 104432,
                        "name": "Medzilaborce",
                        "latitude": "49.27195000",
                        "longitude": "21.90073000"
                    },
                    {
                        "id": 104442,
                        "name": "Nová Lesná",
                        "latitude": "49.12253000",
                        "longitude": "20.26737000"
                    },
                    {
                        "id": 104449,
                        "name": "Okres Bardejov",
                        "latitude": "49.28333000",
                        "longitude": "21.28333000"
                    },
                    {
                        "id": 104464,
                        "name": "Okres Humenné",
                        "latitude": "48.93333000",
                        "longitude": "21.91667000"
                    },
                    {
                        "id": 104466,
                        "name": "Okres Kežmarok",
                        "latitude": "49.13593000",
                        "longitude": "20.42929000"
                    },
                    {
                        "id": 104472,
                        "name": "Okres Levoča",
                        "latitude": "49.01986000",
                        "longitude": "20.57688000"
                    },
                    {
                        "id": 104477,
                        "name": "Okres Medzilaborce",
                        "latitude": "49.27062000",
                        "longitude": "21.90200000"
                    },
                    {
                        "id": 104488,
                        "name": "Okres Poprad",
                        "latitude": "49.05000000",
                        "longitude": "20.30000000"
                    },
                    {
                        "id": 104490,
                        "name": "Okres Prešov",
                        "latitude": "49.00000000",
                        "longitude": "21.25000000"
                    },
                    {
                        "id": 104496,
                        "name": "Okres Sabinov",
                        "latitude": "49.10115000",
                        "longitude": "21.09844000"
                    },
                    {
                        "id": 104500,
                        "name": "Okres Snina",
                        "latitude": "48.98579000",
                        "longitude": "22.15059000"
                    },
                    {
                        "id": 104503,
                        "name": "Okres Stará Ĺubovňa",
                        "latitude": "49.30000000",
                        "longitude": "20.70000000"
                    },
                    {
                        "id": 104504,
                        "name": "Okres Stropkov",
                        "latitude": "49.20249000",
                        "longitude": "21.65025000"
                    },
                    {
                        "id": 104505,
                        "name": "Okres Svidník",
                        "latitude": "49.30000000",
                        "longitude": "21.56667000"
                    },
                    {
                        "id": 104513,
                        "name": "Okres Vranov nad Topľou",
                        "latitude": "48.90000000",
                        "longitude": "21.68333000"
                    },
                    {
                        "id": 104526,
                        "name": "Podolínec",
                        "latitude": "49.25869000",
                        "longitude": "20.53600000"
                    },
                    {
                        "id": 104528,
                        "name": "Poprad",
                        "latitude": "49.06144000",
                        "longitude": "20.29798000"
                    },
                    {
                        "id": 104530,
                        "name": "Prešov",
                        "latitude": "48.99839000",
                        "longitude": "21.23393000"
                    },
                    {
                        "id": 104539,
                        "name": "Sabinov",
                        "latitude": "49.10309000",
                        "longitude": "21.09880000"
                    },
                    {
                        "id": 104546,
                        "name": "Snina",
                        "latitude": "48.98857000",
                        "longitude": "22.15099000"
                    },
                    {
                        "id": 104548,
                        "name": "Spišská Belá",
                        "latitude": "49.18725000",
                        "longitude": "20.45948000"
                    },
                    {
                        "id": 104550,
                        "name": "Spišské Podhradie",
                        "latitude": "49.00088000",
                        "longitude": "20.75307000"
                    },
                    {
                        "id": 104552,
                        "name": "Stará Ľubovňa",
                        "latitude": "49.29859000",
                        "longitude": "20.68620000"
                    },
                    {
                        "id": 104594,
                        "name": "Štrba",
                        "latitude": "49.05913000",
                        "longitude": "20.07975000"
                    },
                    {
                        "id": 104553,
                        "name": "Stropkov",
                        "latitude": "49.20211000",
                        "longitude": "21.65216000"
                    },
                    {
                        "id": 104556,
                        "name": "Svidník",
                        "latitude": "49.30819000",
                        "longitude": "21.57030000"
                    },
                    {
                        "id": 104557,
                        "name": "Svit",
                        "latitude": "49.06014000",
                        "longitude": "20.20695000"
                    },
                    {
                        "id": 104577,
                        "name": "Vranov nad Topľou",
                        "latitude": "48.88836000",
                        "longitude": "21.68479000"
                    },
                    {
                        "id": 104578,
                        "name": "Vrbov",
                        "latitude": "49.08764000",
                        "longitude": "20.42530000"
                    },
                    {
                        "id": 104583,
                        "name": "Vyšné Ružbachy",
                        "latitude": "49.30387000",
                        "longitude": "20.56558000"
                    },
                    {
                        "id": 104582,
                        "name": "Vysoké Tatry",
                        "latitude": "49.13637000",
                        "longitude": "20.24386000"
                    },
                    {
                        "id": 104598,
                        "name": "Ždiar",
                        "latitude": "49.27100000",
                        "longitude": "20.26239000"
                    }
                ]
            },
            {
                "id": 4358,
                "name": "Trenčín",
                "iso2": "TC",
                "latitude": "48.80867580",
                "longitude": "18.23240260",
                "type": "region",
                "cities": [
                    {
                        "id": 104379,
                        "name": "Bánovce nad Bebravou",
                        "latitude": "48.72130000",
                        "longitude": "18.25754000"
                    },
                    {
                        "id": 104373,
                        "name": "Bojnice",
                        "latitude": "48.78511000",
                        "longitude": "18.58640000"
                    },
                    {
                        "id": 104377,
                        "name": "Brezová pod Bradlom",
                        "latitude": "48.66349000",
                        "longitude": "17.53905000"
                    },
                    {
                        "id": 104586,
                        "name": "Čachtice",
                        "latitude": "48.71226000",
                        "longitude": "17.78704000"
                    },
                    {
                        "id": 104384,
                        "name": "Dubnica nad Váhom",
                        "latitude": "48.95981000",
                        "longitude": "18.16634000"
                    },
                    {
                        "id": 104394,
                        "name": "Handlová",
                        "latitude": "48.72760000",
                        "longitude": "18.76012000"
                    },
                    {
                        "id": 104402,
                        "name": "Ilava",
                        "latitude": "48.99769000",
                        "longitude": "18.23530000"
                    },
                    {
                        "id": 104419,
                        "name": "Lehota pod Vtáčnikom",
                        "latitude": "48.69138000",
                        "longitude": "18.59944000"
                    },
                    {
                        "id": 104436,
                        "name": "Myjava",
                        "latitude": "48.75876000",
                        "longitude": "17.56866000"
                    },
                    {
                        "id": 104437,
                        "name": "Nemšová",
                        "latitude": "48.96702000",
                        "longitude": "18.11892000"
                    },
                    {
                        "id": 104441,
                        "name": "Nová Dubnica",
                        "latitude": "48.93479000",
                        "longitude": "18.14632000"
                    },
                    {
                        "id": 104443,
                        "name": "Nováky",
                        "latitude": "48.71106000",
                        "longitude": "18.53389000"
                    },
                    {
                        "id": 104444,
                        "name": "Nové Mesto nad Váhom",
                        "latitude": "48.75763000",
                        "longitude": "17.83090000"
                    },
                    {
                        "id": 104457,
                        "name": "Okres Bánovce nad Bebravou",
                        "latitude": "48.71908000",
                        "longitude": "18.25773000"
                    },
                    {
                        "id": 104465,
                        "name": "Okres Ilava",
                        "latitude": "48.99641000",
                        "longitude": "18.23374000"
                    },
                    {
                        "id": 104479,
                        "name": "Okres Myjava",
                        "latitude": "48.75000000",
                        "longitude": "17.58333000"
                    },
                    {
                        "id": 104482,
                        "name": "Okres Nové Mesto nad Váhom",
                        "latitude": "48.75466000",
                        "longitude": "17.83506000"
                    },
                    {
                        "id": 104484,
                        "name": "Okres Partizánske",
                        "latitude": "48.62613000",
                        "longitude": "18.37957000"
                    },
                    {
                        "id": 104489,
                        "name": "Okres Považská Bystrica",
                        "latitude": "49.11667000",
                        "longitude": "18.45000000"
                    },
                    {
                        "id": 104491,
                        "name": "Okres Prievidza",
                        "latitude": "48.76667000",
                        "longitude": "18.63333000"
                    },
                    {
                        "id": 104492,
                        "name": "Okres Púchov",
                        "latitude": "49.12406000",
                        "longitude": "18.32477000"
                    },
                    {
                        "id": 104508,
                        "name": "Okres Trenčín",
                        "latitude": "48.89520000",
                        "longitude": "18.04264000"
                    },
                    {
                        "id": 104523,
                        "name": "Partizánske",
                        "latitude": "48.62861000",
                        "longitude": "18.38455000"
                    },
                    {
                        "id": 104529,
                        "name": "Považská Bystrica",
                        "latitude": "49.12153000",
                        "longitude": "18.42169000"
                    },
                    {
                        "id": 104532,
                        "name": "Prievidza",
                        "latitude": "48.77446000",
                        "longitude": "18.62750000"
                    },
                    {
                        "id": 104533,
                        "name": "Púchov",
                        "latitude": "49.12494000",
                        "longitude": "18.32597000"
                    },
                    {
                        "id": 104551,
                        "name": "Stará Turá",
                        "latitude": "48.77721000",
                        "longitude": "17.69433000"
                    },
                    {
                        "id": 104566,
                        "name": "Trenčianske Teplice",
                        "latitude": "48.91063000",
                        "longitude": "18.16691000"
                    },
                    {
                        "id": 104567,
                        "name": "Trenčín",
                        "latitude": "48.89452000",
                        "longitude": "18.04436000"
                    }
                ]
            },
            {
                "id": 4355,
                "name": "Trnava",
                "iso2": "TA",
                "latitude": "48.39438980",
                "longitude": "17.72162050",
                "type": "region",
                "cities": [
                    {
                        "id": 104387,
                        "name": "Dunajská Streda",
                        "latitude": "47.99268000",
                        "longitude": "17.61211000"
                    },
                    {
                        "id": 104389,
                        "name": "Gabčíkovo",
                        "latitude": "47.89211000",
                        "longitude": "17.57884000"
                    },
                    {
                        "id": 104390,
                        "name": "Galanta",
                        "latitude": "48.19001000",
                        "longitude": "17.72747000"
                    },
                    {
                        "id": 104391,
                        "name": "Gbely",
                        "latitude": "48.71800000",
                        "longitude": "17.11628000"
                    },
                    {
                        "id": 104395,
                        "name": "Hlohovec",
                        "latitude": "48.43174000",
                        "longitude": "17.80310000"
                    },
                    {
                        "id": 104396,
                        "name": "Holíč",
                        "latitude": "48.81105000",
                        "longitude": "17.16238000"
                    },
                    {
                        "id": 104420,
                        "name": "Leopoldov",
                        "latitude": "48.44575000",
                        "longitude": "17.76458000"
                    },
                    {
                        "id": 104460,
                        "name": "Okres Dunajská Streda",
                        "latitude": "47.99635000",
                        "longitude": "17.60937000"
                    },
                    {
                        "id": 104461,
                        "name": "Okres Galanta",
                        "latitude": "48.20000000",
                        "longitude": "17.71667000"
                    },
                    {
                        "id": 104463,
                        "name": "Okres Hlohovec",
                        "latitude": "48.41667000",
                        "longitude": "17.75000000"
                    },
                    {
                        "id": 104486,
                        "name": "Okres Piešťany",
                        "latitude": "48.59064000",
                        "longitude": "17.82679000"
                    },
                    {
                        "id": 104498,
                        "name": "Okres Senica",
                        "latitude": "48.68333000",
                        "longitude": "17.36667000"
                    },
                    {
                        "id": 104499,
                        "name": "Okres Skalica",
                        "latitude": "48.75000000",
                        "longitude": "17.16667000"
                    },
                    {
                        "id": 104509,
                        "name": "Okres Trnava",
                        "latitude": "48.36667000",
                        "longitude": "17.60000000"
                    },
                    {
                        "id": 104525,
                        "name": "Piešťany",
                        "latitude": "48.59479000",
                        "longitude": "17.82591000"
                    },
                    {
                        "id": 104592,
                        "name": "Šamorín",
                        "latitude": "48.03015000",
                        "longitude": "17.30972000"
                    },
                    {
                        "id": 104541,
                        "name": "Senica",
                        "latitude": "48.67922000",
                        "longitude": "17.36697000"
                    },
                    {
                        "id": 104543,
                        "name": "Skalica",
                        "latitude": "48.84490000",
                        "longitude": "17.22635000"
                    },
                    {
                        "id": 104544,
                        "name": "Sládkovičovo",
                        "latitude": "48.20137000",
                        "longitude": "17.63852000"
                    },
                    {
                        "id": 104545,
                        "name": "Smolenice",
                        "latitude": "48.50478000",
                        "longitude": "17.43067000"
                    },
                    {
                        "id": 104568,
                        "name": "Trnava",
                        "latitude": "48.37741000",
                        "longitude": "17.58723000"
                    },
                    {
                        "id": 104574,
                        "name": "Veľký Meder",
                        "latitude": "47.85798000",
                        "longitude": "17.76884000"
                    },
                    {
                        "id": 104579,
                        "name": "Vrbové",
                        "latitude": "48.61973000",
                        "longitude": "17.72260000"
                    }
                ]
            },
            {
                "id": 4359,
                "name": "Žilina",
                "iso2": "ZI",
                "latitude": "49.20314350",
                "longitude": "19.36457330",
                "type": "region",
                "cities": [
                    {
                        "id": 104378,
                        "name": "Bytča",
                        "latitude": "49.22404000",
                        "longitude": "18.55878000"
                    },
                    {
                        "id": 104587,
                        "name": "Čadca",
                        "latitude": "49.43503000",
                        "longitude": "18.78895000"
                    },
                    {
                        "id": 104383,
                        "name": "Dolný Kubín",
                        "latitude": "49.20983000",
                        "longitude": "19.30341000"
                    },
                    {
                        "id": 104401,
                        "name": "Hybe",
                        "latitude": "49.04439000",
                        "longitude": "19.82895000"
                    },
                    {
                        "id": 104414,
                        "name": "Krasňany",
                        "latitude": "49.21491000",
                        "longitude": "18.88718000"
                    },
                    {
                        "id": 104418,
                        "name": "Kysucké Nové Mesto",
                        "latitude": "49.30000000",
                        "longitude": "18.78333000"
                    },
                    {
                        "id": 104424,
                        "name": "Liptovský Hrádok",
                        "latitude": "49.03962000",
                        "longitude": "19.72335000"
                    },
                    {
                        "id": 104425,
                        "name": "Liptovský Mikuláš",
                        "latitude": "49.08061000",
                        "longitude": "19.62218000"
                    },
                    {
                        "id": 104427,
                        "name": "Lúčky",
                        "latitude": "49.12944000",
                        "longitude": "19.40228000"
                    },
                    {
                        "id": 104430,
                        "name": "Martin",
                        "latitude": "49.06651000",
                        "longitude": "18.92399000"
                    },
                    {
                        "id": 104446,
                        "name": "Námestovo",
                        "latitude": "49.40790000",
                        "longitude": "19.48032000"
                    },
                    {
                        "id": 104439,
                        "name": "Nižná",
                        "latitude": "49.31046000",
                        "longitude": "19.52428000"
                    },
                    {
                        "id": 104456,
                        "name": "Okres Bytča",
                        "latitude": "49.22267000",
                        "longitude": "18.55844000"
                    },
                    {
                        "id": 104516,
                        "name": "Okres Čadca",
                        "latitude": "49.43333000",
                        "longitude": "18.78333000"
                    },
                    {
                        "id": 104459,
                        "name": "Okres Dolný Kubín",
                        "latitude": "49.20000000",
                        "longitude": "19.30000000"
                    },
                    {
                        "id": 104470,
                        "name": "Okres Kysucké Nové Mesto",
                        "latitude": "49.30206000",
                        "longitude": "18.78603000"
                    },
                    {
                        "id": 104473,
                        "name": "Okres Liptovský Mikuláš",
                        "latitude": "49.08333000",
                        "longitude": "19.61667000"
                    },
                    {
                        "id": 104476,
                        "name": "Okres Martin",
                        "latitude": "49.06667000",
                        "longitude": "18.93333000"
                    },
                    {
                        "id": 104480,
                        "name": "Okres Namestovo",
                        "latitude": "49.40651000",
                        "longitude": "19.47670000"
                    },
                    {
                        "id": 104495,
                        "name": "Okres Ružomberok",
                        "latitude": "49.07494000",
                        "longitude": "19.30083000"
                    },
                    {
                        "id": 104510,
                        "name": "Okres Turčianske Teplice",
                        "latitude": "48.86283000",
                        "longitude": "18.85759000"
                    },
                    {
                        "id": 104511,
                        "name": "Okres Tvrdošín",
                        "latitude": "49.33421000",
                        "longitude": "19.55461000"
                    },
                    {
                        "id": 104520,
                        "name": "Okres Žilina",
                        "latitude": "49.22303000",
                        "longitude": "18.74044000"
                    },
                    {
                        "id": 104521,
                        "name": "Oravská Lesná",
                        "latitude": "49.36672000",
                        "longitude": "19.18093000"
                    },
                    {
                        "id": 104522,
                        "name": "Oravský Podzámok",
                        "latitude": "49.25939000",
                        "longitude": "19.35690000"
                    },
                    {
                        "id": 104531,
                        "name": "Pribylina",
                        "latitude": "49.09950000",
                        "longitude": "19.79427000"
                    },
                    {
                        "id": 104534,
                        "name": "Rajec",
                        "latitude": "49.08899000",
                        "longitude": "18.64007000"
                    },
                    {
                        "id": 104538,
                        "name": "Ružomberok",
                        "latitude": "49.07480000",
                        "longitude": "19.30751000"
                    },
                    {
                        "id": 104561,
                        "name": "Terchová",
                        "latitude": "49.25895000",
                        "longitude": "19.02935000"
                    },
                    {
                        "id": 104569,
                        "name": "Trstená",
                        "latitude": "49.36101000",
                        "longitude": "19.61249000"
                    },
                    {
                        "id": 104571,
                        "name": "Turčianske Teplice",
                        "latitude": "48.86225000",
                        "longitude": "18.86048000"
                    },
                    {
                        "id": 104570,
                        "name": "Turzovka",
                        "latitude": "49.40429000",
                        "longitude": "18.62258000"
                    },
                    {
                        "id": 104572,
                        "name": "Tvrdošín",
                        "latitude": "49.33700000",
                        "longitude": "19.55600000"
                    },
                    {
                        "id": 104581,
                        "name": "Vrútky",
                        "latitude": "49.11328000",
                        "longitude": "18.91714000"
                    },
                    {
                        "id": 104602,
                        "name": "Žilina",
                        "latitude": "49.22315000",
                        "longitude": "18.73941000"
                    }
                ]
            }
        ]
    },
    {
        "id": 201,
        "name": "Slovenia",
        "iso3": "SVN",
        "iso2": "SI",
        "numeric_code": "705",
        "phonecode": "386",
        "capital": "Ljubljana",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".si",
        "native": "Slovenija",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Slovenian, Slovene",
        "timezones": [
            {
                "zoneName": "Europe\/Ljubljana",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Slovenia",
            "ko": "슬로베니아",
            "pt-BR": "Eslovênia",
            "pt": "Eslovénia",
            "nl": "Slovenië",
            "hr": "Slovenija",
            "fa": "اسلوونی",
            "de": "Slowenien",
            "es": "Eslovenia",
            "fr": "Slovénie",
            "ja": "スロベニア",
            "it": "Slovenia",
            "zh-CN": "斯洛文尼亚",
            "tr": "Slovenya",
            "ru": "Словения",
            "uk": "Словенія",
            "pl": "Słowenia"
        },
        "latitude": "46.11666666",
        "longitude": "14.81666666",
        "emoji": "🇸🇮",
        "emojiU": "U+1F1F8 U+1F1EE",
        "states": [
            {
                "id": 4183,
                "name": "Ajdovščina",
                "iso2": "001",
                "latitude": "45.88707760",
                "longitude": "13.90428180",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104059,
                        "name": "Ajdovščina",
                        "latitude": "45.88601000",
                        "longitude": "13.90946000"
                    },
                    {
                        "id": 104084,
                        "name": "Cirkulane",
                        "latitude": "46.34408000",
                        "longitude": "15.99472000"
                    },
                    {
                        "id": 104174,
                        "name": "Lokavec",
                        "latitude": "45.90167000",
                        "longitude": "13.87972000"
                    }
                ]
            },
            {
                "id": 4326,
                "name": "Ankaran",
                "iso2": "213",
                "latitude": "45.57845100",
                "longitude": "13.73691740",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104060,
                        "name": "Ankaran",
                        "latitude": "45.57861000",
                        "longitude": "13.73611000"
                    }
                ]
            },
            {
                "id": 4318,
                "name": "Apače",
                "iso2": "195",
                "latitude": "46.69746790",
                "longitude": "15.91025340",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104061,
                        "name": "Apače",
                        "latitude": "46.69722000",
                        "longitude": "15.91056000"
                    }
                ]
            },
            {
                "id": 4301,
                "name": "Beltinci",
                "iso2": "002",
                "latitude": "46.60791530",
                "longitude": "16.23651270",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104063,
                        "name": "Beltinci",
                        "latitude": "46.60528000",
                        "longitude": "16.24056000"
                    },
                    {
                        "id": 104104,
                        "name": "Gančani",
                        "latitude": "46.63250000",
                        "longitude": "16.25111000"
                    },
                    {
                        "id": 104166,
                        "name": "Lipovci",
                        "latitude": "46.62833000",
                        "longitude": "16.22806000"
                    },
                    {
                        "id": 104331,
                        "name": "Zgornje Gorje",
                        "latitude": "46.37962000",
                        "longitude": "14.06937000"
                    }
                ]
            },
            {
                "id": 4166,
                "name": "Benedikt",
                "iso2": "148",
                "latitude": "46.61558410",
                "longitude": "15.89572810",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104064,
                        "name": "Benedikt",
                        "latitude": "46.60861000",
                        "longitude": "15.88833000"
                    }
                ]
            },
            {
                "id": 4179,
                "name": "Bistrica ob Sotli",
                "iso2": "149",
                "latitude": "46.05655790",
                "longitude": "15.66259470",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104067,
                        "name": "Bistrica ob Sotli",
                        "latitude": "46.05889000",
                        "longitude": "15.66417000"
                    }
                ]
            },
            {
                "id": 4202,
                "name": "Bled",
                "iso2": "003",
                "latitude": "46.36832660",
                "longitude": "14.11457980",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104069,
                        "name": "Bled",
                        "latitude": "46.36917000",
                        "longitude": "14.11361000"
                    },
                    {
                        "id": 104144,
                        "name": "Kostanjevica na Krki",
                        "latitude": "45.84611000",
                        "longitude": "15.42222000"
                    },
                    {
                        "id": 104326,
                        "name": "Zasip",
                        "latitude": "46.39284000",
                        "longitude": "14.10869000"
                    }
                ]
            },
            {
                "id": 4278,
                "name": "Bloke",
                "iso2": "150",
                "latitude": "45.77281410",
                "longitude": "14.50634590",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104207,
                        "name": "Nova Vas",
                        "latitude": "45.77167000",
                        "longitude": "14.50583000"
                    }
                ]
            },
            {
                "id": 4282,
                "name": "Bohinj",
                "iso2": "004",
                "latitude": "46.30056520",
                "longitude": "13.94271950",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104070,
                        "name": "Bohinjska Bistrica",
                        "latitude": "46.27216000",
                        "longitude": "13.95350000"
                    },
                    {
                        "id": 104100,
                        "name": "Dragomer",
                        "latitude": "46.01667000",
                        "longitude": "14.38333000"
                    },
                    {
                        "id": 104172,
                        "name": "Log pri Brezovici",
                        "latitude": "46.01667000",
                        "longitude": "14.36667000"
                    }
                ]
            },
            {
                "id": 4200,
                "name": "Borovnica",
                "iso2": "005",
                "latitude": "45.90445250",
                "longitude": "14.38241890",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104071,
                        "name": "Borovnica",
                        "latitude": "45.91583000",
                        "longitude": "14.36306000"
                    },
                    {
                        "id": 104180,
                        "name": "Makole",
                        "latitude": "46.31722000",
                        "longitude": "15.66722000"
                    }
                ]
            },
            {
                "id": 4181,
                "name": "Bovec",
                "iso2": "006",
                "latitude": "46.33804950",
                "longitude": "13.55241740",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104072,
                        "name": "Bovec",
                        "latitude": "46.33808000",
                        "longitude": "13.55245000"
                    },
                    {
                        "id": 104190,
                        "name": "Mirna",
                        "latitude": "45.95528000",
                        "longitude": "15.06194000"
                    }
                ]
            },
            {
                "id": 4141,
                "name": "Braslovče",
                "iso2": "151",
                "latitude": "46.28361920",
                "longitude": "15.04183200",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104073,
                        "name": "Braslovče",
                        "latitude": "46.28972000",
                        "longitude": "15.03889000"
                    }
                ]
            },
            {
                "id": 4240,
                "name": "Brda",
                "iso2": "007",
                "latitude": "45.99756520",
                "longitude": "13.52704740",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104094,
                        "name": "Dobrovo",
                        "latitude": "45.99639000",
                        "longitude": "13.52639000"
                    },
                    {
                        "id": 104195,
                        "name": "Mokronog",
                        "latitude": "45.93417000",
                        "longitude": "15.14083000"
                    }
                ]
            },
            {
                "id": 4215,
                "name": "Brežice",
                "iso2": "009",
                "latitude": "45.90410960",
                "longitude": "15.59436390",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104076,
                        "name": "Brežice",
                        "latitude": "45.90333000",
                        "longitude": "15.59111000"
                    },
                    {
                        "id": 104227,
                        "name": "Poljčane",
                        "latitude": "46.31194000",
                        "longitude": "15.57917000"
                    }
                ]
            },
            {
                "id": 4165,
                "name": "Brezovica",
                "iso2": "008",
                "latitude": "45.95593510",
                "longitude": "14.43499520",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104075,
                        "name": "Brezovica pri Ljubljani",
                        "latitude": "46.03333000",
                        "longitude": "14.40000000"
                    },
                    {
                        "id": 104205,
                        "name": "Notranje Gorice",
                        "latitude": "45.98750000",
                        "longitude": "14.39889000"
                    },
                    {
                        "id": 104214,
                        "name": "Opština Ljubljana-Vič-Rudnik",
                        "latitude": "46.03333000",
                        "longitude": "14.41667000"
                    },
                    {
                        "id": 104254,
                        "name": "Rečica ob Savinji",
                        "latitude": "46.31667000",
                        "longitude": "14.91667000"
                    },
                    {
                        "id": 104316,
                        "name": "Vnanje Gorice",
                        "latitude": "46.00722000",
                        "longitude": "14.42194000"
                    }
                ]
            },
            {
                "id": 4147,
                "name": "Cankova",
                "iso2": "152",
                "latitude": "46.71823700",
                "longitude": "16.01972220",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104078,
                        "name": "Cankova",
                        "latitude": "46.72083000",
                        "longitude": "16.02250000"
                    }
                ]
            },
            {
                "id": 4191,
                "name": "Celje",
                "iso2": "011",
                "latitude": "46.23974950",
                "longitude": "15.26770630",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104079,
                        "name": "Celje",
                        "latitude": "46.23092000",
                        "longitude": "15.26044000"
                    },
                    {
                        "id": 104168,
                        "name": "Ljubečna",
                        "latitude": "46.25567000",
                        "longitude": "15.32430000"
                    },
                    {
                        "id": 104299,
                        "name": "Trnovlje pri Celju",
                        "latitude": "46.25667000",
                        "longitude": "15.29528000"
                    }
                ]
            },
            {
                "id": 4310,
                "name": "Cerklje na Gorenjskem",
                "iso2": "012",
                "latitude": "46.25170540",
                "longitude": "14.48579790",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104080,
                        "name": "Cerklje na Gorenjskem",
                        "latitude": "46.25417000",
                        "longitude": "14.48861000"
                    }
                ]
            },
            {
                "id": 4162,
                "name": "Cerknica",
                "iso2": "013",
                "latitude": "45.79662550",
                "longitude": "14.39217700",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104081,
                        "name": "Cerknica",
                        "latitude": "45.79306000",
                        "longitude": "14.36250000"
                    },
                    {
                        "id": 104246,
                        "name": "Rakek",
                        "latitude": "45.81333000",
                        "longitude": "14.31111000"
                    }
                ]
            },
            {
                "id": 4178,
                "name": "Cerkno",
                "iso2": "014",
                "latitude": "46.12884140",
                "longitude": "13.98940270",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104082,
                        "name": "Cerkno",
                        "latitude": "46.12556000",
                        "longitude": "13.98167000"
                    }
                ]
            },
            {
                "id": 4176,
                "name": "Cerkvenjak",
                "iso2": "153",
                "latitude": "46.56707110",
                "longitude": "15.94297530",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104083,
                        "name": "Cerkvenjak",
                        "latitude": "46.57056000",
                        "longitude": "15.94361000"
                    }
                ]
            },
            {
                "id": 4309,
                "name": "Cirkulane",
                "iso2": "196",
                "latitude": "46.32983220",
                "longitude": "15.99806660",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4151,
                "name": "Črenšovci",
                "iso2": "015",
                "latitude": "46.57200290",
                "longitude": "16.28773460",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104337,
                        "name": "Črenšovci",
                        "latitude": "46.55794000",
                        "longitude": "16.30410000"
                    }
                ]
            },
            {
                "id": 4232,
                "name": "Črna na Koroškem",
                "iso2": "016",
                "latitude": "46.47045290",
                "longitude": "14.84999980",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104338,
                        "name": "Črna na Koroškem",
                        "latitude": "46.47045000",
                        "longitude": "14.85009000"
                    }
                ]
            },
            {
                "id": 4291,
                "name": "Črnomelj",
                "iso2": "017",
                "latitude": "45.53612250",
                "longitude": "15.19441430",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104339,
                        "name": "Črnomelj",
                        "latitude": "45.57111000",
                        "longitude": "15.18889000"
                    }
                ]
            },
            {
                "id": 4304,
                "name": "Destrnik",
                "iso2": "018",
                "latitude": "46.49223680",
                "longitude": "15.87779560",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104087,
                        "name": "Destrnik",
                        "latitude": "46.49254000",
                        "longitude": "15.87893000"
                    }
                ]
            },
            {
                "id": 4167,
                "name": "Divača",
                "iso2": "019",
                "latitude": "45.68060690",
                "longitude": "13.97203120",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104088,
                        "name": "Divača",
                        "latitude": "45.68472000",
                        "longitude": "13.97028000"
                    }
                ]
            },
            {
                "id": 4295,
                "name": "Dobje",
                "iso2": "154",
                "latitude": "46.13700370",
                "longitude": "15.39412900",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104090,
                        "name": "Dobje pri Planini",
                        "latitude": "46.13747000",
                        "longitude": "15.39412000"
                    }
                ]
            },
            {
                "id": 4216,
                "name": "Dobrepolje",
                "iso2": "020",
                "latitude": "45.85249510",
                "longitude": "14.70831090",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104309,
                        "name": "Videm",
                        "latitude": "45.85000000",
                        "longitude": "14.69417000"
                    }
                ]
            },
            {
                "id": 4252,
                "name": "Dobrna",
                "iso2": "155",
                "latitude": "46.33561410",
                "longitude": "15.22597320",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104091,
                        "name": "Dobrna",
                        "latitude": "46.33750000",
                        "longitude": "15.22639000"
                    }
                ]
            },
            {
                "id": 4308,
                "name": "Dobrova–Polhov Gradec",
                "iso2": "021",
                "latitude": "46.06488960",
                "longitude": "14.31681950",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104092,
                        "name": "Dobrova",
                        "latitude": "46.04580000",
                        "longitude": "14.39186000"
                    }
                ]
            },
            {
                "id": 4189,
                "name": "Dobrovnik",
                "iso2": "156",
                "latitude": "46.65386620",
                "longitude": "16.35065940",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104093,
                        "name": "Dobrovnik",
                        "latitude": "46.65139000",
                        "longitude": "16.35250000"
                    }
                ]
            },
            {
                "id": 4173,
                "name": "Dol pri Ljubljani",
                "iso2": "022",
                "latitude": "46.08843860",
                "longitude": "14.64247920",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104096,
                        "name": "Dol pri Ljubljani",
                        "latitude": "46.08861000",
                        "longitude": "14.60083000"
                    }
                ]
            },
            {
                "id": 4281,
                "name": "Dolenjske Toplice",
                "iso2": "157",
                "latitude": "45.73457110",
                "longitude": "15.01294930",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104097,
                        "name": "Dolenjske Toplice",
                        "latitude": "45.75657000",
                        "longitude": "15.05917000"
                    }
                ]
            },
            {
                "id": 4159,
                "name": "Domžale",
                "iso2": "023",
                "latitude": "46.14382690",
                "longitude": "14.63752790",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104089,
                        "name": "Dob",
                        "latitude": "46.15194000",
                        "longitude": "14.62861000"
                    },
                    {
                        "id": 104098,
                        "name": "Domžale",
                        "latitude": "46.13774000",
                        "longitude": "14.59371000"
                    },
                    {
                        "id": 104244,
                        "name": "Radomlje",
                        "latitude": "46.17361000",
                        "longitude": "14.61222000"
                    },
                    {
                        "id": 104312,
                        "name": "Vir",
                        "latitude": "46.15325000",
                        "longitude": "14.60741000"
                    }
                ]
            },
            {
                "id": 4290,
                "name": "Dornava",
                "iso2": "024",
                "latitude": "46.44435130",
                "longitude": "15.98891590",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104099,
                        "name": "Dornava",
                        "latitude": "46.43667000",
                        "longitude": "15.95361000"
                    }
                ]
            },
            {
                "id": 4345,
                "name": "Dravograd",
                "iso2": "025",
                "latitude": "46.58921900",
                "longitude": "15.02460210",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104102,
                        "name": "Dravograd",
                        "latitude": "46.58806000",
                        "longitude": "15.01917000"
                    }
                ]
            },
            {
                "id": 4213,
                "name": "Duplek",
                "iso2": "026",
                "latitude": "46.50100160",
                "longitude": "15.75463070",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104283,
                        "name": "Spodnji Duplek",
                        "latitude": "46.50306000",
                        "longitude": "15.74528000"
                    },
                    {
                        "id": 104334,
                        "name": "Zgornji Duplek",
                        "latitude": "46.51361000",
                        "longitude": "15.72083000"
                    }
                ]
            },
            {
                "id": 4293,
                "name": "Gorenja Vas–Poljane",
                "iso2": "027",
                "latitude": "46.11165820",
                "longitude": "14.11493480",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104106,
                        "name": "Gorenja Vas",
                        "latitude": "46.10722000",
                        "longitude": "14.14806000"
                    }
                ]
            },
            {
                "id": 4210,
                "name": "Gorišnica",
                "iso2": "028",
                "latitude": "46.41202710",
                "longitude": "16.01330890",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104107,
                        "name": "Gorišnica",
                        "latitude": "46.41472000",
                        "longitude": "16.01389000"
                    }
                ]
            },
            {
                "id": 4284,
                "name": "Gorje",
                "iso2": "207",
                "latitude": "46.38024580",
                "longitude": "14.06853390",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4343,
                "name": "Gornja Radgona",
                "iso2": "029",
                "latitude": "46.67670990",
                "longitude": "15.99108470",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104108,
                        "name": "Gornja Radgona",
                        "latitude": "46.67333000",
                        "longitude": "15.99222000"
                    }
                ]
            },
            {
                "id": 4339,
                "name": "Gornji Grad",
                "iso2": "030",
                "latitude": "46.29617120",
                "longitude": "14.80623470",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104109,
                        "name": "Gornji Grad",
                        "latitude": "46.29528000",
                        "longitude": "14.80833000"
                    }
                ]
            },
            {
                "id": 4271,
                "name": "Gornji Petrovci",
                "iso2": "031",
                "latitude": "46.80371280",
                "longitude": "16.21913790",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104110,
                        "name": "Gornji Petrovci",
                        "latitude": "46.80528000",
                        "longitude": "16.22250000"
                    }
                ]
            },
            {
                "id": 4217,
                "name": "Grad",
                "iso2": "158",
                "latitude": "46.80873200",
                "longitude": "16.10920600",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104112,
                        "name": "Grad",
                        "latitude": "46.80000000",
                        "longitude": "16.10000000"
                    }
                ]
            },
            {
                "id": 4336,
                "name": "Grosuplje",
                "iso2": "032",
                "latitude": "45.95576450",
                "longitude": "14.65889900",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104113,
                        "name": "Grosuplje",
                        "latitude": "45.95556000",
                        "longitude": "14.65889000"
                    },
                    {
                        "id": 104357,
                        "name": "Šmarje-Sap",
                        "latitude": "45.97618000",
                        "longitude": "14.61177000"
                    }
                ]
            },
            {
                "id": 4145,
                "name": "Hajdina",
                "iso2": "159",
                "latitude": "46.41850140",
                "longitude": "15.82447220",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104279,
                        "name": "Spodnja Hajdina",
                        "latitude": "46.40889000",
                        "longitude": "15.84694000"
                    }
                ]
            },
            {
                "id": 4175,
                "name": "Hoče–Slivnica",
                "iso2": "160",
                "latitude": "46.47785800",
                "longitude": "15.64760050",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104116,
                        "name": "Hotinja Vas",
                        "latitude": "46.46667000",
                        "longitude": "15.66667000"
                    },
                    {
                        "id": 104242,
                        "name": "Radizel",
                        "latitude": "46.47444000",
                        "longitude": "15.65583000"
                    },
                    {
                        "id": 104260,
                        "name": "Rogoza",
                        "latitude": "46.50000000",
                        "longitude": "15.68333000"
                    },
                    {
                        "id": 104281,
                        "name": "Spodnje Hoče",
                        "latitude": "46.50000000",
                        "longitude": "15.65000000"
                    }
                ]
            },
            {
                "id": 4327,
                "name": "Hodoš",
                "iso2": "161",
                "latitude": "46.83141340",
                "longitude": "16.32106800",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104114,
                        "name": "Hodoš",
                        "latitude": "46.82333000",
                        "longitude": "16.33417000"
                    }
                ]
            },
            {
                "id": 4193,
                "name": "Horjul",
                "iso2": "162",
                "latitude": "46.02253780",
                "longitude": "14.29862690",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104115,
                        "name": "Horjul",
                        "latitude": "46.02361000",
                        "longitude": "14.29917000"
                    }
                ]
            },
            {
                "id": 4341,
                "name": "Hrastnik",
                "iso2": "034",
                "latitude": "46.14172880",
                "longitude": "15.08448940",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104095,
                        "name": "Dol pri Hrastniku",
                        "latitude": "46.14194000",
                        "longitude": "15.11278000"
                    },
                    {
                        "id": 104118,
                        "name": "Hrastnik",
                        "latitude": "46.14611000",
                        "longitude": "15.08139000"
                    }
                ]
            },
            {
                "id": 4321,
                "name": "Hrpelje–Kozina",
                "iso2": "035",
                "latitude": "45.60911920",
                "longitude": "13.93791480",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104147,
                        "name": "Kozina",
                        "latitude": "45.61000000",
                        "longitude": "13.93556000"
                    }
                ]
            },
            {
                "id": 4152,
                "name": "Idrija",
                "iso2": "036",
                "latitude": "46.00409390",
                "longitude": "13.97754930",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104122,
                        "name": "Idrija",
                        "latitude": "46.00278000",
                        "longitude": "14.03056000"
                    },
                    {
                        "id": 104280,
                        "name": "Spodnja Idrija",
                        "latitude": "46.03194000",
                        "longitude": "14.02722000"
                    }
                ]
            },
            {
                "id": 4286,
                "name": "Ig",
                "iso2": "037",
                "latitude": "45.95888680",
                "longitude": "14.52705280",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104123,
                        "name": "Ig",
                        "latitude": "45.96028000",
                        "longitude": "14.52889000"
                    }
                ]
            },
            {
                "id": 4344,
                "name": "Ilirska Bistrica",
                "iso2": "038",
                "latitude": "45.57913230",
                "longitude": "14.28097290",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104124,
                        "name": "Ilirska Bistrica",
                        "latitude": "45.56757000",
                        "longitude": "14.24571000"
                    }
                ]
            },
            {
                "id": 4305,
                "name": "Ivančna Gorica",
                "iso2": "039",
                "latitude": "45.93958410",
                "longitude": "14.80476260",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104125,
                        "name": "Ivančna Gorica",
                        "latitude": "45.93833000",
                        "longitude": "14.80444000"
                    },
                    {
                        "id": 104350,
                        "name": "Šentvid pri Stični",
                        "latitude": "45.95004000",
                        "longitude": "14.84344000"
                    }
                ]
            },
            {
                "id": 4322,
                "name": "Izola",
                "iso2": "040",
                "latitude": "45.53135570",
                "longitude": "13.66646490",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104127,
                        "name": "Izola",
                        "latitude": "45.53694000",
                        "longitude": "13.66194000"
                    },
                    {
                        "id": 104128,
                        "name": "Jagodje",
                        "latitude": "45.52845000",
                        "longitude": "13.64721000"
                    }
                ]
            },
            {
                "id": 4337,
                "name": "Jesenice",
                "iso2": "041",
                "latitude": "46.43670470",
                "longitude": "14.05260570",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104120,
                        "name": "Hrušica",
                        "latitude": "46.44500000",
                        "longitude": "14.01778000"
                    },
                    {
                        "id": 104130,
                        "name": "Jesenice",
                        "latitude": "46.43056000",
                        "longitude": "14.06694000"
                    },
                    {
                        "id": 104143,
                        "name": "Koroška Bela",
                        "latitude": "46.44913000",
                        "longitude": "14.11135000"
                    },
                    {
                        "id": 104274,
                        "name": "Slovenski Javornik",
                        "latitude": "46.42611000",
                        "longitude": "14.08722000"
                    }
                ]
            },
            {
                "id": 4203,
                "name": "Jezersko",
                "iso2": "163",
                "latitude": "46.39427940",
                "longitude": "14.49855590",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104332,
                        "name": "Zgornje Jezersko",
                        "latitude": "46.39410000",
                        "longitude": "14.50659000"
                    }
                ]
            },
            {
                "id": 4266,
                "name": "Juršinci",
                "iso2": "042",
                "latitude": "46.48986510",
                "longitude": "15.98092300",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104131,
                        "name": "Juršinci",
                        "latitude": "46.48472000",
                        "longitude": "15.97139000"
                    }
                ]
            },
            {
                "id": 4180,
                "name": "Kamnik",
                "iso2": "043",
                "latitude": "46.22216660",
                "longitude": "14.60707270",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104133,
                        "name": "Kamnik",
                        "latitude": "46.22587000",
                        "longitude": "14.61207000"
                    },
                    {
                        "id": 104184,
                        "name": "Mekinje",
                        "latitude": "46.23333000",
                        "longitude": "14.61667000"
                    },
                    {
                        "id": 104355,
                        "name": "Šmarca",
                        "latitude": "46.19333000",
                        "longitude": "14.59667000"
                    }
                ]
            },
            {
                "id": 4227,
                "name": "Kanal ob Soči",
                "iso2": "044",
                "latitude": "46.06735300",
                "longitude": "13.62033500",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104086,
                        "name": "Deskle",
                        "latitude": "46.05307000",
                        "longitude": "13.61382000"
                    },
                    {
                        "id": 104134,
                        "name": "Kanal",
                        "latitude": "46.08861000",
                        "longitude": "13.63972000"
                    }
                ]
            },
            {
                "id": 4150,
                "name": "Kidričevo",
                "iso2": "045",
                "latitude": "46.39575720",
                "longitude": "15.79259060",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104135,
                        "name": "Kidričevo",
                        "latitude": "46.40361000",
                        "longitude": "15.79111000"
                    }
                ]
            },
            {
                "id": 4243,
                "name": "Kobarid",
                "iso2": "046",
                "latitude": "46.24569710",
                "longitude": "13.57869490",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104137,
                        "name": "Kobarid",
                        "latitude": "46.24761000",
                        "longitude": "13.57907000"
                    }
                ]
            },
            {
                "id": 4325,
                "name": "Kobilje",
                "iso2": "047",
                "latitude": "46.68518000",
                "longitude": "16.39367190",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104138,
                        "name": "Kobilje",
                        "latitude": "46.68472000",
                        "longitude": "16.39778000"
                    }
                ]
            },
            {
                "id": 4335,
                "name": "Kočevje",
                "iso2": "048",
                "latitude": "45.64280000",
                "longitude": "14.86158380",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104149,
                        "name": "Kočevje",
                        "latitude": "45.64333000",
                        "longitude": "14.86333000"
                    }
                ]
            },
            {
                "id": 4315,
                "name": "Komen",
                "iso2": "049",
                "latitude": "45.81752350",
                "longitude": "13.74827110",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104140,
                        "name": "Komen",
                        "latitude": "45.81528000",
                        "longitude": "13.74833000"
                    }
                ]
            },
            {
                "id": 4283,
                "name": "Komenda",
                "iso2": "164",
                "latitude": "46.20648800",
                "longitude": "14.53824990",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104141,
                        "name": "Komenda",
                        "latitude": "46.20484000",
                        "longitude": "14.53839000"
                    },
                    {
                        "id": 104199,
                        "name": "Moste",
                        "latitude": "46.19500000",
                        "longitude": "14.55139000"
                    }
                ]
            },
            {
                "id": 4319,
                "name": "Koper",
                "iso2": "050",
                "latitude": "45.54805900",
                "longitude": "13.73018770",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104085,
                        "name": "Dekani",
                        "latitude": "45.54972000",
                        "longitude": "13.81361000"
                    },
                    {
                        "id": 104121,
                        "name": "Hrvatini",
                        "latitude": "45.58278000",
                        "longitude": "13.75667000"
                    },
                    {
                        "id": 104142,
                        "name": "Koper",
                        "latitude": "45.54694000",
                        "longitude": "13.72944000"
                    },
                    {
                        "id": 104223,
                        "name": "Pobegi",
                        "latitude": "45.53944000",
                        "longitude": "13.79611000"
                    },
                    {
                        "id": 104231,
                        "name": "Prade",
                        "latitude": "45.54003000",
                        "longitude": "13.77607000"
                    },
                    {
                        "id": 104282,
                        "name": "Spodnje Škofije",
                        "latitude": "45.57167000",
                        "longitude": "13.79250000"
                    },
                    {
                        "id": 104288,
                        "name": "Sv. Anton",
                        "latitude": "45.52583000",
                        "longitude": "13.83194000"
                    }
                ]
            },
            {
                "id": 4254,
                "name": "Kostanjevica na Krki",
                "iso2": "197",
                "latitude": "45.83166380",
                "longitude": "15.44119060",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4331,
                "name": "Kostel",
                "iso2": "165",
                "latitude": "45.49282550",
                "longitude": "14.87082350",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104145,
                        "name": "Kostel",
                        "latitude": "45.50842000",
                        "longitude": "14.91005000"
                    }
                ]
            },
            {
                "id": 4186,
                "name": "Kozje",
                "iso2": "051",
                "latitude": "46.07332110",
                "longitude": "15.55967190",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104148,
                        "name": "Kozje",
                        "latitude": "46.07500000",
                        "longitude": "15.56028000"
                    }
                ]
            },
            {
                "id": 4287,
                "name": "Kranj",
                "iso2": "052",
                "latitude": "46.25850210",
                "longitude": "14.35435690",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104077,
                        "name": "Britof",
                        "latitude": "46.26024000",
                        "longitude": "14.39037000"
                    },
                    {
                        "id": 104105,
                        "name": "Golnik",
                        "latitude": "46.33333000",
                        "longitude": "14.33333000"
                    },
                    {
                        "id": 104139,
                        "name": "Kokrica",
                        "latitude": "46.27028000",
                        "longitude": "14.36111000"
                    },
                    {
                        "id": 104150,
                        "name": "Kranj",
                        "latitude": "46.23887000",
                        "longitude": "14.35561000"
                    },
                    {
                        "id": 104193,
                        "name": "Mlaka pri Kranju",
                        "latitude": "46.28333000",
                        "longitude": "14.35000000"
                    },
                    {
                        "id": 104330,
                        "name": "Zgornje Bitnje",
                        "latitude": "46.22000000",
                        "longitude": "14.33667000"
                    }
                ]
            },
            {
                "id": 4340,
                "name": "Kranjska Gora",
                "iso2": "053",
                "latitude": "46.48452930",
                "longitude": "13.78571450",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104151,
                        "name": "Kranjska Gora",
                        "latitude": "46.45689000",
                        "longitude": "13.77824000"
                    },
                    {
                        "id": 104194,
                        "name": "Mojstrana",
                        "latitude": "46.42383000",
                        "longitude": "13.87520000"
                    }
                ]
            },
            {
                "id": 4238,
                "name": "Križevci",
                "iso2": "166",
                "latitude": "46.57018210",
                "longitude": "16.10926530",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104152,
                        "name": "Križevci pri Ljutomeru",
                        "latitude": "46.56833000",
                        "longitude": "16.13861000"
                    }
                ]
            },
            {
                "id": 4314,
                "name": "Krško",
                "iso2": "054",
                "latitude": "45.95896090",
                "longitude": "15.49235550",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104155,
                        "name": "Krško",
                        "latitude": "45.95915000",
                        "longitude": "15.49167000"
                    },
                    {
                        "id": 104164,
                        "name": "Leskovec pri Krškem",
                        "latitude": "45.93566000",
                        "longitude": "15.47184000"
                    },
                    {
                        "id": 104267,
                        "name": "Senovo",
                        "latitude": "46.02361000",
                        "longitude": "15.47694000"
                    }
                ]
            },
            {
                "id": 4197,
                "name": "Kungota",
                "iso2": "055",
                "latitude": "46.64187930",
                "longitude": "15.60362880",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104328,
                        "name": "Zgornja Kungota",
                        "latitude": "46.63917000",
                        "longitude": "15.61556000"
                    }
                ]
            },
            {
                "id": 4211,
                "name": "Kuzma",
                "iso2": "056",
                "latitude": "46.83510380",
                "longitude": "16.08071000",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104156,
                        "name": "Kuzma",
                        "latitude": "46.83694000",
                        "longitude": "16.08333000"
                    }
                ]
            },
            {
                "id": 4338,
                "name": "Laško",
                "iso2": "057",
                "latitude": "46.15422360",
                "longitude": "15.23614910",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104158,
                        "name": "Laško",
                        "latitude": "46.15463000",
                        "longitude": "15.23555000"
                    }
                ]
            },
            {
                "id": 4142,
                "name": "Lenart",
                "iso2": "058",
                "latitude": "46.58344240",
                "longitude": "15.82621250",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104160,
                        "name": "Lenart v Slov. Goricah",
                        "latitude": "46.57611000",
                        "longitude": "15.83139000"
                    }
                ]
            },
            {
                "id": 4225,
                "name": "Lendava",
                "iso2": "059",
                "latitude": "46.55134830",
                "longitude": "16.44198390",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104161,
                        "name": "Lendava",
                        "latitude": "46.56494000",
                        "longitude": "16.45091000"
                    }
                ]
            },
            {
                "id": 4347,
                "name": "Litija",
                "iso2": "060",
                "latitude": "46.05732260",
                "longitude": "14.83096360",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104167,
                        "name": "Litija",
                        "latitude": "46.05861000",
                        "longitude": "14.82250000"
                    }
                ]
            },
            {
                "id": 4270,
                "name": "Ljubljana",
                "iso2": "061",
                "latitude": "46.05694650",
                "longitude": "14.50575150",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104101,
                        "name": "Dravlje District",
                        "latitude": "46.07290000",
                        "longitude": "14.44741000"
                    },
                    {
                        "id": 104129,
                        "name": "Jarše District",
                        "latitude": "46.07345000",
                        "longitude": "14.55431000"
                    },
                    {
                        "id": 104169,
                        "name": "Ljubljana",
                        "latitude": "46.05108000",
                        "longitude": "14.50513000"
                    },
                    {
                        "id": 104211,
                        "name": "Opčina Ljubljana-Bežigrad",
                        "latitude": "46.08333000",
                        "longitude": "14.53333000"
                    },
                    {
                        "id": 104212,
                        "name": "Opština Ljubljana-Center",
                        "latitude": "46.05000000",
                        "longitude": "14.53333000"
                    },
                    {
                        "id": 104213,
                        "name": "Opština Ljubljana-Moste-Polje",
                        "latitude": "46.06667000",
                        "longitude": "14.61667000"
                    },
                    {
                        "id": 104262,
                        "name": "Rožnik District",
                        "latitude": "46.05999000",
                        "longitude": "14.46779000"
                    },
                    {
                        "id": 104349,
                        "name": "Šentvid District",
                        "latitude": "46.10559000",
                        "longitude": "14.43329000"
                    },
                    {
                        "id": 104278,
                        "name": "Sostro District",
                        "latitude": "46.04341000",
                        "longitude": "14.67293000"
                    },
                    {
                        "id": 104300,
                        "name": "Trnovo District",
                        "latitude": "46.02412000",
                        "longitude": "14.48891000"
                    },
                    {
                        "id": 104315,
                        "name": "Vič District",
                        "latitude": "46.00779000",
                        "longitude": "14.46968000"
                    }
                ]
            },
            {
                "id": 4294,
                "name": "Ljubno",
                "iso2": "062",
                "latitude": "46.34431250",
                "longitude": "14.83354920",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104170,
                        "name": "Ljubno ob Savinji",
                        "latitude": "46.34358000",
                        "longitude": "14.83377000"
                    }
                ]
            },
            {
                "id": 4351,
                "name": "Ljutomer",
                "iso2": "063",
                "latitude": "46.51908480",
                "longitude": "16.18932160",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104171,
                        "name": "Ljutomer",
                        "latitude": "46.52083000",
                        "longitude": "16.19750000"
                    }
                ]
            },
            {
                "id": 4306,
                "name": "Log–Dragomer",
                "iso2": "208",
                "latitude": "46.01787470",
                "longitude": "14.36877670",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4350,
                "name": "Logatec",
                "iso2": "064",
                "latitude": "45.91761100",
                "longitude": "14.23514510",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104173,
                        "name": "Logatec",
                        "latitude": "45.91444000",
                        "longitude": "14.22583000"
                    }
                ]
            },
            {
                "id": 4174,
                "name": "Loška Dolina",
                "iso2": "065",
                "latitude": "45.64779080",
                "longitude": "14.49731470",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104163,
                        "name": "Leskova Dolina",
                        "latitude": "45.62139000",
                        "longitude": "14.46056000"
                    }
                ]
            },
            {
                "id": 4158,
                "name": "Loški Potok",
                "iso2": "066",
                "latitude": "45.69096370",
                "longitude": "14.59859700",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104119,
                        "name": "Hrib-Loški Potok",
                        "latitude": "45.70688000",
                        "longitude": "14.61674000"
                    }
                ]
            },
            {
                "id": 4156,
                "name": "Lovrenc na Pohorju",
                "iso2": "167",
                "latitude": "46.54196380",
                "longitude": "15.40004430",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104175,
                        "name": "Lovrenc na Pohorju",
                        "latitude": "46.54056000",
                        "longitude": "15.39306000"
                    }
                ]
            },
            {
                "id": 4219,
                "name": "Luče",
                "iso2": "067",
                "latitude": "46.35449250",
                "longitude": "14.74715040",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104178,
                        "name": "Luče",
                        "latitude": "46.35611000",
                        "longitude": "14.74667000"
                    }
                ]
            },
            {
                "id": 4302,
                "name": "Lukovica",
                "iso2": "068",
                "latitude": "46.16962930",
                "longitude": "14.69072590",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104177,
                        "name": "Lukovica pri Domžalah",
                        "latitude": "46.16988000",
                        "longitude": "14.69179000"
                    }
                ]
            },
            {
                "id": 4157,
                "name": "Majšperk",
                "iso2": "069",
                "latitude": "46.35030190",
                "longitude": "15.73405950",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104179,
                        "name": "Majšperk",
                        "latitude": "46.35167000",
                        "longitude": "15.73361000"
                    }
                ]
            },
            {
                "id": 4224,
                "name": "Makole",
                "iso2": "198",
                "latitude": "46.31686970",
                "longitude": "15.66641260",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4242,
                "name": "Maribor",
                "iso2": "070",
                "latitude": "46.55064960",
                "longitude": "15.62054390",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104074,
                        "name": "Bresternica",
                        "latitude": "46.56972000",
                        "longitude": "15.57500000"
                    },
                    {
                        "id": 104132,
                        "name": "Kamnica",
                        "latitude": "46.57444000",
                        "longitude": "15.61417000"
                    },
                    {
                        "id": 104165,
                        "name": "Limbuš",
                        "latitude": "46.55361000",
                        "longitude": "15.58361000"
                    },
                    {
                        "id": 104181,
                        "name": "Maribor",
                        "latitude": "46.55472000",
                        "longitude": "15.64667000"
                    },
                    {
                        "id": 104219,
                        "name": "Pekre",
                        "latitude": "46.54722000",
                        "longitude": "15.59556000"
                    },
                    {
                        "id": 104251,
                        "name": "Razvanje",
                        "latitude": "46.51444000",
                        "longitude": "15.63611000"
                    }
                ]
            },
            {
                "id": 4244,
                "name": "Markovci",
                "iso2": "168",
                "latitude": "46.38793090",
                "longitude": "15.95860140",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104182,
                        "name": "Markovci",
                        "latitude": "46.39557000",
                        "longitude": "15.92831000"
                    }
                ]
            },
            {
                "id": 4349,
                "name": "Medvode",
                "iso2": "071",
                "latitude": "46.14190800",
                "longitude": "14.40325960",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104183,
                        "name": "Medvode",
                        "latitude": "46.14220000",
                        "longitude": "14.41114000"
                    },
                    {
                        "id": 104215,
                        "name": "Opština [historical] Ljubljana-Šiška",
                        "latitude": "46.16667000",
                        "longitude": "14.43333000"
                    },
                    {
                        "id": 104333,
                        "name": "Zgornje Pirniče",
                        "latitude": "46.14251000",
                        "longitude": "14.43158000"
                    }
                ]
            },
            {
                "id": 4348,
                "name": "Mengeš",
                "iso2": "072",
                "latitude": "46.16591220",
                "longitude": "14.57196940",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104185,
                        "name": "Mengeš",
                        "latitude": "46.16694000",
                        "longitude": "14.57500000"
                    },
                    {
                        "id": 104235,
                        "name": "Preserje pri Radomljah",
                        "latitude": "46.16911000",
                        "longitude": "14.59698000"
                    }
                ]
            },
            {
                "id": 4323,
                "name": "Metlika",
                "iso2": "073",
                "latitude": "45.64807150",
                "longitude": "15.31778380",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104186,
                        "name": "Metlika",
                        "latitude": "45.64722000",
                        "longitude": "15.31417000"
                    }
                ]
            },
            {
                "id": 4265,
                "name": "Mežica",
                "iso2": "074",
                "latitude": "46.52150270",
                "longitude": "14.85213400",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104187,
                        "name": "Mežica",
                        "latitude": "46.52139000",
                        "longitude": "14.85444000"
                    }
                ]
            },
            {
                "id": 4223,
                "name": "Miklavž na Dravskem Polju",
                "iso2": "169",
                "latitude": "46.50826280",
                "longitude": "15.69520650",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104188,
                        "name": "Miklavž na Dravskem Polju",
                        "latitude": "46.50583000",
                        "longitude": "15.69722000"
                    }
                ]
            },
            {
                "id": 4220,
                "name": "Miren–Kostanjevica",
                "iso2": "075",
                "latitude": "45.84360290",
                "longitude": "13.62766470",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104065,
                        "name": "Bilje",
                        "latitude": "45.89444000",
                        "longitude": "13.63222000"
                    },
                    {
                        "id": 104189,
                        "name": "Miren",
                        "latitude": "45.89556000",
                        "longitude": "13.60750000"
                    }
                ]
            },
            {
                "id": 4298,
                "name": "Mirna",
                "iso2": "212",
                "latitude": "45.95156470",
                "longitude": "15.06209770",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4237,
                "name": "Mirna Peč",
                "iso2": "170",
                "latitude": "45.84815740",
                "longitude": "15.08794500",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104191,
                        "name": "Mirna Peč",
                        "latitude": "45.86028000",
                        "longitude": "15.08333000"
                    }
                ]
            },
            {
                "id": 4212,
                "name": "Mislinja",
                "iso2": "076",
                "latitude": "46.44294030",
                "longitude": "15.19876780",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104192,
                        "name": "Mislinja",
                        "latitude": "46.44141000",
                        "longitude": "15.20027000"
                    }
                ]
            },
            {
                "id": 4297,
                "name": "Mokronog–Trebelno",
                "iso2": "199",
                "latitude": "45.90885290",
                "longitude": "15.15967360",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4168,
                "name": "Moravče",
                "iso2": "077",
                "latitude": "46.13627810",
                "longitude": "14.74600100",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104197,
                        "name": "Moravče",
                        "latitude": "46.13694000",
                        "longitude": "14.74500000"
                    }
                ]
            },
            {
                "id": 4218,
                "name": "Moravske Toplice",
                "iso2": "078",
                "latitude": "46.68569320",
                "longitude": "16.22245820",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104196,
                        "name": "Moravske Toplice",
                        "latitude": "46.68313000",
                        "longitude": "16.22080000"
                    }
                ]
            },
            {
                "id": 4190,
                "name": "Mozirje",
                "iso2": "079",
                "latitude": "46.33943500",
                "longitude": "14.96024130",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104200,
                        "name": "Mozirje",
                        "latitude": "46.33944000",
                        "longitude": "14.96333000"
                    }
                ]
            },
            {
                "id": 4313,
                "name": "Murska Sobota",
                "iso2": "080",
                "latitude": "46.64321470",
                "longitude": "16.15157540",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104062,
                        "name": "Bakovci",
                        "latitude": "46.61889000",
                        "longitude": "16.15028000"
                    },
                    {
                        "id": 104336,
                        "name": "Černelavci",
                        "latitude": "46.66667000",
                        "longitude": "16.13333000"
                    },
                    {
                        "id": 104153,
                        "name": "Krog",
                        "latitude": "46.63806000",
                        "longitude": "16.14139000"
                    },
                    {
                        "id": 104201,
                        "name": "Murska Sobota",
                        "latitude": "46.66250000",
                        "longitude": "16.16639000"
                    },
                    {
                        "id": 104247,
                        "name": "Rakičan",
                        "latitude": "46.65167000",
                        "longitude": "16.20417000"
                    }
                ]
            },
            {
                "id": 4208,
                "name": "Muta",
                "iso2": "081",
                "latitude": "46.60973660",
                "longitude": "15.16299950",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104202,
                        "name": "Muta",
                        "latitude": "46.61139000",
                        "longitude": "15.16611000"
                    }
                ]
            },
            {
                "id": 4177,
                "name": "Naklo",
                "iso2": "082",
                "latitude": "46.27186630",
                "longitude": "14.31569320",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104203,
                        "name": "Naklo",
                        "latitude": "46.27278000",
                        "longitude": "14.31722000"
                    }
                ]
            },
            {
                "id": 4329,
                "name": "Nazarje",
                "iso2": "083",
                "latitude": "46.28217410",
                "longitude": "14.92256290",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104204,
                        "name": "Nazarje",
                        "latitude": "46.31757000",
                        "longitude": "14.94674000"
                    }
                ]
            },
            {
                "id": 4205,
                "name": "Nova Gorica",
                "iso2": "084",
                "latitude": "45.97627600",
                "longitude": "13.73088810",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104154,
                        "name": "Kromberk",
                        "latitude": "45.96083000",
                        "longitude": "13.66556000"
                    },
                    {
                        "id": 104206,
                        "name": "Nova Gorica",
                        "latitude": "45.95604000",
                        "longitude": "13.64837000"
                    },
                    {
                        "id": 104237,
                        "name": "Prvačina",
                        "latitude": "45.89000000",
                        "longitude": "13.71806000"
                    },
                    {
                        "id": 104342,
                        "name": "Šempas",
                        "latitude": "45.93028000",
                        "longitude": "13.74361000"
                    },
                    {
                        "id": 104276,
                        "name": "Solkan",
                        "latitude": "45.97139000",
                        "longitude": "13.64944000"
                    }
                ]
            },
            {
                "id": 4236,
                "name": "Novo Mesto",
                "iso2": "085",
                "latitude": "45.80108240",
                "longitude": "15.17100890",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104208,
                        "name": "Novo Mesto",
                        "latitude": "45.80397000",
                        "longitude": "15.16886000"
                    }
                ]
            },
            {
                "id": 4320,
                "name": "Odranci",
                "iso2": "086",
                "latitude": "46.59010170",
                "longitude": "16.27881650",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104209,
                        "name": "Odranci",
                        "latitude": "46.58667000",
                        "longitude": "16.28028000"
                    }
                ]
            },
            {
                "id": 4143,
                "name": "Oplotnica",
                "iso2": "171",
                "latitude": "46.38716300",
                "longitude": "15.44581310",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104210,
                        "name": "Oplotnica",
                        "latitude": "46.38778000",
                        "longitude": "15.44667000"
                    }
                ]
            },
            {
                "id": 4221,
                "name": "Ormož",
                "iso2": "087",
                "latitude": "46.43533330",
                "longitude": "16.15437400",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104216,
                        "name": "Ormož",
                        "latitude": "46.41139000",
                        "longitude": "16.15444000"
                    }
                ]
            },
            {
                "id": 4199,
                "name": "Osilnica",
                "iso2": "088",
                "latitude": "45.54184670",
                "longitude": "14.71563030",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104217,
                        "name": "Osilnica",
                        "latitude": "45.52914000",
                        "longitude": "14.69838000"
                    }
                ]
            },
            {
                "id": 4172,
                "name": "Pesnica",
                "iso2": "089",
                "latitude": "46.60887550",
                "longitude": "15.67570510",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104220,
                        "name": "Pesnica pri Mariboru",
                        "latitude": "46.60694000",
                        "longitude": "15.67667000"
                    }
                ]
            },
            {
                "id": 4201,
                "name": "Piran",
                "iso2": "090",
                "latitude": "45.52888560",
                "longitude": "13.56807350",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104176,
                        "name": "Lucija",
                        "latitude": "45.50526000",
                        "longitude": "13.60240000"
                    },
                    {
                        "id": 104221,
                        "name": "Piran",
                        "latitude": "45.52778000",
                        "longitude": "13.57056000"
                    },
                    {
                        "id": 104229,
                        "name": "Portorož",
                        "latitude": "45.51429000",
                        "longitude": "13.59206000"
                    },
                    {
                        "id": 104269,
                        "name": "Seča",
                        "latitude": "45.49584000",
                        "longitude": "13.61466000"
                    }
                ]
            },
            {
                "id": 4184,
                "name": "Pivka",
                "iso2": "091",
                "latitude": "45.67892960",
                "longitude": "14.25426890",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104222,
                        "name": "Pivka",
                        "latitude": "45.68292000",
                        "longitude": "14.19588000"
                    }
                ]
            },
            {
                "id": 4146,
                "name": "Podčetrtek",
                "iso2": "092",
                "latitude": "46.17395420",
                "longitude": "15.60138160",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104226,
                        "name": "Podčetrtek",
                        "latitude": "46.15694000",
                        "longitude": "15.59861000"
                    }
                ]
            },
            {
                "id": 4161,
                "name": "Podlehnik",
                "iso2": "172",
                "latitude": "46.33107820",
                "longitude": "15.87858360",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104224,
                        "name": "Podlehnik",
                        "latitude": "46.33528000",
                        "longitude": "15.88000000"
                    }
                ]
            },
            {
                "id": 4234,
                "name": "Podvelka",
                "iso2": "093",
                "latitude": "46.62219520",
                "longitude": "15.38899220",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104225,
                        "name": "Podvelka",
                        "latitude": "46.58694000",
                        "longitude": "15.33056000"
                    }
                ]
            },
            {
                "id": 4239,
                "name": "Poljčane",
                "iso2": "200",
                "latitude": "46.31398530",
                "longitude": "15.57847910",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4272,
                "name": "Polzela",
                "iso2": "173",
                "latitude": "46.28089700",
                "longitude": "15.07373210",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104228,
                        "name": "Polzela",
                        "latitude": "46.28333000",
                        "longitude": "15.06667000"
                    }
                ]
            },
            {
                "id": 4330,
                "name": "Postojna",
                "iso2": "094",
                "latitude": "45.77493900",
                "longitude": "14.21342630",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104230,
                        "name": "Postojna",
                        "latitude": "45.77435000",
                        "longitude": "14.21528000"
                    }
                ]
            },
            {
                "id": 4188,
                "name": "Prebold",
                "iso2": "174",
                "latitude": "46.23591360",
                "longitude": "15.09369120",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104233,
                        "name": "Prebold",
                        "latitude": "46.23694000",
                        "longitude": "15.09250000"
                    }
                ]
            },
            {
                "id": 4303,
                "name": "Preddvor",
                "iso2": "095",
                "latitude": "46.30171390",
                "longitude": "14.42181650",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104234,
                        "name": "Preddvor",
                        "latitude": "46.30250000",
                        "longitude": "14.42306000"
                    }
                ]
            },
            {
                "id": 4274,
                "name": "Prevalje",
                "iso2": "175",
                "latitude": "46.56211460",
                "longitude": "14.88478610",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104236,
                        "name": "Prevalje",
                        "latitude": "46.54694000",
                        "longitude": "14.92083000"
                    }
                ]
            },
            {
                "id": 4228,
                "name": "Ptuj",
                "iso2": "096",
                "latitude": "46.41995350",
                "longitude": "15.86968840",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104238,
                        "name": "Ptuj",
                        "latitude": "46.42005000",
                        "longitude": "15.87018000"
                    }
                ]
            },
            {
                "id": 4288,
                "name": "Puconci",
                "iso2": "097",
                "latitude": "46.72004180",
                "longitude": "16.09977920",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104239,
                        "name": "Puconci",
                        "latitude": "46.70667000",
                        "longitude": "16.15639000"
                    }
                ]
            },
            {
                "id": 4204,
                "name": "Rače–Fram",
                "iso2": "098",
                "latitude": "46.45420830",
                "longitude": "15.63294670",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104103,
                        "name": "Fram",
                        "latitude": "46.45600000",
                        "longitude": "15.63007000"
                    },
                    {
                        "id": 104198,
                        "name": "Morje",
                        "latitude": "46.44444000",
                        "longitude": "15.62139000"
                    },
                    {
                        "id": 104252,
                        "name": "Rače",
                        "latitude": "46.45194000",
                        "longitude": "15.68139000"
                    }
                ]
            },
            {
                "id": 4195,
                "name": "Radeče",
                "iso2": "099",
                "latitude": "46.06669540",
                "longitude": "15.18204380",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104241,
                        "name": "Radeče",
                        "latitude": "46.06806000",
                        "longitude": "15.18389000"
                    }
                ]
            },
            {
                "id": 4292,
                "name": "Radenci",
                "iso2": "100",
                "latitude": "46.62311210",
                "longitude": "16.05069030",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104240,
                        "name": "Radenci",
                        "latitude": "46.64201000",
                        "longitude": "16.03781000"
                    }
                ]
            },
            {
                "id": 4275,
                "name": "Radlje ob Dravi",
                "iso2": "101",
                "latitude": "46.61357320",
                "longitude": "15.23544380",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104243,
                        "name": "Radlje ob Dravi",
                        "latitude": "46.61417000",
                        "longitude": "15.22639000"
                    }
                ]
            },
            {
                "id": 4231,
                "name": "Radovljica",
                "iso2": "102",
                "latitude": "46.33558270",
                "longitude": "14.20945340",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104162,
                        "name": "Lesce",
                        "latitude": "46.36111000",
                        "longitude": "14.15778000"
                    },
                    {
                        "id": 104245,
                        "name": "Radovljica",
                        "latitude": "46.34444000",
                        "longitude": "14.17444000"
                    }
                ]
            },
            {
                "id": 4155,
                "name": "Ravne na Koroškem",
                "iso2": "103",
                "latitude": "46.55211940",
                "longitude": "14.95990840",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104146,
                        "name": "Kotlje",
                        "latitude": "46.52139000",
                        "longitude": "14.98694000"
                    },
                    {
                        "id": 104249,
                        "name": "Ravne na Koroškem",
                        "latitude": "46.54306000",
                        "longitude": "14.96917000"
                    }
                ]
            },
            {
                "id": 4206,
                "name": "Razkrižje",
                "iso2": "176",
                "latitude": "46.52263390",
                "longitude": "16.26686380",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104250,
                        "name": "Razkrižje",
                        "latitude": "46.52167000",
                        "longitude": "16.28111000"
                    }
                ]
            },
            {
                "id": 4160,
                "name": "Rečica ob Savinji",
                "iso2": "209",
                "latitude": "46.32337900",
                "longitude": "14.92236700",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4253,
                "name": "Renče–Vogrsko",
                "iso2": "201",
                "latitude": "45.89546170",
                "longitude": "13.67856730",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104253,
                        "name": "Renče",
                        "latitude": "45.89000000",
                        "longitude": "13.66861000"
                    },
                    {
                        "id": 104319,
                        "name": "Volčja Draga",
                        "latitude": "45.90694000",
                        "longitude": "13.67750000"
                    }
                ]
            },
            {
                "id": 4235,
                "name": "Ribnica",
                "iso2": "104",
                "latitude": "45.74003030",
                "longitude": "14.72657820",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104255,
                        "name": "Ribnica",
                        "latitude": "45.73861000",
                        "longitude": "14.72750000"
                    }
                ]
            },
            {
                "id": 4207,
                "name": "Ribnica na Pohorju",
                "iso2": "177",
                "latitude": "46.53561450",
                "longitude": "15.26745380",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104256,
                        "name": "Ribnica na Pohorju",
                        "latitude": "46.53500000",
                        "longitude": "15.27278000"
                    }
                ]
            },
            {
                "id": 4233,
                "name": "Rogaška Slatina",
                "iso2": "106",
                "latitude": "46.24539730",
                "longitude": "15.62650140",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104258,
                        "name": "Rogaška Slatina",
                        "latitude": "46.23750000",
                        "longitude": "15.63972000"
                    }
                ]
            },
            {
                "id": 4264,
                "name": "Rogašovci",
                "iso2": "105",
                "latitude": "46.80557850",
                "longitude": "16.03452370",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104259,
                        "name": "Rogašovci",
                        "latitude": "46.80000000",
                        "longitude": "16.03333000"
                    }
                ]
            },
            {
                "id": 4209,
                "name": "Rogatec",
                "iso2": "107",
                "latitude": "46.22866260",
                "longitude": "15.69913380",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104257,
                        "name": "Rogatec",
                        "latitude": "46.22944000",
                        "longitude": "15.70028000"
                    }
                ]
            },
            {
                "id": 4280,
                "name": "Ruše",
                "iso2": "108",
                "latitude": "46.52062650",
                "longitude": "15.48178690",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104066,
                        "name": "Bistrica ob Dravi",
                        "latitude": "46.55419000",
                        "longitude": "15.54855000"
                    },
                    {
                        "id": 104263,
                        "name": "Ruše",
                        "latitude": "46.53944000",
                        "longitude": "15.51583000"
                    }
                ]
            },
            {
                "id": 4222,
                "name": "Šalovci",
                "iso2": "033",
                "latitude": "46.85335680",
                "longitude": "16.25917910",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104341,
                        "name": "Šalovci",
                        "latitude": "46.82500000",
                        "longitude": "16.29806000"
                    }
                ]
            },
            {
                "id": 4230,
                "name": "Selnica ob Dravi",
                "iso2": "178",
                "latitude": "46.55139180",
                "longitude": "15.49294100",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104264,
                        "name": "Selnica ob Dravi",
                        "latitude": "46.55000000",
                        "longitude": "15.49500000"
                    }
                ]
            },
            {
                "id": 4346,
                "name": "Semič",
                "iso2": "109",
                "latitude": "45.65205340",
                "longitude": "15.18207010",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104266,
                        "name": "Semič",
                        "latitude": "45.64611000",
                        "longitude": "15.18222000"
                    }
                ]
            },
            {
                "id": 4317,
                "name": "Šempeter–Vrtojba",
                "iso2": "183",
                "latitude": "45.92900950",
                "longitude": "13.64155940",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104261,
                        "name": "Rožna Dolina",
                        "latitude": "45.94194000",
                        "longitude": "13.66779000"
                    },
                    {
                        "id": 104343,
                        "name": "Šempeter pri Gorici",
                        "latitude": "45.92750000",
                        "longitude": "13.64111000"
                    },
                    {
                        "id": 104322,
                        "name": "Vrtojba",
                        "latitude": "45.91250000",
                        "longitude": "13.63417000"
                    }
                ]
            },
            {
                "id": 4299,
                "name": "Šenčur",
                "iso2": "117",
                "latitude": "46.24336990",
                "longitude": "14.41922230",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104117,
                        "name": "Hrastje",
                        "latitude": "46.21667000",
                        "longitude": "14.40000000"
                    },
                    {
                        "id": 104351,
                        "name": "Šenčur",
                        "latitude": "46.24556000",
                        "longitude": "14.41972000"
                    }
                ]
            },
            {
                "id": 4324,
                "name": "Šentilj",
                "iso2": "118",
                "latitude": "46.68628390",
                "longitude": "15.71035670",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104265,
                        "name": "Selnica ob Muri",
                        "latitude": "46.68333000",
                        "longitude": "15.70000000"
                    },
                    {
                        "id": 104345,
                        "name": "Šentilj v Slov. Goricah",
                        "latitude": "46.68167000",
                        "longitude": "15.64806000"
                    }
                ]
            },
            {
                "id": 4241,
                "name": "Šentjernej",
                "iso2": "119",
                "latitude": "45.84341300",
                "longitude": "15.33783120",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104346,
                        "name": "Šentjernej",
                        "latitude": "45.84000000",
                        "longitude": "15.33611000"
                    }
                ]
            },
            {
                "id": 4171,
                "name": "Šentjur",
                "iso2": "120",
                "latitude": "46.26543390",
                "longitude": "15.40800000",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104347,
                        "name": "Šentjur",
                        "latitude": "46.21722000",
                        "longitude": "15.39750000"
                    }
                ]
            },
            {
                "id": 4311,
                "name": "Šentrupert",
                "iso2": "211",
                "latitude": "45.98731420",
                "longitude": "15.08297830",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104348,
                        "name": "Šentrupert",
                        "latitude": "45.97778000",
                        "longitude": "15.09556000"
                    }
                ]
            },
            {
                "id": 4268,
                "name": "Sevnica",
                "iso2": "110",
                "latitude": "46.00703170",
                "longitude": "15.30456790",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104268,
                        "name": "Sevnica",
                        "latitude": "46.00778000",
                        "longitude": "15.31556000"
                    }
                ]
            },
            {
                "id": 4149,
                "name": "Sežana",
                "iso2": "111",
                "latitude": "45.72751090",
                "longitude": "13.86619310",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104270,
                        "name": "Sežana",
                        "latitude": "45.70924000",
                        "longitude": "13.87333000"
                    }
                ]
            },
            {
                "id": 4170,
                "name": "Škocjan",
                "iso2": "121",
                "latitude": "45.91754540",
                "longitude": "15.31017360",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104352,
                        "name": "Škocjan",
                        "latitude": "45.90667000",
                        "longitude": "15.29139000"
                    }
                ]
            },
            {
                "id": 4316,
                "name": "Škofja Loka",
                "iso2": "122",
                "latitude": "46.14098440",
                "longitude": "14.28118730",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104353,
                        "name": "Škofja Loka",
                        "latitude": "46.16551000",
                        "longitude": "14.30626000"
                    },
                    {
                        "id": 104289,
                        "name": "Sv. Duh",
                        "latitude": "46.18333000",
                        "longitude": "14.33333000"
                    }
                ]
            },
            {
                "id": 4187,
                "name": "Škofljica",
                "iso2": "123",
                "latitude": "45.98409620",
                "longitude": "14.57466260",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104157,
                        "name": "Lavrica",
                        "latitude": "46.00002000",
                        "longitude": "14.55730000"
                    },
                    {
                        "id": 104354,
                        "name": "Škofljica",
                        "latitude": "45.98333000",
                        "longitude": "14.57667000"
                    }
                ]
            },
            {
                "id": 4169,
                "name": "Slovenj Gradec",
                "iso2": "112",
                "latitude": "46.48777180",
                "longitude": "15.07294780",
                "type": "urban municipality",
                "cities": [
                    {
                        "id": 104159,
                        "name": "Legen",
                        "latitude": "46.50651000",
                        "longitude": "15.14424000"
                    },
                    {
                        "id": 104218,
                        "name": "Pameče",
                        "latitude": "46.53417000",
                        "longitude": "15.07917000"
                    },
                    {
                        "id": 104271,
                        "name": "Slovenj Gradec",
                        "latitude": "46.51028000",
                        "longitude": "15.08056000"
                    },
                    {
                        "id": 104361,
                        "name": "Šmartno pri Slovenj Gradcu",
                        "latitude": "46.48944000",
                        "longitude": "15.10667000"
                    }
                ]
            },
            {
                "id": 4332,
                "name": "Slovenska Bistrica",
                "iso2": "113",
                "latitude": "46.39198130",
                "longitude": "15.57278690",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104232,
                        "name": "Pragersko",
                        "latitude": "46.39667000",
                        "longitude": "15.66000000"
                    },
                    {
                        "id": 104272,
                        "name": "Slovenska Bistrica",
                        "latitude": "46.39278000",
                        "longitude": "15.57444000"
                    },
                    {
                        "id": 104329,
                        "name": "Zgornja Polskava",
                        "latitude": "46.42556000",
                        "longitude": "15.61222000"
                    }
                ]
            },
            {
                "id": 4198,
                "name": "Slovenske Konjice",
                "iso2": "114",
                "latitude": "46.33691910",
                "longitude": "15.42147080",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104273,
                        "name": "Slovenske Konjice",
                        "latitude": "46.33667000",
                        "longitude": "15.42583000"
                    }
                ]
            },
            {
                "id": 4285,
                "name": "Šmarje pri Jelšah",
                "iso2": "124",
                "latitude": "46.22870250",
                "longitude": "15.51903530",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104356,
                        "name": "Šmarje pri Jelšah",
                        "latitude": "46.22722000",
                        "longitude": "15.51917000"
                    }
                ]
            },
            {
                "id": 4289,
                "name": "Šmarješke Toplice",
                "iso2": "206",
                "latitude": "45.86803770",
                "longitude": "15.23474220",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104358,
                        "name": "Šmarjeta",
                        "latitude": "45.88333000",
                        "longitude": "15.25000000"
                    }
                ]
            },
            {
                "id": 4296,
                "name": "Šmartno ob Paki",
                "iso2": "125",
                "latitude": "46.32903720",
                "longitude": "15.03339370",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104359,
                        "name": "Šmartno ob Paki",
                        "latitude": "46.33333000",
                        "longitude": "15.03333000"
                    }
                ]
            },
            {
                "id": 4279,
                "name": "Šmartno pri Litiji",
                "iso2": "194",
                "latitude": "46.04549710",
                "longitude": "14.84101330",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104360,
                        "name": "Šmartno pri Litiji",
                        "latitude": "46.04444000",
                        "longitude": "14.84417000"
                    }
                ]
            },
            {
                "id": 4277,
                "name": "Sodražica",
                "iso2": "179",
                "latitude": "45.76165650",
                "longitude": "14.63528530",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104275,
                        "name": "Sodražica",
                        "latitude": "45.76111000",
                        "longitude": "14.63556000"
                    }
                ]
            },
            {
                "id": 4261,
                "name": "Solčava",
                "iso2": "180",
                "latitude": "46.40235260",
                "longitude": "14.68023040",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104277,
                        "name": "Solčava",
                        "latitude": "46.41944000",
                        "longitude": "14.69361000"
                    }
                ]
            },
            {
                "id": 4248,
                "name": "Šoštanj",
                "iso2": "126",
                "latitude": "46.37828360",
                "longitude": "15.04613780",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104248,
                        "name": "Ravne",
                        "latitude": "46.41413000",
                        "longitude": "15.06087000"
                    },
                    {
                        "id": 104362,
                        "name": "Šoštanj",
                        "latitude": "46.38000000",
                        "longitude": "15.04861000"
                    },
                    {
                        "id": 104296,
                        "name": "Topolšica",
                        "latitude": "46.40028000",
                        "longitude": "15.02157000"
                    }
                ]
            },
            {
                "id": 4263,
                "name": "Središče ob Dravi",
                "iso2": "202",
                "latitude": "46.39592820",
                "longitude": "16.27049150",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104284,
                        "name": "Središče ob Dravi",
                        "latitude": "46.39417000",
                        "longitude": "16.26806000"
                    }
                ]
            },
            {
                "id": 4259,
                "name": "Starše",
                "iso2": "115",
                "latitude": "46.46743310",
                "longitude": "15.76405460",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104285,
                        "name": "Starše",
                        "latitude": "46.46583000",
                        "longitude": "15.76722000"
                    }
                ]
            },
            {
                "id": 4185,
                "name": "Štore",
                "iso2": "127",
                "latitude": "46.22225140",
                "longitude": "15.31261160",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104363,
                        "name": "Štore",
                        "latitude": "46.22083000",
                        "longitude": "15.31389000"
                    }
                ]
            },
            {
                "id": 4333,
                "name": "Straža",
                "iso2": "203",
                "latitude": "45.77684280",
                "longitude": "15.09486940",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104286,
                        "name": "Straža",
                        "latitude": "45.78000000",
                        "longitude": "15.07278000"
                    }
                ]
            },
            {
                "id": 4164,
                "name": "Sveta Ana",
                "iso2": "181",
                "latitude": "46.65000000",
                "longitude": "15.84527800",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104287,
                        "name": "Sv. Ana v Slov. Goricah",
                        "latitude": "46.64917000",
                        "longitude": "15.84417000"
                    }
                ]
            },
            {
                "id": 4260,
                "name": "Sveta Trojica v Slovenskih Goricah",
                "iso2": "204",
                "latitude": "46.56808090",
                "longitude": "15.88230640",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104290,
                        "name": "Sv. Trojica v Slov. Goricah",
                        "latitude": "46.57667000",
                        "longitude": "15.87694000"
                    }
                ]
            },
            {
                "id": 4229,
                "name": "Sveti Andraž v Slovenskih Goricah",
                "iso2": "182",
                "latitude": "46.51897470",
                "longitude": "15.94982620",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104314,
                        "name": "Vitomarci",
                        "latitude": "46.52750000",
                        "longitude": "15.93944000"
                    }
                ]
            },
            {
                "id": 4255,
                "name": "Sveti Jurij ob Ščavnici",
                "iso2": "116",
                "latitude": "46.56874520",
                "longitude": "16.02225280",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 4328,
                "name": "Sveti Jurij v Slovenskih Goricah",
                "iso2": "210",
                "latitude": "46.61707910",
                "longitude": "15.78046770",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104291,
                        "name": "Sveti Jurij ob Ščavnici",
                        "latitude": "46.56950000",
                        "longitude": "16.02347000"
                    }
                ]
            },
            {
                "id": 4273,
                "name": "Sveti Tomaž",
                "iso2": "205",
                "latitude": "46.48352830",
                "longitude": "16.07944200",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104292,
                        "name": "Sveti Tomaž",
                        "latitude": "46.48417000",
                        "longitude": "16.08361000"
                    }
                ]
            },
            {
                "id": 4194,
                "name": "Tabor",
                "iso2": "184",
                "latitude": "46.21079210",
                "longitude": "15.01742490",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104293,
                        "name": "Tabor",
                        "latitude": "46.23611000",
                        "longitude": "15.01833000"
                    }
                ]
            },
            {
                "id": 4312,
                "name": "Tišina",
                "iso2": "010",
                "latitude": "46.65418840",
                "longitude": "16.07547810",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104294,
                        "name": "Tišina",
                        "latitude": "46.65806000",
                        "longitude": "16.09167000"
                    }
                ]
            },
            {
                "id": 4247,
                "name": "Tolmin",
                "iso2": "128",
                "latitude": "46.18571880",
                "longitude": "13.73198380",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104295,
                        "name": "Tolmin",
                        "latitude": "46.18304000",
                        "longitude": "13.73321000"
                    }
                ]
            },
            {
                "id": 4246,
                "name": "Trbovlje",
                "iso2": "129",
                "latitude": "46.15035630",
                "longitude": "15.04531370",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104297,
                        "name": "Trbovlje",
                        "latitude": "46.15500000",
                        "longitude": "15.05333000"
                    }
                ]
            },
            {
                "id": 4214,
                "name": "Trebnje",
                "iso2": "130",
                "latitude": "45.90801630",
                "longitude": "15.01319050",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104298,
                        "name": "Trebnje",
                        "latitude": "45.90417000",
                        "longitude": "15.02167000"
                    }
                ]
            },
            {
                "id": 4153,
                "name": "Trnovska Vas",
                "iso2": "185",
                "latitude": "46.52940350",
                "longitude": "15.88531180",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104301,
                        "name": "Trnovska Vas",
                        "latitude": "46.52019000",
                        "longitude": "15.88657000"
                    }
                ]
            },
            {
                "id": 4250,
                "name": "Tržič",
                "iso2": "131",
                "latitude": "46.35935140",
                "longitude": "14.30066230",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104068,
                        "name": "Bistrica pri Tržiču",
                        "latitude": "46.35472000",
                        "longitude": "14.29167000"
                    },
                    {
                        "id": 104303,
                        "name": "Tržič",
                        "latitude": "46.36357000",
                        "longitude": "14.31046000"
                    }
                ]
            },
            {
                "id": 4334,
                "name": "Trzin",
                "iso2": "186",
                "latitude": "46.12982410",
                "longitude": "14.55776370",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104340,
                        "name": "Črnuče District",
                        "latitude": "46.11506000",
                        "longitude": "14.55371000"
                    },
                    {
                        "id": 104302,
                        "name": "Trzin",
                        "latitude": "46.13333000",
                        "longitude": "14.56667000"
                    }
                ]
            },
            {
                "id": 4251,
                "name": "Turnišče",
                "iso2": "132",
                "latitude": "46.61375040",
                "longitude": "16.32021000",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104304,
                        "name": "Turnišče",
                        "latitude": "46.62778000",
                        "longitude": "16.32028000"
                    }
                ]
            },
            {
                "id": 4267,
                "name": "Velika Polana",
                "iso2": "187",
                "latitude": "46.57317150",
                "longitude": "16.34441260",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104305,
                        "name": "Velika Polana",
                        "latitude": "46.57194000",
                        "longitude": "16.34694000"
                    }
                ]
            },
            {
                "id": 4144,
                "name": "Velike Lašče",
                "iso2": "134",
                "latitude": "45.83365910",
                "longitude": "14.63623630",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104306,
                        "name": "Velike Lašče",
                        "latitude": "45.83222000",
                        "longitude": "14.63639000"
                    }
                ]
            },
            {
                "id": 4257,
                "name": "Veržej",
                "iso2": "188",
                "latitude": "46.58411350",
                "longitude": "16.16208000",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104308,
                        "name": "Veržej",
                        "latitude": "46.58361000",
                        "longitude": "16.16528000"
                    }
                ]
            },
            {
                "id": 4300,
                "name": "Videm",
                "iso2": "135",
                "latitude": "46.36383300",
                "longitude": "15.87812120",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104310,
                        "name": "Videm pri Ptuju",
                        "latitude": "46.36861000",
                        "longitude": "15.90639000"
                    }
                ]
            },
            {
                "id": 4196,
                "name": "Vipava",
                "iso2": "136",
                "latitude": "45.84126740",
                "longitude": "13.96096130",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104311,
                        "name": "Vipava",
                        "latitude": "45.84667000",
                        "longitude": "13.96306000"
                    }
                ]
            },
            {
                "id": 4148,
                "name": "Vitanje",
                "iso2": "137",
                "latitude": "46.38153230",
                "longitude": "15.29506870",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104313,
                        "name": "Vitanje",
                        "latitude": "46.38167000",
                        "longitude": "15.29583000"
                    }
                ]
            },
            {
                "id": 4154,
                "name": "Vodice",
                "iso2": "138",
                "latitude": "46.18966430",
                "longitude": "14.49385390",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104317,
                        "name": "Vodice",
                        "latitude": "46.18987000",
                        "longitude": "14.49492000"
                    }
                ]
            },
            {
                "id": 4245,
                "name": "Vojnik",
                "iso2": "139",
                "latitude": "46.29205810",
                "longitude": "15.30205800",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104318,
                        "name": "Vojnik",
                        "latitude": "46.29333000",
                        "longitude": "15.30333000"
                    }
                ]
            },
            {
                "id": 4163,
                "name": "Vransko",
                "iso2": "189",
                "latitude": "46.23900600",
                "longitude": "14.95272490",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104320,
                        "name": "Vransko",
                        "latitude": "46.24389000",
                        "longitude": "14.95139000"
                    }
                ]
            },
            {
                "id": 4262,
                "name": "Vrhnika",
                "iso2": "140",
                "latitude": "45.95027190",
                "longitude": "14.32764220",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104307,
                        "name": "Verd",
                        "latitude": "45.95667000",
                        "longitude": "14.30583000"
                    },
                    {
                        "id": 104321,
                        "name": "Vrhnika",
                        "latitude": "45.96350000",
                        "longitude": "14.29484000"
                    }
                ]
            },
            {
                "id": 4226,
                "name": "Vuzenica",
                "iso2": "141",
                "latitude": "46.59808360",
                "longitude": "15.16572370",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104323,
                        "name": "Vuzenica",
                        "latitude": "46.59639000",
                        "longitude": "15.16722000"
                    }
                ]
            },
            {
                "id": 4269,
                "name": "Zagorje ob Savi",
                "iso2": "142",
                "latitude": "46.13452020",
                "longitude": "14.99643840",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104126,
                        "name": "Izlake",
                        "latitude": "46.15000000",
                        "longitude": "14.95000000"
                    },
                    {
                        "id": 104136,
                        "name": "Kisovec",
                        "latitude": "46.13911000",
                        "longitude": "14.96295000"
                    },
                    {
                        "id": 104325,
                        "name": "Zagorje ob Savi",
                        "latitude": "46.13179000",
                        "longitude": "14.99694000"
                    }
                ]
            },
            {
                "id": 4258,
                "name": "Žalec",
                "iso2": "190",
                "latitude": "46.25197120",
                "longitude": "15.16500720",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104111,
                        "name": "Gotovlje",
                        "latitude": "46.27418000",
                        "longitude": "15.15186000"
                    },
                    {
                        "id": 104344,
                        "name": "Šempeter v Savinj. Dolini",
                        "latitude": "46.25639000",
                        "longitude": "15.12194000"
                    },
                    {
                        "id": 104324,
                        "name": "Zabukovica",
                        "latitude": "46.21408000",
                        "longitude": "15.15954000"
                    },
                    {
                        "id": 104364,
                        "name": "Žalec",
                        "latitude": "46.25151000",
                        "longitude": "15.16482000"
                    }
                ]
            },
            {
                "id": 4182,
                "name": "Zavrč",
                "iso2": "143",
                "latitude": "46.35713000",
                "longitude": "16.04777470",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104327,
                        "name": "Zavrč",
                        "latitude": "46.39167000",
                        "longitude": "16.04972000"
                    }
                ]
            },
            {
                "id": 4256,
                "name": "Železniki",
                "iso2": "146",
                "latitude": "46.22563770",
                "longitude": "14.16936170",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104365,
                        "name": "Železniki",
                        "latitude": "46.22482000",
                        "longitude": "14.17205000"
                    }
                ]
            },
            {
                "id": 4249,
                "name": "Žetale",
                "iso2": "191",
                "latitude": "46.27428330",
                "longitude": "15.79133590",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104366,
                        "name": "Žetale",
                        "latitude": "46.27356000",
                        "longitude": "15.82658000"
                    }
                ]
            },
            {
                "id": 4192,
                "name": "Žiri",
                "iso2": "147",
                "latitude": "46.04724990",
                "longitude": "14.10984510",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104367,
                        "name": "Žiri",
                        "latitude": "46.04222000",
                        "longitude": "14.10722000"
                    }
                ]
            },
            {
                "id": 4276,
                "name": "Žirovnica",
                "iso2": "192",
                "latitude": "46.39544030",
                "longitude": "14.15396320",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104368,
                        "name": "Žirovnica",
                        "latitude": "46.40472000",
                        "longitude": "14.14000000"
                    }
                ]
            },
            {
                "id": 4342,
                "name": "Zreče",
                "iso2": "144",
                "latitude": "46.41777860",
                "longitude": "15.37094310",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104335,
                        "name": "Zreče",
                        "latitude": "46.38222000",
                        "longitude": "15.37917000"
                    }
                ]
            },
            {
                "id": 4307,
                "name": "Žužemberk",
                "iso2": "193",
                "latitude": "45.82003500",
                "longitude": "14.95359190",
                "type": "municipality",
                "cities": [
                    {
                        "id": 104369,
                        "name": "Žužemberk",
                        "latitude": "45.83389000",
                        "longitude": "14.92917000"
                    }
                ]
            }
        ]
    },
    {
        "id": 202,
        "name": "Solomon Islands",
        "iso3": "SLB",
        "iso2": "SB",
        "numeric_code": "090",
        "phonecode": "677",
        "capital": "Honiara",
        "currency": "SBD",
        "currency_name": "Solomon Islands dollar",
        "currency_symbol": "Si$",
        "tld": ".sb",
        "native": "Solomon Islands",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Melanesia",
        "subregion_id": 20,
        "nationality": "Solomon Island",
        "timezones": [
            {
                "zoneName": "Pacific\/Guadalcanal",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "SBT",
                "tzName": "Solomon Islands Time"
            }
        ],
        "translations": {
            "br": "Inizi Salomon",
            "ko": "솔로몬 제도",
            "pt-BR": "Ilhas Salomão",
            "pt": "Ilhas Salomão",
            "nl": "Salomonseilanden",
            "hr": "Solomonski Otoci",
            "fa": "جزایر سلیمان",
            "de": "Salomonen",
            "es": "Islas Salomón",
            "fr": "Îles Salomon",
            "ja": "ソロモン諸島",
            "it": "Isole Salomone",
            "zh-CN": "所罗门群岛",
            "tr": "Solomon Adalari",
            "ru": "Соломоновы острова",
            "uk": "Соломонові острови",
            "pl": "Wyspy Salomona"
        },
        "latitude": "-8.00000000",
        "longitude": "159.00000000",
        "emoji": "🇸🇧",
        "emojiU": "U+1F1F8 U+1F1E7",
        "states": [
            {
                "id": 4784,
                "name": "Central",
                "iso2": "CE",
                "latitude": "-9.02025930",
                "longitude": "158.25118300",
                "type": "province",
                "cities": [
                    {
                        "id": 102905,
                        "name": "Tulagi",
                        "latitude": "-9.10306000",
                        "longitude": "160.15056000"
                    }
                ]
            },
            {
                "id": 4781,
                "name": "Choiseul",
                "iso2": "CH",
                "latitude": "-7.05014940",
                "longitude": "156.95114590",
                "type": "province",
                "cities": []
            },
            {
                "id": 4785,
                "name": "Guadalcanal",
                "iso2": "GU",
                "latitude": "-9.57732840",
                "longitude": "160.14558050",
                "type": "province",
                "cities": [
                    {
                        "id": 102902,
                        "name": "Honiara",
                        "latitude": "-9.43333000",
                        "longitude": "159.95000000"
                    }
                ]
            },
            {
                "id": 4778,
                "name": "Honiara",
                "iso2": "CT",
                "latitude": "-9.44563810",
                "longitude": "159.97289990",
                "type": "capital territory",
                "cities": []
            },
            {
                "id": 4780,
                "name": "Isabel",
                "iso2": "IS",
                "latitude": "-8.05923530",
                "longitude": "159.14470810",
                "type": "province",
                "cities": [
                    {
                        "id": 102900,
                        "name": "Buala",
                        "latitude": "-8.14497000",
                        "longitude": "159.59212000"
                    }
                ]
            },
            {
                "id": 4782,
                "name": "Makira-Ulawa",
                "iso2": "MK",
                "latitude": "-10.57374470",
                "longitude": "161.80969410",
                "type": "province",
                "cities": [
                    {
                        "id": 102903,
                        "name": "Kirakira",
                        "latitude": "-10.45442000",
                        "longitude": "161.92045000"
                    }
                ]
            },
            {
                "id": 4783,
                "name": "Malaita",
                "iso2": "ML",
                "latitude": "-8.94461680",
                "longitude": "160.90712360",
                "type": "province",
                "cities": [
                    {
                        "id": 102899,
                        "name": "Auki",
                        "latitude": "-8.76778000",
                        "longitude": "160.69778000"
                    }
                ]
            },
            {
                "id": 4787,
                "name": "Rennell and Bellona",
                "iso2": "RB",
                "latitude": "-11.61314350",
                "longitude": "160.16939490",
                "type": "province",
                "cities": []
            },
            {
                "id": 4779,
                "name": "Temotu",
                "iso2": "TE",
                "latitude": "-10.68692900",
                "longitude": "166.06239790",
                "type": "province",
                "cities": [
                    {
                        "id": 102904,
                        "name": "Lata",
                        "latitude": "-10.72500000",
                        "longitude": "165.79722000"
                    }
                ]
            },
            {
                "id": 4786,
                "name": "Western",
                "iso2": "WE",
                "latitude": "-7.74998690",
                "longitude": "155.56423610",
                "type": "province",
                "cities": [
                    {
                        "id": 102901,
                        "name": "Gizo",
                        "latitude": "-8.10303000",
                        "longitude": "156.84186000"
                    }
                ]
            }
        ]
    },
    {
        "id": 203,
        "name": "Somalia",
        "iso3": "SOM",
        "iso2": "SO",
        "numeric_code": "706",
        "phonecode": "252",
        "capital": "Mogadishu",
        "currency": "SOS",
        "currency_name": "Somali shilling",
        "currency_symbol": "Sh.so.",
        "tld": ".so",
        "native": "Soomaaliya",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Somali, Somalian",
        "timezones": [
            {
                "zoneName": "Africa\/Mogadishu",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Somalia",
            "ko": "소말리아",
            "pt-BR": "Somália",
            "pt": "Somália",
            "nl": "Somalië",
            "hr": "Somalija",
            "fa": "سومالی",
            "de": "Somalia",
            "es": "Somalia",
            "fr": "Somalie",
            "ja": "ソマリア",
            "it": "Somalia",
            "zh-CN": "索马里",
            "tr": "Somali",
            "ru": "Сомали",
            "uk": "Сомалі",
            "pl": "Somalia"
        },
        "latitude": "10.00000000",
        "longitude": "49.00000000",
        "emoji": "🇸🇴",
        "emojiU": "U+1F1F8 U+1F1F4",
        "states": [
            {
                "id": 925,
                "name": "Awdal",
                "iso2": "AW",
                "latitude": "10.63342850",
                "longitude": "43.32946600",
                "type": "region",
                "cities": []
            },
            {
                "id": 917,
                "name": "Bakool",
                "iso2": "BK",
                "latitude": "4.36572210",
                "longitude": "44.09603110",
                "type": "region",
                "cities": [
                    {
                        "id": 104815,
                        "name": "Tayeeglow",
                        "latitude": "4.01897000",
                        "longitude": "44.51111000"
                    },
                    {
                        "id": 104816,
                        "name": "Waajid",
                        "latitude": "3.80958000",
                        "longitude": "43.24627000"
                    },
                    {
                        "id": 104819,
                        "name": "Xuddur",
                        "latitude": "4.12129000",
                        "longitude": "43.88945000"
                    },
                    {
                        "id": 104820,
                        "name": "Yeed",
                        "latitude": "4.55000000",
                        "longitude": "43.03333000"
                    }
                ]
            },
            {
                "id": 927,
                "name": "Banaadir",
                "iso2": "BN",
                "latitude": "2.11873750",
                "longitude": "45.33694590",
                "type": "region",
                "cities": [
                    {
                        "id": 104810,
                        "name": "Mogadishu",
                        "latitude": "2.03711000",
                        "longitude": "45.34375000"
                    }
                ]
            },
            {
                "id": 930,
                "name": "Bari",
                "iso2": "BR",
                "latitude": "41.11714320",
                "longitude": "16.87187150",
                "type": "region",
                "cities": [
                    {
                        "id": 104778,
                        "name": "Bandarbeyla",
                        "latitude": "9.49420000",
                        "longitude": "50.81220000"
                    },
                    {
                        "id": 104779,
                        "name": "Bargaal",
                        "latitude": "11.28636000",
                        "longitude": "51.07730000"
                    },
                    {
                        "id": 104781,
                        "name": "Bereeda",
                        "latitude": "11.87037000",
                        "longitude": "51.05795000"
                    },
                    {
                        "id": 104782,
                        "name": "Bosaso",
                        "latitude": "11.28421000",
                        "longitude": "49.18158000"
                    },
                    {
                        "id": 104788,
                        "name": "Caluula",
                        "latitude": "11.96611000",
                        "longitude": "50.75694000"
                    },
                    {
                        "id": 104800,
                        "name": "Iskushuban",
                        "latitude": "10.28370000",
                        "longitude": "50.23000000"
                    },
                    {
                        "id": 104812,
                        "name": "Qandala",
                        "latitude": "11.47197000",
                        "longitude": "49.87282000"
                    }
                ]
            },
            {
                "id": 926,
                "name": "Bay",
                "iso2": "BY",
                "latitude": "37.03655340",
                "longitude": "-95.61747670",
                "type": "region",
                "cities": [
                    {
                        "id": 104777,
                        "name": "Baidoa",
                        "latitude": "3.11383000",
                        "longitude": "43.64980000"
                    },
                    {
                        "id": 104786,
                        "name": "Buurhakaba",
                        "latitude": "2.80257000",
                        "longitude": "44.07805000"
                    }
                ]
            },
            {
                "id": 918,
                "name": "Galguduud",
                "iso2": "GA",
                "latitude": "5.18501280",
                "longitude": "46.82528380",
                "type": "region",
                "cities": [
                    {
                        "id": 104790,
                        "name": "Ceelbuur",
                        "latitude": "4.68501000",
                        "longitude": "46.61760000"
                    },
                    {
                        "id": 104791,
                        "name": "Ceeldheer",
                        "latitude": "3.84878000",
                        "longitude": "47.18064000"
                    },
                    {
                        "id": 104793,
                        "name": "Dhuusamarreeb",
                        "latitude": "5.53597000",
                        "longitude": "46.38666000"
                    }
                ]
            },
            {
                "id": 928,
                "name": "Gedo",
                "iso2": "GE",
                "latitude": "3.50392270",
                "longitude": "42.23624350",
                "type": "region",
                "cities": [
                    {
                        "id": 104776,
                        "name": "Baardheere",
                        "latitude": "2.34464000",
                        "longitude": "42.27644000"
                    },
                    {
                        "id": 104797,
                        "name": "Garbahaarrey",
                        "latitude": "3.32892000",
                        "longitude": "42.22091000"
                    },
                    {
                        "id": 104807,
                        "name": "Luuq",
                        "latitude": "3.80315000",
                        "longitude": "42.54417000"
                    }
                ]
            },
            {
                "id": 915,
                "name": "Hiran",
                "iso2": "HI",
                "latitude": "4.32101500",
                "longitude": "45.29938620",
                "type": "region",
                "cities": [
                    {
                        "id": 104780,
                        "name": "Beledweyne",
                        "latitude": "4.73583000",
                        "longitude": "45.20361000"
                    },
                    {
                        "id": 104784,
                        "name": "Buulobarde",
                        "latitude": "3.85375000",
                        "longitude": "45.56744000"
                    },
                    {
                        "id": 104801,
                        "name": "Jalalaqsi",
                        "latitude": "3.37660000",
                        "longitude": "45.59960000"
                    }
                ]
            },
            {
                "id": 924,
                "name": "Lower Juba",
                "iso2": "JH",
                "latitude": "0.22402100",
                "longitude": "41.60118140",
                "type": "region",
                "cities": [
                    {
                        "id": 104785,
                        "name": "Buur Gaabo",
                        "latitude": "-1.21917000",
                        "longitude": "41.83725000"
                    },
                    {
                        "id": 104802,
                        "name": "Jamaame",
                        "latitude": "0.06968000",
                        "longitude": "42.74497000"
                    },
                    {
                        "id": 104805,
                        "name": "Kismayo",
                        "latitude": "-0.35817000",
                        "longitude": "42.54536000"
                    }
                ]
            },
            {
                "id": 921,
                "name": "Lower Shebelle",
                "iso2": "SH",
                "latitude": "1.87664580",
                "longitude": "44.24790150",
                "type": "region",
                "cities": [
                    {
                        "id": 104775,
                        "name": "Afgooye",
                        "latitude": "2.13810000",
                        "longitude": "45.12120000"
                    },
                    {
                        "id": 104809,
                        "name": "Marka",
                        "latitude": "1.71594000",
                        "longitude": "44.77166000"
                    },
                    {
                        "id": 104813,
                        "name": "Qoryooley",
                        "latitude": "1.78784000",
                        "longitude": "44.52999000"
                    },
                    {
                        "id": 104817,
                        "name": "Wanlaweyn",
                        "latitude": "2.61850000",
                        "longitude": "44.89380000"
                    }
                ]
            },
            {
                "id": 922,
                "name": "Middle Juba",
                "iso2": "JD",
                "latitude": "2.07804880",
                "longitude": "41.60118140",
                "type": "region",
                "cities": [
                    {
                        "id": 104794,
                        "name": "Dujuuma",
                        "latitude": "1.25311000",
                        "longitude": "42.57377000"
                    },
                    {
                        "id": 104804,
                        "name": "Jilib",
                        "latitude": "0.48829000",
                        "longitude": "42.78535000"
                    },
                    {
                        "id": 104814,
                        "name": "Saacow",
                        "latitude": "1.62794000",
                        "longitude": "42.44067000"
                    }
                ]
            },
            {
                "id": 923,
                "name": "Middle Shebelle",
                "iso2": "SD",
                "latitude": "2.92502470",
                "longitude": "45.90396890",
                "type": "region",
                "cities": [
                    {
                        "id": 104787,
                        "name": "Cadale",
                        "latitude": "2.76030000",
                        "longitude": "46.32220000"
                    },
                    {
                        "id": 104803,
                        "name": "Jawhar",
                        "latitude": "2.78087000",
                        "longitude": "45.50048000"
                    },
                    {
                        "id": 104808,
                        "name": "Mahaddayweyne",
                        "latitude": "2.97260000",
                        "longitude": "45.53470000"
                    }
                ]
            },
            {
                "id": 916,
                "name": "Mudug",
                "iso2": "MU",
                "latitude": "6.56567260",
                "longitude": "47.76375650",
                "type": "region",
                "cities": [
                    {
                        "id": 104796,
                        "name": "Gaalkacyo",
                        "latitude": "6.76972000",
                        "longitude": "47.43083000"
                    },
                    {
                        "id": 104799,
                        "name": "Hobyo",
                        "latitude": "5.35050000",
                        "longitude": "48.52680000"
                    },
                    {
                        "id": 104818,
                        "name": "Xarardheere",
                        "latitude": "4.65440000",
                        "longitude": "47.85750000"
                    }
                ]
            },
            {
                "id": 920,
                "name": "Nugal",
                "iso2": "NU",
                "latitude": "43.27938610",
                "longitude": "17.03392050",
                "type": "region",
                "cities": [
                    {
                        "id": 104795,
                        "name": "Eyl",
                        "latitude": "7.98030000",
                        "longitude": "49.81640000"
                    },
                    {
                        "id": 104798,
                        "name": "Garoowe",
                        "latitude": "8.40207000",
                        "longitude": "48.48284000"
                    }
                ]
            },
            {
                "id": 919,
                "name": "Sanaag",
                "iso2": "SA",
                "latitude": "10.39382180",
                "longitude": "47.76375650",
                "type": "region",
                "cities": [
                    {
                        "id": 104792,
                        "name": "Ceerigaabo",
                        "latitude": "10.61616000",
                        "longitude": "47.36795000"
                    },
                    {
                        "id": 104806,
                        "name": "Las Khorey",
                        "latitude": "11.15950000",
                        "longitude": "48.19670000"
                    }
                ]
            },
            {
                "id": 929,
                "name": "Togdheer",
                "iso2": "TO",
                "latitude": "9.44605870",
                "longitude": "45.29938620",
                "type": "region",
                "cities": [
                    {
                        "id": 104783,
                        "name": "Burao",
                        "latitude": "9.52213000",
                        "longitude": "45.53363000"
                    },
                    {
                        "id": 104789,
                        "name": "Ceek",
                        "latitude": "8.99907000",
                        "longitude": "45.35824000"
                    },
                    {
                        "id": 104811,
                        "name": "Oodweyne",
                        "latitude": "9.40920000",
                        "longitude": "45.06397000"
                    }
                ]
            }
        ]
    },
    {
        "id": 204,
        "name": "South Africa",
        "iso3": "ZAF",
        "iso2": "ZA",
        "numeric_code": "710",
        "phonecode": "27",
        "capital": "Pretoria",
        "currency": "ZAR",
        "currency_name": "South African rand",
        "currency_symbol": "R",
        "tld": ".za",
        "native": "South Africa",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Southern Africa",
        "subregion_id": 5,
        "nationality": "South African",
        "timezones": [
            {
                "zoneName": "Africa\/Johannesburg",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "SAST",
                "tzName": "South African Standard Time"
            }
        ],
        "translations": {
            "br": "Suafrika",
            "ko": "남아프리카 공화국",
            "pt-BR": "República Sul-Africana",
            "pt": "República Sul-Africana",
            "nl": "Zuid-Afrika",
            "hr": "Južnoafrička Republika",
            "fa": "آفریقای جنوبی",
            "de": "Republik Südafrika",
            "es": "República de Sudáfrica",
            "fr": "Afrique du Sud",
            "ja": "南アフリカ",
            "it": "Sud Africa",
            "zh-CN": "南非",
            "tr": "Güney Afrika Cumhuriyeti",
            "ru": "Южная Африка",
            "uk": "Південна Африка",
            "pl": "Republika Południowej Afryki"
        },
        "latitude": "-29.00000000",
        "longitude": "24.00000000",
        "emoji": "🇿🇦",
        "emojiU": "U+1F1FF U+1F1E6",
        "states": [
            {
                "id": 938,
                "name": "Eastern Cape",
                "iso2": "EC",
                "latitude": "-32.29684020",
                "longitude": "26.41938900",
                "type": "province",
                "cities": [
                    {
                        "id": 131015,
                        "name": "Adelaide",
                        "latitude": "-32.70747000",
                        "longitude": "26.29564000"
                    },
                    {
                        "id": 131018,
                        "name": "Alfred Nzo District Municipality",
                        "latitude": "-30.66803000",
                        "longitude": "29.15490000"
                    },
                    {
                        "id": 131019,
                        "name": "Alice",
                        "latitude": "-32.78749000",
                        "longitude": "26.83440000"
                    },
                    {
                        "id": 131020,
                        "name": "Aliwal North",
                        "latitude": "-30.69366000",
                        "longitude": "26.71141000"
                    },
                    {
                        "id": 131023,
                        "name": "Amathole District Municipality",
                        "latitude": "-32.55895000",
                        "longitude": "27.45919000"
                    },
                    {
                        "id": 131037,
                        "name": "Bhisho",
                        "latitude": "-32.84721000",
                        "longitude": "27.44218000"
                    },
                    {
                        "id": 131052,
                        "name": "Buffalo City Metropolitan Municipality",
                        "latitude": "-32.95141000",
                        "longitude": "27.61164000"
                    },
                    {
                        "id": 131053,
                        "name": "Burgersdorp",
                        "latitude": "-30.99766000",
                        "longitude": "26.32862000"
                    },
                    {
                        "id": 131054,
                        "name": "Butterworth",
                        "latitude": "-32.33083000",
                        "longitude": "28.14981000"
                    },
                    {
                        "id": 131055,
                        "name": "Cacadu District Municipality",
                        "latitude": "-33.06583000",
                        "longitude": "24.77583000"
                    },
                    {
                        "id": 131068,
                        "name": "Chris Hani District Municipality",
                        "latitude": "-31.79033000",
                        "longitude": "26.43965000"
                    },
                    {
                        "id": 131078,
                        "name": "Cradock",
                        "latitude": "-32.16422000",
                        "longitude": "25.61918000"
                    },
                    {
                        "id": 131086,
                        "name": "Dordrecht",
                        "latitude": "-31.37200000",
                        "longitude": "27.04878000"
                    },
                    {
                        "id": 131093,
                        "name": "East London",
                        "latitude": "-33.01529000",
                        "longitude": "27.91162000"
                    },
                    {
                        "id": 131103,
                        "name": "Elliot",
                        "latitude": "-31.33333000",
                        "longitude": "27.85000000"
                    },
                    {
                        "id": 131109,
                        "name": "Fort Beaufort",
                        "latitude": "-32.77477000",
                        "longitude": "26.63376000"
                    },
                    {
                        "id": 131119,
                        "name": "Graaff-Reinet",
                        "latitude": "-32.25215000",
                        "longitude": "24.53075000"
                    },
                    {
                        "id": 131121,
                        "name": "Grahamstown",
                        "latitude": "-33.30422000",
                        "longitude": "26.53276000"
                    },
                    {
                        "id": 131133,
                        "name": "Ilinge",
                        "latitude": "-31.97676000",
                        "longitude": "27.04267000"
                    },
                    {
                        "id": 131135,
                        "name": "Joe Gqabi District Municipality",
                        "latitude": "-30.94178000",
                        "longitude": "27.06053000"
                    },
                    {
                        "id": 131141,
                        "name": "Kirkwood",
                        "latitude": "-33.39829000",
                        "longitude": "25.44279000"
                    },
                    {
                        "id": 131152,
                        "name": "Kruisfontein",
                        "latitude": "-34.00333000",
                        "longitude": "24.73142000"
                    },
                    {
                        "id": 131157,
                        "name": "Lady Frere",
                        "latitude": "-31.70312000",
                        "longitude": "27.23290000"
                    },
                    {
                        "id": 131174,
                        "name": "Middelburg",
                        "latitude": "-31.49285000",
                        "longitude": "25.00633000"
                    },
                    {
                        "id": 131182,
                        "name": "Molteno",
                        "latitude": "-31.39675000",
                        "longitude": "26.36246000"
                    },
                    {
                        "id": 131191,
                        "name": "Mthatha",
                        "latitude": "-31.58893000",
                        "longitude": "28.78443000"
                    },
                    {
                        "id": 131197,
                        "name": "Nelson Mandela Bay Metropolitan Municipality",
                        "latitude": "-33.80399000",
                        "longitude": "25.49213000"
                    },
                    {
                        "id": 131206,
                        "name": "OR Tambo District Municipality",
                        "latitude": "-31.46740000",
                        "longitude": "29.05247000"
                    },
                    {
                        "id": 131224,
                        "name": "Port Alfred",
                        "latitude": "-33.58601000",
                        "longitude": "26.88329000"
                    },
                    {
                        "id": 131225,
                        "name": "Port Elizabeth",
                        "latitude": "-33.96109000",
                        "longitude": "25.61494000"
                    },
                    {
                        "id": 131226,
                        "name": "Port Saint John’s",
                        "latitude": "-31.62291000",
                        "longitude": "29.54477000"
                    },
                    {
                        "id": 131233,
                        "name": "Queensdale",
                        "latitude": "-31.87101000",
                        "longitude": "26.97862000"
                    },
                    {
                        "id": 131234,
                        "name": "Queenstown",
                        "latitude": "-31.89756000",
                        "longitude": "26.87533000"
                    },
                    {
                        "id": 131259,
                        "name": "Somerset East",
                        "latitude": "-32.72173000",
                        "longitude": "25.58804000"
                    },
                    {
                        "id": 131266,
                        "name": "Stutterheim",
                        "latitude": "-32.57076000",
                        "longitude": "27.42396000"
                    },
                    {
                        "id": 131279,
                        "name": "Uitenhage",
                        "latitude": "-33.75757000",
                        "longitude": "25.39710000"
                    },
                    {
                        "id": 131308,
                        "name": "Whittlesea",
                        "latitude": "-32.17588000",
                        "longitude": "26.82437000"
                    },
                    {
                        "id": 131309,
                        "name": "Willowmore",
                        "latitude": "-33.29265000",
                        "longitude": "23.48954000"
                    }
                ]
            },
            {
                "id": 932,
                "name": "Free State",
                "iso2": "FS",
                "latitude": "37.68585250",
                "longitude": "-97.28112560",
                "type": "province",
                "cities": [
                    {
                        "id": 131021,
                        "name": "Allanridge",
                        "latitude": "-27.75431000",
                        "longitude": "26.64382000"
                    },
                    {
                        "id": 131036,
                        "name": "Bethlehem",
                        "latitude": "-28.23078000",
                        "longitude": "28.30707000"
                    },
                    {
                        "id": 131038,
                        "name": "Bloemfontein",
                        "latitude": "-29.12107000",
                        "longitude": "26.21400000"
                    },
                    {
                        "id": 131043,
                        "name": "Bothaville",
                        "latitude": "-27.38870000",
                        "longitude": "26.61701000"
                    },
                    {
                        "id": 131044,
                        "name": "Botshabelo",
                        "latitude": "-29.26737000",
                        "longitude": "26.72595000"
                    },
                    {
                        "id": 131046,
                        "name": "Brandfort",
                        "latitude": "-28.70008000",
                        "longitude": "26.45968000"
                    },
                    {
                        "id": 131075,
                        "name": "Clocolan",
                        "latitude": "-28.91367000",
                        "longitude": "27.56555000"
                    },
                    {
                        "id": 131084,
                        "name": "Deneysville",
                        "latitude": "-26.89080000",
                        "longitude": "28.09707000"
                    },
                    {
                        "id": 131107,
                        "name": "Fezile Dabi District Municipality",
                        "latitude": "-27.33918000",
                        "longitude": "27.71927000"
                    },
                    {
                        "id": 131111,
                        "name": "Frankfort",
                        "latitude": "-27.27888000",
                        "longitude": "28.49696000"
                    },
                    {
                        "id": 131124,
                        "name": "Harrismith",
                        "latitude": "-28.27276000",
                        "longitude": "29.12946000"
                    },
                    {
                        "id": 131126,
                        "name": "Heilbron",
                        "latitude": "-27.28115000",
                        "longitude": "27.97090000"
                    },
                    {
                        "id": 131128,
                        "name": "Hennenman",
                        "latitude": "-27.97654000",
                        "longitude": "27.02423000"
                    },
                    {
                        "id": 131131,
                        "name": "Hoopstad",
                        "latitude": "-27.83273000",
                        "longitude": "25.90833000"
                    },
                    {
                        "id": 131146,
                        "name": "Koppies",
                        "latitude": "-27.24179000",
                        "longitude": "27.57422000"
                    },
                    {
                        "id": 131150,
                        "name": "Kroonstad",
                        "latitude": "-27.65036000",
                        "longitude": "27.23488000"
                    },
                    {
                        "id": 131154,
                        "name": "Kutloanong",
                        "latitude": "-27.83333000",
                        "longitude": "26.75000000"
                    },
                    {
                        "id": 131158,
                        "name": "Ladybrand",
                        "latitude": "-29.19448000",
                        "longitude": "27.45739000"
                    },
                    {
                        "id": 131161,
                        "name": "Lejweleputswa District Municipality",
                        "latitude": "-28.23982000",
                        "longitude": "26.12649000"
                    },
                    {
                        "id": 131163,
                        "name": "Lindley",
                        "latitude": "-27.87910000",
                        "longitude": "27.91348000"
                    },
                    {
                        "id": 131170,
                        "name": "Mangaung Metropolitan Municipality",
                        "latitude": "-29.15627000",
                        "longitude": "26.35116000"
                    },
                    {
                        "id": 131173,
                        "name": "Marquard",
                        "latitude": "-28.66449000",
                        "longitude": "27.43048000"
                    },
                    {
                        "id": 131214,
                        "name": "Parys",
                        "latitude": "-26.90330000",
                        "longitude": "27.45727000"
                    },
                    {
                        "id": 131216,
                        "name": "Phuthaditjhaba",
                        "latitude": "-28.52423000",
                        "longitude": "28.81582000"
                    },
                    {
                        "id": 131237,
                        "name": "Reitz",
                        "latitude": "-27.80138000",
                        "longitude": "28.42726000"
                    },
                    {
                        "id": 131249,
                        "name": "Sasolburg",
                        "latitude": "-26.81358000",
                        "longitude": "27.81695000"
                    },
                    {
                        "id": 131255,
                        "name": "Senekal",
                        "latitude": "-28.31971000",
                        "longitude": "27.62082000"
                    },
                    {
                        "id": 131271,
                        "name": "Thaba Nchu",
                        "latitude": "-29.20932000",
                        "longitude": "26.83898000"
                    },
                    {
                        "id": 131273,
                        "name": "Thabo Mofutsanyana District Municipality",
                        "latitude": "-28.24378000",
                        "longitude": "28.34077000"
                    },
                    {
                        "id": 131274,
                        "name": "Theunissen",
                        "latitude": "-28.41098000",
                        "longitude": "26.70107000"
                    },
                    {
                        "id": 131285,
                        "name": "Ventersburg",
                        "latitude": "-28.08561000",
                        "longitude": "27.13814000"
                    },
                    {
                        "id": 131288,
                        "name": "Viljoenskroon",
                        "latitude": "-27.20841000",
                        "longitude": "26.94855000"
                    },
                    {
                        "id": 131289,
                        "name": "Villiers",
                        "latitude": "-27.03026000",
                        "longitude": "28.60061000"
                    },
                    {
                        "id": 131290,
                        "name": "Virginia",
                        "latitude": "-28.10391000",
                        "longitude": "26.86593000"
                    },
                    {
                        "id": 131292,
                        "name": "Vrede",
                        "latitude": "-27.42573000",
                        "longitude": "29.16585000"
                    },
                    {
                        "id": 131293,
                        "name": "Vredefort",
                        "latitude": "-27.00805000",
                        "longitude": "27.36460000"
                    },
                    {
                        "id": 131301,
                        "name": "Welkom",
                        "latitude": "-27.97742000",
                        "longitude": "26.73506000"
                    },
                    {
                        "id": 131303,
                        "name": "Wesselsbron",
                        "latitude": "-27.85490000",
                        "longitude": "26.36583000"
                    },
                    {
                        "id": 131310,
                        "name": "Winburg",
                        "latitude": "-28.51805000",
                        "longitude": "27.00933000"
                    },
                    {
                        "id": 131314,
                        "name": "Xhariep District Municipality",
                        "latitude": "-29.84311000",
                        "longitude": "25.83286000"
                    },
                    {
                        "id": 131315,
                        "name": "Zastron",
                        "latitude": "-30.30225000",
                        "longitude": "27.08395000"
                    }
                ]
            },
            {
                "id": 936,
                "name": "Gauteng",
                "iso2": "GP",
                "latitude": "-26.27075930",
                "longitude": "28.11226790",
                "type": "province",
                "cities": [
                    {
                        "id": 131017,
                        "name": "Alberton",
                        "latitude": "-26.26786000",
                        "longitude": "28.12225000"
                    },
                    {
                        "id": 131032,
                        "name": "Benoni",
                        "latitude": "-26.18848000",
                        "longitude": "28.32078000"
                    },
                    {
                        "id": 131042,
                        "name": "Boksburg",
                        "latitude": "-26.21197000",
                        "longitude": "28.25958000"
                    },
                    {
                        "id": 131045,
                        "name": "Brakpan",
                        "latitude": "-26.23656000",
                        "longitude": "28.36938000"
                    },
                    {
                        "id": 131051,
                        "name": "Bronkhorstspruit",
                        "latitude": "-25.81015000",
                        "longitude": "28.74248000"
                    },
                    {
                        "id": 131062,
                        "name": "Carletonville",
                        "latitude": "-26.36094000",
                        "longitude": "27.39767000"
                    },
                    {
                        "id": 131066,
                        "name": "Centurion",
                        "latitude": "-25.85891000",
                        "longitude": "28.18577000"
                    },
                    {
                        "id": 131071,
                        "name": "City of Johannesburg Metropolitan Municipality",
                        "latitude": "-26.17673000",
                        "longitude": "27.96353000"
                    },
                    {
                        "id": 131072,
                        "name": "City of Tshwane Metropolitan Municipality",
                        "latitude": "-25.65985000",
                        "longitude": "28.44343000"
                    },
                    {
                        "id": 131079,
                        "name": "Cullinan",
                        "latitude": "-25.67088000",
                        "longitude": "28.52364000"
                    },
                    {
                        "id": 131085,
                        "name": "Diepsloot",
                        "latitude": "-25.93312000",
                        "longitude": "28.01213000"
                    },
                    {
                        "id": 131094,
                        "name": "Eastleigh",
                        "latitude": "-26.12965000",
                        "longitude": "28.15541000"
                    },
                    {
                        "id": 131096,
                        "name": "Eden Glen",
                        "latitude": "-26.13230000",
                        "longitude": "28.16859000"
                    },
                    {
                        "id": 131097,
                        "name": "Eden Glen Ext 60",
                        "latitude": "-26.12593000",
                        "longitude": "28.16500000"
                    },
                    {
                        "id": 131098,
                        "name": "Edenvale",
                        "latitude": "-26.14095000",
                        "longitude": "28.15247000"
                    },
                    {
                        "id": 131100,
                        "name": "Ekangala",
                        "latitude": "-25.69619000",
                        "longitude": "28.74918000"
                    },
                    {
                        "id": 131101,
                        "name": "Ekurhuleni Metropolitan Municipality",
                        "latitude": "-26.19890000",
                        "longitude": "28.31262000"
                    },
                    {
                        "id": 131125,
                        "name": "Heidelberg",
                        "latitude": "-26.50476000",
                        "longitude": "28.35921000"
                    },
                    {
                        "id": 131136,
                        "name": "Johannesburg",
                        "latitude": "-26.20227000",
                        "longitude": "28.04363000"
                    },
                    {
                        "id": 131151,
                        "name": "Krugersdorp",
                        "latitude": "-26.08577000",
                        "longitude": "27.77515000"
                    },
                    {
                        "id": 131166,
                        "name": "Mabopane",
                        "latitude": "-25.49768000",
                        "longitude": "28.10065000"
                    },
                    {
                        "id": 131176,
                        "name": "Midrand",
                        "latitude": "-25.98953000",
                        "longitude": "28.12843000"
                    },
                    {
                        "id": 131177,
                        "name": "Midstream",
                        "latitude": "-25.91849000",
                        "longitude": "28.19881000"
                    },
                    {
                        "id": 131179,
                        "name": "Modderfontein",
                        "latitude": "-26.08909000",
                        "longitude": "28.16534000"
                    },
                    {
                        "id": 131193,
                        "name": "Muldersdriseloop",
                        "latitude": "-26.03673000",
                        "longitude": "27.83798000"
                    },
                    {
                        "id": 131202,
                        "name": "Nigel",
                        "latitude": "-26.43138000",
                        "longitude": "28.47713000"
                    },
                    {
                        "id": 131207,
                        "name": "Orange Farm",
                        "latitude": "-26.48333000",
                        "longitude": "27.86667000"
                    },
                    {
                        "id": 131230,
                        "name": "Pretoria",
                        "latitude": "-25.74486000",
                        "longitude": "28.18783000"
                    },
                    {
                        "id": 131235,
                        "name": "Randburg",
                        "latitude": "-26.09410000",
                        "longitude": "28.00123000"
                    },
                    {
                        "id": 131236,
                        "name": "Randfontein",
                        "latitude": "-26.18440000",
                        "longitude": "27.70203000"
                    },
                    {
                        "id": 131245,
                        "name": "Roodepoort",
                        "latitude": "-26.16250000",
                        "longitude": "27.87250000"
                    },
                    {
                        "id": 131253,
                        "name": "Sedibeng District Municipality",
                        "latitude": "-26.56686000",
                        "longitude": "28.18277000"
                    },
                    {
                        "id": 131260,
                        "name": "Soweto",
                        "latitude": "-26.26781000",
                        "longitude": "27.85849000"
                    },
                    {
                        "id": 131262,
                        "name": "Springs",
                        "latitude": "-26.25000000",
                        "longitude": "28.40000000"
                    },
                    {
                        "id": 131270,
                        "name": "Tembisa",
                        "latitude": "-25.99636000",
                        "longitude": "28.22680000"
                    },
                    {
                        "id": 131284,
                        "name": "Vanderbijlpark",
                        "latitude": "-26.71171000",
                        "longitude": "27.83795000"
                    },
                    {
                        "id": 131286,
                        "name": "Vereeniging",
                        "latitude": "-26.67313000",
                        "longitude": "27.92615000"
                    },
                    {
                        "id": 131305,
                        "name": "West Rand District Municipality",
                        "latitude": "-26.24565000",
                        "longitude": "27.55538000"
                    },
                    {
                        "id": 131306,
                        "name": "Westonaria",
                        "latitude": "-26.31905000",
                        "longitude": "27.64860000"
                    }
                ]
            },
            {
                "id": 935,
                "name": "KwaZulu-Natal",
                "iso2": "KZN",
                "latitude": "-28.53055390",
                "longitude": "30.89582420",
                "type": "province",
                "cities": [
                    {
                        "id": 131022,
                        "name": "Amajuba District Municipality",
                        "latitude": "-27.73558000",
                        "longitude": "30.13537000"
                    },
                    {
                        "id": 131027,
                        "name": "Ballito",
                        "latitude": "-29.53897000",
                        "longitude": "31.21439000"
                    },
                    {
                        "id": 131033,
                        "name": "Berea",
                        "latitude": "-29.85185000",
                        "longitude": "30.99337000"
                    },
                    {
                        "id": 131091,
                        "name": "Dundee",
                        "latitude": "-28.16678000",
                        "longitude": "30.23371000"
                    },
                    {
                        "id": 131092,
                        "name": "Durban",
                        "latitude": "-29.85790000",
                        "longitude": "31.02920000"
                    },
                    {
                        "id": 131102,
                        "name": "Ekuvukeni",
                        "latitude": "-28.46752000",
                        "longitude": "30.15513000"
                    },
                    {
                        "id": 131320,
                        "name": "eMkhomazi",
                        "latitude": "-30.20674000",
                        "longitude": "30.79776000"
                    },
                    {
                        "id": 131104,
                        "name": "Empangeni",
                        "latitude": "-28.76197000",
                        "longitude": "31.89329000"
                    },
                    {
                        "id": 131106,
                        "name": "Eshowe",
                        "latitude": "-28.88649000",
                        "longitude": "31.46990000"
                    },
                    {
                        "id": 131321,
                        "name": "eSikhaleni",
                        "latitude": "-28.87097000",
                        "longitude": "31.89961000"
                    },
                    {
                        "id": 131322,
                        "name": "eThekwini Metropolitan Municipality",
                        "latitude": "-29.86670000",
                        "longitude": "31.01670000"
                    },
                    {
                        "id": 131118,
                        "name": "Glencoe",
                        "latitude": "-28.17827000",
                        "longitude": "30.14702000"
                    },
                    {
                        "id": 131122,
                        "name": "Greytown",
                        "latitude": "-29.06415000",
                        "longitude": "30.59279000"
                    },
                    {
                        "id": 131130,
                        "name": "Hluhluwe",
                        "latitude": "-28.01895000",
                        "longitude": "32.26762000"
                    },
                    {
                        "id": 131132,
                        "name": "Howick",
                        "latitude": "-29.47795000",
                        "longitude": "30.23057000"
                    },
                    {
                        "id": 131323,
                        "name": "iLembe District Municipality",
                        "latitude": "-29.27326000",
                        "longitude": "31.14253000"
                    },
                    {
                        "id": 131144,
                        "name": "Kokstad",
                        "latitude": "-30.54723000",
                        "longitude": "29.42412000"
                    },
                    {
                        "id": 131155,
                        "name": "KwaDukuza",
                        "latitude": "-29.32816000",
                        "longitude": "31.28954000"
                    },
                    {
                        "id": 131172,
                        "name": "Margate",
                        "latitude": "-30.86360000",
                        "longitude": "30.37052000"
                    },
                    {
                        "id": 131183,
                        "name": "Mondlo",
                        "latitude": "-27.98299000",
                        "longitude": "30.71769000"
                    },
                    {
                        "id": 131185,
                        "name": "Mooirivier",
                        "latitude": "-29.20824000",
                        "longitude": "29.99460000"
                    },
                    {
                        "id": 131189,
                        "name": "Mpophomeni",
                        "latitude": "-29.56822000",
                        "longitude": "30.18618000"
                    },
                    {
                        "id": 131190,
                        "name": "Mpumalanga",
                        "latitude": "-29.81292000",
                        "longitude": "30.63646000"
                    },
                    {
                        "id": 131192,
                        "name": "Mtubatuba",
                        "latitude": "-28.41789000",
                        "longitude": "32.18483000"
                    },
                    {
                        "id": 131196,
                        "name": "Ndwedwe",
                        "latitude": "-29.51686000",
                        "longitude": "30.92687000"
                    },
                    {
                        "id": 131199,
                        "name": "Newcastle",
                        "latitude": "-27.75796000",
                        "longitude": "29.93180000"
                    },
                    {
                        "id": 131218,
                        "name": "Pietermaritzburg",
                        "latitude": "-29.61679000",
                        "longitude": "30.39278000"
                    },
                    {
                        "id": 131227,
                        "name": "Port Shepstone",
                        "latitude": "-30.74137000",
                        "longitude": "30.45499000"
                    },
                    {
                        "id": 131239,
                        "name": "Richards Bay",
                        "latitude": "-28.78301000",
                        "longitude": "32.03768000"
                    },
                    {
                        "id": 131240,
                        "name": "Richmond",
                        "latitude": "-29.87196000",
                        "longitude": "30.27235000"
                    },
                    {
                        "id": 131251,
                        "name": "Scottburgh",
                        "latitude": "-30.28666000",
                        "longitude": "30.75316000"
                    },
                    {
                        "id": 131256,
                        "name": "Sisonke District Municipality",
                        "latitude": "-30.11082000",
                        "longitude": "29.66009000"
                    },
                    {
                        "id": 131267,
                        "name": "Sundumbili",
                        "latitude": "-29.13371000",
                        "longitude": "31.39752000"
                    },
                    {
                        "id": 131278,
                        "name": "Ugu District Municipality",
                        "latitude": "-30.54365000",
                        "longitude": "30.27480000"
                    },
                    {
                        "id": 131280,
                        "name": "Ulundi",
                        "latitude": "-28.33523000",
                        "longitude": "31.41617000"
                    },
                    {
                        "id": 131324,
                        "name": "uMgungundlovu",
                        "latitude": "-29.50927000",
                        "longitude": "30.19838000"
                    },
                    {
                        "id": 131325,
                        "name": "uMkhanyakude District Municipality",
                        "latitude": "-27.62236000",
                        "longitude": "32.32945000"
                    },
                    {
                        "id": 131326,
                        "name": "uMzinyathi District Municipality",
                        "latitude": "-28.58570000",
                        "longitude": "30.55883000"
                    },
                    {
                        "id": 131327,
                        "name": "uThukela District Municipality",
                        "latitude": "-28.71920000",
                        "longitude": "29.65799000"
                    },
                    {
                        "id": 131328,
                        "name": "uThungulu District Municipality",
                        "latitude": "-28.70046000",
                        "longitude": "31.51527000"
                    },
                    {
                        "id": 131282,
                        "name": "Utrecht",
                        "latitude": "-27.65862000",
                        "longitude": "30.32166000"
                    },
                    {
                        "id": 131297,
                        "name": "Vryheid",
                        "latitude": "-27.76952000",
                        "longitude": "30.79165000"
                    },
                    {
                        "id": 131318,
                        "name": "Zululand District Municipality",
                        "latitude": "-27.81139000",
                        "longitude": "31.29426000"
                    }
                ]
            },
            {
                "id": 933,
                "name": "Limpopo",
                "iso2": "LP",
                "latitude": "-23.40129460",
                "longitude": "29.41793240",
                "type": "province",
                "cities": [
                    {
                        "id": 131040,
                        "name": "Bochum",
                        "latitude": "-23.28609000",
                        "longitude": "29.13964000"
                    },
                    {
                        "id": 131061,
                        "name": "Capricorn District Municipality",
                        "latitude": "-23.48163000",
                        "longitude": "29.18350000"
                    },
                    {
                        "id": 131090,
                        "name": "Duiwelskloof",
                        "latitude": "-23.69339000",
                        "longitude": "30.14002000"
                    },
                    {
                        "id": 131113,
                        "name": "Ga-Kgapane",
                        "latitude": "-23.64378000",
                        "longitude": "30.22324000"
                    },
                    {
                        "id": 131117,
                        "name": "Giyani",
                        "latitude": "-23.30246000",
                        "longitude": "30.71868000"
                    },
                    {
                        "id": 131160,
                        "name": "Lebowakgomo",
                        "latitude": "-24.20000000",
                        "longitude": "29.50000000"
                    },
                    {
                        "id": 131164,
                        "name": "Louis Trichardt",
                        "latitude": "-23.04385000",
                        "longitude": "29.90319000"
                    },
                    {
                        "id": 131171,
                        "name": "Mankoeng",
                        "latitude": "-23.90000000",
                        "longitude": "29.81667000"
                    },
                    {
                        "id": 131180,
                        "name": "Modimolle",
                        "latitude": "-24.70000000",
                        "longitude": "28.40000000"
                    },
                    {
                        "id": 131181,
                        "name": "Mokopane",
                        "latitude": "-24.19436000",
                        "longitude": "29.00974000"
                    },
                    {
                        "id": 131187,
                        "name": "Mopani District Municipality",
                        "latitude": "-23.76661000",
                        "longitude": "30.83600000"
                    },
                    {
                        "id": 131194,
                        "name": "Musina",
                        "latitude": "-22.34881000",
                        "longitude": "30.04074000"
                    },
                    {
                        "id": 131204,
                        "name": "Nkowakowa",
                        "latitude": "-23.88782000",
                        "longitude": "30.28708000"
                    },
                    {
                        "id": 131215,
                        "name": "Phalaborwa",
                        "latitude": "-23.94299000",
                        "longitude": "31.14107000"
                    },
                    {
                        "id": 131223,
                        "name": "Polokwane",
                        "latitude": "-23.90449000",
                        "longitude": "29.46885000"
                    },
                    {
                        "id": 131254,
                        "name": "Sekhukhune District Municipality",
                        "latitude": "-24.82806000",
                        "longitude": "29.83803000"
                    },
                    {
                        "id": 131272,
                        "name": "Thabazimbi",
                        "latitude": "-24.59165000",
                        "longitude": "27.41155000"
                    },
                    {
                        "id": 131275,
                        "name": "Thohoyandou",
                        "latitude": "-22.94564000",
                        "longitude": "30.48497000"
                    },
                    {
                        "id": 131276,
                        "name": "Thulamahashi",
                        "latitude": "-24.72459000",
                        "longitude": "31.19939000"
                    },
                    {
                        "id": 131277,
                        "name": "Tzaneen",
                        "latitude": "-23.83322000",
                        "longitude": "30.16351000"
                    },
                    {
                        "id": 131287,
                        "name": "Vhembe District Municipality",
                        "latitude": "-22.75467000",
                        "longitude": "30.19360000"
                    },
                    {
                        "id": 131298,
                        "name": "Warmbaths",
                        "latitude": "-24.88333000",
                        "longitude": "28.28333000"
                    },
                    {
                        "id": 131300,
                        "name": "Waterberg District Municipality",
                        "latitude": "-24.20514000",
                        "longitude": "27.97870000"
                    }
                ]
            },
            {
                "id": 937,
                "name": "Mpumalanga",
                "iso2": "MP",
                "latitude": "-25.56533600",
                "longitude": "30.52790960",
                "type": "province",
                "cities": [
                    {
                        "id": 131026,
                        "name": "Balfour",
                        "latitude": "-26.66331000",
                        "longitude": "28.59016000"
                    },
                    {
                        "id": 131028,
                        "name": "Barberton",
                        "latitude": "-25.78842000",
                        "longitude": "31.05319000"
                    },
                    {
                        "id": 131031,
                        "name": "Belfast",
                        "latitude": "-25.68991000",
                        "longitude": "30.03504000"
                    },
                    {
                        "id": 131035,
                        "name": "Bethal",
                        "latitude": "-26.45794000",
                        "longitude": "29.46553000"
                    },
                    {
                        "id": 131049,
                        "name": "Breyten",
                        "latitude": "-26.30176000",
                        "longitude": "29.98696000"
                    },
                    {
                        "id": 131064,
                        "name": "Carolina",
                        "latitude": "-26.06927000",
                        "longitude": "30.11489000"
                    },
                    {
                        "id": 131083,
                        "name": "Delmas",
                        "latitude": "-26.14660000",
                        "longitude": "28.68322000"
                    },
                    {
                        "id": 131089,
                        "name": "Driefontein",
                        "latitude": "-27.01770000",
                        "longitude": "30.44979000"
                    },
                    {
                        "id": 131099,
                        "name": "Ehlanzeni District",
                        "latitude": "-25.35100000",
                        "longitude": "31.36100000"
                    },
                    {
                        "id": 131319,
                        "name": "eMbalenhle",
                        "latitude": "-26.53333000",
                        "longitude": "29.06667000"
                    },
                    {
                        "id": 131105,
                        "name": "Ermelo",
                        "latitude": "-26.53333000",
                        "longitude": "29.98333000"
                    },
                    {
                        "id": 131116,
                        "name": "Gert Sibande District Municipality",
                        "latitude": "-26.67100000",
                        "longitude": "29.92953000"
                    },
                    {
                        "id": 131127,
                        "name": "Hendrina",
                        "latitude": "-26.15881000",
                        "longitude": "29.71528000"
                    },
                    {
                        "id": 131145,
                        "name": "Komatipoort",
                        "latitude": "-25.43321000",
                        "longitude": "31.95478000"
                    },
                    {
                        "id": 131149,
                        "name": "Kriel",
                        "latitude": "-26.27391000",
                        "longitude": "29.22530000"
                    },
                    {
                        "id": 131165,
                        "name": "Lydenburg",
                        "latitude": "-25.09598000",
                        "longitude": "30.44393000"
                    },
                    {
                        "id": 131175,
                        "name": "Middelburg",
                        "latitude": "-25.77507000",
                        "longitude": "29.46482000"
                    },
                    {
                        "id": 131198,
                        "name": "Nelspruit",
                        "latitude": "-25.47448000",
                        "longitude": "30.97033000"
                    },
                    {
                        "id": 131203,
                        "name": "Nkangala District Municipality",
                        "latitude": "-25.71222000",
                        "longitude": "29.42431000"
                    },
                    {
                        "id": 131217,
                        "name": "Piet Retief",
                        "latitude": "-27.00706000",
                        "longitude": "30.81323000"
                    },
                    {
                        "id": 131252,
                        "name": "Secunda",
                        "latitude": "-26.55000000",
                        "longitude": "29.16667000"
                    },
                    {
                        "id": 131257,
                        "name": "Siyabuswa",
                        "latitude": "-25.11319000",
                        "longitude": "29.04454000"
                    },
                    {
                        "id": 131263,
                        "name": "Standerton",
                        "latitude": "-26.93366000",
                        "longitude": "29.24152000"
                    },
                    {
                        "id": 131291,
                        "name": "Volksrust",
                        "latitude": "-27.36541000",
                        "longitude": "29.88175000"
                    },
                    {
                        "id": 131307,
                        "name": "White River",
                        "latitude": "-25.33177000",
                        "longitude": "31.01166000"
                    },
                    {
                        "id": 131311,
                        "name": "Witbank",
                        "latitude": "-25.87133000",
                        "longitude": "29.23323000"
                    }
                ]
            },
            {
                "id": 934,
                "name": "North West",
                "iso2": "NW",
                "latitude": "32.75885200",
                "longitude": "-97.32880600",
                "type": "province",
                "cities": [
                    {
                        "id": 131039,
                        "name": "Bloemhof",
                        "latitude": "-27.64685000",
                        "longitude": "25.60697000"
                    },
                    {
                        "id": 131041,
                        "name": "Bojanala Platinum District Municipality",
                        "latitude": "-25.42612000",
                        "longitude": "27.22430000"
                    },
                    {
                        "id": 131050,
                        "name": "Brits",
                        "latitude": "-25.63473000",
                        "longitude": "27.78022000"
                    },
                    {
                        "id": 131069,
                        "name": "Christiana",
                        "latitude": "-27.91402000",
                        "longitude": "25.16111000"
                    },
                    {
                        "id": 131087,
                        "name": "Dr Kenneth Kaunda District Municipality",
                        "latitude": "-26.80678000",
                        "longitude": "26.56926000"
                    },
                    {
                        "id": 131088,
                        "name": "Dr Ruth Segomotsi Mompati District Municipality",
                        "latitude": "-26.63765000",
                        "longitude": "24.27462000"
                    },
                    {
                        "id": 131108,
                        "name": "Fochville",
                        "latitude": "-26.48862000",
                        "longitude": "27.49387000"
                    },
                    {
                        "id": 131114,
                        "name": "Ga-Rankuwa",
                        "latitude": "-25.61692000",
                        "longitude": "27.99471000"
                    },
                    {
                        "id": 131134,
                        "name": "Jan Kempdorp",
                        "latitude": "-27.92246000",
                        "longitude": "24.83051000"
                    },
                    {
                        "id": 131142,
                        "name": "Klerksdorp",
                        "latitude": "-26.85213000",
                        "longitude": "26.66672000"
                    },
                    {
                        "id": 131147,
                        "name": "Koster",
                        "latitude": "-25.86301000",
                        "longitude": "26.89756000"
                    },
                    {
                        "id": 131162,
                        "name": "Lichtenburg",
                        "latitude": "-26.15200000",
                        "longitude": "26.15968000"
                    },
                    {
                        "id": 131167,
                        "name": "Mahikeng",
                        "latitude": "-25.86522000",
                        "longitude": "25.64421000"
                    },
                    {
                        "id": 131168,
                        "name": "Maile",
                        "latitude": "-25.44152000",
                        "longitude": "27.28165000"
                    },
                    {
                        "id": 131178,
                        "name": "Mmabatho",
                        "latitude": "-25.85000000",
                        "longitude": "25.63333000"
                    },
                    {
                        "id": 131201,
                        "name": "Ngaka Modiri Molema District Municipality",
                        "latitude": "-25.95559000",
                        "longitude": "25.80782000"
                    },
                    {
                        "id": 131209,
                        "name": "Orkney",
                        "latitude": "-26.98023000",
                        "longitude": "26.67272000"
                    },
                    {
                        "id": 131229,
                        "name": "Potchefstroom",
                        "latitude": "-26.71667000",
                        "longitude": "27.10000000"
                    },
                    {
                        "id": 131247,
                        "name": "Rustenburg",
                        "latitude": "-25.66756000",
                        "longitude": "27.24208000"
                    },
                    {
                        "id": 131250,
                        "name": "Schweizer-Reneke",
                        "latitude": "-27.18871000",
                        "longitude": "25.32931000"
                    },
                    {
                        "id": 131265,
                        "name": "Stilfontein",
                        "latitude": "-26.84493000",
                        "longitude": "26.76829000"
                    },
                    {
                        "id": 131296,
                        "name": "Vryburg",
                        "latitude": "-26.95659000",
                        "longitude": "24.72840000"
                    },
                    {
                        "id": 131312,
                        "name": "Wolmaransstad",
                        "latitude": "-27.19740000",
                        "longitude": "25.98311000"
                    },
                    {
                        "id": 131316,
                        "name": "Zeerust",
                        "latitude": "-25.53695000",
                        "longitude": "26.07512000"
                    }
                ]
            },
            {
                "id": 931,
                "name": "Northern Cape",
                "iso2": "NC",
                "latitude": "-29.04668080",
                "longitude": "21.85685860",
                "type": "province",
                "cities": [
                    {
                        "id": 131029,
                        "name": "Barkly West",
                        "latitude": "-28.53537000",
                        "longitude": "24.52151000"
                    },
                    {
                        "id": 131047,
                        "name": "Brandvlei",
                        "latitude": "-30.46532000",
                        "longitude": "20.48659000"
                    },
                    {
                        "id": 131058,
                        "name": "Calvinia",
                        "latitude": "-31.47069000",
                        "longitude": "19.77601000"
                    },
                    {
                        "id": 131063,
                        "name": "Carnarvon",
                        "latitude": "-30.96827000",
                        "longitude": "22.13303000"
                    },
                    {
                        "id": 131076,
                        "name": "Colesberg",
                        "latitude": "-30.71999000",
                        "longitude": "25.09718000"
                    },
                    {
                        "id": 131080,
                        "name": "Daniëlskuil",
                        "latitude": "-28.18873000",
                        "longitude": "23.53951000"
                    },
                    {
                        "id": 131081,
                        "name": "De Aar",
                        "latitude": "-30.64966000",
                        "longitude": "24.01230000"
                    },
                    {
                        "id": 131110,
                        "name": "Frances Baard District Municipality",
                        "latitude": "-28.30003000",
                        "longitude": "24.38188000"
                    },
                    {
                        "id": 131112,
                        "name": "Fraserburg",
                        "latitude": "-31.91566000",
                        "longitude": "21.51335000"
                    },
                    {
                        "id": 131137,
                        "name": "John Taolo Gaetsewe District Municipality",
                        "latitude": "-27.04549000",
                        "longitude": "23.04706000"
                    },
                    {
                        "id": 131138,
                        "name": "Kathu",
                        "latitude": "-27.69569000",
                        "longitude": "23.04929000"
                    },
                    {
                        "id": 131139,
                        "name": "Kenhardt",
                        "latitude": "-29.34574000",
                        "longitude": "21.15786000"
                    },
                    {
                        "id": 131140,
                        "name": "Kimberley",
                        "latitude": "-28.73226000",
                        "longitude": "24.76232000"
                    },
                    {
                        "id": 131153,
                        "name": "Kuruman",
                        "latitude": "-27.45240000",
                        "longitude": "23.43246000"
                    },
                    {
                        "id": 131195,
                        "name": "Namakwa District Municipality",
                        "latitude": "-30.53561000",
                        "longitude": "19.42892000"
                    },
                    {
                        "id": 131205,
                        "name": "Noupoort",
                        "latitude": "-31.18736000",
                        "longitude": "24.94991000"
                    },
                    {
                        "id": 131208,
                        "name": "Orania",
                        "latitude": "-29.81381000",
                        "longitude": "24.41205000"
                    },
                    {
                        "id": 131213,
                        "name": "Pampierstad",
                        "latitude": "-27.78324000",
                        "longitude": "24.68768000"
                    },
                    {
                        "id": 131220,
                        "name": "Pixley ka Seme District Municipality",
                        "latitude": "-30.28920000",
                        "longitude": "23.25818000"
                    },
                    {
                        "id": 131222,
                        "name": "Pofadder",
                        "latitude": "-29.12830000",
                        "longitude": "19.39492000"
                    },
                    {
                        "id": 131228,
                        "name": "Postmasburg",
                        "latitude": "-28.33392000",
                        "longitude": "23.06541000"
                    },
                    {
                        "id": 131231,
                        "name": "Prieska",
                        "latitude": "-29.66803000",
                        "longitude": "22.74251000"
                    },
                    {
                        "id": 131241,
                        "name": "Ritchie",
                        "latitude": "-29.03801000",
                        "longitude": "24.60278000"
                    },
                    {
                        "id": 131258,
                        "name": "Siyanda District Municipality",
                        "latitude": "-28.00013000",
                        "longitude": "21.18459000"
                    },
                    {
                        "id": 131261,
                        "name": "Springbok",
                        "latitude": "-29.66434000",
                        "longitude": "17.88650000"
                    },
                    {
                        "id": 131281,
                        "name": "Upington",
                        "latitude": "-28.44776000",
                        "longitude": "21.25612000"
                    },
                    {
                        "id": 131283,
                        "name": "Van Wyksvlei",
                        "latitude": "-30.35101000",
                        "longitude": "21.82498000"
                    },
                    {
                        "id": 131299,
                        "name": "Warrenton",
                        "latitude": "-28.11396000",
                        "longitude": "24.84753000"
                    }
                ]
            },
            {
                "id": 939,
                "name": "Western Cape",
                "iso2": "WC",
                "latitude": "-33.22779180",
                "longitude": "21.85685860",
                "type": "province",
                "cities": [
                    {
                        "id": 131016,
                        "name": "Albertina",
                        "latitude": "-34.20544000",
                        "longitude": "21.58001000"
                    },
                    {
                        "id": 131024,
                        "name": "Arniston",
                        "latitude": "-34.66739000",
                        "longitude": "20.23086000"
                    },
                    {
                        "id": 131025,
                        "name": "Atlantis",
                        "latitude": "-33.56668000",
                        "longitude": "18.48335000"
                    },
                    {
                        "id": 131030,
                        "name": "Beaufort West",
                        "latitude": "-32.35671000",
                        "longitude": "22.58295000"
                    },
                    {
                        "id": 131034,
                        "name": "Bergvliet",
                        "latitude": "-34.04746000",
                        "longitude": "18.45250000"
                    },
                    {
                        "id": 131048,
                        "name": "Bredasdorp",
                        "latitude": "-34.53215000",
                        "longitude": "20.04031000"
                    },
                    {
                        "id": 131056,
                        "name": "Caledon",
                        "latitude": "-34.22997000",
                        "longitude": "19.42650000"
                    },
                    {
                        "id": 131057,
                        "name": "Calitzdorp",
                        "latitude": "-33.52755000",
                        "longitude": "21.67620000"
                    },
                    {
                        "id": 131059,
                        "name": "Cape Town",
                        "latitude": "-33.92584000",
                        "longitude": "18.42322000"
                    },
                    {
                        "id": 131060,
                        "name": "Cape Winelands District Municipality",
                        "latitude": "-33.32249000",
                        "longitude": "19.68998000"
                    },
                    {
                        "id": 131065,
                        "name": "Central Karoo District Municipality",
                        "latitude": "-32.62812000",
                        "longitude": "22.21192000"
                    },
                    {
                        "id": 131067,
                        "name": "Ceres",
                        "latitude": "-33.36889000",
                        "longitude": "19.31095000"
                    },
                    {
                        "id": 131070,
                        "name": "City of Cape Town",
                        "latitude": "-33.91667000",
                        "longitude": "18.41667000"
                    },
                    {
                        "id": 131073,
                        "name": "Clanwilliam",
                        "latitude": "-32.18173000",
                        "longitude": "18.89217000"
                    },
                    {
                        "id": 131074,
                        "name": "Claremont",
                        "latitude": "-33.98056000",
                        "longitude": "18.46528000"
                    },
                    {
                        "id": 131077,
                        "name": "Constantia",
                        "latitude": "-34.03139000",
                        "longitude": "18.41833000"
                    },
                    {
                        "id": 131082,
                        "name": "De Rust",
                        "latitude": "-33.49035000",
                        "longitude": "22.53523000"
                    },
                    {
                        "id": 131095,
                        "name": "Eden District Municipality",
                        "latitude": "-33.82139000",
                        "longitude": "22.01263000"
                    },
                    {
                        "id": 131115,
                        "name": "George",
                        "latitude": "-33.96300000",
                        "longitude": "22.46173000"
                    },
                    {
                        "id": 131120,
                        "name": "Grabouw",
                        "latitude": "-34.15152000",
                        "longitude": "19.01509000"
                    },
                    {
                        "id": 131123,
                        "name": "Hardys Memories of Africa",
                        "latitude": "-33.90539000",
                        "longitude": "20.71690000"
                    },
                    {
                        "id": 131129,
                        "name": "Hermanus",
                        "latitude": "-34.41870000",
                        "longitude": "19.23446000"
                    },
                    {
                        "id": 131143,
                        "name": "Knysna",
                        "latitude": "-34.03627000",
                        "longitude": "23.04713000"
                    },
                    {
                        "id": 131148,
                        "name": "Kraaifontein",
                        "latitude": "-33.84808000",
                        "longitude": "18.71723000"
                    },
                    {
                        "id": 131156,
                        "name": "Ladismith",
                        "latitude": "-33.49331000",
                        "longitude": "21.26755000"
                    },
                    {
                        "id": 131159,
                        "name": "Lansdowne",
                        "latitude": "-33.98735000",
                        "longitude": "18.49746000"
                    },
                    {
                        "id": 131169,
                        "name": "Malmesbury",
                        "latitude": "-33.46080000",
                        "longitude": "18.72714000"
                    },
                    {
                        "id": 131184,
                        "name": "Montagu",
                        "latitude": "-33.78664000",
                        "longitude": "20.12106000"
                    },
                    {
                        "id": 131186,
                        "name": "Moorreesburg",
                        "latitude": "-33.15388000",
                        "longitude": "18.66031000"
                    },
                    {
                        "id": 131188,
                        "name": "Mossel Bay",
                        "latitude": "-34.18307000",
                        "longitude": "22.14605000"
                    },
                    {
                        "id": 131200,
                        "name": "Newlands",
                        "latitude": "-33.97846000",
                        "longitude": "18.44810000"
                    },
                    {
                        "id": 131210,
                        "name": "Oudtshoorn",
                        "latitude": "-33.60047000",
                        "longitude": "22.19955000"
                    },
                    {
                        "id": 131211,
                        "name": "Overberg District Municipality",
                        "latitude": "-34.26131000",
                        "longitude": "19.93985000"
                    },
                    {
                        "id": 131212,
                        "name": "Paarl",
                        "latitude": "-33.73378000",
                        "longitude": "18.97523000"
                    },
                    {
                        "id": 131219,
                        "name": "Piketberg",
                        "latitude": "-32.90323000",
                        "longitude": "18.75704000"
                    },
                    {
                        "id": 131221,
                        "name": "Plettenberg Bay",
                        "latitude": "-34.05274000",
                        "longitude": "23.37160000"
                    },
                    {
                        "id": 131232,
                        "name": "Prince Albert",
                        "latitude": "-33.22476000",
                        "longitude": "22.02673000"
                    },
                    {
                        "id": 131238,
                        "name": "Retreat",
                        "latitude": "-34.05515000",
                        "longitude": "18.47617000"
                    },
                    {
                        "id": 131242,
                        "name": "Riversdale",
                        "latitude": "-34.09345000",
                        "longitude": "21.25725000"
                    },
                    {
                        "id": 131243,
                        "name": "Robertson",
                        "latitude": "-33.80342000",
                        "longitude": "19.88537000"
                    },
                    {
                        "id": 131244,
                        "name": "Rondebosch",
                        "latitude": "-33.96333000",
                        "longitude": "18.47639000"
                    },
                    {
                        "id": 131246,
                        "name": "Rosebank",
                        "latitude": "-33.95556000",
                        "longitude": "18.47417000"
                    },
                    {
                        "id": 131248,
                        "name": "Saldanha",
                        "latitude": "-33.01167000",
                        "longitude": "17.94420000"
                    },
                    {
                        "id": 131264,
                        "name": "Stellenbosch",
                        "latitude": "-33.93462000",
                        "longitude": "18.86676000"
                    },
                    {
                        "id": 131268,
                        "name": "Sunset Beach",
                        "latitude": "-33.85395000",
                        "longitude": "18.49231000"
                    },
                    {
                        "id": 131269,
                        "name": "Swellendam",
                        "latitude": "-34.02262000",
                        "longitude": "20.44171000"
                    },
                    {
                        "id": 131294,
                        "name": "Vredenburg",
                        "latitude": "-32.90719000",
                        "longitude": "17.98997000"
                    },
                    {
                        "id": 131295,
                        "name": "Vredendal",
                        "latitude": "-31.66833000",
                        "longitude": "18.50119000"
                    },
                    {
                        "id": 131302,
                        "name": "Wellington",
                        "latitude": "-33.63981000",
                        "longitude": "19.01120000"
                    },
                    {
                        "id": 131304,
                        "name": "West Coast District Municipality",
                        "latitude": "-32.09506000",
                        "longitude": "18.62695000"
                    },
                    {
                        "id": 131313,
                        "name": "Worcester",
                        "latitude": "-33.64651000",
                        "longitude": "19.44852000"
                    },
                    {
                        "id": 131317,
                        "name": "Zoar",
                        "latitude": "-33.49560000",
                        "longitude": "21.44373000"
                    }
                ]
            }
        ]
    },
    {
        "id": 205,
        "name": "South Georgia",
        "iso3": "SGS",
        "iso2": "GS",
        "numeric_code": "239",
        "phonecode": "500",
        "capital": "Grytviken",
        "currency": "GBP",
        "currency_name": "British pound",
        "currency_symbol": "£",
        "tld": ".gs",
        "native": "South Georgia",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "South Georgia or South Sandwich Islands",
        "timezones": [
            {
                "zoneName": "Atlantic\/South_Georgia",
                "gmtOffset": -7200,
                "gmtOffsetName": "UTC-02:00",
                "abbreviation": "GST",
                "tzName": "South Georgia and the South Sandwich Islands Time"
            }
        ],
        "translations": {
            "br": "Georgia ar Su hag Inizi Sandwich ar Su",
            "ko": "사우스조지아",
            "pt-BR": "Ilhas Geórgias do Sul e Sandwich do Sul",
            "pt": "Ilhas Geórgia do Sul e Sanduíche do Sul",
            "nl": "Zuid-Georgia en Zuidelijke Sandwicheilanden",
            "hr": "Južna Georgija i otočje Južni Sandwich",
            "fa": "جزایر جورجیای جنوبی و ساندویچ جنوبی",
            "de": "Südgeorgien und die Südlichen Sandwichinseln",
            "es": "Islas Georgias del Sur y Sandwich del Sur",
            "fr": "Géorgie du Sud-et-les Îles Sandwich du Sud",
            "ja": "サウスジョージア・サウスサンドウィッチ諸島",
            "it": "Georgia del Sud e Isole Sandwich Meridionali",
            "zh-CN": "南乔治亚",
            "tr": "Güney Georgia",
            "ru": "Южная Джорджия",
            "uk": "Південна Джорджія",
            "pl": "Południowa Georgia"
        },
        "latitude": "-54.50000000",
        "longitude": "-37.00000000",
        "emoji": "🇬🇸",
        "emojiU": "U+1F1EC U+1F1F8",
        "states": []
    },
    {
        "id": 116,
        "name": "South Korea",
        "iso3": "KOR",
        "iso2": "KR",
        "numeric_code": "410",
        "phonecode": "82",
        "capital": "Seoul",
        "currency": "KRW",
        "currency_name": "Won",
        "currency_symbol": "₩",
        "tld": ".kr",
        "native": "대한민국",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Eastern Asia",
        "subregion_id": 12,
        "nationality": "South Korean",
        "timezones": [
            {
                "zoneName": "Asia\/Seoul",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "KST",
                "tzName": "Korea Standard Time"
            }
        ],
        "translations": {
            "br": "Republik Korea",
            "ko": "대한민국",
            "pt-BR": "Coreia do Sul",
            "pt": "Coreia do Sul",
            "nl": "Zuid-Korea",
            "hr": "Južna Koreja",
            "fa": "کره شمالی",
            "de": "Südkorea",
            "es": "Corea del Sur",
            "fr": "Corée du Sud",
            "ja": "大韓民国",
            "it": "Corea del Sud",
            "zh-CN": "韩国",
            "tr": "Güney Kore",
            "ru": "Южная Корея",
            "uk": "Південна Корея",
            "pl": "Korea Południowa"
        },
        "latitude": "37.00000000",
        "longitude": "127.50000000",
        "emoji": "🇰🇷",
        "emojiU": "U+1F1F0 U+1F1F7",
        "states": [
            {
                "id": 3860,
                "name": "Busan",
                "iso2": "26",
                "latitude": "35.17955430",
                "longitude": "129.07564160",
                "type": "metropolitan city",
                "cities": [
                    {
                        "id": 65276,
                        "name": "Buk-gu",
                        "latitude": "35.19724000",
                        "longitude": "128.99134000"
                    },
                    {
                        "id": 65278,
                        "name": "Busan",
                        "latitude": "35.10168000",
                        "longitude": "129.03004000"
                    },
                    {
                        "id": 65313,
                        "name": "Dongnae-gu",
                        "latitude": "35.20447000",
                        "longitude": "129.07800000"
                    },
                    {
                        "id": 65325,
                        "name": "Gangseo-gu",
                        "latitude": "35.15930000",
                        "longitude": "128.93300000"
                    },
                    {
                        "id": 65331,
                        "name": "Geumjeong-gu",
                        "latitude": "35.25863000",
                        "longitude": "129.09010000"
                    },
                    {
                        "id": 65333,
                        "name": "Gijang",
                        "latitude": "35.24417000",
                        "longitude": "129.21389000"
                    },
                    {
                        "id": 65334,
                        "name": "Gijang-gun",
                        "latitude": "35.29721000",
                        "longitude": "129.20076000"
                    },
                    {
                        "id": 65375,
                        "name": "Haeundae-gu",
                        "latitude": "35.16665000",
                        "longitude": "129.16792000"
                    },
                    {
                        "id": 65421,
                        "name": "Jung-gu",
                        "latitude": "35.10594000",
                        "longitude": "129.03331000"
                    },
                    {
                        "id": 65452,
                        "name": "Nam-gu",
                        "latitude": "35.13648000",
                        "longitude": "129.08266000"
                    },
                    {
                        "id": 65477,
                        "name": "Saha-gu",
                        "latitude": "35.08552000",
                        "longitude": "128.98725000"
                    },
                    {
                        "id": 65482,
                        "name": "Sasang-gu",
                        "latitude": "35.14479000",
                        "longitude": "128.97986000"
                    },
                    {
                        "id": 65484,
                        "name": "Seo-gu",
                        "latitude": "35.12529000",
                        "longitude": "129.01946000"
                    },
                    {
                        "id": 65513,
                        "name": "Suyeong-gu",
                        "latitude": "35.15627000",
                        "longitude": "129.11253000"
                    },
                    {
                        "id": 65552,
                        "name": "Yeongdo-gu",
                        "latitude": "35.07849000",
                        "longitude": "129.06483000"
                    }
                ]
            },
            {
                "id": 3846,
                "name": "Daegu",
                "iso2": "27",
                "latitude": "35.87143540",
                "longitude": "128.60144500",
                "type": "metropolitan city",
                "cities": [
                    {
                        "id": 65300,
                        "name": "Daegu",
                        "latitude": "35.87028000",
                        "longitude": "128.59111000"
                    },
                    {
                        "id": 65302,
                        "name": "Dalseo-gu",
                        "latitude": "35.82569000",
                        "longitude": "128.52403000"
                    },
                    {
                        "id": 65303,
                        "name": "Dalseong-gun",
                        "latitude": "35.77467000",
                        "longitude": "128.42955000"
                    },
                    {
                        "id": 65307,
                        "name": "Dong-gu",
                        "latitude": "35.88566000",
                        "longitude": "128.63296000"
                    },
                    {
                        "id": 65394,
                        "name": "Hwawŏn",
                        "latitude": "35.80167000",
                        "longitude": "128.50083000"
                    },
                    {
                        "id": 65422,
                        "name": "Jung-gu",
                        "latitude": "35.86678000",
                        "longitude": "128.59538000"
                    },
                    {
                        "id": 65485,
                        "name": "Seo-gu",
                        "latitude": "35.87465000",
                        "longitude": "128.55109000"
                    },
                    {
                        "id": 65511,
                        "name": "Suseong-gu",
                        "latitude": "35.85905000",
                        "longitude": "128.62625000"
                    }
                ]
            },
            {
                "id": 3850,
                "name": "Daejeon",
                "iso2": "30",
                "latitude": "36.35041190",
                "longitude": "127.38454750",
                "type": "metropolitan city",
                "cities": [
                    {
                        "id": 65301,
                        "name": "Daejeon",
                        "latitude": "36.34913000",
                        "longitude": "127.38493000"
                    },
                    {
                        "id": 65486,
                        "name": "Seo-gu",
                        "latitude": "36.27211000",
                        "longitude": "127.33100000"
                    },
                    {
                        "id": 65503,
                        "name": "Sintansin",
                        "latitude": "36.45361000",
                        "longitude": "127.43111000"
                    },
                    {
                        "id": 65506,
                        "name": "Songgangdong",
                        "latitude": "36.43387000",
                        "longitude": "127.37587000"
                    },
                    {
                        "id": 65567,
                        "name": "Yuseong-gu",
                        "latitude": "36.36685000",
                        "longitude": "127.32700000"
                    }
                ]
            },
            {
                "id": 3862,
                "name": "Gangwon",
                "iso2": "42",
                "latitude": "37.82280000",
                "longitude": "128.15550000",
                "type": "special self-governing province",
                "cities": [
                    {
                        "id": 65293,
                        "name": "Cheorwon-gun",
                        "latitude": "38.24391000",
                        "longitude": "127.44522000"
                    },
                    {
                        "id": 65297,
                        "name": "Chuncheon",
                        "latitude": "37.87472000",
                        "longitude": "127.73417000"
                    },
                    {
                        "id": 65298,
                        "name": "Chuncheon-si",
                        "latitude": "37.88048000",
                        "longitude": "127.72776000"
                    },
                    {
                        "id": 65311,
                        "name": "Donghae-si",
                        "latitude": "37.52345000",
                        "longitude": "129.11357000"
                    },
                    {
                        "id": 65322,
                        "name": "Gangneung",
                        "latitude": "37.75266000",
                        "longitude": "128.87239000"
                    },
                    {
                        "id": 65323,
                        "name": "Gangneung-si",
                        "latitude": "37.75190000",
                        "longitude": "128.87825000"
                    },
                    {
                        "id": 65349,
                        "name": "Goseong-gun",
                        "latitude": "38.37945000",
                        "longitude": "128.46755000"
                    },
                    {
                        "id": 65383,
                        "name": "Hoengseong-gun",
                        "latitude": "37.48817000",
                        "longitude": "127.98570000"
                    },
                    {
                        "id": 65385,
                        "name": "Hongch’ŏn",
                        "latitude": "37.69180000",
                        "longitude": "127.88570000"
                    },
                    {
                        "id": 65384,
                        "name": "Hongcheon-gun",
                        "latitude": "37.76058000",
                        "longitude": "128.02823000"
                    },
                    {
                        "id": 65388,
                        "name": "Hwacheon",
                        "latitude": "38.10705000",
                        "longitude": "127.70632000"
                    },
                    {
                        "id": 65389,
                        "name": "Hwacheon-gun",
                        "latitude": "38.14212000",
                        "longitude": "127.67615000"
                    },
                    {
                        "id": 65401,
                        "name": "Inje-gun",
                        "latitude": "38.04416000",
                        "longitude": "128.27876000"
                    },
                    {
                        "id": 65411,
                        "name": "Jeongseon-gun",
                        "latitude": "37.38911000",
                        "longitude": "128.72995000"
                    },
                    {
                        "id": 65430,
                        "name": "Kosong",
                        "latitude": "38.37881000",
                        "longitude": "128.46760000"
                    },
                    {
                        "id": 65459,
                        "name": "Neietsu",
                        "latitude": "37.18447000",
                        "longitude": "128.46821000"
                    },
                    {
                        "id": 65473,
                        "name": "Pyeongchang",
                        "latitude": "37.37028000",
                        "longitude": "128.39306000"
                    },
                    {
                        "id": 65474,
                        "name": "Pyeongchang-gun",
                        "latitude": "37.36820000",
                        "longitude": "128.39550000"
                    },
                    {
                        "id": 65478,
                        "name": "Samcheok-si",
                        "latitude": "37.45013000",
                        "longitude": "129.16626000"
                    },
                    {
                        "id": 65481,
                        "name": "Santyoku",
                        "latitude": "37.44056000",
                        "longitude": "129.17083000"
                    },
                    {
                        "id": 65504,
                        "name": "Sokcho",
                        "latitude": "38.20701000",
                        "longitude": "128.59181000"
                    },
                    {
                        "id": 65505,
                        "name": "Sokcho-si",
                        "latitude": "38.20725000",
                        "longitude": "128.59275000"
                    },
                    {
                        "id": 65519,
                        "name": "T’aebaek",
                        "latitude": "37.17590000",
                        "longitude": "128.98890000"
                    },
                    {
                        "id": 65515,
                        "name": "Taebaek-si",
                        "latitude": "37.16520000",
                        "longitude": "128.98570000"
                    },
                    {
                        "id": 65518,
                        "name": "Tonghae",
                        "latitude": "37.54389000",
                        "longitude": "129.10694000"
                    },
                    {
                        "id": 65534,
                        "name": "Wŏnju",
                        "latitude": "37.35139000",
                        "longitude": "127.94528000"
                    },
                    {
                        "id": 65533,
                        "name": "Wonju-si",
                        "latitude": "37.32104000",
                        "longitude": "127.92132000"
                    },
                    {
                        "id": 65536,
                        "name": "Yanggu",
                        "latitude": "38.10583000",
                        "longitude": "127.98944000"
                    },
                    {
                        "id": 65537,
                        "name": "Yanggu-gun",
                        "latitude": "38.10160000",
                        "longitude": "127.98555000"
                    },
                    {
                        "id": 65543,
                        "name": "Yangyang-gun",
                        "latitude": "38.06215000",
                        "longitude": "128.61471000"
                    }
                ]
            },
            {
                "id": 3858,
                "name": "Gwangju",
                "iso2": "29",
                "latitude": "35.15954540",
                "longitude": "126.85260120",
                "type": "metropolitan city",
                "cities": [
                    {
                        "id": 65362,
                        "name": "Gwangju",
                        "latitude": "35.15472000",
                        "longitude": "126.91556000"
                    },
                    {
                        "id": 65366,
                        "name": "Gwangsan-gu",
                        "latitude": "35.16158000",
                        "longitude": "126.80810000"
                    },
                    {
                        "id": 65437,
                        "name": "Masan",
                        "latitude": "35.12725000",
                        "longitude": "126.83149000"
                    }
                ]
            },
            {
                "id": 3847,
                "name": "Gyeonggi",
                "iso2": "41",
                "latitude": "37.41380000",
                "longitude": "127.51830000",
                "type": "province",
                "cities": [
                    {
                        "id": 65262,
                        "name": "Ansan-si",
                        "latitude": "37.32361000",
                        "longitude": "126.82194000"
                    },
                    {
                        "id": 65263,
                        "name": "Anseong",
                        "latitude": "37.01083000",
                        "longitude": "127.27028000"
                    },
                    {
                        "id": 65264,
                        "name": "Anyang-si",
                        "latitude": "37.39250000",
                        "longitude": "126.92694000"
                    },
                    {
                        "id": 65274,
                        "name": "Bucheon-si",
                        "latitude": "37.50440000",
                        "longitude": "126.76625000"
                    },
                    {
                        "id": 65310,
                        "name": "Dongducheon",
                        "latitude": "37.91889000",
                        "longitude": "127.06897000"
                    },
                    {
                        "id": 65326,
                        "name": "Gapyeong",
                        "latitude": "37.83101000",
                        "longitude": "127.51059000"
                    },
                    {
                        "id": 65327,
                        "name": "Gapyeong-gun",
                        "latitude": "37.83080000",
                        "longitude": "127.51522000"
                    },
                    {
                        "id": 65339,
                        "name": "Gimpo-si",
                        "latitude": "37.63637000",
                        "longitude": "126.69270000"
                    },
                    {
                        "id": 65350,
                        "name": "Goyang-si",
                        "latitude": "37.65639000",
                        "longitude": "126.83500000"
                    },
                    {
                        "id": 65352,
                        "name": "Gunpo-si",
                        "latitude": "37.34261000",
                        "longitude": "126.92149000"
                    },
                    {
                        "id": 65356,
                        "name": "Guri-si",
                        "latitude": "37.59860000",
                        "longitude": "127.13940000"
                    },
                    {
                        "id": 65359,
                        "name": "Gwacheon-si",
                        "latitude": "37.43407000",
                        "longitude": "126.99989000"
                    },
                    {
                        "id": 65363,
                        "name": "Gwangju",
                        "latitude": "37.41000000",
                        "longitude": "127.25722000"
                    },
                    {
                        "id": 65364,
                        "name": "Gwangju-si",
                        "latitude": "37.40329000",
                        "longitude": "127.29855000"
                    },
                    {
                        "id": 65365,
                        "name": "Gwangmyeong-si",
                        "latitude": "37.44435000",
                        "longitude": "126.86499000"
                    },
                    {
                        "id": 65378,
                        "name": "Hanam",
                        "latitude": "37.54000000",
                        "longitude": "127.20556000"
                    },
                    {
                        "id": 65379,
                        "name": "Hanam-si",
                        "latitude": "37.53895000",
                        "longitude": "127.21250000"
                    },
                    {
                        "id": 65390,
                        "name": "Hwado",
                        "latitude": "37.65250000",
                        "longitude": "127.30750000"
                    },
                    {
                        "id": 65391,
                        "name": "Hwaseong-si",
                        "latitude": "37.20682000",
                        "longitude": "126.81690000"
                    },
                    {
                        "id": 65395,
                        "name": "Icheon-si",
                        "latitude": "37.27642000",
                        "longitude": "127.43692000"
                    },
                    {
                        "id": 65433,
                        "name": "Kwangmyŏng",
                        "latitude": "37.47722000",
                        "longitude": "126.86639000"
                    },
                    {
                        "id": 65448,
                        "name": "Munsan",
                        "latitude": "37.85944000",
                        "longitude": "126.78500000"
                    },
                    {
                        "id": 65456,
                        "name": "Namyangju",
                        "latitude": "37.63667000",
                        "longitude": "127.21417000"
                    },
                    {
                        "id": 65457,
                        "name": "Namyangju-si",
                        "latitude": "37.65217000",
                        "longitude": "127.24010000"
                    },
                    {
                        "id": 65465,
                        "name": "Osan",
                        "latitude": "37.15222000",
                        "longitude": "127.07056000"
                    },
                    {
                        "id": 65466,
                        "name": "Osan-si",
                        "latitude": "37.16230000",
                        "longitude": "127.05246000"
                    },
                    {
                        "id": 65467,
                        "name": "Paju-si",
                        "latitude": "37.75952000",
                        "longitude": "126.77772000"
                    },
                    {
                        "id": 65468,
                        "name": "Pocheon-si",
                        "latitude": "37.89370000",
                        "longitude": "127.20028000"
                    },
                    {
                        "id": 65472,
                        "name": "Pubal",
                        "latitude": "37.29167000",
                        "longitude": "127.50778000"
                    },
                    {
                        "id": 65475,
                        "name": "Pyeongtaek",
                        "latitude": "37.01372000",
                        "longitude": "126.98748000"
                    },
                    {
                        "id": 65495,
                        "name": "Seongnam-si",
                        "latitude": "37.41875000",
                        "longitude": "127.12877000"
                    },
                    {
                        "id": 65499,
                        "name": "Siheung",
                        "latitude": "37.39067000",
                        "longitude": "126.78880000"
                    },
                    {
                        "id": 65512,
                        "name": "Suwon",
                        "latitude": "37.29111000",
                        "longitude": "127.00889000"
                    },
                    {
                        "id": 65520,
                        "name": "Uijeongbu-si",
                        "latitude": "37.73865000",
                        "longitude": "127.04770000"
                    },
                    {
                        "id": 65523,
                        "name": "Uiwang-si",
                        "latitude": "37.34500000",
                        "longitude": "126.97575000"
                    },
                    {
                        "id": 65529,
                        "name": "Wabu",
                        "latitude": "37.58972000",
                        "longitude": "127.22028000"
                    },
                    {
                        "id": 65538,
                        "name": "Yangju",
                        "latitude": "37.83311000",
                        "longitude": "127.06169000"
                    },
                    {
                        "id": 65539,
                        "name": "Yangju-si",
                        "latitude": "37.81732000",
                        "longitude": "127.04600000"
                    },
                    {
                        "id": 65540,
                        "name": "Yangp'yŏng",
                        "latitude": "37.48972000",
                        "longitude": "127.49056000"
                    },
                    {
                        "id": 65541,
                        "name": "Yangpyeong-gun",
                        "latitude": "37.48880000",
                        "longitude": "127.49222000"
                    },
                    {
                        "id": 65545,
                        "name": "Yeoju-si",
                        "latitude": "37.29562000",
                        "longitude": "127.63668000"
                    },
                    {
                        "id": 65546,
                        "name": "Yeoncheon-gun",
                        "latitude": "38.09404000",
                        "longitude": "127.07577000"
                    },
                    {
                        "id": 65564,
                        "name": "Yongin-si",
                        "latitude": "37.23825000",
                        "longitude": "127.17795000"
                    }
                ]
            },
            {
                "id": 3848,
                "name": "Incheon",
                "iso2": "28",
                "latitude": "37.45625570",
                "longitude": "126.70520620",
                "type": "metropolitan city",
                "cities": [
                    {
                        "id": 65277,
                        "name": "Bupyeong-gu",
                        "latitude": "37.49720000",
                        "longitude": "126.71107000"
                    },
                    {
                        "id": 65400,
                        "name": "Incheon",
                        "latitude": "37.45646000",
                        "longitude": "126.70515000"
                    },
                    {
                        "id": 65438,
                        "name": "Michuhol",
                        "latitude": "37.46362000",
                        "longitude": "126.65000000"
                    },
                    {
                        "id": 65560,
                        "name": "Yeonsu-gu",
                        "latitude": "37.41911000",
                        "longitude": "126.66489000"
                    }
                ]
            },
            {
                "id": 3853,
                "name": "Jeju",
                "iso2": "49",
                "latitude": "33.95682780",
                "longitude": "-84.13135000",
                "type": "special self-governing province",
                "cities": [
                    {
                        "id": 65317,
                        "name": "Gaigeturi",
                        "latitude": "33.46444000",
                        "longitude": "126.31833000"
                    },
                    {
                        "id": 65406,
                        "name": "Jeju City",
                        "latitude": "33.50972000",
                        "longitude": "126.52194000"
                    },
                    {
                        "id": 65407,
                        "name": "Jeju-si",
                        "latitude": "33.45578000",
                        "longitude": "126.53928000"
                    },
                    {
                        "id": 65490,
                        "name": "Seogwipo",
                        "latitude": "33.25333000",
                        "longitude": "126.56181000"
                    }
                ]
            },
            {
                "id": 3854,
                "name": "North Chungcheong",
                "iso2": "43",
                "latitude": "36.80000000",
                "longitude": "127.70000000",
                "type": "province",
                "cities": [
                    {
                        "id": 65268,
                        "name": "Boeun-gun",
                        "latitude": "36.49489000",
                        "longitude": "127.72865000"
                    },
                    {
                        "id": 65289,
                        "name": "Cheongju-si",
                        "latitude": "36.63722000",
                        "longitude": "127.48972000"
                    },
                    {
                        "id": 65295,
                        "name": "Chinch'ŏn",
                        "latitude": "36.85667000",
                        "longitude": "127.44333000"
                    },
                    {
                        "id": 65299,
                        "name": "Chungju-si",
                        "latitude": "37.01791000",
                        "longitude": "127.87713000"
                    },
                    {
                        "id": 65305,
                        "name": "Danyang-gun",
                        "latitude": "36.98615000",
                        "longitude": "128.36945000"
                    },
                    {
                        "id": 65315,
                        "name": "Eumseong-gun",
                        "latitude": "36.92602000",
                        "longitude": "127.68070000"
                    },
                    {
                        "id": 65341,
                        "name": "Goesan-gun",
                        "latitude": "36.77179000",
                        "longitude": "127.81426000"
                    },
                    {
                        "id": 65405,
                        "name": "Jecheon-si",
                        "latitude": "37.06206000",
                        "longitude": "128.14065000"
                    },
                    {
                        "id": 65414,
                        "name": "Jeungpyeong-gun",
                        "latitude": "36.78377000",
                        "longitude": "127.59858000"
                    },
                    {
                        "id": 65416,
                        "name": "Jincheon-gun",
                        "latitude": "36.88281000",
                        "longitude": "127.42768000"
                    },
                    {
                        "id": 65429,
                        "name": "Koesan",
                        "latitude": "36.81083000",
                        "longitude": "127.79472000"
                    },
                    {
                        "id": 65463,
                        "name": "Okcheon",
                        "latitude": "36.30120000",
                        "longitude": "127.56800000"
                    },
                    {
                        "id": 65464,
                        "name": "Okcheon-gun",
                        "latitude": "36.26642000",
                        "longitude": "127.58324000"
                    },
                    {
                        "id": 65553,
                        "name": "Yeongdong",
                        "latitude": "36.17500000",
                        "longitude": "127.77639000"
                    },
                    {
                        "id": 65554,
                        "name": "Yeongdong-gun",
                        "latitude": "36.21658000",
                        "longitude": "127.79374000"
                    }
                ]
            },
            {
                "id": 3855,
                "name": "North Gyeongsang",
                "iso2": "47",
                "latitude": "36.49190000",
                "longitude": "128.88890000",
                "type": "province",
                "cities": [
                    {
                        "id": 65260,
                        "name": "Andong",
                        "latitude": "36.56636000",
                        "longitude": "128.72275000"
                    },
                    {
                        "id": 65261,
                        "name": "Andong-si",
                        "latitude": "36.56667000",
                        "longitude": "128.71667000"
                    },
                    {
                        "id": 65269,
                        "name": "Bonghwa-gun",
                        "latitude": "36.88951000",
                        "longitude": "128.73573000"
                    },
                    {
                        "id": 65288,
                        "name": "Cheongdo-gun",
                        "latitude": "35.67166000",
                        "longitude": "128.78509000"
                    },
                    {
                        "id": 65290,
                        "name": "Cheongsong gun",
                        "latitude": "36.43351000",
                        "longitude": "129.05700000"
                    },
                    {
                        "id": 65291,
                        "name": "Cheongsong-gun",
                        "latitude": "36.43288000",
                        "longitude": "129.05159000"
                    },
                    {
                        "id": 65294,
                        "name": "Chilgok-gun",
                        "latitude": "36.01512000",
                        "longitude": "128.46138000"
                    },
                    {
                        "id": 65314,
                        "name": "Eisen",
                        "latitude": "36.82167000",
                        "longitude": "128.63083000"
                    },
                    {
                        "id": 65335,
                        "name": "Gimcheon",
                        "latitude": "36.12176000",
                        "longitude": "128.11981000"
                    },
                    {
                        "id": 65336,
                        "name": "Gimcheon-si",
                        "latitude": "36.14481000",
                        "longitude": "128.11157000"
                    },
                    {
                        "id": 65346,
                        "name": "Goryeong-gun",
                        "latitude": "35.74959000",
                        "longitude": "128.29707000"
                    },
                    {
                        "id": 65351,
                        "name": "Gumi-si",
                        "latitude": "36.21009000",
                        "longitude": "128.35442000"
                    },
                    {
                        "id": 65355,
                        "name": "Gunwi-gun",
                        "latitude": "36.16995000",
                        "longitude": "128.64705000"
                    },
                    {
                        "id": 65369,
                        "name": "Gyeongju",
                        "latitude": "35.84278000",
                        "longitude": "129.21167000"
                    },
                    {
                        "id": 65370,
                        "name": "Gyeongsan-si",
                        "latitude": "35.83333000",
                        "longitude": "128.80000000"
                    },
                    {
                        "id": 65381,
                        "name": "Hayang",
                        "latitude": "35.91333000",
                        "longitude": "128.82000000"
                    },
                    {
                        "id": 65382,
                        "name": "Heunghae",
                        "latitude": "36.10945000",
                        "longitude": "129.34517000"
                    },
                    {
                        "id": 65408,
                        "name": "Jenzan",
                        "latitude": "36.24083000",
                        "longitude": "128.29750000"
                    },
                    {
                        "id": 65431,
                        "name": "Kunwi",
                        "latitude": "36.23472000",
                        "longitude": "128.57278000"
                    },
                    {
                        "id": 65446,
                        "name": "Mungyeong",
                        "latitude": "36.59458000",
                        "longitude": "128.19946000"
                    },
                    {
                        "id": 65447,
                        "name": "Mungyeong-si",
                        "latitude": "36.58755000",
                        "longitude": "128.18624000"
                    },
                    {
                        "id": 65469,
                        "name": "Pohang",
                        "latitude": "36.02917000",
                        "longitude": "129.36481000"
                    },
                    {
                        "id": 65470,
                        "name": "Pohang-si",
                        "latitude": "36.08333000",
                        "longitude": "129.36667000"
                    },
                    {
                        "id": 65480,
                        "name": "Sangju",
                        "latitude": "36.41528000",
                        "longitude": "128.16056000"
                    },
                    {
                        "id": 65494,
                        "name": "Seongju-gun",
                        "latitude": "35.91888000",
                        "longitude": "128.28838000"
                    },
                    {
                        "id": 65522,
                        "name": "Uiseong-gun",
                        "latitude": "36.36122000",
                        "longitude": "128.61517000"
                    },
                    {
                        "id": 65524,
                        "name": "Uljin-gun",
                        "latitude": "36.91968000",
                        "longitude": "129.31966000"
                    },
                    {
                        "id": 65526,
                        "name": "Ulleung-gun",
                        "latitude": "37.50442000",
                        "longitude": "130.86084000"
                    },
                    {
                        "id": 65530,
                        "name": "Waegwan",
                        "latitude": "35.99251000",
                        "longitude": "128.39785000"
                    },
                    {
                        "id": 65544,
                        "name": "Yecheon-gun",
                        "latitude": "36.65272000",
                        "longitude": "128.43007000"
                    },
                    {
                        "id": 65549,
                        "name": "Yeongcheon-si",
                        "latitude": "36.00000000",
                        "longitude": "129.00000000"
                    },
                    {
                        "id": 65550,
                        "name": "Yeongdeok-gun",
                        "latitude": "36.48125000",
                        "longitude": "129.31078000"
                    },
                    {
                        "id": 65557,
                        "name": "Yeongju-si",
                        "latitude": "36.87459000",
                        "longitude": "128.58631000"
                    },
                    {
                        "id": 65558,
                        "name": "Yeongyang-gun",
                        "latitude": "36.69592000",
                        "longitude": "129.14196000"
                    },
                    {
                        "id": 65559,
                        "name": "Yeonil",
                        "latitude": "35.99526000",
                        "longitude": "129.35162000"
                    }
                ]
            },
            {
                "id": 3851,
                "name": "North Jeolla",
                "iso2": "45",
                "latitude": "35.71750000",
                "longitude": "127.15300000",
                "type": "province",
                "cities": [
                    {
                        "id": 65273,
                        "name": "Buan-gun",
                        "latitude": "35.70000000",
                        "longitude": "126.66667000"
                    },
                    {
                        "id": 65283,
                        "name": "Changsu",
                        "latitude": "35.64842000",
                        "longitude": "127.51523000"
                    },
                    {
                        "id": 65338,
                        "name": "Gimje-si",
                        "latitude": "35.80701000",
                        "longitude": "126.90755000"
                    },
                    {
                        "id": 65340,
                        "name": "Gochang-gun",
                        "latitude": "35.43483000",
                        "longitude": "126.70047000"
                    },
                    {
                        "id": 65353,
                        "name": "Gunsan",
                        "latitude": "35.97861000",
                        "longitude": "126.71139000"
                    },
                    {
                        "id": 65354,
                        "name": "Gunsan-si",
                        "latitude": "35.93583000",
                        "longitude": "126.68338000"
                    },
                    {
                        "id": 65396,
                        "name": "Iksan",
                        "latitude": "35.94389000",
                        "longitude": "126.95444000"
                    },
                    {
                        "id": 65397,
                        "name": "Iksan-si",
                        "latitude": "36.03718000",
                        "longitude": "126.98897000"
                    },
                    {
                        "id": 65398,
                        "name": "Imsil",
                        "latitude": "35.61306000",
                        "longitude": "127.27944000"
                    },
                    {
                        "id": 65399,
                        "name": "Imsil-gun",
                        "latitude": "35.62160000",
                        "longitude": "127.23187000"
                    },
                    {
                        "id": 65404,
                        "name": "Jangsu-gun",
                        "latitude": "35.62504000",
                        "longitude": "127.56358000"
                    },
                    {
                        "id": 65409,
                        "name": "Jeongeup",
                        "latitude": "35.60004000",
                        "longitude": "126.91699000"
                    },
                    {
                        "id": 65410,
                        "name": "Jeongeup-si",
                        "latitude": "35.60000000",
                        "longitude": "126.91667000"
                    },
                    {
                        "id": 65412,
                        "name": "Jeonju",
                        "latitude": "35.82194000",
                        "longitude": "127.14889000"
                    },
                    {
                        "id": 65413,
                        "name": "Jeonju-si",
                        "latitude": "35.83333000",
                        "longitude": "127.15000000"
                    },
                    {
                        "id": 65415,
                        "name": "Jinan-gun",
                        "latitude": "35.80472000",
                        "longitude": "127.47579000"
                    },
                    {
                        "id": 65426,
                        "name": "Kimje",
                        "latitude": "35.80167000",
                        "longitude": "126.88889000"
                    },
                    {
                        "id": 65428,
                        "name": "Koch'ang",
                        "latitude": "35.43333000",
                        "longitude": "126.70000000"
                    },
                    {
                        "id": 65445,
                        "name": "Muju-gun",
                        "latitude": "35.93172000",
                        "longitude": "127.71118000"
                    },
                    {
                        "id": 65455,
                        "name": "Namwon",
                        "latitude": "35.44821000",
                        "longitude": "127.38007000"
                    },
                    {
                        "id": 65458,
                        "name": "Nangen",
                        "latitude": "35.41000000",
                        "longitude": "127.38583000"
                    },
                    {
                        "id": 65471,
                        "name": "Puan",
                        "latitude": "35.72806000",
                        "longitude": "126.73194000"
                    },
                    {
                        "id": 65508,
                        "name": "Sunchang-gun",
                        "latitude": "35.37651000",
                        "longitude": "127.14967000"
                    },
                    {
                        "id": 65532,
                        "name": "Wanju",
                        "latitude": "35.84509000",
                        "longitude": "127.14752000"
                    }
                ]
            },
            {
                "id": 3861,
                "name": "Sejong City",
                "iso2": "50",
                "latitude": "34.05233230",
                "longitude": "-118.30848970",
                "type": "special self-governing city",
                "cities": [
                    {
                        "id": 65483,
                        "name": "Sejong",
                        "latitude": "36.59245000",
                        "longitude": "127.29223000"
                    }
                ]
            },
            {
                "id": 3849,
                "name": "Seoul",
                "iso2": "11",
                "latitude": "37.56653500",
                "longitude": "126.97796920",
                "type": "special city",
                "cities": [
                    {
                        "id": 65306,
                        "name": "Dobong-gu",
                        "latitude": "37.65066000",
                        "longitude": "127.03011000"
                    },
                    {
                        "id": 65309,
                        "name": "Dongdaemun-gu",
                        "latitude": "37.58189000",
                        "longitude": "127.05408000"
                    },
                    {
                        "id": 65312,
                        "name": "Dongjak-gu",
                        "latitude": "37.50056000",
                        "longitude": "126.95149000"
                    },
                    {
                        "id": 65316,
                        "name": "Eunpyeong-gu",
                        "latitude": "37.61846000",
                        "longitude": "126.92780000"
                    },
                    {
                        "id": 65318,
                        "name": "Gangbuk-gu",
                        "latitude": "37.63490000",
                        "longitude": "127.02015000"
                    },
                    {
                        "id": 65319,
                        "name": "Gangdong-gu",
                        "latitude": "37.55274000",
                        "longitude": "127.14546000"
                    },
                    {
                        "id": 65321,
                        "name": "Gangnam-gu",
                        "latitude": "37.49510000",
                        "longitude": "127.06278000"
                    },
                    {
                        "id": 65324,
                        "name": "Gangseo-gu",
                        "latitude": "37.56227000",
                        "longitude": "126.81622000"
                    },
                    {
                        "id": 65330,
                        "name": "Geumcheon-gu",
                        "latitude": "37.47486000",
                        "longitude": "126.89106000"
                    },
                    {
                        "id": 65357,
                        "name": "Guro-gu",
                        "latitude": "37.49447000",
                        "longitude": "126.85020000"
                    },
                    {
                        "id": 65360,
                        "name": "Gwanak-gu",
                        "latitude": "37.47876000",
                        "longitude": "126.95235000"
                    },
                    {
                        "id": 65361,
                        "name": "Gwangjin-gu",
                        "latitude": "37.53913000",
                        "longitude": "127.08366000"
                    },
                    {
                        "id": 65419,
                        "name": "Jongno-gu",
                        "latitude": "37.57290000",
                        "longitude": "126.97928000"
                    },
                    {
                        "id": 65420,
                        "name": "Jung-gu",
                        "latitude": "37.55986000",
                        "longitude": "126.99398000"
                    },
                    {
                        "id": 65424,
                        "name": "Jungnang-gu",
                        "latitude": "37.60199000",
                        "longitude": "127.10461000"
                    },
                    {
                        "id": 65436,
                        "name": "Mapo-gu",
                        "latitude": "37.55438000",
                        "longitude": "126.90926000"
                    },
                    {
                        "id": 65462,
                        "name": "Nowon-gu",
                        "latitude": "37.66045000",
                        "longitude": "127.06718000"
                    },
                    {
                        "id": 65488,
                        "name": "Seocho-gu",
                        "latitude": "37.49447000",
                        "longitude": "127.01088000"
                    },
                    {
                        "id": 65489,
                        "name": "Seodaemun-gu",
                        "latitude": "37.57809000",
                        "longitude": "126.93506000"
                    },
                    {
                        "id": 65491,
                        "name": "Seongbuk-gu",
                        "latitude": "37.60267000",
                        "longitude": "127.01448000"
                    },
                    {
                        "id": 65492,
                        "name": "Seongdong-gu",
                        "latitude": "37.54784000",
                        "longitude": "127.02461000"
                    },
                    {
                        "id": 65498,
                        "name": "Seoul",
                        "latitude": "37.56600000",
                        "longitude": "126.97840000"
                    },
                    {
                        "id": 65507,
                        "name": "Songpa-gu",
                        "latitude": "37.50210000",
                        "longitude": "127.11113000"
                    },
                    {
                        "id": 65535,
                        "name": "Yangcheon-gu",
                        "latitude": "37.52157000",
                        "longitude": "126.85827000"
                    },
                    {
                        "id": 65551,
                        "name": "Yeongdeungpo-gu",
                        "latitude": "37.52606000",
                        "longitude": "126.90308000"
                    },
                    {
                        "id": 65565,
                        "name": "Yongsan-dong",
                        "latitude": "37.54450000",
                        "longitude": "126.98370000"
                    },
                    {
                        "id": 65566,
                        "name": "Yongsan-gu",
                        "latitude": "37.53391000",
                        "longitude": "126.97750000"
                    }
                ]
            },
            {
                "id": 3859,
                "name": "South Chungcheong",
                "iso2": "44",
                "latitude": "36.51840000",
                "longitude": "126.80000000",
                "type": "province",
                "cities": [
                    {
                        "id": 65265,
                        "name": "Asan",
                        "latitude": "36.78361000",
                        "longitude": "127.00417000"
                    },
                    {
                        "id": 65266,
                        "name": "Asan-si",
                        "latitude": "36.80791000",
                        "longitude": "126.97769000"
                    },
                    {
                        "id": 65270,
                        "name": "Boryeong",
                        "latitude": "36.34931000",
                        "longitude": "126.59772000"
                    },
                    {
                        "id": 65271,
                        "name": "Boryeong-si",
                        "latitude": "36.35649000",
                        "longitude": "126.59444000"
                    },
                    {
                        "id": 65279,
                        "name": "Buyeo",
                        "latitude": "36.27472000",
                        "longitude": "126.90906000"
                    },
                    {
                        "id": 65280,
                        "name": "Buyeo-gun",
                        "latitude": "36.26257000",
                        "longitude": "126.85802000"
                    },
                    {
                        "id": 65286,
                        "name": "Cheonan",
                        "latitude": "36.80650000",
                        "longitude": "127.15220000"
                    },
                    {
                        "id": 65287,
                        "name": "Cheonan-si",
                        "latitude": "36.80488000",
                        "longitude": "127.19431000"
                    },
                    {
                        "id": 65292,
                        "name": "Cheongyang-gun",
                        "latitude": "36.41676000",
                        "longitude": "126.79419000"
                    },
                    {
                        "id": 65332,
                        "name": "Geumsan-gun",
                        "latitude": "36.13381000",
                        "longitude": "127.48062000"
                    },
                    {
                        "id": 65344,
                        "name": "Gongju",
                        "latitude": "36.45556000",
                        "longitude": "127.12472000"
                    },
                    {
                        "id": 65345,
                        "name": "Gongju-si",
                        "latitude": "36.50000000",
                        "longitude": "127.08333000"
                    },
                    {
                        "id": 65371,
                        "name": "Gyeryong-si",
                        "latitude": "36.29304000",
                        "longitude": "127.22575000"
                    },
                    {
                        "id": 65386,
                        "name": "Hongseong",
                        "latitude": "36.60090000",
                        "longitude": "126.66500000"
                    },
                    {
                        "id": 65387,
                        "name": "Hongseong-gun",
                        "latitude": "36.56705000",
                        "longitude": "126.62626000"
                    },
                    {
                        "id": 65427,
                        "name": "Kinzan",
                        "latitude": "36.10306000",
                        "longitude": "127.48889000"
                    },
                    {
                        "id": 65460,
                        "name": "Nonsan",
                        "latitude": "36.20389000",
                        "longitude": "127.08472000"
                    },
                    {
                        "id": 65461,
                        "name": "Nonsan-si",
                        "latitude": "36.19774000",
                        "longitude": "127.12143000"
                    },
                    {
                        "id": 65487,
                        "name": "Seocheon-gun",
                        "latitude": "36.10600000",
                        "longitude": "126.69716000"
                    },
                    {
                        "id": 65493,
                        "name": "Seonghwan",
                        "latitude": "36.91556000",
                        "longitude": "127.13139000"
                    },
                    {
                        "id": 65496,
                        "name": "Seosan",
                        "latitude": "36.78167000",
                        "longitude": "126.45222000"
                    },
                    {
                        "id": 65497,
                        "name": "Seosan-si",
                        "latitude": "36.78518000",
                        "longitude": "126.46568000"
                    },
                    {
                        "id": 65514,
                        "name": "Taean-gun",
                        "latitude": "36.70036000",
                        "longitude": "126.28391000"
                    },
                    {
                        "id": 65516,
                        "name": "Taesal-li",
                        "latitude": "36.97140000",
                        "longitude": "126.45420000"
                    },
                    {
                        "id": 65517,
                        "name": "Tangjin",
                        "latitude": "36.89444000",
                        "longitude": "126.62972000"
                    },
                    {
                        "id": 65562,
                        "name": "Yesan",
                        "latitude": "36.67756000",
                        "longitude": "126.84272000"
                    },
                    {
                        "id": 65563,
                        "name": "Yesan-gun",
                        "latitude": "36.68218000",
                        "longitude": "126.79592000"
                    },
                    {
                        "id": 65568,
                        "name": "Yŏnmu",
                        "latitude": "36.12944000",
                        "longitude": "127.10000000"
                    }
                ]
            },
            {
                "id": 3857,
                "name": "South Gyeongsang",
                "iso2": "48",
                "latitude": "35.46060000",
                "longitude": "128.21320000",
                "type": "province",
                "cities": [
                    {
                        "id": 65281,
                        "name": "Changnyeong",
                        "latitude": "35.54145000",
                        "longitude": "128.49506000"
                    },
                    {
                        "id": 65282,
                        "name": "Changnyeong-gun",
                        "latitude": "35.50822000",
                        "longitude": "128.49020000"
                    },
                    {
                        "id": 65284,
                        "name": "Changwon",
                        "latitude": "35.22806000",
                        "longitude": "128.68111000"
                    },
                    {
                        "id": 65285,
                        "name": "Changwon-si",
                        "latitude": "35.27533000",
                        "longitude": "128.65152000"
                    },
                    {
                        "id": 65296,
                        "name": "Chinju",
                        "latitude": "35.19278000",
                        "longitude": "128.08472000"
                    },
                    {
                        "id": 65328,
                        "name": "Geochang-gun",
                        "latitude": "35.73034000",
                        "longitude": "127.90149000"
                    },
                    {
                        "id": 65329,
                        "name": "Geoje-si",
                        "latitude": "34.90000000",
                        "longitude": "128.66666000"
                    },
                    {
                        "id": 65337,
                        "name": "Gimhae-si",
                        "latitude": "35.25000000",
                        "longitude": "128.86667000"
                    },
                    {
                        "id": 65347,
                        "name": "Goseong",
                        "latitude": "34.97631000",
                        "longitude": "128.32361000"
                    },
                    {
                        "id": 65348,
                        "name": "Goseong-gun",
                        "latitude": "35.01478000",
                        "longitude": "128.28244000"
                    },
                    {
                        "id": 65372,
                        "name": "Hadong-gun",
                        "latitude": "35.13628000",
                        "longitude": "127.77291000"
                    },
                    {
                        "id": 65376,
                        "name": "Haman-gun",
                        "latitude": "35.29117000",
                        "longitude": "128.42970000"
                    },
                    {
                        "id": 65380,
                        "name": "Hapcheon-gun",
                        "latitude": "35.57410000",
                        "longitude": "128.13841000"
                    },
                    {
                        "id": 65418,
                        "name": "Jinju-si",
                        "latitude": "35.20445000",
                        "longitude": "128.12408000"
                    },
                    {
                        "id": 65425,
                        "name": "Kimhae",
                        "latitude": "35.23417000",
                        "longitude": "128.88111000"
                    },
                    {
                        "id": 65435,
                        "name": "Kyosai",
                        "latitude": "34.85028000",
                        "longitude": "128.58861000"
                    },
                    {
                        "id": 65439,
                        "name": "Miryang",
                        "latitude": "35.49333000",
                        "longitude": "128.74889000"
                    },
                    {
                        "id": 65440,
                        "name": "Miryang-si",
                        "latitude": "35.49750000",
                        "longitude": "128.78690000"
                    },
                    {
                        "id": 65449,
                        "name": "Naesŏ",
                        "latitude": "35.24972000",
                        "longitude": "128.52000000"
                    },
                    {
                        "id": 65454,
                        "name": "Namhae-gun",
                        "latitude": "34.80433000",
                        "longitude": "127.92708000"
                    },
                    {
                        "id": 65476,
                        "name": "Sacheon-si",
                        "latitude": "35.00385000",
                        "longitude": "128.06857000"
                    },
                    {
                        "id": 65479,
                        "name": "Sancheong-gun",
                        "latitude": "35.36625000",
                        "longitude": "127.87065000"
                    },
                    {
                        "id": 65502,
                        "name": "Sinhyeon",
                        "latitude": "34.88250000",
                        "longitude": "128.62667000"
                    },
                    {
                        "id": 65521,
                        "name": "Uiryeong-gun",
                        "latitude": "35.39230000",
                        "longitude": "128.26917000"
                    },
                    {
                        "id": 65528,
                        "name": "Ungsang",
                        "latitude": "35.40611000",
                        "longitude": "129.16861000"
                    },
                    {
                        "id": 65542,
                        "name": "Yangsan",
                        "latitude": "35.34199000",
                        "longitude": "129.03358000"
                    }
                ]
            },
            {
                "id": 3856,
                "name": "South Jeolla",
                "iso2": "46",
                "latitude": "34.86790000",
                "longitude": "126.99100000",
                "type": "province",
                "cities": [
                    {
                        "id": 65267,
                        "name": "Beolgyo",
                        "latitude": "34.84897000",
                        "longitude": "127.34052000"
                    },
                    {
                        "id": 65272,
                        "name": "Boseong-gun",
                        "latitude": "34.84622000",
                        "longitude": "127.22189000"
                    },
                    {
                        "id": 65304,
                        "name": "Damyang-gun",
                        "latitude": "35.33976000",
                        "longitude": "126.99125000"
                    },
                    {
                        "id": 65320,
                        "name": "Gangjin-gun",
                        "latitude": "34.61787000",
                        "longitude": "126.76758000"
                    },
                    {
                        "id": 65342,
                        "name": "Goheung-gun",
                        "latitude": "34.58333000",
                        "longitude": "127.33333000"
                    },
                    {
                        "id": 65343,
                        "name": "Gokseong-gun",
                        "latitude": "35.21449000",
                        "longitude": "127.26280000"
                    },
                    {
                        "id": 65358,
                        "name": "Gurye-gun",
                        "latitude": "35.23616000",
                        "longitude": "127.50129000"
                    },
                    {
                        "id": 65367,
                        "name": "Gwangyang",
                        "latitude": "34.94140000",
                        "longitude": "127.69569000"
                    },
                    {
                        "id": 65368,
                        "name": "Gwangyang-si",
                        "latitude": "35.04007000",
                        "longitude": "127.60949000"
                    },
                    {
                        "id": 65373,
                        "name": "Haenam",
                        "latitude": "34.57111000",
                        "longitude": "126.59889000"
                    },
                    {
                        "id": 65374,
                        "name": "Haenam-gun",
                        "latitude": "34.54047000",
                        "longitude": "126.51870000"
                    },
                    {
                        "id": 65377,
                        "name": "Hampyeong-gun",
                        "latitude": "35.14988000",
                        "longitude": "126.53337000"
                    },
                    {
                        "id": 65392,
                        "name": "Hwasun",
                        "latitude": "35.06125000",
                        "longitude": "126.98746000"
                    },
                    {
                        "id": 65393,
                        "name": "Hwasun-gun",
                        "latitude": "35.00468000",
                        "longitude": "127.02648000"
                    },
                    {
                        "id": 65402,
                        "name": "Jangheung-gun",
                        "latitude": "34.70555000",
                        "longitude": "126.94905000"
                    },
                    {
                        "id": 65403,
                        "name": "Jangseong-gun",
                        "latitude": "35.32734000",
                        "longitude": "126.76817000"
                    },
                    {
                        "id": 65417,
                        "name": "Jindo-gun",
                        "latitude": "34.41958000",
                        "longitude": "126.22599000"
                    },
                    {
                        "id": 65432,
                        "name": "Kurye",
                        "latitude": "35.20944000",
                        "longitude": "127.46444000"
                    },
                    {
                        "id": 65434,
                        "name": "Kwangyang",
                        "latitude": "34.97528000",
                        "longitude": "127.58917000"
                    },
                    {
                        "id": 65441,
                        "name": "Mokpo",
                        "latitude": "34.81282000",
                        "longitude": "126.39181000"
                    },
                    {
                        "id": 65442,
                        "name": "Mokpo-si",
                        "latitude": "34.81226000",
                        "longitude": "126.39179000"
                    },
                    {
                        "id": 65443,
                        "name": "Muan",
                        "latitude": "34.99014000",
                        "longitude": "126.47899000"
                    },
                    {
                        "id": 65444,
                        "name": "Muan-gun",
                        "latitude": "34.95642000",
                        "longitude": "126.44041000"
                    },
                    {
                        "id": 65450,
                        "name": "Naju",
                        "latitude": "35.02920000",
                        "longitude": "126.71750000"
                    },
                    {
                        "id": 65451,
                        "name": "Naju-si",
                        "latitude": "35.05683000",
                        "longitude": "126.67362000"
                    },
                    {
                        "id": 65500,
                        "name": "Sinan",
                        "latitude": "34.82620000",
                        "longitude": "126.10863000"
                    },
                    {
                        "id": 65501,
                        "name": "Sinan-gun",
                        "latitude": "34.83107000",
                        "longitude": "126.09872000"
                    },
                    {
                        "id": 65509,
                        "name": "Suncheon",
                        "latitude": "34.95050000",
                        "longitude": "127.48784000"
                    },
                    {
                        "id": 65510,
                        "name": "Suncheon-si",
                        "latitude": "34.97162000",
                        "longitude": "127.46096000"
                    },
                    {
                        "id": 65531,
                        "name": "Wando-gun",
                        "latitude": "34.31182000",
                        "longitude": "126.73845000"
                    },
                    {
                        "id": 65547,
                        "name": "Yeongam",
                        "latitude": "34.80059000",
                        "longitude": "126.69669000"
                    },
                    {
                        "id": 65548,
                        "name": "Yeongam-gun",
                        "latitude": "34.79790000",
                        "longitude": "126.62651000"
                    },
                    {
                        "id": 65555,
                        "name": "Yeonggwang",
                        "latitude": "35.27814000",
                        "longitude": "126.51181000"
                    },
                    {
                        "id": 65556,
                        "name": "Yeonggwang-gun",
                        "latitude": "35.28711000",
                        "longitude": "126.43616000"
                    },
                    {
                        "id": 65561,
                        "name": "Yeosu",
                        "latitude": "34.76062000",
                        "longitude": "127.66215000"
                    }
                ]
            },
            {
                "id": 3852,
                "name": "Ulsan",
                "iso2": "31",
                "latitude": "35.53837730",
                "longitude": "129.31135960",
                "type": "metropolitan city",
                "cities": [
                    {
                        "id": 65275,
                        "name": "Buk-gu",
                        "latitude": "35.58243000",
                        "longitude": "129.36049000"
                    },
                    {
                        "id": 65308,
                        "name": "Dong-gu",
                        "latitude": "35.50470000",
                        "longitude": "129.41860000"
                    },
                    {
                        "id": 65423,
                        "name": "Jung-gu",
                        "latitude": "35.56840000",
                        "longitude": "129.33226000"
                    },
                    {
                        "id": 65453,
                        "name": "Nam-gu",
                        "latitude": "35.54382000",
                        "longitude": "129.32917000"
                    },
                    {
                        "id": 65525,
                        "name": "Ulju-gun",
                        "latitude": "35.56233000",
                        "longitude": "129.12690000"
                    },
                    {
                        "id": 65527,
                        "name": "Ulsan",
                        "latitude": "35.53722000",
                        "longitude": "129.31667000"
                    }
                ]
            }
        ]
    },
    {
        "id": 206,
        "name": "South Sudan",
        "iso3": "SSD",
        "iso2": "SS",
        "numeric_code": "728",
        "phonecode": "211",
        "capital": "Juba",
        "currency": "SSP",
        "currency_name": "South Sudanese pound",
        "currency_symbol": "£",
        "tld": ".ss",
        "native": "South Sudan",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Middle Africa",
        "subregion_id": 2,
        "nationality": "South Sudanese",
        "timezones": [
            {
                "zoneName": "Africa\/Juba",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Soudan ar Su",
            "ko": "남수단",
            "pt-BR": "Sudão do Sul",
            "pt": "Sudão do Sul",
            "nl": "Zuid-Soedan",
            "hr": "Južni Sudan",
            "fa": "سودان جنوبی",
            "de": "Südsudan",
            "es": "Sudán del Sur",
            "fr": "Soudan du Sud",
            "ja": "南スーダン",
            "it": "Sudan del sud",
            "zh-CN": "南苏丹",
            "tr": "Güney Sudan",
            "ru": "Южный Судан",
            "uk": "Південний Судан",
            "pl": "Sudan Południowy"
        },
        "latitude": "7.00000000",
        "longitude": "30.00000000",
        "emoji": "🇸🇸",
        "emojiU": "U+1F1F8 U+1F1F8",
        "states": [
            {
                "id": 2092,
                "name": "Central Equatoria",
                "iso2": "EC",
                "latitude": "4.61440630",
                "longitude": "31.26263660",
                "type": "state",
                "cities": []
            },
            {
                "id": 2093,
                "name": "Eastern Equatoria",
                "iso2": "EE",
                "latitude": "5.06929950",
                "longitude": "33.43835300",
                "type": "state",
                "cities": []
            },
            {
                "id": 2094,
                "name": "Jonglei State",
                "iso2": "JG",
                "latitude": "7.18196190",
                "longitude": "32.35609520",
                "type": "state",
                "cities": []
            },
            {
                "id": 2090,
                "name": "Lakes",
                "iso2": "LK",
                "latitude": "37.16282550",
                "longitude": "-95.69116230",
                "type": "state",
                "cities": [
                    {
                        "id": 104834,
                        "name": "Yirol",
                        "latitude": "6.55250000",
                        "longitude": "30.49806000"
                    }
                ]
            },
            {
                "id": 2088,
                "name": "Northern Bahr el Ghazal",
                "iso2": "BN",
                "latitude": "8.53604490",
                "longitude": "26.79678490",
                "type": "state",
                "cities": []
            },
            {
                "id": 2085,
                "name": "Unity",
                "iso2": "UY",
                "latitude": "37.78712760",
                "longitude": "-122.40340790",
                "type": "state",
                "cities": []
            },
            {
                "id": 2086,
                "name": "Upper Nile",
                "iso2": "NU",
                "latitude": "9.88942020",
                "longitude": "32.71813750",
                "type": "state",
                "cities": []
            },
            {
                "id": 2087,
                "name": "Warrap",
                "iso2": "WR",
                "latitude": "8.08862380",
                "longitude": "28.64106410",
                "type": "state",
                "cities": []
            },
            {
                "id": 2091,
                "name": "Western Bahr el Ghazal",
                "iso2": "BW",
                "latitude": "8.64523990",
                "longitude": "25.28375850",
                "type": "state",
                "cities": []
            },
            {
                "id": 2089,
                "name": "Western Equatoria",
                "iso2": "EW",
                "latitude": "5.34717990",
                "longitude": "28.29943500",
                "type": "state",
                "cities": []
            }
        ]
    },
    {
        "id": 207,
        "name": "Spain",
        "iso3": "ESP",
        "iso2": "ES",
        "numeric_code": "724",
        "phonecode": "34",
        "capital": "Madrid",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".es",
        "native": "España",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Spanish",
        "timezones": [
            {
                "zoneName": "Africa\/Ceuta",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            },
            {
                "zoneName": "Atlantic\/Canary",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "WET",
                "tzName": "Western European Time"
            },
            {
                "zoneName": "Europe\/Madrid",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Spagn",
            "ko": "스페인",
            "pt-BR": "Espanha",
            "pt": "Espanha",
            "nl": "Spanje",
            "hr": "Španjolska",
            "fa": "اسپانیا",
            "de": "Spanien",
            "es": "España",
            "fr": "Espagne",
            "ja": "スペイン",
            "it": "Spagna",
            "zh-CN": "西班牙",
            "tr": "İspanya",
            "ru": "Испания",
            "uk": "Іспанія",
            "pl": "Hiszpania"
        },
        "latitude": "40.00000000",
        "longitude": "-4.00000000",
        "emoji": "🇪🇸",
        "emojiU": "U+1F1EA U+1F1F8",
        "states": [
            {
                "id": 5089,
                "name": "A Coruña",
                "iso2": "C",
                "latitude": "43.36190400",
                "longitude": "-8.43019320",
                "type": "province",
                "cities": [
                    {
                        "id": 31906,
                        "name": "Abegondo",
                        "latitude": "43.21667000",
                        "longitude": "-8.28333000"
                    },
                    {
                        "id": 32364,
                        "name": "Amés",
                        "latitude": "42.90426000",
                        "longitude": "-8.65551000"
                    },
                    {
                        "id": 32411,
                        "name": "Aranga",
                        "latitude": "43.23469000",
                        "longitude": "-8.01705000"
                    },
                    {
                        "id": 32455,
                        "name": "Ares",
                        "latitude": "43.42995000",
                        "longitude": "-8.24254000"
                    },
                    {
                        "id": 32522,
                        "name": "Arteixo",
                        "latitude": "43.30482000",
                        "longitude": "-8.50749000"
                    },
                    {
                        "id": 32529,
                        "name": "Arzúa",
                        "latitude": "42.93333000",
                        "longitude": "-8.15000000"
                    },
                    {
                        "id": 32533,
                        "name": "As Pontes de García Rodríguez",
                        "latitude": "43.45266000",
                        "longitude": "-7.85178000"
                    },
                    {
                        "id": 151031,
                        "name": "Baña A",
                        "latitude": "42.96164580",
                        "longitude": "-8.75845680"
                    },
                    {
                        "id": 32851,
                        "name": "Bergondo",
                        "latitude": "43.31667000",
                        "longitude": "-8.23333000"
                    },
                    {
                        "id": 32879,
                        "name": "Betanzos",
                        "latitude": "43.28042000",
                        "longitude": "-8.21467000"
                    },
                    {
                        "id": 32933,
                        "name": "Boimorto",
                        "latitude": "43.00000000",
                        "longitude": "-8.13333000"
                    },
                    {
                        "id": 32934,
                        "name": "Boiro",
                        "latitude": "42.64725000",
                        "longitude": "-8.88459000"
                    },
                    {
                        "id": 151032,
                        "name": "Boqueixón",
                        "latitude": "42.81178390",
                        "longitude": "-8.41474100"
                    },
                    {
                        "id": 151033,
                        "name": "Brión",
                        "latitude": "42.86684590",
                        "longitude": "-8.67836890"
                    },
                    {
                        "id": 151034,
                        "name": "Cabana de Bergantiños",
                        "latitude": "43.18607340",
                        "longitude": "-8.89142560"
                    },
                    {
                        "id": 151035,
                        "name": "Cabanas",
                        "latitude": "43.43971340",
                        "longitude": "-8.12839420"
                    },
                    {
                        "id": 33169,
                        "name": "Camariñas",
                        "latitude": "43.13115000",
                        "longitude": "-9.18172000"
                    },
                    {
                        "id": 33176,
                        "name": "Cambre",
                        "latitude": "43.29438000",
                        "longitude": "-8.34736000"
                    },
                    {
                        "id": 151036,
                        "name": "Capela A",
                        "latitude": "43.45184690",
                        "longitude": "-8.02470050"
                    },
                    {
                        "id": 33283,
                        "name": "Carballo",
                        "latitude": "43.21300000",
                        "longitude": "-8.69104000"
                    },
                    {
                        "id": 33307,
                        "name": "Cariño",
                        "latitude": "43.74134000",
                        "longitude": "-7.86715000"
                    },
                    {
                        "id": 33312,
                        "name": "Carnota",
                        "latitude": "42.82330000",
                        "longitude": "-9.08913000"
                    },
                    {
                        "id": 33316,
                        "name": "Carral",
                        "latitude": "43.22860000",
                        "longitude": "-8.35545000"
                    },
                    {
                        "id": 33554,
                        "name": "Cedeira",
                        "latitude": "43.66044000",
                        "longitude": "-8.05719000"
                    },
                    {
                        "id": 33559,
                        "name": "Cee",
                        "latitude": "42.95466000",
                        "longitude": "-9.18800000"
                    },
                    {
                        "id": 151037,
                        "name": "Cerceda",
                        "latitude": "43.18969480",
                        "longitude": "-8.47223580"
                    },
                    {
                        "id": 33581,
                        "name": "Cerdido",
                        "latitude": "43.62063000",
                        "longitude": "-7.99959000"
                    },
                    {
                        "id": 33607,
                        "name": "Cesuras",
                        "latitude": "43.17282000",
                        "longitude": "-8.20061000"
                    },
                    {
                        "id": 33725,
                        "name": "Coirós",
                        "latitude": "43.25000000",
                        "longitude": "-8.16667000"
                    },
                    {
                        "id": 33779,
                        "name": "Corcubión",
                        "latitude": "42.94414000",
                        "longitude": "-9.19260000"
                    },
                    {
                        "id": 33792,
                        "name": "Coristanco",
                        "latitude": "43.20000000",
                        "longitude": "-8.75000000"
                    },
                    {
                        "id": 151038,
                        "name": "Coruña A",
                        "latitude": "43.36376260",
                        "longitude": "-8.41039230"
                    },
                    {
                        "id": 33882,
                        "name": "Culleredo",
                        "latitude": "43.28788000",
                        "longitude": "-8.38858000"
                    },
                    {
                        "id": 33887,
                        "name": "Curtis",
                        "latitude": "43.12374000",
                        "longitude": "-8.14818000"
                    },
                    {
                        "id": 151039,
                        "name": "Dodro",
                        "latitude": "42.71684910",
                        "longitude": "-8.71508310"
                    },
                    {
                        "id": 33960,
                        "name": "Dumbría",
                        "latitude": "43.00836000",
                        "longitude": "-9.11328000"
                    },
                    {
                        "id": 34172,
                        "name": "Fene",
                        "latitude": "43.45000000",
                        "longitude": "-8.15000000"
                    },
                    {
                        "id": 34182,
                        "name": "Ferrol",
                        "latitude": "43.48961000",
                        "longitude": "-8.21940000"
                    },
                    {
                        "id": 34192,
                        "name": "Fisterra",
                        "latitude": "42.90492000",
                        "longitude": "-9.26289000"
                    },
                    {
                        "id": 151040,
                        "name": "Frades",
                        "latitude": "43.04867640",
                        "longitude": "-8.28694780"
                    },
                    {
                        "id": 34759,
                        "name": "Irixoa",
                        "latitude": "43.28470000",
                        "longitude": "-8.05916000"
                    },
                    {
                        "id": 151042,
                        "name": "Laracha A",
                        "latitude": "43.24827000",
                        "longitude": "-8.58440490"
                    },
                    {
                        "id": 151041,
                        "name": "Laxe",
                        "latitude": "43.22121670",
                        "longitude": "-9.00635060"
                    },
                    {
                        "id": 35144,
                        "name": "Lousame",
                        "latitude": "42.76477000",
                        "longitude": "-8.84926000"
                    },
                    {
                        "id": 151043,
                        "name": "Malpica de Bergantiños",
                        "latitude": "43.28894610",
                        "longitude": "-8.80320420"
                    },
                    {
                        "id": 151044,
                        "name": "Mañón",
                        "latitude": "43.65372470",
                        "longitude": "-7.73080700"
                    },
                    {
                        "id": 35354,
                        "name": "Mazaricos",
                        "latitude": "42.94033000",
                        "longitude": "-8.97187000"
                    },
                    {
                        "id": 151045,
                        "name": "Melide",
                        "latitude": "42.91283440",
                        "longitude": "-8.02470050"
                    },
                    {
                        "id": 35410,
                        "name": "Mesia",
                        "latitude": "43.10000000",
                        "longitude": "-8.26667000"
                    },
                    {
                        "id": 35457,
                        "name": "Miño",
                        "latitude": "43.35000000",
                        "longitude": "-8.20000000"
                    },
                    {
                        "id": 35465,
                        "name": "Moeche",
                        "latitude": "43.55000000",
                        "longitude": "-8.01667000"
                    },
                    {
                        "id": 35512,
                        "name": "Monfero",
                        "latitude": "43.33333000",
                        "longitude": "-8.01667000"
                    },
                    {
                        "id": 35658,
                        "name": "Mugardos",
                        "latitude": "43.46040000",
                        "longitude": "-8.25507000"
                    },
                    {
                        "id": 35659,
                        "name": "Mugia",
                        "latitude": "43.10414000",
                        "longitude": "-9.21791000"
                    },
                    {
                        "id": 35685,
                        "name": "Muros",
                        "latitude": "42.77617000",
                        "longitude": "-9.06032000"
                    },
                    {
                        "id": 151046,
                        "name": "Muxía",
                        "latitude": "43.05475910",
                        "longitude": "-9.21205930"
                    },
                    {
                        "id": 35720,
                        "name": "Narón",
                        "latitude": "43.50175000",
                        "longitude": "-8.19082000"
                    },
                    {
                        "id": 151047,
                        "name": "Neda",
                        "latitude": "43.49942180",
                        "longitude": "-8.15790380"
                    },
                    {
                        "id": 35797,
                        "name": "Negreira",
                        "latitude": "42.90402000",
                        "longitude": "-8.74273000"
                    },
                    {
                        "id": 151048,
                        "name": "Noia",
                        "latitude": "42.78427570",
                        "longitude": "-8.88828910"
                    },
                    {
                        "id": 35876,
                        "name": "Oleiros",
                        "latitude": "43.33333000",
                        "longitude": "-8.31667000"
                    },
                    {
                        "id": 35939,
                        "name": "Ordes",
                        "latitude": "43.07654000",
                        "longitude": "-8.40900000"
                    },
                    {
                        "id": 35959,
                        "name": "Oroso",
                        "latitude": "42.98333000",
                        "longitude": "-8.43333000"
                    },
                    {
                        "id": 151049,
                        "name": "Ortigueira",
                        "latitude": "43.68316220",
                        "longitude": "-7.85216530"
                    },
                    {
                        "id": 35987,
                        "name": "Outes",
                        "latitude": "42.86189000",
                        "longitude": "-8.90181000"
                    },
                    {
                        "id": 151050,
                        "name": "Oza dos Ríos",
                        "latitude": "43.21614160",
                        "longitude": "-8.18801770"
                    },
                    {
                        "id": 151051,
                        "name": "Paderne",
                        "latitude": "43.28569570",
                        "longitude": "-8.17625760"
                    },
                    {
                        "id": 35995,
                        "name": "Padrón",
                        "latitude": "42.73875000",
                        "longitude": "-8.66057000"
                    },
                    {
                        "id": 151052,
                        "name": "Pino O",
                        "latitude": "42.93590760",
                        "longitude": "-8.33303450"
                    },
                    {
                        "id": 151053,
                        "name": "Pobra do Caramiñal A",
                        "latitude": "42.60316610",
                        "longitude": "-8.93868990"
                    },
                    {
                        "id": 151054,
                        "name": "Ponteceso",
                        "latitude": "43.26462380",
                        "longitude": "-8.86936090"
                    },
                    {
                        "id": 151055,
                        "name": "Pontedeume",
                        "latitude": "43.40744790",
                        "longitude": "-8.16990940"
                    },
                    {
                        "id": 151056,
                        "name": "Pontes de García Rodríguez As",
                        "latitude": "43.45265540",
                        "longitude": "-7.85236900"
                    },
                    {
                        "id": 36296,
                        "name": "Porto do Son",
                        "latitude": "42.72482000",
                        "longitude": "-9.00527000"
                    },
                    {
                        "id": 36603,
                        "name": "Rianxo",
                        "latitude": "42.64977000",
                        "longitude": "-8.81763000"
                    },
                    {
                        "id": 36614,
                        "name": "Ribeira",
                        "latitude": "42.74611000",
                        "longitude": "-8.44392000"
                    },
                    {
                        "id": 151057,
                        "name": "Rois",
                        "latitude": "42.76244700",
                        "longitude": "-8.70734290"
                    },
                    {
                        "id": 36732,
                        "name": "Sada",
                        "latitude": "43.35619000",
                        "longitude": "-8.25796000"
                    },
                    {
                        "id": 151058,
                        "name": "San Sadurniño",
                        "latitude": "43.53562710",
                        "longitude": "-8.05742990"
                    },
                    {
                        "id": 37021,
                        "name": "Santa Comba",
                        "latitude": "43.03306000",
                        "longitude": "-8.80925000"
                    },
                    {
                        "id": 37114,
                        "name": "Santiago de Compostela",
                        "latitude": "42.88052000",
                        "longitude": "-8.54569000"
                    },
                    {
                        "id": 37132,
                        "name": "Santiso",
                        "latitude": "42.87388000",
                        "longitude": "-8.05497000"
                    },
                    {
                        "id": 37274,
                        "name": "Sobrado",
                        "latitude": "43.03882000",
                        "longitude": "-8.02784000"
                    },
                    {
                        "id": 151059,
                        "name": "Somozas As",
                        "latitude": "43.53540080",
                        "longitude": "-7.94398400"
                    },
                    {
                        "id": 37404,
                        "name": "Teo",
                        "latitude": "42.75000000",
                        "longitude": "-8.50000000"
                    },
                    {
                        "id": 151060,
                        "name": "Toques",
                        "latitude": "42.96685120",
                        "longitude": "-7.97327120"
                    },
                    {
                        "id": 151061,
                        "name": "Tordoia",
                        "latitude": "43.10305410",
                        "longitude": "-8.59408140"
                    },
                    {
                        "id": 37608,
                        "name": "Touro",
                        "latitude": "42.86812000",
                        "longitude": "-8.30764000"
                    },
                    {
                        "id": 37624,
                        "name": "Trazo",
                        "latitude": "43.01667000",
                        "longitude": "-8.53333000"
                    },
                    {
                        "id": 151062,
                        "name": "Val do Dubra",
                        "latitude": "43.02814950",
                        "longitude": "-8.65657860"
                    },
                    {
                        "id": 37812,
                        "name": "Valdoviño",
                        "latitude": "43.60000000",
                        "longitude": "-8.13333000"
                    },
                    {
                        "id": 37902,
                        "name": "Vedra",
                        "latitude": "42.77817000",
                        "longitude": "-8.47636000"
                    },
                    {
                        "id": 151063,
                        "name": "Vilarmaior",
                        "latitude": "43.34663830",
                        "longitude": "-8.14555350"
                    },
                    {
                        "id": 38002,
                        "name": "Vilasantar",
                        "latitude": "43.07106000",
                        "longitude": "-8.12163000"
                    },
                    {
                        "id": 38388,
                        "name": "Vimianzo",
                        "latitude": "43.10988000",
                        "longitude": "-9.03351000"
                    },
                    {
                        "id": 38488,
                        "name": "Zas",
                        "latitude": "43.09885000",
                        "longitude": "-8.91558000"
                    }
                ]
            },
            {
                "id": 5109,
                "name": "Albacete",
                "iso2": "AB",
                "latitude": "38.99223120",
                "longitude": "-1.87809890",
                "type": "province",
                "cities": [
                    {
                        "id": 152202,
                        "name": "Abengibre",
                        "latitude": "39.21050490",
                        "longitude": "-1.54144360"
                    },
                    {
                        "id": 152203,
                        "name": "Alatoz",
                        "latitude": "39.09504990",
                        "longitude": "-1.36199520"
                    },
                    {
                        "id": 152204,
                        "name": "Albacete",
                        "latitude": "38.99439830",
                        "longitude": "-1.86017300"
                    },
                    {
                        "id": 152205,
                        "name": "Albatana",
                        "latitude": "38.57199980",
                        "longitude": "-1.52055980"
                    },
                    {
                        "id": 152206,
                        "name": "Alborea",
                        "latitude": "39.27920500",
                        "longitude": "-1.39577280"
                    },
                    {
                        "id": 152207,
                        "name": "Alcadozo",
                        "latitude": "38.64874000",
                        "longitude": "-1.98020130"
                    },
                    {
                        "id": 152208,
                        "name": "Alcalá del Júcar",
                        "latitude": "39.19177810",
                        "longitude": "-1.42957140"
                    },
                    {
                        "id": 152209,
                        "name": "Alcaraz",
                        "latitude": "38.66652920",
                        "longitude": "-2.49071280"
                    },
                    {
                        "id": 152210,
                        "name": "Almansa",
                        "latitude": "38.87027890",
                        "longitude": "-1.09933660"
                    },
                    {
                        "id": 152211,
                        "name": "Alpera",
                        "latitude": "38.95904490",
                        "longitude": "-1.23015970"
                    },
                    {
                        "id": 152212,
                        "name": "Ayna",
                        "latitude": "38.55373390",
                        "longitude": "-2.07172870"
                    },
                    {
                        "id": 152213,
                        "name": "Balazote",
                        "latitude": "38.88486700",
                        "longitude": "-2.15228680"
                    },
                    {
                        "id": 152215,
                        "name": "Ballestero El",
                        "latitude": "38.84124120",
                        "longitude": "-2.45485170"
                    },
                    {
                        "id": 152214,
                        "name": "Balsa de Ves",
                        "latitude": "39.26454430",
                        "longitude": "-1.19615710"
                    },
                    {
                        "id": 152216,
                        "name": "Barrax",
                        "latitude": "39.04458240",
                        "longitude": "-2.20146250"
                    },
                    {
                        "id": 152217,
                        "name": "Bienservida",
                        "latitude": "38.51707200",
                        "longitude": "-2.61086470"
                    },
                    {
                        "id": 152218,
                        "name": "Bogarra",
                        "latitude": "38.58165480",
                        "longitude": "-2.21321420"
                    },
                    {
                        "id": 152219,
                        "name": "Bonete",
                        "latitude": "38.87160070",
                        "longitude": "-1.34813010"
                    },
                    {
                        "id": 152220,
                        "name": "Bonillo El",
                        "latitude": "38.95104380",
                        "longitude": "-2.53836470"
                    },
                    {
                        "id": 152221,
                        "name": "Carcelén",
                        "latitude": "39.10216240",
                        "longitude": "-1.30897060"
                    },
                    {
                        "id": 152222,
                        "name": "Casas de Juan Núñez",
                        "latitude": "39.10020100",
                        "longitude": "-1.55786970"
                    },
                    {
                        "id": 152223,
                        "name": "Casas de Lázaro",
                        "latitude": "38.77104020",
                        "longitude": "-2.24027280"
                    },
                    {
                        "id": 152224,
                        "name": "Casas de Ves",
                        "latitude": "39.25787080",
                        "longitude": "-1.33306450"
                    },
                    {
                        "id": 152225,
                        "name": "Casas-Ibáñez",
                        "latitude": "39.28671400",
                        "longitude": "-1.47126610"
                    },
                    {
                        "id": 152226,
                        "name": "Caudete",
                        "latitude": "38.71160110",
                        "longitude": "-1.00119020"
                    },
                    {
                        "id": 152227,
                        "name": "Cenizate",
                        "latitude": "39.30231070",
                        "longitude": "-1.66270910"
                    },
                    {
                        "id": 152230,
                        "name": "Chinchilla de Monte-Aragón",
                        "latitude": "38.91953120",
                        "longitude": "-1.72529370"
                    },
                    {
                        "id": 152228,
                        "name": "Corral-Rubio",
                        "latitude": "38.83433580",
                        "longitude": "-1.45978250"
                    },
                    {
                        "id": 152229,
                        "name": "Cotillas",
                        "latitude": "38.43102560",
                        "longitude": "-2.50586950"
                    },
                    {
                        "id": 152231,
                        "name": "Elche de la Sierra",
                        "latitude": "38.45007430",
                        "longitude": "-2.04814010"
                    },
                    {
                        "id": 152232,
                        "name": "Férez",
                        "latitude": "38.35554770",
                        "longitude": "-2.00842080"
                    },
                    {
                        "id": 152233,
                        "name": "Fuensanta",
                        "latitude": "39.24515550",
                        "longitude": "-2.06902250"
                    },
                    {
                        "id": 152234,
                        "name": "Fuente-Álamo",
                        "latitude": "38.69272410",
                        "longitude": "-1.43259680"
                    },
                    {
                        "id": 152235,
                        "name": "Fuentealbilla",
                        "latitude": "39.26751270",
                        "longitude": "-1.55113230"
                    },
                    {
                        "id": 152236,
                        "name": "Gineta La",
                        "latitude": "39.11327810",
                        "longitude": "-1.99610560"
                    },
                    {
                        "id": 152237,
                        "name": "Golosalvo",
                        "latitude": "39.23942190",
                        "longitude": "-1.63569800"
                    },
                    {
                        "id": 152238,
                        "name": "Hellín",
                        "latitude": "38.50819490",
                        "longitude": "-1.69832390"
                    },
                    {
                        "id": 152239,
                        "name": "Herrera La",
                        "latitude": "38.96229560",
                        "longitude": "-2.12635360"
                    },
                    {
                        "id": 152240,
                        "name": "Higueruela",
                        "latitude": "38.96184330",
                        "longitude": "-1.44226090"
                    },
                    {
                        "id": 152241,
                        "name": "Hoya-Gonzalo",
                        "latitude": "38.95842380",
                        "longitude": "-1.55658310"
                    },
                    {
                        "id": 152242,
                        "name": "Jorquera",
                        "latitude": "39.17503020",
                        "longitude": "-1.52146760"
                    },
                    {
                        "id": 152243,
                        "name": "Letur",
                        "latitude": "38.36560790",
                        "longitude": "-2.10202480"
                    },
                    {
                        "id": 152244,
                        "name": "Lezuza",
                        "latitude": "38.94964920",
                        "longitude": "-2.35545270"
                    },
                    {
                        "id": 152245,
                        "name": "Liétor",
                        "latitude": "38.54165450",
                        "longitude": "-1.95329940"
                    },
                    {
                        "id": 152246,
                        "name": "Madrigueras",
                        "latitude": "39.23668080",
                        "longitude": "-1.80014880"
                    },
                    {
                        "id": 152247,
                        "name": "Mahora",
                        "latitude": "39.21312430",
                        "longitude": "-1.72590180"
                    },
                    {
                        "id": 152248,
                        "name": "Masegoso",
                        "latitude": "38.71821490",
                        "longitude": "-2.31630810"
                    },
                    {
                        "id": 152249,
                        "name": "Minaya",
                        "latitude": "39.27101620",
                        "longitude": "-2.32093410"
                    },
                    {
                        "id": 152250,
                        "name": "Molinicos",
                        "latitude": "38.46636990",
                        "longitude": "-2.24059130"
                    },
                    {
                        "id": 152251,
                        "name": "Montalvos",
                        "latitude": "39.16572640",
                        "longitude": "-2.02762510"
                    },
                    {
                        "id": 152252,
                        "name": "Montealegre del Castillo",
                        "latitude": "38.78884930",
                        "longitude": "-1.32703970"
                    },
                    {
                        "id": 152253,
                        "name": "Motilleja",
                        "latitude": "39.18031180",
                        "longitude": "-1.79101320"
                    },
                    {
                        "id": 152254,
                        "name": "Munera",
                        "latitude": "39.04249270",
                        "longitude": "-2.47831170"
                    },
                    {
                        "id": 152255,
                        "name": "Navas de Jorquera",
                        "latitude": "39.28008590",
                        "longitude": "-1.71921360"
                    },
                    {
                        "id": 152256,
                        "name": "Nerpio",
                        "latitude": "38.14776760",
                        "longitude": "-2.29875020"
                    },
                    {
                        "id": 152257,
                        "name": "Ontur",
                        "latitude": "38.61590340",
                        "longitude": "-1.49787160"
                    },
                    {
                        "id": 152258,
                        "name": "Ossa de Montiel",
                        "latitude": "38.96459050",
                        "longitude": "-2.74687370"
                    },
                    {
                        "id": 152259,
                        "name": "Paterna del Madera",
                        "latitude": "38.59737960",
                        "longitude": "-2.34587670"
                    },
                    {
                        "id": 152261,
                        "name": "Peñas de San Pedro",
                        "latitude": "38.72565130",
                        "longitude": "-2.00100040"
                    },
                    {
                        "id": 152260,
                        "name": "Peñascosa",
                        "latitude": "38.67165960",
                        "longitude": "-2.41042010"
                    },
                    {
                        "id": 152262,
                        "name": "Pétrola",
                        "latitude": "38.82721790",
                        "longitude": "-1.55597750"
                    },
                    {
                        "id": 152263,
                        "name": "Povedilla",
                        "latitude": "38.70074350",
                        "longitude": "-2.60342360"
                    },
                    {
                        "id": 152288,
                        "name": "Pozo Cañada",
                        "latitude": "38.80298330",
                        "longitude": "-1.73220650"
                    },
                    {
                        "id": 152265,
                        "name": "Pozo-Lorente",
                        "latitude": "39.07635100",
                        "longitude": "-1.50694550"
                    },
                    {
                        "id": 152264,
                        "name": "Pozohondo",
                        "latitude": "38.71995030",
                        "longitude": "-1.91114510"
                    },
                    {
                        "id": 152266,
                        "name": "Pozuelo",
                        "latitude": "38.80890930",
                        "longitude": "-2.10146190"
                    },
                    {
                        "id": 152267,
                        "name": "Recueja La",
                        "latitude": "39.16076760",
                        "longitude": "-1.46763940"
                    },
                    {
                        "id": 152268,
                        "name": "Riópar",
                        "latitude": "38.49824090",
                        "longitude": "-2.41716580"
                    },
                    {
                        "id": 152269,
                        "name": "Robledo",
                        "latitude": "38.75801480",
                        "longitude": "-2.45021650"
                    },
                    {
                        "id": 152270,
                        "name": "Roda La",
                        "latitude": "39.17557650",
                        "longitude": "-2.18432850"
                    },
                    {
                        "id": 152271,
                        "name": "Salobre",
                        "latitude": "38.59286060",
                        "longitude": "-2.54982080"
                    },
                    {
                        "id": 152272,
                        "name": "San Pedro",
                        "latitude": "38.77965200",
                        "longitude": "-2.16467220"
                    },
                    {
                        "id": 152273,
                        "name": "Socovos",
                        "latitude": "38.33277570",
                        "longitude": "-1.98448270"
                    },
                    {
                        "id": 152274,
                        "name": "Tarazona de la Mancha",
                        "latitude": "39.26511880",
                        "longitude": "-1.91299500"
                    },
                    {
                        "id": 152275,
                        "name": "Tobarra",
                        "latitude": "38.59095810",
                        "longitude": "-1.69307870"
                    },
                    {
                        "id": 152276,
                        "name": "Valdeganga",
                        "latitude": "39.13584320",
                        "longitude": "-1.67728380"
                    },
                    {
                        "id": 152277,
                        "name": "Vianos",
                        "latitude": "38.59470410",
                        "longitude": "-2.50989140"
                    },
                    {
                        "id": 152278,
                        "name": "Villa de Ves",
                        "latitude": "39.22265190",
                        "longitude": "-1.25932060"
                    },
                    {
                        "id": 152279,
                        "name": "Villalgordo del Júcar",
                        "latitude": "39.29664160",
                        "longitude": "-2.06308280"
                    },
                    {
                        "id": 152280,
                        "name": "Villamalea",
                        "latitude": "39.36286740",
                        "longitude": "-1.59718340"
                    },
                    {
                        "id": 152281,
                        "name": "Villapalacios",
                        "latitude": "38.57561360",
                        "longitude": "-2.63319520"
                    },
                    {
                        "id": 152282,
                        "name": "Villarrobledo",
                        "latitude": "39.26831540",
                        "longitude": "-2.60156350"
                    },
                    {
                        "id": 152283,
                        "name": "Villatoya",
                        "latitude": "39.32334930",
                        "longitude": "-1.33728230"
                    },
                    {
                        "id": 152284,
                        "name": "Villavaliente",
                        "latitude": "39.12643190",
                        "longitude": "-1.45736530"
                    },
                    {
                        "id": 152285,
                        "name": "Villaverde de Guadalimar",
                        "latitude": "38.45632780",
                        "longitude": "-2.51835670"
                    },
                    {
                        "id": 152286,
                        "name": "Viveros",
                        "latitude": "38.77265670",
                        "longitude": "-2.57553000"
                    },
                    {
                        "id": 152287,
                        "name": "Yeste",
                        "latitude": "38.36543760",
                        "longitude": "-2.32154600"
                    }
                ]
            },
            {
                "id": 5108,
                "name": "Alicante",
                "iso2": "A",
                "latitude": "38.35795460",
                "longitude": "-0.54256340",
                "type": "province",
                "cities": [
                    {
                        "id": 31941,
                        "name": "Adsubia",
                        "latitude": "38.84819000",
                        "longitude": "-0.15324000"
                    },
                    {
                        "id": 31947,
                        "name": "Agost",
                        "latitude": "38.44003000",
                        "longitude": "-0.63836000"
                    },
                    {
                        "id": 31949,
                        "name": "Agres",
                        "latitude": "38.78333000",
                        "longitude": "-0.51667000"
                    },
                    {
                        "id": 152154,
                        "name": "Aigües",
                        "latitude": "38.51595560",
                        "longitude": "-0.36542040"
                    },
                    {
                        "id": 32032,
                        "name": "Albatera",
                        "latitude": "38.17902000",
                        "longitude": "-0.87059000"
                    },
                    {
                        "id": 32067,
                        "name": "Alcalalí",
                        "latitude": "38.75038000",
                        "longitude": "-0.04013000"
                    },
                    {
                        "id": 32099,
                        "name": "Alcocer de Planes",
                        "latitude": "38.79501000",
                        "longitude": "-0.40244000"
                    },
                    {
                        "id": 152155,
                        "name": "Alcoleja",
                        "latitude": "38.67512260",
                        "longitude": "-0.33160380"
                    },
                    {
                        "id": 152156,
                        "name": "Alcoy\/Alcoi",
                        "latitude": "38.69870660",
                        "longitude": "-0.48109370"
                    },
                    {
                        "id": 32190,
                        "name": "Alfafara",
                        "latitude": "38.77339000",
                        "longitude": "-0.55551000"
                    },
                    {
                        "id": 152157,
                        "name": "Alfàs del Pi l",
                        "latitude": "38.57855200",
                        "longitude": "-0.09966400"
                    },
                    {
                        "id": 32226,
                        "name": "Algorfa",
                        "latitude": "38.08636000",
                        "longitude": "-0.79646000"
                    },
                    {
                        "id": 32230,
                        "name": "Algueña",
                        "latitude": "38.33905000",
                        "longitude": "-1.00433000"
                    },
                    {
                        "id": 152158,
                        "name": "Alicante\/Alacant",
                        "latitude": "38.34576850",
                        "longitude": "-0.49094440"
                    },
                    {
                        "id": 32306,
                        "name": "Almoradí",
                        "latitude": "38.10879000",
                        "longitude": "-0.79197000"
                    },
                    {
                        "id": 32310,
                        "name": "Almudaina",
                        "latitude": "38.75999000",
                        "longitude": "-0.35149000"
                    },
                    {
                        "id": 152159,
                        "name": "Alqueria dAsnar l",
                        "latitude": "38.77334310",
                        "longitude": "-0.42606910"
                    },
                    {
                        "id": 32340,
                        "name": "Altea",
                        "latitude": "38.59885000",
                        "longitude": "-0.05139000"
                    },
                    {
                        "id": 32537,
                        "name": "Aspe",
                        "latitude": "38.34511000",
                        "longitude": "-0.76721000"
                    },
                    {
                        "id": 32626,
                        "name": "Balones",
                        "latitude": "38.73726000",
                        "longitude": "-0.34324000"
                    },
                    {
                        "id": 152160,
                        "name": "Banyeres de Mariola",
                        "latitude": "38.71532720",
                        "longitude": "-0.65951840"
                    },
                    {
                        "id": 32776,
                        "name": "Benasau",
                        "latitude": "38.69047000",
                        "longitude": "-0.34278000"
                    },
                    {
                        "id": 32785,
                        "name": "Beneixama",
                        "latitude": "38.70000000",
                        "longitude": "-0.76667000"
                    },
                    {
                        "id": 32787,
                        "name": "Benejúzar",
                        "latitude": "38.07728000",
                        "longitude": "-0.83942000"
                    },
                    {
                        "id": 32789,
                        "name": "Benferri",
                        "latitude": "38.14129000",
                        "longitude": "-0.96212000"
                    },
                    {
                        "id": 32790,
                        "name": "Beniarbeig",
                        "latitude": "38.82232000",
                        "longitude": "-0.00210000"
                    },
                    {
                        "id": 32791,
                        "name": "Beniardá",
                        "latitude": "38.68433000",
                        "longitude": "-0.21629000"
                    },
                    {
                        "id": 32793,
                        "name": "Beniarrés",
                        "latitude": "38.82019000",
                        "longitude": "-0.37741000"
                    },
                    {
                        "id": 32798,
                        "name": "Benidoleig",
                        "latitude": "38.79278000",
                        "longitude": "-0.02992000"
                    },
                    {
                        "id": 32799,
                        "name": "Benidorm",
                        "latitude": "38.53816000",
                        "longitude": "-0.13098000"
                    },
                    {
                        "id": 32804,
                        "name": "Benifallim",
                        "latitude": "38.66259000",
                        "longitude": "-0.39994000"
                    },
                    {
                        "id": 152162,
                        "name": "Benifato",
                        "latitude": "38.67340230",
                        "longitude": "-0.22886330"
                    },
                    {
                        "id": 152161,
                        "name": "Benigembla",
                        "latitude": "38.75492750",
                        "longitude": "-0.10879870"
                    },
                    {
                        "id": 32807,
                        "name": "Benijofar",
                        "latitude": "38.07785000",
                        "longitude": "-0.73680000"
                    },
                    {
                        "id": 32808,
                        "name": "Benilloba",
                        "latitude": "38.70012000",
                        "longitude": "-0.38998000"
                    },
                    {
                        "id": 32809,
                        "name": "Benillup",
                        "latitude": "38.75397000",
                        "longitude": "-0.37991000"
                    },
                    {
                        "id": 32810,
                        "name": "Benimantell",
                        "latitude": "38.67709000",
                        "longitude": "-0.21057000"
                    },
                    {
                        "id": 32811,
                        "name": "Benimarfull",
                        "latitude": "38.77590000",
                        "longitude": "-0.39079000"
                    },
                    {
                        "id": 32812,
                        "name": "Benimassot",
                        "latitude": "38.75000000",
                        "longitude": "-0.28333000"
                    },
                    {
                        "id": 32813,
                        "name": "Benimeli",
                        "latitude": "38.82362000",
                        "longitude": "-0.04221000"
                    },
                    {
                        "id": 32819,
                        "name": "Benissa",
                        "latitude": "38.71492000",
                        "longitude": "0.04849000"
                    },
                    {
                        "id": 152163,
                        "name": "Benitachell\/Poble Nou de Benitatxell el",
                        "latitude": "38.73130140",
                        "longitude": "0.14356720"
                    },
                    {
                        "id": 32885,
                        "name": "Biar",
                        "latitude": "38.63117000",
                        "longitude": "-0.76458000"
                    },
                    {
                        "id": 32892,
                        "name": "Bigastro",
                        "latitude": "38.06237000",
                        "longitude": "-0.89841000"
                    },
                    {
                        "id": 32941,
                        "name": "Bolulla",
                        "latitude": "38.67529000",
                        "longitude": "-0.11184000"
                    },
                    {
                        "id": 33035,
                        "name": "Busot",
                        "latitude": "38.48206000",
                        "longitude": "-0.41918000"
                    },
                    {
                        "id": 33146,
                        "name": "Callosa de Segura",
                        "latitude": "38.12497000",
                        "longitude": "-0.87822000"
                    },
                    {
                        "id": 152164,
                        "name": "Callosa dEn Sarrià",
                        "latitude": "38.65076840",
                        "longitude": "-0.12161810"
                    },
                    {
                        "id": 33151,
                        "name": "Calp",
                        "latitude": "38.64470000",
                        "longitude": "0.04450000"
                    },
                    {
                        "id": 152165,
                        "name": "Campello el",
                        "latitude": "38.42898040",
                        "longitude": "-0.39781600"
                    },
                    {
                        "id": 152166,
                        "name": "Campo de Mirra\/Camp de Mirra el",
                        "latitude": "38.68774710",
                        "longitude": "-0.77883630"
                    },
                    {
                        "id": 152167,
                        "name": "Cañada",
                        "latitude": "38.68677940",
                        "longitude": "-0.82463860"
                    },
                    {
                        "id": 33396,
                        "name": "Castalla",
                        "latitude": "38.59694000",
                        "longitude": "-0.67207000"
                    },
                    {
                        "id": 33411,
                        "name": "Castell de Castells",
                        "latitude": "38.72555000",
                        "longitude": "-0.19242000"
                    },
                    {
                        "id": 152173,
                        "name": "Castell de Guadalest el",
                        "latitude": "38.67696390",
                        "longitude": "-0.19832360"
                    },
                    {
                        "id": 33516,
                        "name": "Catral",
                        "latitude": "38.16061000",
                        "longitude": "-0.80209000"
                    },
                    {
                        "id": 33716,
                        "name": "Cocentaina",
                        "latitude": "38.73975000",
                        "longitude": "-0.43976000"
                    },
                    {
                        "id": 33757,
                        "name": "Confrides",
                        "latitude": "38.68451000",
                        "longitude": "-0.26890000"
                    },
                    {
                        "id": 33829,
                        "name": "Cox",
                        "latitude": "38.14164000",
                        "longitude": "-0.88736000"
                    },
                    {
                        "id": 152168,
                        "name": "Crevillent",
                        "latitude": "38.24468440",
                        "longitude": "-0.81136360"
                    },
                    {
                        "id": 33915,
                        "name": "Daya Nueva",
                        "latitude": "38.11313000",
                        "longitude": "-0.76028000"
                    },
                    {
                        "id": 33916,
                        "name": "Daya Vieja",
                        "latitude": "38.10480000",
                        "longitude": "-0.73804000"
                    },
                    {
                        "id": 33926,
                        "name": "Denia",
                        "latitude": "38.84078000",
                        "longitude": "0.10574000"
                    },
                    {
                        "id": 33936,
                        "name": "Dolores",
                        "latitude": "38.14002000",
                        "longitude": "-0.77088000"
                    },
                    {
                        "id": 152170,
                        "name": "Elche\/Elx",
                        "latitude": "38.26918270",
                        "longitude": "-0.71142430"
                    },
                    {
                        "id": 34033,
                        "name": "Elda",
                        "latitude": "38.47783000",
                        "longitude": "-0.79157000"
                    },
                    {
                        "id": 34156,
                        "name": "Facheca",
                        "latitude": "38.73501000",
                        "longitude": "-0.26766000"
                    },
                    {
                        "id": 34160,
                        "name": "Famorca",
                        "latitude": "38.73101000",
                        "longitude": "-0.24726000"
                    },
                    {
                        "id": 34189,
                        "name": "Finestrat",
                        "latitude": "38.56737000",
                        "longitude": "-0.21235000"
                    },
                    {
                        "id": 152174,
                        "name": "Fondó de les Neus el\/Hondón de las Nieves",
                        "latitude": "38.30839710",
                        "longitude": "-0.85258680"
                    },
                    {
                        "id": 152171,
                        "name": "Formentera del Segura",
                        "latitude": "38.08525050",
                        "longitude": "-0.74555810"
                    },
                    {
                        "id": 152172,
                        "name": "Gaianes",
                        "latitude": "38.81263950",
                        "longitude": "-0.40957280"
                    },
                    {
                        "id": 34435,
                        "name": "Gata de Gorgos",
                        "latitude": "38.77443000",
                        "longitude": "0.08538000"
                    },
                    {
                        "id": 34487,
                        "name": "Gorga",
                        "latitude": "38.71896000",
                        "longitude": "-0.35589000"
                    },
                    {
                        "id": 34501,
                        "name": "Granja de Rocamora",
                        "latitude": "38.15157000",
                        "longitude": "-0.89170000"
                    },
                    {
                        "id": 34535,
                        "name": "Guardamar del Segura",
                        "latitude": "38.09031000",
                        "longitude": "-0.65556000"
                    },
                    {
                        "id": 34635,
                        "name": "Hondón de los Frailes",
                        "latitude": "38.27390000",
                        "longitude": "-0.92938000"
                    },
                    {
                        "id": 34727,
                        "name": "Ibi",
                        "latitude": "38.62533000",
                        "longitude": "-0.57225000"
                    },
                    {
                        "id": 34788,
                        "name": "Jacarilla",
                        "latitude": "38.06247000",
                        "longitude": "-0.86822000"
                    },
                    {
                        "id": 152176,
                        "name": "Jávea\/Xàbia",
                        "latitude": "38.78891320",
                        "longitude": "0.16605730"
                    },
                    {
                        "id": 152177,
                        "name": "Jijona\/Xixona",
                        "latitude": "38.54694670",
                        "longitude": "-0.50688240"
                    },
                    {
                        "id": 152179,
                        "name": "Llíber",
                        "latitude": "38.74270910",
                        "longitude": "0.00641180"
                    },
                    {
                        "id": 152178,
                        "name": "Lorcha\/Orxa l",
                        "latitude": "38.84431590",
                        "longitude": "-0.31074030"
                    },
                    {
                        "id": 35433,
                        "name": "Millena",
                        "latitude": "38.73082000",
                        "longitude": "-0.36274000"
                    },
                    {
                        "id": 35516,
                        "name": "Monforte del Cid",
                        "latitude": "38.38027000",
                        "longitude": "-0.72850000"
                    },
                    {
                        "id": 152180,
                        "name": "Monóvar\/Monòver",
                        "latitude": "38.41825140",
                        "longitude": "-0.92475010"
                    },
                    {
                        "id": 152201,
                        "name": "Montesinos Los",
                        "latitude": "38.02772690",
                        "longitude": "-0.74496400"
                    },
                    {
                        "id": 35680,
                        "name": "Murla",
                        "latitude": "38.76037000",
                        "longitude": "-0.08208000"
                    },
                    {
                        "id": 152181,
                        "name": "Muro de Alcoy",
                        "latitude": "38.78054060",
                        "longitude": "-0.43721140"
                    },
                    {
                        "id": 35691,
                        "name": "Mutxamel",
                        "latitude": "38.41580000",
                        "longitude": "-0.44529000"
                    },
                    {
                        "id": 35828,
                        "name": "Novelda",
                        "latitude": "38.38479000",
                        "longitude": "-0.76773000"
                    },
                    {
                        "id": 152182,
                        "name": "Nucia la",
                        "latitude": "38.60571210",
                        "longitude": "-0.12610130"
                    },
                    {
                        "id": 35923,
                        "name": "Ondara",
                        "latitude": "38.82817000",
                        "longitude": "0.01720000"
                    },
                    {
                        "id": 35925,
                        "name": "Onil",
                        "latitude": "38.62606000",
                        "longitude": "-0.67313000"
                    },
                    {
                        "id": 35932,
                        "name": "Orba",
                        "latitude": "38.78041000",
                        "longitude": "-0.06278000"
                    },
                    {
                        "id": 35950,
                        "name": "Orihuela",
                        "latitude": "38.08483000",
                        "longitude": "-0.94401000"
                    },
                    {
                        "id": 152183,
                        "name": "Orxeta",
                        "latitude": "38.56284230",
                        "longitude": "-0.26259100"
                    },
                    {
                        "id": 36062,
                        "name": "Parcent",
                        "latitude": "38.74502000",
                        "longitude": "-0.06446000"
                    },
                    {
                        "id": 36095,
                        "name": "Pedreguer",
                        "latitude": "38.79312000",
                        "longitude": "0.03411000"
                    },
                    {
                        "id": 36115,
                        "name": "Pego",
                        "latitude": "38.84305000",
                        "longitude": "-0.11707000"
                    },
                    {
                        "id": 152184,
                        "name": "Penàguila",
                        "latitude": "38.67970650",
                        "longitude": "-0.35953930"
                    },
                    {
                        "id": 152185,
                        "name": "Petrer",
                        "latitude": "38.48079480",
                        "longitude": "-0.77192440"
                    },
                    {
                        "id": 36187,
                        "name": "Pilar de la Horadada",
                        "latitude": "37.86591000",
                        "longitude": "-0.79256000"
                    },
                    {
                        "id": 152186,
                        "name": "Pinós el\/Pinoso",
                        "latitude": "38.40351640",
                        "longitude": "-1.04111070"
                    },
                    {
                        "id": 36234,
                        "name": "Planes",
                        "latitude": "38.78524000",
                        "longitude": "-0.34271000"
                    },
                    {
                        "id": 152200,
                        "name": "Poblets els",
                        "latitude": "38.85478800",
                        "longitude": "0.01727410"
                    },
                    {
                        "id": 36264,
                        "name": "Polop",
                        "latitude": "38.62258000",
                        "longitude": "-0.13090000"
                    },
                    {
                        "id": 152169,
                        "name": "Quatretondeta",
                        "latitude": "38.72362780",
                        "longitude": "-0.31632240"
                    },
                    {
                        "id": 36539,
                        "name": "Rafal",
                        "latitude": "38.10458000",
                        "longitude": "-0.84904000"
                    },
                    {
                        "id": 152187,
                        "name": "Ràfol dAlmúnia El",
                        "latitude": "38.82043110",
                        "longitude": "-0.05289920"
                    },
                    {
                        "id": 36562,
                        "name": "Redován",
                        "latitude": "38.11619000",
                        "longitude": "-0.90981000"
                    },
                    {
                        "id": 36571,
                        "name": "Relleu",
                        "latitude": "38.58725000",
                        "longitude": "-0.31157000"
                    },
                    {
                        "id": 36665,
                        "name": "Rojales",
                        "latitude": "38.08799000",
                        "longitude": "-0.72544000"
                    },
                    {
                        "id": 152188,
                        "name": "Romana la",
                        "latitude": "38.36714620",
                        "longitude": "-0.89731420"
                    },
                    {
                        "id": 36737,
                        "name": "Sagra",
                        "latitude": "38.81102000",
                        "longitude": "-0.06559000"
                    },
                    {
                        "id": 36763,
                        "name": "Salinas",
                        "latitude": "38.52025000",
                        "longitude": "-0.91202000"
                    },
                    {
                        "id": 152189,
                        "name": "San Fulgencio",
                        "latitude": "38.11199970",
                        "longitude": "-0.71924280"
                    },
                    {
                        "id": 36839,
                        "name": "San Isidro",
                        "latitude": "28.07617000",
                        "longitude": "-16.55800000"
                    },
                    {
                        "id": 36883,
                        "name": "San Miguel de Salinas",
                        "latitude": "37.97972000",
                        "longitude": "-0.78904000"
                    },
                    {
                        "id": 152191,
                        "name": "San Vicente del Raspeig\/Sant Vicent del Raspeig",
                        "latitude": "38.39842120",
                        "longitude": "-0.52335070"
                    },
                    {
                        "id": 36942,
                        "name": "Sanet y Negrals",
                        "latitude": "38.81967000",
                        "longitude": "-0.03406000"
                    },
                    {
                        "id": 152190,
                        "name": "Sant Joan dAlacant",
                        "latitude": "38.40171700",
                        "longitude": "-0.43566040"
                    },
                    {
                        "id": 37098,
                        "name": "Santa Pola",
                        "latitude": "38.19165000",
                        "longitude": "-0.56580000"
                    },
                    {
                        "id": 37181,
                        "name": "Sax",
                        "latitude": "38.53729000",
                        "longitude": "-0.81779000"
                    },
                    {
                        "id": 37203,
                        "name": "Sella",
                        "latitude": "38.60926000",
                        "longitude": "-0.27305000"
                    },
                    {
                        "id": 37210,
                        "name": "Senija",
                        "latitude": "38.72804000",
                        "longitude": "0.04176000"
                    },
                    {
                        "id": 152192,
                        "name": "Tàrbena",
                        "latitude": "38.69399730",
                        "longitude": "-0.10209020"
                    },
                    {
                        "id": 37418,
                        "name": "Teulada",
                        "latitude": "38.72940000",
                        "longitude": "0.10383000"
                    },
                    {
                        "id": 37420,
                        "name": "Tibi",
                        "latitude": "38.53072000",
                        "longitude": "-0.57776000"
                    },
                    {
                        "id": 37444,
                        "name": "Tollos",
                        "latitude": "38.75629000",
                        "longitude": "-0.27466000"
                    },
                    {
                        "id": 37470,
                        "name": "Tormos",
                        "latitude": "38.80143000",
                        "longitude": "-0.07160000"
                    },
                    {
                        "id": 152193,
                        "name": "Torremanzanas\/Torre de les Maçanes la",
                        "latitude": "38.60798090",
                        "longitude": "-0.41988220"
                    },
                    {
                        "id": 37584,
                        "name": "Torrevieja",
                        "latitude": "37.97872000",
                        "longitude": "-0.68222000"
                    },
                    {
                        "id": 152194,
                        "name": "Vall dAlcalà la",
                        "latitude": "38.36383810",
                        "longitude": "-0.48059240"
                    },
                    {
                        "id": 152196,
                        "name": "Vall de Gallinera",
                        "latitude": "38.83077060",
                        "longitude": "-0.23384730"
                    },
                    {
                        "id": 152197,
                        "name": "Vall de Laguar la",
                        "latitude": "38.77338430",
                        "longitude": "-0.13545860"
                    },
                    {
                        "id": 152195,
                        "name": "Vall dEbo la",
                        "latitude": "38.80538560",
                        "longitude": "-0.15939580"
                    },
                    {
                        "id": 152198,
                        "name": "Verger el",
                        "latitude": "38.84668780",
                        "longitude": "-0.00466300"
                    },
                    {
                        "id": 152199,
                        "name": "Villajoyosa\/Vila Joiosa la",
                        "latitude": "38.51247440",
                        "longitude": "-0.23268700"
                    },
                    {
                        "id": 38369,
                        "name": "Villena",
                        "latitude": "38.63730000",
                        "longitude": "-0.86568000"
                    },
                    {
                        "id": 152175,
                        "name": "Xaló",
                        "latitude": "38.74065370",
                        "longitude": "-0.01101430"
                    }
                ]
            },
            {
                "id": 5095,
                "name": "Almeria",
                "iso2": "AL",
                "latitude": "36.84152680",
                "longitude": "-2.47462610",
                "type": "province",
                "cities": [
                    {
                        "id": 31915,
                        "name": "Abla",
                        "latitude": "37.14245000",
                        "longitude": "-2.77808000"
                    },
                    {
                        "id": 31918,
                        "name": "Abrucena",
                        "latitude": "37.13226000",
                        "longitude": "-2.79711000"
                    },
                    {
                        "id": 31936,
                        "name": "Adra",
                        "latitude": "36.74961000",
                        "longitude": "-3.02055000"
                    },
                    {
                        "id": 32063,
                        "name": "Albánchez",
                        "latitude": "37.28361000",
                        "longitude": "-2.18229000"
                    },
                    {
                        "id": 151347,
                        "name": "Alboloduy",
                        "latitude": "37.03299600",
                        "longitude": "-2.62109820"
                    },
                    {
                        "id": 32056,
                        "name": "Albox",
                        "latitude": "37.38856000",
                        "longitude": "-2.14949000"
                    },
                    {
                        "id": 32103,
                        "name": "Alcolea",
                        "latitude": "36.97458000",
                        "longitude": "-2.96150000"
                    },
                    {
                        "id": 32138,
                        "name": "Alcóntar",
                        "latitude": "37.33647000",
                        "longitude": "-2.59725000"
                    },
                    {
                        "id": 32130,
                        "name": "Alcudia de Monteagud",
                        "latitude": "37.23529000",
                        "longitude": "-2.26650000"
                    },
                    {
                        "id": 32232,
                        "name": "Alhabia",
                        "latitude": "36.99003000",
                        "longitude": "-2.58655000"
                    },
                    {
                        "id": 32233,
                        "name": "Alhama de Almería",
                        "latitude": "36.95692000",
                        "longitude": "-2.56861000"
                    },
                    {
                        "id": 32245,
                        "name": "Alicún",
                        "latitude": "36.96580000",
                        "longitude": "-2.60212000"
                    },
                    {
                        "id": 32290,
                        "name": "Almería",
                        "latitude": "37.16667000",
                        "longitude": "-2.33333000"
                    },
                    {
                        "id": 32316,
                        "name": "Almócita",
                        "latitude": "37.00262000",
                        "longitude": "-2.79051000"
                    },
                    {
                        "id": 32336,
                        "name": "Alsodux",
                        "latitude": "37.00247000",
                        "longitude": "-2.59476000"
                    },
                    {
                        "id": 32390,
                        "name": "Antas",
                        "latitude": "37.24536000",
                        "longitude": "-1.91760000"
                    },
                    {
                        "id": 32426,
                        "name": "Arboleas",
                        "latitude": "37.35024000",
                        "longitude": "-2.07384000"
                    },
                    {
                        "id": 32491,
                        "name": "Armuña de Almanzora",
                        "latitude": "37.35030000",
                        "longitude": "-2.41150000"
                    },
                    {
                        "id": 151348,
                        "name": "Bacares",
                        "latitude": "37.26077300",
                        "longitude": "-2.45346140"
                    },
                    {
                        "id": 32699,
                        "name": "Bayárcal",
                        "latitude": "37.03073000",
                        "longitude": "-2.99606000"
                    },
                    {
                        "id": 32696,
                        "name": "Bayarque",
                        "latitude": "37.33062000",
                        "longitude": "-2.43610000"
                    },
                    {
                        "id": 33057,
                        "name": "Bédar",
                        "latitude": "37.19389000",
                        "longitude": "-1.98166000"
                    },
                    {
                        "id": 32732,
                        "name": "Beires",
                        "latitude": "37.01237000",
                        "longitude": "-2.79134000"
                    },
                    {
                        "id": 32762,
                        "name": "Benahadux",
                        "latitude": "36.92493000",
                        "longitude": "-2.45941000"
                    },
                    {
                        "id": 32823,
                        "name": "Benitagla",
                        "latitude": "37.23138000",
                        "longitude": "-2.23935000"
                    },
                    {
                        "id": 32824,
                        "name": "Benizalón",
                        "latitude": "37.21213000",
                        "longitude": "-2.24180000"
                    },
                    {
                        "id": 32827,
                        "name": "Bentarique",
                        "latitude": "36.98823000",
                        "longitude": "-2.61991000"
                    },
                    {
                        "id": 32853,
                        "name": "Berja",
                        "latitude": "36.84693000",
                        "longitude": "-2.94966000"
                    },
                    {
                        "id": 33245,
                        "name": "Canjáyar",
                        "latitude": "37.00959000",
                        "longitude": "-2.73943000"
                    },
                    {
                        "id": 33260,
                        "name": "Cantoria",
                        "latitude": "37.35146000",
                        "longitude": "-2.19209000"
                    },
                    {
                        "id": 33285,
                        "name": "Carboneras",
                        "latitude": "36.99666000",
                        "longitude": "-1.89651000"
                    },
                    {
                        "id": 33488,
                        "name": "Castro de Filabres",
                        "latitude": "37.18484000",
                        "longitude": "-2.44024000"
                    },
                    {
                        "id": 33627,
                        "name": "Chercos",
                        "latitude": "37.25450000",
                        "longitude": "-2.26657000"
                    },
                    {
                        "id": 33643,
                        "name": "Chirivel",
                        "latitude": "37.59527000",
                        "longitude": "-2.26844000"
                    },
                    {
                        "id": 33902,
                        "name": "Cóbdar",
                        "latitude": "37.26166000",
                        "longitude": "-2.21098000"
                    },
                    {
                        "id": 33876,
                        "name": "Cuevas del Almanzora",
                        "latitude": "37.29678000",
                        "longitude": "-1.88218000"
                    },
                    {
                        "id": 33911,
                        "name": "Dalías",
                        "latitude": "36.82179000",
                        "longitude": "-2.87138000"
                    },
                    {
                        "id": 151359,
                        "name": "Ejido El",
                        "latitude": "36.77071590",
                        "longitude": "-2.79790100"
                    },
                    {
                        "id": 34060,
                        "name": "Enix",
                        "latitude": "36.87732000",
                        "longitude": "-2.60180000"
                    },
                    {
                        "id": 151349,
                        "name": "Felix",
                        "latitude": "36.86961030",
                        "longitude": "-2.70832870"
                    },
                    {
                        "id": 34194,
                        "name": "Fiñana",
                        "latitude": "37.17150000",
                        "longitude": "-2.84011000"
                    },
                    {
                        "id": 34188,
                        "name": "Fines",
                        "latitude": "37.36074000",
                        "longitude": "-2.25810000"
                    },
                    {
                        "id": 34205,
                        "name": "Fondón",
                        "latitude": "36.98020000",
                        "longitude": "-2.85957000"
                    },
                    {
                        "id": 34558,
                        "name": "Gádor",
                        "latitude": "36.95322000",
                        "longitude": "-2.49254000"
                    },
                    {
                        "id": 151350,
                        "name": "Gallardos Los",
                        "latitude": "37.16889990",
                        "longitude": "-1.94015240"
                    },
                    {
                        "id": 34427,
                        "name": "Garrucha",
                        "latitude": "37.18141000",
                        "longitude": "-1.82252000"
                    },
                    {
                        "id": 34562,
                        "name": "Gérgal",
                        "latitude": "37.11886000",
                        "longitude": "-2.54012000"
                    },
                    {
                        "id": 34706,
                        "name": "Huécija",
                        "latitude": "36.96804000",
                        "longitude": "-2.60941000"
                    },
                    {
                        "id": 34711,
                        "name": "Huércal de Almería",
                        "latitude": "36.88507000",
                        "longitude": "-2.43760000"
                    },
                    {
                        "id": 34712,
                        "name": "Huércal-Overa",
                        "latitude": "37.38918000",
                        "longitude": "-1.94300000"
                    },
                    {
                        "id": 34746,
                        "name": "Illar",
                        "latitude": "36.98562000",
                        "longitude": "-2.63871000"
                    },
                    {
                        "id": 34757,
                        "name": "Instinción",
                        "latitude": "36.99344000",
                        "longitude": "-2.66046000"
                    },
                    {
                        "id": 34977,
                        "name": "Laroya",
                        "latitude": "37.29771000",
                        "longitude": "-2.33419000"
                    },
                    {
                        "id": 35004,
                        "name": "Laujar de Andarax",
                        "latitude": "36.99516000",
                        "longitude": "-2.89033000"
                    },
                    {
                        "id": 151351,
                        "name": "Líjar",
                        "latitude": "37.29487710",
                        "longitude": "-2.21844010"
                    },
                    {
                        "id": 35147,
                        "name": "Lubrín",
                        "latitude": "37.21538000",
                        "longitude": "-2.06677000"
                    },
                    {
                        "id": 35148,
                        "name": "Lucainena de las Torres",
                        "latitude": "37.04037000",
                        "longitude": "-2.20095000"
                    },
                    {
                        "id": 35177,
                        "name": "Lúcar",
                        "latitude": "37.40035000",
                        "longitude": "-2.42496000"
                    },
                    {
                        "id": 35179,
                        "name": "Macael",
                        "latitude": "37.33318000",
                        "longitude": "-2.30087000"
                    },
                    {
                        "id": 35312,
                        "name": "María",
                        "latitude": "37.71023000",
                        "longitude": "-2.16454000"
                    },
                    {
                        "id": 35473,
                        "name": "Mojacar",
                        "latitude": "37.14020000",
                        "longitude": "-1.85102000"
                    },
                    {
                        "id": 151360,
                        "name": "Mojonera La",
                        "latitude": "36.75318160",
                        "longitude": "-2.68223560"
                    },
                    {
                        "id": 151352,
                        "name": "Nacimiento",
                        "latitude": "37.10611060",
                        "longitude": "-2.64839840"
                    },
                    {
                        "id": 35844,
                        "name": "Níjar",
                        "latitude": "36.96655000",
                        "longitude": "-2.20595000"
                    },
                    {
                        "id": 35863,
                        "name": "Ohanes",
                        "latitude": "37.03861000",
                        "longitude": "-2.74524000"
                    },
                    {
                        "id": 35914,
                        "name": "Olula de Castro",
                        "latitude": "37.17475000",
                        "longitude": "-2.47430000"
                    },
                    {
                        "id": 35915,
                        "name": "Olula del Río",
                        "latitude": "37.35445000",
                        "longitude": "-2.29754000"
                    },
                    {
                        "id": 35948,
                        "name": "Oria",
                        "latitude": "37.48530000",
                        "longitude": "-2.29292000"
                    },
                    {
                        "id": 35997,
                        "name": "Padules",
                        "latitude": "36.99813000",
                        "longitude": "-2.77367000"
                    },
                    {
                        "id": 36072,
                        "name": "Partaloa",
                        "latitude": "37.40764000",
                        "longitude": "-2.22526000"
                    },
                    {
                        "id": 36081,
                        "name": "Paterna del Río",
                        "latitude": "37.02222000",
                        "longitude": "-2.95343000"
                    },
                    {
                        "id": 151353,
                        "name": "Pechina",
                        "latitude": "36.91639570",
                        "longitude": "-2.44030120"
                    },
                    {
                        "id": 36469,
                        "name": "Pulpí",
                        "latitude": "37.41154000",
                        "longitude": "-1.74496000"
                    },
                    {
                        "id": 36475,
                        "name": "Purchena",
                        "latitude": "37.34744000",
                        "longitude": "-2.36080000"
                    },
                    {
                        "id": 36714,
                        "name": "Rágol",
                        "latitude": "36.99523000",
                        "longitude": "-2.68178000"
                    },
                    {
                        "id": 36630,
                        "name": "Rioja",
                        "latitude": "36.94508000",
                        "longitude": "-2.46302000"
                    },
                    {
                        "id": 36675,
                        "name": "Roquetas de Mar",
                        "latitude": "36.76419000",
                        "longitude": "-2.61475000"
                    },
                    {
                        "id": 151354,
                        "name": "Santa Cruz de Marchena",
                        "latitude": "37.01663910",
                        "longitude": "-2.60249350"
                    },
                    {
                        "id": 37059,
                        "name": "Santa Fe de Mondújar",
                        "latitude": "36.97479000",
                        "longitude": "-2.53126000"
                    },
                    {
                        "id": 151355,
                        "name": "Senés",
                        "latitude": "37.20414570",
                        "longitude": "-2.34628560"
                    },
                    {
                        "id": 37228,
                        "name": "Serón",
                        "latitude": "37.34485000",
                        "longitude": "-2.50913000"
                    },
                    {
                        "id": 37248,
                        "name": "Sierro",
                        "latitude": "37.32237000",
                        "longitude": "-2.39844000"
                    },
                    {
                        "id": 37288,
                        "name": "Somontín",
                        "latitude": "37.39176000",
                        "longitude": "-2.38828000"
                    },
                    {
                        "id": 37298,
                        "name": "Sorbas",
                        "latitude": "37.09761000",
                        "longitude": "-2.12349000"
                    },
                    {
                        "id": 37331,
                        "name": "Suflí",
                        "latitude": "37.33866000",
                        "longitude": "-2.38817000"
                    },
                    {
                        "id": 37343,
                        "name": "Tabernas",
                        "latitude": "37.04992000",
                        "longitude": "-2.39084000"
                    },
                    {
                        "id": 151356,
                        "name": "Taberno",
                        "latitude": "37.46927500",
                        "longitude": "-2.07816410"
                    },
                    {
                        "id": 37350,
                        "name": "Tahal",
                        "latitude": "37.22797000",
                        "longitude": "-2.28470000"
                    },
                    {
                        "id": 37406,
                        "name": "Terque",
                        "latitude": "36.98393000",
                        "longitude": "-2.59679000"
                    },
                    {
                        "id": 37667,
                        "name": "Tíjola",
                        "latitude": "37.34606000",
                        "longitude": "-2.43326000"
                    },
                    {
                        "id": 151358,
                        "name": "Tres Villas Las",
                        "latitude": "37.15910470",
                        "longitude": "-2.71827280"
                    },
                    {
                        "id": 37656,
                        "name": "Turre",
                        "latitude": "37.15224000",
                        "longitude": "-1.89497000"
                    },
                    {
                        "id": 37657,
                        "name": "Turrillas",
                        "latitude": "37.02948000",
                        "longitude": "-2.26607000"
                    },
                    {
                        "id": 37679,
                        "name": "Uleila del Campo",
                        "latitude": "37.18460000",
                        "longitude": "-2.20491000"
                    },
                    {
                        "id": 37697,
                        "name": "Urrácal",
                        "latitude": "37.39740000",
                        "longitude": "-2.36485000"
                    },
                    {
                        "id": 37926,
                        "name": "Velefique",
                        "latitude": "37.19407000",
                        "longitude": "-2.40155000"
                    },
                    {
                        "id": 38415,
                        "name": "Vélez-Blanco",
                        "latitude": "37.69178000",
                        "longitude": "-2.09587000"
                    },
                    {
                        "id": 151357,
                        "name": "Vélez-Rubio",
                        "latitude": "37.64835010",
                        "longitude": "-2.07682030"
                    },
                    {
                        "id": 37947,
                        "name": "Vera",
                        "latitude": "37.24345000",
                        "longitude": "-1.85905000"
                    },
                    {
                        "id": 37961,
                        "name": "Viator",
                        "latitude": "36.89006000",
                        "longitude": "-2.42695000"
                    },
                    {
                        "id": 38417,
                        "name": "Vícar",
                        "latitude": "36.83155000",
                        "longitude": "-2.64273000"
                    },
                    {
                        "id": 38510,
                        "name": "Zurgena",
                        "latitude": "37.34218000",
                        "longitude": "-2.03985000"
                    }
                ]
            },
            {
                "id": 5325,
                "name": "Andalusia",
                "iso2": "AN",
                "latitude": "37.30840610",
                "longitude": "-7.21644460",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5093,
                "name": "Araba",
                "iso2": "VI",
                "latitude": "42.83951190",
                "longitude": "-3.84237740",
                "type": "province",
                "cities": [
                    {
                        "id": 151219,
                        "name": "Alegría-Dulantzi",
                        "latitude": "42.84409400",
                        "longitude": "-2.51195500"
                    },
                    {
                        "id": 32361,
                        "name": "Amurrio",
                        "latitude": "43.05000000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 151245,
                        "name": "Añana",
                        "latitude": "42.81518910",
                        "longitude": "-2.98755650"
                    },
                    {
                        "id": 151220,
                        "name": "Aramaio",
                        "latitude": "43.05211880",
                        "longitude": "-2.56471100"
                    },
                    {
                        "id": 32489,
                        "name": "Armiñón",
                        "latitude": "42.72313000",
                        "longitude": "-2.87172000"
                    },
                    {
                        "id": 151238,
                        "name": "Arraia-Maeztu",
                        "latitude": "42.73945000",
                        "longitude": "-2.44621810"
                    },
                    {
                        "id": 151222,
                        "name": "Arrazua-Ubarrundia",
                        "latitude": "42.94124840",
                        "longitude": "-2.60900430"
                    },
                    {
                        "id": 151221,
                        "name": "Artziniega",
                        "latitude": "43.12057960",
                        "longitude": "-3.12940840"
                    },
                    {
                        "id": 151223,
                        "name": "Asparrena",
                        "latitude": "42.88922220",
                        "longitude": "-2.31230310"
                    },
                    {
                        "id": 151224,
                        "name": "Ayala\/Aiara",
                        "latitude": "43.07530420",
                        "longitude": "-3.07765680"
                    },
                    {
                        "id": 151225,
                        "name": "Baños de Ebro\/Mañueta",
                        "latitude": "42.52952150",
                        "longitude": "-2.67893010"
                    },
                    {
                        "id": 151226,
                        "name": "Barrundia",
                        "latitude": "42.88970470",
                        "longitude": "-2.46954710"
                    },
                    {
                        "id": 32832,
                        "name": "Berantevilla",
                        "latitude": "42.68254000",
                        "longitude": "-2.85832000"
                    },
                    {
                        "id": 151227,
                        "name": "Bernedo",
                        "latitude": "42.62756030",
                        "longitude": "-2.49913270"
                    },
                    {
                        "id": 151228,
                        "name": "Campezo\/Kanpezu",
                        "latitude": "42.69332380",
                        "longitude": "-2.35175260"
                    },
                    {
                        "id": 151232,
                        "name": "Elburgo\/Burgelu",
                        "latitude": "42.84969190",
                        "longitude": "-2.54524970"
                    },
                    {
                        "id": 34032,
                        "name": "Elciego",
                        "latitude": "42.51569000",
                        "longitude": "-2.61897000"
                    },
                    {
                        "id": 151233,
                        "name": "Elvillar\/Bilar",
                        "latitude": "42.57060680",
                        "longitude": "-2.54331830"
                    },
                    {
                        "id": 151243,
                        "name": "Erriberagoitia\/Ribera Alta",
                        "latitude": "42.80724000",
                        "longitude": "-2.91759550"
                    },
                    {
                        "id": 151250,
                        "name": "Harana\/Valle de Arana",
                        "latitude": "42.75273150",
                        "longitude": "-2.31230310"
                    },
                    {
                        "id": 151257,
                        "name": "Iruña Oka\/Iruña de Oca",
                        "latitude": "42.81923460",
                        "longitude": "-2.82779630"
                    },
                    {
                        "id": 151234,
                        "name": "Iruraiz-Gauna",
                        "latitude": "42.81174670",
                        "longitude": "-2.56582500"
                    },
                    {
                        "id": 151230,
                        "name": "Kripan",
                        "latitude": "42.59694060",
                        "longitude": "-2.51484200"
                    },
                    {
                        "id": 151231,
                        "name": "Kuartango",
                        "latitude": "42.88517270",
                        "longitude": "-2.91759550"
                    },
                    {
                        "id": 151235,
                        "name": "Labastida\/Bastida",
                        "latitude": "42.58993540",
                        "longitude": "-2.79565570"
                    },
                    {
                        "id": 34942,
                        "name": "Lagrán",
                        "latitude": "42.62625000",
                        "longitude": "-2.58385000"
                    },
                    {
                        "id": 34943,
                        "name": "Laguardia",
                        "latitude": "42.55461000",
                        "longitude": "-2.58528000"
                    },
                    {
                        "id": 151236,
                        "name": "Lanciego\/Lantziego",
                        "latitude": "42.56254220",
                        "longitude": "-2.51161450"
                    },
                    {
                        "id": 151258,
                        "name": "Lantarón",
                        "latitude": "42.72800300",
                        "longitude": "-3.00297390"
                    },
                    {
                        "id": 34973,
                        "name": "Lapuebla de Labarca",
                        "latitude": "42.49455000",
                        "longitude": "-2.57341000"
                    },
                    {
                        "id": 151237,
                        "name": "Laudio\/Llodio",
                        "latitude": "43.14551950",
                        "longitude": "-2.98755650"
                    },
                    {
                        "id": 151252,
                        "name": "Legutio",
                        "latitude": "42.98047240",
                        "longitude": "-2.64258410"
                    },
                    {
                        "id": 35039,
                        "name": "Leza",
                        "latitude": "42.56552000",
                        "longitude": "-2.63324000"
                    },
                    {
                        "id": 151239,
                        "name": "Moreda de Álava\/Moreda Araba",
                        "latitude": "42.52505900",
                        "longitude": "-2.40833910"
                    },
                    {
                        "id": 35770,
                        "name": "Navaridas",
                        "latitude": "42.54566000",
                        "longitude": "-2.62650000"
                    },
                    {
                        "id": 151240,
                        "name": "Okondo",
                        "latitude": "43.15567070",
                        "longitude": "-3.02654340"
                    },
                    {
                        "id": 151241,
                        "name": "Oyón-Oion",
                        "latitude": "42.50737600",
                        "longitude": "-2.43646790"
                    },
                    {
                        "id": 151242,
                        "name": "Peñacerrada-Urizaharra",
                        "latitude": "42.64417690",
                        "longitude": "-2.71342270"
                    },
                    {
                        "id": 151244,
                        "name": "Ribera Baja\/Erribera Beitia",
                        "latitude": "42.71201750",
                        "longitude": "-2.91832170"
                    },
                    {
                        "id": 151246,
                        "name": "Salvatierra\/Agurain",
                        "latitude": "42.84933480",
                        "longitude": "-2.38878500"
                    },
                    {
                        "id": 36789,
                        "name": "Samaniego",
                        "latitude": "42.56854000",
                        "longitude": "-2.67974000"
                    },
                    {
                        "id": 151247,
                        "name": "San Millán\/Donemiliaga",
                        "latitude": "42.87639330",
                        "longitude": "-2.37827560"
                    },
                    {
                        "id": 151248,
                        "name": "Urkabustaiz",
                        "latitude": "42.97729040",
                        "longitude": "-2.94109350"
                    },
                    {
                        "id": 151249,
                        "name": "Valdegovía\/Gaubea",
                        "latitude": "42.84204210",
                        "longitude": "-3.07765680"
                    },
                    {
                        "id": 151251,
                        "name": "Villabuena de Álava\/Eskuernaga",
                        "latitude": "42.54461220",
                        "longitude": "-2.66360660"
                    },
                    {
                        "id": 151253,
                        "name": "Vitoria-Gasteiz",
                        "latitude": "42.85318690",
                        "longitude": "-2.67324210"
                    },
                    {
                        "id": 151254,
                        "name": "Yécora\/Iekora",
                        "latitude": "42.56727460",
                        "longitude": "-2.47154220"
                    },
                    {
                        "id": 151255,
                        "name": "Zalduondo",
                        "latitude": "42.88549190",
                        "longitude": "-2.34620290"
                    },
                    {
                        "id": 38464,
                        "name": "Zambrana",
                        "latitude": "42.66102000",
                        "longitude": "-2.87909000"
                    },
                    {
                        "id": 151229,
                        "name": "Zigoitia",
                        "latitude": "42.96788000",
                        "longitude": "-2.71827280"
                    },
                    {
                        "id": 151256,
                        "name": "Zuia",
                        "latitude": "42.96498820",
                        "longitude": "-2.83776560"
                    }
                ]
            },
            {
                "id": 5326,
                "name": "Aragon",
                "iso2": "AR",
                "latitude": "41.38011140",
                "longitude": "-2.02031590",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5327,
                "name": "Asturias",
                "iso2": "AS",
                "latitude": "43.26892790",
                "longitude": "-7.16832120",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 1160,
                "name": "Asturias",
                "iso2": "O",
                "latitude": "43.36139530",
                "longitude": "-5.85932670",
                "type": "province",
                "cities": [
                    {
                        "id": 152574,
                        "name": "Allande",
                        "latitude": "43.24883760",
                        "longitude": "-6.70659140"
                    },
                    {
                        "id": 152575,
                        "name": "Aller",
                        "latitude": "43.14970190",
                        "longitude": "-5.68787360"
                    },
                    {
                        "id": 152576,
                        "name": "Amieva",
                        "latitude": "43.24428340",
                        "longitude": "-5.07244540"
                    },
                    {
                        "id": 152577,
                        "name": "Avilés",
                        "latitude": "43.55666310",
                        "longitude": "-5.92564840"
                    },
                    {
                        "id": 152578,
                        "name": "Belmonte de Miranda",
                        "latitude": "43.25496390",
                        "longitude": "-6.25883690"
                    },
                    {
                        "id": 152579,
                        "name": "Bimenes",
                        "latitude": "43.31936940",
                        "longitude": "-5.57222970"
                    },
                    {
                        "id": 152580,
                        "name": "Boal",
                        "latitude": "43.42856780",
                        "longitude": "-6.81825820"
                    },
                    {
                        "id": 152581,
                        "name": "Cabrales",
                        "latitude": "43.31603200",
                        "longitude": "-4.84605180"
                    },
                    {
                        "id": 152582,
                        "name": "Cabranes",
                        "latitude": "43.40340850",
                        "longitude": "-5.42537570"
                    },
                    {
                        "id": 152583,
                        "name": "Candamo",
                        "latitude": "43.44661620",
                        "longitude": "-6.05809700"
                    },
                    {
                        "id": 152585,
                        "name": "Cangas de Onís",
                        "latitude": "43.35064480",
                        "longitude": "-5.13109440"
                    },
                    {
                        "id": 152584,
                        "name": "Cangas del Narcea",
                        "latitude": "43.10440970",
                        "longitude": "-6.53564490"
                    },
                    {
                        "id": 152586,
                        "name": "Caravia",
                        "latitude": "43.46525740",
                        "longitude": "-5.18756430"
                    },
                    {
                        "id": 152587,
                        "name": "Carreño",
                        "latitude": "43.54856180",
                        "longitude": "-5.79320080"
                    },
                    {
                        "id": 152588,
                        "name": "Caso",
                        "latitude": "43.16589380",
                        "longitude": "-5.35208760"
                    },
                    {
                        "id": 152589,
                        "name": "Castrillón",
                        "latitude": "43.54780230",
                        "longitude": "-5.99383390"
                    },
                    {
                        "id": 152590,
                        "name": "Castropol",
                        "latitude": "43.52476760",
                        "longitude": "-7.02777080"
                    },
                    {
                        "id": 152591,
                        "name": "Coaña",
                        "latitude": "43.50503870",
                        "longitude": "-6.76010570"
                    },
                    {
                        "id": 152592,
                        "name": "Colunga",
                        "latitude": "43.48490960",
                        "longitude": "-5.27122480"
                    },
                    {
                        "id": 152593,
                        "name": "Corvera de Asturias",
                        "latitude": "43.51495290",
                        "longitude": "-5.88815420"
                    },
                    {
                        "id": 152594,
                        "name": "Cudillero",
                        "latitude": "43.56291620",
                        "longitude": "-6.14526480"
                    },
                    {
                        "id": 152595,
                        "name": "Degaña",
                        "latitude": "42.94064680",
                        "longitude": "-6.57092820"
                    },
                    {
                        "id": 152596,
                        "name": "Franco El",
                        "latitude": "43.25043930",
                        "longitude": "-5.98325770"
                    },
                    {
                        "id": 152597,
                        "name": "Gijón",
                        "latitude": "43.53224930",
                        "longitude": "-5.66097330"
                    },
                    {
                        "id": 152598,
                        "name": "Gozón",
                        "latitude": "43.59377200",
                        "longitude": "-5.84593410"
                    },
                    {
                        "id": 152599,
                        "name": "Grado",
                        "latitude": "43.38708370",
                        "longitude": "-6.07439030"
                    },
                    {
                        "id": 152600,
                        "name": "Grandas de Salime",
                        "latitude": "43.17693900",
                        "longitude": "-6.94238440"
                    },
                    {
                        "id": 152601,
                        "name": "Ibias",
                        "latitude": "43.01211360",
                        "longitude": "-6.79223550"
                    },
                    {
                        "id": 152602,
                        "name": "Illano",
                        "latitude": "43.33615160",
                        "longitude": "-6.85654270"
                    },
                    {
                        "id": 152603,
                        "name": "Illas",
                        "latitude": "43.49138690",
                        "longitude": "-5.97268320"
                    },
                    {
                        "id": 152604,
                        "name": "Langreo",
                        "latitude": "43.30811280",
                        "longitude": "-5.69605620"
                    },
                    {
                        "id": 152605,
                        "name": "Laviana",
                        "latitude": "43.21485550",
                        "longitude": "-5.54072990"
                    },
                    {
                        "id": 152606,
                        "name": "Lena",
                        "latitude": "43.08427470",
                        "longitude": "-5.83538370"
                    },
                    {
                        "id": 152608,
                        "name": "Llanera",
                        "latitude": "43.46534880",
                        "longitude": "-5.91983870"
                    },
                    {
                        "id": 152609,
                        "name": "Llanes",
                        "latitude": "43.42114830",
                        "longitude": "-4.75621590"
                    },
                    {
                        "id": 152610,
                        "name": "Morcín",
                        "latitude": "43.26392310",
                        "longitude": "-5.90927540"
                    },
                    {
                        "id": 152611,
                        "name": "Muros de Nalón",
                        "latitude": "43.54361860",
                        "longitude": "-6.10626490"
                    },
                    {
                        "id": 152612,
                        "name": "Nava",
                        "latitude": "43.37105120",
                        "longitude": "-5.49875650"
                    },
                    {
                        "id": 152613,
                        "name": "Navia",
                        "latitude": "43.53818160",
                        "longitude": "-6.68519820"
                    },
                    {
                        "id": 152614,
                        "name": "Noreña",
                        "latitude": "43.39415140",
                        "longitude": "-5.70660730"
                    },
                    {
                        "id": 152615,
                        "name": "Onís",
                        "latitude": "43.30872800",
                        "longitude": "-4.96626080"
                    },
                    {
                        "id": 152616,
                        "name": "Oviedo",
                        "latitude": "43.36225220",
                        "longitude": "-5.84854610"
                    },
                    {
                        "id": 152617,
                        "name": "Parres",
                        "latitude": "43.34625340",
                        "longitude": "-5.20579090"
                    },
                    {
                        "id": 152618,
                        "name": "Peñamellera Alta",
                        "latitude": "43.32931260",
                        "longitude": "-4.70706160"
                    },
                    {
                        "id": 152619,
                        "name": "Peñamellera Baja",
                        "latitude": "43.32429000",
                        "longitude": "-4.59340000"
                    },
                    {
                        "id": 152620,
                        "name": "Pesoz",
                        "latitude": "43.25710500",
                        "longitude": "-6.87631660"
                    },
                    {
                        "id": 152621,
                        "name": "Piloña",
                        "latitude": "43.32024550",
                        "longitude": "-5.35208760"
                    },
                    {
                        "id": 152622,
                        "name": "Ponga",
                        "latitude": "43.19384840",
                        "longitude": "-5.16406050"
                    },
                    {
                        "id": 152623,
                        "name": "Pravia",
                        "latitude": "43.48763020",
                        "longitude": "-6.11053650"
                    },
                    {
                        "id": 152624,
                        "name": "Proaza",
                        "latitude": "43.25536380",
                        "longitude": "-6.01343030"
                    },
                    {
                        "id": 152625,
                        "name": "Quirós",
                        "latitude": "43.14122940",
                        "longitude": "-5.97040900"
                    },
                    {
                        "id": 152626,
                        "name": "Regueras Las",
                        "latitude": "43.41458650",
                        "longitude": "-5.97268320"
                    },
                    {
                        "id": 152627,
                        "name": "Ribadedeva",
                        "latitude": "43.36365460",
                        "longitude": "-4.57275980"
                    },
                    {
                        "id": 152628,
                        "name": "Ribadesella",
                        "latitude": "43.46308500",
                        "longitude": "-5.05610120"
                    },
                    {
                        "id": 152629,
                        "name": "Ribera de Arriba",
                        "latitude": "43.30793050",
                        "longitude": "-5.87868150"
                    },
                    {
                        "id": 152630,
                        "name": "Riosa",
                        "latitude": "43.20715570",
                        "longitude": "-5.88815420"
                    },
                    {
                        "id": 152631,
                        "name": "Salas",
                        "latitude": "43.40930460",
                        "longitude": "-6.26215670"
                    },
                    {
                        "id": 152633,
                        "name": "San Martín de Oscos",
                        "latitude": "43.26509080",
                        "longitude": "-6.96161330"
                    },
                    {
                        "id": 152632,
                        "name": "San Martín del Rey Aurelio",
                        "latitude": "43.27512940",
                        "longitude": "-5.60874880"
                    },
                    {
                        "id": 152635,
                        "name": "San Tirso de Abres",
                        "latitude": "43.41021350",
                        "longitude": "-7.14228640"
                    },
                    {
                        "id": 152634,
                        "name": "Santa Eulalia de Oscos",
                        "latitude": "43.25839980",
                        "longitude": "-7.01825980"
                    },
                    {
                        "id": 152636,
                        "name": "Santo Adriano",
                        "latitude": "43.28444070",
                        "longitude": "-5.97797020"
                    },
                    {
                        "id": 152637,
                        "name": "Sariego",
                        "latitude": "43.41153780",
                        "longitude": "-5.55647770"
                    },
                    {
                        "id": 152638,
                        "name": "Siero",
                        "latitude": "43.39150320",
                        "longitude": "-5.66081580"
                    },
                    {
                        "id": 152639,
                        "name": "Sobrescobio",
                        "latitude": "43.18942660",
                        "longitude": "-5.46729620"
                    },
                    {
                        "id": 152640,
                        "name": "Somiedo",
                        "latitude": "43.11872910",
                        "longitude": "-6.28008640"
                    },
                    {
                        "id": 152641,
                        "name": "Soto del Barco",
                        "latitude": "43.53389600",
                        "longitude": "-6.07096710"
                    },
                    {
                        "id": 152642,
                        "name": "Tapia de Casariego",
                        "latitude": "43.57023330",
                        "longitude": "-6.94390960"
                    },
                    {
                        "id": 152643,
                        "name": "Taramundi",
                        "latitude": "43.36039360",
                        "longitude": "-7.10834580"
                    },
                    {
                        "id": 152644,
                        "name": "Teverga",
                        "latitude": "43.16196400",
                        "longitude": "-6.09656510"
                    },
                    {
                        "id": 152645,
                        "name": "Tineo",
                        "latitude": "43.34057500",
                        "longitude": "-6.45034340"
                    },
                    {
                        "id": 152607,
                        "name": "Valdés",
                        "latitude": "43.49419780",
                        "longitude": "-6.45034340"
                    },
                    {
                        "id": 152646,
                        "name": "Vegadeo",
                        "latitude": "43.46469180",
                        "longitude": "-7.04850410"
                    },
                    {
                        "id": 152647,
                        "name": "Villanueva de Oscos",
                        "latitude": "43.31183840",
                        "longitude": "-6.98635520"
                    },
                    {
                        "id": 152648,
                        "name": "Villaviciosa",
                        "latitude": "43.48172140",
                        "longitude": "-5.43557480"
                    },
                    {
                        "id": 152649,
                        "name": "Villayón",
                        "latitude": "43.44801330",
                        "longitude": "-6.70456100"
                    },
                    {
                        "id": 152650,
                        "name": "Yernes y Tameza",
                        "latitude": "43.25392690",
                        "longitude": "-6.09969780"
                    }
                ]
            },
            {
                "id": 1189,
                "name": "Ávila",
                "iso2": "AV",
                "latitude": "40.69345110",
                "longitude": "-4.89356270",
                "type": "province",
                "cities": [
                    {
                        "id": 31930,
                        "name": "Adanero",
                        "latitude": "40.94487000",
                        "longitude": "-4.60561000"
                    },
                    {
                        "id": 152699,
                        "name": "Adrada La",
                        "latitude": "40.29955820",
                        "longitude": "-4.63653420"
                    },
                    {
                        "id": 32055,
                        "name": "Albornos",
                        "latitude": "40.83795000",
                        "longitude": "-4.88129000"
                    },
                    {
                        "id": 32162,
                        "name": "Aldeanueva de Santa Cruz",
                        "latitude": "40.38189000",
                        "longitude": "-5.42142000"
                    },
                    {
                        "id": 32170,
                        "name": "Aldeaseca",
                        "latitude": "41.04912000",
                        "longitude": "-4.81707000"
                    },
                    {
                        "id": 152700,
                        "name": "Aldehuela La",
                        "latitude": "40.41091990",
                        "longitude": "-5.40933600"
                    },
                    {
                        "id": 32348,
                        "name": "Amavida",
                        "latitude": "40.57371000",
                        "longitude": "-5.06541000"
                    },
                    {
                        "id": 152701,
                        "name": "Arenal El",
                        "latitude": "40.27387650",
                        "longitude": "-5.08589880"
                    },
                    {
                        "id": 32447,
                        "name": "Arenas de San Pedro",
                        "latitude": "40.21041000",
                        "longitude": "-5.08694000"
                    },
                    {
                        "id": 152702,
                        "name": "Arevalillo",
                        "latitude": "40.58675230",
                        "longitude": "-5.37236340"
                    },
                    {
                        "id": 32531,
                        "name": "Arévalo",
                        "latitude": "41.06255000",
                        "longitude": "-4.72042000"
                    },
                    {
                        "id": 32564,
                        "name": "Aveinte",
                        "latitude": "40.78227000",
                        "longitude": "-4.83649000"
                    },
                    {
                        "id": 32565,
                        "name": "Avellaneda",
                        "latitude": "40.38909000",
                        "longitude": "-5.38811000"
                    },
                    {
                        "id": 38576,
                        "name": "Ávila",
                        "latitude": "40.65724000",
                        "longitude": "-4.69951000"
                    },
                    {
                        "id": 152703,
                        "name": "Barco de Ávila El",
                        "latitude": "40.35690630",
                        "longitude": "-5.52367460"
                    },
                    {
                        "id": 152704,
                        "name": "Barraco El",
                        "latitude": "40.44244830",
                        "longitude": "-4.58307890"
                    },
                    {
                        "id": 32680,
                        "name": "Barromán",
                        "latitude": "41.06536000",
                        "longitude": "-4.93066000"
                    },
                    {
                        "id": 32721,
                        "name": "Becedas",
                        "latitude": "40.40369000",
                        "longitude": "-5.63577000"
                    },
                    {
                        "id": 32722,
                        "name": "Becedillas",
                        "latitude": "40.53821000",
                        "longitude": "-5.32561000"
                    },
                    {
                        "id": 32841,
                        "name": "Bercial de Zapardiel",
                        "latitude": "41.04675000",
                        "longitude": "-4.96910000"
                    },
                    {
                        "id": 152705,
                        "name": "Berlanas Las",
                        "latitude": "40.79916630",
                        "longitude": "-4.76218260"
                    },
                    {
                        "id": 152706,
                        "name": "Bernuy-Zapardiel",
                        "latitude": "40.97580910",
                        "longitude": "-4.94483100"
                    },
                    {
                        "id": 32872,
                        "name": "Berrocalejo de Aragona",
                        "latitude": "40.69436000",
                        "longitude": "-4.59474000"
                    },
                    {
                        "id": 32910,
                        "name": "Blascomillán",
                        "latitude": "40.80146000",
                        "longitude": "-5.08703000"
                    },
                    {
                        "id": 152707,
                        "name": "Blasconuño de Matacabras",
                        "latitude": "41.12350360",
                        "longitude": "-4.98987670"
                    },
                    {
                        "id": 32911,
                        "name": "Blascosancho",
                        "latitude": "40.87744000",
                        "longitude": "-4.63743000"
                    },
                    {
                        "id": 152708,
                        "name": "Bohodón El",
                        "latitude": "40.91555010",
                        "longitude": "-4.72969300"
                    },
                    {
                        "id": 32932,
                        "name": "Bohoyo",
                        "latitude": "40.31584000",
                        "longitude": "-5.44294000"
                    },
                    {
                        "id": 32948,
                        "name": "Bonilla de la Sierra",
                        "latitude": "40.53063000",
                        "longitude": "-5.26452000"
                    },
                    {
                        "id": 32968,
                        "name": "Brabos",
                        "latitude": "40.77846000",
                        "longitude": "-4.93934000"
                    },
                    {
                        "id": 152709,
                        "name": "Bularros",
                        "latitude": "40.72434700",
                        "longitude": "-4.86567710"
                    },
                    {
                        "id": 33025,
                        "name": "Burgohondo",
                        "latitude": "40.41416000",
                        "longitude": "-4.78509000"
                    },
                    {
                        "id": 33085,
                        "name": "Cabezas de Alambre",
                        "latitude": "40.94218000",
                        "longitude": "-4.84184000"
                    },
                    {
                        "id": 33086,
                        "name": "Cabezas del Pozo",
                        "latitude": "41.00139000",
                        "longitude": "-4.95453000"
                    },
                    {
                        "id": 33087,
                        "name": "Cabezas del Villar",
                        "latitude": "40.71557000",
                        "longitude": "-5.20956000"
                    },
                    {
                        "id": 33096,
                        "name": "Cabizuela",
                        "latitude": "40.90090000",
                        "longitude": "-4.80212000"
                    },
                    {
                        "id": 33222,
                        "name": "Canales",
                        "latitude": "41.00331000",
                        "longitude": "-4.90163000"
                    },
                    {
                        "id": 33228,
                        "name": "Candeleda",
                        "latitude": "40.15521000",
                        "longitude": "-5.24045000"
                    },
                    {
                        "id": 33259,
                        "name": "Cantiveros",
                        "latitude": "40.95215000",
                        "longitude": "-4.95455000"
                    },
                    {
                        "id": 33301,
                        "name": "Cardeñosa",
                        "latitude": "40.74240000",
                        "longitude": "-4.74579000"
                    },
                    {
                        "id": 152710,
                        "name": "Carrera La",
                        "latitude": "40.34716580",
                        "longitude": "-5.55450900"
                    },
                    {
                        "id": 152711,
                        "name": "Casas del Puerto",
                        "latitude": "40.52884560",
                        "longitude": "-5.19731190"
                    },
                    {
                        "id": 152712,
                        "name": "Casasola",
                        "latitude": "40.66869760",
                        "longitude": "-4.82776210"
                    },
                    {
                        "id": 33382,
                        "name": "Casavieja",
                        "latitude": "40.28325000",
                        "longitude": "-4.76670000"
                    },
                    {
                        "id": 33388,
                        "name": "Casillas",
                        "latitude": "40.32610000",
                        "longitude": "-4.57182000"
                    },
                    {
                        "id": 33417,
                        "name": "Castellanos de Zapardiel",
                        "latitude": "41.08450000",
                        "longitude": "-4.90984000"
                    },
                    {
                        "id": 33551,
                        "name": "Cebreros",
                        "latitude": "40.45835000",
                        "longitude": "-4.46433000"
                    },
                    {
                        "id": 33577,
                        "name": "Cepeda la Mora",
                        "latitude": "40.45780000",
                        "longitude": "-5.04833000"
                    },
                    {
                        "id": 33614,
                        "name": "Chamartín",
                        "latitude": "40.70267000",
                        "longitude": "-4.95769000"
                    },
                    {
                        "id": 33672,
                        "name": "Cillán",
                        "latitude": "40.70675000",
                        "longitude": "-4.98135000"
                    },
                    {
                        "id": 33690,
                        "name": "Cisla",
                        "latitude": "40.96662000",
                        "longitude": "-5.01405000"
                    },
                    {
                        "id": 152713,
                        "name": "Colilla La",
                        "latitude": "40.64626190",
                        "longitude": "-4.76592260"
                    },
                    {
                        "id": 33734,
                        "name": "Collado de Contreras",
                        "latitude": "40.88743000",
                        "longitude": "-4.93140000"
                    },
                    {
                        "id": 33735,
                        "name": "Collado del Mirón",
                        "latitude": "40.55307000",
                        "longitude": "-5.35398000"
                    },
                    {
                        "id": 33767,
                        "name": "Constanzana",
                        "latitude": "40.93821000",
                        "longitude": "-4.87515000"
                    },
                    {
                        "id": 33834,
                        "name": "Crespos",
                        "latitude": "40.87128000",
                        "longitude": "-4.97094000"
                    },
                    {
                        "id": 33879,
                        "name": "Cuevas del Valle",
                        "latitude": "40.29418000",
                        "longitude": "-5.00938000"
                    },
                    {
                        "id": 152753,
                        "name": "Diego del Carpio",
                        "latitude": "40.66349520",
                        "longitude": "-5.34162550"
                    },
                    {
                        "id": 33945,
                        "name": "Donjimeno",
                        "latitude": "40.95978000",
                        "longitude": "-4.84627000"
                    },
                    {
                        "id": 33947,
                        "name": "Donvidas",
                        "latitude": "41.08954000",
                        "longitude": "-4.80634000"
                    },
                    {
                        "id": 152714,
                        "name": "Espinosa de los Caballeros",
                        "latitude": "41.00901490",
                        "longitude": "-4.65310740"
                    },
                    {
                        "id": 34196,
                        "name": "Flores de Ávila",
                        "latitude": "40.93358000",
                        "longitude": "-5.07914000"
                    },
                    {
                        "id": 34217,
                        "name": "Fontiveros",
                        "latitude": "40.92997000",
                        "longitude": "-4.96445000"
                    },
                    {
                        "id": 34248,
                        "name": "Fresnedilla",
                        "latitude": "40.23233000",
                        "longitude": "-4.62201000"
                    },
                    {
                        "id": 152715,
                        "name": "Fresno El",
                        "latitude": "40.61370590",
                        "longitude": "-4.75686300"
                    },
                    {
                        "id": 152716,
                        "name": "Fuente el Saúz",
                        "latitude": "40.97730510",
                        "longitude": "-4.90978180"
                    },
                    {
                        "id": 34340,
                        "name": "Fuentes de Año",
                        "latitude": "41.01769000",
                        "longitude": "-4.89907000"
                    },
                    {
                        "id": 152717,
                        "name": "Gallegos de Altamiros",
                        "latitude": "40.71159930",
                        "longitude": "-4.91108290"
                    },
                    {
                        "id": 34389,
                        "name": "Gallegos de Sobrinos",
                        "latitude": "40.71693000",
                        "longitude": "-5.11224000"
                    },
                    {
                        "id": 34416,
                        "name": "Garganta del Villar",
                        "latitude": "40.44965000",
                        "longitude": "-5.10420000"
                    },
                    {
                        "id": 34440,
                        "name": "Gavilanes",
                        "latitude": "40.27791000",
                        "longitude": "-4.85321000"
                    },
                    {
                        "id": 34450,
                        "name": "Gemuño",
                        "latitude": "40.59159000",
                        "longitude": "-4.78178000"
                    },
                    {
                        "id": 152719,
                        "name": "Gil García",
                        "latitude": "40.29786720",
                        "longitude": "-5.59422400"
                    },
                    {
                        "id": 152718,
                        "name": "Gilbuena",
                        "latitude": "40.41586360",
                        "longitude": "-5.60571680"
                    },
                    {
                        "id": 34465,
                        "name": "Gimialcón",
                        "latitude": "40.87705000",
                        "longitude": "-5.12308000"
                    },
                    {
                        "id": 34489,
                        "name": "Gotarrendura",
                        "latitude": "40.82652000",
                        "longitude": "-4.74090000"
                    },
                    {
                        "id": 152720,
                        "name": "Grandes y San Martín",
                        "latitude": "40.76597400",
                        "longitude": "-4.97145720"
                    },
                    {
                        "id": 34551,
                        "name": "Guisando",
                        "latitude": "40.22225000",
                        "longitude": "-5.13950000"
                    },
                    {
                        "id": 34556,
                        "name": "Gutierre-Muñoz",
                        "latitude": "40.98295000",
                        "longitude": "-4.63839000"
                    },
                    {
                        "id": 34589,
                        "name": "Hernansancho",
                        "latitude": "40.85753000",
                        "longitude": "-4.73045000"
                    },
                    {
                        "id": 152721,
                        "name": "Herradón de Pinares",
                        "latitude": "40.56469660",
                        "longitude": "-4.55929460"
                    },
                    {
                        "id": 34600,
                        "name": "Herreros de Suso",
                        "latitude": "40.80361000",
                        "longitude": "-5.03892000"
                    },
                    {
                        "id": 34613,
                        "name": "Higuera de las Dueñas",
                        "latitude": "40.23903000",
                        "longitude": "-4.60361000"
                    },
                    {
                        "id": 152722,
                        "name": "Hija de Dios La",
                        "latitude": "40.52975710",
                        "longitude": "-4.96723510"
                    },
                    {
                        "id": 152723,
                        "name": "Horcajada La",
                        "latitude": "40.43648720",
                        "longitude": "-5.46664100"
                    },
                    {
                        "id": 34653,
                        "name": "Horcajo de las Torres",
                        "latitude": "41.06497000",
                        "longitude": "-5.09092000"
                    },
                    {
                        "id": 152724,
                        "name": "Hornillo El",
                        "latitude": "40.26671350",
                        "longitude": "-5.13278290"
                    },
                    {
                        "id": 152725,
                        "name": "Hoyo de Pinares El",
                        "latitude": "40.50078860",
                        "longitude": "-4.42206730"
                    },
                    {
                        "id": 34675,
                        "name": "Hoyocasero",
                        "latitude": "40.39890000",
                        "longitude": "-4.97455000"
                    },
                    {
                        "id": 34676,
                        "name": "Hoyorredondo",
                        "latitude": "40.46270000",
                        "longitude": "-5.41097000"
                    },
                    {
                        "id": 34678,
                        "name": "Hoyos de Miguel Muñoz",
                        "latitude": "40.39237000",
                        "longitude": "-5.06713000"
                    },
                    {
                        "id": 34679,
                        "name": "Hoyos del Collado",
                        "latitude": "40.35945000",
                        "longitude": "-5.20027000"
                    },
                    {
                        "id": 34680,
                        "name": "Hoyos del Espino",
                        "latitude": "40.35623000",
                        "longitude": "-5.17505000"
                    },
                    {
                        "id": 34704,
                        "name": "Hurtumpascual",
                        "latitude": "40.69200000",
                        "longitude": "-5.11379000"
                    },
                    {
                        "id": 34830,
                        "name": "Junciana",
                        "latitude": "40.41076000",
                        "longitude": "-5.55698000"
                    },
                    {
                        "id": 34962,
                        "name": "Langa",
                        "latitude": "41.00550000",
                        "longitude": "-4.85946000"
                    },
                    {
                        "id": 152726,
                        "name": "Lanzahíta",
                        "latitude": "40.20524770",
                        "longitude": "-4.93379460"
                    },
                    {
                        "id": 152728,
                        "name": "Llanos de Tormes Los",
                        "latitude": "40.32844610",
                        "longitude": "-5.50039550"
                    },
                    {
                        "id": 152727,
                        "name": "Losar del Barco El",
                        "latitude": "40.39381940",
                        "longitude": "-5.53930110"
                    },
                    {
                        "id": 35190,
                        "name": "Madrigal de las Altas Torres",
                        "latitude": "41.08968000",
                        "longitude": "-4.99863000"
                    },
                    {
                        "id": 35198,
                        "name": "Maello",
                        "latitude": "40.80929000",
                        "longitude": "-4.51186000"
                    },
                    {
                        "id": 35226,
                        "name": "Malpartida de Corneja",
                        "latitude": "40.52208000",
                        "longitude": "-5.35026000"
                    },
                    {
                        "id": 35235,
                        "name": "Mamblas",
                        "latitude": "41.01925000",
                        "longitude": "-5.00873000"
                    },
                    {
                        "id": 35241,
                        "name": "Mancera de Arriba",
                        "latitude": "40.79139000",
                        "longitude": "-5.14772000"
                    },
                    {
                        "id": 35252,
                        "name": "Manjabálago",
                        "latitude": "40.66441000",
                        "longitude": "-5.07719000"
                    },
                    {
                        "id": 152729,
                        "name": "Marlín",
                        "latitude": "40.71165710",
                        "longitude": "-4.82905790"
                    },
                    {
                        "id": 35299,
                        "name": "Martiherrero",
                        "latitude": "40.67392000",
                        "longitude": "-4.78156000"
                    },
                    {
                        "id": 35309,
                        "name": "Martínez",
                        "latitude": "40.63046000",
                        "longitude": "-5.34801000"
                    },
                    {
                        "id": 35368,
                        "name": "Mediana de Voltoya",
                        "latitude": "40.70104000",
                        "longitude": "-4.56341000"
                    },
                    {
                        "id": 35375,
                        "name": "Medinilla",
                        "latitude": "40.43967000",
                        "longitude": "-5.61772000"
                    },
                    {
                        "id": 35404,
                        "name": "Mengamuñoz",
                        "latitude": "40.50006000",
                        "longitude": "-4.99983000"
                    },
                    {
                        "id": 35409,
                        "name": "Mesegar de Corneja",
                        "latitude": "40.50209000",
                        "longitude": "-5.30131000"
                    },
                    {
                        "id": 35426,
                        "name": "Mijares",
                        "latitude": "40.29655000",
                        "longitude": "-4.83651000"
                    },
                    {
                        "id": 35438,
                        "name": "Mingorría",
                        "latitude": "40.75192000",
                        "longitude": "-4.66583000"
                    },
                    {
                        "id": 152730,
                        "name": "Mirón El",
                        "latitude": "40.53327110",
                        "longitude": "-5.40508130"
                    },
                    {
                        "id": 35455,
                        "name": "Mironcillo",
                        "latitude": "40.55435000",
                        "longitude": "-4.82449000"
                    },
                    {
                        "id": 152731,
                        "name": "Mirueña de los Infanzones",
                        "latitude": "40.73615480",
                        "longitude": "-5.09045520"
                    },
                    {
                        "id": 35491,
                        "name": "Mombeltrán",
                        "latitude": "40.25987000",
                        "longitude": "-5.01749000"
                    },
                    {
                        "id": 35526,
                        "name": "Monsalupe",
                        "latitude": "40.76953000",
                        "longitude": "-4.78131000"
                    },
                    {
                        "id": 35603,
                        "name": "Moraleja de Matacabras",
                        "latitude": "41.10732000",
                        "longitude": "-4.95717000"
                    },
                    {
                        "id": 35692,
                        "name": "Muñana",
                        "latitude": "40.59042000",
                        "longitude": "-5.01447000"
                    },
                    {
                        "id": 35693,
                        "name": "Muñico",
                        "latitude": "40.70678000",
                        "longitude": "-5.02717000"
                    },
                    {
                        "id": 35694,
                        "name": "Muñogalindo",
                        "latitude": "40.60324000",
                        "longitude": "-4.89895000"
                    },
                    {
                        "id": 35695,
                        "name": "Muñogrande",
                        "latitude": "40.82181000",
                        "longitude": "-4.92223000"
                    },
                    {
                        "id": 35696,
                        "name": "Muñomer del Peco",
                        "latitude": "40.85878000",
                        "longitude": "-4.87992000"
                    },
                    {
                        "id": 35698,
                        "name": "Muñopepe",
                        "latitude": "40.63408000",
                        "longitude": "-4.81876000"
                    },
                    {
                        "id": 35699,
                        "name": "Muñosancho",
                        "latitude": "40.92097000",
                        "longitude": "-5.03559000"
                    },
                    {
                        "id": 35700,
                        "name": "Muñotello",
                        "latitude": "40.54236000",
                        "longitude": "-5.04187000"
                    },
                    {
                        "id": 35714,
                        "name": "Narrillos del Álamo",
                        "latitude": "40.56673000",
                        "longitude": "-5.46584000"
                    },
                    {
                        "id": 35713,
                        "name": "Narrillos del Rebollar",
                        "latitude": "40.66488000",
                        "longitude": "-4.96577000"
                    },
                    {
                        "id": 35717,
                        "name": "Narros de Saldueña",
                        "latitude": "40.87268000",
                        "longitude": "-4.86909000"
                    },
                    {
                        "id": 35718,
                        "name": "Narros del Castillo",
                        "latitude": "40.85869000",
                        "longitude": "-5.06010000"
                    },
                    {
                        "id": 35719,
                        "name": "Narros del Puerto",
                        "latitude": "40.54131000",
                        "longitude": "-4.99291000"
                    },
                    {
                        "id": 35721,
                        "name": "Nava de Arévalo",
                        "latitude": "40.97803000",
                        "longitude": "-4.77573000"
                    },
                    {
                        "id": 35727,
                        "name": "Nava del Barco",
                        "latitude": "40.29321000",
                        "longitude": "-5.54022000"
                    },
                    {
                        "id": 35730,
                        "name": "Navacepedilla de Corneja",
                        "latitude": "40.48602000",
                        "longitude": "-5.18380000"
                    },
                    {
                        "id": 35733,
                        "name": "Navadijos",
                        "latitude": "40.42524000",
                        "longitude": "-5.08285000"
                    },
                    {
                        "id": 35734,
                        "name": "Navaescurial",
                        "latitude": "40.47163000",
                        "longitude": "-5.27756000"
                    },
                    {
                        "id": 35737,
                        "name": "Navahondilla",
                        "latitude": "40.32510000",
                        "longitude": "-4.49661000"
                    },
                    {
                        "id": 35741,
                        "name": "Navalacruz",
                        "latitude": "40.43993000",
                        "longitude": "-4.93122000"
                    },
                    {
                        "id": 35750,
                        "name": "Navalmoral",
                        "latitude": "40.46028000",
                        "longitude": "-4.76859000"
                    },
                    {
                        "id": 152732,
                        "name": "Navalonguilla",
                        "latitude": "40.27847990",
                        "longitude": "-5.50072330"
                    },
                    {
                        "id": 35754,
                        "name": "Navalosa",
                        "latitude": "40.40212000",
                        "longitude": "-4.92999000"
                    },
                    {
                        "id": 35755,
                        "name": "Navalperal de Pinares",
                        "latitude": "40.59398000",
                        "longitude": "-4.41149000"
                    },
                    {
                        "id": 35756,
                        "name": "Navalperal de Tormes",
                        "latitude": "40.35280000",
                        "longitude": "-5.30084000"
                    },
                    {
                        "id": 35759,
                        "name": "Navaluenga",
                        "latitude": "40.41123000",
                        "longitude": "-4.70897000"
                    },
                    {
                        "id": 35764,
                        "name": "Navaquesera",
                        "latitude": "40.42558000",
                        "longitude": "-4.91108000"
                    },
                    {
                        "id": 35771,
                        "name": "Navarredonda de Gredos",
                        "latitude": "40.36136000",
                        "longitude": "-5.13268000"
                    },
                    {
                        "id": 35773,
                        "name": "Navarredondilla",
                        "latitude": "40.45416000",
                        "longitude": "-4.82199000"
                    },
                    {
                        "id": 35774,
                        "name": "Navarrevisca",
                        "latitude": "40.36417000",
                        "longitude": "-4.89352000"
                    },
                    {
                        "id": 152733,
                        "name": "Navas del Marqués Las",
                        "latitude": "40.60182760",
                        "longitude": "-4.33339540"
                    },
                    {
                        "id": 35787,
                        "name": "Navatalgordo",
                        "latitude": "40.41520000",
                        "longitude": "-4.87155000"
                    },
                    {
                        "id": 35788,
                        "name": "Navatejares",
                        "latitude": "40.33602000",
                        "longitude": "-5.53220000"
                    },
                    {
                        "id": 35800,
                        "name": "Neila de San Miguel",
                        "latitude": "40.42372000",
                        "longitude": "-5.65090000"
                    },
                    {
                        "id": 35811,
                        "name": "Niharra",
                        "latitude": "40.58945000",
                        "longitude": "-4.83895000"
                    },
                    {
                        "id": 35869,
                        "name": "Ojos-Albos",
                        "latitude": "40.70596000",
                        "longitude": "-4.51633000"
                    },
                    {
                        "id": 35934,
                        "name": "Orbita",
                        "latitude": "40.99846000",
                        "longitude": "-4.64833000"
                    },
                    {
                        "id": 152734,
                        "name": "Oso El",
                        "latitude": "40.83949690",
                        "longitude": "-4.76980580"
                    },
                    {
                        "id": 35990,
                        "name": "Padiernos",
                        "latitude": "40.62168000",
                        "longitude": "-4.84523000"
                    },
                    {
                        "id": 36000,
                        "name": "Pajares de Adaja",
                        "latitude": "40.92398000",
                        "longitude": "-4.64048000"
                    },
                    {
                        "id": 36006,
                        "name": "Palacios de Goda",
                        "latitude": "41.11798000",
                        "longitude": "-4.78496000"
                    },
                    {
                        "id": 36051,
                        "name": "Papatrigo",
                        "latitude": "40.86790000",
                        "longitude": "-4.83399000"
                    },
                    {
                        "id": 152735,
                        "name": "Parral El",
                        "latitude": "40.79862870",
                        "longitude": "-4.99029800"
                    },
                    {
                        "id": 152736,
                        "name": "Pascualcobo",
                        "latitude": "40.65571280",
                        "longitude": "-5.27693330"
                    },
                    {
                        "id": 36099,
                        "name": "Pedro Bernardo",
                        "latitude": "40.24214000",
                        "longitude": "-4.90963000"
                    },
                    {
                        "id": 152737,
                        "name": "Pedro-Rodríguez",
                        "latitude": "40.93635860",
                        "longitude": "-4.78685710"
                    },
                    {
                        "id": 36117,
                        "name": "Peguerinos",
                        "latitude": "40.62620000",
                        "longitude": "-4.23154000"
                    },
                    {
                        "id": 36166,
                        "name": "Peñalba de Ávila",
                        "latitude": "40.77266000",
                        "longitude": "-4.74595000"
                    },
                    {
                        "id": 152738,
                        "name": "Piedrahíta",
                        "latitude": "40.46520690",
                        "longitude": "-5.32724310"
                    },
                    {
                        "id": 36182,
                        "name": "Piedralaves",
                        "latitude": "40.31721000",
                        "longitude": "-4.70025000"
                    },
                    {
                        "id": 36306,
                        "name": "Poveda",
                        "latitude": "40.56799000",
                        "longitude": "-5.07909000"
                    },
                    {
                        "id": 36310,
                        "name": "Poyales del Hoyo",
                        "latitude": "40.17254000",
                        "longitude": "-5.16597000"
                    },
                    {
                        "id": 36315,
                        "name": "Pozanco",
                        "latitude": "40.80095000",
                        "longitude": "-4.66772000"
                    },
                    {
                        "id": 36349,
                        "name": "Pradosegar",
                        "latitude": "40.55020000",
                        "longitude": "-5.07015000"
                    },
                    {
                        "id": 36444,
                        "name": "Puerto Castilla",
                        "latitude": "40.28800000",
                        "longitude": "-5.62366000"
                    },
                    {
                        "id": 36550,
                        "name": "Rasueros",
                        "latitude": "41.02344000",
                        "longitude": "-5.07377000"
                    },
                    {
                        "id": 152739,
                        "name": "Riocabado",
                        "latitude": "40.83053030",
                        "longitude": "-4.80347130"
                    },
                    {
                        "id": 152740,
                        "name": "Riofrío",
                        "latitude": "40.54856370",
                        "longitude": "-4.77759500"
                    },
                    {
                        "id": 36640,
                        "name": "Rivilla de Barajas",
                        "latitude": "40.90210000",
                        "longitude": "-4.98836000"
                    },
                    {
                        "id": 36772,
                        "name": "Salobral",
                        "latitude": "40.61179000",
                        "longitude": "-4.81013000"
                    },
                    {
                        "id": 36781,
                        "name": "Salvadiós",
                        "latitude": "40.87836000",
                        "longitude": "-5.09629000"
                    },
                    {
                        "id": 36807,
                        "name": "San Bartolomé de Béjar",
                        "latitude": "40.40783000",
                        "longitude": "-5.66261000"
                    },
                    {
                        "id": 36808,
                        "name": "San Bartolomé de Corneja",
                        "latitude": "40.49257000",
                        "longitude": "-5.38519000"
                    },
                    {
                        "id": 152741,
                        "name": "San Bartolomé de Pinares",
                        "latitude": "40.54255350",
                        "longitude": "-4.53988060"
                    },
                    {
                        "id": 36831,
                        "name": "San Esteban de los Patos",
                        "latitude": "40.74705000",
                        "longitude": "-4.62413000"
                    },
                    {
                        "id": 152742,
                        "name": "San Esteban de Zapardiel",
                        "latitude": "41.09244480",
                        "longitude": "-4.90037410"
                    },
                    {
                        "id": 36833,
                        "name": "San Esteban del Valle",
                        "latitude": "40.27510000",
                        "longitude": "-4.98215000"
                    },
                    {
                        "id": 36837,
                        "name": "San García de Ingelmos",
                        "latitude": "40.76912000",
                        "longitude": "-5.11523000"
                    },
                    {
                        "id": 152751,
                        "name": "San Juan de Gredos",
                        "latitude": "40.36386660",
                        "longitude": "-5.23710870"
                    },
                    {
                        "id": 36846,
                        "name": "San Juan de la Encinilla",
                        "latitude": "40.83020000",
                        "longitude": "-4.83957000"
                    },
                    {
                        "id": 36847,
                        "name": "San Juan de la Nava",
                        "latitude": "40.47880000",
                        "longitude": "-4.68238000"
                    },
                    {
                        "id": 36850,
                        "name": "San Juan del Molinillo",
                        "latitude": "40.45909000",
                        "longitude": "-4.81711000"
                    },
                    {
                        "id": 152743,
                        "name": "San Juan del Olmo",
                        "latitude": "40.65313200",
                        "longitude": "-5.05141170"
                    },
                    {
                        "id": 36859,
                        "name": "San Lorenzo de Tormes",
                        "latitude": "40.36984000",
                        "longitude": "-5.48848000"
                    },
                    {
                        "id": 36874,
                        "name": "San Martín de la Vega del Alberche",
                        "latitude": "40.43053000",
                        "longitude": "-5.15500000"
                    },
                    {
                        "id": 36876,
                        "name": "San Martín del Pimpollar",
                        "latitude": "40.36830000",
                        "longitude": "-5.05443000"
                    },
                    {
                        "id": 36881,
                        "name": "San Miguel de Corneja",
                        "latitude": "40.48722000",
                        "longitude": "-5.28654000"
                    },
                    {
                        "id": 36884,
                        "name": "San Miguel de Serrezuela",
                        "latitude": "40.67064000",
                        "longitude": "-5.28857000"
                    },
                    {
                        "id": 36898,
                        "name": "San Pascual",
                        "latitude": "40.88141000",
                        "longitude": "-4.75612000"
                    },
                    {
                        "id": 36909,
                        "name": "San Pedro del Arroyo",
                        "latitude": "40.80213000",
                        "longitude": "-4.87075000"
                    },
                    {
                        "id": 36927,
                        "name": "San Vicente de Arévalo",
                        "latitude": "40.96773000",
                        "longitude": "-4.80194000"
                    },
                    {
                        "id": 36935,
                        "name": "Sanchidrián",
                        "latitude": "40.89347000",
                        "longitude": "-4.58132000"
                    },
                    {
                        "id": 36937,
                        "name": "Sanchorreja",
                        "latitude": "40.66475000",
                        "longitude": "-4.91494000"
                    },
                    {
                        "id": 37035,
                        "name": "Santa Cruz de Pinares",
                        "latitude": "40.54265000",
                        "longitude": "-4.58036000"
                    },
                    {
                        "id": 37045,
                        "name": "Santa Cruz del Valle",
                        "latitude": "40.25160000",
                        "longitude": "-5.00133000"
                    },
                    {
                        "id": 37083,
                        "name": "Santa María de los Caballeros",
                        "latitude": "40.38925000",
                        "longitude": "-5.45112000"
                    },
                    {
                        "id": 152744,
                        "name": "Santa María del Arroyo",
                        "latitude": "40.60073330",
                        "longitude": "-4.92308490"
                    },
                    {
                        "id": 37084,
                        "name": "Santa María del Berrocal",
                        "latitude": "40.50845000",
                        "longitude": "-5.40483000"
                    },
                    {
                        "id": 152752,
                        "name": "Santa María del Cubillo",
                        "latitude": "40.74096630",
                        "longitude": "-4.46967650"
                    },
                    {
                        "id": 152745,
                        "name": "Santa María del Tiétar",
                        "latitude": "40.30493930",
                        "longitude": "-4.55341670"
                    },
                    {
                        "id": 37118,
                        "name": "Santiago del Collado",
                        "latitude": "40.43326000",
                        "longitude": "-5.35631000"
                    },
                    {
                        "id": 152754,
                        "name": "Santiago del Tormes",
                        "latitude": "40.33680330",
                        "longitude": "-5.38348540"
                    },
                    {
                        "id": 37142,
                        "name": "Santo Domingo de las Posadas",
                        "latitude": "40.81200000",
                        "longitude": "-4.63383000"
                    },
                    {
                        "id": 37144,
                        "name": "Santo Tomé de Zabarcos",
                        "latitude": "40.78726000",
                        "longitude": "-4.91048000"
                    },
                    {
                        "id": 152746,
                        "name": "Serrada La",
                        "latitude": "40.63120930",
                        "longitude": "-4.79311050"
                    },
                    {
                        "id": 37224,
                        "name": "Serranillos",
                        "latitude": "40.33625000",
                        "longitude": "-4.91165000"
                    },
                    {
                        "id": 37251,
                        "name": "Sigeres",
                        "latitude": "40.79939000",
                        "longitude": "-4.93361000"
                    },
                    {
                        "id": 37263,
                        "name": "Sinlabajos",
                        "latitude": "41.07650000",
                        "longitude": "-4.83242000"
                    },
                    {
                        "id": 152747,
                        "name": "Solana de Ávila",
                        "latitude": "40.31506140",
                        "longitude": "-5.61359890"
                    },
                    {
                        "id": 152748,
                        "name": "Solana de Rioalmar",
                        "latitude": "40.73835930",
                        "longitude": "-5.01109520"
                    },
                    {
                        "id": 37284,
                        "name": "Solosancho",
                        "latitude": "40.55294000",
                        "longitude": "-4.90479000"
                    },
                    {
                        "id": 37311,
                        "name": "Sotalbo",
                        "latitude": "40.54170000",
                        "longitude": "-4.84548000"
                    },
                    {
                        "id": 37313,
                        "name": "Sotillo de la Adrada",
                        "latitude": "40.29120000",
                        "longitude": "-4.58385000"
                    },
                    {
                        "id": 152749,
                        "name": "Tiemblo El",
                        "latitude": "40.41308280",
                        "longitude": "-4.49931480"
                    },
                    {
                        "id": 37434,
                        "name": "Tiñosillos",
                        "latitude": "40.93400000",
                        "longitude": "-4.72767000"
                    },
                    {
                        "id": 37442,
                        "name": "Tolbaños",
                        "latitude": "40.75168000",
                        "longitude": "-4.58191000"
                    },
                    {
                        "id": 37469,
                        "name": "Tormellas",
                        "latitude": "40.30404000",
                        "longitude": "-5.51185000"
                    },
                    {
                        "id": 37473,
                        "name": "Tornadizos de Ávila",
                        "latitude": "40.62757000",
                        "longitude": "-4.61426000"
                    },
                    {
                        "id": 152750,
                        "name": "Torre La",
                        "latitude": "40.58972950",
                        "longitude": "-4.96561130"
                    },
                    {
                        "id": 37669,
                        "name": "Tórtoles",
                        "latitude": "40.56120000",
                        "longitude": "-5.26120000"
                    },
                    {
                        "id": 37686,
                        "name": "Umbrías",
                        "latitude": "40.31530000",
                        "longitude": "-5.58037000"
                    },
                    {
                        "id": 37717,
                        "name": "Vadillo de la Sierra",
                        "latitude": "40.60634000",
                        "longitude": "-5.12506000"
                    },
                    {
                        "id": 37739,
                        "name": "Valdecasa",
                        "latitude": "40.65931000",
                        "longitude": "-5.01183000"
                    },
                    {
                        "id": 37908,
                        "name": "Vega de Santa María",
                        "latitude": "40.83618000",
                        "longitude": "-4.64287000"
                    },
                    {
                        "id": 37925,
                        "name": "Velayos",
                        "latitude": "40.84157000",
                        "longitude": "-4.62324000"
                    },
                    {
                        "id": 38052,
                        "name": "Villaflor",
                        "latitude": "40.75865000",
                        "longitude": "-4.87379000"
                    },
                    {
                        "id": 38059,
                        "name": "Villafranca de la Sierra",
                        "latitude": "40.49806000",
                        "longitude": "-5.23005000"
                    },
                    {
                        "id": 152755,
                        "name": "Villanueva de Ávila",
                        "latitude": "40.37873220",
                        "longitude": "-4.82160740"
                    },
                    {
                        "id": 38185,
                        "name": "Villanueva de Gómez",
                        "latitude": "40.88269000",
                        "longitude": "-4.71650000"
                    },
                    {
                        "id": 38211,
                        "name": "Villanueva del Aceral",
                        "latitude": "41.04095000",
                        "longitude": "-4.85419000"
                    },
                    {
                        "id": 38214,
                        "name": "Villanueva del Campillo",
                        "latitude": "40.57646000",
                        "longitude": "-5.18002000"
                    },
                    {
                        "id": 38237,
                        "name": "Villar de Corneja",
                        "latitude": "40.47462000",
                        "longitude": "-5.43307000"
                    },
                    {
                        "id": 38276,
                        "name": "Villarejo del Valle",
                        "latitude": "40.28638000",
                        "longitude": "-4.99674000"
                    },
                    {
                        "id": 38331,
                        "name": "Villatoro",
                        "latitude": "40.55609000",
                        "longitude": "-5.11262000"
                    },
                    {
                        "id": 38409,
                        "name": "Viñegra de Moraña",
                        "latitude": "40.85074000",
                        "longitude": "-4.92115000"
                    },
                    {
                        "id": 38401,
                        "name": "Vita",
                        "latitude": "40.81178000",
                        "longitude": "-5.00583000"
                    },
                    {
                        "id": 38468,
                        "name": "Zapardiel de la Cañada",
                        "latitude": "40.60648000",
                        "longitude": "-5.33791000"
                    },
                    {
                        "id": 38469,
                        "name": "Zapardiel de la Ribera",
                        "latitude": "40.35554000",
                        "longitude": "-5.32826000"
                    }
                ]
            },
            {
                "id": 5092,
                "name": "Badajoz",
                "iso2": "BA",
                "latitude": "38.87937480",
                "longitude": "-7.02269830",
                "type": "province",
                "cities": [
                    {
                        "id": 31924,
                        "name": "Acedera",
                        "latitude": "39.07678000",
                        "longitude": "-5.57384000"
                    },
                    {
                        "id": 31926,
                        "name": "Aceuchal",
                        "latitude": "38.64627000",
                        "longitude": "-6.48636000"
                    },
                    {
                        "id": 31977,
                        "name": "Ahillones",
                        "latitude": "38.26667000",
                        "longitude": "-5.85000000"
                    },
                    {
                        "id": 31999,
                        "name": "Alange",
                        "latitude": "38.78495000",
                        "longitude": "-6.24574000"
                    },
                    {
                        "id": 151167,
                        "name": "Albuera La",
                        "latitude": "38.71702770",
                        "longitude": "-6.82304140"
                    },
                    {
                        "id": 32059,
                        "name": "Alburquerque",
                        "latitude": "39.22076000",
                        "longitude": "-7.00234000"
                    },
                    {
                        "id": 32115,
                        "name": "Alconchel",
                        "latitude": "38.51648000",
                        "longitude": "-7.07161000"
                    },
                    {
                        "id": 32118,
                        "name": "Alconera",
                        "latitude": "38.40000000",
                        "longitude": "-6.46667000"
                    },
                    {
                        "id": 32252,
                        "name": "Aljucén",
                        "latitude": "39.04425000",
                        "longitude": "-6.33109000"
                    },
                    {
                        "id": 32286,
                        "name": "Almendral",
                        "latitude": "38.61418000",
                        "longitude": "-6.82097000"
                    },
                    {
                        "id": 32288,
                        "name": "Almendralejo",
                        "latitude": "38.68316000",
                        "longitude": "-6.40747000"
                    },
                    {
                        "id": 32508,
                        "name": "Arroyo de San Serván",
                        "latitude": "38.85443000",
                        "longitude": "-6.45402000"
                    },
                    {
                        "id": 32544,
                        "name": "Atalaya",
                        "latitude": "38.33333000",
                        "longitude": "-6.46667000"
                    },
                    {
                        "id": 32588,
                        "name": "Azuaga",
                        "latitude": "38.26667000",
                        "longitude": "-5.68333000"
                    },
                    {
                        "id": 32601,
                        "name": "Badajoz",
                        "latitude": "38.87789000",
                        "longitude": "-6.97061000"
                    },
                    {
                        "id": 32652,
                        "name": "Barcarrota",
                        "latitude": "38.51473000",
                        "longitude": "-6.84923000"
                    },
                    {
                        "id": 32694,
                        "name": "Baterno",
                        "latitude": "38.95578000",
                        "longitude": "-4.91039000"
                    },
                    {
                        "id": 151168,
                        "name": "Benquerencia de la Serena",
                        "latitude": "38.70011910",
                        "longitude": "-5.49678970"
                    },
                    {
                        "id": 32854,
                        "name": "Berlanga",
                        "latitude": "38.28333000",
                        "longitude": "-5.81667000"
                    },
                    {
                        "id": 32890,
                        "name": "Bienvenida",
                        "latitude": "38.30000000",
                        "longitude": "-6.20000000"
                    },
                    {
                        "id": 32927,
                        "name": "Bodonal de la Sierra",
                        "latitude": "38.14751000",
                        "longitude": "-6.55950000"
                    },
                    {
                        "id": 33029,
                        "name": "Burguillos del Cerro",
                        "latitude": "38.38008000",
                        "longitude": "-6.59037000"
                    },
                    {
                        "id": 33077,
                        "name": "Cabeza del Buey",
                        "latitude": "38.72227000",
                        "longitude": "-5.21946000"
                    },
                    {
                        "id": 33079,
                        "name": "Cabeza la Vaca",
                        "latitude": "38.08333000",
                        "longitude": "-6.41667000"
                    },
                    {
                        "id": 33129,
                        "name": "Calamonte",
                        "latitude": "38.88861000",
                        "longitude": "-6.38791000"
                    },
                    {
                        "id": 33140,
                        "name": "Calera de León",
                        "latitude": "38.10000000",
                        "longitude": "-6.33333000"
                    },
                    {
                        "id": 151169,
                        "name": "Calzadilla de los Barros",
                        "latitude": "38.30046410",
                        "longitude": "-6.31746140"
                    },
                    {
                        "id": 33181,
                        "name": "Campanario",
                        "latitude": "38.86440000",
                        "longitude": "-5.61744000"
                    },
                    {
                        "id": 33193,
                        "name": "Campillo de Llerena",
                        "latitude": "38.50196000",
                        "longitude": "-5.83139000"
                    },
                    {
                        "id": 33269,
                        "name": "Capilla",
                        "latitude": "38.82037000",
                        "longitude": "-5.08417000"
                    },
                    {
                        "id": 33311,
                        "name": "Carmonita",
                        "latitude": "39.15455000",
                        "longitude": "-6.33864000"
                    },
                    {
                        "id": 151170,
                        "name": "Carrascalejo El",
                        "latitude": "39.02247500",
                        "longitude": "-6.33689810"
                    },
                    {
                        "id": 33361,
                        "name": "Casas de Don Pedro",
                        "latitude": "39.10822000",
                        "longitude": "-5.33077000"
                    },
                    {
                        "id": 33370,
                        "name": "Casas de Reina",
                        "latitude": "38.20000000",
                        "longitude": "-5.96667000"
                    },
                    {
                        "id": 33446,
                        "name": "Castilblanco",
                        "latitude": "39.28487000",
                        "longitude": "-5.09098000"
                    },
                    {
                        "id": 33512,
                        "name": "Castuera",
                        "latitude": "38.73204000",
                        "longitude": "-5.54390000"
                    },
                    {
                        "id": 33622,
                        "name": "Cheles",
                        "latitude": "38.51225000",
                        "longitude": "-7.28177000"
                    },
                    {
                        "id": 151171,
                        "name": "Codosera La",
                        "latitude": "39.20756330",
                        "longitude": "-7.17229170"
                    },
                    {
                        "id": 33780,
                        "name": "Cordobilla de Lácara",
                        "latitude": "39.14763000",
                        "longitude": "-6.43619000"
                    },
                    {
                        "id": 151172,
                        "name": "Coronada La",
                        "latitude": "38.91928810",
                        "longitude": "-5.67077560"
                    },
                    {
                        "id": 33805,
                        "name": "Corte de Peleas",
                        "latitude": "38.72631000",
                        "longitude": "-6.67035000"
                    },
                    {
                        "id": 33836,
                        "name": "Cristina",
                        "latitude": "38.83745000",
                        "longitude": "-6.09867000"
                    },
                    {
                        "id": 33942,
                        "name": "Don Álvaro",
                        "latitude": "38.84837000",
                        "longitude": "-6.27475000"
                    },
                    {
                        "id": 33941,
                        "name": "Don Benito",
                        "latitude": "38.95627000",
                        "longitude": "-5.86162000"
                    },
                    {
                        "id": 34064,
                        "name": "Entrín Bajo",
                        "latitude": "38.71855000",
                        "longitude": "-6.71349000"
                    },
                    {
                        "id": 34105,
                        "name": "Esparragalejo",
                        "latitude": "38.94330000",
                        "longitude": "-6.43549000"
                    },
                    {
                        "id": 34107,
                        "name": "Esparragosa de la Serena",
                        "latitude": "38.65100000",
                        "longitude": "-5.60657000"
                    },
                    {
                        "id": 34106,
                        "name": "Esparragosa de Lares",
                        "latitude": "38.97517000",
                        "longitude": "-5.26968000"
                    },
                    {
                        "id": 34173,
                        "name": "Feria",
                        "latitude": "38.51151000",
                        "longitude": "-6.56416000"
                    },
                    {
                        "id": 34242,
                        "name": "Fregenal de la Sierra",
                        "latitude": "38.16922000",
                        "longitude": "-6.65370000"
                    },
                    {
                        "id": 34284,
                        "name": "Fuenlabrada de los Montes",
                        "latitude": "39.13288000",
                        "longitude": "-4.93513000"
                    },
                    {
                        "id": 34295,
                        "name": "Fuente de Cantos",
                        "latitude": "38.25000000",
                        "longitude": "-6.30000000"
                    },
                    {
                        "id": 151173,
                        "name": "Fuente del Arco",
                        "latitude": "38.15227750",
                        "longitude": "-5.89805380"
                    },
                    {
                        "id": 34299,
                        "name": "Fuente del Maestre",
                        "latitude": "38.52656000",
                        "longitude": "-6.44782000"
                    },
                    {
                        "id": 34345,
                        "name": "Fuentes de León",
                        "latitude": "38.06866000",
                        "longitude": "-6.53884000"
                    },
                    {
                        "id": 34407,
                        "name": "Garbayuela",
                        "latitude": "39.04956000",
                        "longitude": "-4.99856000"
                    },
                    {
                        "id": 34420,
                        "name": "Garlitos",
                        "latitude": "38.88022000",
                        "longitude": "-5.04759000"
                    },
                    {
                        "id": 151174,
                        "name": "Garrovilla La",
                        "latitude": "38.92070940",
                        "longitude": "-6.47813310"
                    },
                    {
                        "id": 34502,
                        "name": "Granja de Torrehermosa",
                        "latitude": "38.31667000",
                        "longitude": "-5.58333000"
                    },
                    {
                        "id": 34537,
                        "name": "Guareña",
                        "latitude": "38.85952000",
                        "longitude": "-6.09987000"
                    },
                    {
                        "id": 151175,
                        "name": "Haba La",
                        "latitude": "38.92063060",
                        "longitude": "-5.80242570"
                    },
                    {
                        "id": 151176,
                        "name": "Helechosa de los Montes",
                        "latitude": "39.31204820",
                        "longitude": "-4.90783520"
                    },
                    {
                        "id": 34599,
                        "name": "Herrera del Duque",
                        "latitude": "39.16840000",
                        "longitude": "-5.05049000"
                    },
                    {
                        "id": 34611,
                        "name": "Higuera de la Serena",
                        "latitude": "38.64616000",
                        "longitude": "-5.74129000"
                    },
                    {
                        "id": 151177,
                        "name": "Higuera de Llerena",
                        "latitude": "38.37573640",
                        "longitude": "-5.99978390"
                    },
                    {
                        "id": 34610,
                        "name": "Higuera de Vargas",
                        "latitude": "38.44700000",
                        "longitude": "-6.97517000"
                    },
                    {
                        "id": 34614,
                        "name": "Higuera la Real",
                        "latitude": "38.14088000",
                        "longitude": "-6.68922000"
                    },
                    {
                        "id": 34628,
                        "name": "Hinojosa del Valle",
                        "latitude": "38.48333000",
                        "longitude": "-6.18333000"
                    },
                    {
                        "id": 34659,
                        "name": "Hornachos",
                        "latitude": "38.55428000",
                        "longitude": "-6.06829000"
                    },
                    {
                        "id": 34813,
                        "name": "Jerez de los Caballeros",
                        "latitude": "38.32063000",
                        "longitude": "-6.77260000"
                    },
                    {
                        "id": 151178,
                        "name": "Lapa La",
                        "latitude": "38.45608150",
                        "longitude": "-6.51964210"
                    },
                    {
                        "id": 35075,
                        "name": "Llera",
                        "latitude": "38.45000000",
                        "longitude": "-6.05000000"
                    },
                    {
                        "id": 35076,
                        "name": "Llerena",
                        "latitude": "38.23333000",
                        "longitude": "-6.01667000"
                    },
                    {
                        "id": 35097,
                        "name": "Lobón",
                        "latitude": "38.84876000",
                        "longitude": "-6.62365000"
                    },
                    {
                        "id": 35199,
                        "name": "Magacela",
                        "latitude": "38.89648000",
                        "longitude": "-5.73437000"
                    },
                    {
                        "id": 35204,
                        "name": "Maguilla",
                        "latitude": "38.36667000",
                        "longitude": "-5.83333000"
                    },
                    {
                        "id": 35221,
                        "name": "Malcocinado",
                        "latitude": "38.11667000",
                        "longitude": "-5.68333000"
                    },
                    {
                        "id": 35229,
                        "name": "Malpartida de la Serena",
                        "latitude": "38.67470000",
                        "longitude": "-5.64054000"
                    },
                    {
                        "id": 35243,
                        "name": "Manchita",
                        "latitude": "38.81404000",
                        "longitude": "-6.02041000"
                    },
                    {
                        "id": 35367,
                        "name": "Medellín",
                        "latitude": "38.96265000",
                        "longitude": "-5.95785000"
                    },
                    {
                        "id": 35372,
                        "name": "Medina de las Torres",
                        "latitude": "38.33333000",
                        "longitude": "-6.40000000"
                    },
                    {
                        "id": 35403,
                        "name": "Mengabril",
                        "latitude": "38.93554000",
                        "longitude": "-5.93335000"
                    },
                    {
                        "id": 35707,
                        "name": "Mérida",
                        "latitude": "38.91611000",
                        "longitude": "-6.34366000"
                    },
                    {
                        "id": 35452,
                        "name": "Mirandilla",
                        "latitude": "39.00200000",
                        "longitude": "-6.28893000"
                    },
                    {
                        "id": 35509,
                        "name": "Monesterio",
                        "latitude": "38.08333000",
                        "longitude": "-6.26667000"
                    },
                    {
                        "id": 35561,
                        "name": "Montemolín",
                        "latitude": "38.15000000",
                        "longitude": "-6.20000000"
                    },
                    {
                        "id": 35568,
                        "name": "Monterrubio de la Serena",
                        "latitude": "38.58876000",
                        "longitude": "-5.44569000"
                    },
                    {
                        "id": 35576,
                        "name": "Montijo",
                        "latitude": "38.90839000",
                        "longitude": "-6.61785000"
                    },
                    {
                        "id": 151179,
                        "name": "Morera La",
                        "latitude": "38.54606970",
                        "longitude": "-6.65245350"
                    },
                    {
                        "id": 151180,
                        "name": "Nava de Santiago La",
                        "latitude": "39.06285420",
                        "longitude": "-6.50497640"
                    },
                    {
                        "id": 35761,
                        "name": "Navalvillar de Pela",
                        "latitude": "39.09436000",
                        "longitude": "-5.46810000"
                    },
                    {
                        "id": 35816,
                        "name": "Nogales",
                        "latitude": "38.58629000",
                        "longitude": "-6.74901000"
                    },
                    {
                        "id": 35887,
                        "name": "Oliva de la Frontera",
                        "latitude": "38.27595000",
                        "longitude": "-6.91873000"
                    },
                    {
                        "id": 35885,
                        "name": "Oliva de Mérida",
                        "latitude": "38.79051000",
                        "longitude": "-6.12402000"
                    },
                    {
                        "id": 35892,
                        "name": "Olivenza",
                        "latitude": "38.68269000",
                        "longitude": "-7.10046000"
                    },
                    {
                        "id": 151181,
                        "name": "Orellana de la Sierra",
                        "latitude": "39.03097550",
                        "longitude": "-5.49678970"
                    },
                    {
                        "id": 35943,
                        "name": "Orellana la Vieja",
                        "latitude": "39.00617000",
                        "longitude": "-5.53441000"
                    },
                    {
                        "id": 36038,
                        "name": "Palomas",
                        "latitude": "38.69277000",
                        "longitude": "-6.13490000"
                    },
                    {
                        "id": 151182,
                        "name": "Parra La",
                        "latitude": "38.52162650",
                        "longitude": "-6.62321160"
                    },
                    {
                        "id": 36167,
                        "name": "Peñalsordo",
                        "latitude": "38.82019000",
                        "longitude": "-5.11405000"
                    },
                    {
                        "id": 151183,
                        "name": "Peraleda del Zaucejo",
                        "latitude": "38.47451950",
                        "longitude": "-5.56500950"
                    },
                    {
                        "id": 36409,
                        "name": "Puebla de Alcocer",
                        "latitude": "38.98648000",
                        "longitude": "-5.25633000"
                    },
                    {
                        "id": 36426,
                        "name": "Puebla de la Calzada",
                        "latitude": "38.89441000",
                        "longitude": "-6.62592000"
                    },
                    {
                        "id": 36427,
                        "name": "Puebla de la Reina",
                        "latitude": "38.66455000",
                        "longitude": "-6.10216000"
                    },
                    {
                        "id": 36419,
                        "name": "Puebla de Obando",
                        "latitude": "39.17630000",
                        "longitude": "-6.62764000"
                    },
                    {
                        "id": 36424,
                        "name": "Puebla de Sancho Pérez",
                        "latitude": "38.40000000",
                        "longitude": "-6.40000000"
                    },
                    {
                        "id": 36428,
                        "name": "Puebla del Maestre",
                        "latitude": "38.08333000",
                        "longitude": "-6.08333000"
                    },
                    {
                        "id": 36429,
                        "name": "Puebla del Prior",
                        "latitude": "38.57032000",
                        "longitude": "-6.19584000"
                    },
                    {
                        "id": 151192,
                        "name": "Pueblonuevo del Guadiana",
                        "latitude": "38.92761310",
                        "longitude": "-6.76010570"
                    },
                    {
                        "id": 36502,
                        "name": "Quintana de la Serena",
                        "latitude": "38.74595000",
                        "longitude": "-5.67233000"
                    },
                    {
                        "id": 36567,
                        "name": "Reina",
                        "latitude": "38.18333000",
                        "longitude": "-5.95000000"
                    },
                    {
                        "id": 36575,
                        "name": "Rena",
                        "latitude": "39.05252000",
                        "longitude": "-5.80868000"
                    },
                    {
                        "id": 151184,
                        "name": "Retamal de Llerena",
                        "latitude": "38.57771250",
                        "longitude": "-5.83868050"
                    },
                    {
                        "id": 36615,
                        "name": "Ribera del Fresno",
                        "latitude": "38.55177000",
                        "longitude": "-6.23768000"
                    },
                    {
                        "id": 151185,
                        "name": "Risco",
                        "latitude": "38.88647460",
                        "longitude": "-5.11194070"
                    },
                    {
                        "id": 151186,
                        "name": "Roca de la Sierra La",
                        "latitude": "39.10946920",
                        "longitude": "-6.68920890"
                    },
                    {
                        "id": 36783,
                        "name": "Salvaleón",
                        "latitude": "38.51020000",
                        "longitude": "-6.78627000"
                    },
                    {
                        "id": 36788,
                        "name": "Salvatierra de los Barros",
                        "latitude": "38.49091000",
                        "longitude": "-6.68423000"
                    },
                    {
                        "id": 36907,
                        "name": "San Pedro de Mérida",
                        "latitude": "38.95007000",
                        "longitude": "-6.18645000"
                    },
                    {
                        "id": 36926,
                        "name": "San Vicente de Alcántara",
                        "latitude": "39.36132000",
                        "longitude": "-7.13766000"
                    },
                    {
                        "id": 37003,
                        "name": "Santa Amalia",
                        "latitude": "39.01118000",
                        "longitude": "-6.01158000"
                    },
                    {
                        "id": 37069,
                        "name": "Santa Marta",
                        "latitude": "38.61421000",
                        "longitude": "-6.62799000"
                    },
                    {
                        "id": 151188,
                        "name": "Santos de Maimona Los",
                        "latitude": "38.44923300",
                        "longitude": "-6.38245120"
                    },
                    {
                        "id": 37195,
                        "name": "Segura de León",
                        "latitude": "38.11667000",
                        "longitude": "-6.51667000"
                    },
                    {
                        "id": 37264,
                        "name": "Siruela",
                        "latitude": "38.97718000",
                        "longitude": "-5.04969000"
                    },
                    {
                        "id": 37279,
                        "name": "Solana de los Barros",
                        "latitude": "38.72527000",
                        "longitude": "-6.53899000"
                    },
                    {
                        "id": 37356,
                        "name": "Talarrubias",
                        "latitude": "39.03697000",
                        "longitude": "-5.23423000"
                    },
                    {
                        "id": 37357,
                        "name": "Talavera La Real",
                        "latitude": "38.87794000",
                        "longitude": "-6.76856000"
                    },
                    {
                        "id": 37663,
                        "name": "Táliga",
                        "latitude": "38.52861000",
                        "longitude": "-7.01713000"
                    },
                    {
                        "id": 37367,
                        "name": "Tamurejo",
                        "latitude": "38.98333000",
                        "longitude": "-4.93333000"
                    },
                    {
                        "id": 37494,
                        "name": "Torre de Miguel Sesmero",
                        "latitude": "38.61913000",
                        "longitude": "-6.79580000"
                    },
                    {
                        "id": 37552,
                        "name": "Torremayor",
                        "latitude": "38.90140000",
                        "longitude": "-6.53858000"
                    },
                    {
                        "id": 151189,
                        "name": "Torremejía",
                        "latitude": "38.78912670",
                        "longitude": "-6.37712940"
                    },
                    {
                        "id": 37619,
                        "name": "Trasierra",
                        "latitude": "38.18333000",
                        "longitude": "-6.00000000"
                    },
                    {
                        "id": 37644,
                        "name": "Trujillanos",
                        "latitude": "38.95233000",
                        "longitude": "-6.25759000"
                    },
                    {
                        "id": 37703,
                        "name": "Usagre",
                        "latitude": "38.35000000",
                        "longitude": "-6.16667000"
                    },
                    {
                        "id": 37737,
                        "name": "Valdecaballeros",
                        "latitude": "39.24289000",
                        "longitude": "-5.19000000"
                    },
                    {
                        "id": 37753,
                        "name": "Valdelacalzada",
                        "latitude": "38.88943000",
                        "longitude": "-6.70029000"
                    },
                    {
                        "id": 37803,
                        "name": "Valdetorres",
                        "latitude": "38.91542000",
                        "longitude": "-6.06765000"
                    },
                    {
                        "id": 37819,
                        "name": "Valencia de las Torres",
                        "latitude": "38.40518000",
                        "longitude": "-6.00403000"
                    },
                    {
                        "id": 37820,
                        "name": "Valencia del Mombuey",
                        "latitude": "38.24243000",
                        "longitude": "-7.11965000"
                    },
                    {
                        "id": 37821,
                        "name": "Valencia del Ventoso",
                        "latitude": "38.26667000",
                        "longitude": "-6.46667000"
                    },
                    {
                        "id": 37848,
                        "name": "Valle de la Serena",
                        "latitude": "38.71010000",
                        "longitude": "-5.79847000"
                    },
                    {
                        "id": 37845,
                        "name": "Valle de Matamoros",
                        "latitude": "38.37889000",
                        "longitude": "-6.80371000"
                    },
                    {
                        "id": 37846,
                        "name": "Valle de Santa Ana",
                        "latitude": "38.36637000",
                        "longitude": "-6.78860000"
                    },
                    {
                        "id": 37883,
                        "name": "Valverde de Burguillos",
                        "latitude": "38.32710000",
                        "longitude": "-6.53648000"
                    },
                    {
                        "id": 37886,
                        "name": "Valverde de Leganés",
                        "latitude": "38.67059000",
                        "longitude": "-6.98036000"
                    },
                    {
                        "id": 37887,
                        "name": "Valverde de Llerena",
                        "latitude": "38.21667000",
                        "longitude": "-5.81667000"
                    },
                    {
                        "id": 37888,
                        "name": "Valverde de Mérida",
                        "latitude": "38.91122000",
                        "longitude": "-6.21999000"
                    },
                    {
                        "id": 38060,
                        "name": "Villafranca de los Barros",
                        "latitude": "38.56144000",
                        "longitude": "-6.33810000"
                    },
                    {
                        "id": 38072,
                        "name": "Villagarcía de la Torre",
                        "latitude": "38.30000000",
                        "longitude": "-6.08333000"
                    },
                    {
                        "id": 38076,
                        "name": "Villagonzalo",
                        "latitude": "38.86329000",
                        "longitude": "-6.19665000"
                    },
                    {
                        "id": 38100,
                        "name": "Villalba de los Barros",
                        "latitude": "38.61294000",
                        "longitude": "-6.50914000"
                    },
                    {
                        "id": 38201,
                        "name": "Villanueva de la Serena",
                        "latitude": "38.97655000",
                        "longitude": "-5.79740000"
                    },
                    {
                        "id": 38218,
                        "name": "Villanueva del Fresno",
                        "latitude": "38.37600000",
                        "longitude": "-7.16753000"
                    },
                    {
                        "id": 38244,
                        "name": "Villar de Rena",
                        "latitude": "39.07651000",
                        "longitude": "-5.81074000"
                    },
                    {
                        "id": 38260,
                        "name": "Villar del Rey",
                        "latitude": "39.13310000",
                        "longitude": "-6.84762000"
                    },
                    {
                        "id": 38308,
                        "name": "Villarta de los Montes",
                        "latitude": "39.21386000",
                        "longitude": "-4.79227000"
                    },
                    {
                        "id": 38450,
                        "name": "Zafra",
                        "latitude": "38.42539000",
                        "longitude": "-6.41734000"
                    },
                    {
                        "id": 38456,
                        "name": "Zahinos",
                        "latitude": "38.33135000",
                        "longitude": "-6.95533000"
                    },
                    {
                        "id": 38458,
                        "name": "Zalamea de la Serena",
                        "latitude": "38.65131000",
                        "longitude": "-5.66063000"
                    },
                    {
                        "id": 151191,
                        "name": "Zarza La",
                        "latitude": "38.81856130",
                        "longitude": "-6.21768670"
                    },
                    {
                        "id": 151190,
                        "name": "Zarza-Capilla",
                        "latitude": "38.76944780",
                        "longitude": "-5.16406050"
                    }
                ]
            },
            {
                "id": 5335,
                "name": "Balearic Islands",
                "iso2": "IB",
                "latitude": "39.36215860",
                "longitude": "1.42334520",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5102,
                "name": "Barcelona",
                "iso2": "B",
                "latitude": "41.39266790",
                "longitude": "2.14018910",
                "type": "province",
                "cities": [
                    {
                        "id": 31917,
                        "name": "Abrera",
                        "latitude": "41.51682000",
                        "longitude": "1.90100000"
                    },
                    {
                        "id": 31963,
                        "name": "Aguilar de Segarra",
                        "latitude": "41.74822000",
                        "longitude": "1.62919000"
                    },
                    {
                        "id": 31980,
                        "name": "Aiguafreda",
                        "latitude": "41.76807000",
                        "longitude": "2.25051000"
                    },
                    {
                        "id": 32183,
                        "name": "Alella",
                        "latitude": "41.49379000",
                        "longitude": "2.29451000"
                    },
                    {
                        "id": 32328,
                        "name": "Alpens",
                        "latitude": "42.11930000",
                        "longitude": "2.10135000"
                    },
                    {
                        "id": 151479,
                        "name": "Ametlla del Vallès L",
                        "latitude": "41.66898350",
                        "longitude": "2.26050150"
                    },
                    {
                        "id": 32451,
                        "name": "Arenys de Mar",
                        "latitude": "41.58190000",
                        "longitude": "2.54936000"
                    },
                    {
                        "id": 32452,
                        "name": "Arenys de Munt",
                        "latitude": "41.61424000",
                        "longitude": "2.53972000"
                    },
                    {
                        "id": 151480,
                        "name": "Argençola",
                        "latitude": "41.59807500",
                        "longitude": "1.44377110"
                    },
                    {
                        "id": 32471,
                        "name": "Argentona",
                        "latitude": "41.55336000",
                        "longitude": "2.40114000"
                    },
                    {
                        "id": 32527,
                        "name": "Artés",
                        "latitude": "41.79800000",
                        "longitude": "1.95428000"
                    },
                    {
                        "id": 151481,
                        "name": "Avià",
                        "latitude": "42.07821010",
                        "longitude": "1.82026490"
                    },
                    {
                        "id": 32568,
                        "name": "Avinyó",
                        "latitude": "41.86367000",
                        "longitude": "1.97095000"
                    },
                    {
                        "id": 151482,
                        "name": "Avinyonet del Penedès",
                        "latitude": "41.35475380",
                        "longitude": "1.78580920"
                    },
                    {
                        "id": 32602,
                        "name": "Badalona",
                        "latitude": "41.45004000",
                        "longitude": "2.24741000"
                    },
                    {
                        "id": 151629,
                        "name": "Badia del Vallès",
                        "latitude": "41.50805200",
                        "longitude": "2.11529320"
                    },
                    {
                        "id": 32609,
                        "name": "Bagà",
                        "latitude": "42.25289000",
                        "longitude": "1.86098000"
                    },
                    {
                        "id": 151483,
                        "name": "Balenyà",
                        "latitude": "41.45527810",
                        "longitude": "2.18390780"
                    },
                    {
                        "id": 32628,
                        "name": "Balsareny",
                        "latitude": "41.86311000",
                        "longitude": "1.87356000"
                    },
                    {
                        "id": 32647,
                        "name": "Barberà del Vallès",
                        "latitude": "41.51590000",
                        "longitude": "2.12457000"
                    },
                    {
                        "id": 32653,
                        "name": "Barcelona",
                        "latitude": "41.38879000",
                        "longitude": "2.15899000"
                    },
                    {
                        "id": 32728,
                        "name": "Begues",
                        "latitude": "41.33333000",
                        "longitude": "1.93333000"
                    },
                    {
                        "id": 32742,
                        "name": "Bellprat",
                        "latitude": "41.51695000",
                        "longitude": "1.43333000"
                    },
                    {
                        "id": 32846,
                        "name": "Berga",
                        "latitude": "42.10429000",
                        "longitude": "1.84628000"
                    },
                    {
                        "id": 32893,
                        "name": "Bigues i Riells",
                        "latitude": "41.68333000",
                        "longitude": "2.23333000"
                    },
                    {
                        "id": 151484,
                        "name": "Borredà",
                        "latitude": "42.13475630",
                        "longitude": "1.99396430"
                    },
                    {
                        "id": 151485,
                        "name": "Bruc El",
                        "latitude": "41.39432320",
                        "longitude": "2.16952660"
                    },
                    {
                        "id": 151486,
                        "name": "Brull El",
                        "latitude": "41.81681130",
                        "longitude": "2.30540670"
                    },
                    {
                        "id": 151487,
                        "name": "Cabanyes Les",
                        "latitude": "41.37194190",
                        "longitude": "1.68882570"
                    },
                    {
                        "id": 151488,
                        "name": "Cabrera dAnoia",
                        "latitude": "41.49361170",
                        "longitude": "1.71009500"
                    },
                    {
                        "id": 33104,
                        "name": "Cabrera de Mar",
                        "latitude": "41.51667000",
                        "longitude": "2.40000000"
                    },
                    {
                        "id": 33111,
                        "name": "Cabrils",
                        "latitude": "41.52760000",
                        "longitude": "2.36996000"
                    },
                    {
                        "id": 33124,
                        "name": "Calaf",
                        "latitude": "41.73289000",
                        "longitude": "1.51375000"
                    },
                    {
                        "id": 151490,
                        "name": "Calders",
                        "latitude": "41.38455100",
                        "longitude": "2.18328210"
                    },
                    {
                        "id": 33138,
                        "name": "Caldes de Montbui",
                        "latitude": "41.63333000",
                        "longitude": "2.16667000"
                    },
                    {
                        "id": 151489,
                        "name": "Caldes dEstrac",
                        "latitude": "41.57168580",
                        "longitude": "2.52367170"
                    },
                    {
                        "id": 33139,
                        "name": "Calella",
                        "latitude": "41.61381000",
                        "longitude": "2.65423000"
                    },
                    {
                        "id": 151492,
                        "name": "Calldetenes",
                        "latitude": "41.92509820",
                        "longitude": "2.28409530"
                    },
                    {
                        "id": 151493,
                        "name": "Callús",
                        "latitude": "41.79659590",
                        "longitude": "1.78309730"
                    },
                    {
                        "id": 151491,
                        "name": "Calonge de Segarra",
                        "latitude": "41.74104490",
                        "longitude": "1.49182350"
                    },
                    {
                        "id": 33198,
                        "name": "Campins",
                        "latitude": "41.71667000",
                        "longitude": "2.46667000"
                    },
                    {
                        "id": 33234,
                        "name": "Canet de Mar",
                        "latitude": "41.59054000",
                        "longitude": "2.58116000"
                    },
                    {
                        "id": 33246,
                        "name": "Canovelles",
                        "latitude": "41.61667000",
                        "longitude": "2.28333000"
                    },
                    {
                        "id": 33890,
                        "name": "Cànoves i Samalús",
                        "latitude": "41.68333000",
                        "longitude": "2.35000000"
                    },
                    {
                        "id": 33261,
                        "name": "Canyelles",
                        "latitude": "41.44509000",
                        "longitude": "2.16346000"
                    },
                    {
                        "id": 33267,
                        "name": "Capellades",
                        "latitude": "41.53005000",
                        "longitude": "1.68651000"
                    },
                    {
                        "id": 151494,
                        "name": "Capolat",
                        "latitude": "42.08314540",
                        "longitude": "1.75480080"
                    },
                    {
                        "id": 33296,
                        "name": "Cardedeu",
                        "latitude": "41.63976000",
                        "longitude": "2.35739000"
                    },
                    {
                        "id": 33304,
                        "name": "Cardona",
                        "latitude": "41.91371000",
                        "longitude": "1.67855000"
                    },
                    {
                        "id": 151495,
                        "name": "Carme",
                        "latitude": "41.53182820",
                        "longitude": "1.62034680"
                    },
                    {
                        "id": 151496,
                        "name": "Casserres",
                        "latitude": "42.01208190",
                        "longitude": "1.84341620"
                    },
                    {
                        "id": 151500,
                        "name": "Castell de lAreny",
                        "latitude": "42.17308830",
                        "longitude": "1.94520140"
                    },
                    {
                        "id": 151498,
                        "name": "Castellar de nHug",
                        "latitude": "42.28295120",
                        "longitude": "2.01721810"
                    },
                    {
                        "id": 151497,
                        "name": "Castellar del Riu",
                        "latitude": "42.11411990",
                        "longitude": "1.76361810"
                    },
                    {
                        "id": 33422,
                        "name": "Castellar del Vallès",
                        "latitude": "41.61667000",
                        "longitude": "2.08333000"
                    },
                    {
                        "id": 151499,
                        "name": "Castellbell i el Vilar",
                        "latitude": "41.62910320",
                        "longitude": "1.86415190"
                    },
                    {
                        "id": 33423,
                        "name": "Castellbisbal",
                        "latitude": "41.47534000",
                        "longitude": "1.98174000"
                    },
                    {
                        "id": 33424,
                        "name": "Castellcir",
                        "latitude": "41.76074000",
                        "longitude": "2.16128000"
                    },
                    {
                        "id": 33425,
                        "name": "Castelldefels",
                        "latitude": "41.27794000",
                        "longitude": "1.97033000"
                    },
                    {
                        "id": 151501,
                        "name": "Castellet i la Gornal",
                        "latitude": "41.25353610",
                        "longitude": "1.59250290"
                    },
                    {
                        "id": 33427,
                        "name": "Castellfollit de Riubregós",
                        "latitude": "41.76667000",
                        "longitude": "1.43333000"
                    },
                    {
                        "id": 151502,
                        "name": "Castellfollit del Boix",
                        "latitude": "41.66587320",
                        "longitude": "1.68426930"
                    },
                    {
                        "id": 151503,
                        "name": "Castellgalí",
                        "latitude": "41.67472390",
                        "longitude": "1.84353190"
                    },
                    {
                        "id": 151504,
                        "name": "Castellnou de Bages",
                        "latitude": "41.83434360",
                        "longitude": "1.83678620"
                    },
                    {
                        "id": 33431,
                        "name": "Castellolí",
                        "latitude": "41.59829000",
                        "longitude": "1.70057000"
                    },
                    {
                        "id": 151505,
                        "name": "Castellterçol",
                        "latitude": "41.41715690",
                        "longitude": "2.14627870"
                    },
                    {
                        "id": 151506,
                        "name": "Castellví de la Marca",
                        "latitude": "41.33248330",
                        "longitude": "1.59358600"
                    },
                    {
                        "id": 33435,
                        "name": "Castellví de Rosanes",
                        "latitude": "41.45000000",
                        "longitude": "1.90000000"
                    },
                    {
                        "id": 33573,
                        "name": "Centelles",
                        "latitude": "41.79746000",
                        "longitude": "2.21902000"
                    },
                    {
                        "id": 151610,
                        "name": "Cercs",
                        "latitude": "42.14687420",
                        "longitude": "1.86018620"
                    },
                    {
                        "id": 33580,
                        "name": "Cerdanyola del Vallès",
                        "latitude": "41.49109000",
                        "longitude": "2.14079000"
                    },
                    {
                        "id": 33594,
                        "name": "Cervelló",
                        "latitude": "41.39587000",
                        "longitude": "1.95917000"
                    },
                    {
                        "id": 33738,
                        "name": "Collbató",
                        "latitude": "41.57009000",
                        "longitude": "1.82712000"
                    },
                    {
                        "id": 33740,
                        "name": "Collsuspina",
                        "latitude": "41.82580000",
                        "longitude": "2.17546000"
                    },
                    {
                        "id": 151507,
                        "name": "Copons",
                        "latitude": "41.64608920",
                        "longitude": "1.51602120"
                    },
                    {
                        "id": 33775,
                        "name": "Corbera de Llobregat",
                        "latitude": "41.41702000",
                        "longitude": "1.91970000"
                    },
                    {
                        "id": 33794,
                        "name": "Cornellà de Llobregat",
                        "latitude": "41.35000000",
                        "longitude": "2.08333000"
                    },
                    {
                        "id": 33847,
                        "name": "Cubelles",
                        "latitude": "41.20772000",
                        "longitude": "1.67267000"
                    },
                    {
                        "id": 33952,
                        "name": "Dosrius",
                        "latitude": "41.58333000",
                        "longitude": "2.41667000"
                    },
                    {
                        "id": 34108,
                        "name": "Esparreguera",
                        "latitude": "41.53809000",
                        "longitude": "1.87025000"
                    },
                    {
                        "id": 34127,
                        "name": "Esplugues de Llobregat",
                        "latitude": "41.37732000",
                        "longitude": "2.08809000"
                    },
                    {
                        "id": 151508,
                        "name": "Espunyola L",
                        "latitude": "42.05356830",
                        "longitude": "1.77124450"
                    },
                    {
                        "id": 151509,
                        "name": "Estany L",
                        "latitude": "41.86897470",
                        "longitude": "2.11158180"
                    },
                    {
                        "id": 151539,
                        "name": "Figaró-Montmany",
                        "latitude": "41.72082040",
                        "longitude": "2.27365590"
                    },
                    {
                        "id": 151510,
                        "name": "Fígols",
                        "latitude": "41.38197400",
                        "longitude": "2.13038320"
                    },
                    {
                        "id": 151512,
                        "name": "Fogars de la Selva",
                        "latitude": "41.72732260",
                        "longitude": "2.67861630"
                    },
                    {
                        "id": 151511,
                        "name": "Fogars de Montclús",
                        "latitude": "41.72749340",
                        "longitude": "2.44284240"
                    },
                    {
                        "id": 151513,
                        "name": "Folgueroles",
                        "latitude": "41.40799640",
                        "longitude": "2.13628680"
                    },
                    {
                        "id": 34209,
                        "name": "Fonollosa",
                        "latitude": "41.76303000",
                        "longitude": "1.66867000"
                    },
                    {
                        "id": 151514,
                        "name": "Font-rubí",
                        "latitude": "41.43470240",
                        "longitude": "1.59107010"
                    },
                    {
                        "id": 151515,
                        "name": "Franqueses del Vallès Les",
                        "latitude": "41.64782750",
                        "longitude": "2.31230310"
                    },
                    {
                        "id": 151517,
                        "name": "Gaià",
                        "latitude": "41.36169170",
                        "longitude": "2.14151710"
                    },
                    {
                        "id": 34392,
                        "name": "Gallifa",
                        "latitude": "41.69243000",
                        "longitude": "2.11346000"
                    },
                    {
                        "id": 151516,
                        "name": "Garriga La",
                        "latitude": "41.68012810",
                        "longitude": "2.28323180"
                    },
                    {
                        "id": 34441,
                        "name": "Gavà",
                        "latitude": "41.30605000",
                        "longitude": "2.00123000"
                    },
                    {
                        "id": 34446,
                        "name": "Gelida",
                        "latitude": "41.43333000",
                        "longitude": "1.86667000"
                    },
                    {
                        "id": 34471,
                        "name": "Gironella",
                        "latitude": "42.03433000",
                        "longitude": "1.88019000"
                    },
                    {
                        "id": 151518,
                        "name": "Gisclareny",
                        "latitude": "42.27172960",
                        "longitude": "1.78309730"
                    },
                    {
                        "id": 151519,
                        "name": "Granada La",
                        "latitude": "41.37583180",
                        "longitude": "1.72225350"
                    },
                    {
                        "id": 34499,
                        "name": "Granera",
                        "latitude": "41.72741000",
                        "longitude": "2.05924000"
                    },
                    {
                        "id": 34503,
                        "name": "Granollers",
                        "latitude": "41.60797000",
                        "longitude": "2.28773000"
                    },
                    {
                        "id": 151520,
                        "name": "Gualba",
                        "latitude": "41.73189920",
                        "longitude": "2.50224180"
                    },
                    {
                        "id": 151521,
                        "name": "Guardiola de Berguedà",
                        "latitude": "42.23260290",
                        "longitude": "1.88001350"
                    },
                    {
                        "id": 34553,
                        "name": "Gurb",
                        "latitude": "41.95419000",
                        "longitude": "2.23537000"
                    },
                    {
                        "id": 151522,
                        "name": "Hospitalet de Llobregat L",
                        "latitude": "41.36618650",
                        "longitude": "2.11649420"
                    },
                    {
                        "id": 151549,
                        "name": "Hostalets de Pierola Els",
                        "latitude": "41.53717590",
                        "longitude": "1.80258520"
                    },
                    {
                        "id": 34739,
                        "name": "Igualada",
                        "latitude": "41.58098000",
                        "longitude": "1.61720000"
                    },
                    {
                        "id": 34821,
                        "name": "Jorba",
                        "latitude": "41.60193000",
                        "longitude": "1.54750000"
                    },
                    {
                        "id": 151523,
                        "name": "Llacuna La",
                        "latitude": "41.47173280",
                        "longitude": "1.53236250"
                    },
                    {
                        "id": 151524,
                        "name": "Llagosta La",
                        "latitude": "41.51276970",
                        "longitude": "2.20153470"
                    },
                    {
                        "id": 151525,
                        "name": "Lliçà dAmunt",
                        "latitude": "41.61457810",
                        "longitude": "2.22858640"
                    },
                    {
                        "id": 151526,
                        "name": "Lliçà de Vall",
                        "latitude": "41.58318640",
                        "longitude": "2.23965770"
                    },
                    {
                        "id": 35080,
                        "name": "Llinars del Vallès",
                        "latitude": "41.63333000",
                        "longitude": "2.40000000"
                    },
                    {
                        "id": 151527,
                        "name": "Lluçà",
                        "latitude": "41.38213490",
                        "longitude": "2.13092920"
                    },
                    {
                        "id": 35223,
                        "name": "Malgrat de Mar",
                        "latitude": "41.64662000",
                        "longitude": "2.74135000"
                    },
                    {
                        "id": 151528,
                        "name": "Malla",
                        "latitude": "41.89640600",
                        "longitude": "2.24381010"
                    },
                    {
                        "id": 35254,
                        "name": "Manlleu",
                        "latitude": "42.00228000",
                        "longitude": "2.28476000"
                    },
                    {
                        "id": 35256,
                        "name": "Manresa",
                        "latitude": "41.72815000",
                        "longitude": "1.82399000"
                    },
                    {
                        "id": 151599,
                        "name": "Marganell",
                        "latitude": "41.64049700",
                        "longitude": "1.79031430"
                    },
                    {
                        "id": 35301,
                        "name": "Martorell",
                        "latitude": "41.47402000",
                        "longitude": "1.93062000"
                    },
                    {
                        "id": 151529,
                        "name": "Martorelles",
                        "latitude": "41.45809220",
                        "longitude": "2.18335120"
                    },
                    {
                        "id": 151530,
                        "name": "Masies de Roda Les",
                        "latitude": "41.98588030",
                        "longitude": "2.31120540"
                    },
                    {
                        "id": 151531,
                        "name": "Masies de Voltregà Les",
                        "latitude": "42.01723120",
                        "longitude": "2.24444600"
                    },
                    {
                        "id": 151532,
                        "name": "Masnou El",
                        "latitude": "41.48056840",
                        "longitude": "2.31476770"
                    },
                    {
                        "id": 35325,
                        "name": "Masquefa",
                        "latitude": "41.50353000",
                        "longitude": "1.81136000"
                    },
                    {
                        "id": 35332,
                        "name": "Matadepera",
                        "latitude": "41.59886000",
                        "longitude": "2.02648000"
                    },
                    {
                        "id": 35340,
                        "name": "Mataró",
                        "latitude": "41.54211000",
                        "longitude": "2.44450000"
                    },
                    {
                        "id": 35376,
                        "name": "Mediona",
                        "latitude": "41.47798000",
                        "longitude": "1.61222000"
                    },
                    {
                        "id": 35472,
                        "name": "Moià",
                        "latitude": "41.81112000",
                        "longitude": "2.09839000"
                    },
                    {
                        "id": 35484,
                        "name": "Molins de Rei",
                        "latitude": "41.41667000",
                        "longitude": "2.01667000"
                    },
                    {
                        "id": 35488,
                        "name": "Mollet del Vallès",
                        "latitude": "41.54026000",
                        "longitude": "2.21306000"
                    },
                    {
                        "id": 151533,
                        "name": "Monistrol de Calders",
                        "latitude": "41.75984090",
                        "longitude": "2.01446380"
                    },
                    {
                        "id": 35517,
                        "name": "Monistrol de Montserrat",
                        "latitude": "41.61667000",
                        "longitude": "1.85000000"
                    },
                    {
                        "id": 35540,
                        "name": "Montcada i Reixac",
                        "latitude": "41.48333000",
                        "longitude": "2.18333000"
                    },
                    {
                        "id": 151535,
                        "name": "Montclar",
                        "latitude": "42.01810680",
                        "longitude": "1.76498740"
                    },
                    {
                        "id": 151536,
                        "name": "Montesquiu",
                        "latitude": "41.40468150",
                        "longitude": "2.13256110"
                    },
                    {
                        "id": 35573,
                        "name": "Montgat",
                        "latitude": "41.46859000",
                        "longitude": "2.28001000"
                    },
                    {
                        "id": 151537,
                        "name": "Montmajor",
                        "latitude": "41.43248270",
                        "longitude": "2.17067000"
                    },
                    {
                        "id": 151538,
                        "name": "Montmaneu",
                        "latitude": "41.62586400",
                        "longitude": "1.41538820"
                    },
                    {
                        "id": 35580,
                        "name": "Montmeló",
                        "latitude": "41.55002000",
                        "longitude": "2.24190000"
                    },
                    {
                        "id": 35582,
                        "name": "Montornès del Vallès",
                        "latitude": "41.54206000",
                        "longitude": "2.26748000"
                    },
                    {
                        "id": 151540,
                        "name": "Montseny",
                        "latitude": "41.78558370",
                        "longitude": "2.39123620"
                    },
                    {
                        "id": 151534,
                        "name": "Muntanyola",
                        "latitude": "41.44101110",
                        "longitude": "2.14852830"
                    },
                    {
                        "id": 35668,
                        "name": "Mura",
                        "latitude": "41.69943000",
                        "longitude": "1.97612000"
                    },
                    {
                        "id": 35765,
                        "name": "Navarcles",
                        "latitude": "41.75171000",
                        "longitude": "1.90357000"
                    },
                    {
                        "id": 35776,
                        "name": "Navas",
                        "latitude": "41.41803000",
                        "longitude": "2.18596000"
                    },
                    {
                        "id": 151541,
                        "name": "Nou de Berguedà La",
                        "latitude": "42.19096050",
                        "longitude": "1.90015500"
                    },
                    {
                        "id": 38581,
                        "name": "Òdena",
                        "latitude": "41.60000000",
                        "longitude": "1.65000000"
                    },
                    {
                        "id": 151543,
                        "name": "Olèrdola",
                        "latitude": "41.31815610",
                        "longitude": "1.72468560"
                    },
                    {
                        "id": 35878,
                        "name": "Olesa de Bonesvalls",
                        "latitude": "41.35435000",
                        "longitude": "1.84907000"
                    },
                    {
                        "id": 35879,
                        "name": "Olesa de Montserrat",
                        "latitude": "41.54372000",
                        "longitude": "1.89407000"
                    },
                    {
                        "id": 35891,
                        "name": "Olivella",
                        "latitude": "41.31667000",
                        "longitude": "1.81667000"
                    },
                    {
                        "id": 35911,
                        "name": "Olost",
                        "latitude": "41.98540000",
                        "longitude": "2.09457000"
                    },
                    {
                        "id": 151542,
                        "name": "Olvan",
                        "latitude": "41.42966570",
                        "longitude": "2.13334100"
                    },
                    {
                        "id": 35966,
                        "name": "Orís",
                        "latitude": "42.05967000",
                        "longitude": "2.22066000"
                    },
                    {
                        "id": 35953,
                        "name": "Oristà",
                        "latitude": "41.93333000",
                        "longitude": "2.06667000"
                    },
                    {
                        "id": 35960,
                        "name": "Orpí",
                        "latitude": "41.51870000",
                        "longitude": "1.57536000"
                    },
                    {
                        "id": 38582,
                        "name": "Òrrius",
                        "latitude": "41.55000000",
                        "longitude": "2.35000000"
                    },
                    {
                        "id": 151544,
                        "name": "Pacs del Penedès",
                        "latitude": "41.36419660",
                        "longitude": "1.66149470"
                    },
                    {
                        "id": 151545,
                        "name": "Palafolls",
                        "latitude": "41.41077540",
                        "longitude": "2.11333640"
                    },
                    {
                        "id": 151546,
                        "name": "Palau-solità i Plegamans",
                        "latitude": "41.58394610",
                        "longitude": "2.18041460"
                    },
                    {
                        "id": 36026,
                        "name": "Pallejà",
                        "latitude": "41.42394000",
                        "longitude": "1.99505000"
                    },
                    {
                        "id": 151630,
                        "name": "Palma de Cervelló La",
                        "latitude": "41.41208110",
                        "longitude": "1.96124600"
                    },
                    {
                        "id": 151547,
                        "name": "Papiol El",
                        "latitude": "41.43872190",
                        "longitude": "2.01262760"
                    },
                    {
                        "id": 36069,
                        "name": "Parets del Vallès",
                        "latitude": "41.57481000",
                        "longitude": "2.23306000"
                    },
                    {
                        "id": 151548,
                        "name": "Perafita",
                        "latitude": "41.45966970",
                        "longitude": "2.17059400"
                    },
                    {
                        "id": 36186,
                        "name": "Piera",
                        "latitude": "41.52232000",
                        "longitude": "1.75076000"
                    },
                    {
                        "id": 36197,
                        "name": "Pineda de Mar",
                        "latitude": "41.62763000",
                        "longitude": "2.68890000"
                    },
                    {
                        "id": 151550,
                        "name": "Pla del Penedès El",
                        "latitude": "41.41777850",
                        "longitude": "1.70927100"
                    },
                    {
                        "id": 151551,
                        "name": "Pobla de Claramunt La",
                        "latitude": "41.55484140",
                        "longitude": "1.67557470"
                    },
                    {
                        "id": 151552,
                        "name": "Pobla de Lillet La",
                        "latitude": "42.24456470",
                        "longitude": "1.97530880"
                    },
                    {
                        "id": 36260,
                        "name": "Polinyà",
                        "latitude": "41.55000000",
                        "longitude": "2.15000000"
                    },
                    {
                        "id": 151562,
                        "name": "Pont de Vilomara i Rocafort El",
                        "latitude": "41.70094790",
                        "longitude": "1.87082900"
                    },
                    {
                        "id": 151553,
                        "name": "Pontons",
                        "latitude": "41.41628250",
                        "longitude": "1.51602120"
                    },
                    {
                        "id": 151554,
                        "name": "Prat de Llobregat El",
                        "latitude": "41.32198200",
                        "longitude": "2.09477880"
                    },
                    {
                        "id": 151556,
                        "name": "Prats de Lluçanès",
                        "latitude": "42.00707020",
                        "longitude": "2.03099260"
                    },
                    {
                        "id": 151555,
                        "name": "Prats de Rei Els",
                        "latitude": "41.70614220",
                        "longitude": "1.54326010"
                    },
                    {
                        "id": 151591,
                        "name": "Premià de Dalt",
                        "latitude": "41.50489540",
                        "longitude": "2.34581980"
                    },
                    {
                        "id": 36350,
                        "name": "Premià de Mar",
                        "latitude": "41.49206000",
                        "longitude": "2.36524000"
                    },
                    {
                        "id": 151558,
                        "name": "Puig-reig",
                        "latitude": "41.97394220",
                        "longitude": "1.87909760"
                    },
                    {
                        "id": 151557,
                        "name": "Puigdàlber",
                        "latitude": "41.40437290",
                        "longitude": "1.70071020"
                    },
                    {
                        "id": 36465,
                        "name": "Pujalt",
                        "latitude": "41.71710000",
                        "longitude": "1.42088000"
                    },
                    {
                        "id": 151559,
                        "name": "Quar La",
                        "latitude": "42.08079810",
                        "longitude": "1.96163690"
                    },
                    {
                        "id": 36543,
                        "name": "Rajadell",
                        "latitude": "41.72802000",
                        "longitude": "1.70621000"
                    },
                    {
                        "id": 151560,
                        "name": "Rellinars",
                        "latitude": "41.63040280",
                        "longitude": "1.90351460"
                    },
                    {
                        "id": 36633,
                        "name": "Ripollet",
                        "latitude": "41.49686000",
                        "longitude": "2.15739000"
                    },
                    {
                        "id": 151561,
                        "name": "Roca del Vallès La",
                        "latitude": "41.58148050",
                        "longitude": "2.32586000"
                    },
                    {
                        "id": 151563,
                        "name": "Roda de Ter",
                        "latitude": "41.98324440",
                        "longitude": "2.30983860"
                    },
                    {
                        "id": 36694,
                        "name": "Rubí",
                        "latitude": "41.49226000",
                        "longitude": "2.03305000"
                    },
                    {
                        "id": 151564,
                        "name": "Rubió",
                        "latitude": "41.64427980",
                        "longitude": "1.56975890"
                    },
                    {
                        "id": 151627,
                        "name": "Rupit i Pruit",
                        "latitude": "42.02199790",
                        "longitude": "2.47030570"
                    },
                    {
                        "id": 36722,
                        "name": "Sabadell",
                        "latitude": "41.54329000",
                        "longitude": "2.10942000"
                    },
                    {
                        "id": 36740,
                        "name": "Sagàs",
                        "latitude": "42.05000000",
                        "longitude": "1.96667000"
                    },
                    {
                        "id": 151566,
                        "name": "Saldes",
                        "latitude": "41.42860360",
                        "longitude": "2.13564660"
                    },
                    {
                        "id": 36768,
                        "name": "Sallent",
                        "latitude": "41.82602000",
                        "longitude": "1.89550000"
                    },
                    {
                        "id": 36951,
                        "name": "Sant Adrià de Besòs",
                        "latitude": "41.43073000",
                        "longitude": "2.21855000"
                    },
                    {
                        "id": 151569,
                        "name": "Sant Agustí de Lluçanès",
                        "latitude": "42.08557530",
                        "longitude": "2.12737960"
                    },
                    {
                        "id": 36955,
                        "name": "Sant Andreu de la Barca",
                        "latitude": "41.44659000",
                        "longitude": "1.97187000"
                    },
                    {
                        "id": 36954,
                        "name": "Sant Andreu de Llavaneres",
                        "latitude": "41.56667000",
                        "longitude": "2.48333000"
                    },
                    {
                        "id": 151570,
                        "name": "Sant Antoni de Vilamajor",
                        "latitude": "41.67239940",
                        "longitude": "2.39997990"
                    },
                    {
                        "id": 151571,
                        "name": "Sant Bartomeu del Grau",
                        "latitude": "41.98111660",
                        "longitude": "2.17503190"
                    },
                    {
                        "id": 36958,
                        "name": "Sant Boi de Llobregat",
                        "latitude": "41.34357000",
                        "longitude": "2.03659000"
                    },
                    {
                        "id": 151572,
                        "name": "Sant Boi de Lluçanès",
                        "latitude": "42.05871900",
                        "longitude": "2.15054960"
                    },
                    {
                        "id": 151573,
                        "name": "Sant Cebrià de Vallalta",
                        "latitude": "41.61989850",
                        "longitude": "2.59970350"
                    },
                    {
                        "id": 36960,
                        "name": "Sant Celoni",
                        "latitude": "41.68921000",
                        "longitude": "2.48965000"
                    },
                    {
                        "id": 151574,
                        "name": "Sant Climent de Llobregat",
                        "latitude": "41.33758820",
                        "longitude": "1.99671740"
                    },
                    {
                        "id": 36962,
                        "name": "Sant Cugat del Vallès",
                        "latitude": "41.47063000",
                        "longitude": "2.08611000"
                    },
                    {
                        "id": 151575,
                        "name": "Sant Cugat Sesgarrigues",
                        "latitude": "41.36346610",
                        "longitude": "1.75327320"
                    },
                    {
                        "id": 151576,
                        "name": "Sant Esteve de Palautordera",
                        "latitude": "41.70628990",
                        "longitude": "2.43197940"
                    },
                    {
                        "id": 151577,
                        "name": "Sant Esteve Sesrovires",
                        "latitude": "41.49777860",
                        "longitude": "1.86957870"
                    },
                    {
                        "id": 151579,
                        "name": "Sant Feliu de Codines",
                        "latitude": "41.69071810",
                        "longitude": "2.16539540"
                    },
                    {
                        "id": 36965,
                        "name": "Sant Feliu de Llobregat",
                        "latitude": "41.38333000",
                        "longitude": "2.05000000"
                    },
                    {
                        "id": 151580,
                        "name": "Sant Feliu Sasserra",
                        "latitude": "41.94444930",
                        "longitude": "2.02074620"
                    },
                    {
                        "id": 151578,
                        "name": "Sant Fost de Campsentelles",
                        "latitude": "41.51908120",
                        "longitude": "2.23369170"
                    },
                    {
                        "id": 151581,
                        "name": "Sant Fruitós de Bages",
                        "latitude": "41.75092620",
                        "longitude": "1.87462390"
                    },
                    {
                        "id": 151583,
                        "name": "Sant Hipòlit de Voltregà",
                        "latitude": "42.01587460",
                        "longitude": "2.23817260"
                    },
                    {
                        "id": 151568,
                        "name": "Sant Iscle de Vallalta",
                        "latitude": "41.62528740",
                        "longitude": "2.56778480"
                    },
                    {
                        "id": 151584,
                        "name": "Sant Jaume de Frontanyà",
                        "latitude": "42.18716570",
                        "longitude": "2.02384800"
                    },
                    {
                        "id": 36975,
                        "name": "Sant Joan de Vilatorrada",
                        "latitude": "41.74549000",
                        "longitude": "1.80476000"
                    },
                    {
                        "id": 36972,
                        "name": "Sant Joan Despí",
                        "latitude": "41.36718000",
                        "longitude": "2.05740000"
                    },
                    {
                        "id": 36981,
                        "name": "Sant Julià de Cerdanyola",
                        "latitude": "42.22350000",
                        "longitude": "1.89308000"
                    },
                    {
                        "id": 151585,
                        "name": "Sant Julià de Vilatorta",
                        "latitude": "41.92462700",
                        "longitude": "2.32107360"
                    },
                    {
                        "id": 36982,
                        "name": "Sant Just Desvern",
                        "latitude": "41.38389000",
                        "longitude": "2.06758000"
                    },
                    {
                        "id": 151586,
                        "name": "Sant Llorenç dHortons",
                        "latitude": "41.46599600",
                        "longitude": "1.82306240"
                    },
                    {
                        "id": 151587,
                        "name": "Sant Llorenç Savall",
                        "latitude": "41.67876330",
                        "longitude": "2.05835760"
                    },
                    {
                        "id": 151588,
                        "name": "Sant Martí dAlbars",
                        "latitude": "42.02844180",
                        "longitude": "2.07310760"
                    },
                    {
                        "id": 36988,
                        "name": "Sant Martí de Centelles",
                        "latitude": "41.76617000",
                        "longitude": "2.20566000"
                    },
                    {
                        "id": 36990,
                        "name": "Sant Martí de Tous",
                        "latitude": "41.55000000",
                        "longitude": "1.51667000"
                    },
                    {
                        "id": 36986,
                        "name": "Sant Martí Sarroca",
                        "latitude": "41.38576000",
                        "longitude": "1.61121000"
                    },
                    {
                        "id": 151589,
                        "name": "Sant Martí Sesgueioles",
                        "latitude": "41.70184680",
                        "longitude": "1.49121870"
                    },
                    {
                        "id": 151590,
                        "name": "Sant Mateu de Bages",
                        "latitude": "41.79671530",
                        "longitude": "1.73274070"
                    },
                    {
                        "id": 36993,
                        "name": "Sant Pere de Ribes",
                        "latitude": "41.26045000",
                        "longitude": "1.77391000"
                    },
                    {
                        "id": 36994,
                        "name": "Sant Pere de Riudebitlles",
                        "latitude": "41.45000000",
                        "longitude": "1.70000000"
                    },
                    {
                        "id": 151592,
                        "name": "Sant Pere de Torelló",
                        "latitude": "42.07635370",
                        "longitude": "2.29382290"
                    },
                    {
                        "id": 151593,
                        "name": "Sant Pere de Vilamajor",
                        "latitude": "41.68318650",
                        "longitude": "2.39280020"
                    },
                    {
                        "id": 151565,
                        "name": "Sant Pere Sallavinera",
                        "latitude": "41.73599570",
                        "longitude": "1.57494390"
                    },
                    {
                        "id": 36996,
                        "name": "Sant Pol de Mar",
                        "latitude": "41.60177000",
                        "longitude": "2.61741000"
                    },
                    {
                        "id": 151594,
                        "name": "Sant Quintí de Mediona",
                        "latitude": "41.46286900",
                        "longitude": "1.66356060"
                    },
                    {
                        "id": 151595,
                        "name": "Sant Quirze de Besora",
                        "latitude": "42.09999950",
                        "longitude": "2.22243690"
                    },
                    {
                        "id": 36997,
                        "name": "Sant Quirze del Vallès",
                        "latitude": "41.53333000",
                        "longitude": "2.08333000"
                    },
                    {
                        "id": 151596,
                        "name": "Sant Quirze Safaja",
                        "latitude": "41.45614850",
                        "longitude": "2.17600210"
                    },
                    {
                        "id": 151597,
                        "name": "Sant Sadurní dAnoia",
                        "latitude": "41.43749180",
                        "longitude": "1.78309730"
                    },
                    {
                        "id": 151598,
                        "name": "Sant Sadurní dOsormort",
                        "latitude": "41.90108920",
                        "longitude": "2.38120780"
                    },
                    {
                        "id": 36999,
                        "name": "Sant Salvador de Guardiola",
                        "latitude": "41.68333000",
                        "longitude": "1.76667000"
                    },
                    {
                        "id": 37000,
                        "name": "Sant Vicenç de Castellet",
                        "latitude": "41.66667000",
                        "longitude": "1.86667000"
                    },
                    {
                        "id": 37001,
                        "name": "Sant Vicenç de Montalt",
                        "latitude": "41.57853000",
                        "longitude": "2.50879000"
                    },
                    {
                        "id": 151609,
                        "name": "Sant Vicenç de Torelló",
                        "latitude": "42.06380030",
                        "longitude": "2.27227220"
                    },
                    {
                        "id": 37002,
                        "name": "Sant Vicenç dels Horts",
                        "latitude": "41.39317000",
                        "longitude": "2.00689000"
                    },
                    {
                        "id": 37012,
                        "name": "Santa Cecília de Voltregà",
                        "latitude": "42.00000000",
                        "longitude": "2.23333000"
                    },
                    {
                        "id": 37015,
                        "name": "Santa Coloma de Cervelló",
                        "latitude": "41.36736000",
                        "longitude": "2.01426000"
                    },
                    {
                        "id": 37017,
                        "name": "Santa Coloma de Gramenet",
                        "latitude": "41.45152000",
                        "longitude": "2.20810000"
                    },
                    {
                        "id": 37053,
                        "name": "Santa Eugènia de Berga",
                        "latitude": "41.90000000",
                        "longitude": "2.28333000"
                    },
                    {
                        "id": 151600,
                        "name": "Santa Eulàlia de Riuprimer",
                        "latitude": "41.91064400",
                        "longitude": "2.18862940"
                    },
                    {
                        "id": 37057,
                        "name": "Santa Eulàlia de Ronçana",
                        "latitude": "41.65000000",
                        "longitude": "2.23333000"
                    },
                    {
                        "id": 151601,
                        "name": "Santa Fe del Penedès",
                        "latitude": "41.38493340",
                        "longitude": "1.72073350"
                    },
                    {
                        "id": 151602,
                        "name": "Santa Margarida de Montbui",
                        "latitude": "41.55686900",
                        "longitude": "1.60303480"
                    },
                    {
                        "id": 151603,
                        "name": "Santa Margarida i els Monjos",
                        "latitude": "41.31406740",
                        "longitude": "1.66149470"
                    },
                    {
                        "id": 151604,
                        "name": "Santa Maria de Besora",
                        "latitude": "42.12740190",
                        "longitude": "2.25842350"
                    },
                    {
                        "id": 37066,
                        "name": "Santa Maria de Corcó",
                        "latitude": "42.03333000",
                        "longitude": "2.36667000"
                    },
                    {
                        "id": 151606,
                        "name": "Santa Maria de Martorelles",
                        "latitude": "41.51892410",
                        "longitude": "2.25473130"
                    },
                    {
                        "id": 151605,
                        "name": "Santa Maria de Merlès",
                        "latitude": "42.00383710",
                        "longitude": "1.97668480"
                    },
                    {
                        "id": 151607,
                        "name": "Santa Maria de Miralles",
                        "latitude": "41.49470860",
                        "longitude": "1.52673420"
                    },
                    {
                        "id": 37067,
                        "name": "Santa Maria de Palautordera",
                        "latitude": "41.69417000",
                        "longitude": "2.44566000"
                    },
                    {
                        "id": 151608,
                        "name": "Santa Maria dOló",
                        "latitude": "41.87500120",
                        "longitude": "2.03527890"
                    },
                    {
                        "id": 37097,
                        "name": "Santa Perpètua de Mogoda",
                        "latitude": "41.53333000",
                        "longitude": "2.18333000"
                    },
                    {
                        "id": 37100,
                        "name": "Santa Susanna",
                        "latitude": "41.63333000",
                        "longitude": "2.71667000"
                    },
                    {
                        "id": 151567,
                        "name": "Santpedor",
                        "latitude": "41.41072110",
                        "longitude": "2.11131830"
                    },
                    {
                        "id": 37212,
                        "name": "Sentmenat",
                        "latitude": "41.60862000",
                        "longitude": "2.13532000"
                    },
                    {
                        "id": 37238,
                        "name": "Seva",
                        "latitude": "41.83831000",
                        "longitude": "2.28007000"
                    },
                    {
                        "id": 37267,
                        "name": "Sitges",
                        "latitude": "41.23506000",
                        "longitude": "1.81193000"
                    },
                    {
                        "id": 151611,
                        "name": "Sobremunt",
                        "latitude": "42.03570970",
                        "longitude": "2.16547330"
                    },
                    {
                        "id": 151612,
                        "name": "Sora",
                        "latitude": "42.11198570",
                        "longitude": "2.16068060"
                    },
                    {
                        "id": 37328,
                        "name": "Subirats",
                        "latitude": "41.40000000",
                        "longitude": "1.83333000"
                    },
                    {
                        "id": 37338,
                        "name": "Súria",
                        "latitude": "41.83333000",
                        "longitude": "1.75000000"
                    },
                    {
                        "id": 37349,
                        "name": "Tagamanent",
                        "latitude": "41.73747000",
                        "longitude": "2.26720000"
                    },
                    {
                        "id": 37353,
                        "name": "Talamanca",
                        "latitude": "41.73740000",
                        "longitude": "1.97791000"
                    },
                    {
                        "id": 37370,
                        "name": "Taradell",
                        "latitude": "41.87495000",
                        "longitude": "2.28662000"
                    },
                    {
                        "id": 151613,
                        "name": "Tavèrnoles",
                        "latitude": "41.95289200",
                        "longitude": "2.32555180"
                    },
                    {
                        "id": 37388,
                        "name": "Tavertet",
                        "latitude": "41.99572000",
                        "longitude": "2.41859000"
                    },
                    {
                        "id": 37393,
                        "name": "Teià",
                        "latitude": "41.49804000",
                        "longitude": "2.32206000"
                    },
                    {
                        "id": 37409,
                        "name": "Terrassa",
                        "latitude": "41.56667000",
                        "longitude": "2.01667000"
                    },
                    {
                        "id": 37419,
                        "name": "Tiana",
                        "latitude": "41.48201000",
                        "longitude": "2.26702000"
                    },
                    {
                        "id": 37452,
                        "name": "Tona",
                        "latitude": "41.84789000",
                        "longitude": "2.22808000"
                    },
                    {
                        "id": 37458,
                        "name": "Tordera",
                        "latitude": "41.69914000",
                        "longitude": "2.71888000"
                    },
                    {
                        "id": 37463,
                        "name": "Torelló",
                        "latitude": "42.04627000",
                        "longitude": "2.26679000"
                    },
                    {
                        "id": 151614,
                        "name": "Torre de Claramunt La",
                        "latitude": "41.52430690",
                        "longitude": "1.66149470"
                    },
                    {
                        "id": 151615,
                        "name": "Torrelavit",
                        "latitude": "41.44646120",
                        "longitude": "1.73004620"
                    },
                    {
                        "id": 151616,
                        "name": "Torrelles de Foix",
                        "latitude": "41.38831460",
                        "longitude": "1.56872290"
                    },
                    {
                        "id": 37549,
                        "name": "Torrelles de Llobregat",
                        "latitude": "41.35000000",
                        "longitude": "1.98333000"
                    },
                    {
                        "id": 37680,
                        "name": "Ullastrell",
                        "latitude": "41.52643000",
                        "longitude": "1.95537000"
                    },
                    {
                        "id": 151617,
                        "name": "Vacarisses",
                        "latitude": "41.45718850",
                        "longitude": "2.18063670"
                    },
                    {
                        "id": 151618,
                        "name": "Vallbona dAnoia",
                        "latitude": "41.51831090",
                        "longitude": "1.70755630"
                    },
                    {
                        "id": 151619,
                        "name": "Vallcebre",
                        "latitude": "42.20355070",
                        "longitude": "1.81806080"
                    },
                    {
                        "id": 37859,
                        "name": "Vallgorguina",
                        "latitude": "41.64822000",
                        "longitude": "2.50996000"
                    },
                    {
                        "id": 37861,
                        "name": "Vallirana",
                        "latitude": "41.38676000",
                        "longitude": "1.93205000"
                    },
                    {
                        "id": 151620,
                        "name": "Vallromanes",
                        "latitude": "41.53574730",
                        "longitude": "2.29413120"
                    },
                    {
                        "id": 151621,
                        "name": "Veciana",
                        "latitude": "41.42012510",
                        "longitude": "2.14282860"
                    },
                    {
                        "id": 37962,
                        "name": "Vic",
                        "latitude": "41.93012000",
                        "longitude": "2.25486000"
                    },
                    {
                        "id": 151622,
                        "name": "Vilada",
                        "latitude": "42.13670980",
                        "longitude": "1.93374460"
                    },
                    {
                        "id": 37978,
                        "name": "Viladecans",
                        "latitude": "41.31405000",
                        "longitude": "2.01427000"
                    },
                    {
                        "id": 151623,
                        "name": "Viladecavalls",
                        "latitude": "41.45433480",
                        "longitude": "2.18075970"
                    },
                    {
                        "id": 37984,
                        "name": "Vilafranca del Penedès",
                        "latitude": "41.34618000",
                        "longitude": "1.69713000"
                    },
                    {
                        "id": 151625,
                        "name": "Vilalba Sasserra",
                        "latitude": "41.65204790",
                        "longitude": "2.44002080"
                    },
                    {
                        "id": 37997,
                        "name": "Vilanova de Sau",
                        "latitude": "41.94700000",
                        "longitude": "2.38440000"
                    },
                    {
                        "id": 37998,
                        "name": "Vilanova del Camí",
                        "latitude": "41.57165000",
                        "longitude": "1.63751000"
                    },
                    {
                        "id": 151628,
                        "name": "Vilanova del Vallès",
                        "latitude": "41.55315320",
                        "longitude": "2.30737430"
                    },
                    {
                        "id": 37999,
                        "name": "Vilanova i la Geltrú",
                        "latitude": "41.22392000",
                        "longitude": "1.72511000"
                    },
                    {
                        "id": 151582,
                        "name": "Vilassar de Dalt",
                        "latitude": "41.51322480",
                        "longitude": "2.36225820"
                    },
                    {
                        "id": 38004,
                        "name": "Vilassar de Mar",
                        "latitude": "41.50507000",
                        "longitude": "2.39227000"
                    },
                    {
                        "id": 151624,
                        "name": "Vilobí del Penedès",
                        "latitude": "41.38881310",
                        "longitude": "1.66211640"
                    },
                    {
                        "id": 151626,
                        "name": "Viver i Serrateix",
                        "latitude": "41.95513820",
                        "longitude": "1.80258520"
                    }
                ]
            },
            {
                "id": 5332,
                "name": "Basque Country",
                "iso2": "PV",
                "latitude": "42.96390850",
                "longitude": "-3.25058230",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5094,
                "name": "Bizkaia",
                "iso2": "BI",
                "latitude": "43.21921990",
                "longitude": "-3.21110870",
                "type": "province",
                "cities": [
                    {
                        "id": 151259,
                        "name": "Abadiño",
                        "latitude": "43.15102980",
                        "longitude": "-2.61126240"
                    },
                    {
                        "id": 151260,
                        "name": "Abanto y Ciérvana-Abanto Zierbena",
                        "latitude": "43.31687940",
                        "longitude": "-3.08767830"
                    },
                    {
                        "id": 151318,
                        "name": "Ajangiz",
                        "latitude": "43.30337950",
                        "longitude": "-2.66360660"
                    },
                    {
                        "id": 32319,
                        "name": "Alonsotegi",
                        "latitude": "43.24483000",
                        "longitude": "-2.98759000"
                    },
                    {
                        "id": 151261,
                        "name": "Amorebieta-Etxano",
                        "latitude": "43.22046920",
                        "longitude": "-2.73306800"
                    },
                    {
                        "id": 32357,
                        "name": "Amoroto",
                        "latitude": "43.32634000",
                        "longitude": "-2.51349000"
                    },
                    {
                        "id": 151262,
                        "name": "Arakaldo",
                        "latitude": "43.15281730",
                        "longitude": "-2.93545430"
                    },
                    {
                        "id": 151263,
                        "name": "Arantzazu",
                        "latitude": "42.97934580",
                        "longitude": "-2.39779280"
                    },
                    {
                        "id": 151311,
                        "name": "Areatza",
                        "latitude": "43.12125500",
                        "longitude": "-2.76974120"
                    },
                    {
                        "id": 151266,
                        "name": "Arrankudiaga",
                        "latitude": "43.17306220",
                        "longitude": "-2.91998200"
                    },
                    {
                        "id": 151319,
                        "name": "Arratzu",
                        "latitude": "43.30628580",
                        "longitude": "-2.64026570"
                    },
                    {
                        "id": 151267,
                        "name": "Arrieta",
                        "latitude": "43.34167510",
                        "longitude": "-2.76896570"
                    },
                    {
                        "id": 32507,
                        "name": "Arrigorriaga",
                        "latitude": "43.21006000",
                        "longitude": "-2.88562000"
                    },
                    {
                        "id": 151271,
                        "name": "Artea",
                        "latitude": "43.13247320",
                        "longitude": "-2.78420530"
                    },
                    {
                        "id": 151265,
                        "name": "Artzentales",
                        "latitude": "43.23574660",
                        "longitude": "-3.22819830"
                    },
                    {
                        "id": 151309,
                        "name": "Atxondo",
                        "latitude": "43.13160500",
                        "longitude": "-2.58327030"
                    },
                    {
                        "id": 32557,
                        "name": "Aulesti",
                        "latitude": "43.30000000",
                        "longitude": "-2.56667000"
                    },
                    {
                        "id": 32618,
                        "name": "Bakio",
                        "latitude": "43.42917000",
                        "longitude": "-2.80881000"
                    },
                    {
                        "id": 151308,
                        "name": "Balmaseda",
                        "latitude": "43.19245610",
                        "longitude": "-3.19868050"
                    },
                    {
                        "id": 32638,
                        "name": "Barakaldo",
                        "latitude": "43.29639000",
                        "longitude": "-2.98813000"
                    },
                    {
                        "id": 151268,
                        "name": "Barrika",
                        "latitude": "43.40676110",
                        "longitude": "-2.96482370"
                    },
                    {
                        "id": 32688,
                        "name": "Basauri",
                        "latitude": "43.23970000",
                        "longitude": "-2.88580000"
                    },
                    {
                        "id": 151310,
                        "name": "Bedia",
                        "latitude": "43.20292570",
                        "longitude": "-2.82281240"
                    },
                    {
                        "id": 32831,
                        "name": "Berango",
                        "latitude": "43.36500000",
                        "longitude": "-2.99601000"
                    },
                    {
                        "id": 32859,
                        "name": "Bermeo",
                        "latitude": "43.42088000",
                        "longitude": "-2.72152000"
                    },
                    {
                        "id": 32863,
                        "name": "Berriatua",
                        "latitude": "43.31667000",
                        "longitude": "-2.46667000"
                    },
                    {
                        "id": 32866,
                        "name": "Berriz",
                        "latitude": "43.16667000",
                        "longitude": "-2.56667000"
                    },
                    {
                        "id": 32895,
                        "name": "Bilbao",
                        "latitude": "43.26271000",
                        "longitude": "-2.92528000"
                    },
                    {
                        "id": 151269,
                        "name": "Busturia",
                        "latitude": "43.38281350",
                        "longitude": "-2.69859880"
                    },
                    {
                        "id": 33927,
                        "name": "Derio",
                        "latitude": "43.30544000",
                        "longitude": "-2.88116000"
                    },
                    {
                        "id": 151273,
                        "name": "Dima",
                        "latitude": "43.13879500",
                        "longitude": "-2.72772130"
                    },
                    {
                        "id": 33961,
                        "name": "Durango",
                        "latitude": "43.17124000",
                        "longitude": "-2.63380000"
                    },
                    {
                        "id": 33968,
                        "name": "Ea",
                        "latitude": "43.37985000",
                        "longitude": "-2.58556000"
                    },
                    {
                        "id": 151276,
                        "name": "Elantxobe",
                        "latitude": "43.40310300",
                        "longitude": "-2.63971020"
                    },
                    {
                        "id": 34038,
                        "name": "Elorrio",
                        "latitude": "43.12924000",
                        "longitude": "-2.54056000"
                    },
                    {
                        "id": 34066,
                        "name": "Erandio",
                        "latitude": "43.30438000",
                        "longitude": "-2.97352000"
                    },
                    {
                        "id": 151277,
                        "name": "Ereño",
                        "latitude": "43.35587140",
                        "longitude": "-2.62281010"
                    },
                    {
                        "id": 34069,
                        "name": "Ermua",
                        "latitude": "43.18725000",
                        "longitude": "-2.50261000"
                    },
                    {
                        "id": 34071,
                        "name": "Errigoiti",
                        "latitude": "43.31667000",
                        "longitude": "-2.71667000"
                    },
                    {
                        "id": 151274,
                        "name": "Etxebarri",
                        "latitude": "43.25277370",
                        "longitude": "-2.88345320"
                    },
                    {
                        "id": 151275,
                        "name": "Etxebarria",
                        "latitude": "43.25376060",
                        "longitude": "-2.47615910"
                    },
                    {
                        "id": 34232,
                        "name": "Forua",
                        "latitude": "43.33343000",
                        "longitude": "-2.67504000"
                    },
                    {
                        "id": 151278,
                        "name": "Fruiz",
                        "latitude": "43.32790870",
                        "longitude": "-2.78408610"
                    },
                    {
                        "id": 34378,
                        "name": "Galdakao",
                        "latitude": "43.23073000",
                        "longitude": "-2.84290000"
                    },
                    {
                        "id": 151279,
                        "name": "Galdames",
                        "latitude": "43.25840120",
                        "longitude": "-3.10772770"
                    },
                    {
                        "id": 151280,
                        "name": "Gamiz-Fika",
                        "latitude": "43.32700730",
                        "longitude": "-2.81837500"
                    },
                    {
                        "id": 151281,
                        "name": "Garai",
                        "latitude": "43.19342820",
                        "longitude": "-2.61038700"
                    },
                    {
                        "id": 34436,
                        "name": "Gatika",
                        "latitude": "43.36313000",
                        "longitude": "-2.87294000"
                    },
                    {
                        "id": 151282,
                        "name": "Gautegiz Arteaga",
                        "latitude": "43.35180020",
                        "longitude": "-2.65394860"
                    },
                    {
                        "id": 34457,
                        "name": "Gernika-Lumo",
                        "latitude": "43.31667000",
                        "longitude": "-2.68333000"
                    },
                    {
                        "id": 34461,
                        "name": "Getxo",
                        "latitude": "43.35689000",
                        "longitude": "-3.01146000"
                    },
                    {
                        "id": 151285,
                        "name": "Gizaburuaga",
                        "latitude": "43.33268230",
                        "longitude": "-2.54207990"
                    },
                    {
                        "id": 151283,
                        "name": "Gordexola",
                        "latitude": "43.17937900",
                        "longitude": "-3.07488990"
                    },
                    {
                        "id": 151284,
                        "name": "Gorliz",
                        "latitude": "43.41317400",
                        "longitude": "-2.93430500"
                    },
                    {
                        "id": 34568,
                        "name": "Güeñes",
                        "latitude": "43.21252000",
                        "longitude": "-3.09497000"
                    },
                    {
                        "id": 34724,
                        "name": "Ibarrangelu",
                        "latitude": "43.39027000",
                        "longitude": "-2.63423000"
                    },
                    {
                        "id": 151312,
                        "name": "Igorre",
                        "latitude": "43.16434970",
                        "longitude": "-2.77924440"
                    },
                    {
                        "id": 151286,
                        "name": "Ispaster",
                        "latitude": "43.36185940",
                        "longitude": "-2.54398190"
                    },
                    {
                        "id": 151317,
                        "name": "Iurreta",
                        "latitude": "43.17697830",
                        "longitude": "-2.63381300"
                    },
                    {
                        "id": 34783,
                        "name": "Izurtza",
                        "latitude": "43.15000000",
                        "longitude": "-2.63333000"
                    },
                    {
                        "id": 151270,
                        "name": "Karrantza Harana\/Valle de Carranza",
                        "latitude": "43.22232260",
                        "longitude": "-3.35904460"
                    },
                    {
                        "id": 151314,
                        "name": "Kortezubi",
                        "latitude": "43.34001450",
                        "longitude": "-2.65487430"
                    },
                    {
                        "id": 34961,
                        "name": "Lanestosa",
                        "latitude": "43.21986000",
                        "longitude": "-3.43920000"
                    },
                    {
                        "id": 151287,
                        "name": "Larrabetzu",
                        "latitude": "43.26098780",
                        "longitude": "-2.79603320"
                    },
                    {
                        "id": 151288,
                        "name": "Laukiz",
                        "latitude": "43.35144500",
                        "longitude": "-2.92285980"
                    },
                    {
                        "id": 35026,
                        "name": "Leioa",
                        "latitude": "43.32686000",
                        "longitude": "-2.98884000"
                    },
                    {
                        "id": 35028,
                        "name": "Lekeitio",
                        "latitude": "43.36417000",
                        "longitude": "-2.50492000"
                    },
                    {
                        "id": 151289,
                        "name": "Lemoa",
                        "latitude": "43.20863700",
                        "longitude": "-2.77511370"
                    },
                    {
                        "id": 151290,
                        "name": "Lemoiz",
                        "latitude": "43.41292910",
                        "longitude": "-2.90262560"
                    },
                    {
                        "id": 35041,
                        "name": "Lezama",
                        "latitude": "43.02799000",
                        "longitude": "-2.97257000"
                    },
                    {
                        "id": 151313,
                        "name": "Loiu",
                        "latitude": "43.30698140",
                        "longitude": "-2.91260220"
                    },
                    {
                        "id": 151291,
                        "name": "Mallabia",
                        "latitude": "43.18979260",
                        "longitude": "-2.53031610"
                    },
                    {
                        "id": 35361,
                        "name": "Mañaria",
                        "latitude": "43.13819000",
                        "longitude": "-2.66104000"
                    },
                    {
                        "id": 35294,
                        "name": "Markina-Xemein",
                        "latitude": "43.26667000",
                        "longitude": "-2.50000000"
                    },
                    {
                        "id": 151292,
                        "name": "Maruri-Jatabe",
                        "latitude": "43.40202230",
                        "longitude": "-2.87216510"
                    },
                    {
                        "id": 151294,
                        "name": "Meñaka",
                        "latitude": "43.36142430",
                        "longitude": "-2.79861060"
                    },
                    {
                        "id": 151293,
                        "name": "Mendata",
                        "latitude": "43.28678370",
                        "longitude": "-2.63522670"
                    },
                    {
                        "id": 35400,
                        "name": "Mendexa",
                        "latitude": "43.34590000",
                        "longitude": "-2.48420000"
                    },
                    {
                        "id": 151296,
                        "name": "Morga",
                        "latitude": "43.29965650",
                        "longitude": "-2.75247330"
                    },
                    {
                        "id": 35662,
                        "name": "Mundaka",
                        "latitude": "43.40804000",
                        "longitude": "-2.69852000"
                    },
                    {
                        "id": 35664,
                        "name": "Mungia",
                        "latitude": "43.35461000",
                        "longitude": "-2.84524000"
                    },
                    {
                        "id": 151264,
                        "name": "Munitibar-Arbatzegi Gerrikaitz",
                        "latitude": "43.26573340",
                        "longitude": "-2.59229500"
                    },
                    {
                        "id": 151315,
                        "name": "Murueta",
                        "latitude": "43.35347390",
                        "longitude": "-2.68177260"
                    },
                    {
                        "id": 151298,
                        "name": "Muskiz",
                        "latitude": "43.32260280",
                        "longitude": "-3.11389280"
                    },
                    {
                        "id": 151297,
                        "name": "Muxika",
                        "latitude": "43.28947230",
                        "longitude": "-2.68913160"
                    },
                    {
                        "id": 151316,
                        "name": "Nabarniz",
                        "latitude": "43.32132080",
                        "longitude": "-2.58443480"
                    },
                    {
                        "id": 35924,
                        "name": "Ondarroa",
                        "latitude": "43.31667000",
                        "longitude": "-2.41667000"
                    },
                    {
                        "id": 151301,
                        "name": "Orozko",
                        "latitude": "43.10756430",
                        "longitude": "-2.91129640"
                    },
                    {
                        "id": 35964,
                        "name": "Ortuella",
                        "latitude": "43.31113000",
                        "longitude": "-3.05617000"
                    },
                    {
                        "id": 151299,
                        "name": "Otxandio",
                        "latitude": "43.04307730",
                        "longitude": "-2.65533490"
                    },
                    {
                        "id": 36244,
                        "name": "Plentzia",
                        "latitude": "43.40530000",
                        "longitude": "-2.94794000"
                    },
                    {
                        "id": 36300,
                        "name": "Portugalete",
                        "latitude": "43.32099000",
                        "longitude": "-3.02064000"
                    },
                    {
                        "id": 37155,
                        "name": "Santurtzi",
                        "latitude": "43.32842000",
                        "longitude": "-3.03248000"
                    },
                    {
                        "id": 37233,
                        "name": "Sestao",
                        "latitude": "43.30975000",
                        "longitude": "-3.00716000"
                    },
                    {
                        "id": 37292,
                        "name": "Sondika",
                        "latitude": "43.30020000",
                        "longitude": "-2.92442000"
                    },
                    {
                        "id": 151304,
                        "name": "Sopelana",
                        "latitude": "43.38049590",
                        "longitude": "-2.98387770"
                    },
                    {
                        "id": 37297,
                        "name": "Sopuerta",
                        "latitude": "43.26239000",
                        "longitude": "-3.15505000"
                    },
                    {
                        "id": 151302,
                        "name": "Sukarrieta",
                        "latitude": "43.39485480",
                        "longitude": "-2.69652290"
                    },
                    {
                        "id": 151305,
                        "name": "Trucios-Turtzioz",
                        "latitude": "43.27168980",
                        "longitude": "-3.25653730"
                    },
                    {
                        "id": 151306,
                        "name": "Ubide",
                        "latitude": "43.02409160",
                        "longitude": "-2.68796710"
                    },
                    {
                        "id": 151295,
                        "name": "Ugao-Miraballes",
                        "latitude": "43.18282410",
                        "longitude": "-2.90136920"
                    },
                    {
                        "id": 151307,
                        "name": "Urduliz",
                        "latitude": "43.36410330",
                        "longitude": "-2.94256980"
                    },
                    {
                        "id": 151300,
                        "name": "Urduña\/Orduña",
                        "latitude": "43.00818170",
                        "longitude": "-3.04760460"
                    },
                    {
                        "id": 151303,
                        "name": "Valle de Trápaga-Trapagaran",
                        "latitude": "43.30499370",
                        "longitude": "-3.03723330"
                    },
                    {
                        "id": 38460,
                        "name": "Zaldibar",
                        "latitude": "43.16667000",
                        "longitude": "-2.53333000"
                    },
                    {
                        "id": 38461,
                        "name": "Zalla",
                        "latitude": "43.23333000",
                        "longitude": "-3.13333000"
                    },
                    {
                        "id": 38466,
                        "name": "Zamudio",
                        "latitude": "43.28600000",
                        "longitude": "-2.87000000"
                    },
                    {
                        "id": 38472,
                        "name": "Zaratamo",
                        "latitude": "43.21667000",
                        "longitude": "-2.86667000"
                    },
                    {
                        "id": 38490,
                        "name": "Zeanuri",
                        "latitude": "43.10000000",
                        "longitude": "-2.75000000"
                    },
                    {
                        "id": 151272,
                        "name": "Zeberio",
                        "latitude": "43.14907510",
                        "longitude": "-2.84773700"
                    },
                    {
                        "id": 38493,
                        "name": "Zierbena",
                        "latitude": "43.35000000",
                        "longitude": "-3.08333000"
                    },
                    {
                        "id": 151320,
                        "name": "Ziortza-Bolibar",
                        "latitude": "43.24971370",
                        "longitude": "-2.54971010"
                    }
                ]
            },
            {
                "id": 1146,
                "name": "Burgos",
                "iso2": "BU",
                "latitude": "42.33807580",
                "longitude": "-3.58126920",
                "type": "province",
                "cities": [
                    {
                        "id": 31902,
                        "name": "Abajas",
                        "latitude": "42.62310000",
                        "longitude": "-3.58086000"
                    },
                    {
                        "id": 31937,
                        "name": "Adrada de Haza",
                        "latitude": "41.59454000",
                        "longitude": "-3.82327000"
                    },
                    {
                        "id": 152289,
                        "name": "Aguas Cándidas",
                        "latitude": "42.71617380",
                        "longitude": "-3.50318810"
                    },
                    {
                        "id": 31959,
                        "name": "Aguilar de Bureba",
                        "latitude": "42.58974000",
                        "longitude": "-3.32913000"
                    },
                    {
                        "id": 32045,
                        "name": "Albillos",
                        "latitude": "42.27680000",
                        "longitude": "-3.78908000"
                    },
                    {
                        "id": 32100,
                        "name": "Alcocero de Mola",
                        "latitude": "42.47222000",
                        "longitude": "-3.35790000"
                    },
                    {
                        "id": 152290,
                        "name": "Alfoz de Bricia",
                        "latitude": "42.88805570",
                        "longitude": "-3.81465260"
                    },
                    {
                        "id": 152367,
                        "name": "Alfoz de Quintanadueñas",
                        "latitude": "42.38480300",
                        "longitude": "-3.73506450"
                    },
                    {
                        "id": 152291,
                        "name": "Alfoz de Santa Gadea",
                        "latitude": "42.95619480",
                        "longitude": "-3.95159310"
                    },
                    {
                        "id": 32337,
                        "name": "Altable",
                        "latitude": "42.60276000",
                        "longitude": "-3.07719000"
                    },
                    {
                        "id": 152292,
                        "name": "Altos Los",
                        "latitude": "42.80784100",
                        "longitude": "-3.63333870"
                    },
                    {
                        "id": 32353,
                        "name": "Ameyugo",
                        "latitude": "42.65617000",
                        "longitude": "-3.06170000"
                    },
                    {
                        "id": 32383,
                        "name": "Anguix",
                        "latitude": "41.75331000",
                        "longitude": "-3.93125000"
                    },
                    {
                        "id": 32407,
                        "name": "Aranda de Duero",
                        "latitude": "41.67041000",
                        "longitude": "-3.68920000"
                    },
                    {
                        "id": 32409,
                        "name": "Arandilla",
                        "latitude": "41.73778000",
                        "longitude": "-3.42914000"
                    },
                    {
                        "id": 32417,
                        "name": "Arauzo de Miel",
                        "latitude": "41.85878000",
                        "longitude": "-3.38773000"
                    },
                    {
                        "id": 32418,
                        "name": "Arauzo de Salce",
                        "latitude": "41.81919000",
                        "longitude": "-3.41191000"
                    },
                    {
                        "id": 32419,
                        "name": "Arauzo de Torre",
                        "latitude": "41.79818000",
                        "longitude": "-3.42314000"
                    },
                    {
                        "id": 32435,
                        "name": "Arcos",
                        "latitude": "42.26664000",
                        "longitude": "-3.75458000"
                    },
                    {
                        "id": 152293,
                        "name": "Arenillas de Riopisuerga",
                        "latitude": "42.34577040",
                        "longitude": "-4.22308360"
                    },
                    {
                        "id": 32479,
                        "name": "Arija",
                        "latitude": "42.99350000",
                        "longitude": "-3.94497000"
                    },
                    {
                        "id": 32484,
                        "name": "Arlanzón",
                        "latitude": "42.32267000",
                        "longitude": "-3.45784000"
                    },
                    {
                        "id": 32503,
                        "name": "Arraya de Oca",
                        "latitude": "42.41488000",
                        "longitude": "-3.39781000"
                    },
                    {
                        "id": 32548,
                        "name": "Atapuerca",
                        "latitude": "42.37757000",
                        "longitude": "-3.50790000"
                    },
                    {
                        "id": 152294,
                        "name": "Ausines Los",
                        "latitude": "42.22741930",
                        "longitude": "-3.59835580"
                    },
                    {
                        "id": 32567,
                        "name": "Avellanosa de Muñó",
                        "latitude": "41.98349000",
                        "longitude": "-3.82553000"
                    },
                    {
                        "id": 32612,
                        "name": "Bahabón de Esgueva",
                        "latitude": "41.86162000",
                        "longitude": "-3.72980000"
                    },
                    {
                        "id": 152295,
                        "name": "Balbases Los",
                        "latitude": "42.21432660",
                        "longitude": "-4.06507390"
                    },
                    {
                        "id": 32708,
                        "name": "Baños de Valdearados",
                        "latitude": "41.77010000",
                        "longitude": "-3.55589000"
                    },
                    {
                        "id": 32711,
                        "name": "Bañuelos de Bureba",
                        "latitude": "42.50258000",
                        "longitude": "-3.27957000"
                    },
                    {
                        "id": 32641,
                        "name": "Barbadillo de Herreros",
                        "latitude": "42.14974000",
                        "longitude": "-3.17702000"
                    },
                    {
                        "id": 32642,
                        "name": "Barbadillo del Mercado",
                        "latitude": "42.03858000",
                        "longitude": "-3.35669000"
                    },
                    {
                        "id": 32643,
                        "name": "Barbadillo del Pez",
                        "latitude": "42.11879000",
                        "longitude": "-3.22803000"
                    },
                    {
                        "id": 32676,
                        "name": "Barrio de Muñó",
                        "latitude": "42.17584000",
                        "longitude": "-4.00715000"
                    },
                    {
                        "id": 152296,
                        "name": "Barrios de Bureba Los",
                        "latitude": "42.64595840",
                        "longitude": "-3.39118030"
                    },
                    {
                        "id": 32679,
                        "name": "Barrios de Colina",
                        "latitude": "42.39595000",
                        "longitude": "-3.46001000"
                    },
                    {
                        "id": 32689,
                        "name": "Basconcillos del Tozo",
                        "latitude": "42.70236000",
                        "longitude": "-3.98937000"
                    },
                    {
                        "id": 32690,
                        "name": "Bascuñana",
                        "latitude": "42.42548000",
                        "longitude": "-3.08231000"
                    },
                    {
                        "id": 32736,
                        "name": "Belbimbre",
                        "latitude": "42.16873000",
                        "longitude": "-4.01280000"
                    },
                    {
                        "id": 32752,
                        "name": "Belorado",
                        "latitude": "42.42048000",
                        "longitude": "-3.19133000"
                    },
                    {
                        "id": 32835,
                        "name": "Berberana",
                        "latitude": "42.91784000",
                        "longitude": "-3.06063000"
                    },
                    {
                        "id": 32857,
                        "name": "Berlangas de Roa",
                        "latitude": "41.68913000",
                        "longitude": "-3.87284000"
                    },
                    {
                        "id": 32874,
                        "name": "Berzosa de Bureba",
                        "latitude": "42.62678000",
                        "longitude": "-3.26652000"
                    },
                    {
                        "id": 152297,
                        "name": "Bozoó",
                        "latitude": "42.72690330",
                        "longitude": "-3.08673870"
                    },
                    {
                        "id": 32970,
                        "name": "Brazacorta",
                        "latitude": "41.71737000",
                        "longitude": "-3.36711000"
                    },
                    {
                        "id": 32989,
                        "name": "Briviesca",
                        "latitude": "42.54993000",
                        "longitude": "-3.32315000"
                    },
                    {
                        "id": 33011,
                        "name": "Bugedo",
                        "latitude": "42.64912000",
                        "longitude": "-3.01786000"
                    },
                    {
                        "id": 33019,
                        "name": "Buniel",
                        "latitude": "42.31197000",
                        "longitude": "-3.82230000"
                    },
                    {
                        "id": 33026,
                        "name": "Burgos",
                        "latitude": "42.34106000",
                        "longitude": "-3.70184000"
                    },
                    {
                        "id": 33044,
                        "name": "Busto de Bureba",
                        "latitude": "42.65910000",
                        "longitude": "-3.26512000"
                    },
                    {
                        "id": 33076,
                        "name": "Cabañes de Esgueva",
                        "latitude": "41.83023000",
                        "longitude": "-3.78824000"
                    },
                    {
                        "id": 33095,
                        "name": "Cabezón de la Sierra",
                        "latitude": "41.93434000",
                        "longitude": "-3.24153000"
                    },
                    {
                        "id": 33142,
                        "name": "Caleruega",
                        "latitude": "41.82548000",
                        "longitude": "-3.48593000"
                    },
                    {
                        "id": 33188,
                        "name": "Campillo de Aranda",
                        "latitude": "41.61015000",
                        "longitude": "-3.73017000"
                    },
                    {
                        "id": 33205,
                        "name": "Campolara",
                        "latitude": "42.11953000",
                        "longitude": "-3.42740000"
                    },
                    {
                        "id": 33238,
                        "name": "Canicosa de la Sierra",
                        "latitude": "41.93673000",
                        "longitude": "-3.04089000"
                    },
                    {
                        "id": 33248,
                        "name": "Cantabrana",
                        "latitude": "42.73422000",
                        "longitude": "-3.46704000"
                    },
                    {
                        "id": 33278,
                        "name": "Carazo",
                        "latitude": "41.96832000",
                        "longitude": "-3.35310000"
                    },
                    {
                        "id": 33293,
                        "name": "Carcedo de Bureba",
                        "latitude": "42.57818000",
                        "longitude": "-3.49831000"
                    },
                    {
                        "id": 33294,
                        "name": "Carcedo de Burgos",
                        "latitude": "42.28696000",
                        "longitude": "-3.62274000"
                    },
                    {
                        "id": 33299,
                        "name": "Cardeñadijo",
                        "latitude": "42.30217000",
                        "longitude": "-3.66779000"
                    },
                    {
                        "id": 33300,
                        "name": "Cardeñajimeno",
                        "latitude": "42.33038000",
                        "longitude": "-3.62103000"
                    },
                    {
                        "id": 152299,
                        "name": "Cardeñuela Riopico",
                        "latitude": "42.35904050",
                        "longitude": "-3.55912860"
                    },
                    {
                        "id": 33326,
                        "name": "Carrias",
                        "latitude": "42.48141000",
                        "longitude": "-3.28319000"
                    },
                    {
                        "id": 33384,
                        "name": "Cascajares de Bureba",
                        "latitude": "42.67884000",
                        "longitude": "-3.23768000"
                    },
                    {
                        "id": 33385,
                        "name": "Cascajares de la Sierra",
                        "latitude": "42.06177000",
                        "longitude": "-3.39936000"
                    },
                    {
                        "id": 33414,
                        "name": "Castellanos de Castro",
                        "latitude": "42.32806000",
                        "longitude": "-4.03417000"
                    },
                    {
                        "id": 33444,
                        "name": "Castil de Peones",
                        "latitude": "42.48347000",
                        "longitude": "-3.38461000"
                    },
                    {
                        "id": 33448,
                        "name": "Castildelgado",
                        "latitude": "42.43756000",
                        "longitude": "-3.08389000"
                    },
                    {
                        "id": 33481,
                        "name": "Castrillo de la Reina",
                        "latitude": "41.98714000",
                        "longitude": "-3.23560000"
                    },
                    {
                        "id": 33483,
                        "name": "Castrillo de la Vega",
                        "latitude": "41.65166000",
                        "longitude": "-3.78089000"
                    },
                    {
                        "id": 152300,
                        "name": "Castrillo de Riopisuerga",
                        "latitude": "42.51496440",
                        "longitude": "-4.25241210"
                    },
                    {
                        "id": 33484,
                        "name": "Castrillo del Val",
                        "latitude": "42.31401000",
                        "longitude": "-3.58501000"
                    },
                    {
                        "id": 152301,
                        "name": "Castrillo Matajudíos",
                        "latitude": "42.30768160",
                        "longitude": "-4.17249430"
                    },
                    {
                        "id": 152302,
                        "name": "Castrojeriz",
                        "latitude": "42.33239110",
                        "longitude": "-3.70599810"
                    },
                    {
                        "id": 152298,
                        "name": "Cavia",
                        "latitude": "42.28355190",
                        "longitude": "-3.84535590"
                    },
                    {
                        "id": 33520,
                        "name": "Cayuela",
                        "latitude": "42.27223000",
                        "longitude": "-3.81895000"
                    },
                    {
                        "id": 33550,
                        "name": "Cebrecos",
                        "latitude": "41.98408000",
                        "longitude": "-3.59661000"
                    },
                    {
                        "id": 33562,
                        "name": "Celada del Camino",
                        "latitude": "42.26359000",
                        "longitude": "-3.93362000"
                    },
                    {
                        "id": 152303,
                        "name": "Cerezo de Río Tirón",
                        "latitude": "42.49128150",
                        "longitude": "-3.13539030"
                    },
                    {
                        "id": 33592,
                        "name": "Cerratón de Juarros",
                        "latitude": "42.42227000",
                        "longitude": "-3.37347000"
                    },
                    {
                        "id": 33655,
                        "name": "Ciadoncha",
                        "latitude": "42.15814000",
                        "longitude": "-3.93235000"
                    },
                    {
                        "id": 152304,
                        "name": "Cillaperlata",
                        "latitude": "42.78243210",
                        "longitude": "-3.35715490"
                    },
                    {
                        "id": 33669,
                        "name": "Cilleruelo de Abajo",
                        "latitude": "41.88405000",
                        "longitude": "-3.79723000"
                    },
                    {
                        "id": 33670,
                        "name": "Cilleruelo de Arriba",
                        "latitude": "41.90487000",
                        "longitude": "-3.66102000"
                    },
                    {
                        "id": 33687,
                        "name": "Ciruelos de Cervera",
                        "latitude": "41.90562000",
                        "longitude": "-3.53015000"
                    },
                    {
                        "id": 33722,
                        "name": "Cogollos",
                        "latitude": "42.19982000",
                        "longitude": "-3.70005000"
                    },
                    {
                        "id": 152305,
                        "name": "Condado de Treviño",
                        "latitude": "42.73413790",
                        "longitude": "-2.74660410"
                    },
                    {
                        "id": 33770,
                        "name": "Contreras",
                        "latitude": "42.02004000",
                        "longitude": "-3.41084000"
                    },
                    {
                        "id": 33814,
                        "name": "Coruña del Conde",
                        "latitude": "41.76566000",
                        "longitude": "-3.39059000"
                    },
                    {
                        "id": 33827,
                        "name": "Covarrubias",
                        "latitude": "42.05927000",
                        "longitude": "-3.51956000"
                    },
                    {
                        "id": 33855,
                        "name": "Cubillo del Campo",
                        "latitude": "42.16854000",
                        "longitude": "-3.61025000"
                    },
                    {
                        "id": 33860,
                        "name": "Cubo de Bureba",
                        "latitude": "42.64011000",
                        "longitude": "-3.20626000"
                    },
                    {
                        "id": 152306,
                        "name": "Cueva de Roa La",
                        "latitude": "41.66779890",
                        "longitude": "-3.94002980"
                    },
                    {
                        "id": 33873,
                        "name": "Cuevas de San Clemente",
                        "latitude": "42.13009000",
                        "longitude": "-3.56840000"
                    },
                    {
                        "id": 34056,
                        "name": "Encío",
                        "latitude": "42.67115000",
                        "longitude": "-3.08680000"
                    },
                    {
                        "id": 34119,
                        "name": "Espinosa de Cervera",
                        "latitude": "41.89683000",
                        "longitude": "-3.46858000"
                    },
                    {
                        "id": 34122,
                        "name": "Espinosa de los Monteros",
                        "latitude": "43.07754000",
                        "longitude": "-3.55365000"
                    },
                    {
                        "id": 34123,
                        "name": "Espinosa del Camino",
                        "latitude": "42.40590000",
                        "longitude": "-3.28019000"
                    },
                    {
                        "id": 34150,
                        "name": "Estépar",
                        "latitude": "42.27731000",
                        "longitude": "-3.89946000"
                    },
                    {
                        "id": 34216,
                        "name": "Fontioso",
                        "latitude": "41.94273000",
                        "longitude": "-3.73872000"
                    },
                    {
                        "id": 34239,
                        "name": "Frandovínez",
                        "latitude": "42.31032000",
                        "longitude": "-3.83783000"
                    },
                    {
                        "id": 34247,
                        "name": "Fresneda de la Sierra Tirón",
                        "latitude": "42.31535000",
                        "longitude": "-3.13596000"
                    },
                    {
                        "id": 34252,
                        "name": "Fresneña",
                        "latitude": "42.41366000",
                        "longitude": "-3.13453000"
                    },
                    {
                        "id": 34253,
                        "name": "Fresnillo de las Dueñas",
                        "latitude": "41.64700000",
                        "longitude": "-3.64558000"
                    },
                    {
                        "id": 152307,
                        "name": "Fresno de Río Tirón",
                        "latitude": "42.45991740",
                        "longitude": "-3.17482810"
                    },
                    {
                        "id": 34257,
                        "name": "Fresno de Rodilla",
                        "latitude": "42.42054000",
                        "longitude": "-3.48507000"
                    },
                    {
                        "id": 34271,
                        "name": "Frías",
                        "latitude": "42.76225000",
                        "longitude": "-3.29394000"
                    },
                    {
                        "id": 34311,
                        "name": "Fuentebureba",
                        "latitude": "42.63400000",
                        "longitude": "-3.23510000"
                    },
                    {
                        "id": 34314,
                        "name": "Fuentecén",
                        "latitude": "41.62852000",
                        "longitude": "-3.86867000"
                    },
                    {
                        "id": 34319,
                        "name": "Fuentelcésped",
                        "latitude": "41.59162000",
                        "longitude": "-3.64064000"
                    },
                    {
                        "id": 34323,
                        "name": "Fuentelisendo",
                        "latitude": "41.62274000",
                        "longitude": "-3.90129000"
                    },
                    {
                        "id": 34327,
                        "name": "Fuentemolinos",
                        "latitude": "41.60477000",
                        "longitude": "-3.85005000"
                    },
                    {
                        "id": 34328,
                        "name": "Fuentenebro",
                        "latitude": "41.52873000",
                        "longitude": "-3.75449000"
                    },
                    {
                        "id": 34357,
                        "name": "Fuentespina",
                        "latitude": "41.63079000",
                        "longitude": "-3.68475000"
                    },
                    {
                        "id": 34376,
                        "name": "Galbarros",
                        "latitude": "42.52729000",
                        "longitude": "-3.43827000"
                    },
                    {
                        "id": 152308,
                        "name": "Gallega La",
                        "latitude": "41.89882540",
                        "longitude": "-3.26402050"
                    },
                    {
                        "id": 34511,
                        "name": "Grijalba",
                        "latitude": "42.43002000",
                        "longitude": "-4.11896000"
                    },
                    {
                        "id": 34513,
                        "name": "Grisaleña",
                        "latitude": "42.59122000",
                        "longitude": "-3.26416000"
                    },
                    {
                        "id": 152309,
                        "name": "Gumiel de Izán",
                        "latitude": "41.77065840",
                        "longitude": "-3.68704620"
                    },
                    {
                        "id": 152310,
                        "name": "Gumiel de Mercado",
                        "latitude": "41.75549950",
                        "longitude": "-3.80245340"
                    },
                    {
                        "id": 34571,
                        "name": "Hacinas",
                        "latitude": "41.98514000",
                        "longitude": "-3.28709000"
                    },
                    {
                        "id": 34574,
                        "name": "Haza",
                        "latitude": "41.61667000",
                        "longitude": "-3.81667000"
                    },
                    {
                        "id": 34641,
                        "name": "Hontanas",
                        "latitude": "42.31312000",
                        "longitude": "-4.04529000"
                    },
                    {
                        "id": 34643,
                        "name": "Hontangas",
                        "latitude": "41.58216000",
                        "longitude": "-3.79550000"
                    },
                    {
                        "id": 34648,
                        "name": "Hontoria de la Cantera",
                        "latitude": "42.18879000",
                        "longitude": "-3.64251000"
                    },
                    {
                        "id": 34647,
                        "name": "Hontoria de Valdearados",
                        "latitude": "41.74488000",
                        "longitude": "-3.51983000"
                    },
                    {
                        "id": 34649,
                        "name": "Hontoria del Pinar",
                        "latitude": "41.84838000",
                        "longitude": "-3.16245000"
                    },
                    {
                        "id": 152311,
                        "name": "Hormazas Las",
                        "latitude": "42.51432710",
                        "longitude": "-3.89608110"
                    },
                    {
                        "id": 34663,
                        "name": "Hornillos del Camino",
                        "latitude": "42.33863000",
                        "longitude": "-3.92560000"
                    },
                    {
                        "id": 152312,
                        "name": "Horra La",
                        "latitude": "41.74520710",
                        "longitude": "-3.87571190"
                    },
                    {
                        "id": 34668,
                        "name": "Hortigüela",
                        "latitude": "42.06842000",
                        "longitude": "-3.42578000"
                    },
                    {
                        "id": 34673,
                        "name": "Hoyales de Roa",
                        "latitude": "41.65893000",
                        "longitude": "-3.86202000"
                    },
                    {
                        "id": 34715,
                        "name": "Huérmeces",
                        "latitude": "42.52250000",
                        "longitude": "-3.77072000"
                    },
                    {
                        "id": 34687,
                        "name": "Huerta de Arriba",
                        "latitude": "42.11672000",
                        "longitude": "-3.08211000"
                    },
                    {
                        "id": 152313,
                        "name": "Huerta de Rey",
                        "latitude": "41.83939150",
                        "longitude": "-3.34707780"
                    },
                    {
                        "id": 34699,
                        "name": "Humada",
                        "latitude": "42.66667000",
                        "longitude": "-4.08333000"
                    },
                    {
                        "id": 34703,
                        "name": "Hurones",
                        "latitude": "42.40571000",
                        "longitude": "-3.61588000"
                    },
                    {
                        "id": 34726,
                        "name": "Ibeas de Juarros",
                        "latitude": "42.33088000",
                        "longitude": "-3.53519000"
                    },
                    {
                        "id": 34730,
                        "name": "Ibrillos",
                        "latitude": "42.45431000",
                        "longitude": "-3.08238000"
                    },
                    {
                        "id": 34736,
                        "name": "Iglesiarrubia",
                        "latitude": "41.97383000",
                        "longitude": "-3.84701000"
                    },
                    {
                        "id": 34737,
                        "name": "Iglesias",
                        "latitude": "42.29807000",
                        "longitude": "-3.98932000"
                    },
                    {
                        "id": 34764,
                        "name": "Isar",
                        "latitude": "42.36140000",
                        "longitude": "-3.93040000"
                    },
                    {
                        "id": 34771,
                        "name": "Itero del Castillo",
                        "latitude": "42.28988000",
                        "longitude": "-4.24441000"
                    },
                    {
                        "id": 34800,
                        "name": "Jaramillo de la Fuente",
                        "latitude": "42.11472000",
                        "longitude": "-3.31239000"
                    },
                    {
                        "id": 34799,
                        "name": "Jaramillo Quemado",
                        "latitude": "42.08568000",
                        "longitude": "-3.35868000"
                    },
                    {
                        "id": 152314,
                        "name": "Junta de Traslaloma",
                        "latitude": "43.04071360",
                        "longitude": "-3.38985100"
                    },
                    {
                        "id": 152315,
                        "name": "Junta de Villalba de Losa",
                        "latitude": "42.93537820",
                        "longitude": "-3.08794320"
                    },
                    {
                        "id": 152316,
                        "name": "Jurisdicción de Lara",
                        "latitude": "42.13519300",
                        "longitude": "-3.44983460"
                    },
                    {
                        "id": 152317,
                        "name": "Jurisdicción de San Zadornil",
                        "latitude": "42.84152200",
                        "longitude": "-3.15854160"
                    },
                    {
                        "id": 35032,
                        "name": "Lerma",
                        "latitude": "42.02609000",
                        "longitude": "-3.75978000"
                    },
                    {
                        "id": 35068,
                        "name": "Llano de Bureba",
                        "latitude": "42.62435000",
                        "longitude": "-3.45890000"
                    },
                    {
                        "id": 35191,
                        "name": "Madrigal del Monte",
                        "latitude": "42.14464000",
                        "longitude": "-3.67571000"
                    },
                    {
                        "id": 35193,
                        "name": "Madrigalejo del Monte",
                        "latitude": "42.12442000",
                        "longitude": "-3.72509000"
                    },
                    {
                        "id": 35206,
                        "name": "Mahamud",
                        "latitude": "42.11981000",
                        "longitude": "-3.94060000"
                    },
                    {
                        "id": 35236,
                        "name": "Mambrilla de Castrejón",
                        "latitude": "41.66634000",
                        "longitude": "-3.98448000"
                    },
                    {
                        "id": 35237,
                        "name": "Mambrillas de Lara",
                        "latitude": "42.09446000",
                        "longitude": "-3.46195000"
                    },
                    {
                        "id": 35238,
                        "name": "Mamolar",
                        "latitude": "41.92762000",
                        "longitude": "-3.36228000"
                    },
                    {
                        "id": 35245,
                        "name": "Manciles",
                        "latitude": "42.45728000",
                        "longitude": "-3.94461000"
                    },
                    {
                        "id": 35360,
                        "name": "Mazuela",
                        "latitude": "42.20767000",
                        "longitude": "-3.91920000"
                    },
                    {
                        "id": 35365,
                        "name": "Mecerreyes",
                        "latitude": "42.09536000",
                        "longitude": "-3.57393000"
                    },
                    {
                        "id": 35370,
                        "name": "Medina de Pomar",
                        "latitude": "42.92938000",
                        "longitude": "-3.48804000"
                    },
                    {
                        "id": 35387,
                        "name": "Melgar de Fernamental",
                        "latitude": "42.40445000",
                        "longitude": "-4.24484000"
                    },
                    {
                        "id": 152318,
                        "name": "Merindad de Cuesta-Urria",
                        "latitude": "42.84564270",
                        "longitude": "-3.45393670"
                    },
                    {
                        "id": 152319,
                        "name": "Merindad de Montija",
                        "latitude": "43.10257350",
                        "longitude": "-3.48013490"
                    },
                    {
                        "id": 152366,
                        "name": "Merindad de Río Ubierna",
                        "latitude": "42.55075630",
                        "longitude": "-3.68260800"
                    },
                    {
                        "id": 152320,
                        "name": "Merindad de Sotoscueva",
                        "latitude": "43.05877470",
                        "longitude": "-3.64204800"
                    },
                    {
                        "id": 152321,
                        "name": "Merindad de Valdeporres",
                        "latitude": "43.05484310",
                        "longitude": "-3.76382560"
                    },
                    {
                        "id": 152322,
                        "name": "Merindad de Valdivielso",
                        "latitude": "42.81998880",
                        "longitude": "-3.53668170"
                    },
                    {
                        "id": 35429,
                        "name": "Milagros",
                        "latitude": "41.57500000",
                        "longitude": "-3.69907000"
                    },
                    {
                        "id": 35450,
                        "name": "Miranda de Ebro",
                        "latitude": "42.68650000",
                        "longitude": "-2.94695000"
                    },
                    {
                        "id": 35453,
                        "name": "Miraveche",
                        "latitude": "42.67396000",
                        "longitude": "-3.19947000"
                    },
                    {
                        "id": 35464,
                        "name": "Modúbar de la Emparedada",
                        "latitude": "42.26118000",
                        "longitude": "-3.65965000"
                    },
                    {
                        "id": 35498,
                        "name": "Monasterio de la Sierra",
                        "latitude": "42.05180000",
                        "longitude": "-3.19314000"
                    },
                    {
                        "id": 35496,
                        "name": "Monasterio de Rodilla",
                        "latitude": "42.45775000",
                        "longitude": "-3.46965000"
                    },
                    {
                        "id": 35500,
                        "name": "Moncalvillo",
                        "latitude": "41.95413000",
                        "longitude": "-3.19886000"
                    },
                    {
                        "id": 152323,
                        "name": "Monterrubio de la Demanda",
                        "latitude": "42.14847600",
                        "longitude": "-3.11399480"
                    },
                    {
                        "id": 35581,
                        "name": "Montorio",
                        "latitude": "42.58469000",
                        "longitude": "-3.77724000"
                    },
                    {
                        "id": 35595,
                        "name": "Moradillo de Roa",
                        "latitude": "41.55164000",
                        "longitude": "-3.79118000"
                    },
                    {
                        "id": 35724,
                        "name": "Nava de Roa",
                        "latitude": "41.61326000",
                        "longitude": "-3.96442000"
                    },
                    {
                        "id": 35777,
                        "name": "Navas de Bureba",
                        "latitude": "42.68090000",
                        "longitude": "-3.32698000"
                    },
                    {
                        "id": 35795,
                        "name": "Nebreda",
                        "latitude": "41.96881000",
                        "longitude": "-3.63430000"
                    },
                    {
                        "id": 35799,
                        "name": "Neila",
                        "latitude": "42.06016000",
                        "longitude": "-2.99691000"
                    },
                    {
                        "id": 35900,
                        "name": "Olmedillo de Roa",
                        "latitude": "41.78362000",
                        "longitude": "-3.93419000"
                    },
                    {
                        "id": 35904,
                        "name": "Olmillos de Muñó",
                        "latitude": "42.20322000",
                        "longitude": "-3.93911000"
                    },
                    {
                        "id": 35988,
                        "name": "Oña",
                        "latitude": "42.73400000",
                        "longitude": "-3.41459000"
                    },
                    {
                        "id": 35931,
                        "name": "Oquillas",
                        "latitude": "41.83085000",
                        "longitude": "-3.70564000"
                    },
                    {
                        "id": 152324,
                        "name": "Orbaneja Riopico",
                        "latitude": "42.36071140",
                        "longitude": "-3.58443300"
                    },
                    {
                        "id": 35991,
                        "name": "Padilla de Abajo",
                        "latitude": "42.40774000",
                        "longitude": "-4.17652000"
                    },
                    {
                        "id": 35992,
                        "name": "Padilla de Arriba",
                        "latitude": "42.43803000",
                        "longitude": "-4.19094000"
                    },
                    {
                        "id": 35994,
                        "name": "Padrones de Bureba",
                        "latitude": "42.70582000",
                        "longitude": "-3.53296000"
                    },
                    {
                        "id": 36008,
                        "name": "Palacios de la Sierra",
                        "latitude": "41.96392000",
                        "longitude": "-3.12788000"
                    },
                    {
                        "id": 152325,
                        "name": "Palacios de Riopisuerga",
                        "latitude": "42.34358350",
                        "longitude": "-4.25737110"
                    },
                    {
                        "id": 36021,
                        "name": "Palazuelos de la Sierra",
                        "latitude": "42.21162000",
                        "longitude": "-3.46014000"
                    },
                    {
                        "id": 36020,
                        "name": "Palazuelos de Muñó",
                        "latitude": "42.19692000",
                        "longitude": "-3.98984000"
                    },
                    {
                        "id": 36044,
                        "name": "Pampliega",
                        "latitude": "42.20582000",
                        "longitude": "-3.98666000"
                    },
                    {
                        "id": 36046,
                        "name": "Pancorbo",
                        "latitude": "42.63418000",
                        "longitude": "-3.11180000"
                    },
                    {
                        "id": 36063,
                        "name": "Pardilla",
                        "latitude": "41.55183000",
                        "longitude": "-3.71089000"
                    },
                    {
                        "id": 152326,
                        "name": "Partido de la Sierra en Tobalina",
                        "latitude": "42.72561830",
                        "longitude": "-3.23322440"
                    },
                    {
                        "id": 36104,
                        "name": "Pedrosa de Duero",
                        "latitude": "41.71289000",
                        "longitude": "-3.98804000"
                    },
                    {
                        "id": 152327,
                        "name": "Pedrosa de Río Úrbel",
                        "latitude": "42.40984850",
                        "longitude": "-3.82196320"
                    },
                    {
                        "id": 36107,
                        "name": "Pedrosa del Páramo",
                        "latitude": "42.44208000",
                        "longitude": "-3.97190000"
                    },
                    {
                        "id": 36106,
                        "name": "Pedrosa del Príncipe",
                        "latitude": "42.24918000",
                        "longitude": "-4.19849000"
                    },
                    {
                        "id": 36172,
                        "name": "Peñaranda de Duero",
                        "latitude": "41.68849000",
                        "longitude": "-3.47863000"
                    },
                    {
                        "id": 36131,
                        "name": "Peral de Arlanza",
                        "latitude": "42.07612000",
                        "longitude": "-4.07733000"
                    },
                    {
                        "id": 36226,
                        "name": "Piérnigas",
                        "latitude": "42.59030000",
                        "longitude": "-3.41337000"
                    },
                    {
                        "id": 36198,
                        "name": "Pineda de la Sierra",
                        "latitude": "42.21560000",
                        "longitude": "-3.29690000"
                    },
                    {
                        "id": 152328,
                        "name": "Pineda Trasmonte",
                        "latitude": "41.90888820",
                        "longitude": "-3.69567610"
                    },
                    {
                        "id": 36204,
                        "name": "Pinilla de los Barruecos",
                        "latitude": "41.91791000",
                        "longitude": "-3.30371000"
                    },
                    {
                        "id": 36205,
                        "name": "Pinilla de los Moros",
                        "latitude": "42.06815000",
                        "longitude": "-3.32706000"
                    },
                    {
                        "id": 152329,
                        "name": "Pinilla Trasmonte",
                        "latitude": "41.87364760",
                        "longitude": "-3.61879480"
                    },
                    {
                        "id": 36311,
                        "name": "Poza de la Sal",
                        "latitude": "42.66542000",
                        "longitude": "-3.50140000"
                    },
                    {
                        "id": 36402,
                        "name": "Prádanos de Bureba",
                        "latitude": "42.50264000",
                        "longitude": "-3.34752000"
                    },
                    {
                        "id": 36347,
                        "name": "Pradoluengo",
                        "latitude": "42.32484000",
                        "longitude": "-3.20284000"
                    },
                    {
                        "id": 36351,
                        "name": "Presencio",
                        "latitude": "42.18656000",
                        "longitude": "-3.90135000"
                    },
                    {
                        "id": 152330,
                        "name": "Puebla de Arganzón La",
                        "latitude": "42.77547620",
                        "longitude": "-2.82281240"
                    },
                    {
                        "id": 36442,
                        "name": "Puentedura",
                        "latitude": "42.04134000",
                        "longitude": "-3.58227000"
                    },
                    {
                        "id": 36493,
                        "name": "Quemada",
                        "latitude": "41.70073000",
                        "longitude": "-3.57476000"
                    },
                    {
                        "id": 36505,
                        "name": "Quintana del Pidio",
                        "latitude": "41.75886000",
                        "longitude": "-3.75121000"
                    },
                    {
                        "id": 36508,
                        "name": "Quintanabureba",
                        "latitude": "42.58665000",
                        "longitude": "-3.36685000"
                    },
                    {
                        "id": 36516,
                        "name": "Quintanaélez",
                        "latitude": "42.66921000",
                        "longitude": "-3.29877000"
                    },
                    {
                        "id": 36509,
                        "name": "Quintanaortuño",
                        "latitude": "42.45000000",
                        "longitude": "-3.68333000"
                    },
                    {
                        "id": 36510,
                        "name": "Quintanapalla",
                        "latitude": "42.40914000",
                        "longitude": "-3.53296000"
                    },
                    {
                        "id": 36512,
                        "name": "Quintanar de la Sierra",
                        "latitude": "41.98288000",
                        "longitude": "-3.03765000"
                    },
                    {
                        "id": 36515,
                        "name": "Quintanavides",
                        "latitude": "42.48084000",
                        "longitude": "-3.42449000"
                    },
                    {
                        "id": 36522,
                        "name": "Quintanilla de la Mata",
                        "latitude": "41.98855000",
                        "longitude": "-3.76756000"
                    },
                    {
                        "id": 152361,
                        "name": "Quintanilla del Agua y Tordueles",
                        "latitude": "42.04991540",
                        "longitude": "-3.65218490"
                    },
                    {
                        "id": 36523,
                        "name": "Quintanilla del Coco",
                        "latitude": "41.98333000",
                        "longitude": "-3.51667000"
                    },
                    {
                        "id": 152332,
                        "name": "Quintanilla San García",
                        "latitude": "42.54886240",
                        "longitude": "-3.19365800"
                    },
                    {
                        "id": 152333,
                        "name": "Quintanilla Vivar",
                        "latitude": "42.41390980",
                        "longitude": "-3.68831430"
                    },
                    {
                        "id": 152331,
                        "name": "Quintanillas Las",
                        "latitude": "42.37191530",
                        "longitude": "-3.84580920"
                    },
                    {
                        "id": 36535,
                        "name": "Rabanera del Pinar",
                        "latitude": "41.89375000",
                        "longitude": "-3.19665000"
                    },
                    {
                        "id": 36710,
                        "name": "Rábanos",
                        "latitude": "42.31971000",
                        "longitude": "-3.27029000"
                    },
                    {
                        "id": 36536,
                        "name": "Rabé de las Calzadas",
                        "latitude": "42.34065000",
                        "longitude": "-3.83414000"
                    },
                    {
                        "id": 36554,
                        "name": "Rebolledo de la Torre",
                        "latitude": "42.68931000",
                        "longitude": "-4.22693000"
                    },
                    {
                        "id": 36559,
                        "name": "Redecilla del Camino",
                        "latitude": "42.43804000",
                        "longitude": "-3.06547000"
                    },
                    {
                        "id": 36560,
                        "name": "Redecilla del Campo",
                        "latitude": "42.46675000",
                        "longitude": "-3.11531000"
                    },
                    {
                        "id": 36566,
                        "name": "Regumiel de la Sierra",
                        "latitude": "41.95623000",
                        "longitude": "-2.98843000"
                    },
                    {
                        "id": 36569,
                        "name": "Reinoso",
                        "latitude": "42.50915000",
                        "longitude": "-3.38466000"
                    },
                    {
                        "id": 36590,
                        "name": "Retuerta",
                        "latitude": "42.02945000",
                        "longitude": "-3.50679000"
                    },
                    {
                        "id": 36596,
                        "name": "Revilla del Campo",
                        "latitude": "42.21081000",
                        "longitude": "-3.54289000"
                    },
                    {
                        "id": 152335,
                        "name": "Revilla Vallejera",
                        "latitude": "42.14684790",
                        "longitude": "-4.13442430"
                    },
                    {
                        "id": 152334,
                        "name": "Revilla y Ahedo La",
                        "latitude": "42.00488420",
                        "longitude": "-3.34392910"
                    },
                    {
                        "id": 36597,
                        "name": "Revillarruz",
                        "latitude": "42.23006000",
                        "longitude": "-3.65246000"
                    },
                    {
                        "id": 36599,
                        "name": "Rezmondo",
                        "latitude": "42.51565000",
                        "longitude": "-4.23877000"
                    },
                    {
                        "id": 36628,
                        "name": "Riocavado de la Sierra",
                        "latitude": "42.15209000",
                        "longitude": "-3.19759000"
                    },
                    {
                        "id": 36643,
                        "name": "Roa",
                        "latitude": "41.69699000",
                        "longitude": "-3.92782000"
                    },
                    {
                        "id": 36666,
                        "name": "Rojas",
                        "latitude": "42.57781000",
                        "longitude": "-3.44195000"
                    },
                    {
                        "id": 36684,
                        "name": "Royuela de Río Franco",
                        "latitude": "42.00217000",
                        "longitude": "-3.95547000"
                    },
                    {
                        "id": 36688,
                        "name": "Rubena",
                        "latitude": "42.38746000",
                        "longitude": "-3.57485000"
                    },
                    {
                        "id": 36693,
                        "name": "Rublacedo de Abajo",
                        "latitude": "42.55332000",
                        "longitude": "-3.50236000"
                    },
                    {
                        "id": 36696,
                        "name": "Rucandio",
                        "latitude": "42.75111000",
                        "longitude": "-3.54166000"
                    },
                    {
                        "id": 36750,
                        "name": "Salas de Bureba",
                        "latitude": "42.69190000",
                        "longitude": "-3.47359000"
                    },
                    {
                        "id": 36751,
                        "name": "Salas de los Infantes",
                        "latitude": "42.02242000",
                        "longitude": "-3.28631000"
                    },
                    {
                        "id": 36755,
                        "name": "Saldaña de Burgos",
                        "latitude": "42.25838000",
                        "longitude": "-3.69707000"
                    },
                    {
                        "id": 36767,
                        "name": "Salinillas de Bureba",
                        "latitude": "42.55243000",
                        "longitude": "-3.38753000"
                    },
                    {
                        "id": 36796,
                        "name": "San Adrián de Juarros",
                        "latitude": "42.27427000",
                        "longitude": "-3.47551000"
                    },
                    {
                        "id": 36851,
                        "name": "San Juan del Monte",
                        "latitude": "41.68313000",
                        "longitude": "-3.52337000"
                    },
                    {
                        "id": 36861,
                        "name": "San Mamés de Burgos",
                        "latitude": "42.33685000",
                        "longitude": "-3.79397000"
                    },
                    {
                        "id": 36867,
                        "name": "San Martín de Rubiales",
                        "latitude": "41.64191000",
                        "longitude": "-3.99134000"
                    },
                    {
                        "id": 36889,
                        "name": "San Millán de Lara",
                        "latitude": "42.13621000",
                        "longitude": "-3.34515000"
                    },
                    {
                        "id": 36932,
                        "name": "San Vicente del Valle",
                        "latitude": "42.33756000",
                        "longitude": "-3.16210000"
                    },
                    {
                        "id": 37010,
                        "name": "Santa Cecilia",
                        "latitude": "42.05225000",
                        "longitude": "-3.80345000"
                    },
                    {
                        "id": 37039,
                        "name": "Santa Cruz de la Salceda",
                        "latitude": "41.59591000",
                        "longitude": "-3.59317000"
                    },
                    {
                        "id": 37046,
                        "name": "Santa Cruz del Valle Urbión",
                        "latitude": "42.30558000",
                        "longitude": "-3.22140000"
                    },
                    {
                        "id": 37060,
                        "name": "Santa Gadea del Cid",
                        "latitude": "42.71531000",
                        "longitude": "-3.05885000"
                    },
                    {
                        "id": 37061,
                        "name": "Santa Inés",
                        "latitude": "42.04013000",
                        "longitude": "-3.70322000"
                    },
                    {
                        "id": 37085,
                        "name": "Santa María del Campo",
                        "latitude": "42.13304000",
                        "longitude": "-3.97283000"
                    },
                    {
                        "id": 37087,
                        "name": "Santa María del Invierno",
                        "latitude": "42.44288000",
                        "longitude": "-3.43782000"
                    },
                    {
                        "id": 152336,
                        "name": "Santa María del Mercadillo",
                        "latitude": "41.85982780",
                        "longitude": "-3.55928440"
                    },
                    {
                        "id": 152337,
                        "name": "Santa María Rivarredonda",
                        "latitude": "42.63988690",
                        "longitude": "-3.18026290"
                    },
                    {
                        "id": 37093,
                        "name": "Santa Olalla de Bureba",
                        "latitude": "42.47721000",
                        "longitude": "-3.44109000"
                    },
                    {
                        "id": 152338,
                        "name": "Santibáñez de Esgueva",
                        "latitude": "41.83287220",
                        "longitude": "-3.75938060"
                    },
                    {
                        "id": 37127,
                        "name": "Santibáñez del Val",
                        "latitude": "41.97354000",
                        "longitude": "-3.48142000"
                    },
                    {
                        "id": 37140,
                        "name": "Santo Domingo de Silos",
                        "latitude": "41.96400000",
                        "longitude": "-3.41740000"
                    },
                    {
                        "id": 37161,
                        "name": "Sargentes de la Lora",
                        "latitude": "42.76917000",
                        "longitude": "-3.87278000"
                    },
                    {
                        "id": 37165,
                        "name": "Sarracín",
                        "latitude": "42.25813000",
                        "longitude": "-3.68608000"
                    },
                    {
                        "id": 37176,
                        "name": "Sasamón",
                        "latitude": "42.41687000",
                        "longitude": "-4.04288000"
                    },
                    {
                        "id": 152339,
                        "name": "Sequera de Haza La",
                        "latitude": "41.56263040",
                        "longitude": "-3.81751310"
                    },
                    {
                        "id": 37281,
                        "name": "Solarana",
                        "latitude": "41.97168000",
                        "longitude": "-3.65876000"
                    },
                    {
                        "id": 37299,
                        "name": "Sordillos",
                        "latitude": "42.46197000",
                        "longitude": "-4.10726000"
                    },
                    {
                        "id": 37314,
                        "name": "Sotillo de la Ribera",
                        "latitude": "41.77717000",
                        "longitude": "-3.82525000"
                    },
                    {
                        "id": 37325,
                        "name": "Sotragero",
                        "latitude": "42.40996000",
                        "longitude": "-3.71312000"
                    },
                    {
                        "id": 37326,
                        "name": "Sotresgudo",
                        "latitude": "42.57935000",
                        "longitude": "-4.17725000"
                    },
                    {
                        "id": 37333,
                        "name": "Susinos del Páramo",
                        "latitude": "42.47108000",
                        "longitude": "-3.92555000"
                    },
                    {
                        "id": 37366,
                        "name": "Tamarón",
                        "latitude": "42.27386000",
                        "longitude": "-3.99154000"
                    },
                    {
                        "id": 37377,
                        "name": "Tardajos",
                        "latitude": "42.34909000",
                        "longitude": "-3.81700000"
                    },
                    {
                        "id": 37394,
                        "name": "Tejada",
                        "latitude": "41.95249000",
                        "longitude": "-3.53514000"
                    },
                    {
                        "id": 37408,
                        "name": "Terradillos de Esgueva",
                        "latitude": "41.81885000",
                        "longitude": "-3.84318000"
                    },
                    {
                        "id": 152340,
                        "name": "Tinieblas de la Sierra",
                        "latitude": "42.17260880",
                        "longitude": "-3.36313910"
                    },
                    {
                        "id": 37435,
                        "name": "Tobar",
                        "latitude": "42.48384000",
                        "longitude": "-3.93984000"
                    },
                    {
                        "id": 37462,
                        "name": "Tordómar",
                        "latitude": "42.04630000",
                        "longitude": "-3.86514000"
                    },
                    {
                        "id": 37521,
                        "name": "Torrecilla del Monte",
                        "latitude": "42.09490000",
                        "longitude": "-3.69356000"
                    },
                    {
                        "id": 37532,
                        "name": "Torregalindo",
                        "latitude": "41.58299000",
                        "longitude": "-3.75222000"
                    },
                    {
                        "id": 37545,
                        "name": "Torrelara",
                        "latitude": "42.16673000",
                        "longitude": "-3.51689000"
                    },
                    {
                        "id": 152341,
                        "name": "Torrepadre",
                        "latitude": "42.04359310",
                        "longitude": "-3.93748110"
                    },
                    {
                        "id": 37580,
                        "name": "Torresandino",
                        "latitude": "41.82920000",
                        "longitude": "-3.90981000"
                    },
                    {
                        "id": 152342,
                        "name": "Tórtoles de Esgueva",
                        "latitude": "41.81592160",
                        "longitude": "-4.02229530"
                    },
                    {
                        "id": 37602,
                        "name": "Tosantos",
                        "latitude": "42.41368000",
                        "longitude": "-3.24286000"
                    },
                    {
                        "id": 37632,
                        "name": "Trespaderne",
                        "latitude": "42.80221000",
                        "longitude": "-3.38989000"
                    },
                    {
                        "id": 37646,
                        "name": "Tubilla del Agua",
                        "latitude": "42.70932000",
                        "longitude": "-3.80116000"
                    },
                    {
                        "id": 37647,
                        "name": "Tubilla del Lago",
                        "latitude": "41.80154000",
                        "longitude": "-3.58625000"
                    },
                    {
                        "id": 152343,
                        "name": "Úrbel del Castillo",
                        "latitude": "42.61765610",
                        "longitude": "-3.84612510"
                    },
                    {
                        "id": 37718,
                        "name": "Vadocondes",
                        "latitude": "41.63925000",
                        "longitude": "-3.57378000"
                    },
                    {
                        "id": 37730,
                        "name": "Valdeande",
                        "latitude": "41.83302000",
                        "longitude": "-3.52792000"
                    },
                    {
                        "id": 37808,
                        "name": "Valdezate",
                        "latitude": "41.60231000",
                        "longitude": "-3.93045000"
                    },
                    {
                        "id": 37811,
                        "name": "Valdorros",
                        "latitude": "42.17232000",
                        "longitude": "-3.70938000"
                    },
                    {
                        "id": 37838,
                        "name": "Vallarta de Bureba",
                        "latitude": "42.58864000",
                        "longitude": "-3.20457000"
                    },
                    {
                        "id": 152364,
                        "name": "Valle de las Navas",
                        "latitude": "42.47618920",
                        "longitude": "-3.56102600"
                    },
                    {
                        "id": 152368,
                        "name": "Valle de Losa",
                        "latitude": "42.99324940",
                        "longitude": "-3.23825100"
                    },
                    {
                        "id": 152344,
                        "name": "Valle de Manzanedo",
                        "latitude": "42.89884980",
                        "longitude": "-3.69167430"
                    },
                    {
                        "id": 152345,
                        "name": "Valle de Mena",
                        "latitude": "43.10851410",
                        "longitude": "-3.27848250"
                    },
                    {
                        "id": 152346,
                        "name": "Valle de Oca",
                        "latitude": "42.43409010",
                        "longitude": "-3.32881830"
                    },
                    {
                        "id": 152362,
                        "name": "Valle de Santibáñez",
                        "latitude": "42.46838470",
                        "longitude": "-3.80448310"
                    },
                    {
                        "id": 152365,
                        "name": "Valle de Sedano",
                        "latitude": "42.70589350",
                        "longitude": "-3.72320050"
                    },
                    {
                        "id": 152347,
                        "name": "Valle de Tobalina",
                        "latitude": "42.79864430",
                        "longitude": "-3.23825100"
                    },
                    {
                        "id": 152348,
                        "name": "Valle de Valdebezana",
                        "latitude": "42.97587030",
                        "longitude": "-3.80448310"
                    },
                    {
                        "id": 152349,
                        "name": "Valle de Valdelaguna",
                        "latitude": "42.10435000",
                        "longitude": "-3.14785140"
                    },
                    {
                        "id": 152350,
                        "name": "Valle de Valdelucio",
                        "latitude": "42.73389620",
                        "longitude": "-4.04910770"
                    },
                    {
                        "id": 152351,
                        "name": "Valle de Zamanzas",
                        "latitude": "42.85617380",
                        "longitude": "-3.74858740"
                    },
                    {
                        "id": 152352,
                        "name": "Vallejera",
                        "latitude": "42.18283890",
                        "longitude": "-4.15329590"
                    },
                    {
                        "id": 37855,
                        "name": "Valles de Palenzuela",
                        "latitude": "42.12019000",
                        "longitude": "-4.07750000"
                    },
                    {
                        "id": 37864,
                        "name": "Valluércanes",
                        "latitude": "42.57220000",
                        "longitude": "-3.12113000"
                    },
                    {
                        "id": 37868,
                        "name": "Valmala",
                        "latitude": "42.30590000",
                        "longitude": "-3.25456000"
                    },
                    {
                        "id": 152354,
                        "name": "Vid de Bureba La",
                        "latitude": "42.63056210",
                        "longitude": "-3.30081260"
                    },
                    {
                        "id": 152353,
                        "name": "Vid y Barrios La",
                        "latitude": "41.61818340",
                        "longitude": "-3.49023910"
                    },
                    {
                        "id": 38007,
                        "name": "Vileña",
                        "latitude": "42.62227000",
                        "longitude": "-3.32293000"
                    },
                    {
                        "id": 38041,
                        "name": "Villadiego",
                        "latitude": "42.51589000",
                        "longitude": "-4.00958000"
                    },
                    {
                        "id": 38046,
                        "name": "Villaescusa de Roa",
                        "latitude": "41.72727000",
                        "longitude": "-4.01720000"
                    },
                    {
                        "id": 38047,
                        "name": "Villaescusa la Sombría",
                        "latitude": "42.41518000",
                        "longitude": "-3.41840000"
                    },
                    {
                        "id": 38048,
                        "name": "Villaespasa",
                        "latitude": "42.09991000",
                        "longitude": "-3.40436000"
                    },
                    {
                        "id": 152355,
                        "name": "Villafranca Montes de Oca",
                        "latitude": "42.38738850",
                        "longitude": "-3.30930710"
                    },
                    {
                        "id": 38066,
                        "name": "Villafruela",
                        "latitude": "41.91647000",
                        "longitude": "-3.91371000"
                    },
                    {
                        "id": 38070,
                        "name": "Villagalijo",
                        "latitude": "42.34872000",
                        "longitude": "-3.19203000"
                    },
                    {
                        "id": 152356,
                        "name": "Villagonzalo Pedernales",
                        "latitude": "42.30059260",
                        "longitude": "-3.73525770"
                    },
                    {
                        "id": 38086,
                        "name": "Villahoz",
                        "latitude": "42.07587000",
                        "longitude": "-3.91290000"
                    },
                    {
                        "id": 38092,
                        "name": "Villalba de Duero",
                        "latitude": "41.68243000",
                        "longitude": "-3.74443000"
                    },
                    {
                        "id": 38106,
                        "name": "Villalbilla de Burgos",
                        "latitude": "42.34757000",
                        "longitude": "-3.78101000"
                    },
                    {
                        "id": 38107,
                        "name": "Villalbilla de Gumiel",
                        "latitude": "41.80621000",
                        "longitude": "-3.62584000"
                    },
                    {
                        "id": 38111,
                        "name": "Villaldemiro",
                        "latitude": "42.24719000",
                        "longitude": "-3.98534000"
                    },
                    {
                        "id": 38114,
                        "name": "Villalmanzo",
                        "latitude": "42.04840000",
                        "longitude": "-3.74195000"
                    },
                    {
                        "id": 38146,
                        "name": "Villamayor de los Montes",
                        "latitude": "42.10565000",
                        "longitude": "-3.76542000"
                    },
                    {
                        "id": 38145,
                        "name": "Villamayor de Treviño",
                        "latitude": "42.46048000",
                        "longitude": "-4.11923000"
                    },
                    {
                        "id": 152357,
                        "name": "Villambistia",
                        "latitude": "42.40471930",
                        "longitude": "-3.26150580"
                    },
                    {
                        "id": 38150,
                        "name": "Villamedianilla",
                        "latitude": "42.16070000",
                        "longitude": "-4.14592000"
                    },
                    {
                        "id": 38156,
                        "name": "Villamiel de la Sierra",
                        "latitude": "42.19124000",
                        "longitude": "-3.41771000"
                    },
                    {
                        "id": 38167,
                        "name": "Villangómez",
                        "latitude": "42.17961000",
                        "longitude": "-3.77419000"
                    },
                    {
                        "id": 38172,
                        "name": "Villanueva de Argaño",
                        "latitude": "42.38045000",
                        "longitude": "-3.93353000"
                    },
                    {
                        "id": 38178,
                        "name": "Villanueva de Carazo",
                        "latitude": "41.98275000",
                        "longitude": "-3.32428000"
                    },
                    {
                        "id": 38183,
                        "name": "Villanueva de Gumiel",
                        "latitude": "41.73778000",
                        "longitude": "-3.62658000"
                    },
                    {
                        "id": 38193,
                        "name": "Villanueva de Teba",
                        "latitude": "42.64890000",
                        "longitude": "-3.16313000"
                    },
                    {
                        "id": 38233,
                        "name": "Villaquirán de la Puebla",
                        "latitude": "42.28287000",
                        "longitude": "-4.10037000"
                    },
                    {
                        "id": 38234,
                        "name": "Villaquirán de los Infantes",
                        "latitude": "42.22744000",
                        "longitude": "-4.00864000"
                    },
                    {
                        "id": 152363,
                        "name": "Villarcayo de Merindad de Castilla la Vieja",
                        "latitude": "42.94482500",
                        "longitude": "-3.56102600"
                    },
                    {
                        "id": 38284,
                        "name": "Villariezo",
                        "latitude": "42.26965000",
                        "longitude": "-3.73272000"
                    },
                    {
                        "id": 38312,
                        "name": "Villasandino",
                        "latitude": "42.37072000",
                        "longitude": "-4.10975000"
                    },
                    {
                        "id": 152358,
                        "name": "Villasur de Herreros",
                        "latitude": "42.30777340",
                        "longitude": "-3.39464720"
                    },
                    {
                        "id": 38333,
                        "name": "Villatuelda",
                        "latitude": "41.81499000",
                        "longitude": "-3.88054000"
                    },
                    {
                        "id": 38349,
                        "name": "Villaverde del Monte",
                        "latitude": "42.16075000",
                        "longitude": "-3.81421000"
                    },
                    {
                        "id": 38352,
                        "name": "Villaverde-Mogina",
                        "latitude": "42.16041000",
                        "longitude": "-4.05024000"
                    },
                    {
                        "id": 152359,
                        "name": "Villayerno Morquillas",
                        "latitude": "42.39612250",
                        "longitude": "-3.63983080"
                    },
                    {
                        "id": 38364,
                        "name": "Villazopeque",
                        "latitude": "42.19845000",
                        "longitude": "-4.01688000"
                    },
                    {
                        "id": 38365,
                        "name": "Villegas",
                        "latitude": "42.46866000",
                        "longitude": "-4.01759000"
                    },
                    {
                        "id": 38374,
                        "name": "Villoruebo",
                        "latitude": "42.16874000",
                        "longitude": "-3.44159000"
                    },
                    {
                        "id": 38384,
                        "name": "Viloria de Rioja",
                        "latitude": "42.42608000",
                        "longitude": "-3.10056000"
                    },
                    {
                        "id": 38386,
                        "name": "Vilviestre del Pinar",
                        "latitude": "41.95033000",
                        "longitude": "-3.07803000"
                    },
                    {
                        "id": 38407,
                        "name": "Vizcaínos",
                        "latitude": "42.10359000",
                        "longitude": "-3.26698000"
                    },
                    {
                        "id": 38448,
                        "name": "Zael",
                        "latitude": "42.10587000",
                        "longitude": "-3.82623000"
                    },
                    {
                        "id": 152360,
                        "name": "Zarzosa de Río Pisuerga",
                        "latitude": "42.53636530",
                        "longitude": "-4.26830620"
                    },
                    {
                        "id": 38489,
                        "name": "Zazuar",
                        "latitude": "41.69528000",
                        "longitude": "-3.55451000"
                    },
                    {
                        "id": 38511,
                        "name": "Zuñeda",
                        "latitude": "42.60501000",
                        "longitude": "-3.22632000"
                    }
                ]
            },
            {
                "id": 1190,
                "name": "Caceres",
                "iso2": "CC",
                "latitude": "39.47163130",
                "longitude": "-6.42573840",
                "type": "province",
                "cities": [
                    {
                        "id": 31900,
                        "name": "Abadía",
                        "latitude": "40.25922000",
                        "longitude": "-5.97828000"
                    },
                    {
                        "id": 31910,
                        "name": "Abertura",
                        "latitude": "39.24352000",
                        "longitude": "-5.81394000"
                    },
                    {
                        "id": 31923,
                        "name": "Acebo",
                        "latitude": "40.20105000",
                        "longitude": "-6.71689000"
                    },
                    {
                        "id": 151193,
                        "name": "Acehúche",
                        "latitude": "39.80271430",
                        "longitude": "-6.63407580"
                    },
                    {
                        "id": 31925,
                        "name": "Aceituna",
                        "latitude": "40.15008000",
                        "longitude": "-6.33292000"
                    },
                    {
                        "id": 31974,
                        "name": "Ahigal",
                        "latitude": "40.18954000",
                        "longitude": "-6.18815000"
                    },
                    {
                        "id": 151218,
                        "name": "Alagón del Río",
                        "latitude": "39.96826190",
                        "longitude": "-6.31729060"
                    },
                    {
                        "id": 32027,
                        "name": "Albalá",
                        "latitude": "39.25592000",
                        "longitude": "-6.18528000"
                    },
                    {
                        "id": 32135,
                        "name": "Alcántara",
                        "latitude": "39.71895000",
                        "longitude": "-6.88375000"
                    },
                    {
                        "id": 32111,
                        "name": "Alcollarín",
                        "latitude": "39.24470000",
                        "longitude": "-5.73924000"
                    },
                    {
                        "id": 32132,
                        "name": "Alcuéscar",
                        "latitude": "39.18091000",
                        "longitude": "-6.22917000"
                    },
                    {
                        "id": 32143,
                        "name": "Aldea del Cano",
                        "latitude": "39.28874000",
                        "longitude": "-6.31806000"
                    },
                    {
                        "id": 151194,
                        "name": "Aldea del Obispo La",
                        "latitude": "39.56300270",
                        "longitude": "-5.91125590"
                    },
                    {
                        "id": 32147,
                        "name": "Aldeacentenera",
                        "latitude": "39.52725000",
                        "longitude": "-5.62936000"
                    },
                    {
                        "id": 32164,
                        "name": "Aldeanueva de la Vera",
                        "latitude": "40.12710000",
                        "longitude": "-5.70150000"
                    },
                    {
                        "id": 32165,
                        "name": "Aldeanueva del Camino",
                        "latitude": "40.25980000",
                        "longitude": "-5.92886000"
                    },
                    {
                        "id": 151195,
                        "name": "Aldehuela de Jerte",
                        "latitude": "40.01139440",
                        "longitude": "-6.23890910"
                    },
                    {
                        "id": 32347,
                        "name": "Alía",
                        "latitude": "39.44803000",
                        "longitude": "-5.21754000"
                    },
                    {
                        "id": 32248,
                        "name": "Aliseda",
                        "latitude": "39.42329000",
                        "longitude": "-6.69228000"
                    },
                    {
                        "id": 32268,
                        "name": "Almaraz",
                        "latitude": "39.81416000",
                        "longitude": "-5.67698000"
                    },
                    {
                        "id": 32299,
                        "name": "Almoharín",
                        "latitude": "39.17685000",
                        "longitude": "-6.04283000"
                    },
                    {
                        "id": 32510,
                        "name": "Arroyo de la Luz",
                        "latitude": "39.48511000",
                        "longitude": "-6.58401000"
                    },
                    {
                        "id": 32515,
                        "name": "Arroyomolinos de la Vera",
                        "latitude": "40.05277000",
                        "longitude": "-5.85111000"
                    },
                    {
                        "id": 32704,
                        "name": "Baños de Montemayor",
                        "latitude": "40.31671000",
                        "longitude": "-5.86009000"
                    },
                    {
                        "id": 32670,
                        "name": "Barrado",
                        "latitude": "40.08477000",
                        "longitude": "-5.88068000"
                    },
                    {
                        "id": 151196,
                        "name": "Belvís de Monroy",
                        "latitude": "39.81957960",
                        "longitude": "-5.60965770"
                    },
                    {
                        "id": 32826,
                        "name": "Benquerencia",
                        "latitude": "39.30994000",
                        "longitude": "-6.08465000"
                    },
                    {
                        "id": 32871,
                        "name": "Berrocalejo",
                        "latitude": "39.81948000",
                        "longitude": "-5.34951000"
                    },
                    {
                        "id": 151197,
                        "name": "Berzocana",
                        "latitude": "39.43671430",
                        "longitude": "-5.46139930"
                    },
                    {
                        "id": 32931,
                        "name": "Bohonal de Ibor",
                        "latitude": "39.78457000",
                        "longitude": "-5.48500000"
                    },
                    {
                        "id": 32965,
                        "name": "Botija",
                        "latitude": "39.34498000",
                        "longitude": "-6.07318000"
                    },
                    {
                        "id": 32993,
                        "name": "Brozas",
                        "latitude": "39.61278000",
                        "longitude": "-6.77770000"
                    },
                    {
                        "id": 33075,
                        "name": "Cabañas del Castillo",
                        "latitude": "39.54804000",
                        "longitude": "-5.51203000"
                    },
                    {
                        "id": 33080,
                        "name": "Cabezabellosa",
                        "latitude": "40.13763000",
                        "longitude": "-6.00086000"
                    },
                    {
                        "id": 33089,
                        "name": "Cabezuela del Valle",
                        "latitude": "40.19364000",
                        "longitude": "-5.80650000"
                    },
                    {
                        "id": 33106,
                        "name": "Cabrero",
                        "latitude": "40.11324000",
                        "longitude": "-5.89293000"
                    },
                    {
                        "id": 33892,
                        "name": "Cáceres",
                        "latitude": "39.47649000",
                        "longitude": "-6.37224000"
                    },
                    {
                        "id": 33113,
                        "name": "Cachorrilla",
                        "latitude": "39.91557000",
                        "longitude": "-6.66909000"
                    },
                    {
                        "id": 33114,
                        "name": "Cadalso",
                        "latitude": "40.23743000",
                        "longitude": "-6.54083000"
                    },
                    {
                        "id": 33161,
                        "name": "Calzadilla",
                        "latitude": "40.06014000",
                        "longitude": "-6.53328000"
                    },
                    {
                        "id": 33178,
                        "name": "Caminomorisco",
                        "latitude": "40.32719000",
                        "longitude": "-6.28923000"
                    },
                    {
                        "id": 33191,
                        "name": "Campillo de Deleitosa",
                        "latitude": "39.70297000",
                        "longitude": "-5.57436000"
                    },
                    {
                        "id": 151198,
                        "name": "Campo Lugar",
                        "latitude": "39.19470590",
                        "longitude": "-5.77343770"
                    },
                    {
                        "id": 33533,
                        "name": "Cañamero",
                        "latitude": "39.37995000",
                        "longitude": "-5.38857000"
                    },
                    {
                        "id": 33535,
                        "name": "Cañaveral",
                        "latitude": "39.79198000",
                        "longitude": "-6.39130000"
                    },
                    {
                        "id": 33280,
                        "name": "Carbajo",
                        "latitude": "39.60333000",
                        "longitude": "-7.19565000"
                    },
                    {
                        "id": 33289,
                        "name": "Carcaboso",
                        "latitude": "40.04968000",
                        "longitude": "-6.21375000"
                    },
                    {
                        "id": 33320,
                        "name": "Carrascalejo",
                        "latitude": "39.63333000",
                        "longitude": "-5.21667000"
                    },
                    {
                        "id": 33346,
                        "name": "Casar de Cáceres",
                        "latitude": "39.56106000",
                        "longitude": "-6.41944000"
                    },
                    {
                        "id": 33347,
                        "name": "Casar de Palomero",
                        "latitude": "40.29483000",
                        "longitude": "-6.25698000"
                    },
                    {
                        "id": 33351,
                        "name": "Casares de las Hurdes",
                        "latitude": "40.43333000",
                        "longitude": "-6.28333000"
                    },
                    {
                        "id": 33359,
                        "name": "Casas de Don Antonio",
                        "latitude": "39.23578000",
                        "longitude": "-6.29143000"
                    },
                    {
                        "id": 33360,
                        "name": "Casas de Don Gómez",
                        "latitude": "40.00932000",
                        "longitude": "-6.60073000"
                    },
                    {
                        "id": 33368,
                        "name": "Casas de Millán",
                        "latitude": "39.81757000",
                        "longitude": "-6.32966000"
                    },
                    {
                        "id": 33369,
                        "name": "Casas de Miravete",
                        "latitude": "39.72687000",
                        "longitude": "-5.74363000"
                    },
                    {
                        "id": 33374,
                        "name": "Casas del Castañar",
                        "latitude": "40.10785000",
                        "longitude": "-5.90509000"
                    },
                    {
                        "id": 33375,
                        "name": "Casas del Monte",
                        "latitude": "40.20320000",
                        "longitude": "-5.96152000"
                    },
                    {
                        "id": 33381,
                        "name": "Casatejada",
                        "latitude": "39.88642000",
                        "longitude": "-5.68193000"
                    },
                    {
                        "id": 33389,
                        "name": "Casillas de Coria",
                        "latitude": "39.96543000",
                        "longitude": "-6.63711000"
                    },
                    {
                        "id": 33397,
                        "name": "Castañar de Ibor",
                        "latitude": "39.62843000",
                        "longitude": "-5.41709000"
                    },
                    {
                        "id": 33553,
                        "name": "Ceclavín",
                        "latitude": "39.82231000",
                        "longitude": "-6.77329000"
                    },
                    {
                        "id": 33555,
                        "name": "Cedillo",
                        "latitude": "39.65099000",
                        "longitude": "-7.49817000"
                    },
                    {
                        "id": 33587,
                        "name": "Cerezo",
                        "latitude": "40.23678000",
                        "longitude": "-6.22764000"
                    },
                    {
                        "id": 33667,
                        "name": "Cilleros",
                        "latitude": "40.11486000",
                        "longitude": "-6.79256000"
                    },
                    {
                        "id": 33731,
                        "name": "Collado",
                        "latitude": "40.05729000",
                        "longitude": "-5.72052000"
                    },
                    {
                        "id": 33763,
                        "name": "Conquista de la Sierra",
                        "latitude": "39.35070000",
                        "longitude": "-5.73464000"
                    },
                    {
                        "id": 33789,
                        "name": "Coria",
                        "latitude": "39.98406000",
                        "longitude": "-6.53603000"
                    },
                    {
                        "id": 151199,
                        "name": "Cuacos de Yuste",
                        "latitude": "40.10241310",
                        "longitude": "-5.72551990"
                    },
                    {
                        "id": 151200,
                        "name": "Cumbre La",
                        "latitude": "39.40430110",
                        "longitude": "-5.97664840"
                    },
                    {
                        "id": 33923,
                        "name": "Deleitosa",
                        "latitude": "39.64359000",
                        "longitude": "-5.64576000"
                    },
                    {
                        "id": 33928,
                        "name": "Descargamaría",
                        "latitude": "40.30446000",
                        "longitude": "-6.48666000"
                    },
                    {
                        "id": 34037,
                        "name": "Eljas",
                        "latitude": "40.21648000",
                        "longitude": "-6.84616000"
                    },
                    {
                        "id": 34092,
                        "name": "Escurial",
                        "latitude": "39.16857000",
                        "longitude": "-5.88465000"
                    },
                    {
                        "id": 34251,
                        "name": "Fresnedoso de Ibor",
                        "latitude": "39.68418000",
                        "longitude": "-5.50899000"
                    },
                    {
                        "id": 34385,
                        "name": "Galisteo",
                        "latitude": "39.97642000",
                        "longitude": "-6.26782000"
                    },
                    {
                        "id": 151201,
                        "name": "Garciaz",
                        "latitude": "39.41309080",
                        "longitude": "-5.62781780"
                    },
                    {
                        "id": 151202,
                        "name": "Garganta La",
                        "latitude": "40.32889030",
                        "longitude": "-5.82285760"
                    },
                    {
                        "id": 34417,
                        "name": "Garganta la Olla",
                        "latitude": "40.11049000",
                        "longitude": "-5.77665000"
                    },
                    {
                        "id": 34418,
                        "name": "Gargantilla",
                        "latitude": "40.24835000",
                        "longitude": "-5.92068000"
                    },
                    {
                        "id": 34419,
                        "name": "Gargüera",
                        "latitude": "40.06130000",
                        "longitude": "-5.92781000"
                    },
                    {
                        "id": 151203,
                        "name": "Garrovillas de Alconétar",
                        "latitude": "39.70550990",
                        "longitude": "-6.55115600"
                    },
                    {
                        "id": 34428,
                        "name": "Garvín",
                        "latitude": "39.71984000",
                        "longitude": "-5.34678000"
                    },
                    {
                        "id": 34434,
                        "name": "Gata",
                        "latitude": "40.23758000",
                        "longitude": "-6.59684000"
                    },
                    {
                        "id": 151204,
                        "name": "Gordo El",
                        "latitude": "39.86547270",
                        "longitude": "-5.34358700"
                    },
                    {
                        "id": 151205,
                        "name": "Granja La",
                        "latitude": "40.24036100",
                        "longitude": "-5.99912280"
                    },
                    {
                        "id": 34526,
                        "name": "Guadalupe",
                        "latitude": "39.45080000",
                        "longitude": "-5.32588000"
                    },
                    {
                        "id": 34542,
                        "name": "Guijo de Coria",
                        "latitude": "40.10098000",
                        "longitude": "-6.46383000"
                    },
                    {
                        "id": 34543,
                        "name": "Guijo de Galisteo",
                        "latitude": "40.09383000",
                        "longitude": "-6.41007000"
                    },
                    {
                        "id": 34544,
                        "name": "Guijo de Granadilla",
                        "latitude": "40.19351000",
                        "longitude": "-6.16339000"
                    },
                    {
                        "id": 34545,
                        "name": "Guijo de Santa Bárbara",
                        "latitude": "40.15410000",
                        "longitude": "-5.65414000"
                    },
                    {
                        "id": 34582,
                        "name": "Herguijuela",
                        "latitude": "39.37452000",
                        "longitude": "-5.76001000"
                    },
                    {
                        "id": 34591,
                        "name": "Hernán-Pérez",
                        "latitude": "40.21246000",
                        "longitude": "-6.46479000"
                    },
                    {
                        "id": 34594,
                        "name": "Herrera de Alcántara",
                        "latitude": "39.63865000",
                        "longitude": "-7.40619000"
                    },
                    {
                        "id": 151206,
                        "name": "Herreruela",
                        "latitude": "39.42928500",
                        "longitude": "-6.85654270"
                    },
                    {
                        "id": 34604,
                        "name": "Hervás",
                        "latitude": "40.27081000",
                        "longitude": "-5.86721000"
                    },
                    {
                        "id": 34607,
                        "name": "Higuera",
                        "latitude": "39.72551000",
                        "longitude": "-5.66692000"
                    },
                    {
                        "id": 34619,
                        "name": "Hinojal",
                        "latitude": "39.70900000",
                        "longitude": "-6.35567000"
                    },
                    {
                        "id": 34631,
                        "name": "Holguera",
                        "latitude": "39.89916000",
                        "longitude": "-6.34999000"
                    },
                    {
                        "id": 34677,
                        "name": "Hoyos",
                        "latitude": "40.17154000",
                        "longitude": "-6.72092000"
                    },
                    {
                        "id": 34707,
                        "name": "Huélaga",
                        "latitude": "40.05582000",
                        "longitude": "-6.61568000"
                    },
                    {
                        "id": 34723,
                        "name": "Ibahernando",
                        "latitude": "39.32538000",
                        "longitude": "-5.91833000"
                    },
                    {
                        "id": 34798,
                        "name": "Jaraicejo",
                        "latitude": "39.66624000",
                        "longitude": "-5.81308000"
                    },
                    {
                        "id": 34802,
                        "name": "Jaraíz de la Vera",
                        "latitude": "40.06005000",
                        "longitude": "-5.75426000"
                    },
                    {
                        "id": 34801,
                        "name": "Jarandilla de la Vera",
                        "latitude": "40.12915000",
                        "longitude": "-5.66079000"
                    },
                    {
                        "id": 151207,
                        "name": "Jarilla",
                        "latitude": "40.17169510",
                        "longitude": "-6.00275910"
                    },
                    {
                        "id": 34814,
                        "name": "Jerte",
                        "latitude": "40.22271000",
                        "longitude": "-5.75011000"
                    },
                    {
                        "id": 34938,
                        "name": "Ladrillar",
                        "latitude": "40.46576000",
                        "longitude": "-6.22427000"
                    },
                    {
                        "id": 35100,
                        "name": "Logrosán",
                        "latitude": "39.33641000",
                        "longitude": "-5.49281000"
                    },
                    {
                        "id": 35141,
                        "name": "Losar de la Vera",
                        "latitude": "40.12158000",
                        "longitude": "-5.60454000"
                    },
                    {
                        "id": 35189,
                        "name": "Madrigal de la Vera",
                        "latitude": "40.14760000",
                        "longitude": "-5.36818000"
                    },
                    {
                        "id": 35192,
                        "name": "Madrigalejo",
                        "latitude": "39.13858000",
                        "longitude": "-5.62740000"
                    },
                    {
                        "id": 35196,
                        "name": "Madroñera",
                        "latitude": "39.42526000",
                        "longitude": "-5.75568000"
                    },
                    {
                        "id": 35215,
                        "name": "Majadas",
                        "latitude": "39.94291000",
                        "longitude": "-5.74589000"
                    },
                    {
                        "id": 35227,
                        "name": "Malpartida de Cáceres",
                        "latitude": "39.44664000",
                        "longitude": "-6.50760000"
                    },
                    {
                        "id": 35228,
                        "name": "Malpartida de Plasencia",
                        "latitude": "39.97962000",
                        "longitude": "-6.04609000"
                    },
                    {
                        "id": 35282,
                        "name": "Marchagaz",
                        "latitude": "40.26769000",
                        "longitude": "-6.27485000"
                    },
                    {
                        "id": 35329,
                        "name": "Mata de Alcántara",
                        "latitude": "39.71738000",
                        "longitude": "-6.81825000"
                    },
                    {
                        "id": 151208,
                        "name": "Membrío",
                        "latitude": "39.52681120",
                        "longitude": "-7.05430500"
                    },
                    {
                        "id": 35408,
                        "name": "Mesas de Ibor",
                        "latitude": "39.75587000",
                        "longitude": "-5.54637000"
                    },
                    {
                        "id": 35416,
                        "name": "Miajadas",
                        "latitude": "39.15127000",
                        "longitude": "-5.90841000"
                    },
                    {
                        "id": 35431,
                        "name": "Millanes",
                        "latitude": "39.84917000",
                        "longitude": "-5.58079000"
                    },
                    {
                        "id": 35440,
                        "name": "Mirabel",
                        "latitude": "39.86230000",
                        "longitude": "-6.23274000"
                    },
                    {
                        "id": 151209,
                        "name": "Mohedas de Granadilla",
                        "latitude": "40.26913720",
                        "longitude": "-6.20176490"
                    },
                    {
                        "id": 151210,
                        "name": "Monroy",
                        "latitude": "39.63618630",
                        "longitude": "-6.21038870"
                    },
                    {
                        "id": 35588,
                        "name": "Montánchez",
                        "latitude": "39.22548000",
                        "longitude": "-6.14914000"
                    },
                    {
                        "id": 35549,
                        "name": "Montehermoso",
                        "latitude": "40.08796000",
                        "longitude": "-6.34984000"
                    },
                    {
                        "id": 35601,
                        "name": "Moraleja",
                        "latitude": "40.06682000",
                        "longitude": "-6.65983000"
                    },
                    {
                        "id": 35622,
                        "name": "Morcillo",
                        "latitude": "40.01884000",
                        "longitude": "-6.39746000"
                    },
                    {
                        "id": 35732,
                        "name": "Navaconcejo",
                        "latitude": "40.17712000",
                        "longitude": "-5.83108000"
                    },
                    {
                        "id": 35752,
                        "name": "Navalmoral de la Mata",
                        "latitude": "39.89158000",
                        "longitude": "-5.54064000"
                    },
                    {
                        "id": 35760,
                        "name": "Navalvillar de Ibor",
                        "latitude": "39.58389000",
                        "longitude": "-5.41328000"
                    },
                    {
                        "id": 35782,
                        "name": "Navas del Madroño",
                        "latitude": "39.62290000",
                        "longitude": "-6.65260000"
                    },
                    {
                        "id": 35789,
                        "name": "Navezuelas",
                        "latitude": "39.50918000",
                        "longitude": "-5.43766000"
                    },
                    {
                        "id": 35841,
                        "name": "Nuñomoral",
                        "latitude": "40.40692000",
                        "longitude": "-6.24636000"
                    },
                    {
                        "id": 35886,
                        "name": "Oliva de Plasencia",
                        "latitude": "40.11227000",
                        "longitude": "-6.08648000"
                    },
                    {
                        "id": 36040,
                        "name": "Palomero",
                        "latitude": "40.24688000",
                        "longitude": "-6.27706000"
                    },
                    {
                        "id": 151211,
                        "name": "Pasarón de la Vera",
                        "latitude": "40.05115990",
                        "longitude": "-5.82022080"
                    },
                    {
                        "id": 36113,
                        "name": "Pedroso de Acim",
                        "latitude": "39.82522000",
                        "longitude": "-6.41251000"
                    },
                    {
                        "id": 36133,
                        "name": "Peraleda de la Mata",
                        "latitude": "39.85288000",
                        "longitude": "-5.46065000"
                    },
                    {
                        "id": 36132,
                        "name": "Peraleda de San Román",
                        "latitude": "39.74130000",
                        "longitude": "-5.38726000"
                    },
                    {
                        "id": 36141,
                        "name": "Perales del Puerto",
                        "latitude": "40.15596000",
                        "longitude": "-6.68192000"
                    },
                    {
                        "id": 36154,
                        "name": "Pescueza",
                        "latitude": "39.91807000",
                        "longitude": "-6.64589000"
                    },
                    {
                        "id": 151212,
                        "name": "Pesga La",
                        "latitude": "40.32510150",
                        "longitude": "-6.17478250"
                    },
                    {
                        "id": 36184,
                        "name": "Piedras Albas",
                        "latitude": "39.78417000",
                        "longitude": "-6.92588000"
                    },
                    {
                        "id": 36210,
                        "name": "Pinofranqueado",
                        "latitude": "40.30351000",
                        "longitude": "-6.33181000"
                    },
                    {
                        "id": 36216,
                        "name": "Piornal",
                        "latitude": "40.11731000",
                        "longitude": "-5.84787000"
                    },
                    {
                        "id": 36236,
                        "name": "Plasencia",
                        "latitude": "40.03116000",
                        "longitude": "-6.08845000"
                    },
                    {
                        "id": 36238,
                        "name": "Plasenzuela",
                        "latitude": "39.38194000",
                        "longitude": "-6.04786000"
                    },
                    {
                        "id": 36285,
                        "name": "Portaje",
                        "latitude": "39.91757000",
                        "longitude": "-6.56218000"
                    },
                    {
                        "id": 36289,
                        "name": "Portezuelo",
                        "latitude": "39.81233000",
                        "longitude": "-6.47433000"
                    },
                    {
                        "id": 36335,
                        "name": "Pozuelo de Zarzón",
                        "latitude": "40.14805000",
                        "longitude": "-6.41458000"
                    },
                    {
                        "id": 36453,
                        "name": "Puerto de Santa Cruz",
                        "latitude": "39.31631000",
                        "longitude": "-5.85875000"
                    },
                    {
                        "id": 36717,
                        "name": "Ríolobos",
                        "latitude": "39.92074000",
                        "longitude": "-6.30397000"
                    },
                    {
                        "id": 36648,
                        "name": "Robledillo de Gata",
                        "latitude": "40.32234000",
                        "longitude": "-6.47129000"
                    },
                    {
                        "id": 36652,
                        "name": "Robledillo de la Vera",
                        "latitude": "40.10093000",
                        "longitude": "-5.58896000"
                    },
                    {
                        "id": 36650,
                        "name": "Robledillo de Trujillo",
                        "latitude": "39.26956000",
                        "longitude": "-5.98001000"
                    },
                    {
                        "id": 36656,
                        "name": "Robledollano",
                        "latitude": "39.60962000",
                        "longitude": "-5.50855000"
                    },
                    {
                        "id": 36669,
                        "name": "Romangordo",
                        "latitude": "39.74199000",
                        "longitude": "-5.70081000"
                    },
                    {
                        "id": 36677,
                        "name": "Rosalejo",
                        "latitude": "39.43660000",
                        "longitude": "-4.90821000"
                    },
                    {
                        "id": 36687,
                        "name": "Ruanes",
                        "latitude": "39.32814000",
                        "longitude": "-6.01347000"
                    },
                    {
                        "id": 36776,
                        "name": "Salorino",
                        "latitude": "39.48018000",
                        "longitude": "-7.00758000"
                    },
                    {
                        "id": 36786,
                        "name": "Salvatierra de Santiago",
                        "latitude": "39.30363000",
                        "longitude": "-6.03206000"
                    },
                    {
                        "id": 36868,
                        "name": "San Martín de Trevejo",
                        "latitude": "40.21241000",
                        "longitude": "-6.79535000"
                    },
                    {
                        "id": 37004,
                        "name": "Santa Ana",
                        "latitude": "39.30823000",
                        "longitude": "-5.99027000"
                    },
                    {
                        "id": 37041,
                        "name": "Santa Cruz de la Sierra",
                        "latitude": "39.33635000",
                        "longitude": "-5.84561000"
                    },
                    {
                        "id": 37034,
                        "name": "Santa Cruz de Paniagua",
                        "latitude": "40.19167000",
                        "longitude": "-6.34003000"
                    },
                    {
                        "id": 37070,
                        "name": "Santa Marta de Magasca",
                        "latitude": "39.51150000",
                        "longitude": "-6.09881000"
                    },
                    {
                        "id": 151214,
                        "name": "Santiago de Alcántara",
                        "latitude": "39.60591530",
                        "longitude": "-7.24303640"
                    },
                    {
                        "id": 37117,
                        "name": "Santiago del Campo",
                        "latitude": "39.62840000",
                        "longitude": "-6.36362000"
                    },
                    {
                        "id": 37128,
                        "name": "Santibáñez el Alto",
                        "latitude": "40.18525000",
                        "longitude": "-6.54782000"
                    },
                    {
                        "id": 37129,
                        "name": "Santibáñez el Bajo",
                        "latitude": "40.17637000",
                        "longitude": "-6.22441000"
                    },
                    {
                        "id": 37177,
                        "name": "Saucedilla",
                        "latitude": "39.85284000",
                        "longitude": "-5.67781000"
                    },
                    {
                        "id": 37196,
                        "name": "Segura de Toro",
                        "latitude": "40.22427000",
                        "longitude": "-5.94836000"
                    },
                    {
                        "id": 37221,
                        "name": "Serradilla",
                        "latitude": "39.82920000",
                        "longitude": "-6.14034000"
                    },
                    {
                        "id": 37226,
                        "name": "Serrejón",
                        "latitude": "39.81735000",
                        "longitude": "-5.80263000"
                    },
                    {
                        "id": 37244,
                        "name": "Sierra de Fuentes",
                        "latitude": "39.43997000",
                        "longitude": "-6.27242000"
                    },
                    {
                        "id": 37359,
                        "name": "Talaván",
                        "latitude": "39.71715000",
                        "longitude": "-6.28146000"
                    },
                    {
                        "id": 151215,
                        "name": "Talaveruela de la Vera",
                        "latitude": "40.12067660",
                        "longitude": "-5.52170700"
                    },
                    {
                        "id": 37360,
                        "name": "Talayuela",
                        "latitude": "39.98701000",
                        "longitude": "-5.60982000"
                    },
                    {
                        "id": 37398,
                        "name": "Tejeda de Tiétar",
                        "latitude": "40.01790000",
                        "longitude": "-5.86953000"
                    },
                    {
                        "id": 37466,
                        "name": "Toril",
                        "latitude": "39.89749000",
                        "longitude": "-5.77950000"
                    },
                    {
                        "id": 37474,
                        "name": "Tornavacas",
                        "latitude": "40.25498000",
                        "longitude": "-5.68876000"
                    },
                    {
                        "id": 151216,
                        "name": "Torno El",
                        "latitude": "40.13560780",
                        "longitude": "-5.94481840"
                    },
                    {
                        "id": 37491,
                        "name": "Torre de Don Miguel",
                        "latitude": "40.22333000",
                        "longitude": "-6.57686000"
                    },
                    {
                        "id": 37496,
                        "name": "Torre de Santa María",
                        "latitude": "39.25441000",
                        "longitude": "-6.11610000"
                    },
                    {
                        "id": 37520,
                        "name": "Torrecilla de los Ángeles",
                        "latitude": "40.24788000",
                        "longitude": "-6.41606000"
                    },
                    {
                        "id": 37526,
                        "name": "Torrecillas de la Tiesa",
                        "latitude": "39.56837000",
                        "longitude": "-5.74238000"
                    },
                    {
                        "id": 37542,
                        "name": "Torrejón el Rubio",
                        "latitude": "39.77068000",
                        "longitude": "-6.01260000"
                    },
                    {
                        "id": 37536,
                        "name": "Torrejoncillo",
                        "latitude": "39.89675000",
                        "longitude": "-6.46712000"
                    },
                    {
                        "id": 37554,
                        "name": "Torremenga",
                        "latitude": "40.04658000",
                        "longitude": "-5.77471000"
                    },
                    {
                        "id": 37555,
                        "name": "Torremocha",
                        "latitude": "39.34565000",
                        "longitude": "-6.17335000"
                    },
                    {
                        "id": 37568,
                        "name": "Torreorgaz",
                        "latitude": "39.38310000",
                        "longitude": "-6.24941000"
                    },
                    {
                        "id": 37570,
                        "name": "Torrequemada",
                        "latitude": "39.36664000",
                        "longitude": "-6.22052000"
                    },
                    {
                        "id": 37645,
                        "name": "Trujillo",
                        "latitude": "39.45786000",
                        "longitude": "-5.88203000"
                    },
                    {
                        "id": 37728,
                        "name": "Valdastillas",
                        "latitude": "40.13293000",
                        "longitude": "-5.87932000"
                    },
                    {
                        "id": 37740,
                        "name": "Valdecañas de Tajo",
                        "latitude": "39.75919000",
                        "longitude": "-5.61951000"
                    },
                    {
                        "id": 37745,
                        "name": "Valdefuentes",
                        "latitude": "39.27433000",
                        "longitude": "-6.12183000"
                    },
                    {
                        "id": 37752,
                        "name": "Valdehúncar",
                        "latitude": "39.83659000",
                        "longitude": "-5.52307000"
                    },
                    {
                        "id": 37755,
                        "name": "Valdelacasa de Tajo",
                        "latitude": "39.72588000",
                        "longitude": "-5.28296000"
                    },
                    {
                        "id": 37771,
                        "name": "Valdemorales",
                        "latitude": "39.20588000",
                        "longitude": "-6.06622000"
                    },
                    {
                        "id": 37778,
                        "name": "Valdeobispo",
                        "latitude": "40.08297000",
                        "longitude": "-6.24757000"
                    },
                    {
                        "id": 37817,
                        "name": "Valencia de Alcántara",
                        "latitude": "39.41148000",
                        "longitude": "-7.24435000"
                    },
                    {
                        "id": 37890,
                        "name": "Valverde de la Vera",
                        "latitude": "40.12268000",
                        "longitude": "-5.49541000"
                    },
                    {
                        "id": 37894,
                        "name": "Valverde del Fresno",
                        "latitude": "40.22210000",
                        "longitude": "-6.87848000"
                    },
                    {
                        "id": 151217,
                        "name": "Vegaviana",
                        "latitude": "40.04149230",
                        "longitude": "-6.71862830"
                    },
                    {
                        "id": 37960,
                        "name": "Viandar de la Vera",
                        "latitude": "40.12191000",
                        "longitude": "-5.53593000"
                    },
                    {
                        "id": 38011,
                        "name": "Villa del Campo",
                        "latitude": "40.14223000",
                        "longitude": "-6.42679000"
                    },
                    {
                        "id": 38013,
                        "name": "Villa del Rey",
                        "latitude": "39.65955000",
                        "longitude": "-6.82122000"
                    },
                    {
                        "id": 38153,
                        "name": "Villamesías",
                        "latitude": "39.24568000",
                        "longitude": "-5.87307000"
                    },
                    {
                        "id": 38154,
                        "name": "Villamiel",
                        "latitude": "40.18635000",
                        "longitude": "-6.78425000"
                    },
                    {
                        "id": 38202,
                        "name": "Villanueva de la Sierra",
                        "latitude": "40.20163000",
                        "longitude": "-6.40611000"
                    },
                    {
                        "id": 38204,
                        "name": "Villanueva de la Vera",
                        "latitude": "40.12998000",
                        "longitude": "-5.46250000"
                    },
                    {
                        "id": 38243,
                        "name": "Villar de Plasencia",
                        "latitude": "40.13773000",
                        "longitude": "-6.02790000"
                    },
                    {
                        "id": 38258,
                        "name": "Villar del Pedroso",
                        "latitude": "39.70631000",
                        "longitude": "-5.19583000"
                    },
                    {
                        "id": 38316,
                        "name": "Villasbuenas de Gata",
                        "latitude": "40.17879000",
                        "longitude": "-6.62641000"
                    },
                    {
                        "id": 38478,
                        "name": "Zarza de Granadilla",
                        "latitude": "40.23723000",
                        "longitude": "-6.04850000"
                    },
                    {
                        "id": 38479,
                        "name": "Zarza de Montánchez",
                        "latitude": "39.25756000",
                        "longitude": "-6.03248000"
                    },
                    {
                        "id": 38481,
                        "name": "Zarza la Mayor",
                        "latitude": "39.87692000",
                        "longitude": "-6.86211000"
                    },
                    {
                        "id": 38495,
                        "name": "Zorita",
                        "latitude": "39.28522000",
                        "longitude": "-5.69973000"
                    }
                ]
            },
            {
                "id": 5096,
                "name": "Cádiz",
                "iso2": "CA",
                "latitude": "36.52133490",
                "longitude": "-7.09588110",
                "type": "province",
                "cities": [
                    {
                        "id": 32076,
                        "name": "Alcalá de los Gazules",
                        "latitude": "36.46212000",
                        "longitude": "-5.72382000"
                    },
                    {
                        "id": 32080,
                        "name": "Alcalá del Valle",
                        "latitude": "36.90448000",
                        "longitude": "-5.17240000"
                    },
                    {
                        "id": 32210,
                        "name": "Algar",
                        "latitude": "36.65748000",
                        "longitude": "-5.65558000"
                    },
                    {
                        "id": 32216,
                        "name": "Algeciras",
                        "latitude": "36.13326000",
                        "longitude": "-5.45051000"
                    },
                    {
                        "id": 32223,
                        "name": "Algodonales",
                        "latitude": "36.88044000",
                        "longitude": "-5.40536000"
                    },
                    {
                        "id": 32437,
                        "name": "Arcos de la Frontera",
                        "latitude": "36.75075000",
                        "longitude": "-5.81056000"
                    },
                    {
                        "id": 32646,
                        "name": "Barbate",
                        "latitude": "36.19237000",
                        "longitude": "-5.92186000"
                    },
                    {
                        "id": 151361,
                        "name": "Barrios Los",
                        "latitude": "36.18506450",
                        "longitude": "-5.49255730"
                    },
                    {
                        "id": 32766,
                        "name": "Benalup-Casas Viejas",
                        "latitude": "36.34375000",
                        "longitude": "-5.81280000"
                    },
                    {
                        "id": 32773,
                        "name": "Benaocaz",
                        "latitude": "36.70069000",
                        "longitude": "-5.42222000"
                    },
                    {
                        "id": 32957,
                        "name": "Bornos",
                        "latitude": "36.81677000",
                        "longitude": "-5.74448000"
                    },
                    {
                        "id": 151362,
                        "name": "Bosque El",
                        "latitude": "36.75800420",
                        "longitude": "-5.50617880"
                    },
                    {
                        "id": 33117,
                        "name": "Cadiz",
                        "latitude": "36.52672000",
                        "longitude": "-6.28910000"
                    },
                    {
                        "id": 33420,
                        "name": "Castellar de la Frontera",
                        "latitude": "36.31736000",
                        "longitude": "-5.45407000"
                    },
                    {
                        "id": 33631,
                        "name": "Chiclana de la Frontera",
                        "latitude": "36.41976000",
                        "longitude": "-6.14367000"
                    },
                    {
                        "id": 33641,
                        "name": "Chipiona",
                        "latitude": "36.73663000",
                        "longitude": "-6.43703000"
                    },
                    {
                        "id": 33761,
                        "name": "Conil de la Frontera",
                        "latitude": "36.27719000",
                        "longitude": "-6.08850000"
                    },
                    {
                        "id": 34115,
                        "name": "Espera",
                        "latitude": "36.87446000",
                        "longitude": "-5.80600000"
                    },
                    {
                        "id": 151363,
                        "name": "Gastor El",
                        "latitude": "36.85602900",
                        "longitude": "-5.32266770"
                    },
                    {
                        "id": 34507,
                        "name": "Grazalema",
                        "latitude": "36.76018000",
                        "longitude": "-5.36839000"
                    },
                    {
                        "id": 34812,
                        "name": "Jerez de la Frontera",
                        "latitude": "36.68645000",
                        "longitude": "-6.13606000"
                    },
                    {
                        "id": 34817,
                        "name": "Jimena de la Frontera",
                        "latitude": "36.43517000",
                        "longitude": "-5.45387000"
                    },
                    {
                        "id": 151364,
                        "name": "Línea de la Concepción La",
                        "latitude": "36.16825630",
                        "longitude": "-5.34947190"
                    },
                    {
                        "id": 151365,
                        "name": "Medina-Sidonia",
                        "latitude": "36.46196440",
                        "longitude": "-5.92921310"
                    },
                    {
                        "id": 35917,
                        "name": "Olvera",
                        "latitude": "36.93418000",
                        "longitude": "-5.26678000"
                    },
                    {
                        "id": 36078,
                        "name": "Paterna de Rivera",
                        "latitude": "36.52246000",
                        "longitude": "-5.86578000"
                    },
                    {
                        "id": 36346,
                        "name": "Prado del Rey",
                        "latitude": "36.78756000",
                        "longitude": "-5.55589000"
                    },
                    {
                        "id": 151366,
                        "name": "Puerto de Santa María El",
                        "latitude": "36.63932810",
                        "longitude": "-6.25883690"
                    },
                    {
                        "id": 36447,
                        "name": "Puerto Real",
                        "latitude": "36.52819000",
                        "longitude": "-6.19011000"
                    },
                    {
                        "id": 36450,
                        "name": "Puerto Serrano",
                        "latitude": "36.92209000",
                        "longitude": "-5.54304000"
                    },
                    {
                        "id": 36680,
                        "name": "Rota",
                        "latitude": "36.62545000",
                        "longitude": "-6.36220000"
                    },
                    {
                        "id": 36835,
                        "name": "San Fernando",
                        "latitude": "36.47590000",
                        "longitude": "-6.19817000"
                    },
                    {
                        "id": 36842,
                        "name": "San José del Valle",
                        "latitude": "36.60554000",
                        "longitude": "-5.79895000"
                    },
                    {
                        "id": 36919,
                        "name": "San Roque",
                        "latitude": "36.21067000",
                        "longitude": "-5.38415000"
                    },
                    {
                        "id": 36947,
                        "name": "Sanlúcar de Barrameda",
                        "latitude": "36.77808000",
                        "longitude": "-6.35150000"
                    },
                    {
                        "id": 37236,
                        "name": "Setenil de las Bodegas",
                        "latitude": "36.86397000",
                        "longitude": "-5.18177000"
                    },
                    {
                        "id": 37381,
                        "name": "Tarifa",
                        "latitude": "36.01393000",
                        "longitude": "-5.60695000"
                    },
                    {
                        "id": 37487,
                        "name": "Torre Alháquime",
                        "latitude": "36.91588000",
                        "longitude": "-5.23381000"
                    },
                    {
                        "id": 37625,
                        "name": "Trebujena",
                        "latitude": "36.87075000",
                        "longitude": "-6.17586000"
                    },
                    {
                        "id": 37670,
                        "name": "Ubrique",
                        "latitude": "36.67777000",
                        "longitude": "-5.44600000"
                    },
                    {
                        "id": 37921,
                        "name": "Vejer de la Frontera",
                        "latitude": "36.25213000",
                        "longitude": "-5.96717000"
                    },
                    {
                        "id": 38124,
                        "name": "Villaluenga del Rosario",
                        "latitude": "36.69644000",
                        "longitude": "-5.38601000"
                    },
                    {
                        "id": 38136,
                        "name": "Villamartín",
                        "latitude": "36.85979000",
                        "longitude": "-5.64485000"
                    },
                    {
                        "id": 38454,
                        "name": "Zahara",
                        "latitude": "36.84055000",
                        "longitude": "-5.39128000"
                    }
                ]
            },
            {
                "id": 5222,
                "name": "Canary Islands",
                "iso2": "CN",
                "latitude": "28.29160000",
                "longitude": "16.62910000",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5328,
                "name": "Cantabria",
                "iso2": "CB",
                "latitude": "43.13497280",
                "longitude": "-4.66145180",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 1170,
                "name": "Cantabria",
                "iso2": "S",
                "latitude": "43.18283960",
                "longitude": "-3.98784270",
                "type": "province",
                "cities": [
                    {
                        "id": 152842,
                        "name": "Alfoz de Lloredo",
                        "latitude": "43.37858300",
                        "longitude": "-4.18209610"
                    },
                    {
                        "id": 32360,
                        "name": "Ampuero",
                        "latitude": "43.34268000",
                        "longitude": "-3.41667000"
                    },
                    {
                        "id": 152843,
                        "name": "Anievas",
                        "latitude": "43.19215360",
                        "longitude": "-3.99804850"
                    },
                    {
                        "id": 32445,
                        "name": "Arenas de Iguña",
                        "latitude": "43.18293000",
                        "longitude": "-4.04729000"
                    },
                    {
                        "id": 32472,
                        "name": "Argoños",
                        "latitude": "43.45740000",
                        "longitude": "-3.49013000"
                    },
                    {
                        "id": 32495,
                        "name": "Arnuero",
                        "latitude": "43.47756000",
                        "longitude": "-3.56959000"
                    },
                    {
                        "id": 32505,
                        "name": "Arredondo",
                        "latitude": "43.27325000",
                        "longitude": "-3.60031000"
                    },
                    {
                        "id": 152844,
                        "name": "Astillero El",
                        "latitude": "43.39837340",
                        "longitude": "-3.82228100"
                    },
                    {
                        "id": 33053,
                        "name": "Bárcena de Cicero",
                        "latitude": "43.42160000",
                        "longitude": "-3.51030000"
                    },
                    {
                        "id": 33054,
                        "name": "Bárcena de Pie de Concha",
                        "latitude": "43.12580000",
                        "longitude": "-4.05662000"
                    },
                    {
                        "id": 32661,
                        "name": "Bareyo",
                        "latitude": "43.46686000",
                        "longitude": "-3.60083000"
                    },
                    {
                        "id": 33094,
                        "name": "Cabezón de la Sal",
                        "latitude": "43.30824000",
                        "longitude": "-4.23571000"
                    },
                    {
                        "id": 33092,
                        "name": "Cabezón de Liébana",
                        "latitude": "43.13437000",
                        "longitude": "-4.57630000"
                    },
                    {
                        "id": 152845,
                        "name": "Cabuérniga",
                        "latitude": "43.21968840",
                        "longitude": "-4.30515420"
                    },
                    {
                        "id": 152846,
                        "name": "Camaleño",
                        "latitude": "43.15119400",
                        "longitude": "-4.69372680"
                    },
                    {
                        "id": 33167,
                        "name": "Camargo",
                        "latitude": "43.40744000",
                        "longitude": "-3.88498000"
                    },
                    {
                        "id": 152852,
                        "name": "Campoo de Enmedio",
                        "latitude": "42.99480450",
                        "longitude": "-4.10021700"
                    },
                    {
                        "id": 152847,
                        "name": "Campoo de Yuso",
                        "latitude": "43.01604790",
                        "longitude": "-4.00507840"
                    },
                    {
                        "id": 33340,
                        "name": "Cartes",
                        "latitude": "43.32596000",
                        "longitude": "-4.06893000"
                    },
                    {
                        "id": 152848,
                        "name": "Castañeda",
                        "latitude": "43.31016110",
                        "longitude": "-3.93684390"
                    },
                    {
                        "id": 33492,
                        "name": "Castro-Urdiales",
                        "latitude": "43.38285000",
                        "longitude": "-3.22043000"
                    },
                    {
                        "id": 152849,
                        "name": "Cillorigo de Liébana",
                        "latitude": "43.20766610",
                        "longitude": "-4.61404810"
                    },
                    {
                        "id": 33728,
                        "name": "Colindres",
                        "latitude": "43.39667000",
                        "longitude": "-3.45361000"
                    },
                    {
                        "id": 33753,
                        "name": "Comillas",
                        "latitude": "43.38603000",
                        "longitude": "-4.29162000"
                    },
                    {
                        "id": 152850,
                        "name": "Corrales de Buelna Los",
                        "latitude": "43.25977610",
                        "longitude": "-4.06699020"
                    },
                    {
                        "id": 152851,
                        "name": "Corvera de Toranzo",
                        "latitude": "43.21290310",
                        "longitude": "-3.95723740"
                    },
                    {
                        "id": 33978,
                        "name": "El Astillero",
                        "latitude": "43.40094000",
                        "longitude": "-3.82051000"
                    },
                    {
                        "id": 152853,
                        "name": "Entrambasaguas",
                        "latitude": "43.37560360",
                        "longitude": "-3.67671290"
                    },
                    {
                        "id": 34076,
                        "name": "Escalante",
                        "latitude": "43.43678000",
                        "longitude": "-3.51347000"
                    },
                    {
                        "id": 152854,
                        "name": "Guriezo",
                        "latitude": "43.33936760",
                        "longitude": "-3.31874700"
                    },
                    {
                        "id": 34575,
                        "name": "Hazas de Cesto",
                        "latitude": "43.39653000",
                        "longitude": "-3.58916000"
                    },
                    {
                        "id": 152855,
                        "name": "Hermandad de Campoo de Suso",
                        "latitude": "43.03771220",
                        "longitude": "-4.25384520"
                    },
                    {
                        "id": 152856,
                        "name": "Herrerías",
                        "latitude": "43.30990390",
                        "longitude": "-4.46967650"
                    },
                    {
                        "id": 152857,
                        "name": "Lamasón",
                        "latitude": "43.22183930",
                        "longitude": "-4.50058080"
                    },
                    {
                        "id": 34976,
                        "name": "Laredo",
                        "latitude": "43.40980000",
                        "longitude": "-3.41613000"
                    },
                    {
                        "id": 152858,
                        "name": "Liendo",
                        "latitude": "43.39766480",
                        "longitude": "-3.37510980"
                    },
                    {
                        "id": 152859,
                        "name": "Liérganes",
                        "latitude": "43.34296420",
                        "longitude": "-3.74465800"
                    },
                    {
                        "id": 35051,
                        "name": "Limpias",
                        "latitude": "43.36402000",
                        "longitude": "-3.41778000"
                    },
                    {
                        "id": 35120,
                        "name": "Los Corrales de Buelna",
                        "latitude": "43.26358000",
                        "longitude": "-4.07262000"
                    },
                    {
                        "id": 152860,
                        "name": "Luena",
                        "latitude": "43.09888540",
                        "longitude": "-3.89608110"
                    },
                    {
                        "id": 35172,
                        "name": "Luzmela",
                        "latitude": "43.29685000",
                        "longitude": "-4.20884000"
                    },
                    {
                        "id": 152861,
                        "name": "Marina de Cudeyo",
                        "latitude": "43.41334100",
                        "longitude": "-3.73335370"
                    },
                    {
                        "id": 35337,
                        "name": "Mataporquera",
                        "latitude": "42.87486000",
                        "longitude": "-4.16276000"
                    },
                    {
                        "id": 152862,
                        "name": "Mazcuerras",
                        "latitude": "43.29750570",
                        "longitude": "-4.20998480"
                    },
                    {
                        "id": 152863,
                        "name": "Medio Cudeyo",
                        "latitude": "43.38614360",
                        "longitude": "-3.74334970"
                    },
                    {
                        "id": 152864,
                        "name": "Meruelo",
                        "latitude": "43.43712940",
                        "longitude": "-3.59139390"
                    },
                    {
                        "id": 35421,
                        "name": "Miengo",
                        "latitude": "43.42861000",
                        "longitude": "-3.99866000"
                    },
                    {
                        "id": 152865,
                        "name": "Miera",
                        "latitude": "43.27902870",
                        "longitude": "-3.71304930"
                    },
                    {
                        "id": 35485,
                        "name": "Molledo",
                        "latitude": "43.14974000",
                        "longitude": "-4.04239000"
                    },
                    {
                        "id": 35820,
                        "name": "Noja",
                        "latitude": "43.48917000",
                        "longitude": "-3.52306000"
                    },
                    {
                        "id": 36127,
                        "name": "Penagos",
                        "latitude": "43.35216000",
                        "longitude": "-3.81382000"
                    },
                    {
                        "id": 152866,
                        "name": "Peñarrubia",
                        "latitude": "43.25718930",
                        "longitude": "-4.58307890"
                    },
                    {
                        "id": 152867,
                        "name": "Pesaguero",
                        "latitude": "43.07615750",
                        "longitude": "-4.54361580"
                    },
                    {
                        "id": 36155,
                        "name": "Pesquera",
                        "latitude": "43.08223000",
                        "longitude": "-4.07932000"
                    },
                    {
                        "id": 152868,
                        "name": "Piélagos",
                        "latitude": "43.38727190",
                        "longitude": "-3.93684390"
                    },
                    {
                        "id": 152869,
                        "name": "Polaciones",
                        "latitude": "43.10900440",
                        "longitude": "-4.41820890"
                    },
                    {
                        "id": 36257,
                        "name": "Polanco",
                        "latitude": "43.38524000",
                        "longitude": "-4.01642000"
                    },
                    {
                        "id": 36304,
                        "name": "Potes",
                        "latitude": "43.15457000",
                        "longitude": "-4.62055000"
                    },
                    {
                        "id": 36365,
                        "name": "Provincia de Cantabria",
                        "latitude": "43.16667000",
                        "longitude": "-4.00000000"
                    },
                    {
                        "id": 36434,
                        "name": "Puente Viesgo",
                        "latitude": "43.29815000",
                        "longitude": "-3.96817000"
                    },
                    {
                        "id": 36544,
                        "name": "Ramales de la Victoria",
                        "latitude": "43.25720000",
                        "longitude": "-3.46516000"
                    },
                    {
                        "id": 36548,
                        "name": "Rasines",
                        "latitude": "43.30505000",
                        "longitude": "-3.42919000"
                    },
                    {
                        "id": 36568,
                        "name": "Reinosa",
                        "latitude": "42.99959000",
                        "longitude": "-4.13801000"
                    },
                    {
                        "id": 36580,
                        "name": "Reocín",
                        "latitude": "43.33915000",
                        "longitude": "-4.09403000"
                    },
                    {
                        "id": 152870,
                        "name": "Ribamontán al Mar",
                        "latitude": "43.45315290",
                        "longitude": "-3.69275310"
                    },
                    {
                        "id": 152871,
                        "name": "Ribamontán al Monte",
                        "latitude": "43.40665010",
                        "longitude": "-3.64204800"
                    },
                    {
                        "id": 152872,
                        "name": "Rionansa",
                        "latitude": "43.22504510",
                        "longitude": "-4.41820890"
                    },
                    {
                        "id": 152873,
                        "name": "Riotuerto",
                        "latitude": "43.33757410",
                        "longitude": "-3.69275310"
                    },
                    {
                        "id": 152874,
                        "name": "Rozas de Valdearroyo Las",
                        "latitude": "42.97235120",
                        "longitude": "-4.03186960"
                    },
                    {
                        "id": 36699,
                        "name": "Ruente",
                        "latitude": "43.25826000",
                        "longitude": "-4.26791000"
                    },
                    {
                        "id": 152875,
                        "name": "Ruiloba",
                        "latitude": "43.37501240",
                        "longitude": "-4.25864890"
                    },
                    {
                        "id": 152876,
                        "name": "San Felices de Buelna",
                        "latitude": "43.26801050",
                        "longitude": "-4.03889180"
                    },
                    {
                        "id": 36864,
                        "name": "San Martín de Elines",
                        "latitude": "42.82864000",
                        "longitude": "-3.86865000"
                    },
                    {
                        "id": 36880,
                        "name": "San Miguel de Aguayo",
                        "latitude": "43.05383000",
                        "longitude": "-4.02550000"
                    },
                    {
                        "id": 36882,
                        "name": "San Miguel de Meruelo",
                        "latitude": "43.46211000",
                        "longitude": "-3.58877000"
                    },
                    {
                        "id": 36911,
                        "name": "San Pedro del Romeral",
                        "latitude": "43.11514000",
                        "longitude": "-3.81860000"
                    },
                    {
                        "id": 152877,
                        "name": "San Roque de Riomiera",
                        "latitude": "43.23544790",
                        "longitude": "-3.70274160"
                    },
                    {
                        "id": 36928,
                        "name": "San Vicente de la Barquera",
                        "latitude": "43.38509000",
                        "longitude": "-4.39934000"
                    },
                    {
                        "id": 37027,
                        "name": "Santa Cruz de Bezana",
                        "latitude": "43.44370000",
                        "longitude": "-3.90324000"
                    },
                    {
                        "id": 37074,
                        "name": "Santa María de Cayón",
                        "latitude": "43.30849000",
                        "longitude": "-3.83680000"
                    },
                    {
                        "id": 37106,
                        "name": "Santander",
                        "latitude": "43.46472000",
                        "longitude": "-3.80444000"
                    },
                    {
                        "id": 37130,
                        "name": "Santillana",
                        "latitude": "43.38903000",
                        "longitude": "-4.10844000"
                    },
                    {
                        "id": 152878,
                        "name": "Santillana del Mar",
                        "latitude": "43.38733270",
                        "longitude": "-4.10660920"
                    },
                    {
                        "id": 37134,
                        "name": "Santiurde de Reinosa",
                        "latitude": "43.06144000",
                        "longitude": "-4.08351000"
                    },
                    {
                        "id": 37135,
                        "name": "Santiurde de Toranzo",
                        "latitude": "43.23819000",
                        "longitude": "-3.93947000"
                    },
                    {
                        "id": 37150,
                        "name": "Santoña",
                        "latitude": "43.44386000",
                        "longitude": "-3.45757000"
                    },
                    {
                        "id": 37164,
                        "name": "Saro",
                        "latitude": "43.25961000",
                        "longitude": "-3.84283000"
                    },
                    {
                        "id": 37202,
                        "name": "Selaya",
                        "latitude": "43.21376000",
                        "longitude": "-3.80563000"
                    },
                    {
                        "id": 152879,
                        "name": "Soba",
                        "latitude": "43.17754540",
                        "longitude": "-3.56102600"
                    },
                    {
                        "id": 37286,
                        "name": "Solórzano",
                        "latitude": "43.38233000",
                        "longitude": "-3.58785000"
                    },
                    {
                        "id": 37327,
                        "name": "Suances",
                        "latitude": "43.43341000",
                        "longitude": "-4.04338000"
                    },
                    {
                        "id": 152880,
                        "name": "Tojos Los",
                        "latitude": "43.15422300",
                        "longitude": "-4.25416570"
                    },
                    {
                        "id": 37546,
                        "name": "Torrelavega",
                        "latitude": "43.34943000",
                        "longitude": "-4.04785000"
                    },
                    {
                        "id": 152881,
                        "name": "Tresviso",
                        "latitude": "43.25707930",
                        "longitude": "-4.66796370"
                    },
                    {
                        "id": 152882,
                        "name": "Tudanca",
                        "latitude": "43.15214840",
                        "longitude": "-4.37353650"
                    },
                    {
                        "id": 152883,
                        "name": "Udías",
                        "latitude": "43.33778220",
                        "longitude": "-4.24358930"
                    },
                    {
                        "id": 152888,
                        "name": "Val de San Vicente",
                        "latitude": "43.36772360",
                        "longitude": "-4.46967650"
                    },
                    {
                        "id": 152884,
                        "name": "Valdáliga",
                        "latitude": "43.30539940",
                        "longitude": "-4.33596350"
                    },
                    {
                        "id": 152885,
                        "name": "Valdeolea",
                        "latitude": "42.91414480",
                        "longitude": "-4.18209610"
                    },
                    {
                        "id": 152886,
                        "name": "Valdeprado del Río",
                        "latitude": "42.87396240",
                        "longitude": "-4.09558320"
                    },
                    {
                        "id": 152887,
                        "name": "Valderredible",
                        "latitude": "42.85368220",
                        "longitude": "-3.96743710"
                    },
                    {
                        "id": 152890,
                        "name": "Valle de Villaverde",
                        "latitude": "43.24680830",
                        "longitude": "-3.26023370"
                    },
                    {
                        "id": 152889,
                        "name": "Vega de Liébana",
                        "latitude": "43.06045690",
                        "longitude": "-4.66570270"
                    },
                    {
                        "id": 37905,
                        "name": "Vega de Pas",
                        "latitude": "43.15692000",
                        "longitude": "-3.78316000"
                    },
                    {
                        "id": 38025,
                        "name": "Villacarriedo",
                        "latitude": "43.22851000",
                        "longitude": "-3.81057000"
                    },
                    {
                        "id": 38068,
                        "name": "Villafufre",
                        "latitude": "43.26557000",
                        "longitude": "-3.89370000"
                    },
                    {
                        "id": 152891,
                        "name": "Voto",
                        "latitude": "43.33334790",
                        "longitude": "-3.52056410"
                    }
                ]
            },
            {
                "id": 5110,
                "name": "Castellón",
                "iso2": "CS",
                "latitude": "39.98114350",
                "longitude": "0.00884070",
                "type": "province",
                "cities": [
                    {
                        "id": 152370,
                        "name": "Aín",
                        "latitude": "39.90015430",
                        "longitude": "-0.34101070"
                    },
                    {
                        "id": 32047,
                        "name": "Albocàsser",
                        "latitude": "40.35000000",
                        "longitude": "0.03333000"
                    },
                    {
                        "id": 32068,
                        "name": "Alcalà de Xivert",
                        "latitude": "40.30000000",
                        "longitude": "0.23333000"
                    },
                    {
                        "id": 152371,
                        "name": "Alcora l",
                        "latitude": "40.07464620",
                        "longitude": "-0.21391510"
                    },
                    {
                        "id": 32131,
                        "name": "Alcudia de Veo",
                        "latitude": "39.91667000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 32203,
                        "name": "Alfondeguilla",
                        "latitude": "39.83333000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 32221,
                        "name": "Algimia de Almonacid",
                        "latitude": "39.91667000",
                        "longitude": "-0.43333000"
                    },
                    {
                        "id": 152372,
                        "name": "Almazora\/Almassora",
                        "latitude": "39.94527570",
                        "longitude": "-0.06066370"
                    },
                    {
                        "id": 32278,
                        "name": "Almedíjar",
                        "latitude": "39.86667000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 32282,
                        "name": "Almenara",
                        "latitude": "39.75000000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 32333,
                        "name": "Alquerías del Niño Perdido",
                        "latitude": "39.89466000",
                        "longitude": "-0.12943000"
                    },
                    {
                        "id": 32342,
                        "name": "Altura",
                        "latitude": "39.85000000",
                        "longitude": "-0.51667000"
                    },
                    {
                        "id": 32420,
                        "name": "Arañuel",
                        "latitude": "40.06667000",
                        "longitude": "-0.48333000"
                    },
                    {
                        "id": 152373,
                        "name": "Ares del Maestrat",
                        "latitude": "40.45635580",
                        "longitude": "-0.13178230"
                    },
                    {
                        "id": 32469,
                        "name": "Argelita",
                        "latitude": "40.05000000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 32520,
                        "name": "Artana",
                        "latitude": "39.89104000",
                        "longitude": "-0.25758000"
                    },
                    {
                        "id": 152369,
                        "name": "Atzeneta del Maestrat",
                        "latitude": "40.21634930",
                        "longitude": "-0.17086860"
                    },
                    {
                        "id": 32579,
                        "name": "Ayódar",
                        "latitude": "40.00000000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 32593,
                        "name": "Azuébar",
                        "latitude": "39.83333000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 32667,
                        "name": "Barracas",
                        "latitude": "40.01667000",
                        "longitude": "-0.68333000"
                    },
                    {
                        "id": 152374,
                        "name": "Bejís",
                        "latitude": "39.90985110",
                        "longitude": "-0.70697020"
                    },
                    {
                        "id": 152375,
                        "name": "Benafer",
                        "latitude": "39.93551330",
                        "longitude": "-0.57721180"
                    },
                    {
                        "id": 32759,
                        "name": "Benafigos",
                        "latitude": "40.27641000",
                        "longitude": "-0.20772000"
                    },
                    {
                        "id": 152376,
                        "name": "Benasal",
                        "latitude": "40.37970680",
                        "longitude": "-0.14195100"
                    },
                    {
                        "id": 32795,
                        "name": "Benicarló",
                        "latitude": "40.41650000",
                        "longitude": "0.42709000"
                    },
                    {
                        "id": 152377,
                        "name": "Benicasim\/Benicàssim",
                        "latitude": "40.05538410",
                        "longitude": "0.06404550"
                    },
                    {
                        "id": 32825,
                        "name": "Benlloch",
                        "latitude": "40.21075000",
                        "longitude": "0.02717000"
                    },
                    {
                        "id": 32882,
                        "name": "Betxí",
                        "latitude": "39.93333000",
                        "longitude": "-0.20000000"
                    },
                    {
                        "id": 152378,
                        "name": "Borriana\/Burriana",
                        "latitude": "39.88959250",
                        "longitude": "-0.08483400"
                    },
                    {
                        "id": 32962,
                        "name": "Borriol",
                        "latitude": "40.04249000",
                        "longitude": "-0.07025000"
                    },
                    {
                        "id": 33067,
                        "name": "Cabanes",
                        "latitude": "40.15600000",
                        "longitude": "0.04325000"
                    },
                    {
                        "id": 33889,
                        "name": "Càlig",
                        "latitude": "40.46262000",
                        "longitude": "0.35521000"
                    },
                    {
                        "id": 33235,
                        "name": "Canet lo Roig",
                        "latitude": "40.55142000",
                        "longitude": "0.24308000"
                    },
                    {
                        "id": 33410,
                        "name": "Castell de Cabres",
                        "latitude": "40.66058000",
                        "longitude": "0.04217000"
                    },
                    {
                        "id": 33428,
                        "name": "Castellfort",
                        "latitude": "40.50208000",
                        "longitude": "-0.19133000"
                    },
                    {
                        "id": 33430,
                        "name": "Castellnovo",
                        "latitude": "39.86667000",
                        "longitude": "-0.45000000"
                    },
                    {
                        "id": 152379,
                        "name": "Castellón de la Plana\/Castelló de la Plana",
                        "latitude": "40.00175050",
                        "longitude": "-0.05599390"
                    },
                    {
                        "id": 33465,
                        "name": "Castillo de Villamalefa",
                        "latitude": "40.13333000",
                        "longitude": "-0.38333000"
                    },
                    {
                        "id": 33517,
                        "name": "Catí",
                        "latitude": "40.47156000",
                        "longitude": "0.02275000"
                    },
                    {
                        "id": 152380,
                        "name": "Caudiel",
                        "latitude": "39.94840080",
                        "longitude": "-0.56774850"
                    },
                    {
                        "id": 33601,
                        "name": "Cervera del Maestre",
                        "latitude": "40.45366000",
                        "longitude": "0.27659000"
                    },
                    {
                        "id": 33628,
                        "name": "Chert\/Xert",
                        "latitude": "40.51944000",
                        "longitude": "0.15831000"
                    },
                    {
                        "id": 152382,
                        "name": "Chilches\/Xilxes",
                        "latitude": "39.78056500",
                        "longitude": "-0.18227920"
                    },
                    {
                        "id": 152383,
                        "name": "Chodos\/Xodos",
                        "latitude": "40.24497920",
                        "longitude": "-0.28695180"
                    },
                    {
                        "id": 33654,
                        "name": "Chóvar",
                        "latitude": "39.85000000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 33678,
                        "name": "Cinctorres",
                        "latitude": "40.58333000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 33681,
                        "name": "Cirat",
                        "latitude": "40.05000000",
                        "longitude": "-0.45000000"
                    },
                    {
                        "id": 33809,
                        "name": "Cortes de Arenoso",
                        "latitude": "40.18812000",
                        "longitude": "-0.54195000"
                    },
                    {
                        "id": 33822,
                        "name": "Costur",
                        "latitude": "40.11971000",
                        "longitude": "-0.17385000"
                    },
                    {
                        "id": 152381,
                        "name": "Coves de Vinromà les",
                        "latitude": "40.32920590",
                        "longitude": "0.13077970"
                    },
                    {
                        "id": 33880,
                        "name": "Culla",
                        "latitude": "40.33650000",
                        "longitude": "-0.16569000"
                    },
                    {
                        "id": 34100,
                        "name": "Eslida",
                        "latitude": "39.88333000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 34103,
                        "name": "Espadilla",
                        "latitude": "40.03333000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 34161,
                        "name": "Fanzara",
                        "latitude": "40.01667000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 34185,
                        "name": "Figueroles",
                        "latitude": "40.11667000",
                        "longitude": "-0.23333000"
                    },
                    {
                        "id": 34220,
                        "name": "Forcall",
                        "latitude": "40.64542000",
                        "longitude": "-0.19992000"
                    },
                    {
                        "id": 34305,
                        "name": "Fuente la Reina",
                        "latitude": "40.06667000",
                        "longitude": "-0.60000000"
                    },
                    {
                        "id": 34339,
                        "name": "Fuentes de Ayódar",
                        "latitude": "40.03333000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 34370,
                        "name": "Gaibiel",
                        "latitude": "39.93333000",
                        "longitude": "-0.48333000"
                    },
                    {
                        "id": 34445,
                        "name": "Geldo",
                        "latitude": "39.83333000",
                        "longitude": "-0.46667000"
                    },
                    {
                        "id": 34579,
                        "name": "Herbés",
                        "latitude": "40.72100000",
                        "longitude": "-0.00441000"
                    },
                    {
                        "id": 34615,
                        "name": "Higueras",
                        "latitude": "39.98333000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 152384,
                        "name": "Jana la",
                        "latitude": "40.51180450",
                        "longitude": "0.25202970"
                    },
                    {
                        "id": 34837,
                        "name": "Jérica",
                        "latitude": "39.91667000",
                        "longitude": "-0.56667000"
                    },
                    {
                        "id": 152385,
                        "name": "Llosa la",
                        "latitude": "39.77021630",
                        "longitude": "-0.21039880"
                    },
                    {
                        "id": 35151,
                        "name": "Lucena del Cid",
                        "latitude": "40.13333000",
                        "longitude": "-0.28333000"
                    },
                    {
                        "id": 35155,
                        "name": "Ludiente",
                        "latitude": "40.08333000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 152386,
                        "name": "Mata de Morella la",
                        "latitude": "39.98559050",
                        "longitude": "-0.04963880"
                    },
                    {
                        "id": 35341,
                        "name": "Matet",
                        "latitude": "39.93333000",
                        "longitude": "-0.46667000"
                    },
                    {
                        "id": 35502,
                        "name": "Moncofa",
                        "latitude": "39.80907000",
                        "longitude": "-0.14701000"
                    },
                    {
                        "id": 35587,
                        "name": "Montán",
                        "latitude": "40.03333000",
                        "longitude": "-0.55000000"
                    },
                    {
                        "id": 35536,
                        "name": "Montanejos",
                        "latitude": "40.06667000",
                        "longitude": "-0.51667000"
                    },
                    {
                        "id": 35624,
                        "name": "Morella",
                        "latitude": "40.61966000",
                        "longitude": "-0.09892000"
                    },
                    {
                        "id": 35738,
                        "name": "Navajas",
                        "latitude": "39.88333000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 35837,
                        "name": "Nules",
                        "latitude": "39.85362000",
                        "longitude": "-0.15643000"
                    },
                    {
                        "id": 35909,
                        "name": "Olocau del Rey",
                        "latitude": "40.63775000",
                        "longitude": "-0.34041000"
                    },
                    {
                        "id": 35922,
                        "name": "Onda",
                        "latitude": "39.96495000",
                        "longitude": "-0.26041000"
                    },
                    {
                        "id": 152387,
                        "name": "Oropesa del Mar\/Orpesa",
                        "latitude": "40.11446580",
                        "longitude": "0.14013810"
                    },
                    {
                        "id": 36016,
                        "name": "Palanques",
                        "latitude": "40.71800000",
                        "longitude": "-0.17941000"
                    },
                    {
                        "id": 36084,
                        "name": "Pavías",
                        "latitude": "39.96667000",
                        "longitude": "-0.48333000"
                    },
                    {
                        "id": 152388,
                        "name": "Peníscola\/Peñíscola",
                        "latitude": "40.36688290",
                        "longitude": "0.39131720"
                    },
                    {
                        "id": 36191,
                        "name": "Pina de Montalgrao",
                        "latitude": "40.01667000",
                        "longitude": "-0.65000000"
                    },
                    {
                        "id": 152389,
                        "name": "Pobla de Benifassà la",
                        "latitude": "40.65646860",
                        "longitude": "0.15681350"
                    },
                    {
                        "id": 152390,
                        "name": "Pobla Tornesa la",
                        "latitude": "40.09994400",
                        "longitude": "0.00059500"
                    },
                    {
                        "id": 36288,
                        "name": "Portell de Morella",
                        "latitude": "40.53267000",
                        "longitude": "-0.26249000"
                    },
                    {
                        "id": 36412,
                        "name": "Puebla de Arenoso",
                        "latitude": "40.10000000",
                        "longitude": "-0.58333000"
                    },
                    {
                        "id": 36618,
                        "name": "Ribesalbes",
                        "latitude": "40.01667000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 152391,
                        "name": "Rossell",
                        "latitude": "40.61411930",
                        "longitude": "0.24323070"
                    },
                    {
                        "id": 36726,
                        "name": "Sacañet",
                        "latitude": "39.86667000",
                        "longitude": "-0.71667000"
                    },
                    {
                        "id": 152392,
                        "name": "Salzadella la",
                        "latitude": "40.42098380",
                        "longitude": "0.14013810"
                    },
                    {
                        "id": 152395,
                        "name": "San Rafael del Río",
                        "latitude": "40.60610870",
                        "longitude": "0.34705310"
                    },
                    {
                        "id": 152412,
                        "name": "Sant Joan de Moró",
                        "latitude": "40.05938230",
                        "longitude": "-0.13896820"
                    },
                    {
                        "id": 152393,
                        "name": "Sant Jordi\/San Jorge",
                        "latitude": "40.50951070",
                        "longitude": "0.33218290"
                    },
                    {
                        "id": 152394,
                        "name": "Sant Mateu",
                        "latitude": "40.46549870",
                        "longitude": "0.17876570"
                    },
                    {
                        "id": 37063,
                        "name": "Santa Magdalena de Pulpis",
                        "latitude": "40.35625000",
                        "longitude": "0.30258000"
                    },
                    {
                        "id": 37166,
                        "name": "Sarratella",
                        "latitude": "40.31284000",
                        "longitude": "0.03150000"
                    },
                    {
                        "id": 37191,
                        "name": "Segorbe",
                        "latitude": "39.85000000",
                        "longitude": "-0.48333000"
                    },
                    {
                        "id": 152396,
                        "name": "Sierra Engarcerán",
                        "latitude": "40.26941510",
                        "longitude": "-0.01913380"
                    },
                    {
                        "id": 37293,
                        "name": "Soneja",
                        "latitude": "39.81667000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 37310,
                        "name": "Sot de Ferrer",
                        "latitude": "39.80000000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 152397,
                        "name": "Sueras\/Suera",
                        "latitude": "39.95284060",
                        "longitude": "-0.33277950"
                    },
                    {
                        "id": 37361,
                        "name": "Tales",
                        "latitude": "39.94844000",
                        "longitude": "-0.30719000"
                    },
                    {
                        "id": 152398,
                        "name": "Teresa",
                        "latitude": "39.89196450",
                        "longitude": "-0.67256090"
                    },
                    {
                        "id": 152399,
                        "name": "Tírig",
                        "latitude": "40.42295330",
                        "longitude": "0.07759670"
                    },
                    {
                        "id": 37440,
                        "name": "Todolella",
                        "latitude": "40.64675000",
                        "longitude": "-0.24675000"
                    },
                    {
                        "id": 37441,
                        "name": "Toga",
                        "latitude": "40.05000000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 37601,
                        "name": "Torás",
                        "latitude": "39.91667000",
                        "longitude": "-0.68333000"
                    },
                    {
                        "id": 152400,
                        "name": "Toro El",
                        "latitude": "39.98210840",
                        "longitude": "-0.74944270"
                    },
                    {
                        "id": 37485,
                        "name": "Torralba del Pinar",
                        "latitude": "39.98333000",
                        "longitude": "-0.43333000"
                    },
                    {
                        "id": 152401,
                        "name": "Torre dEn Besora la",
                        "latitude": "40.32676830",
                        "longitude": "-0.07932440"
                    },
                    {
                        "id": 152402,
                        "name": "Torre den Doménec la",
                        "latitude": "40.27053930",
                        "longitude": "0.07234080"
                    },
                    {
                        "id": 37510,
                        "name": "Torreblanca",
                        "latitude": "40.22033000",
                        "longitude": "0.19650000"
                    },
                    {
                        "id": 37514,
                        "name": "Torrechiva",
                        "latitude": "40.05000000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 37615,
                        "name": "Traiguera",
                        "latitude": "40.52511000",
                        "longitude": "0.29023000"
                    },
                    {
                        "id": 152403,
                        "name": "Useras\/Useres les",
                        "latitude": "40.15858890",
                        "longitude": "-0.16764170"
                    },
                    {
                        "id": 152405,
                        "name": "Vall dAlba",
                        "latitude": "40.17469590",
                        "longitude": "-0.03615330"
                    },
                    {
                        "id": 37833,
                        "name": "Vall de Almonacid",
                        "latitude": "39.90000000",
                        "longitude": "-0.45000000"
                    },
                    {
                        "id": 152406,
                        "name": "Vall dUixó la",
                        "latitude": "39.82423860",
                        "longitude": "-0.23150180"
                    },
                    {
                        "id": 152404,
                        "name": "Vallat",
                        "latitude": "40.03719840",
                        "longitude": "-0.33248560"
                    },
                    {
                        "id": 37860,
                        "name": "Vallibona",
                        "latitude": "40.60300000",
                        "longitude": "0.04642000"
                    },
                    {
                        "id": 37972,
                        "name": "Vila-real",
                        "latitude": "39.93830000",
                        "longitude": "-0.10087000"
                    },
                    {
                        "id": 152407,
                        "name": "Vilafamés",
                        "latitude": "40.11389850",
                        "longitude": "-0.05190820"
                    },
                    {
                        "id": 152409,
                        "name": "Vilanova dAlcolea",
                        "latitude": "40.23155850",
                        "longitude": "0.07273280"
                    },
                    {
                        "id": 152410,
                        "name": "Vilar de Canes",
                        "latitude": "40.35827890",
                        "longitude": "-0.06620990"
                    },
                    {
                        "id": 152411,
                        "name": "Vilavella la",
                        "latitude": "39.85884230",
                        "longitude": "-0.18448920"
                    },
                    {
                        "id": 152408,
                        "name": "Villafranca del Cid\/Vilafranca",
                        "latitude": "40.42978680",
                        "longitude": "-0.25764190"
                    },
                    {
                        "id": 38084,
                        "name": "Villahermosa del Río",
                        "latitude": "40.20268000",
                        "longitude": "-0.41990000"
                    },
                    {
                        "id": 38128,
                        "name": "Villamalur",
                        "latitude": "39.96667000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 38195,
                        "name": "Villanueva de Viver",
                        "latitude": "40.05000000",
                        "longitude": "-0.65000000"
                    },
                    {
                        "id": 38373,
                        "name": "Villores",
                        "latitude": "40.67478000",
                        "longitude": "-0.20023000"
                    },
                    {
                        "id": 38391,
                        "name": "Vinaròs",
                        "latitude": "40.47033000",
                        "longitude": "0.47559000"
                    },
                    {
                        "id": 38400,
                        "name": "Vistabella del Maestrazgo",
                        "latitude": "40.29617000",
                        "longitude": "-0.29435000"
                    },
                    {
                        "id": 38405,
                        "name": "Viver",
                        "latitude": "39.91667000",
                        "longitude": "-0.60000000"
                    },
                    {
                        "id": 38498,
                        "name": "Zorita del Maestrazgo",
                        "latitude": "40.72817000",
                        "longitude": "-0.16667000"
                    },
                    {
                        "id": 38503,
                        "name": "Zucaina",
                        "latitude": "40.11667000",
                        "longitude": "-0.41667000"
                    }
                ]
            },
            {
                "id": 5329,
                "name": "Castile and Leon",
                "iso2": "CL",
                "latitude": "41.63384450",
                "longitude": "-7.07137270",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5330,
                "name": "Castilla-La Mancha",
                "iso2": "CM",
                "latitude": "39.64895440",
                "longitude": "-5.80632400",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5331,
                "name": "Catalonia",
                "iso2": "CT",
                "latitude": "41.68672110",
                "longitude": "0.42393440",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5223,
                "name": "Ceuta",
                "iso2": "CE",
                "latitude": "35.88900000",
                "longitude": "-5.31870000",
                "type": "autonomous city",
                "cities": []
            },
            {
                "id": 5105,
                "name": "Ciudad Real",
                "iso2": "CR",
                "latitude": "38.98607580",
                "longitude": "-3.94449750",
                "type": "province",
                "cities": [
                    {
                        "id": 31909,
                        "name": "Abenójar",
                        "latitude": "38.88032000",
                        "longitude": "-4.35702000"
                    },
                    {
                        "id": 31956,
                        "name": "Agudo",
                        "latitude": "38.98183000",
                        "longitude": "-4.87133000"
                    },
                    {
                        "id": 31997,
                        "name": "Alamillo",
                        "latitude": "38.67842000",
                        "longitude": "-4.79008000"
                    },
                    {
                        "id": 32017,
                        "name": "Albaladejo",
                        "latitude": "38.61887000",
                        "longitude": "-2.80784000"
                    },
                    {
                        "id": 32136,
                        "name": "Alcázar de San Juan",
                        "latitude": "39.39011000",
                        "longitude": "-3.20827000"
                    },
                    {
                        "id": 32096,
                        "name": "Alcoba",
                        "latitude": "39.25988000",
                        "longitude": "-4.47715000"
                    },
                    {
                        "id": 32104,
                        "name": "Alcolea de Calatrava",
                        "latitude": "38.98680000",
                        "longitude": "-4.11597000"
                    },
                    {
                        "id": 32128,
                        "name": "Alcubillas",
                        "latitude": "38.75312000",
                        "longitude": "-3.13407000"
                    },
                    {
                        "id": 32146,
                        "name": "Aldea del Rey",
                        "latitude": "38.73830000",
                        "longitude": "-3.84017000"
                    },
                    {
                        "id": 32237,
                        "name": "Alhambra",
                        "latitude": "38.89925000",
                        "longitude": "-3.05333000"
                    },
                    {
                        "id": 32261,
                        "name": "Almadén",
                        "latitude": "38.77541000",
                        "longitude": "-4.83156000"
                    },
                    {
                        "id": 152013,
                        "name": "Almadenejos",
                        "latitude": "38.73826600",
                        "longitude": "-4.71158710"
                    },
                    {
                        "id": 32263,
                        "name": "Almagro",
                        "latitude": "38.88941000",
                        "longitude": "-3.71131000"
                    },
                    {
                        "id": 32276,
                        "name": "Almedina",
                        "latitude": "38.62453000",
                        "longitude": "-2.95382000"
                    },
                    {
                        "id": 32293,
                        "name": "Almodóvar del Campo",
                        "latitude": "38.70936000",
                        "longitude": "-4.17908000"
                    },
                    {
                        "id": 152014,
                        "name": "Almuradiel",
                        "latitude": "38.51307750",
                        "longitude": "-3.49655530"
                    },
                    {
                        "id": 32369,
                        "name": "Anchuras",
                        "latitude": "39.48059000",
                        "longitude": "-4.83381000"
                    },
                    {
                        "id": 152032,
                        "name": "Arenales de San Gregorio",
                        "latitude": "39.30929070",
                        "longitude": "-3.02695460"
                    },
                    {
                        "id": 32446,
                        "name": "Arenas de San Juan",
                        "latitude": "39.21861000",
                        "longitude": "-3.50211000"
                    },
                    {
                        "id": 32460,
                        "name": "Argamasilla de Alba",
                        "latitude": "39.12917000",
                        "longitude": "-3.09247000"
                    },
                    {
                        "id": 32461,
                        "name": "Argamasilla de Calatrava",
                        "latitude": "38.72985000",
                        "longitude": "-4.07627000"
                    },
                    {
                        "id": 152015,
                        "name": "Arroba de los Montes",
                        "latitude": "39.15313770",
                        "longitude": "-4.54310320"
                    },
                    {
                        "id": 32624,
                        "name": "Ballesteros de Calatrava",
                        "latitude": "38.83460000",
                        "longitude": "-3.94470000"
                    },
                    {
                        "id": 32935,
                        "name": "Bolaños de Calatrava",
                        "latitude": "38.90690000",
                        "longitude": "-3.66345000"
                    },
                    {
                        "id": 32971,
                        "name": "Brazatortas",
                        "latitude": "38.65869000",
                        "longitude": "-4.29368000"
                    },
                    {
                        "id": 33083,
                        "name": "Cabezarados",
                        "latitude": "38.84469000",
                        "longitude": "-4.29830000"
                    },
                    {
                        "id": 152016,
                        "name": "Cabezarrubias del Puerto",
                        "latitude": "38.61550570",
                        "longitude": "-4.18395780"
                    },
                    {
                        "id": 152017,
                        "name": "Calzada de Calatrava",
                        "latitude": "38.69975140",
                        "longitude": "-3.77144640"
                    },
                    {
                        "id": 33202,
                        "name": "Campo de Criptana",
                        "latitude": "39.40463000",
                        "longitude": "-3.12492000"
                    },
                    {
                        "id": 33529,
                        "name": "Cañada de Calatrava",
                        "latitude": "38.85429000",
                        "longitude": "-4.02103000"
                    },
                    {
                        "id": 152018,
                        "name": "Caracuel de Calatrava",
                        "latitude": "38.84511980",
                        "longitude": "-4.06347710"
                    },
                    {
                        "id": 33331,
                        "name": "Carrión de Calatrava",
                        "latitude": "39.01897000",
                        "longitude": "-3.81683000"
                    },
                    {
                        "id": 33330,
                        "name": "Carrizosa",
                        "latitude": "38.84204000",
                        "longitude": "-2.99250000"
                    },
                    {
                        "id": 33418,
                        "name": "Castellar de Santiago",
                        "latitude": "38.53928000",
                        "longitude": "-3.27573000"
                    },
                    {
                        "id": 152020,
                        "name": "Chillón",
                        "latitude": "38.79655930",
                        "longitude": "-4.86632540"
                    },
                    {
                        "id": 33697,
                        "name": "Ciudad Real",
                        "latitude": "38.98626000",
                        "longitude": "-3.92907000"
                    },
                    {
                        "id": 33800,
                        "name": "Corral de Calatrava",
                        "latitude": "38.85793000",
                        "longitude": "-4.08140000"
                    },
                    {
                        "id": 152019,
                        "name": "Cortijos Los",
                        "latitude": "39.31446440",
                        "longitude": "-4.05193860"
                    },
                    {
                        "id": 33905,
                        "name": "Cózar",
                        "latitude": "38.66219000",
                        "longitude": "-3.07205000"
                    },
                    {
                        "id": 33909,
                        "name": "Daimiel",
                        "latitude": "39.07004000",
                        "longitude": "-3.61498000"
                    },
                    {
                        "id": 152021,
                        "name": "Fernán Caballero",
                        "latitude": "39.12332860",
                        "longitude": "-3.90181850"
                    },
                    {
                        "id": 34212,
                        "name": "Fontanarejo",
                        "latitude": "39.22014000",
                        "longitude": "-4.51753000"
                    },
                    {
                        "id": 34275,
                        "name": "Fuencaliente",
                        "latitude": "39.18624000",
                        "longitude": "-4.02576000"
                    },
                    {
                        "id": 34285,
                        "name": "Fuenllana",
                        "latitude": "38.75590000",
                        "longitude": "-2.95814000"
                    },
                    {
                        "id": 34300,
                        "name": "Fuente el Fresno",
                        "latitude": "39.22839000",
                        "longitude": "-3.77487000"
                    },
                    {
                        "id": 152022,
                        "name": "Granátula de Calatrava",
                        "latitude": "38.79871290",
                        "longitude": "-3.74223950"
                    },
                    {
                        "id": 34525,
                        "name": "Guadalmez",
                        "latitude": "38.72665000",
                        "longitude": "-4.97104000"
                    },
                    {
                        "id": 34581,
                        "name": "Herencia",
                        "latitude": "39.36616000",
                        "longitude": "-3.35735000"
                    },
                    {
                        "id": 34629,
                        "name": "Hinojosas de Calatrava",
                        "latitude": "38.61446000",
                        "longitude": "-4.13979000"
                    },
                    {
                        "id": 152023,
                        "name": "Horcajo de los Montes",
                        "latitude": "39.32783540",
                        "longitude": "-4.64890960"
                    },
                    {
                        "id": 152024,
                        "name": "Labores Las",
                        "latitude": "39.27410040",
                        "longitude": "-3.51930010"
                    },
                    {
                        "id": 152033,
                        "name": "Llanos del Caudillo",
                        "latitude": "39.11801860",
                        "longitude": "-3.35274590"
                    },
                    {
                        "id": 152025,
                        "name": "Luciana",
                        "latitude": "38.98516760",
                        "longitude": "-4.29296380"
                    },
                    {
                        "id": 35219,
                        "name": "Malagón",
                        "latitude": "39.16668000",
                        "longitude": "-3.85419000"
                    },
                    {
                        "id": 35265,
                        "name": "Manzanares",
                        "latitude": "38.99915000",
                        "longitude": "-3.36991000"
                    },
                    {
                        "id": 35395,
                        "name": "Membrilla",
                        "latitude": "38.97198000",
                        "longitude": "-3.34330000"
                    },
                    {
                        "id": 35412,
                        "name": "Mestanza",
                        "latitude": "38.57616000",
                        "longitude": "-4.07096000"
                    },
                    {
                        "id": 35424,
                        "name": "Miguelturra",
                        "latitude": "38.96442000",
                        "longitude": "-3.89047000"
                    },
                    {
                        "id": 35575,
                        "name": "Montiel",
                        "latitude": "38.69802000",
                        "longitude": "-2.86441000"
                    },
                    {
                        "id": 35597,
                        "name": "Moral de Calatrava",
                        "latitude": "38.82989000",
                        "longitude": "-3.57813000"
                    },
                    {
                        "id": 35757,
                        "name": "Navalpino",
                        "latitude": "39.22573000",
                        "longitude": "-4.59133000"
                    },
                    {
                        "id": 35778,
                        "name": "Navas de Estena",
                        "latitude": "39.49481000",
                        "longitude": "-4.52155000"
                    },
                    {
                        "id": 36101,
                        "name": "Pedro Muñoz",
                        "latitude": "39.40285000",
                        "longitude": "-2.94664000"
                    },
                    {
                        "id": 36179,
                        "name": "Picón",
                        "latitude": "39.05074000",
                        "longitude": "-4.06084000"
                    },
                    {
                        "id": 36180,
                        "name": "Piedrabuena",
                        "latitude": "39.03536000",
                        "longitude": "-4.17512000"
                    },
                    {
                        "id": 36254,
                        "name": "Poblete",
                        "latitude": "38.93550000",
                        "longitude": "-3.98137000"
                    },
                    {
                        "id": 36301,
                        "name": "Porzuna",
                        "latitude": "39.14618000",
                        "longitude": "-4.15407000"
                    },
                    {
                        "id": 36333,
                        "name": "Pozuelo de Calatrava",
                        "latitude": "38.58333000",
                        "longitude": "-3.83333000"
                    },
                    {
                        "id": 152026,
                        "name": "Pozuelos de Calatrava Los",
                        "latitude": "38.90000000",
                        "longitude": "-4.16666700"
                    },
                    {
                        "id": 36416,
                        "name": "Puebla de Don Rodrigo",
                        "latitude": "39.08564000",
                        "longitude": "-4.61966000"
                    },
                    {
                        "id": 36430,
                        "name": "Puebla del Príncipe",
                        "latitude": "38.56766000",
                        "longitude": "-2.92605000"
                    },
                    {
                        "id": 36446,
                        "name": "Puerto Lápice",
                        "latitude": "39.32360000",
                        "longitude": "-3.48148000"
                    },
                    {
                        "id": 36457,
                        "name": "Puertollano",
                        "latitude": "38.68712000",
                        "longitude": "-4.10734000"
                    },
                    {
                        "id": 152027,
                        "name": "Retuerta del Bullaque",
                        "latitude": "39.46376420",
                        "longitude": "-4.41177890"
                    },
                    {
                        "id": 152031,
                        "name": "Robledo El",
                        "latitude": "39.21793530",
                        "longitude": "-4.28267590"
                    },
                    {
                        "id": 36703,
                        "name": "Ruidera",
                        "latitude": "38.97775000",
                        "longitude": "-2.88321000"
                    },
                    {
                        "id": 36730,
                        "name": "Saceruela",
                        "latitude": "38.94382000",
                        "longitude": "-4.60768000"
                    },
                    {
                        "id": 36813,
                        "name": "San Carlos del Valle",
                        "latitude": "38.84399000",
                        "longitude": "-3.24148000"
                    },
                    {
                        "id": 36857,
                        "name": "San Lorenzo de Calatrava",
                        "latitude": "38.47681000",
                        "longitude": "-3.82605000"
                    },
                    {
                        "id": 37043,
                        "name": "Santa Cruz de los Cáñamos",
                        "latitude": "38.63759000",
                        "longitude": "-2.86618000"
                    },
                    {
                        "id": 37032,
                        "name": "Santa Cruz de Mudela",
                        "latitude": "38.64241000",
                        "longitude": "-3.46650000"
                    },
                    {
                        "id": 37277,
                        "name": "Socuéllamos",
                        "latitude": "39.28581000",
                        "longitude": "-2.79205000"
                    },
                    {
                        "id": 152029,
                        "name": "Solana del Pino",
                        "latitude": "38.46593720",
                        "longitude": "-4.07369780"
                    },
                    {
                        "id": 152028,
                        "name": "Solana La",
                        "latitude": "38.94160130",
                        "longitude": "-3.23920140"
                    },
                    {
                        "id": 37413,
                        "name": "Terrinches",
                        "latitude": "38.61057000",
                        "longitude": "-2.84215000"
                    },
                    {
                        "id": 37450,
                        "name": "Tomelloso",
                        "latitude": "39.15759000",
                        "longitude": "-3.02156000"
                    },
                    {
                        "id": 37480,
                        "name": "Torralba de Calatrava",
                        "latitude": "39.01785000",
                        "longitude": "-3.75105000"
                    },
                    {
                        "id": 37493,
                        "name": "Torre de Juan Abad",
                        "latitude": "38.58417000",
                        "longitude": "-3.05994000"
                    },
                    {
                        "id": 37567,
                        "name": "Torrenueva",
                        "latitude": "38.63960000",
                        "longitude": "-3.36259000"
                    },
                    {
                        "id": 37766,
                        "name": "Valdemanco del Esteras",
                        "latitude": "38.93858000",
                        "longitude": "-4.82920000"
                    },
                    {
                        "id": 37782,
                        "name": "Valdepeñas",
                        "latitude": "38.76211000",
                        "longitude": "-3.38483000"
                    },
                    {
                        "id": 37824,
                        "name": "Valenzuela de Calatrava",
                        "latitude": "38.85254000",
                        "longitude": "-3.77210000"
                    },
                    {
                        "id": 38082,
                        "name": "Villahermosa",
                        "latitude": "38.75023000",
                        "longitude": "-2.87066000"
                    },
                    {
                        "id": 38130,
                        "name": "Villamanrique",
                        "latitude": "38.54636000",
                        "longitude": "-2.99729000"
                    },
                    {
                        "id": 38140,
                        "name": "Villamayor de Calatrava",
                        "latitude": "38.78763000",
                        "longitude": "-4.13774000"
                    },
                    {
                        "id": 38198,
                        "name": "Villanueva de la Fuente",
                        "latitude": "38.69463000",
                        "longitude": "-2.69637000"
                    },
                    {
                        "id": 38188,
                        "name": "Villanueva de San Carlos",
                        "latitude": "38.62173000",
                        "longitude": "-3.90903000"
                    },
                    {
                        "id": 38259,
                        "name": "Villar del Pozo",
                        "latitude": "38.85010000",
                        "longitude": "-3.96405000"
                    },
                    {
                        "id": 38303,
                        "name": "Villarrubia de los Ojos",
                        "latitude": "39.22085000",
                        "longitude": "-3.60802000"
                    },
                    {
                        "id": 38307,
                        "name": "Villarta de San Juan",
                        "latitude": "39.23785000",
                        "longitude": "-3.42333000"
                    },
                    {
                        "id": 38398,
                        "name": "Viso del Marqués",
                        "latitude": "38.52208000",
                        "longitude": "-3.56348000"
                    }
                ]
            },
            {
                "id": 5337,
                "name": "Community of Madrid",
                "iso2": "MD",
                "latitude": "40.52445220",
                "longitude": "-4.47541030",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5097,
                "name": "Córdoba",
                "iso2": "CO",
                "latitude": "37.95141140",
                "longitude": "-6.10981340",
                "type": "province",
                "cities": [
                    {
                        "id": 31929,
                        "name": "Adamuz",
                        "latitude": "38.02674000",
                        "longitude": "-4.52231000"
                    },
                    {
                        "id": 151367,
                        "name": "Aguilar de la Frontera",
                        "latitude": "37.48289080",
                        "longitude": "-4.66570270"
                    },
                    {
                        "id": 32087,
                        "name": "Alcaracejos",
                        "latitude": "38.38333000",
                        "longitude": "-4.96667000"
                    },
                    {
                        "id": 32277,
                        "name": "Almedinilla",
                        "latitude": "37.43902000",
                        "longitude": "-4.09052000"
                    },
                    {
                        "id": 32295,
                        "name": "Almodóvar del Río",
                        "latitude": "37.81070000",
                        "longitude": "-5.02037000"
                    },
                    {
                        "id": 32596,
                        "name": "Añora",
                        "latitude": "38.41667000",
                        "longitude": "-4.90000000"
                    },
                    {
                        "id": 32607,
                        "name": "Baena",
                        "latitude": "37.61670000",
                        "longitude": "-4.32245000"
                    },
                    {
                        "id": 32734,
                        "name": "Belalcázar",
                        "latitude": "38.57566000",
                        "longitude": "-5.16653000"
                    },
                    {
                        "id": 33059,
                        "name": "Bélmez",
                        "latitude": "38.26667000",
                        "longitude": "-5.20000000"
                    },
                    {
                        "id": 32771,
                        "name": "Benamejí",
                        "latitude": "37.26833000",
                        "longitude": "-4.54123000"
                    },
                    {
                        "id": 151368,
                        "name": "Blázquez Los",
                        "latitude": "38.40706540",
                        "longitude": "-5.43781770"
                    },
                    {
                        "id": 33014,
                        "name": "Bujalance",
                        "latitude": "37.89556000",
                        "longitude": "-4.38074000"
                    },
                    {
                        "id": 33098,
                        "name": "Cabra",
                        "latitude": "37.47249000",
                        "longitude": "-4.44206000"
                    },
                    {
                        "id": 33540,
                        "name": "Cañete de las Torres",
                        "latitude": "37.86717000",
                        "longitude": "-4.31835000"
                    },
                    {
                        "id": 33290,
                        "name": "Carcabuey",
                        "latitude": "37.44420000",
                        "longitude": "-4.27471000"
                    },
                    {
                        "id": 33298,
                        "name": "Cardeña",
                        "latitude": "38.27023000",
                        "longitude": "-4.32358000"
                    },
                    {
                        "id": 151369,
                        "name": "Carlota La",
                        "latitude": "37.67264460",
                        "longitude": "-4.93379460"
                    },
                    {
                        "id": 151370,
                        "name": "Carpio El",
                        "latitude": "37.94114150",
                        "longitude": "-4.49638430"
                    },
                    {
                        "id": 33491,
                        "name": "Castro del Río",
                        "latitude": "37.69125000",
                        "longitude": "-4.48058000"
                    },
                    {
                        "id": 33762,
                        "name": "Conquista",
                        "latitude": "38.40000000",
                        "longitude": "-4.50000000"
                    },
                    {
                        "id": 33904,
                        "name": "Córdoba",
                        "latitude": "37.89155000",
                        "longitude": "-4.77275000"
                    },
                    {
                        "id": 33954,
                        "name": "Doña Mencía",
                        "latitude": "37.55346000",
                        "longitude": "-4.35602000"
                    },
                    {
                        "id": 33950,
                        "name": "Dos Torres",
                        "latitude": "38.45000000",
                        "longitude": "-4.90000000"
                    },
                    {
                        "id": 34047,
                        "name": "Encinas Reales",
                        "latitude": "37.27419000",
                        "longitude": "-4.48828000"
                    },
                    {
                        "id": 34112,
                        "name": "Espejo",
                        "latitude": "37.67980000",
                        "longitude": "-4.55355000"
                    },
                    {
                        "id": 34116,
                        "name": "Espiel",
                        "latitude": "38.20000000",
                        "longitude": "-5.01667000"
                    },
                    {
                        "id": 34175,
                        "name": "Fernán-Núñez",
                        "latitude": "37.67044000",
                        "longitude": "-4.72640000"
                    },
                    {
                        "id": 34304,
                        "name": "Fuente la Lancha",
                        "latitude": "38.41667000",
                        "longitude": "-5.03333000"
                    },
                    {
                        "id": 34292,
                        "name": "Fuente Obejuna",
                        "latitude": "38.26667000",
                        "longitude": "-5.41667000"
                    },
                    {
                        "id": 34293,
                        "name": "Fuente Palmera",
                        "latitude": "37.70494000",
                        "longitude": "-5.09965000"
                    },
                    {
                        "id": 34306,
                        "name": "Fuente-Tójar",
                        "latitude": "37.51095000",
                        "longitude": "-4.14631000"
                    },
                    {
                        "id": 151371,
                        "name": "Granjuela La",
                        "latitude": "38.37166920",
                        "longitude": "-5.35143370"
                    },
                    {
                        "id": 34523,
                        "name": "Guadalcázar",
                        "latitude": "37.75738000",
                        "longitude": "-4.94387000"
                    },
                    {
                        "id": 151372,
                        "name": "Guijo El",
                        "latitude": "38.49591780",
                        "longitude": "-4.78275160"
                    },
                    {
                        "id": 34627,
                        "name": "Hinojosa del Duque",
                        "latitude": "38.50057000",
                        "longitude": "-5.14651000"
                    },
                    {
                        "id": 34660,
                        "name": "Hornachuelos",
                        "latitude": "37.83333000",
                        "longitude": "-5.23333000"
                    },
                    {
                        "id": 34782,
                        "name": "Iznájar",
                        "latitude": "37.25766000",
                        "longitude": "-4.30836000"
                    },
                    {
                        "id": 35149,
                        "name": "Lucena",
                        "latitude": "37.40881000",
                        "longitude": "-4.48522000"
                    },
                    {
                        "id": 35169,
                        "name": "Luque",
                        "latitude": "37.55797000",
                        "longitude": "-4.27974000"
                    },
                    {
                        "id": 35533,
                        "name": "Montalbán de Córdoba",
                        "latitude": "37.57996000",
                        "longitude": "-4.74935000"
                    },
                    {
                        "id": 35558,
                        "name": "Montemayor",
                        "latitude": "37.64790000",
                        "longitude": "-4.69779000"
                    },
                    {
                        "id": 35577,
                        "name": "Montilla",
                        "latitude": "37.58627000",
                        "longitude": "-4.63805000"
                    },
                    {
                        "id": 35583,
                        "name": "Montoro",
                        "latitude": "38.02409000",
                        "longitude": "-4.38340000"
                    },
                    {
                        "id": 35585,
                        "name": "Monturque",
                        "latitude": "37.47186000",
                        "longitude": "-4.58164000"
                    },
                    {
                        "id": 35629,
                        "name": "Moriles",
                        "latitude": "37.43670000",
                        "longitude": "-4.60761000"
                    },
                    {
                        "id": 151373,
                        "name": "Nueva Carteya",
                        "latitude": "37.58561130",
                        "longitude": "-4.46774560"
                    },
                    {
                        "id": 35853,
                        "name": "Obejo",
                        "latitude": "38.13265000",
                        "longitude": "-4.80018000"
                    },
                    {
                        "id": 36024,
                        "name": "Palenciana",
                        "latitude": "37.24851000",
                        "longitude": "-4.58261000"
                    },
                    {
                        "id": 36029,
                        "name": "Palma del Río",
                        "latitude": "37.70024000",
                        "longitude": "-5.28121000"
                    },
                    {
                        "id": 36098,
                        "name": "Pedro Abad",
                        "latitude": "37.96686000",
                        "longitude": "-4.45560000"
                    },
                    {
                        "id": 36102,
                        "name": "Pedroche",
                        "latitude": "38.42848000",
                        "longitude": "-4.76325000"
                    },
                    {
                        "id": 36174,
                        "name": "Peñarroya-Pueblonuevo",
                        "latitude": "38.30000000",
                        "longitude": "-5.26667000"
                    },
                    {
                        "id": 36303,
                        "name": "Posadas",
                        "latitude": "37.80205000",
                        "longitude": "-5.10726000"
                    },
                    {
                        "id": 36323,
                        "name": "Pozoblanco",
                        "latitude": "38.37906000",
                        "longitude": "-4.84827000"
                    },
                    {
                        "id": 36354,
                        "name": "Priego de Córdoba",
                        "latitude": "37.43807000",
                        "longitude": "-4.19523000"
                    },
                    {
                        "id": 151374,
                        "name": "Puente Genil",
                        "latitude": "37.38875290",
                        "longitude": "-4.76509980"
                    },
                    {
                        "id": 151375,
                        "name": "Rambla La",
                        "latitude": "37.60634080",
                        "longitude": "-4.73935760"
                    },
                    {
                        "id": 36706,
                        "name": "Rute",
                        "latitude": "37.32690000",
                        "longitude": "-4.36827000"
                    },
                    {
                        "id": 36921,
                        "name": "San Sebastián de los Ballesteros",
                        "latitude": "37.65376000",
                        "longitude": "-4.82409000"
                    },
                    {
                        "id": 37049,
                        "name": "Santa Eufemia",
                        "latitude": "38.60000000",
                        "longitude": "-4.90000000"
                    },
                    {
                        "id": 37104,
                        "name": "Santaella",
                        "latitude": "37.56294000",
                        "longitude": "-4.84362000"
                    },
                    {
                        "id": 37513,
                        "name": "Torrecampo",
                        "latitude": "38.46667000",
                        "longitude": "-4.66667000"
                    },
                    {
                        "id": 37823,
                        "name": "Valenzuela",
                        "latitude": "37.77560000",
                        "longitude": "-4.22038000"
                    },
                    {
                        "id": 151376,
                        "name": "Valsequillo",
                        "latitude": "38.46709140",
                        "longitude": "-5.37301760"
                    },
                    {
                        "id": 151377,
                        "name": "Victoria La",
                        "latitude": "37.69306200",
                        "longitude": "-4.85724930"
                    },
                    {
                        "id": 38014,
                        "name": "Villa del Río",
                        "latitude": "37.98108000",
                        "longitude": "-4.29003000"
                    },
                    {
                        "id": 38056,
                        "name": "Villafranca de Córdoba",
                        "latitude": "37.96257000",
                        "longitude": "-4.54547000"
                    },
                    {
                        "id": 38081,
                        "name": "Villaharta",
                        "latitude": "38.13333000",
                        "longitude": "-4.90000000"
                    },
                    {
                        "id": 38180,
                        "name": "Villanueva de Córdoba",
                        "latitude": "38.32277000",
                        "longitude": "-4.62873000"
                    },
                    {
                        "id": 38217,
                        "name": "Villanueva del Duque",
                        "latitude": "38.38333000",
                        "longitude": "-5.00000000"
                    },
                    {
                        "id": 151378,
                        "name": "Villanueva del Rey",
                        "latitude": "38.19788570",
                        "longitude": "-5.15167770"
                    },
                    {
                        "id": 38264,
                        "name": "Villaralto",
                        "latitude": "38.45000000",
                        "longitude": "-4.98333000"
                    },
                    {
                        "id": 38356,
                        "name": "Villaviciosa de Córdoba",
                        "latitude": "38.08333000",
                        "longitude": "-5.01667000"
                    },
                    {
                        "id": 151379,
                        "name": "Viso El",
                        "latitude": "38.48294380",
                        "longitude": "-4.95327210"
                    },
                    {
                        "id": 38507,
                        "name": "Zuheros",
                        "latitude": "37.54332000",
                        "longitude": "-4.31531000"
                    }
                ]
            },
            {
                "id": 5106,
                "name": "Cuenca",
                "iso2": "CU",
                "latitude": "40.06200360",
                "longitude": "-2.16553440",
                "type": "province",
                "cities": [
                    {
                        "id": 152034,
                        "name": "Abia de la Obispalía",
                        "latitude": "40.01863040",
                        "longitude": "-2.39536820"
                    },
                    {
                        "id": 152035,
                        "name": "Acebrón El",
                        "latitude": "39.90894430",
                        "longitude": "-2.98443110"
                    },
                    {
                        "id": 32005,
                        "name": "Alarcón",
                        "latitude": "39.55000000",
                        "longitude": "-2.08333000"
                    },
                    {
                        "id": 32018,
                        "name": "Albaladejo del Cuende",
                        "latitude": "39.80684000",
                        "longitude": "-2.22903000"
                    },
                    {
                        "id": 32024,
                        "name": "Albalate de las Nogueras",
                        "latitude": "40.36614000",
                        "longitude": "-2.27718000"
                    },
                    {
                        "id": 32035,
                        "name": "Albendea",
                        "latitude": "40.48751000",
                        "longitude": "-2.41747000"
                    },
                    {
                        "id": 152036,
                        "name": "Alberca de Záncara La",
                        "latitude": "39.47993430",
                        "longitude": "-2.51979320"
                    },
                    {
                        "id": 32075,
                        "name": "Alcalá de la Vega",
                        "latitude": "40.03333000",
                        "longitude": "-1.51667000"
                    },
                    {
                        "id": 32085,
                        "name": "Alcantud",
                        "latitude": "40.54818000",
                        "longitude": "-2.33258000"
                    },
                    {
                        "id": 32137,
                        "name": "Alcázar del Rey",
                        "latitude": "40.06289000",
                        "longitude": "-2.80782000"
                    },
                    {
                        "id": 32102,
                        "name": "Alcohujate",
                        "latitude": "40.41763000",
                        "longitude": "-2.61490000"
                    },
                    {
                        "id": 32117,
                        "name": "Alconchel de la Estrella",
                        "latitude": "39.71963000",
                        "longitude": "-2.57366000"
                    },
                    {
                        "id": 32213,
                        "name": "Algarra",
                        "latitude": "40.00000000",
                        "longitude": "-1.43333000"
                    },
                    {
                        "id": 32243,
                        "name": "Aliaguilla",
                        "latitude": "39.74143000",
                        "longitude": "-1.32567000"
                    },
                    {
                        "id": 152037,
                        "name": "Almarcha La",
                        "latitude": "39.69949610",
                        "longitude": "-2.39123620"
                    },
                    {
                        "id": 152038,
                        "name": "Almendros",
                        "latitude": "39.87399870",
                        "longitude": "-2.86768610"
                    },
                    {
                        "id": 32294,
                        "name": "Almodóvar del Pinar",
                        "latitude": "39.71667000",
                        "longitude": "-1.88333000"
                    },
                    {
                        "id": 32304,
                        "name": "Almonacid del Marquesado",
                        "latitude": "39.82344000",
                        "longitude": "-2.76770000"
                    },
                    {
                        "id": 32339,
                        "name": "Altarejos",
                        "latitude": "39.91258000",
                        "longitude": "-2.35692000"
                    },
                    {
                        "id": 32410,
                        "name": "Arandilla del Arroyo",
                        "latitude": "40.51056000",
                        "longitude": "-2.38355000"
                    },
                    {
                        "id": 152076,
                        "name": "Arcas del Villar",
                        "latitude": "39.95209090",
                        "longitude": "-2.09594290"
                    },
                    {
                        "id": 32439,
                        "name": "Arcos de la Sierra",
                        "latitude": "40.34664000",
                        "longitude": "-2.11310000"
                    },
                    {
                        "id": 32475,
                        "name": "Arguisuelas",
                        "latitude": "39.83333000",
                        "longitude": "-1.81667000"
                    },
                    {
                        "id": 32501,
                        "name": "Arrancacepas",
                        "latitude": "40.30320000",
                        "longitude": "-2.35899000"
                    },
                    {
                        "id": 32545,
                        "name": "Atalaya del Cañavate",
                        "latitude": "39.51864000",
                        "longitude": "-2.25175000"
                    },
                    {
                        "id": 32637,
                        "name": "Barajas de Melo",
                        "latitude": "40.12340000",
                        "longitude": "-2.91675000"
                    },
                    {
                        "id": 32655,
                        "name": "Barchín del Hoyo",
                        "latitude": "39.66667000",
                        "longitude": "-2.06667000"
                    },
                    {
                        "id": 32691,
                        "name": "Bascuñana de San Pedro",
                        "latitude": "40.21322000",
                        "longitude": "-2.22812000"
                    },
                    {
                        "id": 32715,
                        "name": "Beamud",
                        "latitude": "40.18645000",
                        "longitude": "-1.82880000"
                    },
                    {
                        "id": 32739,
                        "name": "Belinchón",
                        "latitude": "40.04603000",
                        "longitude": "-3.05517000"
                    },
                    {
                        "id": 32748,
                        "name": "Belmonte",
                        "latitude": "39.55746000",
                        "longitude": "-2.70461000"
                    },
                    {
                        "id": 32751,
                        "name": "Belmontejo",
                        "latitude": "39.82212000",
                        "longitude": "-2.34467000"
                    },
                    {
                        "id": 32881,
                        "name": "Beteta",
                        "latitude": "40.57191000",
                        "longitude": "-2.07588000"
                    },
                    {
                        "id": 32947,
                        "name": "Boniches",
                        "latitude": "39.98333000",
                        "longitude": "-1.61667000"
                    },
                    {
                        "id": 32998,
                        "name": "Buciegas",
                        "latitude": "40.33622000",
                        "longitude": "-2.46250000"
                    },
                    {
                        "id": 33000,
                        "name": "Buenache de Alarcón",
                        "latitude": "39.65000000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 152039,
                        "name": "Buenache de la Sierra",
                        "latitude": "40.13476280",
                        "longitude": "-2.00130630"
                    },
                    {
                        "id": 33006,
                        "name": "Buendía",
                        "latitude": "40.36643000",
                        "longitude": "-2.75645000"
                    },
                    {
                        "id": 33186,
                        "name": "Campillo de Altobuey",
                        "latitude": "39.60000000",
                        "longitude": "-1.80000000"
                    },
                    {
                        "id": 33196,
                        "name": "Campillos-Paravientos",
                        "latitude": "39.98333000",
                        "longitude": "-1.55000000"
                    },
                    {
                        "id": 33197,
                        "name": "Campillos-Sierra",
                        "latitude": "40.10000000",
                        "longitude": "-1.70000000"
                    },
                    {
                        "id": 152072,
                        "name": "Campos del Paraíso",
                        "latitude": "40.01103370",
                        "longitude": "-2.71827280"
                    },
                    {
                        "id": 33530,
                        "name": "Cañada del Hoyo",
                        "latitude": "39.96667000",
                        "longitude": "-1.90000000"
                    },
                    {
                        "id": 152040,
                        "name": "Cañada Juncosa",
                        "latitude": "39.54942200",
                        "longitude": "-2.25011640"
                    },
                    {
                        "id": 33221,
                        "name": "Canalejas del Arroyo",
                        "latitude": "40.36850000",
                        "longitude": "-2.49408000"
                    },
                    {
                        "id": 33532,
                        "name": "Cañamares",
                        "latitude": "40.45203000",
                        "longitude": "-2.23983000"
                    },
                    {
                        "id": 152041,
                        "name": "Cañavate El",
                        "latitude": "39.54256320",
                        "longitude": "-2.30367800"
                    },
                    {
                        "id": 33537,
                        "name": "Cañaveras",
                        "latitude": "40.35994000",
                        "longitude": "-2.39611000"
                    },
                    {
                        "id": 33538,
                        "name": "Cañaveruelas",
                        "latitude": "40.40024000",
                        "longitude": "-2.63719000"
                    },
                    {
                        "id": 33539,
                        "name": "Cañete",
                        "latitude": "40.05000000",
                        "longitude": "-1.65000000"
                    },
                    {
                        "id": 33545,
                        "name": "Cañizares",
                        "latitude": "40.51870000",
                        "longitude": "-2.19201000"
                    },
                    {
                        "id": 33286,
                        "name": "Carboneras de Guadazaón",
                        "latitude": "39.88333000",
                        "longitude": "-1.80000000"
                    },
                    {
                        "id": 33297,
                        "name": "Cardenete",
                        "latitude": "39.76667000",
                        "longitude": "-1.68333000"
                    },
                    {
                        "id": 33321,
                        "name": "Carrascosa",
                        "latitude": "40.59092000",
                        "longitude": "-2.16305000"
                    },
                    {
                        "id": 33323,
                        "name": "Carrascosa de Haro",
                        "latitude": "39.59757000",
                        "longitude": "-2.54182000"
                    },
                    {
                        "id": 33358,
                        "name": "Casas de Benítez",
                        "latitude": "39.36667000",
                        "longitude": "-2.13333000"
                    },
                    {
                        "id": 33362,
                        "name": "Casas de Fernando Alonso",
                        "latitude": "39.35065000",
                        "longitude": "-2.32402000"
                    },
                    {
                        "id": 33363,
                        "name": "Casas de Garcimolina",
                        "latitude": "40.00000000",
                        "longitude": "-1.41667000"
                    },
                    {
                        "id": 33364,
                        "name": "Casas de Guijarro",
                        "latitude": "39.35000000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 33365,
                        "name": "Casas de Haro",
                        "latitude": "39.33355000",
                        "longitude": "-2.27273000"
                    },
                    {
                        "id": 33373,
                        "name": "Casas de los Pinos",
                        "latitude": "39.33375000",
                        "longitude": "-2.36984000"
                    },
                    {
                        "id": 33379,
                        "name": "Casasimarro",
                        "latitude": "39.36667000",
                        "longitude": "-2.03333000"
                    },
                    {
                        "id": 33457,
                        "name": "Castillejo de Iniesta",
                        "latitude": "39.53333000",
                        "longitude": "-1.76667000"
                    },
                    {
                        "id": 33461,
                        "name": "Castillejo-Sierra",
                        "latitude": "40.37477000",
                        "longitude": "-2.14040000"
                    },
                    {
                        "id": 33463,
                        "name": "Castillo de Garcimuñoz",
                        "latitude": "39.65928000",
                        "longitude": "-2.38030000"
                    },
                    {
                        "id": 33466,
                        "name": "Castillo-Albaráñez",
                        "latitude": "40.29869000",
                        "longitude": "-2.39277000"
                    },
                    {
                        "id": 33600,
                        "name": "Cervera del Llano",
                        "latitude": "39.78312000",
                        "longitude": "-2.42019000"
                    },
                    {
                        "id": 33633,
                        "name": "Chillarón de Cuenca",
                        "latitude": "40.10539000",
                        "longitude": "-2.22181000"
                    },
                    {
                        "id": 33651,
                        "name": "Chumillas",
                        "latitude": "39.76667000",
                        "longitude": "-2.03333000"
                    },
                    {
                        "id": 152042,
                        "name": "Cierva La",
                        "latitude": "40.06907400",
                        "longitude": "-1.85134300"
                    },
                    {
                        "id": 33864,
                        "name": "Cuenca",
                        "latitude": "40.06667000",
                        "longitude": "-2.13333000"
                    },
                    {
                        "id": 33868,
                        "name": "Cueva del Hierro",
                        "latitude": "40.58258000",
                        "longitude": "-2.03612000"
                    },
                    {
                        "id": 34059,
                        "name": "Enguídanos",
                        "latitude": "39.66667000",
                        "longitude": "-1.60000000"
                    },
                    {
                        "id": 34244,
                        "name": "Fresneda de Altarejos",
                        "latitude": "39.92577000",
                        "longitude": "-2.31498000"
                    },
                    {
                        "id": 34246,
                        "name": "Fresneda de la Sierra",
                        "latitude": "40.39101000",
                        "longitude": "-2.14233000"
                    },
                    {
                        "id": 152043,
                        "name": "Frontera La",
                        "latitude": "40.40180400",
                        "longitude": "-2.21690300"
                    },
                    {
                        "id": 34296,
                        "name": "Fuente de Pedro Naharro",
                        "latitude": "39.92438000",
                        "longitude": "-3.00916000"
                    },
                    {
                        "id": 34321,
                        "name": "Fuentelespino de Haro",
                        "latitude": "39.68934000",
                        "longitude": "-2.66869000"
                    },
                    {
                        "id": 34322,
                        "name": "Fuentelespino de Moya",
                        "latitude": "39.91667000",
                        "longitude": "-1.46667000"
                    },
                    {
                        "id": 152075,
                        "name": "Fuentenava de Jábaga",
                        "latitude": "40.08635000",
                        "longitude": "-2.26386440"
                    },
                    {
                        "id": 34335,
                        "name": "Fuentes",
                        "latitude": "39.96667000",
                        "longitude": "-2.01667000"
                    },
                    {
                        "id": 34363,
                        "name": "Fuertescusa",
                        "latitude": "40.47552000",
                        "longitude": "-2.17620000"
                    },
                    {
                        "id": 34369,
                        "name": "Gabaldón",
                        "latitude": "39.61667000",
                        "longitude": "-1.93333000"
                    },
                    {
                        "id": 34404,
                        "name": "Garaballa",
                        "latitude": "39.81667000",
                        "longitude": "-1.36667000"
                    },
                    {
                        "id": 34431,
                        "name": "Gascueña",
                        "latitude": "40.29937000",
                        "longitude": "-2.51856000"
                    },
                    {
                        "id": 34493,
                        "name": "Graja de Campalbo",
                        "latitude": "39.90000000",
                        "longitude": "-1.26667000"
                    },
                    {
                        "id": 34494,
                        "name": "Graja de Iniesta",
                        "latitude": "39.51667000",
                        "longitude": "-1.66667000"
                    },
                    {
                        "id": 34577,
                        "name": "Henarejos",
                        "latitude": "39.86667000",
                        "longitude": "-1.48333000"
                    },
                    {
                        "id": 152044,
                        "name": "Herrumblar El",
                        "latitude": "39.40136630",
                        "longitude": "-1.62386700"
                    },
                    {
                        "id": 152045,
                        "name": "Hinojosa La",
                        "latitude": "39.72801040",
                        "longitude": "-2.41407820"
                    },
                    {
                        "id": 152046,
                        "name": "Hinojosos Los",
                        "latitude": "39.60336060",
                        "longitude": "-2.82655030"
                    },
                    {
                        "id": 152047,
                        "name": "Hito El",
                        "latitude": "39.85902850",
                        "longitude": "-2.71516510"
                    },
                    {
                        "id": 34636,
                        "name": "Honrubia",
                        "latitude": "39.61358000",
                        "longitude": "-2.28077000"
                    },
                    {
                        "id": 34642,
                        "name": "Hontanaya",
                        "latitude": "39.71553000",
                        "longitude": "-2.83516000"
                    },
                    {
                        "id": 34644,
                        "name": "Hontecillas",
                        "latitude": "39.70000000",
                        "longitude": "-2.18333000"
                    },
                    {
                        "id": 34651,
                        "name": "Horcajo de Santiago",
                        "latitude": "39.84221000",
                        "longitude": "-2.99724000"
                    },
                    {
                        "id": 34709,
                        "name": "Huélamo",
                        "latitude": "40.27658000",
                        "longitude": "-1.80957000"
                    },
                    {
                        "id": 34686,
                        "name": "Huelves",
                        "latitude": "40.04282000",
                        "longitude": "-2.88444000"
                    },
                    {
                        "id": 34714,
                        "name": "Huérguina",
                        "latitude": "40.03333000",
                        "longitude": "-1.60000000"
                    },
                    {
                        "id": 34689,
                        "name": "Huerta de la Obispalía",
                        "latitude": "39.98901000",
                        "longitude": "-2.47875000"
                    },
                    {
                        "id": 34690,
                        "name": "Huerta del Marquesado",
                        "latitude": "40.15000000",
                        "longitude": "-1.68333000"
                    },
                    {
                        "id": 34697,
                        "name": "Huete",
                        "latitude": "40.14526000",
                        "longitude": "-2.69026000"
                    },
                    {
                        "id": 34755,
                        "name": "Iniesta",
                        "latitude": "39.43333000",
                        "longitude": "-1.75000000"
                    },
                    {
                        "id": 34950,
                        "name": "Laguna del Marquesado",
                        "latitude": "40.17749000",
                        "longitude": "-1.67167000"
                    },
                    {
                        "id": 34951,
                        "name": "Lagunaseca",
                        "latitude": "40.53100000",
                        "longitude": "-2.01956000"
                    },
                    {
                        "id": 34960,
                        "name": "Landete",
                        "latitude": "39.90000000",
                        "longitude": "-1.36667000"
                    },
                    {
                        "id": 35015,
                        "name": "Ledaña",
                        "latitude": "39.36667000",
                        "longitude": "-1.70000000"
                    },
                    {
                        "id": 35020,
                        "name": "Leganiel",
                        "latitude": "40.16568000",
                        "longitude": "-2.94966000"
                    },
                    {
                        "id": 152048,
                        "name": "Majadas Las",
                        "latitude": "40.31192160",
                        "longitude": "-2.00773160"
                    },
                    {
                        "id": 35290,
                        "name": "Mariana",
                        "latitude": "40.16717000",
                        "longitude": "-2.14601000"
                    },
                    {
                        "id": 35320,
                        "name": "Masegosa",
                        "latitude": "40.54689000",
                        "longitude": "-2.02588000"
                    },
                    {
                        "id": 152049,
                        "name": "Mesas Las",
                        "latitude": "39.38778460",
                        "longitude": "-2.76428510"
                    },
                    {
                        "id": 35437,
                        "name": "Minglanilla",
                        "latitude": "39.53333000",
                        "longitude": "-1.60000000"
                    },
                    {
                        "id": 35439,
                        "name": "Mira",
                        "latitude": "39.71667000",
                        "longitude": "-1.43333000"
                    },
                    {
                        "id": 35523,
                        "name": "Monreal del Llano",
                        "latitude": "39.56888000",
                        "longitude": "-2.76046000"
                    },
                    {
                        "id": 35530,
                        "name": "Montalbanejo",
                        "latitude": "39.73369000",
                        "longitude": "-2.49911000"
                    },
                    {
                        "id": 35531,
                        "name": "Montalbo",
                        "latitude": "39.87994000",
                        "longitude": "-2.67038000"
                    },
                    {
                        "id": 35541,
                        "name": "Monteagudo de las Salinas",
                        "latitude": "39.80000000",
                        "longitude": "-1.90000000"
                    },
                    {
                        "id": 35640,
                        "name": "Mota de Altarejos",
                        "latitude": "39.88201000",
                        "longitude": "-2.30958000"
                    },
                    {
                        "id": 35641,
                        "name": "Mota del Cuervo",
                        "latitude": "39.50189000",
                        "longitude": "-2.86994000"
                    },
                    {
                        "id": 35643,
                        "name": "Motilla del Palancar",
                        "latitude": "39.56667000",
                        "longitude": "-1.88333000"
                    },
                    {
                        "id": 35646,
                        "name": "Moya",
                        "latitude": "39.95000000",
                        "longitude": "-1.36667000"
                    },
                    {
                        "id": 35712,
                        "name": "Narboneta",
                        "latitude": "39.75000000",
                        "longitude": "-1.46667000"
                    },
                    {
                        "id": 35890,
                        "name": "Olivares de Júcar",
                        "latitude": "39.76101000",
                        "longitude": "-2.35589000"
                    },
                    {
                        "id": 35896,
                        "name": "Olmeda de la Cuesta",
                        "latitude": "40.31088000",
                        "longitude": "-2.47592000"
                    },
                    {
                        "id": 35897,
                        "name": "Olmeda del Rey",
                        "latitude": "39.80000000",
                        "longitude": "-2.08333000"
                    },
                    {
                        "id": 35898,
                        "name": "Olmedilla de Alarcón",
                        "latitude": "39.61667000",
                        "longitude": "-2.10000000"
                    },
                    {
                        "id": 35899,
                        "name": "Olmedilla de Eliz",
                        "latitude": "40.30232000",
                        "longitude": "-2.41952000"
                    },
                    {
                        "id": 35969,
                        "name": "Osa de la Vega",
                        "latitude": "39.65977000",
                        "longitude": "-2.75998000"
                    },
                    {
                        "id": 36005,
                        "name": "Pajarón",
                        "latitude": "39.95000000",
                        "longitude": "-1.78333000"
                    },
                    {
                        "id": 36004,
                        "name": "Pajaroncillo",
                        "latitude": "39.95000000",
                        "longitude": "-1.73333000"
                    },
                    {
                        "id": 36036,
                        "name": "Palomares del Campo",
                        "latitude": "39.94664000",
                        "longitude": "-2.59776000"
                    },
                    {
                        "id": 152050,
                        "name": "Palomera",
                        "latitude": "40.07655610",
                        "longitude": "-2.01752420"
                    },
                    {
                        "id": 36052,
                        "name": "Paracuellos",
                        "latitude": "39.71667000",
                        "longitude": "-1.78333000"
                    },
                    {
                        "id": 36064,
                        "name": "Paredes",
                        "latitude": "40.06578000",
                        "longitude": "-2.85400000"
                    },
                    {
                        "id": 152051,
                        "name": "Parra de las Vegas La",
                        "latitude": "39.86853440",
                        "longitude": "-2.20460800"
                    },
                    {
                        "id": 152052,
                        "name": "Pedernoso El",
                        "latitude": "39.48391800",
                        "longitude": "-2.74438600"
                    },
                    {
                        "id": 152053,
                        "name": "Pedroñeras Las",
                        "latitude": "39.44800260",
                        "longitude": "-2.67602510"
                    },
                    {
                        "id": 152054,
                        "name": "Peral El",
                        "latitude": "39.49819470",
                        "longitude": "-1.89649220"
                    },
                    {
                        "id": 152055,
                        "name": "Peraleja La",
                        "latitude": "40.23543290",
                        "longitude": "-2.55508540"
                    },
                    {
                        "id": 152056,
                        "name": "Pesquera La",
                        "latitude": "39.57916620",
                        "longitude": "-1.57899940"
                    },
                    {
                        "id": 152057,
                        "name": "Picazo El",
                        "latitude": "39.44766960",
                        "longitude": "-2.09042460"
                    },
                    {
                        "id": 36193,
                        "name": "Pinarejo",
                        "latitude": "39.61639000",
                        "longitude": "-2.42592000"
                    },
                    {
                        "id": 36196,
                        "name": "Pineda de Gigüela",
                        "latitude": "40.08546000",
                        "longitude": "-2.54368000"
                    },
                    {
                        "id": 36219,
                        "name": "Piqueras del Castillo",
                        "latitude": "39.71667000",
                        "longitude": "-2.06667000"
                    },
                    {
                        "id": 152058,
                        "name": "Portalrubio de Guadamejud",
                        "latitude": "40.27265800",
                        "longitude": "-2.60342360"
                    },
                    {
                        "id": 36290,
                        "name": "Portilla",
                        "latitude": "40.28957000",
                        "longitude": "-2.08178000"
                    },
                    {
                        "id": 152059,
                        "name": "Poyatos",
                        "latitude": "40.42270210",
                        "longitude": "-2.04997770"
                    },
                    {
                        "id": 36321,
                        "name": "Pozoamargo",
                        "latitude": "39.36558000",
                        "longitude": "-2.19617000"
                    },
                    {
                        "id": 152078,
                        "name": "Pozorrubielos de la Mancha",
                        "latitude": "39.47901330",
                        "longitude": "-2.03711600"
                    },
                    {
                        "id": 36326,
                        "name": "Pozorrubio",
                        "latitude": "39.81645000",
                        "longitude": "-2.94936000"
                    },
                    {
                        "id": 152060,
                        "name": "Pozuelo El",
                        "latitude": "40.62025320",
                        "longitude": "-2.27688930"
                    },
                    {
                        "id": 36353,
                        "name": "Priego",
                        "latitude": "40.44936000",
                        "longitude": "-2.31435000"
                    },
                    {
                        "id": 152061,
                        "name": "Provencio El",
                        "latitude": "39.37597450",
                        "longitude": "-2.57133830"
                    },
                    {
                        "id": 36411,
                        "name": "Puebla de Almenara",
                        "latitude": "39.78440000",
                        "longitude": "-2.81435000"
                    },
                    {
                        "id": 36431,
                        "name": "Puebla del Salvador",
                        "latitude": "39.56667000",
                        "longitude": "-1.66667000"
                    },
                    {
                        "id": 36513,
                        "name": "Quintanar del Rey",
                        "latitude": "39.33333000",
                        "longitude": "-1.93333000"
                    },
                    {
                        "id": 36538,
                        "name": "Rada de Haro",
                        "latitude": "39.57002000",
                        "longitude": "-2.62086000"
                    },
                    {
                        "id": 36601,
                        "name": "Reíllo",
                        "latitude": "39.90000000",
                        "longitude": "-1.86667000"
                    },
                    {
                        "id": 36685,
                        "name": "Rozalén del Monte",
                        "latitude": "39.99083000",
                        "longitude": "-2.80525000"
                    },
                    {
                        "id": 36728,
                        "name": "Saceda-Trasierra",
                        "latitude": "40.15525000",
                        "longitude": "-2.85369000"
                    },
                    {
                        "id": 36733,
                        "name": "Saelices",
                        "latitude": "39.92061000",
                        "longitude": "-2.80502000"
                    },
                    {
                        "id": 36766,
                        "name": "Salinas del Manzano",
                        "latitude": "40.08333000",
                        "longitude": "-1.55000000"
                    },
                    {
                        "id": 152063,
                        "name": "Salmeroncillos",
                        "latitude": "40.50444200",
                        "longitude": "-2.52070740"
                    },
                    {
                        "id": 36780,
                        "name": "Salvacañete",
                        "latitude": "40.10000000",
                        "longitude": "-1.50000000"
                    },
                    {
                        "id": 36818,
                        "name": "San Clemente",
                        "latitude": "39.40410000",
                        "longitude": "-2.42819000"
                    },
                    {
                        "id": 36860,
                        "name": "San Lorenzo de la Parrilla",
                        "latitude": "39.85129000",
                        "longitude": "-2.36079000"
                    },
                    {
                        "id": 36863,
                        "name": "San Martín de Boniches",
                        "latitude": "39.90000000",
                        "longitude": "-1.56667000"
                    },
                    {
                        "id": 36902,
                        "name": "San Pedro Palmiches",
                        "latitude": "40.42956000",
                        "longitude": "-2.40602000"
                    },
                    {
                        "id": 37031,
                        "name": "Santa Cruz de Moya",
                        "latitude": "39.95000000",
                        "longitude": "-1.26667000"
                    },
                    {
                        "id": 152064,
                        "name": "Santa María de los Llanos",
                        "latitude": "39.49013370",
                        "longitude": "-2.80910950"
                    },
                    {
                        "id": 37086,
                        "name": "Santa María del Campo Rus",
                        "latitude": "39.55942000",
                        "longitude": "-2.42306000"
                    },
                    {
                        "id": 37090,
                        "name": "Santa María del Val",
                        "latitude": "40.50439000",
                        "longitude": "-2.04115000"
                    },
                    {
                        "id": 37266,
                        "name": "Sisante",
                        "latitude": "39.40849000",
                        "longitude": "-2.20173000"
                    },
                    {
                        "id": 152065,
                        "name": "Solera de Gabaldón",
                        "latitude": "39.74913410",
                        "longitude": "-1.97653190"
                    },
                    {
                        "id": 152079,
                        "name": "Sotorribas",
                        "latitude": "40.26752550",
                        "longitude": "-2.20399330"
                    },
                    {
                        "id": 152066,
                        "name": "Talayuelas",
                        "latitude": "39.84955750",
                        "longitude": "-1.28308510"
                    },
                    {
                        "id": 37372,
                        "name": "Tarancón",
                        "latitude": "40.00851000",
                        "longitude": "-3.00731000"
                    },
                    {
                        "id": 37664,
                        "name": "Tébar",
                        "latitude": "39.50000000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 37395,
                        "name": "Tejadillos",
                        "latitude": "40.13333000",
                        "longitude": "-1.63333000"
                    },
                    {
                        "id": 37426,
                        "name": "Tinajas",
                        "latitude": "40.32547000",
                        "longitude": "-2.58228000"
                    },
                    {
                        "id": 37478,
                        "name": "Torralba",
                        "latitude": "40.30253000",
                        "longitude": "-2.28546000"
                    },
                    {
                        "id": 37537,
                        "name": "Torrejoncillo del Rey",
                        "latitude": "40.00840000",
                        "longitude": "-2.57107000"
                    },
                    {
                        "id": 37595,
                        "name": "Torrubia del Campo",
                        "latitude": "39.89749000",
                        "longitude": "-2.96133000"
                    },
                    {
                        "id": 37596,
                        "name": "Torrubia del Castillo",
                        "latitude": "39.65852000",
                        "longitude": "-2.31171000"
                    },
                    {
                        "id": 152067,
                        "name": "Tragacete",
                        "latitude": "40.34960270",
                        "longitude": "-1.85073320"
                    },
                    {
                        "id": 37631,
                        "name": "Tresjuncos",
                        "latitude": "39.70087000",
                        "longitude": "-2.75502000"
                    },
                    {
                        "id": 37635,
                        "name": "Tribaldos",
                        "latitude": "39.97264000",
                        "longitude": "-2.89809000"
                    },
                    {
                        "id": 37673,
                        "name": "Uclés",
                        "latitude": "39.97938000",
                        "longitude": "-2.86143000"
                    },
                    {
                        "id": 37713,
                        "name": "Uña",
                        "latitude": "40.22410000",
                        "longitude": "-1.97788000"
                    },
                    {
                        "id": 152077,
                        "name": "Valdecolmenas Los",
                        "latitude": "40.10878420",
                        "longitude": "-2.47030570"
                    },
                    {
                        "id": 37768,
                        "name": "Valdemeca",
                        "latitude": "40.22367000",
                        "longitude": "-1.74358000"
                    },
                    {
                        "id": 37773,
                        "name": "Valdemorillo de la Sierra",
                        "latitude": "40.03333000",
                        "longitude": "-1.78333000"
                    },
                    {
                        "id": 37775,
                        "name": "Valdemoro-Sierra",
                        "latitude": "40.10000000",
                        "longitude": "-1.76667000"
                    },
                    {
                        "id": 37779,
                        "name": "Valdeolivas",
                        "latitude": "40.50600000",
                        "longitude": "-2.44532000"
                    },
                    {
                        "id": 152073,
                        "name": "Valdetórtola",
                        "latitude": "39.93011190",
                        "longitude": "-2.17449930"
                    },
                    {
                        "id": 152074,
                        "name": "Valeras Las",
                        "latitude": "39.78652130",
                        "longitude": "-2.15484730"
                    },
                    {
                        "id": 37831,
                        "name": "Valhermoso de la Fuente",
                        "latitude": "39.56667000",
                        "longitude": "-2.01667000"
                    },
                    {
                        "id": 152062,
                        "name": "Valle de Altomira El",
                        "latitude": "40.22465690",
                        "longitude": "-2.76370520"
                    },
                    {
                        "id": 37873,
                        "name": "Valsalobre",
                        "latitude": "40.61742000",
                        "longitude": "-2.09297000"
                    },
                    {
                        "id": 37885,
                        "name": "Valverde de Júcar",
                        "latitude": "39.71866000",
                        "longitude": "-2.22135000"
                    },
                    {
                        "id": 37897,
                        "name": "Valverdejo",
                        "latitude": "39.61667000",
                        "longitude": "-2.01667000"
                    },
                    {
                        "id": 37899,
                        "name": "Vara de Rey",
                        "latitude": "39.42595000",
                        "longitude": "-2.29404000"
                    },
                    {
                        "id": 37914,
                        "name": "Vega del Codorno",
                        "latitude": "40.42457000",
                        "longitude": "-1.91312000"
                    },
                    {
                        "id": 37934,
                        "name": "Vellisca",
                        "latitude": "40.12965000",
                        "longitude": "-2.81444000"
                    },
                    {
                        "id": 38035,
                        "name": "Villaconejos de Trabaque",
                        "latitude": "40.40064000",
                        "longitude": "-2.31956000"
                    },
                    {
                        "id": 152068,
                        "name": "Villaescusa de Haro",
                        "latitude": "39.59988760",
                        "longitude": "-2.67292020"
                    },
                    {
                        "id": 38073,
                        "name": "Villagarcía del Llano",
                        "latitude": "39.31667000",
                        "longitude": "-1.83333000"
                    },
                    {
                        "id": 38098,
                        "name": "Villalba de la Sierra",
                        "latitude": "40.23437000",
                        "longitude": "-2.08929000"
                    },
                    {
                        "id": 38103,
                        "name": "Villalba del Rey",
                        "latitude": "40.34653000",
                        "longitude": "-2.63902000"
                    },
                    {
                        "id": 38113,
                        "name": "Villalgordo del Marquesado",
                        "latitude": "39.68245000",
                        "longitude": "-2.50885000"
                    },
                    {
                        "id": 38121,
                        "name": "Villalpardo",
                        "latitude": "39.46667000",
                        "longitude": "-1.63333000"
                    },
                    {
                        "id": 38144,
                        "name": "Villamayor de Santiago",
                        "latitude": "39.73072000",
                        "longitude": "-2.92357000"
                    },
                    {
                        "id": 152069,
                        "name": "Villanueva de Guadamejud",
                        "latitude": "40.22501750",
                        "longitude": "-2.50556010"
                    },
                    {
                        "id": 38199,
                        "name": "Villanueva de la Jara",
                        "latitude": "39.43333000",
                        "longitude": "-1.93333000"
                    },
                    {
                        "id": 38235,
                        "name": "Villar de Cañas",
                        "latitude": "39.77860000",
                        "longitude": "-2.56428000"
                    },
                    {
                        "id": 38238,
                        "name": "Villar de Domingo García",
                        "latitude": "40.23732000",
                        "longitude": "-2.29136000"
                    },
                    {
                        "id": 38247,
                        "name": "Villar de la Encina",
                        "latitude": "39.63725000",
                        "longitude": "-2.52155000"
                    },
                    {
                        "id": 38241,
                        "name": "Villar de Olalla",
                        "latitude": "40.01496000",
                        "longitude": "-2.19561000"
                    },
                    {
                        "id": 38255,
                        "name": "Villar del Humo",
                        "latitude": "39.86667000",
                        "longitude": "-1.63333000"
                    },
                    {
                        "id": 38256,
                        "name": "Villar del Infantado",
                        "latitude": "40.45514000",
                        "longitude": "-2.47905000"
                    },
                    {
                        "id": 152080,
                        "name": "Villar y Velasco",
                        "latitude": "40.14094250",
                        "longitude": "-2.40111240"
                    },
                    {
                        "id": 38271,
                        "name": "Villarejo de Fuentes",
                        "latitude": "39.78809000",
                        "longitude": "-2.69680000"
                    },
                    {
                        "id": 38274,
                        "name": "Villarejo de la Peñuela",
                        "latitude": "40.08745000",
                        "longitude": "-2.40996000"
                    },
                    {
                        "id": 38277,
                        "name": "Villarejo-Periesteban",
                        "latitude": "39.87231000",
                        "longitude": "-2.44145000"
                    },
                    {
                        "id": 38282,
                        "name": "Villares del Saz",
                        "latitude": "39.84109000",
                        "longitude": "-2.50427000"
                    },
                    {
                        "id": 38304,
                        "name": "Villarrubio",
                        "latitude": "39.94511000",
                        "longitude": "-2.89431000"
                    },
                    {
                        "id": 38306,
                        "name": "Villarta",
                        "latitude": "39.45000000",
                        "longitude": "-1.65000000"
                    },
                    {
                        "id": 152070,
                        "name": "Villas de la Ventosa",
                        "latitude": "40.20541470",
                        "longitude": "-2.43254220"
                    },
                    {
                        "id": 38351,
                        "name": "Villaverde y Pasaconsol",
                        "latitude": "39.77099000",
                        "longitude": "-2.26552000"
                    },
                    {
                        "id": 152071,
                        "name": "Víllora",
                        "latitude": "39.75347930",
                        "longitude": "-1.58718120"
                    },
                    {
                        "id": 38392,
                        "name": "Vindel",
                        "latitude": "40.58743000",
                        "longitude": "-2.38060000"
                    },
                    {
                        "id": 38446,
                        "name": "Yémeda",
                        "latitude": "39.76667000",
                        "longitude": "-1.71667000"
                    },
                    {
                        "id": 38451,
                        "name": "Zafra de Záncara",
                        "latitude": "39.89203000",
                        "longitude": "-2.55786000"
                    },
                    {
                        "id": 38452,
                        "name": "Zafrilla",
                        "latitude": "40.20000000",
                        "longitude": "-1.61667000"
                    },
                    {
                        "id": 38480,
                        "name": "Zarza de Tajo",
                        "latitude": "40.01591000",
                        "longitude": "-3.12877000"
                    },
                    {
                        "id": 38484,
                        "name": "Zarzuela",
                        "latitude": "40.25902000",
                        "longitude": "-2.11034000"
                    }
                ]
            },
            {
                "id": 5333,
                "name": "Estremadura",
                "iso2": "EX",
                "latitude": "39.20849790",
                "longitude": "-7.41654810",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5334,
                "name": "Galicia",
                "iso2": "GA",
                "latitude": "42.79428750",
                "longitude": "-9.33959280",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 1191,
                "name": "Gipuzkoa",
                "iso2": "SS",
                "latitude": "43.14523600",
                "longitude": "-2.44618250",
                "type": "province",
                "cities": [
                    {
                        "id": 151321,
                        "name": "Abaltzisketa",
                        "latitude": "43.04844360",
                        "longitude": "-2.10544830"
                    },
                    {
                        "id": 31942,
                        "name": "Aduna",
                        "latitude": "43.20375000",
                        "longitude": "-2.05033000"
                    },
                    {
                        "id": 31978,
                        "name": "Aia",
                        "latitude": "43.23721000",
                        "longitude": "-2.14833000"
                    },
                    {
                        "id": 31984,
                        "name": "Aizarnazabal",
                        "latitude": "43.25591000",
                        "longitude": "-2.23607000"
                    },
                    {
                        "id": 32046,
                        "name": "Albiztur",
                        "latitude": "43.12933000",
                        "longitude": "-2.13649000"
                    },
                    {
                        "id": 151322,
                        "name": "Alegia",
                        "latitude": "43.10219050",
                        "longitude": "-2.10084860"
                    },
                    {
                        "id": 32253,
                        "name": "Alkiza",
                        "latitude": "43.17263000",
                        "longitude": "-2.10923000"
                    },
                    {
                        "id": 151346,
                        "name": "Altzaga",
                        "latitude": "43.06451690",
                        "longitude": "-2.15454030"
                    },
                    {
                        "id": 151323,
                        "name": "Altzo",
                        "latitude": "43.09948430",
                        "longitude": "-2.08306790"
                    },
                    {
                        "id": 32354,
                        "name": "Amezketa",
                        "latitude": "43.04813000",
                        "longitude": "-2.08541000"
                    },
                    {
                        "id": 32372,
                        "name": "Andoain",
                        "latitude": "43.21658000",
                        "longitude": "-2.02530000"
                    },
                    {
                        "id": 32386,
                        "name": "Anoeta",
                        "latitude": "43.16241000",
                        "longitude": "-2.07107000"
                    },
                    {
                        "id": 32396,
                        "name": "Antzuola",
                        "latitude": "43.09725000",
                        "longitude": "-2.37998000"
                    },
                    {
                        "id": 32404,
                        "name": "Arama",
                        "latitude": "43.06335000",
                        "longitude": "-2.16540000"
                    },
                    {
                        "id": 32458,
                        "name": "Aretxabaleta",
                        "latitude": "43.03414000",
                        "longitude": "-2.50456000"
                    },
                    {
                        "id": 151338,
                        "name": "Arrasate\/Mondragón",
                        "latitude": "43.06488650",
                        "longitude": "-2.49020810"
                    },
                    {
                        "id": 32538,
                        "name": "Asteasu",
                        "latitude": "43.19436000",
                        "longitude": "-2.09818000"
                    },
                    {
                        "id": 32539,
                        "name": "Astigarraga",
                        "latitude": "43.28174000",
                        "longitude": "-1.94634000"
                    },
                    {
                        "id": 32552,
                        "name": "Ataun",
                        "latitude": "43.00612000",
                        "longitude": "-2.17663000"
                    },
                    {
                        "id": 32582,
                        "name": "Azkoitia",
                        "latitude": "43.17744000",
                        "longitude": "-2.31129000"
                    },
                    {
                        "id": 32587,
                        "name": "Azpeitia",
                        "latitude": "43.18246000",
                        "longitude": "-2.26693000"
                    },
                    {
                        "id": 32623,
                        "name": "Baliarrain",
                        "latitude": "43.06928000",
                        "longitude": "-2.12781000"
                    },
                    {
                        "id": 32720,
                        "name": "Beasain",
                        "latitude": "43.05017000",
                        "longitude": "-2.20087000"
                    },
                    {
                        "id": 32733,
                        "name": "Beizama",
                        "latitude": "43.13385000",
                        "longitude": "-2.20001000"
                    },
                    {
                        "id": 151324,
                        "name": "Belauntza",
                        "latitude": "43.13577090",
                        "longitude": "-2.05304060"
                    },
                    {
                        "id": 151325,
                        "name": "Berastegi",
                        "latitude": "43.12498890",
                        "longitude": "-1.97714340"
                    },
                    {
                        "id": 32847,
                        "name": "Bergara",
                        "latitude": "43.11510000",
                        "longitude": "-2.41750000"
                    },
                    {
                        "id": 32867,
                        "name": "Berrobi",
                        "latitude": "43.14518000",
                        "longitude": "-2.02623000"
                    },
                    {
                        "id": 151326,
                        "name": "Bidegoian",
                        "latitude": "43.13925150",
                        "longitude": "-2.16037350"
                    },
                    {
                        "id": 33917,
                        "name": "Deba",
                        "latitude": "43.29571000",
                        "longitude": "-2.35213000"
                    },
                    {
                        "id": 151342,
                        "name": "Donostia-San Sebastián",
                        "latitude": "43.31823700",
                        "longitude": "-1.98170510"
                    },
                    {
                        "id": 33972,
                        "name": "Eibar",
                        "latitude": "43.18493000",
                        "longitude": "-2.47158000"
                    },
                    {
                        "id": 151328,
                        "name": "Elduain",
                        "latitude": "43.13971810",
                        "longitude": "-2.00100040"
                    },
                    {
                        "id": 151329,
                        "name": "Elgeta",
                        "latitude": "43.13621810",
                        "longitude": "-2.48947580"
                    },
                    {
                        "id": 34035,
                        "name": "Elgoibar",
                        "latitude": "43.21601000",
                        "longitude": "-2.41334000"
                    },
                    {
                        "id": 34070,
                        "name": "Errenteria",
                        "latitude": "43.31195000",
                        "longitude": "-1.90234000"
                    },
                    {
                        "id": 151341,
                        "name": "Errezil",
                        "latitude": "43.16531460",
                        "longitude": "-2.17480640"
                    },
                    {
                        "id": 34097,
                        "name": "Eskoriatza",
                        "latitude": "43.01829000",
                        "longitude": "-2.52598000"
                    },
                    {
                        "id": 151330,
                        "name": "Ezkio-Itsaso",
                        "latitude": "43.08193220",
                        "longitude": "-2.27418310"
                    },
                    {
                        "id": 151332,
                        "name": "Gabiria",
                        "latitude": "43.05058230",
                        "longitude": "-2.27935200"
                    },
                    {
                        "id": 151331,
                        "name": "Gaintza",
                        "latitude": "43.05278720",
                        "longitude": "-2.13305590"
                    },
                    {
                        "id": 34442,
                        "name": "Gaztelu",
                        "latitude": "43.11622000",
                        "longitude": "-2.02439000"
                    },
                    {
                        "id": 34460,
                        "name": "Getaria",
                        "latitude": "43.30326000",
                        "longitude": "-2.20444000"
                    },
                    {
                        "id": 34588,
                        "name": "Hernani",
                        "latitude": "43.26615000",
                        "longitude": "-1.97615000"
                    },
                    {
                        "id": 34590,
                        "name": "Hernialde",
                        "latitude": "43.15446000",
                        "longitude": "-2.08521000"
                    },
                    {
                        "id": 34633,
                        "name": "Hondarribia",
                        "latitude": "43.36859000",
                        "longitude": "-1.79622000"
                    },
                    {
                        "id": 151333,
                        "name": "Ibarra",
                        "latitude": "43.14924640",
                        "longitude": "-2.04446510"
                    },
                    {
                        "id": 34733,
                        "name": "Idiazabal",
                        "latitude": "43.01189000",
                        "longitude": "-2.23356000"
                    },
                    {
                        "id": 151334,
                        "name": "Ikaztegieta",
                        "latitude": "43.09389380",
                        "longitude": "-2.12354470"
                    },
                    {
                        "id": 34762,
                        "name": "Irun",
                        "latitude": "43.33904000",
                        "longitude": "-1.78938000"
                    },
                    {
                        "id": 34763,
                        "name": "Irura",
                        "latitude": "43.16651000",
                        "longitude": "-2.06746000"
                    },
                    {
                        "id": 151335,
                        "name": "Itsasondo",
                        "latitude": "43.06765020",
                        "longitude": "-2.16528630"
                    },
                    {
                        "id": 34980,
                        "name": "Larraul",
                        "latitude": "43.18773000",
                        "longitude": "-2.10202000"
                    },
                    {
                        "id": 151345,
                        "name": "Lasarte-Oria",
                        "latitude": "43.26843770",
                        "longitude": "-2.01781490"
                    },
                    {
                        "id": 151336,
                        "name": "Lazkao",
                        "latitude": "43.04351600",
                        "longitude": "-2.19047280"
                    },
                    {
                        "id": 35009,
                        "name": "Leaburu",
                        "latitude": "43.12188000",
                        "longitude": "-2.05430000"
                    },
                    {
                        "id": 151337,
                        "name": "Legazpi",
                        "latitude": "43.05235710",
                        "longitude": "-2.33151430"
                    },
                    {
                        "id": 35024,
                        "name": "Legorreta",
                        "latitude": "43.08464000",
                        "longitude": "-2.15017000"
                    },
                    {
                        "id": 35025,
                        "name": "Leintz-Gatzaga",
                        "latitude": "42.98684000",
                        "longitude": "-2.56851000"
                    },
                    {
                        "id": 35042,
                        "name": "Lezo",
                        "latitude": "43.32142000",
                        "longitude": "-1.89739000"
                    },
                    {
                        "id": 35059,
                        "name": "Lizartza",
                        "latitude": "43.10236000",
                        "longitude": "-2.03489000"
                    },
                    {
                        "id": 35398,
                        "name": "Mendaro",
                        "latitude": "43.25326000",
                        "longitude": "-2.38568000"
                    },
                    {
                        "id": 35689,
                        "name": "Mutiloa",
                        "latitude": "43.02288000",
                        "longitude": "-2.27257000"
                    },
                    {
                        "id": 35690,
                        "name": "Mutriku",
                        "latitude": "43.30643000",
                        "longitude": "-2.38517000"
                    },
                    {
                        "id": 151339,
                        "name": "Oiartzun",
                        "latitude": "43.29883800",
                        "longitude": "-1.86241560"
                    },
                    {
                        "id": 35872,
                        "name": "Olaberria",
                        "latitude": "43.02726000",
                        "longitude": "-2.20349000"
                    },
                    {
                        "id": 35989,
                        "name": "Oñati",
                        "latitude": "43.03262000",
                        "longitude": "-2.40997000"
                    },
                    {
                        "id": 35941,
                        "name": "Ordizia",
                        "latitude": "43.05410000",
                        "longitude": "-2.17632000"
                    },
                    {
                        "id": 35944,
                        "name": "Orendain",
                        "latitude": "43.07896000",
                        "longitude": "-2.11201000"
                    },
                    {
                        "id": 35946,
                        "name": "Orexa",
                        "latitude": "43.09382000",
                        "longitude": "-2.01119000"
                    },
                    {
                        "id": 35952,
                        "name": "Orio",
                        "latitude": "43.27870000",
                        "longitude": "-2.12537000"
                    },
                    {
                        "id": 35955,
                        "name": "Ormaiztegi",
                        "latitude": "43.04339000",
                        "longitude": "-2.25673000"
                    },
                    {
                        "id": 36073,
                        "name": "Pasaia",
                        "latitude": "43.32530000",
                        "longitude": "-1.92707000"
                    },
                    {
                        "id": 37194,
                        "name": "Segura",
                        "latitude": "43.00753000",
                        "longitude": "-2.25400000"
                    },
                    {
                        "id": 151340,
                        "name": "Soraluze\/Placencia de las Armas",
                        "latitude": "43.17400070",
                        "longitude": "-2.41266390"
                    },
                    {
                        "id": 37447,
                        "name": "Tolosa",
                        "latitude": "43.13484000",
                        "longitude": "-2.07801000"
                    },
                    {
                        "id": 37693,
                        "name": "Urnieta",
                        "latitude": "43.24727000",
                        "longitude": "-1.99084000"
                    },
                    {
                        "id": 151343,
                        "name": "Urretxu",
                        "latitude": "43.09053340",
                        "longitude": "-2.31728900"
                    },
                    {
                        "id": 37706,
                        "name": "Usurbil",
                        "latitude": "43.27164000",
                        "longitude": "-2.04912000"
                    },
                    {
                        "id": 38018,
                        "name": "Villabona",
                        "latitude": "43.18540000",
                        "longitude": "-2.05304000"
                    },
                    {
                        "id": 151344,
                        "name": "Zaldibia",
                        "latitude": "43.03881010",
                        "longitude": "-2.15054960"
                    },
                    {
                        "id": 38474,
                        "name": "Zarautz",
                        "latitude": "43.28444000",
                        "longitude": "-2.16992000"
                    },
                    {
                        "id": 38491,
                        "name": "Zegama",
                        "latitude": "42.97556000",
                        "longitude": "-2.29091000"
                    },
                    {
                        "id": 151327,
                        "name": "Zerain",
                        "latitude": "43.01127170",
                        "longitude": "-2.27257990"
                    },
                    {
                        "id": 38492,
                        "name": "Zestoa",
                        "latitude": "43.23973000",
                        "longitude": "-2.25790000"
                    },
                    {
                        "id": 38494,
                        "name": "Zizurkil",
                        "latitude": "43.19917000",
                        "longitude": "-2.07420000"
                    },
                    {
                        "id": 38508,
                        "name": "Zumaia",
                        "latitude": "43.29469000",
                        "longitude": "-2.25341000"
                    },
                    {
                        "id": 38509,
                        "name": "Zumarraga",
                        "latitude": "43.08858000",
                        "longitude": "-2.31408000"
                    }
                ]
            },
            {
                "id": 5103,
                "name": "Girona",
                "iso2": "GI",
                "latitude": "41.98034450",
                "longitude": "2.80115770",
                "type": "province",
                "cities": [
                    {
                        "id": 31967,
                        "name": "Agullana",
                        "latitude": "42.39408000",
                        "longitude": "2.84666000"
                    },
                    {
                        "id": 31981,
                        "name": "Aiguaviva",
                        "latitude": "41.93840000",
                        "longitude": "2.76217000"
                    },
                    {
                        "id": 151631,
                        "name": "Albanyà",
                        "latitude": "42.30478540",
                        "longitude": "2.72044830"
                    },
                    {
                        "id": 32050,
                        "name": "Albons",
                        "latitude": "42.10389000",
                        "longitude": "3.08433000"
                    },
                    {
                        "id": 151633,
                        "name": "Alp",
                        "latitude": "42.37284490",
                        "longitude": "1.88611600"
                    },
                    {
                        "id": 151634,
                        "name": "Amer",
                        "latitude": "42.01041740",
                        "longitude": "2.60280360"
                    },
                    {
                        "id": 32379,
                        "name": "Anglès",
                        "latitude": "41.95617000",
                        "longitude": "2.63603000"
                    },
                    {
                        "id": 32427,
                        "name": "Arbúcies",
                        "latitude": "41.81667000",
                        "longitude": "2.51667000"
                    },
                    {
                        "id": 32468,
                        "name": "Argelaguer",
                        "latitude": "42.21563000",
                        "longitude": "2.64193000"
                    },
                    {
                        "id": 151635,
                        "name": "Armentera L",
                        "latitude": "42.17176030",
                        "longitude": "3.07389920"
                    },
                    {
                        "id": 151636,
                        "name": "Avinyonet de Puigventós",
                        "latitude": "42.25054280",
                        "longitude": "2.91197810"
                    },
                    {
                        "id": 32634,
                        "name": "Banyoles",
                        "latitude": "42.11667000",
                        "longitude": "2.76667000"
                    },
                    {
                        "id": 33047,
                        "name": "Bàscara",
                        "latitude": "42.15998000",
                        "longitude": "2.91028000"
                    },
                    {
                        "id": 32729,
                        "name": "Begur",
                        "latitude": "41.95000000",
                        "longitude": "3.21667000"
                    },
                    {
                        "id": 151638,
                        "name": "Bellcaire dEmpordà",
                        "latitude": "42.07920420",
                        "longitude": "3.09582240"
                    },
                    {
                        "id": 32877,
                        "name": "Besalú",
                        "latitude": "42.19893000",
                        "longitude": "2.69953000"
                    },
                    {
                        "id": 32878,
                        "name": "Bescanó",
                        "latitude": "41.96603000",
                        "longitude": "2.73922000"
                    },
                    {
                        "id": 32883,
                        "name": "Beuda",
                        "latitude": "42.23722000",
                        "longitude": "2.70942000"
                    },
                    {
                        "id": 151639,
                        "name": "Bisbal dEmpordà La",
                        "latitude": "41.95864830",
                        "longitude": "3.03978870"
                    },
                    {
                        "id": 151728,
                        "name": "Biure",
                        "latitude": "42.34246150",
                        "longitude": "2.90261720"
                    },
                    {
                        "id": 32909,
                        "name": "Blanes",
                        "latitude": "41.67419000",
                        "longitude": "2.79036000"
                    },
                    {
                        "id": 151641,
                        "name": "Boadella i les Escaules",
                        "latitude": "42.33044230",
                        "longitude": "2.85650870"
                    },
                    {
                        "id": 32942,
                        "name": "Bolvir",
                        "latitude": "42.41775000",
                        "longitude": "1.87986000"
                    },
                    {
                        "id": 32952,
                        "name": "Bordils",
                        "latitude": "42.04336000",
                        "longitude": "2.91088000"
                    },
                    {
                        "id": 32960,
                        "name": "Borrassà",
                        "latitude": "42.22316000",
                        "longitude": "2.92610000"
                    },
                    {
                        "id": 32976,
                        "name": "Breda",
                        "latitude": "41.74833000",
                        "longitude": "2.55964000"
                    },
                    {
                        "id": 151640,
                        "name": "Brunyola",
                        "latitude": "41.90452250",
                        "longitude": "2.68419370"
                    },
                    {
                        "id": 33066,
                        "name": "Cabanelles",
                        "latitude": "42.23068000",
                        "longitude": "2.81997000"
                    },
                    {
                        "id": 33116,
                        "name": "Cadaqués",
                        "latitude": "42.28856000",
                        "longitude": "3.27706000"
                    },
                    {
                        "id": 151642,
                        "name": "Caldes de Malavella",
                        "latitude": "41.83601630",
                        "longitude": "2.80844660"
                    },
                    {
                        "id": 33150,
                        "name": "Calonge",
                        "latitude": "41.85869000",
                        "longitude": "3.07926000"
                    },
                    {
                        "id": 33215,
                        "name": "Camós",
                        "latitude": "42.08776000",
                        "longitude": "2.76288000"
                    },
                    {
                        "id": 33185,
                        "name": "Campdevànol",
                        "latitude": "42.22445000",
                        "longitude": "2.16860000"
                    },
                    {
                        "id": 151643,
                        "name": "Campelles",
                        "latitude": "42.29486230",
                        "longitude": "2.14164840"
                    },
                    {
                        "id": 151644,
                        "name": "Campllong",
                        "latitude": "41.89370080",
                        "longitude": "2.83192200"
                    },
                    {
                        "id": 33213,
                        "name": "Camprodon",
                        "latitude": "42.31185000",
                        "longitude": "2.36506000"
                    },
                    {
                        "id": 151645,
                        "name": "Canet dAdri",
                        "latitude": "42.03277150",
                        "longitude": "2.73749490"
                    },
                    {
                        "id": 33252,
                        "name": "Cantallops",
                        "latitude": "42.42216000",
                        "longitude": "2.92524000"
                    },
                    {
                        "id": 33271,
                        "name": "Capmany",
                        "latitude": "42.37351000",
                        "longitude": "2.92026000"
                    },
                    {
                        "id": 33395,
                        "name": "Cassà de la Selva",
                        "latitude": "41.88784000",
                        "longitude": "2.87524000"
                    },
                    {
                        "id": 151649,
                        "name": "Castell-Platja dAro",
                        "latitude": "41.81796330",
                        "longitude": "3.06687270"
                    },
                    {
                        "id": 151647,
                        "name": "Castellfollit de la Roca",
                        "latitude": "42.21973100",
                        "longitude": "2.54889180"
                    },
                    {
                        "id": 151648,
                        "name": "Castelló dEmpúries",
                        "latitude": "42.24411270",
                        "longitude": "3.08767830"
                    },
                    {
                        "id": 151712,
                        "name": "Cellera de Ter La",
                        "latitude": "41.96853850",
                        "longitude": "2.62078800"
                    },
                    {
                        "id": 33566,
                        "name": "Celrà",
                        "latitude": "42.03333000",
                        "longitude": "2.88333000"
                    },
                    {
                        "id": 33605,
                        "name": "Cervià de Ter",
                        "latitude": "42.06650000",
                        "longitude": "2.90743000"
                    },
                    {
                        "id": 33692,
                        "name": "Cistella",
                        "latitude": "42.26870000",
                        "longitude": "2.84780000"
                    },
                    {
                        "id": 33726,
                        "name": "Colera",
                        "latitude": "42.40394000",
                        "longitude": "3.15153000"
                    },
                    {
                        "id": 151650,
                        "name": "Colomers",
                        "latitude": "42.08452060",
                        "longitude": "2.98818160"
                    },
                    {
                        "id": 151651,
                        "name": "Corçà",
                        "latitude": "41.98725890",
                        "longitude": "3.01443820"
                    },
                    {
                        "id": 33795,
                        "name": "Cornellà del Terri",
                        "latitude": "42.08333000",
                        "longitude": "2.81667000"
                    },
                    {
                        "id": 33833,
                        "name": "Crespià",
                        "latitude": "42.18333000",
                        "longitude": "2.80000000"
                    },
                    {
                        "id": 151729,
                        "name": "Cruïlles  Monells i Sant Sadurní de lHeura",
                        "latitude": "41.95705590",
                        "longitude": "2.99223480"
                    },
                    {
                        "id": 33912,
                        "name": "Darnius",
                        "latitude": "42.36667000",
                        "longitude": "2.83333000"
                    },
                    {
                        "id": 151652,
                        "name": "Das",
                        "latitude": "42.35395480",
                        "longitude": "1.87574220"
                    },
                    {
                        "id": 151653,
                        "name": "Escala L",
                        "latitude": "42.11985040",
                        "longitude": "3.12277020"
                    },
                    {
                        "id": 151654,
                        "name": "Espinelves",
                        "latitude": "41.86978760",
                        "longitude": "2.41747460"
                    },
                    {
                        "id": 34129,
                        "name": "Espolla",
                        "latitude": "42.39120000",
                        "longitude": "3.00064000"
                    },
                    {
                        "id": 34130,
                        "name": "Esponellà",
                        "latitude": "42.16667000",
                        "longitude": "2.80000000"
                    },
                    {
                        "id": 151632,
                        "name": "Far dEmpordà El",
                        "latitude": "42.25208810",
                        "longitude": "2.99568360"
                    },
                    {
                        "id": 34184,
                        "name": "Figueres",
                        "latitude": "42.26645000",
                        "longitude": "2.96163000"
                    },
                    {
                        "id": 151655,
                        "name": "Flaçà",
                        "latitude": "42.04689830",
                        "longitude": "2.95428440"
                    },
                    {
                        "id": 34199,
                        "name": "Foixà",
                        "latitude": "42.03626000",
                        "longitude": "3.00021000"
                    },
                    {
                        "id": 151656,
                        "name": "Fontanals de Cerdanya",
                        "latitude": "42.38765500",
                        "longitude": "1.91969490"
                    },
                    {
                        "id": 151657,
                        "name": "Fontanilles",
                        "latitude": "41.98203050",
                        "longitude": "2.82163670"
                    },
                    {
                        "id": 151658,
                        "name": "Fontcoberta",
                        "latitude": "42.14722530",
                        "longitude": "2.77241170"
                    },
                    {
                        "id": 151730,
                        "name": "Forallac",
                        "latitude": "41.94767640",
                        "longitude": "3.08767830"
                    },
                    {
                        "id": 34225,
                        "name": "Fornells de la Selva",
                        "latitude": "41.93159000",
                        "longitude": "2.80907000"
                    },
                    {
                        "id": 34230,
                        "name": "Fortià",
                        "latitude": "42.24320000",
                        "longitude": "3.03881000"
                    },
                    {
                        "id": 34425,
                        "name": "Garrigàs",
                        "latitude": "42.19343000",
                        "longitude": "2.95438000"
                    },
                    {
                        "id": 151659,
                        "name": "Garrigoles",
                        "latitude": "42.10276900",
                        "longitude": "3.02257540"
                    },
                    {
                        "id": 34424,
                        "name": "Garriguella",
                        "latitude": "42.34392000",
                        "longitude": "3.06506000"
                    },
                    {
                        "id": 151660,
                        "name": "Ger",
                        "latitude": "42.41159660",
                        "longitude": "1.84585500"
                    },
                    {
                        "id": 34470,
                        "name": "Girona",
                        "latitude": "41.98311000",
                        "longitude": "2.82493000"
                    },
                    {
                        "id": 151661,
                        "name": "Gombrèn",
                        "latitude": "42.24776280",
                        "longitude": "2.09073110"
                    },
                    {
                        "id": 34534,
                        "name": "Gualta",
                        "latitude": "42.02953000",
                        "longitude": "3.10312000"
                    },
                    {
                        "id": 151662,
                        "name": "Guils de Cerdanya",
                        "latitude": "42.44913430",
                        "longitude": "1.87879310"
                    },
                    {
                        "id": 34671,
                        "name": "Hostalric",
                        "latitude": "41.75000000",
                        "longitude": "2.63333000"
                    },
                    {
                        "id": 151663,
                        "name": "Isòvol",
                        "latitude": "42.37809600",
                        "longitude": "1.81766390"
                    },
                    {
                        "id": 34790,
                        "name": "Jafre",
                        "latitude": "42.07254000",
                        "longitude": "3.01062000"
                    },
                    {
                        "id": 151664,
                        "name": "Jonquera La",
                        "latitude": "42.44602070",
                        "longitude": "2.88764360"
                    },
                    {
                        "id": 34827,
                        "name": "Juià",
                        "latitude": "42.01667000",
                        "longitude": "2.91667000"
                    },
                    {
                        "id": 35063,
                        "name": "Lladó",
                        "latitude": "42.24769000",
                        "longitude": "2.81373000"
                    },
                    {
                        "id": 35064,
                        "name": "Llagostera",
                        "latitude": "41.82688000",
                        "longitude": "2.89365000"
                    },
                    {
                        "id": 35066,
                        "name": "Llambilles",
                        "latitude": "41.92106000",
                        "longitude": "2.85078000"
                    },
                    {
                        "id": 151665,
                        "name": "Llanars",
                        "latitude": "42.32052780",
                        "longitude": "2.34398070"
                    },
                    {
                        "id": 35070,
                        "name": "Llançà",
                        "latitude": "42.36241000",
                        "longitude": "3.15213000"
                    },
                    {
                        "id": 35077,
                        "name": "Llers",
                        "latitude": "42.29571000",
                        "longitude": "2.91183000"
                    },
                    {
                        "id": 151666,
                        "name": "Llívia",
                        "latitude": "42.46338990",
                        "longitude": "1.98020130"
                    },
                    {
                        "id": 35084,
                        "name": "Lloret de Mar",
                        "latitude": "41.69993000",
                        "longitude": "2.84565000"
                    },
                    {
                        "id": 151667,
                        "name": "Llosses Les",
                        "latitude": "42.15048340",
                        "longitude": "2.11587580"
                    },
                    {
                        "id": 151671,
                        "name": "Maçanet de Cabrenys",
                        "latitude": "42.38138390",
                        "longitude": "2.71827280"
                    },
                    {
                        "id": 151672,
                        "name": "Maçanet de la Selva",
                        "latitude": "41.77683240",
                        "longitude": "2.73249960"
                    },
                    {
                        "id": 35185,
                        "name": "Madremanya",
                        "latitude": "41.98333000",
                        "longitude": "2.96667000"
                    },
                    {
                        "id": 151668,
                        "name": "Maià de Montcal",
                        "latitude": "42.22134890",
                        "longitude": "2.74465540"
                    },
                    {
                        "id": 151670,
                        "name": "Masarac",
                        "latitude": "42.35080950",
                        "longitude": "2.97286870"
                    },
                    {
                        "id": 35327,
                        "name": "Massanes",
                        "latitude": "41.76536000",
                        "longitude": "2.65324000"
                    },
                    {
                        "id": 151669,
                        "name": "Meranges",
                        "latitude": "42.44599250",
                        "longitude": "1.78705510"
                    },
                    {
                        "id": 151673,
                        "name": "Mieres",
                        "latitude": "42.12407110",
                        "longitude": "2.63995840"
                    },
                    {
                        "id": 35487,
                        "name": "Mollet de Peralada",
                        "latitude": "42.35959000",
                        "longitude": "3.00034000"
                    },
                    {
                        "id": 151674,
                        "name": "Molló",
                        "latitude": "42.34673020",
                        "longitude": "2.40498530"
                    },
                    {
                        "id": 151676,
                        "name": "Mont-ras",
                        "latitude": "41.90812330",
                        "longitude": "3.15172090"
                    },
                    {
                        "id": 151675,
                        "name": "Montagut i Oix",
                        "latitude": "42.27180710",
                        "longitude": "2.52853150"
                    },
                    {
                        "id": 35786,
                        "name": "Navata",
                        "latitude": "42.22353000",
                        "longitude": "2.86110000"
                    },
                    {
                        "id": 151677,
                        "name": "Ogassa",
                        "latitude": "42.26598460",
                        "longitude": "2.27779770"
                    },
                    {
                        "id": 35912,
                        "name": "Olot",
                        "latitude": "42.18096000",
                        "longitude": "2.49012000"
                    },
                    {
                        "id": 35940,
                        "name": "Ordis",
                        "latitude": "42.21830000",
                        "longitude": "2.90705000"
                    },
                    {
                        "id": 151678,
                        "name": "Osor",
                        "latitude": "41.94551630",
                        "longitude": "2.55663390"
                    },
                    {
                        "id": 36014,
                        "name": "Palafrugell",
                        "latitude": "41.91738000",
                        "longitude": "3.16310000"
                    },
                    {
                        "id": 36015,
                        "name": "Palamós",
                        "latitude": "41.84843000",
                        "longitude": "3.12912000"
                    },
                    {
                        "id": 151679,
                        "name": "Palau de Santa Eulàlia",
                        "latitude": "42.17742940",
                        "longitude": "2.96958800"
                    },
                    {
                        "id": 36017,
                        "name": "Palau-sator",
                        "latitude": "41.98897000",
                        "longitude": "3.11016000"
                    },
                    {
                        "id": 151680,
                        "name": "Palau-saverdera",
                        "latitude": "42.30747700",
                        "longitude": "3.14736890"
                    },
                    {
                        "id": 36034,
                        "name": "Palol de Revardit",
                        "latitude": "42.06667000",
                        "longitude": "2.80000000"
                    },
                    {
                        "id": 36042,
                        "name": "Pals",
                        "latitude": "41.97102000",
                        "longitude": "3.14814000"
                    },
                    {
                        "id": 151681,
                        "name": "Pardines",
                        "latitude": "42.30327150",
                        "longitude": "2.23350660"
                    },
                    {
                        "id": 151682,
                        "name": "Parlavà",
                        "latitude": "42.02073240",
                        "longitude": "3.04009450"
                    },
                    {
                        "id": 36083,
                        "name": "Pau",
                        "latitude": "42.31607000",
                        "longitude": "3.11621000"
                    },
                    {
                        "id": 151683,
                        "name": "Pedret i Marzà",
                        "latitude": "42.31033130",
                        "longitude": "3.06810530"
                    },
                    {
                        "id": 151684,
                        "name": "Pera La",
                        "latitude": "42.01507420",
                        "longitude": "2.97255630"
                    },
                    {
                        "id": 151685,
                        "name": "Peralada",
                        "latitude": "42.30835230",
                        "longitude": "3.00944040"
                    },
                    {
                        "id": 151686,
                        "name": "Planes dHostoles Les",
                        "latitude": "42.05638630",
                        "longitude": "2.53836470"
                    },
                    {
                        "id": 36235,
                        "name": "Planoles",
                        "latitude": "42.31667000",
                        "longitude": "2.10000000"
                    },
                    {
                        "id": 36271,
                        "name": "Pont de Molins",
                        "latitude": "42.31440000",
                        "longitude": "2.92996000"
                    },
                    {
                        "id": 36276,
                        "name": "Pontós",
                        "latitude": "42.18665000",
                        "longitude": "2.91706000"
                    },
                    {
                        "id": 151687,
                        "name": "Porqueres",
                        "latitude": "42.12019530",
                        "longitude": "2.74628700"
                    },
                    {
                        "id": 151689,
                        "name": "Port de la Selva El",
                        "latitude": "42.31902480",
                        "longitude": "3.22819830"
                    },
                    {
                        "id": 36287,
                        "name": "Portbou",
                        "latitude": "42.42650000",
                        "longitude": "3.15805000"
                    },
                    {
                        "id": 151688,
                        "name": "Preses Les",
                        "latitude": "42.14639980",
                        "longitude": "2.45973460"
                    },
                    {
                        "id": 36462,
                        "name": "Puigcerdà",
                        "latitude": "42.43160000",
                        "longitude": "1.92819000"
                    },
                    {
                        "id": 151690,
                        "name": "Quart",
                        "latitude": "41.93780310",
                        "longitude": "2.84106750"
                    },
                    {
                        "id": 151646,
                        "name": "Queralbs",
                        "latitude": "42.34953030",
                        "longitude": "2.16282990"
                    },
                    {
                        "id": 36537,
                        "name": "Rabós",
                        "latitude": "42.37890000",
                        "longitude": "3.02828000"
                    },
                    {
                        "id": 36564,
                        "name": "Regencós",
                        "latitude": "41.95271000",
                        "longitude": "3.17006000"
                    },
                    {
                        "id": 36617,
                        "name": "Ribes de Freser",
                        "latitude": "42.30417000",
                        "longitude": "2.16757000"
                    },
                    {
                        "id": 151691,
                        "name": "Riells i Viabrea",
                        "latitude": "41.72936760",
                        "longitude": "2.54400260"
                    },
                    {
                        "id": 36632,
                        "name": "Ripoll",
                        "latitude": "42.20064000",
                        "longitude": "2.19033000"
                    },
                    {
                        "id": 151692,
                        "name": "Riudarenes",
                        "latitude": "41.82664320",
                        "longitude": "2.71386990"
                    },
                    {
                        "id": 151693,
                        "name": "Riudaura",
                        "latitude": "42.18885370",
                        "longitude": "2.40856240"
                    },
                    {
                        "id": 36636,
                        "name": "Riudellots de la Selva",
                        "latitude": "41.89327000",
                        "longitude": "2.80452000"
                    },
                    {
                        "id": 36638,
                        "name": "Riumors",
                        "latitude": "42.22726000",
                        "longitude": "3.04190000"
                    },
                    {
                        "id": 36679,
                        "name": "Roses",
                        "latitude": "42.26199000",
                        "longitude": "3.17689000"
                    },
                    {
                        "id": 36704,
                        "name": "Rupià",
                        "latitude": "42.01667000",
                        "longitude": "3.01667000"
                    },
                    {
                        "id": 36760,
                        "name": "Sales de Llierca",
                        "latitude": "42.23333000",
                        "longitude": "2.65000000"
                    },
                    {
                        "id": 36778,
                        "name": "Salt",
                        "latitude": "41.97489000",
                        "longitude": "2.79281000"
                    },
                    {
                        "id": 36953,
                        "name": "Sant Andreu Salou",
                        "latitude": "41.86667000",
                        "longitude": "2.83333000"
                    },
                    {
                        "id": 151709,
                        "name": "Sant Aniol de Finestres",
                        "latitude": "42.08919800",
                        "longitude": "2.59086900"
                    },
                    {
                        "id": 151694,
                        "name": "Sant Climent Sescebes",
                        "latitude": "42.36876550",
                        "longitude": "2.98119410"
                    },
                    {
                        "id": 151695,
                        "name": "Sant Feliu de Buixalleu",
                        "latitude": "41.79101370",
                        "longitude": "2.58575570"
                    },
                    {
                        "id": 36964,
                        "name": "Sant Feliu de Guíxols",
                        "latitude": "41.78333000",
                        "longitude": "3.03333000"
                    },
                    {
                        "id": 151696,
                        "name": "Sant Feliu de Pallerols",
                        "latitude": "42.07681700",
                        "longitude": "2.50865390"
                    },
                    {
                        "id": 36966,
                        "name": "Sant Ferriol",
                        "latitude": "42.20000000",
                        "longitude": "2.66667000"
                    },
                    {
                        "id": 151697,
                        "name": "Sant Gregori",
                        "latitude": "41.98940100",
                        "longitude": "2.76076570"
                    },
                    {
                        "id": 36970,
                        "name": "Sant Hilari Sacalm",
                        "latitude": "41.88333000",
                        "longitude": "2.51667000"
                    },
                    {
                        "id": 151698,
                        "name": "Sant Jaume de Llierca",
                        "latitude": "42.21105750",
                        "longitude": "2.60590380"
                    },
                    {
                        "id": 36976,
                        "name": "Sant Joan de les Abadesses",
                        "latitude": "42.23332000",
                        "longitude": "2.28524000"
                    },
                    {
                        "id": 151699,
                        "name": "Sant Joan de Mollet",
                        "latitude": "42.04616130",
                        "longitude": "2.94194530"
                    },
                    {
                        "id": 36977,
                        "name": "Sant Joan les Fonts",
                        "latitude": "42.21186000",
                        "longitude": "2.51291000"
                    },
                    {
                        "id": 36979,
                        "name": "Sant Jordi Desvalls",
                        "latitude": "42.06667000",
                        "longitude": "2.95000000"
                    },
                    {
                        "id": 151700,
                        "name": "Sant Julià de Ramis",
                        "latitude": "42.03444740",
                        "longitude": "2.83945190"
                    },
                    {
                        "id": 151731,
                        "name": "Sant Julià del Llor i Bonmatí",
                        "latitude": "41.97335800",
                        "longitude": "2.65367420"
                    },
                    {
                        "id": 151702,
                        "name": "Sant Llorenç de la Muga",
                        "latitude": "42.32253180",
                        "longitude": "2.78856260"
                    },
                    {
                        "id": 151703,
                        "name": "Sant Martí de Llémena",
                        "latitude": "42.03631410",
                        "longitude": "2.64715720"
                    },
                    {
                        "id": 36987,
                        "name": "Sant Martí Vell",
                        "latitude": "42.01667000",
                        "longitude": "2.93333000"
                    },
                    {
                        "id": 36991,
                        "name": "Sant Miquel de Campmajor",
                        "latitude": "42.13333000",
                        "longitude": "2.68333000"
                    },
                    {
                        "id": 151704,
                        "name": "Sant Miquel de Fluvià",
                        "latitude": "42.17580380",
                        "longitude": "2.99068220"
                    },
                    {
                        "id": 151705,
                        "name": "Sant Mori",
                        "latitude": "42.15514890",
                        "longitude": "2.99036960"
                    },
                    {
                        "id": 151706,
                        "name": "Sant Pau de Segúries",
                        "latitude": "42.26304370",
                        "longitude": "2.36717180"
                    },
                    {
                        "id": 36992,
                        "name": "Sant Pere Pescador",
                        "latitude": "42.18812000",
                        "longitude": "3.08212000"
                    },
                    {
                        "id": 37016,
                        "name": "Santa Coloma de Farners",
                        "latitude": "41.86667000",
                        "longitude": "2.66667000"
                    },
                    {
                        "id": 151707,
                        "name": "Santa Cristina dAro",
                        "latitude": "41.81377770",
                        "longitude": "2.99729860"
                    },
                    {
                        "id": 151708,
                        "name": "Santa Llogaia dÀlguema",
                        "latitude": "42.23350980",
                        "longitude": "2.95193850"
                    },
                    {
                        "id": 37096,
                        "name": "Santa Pau",
                        "latitude": "42.14430000",
                        "longitude": "2.57123000"
                    },
                    {
                        "id": 37171,
                        "name": "Sarrià de Ter",
                        "latitude": "42.01667000",
                        "longitude": "2.83333000"
                    },
                    {
                        "id": 151710,
                        "name": "Saus  Camallera i Llampaies",
                        "latitude": "42.13370500",
                        "longitude": "2.97255630"
                    },
                    {
                        "id": 151711,
                        "name": "Selva de Mar La",
                        "latitude": "42.32416920",
                        "longitude": "3.18706670"
                    },
                    {
                        "id": 151713,
                        "name": "Serinyà",
                        "latitude": "42.16879560",
                        "longitude": "2.74411940"
                    },
                    {
                        "id": 37219,
                        "name": "Serra de Daró",
                        "latitude": "42.02877000",
                        "longitude": "3.07222000"
                    },
                    {
                        "id": 151714,
                        "name": "Setcases",
                        "latitude": "42.37510230",
                        "longitude": "2.30182770"
                    },
                    {
                        "id": 37257,
                        "name": "Sils",
                        "latitude": "41.80842000",
                        "longitude": "2.74507000"
                    },
                    {
                        "id": 37268,
                        "name": "Siurana",
                        "latitude": "42.20916000",
                        "longitude": "2.99392000"
                    },
                    {
                        "id": 37334,
                        "name": "Susqueda",
                        "latitude": "41.97776000",
                        "longitude": "2.51652000"
                    },
                    {
                        "id": 151715,
                        "name": "Tallada dEmpordà La",
                        "latitude": "42.07891790",
                        "longitude": "3.05608770"
                    },
                    {
                        "id": 151716,
                        "name": "Terrades",
                        "latitude": "42.30994090",
                        "longitude": "2.83807720"
                    },
                    {
                        "id": 37565,
                        "name": "Torrent",
                        "latitude": "41.95243000",
                        "longitude": "3.12684000"
                    },
                    {
                        "id": 37590,
                        "name": "Torroella de Fluvià",
                        "latitude": "42.17522000",
                        "longitude": "3.04025000"
                    },
                    {
                        "id": 37591,
                        "name": "Torroella de Montgrí",
                        "latitude": "42.04254000",
                        "longitude": "3.12703000"
                    },
                    {
                        "id": 151717,
                        "name": "Tortellà",
                        "latitude": "42.23388280",
                        "longitude": "2.63195430"
                    },
                    {
                        "id": 151718,
                        "name": "Toses",
                        "latitude": "42.32660730",
                        "longitude": "2.03711600"
                    },
                    {
                        "id": 37604,
                        "name": "Tossa de Mar",
                        "latitude": "41.71667000",
                        "longitude": "2.93333000"
                    },
                    {
                        "id": 37683,
                        "name": "Ullà",
                        "latitude": "42.04964000",
                        "longitude": "3.10754000"
                    },
                    {
                        "id": 151719,
                        "name": "Ullastret",
                        "latitude": "41.97171910",
                        "longitude": "2.83009710"
                    },
                    {
                        "id": 37684,
                        "name": "Ultramort",
                        "latitude": "42.03640000",
                        "longitude": "3.03455000"
                    },
                    {
                        "id": 37702,
                        "name": "Urús",
                        "latitude": "42.35131000",
                        "longitude": "1.85343000"
                    },
                    {
                        "id": 151637,
                        "name": "Vajol La",
                        "latitude": "42.40368340",
                        "longitude": "2.80008020"
                    },
                    {
                        "id": 151721,
                        "name": "Vall de Bianya La",
                        "latitude": "42.21104920",
                        "longitude": "2.45382600"
                    },
                    {
                        "id": 151720,
                        "name": "Vall den Bas La",
                        "latitude": "42.11164050",
                        "longitude": "2.44063870"
                    },
                    {
                        "id": 151722,
                        "name": "Vall-llobrega",
                        "latitude": "41.88083120",
                        "longitude": "3.12896930"
                    },
                    {
                        "id": 151701,
                        "name": "Vallfogona de Ripollès",
                        "latitude": "42.18341820",
                        "longitude": "2.31230310"
                    },
                    {
                        "id": 37939,
                        "name": "Ventalló",
                        "latitude": "42.14921000",
                        "longitude": "3.02635000"
                    },
                    {
                        "id": 37953,
                        "name": "Verges",
                        "latitude": "42.06283000",
                        "longitude": "3.04579000"
                    },
                    {
                        "id": 37967,
                        "name": "Vidrà",
                        "latitude": "42.12285000",
                        "longitude": "2.30977000"
                    },
                    {
                        "id": 37966,
                        "name": "Vidreres",
                        "latitude": "41.78333000",
                        "longitude": "2.78333000"
                    },
                    {
                        "id": 151726,
                        "name": "Vila-sacra",
                        "latitude": "42.26540130",
                        "longitude": "3.01820540"
                    },
                    {
                        "id": 37975,
                        "name": "Vilabertran",
                        "latitude": "42.28255000",
                        "longitude": "2.98144000"
                    },
                    {
                        "id": 37976,
                        "name": "Vilablareix",
                        "latitude": "41.95746000",
                        "longitude": "2.77377000"
                    },
                    {
                        "id": 151723,
                        "name": "Viladamat",
                        "latitude": "42.13287700",
                        "longitude": "3.07452550"
                    },
                    {
                        "id": 37977,
                        "name": "Viladasens",
                        "latitude": "42.08333000",
                        "longitude": "2.93333000"
                    },
                    {
                        "id": 37979,
                        "name": "Vilademuls",
                        "latitude": "42.13890000",
                        "longitude": "2.88819000"
                    },
                    {
                        "id": 37980,
                        "name": "Viladrau",
                        "latitude": "41.84746000",
                        "longitude": "2.39019000"
                    },
                    {
                        "id": 37981,
                        "name": "Vilafant",
                        "latitude": "42.24668000",
                        "longitude": "2.93820000"
                    },
                    {
                        "id": 37986,
                        "name": "Vilajuïga",
                        "latitude": "42.32533000",
                        "longitude": "3.09302000"
                    },
                    {
                        "id": 151725,
                        "name": "Vilallonga de Ter",
                        "latitude": "42.33053200",
                        "longitude": "2.31104170"
                    },
                    {
                        "id": 37988,
                        "name": "Vilamacolum",
                        "latitude": "42.19618000",
                        "longitude": "3.05662000"
                    },
                    {
                        "id": 37989,
                        "name": "Vilamalla",
                        "latitude": "42.21720000",
                        "longitude": "2.97009000"
                    },
                    {
                        "id": 37990,
                        "name": "Vilamaniscle",
                        "latitude": "42.37522000",
                        "longitude": "3.06755000"
                    },
                    {
                        "id": 37992,
                        "name": "Vilanant",
                        "latitude": "42.25471000",
                        "longitude": "2.88923000"
                    },
                    {
                        "id": 151724,
                        "name": "Vilaür",
                        "latitude": "42.14372910",
                        "longitude": "2.95474950"
                    },
                    {
                        "id": 151727,
                        "name": "Vilobí dOnyar",
                        "latitude": "41.88889760",
                        "longitude": "2.74127650"
                    },
                    {
                        "id": 38382,
                        "name": "Vilopriu",
                        "latitude": "42.10000000",
                        "longitude": "3.00000000"
                    }
                ]
            },
            {
                "id": 5098,
                "name": "Granada",
                "iso2": "GR",
                "latitude": "37.18094110",
                "longitude": "-3.62629100",
                "type": "province",
                "cities": [
                    {
                        "id": 31950,
                        "name": "Agrón",
                        "latitude": "37.03023000",
                        "longitude": "-3.82870000"
                    },
                    {
                        "id": 31996,
                        "name": "Alamedilla",
                        "latitude": "37.58232000",
                        "longitude": "-3.24241000"
                    },
                    {
                        "id": 32048,
                        "name": "Albolote",
                        "latitude": "37.23088000",
                        "longitude": "-3.65510000"
                    },
                    {
                        "id": 32049,
                        "name": "Albondón",
                        "latitude": "36.82770000",
                        "longitude": "-3.21144000"
                    },
                    {
                        "id": 32062,
                        "name": "Albuñán",
                        "latitude": "37.22708000",
                        "longitude": "-3.13321000"
                    },
                    {
                        "id": 32060,
                        "name": "Albuñol",
                        "latitude": "36.79203000",
                        "longitude": "-3.20500000"
                    },
                    {
                        "id": 32061,
                        "name": "Albuñuelas",
                        "latitude": "36.92828000",
                        "longitude": "-3.63184000"
                    },
                    {
                        "id": 32180,
                        "name": "Aldeire",
                        "latitude": "37.16012000",
                        "longitude": "-3.07204000"
                    },
                    {
                        "id": 32188,
                        "name": "Alfacar",
                        "latitude": "37.23744000",
                        "longitude": "-3.56807000"
                    },
                    {
                        "id": 32212,
                        "name": "Algarinejo",
                        "latitude": "37.32526000",
                        "longitude": "-4.15850000"
                    },
                    {
                        "id": 32235,
                        "name": "Alhama de Granada",
                        "latitude": "37.00689000",
                        "longitude": "-3.98963000"
                    },
                    {
                        "id": 32240,
                        "name": "Alhendín",
                        "latitude": "37.10879000",
                        "longitude": "-3.64557000"
                    },
                    {
                        "id": 32246,
                        "name": "Alicún de Ortega",
                        "latitude": "37.60898000",
                        "longitude": "-3.13648000"
                    },
                    {
                        "id": 32279,
                        "name": "Almegíjar",
                        "latitude": "36.90258000",
                        "longitude": "-3.30122000"
                    },
                    {
                        "id": 32314,
                        "name": "Almuñécar",
                        "latitude": "36.73393000",
                        "longitude": "-3.69072000"
                    },
                    {
                        "id": 151405,
                        "name": "Alpujarra de la Sierra",
                        "latitude": "37.00917310",
                        "longitude": "-3.14785140"
                    },
                    {
                        "id": 32334,
                        "name": "Alquife",
                        "latitude": "37.18024000",
                        "longitude": "-3.11553000"
                    },
                    {
                        "id": 32448,
                        "name": "Arenas del Rey",
                        "latitude": "36.95799000",
                        "longitude": "-3.89362000"
                    },
                    {
                        "id": 32488,
                        "name": "Armilla",
                        "latitude": "37.14386000",
                        "longitude": "-3.62534000"
                    },
                    {
                        "id": 32550,
                        "name": "Atarfe",
                        "latitude": "37.22479000",
                        "longitude": "-3.68686000"
                    },
                    {
                        "id": 32700,
                        "name": "Baza",
                        "latitude": "37.49073000",
                        "longitude": "-2.77259000"
                    },
                    {
                        "id": 32717,
                        "name": "Beas de Granada",
                        "latitude": "37.21803000",
                        "longitude": "-3.48095000"
                    },
                    {
                        "id": 32718,
                        "name": "Beas de Guadix",
                        "latitude": "37.27861000",
                        "longitude": "-3.20579000"
                    },
                    {
                        "id": 151380,
                        "name": "Benalúa",
                        "latitude": "37.35078920",
                        "longitude": "-3.16357320"
                    },
                    {
                        "id": 32768,
                        "name": "Benalúa de las Villas",
                        "latitude": "37.42742000",
                        "longitude": "-3.68346000"
                    },
                    {
                        "id": 32770,
                        "name": "Benamaurel",
                        "latitude": "37.60826000",
                        "longitude": "-2.70250000"
                    },
                    {
                        "id": 33061,
                        "name": "Bérchules",
                        "latitude": "36.97678000",
                        "longitude": "-3.19067000"
                    },
                    {
                        "id": 32997,
                        "name": "Bubión",
                        "latitude": "36.94900000",
                        "longitude": "-3.35615000"
                    },
                    {
                        "id": 33036,
                        "name": "Busquístar",
                        "latitude": "36.93796000",
                        "longitude": "-3.29444000"
                    },
                    {
                        "id": 151381,
                        "name": "Cacín",
                        "latitude": "37.05942620",
                        "longitude": "-3.91582160"
                    },
                    {
                        "id": 33893,
                        "name": "Cádiar",
                        "latitude": "36.94591000",
                        "longitude": "-3.18020000"
                    },
                    {
                        "id": 33894,
                        "name": "Cájar",
                        "latitude": "37.13381000",
                        "longitude": "-3.57274000"
                    },
                    {
                        "id": 151392,
                        "name": "Calahorra La",
                        "latitude": "37.18148220",
                        "longitude": "-3.06388050"
                    },
                    {
                        "id": 33144,
                        "name": "Calicasas",
                        "latitude": "37.27130000",
                        "longitude": "-3.61345000"
                    },
                    {
                        "id": 33212,
                        "name": "Campotéjar",
                        "latitude": "37.48235000",
                        "longitude": "-3.61771000"
                    },
                    {
                        "id": 33901,
                        "name": "Cáñar",
                        "latitude": "36.92684000",
                        "longitude": "-3.42808000"
                    },
                    {
                        "id": 33239,
                        "name": "Caniles",
                        "latitude": "37.43671000",
                        "longitude": "-2.72482000"
                    },
                    {
                        "id": 33268,
                        "name": "Capileira",
                        "latitude": "36.96148000",
                        "longitude": "-3.35864000"
                    },
                    {
                        "id": 33276,
                        "name": "Carataunas",
                        "latitude": "36.92204000",
                        "longitude": "-3.40834000"
                    },
                    {
                        "id": 33900,
                        "name": "Cástaras",
                        "latitude": "36.93164000",
                        "longitude": "-3.25406000"
                    },
                    {
                        "id": 33468,
                        "name": "Castilléjar",
                        "latitude": "37.71697000",
                        "longitude": "-2.64060000"
                    },
                    {
                        "id": 33474,
                        "name": "Castril",
                        "latitude": "37.79581000",
                        "longitude": "-2.78002000"
                    },
                    {
                        "id": 33568,
                        "name": "Cenes de la Vega",
                        "latitude": "37.16006000",
                        "longitude": "-3.53548000"
                    },
                    {
                        "id": 33619,
                        "name": "Chauchina",
                        "latitude": "37.19977000",
                        "longitude": "-3.77157000"
                    },
                    {
                        "id": 33637,
                        "name": "Chimeneas",
                        "latitude": "37.13125000",
                        "longitude": "-3.82130000"
                    },
                    {
                        "id": 33652,
                        "name": "Churriana de la Vega",
                        "latitude": "37.14499000",
                        "longitude": "-3.64617000"
                    },
                    {
                        "id": 33666,
                        "name": "Cijuela",
                        "latitude": "37.19800000",
                        "longitude": "-3.81174000"
                    },
                    {
                        "id": 33723,
                        "name": "Cogollos de Guadix",
                        "latitude": "37.22521000",
                        "longitude": "-3.16094000"
                    },
                    {
                        "id": 151382,
                        "name": "Cogollos de la Vega",
                        "latitude": "37.27529260",
                        "longitude": "-3.57193390"
                    },
                    {
                        "id": 33747,
                        "name": "Colomera",
                        "latitude": "37.37156000",
                        "longitude": "-3.71393000"
                    },
                    {
                        "id": 33810,
                        "name": "Cortes de Baza",
                        "latitude": "37.65514000",
                        "longitude": "-2.77167000"
                    },
                    {
                        "id": 151383,
                        "name": "Cortes y Graena",
                        "latitude": "37.30694340",
                        "longitude": "-3.21747510"
                    },
                    {
                        "id": 33878,
                        "name": "Cuevas del Campo",
                        "latitude": "37.60755000",
                        "longitude": "-2.92938000"
                    },
                    {
                        "id": 151384,
                        "name": "Cúllar",
                        "latitude": "37.58283010",
                        "longitude": "-2.57057290"
                    },
                    {
                        "id": 151385,
                        "name": "Cúllar Vega",
                        "latitude": "37.15211680",
                        "longitude": "-3.67161560"
                    },
                    {
                        "id": 33914,
                        "name": "Darro",
                        "latitude": "37.34987000",
                        "longitude": "-3.29465000"
                    },
                    {
                        "id": 33920,
                        "name": "Dehesas de Guadix",
                        "latitude": "37.58876000",
                        "longitude": "-3.10317000"
                    },
                    {
                        "id": 33921,
                        "name": "Deifontes",
                        "latitude": "37.32620000",
                        "longitude": "-3.59568000"
                    },
                    {
                        "id": 33934,
                        "name": "Diezma",
                        "latitude": "37.31982000",
                        "longitude": "-3.33256000"
                    },
                    {
                        "id": 33965,
                        "name": "Dílar",
                        "latitude": "37.07282000",
                        "longitude": "-3.60134000"
                    },
                    {
                        "id": 151386,
                        "name": "Dólar",
                        "latitude": "37.17819550",
                        "longitude": "-2.99138080"
                    },
                    {
                        "id": 33966,
                        "name": "Dúdar",
                        "latitude": "37.18579000",
                        "longitude": "-3.48347000"
                    },
                    {
                        "id": 33967,
                        "name": "Dúrcal",
                        "latitude": "36.98788000",
                        "longitude": "-3.56601000"
                    },
                    {
                        "id": 34094,
                        "name": "Escúzar",
                        "latitude": "37.06219000",
                        "longitude": "-3.76126000"
                    },
                    {
                        "id": 34176,
                        "name": "Ferreira",
                        "latitude": "37.17247000",
                        "longitude": "-3.03539000"
                    },
                    {
                        "id": 34206,
                        "name": "Fonelas",
                        "latitude": "37.41042000",
                        "longitude": "-3.17158000"
                    },
                    {
                        "id": 34243,
                        "name": "Freila",
                        "latitude": "37.52990000",
                        "longitude": "-2.90828000"
                    },
                    {
                        "id": 34294,
                        "name": "Fuente Vaqueros",
                        "latitude": "37.22019000",
                        "longitude": "-3.78294000"
                    },
                    {
                        "id": 151406,
                        "name": "Gabias Las",
                        "latitude": "37.13460550",
                        "longitude": "-3.66930270"
                    },
                    {
                        "id": 34380,
                        "name": "Galera",
                        "latitude": "37.74262000",
                        "longitude": "-2.55175000"
                    },
                    {
                        "id": 34473,
                        "name": "Gobernador",
                        "latitude": "37.47845000",
                        "longitude": "-3.32119000"
                    },
                    {
                        "id": 34563,
                        "name": "Gójar",
                        "latitude": "37.10456000",
                        "longitude": "-3.60565000"
                    },
                    {
                        "id": 34484,
                        "name": "Gor",
                        "latitude": "37.36937000",
                        "longitude": "-2.97016000"
                    },
                    {
                        "id": 151387,
                        "name": "Gorafe",
                        "latitude": "37.52544290",
                        "longitude": "-3.02758020"
                    },
                    {
                        "id": 34497,
                        "name": "Granada",
                        "latitude": "37.18817000",
                        "longitude": "-3.60667000"
                    },
                    {
                        "id": 34519,
                        "name": "Guadahortuna",
                        "latitude": "37.55711000",
                        "longitude": "-3.39859000"
                    },
                    {
                        "id": 34531,
                        "name": "Guadix",
                        "latitude": "37.29932000",
                        "longitude": "-3.13922000"
                    },
                    {
                        "id": 151407,
                        "name": "Guajares Los",
                        "latitude": "36.84567480",
                        "longitude": "-3.61164940"
                    },
                    {
                        "id": 34533,
                        "name": "Gualchos",
                        "latitude": "36.74467000",
                        "longitude": "-3.39079000"
                    },
                    {
                        "id": 151388,
                        "name": "Güejar Sierra",
                        "latitude": "37.15907130",
                        "longitude": "-3.44044620"
                    },
                    {
                        "id": 34567,
                        "name": "Güevéjar",
                        "latitude": "37.25759000",
                        "longitude": "-3.59691000"
                    },
                    {
                        "id": 34708,
                        "name": "Huélago",
                        "latitude": "37.41972000",
                        "longitude": "-3.26226000"
                    },
                    {
                        "id": 34710,
                        "name": "Huéneja",
                        "latitude": "37.17660000",
                        "longitude": "-2.95024000"
                    },
                    {
                        "id": 34717,
                        "name": "Huéscar",
                        "latitude": "37.81104000",
                        "longitude": "-2.54116000"
                    },
                    {
                        "id": 151389,
                        "name": "Huétor de Santillán",
                        "latitude": "37.22283630",
                        "longitude": "-3.51501420"
                    },
                    {
                        "id": 151390,
                        "name": "Huétor Tájar",
                        "latitude": "37.19724280",
                        "longitude": "-4.04813760"
                    },
                    {
                        "id": 34719,
                        "name": "Huétor Vega",
                        "latitude": "37.14529000",
                        "longitude": "-3.56963000"
                    },
                    {
                        "id": 34749,
                        "name": "Illora",
                        "latitude": "37.28771000",
                        "longitude": "-3.88109000"
                    },
                    {
                        "id": 38580,
                        "name": "Ítrabo",
                        "latitude": "36.79998000",
                        "longitude": "-3.63899000"
                    },
                    {
                        "id": 34779,
                        "name": "Iznalloz",
                        "latitude": "37.39258000",
                        "longitude": "-3.52762000"
                    },
                    {
                        "id": 34810,
                        "name": "Jayena",
                        "latitude": "36.94920000",
                        "longitude": "-3.82313000"
                    },
                    {
                        "id": 34836,
                        "name": "Jérez del Marquesado",
                        "latitude": "37.18382000",
                        "longitude": "-3.15961000"
                    },
                    {
                        "id": 151391,
                        "name": "Jete",
                        "latitude": "36.79758460",
                        "longitude": "-3.66802800"
                    },
                    {
                        "id": 34829,
                        "name": "Jun",
                        "latitude": "37.22083000",
                        "longitude": "-3.59407000"
                    },
                    {
                        "id": 34834,
                        "name": "Juviles",
                        "latitude": "36.94879000",
                        "longitude": "-3.22586000"
                    },
                    {
                        "id": 35174,
                        "name": "Láchar",
                        "latitude": "37.19519000",
                        "longitude": "-3.83277000"
                    },
                    {
                        "id": 34967,
                        "name": "Lanjarón",
                        "latitude": "36.91853000",
                        "longitude": "-3.48180000"
                    },
                    {
                        "id": 34969,
                        "name": "Lanteira",
                        "latitude": "37.16871000",
                        "longitude": "-3.13823000"
                    },
                    {
                        "id": 151393,
                        "name": "Lecrín",
                        "latitude": "36.94747730",
                        "longitude": "-3.55280450"
                    },
                    {
                        "id": 35029,
                        "name": "Lentegí",
                        "latitude": "36.83613000",
                        "longitude": "-3.67426000"
                    },
                    {
                        "id": 35096,
                        "name": "Lobras",
                        "latitude": "36.92849000",
                        "longitude": "-3.21230000"
                    },
                    {
                        "id": 35102,
                        "name": "Loja",
                        "latitude": "37.16887000",
                        "longitude": "-4.15129000"
                    },
                    {
                        "id": 35160,
                        "name": "Lugros",
                        "latitude": "37.22942000",
                        "longitude": "-3.24150000"
                    },
                    {
                        "id": 35178,
                        "name": "Lújar",
                        "latitude": "36.78831000",
                        "longitude": "-3.40400000"
                    },
                    {
                        "id": 151394,
                        "name": "Malahá La",
                        "latitude": "37.09915010",
                        "longitude": "-3.72129700"
                    },
                    {
                        "id": 35275,
                        "name": "Maracena",
                        "latitude": "37.20764000",
                        "longitude": "-3.63493000"
                    },
                    {
                        "id": 35283,
                        "name": "Marchal",
                        "latitude": "37.29639000",
                        "longitude": "-3.20353000"
                    },
                    {
                        "id": 35463,
                        "name": "Moclín",
                        "latitude": "37.33959000",
                        "longitude": "-3.78651000"
                    },
                    {
                        "id": 35490,
                        "name": "Molvízar",
                        "latitude": "36.78592000",
                        "longitude": "-3.60783000"
                    },
                    {
                        "id": 35494,
                        "name": "Monachil",
                        "latitude": "37.13320000",
                        "longitude": "-3.53724000"
                    },
                    {
                        "id": 35548,
                        "name": "Montefrío",
                        "latitude": "37.32308000",
                        "longitude": "-4.00898000"
                    },
                    {
                        "id": 35551,
                        "name": "Montejicar",
                        "latitude": "37.57223000",
                        "longitude": "-3.50527000"
                    },
                    {
                        "id": 35578,
                        "name": "Montillana",
                        "latitude": "37.50168000",
                        "longitude": "-3.67368000"
                    },
                    {
                        "id": 35600,
                        "name": "Moraleda de Zafayona",
                        "latitude": "37.16723000",
                        "longitude": "-3.96505000"
                    },
                    {
                        "id": 151410,
                        "name": "Morelábor",
                        "latitude": "37.43266370",
                        "longitude": "-3.30867780"
                    },
                    {
                        "id": 35645,
                        "name": "Motril",
                        "latitude": "36.75066000",
                        "longitude": "-3.51790000"
                    },
                    {
                        "id": 35686,
                        "name": "Murtas",
                        "latitude": "36.88504000",
                        "longitude": "-3.10945000"
                    },
                    {
                        "id": 151404,
                        "name": "Nevada",
                        "latitude": "37.03374620",
                        "longitude": "-3.02758020"
                    },
                    {
                        "id": 35809,
                        "name": "Nigüelas",
                        "latitude": "36.97760000",
                        "longitude": "-3.53949000"
                    },
                    {
                        "id": 35845,
                        "name": "Nívar",
                        "latitude": "37.25909000",
                        "longitude": "-3.57768000"
                    },
                    {
                        "id": 35862,
                        "name": "Ogíjares",
                        "latitude": "37.11913000",
                        "longitude": "-3.60772000"
                    },
                    {
                        "id": 35936,
                        "name": "Orce",
                        "latitude": "37.72120000",
                        "longitude": "-2.47752000"
                    },
                    {
                        "id": 38583,
                        "name": "Órgiva",
                        "latitude": "36.90259000",
                        "longitude": "-3.42379000"
                    },
                    {
                        "id": 35982,
                        "name": "Otívar",
                        "latitude": "36.81582000",
                        "longitude": "-3.67979000"
                    },
                    {
                        "id": 35981,
                        "name": "Otura",
                        "latitude": "37.08846000",
                        "longitude": "-3.63321000"
                    },
                    {
                        "id": 35996,
                        "name": "Padul",
                        "latitude": "37.02462000",
                        "longitude": "-3.62678000"
                    },
                    {
                        "id": 36043,
                        "name": "Pampaneira",
                        "latitude": "36.94015000",
                        "longitude": "-3.36096000"
                    },
                    {
                        "id": 36100,
                        "name": "Pedro Martínez",
                        "latitude": "37.50290000",
                        "longitude": "-3.23134000"
                    },
                    {
                        "id": 36126,
                        "name": "Peligros",
                        "latitude": "37.23231000",
                        "longitude": "-3.62901000"
                    },
                    {
                        "id": 151395,
                        "name": "Peza La",
                        "latitude": "37.27719010",
                        "longitude": "-3.28477160"
                    },
                    {
                        "id": 36229,
                        "name": "Piñar",
                        "latitude": "37.44457000",
                        "longitude": "-3.43861000"
                    },
                    {
                        "id": 151411,
                        "name": "Pinar El",
                        "latitude": "36.89048380",
                        "longitude": "-3.55090740"
                    },
                    {
                        "id": 36211,
                        "name": "Pinos Genil",
                        "latitude": "37.16346000",
                        "longitude": "-3.50215000"
                    },
                    {
                        "id": 36212,
                        "name": "Pinos Puente",
                        "latitude": "37.25109000",
                        "longitude": "-3.74967000"
                    },
                    {
                        "id": 36267,
                        "name": "Polícar",
                        "latitude": "37.25759000",
                        "longitude": "-3.23375000"
                    },
                    {
                        "id": 36265,
                        "name": "Polopos",
                        "latitude": "36.79466000",
                        "longitude": "-3.29816000"
                    },
                    {
                        "id": 36486,
                        "name": "Pórtugos",
                        "latitude": "36.94193000",
                        "longitude": "-3.31066000"
                    },
                    {
                        "id": 36415,
                        "name": "Puebla de Don Fadrique",
                        "latitude": "37.96156000",
                        "longitude": "-2.43961000"
                    },
                    {
                        "id": 36468,
                        "name": "Pulianas",
                        "latitude": "37.22302000",
                        "longitude": "-3.60832000"
                    },
                    {
                        "id": 36477,
                        "name": "Purullena",
                        "latitude": "37.31763000",
                        "longitude": "-3.19056000"
                    },
                    {
                        "id": 36532,
                        "name": "Quéntar",
                        "latitude": "37.19253000",
                        "longitude": "-3.46653000"
                    },
                    {
                        "id": 36692,
                        "name": "Rubite",
                        "latitude": "36.80947000",
                        "longitude": "-3.34816000"
                    },
                    {
                        "id": 36746,
                        "name": "Salar",
                        "latitude": "37.15036000",
                        "longitude": "-4.06576000"
                    },
                    {
                        "id": 36774,
                        "name": "Salobreña",
                        "latitude": "36.74277000",
                        "longitude": "-3.58717000"
                    },
                    {
                        "id": 151396,
                        "name": "Santa Cruz del Comercio",
                        "latitude": "37.06145720",
                        "longitude": "-3.97572590"
                    },
                    {
                        "id": 151397,
                        "name": "Santa Fe",
                        "latitude": "37.18787850",
                        "longitude": "-3.72023910"
                    },
                    {
                        "id": 37296,
                        "name": "Soportújar",
                        "latitude": "36.92863000",
                        "longitude": "-3.40542000"
                    },
                    {
                        "id": 37305,
                        "name": "Sorvilán",
                        "latitude": "36.79505000",
                        "longitude": "-3.26769000"
                    },
                    {
                        "id": 151402,
                        "name": "Taha La",
                        "latitude": "36.92360670",
                        "longitude": "-3.33385470"
                    },
                    {
                        "id": 37506,
                        "name": "Torre-Cardela",
                        "latitude": "37.50456000",
                        "longitude": "-3.35609000"
                    },
                    {
                        "id": 151398,
                        "name": "Torvizcón",
                        "latitude": "36.87884290",
                        "longitude": "-3.29883910"
                    },
                    {
                        "id": 37634,
                        "name": "Trevélez",
                        "latitude": "37.00037000",
                        "longitude": "-3.26545000"
                    },
                    {
                        "id": 151399,
                        "name": "Turón",
                        "latitude": "36.86419890",
                        "longitude": "-3.05730690"
                    },
                    {
                        "id": 37675,
                        "name": "Ugíjar",
                        "latitude": "36.96087000",
                        "longitude": "-3.05523000"
                    },
                    {
                        "id": 151408,
                        "name": "Valle del Zalabí",
                        "latitude": "37.29121380",
                        "longitude": "-3.00756420"
                    },
                    {
                        "id": 151403,
                        "name": "Valle El",
                        "latitude": "36.93222960",
                        "longitude": "-3.59139390"
                    },
                    {
                        "id": 38413,
                        "name": "Válor",
                        "latitude": "36.99618000",
                        "longitude": "-3.08287000"
                    },
                    {
                        "id": 151412,
                        "name": "Vegas del Genil",
                        "latitude": "37.17013960",
                        "longitude": "-3.69782640"
                    },
                    {
                        "id": 38414,
                        "name": "Vélez de Benaudalla",
                        "latitude": "36.83244000",
                        "longitude": "-3.51539000"
                    },
                    {
                        "id": 37941,
                        "name": "Ventas de Huelma",
                        "latitude": "37.06840000",
                        "longitude": "-3.81983000"
                    },
                    {
                        "id": 151409,
                        "name": "Villamena",
                        "latitude": "36.98006920",
                        "longitude": "-3.60658480"
                    },
                    {
                        "id": 38208,
                        "name": "Villanueva de las Torres",
                        "latitude": "37.55719000",
                        "longitude": "-3.08868000"
                    },
                    {
                        "id": 151400,
                        "name": "Villanueva Mesía",
                        "latitude": "37.21458400",
                        "longitude": "-4.01126110"
                    },
                    {
                        "id": 38418,
                        "name": "Víznar",
                        "latitude": "37.23149000",
                        "longitude": "-3.55382000"
                    },
                    {
                        "id": 38449,
                        "name": "Zafarraya",
                        "latitude": "36.97554000",
                        "longitude": "-4.14442000"
                    },
                    {
                        "id": 38453,
                        "name": "Zagra",
                        "latitude": "37.25561000",
                        "longitude": "-4.16905000"
                    },
                    {
                        "id": 151401,
                        "name": "Zubia La",
                        "latitude": "41.37525260",
                        "longitude": "1.72088000"
                    },
                    {
                        "id": 38512,
                        "name": "Zújar",
                        "latitude": "37.54285000",
                        "longitude": "-2.84197000"
                    }
                ]
            },
            {
                "id": 5107,
                "name": "Guadalajara",
                "iso2": "GU",
                "latitude": "40.63222140",
                "longitude": "-3.19068200",
                "type": "province",
                "cities": [
                    {
                        "id": 31921,
                        "name": "Abánades",
                        "latitude": "40.89261000",
                        "longitude": "-2.48526000"
                    },
                    {
                        "id": 31916,
                        "name": "Ablanque",
                        "latitude": "40.89818000",
                        "longitude": "-2.22523000"
                    },
                    {
                        "id": 31934,
                        "name": "Adobes",
                        "latitude": "40.67584000",
                        "longitude": "-1.67916000"
                    },
                    {
                        "id": 31998,
                        "name": "Alaminos",
                        "latitude": "40.86303000",
                        "longitude": "-2.72573000"
                    },
                    {
                        "id": 32006,
                        "name": "Alarilla",
                        "latitude": "40.84711000",
                        "longitude": "-3.10310000"
                    },
                    {
                        "id": 32023,
                        "name": "Albalate de Zorita",
                        "latitude": "40.30812000",
                        "longitude": "-2.84267000"
                    },
                    {
                        "id": 32028,
                        "name": "Albares",
                        "latitude": "40.30690000",
                        "longitude": "-3.00897000"
                    },
                    {
                        "id": 32036,
                        "name": "Albendiego",
                        "latitude": "41.22742000",
                        "longitude": "-3.05171000"
                    },
                    {
                        "id": 32098,
                        "name": "Alcocer",
                        "latitude": "40.46972000",
                        "longitude": "-2.60940000"
                    },
                    {
                        "id": 32107,
                        "name": "Alcolea de las Peñas",
                        "latitude": "41.20960000",
                        "longitude": "-2.78483000"
                    },
                    {
                        "id": 32108,
                        "name": "Alcolea del Pinar",
                        "latitude": "41.03569000",
                        "longitude": "-2.46645000"
                    },
                    {
                        "id": 32121,
                        "name": "Alcoroches",
                        "latitude": "40.62669000",
                        "longitude": "-1.74629000"
                    },
                    {
                        "id": 32160,
                        "name": "Aldeanueva de Guadalajara",
                        "latitude": "40.67988000",
                        "longitude": "-3.04438000"
                    },
                    {
                        "id": 32211,
                        "name": "Algar de Mesa",
                        "latitude": "41.13494000",
                        "longitude": "-1.95964000"
                    },
                    {
                        "id": 32225,
                        "name": "Algora",
                        "latitude": "40.96324000",
                        "longitude": "-2.66688000"
                    },
                    {
                        "id": 32241,
                        "name": "Alhóndiga",
                        "latitude": "40.52669000",
                        "longitude": "-2.82438000"
                    },
                    {
                        "id": 32247,
                        "name": "Alique",
                        "latitude": "40.58671000",
                        "longitude": "-2.64441000"
                    },
                    {
                        "id": 32260,
                        "name": "Almadrones",
                        "latitude": "40.90096000",
                        "longitude": "-2.77406000"
                    },
                    {
                        "id": 32296,
                        "name": "Almoguera",
                        "latitude": "40.29713000",
                        "longitude": "-2.98240000"
                    },
                    {
                        "id": 32301,
                        "name": "Almonacid de Zorita",
                        "latitude": "40.32932000",
                        "longitude": "-2.85040000"
                    },
                    {
                        "id": 32318,
                        "name": "Alocén",
                        "latitude": "40.57455000",
                        "longitude": "-2.74993000"
                    },
                    {
                        "id": 32322,
                        "name": "Alovera",
                        "latitude": "40.59368000",
                        "longitude": "-3.24529000"
                    },
                    {
                        "id": 32343,
                        "name": "Alustante",
                        "latitude": "40.61442000",
                        "longitude": "-1.65910000"
                    },
                    {
                        "id": 152081,
                        "name": "Angón",
                        "latitude": "41.06746530",
                        "longitude": "-2.85428190"
                    },
                    {
                        "id": 32382,
                        "name": "Anguita",
                        "latitude": "41.02659000",
                        "longitude": "-2.36849000"
                    },
                    {
                        "id": 32387,
                        "name": "Anquela del Ducado",
                        "latitude": "40.97084000",
                        "longitude": "-2.13066000"
                    },
                    {
                        "id": 32388,
                        "name": "Anquela del Pedregal",
                        "latitude": "40.74336000",
                        "longitude": "-1.73697000"
                    },
                    {
                        "id": 32414,
                        "name": "Aranzueque",
                        "latitude": "40.49094000",
                        "longitude": "-3.07448000"
                    },
                    {
                        "id": 32421,
                        "name": "Arbancón",
                        "latitude": "40.96434000",
                        "longitude": "-3.11505000"
                    },
                    {
                        "id": 32423,
                        "name": "Arbeteta",
                        "latitude": "40.66999000",
                        "longitude": "-2.40236000"
                    },
                    {
                        "id": 32467,
                        "name": "Argecilla",
                        "latitude": "40.88151000",
                        "longitude": "-2.82181000"
                    },
                    {
                        "id": 32485,
                        "name": "Armallones",
                        "latitude": "40.73580000",
                        "longitude": "-2.30257000"
                    },
                    {
                        "id": 32492,
                        "name": "Armuña de Tajuña",
                        "latitude": "40.52884000",
                        "longitude": "-3.02819000"
                    },
                    {
                        "id": 32511,
                        "name": "Arroyo de las Fraguas",
                        "latitude": "41.10246000",
                        "longitude": "-3.13005000"
                    },
                    {
                        "id": 32547,
                        "name": "Atanzón",
                        "latitude": "40.66697000",
                        "longitude": "-2.99686000"
                    },
                    {
                        "id": 32555,
                        "name": "Atienza",
                        "latitude": "41.19722000",
                        "longitude": "-2.87129000"
                    },
                    {
                        "id": 32563,
                        "name": "Auñón",
                        "latitude": "40.51752000",
                        "longitude": "-2.79250000"
                    },
                    {
                        "id": 32591,
                        "name": "Azuqueca de Henares",
                        "latitude": "40.56566000",
                        "longitude": "-3.26753000"
                    },
                    {
                        "id": 32613,
                        "name": "Baides",
                        "latitude": "41.00685000",
                        "longitude": "-2.77620000"
                    },
                    {
                        "id": 32707,
                        "name": "Baños de Tajo",
                        "latitude": "40.71667000",
                        "longitude": "-1.96667000"
                    },
                    {
                        "id": 32710,
                        "name": "Bañuelos",
                        "latitude": "41.28601000",
                        "longitude": "-2.91477000"
                    },
                    {
                        "id": 32678,
                        "name": "Barriopedro",
                        "latitude": "40.79026000",
                        "longitude": "-2.75246000"
                    },
                    {
                        "id": 32862,
                        "name": "Berninches",
                        "latitude": "40.57106000",
                        "longitude": "-2.80121000"
                    },
                    {
                        "id": 152082,
                        "name": "Bodera La",
                        "latitude": "41.13489250",
                        "longitude": "-2.88701980"
                    },
                    {
                        "id": 32984,
                        "name": "Brihuega",
                        "latitude": "40.76049000",
                        "longitude": "-2.86966000"
                    },
                    {
                        "id": 32999,
                        "name": "Budia",
                        "latitude": "40.62734000",
                        "longitude": "-2.75846000"
                    },
                    {
                        "id": 33015,
                        "name": "Bujalaro",
                        "latitude": "40.93687000",
                        "longitude": "-2.88333000"
                    },
                    {
                        "id": 33037,
                        "name": "Bustares",
                        "latitude": "41.13333000",
                        "longitude": "-3.06667000"
                    },
                    {
                        "id": 33069,
                        "name": "Cabanillas del Campo",
                        "latitude": "40.63376000",
                        "longitude": "-3.22937000"
                    },
                    {
                        "id": 33192,
                        "name": "Campillo de Dueñas",
                        "latitude": "40.88376000",
                        "longitude": "-1.68505000"
                    },
                    {
                        "id": 33194,
                        "name": "Campillo de Ranas",
                        "latitude": "41.08601000",
                        "longitude": "-3.31431000"
                    },
                    {
                        "id": 33199,
                        "name": "Campisábalos",
                        "latitude": "41.26667000",
                        "longitude": "-3.13333000"
                    },
                    {
                        "id": 33543,
                        "name": "Cañizar",
                        "latitude": "40.76763000",
                        "longitude": "-3.06399000"
                    },
                    {
                        "id": 33247,
                        "name": "Canredondo",
                        "latitude": "40.81257000",
                        "longitude": "-2.49377000"
                    },
                    {
                        "id": 33253,
                        "name": "Cantalojas",
                        "latitude": "41.23472000",
                        "longitude": "-3.24629000"
                    },
                    {
                        "id": 152083,
                        "name": "Cardoso de la Sierra El",
                        "latitude": "41.09669630",
                        "longitude": "-3.46466680"
                    },
                    {
                        "id": 33342,
                        "name": "Casa de Uceda",
                        "latitude": "40.84115000",
                        "longitude": "-3.36849000"
                    },
                    {
                        "id": 152084,
                        "name": "Casar El",
                        "latitude": "40.70586210",
                        "longitude": "-3.42733200"
                    },
                    {
                        "id": 33371,
                        "name": "Casas de San Galindo",
                        "latitude": "40.87234000",
                        "longitude": "-2.95750000"
                    },
                    {
                        "id": 33394,
                        "name": "Caspueñas",
                        "latitude": "40.69497000",
                        "longitude": "-2.97941000"
                    },
                    {
                        "id": 33401,
                        "name": "Castejón de Henares",
                        "latitude": "40.93762000",
                        "longitude": "-2.78665000"
                    },
                    {
                        "id": 33421,
                        "name": "Castellar de la Muela",
                        "latitude": "40.81902000",
                        "longitude": "-1.75932000"
                    },
                    {
                        "id": 33450,
                        "name": "Castilforte",
                        "latitude": "40.55735000",
                        "longitude": "-2.43226000"
                    },
                    {
                        "id": 33469,
                        "name": "Castilnuevo",
                        "latitude": "40.81431000",
                        "longitude": "-1.85782000"
                    },
                    {
                        "id": 152085,
                        "name": "Cendejas de Enmedio",
                        "latitude": "40.98291710",
                        "longitude": "-2.87329830"
                    },
                    {
                        "id": 33567,
                        "name": "Cendejas de la Torre",
                        "latitude": "40.97916000",
                        "longitude": "-2.85053000"
                    },
                    {
                        "id": 33574,
                        "name": "Centenera",
                        "latitude": "40.65064000",
                        "longitude": "-3.05120000"
                    },
                    {
                        "id": 33621,
                        "name": "Checa",
                        "latitude": "40.58614000",
                        "longitude": "-1.79056000"
                    },
                    {
                        "id": 33625,
                        "name": "Chequilla",
                        "latitude": "40.60600000",
                        "longitude": "-1.82787000"
                    },
                    {
                        "id": 33634,
                        "name": "Chillarón del Rey",
                        "latitude": "40.59818000",
                        "longitude": "-2.69126000"
                    },
                    {
                        "id": 33636,
                        "name": "Chiloeches",
                        "latitude": "40.57038000",
                        "longitude": "-3.16003000"
                    },
                    {
                        "id": 33660,
                        "name": "Cifuentes",
                        "latitude": "40.78622000",
                        "longitude": "-2.62245000"
                    },
                    {
                        "id": 33677,
                        "name": "Cincovillas",
                        "latitude": "41.20501000",
                        "longitude": "-2.81834000"
                    },
                    {
                        "id": 33685,
                        "name": "Ciruelas",
                        "latitude": "40.75021000",
                        "longitude": "-3.08580000"
                    },
                    {
                        "id": 152086,
                        "name": "Ciruelos del Pinar",
                        "latitude": "41.00781850",
                        "longitude": "-2.22075560"
                    },
                    {
                        "id": 33708,
                        "name": "Cobeta",
                        "latitude": "40.86560000",
                        "longitude": "-2.14211000"
                    },
                    {
                        "id": 33721,
                        "name": "Cogollor",
                        "latitude": "40.84818000",
                        "longitude": "-2.74425000"
                    },
                    {
                        "id": 33724,
                        "name": "Cogolludo",
                        "latitude": "40.94691000",
                        "longitude": "-3.08930000"
                    },
                    {
                        "id": 33754,
                        "name": "Condemios de Abajo",
                        "latitude": "41.21667000",
                        "longitude": "-3.10000000"
                    },
                    {
                        "id": 33755,
                        "name": "Condemios de Arriba",
                        "latitude": "41.21644000",
                        "longitude": "-3.12543000"
                    },
                    {
                        "id": 33760,
                        "name": "Congostrina",
                        "latitude": "41.03719000",
                        "longitude": "-2.98569000"
                    },
                    {
                        "id": 33772,
                        "name": "Copernal",
                        "latitude": "40.86463000",
                        "longitude": "-3.05396000"
                    },
                    {
                        "id": 33784,
                        "name": "Corduente",
                        "latitude": "40.84304000",
                        "longitude": "-1.97841000"
                    },
                    {
                        "id": 152087,
                        "name": "Cubillo de Uceda El",
                        "latitude": "40.82327160",
                        "longitude": "-3.40757130"
                    },
                    {
                        "id": 33958,
                        "name": "Driebes",
                        "latitude": "40.24498000",
                        "longitude": "-3.04165000"
                    },
                    {
                        "id": 33964,
                        "name": "Durón",
                        "latitude": "40.62530000",
                        "longitude": "-2.72662000"
                    },
                    {
                        "id": 34040,
                        "name": "Embid",
                        "latitude": "40.97256000",
                        "longitude": "-1.71206000"
                    },
                    {
                        "id": 34080,
                        "name": "Escamilla",
                        "latitude": "40.54979000",
                        "longitude": "-2.56292000"
                    },
                    {
                        "id": 34082,
                        "name": "Escariche",
                        "latitude": "40.40553000",
                        "longitude": "-3.05310000"
                    },
                    {
                        "id": 34088,
                        "name": "Escopete",
                        "latitude": "40.41324000",
                        "longitude": "-3.00460000"
                    },
                    {
                        "id": 34120,
                        "name": "Espinosa de Henares",
                        "latitude": "40.90053000",
                        "longitude": "-3.06956000"
                    },
                    {
                        "id": 34126,
                        "name": "Esplegares",
                        "latitude": "40.85650000",
                        "longitude": "-2.37084000"
                    },
                    {
                        "id": 34135,
                        "name": "Establés",
                        "latitude": "41.00767000",
                        "longitude": "-2.02438000"
                    },
                    {
                        "id": 34148,
                        "name": "Estriégana",
                        "latitude": "41.05821000",
                        "longitude": "-2.52363000"
                    },
                    {
                        "id": 34211,
                        "name": "Fontanar",
                        "latitude": "40.72466000",
                        "longitude": "-3.17309000"
                    },
                    {
                        "id": 34274,
                        "name": "Fuembellida",
                        "latitude": "40.75589000",
                        "longitude": "-1.99861000"
                    },
                    {
                        "id": 34278,
                        "name": "Fuencemillán",
                        "latitude": "40.92063000",
                        "longitude": "-3.09818000"
                    },
                    {
                        "id": 34317,
                        "name": "Fuentelahiguera de Albatages",
                        "latitude": "40.78312000",
                        "longitude": "-3.30492000"
                    },
                    {
                        "id": 34320,
                        "name": "Fuentelencina",
                        "latitude": "40.51781000",
                        "longitude": "-2.88226000"
                    },
                    {
                        "id": 34324,
                        "name": "Fuentelsaz",
                        "latitude": "41.07359000",
                        "longitude": "-1.83108000"
                    },
                    {
                        "id": 34326,
                        "name": "Fuentelviejo",
                        "latitude": "40.52637000",
                        "longitude": "-2.98430000"
                    },
                    {
                        "id": 34329,
                        "name": "Fuentenovilla",
                        "latitude": "40.36248000",
                        "longitude": "-3.09102000"
                    },
                    {
                        "id": 34371,
                        "name": "Gajanejos",
                        "latitude": "40.84147000",
                        "longitude": "-2.89229000"
                    },
                    {
                        "id": 34399,
                        "name": "Galápagos",
                        "latitude": "40.69347000",
                        "longitude": "-3.33537000"
                    },
                    {
                        "id": 34398,
                        "name": "Galve de Sorbe",
                        "latitude": "41.21667000",
                        "longitude": "-3.18333000"
                    },
                    {
                        "id": 34432,
                        "name": "Gascueña de Bornova",
                        "latitude": "41.14243000",
                        "longitude": "-3.01924000"
                    },
                    {
                        "id": 34520,
                        "name": "Guadalajara",
                        "latitude": "40.62862000",
                        "longitude": "-3.16185000"
                    },
                    {
                        "id": 34578,
                        "name": "Henche",
                        "latitude": "40.71474000",
                        "longitude": "-2.70746000"
                    },
                    {
                        "id": 152088,
                        "name": "Heras de Ayuso",
                        "latitude": "40.78895170",
                        "longitude": "-3.09958160"
                    },
                    {
                        "id": 34602,
                        "name": "Herrería",
                        "latitude": "40.88815000",
                        "longitude": "-1.96014000"
                    },
                    {
                        "id": 34606,
                        "name": "Hiendelaencina",
                        "latitude": "41.08373000",
                        "longitude": "-3.00337000"
                    },
                    {
                        "id": 34618,
                        "name": "Hijes",
                        "latitude": "41.25139000",
                        "longitude": "-2.99989000"
                    },
                    {
                        "id": 34630,
                        "name": "Hita",
                        "latitude": "40.82149000",
                        "longitude": "-3.04540000"
                    },
                    {
                        "id": 34632,
                        "name": "Hombrados",
                        "latitude": "40.80118000",
                        "longitude": "-1.68558000"
                    },
                    {
                        "id": 34645,
                        "name": "Hontoba",
                        "latitude": "40.45385000",
                        "longitude": "-3.03858000"
                    },
                    {
                        "id": 34655,
                        "name": "Horche",
                        "latitude": "40.56399000",
                        "longitude": "-3.06110000"
                    },
                    {
                        "id": 152089,
                        "name": "Hortezuela de Océn",
                        "latitude": "40.95174940",
                        "longitude": "-2.41654830"
                    },
                    {
                        "id": 152090,
                        "name": "Huerce La",
                        "latitude": "41.15292170",
                        "longitude": "-3.17012180"
                    },
                    {
                        "id": 34716,
                        "name": "Huérmeces del Cerro",
                        "latitude": "41.05332000",
                        "longitude": "-2.79711000"
                    },
                    {
                        "id": 34692,
                        "name": "Huertahernando",
                        "latitude": "40.82348000",
                        "longitude": "-2.28697000"
                    },
                    {
                        "id": 34698,
                        "name": "Hueva",
                        "latitude": "40.46221000",
                        "longitude": "-2.96039000"
                    },
                    {
                        "id": 34700,
                        "name": "Humanes",
                        "latitude": "40.82598000",
                        "longitude": "-3.15257000"
                    },
                    {
                        "id": 34745,
                        "name": "Illana",
                        "latitude": "40.18442000",
                        "longitude": "-2.90889000"
                    },
                    {
                        "id": 34756,
                        "name": "Iniéstola",
                        "latitude": "40.99400000",
                        "longitude": "-2.37063000"
                    },
                    {
                        "id": 152091,
                        "name": "Inviernas Las",
                        "latitude": "40.87169160",
                        "longitude": "-2.67043640"
                    },
                    {
                        "id": 34761,
                        "name": "Irueste",
                        "latitude": "40.61206000",
                        "longitude": "-2.89072000"
                    },
                    {
                        "id": 34789,
                        "name": "Jadraque",
                        "latitude": "40.92454000",
                        "longitude": "-2.92468000"
                    },
                    {
                        "id": 34819,
                        "name": "Jirueque",
                        "latitude": "40.96431000",
                        "longitude": "-2.90289000"
                    },
                    {
                        "id": 35014,
                        "name": "Ledanca",
                        "latitude": "40.86881000",
                        "longitude": "-2.84340000"
                    },
                    {
                        "id": 35112,
                        "name": "Loranca de Tajuña",
                        "latitude": "40.44368000",
                        "longitude": "-3.11082000"
                    },
                    {
                        "id": 35167,
                        "name": "Lupiana",
                        "latitude": "40.60846000",
                        "longitude": "-3.05118000"
                    },
                    {
                        "id": 35171,
                        "name": "Luzaga",
                        "latitude": "40.97337000",
                        "longitude": "-2.44497000"
                    },
                    {
                        "id": 35173,
                        "name": "Luzón",
                        "latitude": "41.02691000",
                        "longitude": "-2.27691000"
                    },
                    {
                        "id": 35216,
                        "name": "Majaelrayo",
                        "latitude": "41.11260000",
                        "longitude": "-3.30257000"
                    },
                    {
                        "id": 35704,
                        "name": "Málaga del Fresno",
                        "latitude": "40.78740000",
                        "longitude": "-3.24465000"
                    },
                    {
                        "id": 35218,
                        "name": "Malaguilla",
                        "latitude": "40.81956000",
                        "longitude": "-3.25450000"
                    },
                    {
                        "id": 35247,
                        "name": "Mandayona",
                        "latitude": "40.95610000",
                        "longitude": "-2.75021000"
                    },
                    {
                        "id": 35259,
                        "name": "Mantiel",
                        "latitude": "40.61892000",
                        "longitude": "-2.66324000"
                    },
                    {
                        "id": 35276,
                        "name": "Maranchón",
                        "latitude": "41.04754000",
                        "longitude": "-2.20482000"
                    },
                    {
                        "id": 35284,
                        "name": "Marchamalo",
                        "latitude": "40.66677000",
                        "longitude": "-3.19914000"
                    },
                    {
                        "id": 35322,
                        "name": "Masegoso de Tajuña",
                        "latitude": "40.82552000",
                        "longitude": "-2.69532000"
                    },
                    {
                        "id": 35339,
                        "name": "Matarrubia",
                        "latitude": "40.86463000",
                        "longitude": "-3.28944000"
                    },
                    {
                        "id": 35346,
                        "name": "Matillas",
                        "latitude": "40.94415000",
                        "longitude": "-2.83590000"
                    },
                    {
                        "id": 35353,
                        "name": "Mazarete",
                        "latitude": "41.00086000",
                        "longitude": "-2.15921000"
                    },
                    {
                        "id": 35358,
                        "name": "Mazuecos",
                        "latitude": "40.26020000",
                        "longitude": "-3.00755000"
                    },
                    {
                        "id": 35377,
                        "name": "Medranda",
                        "latitude": "40.98333000",
                        "longitude": "-2.93719000"
                    },
                    {
                        "id": 35380,
                        "name": "Megina",
                        "latitude": "40.63911000",
                        "longitude": "-1.87041000"
                    },
                    {
                        "id": 35396,
                        "name": "Membrillera",
                        "latitude": "40.94807000",
                        "longitude": "-2.97969000"
                    },
                    {
                        "id": 35420,
                        "name": "Miedes de Atienza",
                        "latitude": "41.26672000",
                        "longitude": "-2.96375000"
                    },
                    {
                        "id": 152092,
                        "name": "Mierla La",
                        "latitude": "40.93834480",
                        "longitude": "-3.23605180"
                    },
                    {
                        "id": 35430,
                        "name": "Millana",
                        "latitude": "40.50717000",
                        "longitude": "-2.57116000"
                    },
                    {
                        "id": 35435,
                        "name": "Milmarcos",
                        "latitude": "41.08622000",
                        "longitude": "-1.87652000"
                    },
                    {
                        "id": 152093,
                        "name": "Miñosa La",
                        "latitude": "41.17930520",
                        "longitude": "-2.93226630"
                    },
                    {
                        "id": 35441,
                        "name": "Mirabueno",
                        "latitude": "40.94479000",
                        "longitude": "-2.72438000"
                    },
                    {
                        "id": 35445,
                        "name": "Miralrío",
                        "latitude": "40.88901000",
                        "longitude": "-2.94340000"
                    },
                    {
                        "id": 35461,
                        "name": "Mochales",
                        "latitude": "41.09647000",
                        "longitude": "-2.01560000"
                    },
                    {
                        "id": 35471,
                        "name": "Mohernando",
                        "latitude": "40.80129000",
                        "longitude": "-3.17234000"
                    },
                    {
                        "id": 35477,
                        "name": "Molina de Aragón",
                        "latitude": "40.84358000",
                        "longitude": "-1.88762000"
                    },
                    {
                        "id": 35495,
                        "name": "Monasterio",
                        "latitude": "40.98547000",
                        "longitude": "-3.09711000"
                    },
                    {
                        "id": 35507,
                        "name": "Mondéjar",
                        "latitude": "40.32095000",
                        "longitude": "-3.10686000"
                    },
                    {
                        "id": 35537,
                        "name": "Montarrón",
                        "latitude": "40.90675000",
                        "longitude": "-3.11495000"
                    },
                    {
                        "id": 35619,
                        "name": "Moratilla de los Meleros",
                        "latitude": "40.50182000",
                        "longitude": "-2.94276000"
                    },
                    {
                        "id": 35625,
                        "name": "Morenilla",
                        "latitude": "40.78687000",
                        "longitude": "-1.70717000"
                    },
                    {
                        "id": 35653,
                        "name": "Muduex",
                        "latitude": "40.82930000",
                        "longitude": "-2.95899000"
                    },
                    {
                        "id": 152094,
                        "name": "Navas de Jadraque Las",
                        "latitude": "41.10485800",
                        "longitude": "-3.08862100"
                    },
                    {
                        "id": 35796,
                        "name": "Negredo",
                        "latitude": "41.02737000",
                        "longitude": "-2.85878000"
                    },
                    {
                        "id": 35856,
                        "name": "Ocentejo",
                        "latitude": "40.77234000",
                        "longitude": "-2.39764000"
                    },
                    {
                        "id": 152095,
                        "name": "Olivar El",
                        "latitude": "40.60650180",
                        "longitude": "-2.74998350"
                    },
                    {
                        "id": 35895,
                        "name": "Olmeda de Cobeta",
                        "latitude": "40.85971000",
                        "longitude": "-2.18280000"
                    },
                    {
                        "id": 152096,
                        "name": "Olmeda de Jadraque La",
                        "latitude": "41.12651860",
                        "longitude": "-2.74129770"
                    },
                    {
                        "id": 152097,
                        "name": "Ordial El",
                        "latitude": "41.12772400",
                        "longitude": "-3.11462160"
                    },
                    {
                        "id": 35942,
                        "name": "Orea",
                        "latitude": "40.55725000",
                        "longitude": "-1.72738000"
                    },
                    {
                        "id": 36481,
                        "name": "Pálmaces de Jadraque",
                        "latitude": "41.05610000",
                        "longitude": "-2.91060000"
                    },
                    {
                        "id": 152098,
                        "name": "Pardos",
                        "latitude": "40.95253440",
                        "longitude": "-1.93924350"
                    },
                    {
                        "id": 36067,
                        "name": "Paredes de Sigüenza",
                        "latitude": "41.24283000",
                        "longitude": "-2.73376000"
                    },
                    {
                        "id": 36068,
                        "name": "Pareja",
                        "latitude": "40.55578000",
                        "longitude": "-2.64882000"
                    },
                    {
                        "id": 36076,
                        "name": "Pastrana",
                        "latitude": "40.41902000",
                        "longitude": "-2.92256000"
                    },
                    {
                        "id": 152099,
                        "name": "Pedregal El",
                        "latitude": "40.77931440",
                        "longitude": "-1.56991030"
                    },
                    {
                        "id": 36169,
                        "name": "Peñalén",
                        "latitude": "40.66560000",
                        "longitude": "-2.06999000"
                    },
                    {
                        "id": 36168,
                        "name": "Peñalver",
                        "latitude": "40.58140000",
                        "longitude": "-2.88890000"
                    },
                    {
                        "id": 36137,
                        "name": "Peralejos de las Truchas",
                        "latitude": "40.59336000",
                        "longitude": "-1.90953000"
                    },
                    {
                        "id": 36144,
                        "name": "Peralveche",
                        "latitude": "40.61078000",
                        "longitude": "-2.44957000"
                    },
                    {
                        "id": 36201,
                        "name": "Pinilla de Jadraque",
                        "latitude": "41.01988000",
                        "longitude": "-2.94254000"
                    },
                    {
                        "id": 36202,
                        "name": "Pinilla de Molina",
                        "latitude": "40.67969000",
                        "longitude": "-1.88034000"
                    },
                    {
                        "id": 36217,
                        "name": "Pioz",
                        "latitude": "40.46153000",
                        "longitude": "-3.17234000"
                    },
                    {
                        "id": 36218,
                        "name": "Piqueras",
                        "latitude": "40.66367000",
                        "longitude": "-1.72202000"
                    },
                    {
                        "id": 152100,
                        "name": "Pobo de Dueñas El",
                        "latitude": "40.77823620",
                        "longitude": "-1.64753220"
                    },
                    {
                        "id": 36307,
                        "name": "Poveda de la Sierra",
                        "latitude": "40.64329000",
                        "longitude": "-2.02905000"
                    },
                    {
                        "id": 36317,
                        "name": "Pozo de Almoguera",
                        "latitude": "40.34030000",
                        "longitude": "-3.02638000"
                    },
                    {
                        "id": 36318,
                        "name": "Pozo de Guadalajara",
                        "latitude": "40.49533000",
                        "longitude": "-3.18140000"
                    },
                    {
                        "id": 36405,
                        "name": "Prádena de Atienza",
                        "latitude": "41.17245000",
                        "longitude": "-3.00728000"
                    },
                    {
                        "id": 36348,
                        "name": "Prados Redondos",
                        "latitude": "40.78505000",
                        "longitude": "-1.79329000"
                    },
                    {
                        "id": 36414,
                        "name": "Puebla de Beleña",
                        "latitude": "40.88794000",
                        "longitude": "-3.21624000"
                    },
                    {
                        "id": 152101,
                        "name": "Puebla de Valles",
                        "latitude": "40.92763110",
                        "longitude": "-3.30270020"
                    },
                    {
                        "id": 36494,
                        "name": "Quer",
                        "latitude": "40.60532000",
                        "longitude": "-3.27530000"
                    },
                    {
                        "id": 36556,
                        "name": "Rebollosa de Jadraque",
                        "latitude": "41.09040000",
                        "longitude": "-2.84201000"
                    },
                    {
                        "id": 152102,
                        "name": "Recuenco El",
                        "latitude": "40.61519480",
                        "longitude": "-2.33972920"
                    },
                    {
                        "id": 36578,
                        "name": "Renera",
                        "latitude": "40.48976000",
                        "longitude": "-3.01367000"
                    },
                    {
                        "id": 36586,
                        "name": "Retiendas",
                        "latitude": "40.96835000",
                        "longitude": "-3.27229000"
                    },
                    {
                        "id": 36606,
                        "name": "Riba de Saelices",
                        "latitude": "40.91145000",
                        "longitude": "-2.29715000"
                    },
                    {
                        "id": 36625,
                        "name": "Rillo de Gallo",
                        "latitude": "40.86635000",
                        "longitude": "-1.93740000"
                    },
                    {
                        "id": 152103,
                        "name": "Riofrío del Llano",
                        "latitude": "41.13894750",
                        "longitude": "-2.82468130"
                    },
                    {
                        "id": 36649,
                        "name": "Robledillo de Mohernando",
                        "latitude": "40.85118000",
                        "longitude": "-3.23162000"
                    },
                    {
                        "id": 36655,
                        "name": "Robledo de Corpes",
                        "latitude": "41.11838000",
                        "longitude": "-2.95000000"
                    },
                    {
                        "id": 36670,
                        "name": "Romanillos de Atienza",
                        "latitude": "41.26667000",
                        "longitude": "-2.90000000"
                    },
                    {
                        "id": 36671,
                        "name": "Romanones",
                        "latitude": "40.57149000",
                        "longitude": "-2.99072000"
                    },
                    {
                        "id": 36698,
                        "name": "Rueda de la Sierra",
                        "latitude": "40.91795000",
                        "longitude": "-1.85439000"
                    },
                    {
                        "id": 36727,
                        "name": "Sacecorbo",
                        "latitude": "40.83280000",
                        "longitude": "-2.41838000"
                    },
                    {
                        "id": 36729,
                        "name": "Sacedón",
                        "latitude": "40.48076000",
                        "longitude": "-2.73337000"
                    },
                    {
                        "id": 36735,
                        "name": "Saelices de la Sal",
                        "latitude": "40.90723000",
                        "longitude": "-2.32325000"
                    },
                    {
                        "id": 36770,
                        "name": "Salmerón",
                        "latitude": "40.54529000",
                        "longitude": "-2.49315000"
                    },
                    {
                        "id": 36802,
                        "name": "San Andrés del Congosto",
                        "latitude": "40.99775000",
                        "longitude": "-3.02423000"
                    },
                    {
                        "id": 36804,
                        "name": "San Andrés del Rey",
                        "latitude": "40.63837000",
                        "longitude": "-2.82020000"
                    },
                    {
                        "id": 37136,
                        "name": "Santiuste",
                        "latitude": "41.08462000",
                        "longitude": "-2.80953000"
                    },
                    {
                        "id": 37184,
                        "name": "Saúca",
                        "latitude": "41.03098000",
                        "longitude": "-2.52905000"
                    },
                    {
                        "id": 37183,
                        "name": "Sayatón",
                        "latitude": "40.37635000",
                        "longitude": "-2.85253000"
                    },
                    {
                        "id": 37201,
                        "name": "Selas",
                        "latitude": "40.95150000",
                        "longitude": "-2.10203000"
                    },
                    {
                        "id": 37206,
                        "name": "Semillas",
                        "latitude": "41.05857000",
                        "longitude": "-3.11945000"
                    },
                    {
                        "id": 37237,
                        "name": "Setiles",
                        "latitude": "40.73419000",
                        "longitude": "-1.61720000"
                    },
                    {
                        "id": 37243,
                        "name": "Sienes",
                        "latitude": "41.20096000",
                        "longitude": "-2.65332000"
                    },
                    {
                        "id": 37252,
                        "name": "Sigüenza",
                        "latitude": "41.06892000",
                        "longitude": "-2.64308000"
                    },
                    {
                        "id": 37280,
                        "name": "Solanillos del Extremo",
                        "latitude": "40.75088000",
                        "longitude": "-2.69799000"
                    },
                    {
                        "id": 37287,
                        "name": "Somolinos",
                        "latitude": "41.24606000",
                        "longitude": "-3.06004000"
                    },
                    {
                        "id": 152104,
                        "name": "Sotillo El",
                        "latitude": "40.87832760",
                        "longitude": "-2.62885230"
                    },
                    {
                        "id": 37322,
                        "name": "Sotodosos",
                        "latitude": "40.92149000",
                        "longitude": "-2.39211000"
                    },
                    {
                        "id": 37362,
                        "name": "Tamajón",
                        "latitude": "40.99914000",
                        "longitude": "-3.24743000"
                    },
                    {
                        "id": 37371,
                        "name": "Taragudo",
                        "latitude": "40.82106000",
                        "longitude": "-3.07680000"
                    },
                    {
                        "id": 37373,
                        "name": "Taravilla",
                        "latitude": "40.69743000",
                        "longitude": "-1.96817000"
                    },
                    {
                        "id": 37384,
                        "name": "Tartanedo",
                        "latitude": "40.99347000",
                        "longitude": "-1.92459000"
                    },
                    {
                        "id": 37402,
                        "name": "Tendilla",
                        "latitude": "40.54379000",
                        "longitude": "-2.95782000"
                    },
                    {
                        "id": 37416,
                        "name": "Terzaga",
                        "latitude": "40.69508000",
                        "longitude": "-1.90386000"
                    },
                    {
                        "id": 37424,
                        "name": "Tierzo",
                        "latitude": "40.74925000",
                        "longitude": "-1.93069000"
                    },
                    {
                        "id": 152105,
                        "name": "Toba La",
                        "latitude": "41.00469260",
                        "longitude": "-2.98380600"
                    },
                    {
                        "id": 37456,
                        "name": "Tordellego",
                        "latitude": "40.72165000",
                        "longitude": "-1.67036000"
                    },
                    {
                        "id": 37457,
                        "name": "Tordelrábano",
                        "latitude": "41.21827000",
                        "longitude": "-2.75792000"
                    },
                    {
                        "id": 37460,
                        "name": "Tordesilos",
                        "latitude": "40.67074000",
                        "longitude": "-1.59372000"
                    },
                    {
                        "id": 37465,
                        "name": "Torija",
                        "latitude": "40.74251000",
                        "longitude": "-3.02830000"
                    },
                    {
                        "id": 37500,
                        "name": "Torre del Burgo",
                        "latitude": "40.79176000",
                        "longitude": "-3.07723000"
                    },
                    {
                        "id": 37527,
                        "name": "Torrecuadrada de Molina",
                        "latitude": "40.74947000",
                        "longitude": "-1.80707000"
                    },
                    {
                        "id": 37528,
                        "name": "Torrecuadradilla",
                        "latitude": "40.85364000",
                        "longitude": "-2.53215000"
                    },
                    {
                        "id": 37541,
                        "name": "Torrejón del Rey",
                        "latitude": "40.64325000",
                        "longitude": "-3.33376000"
                    },
                    {
                        "id": 37556,
                        "name": "Torremocha de Jadraque",
                        "latitude": "41.01881000",
                        "longitude": "-2.89918000"
                    },
                    {
                        "id": 37558,
                        "name": "Torremocha del Campo",
                        "latitude": "40.97819000",
                        "longitude": "-2.61881000"
                    },
                    {
                        "id": 37559,
                        "name": "Torremocha del Pinar",
                        "latitude": "40.88954000",
                        "longitude": "-2.04497000"
                    },
                    {
                        "id": 37560,
                        "name": "Torremochuela",
                        "latitude": "40.76528000",
                        "longitude": "-1.84190000"
                    },
                    {
                        "id": 37593,
                        "name": "Torrubia",
                        "latitude": "40.96581000",
                        "longitude": "-1.90064000"
                    },
                    {
                        "id": 37668,
                        "name": "Tórtola de Henares",
                        "latitude": "40.70425000",
                        "longitude": "-3.12316000"
                    },
                    {
                        "id": 37598,
                        "name": "Tortuera",
                        "latitude": "40.97181000",
                        "longitude": "-1.79764000"
                    },
                    {
                        "id": 37599,
                        "name": "Tortuero",
                        "latitude": "40.93414000",
                        "longitude": "-3.35024000"
                    },
                    {
                        "id": 152106,
                        "name": "Traíd",
                        "latitude": "40.66813730",
                        "longitude": "-1.80928620"
                    },
                    {
                        "id": 37639,
                        "name": "Trijueque",
                        "latitude": "40.77426000",
                        "longitude": "-2.99253000"
                    },
                    {
                        "id": 37640,
                        "name": "Trillo",
                        "latitude": "40.70086000",
                        "longitude": "-2.59265000"
                    },
                    {
                        "id": 37671,
                        "name": "Uceda",
                        "latitude": "40.83944000",
                        "longitude": "-3.46040000"
                    },
                    {
                        "id": 37676,
                        "name": "Ujados",
                        "latitude": "41.23526000",
                        "longitude": "-3.00482000"
                    },
                    {
                        "id": 37707,
                        "name": "Utande",
                        "latitude": "40.84832000",
                        "longitude": "-2.92770000"
                    },
                    {
                        "id": 37727,
                        "name": "Valdarachas",
                        "latitude": "40.51710000",
                        "longitude": "-3.12652000"
                    },
                    {
                        "id": 37732,
                        "name": "Valdearenas",
                        "latitude": "40.80939000",
                        "longitude": "-2.99218000"
                    },
                    {
                        "id": 37733,
                        "name": "Valdeavellano",
                        "latitude": "40.66560000",
                        "longitude": "-2.96977000"
                    },
                    {
                        "id": 37736,
                        "name": "Valdeaveruelo",
                        "latitude": "40.63473000",
                        "longitude": "-3.31367000"
                    },
                    {
                        "id": 37741,
                        "name": "Valdeconcha",
                        "latitude": "40.45643000",
                        "longitude": "-2.87663000"
                    },
                    {
                        "id": 37749,
                        "name": "Valdegrudas",
                        "latitude": "40.71125000",
                        "longitude": "-3.01209000"
                    },
                    {
                        "id": 37759,
                        "name": "Valdelcubo",
                        "latitude": "41.22637000",
                        "longitude": "-2.67588000"
                    },
                    {
                        "id": 152107,
                        "name": "Valdenuño Fernández",
                        "latitude": "40.76213380",
                        "longitude": "-3.37983590"
                    },
                    {
                        "id": 37784,
                        "name": "Valdepeñas de la Sierra",
                        "latitude": "40.90562000",
                        "longitude": "-3.38414000"
                    },
                    {
                        "id": 37791,
                        "name": "Valderrebollo",
                        "latitude": "40.81035000",
                        "longitude": "-2.72887000"
                    },
                    {
                        "id": 37801,
                        "name": "Valdesotos",
                        "latitude": "40.95546000",
                        "longitude": "-3.32542000"
                    },
                    {
                        "id": 37827,
                        "name": "Valfermoso de Tajuña",
                        "latitude": "40.61902000",
                        "longitude": "-2.95407000"
                    },
                    {
                        "id": 37830,
                        "name": "Valhermoso",
                        "latitude": "40.78590000",
                        "longitude": "-1.96121000"
                    },
                    {
                        "id": 37876,
                        "name": "Valtablado del Río",
                        "latitude": "40.71420000",
                        "longitude": "-2.40225000"
                    },
                    {
                        "id": 37892,
                        "name": "Valverde de los Arroyos",
                        "latitude": "41.12930000",
                        "longitude": "-3.23333000"
                    },
                    {
                        "id": 37959,
                        "name": "Viana de Jadraque",
                        "latitude": "41.02577000",
                        "longitude": "-2.76966000"
                    },
                    {
                        "id": 38170,
                        "name": "Villanueva de Alcorón",
                        "latitude": "40.67956000",
                        "longitude": "-2.25145000"
                    },
                    {
                        "id": 38173,
                        "name": "Villanueva de Argecilla",
                        "latitude": "40.90257000",
                        "longitude": "-2.91431000"
                    },
                    {
                        "id": 38203,
                        "name": "Villanueva de la Torre",
                        "latitude": "40.58216000",
                        "longitude": "-3.29764000"
                    },
                    {
                        "id": 38278,
                        "name": "Villares de Jadraque",
                        "latitude": "41.10169000",
                        "longitude": "-3.02558000"
                    },
                    {
                        "id": 38319,
                        "name": "Villaseca de Henares",
                        "latitude": "40.96060000",
                        "longitude": "-2.79775000"
                    },
                    {
                        "id": 38320,
                        "name": "Villaseca de Uceda",
                        "latitude": "40.81827000",
                        "longitude": "-3.34904000"
                    },
                    {
                        "id": 38368,
                        "name": "Villel de Mesa",
                        "latitude": "41.12616000",
                        "longitude": "-1.99072000"
                    },
                    {
                        "id": 38411,
                        "name": "Viñuelas",
                        "latitude": "40.79229000",
                        "longitude": "-3.34036000"
                    },
                    {
                        "id": 38428,
                        "name": "Yebes",
                        "latitude": "40.53162000",
                        "longitude": "-3.10782000"
                    },
                    {
                        "id": 38429,
                        "name": "Yebra",
                        "latitude": "40.35702000",
                        "longitude": "-2.96630000"
                    },
                    {
                        "id": 38444,
                        "name": "Yélamos de Abajo",
                        "latitude": "40.63092000",
                        "longitude": "-2.85803000"
                    },
                    {
                        "id": 38445,
                        "name": "Yélamos de Arriba",
                        "latitude": "40.64008000",
                        "longitude": "-2.84340000"
                    },
                    {
                        "id": 38442,
                        "name": "Yunquera de Henares",
                        "latitude": "40.75139000",
                        "longitude": "-3.16260000"
                    },
                    {
                        "id": 152108,
                        "name": "Yunta La",
                        "latitude": "40.91486900",
                        "longitude": "-1.68457310"
                    },
                    {
                        "id": 38467,
                        "name": "Zaorejas",
                        "latitude": "40.76209000",
                        "longitude": "-2.20120000"
                    },
                    {
                        "id": 38485,
                        "name": "Zarzuela de Jadraque",
                        "latitude": "41.06838000",
                        "longitude": "-3.04436000"
                    },
                    {
                        "id": 38497,
                        "name": "Zorita de los Canes",
                        "latitude": "40.33052000",
                        "longitude": "-2.88764000"
                    }
                ]
            },
            {
                "id": 5099,
                "name": "Huelva",
                "iso2": "H",
                "latitude": "37.27086660",
                "longitude": "-6.95719990",
                "type": "province",
                "cities": [
                    {
                        "id": 32346,
                        "name": "Alájar",
                        "latitude": "37.87408000",
                        "longitude": "-6.66536000"
                    },
                    {
                        "id": 32251,
                        "name": "Aljaraque",
                        "latitude": "37.26989000",
                        "longitude": "-7.02313000"
                    },
                    {
                        "id": 151413,
                        "name": "Almendro El",
                        "latitude": "37.50732000",
                        "longitude": "-7.26966440"
                    },
                    {
                        "id": 151414,
                        "name": "Almonaster la Real",
                        "latitude": "37.87231670",
                        "longitude": "-6.78754890"
                    },
                    {
                        "id": 32305,
                        "name": "Almonte",
                        "latitude": "37.26470000",
                        "longitude": "-6.51667000"
                    },
                    {
                        "id": 32321,
                        "name": "Alosno",
                        "latitude": "37.54861000",
                        "longitude": "-7.11470000"
                    },
                    {
                        "id": 32399,
                        "name": "Aracena",
                        "latitude": "37.89396000",
                        "longitude": "-6.56116000"
                    },
                    {
                        "id": 32496,
                        "name": "Aroche",
                        "latitude": "37.94213000",
                        "longitude": "-6.95760000"
                    },
                    {
                        "id": 32514,
                        "name": "Arroyomolinos de León",
                        "latitude": "38.01667000",
                        "longitude": "-6.41667000"
                    },
                    {
                        "id": 32571,
                        "name": "Ayamonte",
                        "latitude": "37.21329000",
                        "longitude": "-7.40807000"
                    },
                    {
                        "id": 32716,
                        "name": "Beas",
                        "latitude": "37.42570000",
                        "longitude": "-6.79318000"
                    },
                    {
                        "id": 32868,
                        "name": "Berrocal",
                        "latitude": "37.60863000",
                        "longitude": "-6.54147000"
                    },
                    {
                        "id": 32939,
                        "name": "Bollullos par del Condado",
                        "latitude": "37.34127000",
                        "longitude": "-6.53970000"
                    },
                    {
                        "id": 32944,
                        "name": "Bonares",
                        "latitude": "37.32423000",
                        "longitude": "-6.68073000"
                    },
                    {
                        "id": 33084,
                        "name": "Cabezas Rubias",
                        "latitude": "37.72660000",
                        "longitude": "-7.08738000"
                    },
                    {
                        "id": 33120,
                        "name": "Cala",
                        "latitude": "37.96667000",
                        "longitude": "-6.31667000"
                    },
                    {
                        "id": 33135,
                        "name": "Calañas",
                        "latitude": "37.65568000",
                        "longitude": "-6.88050000"
                    },
                    {
                        "id": 151415,
                        "name": "Campillo El",
                        "latitude": "37.69371280",
                        "longitude": "-6.62862100"
                    },
                    {
                        "id": 151416,
                        "name": "Campofrío",
                        "latitude": "37.76535340",
                        "longitude": "-6.57535700"
                    },
                    {
                        "id": 33536,
                        "name": "Cañaveral de León",
                        "latitude": "38.01667000",
                        "longitude": "-6.51667000"
                    },
                    {
                        "id": 33338,
                        "name": "Cartaya",
                        "latitude": "37.28114000",
                        "longitude": "-7.15071000"
                    },
                    {
                        "id": 151417,
                        "name": "Castaño del Robledo",
                        "latitude": "37.89555170",
                        "longitude": "-6.70458550"
                    },
                    {
                        "id": 151418,
                        "name": "Cerro de Andévalo El",
                        "latitude": "37.73338240",
                        "longitude": "-6.93835810"
                    },
                    {
                        "id": 33648,
                        "name": "Chucena",
                        "latitude": "37.36305000",
                        "longitude": "-6.39304000"
                    },
                    {
                        "id": 33806,
                        "name": "Corteconcepción",
                        "latitude": "37.90000000",
                        "longitude": "-6.50000000"
                    },
                    {
                        "id": 151419,
                        "name": "Cortegana",
                        "latitude": "37.90879200",
                        "longitude": "-6.82147400"
                    },
                    {
                        "id": 33807,
                        "name": "Cortelazor",
                        "latitude": "37.93639000",
                        "longitude": "-6.62462000"
                    },
                    {
                        "id": 151420,
                        "name": "Cumbres de Enmedio",
                        "latitude": "38.07313050",
                        "longitude": "-6.69355410"
                    },
                    {
                        "id": 151421,
                        "name": "Cumbres de San Bartolomé",
                        "latitude": "38.07792650",
                        "longitude": "-6.74203960"
                    },
                    {
                        "id": 33883,
                        "name": "Cumbres Mayores",
                        "latitude": "38.06194000",
                        "longitude": "-6.64565000"
                    },
                    {
                        "id": 34051,
                        "name": "Encinasola",
                        "latitude": "38.13413000",
                        "longitude": "-6.86675000"
                    },
                    {
                        "id": 34075,
                        "name": "Escacena del Campo",
                        "latitude": "37.40837000",
                        "longitude": "-6.38870000"
                    },
                    {
                        "id": 34316,
                        "name": "Fuenteheridos",
                        "latitude": "37.90545000",
                        "longitude": "-6.66108000"
                    },
                    {
                        "id": 34375,
                        "name": "Galaroza",
                        "latitude": "37.92864000",
                        "longitude": "-6.70730000"
                    },
                    {
                        "id": 34462,
                        "name": "Gibraleón",
                        "latitude": "37.37628000",
                        "longitude": "-6.96895000"
                    },
                    {
                        "id": 151422,
                        "name": "Granada de Río-Tinto La",
                        "latitude": "37.76881580",
                        "longitude": "-6.50864250"
                    },
                    {
                        "id": 151423,
                        "name": "Granado El",
                        "latitude": "37.52220070",
                        "longitude": "-7.42731950"
                    },
                    {
                        "id": 34612,
                        "name": "Higuera de la Sierra",
                        "latitude": "37.83333000",
                        "longitude": "-6.45000000"
                    },
                    {
                        "id": 34620,
                        "name": "Hinojales",
                        "latitude": "38.00000000",
                        "longitude": "-6.58333000"
                    },
                    {
                        "id": 34622,
                        "name": "Hinojos",
                        "latitude": "37.29173000",
                        "longitude": "-6.37872000"
                    },
                    {
                        "id": 34685,
                        "name": "Huelva",
                        "latitude": "37.26638000",
                        "longitude": "-6.94004000"
                    },
                    {
                        "id": 34766,
                        "name": "Isla Cristina",
                        "latitude": "37.20000000",
                        "longitude": "-7.31667000"
                    },
                    {
                        "id": 34786,
                        "name": "Jabugo",
                        "latitude": "37.91622000",
                        "longitude": "-6.72968000"
                    },
                    {
                        "id": 35030,
                        "name": "Lepe",
                        "latitude": "37.25482000",
                        "longitude": "-7.20433000"
                    },
                    {
                        "id": 35055,
                        "name": "Linares de la Sierra",
                        "latitude": "37.87963000",
                        "longitude": "-6.62321000"
                    },
                    {
                        "id": 35152,
                        "name": "Lucena del Puerto",
                        "latitude": "37.30396000",
                        "longitude": "-6.72926000"
                    },
                    {
                        "id": 35271,
                        "name": "Manzanilla",
                        "latitude": "37.38987000",
                        "longitude": "-6.43295000"
                    },
                    {
                        "id": 151424,
                        "name": "Marines Los",
                        "latitude": "37.90288300",
                        "longitude": "-6.62172880"
                    },
                    {
                        "id": 151425,
                        "name": "Minas de Riotinto",
                        "latitude": "37.69274520",
                        "longitude": "-6.59628630"
                    },
                    {
                        "id": 35468,
                        "name": "Moguer",
                        "latitude": "37.27559000",
                        "longitude": "-6.83851000"
                    },
                    {
                        "id": 151426,
                        "name": "Nava La",
                        "latitude": "37.96316870",
                        "longitude": "-6.74471580"
                    },
                    {
                        "id": 35804,
                        "name": "Nerva",
                        "latitude": "37.69627000",
                        "longitude": "-6.54967000"
                    },
                    {
                        "id": 35805,
                        "name": "Niebla",
                        "latitude": "37.36213000",
                        "longitude": "-6.67894000"
                    },
                    {
                        "id": 151427,
                        "name": "Palma del Condado La",
                        "latitude": "37.38676440",
                        "longitude": "-6.55298580"
                    },
                    {
                        "id": 36041,
                        "name": "Palos de la Frontera",
                        "latitude": "37.23457000",
                        "longitude": "-6.89471000"
                    },
                    {
                        "id": 36079,
                        "name": "Paterna del Campo",
                        "latitude": "37.41948000",
                        "longitude": "-6.40248000"
                    },
                    {
                        "id": 36085,
                        "name": "Paymogo",
                        "latitude": "37.73999000",
                        "longitude": "-7.34499000"
                    },
                    {
                        "id": 36417,
                        "name": "Puebla de Guzmán",
                        "latitude": "37.61427000",
                        "longitude": "-7.24878000"
                    },
                    {
                        "id": 151428,
                        "name": "Puerto Moral",
                        "latitude": "37.89199940",
                        "longitude": "-6.47931960"
                    },
                    {
                        "id": 36470,
                        "name": "Punta Umbría",
                        "latitude": "37.18213000",
                        "longitude": "-6.96605000"
                    },
                    {
                        "id": 151429,
                        "name": "Rociana del Condado",
                        "latitude": "37.30848590",
                        "longitude": "-6.59702620"
                    },
                    {
                        "id": 36676,
                        "name": "Rosal de la Frontera",
                        "latitude": "37.96754000",
                        "longitude": "-7.21889000"
                    },
                    {
                        "id": 36810,
                        "name": "San Bartolomé de la Torre",
                        "latitude": "37.44515000",
                        "longitude": "-7.10597000"
                    },
                    {
                        "id": 36852,
                        "name": "San Juan del Puerto",
                        "latitude": "37.31667000",
                        "longitude": "-6.84139000"
                    },
                    {
                        "id": 36923,
                        "name": "San Silvestre de Guzmán",
                        "latitude": "37.38770000",
                        "longitude": "-7.34908000"
                    },
                    {
                        "id": 36948,
                        "name": "Sanlúcar de Guadiana",
                        "latitude": "37.47268000",
                        "longitude": "-7.46546000"
                    },
                    {
                        "id": 37006,
                        "name": "Santa Ana la Real",
                        "latitude": "37.86245000",
                        "longitude": "-6.72385000"
                    },
                    {
                        "id": 37009,
                        "name": "Santa Bárbara de Casa",
                        "latitude": "37.79665000",
                        "longitude": "-7.18735000"
                    },
                    {
                        "id": 37094,
                        "name": "Santa Olalla del Cala",
                        "latitude": "37.90000000",
                        "longitude": "-6.21667000"
                    },
                    {
                        "id": 37637,
                        "name": "Trigueros",
                        "latitude": "37.38606000",
                        "longitude": "-6.82680000"
                    },
                    {
                        "id": 37758,
                        "name": "Valdelarco",
                        "latitude": "37.94877000",
                        "longitude": "-6.68202000"
                    },
                    {
                        "id": 37893,
                        "name": "Valverde del Camino",
                        "latitude": "37.57511000",
                        "longitude": "-6.75432000"
                    },
                    {
                        "id": 38016,
                        "name": "Villablanca",
                        "latitude": "37.30239000",
                        "longitude": "-7.34413000"
                    },
                    {
                        "id": 38102,
                        "name": "Villalba del Alcor",
                        "latitude": "37.39731000",
                        "longitude": "-6.47461000"
                    },
                    {
                        "id": 38205,
                        "name": "Villanueva de las Cruces",
                        "latitude": "37.62783000",
                        "longitude": "-7.02359000"
                    },
                    {
                        "id": 38210,
                        "name": "Villanueva de los Castillejos",
                        "latitude": "37.49940000",
                        "longitude": "-7.29118000"
                    },
                    {
                        "id": 38294,
                        "name": "Villarrasa",
                        "latitude": "37.38849000",
                        "longitude": "-6.60641000"
                    },
                    {
                        "id": 38459,
                        "name": "Zalamea la Real",
                        "latitude": "37.68012000",
                        "longitude": "-6.65977000"
                    },
                    {
                        "id": 38505,
                        "name": "Zufre",
                        "latitude": "37.83333000",
                        "longitude": "-6.33333000"
                    }
                ]
            },
            {
                "id": 1177,
                "name": "Huesca",
                "iso2": "HU",
                "latitude": "41.59762750",
                "longitude": "-0.90566230",
                "type": "province",
                "cities": [
                    {
                        "id": 31913,
                        "name": "Abiego",
                        "latitude": "42.12094000",
                        "longitude": "-0.06873000"
                    },
                    {
                        "id": 31914,
                        "name": "Abizanda",
                        "latitude": "42.24236000",
                        "longitude": "0.19717000"
                    },
                    {
                        "id": 31927,
                        "name": "Adahuesca",
                        "latitude": "42.14610000",
                        "longitude": "-0.00804000"
                    },
                    {
                        "id": 31972,
                        "name": "Agüero",
                        "latitude": "42.35505000",
                        "longitude": "-0.79324000"
                    },
                    {
                        "id": 32594,
                        "name": "Aínsa",
                        "latitude": "42.41547000",
                        "longitude": "0.14008000"
                    },
                    {
                        "id": 153193,
                        "name": "Aínsa-Sobrarbe",
                        "latitude": "42.41469410",
                        "longitude": "0.14038110"
                    },
                    {
                        "id": 153135,
                        "name": "Aisa",
                        "latitude": "42.71586120",
                        "longitude": "-0.59200270"
                    },
                    {
                        "id": 32022,
                        "name": "Albalate de Cinca",
                        "latitude": "41.72521000",
                        "longitude": "0.15244000"
                    },
                    {
                        "id": 32026,
                        "name": "Albalatillo",
                        "latitude": "41.73527000",
                        "longitude": "-0.15115000"
                    },
                    {
                        "id": 32033,
                        "name": "Albelda",
                        "latitude": "41.86542000",
                        "longitude": "0.45999000"
                    },
                    {
                        "id": 32040,
                        "name": "Albero Alto",
                        "latitude": "42.05031000",
                        "longitude": "-0.33710000"
                    },
                    {
                        "id": 32041,
                        "name": "Albero Bajo",
                        "latitude": "42.02380000",
                        "longitude": "-0.38018000"
                    },
                    {
                        "id": 32042,
                        "name": "Alberuela de Tubo",
                        "latitude": "41.90846000",
                        "longitude": "-0.21418000"
                    },
                    {
                        "id": 32071,
                        "name": "Alcalá de Gurrea",
                        "latitude": "42.06653000",
                        "longitude": "-0.68534000"
                    },
                    {
                        "id": 32078,
                        "name": "Alcalá del Obispo",
                        "latitude": "42.07730000",
                        "longitude": "-0.29120000"
                    },
                    {
                        "id": 153136,
                        "name": "Alcampell",
                        "latitude": "41.90580780",
                        "longitude": "0.43314100"
                    },
                    {
                        "id": 32105,
                        "name": "Alcolea de Cinca",
                        "latitude": "41.71944000",
                        "longitude": "0.11716000"
                    },
                    {
                        "id": 32124,
                        "name": "Alcubierre",
                        "latitude": "41.80757000",
                        "longitude": "-0.45291000"
                    },
                    {
                        "id": 32185,
                        "name": "Alerre",
                        "latitude": "42.16468000",
                        "longitude": "-0.46369000"
                    },
                    {
                        "id": 32206,
                        "name": "Alfántega",
                        "latitude": "41.82832000",
                        "longitude": "0.14823000"
                    },
                    {
                        "id": 32309,
                        "name": "Almozara",
                        "latitude": "41.66124000",
                        "longitude": "-0.90169000"
                    },
                    {
                        "id": 32311,
                        "name": "Almudévar",
                        "latitude": "42.04255000",
                        "longitude": "-0.58141000"
                    },
                    {
                        "id": 153137,
                        "name": "Almunia de San Juan",
                        "latitude": "41.93489150",
                        "longitude": "0.24381720"
                    },
                    {
                        "id": 32312,
                        "name": "Almuniente",
                        "latitude": "41.94949000",
                        "longitude": "-0.41173000"
                    },
                    {
                        "id": 32335,
                        "name": "Alquézar",
                        "latitude": "42.17268000",
                        "longitude": "0.02586000"
                    },
                    {
                        "id": 153138,
                        "name": "Altorricón",
                        "latitude": "41.78972320",
                        "longitude": "0.42194440"
                    },
                    {
                        "id": 32384,
                        "name": "Angüés",
                        "latitude": "42.11109000",
                        "longitude": "-0.15298000"
                    },
                    {
                        "id": 32389,
                        "name": "Ansó",
                        "latitude": "42.75785000",
                        "longitude": "-0.82947000"
                    },
                    {
                        "id": 32395,
                        "name": "Antillón",
                        "latitude": "42.03639000",
                        "longitude": "-0.16239000"
                    },
                    {
                        "id": 32401,
                        "name": "Aragüés del Puerto",
                        "latitude": "42.70641000",
                        "longitude": "-0.66999000"
                    },
                    {
                        "id": 153139,
                        "name": "Arén",
                        "latitude": "42.29351370",
                        "longitude": "0.65833300"
                    },
                    {
                        "id": 32450,
                        "name": "Arenys de Lledó \/ Arens de Lledó",
                        "latitude": "40.99244000",
                        "longitude": "0.27092000"
                    },
                    {
                        "id": 32465,
                        "name": "Argavieso",
                        "latitude": "42.05275000",
                        "longitude": "-0.27834000"
                    },
                    {
                        "id": 32474,
                        "name": "Arguis",
                        "latitude": "42.31476000",
                        "longitude": "-0.43967000"
                    },
                    {
                        "id": 32573,
                        "name": "Ayerbe",
                        "latitude": "42.27267000",
                        "longitude": "-0.68844000"
                    },
                    {
                        "id": 153140,
                        "name": "Azanuy-Alins",
                        "latitude": "41.97296580",
                        "longitude": "0.31130980"
                    },
                    {
                        "id": 32581,
                        "name": "Azara",
                        "latitude": "42.07033000",
                        "longitude": "-0.02921000"
                    },
                    {
                        "id": 32583,
                        "name": "Azlor",
                        "latitude": "42.09427000",
                        "longitude": "-0.04594000"
                    },
                    {
                        "id": 32606,
                        "name": "Baells",
                        "latitude": "41.95325000",
                        "longitude": "0.45956000"
                    },
                    {
                        "id": 32614,
                        "name": "Bailo",
                        "latitude": "42.50906000",
                        "longitude": "-0.81136000"
                    },
                    {
                        "id": 153141,
                        "name": "Baldellou",
                        "latitude": "41.91741990",
                        "longitude": "0.54675990"
                    },
                    {
                        "id": 32625,
                        "name": "Ballobar",
                        "latitude": "41.62106000",
                        "longitude": "0.19200000"
                    },
                    {
                        "id": 32631,
                        "name": "Banastás",
                        "latitude": "42.18089000",
                        "longitude": "-0.45191000"
                    },
                    {
                        "id": 32645,
                        "name": "Barbastro",
                        "latitude": "42.03565000",
                        "longitude": "0.12686000"
                    },
                    {
                        "id": 32649,
                        "name": "Barbués",
                        "latitude": "41.98085000",
                        "longitude": "-0.41949000"
                    },
                    {
                        "id": 32650,
                        "name": "Barbuñales",
                        "latitude": "42.02563000",
                        "longitude": "-0.08659000"
                    },
                    {
                        "id": 33051,
                        "name": "Bárcabo",
                        "latitude": "42.24219000",
                        "longitude": "0.06934000"
                    },
                    {
                        "id": 32753,
                        "name": "Belver de Cinca",
                        "latitude": "41.69272000",
                        "longitude": "0.17827000"
                    },
                    {
                        "id": 153142,
                        "name": "Benabarre",
                        "latitude": "42.10870480",
                        "longitude": "0.48031970"
                    },
                    {
                        "id": 32777,
                        "name": "Benasque",
                        "latitude": "42.60528000",
                        "longitude": "0.52305000"
                    },
                    {
                        "id": 32780,
                        "name": "Benavarri \/ Benabarre",
                        "latitude": "42.10586000",
                        "longitude": "0.48211000"
                    },
                    {
                        "id": 153184,
                        "name": "Beranuy",
                        "latitude": "42.36694150",
                        "longitude": "0.59422180"
                    },
                    {
                        "id": 32834,
                        "name": "Berbegal",
                        "latitude": "41.95959000",
                        "longitude": "-0.00326000"
                    },
                    {
                        "id": 32888,
                        "name": "Bielsa",
                        "latitude": "42.63347000",
                        "longitude": "0.21858000"
                    },
                    {
                        "id": 32891,
                        "name": "Bierge",
                        "latitude": "42.16216000",
                        "longitude": "-0.08326000"
                    },
                    {
                        "id": 153143,
                        "name": "Biescas",
                        "latitude": "42.62862870",
                        "longitude": "-0.32247930"
                    },
                    {
                        "id": 32896,
                        "name": "Binaced",
                        "latitude": "41.82564000",
                        "longitude": "0.20084000"
                    },
                    {
                        "id": 32898,
                        "name": "Binéfar",
                        "latitude": "41.85141000",
                        "longitude": "0.29433000"
                    },
                    {
                        "id": 32900,
                        "name": "Bisaurri",
                        "latitude": "42.49677000",
                        "longitude": "0.50647000"
                    },
                    {
                        "id": 32901,
                        "name": "Biscarrués",
                        "latitude": "42.22867000",
                        "longitude": "-0.74967000"
                    },
                    {
                        "id": 153144,
                        "name": "Blecua y Torres",
                        "latitude": "42.08790500",
                        "longitude": "-0.19633640"
                    },
                    {
                        "id": 32940,
                        "name": "Boltaña",
                        "latitude": "42.44550000",
                        "longitude": "0.06802000"
                    },
                    {
                        "id": 32943,
                        "name": "Bonansa",
                        "latitude": "42.42691000",
                        "longitude": "0.66692000"
                    },
                    {
                        "id": 32950,
                        "name": "Borau",
                        "latitude": "42.65858000",
                        "longitude": "-0.58846000"
                    },
                    {
                        "id": 32992,
                        "name": "Broto",
                        "latitude": "42.60434000",
                        "longitude": "-0.12351000"
                    },
                    {
                        "id": 153145,
                        "name": "Caldearenas",
                        "latitude": "42.39735810",
                        "longitude": "-0.50068290"
                    },
                    {
                        "id": 153146,
                        "name": "Campo",
                        "latitude": "42.40852280",
                        "longitude": "0.39543870"
                    },
                    {
                        "id": 33208,
                        "name": "Camporrells",
                        "latitude": "41.95856000",
                        "longitude": "0.52136000"
                    },
                    {
                        "id": 153147,
                        "name": "Canal de Berdún",
                        "latitude": "42.60662940",
                        "longitude": "-0.84845240"
                    },
                    {
                        "id": 33225,
                        "name": "Candasnos",
                        "latitude": "41.50213000",
                        "longitude": "0.06425000"
                    },
                    {
                        "id": 33236,
                        "name": "Canfranc",
                        "latitude": "42.71628000",
                        "longitude": "-0.52563000"
                    },
                    {
                        "id": 33265,
                        "name": "Capdesaso",
                        "latitude": "41.84287000",
                        "longitude": "-0.18316000"
                    },
                    {
                        "id": 33266,
                        "name": "Capella",
                        "latitude": "42.19635000",
                        "longitude": "0.39637000"
                    },
                    {
                        "id": 33383,
                        "name": "Casbas de Huesca",
                        "latitude": "42.15550000",
                        "longitude": "-0.13990000"
                    },
                    {
                        "id": 33402,
                        "name": "Castejón de Monegros",
                        "latitude": "41.61802000",
                        "longitude": "-0.24013000"
                    },
                    {
                        "id": 33403,
                        "name": "Castejón de Sos",
                        "latitude": "42.51235000",
                        "longitude": "0.49241000"
                    },
                    {
                        "id": 33407,
                        "name": "Castejón del Puente",
                        "latitude": "41.96179000",
                        "longitude": "0.15883000"
                    },
                    {
                        "id": 33409,
                        "name": "Castelflorite",
                        "latitude": "41.80273000",
                        "longitude": "-0.02169000"
                    },
                    {
                        "id": 33442,
                        "name": "Castiello de Jaca",
                        "latitude": "42.62964000",
                        "longitude": "-0.55020000"
                    },
                    {
                        "id": 33443,
                        "name": "Castigaleu",
                        "latitude": "42.20374000",
                        "longitude": "0.57944000"
                    },
                    {
                        "id": 33453,
                        "name": "Castillazuelo",
                        "latitude": "42.06774000",
                        "longitude": "0.06491000"
                    },
                    {
                        "id": 153148,
                        "name": "Castillonroy",
                        "latitude": "41.88562420",
                        "longitude": "0.51337830"
                    },
                    {
                        "id": 33613,
                        "name": "Chalamera",
                        "latitude": "41.66567000",
                        "longitude": "0.16299000"
                    },
                    {
                        "id": 33653,
                        "name": "Chía",
                        "latitude": "42.52080000",
                        "longitude": "0.46563000"
                    },
                    {
                        "id": 33638,
                        "name": "Chimillas",
                        "latitude": "42.17033000",
                        "longitude": "-0.45168000"
                    },
                    {
                        "id": 33748,
                        "name": "Colungo",
                        "latitude": "42.17125000",
                        "longitude": "0.06812000"
                    },
                    {
                        "id": 33924,
                        "name": "Delicias",
                        "latitude": "41.64928000",
                        "longitude": "-0.90757000"
                    },
                    {
                        "id": 33971,
                        "name": "Echo",
                        "latitude": "42.73844000",
                        "longitude": "-0.75016000"
                    },
                    {
                        "id": 33982,
                        "name": "El Burgo de Ebro",
                        "latitude": "41.57157000",
                        "longitude": "-0.74128000"
                    },
                    {
                        "id": 33990,
                        "name": "El Castellar",
                        "latitude": "40.36531000",
                        "longitude": "-0.81734000"
                    },
                    {
                        "id": 38530,
                        "name": "el Torricó \/ Altorricon",
                        "latitude": "41.80280000",
                        "longitude": "0.41390000"
                    },
                    {
                        "id": 34128,
                        "name": "Esplús",
                        "latitude": "41.79870000",
                        "longitude": "0.27586000"
                    },
                    {
                        "id": 34137,
                        "name": "Estada",
                        "latitude": "42.07201000",
                        "longitude": "0.23219000"
                    },
                    {
                        "id": 34138,
                        "name": "Estadilla",
                        "latitude": "42.05657000",
                        "longitude": "0.24343000"
                    },
                    {
                        "id": 153149,
                        "name": "Estopiñán del Castillo",
                        "latitude": "41.99646260",
                        "longitude": "0.54347410"
                    },
                    {
                        "id": 34157,
                        "name": "Fago",
                        "latitude": "42.73440000",
                        "longitude": "-0.88131000"
                    },
                    {
                        "id": 153150,
                        "name": "Fanlo",
                        "latitude": "42.58740950",
                        "longitude": "-0.02127970"
                    },
                    {
                        "id": 34191,
                        "name": "Fiscal",
                        "latitude": "42.49561000",
                        "longitude": "-0.12094000"
                    },
                    {
                        "id": 34218,
                        "name": "Fonz",
                        "latitude": "42.01015000",
                        "longitude": "0.25878000"
                    },
                    {
                        "id": 153151,
                        "name": "Foradada del Toscar",
                        "latitude": "42.41081760",
                        "longitude": "0.35100800"
                    },
                    {
                        "id": 34237,
                        "name": "Fraga",
                        "latitude": "41.52294000",
                        "longitude": "0.34894000"
                    },
                    {
                        "id": 153152,
                        "name": "Fueva La",
                        "latitude": "42.45247120",
                        "longitude": "0.28078680"
                    },
                    {
                        "id": 34472,
                        "name": "Gistaín",
                        "latitude": "42.59110000",
                        "longitude": "0.33478000"
                    },
                    {
                        "id": 153153,
                        "name": "Grado El",
                        "latitude": "42.13732480",
                        "longitude": "0.20571080"
                    },
                    {
                        "id": 34508,
                        "name": "Grañén",
                        "latitude": "41.94104000",
                        "longitude": "-0.36941000"
                    },
                    {
                        "id": 34506,
                        "name": "Graus",
                        "latitude": "42.18885000",
                        "longitude": "0.33749000"
                    },
                    {
                        "id": 34554,
                        "name": "Gurrea de Gállego",
                        "latitude": "42.01541000",
                        "longitude": "-0.76150000"
                    },
                    {
                        "id": 34681,
                        "name": "Hoz de Jaca",
                        "latitude": "42.69045000",
                        "longitude": "-0.30650000"
                    },
                    {
                        "id": 153194,
                        "name": "Hoz y Costean",
                        "latitude": "42.14732630",
                        "longitude": "0.12142350"
                    },
                    {
                        "id": 34693,
                        "name": "Huerto",
                        "latitude": "41.93128000",
                        "longitude": "-0.16684000"
                    },
                    {
                        "id": 34696,
                        "name": "Huesca",
                        "latitude": "42.13615000",
                        "longitude": "-0.40870000"
                    },
                    {
                        "id": 34728,
                        "name": "Ibieca",
                        "latitude": "42.16079000",
                        "longitude": "-0.20855000"
                    },
                    {
                        "id": 34738,
                        "name": "Igriés",
                        "latitude": "42.21443000",
                        "longitude": "-0.43201000"
                    },
                    {
                        "id": 34743,
                        "name": "Ilche",
                        "latitude": "41.95702000",
                        "longitude": "0.05728000"
                    },
                    {
                        "id": 153154,
                        "name": "Isábena",
                        "latitude": "42.29410760",
                        "longitude": "0.54469120"
                    },
                    {
                        "id": 34787,
                        "name": "Jaca",
                        "latitude": "42.56898000",
                        "longitude": "-0.54987000"
                    },
                    {
                        "id": 34805,
                        "name": "Jasa",
                        "latitude": "42.69480000",
                        "longitude": "-0.66605000"
                    },
                    {
                        "id": 34854,
                        "name": "La Almunia de Doña Godina",
                        "latitude": "41.47670000",
                        "longitude": "-1.37451000"
                    },
                    {
                        "id": 34877,
                        "name": "La Ginebrosa",
                        "latitude": "40.86991000",
                        "longitude": "-0.13525000"
                    },
                    {
                        "id": 34885,
                        "name": "La Iglesuela del Cid",
                        "latitude": "40.48312000",
                        "longitude": "-0.31938000"
                    },
                    {
                        "id": 34937,
                        "name": "Labuerda",
                        "latitude": "42.45234000",
                        "longitude": "0.13561000"
                    },
                    {
                        "id": 34954,
                        "name": "Laluenga",
                        "latitude": "42.00703000",
                        "longitude": "-0.04715000"
                    },
                    {
                        "id": 34955,
                        "name": "Lalueza",
                        "latitude": "41.83967000",
                        "longitude": "-0.25493000"
                    },
                    {
                        "id": 34958,
                        "name": "Lanaja",
                        "latitude": "41.77063000",
                        "longitude": "-0.33095000"
                    },
                    {
                        "id": 34971,
                        "name": "Laperdiguera",
                        "latitude": "41.99053000",
                        "longitude": "-0.04657000"
                    },
                    {
                        "id": 153155,
                        "name": "Lascellas-Ponzano",
                        "latitude": "42.06604790",
                        "longitude": "-0.07645080"
                    },
                    {
                        "id": 34997,
                        "name": "Lascuarre",
                        "latitude": "42.19611000",
                        "longitude": "0.52010000"
                    },
                    {
                        "id": 34998,
                        "name": "Laspaúles",
                        "latitude": "42.47136000",
                        "longitude": "0.59698000"
                    },
                    {
                        "id": 34999,
                        "name": "Laspuña",
                        "latitude": "42.50374000",
                        "longitude": "0.15441000"
                    },
                    {
                        "id": 35093,
                        "name": "Loarre",
                        "latitude": "42.31432000",
                        "longitude": "-0.62588000"
                    },
                    {
                        "id": 35109,
                        "name": "Loporzano",
                        "latitude": "42.16137000",
                        "longitude": "-0.32337000"
                    },
                    {
                        "id": 35142,
                        "name": "Loscorrales",
                        "latitude": "42.25451000",
                        "longitude": "-0.64296000"
                    },
                    {
                        "id": 153191,
                        "name": "Lupiñén-Ortilla",
                        "latitude": "42.16212110",
                        "longitude": "-0.62544470"
                    },
                    {
                        "id": 35406,
                        "name": "Mequinensa \/ Mequinenza",
                        "latitude": "41.37211000",
                        "longitude": "0.30169000"
                    },
                    {
                        "id": 153156,
                        "name": "Monesma y Cajigar",
                        "latitude": "42.22475730",
                        "longitude": "0.61094300"
                    },
                    {
                        "id": 153157,
                        "name": "Monflorite-Lascasas",
                        "latitude": "42.09432780",
                        "longitude": "-0.35424300"
                    },
                    {
                        "id": 153158,
                        "name": "Montanuy",
                        "latitude": "42.46575980",
                        "longitude": "0.69420880"
                    },
                    {
                        "id": 35546,
                        "name": "Montecanal",
                        "latitude": "41.62965000",
                        "longitude": "-0.93873000"
                    },
                    {
                        "id": 35590,
                        "name": "Monzón",
                        "latitude": "41.91084000",
                        "longitude": "0.19406000"
                    },
                    {
                        "id": 35740,
                        "name": "Naval",
                        "latitude": "42.19503000",
                        "longitude": "0.15183000"
                    },
                    {
                        "id": 35826,
                        "name": "Novales",
                        "latitude": "42.03201000",
                        "longitude": "-0.28700000"
                    },
                    {
                        "id": 35832,
                        "name": "Nueno",
                        "latitude": "42.26697000",
                        "longitude": "-0.43906000"
                    },
                    {
                        "id": 35893,
                        "name": "Oliver-Valdefierro",
                        "latitude": "41.64454000",
                        "longitude": "-0.93349000"
                    },
                    {
                        "id": 153159,
                        "name": "Olvena",
                        "latitude": "42.10259930",
                        "longitude": "0.26669900"
                    },
                    {
                        "id": 35927,
                        "name": "Ontiñena",
                        "latitude": "41.67663000",
                        "longitude": "0.08858000"
                    },
                    {
                        "id": 153160,
                        "name": "Osso de Cinca",
                        "latitude": "41.66648530",
                        "longitude": "0.19106440"
                    },
                    {
                        "id": 36033,
                        "name": "Palo",
                        "latitude": "42.32270000",
                        "longitude": "0.24376000"
                    },
                    {
                        "id": 153161,
                        "name": "Panticosa",
                        "latitude": "42.72690140",
                        "longitude": "-0.24323070"
                    },
                    {
                        "id": 36165,
                        "name": "Peñalba",
                        "latitude": "41.50087000",
                        "longitude": "-0.03798000"
                    },
                    {
                        "id": 153162,
                        "name": "Peñas de Riglos Las",
                        "latitude": "42.34854140",
                        "longitude": "-0.72643940"
                    },
                    {
                        "id": 153163,
                        "name": "Peralta de Alcofea",
                        "latitude": "41.93140970",
                        "longitude": "-0.06708570"
                    },
                    {
                        "id": 153164,
                        "name": "Peralta de Calasanz",
                        "latitude": "42.01811220",
                        "longitude": "0.39367220"
                    },
                    {
                        "id": 36143,
                        "name": "Peraltilla",
                        "latitude": "42.05407000",
                        "longitude": "-0.01840000"
                    },
                    {
                        "id": 153165,
                        "name": "Perarrúa",
                        "latitude": "42.26744790",
                        "longitude": "0.35159620"
                    },
                    {
                        "id": 36153,
                        "name": "Pertusa",
                        "latitude": "42.00214000",
                        "longitude": "-0.12732000"
                    },
                    {
                        "id": 36220,
                        "name": "Piracés",
                        "latitude": "42.00448000",
                        "longitude": "-0.31769000"
                    },
                    {
                        "id": 36233,
                        "name": "Plan",
                        "latitude": "42.58126000",
                        "longitude": "0.33742000"
                    },
                    {
                        "id": 36259,
                        "name": "Poleñino",
                        "latitude": "41.86972000",
                        "longitude": "-0.31009000"
                    },
                    {
                        "id": 36339,
                        "name": "Pozán de Vero",
                        "latitude": "42.08219000",
                        "longitude": "0.03066000"
                    },
                    {
                        "id": 36373,
                        "name": "Provincia de Huesca",
                        "latitude": "42.16667000",
                        "longitude": "-0.16667000"
                    },
                    {
                        "id": 36390,
                        "name": "Provincia de Teruel",
                        "latitude": "40.66667000",
                        "longitude": "-0.66667000"
                    },
                    {
                        "id": 36393,
                        "name": "Provincia de Zaragoza",
                        "latitude": "41.58333000",
                        "longitude": "-1.00000000"
                    },
                    {
                        "id": 36410,
                        "name": "Puebla de Alfindén",
                        "latitude": "41.63188000",
                        "longitude": "-0.75154000"
                    },
                    {
                        "id": 153166,
                        "name": "Puebla de Castro La",
                        "latitude": "42.12725940",
                        "longitude": "0.29018150"
                    },
                    {
                        "id": 153167,
                        "name": "Puente de Montañana",
                        "latitude": "42.15084660",
                        "longitude": "0.69569200"
                    },
                    {
                        "id": 36440,
                        "name": "Puente la Reina de Jaca",
                        "latitude": "42.55908000",
                        "longitude": "-0.78759000"
                    },
                    {
                        "id": 36479,
                        "name": "Puértolas",
                        "latitude": "42.54748000",
                        "longitude": "0.13214000"
                    },
                    {
                        "id": 153168,
                        "name": "Pueyo de Araguás El",
                        "latitude": "42.45269080",
                        "longitude": "0.16822710"
                    },
                    {
                        "id": 36460,
                        "name": "Pueyo de Santa Cruz",
                        "latitude": "41.85799000",
                        "longitude": "0.15660000"
                    },
                    {
                        "id": 36499,
                        "name": "Quicena",
                        "latitude": "42.14797000",
                        "longitude": "-0.36049000"
                    },
                    {
                        "id": 36658,
                        "name": "Robres",
                        "latitude": "41.86746000",
                        "longitude": "-0.46094000"
                    },
                    {
                        "id": 36725,
                        "name": "Sabiñánigo",
                        "latitude": "42.51924000",
                        "longitude": "-0.36607000"
                    },
                    {
                        "id": 36742,
                        "name": "Sahún",
                        "latitude": "42.57590000",
                        "longitude": "0.46546000"
                    },
                    {
                        "id": 36748,
                        "name": "Salas Altas",
                        "latitude": "42.11407000",
                        "longitude": "0.06821000"
                    },
                    {
                        "id": 36749,
                        "name": "Salas Bajas",
                        "latitude": "42.10046000",
                        "longitude": "0.08349000"
                    },
                    {
                        "id": 36761,
                        "name": "Salillas",
                        "latitude": "41.99498000",
                        "longitude": "-0.22278000"
                    },
                    {
                        "id": 36769,
                        "name": "Sallent de Gállego",
                        "latitude": "42.77127000",
                        "longitude": "-0.33448000"
                    },
                    {
                        "id": 153169,
                        "name": "San Esteban de Litera",
                        "latitude": "41.90522760",
                        "longitude": "0.32690120"
                    },
                    {
                        "id": 153170,
                        "name": "San Juan de Plan",
                        "latitude": "42.58872900",
                        "longitude": "0.34571500"
                    },
                    {
                        "id": 153189,
                        "name": "San Miguel del Cinca",
                        "latitude": "41.82028900",
                        "longitude": "0.09336860"
                    },
                    {
                        "id": 36944,
                        "name": "Sangarrén",
                        "latitude": "42.01921000",
                        "longitude": "-0.43323000"
                    },
                    {
                        "id": 153171,
                        "name": "Santa Cilia",
                        "latitude": "42.56004490",
                        "longitude": "-0.71425700"
                    },
                    {
                        "id": 37040,
                        "name": "Santa Cruz de la Serós",
                        "latitude": "42.52271000",
                        "longitude": "-0.67515000"
                    },
                    {
                        "id": 153192,
                        "name": "Santa María de Dulcis",
                        "latitude": "42.12268020",
                        "longitude": "0.02332080"
                    },
                    {
                        "id": 153172,
                        "name": "Santaliestra y San Quílez",
                        "latitude": "42.30660530",
                        "longitude": "0.36446110"
                    },
                    {
                        "id": 37163,
                        "name": "Sariñena",
                        "latitude": "41.79128000",
                        "longitude": "-0.15804000"
                    },
                    {
                        "id": 37186,
                        "name": "Secastilla",
                        "latitude": "42.18112000",
                        "longitude": "0.26736000"
                    },
                    {
                        "id": 37200,
                        "name": "Seira",
                        "latitude": "42.47696000",
                        "longitude": "0.43127000"
                    },
                    {
                        "id": 153173,
                        "name": "Sena",
                        "latitude": "41.67097430",
                        "longitude": "-0.08402150"
                    },
                    {
                        "id": 37214,
                        "name": "Senés de Alcubierre",
                        "latitude": "41.90731000",
                        "longitude": "-0.48906000"
                    },
                    {
                        "id": 37230,
                        "name": "Sesa",
                        "latitude": "41.99484000",
                        "longitude": "-0.24511000"
                    },
                    {
                        "id": 37235,
                        "name": "Sesué",
                        "latitude": "42.55131000",
                        "longitude": "0.47212000"
                    },
                    {
                        "id": 37269,
                        "name": "Siétamo",
                        "latitude": "42.12392000",
                        "longitude": "-0.28066000"
                    },
                    {
                        "id": 153174,
                        "name": "Sopeira",
                        "latitude": "42.31668000",
                        "longitude": "0.74644910"
                    },
                    {
                        "id": 153190,
                        "name": "Sotonera La",
                        "latitude": "42.25467990",
                        "longitude": "-0.54469120"
                    },
                    {
                        "id": 37364,
                        "name": "Tamarit de Llitera \/ Tamarite de Litera",
                        "latitude": "41.86910000",
                        "longitude": "0.42214000"
                    },
                    {
                        "id": 153175,
                        "name": "Tamarite de Litera",
                        "latitude": "41.86737740",
                        "longitude": "0.42135520"
                    },
                    {
                        "id": 37379,
                        "name": "Tardienta",
                        "latitude": "41.97781000",
                        "longitude": "-0.53731000"
                    },
                    {
                        "id": 153176,
                        "name": "Tella-Sin",
                        "latitude": "42.57455630",
                        "longitude": "0.18330400"
                    },
                    {
                        "id": 37423,
                        "name": "Tierz",
                        "latitude": "42.13356000",
                        "longitude": "-0.35489000"
                    },
                    {
                        "id": 153177,
                        "name": "Tolva",
                        "latitude": "42.11481140",
                        "longitude": "0.56449600"
                    },
                    {
                        "id": 153178,
                        "name": "Torla",
                        "latitude": "42.62867750",
                        "longitude": "-0.11265420"
                    },
                    {
                        "id": 37479,
                        "name": "Torralba de Aragón",
                        "latitude": "41.93487000",
                        "longitude": "-0.51053000"
                    },
                    {
                        "id": 153179,
                        "name": "Torre la Ribera",
                        "latitude": "42.37219350",
                        "longitude": "0.52593000"
                    },
                    {
                        "id": 153180,
                        "name": "Torrente de Cinca",
                        "latitude": "41.47266190",
                        "longitude": "0.33542510"
                    },
                    {
                        "id": 37573,
                        "name": "Torres de Alcanadre",
                        "latitude": "41.96727000",
                        "longitude": "-0.11096000"
                    },
                    {
                        "id": 37574,
                        "name": "Torres de Barbués",
                        "latitude": "41.96050000",
                        "longitude": "-0.43350000"
                    },
                    {
                        "id": 37618,
                        "name": "Tramaced",
                        "latitude": "41.97318000",
                        "longitude": "-0.29752000"
                    },
                    {
                        "id": 37826,
                        "name": "Valfarta",
                        "latitude": "41.55726000",
                        "longitude": "-0.13304000"
                    },
                    {
                        "id": 153181,
                        "name": "Valle de Bardají",
                        "latitude": "42.42241570",
                        "longitude": "0.45967210"
                    },
                    {
                        "id": 153188,
                        "name": "Valle de Hecho",
                        "latitude": "42.72481350",
                        "longitude": "-0.73427340"
                    },
                    {
                        "id": 153182,
                        "name": "Valle de Lierp",
                        "latitude": "42.38559510",
                        "longitude": "0.48564400"
                    },
                    {
                        "id": 153183,
                        "name": "Velilla de Cinca",
                        "latitude": "41.58653820",
                        "longitude": "0.26024380"
                    },
                    {
                        "id": 153195,
                        "name": "Vencillón",
                        "latitude": "41.70480330",
                        "longitude": "0.32484400"
                    },
                    {
                        "id": 153185,
                        "name": "Viacamp y Litera",
                        "latitude": "42.09608180",
                        "longitude": "0.65833300"
                    },
                    {
                        "id": 153186,
                        "name": "Vicién",
                        "latitude": "42.13184500",
                        "longitude": "-0.40780580"
                    },
                    {
                        "id": 153187,
                        "name": "Villanova",
                        "latitude": "42.55496290",
                        "longitude": "0.45495420"
                    },
                    {
                        "id": 38227,
                        "name": "Villanúa",
                        "latitude": "42.67970000",
                        "longitude": "-0.53769000"
                    },
                    {
                        "id": 38191,
                        "name": "Villanueva de Sigena",
                        "latitude": "41.71576000",
                        "longitude": "-0.00897000"
                    },
                    {
                        "id": 38430,
                        "name": "Yebra de Basa",
                        "latitude": "42.48647000",
                        "longitude": "-0.28178000"
                    },
                    {
                        "id": 38447,
                        "name": "Yésero",
                        "latitude": "42.61911000",
                        "longitude": "-0.25020000"
                    },
                    {
                        "id": 38457,
                        "name": "Zaidín",
                        "latitude": "41.60402000",
                        "longitude": "0.26429000"
                    }
                ]
            },
            {
                "id": 1174,
                "name": "Islas Baleares",
                "iso2": "PM",
                "latitude": "39.35877590",
                "longitude": "2.73563280",
                "type": "province",
                "cities": [
                    {
                        "id": 31992,
                        "name": "Alaior",
                        "latitude": "39.93034000",
                        "longitude": "4.14039000"
                    },
                    {
                        "id": 32007,
                        "name": "Alaró",
                        "latitude": "39.70441000",
                        "longitude": "2.79181000"
                    },
                    {
                        "id": 32139,
                        "name": "Alcúdia",
                        "latitude": "39.85316000",
                        "longitude": "3.12138000"
                    },
                    {
                        "id": 32209,
                        "name": "Algaida",
                        "latitude": "39.55899000",
                        "longitude": "2.89541000"
                    },
                    {
                        "id": 32375,
                        "name": "Andratx",
                        "latitude": "39.57553000",
                        "longitude": "2.42017000"
                    },
                    {
                        "id": 32478,
                        "name": "Ariany",
                        "latitude": "39.65048000",
                        "longitude": "3.11055000"
                    },
                    {
                        "id": 32526,
                        "name": "Artà",
                        "latitude": "39.69315000",
                        "longitude": "3.34979000"
                    },
                    {
                        "id": 32633,
                        "name": "Banyalbufar",
                        "latitude": "39.68734000",
                        "longitude": "2.51409000"
                    },
                    {
                        "id": 32897,
                        "name": "Binissalem",
                        "latitude": "39.68744000",
                        "longitude": "2.84396000"
                    },
                    {
                        "id": 33064,
                        "name": "Búger",
                        "latitude": "39.75809000",
                        "longitude": "2.98349000"
                    },
                    {
                        "id": 33020,
                        "name": "Bunyola",
                        "latitude": "39.69634000",
                        "longitude": "2.69955000"
                    },
                    {
                        "id": 33122,
                        "name": "Cala d'Or",
                        "latitude": "39.37810000",
                        "longitude": "3.23479000"
                    },
                    {
                        "id": 33121,
                        "name": "Cala Rajada",
                        "latitude": "39.71174000",
                        "longitude": "3.46310000"
                    },
                    {
                        "id": 33149,
                        "name": "Calonge",
                        "latitude": "39.40039000",
                        "longitude": "3.20335000"
                    },
                    {
                        "id": 33155,
                        "name": "Calvià",
                        "latitude": "39.56570000",
                        "longitude": "2.50621000"
                    },
                    {
                        "id": 33180,
                        "name": "Camp de Mar",
                        "latitude": "39.53827000",
                        "longitude": "2.42386000"
                    },
                    {
                        "id": 33182,
                        "name": "Campanet",
                        "latitude": "39.77470000",
                        "longitude": "2.96506000"
                    },
                    {
                        "id": 33210,
                        "name": "Campos",
                        "latitude": "39.43099000",
                        "longitude": "3.01935000"
                    },
                    {
                        "id": 33217,
                        "name": "Can Pastilla",
                        "latitude": "39.53615000",
                        "longitude": "2.71766000"
                    },
                    {
                        "id": 33219,
                        "name": "Can Picafort",
                        "latitude": "39.76567000",
                        "longitude": "3.15488000"
                    },
                    {
                        "id": 33264,
                        "name": "Capdepera",
                        "latitude": "39.70237000",
                        "longitude": "3.43532000"
                    },
                    {
                        "id": 152918,
                        "name": "Castell Es",
                        "latitude": "39.87968800",
                        "longitude": "4.28911480"
                    },
                    {
                        "id": 33699,
                        "name": "Ciutadella",
                        "latitude": "40.00112000",
                        "longitude": "3.84144000"
                    },
                    {
                        "id": 152909,
                        "name": "Ciutadella de Menorca",
                        "latitude": "39.99911630",
                        "longitude": "3.83890470"
                    },
                    {
                        "id": 33729,
                        "name": "Coll d'en Rabassa",
                        "latitude": "39.55083000",
                        "longitude": "2.69468000"
                    },
                    {
                        "id": 33749,
                        "name": "Colònia de Sant Jordi",
                        "latitude": "39.31810000",
                        "longitude": "2.99197000"
                    },
                    {
                        "id": 33764,
                        "name": "Consell",
                        "latitude": "39.66861000",
                        "longitude": "2.81267000"
                    },
                    {
                        "id": 33821,
                        "name": "Costitx",
                        "latitude": "39.65675000",
                        "longitude": "2.94953000"
                    },
                    {
                        "id": 33922,
                        "name": "Deià",
                        "latitude": "39.74806000",
                        "longitude": "2.64823000"
                    },
                    {
                        "id": 152910,
                        "name": "Deyá",
                        "latitude": "39.74793940",
                        "longitude": "2.64837430"
                    },
                    {
                        "id": 152912,
                        "name": "Eivissa",
                        "latitude": "39.02000990",
                        "longitude": "1.48214820"
                    },
                    {
                        "id": 34022,
                        "name": "El Toro",
                        "latitude": "39.48477000",
                        "longitude": "2.48222000"
                    },
                    {
                        "id": 34073,
                        "name": "Es Castell",
                        "latitude": "39.87760000",
                        "longitude": "4.28990000"
                    },
                    {
                        "id": 34074,
                        "name": "Es Molinar",
                        "latitude": "39.56140000",
                        "longitude": "2.67517000"
                    },
                    {
                        "id": 34089,
                        "name": "Escorca",
                        "latitude": "39.82138000",
                        "longitude": "2.86941000"
                    },
                    {
                        "id": 34131,
                        "name": "Esporles",
                        "latitude": "39.66794000",
                        "longitude": "2.57867000"
                    },
                    {
                        "id": 34140,
                        "name": "Estellencs",
                        "latitude": "39.65338000",
                        "longitude": "2.48130000"
                    },
                    {
                        "id": 34171,
                        "name": "Felanitx",
                        "latitude": "39.46960000",
                        "longitude": "3.14831000"
                    },
                    {
                        "id": 34179,
                        "name": "Ferreries",
                        "latitude": "39.98324000",
                        "longitude": "4.01181000"
                    },
                    {
                        "id": 152911,
                        "name": "Formentera",
                        "latitude": "38.69640060",
                        "longitude": "1.45313550"
                    },
                    {
                        "id": 34224,
                        "name": "Fornalutx",
                        "latitude": "39.78232000",
                        "longitude": "2.74107000"
                    },
                    {
                        "id": 34729,
                        "name": "Ibiza",
                        "latitude": "38.90883000",
                        "longitude": "1.43296000"
                    },
                    {
                        "id": 34747,
                        "name": "Illes Balears",
                        "latitude": "39.60992000",
                        "longitude": "3.02948000"
                    },
                    {
                        "id": 34752,
                        "name": "Inca",
                        "latitude": "39.72110000",
                        "longitude": "2.91093000"
                    },
                    {
                        "id": 35085,
                        "name": "Lloret de Vistalegre",
                        "latitude": "39.61835000",
                        "longitude": "2.97493000"
                    },
                    {
                        "id": 35087,
                        "name": "Lloseta",
                        "latitude": "39.71849000",
                        "longitude": "2.86690000"
                    },
                    {
                        "id": 35088,
                        "name": "Llubí",
                        "latitude": "39.69933000",
                        "longitude": "3.00681000"
                    },
                    {
                        "id": 35089,
                        "name": "Llucmajor",
                        "latitude": "39.49093000",
                        "longitude": "2.89108000"
                    },
                    {
                        "id": 35201,
                        "name": "Magaluf",
                        "latitude": "39.51110000",
                        "longitude": "2.53530000"
                    },
                    {
                        "id": 35239,
                        "name": "Manacor",
                        "latitude": "39.56964000",
                        "longitude": "3.20955000"
                    },
                    {
                        "id": 35246,
                        "name": "Mancor de la Vall",
                        "latitude": "39.74966000",
                        "longitude": "2.87284000"
                    },
                    {
                        "id": 35363,
                        "name": "Maó",
                        "latitude": "39.88853000",
                        "longitude": "4.26583000"
                    },
                    {
                        "id": 35289,
                        "name": "Maria de la Salut",
                        "latitude": "39.66306000",
                        "longitude": "3.07300000"
                    },
                    {
                        "id": 35297,
                        "name": "Marratxí",
                        "latitude": "39.62142000",
                        "longitude": "2.72530000"
                    },
                    {
                        "id": 35407,
                        "name": "Mercadal",
                        "latitude": "39.99014000",
                        "longitude": "4.09387000"
                    },
                    {
                        "id": 152913,
                        "name": "Mercadal Es",
                        "latitude": "39.98737780",
                        "longitude": "4.09382560"
                    },
                    {
                        "id": 152919,
                        "name": "Migjorn Gran Es",
                        "latitude": "39.94722270",
                        "longitude": "4.04937590"
                    },
                    {
                        "id": 35586,
                        "name": "Montuïri",
                        "latitude": "39.56742000",
                        "longitude": "2.98189000"
                    },
                    {
                        "id": 35681,
                        "name": "Muro",
                        "latitude": "39.73661000",
                        "longitude": "3.05559000"
                    },
                    {
                        "id": 36027,
                        "name": "Palma",
                        "latitude": "39.56939000",
                        "longitude": "2.65024000"
                    },
                    {
                        "id": 36030,
                        "name": "Palmanova",
                        "latitude": "39.52470000",
                        "longitude": "2.53922000"
                    },
                    {
                        "id": 36116,
                        "name": "Peguera",
                        "latitude": "39.53751000",
                        "longitude": "2.44806000"
                    },
                    {
                        "id": 36157,
                        "name": "Petra",
                        "latitude": "39.61351000",
                        "longitude": "3.11312000"
                    },
                    {
                        "id": 152914,
                        "name": "Pobla Sa",
                        "latitude": "39.76973840",
                        "longitude": "3.02507780"
                    },
                    {
                        "id": 36262,
                        "name": "Pollença",
                        "latitude": "39.87678000",
                        "longitude": "3.01626000"
                    },
                    {
                        "id": 36279,
                        "name": "Porreres",
                        "latitude": "39.51434000",
                        "longitude": "3.02197000"
                    },
                    {
                        "id": 36281,
                        "name": "Port d'Alcúdia",
                        "latitude": "39.84182000",
                        "longitude": "3.13291000"
                    },
                    {
                        "id": 36282,
                        "name": "Port de Pollença",
                        "latitude": "39.90750000",
                        "longitude": "3.08140000"
                    },
                    {
                        "id": 36283,
                        "name": "Port de Sóller",
                        "latitude": "39.79759000",
                        "longitude": "2.69637000"
                    },
                    {
                        "id": 36295,
                        "name": "Porto Cristo",
                        "latitude": "39.53953000",
                        "longitude": "3.33302000"
                    },
                    {
                        "id": 36297,
                        "name": "Portocolom",
                        "latitude": "39.41589000",
                        "longitude": "3.25697000"
                    },
                    {
                        "id": 36464,
                        "name": "Puigpunyent",
                        "latitude": "39.62514000",
                        "longitude": "2.52759000"
                    },
                    {
                        "id": 38569,
                        "name": "s'Arenal",
                        "latitude": "39.50000000",
                        "longitude": "2.75000000"
                    },
                    {
                        "id": 38570,
                        "name": "sa Pobla",
                        "latitude": "39.76920000",
                        "longitude": "3.02394000"
                    },
                    {
                        "id": 152917,
                        "name": "Salines Ses",
                        "latitude": "40.04044970",
                        "longitude": "4.12291280"
                    },
                    {
                        "id": 36957,
                        "name": "Sant Antoni de Portmany",
                        "latitude": "38.98068000",
                        "longitude": "1.30362000"
                    },
                    {
                        "id": 36967,
                        "name": "Sant Francesc de Formentera",
                        "latitude": "38.70566000",
                        "longitude": "1.42893000"
                    },
                    {
                        "id": 36971,
                        "name": "Sant Joan",
                        "latitude": "39.59621000",
                        "longitude": "3.03920000"
                    },
                    {
                        "id": 36973,
                        "name": "Sant Joan de Labritja",
                        "latitude": "39.07891000",
                        "longitude": "1.51397000"
                    },
                    {
                        "id": 36980,
                        "name": "Sant Josep de sa Talaia",
                        "latitude": "38.92239000",
                        "longitude": "1.29437000"
                    },
                    {
                        "id": 36983,
                        "name": "Sant Llorenç des Cardassar",
                        "latitude": "39.61009000",
                        "longitude": "3.28380000"
                    },
                    {
                        "id": 36984,
                        "name": "Sant Lluís",
                        "latitude": "39.84939000",
                        "longitude": "4.25819000"
                    },
                    {
                        "id": 37052,
                        "name": "Santa Eugènia",
                        "latitude": "39.62361000",
                        "longitude": "2.83864000"
                    },
                    {
                        "id": 152915,
                        "name": "Santa Eulalia del Río",
                        "latitude": "38.98527530",
                        "longitude": "1.53509640"
                    },
                    {
                        "id": 37058,
                        "name": "Santa Eulària des Riu",
                        "latitude": "38.98457000",
                        "longitude": "1.53409000"
                    },
                    {
                        "id": 37064,
                        "name": "Santa Margalida",
                        "latitude": "39.70143000",
                        "longitude": "3.10215000"
                    },
                    {
                        "id": 152916,
                        "name": "Santa María del Camí",
                        "latitude": "39.64867960",
                        "longitude": "2.77488850"
                    },
                    {
                        "id": 37099,
                        "name": "Santa Ponsa",
                        "latitude": "39.50868000",
                        "longitude": "2.47660000"
                    },
                    {
                        "id": 37107,
                        "name": "Santanyí",
                        "latitude": "39.35461000",
                        "longitude": "3.12907000"
                    },
                    {
                        "id": 37205,
                        "name": "Selva",
                        "latitude": "39.75504000",
                        "longitude": "2.90069000"
                    },
                    {
                        "id": 37209,
                        "name": "Sencelles",
                        "latitude": "39.64598000",
                        "longitude": "2.89769000"
                    },
                    {
                        "id": 37229,
                        "name": "Ses Salines",
                        "latitude": "39.33831000",
                        "longitude": "3.05274000"
                    },
                    {
                        "id": 37261,
                        "name": "Sineu",
                        "latitude": "39.64254000",
                        "longitude": "3.01034000"
                    },
                    {
                        "id": 37337,
                        "name": "Sóller",
                        "latitude": "39.76623000",
                        "longitude": "2.71521000"
                    },
                    {
                        "id": 37290,
                        "name": "Son Ferrer",
                        "latitude": "39.49666000",
                        "longitude": "2.50102000"
                    },
                    {
                        "id": 37291,
                        "name": "Son Servera",
                        "latitude": "39.62073000",
                        "longitude": "3.36008000"
                    },
                    {
                        "id": 37843,
                        "name": "Valldemossa",
                        "latitude": "39.71042000",
                        "longitude": "2.62230000"
                    },
                    {
                        "id": 37983,
                        "name": "Vilafranca de Bonany",
                        "latitude": "39.56894000",
                        "longitude": "3.08815000"
                    }
                ]
            },
            {
                "id": 5100,
                "name": "Jaén",
                "iso2": "J",
                "latitude": "37.78009310",
                "longitude": "-3.81437450",
                "type": "province",
                "cities": [
                    {
                        "id": 151430,
                        "name": "Albanchez de Mágina",
                        "latitude": "37.79188780",
                        "longitude": "-3.46812120"
                    },
                    {
                        "id": 32081,
                        "name": "Alcalá la Real",
                        "latitude": "37.46140000",
                        "longitude": "-3.92301000"
                    },
                    {
                        "id": 32091,
                        "name": "Alcaudete",
                        "latitude": "37.59091000",
                        "longitude": "-4.08237000"
                    },
                    {
                        "id": 32167,
                        "name": "Aldeaquemada",
                        "latitude": "38.41215000",
                        "longitude": "-3.37137000"
                    },
                    {
                        "id": 32376,
                        "name": "Andújar",
                        "latitude": "38.03922000",
                        "longitude": "-4.05077000"
                    },
                    {
                        "id": 32482,
                        "name": "Arjona",
                        "latitude": "37.93493000",
                        "longitude": "-4.05478000"
                    },
                    {
                        "id": 32483,
                        "name": "Arjonilla",
                        "latitude": "37.97422000",
                        "longitude": "-4.10677000"
                    },
                    {
                        "id": 32499,
                        "name": "Arquillos",
                        "latitude": "38.18148000",
                        "longitude": "-3.42827000"
                    },
                    {
                        "id": 32512,
                        "name": "Arroyo del Ojanco",
                        "latitude": "38.32065000",
                        "longitude": "-2.89486000"
                    },
                    {
                        "id": 32608,
                        "name": "Baeza",
                        "latitude": "37.99384000",
                        "longitude": "-3.47103000"
                    },
                    {
                        "id": 32615,
                        "name": "Bailén",
                        "latitude": "38.09639000",
                        "longitude": "-3.77786000"
                    },
                    {
                        "id": 32709,
                        "name": "Baños de la Encina",
                        "latitude": "38.17379000",
                        "longitude": "-3.77477000"
                    },
                    {
                        "id": 32719,
                        "name": "Beas de Segura",
                        "latitude": "38.25240000",
                        "longitude": "-2.88875000"
                    },
                    {
                        "id": 151442,
                        "name": "Bedmar y Garcíez",
                        "latitude": "37.82176430",
                        "longitude": "-3.41253670"
                    },
                    {
                        "id": 32730,
                        "name": "Begíjar",
                        "latitude": "37.98492000",
                        "longitude": "-3.53094000"
                    },
                    {
                        "id": 33060,
                        "name": "Bélmez de la Moraleda",
                        "latitude": "37.72382000",
                        "longitude": "-3.38207000"
                    },
                    {
                        "id": 32779,
                        "name": "Benatae",
                        "latitude": "38.35323000",
                        "longitude": "-2.65121000"
                    },
                    {
                        "id": 33100,
                        "name": "Cabra del Santo Cristo",
                        "latitude": "37.70379000",
                        "longitude": "-3.28765000"
                    },
                    {
                        "id": 33175,
                        "name": "Cambil",
                        "latitude": "37.67934000",
                        "longitude": "-3.56537000"
                    },
                    {
                        "id": 33189,
                        "name": "Campillo de Arenas",
                        "latitude": "37.55535000",
                        "longitude": "-3.63552000"
                    },
                    {
                        "id": 33231,
                        "name": "Canena",
                        "latitude": "38.04930000",
                        "longitude": "-3.48310000"
                    },
                    {
                        "id": 33288,
                        "name": "Carboneros",
                        "latitude": "38.22958000",
                        "longitude": "-3.63139000"
                    },
                    {
                        "id": 151441,
                        "name": "Cárcheles",
                        "latitude": "37.63614920",
                        "longitude": "-3.63191310"
                    },
                    {
                        "id": 151431,
                        "name": "Carolina La",
                        "latitude": "38.27426450",
                        "longitude": "-3.61418190"
                    },
                    {
                        "id": 151432,
                        "name": "Castellar",
                        "latitude": "38.25421970",
                        "longitude": "-3.11775550"
                    },
                    {
                        "id": 33464,
                        "name": "Castillo de Locubín",
                        "latitude": "37.52858000",
                        "longitude": "-3.94220000"
                    },
                    {
                        "id": 33522,
                        "name": "Cazalilla",
                        "latitude": "37.98389000",
                        "longitude": "-3.88295000"
                    },
                    {
                        "id": 33524,
                        "name": "Cazorla",
                        "latitude": "37.91495000",
                        "longitude": "-3.00342000"
                    },
                    {
                        "id": 33630,
                        "name": "Chiclana de Segura",
                        "latitude": "38.31187000",
                        "longitude": "-3.04219000"
                    },
                    {
                        "id": 33635,
                        "name": "Chilluévar",
                        "latitude": "38.00088000",
                        "longitude": "-3.03240000"
                    },
                    {
                        "id": 34084,
                        "name": "Escañuela",
                        "latitude": "37.87885000",
                        "longitude": "-4.03376000"
                    },
                    {
                        "id": 34114,
                        "name": "Espelúy",
                        "latitude": "38.03180000",
                        "longitude": "-3.86309000"
                    },
                    {
                        "id": 34238,
                        "name": "Frailes",
                        "latitude": "37.48617000",
                        "longitude": "-3.83743000"
                    },
                    {
                        "id": 34290,
                        "name": "Fuensanta de Martos",
                        "latitude": "37.64756000",
                        "longitude": "-3.90846000"
                    },
                    {
                        "id": 34362,
                        "name": "Fuerte del Rey",
                        "latitude": "37.87492000",
                        "longitude": "-3.88389000"
                    },
                    {
                        "id": 34561,
                        "name": "Génave",
                        "latitude": "38.43062000",
                        "longitude": "-2.73310000"
                    },
                    {
                        "id": 151433,
                        "name": "Guardia de Jaén La",
                        "latitude": "37.74246540",
                        "longitude": "-3.69338720"
                    },
                    {
                        "id": 34539,
                        "name": "Guarromán",
                        "latitude": "38.18282000",
                        "longitude": "-3.68697000"
                    },
                    {
                        "id": 34609,
                        "name": "Higuera de Calatrava",
                        "latitude": "37.79848000",
                        "longitude": "-4.15737000"
                    },
                    {
                        "id": 34621,
                        "name": "Hinojares",
                        "latitude": "37.71586000",
                        "longitude": "-2.99769000"
                    },
                    {
                        "id": 151435,
                        "name": "Hornos",
                        "latitude": "38.21698140",
                        "longitude": "-2.71920520"
                    },
                    {
                        "id": 34684,
                        "name": "Huelma",
                        "latitude": "37.64784000",
                        "longitude": "-3.45985000"
                    },
                    {
                        "id": 34694,
                        "name": "Huesa",
                        "latitude": "37.76434000",
                        "longitude": "-3.07639000"
                    },
                    {
                        "id": 34731,
                        "name": "Ibros",
                        "latitude": "38.02106000",
                        "longitude": "-3.50313000"
                    },
                    {
                        "id": 151436,
                        "name": "Iruela La",
                        "latitude": "37.92037570",
                        "longitude": "-2.99161990"
                    },
                    {
                        "id": 34781,
                        "name": "Iznatoraf",
                        "latitude": "38.15706000",
                        "longitude": "-3.03242000"
                    },
                    {
                        "id": 34785,
                        "name": "Jabalquinto",
                        "latitude": "38.01935000",
                        "longitude": "-3.72512000"
                    },
                    {
                        "id": 34811,
                        "name": "Jaén",
                        "latitude": "37.76922000",
                        "longitude": "-3.79028000"
                    },
                    {
                        "id": 34795,
                        "name": "Jamilena",
                        "latitude": "37.74717000",
                        "longitude": "-3.91433000"
                    },
                    {
                        "id": 34816,
                        "name": "Jimena",
                        "latitude": "37.84157000",
                        "longitude": "-3.47710000"
                    },
                    {
                        "id": 34838,
                        "name": "Jódar",
                        "latitude": "37.84064000",
                        "longitude": "-3.35262000"
                    },
                    {
                        "id": 151434,
                        "name": "Lahiguera",
                        "latitude": "37.96436340",
                        "longitude": "-3.97763890"
                    },
                    {
                        "id": 34982,
                        "name": "Larva",
                        "latitude": "37.76069000",
                        "longitude": "-3.20269000"
                    },
                    {
                        "id": 35052,
                        "name": "Linares",
                        "latitude": "38.09519000",
                        "longitude": "-3.63602000"
                    },
                    {
                        "id": 35108,
                        "name": "Lopera",
                        "latitude": "37.94542000",
                        "longitude": "-4.21463000"
                    },
                    {
                        "id": 35168,
                        "name": "Lupión",
                        "latitude": "37.99653000",
                        "longitude": "-3.54699000"
                    },
                    {
                        "id": 35242,
                        "name": "Mancha Real",
                        "latitude": "37.78627000",
                        "longitude": "-3.61226000"
                    },
                    {
                        "id": 35295,
                        "name": "Marmolejo",
                        "latitude": "38.04549000",
                        "longitude": "-4.17029000"
                    },
                    {
                        "id": 35302,
                        "name": "Martos",
                        "latitude": "37.72107000",
                        "longitude": "-3.97264000"
                    },
                    {
                        "id": 35405,
                        "name": "Mengibar",
                        "latitude": "37.96978000",
                        "longitude": "-3.80884000"
                    },
                    {
                        "id": 35579,
                        "name": "Montizón",
                        "latitude": "38.34249000",
                        "longitude": "-3.10404000"
                    },
                    {
                        "id": 35781,
                        "name": "Navas de San Juan",
                        "latitude": "38.18382000",
                        "longitude": "-3.31598000"
                    },
                    {
                        "id": 35812,
                        "name": "Noalejo",
                        "latitude": "37.53017000",
                        "longitude": "-3.65615000"
                    },
                    {
                        "id": 35937,
                        "name": "Orcera",
                        "latitude": "38.31742000",
                        "longitude": "-2.66487000"
                    },
                    {
                        "id": 36088,
                        "name": "Peal de Becerro",
                        "latitude": "37.91338000",
                        "longitude": "-3.12148000"
                    },
                    {
                        "id": 36114,
                        "name": "Pegalajar",
                        "latitude": "37.74008000",
                        "longitude": "-3.64946000"
                    },
                    {
                        "id": 36277,
                        "name": "Porcuna",
                        "latitude": "37.87102000",
                        "longitude": "-4.18501000"
                    },
                    {
                        "id": 36316,
                        "name": "Pozo Alcón",
                        "latitude": "37.70256000",
                        "longitude": "-2.93367000"
                    },
                    {
                        "id": 36436,
                        "name": "Puente de Génave",
                        "latitude": "38.35544000",
                        "longitude": "-2.80320000"
                    },
                    {
                        "id": 151437,
                        "name": "Puerta de Segura La",
                        "latitude": "38.34927210",
                        "longitude": "-2.73692360"
                    },
                    {
                        "id": 36498,
                        "name": "Quesada",
                        "latitude": "37.84338000",
                        "longitude": "-3.06561000"
                    },
                    {
                        "id": 36705,
                        "name": "Rus",
                        "latitude": "38.04759000",
                        "longitude": "-3.46254000"
                    },
                    {
                        "id": 36724,
                        "name": "Sabiote",
                        "latitude": "38.06916000",
                        "longitude": "-3.31448000"
                    },
                    {
                        "id": 37047,
                        "name": "Santa Elena",
                        "latitude": "38.34162000",
                        "longitude": "-3.53953000"
                    },
                    {
                        "id": 37113,
                        "name": "Santiago de Calatrava",
                        "latitude": "37.75382000",
                        "longitude": "-4.17093000"
                    },
                    {
                        "id": 151444,
                        "name": "Santiago-Pontones",
                        "latitude": "38.11782710",
                        "longitude": "-2.67012590"
                    },
                    {
                        "id": 37133,
                        "name": "Santisteban del Puerto",
                        "latitude": "38.24829000",
                        "longitude": "-3.20762000"
                    },
                    {
                        "id": 37143,
                        "name": "Santo Tomé",
                        "latitude": "38.02861000",
                        "longitude": "-3.10092000"
                    },
                    {
                        "id": 37197,
                        "name": "Segura de la Sierra",
                        "latitude": "38.29777000",
                        "longitude": "-2.65229000"
                    },
                    {
                        "id": 37254,
                        "name": "Siles",
                        "latitude": "38.38983000",
                        "longitude": "-2.58190000"
                    },
                    {
                        "id": 37302,
                        "name": "Sorihuela del Guadalimar",
                        "latitude": "38.24062000",
                        "longitude": "-3.05360000"
                    },
                    {
                        "id": 37501,
                        "name": "Torre del Campo",
                        "latitude": "37.77051000",
                        "longitude": "-3.89731000"
                    },
                    {
                        "id": 37511,
                        "name": "Torreblascopedro",
                        "latitude": "37.99750000",
                        "longitude": "-3.63780000"
                    },
                    {
                        "id": 37530,
                        "name": "Torredonjimeno",
                        "latitude": "37.76748000",
                        "longitude": "-3.95776000"
                    },
                    {
                        "id": 37569,
                        "name": "Torreperogil",
                        "latitude": "38.03540000",
                        "longitude": "-3.28998000"
                    },
                    {
                        "id": 37571,
                        "name": "Torres",
                        "latitude": "37.78537000",
                        "longitude": "-3.50902000"
                    },
                    {
                        "id": 151438,
                        "name": "Torres de Albánchez",
                        "latitude": "38.41475390",
                        "longitude": "-2.67757770"
                    },
                    {
                        "id": 38584,
                        "name": "Úbeda",
                        "latitude": "38.01328000",
                        "longitude": "-3.37050000"
                    },
                    {
                        "id": 37783,
                        "name": "Valdepeñas de Jaén",
                        "latitude": "37.58903000",
                        "longitude": "-3.81450000"
                    },
                    {
                        "id": 38006,
                        "name": "Vilches",
                        "latitude": "38.20695000",
                        "longitude": "-3.51025000"
                    },
                    {
                        "id": 38026,
                        "name": "Villacarrillo",
                        "latitude": "38.11560000",
                        "longitude": "-3.08480000"
                    },
                    {
                        "id": 38200,
                        "name": "Villanueva de la Reina",
                        "latitude": "38.00432000",
                        "longitude": "-3.91603000"
                    },
                    {
                        "id": 38213,
                        "name": "Villanueva del Arzobispo",
                        "latitude": "38.16842000",
                        "longitude": "-3.00742000"
                    },
                    {
                        "id": 38268,
                        "name": "Villardompardo",
                        "latitude": "37.83735000",
                        "longitude": "-4.00051000"
                    },
                    {
                        "id": 151439,
                        "name": "Villares Los",
                        "latitude": "37.68739180",
                        "longitude": "-3.81846670"
                    },
                    {
                        "id": 151440,
                        "name": "Villarrodrigo",
                        "latitude": "38.48760710",
                        "longitude": "-2.63691800"
                    },
                    {
                        "id": 151443,
                        "name": "Villatorres",
                        "latitude": "37.93129750",
                        "longitude": "-3.69275310"
                    }
                ]
            },
            {
                "id": 5336,
                "name": "La Rioja",
                "iso2": "RI",
                "latitude": "42.28076920",
                "longitude": "-3.06723480",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 1171,
                "name": "La Rioja",
                "iso2": "LO",
                "latitude": "42.28707330",
                "longitude": "-2.53960300",
                "type": "province",
                "cities": [
                    {
                        "id": 38572,
                        "name": "Ábalos",
                        "latitude": "42.57154000",
                        "longitude": "-2.70956000"
                    },
                    {
                        "id": 31946,
                        "name": "Agoncillo",
                        "latitude": "42.44667000",
                        "longitude": "-2.28980000"
                    },
                    {
                        "id": 31965,
                        "name": "Aguilar del Río Alhama",
                        "latitude": "41.96212000",
                        "longitude": "-1.99340000"
                    },
                    {
                        "id": 31986,
                        "name": "Ajamil",
                        "latitude": "42.16705000",
                        "longitude": "-2.48752000"
                    },
                    {
                        "id": 152892,
                        "name": "Ajamil de Cameros",
                        "latitude": "42.16745110",
                        "longitude": "-2.48756920"
                    },
                    {
                        "id": 32034,
                        "name": "Albelda de Iregua",
                        "latitude": "42.35837000",
                        "longitude": "-2.47278000"
                    },
                    {
                        "id": 32038,
                        "name": "Alberite",
                        "latitude": "42.40704000",
                        "longitude": "-2.43894000"
                    },
                    {
                        "id": 32082,
                        "name": "Alcanadre",
                        "latitude": "42.40492000",
                        "longitude": "-2.12073000"
                    },
                    {
                        "id": 32158,
                        "name": "Aldeanueva de Ebro",
                        "latitude": "42.22911000",
                        "longitude": "-1.88735000"
                    },
                    {
                        "id": 32186,
                        "name": "Alesanco",
                        "latitude": "42.41409000",
                        "longitude": "-2.81666000"
                    },
                    {
                        "id": 32187,
                        "name": "Alesón",
                        "latitude": "42.40554000",
                        "longitude": "-2.68938000"
                    },
                    {
                        "id": 32198,
                        "name": "Alfaro",
                        "latitude": "42.18032000",
                        "longitude": "-1.75016000"
                    },
                    {
                        "id": 32272,
                        "name": "Almarza de Cameros",
                        "latitude": "42.21650000",
                        "longitude": "-2.59873000"
                    },
                    {
                        "id": 32380,
                        "name": "Anguciana",
                        "latitude": "42.57421000",
                        "longitude": "-2.90124000"
                    },
                    {
                        "id": 32381,
                        "name": "Anguiano",
                        "latitude": "42.26381000",
                        "longitude": "-2.76463000"
                    },
                    {
                        "id": 32453,
                        "name": "Arenzana de Abajo",
                        "latitude": "42.38599000",
                        "longitude": "-2.71940000"
                    },
                    {
                        "id": 32454,
                        "name": "Arenzana de Arriba",
                        "latitude": "42.38745000",
                        "longitude": "-2.69494000"
                    },
                    {
                        "id": 32493,
                        "name": "Arnedillo",
                        "latitude": "42.21221000",
                        "longitude": "-2.23602000"
                    },
                    {
                        "id": 32494,
                        "name": "Arnedo",
                        "latitude": "42.22800000",
                        "longitude": "-2.10083000"
                    },
                    {
                        "id": 32518,
                        "name": "Arrúbal",
                        "latitude": "42.43485000",
                        "longitude": "-2.25143000"
                    },
                    {
                        "id": 32558,
                        "name": "Ausejo",
                        "latitude": "42.34210000",
                        "longitude": "-2.16710000"
                    },
                    {
                        "id": 32562,
                        "name": "Autol",
                        "latitude": "42.21661000",
                        "longitude": "-2.00525000"
                    },
                    {
                        "id": 32586,
                        "name": "Azofra",
                        "latitude": "42.42400000",
                        "longitude": "-2.80086000"
                    },
                    {
                        "id": 32603,
                        "name": "Badarán",
                        "latitude": "42.36794000",
                        "longitude": "-2.81079000"
                    },
                    {
                        "id": 32701,
                        "name": "Bañares",
                        "latitude": "42.46838000",
                        "longitude": "-2.91010000"
                    },
                    {
                        "id": 32706,
                        "name": "Baños de Río Tobía",
                        "latitude": "42.33533000",
                        "longitude": "-2.76099000"
                    },
                    {
                        "id": 32705,
                        "name": "Baños de Rioja",
                        "latitude": "42.51230000",
                        "longitude": "-2.94635000"
                    },
                    {
                        "id": 32837,
                        "name": "Berceo",
                        "latitude": "42.33906000",
                        "longitude": "-2.85239000"
                    },
                    {
                        "id": 32848,
                        "name": "Bergasa",
                        "latitude": "42.25285000",
                        "longitude": "-2.13221000"
                    },
                    {
                        "id": 32849,
                        "name": "Bergasillas Bajera",
                        "latitude": "42.24462000",
                        "longitude": "-2.15830000"
                    },
                    {
                        "id": 152893,
                        "name": "Bezares",
                        "latitude": "42.37083010",
                        "longitude": "-2.67043640"
                    },
                    {
                        "id": 32919,
                        "name": "Bobadilla",
                        "latitude": "42.31873000",
                        "longitude": "-2.75992000"
                    },
                    {
                        "id": 32983,
                        "name": "Brieva de Cameros",
                        "latitude": "42.16462000",
                        "longitude": "-2.79450000"
                    },
                    {
                        "id": 32990,
                        "name": "Briñas",
                        "latitude": "42.60106000",
                        "longitude": "-2.83192000"
                    },
                    {
                        "id": 32988,
                        "name": "Briones",
                        "latitude": "42.54397000",
                        "longitude": "-2.78572000"
                    },
                    {
                        "id": 33091,
                        "name": "Cabezón de Cameros",
                        "latitude": "42.19716000",
                        "longitude": "-2.51989000"
                    },
                    {
                        "id": 33126,
                        "name": "Calahorra",
                        "latitude": "42.30506000",
                        "longitude": "-1.96521000"
                    },
                    {
                        "id": 152894,
                        "name": "Camprovín",
                        "latitude": "42.35296730",
                        "longitude": "-2.72448890"
                    },
                    {
                        "id": 33223,
                        "name": "Canales de la Sierra",
                        "latitude": "42.14233000",
                        "longitude": "-3.02458000"
                    },
                    {
                        "id": 33534,
                        "name": "Cañas",
                        "latitude": "42.39240000",
                        "longitude": "-2.84649000"
                    },
                    {
                        "id": 33244,
                        "name": "Canillas de Río Tuerto",
                        "latitude": "42.39950000",
                        "longitude": "-2.84091000"
                    },
                    {
                        "id": 33896,
                        "name": "Cárdenas",
                        "latitude": "42.37464000",
                        "longitude": "-2.76726000"
                    },
                    {
                        "id": 33345,
                        "name": "Casalarreina",
                        "latitude": "42.54911000",
                        "longitude": "-2.90994000"
                    },
                    {
                        "id": 33398,
                        "name": "Castañares de Rioja",
                        "latitude": "42.51248000",
                        "longitude": "-2.93148000"
                    },
                    {
                        "id": 152895,
                        "name": "Castroviejo",
                        "latitude": "42.32955620",
                        "longitude": "-2.66081290"
                    },
                    {
                        "id": 33565,
                        "name": "Cellorigo",
                        "latitude": "42.62703000",
                        "longitude": "-3.00016000"
                    },
                    {
                        "id": 33569,
                        "name": "Cenicero",
                        "latitude": "42.48130000",
                        "longitude": "-2.64412000"
                    },
                    {
                        "id": 33602,
                        "name": "Cervera del Río Alhama",
                        "latitude": "42.00517000",
                        "longitude": "-1.95531000"
                    },
                    {
                        "id": 33656,
                        "name": "Cidamón",
                        "latitude": "42.49518000",
                        "longitude": "-2.87834000"
                    },
                    {
                        "id": 33665,
                        "name": "Cihuri",
                        "latitude": "42.56499000",
                        "longitude": "-2.92287000"
                    },
                    {
                        "id": 33688,
                        "name": "Cirueña",
                        "latitude": "42.41214000",
                        "longitude": "-2.89593000"
                    },
                    {
                        "id": 33705,
                        "name": "Clavijo",
                        "latitude": "42.34897000",
                        "longitude": "-2.42666000"
                    },
                    {
                        "id": 33783,
                        "name": "Cordovín",
                        "latitude": "42.38557000",
                        "longitude": "-2.81500000"
                    },
                    {
                        "id": 33786,
                        "name": "Corera",
                        "latitude": "42.34344000",
                        "longitude": "-2.22023000"
                    },
                    {
                        "id": 33793,
                        "name": "Cornago",
                        "latitude": "42.06444000",
                        "longitude": "-2.09486000"
                    },
                    {
                        "id": 33797,
                        "name": "Corporales",
                        "latitude": "42.43208000",
                        "longitude": "-2.99535000"
                    },
                    {
                        "id": 152896,
                        "name": "Cuzcurrita de Río Tirón",
                        "latitude": "42.54264830",
                        "longitude": "-2.96310190"
                    },
                    {
                        "id": 152897,
                        "name": "Daroca de Rioja",
                        "latitude": "42.37095310",
                        "longitude": "-2.58191450"
                    },
                    {
                        "id": 34055,
                        "name": "Enciso",
                        "latitude": "42.14946000",
                        "longitude": "-2.26953000"
                    },
                    {
                        "id": 34062,
                        "name": "Entrena",
                        "latitude": "42.38782000",
                        "longitude": "-2.53066000"
                    },
                    {
                        "id": 34146,
                        "name": "Estollo",
                        "latitude": "42.32953000",
                        "longitude": "-2.85092000"
                    },
                    {
                        "id": 34153,
                        "name": "Ezcaray",
                        "latitude": "42.32536000",
                        "longitude": "-3.01309000"
                    },
                    {
                        "id": 34204,
                        "name": "Foncea",
                        "latitude": "42.61529000",
                        "longitude": "-3.03897000"
                    },
                    {
                        "id": 34219,
                        "name": "Fonzaleche",
                        "latitude": "42.58114000",
                        "longitude": "-3.01218000"
                    },
                    {
                        "id": 34286,
                        "name": "Fuenmayor",
                        "latitude": "42.46729000",
                        "longitude": "-2.56153000"
                    },
                    {
                        "id": 34377,
                        "name": "Galbárruli",
                        "latitude": "42.62181000",
                        "longitude": "-2.96087000"
                    },
                    {
                        "id": 34381,
                        "name": "Galilea",
                        "latitude": "42.34703000",
                        "longitude": "-2.23605000"
                    },
                    {
                        "id": 34393,
                        "name": "Gallinero de Cameros",
                        "latitude": "42.17229000",
                        "longitude": "-2.61793000"
                    },
                    {
                        "id": 34466,
                        "name": "Gimileo",
                        "latitude": "42.54992000",
                        "longitude": "-2.82237000"
                    },
                    {
                        "id": 34509,
                        "name": "Grañón",
                        "latitude": "42.44992000",
                        "longitude": "-3.02767000"
                    },
                    {
                        "id": 34518,
                        "name": "Grávalos",
                        "latitude": "42.10836000",
                        "longitude": "-1.99874000"
                    },
                    {
                        "id": 34572,
                        "name": "Haro",
                        "latitude": "42.57634000",
                        "longitude": "-2.84760000"
                    },
                    {
                        "id": 34580,
                        "name": "Herce",
                        "latitude": "42.21423000",
                        "longitude": "-2.16488000"
                    },
                    {
                        "id": 34592,
                        "name": "Herramélluri",
                        "latitude": "42.50295000",
                        "longitude": "-3.01954000"
                    },
                    {
                        "id": 34605,
                        "name": "Hervías",
                        "latitude": "42.44781000",
                        "longitude": "-2.88714000"
                    },
                    {
                        "id": 34657,
                        "name": "Hormilla",
                        "latitude": "42.43828000",
                        "longitude": "-2.77447000"
                    },
                    {
                        "id": 34658,
                        "name": "Hormilleja",
                        "latitude": "42.45628000",
                        "longitude": "-2.73155000"
                    },
                    {
                        "id": 34661,
                        "name": "Hornillos de Cameros",
                        "latitude": "42.21001000",
                        "longitude": "-2.41960000"
                    },
                    {
                        "id": 34664,
                        "name": "Hornos de Moncalvillo",
                        "latitude": "42.39198000",
                        "longitude": "-2.58550000"
                    },
                    {
                        "id": 34713,
                        "name": "Huércanos",
                        "latitude": "42.42800000",
                        "longitude": "-2.69589000"
                    },
                    {
                        "id": 34735,
                        "name": "Igea",
                        "latitude": "42.06777000",
                        "longitude": "-2.01094000"
                    },
                    {
                        "id": 34793,
                        "name": "Jalón de Cameros",
                        "latitude": "42.21804000",
                        "longitude": "-2.49004000"
                    },
                    {
                        "id": 34946,
                        "name": "Laguna de Cameros",
                        "latitude": "42.17455000",
                        "longitude": "-2.54282000"
                    },
                    {
                        "id": 34953,
                        "name": "Lagunilla del Jubera",
                        "latitude": "42.33414000",
                        "longitude": "-2.32117000"
                    },
                    {
                        "id": 34975,
                        "name": "Lardero",
                        "latitude": "42.42686000",
                        "longitude": "-2.46153000"
                    },
                    {
                        "id": 35017,
                        "name": "Ledesma de la Cogolla",
                        "latitude": "42.32032000",
                        "longitude": "-2.71900000"
                    },
                    {
                        "id": 35027,
                        "name": "Leiva",
                        "latitude": "42.50281000",
                        "longitude": "-3.04701000"
                    },
                    {
                        "id": 35040,
                        "name": "Leza de Río Leza",
                        "latitude": "42.32952000",
                        "longitude": "-2.40606000"
                    },
                    {
                        "id": 35101,
                        "name": "Logroño",
                        "latitude": "42.46667000",
                        "longitude": "-2.45000000"
                    },
                    {
                        "id": 35164,
                        "name": "Lumbreras",
                        "latitude": "42.10477000",
                        "longitude": "-2.62189000"
                    },
                    {
                        "id": 35253,
                        "name": "Manjarrés",
                        "latitude": "42.39152000",
                        "longitude": "-2.67512000"
                    },
                    {
                        "id": 152898,
                        "name": "Mansilla de la Sierra",
                        "latitude": "42.15000000",
                        "longitude": "-2.95000000"
                    },
                    {
                        "id": 35266,
                        "name": "Manzanares de Rioja",
                        "latitude": "42.39610000",
                        "longitude": "-2.89590000"
                    },
                    {
                        "id": 35347,
                        "name": "Matute",
                        "latitude": "42.29888000",
                        "longitude": "-2.79564000"
                    },
                    {
                        "id": 35378,
                        "name": "Medrano",
                        "latitude": "42.38361000",
                        "longitude": "-2.55394000"
                    },
                    {
                        "id": 35666,
                        "name": "Munilla",
                        "latitude": "42.18900000",
                        "longitude": "-2.29506000"
                    },
                    {
                        "id": 35678,
                        "name": "Murillo de Río Leza",
                        "latitude": "42.40099000",
                        "longitude": "-2.32464000"
                    },
                    {
                        "id": 35682,
                        "name": "Muro de Aguas",
                        "latitude": "42.13364000",
                        "longitude": "-2.11175000"
                    },
                    {
                        "id": 35684,
                        "name": "Muro en Cameros",
                        "latitude": "42.22509000",
                        "longitude": "-2.53038000"
                    },
                    {
                        "id": 35842,
                        "name": "Nájera",
                        "latitude": "42.41822000",
                        "longitude": "-2.72865000"
                    },
                    {
                        "id": 35710,
                        "name": "Nalda",
                        "latitude": "42.33467000",
                        "longitude": "-2.48710000"
                    },
                    {
                        "id": 35739,
                        "name": "Navajún",
                        "latitude": "41.96667000",
                        "longitude": "-2.10000000"
                    },
                    {
                        "id": 152899,
                        "name": "Navarrete",
                        "latitude": "42.42981100",
                        "longitude": "-2.56196070"
                    },
                    {
                        "id": 152900,
                        "name": "Nestares",
                        "latitude": "42.26988980",
                        "longitude": "-2.61954750"
                    },
                    {
                        "id": 35807,
                        "name": "Nieva de Cameros",
                        "latitude": "42.21835000",
                        "longitude": "-2.66700000"
                    },
                    {
                        "id": 35857,
                        "name": "Ochánduri",
                        "latitude": "42.52525000",
                        "longitude": "-3.00415000"
                    },
                    {
                        "id": 35859,
                        "name": "Ocón",
                        "latitude": "42.29898000",
                        "longitude": "-2.24019000"
                    },
                    {
                        "id": 35867,
                        "name": "Ojacastro",
                        "latitude": "42.34720000",
                        "longitude": "-3.00490000"
                    },
                    {
                        "id": 35894,
                        "name": "Ollauri",
                        "latitude": "42.54256000",
                        "longitude": "-2.83448000"
                    },
                    {
                        "id": 152901,
                        "name": "Ortigosa de Cameros",
                        "latitude": "42.17670250",
                        "longitude": "-2.70522170"
                    },
                    {
                        "id": 36087,
                        "name": "Pazuengos",
                        "latitude": "42.31776000",
                        "longitude": "-2.92539000"
                    },
                    {
                        "id": 36112,
                        "name": "Pedroso",
                        "latitude": "42.29959000",
                        "longitude": "-2.71889000"
                    },
                    {
                        "id": 36208,
                        "name": "Pinillos",
                        "latitude": "42.19951000",
                        "longitude": "-2.59709000"
                    },
                    {
                        "id": 36341,
                        "name": "Pradejón",
                        "latitude": "42.33446000",
                        "longitude": "-2.06851000"
                    },
                    {
                        "id": 36343,
                        "name": "Pradillo",
                        "latitude": "42.17660000",
                        "longitude": "-2.64185000"
                    },
                    {
                        "id": 36407,
                        "name": "Préjano",
                        "latitude": "42.18648000",
                        "longitude": "-2.17998000"
                    },
                    {
                        "id": 36375,
                        "name": "Provincia de La Rioja",
                        "latitude": "42.46311000",
                        "longitude": "-2.42455000"
                    },
                    {
                        "id": 36492,
                        "name": "Quel",
                        "latitude": "42.22979000",
                        "longitude": "-2.05196000"
                    },
                    {
                        "id": 36534,
                        "name": "Rabanera",
                        "latitude": "42.18955000",
                        "longitude": "-2.48654000"
                    },
                    {
                        "id": 152902,
                        "name": "Rasillo de Cameros El",
                        "latitude": "42.19600870",
                        "longitude": "-2.69714420"
                    },
                    {
                        "id": 152903,
                        "name": "Redal El",
                        "latitude": "42.34822820",
                        "longitude": "-2.19907630"
                    },
                    {
                        "id": 152904,
                        "name": "Ribafrecha",
                        "latitude": "42.35697600",
                        "longitude": "-2.38847780"
                    },
                    {
                        "id": 36626,
                        "name": "Rincón de Soto",
                        "latitude": "42.23475000",
                        "longitude": "-1.85214000"
                    },
                    {
                        "id": 36659,
                        "name": "Robres del Castillo",
                        "latitude": "42.27593000",
                        "longitude": "-2.29245000"
                    },
                    {
                        "id": 36664,
                        "name": "Rodezno",
                        "latitude": "42.52576000",
                        "longitude": "-2.84597000"
                    },
                    {
                        "id": 36743,
                        "name": "Sajazarra",
                        "latitude": "42.58884000",
                        "longitude": "-2.96124000"
                    },
                    {
                        "id": 36805,
                        "name": "San Asensio",
                        "latitude": "42.49677000",
                        "longitude": "-2.75057000"
                    },
                    {
                        "id": 36891,
                        "name": "San Millán de la Cogolla",
                        "latitude": "42.32974000",
                        "longitude": "-2.86185000"
                    },
                    {
                        "id": 36890,
                        "name": "San Millán de Yécora",
                        "latitude": "42.54705000",
                        "longitude": "-3.09681000"
                    },
                    {
                        "id": 36916,
                        "name": "San Román de Cameros",
                        "latitude": "42.23255000",
                        "longitude": "-2.47436000"
                    },
                    {
                        "id": 36924,
                        "name": "San Torcuato",
                        "latitude": "42.48219000",
                        "longitude": "-2.88923000"
                    },
                    {
                        "id": 36930,
                        "name": "San Vicente de la Sonsierra",
                        "latitude": "42.56321000",
                        "longitude": "-2.76071000"
                    },
                    {
                        "id": 37014,
                        "name": "Santa Coloma",
                        "latitude": "42.36717000",
                        "longitude": "-2.65598000"
                    },
                    {
                        "id": 152905,
                        "name": "Santa Engracia del Jubera",
                        "latitude": "42.30131660",
                        "longitude": "-2.33202350"
                    },
                    {
                        "id": 37055,
                        "name": "Santa Eulalia Bajera",
                        "latitude": "42.20960000",
                        "longitude": "-2.19174000"
                    },
                    {
                        "id": 37141,
                        "name": "Santo Domingo de la Calzada",
                        "latitude": "42.44015000",
                        "longitude": "-2.95365000"
                    },
                    {
                        "id": 152906,
                        "name": "Santurde de Rioja",
                        "latitude": "42.39012090",
                        "longitude": "-2.97982800"
                    },
                    {
                        "id": 37154,
                        "name": "Santurdejo",
                        "latitude": "42.37696000",
                        "longitude": "-2.95437000"
                    },
                    {
                        "id": 37278,
                        "name": "Sojuela",
                        "latitude": "42.36988000",
                        "longitude": "-2.54525000"
                    },
                    {
                        "id": 37306,
                        "name": "Sorzano",
                        "latitude": "42.34307000",
                        "longitude": "-2.52872000"
                    },
                    {
                        "id": 152907,
                        "name": "Sotés",
                        "latitude": "42.39939910",
                        "longitude": "-2.60342360"
                    },
                    {
                        "id": 37319,
                        "name": "Soto en Cameros",
                        "latitude": "42.28591000",
                        "longitude": "-2.42597000"
                    },
                    {
                        "id": 37414,
                        "name": "Terroba",
                        "latitude": "42.25809000",
                        "longitude": "-2.44375000"
                    },
                    {
                        "id": 37429,
                        "name": "Tirgo",
                        "latitude": "42.54587000",
                        "longitude": "-2.94940000"
                    },
                    {
                        "id": 37438,
                        "name": "Tobía",
                        "latitude": "42.29846000",
                        "longitude": "-2.81399000"
                    },
                    {
                        "id": 37468,
                        "name": "Tormantos",
                        "latitude": "42.49431000",
                        "longitude": "-3.07446000"
                    },
                    {
                        "id": 37504,
                        "name": "Torre en Cameros",
                        "latitude": "42.24133000",
                        "longitude": "-2.51805000"
                    },
                    {
                        "id": 37524,
                        "name": "Torrecilla en Cameros",
                        "latitude": "42.25532000",
                        "longitude": "-2.63109000"
                    },
                    {
                        "id": 37525,
                        "name": "Torrecilla sobre Alesanco",
                        "latitude": "42.40825000",
                        "longitude": "-2.83379000"
                    },
                    {
                        "id": 37562,
                        "name": "Torremontalbo",
                        "latitude": "42.50000000",
                        "longitude": "-2.68333000"
                    },
                    {
                        "id": 37633,
                        "name": "Treviana",
                        "latitude": "42.55901000",
                        "longitude": "-3.05032000"
                    },
                    {
                        "id": 37636,
                        "name": "Tricio",
                        "latitude": "42.40223000",
                        "longitude": "-2.71912000"
                    },
                    {
                        "id": 37650,
                        "name": "Tudelilla",
                        "latitude": "42.30023000",
                        "longitude": "-2.11749000"
                    },
                    {
                        "id": 37700,
                        "name": "Uruñuela",
                        "latitude": "42.44310000",
                        "longitude": "-2.70749000"
                    },
                    {
                        "id": 37763,
                        "name": "Valdemadera",
                        "latitude": "41.98408000",
                        "longitude": "-2.07403000"
                    },
                    {
                        "id": 37829,
                        "name": "Valgañón",
                        "latitude": "42.31782000",
                        "longitude": "-3.06725000"
                    },
                    {
                        "id": 37942,
                        "name": "Ventosa",
                        "latitude": "42.40495000",
                        "longitude": "-2.62651000"
                    },
                    {
                        "id": 37945,
                        "name": "Ventrosa",
                        "latitude": "42.15705000",
                        "longitude": "-2.85044000"
                    },
                    {
                        "id": 37971,
                        "name": "Viguera",
                        "latitude": "42.30934000",
                        "longitude": "-2.53334000"
                    },
                    {
                        "id": 38095,
                        "name": "Villalba de Rioja",
                        "latitude": "42.60967000",
                        "longitude": "-2.88687000"
                    },
                    {
                        "id": 38115,
                        "name": "Villalobar de Rioja",
                        "latitude": "42.49123000",
                        "longitude": "-2.96404000"
                    },
                    {
                        "id": 38149,
                        "name": "Villamediana de Iregua",
                        "latitude": "42.42658000",
                        "longitude": "-2.41943000"
                    },
                    {
                        "id": 38176,
                        "name": "Villanueva de Cameros",
                        "latitude": "42.16719000",
                        "longitude": "-2.65040000"
                    },
                    {
                        "id": 152908,
                        "name": "Villar de Arnedo El",
                        "latitude": "42.32183680",
                        "longitude": "-2.09716930"
                    },
                    {
                        "id": 38246,
                        "name": "Villar de Torre",
                        "latitude": "42.37133000",
                        "longitude": "-2.86411000"
                    },
                    {
                        "id": 38270,
                        "name": "Villarejo",
                        "latitude": "42.37417000",
                        "longitude": "-2.88712000"
                    },
                    {
                        "id": 38297,
                        "name": "Villarroya",
                        "latitude": "42.13053000",
                        "longitude": "-2.06896000"
                    },
                    {
                        "id": 38309,
                        "name": "Villarta-Quintana",
                        "latitude": "42.42998000",
                        "longitude": "-3.04840000"
                    },
                    {
                        "id": 38340,
                        "name": "Villavelayo",
                        "latitude": "42.13084000",
                        "longitude": "-2.98565000"
                    },
                    {
                        "id": 38348,
                        "name": "Villaverde de Rioja",
                        "latitude": "42.32051000",
                        "longitude": "-2.81370000"
                    },
                    {
                        "id": 38377,
                        "name": "Villoslada de Cameros",
                        "latitude": "42.11383000",
                        "longitude": "-2.67413000"
                    },
                    {
                        "id": 38394,
                        "name": "Viniegra de Abajo",
                        "latitude": "42.15055000",
                        "longitude": "-2.88930000"
                    },
                    {
                        "id": 38395,
                        "name": "Viniegra de Arriba",
                        "latitude": "42.09513000",
                        "longitude": "-2.83304000"
                    },
                    {
                        "id": 38476,
                        "name": "Zarratón",
                        "latitude": "42.51649000",
                        "longitude": "-2.88094000"
                    },
                    {
                        "id": 38483,
                        "name": "Zarzosa",
                        "latitude": "42.18294000",
                        "longitude": "-2.34297000"
                    },
                    {
                        "id": 38499,
                        "name": "Zorraquín",
                        "latitude": "42.32565000",
                        "longitude": "-3.03925000"
                    }
                ]
            },
            {
                "id": 1185,
                "name": "Las Palmas",
                "iso2": "GC",
                "latitude": "28.57153750",
                "longitude": "-15.90137950",
                "type": "province",
                "cities": [
                    {
                        "id": 31944,
                        "name": "Agaete",
                        "latitude": "28.10023000",
                        "longitude": "-15.69998000"
                    },
                    {
                        "id": 31973,
                        "name": "Agüimes",
                        "latitude": "27.90539000",
                        "longitude": "-15.44609000"
                    },
                    {
                        "id": 153199,
                        "name": "Aldea de San Nicolás La",
                        "latitude": "27.98222180",
                        "longitude": "-15.77937410"
                    },
                    {
                        "id": 32393,
                        "name": "Antigua",
                        "latitude": "28.42307000",
                        "longitude": "-14.01379000"
                    },
                    {
                        "id": 32504,
                        "name": "Arrecife",
                        "latitude": "28.96302000",
                        "longitude": "-13.54769000"
                    },
                    {
                        "id": 32523,
                        "name": "Artenara",
                        "latitude": "28.02055000",
                        "longitude": "-15.64693000"
                    },
                    {
                        "id": 32528,
                        "name": "Arucas",
                        "latitude": "28.11983000",
                        "longitude": "-15.52325000"
                    },
                    {
                        "id": 153196,
                        "name": "Betancuria",
                        "latitude": "28.42487610",
                        "longitude": "-14.05730490"
                    },
                    {
                        "id": 33328,
                        "name": "Carrizal",
                        "latitude": "27.91161000",
                        "longitude": "-15.40558000"
                    },
                    {
                        "id": 33802,
                        "name": "Corralejo",
                        "latitude": "28.73079000",
                        "longitude": "-13.86749000"
                    },
                    {
                        "id": 33818,
                        "name": "Costa Calma",
                        "latitude": "28.16155000",
                        "longitude": "-14.22691000"
                    },
                    {
                        "id": 33819,
                        "name": "Costa Teguise",
                        "latitude": "28.99838000",
                        "longitude": "-13.49911000"
                    },
                    {
                        "id": 33839,
                        "name": "Cruce de Arinaga",
                        "latitude": "27.87656000",
                        "longitude": "-15.42798000"
                    },
                    {
                        "id": 33994,
                        "name": "El Cotillo",
                        "latitude": "28.68264000",
                        "longitude": "-14.00637000"
                    },
                    {
                        "id": 34004,
                        "name": "El Paso",
                        "latitude": "28.65007000",
                        "longitude": "-17.88274000"
                    },
                    {
                        "id": 34190,
                        "name": "Firgas",
                        "latitude": "28.10711000",
                        "longitude": "-15.56299000"
                    },
                    {
                        "id": 34559,
                        "name": "Gáldar",
                        "latitude": "28.14701000",
                        "longitude": "-15.65020000"
                    },
                    {
                        "id": 34541,
                        "name": "Guia",
                        "latitude": "28.13974000",
                        "longitude": "-15.63294000"
                    },
                    {
                        "id": 34573,
                        "name": "Haría",
                        "latitude": "29.14553000",
                        "longitude": "-13.49986000"
                    },
                    {
                        "id": 34754,
                        "name": "Ingenio",
                        "latitude": "27.91855000",
                        "longitude": "-15.43433000"
                    },
                    {
                        "id": 34880,
                        "name": "La Guancha",
                        "latitude": "28.37320000",
                        "longitude": "-16.65158000"
                    },
                    {
                        "id": 34887,
                        "name": "La Laguna",
                        "latitude": "28.48530000",
                        "longitude": "-16.32014000"
                    },
                    {
                        "id": 34894,
                        "name": "La Matanza de Acentejo",
                        "latitude": "28.45242000",
                        "longitude": "-16.44720000"
                    },
                    {
                        "id": 34897,
                        "name": "La Oliva",
                        "latitude": "28.61052000",
                        "longitude": "-13.92912000"
                    },
                    {
                        "id": 34898,
                        "name": "La Orotava",
                        "latitude": "28.39076000",
                        "longitude": "-16.52309000"
                    },
                    {
                        "id": 34934,
                        "name": "La Victoria de Acentejo",
                        "latitude": "28.43231000",
                        "longitude": "-16.46232000"
                    },
                    {
                        "id": 34988,
                        "name": "Las Palmas de Gran Canaria",
                        "latitude": "28.09973000",
                        "longitude": "-15.41343000"
                    },
                    {
                        "id": 34990,
                        "name": "Las Rosas",
                        "latitude": "28.01539000",
                        "longitude": "-16.65373000"
                    },
                    {
                        "id": 35105,
                        "name": "Lomo de Arico",
                        "latitude": "28.16667000",
                        "longitude": "-16.48333000"
                    },
                    {
                        "id": 35122,
                        "name": "Los Gigantes",
                        "latitude": "28.24361000",
                        "longitude": "-16.84153000"
                    },
                    {
                        "id": 35124,
                        "name": "Los Llanos de Aridane",
                        "latitude": "28.65851000",
                        "longitude": "-17.91821000"
                    },
                    {
                        "id": 35132,
                        "name": "Los Realejos",
                        "latitude": "28.38487000",
                        "longitude": "-16.58275000"
                    },
                    {
                        "id": 35135,
                        "name": "Los Silos",
                        "latitude": "28.36610000",
                        "longitude": "-16.81552000"
                    },
                    {
                        "id": 35702,
                        "name": "Mácher",
                        "latitude": "28.94840000",
                        "longitude": "-13.69117000"
                    },
                    {
                        "id": 35324,
                        "name": "Maspalomas",
                        "latitude": "27.76056000",
                        "longitude": "-15.58602000"
                    },
                    {
                        "id": 35357,
                        "name": "Mazo",
                        "latitude": "28.60906000",
                        "longitude": "-17.77801000"
                    },
                    {
                        "id": 35469,
                        "name": "Mogán",
                        "latitude": "27.88385000",
                        "longitude": "-15.72538000"
                    },
                    {
                        "id": 35647,
                        "name": "Moya",
                        "latitude": "28.11106000",
                        "longitude": "-15.58285000"
                    },
                    {
                        "id": 35794,
                        "name": "Nazaret",
                        "latitude": "29.03818000",
                        "longitude": "-13.56386000"
                    },
                    {
                        "id": 153197,
                        "name": "Oliva La",
                        "latitude": "28.61007670",
                        "longitude": "-13.92672520"
                    },
                    {
                        "id": 36480,
                        "name": "Pájara",
                        "latitude": "28.35039000",
                        "longitude": "-14.10760000"
                    },
                    {
                        "id": 153198,
                        "name": "Palmas de Gran Canaria Las",
                        "latitude": "28.12354590",
                        "longitude": "-15.43625740"
                    },
                    {
                        "id": 36239,
                        "name": "Playa Blanca",
                        "latitude": "28.86426000",
                        "longitude": "-13.82814000"
                    },
                    {
                        "id": 36240,
                        "name": "Playa de las Américas",
                        "latitude": "28.06403000",
                        "longitude": "-16.73012000"
                    },
                    {
                        "id": 36241,
                        "name": "Playa del Ingles",
                        "latitude": "27.75670000",
                        "longitude": "-15.57870000"
                    },
                    {
                        "id": 36376,
                        "name": "Provincia de Las Palmas",
                        "latitude": "28.42039000",
                        "longitude": "-14.01306000"
                    },
                    {
                        "id": 36386,
                        "name": "Provincia de Santa Cruz de Tenerife",
                        "latitude": "28.16667000",
                        "longitude": "-17.33333000"
                    },
                    {
                        "id": 36455,
                        "name": "Puerto del Carmen",
                        "latitude": "28.92313000",
                        "longitude": "-13.66579000"
                    },
                    {
                        "id": 36456,
                        "name": "Puerto del Rosario",
                        "latitude": "28.50038000",
                        "longitude": "-13.86272000"
                    },
                    {
                        "id": 36448,
                        "name": "Puerto Rico",
                        "latitude": "27.78943000",
                        "longitude": "-15.71045000"
                    },
                    {
                        "id": 36471,
                        "name": "Punta de Mujeres",
                        "latitude": "29.14660000",
                        "longitude": "-13.44761000"
                    },
                    {
                        "id": 36553,
                        "name": "Realejo Alto",
                        "latitude": "28.37645000",
                        "longitude": "-16.58575000"
                    },
                    {
                        "id": 36806,
                        "name": "San Bartolomé",
                        "latitude": "29.00093000",
                        "longitude": "-13.61300000"
                    },
                    {
                        "id": 36809,
                        "name": "San Bartolomé de Tirajana",
                        "latitude": "27.92481000",
                        "longitude": "-15.57329000"
                    },
                    {
                        "id": 36895,
                        "name": "San Nicolás",
                        "latitude": "27.98910000",
                        "longitude": "-15.78126000"
                    },
                    {
                        "id": 37007,
                        "name": "Santa Brígida",
                        "latitude": "28.03197000",
                        "longitude": "-15.50425000"
                    },
                    {
                        "id": 37062,
                        "name": "Santa Lucía",
                        "latitude": "27.91174000",
                        "longitude": "-15.54071000"
                    },
                    {
                        "id": 153200,
                        "name": "Santa Lucía de Tirajana",
                        "latitude": "27.91006630",
                        "longitude": "-15.54021120"
                    },
                    {
                        "id": 153201,
                        "name": "Santa María de Guía de Gran Canaria",
                        "latitude": "28.10744940",
                        "longitude": "-15.60606610"
                    },
                    {
                        "id": 37180,
                        "name": "Sauzal",
                        "latitude": "28.46667000",
                        "longitude": "-16.41667000"
                    },
                    {
                        "id": 37368,
                        "name": "Tanque",
                        "latitude": "28.36667000",
                        "longitude": "-16.83333000"
                    },
                    {
                        "id": 37392,
                        "name": "Teguise",
                        "latitude": "29.06049000",
                        "longitude": "-13.56397000"
                    },
                    {
                        "id": 37397,
                        "name": "Tejeda",
                        "latitude": "27.99508000",
                        "longitude": "-15.61543000"
                    },
                    {
                        "id": 37400,
                        "name": "Telde",
                        "latitude": "27.99243000",
                        "longitude": "-15.41915000"
                    },
                    {
                        "id": 37405,
                        "name": "Teror",
                        "latitude": "28.06062000",
                        "longitude": "-15.54909000"
                    },
                    {
                        "id": 37666,
                        "name": "Tías",
                        "latitude": "28.96108000",
                        "longitude": "-13.64502000"
                    },
                    {
                        "id": 37427,
                        "name": "Tinajo",
                        "latitude": "29.06326000",
                        "longitude": "-13.67647000"
                    },
                    {
                        "id": 37652,
                        "name": "Tuineje",
                        "latitude": "28.32372000",
                        "longitude": "-14.04722000"
                    },
                    {
                        "id": 37850,
                        "name": "Vallehermosa",
                        "latitude": "28.17944000",
                        "longitude": "-17.26664000"
                    },
                    {
                        "id": 37857,
                        "name": "Valleseco",
                        "latitude": "28.04330000",
                        "longitude": "-15.57623000"
                    },
                    {
                        "id": 37875,
                        "name": "Valsequillo de Gran Canaria",
                        "latitude": "27.98562000",
                        "longitude": "-15.49725000"
                    },
                    {
                        "id": 37900,
                        "name": "Vecindario",
                        "latitude": "27.84636000",
                        "longitude": "-15.44455000"
                    },
                    {
                        "id": 37907,
                        "name": "Vega de San Mateo",
                        "latitude": "28.00892000",
                        "longitude": "-15.53330000"
                    },
                    {
                        "id": 38425,
                        "name": "Yaiza",
                        "latitude": "28.95678000",
                        "longitude": "-13.76535000"
                    }
                ]
            },
            {
                "id": 1200,
                "name": "León",
                "iso2": "LE",
                "latitude": "42.59870410",
                "longitude": "-5.56708390",
                "type": "province",
                "cities": [
                    {
                        "id": 31922,
                        "name": "Acebedo",
                        "latitude": "43.03969000",
                        "longitude": "-5.11600000"
                    },
                    {
                        "id": 32208,
                        "name": "Algadefe",
                        "latitude": "42.21931000",
                        "longitude": "-5.58419000"
                    },
                    {
                        "id": 152977,
                        "name": "Alija del Infantado",
                        "latitude": "42.13870900",
                        "longitude": "-5.83406510"
                    },
                    {
                        "id": 32267,
                        "name": "Almanza",
                        "latitude": "42.65825000",
                        "longitude": "-5.03620000"
                    },
                    {
                        "id": 152978,
                        "name": "Antigua La",
                        "latitude": "42.17882650",
                        "longitude": "-5.69083340"
                    },
                    {
                        "id": 32442,
                        "name": "Ardón",
                        "latitude": "42.43629000",
                        "longitude": "-5.56048000"
                    },
                    {
                        "id": 32463,
                        "name": "Arganza",
                        "latitude": "42.64077000",
                        "longitude": "-6.68627000"
                    },
                    {
                        "id": 32540,
                        "name": "Astorga",
                        "latitude": "42.45879000",
                        "longitude": "-6.05601000"
                    },
                    {
                        "id": 32621,
                        "name": "Balboa",
                        "latitude": "42.70608000",
                        "longitude": "-6.92222000"
                    },
                    {
                        "id": 152979,
                        "name": "Bañeza La",
                        "latitude": "42.29099730",
                        "longitude": "-5.90927540"
                    },
                    {
                        "id": 32665,
                        "name": "Barjas",
                        "latitude": "42.61182000",
                        "longitude": "-6.97979000"
                    },
                    {
                        "id": 32669,
                        "name": "Barraco",
                        "latitude": "40.47647000",
                        "longitude": "-4.64346000"
                    },
                    {
                        "id": 152980,
                        "name": "Barrios de Luna Los",
                        "latitude": "42.84476000",
                        "longitude": "-5.86242280"
                    },
                    {
                        "id": 32756,
                        "name": "Bembibre",
                        "latitude": "42.61771000",
                        "longitude": "-6.41545000"
                    },
                    {
                        "id": 32782,
                        "name": "Benavides",
                        "latitude": "42.50442000",
                        "longitude": "-5.89442000"
                    },
                    {
                        "id": 32828,
                        "name": "Benuza",
                        "latitude": "42.39941000",
                        "longitude": "-6.70969000"
                    },
                    {
                        "id": 32842,
                        "name": "Bercianos del Páramo",
                        "latitude": "42.38017000",
                        "longitude": "-5.70834000"
                    },
                    {
                        "id": 32843,
                        "name": "Bercianos del Real Camino",
                        "latitude": "42.38732000",
                        "longitude": "-5.14462000"
                    },
                    {
                        "id": 32856,
                        "name": "Berlanga del Bierzo",
                        "latitude": "42.73104000",
                        "longitude": "-6.60565000"
                    },
                    {
                        "id": 32922,
                        "name": "Boca de Huérgano",
                        "latitude": "42.97287000",
                        "longitude": "-4.92419000"
                    },
                    {
                        "id": 32967,
                        "name": "Boñar",
                        "latitude": "42.86680000",
                        "longitude": "-5.32386000"
                    },
                    {
                        "id": 32961,
                        "name": "Borrenes",
                        "latitude": "42.49019000",
                        "longitude": "-6.72338000"
                    },
                    {
                        "id": 32972,
                        "name": "Brazuelo",
                        "latitude": "42.49702000",
                        "longitude": "-6.15734000"
                    },
                    {
                        "id": 152981,
                        "name": "Burgo Ranero El",
                        "latitude": "42.42319110",
                        "longitude": "-5.21949030"
                    },
                    {
                        "id": 33034,
                        "name": "Burón",
                        "latitude": "43.02486000",
                        "longitude": "-5.05119000"
                    },
                    {
                        "id": 33042,
                        "name": "Bustillo del Páramo",
                        "latitude": "42.44126000",
                        "longitude": "-5.79280000"
                    },
                    {
                        "id": 152982,
                        "name": "Cabañas Raras",
                        "latitude": "42.62031170",
                        "longitude": "-6.63745170"
                    },
                    {
                        "id": 33090,
                        "name": "Cabezón",
                        "latitude": "41.73369000",
                        "longitude": "-4.64510000"
                    },
                    {
                        "id": 33108,
                        "name": "Cabreros del Río",
                        "latitude": "42.40205000",
                        "longitude": "-5.54154000"
                    },
                    {
                        "id": 33109,
                        "name": "Cabrillanes",
                        "latitude": "42.95343000",
                        "longitude": "-6.14849000"
                    },
                    {
                        "id": 33112,
                        "name": "Cacabelos",
                        "latitude": "42.60021000",
                        "longitude": "-6.72373000"
                    },
                    {
                        "id": 33160,
                        "name": "Calzada del Coto",
                        "latitude": "42.38613000",
                        "longitude": "-5.07809000"
                    },
                    {
                        "id": 33184,
                        "name": "Campazas",
                        "latitude": "42.14219000",
                        "longitude": "-5.49349000"
                    },
                    {
                        "id": 33204,
                        "name": "Campo de Villavidel",
                        "latitude": "42.43906000",
                        "longitude": "-5.52808000"
                    },
                    {
                        "id": 33206,
                        "name": "Camponaraya",
                        "latitude": "42.57799000",
                        "longitude": "-6.66709000"
                    },
                    {
                        "id": 33230,
                        "name": "Candín",
                        "latitude": "42.81695000",
                        "longitude": "-6.72848000"
                    },
                    {
                        "id": 33897,
                        "name": "Cármenes",
                        "latitude": "42.95863000",
                        "longitude": "-5.57346000"
                    },
                    {
                        "id": 33315,
                        "name": "Carracedelo",
                        "latitude": "42.55602000",
                        "longitude": "-6.73317000"
                    },
                    {
                        "id": 152983,
                        "name": "Carrizo",
                        "latitude": "42.58395510",
                        "longitude": "-5.82927530"
                    },
                    {
                        "id": 33329,
                        "name": "Carrizo de la Ribera",
                        "latitude": "42.58395000",
                        "longitude": "-5.82881000"
                    },
                    {
                        "id": 33334,
                        "name": "Carrocera",
                        "latitude": "42.79605000",
                        "longitude": "-5.74374000"
                    },
                    {
                        "id": 33341,
                        "name": "Carucedo",
                        "latitude": "42.49029000",
                        "longitude": "-6.76565000"
                    },
                    {
                        "id": 33449,
                        "name": "Castilfalé",
                        "latitude": "42.21991000",
                        "longitude": "-5.42122000"
                    },
                    {
                        "id": 33475,
                        "name": "Castrillo de Cabrera",
                        "latitude": "42.34036000",
                        "longitude": "-6.54451000"
                    },
                    {
                        "id": 33482,
                        "name": "Castrillo de la Valduerna",
                        "latitude": "42.32393000",
                        "longitude": "-6.13455000"
                    },
                    {
                        "id": 33494,
                        "name": "Castrocalbón",
                        "latitude": "42.19706000",
                        "longitude": "-5.98226000"
                    },
                    {
                        "id": 33495,
                        "name": "Castrocontrigo",
                        "latitude": "42.18363000",
                        "longitude": "-6.19022000"
                    },
                    {
                        "id": 33505,
                        "name": "Castropodame",
                        "latitude": "42.57943000",
                        "longitude": "-6.46837000"
                    },
                    {
                        "id": 152984,
                        "name": "Castrotierra de Valmadrigal",
                        "latitude": "42.34713590",
                        "longitude": "-5.24689910"
                    },
                    {
                        "id": 152985,
                        "name": "Cea",
                        "latitude": "42.46182760",
                        "longitude": "-5.01239530"
                    },
                    {
                        "id": 33548,
                        "name": "Cebanico",
                        "latitude": "42.72526000",
                        "longitude": "-5.02568000"
                    },
                    {
                        "id": 33552,
                        "name": "Cebrones del Río",
                        "latitude": "42.25726000",
                        "longitude": "-5.82622000"
                    },
                    {
                        "id": 33646,
                        "name": "Chozas de Abajo",
                        "latitude": "42.50657000",
                        "longitude": "-5.68656000"
                    },
                    {
                        "id": 33673,
                        "name": "Cimanes de la Vega",
                        "latitude": "42.11646000",
                        "longitude": "-5.59851000"
                    },
                    {
                        "id": 33674,
                        "name": "Cimanes del Tejar",
                        "latitude": "42.61789000",
                        "longitude": "-5.80506000"
                    },
                    {
                        "id": 33693,
                        "name": "Cistierna",
                        "latitude": "42.80344000",
                        "longitude": "-5.12664000"
                    },
                    {
                        "id": 33758,
                        "name": "Congosto",
                        "latitude": "42.61755000",
                        "longitude": "-6.52048000"
                    },
                    {
                        "id": 33776,
                        "name": "Corbillos de los Oteros",
                        "latitude": "42.40769000",
                        "longitude": "-5.45963000"
                    },
                    {
                        "id": 33803,
                        "name": "Corrales",
                        "latitude": "41.35800000",
                        "longitude": "-5.72479000"
                    },
                    {
                        "id": 33813,
                        "name": "Corullón",
                        "latitude": "42.57896000",
                        "longitude": "-6.81925000"
                    },
                    {
                        "id": 33841,
                        "name": "Crémenes",
                        "latitude": "42.90357000",
                        "longitude": "-5.14374000"
                    },
                    {
                        "id": 33842,
                        "name": "Cuadros",
                        "latitude": "42.71163000",
                        "longitude": "-5.63828000"
                    },
                    {
                        "id": 33853,
                        "name": "Cubillas de los Oteros",
                        "latitude": "42.37199000",
                        "longitude": "-5.50877000"
                    },
                    {
                        "id": 33851,
                        "name": "Cubillas de Rueda",
                        "latitude": "42.65626000",
                        "longitude": "-5.17528000"
                    },
                    {
                        "id": 33857,
                        "name": "Cubillos del Sil",
                        "latitude": "42.62519000",
                        "longitude": "-6.56360000"
                    },
                    {
                        "id": 33930,
                        "name": "Destriana",
                        "latitude": "42.32729000",
                        "longitude": "-6.09573000"
                    },
                    {
                        "id": 33979,
                        "name": "El Barco de Ávila",
                        "latitude": "40.35710000",
                        "longitude": "-5.52365000"
                    },
                    {
                        "id": 33983,
                        "name": "El Burgo de Osma",
                        "latitude": "41.58619000",
                        "longitude": "-3.06522000"
                    },
                    {
                        "id": 34000,
                        "name": "El Hoyo de Pinares",
                        "latitude": "40.50084000",
                        "longitude": "-4.42357000"
                    },
                    {
                        "id": 34020,
                        "name": "El Tiemblo",
                        "latitude": "40.41533000",
                        "longitude": "-4.50156000"
                    },
                    {
                        "id": 34053,
                        "name": "Encinedo",
                        "latitude": "42.27049000",
                        "longitude": "-6.59368000"
                    },
                    {
                        "id": 152986,
                        "name": "Ercina La",
                        "latitude": "42.80940040",
                        "longitude": "-5.21306780"
                    },
                    {
                        "id": 34085,
                        "name": "Escobar de Campos",
                        "latitude": "42.31337000",
                        "longitude": "-4.96573000"
                    },
                    {
                        "id": 34155,
                        "name": "Fabero",
                        "latitude": "42.76803000",
                        "longitude": "-6.62651000"
                    },
                    {
                        "id": 34200,
                        "name": "Folgoso de la Ribera",
                        "latitude": "42.64693000",
                        "longitude": "-6.32035000"
                    },
                    {
                        "id": 34263,
                        "name": "Fresno de la Vega",
                        "latitude": "42.34545000",
                        "longitude": "-5.53587000"
                    },
                    {
                        "id": 34342,
                        "name": "Fuentes de Carbajal",
                        "latitude": "42.17776000",
                        "longitude": "-5.44606000"
                    },
                    {
                        "id": 34400,
                        "name": "Gamonal",
                        "latitude": "42.35664000",
                        "longitude": "-3.67321000"
                    },
                    {
                        "id": 34421,
                        "name": "Garrafe de Torío",
                        "latitude": "42.73285000",
                        "longitude": "-5.52360000"
                    },
                    {
                        "id": 34485,
                        "name": "Gordaliza del Pino",
                        "latitude": "42.34357000",
                        "longitude": "-5.15731000"
                    },
                    {
                        "id": 34486,
                        "name": "Gordoncillo",
                        "latitude": "42.13557000",
                        "longitude": "-5.40181000"
                    },
                    {
                        "id": 34492,
                        "name": "Gradefes",
                        "latitude": "42.62396000",
                        "longitude": "-5.22691000"
                    },
                    {
                        "id": 34495,
                        "name": "Grajal de Campos",
                        "latitude": "42.32073000",
                        "longitude": "-5.01938000"
                    },
                    {
                        "id": 34555,
                        "name": "Gusendos de los Oteros",
                        "latitude": "42.37818000",
                        "longitude": "-5.43088000"
                    },
                    {
                        "id": 34669,
                        "name": "Hospital de Órbigo",
                        "latitude": "42.46354000",
                        "longitude": "-5.88636000"
                    },
                    {
                        "id": 34691,
                        "name": "Huerta del Rey",
                        "latitude": "41.83910000",
                        "longitude": "-3.34755000"
                    },
                    {
                        "id": 34742,
                        "name": "Igüeña",
                        "latitude": "42.72853000",
                        "longitude": "-6.27738000"
                    },
                    {
                        "id": 34778,
                        "name": "Izagre",
                        "latitude": "42.22410000",
                        "longitude": "-5.25727000"
                    },
                    {
                        "id": 34820,
                        "name": "Joarilla de las Matas",
                        "latitude": "42.28755000",
                        "longitude": "-5.17855000"
                    },
                    {
                        "id": 34848,
                        "name": "La Adrada",
                        "latitude": "40.29953000",
                        "longitude": "-4.63589000"
                    },
                    {
                        "id": 34850,
                        "name": "La Alberca",
                        "latitude": "40.48908000",
                        "longitude": "-6.11107000"
                    },
                    {
                        "id": 34856,
                        "name": "La Bañeza",
                        "latitude": "42.30026000",
                        "longitude": "-5.89772000"
                    },
                    {
                        "id": 34859,
                        "name": "La Bouza",
                        "latitude": "40.83626000",
                        "longitude": "-6.79551000"
                    },
                    {
                        "id": 34866,
                        "name": "La Carrera",
                        "latitude": "40.34777000",
                        "longitude": "-5.55474000"
                    },
                    {
                        "id": 34869,
                        "name": "La Cuesta",
                        "latitude": "41.08280000",
                        "longitude": "-3.96017000"
                    },
                    {
                        "id": 34873,
                        "name": "La Fuente de San Esteban",
                        "latitude": "40.80161000",
                        "longitude": "-6.25852000"
                    },
                    {
                        "id": 34889,
                        "name": "La Lastrilla",
                        "latitude": "40.96817000",
                        "longitude": "-4.10468000"
                    },
                    {
                        "id": 34901,
                        "name": "La Pedraja de Portillo",
                        "latitude": "41.47124000",
                        "longitude": "-4.64639000"
                    },
                    {
                        "id": 34908,
                        "name": "La Pola de Gordón",
                        "latitude": "42.85658000",
                        "longitude": "-5.66768000"
                    },
                    {
                        "id": 34918,
                        "name": "La Robla",
                        "latitude": "42.80302000",
                        "longitude": "-5.62904000"
                    },
                    {
                        "id": 34925,
                        "name": "La Seca",
                        "latitude": "41.41364000",
                        "longitude": "-4.90552000"
                    },
                    {
                        "id": 34945,
                        "name": "Laguna Dalga",
                        "latitude": "42.33192000",
                        "longitude": "-5.75220000"
                    },
                    {
                        "id": 34949,
                        "name": "Laguna de Negrillos",
                        "latitude": "42.23889000",
                        "longitude": "-5.66066000"
                    },
                    {
                        "id": 34987,
                        "name": "Las Navas del Marqués",
                        "latitude": "40.60244000",
                        "longitude": "-4.33449000"
                    },
                    {
                        "id": 35045,
                        "name": "León",
                        "latitude": "42.60003000",
                        "longitude": "-5.57032000"
                    },
                    {
                        "id": 35065,
                        "name": "Llamas de la Ribera",
                        "latitude": "42.63504000",
                        "longitude": "-5.82524000"
                    },
                    {
                        "id": 152987,
                        "name": "Lucillo",
                        "latitude": "42.40915470",
                        "longitude": "-6.30333640"
                    },
                    {
                        "id": 35170,
                        "name": "Luyego",
                        "latitude": "42.36667000",
                        "longitude": "-6.23333000"
                    },
                    {
                        "id": 35202,
                        "name": "Magaz de Cepeda",
                        "latitude": "42.53967000",
                        "longitude": "-6.07170000"
                    },
                    {
                        "id": 35258,
                        "name": "Mansilla de las Mulas",
                        "latitude": "42.49886000",
                        "longitude": "-5.41738000"
                    },
                    {
                        "id": 35257,
                        "name": "Mansilla Mayor",
                        "latitude": "42.50943000",
                        "longitude": "-5.44271000"
                    },
                    {
                        "id": 35279,
                        "name": "Maraña",
                        "latitude": "43.04991000",
                        "longitude": "-5.17726000"
                    },
                    {
                        "id": 35333,
                        "name": "Matadeón de los Oteros",
                        "latitude": "42.33776000",
                        "longitude": "-5.36887000"
                    },
                    {
                        "id": 35335,
                        "name": "Matallana de Torío",
                        "latitude": "42.86560000",
                        "longitude": "-5.52034000"
                    },
                    {
                        "id": 152988,
                        "name": "Matanza",
                        "latitude": "42.24057390",
                        "longitude": "-5.37422850"
                    },
                    {
                        "id": 35479,
                        "name": "Molinaseca",
                        "latitude": "42.53829000",
                        "longitude": "-6.51997000"
                    },
                    {
                        "id": 35674,
                        "name": "Murias de Paredes",
                        "latitude": "42.85027000",
                        "longitude": "-6.19164000"
                    },
                    {
                        "id": 152989,
                        "name": "Noceda del Bierzo",
                        "latitude": "42.71191440",
                        "longitude": "-6.39856630"
                    },
                    {
                        "id": 35861,
                        "name": "Oencia",
                        "latitude": "42.54758000",
                        "longitude": "-6.96859000"
                    },
                    {
                        "id": 152990,
                        "name": "Omañas Las",
                        "latitude": "42.68164860",
                        "longitude": "-5.87000910"
                    },
                    {
                        "id": 35930,
                        "name": "Onzonilla",
                        "latitude": "42.52435000",
                        "longitude": "-5.58160000"
                    },
                    {
                        "id": 35971,
                        "name": "Oseja de Sajambre",
                        "latitude": "43.13671000",
                        "longitude": "-5.03786000"
                    },
                    {
                        "id": 36003,
                        "name": "Pajares de los Oteros",
                        "latitude": "42.33010000",
                        "longitude": "-5.47313000"
                    },
                    {
                        "id": 36009,
                        "name": "Palacios de la Valduerna",
                        "latitude": "42.32773000",
                        "longitude": "-5.93830000"
                    },
                    {
                        "id": 36012,
                        "name": "Palacios del Sil",
                        "latitude": "42.87601000",
                        "longitude": "-6.43150000"
                    },
                    {
                        "id": 36483,
                        "name": "Páramo del Sil",
                        "latitude": "42.82056000",
                        "longitude": "-6.48747000"
                    },
                    {
                        "id": 36145,
                        "name": "Peranzanes",
                        "latitude": "42.87725000",
                        "longitude": "-6.63383000"
                    },
                    {
                        "id": 36250,
                        "name": "Pobladura de Pelayo García",
                        "latitude": "42.30602000",
                        "longitude": "-5.68560000"
                    },
                    {
                        "id": 152991,
                        "name": "Pola de Gordón La",
                        "latitude": "42.85437720",
                        "longitude": "-5.67143310"
                    },
                    {
                        "id": 36270,
                        "name": "Ponferrada",
                        "latitude": "42.54664000",
                        "longitude": "-6.59619000"
                    },
                    {
                        "id": 36302,
                        "name": "Posada de Valdeón",
                        "latitude": "43.15154000",
                        "longitude": "-4.92102000"
                    },
                    {
                        "id": 36337,
                        "name": "Pozuelo del Páramo",
                        "latitude": "42.17101000",
                        "longitude": "-5.76813000"
                    },
                    {
                        "id": 36345,
                        "name": "Prado de la Guzpeña",
                        "latitude": "42.78309000",
                        "longitude": "-5.02554000"
                    },
                    {
                        "id": 36352,
                        "name": "Priaranza del Bierzo",
                        "latitude": "42.50978000",
                        "longitude": "-6.67017000"
                    },
                    {
                        "id": 36356,
                        "name": "Prioro",
                        "latitude": "42.89481000",
                        "longitude": "-4.96349000"
                    },
                    {
                        "id": 36394,
                        "name": "Provincia de Ávila",
                        "latitude": "40.58333000",
                        "longitude": "-5.00000000"
                    },
                    {
                        "id": 36364,
                        "name": "Provincia de Burgos",
                        "latitude": "42.33939000",
                        "longitude": "-3.70789000"
                    },
                    {
                        "id": 36377,
                        "name": "Provincia de León",
                        "latitude": "42.66667000",
                        "longitude": "-6.00000000"
                    },
                    {
                        "id": 36383,
                        "name": "Provincia de Palencia",
                        "latitude": "42.41667000",
                        "longitude": "-4.50000000"
                    },
                    {
                        "id": 36385,
                        "name": "Provincia de Salamanca",
                        "latitude": "40.83333000",
                        "longitude": "-6.00000000"
                    },
                    {
                        "id": 36387,
                        "name": "Provincia de Segovia",
                        "latitude": "41.16667000",
                        "longitude": "-4.00000000"
                    },
                    {
                        "id": 36389,
                        "name": "Provincia de Soria",
                        "latitude": "41.66667000",
                        "longitude": "-2.66667000"
                    },
                    {
                        "id": 36391,
                        "name": "Provincia de Valladolid",
                        "latitude": "41.58333000",
                        "longitude": "-4.66667000"
                    },
                    {
                        "id": 36392,
                        "name": "Provincia de Zamora",
                        "latitude": "41.75000000",
                        "longitude": "-6.00000000"
                    },
                    {
                        "id": 36418,
                        "name": "Puebla de Lillo",
                        "latitude": "43.00691000",
                        "longitude": "-5.27387000"
                    },
                    {
                        "id": 36435,
                        "name": "Puente de Domingo Flórez",
                        "latitude": "42.41166000",
                        "longitude": "-6.82077000"
                    },
                    {
                        "id": 36503,
                        "name": "Quintana del Castillo",
                        "latitude": "42.65987000",
                        "longitude": "-6.04978000"
                    },
                    {
                        "id": 36504,
                        "name": "Quintana del Marco",
                        "latitude": "42.20670000",
                        "longitude": "-5.85030000"
                    },
                    {
                        "id": 36507,
                        "name": "Quintana y Congosto",
                        "latitude": "42.25585000",
                        "longitude": "-6.03636000"
                    },
                    {
                        "id": 36565,
                        "name": "Regueras de Arriba",
                        "latitude": "42.29414000",
                        "longitude": "-5.85958000"
                    },
                    {
                        "id": 36598,
                        "name": "Reyero",
                        "latitude": "42.94882000",
                        "longitude": "-5.19892000"
                    },
                    {
                        "id": 36605,
                        "name": "Riaño",
                        "latitude": "42.97705000",
                        "longitude": "-5.00352000"
                    },
                    {
                        "id": 36622,
                        "name": "Riego de la Vega",
                        "latitude": "42.39138000",
                        "longitude": "-5.98102000"
                    },
                    {
                        "id": 152992,
                        "name": "Riello",
                        "latitude": "42.77394180",
                        "longitude": "-5.94526440"
                    },
                    {
                        "id": 152993,
                        "name": "Rioseco de Tapia",
                        "latitude": "42.73048710",
                        "longitude": "-5.78990650"
                    },
                    {
                        "id": 152994,
                        "name": "Robla La",
                        "latitude": "42.80124890",
                        "longitude": "-5.62739510"
                    },
                    {
                        "id": 36674,
                        "name": "Roperuelos del Páramo",
                        "latitude": "42.23780000",
                        "longitude": "-5.78235000"
                    },
                    {
                        "id": 36701,
                        "name": "Ruesga",
                        "latitude": "42.86413000",
                        "longitude": "-4.52942000"
                    },
                    {
                        "id": 36723,
                        "name": "Sabero",
                        "latitude": "42.83593000",
                        "longitude": "-5.14875000"
                    },
                    {
                        "id": 36741,
                        "name": "Sahagún",
                        "latitude": "42.37085000",
                        "longitude": "-5.02942000"
                    },
                    {
                        "id": 36797,
                        "name": "San Adrián del Valle",
                        "latitude": "42.13033000",
                        "longitude": "-5.72905000"
                    },
                    {
                        "id": 36803,
                        "name": "San Andrés del Rabanedo",
                        "latitude": "42.61174000",
                        "longitude": "-5.61671000"
                    },
                    {
                        "id": 36824,
                        "name": "San Cristóbal de la Polantera",
                        "latitude": "42.39041000",
                        "longitude": "-5.90732000"
                    },
                    {
                        "id": 36826,
                        "name": "San Emiliano",
                        "latitude": "42.97164000",
                        "longitude": "-6.00075000"
                    },
                    {
                        "id": 36829,
                        "name": "San Esteban de Nogales",
                        "latitude": "42.15995000",
                        "longitude": "-5.93065000"
                    },
                    {
                        "id": 36838,
                        "name": "San Ildefonso",
                        "latitude": "40.90182000",
                        "longitude": "-4.00685000"
                    },
                    {
                        "id": 36854,
                        "name": "San Justo de la Vega",
                        "latitude": "42.45696000",
                        "longitude": "-6.01825000"
                    },
                    {
                        "id": 36892,
                        "name": "San Millán de los Caballeros",
                        "latitude": "42.28520000",
                        "longitude": "-5.56107000"
                    },
                    {
                        "id": 36900,
                        "name": "San Pedro Bercianos",
                        "latitude": "42.39145000",
                        "longitude": "-5.71341000"
                    },
                    {
                        "id": 36934,
                        "name": "Sancedo",
                        "latitude": "42.66666000",
                        "longitude": "-6.63456000"
                    },
                    {
                        "id": 37018,
                        "name": "Santa Colomba de Curueño",
                        "latitude": "42.75058000",
                        "longitude": "-5.41201000"
                    },
                    {
                        "id": 37019,
                        "name": "Santa Colomba de Somoza",
                        "latitude": "42.44466000",
                        "longitude": "-6.24483000"
                    },
                    {
                        "id": 37023,
                        "name": "Santa Cristina de Valmadrigal",
                        "latitude": "42.35446000",
                        "longitude": "-5.30929000"
                    },
                    {
                        "id": 37048,
                        "name": "Santa Elena de Jamuz",
                        "latitude": "42.26064000",
                        "longitude": "-5.88762000"
                    },
                    {
                        "id": 37080,
                        "name": "Santa María de la Isla",
                        "latitude": "42.35533000",
                        "longitude": "-5.92870000"
                    },
                    {
                        "id": 37076,
                        "name": "Santa María de Ordás",
                        "latitude": "42.72653000",
                        "longitude": "-5.82301000"
                    },
                    {
                        "id": 37088,
                        "name": "Santa María del Monte de Cea",
                        "latitude": "42.49137000",
                        "longitude": "-5.11689000"
                    },
                    {
                        "id": 37089,
                        "name": "Santa María del Páramo",
                        "latitude": "42.35512000",
                        "longitude": "-5.75151000"
                    },
                    {
                        "id": 37068,
                        "name": "Santa Marina del Rey",
                        "latitude": "42.51334000",
                        "longitude": "-5.86065000"
                    },
                    {
                        "id": 37108,
                        "name": "Santas Martas",
                        "latitude": "42.43220000",
                        "longitude": "-5.37066000"
                    },
                    {
                        "id": 37112,
                        "name": "Santiago Millas",
                        "latitude": "42.38379000",
                        "longitude": "-6.10538000"
                    },
                    {
                        "id": 152995,
                        "name": "Santovenia de la Valdoncina",
                        "latitude": "42.54363890",
                        "longitude": "-5.62279600"
                    },
                    {
                        "id": 37162,
                        "name": "Sariegos",
                        "latitude": "42.65000000",
                        "longitude": "-5.63333000"
                    },
                    {
                        "id": 37208,
                        "name": "Sena de Luna",
                        "latitude": "42.92906000",
                        "longitude": "-5.95267000"
                    },
                    {
                        "id": 37275,
                        "name": "Sobrado",
                        "latitude": "42.51667000",
                        "longitude": "-6.85000000"
                    },
                    {
                        "id": 37318,
                        "name": "Soto de la Vega",
                        "latitude": "42.33227000",
                        "longitude": "-5.88225000"
                    },
                    {
                        "id": 37320,
                        "name": "Soto y Amío",
                        "latitude": "42.77477000",
                        "longitude": "-5.88693000"
                    },
                    {
                        "id": 37454,
                        "name": "Toral de los Guzmanes",
                        "latitude": "42.24274000",
                        "longitude": "-5.56771000"
                    },
                    {
                        "id": 152999,
                        "name": "Toral de los Vados",
                        "latitude": "42.55144100",
                        "longitude": "-6.77616860"
                    },
                    {
                        "id": 37464,
                        "name": "Toreno",
                        "latitude": "42.69955000",
                        "longitude": "-6.51236000"
                    },
                    {
                        "id": 37499,
                        "name": "Torre del Bierzo",
                        "latitude": "42.60769000",
                        "longitude": "-6.36675000"
                    },
                    {
                        "id": 37612,
                        "name": "Trabadelo",
                        "latitude": "42.64874000",
                        "longitude": "-6.88000000"
                    },
                    {
                        "id": 37643,
                        "name": "Truchas",
                        "latitude": "42.26093000",
                        "longitude": "-6.43605000"
                    },
                    {
                        "id": 37654,
                        "name": "Turcia",
                        "latitude": "42.53431000",
                        "longitude": "-5.87844000"
                    },
                    {
                        "id": 37691,
                        "name": "Urdiales del Páramo",
                        "latitude": "42.37034000",
                        "longitude": "-5.77297000"
                    },
                    {
                        "id": 37719,
                        "name": "Val de San Lorenzo",
                        "latitude": "42.41819000",
                        "longitude": "-6.12391000"
                    },
                    {
                        "id": 37744,
                        "name": "Valdefresno",
                        "latitude": "42.59492000",
                        "longitude": "-5.49355000"
                    },
                    {
                        "id": 37747,
                        "name": "Valdefuentes del Páramo",
                        "latitude": "42.32370000",
                        "longitude": "-5.83097000"
                    },
                    {
                        "id": 152996,
                        "name": "Valdelugueros",
                        "latitude": "42.98872960",
                        "longitude": "-5.41490030"
                    },
                    {
                        "id": 37770,
                        "name": "Valdemora",
                        "latitude": "42.19541000",
                        "longitude": "-5.42747000"
                    },
                    {
                        "id": 37785,
                        "name": "Valdepiélago",
                        "latitude": "42.86895000",
                        "longitude": "-5.39763000"
                    },
                    {
                        "id": 37787,
                        "name": "Valdepolo",
                        "latitude": "42.57686000",
                        "longitude": "-5.22513000"
                    },
                    {
                        "id": 37790,
                        "name": "Valderas",
                        "latitude": "42.07830000",
                        "longitude": "-5.44355000"
                    },
                    {
                        "id": 37792,
                        "name": "Valderrey",
                        "latitude": "42.39408000",
                        "longitude": "-6.02151000"
                    },
                    {
                        "id": 37797,
                        "name": "Valderrueda",
                        "latitude": "42.81558000",
                        "longitude": "-4.94731000"
                    },
                    {
                        "id": 37799,
                        "name": "Valdesamario",
                        "latitude": "42.72094000",
                        "longitude": "-5.95104000"
                    },
                    {
                        "id": 37807,
                        "name": "Valdevimbre",
                        "latitude": "42.41959000",
                        "longitude": "-5.61975000"
                    },
                    {
                        "id": 37818,
                        "name": "Valencia de Don Juan",
                        "latitude": "42.29374000",
                        "longitude": "-5.51720000"
                    },
                    {
                        "id": 37849,
                        "name": "Vallecillo",
                        "latitude": "42.35604000",
                        "longitude": "-5.21088000"
                    },
                    {
                        "id": 37891,
                        "name": "Valverde de la Virgen",
                        "latitude": "42.56823000",
                        "longitude": "-5.68461000"
                    },
                    {
                        "id": 37896,
                        "name": "Valverde-Enrique",
                        "latitude": "42.30459000",
                        "longitude": "-5.29990000"
                    },
                    {
                        "id": 152997,
                        "name": "Vecilla La",
                        "latitude": "42.82414270",
                        "longitude": "-5.40442680"
                    },
                    {
                        "id": 37903,
                        "name": "Vega de Espinareda",
                        "latitude": "42.72537000",
                        "longitude": "-6.65439000"
                    },
                    {
                        "id": 37904,
                        "name": "Vega de Infanzones",
                        "latitude": "42.48116000",
                        "longitude": "-5.53295000"
                    },
                    {
                        "id": 37911,
                        "name": "Vega de Valcarce",
                        "latitude": "42.66068000",
                        "longitude": "-6.93785000"
                    },
                    {
                        "id": 37915,
                        "name": "Vegacervera",
                        "latitude": "42.88808000",
                        "longitude": "-5.53549000"
                    },
                    {
                        "id": 37918,
                        "name": "Vegaquemada",
                        "latitude": "42.81870000",
                        "longitude": "-5.33242000"
                    },
                    {
                        "id": 152998,
                        "name": "Vegas del Condado",
                        "latitude": "42.68296340",
                        "longitude": "-5.36451390"
                    },
                    {
                        "id": 38017,
                        "name": "Villablino",
                        "latitude": "42.93932000",
                        "longitude": "-6.31943000"
                    },
                    {
                        "id": 38019,
                        "name": "Villabraz",
                        "latitude": "42.24658000",
                        "longitude": "-5.44593000"
                    },
                    {
                        "id": 38037,
                        "name": "Villadangos del Páramo",
                        "latitude": "42.51672000",
                        "longitude": "-5.76737000"
                    },
                    {
                        "id": 38038,
                        "name": "Villadecanes",
                        "latitude": "42.57973000",
                        "longitude": "-6.75971000"
                    },
                    {
                        "id": 38039,
                        "name": "Villademor de la Vega",
                        "latitude": "42.26964000",
                        "longitude": "-5.56808000"
                    },
                    {
                        "id": 38062,
                        "name": "Villafranca del Bierzo",
                        "latitude": "42.60601000",
                        "longitude": "-6.81069000"
                    },
                    {
                        "id": 38074,
                        "name": "Villagatón",
                        "latitude": "42.63413000",
                        "longitude": "-6.16184000"
                    },
                    {
                        "id": 38078,
                        "name": "Villagonzalo-Pedernales",
                        "latitude": "42.30145000",
                        "longitude": "-3.73539000"
                    },
                    {
                        "id": 38147,
                        "name": "Villamañán",
                        "latitude": "42.32198000",
                        "longitude": "-5.58195000"
                    },
                    {
                        "id": 38129,
                        "name": "Villamandos",
                        "latitude": "42.18058000",
                        "longitude": "-5.59397000"
                    },
                    {
                        "id": 38135,
                        "name": "Villamanín",
                        "latitude": "42.93864000",
                        "longitude": "-5.65669000"
                    },
                    {
                        "id": 38138,
                        "name": "Villamartín de Don Sancho",
                        "latitude": "42.56943000",
                        "longitude": "-5.06056000"
                    },
                    {
                        "id": 38151,
                        "name": "Villamejil",
                        "latitude": "42.56205000",
                        "longitude": "-6.02514000"
                    },
                    {
                        "id": 38158,
                        "name": "Villamol",
                        "latitude": "42.42766000",
                        "longitude": "-5.04832000"
                    },
                    {
                        "id": 38159,
                        "name": "Villamontán de la Valduerna",
                        "latitude": "42.30962000",
                        "longitude": "-5.99656000"
                    },
                    {
                        "id": 38161,
                        "name": "Villamoratiel de las Matas",
                        "latitude": "42.39755000",
                        "longitude": "-5.30064000"
                    },
                    {
                        "id": 38206,
                        "name": "Villanueva de las Manzanas",
                        "latitude": "42.47264000",
                        "longitude": "-5.48043000"
                    },
                    {
                        "id": 38228,
                        "name": "Villaobispo de Otero",
                        "latitude": "42.50065000",
                        "longitude": "-6.05809000"
                    },
                    {
                        "id": 153000,
                        "name": "Villaornate y Castro",
                        "latitude": "42.19190640",
                        "longitude": "-5.53023370"
                    },
                    {
                        "id": 38231,
                        "name": "Villaquejida",
                        "latitude": "42.14500000",
                        "longitude": "-5.59699000"
                    },
                    {
                        "id": 38232,
                        "name": "Villaquilambre",
                        "latitude": "42.64685000",
                        "longitude": "-5.55835000"
                    },
                    {
                        "id": 38275,
                        "name": "Villarejo de Órbigo",
                        "latitude": "42.44559000",
                        "longitude": "-5.90462000"
                    },
                    {
                        "id": 38281,
                        "name": "Villares de Órbigo",
                        "latitude": "42.46955000",
                        "longitude": "-5.91002000"
                    },
                    {
                        "id": 38310,
                        "name": "Villasabariego",
                        "latitude": "42.53288000",
                        "longitude": "-5.41322000"
                    },
                    {
                        "id": 38311,
                        "name": "Villasana de Mena",
                        "latitude": "43.10017000",
                        "longitude": "-3.28253000"
                    },
                    {
                        "id": 38324,
                        "name": "Villaselán",
                        "latitude": "42.56105000",
                        "longitude": "-5.04820000"
                    },
                    {
                        "id": 38336,
                        "name": "Villaturiel",
                        "latitude": "42.51819000",
                        "longitude": "-5.48615000"
                    },
                    {
                        "id": 38362,
                        "name": "Villazala",
                        "latitude": "42.36146000",
                        "longitude": "-5.85600000"
                    },
                    {
                        "id": 38363,
                        "name": "Villazanzo de Valderaduey",
                        "latitude": "42.53592000",
                        "longitude": "-4.96462000"
                    },
                    {
                        "id": 38500,
                        "name": "Zotes del Páramo",
                        "latitude": "42.27268000",
                        "longitude": "-5.73617000"
                    }
                ]
            },
            {
                "id": 5104,
                "name": "Lleida",
                "iso2": "L",
                "latitude": "41.61837310",
                "longitude": "0.60242530",
                "type": "province",
                "cities": [
                    {
                        "id": 151732,
                        "name": "Abella de la Conca",
                        "latitude": "42.16150740",
                        "longitude": "1.09199750"
                    },
                    {
                        "id": 38571,
                        "name": "Àger",
                        "latitude": "42.00000000",
                        "longitude": "0.76667000"
                    },
                    {
                        "id": 31948,
                        "name": "Agramunt",
                        "latitude": "41.78686000",
                        "longitude": "1.09683000"
                    },
                    {
                        "id": 31983,
                        "name": "Aitona",
                        "latitude": "41.48333000",
                        "longitude": "0.46667000"
                    },
                    {
                        "id": 151733,
                        "name": "Alamús Els",
                        "latitude": "41.61502420",
                        "longitude": "0.74021230"
                    },
                    {
                        "id": 32345,
                        "name": "Alàs i Cerc",
                        "latitude": "42.35000000",
                        "longitude": "1.51667000"
                    },
                    {
                        "id": 151734,
                        "name": "Albagés L",
                        "latitude": "41.44700740",
                        "longitude": "0.74080630"
                    },
                    {
                        "id": 151735,
                        "name": "Albatàrrec",
                        "latitude": "41.57337630",
                        "longitude": "0.60739100"
                    },
                    {
                        "id": 32043,
                        "name": "Albesa",
                        "latitude": "41.75282000",
                        "longitude": "0.65936000"
                    },
                    {
                        "id": 151736,
                        "name": "Albi L",
                        "latitude": "41.42306580",
                        "longitude": "0.93608770"
                    },
                    {
                        "id": 32086,
                        "name": "Alcanó",
                        "latitude": "41.48064000",
                        "longitude": "0.61659000"
                    },
                    {
                        "id": 32089,
                        "name": "Alcarràs",
                        "latitude": "41.56667000",
                        "longitude": "0.51667000"
                    },
                    {
                        "id": 32110,
                        "name": "Alcoletge",
                        "latitude": "41.64762000",
                        "longitude": "0.69383000"
                    },
                    {
                        "id": 32201,
                        "name": "Alfarràs",
                        "latitude": "41.81667000",
                        "longitude": "0.58333000"
                    },
                    {
                        "id": 32207,
                        "name": "Alfés",
                        "latitude": "41.52143000",
                        "longitude": "0.62050000"
                    },
                    {
                        "id": 32218,
                        "name": "Algerri",
                        "latitude": "41.81482000",
                        "longitude": "0.63633000"
                    },
                    {
                        "id": 32228,
                        "name": "Alguaire",
                        "latitude": "41.73703000",
                        "longitude": "0.58450000"
                    },
                    {
                        "id": 151737,
                        "name": "Alins",
                        "latitude": "42.54861990",
                        "longitude": "1.31770310"
                    },
                    {
                        "id": 32259,
                        "name": "Almacelles",
                        "latitude": "41.73216000",
                        "longitude": "0.43722000"
                    },
                    {
                        "id": 151738,
                        "name": "Almatret",
                        "latitude": "41.30579990",
                        "longitude": "0.42371210"
                    },
                    {
                        "id": 32280,
                        "name": "Almenar",
                        "latitude": "41.79604000",
                        "longitude": "0.56834000"
                    },
                    {
                        "id": 151739,
                        "name": "Alòs de Balaguer",
                        "latitude": "41.91265590",
                        "longitude": "0.96006620"
                    },
                    {
                        "id": 32331,
                        "name": "Alpicat",
                        "latitude": "41.66570000",
                        "longitude": "0.55564000"
                    },
                    {
                        "id": 151740,
                        "name": "Alt Àneu",
                        "latitude": "42.68300310",
                        "longitude": "1.07777230"
                    },
                    {
                        "id": 32378,
                        "name": "Anglesola",
                        "latitude": "41.65649000",
                        "longitude": "1.08286000"
                    },
                    {
                        "id": 32422,
                        "name": "Arbeca",
                        "latitude": "41.54153000",
                        "longitude": "0.92457000"
                    },
                    {
                        "id": 151743,
                        "name": "Arres",
                        "latitude": "42.75915380",
                        "longitude": "0.71052670"
                    },
                    {
                        "id": 151744,
                        "name": "Arsèguel",
                        "latitude": "42.35005370",
                        "longitude": "1.58293860"
                    },
                    {
                        "id": 151745,
                        "name": "Artesa de Lleida",
                        "latitude": "41.55305400",
                        "longitude": "0.70337450"
                    },
                    {
                        "id": 32524,
                        "name": "Artesa de Segre",
                        "latitude": "41.89467000",
                        "longitude": "1.04625000"
                    },
                    {
                        "id": 32535,
                        "name": "Aspa",
                        "latitude": "41.49472000",
                        "longitude": "0.67277000"
                    },
                    {
                        "id": 151747,
                        "name": "Avellanes i Santa Linya Les",
                        "latitude": "41.93664020",
                        "longitude": "0.81035700"
                    },
                    {
                        "id": 151748,
                        "name": "Baix Pallars",
                        "latitude": "42.33010060",
                        "longitude": "1.03946350"
                    },
                    {
                        "id": 32619,
                        "name": "Balaguer",
                        "latitude": "41.79117000",
                        "longitude": "0.81094000"
                    },
                    {
                        "id": 151749,
                        "name": "Barbens",
                        "latitude": "41.67759140",
                        "longitude": "1.01608300"
                    },
                    {
                        "id": 151750,
                        "name": "Baronia de Rialb La",
                        "latitude": "42.01260880",
                        "longitude": "1.19291140"
                    },
                    {
                        "id": 151752,
                        "name": "Bassella",
                        "latitude": "42.01691270",
                        "longitude": "1.29587540"
                    },
                    {
                        "id": 151753,
                        "name": "Bausen",
                        "latitude": "42.83443830",
                        "longitude": "0.71675880"
                    },
                    {
                        "id": 151754,
                        "name": "Belianes",
                        "latitude": "41.56053040",
                        "longitude": "1.01434260"
                    },
                    {
                        "id": 151756,
                        "name": "Bell-lloc dUrgell",
                        "latitude": "41.63034380",
                        "longitude": "0.77912830"
                    },
                    {
                        "id": 151828,
                        "name": "Bellaguarda",
                        "latitude": "41.32875690",
                        "longitude": "0.72477300"
                    },
                    {
                        "id": 151755,
                        "name": "Bellcaire dUrgell",
                        "latitude": "41.75834430",
                        "longitude": "0.90446960"
                    },
                    {
                        "id": 151757,
                        "name": "Bellmunt dUrgell",
                        "latitude": "41.77399420",
                        "longitude": "0.95197080"
                    },
                    {
                        "id": 32743,
                        "name": "Bellpuig",
                        "latitude": "41.62595000",
                        "longitude": "1.01144000"
                    },
                    {
                        "id": 32745,
                        "name": "Bellver de Cerdanya",
                        "latitude": "42.36667000",
                        "longitude": "1.78333000"
                    },
                    {
                        "id": 32746,
                        "name": "Bellvís",
                        "latitude": "41.67269000",
                        "longitude": "0.81768000"
                    },
                    {
                        "id": 151758,
                        "name": "Benavent de Segrià",
                        "latitude": "41.69729800",
                        "longitude": "0.63285390"
                    },
                    {
                        "id": 151759,
                        "name": "Biosca",
                        "latitude": "41.89146980",
                        "longitude": "1.38551610"
                    },
                    {
                        "id": 151761,
                        "name": "Bòrdes Es",
                        "latitude": "41.61683930",
                        "longitude": "0.62045610"
                    },
                    {
                        "id": 151762,
                        "name": "Borges Blanques Les",
                        "latitude": "41.52237050",
                        "longitude": "0.87356070"
                    },
                    {
                        "id": 151763,
                        "name": "Bossòst",
                        "latitude": "42.78550450",
                        "longitude": "0.69213250"
                    },
                    {
                        "id": 151760,
                        "name": "Bovera",
                        "latitude": "41.32613000",
                        "longitude": "0.63877780"
                    },
                    {
                        "id": 151764,
                        "name": "Cabanabona",
                        "latitude": "41.85086260",
                        "longitude": "1.21663830"
                    },
                    {
                        "id": 151765,
                        "name": "Cabó",
                        "latitude": "42.23888890",
                        "longitude": "1.24714270"
                    },
                    {
                        "id": 33163,
                        "name": "Camarasa",
                        "latitude": "41.87486000",
                        "longitude": "0.87814000"
                    },
                    {
                        "id": 151766,
                        "name": "Canejan",
                        "latitude": "42.81224280",
                        "longitude": "0.80083880"
                    },
                    {
                        "id": 151884,
                        "name": "Castell de Mur",
                        "latitude": "42.10465660",
                        "longitude": "0.85798180"
                    },
                    {
                        "id": 151767,
                        "name": "Castellar de la Ribera",
                        "latitude": "42.02231250",
                        "longitude": "1.41553910"
                    },
                    {
                        "id": 151768,
                        "name": "Castelldans",
                        "latitude": "41.49748580",
                        "longitude": "0.76635380"
                    },
                    {
                        "id": 33429,
                        "name": "Castellnou de Seana",
                        "latitude": "41.64802000",
                        "longitude": "0.97093000"
                    },
                    {
                        "id": 151769,
                        "name": "Castelló de Farfanya",
                        "latitude": "41.81741630",
                        "longitude": "0.72655420"
                    },
                    {
                        "id": 33434,
                        "name": "Castellserà",
                        "latitude": "41.75000000",
                        "longitude": "1.00000000"
                    },
                    {
                        "id": 151770,
                        "name": "Cava",
                        "latitude": "42.32528710",
                        "longitude": "1.60552020"
                    },
                    {
                        "id": 33595,
                        "name": "Cervera",
                        "latitude": "41.67003000",
                        "longitude": "1.27210000"
                    },
                    {
                        "id": 151771,
                        "name": "Cervià de les Garrigues",
                        "latitude": "41.42740490",
                        "longitude": "0.86096020"
                    },
                    {
                        "id": 33700,
                        "name": "Ciutadilla",
                        "latitude": "41.56113000",
                        "longitude": "1.13935000"
                    },
                    {
                        "id": 151772,
                        "name": "Clariana de Cardener",
                        "latitude": "41.93312970",
                        "longitude": "1.62614200"
                    },
                    {
                        "id": 151773,
                        "name": "Cogul El",
                        "latitude": "41.46733710",
                        "longitude": "0.68975970"
                    },
                    {
                        "id": 33730,
                        "name": "Coll de Nargó",
                        "latitude": "42.17473000",
                        "longitude": "1.31694000"
                    },
                    {
                        "id": 151821,
                        "name": "Coma i la Pedra La",
                        "latitude": "42.17593800",
                        "longitude": "1.58869660"
                    },
                    {
                        "id": 151820,
                        "name": "Conca de Dalt",
                        "latitude": "42.21215790",
                        "longitude": "1.00119020"
                    },
                    {
                        "id": 33777,
                        "name": "Corbins",
                        "latitude": "41.68333000",
                        "longitude": "0.70000000"
                    },
                    {
                        "id": 33848,
                        "name": "Cubells",
                        "latitude": "41.85062000",
                        "longitude": "0.95900000"
                    },
                    {
                        "id": 151774,
                        "name": "Espluga Calba L",
                        "latitude": "41.49503710",
                        "longitude": "1.00417900"
                    },
                    {
                        "id": 34132,
                        "name": "Espot",
                        "latitude": "42.57838000",
                        "longitude": "1.08666000"
                    },
                    {
                        "id": 151778,
                        "name": "Estamariu",
                        "latitude": "42.37315570",
                        "longitude": "1.52282930"
                    },
                    {
                        "id": 151775,
                        "name": "Estaràs",
                        "latitude": "41.69750380",
                        "longitude": "1.39034250"
                    },
                    {
                        "id": 151776,
                        "name": "Esterri dÀneu",
                        "latitude": "42.62692270",
                        "longitude": "1.12271060"
                    },
                    {
                        "id": 151777,
                        "name": "Esterri de Cardós",
                        "latitude": "42.59273580",
                        "longitude": "1.26172650"
                    },
                    {
                        "id": 34166,
                        "name": "Farrera",
                        "latitude": "42.49654000",
                        "longitude": "1.27216000"
                    },
                    {
                        "id": 151888,
                        "name": "Fígols i Alinyà",
                        "latitude": "42.19818870",
                        "longitude": "1.39516940"
                    },
                    {
                        "id": 151779,
                        "name": "Floresta La",
                        "latitude": "41.51073120",
                        "longitude": "0.92057390"
                    },
                    {
                        "id": 151780,
                        "name": "Fondarella",
                        "latitude": "41.63435500",
                        "longitude": "0.87408710"
                    },
                    {
                        "id": 151781,
                        "name": "Foradada",
                        "latitude": "41.87688610",
                        "longitude": "1.01299730"
                    },
                    {
                        "id": 151782,
                        "name": "Fuliola La",
                        "latitude": "41.71145760",
                        "longitude": "1.00597240"
                    },
                    {
                        "id": 34364,
                        "name": "Fulleda",
                        "latitude": "41.46334000",
                        "longitude": "1.02395000"
                    },
                    {
                        "id": 151783,
                        "name": "Gavet de la Conca",
                        "latitude": "42.12286100",
                        "longitude": "0.92102130"
                    },
                    {
                        "id": 151892,
                        "name": "Gimenells i el Pla de la Font",
                        "latitude": "41.66036390",
                        "longitude": "0.39367220"
                    },
                    {
                        "id": 34479,
                        "name": "Golmés",
                        "latitude": "41.63354000",
                        "longitude": "0.93125000"
                    },
                    {
                        "id": 34565,
                        "name": "Gósol",
                        "latitude": "42.23697000",
                        "longitude": "1.66010000"
                    },
                    {
                        "id": 151784,
                        "name": "Granadella La",
                        "latitude": "41.35480620",
                        "longitude": "0.66603910"
                    },
                    {
                        "id": 151785,
                        "name": "Granja dEscarp La",
                        "latitude": "41.41880990",
                        "longitude": "0.35306660"
                    },
                    {
                        "id": 151786,
                        "name": "Granyanella",
                        "latitude": "41.64800720",
                        "longitude": "1.22324820"
                    },
                    {
                        "id": 151788,
                        "name": "Granyena de les Garrigues",
                        "latitude": "41.43285700",
                        "longitude": "0.64914680"
                    },
                    {
                        "id": 151787,
                        "name": "Granyena de Segarra",
                        "latitude": "41.62376120",
                        "longitude": "1.24639110"
                    },
                    {
                        "id": 34549,
                        "name": "Guimerà",
                        "latitude": "41.56450000",
                        "longitude": "1.18528000"
                    },
                    {
                        "id": 151883,
                        "name": "Guingueta dÀneu La",
                        "latitude": "42.59454680",
                        "longitude": "1.13185400"
                    },
                    {
                        "id": 151789,
                        "name": "Guissona",
                        "latitude": "41.78451900",
                        "longitude": "1.29030740"
                    },
                    {
                        "id": 151790,
                        "name": "Guixers",
                        "latitude": "42.13745410",
                        "longitude": "1.64229750"
                    },
                    {
                        "id": 151793,
                        "name": "Isona i Conca Dellà",
                        "latitude": "42.11848610",
                        "longitude": "1.04659380"
                    },
                    {
                        "id": 151791,
                        "name": "Ivars de Noguera",
                        "latitude": "41.84981110",
                        "longitude": "0.58653750"
                    },
                    {
                        "id": 151792,
                        "name": "Ivars dUrgell",
                        "latitude": "41.68047850",
                        "longitude": "0.98804190"
                    },
                    {
                        "id": 34777,
                        "name": "Ivorra",
                        "latitude": "41.76667000",
                        "longitude": "1.40000000"
                    },
                    {
                        "id": 151890,
                        "name": "Josa i Tuixén",
                        "latitude": "42.25459490",
                        "longitude": "1.60809740"
                    },
                    {
                        "id": 34831,
                        "name": "Juncosa",
                        "latitude": "41.37033000",
                        "longitude": "0.77650000"
                    },
                    {
                        "id": 34832,
                        "name": "Juneda",
                        "latitude": "41.54847000",
                        "longitude": "0.82451000"
                    },
                    {
                        "id": 35034,
                        "name": "Les",
                        "latitude": "42.81076000",
                        "longitude": "0.71050000"
                    },
                    {
                        "id": 35056,
                        "name": "Linyola",
                        "latitude": "41.70000000",
                        "longitude": "0.91667000"
                    },
                    {
                        "id": 151794,
                        "name": "Lladorre",
                        "latitude": "42.68104170",
                        "longitude": "1.26984750"
                    },
                    {
                        "id": 151795,
                        "name": "Lladurs",
                        "latitude": "42.04438990",
                        "longitude": "1.50668740"
                    },
                    {
                        "id": 151796,
                        "name": "Llardecans",
                        "latitude": "41.37421120",
                        "longitude": "0.55001090"
                    },
                    {
                        "id": 151797,
                        "name": "Llavorsí",
                        "latitude": "42.49585200",
                        "longitude": "1.21002950"
                    },
                    {
                        "id": 35074,
                        "name": "Lleida",
                        "latitude": "41.61674000",
                        "longitude": "0.62218000"
                    },
                    {
                        "id": 35078,
                        "name": "Lles de Cerdanya",
                        "latitude": "42.39025000",
                        "longitude": "1.68692000"
                    },
                    {
                        "id": 35079,
                        "name": "Llimiana",
                        "latitude": "42.07476000",
                        "longitude": "0.91621000"
                    },
                    {
                        "id": 151798,
                        "name": "Llobera",
                        "latitude": "41.94976290",
                        "longitude": "1.47232400"
                    },
                    {
                        "id": 151802,
                        "name": "Maials",
                        "latitude": "41.36377470",
                        "longitude": "0.50333970"
                    },
                    {
                        "id": 151799,
                        "name": "Maldà",
                        "latitude": "41.55037290",
                        "longitude": "1.03860880"
                    },
                    {
                        "id": 151800,
                        "name": "Massalcoreig",
                        "latitude": "41.45695540",
                        "longitude": "0.35953720"
                    },
                    {
                        "id": 151801,
                        "name": "Massoteres",
                        "latitude": "41.79734760",
                        "longitude": "1.31017500"
                    },
                    {
                        "id": 151803,
                        "name": "Menàrguens",
                        "latitude": "41.61683930",
                        "longitude": "0.62045610"
                    },
                    {
                        "id": 35444,
                        "name": "Miralcamp",
                        "latitude": "41.60516000",
                        "longitude": "0.87987000"
                    },
                    {
                        "id": 35486,
                        "name": "Mollerussa",
                        "latitude": "41.63333000",
                        "longitude": "0.90000000"
                    },
                    {
                        "id": 151804,
                        "name": "Molsosa La",
                        "latitude": "41.78033690",
                        "longitude": "1.53054650"
                    },
                    {
                        "id": 151806,
                        "name": "Montellà i Martinet",
                        "latitude": "42.35421290",
                        "longitude": "1.70454990"
                    },
                    {
                        "id": 151807,
                        "name": "Montferrer i Castellbò",
                        "latitude": "42.36628060",
                        "longitude": "1.34692470"
                    },
                    {
                        "id": 151805,
                        "name": "Montgai",
                        "latitude": "41.79973520",
                        "longitude": "0.96078690"
                    },
                    {
                        "id": 151809,
                        "name": "Montoliu de Lleida",
                        "latitude": "41.56099070",
                        "longitude": "0.58845230"
                    },
                    {
                        "id": 151808,
                        "name": "Montoliu de Segarra",
                        "latitude": "41.59012960",
                        "longitude": "1.27074990"
                    },
                    {
                        "id": 151810,
                        "name": "Montornès de Segarra",
                        "latitude": "41.60116430",
                        "longitude": "1.23106130"
                    },
                    {
                        "id": 151811,
                        "name": "Nalec",
                        "latitude": "41.56022110",
                        "longitude": "1.11551720"
                    },
                    {
                        "id": 151741,
                        "name": "Naut Aran",
                        "latitude": "42.74282410",
                        "longitude": "0.94384680"
                    },
                    {
                        "id": 151812,
                        "name": "Navès",
                        "latitude": "42.04702750",
                        "longitude": "1.61780110"
                    },
                    {
                        "id": 151813,
                        "name": "Odèn",
                        "latitude": "42.13277130",
                        "longitude": "1.45479220"
                    },
                    {
                        "id": 35880,
                        "name": "Oliana",
                        "latitude": "42.06895000",
                        "longitude": "1.31353000"
                    },
                    {
                        "id": 151814,
                        "name": "Oliola",
                        "latitude": "41.87612830",
                        "longitude": "1.17459980"
                    },
                    {
                        "id": 35883,
                        "name": "Olius",
                        "latitude": "42.01035000",
                        "longitude": "1.56460000"
                    },
                    {
                        "id": 151815,
                        "name": "Oluges Les",
                        "latitude": "41.69729280",
                        "longitude": "1.31995360"
                    },
                    {
                        "id": 151816,
                        "name": "Omellons Els",
                        "latitude": "41.50166250",
                        "longitude": "0.95996650"
                    },
                    {
                        "id": 151817,
                        "name": "Omells de na Gaia Els",
                        "latitude": "41.50063950",
                        "longitude": "1.07597580"
                    },
                    {
                        "id": 151818,
                        "name": "Organyà",
                        "latitude": "42.21194600",
                        "longitude": "1.32780620"
                    },
                    {
                        "id": 35968,
                        "name": "Os de Balaguer",
                        "latitude": "41.87314000",
                        "longitude": "0.72017000"
                    },
                    {
                        "id": 35974,
                        "name": "Ossó de Sió",
                        "latitude": "41.75485000",
                        "longitude": "1.15900000"
                    },
                    {
                        "id": 151819,
                        "name": "Palau dAnglesola El",
                        "latitude": "41.65014680",
                        "longitude": "0.88123240"
                    },
                    {
                        "id": 151822,
                        "name": "Penelles",
                        "latitude": "41.75722390",
                        "longitude": "0.96593840"
                    },
                    {
                        "id": 151823,
                        "name": "Peramola",
                        "latitude": "42.06185880",
                        "longitude": "1.27282430"
                    },
                    {
                        "id": 151824,
                        "name": "Pinell de Solsonès",
                        "latitude": "41.97079940",
                        "longitude": "1.40014780"
                    },
                    {
                        "id": 151825,
                        "name": "Pinós",
                        "latitude": "41.82725430",
                        "longitude": "1.54189770"
                    },
                    {
                        "id": 151891,
                        "name": "Plans de Sió Els",
                        "latitude": "41.74442470",
                        "longitude": "1.20252070"
                    },
                    {
                        "id": 151826,
                        "name": "Poal El",
                        "latitude": "41.67841800",
                        "longitude": "0.85619490"
                    },
                    {
                        "id": 151827,
                        "name": "Pobla de Cérvoles La",
                        "latitude": "41.36696650",
                        "longitude": "0.91555230"
                    },
                    {
                        "id": 151829,
                        "name": "Pobla de Segur La",
                        "latitude": "42.24771930",
                        "longitude": "0.96758470"
                    },
                    {
                        "id": 151742,
                        "name": "Pont de Bar El",
                        "latitude": "42.37203570",
                        "longitude": "1.60521700"
                    },
                    {
                        "id": 151830,
                        "name": "Pont de Suert El",
                        "latitude": "42.40804640",
                        "longitude": "0.74080630"
                    },
                    {
                        "id": 36275,
                        "name": "Ponts",
                        "latitude": "41.91607000",
                        "longitude": "1.18515000"
                    },
                    {
                        "id": 151831,
                        "name": "Portella La",
                        "latitude": "41.73958610",
                        "longitude": "0.63996270"
                    },
                    {
                        "id": 151832,
                        "name": "Prats i Sansor",
                        "latitude": "42.36442280",
                        "longitude": "1.83671000"
                    },
                    {
                        "id": 151833,
                        "name": "Preixana",
                        "latitude": "41.60773800",
                        "longitude": "1.03826690"
                    },
                    {
                        "id": 151834,
                        "name": "Preixens",
                        "latitude": "41.79390950",
                        "longitude": "1.05054720"
                    },
                    {
                        "id": 151835,
                        "name": "Prullans",
                        "latitude": "42.37885600",
                        "longitude": "1.73867300"
                    },
                    {
                        "id": 151836,
                        "name": "Puiggròs",
                        "latitude": "41.56286760",
                        "longitude": "0.88181510"
                    },
                    {
                        "id": 151837,
                        "name": "Puigverd dAgramunt",
                        "latitude": "41.77695910",
                        "longitude": "1.12151160"
                    },
                    {
                        "id": 151838,
                        "name": "Puigverd de Lleida",
                        "latitude": "41.54336390",
                        "longitude": "0.73293770"
                    },
                    {
                        "id": 151839,
                        "name": "Rialp",
                        "latitude": "42.44291960",
                        "longitude": "1.13470240"
                    },
                    {
                        "id": 151885,
                        "name": "Ribera dOndara",
                        "latitude": "41.62358870",
                        "longitude": "1.31800420"
                    },
                    {
                        "id": 151840,
                        "name": "Ribera dUrgellet",
                        "latitude": "42.28658540",
                        "longitude": "1.42414260"
                    },
                    {
                        "id": 151841,
                        "name": "Riner",
                        "latitude": "41.94135350",
                        "longitude": "1.56377630"
                    },
                    {
                        "id": 151893,
                        "name": "Riu de Cerdanya",
                        "latitude": "42.34510940",
                        "longitude": "1.82591320"
                    },
                    {
                        "id": 151842,
                        "name": "Rosselló",
                        "latitude": "41.69383940",
                        "longitude": "0.59495710"
                    },
                    {
                        "id": 151843,
                        "name": "Salàs de Pallars",
                        "latitude": "42.21305040",
                        "longitude": "0.93161190"
                    },
                    {
                        "id": 151844,
                        "name": "Sanaüja",
                        "latitude": "41.87560900",
                        "longitude": "1.30953510"
                    },
                    {
                        "id": 151848,
                        "name": "Sant Esteve de la Sarga",
                        "latitude": "42.07978790",
                        "longitude": "0.76421100"
                    },
                    {
                        "id": 151845,
                        "name": "Sant Guim de Freixenet",
                        "latitude": "41.65602850",
                        "longitude": "1.42051990"
                    },
                    {
                        "id": 151849,
                        "name": "Sant Guim de la Plana",
                        "latitude": "41.76268280",
                        "longitude": "1.32432890"
                    },
                    {
                        "id": 151846,
                        "name": "Sant Llorenç de Morunys",
                        "latitude": "42.13582170",
                        "longitude": "1.58809040"
                    },
                    {
                        "id": 151882,
                        "name": "Sant Martí de Riucorb",
                        "latitude": "41.56628640",
                        "longitude": "1.06819180"
                    },
                    {
                        "id": 151847,
                        "name": "Sant Ramon",
                        "latitude": "41.72582370",
                        "longitude": "1.36440700"
                    },
                    {
                        "id": 151851,
                        "name": "Sarroca de Bellera",
                        "latitude": "42.36003010",
                        "longitude": "0.88092110"
                    },
                    {
                        "id": 151850,
                        "name": "Sarroca de Lleida",
                        "latitude": "41.45928120",
                        "longitude": "0.56065250"
                    },
                    {
                        "id": 151852,
                        "name": "Senterada",
                        "latitude": "42.32436870",
                        "longitude": "0.93659270"
                    },
                    {
                        "id": 151746,
                        "name": "Sentiu de Sió La",
                        "latitude": "41.80517120",
                        "longitude": "0.87883520"
                    },
                    {
                        "id": 37227,
                        "name": "Seròs",
                        "latitude": "41.46667000",
                        "longitude": "0.41667000"
                    },
                    {
                        "id": 151853,
                        "name": "Seu dUrgell La",
                        "latitude": "42.35757840",
                        "longitude": "1.45555250"
                    },
                    {
                        "id": 37242,
                        "name": "Sidamon",
                        "latitude": "41.63333000",
                        "longitude": "0.83333000"
                    },
                    {
                        "id": 151854,
                        "name": "Soleràs El",
                        "latitude": "41.41359070",
                        "longitude": "0.68026980"
                    },
                    {
                        "id": 37285,
                        "name": "Solsona",
                        "latitude": "41.99395000",
                        "longitude": "1.51706000"
                    },
                    {
                        "id": 151855,
                        "name": "Soriguera",
                        "latitude": "42.37040860",
                        "longitude": "1.18105300"
                    },
                    {
                        "id": 37304,
                        "name": "Sort",
                        "latitude": "42.41319000",
                        "longitude": "1.13045000"
                    },
                    {
                        "id": 37308,
                        "name": "Soses",
                        "latitude": "41.53333000",
                        "longitude": "0.48333000"
                    },
                    {
                        "id": 151856,
                        "name": "Sudanell",
                        "latitude": "41.55610310",
                        "longitude": "0.56715710"
                    },
                    {
                        "id": 151857,
                        "name": "Sunyer",
                        "latitude": "41.52351050",
                        "longitude": "0.59081920"
                    },
                    {
                        "id": 151858,
                        "name": "Talarn",
                        "latitude": "42.18615840",
                        "longitude": "0.89999730"
                    },
                    {
                        "id": 151859,
                        "name": "Talavera",
                        "latitude": "41.58188760",
                        "longitude": "1.33758360"
                    },
                    {
                        "id": 37661,
                        "name": "Tàrrega",
                        "latitude": "41.64704000",
                        "longitude": "1.13957000"
                    },
                    {
                        "id": 151860,
                        "name": "Tarrés",
                        "latitude": "41.42267300",
                        "longitude": "1.01942540"
                    },
                    {
                        "id": 151861,
                        "name": "Tarroja de Segarra",
                        "latitude": "41.73150100",
                        "longitude": "1.27616490"
                    },
                    {
                        "id": 37665,
                        "name": "Térmens",
                        "latitude": "41.71667000",
                        "longitude": "0.76667000"
                    },
                    {
                        "id": 151862,
                        "name": "Tírvia",
                        "latitude": "42.51979770",
                        "longitude": "1.23617060"
                    },
                    {
                        "id": 37432,
                        "name": "Tiurana",
                        "latitude": "41.97527000",
                        "longitude": "1.25608000"
                    },
                    {
                        "id": 151863,
                        "name": "Torà",
                        "latitude": "41.81054000",
                        "longitude": "1.40361790"
                    },
                    {
                        "id": 151864,
                        "name": "Torms Els",
                        "latitude": "41.39425410",
                        "longitude": "0.72032050"
                    },
                    {
                        "id": 37472,
                        "name": "Tornabous",
                        "latitude": "41.70117000",
                        "longitude": "1.05384000"
                    },
                    {
                        "id": 151866,
                        "name": "Torre de Cabdella La",
                        "latitude": "42.44878360",
                        "longitude": "0.96295230"
                    },
                    {
                        "id": 151869,
                        "name": "Torre-serona",
                        "latitude": "41.67177410",
                        "longitude": "0.62936750"
                    },
                    {
                        "id": 151865,
                        "name": "Torrebesses",
                        "latitude": "41.42658470",
                        "longitude": "0.59377790"
                    },
                    {
                        "id": 37531,
                        "name": "Torrefarrera",
                        "latitude": "41.67318000",
                        "longitude": "0.60671000"
                    },
                    {
                        "id": 151887,
                        "name": "Torrefeta i Florejacs",
                        "latitude": "41.76371220",
                        "longitude": "1.26022280"
                    },
                    {
                        "id": 151867,
                        "name": "Torregrossa",
                        "latitude": "41.58039170",
                        "longitude": "0.82926470"
                    },
                    {
                        "id": 151868,
                        "name": "Torrelameu",
                        "latitude": "41.70435760",
                        "longitude": "0.70399870"
                    },
                    {
                        "id": 37576,
                        "name": "Torres de Segre",
                        "latitude": "41.53399000",
                        "longitude": "0.51420000"
                    },
                    {
                        "id": 37628,
                        "name": "Tremp",
                        "latitude": "42.16703000",
                        "longitude": "0.89487000"
                    },
                    {
                        "id": 151751,
                        "name": "Vall de Boí La",
                        "latitude": "42.52821620",
                        "longitude": "0.84845240"
                    },
                    {
                        "id": 151881,
                        "name": "Vall de Cardós",
                        "latitude": "42.56244090",
                        "longitude": "1.22609730"
                    },
                    {
                        "id": 37840,
                        "name": "Vallbona de les Monges",
                        "latitude": "41.52631000",
                        "longitude": "1.08872000"
                    },
                    {
                        "id": 37858,
                        "name": "Vallfogona de Balaguer",
                        "latitude": "41.75211000",
                        "longitude": "0.81385000"
                    },
                    {
                        "id": 151886,
                        "name": "Valls dAguilar Les",
                        "latitude": "42.28880950",
                        "longitude": "1.23136180"
                    },
                    {
                        "id": 151870,
                        "name": "Valls de Valira Les",
                        "latitude": "42.40420420",
                        "longitude": "1.46280420"
                    },
                    {
                        "id": 151889,
                        "name": "Vansa i Fórnols La",
                        "latitude": "42.24617550",
                        "longitude": "1.50150090"
                    },
                    {
                        "id": 37950,
                        "name": "Verdú",
                        "latitude": "41.61057000",
                        "longitude": "1.14284000"
                    },
                    {
                        "id": 151871,
                        "name": "Vielha e Mijaran",
                        "latitude": "42.72456430",
                        "longitude": "0.77229740"
                    },
                    {
                        "id": 151878,
                        "name": "Vila-sana",
                        "latitude": "41.66332020",
                        "longitude": "0.92827890"
                    },
                    {
                        "id": 151872,
                        "name": "Vilagrassa",
                        "latitude": "41.64888000",
                        "longitude": "1.10592800"
                    },
                    {
                        "id": 151873,
                        "name": "Vilaller",
                        "latitude": "42.47697390",
                        "longitude": "0.71705560"
                    },
                    {
                        "id": 151874,
                        "name": "Vilamòs",
                        "latitude": "42.74769610",
                        "longitude": "0.72636090"
                    },
                    {
                        "id": 37995,
                        "name": "Vilanova de Bellpuig",
                        "latitude": "41.61379000",
                        "longitude": "0.96432000"
                    },
                    {
                        "id": 151880,
                        "name": "Vilanova de la Barca",
                        "latitude": "41.68988450",
                        "longitude": "0.72833540"
                    },
                    {
                        "id": 151875,
                        "name": "Vilanova de lAguda",
                        "latitude": "41.91005460",
                        "longitude": "1.25210360"
                    },
                    {
                        "id": 151876,
                        "name": "Vilanova de Meià",
                        "latitude": "41.99384010",
                        "longitude": "1.01972440"
                    },
                    {
                        "id": 151877,
                        "name": "Vilanova de Segrià",
                        "latitude": "41.71238040",
                        "longitude": "0.61679220"
                    },
                    {
                        "id": 151879,
                        "name": "Vilosell El",
                        "latitude": "41.38259790",
                        "longitude": "0.94712990"
                    },
                    {
                        "id": 38389,
                        "name": "Vinaixa",
                        "latitude": "41.43333000",
                        "longitude": "0.98333000"
                    }
                ]
            },
            {
                "id": 5090,
                "name": "Lugo",
                "iso2": "LU",
                "latitude": "43.01231370",
                "longitude": "-7.57400960",
                "type": "province",
                "cities": [
                    {
                        "id": 31901,
                        "name": "Abadín",
                        "latitude": "43.36667000",
                        "longitude": "-7.48333000"
                    },
                    {
                        "id": 151064,
                        "name": "Alfoz",
                        "latitude": "43.50188580",
                        "longitude": "-7.42731950"
                    },
                    {
                        "id": 151065,
                        "name": "Antas de Ulla",
                        "latitude": "43.00991000",
                        "longitude": "-7.55886000"
                    },
                    {
                        "id": 151066,
                        "name": "Baleira",
                        "latitude": "43.01628790",
                        "longitude": "-7.24587360"
                    },
                    {
                        "id": 32639,
                        "name": "Baralla",
                        "latitude": "42.89207000",
                        "longitude": "-7.25492000"
                    },
                    {
                        "id": 32672,
                        "name": "Barreiros",
                        "latitude": "43.53321000",
                        "longitude": "-7.23342000"
                    },
                    {
                        "id": 32723,
                        "name": "Becerreá",
                        "latitude": "42.85610000",
                        "longitude": "-7.16360000"
                    },
                    {
                        "id": 32727,
                        "name": "Begonte",
                        "latitude": "43.15121000",
                        "longitude": "-7.68643000"
                    },
                    {
                        "id": 151067,
                        "name": "Bóveda",
                        "latitude": "42.62301650",
                        "longitude": "-7.48517110"
                    },
                    {
                        "id": 151094,
                        "name": "Burela",
                        "latitude": "43.66029540",
                        "longitude": "-7.36110920"
                    },
                    {
                        "id": 151068,
                        "name": "Carballedo",
                        "latitude": "42.52096190",
                        "longitude": "-7.82914660"
                    },
                    {
                        "id": 33490,
                        "name": "Castro de Rei",
                        "latitude": "43.20866000",
                        "longitude": "-7.40026000"
                    },
                    {
                        "id": 33509,
                        "name": "Castroverde",
                        "latitude": "43.03020000",
                        "longitude": "-7.32428000"
                    },
                    {
                        "id": 151069,
                        "name": "Cervantes",
                        "latitude": "42.82603690",
                        "longitude": "-6.98534740"
                    },
                    {
                        "id": 33606,
                        "name": "Cervo",
                        "latitude": "43.67019000",
                        "longitude": "-7.41013000"
                    },
                    {
                        "id": 33617,
                        "name": "Chantada",
                        "latitude": "42.60876000",
                        "longitude": "-7.77115000"
                    },
                    {
                        "id": 151070,
                        "name": "Corgo O",
                        "latitude": "42.94278320",
                        "longitude": "-7.43021300"
                    },
                    {
                        "id": 151071,
                        "name": "Cospeito",
                        "latitude": "43.21423090",
                        "longitude": "-7.55964300"
                    },
                    {
                        "id": 151072,
                        "name": "Folgoso do Courel",
                        "latitude": "42.58934430",
                        "longitude": "-7.19484980"
                    },
                    {
                        "id": 151073,
                        "name": "Fonsagrada A",
                        "latitude": "43.12471000",
                        "longitude": "-7.06885740"
                    },
                    {
                        "id": 34234,
                        "name": "Foz",
                        "latitude": "43.56920000",
                        "longitude": "-7.25441000"
                    },
                    {
                        "id": 34267,
                        "name": "Friol",
                        "latitude": "43.03213000",
                        "longitude": "-7.79514000"
                    },
                    {
                        "id": 34552,
                        "name": "Guitiriz",
                        "latitude": "43.18169000",
                        "longitude": "-7.89656000"
                    },
                    {
                        "id": 151075,
                        "name": "Guntín",
                        "latitude": "43.04242150",
                        "longitude": "-7.58213410"
                    },
                    {
                        "id": 151076,
                        "name": "Incio O",
                        "latitude": "42.68783960",
                        "longitude": "-7.33005300"
                    },
                    {
                        "id": 35175,
                        "name": "Láncara",
                        "latitude": "42.86425000",
                        "longitude": "-7.33667000"
                    },
                    {
                        "id": 151078,
                        "name": "Lourenzá",
                        "latitude": "43.47210150",
                        "longitude": "-7.30054380"
                    },
                    {
                        "id": 35159,
                        "name": "Lugo",
                        "latitude": "43.00992000",
                        "longitude": "-7.55602000"
                    },
                    {
                        "id": 35381,
                        "name": "Meira",
                        "latitude": "43.21337000",
                        "longitude": "-7.29372000"
                    },
                    {
                        "id": 35506,
                        "name": "Mondoñedo",
                        "latitude": "43.40000000",
                        "longitude": "-7.40000000"
                    },
                    {
                        "id": 35513,
                        "name": "Monforte de Lemos",
                        "latitude": "42.52165000",
                        "longitude": "-7.51422000"
                    },
                    {
                        "id": 35565,
                        "name": "Monterroso",
                        "latitude": "42.79250000",
                        "longitude": "-7.83425000"
                    },
                    {
                        "id": 35669,
                        "name": "Muras",
                        "latitude": "43.46685000",
                        "longitude": "-7.72383000"
                    },
                    {
                        "id": 35790,
                        "name": "Navia de Suarna",
                        "latitude": "42.96667000",
                        "longitude": "-7.00000000"
                    },
                    {
                        "id": 151079,
                        "name": "Negueira de Muñiz",
                        "latitude": "43.13195600",
                        "longitude": "-6.88872020"
                    },
                    {
                        "id": 151080,
                        "name": "Nogais As",
                        "latitude": "42.77923570",
                        "longitude": "-7.11440390"
                    },
                    {
                        "id": 35849,
                        "name": "O Incio",
                        "latitude": "42.63333000",
                        "longitude": "-7.35000000"
                    },
                    {
                        "id": 35850,
                        "name": "O Páramo",
                        "latitude": "42.95000000",
                        "longitude": "-7.30000000"
                    },
                    {
                        "id": 35984,
                        "name": "Ourol",
                        "latitude": "42.87013000",
                        "longitude": "-7.61447000"
                    },
                    {
                        "id": 35986,
                        "name": "Outeiro de Rei",
                        "latitude": "43.10198000",
                        "longitude": "-7.61497000"
                    },
                    {
                        "id": 151081,
                        "name": "Palas de Rei",
                        "latitude": "42.87346660",
                        "longitude": "-7.86875880"
                    },
                    {
                        "id": 36050,
                        "name": "Pantón",
                        "latitude": "42.51667000",
                        "longitude": "-7.60000000"
                    },
                    {
                        "id": 36059,
                        "name": "Paradela",
                        "latitude": "42.76667000",
                        "longitude": "-7.56667000"
                    },
                    {
                        "id": 151082,
                        "name": "Páramo O",
                        "latitude": "42.84099010",
                        "longitude": "-7.49753830"
                    },
                    {
                        "id": 151083,
                        "name": "Pastoriza A",
                        "latitude": "43.30053020",
                        "longitude": "-7.35090380"
                    },
                    {
                        "id": 151084,
                        "name": "Pedrafita do Cebreiro",
                        "latitude": "42.72680040",
                        "longitude": "-7.02141380"
                    },
                    {
                        "id": 151086,
                        "name": "Pobra do Brollón A",
                        "latitude": "42.55730650",
                        "longitude": "-7.39326500"
                    },
                    {
                        "id": 151085,
                        "name": "Pol",
                        "latitude": "43.14954090",
                        "longitude": "-7.32916140"
                    },
                    {
                        "id": 151087,
                        "name": "Pontenova A",
                        "latitude": "43.00713610",
                        "longitude": "-7.55639860"
                    },
                    {
                        "id": 36298,
                        "name": "Portomarín",
                        "latitude": "42.80620000",
                        "longitude": "-7.61644000"
                    },
                    {
                        "id": 36529,
                        "name": "Quiroga",
                        "latitude": "42.47678000",
                        "longitude": "-7.27463000"
                    },
                    {
                        "id": 36707,
                        "name": "Rábade",
                        "latitude": "43.11700000",
                        "longitude": "-7.61714000"
                    },
                    {
                        "id": 36608,
                        "name": "Ribadeo",
                        "latitude": "43.53704000",
                        "longitude": "-7.04095000"
                    },
                    {
                        "id": 151088,
                        "name": "Ribas de Sil",
                        "latitude": "42.46658940",
                        "longitude": "-7.28787980"
                    },
                    {
                        "id": 151089,
                        "name": "Ribeira de Piquín",
                        "latitude": "43.19950680",
                        "longitude": "-7.20058060"
                    },
                    {
                        "id": 36718,
                        "name": "Ríotorto",
                        "latitude": "43.35000000",
                        "longitude": "-7.23333000"
                    },
                    {
                        "id": 36792,
                        "name": "Samos",
                        "latitude": "42.73100000",
                        "longitude": "-7.32582000"
                    },
                    {
                        "id": 37168,
                        "name": "Sarria",
                        "latitude": "42.78148000",
                        "longitude": "-7.41431000"
                    },
                    {
                        "id": 151090,
                        "name": "Saviñao O",
                        "latitude": "42.64709350",
                        "longitude": "-7.65481100"
                    },
                    {
                        "id": 37270,
                        "name": "Sober",
                        "latitude": "42.46127000",
                        "longitude": "-7.58640000"
                    },
                    {
                        "id": 37344,
                        "name": "Taboada",
                        "latitude": "42.69900000",
                        "longitude": "-7.82298000"
                    },
                    {
                        "id": 37611,
                        "name": "Trabada",
                        "latitude": "43.44475000",
                        "longitude": "-7.19527000"
                    },
                    {
                        "id": 151091,
                        "name": "Triacastela",
                        "latitude": "42.75661970",
                        "longitude": "-7.23962230"
                    },
                    {
                        "id": 151092,
                        "name": "Valadouro O",
                        "latitude": "43.55047050",
                        "longitude": "-7.44112320"
                    },
                    {
                        "id": 151093,
                        "name": "Vicedo O",
                        "latitude": "43.00713610",
                        "longitude": "-7.55639860"
                    },
                    {
                        "id": 37987,
                        "name": "Vilalba",
                        "latitude": "43.29806000",
                        "longitude": "-7.68130000"
                    },
                    {
                        "id": 38403,
                        "name": "Viveiro",
                        "latitude": "43.66228000",
                        "longitude": "-7.59344000"
                    },
                    {
                        "id": 151074,
                        "name": "Xermade",
                        "latitude": "43.35604390",
                        "longitude": "-7.81255790"
                    },
                    {
                        "id": 151077,
                        "name": "Xove",
                        "latitude": "43.68495540",
                        "longitude": "-7.51234980"
                    }
                ]
            },
            {
                "id": 1158,
                "name": "Madrid",
                "iso2": "M",
                "latitude": "40.41675150",
                "longitude": "-3.70383220",
                "type": "province",
                "cities": [
                    {
                        "id": 152808,
                        "name": "Acebeda La",
                        "latitude": "41.08637910",
                        "longitude": "-3.62384900"
                    },
                    {
                        "id": 31985,
                        "name": "Ajalvir",
                        "latitude": "40.53205000",
                        "longitude": "-3.47841000"
                    },
                    {
                        "id": 31995,
                        "name": "Alameda del Valle",
                        "latitude": "40.91870000",
                        "longitude": "-3.84243000"
                    },
                    {
                        "id": 152809,
                        "name": "Álamo El",
                        "latitude": "40.23120910",
                        "longitude": "-3.99422110"
                    },
                    {
                        "id": 32072,
                        "name": "Alcalá de Henares",
                        "latitude": "40.48205000",
                        "longitude": "-3.35996000"
                    },
                    {
                        "id": 32097,
                        "name": "Alcobendas",
                        "latitude": "40.54746000",
                        "longitude": "-3.64197000"
                    },
                    {
                        "id": 32119,
                        "name": "Alcorcón",
                        "latitude": "40.34582000",
                        "longitude": "-3.82487000"
                    },
                    {
                        "id": 32144,
                        "name": "Aldea del Fresno",
                        "latitude": "40.32360000",
                        "longitude": "-4.20319000"
                    },
                    {
                        "id": 32219,
                        "name": "Algete",
                        "latitude": "40.59711000",
                        "longitude": "-3.49743000"
                    },
                    {
                        "id": 32327,
                        "name": "Alpedrete",
                        "latitude": "40.65889000",
                        "longitude": "-4.02512000"
                    },
                    {
                        "id": 32351,
                        "name": "Ambite",
                        "latitude": "40.33190000",
                        "longitude": "-3.18034000"
                    },
                    {
                        "id": 32368,
                        "name": "Anchuelo",
                        "latitude": "40.46527000",
                        "longitude": "-3.26838000"
                    },
                    {
                        "id": 32412,
                        "name": "Aranjuez",
                        "latitude": "40.03108000",
                        "longitude": "-3.60246000"
                    },
                    {
                        "id": 32462,
                        "name": "Arganda",
                        "latitude": "40.30076000",
                        "longitude": "-3.43722000"
                    },
                    {
                        "id": 152810,
                        "name": "Arganda del Rey",
                        "latitude": "40.30643080",
                        "longitude": "-3.44717150"
                    },
                    {
                        "id": 32464,
                        "name": "Arganzuela",
                        "latitude": "40.40021000",
                        "longitude": "-3.69618000"
                    },
                    {
                        "id": 32513,
                        "name": "Arroyomolinos",
                        "latitude": "40.26951000",
                        "longitude": "-3.91946000"
                    },
                    {
                        "id": 152811,
                        "name": "Atazar El",
                        "latitude": "40.93405330",
                        "longitude": "-3.47097970"
                    },
                    {
                        "id": 32636,
                        "name": "Barajas de Madrid",
                        "latitude": "40.47366000",
                        "longitude": "-3.57777000"
                    },
                    {
                        "id": 32695,
                        "name": "Batres",
                        "latitude": "40.20981000",
                        "longitude": "-3.92331000"
                    },
                    {
                        "id": 32725,
                        "name": "Becerril de la Sierra",
                        "latitude": "40.71699000",
                        "longitude": "-3.98858000"
                    },
                    {
                        "id": 32750,
                        "name": "Belmonte de Tajo",
                        "latitude": "40.13162000",
                        "longitude": "-3.33580000"
                    },
                    {
                        "id": 152812,
                        "name": "Berrueco El",
                        "latitude": "40.88930890",
                        "longitude": "-3.56292340"
                    },
                    {
                        "id": 32875,
                        "name": "Berzosa del Lozoya",
                        "latitude": "40.97320000",
                        "longitude": "-3.52009000"
                    },
                    {
                        "id": 32917,
                        "name": "Boadilla del Monte",
                        "latitude": "40.40500000",
                        "longitude": "-3.87835000"
                    },
                    {
                        "id": 32918,
                        "name": "Boalo",
                        "latitude": "40.71603000",
                        "longitude": "-3.91656000"
                    },
                    {
                        "id": 152813,
                        "name": "Boalo El",
                        "latitude": "40.71980310",
                        "longitude": "-3.91964320"
                    },
                    {
                        "id": 32969,
                        "name": "Braojos",
                        "latitude": "41.04040000",
                        "longitude": "-3.64329000"
                    },
                    {
                        "id": 32975,
                        "name": "Brea de Tajo",
                        "latitude": "40.23333000",
                        "longitude": "-3.10000000"
                    },
                    {
                        "id": 32994,
                        "name": "Brunete",
                        "latitude": "40.40532000",
                        "longitude": "-3.99850000"
                    },
                    {
                        "id": 33013,
                        "name": "Buitrago del Lozoya",
                        "latitude": "40.99090000",
                        "longitude": "-3.63365000"
                    },
                    {
                        "id": 33038,
                        "name": "Bustarviejo",
                        "latitude": "40.85720000",
                        "longitude": "-3.70766000"
                    },
                    {
                        "id": 33068,
                        "name": "Cabanillas de la Sierra",
                        "latitude": "40.82009000",
                        "longitude": "-3.62438000"
                    },
                    {
                        "id": 152814,
                        "name": "Cabrera La",
                        "latitude": "40.86558870",
                        "longitude": "-3.61544820"
                    },
                    {
                        "id": 33115,
                        "name": "Cadalso de los Vidrios",
                        "latitude": "40.30067000",
                        "longitude": "-4.43348000"
                    },
                    {
                        "id": 33170,
                        "name": "Camarma de Esteruelas",
                        "latitude": "40.55032000",
                        "longitude": "-3.37295000"
                    },
                    {
                        "id": 33201,
                        "name": "Campo Real",
                        "latitude": "40.33333000",
                        "longitude": "-3.38333000"
                    },
                    {
                        "id": 33232,
                        "name": "Canencia",
                        "latitude": "40.90728000",
                        "longitude": "-3.73523000"
                    },
                    {
                        "id": 33274,
                        "name": "Carabaña",
                        "latitude": "40.25424000",
                        "longitude": "-3.23572000"
                    },
                    {
                        "id": 33272,
                        "name": "Carabanchel",
                        "latitude": "40.39094000",
                        "longitude": "-3.72420000"
                    },
                    {
                        "id": 33354,
                        "name": "Casarrubuelos",
                        "latitude": "40.17146000",
                        "longitude": "-3.83105000"
                    },
                    {
                        "id": 33570,
                        "name": "Cenicientos",
                        "latitude": "40.26459000",
                        "longitude": "-4.46683000"
                    },
                    {
                        "id": 33579,
                        "name": "Cercedilla",
                        "latitude": "40.74101000",
                        "longitude": "-4.05644000"
                    },
                    {
                        "id": 33596,
                        "name": "Cervera de Buitrago",
                        "latitude": "40.91988000",
                        "longitude": "-3.52702000"
                    },
                    {
                        "id": 33616,
                        "name": "Chamberí",
                        "latitude": "40.43404000",
                        "longitude": "-3.70379000"
                    },
                    {
                        "id": 33618,
                        "name": "Chapinería",
                        "latitude": "40.37891000",
                        "longitude": "-4.21009000"
                    },
                    {
                        "id": 33640,
                        "name": "Chinchón",
                        "latitude": "40.14020000",
                        "longitude": "-3.42267000"
                    },
                    {
                        "id": 33658,
                        "name": "Ciempozuelos",
                        "latitude": "40.15913000",
                        "longitude": "-3.62103000"
                    },
                    {
                        "id": 33695,
                        "name": "City Center",
                        "latitude": "40.41831000",
                        "longitude": "-3.70275000"
                    },
                    {
                        "id": 33696,
                        "name": "Ciudad Lineal",
                        "latitude": "40.44505000",
                        "longitude": "-3.65132000"
                    },
                    {
                        "id": 33709,
                        "name": "Cobeña",
                        "latitude": "40.56667000",
                        "longitude": "-3.50000000"
                    },
                    {
                        "id": 33733,
                        "name": "Collado Mediano",
                        "latitude": "40.69326000",
                        "longitude": "-4.02280000"
                    },
                    {
                        "id": 152815,
                        "name": "Collado Villalba",
                        "latitude": "40.63086750",
                        "longitude": "-4.00544580"
                    },
                    {
                        "id": 33736,
                        "name": "Collado-Villalba",
                        "latitude": "40.63506000",
                        "longitude": "-4.00486000"
                    },
                    {
                        "id": 33744,
                        "name": "Colmenar de Oreja",
                        "latitude": "40.10675000",
                        "longitude": "-3.38547000"
                    },
                    {
                        "id": 33745,
                        "name": "Colmenar del Arroyo",
                        "latitude": "40.41897000",
                        "longitude": "-4.19845000"
                    },
                    {
                        "id": 33742,
                        "name": "Colmenar Viejo",
                        "latitude": "40.65909000",
                        "longitude": "-3.76762000"
                    },
                    {
                        "id": 33746,
                        "name": "Colmenarejo",
                        "latitude": "40.56063000",
                        "longitude": "-4.01713000"
                    },
                    {
                        "id": 33796,
                        "name": "Corpa",
                        "latitude": "40.42327000",
                        "longitude": "-3.26003000"
                    },
                    {
                        "id": 33817,
                        "name": "Coslada",
                        "latitude": "40.42378000",
                        "longitude": "-3.56129000"
                    },
                    {
                        "id": 33845,
                        "name": "Cubas",
                        "latitude": "40.18900000",
                        "longitude": "-3.83526000"
                    },
                    {
                        "id": 152816,
                        "name": "Cubas de la Sagra",
                        "latitude": "40.19105680",
                        "longitude": "-3.83720050"
                    },
                    {
                        "id": 33908,
                        "name": "Daganzo de Arriba",
                        "latitude": "40.54293000",
                        "longitude": "-3.45457000"
                    },
                    {
                        "id": 34029,
                        "name": "El Álamo",
                        "latitude": "40.23066000",
                        "longitude": "-3.99447000"
                    },
                    {
                        "id": 33997,
                        "name": "El Escorial",
                        "latitude": "40.58254000",
                        "longitude": "-4.12846000"
                    },
                    {
                        "id": 34002,
                        "name": "El Molar",
                        "latitude": "40.73215000",
                        "longitude": "-3.57969000"
                    },
                    {
                        "id": 34003,
                        "name": "El Pardo",
                        "latitude": "40.51454000",
                        "longitude": "-3.77253000"
                    },
                    {
                        "id": 34024,
                        "name": "El Vellón",
                        "latitude": "40.76495000",
                        "longitude": "-3.57969000"
                    },
                    {
                        "id": 152817,
                        "name": "Escorial El",
                        "latitude": "40.58426570",
                        "longitude": "-4.12804680"
                    },
                    {
                        "id": 34147,
                        "name": "Estremera",
                        "latitude": "40.18333000",
                        "longitude": "-3.10000000"
                    },
                    {
                        "id": 34249,
                        "name": "Fresnedillas",
                        "latitude": "40.48704000",
                        "longitude": "-4.17146000"
                    },
                    {
                        "id": 152818,
                        "name": "Fresnedillas de la Oliva",
                        "latitude": "40.48640170",
                        "longitude": "-4.17222550"
                    },
                    {
                        "id": 34259,
                        "name": "Fresno de Torote",
                        "latitude": "40.59040000",
                        "longitude": "-3.41003000"
                    },
                    {
                        "id": 34277,
                        "name": "Fuencarral-El Pardo",
                        "latitude": "40.49840000",
                        "longitude": "-3.73140000"
                    },
                    {
                        "id": 34283,
                        "name": "Fuenlabrada",
                        "latitude": "40.28419000",
                        "longitude": "-3.79415000"
                    },
                    {
                        "id": 34302,
                        "name": "Fuente el Saz",
                        "latitude": "40.63215000",
                        "longitude": "-3.51146000"
                    },
                    {
                        "id": 152819,
                        "name": "Fuente el Saz de Jarama",
                        "latitude": "40.63521390",
                        "longitude": "-3.51078940"
                    },
                    {
                        "id": 34361,
                        "name": "Fuentidueña de Tajo",
                        "latitude": "40.11574000",
                        "longitude": "-3.15718000"
                    },
                    {
                        "id": 34373,
                        "name": "Galapagar",
                        "latitude": "40.57830000",
                        "longitude": "-4.00426000"
                    },
                    {
                        "id": 34415,
                        "name": "Garganta de los Montes",
                        "latitude": "40.91992000",
                        "longitude": "-3.68375000"
                    },
                    {
                        "id": 152820,
                        "name": "Gargantilla del Lozoya y Pinilla de Buitrago",
                        "latitude": "40.96482980",
                        "longitude": "-3.70797450"
                    },
                    {
                        "id": 34430,
                        "name": "Gascones",
                        "latitude": "41.01843000",
                        "longitude": "-3.64217000"
                    },
                    {
                        "id": 34459,
                        "name": "Getafe",
                        "latitude": "40.30571000",
                        "longitude": "-3.73295000"
                    },
                    {
                        "id": 34516,
                        "name": "Griñón",
                        "latitude": "40.21249000",
                        "longitude": "-3.85482000"
                    },
                    {
                        "id": 34524,
                        "name": "Guadalix de la Sierra",
                        "latitude": "40.78496000",
                        "longitude": "-3.69347000"
                    },
                    {
                        "id": 34528,
                        "name": "Guadarrama",
                        "latitude": "40.67270000",
                        "longitude": "-4.08949000"
                    },
                    {
                        "id": 152821,
                        "name": "Hiruela La",
                        "latitude": "41.07748480",
                        "longitude": "-3.45519890"
                    },
                    {
                        "id": 34652,
                        "name": "Horcajo de la Sierra",
                        "latitude": "41.06723000",
                        "longitude": "-3.58534000"
                    },
                    {
                        "id": 152822,
                        "name": "Horcajo de la Sierra-Aoslos",
                        "latitude": "41.06723340",
                        "longitude": "-3.58542350"
                    },
                    {
                        "id": 34654,
                        "name": "Horcajuelo de la Sierra",
                        "latitude": "41.06019000",
                        "longitude": "-3.54640000"
                    },
                    {
                        "id": 34667,
                        "name": "Hortaleza",
                        "latitude": "40.47444000",
                        "longitude": "-3.64110000"
                    },
                    {
                        "id": 34674,
                        "name": "Hoyo de Manzanares",
                        "latitude": "40.62265000",
                        "longitude": "-3.90733000"
                    },
                    {
                        "id": 34701,
                        "name": "Humanes de Madrid",
                        "latitude": "40.25038000",
                        "longitude": "-3.83062000"
                    },
                    {
                        "id": 34860,
                        "name": "La Cabrera",
                        "latitude": "40.86386000",
                        "longitude": "-3.61265000"
                    },
                    {
                        "id": 34985,
                        "name": "Las Matas",
                        "latitude": "40.55779000",
                        "longitude": "-3.89173000"
                    },
                    {
                        "id": 34991,
                        "name": "Las Rozas de Madrid",
                        "latitude": "40.49292000",
                        "longitude": "-3.87371000"
                    },
                    {
                        "id": 34992,
                        "name": "Las Tablas",
                        "latitude": "40.50649000",
                        "longitude": "-3.67235000"
                    },
                    {
                        "id": 35002,
                        "name": "Latina",
                        "latitude": "40.38897000",
                        "longitude": "-3.74569000"
                    },
                    {
                        "id": 35021,
                        "name": "Leganés",
                        "latitude": "40.32718000",
                        "longitude": "-3.76350000"
                    },
                    {
                        "id": 35099,
                        "name": "Loeches",
                        "latitude": "40.38343000",
                        "longitude": "-3.41460000"
                    },
                    {
                        "id": 35127,
                        "name": "Los Molinos",
                        "latitude": "40.71578000",
                        "longitude": "-4.07402000"
                    },
                    {
                        "id": 35134,
                        "name": "Los Santos de la Humosa",
                        "latitude": "40.49968000",
                        "longitude": "-3.25332000"
                    },
                    {
                        "id": 35145,
                        "name": "Lozoya",
                        "latitude": "40.94949000",
                        "longitude": "-3.79086000"
                    },
                    {
                        "id": 152840,
                        "name": "Lozoyuela-Navas-Sieteiglesias",
                        "latitude": "40.92704410",
                        "longitude": "-3.61835040"
                    },
                    {
                        "id": 152823,
                        "name": "Madarcos",
                        "latitude": "40.46209940",
                        "longitude": "-3.65152560"
                    },
                    {
                        "id": 35186,
                        "name": "Madrid",
                        "latitude": "40.41650000",
                        "longitude": "-3.70256000"
                    },
                    {
                        "id": 35214,
                        "name": "Majadahonda",
                        "latitude": "40.47353000",
                        "longitude": "-3.87182000"
                    },
                    {
                        "id": 35267,
                        "name": "Manzanares el Real",
                        "latitude": "40.72627000",
                        "longitude": "-3.86265000"
                    },
                    {
                        "id": 35366,
                        "name": "Meco",
                        "latitude": "40.55274000",
                        "longitude": "-3.32894000"
                    },
                    {
                        "id": 35384,
                        "name": "Mejorada del Campo",
                        "latitude": "40.39283000",
                        "longitude": "-3.48194000"
                    },
                    {
                        "id": 35442,
                        "name": "Miraflores de la Sierra",
                        "latitude": "40.81550000",
                        "longitude": "-3.76213000"
                    },
                    {
                        "id": 152824,
                        "name": "Molar El",
                        "latitude": "40.73516030",
                        "longitude": "-3.58253470"
                    },
                    {
                        "id": 152825,
                        "name": "Molinos Los",
                        "latitude": "40.71941970",
                        "longitude": "-4.09510380"
                    },
                    {
                        "id": 35501,
                        "name": "Moncloa-Aravaca",
                        "latitude": "40.43547000",
                        "longitude": "-3.73170000"
                    },
                    {
                        "id": 35555,
                        "name": "Montejo de la Sierra",
                        "latitude": "41.05955000",
                        "longitude": "-3.52993000"
                    },
                    {
                        "id": 35602,
                        "name": "Moraleja de Enmedio",
                        "latitude": "40.26125000",
                        "longitude": "-3.85963000"
                    },
                    {
                        "id": 35612,
                        "name": "Moralzarzal",
                        "latitude": "40.67816000",
                        "longitude": "-3.97070000"
                    },
                    {
                        "id": 35616,
                        "name": "Morata de Tajuña",
                        "latitude": "40.22680000",
                        "longitude": "-3.43269000"
                    },
                    {
                        "id": 35617,
                        "name": "Moratalaz",
                        "latitude": "40.40742000",
                        "longitude": "-3.64935000"
                    },
                    {
                        "id": 35708,
                        "name": "Móstoles",
                        "latitude": "40.32234000",
                        "longitude": "-3.86496000"
                    },
                    {
                        "id": 35731,
                        "name": "Navacerrada",
                        "latitude": "40.72905000",
                        "longitude": "-4.01696000"
                    },
                    {
                        "id": 35742,
                        "name": "Navalafuente",
                        "latitude": "40.82063000",
                        "longitude": "-3.67266000"
                    },
                    {
                        "id": 35743,
                        "name": "Navalagamella",
                        "latitude": "40.46894000",
                        "longitude": "-4.12334000"
                    },
                    {
                        "id": 35744,
                        "name": "Navalcarnero",
                        "latitude": "40.28908000",
                        "longitude": "-4.01197000"
                    },
                    {
                        "id": 35758,
                        "name": "Navalquejigo",
                        "latitude": "40.60705000",
                        "longitude": "-4.04966000"
                    },
                    {
                        "id": 152826,
                        "name": "Navarredonda y San Mamés",
                        "latitude": "40.99064930",
                        "longitude": "-3.72603170"
                    },
                    {
                        "id": 35783,
                        "name": "Navas del Rey",
                        "latitude": "40.38610000",
                        "longitude": "-4.25117000"
                    },
                    {
                        "id": 35835,
                        "name": "Nuevo Baztán",
                        "latitude": "40.36731000",
                        "longitude": "-3.24125000"
                    },
                    {
                        "id": 152827,
                        "name": "Olmeda de las Fuentes",
                        "latitude": "40.36934590",
                        "longitude": "-3.22128830"
                    },
                    {
                        "id": 152828,
                        "name": "Orusco de Tajuña",
                        "latitude": "40.28610000",
                        "longitude": "-3.21142070"
                    },
                    {
                        "id": 36053,
                        "name": "Paracuellos de Jarama",
                        "latitude": "40.50353000",
                        "longitude": "-3.52775000"
                    },
                    {
                        "id": 36070,
                        "name": "Parla",
                        "latitude": "40.23604000",
                        "longitude": "-3.76752000"
                    },
                    {
                        "id": 36082,
                        "name": "Patones",
                        "latitude": "40.85563000",
                        "longitude": "-3.48490000"
                    },
                    {
                        "id": 36097,
                        "name": "Pedrezuela",
                        "latitude": "40.74277000",
                        "longitude": "-3.59980000"
                    },
                    {
                        "id": 36122,
                        "name": "Pelayos de la Presa",
                        "latitude": "40.36051000",
                        "longitude": "-4.33462000"
                    },
                    {
                        "id": 36139,
                        "name": "Perales de Tajuña",
                        "latitude": "40.23130000",
                        "longitude": "-3.35021000"
                    },
                    {
                        "id": 36160,
                        "name": "Pezuela de las Torres",
                        "latitude": "40.41613000",
                        "longitude": "-3.17363000"
                    },
                    {
                        "id": 36192,
                        "name": "Pinar de Chamartín",
                        "latitude": "40.47903000",
                        "longitude": "-3.66836000"
                    },
                    {
                        "id": 36207,
                        "name": "Pinilla del Valle",
                        "latitude": "40.92448000",
                        "longitude": "-3.81688000"
                    },
                    {
                        "id": 36215,
                        "name": "Pinto",
                        "latitude": "40.24147000",
                        "longitude": "-3.69999000"
                    },
                    {
                        "id": 152829,
                        "name": "Piñuécar-Gandullas",
                        "latitude": "41.01261270",
                        "longitude": "-3.60120420"
                    },
                    {
                        "id": 36331,
                        "name": "Pozuelo de Alarcón",
                        "latitude": "40.43293000",
                        "longitude": "-3.81338000"
                    },
                    {
                        "id": 36338,
                        "name": "Pozuelo del Rey",
                        "latitude": "40.36463000",
                        "longitude": "-3.31699000"
                    },
                    {
                        "id": 36406,
                        "name": "Prádena del Rincón",
                        "latitude": "41.04414000",
                        "longitude": "-3.54075000"
                    },
                    {
                        "id": 36379,
                        "name": "Provincia de Madrid",
                        "latitude": "40.40225000",
                        "longitude": "-3.71029000"
                    },
                    {
                        "id": 152830,
                        "name": "Puebla de la Sierra",
                        "latitude": "41.01170460",
                        "longitude": "-3.44510180"
                    },
                    {
                        "id": 36437,
                        "name": "Puente de Vallecas",
                        "latitude": "40.39354000",
                        "longitude": "-3.66200000"
                    },
                    {
                        "id": 152841,
                        "name": "Puentes Viejas",
                        "latitude": "40.96498300",
                        "longitude": "-3.58319900"
                    },
                    {
                        "id": 36500,
                        "name": "Quijorna",
                        "latitude": "40.42763000",
                        "longitude": "-4.05683000"
                    },
                    {
                        "id": 36547,
                        "name": "Rascafría",
                        "latitude": "40.90407000",
                        "longitude": "-3.87898000"
                    },
                    {
                        "id": 36563,
                        "name": "Redueña",
                        "latitude": "40.81685000",
                        "longitude": "-3.59837000"
                    },
                    {
                        "id": 36587,
                        "name": "Retiro",
                        "latitude": "40.41317000",
                        "longitude": "-3.68307000"
                    },
                    {
                        "id": 36613,
                        "name": "Ribatejada",
                        "latitude": "40.66420000",
                        "longitude": "-3.38976000"
                    },
                    {
                        "id": 36639,
                        "name": "Rivas-Vaciamadrid",
                        "latitude": "40.32605000",
                        "longitude": "-3.51089000"
                    },
                    {
                        "id": 36651,
                        "name": "Robledillo de la Jara",
                        "latitude": "40.95054000",
                        "longitude": "-3.52181000"
                    },
                    {
                        "id": 36654,
                        "name": "Robledo de Chavela",
                        "latitude": "40.50062000",
                        "longitude": "-4.23635000"
                    },
                    {
                        "id": 152831,
                        "name": "Robregordo",
                        "latitude": "41.10675000",
                        "longitude": "-3.59345080"
                    },
                    {
                        "id": 152832,
                        "name": "Rozas de Madrid Las",
                        "latitude": "40.49531380",
                        "longitude": "-3.87847320"
                    },
                    {
                        "id": 36686,
                        "name": "Rozas de Puerto Real",
                        "latitude": "40.31667000",
                        "longitude": "-4.48333000"
                    },
                    {
                        "id": 36799,
                        "name": "San Agustín del Guadalix",
                        "latitude": "40.67882000",
                        "longitude": "-3.61639000"
                    },
                    {
                        "id": 36812,
                        "name": "San Blas-Canillejas",
                        "latitude": "40.43893000",
                        "longitude": "-3.61537000"
                    },
                    {
                        "id": 36836,
                        "name": "San Fernando de Henares",
                        "latitude": "40.42386000",
                        "longitude": "-3.53261000"
                    },
                    {
                        "id": 36858,
                        "name": "San Lorenzo de El Escorial",
                        "latitude": "40.59144000",
                        "longitude": "-4.14738000"
                    },
                    {
                        "id": 36873,
                        "name": "San Martín de la Vega",
                        "latitude": "40.20735000",
                        "longitude": "-3.57063000"
                    },
                    {
                        "id": 36870,
                        "name": "San Martín de Valdeiglesias",
                        "latitude": "40.36185000",
                        "longitude": "-4.39831000"
                    },
                    {
                        "id": 36922,
                        "name": "San Sebastián de los Reyes",
                        "latitude": "40.55555000",
                        "longitude": "-3.62733000"
                    },
                    {
                        "id": 37079,
                        "name": "Santa María de la Alameda",
                        "latitude": "40.59492000",
                        "longitude": "-4.25772000"
                    },
                    {
                        "id": 37146,
                        "name": "Santorcaz",
                        "latitude": "40.47176000",
                        "longitude": "-3.23462000"
                    },
                    {
                        "id": 152833,
                        "name": "Santos de la Humosa Los",
                        "latitude": "40.50129410",
                        "longitude": "-3.25710540"
                    },
                    {
                        "id": 152834,
                        "name": "Serna del Monte La",
                        "latitude": "41.03074640",
                        "longitude": "-3.62526320"
                    },
                    {
                        "id": 37225,
                        "name": "Serranillos del Valle",
                        "latitude": "40.20211000",
                        "longitude": "-3.88187000"
                    },
                    {
                        "id": 37240,
                        "name": "Sevilla La Nueva",
                        "latitude": "40.34775000",
                        "longitude": "-4.02727000"
                    },
                    {
                        "id": 152835,
                        "name": "Somosierra",
                        "latitude": "41.13525030",
                        "longitude": "-3.57114660"
                    },
                    {
                        "id": 152836,
                        "name": "Soto del Real",
                        "latitude": "40.75437950",
                        "longitude": "-3.78321720"
                    },
                    {
                        "id": 37354,
                        "name": "Talamanca de Jarama",
                        "latitude": "40.74325000",
                        "longitude": "-3.50889000"
                    },
                    {
                        "id": 37417,
                        "name": "Tetuán de las Victorias",
                        "latitude": "40.45975000",
                        "longitude": "-3.69750000"
                    },
                    {
                        "id": 37422,
                        "name": "Tielmes",
                        "latitude": "40.24652000",
                        "longitude": "-3.31461000"
                    },
                    {
                        "id": 37431,
                        "name": "Titulcia",
                        "latitude": "40.13537000",
                        "longitude": "-3.56763000"
                    },
                    {
                        "id": 37538,
                        "name": "Torrejón de Ardoz",
                        "latitude": "40.45535000",
                        "longitude": "-3.46973000"
                    },
                    {
                        "id": 37540,
                        "name": "Torrejón de la Calzada",
                        "latitude": "40.19886000",
                        "longitude": "-3.79700000"
                    },
                    {
                        "id": 37539,
                        "name": "Torrejón de Velasco",
                        "latitude": "40.18746000",
                        "longitude": "-3.77681000"
                    },
                    {
                        "id": 37543,
                        "name": "Torrelaguna",
                        "latitude": "40.82764000",
                        "longitude": "-3.53683000"
                    },
                    {
                        "id": 37551,
                        "name": "Torrelodones",
                        "latitude": "40.57654000",
                        "longitude": "-3.92658000"
                    },
                    {
                        "id": 37557,
                        "name": "Torremocha de Jarama",
                        "latitude": "40.84148000",
                        "longitude": "-3.49666000"
                    },
                    {
                        "id": 37577,
                        "name": "Torres de la Alameda",
                        "latitude": "40.40264000",
                        "longitude": "-3.35767000"
                    },
                    {
                        "id": 37629,
                        "name": "Tres Cantos",
                        "latitude": "40.60092000",
                        "longitude": "-3.70806000"
                    },
                    {
                        "id": 37705,
                        "name": "Usera",
                        "latitude": "40.38866000",
                        "longitude": "-3.70035000"
                    },
                    {
                        "id": 37726,
                        "name": "Valdaracete",
                        "latitude": "40.20770000",
                        "longitude": "-3.19101000"
                    },
                    {
                        "id": 37735,
                        "name": "Valdeavero",
                        "latitude": "40.62980000",
                        "longitude": "-3.33001000"
                    },
                    {
                        "id": 152837,
                        "name": "Valdelaguna",
                        "latitude": "40.16168530",
                        "longitude": "-3.36786410"
                    },
                    {
                        "id": 37765,
                        "name": "Valdemanco",
                        "latitude": "40.87039000",
                        "longitude": "-3.65873000"
                    },
                    {
                        "id": 37767,
                        "name": "Valdemaqueda",
                        "latitude": "40.51201000",
                        "longitude": "-4.29722000"
                    },
                    {
                        "id": 37772,
                        "name": "Valdemorillo",
                        "latitude": "40.50064000",
                        "longitude": "-4.06710000"
                    },
                    {
                        "id": 37774,
                        "name": "Valdemoro",
                        "latitude": "40.19081000",
                        "longitude": "-3.67887000"
                    },
                    {
                        "id": 37781,
                        "name": "Valdeolmos",
                        "latitude": "40.63708000",
                        "longitude": "-3.45064000"
                    },
                    {
                        "id": 152838,
                        "name": "Valdeolmos-Alalpardo",
                        "latitude": "40.63850420",
                        "longitude": "-3.45316440"
                    },
                    {
                        "id": 37786,
                        "name": "Valdepiélagos",
                        "latitude": "40.75842000",
                        "longitude": "-3.46163000"
                    },
                    {
                        "id": 37804,
                        "name": "Valdetorres de Jarama",
                        "latitude": "40.69366000",
                        "longitude": "-3.51156000"
                    },
                    {
                        "id": 37810,
                        "name": "Valdilecha",
                        "latitude": "40.29530000",
                        "longitude": "-3.30233000"
                    },
                    {
                        "id": 37882,
                        "name": "Valverde de Alcalá",
                        "latitude": "40.41667000",
                        "longitude": "-3.29631000"
                    },
                    {
                        "id": 37931,
                        "name": "Velilla de San Antonio",
                        "latitude": "40.36516000",
                        "longitude": "-3.48484000"
                    },
                    {
                        "id": 152839,
                        "name": "Vellón El",
                        "latitude": "40.76743890",
                        "longitude": "-3.58190200"
                    },
                    {
                        "id": 37946,
                        "name": "Venturada",
                        "latitude": "40.79717000",
                        "longitude": "-3.61974000"
                    },
                    {
                        "id": 37963,
                        "name": "Vicálvaro",
                        "latitude": "40.40000000",
                        "longitude": "-3.60000000"
                    },
                    {
                        "id": 38009,
                        "name": "Villa de Vallecas",
                        "latitude": "40.36695000",
                        "longitude": "-3.60146000"
                    },
                    {
                        "id": 38012,
                        "name": "Villa del Prado",
                        "latitude": "40.27852000",
                        "longitude": "-4.30534000"
                    },
                    {
                        "id": 38034,
                        "name": "Villaconejos",
                        "latitude": "40.10139000",
                        "longitude": "-3.48258000"
                    },
                    {
                        "id": 38105,
                        "name": "Villalbilla",
                        "latitude": "40.43044000",
                        "longitude": "-3.29904000"
                    },
                    {
                        "id": 38131,
                        "name": "Villamanrique de Tajo",
                        "latitude": "40.06617000",
                        "longitude": "-3.23668000"
                    },
                    {
                        "id": 38133,
                        "name": "Villamanta",
                        "latitude": "40.29858000",
                        "longitude": "-4.10880000"
                    },
                    {
                        "id": 38134,
                        "name": "Villamantilla",
                        "latitude": "40.33846000",
                        "longitude": "-4.12986000"
                    },
                    {
                        "id": 38196,
                        "name": "Villanueva de la Cañada",
                        "latitude": "40.44689000",
                        "longitude": "-4.00428000"
                    },
                    {
                        "id": 38187,
                        "name": "Villanueva de Perales",
                        "latitude": "40.34541000",
                        "longitude": "-4.09891000"
                    },
                    {
                        "id": 38219,
                        "name": "Villanueva del Pardillo",
                        "latitude": "40.49014000",
                        "longitude": "-3.96383000"
                    },
                    {
                        "id": 38257,
                        "name": "Villar del Olmo",
                        "latitude": "40.33468000",
                        "longitude": "-3.23399000"
                    },
                    {
                        "id": 38273,
                        "name": "Villarejo de Salvanés",
                        "latitude": "40.16663000",
                        "longitude": "-3.27277000"
                    },
                    {
                        "id": 38343,
                        "name": "Villaverde",
                        "latitude": "40.35000000",
                        "longitude": "-3.70000000"
                    },
                    {
                        "id": 38357,
                        "name": "Villaviciosa de Odón",
                        "latitude": "40.35810000",
                        "longitude": "-3.90430000"
                    },
                    {
                        "id": 38360,
                        "name": "Villavieja del Lozoya",
                        "latitude": "41.00396000",
                        "longitude": "-3.66870000"
                    },
                    {
                        "id": 38482,
                        "name": "Zarzalejo",
                        "latitude": "40.54811000",
                        "longitude": "-4.18176000"
                    }
                ]
            },
            {
                "id": 5101,
                "name": "Málaga",
                "iso2": "MA",
                "latitude": "36.71820150",
                "longitude": "-4.51930600",
                "type": "province",
                "cities": [
                    {
                        "id": 31994,
                        "name": "Alameda",
                        "latitude": "37.20870000",
                        "longitude": "-4.65860000"
                    },
                    {
                        "id": 32090,
                        "name": "Alcaucín",
                        "latitude": "36.90301000",
                        "longitude": "-4.11406000"
                    },
                    {
                        "id": 32196,
                        "name": "Alfarnate",
                        "latitude": "36.99426000",
                        "longitude": "-4.25929000"
                    },
                    {
                        "id": 32197,
                        "name": "Alfarnatejo",
                        "latitude": "36.99570000",
                        "longitude": "-4.26064000"
                    },
                    {
                        "id": 32214,
                        "name": "Algarrobo",
                        "latitude": "36.77388000",
                        "longitude": "-4.03952000"
                    },
                    {
                        "id": 32215,
                        "name": "Algatocín",
                        "latitude": "36.57356000",
                        "longitude": "-5.27554000"
                    },
                    {
                        "id": 32238,
                        "name": "Alhaurín de la Torre",
                        "latitude": "36.66401000",
                        "longitude": "-4.56139000"
                    },
                    {
                        "id": 32239,
                        "name": "Alhaurín el Grande",
                        "latitude": "36.64300000",
                        "longitude": "-4.68728000"
                    },
                    {
                        "id": 32315,
                        "name": "Almáchar",
                        "latitude": "36.80892000",
                        "longitude": "-4.21614000"
                    },
                    {
                        "id": 32270,
                        "name": "Almargen",
                        "latitude": "37.00210000",
                        "longitude": "-5.02178000"
                    },
                    {
                        "id": 32297,
                        "name": "Almogía",
                        "latitude": "36.82550000",
                        "longitude": "-4.54070000"
                    },
                    {
                        "id": 32320,
                        "name": "Alora",
                        "latitude": "36.82358000",
                        "longitude": "-4.70575000"
                    },
                    {
                        "id": 32323,
                        "name": "Alozaina",
                        "latitude": "36.72736000",
                        "longitude": "-4.85761000"
                    },
                    {
                        "id": 32324,
                        "name": "Alpandeire",
                        "latitude": "36.63402000",
                        "longitude": "-5.20216000"
                    },
                    {
                        "id": 32392,
                        "name": "Antequera",
                        "latitude": "37.01938000",
                        "longitude": "-4.56123000"
                    },
                    {
                        "id": 38575,
                        "name": "Árchez",
                        "latitude": "36.83992000",
                        "longitude": "-3.99208000"
                    },
                    {
                        "id": 32431,
                        "name": "Archidona",
                        "latitude": "37.09654000",
                        "longitude": "-4.38869000"
                    },
                    {
                        "id": 32441,
                        "name": "Ardales",
                        "latitude": "36.87804000",
                        "longitude": "-4.84694000"
                    },
                    {
                        "id": 32444,
                        "name": "Arenas",
                        "latitude": "36.81625000",
                        "longitude": "-4.04411000"
                    },
                    {
                        "id": 32506,
                        "name": "Arriate",
                        "latitude": "36.80005000",
                        "longitude": "-5.14080000"
                    },
                    {
                        "id": 32543,
                        "name": "Atajate",
                        "latitude": "36.64017000",
                        "longitude": "-5.24606000"
                    },
                    {
                        "id": 151445,
                        "name": "Benadalid",
                        "latitude": "36.60614400",
                        "longitude": "-5.26877020"
                    },
                    {
                        "id": 32763,
                        "name": "Benahavís",
                        "latitude": "36.52361000",
                        "longitude": "-5.04631000"
                    },
                    {
                        "id": 32764,
                        "name": "Benalauría",
                        "latitude": "36.59445000",
                        "longitude": "-5.26099000"
                    },
                    {
                        "id": 32765,
                        "name": "Benalmádena",
                        "latitude": "36.59610000",
                        "longitude": "-4.57267000"
                    },
                    {
                        "id": 32769,
                        "name": "Benamargosa",
                        "latitude": "36.83499000",
                        "longitude": "-4.19362000"
                    },
                    {
                        "id": 32772,
                        "name": "Benamocarra",
                        "latitude": "36.79075000",
                        "longitude": "-4.16146000"
                    },
                    {
                        "id": 32774,
                        "name": "Benaoján",
                        "latitude": "36.71929000",
                        "longitude": "-5.25220000"
                    },
                    {
                        "id": 32775,
                        "name": "Benarrabá",
                        "latitude": "36.55120000",
                        "longitude": "-5.27608000"
                    },
                    {
                        "id": 151446,
                        "name": "Borge El",
                        "latitude": "36.81507650",
                        "longitude": "-4.23525790"
                    },
                    {
                        "id": 151447,
                        "name": "Burgo El",
                        "latitude": "36.79032970",
                        "longitude": "-4.94742810"
                    },
                    {
                        "id": 33195,
                        "name": "Campillos",
                        "latitude": "37.04826000",
                        "longitude": "-4.86308000"
                    },
                    {
                        "id": 33541,
                        "name": "Cañete la Real",
                        "latitude": "36.95154000",
                        "longitude": "-5.02440000"
                    },
                    {
                        "id": 33241,
                        "name": "Canillas de Aceituno",
                        "latitude": "36.87303000",
                        "longitude": "-4.08254000"
                    },
                    {
                        "id": 33242,
                        "name": "Canillas de Albaida",
                        "latitude": "36.84665000",
                        "longitude": "-3.98678000"
                    },
                    {
                        "id": 33325,
                        "name": "Carratraca",
                        "latitude": "36.85290000",
                        "longitude": "-4.81998000"
                    },
                    {
                        "id": 33337,
                        "name": "Cartajima",
                        "latitude": "36.64548000",
                        "longitude": "-5.15410000"
                    },
                    {
                        "id": 33898,
                        "name": "Cártama",
                        "latitude": "36.71068000",
                        "longitude": "-4.63297000"
                    },
                    {
                        "id": 33343,
                        "name": "Casabermeja",
                        "latitude": "36.89260000",
                        "longitude": "-4.42938000"
                    },
                    {
                        "id": 33348,
                        "name": "Casarabonela",
                        "latitude": "36.78616000",
                        "longitude": "-4.84276000"
                    },
                    {
                        "id": 33350,
                        "name": "Casares",
                        "latitude": "36.44689000",
                        "longitude": "-5.28580000"
                    },
                    {
                        "id": 33831,
                        "name": "Coín",
                        "latitude": "36.65947000",
                        "longitude": "-4.75639000"
                    },
                    {
                        "id": 33741,
                        "name": "Colmenar",
                        "latitude": "36.90519000",
                        "longitude": "-4.33557000"
                    },
                    {
                        "id": 33751,
                        "name": "Comares",
                        "latitude": "36.84929000",
                        "longitude": "-4.24664000"
                    },
                    {
                        "id": 33903,
                        "name": "Cómpeta",
                        "latitude": "36.83352000",
                        "longitude": "-3.97430000"
                    },
                    {
                        "id": 33812,
                        "name": "Cortes de la Frontera",
                        "latitude": "36.61710000",
                        "longitude": "-5.34266000"
                    },
                    {
                        "id": 33869,
                        "name": "Cuevas Bajas",
                        "latitude": "37.23526000",
                        "longitude": "-4.48714000"
                    },
                    {
                        "id": 33874,
                        "name": "Cuevas de San Marcos",
                        "latitude": "37.26666000",
                        "longitude": "-4.41432000"
                    },
                    {
                        "id": 33877,
                        "name": "Cuevas del Becerro",
                        "latitude": "36.87537000",
                        "longitude": "-5.04488000"
                    },
                    {
                        "id": 33907,
                        "name": "Cútar",
                        "latitude": "36.83134000",
                        "longitude": "-4.22739000"
                    },
                    {
                        "id": 34143,
                        "name": "Estepona",
                        "latitude": "36.42764000",
                        "longitude": "-5.14589000"
                    },
                    {
                        "id": 34162,
                        "name": "Faraján",
                        "latitude": "36.61695000",
                        "longitude": "-5.18839000"
                    },
                    {
                        "id": 34266,
                        "name": "Frigiliana",
                        "latitude": "36.78747000",
                        "longitude": "-3.89441000"
                    },
                    {
                        "id": 34282,
                        "name": "Fuengirola",
                        "latitude": "36.53998000",
                        "longitude": "-4.62473000"
                    },
                    {
                        "id": 34297,
                        "name": "Fuente de Piedra",
                        "latitude": "37.13526000",
                        "longitude": "-4.73000000"
                    },
                    {
                        "id": 34438,
                        "name": "Gaucín",
                        "latitude": "36.51784000",
                        "longitude": "-5.31581000"
                    },
                    {
                        "id": 34451,
                        "name": "Genalguacil",
                        "latitude": "36.54546000",
                        "longitude": "-5.23572000"
                    },
                    {
                        "id": 34538,
                        "name": "Guaro",
                        "latitude": "36.65630000",
                        "longitude": "-4.83433000"
                    },
                    {
                        "id": 34702,
                        "name": "Humilladero",
                        "latitude": "37.11390000",
                        "longitude": "-4.70298000"
                    },
                    {
                        "id": 34740,
                        "name": "Igualeja",
                        "latitude": "36.63208000",
                        "longitude": "-5.12188000"
                    },
                    {
                        "id": 34768,
                        "name": "Istán",
                        "latitude": "36.58273000",
                        "longitude": "-4.94956000"
                    },
                    {
                        "id": 34780,
                        "name": "Iznate",
                        "latitude": "36.78333000",
                        "longitude": "-4.18333000"
                    },
                    {
                        "id": 34818,
                        "name": "Jimera de Líbar",
                        "latitude": "36.65119000",
                        "longitude": "-5.27412000"
                    },
                    {
                        "id": 34826,
                        "name": "Jubrique",
                        "latitude": "36.56475000",
                        "longitude": "-5.21560000"
                    },
                    {
                        "id": 34839,
                        "name": "Júzcar",
                        "latitude": "36.62442000",
                        "longitude": "-5.16971000"
                    },
                    {
                        "id": 151448,
                        "name": "Macharaviaya",
                        "latitude": "36.76663420",
                        "longitude": "-4.21795840"
                    },
                    {
                        "id": 35703,
                        "name": "Málaga",
                        "latitude": "36.72016000",
                        "longitude": "-4.42034000"
                    },
                    {
                        "id": 35250,
                        "name": "Manilva",
                        "latitude": "36.37645000",
                        "longitude": "-5.25026000"
                    },
                    {
                        "id": 35281,
                        "name": "Marbella",
                        "latitude": "36.51543000",
                        "longitude": "-4.88583000"
                    },
                    {
                        "id": 35427,
                        "name": "Mijas",
                        "latitude": "36.59575000",
                        "longitude": "-4.63728000"
                    },
                    {
                        "id": 35462,
                        "name": "Moclinejo",
                        "latitude": "36.77134000",
                        "longitude": "-4.25514000"
                    },
                    {
                        "id": 35489,
                        "name": "Mollina",
                        "latitude": "37.12534000",
                        "longitude": "-4.65686000"
                    },
                    {
                        "id": 35503,
                        "name": "Monda",
                        "latitude": "36.63027000",
                        "longitude": "-4.83192000"
                    },
                    {
                        "id": 35550,
                        "name": "Montejaque",
                        "latitude": "36.73684000",
                        "longitude": "-5.24990000"
                    },
                    {
                        "id": 35802,
                        "name": "Nerja",
                        "latitude": "36.75278000",
                        "longitude": "-3.87440000"
                    },
                    {
                        "id": 35870,
                        "name": "Ojén",
                        "latitude": "36.56486000",
                        "longitude": "-4.85561000"
                    },
                    {
                        "id": 36061,
                        "name": "Parauta",
                        "latitude": "36.65629000",
                        "longitude": "-5.12916000"
                    },
                    {
                        "id": 36149,
                        "name": "Periana",
                        "latitude": "36.92931000",
                        "longitude": "-4.19163000"
                    },
                    {
                        "id": 36224,
                        "name": "Pizarra",
                        "latitude": "36.76543000",
                        "longitude": "-4.70833000"
                    },
                    {
                        "id": 36466,
                        "name": "Pujerra",
                        "latitude": "36.61274000",
                        "longitude": "-5.14979000"
                    },
                    {
                        "id": 36627,
                        "name": "Rincón de la Victoria",
                        "latitude": "36.71715000",
                        "longitude": "-4.27583000"
                    },
                    {
                        "id": 36716,
                        "name": "Ríogordo",
                        "latitude": "36.91727000",
                        "longitude": "-4.29318000"
                    },
                    {
                        "id": 36673,
                        "name": "Ronda",
                        "latitude": "36.74231000",
                        "longitude": "-5.16709000"
                    },
                    {
                        "id": 36747,
                        "name": "Salares",
                        "latitude": "36.85463000",
                        "longitude": "-4.02434000"
                    },
                    {
                        "id": 37182,
                        "name": "Sayalonga",
                        "latitude": "36.79819000",
                        "longitude": "-4.01325000"
                    },
                    {
                        "id": 37188,
                        "name": "Sedella",
                        "latitude": "36.86232000",
                        "longitude": "-4.03314000"
                    },
                    {
                        "id": 37246,
                        "name": "Sierra de Yeguas",
                        "latitude": "37.12420000",
                        "longitude": "-4.86773000"
                    },
                    {
                        "id": 37390,
                        "name": "Teba",
                        "latitude": "36.98358000",
                        "longitude": "-4.91913000"
                    },
                    {
                        "id": 37448,
                        "name": "Tolox",
                        "latitude": "36.68721000",
                        "longitude": "-4.90511000"
                    },
                    {
                        "id": 37561,
                        "name": "Torremolinos",
                        "latitude": "36.62035000",
                        "longitude": "-4.49976000"
                    },
                    {
                        "id": 37592,
                        "name": "Torrox",
                        "latitude": "36.75793000",
                        "longitude": "-3.95233000"
                    },
                    {
                        "id": 37605,
                        "name": "Totalán",
                        "latitude": "36.76526000",
                        "longitude": "-4.29707000"
                    },
                    {
                        "id": 151449,
                        "name": "Valle de Abdalajís",
                        "latitude": "36.93136660",
                        "longitude": "-4.68425630"
                    },
                    {
                        "id": 38416,
                        "name": "Vélez-Málaga",
                        "latitude": "36.78107000",
                        "longitude": "-4.10266000"
                    },
                    {
                        "id": 38171,
                        "name": "Villanueva de Algaidas",
                        "latitude": "37.18350000",
                        "longitude": "-4.45032000"
                    },
                    {
                        "id": 151450,
                        "name": "Villanueva de la Concepción",
                        "latitude": "36.93037810",
                        "longitude": "-4.53085850"
                    },
                    {
                        "id": 38192,
                        "name": "Villanueva de Tapia",
                        "latitude": "37.18276000",
                        "longitude": "-4.33383000"
                    },
                    {
                        "id": 38222,
                        "name": "Villanueva del Rosario",
                        "latitude": "36.99679000",
                        "longitude": "-4.36535000"
                    },
                    {
                        "id": 38224,
                        "name": "Villanueva del Trabuco",
                        "latitude": "37.02832000",
                        "longitude": "-4.33891000"
                    },
                    {
                        "id": 38410,
                        "name": "Viñuela",
                        "latitude": "36.86307000",
                        "longitude": "-4.14124000"
                    },
                    {
                        "id": 38441,
                        "name": "Yunquera",
                        "latitude": "36.73252000",
                        "longitude": "-4.92122000"
                    }
                ]
            },
            {
                "id": 5224,
                "name": "Melilla",
                "iso2": "ML",
                "latitude": "35.29370000",
                "longitude": "-2.93830000",
                "type": "autonomous city",
                "cities": []
            },
            {
                "id": 1176,
                "name": "Murcia",
                "iso2": "MU",
                "latitude": "38.13981410",
                "longitude": "-1.36621600",
                "type": "province",
                "cities": [
                    {
                        "id": 31903,
                        "name": "Abanilla",
                        "latitude": "38.20537000",
                        "longitude": "-1.04153000"
                    },
                    {
                        "id": 31905,
                        "name": "Abarán",
                        "latitude": "38.20551000",
                        "longitude": "-1.39907000"
                    },
                    {
                        "id": 38574,
                        "name": "Águilas",
                        "latitude": "37.40630000",
                        "longitude": "-1.58289000"
                    },
                    {
                        "id": 32057,
                        "name": "Albudeite",
                        "latitude": "38.02895000",
                        "longitude": "-1.38664000"
                    },
                    {
                        "id": 32084,
                        "name": "Alcantarilla",
                        "latitude": "37.96939000",
                        "longitude": "-1.21714000"
                    },
                    {
                        "id": 152976,
                        "name": "Alcázares Los",
                        "latitude": "37.74818430",
                        "longitude": "-0.84806550"
                    },
                    {
                        "id": 32182,
                        "name": "Aledo",
                        "latitude": "37.79341000",
                        "longitude": "-1.57356000"
                    },
                    {
                        "id": 32229,
                        "name": "Alguazas",
                        "latitude": "38.05356000",
                        "longitude": "-1.25051000"
                    },
                    {
                        "id": 32236,
                        "name": "Alhama de Murcia",
                        "latitude": "37.85103000",
                        "longitude": "-1.42507000"
                    },
                    {
                        "id": 32430,
                        "name": "Archena",
                        "latitude": "38.11631000",
                        "longitude": "-1.30043000"
                    },
                    {
                        "id": 32546,
                        "name": "Atamaría",
                        "latitude": "37.59989000",
                        "longitude": "-0.80682000"
                    },
                    {
                        "id": 32677,
                        "name": "Barrio de la Concepción",
                        "latitude": "37.60000000",
                        "longitude": "-1.00000000"
                    },
                    {
                        "id": 32800,
                        "name": "Beniel",
                        "latitude": "38.04636000",
                        "longitude": "-1.00233000"
                    },
                    {
                        "id": 32905,
                        "name": "Blanca",
                        "latitude": "38.17910000",
                        "longitude": "-1.37473000"
                    },
                    {
                        "id": 33018,
                        "name": "Bullas",
                        "latitude": "38.04667000",
                        "longitude": "-1.67227000"
                    },
                    {
                        "id": 33131,
                        "name": "Calasparra",
                        "latitude": "38.22997000",
                        "longitude": "-1.69986000"
                    },
                    {
                        "id": 33211,
                        "name": "Campos del Río",
                        "latitude": "38.03966000",
                        "longitude": "-1.35306000"
                    },
                    {
                        "id": 33277,
                        "name": "Caravaca",
                        "latitude": "38.10558000",
                        "longitude": "-1.86343000"
                    },
                    {
                        "id": 152971,
                        "name": "Caravaca de la Cruz",
                        "latitude": "38.10418920",
                        "longitude": "-1.86091520"
                    },
                    {
                        "id": 33336,
                        "name": "Cartagena",
                        "latitude": "37.60512000",
                        "longitude": "-0.98623000"
                    },
                    {
                        "id": 33560,
                        "name": "Cehegín",
                        "latitude": "38.09242000",
                        "longitude": "-1.79850000"
                    },
                    {
                        "id": 33610,
                        "name": "Ceuti",
                        "latitude": "38.07859000",
                        "longitude": "-1.27467000"
                    },
                    {
                        "id": 33659,
                        "name": "Cieza",
                        "latitude": "38.23998000",
                        "longitude": "-1.41987000"
                    },
                    {
                        "id": 33706,
                        "name": "Cobatillas",
                        "latitude": "38.05545000",
                        "longitude": "-1.07683000"
                    },
                    {
                        "id": 34009,
                        "name": "El Plan",
                        "latitude": "37.65000000",
                        "longitude": "-1.01667000"
                    },
                    {
                        "id": 34104,
                        "name": "Esparragal",
                        "latitude": "38.03333000",
                        "longitude": "-1.08333000"
                    },
                    {
                        "id": 34231,
                        "name": "Fortuna",
                        "latitude": "38.18140000",
                        "longitude": "-1.12590000"
                    },
                    {
                        "id": 152972,
                        "name": "Fuente Álamo de Murcia",
                        "latitude": "37.72174940",
                        "longitude": "-1.17194220"
                    },
                    {
                        "id": 34308,
                        "name": "Fuente-Álamo de Murcia",
                        "latitude": "37.72389000",
                        "longitude": "-1.16972000"
                    },
                    {
                        "id": 34828,
                        "name": "Jumilla",
                        "latitude": "38.47917000",
                        "longitude": "-1.32500000"
                    },
                    {
                        "id": 34893,
                        "name": "La Manga del Mar Menor",
                        "latitude": "37.64129000",
                        "longitude": "-0.71651000"
                    },
                    {
                        "id": 34931,
                        "name": "La Torrecilla",
                        "latitude": "37.62363000",
                        "longitude": "-1.72785000"
                    },
                    {
                        "id": 34932,
                        "name": "La Unión",
                        "latitude": "37.61915000",
                        "longitude": "-0.87799000"
                    },
                    {
                        "id": 34993,
                        "name": "Las Torres de Cotillas",
                        "latitude": "38.02822000",
                        "longitude": "-1.24188000"
                    },
                    {
                        "id": 35046,
                        "name": "Librilla",
                        "latitude": "37.88642000",
                        "longitude": "-1.35557000"
                    },
                    {
                        "id": 35092,
                        "name": "Lo Pagán",
                        "latitude": "37.81761000",
                        "longitude": "-0.78832000"
                    },
                    {
                        "id": 35113,
                        "name": "Lorca",
                        "latitude": "37.67119000",
                        "longitude": "-1.70170000"
                    },
                    {
                        "id": 35115,
                        "name": "Lorquí",
                        "latitude": "38.08261000",
                        "longitude": "-1.25103000"
                    },
                    {
                        "id": 35116,
                        "name": "Los Alcázares",
                        "latitude": "37.74425000",
                        "longitude": "-0.85041000"
                    },
                    {
                        "id": 35121,
                        "name": "Los Gabatos",
                        "latitude": "37.63333000",
                        "longitude": "-1.00000000"
                    },
                    {
                        "id": 35125,
                        "name": "Los Martínez",
                        "latitude": "37.81841000",
                        "longitude": "-1.07880000"
                    },
                    {
                        "id": 35356,
                        "name": "Mazarrón",
                        "latitude": "37.59920000",
                        "longitude": "-1.31493000"
                    },
                    {
                        "id": 35478,
                        "name": "Molina de Segura",
                        "latitude": "38.05456000",
                        "longitude": "-1.20763000"
                    },
                    {
                        "id": 35618,
                        "name": "Moratalla",
                        "latitude": "38.18928000",
                        "longitude": "-1.89183000"
                    },
                    {
                        "id": 35661,
                        "name": "Mula",
                        "latitude": "38.04095000",
                        "longitude": "-1.49014000"
                    },
                    {
                        "id": 35671,
                        "name": "Murcia",
                        "latitude": "37.98662000",
                        "longitude": "-1.14146000"
                    },
                    {
                        "id": 35871,
                        "name": "Ojós",
                        "latitude": "38.14700000",
                        "longitude": "-1.34261000"
                    },
                    {
                        "id": 36245,
                        "name": "Pliego",
                        "latitude": "37.98946000",
                        "longitude": "-1.50444000"
                    },
                    {
                        "id": 36445,
                        "name": "Puerto Lumbreras",
                        "latitude": "37.56329000",
                        "longitude": "-1.80974000"
                    },
                    {
                        "id": 36621,
                        "name": "Ricote",
                        "latitude": "38.15338000",
                        "longitude": "-1.36557000"
                    },
                    {
                        "id": 36840,
                        "name": "San Javier",
                        "latitude": "37.80626000",
                        "longitude": "-0.83736000"
                    },
                    {
                        "id": 36910,
                        "name": "San Pedro del Pinatar",
                        "latitude": "37.83568000",
                        "longitude": "-0.79102000"
                    },
                    {
                        "id": 36945,
                        "name": "Sangonera la Verde",
                        "latitude": "37.92862000",
                        "longitude": "-1.20794000"
                    },
                    {
                        "id": 37026,
                        "name": "Santa Cruz",
                        "latitude": "38.02180000",
                        "longitude": "-1.05749000"
                    },
                    {
                        "id": 37116,
                        "name": "Santiago de la Ribera",
                        "latitude": "37.79681000",
                        "longitude": "-0.80544000"
                    },
                    {
                        "id": 37145,
                        "name": "Santomera",
                        "latitude": "38.06147000",
                        "longitude": "-1.04877000"
                    },
                    {
                        "id": 37507,
                        "name": "Torre-Pacheco",
                        "latitude": "37.74293000",
                        "longitude": "-0.95396000"
                    },
                    {
                        "id": 152973,
                        "name": "Torres de Cotillas Las",
                        "latitude": "38.02749860",
                        "longitude": "-1.24338480"
                    },
                    {
                        "id": 37606,
                        "name": "Totana",
                        "latitude": "37.76880000",
                        "longitude": "-1.50229000"
                    },
                    {
                        "id": 37678,
                        "name": "Ulea",
                        "latitude": "38.14045000",
                        "longitude": "-1.33007000"
                    },
                    {
                        "id": 152974,
                        "name": "Unión La",
                        "latitude": "37.62191410",
                        "longitude": "-0.88598980"
                    },
                    {
                        "id": 152975,
                        "name": "Villanueva del Río Segura",
                        "latitude": "38.13566600",
                        "longitude": "-1.32463010"
                    },
                    {
                        "id": 38431,
                        "name": "Yecla",
                        "latitude": "38.61365000",
                        "longitude": "-1.11468000"
                    }
                ]
            },
            {
                "id": 1204,
                "name": "Navarra",
                "iso2": "NA",
                "latitude": "42.69539090",
                "longitude": "-1.67606910",
                "type": "province",
                "cities": [
                    {
                        "id": 31920,
                        "name": "Abáigar",
                        "latitude": "42.64823000",
                        "longitude": "-2.14182000"
                    },
                    {
                        "id": 153001,
                        "name": "Abárzuza\/Abartzuza",
                        "latitude": "42.72684650",
                        "longitude": "-2.02165970"
                    },
                    {
                        "id": 153002,
                        "name": "Abaurregaina\/Abaurrea Alta",
                        "latitude": "42.90307740",
                        "longitude": "-1.21032990"
                    },
                    {
                        "id": 153003,
                        "name": "Abaurrepea\/Abaurrea Baja",
                        "latitude": "42.90981650",
                        "longitude": "-1.21720560"
                    },
                    {
                        "id": 153004,
                        "name": "Aberin",
                        "latitude": "42.61946650",
                        "longitude": "-2.00742560"
                    },
                    {
                        "id": 153005,
                        "name": "Ablitas",
                        "latitude": "41.97613950",
                        "longitude": "-1.64085610"
                    },
                    {
                        "id": 31933,
                        "name": "Adiós",
                        "latitude": "42.68635000",
                        "longitude": "-1.73532000"
                    },
                    {
                        "id": 31962,
                        "name": "Aguilar de Codés",
                        "latitude": "42.61249000",
                        "longitude": "-2.38987000"
                    },
                    {
                        "id": 153006,
                        "name": "Aibar\/Oibar",
                        "latitude": "42.59314380",
                        "longitude": "-1.36018650"
                    },
                    {
                        "id": 153008,
                        "name": "Allín\/Allin",
                        "latitude": "42.70876730",
                        "longitude": "-2.07531890"
                    },
                    {
                        "id": 32256,
                        "name": "Allo",
                        "latitude": "42.56738000",
                        "longitude": "-2.02052000"
                    },
                    {
                        "id": 32341,
                        "name": "Altsasu",
                        "latitude": "42.89999000",
                        "longitude": "-2.16516000"
                    },
                    {
                        "id": 153007,
                        "name": "Altsasu\/Alsasua",
                        "latitude": "42.89563480",
                        "longitude": "-2.17081390"
                    },
                    {
                        "id": 153009,
                        "name": "Améscoa Baja",
                        "latitude": "42.77328490",
                        "longitude": "-2.12556090"
                    },
                    {
                        "id": 32370,
                        "name": "Ancín",
                        "latitude": "42.66047000",
                        "longitude": "-2.18885000"
                    },
                    {
                        "id": 153010,
                        "name": "Ancín\/Antzin",
                        "latitude": "42.65974070",
                        "longitude": "-2.18919650"
                    },
                    {
                        "id": 32374,
                        "name": "Andosilla",
                        "latitude": "42.38144000",
                        "longitude": "-1.67305000"
                    },
                    {
                        "id": 32597,
                        "name": "Añorbe",
                        "latitude": "42.65732000",
                        "longitude": "-1.71490000"
                    },
                    {
                        "id": 153011,
                        "name": "Ansoáin\/Antsoain",
                        "latitude": "42.83375930",
                        "longitude": "-1.64328370"
                    },
                    {
                        "id": 153012,
                        "name": "Anue",
                        "latitude": "42.96292440",
                        "longitude": "-1.61879430"
                    },
                    {
                        "id": 32397,
                        "name": "Aoiz",
                        "latitude": "42.78633000",
                        "longitude": "-1.37252000"
                    },
                    {
                        "id": 153013,
                        "name": "Aoiz\/Agoitz",
                        "latitude": "42.78608200",
                        "longitude": "-1.37096570"
                    },
                    {
                        "id": 153014,
                        "name": "Araitz",
                        "latitude": "43.03669550",
                        "longitude": "-2.01274050"
                    },
                    {
                        "id": 153018,
                        "name": "Arakil",
                        "latitude": "42.91795070",
                        "longitude": "-1.84148280"
                    },
                    {
                        "id": 32405,
                        "name": "Aranarache",
                        "latitude": "42.77979000",
                        "longitude": "-2.22924000"
                    },
                    {
                        "id": 153015,
                        "name": "Aranarache\/Aranaratxe",
                        "latitude": "42.77913740",
                        "longitude": "-2.22841790"
                    },
                    {
                        "id": 153017,
                        "name": "Aranguren",
                        "latitude": "42.78937650",
                        "longitude": "-1.53554070"
                    },
                    {
                        "id": 32413,
                        "name": "Arano",
                        "latitude": "43.19956000",
                        "longitude": "-1.89569000"
                    },
                    {
                        "id": 153016,
                        "name": "Arantza",
                        "latitude": "43.19624910",
                        "longitude": "-1.72529370"
                    },
                    {
                        "id": 32416,
                        "name": "Aras",
                        "latitude": "42.56172000",
                        "longitude": "-2.35600000"
                    },
                    {
                        "id": 32424,
                        "name": "Arbizu",
                        "latitude": "42.91545000",
                        "longitude": "-2.03917000"
                    },
                    {
                        "id": 153019,
                        "name": "Arce\/Artzi",
                        "latitude": "42.87104020",
                        "longitude": "-1.34814400"
                    },
                    {
                        "id": 153020,
                        "name": "Arcos Los",
                        "latitude": "42.56848680",
                        "longitude": "-2.19165420"
                    },
                    {
                        "id": 32443,
                        "name": "Arellano",
                        "latitude": "42.60598000",
                        "longitude": "-2.04653000"
                    },
                    {
                        "id": 32457,
                        "name": "Areso",
                        "latitude": "43.08209000",
                        "longitude": "-1.95198000"
                    },
                    {
                        "id": 32473,
                        "name": "Arguedas",
                        "latitude": "42.17759000",
                        "longitude": "-1.59719000"
                    },
                    {
                        "id": 32477,
                        "name": "Aria",
                        "latitude": "42.95283000",
                        "longitude": "-1.26584000"
                    },
                    {
                        "id": 153021,
                        "name": "Aribe",
                        "latitude": "42.94312300",
                        "longitude": "-1.26247840"
                    },
                    {
                        "id": 32486,
                        "name": "Armañanzas",
                        "latitude": "42.55963000",
                        "longitude": "-2.28476000"
                    },
                    {
                        "id": 32517,
                        "name": "Arróniz",
                        "latitude": "42.58823000",
                        "longitude": "-2.09237000"
                    },
                    {
                        "id": 32516,
                        "name": "Arruazu",
                        "latitude": "42.92186000",
                        "longitude": "-2.00157000"
                    },
                    {
                        "id": 32519,
                        "name": "Artajona",
                        "latitude": "42.58867000",
                        "longitude": "-1.76504000"
                    },
                    {
                        "id": 32521,
                        "name": "Artazu",
                        "latitude": "42.69228000",
                        "longitude": "-1.83954000"
                    },
                    {
                        "id": 32551,
                        "name": "Atarrabia",
                        "latitude": "42.83230000",
                        "longitude": "-1.60735000"
                    },
                    {
                        "id": 153022,
                        "name": "Atez",
                        "latitude": "42.94461660",
                        "longitude": "-1.71800170"
                    },
                    {
                        "id": 153029,
                        "name": "Auritz\/Burguete",
                        "latitude": "42.99046680",
                        "longitude": "-1.33547460"
                    },
                    {
                        "id": 32572,
                        "name": "Ayegui",
                        "latitude": "42.65656000",
                        "longitude": "-2.03934000"
                    },
                    {
                        "id": 153023,
                        "name": "Ayegui\/Aiegi",
                        "latitude": "42.65708460",
                        "longitude": "-2.03860750"
                    },
                    {
                        "id": 32580,
                        "name": "Azagra",
                        "latitude": "42.30000000",
                        "longitude": "-1.90000000"
                    },
                    {
                        "id": 32590,
                        "name": "Azuelo",
                        "latitude": "42.60844000",
                        "longitude": "-2.34987000"
                    },
                    {
                        "id": 32617,
                        "name": "Bakaiku",
                        "latitude": "42.89244000",
                        "longitude": "-2.10251000"
                    },
                    {
                        "id": 32640,
                        "name": "Barañáin",
                        "latitude": "42.80567000",
                        "longitude": "-1.67731000"
                    },
                    {
                        "id": 32685,
                        "name": "Barásoain",
                        "latitude": "42.60339000",
                        "longitude": "-1.64658000"
                    },
                    {
                        "id": 153024,
                        "name": "Barbarin",
                        "latitude": "42.60216400",
                        "longitude": "-2.10141000"
                    },
                    {
                        "id": 32663,
                        "name": "Bargota",
                        "latitude": "42.55982000",
                        "longitude": "-2.31067000"
                    },
                    {
                        "id": 32664,
                        "name": "Barillas",
                        "latitude": "41.96667000",
                        "longitude": "-1.63333000"
                    },
                    {
                        "id": 153025,
                        "name": "Basaburua",
                        "latitude": "43.02903120",
                        "longitude": "-1.79135630"
                    },
                    {
                        "id": 153026,
                        "name": "Baztan",
                        "latitude": "43.19358470",
                        "longitude": "-1.48510760"
                    },
                    {
                        "id": 153070,
                        "name": "Beintza-Labaien",
                        "latitude": "43.08696800",
                        "longitude": "-1.74189310"
                    },
                    {
                        "id": 32731,
                        "name": "Beire",
                        "latitude": "42.45415000",
                        "longitude": "-1.62101000"
                    },
                    {
                        "id": 32735,
                        "name": "Belascoáin",
                        "latitude": "42.75619000",
                        "longitude": "-1.83227000"
                    },
                    {
                        "id": 32830,
                        "name": "Bera",
                        "latitude": "43.28177000",
                        "longitude": "-1.68632000"
                    },
                    {
                        "id": 32836,
                        "name": "Berbinzana",
                        "latitude": "42.52779000",
                        "longitude": "-1.83419000"
                    },
                    {
                        "id": 32852,
                        "name": "Beriáin",
                        "latitude": "42.73347000",
                        "longitude": "-1.64448000"
                    },
                    {
                        "id": 32864,
                        "name": "Berriobeiti",
                        "latitude": "42.85000000",
                        "longitude": "-1.70000000"
                    },
                    {
                        "id": 153131,
                        "name": "Berrioplano\/Berriobeiti",
                        "latitude": "42.85438360",
                        "longitude": "-1.69035690"
                    },
                    {
                        "id": 32865,
                        "name": "Berriozar",
                        "latitude": "42.83067000",
                        "longitude": "-1.66648000"
                    },
                    {
                        "id": 153027,
                        "name": "Bertizarana",
                        "latitude": "43.13638020",
                        "longitude": "-1.62506330"
                    },
                    {
                        "id": 32880,
                        "name": "Betelu",
                        "latitude": "43.02555000",
                        "longitude": "-1.98029000"
                    },
                    {
                        "id": 153126,
                        "name": "Bidaurreta",
                        "latitude": "42.77514430",
                        "longitude": "-1.83504530"
                    },
                    {
                        "id": 153028,
                        "name": "Biurrun-Olcoz",
                        "latitude": "42.66486530",
                        "longitude": "-1.68032860"
                    },
                    {
                        "id": 33046,
                        "name": "Buñuel",
                        "latitude": "41.98009000",
                        "longitude": "-1.44503000"
                    },
                    {
                        "id": 153030,
                        "name": "Burgui\/Burgi",
                        "latitude": "42.72095060",
                        "longitude": "-1.00298340"
                    },
                    {
                        "id": 153031,
                        "name": "Burlada\/Burlata",
                        "latitude": "42.82647590",
                        "longitude": "-1.61562610"
                    },
                    {
                        "id": 33031,
                        "name": "Burlata",
                        "latitude": "42.82562000",
                        "longitude": "-1.61671000"
                    },
                    {
                        "id": 153032,
                        "name": "Busto El",
                        "latitude": "42.55074800",
                        "longitude": "-2.24356100"
                    },
                    {
                        "id": 153033,
                        "name": "Cabanillas",
                        "latitude": "42.03221540",
                        "longitude": "-1.52449370"
                    },
                    {
                        "id": 33101,
                        "name": "Cabredo",
                        "latitude": "42.62966000",
                        "longitude": "-2.41133000"
                    },
                    {
                        "id": 33118,
                        "name": "Cadreita",
                        "latitude": "42.21667000",
                        "longitude": "-1.68333000"
                    },
                    {
                        "id": 33263,
                        "name": "Caparroso",
                        "latitude": "42.34129000",
                        "longitude": "-1.64962000"
                    },
                    {
                        "id": 33895,
                        "name": "Cárcar",
                        "latitude": "42.39314000",
                        "longitude": "-1.97904000"
                    },
                    {
                        "id": 33292,
                        "name": "Carcastillo",
                        "latitude": "42.37908000",
                        "longitude": "-1.44376000"
                    },
                    {
                        "id": 33386,
                        "name": "Cascante",
                        "latitude": "41.99769000",
                        "longitude": "-1.68098000"
                    },
                    {
                        "id": 33899,
                        "name": "Cáseda",
                        "latitude": "42.52255000",
                        "longitude": "-1.36636000"
                    },
                    {
                        "id": 33399,
                        "name": "Castejón",
                        "latitude": "42.16912000",
                        "longitude": "-1.68951000"
                    },
                    {
                        "id": 33467,
                        "name": "Castillonuevo",
                        "latitude": "42.68270000",
                        "longitude": "-1.03121000"
                    },
                    {
                        "id": 153094,
                        "name": "Cendea de Olza\/Oltza Zendea",
                        "latitude": "42.84700900",
                        "longitude": "-1.77871630"
                    },
                    {
                        "id": 33679,
                        "name": "Cintruénigo",
                        "latitude": "42.07937000",
                        "longitude": "-1.80458000"
                    },
                    {
                        "id": 33682,
                        "name": "Cirauqui",
                        "latitude": "42.67596000",
                        "longitude": "-1.89115000"
                    },
                    {
                        "id": 153035,
                        "name": "Cirauqui\/Zirauki",
                        "latitude": "42.67558020",
                        "longitude": "-1.89107600"
                    },
                    {
                        "id": 33684,
                        "name": "Ciriza",
                        "latitude": "42.79019000",
                        "longitude": "-1.82822000"
                    },
                    {
                        "id": 153036,
                        "name": "Ciriza\/Ziritza",
                        "latitude": "42.79077350",
                        "longitude": "-1.82507810"
                    },
                    {
                        "id": 153037,
                        "name": "Cizur",
                        "latitude": "42.78651630",
                        "longitude": "-1.67703710"
                    },
                    {
                        "id": 33703,
                        "name": "Cizur Mayor",
                        "latitude": "42.78795000",
                        "longitude": "-1.69065000"
                    },
                    {
                        "id": 33785,
                        "name": "Corella",
                        "latitude": "42.11507000",
                        "longitude": "-1.78563000"
                    },
                    {
                        "id": 153038,
                        "name": "Cortes",
                        "latitude": "41.92205420",
                        "longitude": "-1.42051990"
                    },
                    {
                        "id": 33929,
                        "name": "Desojo",
                        "latitude": "42.58790000",
                        "longitude": "-2.27438000"
                    },
                    {
                        "id": 33933,
                        "name": "Dicastillo",
                        "latitude": "42.59647000",
                        "longitude": "-2.02666000"
                    },
                    {
                        "id": 153039,
                        "name": "Donamaria",
                        "latitude": "43.11194510",
                        "longitude": "-1.67333600"
                    },
                    {
                        "id": 33943,
                        "name": "Doneztebe",
                        "latitude": "43.13333000",
                        "longitude": "-1.66667000"
                    },
                    {
                        "id": 153106,
                        "name": "Doneztebe\/Santesteban",
                        "latitude": "43.13287040",
                        "longitude": "-1.67181770"
                    },
                    {
                        "id": 33969,
                        "name": "Echarri",
                        "latitude": "42.78017000",
                        "longitude": "-1.82525000"
                    },
                    {
                        "id": 33970,
                        "name": "Echarri-Aranaz",
                        "latitude": "42.90791000",
                        "longitude": "-2.06474000"
                    },
                    {
                        "id": 153043,
                        "name": "Egüés",
                        "latitude": "42.82497300",
                        "longitude": "-1.55204070"
                    },
                    {
                        "id": 34036,
                        "name": "Elgorriaga",
                        "latitude": "43.13858000",
                        "longitude": "-1.68657000"
                    },
                    {
                        "id": 34039,
                        "name": "Elorz",
                        "latitude": "42.73258000",
                        "longitude": "-1.56152000"
                    },
                    {
                        "id": 34065,
                        "name": "Enériz",
                        "latitude": "42.67095000",
                        "longitude": "-1.72794000"
                    },
                    {
                        "id": 153045,
                        "name": "Enériz\/Eneritz",
                        "latitude": "42.67103300",
                        "longitude": "-1.72896010"
                    },
                    {
                        "id": 153046,
                        "name": "Eratsun",
                        "latitude": "43.08281090",
                        "longitude": "-1.79618980"
                    },
                    {
                        "id": 153047,
                        "name": "Ergoiena",
                        "latitude": "42.87442740",
                        "longitude": "-2.03560790"
                    },
                    {
                        "id": 34068,
                        "name": "Ermitagaña",
                        "latitude": "42.81084000",
                        "longitude": "-1.66409000"
                    },
                    {
                        "id": 153048,
                        "name": "Erro",
                        "latitude": "42.94180590",
                        "longitude": "-1.44984890"
                    },
                    {
                        "id": 34099,
                        "name": "Eslava",
                        "latitude": "42.56459000",
                        "longitude": "-1.45947000"
                    },
                    {
                        "id": 153050,
                        "name": "Esparza de Salazar\/Espartza Zaraitzu",
                        "latitude": "42.85446030",
                        "longitude": "-1.09991570"
                    },
                    {
                        "id": 34133,
                        "name": "Espronceda",
                        "latitude": "42.59707000",
                        "longitude": "-2.30524000"
                    },
                    {
                        "id": 34139,
                        "name": "Estella-Lizarra",
                        "latitude": "42.67182000",
                        "longitude": "-2.03226000"
                    },
                    {
                        "id": 153051,
                        "name": "Esteribar",
                        "latitude": "42.93654930",
                        "longitude": "-1.50326260"
                    },
                    {
                        "id": 34151,
                        "name": "Etayo",
                        "latitude": "42.61695000",
                        "longitude": "-2.15447000"
                    },
                    {
                        "id": 153040,
                        "name": "Etxalar",
                        "latitude": "43.23381700",
                        "longitude": "-1.63782190"
                    },
                    {
                        "id": 153041,
                        "name": "Etxarri-Aranatz",
                        "latitude": "42.90602010",
                        "longitude": "-2.06437080"
                    },
                    {
                        "id": 153042,
                        "name": "Etxauri",
                        "latitude": "42.79438740",
                        "longitude": "-1.78979530"
                    },
                    {
                        "id": 34152,
                        "name": "Eulate",
                        "latitude": "42.77641000",
                        "longitude": "-2.20638000"
                    },
                    {
                        "id": 153052,
                        "name": "Ezcabarte",
                        "latitude": "42.84635750",
                        "longitude": "-1.62041430"
                    },
                    {
                        "id": 153049,
                        "name": "Ezcároz\/Ezkaroze",
                        "latitude": "42.88703650",
                        "longitude": "-1.09688090"
                    },
                    {
                        "id": 153053,
                        "name": "Ezkurra",
                        "latitude": "43.08447670",
                        "longitude": "-1.82512900"
                    },
                    {
                        "id": 153054,
                        "name": "Ezprogui",
                        "latitude": "42.57133400",
                        "longitude": "-1.42123380"
                    },
                    {
                        "id": 34158,
                        "name": "Falces",
                        "latitude": "42.38966000",
                        "longitude": "-1.79321000"
                    },
                    {
                        "id": 34193,
                        "name": "Fitero",
                        "latitude": "42.05770000",
                        "longitude": "-1.85756000"
                    },
                    {
                        "id": 34214,
                        "name": "Fontellas",
                        "latitude": "42.02694000",
                        "longitude": "-1.57648000"
                    },
                    {
                        "id": 34365,
                        "name": "Funes",
                        "latitude": "42.31562000",
                        "longitude": "-1.80017000"
                    },
                    {
                        "id": 34366,
                        "name": "Fustiñana",
                        "latitude": "42.02087000",
                        "longitude": "-1.48526000"
                    },
                    {
                        "id": 34374,
                        "name": "Galar",
                        "latitude": "42.76147000",
                        "longitude": "-1.69881000"
                    },
                    {
                        "id": 34394,
                        "name": "Gallipienzo",
                        "latitude": "42.52450000",
                        "longitude": "-1.41115000"
                    },
                    {
                        "id": 153055,
                        "name": "Gallipienzo\/Galipentzu",
                        "latitude": "42.52409870",
                        "longitude": "-1.41050300"
                    },
                    {
                        "id": 153056,
                        "name": "Gallués\/Galoze",
                        "latitude": "42.78409000",
                        "longitude": "-1.09604420"
                    },
                    {
                        "id": 153057,
                        "name": "Garaioa",
                        "latitude": "42.92978300",
                        "longitude": "-1.24488790"
                    },
                    {
                        "id": 34413,
                        "name": "Garde",
                        "latitude": "42.78937000",
                        "longitude": "-0.92589000"
                    },
                    {
                        "id": 34429,
                        "name": "Garínoain",
                        "latitude": "42.60036000",
                        "longitude": "-1.64434000"
                    },
                    {
                        "id": 34422,
                        "name": "Garralda",
                        "latitude": "42.94818000",
                        "longitude": "-1.28624000"
                    },
                    {
                        "id": 34452,
                        "name": "Genevilla",
                        "latitude": "42.64520000",
                        "longitude": "-2.39021000"
                    },
                    {
                        "id": 34477,
                        "name": "Goizueta",
                        "latitude": "43.17187000",
                        "longitude": "-1.86411000"
                    },
                    {
                        "id": 34491,
                        "name": "Goñi",
                        "latitude": "42.85167000",
                        "longitude": "-1.90358000"
                    },
                    {
                        "id": 153058,
                        "name": "Güesa\/Gorza",
                        "latitude": "42.80636840",
                        "longitude": "-1.09470770"
                    },
                    {
                        "id": 153059,
                        "name": "Guesálaz\/Gesalatz",
                        "latitude": "42.75548250",
                        "longitude": "-1.93308340"
                    },
                    {
                        "id": 34550,
                        "name": "Guirguillano",
                        "latitude": "42.71725000",
                        "longitude": "-1.87798000"
                    },
                    {
                        "id": 153127,
                        "name": "Hiriberri\/Villanueva de Aezkoa",
                        "latitude": "42.94605810",
                        "longitude": "-1.23015970"
                    },
                    {
                        "id": 34682,
                        "name": "Huarte-Uharte",
                        "latitude": "42.83035000",
                        "longitude": "-1.59087000"
                    },
                    {
                        "id": 153060,
                        "name": "Huarte\/Uharte",
                        "latitude": "42.82970050",
                        "longitude": "-1.59038420"
                    },
                    {
                        "id": 153062,
                        "name": "Ibargoiti",
                        "latitude": "42.69306540",
                        "longitude": "-1.48688670"
                    },
                    {
                        "id": 34734,
                        "name": "Igantzi",
                        "latitude": "43.22526000",
                        "longitude": "-1.70048000"
                    },
                    {
                        "id": 34741,
                        "name": "Igúzquiza",
                        "latitude": "42.64545000",
                        "longitude": "-2.08551000"
                    },
                    {
                        "id": 153063,
                        "name": "Imotz",
                        "latitude": "42.94927390",
                        "longitude": "-1.80641630"
                    },
                    {
                        "id": 34758,
                        "name": "Irañeta",
                        "latitude": "42.92287000",
                        "longitude": "-1.94595000"
                    },
                    {
                        "id": 153132,
                        "name": "Irurtzun",
                        "latitude": "42.91925280",
                        "longitude": "-1.82756680"
                    },
                    {
                        "id": 153064,
                        "name": "Isaba\/Izaba",
                        "latitude": "42.86068030",
                        "longitude": "-0.92415340"
                    },
                    {
                        "id": 34774,
                        "name": "Ituren",
                        "latitude": "43.13238000",
                        "longitude": "-1.72063000"
                    },
                    {
                        "id": 34775,
                        "name": "Iturmendi",
                        "latitude": "42.88993000",
                        "longitude": "-2.11916000"
                    },
                    {
                        "id": 34776,
                        "name": "Iturrama",
                        "latitude": "42.80847000",
                        "longitude": "-1.65825000"
                    },
                    {
                        "id": 153065,
                        "name": "Iza\/Itza",
                        "latitude": "42.83744530",
                        "longitude": "-1.72941420"
                    },
                    {
                        "id": 153066,
                        "name": "Izagaondoa",
                        "latitude": "42.76289270",
                        "longitude": "-1.48670330"
                    },
                    {
                        "id": 153067,
                        "name": "Izalzu\/Itzaltzu",
                        "latitude": "42.91344060",
                        "longitude": "-1.05412440"
                    },
                    {
                        "id": 153068,
                        "name": "Jaurrieta",
                        "latitude": "42.88678220",
                        "longitude": "-1.13710110"
                    },
                    {
                        "id": 34809,
                        "name": "Javier",
                        "latitude": "42.59119000",
                        "longitude": "-1.20884000"
                    },
                    {
                        "id": 153069,
                        "name": "Juslapeña",
                        "latitude": "42.89125990",
                        "longitude": "-1.69141160"
                    },
                    {
                        "id": 153071,
                        "name": "Lakuntza",
                        "latitude": "42.92261280",
                        "longitude": "-2.02609450"
                    },
                    {
                        "id": 153072,
                        "name": "Lana",
                        "latitude": "42.72156590",
                        "longitude": "-2.25810000"
                    },
                    {
                        "id": 153073,
                        "name": "Lantz",
                        "latitude": "42.99804480",
                        "longitude": "-1.61992410"
                    },
                    {
                        "id": 34972,
                        "name": "Lapoblación",
                        "latitude": "42.60478000",
                        "longitude": "-2.46008000"
                    },
                    {
                        "id": 34978,
                        "name": "Larraga",
                        "latitude": "42.55841000",
                        "longitude": "-1.84954000"
                    },
                    {
                        "id": 34979,
                        "name": "Larraona",
                        "latitude": "42.77970000",
                        "longitude": "-2.25682000"
                    },
                    {
                        "id": 153074,
                        "name": "Larraun",
                        "latitude": "43.00790240",
                        "longitude": "-1.93538120"
                    },
                    {
                        "id": 35008,
                        "name": "Lazagurría",
                        "latitude": "42.49286000",
                        "longitude": "-2.24018000"
                    },
                    {
                        "id": 35010,
                        "name": "Leache",
                        "latitude": "42.60718000",
                        "longitude": "-1.40728000"
                    },
                    {
                        "id": 35022,
                        "name": "Legarda",
                        "latitude": "42.71183000",
                        "longitude": "-1.76846000"
                    },
                    {
                        "id": 35023,
                        "name": "Legaria",
                        "latitude": "42.64924000",
                        "longitude": "-2.17392000"
                    },
                    {
                        "id": 153075,
                        "name": "Leitza",
                        "latitude": "43.08481450",
                        "longitude": "-1.91603050"
                    },
                    {
                        "id": 153134,
                        "name": "Lekunberri",
                        "latitude": "43.00504570",
                        "longitude": "-1.89649220"
                    },
                    {
                        "id": 153076,
                        "name": "Leoz\/Leotz",
                        "latitude": "42.64521440",
                        "longitude": "-1.51937140"
                    },
                    {
                        "id": 35031,
                        "name": "Lerga",
                        "latitude": "42.56781000",
                        "longitude": "-1.50110000"
                    },
                    {
                        "id": 35033,
                        "name": "Lerín",
                        "latitude": "42.48318000",
                        "longitude": "-1.97184000"
                    },
                    {
                        "id": 153077,
                        "name": "Lesaka",
                        "latitude": "43.24738760",
                        "longitude": "-1.70219370"
                    },
                    {
                        "id": 35044,
                        "name": "Lezáun",
                        "latitude": "42.77739000",
                        "longitude": "-1.99385000"
                    },
                    {
                        "id": 35061,
                        "name": "Liédena",
                        "latitude": "42.61943000",
                        "longitude": "-1.27579000"
                    },
                    {
                        "id": 35060,
                        "name": "Lizoáin",
                        "latitude": "42.79868000",
                        "longitude": "-1.46753000"
                    },
                    {
                        "id": 153078,
                        "name": "Lizoáin-Arriasgoiti",
                        "latitude": "42.79865290",
                        "longitude": "-1.46733720"
                    },
                    {
                        "id": 35098,
                        "name": "Lodosa",
                        "latitude": "42.42269000",
                        "longitude": "-2.07741000"
                    },
                    {
                        "id": 153079,
                        "name": "Lónguida\/Longida",
                        "latitude": "42.74979410",
                        "longitude": "-1.36183030"
                    },
                    {
                        "id": 35117,
                        "name": "Los Arcos",
                        "latitude": "42.57076000",
                        "longitude": "-2.19275000"
                    },
                    {
                        "id": 35162,
                        "name": "Lumbier",
                        "latitude": "42.65303000",
                        "longitude": "-1.30669000"
                    },
                    {
                        "id": 153080,
                        "name": "Luquin",
                        "latitude": "42.61201810",
                        "longitude": "-2.09900890"
                    },
                    {
                        "id": 153123,
                        "name": "Luzaide\/Valcarlos",
                        "latitude": "43.09160340",
                        "longitude": "-1.30174520"
                    },
                    {
                        "id": 35362,
                        "name": "Mañeru",
                        "latitude": "42.67001000",
                        "longitude": "-1.86297000"
                    },
                    {
                        "id": 35280,
                        "name": "Marañón",
                        "latitude": "42.62941000",
                        "longitude": "-2.43931000"
                    },
                    {
                        "id": 35286,
                        "name": "Marcilla",
                        "latitude": "42.32794000",
                        "longitude": "-1.73714000"
                    },
                    {
                        "id": 35705,
                        "name": "Mélida",
                        "latitude": "42.35869000",
                        "longitude": "-1.54888000"
                    },
                    {
                        "id": 35399,
                        "name": "Mendavia",
                        "latitude": "42.44335000",
                        "longitude": "-2.20087000"
                    },
                    {
                        "id": 153081,
                        "name": "Mendaza",
                        "latitude": "42.64155380",
                        "longitude": "-2.23565940"
                    },
                    {
                        "id": 35401,
                        "name": "Mendigorría",
                        "latitude": "42.62822000",
                        "longitude": "-1.83450000"
                    },
                    {
                        "id": 35413,
                        "name": "Metauten",
                        "latitude": "42.67714000",
                        "longitude": "-2.13015000"
                    },
                    {
                        "id": 35428,
                        "name": "Milagro",
                        "latitude": "42.24160000",
                        "longitude": "-1.76588000"
                    },
                    {
                        "id": 35443,
                        "name": "Mirafuentes",
                        "latitude": "42.62297000",
                        "longitude": "-2.27966000"
                    },
                    {
                        "id": 35448,
                        "name": "Miranda de Arga",
                        "latitude": "42.48337000",
                        "longitude": "-1.82759000"
                    },
                    {
                        "id": 35520,
                        "name": "Monreal",
                        "latitude": "42.70421000",
                        "longitude": "-1.50785000"
                    },
                    {
                        "id": 153082,
                        "name": "Monreal\/Elo",
                        "latitude": "42.70480990",
                        "longitude": "-1.50704920"
                    },
                    {
                        "id": 153083,
                        "name": "Monteagudo",
                        "latitude": "41.96297720",
                        "longitude": "-1.69429390"
                    },
                    {
                        "id": 35626,
                        "name": "Morentin",
                        "latitude": "42.61286000",
                        "longitude": "-2.01393000"
                    },
                    {
                        "id": 153084,
                        "name": "Mues",
                        "latitude": "42.60552960",
                        "longitude": "-2.22616490"
                    },
                    {
                        "id": 35670,
                        "name": "Murchante",
                        "latitude": "42.03185000",
                        "longitude": "-1.65582000"
                    },
                    {
                        "id": 35677,
                        "name": "Murieta",
                        "latitude": "42.65618000",
                        "longitude": "-2.15452000"
                    },
                    {
                        "id": 153085,
                        "name": "Murillo el Cuende",
                        "latitude": "42.39742380",
                        "longitude": "-1.63025160"
                    },
                    {
                        "id": 35679,
                        "name": "Murillo el Fruto",
                        "latitude": "42.39272000",
                        "longitude": "-1.46034000"
                    },
                    {
                        "id": 35687,
                        "name": "Muruzábal",
                        "latitude": "42.69051000",
                        "longitude": "-1.76931000"
                    },
                    {
                        "id": 35784,
                        "name": "Navascués",
                        "latitude": "42.71758000",
                        "longitude": "-1.11744000"
                    },
                    {
                        "id": 153086,
                        "name": "Navascués\/Nabaskoze",
                        "latitude": "42.71856610",
                        "longitude": "-1.11604270"
                    },
                    {
                        "id": 35793,
                        "name": "Nazar",
                        "latitude": "42.63686000",
                        "longitude": "-2.27966000"
                    },
                    {
                        "id": 153044,
                        "name": "Noáin (Valle de Elorz)\/Noain (Elortzibar)",
                        "latitude": "42.75923970",
                        "longitude": "-1.63338480"
                    },
                    {
                        "id": 35852,
                        "name": "Obanos",
                        "latitude": "42.68071000",
                        "longitude": "-1.78493000"
                    },
                    {
                        "id": 153087,
                        "name": "Ochagavía\/Otsagabia",
                        "latitude": "42.90559190",
                        "longitude": "-1.09002240"
                    },
                    {
                        "id": 35858,
                        "name": "Oco",
                        "latitude": "42.63828000",
                        "longitude": "-2.16476000"
                    },
                    {
                        "id": 153088,
                        "name": "Odieta",
                        "latitude": "42.93580840",
                        "longitude": "-1.63800980"
                    },
                    {
                        "id": 153089,
                        "name": "Oitz",
                        "latitude": "43.10994040",
                        "longitude": "-1.68609180"
                    },
                    {
                        "id": 153090,
                        "name": "Olaibar",
                        "latitude": "42.89825510",
                        "longitude": "-1.59737670"
                    },
                    {
                        "id": 35873,
                        "name": "Olazagutía",
                        "latitude": "42.87584000",
                        "longitude": "-2.19538000"
                    },
                    {
                        "id": 153091,
                        "name": "Olazti\/Olazagutía",
                        "latitude": "42.87564370",
                        "longitude": "-2.19709120"
                    },
                    {
                        "id": 35877,
                        "name": "Olejua",
                        "latitude": "42.62329000",
                        "longitude": "-2.14202000"
                    },
                    {
                        "id": 35882,
                        "name": "Olite",
                        "latitude": "42.47971000",
                        "longitude": "-1.65196000"
                    },
                    {
                        "id": 153092,
                        "name": "Olite\/Erriberri",
                        "latitude": "42.48142500",
                        "longitude": "-1.65097680"
                    },
                    {
                        "id": 153095,
                        "name": "Ollo",
                        "latitude": "42.86736780",
                        "longitude": "-1.85841140"
                    },
                    {
                        "id": 35920,
                        "name": "Olóriz",
                        "latitude": "42.63522000",
                        "longitude": "-1.61276000"
                    },
                    {
                        "id": 153093,
                        "name": "Olóriz\/Oloritz",
                        "latitude": "42.63548130",
                        "longitude": "-1.61316900"
                    },
                    {
                        "id": 35913,
                        "name": "Oltza",
                        "latitude": "42.85000000",
                        "longitude": "-1.76667000"
                    },
                    {
                        "id": 153096,
                        "name": "Orbaizeta",
                        "latitude": "42.97484320",
                        "longitude": "-1.22976980"
                    },
                    {
                        "id": 35933,
                        "name": "Orbara",
                        "latitude": "42.96728000",
                        "longitude": "-1.24213000"
                    },
                    {
                        "id": 35967,
                        "name": "Orísoain",
                        "latitude": "42.60122000",
                        "longitude": "-1.60403000"
                    },
                    {
                        "id": 35954,
                        "name": "Orkoien",
                        "latitude": "42.82380000",
                        "longitude": "-1.70485000"
                    },
                    {
                        "id": 35956,
                        "name": "Oronz",
                        "latitude": "42.86873000",
                        "longitude": "-1.09683000"
                    },
                    {
                        "id": 153097,
                        "name": "Oronz\/Orontze",
                        "latitude": "42.86886940",
                        "longitude": "-1.09732020"
                    },
                    {
                        "id": 153098,
                        "name": "Oroz-Betelu\/Orotz-Betelu",
                        "latitude": "42.89551350",
                        "longitude": "-1.30381160"
                    },
                    {
                        "id": 153104,
                        "name": "Orreaga\/Roncesvalles",
                        "latitude": "43.00917740",
                        "longitude": "-1.31951000"
                    },
                    {
                        "id": 35976,
                        "name": "Oteiza",
                        "latitude": "42.61905000",
                        "longitude": "-1.95385000"
                    },
                    {
                        "id": 36045,
                        "name": "Pamplona",
                        "latitude": "42.81687000",
                        "longitude": "-1.64323000"
                    },
                    {
                        "id": 153099,
                        "name": "Pamplona\/Iruña",
                        "latitude": "42.81252600",
                        "longitude": "-1.64577450"
                    },
                    {
                        "id": 36142,
                        "name": "Peralta",
                        "latitude": "42.33834000",
                        "longitude": "-1.80035000"
                    },
                    {
                        "id": 153100,
                        "name": "Peralta\/Azkoien",
                        "latitude": "42.33897570",
                        "longitude": "-1.79909570"
                    },
                    {
                        "id": 36156,
                        "name": "Petilla de Aragón",
                        "latitude": "42.45000000",
                        "longitude": "-1.11667000"
                    },
                    {
                        "id": 36183,
                        "name": "Piedramillera",
                        "latitude": "42.63200000",
                        "longitude": "-2.20416000"
                    },
                    {
                        "id": 36223,
                        "name": "Pitillas",
                        "latitude": "42.42172000",
                        "longitude": "-1.62017000"
                    },
                    {
                        "id": 36355,
                        "name": "Primer Ensanche",
                        "latitude": "42.81483000",
                        "longitude": "-1.64898000"
                    },
                    {
                        "id": 36381,
                        "name": "Provincia de Navarra",
                        "latitude": "42.82330000",
                        "longitude": "-1.65138000"
                    },
                    {
                        "id": 36439,
                        "name": "Puente la Reina",
                        "latitude": "42.67291000",
                        "longitude": "-1.81412000"
                    },
                    {
                        "id": 153101,
                        "name": "Puente la Reina\/Gares",
                        "latitude": "42.67228180",
                        "longitude": "-1.81357500"
                    },
                    {
                        "id": 36459,
                        "name": "Pueyo",
                        "latitude": "42.56506000",
                        "longitude": "-1.64826000"
                    },
                    {
                        "id": 36610,
                        "name": "Ribaforada",
                        "latitude": "41.99814000",
                        "longitude": "-1.51272000"
                    },
                    {
                        "id": 153102,
                        "name": "Romanzado",
                        "latitude": "42.67545340",
                        "longitude": "-1.23909570"
                    },
                    {
                        "id": 153103,
                        "name": "Roncal\/Erronkari",
                        "latitude": "42.80962050",
                        "longitude": "-0.95565560"
                    },
                    {
                        "id": 36758,
                        "name": "Saldías",
                        "latitude": "43.08858000",
                        "longitude": "-1.77946000"
                    },
                    {
                        "id": 36764,
                        "name": "Salinas de Oro",
                        "latitude": "42.77487000",
                        "longitude": "-1.88999000"
                    },
                    {
                        "id": 153105,
                        "name": "Salinas de Oro\/Jaitz",
                        "latitude": "42.77549670",
                        "longitude": "-1.88932060"
                    },
                    {
                        "id": 36795,
                        "name": "San Adrián",
                        "latitude": "42.33433000",
                        "longitude": "-1.93509000"
                    },
                    {
                        "id": 36869,
                        "name": "San Martín de Unx",
                        "latitude": "42.52473000",
                        "longitude": "-1.56091000"
                    },
                    {
                        "id": 36946,
                        "name": "Sangüesa\/Zangoza",
                        "latitude": "42.57483000",
                        "longitude": "-1.28283000"
                    },
                    {
                        "id": 36950,
                        "name": "Sansol",
                        "latitude": "42.55362000",
                        "longitude": "-2.26676000"
                    },
                    {
                        "id": 37103,
                        "name": "Santacara",
                        "latitude": "42.36667000",
                        "longitude": "-1.63333000"
                    },
                    {
                        "id": 153107,
                        "name": "Sarriés\/Sartze",
                        "latitude": "42.83513000",
                        "longitude": "-1.10040710"
                    },
                    {
                        "id": 37169,
                        "name": "Sarriguren",
                        "latitude": "42.81292000",
                        "longitude": "-1.59815000"
                    },
                    {
                        "id": 37174,
                        "name": "Sartaguda",
                        "latitude": "42.38333000",
                        "longitude": "-2.05709000"
                    },
                    {
                        "id": 37193,
                        "name": "Segundo Ensanche",
                        "latitude": "42.81390000",
                        "longitude": "-1.64295000"
                    },
                    {
                        "id": 37232,
                        "name": "Sesma",
                        "latitude": "42.47748000",
                        "longitude": "-2.08353000"
                    },
                    {
                        "id": 37303,
                        "name": "Sorlada",
                        "latitude": "42.61507000",
                        "longitude": "-2.21525000"
                    },
                    {
                        "id": 153108,
                        "name": "Sunbilla",
                        "latitude": "43.16437790",
                        "longitude": "-1.67060310"
                    },
                    {
                        "id": 37348,
                        "name": "Tafalla",
                        "latitude": "42.52687000",
                        "longitude": "-1.67446000"
                    },
                    {
                        "id": 153109,
                        "name": "Tiebas-Muruarte de Reta",
                        "latitude": "42.66806250",
                        "longitude": "-1.66443520"
                    },
                    {
                        "id": 37428,
                        "name": "Tirapu",
                        "latitude": "42.65740000",
                        "longitude": "-1.70263000"
                    },
                    {
                        "id": 153110,
                        "name": "Torralba del Río",
                        "latitude": "42.60876260",
                        "longitude": "-2.33140710"
                    },
                    {
                        "id": 37579,
                        "name": "Torres del Río",
                        "latitude": "42.55162000",
                        "longitude": "-2.27285000"
                    },
                    {
                        "id": 37648,
                        "name": "Tudela",
                        "latitude": "42.06166000",
                        "longitude": "-1.60452000"
                    },
                    {
                        "id": 37653,
                        "name": "Tulebras",
                        "latitude": "41.97695000",
                        "longitude": "-1.67618000"
                    },
                    {
                        "id": 153111,
                        "name": "Ucar",
                        "latitude": "42.67551060",
                        "longitude": "-1.70556300"
                    },
                    {
                        "id": 153061,
                        "name": "Uharte-Arakil",
                        "latitude": "42.91934500",
                        "longitude": "-1.96919400"
                    },
                    {
                        "id": 37677,
                        "name": "Ujué",
                        "latitude": "42.50000000",
                        "longitude": "-1.50000000"
                    },
                    {
                        "id": 153112,
                        "name": "Ultzama",
                        "latitude": "43.00018990",
                        "longitude": "-1.67271530"
                    },
                    {
                        "id": 153113,
                        "name": "Unciti",
                        "latitude": "42.74757840",
                        "longitude": "-1.50119850"
                    },
                    {
                        "id": 37689,
                        "name": "Unzué",
                        "latitude": "42.65252000",
                        "longitude": "-1.62598000"
                    },
                    {
                        "id": 153114,
                        "name": "Unzué\/Untzue",
                        "latitude": "42.65301920",
                        "longitude": "-1.62623180"
                    },
                    {
                        "id": 153115,
                        "name": "Urdazubi\/Urdax",
                        "latitude": "43.26706880",
                        "longitude": "-1.50452560"
                    },
                    {
                        "id": 153116,
                        "name": "Urdiain",
                        "latitude": "42.88655680",
                        "longitude": "-2.13703910"
                    },
                    {
                        "id": 153117,
                        "name": "Urraul Alto",
                        "latitude": "42.75766830",
                        "longitude": "-1.25609350"
                    },
                    {
                        "id": 153118,
                        "name": "Urraul Bajo",
                        "latitude": "42.69067270",
                        "longitude": "-1.32838980"
                    },
                    {
                        "id": 153120,
                        "name": "Urrotz",
                        "latitude": "42.77826600",
                        "longitude": "-1.45885660"
                    },
                    {
                        "id": 153119,
                        "name": "Urroz-Villa",
                        "latitude": "42.77826600",
                        "longitude": "-1.45885660"
                    },
                    {
                        "id": 37701,
                        "name": "Urzainqui",
                        "latitude": "42.83029000",
                        "longitude": "-0.94617000"
                    },
                    {
                        "id": 153121,
                        "name": "Urzainqui\/Urzainki",
                        "latitude": "42.83149170",
                        "longitude": "-0.94602750"
                    },
                    {
                        "id": 37709,
                        "name": "Uterga",
                        "latitude": "42.70981000",
                        "longitude": "-1.76004000"
                    },
                    {
                        "id": 153122,
                        "name": "Uztárroz\/Uztarroze",
                        "latitude": "42.89189690",
                        "longitude": "-0.94065100"
                    },
                    {
                        "id": 153129,
                        "name": "Valle de Yerri\/Deierri",
                        "latitude": "42.73750820",
                        "longitude": "-1.94686510"
                    },
                    {
                        "id": 37879,
                        "name": "Valtierra",
                        "latitude": "42.19653000",
                        "longitude": "-1.63459000"
                    },
                    {
                        "id": 153124,
                        "name": "Viana",
                        "latitude": "42.51544770",
                        "longitude": "-2.37279470"
                    },
                    {
                        "id": 153125,
                        "name": "Vidángoz\/Bidankoze",
                        "latitude": "42.80171770",
                        "longitude": "-1.01404360"
                    },
                    {
                        "id": 38055,
                        "name": "Villafranca",
                        "latitude": "42.27933000",
                        "longitude": "-1.74628000"
                    },
                    {
                        "id": 38143,
                        "name": "Villamayor de Monjardín",
                        "latitude": "42.62937000",
                        "longitude": "-2.10503000"
                    },
                    {
                        "id": 38334,
                        "name": "Villatuerta",
                        "latitude": "42.66022000",
                        "longitude": "-1.99247000"
                    },
                    {
                        "id": 153128,
                        "name": "Villava\/Atarrabia",
                        "latitude": "42.83130140",
                        "longitude": "-1.61214960"
                    },
                    {
                        "id": 38436,
                        "name": "Yerri",
                        "latitude": "42.70161000",
                        "longitude": "-1.93806000"
                    },
                    {
                        "id": 38437,
                        "name": "Yesa",
                        "latitude": "42.62025000",
                        "longitude": "-1.20360000"
                    },
                    {
                        "id": 153130,
                        "name": "Zabalza\/Zabaltza",
                        "latitude": "42.77853000",
                        "longitude": "-1.79854740"
                    },
                    {
                        "id": 153034,
                        "name": "Ziordia",
                        "latitude": "42.87050550",
                        "longitude": "-2.22766390"
                    },
                    {
                        "id": 153133,
                        "name": "Zizur Mayor\/Zizur Nagusia",
                        "latitude": "42.78555750",
                        "longitude": "-1.68821810"
                    },
                    {
                        "id": 38502,
                        "name": "Zubieta",
                        "latitude": "43.12473000",
                        "longitude": "-1.74219000"
                    },
                    {
                        "id": 38506,
                        "name": "Zugarramurdi",
                        "latitude": "43.26964000",
                        "longitude": "-1.54113000"
                    },
                    {
                        "id": 38513,
                        "name": "Zúñiga",
                        "latitude": "42.69247000",
                        "longitude": "-2.29982000"
                    }
                ]
            },
            {
                "id": 5339,
                "name": "Navarre",
                "iso2": "NC",
                "latitude": "42.61147290",
                "longitude": "-2.27145430",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 5091,
                "name": "Ourense",
                "iso2": "OR",
                "latitude": "42.33836130",
                "longitude": "-7.88119510",
                "type": "province",
                "cities": [
                    {
                        "id": 32254,
                        "name": "Allariz",
                        "latitude": "42.19044000",
                        "longitude": "-7.80175000"
                    },
                    {
                        "id": 32352,
                        "name": "Ambía",
                        "latitude": "42.20578000",
                        "longitude": "-7.73707000"
                    },
                    {
                        "id": 32355,
                        "name": "Amoeiro",
                        "latitude": "42.41667000",
                        "longitude": "-7.95000000"
                    },
                    {
                        "id": 151095,
                        "name": "Arnoia A",
                        "latitude": "42.25666970",
                        "longitude": "-8.14048750"
                    },
                    {
                        "id": 32569,
                        "name": "Avión",
                        "latitude": "42.38333000",
                        "longitude": "-8.25000000"
                    },
                    {
                        "id": 32630,
                        "name": "Baltar",
                        "latitude": "41.95200000",
                        "longitude": "-7.71581000"
                    },
                    {
                        "id": 32632,
                        "name": "Bande",
                        "latitude": "42.03120000",
                        "longitude": "-7.97489000"
                    },
                    {
                        "id": 32703,
                        "name": "Baños de Molgas",
                        "latitude": "42.24148000",
                        "longitude": "-7.67223000"
                    },
                    {
                        "id": 151096,
                        "name": "Barbadás",
                        "latitude": "42.29814510",
                        "longitude": "-7.88712730"
                    },
                    {
                        "id": 151097,
                        "name": "Barco de Valdeorras O",
                        "latitude": "42.39713180",
                        "longitude": "-6.98534740"
                    },
                    {
                        "id": 32714,
                        "name": "Beade",
                        "latitude": "42.33074000",
                        "longitude": "-8.12950000"
                    },
                    {
                        "id": 151098,
                        "name": "Beariz",
                        "latitude": "42.46671900",
                        "longitude": "-8.27372960"
                    },
                    {
                        "id": 151099,
                        "name": "Blancos Os",
                        "latitude": "41.99746000",
                        "longitude": "-7.75228560"
                    },
                    {
                        "id": 32921,
                        "name": "Boborás",
                        "latitude": "42.43332000",
                        "longitude": "-8.14431000"
                    },
                    {
                        "id": 151100,
                        "name": "Bola A",
                        "latitude": "42.15104360",
                        "longitude": "-7.90482000"
                    },
                    {
                        "id": 151101,
                        "name": "Bolo O",
                        "latitude": "42.30168960",
                        "longitude": "-7.10363960"
                    },
                    {
                        "id": 151102,
                        "name": "Calvos de Randín",
                        "latitude": "41.90534310",
                        "longitude": "-7.87470560"
                    },
                    {
                        "id": 33282,
                        "name": "Carballeda de Avia",
                        "latitude": "42.32140000",
                        "longitude": "-8.16456000"
                    },
                    {
                        "id": 151103,
                        "name": "Carballeda de Valdeorras",
                        "latitude": "42.32655290",
                        "longitude": "-6.85654270"
                    },
                    {
                        "id": 151104,
                        "name": "Carballiño O",
                        "latitude": "42.43163110",
                        "longitude": "-8.07750760"
                    },
                    {
                        "id": 33339,
                        "name": "Cartelle",
                        "latitude": "42.25109000",
                        "longitude": "-8.07062000"
                    },
                    {
                        "id": 33473,
                        "name": "Castrelo de Miño",
                        "latitude": "42.29798000",
                        "longitude": "-8.06697000"
                    },
                    {
                        "id": 151105,
                        "name": "Castrelo do Val",
                        "latitude": "41.98961620",
                        "longitude": "-7.42258810"
                    },
                    {
                        "id": 33487,
                        "name": "Castro Caldelas",
                        "latitude": "42.37366000",
                        "longitude": "-7.42578000"
                    },
                    {
                        "id": 33563,
                        "name": "Celanova",
                        "latitude": "42.15303000",
                        "longitude": "-7.95513000"
                    },
                    {
                        "id": 33572,
                        "name": "Cenlle",
                        "latitude": "42.34183000",
                        "longitude": "-8.08982000"
                    },
                    {
                        "id": 151107,
                        "name": "Chandrexa de Queixa",
                        "latitude": "42.25477690",
                        "longitude": "-7.38145520"
                    },
                    {
                        "id": 33727,
                        "name": "Coles",
                        "latitude": "42.40000000",
                        "longitude": "-7.83333000"
                    },
                    {
                        "id": 151106,
                        "name": "Cortegada",
                        "latitude": "42.20732230",
                        "longitude": "-8.17012000"
                    },
                    {
                        "id": 33843,
                        "name": "Cualedro",
                        "latitude": "41.98897000",
                        "longitude": "-7.59464000"
                    },
                    {
                        "id": 34063,
                        "name": "Entrimo",
                        "latitude": "41.93297000",
                        "longitude": "-8.11725000"
                    },
                    {
                        "id": 34095,
                        "name": "Esgos",
                        "latitude": "42.32549000",
                        "longitude": "-7.69691000"
                    },
                    {
                        "id": 151108,
                        "name": "Gomesende",
                        "latitude": "42.16322380",
                        "longitude": "-8.10348050"
                    },
                    {
                        "id": 151109,
                        "name": "Gudiña A",
                        "latitude": "42.06057390",
                        "longitude": "-7.13930290"
                    },
                    {
                        "id": 151110,
                        "name": "Irixo O",
                        "latitude": "42.33578930",
                        "longitude": "-7.86388100"
                    },
                    {
                        "id": 151113,
                        "name": "Larouco",
                        "latitude": "42.34651170",
                        "longitude": "-7.16084480"
                    },
                    {
                        "id": 35007,
                        "name": "Laza",
                        "latitude": "42.06136000",
                        "longitude": "-7.46200000"
                    },
                    {
                        "id": 151114,
                        "name": "Leiro",
                        "latitude": "42.36937040",
                        "longitude": "-8.14478040"
                    },
                    {
                        "id": 151115,
                        "name": "Lobeira",
                        "latitude": "41.98645690",
                        "longitude": "-8.03958980"
                    },
                    {
                        "id": 35095,
                        "name": "Lobios",
                        "latitude": "42.40746000",
                        "longitude": "-7.53164000"
                    },
                    {
                        "id": 35161,
                        "name": "Luintra",
                        "latitude": "42.40964000",
                        "longitude": "-7.72682000"
                    },
                    {
                        "id": 35181,
                        "name": "Maceda",
                        "latitude": "42.26972000",
                        "longitude": "-7.65052000"
                    },
                    {
                        "id": 35268,
                        "name": "Manzaneda",
                        "latitude": "42.30962000",
                        "longitude": "-7.23209000"
                    },
                    {
                        "id": 35323,
                        "name": "Maside",
                        "latitude": "42.41031000",
                        "longitude": "-8.02582000"
                    },
                    {
                        "id": 35392,
                        "name": "Melón",
                        "latitude": "42.26016000",
                        "longitude": "-8.21400000"
                    },
                    {
                        "id": 151116,
                        "name": "Merca A",
                        "latitude": "42.22228080",
                        "longitude": "-7.90548160"
                    },
                    {
                        "id": 151117,
                        "name": "Mezquita A",
                        "latitude": "42.34697080",
                        "longitude": "-7.85456320"
                    },
                    {
                        "id": 35547,
                        "name": "Montederramo",
                        "latitude": "42.27554000",
                        "longitude": "-7.50138000"
                    },
                    {
                        "id": 151118,
                        "name": "Monterrei",
                        "latitude": "41.94701790",
                        "longitude": "-7.44923960"
                    },
                    {
                        "id": 35660,
                        "name": "Muiños",
                        "latitude": "41.95609000",
                        "longitude": "-7.97396000"
                    },
                    {
                        "id": 35817,
                        "name": "Nogueira de Ramuín",
                        "latitude": "42.41712000",
                        "longitude": "-7.74982000"
                    },
                    {
                        "id": 35846,
                        "name": "O Barco de Valdeorras",
                        "latitude": "42.41642000",
                        "longitude": "-6.99005000"
                    },
                    {
                        "id": 35847,
                        "name": "O Carballiño",
                        "latitude": "42.43163000",
                        "longitude": "-8.07899000"
                    },
                    {
                        "id": 35865,
                        "name": "Oimbra",
                        "latitude": "41.88554000",
                        "longitude": "-7.47216000"
                    },
                    {
                        "id": 35983,
                        "name": "Ourense",
                        "latitude": "42.33669000",
                        "longitude": "-7.86407000"
                    },
                    {
                        "id": 151119,
                        "name": "Paderne de Allariz",
                        "latitude": "42.27146620",
                        "longitude": "-7.75094040"
                    },
                    {
                        "id": 35993,
                        "name": "Padrenda",
                        "latitude": "42.13333000",
                        "longitude": "-8.15000000"
                    },
                    {
                        "id": 151120,
                        "name": "Parada de Sil",
                        "latitude": "42.38242790",
                        "longitude": "-7.56772080"
                    },
                    {
                        "id": 36147,
                        "name": "Pereiro de Aguiar",
                        "latitude": "42.34524000",
                        "longitude": "-7.80008000"
                    },
                    {
                        "id": 151121,
                        "name": "Pereiro de Aguiar O",
                        "latitude": "42.33578930",
                        "longitude": "-7.86388100"
                    },
                    {
                        "id": 151122,
                        "name": "Peroxa A",
                        "latitude": "42.45231580",
                        "longitude": "-7.79601180"
                    },
                    {
                        "id": 36159,
                        "name": "Petín",
                        "latitude": "42.38191000",
                        "longitude": "-7.12899000"
                    },
                    {
                        "id": 36232,
                        "name": "Piñor",
                        "latitude": "42.50120000",
                        "longitude": "-8.00151000"
                    },
                    {
                        "id": 151123,
                        "name": "Pobra de Trives A",
                        "latitude": "42.33934680",
                        "longitude": "-7.25380970"
                    },
                    {
                        "id": 151124,
                        "name": "Pontedeva",
                        "latitude": "42.16561270",
                        "longitude": "-8.13768240"
                    },
                    {
                        "id": 36278,
                        "name": "Porqueira",
                        "latitude": "42.01667000",
                        "longitude": "-7.85000000"
                    },
                    {
                        "id": 151125,
                        "name": "Punxín",
                        "latitude": "42.37862830",
                        "longitude": "-8.01379400"
                    },
                    {
                        "id": 36527,
                        "name": "Quintela de Leirado",
                        "latitude": "42.13967000",
                        "longitude": "-8.10126000"
                    },
                    {
                        "id": 36542,
                        "name": "Rairiz de Veiga",
                        "latitude": "42.08364000",
                        "longitude": "-7.83503000"
                    },
                    {
                        "id": 151126,
                        "name": "Ramirás",
                        "latitude": "42.28320310",
                        "longitude": "-8.01928670"
                    },
                    {
                        "id": 36607,
                        "name": "Ribadavia",
                        "latitude": "42.28804000",
                        "longitude": "-8.14362000"
                    },
                    {
                        "id": 36642,
                        "name": "Riós",
                        "latitude": "41.97457000",
                        "longitude": "-7.28234000"
                    },
                    {
                        "id": 151128,
                        "name": "Rúa A",
                        "latitude": "42.33932800",
                        "longitude": "-7.84871580"
                    },
                    {
                        "id": 151129,
                        "name": "Rubiá",
                        "latitude": "42.47145850",
                        "longitude": "-6.88872020"
                    },
                    {
                        "id": 36801,
                        "name": "San Amaro",
                        "latitude": "42.37385000",
                        "longitude": "-8.07347000"
                    },
                    {
                        "id": 151130,
                        "name": "San Cibrao das Viñas",
                        "latitude": "42.29484450",
                        "longitude": "-7.87284030"
                    },
                    {
                        "id": 151131,
                        "name": "San Cristovo de Cea",
                        "latitude": "42.50038680",
                        "longitude": "-7.94838980"
                    },
                    {
                        "id": 151127,
                        "name": "San Xoán de Río",
                        "latitude": "42.37059030",
                        "longitude": "-7.29937170"
                    },
                    {
                        "id": 151132,
                        "name": "Sandiás",
                        "latitude": "42.10250340",
                        "longitude": "-7.75253520"
                    },
                    {
                        "id": 37167,
                        "name": "Sarreaus",
                        "latitude": "42.08784000",
                        "longitude": "-7.60348000"
                    },
                    {
                        "id": 37345,
                        "name": "Taboadela",
                        "latitude": "42.24234000",
                        "longitude": "-7.82719000"
                    },
                    {
                        "id": 151133,
                        "name": "Teixeira A",
                        "latitude": "42.33578930",
                        "longitude": "-7.86388100"
                    },
                    {
                        "id": 37610,
                        "name": "Toén",
                        "latitude": "42.31765000",
                        "longitude": "-7.95435000"
                    },
                    {
                        "id": 37620,
                        "name": "Trasmiras",
                        "latitude": "42.02540000",
                        "longitude": "-7.61735000"
                    },
                    {
                        "id": 151134,
                        "name": "Veiga A",
                        "latitude": "42.13776390",
                        "longitude": "-7.92993400"
                    },
                    {
                        "id": 37951,
                        "name": "Verea",
                        "latitude": "42.10653000",
                        "longitude": "-8.00092000"
                    },
                    {
                        "id": 37955,
                        "name": "Verín",
                        "latitude": "41.94149000",
                        "longitude": "-7.43809000"
                    },
                    {
                        "id": 151135,
                        "name": "Viana do Bolo",
                        "latitude": "42.33896300",
                        "longitude": "-7.85202770"
                    },
                    {
                        "id": 151136,
                        "name": "Vilamarín",
                        "latitude": "42.46507870",
                        "longitude": "-7.89018920"
                    },
                    {
                        "id": 151137,
                        "name": "Vilamartín de Valdeorras",
                        "latitude": "42.41339370",
                        "longitude": "-7.05925530"
                    },
                    {
                        "id": 151138,
                        "name": "Vilar de Barrio",
                        "latitude": "42.15979160",
                        "longitude": "-7.61277720"
                    },
                    {
                        "id": 151139,
                        "name": "Vilar de Santos",
                        "latitude": "42.08612310",
                        "longitude": "-7.79465270"
                    },
                    {
                        "id": 151140,
                        "name": "Vilardevós",
                        "latitude": "41.90731400",
                        "longitude": "-7.31255920"
                    },
                    {
                        "id": 151141,
                        "name": "Vilariño de Conso",
                        "latitude": "42.16605680",
                        "longitude": "-7.18327240"
                    },
                    {
                        "id": 38422,
                        "name": "Xinzo de Limia",
                        "latitude": "42.06350000",
                        "longitude": "-7.72459000"
                    },
                    {
                        "id": 151111,
                        "name": "Xunqueira de Ambía",
                        "latitude": "42.20362720",
                        "longitude": "-7.73691740"
                    },
                    {
                        "id": 151112,
                        "name": "Xunqueira de Espadanedo",
                        "latitude": "42.31837970",
                        "longitude": "-7.62938430"
                    }
                ]
            },
            {
                "id": 1157,
                "name": "Palencia",
                "iso2": "P",
                "latitude": "42.00968320",
                "longitude": "-4.52879490",
                "type": "province",
                "cities": [
                    {
                        "id": 152559,
                        "name": "Abarca de Campos",
                        "latitude": "42.06249640",
                        "longitude": "-4.84136960"
                    },
                    {
                        "id": 31912,
                        "name": "Abia de las Torres",
                        "latitude": "42.42016000",
                        "longitude": "-4.42131000"
                    },
                    {
                        "id": 31960,
                        "name": "Aguilar de Campoo",
                        "latitude": "42.79452000",
                        "longitude": "-4.25892000"
                    },
                    {
                        "id": 32002,
                        "name": "Alar del Rey",
                        "latitude": "42.66037000",
                        "longitude": "-4.31271000"
                    },
                    {
                        "id": 32010,
                        "name": "Alba de Cerrato",
                        "latitude": "41.81276000",
                        "longitude": "-4.36470000"
                    },
                    {
                        "id": 32349,
                        "name": "Amayuelas de Arriba",
                        "latitude": "42.21108000",
                        "longitude": "-4.48880000"
                    },
                    {
                        "id": 32359,
                        "name": "Ampudia",
                        "latitude": "41.91608000",
                        "longitude": "-4.78033000"
                    },
                    {
                        "id": 32362,
                        "name": "Amusco",
                        "latitude": "42.17306000",
                        "longitude": "-4.47018000"
                    },
                    {
                        "id": 32394,
                        "name": "Antigüedad",
                        "latitude": "41.94681000",
                        "longitude": "-4.12058000"
                    },
                    {
                        "id": 32433,
                        "name": "Arconada",
                        "latitude": "42.32774000",
                        "longitude": "-4.49617000"
                    },
                    {
                        "id": 32541,
                        "name": "Astudillo",
                        "latitude": "42.19330000",
                        "longitude": "-4.29394000"
                    },
                    {
                        "id": 32560,
                        "name": "Autilla del Pino",
                        "latitude": "41.99207000",
                        "longitude": "-4.63393000"
                    },
                    {
                        "id": 32561,
                        "name": "Autillo de Campos",
                        "latitude": "42.08725000",
                        "longitude": "-4.83376000"
                    },
                    {
                        "id": 32578,
                        "name": "Ayuela",
                        "latitude": "42.62618000",
                        "longitude": "-4.65979000"
                    },
                    {
                        "id": 32629,
                        "name": "Baltanás",
                        "latitude": "41.93775000",
                        "longitude": "-4.24656000"
                    },
                    {
                        "id": 32635,
                        "name": "Baquerín de Campos",
                        "latitude": "42.01600000",
                        "longitude": "-4.78185000"
                    },
                    {
                        "id": 33052,
                        "name": "Bárcena de Campos",
                        "latitude": "42.48428000",
                        "longitude": "-4.49875000"
                    },
                    {
                        "id": 32682,
                        "name": "Barruelo de Santullán",
                        "latitude": "42.90641000",
                        "longitude": "-4.28593000"
                    },
                    {
                        "id": 33055,
                        "name": "Báscones de Ojeda",
                        "latitude": "42.67064000",
                        "longitude": "-4.52693000"
                    },
                    {
                        "id": 32724,
                        "name": "Becerril de Campos",
                        "latitude": "42.10841000",
                        "longitude": "-4.64152000"
                    },
                    {
                        "id": 32749,
                        "name": "Belmonte de Campos",
                        "latitude": "41.94255000",
                        "longitude": "-4.98659000"
                    },
                    {
                        "id": 32876,
                        "name": "Berzosilla",
                        "latitude": "42.78053000",
                        "longitude": "-4.03753000"
                    },
                    {
                        "id": 32915,
                        "name": "Boada de Campos",
                        "latitude": "41.98957000",
                        "longitude": "-4.87730000"
                    },
                    {
                        "id": 152560,
                        "name": "Boadilla de Rioseco",
                        "latitude": "42.18000060",
                        "longitude": "-4.96950850"
                    },
                    {
                        "id": 32916,
                        "name": "Boadilla del Camino",
                        "latitude": "42.25934000",
                        "longitude": "-4.34525000"
                    },
                    {
                        "id": 32973,
                        "name": "Brañosera",
                        "latitude": "42.93620000",
                        "longitude": "-4.30833000"
                    },
                    {
                        "id": 33004,
                        "name": "Buenavista de Valdavia",
                        "latitude": "42.63788000",
                        "longitude": "-4.61446000"
                    },
                    {
                        "id": 33040,
                        "name": "Bustillo de la Vega",
                        "latitude": "42.45605000",
                        "longitude": "-4.74115000"
                    },
                    {
                        "id": 33043,
                        "name": "Bustillo del Páramo de Carrión",
                        "latitude": "42.35509000",
                        "longitude": "-4.73980000"
                    },
                    {
                        "id": 33127,
                        "name": "Calahorra de Boedo",
                        "latitude": "42.57409000",
                        "longitude": "-4.38485000"
                    },
                    {
                        "id": 33159,
                        "name": "Calzada de los Molinos",
                        "latitude": "42.32724000",
                        "longitude": "-4.65293000"
                    },
                    {
                        "id": 33270,
                        "name": "Capillas",
                        "latitude": "42.01362000",
                        "longitude": "-4.89051000"
                    },
                    {
                        "id": 33302,
                        "name": "Cardeñosa de Volpejera",
                        "latitude": "42.23214000",
                        "longitude": "-4.70197000"
                    },
                    {
                        "id": 33332,
                        "name": "Carrión de los Condes",
                        "latitude": "42.34130000",
                        "longitude": "-4.60071000"
                    },
                    {
                        "id": 33445,
                        "name": "Castil de Vela",
                        "latitude": "41.98461000",
                        "longitude": "-4.95920000"
                    },
                    {
                        "id": 33472,
                        "name": "Castrejón de la Peña",
                        "latitude": "42.80795000",
                        "longitude": "-4.59901000"
                    },
                    {
                        "id": 33476,
                        "name": "Castrillo de Don Juan",
                        "latitude": "41.79086000",
                        "longitude": "-4.07031000"
                    },
                    {
                        "id": 33478,
                        "name": "Castrillo de Onielo",
                        "latitude": "41.85820000",
                        "longitude": "-4.30125000"
                    },
                    {
                        "id": 33479,
                        "name": "Castrillo de Villavega",
                        "latitude": "42.45463000",
                        "longitude": "-4.48069000"
                    },
                    {
                        "id": 33500,
                        "name": "Castromocho",
                        "latitude": "42.03104000",
                        "longitude": "-4.82404000"
                    },
                    {
                        "id": 33593,
                        "name": "Cervatos de la Cueza",
                        "latitude": "42.29054000",
                        "longitude": "-4.76947000"
                    },
                    {
                        "id": 33597,
                        "name": "Cervera de Pisuerga",
                        "latitude": "42.86676000",
                        "longitude": "-4.49796000"
                    },
                    {
                        "id": 33612,
                        "name": "Cevico de la Torre",
                        "latitude": "41.85113000",
                        "longitude": "-4.40973000"
                    },
                    {
                        "id": 33611,
                        "name": "Cevico Navero",
                        "latitude": "41.86112000",
                        "longitude": "-4.18498000"
                    },
                    {
                        "id": 33691,
                        "name": "Cisneros",
                        "latitude": "42.22046000",
                        "longitude": "-4.85807000"
                    },
                    {
                        "id": 33711,
                        "name": "Cobos de Cerrato",
                        "latitude": "42.02808000",
                        "longitude": "-4.00251000"
                    },
                    {
                        "id": 33737,
                        "name": "Collazos de Boedo",
                        "latitude": "42.62009000",
                        "longitude": "-4.48294000"
                    },
                    {
                        "id": 33759,
                        "name": "Congosto de Valdavia",
                        "latitude": "42.71584000",
                        "longitude": "-4.63366000"
                    },
                    {
                        "id": 33782,
                        "name": "Cordovilla la Real",
                        "latitude": "42.07961000",
                        "longitude": "-4.25988000"
                    },
                    {
                        "id": 33850,
                        "name": "Cubillas de Cerrato",
                        "latitude": "41.79844000",
                        "longitude": "-4.46720000"
                    },
                    {
                        "id": 33918,
                        "name": "Dehesa de Montejo",
                        "latitude": "42.81939000",
                        "longitude": "-4.51019000"
                    },
                    {
                        "id": 33919,
                        "name": "Dehesa de Romanos",
                        "latitude": "42.63876000",
                        "longitude": "-4.43518000"
                    },
                    {
                        "id": 33959,
                        "name": "Dueñas",
                        "latitude": "41.87717000",
                        "longitude": "-4.54714000"
                    },
                    {
                        "id": 34118,
                        "name": "Espinosa de Cerrato",
                        "latitude": "41.96679000",
                        "longitude": "-3.95346000"
                    },
                    {
                        "id": 34121,
                        "name": "Espinosa de Villagonzalo",
                        "latitude": "42.47949000",
                        "longitude": "-4.37218000"
                    },
                    {
                        "id": 34240,
                        "name": "Frechilla",
                        "latitude": "42.13768000",
                        "longitude": "-4.84112000"
                    },
                    {
                        "id": 34264,
                        "name": "Fresno del Río",
                        "latitude": "42.68176000",
                        "longitude": "-4.81734000"
                    },
                    {
                        "id": 34273,
                        "name": "Frómista",
                        "latitude": "42.26667000",
                        "longitude": "-4.40546000"
                    },
                    {
                        "id": 34347,
                        "name": "Fuentes de Nava",
                        "latitude": "42.08333000",
                        "longitude": "-4.78333000"
                    },
                    {
                        "id": 34351,
                        "name": "Fuentes de Valdepero",
                        "latitude": "42.07532000",
                        "longitude": "-4.50050000"
                    },
                    {
                        "id": 34512,
                        "name": "Grijota",
                        "latitude": "42.05289000",
                        "longitude": "-4.58309000"
                    },
                    {
                        "id": 34536,
                        "name": "Guardo",
                        "latitude": "42.78966000",
                        "longitude": "-4.84823000"
                    },
                    {
                        "id": 34540,
                        "name": "Guaza de Campos",
                        "latitude": "42.13365000",
                        "longitude": "-4.90949000"
                    },
                    {
                        "id": 34721,
                        "name": "Hérmedes de Cerrato",
                        "latitude": "41.81972000",
                        "longitude": "-4.17361000"
                    },
                    {
                        "id": 34595,
                        "name": "Herrera de Pisuerga",
                        "latitude": "42.59492000",
                        "longitude": "-4.33034000"
                    },
                    {
                        "id": 34597,
                        "name": "Herrera de Valdecañas",
                        "latitude": "42.04828000",
                        "longitude": "-4.20004000"
                    },
                    {
                        "id": 34646,
                        "name": "Hontoria de Cerrato",
                        "latitude": "41.91061000",
                        "longitude": "-4.44209000"
                    },
                    {
                        "id": 34662,
                        "name": "Hornillos de Cerrato",
                        "latitude": "41.98772000",
                        "longitude": "-4.27207000"
                    },
                    {
                        "id": 34705,
                        "name": "Husillos",
                        "latitude": "42.09054000",
                        "longitude": "-4.52709000"
                    },
                    {
                        "id": 34770,
                        "name": "Itero de la Vega",
                        "latitude": "42.28804000",
                        "longitude": "-4.25677000"
                    },
                    {
                        "id": 34940,
                        "name": "Lagartos",
                        "latitude": "42.40578000",
                        "longitude": "-4.90454000"
                    },
                    {
                        "id": 34968,
                        "name": "Lantadilla",
                        "latitude": "42.34078000",
                        "longitude": "-4.27866000"
                    },
                    {
                        "id": 35018,
                        "name": "Ledigos",
                        "latitude": "42.35480000",
                        "longitude": "-4.86480000"
                    },
                    {
                        "id": 152572,
                        "name": "Loma de Ucieza",
                        "latitude": "42.46977340",
                        "longitude": "-4.57275980"
                    },
                    {
                        "id": 35103,
                        "name": "Lomas",
                        "latitude": "42.27362000",
                        "longitude": "-4.55095000"
                    },
                    {
                        "id": 152562,
                        "name": "Magaz de Pisuerga",
                        "latitude": "41.98262540",
                        "longitude": "-4.42756100"
                    },
                    {
                        "id": 35255,
                        "name": "Manquillos",
                        "latitude": "42.20518000",
                        "longitude": "-4.56841000"
                    },
                    {
                        "id": 35260,
                        "name": "Mantinos",
                        "latitude": "42.75259000",
                        "longitude": "-4.84213000"
                    },
                    {
                        "id": 35287,
                        "name": "Marcilla de Campos",
                        "latitude": "42.31770000",
                        "longitude": "-4.39670000"
                    },
                    {
                        "id": 35355,
                        "name": "Mazariegos",
                        "latitude": "42.02691000",
                        "longitude": "-4.71542000"
                    },
                    {
                        "id": 35359,
                        "name": "Mazuecos de Valdeginate",
                        "latitude": "42.16814000",
                        "longitude": "-4.84059000"
                    },
                    {
                        "id": 35389,
                        "name": "Melgar de Yuso",
                        "latitude": "42.25381000",
                        "longitude": "-4.25394000"
                    },
                    {
                        "id": 35402,
                        "name": "Meneses de Campos",
                        "latitude": "41.94142000",
                        "longitude": "-4.91927000"
                    },
                    {
                        "id": 35419,
                        "name": "Micieces de Ojeda",
                        "latitude": "42.69078000",
                        "longitude": "-4.46166000"
                    },
                    {
                        "id": 35591,
                        "name": "Monzón de Campos",
                        "latitude": "42.11604000",
                        "longitude": "-4.49283000"
                    },
                    {
                        "id": 35620,
                        "name": "Moratinos",
                        "latitude": "42.36191000",
                        "longitude": "-4.92831000"
                    },
                    {
                        "id": 35654,
                        "name": "Mudá",
                        "latitude": "42.87530000",
                        "longitude": "-4.39426000"
                    },
                    {
                        "id": 35815,
                        "name": "Nogal de las Huertas",
                        "latitude": "42.39255000",
                        "longitude": "-4.64156000"
                    },
                    {
                        "id": 35875,
                        "name": "Olea de Boedo",
                        "latitude": "42.60990000",
                        "longitude": "-4.45040000"
                    },
                    {
                        "id": 35906,
                        "name": "Olmos de Ojeda",
                        "latitude": "42.72274000",
                        "longitude": "-4.42446000"
                    },
                    {
                        "id": 35972,
                        "name": "Osornillo",
                        "latitude": "42.37047000",
                        "longitude": "-4.29153000"
                    },
                    {
                        "id": 152570,
                        "name": "Osorno la Mayor",
                        "latitude": "42.36947800",
                        "longitude": "-4.37707040"
                    },
                    {
                        "id": 36022,
                        "name": "Palencia",
                        "latitude": "42.00955000",
                        "longitude": "-4.52406000"
                    },
                    {
                        "id": 36025,
                        "name": "Palenzuela",
                        "latitude": "42.09518000",
                        "longitude": "-4.13039000"
                    },
                    {
                        "id": 36482,
                        "name": "Páramo de Boedo",
                        "latitude": "42.57842000",
                        "longitude": "-4.40042000"
                    },
                    {
                        "id": 36066,
                        "name": "Paredes de Nava",
                        "latitude": "42.15367000",
                        "longitude": "-4.69193000"
                    },
                    {
                        "id": 36086,
                        "name": "Payo de Ojeda",
                        "latitude": "42.71859000",
                        "longitude": "-4.47752000"
                    },
                    {
                        "id": 36094,
                        "name": "Pedraza de Campos",
                        "latitude": "41.98419000",
                        "longitude": "-4.73524000"
                    },
                    {
                        "id": 36105,
                        "name": "Pedrosa de la Vega",
                        "latitude": "42.48159000",
                        "longitude": "-4.74678000"
                    },
                    {
                        "id": 36138,
                        "name": "Perales",
                        "latitude": "42.19398000",
                        "longitude": "-4.58105000"
                    },
                    {
                        "id": 152573,
                        "name": "Pernía La",
                        "latitude": "42.98949270",
                        "longitude": "-4.50058080"
                    },
                    {
                        "id": 36227,
                        "name": "Piña de Campos",
                        "latitude": "42.21326000",
                        "longitude": "-4.43657000"
                    },
                    {
                        "id": 36209,
                        "name": "Pino del Río",
                        "latitude": "42.64504000",
                        "longitude": "-4.80795000"
                    },
                    {
                        "id": 36247,
                        "name": "Población de Arroyo",
                        "latitude": "42.33675000",
                        "longitude": "-4.87398000"
                    },
                    {
                        "id": 36248,
                        "name": "Población de Campos",
                        "latitude": "42.26994000",
                        "longitude": "-4.44744000"
                    },
                    {
                        "id": 36249,
                        "name": "Población de Cerrato",
                        "latitude": "41.79298000",
                        "longitude": "-4.42874000"
                    },
                    {
                        "id": 36258,
                        "name": "Polentinos",
                        "latitude": "42.93932000",
                        "longitude": "-4.52887000"
                    },
                    {
                        "id": 36268,
                        "name": "Pomar de Valdivia",
                        "latitude": "42.77437000",
                        "longitude": "-4.16756000"
                    },
                    {
                        "id": 36312,
                        "name": "Poza de la Vega",
                        "latitude": "42.57823000",
                        "longitude": "-4.79845000"
                    },
                    {
                        "id": 36319,
                        "name": "Pozo de Urama",
                        "latitude": "42.25438000",
                        "longitude": "-4.89389000"
                    },
                    {
                        "id": 36403,
                        "name": "Prádanos de Ojeda",
                        "latitude": "42.68156000",
                        "longitude": "-4.34659000"
                    },
                    {
                        "id": 152563,
                        "name": "Puebla de Valdavia La",
                        "latitude": "42.67944970",
                        "longitude": "-4.58823920"
                    },
                    {
                        "id": 36506,
                        "name": "Quintana del Puente",
                        "latitude": "42.08471000",
                        "longitude": "-4.20649000"
                    },
                    {
                        "id": 36518,
                        "name": "Quintanilla de Onsoña",
                        "latitude": "42.46937000",
                        "longitude": "-4.66385000"
                    },
                    {
                        "id": 36570,
                        "name": "Reinoso de Cerrato",
                        "latitude": "41.97624000",
                        "longitude": "-4.38337000"
                    },
                    {
                        "id": 36577,
                        "name": "Renedo de la Vega",
                        "latitude": "42.45348000",
                        "longitude": "-4.70298000"
                    },
                    {
                        "id": 36582,
                        "name": "Requena de Campos",
                        "latitude": "42.30796000",
                        "longitude": "-4.34304000"
                    },
                    {
                        "id": 36583,
                        "name": "Respenda de la Peña",
                        "latitude": "42.76512000",
                        "longitude": "-4.68540000"
                    },
                    {
                        "id": 36594,
                        "name": "Revenga de Campos",
                        "latitude": "42.28401000",
                        "longitude": "-4.48218000"
                    },
                    {
                        "id": 36595,
                        "name": "Revilla de Collazos",
                        "latitude": "42.62960000",
                        "longitude": "-4.50343000"
                    },
                    {
                        "id": 36612,
                        "name": "Ribas de Campos",
                        "latitude": "42.15249000",
                        "longitude": "-4.51649000"
                    },
                    {
                        "id": 36616,
                        "name": "Riberos de la Cueza",
                        "latitude": "42.27881000",
                        "longitude": "-4.72503000"
                    },
                    {
                        "id": 36754,
                        "name": "Saldaña",
                        "latitude": "42.52146000",
                        "longitude": "-4.73605000"
                    },
                    {
                        "id": 36765,
                        "name": "Salinas de Pisuerga",
                        "latitude": "42.85046000",
                        "longitude": "-4.37783000"
                    },
                    {
                        "id": 36814,
                        "name": "San Cebrián de Campos",
                        "latitude": "42.20063000",
                        "longitude": "-4.53127000"
                    },
                    {
                        "id": 36817,
                        "name": "San Cebrián de Mudá",
                        "latitude": "42.89261000",
                        "longitude": "-4.38719000"
                    },
                    {
                        "id": 36819,
                        "name": "San Cristóbal de Boedo",
                        "latitude": "42.54194000",
                        "longitude": "-4.35325000"
                    },
                    {
                        "id": 36862,
                        "name": "San Mamés de Campos",
                        "latitude": "42.35512000",
                        "longitude": "-4.56565000"
                    },
                    {
                        "id": 36918,
                        "name": "San Román de la Cuba",
                        "latitude": "42.26257000",
                        "longitude": "-4.85724000"
                    },
                    {
                        "id": 37011,
                        "name": "Santa Cecilia del Alcor",
                        "latitude": "41.93227000",
                        "longitude": "-4.65546000"
                    },
                    {
                        "id": 37028,
                        "name": "Santa Cruz de Boedo",
                        "latitude": "42.52531000",
                        "longitude": "-4.37398000"
                    },
                    {
                        "id": 37111,
                        "name": "Santervás de la Vega",
                        "latitude": "42.50677000",
                        "longitude": "-4.80002000"
                    },
                    {
                        "id": 37121,
                        "name": "Santibáñez de Ecla",
                        "latitude": "42.70784000",
                        "longitude": "-4.37263000"
                    },
                    {
                        "id": 37125,
                        "name": "Santibáñez de la Peña",
                        "latitude": "42.80929000",
                        "longitude": "-4.73026000"
                    },
                    {
                        "id": 37149,
                        "name": "Santoyo",
                        "latitude": "42.21473000",
                        "longitude": "-4.34296000"
                    },
                    {
                        "id": 152564,
                        "name": "Serna La",
                        "latitude": "42.41615260",
                        "longitude": "-4.66408780"
                    },
                    {
                        "id": 37317,
                        "name": "Soto de Cerrato",
                        "latitude": "41.95312000",
                        "longitude": "-4.42998000"
                    },
                    {
                        "id": 37321,
                        "name": "Sotobañado y Priorato",
                        "latitude": "42.58987000",
                        "longitude": "-4.44185000"
                    },
                    {
                        "id": 37339,
                        "name": "Tabanera de Cerrato",
                        "latitude": "42.02469000",
                        "longitude": "-4.12361000"
                    },
                    {
                        "id": 37340,
                        "name": "Tabanera de Valdavia",
                        "latitude": "42.64728000",
                        "longitude": "-4.69414000"
                    },
                    {
                        "id": 152565,
                        "name": "Támara de Campos",
                        "latitude": "42.20348610",
                        "longitude": "-4.39313630"
                    },
                    {
                        "id": 152566,
                        "name": "Tariego de Cerrato",
                        "latitude": "41.90368070",
                        "longitude": "-4.48190740"
                    },
                    {
                        "id": 37477,
                        "name": "Torquemada",
                        "latitude": "42.03490000",
                        "longitude": "-4.31841000"
                    },
                    {
                        "id": 37563,
                        "name": "Torremormojón",
                        "latitude": "41.96018000",
                        "longitude": "-4.77765000"
                    },
                    {
                        "id": 37641,
                        "name": "Triollo",
                        "latitude": "42.92456000",
                        "longitude": "-4.68130000"
                    },
                    {
                        "id": 37724,
                        "name": "Valbuena de Pisuerga",
                        "latitude": "42.14584000",
                        "longitude": "-4.24010000"
                    },
                    {
                        "id": 152567,
                        "name": "Valde-Ucieza",
                        "latitude": "42.39130780",
                        "longitude": "-4.57275980"
                    },
                    {
                        "id": 37780,
                        "name": "Valdeolmillos",
                        "latitude": "42.04123000",
                        "longitude": "-4.40015000"
                    },
                    {
                        "id": 37798,
                        "name": "Valderrábano",
                        "latitude": "42.60674000",
                        "longitude": "-4.65584000"
                    },
                    {
                        "id": 37844,
                        "name": "Valle de Cerrato",
                        "latitude": "41.88045000",
                        "longitude": "-4.36243000"
                    },
                    {
                        "id": 152571,
                        "name": "Valle del Retortillo",
                        "latitude": "42.23502070",
                        "longitude": "-4.78987310"
                    },
                    {
                        "id": 37933,
                        "name": "Velilla del Río Carrión",
                        "latitude": "42.82611000",
                        "longitude": "-4.84626000"
                    },
                    {
                        "id": 37937,
                        "name": "Venta de Baños",
                        "latitude": "41.92110000",
                        "longitude": "-4.49089000"
                    },
                    {
                        "id": 37954,
                        "name": "Vertavillo",
                        "latitude": "41.83281000",
                        "longitude": "-4.32707000"
                    },
                    {
                        "id": 152561,
                        "name": "Vid de Ojeda La",
                        "latitude": "42.65991950",
                        "longitude": "-4.38542410"
                    },
                    {
                        "id": 152568,
                        "name": "Villabasta de Valdavia",
                        "latitude": "42.56074610",
                        "longitude": "-4.60262870"
                    },
                    {
                        "id": 38030,
                        "name": "Villacidaler",
                        "latitude": "42.22168000",
                        "longitude": "-4.97668000"
                    },
                    {
                        "id": 38033,
                        "name": "Villaconancio",
                        "latitude": "41.87174000",
                        "longitude": "-4.22379000"
                    },
                    {
                        "id": 38036,
                        "name": "Villada",
                        "latitude": "42.25111000",
                        "longitude": "-4.96708000"
                    },
                    {
                        "id": 38043,
                        "name": "Villaeles de Valdavia",
                        "latitude": "42.56556000",
                        "longitude": "-4.58318000"
                    },
                    {
                        "id": 38087,
                        "name": "Villahán",
                        "latitude": "42.05031000",
                        "longitude": "-4.13104000"
                    },
                    {
                        "id": 38085,
                        "name": "Villaherreros",
                        "latitude": "42.38964000",
                        "longitude": "-4.46254000"
                    },
                    {
                        "id": 38089,
                        "name": "Villalaco",
                        "latitude": "42.15569000",
                        "longitude": "-4.25940000"
                    },
                    {
                        "id": 38093,
                        "name": "Villalba de Guardo",
                        "latitude": "42.72229000",
                        "longitude": "-4.82328000"
                    },
                    {
                        "id": 38109,
                        "name": "Villalcázar de Sirga",
                        "latitude": "42.31662000",
                        "longitude": "-4.54278000"
                    },
                    {
                        "id": 38110,
                        "name": "Villalcón",
                        "latitude": "42.29287000",
                        "longitude": "-4.85527000"
                    },
                    {
                        "id": 38117,
                        "name": "Villalobón",
                        "latitude": "42.03037000",
                        "longitude": "-4.50340000"
                    },
                    {
                        "id": 38123,
                        "name": "Villaluenga de la Vega",
                        "latitude": "42.52386000",
                        "longitude": "-4.76489000"
                    },
                    {
                        "id": 38137,
                        "name": "Villamartín de Campos",
                        "latitude": "42.01598000",
                        "longitude": "-4.66414000"
                    },
                    {
                        "id": 38148,
                        "name": "Villamediana",
                        "latitude": "42.05024000",
                        "longitude": "-4.36115000"
                    },
                    {
                        "id": 38152,
                        "name": "Villameriel",
                        "latitude": "42.52822000",
                        "longitude": "-4.47572000"
                    },
                    {
                        "id": 38162,
                        "name": "Villamoronta",
                        "latitude": "42.40337000",
                        "longitude": "-4.69899000"
                    },
                    {
                        "id": 38164,
                        "name": "Villamuera de la Cueza",
                        "latitude": "42.25843000",
                        "longitude": "-4.68860000"
                    },
                    {
                        "id": 38166,
                        "name": "Villamuriel de Cerrato",
                        "latitude": "41.94935000",
                        "longitude": "-4.51584000"
                    },
                    {
                        "id": 38220,
                        "name": "Villanueva del Rebollar",
                        "latitude": "42.24114000",
                        "longitude": "-4.74288000"
                    },
                    {
                        "id": 38225,
                        "name": "Villanuño de Valdavia",
                        "latitude": "42.50775000",
                        "longitude": "-4.51887000"
                    },
                    {
                        "id": 38230,
                        "name": "Villaprovedo",
                        "latitude": "42.51674000",
                        "longitude": "-4.39645000"
                    },
                    {
                        "id": 38288,
                        "name": "Villarmentero de Campos",
                        "latitude": "42.29777000",
                        "longitude": "-4.49992000"
                    },
                    {
                        "id": 38292,
                        "name": "Villarrabé",
                        "latitude": "42.42090000",
                        "longitude": "-4.78445000"
                    },
                    {
                        "id": 38293,
                        "name": "Villarramiel",
                        "latitude": "42.04301000",
                        "longitude": "-4.91215000"
                    },
                    {
                        "id": 38313,
                        "name": "Villasarracino",
                        "latitude": "42.41207000",
                        "longitude": "-4.49633000"
                    },
                    {
                        "id": 38327,
                        "name": "Villasila de Valdavia",
                        "latitude": "42.53192000",
                        "longitude": "-4.55884000"
                    },
                    {
                        "id": 38335,
                        "name": "Villaturde",
                        "latitude": "42.37769000",
                        "longitude": "-4.67085000"
                    },
                    {
                        "id": 38337,
                        "name": "Villaumbrales",
                        "latitude": "42.08873000",
                        "longitude": "-4.61384000"
                    },
                    {
                        "id": 38361,
                        "name": "Villaviudas",
                        "latitude": "41.96227000",
                        "longitude": "-4.34200000"
                    },
                    {
                        "id": 152569,
                        "name": "Villerías de Campos",
                        "latitude": "41.94416120",
                        "longitude": "-4.85660100"
                    },
                    {
                        "id": 38370,
                        "name": "Villodre",
                        "latitude": "42.21161000",
                        "longitude": "-4.24484000"
                    },
                    {
                        "id": 38371,
                        "name": "Villodrigo",
                        "latitude": "42.14436000",
                        "longitude": "-4.09527000"
                    },
                    {
                        "id": 38372,
                        "name": "Villoldo",
                        "latitude": "42.24782000",
                        "longitude": "-4.59592000"
                    },
                    {
                        "id": 38378,
                        "name": "Villota del Páramo",
                        "latitude": "42.55234000",
                        "longitude": "-4.84893000"
                    },
                    {
                        "id": 38379,
                        "name": "Villovieco",
                        "latitude": "42.29478000",
                        "longitude": "-4.48122000"
                    }
                ]
            },
            {
                "id": 1167,
                "name": "Pontevedra",
                "iso2": "PO",
                "latitude": "42.43385950",
                "longitude": "-8.65685520",
                "type": "province",
                "cities": [
                    {
                        "id": 151151,
                        "name": "Agolada",
                        "latitude": "42.76170210",
                        "longitude": "-8.02061040"
                    },
                    {
                        "id": 32425,
                        "name": "Arbo",
                        "latitude": "42.11667000",
                        "longitude": "-8.31667000"
                    },
                    {
                        "id": 32616,
                        "name": "Baiona",
                        "latitude": "42.11667000",
                        "longitude": "-8.85000000"
                    },
                    {
                        "id": 151142,
                        "name": "Barro",
                        "latitude": "42.55414510",
                        "longitude": "-8.62209590"
                    },
                    {
                        "id": 33007,
                        "name": "Bueu",
                        "latitude": "42.32458000",
                        "longitude": "-8.78497000"
                    },
                    {
                        "id": 33137,
                        "name": "Caldas de Reis",
                        "latitude": "42.60473000",
                        "longitude": "-8.64230000"
                    },
                    {
                        "id": 33174,
                        "name": "Cambados",
                        "latitude": "42.51222000",
                        "longitude": "-8.81310000"
                    },
                    {
                        "id": 151143,
                        "name": "Campo Lameiro",
                        "latitude": "42.53997850",
                        "longitude": "-8.54400750"
                    },
                    {
                        "id": 151144,
                        "name": "Cangas",
                        "latitude": "42.26458450",
                        "longitude": "-8.78092820"
                    },
                    {
                        "id": 151145,
                        "name": "Cañiza A",
                        "latitude": "42.21288610",
                        "longitude": "-8.27297800"
                    },
                    {
                        "id": 33515,
                        "name": "Catoira",
                        "latitude": "42.66748000",
                        "longitude": "-8.72323000"
                    },
                    {
                        "id": 151146,
                        "name": "Cerdedo",
                        "latitude": "42.53219380",
                        "longitude": "-8.38949650"
                    },
                    {
                        "id": 151147,
                        "name": "Cotobade",
                        "latitude": "42.21893000",
                        "longitude": "-8.49312620"
                    },
                    {
                        "id": 33828,
                        "name": "Covelo",
                        "latitude": "42.23333000",
                        "longitude": "-8.35000000"
                    },
                    {
                        "id": 151148,
                        "name": "Crecente",
                        "latitude": "42.15034970",
                        "longitude": "-8.22369040"
                    },
                    {
                        "id": 33885,
                        "name": "Cuntis",
                        "latitude": "42.63396000",
                        "longitude": "-8.56256000"
                    },
                    {
                        "id": 33953,
                        "name": "Dozón",
                        "latitude": "42.58333000",
                        "longitude": "-8.01667000"
                    },
                    {
                        "id": 151149,
                        "name": "Estrada A",
                        "latitude": "42.68987120",
                        "longitude": "-8.49096670"
                    },
                    {
                        "id": 151150,
                        "name": "Forcarei",
                        "latitude": "42.58791090",
                        "longitude": "-8.35197130"
                    },
                    {
                        "id": 34226,
                        "name": "Fornelos de Montes",
                        "latitude": "42.34126000",
                        "longitude": "-8.45291000"
                    },
                    {
                        "id": 34483,
                        "name": "Gondomar",
                        "latitude": "42.11155000",
                        "longitude": "-8.74971000"
                    },
                    {
                        "id": 151152,
                        "name": "Grove O",
                        "latitude": "42.49599620",
                        "longitude": "-8.86514180"
                    },
                    {
                        "id": 151153,
                        "name": "Guarda A",
                        "latitude": "42.62084010",
                        "longitude": "-8.57210160"
                    },
                    {
                        "id": 151166,
                        "name": "Illa de Arousa A",
                        "latitude": "42.56179750",
                        "longitude": "-8.86815270"
                    },
                    {
                        "id": 34956,
                        "name": "Lalín",
                        "latitude": "42.66085000",
                        "longitude": "-8.11285000"
                    },
                    {
                        "id": 151154,
                        "name": "Lama A",
                        "latitude": "42.42114980",
                        "longitude": "-8.37457170"
                    },
                    {
                        "id": 35314,
                        "name": "Marín",
                        "latitude": "42.39145000",
                        "longitude": "-8.70136000"
                    },
                    {
                        "id": 35364,
                        "name": "Meaño",
                        "latitude": "42.44661000",
                        "longitude": "-8.78122000"
                    },
                    {
                        "id": 35382,
                        "name": "Meis",
                        "latitude": "42.50000000",
                        "longitude": "-8.75000000"
                    },
                    {
                        "id": 35459,
                        "name": "Moaña",
                        "latitude": "42.27807000",
                        "longitude": "-8.73921000"
                    },
                    {
                        "id": 35504,
                        "name": "Mondariz",
                        "latitude": "42.23110000",
                        "longitude": "-8.45839000"
                    },
                    {
                        "id": 35505,
                        "name": "Mondariz-Balneario",
                        "latitude": "42.22686000",
                        "longitude": "-8.46728000"
                    },
                    {
                        "id": 35621,
                        "name": "Moraña",
                        "latitude": "42.55000000",
                        "longitude": "-8.58333000"
                    },
                    {
                        "id": 35637,
                        "name": "Mos",
                        "latitude": "43.15667000",
                        "longitude": "-7.55047000"
                    },
                    {
                        "id": 151155,
                        "name": "Neves As",
                        "latitude": "42.11520440",
                        "longitude": "-8.40745730"
                    },
                    {
                        "id": 35808,
                        "name": "Nigrán",
                        "latitude": "42.14153000",
                        "longitude": "-8.80656000"
                    },
                    {
                        "id": 35848,
                        "name": "O Grove",
                        "latitude": "42.49444000",
                        "longitude": "-8.86502000"
                    },
                    {
                        "id": 35851,
                        "name": "O Rosal",
                        "latitude": "41.93536000",
                        "longitude": "-8.83677000"
                    },
                    {
                        "id": 35864,
                        "name": "Oia",
                        "latitude": "42.00000000",
                        "longitude": "-8.86667000"
                    },
                    {
                        "id": 151156,
                        "name": "Pazos de Borbén",
                        "latitude": "42.28189410",
                        "longitude": "-8.53914400"
                    },
                    {
                        "id": 36256,
                        "name": "Poio",
                        "latitude": "42.44775000",
                        "longitude": "-8.68594000"
                    },
                    {
                        "id": 151158,
                        "name": "Ponte Caldelas",
                        "latitude": "42.39031790",
                        "longitude": "-8.50277000"
                    },
                    {
                        "id": 36272,
                        "name": "Ponteareas",
                        "latitude": "42.17476000",
                        "longitude": "-8.50398000"
                    },
                    {
                        "id": 151159,
                        "name": "Pontecesures",
                        "latitude": "42.71784840",
                        "longitude": "-8.65170720"
                    },
                    {
                        "id": 36273,
                        "name": "Pontevedra",
                        "latitude": "42.43100000",
                        "longitude": "-8.64435000"
                    },
                    {
                        "id": 151157,
                        "name": "Porriño O",
                        "latitude": "42.16116100",
                        "longitude": "-8.61923160"
                    },
                    {
                        "id": 36286,
                        "name": "Portas",
                        "latitude": "42.58531000",
                        "longitude": "-8.65573000"
                    },
                    {
                        "id": 36561,
                        "name": "Redondela",
                        "latitude": "42.28337000",
                        "longitude": "-8.60960000"
                    },
                    {
                        "id": 36609,
                        "name": "Ribadumia",
                        "latitude": "42.51667000",
                        "longitude": "-8.75000000"
                    },
                    {
                        "id": 36663,
                        "name": "Rodeiro",
                        "latitude": "42.65193000",
                        "longitude": "-7.95519000"
                    },
                    {
                        "id": 151160,
                        "name": "Rosal O",
                        "latitude": "41.93724620",
                        "longitude": "-8.83637300"
                    },
                    {
                        "id": 151161,
                        "name": "Salceda de Caselas",
                        "latitude": "42.09993330",
                        "longitude": "-8.56005200"
                    },
                    {
                        "id": 151162,
                        "name": "Salvaterra de Miño",
                        "latitude": "42.08338360",
                        "longitude": "-8.50027770"
                    },
                    {
                        "id": 37157,
                        "name": "Sanxenxo",
                        "latitude": "42.39996000",
                        "longitude": "-8.80698000"
                    },
                    {
                        "id": 37256,
                        "name": "Silleda",
                        "latitude": "42.69605000",
                        "longitude": "-8.24653000"
                    },
                    {
                        "id": 151163,
                        "name": "Soutomaior",
                        "latitude": "42.33363590",
                        "longitude": "-8.56660770"
                    },
                    {
                        "id": 37451,
                        "name": "Tomiño",
                        "latitude": "41.98772000",
                        "longitude": "-8.75502000"
                    },
                    {
                        "id": 37651,
                        "name": "Tui",
                        "latitude": "42.04713000",
                        "longitude": "-8.64435000"
                    },
                    {
                        "id": 37828,
                        "name": "Valga",
                        "latitude": "42.69792000",
                        "longitude": "-8.63959000"
                    },
                    {
                        "id": 37970,
                        "name": "Vigo",
                        "latitude": "42.23282000",
                        "longitude": "-8.72264000"
                    },
                    {
                        "id": 151165,
                        "name": "Vila de Cruces",
                        "latitude": "42.79368830",
                        "longitude": "-8.16939910"
                    },
                    {
                        "id": 151164,
                        "name": "Vilaboa",
                        "latitude": "42.34893690",
                        "longitude": "-8.64374970"
                    },
                    {
                        "id": 37985,
                        "name": "Vilagarcía de Arousa",
                        "latitude": "42.59631000",
                        "longitude": "-8.76426000"
                    },
                    {
                        "id": 37994,
                        "name": "Vilanova de Arousa",
                        "latitude": "42.56400000",
                        "longitude": "-8.82797000"
                    },
                    {
                        "id": 38005,
                        "name": "Vilaxoán",
                        "latitude": "42.58353000",
                        "longitude": "-8.79353000"
                    }
                ]
            },
            {
                "id": 5338,
                "name": "Region of Murcia",
                "iso2": "MC",
                "latitude": "38.06365820",
                "longitude": "-2.15547250",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 1147,
                "name": "Salamanca",
                "iso2": "SA",
                "latitude": "40.95152630",
                "longitude": "-6.23759470",
                "type": "province",
                "cities": [
                    {
                        "id": 31919,
                        "name": "Abusejo",
                        "latitude": "40.70900000",
                        "longitude": "-6.14074000"
                    },
                    {
                        "id": 31945,
                        "name": "Agallas",
                        "latitude": "40.44867000",
                        "longitude": "-6.44176000"
                    },
                    {
                        "id": 31976,
                        "name": "Ahigal de los Aceiteros",
                        "latitude": "40.87231000",
                        "longitude": "-6.74702000"
                    },
                    {
                        "id": 31975,
                        "name": "Ahigal de Villarino",
                        "latitude": "41.15819000",
                        "longitude": "-6.38037000"
                    },
                    {
                        "id": 152501,
                        "name": "Alameda de Gardón La",
                        "latitude": "40.65060050",
                        "longitude": "-6.75809810"
                    },
                    {
                        "id": 152502,
                        "name": "Alamedilla La",
                        "latitude": "40.47221790",
                        "longitude": "-6.82806550"
                    },
                    {
                        "id": 32003,
                        "name": "Alaraz",
                        "latitude": "40.74886000",
                        "longitude": "-5.28781000"
                    },
                    {
                        "id": 32011,
                        "name": "Alba de Tormes",
                        "latitude": "40.82664000",
                        "longitude": "-5.51237000"
                    },
                    {
                        "id": 32012,
                        "name": "Alba de Yeltes",
                        "latitude": "40.67180000",
                        "longitude": "-6.31660000"
                    },
                    {
                        "id": 152503,
                        "name": "Alberca La",
                        "latitude": "40.48301250",
                        "longitude": "-6.12089260"
                    },
                    {
                        "id": 152504,
                        "name": "Alberguería de Argañán La",
                        "latitude": "40.41313450",
                        "longitude": "-6.81433390"
                    },
                    {
                        "id": 32113,
                        "name": "Alconada",
                        "latitude": "40.91092000",
                        "longitude": "-5.36305000"
                    },
                    {
                        "id": 32145,
                        "name": "Aldea del Obispo",
                        "latitude": "40.70677000",
                        "longitude": "-6.79253000"
                    },
                    {
                        "id": 32148,
                        "name": "Aldeacipreste",
                        "latitude": "40.38090000",
                        "longitude": "-5.89754000"
                    },
                    {
                        "id": 32149,
                        "name": "Aldeadávila de la Ribera",
                        "latitude": "41.21769000",
                        "longitude": "-6.61786000"
                    },
                    {
                        "id": 32152,
                        "name": "Aldealengua",
                        "latitude": "40.98090000",
                        "longitude": "-5.54922000"
                    },
                    {
                        "id": 32159,
                        "name": "Aldeanueva de Figueroa",
                        "latitude": "41.14809000",
                        "longitude": "-5.52404000"
                    },
                    {
                        "id": 32163,
                        "name": "Aldeanueva de la Sierra",
                        "latitude": "40.61620000",
                        "longitude": "-6.10023000"
                    },
                    {
                        "id": 32168,
                        "name": "Aldearrodrigo",
                        "latitude": "41.10966000",
                        "longitude": "-5.80726000"
                    },
                    {
                        "id": 32169,
                        "name": "Aldearrubia",
                        "latitude": "41.00807000",
                        "longitude": "-5.49829000"
                    },
                    {
                        "id": 32171,
                        "name": "Aldeaseca de Alba",
                        "latitude": "40.81909000",
                        "longitude": "-5.44699000"
                    },
                    {
                        "id": 32172,
                        "name": "Aldeaseca de la Frontera",
                        "latitude": "40.94161000",
                        "longitude": "-5.20719000"
                    },
                    {
                        "id": 32174,
                        "name": "Aldeatejada",
                        "latitude": "40.92168000",
                        "longitude": "-5.69273000"
                    },
                    {
                        "id": 32175,
                        "name": "Aldeavieja de Tormes",
                        "latitude": "40.58307000",
                        "longitude": "-5.61705000"
                    },
                    {
                        "id": 32178,
                        "name": "Aldehuela de la Bóveda",
                        "latitude": "40.85077000",
                        "longitude": "-6.05260000"
                    },
                    {
                        "id": 32177,
                        "name": "Aldehuela de Yeltes",
                        "latitude": "40.66254000",
                        "longitude": "-6.24332000"
                    },
                    {
                        "id": 32284,
                        "name": "Almenara de Tormes",
                        "latitude": "41.06390000",
                        "longitude": "-5.82350000"
                    },
                    {
                        "id": 32285,
                        "name": "Almendra",
                        "latitude": "41.22922000",
                        "longitude": "-6.34068000"
                    },
                    {
                        "id": 32367,
                        "name": "Anaya de Alba",
                        "latitude": "40.72828000",
                        "longitude": "-5.49266000"
                    },
                    {
                        "id": 32599,
                        "name": "Añover de Tormes",
                        "latitude": "41.13658000",
                        "longitude": "-5.91585000"
                    },
                    {
                        "id": 152505,
                        "name": "Arabayona de Mógica",
                        "latitude": "41.04842910",
                        "longitude": "-5.38741130"
                    },
                    {
                        "id": 32415,
                        "name": "Arapiles",
                        "latitude": "40.89366000",
                        "longitude": "-5.64494000"
                    },
                    {
                        "id": 32428,
                        "name": "Arcediano",
                        "latitude": "41.09379000",
                        "longitude": "-5.56055000"
                    },
                    {
                        "id": 152506,
                        "name": "Arco El",
                        "latitude": "41.11312950",
                        "longitude": "-5.82549440"
                    },
                    {
                        "id": 32487,
                        "name": "Armenteros",
                        "latitude": "40.59320000",
                        "longitude": "-5.44806000"
                    },
                    {
                        "id": 152508,
                        "name": "Atalaya La",
                        "latitude": "40.50860900",
                        "longitude": "-6.39708840"
                    },
                    {
                        "id": 32600,
                        "name": "Babilafuente",
                        "latitude": "40.97704000",
                        "longitude": "-5.42554000"
                    },
                    {
                        "id": 32702,
                        "name": "Bañobárez",
                        "latitude": "40.84825000",
                        "longitude": "-6.61311000"
                    },
                    {
                        "id": 152509,
                        "name": "Barbadillo",
                        "latitude": "40.93190170",
                        "longitude": "-5.88089550"
                    },
                    {
                        "id": 32644,
                        "name": "Barbalos",
                        "latitude": "40.67678000",
                        "longitude": "-5.94258000"
                    },
                    {
                        "id": 32654,
                        "name": "Barceo",
                        "latitude": "41.06108000",
                        "longitude": "-6.45175000"
                    },
                    {
                        "id": 32681,
                        "name": "Barruecopardo",
                        "latitude": "41.07215000",
                        "longitude": "-6.66423000"
                    },
                    {
                        "id": 152510,
                        "name": "Bastida La",
                        "latitude": "40.58540180",
                        "longitude": "-6.05898470"
                    },
                    {
                        "id": 33058,
                        "name": "Béjar",
                        "latitude": "40.38641000",
                        "longitude": "-5.76341000"
                    },
                    {
                        "id": 32738,
                        "name": "Beleña",
                        "latitude": "40.75067000",
                        "longitude": "-5.62713000"
                    },
                    {
                        "id": 32858,
                        "name": "Bermellar",
                        "latitude": "40.99918000",
                        "longitude": "-6.67014000"
                    },
                    {
                        "id": 32869,
                        "name": "Berrocal de Huebra",
                        "latitude": "40.71864000",
                        "longitude": "-6.00054000"
                    },
                    {
                        "id": 32870,
                        "name": "Berrocal de Salvatierra",
                        "latitude": "40.63331000",
                        "longitude": "-5.69005000"
                    },
                    {
                        "id": 32914,
                        "name": "Boada",
                        "latitude": "40.81569000",
                        "longitude": "-6.30611000"
                    },
                    {
                        "id": 152511,
                        "name": "Bodón El",
                        "latitude": "40.48785100",
                        "longitude": "-6.57500220"
                    },
                    {
                        "id": 32929,
                        "name": "Bogajo",
                        "latitude": "40.90710000",
                        "longitude": "-6.53065000"
                    },
                    {
                        "id": 152512,
                        "name": "Bouza La",
                        "latitude": "40.83630880",
                        "longitude": "-6.79558320"
                    },
                    {
                        "id": 33063,
                        "name": "Bóveda del Río Almar",
                        "latitude": "40.85719000",
                        "longitude": "-5.21030000"
                    },
                    {
                        "id": 32987,
                        "name": "Brincones",
                        "latitude": "41.11339000",
                        "longitude": "-6.34865000"
                    },
                    {
                        "id": 33001,
                        "name": "Buenamadre",
                        "latitude": "40.85705000",
                        "longitude": "-6.24987000"
                    },
                    {
                        "id": 33003,
                        "name": "Buenavista",
                        "latitude": "40.76763000",
                        "longitude": "-5.61139000"
                    },
                    {
                        "id": 152513,
                        "name": "Cabaco El",
                        "latitude": "40.97010390",
                        "longitude": "-5.66353970"
                    },
                    {
                        "id": 152514,
                        "name": "Cabeza de Béjar La",
                        "latitude": "40.50134550",
                        "longitude": "-5.66157100"
                    },
                    {
                        "id": 33078,
                        "name": "Cabeza del Caballo",
                        "latitude": "41.12982000",
                        "longitude": "-6.55742000"
                    },
                    {
                        "id": 33081,
                        "name": "Cabezabellosa de la Calzada",
                        "latitude": "41.04395000",
                        "longitude": "-5.48866000"
                    },
                    {
                        "id": 33105,
                        "name": "Cabrerizos",
                        "latitude": "40.97808000",
                        "longitude": "-5.60907000"
                    },
                    {
                        "id": 33110,
                        "name": "Cabrillas",
                        "latitude": "40.73977000",
                        "longitude": "-6.17873000"
                    },
                    {
                        "id": 33153,
                        "name": "Calvarrasa de Abajo",
                        "latitude": "40.94638000",
                        "longitude": "-5.55258000"
                    },
                    {
                        "id": 33154,
                        "name": "Calvarrasa de Arriba",
                        "latitude": "40.90672000",
                        "longitude": "-5.59199000"
                    },
                    {
                        "id": 152515,
                        "name": "Calzada de Béjar La",
                        "latitude": "40.41175350",
                        "longitude": "-5.81758420"
                    },
                    {
                        "id": 33157,
                        "name": "Calzada de Don Diego",
                        "latitude": "40.90500000",
                        "longitude": "-5.90279000"
                    },
                    {
                        "id": 33158,
                        "name": "Calzada de Valdunciel",
                        "latitude": "41.08663000",
                        "longitude": "-5.70219000"
                    },
                    {
                        "id": 33190,
                        "name": "Campillo de Azaba",
                        "latitude": "40.50951000",
                        "longitude": "-6.68705000"
                    },
                    {
                        "id": 152516,
                        "name": "Campo de Peñaranda El",
                        "latitude": "40.98464870",
                        "longitude": "-5.25734400"
                    },
                    {
                        "id": 33227,
                        "name": "Candelario",
                        "latitude": "40.36806000",
                        "longitude": "-5.74499000"
                    },
                    {
                        "id": 33240,
                        "name": "Canillas de Abajo",
                        "latitude": "40.92266000",
                        "longitude": "-5.92905000"
                    },
                    {
                        "id": 33249,
                        "name": "Cantagallo",
                        "latitude": "40.37239000",
                        "longitude": "-5.81890000"
                    },
                    {
                        "id": 33250,
                        "name": "Cantalapiedra",
                        "latitude": "41.12630000",
                        "longitude": "-5.18351000"
                    },
                    {
                        "id": 33254,
                        "name": "Cantalpino",
                        "latitude": "41.05341000",
                        "longitude": "-5.33045000"
                    },
                    {
                        "id": 33255,
                        "name": "Cantaracillo",
                        "latitude": "40.90376000",
                        "longitude": "-5.16291000"
                    },
                    {
                        "id": 33281,
                        "name": "Carbajosa de la Sagrada",
                        "latitude": "40.93305000",
                        "longitude": "-5.65026000"
                    },
                    {
                        "id": 33314,
                        "name": "Carpio de Azaba",
                        "latitude": "40.59602000",
                        "longitude": "-6.64680000"
                    },
                    {
                        "id": 33318,
                        "name": "Carrascal de Barregas",
                        "latitude": "40.97868000",
                        "longitude": "-5.76227000"
                    },
                    {
                        "id": 33319,
                        "name": "Carrascal del Obispo",
                        "latitude": "40.76376000",
                        "longitude": "-5.99913000"
                    },
                    {
                        "id": 33344,
                        "name": "Casafranca",
                        "latitude": "40.59267000",
                        "longitude": "-5.76039000"
                    },
                    {
                        "id": 152517,
                        "name": "Casas del Conde Las",
                        "latitude": "40.50759830",
                        "longitude": "-6.04158850"
                    },
                    {
                        "id": 33390,
                        "name": "Casillas de Flores",
                        "latitude": "40.38108000",
                        "longitude": "-6.75602000"
                    },
                    {
                        "id": 33415,
                        "name": "Castellanos de Moriscos",
                        "latitude": "41.01917000",
                        "longitude": "-5.59065000"
                    },
                    {
                        "id": 33416,
                        "name": "Castellanos de Villiquera",
                        "latitude": "41.05139000",
                        "longitude": "-5.69477000"
                    },
                    {
                        "id": 33458,
                        "name": "Castillejo de Martín Viejo",
                        "latitude": "40.69728000",
                        "longitude": "-6.63763000"
                    },
                    {
                        "id": 33471,
                        "name": "Castraz",
                        "latitude": "40.70517000",
                        "longitude": "-6.33383000"
                    },
                    {
                        "id": 33576,
                        "name": "Cepeda",
                        "latitude": "40.46600000",
                        "longitude": "-6.04100000"
                    },
                    {
                        "id": 33583,
                        "name": "Cereceda de la Sierra",
                        "latitude": "40.56627000",
                        "longitude": "-6.09140000"
                    },
                    {
                        "id": 33586,
                        "name": "Cerezal de Peñahorcada",
                        "latitude": "41.13071000",
                        "longitude": "-6.65357000"
                    },
                    {
                        "id": 33591,
                        "name": "Cerralbo",
                        "latitude": "40.97347000",
                        "longitude": "-6.58710000"
                    },
                    {
                        "id": 152518,
                        "name": "Cerro El",
                        "latitude": "40.32668200",
                        "longitude": "-5.91653750"
                    },
                    {
                        "id": 152519,
                        "name": "Cespedosa de Tormes",
                        "latitude": "40.54393940",
                        "longitude": "-5.58076380"
                    },
                    {
                        "id": 152521,
                        "name": "Chagarcía Medianero",
                        "latitude": "40.64962540",
                        "longitude": "-5.38152250"
                    },
                    {
                        "id": 33668,
                        "name": "Cilleros de la Bastida",
                        "latitude": "40.57614000",
                        "longitude": "-6.06094000"
                    },
                    {
                        "id": 33680,
                        "name": "Cipérez",
                        "latitude": "40.96210000",
                        "longitude": "-6.26552000"
                    },
                    {
                        "id": 33698,
                        "name": "Ciudad Rodrigo",
                        "latitude": "40.60000000",
                        "longitude": "-6.53333000"
                    },
                    {
                        "id": 33715,
                        "name": "Coca de Alba",
                        "latitude": "40.87833000",
                        "longitude": "-5.36537000"
                    },
                    {
                        "id": 33743,
                        "name": "Colmenar de Montemayor",
                        "latitude": "40.39957000",
                        "longitude": "-5.95618000"
                    },
                    {
                        "id": 33781,
                        "name": "Cordovilla",
                        "latitude": "40.95095000",
                        "longitude": "-5.40725000"
                    },
                    {
                        "id": 33837,
                        "name": "Cristóbal",
                        "latitude": "40.46923000",
                        "longitude": "-5.88967000"
                    },
                    {
                        "id": 152520,
                        "name": "Cubo de Don Sancho El",
                        "latitude": "40.89122940",
                        "longitude": "-6.30532970"
                    },
                    {
                        "id": 33935,
                        "name": "Dios le Guarde",
                        "latitude": "40.64283000",
                        "longitude": "-6.31511000"
                    },
                    {
                        "id": 33955,
                        "name": "Doñinos de Ledesma",
                        "latitude": "41.01251000",
                        "longitude": "-6.03412000"
                    },
                    {
                        "id": 33956,
                        "name": "Doñinos de Salamanca",
                        "latitude": "40.95978000",
                        "longitude": "-5.74349000"
                    },
                    {
                        "id": 33975,
                        "name": "Ejeme",
                        "latitude": "40.76685000",
                        "longitude": "-5.53828000"
                    },
                    {
                        "id": 34044,
                        "name": "Encina de San Silvestre",
                        "latitude": "41.01442000",
                        "longitude": "-6.09268000"
                    },
                    {
                        "id": 152522,
                        "name": "Encina La",
                        "latitude": "40.51635500",
                        "longitude": "-6.53031020"
                    },
                    {
                        "id": 34048,
                        "name": "Encinas de Abajo",
                        "latitude": "40.93493000",
                        "longitude": "-5.47037000"
                    },
                    {
                        "id": 34049,
                        "name": "Encinas de Arriba",
                        "latitude": "40.77120000",
                        "longitude": "-5.55661000"
                    },
                    {
                        "id": 34052,
                        "name": "Encinasola de los Comendadores",
                        "latitude": "41.03089000",
                        "longitude": "-6.53261000"
                    },
                    {
                        "id": 34057,
                        "name": "Endrinal",
                        "latitude": "40.59109000",
                        "longitude": "-5.80411000"
                    },
                    {
                        "id": 34093,
                        "name": "Escurial de la Sierra",
                        "latitude": "40.61731000",
                        "longitude": "-5.95520000"
                    },
                    {
                        "id": 34101,
                        "name": "Espadaña",
                        "latitude": "41.06085000",
                        "longitude": "-6.28457000"
                    },
                    {
                        "id": 34110,
                        "name": "Espeja",
                        "latitude": "40.56565000",
                        "longitude": "-6.71582000"
                    },
                    {
                        "id": 34117,
                        "name": "Espino de la Orbada",
                        "latitude": "41.10693000",
                        "longitude": "-5.42515000"
                    },
                    {
                        "id": 34197,
                        "name": "Florida de Liébana",
                        "latitude": "41.02361000",
                        "longitude": "-5.76252000"
                    },
                    {
                        "id": 34221,
                        "name": "Forfoleda",
                        "latitude": "41.09779000",
                        "longitude": "-5.74979000"
                    },
                    {
                        "id": 34236,
                        "name": "Frades de la Sierra",
                        "latitude": "40.65687000",
                        "longitude": "-5.78223000"
                    },
                    {
                        "id": 152523,
                        "name": "Fregeneda La",
                        "latitude": "40.98801120",
                        "longitude": "-6.86659650"
                    },
                    {
                        "id": 34250,
                        "name": "Fresnedoso",
                        "latitude": "40.43619000",
                        "longitude": "-5.70969000"
                    },
                    {
                        "id": 152524,
                        "name": "Fresno Alhándiga",
                        "latitude": "40.71307930",
                        "longitude": "-5.61520210"
                    },
                    {
                        "id": 152525,
                        "name": "Fuente de San Esteban La",
                        "latitude": "40.80061560",
                        "longitude": "-6.25750910"
                    },
                    {
                        "id": 34315,
                        "name": "Fuenteguinaldo",
                        "latitude": "40.42876000",
                        "longitude": "-6.67528000"
                    },
                    {
                        "id": 152526,
                        "name": "Fuenteliante",
                        "latitude": "40.84259290",
                        "longitude": "-6.56766250"
                    },
                    {
                        "id": 34333,
                        "name": "Fuenterroble de Salvatierra",
                        "latitude": "40.56466000",
                        "longitude": "-5.73379000"
                    },
                    {
                        "id": 34341,
                        "name": "Fuentes de Béjar",
                        "latitude": "40.50815000",
                        "longitude": "-5.69270000"
                    },
                    {
                        "id": 34348,
                        "name": "Fuentes de Oñoro",
                        "latitude": "40.59102000",
                        "longitude": "-6.81144000"
                    },
                    {
                        "id": 34372,
                        "name": "Gajates",
                        "latitude": "40.78254000",
                        "longitude": "-5.36506000"
                    },
                    {
                        "id": 34382,
                        "name": "Galindo y Perahuy",
                        "latitude": "40.94397000",
                        "longitude": "-5.87410000"
                    },
                    {
                        "id": 34383,
                        "name": "Galinduste",
                        "latitude": "40.66266000",
                        "longitude": "-5.54003000"
                    },
                    {
                        "id": 34384,
                        "name": "Galisancho",
                        "latitude": "40.74418000",
                        "longitude": "-5.55471000"
                    },
                    {
                        "id": 34387,
                        "name": "Gallegos de Argañán",
                        "latitude": "40.63146000",
                        "longitude": "-6.70246000"
                    },
                    {
                        "id": 152527,
                        "name": "Gallegos de Solmirón",
                        "latitude": "40.53605130",
                        "longitude": "-5.46729620"
                    },
                    {
                        "id": 34409,
                        "name": "Garcibuey",
                        "latitude": "40.51552000",
                        "longitude": "-5.99439000"
                    },
                    {
                        "id": 34410,
                        "name": "Garcihernández",
                        "latitude": "40.86096000",
                        "longitude": "-5.43567000"
                    },
                    {
                        "id": 34412,
                        "name": "Garcirrey",
                        "latitude": "40.90049000",
                        "longitude": "-6.13120000"
                    },
                    {
                        "id": 34444,
                        "name": "Gejuelo del Barro",
                        "latitude": "41.07633000",
                        "longitude": "-6.12332000"
                    },
                    {
                        "id": 34481,
                        "name": "Golpejas",
                        "latitude": "40.99981000",
                        "longitude": "-5.90687000"
                    },
                    {
                        "id": 34482,
                        "name": "Gomecello",
                        "latitude": "41.04280000",
                        "longitude": "-5.53585000"
                    },
                    {
                        "id": 34532,
                        "name": "Guadramiro",
                        "latitude": "41.01703000",
                        "longitude": "-6.49369000"
                    },
                    {
                        "id": 34546,
                        "name": "Guijo de Ávila",
                        "latitude": "40.53078000",
                        "longitude": "-5.63970000"
                    },
                    {
                        "id": 34547,
                        "name": "Guijuelo",
                        "latitude": "40.55757000",
                        "longitude": "-5.67067000"
                    },
                    {
                        "id": 34583,
                        "name": "Herguijuela de Ciudad Rodrigo",
                        "latitude": "40.45860000",
                        "longitude": "-6.52075000"
                    },
                    {
                        "id": 34584,
                        "name": "Herguijuela de la Sierra",
                        "latitude": "40.44535000",
                        "longitude": "-6.07445000"
                    },
                    {
                        "id": 34585,
                        "name": "Herguijuela del Campo",
                        "latitude": "40.63102000",
                        "longitude": "-5.86398000"
                    },
                    {
                        "id": 34623,
                        "name": "Hinojosa de Duero",
                        "latitude": "40.98674000",
                        "longitude": "-6.79529000"
                    },
                    {
                        "id": 34650,
                        "name": "Horcajo de Montemayor",
                        "latitude": "40.42265000",
                        "longitude": "-5.89427000"
                    },
                    {
                        "id": 152528,
                        "name": "Horcajo Medianero",
                        "latitude": "40.63900510",
                        "longitude": "-5.40573580"
                    },
                    {
                        "id": 152529,
                        "name": "Hoya La",
                        "latitude": "40.40719210",
                        "longitude": "-5.69872690"
                    },
                    {
                        "id": 152530,
                        "name": "Huerta",
                        "latitude": "40.96838410",
                        "longitude": "-5.46777690"
                    },
                    {
                        "id": 34760,
                        "name": "Iruelos",
                        "latitude": "41.14135000",
                        "longitude": "-6.32808000"
                    },
                    {
                        "id": 34772,
                        "name": "Ituero de Azaba",
                        "latitude": "40.48487000",
                        "longitude": "-6.69272000"
                    },
                    {
                        "id": 34835,
                        "name": "Juzbado",
                        "latitude": "41.07791000",
                        "longitude": "-5.86140000"
                    },
                    {
                        "id": 34952,
                        "name": "Lagunilla",
                        "latitude": "40.32491000",
                        "longitude": "-5.97132000"
                    },
                    {
                        "id": 34981,
                        "name": "Larrodrigo",
                        "latitude": "40.73722000",
                        "longitude": "-5.44895000"
                    },
                    {
                        "id": 35016,
                        "name": "Ledesma",
                        "latitude": "41.08829000",
                        "longitude": "-6.00178000"
                    },
                    {
                        "id": 35019,
                        "name": "Ledrada",
                        "latitude": "40.46878000",
                        "longitude": "-5.72038000"
                    },
                    {
                        "id": 35054,
                        "name": "Linares de Riofrío",
                        "latitude": "40.58338000",
                        "longitude": "-5.92091000"
                    },
                    {
                        "id": 35163,
                        "name": "Lumbrales",
                        "latitude": "40.93501000",
                        "longitude": "-6.71948000"
                    },
                    {
                        "id": 35182,
                        "name": "Machacón",
                        "latitude": "40.92623000",
                        "longitude": "-5.52430000"
                    },
                    {
                        "id": 35183,
                        "name": "Macotera",
                        "latitude": "40.83105000",
                        "longitude": "-5.28526000"
                    },
                    {
                        "id": 35195,
                        "name": "Madroñal",
                        "latitude": "40.46407000",
                        "longitude": "-6.06271000"
                    },
                    {
                        "id": 152531,
                        "name": "Maíllo El",
                        "latitude": "40.56628660",
                        "longitude": "-6.18087380"
                    },
                    {
                        "id": 35225,
                        "name": "Malpartida",
                        "latitude": "40.76269000",
                        "longitude": "-5.23149000"
                    },
                    {
                        "id": 35240,
                        "name": "Mancera de Abajo",
                        "latitude": "40.83974000",
                        "longitude": "-5.19933000"
                    },
                    {
                        "id": 152532,
                        "name": "Manzano El",
                        "latitude": "41.17401000",
                        "longitude": "-6.28872110"
                    },
                    {
                        "id": 35298,
                        "name": "Martiago",
                        "latitude": "40.45420000",
                        "longitude": "-6.49010000"
                    },
                    {
                        "id": 35306,
                        "name": "Martín de Yeltes",
                        "latitude": "40.77594000",
                        "longitude": "-6.29162000"
                    },
                    {
                        "id": 35300,
                        "name": "Martinamor",
                        "latitude": "40.80676000",
                        "longitude": "-5.59913000"
                    },
                    {
                        "id": 35328,
                        "name": "Masueco",
                        "latitude": "41.20352000",
                        "longitude": "-6.58938000"
                    },
                    {
                        "id": 152533,
                        "name": "Mata de Ledesma La",
                        "latitude": "41.00052450",
                        "longitude": "-5.97103110"
                    },
                    {
                        "id": 35344,
                        "name": "Matilla de los Caños del Río",
                        "latitude": "40.82539000",
                        "longitude": "-5.94276000"
                    },
                    {
                        "id": 152534,
                        "name": "Maya La",
                        "latitude": "40.68838100",
                        "longitude": "-5.61688340"
                    },
                    {
                        "id": 35394,
                        "name": "Membribe de la Sierra",
                        "latitude": "40.69123000",
                        "longitude": "-5.80568000"
                    },
                    {
                        "id": 35422,
                        "name": "Mieza",
                        "latitude": "41.16424000",
                        "longitude": "-6.69137000"
                    },
                    {
                        "id": 152535,
                        "name": "Milano El",
                        "latitude": "41.09273770",
                        "longitude": "-6.59902880"
                    },
                    {
                        "id": 35449,
                        "name": "Miranda de Azán",
                        "latitude": "40.88752000",
                        "longitude": "-5.68182000"
                    },
                    {
                        "id": 35451,
                        "name": "Miranda del Castañar",
                        "latitude": "40.48448000",
                        "longitude": "-5.99581000"
                    },
                    {
                        "id": 35466,
                        "name": "Mogarraz",
                        "latitude": "40.49264000",
                        "longitude": "-6.05327000"
                    },
                    {
                        "id": 35481,
                        "name": "Molinillo",
                        "latitude": "40.46898000",
                        "longitude": "-5.94493000"
                    },
                    {
                        "id": 35515,
                        "name": "Monforte de la Sierra",
                        "latitude": "40.48264000",
                        "longitude": "-6.05671000"
                    },
                    {
                        "id": 35519,
                        "name": "Monleón",
                        "latitude": "40.58192000",
                        "longitude": "-5.84312000"
                    },
                    {
                        "id": 35518,
                        "name": "Monleras",
                        "latitude": "41.18704000",
                        "longitude": "-6.22622000"
                    },
                    {
                        "id": 35525,
                        "name": "Monsagro",
                        "latitude": "40.50343000",
                        "longitude": "-6.27110000"
                    },
                    {
                        "id": 35552,
                        "name": "Montejo",
                        "latitude": "40.63246000",
                        "longitude": "-5.62287000"
                    },
                    {
                        "id": 35560,
                        "name": "Montemayor del Río",
                        "latitude": "40.34836000",
                        "longitude": "-5.89427000"
                    },
                    {
                        "id": 35567,
                        "name": "Monterrubio de Armuña",
                        "latitude": "41.02651000",
                        "longitude": "-5.64389000"
                    },
                    {
                        "id": 35569,
                        "name": "Monterrubio de la Sierra",
                        "latitude": "40.75592000",
                        "longitude": "-5.69329000"
                    },
                    {
                        "id": 35613,
                        "name": "Morasverdes",
                        "latitude": "40.60019000",
                        "longitude": "-6.27503000"
                    },
                    {
                        "id": 35630,
                        "name": "Morille",
                        "latitude": "40.80693000",
                        "longitude": "-5.69833000"
                    },
                    {
                        "id": 152536,
                        "name": "Moríñigo",
                        "latitude": "40.96984480",
                        "longitude": "-5.41424560"
                    },
                    {
                        "id": 35631,
                        "name": "Moriscos",
                        "latitude": "41.00818000",
                        "longitude": "-5.58184000"
                    },
                    {
                        "id": 35632,
                        "name": "Moronta",
                        "latitude": "40.97688000",
                        "longitude": "-6.43103000"
                    },
                    {
                        "id": 35651,
                        "name": "Mozárbez",
                        "latitude": "40.85652000",
                        "longitude": "-5.65144000"
                    },
                    {
                        "id": 35716,
                        "name": "Narros de Matalayegua",
                        "latitude": "40.69880000",
                        "longitude": "-5.92658000"
                    },
                    {
                        "id": 35722,
                        "name": "Nava de Béjar",
                        "latitude": "40.47518000",
                        "longitude": "-5.67856000"
                    },
                    {
                        "id": 35723,
                        "name": "Nava de Francia",
                        "latitude": "40.53572000",
                        "longitude": "-6.11628000"
                    },
                    {
                        "id": 35725,
                        "name": "Nava de Sotrobal",
                        "latitude": "40.89039000",
                        "longitude": "-5.28562000"
                    },
                    {
                        "id": 35729,
                        "name": "Navacarros",
                        "latitude": "40.39776000",
                        "longitude": "-5.71425000"
                    },
                    {
                        "id": 35747,
                        "name": "Navales",
                        "latitude": "40.78857000",
                        "longitude": "-5.47863000"
                    },
                    {
                        "id": 35751,
                        "name": "Navalmoral de Béjar",
                        "latitude": "40.42264000",
                        "longitude": "-5.78310000"
                    },
                    {
                        "id": 35762,
                        "name": "Navamorales",
                        "latitude": "40.47618000",
                        "longitude": "-5.47893000"
                    },
                    {
                        "id": 35772,
                        "name": "Navarredonda de la Rinconada",
                        "latitude": "40.60657000",
                        "longitude": "-6.01169000"
                    },
                    {
                        "id": 35785,
                        "name": "Navasfrías",
                        "latitude": "40.29679000",
                        "longitude": "-6.81975000"
                    },
                    {
                        "id": 35798,
                        "name": "Negrilla de Palencia",
                        "latitude": "41.09185000",
                        "longitude": "-5.59165000"
                    },
                    {
                        "id": 35902,
                        "name": "Olmedo de Camaces",
                        "latitude": "40.87967000",
                        "longitude": "-6.62360000"
                    },
                    {
                        "id": 152537,
                        "name": "Orbada La",
                        "latitude": "41.10354440",
                        "longitude": "-5.48367970"
                    },
                    {
                        "id": 36001,
                        "name": "Pajares de la Laguna",
                        "latitude": "41.08754000",
                        "longitude": "-5.50888000"
                    },
                    {
                        "id": 36010,
                        "name": "Palacios del Arzobispo",
                        "latitude": "41.16655000",
                        "longitude": "-5.88933000"
                    },
                    {
                        "id": 36013,
                        "name": "Palaciosrubios",
                        "latitude": "41.05238000",
                        "longitude": "-5.19507000"
                    },
                    {
                        "id": 36023,
                        "name": "Palencia de Negrilla",
                        "latitude": "41.09439000",
                        "longitude": "-5.60168000"
                    },
                    {
                        "id": 36056,
                        "name": "Parada de Arriba",
                        "latitude": "40.98655000",
                        "longitude": "-5.79332000"
                    },
                    {
                        "id": 36057,
                        "name": "Parada de Rubiales",
                        "latitude": "41.14818000",
                        "longitude": "-5.43638000"
                    },
                    {
                        "id": 36060,
                        "name": "Paradinas de San Juan",
                        "latitude": "40.98325000",
                        "longitude": "-5.15418000"
                    },
                    {
                        "id": 36074,
                        "name": "Pastores",
                        "latitude": "40.51508000",
                        "longitude": "-6.51018000"
                    },
                    {
                        "id": 152538,
                        "name": "Payo El",
                        "latitude": "40.28745490",
                        "longitude": "-6.72732290"
                    },
                    {
                        "id": 36093,
                        "name": "Pedraza de Alba",
                        "latitude": "40.75502000",
                        "longitude": "-5.37524000"
                    },
                    {
                        "id": 36109,
                        "name": "Pedrosillo de Alba",
                        "latitude": "40.82277000",
                        "longitude": "-5.39506000"
                    },
                    {
                        "id": 36110,
                        "name": "Pedrosillo de los Aires",
                        "latitude": "40.71524000",
                        "longitude": "-5.70511000"
                    },
                    {
                        "id": 36111,
                        "name": "Pedrosillo el Ralo",
                        "latitude": "41.06305000",
                        "longitude": "-5.54794000"
                    },
                    {
                        "id": 152539,
                        "name": "Pedroso de la Armuña El",
                        "latitude": "41.07987980",
                        "longitude": "-5.39984520"
                    },
                    {
                        "id": 36118,
                        "name": "Pelabravo",
                        "latitude": "40.93658000",
                        "longitude": "-5.57916000"
                    },
                    {
                        "id": 36120,
                        "name": "Pelarrodríguez",
                        "latitude": "40.88723000",
                        "longitude": "-6.21271000"
                    },
                    {
                        "id": 36121,
                        "name": "Pelayos",
                        "latitude": "40.64985000",
                        "longitude": "-5.57580000"
                    },
                    {
                        "id": 152540,
                        "name": "Peña La",
                        "latitude": "41.17376640",
                        "longitude": "-6.51875450"
                    },
                    {
                        "id": 36161,
                        "name": "Peñacaballera",
                        "latitude": "40.34353000",
                        "longitude": "-5.86121000"
                    },
                    {
                        "id": 36170,
                        "name": "Peñaparda",
                        "latitude": "40.32093000",
                        "longitude": "-6.66948000"
                    },
                    {
                        "id": 36171,
                        "name": "Peñaranda de Bracamonte",
                        "latitude": "40.90108000",
                        "longitude": "-5.20026000"
                    },
                    {
                        "id": 36173,
                        "name": "Peñarandilla",
                        "latitude": "40.88348000",
                        "longitude": "-5.39360000"
                    },
                    {
                        "id": 36135,
                        "name": "Peralejos de Abajo",
                        "latitude": "41.00469000",
                        "longitude": "-6.36238000"
                    },
                    {
                        "id": 36136,
                        "name": "Peralejos de Arriba",
                        "latitude": "41.00410000",
                        "longitude": "-6.33362000"
                    },
                    {
                        "id": 152541,
                        "name": "Pereña de la Ribera",
                        "latitude": "41.23790750",
                        "longitude": "-6.52364240"
                    },
                    {
                        "id": 36151,
                        "name": "Peromingo",
                        "latitude": "40.46386000",
                        "longitude": "-5.77238000"
                    },
                    {
                        "id": 36199,
                        "name": "Pinedas",
                        "latitude": "40.44493000",
                        "longitude": "-5.96025000"
                    },
                    {
                        "id": 152542,
                        "name": "Pino de Tormes El",
                        "latitude": "41.03947080",
                        "longitude": "-5.79254190"
                    },
                    {
                        "id": 36222,
                        "name": "Pitiegua",
                        "latitude": "41.06210000",
                        "longitude": "-5.46647000"
                    },
                    {
                        "id": 36225,
                        "name": "Pizarral",
                        "latitude": "40.61450000",
                        "longitude": "-5.65238000"
                    },
                    {
                        "id": 36308,
                        "name": "Poveda de las Cintas",
                        "latitude": "41.04596000",
                        "longitude": "-5.26019000"
                    },
                    {
                        "id": 36327,
                        "name": "Pozos de Hinojo",
                        "latitude": "40.91303000",
                        "longitude": "-6.41144000"
                    },
                    {
                        "id": 36413,
                        "name": "Puebla de Azaba",
                        "latitude": "40.44732000",
                        "longitude": "-6.74616000"
                    },
                    {
                        "id": 36421,
                        "name": "Puebla de San Medel",
                        "latitude": "40.51073000",
                        "longitude": "-5.73673000"
                    },
                    {
                        "id": 36425,
                        "name": "Puebla de Yeltes",
                        "latitude": "40.62528000",
                        "longitude": "-6.18150000"
                    },
                    {
                        "id": 36438,
                        "name": "Puente del Congosto",
                        "latitude": "40.49041000",
                        "longitude": "-5.52628000"
                    },
                    {
                        "id": 36443,
                        "name": "Puertas",
                        "latitude": "41.09681000",
                        "longitude": "-6.28752000"
                    },
                    {
                        "id": 36451,
                        "name": "Puerto de Béjar",
                        "latitude": "40.35052000",
                        "longitude": "-5.83756000"
                    },
                    {
                        "id": 36449,
                        "name": "Puerto Seguro",
                        "latitude": "40.82718000",
                        "longitude": "-6.76109000"
                    },
                    {
                        "id": 36713,
                        "name": "Rágama",
                        "latitude": "40.99768000",
                        "longitude": "-5.12724000"
                    },
                    {
                        "id": 152543,
                        "name": "Redonda La",
                        "latitude": "40.90827040",
                        "longitude": "-6.74873020"
                    },
                    {
                        "id": 36588,
                        "name": "Retortillo",
                        "latitude": "40.80132000",
                        "longitude": "-6.35951000"
                    },
                    {
                        "id": 152544,
                        "name": "Rinconada de la Sierra La",
                        "latitude": "40.61301620",
                        "longitude": "-6.02094400"
                    },
                    {
                        "id": 36646,
                        "name": "Robleda",
                        "latitude": "40.38469000",
                        "longitude": "-6.60726000"
                    },
                    {
                        "id": 36657,
                        "name": "Robliza de Cojos",
                        "latitude": "40.86766000",
                        "longitude": "-5.97786000"
                    },
                    {
                        "id": 36668,
                        "name": "Rollán",
                        "latitude": "40.96230000",
                        "longitude": "-5.91753000"
                    },
                    {
                        "id": 36736,
                        "name": "Saelices el Chico",
                        "latitude": "40.66998000",
                        "longitude": "-6.63271000"
                    },
                    {
                        "id": 152545,
                        "name": "Sagrada La",
                        "latitude": "40.74433770",
                        "longitude": "-6.07122890"
                    },
                    {
                        "id": 152547,
                        "name": "Sahugo El",
                        "latitude": "40.41494090",
                        "longitude": "-6.54164700"
                    },
                    {
                        "id": 36744,
                        "name": "Salamanca",
                        "latitude": "40.96882000",
                        "longitude": "-5.66388000"
                    },
                    {
                        "id": 36756,
                        "name": "Saldeana",
                        "latitude": "41.02068000",
                        "longitude": "-6.64015000"
                    },
                    {
                        "id": 36771,
                        "name": "Salmoral",
                        "latitude": "40.80137000",
                        "longitude": "-5.21910000"
                    },
                    {
                        "id": 36787,
                        "name": "Salvatierra de Tormes",
                        "latitude": "40.59007000",
                        "longitude": "-5.59763000"
                    },
                    {
                        "id": 36823,
                        "name": "San Cristóbal de la Cuesta",
                        "latitude": "41.02919000",
                        "longitude": "-5.61771000"
                    },
                    {
                        "id": 36830,
                        "name": "San Esteban de la Sierra",
                        "latitude": "40.50680000",
                        "longitude": "-5.90619000"
                    },
                    {
                        "id": 36834,
                        "name": "San Felices de los Gallegos",
                        "latitude": "40.84954000",
                        "longitude": "-6.70804000"
                    },
                    {
                        "id": 36875,
                        "name": "San Martín del Castañar",
                        "latitude": "40.52264000",
                        "longitude": "-6.06387000"
                    },
                    {
                        "id": 36885,
                        "name": "San Miguel de Valero",
                        "latitude": "40.54361000",
                        "longitude": "-5.92280000"
                    },
                    {
                        "id": 152507,
                        "name": "San Miguel del Robledo",
                        "latitude": "40.53689480",
                        "longitude": "-6.04525420"
                    },
                    {
                        "id": 36893,
                        "name": "San Morales",
                        "latitude": "40.99358000",
                        "longitude": "-5.50234000"
                    },
                    {
                        "id": 36894,
                        "name": "San Muñoz",
                        "latitude": "40.78334000",
                        "longitude": "-6.12758000"
                    },
                    {
                        "id": 36908,
                        "name": "San Pedro de Rozados",
                        "latitude": "40.79008000",
                        "longitude": "-5.73716000"
                    },
                    {
                        "id": 36912,
                        "name": "San Pedro del Valle",
                        "latitude": "41.03332000",
                        "longitude": "-5.86025000"
                    },
                    {
                        "id": 36914,
                        "name": "San Pelayo de Guareña",
                        "latitude": "41.11579000",
                        "longitude": "-5.85702000"
                    },
                    {
                        "id": 36939,
                        "name": "Sanchón de la Ribera",
                        "latitude": "41.08844000",
                        "longitude": "-6.41314000"
                    },
                    {
                        "id": 36940,
                        "name": "Sanchón de la Sagrada",
                        "latitude": "40.74287000",
                        "longitude": "-6.02502000"
                    },
                    {
                        "id": 36938,
                        "name": "Sanchotello",
                        "latitude": "40.43812000",
                        "longitude": "-5.75394000"
                    },
                    {
                        "id": 151187,
                        "name": "Sancti-Spíritus",
                        "latitude": "40.70709620",
                        "longitude": "-6.39841920"
                    },
                    {
                        "id": 36941,
                        "name": "Sando",
                        "latitude": "40.96773000",
                        "longitude": "-6.11136000"
                    },
                    {
                        "id": 37077,
                        "name": "Santa María de Sando",
                        "latitude": "40.97909000",
                        "longitude": "-6.12904000"
                    },
                    {
                        "id": 37072,
                        "name": "Santa Marta de Tormes",
                        "latitude": "40.95065000",
                        "longitude": "-5.62723000"
                    },
                    {
                        "id": 37115,
                        "name": "Santiago de la Puebla",
                        "latitude": "40.80132000",
                        "longitude": "-5.28073000"
                    },
                    {
                        "id": 37120,
                        "name": "Santibáñez de Béjar",
                        "latitude": "40.48785000",
                        "longitude": "-5.61110000"
                    },
                    {
                        "id": 37126,
                        "name": "Santibáñez de la Sierra",
                        "latitude": "40.49464000",
                        "longitude": "-5.91576000"
                    },
                    {
                        "id": 37138,
                        "name": "Santiz",
                        "latitude": "41.20579000",
                        "longitude": "-5.89654000"
                    },
                    {
                        "id": 152546,
                        "name": "Santos Los",
                        "latitude": "40.54520100",
                        "longitude": "-5.79712100"
                    },
                    {
                        "id": 37160,
                        "name": "Sardón de los Frailes",
                        "latitude": "41.21373000",
                        "longitude": "-6.27101000"
                    },
                    {
                        "id": 37178,
                        "name": "Saucelle",
                        "latitude": "41.04769000",
                        "longitude": "-6.75328000"
                    },
                    {
                        "id": 152548,
                        "name": "Sepulcro-Hilario",
                        "latitude": "40.69900370",
                        "longitude": "-6.18783670"
                    },
                    {
                        "id": 37217,
                        "name": "Sequeros",
                        "latitude": "40.51295000",
                        "longitude": "-6.02495000"
                    },
                    {
                        "id": 37222,
                        "name": "Serradilla del Arroyo",
                        "latitude": "40.52133000",
                        "longitude": "-6.36008000"
                    },
                    {
                        "id": 37223,
                        "name": "Serradilla del Llano",
                        "latitude": "40.49996000",
                        "longitude": "-6.35701000"
                    },
                    {
                        "id": 152549,
                        "name": "Sierpe La",
                        "latitude": "40.64387490",
                        "longitude": "-5.85121000"
                    },
                    {
                        "id": 152550,
                        "name": "Sieteiglesias de Tormes",
                        "latitude": "40.74143320",
                        "longitude": "-5.57813780"
                    },
                    {
                        "id": 37273,
                        "name": "Sobradillo",
                        "latitude": "40.91754000",
                        "longitude": "-6.79729000"
                    },
                    {
                        "id": 37301,
                        "name": "Sorihuela",
                        "latitude": "40.44378000",
                        "longitude": "-5.67818000"
                    },
                    {
                        "id": 37324,
                        "name": "Sotoserrano",
                        "latitude": "40.43499000",
                        "longitude": "-6.03261000"
                    },
                    {
                        "id": 37342,
                        "name": "Tabera de Abajo",
                        "latitude": "40.91021000",
                        "longitude": "-6.00227000"
                    },
                    {
                        "id": 152551,
                        "name": "Tala La",
                        "latitude": "40.58982760",
                        "longitude": "-5.53683540"
                    },
                    {
                        "id": 37363,
                        "name": "Tamames",
                        "latitude": "40.65725000",
                        "longitude": "-6.10536000"
                    },
                    {
                        "id": 37375,
                        "name": "Tarazona de Guareña",
                        "latitude": "41.17206000",
                        "longitude": "-5.25005000"
                    },
                    {
                        "id": 37380,
                        "name": "Tardáguila",
                        "latitude": "41.11493000",
                        "longitude": "-5.57423000"
                    },
                    {
                        "id": 152552,
                        "name": "Tejado El",
                        "latitude": "40.44234670",
                        "longitude": "-5.53932780"
                    },
                    {
                        "id": 37399,
                        "name": "Tejeda y Segoyuela",
                        "latitude": "40.63155000",
                        "longitude": "-6.02311000"
                    },
                    {
                        "id": 37403,
                        "name": "Tenebrón",
                        "latitude": "40.62449000",
                        "longitude": "-6.35450000"
                    },
                    {
                        "id": 37407,
                        "name": "Terradillos",
                        "latitude": "40.83836000",
                        "longitude": "-5.54160000"
                    },
                    {
                        "id": 37453,
                        "name": "Topas",
                        "latitude": "41.15759000",
                        "longitude": "-5.63402000"
                    },
                    {
                        "id": 37461,
                        "name": "Tordillos",
                        "latitude": "40.85266000",
                        "longitude": "-5.35278000"
                    },
                    {
                        "id": 152553,
                        "name": "Tornadizo El",
                        "latitude": "40.54246180",
                        "longitude": "-5.89145390"
                    },
                    {
                        "id": 37582,
                        "name": "Torresmenudas",
                        "latitude": "41.10249000",
                        "longitude": "-5.78475000"
                    },
                    {
                        "id": 37613,
                        "name": "Trabanca",
                        "latitude": "41.23278000",
                        "longitude": "-6.38484000"
                    },
                    {
                        "id": 37627,
                        "name": "Tremedal de Tormes",
                        "latitude": "41.07423000",
                        "longitude": "-6.18164000"
                    },
                    {
                        "id": 37738,
                        "name": "Valdecarros",
                        "latitude": "40.77007000",
                        "longitude": "-5.42219000"
                    },
                    {
                        "id": 37746,
                        "name": "Valdefuentes de Sangusín",
                        "latitude": "40.46578000",
                        "longitude": "-5.83286000"
                    },
                    {
                        "id": 37750,
                        "name": "Valdehijaderos",
                        "latitude": "40.41916000",
                        "longitude": "-5.84792000"
                    },
                    {
                        "id": 37754,
                        "name": "Valdelacasa",
                        "latitude": "40.50631000",
                        "longitude": "-5.76354000"
                    },
                    {
                        "id": 37756,
                        "name": "Valdelageve",
                        "latitude": "40.36949000",
                        "longitude": "-5.99078000"
                    },
                    {
                        "id": 37761,
                        "name": "Valdelosa",
                        "latitude": "41.17157000",
                        "longitude": "-5.78390000"
                    },
                    {
                        "id": 37769,
                        "name": "Valdemierque",
                        "latitude": "40.82176000",
                        "longitude": "-5.58225000"
                    },
                    {
                        "id": 37795,
                        "name": "Valderrodrigo",
                        "latitude": "41.06524000",
                        "longitude": "-6.50878000"
                    },
                    {
                        "id": 37813,
                        "name": "Valdunciel",
                        "latitude": "41.08544000",
                        "longitude": "-5.67217000"
                    },
                    {
                        "id": 37825,
                        "name": "Valero",
                        "latitude": "40.53533000",
                        "longitude": "-5.94307000"
                    },
                    {
                        "id": 37851,
                        "name": "Vallejera de Riofrío",
                        "latitude": "40.40910000",
                        "longitude": "-5.71943000"
                    },
                    {
                        "id": 37872,
                        "name": "Valsalabroso",
                        "latitude": "41.10962000",
                        "longitude": "-6.50269000"
                    },
                    {
                        "id": 37889,
                        "name": "Valverde de Valdelacasa",
                        "latitude": "40.48155000",
                        "longitude": "-5.78145000"
                    },
                    {
                        "id": 37898,
                        "name": "Valverdón",
                        "latitude": "41.04691000",
                        "longitude": "-5.76955000"
                    },
                    {
                        "id": 37901,
                        "name": "Vecinos",
                        "latitude": "40.77875000",
                        "longitude": "-5.87815000"
                    },
                    {
                        "id": 37910,
                        "name": "Vega de Tirados",
                        "latitude": "41.02543000",
                        "longitude": "-5.88667000"
                    },
                    {
                        "id": 152554,
                        "name": "Veguillas Las",
                        "latitude": "40.71499430",
                        "longitude": "-5.83208710"
                    },
                    {
                        "id": 152555,
                        "name": "Vellés La",
                        "latitude": "41.07079740",
                        "longitude": "-5.57748140"
                    },
                    {
                        "id": 37944,
                        "name": "Ventosa del Río Almar",
                        "latitude": "40.92728000",
                        "longitude": "-5.34838000"
                    },
                    {
                        "id": 152556,
                        "name": "Vídola La",
                        "latitude": "41.15424380",
                        "longitude": "-6.48698230"
                    },
                    {
                        "id": 38053,
                        "name": "Villaflores",
                        "latitude": "41.08397000",
                        "longitude": "-5.23436000"
                    },
                    {
                        "id": 38077,
                        "name": "Villagonzalo de Tormes",
                        "latitude": "40.89221000",
                        "longitude": "-5.49664000"
                    },
                    {
                        "id": 38101,
                        "name": "Villalba de los Llanos",
                        "latitude": "40.80020000",
                        "longitude": "-5.97580000"
                    },
                    {
                        "id": 38139,
                        "name": "Villamayor",
                        "latitude": "40.99939000",
                        "longitude": "-5.69579000"
                    },
                    {
                        "id": 38216,
                        "name": "Villanueva del Conde",
                        "latitude": "40.51039000",
                        "longitude": "-6.01210000"
                    },
                    {
                        "id": 152557,
                        "name": "Villar de Argañán",
                        "latitude": "40.67299650",
                        "longitude": "-6.72063460"
                    },
                    {
                        "id": 38236,
                        "name": "Villar de Ciervo",
                        "latitude": "40.73772000",
                        "longitude": "-6.73850000"
                    },
                    {
                        "id": 38240,
                        "name": "Villar de Gallimazo",
                        "latitude": "40.95367000",
                        "longitude": "-5.28819000"
                    },
                    {
                        "id": 38248,
                        "name": "Villar de la Yegua",
                        "latitude": "40.72554000",
                        "longitude": "-6.70364000"
                    },
                    {
                        "id": 38242,
                        "name": "Villar de Peralonso",
                        "latitude": "41.03223000",
                        "longitude": "-6.22284000"
                    },
                    {
                        "id": 38245,
                        "name": "Villar de Samaniego",
                        "latitude": "41.11667000",
                        "longitude": "-6.43333000"
                    },
                    {
                        "id": 38280,
                        "name": "Villares de la Reina",
                        "latitude": "41.00832000",
                        "longitude": "-5.64881000"
                    },
                    {
                        "id": 38279,
                        "name": "Villares de Yeltes",
                        "latitude": "40.86594000",
                        "longitude": "-6.41300000"
                    },
                    {
                        "id": 38285,
                        "name": "Villarino de los Aires",
                        "latitude": "41.27102000",
                        "longitude": "-6.46847000"
                    },
                    {
                        "id": 38287,
                        "name": "Villarmayor",
                        "latitude": "41.01514000",
                        "longitude": "-5.97151000"
                    },
                    {
                        "id": 38290,
                        "name": "Villarmuerto",
                        "latitude": "41.05620000",
                        "longitude": "-6.36294000"
                    },
                    {
                        "id": 38315,
                        "name": "Villasbuenas",
                        "latitude": "41.06263000",
                        "longitude": "-6.59662000"
                    },
                    {
                        "id": 38317,
                        "name": "Villasdardo",
                        "latitude": "41.00449000",
                        "longitude": "-6.16303000"
                    },
                    {
                        "id": 38322,
                        "name": "Villaseco de los Gamitos",
                        "latitude": "41.03621000",
                        "longitude": "-6.11323000"
                    },
                    {
                        "id": 38323,
                        "name": "Villaseco de los Reyes",
                        "latitude": "41.16262000",
                        "longitude": "-6.18426000"
                    },
                    {
                        "id": 38328,
                        "name": "Villasrubias",
                        "latitude": "40.33822000",
                        "longitude": "-6.63920000"
                    },
                    {
                        "id": 38345,
                        "name": "Villaverde de Guareña",
                        "latitude": "41.06406000",
                        "longitude": "-5.52492000"
                    },
                    {
                        "id": 38359,
                        "name": "Villavieja de Yeltes",
                        "latitude": "40.87573000",
                        "longitude": "-6.46792000"
                    },
                    {
                        "id": 38376,
                        "name": "Villoría",
                        "latitude": "40.99435000",
                        "longitude": "-5.37363000"
                    },
                    {
                        "id": 38375,
                        "name": "Villoruela",
                        "latitude": "41.00860000",
                        "longitude": "-5.39381000"
                    },
                    {
                        "id": 38385,
                        "name": "Vilvestre",
                        "latitude": "41.10636000",
                        "longitude": "-6.72725000"
                    },
                    {
                        "id": 38402,
                        "name": "Vitigudino",
                        "latitude": "41.00912000",
                        "longitude": "-6.43404000"
                    },
                    {
                        "id": 38432,
                        "name": "Yecla de Yeltes",
                        "latitude": "40.95917000",
                        "longitude": "-6.48904000"
                    },
                    {
                        "id": 38462,
                        "name": "Zamarra",
                        "latitude": "40.51893000",
                        "longitude": "-6.45248000"
                    },
                    {
                        "id": 38463,
                        "name": "Zamayón",
                        "latitude": "41.14861000",
                        "longitude": "-5.83054000"
                    },
                    {
                        "id": 38471,
                        "name": "Zarapicos",
                        "latitude": "41.03830000",
                        "longitude": "-5.84526000"
                    },
                    {
                        "id": 152558,
                        "name": "Zarza de Pumareda La",
                        "latitude": "41.16127260",
                        "longitude": "-6.62765420"
                    },
                    {
                        "id": 38496,
                        "name": "Zorita de la Frontera",
                        "latitude": "41.01453000",
                        "longitude": "-5.19659000"
                    }
                ]
            },
            {
                "id": 5112,
                "name": "Santa Cruz de Tenerife",
                "iso2": "TF",
                "latitude": "28.45789140",
                "longitude": "-16.32135390",
                "type": "province",
                "cities": [
                    {
                        "id": 31931,
                        "name": "Adeje",
                        "latitude": "28.12271000",
                        "longitude": "-16.72600000"
                    },
                    {
                        "id": 31969,
                        "name": "Agulo",
                        "latitude": "28.18778000",
                        "longitude": "-17.19678000"
                    },
                    {
                        "id": 31993,
                        "name": "Alajeró",
                        "latitude": "28.06205000",
                        "longitude": "-17.24073000"
                    },
                    {
                        "id": 32400,
                        "name": "Arafo",
                        "latitude": "28.33971000",
                        "longitude": "-16.42244000"
                    },
                    {
                        "id": 152448,
                        "name": "Arico",
                        "latitude": "28.46671860",
                        "longitude": "-16.27971730"
                    },
                    {
                        "id": 32497,
                        "name": "Arona",
                        "latitude": "28.09962000",
                        "longitude": "-16.68102000"
                    },
                    {
                        "id": 32666,
                        "name": "Barlovento",
                        "latitude": "28.82708000",
                        "longitude": "-17.80377000"
                    },
                    {
                        "id": 32980,
                        "name": "Breña Alta",
                        "latitude": "28.65000000",
                        "longitude": "-17.78333000"
                    },
                    {
                        "id": 32981,
                        "name": "Breña Baja",
                        "latitude": "28.63011000",
                        "longitude": "-17.78953000"
                    },
                    {
                        "id": 33005,
                        "name": "Buenavista del Norte",
                        "latitude": "28.37458000",
                        "longitude": "-16.86098000"
                    },
                    {
                        "id": 33226,
                        "name": "Candelaria",
                        "latitude": "28.35480000",
                        "longitude": "-16.37268000"
                    },
                    {
                        "id": 34167,
                        "name": "Fasnia",
                        "latitude": "28.23638000",
                        "longitude": "-16.43886000"
                    },
                    {
                        "id": 34268,
                        "name": "Frontera",
                        "latitude": "27.75404000",
                        "longitude": "-18.00367000"
                    },
                    {
                        "id": 34276,
                        "name": "Fuencaliente de la Palma",
                        "latitude": "28.49236000",
                        "longitude": "-17.84529000"
                    },
                    {
                        "id": 34405,
                        "name": "Garachico",
                        "latitude": "28.37365000",
                        "longitude": "-16.76342000"
                    },
                    {
                        "id": 34406,
                        "name": "Garafía",
                        "latitude": "28.81667000",
                        "longitude": "-17.93333000"
                    },
                    {
                        "id": 34498,
                        "name": "Granadilla de Abona",
                        "latitude": "28.11882000",
                        "longitude": "-16.57599000"
                    },
                    {
                        "id": 152449,
                        "name": "Guancha La",
                        "latitude": "28.46741910",
                        "longitude": "-16.28016110"
                    },
                    {
                        "id": 34557,
                        "name": "Guía de Isora",
                        "latitude": "28.21154000",
                        "longitude": "-16.77947000"
                    },
                    {
                        "id": 34569,
                        "name": "Güimar",
                        "latitude": "28.31122000",
                        "longitude": "-16.41276000"
                    },
                    {
                        "id": 34586,
                        "name": "Hermigua",
                        "latitude": "28.16766000",
                        "longitude": "-17.19051000"
                    },
                    {
                        "id": 34732,
                        "name": "Icod de los Vinos",
                        "latitude": "28.37241000",
                        "longitude": "-16.71188000"
                    },
                    {
                        "id": 152451,
                        "name": "Llanos de Aridane Los",
                        "latitude": "28.61835150",
                        "longitude": "-17.89985660"
                    },
                    {
                        "id": 152452,
                        "name": "Matanza de Acentejo La",
                        "latitude": "28.44814830",
                        "longitude": "-16.45796610"
                    },
                    {
                        "id": 152453,
                        "name": "Orotava La",
                        "latitude": "28.38900040",
                        "longitude": "-16.52388020"
                    },
                    {
                        "id": 152454,
                        "name": "Paso El",
                        "latitude": "28.65176560",
                        "longitude": "-17.87999020"
                    },
                    {
                        "id": 152465,
                        "name": "Pinar de El Hierro El",
                        "latitude": "27.69309740",
                        "longitude": "-18.01244690"
                    },
                    {
                        "id": 36454,
                        "name": "Puerto de la Cruz",
                        "latitude": "28.41397000",
                        "longitude": "-16.54867000"
                    },
                    {
                        "id": 36472,
                        "name": "Puntagorda",
                        "latitude": "28.77490000",
                        "longitude": "-17.97741000"
                    },
                    {
                        "id": 36473,
                        "name": "Puntallana",
                        "latitude": "28.73333000",
                        "longitude": "-17.73333000"
                    },
                    {
                        "id": 152455,
                        "name": "Realejos Los",
                        "latitude": "28.38521270",
                        "longitude": "-16.58410460"
                    },
                    {
                        "id": 152456,
                        "name": "Rosario El",
                        "latitude": "28.46362960",
                        "longitude": "-16.25184670"
                    },
                    {
                        "id": 152457,
                        "name": "San Andrés y Sauces",
                        "latitude": "28.78422180",
                        "longitude": "-17.79915450"
                    },
                    {
                        "id": 152450,
                        "name": "San Cristóbal de La Laguna",
                        "latitude": "28.48740090",
                        "longitude": "-16.31590610"
                    },
                    {
                        "id": 36848,
                        "name": "San Juan de la Rambla",
                        "latitude": "28.39276000",
                        "longitude": "-16.65015000"
                    },
                    {
                        "id": 36879,
                        "name": "San Miguel De Abona",
                        "latitude": "28.09826000",
                        "longitude": "-16.61708000"
                    },
                    {
                        "id": 36920,
                        "name": "San Sebastián de la Gomera",
                        "latitude": "28.09163000",
                        "longitude": "-17.11331000"
                    },
                    {
                        "id": 37038,
                        "name": "Santa Cruz de la Palma",
                        "latitude": "28.68351000",
                        "longitude": "-17.76421000"
                    },
                    {
                        "id": 37036,
                        "name": "Santa Cruz de Tenerife",
                        "latitude": "28.46824000",
                        "longitude": "-16.25462000"
                    },
                    {
                        "id": 37102,
                        "name": "Santa Úrsula",
                        "latitude": "28.42613000",
                        "longitude": "-16.48876000"
                    },
                    {
                        "id": 37119,
                        "name": "Santiago del Teide",
                        "latitude": "28.29400000",
                        "longitude": "-16.81618000"
                    },
                    {
                        "id": 152458,
                        "name": "Sauzal El",
                        "latitude": "28.47941470",
                        "longitude": "-16.43653990"
                    },
                    {
                        "id": 152459,
                        "name": "Silos Los",
                        "latitude": "28.36626140",
                        "longitude": "-16.81791850"
                    },
                    {
                        "id": 37347,
                        "name": "Tacoronte",
                        "latitude": "28.47688000",
                        "longitude": "-16.41016000"
                    },
                    {
                        "id": 152460,
                        "name": "Tanque El",
                        "latitude": "28.35702480",
                        "longitude": "-16.78023090"
                    },
                    {
                        "id": 37389,
                        "name": "Tazacorte",
                        "latitude": "28.64186000",
                        "longitude": "-17.93394000"
                    },
                    {
                        "id": 37391,
                        "name": "Tegueste",
                        "latitude": "28.51667000",
                        "longitude": "-16.31667000"
                    },
                    {
                        "id": 37425,
                        "name": "Tijarafe",
                        "latitude": "28.70000000",
                        "longitude": "-17.95000000"
                    },
                    {
                        "id": 152461,
                        "name": "Valle Gran Rey",
                        "latitude": "28.08496250",
                        "longitude": "-17.33388390"
                    },
                    {
                        "id": 152462,
                        "name": "Vallehermoso",
                        "latitude": "28.18019910",
                        "longitude": "-17.26590080"
                    },
                    {
                        "id": 37881,
                        "name": "Valverde",
                        "latitude": "27.80628000",
                        "longitude": "-17.91578000"
                    },
                    {
                        "id": 152463,
                        "name": "Victoria de Acentejo La",
                        "latitude": "28.43403440",
                        "longitude": "-16.47093680"
                    },
                    {
                        "id": 37982,
                        "name": "Vilaflor",
                        "latitude": "28.15623000",
                        "longitude": "-16.63592000"
                    },
                    {
                        "id": 152464,
                        "name": "Villa de Mazo",
                        "latitude": "28.62207120",
                        "longitude": "-17.78067530"
                    }
                ]
            },
            {
                "id": 1192,
                "name": "Segovia",
                "iso2": "SG",
                "latitude": "40.94292960",
                "longitude": "-4.10889420",
                "type": "province",
                "cities": [
                    {
                        "id": 31899,
                        "name": "Abades",
                        "latitude": "40.91646000",
                        "longitude": "-4.26937000"
                    },
                    {
                        "id": 31938,
                        "name": "Adrada de Pirón",
                        "latitude": "41.05257000",
                        "longitude": "-4.05107000"
                    },
                    {
                        "id": 31940,
                        "name": "Adrados",
                        "latitude": "41.36816000",
                        "longitude": "-4.11186000"
                    },
                    {
                        "id": 31957,
                        "name": "Aguilafuente",
                        "latitude": "41.22667000",
                        "longitude": "-4.11185000"
                    },
                    {
                        "id": 32114,
                        "name": "Alconada de Maderuelo",
                        "latitude": "41.45015000",
                        "longitude": "-3.48554000"
                    },
                    {
                        "id": 32141,
                        "name": "Aldea Real",
                        "latitude": "41.18553000",
                        "longitude": "-4.16559000"
                    },
                    {
                        "id": 32151,
                        "name": "Aldealcorvo",
                        "latitude": "41.24443000",
                        "longitude": "-3.79136000"
                    },
                    {
                        "id": 152756,
                        "name": "Aldealengua de Pedraza",
                        "latitude": "41.02752130",
                        "longitude": "-3.79431570"
                    },
                    {
                        "id": 32153,
                        "name": "Aldealengua de Santa María",
                        "latitude": "41.46196000",
                        "longitude": "-3.46723000"
                    },
                    {
                        "id": 152757,
                        "name": "Aldeanueva de la Serrezuela",
                        "latitude": "41.46119330",
                        "longitude": "-3.78097400"
                    },
                    {
                        "id": 32166,
                        "name": "Aldeanueva del Codonal",
                        "latitude": "41.08236000",
                        "longitude": "-4.54369000"
                    },
                    {
                        "id": 32173,
                        "name": "Aldeasoña",
                        "latitude": "41.47285000",
                        "longitude": "-4.05711000"
                    },
                    {
                        "id": 152758,
                        "name": "Aldehorno",
                        "latitude": "41.51278770",
                        "longitude": "-3.77811560"
                    },
                    {
                        "id": 32179,
                        "name": "Aldehuela del Codonal",
                        "latitude": "41.05504000",
                        "longitude": "-4.53863000"
                    },
                    {
                        "id": 32181,
                        "name": "Aldeonte",
                        "latitude": "41.35092000",
                        "longitude": "-3.67847000"
                    },
                    {
                        "id": 32366,
                        "name": "Anaya",
                        "latitude": "40.99184000",
                        "longitude": "-4.30950000"
                    },
                    {
                        "id": 32595,
                        "name": "Añe",
                        "latitude": "41.03702000",
                        "longitude": "-4.29462000"
                    },
                    {
                        "id": 32402,
                        "name": "Arahuetes",
                        "latitude": "41.13762000",
                        "longitude": "-3.85664000"
                    },
                    {
                        "id": 32434,
                        "name": "Arcones",
                        "latitude": "41.11817000",
                        "longitude": "-3.72384000"
                    },
                    {
                        "id": 32459,
                        "name": "Arevalillo de Cega",
                        "latitude": "41.16174000",
                        "longitude": "-3.88911000"
                    },
                    {
                        "id": 32490,
                        "name": "Armuña",
                        "latitude": "41.07715000",
                        "longitude": "-4.31949000"
                    },
                    {
                        "id": 32574,
                        "name": "Ayllón",
                        "latitude": "41.41899000",
                        "longitude": "-3.37537000"
                    },
                    {
                        "id": 32648,
                        "name": "Barbolla",
                        "latitude": "41.32567000",
                        "longitude": "-3.67361000"
                    },
                    {
                        "id": 32687,
                        "name": "Basardilla",
                        "latitude": "41.02737000",
                        "longitude": "-4.02598000"
                    },
                    {
                        "id": 32840,
                        "name": "Bercial",
                        "latitude": "40.90711000",
                        "longitude": "-4.43638000"
                    },
                    {
                        "id": 32844,
                        "name": "Bercimuel",
                        "latitude": "41.39925000",
                        "longitude": "-3.57051000"
                    },
                    {
                        "id": 32861,
                        "name": "Bernardos",
                        "latitude": "41.12787000",
                        "longitude": "-4.35119000"
                    },
                    {
                        "id": 152759,
                        "name": "Bernuy de Porreros",
                        "latitude": "40.99941430",
                        "longitude": "-4.11875650"
                    },
                    {
                        "id": 32924,
                        "name": "Boceguillas",
                        "latitude": "41.33641000",
                        "longitude": "-3.63828000"
                    },
                    {
                        "id": 32982,
                        "name": "Brieva",
                        "latitude": "41.03483000",
                        "longitude": "-4.05364000"
                    },
                    {
                        "id": 33065,
                        "name": "Caballar",
                        "latitude": "41.12159000",
                        "longitude": "-3.96420000"
                    },
                    {
                        "id": 33071,
                        "name": "Cabañas de Polendos",
                        "latitude": "41.06667000",
                        "longitude": "-4.11010000"
                    },
                    {
                        "id": 33088,
                        "name": "Cabezuela",
                        "latitude": "41.23590000",
                        "longitude": "-3.93173000"
                    },
                    {
                        "id": 152760,
                        "name": "Calabazas de Fuentidueña",
                        "latitude": "41.44565330",
                        "longitude": "-4.00985150"
                    },
                    {
                        "id": 33203,
                        "name": "Campo de San Pedro",
                        "latitude": "41.42992000",
                        "longitude": "-3.54599000"
                    },
                    {
                        "id": 33251,
                        "name": "Cantalejo",
                        "latitude": "41.25760000",
                        "longitude": "-3.92791000"
                    },
                    {
                        "id": 33258,
                        "name": "Cantimpalos",
                        "latitude": "41.07406000",
                        "longitude": "-4.15988000"
                    },
                    {
                        "id": 33287,
                        "name": "Carbonero el Mayor",
                        "latitude": "41.12257000",
                        "longitude": "-4.26478000"
                    },
                    {
                        "id": 152761,
                        "name": "Carrascal del Río",
                        "latitude": "41.36729130",
                        "longitude": "-3.89799120"
                    },
                    {
                        "id": 33392,
                        "name": "Casla",
                        "latitude": "41.16602000",
                        "longitude": "-3.65643000"
                    },
                    {
                        "id": 33459,
                        "name": "Castillejo de Mesleón",
                        "latitude": "41.28100000",
                        "longitude": "-3.60137000"
                    },
                    {
                        "id": 33489,
                        "name": "Castro de Fuentidueña",
                        "latitude": "41.42044000",
                        "longitude": "-3.85528000"
                    },
                    {
                        "id": 33498,
                        "name": "Castrojimeno",
                        "latitude": "41.39659000",
                        "longitude": "-3.84726000"
                    },
                    {
                        "id": 33507,
                        "name": "Castroserna de Abajo",
                        "latitude": "41.20835000",
                        "longitude": "-3.73387000"
                    },
                    {
                        "id": 33508,
                        "name": "Castroserracín",
                        "latitude": "41.39329000",
                        "longitude": "-3.80196000"
                    },
                    {
                        "id": 33556,
                        "name": "Cedillo de la Torre",
                        "latitude": "41.42482000",
                        "longitude": "-3.60577000"
                    },
                    {
                        "id": 33588,
                        "name": "Cerezo de Abajo",
                        "latitude": "41.21817000",
                        "longitude": "-3.59126000"
                    },
                    {
                        "id": 33589,
                        "name": "Cerezo de Arriba",
                        "latitude": "41.23890000",
                        "longitude": "-3.55846000"
                    },
                    {
                        "id": 33620,
                        "name": "Chañe",
                        "latitude": "41.33834000",
                        "longitude": "-4.42764000"
                    },
                    {
                        "id": 33671,
                        "name": "Cilleruelo de San Mamés",
                        "latitude": "41.43220000",
                        "longitude": "-3.56614000"
                    },
                    {
                        "id": 33712,
                        "name": "Cobos de Fuentidueña",
                        "latitude": "41.38265000",
                        "longitude": "-3.92723000"
                    },
                    {
                        "id": 33714,
                        "name": "Coca",
                        "latitude": "41.21767000",
                        "longitude": "-4.52145000"
                    },
                    {
                        "id": 33717,
                        "name": "Codorniz",
                        "latitude": "41.06745000",
                        "longitude": "-4.60021000"
                    },
                    {
                        "id": 33732,
                        "name": "Collado Hermoso",
                        "latitude": "41.03869000",
                        "longitude": "-3.91859000"
                    },
                    {
                        "id": 152762,
                        "name": "Condado de Castilnovo",
                        "latitude": "41.24511060",
                        "longitude": "-3.74858740"
                    },
                    {
                        "id": 33799,
                        "name": "Corral de Ayllón",
                        "latitude": "41.39081000",
                        "longitude": "-3.45856000"
                    },
                    {
                        "id": 33830,
                        "name": "Cozuelos de Fuentidueña",
                        "latitude": "41.39086000",
                        "longitude": "-4.09564000"
                    },
                    {
                        "id": 33854,
                        "name": "Cubillo",
                        "latitude": "41.12138000",
                        "longitude": "-3.90878000"
                    },
                    {
                        "id": 33888,
                        "name": "Cuéllar",
                        "latitude": "41.40155000",
                        "longitude": "-4.31474000"
                    },
                    {
                        "id": 33872,
                        "name": "Cuevas de Provanco",
                        "latitude": "41.54209000",
                        "longitude": "-3.96203000"
                    },
                    {
                        "id": 33938,
                        "name": "Domingo García",
                        "latitude": "41.11528000",
                        "longitude": "-4.37927000"
                    },
                    {
                        "id": 33944,
                        "name": "Donhierro",
                        "latitude": "41.11642000",
                        "longitude": "-4.69670000"
                    },
                    {
                        "id": 33962,
                        "name": "Duruelo",
                        "latitude": "41.23622000",
                        "longitude": "-3.64914000"
                    },
                    {
                        "id": 34046,
                        "name": "Encinas",
                        "latitude": "41.37511000",
                        "longitude": "-3.66762000"
                    },
                    {
                        "id": 34054,
                        "name": "Encinillas",
                        "latitude": "41.01809000",
                        "longitude": "-4.15784000"
                    },
                    {
                        "id": 34078,
                        "name": "Escalona del Prado",
                        "latitude": "41.16682000",
                        "longitude": "-4.12272000"
                    },
                    {
                        "id": 34081,
                        "name": "Escarabajosa de Cabezas",
                        "latitude": "41.10470000",
                        "longitude": "-4.19411000"
                    },
                    {
                        "id": 34086,
                        "name": "Escobar de Polendos",
                        "latitude": "41.09079000",
                        "longitude": "-4.13117000"
                    },
                    {
                        "id": 152763,
                        "name": "Espinar El",
                        "latitude": "40.74049150",
                        "longitude": "-4.21283370"
                    },
                    {
                        "id": 34125,
                        "name": "Espirdo",
                        "latitude": "40.99764000",
                        "longitude": "-4.07331000"
                    },
                    {
                        "id": 34245,
                        "name": "Fresneda de Cuéllar",
                        "latitude": "41.31905000",
                        "longitude": "-4.44938000"
                    },
                    {
                        "id": 34255,
                        "name": "Fresno de Cantespino",
                        "latitude": "41.36820000",
                        "longitude": "-3.49950000"
                    },
                    {
                        "id": 34260,
                        "name": "Fresno de la Fuente",
                        "latitude": "41.39243000",
                        "longitude": "-3.64491000"
                    },
                    {
                        "id": 34269,
                        "name": "Frumales",
                        "latitude": "41.38333000",
                        "longitude": "-4.18631000"
                    },
                    {
                        "id": 34298,
                        "name": "Fuente de Santa Cruz",
                        "latitude": "41.20972000",
                        "longitude": "-4.63530000"
                    },
                    {
                        "id": 34301,
                        "name": "Fuente el Olmo de Fuentidueña",
                        "latitude": "41.37929000",
                        "longitude": "-4.00086000"
                    },
                    {
                        "id": 152764,
                        "name": "Fuente el Olmo de Íscar",
                        "latitude": "41.28053600",
                        "longitude": "-4.49349700"
                    },
                    {
                        "id": 34330,
                        "name": "Fuentepelayo",
                        "latitude": "41.22249000",
                        "longitude": "-4.17570000"
                    },
                    {
                        "id": 34332,
                        "name": "Fuentepiñel",
                        "latitude": "41.39892000",
                        "longitude": "-4.04295000"
                    },
                    {
                        "id": 152765,
                        "name": "Fuenterrebollo",
                        "latitude": "41.30331120",
                        "longitude": "-3.95723740"
                    },
                    {
                        "id": 34353,
                        "name": "Fuentesaúco de Fuentidueña",
                        "latitude": "41.42445000",
                        "longitude": "-4.06215000"
                    },
                    {
                        "id": 34355,
                        "name": "Fuentesoto",
                        "latitude": "41.45664000",
                        "longitude": "-3.91835000"
                    },
                    {
                        "id": 34360,
                        "name": "Fuentidueña",
                        "latitude": "41.44226000",
                        "longitude": "-3.97899000"
                    },
                    {
                        "id": 34386,
                        "name": "Gallegos",
                        "latitude": "41.07508000",
                        "longitude": "-3.78591000"
                    },
                    {
                        "id": 34411,
                        "name": "Garcillán",
                        "latitude": "40.97771000",
                        "longitude": "-4.26577000"
                    },
                    {
                        "id": 152766,
                        "name": "Gomezserracín",
                        "latitude": "41.28887860",
                        "longitude": "-4.32440790"
                    },
                    {
                        "id": 34496,
                        "name": "Grajera",
                        "latitude": "41.37319000",
                        "longitude": "-3.61304000"
                    },
                    {
                        "id": 34637,
                        "name": "Honrubia de la Cuesta",
                        "latitude": "41.50998000",
                        "longitude": "-3.70453000"
                    },
                    {
                        "id": 34638,
                        "name": "Hontalbilla",
                        "latitude": "41.34551000",
                        "longitude": "-4.12149000"
                    },
                    {
                        "id": 34640,
                        "name": "Hontanares de Eresma",
                        "latitude": "40.98273000",
                        "longitude": "-4.20439000"
                    },
                    {
                        "id": 152767,
                        "name": "Huertos Los",
                        "latitude": "41.00961240",
                        "longitude": "-4.21988030"
                    },
                    {
                        "id": 34773,
                        "name": "Ituero y Lama",
                        "latitude": "40.80066000",
                        "longitude": "-4.37917000"
                    },
                    {
                        "id": 152768,
                        "name": "Juarros de Riomoros",
                        "latitude": "40.94589450",
                        "longitude": "-4.30836270"
                    },
                    {
                        "id": 34825,
                        "name": "Juarros de Voltoya",
                        "latitude": "41.03097000",
                        "longitude": "-4.51922000"
                    },
                    {
                        "id": 34936,
                        "name": "Labajos",
                        "latitude": "40.84335000",
                        "longitude": "-4.52005000"
                    },
                    {
                        "id": 34947,
                        "name": "Laguna de Contreras",
                        "latitude": "41.49513000",
                        "longitude": "-4.02874000"
                    },
                    {
                        "id": 34966,
                        "name": "Languilla",
                        "latitude": "41.44926000",
                        "longitude": "-3.42438000"
                    },
                    {
                        "id": 35000,
                        "name": "Lastras de Cuéllar",
                        "latitude": "41.29762000",
                        "longitude": "-4.10670000"
                    },
                    {
                        "id": 35001,
                        "name": "Lastras del Pozo",
                        "latitude": "40.87920000",
                        "longitude": "-4.34658000"
                    },
                    {
                        "id": 152769,
                        "name": "Lastrilla La",
                        "latitude": "40.96773110",
                        "longitude": "-4.10660920"
                    },
                    {
                        "id": 152770,
                        "name": "Losa La",
                        "latitude": "40.85414010",
                        "longitude": "-4.16225430"
                    },
                    {
                        "id": 35184,
                        "name": "Maderuelo",
                        "latitude": "41.48644000",
                        "longitude": "-3.52218000"
                    },
                    {
                        "id": 35277,
                        "name": "Marazoleja",
                        "latitude": "40.96086000",
                        "longitude": "-4.33882000"
                    },
                    {
                        "id": 35278,
                        "name": "Marazuela",
                        "latitude": "40.97912000",
                        "longitude": "-4.36506000"
                    },
                    {
                        "id": 35303,
                        "name": "Martín Miguel",
                        "latitude": "40.95220000",
                        "longitude": "-4.27166000"
                    },
                    {
                        "id": 35304,
                        "name": "Martín Muñoz de la Dehesa",
                        "latitude": "41.06652000",
                        "longitude": "-4.68676000"
                    },
                    {
                        "id": 35305,
                        "name": "Martín Muñoz de las Posadas",
                        "latitude": "40.99546000",
                        "longitude": "-4.59672000"
                    },
                    {
                        "id": 35310,
                        "name": "Marugán",
                        "latitude": "40.89943000",
                        "longitude": "-4.38383000"
                    },
                    {
                        "id": 35330,
                        "name": "Mata de Cuéllar",
                        "latitude": "41.39655000",
                        "longitude": "-4.47167000"
                    },
                    {
                        "id": 35331,
                        "name": "Matabuena",
                        "latitude": "41.09590000",
                        "longitude": "-3.75827000"
                    },
                    {
                        "id": 152771,
                        "name": "Matilla La",
                        "latitude": "41.19326840",
                        "longitude": "-3.79939920"
                    },
                    {
                        "id": 152772,
                        "name": "Melque de Cercos",
                        "latitude": "41.05182310",
                        "longitude": "-4.46903290"
                    },
                    {
                        "id": 35393,
                        "name": "Membibre de la Hoz",
                        "latitude": "41.44958000",
                        "longitude": "-4.09571000"
                    },
                    {
                        "id": 35425,
                        "name": "Migueláñez",
                        "latitude": "41.12155000",
                        "longitude": "-4.36410000"
                    },
                    {
                        "id": 35553,
                        "name": "Montejo de Arévalo",
                        "latitude": "41.14027000",
                        "longitude": "-4.66414000"
                    },
                    {
                        "id": 35556,
                        "name": "Montejo de la Vega de la Serrezuela",
                        "latitude": "41.55032000",
                        "longitude": "-3.65406000"
                    },
                    {
                        "id": 35566,
                        "name": "Monterrubio",
                        "latitude": "40.84914000",
                        "longitude": "-4.35001000"
                    },
                    {
                        "id": 152773,
                        "name": "Moral de Hornuez",
                        "latitude": "41.46398400",
                        "longitude": "-3.61608140"
                    },
                    {
                        "id": 35649,
                        "name": "Mozoncillo",
                        "latitude": "41.14539000",
                        "longitude": "-4.18753000"
                    },
                    {
                        "id": 35697,
                        "name": "Muñopedro",
                        "latitude": "40.88804000",
                        "longitude": "-4.47213000"
                    },
                    {
                        "id": 35701,
                        "name": "Muñoveros",
                        "latitude": "41.17234000",
                        "longitude": "-3.95161000"
                    },
                    {
                        "id": 35726,
                        "name": "Nava de la Asunción",
                        "latitude": "41.15586000",
                        "longitude": "-4.48751000"
                    },
                    {
                        "id": 35735,
                        "name": "Navafría",
                        "latitude": "41.05514000",
                        "longitude": "-3.82478000"
                    },
                    {
                        "id": 35748,
                        "name": "Navalilla",
                        "latitude": "41.34146000",
                        "longitude": "-3.93211000"
                    },
                    {
                        "id": 35749,
                        "name": "Navalmanzano",
                        "latitude": "41.21594000",
                        "longitude": "-4.25631000"
                    },
                    {
                        "id": 35767,
                        "name": "Navares de Ayuso",
                        "latitude": "41.37447000",
                        "longitude": "-3.70745000"
                    },
                    {
                        "id": 35768,
                        "name": "Navares de Enmedio",
                        "latitude": "41.38096000",
                        "longitude": "-3.72283000"
                    },
                    {
                        "id": 35769,
                        "name": "Navares de las Cuevas",
                        "latitude": "41.41431000",
                        "longitude": "-3.75076000"
                    },
                    {
                        "id": 35780,
                        "name": "Navas de Oro",
                        "latitude": "41.19627000",
                        "longitude": "-4.43754000"
                    },
                    {
                        "id": 152785,
                        "name": "Navas de Riofrío",
                        "latitude": "40.86777140",
                        "longitude": "-4.13410450"
                    },
                    {
                        "id": 152774,
                        "name": "Navas de San Antonio",
                        "latitude": "40.76020490",
                        "longitude": "-4.32954340"
                    },
                    {
                        "id": 35806,
                        "name": "Nieva",
                        "latitude": "41.08191000",
                        "longitude": "-4.42501000"
                    },
                    {
                        "id": 35910,
                        "name": "Olombrada",
                        "latitude": "41.41492000",
                        "longitude": "-4.16071000"
                    },
                    {
                        "id": 152775,
                        "name": "Orejana",
                        "latitude": "41.16051220",
                        "longitude": "-3.77229310"
                    },
                    {
                        "id": 35962,
                        "name": "Ortigosa de Pestaño",
                        "latitude": "41.08741000",
                        "longitude": "-4.39516000"
                    },
                    {
                        "id": 35963,
                        "name": "Ortigosa del Monte",
                        "latitude": "40.84182000",
                        "longitude": "-4.17724000"
                    },
                    {
                        "id": 35979,
                        "name": "Otero de Herreros",
                        "latitude": "40.82016000",
                        "longitude": "-4.20990000"
                    },
                    {
                        "id": 35999,
                        "name": "Pajarejos",
                        "latitude": "41.38994000",
                        "longitude": "-3.58997000"
                    },
                    {
                        "id": 36019,
                        "name": "Palazuelos de Eresma",
                        "latitude": "40.93055000",
                        "longitude": "-4.06071000"
                    },
                    {
                        "id": 36092,
                        "name": "Pedraza",
                        "latitude": "41.13092000",
                        "longitude": "-3.81116000"
                    },
                    {
                        "id": 36123,
                        "name": "Pelayos del Arroyo",
                        "latitude": "41.05086000",
                        "longitude": "-3.94104000"
                    },
                    {
                        "id": 36152,
                        "name": "Perosillo",
                        "latitude": "41.39294000",
                        "longitude": "-4.14115000"
                    },
                    {
                        "id": 36194,
                        "name": "Pinarejos",
                        "latitude": "41.25950000",
                        "longitude": "-4.29364000"
                    },
                    {
                        "id": 36195,
                        "name": "Pinarnegrillo",
                        "latitude": "41.19098000",
                        "longitude": "-4.20967000"
                    },
                    {
                        "id": 36340,
                        "name": "Pradales",
                        "latitude": "41.45555000",
                        "longitude": "-3.70753000"
                    },
                    {
                        "id": 36404,
                        "name": "Prádena",
                        "latitude": "41.13911000",
                        "longitude": "-3.68823000"
                    },
                    {
                        "id": 36420,
                        "name": "Puebla de Pedraza",
                        "latitude": "41.20557000",
                        "longitude": "-3.91378000"
                    },
                    {
                        "id": 36546,
                        "name": "Rapariegos",
                        "latitude": "41.09498000",
                        "longitude": "-4.65271000"
                    },
                    {
                        "id": 152777,
                        "name": "Real Sitio de San Ildefonso",
                        "latitude": "40.90212260",
                        "longitude": "-4.00728990"
                    },
                    {
                        "id": 36555,
                        "name": "Rebollo",
                        "latitude": "41.19318000",
                        "longitude": "-3.85771000"
                    },
                    {
                        "id": 36574,
                        "name": "Remondo",
                        "latitude": "41.34100000",
                        "longitude": "-4.48390000"
                    },
                    {
                        "id": 36602,
                        "name": "Riaguas de San Bartolomé",
                        "latitude": "41.42640000",
                        "longitude": "-3.48893000"
                    },
                    {
                        "id": 36604,
                        "name": "Riaza",
                        "latitude": "41.27826000",
                        "longitude": "-3.47787000"
                    },
                    {
                        "id": 36619,
                        "name": "Ribota",
                        "latitude": "41.36477000",
                        "longitude": "-3.42964000"
                    },
                    {
                        "id": 152776,
                        "name": "Riofrío de Riaza",
                        "latitude": "41.24706300",
                        "longitude": "-3.44967680"
                    },
                    {
                        "id": 36662,
                        "name": "Roda de Eresma",
                        "latitude": "41.02852000",
                        "longitude": "-4.18130000"
                    },
                    {
                        "id": 36731,
                        "name": "Sacramenia",
                        "latitude": "41.49419000",
                        "longitude": "-3.96210000"
                    },
                    {
                        "id": 36790,
                        "name": "Samboal",
                        "latitude": "41.25758000",
                        "longitude": "-4.41727000"
                    },
                    {
                        "id": 36820,
                        "name": "San Cristóbal de Cuéllar",
                        "latitude": "41.40591000",
                        "longitude": "-4.40445000"
                    },
                    {
                        "id": 36825,
                        "name": "San Cristóbal de la Vega",
                        "latitude": "41.11214000",
                        "longitude": "-4.64448000"
                    },
                    {
                        "id": 36822,
                        "name": "San Cristóbal de Segovia",
                        "latitude": "40.95225000",
                        "longitude": "-4.07652000"
                    },
                    {
                        "id": 152778,
                        "name": "San Martín y Mudrián",
                        "latitude": "41.22916360",
                        "longitude": "-4.34623730"
                    },
                    {
                        "id": 152779,
                        "name": "San Miguel de Bernuy",
                        "latitude": "41.39829070",
                        "longitude": "-3.95181960"
                    },
                    {
                        "id": 36905,
                        "name": "San Pedro de Gaíllos",
                        "latitude": "41.22662000",
                        "longitude": "-3.80921000"
                    },
                    {
                        "id": 36936,
                        "name": "Sanchonuño",
                        "latitude": "41.32325000",
                        "longitude": "-4.30531000"
                    },
                    {
                        "id": 36943,
                        "name": "Sangarcía",
                        "latitude": "40.95023000",
                        "longitude": "-4.41085000"
                    },
                    {
                        "id": 37091,
                        "name": "Santa María la Real de Nieva",
                        "latitude": "41.06998000",
                        "longitude": "-4.40709000"
                    },
                    {
                        "id": 37073,
                        "name": "Santa Marta del Cerro",
                        "latitude": "41.21843000",
                        "longitude": "-3.68582000"
                    },
                    {
                        "id": 152780,
                        "name": "Santiuste de Pedraza",
                        "latitude": "41.08452210",
                        "longitude": "-3.89608110"
                    },
                    {
                        "id": 37137,
                        "name": "Santiuste de San Juan Bautista",
                        "latitude": "41.15593000",
                        "longitude": "-4.57202000"
                    },
                    {
                        "id": 37139,
                        "name": "Santo Domingo de Pirón",
                        "latitude": "41.04104000",
                        "longitude": "-3.98933000"
                    },
                    {
                        "id": 152781,
                        "name": "Santo Tomé del Puerto",
                        "latitude": "41.19409580",
                        "longitude": "-3.57729910"
                    },
                    {
                        "id": 37179,
                        "name": "Sauquillo de Cabezas",
                        "latitude": "41.19422000",
                        "longitude": "-4.06884000"
                    },
                    {
                        "id": 37185,
                        "name": "Sebúlcor",
                        "latitude": "41.27091000",
                        "longitude": "-3.88398000"
                    },
                    {
                        "id": 37192,
                        "name": "Segovia",
                        "latitude": "40.94808000",
                        "longitude": "-4.11839000"
                    },
                    {
                        "id": 37215,
                        "name": "Sepúlveda",
                        "latitude": "41.29695000",
                        "longitude": "-3.74221000"
                    },
                    {
                        "id": 37216,
                        "name": "Sequera de Fresno",
                        "latitude": "41.36640000",
                        "longitude": "-3.54612000"
                    },
                    {
                        "id": 37312,
                        "name": "Sotillo",
                        "latitude": "41.25846000",
                        "longitude": "-3.63729000"
                    },
                    {
                        "id": 37323,
                        "name": "Sotosalbos",
                        "latitude": "41.03537000",
                        "longitude": "-3.94115000"
                    },
                    {
                        "id": 37341,
                        "name": "Tabanera la Luenga",
                        "latitude": "41.09647000",
                        "longitude": "-4.23937000"
                    },
                    {
                        "id": 37445,
                        "name": "Tolocirio",
                        "latitude": "41.13425000",
                        "longitude": "-4.65121000"
                    },
                    {
                        "id": 37489,
                        "name": "Torre Val de San Pedro",
                        "latitude": "41.07534000",
                        "longitude": "-3.87116000"
                    },
                    {
                        "id": 37508,
                        "name": "Torreadrada",
                        "latitude": "41.44474000",
                        "longitude": "-3.84000000"
                    },
                    {
                        "id": 37512,
                        "name": "Torrecaballeros",
                        "latitude": "40.99211000",
                        "longitude": "-4.02470000"
                    },
                    {
                        "id": 37522,
                        "name": "Torrecilla del Pinar",
                        "latitude": "41.37360000",
                        "longitude": "-4.03838000"
                    },
                    {
                        "id": 37535,
                        "name": "Torreiglesias",
                        "latitude": "41.10236000",
                        "longitude": "-4.03280000"
                    },
                    {
                        "id": 37630,
                        "name": "Trescasas",
                        "latitude": "40.96442000",
                        "longitude": "-4.03590000"
                    },
                    {
                        "id": 37658,
                        "name": "Turégano",
                        "latitude": "41.15610000",
                        "longitude": "-4.00696000"
                    },
                    {
                        "id": 37699,
                        "name": "Urueñas",
                        "latitude": "41.35589000",
                        "longitude": "-3.77391000"
                    },
                    {
                        "id": 37789,
                        "name": "Valdeprados",
                        "latitude": "40.81766000",
                        "longitude": "-4.25734000"
                    },
                    {
                        "id": 37805,
                        "name": "Valdevacas de Montejo",
                        "latitude": "41.52068000",
                        "longitude": "-3.63571000"
                    },
                    {
                        "id": 152782,
                        "name": "Valdevacas y Guijar",
                        "latitude": "41.14415610",
                        "longitude": "-3.91645850"
                    },
                    {
                        "id": 37847,
                        "name": "Valle de Tabladillo",
                        "latitude": "41.36304000",
                        "longitude": "-3.83966000"
                    },
                    {
                        "id": 37852,
                        "name": "Vallelado",
                        "latitude": "41.40436000",
                        "longitude": "-4.42662000"
                    },
                    {
                        "id": 37853,
                        "name": "Valleruela de Pedraza",
                        "latitude": "41.17937000",
                        "longitude": "-3.80717000"
                    },
                    {
                        "id": 37854,
                        "name": "Valleruela de Sepúlveda",
                        "latitude": "41.18794000",
                        "longitude": "-3.77277000"
                    },
                    {
                        "id": 37874,
                        "name": "Valseca",
                        "latitude": "40.99933000",
                        "longitude": "-4.17514000"
                    },
                    {
                        "id": 37878,
                        "name": "Valtiendas",
                        "latitude": "41.47851000",
                        "longitude": "-3.91766000"
                    },
                    {
                        "id": 37895,
                        "name": "Valverde del Majano",
                        "latitude": "40.95689000",
                        "longitude": "-4.23468000"
                    },
                    {
                        "id": 37917,
                        "name": "Veganzones",
                        "latitude": "41.19308000",
                        "longitude": "-3.99329000"
                    },
                    {
                        "id": 37919,
                        "name": "Vegas de Matute",
                        "latitude": "40.79476000",
                        "longitude": "-4.27762000"
                    },
                    {
                        "id": 152783,
                        "name": "Ventosilla y Tejadilla",
                        "latitude": "41.18684940",
                        "longitude": "-3.68768030"
                    },
                    {
                        "id": 38027,
                        "name": "Villacastín",
                        "latitude": "40.77960000",
                        "longitude": "-4.41357000"
                    },
                    {
                        "id": 152784,
                        "name": "Villaverde de Íscar",
                        "latitude": "41.30677250",
                        "longitude": "-4.52699230"
                    },
                    {
                        "id": 38347,
                        "name": "Villaverde de Montejo",
                        "latitude": "41.52225000",
                        "longitude": "-3.65452000"
                    },
                    {
                        "id": 38366,
                        "name": "Villeguillo",
                        "latitude": "41.25290000",
                        "longitude": "-4.57951000"
                    },
                    {
                        "id": 38427,
                        "name": "Yanguas de Eresma",
                        "latitude": "41.07201000",
                        "longitude": "-4.23905000"
                    },
                    {
                        "id": 38486,
                        "name": "Zarzuela del Monte",
                        "latitude": "40.80888000",
                        "longitude": "-4.33613000"
                    },
                    {
                        "id": 38487,
                        "name": "Zarzuela del Pinar",
                        "latitude": "41.26018000",
                        "longitude": "-4.18457000"
                    }
                ]
            },
            {
                "id": 1193,
                "name": "Sevilla",
                "iso2": "SE",
                "latitude": "37.37535010",
                "longitude": "-6.02509730",
                "type": "province",
                "cities": [
                    {
                        "id": 31951,
                        "name": "Aguadulce",
                        "latitude": "37.25273000",
                        "longitude": "-4.99269000"
                    },
                    {
                        "id": 32000,
                        "name": "Alanís",
                        "latitude": "38.03333000",
                        "longitude": "-5.71667000"
                    },
                    {
                        "id": 32015,
                        "name": "Albaida del Aljarafe",
                        "latitude": "37.42354000",
                        "longitude": "-6.16675000"
                    },
                    {
                        "id": 32070,
                        "name": "Alcalá de Guadaira",
                        "latitude": "37.33791000",
                        "longitude": "-5.83951000"
                    },
                    {
                        "id": 32079,
                        "name": "Alcalá del Río",
                        "latitude": "37.51780000",
                        "longitude": "-5.98185000"
                    },
                    {
                        "id": 32109,
                        "name": "Alcolea del Río",
                        "latitude": "37.61506000",
                        "longitude": "-5.66694000"
                    },
                    {
                        "id": 151451,
                        "name": "Algaba La",
                        "latitude": "37.45874610",
                        "longitude": "-6.01363170"
                    },
                    {
                        "id": 32231,
                        "name": "Algámitas",
                        "latitude": "37.01516000",
                        "longitude": "-5.14949000"
                    },
                    {
                        "id": 32262,
                        "name": "Almadén de la Plata",
                        "latitude": "37.87221000",
                        "longitude": "-6.08085000"
                    },
                    {
                        "id": 32289,
                        "name": "Almensilla",
                        "latitude": "37.31099000",
                        "longitude": "-6.10998000"
                    },
                    {
                        "id": 151452,
                        "name": "Arahal",
                        "latitude": "37.18733690",
                        "longitude": "-5.58273340"
                    },
                    {
                        "id": 32584,
                        "name": "Aznalcázar",
                        "latitude": "37.30422000",
                        "longitude": "-6.24963000"
                    },
                    {
                        "id": 32585,
                        "name": "Aznalcóllar",
                        "latitude": "37.51914000",
                        "longitude": "-6.26988000"
                    },
                    {
                        "id": 32604,
                        "name": "Badolatosa",
                        "latitude": "37.30785000",
                        "longitude": "-4.67296000"
                    },
                    {
                        "id": 32757,
                        "name": "Benacazón",
                        "latitude": "37.35289000",
                        "longitude": "-6.19663000"
                    },
                    {
                        "id": 32938,
                        "name": "Bollullos de la Mitación",
                        "latitude": "37.34014000",
                        "longitude": "-6.13719000"
                    },
                    {
                        "id": 32956,
                        "name": "Bormujos",
                        "latitude": "37.37358000",
                        "longitude": "-6.07233000"
                    },
                    {
                        "id": 32977,
                        "name": "Brenes",
                        "latitude": "37.54944000",
                        "longitude": "-5.87139000"
                    },
                    {
                        "id": 33027,
                        "name": "Burguillos",
                        "latitude": "37.58440000",
                        "longitude": "-5.96654000"
                    },
                    {
                        "id": 151453,
                        "name": "Cabezas de San Juan Las",
                        "latitude": "36.98028730",
                        "longitude": "-5.93832910"
                    },
                    {
                        "id": 33172,
                        "name": "Camas",
                        "latitude": "37.40202000",
                        "longitude": "-6.03314000"
                    },
                    {
                        "id": 151454,
                        "name": "Campana La",
                        "latitude": "37.56874130",
                        "longitude": "-5.42668520"
                    },
                    {
                        "id": 33526,
                        "name": "Cañada Rosal",
                        "latitude": "37.59924000",
                        "longitude": "-5.21016000"
                    },
                    {
                        "id": 33257,
                        "name": "Cantillana",
                        "latitude": "37.61032000",
                        "longitude": "-5.82472000"
                    },
                    {
                        "id": 33310,
                        "name": "Carmona",
                        "latitude": "37.47125000",
                        "longitude": "-5.64608000"
                    },
                    {
                        "id": 33333,
                        "name": "Carrión de los Céspedes",
                        "latitude": "37.37007000",
                        "longitude": "-6.32923000"
                    },
                    {
                        "id": 33352,
                        "name": "Casariche",
                        "latitude": "37.29389000",
                        "longitude": "-4.75972000"
                    },
                    {
                        "id": 33447,
                        "name": "Castilblanco de los Arroyos",
                        "latitude": "37.67576000",
                        "longitude": "-5.98886000"
                    },
                    {
                        "id": 33454,
                        "name": "Castilleja de Guzmán",
                        "latitude": "37.40955000",
                        "longitude": "-6.05515000"
                    },
                    {
                        "id": 33455,
                        "name": "Castilleja de la Cuesta",
                        "latitude": "37.38594000",
                        "longitude": "-6.05258000"
                    },
                    {
                        "id": 33456,
                        "name": "Castilleja del Campo",
                        "latitude": "37.38627000",
                        "longitude": "-6.33443000"
                    },
                    {
                        "id": 151455,
                        "name": "Castillo de las Guardas El",
                        "latitude": "37.69231710",
                        "longitude": "-6.31529690"
                    },
                    {
                        "id": 33523,
                        "name": "Cazalla de la Sierra",
                        "latitude": "37.93333000",
                        "longitude": "-5.75000000"
                    },
                    {
                        "id": 33765,
                        "name": "Constantina",
                        "latitude": "37.86667000",
                        "longitude": "-5.61667000"
                    },
                    {
                        "id": 33790,
                        "name": "Coria del Río",
                        "latitude": "37.28766000",
                        "longitude": "-6.05410000"
                    },
                    {
                        "id": 33791,
                        "name": "Coripe",
                        "latitude": "36.97335000",
                        "longitude": "-5.44022000"
                    },
                    {
                        "id": 151456,
                        "name": "Coronil El",
                        "latitude": "37.07936530",
                        "longitude": "-5.63379830"
                    },
                    {
                        "id": 151457,
                        "name": "Corrales Los",
                        "latitude": "37.10033910",
                        "longitude": "-4.98574960"
                    },
                    {
                        "id": 151478,
                        "name": "Cuervo de Sevilla El",
                        "latitude": "36.85279760",
                        "longitude": "-6.03852350"
                    },
                    {
                        "id": 33949,
                        "name": "Dos Hermanas",
                        "latitude": "37.28287000",
                        "longitude": "-5.92088000"
                    },
                    {
                        "id": 38577,
                        "name": "Écija",
                        "latitude": "37.54220000",
                        "longitude": "-5.08260000"
                    },
                    {
                        "id": 34109,
                        "name": "Espartinas",
                        "latitude": "37.38154000",
                        "longitude": "-6.12578000"
                    },
                    {
                        "id": 34141,
                        "name": "Estepa",
                        "latitude": "37.29263000",
                        "longitude": "-4.87896000"
                    },
                    {
                        "id": 34338,
                        "name": "Fuentes de Andalucía",
                        "latitude": "37.46409000",
                        "longitude": "-5.34615000"
                    },
                    {
                        "id": 151458,
                        "name": "Garrobo El",
                        "latitude": "37.62765450",
                        "longitude": "-6.17258560"
                    },
                    {
                        "id": 34448,
                        "name": "Gelves",
                        "latitude": "37.33481000",
                        "longitude": "-6.02601000"
                    },
                    {
                        "id": 34454,
                        "name": "Gerena",
                        "latitude": "37.52957000",
                        "longitude": "-6.15479000"
                    },
                    {
                        "id": 34463,
                        "name": "Gilena",
                        "latitude": "37.25150000",
                        "longitude": "-4.91442000"
                    },
                    {
                        "id": 34467,
                        "name": "Gines",
                        "latitude": "37.38647000",
                        "longitude": "-6.07729000"
                    },
                    {
                        "id": 34522,
                        "name": "Guadalcanal",
                        "latitude": "38.10000000",
                        "longitude": "-5.81667000"
                    },
                    {
                        "id": 34548,
                        "name": "Guillena",
                        "latitude": "37.54262000",
                        "longitude": "-6.05626000"
                    },
                    {
                        "id": 34593,
                        "name": "Herrera",
                        "latitude": "37.36396000",
                        "longitude": "-4.84979000"
                    },
                    {
                        "id": 151459,
                        "name": "Huévar del Aljarafe",
                        "latitude": "37.35665510",
                        "longitude": "-6.27733950"
                    },
                    {
                        "id": 151477,
                        "name": "Isla Mayor",
                        "latitude": "37.13325080",
                        "longitude": "-6.16583510"
                    },
                    {
                        "id": 151460,
                        "name": "Lantejuela La",
                        "latitude": "37.35444580",
                        "longitude": "-5.22275260"
                    },
                    {
                        "id": 35011,
                        "name": "Lebrija",
                        "latitude": "36.92077000",
                        "longitude": "-6.07529000"
                    },
                    {
                        "id": 35110,
                        "name": "Lora de Estepa",
                        "latitude": "37.26926000",
                        "longitude": "-4.82759000"
                    },
                    {
                        "id": 35111,
                        "name": "Lora del Río",
                        "latitude": "37.65896000",
                        "longitude": "-5.52751000"
                    },
                    {
                        "id": 151461,
                        "name": "Luisiana La",
                        "latitude": "37.52628410",
                        "longitude": "-5.24885730"
                    },
                    {
                        "id": 151462,
                        "name": "Madroño El",
                        "latitude": "37.65271470",
                        "longitude": "-6.47165800"
                    },
                    {
                        "id": 35212,
                        "name": "Mairena del Alcor",
                        "latitude": "37.37301000",
                        "longitude": "-5.74951000"
                    },
                    {
                        "id": 35213,
                        "name": "Mairena del Aljarafe",
                        "latitude": "37.34461000",
                        "longitude": "-6.06391000"
                    },
                    {
                        "id": 35285,
                        "name": "Marchena",
                        "latitude": "37.32900000",
                        "longitude": "-5.41681000"
                    },
                    {
                        "id": 35291,
                        "name": "Marinaleda",
                        "latitude": "37.37120000",
                        "longitude": "-4.95949000"
                    },
                    {
                        "id": 35307,
                        "name": "Martín de la Jara",
                        "latitude": "37.10867000",
                        "longitude": "-4.96347000"
                    },
                    {
                        "id": 151463,
                        "name": "Molares Los",
                        "latitude": "37.15622950",
                        "longitude": "-5.71915640"
                    },
                    {
                        "id": 35557,
                        "name": "Montellano",
                        "latitude": "36.99531000",
                        "longitude": "-5.57145000"
                    },
                    {
                        "id": 35636,
                        "name": "Morón de la Frontera",
                        "latitude": "37.12084000",
                        "longitude": "-5.45403000"
                    },
                    {
                        "id": 151464,
                        "name": "Navas de la Concepción Las",
                        "latitude": "37.93324890",
                        "longitude": "-5.46555420"
                    },
                    {
                        "id": 35888,
                        "name": "Olivares",
                        "latitude": "37.41802000",
                        "longitude": "-6.15603000"
                    },
                    {
                        "id": 35975,
                        "name": "Osuna",
                        "latitude": "37.23760000",
                        "longitude": "-5.10311000"
                    },
                    {
                        "id": 151465,
                        "name": "Palacios y Villafranca Los",
                        "latitude": "37.15846360",
                        "longitude": "-5.92448080"
                    },
                    {
                        "id": 36037,
                        "name": "Palomares del Río",
                        "latitude": "37.32225000",
                        "longitude": "-6.05863000"
                    },
                    {
                        "id": 36058,
                        "name": "Paradas",
                        "latitude": "37.29047000",
                        "longitude": "-5.49703000"
                    },
                    {
                        "id": 36096,
                        "name": "Pedrera",
                        "latitude": "37.22604000",
                        "longitude": "-4.89420000"
                    },
                    {
                        "id": 151466,
                        "name": "Pedroso El",
                        "latitude": "37.84156670",
                        "longitude": "-5.76553430"
                    },
                    {
                        "id": 36163,
                        "name": "Peñaflor",
                        "latitude": "37.70892000",
                        "longitude": "-5.34504000"
                    },
                    {
                        "id": 36188,
                        "name": "Pilas",
                        "latitude": "37.30337000",
                        "longitude": "-6.30097000"
                    },
                    {
                        "id": 36401,
                        "name": "Pruna",
                        "latitude": "36.97226000",
                        "longitude": "-5.22230000"
                    },
                    {
                        "id": 151467,
                        "name": "Puebla de Cazalla La",
                        "latitude": "37.22236530",
                        "longitude": "-5.31417140"
                    },
                    {
                        "id": 151468,
                        "name": "Puebla de los Infantes La",
                        "latitude": "37.78039300",
                        "longitude": "-5.38957780"
                    },
                    {
                        "id": 151469,
                        "name": "Puebla del Río La",
                        "latitude": "37.26940650",
                        "longitude": "-6.06313300"
                    },
                    {
                        "id": 151470,
                        "name": "Real de la Jara El",
                        "latitude": "37.94872530",
                        "longitude": "-6.15402410"
                    },
                    {
                        "id": 151471,
                        "name": "Rinconada La",
                        "latitude": "37.48726810",
                        "longitude": "-5.98164240"
                    },
                    {
                        "id": 151472,
                        "name": "Roda de Andalucía La",
                        "latitude": "37.20133850",
                        "longitude": "-4.77863780"
                    },
                    {
                        "id": 151473,
                        "name": "Ronquillo El",
                        "latitude": "37.72611180",
                        "longitude": "-6.17722680"
                    },
                    {
                        "id": 151474,
                        "name": "Rubio El",
                        "latitude": "37.35377700",
                        "longitude": "-4.99094780"
                    },
                    {
                        "id": 36779,
                        "name": "Salteras",
                        "latitude": "37.42060000",
                        "longitude": "-6.11049000"
                    },
                    {
                        "id": 36844,
                        "name": "San Juan de Aznalfarache",
                        "latitude": "37.35813000",
                        "longitude": "-6.03731000"
                    },
                    {
                        "id": 36896,
                        "name": "San Nicolás del Puerto",
                        "latitude": "38.00000000",
                        "longitude": "-5.65000000"
                    },
                    {
                        "id": 36949,
                        "name": "Sanlúcar la Mayor",
                        "latitude": "37.38758000",
                        "longitude": "-6.20346000"
                    },
                    {
                        "id": 37131,
                        "name": "Santiponce",
                        "latitude": "37.43553000",
                        "longitude": "-6.04106000"
                    },
                    {
                        "id": 151475,
                        "name": "Saucejo El",
                        "latitude": "37.07419080",
                        "longitude": "-5.09761610"
                    },
                    {
                        "id": 37239,
                        "name": "Sevilla",
                        "latitude": "37.38283000",
                        "longitude": "-5.97317000"
                    },
                    {
                        "id": 37439,
                        "name": "Tocina",
                        "latitude": "37.60904000",
                        "longitude": "-5.73403000"
                    },
                    {
                        "id": 37449,
                        "name": "Tomares",
                        "latitude": "37.37281000",
                        "longitude": "-6.04589000"
                    },
                    {
                        "id": 37685,
                        "name": "Umbrete",
                        "latitude": "37.36881000",
                        "longitude": "-6.15847000"
                    },
                    {
                        "id": 37711,
                        "name": "Utrera",
                        "latitude": "37.18516000",
                        "longitude": "-5.78093000"
                    },
                    {
                        "id": 37822,
                        "name": "Valencina de la Concepción",
                        "latitude": "37.41618000",
                        "longitude": "-6.07422000"
                    },
                    {
                        "id": 38132,
                        "name": "Villamanrique de la Condesa",
                        "latitude": "37.24481000",
                        "longitude": "-6.30665000"
                    },
                    {
                        "id": 38189,
                        "name": "Villanueva de San Juan",
                        "latitude": "37.04955000",
                        "longitude": "-5.17540000"
                    },
                    {
                        "id": 38212,
                        "name": "Villanueva del Ariscal",
                        "latitude": "37.39623000",
                        "longitude": "-6.14077000"
                    },
                    {
                        "id": 38223,
                        "name": "Villanueva del Río y Minas",
                        "latitude": "37.65502000",
                        "longitude": "-5.71369000"
                    },
                    {
                        "id": 38350,
                        "name": "Villaverde del Río",
                        "latitude": "37.58919000",
                        "longitude": "-5.87443000"
                    },
                    {
                        "id": 151476,
                        "name": "Viso del Alcor El",
                        "latitude": "37.38868620",
                        "longitude": "-5.72178110"
                    }
                ]
            },
            {
                "id": 1208,
                "name": "Soria",
                "iso2": "SO",
                "latitude": "41.76654640",
                "longitude": "-2.47903060",
                "type": "province",
                "cities": [
                    {
                        "id": 31907,
                        "name": "Abejar",
                        "latitude": "41.80755000",
                        "longitude": "-2.78407000"
                    },
                    {
                        "id": 31939,
                        "name": "Adradas",
                        "latitude": "41.35098000",
                        "longitude": "-2.47373000"
                    },
                    {
                        "id": 38573,
                        "name": "Ágreda",
                        "latitude": "41.85588000",
                        "longitude": "-1.92244000"
                    },
                    {
                        "id": 32112,
                        "name": "Alconaba",
                        "latitude": "41.72360000",
                        "longitude": "-2.38483000"
                    },
                    {
                        "id": 32125,
                        "name": "Alcubilla de Avellaneda",
                        "latitude": "41.72593000",
                        "longitude": "-3.30471000"
                    },
                    {
                        "id": 32127,
                        "name": "Alcubilla de las Peñas",
                        "latitude": "41.25129000",
                        "longitude": "-2.52684000"
                    },
                    {
                        "id": 32150,
                        "name": "Aldealafuente",
                        "latitude": "41.67194000",
                        "longitude": "-2.32522000"
                    },
                    {
                        "id": 152786,
                        "name": "Aldealices",
                        "latitude": "41.90177340",
                        "longitude": "-2.30953060"
                    },
                    {
                        "id": 32154,
                        "name": "Aldealpozo",
                        "latitude": "41.78258000",
                        "longitude": "-2.20416000"
                    },
                    {
                        "id": 32155,
                        "name": "Aldealseñor",
                        "latitude": "41.87890000",
                        "longitude": "-2.31565000"
                    },
                    {
                        "id": 152787,
                        "name": "Aldehuela de Periáñez",
                        "latitude": "41.80749040",
                        "longitude": "-2.30706620"
                    },
                    {
                        "id": 152788,
                        "name": "Aldehuelas Las",
                        "latitude": "41.99436040",
                        "longitude": "-2.36455020"
                    },
                    {
                        "id": 32184,
                        "name": "Alentisque",
                        "latitude": "41.42059000",
                        "longitude": "-2.33189000"
                    },
                    {
                        "id": 32249,
                        "name": "Aliud",
                        "latitude": "41.65412000",
                        "longitude": "-2.25314000"
                    },
                    {
                        "id": 32264,
                        "name": "Almajano",
                        "latitude": "41.85095000",
                        "longitude": "-2.33830000"
                    },
                    {
                        "id": 32265,
                        "name": "Almaluez",
                        "latitude": "41.28932000",
                        "longitude": "-2.26871000"
                    },
                    {
                        "id": 32271,
                        "name": "Almarza",
                        "latitude": "41.94678000",
                        "longitude": "-2.46900000"
                    },
                    {
                        "id": 32275,
                        "name": "Almazán",
                        "latitude": "41.48648000",
                        "longitude": "-2.53088000"
                    },
                    {
                        "id": 32274,
                        "name": "Almazul",
                        "latitude": "41.57400000",
                        "longitude": "-2.14620000"
                    },
                    {
                        "id": 32281,
                        "name": "Almenar de Soria",
                        "latitude": "41.68230000",
                        "longitude": "-2.20082000"
                    },
                    {
                        "id": 32325,
                        "name": "Alpanseque",
                        "latitude": "41.26505000",
                        "longitude": "-2.67064000"
                    },
                    {
                        "id": 32406,
                        "name": "Arancón",
                        "latitude": "41.80017000",
                        "longitude": "-2.28141000"
                    },
                    {
                        "id": 32436,
                        "name": "Arcos de Jalón",
                        "latitude": "41.21592000",
                        "longitude": "-2.27470000"
                    },
                    {
                        "id": 32449,
                        "name": "Arenillas",
                        "latitude": "41.34706000",
                        "longitude": "-2.84618000"
                    },
                    {
                        "id": 32532,
                        "name": "Arévalo de la Sierra",
                        "latitude": "41.94723000",
                        "longitude": "-2.40033000"
                    },
                    {
                        "id": 32559,
                        "name": "Ausejo de la Sierra",
                        "latitude": "41.89462000",
                        "longitude": "-2.37394000"
                    },
                    {
                        "id": 152789,
                        "name": "Baraona",
                        "latitude": "41.29608760",
                        "longitude": "-2.65677780"
                    },
                    {
                        "id": 32651,
                        "name": "Barca",
                        "latitude": "41.45490000",
                        "longitude": "-2.62217000"
                    },
                    {
                        "id": 32659,
                        "name": "Barcones",
                        "latitude": "41.29146000",
                        "longitude": "-2.81630000"
                    },
                    {
                        "id": 32697,
                        "name": "Bayubas de Abajo",
                        "latitude": "41.52747000",
                        "longitude": "-2.89586000"
                    },
                    {
                        "id": 32698,
                        "name": "Bayubas de Arriba",
                        "latitude": "41.55750000",
                        "longitude": "-2.88731000"
                    },
                    {
                        "id": 32833,
                        "name": "Beratón",
                        "latitude": "41.71749000",
                        "longitude": "-1.81092000"
                    },
                    {
                        "id": 32855,
                        "name": "Berlanga de Duero",
                        "latitude": "41.46560000",
                        "longitude": "-2.86147000"
                    },
                    {
                        "id": 32904,
                        "name": "Blacos",
                        "latitude": "41.68090000",
                        "longitude": "-2.85826000"
                    },
                    {
                        "id": 32913,
                        "name": "Bliecos",
                        "latitude": "41.52790000",
                        "longitude": "-2.27135000"
                    },
                    {
                        "id": 32955,
                        "name": "Borjabad",
                        "latitude": "41.55245000",
                        "longitude": "-2.36625000"
                    },
                    {
                        "id": 32958,
                        "name": "Borobia",
                        "latitude": "41.66481000",
                        "longitude": "-1.89615000"
                    },
                    {
                        "id": 32995,
                        "name": "Buberos",
                        "latitude": "41.64692000",
                        "longitude": "-2.19406000"
                    },
                    {
                        "id": 33012,
                        "name": "Buitrago",
                        "latitude": "41.84735000",
                        "longitude": "-2.40858000"
                    },
                    {
                        "id": 152790,
                        "name": "Burgo de Osma-Ciudad de Osma",
                        "latitude": "41.58756500",
                        "longitude": "-3.06685490"
                    },
                    {
                        "id": 33102,
                        "name": "Cabrejas del Campo",
                        "latitude": "41.68096000",
                        "longitude": "-2.26964000"
                    },
                    {
                        "id": 33103,
                        "name": "Cabrejas del Pinar",
                        "latitude": "41.79596000",
                        "longitude": "-2.84945000"
                    },
                    {
                        "id": 33133,
                        "name": "Calatañazor",
                        "latitude": "41.69879000",
                        "longitude": "-2.81837000"
                    },
                    {
                        "id": 33152,
                        "name": "Caltojar",
                        "latitude": "41.40226000",
                        "longitude": "-2.76436000"
                    },
                    {
                        "id": 33531,
                        "name": "Cañamaque",
                        "latitude": "41.44453000",
                        "longitude": "-2.23792000"
                    },
                    {
                        "id": 33229,
                        "name": "Candilichera",
                        "latitude": "41.70434000",
                        "longitude": "-2.30123000"
                    },
                    {
                        "id": 33273,
                        "name": "Carabantes",
                        "latitude": "41.55211000",
                        "longitude": "-1.99810000"
                    },
                    {
                        "id": 33275,
                        "name": "Caracena",
                        "latitude": "41.38321000",
                        "longitude": "-3.09146000"
                    },
                    {
                        "id": 33322,
                        "name": "Carrascosa de Abajo",
                        "latitude": "41.42338000",
                        "longitude": "-3.08955000"
                    },
                    {
                        "id": 33324,
                        "name": "Carrascosa de la Sierra",
                        "latitude": "41.89535000",
                        "longitude": "-2.28003000"
                    },
                    {
                        "id": 33349,
                        "name": "Casarejos",
                        "latitude": "41.79651000",
                        "longitude": "-3.03251000"
                    },
                    {
                        "id": 33451,
                        "name": "Castilfrío de la Sierra",
                        "latitude": "41.91929000",
                        "longitude": "-2.30497000"
                    },
                    {
                        "id": 33460,
                        "name": "Castillejo de Robledo",
                        "latitude": "41.55867000",
                        "longitude": "-3.49689000"
                    },
                    {
                        "id": 33470,
                        "name": "Castilruiz",
                        "latitude": "41.87678000",
                        "longitude": "-2.05930000"
                    },
                    {
                        "id": 33575,
                        "name": "Centenera de Andaluz",
                        "latitude": "41.50679000",
                        "longitude": "-2.71813000"
                    },
                    {
                        "id": 33578,
                        "name": "Cerbón",
                        "latitude": "41.92934000",
                        "longitude": "-2.16895000"
                    },
                    {
                        "id": 33657,
                        "name": "Cidones",
                        "latitude": "41.81444000",
                        "longitude": "-2.63991000"
                    },
                    {
                        "id": 33662,
                        "name": "Cigudosa",
                        "latitude": "41.93333000",
                        "longitude": "-2.05000000"
                    },
                    {
                        "id": 33664,
                        "name": "Cihuela",
                        "latitude": "41.40721000",
                        "longitude": "-1.99989000"
                    },
                    {
                        "id": 33683,
                        "name": "Ciria",
                        "latitude": "41.61831000",
                        "longitude": "-1.96578000"
                    },
                    {
                        "id": 33689,
                        "name": "Cirujales del Río",
                        "latitude": "41.86691000",
                        "longitude": "-2.32549000"
                    },
                    {
                        "id": 33816,
                        "name": "Coscurita",
                        "latitude": "41.43483000",
                        "longitude": "-2.47571000"
                    },
                    {
                        "id": 33826,
                        "name": "Covaleda",
                        "latitude": "41.93493000",
                        "longitude": "-2.88325000"
                    },
                    {
                        "id": 33849,
                        "name": "Cubilla",
                        "latitude": "41.74905000",
                        "longitude": "-2.93717000"
                    },
                    {
                        "id": 33861,
                        "name": "Cubo de la Solana",
                        "latitude": "41.60224000",
                        "longitude": "-2.42179000"
                    },
                    {
                        "id": 33867,
                        "name": "Cueva de Ágreda",
                        "latitude": "41.76310000",
                        "longitude": "-1.88818000"
                    },
                    {
                        "id": 152791,
                        "name": "Dévanos",
                        "latitude": "41.90381640",
                        "longitude": "-1.94718760"
                    },
                    {
                        "id": 33931,
                        "name": "Deza",
                        "latitude": "41.46373000",
                        "longitude": "-2.02046000"
                    },
                    {
                        "id": 33963,
                        "name": "Duruelo de la Sierra",
                        "latitude": "41.95448000",
                        "longitude": "-2.93086000"
                    },
                    {
                        "id": 34087,
                        "name": "Escobosa de Almazán",
                        "latitude": "41.48626000",
                        "longitude": "-2.37140000"
                    },
                    {
                        "id": 34111,
                        "name": "Espeja de San Marcelino",
                        "latitude": "41.80227000",
                        "longitude": "-3.22230000"
                    },
                    {
                        "id": 34113,
                        "name": "Espejón",
                        "latitude": "41.83023000",
                        "longitude": "-3.25936000"
                    },
                    {
                        "id": 34142,
                        "name": "Estepa de San Juan",
                        "latitude": "41.92661000",
                        "longitude": "-2.33322000"
                    },
                    {
                        "id": 34241,
                        "name": "Frechilla de Almazán",
                        "latitude": "41.42656000",
                        "longitude": "-2.51444000"
                    },
                    {
                        "id": 34256,
                        "name": "Fresno de Caracena",
                        "latitude": "41.45247000",
                        "longitude": "-3.09123000"
                    },
                    {
                        "id": 34310,
                        "name": "Fuentearmegil",
                        "latitude": "41.71496000",
                        "longitude": "-3.18362000"
                    },
                    {
                        "id": 34312,
                        "name": "Fuentecambrón",
                        "latitude": "41.50579000",
                        "longitude": "-3.32872000"
                    },
                    {
                        "id": 34313,
                        "name": "Fuentecantos",
                        "latitude": "41.84929000",
                        "longitude": "-2.42846000"
                    },
                    {
                        "id": 152792,
                        "name": "Fuentelmonge",
                        "latitude": "41.41995150",
                        "longitude": "-2.18494290"
                    },
                    {
                        "id": 34325,
                        "name": "Fuentelsaz de Soria",
                        "latitude": "41.86586000",
                        "longitude": "-2.41525000"
                    },
                    {
                        "id": 34331,
                        "name": "Fuentepinilla",
                        "latitude": "41.56683000",
                        "longitude": "-2.76288000"
                    },
                    {
                        "id": 34346,
                        "name": "Fuentes de Magaña",
                        "latitude": "41.93521000",
                        "longitude": "-2.17950000"
                    },
                    {
                        "id": 34359,
                        "name": "Fuentestrún",
                        "latitude": "41.87466000",
                        "longitude": "-2.08283000"
                    },
                    {
                        "id": 34423,
                        "name": "Garray",
                        "latitude": "41.81617000",
                        "longitude": "-2.44592000"
                    },
                    {
                        "id": 34478,
                        "name": "Golmayo",
                        "latitude": "41.76620000",
                        "longitude": "-2.52267000"
                    },
                    {
                        "id": 34564,
                        "name": "Gómara",
                        "latitude": "41.62347000",
                        "longitude": "-2.22493000"
                    },
                    {
                        "id": 34488,
                        "name": "Gormaz",
                        "latitude": "41.49232000",
                        "longitude": "-3.00500000"
                    },
                    {
                        "id": 34596,
                        "name": "Herrera de Soria",
                        "latitude": "41.76269000",
                        "longitude": "-3.01243000"
                    },
                    {
                        "id": 34626,
                        "name": "Hinojosa del Campo",
                        "latitude": "41.73844000",
                        "longitude": "-2.09946000"
                    },
                    {
                        "id": 34963,
                        "name": "Langa de Duero",
                        "latitude": "41.60985000",
                        "longitude": "-3.40061000"
                    },
                    {
                        "id": 35048,
                        "name": "Liceras",
                        "latitude": "41.37939000",
                        "longitude": "-3.24371000"
                    },
                    {
                        "id": 152793,
                        "name": "Losilla La",
                        "latitude": "41.87277940",
                        "longitude": "-2.27827450"
                    },
                    {
                        "id": 35203,
                        "name": "Magaña",
                        "latitude": "41.90089000",
                        "longitude": "-2.16269000"
                    },
                    {
                        "id": 35217,
                        "name": "Maján",
                        "latitude": "41.46888000",
                        "longitude": "-2.30268000"
                    },
                    {
                        "id": 35334,
                        "name": "Matalebreras",
                        "latitude": "41.84116000",
                        "longitude": "-2.04644000"
                    },
                    {
                        "id": 35336,
                        "name": "Matamala de Almazán",
                        "latitude": "41.50563000",
                        "longitude": "-2.64122000"
                    },
                    {
                        "id": 35374,
                        "name": "Medinaceli",
                        "latitude": "41.17224000",
                        "longitude": "-2.43476000"
                    },
                    {
                        "id": 152794,
                        "name": "Miño de Medinaceli",
                        "latitude": "41.18968640",
                        "longitude": "-2.51886480"
                    },
                    {
                        "id": 35458,
                        "name": "Miño de San Esteban",
                        "latitude": "41.53584000",
                        "longitude": "-3.34579000"
                    },
                    {
                        "id": 35483,
                        "name": "Molinos de Duero",
                        "latitude": "41.88603000",
                        "longitude": "-2.78682000"
                    },
                    {
                        "id": 35492,
                        "name": "Momblona",
                        "latitude": "41.44420000",
                        "longitude": "-2.34660000"
                    },
                    {
                        "id": 35542,
                        "name": "Monteagudo de las Vicarías",
                        "latitude": "41.36485000",
                        "longitude": "-2.16960000"
                    },
                    {
                        "id": 35554,
                        "name": "Montejo de Tiermes",
                        "latitude": "41.36838000",
                        "longitude": "-3.20016000"
                    },
                    {
                        "id": 35562,
                        "name": "Montenegro de Cameros",
                        "latitude": "42.08924000",
                        "longitude": "-2.75406000"
                    },
                    {
                        "id": 35635,
                        "name": "Morón de Almazán",
                        "latitude": "41.41361000",
                        "longitude": "-2.41317000"
                    },
                    {
                        "id": 35676,
                        "name": "Muriel de la Fuente",
                        "latitude": "41.72320000",
                        "longitude": "-2.86000000"
                    },
                    {
                        "id": 35675,
                        "name": "Muriel Viejo",
                        "latitude": "41.78261000",
                        "longitude": "-2.91522000"
                    },
                    {
                        "id": 35709,
                        "name": "Nafría de Ucero",
                        "latitude": "41.72273000",
                        "longitude": "-3.09499000"
                    },
                    {
                        "id": 35715,
                        "name": "Narros",
                        "latitude": "41.84923000",
                        "longitude": "-2.29474000"
                    },
                    {
                        "id": 35746,
                        "name": "Navaleno",
                        "latitude": "41.83830000",
                        "longitude": "-3.00418000"
                    },
                    {
                        "id": 35801,
                        "name": "Nepas",
                        "latitude": "41.52639000",
                        "longitude": "-2.39866000"
                    },
                    {
                        "id": 35821,
                        "name": "Nolay",
                        "latitude": "41.52721000",
                        "longitude": "-2.35061000"
                    },
                    {
                        "id": 35829,
                        "name": "Noviercas",
                        "latitude": "41.71194000",
                        "longitude": "-2.03433000"
                    },
                    {
                        "id": 35916,
                        "name": "Olvega",
                        "latitude": "41.77901000",
                        "longitude": "-1.98391000"
                    },
                    {
                        "id": 35921,
                        "name": "Oncala",
                        "latitude": "41.97021000",
                        "longitude": "-2.31493000"
                    },
                    {
                        "id": 36206,
                        "name": "Pinilla del Campo",
                        "latitude": "41.71691000",
                        "longitude": "-2.08350000"
                    },
                    {
                        "id": 36292,
                        "name": "Portillo de Soria",
                        "latitude": "41.63504000",
                        "longitude": "-2.12142000"
                    },
                    {
                        "id": 152795,
                        "name": "Póveda de Soria La",
                        "latitude": "42.01169350",
                        "longitude": "-2.50339460"
                    },
                    {
                        "id": 36314,
                        "name": "Pozalmuro",
                        "latitude": "41.77449000",
                        "longitude": "-2.10215000"
                    },
                    {
                        "id": 152796,
                        "name": "Quiñonería",
                        "latitude": "41.56852150",
                        "longitude": "-2.03803450"
                    },
                    {
                        "id": 36501,
                        "name": "Quintana Redonda",
                        "latitude": "41.63905000",
                        "longitude": "-2.61449000"
                    },
                    {
                        "id": 36514,
                        "name": "Quintanas de Gormaz",
                        "latitude": "41.50926000",
                        "longitude": "-2.97631000"
                    },
                    {
                        "id": 152797,
                        "name": "Rábanos Los",
                        "latitude": "41.71736390",
                        "longitude": "-2.47653100"
                    },
                    {
                        "id": 151213,
                        "name": "Rebollar",
                        "latitude": "41.91380230",
                        "longitude": "-2.50525070"
                    },
                    {
                        "id": 36558,
                        "name": "Recuerda",
                        "latitude": "41.47408000",
                        "longitude": "-2.99460000"
                    },
                    {
                        "id": 36572,
                        "name": "Rello",
                        "latitude": "41.33297000",
                        "longitude": "-2.74925000"
                    },
                    {
                        "id": 36579,
                        "name": "Renieblas",
                        "latitude": "41.82009000",
                        "longitude": "-2.37236000"
                    },
                    {
                        "id": 36589,
                        "name": "Retortillo de Soria",
                        "latitude": "41.31092000",
                        "longitude": "-2.98228000"
                    },
                    {
                        "id": 36600,
                        "name": "Reznos",
                        "latitude": "41.59090000",
                        "longitude": "-2.02779000"
                    },
                    {
                        "id": 152798,
                        "name": "Riba de Escalote La",
                        "latitude": "41.35703840",
                        "longitude": "-2.80786400"
                    },
                    {
                        "id": 152799,
                        "name": "Rioseco de Soria",
                        "latitude": "41.64162200",
                        "longitude": "-2.84088140"
                    },
                    {
                        "id": 36667,
                        "name": "Rollamienta",
                        "latitude": "41.92592000",
                        "longitude": "-2.53125000"
                    },
                    {
                        "id": 152800,
                        "name": "Royo El",
                        "latitude": "41.90725470",
                        "longitude": "-2.64560560"
                    },
                    {
                        "id": 36757,
                        "name": "Salduero",
                        "latitude": "41.88946000",
                        "longitude": "-2.79670000"
                    },
                    {
                        "id": 36828,
                        "name": "San Esteban de Gormaz",
                        "latitude": "41.57436000",
                        "longitude": "-3.20418000"
                    },
                    {
                        "id": 152801,
                        "name": "San Felices",
                        "latitude": "41.93844380",
                        "longitude": "-2.02425790"
                    },
                    {
                        "id": 36855,
                        "name": "San Leonardo de Yagüe",
                        "latitude": "41.83034000",
                        "longitude": "-3.06880000"
                    },
                    {
                        "id": 36901,
                        "name": "San Pedro Manrique",
                        "latitude": "42.02860000",
                        "longitude": "-2.23104000"
                    },
                    {
                        "id": 37037,
                        "name": "Santa Cruz de Yanguas",
                        "latitude": "42.06250000",
                        "longitude": "-2.44894000"
                    },
                    {
                        "id": 37075,
                        "name": "Santa María de Huerta",
                        "latitude": "41.26667000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 37082,
                        "name": "Santa María de las Hoyas",
                        "latitude": "41.77145000",
                        "longitude": "-3.14172000"
                    },
                    {
                        "id": 152802,
                        "name": "Serón de Nágima",
                        "latitude": "41.49589310",
                        "longitude": "-2.20214940"
                    },
                    {
                        "id": 37282,
                        "name": "Soliedra",
                        "latitude": "41.46932000",
                        "longitude": "-2.38164000"
                    },
                    {
                        "id": 37300,
                        "name": "Soria",
                        "latitude": "41.76401000",
                        "longitude": "-2.46883000"
                    },
                    {
                        "id": 37316,
                        "name": "Sotillo del Rincón",
                        "latitude": "41.93220000",
                        "longitude": "-2.60297000"
                    },
                    {
                        "id": 37330,
                        "name": "Suellacabras",
                        "latitude": "41.85298000",
                        "longitude": "-2.22398000"
                    },
                    {
                        "id": 37351,
                        "name": "Tajahuerce",
                        "latitude": "41.73991000",
                        "longitude": "-2.15069000"
                    },
                    {
                        "id": 37352,
                        "name": "Tajueco",
                        "latitude": "41.53641000",
                        "longitude": "-2.84845000"
                    },
                    {
                        "id": 152803,
                        "name": "Talveila",
                        "latitude": "41.78368500",
                        "longitude": "-2.96724480"
                    },
                    {
                        "id": 37378,
                        "name": "Tardelcuende",
                        "latitude": "41.59402000",
                        "longitude": "-2.64439000"
                    },
                    {
                        "id": 37382,
                        "name": "Taroda",
                        "latitude": "41.34798000",
                        "longitude": "-2.43318000"
                    },
                    {
                        "id": 37396,
                        "name": "Tejado",
                        "latitude": "41.58887000",
                        "longitude": "-2.26721000"
                    },
                    {
                        "id": 37467,
                        "name": "Torlengua",
                        "latitude": "41.45483000",
                        "longitude": "-2.16183000"
                    },
                    {
                        "id": 37509,
                        "name": "Torreblacos",
                        "latitude": "41.66927000",
                        "longitude": "-2.87881000"
                    },
                    {
                        "id": 37594,
                        "name": "Torrubia de Soria",
                        "latitude": "41.63045000",
                        "longitude": "-2.09151000"
                    },
                    {
                        "id": 152804,
                        "name": "Trévago",
                        "latitude": "41.85546910",
                        "longitude": "-2.12047700"
                    },
                    {
                        "id": 37672,
                        "name": "Ucero",
                        "latitude": "41.71685000",
                        "longitude": "-3.05154000"
                    },
                    {
                        "id": 37715,
                        "name": "Vadillo",
                        "latitude": "41.79111000",
                        "longitude": "-3.00845000"
                    },
                    {
                        "id": 37734,
                        "name": "Valdeavellano de Tera",
                        "latitude": "41.94229000",
                        "longitude": "-2.57634000"
                    },
                    {
                        "id": 152805,
                        "name": "Valdegeña",
                        "latitude": "41.81753860",
                        "longitude": "-2.17357790"
                    },
                    {
                        "id": 37757,
                        "name": "Valdelagua del Cerro",
                        "latitude": "41.88825000",
                        "longitude": "-2.11538000"
                    },
                    {
                        "id": 37764,
                        "name": "Valdemaluque",
                        "latitude": "41.67377000",
                        "longitude": "-3.04643000"
                    },
                    {
                        "id": 37776,
                        "name": "Valdenebro",
                        "latitude": "41.57167000",
                        "longitude": "-2.96424000"
                    },
                    {
                        "id": 37788,
                        "name": "Valdeprado",
                        "latitude": "41.93768000",
                        "longitude": "-2.10915000"
                    },
                    {
                        "id": 37794,
                        "name": "Valderrodilla",
                        "latitude": "41.56346000",
                        "longitude": "-2.80777000"
                    },
                    {
                        "id": 37877,
                        "name": "Valtajeros",
                        "latitude": "41.93808000",
                        "longitude": "-2.22289000"
                    },
                    {
                        "id": 37923,
                        "name": "Velamazán",
                        "latitude": "41.44895000",
                        "longitude": "-2.69935000"
                    },
                    {
                        "id": 152806,
                        "name": "Velilla de la Sierra",
                        "latitude": "41.80927670",
                        "longitude": "-2.40203840"
                    },
                    {
                        "id": 37932,
                        "name": "Velilla de los Ajos",
                        "latitude": "41.49058000",
                        "longitude": "-2.25579000"
                    },
                    {
                        "id": 37958,
                        "name": "Viana de Duero",
                        "latitude": "41.53406000",
                        "longitude": "-2.46099000"
                    },
                    {
                        "id": 38031,
                        "name": "Villaciervos",
                        "latitude": "41.76227000",
                        "longitude": "-2.62678000"
                    },
                    {
                        "id": 38182,
                        "name": "Villanueva de Gormaz",
                        "latitude": "41.46740000",
                        "longitude": "-3.06223000"
                    },
                    {
                        "id": 38250,
                        "name": "Villar del Ala",
                        "latitude": "41.91638000",
                        "longitude": "-2.56651000"
                    },
                    {
                        "id": 38253,
                        "name": "Villar del Campo",
                        "latitude": "41.78881000",
                        "longitude": "-2.14955000"
                    },
                    {
                        "id": 38261,
                        "name": "Villar del Río",
                        "latitude": "42.07574000",
                        "longitude": "-2.35082000"
                    },
                    {
                        "id": 152807,
                        "name": "Villares de Soria Los",
                        "latitude": "41.86487420",
                        "longitude": "-2.35514430"
                    },
                    {
                        "id": 38314,
                        "name": "Villasayas",
                        "latitude": "41.35291000",
                        "longitude": "-2.61011000"
                    },
                    {
                        "id": 38318,
                        "name": "Villaseca de Arciel",
                        "latitude": "41.62430000",
                        "longitude": "-2.16176000"
                    },
                    {
                        "id": 38396,
                        "name": "Vinuesa",
                        "latitude": "41.91032000",
                        "longitude": "-2.76483000"
                    },
                    {
                        "id": 38408,
                        "name": "Vizmanos",
                        "latitude": "42.02342000",
                        "longitude": "-2.40869000"
                    },
                    {
                        "id": 38412,
                        "name": "Vozmediano",
                        "latitude": "41.83752000",
                        "longitude": "-1.85580000"
                    },
                    {
                        "id": 38426,
                        "name": "Yanguas",
                        "latitude": "42.10171000",
                        "longitude": "-2.33986000"
                    },
                    {
                        "id": 38434,
                        "name": "Yelo",
                        "latitude": "41.21667000",
                        "longitude": "-2.51667000"
                    }
                ]
            },
            {
                "id": 1203,
                "name": "Tarragona",
                "iso2": "T",
                "latitude": "41.12586420",
                "longitude": "1.20356420",
                "type": "province",
                "cities": [
                    {
                        "id": 151894,
                        "name": "Aiguamúrcia",
                        "latitude": "41.32962240",
                        "longitude": "1.35867930"
                    },
                    {
                        "id": 151895,
                        "name": "Albinyana",
                        "latitude": "41.24498070",
                        "longitude": "1.48623900"
                    },
                    {
                        "id": 151896,
                        "name": "Albiol",
                        "latitude": "41.25203050",
                        "longitude": "1.08960140"
                    },
                    {
                        "id": 32083,
                        "name": "Alcanar",
                        "latitude": "40.54316000",
                        "longitude": "0.48082000"
                    },
                    {
                        "id": 32122,
                        "name": "Alcover",
                        "latitude": "41.26267000",
                        "longitude": "1.17010000"
                    },
                    {
                        "id": 152010,
                        "name": "Aldea L",
                        "latitude": "40.74557350",
                        "longitude": "0.61866630"
                    },
                    {
                        "id": 151897,
                        "name": "Aldover",
                        "latitude": "40.87994200",
                        "longitude": "0.49920690"
                    },
                    {
                        "id": 151898,
                        "name": "Aleixar",
                        "latitude": "41.20166390",
                        "longitude": "1.04622440"
                    },
                    {
                        "id": 151899,
                        "name": "Alfara de Carles",
                        "latitude": "40.87369050",
                        "longitude": "0.40044390"
                    },
                    {
                        "id": 32204,
                        "name": "Alforja",
                        "latitude": "41.21108000",
                        "longitude": "0.97542000"
                    },
                    {
                        "id": 32250,
                        "name": "Alió",
                        "latitude": "41.29422000",
                        "longitude": "1.30585000"
                    },
                    {
                        "id": 32308,
                        "name": "Almoster",
                        "latitude": "41.19758000",
                        "longitude": "1.11167000"
                    },
                    {
                        "id": 32338,
                        "name": "Altafulla",
                        "latitude": "41.14286000",
                        "longitude": "1.37269000"
                    },
                    {
                        "id": 151900,
                        "name": "Ametlla de Mar",
                        "latitude": "40.88394350",
                        "longitude": "0.79964910"
                    },
                    {
                        "id": 152011,
                        "name": "Ampolla L",
                        "latitude": "40.80500300",
                        "longitude": "0.68679390"
                    },
                    {
                        "id": 32358,
                        "name": "Amposta",
                        "latitude": "40.70995000",
                        "longitude": "0.57856000"
                    },
                    {
                        "id": 151902,
                        "name": "Arboç",
                        "latitude": "41.26598770",
                        "longitude": "1.60203370"
                    },
                    {
                        "id": 151901,
                        "name": "Arbolí",
                        "latitude": "41.24260060",
                        "longitude": "0.94877160"
                    },
                    {
                        "id": 151903,
                        "name": "Argentera",
                        "latitude": "41.13750600",
                        "longitude": "0.90894240"
                    },
                    {
                        "id": 151904,
                        "name": "Arnes",
                        "latitude": "40.91104580",
                        "longitude": "0.26141740"
                    },
                    {
                        "id": 32534,
                        "name": "Ascó",
                        "latitude": "41.18333000",
                        "longitude": "0.56667000"
                    },
                    {
                        "id": 151905,
                        "name": "Banyeres del Penedès",
                        "latitude": "41.27945480",
                        "longitude": "1.58081750"
                    },
                    {
                        "id": 151906,
                        "name": "Barberà de la Conca",
                        "latitude": "41.41094560",
                        "longitude": "1.22775560"
                    },
                    {
                        "id": 32693,
                        "name": "Batea",
                        "latitude": "41.09434000",
                        "longitude": "0.31100000"
                    },
                    {
                        "id": 151907,
                        "name": "Bellmunt del Priorat",
                        "latitude": "41.16369910",
                        "longitude": "0.76546230"
                    },
                    {
                        "id": 151908,
                        "name": "Bellvei",
                        "latitude": "41.23512120",
                        "longitude": "1.56445780"
                    },
                    {
                        "id": 32803,
                        "name": "Benifallet",
                        "latitude": "40.97422000",
                        "longitude": "0.51767000"
                    },
                    {
                        "id": 151909,
                        "name": "Benissanet",
                        "latitude": "41.05845590",
                        "longitude": "0.63403860"
                    },
                    {
                        "id": 151910,
                        "name": "Bisbal de Falset",
                        "latitude": "41.28063790",
                        "longitude": "0.72254670"
                    },
                    {
                        "id": 151911,
                        "name": "Bisbal del Penedès",
                        "latitude": "41.27942250",
                        "longitude": "1.48879970"
                    },
                    {
                        "id": 32906,
                        "name": "Blancafort",
                        "latitude": "41.43740000",
                        "longitude": "1.15983000"
                    },
                    {
                        "id": 32945,
                        "name": "Bonastre",
                        "latitude": "41.22031000",
                        "longitude": "1.43936000"
                    },
                    {
                        "id": 151912,
                        "name": "Borges del Camp",
                        "latitude": "41.17021250",
                        "longitude": "1.02092040"
                    },
                    {
                        "id": 32963,
                        "name": "Bot",
                        "latitude": "41.00916000",
                        "longitude": "0.38392000"
                    },
                    {
                        "id": 32964,
                        "name": "Botarell",
                        "latitude": "41.13627000",
                        "longitude": "0.98919000"
                    },
                    {
                        "id": 151913,
                        "name": "Bràfim",
                        "latitude": "41.26877280",
                        "longitude": "1.34126630"
                    },
                    {
                        "id": 151914,
                        "name": "Cabacés",
                        "latitude": "41.24746030",
                        "longitude": "0.73397650"
                    },
                    {
                        "id": 151915,
                        "name": "Cabra del Camp",
                        "latitude": "41.39540090",
                        "longitude": "1.27586410"
                    },
                    {
                        "id": 33125,
                        "name": "Calafell",
                        "latitude": "41.19997000",
                        "longitude": "1.56830000"
                    },
                    {
                        "id": 152009,
                        "name": "Camarles",
                        "latitude": "40.77093110",
                        "longitude": "0.66900340"
                    },
                    {
                        "id": 33177,
                        "name": "Cambrils",
                        "latitude": "41.06997000",
                        "longitude": "1.05949000"
                    },
                    {
                        "id": 152012,
                        "name": "Canonja La",
                        "latitude": "41.10886560",
                        "longitude": "1.18810760"
                    },
                    {
                        "id": 33262,
                        "name": "Capafonts",
                        "latitude": "41.30000000",
                        "longitude": "1.03333000"
                    },
                    {
                        "id": 151916,
                        "name": "Capçanes",
                        "latitude": "41.10068110",
                        "longitude": "0.78210620"
                    },
                    {
                        "id": 151917,
                        "name": "Caseres",
                        "latitude": "41.03944530",
                        "longitude": "0.25114970"
                    },
                    {
                        "id": 151918,
                        "name": "Castellvell del Camp",
                        "latitude": "41.18051300",
                        "longitude": "1.09723960"
                    },
                    {
                        "id": 151919,
                        "name": "Catllar",
                        "latitude": "41.17590370",
                        "longitude": "1.32703970"
                    },
                    {
                        "id": 33739,
                        "name": "Colldejou",
                        "latitude": "41.09970000",
                        "longitude": "0.88717000"
                    },
                    {
                        "id": 33756,
                        "name": "Conesa",
                        "latitude": "41.51667000",
                        "longitude": "1.30000000"
                    },
                    {
                        "id": 33766,
                        "name": "Constantí",
                        "latitude": "41.15392000",
                        "longitude": "1.21262000"
                    },
                    {
                        "id": 151921,
                        "name": "Corbera dEbre",
                        "latitude": "41.07685030",
                        "longitude": "0.47559930"
                    },
                    {
                        "id": 151922,
                        "name": "Cornudella de Montsant",
                        "latitude": "41.26539100",
                        "longitude": "0.90506590"
                    },
                    {
                        "id": 33832,
                        "name": "Creixell",
                        "latitude": "41.16618000",
                        "longitude": "1.44032000"
                    },
                    {
                        "id": 33884,
                        "name": "Cunit",
                        "latitude": "41.19829000",
                        "longitude": "1.63645000"
                    },
                    {
                        "id": 33925,
                        "name": "Deltebre",
                        "latitude": "40.71944000",
                        "longitude": "0.70835000"
                    },
                    {
                        "id": 151924,
                        "name": "Duesaigües",
                        "latitude": "41.14582840",
                        "longitude": "0.93012010"
                    },
                    {
                        "id": 151925,
                        "name": "Espluga de Francolí",
                        "latitude": "41.39718190",
                        "longitude": "1.10293180"
                    },
                    {
                        "id": 34159,
                        "name": "Falset",
                        "latitude": "41.14576000",
                        "longitude": "0.81979000"
                    },
                    {
                        "id": 151926,
                        "name": "Fatarella",
                        "latitude": "41.16211050",
                        "longitude": "0.47367980"
                    },
                    {
                        "id": 151927,
                        "name": "Febró",
                        "latitude": "41.27759130",
                        "longitude": "1.00432840"
                    },
                    {
                        "id": 151928,
                        "name": "Figuera",
                        "latitude": "41.11820310",
                        "longitude": "1.24962180"
                    },
                    {
                        "id": 151929,
                        "name": "Figuerola del Camp",
                        "latitude": "41.37140850",
                        "longitude": "1.26533560"
                    },
                    {
                        "id": 34195,
                        "name": "Flix",
                        "latitude": "41.23074000",
                        "longitude": "0.55008000"
                    },
                    {
                        "id": 34233,
                        "name": "Forès",
                        "latitude": "41.48333000",
                        "longitude": "1.23333000"
                    },
                    {
                        "id": 151930,
                        "name": "Freginals",
                        "latitude": "40.67221430",
                        "longitude": "0.52046580"
                    },
                    {
                        "id": 151931,
                        "name": "Galera",
                        "latitude": "40.68968260",
                        "longitude": "0.43608810"
                    },
                    {
                        "id": 34402,
                        "name": "Gandesa",
                        "latitude": "41.05375000",
                        "longitude": "0.43850000"
                    },
                    {
                        "id": 34408,
                        "name": "Garcia",
                        "latitude": "41.13333000",
                        "longitude": "0.65000000"
                    },
                    {
                        "id": 151932,
                        "name": "Garidells",
                        "latitude": "41.20745490",
                        "longitude": "1.24754590"
                    },
                    {
                        "id": 34468,
                        "name": "Ginestar",
                        "latitude": "41.04184000",
                        "longitude": "0.63290000"
                    },
                    {
                        "id": 151933,
                        "name": "Godall",
                        "latitude": "40.65467160",
                        "longitude": "0.46969960"
                    },
                    {
                        "id": 151934,
                        "name": "Gratallops",
                        "latitude": "41.19316560",
                        "longitude": "0.77675560"
                    },
                    {
                        "id": 151935,
                        "name": "Guiamets",
                        "latitude": "41.10150770",
                        "longitude": "0.75238980"
                    },
                    {
                        "id": 151936,
                        "name": "Horta de Sant Joan",
                        "latitude": "40.95384080",
                        "longitude": "0.31544100"
                    },
                    {
                        "id": 151937,
                        "name": "Lloar",
                        "latitude": "41.18580880",
                        "longitude": "0.74882520"
                    },
                    {
                        "id": 151938,
                        "name": "Llorac",
                        "latitude": "41.55680330",
                        "longitude": "1.30731470"
                    },
                    {
                        "id": 151939,
                        "name": "Llorenç del Penedès",
                        "latitude": "41.28428060",
                        "longitude": "1.54870990"
                    },
                    {
                        "id": 151940,
                        "name": "Marçà",
                        "latitude": "41.12665530",
                        "longitude": "0.80262330"
                    },
                    {
                        "id": 35288,
                        "name": "Margalef",
                        "latitude": "41.28496000",
                        "longitude": "0.75331000"
                    },
                    {
                        "id": 35315,
                        "name": "Mas de Barberans",
                        "latitude": "40.73333000",
                        "longitude": "0.36667000"
                    },
                    {
                        "id": 35319,
                        "name": "Masdenverge",
                        "latitude": "40.71600000",
                        "longitude": "0.53009000"
                    },
                    {
                        "id": 151941,
                        "name": "Masllorenç",
                        "latitude": "41.27029600",
                        "longitude": "1.41629370"
                    },
                    {
                        "id": 151942,
                        "name": "Masó",
                        "latitude": "41.23461470",
                        "longitude": "1.22117370"
                    },
                    {
                        "id": 151943,
                        "name": "Maspujols",
                        "latitude": "41.18162420",
                        "longitude": "1.04514770"
                    },
                    {
                        "id": 151944,
                        "name": "Masroig",
                        "latitude": "41.12586250",
                        "longitude": "0.73249190"
                    },
                    {
                        "id": 151945,
                        "name": "Milà",
                        "latitude": "41.24851610",
                        "longitude": "1.20642510"
                    },
                    {
                        "id": 35454,
                        "name": "Miravet",
                        "latitude": "41.03930000",
                        "longitude": "0.59665000"
                    },
                    {
                        "id": 151946,
                        "name": "Molar",
                        "latitude": "41.16310660",
                        "longitude": "0.71052670"
                    },
                    {
                        "id": 151949,
                        "name": "Mont-ral",
                        "latitude": "41.28685610",
                        "longitude": "1.09794430"
                    },
                    {
                        "id": 35528,
                        "name": "Mont-roig del Camp",
                        "latitude": "41.08675000",
                        "longitude": "0.95925000"
                    },
                    {
                        "id": 35539,
                        "name": "Montblanc",
                        "latitude": "41.37636000",
                        "longitude": "1.16163000"
                    },
                    {
                        "id": 151947,
                        "name": "Montbrió del Camp",
                        "latitude": "41.12192980",
                        "longitude": "1.00477680"
                    },
                    {
                        "id": 35572,
                        "name": "Montferri",
                        "latitude": "41.26545000",
                        "longitude": "1.36517000"
                    },
                    {
                        "id": 151948,
                        "name": "Montmell",
                        "latitude": "41.34145370",
                        "longitude": "1.49182350"
                    },
                    {
                        "id": 151950,
                        "name": "Móra dEbre",
                        "latitude": "41.08677150",
                        "longitude": "0.63818540"
                    },
                    {
                        "id": 151951,
                        "name": "Móra la Nova",
                        "latitude": "41.10433110",
                        "longitude": "0.65003570"
                    },
                    {
                        "id": 151952,
                        "name": "Morell",
                        "latitude": "41.19218390",
                        "longitude": "1.20644990"
                    },
                    {
                        "id": 151953,
                        "name": "Morera de Montsant",
                        "latitude": "41.26492930",
                        "longitude": "0.84160450"
                    },
                    {
                        "id": 151954,
                        "name": "Nou de Gaià",
                        "latitude": "41.18277470",
                        "longitude": "1.37559760"
                    },
                    {
                        "id": 151955,
                        "name": "Nulles",
                        "latitude": "41.24910510",
                        "longitude": "1.29692890"
                    },
                    {
                        "id": 151957,
                        "name": "Pallaresos",
                        "latitude": "41.17528240",
                        "longitude": "1.27044910"
                    },
                    {
                        "id": 151956,
                        "name": "Palma dEbre",
                        "latitude": "41.28333020",
                        "longitude": "0.66603910"
                    },
                    {
                        "id": 151958,
                        "name": "Passanant i Belltall",
                        "latitude": "41.52500510",
                        "longitude": "1.20252070"
                    },
                    {
                        "id": 151959,
                        "name": "Paüls",
                        "latitude": "40.92201620",
                        "longitude": "0.40014950"
                    },
                    {
                        "id": 151960,
                        "name": "Perafort",
                        "latitude": "41.19052270",
                        "longitude": "1.25601260"
                    },
                    {
                        "id": 151961,
                        "name": "Perelló El",
                        "latitude": "40.89598290",
                        "longitude": "0.69628530"
                    },
                    {
                        "id": 151962,
                        "name": "Piles Les",
                        "latitude": "41.50353180",
                        "longitude": "1.33728230"
                    },
                    {
                        "id": 151963,
                        "name": "Pinell de Brai",
                        "latitude": "41.01619960",
                        "longitude": "0.51455940"
                    },
                    {
                        "id": 151964,
                        "name": "Pira",
                        "latitude": "41.42341140",
                        "longitude": "1.20282100"
                    },
                    {
                        "id": 151965,
                        "name": "Pla de Santa Maria",
                        "latitude": "41.34356780",
                        "longitude": "1.31800420"
                    },
                    {
                        "id": 151966,
                        "name": "Pobla de Mafumet",
                        "latitude": "41.18490960",
                        "longitude": "1.20999390"
                    },
                    {
                        "id": 151967,
                        "name": "Pobla de Massaluc",
                        "latitude": "41.18078020",
                        "longitude": "0.35336070"
                    },
                    {
                        "id": 151968,
                        "name": "Pobla de Montornès",
                        "latitude": "41.17737340",
                        "longitude": "1.41508630"
                    },
                    {
                        "id": 151969,
                        "name": "Poboleda",
                        "latitude": "41.23445540",
                        "longitude": "0.84547490"
                    },
                    {
                        "id": 151970,
                        "name": "Pont dArmentera",
                        "latitude": "41.13601600",
                        "longitude": "1.25744440"
                    },
                    {
                        "id": 36274,
                        "name": "Pontils",
                        "latitude": "41.47734000",
                        "longitude": "1.38772000"
                    },
                    {
                        "id": 151971,
                        "name": "Porrera",
                        "latitude": "41.18790030",
                        "longitude": "0.85500360"
                    },
                    {
                        "id": 151972,
                        "name": "Pradell de la Teixeta",
                        "latitude": "41.15662580",
                        "longitude": "0.87615340"
                    },
                    {
                        "id": 151973,
                        "name": "Prades",
                        "latitude": "41.30671140",
                        "longitude": "0.99162740"
                    },
                    {
                        "id": 151974,
                        "name": "Prat de Comte",
                        "latitude": "40.98338150",
                        "longitude": "0.40529080"
                    },
                    {
                        "id": 151975,
                        "name": "Pratdip",
                        "latitude": "41.05092720",
                        "longitude": "0.87138630"
                    },
                    {
                        "id": 36463,
                        "name": "Puigpelat",
                        "latitude": "41.27899000",
                        "longitude": "1.29713000"
                    },
                    {
                        "id": 36496,
                        "name": "Querol",
                        "latitude": "41.42293000",
                        "longitude": "1.39684000"
                    },
                    {
                        "id": 36549,
                        "name": "Rasquera",
                        "latitude": "41.00267000",
                        "longitude": "0.59967000"
                    },
                    {
                        "id": 36576,
                        "name": "Renau",
                        "latitude": "41.22448000",
                        "longitude": "1.31083000"
                    },
                    {
                        "id": 36592,
                        "name": "Reus",
                        "latitude": "41.15612000",
                        "longitude": "1.10687000"
                    },
                    {
                        "id": 151976,
                        "name": "Riba La",
                        "latitude": "41.31792030",
                        "longitude": "1.17738560"
                    },
                    {
                        "id": 151977,
                        "name": "Riba-roja dEbre",
                        "latitude": "41.25982400",
                        "longitude": "0.46910970"
                    },
                    {
                        "id": 151978,
                        "name": "Riera de Gaià La",
                        "latitude": "41.16671160",
                        "longitude": "1.36078940"
                    },
                    {
                        "id": 36634,
                        "name": "Riudecanyes",
                        "latitude": "41.13333000",
                        "longitude": "0.96667000"
                    },
                    {
                        "id": 36635,
                        "name": "Riudecols",
                        "latitude": "41.16900000",
                        "longitude": "0.97625000"
                    },
                    {
                        "id": 36637,
                        "name": "Riudoms",
                        "latitude": "41.13333000",
                        "longitude": "1.05000000"
                    },
                    {
                        "id": 151979,
                        "name": "Rocafort de Queralt",
                        "latitude": "41.47854340",
                        "longitude": "1.28127970"
                    },
                    {
                        "id": 36661,
                        "name": "Roda de Barà",
                        "latitude": "41.18645000",
                        "longitude": "1.45893000"
                    },
                    {
                        "id": 151980,
                        "name": "Rodonyà",
                        "latitude": "41.28052580",
                        "longitude": "1.39894740"
                    },
                    {
                        "id": 151981,
                        "name": "Roquetes",
                        "latitude": "40.82094220",
                        "longitude": "0.50205170"
                    },
                    {
                        "id": 151982,
                        "name": "Rourell",
                        "latitude": "41.22359940",
                        "longitude": "1.21753960"
                    },
                    {
                        "id": 36775,
                        "name": "Salomó",
                        "latitude": "41.22955000",
                        "longitude": "1.37445000"
                    },
                    {
                        "id": 36777,
                        "name": "Salou",
                        "latitude": "41.07663000",
                        "longitude": "1.14163000"
                    },
                    {
                        "id": 36959,
                        "name": "Sant Carles de la Ràpita",
                        "latitude": "40.61667000",
                        "longitude": "0.60000000"
                    },
                    {
                        "id": 151983,
                        "name": "Sant Jaume dels Domenys",
                        "latitude": "41.29982130",
                        "longitude": "1.55900600"
                    },
                    {
                        "id": 152008,
                        "name": "Sant Jaume dEnveja",
                        "latitude": "40.70597070",
                        "longitude": "0.72714790"
                    },
                    {
                        "id": 37008,
                        "name": "Santa Bárbara",
                        "latitude": "40.71542000",
                        "longitude": "0.49292000"
                    },
                    {
                        "id": 151984,
                        "name": "Santa Coloma de Queralt",
                        "latitude": "41.53222150",
                        "longitude": "1.38292460"
                    },
                    {
                        "id": 37095,
                        "name": "Santa Oliva",
                        "latitude": "41.25357000",
                        "longitude": "1.55086000"
                    },
                    {
                        "id": 151985,
                        "name": "Sarral",
                        "latitude": "41.44514590",
                        "longitude": "1.24759370"
                    },
                    {
                        "id": 151986,
                        "name": "Savallà del Comtat",
                        "latitude": "41.54300610",
                        "longitude": "1.29903590"
                    },
                    {
                        "id": 151987,
                        "name": "Secuita",
                        "latitude": "41.20379740",
                        "longitude": "1.28116470"
                    },
                    {
                        "id": 151988,
                        "name": "Selva del Camp",
                        "latitude": "41.20505910",
                        "longitude": "1.12570820"
                    },
                    {
                        "id": 151989,
                        "name": "Senan",
                        "latitude": "41.47005960",
                        "longitude": "1.08750480"
                    },
                    {
                        "id": 151920,
                        "name": "Sénia",
                        "latitude": "40.65455160",
                        "longitude": "0.31837920"
                    },
                    {
                        "id": 151990,
                        "name": "Solivella",
                        "latitude": "41.45588490",
                        "longitude": "1.17790130"
                    },
                    {
                        "id": 37383,
                        "name": "Tarragona",
                        "latitude": "41.11667000",
                        "longitude": "1.25000000"
                    },
                    {
                        "id": 37433,
                        "name": "Tivenys",
                        "latitude": "40.90787000",
                        "longitude": "0.51236000"
                    },
                    {
                        "id": 151991,
                        "name": "Tivissa",
                        "latitude": "41.04086090",
                        "longitude": "0.73308580"
                    },
                    {
                        "id": 151993,
                        "name": "Torre de Espanyol",
                        "latitude": "41.11888270",
                        "longitude": "1.24449090"
                    },
                    {
                        "id": 151992,
                        "name": "Torre de Fontaubella",
                        "latitude": "41.12463390",
                        "longitude": "0.86483240"
                    },
                    {
                        "id": 37529,
                        "name": "Torredembarra",
                        "latitude": "41.14505000",
                        "longitude": "1.39861000"
                    },
                    {
                        "id": 151994,
                        "name": "Torroja del Priorat",
                        "latitude": "41.21334950",
                        "longitude": "0.81095200"
                    },
                    {
                        "id": 37597,
                        "name": "Tortosa",
                        "latitude": "40.81249000",
                        "longitude": "0.52160000"
                    },
                    {
                        "id": 37681,
                        "name": "Ulldecona",
                        "latitude": "40.59734000",
                        "longitude": "0.44718000"
                    },
                    {
                        "id": 37682,
                        "name": "Ulldemolins",
                        "latitude": "41.32216000",
                        "longitude": "0.87650000"
                    },
                    {
                        "id": 37842,
                        "name": "Vallclara",
                        "latitude": "41.37958000",
                        "longitude": "0.98342000"
                    },
                    {
                        "id": 151995,
                        "name": "Vallfogona de Riucorb",
                        "latitude": "41.55961600",
                        "longitude": "1.23617060"
                    },
                    {
                        "id": 37862,
                        "name": "Vallmoll",
                        "latitude": "41.24311000",
                        "longitude": "1.24900000"
                    },
                    {
                        "id": 37863,
                        "name": "Valls",
                        "latitude": "41.28612000",
                        "longitude": "1.24993000"
                    },
                    {
                        "id": 151996,
                        "name": "Vandellòs i Hospitalet de Infant",
                        "latitude": "40.99089910",
                        "longitude": "0.92366910"
                    },
                    {
                        "id": 151997,
                        "name": "Vendrell",
                        "latitude": "41.21963220",
                        "longitude": "1.53689850"
                    },
                    {
                        "id": 151998,
                        "name": "Vespella de Gaià",
                        "latitude": "41.20306950",
                        "longitude": "1.36079020"
                    },
                    {
                        "id": 152001,
                        "name": "Vila-rodona",
                        "latitude": "41.31102450",
                        "longitude": "1.35809580"
                    },
                    {
                        "id": 37973,
                        "name": "Vila-seca",
                        "latitude": "41.11118000",
                        "longitude": "1.14764000"
                    },
                    {
                        "id": 37974,
                        "name": "Vilabella",
                        "latitude": "41.24779000",
                        "longitude": "1.33019000"
                    },
                    {
                        "id": 152005,
                        "name": "Vilalba dels Arcs",
                        "latitude": "41.11990680",
                        "longitude": "0.40957280"
                    },
                    {
                        "id": 151999,
                        "name": "Vilallonga del Camp",
                        "latitude": "41.20997220",
                        "longitude": "1.20532210"
                    },
                    {
                        "id": 37996,
                        "name": "Vilanova de Prades",
                        "latitude": "41.34850000",
                        "longitude": "0.95667000"
                    },
                    {
                        "id": 152000,
                        "name": "Vilanova dEscornalbou",
                        "latitude": "41.11305840",
                        "longitude": "0.93728130"
                    },
                    {
                        "id": 38001,
                        "name": "Vilaplana",
                        "latitude": "41.22800000",
                        "longitude": "1.03325000"
                    },
                    {
                        "id": 152002,
                        "name": "Vilaverd",
                        "latitude": "41.33569340",
                        "longitude": "1.17670070"
                    },
                    {
                        "id": 152003,
                        "name": "Vilella Alta La",
                        "latitude": "41.22517600",
                        "longitude": "0.78091710"
                    },
                    {
                        "id": 152004,
                        "name": "Vilella Baixa La",
                        "latitude": "41.22027070",
                        "longitude": "0.76308520"
                    },
                    {
                        "id": 152006,
                        "name": "Vimbodí i Poblet",
                        "latitude": "41.40081750",
                        "longitude": "1.04886180"
                    },
                    {
                        "id": 38393,
                        "name": "Vinebre",
                        "latitude": "41.18464000",
                        "longitude": "0.58945000"
                    },
                    {
                        "id": 152007,
                        "name": "Vinyols i els Arcs",
                        "latitude": "41.11365220",
                        "longitude": "1.04063820"
                    },
                    {
                        "id": 151923,
                        "name": "Xerta",
                        "latitude": "40.90841280",
                        "longitude": "0.48917200"
                    }
                ]
            },
            {
                "id": 5111,
                "name": "Teruel",
                "iso2": "TE",
                "latitude": "40.34504100",
                "longitude": "-1.11847440",
                "type": "province",
                "cities": [
                    {
                        "id": 31898,
                        "name": "Ababuj",
                        "latitude": "40.54908000",
                        "longitude": "-0.80758000"
                    },
                    {
                        "id": 152413,
                        "name": "Abejuela",
                        "latitude": "39.91007410",
                        "longitude": "-0.89343890"
                    },
                    {
                        "id": 31954,
                        "name": "Aguatón",
                        "latitude": "40.67158000",
                        "longitude": "-1.23475000"
                    },
                    {
                        "id": 31955,
                        "name": "Aguaviva",
                        "latitude": "40.82211000",
                        "longitude": "-0.19532000"
                    },
                    {
                        "id": 31964,
                        "name": "Aguilar del Alfambra",
                        "latitude": "40.59027000",
                        "longitude": "-0.79589000"
                    },
                    {
                        "id": 31988,
                        "name": "Alacón",
                        "latitude": "41.02575000",
                        "longitude": "-0.69782000"
                    },
                    {
                        "id": 32009,
                        "name": "Alba",
                        "latitude": "40.61825000",
                        "longitude": "-1.34658000"
                    },
                    {
                        "id": 32025,
                        "name": "Albalate del Arzobispo",
                        "latitude": "41.12173000",
                        "longitude": "-0.51142000"
                    },
                    {
                        "id": 32029,
                        "name": "Albarracín",
                        "latitude": "40.40818000",
                        "longitude": "-1.44375000"
                    },
                    {
                        "id": 152414,
                        "name": "Albentosa",
                        "latitude": "40.10239330",
                        "longitude": "-0.77051420"
                    },
                    {
                        "id": 32066,
                        "name": "Alcaine",
                        "latitude": "40.95341000",
                        "longitude": "-0.70583000"
                    },
                    {
                        "id": 32074,
                        "name": "Alcalá de la Selva",
                        "latitude": "40.37183000",
                        "longitude": "-0.72015000"
                    },
                    {
                        "id": 32094,
                        "name": "Alcañiz",
                        "latitude": "41.05000000",
                        "longitude": "-0.13333000"
                    },
                    {
                        "id": 32120,
                        "name": "Alcorisa",
                        "latitude": "40.89210000",
                        "longitude": "-0.38143000"
                    },
                    {
                        "id": 32192,
                        "name": "Alfambra",
                        "latitude": "40.54638000",
                        "longitude": "-1.03314000"
                    },
                    {
                        "id": 32242,
                        "name": "Aliaga",
                        "latitude": "40.67411000",
                        "longitude": "-0.70333000"
                    },
                    {
                        "id": 32255,
                        "name": "Allepuz",
                        "latitude": "40.49295000",
                        "longitude": "-0.72478000"
                    },
                    {
                        "id": 32257,
                        "name": "Alloza",
                        "latitude": "40.96942000",
                        "longitude": "-0.52941000"
                    },
                    {
                        "id": 32258,
                        "name": "Allueva",
                        "latitude": "40.98533000",
                        "longitude": "-1.04258000"
                    },
                    {
                        "id": 32298,
                        "name": "Almohaja",
                        "latitude": "40.60489000",
                        "longitude": "-1.43800000"
                    },
                    {
                        "id": 32317,
                        "name": "Alobras",
                        "latitude": "40.18169000",
                        "longitude": "-1.38731000"
                    },
                    {
                        "id": 32330,
                        "name": "Alpeñés",
                        "latitude": "40.79958000",
                        "longitude": "-1.06625000"
                    },
                    {
                        "id": 32365,
                        "name": "Anadón",
                        "latitude": "40.98225000",
                        "longitude": "-0.98367000"
                    },
                    {
                        "id": 32373,
                        "name": "Andorra",
                        "latitude": "40.97655000",
                        "longitude": "-0.44721000"
                    },
                    {
                        "id": 32440,
                        "name": "Arcos de las Salinas",
                        "latitude": "39.98333000",
                        "longitude": "-1.03333000"
                    },
                    {
                        "id": 152415,
                        "name": "Arens de Lledó",
                        "latitude": "40.99246410",
                        "longitude": "0.27077150"
                    },
                    {
                        "id": 32470,
                        "name": "Argente",
                        "latitude": "40.68841000",
                        "longitude": "-1.16217000"
                    },
                    {
                        "id": 32481,
                        "name": "Ariño",
                        "latitude": "41.03019000",
                        "longitude": "-0.59206000"
                    },
                    {
                        "id": 152416,
                        "name": "Azaila",
                        "latitude": "41.29047020",
                        "longitude": "-0.49330370"
                    },
                    {
                        "id": 33048,
                        "name": "Bádenas",
                        "latitude": "41.09216000",
                        "longitude": "-1.12241000"
                    },
                    {
                        "id": 33049,
                        "name": "Báguena",
                        "latitude": "41.04181000",
                        "longitude": "-1.35767000"
                    },
                    {
                        "id": 32712,
                        "name": "Bañón",
                        "latitude": "40.83825000",
                        "longitude": "-1.19091000"
                    },
                    {
                        "id": 32668,
                        "name": "Barrachina",
                        "latitude": "40.89688000",
                        "longitude": "-1.13858000"
                    },
                    {
                        "id": 32713,
                        "name": "Bea",
                        "latitude": "41.03633000",
                        "longitude": "-1.14725000"
                    },
                    {
                        "id": 152417,
                        "name": "Beceite",
                        "latitude": "40.83156690",
                        "longitude": "0.18169360"
                    },
                    {
                        "id": 32741,
                        "name": "Bello",
                        "latitude": "40.92266000",
                        "longitude": "-1.49850000"
                    },
                    {
                        "id": 152418,
                        "name": "Belmonte de San José",
                        "latitude": "40.87468150",
                        "longitude": "-0.06358270"
                    },
                    {
                        "id": 32850,
                        "name": "Berge",
                        "latitude": "40.85791000",
                        "longitude": "-0.42709000"
                    },
                    {
                        "id": 32884,
                        "name": "Bezas",
                        "latitude": "40.33076000",
                        "longitude": "-1.32511000"
                    },
                    {
                        "id": 32907,
                        "name": "Blancas",
                        "latitude": "40.81392000",
                        "longitude": "-1.48208000"
                    },
                    {
                        "id": 32912,
                        "name": "Blesa",
                        "latitude": "41.05150000",
                        "longitude": "-0.88500000"
                    },
                    {
                        "id": 32953,
                        "name": "Bordón",
                        "latitude": "40.68650000",
                        "longitude": "-0.32216000"
                    },
                    {
                        "id": 32991,
                        "name": "Bronchales",
                        "latitude": "40.51171000",
                        "longitude": "-1.58821000"
                    },
                    {
                        "id": 33008,
                        "name": "Bueña",
                        "latitude": "40.70881000",
                        "longitude": "-1.26742000"
                    },
                    {
                        "id": 33021,
                        "name": "Burbáguena",
                        "latitude": "41.01783000",
                        "longitude": "-1.33825000"
                    },
                    {
                        "id": 33099,
                        "name": "Cabra de Mora",
                        "latitude": "40.31696000",
                        "longitude": "-0.80678000"
                    },
                    {
                        "id": 33123,
                        "name": "Calaceite",
                        "latitude": "41.01625000",
                        "longitude": "0.18876000"
                    },
                    {
                        "id": 33128,
                        "name": "Calamocha",
                        "latitude": "40.91933000",
                        "longitude": "-1.29750000"
                    },
                    {
                        "id": 33130,
                        "name": "Calanda",
                        "latitude": "40.94153000",
                        "longitude": "-0.23243000"
                    },
                    {
                        "id": 33148,
                        "name": "Calomarde",
                        "latitude": "40.37264000",
                        "longitude": "-1.57435000"
                    },
                    {
                        "id": 33173,
                        "name": "Camañas",
                        "latitude": "40.64308000",
                        "longitude": "-1.13752000"
                    },
                    {
                        "id": 33165,
                        "name": "Camarena de la Sierra",
                        "latitude": "40.15000000",
                        "longitude": "-1.03333000"
                    },
                    {
                        "id": 33168,
                        "name": "Camarillas",
                        "latitude": "40.61242000",
                        "longitude": "-0.75416000"
                    },
                    {
                        "id": 33179,
                        "name": "Caminreal",
                        "latitude": "40.83883000",
                        "longitude": "-1.32416000"
                    },
                    {
                        "id": 33528,
                        "name": "Cañada de Benatanduz",
                        "latitude": "40.57934000",
                        "longitude": "-0.53682000"
                    },
                    {
                        "id": 152419,
                        "name": "Cañada de Verich La",
                        "latitude": "40.86612410",
                        "longitude": "-0.09950390"
                    },
                    {
                        "id": 33527,
                        "name": "Cañada Vellida",
                        "latitude": "40.70811000",
                        "longitude": "-0.91489000"
                    },
                    {
                        "id": 33544,
                        "name": "Cañizar del Olivar",
                        "latitude": "40.81622000",
                        "longitude": "-0.64567000"
                    },
                    {
                        "id": 33256,
                        "name": "Cantavieja",
                        "latitude": "40.52642000",
                        "longitude": "-0.40558000"
                    },
                    {
                        "id": 33387,
                        "name": "Cascante del Río",
                        "latitude": "40.19652000",
                        "longitude": "-1.11414000"
                    },
                    {
                        "id": 33404,
                        "name": "Castejón de Tornos",
                        "latitude": "40.99726000",
                        "longitude": "-1.42805000"
                    },
                    {
                        "id": 33408,
                        "name": "Castel de Cabra",
                        "latitude": "40.80255000",
                        "longitude": "-0.69600000"
                    },
                    {
                        "id": 152420,
                        "name": "Castellar El",
                        "latitude": "40.36530590",
                        "longitude": "-0.81690210"
                    },
                    {
                        "id": 33433,
                        "name": "Castellote",
                        "latitude": "40.80000000",
                        "longitude": "-0.31975000"
                    },
                    {
                        "id": 33439,
                        "name": "Castelnou",
                        "latitude": "41.22892000",
                        "longitude": "-0.36434000"
                    },
                    {
                        "id": 33440,
                        "name": "Castelserás",
                        "latitude": "40.98133000",
                        "longitude": "-0.14666000"
                    },
                    {
                        "id": 33558,
                        "name": "Cedrillas",
                        "latitude": "40.43708000",
                        "longitude": "-0.85150000"
                    },
                    {
                        "id": 152421,
                        "name": "Celadas",
                        "latitude": "40.48661670",
                        "longitude": "-1.15449630"
                    },
                    {
                        "id": 33564,
                        "name": "Cella",
                        "latitude": "40.45325000",
                        "longitude": "-1.28750000"
                    },
                    {
                        "id": 152422,
                        "name": "Cerollera La",
                        "latitude": "40.83960090",
                        "longitude": "-0.05570200"
                    },
                    {
                        "id": 152423,
                        "name": "Codoñera La",
                        "latitude": "40.93404150",
                        "longitude": "-0.08460560"
                    },
                    {
                        "id": 33773,
                        "name": "Corbalán",
                        "latitude": "40.40308000",
                        "longitude": "-0.98525000"
                    },
                    {
                        "id": 33808,
                        "name": "Cortes de Aragón",
                        "latitude": "40.97366000",
                        "longitude": "-0.83575000"
                    },
                    {
                        "id": 33815,
                        "name": "Cosa",
                        "latitude": "40.83392000",
                        "longitude": "-1.13650000"
                    },
                    {
                        "id": 152424,
                        "name": "Cretas",
                        "latitude": "40.92822390",
                        "longitude": "0.19633640"
                    },
                    {
                        "id": 33838,
                        "name": "Crivillén",
                        "latitude": "40.88325000",
                        "longitude": "-0.57666000"
                    },
                    {
                        "id": 152425,
                        "name": "Cuba La",
                        "latitude": "40.59176890",
                        "longitude": "-0.29781640"
                    },
                    {
                        "id": 33858,
                        "name": "Cubla",
                        "latitude": "40.20978000",
                        "longitude": "-1.07917000"
                    },
                    {
                        "id": 33862,
                        "name": "Cucalón",
                        "latitude": "41.08608000",
                        "longitude": "-1.21475000"
                    },
                    {
                        "id": 152426,
                        "name": "Cuervo El",
                        "latitude": "40.15114850",
                        "longitude": "-1.32583490"
                    },
                    {
                        "id": 33871,
                        "name": "Cuevas de Almudén",
                        "latitude": "40.71342000",
                        "longitude": "-0.82958000"
                    },
                    {
                        "id": 33870,
                        "name": "Cuevas Labradas",
                        "latitude": "40.45350000",
                        "longitude": "-1.05008000"
                    },
                    {
                        "id": 33976,
                        "name": "Ejulve",
                        "latitude": "40.77633000",
                        "longitude": "-0.55344000"
                    },
                    {
                        "id": 34090,
                        "name": "Escorihuela",
                        "latitude": "40.54400000",
                        "longitude": "-0.97078000"
                    },
                    {
                        "id": 34091,
                        "name": "Escucha",
                        "latitude": "40.79467000",
                        "longitude": "-0.81012000"
                    },
                    {
                        "id": 34144,
                        "name": "Estercuel",
                        "latitude": "40.85500000",
                        "longitude": "-0.63208000"
                    },
                    {
                        "id": 34181,
                        "name": "Ferreruela de Huerva",
                        "latitude": "41.06325000",
                        "longitude": "-1.23350000"
                    },
                    {
                        "id": 34223,
                        "name": "Formiche Alto",
                        "latitude": "40.32367000",
                        "longitude": "-0.89241000"
                    },
                    {
                        "id": 34368,
                        "name": "Fórnoles",
                        "latitude": "40.89359000",
                        "longitude": "-0.00383000"
                    },
                    {
                        "id": 34229,
                        "name": "Fortanete",
                        "latitude": "40.50533000",
                        "longitude": "-0.52283000"
                    },
                    {
                        "id": 34235,
                        "name": "Foz-Calanda",
                        "latitude": "40.92208000",
                        "longitude": "-0.26483000"
                    },
                    {
                        "id": 152427,
                        "name": "Fresneda La",
                        "latitude": "40.92773460",
                        "longitude": "0.07526070"
                    },
                    {
                        "id": 34272,
                        "name": "Frías de Albarracín",
                        "latitude": "40.33754000",
                        "longitude": "-1.61470000"
                    },
                    {
                        "id": 34281,
                        "name": "Fuenferrada",
                        "latitude": "40.86923000",
                        "longitude": "-1.01179000"
                    },
                    {
                        "id": 34336,
                        "name": "Fuentes Calientes",
                        "latitude": "40.70000000",
                        "longitude": "-0.96667000"
                    },
                    {
                        "id": 34337,
                        "name": "Fuentes Claras",
                        "latitude": "40.86375000",
                        "longitude": "-1.32266000"
                    },
                    {
                        "id": 34350,
                        "name": "Fuentes de Rubielos",
                        "latitude": "40.16667000",
                        "longitude": "-0.61667000"
                    },
                    {
                        "id": 34356,
                        "name": "Fuentespalda",
                        "latitude": "40.80666000",
                        "longitude": "0.06517000"
                    },
                    {
                        "id": 34397,
                        "name": "Galve",
                        "latitude": "40.65591000",
                        "longitude": "-0.88217000"
                    },
                    {
                        "id": 34414,
                        "name": "Gargallo",
                        "latitude": "40.83583000",
                        "longitude": "-0.58442000"
                    },
                    {
                        "id": 34443,
                        "name": "Gea de Albarracín",
                        "latitude": "40.41114000",
                        "longitude": "-1.34823000"
                    },
                    {
                        "id": 152428,
                        "name": "Ginebrosa La",
                        "latitude": "40.87051280",
                        "longitude": "-0.13458130"
                    },
                    {
                        "id": 34510,
                        "name": "Griegos",
                        "latitude": "40.42722000",
                        "longitude": "-1.71201000"
                    },
                    {
                        "id": 34521,
                        "name": "Guadalaviar",
                        "latitude": "40.38824000",
                        "longitude": "-1.71803000"
                    },
                    {
                        "id": 34566,
                        "name": "Gúdar",
                        "latitude": "40.44107000",
                        "longitude": "-0.72048000"
                    },
                    {
                        "id": 34722,
                        "name": "Híjar",
                        "latitude": "41.17429000",
                        "longitude": "-0.45112000"
                    },
                    {
                        "id": 34624,
                        "name": "Hinojosa de Jarque",
                        "latitude": "40.69049000",
                        "longitude": "-0.78541000"
                    },
                    {
                        "id": 152429,
                        "name": "Hoz de la Vieja La",
                        "latitude": "40.92404440",
                        "longitude": "-0.84487940"
                    },
                    {
                        "id": 34695,
                        "name": "Huesa del Común",
                        "latitude": "41.01053000",
                        "longitude": "-0.91882000"
                    },
                    {
                        "id": 152430,
                        "name": "Iglesuela del Cid La",
                        "latitude": "40.48237940",
                        "longitude": "-0.31896680"
                    },
                    {
                        "id": 34784,
                        "name": "Jabaloyas",
                        "latitude": "40.24010000",
                        "longitude": "-1.40886000"
                    },
                    {
                        "id": 34804,
                        "name": "Jarque de la Val",
                        "latitude": "40.70283000",
                        "longitude": "-0.80083000"
                    },
                    {
                        "id": 34806,
                        "name": "Jatiel",
                        "latitude": "41.22008000",
                        "longitude": "-0.38183000"
                    },
                    {
                        "id": 34822,
                        "name": "Jorcas",
                        "latitude": "40.54275000",
                        "longitude": "-0.75308000"
                    },
                    {
                        "id": 34824,
                        "name": "Josa",
                        "latitude": "40.95550000",
                        "longitude": "-0.76683000"
                    },
                    {
                        "id": 34944,
                        "name": "Lagueruela",
                        "latitude": "41.04250000",
                        "longitude": "-1.19283000"
                    },
                    {
                        "id": 34970,
                        "name": "Lanzuela",
                        "latitude": "41.09850000",
                        "longitude": "-1.20616000"
                    },
                    {
                        "id": 35047,
                        "name": "Libros",
                        "latitude": "40.16311000",
                        "longitude": "-1.23361000"
                    },
                    {
                        "id": 35049,
                        "name": "Lidón",
                        "latitude": "40.71725000",
                        "longitude": "-1.11250000"
                    },
                    {
                        "id": 35053,
                        "name": "Linares de Mora",
                        "latitude": "40.32159000",
                        "longitude": "-0.57468000"
                    },
                    {
                        "id": 35072,
                        "name": "Lledó",
                        "latitude": "40.95498000",
                        "longitude": "0.27749000"
                    },
                    {
                        "id": 35143,
                        "name": "Loscos",
                        "latitude": "41.08108000",
                        "longitude": "-1.04433000"
                    },
                    {
                        "id": 35209,
                        "name": "Maicas",
                        "latitude": "40.96708000",
                        "longitude": "-0.89041000"
                    },
                    {
                        "id": 35270,
                        "name": "Manzanera",
                        "latitude": "40.05000000",
                        "longitude": "-0.83333000"
                    },
                    {
                        "id": 35308,
                        "name": "Martín del Río",
                        "latitude": "40.84459000",
                        "longitude": "-0.89549000"
                    },
                    {
                        "id": 35316,
                        "name": "Mas de las Matas",
                        "latitude": "40.83408000",
                        "longitude": "-0.24292000"
                    },
                    {
                        "id": 152431,
                        "name": "Mata de los Olmos La",
                        "latitude": "40.86530520",
                        "longitude": "-0.52223790"
                    },
                    {
                        "id": 35351,
                        "name": "Mazaleón",
                        "latitude": "41.05056000",
                        "longitude": "0.10290000"
                    },
                    {
                        "id": 35415,
                        "name": "Mezquita de Jarque",
                        "latitude": "40.72100000",
                        "longitude": "-0.86700000"
                    },
                    {
                        "id": 35447,
                        "name": "Mirambel",
                        "latitude": "40.58733000",
                        "longitude": "-0.34266000"
                    },
                    {
                        "id": 152432,
                        "name": "Miravete de la Sierra",
                        "latitude": "40.57578640",
                        "longitude": "-0.69361560"
                    },
                    {
                        "id": 35482,
                        "name": "Molinos",
                        "latitude": "40.82100000",
                        "longitude": "-0.45017000"
                    },
                    {
                        "id": 35514,
                        "name": "Monforte de Moyuela",
                        "latitude": "41.05512000",
                        "longitude": "-1.01411000"
                    },
                    {
                        "id": 35522,
                        "name": "Monreal del Campo",
                        "latitude": "40.78800000",
                        "longitude": "-1.35541000"
                    },
                    {
                        "id": 35524,
                        "name": "Monroyo",
                        "latitude": "40.78775000",
                        "longitude": "-0.03550000"
                    },
                    {
                        "id": 35532,
                        "name": "Montalbán",
                        "latitude": "40.83278000",
                        "longitude": "-0.80178000"
                    },
                    {
                        "id": 35543,
                        "name": "Monteagudo del Castillo",
                        "latitude": "40.45656000",
                        "longitude": "-0.81781000"
                    },
                    {
                        "id": 35564,
                        "name": "Monterde de Albarracín",
                        "latitude": "40.49708000",
                        "longitude": "-1.49216000"
                    },
                    {
                        "id": 35594,
                        "name": "Mora de Rubielos",
                        "latitude": "40.25020000",
                        "longitude": "-0.75249000"
                    },
                    {
                        "id": 35638,
                        "name": "Moscardón",
                        "latitude": "40.33295000",
                        "longitude": "-1.53683000"
                    },
                    {
                        "id": 35639,
                        "name": "Mosqueruela",
                        "latitude": "40.36133000",
                        "longitude": "-0.44890000"
                    },
                    {
                        "id": 35665,
                        "name": "Muniesa",
                        "latitude": "41.03308000",
                        "longitude": "-0.81141000"
                    },
                    {
                        "id": 152433,
                        "name": "Noguera de Albarracín",
                        "latitude": "40.45976110",
                        "longitude": "-1.59690510"
                    },
                    {
                        "id": 35818,
                        "name": "Nogueras",
                        "latitude": "41.13475000",
                        "longitude": "-1.06708000"
                    },
                    {
                        "id": 35819,
                        "name": "Nogueruelas",
                        "latitude": "40.23622000",
                        "longitude": "-0.63606000"
                    },
                    {
                        "id": 35854,
                        "name": "Obón",
                        "latitude": "40.90450000",
                        "longitude": "-0.72300000"
                    },
                    {
                        "id": 35860,
                        "name": "Odón",
                        "latitude": "40.88417000",
                        "longitude": "-1.56792000"
                    },
                    {
                        "id": 35868,
                        "name": "Ojos Negros",
                        "latitude": "40.73750000",
                        "longitude": "-1.49875000"
                    },
                    {
                        "id": 35874,
                        "name": "Olba",
                        "latitude": "40.13333000",
                        "longitude": "-0.61667000"
                    },
                    {
                        "id": 35881,
                        "name": "Oliete",
                        "latitude": "40.99791000",
                        "longitude": "-0.67429000"
                    },
                    {
                        "id": 152434,
                        "name": "Olmos Los",
                        "latitude": "40.87715000",
                        "longitude": "-0.48710630"
                    },
                    {
                        "id": 35951,
                        "name": "Orihuela del Tremedal",
                        "latitude": "40.55000000",
                        "longitude": "-1.65000000"
                    },
                    {
                        "id": 35961,
                        "name": "Orrios",
                        "latitude": "40.58945000",
                        "longitude": "-0.98614000"
                    },
                    {
                        "id": 36035,
                        "name": "Palomar de Arroyos",
                        "latitude": "40.77911000",
                        "longitude": "-0.75055000"
                    },
                    {
                        "id": 36047,
                        "name": "Pancrudo",
                        "latitude": "40.76223000",
                        "longitude": "-1.02967000"
                    },
                    {
                        "id": 152435,
                        "name": "Parras de Castellote Las",
                        "latitude": "40.77576900",
                        "longitude": "-0.24499030"
                    },
                    {
                        "id": 152436,
                        "name": "Peñarroya de Tastavins",
                        "latitude": "40.75657900",
                        "longitude": "0.03919330"
                    },
                    {
                        "id": 36130,
                        "name": "Peracense",
                        "latitude": "40.64099000",
                        "longitude": "-1.47075000"
                    },
                    {
                        "id": 36134,
                        "name": "Peralejos",
                        "latitude": "40.48433000",
                        "longitude": "-1.03408000"
                    },
                    {
                        "id": 36140,
                        "name": "Perales del Alfambra",
                        "latitude": "40.63383000",
                        "longitude": "-1.00181000"
                    },
                    {
                        "id": 36221,
                        "name": "Pitarque",
                        "latitude": "40.64850000",
                        "longitude": "-0.59324000"
                    },
                    {
                        "id": 36246,
                        "name": "Plou",
                        "latitude": "40.99274000",
                        "longitude": "-0.85441000"
                    },
                    {
                        "id": 152437,
                        "name": "Pobo El",
                        "latitude": "40.50761160",
                        "longitude": "-0.86096020"
                    },
                    {
                        "id": 152438,
                        "name": "Portellada La",
                        "latitude": "40.88795920",
                        "longitude": "0.04665590"
                    },
                    {
                        "id": 36325,
                        "name": "Pozondón",
                        "latitude": "40.56112000",
                        "longitude": "-1.47033000"
                    },
                    {
                        "id": 36329,
                        "name": "Pozuel del Campo",
                        "latitude": "40.77125000",
                        "longitude": "-1.50575000"
                    },
                    {
                        "id": 152439,
                        "name": "Puebla de Híjar La",
                        "latitude": "41.22979950",
                        "longitude": "-0.44080370"
                    },
                    {
                        "id": 152440,
                        "name": "Puebla de Valverde La",
                        "latitude": "40.22531860",
                        "longitude": "-0.93012010"
                    },
                    {
                        "id": 36458,
                        "name": "Puertomingalvo",
                        "latitude": "40.26430000",
                        "longitude": "-0.45756000"
                    },
                    {
                        "id": 36711,
                        "name": "Ráfales",
                        "latitude": "40.83770000",
                        "longitude": "0.01923000"
                    },
                    {
                        "id": 36624,
                        "name": "Rillo",
                        "latitude": "40.72233000",
                        "longitude": "-0.99623000"
                    },
                    {
                        "id": 36629,
                        "name": "Riodeva",
                        "latitude": "40.11667000",
                        "longitude": "-1.15000000"
                    },
                    {
                        "id": 36719,
                        "name": "Ródenas",
                        "latitude": "40.64076000",
                        "longitude": "-1.51617000"
                    },
                    {
                        "id": 36683,
                        "name": "Royuela",
                        "latitude": "40.37846000",
                        "longitude": "-1.51337000"
                    },
                    {
                        "id": 36689,
                        "name": "Rubiales",
                        "latitude": "40.27623000",
                        "longitude": "-1.27167000"
                    },
                    {
                        "id": 36691,
                        "name": "Rubielos de la Cérida",
                        "latitude": "40.77058000",
                        "longitude": "-1.21291000"
                    },
                    {
                        "id": 36690,
                        "name": "Rubielos de Mora",
                        "latitude": "40.18894000",
                        "longitude": "-0.65307000"
                    },
                    {
                        "id": 36753,
                        "name": "Salcedillo",
                        "latitude": "40.96200000",
                        "longitude": "-1.00433000"
                    },
                    {
                        "id": 36759,
                        "name": "Saldón",
                        "latitude": "40.32513000",
                        "longitude": "-1.42782000"
                    },
                    {
                        "id": 36793,
                        "name": "Samper de Calanda",
                        "latitude": "41.18933000",
                        "longitude": "-0.38883000"
                    },
                    {
                        "id": 36798,
                        "name": "San Agustín",
                        "latitude": "40.05929000",
                        "longitude": "-0.69254000"
                    },
                    {
                        "id": 36877,
                        "name": "San Martín del Río",
                        "latitude": "41.06633000",
                        "longitude": "-1.38733000"
                    },
                    {
                        "id": 37033,
                        "name": "Santa Cruz de Nogueras",
                        "latitude": "41.11475000",
                        "longitude": "-1.08933000"
                    },
                    {
                        "id": 37054,
                        "name": "Santa Eulalia",
                        "latitude": "40.56742000",
                        "longitude": "-1.31354000"
                    },
                    {
                        "id": 37173,
                        "name": "Sarrión",
                        "latitude": "40.14175000",
                        "longitude": "-0.81533000"
                    },
                    {
                        "id": 37198,
                        "name": "Segura de los Baños",
                        "latitude": "40.94088000",
                        "longitude": "-0.95111000"
                    },
                    {
                        "id": 37211,
                        "name": "Seno",
                        "latitude": "40.81225000",
                        "longitude": "-0.33816000"
                    },
                    {
                        "id": 37262,
                        "name": "Singra",
                        "latitude": "40.65508000",
                        "longitude": "-1.31158000"
                    },
                    {
                        "id": 37412,
                        "name": "Terriente",
                        "latitude": "40.29741000",
                        "longitude": "-1.50399000"
                    },
                    {
                        "id": 37415,
                        "name": "Teruel",
                        "latitude": "40.34560000",
                        "longitude": "-1.10646000"
                    },
                    {
                        "id": 152441,
                        "name": "Toril y Masegoso",
                        "latitude": "40.22751990",
                        "longitude": "-1.51118060"
                    },
                    {
                        "id": 37471,
                        "name": "Tormón",
                        "latitude": "40.20266000",
                        "longitude": "-1.35406000"
                    },
                    {
                        "id": 37475,
                        "name": "Tornos",
                        "latitude": "40.96188000",
                        "longitude": "-1.43389000"
                    },
                    {
                        "id": 37484,
                        "name": "Torralba de los Sisones",
                        "latitude": "40.89084000",
                        "longitude": "-1.45866000"
                    },
                    {
                        "id": 37490,
                        "name": "Torre de Arcas",
                        "latitude": "40.75137000",
                        "longitude": "-0.06892000"
                    },
                    {
                        "id": 37498,
                        "name": "Torre de las Arcas",
                        "latitude": "40.84166000",
                        "longitude": "-0.71783000"
                    },
                    {
                        "id": 37502,
                        "name": "Torre del Compte",
                        "latitude": "40.93625000",
                        "longitude": "0.10934000"
                    },
                    {
                        "id": 37505,
                        "name": "Torre los Negros",
                        "latitude": "40.85308000",
                        "longitude": "-1.09782000"
                    },
                    {
                        "id": 37515,
                        "name": "Torrecilla de Alcañiz",
                        "latitude": "40.96056000",
                        "longitude": "-0.09077000"
                    },
                    {
                        "id": 37523,
                        "name": "Torrecilla del Rebollar",
                        "latitude": "40.90978000",
                        "longitude": "-1.07244000"
                    },
                    {
                        "id": 152442,
                        "name": "Torrelacárcel",
                        "latitude": "40.61406240",
                        "longitude": "-1.30054110"
                    },
                    {
                        "id": 152443,
                        "name": "Torremocha de Jiloca",
                        "latitude": "40.58873540",
                        "longitude": "-1.29452090"
                    },
                    {
                        "id": 37572,
                        "name": "Torres de Albarracín",
                        "latitude": "40.42709000",
                        "longitude": "-1.53242000"
                    },
                    {
                        "id": 37583,
                        "name": "Torrevelilla",
                        "latitude": "40.90200000",
                        "longitude": "-0.10977000"
                    },
                    {
                        "id": 37586,
                        "name": "Torrijas",
                        "latitude": "40.01667000",
                        "longitude": "-0.95000000"
                    },
                    {
                        "id": 37588,
                        "name": "Torrijo del Campo",
                        "latitude": "40.82575000",
                        "longitude": "-1.33766000"
                    },
                    {
                        "id": 37616,
                        "name": "Tramacastiel",
                        "latitude": "40.18842000",
                        "longitude": "-1.24081000"
                    },
                    {
                        "id": 37617,
                        "name": "Tramacastilla",
                        "latitude": "40.43059000",
                        "longitude": "-1.57466000"
                    },
                    {
                        "id": 37642,
                        "name": "Tronchón",
                        "latitude": "40.62091000",
                        "longitude": "-0.39833000"
                    },
                    {
                        "id": 152444,
                        "name": "Urrea de Gaén",
                        "latitude": "41.16056090",
                        "longitude": "-0.47028950"
                    },
                    {
                        "id": 37712,
                        "name": "Utrillas",
                        "latitude": "40.81267000",
                        "longitude": "-0.84545000"
                    },
                    {
                        "id": 37721,
                        "name": "Valacloche",
                        "latitude": "40.19092000",
                        "longitude": "-1.09134000"
                    },
                    {
                        "id": 37722,
                        "name": "Valbona",
                        "latitude": "40.22877000",
                        "longitude": "-0.81079000"
                    },
                    {
                        "id": 37729,
                        "name": "Valdealgorfa",
                        "latitude": "40.99066000",
                        "longitude": "-0.03433000"
                    },
                    {
                        "id": 37742,
                        "name": "Valdecuenca",
                        "latitude": "40.29776000",
                        "longitude": "-1.40829000"
                    },
                    {
                        "id": 37760,
                        "name": "Valdelinares",
                        "latitude": "40.39114000",
                        "longitude": "-0.60593000"
                    },
                    {
                        "id": 37762,
                        "name": "Valdeltormo",
                        "latitude": "40.98716000",
                        "longitude": "0.08342000"
                    },
                    {
                        "id": 37793,
                        "name": "Valderrobres",
                        "latitude": "40.87209000",
                        "longitude": "0.15431000"
                    },
                    {
                        "id": 37832,
                        "name": "Valjunquera",
                        "latitude": "40.95250000",
                        "longitude": "0.02575000"
                    },
                    {
                        "id": 152445,
                        "name": "Vallecillo El",
                        "latitude": "40.23507850",
                        "longitude": "-1.56748690"
                    },
                    {
                        "id": 37920,
                        "name": "Veguillas de la Sierra",
                        "latitude": "40.15000000",
                        "longitude": "-1.40000000"
                    },
                    {
                        "id": 38063,
                        "name": "Villafranca del Campo",
                        "latitude": "40.69545000",
                        "longitude": "-1.34722000"
                    },
                    {
                        "id": 38083,
                        "name": "Villahermosa del Campo",
                        "latitude": "41.10942000",
                        "longitude": "-1.24692000"
                    },
                    {
                        "id": 38221,
                        "name": "Villanueva del Rebollar de la Sierra",
                        "latitude": "40.89108000",
                        "longitude": "-1.00837000"
                    },
                    {
                        "id": 38254,
                        "name": "Villar del Cobo",
                        "latitude": "40.39475000",
                        "longitude": "-1.67332000"
                    },
                    {
                        "id": 38262,
                        "name": "Villar del Salz",
                        "latitude": "40.68200000",
                        "longitude": "-1.49967000"
                    },
                    {
                        "id": 38286,
                        "name": "Villarluengo",
                        "latitude": "40.64842000",
                        "longitude": "-0.53066000"
                    },
                    {
                        "id": 38291,
                        "name": "Villarquemado",
                        "latitude": "40.51750000",
                        "longitude": "-1.26500000"
                    },
                    {
                        "id": 38299,
                        "name": "Villarroya de los Pinares",
                        "latitude": "40.52917000",
                        "longitude": "-0.66900000"
                    },
                    {
                        "id": 38329,
                        "name": "Villastar",
                        "latitude": "40.28102000",
                        "longitude": "-1.15139000"
                    },
                    {
                        "id": 38367,
                        "name": "Villel",
                        "latitude": "40.23463000",
                        "longitude": "-1.18611000"
                    },
                    {
                        "id": 152446,
                        "name": "Vinaceite",
                        "latitude": "41.26621470",
                        "longitude": "-0.58194430"
                    },
                    {
                        "id": 38397,
                        "name": "Visiedo",
                        "latitude": "40.68558000",
                        "longitude": "-1.09709000"
                    },
                    {
                        "id": 38404,
                        "name": "Vivel del Río Martín",
                        "latitude": "40.87091000",
                        "longitude": "-0.93889000"
                    },
                    {
                        "id": 152447,
                        "name": "Zoma La",
                        "latitude": "40.78354990",
                        "longitude": "-0.61952820"
                    }
                ]
            },
            {
                "id": 1205,
                "name": "Toledo",
                "iso2": "TO",
                "latitude": "39.86232000",
                "longitude": "-4.06946920",
                "type": "province",
                "cities": [
                    {
                        "id": 31987,
                        "name": "Ajofrín",
                        "latitude": "39.71088000",
                        "longitude": "-3.98220000"
                    },
                    {
                        "id": 152109,
                        "name": "Alameda de la Sagra",
                        "latitude": "40.01287580",
                        "longitude": "-3.79558650"
                    },
                    {
                        "id": 32030,
                        "name": "Albarreal de Tajo",
                        "latitude": "39.89698000",
                        "longitude": "-4.22895000"
                    },
                    {
                        "id": 32064,
                        "name": "Alcabón",
                        "latitude": "40.00224000",
                        "longitude": "-4.36852000"
                    },
                    {
                        "id": 32095,
                        "name": "Alcañizo",
                        "latitude": "39.90315000",
                        "longitude": "-5.10588000"
                    },
                    {
                        "id": 152110,
                        "name": "Alcaudete de la Jara",
                        "latitude": "39.78559520",
                        "longitude": "-4.86891890"
                    },
                    {
                        "id": 32106,
                        "name": "Alcolea de Tajo",
                        "latitude": "39.80966000",
                        "longitude": "-5.14738000"
                    },
                    {
                        "id": 152111,
                        "name": "Aldea en Cabo",
                        "latitude": "40.18439250",
                        "longitude": "-4.45616150"
                    },
                    {
                        "id": 32157,
                        "name": "Aldeanueva de Barbarroya",
                        "latitude": "39.75934000",
                        "longitude": "-5.02287000"
                    },
                    {
                        "id": 32161,
                        "name": "Aldeanueva de San Bartolomé",
                        "latitude": "39.63608000",
                        "longitude": "-5.11307000"
                    },
                    {
                        "id": 32287,
                        "name": "Almendral de la Cañada",
                        "latitude": "40.18456000",
                        "longitude": "-4.74173000"
                    },
                    {
                        "id": 152112,
                        "name": "Almonacid de Toledo",
                        "latitude": "39.80501830",
                        "longitude": "-3.83499760"
                    },
                    {
                        "id": 32307,
                        "name": "Almorox",
                        "latitude": "40.23423000",
                        "longitude": "-4.39044000"
                    },
                    {
                        "id": 32598,
                        "name": "Añover de Tajo",
                        "latitude": "39.98873000",
                        "longitude": "-3.76579000"
                    },
                    {
                        "id": 32432,
                        "name": "Arcicóllar",
                        "latitude": "40.05517000",
                        "longitude": "-4.11638000"
                    },
                    {
                        "id": 152113,
                        "name": "Argés",
                        "latitude": "39.80644590",
                        "longitude": "-4.05804820"
                    },
                    {
                        "id": 32592,
                        "name": "Azután",
                        "latitude": "39.78564000",
                        "longitude": "-5.12730000"
                    },
                    {
                        "id": 32658,
                        "name": "Barcience",
                        "latitude": "39.98367000",
                        "longitude": "-4.23437000"
                    },
                    {
                        "id": 32662,
                        "name": "Bargas",
                        "latitude": "39.94113000",
                        "longitude": "-4.01979000"
                    },
                    {
                        "id": 32755,
                        "name": "Belvis de la Jara",
                        "latitude": "39.75768000",
                        "longitude": "-4.94932000"
                    },
                    {
                        "id": 32959,
                        "name": "Borox",
                        "latitude": "40.06795000",
                        "longitude": "-3.73804000"
                    },
                    {
                        "id": 33002,
                        "name": "Buenaventura",
                        "latitude": "40.17705000",
                        "longitude": "-4.85003000"
                    },
                    {
                        "id": 33028,
                        "name": "Burguillos de Toledo",
                        "latitude": "39.79635000",
                        "longitude": "-3.99254000"
                    },
                    {
                        "id": 33033,
                        "name": "Burujón",
                        "latitude": "39.90113000",
                        "longitude": "-4.29730000"
                    },
                    {
                        "id": 33074,
                        "name": "Cabañas de la Sagra",
                        "latitude": "40.00610000",
                        "longitude": "-3.94560000"
                    },
                    {
                        "id": 33073,
                        "name": "Cabañas de Yepes",
                        "latitude": "39.89051000",
                        "longitude": "-3.53502000"
                    },
                    {
                        "id": 33082,
                        "name": "Cabezamesada",
                        "latitude": "39.81630000",
                        "longitude": "-3.10236000"
                    },
                    {
                        "id": 33141,
                        "name": "Calera y Chozas",
                        "latitude": "39.88278000",
                        "longitude": "-4.98213000"
                    },
                    {
                        "id": 33143,
                        "name": "Caleruela",
                        "latitude": "39.87483000",
                        "longitude": "-5.25693000"
                    },
                    {
                        "id": 152114,
                        "name": "Calzada de Oropesa",
                        "latitude": "39.89861520",
                        "longitude": "-5.27758640"
                    },
                    {
                        "id": 33164,
                        "name": "Camarena",
                        "latitude": "40.09311000",
                        "longitude": "-4.11927000"
                    },
                    {
                        "id": 33166,
                        "name": "Camarenilla",
                        "latitude": "40.01672000",
                        "longitude": "-4.07624000"
                    },
                    {
                        "id": 152115,
                        "name": "Campillo de la Jara El",
                        "latitude": "39.58991290",
                        "longitude": "-5.05336320"
                    },
                    {
                        "id": 33214,
                        "name": "Camuñas",
                        "latitude": "39.42704000",
                        "longitude": "-3.45503000"
                    },
                    {
                        "id": 33303,
                        "name": "Cardiel de los Montes",
                        "latitude": "40.06348000",
                        "longitude": "-4.65488000"
                    },
                    {
                        "id": 33309,
                        "name": "Carmena",
                        "latitude": "39.95562000",
                        "longitude": "-4.40149000"
                    },
                    {
                        "id": 152116,
                        "name": "Carpio de Tajo El",
                        "latitude": "39.88813230",
                        "longitude": "-4.45680500"
                    },
                    {
                        "id": 33317,
                        "name": "Carranque",
                        "latitude": "40.16976000",
                        "longitude": "-3.90092000"
                    },
                    {
                        "id": 33327,
                        "name": "Carriches",
                        "latitude": "39.96417000",
                        "longitude": "-4.45864000"
                    },
                    {
                        "id": 152117,
                        "name": "Casar de Escalona El",
                        "latitude": "40.04699280",
                        "longitude": "-4.52250090"
                    },
                    {
                        "id": 33353,
                        "name": "Casarrubios del Monte",
                        "latitude": "40.18697000",
                        "longitude": "-4.03644000"
                    },
                    {
                        "id": 33376,
                        "name": "Casasbuenas",
                        "latitude": "39.76117000",
                        "longitude": "-4.12558000"
                    },
                    {
                        "id": 33462,
                        "name": "Castillo de Bayuela",
                        "latitude": "40.10032000",
                        "longitude": "-4.68562000"
                    },
                    {
                        "id": 33521,
                        "name": "Cazalegas",
                        "latitude": "40.00958000",
                        "longitude": "-4.67606000"
                    },
                    {
                        "id": 33549,
                        "name": "Cebolla",
                        "latitude": "39.94897000",
                        "longitude": "-4.57175000"
                    },
                    {
                        "id": 33557,
                        "name": "Cedillo del Condado",
                        "latitude": "40.11260000",
                        "longitude": "-3.92127000"
                    },
                    {
                        "id": 152118,
                        "name": "Cerralbos Los",
                        "latitude": "39.98436600",
                        "longitude": "-4.56953540"
                    },
                    {
                        "id": 33599,
                        "name": "Cervera de los Montes",
                        "latitude": "40.05182000",
                        "longitude": "-4.81072000"
                    },
                    {
                        "id": 33647,
                        "name": "Chozas de Canales",
                        "latitude": "40.10014000",
                        "longitude": "-4.04333000"
                    },
                    {
                        "id": 33649,
                        "name": "Chueca",
                        "latitude": "39.73191000",
                        "longitude": "-3.94365000"
                    },
                    {
                        "id": 33686,
                        "name": "Ciruelos",
                        "latitude": "39.93881000",
                        "longitude": "-3.61383000"
                    },
                    {
                        "id": 33707,
                        "name": "Cobeja",
                        "latitude": "40.02076000",
                        "longitude": "-3.85599000"
                    },
                    {
                        "id": 33710,
                        "name": "Cobisa",
                        "latitude": "39.80425000",
                        "longitude": "-4.02528000"
                    },
                    {
                        "id": 33768,
                        "name": "Consuegra",
                        "latitude": "39.46246000",
                        "longitude": "-3.60800000"
                    },
                    {
                        "id": 33798,
                        "name": "Corral de Almaguer",
                        "latitude": "39.75987000",
                        "longitude": "-3.16452000"
                    },
                    {
                        "id": 33866,
                        "name": "Cuerva",
                        "latitude": "39.66374000",
                        "longitude": "-4.21085000"
                    },
                    {
                        "id": 33939,
                        "name": "Domingo Pérez",
                        "latitude": "39.97661000",
                        "longitude": "-4.50554000"
                    },
                    {
                        "id": 33951,
                        "name": "Dosbarrios",
                        "latitude": "39.88199000",
                        "longitude": "-3.48419000"
                    },
                    {
                        "id": 34072,
                        "name": "Erustes",
                        "latitude": "39.95667000",
                        "longitude": "-4.49656000"
                    },
                    {
                        "id": 34077,
                        "name": "Escalona",
                        "latitude": "40.16690000",
                        "longitude": "-4.40484000"
                    },
                    {
                        "id": 34079,
                        "name": "Escalonilla",
                        "latitude": "39.92570000",
                        "longitude": "-4.35095000"
                    },
                    {
                        "id": 34124,
                        "name": "Espinoso del Rey",
                        "latitude": "39.65333000",
                        "longitude": "-4.78371000"
                    },
                    {
                        "id": 34134,
                        "name": "Esquivias",
                        "latitude": "40.10440000",
                        "longitude": "-3.76677000"
                    },
                    {
                        "id": 152119,
                        "name": "Estrella La",
                        "latitude": "39.68941570",
                        "longitude": "-5.09659290"
                    },
                    {
                        "id": 34288,
                        "name": "Fuensalida",
                        "latitude": "40.05288000",
                        "longitude": "-4.20718000"
                    },
                    {
                        "id": 34560,
                        "name": "Gálvez",
                        "latitude": "39.70208000",
                        "longitude": "-4.27239000"
                    },
                    {
                        "id": 152120,
                        "name": "Garciotum",
                        "latitude": "40.09899220",
                        "longitude": "-4.64697230"
                    },
                    {
                        "id": 34456,
                        "name": "Gerindote",
                        "latitude": "39.96594000",
                        "longitude": "-4.30278000"
                    },
                    {
                        "id": 34527,
                        "name": "Guadamur",
                        "latitude": "39.81178000",
                        "longitude": "-4.14885000"
                    },
                    {
                        "id": 152121,
                        "name": "Guardia La",
                        "latitude": "39.78679490",
                        "longitude": "-3.47382080"
                    },
                    {
                        "id": 152122,
                        "name": "Herencias Las",
                        "latitude": "39.86873800",
                        "longitude": "-4.92146240"
                    },
                    {
                        "id": 34601,
                        "name": "Herreruela de Oropesa",
                        "latitude": "39.88928000",
                        "longitude": "-5.24279000"
                    },
                    {
                        "id": 34625,
                        "name": "Hinojosa de San Vicente",
                        "latitude": "40.10463000",
                        "longitude": "-4.72269000"
                    },
                    {
                        "id": 34639,
                        "name": "Hontanar",
                        "latitude": "39.61297000",
                        "longitude": "-4.49663000"
                    },
                    {
                        "id": 34656,
                        "name": "Hormigos",
                        "latitude": "40.09778000",
                        "longitude": "-4.44473000"
                    },
                    {
                        "id": 34683,
                        "name": "Huecas",
                        "latitude": "40.01230000",
                        "longitude": "-4.19541000"
                    },
                    {
                        "id": 34688,
                        "name": "Huerta de Valdecarábanos",
                        "latitude": "39.86319000",
                        "longitude": "-3.61275000"
                    },
                    {
                        "id": 152123,
                        "name": "Iglesuela La",
                        "latitude": "40.23333900",
                        "longitude": "-4.74974570"
                    },
                    {
                        "id": 34751,
                        "name": "Illán de Vacas",
                        "latitude": "39.97079000",
                        "longitude": "-4.55743000"
                    },
                    {
                        "id": 34748,
                        "name": "Illescas",
                        "latitude": "40.12213000",
                        "longitude": "-3.84704000"
                    },
                    {
                        "id": 34939,
                        "name": "Lagartera",
                        "latitude": "39.90557000",
                        "longitude": "-5.20143000"
                    },
                    {
                        "id": 35006,
                        "name": "Layos",
                        "latitude": "39.77703000",
                        "longitude": "-4.06448000"
                    },
                    {
                        "id": 35050,
                        "name": "Lillo",
                        "latitude": "39.72331000",
                        "longitude": "-3.30618000"
                    },
                    {
                        "id": 35104,
                        "name": "Lominchar",
                        "latitude": "40.09061000",
                        "longitude": "-3.96713000"
                    },
                    {
                        "id": 35154,
                        "name": "Lucillos",
                        "latitude": "39.98510000",
                        "longitude": "-4.61279000"
                    },
                    {
                        "id": 35188,
                        "name": "Madridejos",
                        "latitude": "39.46823000",
                        "longitude": "-3.53196000"
                    },
                    {
                        "id": 35205,
                        "name": "Magán",
                        "latitude": "39.96138000",
                        "longitude": "-3.93164000"
                    },
                    {
                        "id": 152124,
                        "name": "Malpica de Tajo",
                        "latitude": "39.89755110",
                        "longitude": "-4.54801160"
                    },
                    {
                        "id": 35269,
                        "name": "Manzaneque",
                        "latitude": "39.63549000",
                        "longitude": "-3.79249000"
                    },
                    {
                        "id": 35273,
                        "name": "Maqueda",
                        "latitude": "40.06614000",
                        "longitude": "-4.37066000"
                    },
                    {
                        "id": 35293,
                        "name": "Marjaliza",
                        "latitude": "39.56329000",
                        "longitude": "-3.93499000"
                    },
                    {
                        "id": 152125,
                        "name": "Marrupe",
                        "latitude": "40.09049120",
                        "longitude": "-4.79311050"
                    },
                    {
                        "id": 35318,
                        "name": "Mascaraque",
                        "latitude": "39.71643000",
                        "longitude": "-3.81254000"
                    },
                    {
                        "id": 152126,
                        "name": "Mata La",
                        "latitude": "39.94144250",
                        "longitude": "-4.43750350"
                    },
                    {
                        "id": 35352,
                        "name": "Mazarambroz",
                        "latitude": "39.69411000",
                        "longitude": "-4.01962000"
                    },
                    {
                        "id": 35383,
                        "name": "Mejorada",
                        "latitude": "40.00991000",
                        "longitude": "-4.88506000"
                    },
                    {
                        "id": 35397,
                        "name": "Menasalbas",
                        "latitude": "39.63954000",
                        "longitude": "-4.28418000"
                    },
                    {
                        "id": 35706,
                        "name": "Méntrida",
                        "latitude": "40.23899000",
                        "longitude": "-4.19337000"
                    },
                    {
                        "id": 152127,
                        "name": "Mesegar de Tajo",
                        "latitude": "39.92676400",
                        "longitude": "-4.50251290"
                    },
                    {
                        "id": 35423,
                        "name": "Miguel Esteban",
                        "latitude": "39.52448000",
                        "longitude": "-3.07618000"
                    },
                    {
                        "id": 35460,
                        "name": "Mocejón",
                        "latitude": "39.93934000",
                        "longitude": "-3.91716000"
                    },
                    {
                        "id": 35470,
                        "name": "Mohedas de la Jara",
                        "latitude": "39.60417000",
                        "longitude": "-5.14247000"
                    },
                    {
                        "id": 35545,
                        "name": "Montearagón",
                        "latitude": "39.96425000",
                        "longitude": "-4.63214000"
                    },
                    {
                        "id": 35571,
                        "name": "Montesclaros",
                        "latitude": "40.10646000",
                        "longitude": "-4.93849000"
                    },
                    {
                        "id": 35593,
                        "name": "Mora",
                        "latitude": "39.68492000",
                        "longitude": "-3.77394000"
                    },
                    {
                        "id": 35711,
                        "name": "Nambroca",
                        "latitude": "39.79771000",
                        "longitude": "-3.94434000"
                    },
                    {
                        "id": 152128,
                        "name": "Nava de Ricomalillo La",
                        "latitude": "39.63784970",
                        "longitude": "-4.98704910"
                    },
                    {
                        "id": 35736,
                        "name": "Navahermosa",
                        "latitude": "39.63526000",
                        "longitude": "-4.47012000"
                    },
                    {
                        "id": 35745,
                        "name": "Navalcán",
                        "latitude": "40.06667000",
                        "longitude": "-5.08333000"
                    },
                    {
                        "id": 35753,
                        "name": "Navalmoralejo",
                        "latitude": "39.73929000",
                        "longitude": "-5.14359000"
                    },
                    {
                        "id": 152129,
                        "name": "Navalmorales Los",
                        "latitude": "39.72550720",
                        "longitude": "-4.64116070"
                    },
                    {
                        "id": 152130,
                        "name": "Navalucillos Los",
                        "latitude": "39.66498400",
                        "longitude": "-4.64245210"
                    },
                    {
                        "id": 35763,
                        "name": "Navamorcuende",
                        "latitude": "40.15659000",
                        "longitude": "-4.78625000"
                    },
                    {
                        "id": 35813,
                        "name": "Noblejas",
                        "latitude": "39.98061000",
                        "longitude": "-3.44001000"
                    },
                    {
                        "id": 35814,
                        "name": "Noez",
                        "latitude": "39.74094000",
                        "longitude": "-4.18408000"
                    },
                    {
                        "id": 35822,
                        "name": "Nombela",
                        "latitude": "40.15530000",
                        "longitude": "-4.50223000"
                    },
                    {
                        "id": 35831,
                        "name": "Novés",
                        "latitude": "40.04746000",
                        "longitude": "-4.27471000"
                    },
                    {
                        "id": 35838,
                        "name": "Numancia de la Sagra",
                        "latitude": "40.07395000",
                        "longitude": "-3.85118000"
                    },
                    {
                        "id": 35840,
                        "name": "Nuño Gómez",
                        "latitude": "40.11383000",
                        "longitude": "-4.61978000"
                    },
                    {
                        "id": 35855,
                        "name": "Ocaña",
                        "latitude": "39.95785000",
                        "longitude": "-3.49820000"
                    },
                    {
                        "id": 35919,
                        "name": "Olías del Rey",
                        "latitude": "39.94436000",
                        "longitude": "-3.98684000"
                    },
                    {
                        "id": 35929,
                        "name": "Ontígola",
                        "latitude": "40.00421000",
                        "longitude": "-3.57227000"
                    },
                    {
                        "id": 35947,
                        "name": "Orgaz",
                        "latitude": "39.64826000",
                        "longitude": "-3.87577000"
                    },
                    {
                        "id": 35957,
                        "name": "Oropesa",
                        "latitude": "39.91726000",
                        "longitude": "-5.17371000"
                    },
                    {
                        "id": 35977,
                        "name": "Otero",
                        "latitude": "40.00096000",
                        "longitude": "-4.51539000"
                    },
                    {
                        "id": 36039,
                        "name": "Palomeque",
                        "latitude": "40.11966000",
                        "longitude": "-3.96403000"
                    },
                    {
                        "id": 36049,
                        "name": "Pantoja",
                        "latitude": "40.04336000",
                        "longitude": "-3.83280000"
                    },
                    {
                        "id": 36065,
                        "name": "Paredes de Escalona",
                        "latitude": "40.20472000",
                        "longitude": "-4.43050000"
                    },
                    {
                        "id": 36071,
                        "name": "Parrillas",
                        "latitude": "40.06225000",
                        "longitude": "-5.06390000"
                    },
                    {
                        "id": 36119,
                        "name": "Pelahustán",
                        "latitude": "40.17599000",
                        "longitude": "-4.59842000"
                    },
                    {
                        "id": 152131,
                        "name": "Pepino",
                        "latitude": "40.03257450",
                        "longitude": "-4.80217610"
                    },
                    {
                        "id": 36266,
                        "name": "Polán",
                        "latitude": "39.78765000",
                        "longitude": "-4.16792000"
                    },
                    {
                        "id": 36293,
                        "name": "Portillo de Toledo",
                        "latitude": "40.06415000",
                        "longitude": "-4.22793000"
                    },
                    {
                        "id": 152132,
                        "name": "Puebla de Almoradiel La",
                        "latitude": "39.59715780",
                        "longitude": "-3.12026280"
                    },
                    {
                        "id": 152133,
                        "name": "Puebla de Montalbán La",
                        "latitude": "39.86434670",
                        "longitude": "-4.35933010"
                    },
                    {
                        "id": 152134,
                        "name": "Pueblanueva La",
                        "latitude": "39.91432670",
                        "longitude": "-4.67692960"
                    },
                    {
                        "id": 152135,
                        "name": "Puente del Arzobispo El",
                        "latitude": "39.80296360",
                        "longitude": "-5.17187630"
                    },
                    {
                        "id": 36452,
                        "name": "Puerto de San Vicente",
                        "latitude": "39.52283000",
                        "longitude": "-5.11407000"
                    },
                    {
                        "id": 36467,
                        "name": "Pulgar",
                        "latitude": "39.69383000",
                        "longitude": "-4.15233000"
                    },
                    {
                        "id": 36495,
                        "name": "Quero",
                        "latitude": "39.51111000",
                        "longitude": "-3.24741000"
                    },
                    {
                        "id": 36511,
                        "name": "Quintanar de la Orden",
                        "latitude": "39.59369000",
                        "longitude": "-3.04165000"
                    },
                    {
                        "id": 36531,
                        "name": "Quismondo",
                        "latitude": "40.10533000",
                        "longitude": "-4.32394000"
                    },
                    {
                        "id": 152136,
                        "name": "Real de San Vicente El",
                        "latitude": "40.13621920",
                        "longitude": "-4.69025580"
                    },
                    {
                        "id": 36557,
                        "name": "Recas",
                        "latitude": "40.05286000",
                        "longitude": "-3.99090000"
                    },
                    {
                        "id": 152137,
                        "name": "Retamoso de la Jara",
                        "latitude": "39.74338550",
                        "longitude": "-4.75556880"
                    },
                    {
                        "id": 36623,
                        "name": "Rielves",
                        "latitude": "39.96206000",
                        "longitude": "-4.19300000"
                    },
                    {
                        "id": 152138,
                        "name": "Robledo del Mazo",
                        "latitude": "39.60975010",
                        "longitude": "-4.90588880"
                    },
                    {
                        "id": 152139,
                        "name": "Romeral El",
                        "latitude": "39.71476410",
                        "longitude": "-3.42964460"
                    },
                    {
                        "id": 36811,
                        "name": "San Bartolomé de las Abiertas",
                        "latitude": "39.82972000",
                        "longitude": "-4.71901000"
                    },
                    {
                        "id": 36865,
                        "name": "San Martín de Montalbán",
                        "latitude": "39.70186000",
                        "longitude": "-4.38796000"
                    },
                    {
                        "id": 36866,
                        "name": "San Martín de Pusa",
                        "latitude": "39.78404000",
                        "longitude": "-4.63252000"
                    },
                    {
                        "id": 152140,
                        "name": "San Pablo de los Montes",
                        "latitude": "39.54162940",
                        "longitude": "-4.33211140"
                    },
                    {
                        "id": 152141,
                        "name": "San Román de los Montes",
                        "latitude": "0.00000000",
                        "longitude": "0.00000000"
                    },
                    {
                        "id": 37005,
                        "name": "Santa Ana de Pusa",
                        "latitude": "39.76238000",
                        "longitude": "-4.70904000"
                    },
                    {
                        "id": 37042,
                        "name": "Santa Cruz de la Zarza",
                        "latitude": "39.98104000",
                        "longitude": "-3.18787000"
                    },
                    {
                        "id": 37044,
                        "name": "Santa Cruz del Retamar",
                        "latitude": "40.11917000",
                        "longitude": "-4.24158000"
                    },
                    {
                        "id": 37092,
                        "name": "Santa Olalla",
                        "latitude": "40.02348000",
                        "longitude": "-4.43025000"
                    },
                    {
                        "id": 152153,
                        "name": "Santo Domingo-Caudilla",
                        "latitude": "40.01937010",
                        "longitude": "-4.30181690"
                    },
                    {
                        "id": 37175,
                        "name": "Sartajada",
                        "latitude": "40.21320000",
                        "longitude": "-4.79427000"
                    },
                    {
                        "id": 37199,
                        "name": "Segurilla",
                        "latitude": "40.02386000",
                        "longitude": "-4.86418000"
                    },
                    {
                        "id": 37231,
                        "name": "Seseña",
                        "latitude": "40.10473000",
                        "longitude": "-3.69793000"
                    },
                    {
                        "id": 37241,
                        "name": "Sevilleja de la Jara",
                        "latitude": "39.57488000",
                        "longitude": "-4.96387000"
                    },
                    {
                        "id": 37294,
                        "name": "Sonseca",
                        "latitude": "39.67747000",
                        "longitude": "-3.97448000"
                    },
                    {
                        "id": 37315,
                        "name": "Sotillo de las Palomas",
                        "latitude": "40.10359000",
                        "longitude": "-4.82736000"
                    },
                    {
                        "id": 37358,
                        "name": "Talavera de la Reina",
                        "latitude": "39.96348000",
                        "longitude": "-4.83076000"
                    },
                    {
                        "id": 37401,
                        "name": "Tembleque",
                        "latitude": "39.69541000",
                        "longitude": "-3.50429000"
                    },
                    {
                        "id": 152142,
                        "name": "Toboso El",
                        "latitude": "39.51390610",
                        "longitude": "-2.99630890"
                    },
                    {
                        "id": 37443,
                        "name": "Toledo",
                        "latitude": "39.85810000",
                        "longitude": "-4.02263000"
                    },
                    {
                        "id": 37481,
                        "name": "Torralba de Oropesa",
                        "latitude": "39.93384000",
                        "longitude": "-5.15404000"
                    },
                    {
                        "id": 152143,
                        "name": "Torre de Esteban Hambrán La",
                        "latitude": "40.16636430",
                        "longitude": "-4.21546640"
                    },
                    {
                        "id": 37517,
                        "name": "Torrecilla de la Jara",
                        "latitude": "39.70425000",
                        "longitude": "-4.77186000"
                    },
                    {
                        "id": 37585,
                        "name": "Torrico",
                        "latitude": "39.82918000",
                        "longitude": "-5.22581000"
                    },
                    {
                        "id": 37589,
                        "name": "Torrijos",
                        "latitude": "39.98195000",
                        "longitude": "-4.28349000"
                    },
                    {
                        "id": 37607,
                        "name": "Totanés",
                        "latitude": "39.71057000",
                        "longitude": "-4.22655000"
                    },
                    {
                        "id": 37655,
                        "name": "Turleque",
                        "latitude": "39.60138000",
                        "longitude": "-3.61404000"
                    },
                    {
                        "id": 37674,
                        "name": "Ugena",
                        "latitude": "40.15572000",
                        "longitude": "-3.87603000"
                    },
                    {
                        "id": 37690,
                        "name": "Urda",
                        "latitude": "39.41179000",
                        "longitude": "-3.71493000"
                    },
                    {
                        "id": 37806,
                        "name": "Valdeverdeja",
                        "latitude": "39.79635000",
                        "longitude": "-5.24544000"
                    },
                    {
                        "id": 37869,
                        "name": "Valmojado",
                        "latitude": "40.20444000",
                        "longitude": "-4.09146000"
                    },
                    {
                        "id": 37922,
                        "name": "Velada",
                        "latitude": "39.97687000",
                        "longitude": "-4.97641000"
                    },
                    {
                        "id": 152144,
                        "name": "Ventas con Peña Aguilera Las",
                        "latitude": "39.61121800",
                        "longitude": "-4.23014610"
                    },
                    {
                        "id": 152145,
                        "name": "Ventas de Retamosa Las",
                        "latitude": "40.15821230",
                        "longitude": "-4.14625820"
                    },
                    {
                        "id": 152146,
                        "name": "Ventas de San Julián Las",
                        "latitude": "40.00923430",
                        "longitude": "-5.29456940"
                    },
                    {
                        "id": 152147,
                        "name": "Villa de Don Fadrique La",
                        "latitude": "39.61432320",
                        "longitude": "-3.21696220"
                    },
                    {
                        "id": 38028,
                        "name": "Villacañas",
                        "latitude": "39.62367000",
                        "longitude": "-3.33813000"
                    },
                    {
                        "id": 38061,
                        "name": "Villafranca de los Caballeros",
                        "latitude": "39.42824000",
                        "longitude": "-3.36079000"
                    },
                    {
                        "id": 152148,
                        "name": "Villaluenga de la Sagra",
                        "latitude": "40.02700690",
                        "longitude": "-3.91008970"
                    },
                    {
                        "id": 38155,
                        "name": "Villamiel de Toledo",
                        "latitude": "39.96482000",
                        "longitude": "-4.12627000"
                    },
                    {
                        "id": 38157,
                        "name": "Villaminaya",
                        "latitude": "39.71197000",
                        "longitude": "-3.87055000"
                    },
                    {
                        "id": 38163,
                        "name": "Villamuelas",
                        "latitude": "39.81784000",
                        "longitude": "-3.73461000"
                    },
                    {
                        "id": 38169,
                        "name": "Villanueva de Alcardete",
                        "latitude": "39.67321000",
                        "longitude": "-3.01445000"
                    },
                    {
                        "id": 38175,
                        "name": "Villanueva de Bogas",
                        "latitude": "39.72347000",
                        "longitude": "-3.65743000"
                    },
                    {
                        "id": 38272,
                        "name": "Villarejo de Montalbán",
                        "latitude": "39.76913000",
                        "longitude": "-4.57314000"
                    },
                    {
                        "id": 38302,
                        "name": "Villarrubia de Santiago",
                        "latitude": "39.98555000",
                        "longitude": "-3.36898000"
                    },
                    {
                        "id": 38321,
                        "name": "Villaseca de la Sagra",
                        "latitude": "39.96185000",
                        "longitude": "-3.88291000"
                    },
                    {
                        "id": 152149,
                        "name": "Villasequilla",
                        "latitude": "39.87387610",
                        "longitude": "-3.73208450"
                    },
                    {
                        "id": 38330,
                        "name": "Villatobas",
                        "latitude": "39.90187000",
                        "longitude": "-3.32386000"
                    },
                    {
                        "id": 152150,
                        "name": "Viso de San Juan El",
                        "latitude": "40.14372810",
                        "longitude": "-3.91964320"
                    },
                    {
                        "id": 152151,
                        "name": "Yébenes Los",
                        "latitude": "39.58114050",
                        "longitude": "-3.86934810"
                    },
                    {
                        "id": 38433,
                        "name": "Yeles",
                        "latitude": "40.12035000",
                        "longitude": "-3.80487000"
                    },
                    {
                        "id": 38435,
                        "name": "Yepes",
                        "latitude": "39.90199000",
                        "longitude": "-3.62517000"
                    },
                    {
                        "id": 38439,
                        "name": "Yuncler",
                        "latitude": "40.04079000",
                        "longitude": "-3.89979000"
                    },
                    {
                        "id": 152152,
                        "name": "Yunclillos",
                        "latitude": "40.02175890",
                        "longitude": "-3.98911830"
                    },
                    {
                        "id": 38440,
                        "name": "Yuncos",
                        "latitude": "40.08590000",
                        "longitude": "-3.87106000"
                    }
                ]
            },
            {
                "id": 1175,
                "name": "Valencia",
                "iso2": "V",
                "latitude": "39.48401080",
                "longitude": "-0.75328090",
                "type": "province",
                "cities": [
                    {
                        "id": 31932,
                        "name": "Ademuz",
                        "latitude": "40.06139000",
                        "longitude": "-1.28677000"
                    },
                    {
                        "id": 31935,
                        "name": "Ador",
                        "latitude": "38.91823000",
                        "longitude": "-0.22247000"
                    },
                    {
                        "id": 31943,
                        "name": "Adzaneta",
                        "latitude": "40.21616000",
                        "longitude": "-0.17028000"
                    },
                    {
                        "id": 31968,
                        "name": "Agullent",
                        "latitude": "38.82273000",
                        "longitude": "-0.54833000"
                    },
                    {
                        "id": 31979,
                        "name": "Aielo de Malferit",
                        "latitude": "38.88333000",
                        "longitude": "-0.58333000"
                    },
                    {
                        "id": 152928,
                        "name": "Aielo de Rugat",
                        "latitude": "38.88210350",
                        "longitude": "-0.34458250"
                    },
                    {
                        "id": 32001,
                        "name": "Alaquàs",
                        "latitude": "39.45568000",
                        "longitude": "-0.46100000"
                    },
                    {
                        "id": 32014,
                        "name": "Albaida",
                        "latitude": "38.83798000",
                        "longitude": "-0.51721000"
                    },
                    {
                        "id": 32016,
                        "name": "Albal",
                        "latitude": "39.40000000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 32019,
                        "name": "Albalat de la Ribera",
                        "latitude": "39.20000000",
                        "longitude": "-0.38333000"
                    },
                    {
                        "id": 32020,
                        "name": "Albalat dels Sorells",
                        "latitude": "39.53333000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 32021,
                        "name": "Albalat dels Tarongers",
                        "latitude": "39.70000000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 32037,
                        "name": "Alberic",
                        "latitude": "39.11667000",
                        "longitude": "-0.51667000"
                    },
                    {
                        "id": 32051,
                        "name": "Alborache",
                        "latitude": "39.38333000",
                        "longitude": "-0.76667000"
                    },
                    {
                        "id": 32052,
                        "name": "Alboraya",
                        "latitude": "39.50000000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 32058,
                        "name": "Albuixech",
                        "latitude": "39.55000000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 32133,
                        "name": "Alcàntera de Xúquer",
                        "latitude": "39.06667000",
                        "longitude": "-0.55000000"
                    },
                    {
                        "id": 32134,
                        "name": "Alcàsser",
                        "latitude": "39.36791000",
                        "longitude": "-0.44447000"
                    },
                    {
                        "id": 32101,
                        "name": "Alcocéber",
                        "latitude": "40.25142000",
                        "longitude": "0.28433000"
                    },
                    {
                        "id": 32123,
                        "name": "Alcoy",
                        "latitude": "38.70545000",
                        "longitude": "-0.47432000"
                    },
                    {
                        "id": 32129,
                        "name": "Alcublas",
                        "latitude": "39.80000000",
                        "longitude": "-0.70000000"
                    },
                    {
                        "id": 152922,
                        "name": "Alcúdia de Crespins l",
                        "latitude": "38.97287250",
                        "longitude": "-0.59365490"
                    },
                    {
                        "id": 152921,
                        "name": "Alcúdia l",
                        "latitude": "39.19748430",
                        "longitude": "-0.50452060"
                    },
                    {
                        "id": 32140,
                        "name": "Aldaia",
                        "latitude": "39.46569000",
                        "longitude": "-0.46005000"
                    },
                    {
                        "id": 32189,
                        "name": "Alfafar",
                        "latitude": "39.41667000",
                        "longitude": "-0.38333000"
                    },
                    {
                        "id": 32194,
                        "name": "Alfara de Algimia",
                        "latitude": "39.76667000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 152923,
                        "name": "Alfara de la Baronia",
                        "latitude": "39.76278110",
                        "longitude": "-0.35541940"
                    },
                    {
                        "id": 32195,
                        "name": "Alfara del Patriarca",
                        "latitude": "39.55000000",
                        "longitude": "-0.38333000"
                    },
                    {
                        "id": 32199,
                        "name": "Alfarp",
                        "latitude": "39.28333000",
                        "longitude": "-0.55000000"
                    },
                    {
                        "id": 32200,
                        "name": "Alfarrasí",
                        "latitude": "38.90000000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 32202,
                        "name": "Alfauir",
                        "latitude": "38.93333000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 152924,
                        "name": "Algar de Palancia",
                        "latitude": "39.78077280",
                        "longitude": "-0.36718560"
                    },
                    {
                        "id": 32217,
                        "name": "Algemesí",
                        "latitude": "39.19042000",
                        "longitude": "-0.43572000"
                    },
                    {
                        "id": 32220,
                        "name": "Algimia de Alfara",
                        "latitude": "39.75000000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 32222,
                        "name": "Alginet",
                        "latitude": "39.26667000",
                        "longitude": "-0.46667000"
                    },
                    {
                        "id": 32244,
                        "name": "Alicante",
                        "latitude": "38.34517000",
                        "longitude": "-0.48149000"
                    },
                    {
                        "id": 152925,
                        "name": "Almàssera",
                        "latitude": "39.51047040",
                        "longitude": "-0.35718410"
                    },
                    {
                        "id": 32273,
                        "name": "Almassora",
                        "latitude": "39.94729000",
                        "longitude": "-0.06313000"
                    },
                    {
                        "id": 32291,
                        "name": "Almiserà",
                        "latitude": "38.91667000",
                        "longitude": "-0.28333000"
                    },
                    {
                        "id": 32300,
                        "name": "Almoines",
                        "latitude": "38.94325000",
                        "longitude": "-0.18155000"
                    },
                    {
                        "id": 32313,
                        "name": "Almussafes",
                        "latitude": "39.28333000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 32332,
                        "name": "Alpuente",
                        "latitude": "39.86667000",
                        "longitude": "-1.01667000"
                    },
                    {
                        "id": 152926,
                        "name": "Alqueria de la Comtessa l",
                        "latitude": "38.93278450",
                        "longitude": "-0.15183940"
                    },
                    {
                        "id": 32344,
                        "name": "Alzira",
                        "latitude": "39.15000000",
                        "longitude": "-0.43333000"
                    },
                    {
                        "id": 32371,
                        "name": "Andilla",
                        "latitude": "39.83333000",
                        "longitude": "-0.80000000"
                    },
                    {
                        "id": 32385,
                        "name": "Anna",
                        "latitude": "39.02029000",
                        "longitude": "-0.64621000"
                    },
                    {
                        "id": 32391,
                        "name": "Antella",
                        "latitude": "39.07977000",
                        "longitude": "-0.59195000"
                    },
                    {
                        "id": 152927,
                        "name": "Aras de los Olmos",
                        "latitude": "39.92418290",
                        "longitude": "-1.13319120"
                    },
                    {
                        "id": 32456,
                        "name": "Ares del Maestre",
                        "latitude": "40.45675000",
                        "longitude": "-0.13267000"
                    },
                    {
                        "id": 32556,
                        "name": "Atzeneta d'Albaida",
                        "latitude": "38.83333000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 152920,
                        "name": "Atzeneta dAlbaida",
                        "latitude": "38.83125110",
                        "longitude": "-0.49861660"
                    },
                    {
                        "id": 32576,
                        "name": "Ayora",
                        "latitude": "39.05852000",
                        "longitude": "-1.05635000"
                    },
                    {
                        "id": 32683,
                        "name": "Barx",
                        "latitude": "39.01667000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 32684,
                        "name": "Barxeta",
                        "latitude": "39.01667000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 33056,
                        "name": "Bèlgida",
                        "latitude": "38.85000000",
                        "longitude": "-0.46667000"
                    },
                    {
                        "id": 32744,
                        "name": "Bellreguard",
                        "latitude": "38.95000000",
                        "longitude": "-0.16667000"
                    },
                    {
                        "id": 32747,
                        "name": "Bellús",
                        "latitude": "38.94580000",
                        "longitude": "-0.48697000"
                    },
                    {
                        "id": 32761,
                        "name": "Benagéber",
                        "latitude": "39.71667000",
                        "longitude": "-1.10000000"
                    },
                    {
                        "id": 32760,
                        "name": "Benaguasil",
                        "latitude": "39.60000000",
                        "longitude": "-0.58333000"
                    },
                    {
                        "id": 32778,
                        "name": "Benassal",
                        "latitude": "40.37690000",
                        "longitude": "-0.13970000"
                    },
                    {
                        "id": 32783,
                        "name": "Benavites",
                        "latitude": "39.73333000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 32786,
                        "name": "Beneixida",
                        "latitude": "39.06667000",
                        "longitude": "-0.55000000"
                    },
                    {
                        "id": 32788,
                        "name": "Benetússer",
                        "latitude": "39.42265000",
                        "longitude": "-0.39686000"
                    },
                    {
                        "id": 32792,
                        "name": "Beniarjó",
                        "latitude": "38.93249000",
                        "longitude": "-0.18634000"
                    },
                    {
                        "id": 32794,
                        "name": "Beniatjar",
                        "latitude": "38.84754000",
                        "longitude": "-0.41736000"
                    },
                    {
                        "id": 32797,
                        "name": "Benicàssim",
                        "latitude": "40.05000000",
                        "longitude": "0.06667000"
                    },
                    {
                        "id": 32796,
                        "name": "Benicolet",
                        "latitude": "38.91987000",
                        "longitude": "-0.34694000"
                    },
                    {
                        "id": 152970,
                        "name": "Benicull de Xúquer",
                        "latitude": "39.18540630",
                        "longitude": "-0.38308930"
                    },
                    {
                        "id": 32802,
                        "name": "Benifaió",
                        "latitude": "39.28439000",
                        "longitude": "-0.42598000"
                    },
                    {
                        "id": 152929,
                        "name": "Benifairó de la Valldigna",
                        "latitude": "39.05479840",
                        "longitude": "-0.30310190"
                    },
                    {
                        "id": 32801,
                        "name": "Benifairó de les Valls",
                        "latitude": "39.73333000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 32805,
                        "name": "Beniflá",
                        "latitude": "38.92813000",
                        "longitude": "-0.17816000"
                    },
                    {
                        "id": 32806,
                        "name": "Benigànim",
                        "latitude": "38.95000000",
                        "longitude": "-0.43333000"
                    },
                    {
                        "id": 32814,
                        "name": "Benimodo",
                        "latitude": "39.21403000",
                        "longitude": "-0.52679000"
                    },
                    {
                        "id": 32815,
                        "name": "Benimuslem",
                        "latitude": "39.13162000",
                        "longitude": "-0.49288000"
                    },
                    {
                        "id": 32816,
                        "name": "Beniparrell",
                        "latitude": "39.38333000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 32817,
                        "name": "Benirredrà",
                        "latitude": "38.96667000",
                        "longitude": "-0.18333000"
                    },
                    {
                        "id": 32818,
                        "name": "Benisanó",
                        "latitude": "39.61667000",
                        "longitude": "-0.56667000"
                    },
                    {
                        "id": 32820,
                        "name": "Benissoda",
                        "latitude": "38.83333000",
                        "longitude": "-0.51667000"
                    },
                    {
                        "id": 32821,
                        "name": "Benisuera",
                        "latitude": "38.91320000",
                        "longitude": "-0.47784000"
                    },
                    {
                        "id": 32822,
                        "name": "Benitachell",
                        "latitude": "38.73273000",
                        "longitude": "0.14354000"
                    },
                    {
                        "id": 33062,
                        "name": "Bétera",
                        "latitude": "39.59111000",
                        "longitude": "-0.46151000"
                    },
                    {
                        "id": 32886,
                        "name": "Bicorp",
                        "latitude": "39.13215000",
                        "longitude": "-0.78720000"
                    },
                    {
                        "id": 32923,
                        "name": "Bocairent",
                        "latitude": "38.76667000",
                        "longitude": "-0.61667000"
                    },
                    {
                        "id": 32937,
                        "name": "Bolbaite",
                        "latitude": "39.06041000",
                        "longitude": "-0.67466000"
                    },
                    {
                        "id": 152930,
                        "name": "Bonrepòs i Mirambell",
                        "latitude": "39.51775270",
                        "longitude": "-0.36465510"
                    },
                    {
                        "id": 33009,
                        "name": "Bufali",
                        "latitude": "38.86775000",
                        "longitude": "-0.51617000"
                    },
                    {
                        "id": 33010,
                        "name": "Bugarra",
                        "latitude": "39.61667000",
                        "longitude": "-0.76667000"
                    },
                    {
                        "id": 33045,
                        "name": "Buñol",
                        "latitude": "39.41667000",
                        "longitude": "-0.78333000"
                    },
                    {
                        "id": 33030,
                        "name": "Burjassot",
                        "latitude": "39.50984000",
                        "longitude": "-0.41327000"
                    },
                    {
                        "id": 33032,
                        "name": "Burriana",
                        "latitude": "39.88901000",
                        "longitude": "-0.08499000"
                    },
                    {
                        "id": 33145,
                        "name": "Calles",
                        "latitude": "39.72118000",
                        "longitude": "-0.97057000"
                    },
                    {
                        "id": 33209,
                        "name": "Camporrobles",
                        "latitude": "39.65000000",
                        "longitude": "-1.40000000"
                    },
                    {
                        "id": 33224,
                        "name": "Canals",
                        "latitude": "38.96251000",
                        "longitude": "-0.58443000"
                    },
                    {
                        "id": 33233,
                        "name": "Canet d'En Berenguer",
                        "latitude": "39.68333000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 152931,
                        "name": "Canet dEn Berenguer",
                        "latitude": "39.68063460",
                        "longitude": "-0.21919030"
                    },
                    {
                        "id": 33291,
                        "name": "Carcaixent",
                        "latitude": "39.12180000",
                        "longitude": "-0.44812000"
                    },
                    {
                        "id": 33891,
                        "name": "Càrcer",
                        "latitude": "39.06667000",
                        "longitude": "-0.56667000"
                    },
                    {
                        "id": 33308,
                        "name": "Carlet",
                        "latitude": "39.22660000",
                        "longitude": "-0.52142000"
                    },
                    {
                        "id": 33335,
                        "name": "Carrícola",
                        "latitude": "38.84133000",
                        "longitude": "-0.47260000"
                    },
                    {
                        "id": 33355,
                        "name": "Casas Altas",
                        "latitude": "40.03333000",
                        "longitude": "-1.26667000"
                    },
                    {
                        "id": 33356,
                        "name": "Casas Bajas",
                        "latitude": "40.01667000",
                        "longitude": "-1.26667000"
                    },
                    {
                        "id": 33391,
                        "name": "Casinos",
                        "latitude": "39.70000000",
                        "longitude": "-0.70000000"
                    },
                    {
                        "id": 33438,
                        "name": "Castelló de la Plana",
                        "latitude": "39.98567000",
                        "longitude": "-0.04935000"
                    },
                    {
                        "id": 33437,
                        "name": "Castelló de Rugat",
                        "latitude": "38.88333000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 33432,
                        "name": "Castellonet de la Conquesta",
                        "latitude": "38.91667000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 33441,
                        "name": "Castielfabib",
                        "latitude": "40.13076000",
                        "longitude": "-1.30396000"
                    },
                    {
                        "id": 33513,
                        "name": "Catadau",
                        "latitude": "39.26667000",
                        "longitude": "-0.56667000"
                    },
                    {
                        "id": 33514,
                        "name": "Catarroja",
                        "latitude": "39.40000000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 33519,
                        "name": "Caudete de las Fuentes",
                        "latitude": "39.55965000",
                        "longitude": "-1.27853000"
                    },
                    {
                        "id": 33582,
                        "name": "Cerdà",
                        "latitude": "38.98333000",
                        "longitude": "-0.56667000"
                    },
                    {
                        "id": 33623,
                        "name": "Chella",
                        "latitude": "39.04203000",
                        "longitude": "-0.65916000"
                    },
                    {
                        "id": 33624,
                        "name": "Chelva",
                        "latitude": "39.74930000",
                        "longitude": "-0.99684000"
                    },
                    {
                        "id": 33626,
                        "name": "Chera",
                        "latitude": "39.60000000",
                        "longitude": "-0.96667000"
                    },
                    {
                        "id": 33629,
                        "name": "Cheste",
                        "latitude": "39.48333000",
                        "longitude": "-0.68333000"
                    },
                    {
                        "id": 33632,
                        "name": "Chilches",
                        "latitude": "39.78238000",
                        "longitude": "-0.18742000"
                    },
                    {
                        "id": 33644,
                        "name": "Chiva",
                        "latitude": "39.46667000",
                        "longitude": "-0.71667000"
                    },
                    {
                        "id": 33650,
                        "name": "Chulilla",
                        "latitude": "39.65000000",
                        "longitude": "-0.88333000"
                    },
                    {
                        "id": 33719,
                        "name": "Cofrentes",
                        "latitude": "39.22926000",
                        "longitude": "-1.06061000"
                    },
                    {
                        "id": 33774,
                        "name": "Corbera",
                        "latitude": "39.15000000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 33811,
                        "name": "Cortes de Pallás",
                        "latitude": "39.25000000",
                        "longitude": "-0.93333000"
                    },
                    {
                        "id": 33824,
                        "name": "Cotes",
                        "latitude": "39.07010000",
                        "longitude": "-0.57449000"
                    },
                    {
                        "id": 33835,
                        "name": "Crevillente",
                        "latitude": "38.24994000",
                        "longitude": "-0.80975000"
                    },
                    {
                        "id": 33875,
                        "name": "Cuevas de Vinromá",
                        "latitude": "40.30976000",
                        "longitude": "0.12084000"
                    },
                    {
                        "id": 33881,
                        "name": "Cullera",
                        "latitude": "39.16667000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 33910,
                        "name": "Daimús",
                        "latitude": "38.96667000",
                        "longitude": "-0.15000000"
                    },
                    {
                        "id": 33937,
                        "name": "Domeño",
                        "latitude": "39.66115000",
                        "longitude": "-0.67077000"
                    },
                    {
                        "id": 33948,
                        "name": "Dos Aguas",
                        "latitude": "39.28333000",
                        "longitude": "-0.80000000"
                    },
                    {
                        "id": 33984,
                        "name": "El Campello",
                        "latitude": "38.42885000",
                        "longitude": "-0.39774000"
                    },
                    {
                        "id": 33999,
                        "name": "El Grao",
                        "latitude": "39.97358000",
                        "longitude": "0.01284000"
                    },
                    {
                        "id": 34006,
                        "name": "El Perelló",
                        "latitude": "39.27718000",
                        "longitude": "-0.27569000"
                    },
                    {
                        "id": 34030,
                        "name": "Elche",
                        "latitude": "38.26218000",
                        "longitude": "-0.70107000"
                    },
                    {
                        "id": 152932,
                        "name": "Eliana l",
                        "latitude": "39.56280990",
                        "longitude": "-0.53050870"
                    },
                    {
                        "id": 38533,
                        "name": "els Poblets",
                        "latitude": "38.85381000",
                        "longitude": "0.02103000"
                    },
                    {
                        "id": 34042,
                        "name": "Emperador",
                        "latitude": "39.55000000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 34058,
                        "name": "Enguera",
                        "latitude": "38.97974000",
                        "longitude": "-0.68683000"
                    },
                    {
                        "id": 152933,
                        "name": "Ènova l",
                        "latitude": "39.04513020",
                        "longitude": "-0.48150540"
                    },
                    {
                        "id": 34145,
                        "name": "Estivella",
                        "latitude": "39.71667000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 34149,
                        "name": "Estubeny",
                        "latitude": "39.01792000",
                        "longitude": "-0.62379000"
                    },
                    {
                        "id": 34168,
                        "name": "Faura",
                        "latitude": "39.71667000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 34169,
                        "name": "Favara",
                        "latitude": "39.11667000",
                        "longitude": "-0.28333000"
                    },
                    {
                        "id": 34198,
                        "name": "Foios",
                        "latitude": "39.53333000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 152935,
                        "name": "Font de la Figuera la",
                        "latitude": "38.80613110",
                        "longitude": "-0.88002710"
                    },
                    {
                        "id": 152934,
                        "name": "Font dEn Carròs la",
                        "latitude": "38.91644190",
                        "longitude": "-0.17115420"
                    },
                    {
                        "id": 34213,
                        "name": "Fontanars dels Alforins",
                        "latitude": "38.78423000",
                        "longitude": "-0.78667000"
                    },
                    {
                        "id": 34222,
                        "name": "Formentera de Segura",
                        "latitude": "38.08509000",
                        "longitude": "-0.74604000"
                    },
                    {
                        "id": 34228,
                        "name": "Fortaleny",
                        "latitude": "39.18333000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 34334,
                        "name": "Fuenterrobles",
                        "latitude": "39.58333000",
                        "longitude": "-1.35000000"
                    },
                    {
                        "id": 34403,
                        "name": "Gandia",
                        "latitude": "38.96667000",
                        "longitude": "-0.18333000"
                    },
                    {
                        "id": 152968,
                        "name": "Gátova",
                        "latitude": "39.75889570",
                        "longitude": "-0.53050870"
                    },
                    {
                        "id": 34439,
                        "name": "Gavarda",
                        "latitude": "39.08333000",
                        "longitude": "-0.55000000"
                    },
                    {
                        "id": 34453,
                        "name": "Genovés",
                        "latitude": "38.98915000",
                        "longitude": "-0.46992000"
                    },
                    {
                        "id": 34458,
                        "name": "Gestalgar",
                        "latitude": "39.60000000",
                        "longitude": "-0.83333000"
                    },
                    {
                        "id": 34464,
                        "name": "Gilet",
                        "latitude": "39.68333000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 34474,
                        "name": "Godella",
                        "latitude": "39.53333000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 34475,
                        "name": "Godelleta",
                        "latitude": "39.41667000",
                        "longitude": "-0.68333000"
                    },
                    {
                        "id": 152936,
                        "name": "Granja de la Costera la",
                        "latitude": "38.99547400",
                        "longitude": "-0.55769620"
                    },
                    {
                        "id": 34505,
                        "name": "Grao de Murviedro",
                        "latitude": "39.64167000",
                        "longitude": "-0.23889000"
                    },
                    {
                        "id": 34529,
                        "name": "Guadasequies",
                        "latitude": "38.92539000",
                        "longitude": "-0.48585000"
                    },
                    {
                        "id": 152937,
                        "name": "Guadasséquies",
                        "latitude": "38.92409630",
                        "longitude": "-0.48843080"
                    },
                    {
                        "id": 34530,
                        "name": "Guadassuar",
                        "latitude": "39.18663000",
                        "longitude": "-0.47859000"
                    },
                    {
                        "id": 152938,
                        "name": "Guardamar de la Safor",
                        "latitude": "38.96182000",
                        "longitude": "-0.14920630"
                    },
                    {
                        "id": 34617,
                        "name": "Higueruelas",
                        "latitude": "39.78333000",
                        "longitude": "-0.85000000"
                    },
                    {
                        "id": 34634,
                        "name": "Hondón de las Nieves",
                        "latitude": "38.30844000",
                        "longitude": "-0.85330000"
                    },
                    {
                        "id": 34791,
                        "name": "Jalance",
                        "latitude": "39.20000000",
                        "longitude": "-1.06667000"
                    },
                    {
                        "id": 34792,
                        "name": "Jalón",
                        "latitude": "38.74063000",
                        "longitude": "-0.01129000"
                    },
                    {
                        "id": 34797,
                        "name": "Jarafuel",
                        "latitude": "39.14013000",
                        "longitude": "-1.07306000"
                    },
                    {
                        "id": 34808,
                        "name": "Javea",
                        "latitude": "38.78333000",
                        "longitude": "0.16667000"
                    },
                    {
                        "id": 34815,
                        "name": "Jijona",
                        "latitude": "38.54086000",
                        "longitude": "-0.50263000"
                    },
                    {
                        "id": 38534,
                        "name": "l'Alcora",
                        "latitude": "40.06667000",
                        "longitude": "-0.20000000"
                    },
                    {
                        "id": 34840,
                        "name": "L'Alcúdia",
                        "latitude": "39.19717000",
                        "longitude": "-0.50537000"
                    },
                    {
                        "id": 34841,
                        "name": "L'Alcúdia de Crespìns",
                        "latitude": "38.96667000",
                        "longitude": "-0.58333000"
                    },
                    {
                        "id": 38535,
                        "name": "l'Alfàs del Pi",
                        "latitude": "38.58055000",
                        "longitude": "-0.10321000"
                    },
                    {
                        "id": 34842,
                        "name": "L'Alqueria de la Comtessa",
                        "latitude": "38.93333000",
                        "longitude": "-0.15000000"
                    },
                    {
                        "id": 34845,
                        "name": "L'Eliana",
                        "latitude": "39.56667000",
                        "longitude": "-0.53333000"
                    },
                    {
                        "id": 34847,
                        "name": "L'Olleria",
                        "latitude": "38.91667000",
                        "longitude": "-0.55000000"
                    },
                    {
                        "id": 34871,
                        "name": "La Font de la Figuera",
                        "latitude": "38.80000000",
                        "longitude": "-0.88333000"
                    },
                    {
                        "id": 38554,
                        "name": "la Nucia",
                        "latitude": "38.61372000",
                        "longitude": "-0.12690000"
                    },
                    {
                        "id": 34906,
                        "name": "La Pobla de Farnals",
                        "latitude": "39.56571000",
                        "longitude": "-0.28425000"
                    },
                    {
                        "id": 34907,
                        "name": "La Pobla de Vallbona",
                        "latitude": "39.59747000",
                        "longitude": "-0.55468000"
                    },
                    {
                        "id": 34904,
                        "name": "La Pobla Llarga",
                        "latitude": "39.08333000",
                        "longitude": "-0.46667000"
                    },
                    {
                        "id": 34923,
                        "name": "La Romana",
                        "latitude": "38.36753000",
                        "longitude": "-0.89862000"
                    },
                    {
                        "id": 34935,
                        "name": "La Yesa",
                        "latitude": "39.88333000",
                        "longitude": "-0.95000000"
                    },
                    {
                        "id": 35067,
                        "name": "Llanera de Ranes",
                        "latitude": "38.99507000",
                        "longitude": "-0.57534000"
                    },
                    {
                        "id": 35071,
                        "name": "Llaurí",
                        "latitude": "39.14671000",
                        "longitude": "-0.32944000"
                    },
                    {
                        "id": 35091,
                        "name": "Llíria",
                        "latitude": "39.62894000",
                        "longitude": "-0.59783000"
                    },
                    {
                        "id": 152941,
                        "name": "Llocnou de la Corona",
                        "latitude": "39.42123820",
                        "longitude": "-0.38190270"
                    },
                    {
                        "id": 35082,
                        "name": "Llocnou de Sant Jeroni",
                        "latitude": "38.91667000",
                        "longitude": "-0.28333000"
                    },
                    {
                        "id": 152940,
                        "name": "Llocnou dEn Fenollet",
                        "latitude": "39.01327190",
                        "longitude": "-0.46701950"
                    },
                    {
                        "id": 35083,
                        "name": "Llombai",
                        "latitude": "39.28333000",
                        "longitude": "-0.56667000"
                    },
                    {
                        "id": 35086,
                        "name": "Llosa de Ranes",
                        "latitude": "39.02163000",
                        "longitude": "-0.53803000"
                    },
                    {
                        "id": 152942,
                        "name": "Llosa de Ranes la",
                        "latitude": "39.01904820",
                        "longitude": "-0.53405380"
                    },
                    {
                        "id": 35090,
                        "name": "Llutxent",
                        "latitude": "38.93333000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 35114,
                        "name": "Loriguilla",
                        "latitude": "39.68333000",
                        "longitude": "-0.91667000"
                    },
                    {
                        "id": 35128,
                        "name": "Los Montesinos",
                        "latitude": "38.02822000",
                        "longitude": "-0.74501000"
                    },
                    {
                        "id": 35138,
                        "name": "Losa del Obispo",
                        "latitude": "39.70000000",
                        "longitude": "-0.86667000"
                    },
                    {
                        "id": 35180,
                        "name": "Macastre",
                        "latitude": "39.38333000",
                        "longitude": "-0.78333000"
                    },
                    {
                        "id": 35251,
                        "name": "Manises",
                        "latitude": "39.49139000",
                        "longitude": "-0.46349000"
                    },
                    {
                        "id": 35261,
                        "name": "Manuel",
                        "latitude": "39.05059000",
                        "longitude": "-0.48978000"
                    },
                    {
                        "id": 35292,
                        "name": "Marines",
                        "latitude": "39.74165000",
                        "longitude": "-0.53103000"
                    },
                    {
                        "id": 35317,
                        "name": "Masalavés",
                        "latitude": "39.14377000",
                        "longitude": "-0.52260000"
                    },
                    {
                        "id": 152943,
                        "name": "Massalavés",
                        "latitude": "39.14248910",
                        "longitude": "-0.52263470"
                    },
                    {
                        "id": 152944,
                        "name": "Massalfassar",
                        "latitude": "39.55583490",
                        "longitude": "-0.31602860"
                    },
                    {
                        "id": 35326,
                        "name": "Massamagrell",
                        "latitude": "39.56667000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 152945,
                        "name": "Massanassa",
                        "latitude": "39.40556950",
                        "longitude": "-0.37718950"
                    },
                    {
                        "id": 35390,
                        "name": "Meliana",
                        "latitude": "39.53333000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 35432,
                        "name": "Millares",
                        "latitude": "39.25000000",
                        "longitude": "-0.76667000"
                    },
                    {
                        "id": 35446,
                        "name": "Miramar",
                        "latitude": "38.95036000",
                        "longitude": "-0.14007000"
                    },
                    {
                        "id": 35456,
                        "name": "Mislata",
                        "latitude": "39.47523000",
                        "longitude": "-0.41825000"
                    },
                    {
                        "id": 35467,
                        "name": "Mogente",
                        "latitude": "38.87598000",
                        "longitude": "-0.75150000"
                    },
                    {
                        "id": 152946,
                        "name": "Mogente\/Moixent",
                        "latitude": "38.87432660",
                        "longitude": "-0.75209270"
                    },
                    {
                        "id": 35499,
                        "name": "Moncada",
                        "latitude": "39.54555000",
                        "longitude": "-0.39551000"
                    },
                    {
                        "id": 35592,
                        "name": "Monóvar",
                        "latitude": "38.43809000",
                        "longitude": "-0.84062000"
                    },
                    {
                        "id": 35527,
                        "name": "Monserrat",
                        "latitude": "39.36667000",
                        "longitude": "-0.60000000"
                    },
                    {
                        "id": 35529,
                        "name": "Montaberner",
                        "latitude": "38.89021000",
                        "longitude": "-0.49582000"
                    },
                    {
                        "id": 152948,
                        "name": "Montaverner",
                        "latitude": "38.88810410",
                        "longitude": "-0.49448430"
                    },
                    {
                        "id": 35570,
                        "name": "Montesa",
                        "latitude": "38.95030000",
                        "longitude": "-0.65200000"
                    },
                    {
                        "id": 35574,
                        "name": "Montichelvo",
                        "latitude": "38.89129000",
                        "longitude": "-0.34123000"
                    },
                    {
                        "id": 152949,
                        "name": "Montitxelvo\/Montichelvo",
                        "latitude": "38.89844250",
                        "longitude": "-0.34189270"
                    },
                    {
                        "id": 35584,
                        "name": "Montroy",
                        "latitude": "39.33333000",
                        "longitude": "-0.61667000"
                    },
                    {
                        "id": 152947,
                        "name": "Montserrat",
                        "latitude": "39.35823960",
                        "longitude": "-0.60125150"
                    },
                    {
                        "id": 35596,
                        "name": "Moraira",
                        "latitude": "38.68866000",
                        "longitude": "0.13484000"
                    },
                    {
                        "id": 35683,
                        "name": "Muro del Alcoy",
                        "latitude": "38.78120000",
                        "longitude": "-0.43608000"
                    },
                    {
                        "id": 35688,
                        "name": "Museros",
                        "latitude": "39.56667000",
                        "longitude": "-0.35000000"
                    },
                    {
                        "id": 35843,
                        "name": "Náquera",
                        "latitude": "39.65000000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 35775,
                        "name": "Navarrés",
                        "latitude": "39.10198000",
                        "longitude": "-0.69469000"
                    },
                    {
                        "id": 152950,
                        "name": "Novelé\/Novetlè",
                        "latitude": "38.98019580",
                        "longitude": "-0.54853310"
                    },
                    {
                        "id": 35884,
                        "name": "Oliva",
                        "latitude": "38.91971000",
                        "longitude": "-0.11935000"
                    },
                    {
                        "id": 152951,
                        "name": "Olleria l",
                        "latitude": "38.91462110",
                        "longitude": "-0.55060200"
                    },
                    {
                        "id": 35908,
                        "name": "Olocau",
                        "latitude": "39.70000000",
                        "longitude": "-0.53333000"
                    },
                    {
                        "id": 35926,
                        "name": "Ontinyent",
                        "latitude": "38.82191000",
                        "longitude": "-0.60603000"
                    },
                    {
                        "id": 35938,
                        "name": "Orcheta",
                        "latitude": "38.56397000",
                        "longitude": "-0.26299000"
                    },
                    {
                        "id": 35958,
                        "name": "Oropesa del Mar",
                        "latitude": "40.09134000",
                        "longitude": "0.14115000"
                    },
                    {
                        "id": 35980,
                        "name": "Otos",
                        "latitude": "38.85427000",
                        "longitude": "-0.44399000"
                    },
                    {
                        "id": 35998,
                        "name": "Paiporta",
                        "latitude": "39.42814000",
                        "longitude": "-0.41765000"
                    },
                    {
                        "id": 36028,
                        "name": "Palma de Gandía",
                        "latitude": "38.92672000",
                        "longitude": "-0.22028000"
                    },
                    {
                        "id": 36032,
                        "name": "Palmera",
                        "latitude": "38.93927000",
                        "longitude": "-0.15411000"
                    },
                    {
                        "id": 152952,
                        "name": "Palomar el",
                        "latitude": "38.85873000",
                        "longitude": "-0.49035240"
                    },
                    {
                        "id": 36077,
                        "name": "Paterna",
                        "latitude": "39.50263000",
                        "longitude": "-0.44079000"
                    },
                    {
                        "id": 36090,
                        "name": "Pedralba",
                        "latitude": "39.60000000",
                        "longitude": "-0.71667000"
                    },
                    {
                        "id": 36128,
                        "name": "Peníscola",
                        "latitude": "40.35740000",
                        "longitude": "0.40692000"
                    },
                    {
                        "id": 36158,
                        "name": "Petrés",
                        "latitude": "39.68333000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 36177,
                        "name": "Picanya",
                        "latitude": "39.43333000",
                        "longitude": "-0.43333000"
                    },
                    {
                        "id": 36178,
                        "name": "Picassent",
                        "latitude": "39.36350000",
                        "longitude": "-0.45949000"
                    },
                    {
                        "id": 36189,
                        "name": "Piles",
                        "latitude": "38.94143000",
                        "longitude": "-0.13286000"
                    },
                    {
                        "id": 36200,
                        "name": "Pinet",
                        "latitude": "38.98176000",
                        "longitude": "-0.33870000"
                    },
                    {
                        "id": 36213,
                        "name": "Pinoso",
                        "latitude": "38.40164000",
                        "longitude": "-1.04196000"
                    },
                    {
                        "id": 152953,
                        "name": "Pobla de Farnals la",
                        "latitude": "39.57649480",
                        "longitude": "-0.32072990"
                    },
                    {
                        "id": 152955,
                        "name": "Pobla de Vallbona la",
                        "latitude": "39.59629650",
                        "longitude": "-0.55178430"
                    },
                    {
                        "id": 152954,
                        "name": "Pobla del Duc la",
                        "latitude": "38.90471460",
                        "longitude": "-0.42076600"
                    },
                    {
                        "id": 152956,
                        "name": "Pobla Llarga la",
                        "latitude": "39.08508400",
                        "longitude": "-0.47559930"
                    },
                    {
                        "id": 36261,
                        "name": "Polinyà de Xúquer",
                        "latitude": "39.20000000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 36305,
                        "name": "Potríes",
                        "latitude": "38.91617000",
                        "longitude": "-0.19594000"
                    },
                    {
                        "id": 36362,
                        "name": "Provincia de Alicante",
                        "latitude": "38.50000000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 36396,
                        "name": "Província de Castelló",
                        "latitude": "40.16667000",
                        "longitude": "-0.16667000"
                    },
                    {
                        "id": 36400,
                        "name": "Província de València",
                        "latitude": "39.33333000",
                        "longitude": "-0.83333000"
                    },
                    {
                        "id": 36478,
                        "name": "Puçol",
                        "latitude": "39.61667000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 36422,
                        "name": "Puebla de San Miguel",
                        "latitude": "40.05000000",
                        "longitude": "-1.13333000"
                    },
                    {
                        "id": 36461,
                        "name": "Puig",
                        "latitude": "39.58869000",
                        "longitude": "-0.30333000"
                    },
                    {
                        "id": 36488,
                        "name": "Quart de les Valls",
                        "latitude": "39.73333000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 36487,
                        "name": "Quart de Poblet",
                        "latitude": "39.48139000",
                        "longitude": "-0.43937000"
                    },
                    {
                        "id": 36490,
                        "name": "Quartell",
                        "latitude": "39.73751000",
                        "longitude": "-0.26458000"
                    },
                    {
                        "id": 36491,
                        "name": "Quatretonda",
                        "latitude": "38.95000000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 36497,
                        "name": "Quesa",
                        "latitude": "39.11970000",
                        "longitude": "-0.74000000"
                    },
                    {
                        "id": 152957,
                        "name": "Rafelbuñol\/Rafelbunyol",
                        "latitude": "39.58884560",
                        "longitude": "-0.33064360"
                    },
                    {
                        "id": 36540,
                        "name": "Rafelcofer",
                        "latitude": "38.93248000",
                        "longitude": "-0.16772000"
                    },
                    {
                        "id": 36541,
                        "name": "Rafelguaraf",
                        "latitude": "39.05126000",
                        "longitude": "-0.45543000"
                    },
                    {
                        "id": 36712,
                        "name": "Ráfol de Salem",
                        "latitude": "38.86651000",
                        "longitude": "-0.39991000"
                    },
                    {
                        "id": 152958,
                        "name": "Real",
                        "latitude": "39.31376340",
                        "longitude": "-0.62515410"
                    },
                    {
                        "id": 36551,
                        "name": "Real de Gandía",
                        "latitude": "38.94817000",
                        "longitude": "-0.19239000"
                    },
                    {
                        "id": 36552,
                        "name": "Real de Montroi",
                        "latitude": "39.33333000",
                        "longitude": "-0.60000000"
                    },
                    {
                        "id": 36581,
                        "name": "Requena",
                        "latitude": "39.48834000",
                        "longitude": "-1.10044000"
                    },
                    {
                        "id": 152959,
                        "name": "Riba-roja de Túria",
                        "latitude": "39.54442650",
                        "longitude": "-0.57066770"
                    },
                    {
                        "id": 36611,
                        "name": "Ribarroja del Turia",
                        "latitude": "39.54595000",
                        "longitude": "-0.57069000"
                    },
                    {
                        "id": 36631,
                        "name": "Riola",
                        "latitude": "39.20000000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 36660,
                        "name": "Rocafort",
                        "latitude": "39.53333000",
                        "longitude": "-0.40000000"
                    },
                    {
                        "id": 36678,
                        "name": "Rosell",
                        "latitude": "40.61792000",
                        "longitude": "0.22133000"
                    },
                    {
                        "id": 152960,
                        "name": "Rotglà i Corberà",
                        "latitude": "39.00468400",
                        "longitude": "-0.56531040"
                    },
                    {
                        "id": 36681,
                        "name": "Rotglá y Corbera",
                        "latitude": "39.00465000",
                        "longitude": "-0.56482000"
                    },
                    {
                        "id": 36720,
                        "name": "Rótova",
                        "latitude": "38.93205000",
                        "longitude": "-0.25765000"
                    },
                    {
                        "id": 36702,
                        "name": "Rugat",
                        "latitude": "38.87933000",
                        "longitude": "-0.36115000"
                    },
                    {
                        "id": 36739,
                        "name": "Sagunto",
                        "latitude": "39.68333000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 152961,
                        "name": "Sagunto\/Sagunt",
                        "latitude": "39.68011210",
                        "longitude": "-0.27840010"
                    },
                    {
                        "id": 152962,
                        "name": "Salem",
                        "latitude": "38.84607380",
                        "longitude": "-0.37954380"
                    },
                    {
                        "id": 152969,
                        "name": "San Antonio de Benagéber",
                        "latitude": "39.56297560",
                        "longitude": "-0.49271340"
                    },
                    {
                        "id": 36843,
                        "name": "San Juan de Alicante",
                        "latitude": "38.40148000",
                        "longitude": "-0.43623000"
                    },
                    {
                        "id": 36849,
                        "name": "San Juan de Énova",
                        "latitude": "39.07104000",
                        "longitude": "-0.48705000"
                    },
                    {
                        "id": 36845,
                        "name": "San Juan de Moró",
                        "latitude": "40.05990000",
                        "longitude": "-0.13691000"
                    },
                    {
                        "id": 36925,
                        "name": "San Vicent del Raspeig",
                        "latitude": "38.39640000",
                        "longitude": "-0.52550000"
                    },
                    {
                        "id": 152963,
                        "name": "Sant Joanet",
                        "latitude": "39.07141770",
                        "longitude": "-0.48699630"
                    },
                    {
                        "id": 36978,
                        "name": "Sant Jordi",
                        "latitude": "40.50982000",
                        "longitude": "0.33208000"
                    },
                    {
                        "id": 37187,
                        "name": "Sedaví",
                        "latitude": "39.43333000",
                        "longitude": "-0.38333000"
                    },
                    {
                        "id": 37190,
                        "name": "Segart",
                        "latitude": "39.68333000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 37204,
                        "name": "Sellent",
                        "latitude": "39.03221000",
                        "longitude": "-0.58784000"
                    },
                    {
                        "id": 37207,
                        "name": "Sempere",
                        "latitude": "38.92014000",
                        "longitude": "-0.48140000"
                    },
                    {
                        "id": 37213,
                        "name": "Senyera",
                        "latitude": "39.06667000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 37218,
                        "name": "Serra",
                        "latitude": "39.68333000",
                        "longitude": "-0.43333000"
                    },
                    {
                        "id": 37247,
                        "name": "Sierra-Engarcerán",
                        "latitude": "40.26929000",
                        "longitude": "-0.01892000"
                    },
                    {
                        "id": 37249,
                        "name": "Siete Aguas",
                        "latitude": "39.46667000",
                        "longitude": "-0.91667000"
                    },
                    {
                        "id": 37255,
                        "name": "Silla",
                        "latitude": "39.36257000",
                        "longitude": "-0.41169000"
                    },
                    {
                        "id": 37259,
                        "name": "Simat de la Valldigna",
                        "latitude": "39.03333000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 37260,
                        "name": "Sinarcas",
                        "latitude": "39.73333000",
                        "longitude": "-1.23333000"
                    },
                    {
                        "id": 37283,
                        "name": "Sollana",
                        "latitude": "39.27830000",
                        "longitude": "-0.38238000"
                    },
                    {
                        "id": 37309,
                        "name": "Sot de Chera",
                        "latitude": "39.63333000",
                        "longitude": "-0.90000000"
                    },
                    {
                        "id": 37329,
                        "name": "Sueca",
                        "latitude": "39.20260000",
                        "longitude": "-0.31114000"
                    },
                    {
                        "id": 37332,
                        "name": "Sumacàrcer",
                        "latitude": "39.10000000",
                        "longitude": "-0.63333000"
                    },
                    {
                        "id": 37386,
                        "name": "Tavernes Blanques",
                        "latitude": "39.50000000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 37387,
                        "name": "Tavernes de la Valldigna",
                        "latitude": "39.07195000",
                        "longitude": "-0.26623000"
                    },
                    {
                        "id": 152964,
                        "name": "Teresa de Cofrentes",
                        "latitude": "39.10476460",
                        "longitude": "-1.05083270"
                    },
                    {
                        "id": 37410,
                        "name": "Terrateig",
                        "latitude": "38.89453000",
                        "longitude": "-0.31993000"
                    },
                    {
                        "id": 37430,
                        "name": "Titaguas",
                        "latitude": "39.86667000",
                        "longitude": "-1.08333000"
                    },
                    {
                        "id": 37497,
                        "name": "Torre de la Horadada",
                        "latitude": "37.86970000",
                        "longitude": "-0.75840000"
                    },
                    {
                        "id": 152965,
                        "name": "Torrebaja",
                        "latitude": "40.09808660",
                        "longitude": "-1.25882430"
                    },
                    {
                        "id": 37547,
                        "name": "Torrella",
                        "latitude": "38.98446000",
                        "longitude": "-0.56727000"
                    },
                    {
                        "id": 37564,
                        "name": "Torrent",
                        "latitude": "39.43705000",
                        "longitude": "-0.46546000"
                    },
                    {
                        "id": 152966,
                        "name": "Torres Torres",
                        "latitude": "39.74345210",
                        "longitude": "-0.35777240"
                    },
                    {
                        "id": 37609,
                        "name": "Tous",
                        "latitude": "39.13951000",
                        "longitude": "-0.58777000"
                    },
                    {
                        "id": 37660,
                        "name": "Tuéjar",
                        "latitude": "39.76667000",
                        "longitude": "-1.03333000"
                    },
                    {
                        "id": 37659,
                        "name": "Turís",
                        "latitude": "39.38333000",
                        "longitude": "-0.70000000"
                    },
                    {
                        "id": 37710,
                        "name": "Utiel",
                        "latitude": "39.56667000",
                        "longitude": "-1.20000000"
                    },
                    {
                        "id": 37816,
                        "name": "Valencia",
                        "latitude": "39.46975000",
                        "longitude": "-0.37739000"
                    },
                    {
                        "id": 37834,
                        "name": "Vall de Ebo",
                        "latitude": "38.80561000",
                        "longitude": "-0.15890000"
                    },
                    {
                        "id": 37835,
                        "name": "Vallada",
                        "latitude": "38.89575000",
                        "longitude": "-0.69104000"
                    },
                    {
                        "id": 37837,
                        "name": "Vallanca",
                        "latitude": "40.06667000",
                        "longitude": "-1.33333000"
                    },
                    {
                        "id": 37866,
                        "name": "Vallés",
                        "latitude": "38.98518000",
                        "longitude": "-0.55696000"
                    },
                    {
                        "id": 37938,
                        "name": "Venta del Moro",
                        "latitude": "39.48333000",
                        "longitude": "-1.35000000"
                    },
                    {
                        "id": 37952,
                        "name": "Vergel",
                        "latitude": "38.84709000",
                        "longitude": "0.01034000"
                    },
                    {
                        "id": 37991,
                        "name": "Vilamarxant",
                        "latitude": "39.56916000",
                        "longitude": "-0.62453000"
                    },
                    {
                        "id": 38049,
                        "name": "Villafamés",
                        "latitude": "40.11667000",
                        "longitude": "-0.05000000"
                    },
                    {
                        "id": 38064,
                        "name": "Villafranca del Cid",
                        "latitude": "40.42885000",
                        "longitude": "-0.25775000"
                    },
                    {
                        "id": 38088,
                        "name": "Villajoyosa",
                        "latitude": "38.50754000",
                        "longitude": "-0.23346000"
                    },
                    {
                        "id": 38118,
                        "name": "Villalonga",
                        "latitude": "38.88566000",
                        "longitude": "-0.20795000"
                    },
                    {
                        "id": 38179,
                        "name": "Villanueva de Castellón",
                        "latitude": "39.07741000",
                        "longitude": "-0.51167000"
                    },
                    {
                        "id": 38251,
                        "name": "Villar del Arzobispo",
                        "latitude": "39.73333000",
                        "longitude": "-0.81667000"
                    },
                    {
                        "id": 38283,
                        "name": "Villargordo del Cabriel",
                        "latitude": "39.53333000",
                        "longitude": "-1.43333000"
                    },
                    {
                        "id": 38358,
                        "name": "Villavieja",
                        "latitude": "39.85000000",
                        "longitude": "-0.18333000"
                    },
                    {
                        "id": 38390,
                        "name": "Vinalesa",
                        "latitude": "39.53333000",
                        "longitude": "-0.36667000"
                    },
                    {
                        "id": 38424,
                        "name": "Xàtiva",
                        "latitude": "38.99042000",
                        "longitude": "-0.51852000"
                    },
                    {
                        "id": 152939,
                        "name": "Xeraco",
                        "latitude": "39.03309800",
                        "longitude": "-0.21625960"
                    },
                    {
                        "id": 38420,
                        "name": "XeracoJaraco",
                        "latitude": "39.03333000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 38421,
                        "name": "Xeresa",
                        "latitude": "39.01667000",
                        "longitude": "-0.21667000"
                    },
                    {
                        "id": 38423,
                        "name": "Xirivella",
                        "latitude": "39.46588000",
                        "longitude": "-0.42589000"
                    },
                    {
                        "id": 38443,
                        "name": "Yátova",
                        "latitude": "39.38333000",
                        "longitude": "-0.80000000"
                    },
                    {
                        "id": 152967,
                        "name": "Yesa La",
                        "latitude": "39.89186730",
                        "longitude": "-0.96116080"
                    },
                    {
                        "id": 38475,
                        "name": "Zarra",
                        "latitude": "39.09175000",
                        "longitude": "-1.07532000"
                    }
                ]
            },
            {
                "id": 5340,
                "name": "Valencian Community",
                "iso2": "VC",
                "latitude": "39.31088690",
                "longitude": "-1.73841720",
                "type": "autonomous community",
                "cities": []
            },
            {
                "id": 1183,
                "name": "Valladolid",
                "iso2": "VA",
                "latitude": "41.65173750",
                "longitude": "-4.72449500",
                "type": "province",
                "cities": [
                    {
                        "id": 31928,
                        "name": "Adalia",
                        "latitude": "41.64894000",
                        "longitude": "-5.12107000"
                    },
                    {
                        "id": 31953,
                        "name": "Aguasal",
                        "latitude": "41.27495000",
                        "longitude": "-4.65290000"
                    },
                    {
                        "id": 31961,
                        "name": "Aguilar de Campos",
                        "latitude": "41.98375000",
                        "longitude": "-5.18117000"
                    },
                    {
                        "id": 31990,
                        "name": "Alaejos",
                        "latitude": "41.30732000",
                        "longitude": "-5.21567000"
                    },
                    {
                        "id": 32092,
                        "name": "Alcazarén",
                        "latitude": "41.37061000",
                        "longitude": "-4.67262000"
                    },
                    {
                        "id": 32142,
                        "name": "Aldea de San Miguel",
                        "latitude": "41.46098000",
                        "longitude": "-4.61580000"
                    },
                    {
                        "id": 32156,
                        "name": "Aldeamayor de San Martín",
                        "latitude": "41.51256000",
                        "longitude": "-4.63955000"
                    },
                    {
                        "id": 32283,
                        "name": "Almenara de Adaja",
                        "latitude": "41.21406000",
                        "longitude": "-4.67824000"
                    },
                    {
                        "id": 32363,
                        "name": "Amusquillo",
                        "latitude": "41.74853000",
                        "longitude": "-4.30117000"
                    },
                    {
                        "id": 32509,
                        "name": "Arroyo de la Encomienda",
                        "latitude": "41.60956000",
                        "longitude": "-4.79692000"
                    },
                    {
                        "id": 32549,
                        "name": "Ataquines",
                        "latitude": "41.18247000",
                        "longitude": "-4.80319000"
                    },
                    {
                        "id": 32611,
                        "name": "Bahabón",
                        "latitude": "41.48141000",
                        "longitude": "-4.27941000"
                    },
                    {
                        "id": 32656,
                        "name": "Barcial de la Loma",
                        "latitude": "41.95139000",
                        "longitude": "-5.28353000"
                    },
                    {
                        "id": 152677,
                        "name": "Barruelo del Valle",
                        "latitude": "41.67458500",
                        "longitude": "-5.06962870"
                    },
                    {
                        "id": 32726,
                        "name": "Becilla de Valderaduey",
                        "latitude": "42.09905000",
                        "longitude": "-5.21805000"
                    },
                    {
                        "id": 32758,
                        "name": "Benafarces",
                        "latitude": "41.62133000",
                        "longitude": "-5.29285000"
                    },
                    {
                        "id": 32838,
                        "name": "Bercero",
                        "latitude": "41.56397000",
                        "longitude": "-5.05580000"
                    },
                    {
                        "id": 32839,
                        "name": "Berceruelo",
                        "latitude": "41.58033000",
                        "longitude": "-5.03267000"
                    },
                    {
                        "id": 32873,
                        "name": "Berrueces",
                        "latitude": "41.94606000",
                        "longitude": "-5.09693000"
                    },
                    {
                        "id": 32920,
                        "name": "Bobadilla del Campo",
                        "latitude": "41.20432000",
                        "longitude": "-5.02294000"
                    },
                    {
                        "id": 32925,
                        "name": "Bocigas",
                        "latitude": "41.23070000",
                        "longitude": "-4.68128000"
                    },
                    {
                        "id": 32926,
                        "name": "Bocos de Duero",
                        "latitude": "41.62339000",
                        "longitude": "-4.07048000"
                    },
                    {
                        "id": 32928,
                        "name": "Boecillo",
                        "latitude": "41.54090000",
                        "longitude": "-4.69940000"
                    },
                    {
                        "id": 32936,
                        "name": "Bolaños de Campos",
                        "latitude": "42.00680000",
                        "longitude": "-5.28428000"
                    },
                    {
                        "id": 152678,
                        "name": "Brahojos de Medina",
                        "latitude": "41.22962990",
                        "longitude": "-5.04295580"
                    },
                    {
                        "id": 33039,
                        "name": "Bustillo de Chaves",
                        "latitude": "42.13114000",
                        "longitude": "-5.09169000"
                    },
                    {
                        "id": 152679,
                        "name": "Cabezón de Pisuerga",
                        "latitude": "41.73192920",
                        "longitude": "-4.64592590"
                    },
                    {
                        "id": 33093,
                        "name": "Cabezón de Valderaduey",
                        "latitude": "42.16793000",
                        "longitude": "-5.15892000"
                    },
                    {
                        "id": 33107,
                        "name": "Cabreros del Monte",
                        "latitude": "41.84906000",
                        "longitude": "-5.27016000"
                    },
                    {
                        "id": 33183,
                        "name": "Campaspero",
                        "latitude": "41.49208000",
                        "longitude": "-4.19608000"
                    },
                    {
                        "id": 152680,
                        "name": "Campillo El",
                        "latitude": "41.25778110",
                        "longitude": "-5.01499550"
                    },
                    {
                        "id": 33207,
                        "name": "Camporredondo",
                        "latitude": "41.47333000",
                        "longitude": "-4.50503000"
                    },
                    {
                        "id": 33220,
                        "name": "Canalejas de Peñafiel",
                        "latitude": "41.52513000",
                        "longitude": "-4.11546000"
                    },
                    {
                        "id": 33243,
                        "name": "Canillas de Esgueva",
                        "latitude": "41.75464000",
                        "longitude": "-4.12502000"
                    },
                    {
                        "id": 33313,
                        "name": "Carpio",
                        "latitude": "41.21329000",
                        "longitude": "-5.10907000"
                    },
                    {
                        "id": 33380,
                        "name": "Casasola de Arión",
                        "latitude": "41.57825000",
                        "longitude": "-5.24076000"
                    },
                    {
                        "id": 152681,
                        "name": "Castrejón de Trabancos",
                        "latitude": "41.25403810",
                        "longitude": "-5.17057890"
                    },
                    {
                        "id": 33477,
                        "name": "Castrillo de Duero",
                        "latitude": "41.57494000",
                        "longitude": "-4.01547000"
                    },
                    {
                        "id": 33485,
                        "name": "Castrillo-Tejeriego",
                        "latitude": "41.70340000",
                        "longitude": "-4.37142000"
                    },
                    {
                        "id": 33493,
                        "name": "Castrobol",
                        "latitude": "42.13717000",
                        "longitude": "-5.31423000"
                    },
                    {
                        "id": 33496,
                        "name": "Castrodeza",
                        "latitude": "41.64921000",
                        "longitude": "-4.95888000"
                    },
                    {
                        "id": 33499,
                        "name": "Castromembibre",
                        "latitude": "41.67246000",
                        "longitude": "-5.30473000"
                    },
                    {
                        "id": 33501,
                        "name": "Castromonte",
                        "latitude": "41.77355000",
                        "longitude": "-5.03909000"
                    },
                    {
                        "id": 33503,
                        "name": "Castronuevo de Esgueva",
                        "latitude": "41.68180000",
                        "longitude": "-4.58866000"
                    },
                    {
                        "id": 33504,
                        "name": "Castronuño",
                        "latitude": "41.38918000",
                        "longitude": "-5.26408000"
                    },
                    {
                        "id": 33506,
                        "name": "Castroponce",
                        "latitude": "42.12646000",
                        "longitude": "-5.18245000"
                    },
                    {
                        "id": 33511,
                        "name": "Castroverde de Cerrato",
                        "latitude": "41.75609000",
                        "longitude": "-4.22151000"
                    },
                    {
                        "id": 33561,
                        "name": "Ceinos de Campos",
                        "latitude": "42.03284000",
                        "longitude": "-5.15007000"
                    },
                    {
                        "id": 33604,
                        "name": "Cervillego de la Cruz",
                        "latitude": "41.18783000",
                        "longitude": "-4.94966000"
                    },
                    {
                        "id": 33661,
                        "name": "Cigales",
                        "latitude": "41.75780000",
                        "longitude": "-4.69848000"
                    },
                    {
                        "id": 33663,
                        "name": "Ciguñuela",
                        "latitude": "41.64064000",
                        "longitude": "-4.85688000"
                    },
                    {
                        "id": 33694,
                        "name": "Cistérniga",
                        "latitude": "41.61294000",
                        "longitude": "-4.68697000"
                    },
                    {
                        "id": 152682,
                        "name": "Cogeces de Íscar",
                        "latitude": "41.40611650",
                        "longitude": "-4.54503680"
                    },
                    {
                        "id": 33720,
                        "name": "Cogeces del Monte",
                        "latitude": "41.51030000",
                        "longitude": "-4.31721000"
                    },
                    {
                        "id": 33778,
                        "name": "Corcos",
                        "latitude": "41.80946000",
                        "longitude": "-4.69270000"
                    },
                    {
                        "id": 33804,
                        "name": "Corrales de Duero",
                        "latitude": "41.67205000",
                        "longitude": "-4.04817000"
                    },
                    {
                        "id": 33852,
                        "name": "Cubillas de Santa Marta",
                        "latitude": "41.83358000",
                        "longitude": "-4.61463000"
                    },
                    {
                        "id": 33865,
                        "name": "Cuenca de Campos",
                        "latitude": "42.05927000",
                        "longitude": "-5.05539000"
                    },
                    {
                        "id": 33886,
                        "name": "Curiel de Duero",
                        "latitude": "41.64327000",
                        "longitude": "-4.10110000"
                    },
                    {
                        "id": 34050,
                        "name": "Encinas de Esgueva",
                        "latitude": "41.75653000",
                        "longitude": "-4.10357000"
                    },
                    {
                        "id": 34096,
                        "name": "Esguevillas de Esgueva",
                        "latitude": "41.75018000",
                        "longitude": "-4.38062000"
                    },
                    {
                        "id": 34201,
                        "name": "Fombellida",
                        "latitude": "41.76693000",
                        "longitude": "-4.18409000"
                    },
                    {
                        "id": 34203,
                        "name": "Fompedraza",
                        "latitude": "41.53541000",
                        "longitude": "-4.14483000"
                    },
                    {
                        "id": 34215,
                        "name": "Fontihoyuelo",
                        "latitude": "42.16192000",
                        "longitude": "-5.05791000"
                    },
                    {
                        "id": 34254,
                        "name": "Fresno El Viejo",
                        "latitude": "41.19752000",
                        "longitude": "-5.14413000"
                    },
                    {
                        "id": 34287,
                        "name": "Fuensaldaña",
                        "latitude": "41.70617000",
                        "longitude": "-4.76547000"
                    },
                    {
                        "id": 34303,
                        "name": "Fuente el Sol",
                        "latitude": "41.17603000",
                        "longitude": "-4.93430000"
                    },
                    {
                        "id": 152683,
                        "name": "Fuente-Olmedo",
                        "latitude": "41.24406200",
                        "longitude": "-4.64729510"
                    },
                    {
                        "id": 34388,
                        "name": "Gallegos de Hornija",
                        "latitude": "41.60980000",
                        "longitude": "-5.09768000"
                    },
                    {
                        "id": 34437,
                        "name": "Gatón de Campos",
                        "latitude": "42.04984000",
                        "longitude": "-4.98078000"
                    },
                    {
                        "id": 34455,
                        "name": "Geria",
                        "latitude": "41.57868000",
                        "longitude": "-4.87663000"
                    },
                    {
                        "id": 34603,
                        "name": "Herrín de Campos",
                        "latitude": "42.12476000",
                        "longitude": "-4.95239000"
                    },
                    {
                        "id": 152684,
                        "name": "Hornillos de Eresma",
                        "latitude": "41.36661380",
                        "longitude": "-4.71934610"
                    },
                    {
                        "id": 34765,
                        "name": "Iscar",
                        "latitude": "41.36117000",
                        "longitude": "-4.53348000"
                    },
                    {
                        "id": 34948,
                        "name": "Laguna de Duero",
                        "latitude": "41.58151000",
                        "longitude": "-4.72332000"
                    },
                    {
                        "id": 34965,
                        "name": "Langayo",
                        "latitude": "41.56986000",
                        "longitude": "-4.19866000"
                    },
                    {
                        "id": 35069,
                        "name": "Llano de Olmedo",
                        "latitude": "41.26727000",
                        "longitude": "-4.61386000"
                    },
                    {
                        "id": 152685,
                        "name": "Lomoviejo",
                        "latitude": "41.14915290",
                        "longitude": "-4.91756860"
                    },
                    {
                        "id": 35272,
                        "name": "Manzanillo",
                        "latitude": "41.58617000",
                        "longitude": "-4.18826000"
                    },
                    {
                        "id": 35311,
                        "name": "Marzales",
                        "latitude": "41.58644000",
                        "longitude": "-5.13455000"
                    },
                    {
                        "id": 35338,
                        "name": "Matapozuelos",
                        "latitude": "41.41423000",
                        "longitude": "-4.79122000"
                    },
                    {
                        "id": 35343,
                        "name": "Matilla de los Caños",
                        "latitude": "41.54818000",
                        "longitude": "-4.96761000"
                    },
                    {
                        "id": 35349,
                        "name": "Mayorga",
                        "latitude": "42.16687000",
                        "longitude": "-5.26304000"
                    },
                    {
                        "id": 35371,
                        "name": "Medina de Ríoseco",
                        "latitude": "41.88327000",
                        "longitude": "-5.04405000"
                    },
                    {
                        "id": 35373,
                        "name": "Medina del Campo",
                        "latitude": "41.31239000",
                        "longitude": "-4.91413000"
                    },
                    {
                        "id": 35379,
                        "name": "Megeces",
                        "latitude": "41.40828000",
                        "longitude": "-4.56166000"
                    },
                    {
                        "id": 35385,
                        "name": "Melgar de Abajo",
                        "latitude": "42.24344000",
                        "longitude": "-5.14216000"
                    },
                    {
                        "id": 35386,
                        "name": "Melgar de Arriba",
                        "latitude": "42.26806000",
                        "longitude": "-5.09712000"
                    },
                    {
                        "id": 35474,
                        "name": "Mojados",
                        "latitude": "41.43237000",
                        "longitude": "-4.66490000"
                    },
                    {
                        "id": 35497,
                        "name": "Monasterio de Vega",
                        "latitude": "42.23015000",
                        "longitude": "-5.18095000"
                    },
                    {
                        "id": 152686,
                        "name": "Montealegre de Campos",
                        "latitude": "41.90156540",
                        "longitude": "-4.89810360"
                    },
                    {
                        "id": 35559,
                        "name": "Montemayor de Pililla",
                        "latitude": "41.50874000",
                        "longitude": "-4.45745000"
                    },
                    {
                        "id": 35599,
                        "name": "Moral de la Reina",
                        "latitude": "41.98611000",
                        "longitude": "-5.07208000"
                    },
                    {
                        "id": 35605,
                        "name": "Moraleja de las Panaderas",
                        "latitude": "41.27636000",
                        "longitude": "-4.82521000"
                    },
                    {
                        "id": 35607,
                        "name": "Morales de Campos",
                        "latitude": "41.86068000",
                        "longitude": "-5.17252000"
                    },
                    {
                        "id": 35642,
                        "name": "Mota del Marqués",
                        "latitude": "41.63247000",
                        "longitude": "-5.17681000"
                    },
                    {
                        "id": 35652,
                        "name": "Mucientes",
                        "latitude": "41.74278000",
                        "longitude": "-4.76191000"
                    },
                    {
                        "id": 152687,
                        "name": "Mudarra La",
                        "latitude": "41.78000500",
                        "longitude": "-4.94418170"
                    },
                    {
                        "id": 152688,
                        "name": "Muriel",
                        "latitude": "41.12235570",
                        "longitude": "-4.84289470"
                    },
                    {
                        "id": 35728,
                        "name": "Nava del Rey",
                        "latitude": "41.33036000",
                        "longitude": "-5.08095000"
                    },
                    {
                        "id": 35833,
                        "name": "Nueva Villa de las Torres",
                        "latitude": "41.26762000",
                        "longitude": "-5.05685000"
                    },
                    {
                        "id": 35889,
                        "name": "Olivares de Duero",
                        "latitude": "41.63755000",
                        "longitude": "-4.36547000"
                    },
                    {
                        "id": 35901,
                        "name": "Olmedo",
                        "latitude": "41.28706000",
                        "longitude": "-4.68878000"
                    },
                    {
                        "id": 35905,
                        "name": "Olmos de Esgueva",
                        "latitude": "41.68815000",
                        "longitude": "-4.52255000"
                    },
                    {
                        "id": 35907,
                        "name": "Olmos de Peñafiel",
                        "latitude": "41.57142000",
                        "longitude": "-4.04316000"
                    },
                    {
                        "id": 36018,
                        "name": "Palazuelo de Vedija",
                        "latitude": "41.92966000",
                        "longitude": "-5.14534000"
                    },
                    {
                        "id": 152689,
                        "name": "Parrilla La",
                        "latitude": "41.53676130",
                        "longitude": "-4.53337390"
                    },
                    {
                        "id": 152690,
                        "name": "Pedraja de Portillo La",
                        "latitude": "41.47138310",
                        "longitude": "-4.64632650"
                    },
                    {
                        "id": 36089,
                        "name": "Pedrajas de San Esteban",
                        "latitude": "41.34145000",
                        "longitude": "-4.58225000"
                    },
                    {
                        "id": 36108,
                        "name": "Pedrosa del Rey",
                        "latitude": "41.55617000",
                        "longitude": "-5.20466000"
                    },
                    {
                        "id": 36162,
                        "name": "Peñafiel",
                        "latitude": "41.60165000",
                        "longitude": "-4.11418000"
                    },
                    {
                        "id": 36164,
                        "name": "Peñaflor de Hornija",
                        "latitude": "41.71159000",
                        "longitude": "-4.98333000"
                    },
                    {
                        "id": 152691,
                        "name": "Pesquera de Duero",
                        "latitude": "41.64154750",
                        "longitude": "-4.15585530"
                    },
                    {
                        "id": 36228,
                        "name": "Piña de Esgueva",
                        "latitude": "41.72843000",
                        "longitude": "-4.42823000"
                    },
                    {
                        "id": 36230,
                        "name": "Piñel de Abajo",
                        "latitude": "41.67459000",
                        "longitude": "-4.14655000"
                    },
                    {
                        "id": 36231,
                        "name": "Piñel de Arriba",
                        "latitude": "41.69923000",
                        "longitude": "-4.12808000"
                    },
                    {
                        "id": 36263,
                        "name": "Pollos",
                        "latitude": "41.44406000",
                        "longitude": "-5.12491000"
                    },
                    {
                        "id": 36291,
                        "name": "Portillo",
                        "latitude": "41.47867000",
                        "longitude": "-4.58967000"
                    },
                    {
                        "id": 36313,
                        "name": "Pozal de Gallinas",
                        "latitude": "41.31831000",
                        "longitude": "-4.83936000"
                    },
                    {
                        "id": 152692,
                        "name": "Pozaldez",
                        "latitude": "41.37147140",
                        "longitude": "-4.84461540"
                    },
                    {
                        "id": 36336,
                        "name": "Pozuelo de la Orden",
                        "latitude": "41.82138000",
                        "longitude": "-5.25891000"
                    },
                    {
                        "id": 36474,
                        "name": "Puras",
                        "latitude": "41.18333000",
                        "longitude": "-4.65000000"
                    },
                    {
                        "id": 36517,
                        "name": "Quintanilla de Arriba",
                        "latitude": "41.61974000",
                        "longitude": "-4.21774000"
                    },
                    {
                        "id": 36519,
                        "name": "Quintanilla de Onésimo",
                        "latitude": "41.62490000",
                        "longitude": "-4.36291000"
                    },
                    {
                        "id": 36520,
                        "name": "Quintanilla de Trigueros",
                        "latitude": "41.85449000",
                        "longitude": "-4.65931000"
                    },
                    {
                        "id": 36524,
                        "name": "Quintanilla del Molar",
                        "latitude": "41.98935000",
                        "longitude": "-5.44928000"
                    },
                    {
                        "id": 36708,
                        "name": "Rábano",
                        "latitude": "41.53314000",
                        "longitude": "-4.06214000"
                    },
                    {
                        "id": 36545,
                        "name": "Ramiro",
                        "latitude": "41.22845000",
                        "longitude": "-4.78608000"
                    },
                    {
                        "id": 152693,
                        "name": "Renedo de Esgueva",
                        "latitude": "41.65461010",
                        "longitude": "-4.62889380"
                    },
                    {
                        "id": 152694,
                        "name": "Roales de Campos",
                        "latitude": "42.03070940",
                        "longitude": "-5.47384910"
                    },
                    {
                        "id": 36645,
                        "name": "Robladillo",
                        "latitude": "41.60838000",
                        "longitude": "-4.90992000"
                    },
                    {
                        "id": 36682,
                        "name": "Roturas",
                        "latitude": "41.66791000",
                        "longitude": "-4.11901000"
                    },
                    {
                        "id": 36695,
                        "name": "Rubí de Bracamonte",
                        "latitude": "41.21421000",
                        "longitude": "-4.92491000"
                    },
                    {
                        "id": 36697,
                        "name": "Rueda",
                        "latitude": "41.41231000",
                        "longitude": "-4.95885000"
                    },
                    {
                        "id": 36734,
                        "name": "Saelices de Mayorga",
                        "latitude": "42.21206000",
                        "longitude": "-5.20534000"
                    },
                    {
                        "id": 36782,
                        "name": "Salvador de Zapardiel",
                        "latitude": "41.11696000",
                        "longitude": "-4.87486000"
                    },
                    {
                        "id": 36816,
                        "name": "San Cebrián de Mazote",
                        "latitude": "41.68022000",
                        "longitude": "-5.14847000"
                    },
                    {
                        "id": 36856,
                        "name": "San Llorente",
                        "latitude": "41.68631000",
                        "longitude": "-4.06600000"
                    },
                    {
                        "id": 36872,
                        "name": "San Martín de Valvení",
                        "latitude": "41.75336000",
                        "longitude": "-4.56724000"
                    },
                    {
                        "id": 36887,
                        "name": "San Miguel del Arroyo",
                        "latitude": "41.44328000",
                        "longitude": "-4.45990000"
                    },
                    {
                        "id": 36888,
                        "name": "San Miguel del Pino",
                        "latitude": "41.50941000",
                        "longitude": "-4.91149000"
                    },
                    {
                        "id": 36897,
                        "name": "San Pablo de la Moraleja",
                        "latitude": "41.16100000",
                        "longitude": "-4.77761000"
                    },
                    {
                        "id": 36906,
                        "name": "San Pedro de Latarce",
                        "latitude": "41.73556000",
                        "longitude": "-5.32592000"
                    },
                    {
                        "id": 36913,
                        "name": "San Pelayo",
                        "latitude": "41.68033000",
                        "longitude": "-5.03403000"
                    },
                    {
                        "id": 36917,
                        "name": "San Román de Hornija",
                        "latitude": "41.48131000",
                        "longitude": "-5.28454000"
                    },
                    {
                        "id": 152695,
                        "name": "San Salvador",
                        "latitude": "41.62350780",
                        "longitude": "-5.08589880"
                    },
                    {
                        "id": 36931,
                        "name": "San Vicente del Palacio",
                        "latitude": "41.21901000",
                        "longitude": "-4.85158000"
                    },
                    {
                        "id": 37050,
                        "name": "Santa Eufemia del Arroyo",
                        "latitude": "41.89505000",
                        "longitude": "-5.26575000"
                    },
                    {
                        "id": 37110,
                        "name": "Santervás de Campos",
                        "latitude": "42.21820000",
                        "longitude": "-5.10027000"
                    },
                    {
                        "id": 37123,
                        "name": "Santibáñez de Valcorba",
                        "latitude": "41.56983000",
                        "longitude": "-4.44938000"
                    },
                    {
                        "id": 37148,
                        "name": "Santovenia de Pisuerga",
                        "latitude": "41.69457000",
                        "longitude": "-4.69029000"
                    },
                    {
                        "id": 37159,
                        "name": "Sardón de Duero",
                        "latitude": "41.60847000",
                        "longitude": "-4.43397000"
                    },
                    {
                        "id": 152696,
                        "name": "Seca La",
                        "latitude": "41.43654710",
                        "longitude": "-4.91432390"
                    },
                    {
                        "id": 37220,
                        "name": "Serrada",
                        "latitude": "41.45722000",
                        "longitude": "-4.86279000"
                    },
                    {
                        "id": 37250,
                        "name": "Siete Iglesias de Trabancos",
                        "latitude": "41.35223000",
                        "longitude": "-5.18488000"
                    },
                    {
                        "id": 37258,
                        "name": "Simancas",
                        "latitude": "41.59072000",
                        "longitude": "-4.82796000"
                    },
                    {
                        "id": 37365,
                        "name": "Tamariz de Campos",
                        "latitude": "41.97706000",
                        "longitude": "-5.02335000"
                    },
                    {
                        "id": 37421,
                        "name": "Tiedra",
                        "latitude": "41.65239000",
                        "longitude": "-5.26688000"
                    },
                    {
                        "id": 37455,
                        "name": "Tordehumos",
                        "latitude": "41.81531000",
                        "longitude": "-5.15811000"
                    },
                    {
                        "id": 37459,
                        "name": "Tordesillas",
                        "latitude": "41.50202000",
                        "longitude": "-5.00146000"
                    },
                    {
                        "id": 37492,
                        "name": "Torre de Esgueva",
                        "latitude": "41.76821000",
                        "longitude": "-4.20003000"
                    },
                    {
                        "id": 37495,
                        "name": "Torre de Peñafiel",
                        "latitude": "41.53646000",
                        "longitude": "-4.08833000"
                    },
                    {
                        "id": 37516,
                        "name": "Torrecilla de la Abadesa",
                        "latitude": "41.48498000",
                        "longitude": "-5.08762000"
                    },
                    {
                        "id": 37518,
                        "name": "Torrecilla de la Orden",
                        "latitude": "41.21885000",
                        "longitude": "-5.22384000"
                    },
                    {
                        "id": 37519,
                        "name": "Torrecilla de la Torre",
                        "latitude": "41.66716000",
                        "longitude": "-5.04982000"
                    },
                    {
                        "id": 37550,
                        "name": "Torrelobatón",
                        "latitude": "41.64942000",
                        "longitude": "-5.02526000"
                    },
                    {
                        "id": 37581,
                        "name": "Torrescárcela",
                        "latitude": "41.48455000",
                        "longitude": "-4.31920000"
                    },
                    {
                        "id": 37623,
                        "name": "Traspinedo",
                        "latitude": "41.57509000",
                        "longitude": "-4.47569000"
                    },
                    {
                        "id": 37638,
                        "name": "Trigueros del Valle",
                        "latitude": "41.83049000",
                        "longitude": "-4.65179000"
                    },
                    {
                        "id": 37649,
                        "name": "Tudela de Duero",
                        "latitude": "41.58450000",
                        "longitude": "-4.58093000"
                    },
                    {
                        "id": 152697,
                        "name": "Unión de Campos La",
                        "latitude": "42.07708350",
                        "longitude": "-5.32724310"
                    },
                    {
                        "id": 37694,
                        "name": "Urones de Castroponce",
                        "latitude": "42.09911000",
                        "longitude": "-5.28222000"
                    },
                    {
                        "id": 37698,
                        "name": "Urueña",
                        "latitude": "41.72738000",
                        "longitude": "-5.20304000"
                    },
                    {
                        "id": 37723,
                        "name": "Valbuena de Duero",
                        "latitude": "41.64323000",
                        "longitude": "-4.29271000"
                    },
                    {
                        "id": 37731,
                        "name": "Valdearcos de la Vega",
                        "latitude": "41.64260000",
                        "longitude": "-4.04845000"
                    },
                    {
                        "id": 37777,
                        "name": "Valdenebro de los Valles",
                        "latitude": "41.85690000",
                        "longitude": "-4.97005000"
                    },
                    {
                        "id": 37802,
                        "name": "Valdestillas",
                        "latitude": "41.47697000",
                        "longitude": "-4.77116000"
                    },
                    {
                        "id": 37814,
                        "name": "Valdunquillo",
                        "latitude": "42.04232000",
                        "longitude": "-5.31339000"
                    },
                    {
                        "id": 37836,
                        "name": "Valladolid",
                        "latitude": "41.65518000",
                        "longitude": "-4.72372000"
                    },
                    {
                        "id": 37870,
                        "name": "Valoria la Buena",
                        "latitude": "41.79966000",
                        "longitude": "-4.53055000"
                    },
                    {
                        "id": 37884,
                        "name": "Valverde de Campos",
                        "latitude": "41.83510000",
                        "longitude": "-5.03674000"
                    },
                    {
                        "id": 37906,
                        "name": "Vega de Ruiponce",
                        "latitude": "42.18808000",
                        "longitude": "-5.11477000"
                    },
                    {
                        "id": 37912,
                        "name": "Vega de Valdetronco",
                        "latitude": "41.59364000",
                        "longitude": "-5.11319000"
                    },
                    {
                        "id": 37924,
                        "name": "Velascálvaro",
                        "latitude": "41.23028000",
                        "longitude": "-4.97242000"
                    },
                    {
                        "id": 37928,
                        "name": "Velilla",
                        "latitude": "41.55920000",
                        "longitude": "-5.00454000"
                    },
                    {
                        "id": 37935,
                        "name": "Velliza",
                        "latitude": "41.57918000",
                        "longitude": "-4.94655000"
                    },
                    {
                        "id": 37943,
                        "name": "Ventosa de la Cuesta",
                        "latitude": "41.41110000",
                        "longitude": "-4.82932000"
                    },
                    {
                        "id": 37957,
                        "name": "Viana de Cega",
                        "latitude": "41.52927000",
                        "longitude": "-4.75245000"
                    },
                    {
                        "id": 38023,
                        "name": "Villabáñez",
                        "latitude": "41.63097000",
                        "longitude": "-4.52192000"
                    },
                    {
                        "id": 38015,
                        "name": "Villabaruz de Campos",
                        "latitude": "42.01099000",
                        "longitude": "-4.99624000"
                    },
                    {
                        "id": 38020,
                        "name": "Villabrágima",
                        "latitude": "41.82178000",
                        "longitude": "-5.11546000"
                    },
                    {
                        "id": 38024,
                        "name": "Villacarralón",
                        "latitude": "42.18999000",
                        "longitude": "-5.04324000"
                    },
                    {
                        "id": 38029,
                        "name": "Villacid de Campos",
                        "latitude": "42.08250000",
                        "longitude": "-5.12498000"
                    },
                    {
                        "id": 38032,
                        "name": "Villaco",
                        "latitude": "41.74022000",
                        "longitude": "-4.26817000"
                    },
                    {
                        "id": 38054,
                        "name": "Villafrades de Campos",
                        "latitude": "42.07853000",
                        "longitude": "-4.97125000"
                    },
                    {
                        "id": 38057,
                        "name": "Villafranca de Duero",
                        "latitude": "41.43310000",
                        "longitude": "-5.30192000"
                    },
                    {
                        "id": 38065,
                        "name": "Villafrechós",
                        "latitude": "41.89290000",
                        "longitude": "-5.21859000"
                    },
                    {
                        "id": 38067,
                        "name": "Villafuerte",
                        "latitude": "41.73431000",
                        "longitude": "-4.32365000"
                    },
                    {
                        "id": 38071,
                        "name": "Villagarcía de Campos",
                        "latitude": "41.78032000",
                        "longitude": "-5.19242000"
                    },
                    {
                        "id": 38080,
                        "name": "Villagómez la Nueva",
                        "latitude": "42.15592000",
                        "longitude": "-5.14208000"
                    },
                    {
                        "id": 38125,
                        "name": "Villalán de Campos",
                        "latitude": "42.01484000",
                        "longitude": "-5.23642000"
                    },
                    {
                        "id": 38090,
                        "name": "Villalar de los Comuneros",
                        "latitude": "41.54966000",
                        "longitude": "-5.13810000"
                    },
                    {
                        "id": 38097,
                        "name": "Villalba de la Loma",
                        "latitude": "42.17472000",
                        "longitude": "-5.19023000"
                    },
                    {
                        "id": 38099,
                        "name": "Villalba de los Alcores",
                        "latitude": "41.86361000",
                        "longitude": "-4.86063000"
                    },
                    {
                        "id": 38104,
                        "name": "Villalbarba",
                        "latitude": "41.60389000",
                        "longitude": "-5.21281000"
                    },
                    {
                        "id": 38126,
                        "name": "Villalón de Campos",
                        "latitude": "42.09994000",
                        "longitude": "-5.03440000"
                    },
                    {
                        "id": 38165,
                        "name": "Villamuriel de Campos",
                        "latitude": "41.94690000",
                        "longitude": "-5.20717000"
                    },
                    {
                        "id": 38380,
                        "name": "Villán de Tordesillas",
                        "latitude": "41.59311000",
                        "longitude": "-4.92214000"
                    },
                    {
                        "id": 38168,
                        "name": "Villanubla",
                        "latitude": "41.69877000",
                        "longitude": "-4.84173000"
                    },
                    {
                        "id": 38181,
                        "name": "Villanueva de Duero",
                        "latitude": "41.51946000",
                        "longitude": "-4.86671000"
                    },
                    {
                        "id": 38197,
                        "name": "Villanueva de la Condesa",
                        "latitude": "42.14914000",
                        "longitude": "-5.09550000"
                    },
                    {
                        "id": 38209,
                        "name": "Villanueva de los Caballeros",
                        "latitude": "41.75916000",
                        "longitude": "-5.24786000"
                    },
                    {
                        "id": 152030,
                        "name": "Villanueva de los Infantes",
                        "latitude": "41.70394400",
                        "longitude": "-4.48190740"
                    },
                    {
                        "id": 38190,
                        "name": "Villanueva de San Mancio",
                        "latitude": "41.92842000",
                        "longitude": "-5.01200000"
                    },
                    {
                        "id": 38266,
                        "name": "Villardefrades",
                        "latitude": "41.72358000",
                        "longitude": "-5.25513000"
                    },
                    {
                        "id": 38289,
                        "name": "Villarmentero de Esgueva",
                        "latitude": "41.68515000",
                        "longitude": "-4.54636000"
                    },
                    {
                        "id": 38326,
                        "name": "Villasexmir",
                        "latitude": "41.63943000",
                        "longitude": "-5.06470000"
                    },
                    {
                        "id": 38339,
                        "name": "Villavaquerín",
                        "latitude": "41.66357000",
                        "longitude": "-4.46287000"
                    },
                    {
                        "id": 38341,
                        "name": "Villavellid",
                        "latitude": "41.69218000",
                        "longitude": "-5.27630000"
                    },
                    {
                        "id": 38346,
                        "name": "Villaverde de Medina",
                        "latitude": "41.30687000",
                        "longitude": "-5.02625000"
                    },
                    {
                        "id": 38355,
                        "name": "Villavicencio de los Caballeros",
                        "latitude": "42.05893000",
                        "longitude": "-5.23566000"
                    },
                    {
                        "id": 38383,
                        "name": "Viloria",
                        "latitude": "41.44604000",
                        "longitude": "-4.38356000"
                    },
                    {
                        "id": 38419,
                        "name": "Wamba",
                        "latitude": "41.67525000",
                        "longitude": "-4.91748000"
                    },
                    {
                        "id": 38473,
                        "name": "Zaratán",
                        "latitude": "41.65971000",
                        "longitude": "-4.78417000"
                    },
                    {
                        "id": 152698,
                        "name": "Zarza La",
                        "latitude": "41.26186980",
                        "longitude": "-4.77110020"
                    }
                ]
            },
            {
                "id": 1161,
                "name": "Zamora",
                "iso2": "ZA",
                "latitude": "41.60957440",
                "longitude": "-5.89871390",
                "type": "province",
                "cities": [
                    {
                        "id": 31911,
                        "name": "Abezames",
                        "latitude": "41.62642000",
                        "longitude": "-5.42577000"
                    },
                    {
                        "id": 32093,
                        "name": "Alcañices",
                        "latitude": "41.69940000",
                        "longitude": "-6.34647000"
                    },
                    {
                        "id": 32126,
                        "name": "Alcubilla de Nogales",
                        "latitude": "42.12787000",
                        "longitude": "-5.92184000"
                    },
                    {
                        "id": 152651,
                        "name": "Alfaraz de Sayago",
                        "latitude": "41.22781300",
                        "longitude": "-5.98391860"
                    },
                    {
                        "id": 32224,
                        "name": "Algodre",
                        "latitude": "41.56631000",
                        "longitude": "-5.60406000"
                    },
                    {
                        "id": 32269,
                        "name": "Almaraz de Duero",
                        "latitude": "41.47505000",
                        "longitude": "-5.91654000"
                    },
                    {
                        "id": 152652,
                        "name": "Almeida de Sayago",
                        "latitude": "41.26762530",
                        "longitude": "-6.07189080"
                    },
                    {
                        "id": 152653,
                        "name": "Andavías",
                        "latitude": "41.51178970",
                        "longitude": "-5.75386240"
                    },
                    {
                        "id": 32429,
                        "name": "Arcenillas",
                        "latitude": "41.45641000",
                        "longitude": "-5.68512000"
                    },
                    {
                        "id": 32438,
                        "name": "Arcos de la Polvorosa",
                        "latitude": "41.94389000",
                        "longitude": "-5.69731000"
                    },
                    {
                        "id": 32466,
                        "name": "Argañín",
                        "latitude": "41.43948000",
                        "longitude": "-6.20827000"
                    },
                    {
                        "id": 32476,
                        "name": "Argujillo",
                        "latitude": "41.31156000",
                        "longitude": "-5.58763000"
                    },
                    {
                        "id": 32498,
                        "name": "Arquillinos",
                        "latitude": "41.70990000",
                        "longitude": "-5.65708000"
                    },
                    {
                        "id": 32500,
                        "name": "Arrabalde",
                        "latitude": "42.10760000",
                        "longitude": "-5.89441000"
                    },
                    {
                        "id": 32536,
                        "name": "Aspariegos",
                        "latitude": "41.67458000",
                        "longitude": "-5.59955000"
                    },
                    {
                        "id": 32542,
                        "name": "Asturianos",
                        "latitude": "42.05201000",
                        "longitude": "-6.48940000"
                    },
                    {
                        "id": 32577,
                        "name": "Ayoó de Vidriales",
                        "latitude": "42.13042000",
                        "longitude": "-6.06550000"
                    },
                    {
                        "id": 32657,
                        "name": "Barcial del Barco",
                        "latitude": "41.93353000",
                        "longitude": "-5.66268000"
                    },
                    {
                        "id": 32754,
                        "name": "Belver de los Montes",
                        "latitude": "41.72284000",
                        "longitude": "-5.45182000"
                    },
                    {
                        "id": 32781,
                        "name": "Benavente",
                        "latitude": "42.00249000",
                        "longitude": "-5.67826000"
                    },
                    {
                        "id": 32784,
                        "name": "Benegiles",
                        "latitude": "41.62700000",
                        "longitude": "-5.63479000"
                    },
                    {
                        "id": 32860,
                        "name": "Bermillo de Sayago",
                        "latitude": "41.36648000",
                        "longitude": "-6.11223000"
                    },
                    {
                        "id": 152654,
                        "name": "Bóveda de Toro La",
                        "latitude": "41.34308550",
                        "longitude": "-5.41097250"
                    },
                    {
                        "id": 32979,
                        "name": "Bretó",
                        "latitude": "41.87917000",
                        "longitude": "-5.73902000"
                    },
                    {
                        "id": 32978,
                        "name": "Bretocino",
                        "latitude": "41.88430000",
                        "longitude": "-5.75473000"
                    },
                    {
                        "id": 32985,
                        "name": "Brime de Sog",
                        "latitude": "42.06162000",
                        "longitude": "-6.04791000"
                    },
                    {
                        "id": 32986,
                        "name": "Brime de Urz",
                        "latitude": "42.03794000",
                        "longitude": "-5.87326000"
                    },
                    {
                        "id": 33024,
                        "name": "Burganes de Valverde",
                        "latitude": "41.92130000",
                        "longitude": "-5.78244000"
                    },
                    {
                        "id": 33041,
                        "name": "Bustillo del Oro",
                        "latitude": "41.67460000",
                        "longitude": "-5.46158000"
                    },
                    {
                        "id": 33072,
                        "name": "Cabañas de Sayago",
                        "latitude": "41.33333000",
                        "longitude": "-5.78333000"
                    },
                    {
                        "id": 33162,
                        "name": "Calzadilla de Tera",
                        "latitude": "41.97899000",
                        "longitude": "-6.08243000"
                    },
                    {
                        "id": 33171,
                        "name": "Camarzana de Tera",
                        "latitude": "41.99471000",
                        "longitude": "-6.02657000"
                    },
                    {
                        "id": 33542,
                        "name": "Cañizal",
                        "latitude": "41.16654000",
                        "longitude": "-5.36828000"
                    },
                    {
                        "id": 33546,
                        "name": "Cañizo",
                        "latitude": "41.76955000",
                        "longitude": "-5.50199000"
                    },
                    {
                        "id": 33279,
                        "name": "Carbajales de Alba",
                        "latitude": "41.65347000",
                        "longitude": "-5.99706000"
                    },
                    {
                        "id": 33284,
                        "name": "Carbellino",
                        "latitude": "41.22975000",
                        "longitude": "-6.14901000"
                    },
                    {
                        "id": 33377,
                        "name": "Casaseca de Campeán",
                        "latitude": "41.37429000",
                        "longitude": "-5.74648000"
                    },
                    {
                        "id": 33378,
                        "name": "Casaseca de las Chanas",
                        "latitude": "41.43870000",
                        "longitude": "-5.67547000"
                    },
                    {
                        "id": 33480,
                        "name": "Castrillo de la Guareña",
                        "latitude": "41.23043000",
                        "longitude": "-5.32550000"
                    },
                    {
                        "id": 33497,
                        "name": "Castrogonzalo",
                        "latitude": "41.99099000",
                        "longitude": "-5.60301000"
                    },
                    {
                        "id": 33502,
                        "name": "Castronuevo",
                        "latitude": "41.72046000",
                        "longitude": "-5.54315000"
                    },
                    {
                        "id": 33510,
                        "name": "Castroverde de Campos",
                        "latitude": "41.97049000",
                        "longitude": "-5.31434000"
                    },
                    {
                        "id": 33525,
                        "name": "Cazurra",
                        "latitude": "41.41583000",
                        "longitude": "-5.70454000"
                    },
                    {
                        "id": 33584,
                        "name": "Cerecinos de Campos",
                        "latitude": "41.90017000",
                        "longitude": "-5.48605000"
                    },
                    {
                        "id": 33585,
                        "name": "Cerecinos del Carrizal",
                        "latitude": "41.68384000",
                        "longitude": "-5.65303000"
                    },
                    {
                        "id": 33590,
                        "name": "Cernadilla",
                        "latitude": "42.02083000",
                        "longitude": "-6.41701000"
                    },
                    {
                        "id": 33713,
                        "name": "Cobreros",
                        "latitude": "42.07323000",
                        "longitude": "-6.70053000"
                    },
                    {
                        "id": 33771,
                        "name": "Coomonte",
                        "latitude": "42.11546000",
                        "longitude": "-5.81316000"
                    },
                    {
                        "id": 33787,
                        "name": "Coreses",
                        "latitude": "41.54794000",
                        "longitude": "-5.62252000"
                    },
                    {
                        "id": 152655,
                        "name": "Corrales del Vino",
                        "latitude": "41.35787590",
                        "longitude": "-5.72561160"
                    },
                    {
                        "id": 152656,
                        "name": "Cotanes del Monte",
                        "latitude": "41.81725720",
                        "longitude": "-5.29130300"
                    },
                    {
                        "id": 33856,
                        "name": "Cubillos",
                        "latitude": "41.57436000",
                        "longitude": "-5.73920000"
                    },
                    {
                        "id": 33859,
                        "name": "Cubo de Benavente",
                        "latitude": "42.12490000",
                        "longitude": "-6.16342000"
                    },
                    {
                        "id": 152657,
                        "name": "Cubo de Tierra del Vino El",
                        "latitude": "41.25544070",
                        "longitude": "-5.71089800"
                    },
                    {
                        "id": 33863,
                        "name": "Cuelgamures",
                        "latitude": "41.30738000",
                        "longitude": "-5.65769000"
                    },
                    {
                        "id": 34061,
                        "name": "Entrala",
                        "latitude": "41.43006000",
                        "longitude": "-5.75556000"
                    },
                    {
                        "id": 34102,
                        "name": "Espadañedo",
                        "latitude": "42.11618000",
                        "longitude": "-6.39419000"
                    },
                    {
                        "id": 34163,
                        "name": "Faramontanos de Tábara",
                        "latitude": "41.83469000",
                        "longitude": "-5.88883000"
                    },
                    {
                        "id": 34164,
                        "name": "Fariza",
                        "latitude": "41.41667000",
                        "longitude": "-6.26667000"
                    },
                    {
                        "id": 34174,
                        "name": "Fermoselle",
                        "latitude": "41.31738000",
                        "longitude": "-6.39584000"
                    },
                    {
                        "id": 34177,
                        "name": "Ferreras de Abajo",
                        "latitude": "41.89651000",
                        "longitude": "-6.07904000"
                    },
                    {
                        "id": 34178,
                        "name": "Ferreras de Arriba",
                        "latitude": "41.89878000",
                        "longitude": "-6.19461000"
                    },
                    {
                        "id": 34180,
                        "name": "Ferreruela",
                        "latitude": "41.76673000",
                        "longitude": "-6.07215000"
                    },
                    {
                        "id": 34186,
                        "name": "Figueruela de Arriba",
                        "latitude": "41.86867000",
                        "longitude": "-6.44454000"
                    },
                    {
                        "id": 34207,
                        "name": "Fonfría",
                        "latitude": "40.99566000",
                        "longitude": "-1.08475000"
                    },
                    {
                        "id": 34261,
                        "name": "Fresno de la Polvorosa",
                        "latitude": "42.08310000",
                        "longitude": "-5.76969000"
                    },
                    {
                        "id": 34262,
                        "name": "Fresno de la Ribera",
                        "latitude": "41.52926000",
                        "longitude": "-5.56658000"
                    },
                    {
                        "id": 34258,
                        "name": "Fresno de Sayago",
                        "latitude": "41.31848000",
                        "longitude": "-5.97129000"
                    },
                    {
                        "id": 34265,
                        "name": "Friera de Valverde",
                        "latitude": "41.91214000",
                        "longitude": "-5.84153000"
                    },
                    {
                        "id": 34291,
                        "name": "Fuente Encalada",
                        "latitude": "42.11011000",
                        "longitude": "-5.99622000"
                    },
                    {
                        "id": 34318,
                        "name": "Fuentelapeña",
                        "latitude": "41.25144000",
                        "longitude": "-5.38325000"
                    },
                    {
                        "id": 34349,
                        "name": "Fuentes de Ropel",
                        "latitude": "42.00377000",
                        "longitude": "-5.54532000"
                    },
                    {
                        "id": 34352,
                        "name": "Fuentesaúco",
                        "latitude": "41.23043000",
                        "longitude": "-5.49722000"
                    },
                    {
                        "id": 34354,
                        "name": "Fuentesecas",
                        "latitude": "41.63077000",
                        "longitude": "-5.47252000"
                    },
                    {
                        "id": 34358,
                        "name": "Fuentespreadas",
                        "latitude": "41.32627000",
                        "longitude": "-5.62798000"
                    },
                    {
                        "id": 34379,
                        "name": "Galende",
                        "latitude": "42.10440000",
                        "longitude": "-6.66252000"
                    },
                    {
                        "id": 34390,
                        "name": "Gallegos del Pan",
                        "latitude": "41.59985000",
                        "longitude": "-5.58117000"
                    },
                    {
                        "id": 34391,
                        "name": "Gallegos del Río",
                        "latitude": "41.73497000",
                        "longitude": "-6.17435000"
                    },
                    {
                        "id": 34401,
                        "name": "Gamones",
                        "latitude": "41.46690000",
                        "longitude": "-6.17621000"
                    },
                    {
                        "id": 34449,
                        "name": "Gema",
                        "latitude": "41.41855000",
                        "longitude": "-5.64906000"
                    },
                    {
                        "id": 34500,
                        "name": "Granja de Moreruela",
                        "latitude": "41.81026000",
                        "longitude": "-5.73893000"
                    },
                    {
                        "id": 34504,
                        "name": "Granucillo",
                        "latitude": "42.05209000",
                        "longitude": "-5.92777000"
                    },
                    {
                        "id": 152658,
                        "name": "Guarrate",
                        "latitude": "41.28908390",
                        "longitude": "-5.44240230"
                    },
                    {
                        "id": 34587,
                        "name": "Hermisende",
                        "latitude": "41.96898000",
                        "longitude": "-6.89616000"
                    },
                    {
                        "id": 152659,
                        "name": "Hiniesta La",
                        "latitude": "41.55116260",
                        "longitude": "-5.79978990"
                    },
                    {
                        "id": 34794,
                        "name": "Jambrina",
                        "latitude": "41.39196000",
                        "longitude": "-5.66411000"
                    },
                    {
                        "id": 34833,
                        "name": "Justel",
                        "latitude": "42.14861000",
                        "longitude": "-6.29594000"
                    },
                    {
                        "id": 35139,
                        "name": "Losacino",
                        "latitude": "41.68084000",
                        "longitude": "-6.07986000"
                    },
                    {
                        "id": 35140,
                        "name": "Losacio",
                        "latitude": "41.71092000",
                        "longitude": "-6.04059000"
                    },
                    {
                        "id": 35146,
                        "name": "Lubián",
                        "latitude": "42.03569000",
                        "longitude": "-6.90541000"
                    },
                    {
                        "id": 35156,
                        "name": "Luelmo",
                        "latitude": "41.44030000",
                        "longitude": "-6.13338000"
                    },
                    {
                        "id": 152660,
                        "name": "Maderal El",
                        "latitude": "41.28229700",
                        "longitude": "-5.62279600"
                    },
                    {
                        "id": 35187,
                        "name": "Madridanos",
                        "latitude": "41.47967000",
                        "longitude": "-5.60459000"
                    },
                    {
                        "id": 35207,
                        "name": "Mahide",
                        "latitude": "41.86917000",
                        "longitude": "-6.37784000"
                    },
                    {
                        "id": 35211,
                        "name": "Maire de Castroponce",
                        "latitude": "42.11283000",
                        "longitude": "-5.78475000"
                    },
                    {
                        "id": 35233,
                        "name": "Malva",
                        "latitude": "41.65467000",
                        "longitude": "-5.48657000"
                    },
                    {
                        "id": 35248,
                        "name": "Manganeses de la Lampreana",
                        "latitude": "41.75085000",
                        "longitude": "-5.71048000"
                    },
                    {
                        "id": 35249,
                        "name": "Manganeses de la Polvorosa",
                        "latitude": "42.03563000",
                        "longitude": "-5.74694000"
                    },
                    {
                        "id": 35262,
                        "name": "Manzanal de Arriba",
                        "latitude": "41.99217000",
                        "longitude": "-6.44012000"
                    },
                    {
                        "id": 35263,
                        "name": "Manzanal de los Infantes",
                        "latitude": "42.05428000",
                        "longitude": "-6.38288000"
                    },
                    {
                        "id": 35264,
                        "name": "Manzanal del Barco",
                        "latitude": "41.63501000",
                        "longitude": "-5.94671000"
                    },
                    {
                        "id": 35342,
                        "name": "Matilla de Arzón",
                        "latitude": "42.10499000",
                        "longitude": "-5.64156000"
                    },
                    {
                        "id": 35345,
                        "name": "Matilla la Seca",
                        "latitude": "41.57935000",
                        "longitude": "-5.50030000"
                    },
                    {
                        "id": 35348,
                        "name": "Mayalde",
                        "latitude": "41.25080000",
                        "longitude": "-5.79767000"
                    },
                    {
                        "id": 35388,
                        "name": "Melgar de Tera",
                        "latitude": "41.96618000",
                        "longitude": "-6.01390000"
                    },
                    {
                        "id": 35418,
                        "name": "Micereces de Tera",
                        "latitude": "41.98886000",
                        "longitude": "-5.87133000"
                    },
                    {
                        "id": 35434,
                        "name": "Milles de la Polvorosa",
                        "latitude": "41.92339000",
                        "longitude": "-5.73309000"
                    },
                    {
                        "id": 35475,
                        "name": "Molacillos",
                        "latitude": "41.58269000",
                        "longitude": "-5.66046000"
                    },
                    {
                        "id": 35476,
                        "name": "Molezuelas de la Carballeda",
                        "latitude": "42.08166000",
                        "longitude": "-6.18723000"
                    },
                    {
                        "id": 35493,
                        "name": "Mombuey",
                        "latitude": "42.02283000",
                        "longitude": "-6.33027000"
                    },
                    {
                        "id": 35511,
                        "name": "Monfarracinos",
                        "latitude": "41.55468000",
                        "longitude": "-5.70795000"
                    },
                    {
                        "id": 35535,
                        "name": "Montamarta",
                        "latitude": "41.64724000",
                        "longitude": "-5.80402000"
                    },
                    {
                        "id": 35598,
                        "name": "Moral de Sayago",
                        "latitude": "41.47019000",
                        "longitude": "-6.10060000"
                    },
                    {
                        "id": 35604,
                        "name": "Moraleja de Sayago",
                        "latitude": "41.16916000",
                        "longitude": "-6.00369000"
                    },
                    {
                        "id": 35606,
                        "name": "Moraleja del Vino",
                        "latitude": "41.46385000",
                        "longitude": "-5.65631000"
                    },
                    {
                        "id": 152661,
                        "name": "Morales de Rey",
                        "latitude": "42.06718500",
                        "longitude": "-5.78661240"
                    },
                    {
                        "id": 35608,
                        "name": "Morales de Toro",
                        "latitude": "41.53737000",
                        "longitude": "-5.30642000"
                    },
                    {
                        "id": 35609,
                        "name": "Morales de Valverde",
                        "latitude": "41.93643000",
                        "longitude": "-5.89255000"
                    },
                    {
                        "id": 35610,
                        "name": "Morales del Vino",
                        "latitude": "41.44736000",
                        "longitude": "-5.73070000"
                    },
                    {
                        "id": 35611,
                        "name": "Moralina",
                        "latitude": "41.49001000",
                        "longitude": "-6.13670000"
                    },
                    {
                        "id": 35628,
                        "name": "Moreruela de los Infanzones",
                        "latitude": "41.63118000",
                        "longitude": "-5.70614000"
                    },
                    {
                        "id": 35627,
                        "name": "Moreruela de Tábara",
                        "latitude": "41.79588000",
                        "longitude": "-5.86849000"
                    },
                    {
                        "id": 35656,
                        "name": "Muelas de los Caballeros",
                        "latitude": "42.12843000",
                        "longitude": "-6.33719000"
                    },
                    {
                        "id": 152662,
                        "name": "Muelas del Pan",
                        "latitude": "41.52060810",
                        "longitude": "-5.97181620"
                    },
                    {
                        "id": 35657,
                        "name": "Muga de Sayago",
                        "latitude": "41.38779000",
                        "longitude": "-6.19777000"
                    },
                    {
                        "id": 35791,
                        "name": "Navianos de Valverde",
                        "latitude": "41.95319000",
                        "longitude": "-5.81781000"
                    },
                    {
                        "id": 35903,
                        "name": "Olmillos de Castro",
                        "latitude": "41.73179000",
                        "longitude": "-5.96791000"
                    },
                    {
                        "id": 35978,
                        "name": "Otero de Bodas",
                        "latitude": "41.93868000",
                        "longitude": "-6.15024000"
                    },
                    {
                        "id": 36002,
                        "name": "Pajares de la Lampreana",
                        "latitude": "41.71551000",
                        "longitude": "-5.69351000"
                    },
                    {
                        "id": 36007,
                        "name": "Palacios de Sanabria",
                        "latitude": "42.05901000",
                        "longitude": "-6.52362000"
                    },
                    {
                        "id": 36011,
                        "name": "Palacios del Pan",
                        "latitude": "41.60242000",
                        "longitude": "-5.87773000"
                    },
                    {
                        "id": 152663,
                        "name": "Pedralba de la Pradería",
                        "latitude": "41.97209710",
                        "longitude": "-6.69589390"
                    },
                    {
                        "id": 152664,
                        "name": "Pego El",
                        "latitude": "41.33476990",
                        "longitude": "-5.46795150"
                    },
                    {
                        "id": 36124,
                        "name": "Peleagonzalo",
                        "latitude": "41.48175000",
                        "longitude": "-5.48304000"
                    },
                    {
                        "id": 36125,
                        "name": "Peleas de Abajo",
                        "latitude": "41.39260000",
                        "longitude": "-5.68966000"
                    },
                    {
                        "id": 36176,
                        "name": "Peñausende",
                        "latitude": "41.28662000",
                        "longitude": "-5.86755000"
                    },
                    {
                        "id": 36129,
                        "name": "Peque",
                        "latitude": "42.07297000",
                        "longitude": "-6.27489000"
                    },
                    {
                        "id": 152665,
                        "name": "Perdigón El",
                        "latitude": "41.41146340",
                        "longitude": "-5.75236440"
                    },
                    {
                        "id": 36148,
                        "name": "Pereruela",
                        "latitude": "41.41650000",
                        "longitude": "-5.87812000"
                    },
                    {
                        "id": 36150,
                        "name": "Perilla de Castro",
                        "latitude": "41.72540000",
                        "longitude": "-5.87636000"
                    },
                    {
                        "id": 36485,
                        "name": "Pías",
                        "latitude": "42.08333000",
                        "longitude": "-7.00000000"
                    },
                    {
                        "id": 36181,
                        "name": "Piedrahita de Castro",
                        "latitude": "41.68089000",
                        "longitude": "-5.72886000"
                    },
                    {
                        "id": 152667,
                        "name": "Piñero El",
                        "latitude": "41.35272190",
                        "longitude": "-5.58864260"
                    },
                    {
                        "id": 36203,
                        "name": "Pinilla de Toro",
                        "latitude": "41.62783000",
                        "longitude": "-5.36414000"
                    },
                    {
                        "id": 152666,
                        "name": "Pino del Oro",
                        "latitude": "41.57623000",
                        "longitude": "-6.12089480"
                    },
                    {
                        "id": 36251,
                        "name": "Pobladura de Valderaduey",
                        "latitude": "41.70009000",
                        "longitude": "-5.54189000"
                    },
                    {
                        "id": 36252,
                        "name": "Pobladura del Valle",
                        "latitude": "42.10257000",
                        "longitude": "-5.73333000"
                    },
                    {
                        "id": 36294,
                        "name": "Porto",
                        "latitude": "42.16737000",
                        "longitude": "-6.89934000"
                    },
                    {
                        "id": 36322,
                        "name": "Pozoantiguo",
                        "latitude": "41.59730000",
                        "longitude": "-5.43660000"
                    },
                    {
                        "id": 36334,
                        "name": "Pozuelo de Tábara",
                        "latitude": "41.78502000",
                        "longitude": "-5.89455000"
                    },
                    {
                        "id": 36344,
                        "name": "Prado",
                        "latitude": "41.92077000",
                        "longitude": "-5.42027000"
                    },
                    {
                        "id": 36423,
                        "name": "Puebla de Sanabria",
                        "latitude": "42.05401000",
                        "longitude": "-6.63350000"
                    },
                    {
                        "id": 36432,
                        "name": "Pueblica de Valverde",
                        "latitude": "41.91843000",
                        "longitude": "-5.89975000"
                    },
                    {
                        "id": 36521,
                        "name": "Quintanilla de Urz",
                        "latitude": "42.03290000",
                        "longitude": "-5.84866000"
                    },
                    {
                        "id": 36525,
                        "name": "Quintanilla del Monte",
                        "latitude": "41.86812000",
                        "longitude": "-5.34928000"
                    },
                    {
                        "id": 36526,
                        "name": "Quintanilla del Olmo",
                        "latitude": "41.90561000",
                        "longitude": "-5.40726000"
                    },
                    {
                        "id": 36530,
                        "name": "Quiruelas de Vidriales",
                        "latitude": "42.01762000",
                        "longitude": "-5.82947000"
                    },
                    {
                        "id": 36533,
                        "name": "Rabanales",
                        "latitude": "41.74287000",
                        "longitude": "-6.27674000"
                    },
                    {
                        "id": 36709,
                        "name": "Rábano de Aliste",
                        "latitude": "41.74430000",
                        "longitude": "-6.43302000"
                    },
                    {
                        "id": 152668,
                        "name": "Requejo",
                        "latitude": "42.03050200",
                        "longitude": "-6.74370280"
                    },
                    {
                        "id": 36593,
                        "name": "Revellinos",
                        "latitude": "41.88982000",
                        "longitude": "-5.56871000"
                    },
                    {
                        "id": 36715,
                        "name": "Ríofrío de Aliste",
                        "latitude": "41.81724000",
                        "longitude": "-6.17741000"
                    },
                    {
                        "id": 152669,
                        "name": "Rionegro del Puente",
                        "latitude": "42.00460090",
                        "longitude": "-6.22830350"
                    },
                    {
                        "id": 36644,
                        "name": "Roales",
                        "latitude": "41.55170000",
                        "longitude": "-5.77211000"
                    },
                    {
                        "id": 36647,
                        "name": "Robleda-Cervantes",
                        "latitude": "42.08246000",
                        "longitude": "-6.59414000"
                    },
                    {
                        "id": 152670,
                        "name": "Roelos de Sayago",
                        "latitude": "41.25271330",
                        "longitude": "-6.17249770"
                    },
                    {
                        "id": 152671,
                        "name": "Rosinos de la Requejada",
                        "latitude": "42.08560960",
                        "longitude": "-6.53364430"
                    },
                    {
                        "id": 36752,
                        "name": "Salce",
                        "latitude": "41.26996000",
                        "longitude": "-6.21875000"
                    },
                    {
                        "id": 36791,
                        "name": "Samir de los Caños",
                        "latitude": "41.67280000",
                        "longitude": "-6.16415000"
                    },
                    {
                        "id": 36800,
                        "name": "San Agustín del Pozo",
                        "latitude": "41.88613000",
                        "longitude": "-5.59351000"
                    },
                    {
                        "id": 36815,
                        "name": "San Cebrián de Castro",
                        "latitude": "41.70632000",
                        "longitude": "-5.75605000"
                    },
                    {
                        "id": 36821,
                        "name": "San Cristóbal de Entreviñas",
                        "latitude": "42.04575000",
                        "longitude": "-5.63468000"
                    },
                    {
                        "id": 36832,
                        "name": "San Esteban del Molar",
                        "latitude": "41.93717000",
                        "longitude": "-5.55158000"
                    },
                    {
                        "id": 36853,
                        "name": "San Justo",
                        "latitude": "42.13321000",
                        "longitude": "-6.62388000"
                    },
                    {
                        "id": 36871,
                        "name": "San Martín de Valderaduey",
                        "latitude": "41.81414000",
                        "longitude": "-5.47249000"
                    },
                    {
                        "id": 36886,
                        "name": "San Miguel de la Ribera",
                        "latitude": "41.33301000",
                        "longitude": "-5.57689000"
                    },
                    {
                        "id": 152672,
                        "name": "San Miguel del Valle",
                        "latitude": "42.04037510",
                        "longitude": "-5.50400150"
                    },
                    {
                        "id": 36904,
                        "name": "San Pedro de Ceque",
                        "latitude": "42.04334000",
                        "longitude": "-6.07242000"
                    },
                    {
                        "id": 152673,
                        "name": "San Pedro de la Nave-Almendra",
                        "latitude": "41.58280140",
                        "longitude": "-5.93568720"
                    },
                    {
                        "id": 36929,
                        "name": "San Vicente de la Cabeza",
                        "latitude": "41.80696000",
                        "longitude": "-6.24993000"
                    },
                    {
                        "id": 36933,
                        "name": "San Vitero",
                        "latitude": "41.77740000",
                        "longitude": "-6.34877000"
                    },
                    {
                        "id": 37013,
                        "name": "Santa Clara de Avedillo",
                        "latitude": "41.33877000",
                        "longitude": "-5.67692000"
                    },
                    {
                        "id": 37020,
                        "name": "Santa Colomba de las Monjas",
                        "latitude": "41.95833000",
                        "longitude": "-5.68389000"
                    },
                    {
                        "id": 37024,
                        "name": "Santa Cristina de la Polvorosa",
                        "latitude": "41.99985000",
                        "longitude": "-5.71355000"
                    },
                    {
                        "id": 37025,
                        "name": "Santa Croya de Tera",
                        "latitude": "41.98334000",
                        "longitude": "-5.97725000"
                    },
                    {
                        "id": 37051,
                        "name": "Santa Eufemia del Barco",
                        "latitude": "41.67808000",
                        "longitude": "-5.89831000"
                    },
                    {
                        "id": 37081,
                        "name": "Santa María de la Vega",
                        "latitude": "42.08497000",
                        "longitude": "-5.80851000"
                    },
                    {
                        "id": 37078,
                        "name": "Santa María de Valverde",
                        "latitude": "41.93479000",
                        "longitude": "-5.93560000"
                    },
                    {
                        "id": 37122,
                        "name": "Santibáñez de Tera",
                        "latitude": "41.98563000",
                        "longitude": "-5.92257000"
                    },
                    {
                        "id": 37124,
                        "name": "Santibáñez de Vidriales",
                        "latitude": "42.07362000",
                        "longitude": "-6.01549000"
                    },
                    {
                        "id": 37147,
                        "name": "Santovenia",
                        "latitude": "41.87857000",
                        "longitude": "-5.71003000"
                    },
                    {
                        "id": 37158,
                        "name": "Sanzoles",
                        "latitude": "41.43235000",
                        "longitude": "-5.56710000"
                    },
                    {
                        "id": 37662,
                        "name": "Tábara",
                        "latitude": "41.82458000",
                        "longitude": "-5.96420000"
                    },
                    {
                        "id": 37369,
                        "name": "Tapioles",
                        "latitude": "41.85741000",
                        "longitude": "-5.49623000"
                    },
                    {
                        "id": 37476,
                        "name": "Toro",
                        "latitude": "41.52417000",
                        "longitude": "-5.39534000"
                    },
                    {
                        "id": 152674,
                        "name": "Torre del Valle La",
                        "latitude": "42.09066110",
                        "longitude": "-5.72405880"
                    },
                    {
                        "id": 37533,
                        "name": "Torregamones",
                        "latitude": "41.48700000",
                        "longitude": "-6.18335000"
                    },
                    {
                        "id": 37578,
                        "name": "Torres del Carrizal",
                        "latitude": "41.61701000",
                        "longitude": "-5.67173000"
                    },
                    {
                        "id": 37614,
                        "name": "Trabazos",
                        "latitude": "41.74793000",
                        "longitude": "-6.49094000"
                    },
                    {
                        "id": 37626,
                        "name": "Trefacio",
                        "latitude": "42.12165000",
                        "longitude": "-6.65407000"
                    },
                    {
                        "id": 37714,
                        "name": "Uña de Quintana",
                        "latitude": "42.08662000",
                        "longitude": "-6.14475000"
                    },
                    {
                        "id": 37716,
                        "name": "Vadillo de la Guareña",
                        "latitude": "41.28242000",
                        "longitude": "-5.35300000"
                    },
                    {
                        "id": 37725,
                        "name": "Valcabado",
                        "latitude": "41.54863000",
                        "longitude": "-5.74916000"
                    },
                    {
                        "id": 37743,
                        "name": "Valdefinjas",
                        "latitude": "41.45172000",
                        "longitude": "-5.45232000"
                    },
                    {
                        "id": 37800,
                        "name": "Valdescorriel",
                        "latitude": "42.02233000",
                        "longitude": "-5.50998000"
                    },
                    {
                        "id": 37856,
                        "name": "Vallesa de la Guareña",
                        "latitude": "41.13532000",
                        "longitude": "-5.32611000"
                    },
                    {
                        "id": 37909,
                        "name": "Vega de Tera",
                        "latitude": "41.99759000",
                        "longitude": "-6.12500000"
                    },
                    {
                        "id": 37913,
                        "name": "Vega de Villalobos",
                        "latitude": "41.97057000",
                        "longitude": "-5.46324000"
                    },
                    {
                        "id": 37916,
                        "name": "Vegalatrave",
                        "latitude": "41.70026000",
                        "longitude": "-6.10675000"
                    },
                    {
                        "id": 37936,
                        "name": "Venialbo",
                        "latitude": "41.38957000",
                        "longitude": "-5.53596000"
                    },
                    {
                        "id": 37956,
                        "name": "Vezdemarbán",
                        "latitude": "41.65480000",
                        "longitude": "-5.36609000"
                    },
                    {
                        "id": 37964,
                        "name": "Vidayanes",
                        "latitude": "41.91011000",
                        "longitude": "-5.57424000"
                    },
                    {
                        "id": 37965,
                        "name": "Videmala",
                        "latitude": "41.61299000",
                        "longitude": "-6.04056000"
                    },
                    {
                        "id": 38021,
                        "name": "Villabrázaro",
                        "latitude": "42.05394000",
                        "longitude": "-5.72748000"
                    },
                    {
                        "id": 38022,
                        "name": "Villabuena del Puente",
                        "latitude": "41.38074000",
                        "longitude": "-5.40787000"
                    },
                    {
                        "id": 38040,
                        "name": "Villadepera",
                        "latitude": "41.54700000",
                        "longitude": "-6.13305000"
                    },
                    {
                        "id": 38044,
                        "name": "Villaescusa",
                        "latitude": "41.20617000",
                        "longitude": "-5.46406000"
                    },
                    {
                        "id": 38069,
                        "name": "Villafáfila",
                        "latitude": "41.84692000",
                        "longitude": "-5.61527000"
                    },
                    {
                        "id": 38051,
                        "name": "Villaferrueña",
                        "latitude": "42.09830000",
                        "longitude": "-5.85802000"
                    },
                    {
                        "id": 38075,
                        "name": "Villageriz",
                        "latitude": "42.11884000",
                        "longitude": "-5.95554000"
                    },
                    {
                        "id": 38091,
                        "name": "Villalazán",
                        "latitude": "41.49414000",
                        "longitude": "-5.58910000"
                    },
                    {
                        "id": 38096,
                        "name": "Villalba de la Lampreana",
                        "latitude": "41.74327000",
                        "longitude": "-5.64094000"
                    },
                    {
                        "id": 38108,
                        "name": "Villalcampo",
                        "latitude": "41.52229000",
                        "longitude": "-6.04801000"
                    },
                    {
                        "id": 38116,
                        "name": "Villalobos",
                        "latitude": "41.94567000",
                        "longitude": "-5.47517000"
                    },
                    {
                        "id": 38119,
                        "name": "Villalonso",
                        "latitude": "41.59767000",
                        "longitude": "-5.29769000"
                    },
                    {
                        "id": 38120,
                        "name": "Villalpando",
                        "latitude": "41.86517000",
                        "longitude": "-5.41231000"
                    },
                    {
                        "id": 38122,
                        "name": "Villalube",
                        "latitude": "41.61005000",
                        "longitude": "-5.54545000"
                    },
                    {
                        "id": 38141,
                        "name": "Villamayor de Campos",
                        "latitude": "41.89870000",
                        "longitude": "-5.35963000"
                    },
                    {
                        "id": 38160,
                        "name": "Villamor de los Escuderos",
                        "latitude": "41.25244000",
                        "longitude": "-5.57485000"
                    },
                    {
                        "id": 38226,
                        "name": "Villanázar",
                        "latitude": "41.97398000",
                        "longitude": "-5.78043000"
                    },
                    {
                        "id": 38174,
                        "name": "Villanueva de Azoague",
                        "latitude": "41.97607000",
                        "longitude": "-5.66400000"
                    },
                    {
                        "id": 38177,
                        "name": "Villanueva de Campeán",
                        "latitude": "41.35447000",
                        "longitude": "-5.77020000"
                    },
                    {
                        "id": 38207,
                        "name": "Villanueva de las Peras",
                        "latitude": "41.93478000",
                        "longitude": "-5.97942000"
                    },
                    {
                        "id": 38215,
                        "name": "Villanueva del Campo",
                        "latitude": "41.98492000",
                        "longitude": "-5.40660000"
                    },
                    {
                        "id": 38239,
                        "name": "Villar de Fallaves",
                        "latitude": "41.92503000",
                        "longitude": "-5.34039000"
                    },
                    {
                        "id": 38252,
                        "name": "Villar del Buey",
                        "latitude": "41.33024000",
                        "longitude": "-6.18935000"
                    },
                    {
                        "id": 38263,
                        "name": "Villaralbo",
                        "latitude": "41.49224000",
                        "longitude": "-5.68359000"
                    },
                    {
                        "id": 38265,
                        "name": "Villardeciervos",
                        "latitude": "41.94206000",
                        "longitude": "-6.28647000"
                    },
                    {
                        "id": 38267,
                        "name": "Villardiegua de la Ribera",
                        "latitude": "41.53543000",
                        "longitude": "-6.18327000"
                    },
                    {
                        "id": 38381,
                        "name": "Villárdiga",
                        "latitude": "41.81950000",
                        "longitude": "-5.46439000"
                    },
                    {
                        "id": 38269,
                        "name": "Villardondiego",
                        "latitude": "41.58483000",
                        "longitude": "-5.37707000"
                    },
                    {
                        "id": 38305,
                        "name": "Villarrín de Campos",
                        "latitude": "41.79522000",
                        "longitude": "-5.63898000"
                    },
                    {
                        "id": 152675,
                        "name": "Villaseco del Pan",
                        "latitude": "41.46858500",
                        "longitude": "-5.96541440"
                    },
                    {
                        "id": 38342,
                        "name": "Villavendimio",
                        "latitude": "41.57812000",
                        "longitude": "-5.34287000"
                    },
                    {
                        "id": 38353,
                        "name": "Villaveza de Valverde",
                        "latitude": "41.94516000",
                        "longitude": "-5.84849000"
                    },
                    {
                        "id": 38354,
                        "name": "Villaveza del Agua",
                        "latitude": "41.91922000",
                        "longitude": "-5.67871000"
                    },
                    {
                        "id": 152676,
                        "name": "Viñas",
                        "latitude": "41.78778940",
                        "longitude": "-6.46099980"
                    },
                    {
                        "id": 38465,
                        "name": "Zamora",
                        "latitude": "41.50633000",
                        "longitude": "-5.74456000"
                    }
                ]
            },
            {
                "id": 5113,
                "name": "Zaragoza",
                "iso2": "Z",
                "latitude": "41.65175010",
                "longitude": "-0.93000020",
                "type": "province",
                "cities": [
                    {
                        "id": 31904,
                        "name": "Abanto",
                        "latitude": "41.13751000",
                        "longitude": "-1.69818000"
                    },
                    {
                        "id": 152466,
                        "name": "Acered",
                        "latitude": "41.17113740",
                        "longitude": "-1.60385270"
                    },
                    {
                        "id": 31971,
                        "name": "Agón",
                        "latitude": "41.85574000",
                        "longitude": "-1.45233000"
                    },
                    {
                        "id": 31952,
                        "name": "Aguarón",
                        "latitude": "41.33901000",
                        "longitude": "-1.27055000"
                    },
                    {
                        "id": 31966,
                        "name": "Aguilón",
                        "latitude": "41.29467000",
                        "longitude": "-1.04634000"
                    },
                    {
                        "id": 31982,
                        "name": "Ainzón",
                        "latitude": "41.81644000",
                        "longitude": "-1.51995000"
                    },
                    {
                        "id": 31989,
                        "name": "Aladrén",
                        "latitude": "41.24917000",
                        "longitude": "-1.15591000"
                    },
                    {
                        "id": 31991,
                        "name": "Alagón",
                        "latitude": "41.76964000",
                        "longitude": "-1.11906000"
                    },
                    {
                        "id": 32004,
                        "name": "Alarba",
                        "latitude": "41.20482000",
                        "longitude": "-1.61335000"
                    },
                    {
                        "id": 32039,
                        "name": "Alberite de San Juan",
                        "latitude": "41.82009000",
                        "longitude": "-1.47063000"
                    },
                    {
                        "id": 32044,
                        "name": "Albeta",
                        "latitude": "41.82636000",
                        "longitude": "-1.49936000"
                    },
                    {
                        "id": 32054,
                        "name": "Alborge",
                        "latitude": "41.33367000",
                        "longitude": "-0.35675000"
                    },
                    {
                        "id": 32069,
                        "name": "Alcalá de Ebro",
                        "latitude": "41.81495000",
                        "longitude": "-1.19429000"
                    },
                    {
                        "id": 32073,
                        "name": "Alcalá de Moncayo",
                        "latitude": "41.78610000",
                        "longitude": "-1.69544000"
                    },
                    {
                        "id": 32116,
                        "name": "Alconchel de Ariza",
                        "latitude": "41.20428000",
                        "longitude": "-2.12191000"
                    },
                    {
                        "id": 32176,
                        "name": "Aldehuela de Liestos",
                        "latitude": "41.06410000",
                        "longitude": "-1.70107000"
                    },
                    {
                        "id": 32191,
                        "name": "Alfajarín",
                        "latitude": "41.61400000",
                        "longitude": "-0.70370000"
                    },
                    {
                        "id": 32193,
                        "name": "Alfamén",
                        "latitude": "41.43919000",
                        "longitude": "-1.24458000"
                    },
                    {
                        "id": 32205,
                        "name": "Alforque",
                        "latitude": "41.32942000",
                        "longitude": "-0.38525000"
                    },
                    {
                        "id": 32234,
                        "name": "Alhama de Aragón",
                        "latitude": "41.29657000",
                        "longitude": "-1.89358000"
                    },
                    {
                        "id": 32292,
                        "name": "Almochuel",
                        "latitude": "41.27992000",
                        "longitude": "-0.55067000"
                    },
                    {
                        "id": 152467,
                        "name": "Almolda La",
                        "latitude": "41.55230780",
                        "longitude": "-0.21157090"
                    },
                    {
                        "id": 32302,
                        "name": "Almonacid de la Cuba",
                        "latitude": "41.28067000",
                        "longitude": "-0.79266000"
                    },
                    {
                        "id": 32303,
                        "name": "Almonacid de la Sierra",
                        "latitude": "41.39754000",
                        "longitude": "-1.32394000"
                    },
                    {
                        "id": 152468,
                        "name": "Almunia de Doña Godina La",
                        "latitude": "41.47684410",
                        "longitude": "-1.37465870"
                    },
                    {
                        "id": 32326,
                        "name": "Alpartir",
                        "latitude": "41.42253000",
                        "longitude": "-1.38061000"
                    },
                    {
                        "id": 32350,
                        "name": "Ambel",
                        "latitude": "41.79472000",
                        "longitude": "-1.61520000"
                    },
                    {
                        "id": 32377,
                        "name": "Anento",
                        "latitude": "41.06958000",
                        "longitude": "-1.33375000"
                    },
                    {
                        "id": 152469,
                        "name": "Aniñón",
                        "latitude": "41.44490480",
                        "longitude": "-1.70644810"
                    },
                    {
                        "id": 152470,
                        "name": "Añón de Moncayo",
                        "latitude": "41.77859660",
                        "longitude": "-1.72012550"
                    },
                    {
                        "id": 32408,
                        "name": "Aranda de Moncayo",
                        "latitude": "41.57749000",
                        "longitude": "-1.79171000"
                    },
                    {
                        "id": 32530,
                        "name": "Arándiga",
                        "latitude": "41.50872000",
                        "longitude": "-1.50074000"
                    },
                    {
                        "id": 152471,
                        "name": "Ardisa",
                        "latitude": "42.20136900",
                        "longitude": "-0.75833130"
                    },
                    {
                        "id": 32480,
                        "name": "Ariza",
                        "latitude": "41.31442000",
                        "longitude": "-2.05332000"
                    },
                    {
                        "id": 32525,
                        "name": "Artieda",
                        "latitude": "42.58538000",
                        "longitude": "-0.98422000"
                    },
                    {
                        "id": 152472,
                        "name": "Asín",
                        "latitude": "42.28386860",
                        "longitude": "-1.04604530"
                    },
                    {
                        "id": 32553,
                        "name": "Atea",
                        "latitude": "41.16059000",
                        "longitude": "-1.55533000"
                    },
                    {
                        "id": 32554,
                        "name": "Ateca",
                        "latitude": "41.33092000",
                        "longitude": "-1.79353000"
                    },
                    {
                        "id": 32589,
                        "name": "Azuara",
                        "latitude": "41.25822000",
                        "longitude": "-0.87078000"
                    },
                    {
                        "id": 32605,
                        "name": "Badules",
                        "latitude": "41.13901000",
                        "longitude": "-1.25366000"
                    },
                    {
                        "id": 32610,
                        "name": "Bagüés",
                        "latitude": "42.54935000",
                        "longitude": "-0.94577000"
                    },
                    {
                        "id": 32622,
                        "name": "Balconchán",
                        "latitude": "41.08737000",
                        "longitude": "-1.45998000"
                    },
                    {
                        "id": 33050,
                        "name": "Bárboles",
                        "latitude": "41.70898000",
                        "longitude": "-1.18594000"
                    },
                    {
                        "id": 32660,
                        "name": "Bardallur",
                        "latitude": "41.68423000",
                        "longitude": "-1.21183000"
                    },
                    {
                        "id": 32737,
                        "name": "Belchite",
                        "latitude": "41.30600000",
                        "longitude": "-0.75400000"
                    },
                    {
                        "id": 152473,
                        "name": "Belmonte de Gracián",
                        "latitude": "41.31263740",
                        "longitude": "-1.53841640"
                    },
                    {
                        "id": 32845,
                        "name": "Berdejo",
                        "latitude": "41.56133000",
                        "longitude": "-1.94431000"
                    },
                    {
                        "id": 152474,
                        "name": "Berrueco",
                        "latitude": "40.99039020",
                        "longitude": "-1.46703500"
                    },
                    {
                        "id": 32887,
                        "name": "Biel",
                        "latitude": "42.38763000",
                        "longitude": "-0.94154000"
                    },
                    {
                        "id": 32894,
                        "name": "Bijuesca",
                        "latitude": "41.54083000",
                        "longitude": "-1.92039000"
                    },
                    {
                        "id": 32899,
                        "name": "Biota",
                        "latitude": "42.26214000",
                        "longitude": "-1.18735000"
                    },
                    {
                        "id": 32902,
                        "name": "Bisimbre",
                        "latitude": "41.85607000",
                        "longitude": "-1.44268000"
                    },
                    {
                        "id": 32949,
                        "name": "Boquiñeni",
                        "latitude": "41.84804000",
                        "longitude": "-1.25246000"
                    },
                    {
                        "id": 32951,
                        "name": "Bordalba",
                        "latitude": "41.41667000",
                        "longitude": "-2.06667000"
                    },
                    {
                        "id": 32954,
                        "name": "Borja",
                        "latitude": "41.83412000",
                        "longitude": "-1.53271000"
                    },
                    {
                        "id": 32966,
                        "name": "Botorrita",
                        "latitude": "41.50706000",
                        "longitude": "-1.03104000"
                    },
                    {
                        "id": 32974,
                        "name": "Brea de Aragón",
                        "latitude": "41.52387000",
                        "longitude": "-1.60261000"
                    },
                    {
                        "id": 32996,
                        "name": "Bubierca",
                        "latitude": "41.31482000",
                        "longitude": "-1.85386000"
                    },
                    {
                        "id": 33016,
                        "name": "Bujaraloz",
                        "latitude": "41.49806000",
                        "longitude": "-0.15290000"
                    },
                    {
                        "id": 33017,
                        "name": "Bulbuente",
                        "latitude": "41.81970000",
                        "longitude": "-1.60238000"
                    },
                    {
                        "id": 33023,
                        "name": "Bureta",
                        "latitude": "41.81572000",
                        "longitude": "-1.48819000"
                    },
                    {
                        "id": 152475,
                        "name": "Burgo de Ebro El",
                        "latitude": "41.57196530",
                        "longitude": "-0.74199420"
                    },
                    {
                        "id": 152476,
                        "name": "Buste El",
                        "latitude": "41.88587580",
                        "longitude": "-1.60173050"
                    },
                    {
                        "id": 33070,
                        "name": "Cabañas de Ebro",
                        "latitude": "41.80000000",
                        "longitude": "-1.20000000"
                    },
                    {
                        "id": 33097,
                        "name": "Cabolafuente",
                        "latitude": "41.21053000",
                        "longitude": "-2.04133000"
                    },
                    {
                        "id": 33119,
                        "name": "Cadrete",
                        "latitude": "41.55575000",
                        "longitude": "-0.96013000"
                    },
                    {
                        "id": 33132,
                        "name": "Calatayud",
                        "latitude": "41.35353000",
                        "longitude": "-1.64318000"
                    },
                    {
                        "id": 33134,
                        "name": "Calatorao",
                        "latitude": "41.52228000",
                        "longitude": "-1.34702000"
                    },
                    {
                        "id": 33136,
                        "name": "Calcena",
                        "latitude": "41.65515000",
                        "longitude": "-1.71764000"
                    },
                    {
                        "id": 33147,
                        "name": "Calmarza",
                        "latitude": "41.15810000",
                        "longitude": "-1.91196000"
                    },
                    {
                        "id": 33187,
                        "name": "Campillo de Aragón",
                        "latitude": "41.12648000",
                        "longitude": "-1.84393000"
                    },
                    {
                        "id": 33305,
                        "name": "Carenas",
                        "latitude": "41.27755000",
                        "longitude": "-1.79754000"
                    },
                    {
                        "id": 33306,
                        "name": "Cariñena",
                        "latitude": "41.33733000",
                        "longitude": "-1.22444000"
                    },
                    {
                        "id": 33393,
                        "name": "Caspe",
                        "latitude": "41.23402000",
                        "longitude": "-0.03945000"
                    },
                    {
                        "id": 33400,
                        "name": "Castejón de Alarba",
                        "latitude": "41.18365000",
                        "longitude": "-1.63612000"
                    },
                    {
                        "id": 33406,
                        "name": "Castejón de las Armas",
                        "latitude": "41.30976000",
                        "longitude": "-1.81084000"
                    },
                    {
                        "id": 33405,
                        "name": "Castejón de Valdejasa",
                        "latitude": "41.98204000",
                        "longitude": "-0.99393000"
                    },
                    {
                        "id": 33452,
                        "name": "Castiliscar",
                        "latitude": "42.37662000",
                        "longitude": "-1.27326000"
                    },
                    {
                        "id": 33598,
                        "name": "Cervera de la Cañada",
                        "latitude": "41.43301000",
                        "longitude": "-1.73568000"
                    },
                    {
                        "id": 33603,
                        "name": "Cerveruela",
                        "latitude": "41.21567000",
                        "longitude": "-1.21525000"
                    },
                    {
                        "id": 33608,
                        "name": "Cetina",
                        "latitude": "41.29208000",
                        "longitude": "-1.96281000"
                    },
                    {
                        "id": 33642,
                        "name": "Chiprana",
                        "latitude": "41.26317000",
                        "longitude": "-0.12741000"
                    },
                    {
                        "id": 33645,
                        "name": "Chodes",
                        "latitude": "41.48696000",
                        "longitude": "-1.48012000"
                    },
                    {
                        "id": 33675,
                        "name": "Cimballa",
                        "latitude": "41.10118000",
                        "longitude": "-1.77352000"
                    },
                    {
                        "id": 33676,
                        "name": "Cinco Olivas",
                        "latitude": "41.33966000",
                        "longitude": "-0.37116000"
                    },
                    {
                        "id": 33704,
                        "name": "Clarés de Ribota",
                        "latitude": "41.52957000",
                        "longitude": "-1.83773000"
                    },
                    {
                        "id": 152477,
                        "name": "Codo",
                        "latitude": "41.33454860",
                        "longitude": "-0.70043850"
                    },
                    {
                        "id": 33718,
                        "name": "Codos",
                        "latitude": "41.29266000",
                        "longitude": "-1.37425000"
                    },
                    {
                        "id": 33769,
                        "name": "Contamina",
                        "latitude": "41.30535000",
                        "longitude": "-1.91731000"
                    },
                    {
                        "id": 33823,
                        "name": "Cosuenda",
                        "latitude": "41.36559000",
                        "longitude": "-1.29867000"
                    },
                    {
                        "id": 33844,
                        "name": "Cuarte de Huerva",
                        "latitude": "41.59466000",
                        "longitude": "-0.93268000"
                    },
                    {
                        "id": 33846,
                        "name": "Cubel",
                        "latitude": "41.09604000",
                        "longitude": "-1.63729000"
                    },
                    {
                        "id": 152478,
                        "name": "Cuerlas Las",
                        "latitude": "40.95965000",
                        "longitude": "-1.55113230"
                    },
                    {
                        "id": 33913,
                        "name": "Daroca",
                        "latitude": "41.11475000",
                        "longitude": "-1.41492000"
                    },
                    {
                        "id": 33974,
                        "name": "Ejea de los Caballeros",
                        "latitude": "42.12632000",
                        "longitude": "-1.13716000"
                    },
                    {
                        "id": 34041,
                        "name": "Embid de Ariza",
                        "latitude": "41.37830000",
                        "longitude": "-1.97373000"
                    },
                    {
                        "id": 34045,
                        "name": "Encinacorba",
                        "latitude": "41.28516000",
                        "longitude": "-1.27516000"
                    },
                    {
                        "id": 38579,
                        "name": "Épila",
                        "latitude": "41.60045000",
                        "longitude": "-1.28007000"
                    },
                    {
                        "id": 34067,
                        "name": "Erla",
                        "latitude": "42.11732000",
                        "longitude": "-0.95019000"
                    },
                    {
                        "id": 34083,
                        "name": "Escatrón",
                        "latitude": "41.29149000",
                        "longitude": "-0.32308000"
                    },
                    {
                        "id": 34154,
                        "name": "Fabara",
                        "latitude": "41.17750000",
                        "longitude": "0.16908000"
                    },
                    {
                        "id": 34165,
                        "name": "Farlete",
                        "latitude": "41.68122000",
                        "longitude": "-0.50678000"
                    },
                    {
                        "id": 34170,
                        "name": "Fayón",
                        "latitude": "41.23851000",
                        "longitude": "0.33302000"
                    },
                    {
                        "id": 152479,
                        "name": "Fayos Los",
                        "latitude": "41.87886450",
                        "longitude": "-1.78340170"
                    },
                    {
                        "id": 34187,
                        "name": "Figueruelas",
                        "latitude": "41.76651000",
                        "longitude": "-1.17473000"
                    },
                    {
                        "id": 34202,
                        "name": "Fombuena",
                        "latitude": "41.14442000",
                        "longitude": "-1.19266000"
                    },
                    {
                        "id": 152480,
                        "name": "Frago El",
                        "latitude": "42.27253460",
                        "longitude": "-0.93131360"
                    },
                    {
                        "id": 152481,
                        "name": "Frasno El",
                        "latitude": "41.41466550",
                        "longitude": "-1.49605710"
                    },
                    {
                        "id": 34270,
                        "name": "Fréscano",
                        "latitude": "41.88333000",
                        "longitude": "-1.45000000"
                    },
                    {
                        "id": 34279,
                        "name": "Fuendejalón",
                        "latitude": "41.76050000",
                        "longitude": "-1.47213000"
                    },
                    {
                        "id": 34280,
                        "name": "Fuendetodos",
                        "latitude": "41.34245000",
                        "longitude": "-0.95988000"
                    },
                    {
                        "id": 34343,
                        "name": "Fuentes de Ebro",
                        "latitude": "41.51250000",
                        "longitude": "-0.63159000"
                    },
                    {
                        "id": 34344,
                        "name": "Fuentes de Jiloca",
                        "latitude": "41.22859000",
                        "longitude": "-1.53616000"
                    },
                    {
                        "id": 34395,
                        "name": "Gallocanta",
                        "latitude": "40.99624000",
                        "longitude": "-1.50774000"
                    },
                    {
                        "id": 34396,
                        "name": "Gallur",
                        "latitude": "41.86830000",
                        "longitude": "-1.31577000"
                    },
                    {
                        "id": 34447,
                        "name": "Gelsa",
                        "latitude": "41.40766000",
                        "longitude": "-0.46158000"
                    },
                    {
                        "id": 34476,
                        "name": "Godojos",
                        "latitude": "41.26838000",
                        "longitude": "-1.86410000"
                    },
                    {
                        "id": 34490,
                        "name": "Gotor",
                        "latitude": "41.54583000",
                        "longitude": "-1.64915000"
                    },
                    {
                        "id": 34514,
                        "name": "Grisel",
                        "latitude": "41.87109000",
                        "longitude": "-1.72794000"
                    },
                    {
                        "id": 34515,
                        "name": "Grisén",
                        "latitude": "41.74524000",
                        "longitude": "-1.16260000"
                    },
                    {
                        "id": 34598,
                        "name": "Herrera de los Navarros",
                        "latitude": "41.21024000",
                        "longitude": "-1.08271000"
                    },
                    {
                        "id": 34725,
                        "name": "Ibdes",
                        "latitude": "41.21667000",
                        "longitude": "-1.83333000"
                    },
                    {
                        "id": 34750,
                        "name": "Illueca",
                        "latitude": "41.53818000",
                        "longitude": "-1.62747000"
                    },
                    {
                        "id": 34769,
                        "name": "Isuerre",
                        "latitude": "42.48729000",
                        "longitude": "-1.05400000"
                    },
                    {
                        "id": 34796,
                        "name": "Jaraba",
                        "latitude": "41.19083000",
                        "longitude": "-1.88440000"
                    },
                    {
                        "id": 34803,
                        "name": "Jarque",
                        "latitude": "41.55613000",
                        "longitude": "-1.67563000"
                    },
                    {
                        "id": 34807,
                        "name": "Jaulín",
                        "latitude": "41.45198000",
                        "longitude": "-0.99256000"
                    },
                    {
                        "id": 152482,
                        "name": "Joyosa La",
                        "latitude": "41.74507510",
                        "longitude": "-1.07358060"
                    },
                    {
                        "id": 34941,
                        "name": "Lagata",
                        "latitude": "41.23970000",
                        "longitude": "-0.80487000"
                    },
                    {
                        "id": 34964,
                        "name": "Langa del Castillo",
                        "latitude": "41.21200000",
                        "longitude": "-1.39850000"
                    },
                    {
                        "id": 35005,
                        "name": "Layana",
                        "latitude": "42.29546000",
                        "longitude": "-1.24483000"
                    },
                    {
                        "id": 35176,
                        "name": "Lécera",
                        "latitude": "41.20491000",
                        "longitude": "-0.71133000"
                    },
                    {
                        "id": 35012,
                        "name": "Lechón",
                        "latitude": "41.08633000",
                        "longitude": "-1.28483000"
                    },
                    {
                        "id": 35013,
                        "name": "Leciñena",
                        "latitude": "41.79868000",
                        "longitude": "-0.61174000"
                    },
                    {
                        "id": 35038,
                        "name": "Letux",
                        "latitude": "41.25512000",
                        "longitude": "-0.80269000"
                    },
                    {
                        "id": 35057,
                        "name": "Litago",
                        "latitude": "41.81407000",
                        "longitude": "-1.75276000"
                    },
                    {
                        "id": 35058,
                        "name": "Lituénigo",
                        "latitude": "41.83533000",
                        "longitude": "-1.76196000"
                    },
                    {
                        "id": 35094,
                        "name": "Lobera de Onsella",
                        "latitude": "42.47848000",
                        "longitude": "-1.02208000"
                    },
                    {
                        "id": 35106,
                        "name": "Longares",
                        "latitude": "41.40308000",
                        "longitude": "-1.16876000"
                    },
                    {
                        "id": 35107,
                        "name": "Longás",
                        "latitude": "42.48092000",
                        "longitude": "-0.93420000"
                    },
                    {
                        "id": 35150,
                        "name": "Lucena de Jalón",
                        "latitude": "41.55301000",
                        "longitude": "-1.31305000"
                    },
                    {
                        "id": 35153,
                        "name": "Luceni",
                        "latitude": "41.82857000",
                        "longitude": "-1.23889000"
                    },
                    {
                        "id": 35157,
                        "name": "Luesia",
                        "latitude": "42.36974000",
                        "longitude": "-1.02421000"
                    },
                    {
                        "id": 35158,
                        "name": "Luesma",
                        "latitude": "41.16583000",
                        "longitude": "-1.14575000"
                    },
                    {
                        "id": 35165,
                        "name": "Lumpiaque",
                        "latitude": "41.62953000",
                        "longitude": "-1.30156000"
                    },
                    {
                        "id": 35166,
                        "name": "Luna",
                        "latitude": "42.16760000",
                        "longitude": "-0.93292000"
                    },
                    {
                        "id": 35197,
                        "name": "Maella",
                        "latitude": "41.12251000",
                        "longitude": "0.13926000"
                    },
                    {
                        "id": 35200,
                        "name": "Magallón",
                        "latitude": "41.83248000",
                        "longitude": "-1.45979000"
                    },
                    {
                        "id": 35210,
                        "name": "Mainar",
                        "latitude": "41.19275000",
                        "longitude": "-1.30292000"
                    },
                    {
                        "id": 35220,
                        "name": "Malanquilla",
                        "latitude": "41.56856000",
                        "longitude": "-1.87481000"
                    },
                    {
                        "id": 35222,
                        "name": "Maleján",
                        "latitude": "41.82762000",
                        "longitude": "-1.54906000"
                    },
                    {
                        "id": 35224,
                        "name": "Mallén",
                        "latitude": "41.90064000",
                        "longitude": "-1.41994000"
                    },
                    {
                        "id": 35234,
                        "name": "Malón",
                        "latitude": "41.95235000",
                        "longitude": "-1.67199000"
                    },
                    {
                        "id": 35232,
                        "name": "Maluenda",
                        "latitude": "41.28772000",
                        "longitude": "-1.61603000"
                    },
                    {
                        "id": 35244,
                        "name": "Manchones",
                        "latitude": "41.15000000",
                        "longitude": "-1.46667000"
                    },
                    {
                        "id": 35274,
                        "name": "Mara",
                        "latitude": "41.28950000",
                        "longitude": "-1.51842000"
                    },
                    {
                        "id": 35313,
                        "name": "María de Huerva",
                        "latitude": "41.53880000",
                        "longitude": "-0.99615000"
                    },
                    {
                        "id": 35296,
                        "name": "Marracos",
                        "latitude": "42.08826000",
                        "longitude": "-0.77587000"
                    },
                    {
                        "id": 152483,
                        "name": "Mediana de Aragón",
                        "latitude": "41.46597150",
                        "longitude": "-0.70874620"
                    },
                    {
                        "id": 152484,
                        "name": "Mequinenza",
                        "latitude": "41.37199710",
                        "longitude": "0.30075330"
                    },
                    {
                        "id": 35411,
                        "name": "Mesones de Isuela",
                        "latitude": "41.55119000",
                        "longitude": "-1.53858000"
                    },
                    {
                        "id": 35414,
                        "name": "Mezalocha",
                        "latitude": "41.42581000",
                        "longitude": "-1.08276000"
                    },
                    {
                        "id": 35417,
                        "name": "Mianos",
                        "latitude": "42.58544000",
                        "longitude": "-0.95478000"
                    },
                    {
                        "id": 152485,
                        "name": "Miedes de Aragón",
                        "latitude": "41.25743860",
                        "longitude": "-1.49061400"
                    },
                    {
                        "id": 35508,
                        "name": "Monegrillo",
                        "latitude": "41.63856000",
                        "longitude": "-0.41570000"
                    },
                    {
                        "id": 35510,
                        "name": "Moneva",
                        "latitude": "41.12817000",
                        "longitude": "-0.83591000"
                    },
                    {
                        "id": 35521,
                        "name": "Monreal de Ariza",
                        "latitude": "41.29165000",
                        "longitude": "-2.10493000"
                    },
                    {
                        "id": 35563,
                        "name": "Monterde",
                        "latitude": "41.17434000",
                        "longitude": "-1.73505000"
                    },
                    {
                        "id": 35589,
                        "name": "Montón",
                        "latitude": "41.20667000",
                        "longitude": "-1.51550000"
                    },
                    {
                        "id": 35614,
                        "name": "Morata de Jalón",
                        "latitude": "41.47348000",
                        "longitude": "-1.47628000"
                    },
                    {
                        "id": 35615,
                        "name": "Morata de Jiloca",
                        "latitude": "41.24797000",
                        "longitude": "-1.58665000"
                    },
                    {
                        "id": 35634,
                        "name": "Morés",
                        "latitude": "41.47326000",
                        "longitude": "-1.56491000"
                    },
                    {
                        "id": 35633,
                        "name": "Moros",
                        "latitude": "41.39775000",
                        "longitude": "-1.82839000"
                    },
                    {
                        "id": 35648,
                        "name": "Moyuela",
                        "latitude": "41.12792000",
                        "longitude": "-0.92225000"
                    },
                    {
                        "id": 35650,
                        "name": "Mozota",
                        "latitude": "41.48410000",
                        "longitude": "-1.06807000"
                    },
                    {
                        "id": 35655,
                        "name": "Muel",
                        "latitude": "41.46633000",
                        "longitude": "-1.08503000"
                    },
                    {
                        "id": 152486,
                        "name": "Muela La",
                        "latitude": "41.57581840",
                        "longitude": "-1.11611660"
                    },
                    {
                        "id": 35667,
                        "name": "Munébrega",
                        "latitude": "41.25203000",
                        "longitude": "-1.70557000"
                    },
                    {
                        "id": 35672,
                        "name": "Murero",
                        "latitude": "41.15967000",
                        "longitude": "-1.48275000"
                    },
                    {
                        "id": 152487,
                        "name": "Murillo de Gállego",
                        "latitude": "42.33633910",
                        "longitude": "-0.75179560"
                    },
                    {
                        "id": 35766,
                        "name": "Navardún",
                        "latitude": "42.51255000",
                        "longitude": "-1.14822000"
                    },
                    {
                        "id": 35810,
                        "name": "Nigüella",
                        "latitude": "41.53621000",
                        "longitude": "-1.52450000"
                    },
                    {
                        "id": 35823,
                        "name": "Nombrevilla",
                        "latitude": "41.10730000",
                        "longitude": "-1.35904000"
                    },
                    {
                        "id": 35824,
                        "name": "Nonaspe",
                        "latitude": "41.20881000",
                        "longitude": "0.24775000"
                    },
                    {
                        "id": 35827,
                        "name": "Novallas",
                        "latitude": "41.95000000",
                        "longitude": "-1.70000000"
                    },
                    {
                        "id": 35830,
                        "name": "Novillas",
                        "latitude": "41.93334000",
                        "longitude": "-1.39412000"
                    },
                    {
                        "id": 35839,
                        "name": "Nuévalos",
                        "latitude": "41.21185000",
                        "longitude": "-1.78954000"
                    },
                    {
                        "id": 35836,
                        "name": "Nuez de Ebro",
                        "latitude": "41.58957000",
                        "longitude": "-0.66774000"
                    },
                    {
                        "id": 35918,
                        "name": "Olvés",
                        "latitude": "41.23965000",
                        "longitude": "-1.64647000"
                    },
                    {
                        "id": 35935,
                        "name": "Orcajo",
                        "latitude": "41.10975000",
                        "longitude": "-1.48933000"
                    },
                    {
                        "id": 35945,
                        "name": "Orera",
                        "latitude": "41.29842000",
                        "longitude": "-1.47849000"
                    },
                    {
                        "id": 35965,
                        "name": "Orés",
                        "latitude": "42.27765000",
                        "longitude": "-1.00150000"
                    },
                    {
                        "id": 35970,
                        "name": "Oseja",
                        "latitude": "41.59564000",
                        "longitude": "-1.70026000"
                    },
                    {
                        "id": 152488,
                        "name": "Osera de Ebro",
                        "latitude": "41.53418600",
                        "longitude": "-0.57957800"
                    },
                    {
                        "id": 36048,
                        "name": "Paniza",
                        "latitude": "41.28400000",
                        "longitude": "-1.21224000"
                    },
                    {
                        "id": 36054,
                        "name": "Paracuellos de Jiloca",
                        "latitude": "41.31378000",
                        "longitude": "-1.64029000"
                    },
                    {
                        "id": 36055,
                        "name": "Paracuellos de la Ribera",
                        "latitude": "41.42273000",
                        "longitude": "-1.56245000"
                    },
                    {
                        "id": 152489,
                        "name": "Pastriz",
                        "latitude": "41.61876010",
                        "longitude": "-0.78265240"
                    },
                    {
                        "id": 36103,
                        "name": "Pedrola",
                        "latitude": "41.79102000",
                        "longitude": "-1.21357000"
                    },
                    {
                        "id": 152490,
                        "name": "Pedrosas Las",
                        "latitude": "42.02535010",
                        "longitude": "-0.87704730"
                    },
                    {
                        "id": 36146,
                        "name": "Perdiguera",
                        "latitude": "41.75458000",
                        "longitude": "-0.63148000"
                    },
                    {
                        "id": 36185,
                        "name": "Piedratajada",
                        "latitude": "42.12124000",
                        "longitude": "-0.80373000"
                    },
                    {
                        "id": 36190,
                        "name": "Pina de Ebro",
                        "latitude": "41.48846000",
                        "longitude": "-0.53120000"
                    },
                    {
                        "id": 36214,
                        "name": "Pinseque",
                        "latitude": "41.73657000",
                        "longitude": "-1.10041000"
                    },
                    {
                        "id": 152491,
                        "name": "Pintanos Los",
                        "latitude": "42.52698800",
                        "longitude": "-1.00119020"
                    },
                    {
                        "id": 36237,
                        "name": "Plasencia de Jalón",
                        "latitude": "41.68154000",
                        "longitude": "-1.22996000"
                    },
                    {
                        "id": 36242,
                        "name": "Pleitas",
                        "latitude": "41.71135000",
                        "longitude": "-1.20251000"
                    },
                    {
                        "id": 36243,
                        "name": "Plenas",
                        "latitude": "41.11209000",
                        "longitude": "-0.96442000"
                    },
                    {
                        "id": 36269,
                        "name": "Pomer",
                        "latitude": "41.63765000",
                        "longitude": "-1.84104000"
                    },
                    {
                        "id": 36328,
                        "name": "Pozuel de Ariza",
                        "latitude": "41.35000000",
                        "longitude": "-2.15000000"
                    },
                    {
                        "id": 36332,
                        "name": "Pozuelo de Aragón",
                        "latitude": "41.76430000",
                        "longitude": "-1.42305000"
                    },
                    {
                        "id": 36342,
                        "name": "Pradilla de Ebro",
                        "latitude": "41.86111000",
                        "longitude": "-1.26325000"
                    },
                    {
                        "id": 36408,
                        "name": "Puebla de Albortón",
                        "latitude": "41.38517000",
                        "longitude": "-0.85558000"
                    },
                    {
                        "id": 152492,
                        "name": "Puebla de Alfindén La",
                        "latitude": "41.63484600",
                        "longitude": "-0.74829500"
                    },
                    {
                        "id": 152493,
                        "name": "Puendeluna",
                        "latitude": "42.15308020",
                        "longitude": "-0.75758860"
                    },
                    {
                        "id": 36476,
                        "name": "Purujosa",
                        "latitude": "41.68259000",
                        "longitude": "-1.76519000"
                    },
                    {
                        "id": 36528,
                        "name": "Quinto",
                        "latitude": "41.42378000",
                        "longitude": "-0.49592000"
                    },
                    {
                        "id": 36573,
                        "name": "Remolinos",
                        "latitude": "41.83946000",
                        "longitude": "-1.17768000"
                    },
                    {
                        "id": 36585,
                        "name": "Retascón",
                        "latitude": "41.14350000",
                        "longitude": "-1.38376000"
                    },
                    {
                        "id": 36620,
                        "name": "Ricla",
                        "latitude": "41.50580000",
                        "longitude": "-1.40468000"
                    },
                    {
                        "id": 36672,
                        "name": "Romanos",
                        "latitude": "41.12636000",
                        "longitude": "-1.27502000"
                    },
                    {
                        "id": 152494,
                        "name": "Rueda de Jalón",
                        "latitude": "41.63343360",
                        "longitude": "-1.27405900"
                    },
                    {
                        "id": 36700,
                        "name": "Ruesca",
                        "latitude": "41.28350000",
                        "longitude": "-1.48142000"
                    },
                    {
                        "id": 152496,
                        "name": "Sabiñán",
                        "latitude": "41.64585140",
                        "longitude": "-0.92787110"
                    },
                    {
                        "id": 37335,
                        "name": "Sádaba",
                        "latitude": "42.28180000",
                        "longitude": "-1.26951000"
                    },
                    {
                        "id": 36762,
                        "name": "Salillas de Jalón",
                        "latitude": "41.56789000",
                        "longitude": "-1.32344000"
                    },
                    {
                        "id": 36784,
                        "name": "Salvatierra de Esca",
                        "latitude": "42.67002000",
                        "longitude": "-1.00475000"
                    },
                    {
                        "id": 36794,
                        "name": "Samper del Salz",
                        "latitude": "41.23458000",
                        "longitude": "-0.82510000"
                    },
                    {
                        "id": 152495,
                        "name": "San Martín de la Virgen de Moncayo",
                        "latitude": "41.83375390",
                        "longitude": "-1.79040420"
                    },
                    {
                        "id": 36878,
                        "name": "San Mateo de Gállego",
                        "latitude": "41.83043000",
                        "longitude": "-0.76578000"
                    },
                    {
                        "id": 37029,
                        "name": "Santa Cruz de Grío",
                        "latitude": "41.37050000",
                        "longitude": "-1.43009000"
                    },
                    {
                        "id": 37030,
                        "name": "Santa Cruz de Moncayo",
                        "latitude": "41.88240000",
                        "longitude": "-1.75637000"
                    },
                    {
                        "id": 37056,
                        "name": "Santa Eulalia de Gállego",
                        "latitude": "42.28700000",
                        "longitude": "-0.76065000"
                    },
                    {
                        "id": 37109,
                        "name": "Santed",
                        "latitude": "41.03172000",
                        "longitude": "-1.51028000"
                    },
                    {
                        "id": 37336,
                        "name": "Sástago",
                        "latitude": "41.32166000",
                        "longitude": "-0.35075000"
                    },
                    {
                        "id": 37189,
                        "name": "Sediles",
                        "latitude": "41.34613000",
                        "longitude": "-1.53177000"
                    },
                    {
                        "id": 37234,
                        "name": "Sestrica",
                        "latitude": "41.48595000",
                        "longitude": "-1.59501000"
                    },
                    {
                        "id": 37245,
                        "name": "Sierra de Luna",
                        "latitude": "42.04818000",
                        "longitude": "-0.91025000"
                    },
                    {
                        "id": 37253,
                        "name": "Sigüés",
                        "latitude": "42.63030000",
                        "longitude": "-1.01212000"
                    },
                    {
                        "id": 37265,
                        "name": "Sisamón",
                        "latitude": "41.17124000",
                        "longitude": "-2.00386000"
                    },
                    {
                        "id": 37272,
                        "name": "Sobradiel",
                        "latitude": "41.73875000",
                        "longitude": "-1.03765000"
                    },
                    {
                        "id": 37307,
                        "name": "Sos del Rey Católico",
                        "latitude": "42.49686000",
                        "longitude": "-1.21514000"
                    },
                    {
                        "id": 37346,
                        "name": "Tabuenca",
                        "latitude": "41.69500000",
                        "longitude": "-1.54335000"
                    },
                    {
                        "id": 37355,
                        "name": "Talamantes",
                        "latitude": "41.73051000",
                        "longitude": "-1.67857000"
                    },
                    {
                        "id": 37374,
                        "name": "Tarazona",
                        "latitude": "41.90475000",
                        "longitude": "-1.72678000"
                    },
                    {
                        "id": 37385,
                        "name": "Tauste",
                        "latitude": "41.91804000",
                        "longitude": "-1.25343000"
                    },
                    {
                        "id": 37411,
                        "name": "Terrer",
                        "latitude": "41.32811000",
                        "longitude": "-1.71329000"
                    },
                    {
                        "id": 152497,
                        "name": "Tierga",
                        "latitude": "41.60810520",
                        "longitude": "-1.60506550"
                    },
                    {
                        "id": 37437,
                        "name": "Tobed",
                        "latitude": "41.33866000",
                        "longitude": "-1.39975000"
                    },
                    {
                        "id": 37483,
                        "name": "Torralba de los Frailes",
                        "latitude": "41.03622000",
                        "longitude": "-1.66046000"
                    },
                    {
                        "id": 37482,
                        "name": "Torralba de Ribota",
                        "latitude": "41.41803000",
                        "longitude": "-1.68429000"
                    },
                    {
                        "id": 37486,
                        "name": "Torralbilla",
                        "latitude": "41.21009000",
                        "longitude": "-1.33800000"
                    },
                    {
                        "id": 37534,
                        "name": "Torrehermosa",
                        "latitude": "41.23767000",
                        "longitude": "-2.12800000"
                    },
                    {
                        "id": 37544,
                        "name": "Torrelapaja",
                        "latitude": "41.58133000",
                        "longitude": "-1.95181000"
                    },
                    {
                        "id": 37548,
                        "name": "Torrellas",
                        "latitude": "41.89444000",
                        "longitude": "-1.77139000"
                    },
                    {
                        "id": 37575,
                        "name": "Torres de Berrellén",
                        "latitude": "41.75797000",
                        "longitude": "-1.06550000"
                    },
                    {
                        "id": 37587,
                        "name": "Torrijo de la Cañada",
                        "latitude": "41.47304000",
                        "longitude": "-1.87441000"
                    },
                    {
                        "id": 37603,
                        "name": "Tosos",
                        "latitude": "41.31542000",
                        "longitude": "-1.07292000"
                    },
                    {
                        "id": 37621,
                        "name": "Trasmoz",
                        "latitude": "41.82599000",
                        "longitude": "-1.72279000"
                    },
                    {
                        "id": 37622,
                        "name": "Trasobares",
                        "latitude": "41.64308000",
                        "longitude": "-1.64192000"
                    },
                    {
                        "id": 37687,
                        "name": "Uncastillo",
                        "latitude": "42.35963000",
                        "longitude": "-1.12842000"
                    },
                    {
                        "id": 37688,
                        "name": "Undués de Lerda",
                        "latitude": "42.56572000",
                        "longitude": "-1.16944000"
                    },
                    {
                        "id": 37695,
                        "name": "Urrea de Jalón",
                        "latitude": "41.66715000",
                        "longitude": "-1.23420000"
                    },
                    {
                        "id": 37696,
                        "name": "Urriés",
                        "latitude": "42.51943000",
                        "longitude": "-1.13022000"
                    },
                    {
                        "id": 37704,
                        "name": "Used",
                        "latitude": "41.05554000",
                        "longitude": "-1.55954000"
                    },
                    {
                        "id": 37708,
                        "name": "Utebo",
                        "latitude": "41.70826000",
                        "longitude": "-0.99916000"
                    },
                    {
                        "id": 37720,
                        "name": "Val de San Martín",
                        "latitude": "41.05787000",
                        "longitude": "-1.44934000"
                    },
                    {
                        "id": 37751,
                        "name": "Valdehorna",
                        "latitude": "41.07275000",
                        "longitude": "-1.42376000"
                    },
                    {
                        "id": 37867,
                        "name": "Valmadrid",
                        "latitude": "41.44351000",
                        "longitude": "-0.88482000"
                    },
                    {
                        "id": 37871,
                        "name": "Valpalmas",
                        "latitude": "42.15821000",
                        "longitude": "-0.85481000"
                    },
                    {
                        "id": 37880,
                        "name": "Valtorres",
                        "latitude": "41.29855000",
                        "longitude": "-1.74080000"
                    },
                    {
                        "id": 37929,
                        "name": "Velilla de Ebro",
                        "latitude": "41.37416000",
                        "longitude": "-0.43483000"
                    },
                    {
                        "id": 37930,
                        "name": "Velilla de Jiloca",
                        "latitude": "41.27509000",
                        "longitude": "-1.60396000"
                    },
                    {
                        "id": 37948,
                        "name": "Vera de Moncayo",
                        "latitude": "41.82400000",
                        "longitude": "-1.68799000"
                    },
                    {
                        "id": 37969,
                        "name": "Vierlas",
                        "latitude": "41.92708000",
                        "longitude": "-1.68123000"
                    },
                    {
                        "id": 38042,
                        "name": "Villadoz",
                        "latitude": "41.16234000",
                        "longitude": "-1.28800000"
                    },
                    {
                        "id": 38050,
                        "name": "Villafeliche",
                        "latitude": "41.19509000",
                        "longitude": "-1.50983000"
                    },
                    {
                        "id": 38058,
                        "name": "Villafranca de Ebro",
                        "latitude": "41.57473000",
                        "longitude": "-0.65039000"
                    },
                    {
                        "id": 38094,
                        "name": "Villalba de Perejil",
                        "latitude": "41.32742000",
                        "longitude": "-1.54833000"
                    },
                    {
                        "id": 38112,
                        "name": "Villalengua",
                        "latitude": "41.43548000",
                        "longitude": "-1.84125000"
                    },
                    {
                        "id": 38142,
                        "name": "Villamayor de Gállego",
                        "latitude": "41.68584000",
                        "longitude": "-0.77230000"
                    },
                    {
                        "id": 38184,
                        "name": "Villanueva de Gállego",
                        "latitude": "41.76917000",
                        "longitude": "-0.82350000"
                    },
                    {
                        "id": 152499,
                        "name": "Villanueva de Huerva",
                        "latitude": "41.35308610",
                        "longitude": "-1.03603260"
                    },
                    {
                        "id": 38186,
                        "name": "Villanueva de Jiloca",
                        "latitude": "41.07625000",
                        "longitude": "-1.38960000"
                    },
                    {
                        "id": 38249,
                        "name": "Villar de los Navarros",
                        "latitude": "41.15949000",
                        "longitude": "-1.04199000"
                    },
                    {
                        "id": 38295,
                        "name": "Villarreal de Huerva",
                        "latitude": "41.19034000",
                        "longitude": "-1.28983000"
                    },
                    {
                        "id": 38298,
                        "name": "Villarroya de la Sierra",
                        "latitude": "41.46346000",
                        "longitude": "-1.78350000"
                    },
                    {
                        "id": 38300,
                        "name": "Villarroya del Campo",
                        "latitude": "41.14309000",
                        "longitude": "-1.32416000"
                    },
                    {
                        "id": 152498,
                        "name": "Vilueña La",
                        "latitude": "41.27235080",
                        "longitude": "-1.72650980"
                    },
                    {
                        "id": 38399,
                        "name": "Vistabella",
                        "latitude": "41.21850000",
                        "longitude": "-1.15358000"
                    },
                    {
                        "id": 152500,
                        "name": "Zaida La",
                        "latitude": "41.32585200",
                        "longitude": "-0.42724770"
                    },
                    {
                        "id": 38470,
                        "name": "Zaragoza",
                        "latitude": "41.65606000",
                        "longitude": "-0.87734000"
                    },
                    {
                        "id": 38504,
                        "name": "Zuera",
                        "latitude": "41.86775000",
                        "longitude": "-0.78984000"
                    }
                ]
            }
        ]
    },
    {
        "id": 208,
        "name": "Sri Lanka",
        "iso3": "LKA",
        "iso2": "LK",
        "numeric_code": "144",
        "phonecode": "94",
        "capital": "Colombo",
        "currency": "LKR",
        "currency_name": "Sri Lankan rupee",
        "currency_symbol": "Rs",
        "tld": ".lk",
        "native": "śrī laṃkāva",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Southern Asia",
        "subregion_id": 14,
        "nationality": "Sri Lankan",
        "timezones": [
            {
                "zoneName": "Asia\/Colombo",
                "gmtOffset": 19800,
                "gmtOffsetName": "UTC+05:30",
                "abbreviation": "IST",
                "tzName": "Indian Standard Time"
            }
        ],
        "translations": {
            "br": "Sri Lanka",
            "ko": "스리랑카",
            "pt-BR": "Sri Lanka",
            "pt": "Sri Lanka",
            "nl": "Sri Lanka",
            "hr": "Šri Lanka",
            "fa": "سری‌لانکا",
            "de": "Sri Lanka",
            "es": "Sri Lanka",
            "fr": "Sri Lanka",
            "ja": "スリランカ",
            "it": "Sri Lanka",
            "zh-CN": "斯里兰卡",
            "tr": "Sri Lanka",
            "ru": "Шри-Ланка",
            "uk": "Шрі-Ланка",
            "pl": "Sri Lanka"
        },
        "latitude": "7.00000000",
        "longitude": "81.00000000",
        "emoji": "🇱🇰",
        "emojiU": "U+1F1F1 U+1F1F0",
        "states": [
            {
                "id": 2799,
                "name": "Ampara",
                "iso2": "52",
                "latitude": "7.29116850",
                "longitude": "81.67237610",
                "type": "district",
                "cities": []
            },
            {
                "id": 2816,
                "name": "Anuradhapura",
                "iso2": "71",
                "latitude": "8.33183050",
                "longitude": "80.40290170",
                "type": "district",
                "cities": []
            },
            {
                "id": 2790,
                "name": "Badulla",
                "iso2": "81",
                "latitude": "6.99340090",
                "longitude": "81.05498150",
                "type": "district",
                "cities": []
            },
            {
                "id": 2818,
                "name": "Batticaloa",
                "iso2": "51",
                "latitude": "7.82927810",
                "longitude": "81.47183870",
                "type": "district",
                "cities": []
            },
            {
                "id": 2798,
                "name": "Central",
                "iso2": "2",
                "latitude": "7.38164450",
                "longitude": "80.05812960",
                "type": "province",
                "cities": [
                    {
                        "id": 66463,
                        "name": "Dambulla",
                        "latitude": "7.86000000",
                        "longitude": "80.65167000"
                    },
                    {
                        "id": 66476,
                        "name": "Hatton",
                        "latitude": "6.89160000",
                        "longitude": "80.59550000"
                    },
                    {
                        "id": 66489,
                        "name": "Kandy",
                        "latitude": "7.29060000",
                        "longitude": "80.63360000"
                    },
                    {
                        "id": 66490,
                        "name": "Kandy District",
                        "latitude": "7.30440000",
                        "longitude": "80.70730000"
                    },
                    {
                        "id": 66505,
                        "name": "Matale",
                        "latitude": "7.46980000",
                        "longitude": "80.62170000"
                    },
                    {
                        "id": 66506,
                        "name": "Matale District",
                        "latitude": "7.65980000",
                        "longitude": "80.70730000"
                    },
                    {
                        "id": 66517,
                        "name": "Nuwara Eliya",
                        "latitude": "6.97078000",
                        "longitude": "80.78286000"
                    },
                    {
                        "id": 66518,
                        "name": "Nuwara Eliya District",
                        "latitude": "6.97850000",
                        "longitude": "80.71330000"
                    },
                    {
                        "id": 66529,
                        "name": "Sigiriya",
                        "latitude": "7.94946000",
                        "longitude": "80.75037000"
                    },
                    {
                        "id": 66531,
                        "name": "Talawakele",
                        "latitude": "6.93710000",
                        "longitude": "80.65810000"
                    }
                ]
            },
            {
                "id": 2815,
                "name": "Colombo",
                "iso2": "11",
                "latitude": "6.92695570",
                "longitude": "79.86173060",
                "type": "district",
                "cities": [
                    {
                        "id": 66464,
                        "name": "Dehiwala-Mount Lavinia",
                        "latitude": "6.84019000",
                        "longitude": "79.87116000"
                    },
                    {
                        "id": 66479,
                        "name": "Homagama",
                        "latitude": "6.84879896",
                        "longitude": "80.00467300"
                    },
                    {
                        "id": 146181,
                        "name": "Kaduwela",
                        "latitude": "6.93106260",
                        "longitude": "79.97944220"
                    },
                    {
                        "id": 146180,
                        "name": "Kesbewa",
                        "latitude": "6.78425894",
                        "longitude": "79.94665276"
                    },
                    {
                        "id": 66499,
                        "name": "Kolonnawa",
                        "latitude": "6.92893463",
                        "longitude": "79.89495168"
                    },
                    {
                        "id": 146176,
                        "name": "Kotte",
                        "latitude": "6.88932048",
                        "longitude": "79.90359501"
                    },
                    {
                        "id": 66504,
                        "name": "Maharagama",
                        "latitude": "6.84954886",
                        "longitude": "79.92507313"
                    },
                    {
                        "id": 66514,
                        "name": "Moratuwa",
                        "latitude": "6.78149272",
                        "longitude": "79.88347117"
                    },
                    {
                        "id": 146179,
                        "name": "Padukka",
                        "latitude": "6.84794680",
                        "longitude": "80.10153292"
                    },
                    {
                        "id": 146178,
                        "name": "Ratmalana",
                        "latitude": "6.82105987",
                        "longitude": "79.88023083"
                    },
                    {
                        "id": 146177,
                        "name": "Seethawaka",
                        "latitude": "6.92959912",
                        "longitude": "80.14979867"
                    },
                    {
                        "id": 146175,
                        "name": "Thimbirigasyaya",
                        "latitude": "6.90214217",
                        "longitude": "79.86957578"
                    }
                ]
            },
            {
                "id": 2808,
                "name": "Eastern",
                "iso2": "5",
                "latitude": "7.74871760",
                "longitude": "79.99362660",
                "type": "province",
                "cities": [
                    {
                        "id": 66449,
                        "name": "Ampara",
                        "latitude": "7.29754000",
                        "longitude": "81.68202000"
                    },
                    {
                        "id": 66450,
                        "name": "Ampara District",
                        "latitude": "7.08330000",
                        "longitude": "81.75000000"
                    },
                    {
                        "id": 66456,
                        "name": "Batticaloa",
                        "latitude": "7.71020000",
                        "longitude": "81.69240000"
                    },
                    {
                        "id": 66457,
                        "name": "Batticaloa District",
                        "latitude": "7.75000000",
                        "longitude": "81.49970000"
                    },
                    {
                        "id": 66467,
                        "name": "Eravur Town",
                        "latitude": "7.77820000",
                        "longitude": "81.60380000"
                    },
                    {
                        "id": 66486,
                        "name": "Kalmunai",
                        "latitude": "7.40902000",
                        "longitude": "81.83472000"
                    },
                    {
                        "id": 66534,
                        "name": "Trincomalee",
                        "latitude": "8.57780000",
                        "longitude": "81.22890000"
                    },
                    {
                        "id": 66535,
                        "name": "Trincomalee District",
                        "latitude": "8.58333000",
                        "longitude": "81.08333000"
                    },
                    {
                        "id": 66537,
                        "name": "Vakarai",
                        "latitude": "8.13333000",
                        "longitude": "81.43333000"
                    }
                ]
            },
            {
                "id": 2792,
                "name": "Galle",
                "iso2": "31",
                "latitude": "6.05774900",
                "longitude": "80.21755720",
                "type": "district",
                "cities": []
            },
            {
                "id": 2804,
                "name": "Gampaha",
                "iso2": "12",
                "latitude": "7.07126190",
                "longitude": "80.00877460",
                "type": "district",
                "cities": []
            },
            {
                "id": 2791,
                "name": "Hambantota",
                "iso2": "33",
                "latitude": "6.15358160",
                "longitude": "81.12714900",
                "type": "district",
                "cities": []
            },
            {
                "id": 2787,
                "name": "Jaffna",
                "iso2": "41",
                "latitude": "9.69304680",
                "longitude": "80.16518540",
                "type": "district",
                "cities": []
            },
            {
                "id": 2789,
                "name": "Kalutara",
                "iso2": "13",
                "latitude": "6.60846860",
                "longitude": "80.14285840",
                "type": "district",
                "cities": []
            },
            {
                "id": 2788,
                "name": "Kandy",
                "iso2": "21",
                "latitude": "7.29315880",
                "longitude": "80.63501070",
                "type": "district",
                "cities": [
                    {
                        "id": 146174,
                        "name": "Akurana",
                        "latitude": "7.36500000",
                        "longitude": "80.61722200"
                    },
                    {
                        "id": 146150,
                        "name": "Alawatugoda",
                        "latitude": "7.41048962",
                        "longitude": "80.60918933"
                    },
                    {
                        "id": 146149,
                        "name": "Ambatenna",
                        "latitude": "7.35252855",
                        "longitude": "80.61378113"
                    },
                    {
                        "id": 146148,
                        "name": "Daskara",
                        "latitude": "7.20902217",
                        "longitude": "80.57764643"
                    },
                    {
                        "id": 146147,
                        "name": "Daulagala",
                        "latitude": "7.22882494",
                        "longitude": "80.57756073"
                    },
                    {
                        "id": 146173,
                        "name": "Delthota",
                        "latitude": "7.18491721",
                        "longitude": "80.70488697"
                    },
                    {
                        "id": 146172,
                        "name": "Doluwa",
                        "latitude": "7.18518536",
                        "longitude": "80.60573450"
                    },
                    {
                        "id": 146146,
                        "name": "Galagedara",
                        "latitude": "7.36833300",
                        "longitude": "80.52750000"
                    },
                    {
                        "id": 146145,
                        "name": "Galhinna",
                        "latitude": "7.41614200",
                        "longitude": "80.56884200"
                    },
                    {
                        "id": 66472,
                        "name": "Gampola",
                        "latitude": "7.16430000",
                        "longitude": "80.56960000"
                    },
                    {
                        "id": 146171,
                        "name": "Ganga Ihala Korale",
                        "latitude": "7.11455516",
                        "longitude": "80.51448810"
                    },
                    {
                        "id": 146144,
                        "name": "Hanguranketa",
                        "latitude": "7.16666700",
                        "longitude": "80.78333300"
                    },
                    {
                        "id": 146143,
                        "name": "Hapugastalawa",
                        "latitude": "7.05872498",
                        "longitude": "80.57137014"
                    },
                    {
                        "id": 146170,
                        "name": "Harispattuwa",
                        "latitude": "7.33016007",
                        "longitude": "80.58765149"
                    },
                    {
                        "id": 146169,
                        "name": "Hatharaliyadda",
                        "latitude": "7.33032982",
                        "longitude": "80.47875881"
                    },
                    {
                        "id": 66485,
                        "name": "Kadugannawa",
                        "latitude": "7.25470000",
                        "longitude": "80.52420000"
                    },
                    {
                        "id": 146168,
                        "name": "Kandy Four Gravets",
                        "latitude": "7.28318748",
                        "longitude": "80.63527585"
                    },
                    {
                        "id": 146153,
                        "name": "Katugastota",
                        "latitude": "7.33333300",
                        "longitude": "80.61666700"
                    },
                    {
                        "id": 146167,
                        "name": "Kundasale",
                        "latitude": "7.30391594",
                        "longitude": "80.71230408"
                    },
                    {
                        "id": 146142,
                        "name": "Madawala",
                        "latitude": "7.32833100",
                        "longitude": "80.67355200"
                    },
                    {
                        "id": 146166,
                        "name": "Medadumbara",
                        "latitude": "7.30425996",
                        "longitude": "80.77519844"
                    },
                    {
                        "id": 146141,
                        "name": "Menikdiwela",
                        "latitude": "7.08333300",
                        "longitude": "80.73333300"
                    },
                    {
                        "id": 146165,
                        "name": "Minipe",
                        "latitude": "7.22638754",
                        "longitude": "81.00116732"
                    },
                    {
                        "id": 146151,
                        "name": "Nawalapitiya",
                        "latitude": "7.03696481",
                        "longitude": "80.51626688"
                    },
                    {
                        "id": 146152,
                        "name": "Pallekele",
                        "latitude": "7.28333300",
                        "longitude": "80.70000000"
                    },
                    {
                        "id": 146164,
                        "name": "Panvila",
                        "latitude": "7.40929750",
                        "longitude": "80.73966228"
                    },
                    {
                        "id": 146163,
                        "name": "Pasbage Korale",
                        "latitude": "7.01510450",
                        "longitude": "80.54078073"
                    },
                    {
                        "id": 146162,
                        "name": "Pathadumbara",
                        "latitude": "7.34931196",
                        "longitude": "80.66303689"
                    },
                    {
                        "id": 146161,
                        "name": "Pathahewaheta",
                        "latitude": "7.23139207",
                        "longitude": "80.70848937"
                    },
                    {
                        "id": 146154,
                        "name": "Peradeniya",
                        "latitude": "7.26666700",
                        "longitude": "80.60000000"
                    },
                    {
                        "id": 146140,
                        "name": "Pilimathalawa",
                        "latitude": "7.27000000",
                        "longitude": "80.57000000"
                    },
                    {
                        "id": 146160,
                        "name": "Poojapitiya",
                        "latitude": "7.38093796",
                        "longitude": "80.58913708"
                    },
                    {
                        "id": 146139,
                        "name": "Pussellawa",
                        "latitude": "7.10533300",
                        "longitude": "80.63666700"
                    },
                    {
                        "id": 146138,
                        "name": "Talatuoya",
                        "latitude": "7.25000000",
                        "longitude": "80.68333300"
                    },
                    {
                        "id": 146137,
                        "name": "Teldeniya",
                        "latitude": "7.30000000",
                        "longitude": "80.76666700"
                    },
                    {
                        "id": 146159,
                        "name": "Thumpane",
                        "latitude": "7.36616728",
                        "longitude": "80.51587048"
                    },
                    {
                        "id": 146133,
                        "name": "Udadumbara",
                        "latitude": "7.35000000",
                        "longitude": "80.83333300"
                    },
                    {
                        "id": 146158,
                        "name": "Udapalatha",
                        "latitude": "7.11515526",
                        "longitude": "80.60248340"
                    },
                    {
                        "id": 146157,
                        "name": "Ududumbara",
                        "latitude": "7.31434839",
                        "longitude": "80.87707756"
                    },
                    {
                        "id": 146156,
                        "name": "Udunuwara",
                        "latitude": "7.22777866",
                        "longitude": "80.55894578"
                    },
                    {
                        "id": 146136,
                        "name": "Ulapane",
                        "latitude": "7.10277800",
                        "longitude": "80.56111100"
                    },
                    {
                        "id": 146135,
                        "name": "Watadeniya",
                        "latitude": "7.19501100",
                        "longitude": "80.55249400"
                    },
                    {
                        "id": 66542,
                        "name": "Wattegama",
                        "latitude": "7.35027800",
                        "longitude": "80.68250000"
                    },
                    {
                        "id": 146134,
                        "name": "Welamboda",
                        "latitude": "7.20000000",
                        "longitude": "80.55000000"
                    },
                    {
                        "id": 146155,
                        "name": "Yatinuwara",
                        "latitude": "7.28584509",
                        "longitude": "80.53516168"
                    }
                ]
            },
            {
                "id": 2797,
                "name": "Kegalle",
                "iso2": "92",
                "latitude": "7.12040530",
                "longitude": "80.32131060",
                "type": "district",
                "cities": []
            },
            {
                "id": 2793,
                "name": "Kilinochchi",
                "iso2": "42",
                "latitude": "9.36779710",
                "longitude": "80.32131060",
                "type": "district",
                "cities": []
            },
            {
                "id": 5342,
                "name": "Kurunegala",
                "iso2": "61",
                "latitude": "7.72856470",
                "longitude": "79.90891700",
                "type": "district",
                "cities": []
            },
            {
                "id": 2805,
                "name": "Mannar",
                "iso2": "43",
                "latitude": "8.98095310",
                "longitude": "79.90439750",
                "type": "district",
                "cities": []
            },
            {
                "id": 2810,
                "name": "Matale",
                "iso2": "22",
                "latitude": "7.46596460",
                "longitude": "80.62342590",
                "type": "district",
                "cities": []
            },
            {
                "id": 2806,
                "name": "Matara",
                "iso2": "32",
                "latitude": "5.94493480",
                "longitude": "80.54879970",
                "type": "district",
                "cities": []
            },
            {
                "id": 2819,
                "name": "Monaragala",
                "iso2": "82",
                "latitude": "6.87277810",
                "longitude": "81.35068320",
                "type": "district",
                "cities": []
            },
            {
                "id": 2814,
                "name": "Mullaitivu",
                "iso2": "45",
                "latitude": "9.26753880",
                "longitude": "80.81282540",
                "type": "district",
                "cities": []
            },
            {
                "id": 2800,
                "name": "North Central",
                "iso2": "7",
                "latitude": "8.19956380",
                "longitude": "80.63269160",
                "type": "province",
                "cities": [
                    {
                        "id": 66451,
                        "name": "Anuradhapura",
                        "latitude": "8.31223000",
                        "longitude": "80.41306000"
                    },
                    {
                        "id": 66452,
                        "name": "Anuradhapura District",
                        "latitude": "8.33333000",
                        "longitude": "80.50000000"
                    },
                    {
                        "id": 66509,
                        "name": "Mihintale",
                        "latitude": "8.35930000",
                        "longitude": "80.51030000"
                    },
                    {
                        "id": 66523,
                        "name": "Polonnaruwa",
                        "latitude": "7.93965000",
                        "longitude": "81.00274000"
                    },
                    {
                        "id": 66524,
                        "name": "Polonnaruwa District",
                        "latitude": "8.00000000",
                        "longitude": "81.00000000"
                    }
                ]
            },
            {
                "id": 2817,
                "name": "North Western",
                "iso2": "6",
                "latitude": "7.75840910",
                "longitude": "80.18750650",
                "type": "province",
                "cities": [
                    {
                        "id": 66460,
                        "name": "Chilaw",
                        "latitude": "7.57583000",
                        "longitude": "79.79528000"
                    },
                    {
                        "id": 66501,
                        "name": "Kuliyapitiya",
                        "latitude": "7.46880000",
                        "longitude": "80.04010000"
                    },
                    {
                        "id": 66502,
                        "name": "Kurunegala",
                        "latitude": "7.48390000",
                        "longitude": "80.36830000"
                    },
                    {
                        "id": 66503,
                        "name": "Kurunegala District",
                        "latitude": "7.75000000",
                        "longitude": "80.25000000"
                    },
                    {
                        "id": 66525,
                        "name": "Puttalam",
                        "latitude": "8.03620000",
                        "longitude": "79.82830000"
                    },
                    {
                        "id": 66526,
                        "name": "Puttalam District",
                        "latitude": "8.04540000",
                        "longitude": "79.93190000"
                    }
                ]
            },
            {
                "id": 2813,
                "name": "Northern",
                "iso2": "4",
                "latitude": "9.37238330",
                "longitude": "79.84713770",
                "type": "province",
                "cities": [
                    {
                        "id": 66483,
                        "name": "Jaffna",
                        "latitude": "9.66845000",
                        "longitude": "80.00742000"
                    },
                    {
                        "id": 66484,
                        "name": "Jaffna District",
                        "latitude": "9.75000000",
                        "longitude": "80.08333000"
                    },
                    {
                        "id": 66496,
                        "name": "Kilinochchi",
                        "latitude": "9.39610000",
                        "longitude": "80.39820000"
                    },
                    {
                        "id": 66497,
                        "name": "Kilinochchi District",
                        "latitude": "9.39487000",
                        "longitude": "80.40894000"
                    },
                    {
                        "id": 66522,
                        "name": "Point Pedro",
                        "latitude": "9.81667000",
                        "longitude": "80.23333000"
                    },
                    {
                        "id": 66538,
                        "name": "Valvedditturai",
                        "latitude": "9.81667000",
                        "longitude": "80.16667000"
                    },
                    {
                        "id": 66539,
                        "name": "Vavuniya",
                        "latitude": "8.75140000",
                        "longitude": "80.49710000"
                    },
                    {
                        "id": 66540,
                        "name": "Vavuniya District",
                        "latitude": "8.86134000",
                        "longitude": "80.47576000"
                    }
                ]
            },
            {
                "id": 2794,
                "name": "Nuwara Eliya",
                "iso2": "23",
                "latitude": "6.96065320",
                "longitude": "80.76927580",
                "type": "district",
                "cities": []
            },
            {
                "id": 2812,
                "name": "Polonnaruwa",
                "iso2": "72",
                "latitude": "7.93955670",
                "longitude": "81.00034030",
                "type": "district",
                "cities": []
            },
            {
                "id": 2796,
                "name": "Puttalam",
                "iso2": "62",
                "latitude": "8.02599150",
                "longitude": "79.84712720",
                "type": "district",
                "cities": []
            },
            {
                "id": 2807,
                "name": "Ratnapura",
                "iso2": "91",
                "latitude": "6.70551680",
                "longitude": "80.38483890",
                "type": "district",
                "cities": []
            },
            {
                "id": 2803,
                "name": "Sabaragamuwa",
                "iso2": "9",
                "latitude": "6.73959410",
                "longitude": "80.36586500",
                "type": "province",
                "cities": [
                    {
                        "id": 66493,
                        "name": "Kegalle",
                        "latitude": "7.25230000",
                        "longitude": "80.34360000"
                    },
                    {
                        "id": 66494,
                        "name": "Kegalle District",
                        "latitude": "7.11670000",
                        "longitude": "80.33330000"
                    },
                    {
                        "id": 66527,
                        "name": "Ratnapura",
                        "latitude": "6.68580000",
                        "longitude": "80.40360000"
                    },
                    {
                        "id": 66528,
                        "name": "Ratnapura District",
                        "latitude": "6.58310000",
                        "longitude": "80.58330000"
                    }
                ]
            },
            {
                "id": 2801,
                "name": "Southern",
                "iso2": "3",
                "latitude": "6.25036500",
                "longitude": "79.52503880",
                "type": "province",
                "cities": [
                    {
                        "id": 66448,
                        "name": "Ambalangoda",
                        "latitude": "6.23550000",
                        "longitude": "80.05380000"
                    },
                    {
                        "id": 66458,
                        "name": "Bentota",
                        "latitude": "6.42598000",
                        "longitude": "79.99575000"
                    },
                    {
                        "id": 66465,
                        "name": "Devinuwara",
                        "latitude": "5.92825000",
                        "longitude": "80.58880000"
                    },
                    {
                        "id": 66468,
                        "name": "Galle",
                        "latitude": "6.04610000",
                        "longitude": "80.21030000"
                    },
                    {
                        "id": 66469,
                        "name": "Galle District",
                        "latitude": "6.25000000",
                        "longitude": "80.25000000"
                    },
                    {
                        "id": 66473,
                        "name": "Hambantota District",
                        "latitude": "6.25440000",
                        "longitude": "81.11110000"
                    },
                    {
                        "id": 66478,
                        "name": "Hikkaduwa",
                        "latitude": "6.14070000",
                        "longitude": "80.10120000"
                    },
                    {
                        "id": 66498,
                        "name": "Koggala",
                        "latitude": "5.98860000",
                        "longitude": "80.32860000"
                    },
                    {
                        "id": 66507,
                        "name": "Matara",
                        "latitude": "5.94851000",
                        "longitude": "80.53528000"
                    },
                    {
                        "id": 66508,
                        "name": "Matara District",
                        "latitude": "6.13290000",
                        "longitude": "80.52800000"
                    },
                    {
                        "id": 66511,
                        "name": "Mirissa city",
                        "latitude": "5.94655000",
                        "longitude": "80.45831000"
                    },
                    {
                        "id": 66532,
                        "name": "Talpe",
                        "latitude": "5.99990000",
                        "longitude": "80.27870000"
                    },
                    {
                        "id": 66533,
                        "name": "Tangalle",
                        "latitude": "6.02338000",
                        "longitude": "80.79738000"
                    },
                    {
                        "id": 66536,
                        "name": "Unawatuna",
                        "latitude": "6.02120000",
                        "longitude": "80.25030000"
                    },
                    {
                        "id": 66543,
                        "name": "Weligama",
                        "latitude": "5.97501000",
                        "longitude": "80.42968000"
                    }
                ]
            },
            {
                "id": 2795,
                "name": "Trincomalee",
                "iso2": "53",
                "latitude": "8.60130690",
                "longitude": "81.11960750",
                "type": "district",
                "cities": []
            },
            {
                "id": 2811,
                "name": "Uva",
                "iso2": "8",
                "latitude": "6.84276120",
                "longitude": "81.33994140",
                "type": "province",
                "cities": [
                    {
                        "id": 66453,
                        "name": "Badulla",
                        "latitude": "6.98020000",
                        "longitude": "81.05770000"
                    },
                    {
                        "id": 66454,
                        "name": "Badulla District",
                        "latitude": "6.98472000",
                        "longitude": "81.05639000"
                    },
                    {
                        "id": 66466,
                        "name": "Ella Town",
                        "latitude": "6.87560000",
                        "longitude": "81.04630000"
                    },
                    {
                        "id": 66475,
                        "name": "Haputale",
                        "latitude": "6.76566000",
                        "longitude": "80.95104000"
                    },
                    {
                        "id": 66491,
                        "name": "Kataragama",
                        "latitude": "6.41340000",
                        "longitude": "81.33460000"
                    },
                    {
                        "id": 66512,
                        "name": "Monaragala",
                        "latitude": "6.87140000",
                        "longitude": "81.34870000"
                    },
                    {
                        "id": 66513,
                        "name": "Moneragala District",
                        "latitude": "6.66667000",
                        "longitude": "81.33333000"
                    },
                    {
                        "id": 66545,
                        "name": "Wellawaya",
                        "latitude": "6.73694000",
                        "longitude": "81.10279000"
                    }
                ]
            },
            {
                "id": 2809,
                "name": "Vavuniya",
                "iso2": "44",
                "latitude": "8.75947390",
                "longitude": "80.50003340",
                "type": "district",
                "cities": []
            },
            {
                "id": 2802,
                "name": "Western",
                "iso2": "1",
                "latitude": "6.82823500",
                "longitude": "79.76864030",
                "type": "province",
                "cities": [
                    {
                        "id": 66455,
                        "name": "Battaramulla South",
                        "latitude": "6.89640000",
                        "longitude": "79.91810000"
                    },
                    {
                        "id": 66459,
                        "name": "Beruwala",
                        "latitude": "6.47880000",
                        "longitude": "79.98280000"
                    },
                    {
                        "id": 66461,
                        "name": "Colombo",
                        "latitude": "6.93548000",
                        "longitude": "79.84868000"
                    },
                    {
                        "id": 66462,
                        "name": "Colombo District",
                        "latitude": "6.86640000",
                        "longitude": "80.01660000"
                    },
                    {
                        "id": 66470,
                        "name": "Gampaha",
                        "latitude": "7.08970000",
                        "longitude": "79.99250000"
                    },
                    {
                        "id": 66471,
                        "name": "Gampaha District",
                        "latitude": "7.13330000",
                        "longitude": "80.00000000"
                    },
                    {
                        "id": 66474,
                        "name": "Hanwella Ihala",
                        "latitude": "6.90120000",
                        "longitude": "80.08520000"
                    },
                    {
                        "id": 66477,
                        "name": "Hendala",
                        "latitude": "6.99090000",
                        "longitude": "79.88300000"
                    },
                    {
                        "id": 66480,
                        "name": "Horana South",
                        "latitude": "6.71590000",
                        "longitude": "80.06260000"
                    },
                    {
                        "id": 66481,
                        "name": "Horawala Junction",
                        "latitude": "6.48088000",
                        "longitude": "80.12708000"
                    },
                    {
                        "id": 66482,
                        "name": "Ja Ela",
                        "latitude": "7.07440000",
                        "longitude": "79.89190000"
                    },
                    {
                        "id": 66487,
                        "name": "Kalutara",
                        "latitude": "6.58310000",
                        "longitude": "79.95930000"
                    },
                    {
                        "id": 66488,
                        "name": "Kandana",
                        "latitude": "7.04800000",
                        "longitude": "79.89370000"
                    },
                    {
                        "id": 66492,
                        "name": "Katunayaka",
                        "latitude": "7.16992000",
                        "longitude": "79.88837000"
                    },
                    {
                        "id": 66495,
                        "name": "Kelaniya",
                        "latitude": "6.95530000",
                        "longitude": "79.92200000"
                    },
                    {
                        "id": 66500,
                        "name": "Kotikawatta",
                        "latitude": "6.92690000",
                        "longitude": "79.90950000"
                    },
                    {
                        "id": 66510,
                        "name": "Minuwangoda",
                        "latitude": "7.16630000",
                        "longitude": "79.95330000"
                    },
                    {
                        "id": 66515,
                        "name": "Mulleriyawa",
                        "latitude": "6.93300000",
                        "longitude": "79.92970000"
                    },
                    {
                        "id": 66516,
                        "name": "Negombo",
                        "latitude": "7.20830000",
                        "longitude": "79.83580000"
                    },
                    {
                        "id": 66519,
                        "name": "Panadura",
                        "latitude": "6.71320000",
                        "longitude": "79.90260000"
                    },
                    {
                        "id": 66520,
                        "name": "Peliyagoda",
                        "latitude": "6.96850000",
                        "longitude": "79.88360000"
                    },
                    {
                        "id": 66521,
                        "name": "Pita Kotte",
                        "latitude": "6.89050000",
                        "longitude": "79.90150000"
                    },
                    {
                        "id": 66530,
                        "name": "Sri Jayewardenepura Kotte",
                        "latitude": "6.88297000",
                        "longitude": "79.90708000"
                    },
                    {
                        "id": 66541,
                        "name": "Wattala",
                        "latitude": "6.98918000",
                        "longitude": "79.89167000"
                    },
                    {
                        "id": 66544,
                        "name": "Welisara",
                        "latitude": "7.02810000",
                        "longitude": "79.90140000"
                    }
                ]
            }
        ]
    },
    {
        "id": 209,
        "name": "Sudan",
        "iso3": "SDN",
        "iso2": "SD",
        "numeric_code": "729",
        "phonecode": "249",
        "capital": "Khartoum",
        "currency": "SDG",
        "currency_name": "Sudanese pound",
        "currency_symbol": ".س.ج",
        "tld": ".sd",
        "native": "السودان",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Northern Africa",
        "subregion_id": 1,
        "nationality": "Sudanese",
        "timezones": [
            {
                "zoneName": "Africa\/Khartoum",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EAT",
                "tzName": "Eastern African Time"
            }
        ],
        "translations": {
            "br": "Soudan",
            "ko": "수단",
            "pt-BR": "Sudão",
            "pt": "Sudão",
            "nl": "Soedan",
            "hr": "Sudan",
            "fa": "سودان",
            "de": "Sudan",
            "es": "Sudán",
            "fr": "Soudan",
            "ja": "スーダン",
            "it": "Sudan",
            "zh-CN": "苏丹",
            "tr": "Sudan",
            "ru": "Судан",
            "uk": "Судан",
            "pl": "Sudan"
        },
        "latitude": "15.00000000",
        "longitude": "30.00000000",
        "emoji": "🇸🇩",
        "emojiU": "U+1F1F8 U+1F1E9",
        "states": [
            {
                "id": 885,
                "name": "Al Jazirah",
                "iso2": "GZ",
                "latitude": "14.88596110",
                "longitude": "33.43835300",
                "type": "state",
                "cities": [
                    {
                        "id": 102921,
                        "name": "Al Hasaheisa",
                        "latitude": "14.75264000",
                        "longitude": "33.29836000"
                    },
                    {
                        "id": 102922,
                        "name": "Al Hilāliyya",
                        "latitude": "14.93980000",
                        "longitude": "33.23400000"
                    },
                    {
                        "id": 102924,
                        "name": "Al Kiremit al ‘Arakiyyīn",
                        "latitude": "14.34760000",
                        "longitude": "32.94370000"
                    },
                    {
                        "id": 102926,
                        "name": "Al Manāqil",
                        "latitude": "14.24590000",
                        "longitude": "32.98910000"
                    },
                    {
                        "id": 102927,
                        "name": "Al Masallamiyya",
                        "latitude": "14.57480000",
                        "longitude": "33.33730000"
                    },
                    {
                        "id": 102980,
                        "name": "Wad Medani",
                        "latitude": "14.40118000",
                        "longitude": "33.51989000"
                    },
                    {
                        "id": 102981,
                        "name": "Wad Rāwah",
                        "latitude": "15.16028000",
                        "longitude": "33.13972000"
                    }
                ]
            },
            {
                "id": 886,
                "name": "Al Qadarif",
                "iso2": "GD",
                "latitude": "14.02430700",
                "longitude": "35.36856790",
                "type": "state",
                "cities": [
                    {
                        "id": 102931,
                        "name": "Al Ḩawātah",
                        "latitude": "13.41667000",
                        "longitude": "34.63333000"
                    },
                    {
                        "id": 102929,
                        "name": "Al Qadarif",
                        "latitude": "14.03493000",
                        "longitude": "35.38344000"
                    },
                    {
                        "id": 102942,
                        "name": "Doka",
                        "latitude": "13.51667000",
                        "longitude": "35.76667000"
                    }
                ]
            },
            {
                "id": 887,
                "name": "Blue Nile",
                "iso2": "NB",
                "latitude": "47.59867300",
                "longitude": "-122.33441900",
                "type": "state",
                "cities": [
                    {
                        "id": 102919,
                        "name": "Ad-Damazin",
                        "latitude": "11.78910000",
                        "longitude": "34.35920000"
                    },
                    {
                        "id": 102934,
                        "name": "Ar Ruseris",
                        "latitude": "11.86590000",
                        "longitude": "34.38690000"
                    },
                    {
                        "id": 102961,
                        "name": "Kurmuk",
                        "latitude": "10.55000000",
                        "longitude": "34.28333000"
                    }
                ]
            },
            {
                "id": 896,
                "name": "Central Darfur",
                "iso2": "DC",
                "latitude": "12.29212820",
                "longitude": "22.31561450",
                "type": "state",
                "cities": [
                    {
                        "id": 102984,
                        "name": "Zalingei",
                        "latitude": "12.90918000",
                        "longitude": "23.47058000"
                    }
                ]
            },
            {
                "id": 892,
                "name": "East Darfur",
                "iso2": "DE",
                "latitude": "11.23054740",
                "longitude": "25.11397040",
                "type": "state",
                "cities": [
                    {
                        "id": 102946,
                        "name": "El Daein",
                        "latitude": "11.46186000",
                        "longitude": "26.12583000"
                    }
                ]
            },
            {
                "id": 884,
                "name": "Kassala",
                "iso2": "KA",
                "latitude": "15.45813320",
                "longitude": "36.40396290",
                "type": "state",
                "cities": [
                    {
                        "id": 102936,
                        "name": "Aroma",
                        "latitude": "15.81667000",
                        "longitude": "36.13333000"
                    },
                    {
                        "id": 102956,
                        "name": "Kassala",
                        "latitude": "15.45099000",
                        "longitude": "36.39998000"
                    },
                    {
                        "id": 102983,
                        "name": "Wagar",
                        "latitude": "16.15250000",
                        "longitude": "36.20320000"
                    }
                ]
            },
            {
                "id": 881,
                "name": "Khartoum",
                "iso2": "KH",
                "latitude": "15.50065440",
                "longitude": "32.55989940",
                "type": "state",
                "cities": [
                    {
                        "id": 102957,
                        "name": "Khartoum",
                        "latitude": "15.55177000",
                        "longitude": "32.53241000"
                    },
                    {
                        "id": 102967,
                        "name": "Omdurman",
                        "latitude": "15.64453000",
                        "longitude": "32.47773000"
                    }
                ]
            },
            {
                "id": 890,
                "name": "North Darfur",
                "iso2": "DN",
                "latitude": "15.76619690",
                "longitude": "24.90422080",
                "type": "state",
                "cities": [
                    {
                        "id": 102947,
                        "name": "El Fasher",
                        "latitude": "13.62793000",
                        "longitude": "25.34936000"
                    },
                    {
                        "id": 102962,
                        "name": "Kutum",
                        "latitude": "14.20000000",
                        "longitude": "24.66667000"
                    },
                    {
                        "id": 102978,
                        "name": "Umm Kaddadah",
                        "latitude": "13.60169000",
                        "longitude": "26.68759000"
                    }
                ]
            },
            {
                "id": 893,
                "name": "North Kordofan",
                "iso2": "KN",
                "latitude": "13.83064410",
                "longitude": "29.41793240",
                "type": "state",
                "cities": [
                    {
                        "id": 102933,
                        "name": "Ar Rahad",
                        "latitude": "12.71667000",
                        "longitude": "30.65000000"
                    },
                    {
                        "id": 102940,
                        "name": "Bārah",
                        "latitude": "13.70000000",
                        "longitude": "30.36667000"
                    },
                    {
                        "id": 102949,
                        "name": "El Obeid",
                        "latitude": "13.18421000",
                        "longitude": "30.21669000"
                    },
                    {
                        "id": 102979,
                        "name": "Umm Ruwaba",
                        "latitude": "12.90610000",
                        "longitude": "31.21580000"
                    }
                ]
            },
            {
                "id": 895,
                "name": "Northern",
                "iso2": "NO",
                "latitude": "38.06381700",
                "longitude": "-84.46286480",
                "type": "state",
                "cities": [
                    {
                        "id": 102916,
                        "name": "Ad Dabbah",
                        "latitude": "18.05000000",
                        "longitude": "30.95000000"
                    },
                    {
                        "id": 102935,
                        "name": "Argo",
                        "latitude": "19.51667000",
                        "longitude": "30.41667000"
                    },
                    {
                        "id": 102943,
                        "name": "Dongola",
                        "latitude": "19.18163000",
                        "longitude": "30.47689000"
                    },
                    {
                        "id": 102955,
                        "name": "Karmah an Nuzul",
                        "latitude": "19.63333000",
                        "longitude": "30.41667000"
                    },
                    {
                        "id": 102960,
                        "name": "Kuraymah",
                        "latitude": "18.55000000",
                        "longitude": "31.85000000"
                    },
                    {
                        "id": 102965,
                        "name": "Merowe",
                        "latitude": "18.47036000",
                        "longitude": "31.81126000"
                    }
                ]
            },
            {
                "id": 880,
                "name": "Red Sea",
                "iso2": "RS",
                "latitude": "20.28023200",
                "longitude": "38.51257300",
                "type": "state",
                "cities": [
                    {
                        "id": 102950,
                        "name": "Gebeit",
                        "latitude": "21.06667000",
                        "longitude": "36.31667000"
                    },
                    {
                        "id": 102968,
                        "name": "Port Sudan",
                        "latitude": "19.61745000",
                        "longitude": "37.21644000"
                    },
                    {
                        "id": 102970,
                        "name": "Sawākin",
                        "latitude": "19.10590000",
                        "longitude": "37.33210000"
                    },
                    {
                        "id": 102976,
                        "name": "Tokār",
                        "latitude": "18.42540000",
                        "longitude": "37.72900000"
                    }
                ]
            },
            {
                "id": 891,
                "name": "River Nile",
                "iso2": "NR",
                "latitude": "23.97275950",
                "longitude": "32.87492060",
                "type": "state",
                "cities": [
                    {
                        "id": 102938,
                        "name": "Atbara",
                        "latitude": "17.70217000",
                        "longitude": "33.98638000"
                    },
                    {
                        "id": 102939,
                        "name": "Berber",
                        "latitude": "18.02158000",
                        "longitude": "33.98299000"
                    },
                    {
                        "id": 102944,
                        "name": "Ed Damer",
                        "latitude": "17.59898000",
                        "longitude": "33.97205000"
                    },
                    {
                        "id": 102945,
                        "name": "El Bauga",
                        "latitude": "18.26197000",
                        "longitude": "33.90812000"
                    },
                    {
                        "id": 102948,
                        "name": "El Matama",
                        "latitude": "16.70950000",
                        "longitude": "33.35650000"
                    },
                    {
                        "id": 102971,
                        "name": "Shendi",
                        "latitude": "16.69150000",
                        "longitude": "33.43410000"
                    }
                ]
            },
            {
                "id": 882,
                "name": "Sennar",
                "iso2": "SI",
                "latitude": "13.56746900",
                "longitude": "33.56720450",
                "type": "state",
                "cities": [
                    {
                        "id": 102917,
                        "name": "Ad Dindar",
                        "latitude": "13.20000000",
                        "longitude": "34.16667000"
                    },
                    {
                        "id": 102937,
                        "name": "As Sūkī",
                        "latitude": "13.31667000",
                        "longitude": "33.88333000"
                    },
                    {
                        "id": 102953,
                        "name": "Jalqani",
                        "latitude": "12.44860000",
                        "longitude": "34.21860000"
                    },
                    {
                        "id": 102958,
                        "name": "Kināna",
                        "latitude": "14.03610000",
                        "longitude": "33.17120000"
                    },
                    {
                        "id": 102963,
                        "name": "Maiurno",
                        "latitude": "13.41667000",
                        "longitude": "33.66667000"
                    },
                    {
                        "id": 102972,
                        "name": "Singa",
                        "latitude": "13.14830000",
                        "longitude": "33.93117000"
                    },
                    {
                        "id": 102973,
                        "name": "Sinnar",
                        "latitude": "13.56907000",
                        "longitude": "33.56718000"
                    }
                ]
            },
            {
                "id": 894,
                "name": "South Darfur",
                "iso2": "DS",
                "latitude": "11.64886390",
                "longitude": "24.90422080",
                "type": "state",
                "cities": [
                    {
                        "id": 102952,
                        "name": "Gereida",
                        "latitude": "11.27543000",
                        "longitude": "25.14026000"
                    },
                    {
                        "id": 102966,
                        "name": "Nyala",
                        "latitude": "12.04888000",
                        "longitude": "24.88069000"
                    }
                ]
            },
            {
                "id": 883,
                "name": "South Kordofan",
                "iso2": "KS",
                "latitude": "11.22853150",
                "longitude": "29.52727540",
                "type": "state",
                "cities": [
                    {
                        "id": 102914,
                        "name": "Abu Jibeha",
                        "latitude": "11.45620000",
                        "longitude": "31.22850000"
                    },
                    {
                        "id": 102920,
                        "name": "Al Fūlah",
                        "latitude": "11.73292000",
                        "longitude": "28.35786000"
                    },
                    {
                        "id": 102941,
                        "name": "Dilling",
                        "latitude": "12.05000000",
                        "longitude": "29.65000000"
                    },
                    {
                        "id": 102954,
                        "name": "Kadugli",
                        "latitude": "11.01111000",
                        "longitude": "29.71833000"
                    },
                    {
                        "id": 102974,
                        "name": "Talodi",
                        "latitude": "10.63246000",
                        "longitude": "30.37970000"
                    }
                ]
            },
            {
                "id": 888,
                "name": "West Darfur",
                "iso2": "DW",
                "latitude": "12.84635610",
                "longitude": "23.00119890",
                "type": "state",
                "cities": [
                    {
                        "id": 102951,
                        "name": "Geneina",
                        "latitude": "13.45262000",
                        "longitude": "22.44725000"
                    }
                ]
            },
            {
                "id": 889,
                "name": "West Kordofan",
                "iso2": "GK",
                "latitude": "11.85756830",
                "longitude": "25.88143560",
                "type": "state",
                "cities": [
                    {
                        "id": 102915,
                        "name": "Abū Zabad",
                        "latitude": "12.35000000",
                        "longitude": "29.25000000"
                    },
                    {
                        "id": 102925,
                        "name": "Al Lagowa",
                        "latitude": "11.40000000",
                        "longitude": "29.13333000"
                    },
                    {
                        "id": 102928,
                        "name": "Al Mijlad",
                        "latitude": "11.03333000",
                        "longitude": "27.73333000"
                    },
                    {
                        "id": 102932,
                        "name": "An Nuhūd",
                        "latitude": "12.70000000",
                        "longitude": "28.43333000"
                    }
                ]
            },
            {
                "id": 879,
                "name": "White Nile",
                "iso2": "NW",
                "latitude": "9.33215160",
                "longitude": "31.46153000",
                "type": "state",
                "cities": [
                    {
                        "id": 102918,
                        "name": "Ad Douiem",
                        "latitude": "14.00120000",
                        "longitude": "32.31160000"
                    },
                    {
                        "id": 102923,
                        "name": "Al Kawa",
                        "latitude": "13.74630000",
                        "longitude": "32.49960000"
                    },
                    {
                        "id": 102930,
                        "name": "Al Qiţena",
                        "latitude": "14.86480000",
                        "longitude": "32.36680000"
                    },
                    {
                        "id": 102959,
                        "name": "Kosti",
                        "latitude": "13.16290000",
                        "longitude": "32.66347000"
                    },
                    {
                        "id": 102964,
                        "name": "Marabba",
                        "latitude": "12.35000000",
                        "longitude": "32.18333000"
                    },
                    {
                        "id": 102969,
                        "name": "Rabak",
                        "latitude": "13.18087000",
                        "longitude": "32.73999000"
                    },
                    {
                        "id": 102975,
                        "name": "Tandaltī",
                        "latitude": "13.01667000",
                        "longitude": "31.86667000"
                    },
                    {
                        "id": 102977,
                        "name": "Um Jar Al Gharbiyya",
                        "latitude": "13.80130000",
                        "longitude": "32.40780000"
                    },
                    {
                        "id": 102982,
                        "name": "Wad az Zāki",
                        "latitude": "14.46190000",
                        "longitude": "32.20650000"
                    }
                ]
            }
        ]
    },
    {
        "id": 210,
        "name": "Suriname",
        "iso3": "SUR",
        "iso2": "SR",
        "numeric_code": "740",
        "phonecode": "597",
        "capital": "Paramaribo",
        "currency": "SRD",
        "currency_name": "Surinamese dollar",
        "currency_symbol": "$",
        "tld": ".sr",
        "native": "Suriname",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Surinamese",
        "timezones": [
            {
                "zoneName": "America\/Paramaribo",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "SRT",
                "tzName": "Suriname Time"
            }
        ],
        "translations": {
            "br": "Surinam",
            "ko": "수리남",
            "pt-BR": "Suriname",
            "pt": "Suriname",
            "nl": "Suriname",
            "hr": "Surinam",
            "fa": "سورینام",
            "de": "Suriname",
            "es": "Surinam",
            "fr": "Surinam",
            "ja": "スリナム",
            "it": "Suriname",
            "zh-CN": "苏里南",
            "tr": "Surinam",
            "ru": "Суринам",
            "uk": "Суринам",
            "pl": "Surinam"
        },
        "latitude": "4.00000000",
        "longitude": "-56.00000000",
        "emoji": "🇸🇷",
        "emojiU": "U+1F1F8 U+1F1F7",
        "states": [
            {
                "id": 2846,
                "name": "Brokopondo",
                "iso2": "BR",
                "latitude": "4.77102470",
                "longitude": "-55.04933750",
                "type": "district",
                "cities": [
                    {
                        "id": 104822,
                        "name": "Brokopondo",
                        "latitude": "5.05594000",
                        "longitude": "-54.98043000"
                    },
                    {
                        "id": 104823,
                        "name": "Brownsweg",
                        "latitude": "5.00435000",
                        "longitude": "-55.15333000"
                    }
                ]
            },
            {
                "id": 2839,
                "name": "Commewijne",
                "iso2": "CM",
                "latitude": "5.74021100",
                "longitude": "-54.87312190",
                "type": "district",
                "cities": [
                    {
                        "id": 104826,
                        "name": "Mariënburg",
                        "latitude": "5.87722000",
                        "longitude": "-55.04322000"
                    },
                    {
                        "id": 104828,
                        "name": "Nieuw Amsterdam",
                        "latitude": "5.88573000",
                        "longitude": "-55.08871000"
                    }
                ]
            },
            {
                "id": 2842,
                "name": "Coronie",
                "iso2": "CR",
                "latitude": "5.69432710",
                "longitude": "-56.29293810",
                "type": "district",
                "cities": [
                    {
                        "id": 104832,
                        "name": "Totness",
                        "latitude": "5.87618000",
                        "longitude": "-56.32572000"
                    }
                ]
            },
            {
                "id": 2845,
                "name": "Marowijne",
                "iso2": "MA",
                "latitude": "5.62681280",
                "longitude": "-54.25931180",
                "type": "district",
                "cities": [
                    {
                        "id": 104821,
                        "name": "Albina",
                        "latitude": "5.49788000",
                        "longitude": "-54.05522000"
                    },
                    {
                        "id": 104827,
                        "name": "Moengo",
                        "latitude": "5.61411000",
                        "longitude": "-54.40121000"
                    }
                ]
            },
            {
                "id": 2840,
                "name": "Nickerie",
                "iso2": "NI",
                "latitude": "5.58554690",
                "longitude": "-56.83111170",
                "type": "district",
                "cities": [
                    {
                        "id": 104829,
                        "name": "Nieuw Nickerie",
                        "latitude": "5.92606000",
                        "longitude": "-56.97297000"
                    },
                    {
                        "id": 104833,
                        "name": "Wageningen",
                        "latitude": "5.76010000",
                        "longitude": "-56.66523000"
                    }
                ]
            },
            {
                "id": 2841,
                "name": "Para",
                "iso2": "PR",
                "latitude": "5.48173180",
                "longitude": "-55.22592070",
                "type": "district",
                "cities": [
                    {
                        "id": 104830,
                        "name": "Onverwacht",
                        "latitude": "5.58983000",
                        "longitude": "-55.19462000"
                    }
                ]
            },
            {
                "id": 2843,
                "name": "Paramaribo",
                "iso2": "PM",
                "latitude": "5.85203550",
                "longitude": "-55.20382780",
                "type": "district",
                "cities": [
                    {
                        "id": 104831,
                        "name": "Paramaribo",
                        "latitude": "5.86638000",
                        "longitude": "-55.16682000"
                    }
                ]
            },
            {
                "id": 2848,
                "name": "Saramacca",
                "iso2": "SA",
                "latitude": "5.72408130",
                "longitude": "-55.66896360",
                "type": "district",
                "cities": [
                    {
                        "id": 104824,
                        "name": "Groningen",
                        "latitude": "5.80000000",
                        "longitude": "-55.46667000"
                    }
                ]
            },
            {
                "id": 2847,
                "name": "Sipaliwini",
                "iso2": "SI",
                "latitude": "3.65673820",
                "longitude": "-56.20353870",
                "type": "district",
                "cities": []
            },
            {
                "id": 2844,
                "name": "Wanica",
                "iso2": "WA",
                "latitude": "5.73237620",
                "longitude": "-55.27012350",
                "type": "district",
                "cities": [
                    {
                        "id": 104825,
                        "name": "Lelydorp",
                        "latitude": "5.70000000",
                        "longitude": "-55.23333000"
                    }
                ]
            }
        ]
    },
    {
        "id": 211,
        "name": "Svalbard and Jan Mayen Islands",
        "iso3": "SJM",
        "iso2": "SJ",
        "numeric_code": "744",
        "phonecode": "47",
        "capital": "Longyearbyen",
        "currency": "NOK",
        "currency_name": "Norwegian krone",
        "currency_symbol": "ko",
        "tld": ".sj",
        "native": "Svalbard og Jan Mayen",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Svalbard",
        "timezones": [
            {
                "zoneName": "Arctic\/Longyearbyen",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Svalbard ha Enez Jan Mayen",
            "ko": "스발바르 얀마옌 제도",
            "pt-BR": "Svalbard",
            "pt": "Svalbard",
            "nl": "Svalbard en Jan Mayen",
            "hr": "Svalbard i Jan Mayen",
            "fa": "سوالبارد و یان ماین",
            "de": "Svalbard und Jan Mayen",
            "es": "Islas Svalbard y Jan Mayen",
            "fr": "Svalbard et Jan Mayen",
            "ja": "スヴァールバル諸島およびヤンマイエン島",
            "it": "Svalbard e Jan Mayen",
            "zh-CN": "斯瓦尔巴和扬马延群岛",
            "tr": "Svalbard Ve Jan Mayen",
            "ru": "Шпицберген и острова Ян-Майен",
            "uk": "Шпіцберген та острови Ян-Майєн",
            "pl": "Wyspy Svalbard i Jan Mayen"
        },
        "latitude": "78.00000000",
        "longitude": "20.00000000",
        "emoji": "🇸🇯",
        "emojiU": "U+1F1F8 U+1F1EF",
        "states": []
    },
    {
        "id": 213,
        "name": "Sweden",
        "iso3": "SWE",
        "iso2": "SE",
        "numeric_code": "752",
        "phonecode": "46",
        "capital": "Stockholm",
        "currency": "SEK",
        "currency_name": "Swedish krona",
        "currency_symbol": "ko",
        "tld": ".se",
        "native": "Sverige",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "Swedish",
        "timezones": [
            {
                "zoneName": "Europe\/Stockholm",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Sveden",
            "ko": "스웨덴",
            "pt-BR": "Suécia",
            "pt": "Suécia",
            "nl": "Zweden",
            "hr": "Švedska",
            "fa": "سوئد",
            "de": "Schweden",
            "es": "Suecia",
            "fr": "Suède",
            "ja": "スウェーデン",
            "it": "Svezia",
            "zh-CN": "瑞典",
            "tr": "İsveç",
            "ru": "Швеция",
            "uk": "Швеція",
            "pl": "Szwecja"
        },
        "latitude": "62.00000000",
        "longitude": "15.00000000",
        "emoji": "🇸🇪",
        "emojiU": "U+1F1F8 U+1F1EA",
        "states": [
            {
                "id": 1537,
                "name": "Blekinge",
                "iso2": "K",
                "latitude": "56.28333333",
                "longitude": "15.11666666",
                "type": "county",
                "cities": [
                    {
                        "id": 103094,
                        "name": "Bräkne-Hoby",
                        "latitude": "56.23333000",
                        "longitude": "15.11667000"
                    },
                    {
                        "id": 103321,
                        "name": "Hällevik",
                        "latitude": "56.01667000",
                        "longitude": "14.70000000"
                    },
                    {
                        "id": 103270,
                        "name": "Hasslö",
                        "latitude": "56.11667000",
                        "longitude": "15.48333000"
                    },
                    {
                        "id": 103359,
                        "name": "Jämjö",
                        "latitude": "56.19187000",
                        "longitude": "15.84115000"
                    },
                    {
                        "id": 103360,
                        "name": "Jämshög",
                        "latitude": "56.23333000",
                        "longitude": "14.51667000"
                    },
                    {
                        "id": 103371,
                        "name": "Kallinge",
                        "latitude": "56.24841000",
                        "longitude": "15.28721000"
                    },
                    {
                        "id": 103377,
                        "name": "Karlshamn",
                        "latitude": "56.17060000",
                        "longitude": "14.86188000"
                    },
                    {
                        "id": 103381,
                        "name": "Karlskrona",
                        "latitude": "56.16156000",
                        "longitude": "15.58661000"
                    },
                    {
                        "id": 103539,
                        "name": "Mjällby",
                        "latitude": "56.05000000",
                        "longitude": "14.68333000"
                    },
                    {
                        "id": 103570,
                        "name": "Mörrum",
                        "latitude": "56.19281000",
                        "longitude": "14.74739000"
                    },
                    {
                        "id": 103605,
                        "name": "Nättraby",
                        "latitude": "56.20000000",
                        "longitude": "15.51667000"
                    },
                    {
                        "id": 103612,
                        "name": "Olofström",
                        "latitude": "56.27730000",
                        "longitude": "14.53402000"
                    },
                    {
                        "id": 103672,
                        "name": "Rödeby",
                        "latitude": "56.26078000",
                        "longitude": "15.62143000"
                    },
                    {
                        "id": 103655,
                        "name": "Ronneby",
                        "latitude": "56.20999000",
                        "longitude": "15.27602000"
                    },
                    {
                        "id": 103830,
                        "name": "Sölvesborg",
                        "latitude": "56.05205000",
                        "longitude": "14.57525000"
                    },
                    {
                        "id": 103779,
                        "name": "Sturkö",
                        "latitude": "56.08333000",
                        "longitude": "15.70000000"
                    },
                    {
                        "id": 103801,
                        "name": "Svängsta",
                        "latitude": "56.26667000",
                        "longitude": "14.76667000"
                    }
                ]
            },
            {
                "id": 1534,
                "name": "Dalarna",
                "iso2": "W",
                "latitude": "61.09170120",
                "longitude": "14.66636530",
                "type": "county",
                "cities": [
                    {
                        "id": 102985,
                        "name": "Abborrberget",
                        "latitude": "60.15000000",
                        "longitude": "14.80000000"
                    },
                    {
                        "id": 103989,
                        "name": "Älvdalen",
                        "latitude": "61.22774000",
                        "longitude": "14.03935000"
                    },
                    {
                        "id": 103022,
                        "name": "Avesta",
                        "latitude": "60.14274000",
                        "longitude": "16.16295000"
                    },
                    {
                        "id": 103046,
                        "name": "Bjursås",
                        "latitude": "60.73726000",
                        "longitude": "15.45291000"
                    },
                    {
                        "id": 103075,
                        "name": "Borlänge",
                        "latitude": "60.48580000",
                        "longitude": "15.43714000"
                    },
                    {
                        "id": 103093,
                        "name": "Brunna",
                        "latitude": "60.26255000",
                        "longitude": "16.01034000"
                    },
                    {
                        "id": 103122,
                        "name": "Djurås",
                        "latitude": "60.56061000",
                        "longitude": "15.13281000"
                    },
                    {
                        "id": 103142,
                        "name": "Enbacka",
                        "latitude": "60.40993000",
                        "longitude": "15.59575000"
                    },
                    {
                        "id": 103162,
                        "name": "Falun",
                        "latitude": "60.60357000",
                        "longitude": "15.62597000"
                    },
                    {
                        "id": 103197,
                        "name": "Gagnef",
                        "latitude": "60.59856000",
                        "longitude": "15.07745000"
                    },
                    {
                        "id": 103226,
                        "name": "Grängesberg",
                        "latitude": "60.07465000",
                        "longitude": "15.00784000"
                    },
                    {
                        "id": 103225,
                        "name": "Grycksbo",
                        "latitude": "60.68751000",
                        "longitude": "15.48507000"
                    },
                    {
                        "id": 103274,
                        "name": "Hedemora",
                        "latitude": "60.27973000",
                        "longitude": "15.98855000"
                    },
                    {
                        "id": 103297,
                        "name": "Horndal",
                        "latitude": "60.30000000",
                        "longitude": "16.41667000"
                    },
                    {
                        "id": 103347,
                        "name": "Insjön",
                        "latitude": "60.67688000",
                        "longitude": "15.09487000"
                    },
                    {
                        "id": 103364,
                        "name": "Järna",
                        "latitude": "60.53333000",
                        "longitude": "14.36667000"
                    },
                    {
                        "id": 103419,
                        "name": "Krylbo",
                        "latitude": "60.13333000",
                        "longitude": "16.21667000"
                    },
                    {
                        "id": 103504,
                        "name": "Långshyttan",
                        "latitude": "60.45238000",
                        "longitude": "16.03831000"
                    },
                    {
                        "id": 103456,
                        "name": "Leksand",
                        "latitude": "60.73030000",
                        "longitude": "14.99994000"
                    },
                    {
                        "id": 103491,
                        "name": "Ludvika",
                        "latitude": "60.14959000",
                        "longitude": "15.18776000"
                    },
                    {
                        "id": 103518,
                        "name": "Malung",
                        "latitude": "60.68329000",
                        "longitude": "13.71542000"
                    },
                    {
                        "id": 103542,
                        "name": "Mockfjärd",
                        "latitude": "60.50000000",
                        "longitude": "14.96667000"
                    },
                    {
                        "id": 103545,
                        "name": "Mora",
                        "latitude": "61.00704000",
                        "longitude": "14.54316000"
                    },
                    {
                        "id": 103595,
                        "name": "Nyhammar",
                        "latitude": "60.28333000",
                        "longitude": "14.96667000"
                    },
                    {
                        "id": 103617,
                        "name": "Ornäs",
                        "latitude": "60.50944000",
                        "longitude": "15.54128000"
                    },
                    {
                        "id": 103618,
                        "name": "Orsa",
                        "latitude": "61.12034000",
                        "longitude": "14.61550000"
                    },
                    {
                        "id": 103665,
                        "name": "Rättvik",
                        "latitude": "60.88632000",
                        "longitude": "15.11787000"
                    },
                    {
                        "id": 103654,
                        "name": "Romme",
                        "latitude": "60.43333000",
                        "longitude": "15.50000000"
                    },
                    {
                        "id": 103807,
                        "name": "Säter",
                        "latitude": "60.34778000",
                        "longitude": "15.75051000"
                    },
                    {
                        "id": 103688,
                        "name": "Siljansnäs",
                        "latitude": "60.78333000",
                        "longitude": "14.85000000"
                    },
                    {
                        "id": 103728,
                        "name": "Smedby",
                        "latitude": "60.70000000",
                        "longitude": "15.05000000"
                    },
                    {
                        "id": 103729,
                        "name": "Smedjebacken",
                        "latitude": "60.14181000",
                        "longitude": "15.41416000"
                    },
                    {
                        "id": 103802,
                        "name": "Svärdsjö",
                        "latitude": "60.74022000",
                        "longitude": "15.90173000"
                    },
                    {
                        "id": 103920,
                        "name": "Vansbro",
                        "latitude": "60.50893000",
                        "longitude": "14.22458000"
                    },
                    {
                        "id": 103941,
                        "name": "Vikarbyn",
                        "latitude": "60.91667000",
                        "longitude": "15.01667000"
                    }
                ]
            },
            {
                "id": 1533,
                "name": "Gävleborg",
                "iso2": "X",
                "latitude": "61.30119930",
                "longitude": "16.15342140",
                "type": "county",
                "cities": [
                    {
                        "id": 102990,
                        "name": "Alfta",
                        "latitude": "61.34675000",
                        "longitude": "16.07499000"
                    },
                    {
                        "id": 103009,
                        "name": "Arbrå",
                        "latitude": "61.46667000",
                        "longitude": "16.38333000"
                    },
                    {
                        "id": 104014,
                        "name": "Årsunda",
                        "latitude": "60.51644000",
                        "longitude": "16.73436000"
                    },
                    {
                        "id": 103033,
                        "name": "Bergby",
                        "latitude": "60.92931000",
                        "longitude": "17.04194000"
                    },
                    {
                        "id": 103038,
                        "name": "Bergsjö",
                        "latitude": "61.98253000",
                        "longitude": "17.06368000"
                    },
                    {
                        "id": 103067,
                        "name": "Bollnäs",
                        "latitude": "61.34817000",
                        "longitude": "16.39464000"
                    },
                    {
                        "id": 103118,
                        "name": "Delsbo",
                        "latitude": "61.80104000",
                        "longitude": "16.55571000"
                    },
                    {
                        "id": 103129,
                        "name": "Edsbyn",
                        "latitude": "61.37692000",
                        "longitude": "15.81747000"
                    },
                    {
                        "id": 103193,
                        "name": "Färila",
                        "latitude": "61.80011000",
                        "longitude": "15.84422000"
                    },
                    {
                        "id": 103177,
                        "name": "Forsbacka",
                        "latitude": "60.61667000",
                        "longitude": "16.88333000"
                    },
                    {
                        "id": 103240,
                        "name": "Gävle",
                        "latitude": "60.67452000",
                        "longitude": "17.14174000"
                    },
                    {
                        "id": 103214,
                        "name": "Gnarp",
                        "latitude": "62.04874000",
                        "longitude": "17.25858000"
                    },
                    {
                        "id": 103276,
                        "name": "Hedesunda",
                        "latitude": "60.40000000",
                        "longitude": "17.00000000"
                    },
                    {
                        "id": 103293,
                        "name": "Hofors",
                        "latitude": "60.54573000",
                        "longitude": "16.28668000"
                    },
                    {
                        "id": 103305,
                        "name": "Hudiksvall",
                        "latitude": "61.72744000",
                        "longitude": "17.10558000"
                    },
                    {
                        "id": 103344,
                        "name": "Iggesund",
                        "latitude": "61.64219000",
                        "longitude": "17.07477000"
                    },
                    {
                        "id": 103361,
                        "name": "Järbo",
                        "latitude": "60.71667000",
                        "longitude": "16.60000000"
                    },
                    {
                        "id": 103365,
                        "name": "Järvsö",
                        "latitude": "61.71667000",
                        "longitude": "16.16667000"
                    },
                    {
                        "id": 103389,
                        "name": "Kilafors",
                        "latitude": "61.23333000",
                        "longitude": "16.56667000"
                    },
                    {
                        "id": 103485,
                        "name": "Ljusdal",
                        "latitude": "61.82883000",
                        "longitude": "16.09126000"
                    },
                    {
                        "id": 103488,
                        "name": "Ljusne",
                        "latitude": "61.21170000",
                        "longitude": "17.12790000"
                    },
                    {
                        "id": 103607,
                        "name": "Ockelbo",
                        "latitude": "60.89120000",
                        "longitude": "16.71846000"
                    },
                    {
                        "id": 103680,
                        "name": "Sandarne",
                        "latitude": "61.25893000",
                        "longitude": "17.15284000"
                    },
                    {
                        "id": 103681,
                        "name": "Sandviken",
                        "latitude": "60.61667000",
                        "longitude": "16.76667000"
                    },
                    {
                        "id": 103819,
                        "name": "Söderhamn",
                        "latitude": "61.30373000",
                        "longitude": "17.05921000"
                    },
                    {
                        "id": 103832,
                        "name": "Sörforsa",
                        "latitude": "61.73333000",
                        "longitude": "16.98333000"
                    },
                    {
                        "id": 103768,
                        "name": "Storvik",
                        "latitude": "60.58333000",
                        "longitude": "16.53333000"
                    },
                    {
                        "id": 103912,
                        "name": "Valbo",
                        "latitude": "60.65000000",
                        "longitude": "17.03333000"
                    }
                ]
            },
            {
                "id": 1546,
                "name": "Gotland",
                "iso2": "I",
                "latitude": "57.46841210",
                "longitude": "18.48674470",
                "type": "county",
                "cities": [
                    {
                        "id": 103219,
                        "name": "Gotland",
                        "latitude": "57.50000000",
                        "longitude": "18.50000000"
                    },
                    {
                        "id": 103279,
                        "name": "Hemse",
                        "latitude": "57.23788000",
                        "longitude": "18.37443000"
                    },
                    {
                        "id": 103398,
                        "name": "Klintehamn",
                        "latitude": "57.38667000",
                        "longitude": "18.20371000"
                    },
                    {
                        "id": 103940,
                        "name": "Vibble",
                        "latitude": "57.60452000",
                        "longitude": "18.25601000"
                    },
                    {
                        "id": 103957,
                        "name": "Visby",
                        "latitude": "57.64089000",
                        "longitude": "18.29602000"
                    }
                ]
            },
            {
                "id": 1548,
                "name": "Halland",
                "iso2": "N",
                "latitude": "56.89668050",
                "longitude": "12.80339930",
                "type": "county",
                "cities": [
                    {
                        "id": 104005,
                        "name": "Åled",
                        "latitude": "56.75000000",
                        "longitude": "12.93333000"
                    },
                    {
                        "id": 104016,
                        "name": "Åsa",
                        "latitude": "57.35000000",
                        "longitude": "12.11667000"
                    },
                    {
                        "id": 103096,
                        "name": "Bua",
                        "latitude": "57.23780000",
                        "longitude": "12.12187000"
                    },
                    {
                        "id": 103157,
                        "name": "Falkenberg",
                        "latitude": "56.90552000",
                        "longitude": "12.49118000"
                    },
                    {
                        "id": 103172,
                        "name": "Fjärås kyrkby",
                        "latitude": "57.45913000",
                        "longitude": "12.17508000"
                    },
                    {
                        "id": 103182,
                        "name": "Frillesås",
                        "latitude": "57.31667000",
                        "longitude": "12.16667000"
                    },
                    {
                        "id": 103186,
                        "name": "Frösakull",
                        "latitude": "56.68333000",
                        "longitude": "12.73333000"
                    },
                    {
                        "id": 103190,
                        "name": "Fyllinge",
                        "latitude": "56.65000000",
                        "longitude": "12.91667000"
                    },
                    {
                        "id": 103207,
                        "name": "Getinge",
                        "latitude": "56.81667000",
                        "longitude": "12.73333000"
                    },
                    {
                        "id": 103212,
                        "name": "Glommen",
                        "latitude": "56.93333000",
                        "longitude": "12.35000000"
                    },
                    {
                        "id": 103231,
                        "name": "Gullbrandstorp",
                        "latitude": "56.70000000",
                        "longitude": "12.73333000"
                    },
                    {
                        "id": 103258,
                        "name": "Halmstad",
                        "latitude": "56.67446000",
                        "longitude": "12.85676000"
                    },
                    {
                        "id": 103269,
                        "name": "Harplinge",
                        "latitude": "56.74491000",
                        "longitude": "12.72758000"
                    },
                    {
                        "id": 103271,
                        "name": "Haverdal",
                        "latitude": "56.72222000",
                        "longitude": "12.67194000"
                    },
                    {
                        "id": 103314,
                        "name": "Hyltebruk",
                        "latitude": "56.99892000",
                        "longitude": "13.23958000"
                    },
                    {
                        "id": 103405,
                        "name": "Knäred",
                        "latitude": "56.51861000",
                        "longitude": "13.32423000"
                    },
                    {
                        "id": 103423,
                        "name": "Kungsbacka",
                        "latitude": "57.48719000",
                        "longitude": "12.07612000"
                    },
                    {
                        "id": 103447,
                        "name": "Laholm",
                        "latitude": "56.51207000",
                        "longitude": "13.04371000"
                    },
                    {
                        "id": 103535,
                        "name": "Mellbystrand",
                        "latitude": "56.48561000",
                        "longitude": "12.93958000"
                    },
                    {
                        "id": 103538,
                        "name": "Mjällby",
                        "latitude": "56.68333000",
                        "longitude": "12.76667000"
                    },
                    {
                        "id": 103616,
                        "name": "Onsala",
                        "latitude": "57.42531000",
                        "longitude": "12.02903000"
                    },
                    {
                        "id": 103625,
                        "name": "Oskarström",
                        "latitude": "56.80000000",
                        "longitude": "12.96667000"
                    },
                    {
                        "id": 103806,
                        "name": "Särö",
                        "latitude": "57.50577000",
                        "longitude": "11.93210000"
                    },
                    {
                        "id": 103711,
                        "name": "Skrea",
                        "latitude": "56.88333000",
                        "longitude": "12.56667000"
                    },
                    {
                        "id": 103750,
                        "name": "Steninge",
                        "latitude": "56.76900000",
                        "longitude": "12.63034000"
                    },
                    {
                        "id": 103868,
                        "name": "Torup",
                        "latitude": "56.95663000",
                        "longitude": "13.07725000"
                    },
                    {
                        "id": 103879,
                        "name": "Träslövsläge",
                        "latitude": "57.05417000",
                        "longitude": "12.27899000"
                    },
                    {
                        "id": 103880,
                        "name": "Trönninge",
                        "latitude": "56.61667000",
                        "longitude": "12.93333000"
                    },
                    {
                        "id": 103883,
                        "name": "Tvååker",
                        "latitude": "57.04147000",
                        "longitude": "12.39950000"
                    },
                    {
                        "id": 103917,
                        "name": "Vallda",
                        "latitude": "57.47750000",
                        "longitude": "12.00139000"
                    },
                    {
                        "id": 103924,
                        "name": "Varberg",
                        "latitude": "57.10557000",
                        "longitude": "12.25078000"
                    },
                    {
                        "id": 103974,
                        "name": "Västra Hagen",
                        "latitude": "57.42444000",
                        "longitude": "11.93583000"
                    },
                    {
                        "id": 103932,
                        "name": "Veddige",
                        "latitude": "57.26591000",
                        "longitude": "12.33220000"
                    },
                    {
                        "id": 103933,
                        "name": "Veinge",
                        "latitude": "56.55000000",
                        "longitude": "13.06667000"
                    }
                ]
            },
            {
                "id": 5117,
                "name": "Jämtland",
                "iso2": "Z",
                "latitude": "63.28306200",
                "longitude": "14.23828100",
                "type": "county",
                "cities": []
            },
            {
                "id": 1550,
                "name": "Jönköping",
                "iso2": "F",
                "latitude": "57.37084340",
                "longitude": "14.34391740",
                "type": "county",
                "cities": [
                    {
                        "id": 102999,
                        "name": "Anderstorp",
                        "latitude": "57.28333000",
                        "longitude": "13.63333000"
                    },
                    {
                        "id": 103001,
                        "name": "Aneby",
                        "latitude": "57.83895000",
                        "longitude": "14.81016000"
                    },
                    {
                        "id": 103026,
                        "name": "Bankeryd",
                        "latitude": "57.86021000",
                        "longitude": "14.12400000"
                    },
                    {
                        "id": 103060,
                        "name": "Bodafors",
                        "latitude": "57.50000000",
                        "longitude": "14.70000000"
                    },
                    {
                        "id": 103071,
                        "name": "Bor",
                        "latitude": "57.11667000",
                        "longitude": "14.16667000"
                    },
                    {
                        "id": 103083,
                        "name": "Bredaryd",
                        "latitude": "57.17343000",
                        "longitude": "13.73789000"
                    },
                    {
                        "id": 103132,
                        "name": "Ekenässjön",
                        "latitude": "57.49175000",
                        "longitude": "15.02226000"
                    },
                    {
                        "id": 103136,
                        "name": "Eksjö",
                        "latitude": "57.66643000",
                        "longitude": "14.97205000"
                    },
                    {
                        "id": 103178,
                        "name": "Forserum",
                        "latitude": "57.70000000",
                        "longitude": "14.46667000"
                    },
                    {
                        "id": 103181,
                        "name": "Forsheda",
                        "latitude": "57.16415000",
                        "longitude": "13.83016000"
                    },
                    {
                        "id": 103209,
                        "name": "Gislaved",
                        "latitude": "57.30440000",
                        "longitude": "13.54078000"
                    },
                    {
                        "id": 103217,
                        "name": "Gnosjö",
                        "latitude": "57.35850000",
                        "longitude": "13.73686000"
                    },
                    {
                        "id": 103227,
                        "name": "Gränna",
                        "latitude": "58.01667000",
                        "longitude": "14.46667000"
                    },
                    {
                        "id": 103249,
                        "name": "Habo",
                        "latitude": "57.91185000",
                        "longitude": "14.07444000"
                    },
                    {
                        "id": 103284,
                        "name": "Hestra",
                        "latitude": "57.44232000",
                        "longitude": "13.59575000"
                    },
                    {
                        "id": 103285,
                        "name": "Hillerstorp",
                        "latitude": "57.31293000",
                        "longitude": "13.88437000"
                    },
                    {
                        "id": 103310,
                        "name": "Huskvarna",
                        "latitude": "57.78596000",
                        "longitude": "14.30214000"
                    },
                    {
                        "id": 103366,
                        "name": "Jönköping",
                        "latitude": "57.78145000",
                        "longitude": "14.15618000"
                    },
                    {
                        "id": 103387,
                        "name": "Kaxholmen",
                        "latitude": "57.85345000",
                        "longitude": "14.30457000"
                    },
                    {
                        "id": 103450,
                        "name": "Landsbro",
                        "latitude": "57.36667000",
                        "longitude": "14.90000000"
                    },
                    {
                        "id": 103514,
                        "name": "Malmbäck",
                        "latitude": "57.57667000",
                        "longitude": "14.46170000"
                    },
                    {
                        "id": 103523,
                        "name": "Mariannelund",
                        "latitude": "57.61667000",
                        "longitude": "15.56667000"
                    },
                    {
                        "id": 103526,
                        "name": "Marieholm",
                        "latitude": "57.38333000",
                        "longitude": "13.85000000"
                    },
                    {
                        "id": 103550,
                        "name": "Mullsjö",
                        "latitude": "57.91710000",
                        "longitude": "13.87831000"
                    },
                    {
                        "id": 103602,
                        "name": "Nässjö",
                        "latitude": "57.65307000",
                        "longitude": "14.69676000"
                    },
                    {
                        "id": 103610,
                        "name": "Odensjö",
                        "latitude": "57.71667000",
                        "longitude": "14.16667000"
                    },
                    {
                        "id": 103644,
                        "name": "Reftele",
                        "latitude": "57.17467000",
                        "longitude": "13.59498000"
                    },
                    {
                        "id": 103662,
                        "name": "Rydaholm",
                        "latitude": "56.98388000",
                        "longitude": "14.30849000"
                    },
                    {
                        "id": 103814,
                        "name": "Sävsjö",
                        "latitude": "57.40327000",
                        "longitude": "14.66244000"
                    },
                    {
                        "id": 103704,
                        "name": "Skillingaryd",
                        "latitude": "57.43044000",
                        "longitude": "14.09383000"
                    },
                    {
                        "id": 103732,
                        "name": "Smålandsstenar",
                        "latitude": "57.16241000",
                        "longitude": "13.41212000"
                    },
                    {
                        "id": 103757,
                        "name": "Stockaryd",
                        "latitude": "57.31737000",
                        "longitude": "14.59341000"
                    },
                    {
                        "id": 103835,
                        "name": "Taberg",
                        "latitude": "57.67722000",
                        "longitude": "14.08876000"
                    },
                    {
                        "id": 103840,
                        "name": "Tenhult",
                        "latitude": "57.70761000",
                        "longitude": "14.32205000"
                    },
                    {
                        "id": 103871,
                        "name": "Tranås",
                        "latitude": "58.03717000",
                        "longitude": "14.97820000"
                    },
                    {
                        "id": 103909,
                        "name": "Vaggeryd",
                        "latitude": "57.49807000",
                        "longitude": "14.14842000"
                    },
                    {
                        "id": 103968,
                        "name": "Värnamo",
                        "latitude": "57.18604000",
                        "longitude": "14.04001000"
                    },
                    {
                        "id": 103937,
                        "name": "Vetlanda",
                        "latitude": "57.42887000",
                        "longitude": "15.07762000"
                    },
                    {
                        "id": 103961,
                        "name": "Vrigstad",
                        "latitude": "57.35000000",
                        "longitude": "14.46667000"
                    }
                ]
            },
            {
                "id": 1544,
                "name": "Kalmar",
                "iso2": "H",
                "latitude": "57.23501560",
                "longitude": "16.18493490",
                "type": "county",
                "cities": [
                    {
                        "id": 103004,
                        "name": "Ankarsrum",
                        "latitude": "57.69896000",
                        "longitude": "16.33407000"
                    },
                    {
                        "id": 103035,
                        "name": "Bergkvara",
                        "latitude": "56.39063000",
                        "longitude": "16.07274000"
                    },
                    {
                        "id": 103059,
                        "name": "Blomstermåla",
                        "latitude": "56.98333000",
                        "longitude": "16.33333000"
                    },
                    {
                        "id": 103073,
                        "name": "Borgholm",
                        "latitude": "56.87930000",
                        "longitude": "16.65634000"
                    },
                    {
                        "id": 103140,
                        "name": "Emmaboda",
                        "latitude": "56.63268000",
                        "longitude": "15.53648000"
                    },
                    {
                        "id": 103194,
                        "name": "Färjestaden",
                        "latitude": "56.64990000",
                        "longitude": "16.46859000"
                    },
                    {
                        "id": 103201,
                        "name": "Gamleby",
                        "latitude": "57.89485000",
                        "longitude": "16.40508000"
                    },
                    {
                        "id": 103234,
                        "name": "Gunnebo",
                        "latitude": "57.71667000",
                        "longitude": "16.53333000"
                    },
                    {
                        "id": 103331,
                        "name": "Högsby",
                        "latitude": "57.16597000",
                        "longitude": "16.02562000"
                    },
                    {
                        "id": 103307,
                        "name": "Hultsfred",
                        "latitude": "57.48815000",
                        "longitude": "15.84357000"
                    },
                    {
                        "id": 103372,
                        "name": "Kalmar",
                        "latitude": "56.66157000",
                        "longitude": "16.36163000"
                    },
                    {
                        "id": 103413,
                        "name": "Kristdala",
                        "latitude": "57.40070000",
                        "longitude": "16.20496000"
                    },
                    {
                        "id": 103473,
                        "name": "Lindsdal",
                        "latitude": "56.73333000",
                        "longitude": "16.30000000"
                    },
                    {
                        "id": 103481,
                        "name": "Ljungbyholm",
                        "latitude": "56.63333000",
                        "longitude": "16.16667000"
                    },
                    {
                        "id": 103559,
                        "name": "Målilla",
                        "latitude": "57.38773000",
                        "longitude": "15.80675000"
                    },
                    {
                        "id": 103565,
                        "name": "Mönsterås",
                        "latitude": "57.04134000",
                        "longitude": "16.44463000"
                    },
                    {
                        "id": 103568,
                        "name": "Mörbylånga",
                        "latitude": "56.52480000",
                        "longitude": "16.37877000"
                    },
                    {
                        "id": 103593,
                        "name": "Nybro",
                        "latitude": "56.74461000",
                        "longitude": "15.90714000"
                    },
                    {
                        "id": 103623,
                        "name": "Oskarshamn",
                        "latitude": "57.26455000",
                        "longitude": "16.44837000"
                    },
                    {
                        "id": 104056,
                        "name": "Överum",
                        "latitude": "57.98856000",
                        "longitude": "16.31390000"
                    },
                    {
                        "id": 103641,
                        "name": "Påskallavik",
                        "latitude": "57.16667000",
                        "longitude": "16.45000000"
                    },
                    {
                        "id": 103649,
                        "name": "Rinkabyholm",
                        "latitude": "56.64972000",
                        "longitude": "16.26667000"
                    },
                    {
                        "id": 103727,
                        "name": "Smedby",
                        "latitude": "56.67413000",
                        "longitude": "16.24320000"
                    },
                    {
                        "id": 103827,
                        "name": "Södra Sandby",
                        "latitude": "56.56667000",
                        "longitude": "16.61667000"
                    },
                    {
                        "id": 103829,
                        "name": "Södra Vi",
                        "latitude": "57.73993000",
                        "longitude": "15.79391000"
                    },
                    {
                        "id": 103762,
                        "name": "Storebro",
                        "latitude": "57.58333000",
                        "longitude": "15.85000000"
                    },
                    {
                        "id": 103849,
                        "name": "Timmernabben",
                        "latitude": "56.96667000",
                        "longitude": "16.43333000"
                    },
                    {
                        "id": 103866,
                        "name": "Torsås",
                        "latitude": "56.41251000",
                        "longitude": "15.99844000"
                    },
                    {
                        "id": 103873,
                        "name": "Trekanten",
                        "latitude": "56.70000000",
                        "longitude": "16.11667000"
                    },
                    {
                        "id": 103970,
                        "name": "Västervik",
                        "latitude": "57.75840000",
                        "longitude": "16.63733000"
                    },
                    {
                        "id": 103947,
                        "name": "Vimmerby",
                        "latitude": "57.66588000",
                        "longitude": "15.85515000"
                    },
                    {
                        "id": 103956,
                        "name": "Virserum",
                        "latitude": "57.31667000",
                        "longitude": "15.58333000"
                    }
                ]
            },
            {
                "id": 1542,
                "name": "Kronoberg",
                "iso2": "G",
                "latitude": "56.71834030",
                "longitude": "14.41146730",
                "type": "county",
                "cities": [
                    {
                        "id": 103985,
                        "name": "Älmhult",
                        "latitude": "56.55146000",
                        "longitude": "14.13827000"
                    },
                    {
                        "id": 102995,
                        "name": "Alvesta",
                        "latitude": "56.89935000",
                        "longitude": "14.55559000"
                    },
                    {
                        "id": 104018,
                        "name": "Åseda",
                        "latitude": "57.17010000",
                        "longitude": "15.34430000"
                    },
                    {
                        "id": 103082,
                        "name": "Braås",
                        "latitude": "57.06667000",
                        "longitude": "15.05000000"
                    },
                    {
                        "id": 103205,
                        "name": "Gemla",
                        "latitude": "56.86753000",
                        "longitude": "14.64379000"
                    },
                    {
                        "id": 103301,
                        "name": "Hovmantorp",
                        "latitude": "56.78685000",
                        "longitude": "15.14023000"
                    },
                    {
                        "id": 103346,
                        "name": "Ingelstad",
                        "latitude": "56.75000000",
                        "longitude": "14.91667000"
                    },
                    {
                        "id": 103446,
                        "name": "Lagan",
                        "latitude": "56.91667000",
                        "longitude": "13.98333000"
                    },
                    {
                        "id": 103449,
                        "name": "Lammhult",
                        "latitude": "57.16667000",
                        "longitude": "14.58333000"
                    },
                    {
                        "id": 103458,
                        "name": "Lenhovda",
                        "latitude": "57.00000000",
                        "longitude": "15.28333000"
                    },
                    {
                        "id": 103461,
                        "name": "Lessebo",
                        "latitude": "56.75185000",
                        "longitude": "15.26969000"
                    },
                    {
                        "id": 103478,
                        "name": "Ljungby",
                        "latitude": "56.83324000",
                        "longitude": "13.94082000"
                    },
                    {
                        "id": 103531,
                        "name": "Markaryd",
                        "latitude": "56.46135000",
                        "longitude": "13.59644000"
                    },
                    {
                        "id": 103543,
                        "name": "Moheda",
                        "latitude": "57.00000000",
                        "longitude": "14.56667000"
                    },
                    {
                        "id": 103659,
                        "name": "Rottne",
                        "latitude": "57.01667000",
                        "longitude": "14.90000000"
                    },
                    {
                        "id": 103660,
                        "name": "Ryd",
                        "latitude": "56.46667000",
                        "longitude": "14.68333000"
                    },
                    {
                        "id": 103774,
                        "name": "Strömsnäsbruk",
                        "latitude": "56.55000000",
                        "longitude": "13.71667000"
                    },
                    {
                        "id": 103852,
                        "name": "Tingsryd",
                        "latitude": "56.52470000",
                        "longitude": "14.97902000"
                    },
                    {
                        "id": 103975,
                        "name": "Växjö",
                        "latitude": "56.87767000",
                        "longitude": "14.80906000"
                    },
                    {
                        "id": 103959,
                        "name": "Vislanda",
                        "latitude": "56.78333000",
                        "longitude": "14.45000000"
                    }
                ]
            },
            {
                "id": 1538,
                "name": "Norrbotten",
                "iso2": "BD",
                "latitude": "66.83092160",
                "longitude": "20.39919660",
                "type": "county",
                "cities": [
                    {
                        "id": 103993,
                        "name": "Älvsbyn",
                        "latitude": "65.67624000",
                        "longitude": "21.00162000"
                    },
                    {
                        "id": 103010,
                        "name": "Arjeplog",
                        "latitude": "66.05173000",
                        "longitude": "17.88606000"
                    },
                    {
                        "id": 103015,
                        "name": "Arvidsjaur",
                        "latitude": "65.59033000",
                        "longitude": "19.16682000"
                    },
                    {
                        "id": 103036,
                        "name": "Bergnäset",
                        "latitude": "65.57791000",
                        "longitude": "22.10844000"
                    },
                    {
                        "id": 103039,
                        "name": "Bergsviken",
                        "latitude": "65.30000000",
                        "longitude": "21.38333000"
                    },
                    {
                        "id": 103054,
                        "name": "Björkskatan",
                        "latitude": "65.61373000",
                        "longitude": "22.17702000"
                    },
                    {
                        "id": 103061,
                        "name": "Boden",
                        "latitude": "65.82518000",
                        "longitude": "21.68864000"
                    },
                    {
                        "id": 103237,
                        "name": "Gällivare",
                        "latitude": "67.13387000",
                        "longitude": "20.65278000"
                    },
                    {
                        "id": 103202,
                        "name": "Gammelstad",
                        "latitude": "65.63931000",
                        "longitude": "22.01145000"
                    },
                    {
                        "id": 103267,
                        "name": "Haparanda",
                        "latitude": "65.83549000",
                        "longitude": "24.13676000"
                    },
                    {
                        "id": 103299,
                        "name": "Hortlax",
                        "latitude": "65.28188000",
                        "longitude": "21.40544000"
                    },
                    {
                        "id": 103353,
                        "name": "Jokkmokk",
                        "latitude": "66.60665000",
                        "longitude": "19.82324000"
                    },
                    {
                        "id": 103369,
                        "name": "Kalix",
                        "latitude": "65.85298000",
                        "longitude": "23.15645000"
                    },
                    {
                        "id": 103394,
                        "name": "Kiruna",
                        "latitude": "67.85572000",
                        "longitude": "20.22513000"
                    },
                    {
                        "id": 103493,
                        "name": "Luleå",
                        "latitude": "65.58415000",
                        "longitude": "22.15465000"
                    },
                    {
                        "id": 103513,
                        "name": "Malmberget",
                        "latitude": "67.17529000",
                        "longitude": "20.65495000"
                    },
                    {
                        "id": 103528,
                        "name": "Marielund",
                        "latitude": "65.85307000",
                        "longitude": "24.10486000"
                    },
                    {
                        "id": 103585,
                        "name": "Norrfjärden",
                        "latitude": "65.41805000",
                        "longitude": "21.50151000"
                    },
                    {
                        "id": 104052,
                        "name": "Överkalix",
                        "latitude": "66.32754000",
                        "longitude": "22.84414000"
                    },
                    {
                        "id": 104054,
                        "name": "Övertorneå",
                        "latitude": "66.38778000",
                        "longitude": "23.65425000"
                    },
                    {
                        "id": 103630,
                        "name": "Pajala",
                        "latitude": "67.21284000",
                        "longitude": "23.36607000"
                    },
                    {
                        "id": 103637,
                        "name": "Piteå",
                        "latitude": "65.31717000",
                        "longitude": "21.47944000"
                    },
                    {
                        "id": 103668,
                        "name": "Råneå",
                        "latitude": "65.85482000",
                        "longitude": "22.29126000"
                    },
                    {
                        "id": 103652,
                        "name": "Roknäs",
                        "latitude": "65.35000000",
                        "longitude": "21.20000000"
                    },
                    {
                        "id": 103653,
                        "name": "Rolfs",
                        "latitude": "65.85000000",
                        "longitude": "23.11667000"
                    },
                    {
                        "id": 103658,
                        "name": "Rosvik",
                        "latitude": "65.43333000",
                        "longitude": "21.70000000"
                    },
                    {
                        "id": 103812,
                        "name": "Sävast",
                        "latitude": "65.77002000",
                        "longitude": "21.73113000"
                    },
                    {
                        "id": 103828,
                        "name": "Södra Sunderbyn",
                        "latitude": "65.65983000",
                        "longitude": "21.94004000"
                    },
                    {
                        "id": 103891,
                        "name": "Töre",
                        "latitude": "65.91243000",
                        "longitude": "22.65128000"
                    }
                ]
            },
            {
                "id": 1539,
                "name": "Örebro",
                "iso2": "T",
                "latitude": "59.53503600",
                "longitude": "15.00657310",
                "type": "county",
                "cities": [
                    {
                        "id": 104017,
                        "name": "Åsbro",
                        "latitude": "59.00000000",
                        "longitude": "15.05000000"
                    },
                    {
                        "id": 103019,
                        "name": "Askersund",
                        "latitude": "58.87988000",
                        "longitude": "14.90230000"
                    },
                    {
                        "id": 103115,
                        "name": "Degerfors",
                        "latitude": "59.23797000",
                        "longitude": "14.43077000"
                    },
                    {
                        "id": 103131,
                        "name": "Ekeby-Almby",
                        "latitude": "59.26000000",
                        "longitude": "15.33000000"
                    },
                    {
                        "id": 103163,
                        "name": "Fellingsbro",
                        "latitude": "59.43333000",
                        "longitude": "15.58333000"
                    },
                    {
                        "id": 103170,
                        "name": "Fjugesta",
                        "latitude": "59.17375000",
                        "longitude": "14.87227000"
                    },
                    {
                        "id": 103187,
                        "name": "Frövi",
                        "latitude": "59.46667000",
                        "longitude": "15.36667000"
                    },
                    {
                        "id": 103204,
                        "name": "Garphyttan",
                        "latitude": "59.30429000",
                        "longitude": "14.94623000"
                    },
                    {
                        "id": 103316,
                        "name": "Hällabrottet",
                        "latitude": "59.11667000",
                        "longitude": "15.20000000"
                    },
                    {
                        "id": 103318,
                        "name": "Hällefors",
                        "latitude": "59.78388000",
                        "longitude": "14.52197000"
                    },
                    {
                        "id": 103253,
                        "name": "Hallsberg",
                        "latitude": "59.06463000",
                        "longitude": "15.10993000"
                    },
                    {
                        "id": 103302,
                        "name": "Hovsta",
                        "latitude": "59.35000000",
                        "longitude": "15.21667000"
                    },
                    {
                        "id": 103379,
                        "name": "Karlskoga",
                        "latitude": "59.32667000",
                        "longitude": "14.52386000"
                    },
                    {
                        "id": 103409,
                        "name": "Kopparberg",
                        "latitude": "59.87597000",
                        "longitude": "14.99436000"
                    },
                    {
                        "id": 103420,
                        "name": "Kumla",
                        "latitude": "59.12770000",
                        "longitude": "15.14341000"
                    },
                    {
                        "id": 103453,
                        "name": "Laxå",
                        "latitude": "58.98630000",
                        "longitude": "14.61904000"
                    },
                    {
                        "id": 103469,
                        "name": "Lindesberg",
                        "latitude": "59.59202000",
                        "longitude": "15.23040000"
                    },
                    {
                        "id": 103577,
                        "name": "Nora",
                        "latitude": "59.51926000",
                        "longitude": "15.03979000"
                    },
                    {
                        "id": 103609,
                        "name": "Odensbacken",
                        "latitude": "59.16667000",
                        "longitude": "15.53333000"
                    },
                    {
                        "id": 104034,
                        "name": "Örebro",
                        "latitude": "59.27412000",
                        "longitude": "15.20660000"
                    },
                    {
                        "id": 103640,
                        "name": "Pålsboda",
                        "latitude": "59.06565000",
                        "longitude": "15.33747000"
                    },
                    {
                        "id": 103723,
                        "name": "Sköllersta",
                        "latitude": "59.13738000",
                        "longitude": "15.33940000"
                    },
                    {
                        "id": 103770,
                        "name": "Storå",
                        "latitude": "59.71409000",
                        "longitude": "15.13169000"
                    },
                    {
                        "id": 103955,
                        "name": "Vintrosa",
                        "latitude": "59.25000000",
                        "longitude": "14.95000000"
                    }
                ]
            },
            {
                "id": 1536,
                "name": "Östergötland",
                "iso2": "E",
                "latitude": "58.34536350",
                "longitude": "15.51978440",
                "type": "county",
                "cities": [
                    {
                        "id": 103999,
                        "name": "Åby",
                        "latitude": "58.66667000",
                        "longitude": "16.18333000"
                    },
                    {
                        "id": 104023,
                        "name": "Åtvidaberg",
                        "latitude": "58.20152000",
                        "longitude": "15.99770000"
                    },
                    {
                        "id": 103032,
                        "name": "Berg",
                        "latitude": "58.48831000",
                        "longitude": "15.52969000"
                    },
                    {
                        "id": 103072,
                        "name": "Borensberg",
                        "latitude": "58.56667000",
                        "longitude": "15.28333000"
                    },
                    {
                        "id": 103079,
                        "name": "Boxholm",
                        "latitude": "58.19719000",
                        "longitude": "15.05376000"
                    },
                    {
                        "id": 103138,
                        "name": "Ekängen",
                        "latitude": "58.46667000",
                        "longitude": "15.63333000"
                    },
                    {
                        "id": 103166,
                        "name": "Finspång",
                        "latitude": "58.70578000",
                        "longitude": "15.76739000"
                    },
                    {
                        "id": 103221,
                        "name": "Grebo",
                        "latitude": "58.30145000",
                        "longitude": "15.87085000"
                    },
                    {
                        "id": 103236,
                        "name": "Gusum",
                        "latitude": "58.26880000",
                        "longitude": "16.49894000"
                    },
                    {
                        "id": 103281,
                        "name": "Herrestad",
                        "latitude": "58.38333000",
                        "longitude": "14.80000000"
                    },
                    {
                        "id": 103358,
                        "name": "Jursla",
                        "latitude": "58.66667000",
                        "longitude": "16.18333000"
                    },
                    {
                        "id": 103391,
                        "name": "Kimstad",
                        "latitude": "58.54967000",
                        "longitude": "15.96296000"
                    },
                    {
                        "id": 103396,
                        "name": "Kisa",
                        "latitude": "57.98781000",
                        "longitude": "15.63303000"
                    },
                    {
                        "id": 103418,
                        "name": "Krokek",
                        "latitude": "58.67231000",
                        "longitude": "16.36741000"
                    },
                    {
                        "id": 103474,
                        "name": "Lindö",
                        "latitude": "58.61667000",
                        "longitude": "16.25000000"
                    },
                    {
                        "id": 103475,
                        "name": "Linghem",
                        "latitude": "58.43333000",
                        "longitude": "15.78333000"
                    },
                    {
                        "id": 103476,
                        "name": "Linköping",
                        "latitude": "58.41086000",
                        "longitude": "15.62157000"
                    },
                    {
                        "id": 103483,
                        "name": "Ljungsbro",
                        "latitude": "58.51667000",
                        "longitude": "15.50000000"
                    },
                    {
                        "id": 103516,
                        "name": "Malmslätt",
                        "latitude": "58.41102000",
                        "longitude": "15.51647000"
                    },
                    {
                        "id": 103522,
                        "name": "Mantorp",
                        "latitude": "58.35000000",
                        "longitude": "15.28333000"
                    },
                    {
                        "id": 103540,
                        "name": "Mjölby",
                        "latitude": "58.32595000",
                        "longitude": "15.12365000"
                    },
                    {
                        "id": 103548,
                        "name": "Motala",
                        "latitude": "58.53706000",
                        "longitude": "15.03649000"
                    },
                    {
                        "id": 103586,
                        "name": "Norrköping",
                        "latitude": "58.59419000",
                        "longitude": "16.18260000"
                    },
                    {
                        "id": 104027,
                        "name": "Ödeshög",
                        "latitude": "58.22949000",
                        "longitude": "14.65294000"
                    },
                    {
                        "id": 104044,
                        "name": "Österbymo",
                        "latitude": "57.82465000",
                        "longitude": "15.27357000"
                    },
                    {
                        "id": 103647,
                        "name": "Rimforsa",
                        "latitude": "58.13624000",
                        "longitude": "15.68650000"
                    },
                    {
                        "id": 103661,
                        "name": "Ryd",
                        "latitude": "58.66667000",
                        "longitude": "15.08333000"
                    },
                    {
                        "id": 103718,
                        "name": "Skänninge",
                        "latitude": "58.39427000",
                        "longitude": "15.08659000"
                    },
                    {
                        "id": 103719,
                        "name": "Skärblacka",
                        "latitude": "58.56667000",
                        "longitude": "15.90000000"
                    },
                    {
                        "id": 103821,
                        "name": "Söderköping",
                        "latitude": "58.48057000",
                        "longitude": "16.32221000"
                    },
                    {
                        "id": 103752,
                        "name": "Stenstorp",
                        "latitude": "58.48333000",
                        "longitude": "15.06667000"
                    },
                    {
                        "id": 103778,
                        "name": "Sturefors",
                        "latitude": "58.33333000",
                        "longitude": "15.73333000"
                    },
                    {
                        "id": 103803,
                        "name": "Svärtinge",
                        "latitude": "58.65507000",
                        "longitude": "16.02823000"
                    },
                    {
                        "id": 103836,
                        "name": "Tallboda",
                        "latitude": "58.42521000",
                        "longitude": "15.68154000"
                    },
                    {
                        "id": 103907,
                        "name": "Vadstena",
                        "latitude": "58.44863000",
                        "longitude": "14.88969000"
                    },
                    {
                        "id": 103913,
                        "name": "Valdemarsvik",
                        "latitude": "58.20310000",
                        "longitude": "16.60225000"
                    },
                    {
                        "id": 103944,
                        "name": "Vikingstad",
                        "latitude": "58.38304000",
                        "longitude": "15.43201000"
                    }
                ]
            },
            {
                "id": 1541,
                "name": "Skåne",
                "iso2": "M",
                "latitude": "55.99025720",
                "longitude": "13.59576920",
                "type": "county",
                "cities": [
                    {
                        "id": 104000,
                        "name": "Åhus",
                        "latitude": "55.91667000",
                        "longitude": "14.28333000"
                    },
                    {
                        "id": 104002,
                        "name": "Åkarp",
                        "latitude": "55.65396000",
                        "longitude": "13.11107000"
                    },
                    {
                        "id": 102998,
                        "name": "Anderslöv",
                        "latitude": "55.43836000",
                        "longitude": "13.31966000"
                    },
                    {
                        "id": 103996,
                        "name": "Ängelholm",
                        "latitude": "56.24280000",
                        "longitude": "12.86219000"
                    },
                    {
                        "id": 103012,
                        "name": "Arlöv",
                        "latitude": "55.63248000",
                        "longitude": "13.07141000"
                    },
                    {
                        "id": 103021,
                        "name": "Asmundtorp",
                        "latitude": "55.88333000",
                        "longitude": "12.93333000"
                    },
                    {
                        "id": 104021,
                        "name": "Åstorp",
                        "latitude": "56.13566000",
                        "longitude": "12.94430000"
                    },
                    {
                        "id": 103028,
                        "name": "Bara",
                        "latitude": "55.58155000",
                        "longitude": "13.17862000"
                    },
                    {
                        "id": 103104,
                        "name": "Bårslöv",
                        "latitude": "56.00910000",
                        "longitude": "12.80580000"
                    },
                    {
                        "id": 103105,
                        "name": "Båstad",
                        "latitude": "56.42689000",
                        "longitude": "12.85339000"
                    },
                    {
                        "id": 103041,
                        "name": "Billeberga",
                        "latitude": "55.88333000",
                        "longitude": "13.00000000"
                    },
                    {
                        "id": 103042,
                        "name": "Billesholm",
                        "latitude": "56.05000000",
                        "longitude": "13.00000000"
                    },
                    {
                        "id": 103049,
                        "name": "Bjärnum",
                        "latitude": "56.29032000",
                        "longitude": "13.71128000"
                    },
                    {
                        "id": 103050,
                        "name": "Bjärred",
                        "latitude": "55.71667000",
                        "longitude": "13.01667000"
                    },
                    {
                        "id": 103047,
                        "name": "Bjuv",
                        "latitude": "56.08372000",
                        "longitude": "12.91914000"
                    },
                    {
                        "id": 103058,
                        "name": "Blentarp",
                        "latitude": "55.58333000",
                        "longitude": "13.60000000"
                    },
                    {
                        "id": 103087,
                        "name": "Broby",
                        "latitude": "56.25521000",
                        "longitude": "14.07797000"
                    },
                    {
                        "id": 103089,
                        "name": "Bromölla",
                        "latitude": "56.07551000",
                        "longitude": "14.46958000"
                    },
                    {
                        "id": 103097,
                        "name": "Bunkeflostrand",
                        "latitude": "55.54478000",
                        "longitude": "12.92375000"
                    },
                    {
                        "id": 103109,
                        "name": "Dalby",
                        "latitude": "55.66655000",
                        "longitude": "13.34976000"
                    },
                    {
                        "id": 103114,
                        "name": "Degeberga",
                        "latitude": "55.83333000",
                        "longitude": "14.08333000"
                    },
                    {
                        "id": 103130,
                        "name": "Ekeby",
                        "latitude": "56.00000000",
                        "longitude": "12.96667000"
                    },
                    {
                        "id": 103152,
                        "name": "Eslöv",
                        "latitude": "55.83928000",
                        "longitude": "13.30393000"
                    },
                    {
                        "id": 103195,
                        "name": "Färlöv",
                        "latitude": "56.06667000",
                        "longitude": "14.08333000"
                    },
                    {
                        "id": 103171,
                        "name": "Fjälkinge",
                        "latitude": "56.04364000",
                        "longitude": "14.27562000"
                    },
                    {
                        "id": 103196,
                        "name": "Förslöv",
                        "latitude": "56.35000000",
                        "longitude": "12.81667000"
                    },
                    {
                        "id": 103188,
                        "name": "Furulund",
                        "latitude": "55.77380000",
                        "longitude": "13.09022000"
                    },
                    {
                        "id": 103203,
                        "name": "Gantofta",
                        "latitude": "55.98729000",
                        "longitude": "12.80482000"
                    },
                    {
                        "id": 103239,
                        "name": "Gärsnäs",
                        "latitude": "55.54949000",
                        "longitude": "14.17923000"
                    },
                    {
                        "id": 103206,
                        "name": "Genarp",
                        "latitude": "55.59907000",
                        "longitude": "13.39820000"
                    },
                    {
                        "id": 103211,
                        "name": "Glimåkra",
                        "latitude": "56.30000000",
                        "longitude": "14.13333000"
                    },
                    {
                        "id": 103213,
                        "name": "Glumslöv",
                        "latitude": "55.94091000",
                        "longitude": "12.80929000"
                    },
                    {
                        "id": 103315,
                        "name": "Häljarp",
                        "latitude": "55.85000000",
                        "longitude": "12.91667000"
                    },
                    {
                        "id": 103260,
                        "name": "Hammar",
                        "latitude": "56.01667000",
                        "longitude": "14.21667000"
                    },
                    {
                        "id": 103263,
                        "name": "Hanaskog",
                        "latitude": "56.16061000",
                        "longitude": "14.09307000"
                    },
                    {
                        "id": 103325,
                        "name": "Hässleholm",
                        "latitude": "56.15905000",
                        "longitude": "13.76638000"
                    },
                    {
                        "id": 103327,
                        "name": "Hästveda",
                        "latitude": "56.28468000",
                        "longitude": "13.93547000"
                    },
                    {
                        "id": 103277,
                        "name": "Helsingborg",
                        "latitude": "56.05648000",
                        "longitude": "12.78718000"
                    },
                    {
                        "id": 103287,
                        "name": "Hittarp",
                        "latitude": "56.10000000",
                        "longitude": "12.63333000"
                    },
                    {
                        "id": 103291,
                        "name": "Hjärnarp",
                        "latitude": "56.31667000",
                        "longitude": "12.91667000"
                    },
                    {
                        "id": 103292,
                        "name": "Hjärup",
                        "latitude": "55.66880000",
                        "longitude": "13.13931000"
                    },
                    {
                        "id": 103295,
                        "name": "Hofterup",
                        "latitude": "55.80485000",
                        "longitude": "12.97970000"
                    },
                    {
                        "id": 103329,
                        "name": "Höganäs",
                        "latitude": "56.19971000",
                        "longitude": "12.55795000"
                    },
                    {
                        "id": 103334,
                        "name": "Hököpinge",
                        "latitude": "55.49411000",
                        "longitude": "13.00782000"
                    },
                    {
                        "id": 103335,
                        "name": "Höllviken",
                        "latitude": "55.40982000",
                        "longitude": "12.95580000"
                    },
                    {
                        "id": 103342,
                        "name": "Höör",
                        "latitude": "55.93444000",
                        "longitude": "13.53850000"
                    },
                    {
                        "id": 103338,
                        "name": "Hörby",
                        "latitude": "55.85238000",
                        "longitude": "13.66094000"
                    },
                    {
                        "id": 103312,
                        "name": "Hyllinge",
                        "latitude": "56.10000000",
                        "longitude": "12.85000000"
                    },
                    {
                        "id": 103356,
                        "name": "Jonstorp",
                        "latitude": "56.23380000",
                        "longitude": "12.67184000"
                    },
                    {
                        "id": 103440,
                        "name": "Kågeröd",
                        "latitude": "55.99976000",
                        "longitude": "13.08795000"
                    },
                    {
                        "id": 103437,
                        "name": "Kävlinge",
                        "latitude": "55.79188000",
                        "longitude": "13.11021000"
                    },
                    {
                        "id": 103401,
                        "name": "Klågerup",
                        "latitude": "55.59416000",
                        "longitude": "13.24574000"
                    },
                    {
                        "id": 103399,
                        "name": "Klippan",
                        "latitude": "56.13559000",
                        "longitude": "13.13086000"
                    },
                    {
                        "id": 103402,
                        "name": "Knislinge",
                        "latitude": "56.18333000",
                        "longitude": "14.08333000"
                    },
                    {
                        "id": 103443,
                        "name": "Köpingebro",
                        "latitude": "55.45526000",
                        "longitude": "13.93453000"
                    },
                    {
                        "id": 103414,
                        "name": "Kristianstad",
                        "latitude": "56.03129000",
                        "longitude": "14.15242000"
                    },
                    {
                        "id": 103433,
                        "name": "Kvidinge",
                        "latitude": "56.13386000",
                        "longitude": "13.04678000"
                    },
                    {
                        "id": 103451,
                        "name": "Landskrona",
                        "latitude": "55.88620000",
                        "longitude": "12.85880000"
                    },
                    {
                        "id": 103480,
                        "name": "Ljungbyhed",
                        "latitude": "56.07437000",
                        "longitude": "13.24010000"
                    },
                    {
                        "id": 103482,
                        "name": "Ljunghusen",
                        "latitude": "55.39793000",
                        "longitude": "12.92486000"
                    },
                    {
                        "id": 103506,
                        "name": "Löberöd",
                        "latitude": "55.77610000",
                        "longitude": "13.52414000"
                    },
                    {
                        "id": 103507,
                        "name": "Löddeköpinge",
                        "latitude": "55.76667000",
                        "longitude": "13.01667000"
                    },
                    {
                        "id": 103489,
                        "name": "Lomma",
                        "latitude": "55.67244000",
                        "longitude": "13.06849000"
                    },
                    {
                        "id": 103509,
                        "name": "Lönsboda",
                        "latitude": "56.40000000",
                        "longitude": "14.31667000"
                    },
                    {
                        "id": 103495,
                        "name": "Lund",
                        "latitude": "55.70584000",
                        "longitude": "13.19321000"
                    },
                    {
                        "id": 103517,
                        "name": "Malmö",
                        "latitude": "55.60587000",
                        "longitude": "13.00073000"
                    },
                    {
                        "id": 103527,
                        "name": "Marieholm",
                        "latitude": "55.86667000",
                        "longitude": "13.15000000"
                    },
                    {
                        "id": 103567,
                        "name": "Mörarp",
                        "latitude": "56.05749000",
                        "longitude": "12.88018000"
                    },
                    {
                        "id": 103552,
                        "name": "Munka-Ljungby",
                        "latitude": "56.25000000",
                        "longitude": "12.96667000"
                    },
                    {
                        "id": 103604,
                        "name": "Näsum",
                        "latitude": "56.17693000",
                        "longitude": "14.49706000"
                    },
                    {
                        "id": 103584,
                        "name": "Norra Åsum",
                        "latitude": "55.98333000",
                        "longitude": "14.15000000"
                    },
                    {
                        "id": 104030,
                        "name": "Ödåkra",
                        "latitude": "56.10412000",
                        "longitude": "12.74770000"
                    },
                    {
                        "id": 104032,
                        "name": "Önnestad",
                        "latitude": "56.05747000",
                        "longitude": "14.02233000"
                    },
                    {
                        "id": 104037,
                        "name": "Örkelljunga",
                        "latitude": "56.28338000",
                        "longitude": "13.27773000"
                    },
                    {
                        "id": 103621,
                        "name": "Osby",
                        "latitude": "56.38165000",
                        "longitude": "13.99364000"
                    },
                    {
                        "id": 104051,
                        "name": "Östra Ljungby",
                        "latitude": "56.19601000",
                        "longitude": "13.09199000"
                    },
                    {
                        "id": 103629,
                        "name": "Oxie",
                        "latitude": "55.54014000",
                        "longitude": "13.09605000"
                    },
                    {
                        "id": 103639,
                        "name": "Påarp",
                        "latitude": "56.03333000",
                        "longitude": "12.81667000"
                    },
                    {
                        "id": 103635,
                        "name": "Perstorp",
                        "latitude": "56.13829000",
                        "longitude": "13.39476000"
                    },
                    {
                        "id": 103663,
                        "name": "Rydebäck",
                        "latitude": "55.96667000",
                        "longitude": "12.76667000"
                    },
                    {
                        "id": 103664,
                        "name": "Rydsgård",
                        "latitude": "55.47285000",
                        "longitude": "13.58829000"
                    },
                    {
                        "id": 103810,
                        "name": "Sätofta",
                        "latitude": "55.91667000",
                        "longitude": "13.55000000"
                    },
                    {
                        "id": 103683,
                        "name": "Saxtorpsskogen",
                        "latitude": "55.83208000",
                        "longitude": "12.94429000"
                    },
                    {
                        "id": 103685,
                        "name": "Sibbhult",
                        "latitude": "56.26667000",
                        "longitude": "14.20000000"
                    },
                    {
                        "id": 103689,
                        "name": "Simrishamn",
                        "latitude": "55.55653000",
                        "longitude": "14.35037000"
                    },
                    {
                        "id": 103692,
                        "name": "Sjöbo",
                        "latitude": "55.63135000",
                        "longitude": "13.70622000"
                    },
                    {
                        "id": 103695,
                        "name": "Skanör med Falsterbo",
                        "latitude": "55.40000000",
                        "longitude": "12.85000000"
                    },
                    {
                        "id": 103721,
                        "name": "Skåre",
                        "latitude": "55.38333000",
                        "longitude": "13.05000000"
                    },
                    {
                        "id": 103699,
                        "name": "Skegrie",
                        "latitude": "55.40633000",
                        "longitude": "13.07693000"
                    },
                    {
                        "id": 103707,
                        "name": "Skivarp",
                        "latitude": "55.41667000",
                        "longitude": "13.56667000"
                    },
                    {
                        "id": 103714,
                        "name": "Skurup",
                        "latitude": "55.47839000",
                        "longitude": "13.50186000"
                    },
                    {
                        "id": 103731,
                        "name": "Smygehamn",
                        "latitude": "55.34337000",
                        "longitude": "13.36989000"
                    },
                    {
                        "id": 103826,
                        "name": "Södra Sandby",
                        "latitude": "55.71677000",
                        "longitude": "13.34659000"
                    },
                    {
                        "id": 103834,
                        "name": "Sösdala",
                        "latitude": "56.03992000",
                        "longitude": "13.67811000"
                    },
                    {
                        "id": 103744,
                        "name": "Staffanstorp",
                        "latitude": "55.64277000",
                        "longitude": "13.20638000"
                    },
                    {
                        "id": 103781,
                        "name": "Stångby",
                        "latitude": "55.75030000",
                        "longitude": "13.19797000"
                    },
                    {
                        "id": 103748,
                        "name": "Stehag",
                        "latitude": "55.90188000",
                        "longitude": "13.39577000"
                    },
                    {
                        "id": 103777,
                        "name": "Strövelstorp",
                        "latitude": "56.16979000",
                        "longitude": "12.83925000"
                    },
                    {
                        "id": 103794,
                        "name": "Svalöv",
                        "latitude": "55.91340000",
                        "longitude": "13.10762000"
                    },
                    {
                        "id": 103797,
                        "name": "Svedala",
                        "latitude": "55.50788000",
                        "longitude": "13.23515000"
                    },
                    {
                        "id": 103839,
                        "name": "Teckomatorp",
                        "latitude": "55.86667000",
                        "longitude": "13.08333000"
                    },
                    {
                        "id": 103856,
                        "name": "Tollarp",
                        "latitude": "55.93333000",
                        "longitude": "13.98333000"
                    },
                    {
                        "id": 103857,
                        "name": "Tollarp1",
                        "latitude": "56.16667000",
                        "longitude": "14.28333000"
                    },
                    {
                        "id": 103858,
                        "name": "Tomelilla",
                        "latitude": "55.54293000",
                        "longitude": "13.95460000"
                    },
                    {
                        "id": 103860,
                        "name": "Torekov",
                        "latitude": "56.42500000",
                        "longitude": "12.63333000"
                    },
                    {
                        "id": 103861,
                        "name": "Tormestorp",
                        "latitude": "56.11350000",
                        "longitude": "13.74516000"
                    },
                    {
                        "id": 103874,
                        "name": "Trelleborg",
                        "latitude": "55.37514000",
                        "longitude": "13.15691000"
                    },
                    {
                        "id": 103884,
                        "name": "Tygelsjö",
                        "latitude": "55.51667000",
                        "longitude": "13.00000000"
                    },
                    {
                        "id": 103886,
                        "name": "Tyringe",
                        "latitude": "56.16037000",
                        "longitude": "13.59811000"
                    },
                    {
                        "id": 103915,
                        "name": "Valje",
                        "latitude": "56.06279000",
                        "longitude": "14.54388000"
                    },
                    {
                        "id": 103931,
                        "name": "Veberöd",
                        "latitude": "55.63333000",
                        "longitude": "13.48333000"
                    },
                    {
                        "id": 103934,
                        "name": "Vejbystrand",
                        "latitude": "56.31778000",
                        "longitude": "12.76722000"
                    },
                    {
                        "id": 103935,
                        "name": "Vellinge",
                        "latitude": "55.47124000",
                        "longitude": "13.01971000"
                    },
                    {
                        "id": 103943,
                        "name": "Viken",
                        "latitude": "56.15063000",
                        "longitude": "12.57429000"
                    },
                    {
                        "id": 103954,
                        "name": "Vinslöv",
                        "latitude": "56.10000000",
                        "longitude": "13.91667000"
                    },
                    {
                        "id": 103960,
                        "name": "Vittsjö",
                        "latitude": "56.34366000",
                        "longitude": "13.66081000"
                    },
                    {
                        "id": 103983,
                        "name": "Ystad",
                        "latitude": "55.42966000",
                        "longitude": "13.82041000"
                    }
                ]
            },
            {
                "id": 1540,
                "name": "Södermanland",
                "iso2": "D",
                "latitude": "59.03363490",
                "longitude": "16.75188990",
                "type": "county",
                "cities": [
                    {
                        "id": 104003,
                        "name": "Åkers Styckebruk",
                        "latitude": "59.25000000",
                        "longitude": "17.08333000"
                    },
                    {
                        "id": 103998,
                        "name": "Ärla",
                        "latitude": "59.27983000",
                        "longitude": "16.67896000"
                    },
                    {
                        "id": 103013,
                        "name": "Arnö",
                        "latitude": "58.72675000",
                        "longitude": "17.02322000"
                    },
                    {
                        "id": 103027,
                        "name": "Bara",
                        "latitude": "58.68333000",
                        "longitude": "17.06667000"
                    },
                    {
                        "id": 103150,
                        "name": "Eskilstuna",
                        "latitude": "59.36661000",
                        "longitude": "16.50770000"
                    },
                    {
                        "id": 103173,
                        "name": "Flen",
                        "latitude": "59.05834000",
                        "longitude": "16.58781000"
                    },
                    {
                        "id": 103215,
                        "name": "Gnesta",
                        "latitude": "59.04751000",
                        "longitude": "17.31191000"
                    },
                    {
                        "id": 103317,
                        "name": "Hällbybrunn",
                        "latitude": "59.39152000",
                        "longitude": "16.42229000"
                    },
                    {
                        "id": 103320,
                        "name": "Hälleforsnäs",
                        "latitude": "59.15208000",
                        "longitude": "16.49700000"
                    },
                    {
                        "id": 103385,
                        "name": "Katrineholm",
                        "latitude": "58.99587000",
                        "longitude": "16.20721000"
                    },
                    {
                        "id": 103432,
                        "name": "Kvicksund",
                        "latitude": "59.45099000",
                        "longitude": "16.32131000"
                    },
                    {
                        "id": 103515,
                        "name": "Malmköping",
                        "latitude": "59.13333000",
                        "longitude": "16.73333000"
                    },
                    {
                        "id": 103525,
                        "name": "Mariefred",
                        "latitude": "59.25963000",
                        "longitude": "17.22300000"
                    },
                    {
                        "id": 103598,
                        "name": "Nyköping",
                        "latitude": "58.75300000",
                        "longitude": "17.00788000"
                    },
                    {
                        "id": 103614,
                        "name": "Olstorp",
                        "latitude": "58.81667000",
                        "longitude": "16.63333000"
                    },
                    {
                        "id": 103627,
                        "name": "Oxelösund",
                        "latitude": "58.67057000",
                        "longitude": "17.10152000"
                    },
                    {
                        "id": 103709,
                        "name": "Skogstorp",
                        "latitude": "59.32472000",
                        "longitude": "16.48284000"
                    },
                    {
                        "id": 103746,
                        "name": "Stallarholmen",
                        "latitude": "59.36667000",
                        "longitude": "17.20000000"
                    },
                    {
                        "id": 103756,
                        "name": "Stigtomta",
                        "latitude": "58.80000000",
                        "longitude": "16.78333000"
                    },
                    {
                        "id": 103771,
                        "name": "Strängnäs",
                        "latitude": "59.37741000",
                        "longitude": "17.03119000"
                    },
                    {
                        "id": 103793,
                        "name": "Svalsta",
                        "latitude": "58.74273000",
                        "longitude": "16.86978000"
                    },
                    {
                        "id": 103864,
                        "name": "Torshälla",
                        "latitude": "59.41667000",
                        "longitude": "16.46667000"
                    },
                    {
                        "id": 103877,
                        "name": "Trosa",
                        "latitude": "58.89621000",
                        "longitude": "17.54812000"
                    },
                    {
                        "id": 103911,
                        "name": "Vagnhärad",
                        "latitude": "58.94587000",
                        "longitude": "17.48757000"
                    },
                    {
                        "id": 103916,
                        "name": "Valla",
                        "latitude": "59.01667000",
                        "longitude": "16.38333000"
                    },
                    {
                        "id": 103951,
                        "name": "Vingåker",
                        "latitude": "59.04330000",
                        "longitude": "15.87374000"
                    }
                ]
            },
            {
                "id": 1551,
                "name": "Stockholm",
                "iso2": "AB",
                "latitude": "59.60249580",
                "longitude": "18.13843830",
                "type": "county",
                "cities": [
                    {
                        "id": 102986,
                        "name": "Akalla",
                        "latitude": "59.41465000",
                        "longitude": "17.91398000"
                    },
                    {
                        "id": 104004,
                        "name": "Åkersberga",
                        "latitude": "59.47944000",
                        "longitude": "18.29967000"
                    },
                    {
                        "id": 102988,
                        "name": "Alby",
                        "latitude": "59.23350000",
                        "longitude": "17.85380000"
                    },
                    {
                        "id": 103987,
                        "name": "Älmsta",
                        "latitude": "59.96667000",
                        "longitude": "18.80000000"
                    },
                    {
                        "id": 103988,
                        "name": "Älta",
                        "latitude": "59.26667000",
                        "longitude": "18.18333000"
                    },
                    {
                        "id": 103014,
                        "name": "Arnö",
                        "latitude": "60.11667000",
                        "longitude": "18.63333000"
                    },
                    {
                        "id": 104013,
                        "name": "Årsta",
                        "latitude": "59.29780000",
                        "longitude": "18.05140000"
                    },
                    {
                        "id": 103037,
                        "name": "Bergshamra",
                        "latitude": "59.38083000",
                        "longitude": "18.03427000"
                    },
                    {
                        "id": 103066,
                        "name": "Bollmora",
                        "latitude": "59.24196000",
                        "longitude": "18.22762000"
                    },
                    {
                        "id": 103070,
                        "name": "Boo",
                        "latitude": "59.33333000",
                        "longitude": "18.28333000"
                    },
                    {
                        "id": 103085,
                        "name": "Brevik",
                        "latitude": "59.35000000",
                        "longitude": "18.20000000"
                    },
                    {
                        "id": 103086,
                        "name": "Bro",
                        "latitude": "59.51667000",
                        "longitude": "17.63333000"
                    },
                    {
                        "id": 103088,
                        "name": "Bromma",
                        "latitude": "59.34000000",
                        "longitude": "17.94000000"
                    },
                    {
                        "id": 103091,
                        "name": "Brunn",
                        "latitude": "59.28000000",
                        "longitude": "18.43000000"
                    },
                    {
                        "id": 103092,
                        "name": "Brunna",
                        "latitude": "59.51667000",
                        "longitude": "17.75000000"
                    },
                    {
                        "id": 103108,
                        "name": "Dalarö",
                        "latitude": "59.13306000",
                        "longitude": "18.40639000"
                    },
                    {
                        "id": 103123,
                        "name": "Djurö",
                        "latitude": "59.32653000",
                        "longitude": "18.71152000"
                    },
                    {
                        "id": 103121,
                        "name": "Djursholm",
                        "latitude": "59.39926000",
                        "longitude": "18.05619000"
                    },
                    {
                        "id": 103133,
                        "name": "Ekerö",
                        "latitude": "59.29100000",
                        "longitude": "17.81212000"
                    },
                    {
                        "id": 103143,
                        "name": "Enebyberg",
                        "latitude": "59.43333000",
                        "longitude": "18.05000000"
                    },
                    {
                        "id": 103147,
                        "name": "Eriksberg",
                        "latitude": "59.24241000",
                        "longitude": "17.81631000"
                    },
                    {
                        "id": 103168,
                        "name": "Fisksätra",
                        "latitude": "59.29153000",
                        "longitude": "18.25490000"
                    },
                    {
                        "id": 103169,
                        "name": "Fittja",
                        "latitude": "59.24868000",
                        "longitude": "17.85991000"
                    },
                    {
                        "id": 103199,
                        "name": "Gamla Stan",
                        "latitude": "59.32627000",
                        "longitude": "18.07251000"
                    },
                    {
                        "id": 103235,
                        "name": "Gustavsberg",
                        "latitude": "59.32684000",
                        "longitude": "18.38975000"
                    },
                    {
                        "id": 103257,
                        "name": "Hallstavik",
                        "latitude": "60.05000000",
                        "longitude": "18.60000000"
                    },
                    {
                        "id": 103264,
                        "name": "Handen",
                        "latitude": "59.16809000",
                        "longitude": "18.13796000"
                    },
                    {
                        "id": 103265,
                        "name": "Haninge",
                        "latitude": "59.16775000",
                        "longitude": "18.14478000"
                    },
                    {
                        "id": 103278,
                        "name": "Hemmesta",
                        "latitude": "59.32273000",
                        "longitude": "18.48675000"
                    },
                    {
                        "id": 103336,
                        "name": "Hölö",
                        "latitude": "59.01667000",
                        "longitude": "17.53333000"
                    },
                    {
                        "id": 103303,
                        "name": "Huddinge",
                        "latitude": "59.23705000",
                        "longitude": "17.98192000"
                    },
                    {
                        "id": 103351,
                        "name": "Jakobsberg",
                        "latitude": "59.42268000",
                        "longitude": "17.83508000"
                    },
                    {
                        "id": 103363,
                        "name": "Järna",
                        "latitude": "59.09165000",
                        "longitude": "17.56615000"
                    },
                    {
                        "id": 103357,
                        "name": "Jordbro",
                        "latitude": "59.14972000",
                        "longitude": "18.11667000"
                    },
                    {
                        "id": 103397,
                        "name": "Kista",
                        "latitude": "59.40316000",
                        "longitude": "17.94479000"
                    },
                    {
                        "id": 103410,
                        "name": "Kopparmora",
                        "latitude": "59.33306000",
                        "longitude": "18.58306000"
                    },
                    {
                        "id": 103422,
                        "name": "Kummelnäs",
                        "latitude": "59.35000000",
                        "longitude": "18.28333000"
                    },
                    {
                        "id": 103427,
                        "name": "Kungsängen",
                        "latitude": "59.47857000",
                        "longitude": "17.74834000"
                    },
                    {
                        "id": 103426,
                        "name": "Kungsholmen",
                        "latitude": "59.33183000",
                        "longitude": "18.04118000"
                    },
                    {
                        "id": 103505,
                        "name": "Långvik",
                        "latitude": "59.24583000",
                        "longitude": "18.51667000"
                    },
                    {
                        "id": 103463,
                        "name": "Lidingö",
                        "latitude": "59.36303000",
                        "longitude": "18.15096000"
                    },
                    {
                        "id": 103471,
                        "name": "Lindholmen",
                        "latitude": "59.58333000",
                        "longitude": "18.10000000"
                    },
                    {
                        "id": 103558,
                        "name": "Märsta",
                        "latitude": "59.62157000",
                        "longitude": "17.85476000"
                    },
                    {
                        "id": 103561,
                        "name": "Mölnbo",
                        "latitude": "59.05000000",
                        "longitude": "17.41667000"
                    },
                    {
                        "id": 103571,
                        "name": "Mörtnäs",
                        "latitude": "59.31862000",
                        "longitude": "18.44312000"
                    },
                    {
                        "id": 103572,
                        "name": "Nacka",
                        "latitude": "59.31053000",
                        "longitude": "18.16372000"
                    },
                    {
                        "id": 103588,
                        "name": "Norrtälje",
                        "latitude": "59.75799000",
                        "longitude": "18.70496000"
                    },
                    {
                        "id": 103596,
                        "name": "Nykvarn",
                        "latitude": "59.80000000",
                        "longitude": "18.30000000"
                    },
                    {
                        "id": 103600,
                        "name": "Nynäshamn",
                        "latitude": "58.90337000",
                        "longitude": "17.94793000"
                    },
                    {
                        "id": 104042,
                        "name": "Ösmo",
                        "latitude": "58.98333000",
                        "longitude": "17.90000000"
                    },
                    {
                        "id": 104045,
                        "name": "Östermalm",
                        "latitude": "59.33879000",
                        "longitude": "18.08487000"
                    },
                    {
                        "id": 103634,
                        "name": "Pershagen",
                        "latitude": "59.15494000",
                        "longitude": "17.65340000"
                    },
                    {
                        "id": 103669,
                        "name": "Råsunda",
                        "latitude": "59.36588000",
                        "longitude": "17.99569000"
                    },
                    {
                        "id": 103645,
                        "name": "Resarö",
                        "latitude": "59.42910000",
                        "longitude": "18.33386000"
                    },
                    {
                        "id": 103646,
                        "name": "Rimbo",
                        "latitude": "59.75000000",
                        "longitude": "18.36667000"
                    },
                    {
                        "id": 103648,
                        "name": "Rindö",
                        "latitude": "59.39688000",
                        "longitude": "18.39434000"
                    },
                    {
                        "id": 103673,
                        "name": "Rönninge",
                        "latitude": "59.20000000",
                        "longitude": "17.73333000"
                    },
                    {
                        "id": 103657,
                        "name": "Rosersberg",
                        "latitude": "59.58333000",
                        "longitude": "17.88333000"
                    },
                    {
                        "id": 103678,
                        "name": "Saltsjöbaden",
                        "latitude": "59.28333000",
                        "longitude": "18.30000000"
                    },
                    {
                        "id": 103684,
                        "name": "Segeltorp",
                        "latitude": "59.27597000",
                        "longitude": "17.93072000"
                    },
                    {
                        "id": 103686,
                        "name": "Sigtuna",
                        "latitude": "59.61731000",
                        "longitude": "17.72361000"
                    },
                    {
                        "id": 103717,
                        "name": "Skänninge",
                        "latitude": "59.93333000",
                        "longitude": "18.48333000"
                    },
                    {
                        "id": 103823,
                        "name": "Södermalm",
                        "latitude": "59.31278000",
                        "longitude": "18.07577000"
                    },
                    {
                        "id": 103824,
                        "name": "Södertälje",
                        "latitude": "59.19554000",
                        "longitude": "17.62525000"
                    },
                    {
                        "id": 103737,
                        "name": "Sollentuna",
                        "latitude": "59.42804000",
                        "longitude": "17.95093000"
                    },
                    {
                        "id": 103739,
                        "name": "Solna",
                        "latitude": "59.36004000",
                        "longitude": "18.00086000"
                    },
                    {
                        "id": 103747,
                        "name": "Stavsnäs",
                        "latitude": "59.28333000",
                        "longitude": "18.68333000"
                    },
                    {
                        "id": 103749,
                        "name": "Stenhamra",
                        "latitude": "59.33440000",
                        "longitude": "17.68842000"
                    },
                    {
                        "id": 103758,
                        "name": "Stockholm",
                        "latitude": "59.33258000",
                        "longitude": "18.06490000"
                    },
                    {
                        "id": 103773,
                        "name": "Strömma",
                        "latitude": "59.28333000",
                        "longitude": "18.53333000"
                    },
                    {
                        "id": 103783,
                        "name": "Sundbyberg",
                        "latitude": "59.36128000",
                        "longitude": "17.97114000"
                    },
                    {
                        "id": 103841,
                        "name": "Tensta",
                        "latitude": "59.39390000",
                        "longitude": "17.90111000"
                    },
                    {
                        "id": 103881,
                        "name": "Tullinge",
                        "latitude": "59.20000000",
                        "longitude": "17.90000000"
                    },
                    {
                        "id": 103882,
                        "name": "Tumba",
                        "latitude": "59.19858000",
                        "longitude": "17.83317000"
                    },
                    {
                        "id": 103900,
                        "name": "Upplands Väsby",
                        "latitude": "59.51839000",
                        "longitude": "17.91128000"
                    },
                    {
                        "id": 103918,
                        "name": "Vallentuna",
                        "latitude": "59.53436000",
                        "longitude": "18.07758000"
                    },
                    {
                        "id": 103978,
                        "name": "Vårby",
                        "latitude": "59.26671000",
                        "longitude": "17.88407000"
                    },
                    {
                        "id": 103981,
                        "name": "Vårsta",
                        "latitude": "59.16528000",
                        "longitude": "17.79722000"
                    },
                    {
                        "id": 103927,
                        "name": "Vasastan",
                        "latitude": "59.34571000",
                        "longitude": "18.04985000"
                    },
                    {
                        "id": 103929,
                        "name": "Vaxholm",
                        "latitude": "59.40225000",
                        "longitude": "18.35317000"
                    }
                ]
            },
            {
                "id": 1545,
                "name": "Uppsala",
                "iso2": "C",
                "latitude": "60.00922620",
                "longitude": "17.27145880",
                "type": "county",
                "cities": [
                    {
                        "id": 102993,
                        "name": "Alsike",
                        "latitude": "59.75324000",
                        "longitude": "17.77331000"
                    },
                    {
                        "id": 102994,
                        "name": "Alunda",
                        "latitude": "60.26667000",
                        "longitude": "18.40000000"
                    },
                    {
                        "id": 103991,
                        "name": "Älvkarleby",
                        "latitude": "60.57081000",
                        "longitude": "17.44895000"
                    },
                    {
                        "id": 103005,
                        "name": "Anneberg",
                        "latitude": "60.24167000",
                        "longitude": "18.41667000"
                    },
                    {
                        "id": 103102,
                        "name": "Bälinge",
                        "latitude": "59.95000000",
                        "longitude": "17.53333000"
                    },
                    {
                        "id": 103103,
                        "name": "Bålsta",
                        "latitude": "59.56710000",
                        "longitude": "17.52781000"
                    },
                    {
                        "id": 103053,
                        "name": "Björklinge",
                        "latitude": "60.03004000",
                        "longitude": "17.55203000"
                    },
                    {
                        "id": 103145,
                        "name": "Enköping",
                        "latitude": "59.63607000",
                        "longitude": "17.07768000"
                    },
                    {
                        "id": 103200,
                        "name": "Gamla Uppsala",
                        "latitude": "59.89817000",
                        "longitude": "17.63386000"
                    },
                    {
                        "id": 103208,
                        "name": "Gimo",
                        "latitude": "60.17304000",
                        "longitude": "18.18507000"
                    },
                    {
                        "id": 103222,
                        "name": "Grillby",
                        "latitude": "59.62603000",
                        "longitude": "17.25787000"
                    },
                    {
                        "id": 103272,
                        "name": "Heby",
                        "latitude": "59.93815000",
                        "longitude": "16.86217000"
                    },
                    {
                        "id": 103350,
                        "name": "Irsta",
                        "latitude": "59.70000000",
                        "longitude": "16.93333000"
                    },
                    {
                        "id": 103374,
                        "name": "Karlholmsbruk",
                        "latitude": "60.52091000",
                        "longitude": "17.63152000"
                    },
                    {
                        "id": 103403,
                        "name": "Knivsta",
                        "latitude": "59.72564000",
                        "longitude": "17.78753000"
                    },
                    {
                        "id": 103511,
                        "name": "Lövstalöt",
                        "latitude": "59.95740000",
                        "longitude": "17.57826000"
                    },
                    {
                        "id": 103524,
                        "name": "Marieberg",
                        "latitude": "60.23333000",
                        "longitude": "18.50000000"
                    },
                    {
                        "id": 103547,
                        "name": "Morgongåva",
                        "latitude": "59.93395000",
                        "longitude": "16.96353000"
                    },
                    {
                        "id": 104033,
                        "name": "Örbyhus",
                        "latitude": "60.22407000",
                        "longitude": "17.70138000"
                    },
                    {
                        "id": 104036,
                        "name": "Öregrund",
                        "latitude": "60.33333000",
                        "longitude": "18.43333000"
                    },
                    {
                        "id": 104041,
                        "name": "Örsundsbro",
                        "latitude": "59.73333000",
                        "longitude": "17.30000000"
                    },
                    {
                        "id": 104043,
                        "name": "Österbybruk",
                        "latitude": "60.20000000",
                        "longitude": "17.90000000"
                    },
                    {
                        "id": 104046,
                        "name": "Östervåla",
                        "latitude": "60.18333000",
                        "longitude": "17.18333000"
                    },
                    {
                        "id": 104048,
                        "name": "Östhammar",
                        "latitude": "60.25909000",
                        "longitude": "18.37408000"
                    },
                    {
                        "id": 103813,
                        "name": "Sävja",
                        "latitude": "59.81872000",
                        "longitude": "17.69958000"
                    },
                    {
                        "id": 103716,
                        "name": "Skutskär",
                        "latitude": "60.62507000",
                        "longitude": "17.41552000"
                    },
                    {
                        "id": 103817,
                        "name": "Söderfors",
                        "latitude": "60.38333000",
                        "longitude": "17.23333000"
                    },
                    {
                        "id": 103769,
                        "name": "Storvreta",
                        "latitude": "59.95933000",
                        "longitude": "17.70588000"
                    },
                    {
                        "id": 103889,
                        "name": "Tärnsjö",
                        "latitude": "60.15000000",
                        "longitude": "16.93333000"
                    },
                    {
                        "id": 103846,
                        "name": "Tierp",
                        "latitude": "60.34269000",
                        "longitude": "17.51812000"
                    },
                    {
                        "id": 103903,
                        "name": "Uppsala",
                        "latitude": "59.85882000",
                        "longitude": "17.63889000"
                    },
                    {
                        "id": 103928,
                        "name": "Vattholma",
                        "latitude": "60.01667000",
                        "longitude": "17.73333000"
                    }
                ]
            },
            {
                "id": 1535,
                "name": "Värmland",
                "iso2": "S",
                "latitude": "59.72940650",
                "longitude": "13.23540240",
                "type": "county",
                "cities": [
                    {
                        "id": 104006,
                        "name": "Åmotfors",
                        "latitude": "59.76191000",
                        "longitude": "12.36211000"
                    },
                    {
                        "id": 104011,
                        "name": "Årjäng",
                        "latitude": "59.39217000",
                        "longitude": "12.13336000"
                    },
                    {
                        "id": 103017,
                        "name": "Arvika",
                        "latitude": "59.65528000",
                        "longitude": "12.58518000"
                    },
                    {
                        "id": 103057,
                        "name": "Björneborg",
                        "latitude": "59.24122000",
                        "longitude": "14.24942000"
                    },
                    {
                        "id": 103107,
                        "name": "Charlottenberg",
                        "latitude": "59.88422000",
                        "longitude": "12.30398000"
                    },
                    {
                        "id": 103117,
                        "name": "Deje",
                        "latitude": "59.60300000",
                        "longitude": "13.47200000"
                    },
                    {
                        "id": 103135,
                        "name": "Ekshärad",
                        "latitude": "60.17275000",
                        "longitude": "13.49647000"
                    },
                    {
                        "id": 103164,
                        "name": "Filipstad",
                        "latitude": "59.71236000",
                        "longitude": "14.16831000"
                    },
                    {
                        "id": 103179,
                        "name": "Forshaga",
                        "latitude": "59.52541000",
                        "longitude": "13.48127000"
                    },
                    {
                        "id": 103223,
                        "name": "Grums",
                        "latitude": "59.35141000",
                        "longitude": "13.11105000"
                    },
                    {
                        "id": 103251,
                        "name": "Hagfors",
                        "latitude": "60.02378000",
                        "longitude": "13.67214000"
                    },
                    {
                        "id": 103383,
                        "name": "Karlstad",
                        "latitude": "59.37930000",
                        "longitude": "13.50357000"
                    },
                    {
                        "id": 103388,
                        "name": "Kil",
                        "latitude": "59.50234000",
                        "longitude": "13.31277000"
                    },
                    {
                        "id": 103416,
                        "name": "Kristinehamn",
                        "latitude": "59.30978000",
                        "longitude": "14.10808000"
                    },
                    {
                        "id": 103544,
                        "name": "Molkom",
                        "latitude": "59.60057000",
                        "longitude": "13.72115000"
                    },
                    {
                        "id": 103555,
                        "name": "Munkfors",
                        "latitude": "59.83856000",
                        "longitude": "13.54361000"
                    },
                    {
                        "id": 103670,
                        "name": "Råtorp",
                        "latitude": "59.40197000",
                        "longitude": "13.49144000"
                    },
                    {
                        "id": 103804,
                        "name": "Säffle",
                        "latitude": "59.13229000",
                        "longitude": "12.92888000"
                    },
                    {
                        "id": 103722,
                        "name": "Skåre",
                        "latitude": "59.43333000",
                        "longitude": "13.43333000"
                    },
                    {
                        "id": 103698,
                        "name": "Skattkärr",
                        "latitude": "59.41208000",
                        "longitude": "13.67078000"
                    },
                    {
                        "id": 103708,
                        "name": "Skoghall",
                        "latitude": "59.32324000",
                        "longitude": "13.46552000"
                    },
                    {
                        "id": 103726,
                        "name": "Slottsbron",
                        "latitude": "59.32270000",
                        "longitude": "13.10268000"
                    },
                    {
                        "id": 103763,
                        "name": "Storfors",
                        "latitude": "59.53183000",
                        "longitude": "14.27201000"
                    },
                    {
                        "id": 103788,
                        "name": "Sunne",
                        "latitude": "59.83764000",
                        "longitude": "13.14302000"
                    },
                    {
                        "id": 103890,
                        "name": "Töcksfors",
                        "latitude": "59.50816000",
                        "longitude": "11.84431000"
                    },
                    {
                        "id": 103862,
                        "name": "Torsby",
                        "latitude": "60.13527000",
                        "longitude": "13.00820000"
                    },
                    {
                        "id": 103977,
                        "name": "Vålberg",
                        "latitude": "59.39145000",
                        "longitude": "13.18633000"
                    }
                ]
            },
            {
                "id": 1543,
                "name": "Västerbotten",
                "iso2": "AC",
                "latitude": "65.33373110",
                "longitude": "16.51616940",
                "type": "county",
                "cities": [
                    {
                        "id": 104019,
                        "name": "Åsele",
                        "latitude": "64.16026000",
                        "longitude": "17.34762000"
                    },
                    {
                        "id": 103025,
                        "name": "Backa",
                        "latitude": "64.98333000",
                        "longitude": "21.06667000"
                    },
                    {
                        "id": 103044,
                        "name": "Bjurholm",
                        "latitude": "63.93027000",
                        "longitude": "19.21369000"
                    },
                    {
                        "id": 103063,
                        "name": "Boliden",
                        "latitude": "64.86667000",
                        "longitude": "20.38333000"
                    },
                    {
                        "id": 103098,
                        "name": "Bureå",
                        "latitude": "64.61667000",
                        "longitude": "21.20000000"
                    },
                    {
                        "id": 103100,
                        "name": "Burträsk",
                        "latitude": "64.51667000",
                        "longitude": "20.65000000"
                    },
                    {
                        "id": 103101,
                        "name": "Byske",
                        "latitude": "64.95258000",
                        "longitude": "21.20580000"
                    },
                    {
                        "id": 103125,
                        "name": "Dorotea",
                        "latitude": "64.26185000",
                        "longitude": "16.41306000"
                    },
                    {
                        "id": 103149,
                        "name": "Ersmark",
                        "latitude": "63.88333000",
                        "longitude": "20.31667000"
                    },
                    {
                        "id": 103176,
                        "name": "Forsbacka",
                        "latitude": "64.76667000",
                        "longitude": "20.50000000"
                    },
                    {
                        "id": 103296,
                        "name": "Holmsund",
                        "latitude": "63.70602000",
                        "longitude": "20.36409000"
                    },
                    {
                        "id": 103340,
                        "name": "Hörnefors",
                        "latitude": "63.62312000",
                        "longitude": "19.90856000"
                    },
                    {
                        "id": 103348,
                        "name": "Insjön",
                        "latitude": "64.40000000",
                        "longitude": "17.48333000"
                    },
                    {
                        "id": 103439,
                        "name": "Kåge",
                        "latitude": "64.83571000",
                        "longitude": "20.98453000"
                    },
                    {
                        "id": 103503,
                        "name": "Långsele",
                        "latitude": "64.81667000",
                        "longitude": "20.25000000"
                    },
                    {
                        "id": 103497,
                        "name": "Lycksele",
                        "latitude": "64.59537000",
                        "longitude": "18.67351000"
                    },
                    {
                        "id": 103520,
                        "name": "Malå",
                        "latitude": "65.18501000",
                        "longitude": "18.74243000"
                    },
                    {
                        "id": 103582,
                        "name": "Nordmaling",
                        "latitude": "63.56852000",
                        "longitude": "19.50244000"
                    },
                    {
                        "id": 103590,
                        "name": "Norsjö",
                        "latitude": "64.91206000",
                        "longitude": "19.48153000"
                    },
                    {
                        "id": 103606,
                        "name": "Obbola",
                        "latitude": "63.70000000",
                        "longitude": "20.31667000"
                    },
                    {
                        "id": 103671,
                        "name": "Röbäck",
                        "latitude": "63.80879000",
                        "longitude": "20.18901000"
                    },
                    {
                        "id": 103650,
                        "name": "Robertsfors",
                        "latitude": "64.19324000",
                        "longitude": "20.84806000"
                    },
                    {
                        "id": 103811,
                        "name": "Sävar",
                        "latitude": "63.90383000",
                        "longitude": "20.55014000"
                    },
                    {
                        "id": 103701,
                        "name": "Skellefteå",
                        "latitude": "64.75067000",
                        "longitude": "20.95279000"
                    },
                    {
                        "id": 103700,
                        "name": "Skelleftehamn",
                        "latitude": "64.68333000",
                        "longitude": "21.23333000"
                    },
                    {
                        "id": 103818,
                        "name": "Söderfors",
                        "latitude": "64.81667000",
                        "longitude": "18.05000000"
                    },
                    {
                        "id": 103741,
                        "name": "Sorsele",
                        "latitude": "65.53484000",
                        "longitude": "17.53702000"
                    },
                    {
                        "id": 103765,
                        "name": "Storuman",
                        "latitude": "65.09590000",
                        "longitude": "17.11731000"
                    },
                    {
                        "id": 103767,
                        "name": "Storvik",
                        "latitude": "65.15000000",
                        "longitude": "20.73333000"
                    },
                    {
                        "id": 103888,
                        "name": "Täfteå",
                        "latitude": "63.83970000",
                        "longitude": "20.47857000"
                    },
                    {
                        "id": 103898,
                        "name": "Umeå",
                        "latitude": "63.82842000",
                        "longitude": "20.25972000"
                    },
                    {
                        "id": 103906,
                        "name": "Ursviken",
                        "latitude": "64.71261000",
                        "longitude": "21.16580000"
                    },
                    {
                        "id": 103964,
                        "name": "Vännäs",
                        "latitude": "63.90676000",
                        "longitude": "19.75712000"
                    },
                    {
                        "id": 103966,
                        "name": "Vännäsby",
                        "latitude": "63.91564000",
                        "longitude": "19.82438000"
                    },
                    {
                        "id": 103942,
                        "name": "Viken",
                        "latitude": "64.72587000",
                        "longitude": "20.91548000"
                    },
                    {
                        "id": 103945,
                        "name": "Vilhelmina",
                        "latitude": "64.62417000",
                        "longitude": "16.65596000"
                    },
                    {
                        "id": 103949,
                        "name": "Vindeln",
                        "latitude": "64.20175000",
                        "longitude": "19.71945000"
                    }
                ]
            },
            {
                "id": 1552,
                "name": "Västernorrland",
                "iso2": "Y",
                "latitude": "63.42764730",
                "longitude": "17.72924440",
                "type": "county",
                "cities": [
                    {
                        "id": 104009,
                        "name": "Ånge",
                        "latitude": "62.52495000",
                        "longitude": "15.65904000"
                    },
                    {
                        "id": 104015,
                        "name": "Ås",
                        "latitude": "63.36667000",
                        "longitude": "16.58333000"
                    },
                    {
                        "id": 103034,
                        "name": "Bergeforsen",
                        "latitude": "62.53074000",
                        "longitude": "17.38123000"
                    },
                    {
                        "id": 103051,
                        "name": "Bjästa",
                        "latitude": "63.20000000",
                        "longitude": "18.50000000"
                    },
                    {
                        "id": 103069,
                        "name": "Bollstabruk",
                        "latitude": "62.99777000",
                        "longitude": "17.67348000"
                    },
                    {
                        "id": 103084,
                        "name": "Bredbyn",
                        "latitude": "63.44655000",
                        "longitude": "18.11019000"
                    },
                    {
                        "id": 103185,
                        "name": "Fränsta",
                        "latitude": "62.49855000",
                        "longitude": "16.17016000"
                    },
                    {
                        "id": 103322,
                        "name": "Härnösand",
                        "latitude": "62.63228000",
                        "longitude": "17.93794000"
                    },
                    {
                        "id": 103311,
                        "name": "Husum",
                        "latitude": "63.33333000",
                        "longitude": "19.16667000"
                    },
                    {
                        "id": 103352,
                        "name": "Johannedal",
                        "latitude": "62.43424000",
                        "longitude": "17.37273000"
                    },
                    {
                        "id": 103445,
                        "name": "Köpmanholmen",
                        "latitude": "63.16667000",
                        "longitude": "18.56667000"
                    },
                    {
                        "id": 103411,
                        "name": "Kramfors",
                        "latitude": "62.93161000",
                        "longitude": "17.77646000"
                    },
                    {
                        "id": 103434,
                        "name": "Kvissleby",
                        "latitude": "62.29361000",
                        "longitude": "17.37500000"
                    },
                    {
                        "id": 103502,
                        "name": "Långsele",
                        "latitude": "63.18333000",
                        "longitude": "17.06667000"
                    },
                    {
                        "id": 103534,
                        "name": "Matfors",
                        "latitude": "62.34864000",
                        "longitude": "17.03173000"
                    },
                    {
                        "id": 103574,
                        "name": "Njurundabommen",
                        "latitude": "62.26339000",
                        "longitude": "17.38354000"
                    },
                    {
                        "id": 103575,
                        "name": "Nolby",
                        "latitude": "62.28750000",
                        "longitude": "17.36917000"
                    },
                    {
                        "id": 104039,
                        "name": "Örnsköldsvik",
                        "latitude": "63.29091000",
                        "longitude": "18.71525000"
                    },
                    {
                        "id": 103710,
                        "name": "Skottsund",
                        "latitude": "62.29056000",
                        "longitude": "17.38694000"
                    },
                    {
                        "id": 103735,
                        "name": "Sollefteå",
                        "latitude": "63.16667000",
                        "longitude": "17.26667000"
                    },
                    {
                        "id": 103833,
                        "name": "Söråker",
                        "latitude": "62.50561000",
                        "longitude": "17.51032000"
                    },
                    {
                        "id": 103760,
                        "name": "Stockvik",
                        "latitude": "62.33667000",
                        "longitude": "17.36583000"
                    },
                    {
                        "id": 103785,
                        "name": "Sundsbruk",
                        "latitude": "62.45806000",
                        "longitude": "17.34889000"
                    },
                    {
                        "id": 103786,
                        "name": "Sundsvall",
                        "latitude": "62.39129000",
                        "longitude": "17.30630000"
                    },
                    {
                        "id": 103850,
                        "name": "Timrå",
                        "latitude": "62.48654000",
                        "longitude": "17.32613000"
                    },
                    {
                        "id": 103939,
                        "name": "Vi",
                        "latitude": "62.43333000",
                        "longitude": "17.41667000"
                    }
                ]
            },
            {
                "id": 1549,
                "name": "Västmanland",
                "iso2": "U",
                "latitude": "59.67138790",
                "longitude": "16.21589530",
                "type": "county",
                "cities": [
                    {
                        "id": 103007,
                        "name": "Arboga",
                        "latitude": "59.39387000",
                        "longitude": "15.83882000"
                    },
                    {
                        "id": 103029,
                        "name": "Barkarö",
                        "latitude": "59.54935000",
                        "longitude": "16.50740000"
                    },
                    {
                        "id": 103119,
                        "name": "Dingtuna",
                        "latitude": "59.57279000",
                        "longitude": "16.38722000"
                    },
                    {
                        "id": 103144,
                        "name": "Enhagen-Ekbacken",
                        "latitude": "59.56543000",
                        "longitude": "16.53045000"
                    },
                    {
                        "id": 103155,
                        "name": "Fagersta",
                        "latitude": "60.00418000",
                        "longitude": "15.79316000"
                    },
                    {
                        "id": 103255,
                        "name": "Hallstahammar",
                        "latitude": "59.61395000",
                        "longitude": "16.22846000"
                    },
                    {
                        "id": 103333,
                        "name": "Hökåsen",
                        "latitude": "59.66667000",
                        "longitude": "16.58333000"
                    },
                    {
                        "id": 103349,
                        "name": "Irsta",
                        "latitude": "59.60000000",
                        "longitude": "16.70000000"
                    },
                    {
                        "id": 103407,
                        "name": "Kolbäck",
                        "latitude": "59.56516000",
                        "longitude": "16.23037000"
                    },
                    {
                        "id": 103408,
                        "name": "Kolsva",
                        "latitude": "59.60000000",
                        "longitude": "15.83333000"
                    },
                    {
                        "id": 103442,
                        "name": "Köping",
                        "latitude": "59.51404000",
                        "longitude": "15.99255000"
                    },
                    {
                        "id": 103428,
                        "name": "Kungsör",
                        "latitude": "59.42245000",
                        "longitude": "16.09656000"
                    },
                    {
                        "id": 103579,
                        "name": "Norberg",
                        "latitude": "60.06505000",
                        "longitude": "15.92366000"
                    },
                    {
                        "id": 103642,
                        "name": "Ramnäs",
                        "latitude": "59.76667000",
                        "longitude": "16.20000000"
                    },
                    {
                        "id": 103675,
                        "name": "Sala",
                        "latitude": "59.91993000",
                        "longitude": "16.60655000"
                    },
                    {
                        "id": 103705,
                        "name": "Skinnskatteberg",
                        "latitude": "59.83028000",
                        "longitude": "15.69337000"
                    },
                    {
                        "id": 103713,
                        "name": "Skultuna",
                        "latitude": "59.71667000",
                        "longitude": "16.41667000"
                    },
                    {
                        "id": 103790,
                        "name": "Surahammar",
                        "latitude": "59.70725000",
                        "longitude": "16.22188000"
                    },
                    {
                        "id": 103848,
                        "name": "Tillberga",
                        "latitude": "59.68333000",
                        "longitude": "16.61667000"
                    },
                    {
                        "id": 103972,
                        "name": "Västerås",
                        "latitude": "59.64914000",
                        "longitude": "16.56445000"
                    }
                ]
            },
            {
                "id": 1547,
                "name": "Västra Götaland",
                "iso2": "O",
                "latitude": "58.25279260",
                "longitude": "13.05964250",
                "type": "county",
                "cities": [
                    {
                        "id": 104001,
                        "name": "Åkarp",
                        "latitude": "58.23333000",
                        "longitude": "13.65000000"
                    },
                    {
                        "id": 102987,
                        "name": "Alafors",
                        "latitude": "57.92579000",
                        "longitude": "12.07835000"
                    },
                    {
                        "id": 102991,
                        "name": "Alingsås",
                        "latitude": "57.93033000",
                        "longitude": "12.53345000"
                    },
                    {
                        "id": 103995,
                        "name": "Älvängen",
                        "latitude": "57.95872000",
                        "longitude": "12.12350000"
                    },
                    {
                        "id": 104007,
                        "name": "Åmål",
                        "latitude": "59.05100000",
                        "longitude": "12.70492000"
                    },
                    {
                        "id": 102997,
                        "name": "Andalen",
                        "latitude": "57.70039000",
                        "longitude": "11.76136000"
                    },
                    {
                        "id": 103000,
                        "name": "Anderstorp",
                        "latitude": "58.88333000",
                        "longitude": "14.28333000"
                    },
                    {
                        "id": 103003,
                        "name": "Angered",
                        "latitude": "57.78628000",
                        "longitude": "12.09852000"
                    },
                    {
                        "id": 103006,
                        "name": "Annelund",
                        "latitude": "57.98843000",
                        "longitude": "13.07483000"
                    },
                    {
                        "id": 103024,
                        "name": "Axvall",
                        "latitude": "58.38333000",
                        "longitude": "13.56667000"
                    },
                    {
                        "id": 103030,
                        "name": "Bengtsfors",
                        "latitude": "59.02912000",
                        "longitude": "12.23207000"
                    },
                    {
                        "id": 103040,
                        "name": "Billdal",
                        "latitude": "57.56667000",
                        "longitude": "11.93333000"
                    },
                    {
                        "id": 103043,
                        "name": "Billingsfors",
                        "latitude": "58.98333000",
                        "longitude": "12.25000000"
                    },
                    {
                        "id": 103052,
                        "name": "Björboholm",
                        "latitude": "57.87096000",
                        "longitude": "12.32546000"
                    },
                    {
                        "id": 103055,
                        "name": "Björkö",
                        "latitude": "57.73221000",
                        "longitude": "11.67916000"
                    },
                    {
                        "id": 103056,
                        "name": "Björlanda",
                        "latitude": "57.76667000",
                        "longitude": "11.83333000"
                    },
                    {
                        "id": 103064,
                        "name": "Bollebygd",
                        "latitude": "57.66866000",
                        "longitude": "12.57272000"
                    },
                    {
                        "id": 103077,
                        "name": "Borås",
                        "latitude": "57.73783000",
                        "longitude": "12.94076000"
                    },
                    {
                        "id": 103095,
                        "name": "Brålanda",
                        "latitude": "58.56344000",
                        "longitude": "12.34923000"
                    },
                    {
                        "id": 103081,
                        "name": "Brastad",
                        "latitude": "58.38333000",
                        "longitude": "11.48333000"
                    },
                    {
                        "id": 103110,
                        "name": "Dals Långed",
                        "latitude": "58.92555000",
                        "longitude": "12.30865000"
                    },
                    {
                        "id": 103112,
                        "name": "Dalsjöfors",
                        "latitude": "57.71667000",
                        "longitude": "13.08333000"
                    },
                    {
                        "id": 103120,
                        "name": "Diseröd",
                        "latitude": "57.92636000",
                        "longitude": "12.02598000"
                    },
                    {
                        "id": 103124,
                        "name": "Donsö",
                        "latitude": "57.60000000",
                        "longitude": "11.79917000"
                    },
                    {
                        "id": 103127,
                        "name": "Ed",
                        "latitude": "58.91247000",
                        "longitude": "11.93308000"
                    },
                    {
                        "id": 103139,
                        "name": "Ellös",
                        "latitude": "58.18333000",
                        "longitude": "11.46667000"
                    },
                    {
                        "id": 103148,
                        "name": "Eriksbo",
                        "latitude": "57.77141000",
                        "longitude": "12.04183000"
                    },
                    {
                        "id": 103159,
                        "name": "Falköping",
                        "latitude": "58.17347000",
                        "longitude": "13.55068000"
                    },
                    {
                        "id": 103191,
                        "name": "Färgelanda",
                        "latitude": "58.56816000",
                        "longitude": "11.99235000"
                    },
                    {
                        "id": 103175,
                        "name": "Floby",
                        "latitude": "58.13333000",
                        "longitude": "13.33333000"
                    },
                    {
                        "id": 103183,
                        "name": "Fristad",
                        "latitude": "57.82483000",
                        "longitude": "13.01064000"
                    },
                    {
                        "id": 103184,
                        "name": "Fritsla",
                        "latitude": "57.55655000",
                        "longitude": "12.78457000"
                    },
                    {
                        "id": 103189,
                        "name": "Furulund",
                        "latitude": "57.71667000",
                        "longitude": "12.13333000"
                    },
                    {
                        "id": 103242,
                        "name": "Gånghester",
                        "latitude": "57.70000000",
                        "longitude": "13.01667000"
                    },
                    {
                        "id": 103243,
                        "name": "Gårdsten",
                        "latitude": "57.80480000",
                        "longitude": "12.02883000"
                    },
                    {
                        "id": 103244,
                        "name": "Göta",
                        "latitude": "58.10617000",
                        "longitude": "12.15254000"
                    },
                    {
                        "id": 103245,
                        "name": "Göteborg",
                        "latitude": "57.70716000",
                        "longitude": "11.96679000"
                    },
                    {
                        "id": 103246,
                        "name": "Göteborgs stad",
                        "latitude": "57.72288000",
                        "longitude": "11.94577000"
                    },
                    {
                        "id": 103247,
                        "name": "Götene",
                        "latitude": "58.52824000",
                        "longitude": "13.49458000"
                    },
                    {
                        "id": 103230,
                        "name": "Gråbo",
                        "latitude": "57.83625000",
                        "longitude": "12.29954000"
                    },
                    {
                        "id": 103228,
                        "name": "Grästorp",
                        "latitude": "58.33219000",
                        "longitude": "12.68122000"
                    },
                    {
                        "id": 103220,
                        "name": "Grebbestad",
                        "latitude": "58.70248000",
                        "longitude": "11.25738000"
                    },
                    {
                        "id": 103232,
                        "name": "Gullspång",
                        "latitude": "58.98615000",
                        "longitude": "14.09644000"
                    },
                    {
                        "id": 103261,
                        "name": "Hammarkullen",
                        "latitude": "57.78049000",
                        "longitude": "12.03604000"
                    },
                    {
                        "id": 103280,
                        "name": "Henån",
                        "latitude": "58.23848000",
                        "longitude": "11.67598000"
                    },
                    {
                        "id": 103282,
                        "name": "Herrljunga",
                        "latitude": "58.07739000",
                        "longitude": "13.02662000"
                    },
                    {
                        "id": 103286,
                        "name": "Hindås",
                        "latitude": "57.70338000",
                        "longitude": "12.44657000"
                    },
                    {
                        "id": 103288,
                        "name": "Hjo",
                        "latitude": "58.30133000",
                        "longitude": "14.28784000"
                    },
                    {
                        "id": 103290,
                        "name": "Hjuvik",
                        "latitude": "57.70167000",
                        "longitude": "11.71639000"
                    },
                    {
                        "id": 103337,
                        "name": "Hönö",
                        "latitude": "57.68972000",
                        "longitude": "11.64972000"
                    },
                    {
                        "id": 103298,
                        "name": "Horred",
                        "latitude": "57.35475000",
                        "longitude": "12.47777000"
                    },
                    {
                        "id": 103300,
                        "name": "Hova",
                        "latitude": "58.85363000",
                        "longitude": "14.21914000"
                    },
                    {
                        "id": 103341,
                        "name": "Höviksnäs",
                        "latitude": "58.03333000",
                        "longitude": "11.76667000"
                    },
                    {
                        "id": 103309,
                        "name": "Hunnebostrand",
                        "latitude": "58.44127000",
                        "longitude": "11.30320000"
                    },
                    {
                        "id": 103345,
                        "name": "Ingared",
                        "latitude": "57.85989000",
                        "longitude": "12.45161000"
                    },
                    {
                        "id": 103355,
                        "name": "Jonstorp",
                        "latitude": "58.00000000",
                        "longitude": "12.71667000"
                    },
                    {
                        "id": 103368,
                        "name": "Jörlanda",
                        "latitude": "57.98630000",
                        "longitude": "11.82943000"
                    },
                    {
                        "id": 103436,
                        "name": "Källby",
                        "latitude": "58.50999000",
                        "longitude": "13.30582000"
                    },
                    {
                        "id": 103441,
                        "name": "Kållered",
                        "latitude": "57.60992000",
                        "longitude": "12.05106000"
                    },
                    {
                        "id": 103375,
                        "name": "Karlsborg",
                        "latitude": "58.53724000",
                        "longitude": "14.50470000"
                    },
                    {
                        "id": 103393,
                        "name": "Kinna",
                        "latitude": "57.50728000",
                        "longitude": "12.69463000"
                    },
                    {
                        "id": 103406,
                        "name": "Kode",
                        "latitude": "57.94263000",
                        "longitude": "11.85051000"
                    },
                    {
                        "id": 103430,
                        "name": "Kungälv",
                        "latitude": "57.87096000",
                        "longitude": "11.98054000"
                    },
                    {
                        "id": 103425,
                        "name": "Kungshamn",
                        "latitude": "58.36305000",
                        "longitude": "11.25938000"
                    },
                    {
                        "id": 103435,
                        "name": "Kvänum",
                        "latitude": "58.30000000",
                        "longitude": "13.18333000"
                    },
                    {
                        "id": 103452,
                        "name": "Landvetter",
                        "latitude": "57.68665000",
                        "longitude": "12.21169000"
                    },
                    {
                        "id": 103501,
                        "name": "Länghem",
                        "latitude": "57.60000000",
                        "longitude": "13.23333000"
                    },
                    {
                        "id": 103459,
                        "name": "Lerum",
                        "latitude": "57.77051000",
                        "longitude": "12.26904000"
                    },
                    {
                        "id": 103464,
                        "name": "Lidköping",
                        "latitude": "58.50517000",
                        "longitude": "13.15765000"
                    },
                    {
                        "id": 103466,
                        "name": "Lilla Edet",
                        "latitude": "58.13333000",
                        "longitude": "12.13333000"
                    },
                    {
                        "id": 103468,
                        "name": "Limmared",
                        "latitude": "57.53592000",
                        "longitude": "13.35566000"
                    },
                    {
                        "id": 103472,
                        "name": "Lindome",
                        "latitude": "57.56667000",
                        "longitude": "12.08333000"
                    },
                    {
                        "id": 103484,
                        "name": "Ljungskile",
                        "latitude": "58.22452000",
                        "longitude": "11.92014000"
                    },
                    {
                        "id": 103508,
                        "name": "Lödöse",
                        "latitude": "58.02994000",
                        "longitude": "12.15934000"
                    },
                    {
                        "id": 103510,
                        "name": "Lövgärdet",
                        "latitude": "57.81555000",
                        "longitude": "12.03861000"
                    },
                    {
                        "id": 103499,
                        "name": "Lysekil",
                        "latitude": "58.27429000",
                        "longitude": "11.43576000"
                    },
                    {
                        "id": 103512,
                        "name": "Majorna",
                        "latitude": "57.69195000",
                        "longitude": "11.91605000"
                    },
                    {
                        "id": 103529,
                        "name": "Mariestad",
                        "latitude": "58.70971000",
                        "longitude": "13.82367000"
                    },
                    {
                        "id": 103536,
                        "name": "Mellerud",
                        "latitude": "58.69979000",
                        "longitude": "12.45312000"
                    },
                    {
                        "id": 103560,
                        "name": "Mölltorp",
                        "latitude": "58.50000000",
                        "longitude": "14.40000000"
                    },
                    {
                        "id": 103562,
                        "name": "Mölndal",
                        "latitude": "57.65540000",
                        "longitude": "12.01378000"
                    },
                    {
                        "id": 103564,
                        "name": "Mölnlycke",
                        "latitude": "57.65893000",
                        "longitude": "12.11792000"
                    },
                    {
                        "id": 103553,
                        "name": "Munkedal",
                        "latitude": "58.46634000",
                        "longitude": "11.67345000"
                    },
                    {
                        "id": 103557,
                        "name": "Myggenäs",
                        "latitude": "58.06176000",
                        "longitude": "11.74936000"
                    },
                    {
                        "id": 103576,
                        "name": "Nolvik",
                        "latitude": "57.77500000",
                        "longitude": "11.83333000"
                    },
                    {
                        "id": 103592,
                        "name": "Nossebro",
                        "latitude": "58.18808000",
                        "longitude": "12.71599000"
                    },
                    {
                        "id": 104025,
                        "name": "Öckerö",
                        "latitude": "57.70814000",
                        "longitude": "11.65585000"
                    },
                    {
                        "id": 104029,
                        "name": "Ödsmål",
                        "latitude": "58.10000000",
                        "longitude": "11.85000000"
                    },
                    {
                        "id": 104031,
                        "name": "Öjersjö",
                        "latitude": "57.69882000",
                        "longitude": "12.13448000"
                    },
                    {
                        "id": 103611,
                        "name": "Olofstorp",
                        "latitude": "57.80444000",
                        "longitude": "12.17131000"
                    },
                    {
                        "id": 103615,
                        "name": "Olstorp",
                        "latitude": "57.82277000",
                        "longitude": "12.27696000"
                    },
                    {
                        "id": 103620,
                        "name": "Orust",
                        "latitude": "58.18025000",
                        "longitude": "11.63419000"
                    },
                    {
                        "id": 103632,
                        "name": "Partille",
                        "latitude": "57.73950000",
                        "longitude": "12.10642000"
                    },
                    {
                        "id": 103643,
                        "name": "Rannebergen",
                        "latitude": "57.80236000",
                        "longitude": "12.07131000"
                    },
                    {
                        "id": 103667,
                        "name": "Rävlanda",
                        "latitude": "57.65338000",
                        "longitude": "12.49791000"
                    },
                    {
                        "id": 103674,
                        "name": "Rönnäng",
                        "latitude": "57.93333000",
                        "longitude": "11.58333000"
                    },
                    {
                        "id": 103816,
                        "name": "Sålanda",
                        "latitude": "57.98333000",
                        "longitude": "12.21667000"
                    },
                    {
                        "id": 103679,
                        "name": "Sandared",
                        "latitude": "57.70992000",
                        "longitude": "12.79238000"
                    },
                    {
                        "id": 103809,
                        "name": "Sätila",
                        "latitude": "57.54172000",
                        "longitude": "12.43429000"
                    },
                    {
                        "id": 103694,
                        "name": "Sjömarken",
                        "latitude": "57.71533000",
                        "longitude": "12.83495000"
                    },
                    {
                        "id": 103691,
                        "name": "Sjuntorp",
                        "latitude": "58.20000000",
                        "longitude": "12.21667000"
                    },
                    {
                        "id": 103696,
                        "name": "Skara",
                        "latitude": "58.38659000",
                        "longitude": "13.43836000"
                    },
                    {
                        "id": 103720,
                        "name": "Skärhamn",
                        "latitude": "57.98665000",
                        "longitude": "11.55742000"
                    },
                    {
                        "id": 103703,
                        "name": "Skepplanda",
                        "latitude": "57.98333000",
                        "longitude": "12.20000000"
                    },
                    {
                        "id": 103724,
                        "name": "Skövde",
                        "latitude": "58.39118000",
                        "longitude": "13.84506000"
                    },
                    {
                        "id": 103712,
                        "name": "Skultorp",
                        "latitude": "58.35000000",
                        "longitude": "13.83333000"
                    },
                    {
                        "id": 103733,
                        "name": "Smögen",
                        "latitude": "58.35593000",
                        "longitude": "11.22411000"
                    },
                    {
                        "id": 103734,
                        "name": "Sollebrunn",
                        "latitude": "58.11667000",
                        "longitude": "12.53333000"
                    },
                    {
                        "id": 103751,
                        "name": "Stenkullen",
                        "latitude": "57.79476000",
                        "longitude": "12.31688000"
                    },
                    {
                        "id": 103753,
                        "name": "Stenstorp",
                        "latitude": "58.27254000",
                        "longitude": "13.71454000"
                    },
                    {
                        "id": 103754,
                        "name": "Stenungsund",
                        "latitude": "58.07046000",
                        "longitude": "11.81810000"
                    },
                    {
                        "id": 103782,
                        "name": "Stöpen",
                        "latitude": "58.47802000",
                        "longitude": "13.86611000"
                    },
                    {
                        "id": 103761,
                        "name": "Stora Höga",
                        "latitude": "58.01667000",
                        "longitude": "11.83333000"
                    },
                    {
                        "id": 103775,
                        "name": "Strömstad",
                        "latitude": "58.93945000",
                        "longitude": "11.17120000"
                    },
                    {
                        "id": 103780,
                        "name": "Styrsö",
                        "latitude": "57.61639000",
                        "longitude": "11.78556000"
                    },
                    {
                        "id": 103792,
                        "name": "Surte",
                        "latitude": "57.82533000",
                        "longitude": "12.01604000"
                    },
                    {
                        "id": 103796,
                        "name": "Svanesund",
                        "latitude": "58.14292000",
                        "longitude": "11.81821000"
                    },
                    {
                        "id": 103799,
                        "name": "Svenljunga",
                        "latitude": "57.49551000",
                        "longitude": "13.11078000"
                    },
                    {
                        "id": 103838,
                        "name": "Tanumshede",
                        "latitude": "58.72385000",
                        "longitude": "11.32587000"
                    },
                    {
                        "id": 103842,
                        "name": "Tibro",
                        "latitude": "58.42453000",
                        "longitude": "14.16162000"
                    },
                    {
                        "id": 103844,
                        "name": "Tidaholm",
                        "latitude": "58.18035000",
                        "longitude": "13.95824000"
                    },
                    {
                        "id": 103854,
                        "name": "Tjuvkil",
                        "latitude": "57.90000000",
                        "longitude": "11.73333000"
                    },
                    {
                        "id": 103892,
                        "name": "Töreboda",
                        "latitude": "58.70739000",
                        "longitude": "14.12597000"
                    },
                    {
                        "id": 103865,
                        "name": "Torslanda",
                        "latitude": "57.72432000",
                        "longitude": "11.77013000"
                    },
                    {
                        "id": 103869,
                        "name": "Tranemo",
                        "latitude": "57.48333000",
                        "longitude": "13.35000000"
                    },
                    {
                        "id": 103876,
                        "name": "Trollhättan",
                        "latitude": "58.21208000",
                        "longitude": "12.35033000"
                    },
                    {
                        "id": 103894,
                        "name": "Uddevalla",
                        "latitude": "58.34784000",
                        "longitude": "11.94240000"
                    },
                    {
                        "id": 103896,
                        "name": "Ulricehamn",
                        "latitude": "57.79159000",
                        "longitude": "13.41422000"
                    },
                    {
                        "id": 103962,
                        "name": "Vänersborg",
                        "latitude": "58.38075000",
                        "longitude": "12.32340000"
                    },
                    {
                        "id": 103922,
                        "name": "Vara",
                        "latitude": "58.26234000",
                        "longitude": "12.95413000"
                    },
                    {
                        "id": 103979,
                        "name": "Vårgårda",
                        "latitude": "58.03706000",
                        "longitude": "12.80907000"
                    },
                    {
                        "id": 103926,
                        "name": "Vargön",
                        "latitude": "58.35599000",
                        "longitude": "12.39060000"
                    },
                    {
                        "id": 103973,
                        "name": "Västra Frölunda",
                        "latitude": "57.64667000",
                        "longitude": "11.92944000"
                    },
                    {
                        "id": 103953,
                        "name": "Vinninga",
                        "latitude": "58.45000000",
                        "longitude": "13.26667000"
                    },
                    {
                        "id": 103958,
                        "name": "Viskafors",
                        "latitude": "57.62941000",
                        "longitude": "12.84890000"
                    }
                ]
            }
        ]
    },
    {
        "id": 214,
        "name": "Switzerland",
        "iso3": "CHE",
        "iso2": "CH",
        "numeric_code": "756",
        "phonecode": "41",
        "capital": "Bern",
        "currency": "CHF",
        "currency_name": "Swiss franc",
        "currency_symbol": "CHf",
        "tld": ".ch",
        "native": "Schweiz",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Western Europe",
        "subregion_id": 17,
        "nationality": "Swiss",
        "timezones": [
            {
                "zoneName": "Europe\/Zurich",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Suis",
            "ko": "스위스",
            "pt-BR": "Suíça",
            "pt": "Suíça",
            "nl": "Zwitserland",
            "hr": "Švicarska",
            "fa": "سوئیس",
            "de": "Schweiz",
            "es": "Suiza",
            "fr": "Suisse",
            "ja": "スイス",
            "it": "Svizzera",
            "zh-CN": "瑞士",
            "tr": "İsviçre",
            "ru": "Швейцария",
            "uk": "Швейцарія",
            "pl": "Szwajcaria"
        },
        "latitude": "47.00000000",
        "longitude": "8.00000000",
        "emoji": "🇨🇭",
        "emojiU": "U+1F1E8 U+1F1ED",
        "states": [
            {
                "id": 1639,
                "name": "Aargau",
                "iso2": "AG",
                "latitude": "47.38766640",
                "longitude": "8.25542950",
                "type": "canton",
                "cities": [
                    {
                        "id": 17357,
                        "name": "Aarau",
                        "latitude": "47.39254000",
                        "longitude": "8.04422000"
                    },
                    {
                        "id": 17359,
                        "name": "Aarburg",
                        "latitude": "47.32067000",
                        "longitude": "7.89986000"
                    },
                    {
                        "id": 17407,
                        "name": "Aristau",
                        "latitude": "47.28692000",
                        "longitude": "8.36356000"
                    },
                    {
                        "id": 17424,
                        "name": "Auw",
                        "latitude": "47.21082000",
                        "longitude": "8.36583000"
                    },
                    {
                        "id": 17431,
                        "name": "Bad Zurzach",
                        "latitude": "47.58764000",
                        "longitude": "8.29365000"
                    },
                    {
                        "id": 17432,
                        "name": "Baden",
                        "latitude": "47.47333000",
                        "longitude": "8.30592000"
                    },
                    {
                        "id": 17460,
                        "name": "Berikon",
                        "latitude": "47.35155000",
                        "longitude": "8.37232000"
                    },
                    {
                        "id": 17467,
                        "name": "Besenbüren",
                        "latitude": "47.31439000",
                        "longitude": "8.34586000"
                    },
                    {
                        "id": 17471,
                        "name": "Bezirk Aarau",
                        "latitude": "47.37706000",
                        "longitude": "8.05235000"
                    },
                    {
                        "id": 17475,
                        "name": "Bezirk Baden",
                        "latitude": "47.45660000",
                        "longitude": "8.30059000"
                    },
                    {
                        "id": 17476,
                        "name": "Bezirk Bremgarten",
                        "latitude": "47.34927000",
                        "longitude": "8.33343000"
                    },
                    {
                        "id": 17477,
                        "name": "Bezirk Brugg",
                        "latitude": "47.47776000",
                        "longitude": "8.17798000"
                    },
                    {
                        "id": 17491,
                        "name": "Bezirk Kulm",
                        "latitude": "47.28757000",
                        "longitude": "8.13302000"
                    },
                    {
                        "id": 17494,
                        "name": "Bezirk Laufenburg",
                        "latitude": "47.51844000",
                        "longitude": "8.03878000"
                    },
                    {
                        "id": 17496,
                        "name": "Bezirk Lenzburg",
                        "latitude": "47.37184000",
                        "longitude": "8.18910000"
                    },
                    {
                        "id": 17501,
                        "name": "Bezirk Muri",
                        "latitude": "47.25233000",
                        "longitude": "8.35362000"
                    },
                    {
                        "id": 17506,
                        "name": "Bezirk Rheinfelden",
                        "latitude": "47.54048000",
                        "longitude": "7.83331000"
                    },
                    {
                        "id": 17521,
                        "name": "Bezirk Zofingen",
                        "latitude": "47.28864000",
                        "longitude": "7.95697000"
                    },
                    {
                        "id": 17522,
                        "name": "Bezirk Zurzach",
                        "latitude": "47.56182000",
                        "longitude": "8.28020000"
                    },
                    {
                        "id": 17536,
                        "name": "Birmenstorf",
                        "latitude": "47.46152000",
                        "longitude": "8.24816000"
                    },
                    {
                        "id": 17537,
                        "name": "Birr",
                        "latitude": "47.43432000",
                        "longitude": "8.20891000"
                    },
                    {
                        "id": 17549,
                        "name": "Boniswil",
                        "latitude": "47.31725000",
                        "longitude": "8.18963000"
                    },
                    {
                        "id": 17558,
                        "name": "Bremgarten",
                        "latitude": "47.35109000",
                        "longitude": "8.34214000"
                    },
                    {
                        "id": 17565,
                        "name": "Brittnau",
                        "latitude": "47.25954000",
                        "longitude": "7.94689000"
                    },
                    {
                        "id": 17570,
                        "name": "Brugg",
                        "latitude": "47.48096000",
                        "longitude": "8.20869000"
                    },
                    {
                        "id": 17579,
                        "name": "Buchs",
                        "latitude": "47.39358000",
                        "longitude": "8.08233000"
                    },
                    {
                        "id": 17588,
                        "name": "Buttwil",
                        "latitude": "47.26828000",
                        "longitude": "8.31064000"
                    },
                    {
                        "id": 17682,
                        "name": "Densbüren",
                        "latitude": "47.45260000",
                        "longitude": "8.05330000"
                    },
                    {
                        "id": 17705,
                        "name": "Dottikon",
                        "latitude": "47.38437000",
                        "longitude": "8.23981000"
                    },
                    {
                        "id": 17717,
                        "name": "Dürrenäsch",
                        "latitude": "47.32094000",
                        "longitude": "8.15874000"
                    },
                    {
                        "id": 17732,
                        "name": "Egliswil",
                        "latitude": "47.34922000",
                        "longitude": "8.18553000"
                    },
                    {
                        "id": 17734,
                        "name": "Ehrendingen",
                        "latitude": "47.50250000",
                        "longitude": "8.34729000"
                    },
                    {
                        "id": 17737,
                        "name": "Eiken",
                        "latitude": "47.53361000",
                        "longitude": "7.98801000"
                    },
                    {
                        "id": 17749,
                        "name": "Endingen",
                        "latitude": "47.53742000",
                        "longitude": "8.29036000"
                    },
                    {
                        "id": 17810,
                        "name": "Frick",
                        "latitude": "47.51169000",
                        "longitude": "8.02471000"
                    },
                    {
                        "id": 17824,
                        "name": "Gebenstorf",
                        "latitude": "47.48136000",
                        "longitude": "8.23949000"
                    },
                    {
                        "id": 17834,
                        "name": "Gipf-Oberfrick",
                        "latitude": "47.49875000",
                        "longitude": "8.00497000"
                    },
                    {
                        "id": 17853,
                        "name": "Gontenschwil",
                        "latitude": "47.27166000",
                        "longitude": "8.14396000"
                    },
                    {
                        "id": 17880,
                        "name": "Gränichen",
                        "latitude": "47.35930000",
                        "longitude": "8.10243000"
                    },
                    {
                        "id": 17939,
                        "name": "Hägglingen",
                        "latitude": "47.38851000",
                        "longitude": "8.25285000"
                    },
                    {
                        "id": 17895,
                        "name": "Hausen",
                        "latitude": "47.46396000",
                        "longitude": "8.20988000"
                    },
                    {
                        "id": 17960,
                        "name": "Jonen",
                        "latitude": "47.29750000",
                        "longitude": "8.39282000"
                    },
                    {
                        "id": 17966,
                        "name": "Kaiseraugst",
                        "latitude": "47.53966000",
                        "longitude": "7.72605000"
                    },
                    {
                        "id": 17967,
                        "name": "Kaisten",
                        "latitude": "47.54160000",
                        "longitude": "8.04337000"
                    },
                    {
                        "id": 17978,
                        "name": "Killwangen",
                        "latitude": "47.43223000",
                        "longitude": "8.35097000"
                    },
                    {
                        "id": 17985,
                        "name": "Klingnau",
                        "latitude": "47.58361000",
                        "longitude": "8.24880000"
                    },
                    {
                        "id": 17999,
                        "name": "Koblenz",
                        "latitude": "47.60972000",
                        "longitude": "8.23750000"
                    },
                    {
                        "id": 18010,
                        "name": "Kölliken",
                        "latitude": "47.33337000",
                        "longitude": "8.02237000"
                    },
                    {
                        "id": 18012,
                        "name": "Künten",
                        "latitude": "47.38887000",
                        "longitude": "8.33045000"
                    },
                    {
                        "id": 18020,
                        "name": "Küttigen",
                        "latitude": "47.41484000",
                        "longitude": "8.04979000"
                    },
                    {
                        "id": 18043,
                        "name": "Laufenburg",
                        "latitude": "47.55985000",
                        "longitude": "8.06225000"
                    },
                    {
                        "id": 18044,
                        "name": "Lauffohr (Brugg)",
                        "latitude": "47.50154000",
                        "longitude": "8.23122000"
                    },
                    {
                        "id": 18062,
                        "name": "Leibstadt",
                        "latitude": "47.58790000",
                        "longitude": "8.17611000"
                    },
                    {
                        "id": 18066,
                        "name": "Lenzburg",
                        "latitude": "47.38853000",
                        "longitude": "8.17503000"
                    },
                    {
                        "id": 18115,
                        "name": "Magden",
                        "latitude": "47.52868000",
                        "longitude": "7.81128000"
                    },
                    {
                        "id": 18144,
                        "name": "Meisterschwanden",
                        "latitude": "47.29489000",
                        "longitude": "8.22867000"
                    },
                    {
                        "id": 18148,
                        "name": "Mellingen",
                        "latitude": "47.41903000",
                        "longitude": "8.27331000"
                    },
                    {
                        "id": 18151,
                        "name": "Menziken",
                        "latitude": "47.23965000",
                        "longitude": "8.18996000"
                    },
                    {
                        "id": 18154,
                        "name": "Merenschwand",
                        "latitude": "47.25944000",
                        "longitude": "8.37633000"
                    },
                    {
                        "id": 18191,
                        "name": "Möhlin",
                        "latitude": "47.55915000",
                        "longitude": "7.84329000"
                    },
                    {
                        "id": 18176,
                        "name": "Muhen",
                        "latitude": "47.33578000",
                        "longitude": "8.05536000"
                    },
                    {
                        "id": 18177,
                        "name": "Mumpf",
                        "latitude": "47.54563000",
                        "longitude": "7.92123000"
                    },
                    {
                        "id": 18181,
                        "name": "Murgenthal",
                        "latitude": "47.27145000",
                        "longitude": "7.83935000"
                    },
                    {
                        "id": 18182,
                        "name": "Muri",
                        "latitude": "47.27428000",
                        "longitude": "8.33854000"
                    },
                    {
                        "id": 18215,
                        "name": "Neuenhof",
                        "latitude": "47.44985000",
                        "longitude": "8.32682000"
                    },
                    {
                        "id": 18227,
                        "name": "Niederlenz",
                        "latitude": "47.40079000",
                        "longitude": "8.17640000"
                    },
                    {
                        "id": 18228,
                        "name": "Niederrohrdorf",
                        "latitude": "47.42409000",
                        "longitude": "8.30404000"
                    },
                    {
                        "id": 18250,
                        "name": "Oberentfelden",
                        "latitude": "47.35639000",
                        "longitude": "8.04594000"
                    },
                    {
                        "id": 18257,
                        "name": "Oberlunkhofen",
                        "latitude": "47.31244000",
                        "longitude": "8.39242000"
                    },
                    {
                        "id": 18263,
                        "name": "Oberrohrdorf",
                        "latitude": "47.41833000",
                        "longitude": "8.31983000"
                    },
                    {
                        "id": 18264,
                        "name": "Oberrüti",
                        "latitude": "47.16673000",
                        "longitude": "8.39441000"
                    },
                    {
                        "id": 18266,
                        "name": "Obersiggenthal",
                        "latitude": "47.48750000",
                        "longitude": "8.29652000"
                    },
                    {
                        "id": 18281,
                        "name": "Oftringen",
                        "latitude": "47.31382000",
                        "longitude": "7.92533000"
                    },
                    {
                        "id": 18293,
                        "name": "Othmarsingen",
                        "latitude": "47.40125000",
                        "longitude": "8.21383000"
                    },
                    {
                        "id": 18363,
                        "name": "Reinach",
                        "latitude": "47.25732000",
                        "longitude": "8.18091000"
                    },
                    {
                        "id": 18366,
                        "name": "Rheinfelden",
                        "latitude": "47.55437000",
                        "longitude": "7.79403000"
                    },
                    {
                        "id": 18394,
                        "name": "Rothrist",
                        "latitude": "47.30508000",
                        "longitude": "7.89196000"
                    },
                    {
                        "id": 18397,
                        "name": "Rudolfstetten",
                        "latitude": "47.37101000",
                        "longitude": "8.38083000"
                    },
                    {
                        "id": 18399,
                        "name": "Rupperswil",
                        "latitude": "47.40131000",
                        "longitude": "8.12877000"
                    },
                    {
                        "id": 18419,
                        "name": "Safenwil",
                        "latitude": "47.32163000",
                        "longitude": "7.98254000"
                    },
                    {
                        "id": 18446,
                        "name": "Sarmenstorf",
                        "latitude": "47.31109000",
                        "longitude": "8.24950000"
                    },
                    {
                        "id": 18456,
                        "name": "Schafisheim",
                        "latitude": "47.37664000",
                        "longitude": "8.14263000"
                    },
                    {
                        "id": 18462,
                        "name": "Schinznach Bad",
                        "latitude": "47.44992000",
                        "longitude": "8.16833000"
                    },
                    {
                        "id": 18463,
                        "name": "Schinznach Dorf",
                        "latitude": "47.44650000",
                        "longitude": "8.14089000"
                    },
                    {
                        "id": 18483,
                        "name": "Schöftland",
                        "latitude": "47.30590000",
                        "longitude": "8.05119000"
                    },
                    {
                        "id": 18474,
                        "name": "Schwaderloch",
                        "latitude": "47.58541000",
                        "longitude": "8.14455000"
                    },
                    {
                        "id": 18501,
                        "name": "Seengen",
                        "latitude": "47.32503000",
                        "longitude": "8.20724000"
                    },
                    {
                        "id": 18511,
                        "name": "Seon",
                        "latitude": "47.34848000",
                        "longitude": "8.16072000"
                    },
                    {
                        "id": 18523,
                        "name": "Sins",
                        "latitude": "47.19296000",
                        "longitude": "8.39384000"
                    },
                    {
                        "id": 18534,
                        "name": "Spreitenbach",
                        "latitude": "47.42285000",
                        "longitude": "8.36792000"
                    },
                    {
                        "id": 18544,
                        "name": "Staffelbach",
                        "latitude": "47.28395000",
                        "longitude": "8.04208000"
                    },
                    {
                        "id": 18548,
                        "name": "Staufen",
                        "latitude": "47.38197000",
                        "longitude": "8.16681000"
                    },
                    {
                        "id": 18551,
                        "name": "Stein",
                        "latitude": "47.54403000",
                        "longitude": "7.95256000"
                    },
                    {
                        "id": 18559,
                        "name": "Strengelbach",
                        "latitude": "47.27917000",
                        "longitude": "7.92895000"
                    },
                    {
                        "id": 18562,
                        "name": "Suhr",
                        "latitude": "47.37172000",
                        "longitude": "8.07967000"
                    },
                    {
                        "id": 18564,
                        "name": "Sulz",
                        "latitude": "47.53602000",
                        "longitude": "8.09628000"
                    },
                    {
                        "id": 18577,
                        "name": "Tegerfelden",
                        "latitude": "47.55809000",
                        "longitude": "8.28914000"
                    },
                    {
                        "id": 18580,
                        "name": "Teufenthal",
                        "latitude": "47.32896000",
                        "longitude": "8.11777000"
                    },
                    {
                        "id": 18614,
                        "name": "Turgi",
                        "latitude": "47.49201000",
                        "longitude": "8.25412000"
                    },
                    {
                        "id": 18625,
                        "name": "Uerkheim",
                        "latitude": "47.30353000",
                        "longitude": "8.02320000"
                    },
                    {
                        "id": 18633,
                        "name": "Unterkulm",
                        "latitude": "47.30998000",
                        "longitude": "8.11371000"
                    },
                    {
                        "id": 18634,
                        "name": "Unterlunkhofen",
                        "latitude": "47.32120000",
                        "longitude": "8.38102000"
                    },
                    {
                        "id": 18636,
                        "name": "Untersiggenthal",
                        "latitude": "47.50213000",
                        "longitude": "8.25554000"
                    },
                    {
                        "id": 18664,
                        "name": "Veltheim",
                        "latitude": "47.43796000",
                        "longitude": "8.14722000"
                    },
                    {
                        "id": 18683,
                        "name": "Villigen",
                        "latitude": "47.52682000",
                        "longitude": "8.21486000"
                    },
                    {
                        "id": 18684,
                        "name": "Villmergen",
                        "latitude": "47.35009000",
                        "longitude": "8.24762000"
                    },
                    {
                        "id": 18685,
                        "name": "Villnachern",
                        "latitude": "47.47098000",
                        "longitude": "8.15975000"
                    },
                    {
                        "id": 18692,
                        "name": "Vordemwald",
                        "latitude": "47.27585000",
                        "longitude": "7.90114000"
                    },
                    {
                        "id": 18719,
                        "name": "Waltenschwil",
                        "latitude": "47.33339000",
                        "longitude": "8.29791000"
                    },
                    {
                        "id": 18728,
                        "name": "Wegenstetten",
                        "latitude": "47.49797000",
                        "longitude": "7.93141000"
                    },
                    {
                        "id": 18736,
                        "name": "Wettingen",
                        "latitude": "47.47049000",
                        "longitude": "8.31636000"
                    },
                    {
                        "id": 18757,
                        "name": "Windisch",
                        "latitude": "47.47899000",
                        "longitude": "8.21842000"
                    },
                    {
                        "id": 18760,
                        "name": "Wittnau",
                        "latitude": "47.48139000",
                        "longitude": "7.97577000"
                    },
                    {
                        "id": 18761,
                        "name": "Wohlen",
                        "latitude": "47.35066000",
                        "longitude": "8.27517000"
                    },
                    {
                        "id": 18782,
                        "name": "Wölflinswil",
                        "latitude": "47.46070000",
                        "longitude": "7.99835000"
                    },
                    {
                        "id": 18788,
                        "name": "Würenlingen",
                        "latitude": "47.53356000",
                        "longitude": "8.25666000"
                    },
                    {
                        "id": 18789,
                        "name": "Würenlos",
                        "latitude": "47.44205000",
                        "longitude": "8.36261000"
                    },
                    {
                        "id": 18796,
                        "name": "Zofingen",
                        "latitude": "47.28779000",
                        "longitude": "7.94586000"
                    }
                ]
            },
            {
                "id": 1655,
                "name": "Appenzell Ausserrhoden",
                "iso2": "AR",
                "latitude": "47.36648100",
                "longitude": "9.30009160",
                "type": "canton",
                "cities": [
                    {
                        "id": 17487,
                        "name": "Bezirk Hinterland",
                        "latitude": "47.36470000",
                        "longitude": "9.27350000"
                    },
                    {
                        "id": 17500,
                        "name": "Bezirk Mittelland",
                        "latitude": "47.37700000",
                        "longitude": "9.43469000"
                    },
                    {
                        "id": 17517,
                        "name": "Bezirk Vorderland",
                        "latitude": "47.44167000",
                        "longitude": "9.53869000"
                    },
                    {
                        "id": 17597,
                        "name": "Bühler",
                        "latitude": "47.37348000",
                        "longitude": "9.42507000"
                    },
                    {
                        "id": 17819,
                        "name": "Gais",
                        "latitude": "47.36150000",
                        "longitude": "9.45356000"
                    },
                    {
                        "id": 17901,
                        "name": "Heiden",
                        "latitude": "47.44255000",
                        "longitude": "9.53293000"
                    },
                    {
                        "id": 17907,
                        "name": "Herisau",
                        "latitude": "47.38615000",
                        "longitude": "9.27916000"
                    },
                    {
                        "id": 18359,
                        "name": "Rehetobel",
                        "latitude": "47.42611000",
                        "longitude": "9.48300000"
                    },
                    {
                        "id": 18477,
                        "name": "Schwellbrunn",
                        "latitude": "47.35255000",
                        "longitude": "9.24894000"
                    },
                    {
                        "id": 18532,
                        "name": "Speicher",
                        "latitude": "47.41090000",
                        "longitude": "9.44335000"
                    },
                    {
                        "id": 18579,
                        "name": "Teufen",
                        "latitude": "47.39080000",
                        "longitude": "9.38644000"
                    },
                    {
                        "id": 18605,
                        "name": "Trogen",
                        "latitude": "47.40782000",
                        "longitude": "9.46498000"
                    },
                    {
                        "id": 18643,
                        "name": "Urnäsch",
                        "latitude": "47.31669000",
                        "longitude": "9.27950000"
                    },
                    {
                        "id": 18712,
                        "name": "Waldstatt",
                        "latitude": "47.35627000",
                        "longitude": "9.28345000"
                    },
                    {
                        "id": 18720,
                        "name": "Walzenhausen",
                        "latitude": "47.44867000",
                        "longitude": "9.60495000"
                    }
                ]
            },
            {
                "id": 1649,
                "name": "Appenzell Innerrhoden",
                "iso2": "AI",
                "latitude": "47.31619250",
                "longitude": "9.43165730",
                "type": "canton",
                "cities": [
                    {
                        "id": 17400,
                        "name": "Appenzell",
                        "latitude": "47.33103000",
                        "longitude": "9.40996000"
                    },
                    {
                        "id": 17852,
                        "name": "Gonten",
                        "latitude": "47.32725000",
                        "longitude": "9.34705000"
                    },
                    {
                        "id": 17894,
                        "name": "Haslen",
                        "latitude": "47.36931000",
                        "longitude": "9.36752000"
                    },
                    {
                        "id": 18245,
                        "name": "Oberegg",
                        "latitude": "47.42531000",
                        "longitude": "9.55134000"
                    }
                ]
            },
            {
                "id": 1641,
                "name": "Basel-Land",
                "iso2": "BL",
                "latitude": "47.44181220",
                "longitude": "7.76440020",
                "type": "canton",
                "cities": [
                    {
                        "id": 17371,
                        "name": "Aesch",
                        "latitude": "47.47104000",
                        "longitude": "7.59730000"
                    },
                    {
                        "id": 17386,
                        "name": "Allschwil",
                        "latitude": "47.55074000",
                        "longitude": "7.53599000"
                    },
                    {
                        "id": 17406,
                        "name": "Arisdorf",
                        "latitude": "47.51323000",
                        "longitude": "7.76515000"
                    },
                    {
                        "id": 17408,
                        "name": "Arlesheim",
                        "latitude": "47.49412000",
                        "longitude": "7.61979000"
                    },
                    {
                        "id": 17474,
                        "name": "Bezirk Arlesheim",
                        "latitude": "47.51668000",
                        "longitude": "7.58733000"
                    },
                    {
                        "id": 17493,
                        "name": "Bezirk Laufen",
                        "latitude": "47.42324000",
                        "longitude": "7.48750000"
                    },
                    {
                        "id": 17497,
                        "name": "Bezirk Liestal",
                        "latitude": "47.48124000",
                        "longitude": "7.72714000"
                    },
                    {
                        "id": 17510,
                        "name": "Bezirk Sissach",
                        "latitude": "47.44237000",
                        "longitude": "7.84871000"
                    },
                    {
                        "id": 17518,
                        "name": "Bezirk Waldenburg",
                        "latitude": "47.39367000",
                        "longitude": "7.74137000"
                    },
                    {
                        "id": 17530,
                        "name": "Binningen",
                        "latitude": "47.54021000",
                        "longitude": "7.56932000"
                    },
                    {
                        "id": 17538,
                        "name": "Birsfelden",
                        "latitude": "47.55290000",
                        "longitude": "7.62322000"
                    },
                    {
                        "id": 17553,
                        "name": "Bottmingen",
                        "latitude": "47.52343000",
                        "longitude": "7.57211000"
                    },
                    {
                        "id": 17563,
                        "name": "Brislach",
                        "latitude": "47.41763000",
                        "longitude": "7.54340000"
                    },
                    {
                        "id": 17575,
                        "name": "Bubendorf",
                        "latitude": "47.44586000",
                        "longitude": "7.73759000"
                    },
                    {
                        "id": 17589,
                        "name": "Buus",
                        "latitude": "47.50635000",
                        "longitude": "7.86414000"
                    },
                    {
                        "id": 17684,
                        "name": "Diegten",
                        "latitude": "47.41380000",
                        "longitude": "7.81085000"
                    },
                    {
                        "id": 17775,
                        "name": "Ettingen",
                        "latitude": "47.48225000",
                        "longitude": "7.54654000"
                    },
                    {
                        "id": 17808,
                        "name": "Frenkendorf",
                        "latitude": "47.50686000",
                        "longitude": "7.71648000"
                    },
                    {
                        "id": 17817,
                        "name": "Füllinsdorf",
                        "latitude": "47.50688000",
                        "longitude": "7.73129000"
                    },
                    {
                        "id": 17825,
                        "name": "Gelterkinden",
                        "latitude": "47.46497000",
                        "longitude": "7.85174000"
                    },
                    {
                        "id": 17867,
                        "name": "Grellingen",
                        "latitude": "47.44231000",
                        "longitude": "7.58906000"
                    },
                    {
                        "id": 17942,
                        "name": "Hölstein",
                        "latitude": "47.42290000",
                        "longitude": "7.77041000"
                    },
                    {
                        "id": 17956,
                        "name": "Itingen",
                        "latitude": "47.46651000",
                        "longitude": "7.78502000"
                    },
                    {
                        "id": 18034,
                        "name": "Langenbruck",
                        "latitude": "47.34917000",
                        "longitude": "7.76802000"
                    },
                    {
                        "id": 18109,
                        "name": "Läufelfingen",
                        "latitude": "47.39457000",
                        "longitude": "7.85578000"
                    },
                    {
                        "id": 18042,
                        "name": "Laufen",
                        "latitude": "47.42193000",
                        "longitude": "7.49946000"
                    },
                    {
                        "id": 18050,
                        "name": "Lausen",
                        "latitude": "47.47139000",
                        "longitude": "7.76030000"
                    },
                    {
                        "id": 18082,
                        "name": "Liesberg",
                        "latitude": "47.40398000",
                        "longitude": "7.42787000"
                    },
                    {
                        "id": 18083,
                        "name": "Liestal",
                        "latitude": "47.48455000",
                        "longitude": "7.73446000"
                    },
                    {
                        "id": 18200,
                        "name": "Münchenstein",
                        "latitude": "47.51848000",
                        "longitude": "7.60966000"
                    },
                    {
                        "id": 18185,
                        "name": "Muttenz",
                        "latitude": "47.52271000",
                        "longitude": "7.64511000"
                    },
                    {
                        "id": 18244,
                        "name": "Oberdorf",
                        "latitude": "47.39353000",
                        "longitude": "7.75169000"
                    },
                    {
                        "id": 18270,
                        "name": "Oberwil",
                        "latitude": "47.51407000",
                        "longitude": "7.55786000"
                    },
                    {
                        "id": 18287,
                        "name": "Ormalingen",
                        "latitude": "47.46936000",
                        "longitude": "7.87248000"
                    },
                    {
                        "id": 18307,
                        "name": "Pfeffingen",
                        "latitude": "47.45984000",
                        "longitude": "7.58975000"
                    },
                    {
                        "id": 18324,
                        "name": "Pratteln",
                        "latitude": "47.52071000",
                        "longitude": "7.69356000"
                    },
                    {
                        "id": 18362,
                        "name": "Reigoldswil",
                        "latitude": "47.39824000",
                        "longitude": "7.68718000"
                    },
                    {
                        "id": 18403,
                        "name": "Röschenz",
                        "latitude": "47.42366000",
                        "longitude": "7.48024000"
                    },
                    {
                        "id": 18484,
                        "name": "Schönenbuch",
                        "latitude": "47.53853000",
                        "longitude": "7.50572000"
                    },
                    {
                        "id": 18505,
                        "name": "Seltisberg",
                        "latitude": "47.46249000",
                        "longitude": "7.72039000"
                    },
                    {
                        "id": 18526,
                        "name": "Sissach",
                        "latitude": "47.46408000",
                        "longitude": "7.80888000"
                    },
                    {
                        "id": 18589,
                        "name": "Therwil",
                        "latitude": "47.49941000",
                        "longitude": "7.55669000"
                    },
                    {
                        "id": 18699,
                        "name": "Wahlen",
                        "latitude": "47.40226000",
                        "longitude": "7.51511000"
                    },
                    {
                        "id": 18710,
                        "name": "Waldenburg",
                        "latitude": "47.38333000",
                        "longitude": "7.75000000"
                    },
                    {
                        "id": 18803,
                        "name": "Zunzgen",
                        "latitude": "47.44925000",
                        "longitude": "7.80789000"
                    },
                    {
                        "id": 18807,
                        "name": "Zwingen",
                        "latitude": "47.43825000",
                        "longitude": "7.53027000"
                    }
                ]
            },
            {
                "id": 4957,
                "name": "Basel-Stadt",
                "iso2": "BS",
                "latitude": "47.56666700",
                "longitude": "7.60000000",
                "type": "canton",
                "cities": [
                    {
                        "id": 149129,
                        "name": "Basel",
                        "latitude": "47.55472200",
                        "longitude": "7.59055600"
                    },
                    {
                        "id": 149130,
                        "name": "Bettingen",
                        "latitude": "47.57138900",
                        "longitude": "7.66416700"
                    },
                    {
                        "id": 149131,
                        "name": "Riehen",
                        "latitude": "47.58333300",
                        "longitude": "7.63333300"
                    }
                ]
            },
            {
                "id": 1645,
                "name": "Bern",
                "iso2": "BE",
                "latitude": "46.79886210",
                "longitude": "7.70807010",
                "type": "canton",
                "cities": [
                    {
                        "id": 17358,
                        "name": "Aarberg",
                        "latitude": "47.04439000",
                        "longitude": "7.27578000"
                    },
                    {
                        "id": 17360,
                        "name": "Aarwangen",
                        "latitude": "47.23845000",
                        "longitude": "7.76854000"
                    },
                    {
                        "id": 17362,
                        "name": "Adelboden",
                        "latitude": "46.49142000",
                        "longitude": "7.56031000"
                    },
                    {
                        "id": 17373,
                        "name": "Aeschi b. Spiez",
                        "latitude": "46.65848000",
                        "longitude": "7.69650000"
                    },
                    {
                        "id": 17404,
                        "name": "Arch",
                        "latitude": "47.16533000",
                        "longitude": "7.43139000"
                    },
                    {
                        "id": 17417,
                        "name": "Attiswil",
                        "latitude": "47.24673000",
                        "longitude": "7.61353000"
                    },
                    {
                        "id": 17592,
                        "name": "Bäriswil",
                        "latitude": "47.01947000",
                        "longitude": "7.52709000"
                    },
                    {
                        "id": 17593,
                        "name": "Bätterkinden",
                        "latitude": "47.13164000",
                        "longitude": "7.53817000"
                    },
                    {
                        "id": 17447,
                        "name": "Beatenberg",
                        "latitude": "46.69896000",
                        "longitude": "7.79428000"
                    },
                    {
                        "id": 17454,
                        "name": "Bellmund",
                        "latitude": "47.10852000",
                        "longitude": "7.24608000"
                    },
                    {
                        "id": 17456,
                        "name": "Belp",
                        "latitude": "46.89129000",
                        "longitude": "7.49825000"
                    },
                    {
                        "id": 17462,
                        "name": "Bern",
                        "latitude": "46.94809000",
                        "longitude": "7.44744000"
                    },
                    {
                        "id": 17463,
                        "name": "Bern-Mittelland District",
                        "latitude": "46.92526000",
                        "longitude": "7.49024000"
                    },
                    {
                        "id": 17594,
                        "name": "Bévilard",
                        "latitude": "47.23711000",
                        "longitude": "7.28325000"
                    },
                    {
                        "id": 17526,
                        "name": "Biel\/Bienne",
                        "latitude": "47.13713000",
                        "longitude": "7.24608000"
                    },
                    {
                        "id": 17527,
                        "name": "Biel\/Bienne District",
                        "latitude": "47.12725000",
                        "longitude": "7.26174000"
                    },
                    {
                        "id": 17528,
                        "name": "Biglen",
                        "latitude": "46.92629000",
                        "longitude": "7.62508000"
                    },
                    {
                        "id": 17542,
                        "name": "Blumenstein",
                        "latitude": "46.74210000",
                        "longitude": "7.52136000"
                    },
                    {
                        "id": 17545,
                        "name": "Bolligen",
                        "latitude": "46.97510000",
                        "longitude": "7.49697000"
                    },
                    {
                        "id": 17546,
                        "name": "Boltigen",
                        "latitude": "46.62847000",
                        "longitude": "7.39054000"
                    },
                    {
                        "id": 17595,
                        "name": "Bönigen",
                        "latitude": "46.68736000",
                        "longitude": "7.89350000"
                    },
                    {
                        "id": 17556,
                        "name": "Bowil",
                        "latitude": "46.89304000",
                        "longitude": "7.69757000"
                    },
                    {
                        "id": 17560,
                        "name": "Brienz",
                        "latitude": "46.75450000",
                        "longitude": "8.03847000"
                    },
                    {
                        "id": 17572,
                        "name": "Brügg",
                        "latitude": "47.12370000",
                        "longitude": "7.27887000"
                    },
                    {
                        "id": 17577,
                        "name": "Buchholterberg",
                        "latitude": "46.81351000",
                        "longitude": "7.67463000"
                    },
                    {
                        "id": 17583,
                        "name": "Burgdorf",
                        "latitude": "47.05901000",
                        "longitude": "7.62786000"
                    },
                    {
                        "id": 17584,
                        "name": "Burgistein",
                        "latitude": "46.78464000",
                        "longitude": "7.49988000"
                    },
                    {
                        "id": 17653,
                        "name": "Corgémont",
                        "latitude": "47.19457000",
                        "longitude": "7.14517000"
                    },
                    {
                        "id": 17664,
                        "name": "Court",
                        "latitude": "47.23956000",
                        "longitude": "7.33655000"
                    },
                    {
                        "id": 17665,
                        "name": "Courtelary",
                        "latitude": "47.17822000",
                        "longitude": "7.07236000"
                    },
                    {
                        "id": 17708,
                        "name": "Därligen",
                        "latitude": "46.66175000",
                        "longitude": "7.80808000"
                    },
                    {
                        "id": 17686,
                        "name": "Diemtigen",
                        "latitude": "46.64928000",
                        "longitude": "7.56477000"
                    },
                    {
                        "id": 17716,
                        "name": "Dürrenroth",
                        "latitude": "47.08953000",
                        "longitude": "7.79170000"
                    },
                    {
                        "id": 17731,
                        "name": "Eggiwil",
                        "latitude": "46.87575000",
                        "longitude": "7.79567000"
                    },
                    {
                        "id": 17747,
                        "name": "Emmental District",
                        "latitude": "47.04425000",
                        "longitude": "7.66176000"
                    },
                    {
                        "id": 17758,
                        "name": "Eriswil",
                        "latitude": "47.07816000",
                        "longitude": "7.85149000"
                    },
                    {
                        "id": 17759,
                        "name": "Erlach",
                        "latitude": "47.04220000",
                        "longitude": "7.09728000"
                    },
                    {
                        "id": 17764,
                        "name": "Erlenbach im Simmental",
                        "latitude": "46.66021000",
                        "longitude": "7.55445000"
                    },
                    {
                        "id": 17767,
                        "name": "Ersigen",
                        "latitude": "47.09368000",
                        "longitude": "7.59507000"
                    },
                    {
                        "id": 17777,
                        "name": "Evilard",
                        "latitude": "47.15046000",
                        "longitude": "7.23895000"
                    },
                    {
                        "id": 17784,
                        "name": "Ferenbalm",
                        "latitude": "46.94880000",
                        "longitude": "7.21124000"
                    },
                    {
                        "id": 17802,
                        "name": "Fraubrunnen",
                        "latitude": "47.08620000",
                        "longitude": "7.52727000"
                    },
                    {
                        "id": 17805,
                        "name": "Frauenkappelen",
                        "latitude": "46.95425000",
                        "longitude": "7.33835000"
                    },
                    {
                        "id": 17812,
                        "name": "Frutigen",
                        "latitude": "46.58723000",
                        "longitude": "7.64945000"
                    },
                    {
                        "id": 17813,
                        "name": "Frutigen-Niedersimmental District",
                        "latitude": "46.60236000",
                        "longitude": "7.62292000"
                    },
                    {
                        "id": 17870,
                        "name": "Grindelwald",
                        "latitude": "46.62396000",
                        "longitude": "8.03601000"
                    },
                    {
                        "id": 17874,
                        "name": "Grossaffoltern",
                        "latitude": "47.06534000",
                        "longitude": "7.35689000"
                    },
                    {
                        "id": 17884,
                        "name": "Gstaad",
                        "latitude": "46.47215000",
                        "longitude": "7.28685000"
                    },
                    {
                        "id": 17885,
                        "name": "Guggisberg",
                        "latitude": "46.76756000",
                        "longitude": "7.32946000"
                    },
                    {
                        "id": 17902,
                        "name": "Heimberg",
                        "latitude": "46.79482000",
                        "longitude": "7.60433000"
                    },
                    {
                        "id": 17903,
                        "name": "Heimiswil",
                        "latitude": "47.06755000",
                        "longitude": "7.66665000"
                    },
                    {
                        "id": 17908,
                        "name": "Hermiswil",
                        "latitude": "46.83125000",
                        "longitude": "7.47775000"
                    },
                    {
                        "id": 17910,
                        "name": "Herzogenbuchsee",
                        "latitude": "47.18795000",
                        "longitude": "7.70620000"
                    },
                    {
                        "id": 17913,
                        "name": "Hilterfingen",
                        "latitude": "46.73521000",
                        "longitude": "7.66185000"
                    },
                    {
                        "id": 17915,
                        "name": "Hindelbank",
                        "latitude": "47.04270000",
                        "longitude": "7.54143000"
                    },
                    {
                        "id": 17936,
                        "name": "Huttwil",
                        "latitude": "47.11502000",
                        "longitude": "7.86209000"
                    },
                    {
                        "id": 17952,
                        "name": "Ins",
                        "latitude": "47.00584000",
                        "longitude": "7.10609000"
                    },
                    {
                        "id": 17953,
                        "name": "Interlaken",
                        "latitude": "46.68387000",
                        "longitude": "7.86638000"
                    },
                    {
                        "id": 17954,
                        "name": "Interlaken-Oberhasli District",
                        "latitude": "46.68931000",
                        "longitude": "7.98869000"
                    },
                    {
                        "id": 17957,
                        "name": "Jegenstorf",
                        "latitude": "47.04802000",
                        "longitude": "7.50787000"
                    },
                    {
                        "id": 17963,
                        "name": "Jura bernois",
                        "latitude": "47.21892000",
                        "longitude": "7.21981000"
                    },
                    {
                        "id": 17968,
                        "name": "Kallnach",
                        "latitude": "47.02032000",
                        "longitude": "7.23545000"
                    },
                    {
                        "id": 17970,
                        "name": "Kandersteg",
                        "latitude": "46.49467000",
                        "longitude": "7.67326000"
                    },
                    {
                        "id": 17971,
                        "name": "Kappelen",
                        "latitude": "47.06015000",
                        "longitude": "7.26860000"
                    },
                    {
                        "id": 17972,
                        "name": "Kehrsatz",
                        "latitude": "46.91035000",
                        "longitude": "7.47096000"
                    },
                    {
                        "id": 17981,
                        "name": "Kirchberg",
                        "latitude": "47.08538000",
                        "longitude": "7.58288000"
                    },
                    {
                        "id": 17982,
                        "name": "Kirchlindach",
                        "latitude": "46.99965000",
                        "longitude": "7.41735000"
                    },
                    {
                        "id": 18011,
                        "name": "Köniz",
                        "latitude": "46.92436000",
                        "longitude": "7.41457000"
                    },
                    {
                        "id": 18002,
                        "name": "Konolfingen",
                        "latitude": "46.87909000",
                        "longitude": "7.62013000"
                    },
                    {
                        "id": 18003,
                        "name": "Koppigen",
                        "latitude": "47.13125000",
                        "longitude": "7.60525000"
                    },
                    {
                        "id": 18004,
                        "name": "Krauchthal",
                        "latitude": "47.00964000",
                        "longitude": "7.56640000"
                    },
                    {
                        "id": 18023,
                        "name": "La Neuveville",
                        "latitude": "47.06592000",
                        "longitude": "7.09717000"
                    },
                    {
                        "id": 18036,
                        "name": "Langenthal",
                        "latitude": "47.21526000",
                        "longitude": "7.79607000"
                    },
                    {
                        "id": 18037,
                        "name": "Langnau",
                        "latitude": "46.93936000",
                        "longitude": "7.78738000"
                    },
                    {
                        "id": 18045,
                        "name": "Laupen",
                        "latitude": "46.90214000",
                        "longitude": "7.23973000"
                    },
                    {
                        "id": 18047,
                        "name": "Lauperswil",
                        "latitude": "46.96564000",
                        "longitude": "7.74214000"
                    },
                    {
                        "id": 18051,
                        "name": "Lauterbrunnen",
                        "latitude": "46.59307000",
                        "longitude": "7.90938000"
                    },
                    {
                        "id": 18063,
                        "name": "Lengnau",
                        "latitude": "47.18155000",
                        "longitude": "7.36814000"
                    },
                    {
                        "id": 18064,
                        "name": "Lenk",
                        "latitude": "46.45826000",
                        "longitude": "7.44298000"
                    },
                    {
                        "id": 18077,
                        "name": "Leuzigen",
                        "latitude": "47.17458000",
                        "longitude": "7.45775000"
                    },
                    {
                        "id": 153791,
                        "name": "Liebefeld ",
                        "latitude": "46.93335790",
                        "longitude": "7.39606840"
                    },
                    {
                        "id": 18085,
                        "name": "Linden",
                        "latitude": "46.84690000",
                        "longitude": "7.67831000"
                    },
                    {
                        "id": 18093,
                        "name": "Lotzwil",
                        "latitude": "47.19135000",
                        "longitude": "7.79102000"
                    },
                    {
                        "id": 18112,
                        "name": "Lützelflüh",
                        "latitude": "47.00757000",
                        "longitude": "7.69165000"
                    },
                    {
                        "id": 18107,
                        "name": "Lyss",
                        "latitude": "47.07410000",
                        "longitude": "7.30655000"
                    },
                    {
                        "id": 18108,
                        "name": "Lyssach",
                        "latitude": "47.06445000",
                        "longitude": "7.58228000"
                    },
                    {
                        "id": 18113,
                        "name": "Madiswil",
                        "latitude": "47.16463000",
                        "longitude": "7.79858000"
                    },
                    {
                        "id": 18118,
                        "name": "Malleray",
                        "latitude": "47.23839000",
                        "longitude": "7.27286000"
                    },
                    {
                        "id": 18129,
                        "name": "Matten",
                        "latitude": "46.67833000",
                        "longitude": "7.86889000"
                    },
                    {
                        "id": 18142,
                        "name": "Meinisberg",
                        "latitude": "47.15965000",
                        "longitude": "7.34801000"
                    },
                    {
                        "id": 18143,
                        "name": "Meiringen",
                        "latitude": "46.72709000",
                        "longitude": "8.18720000"
                    },
                    {
                        "id": 18146,
                        "name": "Melchnau",
                        "latitude": "47.18213000",
                        "longitude": "7.85128000"
                    },
                    {
                        "id": 18175,
                        "name": "Moutier",
                        "latitude": "47.27818000",
                        "longitude": "7.36951000"
                    },
                    {
                        "id": 18195,
                        "name": "Mühleberg",
                        "latitude": "46.95466000",
                        "longitude": "7.26102000"
                    },
                    {
                        "id": 18197,
                        "name": "Mühlethurnen",
                        "latitude": "46.81345000",
                        "longitude": "7.50881000"
                    },
                    {
                        "id": 18199,
                        "name": "Münchenbuchsee",
                        "latitude": "47.02175000",
                        "longitude": "7.45036000"
                    },
                    {
                        "id": 18201,
                        "name": "Münchenwiler",
                        "latitude": "46.91334000",
                        "longitude": "7.12556000"
                    },
                    {
                        "id": 18204,
                        "name": "Münsingen",
                        "latitude": "46.87298000",
                        "longitude": "7.56100000"
                    },
                    {
                        "id": 18206,
                        "name": "Müntschemier",
                        "latitude": "46.99548000",
                        "longitude": "7.14626000"
                    },
                    {
                        "id": 18183,
                        "name": "Muri",
                        "latitude": "46.93122000",
                        "longitude": "7.48658000"
                    },
                    {
                        "id": 18219,
                        "name": "Nidau",
                        "latitude": "47.12545000",
                        "longitude": "7.24033000"
                    },
                    {
                        "id": 18220,
                        "name": "Niederbipp",
                        "latitude": "47.27175000",
                        "longitude": "7.69583000"
                    },
                    {
                        "id": 18239,
                        "name": "Oberaargau",
                        "latitude": "47.19202000",
                        "longitude": "7.74553000"
                    },
                    {
                        "id": 18240,
                        "name": "Oberbipp",
                        "latitude": "47.26070000",
                        "longitude": "7.66359000"
                    },
                    {
                        "id": 18242,
                        "name": "Oberburg",
                        "latitude": "47.03665000",
                        "longitude": "7.62745000"
                    },
                    {
                        "id": 18243,
                        "name": "Oberdiessbach",
                        "latitude": "46.84117000",
                        "longitude": "7.61730000"
                    },
                    {
                        "id": 18267,
                        "name": "Obersimmental-Saanen District",
                        "latitude": "46.47932000",
                        "longitude": "7.35803000"
                    },
                    {
                        "id": 18289,
                        "name": "Orpund",
                        "latitude": "47.13891000",
                        "longitude": "7.30775000"
                    },
                    {
                        "id": 18291,
                        "name": "Orvin",
                        "latitude": "47.16068000",
                        "longitude": "7.21368000"
                    },
                    {
                        "id": 18332,
                        "name": "Péry",
                        "latitude": "47.19398000",
                        "longitude": "7.24913000"
                    },
                    {
                        "id": 18314,
                        "name": "Pieterlen",
                        "latitude": "47.17501000",
                        "longitude": "7.33791000"
                    },
                    {
                        "id": 18334,
                        "name": "Radelfingen",
                        "latitude": "47.02146000",
                        "longitude": "7.27178000"
                    },
                    {
                        "id": 18343,
                        "name": "Reconvilier",
                        "latitude": "47.23431000",
                        "longitude": "7.22239000"
                    },
                    {
                        "id": 18376,
                        "name": "Riggisberg",
                        "latitude": "46.81028000",
                        "longitude": "7.48014000"
                    },
                    {
                        "id": 18377,
                        "name": "Ringgenberg",
                        "latitude": "46.70114000",
                        "longitude": "7.89445000"
                    },
                    {
                        "id": 18382,
                        "name": "Roggwil",
                        "latitude": "47.24119000",
                        "longitude": "7.82141000"
                    },
                    {
                        "id": 18385,
                        "name": "Rohrbach",
                        "latitude": "47.13521000",
                        "longitude": "7.81334000"
                    },
                    {
                        "id": 18396,
                        "name": "Rubigen",
                        "latitude": "46.89868000",
                        "longitude": "7.54460000"
                    },
                    {
                        "id": 18404,
                        "name": "Rüderswil",
                        "latitude": "46.98374000",
                        "longitude": "7.72167000"
                    },
                    {
                        "id": 18405,
                        "name": "Rüeggisberg",
                        "latitude": "46.82216000",
                        "longitude": "7.43890000"
                    },
                    {
                        "id": 18408,
                        "name": "Rüschegg",
                        "latitude": "46.77977000",
                        "longitude": "7.39167000"
                    },
                    {
                        "id": 18415,
                        "name": "Saanen",
                        "latitude": "46.48945000",
                        "longitude": "7.26003000"
                    },
                    {
                        "id": 18425,
                        "name": "Saint-Imier",
                        "latitude": "47.15284000",
                        "longitude": "6.99692000"
                    },
                    {
                        "id": 18443,
                        "name": "Sankt Stephan",
                        "latitude": "46.50827000",
                        "longitude": "7.39559000"
                    },
                    {
                        "id": 18488,
                        "name": "Schüpfen",
                        "latitude": "47.03661000",
                        "longitude": "7.37723000"
                    },
                    {
                        "id": 18491,
                        "name": "Seeberg",
                        "latitude": "47.15585000",
                        "longitude": "7.66567000"
                    },
                    {
                        "id": 18493,
                        "name": "Seedorf",
                        "latitude": "47.03445000",
                        "longitude": "7.31249000"
                    },
                    {
                        "id": 18494,
                        "name": "Seeland District",
                        "latitude": "47.06635000",
                        "longitude": "7.26333000"
                    },
                    {
                        "id": 18502,
                        "name": "Seftigen",
                        "latitude": "46.78765000",
                        "longitude": "7.53937000"
                    },
                    {
                        "id": 18519,
                        "name": "Signau",
                        "latitude": "46.91944000",
                        "longitude": "7.72418000"
                    },
                    {
                        "id": 18520,
                        "name": "Sigriswil",
                        "latitude": "46.71656000",
                        "longitude": "7.71335000"
                    },
                    {
                        "id": 18533,
                        "name": "Spiez",
                        "latitude": "46.68473000",
                        "longitude": "7.69111000"
                    },
                    {
                        "id": 18550,
                        "name": "Steffisburg",
                        "latitude": "46.77807000",
                        "longitude": "7.63249000"
                    },
                    {
                        "id": 18558,
                        "name": "Stettlen",
                        "latitude": "46.95835000",
                        "longitude": "7.52508000"
                    },
                    {
                        "id": 18566,
                        "name": "Sumiswald",
                        "latitude": "47.02747000",
                        "longitude": "7.74526000"
                    },
                    {
                        "id": 18617,
                        "name": "Täuffelen",
                        "latitude": "47.06630000",
                        "longitude": "7.19883000"
                    },
                    {
                        "id": 18576,
                        "name": "Tavannes",
                        "latitude": "47.22079000",
                        "longitude": "7.19759000"
                    },
                    {
                        "id": 18590,
                        "name": "Thierachern",
                        "latitude": "46.75319000",
                        "longitude": "7.57442000"
                    },
                    {
                        "id": 18591,
                        "name": "Thun",
                        "latitude": "46.75118000",
                        "longitude": "7.62166000"
                    },
                    {
                        "id": 18592,
                        "name": "Thun District",
                        "latitude": "46.76290000",
                        "longitude": "7.62503000"
                    },
                    {
                        "id": 18597,
                        "name": "Toffen",
                        "latitude": "46.86031000",
                        "longitude": "7.49216000"
                    },
                    {
                        "id": 18598,
                        "name": "Trachselwald",
                        "latitude": "47.01699000",
                        "longitude": "7.73639000"
                    },
                    {
                        "id": 18599,
                        "name": "Tramelan",
                        "latitude": "47.22298000",
                        "longitude": "7.10287000"
                    },
                    {
                        "id": 18608,
                        "name": "Trub",
                        "latitude": "46.94168000",
                        "longitude": "7.87996000"
                    },
                    {
                        "id": 18609,
                        "name": "Trubschachen",
                        "latitude": "46.92228000",
                        "longitude": "7.84520000"
                    },
                    {
                        "id": 18626,
                        "name": "Uetendorf",
                        "latitude": "46.77392000",
                        "longitude": "7.57251000"
                    },
                    {
                        "id": 18635,
                        "name": "Unterseen",
                        "latitude": "46.68530000",
                        "longitude": "7.84722000"
                    },
                    {
                        "id": 18644,
                        "name": "Urtenen",
                        "latitude": "47.02667000",
                        "longitude": "7.50081000"
                    },
                    {
                        "id": 18651,
                        "name": "Uttigen",
                        "latitude": "46.79435000",
                        "longitude": "7.57789000"
                    },
                    {
                        "id": 18653,
                        "name": "Utzenstorf",
                        "latitude": "47.13248000",
                        "longitude": "7.55355000"
                    },
                    {
                        "id": 18663,
                        "name": "Vechigen",
                        "latitude": "46.94616000",
                        "longitude": "7.56065000"
                    },
                    {
                        "id": 18714,
                        "name": "Walkringen",
                        "latitude": "46.94856000",
                        "longitude": "7.62040000"
                    },
                    {
                        "id": 18723,
                        "name": "Wangen an der Aare",
                        "latitude": "47.23208000",
                        "longitude": "7.65253000"
                    },
                    {
                        "id": 18724,
                        "name": "Wattenwil",
                        "latitude": "46.76973000",
                        "longitude": "7.50835000"
                    },
                    {
                        "id": 18744,
                        "name": "Wichtrach",
                        "latitude": "46.85010000",
                        "longitude": "7.57748000"
                    },
                    {
                        "id": 18745,
                        "name": "Wiedlisbach",
                        "latitude": "47.25194000",
                        "longitude": "7.64610000"
                    },
                    {
                        "id": 18752,
                        "name": "Wilderswil",
                        "latitude": "46.66369000",
                        "longitude": "7.86175000"
                    },
                    {
                        "id": 18756,
                        "name": "Wimmis",
                        "latitude": "46.67587000",
                        "longitude": "7.63972000"
                    },
                    {
                        "id": 18762,
                        "name": "Wohlen",
                        "latitude": "46.97118000",
                        "longitude": "7.35685000"
                    },
                    {
                        "id": 18768,
                        "name": "Worb",
                        "latitude": "46.92984000",
                        "longitude": "7.56306000"
                    },
                    {
                        "id": 18769,
                        "name": "Worben",
                        "latitude": "47.10279000",
                        "longitude": "7.29518000"
                    },
                    {
                        "id": 18770,
                        "name": "Wynau",
                        "latitude": "47.25570000",
                        "longitude": "7.81626000"
                    },
                    {
                        "id": 18771,
                        "name": "Wynigen",
                        "latitude": "47.10586000",
                        "longitude": "7.66681000"
                    },
                    {
                        "id": 18772,
                        "name": "Wyssachen",
                        "latitude": "47.07851000",
                        "longitude": "7.82922000"
                    },
                    {
                        "id": 18808,
                        "name": "Zäziwil",
                        "latitude": "46.90196000",
                        "longitude": "7.66185000"
                    },
                    {
                        "id": 18798,
                        "name": "Zollikofen",
                        "latitude": "46.99905000",
                        "longitude": "7.45809000"
                    },
                    {
                        "id": 18806,
                        "name": "Zweisimmen",
                        "latitude": "46.55539000",
                        "longitude": "7.37302000"
                    }
                ]
            },
            {
                "id": 1640,
                "name": "Fribourg",
                "iso2": "FR",
                "latitude": "46.68167480",
                "longitude": "7.11726350",
                "type": "canton",
                "cities": [
                    {
                        "id": 17390,
                        "name": "Alterswil",
                        "latitude": "46.79587000",
                        "longitude": "7.25877000"
                    },
                    {
                        "id": 17415,
                        "name": "Attalens",
                        "latitude": "46.50555000",
                        "longitude": "6.85039000"
                    },
                    {
                        "id": 17426,
                        "name": "Avry-sur-Matran",
                        "latitude": "46.78753000",
                        "longitude": "7.06735000"
                    },
                    {
                        "id": 17440,
                        "name": "Bas-Vully",
                        "latitude": "46.96194000",
                        "longitude": "7.11251000"
                    },
                    {
                        "id": 17450,
                        "name": "Belfaux",
                        "latitude": "46.82171000",
                        "longitude": "7.10674000"
                    },
                    {
                        "id": 17596,
                        "name": "Bösingen",
                        "latitude": "46.89229000",
                        "longitude": "7.22770000"
                    },
                    {
                        "id": 17566,
                        "name": "Broc",
                        "latitude": "46.60513000",
                        "longitude": "7.09891000"
                    },
                    {
                        "id": 17568,
                        "name": "Broye District",
                        "latitude": "46.82212000",
                        "longitude": "6.90249000"
                    },
                    {
                        "id": 17581,
                        "name": "Bulle",
                        "latitude": "46.61797000",
                        "longitude": "7.05690000"
                    },
                    {
                        "id": 17627,
                        "name": "Charmey",
                        "latitude": "46.61957000",
                        "longitude": "7.16486000"
                    },
                    {
                        "id": 17641,
                        "name": "Châtel-Saint-Denis",
                        "latitude": "46.52691000",
                        "longitude": "6.90083000"
                    },
                    {
                        "id": 17654,
                        "name": "Corminboeuf",
                        "latitude": "46.81029000",
                        "longitude": "7.10535000"
                    },
                    {
                        "id": 17661,
                        "name": "Courgevaux",
                        "latitude": "46.90648000",
                        "longitude": "7.11215000"
                    },
                    {
                        "id": 17671,
                        "name": "Cugy",
                        "latitude": "46.81479000",
                        "longitude": "6.88888000"
                    },
                    {
                        "id": 17702,
                        "name": "Domdidier",
                        "latitude": "46.86716000",
                        "longitude": "7.01337000"
                    },
                    {
                        "id": 17714,
                        "name": "Düdingen",
                        "latitude": "46.84916000",
                        "longitude": "7.19150000"
                    },
                    {
                        "id": 17723,
                        "name": "Ecublens",
                        "latitude": "46.60735000",
                        "longitude": "6.80895000"
                    },
                    {
                        "id": 17757,
                        "name": "Ependes",
                        "latitude": "46.75368000",
                        "longitude": "7.14609000"
                    },
                    {
                        "id": 17774,
                        "name": "Estavayer-le-Lac",
                        "latitude": "46.84876000",
                        "longitude": "6.84650000"
                    },
                    {
                        "id": 17790,
                        "name": "Flamatt",
                        "latitude": "46.88994000",
                        "longitude": "7.32204000"
                    },
                    {
                        "id": 17809,
                        "name": "Fribourg",
                        "latitude": "46.80237000",
                        "longitude": "7.15128000"
                    },
                    {
                        "id": 17832,
                        "name": "Giffers",
                        "latitude": "46.76230000",
                        "longitude": "7.20845000"
                    },
                    {
                        "id": 17837,
                        "name": "Givisiez",
                        "latitude": "46.81201000",
                        "longitude": "7.12639000"
                    },
                    {
                        "id": 17845,
                        "name": "Glâne District",
                        "latitude": "46.66667000",
                        "longitude": "6.91667000"
                    },
                    {
                        "id": 17871,
                        "name": "Grolley",
                        "latitude": "46.83360000",
                        "longitude": "7.07116000"
                    },
                    {
                        "id": 17876,
                        "name": "Gruyère District",
                        "latitude": "46.60753000",
                        "longitude": "7.10741000"
                    },
                    {
                        "id": 17877,
                        "name": "Gruyères",
                        "latitude": "46.58338000",
                        "longitude": "7.08207000"
                    },
                    {
                        "id": 17904,
                        "name": "Heitenried",
                        "latitude": "46.82762000",
                        "longitude": "7.29944000"
                    },
                    {
                        "id": 17974,
                        "name": "Kerzers",
                        "latitude": "46.97586000",
                        "longitude": "7.19570000"
                    },
                    {
                        "id": 18025,
                        "name": "La Roche",
                        "latitude": "46.69620000",
                        "longitude": "7.13721000"
                    },
                    {
                        "id": 18028,
                        "name": "La Tour-de-Trême",
                        "latitude": "46.61061000",
                        "longitude": "7.06496000"
                    },
                    {
                        "id": 18031,
                        "name": "Lake District",
                        "latitude": "46.91016000",
                        "longitude": "7.14088000"
                    },
                    {
                        "id": 18122,
                        "name": "Marly",
                        "latitude": "46.77611000",
                        "longitude": "7.16459000"
                    },
                    {
                        "id": 18123,
                        "name": "Marsens",
                        "latitude": "46.65644000",
                        "longitude": "7.05948000"
                    },
                    {
                        "id": 18190,
                        "name": "Mézières",
                        "latitude": "46.67958000",
                        "longitude": "6.92630000"
                    },
                    {
                        "id": 18184,
                        "name": "Murten\/Morat",
                        "latitude": "46.92827000",
                        "longitude": "7.11715000"
                    },
                    {
                        "id": 18265,
                        "name": "Oberschrot",
                        "latitude": "46.74126000",
                        "longitude": "7.28149000"
                    },
                    {
                        "id": 18315,
                        "name": "Plaffeien",
                        "latitude": "46.74198000",
                        "longitude": "7.28666000"
                    },
                    {
                        "id": 18323,
                        "name": "Praroman",
                        "latitude": "46.75145000",
                        "longitude": "7.17778000"
                    },
                    {
                        "id": 18342,
                        "name": "Rechthalten",
                        "latitude": "46.76766000",
                        "longitude": "7.24028000"
                    },
                    {
                        "id": 18368,
                        "name": "Riaz",
                        "latitude": "46.64224000",
                        "longitude": "7.06183000"
                    },
                    {
                        "id": 18389,
                        "name": "Romont",
                        "latitude": "46.69652000",
                        "longitude": "6.91898000"
                    },
                    {
                        "id": 18398,
                        "name": "Rue",
                        "latitude": "46.61916000",
                        "longitude": "6.82225000"
                    },
                    {
                        "id": 18569,
                        "name": "Sâles",
                        "latitude": "46.63473000",
                        "longitude": "6.97336000"
                    },
                    {
                        "id": 18437,
                        "name": "Sankt Antoni",
                        "latitude": "46.82207000",
                        "longitude": "7.26091000"
                    },
                    {
                        "id": 18445,
                        "name": "Sarine District",
                        "latitude": "46.78435000",
                        "longitude": "7.09993000"
                    },
                    {
                        "id": 18473,
                        "name": "Schmitten",
                        "latitude": "46.85750000",
                        "longitude": "7.25031000"
                    },
                    {
                        "id": 18510,
                        "name": "Sense District",
                        "latitude": "46.80132000",
                        "longitude": "7.26028000"
                    },
                    {
                        "id": 18570,
                        "name": "Tafers",
                        "latitude": "46.81483000",
                        "longitude": "7.21852000"
                    },
                    {
                        "id": 18601,
                        "name": "Treyvaux",
                        "latitude": "46.72796000",
                        "longitude": "7.13769000"
                    },
                    {
                        "id": 18623,
                        "name": "Ueberstorf",
                        "latitude": "46.86587000",
                        "longitude": "7.30998000"
                    },
                    {
                        "id": 18674,
                        "name": "Veveyse District",
                        "latitude": "46.55083000",
                        "longitude": "6.91085000"
                    },
                    {
                        "id": 18679,
                        "name": "Villars-sur-Glâne",
                        "latitude": "46.79054000",
                        "longitude": "7.11717000"
                    },
                    {
                        "id": 18681,
                        "name": "Villaz-Saint-Pierre",
                        "latitude": "46.72074000",
                        "longitude": "6.95638000"
                    },
                    {
                        "id": 18695,
                        "name": "Vuadens",
                        "latitude": "46.61545000",
                        "longitude": "7.01732000"
                    }
                ]
            },
            {
                "id": 1647,
                "name": "Geneva",
                "iso2": "GE",
                "latitude": "46.21800730",
                "longitude": "6.12169250",
                "type": "canton",
                "cities": [
                    {
                        "id": 17383,
                        "name": "Aire-la-Ville",
                        "latitude": "46.19057000",
                        "longitude": "6.04287000"
                    },
                    {
                        "id": 17399,
                        "name": "Anières",
                        "latitude": "46.27673000",
                        "longitude": "6.22204000"
                    },
                    {
                        "id": 17451,
                        "name": "Bellevue",
                        "latitude": "46.25739000",
                        "longitude": "6.15475000"
                    },
                    {
                        "id": 17464,
                        "name": "Bernex",
                        "latitude": "46.17650000",
                        "longitude": "6.07544000"
                    },
                    {
                        "id": 17612,
                        "name": "Carouge",
                        "latitude": "46.18096000",
                        "longitude": "6.13921000"
                    },
                    {
                        "id": 17625,
                        "name": "Chancy",
                        "latitude": "46.15003000",
                        "longitude": "5.97153000"
                    },
                    {
                        "id": 17643,
                        "name": "Chêne-Bougeries",
                        "latitude": "46.19843000",
                        "longitude": "6.18642000"
                    },
                    {
                        "id": 17644,
                        "name": "Chêne-Bourg",
                        "latitude": "46.19534000",
                        "longitude": "6.19406000"
                    },
                    {
                        "id": 17649,
                        "name": "Confignon",
                        "latitude": "46.17341000",
                        "longitude": "6.08437000"
                    },
                    {
                        "id": 17656,
                        "name": "Corsier",
                        "latitude": "46.26297000",
                        "longitude": "6.22461000"
                    },
                    {
                        "id": 17676,
                        "name": "Dardagny",
                        "latitude": "46.19564000",
                        "longitude": "5.99497000"
                    },
                    {
                        "id": 17827,
                        "name": "Geneva",
                        "latitude": "46.20222000",
                        "longitude": "6.14569000"
                    },
                    {
                        "id": 17965,
                        "name": "Jussy",
                        "latitude": "46.23590000",
                        "longitude": "6.26701000"
                    },
                    {
                        "id": 18032,
                        "name": "Lancy",
                        "latitude": "46.18981000",
                        "longitude": "6.11441000"
                    },
                    {
                        "id": 18055,
                        "name": "Le Grand-Saconnex",
                        "latitude": "46.23188000",
                        "longitude": "6.12091000"
                    },
                    {
                        "id": 18068,
                        "name": "Les Avanchets",
                        "latitude": "46.22168000",
                        "longitude": "6.10814000"
                    },
                    {
                        "id": 18141,
                        "name": "Meinier",
                        "latitude": "46.24706000",
                        "longitude": "6.23423000"
                    },
                    {
                        "id": 18158,
                        "name": "Meyrin",
                        "latitude": "46.23424000",
                        "longitude": "6.08025000"
                    },
                    {
                        "id": 18284,
                        "name": "Onex",
                        "latitude": "46.18396000",
                        "longitude": "6.10237000"
                    },
                    {
                        "id": 18316,
                        "name": "Plan-les-Ouates",
                        "latitude": "46.16789000",
                        "longitude": "6.11664000"
                    },
                    {
                        "id": 18330,
                        "name": "Puplinge",
                        "latitude": "46.21043000",
                        "longitude": "6.23114000"
                    },
                    {
                        "id": 18448,
                        "name": "Satigny",
                        "latitude": "46.21462000",
                        "longitude": "6.03553000"
                    },
                    {
                        "id": 18595,
                        "name": "Thônex",
                        "latitude": "46.18815000",
                        "longitude": "6.19904000"
                    },
                    {
                        "id": 18606,
                        "name": "Troinex",
                        "latitude": "46.16313000",
                        "longitude": "6.14745000"
                    },
                    {
                        "id": 18661,
                        "name": "Vandœuvres",
                        "latitude": "46.22179000",
                        "longitude": "6.20285000"
                    },
                    {
                        "id": 18670,
                        "name": "Vernier",
                        "latitude": "46.21702000",
                        "longitude": "6.08497000"
                    },
                    {
                        "id": 18672,
                        "name": "Versoix",
                        "latitude": "46.28382000",
                        "longitude": "6.16214000"
                    },
                    {
                        "id": 18676,
                        "name": "Veyrier",
                        "latitude": "46.16699000",
                        "longitude": "6.18436000"
                    }
                ]
            },
            {
                "id": 1661,
                "name": "Glarus",
                "iso2": "GL",
                "latitude": "47.04112320",
                "longitude": "9.06790000",
                "type": "canton",
                "cities": [
                    {
                        "id": 17529,
                        "name": "Bilten",
                        "latitude": "47.14995000",
                        "longitude": "9.02551000"
                    },
                    {
                        "id": 17751,
                        "name": "Ennenda",
                        "latitude": "47.03363000",
                        "longitude": "9.07888000"
                    },
                    {
                        "id": 17839,
                        "name": "Glarus",
                        "latitude": "47.04057000",
                        "longitude": "9.06804000"
                    },
                    {
                        "id": 18086,
                        "name": "Linthal",
                        "latitude": "46.92127000",
                        "longitude": "8.99799000"
                    },
                    {
                        "id": 18097,
                        "name": "Luchsingen",
                        "latitude": "46.96640000",
                        "longitude": "9.03715000"
                    },
                    {
                        "id": 18162,
                        "name": "Mollis",
                        "latitude": "47.08878000",
                        "longitude": "9.07242000"
                    },
                    {
                        "id": 18235,
                        "name": "Näfels",
                        "latitude": "47.09775000",
                        "longitude": "9.06361000"
                    },
                    {
                        "id": 18211,
                        "name": "Netstal",
                        "latitude": "47.06337000",
                        "longitude": "9.05734000"
                    },
                    {
                        "id": 18229,
                        "name": "Niederurnen",
                        "latitude": "47.12598000",
                        "longitude": "9.05428000"
                    },
                    {
                        "id": 18268,
                        "name": "Oberurnen",
                        "latitude": "47.11412000",
                        "longitude": "9.05866000"
                    },
                    {
                        "id": 18475,
                        "name": "Schwanden",
                        "latitude": "46.99541000",
                        "longitude": "9.07010000"
                    }
                ]
            },
            {
                "id": 1660,
                "name": "Graubünden",
                "iso2": "GR",
                "latitude": "46.65698710",
                "longitude": "9.57802570",
                "type": "canton",
                "cities": [
                    {
                        "id": 17409,
                        "name": "Arosa",
                        "latitude": "46.77793000",
                        "longitude": "9.67621000"
                    },
                    {
                        "id": 17411,
                        "name": "Arvigo",
                        "latitude": "46.30211000",
                        "longitude": "9.11300000"
                    },
                    {
                        "id": 17547,
                        "name": "Bonaduz",
                        "latitude": "46.81103000",
                        "longitude": "9.39821000"
                    },
                    {
                        "id": 17559,
                        "name": "Breíl",
                        "latitude": "46.76986000",
                        "longitude": "9.06036000"
                    },
                    {
                        "id": 17571,
                        "name": "Brusio",
                        "latitude": "46.25953000",
                        "longitude": "10.12385000"
                    },
                    {
                        "id": 17585,
                        "name": "Buseno",
                        "latitude": "46.27381000",
                        "longitude": "9.10735000"
                    },
                    {
                        "id": 17615,
                        "name": "Cauco",
                        "latitude": "46.33541000",
                        "longitude": "9.12129000"
                    },
                    {
                        "id": 17617,
                        "name": "Cazis",
                        "latitude": "46.71940000",
                        "longitude": "9.43271000"
                    },
                    {
                        "id": 17618,
                        "name": "Celerina",
                        "latitude": "46.51217000",
                        "longitude": "9.85794000"
                    },
                    {
                        "id": 17638,
                        "name": "Chur",
                        "latitude": "46.84986000",
                        "longitude": "9.53287000"
                    },
                    {
                        "id": 17639,
                        "name": "Churwalden",
                        "latitude": "46.78143000",
                        "longitude": "9.54377000"
                    },
                    {
                        "id": 17677,
                        "name": "Davos",
                        "latitude": "46.80429000",
                        "longitude": "9.83723000"
                    },
                    {
                        "id": 17699,
                        "name": "Disentis",
                        "latitude": "46.70341000",
                        "longitude": "8.85090000"
                    },
                    {
                        "id": 17700,
                        "name": "Domat",
                        "latitude": "46.83483000",
                        "longitude": "9.45075000"
                    },
                    {
                        "id": 17783,
                        "name": "Felsberg",
                        "latitude": "46.84566000",
                        "longitude": "9.47588000"
                    },
                    {
                        "id": 17793,
                        "name": "Flims",
                        "latitude": "46.83705000",
                        "longitude": "9.28458000"
                    },
                    {
                        "id": 17882,
                        "name": "Grüsch",
                        "latitude": "46.97965000",
                        "longitude": "9.64639000"
                    },
                    {
                        "id": 17917,
                        "name": "Hinterrhein",
                        "latitude": "46.53333000",
                        "longitude": "9.20000000"
                    },
                    {
                        "id": 17947,
                        "name": "Igis",
                        "latitude": "46.94531000",
                        "longitude": "9.57218000"
                    },
                    {
                        "id": 17948,
                        "name": "Ilanz",
                        "latitude": "46.77413000",
                        "longitude": "9.20461000"
                    },
                    {
                        "id": 17958,
                        "name": "Jenaz",
                        "latitude": "46.92892000",
                        "longitude": "9.71275000"
                    },
                    {
                        "id": 17986,
                        "name": "Klosters Serneus",
                        "latitude": "46.88918000",
                        "longitude": "9.83826000"
                    },
                    {
                        "id": 18024,
                        "name": "La Punt Chamues-ch",
                        "latitude": "46.57887000",
                        "longitude": "9.92015000"
                    },
                    {
                        "id": 18029,
                        "name": "Laax",
                        "latitude": "46.80452000",
                        "longitude": "9.25787000"
                    },
                    {
                        "id": 18033,
                        "name": "Landquart",
                        "latitude": "46.95000000",
                        "longitude": "9.56667000"
                    },
                    {
                        "id": 18067,
                        "name": "Lenzerheide",
                        "latitude": "46.72215000",
                        "longitude": "9.55905000"
                    },
                    {
                        "id": 18105,
                        "name": "Luzein",
                        "latitude": "46.91957000",
                        "longitude": "9.76080000"
                    },
                    {
                        "id": 18116,
                        "name": "Maienfeld",
                        "latitude": "47.00472000",
                        "longitude": "9.53115000"
                    },
                    {
                        "id": 18117,
                        "name": "Malans",
                        "latitude": "46.98096000",
                        "longitude": "9.57527000"
                    },
                    {
                        "id": 18155,
                        "name": "Mesocco",
                        "latitude": "46.39390000",
                        "longitude": "9.23333000"
                    },
                    {
                        "id": 18318,
                        "name": "Pontresina",
                        "latitude": "46.49550000",
                        "longitude": "9.90126000"
                    },
                    {
                        "id": 18321,
                        "name": "Poschiavo",
                        "latitude": "46.32441000",
                        "longitude": "10.05823000"
                    },
                    {
                        "id": 18348,
                        "name": "Region Albula",
                        "latitude": "46.60255000",
                        "longitude": "9.65150000"
                    },
                    {
                        "id": 18349,
                        "name": "Region Bernina",
                        "latitude": "46.33488000",
                        "longitude": "10.07349000"
                    },
                    {
                        "id": 18350,
                        "name": "Region Engiadina Bassa \/ Val Müstair",
                        "latitude": "46.75212000",
                        "longitude": "10.26032000"
                    },
                    {
                        "id": 18351,
                        "name": "Region Imboden",
                        "latitude": "46.84876000",
                        "longitude": "9.36225000"
                    },
                    {
                        "id": 18352,
                        "name": "Region Landquart",
                        "latitude": "46.96403000",
                        "longitude": "9.56365000"
                    },
                    {
                        "id": 18353,
                        "name": "Region Maloja",
                        "latitude": "46.47448000",
                        "longitude": "9.83138000"
                    },
                    {
                        "id": 18354,
                        "name": "Region Moesa",
                        "latitude": "46.35200000",
                        "longitude": "9.17870000"
                    },
                    {
                        "id": 18355,
                        "name": "Region Plessur",
                        "latitude": "46.81819000",
                        "longitude": "9.62542000"
                    },
                    {
                        "id": 18356,
                        "name": "Region Prättigau \/ Davos",
                        "latitude": "46.86727000",
                        "longitude": "9.82014000"
                    },
                    {
                        "id": 18357,
                        "name": "Region Surselva",
                        "latitude": "46.69564000",
                        "longitude": "9.04834000"
                    },
                    {
                        "id": 18358,
                        "name": "Region Viamala",
                        "latitude": "46.58762000",
                        "longitude": "9.40035000"
                    },
                    {
                        "id": 18367,
                        "name": "Rhäzüns",
                        "latitude": "46.79891000",
                        "longitude": "9.39764000"
                    },
                    {
                        "id": 18435,
                        "name": "Samedan",
                        "latitude": "46.53399000",
                        "longitude": "9.87276000"
                    },
                    {
                        "id": 18457,
                        "name": "Scharans",
                        "latitude": "46.71814000",
                        "longitude": "9.45903000"
                    },
                    {
                        "id": 18460,
                        "name": "Schiers",
                        "latitude": "46.96973000",
                        "longitude": "9.68720000"
                    },
                    {
                        "id": 18490,
                        "name": "Scuol",
                        "latitude": "46.79671000",
                        "longitude": "10.29804000"
                    },
                    {
                        "id": 18522,
                        "name": "Silvaplana",
                        "latitude": "46.45810000",
                        "longitude": "9.79514000"
                    },
                    {
                        "id": 18535,
                        "name": "St. Moritz",
                        "latitude": "46.49937000",
                        "longitude": "9.84327000"
                    },
                    {
                        "id": 18572,
                        "name": "Tamins",
                        "latitude": "46.82964000",
                        "longitude": "9.40648000"
                    },
                    {
                        "id": 18594,
                        "name": "Thusis",
                        "latitude": "46.69724000",
                        "longitude": "9.43938000"
                    },
                    {
                        "id": 18596,
                        "name": "Tiefencastel",
                        "latitude": "46.66014000",
                        "longitude": "9.57883000"
                    },
                    {
                        "id": 18604,
                        "name": "Trimmis",
                        "latitude": "46.90075000",
                        "longitude": "9.56120000"
                    },
                    {
                        "id": 18610,
                        "name": "Trun",
                        "latitude": "46.74292000",
                        "longitude": "8.98716000"
                    },
                    {
                        "id": 18637,
                        "name": "Untervaz",
                        "latitude": "46.92750000",
                        "longitude": "9.53422000"
                    },
                    {
                        "id": 18660,
                        "name": "Vals Platz",
                        "latitude": "46.61647000",
                        "longitude": "9.18025000"
                    },
                    {
                        "id": 18794,
                        "name": "Zernez",
                        "latitude": "46.69862000",
                        "longitude": "10.09268000"
                    },
                    {
                        "id": 18795,
                        "name": "Zizers",
                        "latitude": "46.93575000",
                        "longitude": "9.56491000"
                    },
                    {
                        "id": 18804,
                        "name": "Zuoz",
                        "latitude": "46.60206000",
                        "longitude": "9.95965000"
                    }
                ]
            },
            {
                "id": 1658,
                "name": "Jura",
                "iso2": "JU",
                "latitude": "47.34444740",
                "longitude": "7.14306080",
                "type": "canton",
                "cities": [
                    {
                        "id": 17385,
                        "name": "Alle",
                        "latitude": "47.42542000",
                        "longitude": "7.13018000"
                    },
                    {
                        "id": 17442,
                        "name": "Bassecourt",
                        "latitude": "47.33808000",
                        "longitude": "7.24373000"
                    },
                    {
                        "id": 17548,
                        "name": "Boncourt",
                        "latitude": "47.49493000",
                        "longitude": "7.01297000"
                    },
                    {
                        "id": 17659,
                        "name": "Courfaivre",
                        "latitude": "47.33461000",
                        "longitude": "7.28186000"
                    },
                    {
                        "id": 17660,
                        "name": "Courgenay",
                        "latitude": "47.40483000",
                        "longitude": "7.12522000"
                    },
                    {
                        "id": 17662,
                        "name": "Courrendlin",
                        "latitude": "47.33853000",
                        "longitude": "7.37243000"
                    },
                    {
                        "id": 17663,
                        "name": "Courroux",
                        "latitude": "47.36069000",
                        "longitude": "7.37371000"
                    },
                    {
                        "id": 17666,
                        "name": "Courtételle",
                        "latitude": "47.34074000",
                        "longitude": "7.31827000"
                    },
                    {
                        "id": 17680,
                        "name": "Delémont",
                        "latitude": "47.36493000",
                        "longitude": "7.34453000"
                    },
                    {
                        "id": 17681,
                        "name": "Delémont District",
                        "latitude": "47.35434000",
                        "longitude": "7.33053000"
                    },
                    {
                        "id": 17799,
                        "name": "Fontenais",
                        "latitude": "47.40292000",
                        "longitude": "7.08108000"
                    },
                    {
                        "id": 17801,
                        "name": "Franches-Montagnes District",
                        "latitude": "47.24935000",
                        "longitude": "7.04562000"
                    },
                    {
                        "id": 17844,
                        "name": "Glovelier",
                        "latitude": "47.33534000",
                        "longitude": "7.20556000"
                    },
                    {
                        "id": 18060,
                        "name": "Le Noirmont",
                        "latitude": "47.22464000",
                        "longitude": "6.95784000"
                    },
                    {
                        "id": 18069,
                        "name": "Les Bois",
                        "latitude": "47.17715000",
                        "longitude": "6.90498000"
                    },
                    {
                        "id": 18071,
                        "name": "Les Breuleux",
                        "latitude": "47.21099000",
                        "longitude": "7.00792000"
                    },
                    {
                        "id": 18319,
                        "name": "Porrentruy",
                        "latitude": "47.41728000",
                        "longitude": "7.07573000"
                    },
                    {
                        "id": 18320,
                        "name": "Porrentruy District",
                        "latitude": "47.41475000",
                        "longitude": "7.07638000"
                    },
                    {
                        "id": 18420,
                        "name": "Saignelégier",
                        "latitude": "47.25619000",
                        "longitude": "6.99648000"
                    },
                    {
                        "id": 18677,
                        "name": "Vicques",
                        "latitude": "47.35000000",
                        "longitude": "7.41342000"
                    }
                ]
            },
            {
                "id": 1663,
                "name": "Lucerne",
                "iso2": "LU",
                "latitude": "47.07956710",
                "longitude": "8.16624450",
                "type": "canton",
                "cities": [
                    {
                        "id": 17363,
                        "name": "Adligenswil",
                        "latitude": "47.06521000",
                        "longitude": "8.36124000"
                    },
                    {
                        "id": 17391,
                        "name": "Altishofen",
                        "latitude": "47.19916000",
                        "longitude": "7.96964000"
                    },
                    {
                        "id": 17437,
                        "name": "Ballwil",
                        "latitude": "47.15371000",
                        "longitude": "8.32233000"
                    },
                    {
                        "id": 17466,
                        "name": "Beromünster",
                        "latitude": "47.20612000",
                        "longitude": "8.19265000"
                    },
                    {
                        "id": 17578,
                        "name": "Buchrain",
                        "latitude": "47.09625000",
                        "longitude": "8.34729000"
                    },
                    {
                        "id": 17604,
                        "name": "Büron",
                        "latitude": "47.21192000",
                        "longitude": "8.09420000"
                    },
                    {
                        "id": 17587,
                        "name": "Buttisholz",
                        "latitude": "47.11442000",
                        "longitude": "8.09425000"
                    },
                    {
                        "id": 17674,
                        "name": "Dagmersellen",
                        "latitude": "47.21405000",
                        "longitude": "7.98519000"
                    },
                    {
                        "id": 17718,
                        "name": "Ebikon",
                        "latitude": "47.07937000",
                        "longitude": "8.34041000"
                    },
                    {
                        "id": 17735,
                        "name": "Eich",
                        "latitude": "47.15116000",
                        "longitude": "8.16695000"
                    },
                    {
                        "id": 17746,
                        "name": "Emmen",
                        "latitude": "47.07819000",
                        "longitude": "8.27331000"
                    },
                    {
                        "id": 17753,
                        "name": "Entlebuch",
                        "latitude": "46.99559000",
                        "longitude": "8.06354000"
                    },
                    {
                        "id": 17754,
                        "name": "Entlebuch District",
                        "latitude": "46.92590000",
                        "longitude": "8.01427000"
                    },
                    {
                        "id": 17772,
                        "name": "Escholzmatt",
                        "latitude": "46.91350000",
                        "longitude": "7.93426000"
                    },
                    {
                        "id": 17776,
                        "name": "Ettiswil",
                        "latitude": "47.15031000",
                        "longitude": "8.01759000"
                    },
                    {
                        "id": 17797,
                        "name": "Flühli",
                        "latitude": "46.88391000",
                        "longitude": "8.01558000"
                    },
                    {
                        "id": 17831,
                        "name": "Geuensee",
                        "latitude": "47.19970000",
                        "longitude": "8.10689000"
                    },
                    {
                        "id": 17875,
                        "name": "Grosswangen",
                        "latitude": "47.13310000",
                        "longitude": "8.05041000"
                    },
                    {
                        "id": 17887,
                        "name": "Gunzwil",
                        "latitude": "47.21072000",
                        "longitude": "8.17932000"
                    },
                    {
                        "id": 17893,
                        "name": "Hasle",
                        "latitude": "46.97787000",
                        "longitude": "8.05326000"
                    },
                    {
                        "id": 17912,
                        "name": "Hildisrieden",
                        "latitude": "47.15068000",
                        "longitude": "8.22582000"
                    },
                    {
                        "id": 17920,
                        "name": "Hitzkirch",
                        "latitude": "47.22403000",
                        "longitude": "8.26425000"
                    },
                    {
                        "id": 17921,
                        "name": "Hochdorf",
                        "latitude": "47.16841000",
                        "longitude": "8.29179000"
                    },
                    {
                        "id": 17922,
                        "name": "Hochdorf District",
                        "latitude": "47.17062000",
                        "longitude": "8.28702000"
                    },
                    {
                        "id": 17926,
                        "name": "Hohenrain",
                        "latitude": "47.18083000",
                        "longitude": "8.31802000"
                    },
                    {
                        "id": 17935,
                        "name": "Horw",
                        "latitude": "47.01692000",
                        "longitude": "8.30956000"
                    },
                    {
                        "id": 17955,
                        "name": "Inwil",
                        "latitude": "47.12530000",
                        "longitude": "8.34885000"
                    },
                    {
                        "id": 17998,
                        "name": "Knutwil",
                        "latitude": "47.19953000",
                        "longitude": "8.07315000"
                    },
                    {
                        "id": 18008,
                        "name": "Kriens",
                        "latitude": "47.03110000",
                        "longitude": "8.28547000"
                    },
                    {
                        "id": 18087,
                        "name": "Littau",
                        "latitude": "47.05000000",
                        "longitude": "8.26274000"
                    },
                    {
                        "id": 18095,
                        "name": "Lucerne-Land District",
                        "latitude": "47.04046000",
                        "longitude": "8.29271000"
                    },
                    {
                        "id": 18096,
                        "name": "Lucerne-Stadt District",
                        "latitude": "47.05334000",
                        "longitude": "8.31063000"
                    },
                    {
                        "id": 18103,
                        "name": "Luthern",
                        "latitude": "47.05753000",
                        "longitude": "7.91692000"
                    },
                    {
                        "id": 18106,
                        "name": "Luzern",
                        "latitude": "47.05048000",
                        "longitude": "8.30635000"
                    },
                    {
                        "id": 18119,
                        "name": "Malters",
                        "latitude": "47.03628000",
                        "longitude": "8.18193000"
                    },
                    {
                        "id": 18136,
                        "name": "Mauensee",
                        "latitude": "47.16703000",
                        "longitude": "8.06793000"
                    },
                    {
                        "id": 18138,
                        "name": "Meggen",
                        "latitude": "47.04691000",
                        "longitude": "8.37467000"
                    },
                    {
                        "id": 18139,
                        "name": "Meierskappel",
                        "latitude": "47.12470000",
                        "longitude": "8.44274000"
                    },
                    {
                        "id": 18153,
                        "name": "Menznau",
                        "latitude": "47.08364000",
                        "longitude": "8.03971000"
                    },
                    {
                        "id": 18208,
                        "name": "Nebikon",
                        "latitude": "47.19185000",
                        "longitude": "7.97769000"
                    },
                    {
                        "id": 18214,
                        "name": "Neudorf",
                        "latitude": "47.17699000",
                        "longitude": "8.20911000"
                    },
                    {
                        "id": 18216,
                        "name": "Neuenkirch",
                        "latitude": "47.09989000",
                        "longitude": "8.20416000"
                    },
                    {
                        "id": 18230,
                        "name": "Nottwil",
                        "latitude": "47.13469000",
                        "longitude": "8.13774000"
                    },
                    {
                        "id": 18256,
                        "name": "Oberkirch",
                        "latitude": "47.15642000",
                        "longitude": "8.11567000"
                    },
                    {
                        "id": 18306,
                        "name": "Pfaffnau",
                        "latitude": "47.22772000",
                        "longitude": "7.89719000"
                    },
                    {
                        "id": 18361,
                        "name": "Reiden",
                        "latitude": "47.24719000",
                        "longitude": "7.97135000"
                    },
                    {
                        "id": 18402,
                        "name": "Römerswil",
                        "latitude": "47.16881000",
                        "longitude": "8.24528000"
                    },
                    {
                        "id": 18390,
                        "name": "Root",
                        "latitude": "47.11458000",
                        "longitude": "8.39021000"
                    },
                    {
                        "id": 18401,
                        "name": "Ruswil",
                        "latitude": "47.08425000",
                        "longitude": "8.12645000"
                    },
                    {
                        "id": 18459,
                        "name": "Schenkon",
                        "latitude": "47.17765000",
                        "longitude": "8.13204000"
                    },
                    {
                        "id": 18486,
                        "name": "Schötz",
                        "latitude": "47.16896000",
                        "longitude": "7.98870000"
                    },
                    {
                        "id": 18489,
                        "name": "Schüpfheim",
                        "latitude": "46.95161000",
                        "longitude": "8.01723000"
                    },
                    {
                        "id": 18476,
                        "name": "Schwarzenberg",
                        "latitude": "47.01705000",
                        "longitude": "8.17261000"
                    },
                    {
                        "id": 18508,
                        "name": "Sempach",
                        "latitude": "47.13577000",
                        "longitude": "8.19149000"
                    },
                    {
                        "id": 18567,
                        "name": "Sursee",
                        "latitude": "47.17088000",
                        "longitude": "8.11113000"
                    },
                    {
                        "id": 18568,
                        "name": "Sursee District",
                        "latitude": "47.15591000",
                        "longitude": "8.13704000"
                    },
                    {
                        "id": 18602,
                        "name": "Triengen",
                        "latitude": "47.23573000",
                        "longitude": "8.07652000"
                    },
                    {
                        "id": 18622,
                        "name": "Udligenswil",
                        "latitude": "47.09005000",
                        "longitude": "8.40335000"
                    },
                    {
                        "id": 18690,
                        "name": "Vitznau",
                        "latitude": "47.01014000",
                        "longitude": "8.48420000"
                    },
                    {
                        "id": 18726,
                        "name": "Wauwil",
                        "latitude": "47.18457000",
                        "longitude": "8.02100000"
                    },
                    {
                        "id": 18729,
                        "name": "Weggis",
                        "latitude": "47.03208000",
                        "longitude": "8.43219000"
                    },
                    {
                        "id": 18735,
                        "name": "Werthenstein",
                        "latitude": "47.05578000",
                        "longitude": "8.10182000"
                    },
                    {
                        "id": 18748,
                        "name": "Wikon",
                        "latitude": "47.26339000",
                        "longitude": "7.96801000"
                    },
                    {
                        "id": 18754,
                        "name": "Willisau",
                        "latitude": "47.12183000",
                        "longitude": "7.99418000"
                    },
                    {
                        "id": 18755,
                        "name": "Willisau District",
                        "latitude": "47.14097000",
                        "longitude": "7.95933000"
                    },
                    {
                        "id": 18766,
                        "name": "Wolhusen",
                        "latitude": "47.05983000",
                        "longitude": "8.07389000"
                    },
                    {
                        "id": 18792,
                        "name": "Zell",
                        "latitude": "47.13673000",
                        "longitude": "7.92495000"
                    }
                ]
            },
            {
                "id": 1659,
                "name": "Neuchâtel",
                "iso2": "NE",
                "latitude": "46.98998740",
                "longitude": "6.92927320",
                "type": "canton",
                "cities": [
                    {
                        "id": 17423,
                        "name": "Auvernier",
                        "latitude": "46.97545000",
                        "longitude": "6.87903000"
                    },
                    {
                        "id": 17469,
                        "name": "Bevaix",
                        "latitude": "46.92958000",
                        "longitude": "6.81470000"
                    },
                    {
                        "id": 17554,
                        "name": "Boudry",
                        "latitude": "46.94991000",
                        "longitude": "6.83757000"
                    },
                    {
                        "id": 17555,
                        "name": "Boudry District",
                        "latitude": "46.94594000",
                        "longitude": "6.82842000"
                    },
                    {
                        "id": 17619,
                        "name": "Cernier",
                        "latitude": "47.05878000",
                        "longitude": "6.90040000"
                    },
                    {
                        "id": 17642,
                        "name": "Chézard-Saint-Martin",
                        "latitude": "47.06629000",
                        "longitude": "6.93332000"
                    },
                    {
                        "id": 17655,
                        "name": "Cornaux",
                        "latitude": "47.03960000",
                        "longitude": "7.01872000"
                    },
                    {
                        "id": 17657,
                        "name": "Cortaillod",
                        "latitude": "46.94306000",
                        "longitude": "6.84440000"
                    },
                    {
                        "id": 17667,
                        "name": "Couvet",
                        "latitude": "46.92525000",
                        "longitude": "6.63270000"
                    },
                    {
                        "id": 17701,
                        "name": "Dombresson",
                        "latitude": "47.07192000",
                        "longitude": "6.95920000"
                    },
                    {
                        "id": 17792,
                        "name": "Fleurier",
                        "latitude": "46.90224000",
                        "longitude": "6.58253000"
                    },
                    {
                        "id": 17798,
                        "name": "Fontainemelon",
                        "latitude": "47.05495000",
                        "longitude": "6.88680000"
                    },
                    {
                        "id": 17855,
                        "name": "Gorgier",
                        "latitude": "46.90143000",
                        "longitude": "6.77985000"
                    },
                    {
                        "id": 17861,
                        "name": "Grand-Savagnier",
                        "latitude": "47.05101000",
                        "longitude": "6.95489000"
                    },
                    {
                        "id": 18021,
                        "name": "La Chaux-de-Fonds",
                        "latitude": "47.09993000",
                        "longitude": "6.82586000"
                    },
                    {
                        "id": 18022,
                        "name": "La Chaux-de-Fonds District",
                        "latitude": "47.12159000",
                        "longitude": "6.84064000"
                    },
                    {
                        "id": 18056,
                        "name": "Le Landeron",
                        "latitude": "47.05702000",
                        "longitude": "7.07052000"
                    },
                    {
                        "id": 18057,
                        "name": "Le Locle",
                        "latitude": "47.05619000",
                        "longitude": "6.74913000"
                    },
                    {
                        "id": 18058,
                        "name": "Le Locle District",
                        "latitude": "47.01927000",
                        "longitude": "6.69635000"
                    },
                    {
                        "id": 18070,
                        "name": "Les Brenets",
                        "latitude": "47.06774000",
                        "longitude": "6.70478000"
                    },
                    {
                        "id": 18072,
                        "name": "Les Geneveys-sur-Coffrane",
                        "latitude": "47.01528000",
                        "longitude": "6.85130000"
                    },
                    {
                        "id": 18073,
                        "name": "Les Ponts-de-Martel",
                        "latitude": "46.99735000",
                        "longitude": "6.73059000"
                    },
                    {
                        "id": 18121,
                        "name": "Marin-Epagnier",
                        "latitude": "47.01017000",
                        "longitude": "6.99941000"
                    },
                    {
                        "id": 18212,
                        "name": "Neuchâtel",
                        "latitude": "46.99179000",
                        "longitude": "6.93100000"
                    },
                    {
                        "id": 18213,
                        "name": "Neuchâtel District",
                        "latitude": "47.01799000",
                        "longitude": "6.99337000"
                    },
                    {
                        "id": 18304,
                        "name": "Peseux",
                        "latitude": "46.98704000",
                        "longitude": "6.88903000"
                    },
                    {
                        "id": 18422,
                        "name": "Saint-Aubin-Sauges",
                        "latitude": "46.89419000",
                        "longitude": "6.77251000"
                    },
                    {
                        "id": 18423,
                        "name": "Saint-Blaise",
                        "latitude": "47.01511000",
                        "longitude": "6.98832000"
                    },
                    {
                        "id": 18600,
                        "name": "Travers",
                        "latitude": "46.94018000",
                        "longitude": "6.67595000"
                    },
                    {
                        "id": 18656,
                        "name": "Val-de-Ruz District",
                        "latitude": "47.04008000",
                        "longitude": "6.90829000"
                    },
                    {
                        "id": 18657,
                        "name": "Val-de-Travers District",
                        "latitude": "46.90357000",
                        "longitude": "6.56310000"
                    }
                ]
            },
            {
                "id": 1652,
                "name": "Nidwalden",
                "iso2": "NW",
                "latitude": "46.92670160",
                "longitude": "8.38499820",
                "type": "canton",
                "cities": [
                    {
                        "id": 17448,
                        "name": "Beckenried",
                        "latitude": "46.96653000",
                        "longitude": "8.47575000"
                    },
                    {
                        "id": 17582,
                        "name": "Buochs",
                        "latitude": "46.97398000",
                        "longitude": "8.42279000"
                    },
                    {
                        "id": 17675,
                        "name": "Dallenwil",
                        "latitude": "46.92420000",
                        "longitude": "8.38785000"
                    },
                    {
                        "id": 17748,
                        "name": "Emmetten",
                        "latitude": "46.95658000",
                        "longitude": "8.51467000"
                    },
                    {
                        "id": 17752,
                        "name": "Ennetbürgen",
                        "latitude": "46.98423000",
                        "longitude": "8.41003000"
                    },
                    {
                        "id": 17906,
                        "name": "Hergiswil",
                        "latitude": "46.98429000",
                        "longitude": "8.30944000"
                    },
                    {
                        "id": 18546,
                        "name": "Stans",
                        "latitude": "46.95805000",
                        "longitude": "8.36609000"
                    },
                    {
                        "id": 18547,
                        "name": "Stansstad",
                        "latitude": "46.97680000",
                        "longitude": "8.33553000"
                    },
                    {
                        "id": 18763,
                        "name": "Wolfenschiessen",
                        "latitude": "46.90322000",
                        "longitude": "8.39423000"
                    }
                ]
            },
            {
                "id": 1650,
                "name": "Obwalden",
                "iso2": "OW",
                "latitude": "46.87785800",
                "longitude": "8.25124900",
                "type": "canton",
                "cities": [
                    {
                        "id": 17387,
                        "name": "Alpnach",
                        "latitude": "46.94227000",
                        "longitude": "8.27180000"
                    },
                    {
                        "id": 17750,
                        "name": "Engelberg",
                        "latitude": "46.82107000",
                        "longitude": "8.40133000"
                    },
                    {
                        "id": 17835,
                        "name": "Giswil",
                        "latitude": "46.83333000",
                        "longitude": "8.18065000"
                    },
                    {
                        "id": 17973,
                        "name": "Kerns",
                        "latitude": "46.90121000",
                        "longitude": "8.27514000"
                    },
                    {
                        "id": 18101,
                        "name": "Lungern",
                        "latitude": "46.78578000",
                        "longitude": "8.15984000"
                    },
                    {
                        "id": 18418,
                        "name": "Sachseln",
                        "latitude": "46.86718000",
                        "longitude": "8.23344000"
                    },
                    {
                        "id": 18447,
                        "name": "Sarnen",
                        "latitude": "46.89611000",
                        "longitude": "8.24531000"
                    }
                ]
            },
            {
                "id": 1654,
                "name": "Schaffhausen",
                "iso2": "SH",
                "latitude": "47.70093640",
                "longitude": "8.56800400",
                "type": "canton",
                "cities": [
                    {
                        "id": 17461,
                        "name": "Beringen",
                        "latitude": "47.69763000",
                        "longitude": "8.57431000"
                    },
                    {
                        "id": 17502,
                        "name": "Bezirk Oberklettgau",
                        "latitude": "47.69893000",
                        "longitude": "8.51774000"
                    },
                    {
                        "id": 17505,
                        "name": "Bezirk Reiat",
                        "latitude": "47.74752000",
                        "longitude": "8.70821000"
                    },
                    {
                        "id": 17507,
                        "name": "Bezirk Schaffhausen",
                        "latitude": "47.69440000",
                        "longitude": "8.63525000"
                    },
                    {
                        "id": 17508,
                        "name": "Bezirk Schleitheim",
                        "latitude": "47.75000000",
                        "longitude": "8.51111000"
                    },
                    {
                        "id": 17512,
                        "name": "Bezirk Stein",
                        "latitude": "47.66429000",
                        "longitude": "8.84683000"
                    },
                    {
                        "id": 17515,
                        "name": "Bezirk Unterklettgau",
                        "latitude": "47.68000000",
                        "longitude": "8.46333000"
                    },
                    {
                        "id": 17892,
                        "name": "Hallau",
                        "latitude": "47.69648000",
                        "longitude": "8.45827000"
                    },
                    {
                        "id": 18110,
                        "name": "Löhningen",
                        "latitude": "47.70121000",
                        "longitude": "8.55236000"
                    },
                    {
                        "id": 18217,
                        "name": "Neuhausen",
                        "latitude": "47.68579000",
                        "longitude": "8.61474000"
                    },
                    {
                        "id": 18218,
                        "name": "Neunkirch",
                        "latitude": "47.69012000",
                        "longitude": "8.49981000"
                    },
                    {
                        "id": 18336,
                        "name": "Ramsen",
                        "latitude": "47.70797000",
                        "longitude": "8.80949000"
                    },
                    {
                        "id": 18455,
                        "name": "Schaffhausen",
                        "latitude": "47.69732000",
                        "longitude": "8.63493000"
                    },
                    {
                        "id": 18464,
                        "name": "Schleitheim",
                        "latitude": "47.74818000",
                        "longitude": "8.48213000"
                    },
                    {
                        "id": 18552,
                        "name": "Stein am Rhein",
                        "latitude": "47.65933000",
                        "longitude": "8.85964000"
                    },
                    {
                        "id": 18556,
                        "name": "Stetten",
                        "latitude": "47.74025000",
                        "longitude": "8.66298000"
                    },
                    {
                        "id": 18588,
                        "name": "Thayngen",
                        "latitude": "47.74717000",
                        "longitude": "8.70724000"
                    },
                    {
                        "id": 18751,
                        "name": "Wilchingen",
                        "latitude": "47.66745000",
                        "longitude": "8.46774000"
                    }
                ]
            },
            {
                "id": 1653,
                "name": "Schwyz",
                "iso2": "SZ",
                "latitude": "47.02071380",
                "longitude": "8.65298840",
                "type": "canton",
                "cities": [
                    {
                        "id": 17389,
                        "name": "Altendorf",
                        "latitude": "47.18994000",
                        "longitude": "8.83823000"
                    },
                    {
                        "id": 17410,
                        "name": "Arth",
                        "latitude": "47.06337000",
                        "longitude": "8.52349000"
                    },
                    {
                        "id": 17590,
                        "name": "Bäch",
                        "latitude": "47.20388000",
                        "longitude": "8.73224000"
                    },
                    {
                        "id": 17483,
                        "name": "Bezirk Einsiedeln",
                        "latitude": "47.10792000",
                        "longitude": "8.76010000"
                    },
                    {
                        "id": 17484,
                        "name": "Bezirk Gersau",
                        "latitude": "47.00800000",
                        "longitude": "8.51678000"
                    },
                    {
                        "id": 17490,
                        "name": "Bezirk Höfe",
                        "latitude": "47.19043000",
                        "longitude": "8.73960000"
                    },
                    {
                        "id": 17492,
                        "name": "Bezirk Küssnacht",
                        "latitude": "47.08611000",
                        "longitude": "8.44444000"
                    },
                    {
                        "id": 17498,
                        "name": "Bezirk March",
                        "latitude": "47.16128000",
                        "longitude": "8.91103000"
                    },
                    {
                        "id": 17509,
                        "name": "Bezirk Schwyz",
                        "latitude": "47.02814000",
                        "longitude": "8.63619000"
                    },
                    {
                        "id": 17738,
                        "name": "Einsiedeln",
                        "latitude": "47.12849000",
                        "longitude": "8.74735000"
                    },
                    {
                        "id": 17787,
                        "name": "Feusisberg",
                        "latitude": "47.18707000",
                        "longitude": "8.74724000"
                    },
                    {
                        "id": 17806,
                        "name": "Freienbach",
                        "latitude": "47.20534000",
                        "longitude": "8.75842000"
                    },
                    {
                        "id": 17830,
                        "name": "Gersau",
                        "latitude": "46.99419000",
                        "longitude": "8.52500000"
                    },
                    {
                        "id": 17848,
                        "name": "Goldau",
                        "latitude": "47.04761000",
                        "longitude": "8.54616000"
                    },
                    {
                        "id": 17946,
                        "name": "Ibach",
                        "latitude": "47.01105000",
                        "longitude": "8.64538000"
                    },
                    {
                        "id": 17951,
                        "name": "Ingenbohl",
                        "latitude": "46.99880000",
                        "longitude": "8.61529000"
                    },
                    {
                        "id": 18019,
                        "name": "Küssnacht",
                        "latitude": "47.08557000",
                        "longitude": "8.44206000"
                    },
                    {
                        "id": 18030,
                        "name": "Lachen",
                        "latitude": "47.19224000",
                        "longitude": "8.85324000"
                    },
                    {
                        "id": 18179,
                        "name": "Muotathal",
                        "latitude": "46.97676000",
                        "longitude": "8.76499000"
                    },
                    {
                        "id": 18310,
                        "name": "Pfäffikon",
                        "latitude": "47.20109000",
                        "longitude": "8.77816000"
                    },
                    {
                        "id": 18360,
                        "name": "Reichenburg",
                        "latitude": "47.17097000",
                        "longitude": "8.97704000"
                    },
                    {
                        "id": 18393,
                        "name": "Rothenthurm",
                        "latitude": "47.10420000",
                        "longitude": "8.67585000"
                    },
                    {
                        "id": 18449,
                        "name": "Sattel",
                        "latitude": "47.08246000",
                        "longitude": "8.63565000"
                    },
                    {
                        "id": 18461,
                        "name": "Schindellegi",
                        "latitude": "47.17460000",
                        "longitude": "8.71345000"
                    },
                    {
                        "id": 18487,
                        "name": "Schübelbach",
                        "latitude": "47.17326000",
                        "longitude": "8.92811000"
                    },
                    {
                        "id": 18481,
                        "name": "Schwyz",
                        "latitude": "47.02076000",
                        "longitude": "8.65414000"
                    },
                    {
                        "id": 18516,
                        "name": "Siebnen",
                        "latitude": "47.17449000",
                        "longitude": "8.89781000"
                    },
                    {
                        "id": 18553,
                        "name": "Steinen",
                        "latitude": "47.04975000",
                        "longitude": "8.61214000"
                    },
                    {
                        "id": 18612,
                        "name": "Tuggen",
                        "latitude": "47.20291000",
                        "longitude": "8.94896000"
                    },
                    {
                        "id": 18632,
                        "name": "Unteriberg",
                        "latitude": "47.06258000",
                        "longitude": "8.80520000"
                    },
                    {
                        "id": 18693,
                        "name": "Vorderthal",
                        "latitude": "47.12172000",
                        "longitude": "8.90225000"
                    },
                    {
                        "id": 18767,
                        "name": "Wollerau",
                        "latitude": "47.19478000",
                        "longitude": "8.71903000"
                    }
                ]
            },
            {
                "id": 1662,
                "name": "Solothurn",
                "iso2": "SO",
                "latitude": "47.33207170",
                "longitude": "7.63883850",
                "type": "canton",
                "cities": [
                    {
                        "id": 17438,
                        "name": "Balsthal",
                        "latitude": "47.31613000",
                        "longitude": "7.69318000"
                    },
                    {
                        "id": 17468,
                        "name": "Bettlach",
                        "latitude": "47.20062000",
                        "longitude": "7.42405000"
                    },
                    {
                        "id": 17478,
                        "name": "Bezirk Bucheggberg",
                        "latitude": "47.13205000",
                        "longitude": "7.47885000"
                    },
                    {
                        "id": 17482,
                        "name": "Bezirk Dorneck",
                        "latitude": "47.48032000",
                        "longitude": "7.61816000"
                    },
                    {
                        "id": 17485,
                        "name": "Bezirk Gäu",
                        "latitude": "47.29606000",
                        "longitude": "7.77503000"
                    },
                    {
                        "id": 17486,
                        "name": "Bezirk Gösgen",
                        "latitude": "47.37758000",
                        "longitude": "7.92030000"
                    },
                    {
                        "id": 17495,
                        "name": "Bezirk Lebern",
                        "latitude": "47.21798000",
                        "longitude": "7.48053000"
                    },
                    {
                        "id": 17503,
                        "name": "Bezirk Olten",
                        "latitude": "47.34426000",
                        "longitude": "7.90755000"
                    },
                    {
                        "id": 17511,
                        "name": "Bezirk Solothurn",
                        "latitude": "47.20818000",
                        "longitude": "7.53084000"
                    },
                    {
                        "id": 17513,
                        "name": "Bezirk Thal",
                        "latitude": "47.31095000",
                        "longitude": "7.63592000"
                    },
                    {
                        "id": 17514,
                        "name": "Bezirk Thierstein",
                        "latitude": "47.38333000",
                        "longitude": "7.55000000"
                    },
                    {
                        "id": 17519,
                        "name": "Bezirk Wasseramt",
                        "latitude": "47.18911000",
                        "longitude": "7.59157000"
                    },
                    {
                        "id": 17525,
                        "name": "Biberist",
                        "latitude": "47.18009000",
                        "longitude": "7.56246000"
                    },
                    {
                        "id": 17557,
                        "name": "Breitenbach",
                        "latitude": "47.40668000",
                        "longitude": "7.54554000"
                    },
                    {
                        "id": 17605,
                        "name": "Büsserach",
                        "latitude": "47.39415000",
                        "longitude": "7.54117000"
                    },
                    {
                        "id": 17679,
                        "name": "Deitingen",
                        "latitude": "47.21515000",
                        "longitude": "7.61880000"
                    },
                    {
                        "id": 17683,
                        "name": "Derendingen",
                        "latitude": "47.19850000",
                        "longitude": "7.58844000"
                    },
                    {
                        "id": 17704,
                        "name": "Dornach",
                        "latitude": "47.48038000",
                        "longitude": "7.61644000"
                    },
                    {
                        "id": 17728,
                        "name": "Egerkingen",
                        "latitude": "47.31957000",
                        "longitude": "7.78424000"
                    },
                    {
                        "id": 17765,
                        "name": "Erlinsbach",
                        "latitude": "47.39753000",
                        "longitude": "8.00797000"
                    },
                    {
                        "id": 17814,
                        "name": "Fulenbach",
                        "latitude": "47.27103000",
                        "longitude": "7.83136000"
                    },
                    {
                        "id": 17828,
                        "name": "Gerlafingen",
                        "latitude": "47.17087000",
                        "longitude": "7.57249000"
                    },
                    {
                        "id": 17868,
                        "name": "Grenchen",
                        "latitude": "47.19210000",
                        "longitude": "7.39586000"
                    },
                    {
                        "id": 17886,
                        "name": "Gunzgen",
                        "latitude": "47.31375000",
                        "longitude": "7.83102000"
                    },
                    {
                        "id": 17937,
                        "name": "Hägendorf",
                        "latitude": "47.33497000",
                        "longitude": "7.84133000"
                    },
                    {
                        "id": 17914,
                        "name": "Himmelried",
                        "latitude": "47.42136000",
                        "longitude": "7.59985000"
                    },
                    {
                        "id": 17924,
                        "name": "Hochwald",
                        "latitude": "47.45389000",
                        "longitude": "7.64459000"
                    },
                    {
                        "id": 17984,
                        "name": "Kleinlützel",
                        "latitude": "47.42518000",
                        "longitude": "7.41607000"
                    },
                    {
                        "id": 18007,
                        "name": "Kriegstetten",
                        "latitude": "47.17449000",
                        "longitude": "7.59799000"
                    },
                    {
                        "id": 18035,
                        "name": "Langendorf",
                        "latitude": "47.21974000",
                        "longitude": "7.51469000"
                    },
                    {
                        "id": 18046,
                        "name": "Laupersdorf",
                        "latitude": "47.31260000",
                        "longitude": "7.65465000"
                    },
                    {
                        "id": 18092,
                        "name": "Lostorf",
                        "latitude": "47.38372000",
                        "longitude": "7.94655000"
                    },
                    {
                        "id": 18102,
                        "name": "Luterbach",
                        "latitude": "47.21426000",
                        "longitude": "7.58463000"
                    },
                    {
                        "id": 18134,
                        "name": "Matzendorf",
                        "latitude": "47.30374000",
                        "longitude": "7.62820000"
                    },
                    {
                        "id": 18156,
                        "name": "Messen",
                        "latitude": "47.09155000",
                        "longitude": "7.44528000"
                    },
                    {
                        "id": 18224,
                        "name": "Niedergösgen",
                        "latitude": "47.37157000",
                        "longitude": "7.98837000"
                    },
                    {
                        "id": 18232,
                        "name": "Nunningen",
                        "latitude": "47.39410000",
                        "longitude": "7.61951000"
                    },
                    {
                        "id": 18241,
                        "name": "Oberbuchsiten",
                        "latitude": "47.31334000",
                        "longitude": "7.76836000"
                    },
                    {
                        "id": 18254,
                        "name": "Obergösgen",
                        "latitude": "47.36538000",
                        "longitude": "7.95173000"
                    },
                    {
                        "id": 18279,
                        "name": "Oensingen",
                        "latitude": "47.28764000",
                        "longitude": "7.71612000"
                    },
                    {
                        "id": 18283,
                        "name": "Olten",
                        "latitude": "47.34999000",
                        "longitude": "7.90329000"
                    },
                    {
                        "id": 18375,
                        "name": "Riedholz",
                        "latitude": "47.23158000",
                        "longitude": "7.56829000"
                    },
                    {
                        "id": 18381,
                        "name": "Rodersdorf",
                        "latitude": "47.48082000",
                        "longitude": "7.45767000"
                    },
                    {
                        "id": 18384,
                        "name": "Rohr",
                        "latitude": "47.41029000",
                        "longitude": "7.95333000"
                    },
                    {
                        "id": 18485,
                        "name": "Schönenwerd",
                        "latitude": "47.36910000",
                        "longitude": "8.00167000"
                    },
                    {
                        "id": 18506,
                        "name": "Selzach",
                        "latitude": "47.20531000",
                        "longitude": "7.45521000"
                    },
                    {
                        "id": 18528,
                        "name": "Solothurn",
                        "latitude": "47.20791000",
                        "longitude": "7.53714000"
                    },
                    {
                        "id": 18561,
                        "name": "Subingen",
                        "latitude": "47.19852000",
                        "longitude": "7.61949000"
                    },
                    {
                        "id": 18603,
                        "name": "Trimbach",
                        "latitude": "47.36561000",
                        "longitude": "7.88680000"
                    },
                    {
                        "id": 18721,
                        "name": "Wangen",
                        "latitude": "47.34365000",
                        "longitude": "7.86982000"
                    },
                    {
                        "id": 18734,
                        "name": "Welschenrohr",
                        "latitude": "47.28052000",
                        "longitude": "7.52664000"
                    },
                    {
                        "id": 18765,
                        "name": "Wolfwil",
                        "latitude": "47.26871000",
                        "longitude": "7.79652000"
                    },
                    {
                        "id": 18800,
                        "name": "Zuchwil",
                        "latitude": "47.20173000",
                        "longitude": "7.56649000"
                    }
                ]
            },
            {
                "id": 1644,
                "name": "St. Gallen",
                "iso2": "SG",
                "latitude": "47.14562540",
                "longitude": "9.35043320",
                "type": "canton",
                "cities": [
                    {
                        "id": 17393,
                        "name": "Altstätten",
                        "latitude": "47.37766000",
                        "longitude": "9.54746000"
                    },
                    {
                        "id": 17394,
                        "name": "Amden",
                        "latitude": "47.14888000",
                        "longitude": "9.14233000"
                    },
                    {
                        "id": 17398,
                        "name": "Andwil",
                        "latitude": "47.43855000",
                        "longitude": "9.27436000"
                    },
                    {
                        "id": 17419,
                        "name": "Au",
                        "latitude": "47.43093000",
                        "longitude": "9.63448000"
                    },
                    {
                        "id": 17430,
                        "name": "Bad Ragaz",
                        "latitude": "47.00601000",
                        "longitude": "9.50266000"
                    },
                    {
                        "id": 17435,
                        "name": "Balgach",
                        "latitude": "47.40556000",
                        "longitude": "9.60702000"
                    },
                    {
                        "id": 17458,
                        "name": "Benken",
                        "latitude": "47.19942000",
                        "longitude": "9.00735000"
                    },
                    {
                        "id": 17567,
                        "name": "Bronschhofen",
                        "latitude": "47.47835000",
                        "longitude": "9.03454000"
                    },
                    {
                        "id": 17580,
                        "name": "Buchs",
                        "latitude": "47.16743000",
                        "longitude": "9.47794000"
                    },
                    {
                        "id": 17606,
                        "name": "Bütschwil",
                        "latitude": "47.36022000",
                        "longitude": "9.07213000"
                    },
                    {
                        "id": 17678,
                        "name": "Degersheim",
                        "latitude": "47.37429000",
                        "longitude": "9.20019000"
                    },
                    {
                        "id": 17687,
                        "name": "Diepoldsau",
                        "latitude": "47.38600000",
                        "longitude": "9.65558000"
                    },
                    {
                        "id": 17720,
                        "name": "Ebnat-Kappel",
                        "latitude": "47.26195000",
                        "longitude": "9.12473000"
                    },
                    {
                        "id": 17730,
                        "name": "Eggersriet",
                        "latitude": "47.44202000",
                        "longitude": "9.46901000"
                    },
                    {
                        "id": 17736,
                        "name": "Eichberg",
                        "latitude": "47.34374000",
                        "longitude": "9.53140000"
                    },
                    {
                        "id": 17769,
                        "name": "Eschenbach",
                        "latitude": "47.23981000",
                        "longitude": "8.92156000"
                    },
                    {
                        "id": 17791,
                        "name": "Flawil",
                        "latitude": "47.41301000",
                        "longitude": "9.18324000"
                    },
                    {
                        "id": 17794,
                        "name": "Flums",
                        "latitude": "47.09058000",
                        "longitude": "9.34301000"
                    },
                    {
                        "id": 17821,
                        "name": "Gams",
                        "latitude": "47.20429000",
                        "longitude": "9.44172000"
                    },
                    {
                        "id": 17822,
                        "name": "Ganterschwil",
                        "latitude": "47.38103000",
                        "longitude": "9.09239000"
                    },
                    {
                        "id": 17847,
                        "name": "Goldach",
                        "latitude": "47.47401000",
                        "longitude": "9.46711000"
                    },
                    {
                        "id": 17849,
                        "name": "Goldingen",
                        "latitude": "47.26477000",
                        "longitude": "8.96167000"
                    },
                    {
                        "id": 17850,
                        "name": "Gommiswald",
                        "latitude": "47.23128000",
                        "longitude": "9.02355000"
                    },
                    {
                        "id": 17856,
                        "name": "Gossau",
                        "latitude": "47.41551000",
                        "longitude": "9.25482000"
                    },
                    {
                        "id": 17859,
                        "name": "Grabs",
                        "latitude": "47.18248000",
                        "longitude": "9.44395000"
                    },
                    {
                        "id": 17890,
                        "name": "Haag (Rheintal)",
                        "latitude": "47.20989000",
                        "longitude": "9.48931000"
                    },
                    {
                        "id": 17938,
                        "name": "Häggenschwil",
                        "latitude": "47.49462000",
                        "longitude": "9.34487000"
                    },
                    {
                        "id": 17934,
                        "name": "Horn",
                        "latitude": "47.49425000",
                        "longitude": "9.46246000"
                    },
                    {
                        "id": 17959,
                        "name": "Jona",
                        "latitude": "47.22983000",
                        "longitude": "8.83884000"
                    },
                    {
                        "id": 17962,
                        "name": "Jonschwil",
                        "latitude": "47.42402000",
                        "longitude": "9.08689000"
                    },
                    {
                        "id": 17969,
                        "name": "Kaltbrunn",
                        "latitude": "47.21367000",
                        "longitude": "9.02590000"
                    },
                    {
                        "id": 17980,
                        "name": "Kirchberg",
                        "latitude": "47.41159000",
                        "longitude": "9.04020000"
                    },
                    {
                        "id": 18009,
                        "name": "Krummenau",
                        "latitude": "47.24755000",
                        "longitude": "9.17064000"
                    },
                    {
                        "id": 18081,
                        "name": "Lichtensteig",
                        "latitude": "47.32381000",
                        "longitude": "9.08758000"
                    },
                    {
                        "id": 18111,
                        "name": "Lütisburg",
                        "latitude": "47.39451000",
                        "longitude": "9.08312000"
                    },
                    {
                        "id": 18160,
                        "name": "Mogelsberg",
                        "latitude": "47.36222000",
                        "longitude": "9.13541000"
                    },
                    {
                        "id": 18194,
                        "name": "Mörschwil",
                        "latitude": "47.47097000",
                        "longitude": "9.42278000"
                    },
                    {
                        "id": 18173,
                        "name": "Mosnang",
                        "latitude": "47.36252000",
                        "longitude": "9.04296000"
                    },
                    {
                        "id": 18178,
                        "name": "Muolen",
                        "latitude": "47.52102000",
                        "longitude": "9.32484000"
                    },
                    {
                        "id": 18221,
                        "name": "Niederbüren",
                        "latitude": "47.46547000",
                        "longitude": "9.20568000"
                    },
                    {
                        "id": 18226,
                        "name": "Niederhelfenschwil",
                        "latitude": "47.47487000",
                        "longitude": "9.18543000"
                    },
                    {
                        "id": 18255,
                        "name": "Oberhelfenschwil",
                        "latitude": "47.35673000",
                        "longitude": "9.11076000"
                    },
                    {
                        "id": 18262,
                        "name": "Oberriet",
                        "latitude": "47.32088000",
                        "longitude": "9.56808000"
                    },
                    {
                        "id": 18269,
                        "name": "Oberuzwil",
                        "latitude": "47.43076000",
                        "longitude": "9.12724000"
                    },
                    {
                        "id": 18333,
                        "name": "Quarten",
                        "latitude": "47.10700000",
                        "longitude": "9.24199000"
                    },
                    {
                        "id": 18338,
                        "name": "Rapperswil",
                        "latitude": "47.22557000",
                        "longitude": "8.82228000"
                    },
                    {
                        "id": 18341,
                        "name": "Rebstein",
                        "latitude": "47.39812000",
                        "longitude": "9.58503000"
                    },
                    {
                        "id": 18365,
                        "name": "Rheineck",
                        "latitude": "47.46630000",
                        "longitude": "9.59028000"
                    },
                    {
                        "id": 18392,
                        "name": "Rorschach",
                        "latitude": "47.47800000",
                        "longitude": "9.49030000"
                    },
                    {
                        "id": 18410,
                        "name": "Rüthi",
                        "latitude": "47.29480000",
                        "longitude": "9.53857000"
                    },
                    {
                        "id": 18438,
                        "name": "Sankt Gallen",
                        "latitude": "47.42391000",
                        "longitude": "9.37477000"
                    },
                    {
                        "id": 18439,
                        "name": "Sankt Gallenkappel",
                        "latitude": "47.24368000",
                        "longitude": "8.96438000"
                    },
                    {
                        "id": 18440,
                        "name": "Sankt Margrethen",
                        "latitude": "47.45253000",
                        "longitude": "9.63741000"
                    },
                    {
                        "id": 18442,
                        "name": "Sankt Peterzell",
                        "latitude": "47.31782000",
                        "longitude": "9.17599000"
                    },
                    {
                        "id": 18444,
                        "name": "Sargans",
                        "latitude": "47.04896000",
                        "longitude": "9.44103000"
                    },
                    {
                        "id": 18482,
                        "name": "Schänis",
                        "latitude": "47.15995000",
                        "longitude": "9.04549000"
                    },
                    {
                        "id": 18472,
                        "name": "Schmerikon",
                        "latitude": "47.22538000",
                        "longitude": "8.94836000"
                    },
                    {
                        "id": 18509,
                        "name": "Sennwald",
                        "latitude": "47.26063000",
                        "longitude": "9.50268000"
                    },
                    {
                        "id": 18515,
                        "name": "Sevelen",
                        "latitude": "47.12213000",
                        "longitude": "9.48601000"
                    },
                    {
                        "id": 18581,
                        "name": "Thal",
                        "latitude": "47.46677000",
                        "longitude": "9.56643000"
                    },
                    {
                        "id": 18654,
                        "name": "Uznach",
                        "latitude": "47.22421000",
                        "longitude": "8.98263000"
                    },
                    {
                        "id": 18655,
                        "name": "Uzwil",
                        "latitude": "47.43653000",
                        "longitude": "9.13422000"
                    },
                    {
                        "id": 18700,
                        "name": "Wahlkreis Rheintal",
                        "latitude": "47.37769000",
                        "longitude": "9.57903000"
                    },
                    {
                        "id": 18701,
                        "name": "Wahlkreis Rorschach",
                        "latitude": "47.46647000",
                        "longitude": "9.44246000"
                    },
                    {
                        "id": 18702,
                        "name": "Wahlkreis Sarganserland",
                        "latitude": "47.05000000",
                        "longitude": "9.43333000"
                    },
                    {
                        "id": 18703,
                        "name": "Wahlkreis See-Gaster",
                        "latitude": "47.22459000",
                        "longitude": "9.01680000"
                    },
                    {
                        "id": 18704,
                        "name": "Wahlkreis St. Gallen",
                        "latitude": "47.46342000",
                        "longitude": "9.39052000"
                    },
                    {
                        "id": 18705,
                        "name": "Wahlkreis Toggenburg",
                        "latitude": "47.29453000",
                        "longitude": "9.17283000"
                    },
                    {
                        "id": 18706,
                        "name": "Wahlkreis Werdenberg",
                        "latitude": "47.17743000",
                        "longitude": "9.46299000"
                    },
                    {
                        "id": 18707,
                        "name": "Wahlkreis Wil",
                        "latitude": "47.42591000",
                        "longitude": "9.12451000"
                    },
                    {
                        "id": 18711,
                        "name": "Waldkirch",
                        "latitude": "47.46859000",
                        "longitude": "9.28665000"
                    },
                    {
                        "id": 18713,
                        "name": "Walenstadt",
                        "latitude": "47.12411000",
                        "longitude": "9.31194000"
                    },
                    {
                        "id": 18725,
                        "name": "Wattwil",
                        "latitude": "47.29955000",
                        "longitude": "9.08657000"
                    },
                    {
                        "id": 18727,
                        "name": "Weesen",
                        "latitude": "47.13447000",
                        "longitude": "9.09644000"
                    },
                    {
                        "id": 18749,
                        "name": "Wil",
                        "latitude": "47.46152000",
                        "longitude": "9.04552000"
                    },
                    {
                        "id": 18753,
                        "name": "Wildhaus",
                        "latitude": "47.20583000",
                        "longitude": "9.35402000"
                    },
                    {
                        "id": 18759,
                        "name": "Wittenbach",
                        "latitude": "47.46108000",
                        "longitude": "9.38601000"
                    },
                    {
                        "id": 18805,
                        "name": "Zuzwil",
                        "latitude": "47.47452000",
                        "longitude": "9.11196000"
                    }
                ]
            },
            {
                "id": 1657,
                "name": "Thurgau",
                "iso2": "TG",
                "latitude": "47.60378560",
                "longitude": "9.05573710",
                "type": "canton",
                "cities": [
                    {
                        "id": 17356,
                        "name": "Aadorf",
                        "latitude": "47.49204000",
                        "longitude": "8.90099000"
                    },
                    {
                        "id": 17374,
                        "name": "Affeltrangen",
                        "latitude": "47.52581000",
                        "longitude": "9.03307000"
                    },
                    {
                        "id": 17392,
                        "name": "Altnau",
                        "latitude": "47.61052000",
                        "longitude": "9.26160000"
                    },
                    {
                        "id": 17395,
                        "name": "Amriswil",
                        "latitude": "47.54699000",
                        "longitude": "9.29586000"
                    },
                    {
                        "id": 17402,
                        "name": "Arbon",
                        "latitude": "47.51667000",
                        "longitude": "9.43333000"
                    },
                    {
                        "id": 17403,
                        "name": "Arbon District",
                        "latitude": "47.54867000",
                        "longitude": "9.35159000"
                    },
                    {
                        "id": 17459,
                        "name": "Berg",
                        "latitude": "47.57879000",
                        "longitude": "9.16635000"
                    },
                    {
                        "id": 17552,
                        "name": "Bottighofen",
                        "latitude": "47.63643000",
                        "longitude": "9.20882000"
                    },
                    {
                        "id": 17603,
                        "name": "Bürglen",
                        "latitude": "47.54921000",
                        "longitude": "9.14950000"
                    },
                    {
                        "id": 17688,
                        "name": "Diessenhofen",
                        "latitude": "47.68908000",
                        "longitude": "8.74958000"
                    },
                    {
                        "id": 17733,
                        "name": "Egnach",
                        "latitude": "47.54268000",
                        "longitude": "9.38048000"
                    },
                    {
                        "id": 17760,
                        "name": "Erlen",
                        "latitude": "47.54814000",
                        "longitude": "9.23415000"
                    },
                    {
                        "id": 17766,
                        "name": "Ermatingen",
                        "latitude": "47.67057000",
                        "longitude": "9.08573000"
                    },
                    {
                        "id": 17770,
                        "name": "Eschenz",
                        "latitude": "47.64793000",
                        "longitude": "8.87472000"
                    },
                    {
                        "id": 17771,
                        "name": "Eschlikon",
                        "latitude": "47.46361000",
                        "longitude": "8.96381000"
                    },
                    {
                        "id": 17789,
                        "name": "Fischingen",
                        "latitude": "47.41422000",
                        "longitude": "8.96862000"
                    },
                    {
                        "id": 17803,
                        "name": "Frauenfeld",
                        "latitude": "47.55776000",
                        "longitude": "8.89893000"
                    },
                    {
                        "id": 17804,
                        "name": "Frauenfeld District",
                        "latitude": "47.61115000",
                        "longitude": "8.89444000"
                    },
                    {
                        "id": 17818,
                        "name": "Gachnang",
                        "latitude": "47.53935000",
                        "longitude": "8.85311000"
                    },
                    {
                        "id": 17858,
                        "name": "Gottlieben",
                        "latitude": "47.66380000",
                        "longitude": "9.13371000"
                    },
                    {
                        "id": 17889,
                        "name": "Güttingen",
                        "latitude": "47.60349000",
                        "longitude": "9.28742000"
                    },
                    {
                        "id": 17928,
                        "name": "Homburg",
                        "latitude": "47.63469000",
                        "longitude": "9.00756000"
                    },
                    {
                        "id": 17945,
                        "name": "Hüttwilen",
                        "latitude": "47.60674000",
                        "longitude": "8.87343000"
                    },
                    {
                        "id": 18005,
                        "name": "Kreuzlingen",
                        "latitude": "47.65051000",
                        "longitude": "9.17504000"
                    },
                    {
                        "id": 18006,
                        "name": "Kreuzlingen District",
                        "latitude": "47.63046000",
                        "longitude": "9.16458000"
                    },
                    {
                        "id": 18041,
                        "name": "Langrickenbach",
                        "latitude": "47.59353000",
                        "longitude": "9.24727000"
                    },
                    {
                        "id": 18189,
                        "name": "Märstetten-Dorf",
                        "latitude": "47.59252000",
                        "longitude": "9.06851000"
                    },
                    {
                        "id": 18135,
                        "name": "Matzingen",
                        "latitude": "47.51957000",
                        "longitude": "8.93365000"
                    },
                    {
                        "id": 18198,
                        "name": "Müllheim",
                        "latitude": "47.60195000",
                        "longitude": "9.00357000"
                    },
                    {
                        "id": 18202,
                        "name": "Münchwilen",
                        "latitude": "47.47719000",
                        "longitude": "8.99677000"
                    },
                    {
                        "id": 18203,
                        "name": "Münchwilen District",
                        "latitude": "47.47324000",
                        "longitude": "8.98812000"
                    },
                    {
                        "id": 18205,
                        "name": "Münsterlingen",
                        "latitude": "47.63197000",
                        "longitude": "9.23271000"
                    },
                    {
                        "id": 18309,
                        "name": "Pfyn",
                        "latitude": "47.59693000",
                        "longitude": "8.95420000"
                    },
                    {
                        "id": 18373,
                        "name": "Rickenbach bei Wil",
                        "latitude": "47.44856000",
                        "longitude": "9.04902000"
                    },
                    {
                        "id": 18383,
                        "name": "Roggwil",
                        "latitude": "47.49981000",
                        "longitude": "9.39580000"
                    },
                    {
                        "id": 18388,
                        "name": "Romanshorn",
                        "latitude": "47.56586000",
                        "longitude": "9.37869000"
                    },
                    {
                        "id": 18433,
                        "name": "Salmsach",
                        "latitude": "47.55433000",
                        "longitude": "9.37229000"
                    },
                    {
                        "id": 18525,
                        "name": "Sirnach",
                        "latitude": "47.46222000",
                        "longitude": "8.99763000"
                    },
                    {
                        "id": 18549,
                        "name": "Steckborn",
                        "latitude": "47.66667000",
                        "longitude": "8.98333000"
                    },
                    {
                        "id": 18557,
                        "name": "Stettfurt",
                        "latitude": "47.52588000",
                        "longitude": "8.95317000"
                    },
                    {
                        "id": 18563,
                        "name": "Sulgen",
                        "latitude": "47.53967000",
                        "longitude": "9.18585000"
                    },
                    {
                        "id": 18616,
                        "name": "Tägerwilen",
                        "latitude": "47.65698000",
                        "longitude": "9.13999000"
                    },
                    {
                        "id": 18593,
                        "name": "Thundorf",
                        "latitude": "47.54594000",
                        "longitude": "8.96358000"
                    },
                    {
                        "id": 18652,
                        "name": "Uttwil",
                        "latitude": "47.58440000",
                        "longitude": "9.34101000"
                    },
                    {
                        "id": 18698,
                        "name": "Wagenhausen",
                        "latitude": "47.66003000",
                        "longitude": "8.84782000"
                    },
                    {
                        "id": 18781,
                        "name": "Wängi",
                        "latitude": "47.49654000",
                        "longitude": "8.95325000"
                    },
                    {
                        "id": 18730,
                        "name": "Weinfelden",
                        "latitude": "47.56667000",
                        "longitude": "9.10000000"
                    },
                    {
                        "id": 18731,
                        "name": "Weinfelden District",
                        "latitude": "47.54237000",
                        "longitude": "9.15713000"
                    },
                    {
                        "id": 18747,
                        "name": "Wigoltingen",
                        "latitude": "47.59770000",
                        "longitude": "9.03141000"
                    }
                ]
            },
            {
                "id": 1643,
                "name": "Ticino",
                "iso2": "TI",
                "latitude": "46.33173400",
                "longitude": "8.80045290",
                "type": "canton",
                "cities": [
                    {
                        "id": 17361,
                        "name": "Acquarossa",
                        "latitude": "46.45473000",
                        "longitude": "8.94261000"
                    },
                    {
                        "id": 17380,
                        "name": "Agno",
                        "latitude": "45.99863000",
                        "longitude": "8.90030000"
                    },
                    {
                        "id": 17384,
                        "name": "Airolo",
                        "latitude": "46.52855000",
                        "longitude": "8.61189000"
                    },
                    {
                        "id": 17413,
                        "name": "Arzo",
                        "latitude": "45.87606000",
                        "longitude": "8.94103000"
                    },
                    {
                        "id": 17414,
                        "name": "Ascona",
                        "latitude": "46.15451000",
                        "longitude": "8.77327000"
                    },
                    {
                        "id": 17434,
                        "name": "Balerna",
                        "latitude": "45.84638000",
                        "longitude": "9.00724000"
                    },
                    {
                        "id": 17452,
                        "name": "Bellinzona",
                        "latitude": "46.19278000",
                        "longitude": "9.01703000"
                    },
                    {
                        "id": 17453,
                        "name": "Bellinzona District",
                        "latitude": "46.18858000",
                        "longitude": "9.00254000"
                    },
                    {
                        "id": 17524,
                        "name": "Biasca",
                        "latitude": "46.35972000",
                        "longitude": "8.96965000"
                    },
                    {
                        "id": 17533,
                        "name": "Bioggio",
                        "latitude": "46.01357000",
                        "longitude": "8.91103000"
                    },
                    {
                        "id": 17540,
                        "name": "Blenio District",
                        "latitude": "46.47613000",
                        "longitude": "8.94609000"
                    },
                    {
                        "id": 17544,
                        "name": "Bodio",
                        "latitude": "46.37808000",
                        "longitude": "8.90991000"
                    },
                    {
                        "id": 17564,
                        "name": "Brissago",
                        "latitude": "46.12013000",
                        "longitude": "8.71181000"
                    },
                    {
                        "id": 17607,
                        "name": "Cadempino",
                        "latitude": "46.03672000",
                        "longitude": "8.93403000"
                    },
                    {
                        "id": 17608,
                        "name": "Cadenazzo",
                        "latitude": "46.15172000",
                        "longitude": "8.94719000"
                    },
                    {
                        "id": 17609,
                        "name": "Cadro",
                        "latitude": "46.04595000",
                        "longitude": "8.98725000"
                    },
                    {
                        "id": 17610,
                        "name": "Camorino",
                        "latitude": "46.16483000",
                        "longitude": "9.00547000"
                    },
                    {
                        "id": 17611,
                        "name": "Canobbio",
                        "latitude": "46.03592000",
                        "longitude": "8.96605000"
                    },
                    {
                        "id": 17613,
                        "name": "Caslano",
                        "latitude": "45.97364000",
                        "longitude": "8.87739000"
                    },
                    {
                        "id": 17614,
                        "name": "Castel San Pietro",
                        "latitude": "45.86211000",
                        "longitude": "9.00843000"
                    },
                    {
                        "id": 17620,
                        "name": "Cevio",
                        "latitude": "46.31479000",
                        "longitude": "8.60332000"
                    },
                    {
                        "id": 17636,
                        "name": "Chiasso",
                        "latitude": "45.83203000",
                        "longitude": "9.03119000"
                    },
                    {
                        "id": 17645,
                        "name": "Claro",
                        "latitude": "46.25763000",
                        "longitude": "9.02252000"
                    },
                    {
                        "id": 17648,
                        "name": "Comano",
                        "latitude": "46.03635000",
                        "longitude": "8.95526000"
                    },
                    {
                        "id": 17670,
                        "name": "Cugnasco",
                        "latitude": "46.17473000",
                        "longitude": "8.91684000"
                    },
                    {
                        "id": 17780,
                        "name": "Faido",
                        "latitude": "46.47700000",
                        "longitude": "8.80125000"
                    },
                    {
                        "id": 17836,
                        "name": "Giubiasco",
                        "latitude": "46.17246000",
                        "longitude": "9.00793000"
                    },
                    {
                        "id": 17854,
                        "name": "Gordola",
                        "latitude": "46.18256000",
                        "longitude": "8.86657000"
                    },
                    {
                        "id": 17863,
                        "name": "Gravesano",
                        "latitude": "46.04208000",
                        "longitude": "8.91832000"
                    },
                    {
                        "id": 18053,
                        "name": "Lavertezzo",
                        "latitude": "46.25893000",
                        "longitude": "8.83756000"
                    },
                    {
                        "id": 18078,
                        "name": "Leventina District",
                        "latitude": "46.46912000",
                        "longitude": "8.75539000"
                    },
                    {
                        "id": 18084,
                        "name": "Ligornetto",
                        "latitude": "45.86161000",
                        "longitude": "8.95166000"
                    },
                    {
                        "id": 18088,
                        "name": "Locarno",
                        "latitude": "46.17086000",
                        "longitude": "8.79953000"
                    },
                    {
                        "id": 18089,
                        "name": "Locarno District",
                        "latitude": "46.18033000",
                        "longitude": "8.75991000"
                    },
                    {
                        "id": 18090,
                        "name": "Lodrino",
                        "latitude": "46.30016000",
                        "longitude": "8.97986000"
                    },
                    {
                        "id": 18091,
                        "name": "Losone",
                        "latitude": "46.16866000",
                        "longitude": "8.75928000"
                    },
                    {
                        "id": 18098,
                        "name": "Lugano",
                        "latitude": "46.01008000",
                        "longitude": "8.96004000"
                    },
                    {
                        "id": 18099,
                        "name": "Lugano District",
                        "latitude": "46.02322000",
                        "longitude": "8.93802000"
                    },
                    {
                        "id": 18100,
                        "name": "Lumino",
                        "latitude": "46.23020000",
                        "longitude": "9.06420000"
                    },
                    {
                        "id": 18114,
                        "name": "Magadino",
                        "latitude": "46.14892000",
                        "longitude": "8.85610000"
                    },
                    {
                        "id": 18120,
                        "name": "Malvaglia",
                        "latitude": "46.40588000",
                        "longitude": "8.98190000"
                    },
                    {
                        "id": 18128,
                        "name": "Massagno",
                        "latitude": "46.01257000",
                        "longitude": "8.94354000"
                    },
                    {
                        "id": 18145,
                        "name": "Melano",
                        "latitude": "45.92202000",
                        "longitude": "8.98435000"
                    },
                    {
                        "id": 18147,
                        "name": "Melide",
                        "latitude": "45.95455000",
                        "longitude": "8.94725000"
                    },
                    {
                        "id": 18149,
                        "name": "Mendrisio",
                        "latitude": "45.87019000",
                        "longitude": "8.98160000"
                    },
                    {
                        "id": 18150,
                        "name": "Mendrisio District",
                        "latitude": "45.86592000",
                        "longitude": "8.99931000"
                    },
                    {
                        "id": 18159,
                        "name": "Minusio",
                        "latitude": "46.17769000",
                        "longitude": "8.81473000"
                    },
                    {
                        "id": 18163,
                        "name": "Montagnola",
                        "latitude": "45.98323000",
                        "longitude": "8.91786000"
                    },
                    {
                        "id": 18166,
                        "name": "Monte Carasso",
                        "latitude": "46.18649000",
                        "longitude": "8.99892000"
                    },
                    {
                        "id": 18170,
                        "name": "Morbio Inferiore",
                        "latitude": "45.84915000",
                        "longitude": "9.01907000"
                    },
                    {
                        "id": 18180,
                        "name": "Muralto",
                        "latitude": "46.17323000",
                        "longitude": "8.80219000"
                    },
                    {
                        "id": 18231,
                        "name": "Novazzano",
                        "latitude": "45.84073000",
                        "longitude": "8.98236000"
                    },
                    {
                        "id": 18325,
                        "name": "Pregassona",
                        "latitude": "46.02021000",
                        "longitude": "8.97429000"
                    },
                    {
                        "id": 18331,
                        "name": "Pura",
                        "latitude": "45.98647000",
                        "longitude": "8.86877000"
                    },
                    {
                        "id": 18378,
                        "name": "Riva San Vitale",
                        "latitude": "45.90123000",
                        "longitude": "8.97167000"
                    },
                    {
                        "id": 18379,
                        "name": "Riviera District",
                        "latitude": "46.30926000",
                        "longitude": "8.98148000"
                    },
                    {
                        "id": 18507,
                        "name": "Sementina",
                        "latitude": "46.18363000",
                        "longitude": "8.99162000"
                    },
                    {
                        "id": 18530,
                        "name": "Sorengo",
                        "latitude": "45.99766000",
                        "longitude": "8.93783000"
                    },
                    {
                        "id": 18536,
                        "name": "Stabio",
                        "latitude": "45.84846000",
                        "longitude": "8.93642000"
                    },
                    {
                        "id": 18578,
                        "name": "Tesserete",
                        "latitude": "46.06813000",
                        "longitude": "8.96501000"
                    },
                    {
                        "id": 18658,
                        "name": "Vallemaggia District",
                        "latitude": "46.35483000",
                        "longitude": "8.60540000"
                    },
                    {
                        "id": 18671,
                        "name": "Verscio",
                        "latitude": "46.18482000",
                        "longitude": "8.73224000"
                    },
                    {
                        "id": 18678,
                        "name": "Viganello",
                        "latitude": "46.01342000",
                        "longitude": "8.96879000"
                    }
                ]
            },
            {
                "id": 1642,
                "name": "Uri",
                "iso2": "UR",
                "latitude": "41.48606470",
                "longitude": "-71.53085370",
                "type": "canton",
                "cities": [
                    {
                        "id": 17388,
                        "name": "Altdorf",
                        "latitude": "46.88042000",
                        "longitude": "8.64441000"
                    },
                    {
                        "id": 17397,
                        "name": "Andermatt",
                        "latitude": "46.63565000",
                        "longitude": "8.59388000"
                    },
                    {
                        "id": 17416,
                        "name": "Attinghausen",
                        "latitude": "46.86255000",
                        "longitude": "8.63036000"
                    },
                    {
                        "id": 17444,
                        "name": "Bauen",
                        "latitude": "46.93559000",
                        "longitude": "8.57836000"
                    },
                    {
                        "id": 17602,
                        "name": "Bürglen",
                        "latitude": "46.87565000",
                        "longitude": "8.66539000"
                    },
                    {
                        "id": 17768,
                        "name": "Erstfeld",
                        "latitude": "46.81885000",
                        "longitude": "8.65052000"
                    },
                    {
                        "id": 17796,
                        "name": "Flüelen",
                        "latitude": "46.90478000",
                        "longitude": "8.62396000"
                    },
                    {
                        "id": 18458,
                        "name": "Schattdorf",
                        "latitude": "46.86550000",
                        "longitude": "8.65465000"
                    },
                    {
                        "id": 18492,
                        "name": "Seedorf",
                        "latitude": "46.88199000",
                        "longitude": "8.61611000"
                    },
                    {
                        "id": 18521,
                        "name": "Silenen",
                        "latitude": "46.78910000",
                        "longitude": "8.67325000"
                    }
                ]
            },
            {
                "id": 1648,
                "name": "Valais",
                "iso2": "VS",
                "latitude": "46.19046140",
                "longitude": "7.54492260",
                "type": "canton",
                "cities": [
                    {
                        "id": 17405,
                        "name": "Ardon",
                        "latitude": "46.20951000",
                        "longitude": "7.26012000"
                    },
                    {
                        "id": 17427,
                        "name": "Ayent",
                        "latitude": "46.28249000",
                        "longitude": "7.41028000"
                    },
                    {
                        "id": 17433,
                        "name": "Bagnes",
                        "latitude": "46.08333000",
                        "longitude": "7.21667000"
                    },
                    {
                        "id": 17439,
                        "name": "Baltschieder",
                        "latitude": "46.30888000",
                        "longitude": "7.86570000"
                    },
                    {
                        "id": 17441,
                        "name": "Basse-Nendaz",
                        "latitude": "46.18993000",
                        "longitude": "7.31209000"
                    },
                    {
                        "id": 17561,
                        "name": "Brig",
                        "latitude": "46.31667000",
                        "longitude": "7.98333000"
                    },
                    {
                        "id": 17562,
                        "name": "Brig District",
                        "latitude": "46.28255000",
                        "longitude": "8.01185000"
                    },
                    {
                        "id": 17621,
                        "name": "Chalais",
                        "latitude": "46.26758000",
                        "longitude": "7.51145000"
                    },
                    {
                        "id": 17623,
                        "name": "Chamoson",
                        "latitude": "46.20275000",
                        "longitude": "7.22319000"
                    },
                    {
                        "id": 17624,
                        "name": "Champéry",
                        "latitude": "46.17543000",
                        "longitude": "6.86903000"
                    },
                    {
                        "id": 17628,
                        "name": "Charrat",
                        "latitude": "46.12490000",
                        "longitude": "7.13138000"
                    },
                    {
                        "id": 17632,
                        "name": "Chermignon-d’en Haut",
                        "latitude": "46.28844000",
                        "longitude": "7.47487000"
                    },
                    {
                        "id": 17637,
                        "name": "Chippis",
                        "latitude": "46.28020000",
                        "longitude": "7.53962000"
                    },
                    {
                        "id": 17646,
                        "name": "Collombey-Muraz",
                        "latitude": "46.27385000",
                        "longitude": "6.94789000"
                    },
                    {
                        "id": 17650,
                        "name": "Conthey",
                        "latitude": "46.22370000",
                        "longitude": "7.30283000"
                    },
                    {
                        "id": 17651,
                        "name": "Conthey District",
                        "latitude": "46.20485000",
                        "longitude": "7.27857000"
                    },
                    {
                        "id": 17755,
                        "name": "Entremont District",
                        "latitude": "46.02099000",
                        "longitude": "7.21260000"
                    },
                    {
                        "id": 17778,
                        "name": "Evionnaz",
                        "latitude": "46.18096000",
                        "longitude": "7.02232000"
                    },
                    {
                        "id": 17779,
                        "name": "Evolène",
                        "latitude": "46.11422000",
                        "longitude": "7.49407000"
                    },
                    {
                        "id": 17788,
                        "name": "Fiesch",
                        "latitude": "46.39981000",
                        "longitude": "8.13533000"
                    },
                    {
                        "id": 17815,
                        "name": "Fully",
                        "latitude": "46.13851000",
                        "longitude": "7.11468000"
                    },
                    {
                        "id": 17820,
                        "name": "Gampel",
                        "latitude": "46.31599000",
                        "longitude": "7.74210000"
                    },
                    {
                        "id": 17851,
                        "name": "Goms District",
                        "latitude": "46.46161000",
                        "longitude": "8.22190000"
                    },
                    {
                        "id": 17879,
                        "name": "Grächen",
                        "latitude": "46.19529000",
                        "longitude": "7.83745000"
                    },
                    {
                        "id": 17869,
                        "name": "Grimisuat",
                        "latitude": "46.25938000",
                        "longitude": "7.38408000"
                    },
                    {
                        "id": 17881,
                        "name": "Grône",
                        "latitude": "46.25288000",
                        "longitude": "7.45947000"
                    },
                    {
                        "id": 17941,
                        "name": "Hérémence",
                        "latitude": "46.18032000",
                        "longitude": "7.40477000"
                    },
                    {
                        "id": 17940,
                        "name": "Hérens District",
                        "latitude": "46.19407000",
                        "longitude": "7.42391000"
                    },
                    {
                        "id": 18065,
                        "name": "Lens",
                        "latitude": "46.28298000",
                        "longitude": "7.44976000"
                    },
                    {
                        "id": 18074,
                        "name": "Leuk",
                        "latitude": "46.31736000",
                        "longitude": "7.63412000"
                    },
                    {
                        "id": 18075,
                        "name": "Leuk District",
                        "latitude": "46.31439000",
                        "longitude": "7.67291000"
                    },
                    {
                        "id": 18076,
                        "name": "Leukerbad",
                        "latitude": "46.37943000",
                        "longitude": "7.62687000"
                    },
                    {
                        "id": 18080,
                        "name": "Leytron",
                        "latitude": "46.18660000",
                        "longitude": "7.20780000"
                    },
                    {
                        "id": 18125,
                        "name": "Martigny District",
                        "latitude": "46.12386000",
                        "longitude": "7.10354000"
                    },
                    {
                        "id": 18126,
                        "name": "Martigny-Combe",
                        "latitude": "46.07817000",
                        "longitude": "7.05099000"
                    },
                    {
                        "id": 18127,
                        "name": "Martigny-Ville",
                        "latitude": "46.10276000",
                        "longitude": "7.07245000"
                    },
                    {
                        "id": 18165,
                        "name": "Montana",
                        "latitude": "46.31338000",
                        "longitude": "7.48839000"
                    },
                    {
                        "id": 18167,
                        "name": "Monthey",
                        "latitude": "46.25451000",
                        "longitude": "6.95406000"
                    },
                    {
                        "id": 18168,
                        "name": "Monthey District",
                        "latitude": "46.27043000",
                        "longitude": "6.90274000"
                    },
                    {
                        "id": 18207,
                        "name": "Naters",
                        "latitude": "46.32536000",
                        "longitude": "7.98912000"
                    },
                    {
                        "id": 18290,
                        "name": "Orsières",
                        "latitude": "46.02903000",
                        "longitude": "7.14437000"
                    },
                    {
                        "id": 18337,
                        "name": "Randogne",
                        "latitude": "46.30952000",
                        "longitude": "7.50058000"
                    },
                    {
                        "id": 18339,
                        "name": "Raron",
                        "latitude": "46.31196000",
                        "longitude": "7.80029000"
                    },
                    {
                        "id": 18340,
                        "name": "Raron District",
                        "latitude": "46.30000000",
                        "longitude": "7.80000000"
                    },
                    {
                        "id": 18374,
                        "name": "Riddes",
                        "latitude": "46.17276000",
                        "longitude": "7.22360000"
                    },
                    {
                        "id": 18416,
                        "name": "Saas-Fee",
                        "latitude": "46.10805000",
                        "longitude": "7.92741000"
                    },
                    {
                        "id": 18417,
                        "name": "Saas-Grund",
                        "latitude": "46.12281000",
                        "longitude": "7.93651000"
                    },
                    {
                        "id": 18421,
                        "name": "Saillon",
                        "latitude": "46.17035000",
                        "longitude": "7.18771000"
                    },
                    {
                        "id": 18427,
                        "name": "Saint-Léonard",
                        "latitude": "46.25152000",
                        "longitude": "7.41714000"
                    },
                    {
                        "id": 18428,
                        "name": "Saint-Maurice",
                        "latitude": "46.21826000",
                        "longitude": "7.00320000"
                    },
                    {
                        "id": 18429,
                        "name": "Saint-Maurice District",
                        "latitude": "46.15384000",
                        "longitude": "6.99823000"
                    },
                    {
                        "id": 18432,
                        "name": "Salgesch",
                        "latitude": "46.31155000",
                        "longitude": "7.57120000"
                    },
                    {
                        "id": 18434,
                        "name": "Salvan",
                        "latitude": "46.11890000",
                        "longitude": "7.02078000"
                    },
                    {
                        "id": 18441,
                        "name": "Sankt Niklaus",
                        "latitude": "46.17717000",
                        "longitude": "7.80349000"
                    },
                    {
                        "id": 18452,
                        "name": "Savièse",
                        "latitude": "46.25115000",
                        "longitude": "7.34558000"
                    },
                    {
                        "id": 18453,
                        "name": "Saxon",
                        "latitude": "46.14937000",
                        "longitude": "7.17514000"
                    },
                    {
                        "id": 18517,
                        "name": "Sierre",
                        "latitude": "46.29192000",
                        "longitude": "7.53559000"
                    },
                    {
                        "id": 18518,
                        "name": "Sierre District",
                        "latitude": "46.27052000",
                        "longitude": "7.51570000"
                    },
                    {
                        "id": 18524,
                        "name": "Sion District",
                        "latitude": "46.23343000",
                        "longitude": "7.34939000"
                    },
                    {
                        "id": 18527,
                        "name": "Sitten",
                        "latitude": "46.22739000",
                        "longitude": "7.35559000"
                    },
                    {
                        "id": 18545,
                        "name": "Stalden",
                        "latitude": "46.23341000",
                        "longitude": "7.87273000"
                    },
                    {
                        "id": 18573,
                        "name": "Tanay",
                        "latitude": "46.34503000",
                        "longitude": "6.83041000"
                    },
                    {
                        "id": 18607,
                        "name": "Troistorrents",
                        "latitude": "46.22890000",
                        "longitude": "6.91589000"
                    },
                    {
                        "id": 18615,
                        "name": "Turtmann",
                        "latitude": "46.30028000",
                        "longitude": "7.70200000"
                    },
                    {
                        "id": 18662,
                        "name": "Varen",
                        "latitude": "46.31860000",
                        "longitude": "7.60743000"
                    },
                    {
                        "id": 18668,
                        "name": "Verbier",
                        "latitude": "46.10020000",
                        "longitude": "7.22651000"
                    },
                    {
                        "id": 18669,
                        "name": "Vernayaz",
                        "latitude": "46.13667000",
                        "longitude": "7.03906000"
                    },
                    {
                        "id": 18697,
                        "name": "Vétroz",
                        "latitude": "46.22171000",
                        "longitude": "7.27858000"
                    },
                    {
                        "id": 18675,
                        "name": "Vex",
                        "latitude": "46.21239000",
                        "longitude": "7.39826000"
                    },
                    {
                        "id": 18686,
                        "name": "Vionnaz",
                        "latitude": "46.31101000",
                        "longitude": "6.90062000"
                    },
                    {
                        "id": 18687,
                        "name": "Visp",
                        "latitude": "46.29370000",
                        "longitude": "7.88149000"
                    },
                    {
                        "id": 18688,
                        "name": "Visp District",
                        "latitude": "46.17612000",
                        "longitude": "7.85609000"
                    },
                    {
                        "id": 18689,
                        "name": "Visperterminen",
                        "latitude": "46.25899000",
                        "longitude": "7.90192000"
                    },
                    {
                        "id": 18694,
                        "name": "Vouvry",
                        "latitude": "46.33746000",
                        "longitude": "6.88950000"
                    },
                    {
                        "id": 18793,
                        "name": "Zermatt",
                        "latitude": "46.01998000",
                        "longitude": "7.74863000"
                    }
                ]
            },
            {
                "id": 1651,
                "name": "Vaud",
                "iso2": "VD",
                "latitude": "46.56131350",
                "longitude": "6.53676500",
                "type": "canton",
                "cities": [
                    {
                        "id": 17381,
                        "name": "Aigle",
                        "latitude": "46.31810000",
                        "longitude": "6.96457000"
                    },
                    {
                        "id": 17382,
                        "name": "Aigle District",
                        "latitude": "46.30577000",
                        "longitude": "7.02974000"
                    },
                    {
                        "id": 17401,
                        "name": "Apples",
                        "latitude": "46.55237000",
                        "longitude": "6.42889000"
                    },
                    {
                        "id": 17412,
                        "name": "Arzier",
                        "latitude": "46.45962000",
                        "longitude": "6.20813000"
                    },
                    {
                        "id": 17422,
                        "name": "Aubonne",
                        "latitude": "46.49514000",
                        "longitude": "6.39155000"
                    },
                    {
                        "id": 17425,
                        "name": "Avenches",
                        "latitude": "46.88004000",
                        "longitude": "7.04071000"
                    },
                    {
                        "id": 17436,
                        "name": "Ballens",
                        "latitude": "46.55485000",
                        "longitude": "6.37310000"
                    },
                    {
                        "id": 17446,
                        "name": "Bavois",
                        "latitude": "46.68403000",
                        "longitude": "6.56710000"
                    },
                    {
                        "id": 17449,
                        "name": "Begnins",
                        "latitude": "46.44152000",
                        "longitude": "6.24762000"
                    },
                    {
                        "id": 17455,
                        "name": "Belmont-sur-Lausanne",
                        "latitude": "46.51891000",
                        "longitude": "6.67636000"
                    },
                    {
                        "id": 17465,
                        "name": "Berolle",
                        "latitude": "46.55798000",
                        "longitude": "6.33551000"
                    },
                    {
                        "id": 17470,
                        "name": "Bex",
                        "latitude": "46.24965000",
                        "longitude": "7.00980000"
                    },
                    {
                        "id": 17539,
                        "name": "Bière",
                        "latitude": "46.53761000",
                        "longitude": "6.33362000"
                    },
                    {
                        "id": 17543,
                        "name": "Blécherette",
                        "latitude": "46.53932000",
                        "longitude": "6.62227000"
                    },
                    {
                        "id": 17541,
                        "name": "Blonay",
                        "latitude": "46.46778000",
                        "longitude": "6.89615000"
                    },
                    {
                        "id": 17551,
                        "name": "Bottens",
                        "latitude": "46.61596000",
                        "longitude": "6.66149000"
                    },
                    {
                        "id": 17569,
                        "name": "Broye-Vully District",
                        "latitude": "46.78082000",
                        "longitude": "6.90161000"
                    },
                    {
                        "id": 17586,
                        "name": "Bussigny",
                        "latitude": "46.55110000",
                        "longitude": "6.55597000"
                    },
                    {
                        "id": 17616,
                        "name": "Caux",
                        "latitude": "46.43241000",
                        "longitude": "6.93855000"
                    },
                    {
                        "id": 17626,
                        "name": "Chardonne",
                        "latitude": "46.47676000",
                        "longitude": "6.82680000"
                    },
                    {
                        "id": 17640,
                        "name": "Château-d'Oex",
                        "latitude": "46.47455000",
                        "longitude": "7.13155000"
                    },
                    {
                        "id": 17629,
                        "name": "Chavannes",
                        "latitude": "46.53005000",
                        "longitude": "6.57068000"
                    },
                    {
                        "id": 17630,
                        "name": "Chavannes-le-Veyron",
                        "latitude": "46.60700000",
                        "longitude": "6.45086000"
                    },
                    {
                        "id": 17631,
                        "name": "Chavornay",
                        "latitude": "46.70244000",
                        "longitude": "6.56940000"
                    },
                    {
                        "id": 17633,
                        "name": "Cheseaux",
                        "latitude": "46.58624000",
                        "longitude": "6.60587000"
                    },
                    {
                        "id": 17634,
                        "name": "Chevilly",
                        "latitude": "46.64272000",
                        "longitude": "6.47661000"
                    },
                    {
                        "id": 17635,
                        "name": "Chexbres",
                        "latitude": "46.48208000",
                        "longitude": "6.77805000"
                    },
                    {
                        "id": 17647,
                        "name": "Colombier",
                        "latitude": "46.55709000",
                        "longitude": "6.47284000"
                    },
                    {
                        "id": 17652,
                        "name": "Coppet",
                        "latitude": "46.31682000",
                        "longitude": "6.19114000"
                    },
                    {
                        "id": 17658,
                        "name": "Cossonay",
                        "latitude": "46.61443000",
                        "longitude": "6.50631000"
                    },
                    {
                        "id": 17668,
                        "name": "Crissier",
                        "latitude": "46.54586000",
                        "longitude": "6.57567000"
                    },
                    {
                        "id": 17669,
                        "name": "Cuarnens",
                        "latitude": "46.62545000",
                        "longitude": "6.43713000"
                    },
                    {
                        "id": 17672,
                        "name": "Cully",
                        "latitude": "46.48892000",
                        "longitude": "6.72945000"
                    },
                    {
                        "id": 17721,
                        "name": "Echallens",
                        "latitude": "46.64130000",
                        "longitude": "6.63317000"
                    },
                    {
                        "id": 17722,
                        "name": "Ecublens",
                        "latitude": "46.52899000",
                        "longitude": "6.56261000"
                    },
                    {
                        "id": 17756,
                        "name": "Epalinges",
                        "latitude": "46.54896000",
                        "longitude": "6.66831000"
                    },
                    {
                        "id": 17785,
                        "name": "Ferreyres",
                        "latitude": "46.65804000",
                        "longitude": "6.48520000"
                    },
                    {
                        "id": 17800,
                        "name": "Founex",
                        "latitude": "46.33277000",
                        "longitude": "6.19243000"
                    },
                    {
                        "id": 17811,
                        "name": "Froideville",
                        "latitude": "46.60123000",
                        "longitude": "6.68085000"
                    },
                    {
                        "id": 17826,
                        "name": "Genolier",
                        "latitude": "46.43537000",
                        "longitude": "6.21809000"
                    },
                    {
                        "id": 17833,
                        "name": "Gimel",
                        "latitude": "46.50945000",
                        "longitude": "6.30736000"
                    },
                    {
                        "id": 17838,
                        "name": "Gland",
                        "latitude": "46.42082000",
                        "longitude": "6.27010000"
                    },
                    {
                        "id": 17860,
                        "name": "Grancy",
                        "latitude": "46.59214000",
                        "longitude": "6.46391000"
                    },
                    {
                        "id": 17862,
                        "name": "Grandson",
                        "latitude": "46.80946000",
                        "longitude": "6.64600000"
                    },
                    {
                        "id": 17872,
                        "name": "Gros-de-Vaud District",
                        "latitude": "46.65180000",
                        "longitude": "6.65728000"
                    },
                    {
                        "id": 17878,
                        "name": "Gryon",
                        "latitude": "46.27377000",
                        "longitude": "7.05975000"
                    },
                    {
                        "id": 17961,
                        "name": "Jongny",
                        "latitude": "46.47883000",
                        "longitude": "6.84114000"
                    },
                    {
                        "id": 17964,
                        "name": "Jura-Nord vaudois District",
                        "latitude": "46.72981000",
                        "longitude": "6.45429000"
                    },
                    {
                        "id": 18026,
                        "name": "La Sarraz",
                        "latitude": "46.65863000",
                        "longitude": "6.51077000"
                    },
                    {
                        "id": 18027,
                        "name": "La Tour-de-Peilz",
                        "latitude": "46.45312000",
                        "longitude": "6.85856000"
                    },
                    {
                        "id": 18048,
                        "name": "Lausanne",
                        "latitude": "46.51600000",
                        "longitude": "6.63282000"
                    },
                    {
                        "id": 18049,
                        "name": "Lausanne District",
                        "latitude": "46.52131000",
                        "longitude": "6.63334000"
                    },
                    {
                        "id": 18052,
                        "name": "Lavaux-Oron District",
                        "latitude": "46.53618000",
                        "longitude": "6.77086000"
                    },
                    {
                        "id": 18054,
                        "name": "Le Chenit",
                        "latitude": "46.60688000",
                        "longitude": "6.23062000"
                    },
                    {
                        "id": 18059,
                        "name": "Le Mont-sur-Lausanne",
                        "latitude": "46.55815000",
                        "longitude": "6.63145000"
                    },
                    {
                        "id": 18061,
                        "name": "Le Vaud",
                        "latitude": "46.47753000",
                        "longitude": "6.23603000"
                    },
                    {
                        "id": 18079,
                        "name": "Leysin",
                        "latitude": "46.34183000",
                        "longitude": "7.01151000"
                    },
                    {
                        "id": 18094,
                        "name": "Lucens",
                        "latitude": "46.70854000",
                        "longitude": "6.83931000"
                    },
                    {
                        "id": 18104,
                        "name": "Lutry",
                        "latitude": "46.50241000",
                        "longitude": "6.68647000"
                    },
                    {
                        "id": 18137,
                        "name": "Mauraz",
                        "latitude": "46.60558000",
                        "longitude": "6.42074000"
                    },
                    {
                        "id": 18161,
                        "name": "Mollens",
                        "latitude": "46.57760000",
                        "longitude": "6.36320000"
                    },
                    {
                        "id": 18164,
                        "name": "Montagny",
                        "latitude": "46.79289000",
                        "longitude": "6.61222000"
                    },
                    {
                        "id": 18169,
                        "name": "Montreux",
                        "latitude": "46.43301000",
                        "longitude": "6.91143000"
                    },
                    {
                        "id": 18171,
                        "name": "Morges",
                        "latitude": "46.51127000",
                        "longitude": "6.49854000"
                    },
                    {
                        "id": 18172,
                        "name": "Morges District",
                        "latitude": "46.53578000",
                        "longitude": "6.48662000"
                    },
                    {
                        "id": 18174,
                        "name": "Moudon",
                        "latitude": "46.66758000",
                        "longitude": "6.79781000"
                    },
                    {
                        "id": 18233,
                        "name": "Nyon",
                        "latitude": "46.38318000",
                        "longitude": "6.23955000"
                    },
                    {
                        "id": 18234,
                        "name": "Nyon District",
                        "latitude": "46.42004000",
                        "longitude": "6.22177000"
                    },
                    {
                        "id": 18282,
                        "name": "Ollon",
                        "latitude": "46.29524000",
                        "longitude": "6.99314000"
                    },
                    {
                        "id": 18286,
                        "name": "Orbe",
                        "latitude": "46.72504000",
                        "longitude": "6.53069000"
                    },
                    {
                        "id": 18288,
                        "name": "Oron-la-Ville",
                        "latitude": "46.57094000",
                        "longitude": "6.82557000"
                    },
                    {
                        "id": 18295,
                        "name": "Ouest Lausannois District",
                        "latitude": "46.54589000",
                        "longitude": "6.56995000"
                    },
                    {
                        "id": 18296,
                        "name": "Pailly",
                        "latitude": "46.70123000",
                        "longitude": "6.67540000"
                    },
                    {
                        "id": 18297,
                        "name": "Palézieux",
                        "latitude": "46.54191000",
                        "longitude": "6.83989000"
                    },
                    {
                        "id": 18298,
                        "name": "Pampigny",
                        "latitude": "46.58093000",
                        "longitude": "6.42941000"
                    },
                    {
                        "id": 18299,
                        "name": "Paudex",
                        "latitude": "46.50548000",
                        "longitude": "6.66819000"
                    },
                    {
                        "id": 18300,
                        "name": "Payerne",
                        "latitude": "46.82192000",
                        "longitude": "6.93817000"
                    },
                    {
                        "id": 18301,
                        "name": "Penthalaz",
                        "latitude": "46.61077000",
                        "longitude": "6.52519000"
                    },
                    {
                        "id": 18302,
                        "name": "Penthéréaz",
                        "latitude": "46.68171000",
                        "longitude": "6.60390000"
                    },
                    {
                        "id": 18303,
                        "name": "Perroy",
                        "latitude": "46.46690000",
                        "longitude": "6.35349000"
                    },
                    {
                        "id": 18317,
                        "name": "Pompaples",
                        "latitude": "46.66699000",
                        "longitude": "6.50966000"
                    },
                    {
                        "id": 18322,
                        "name": "Prangins",
                        "latitude": "46.39518000",
                        "longitude": "6.24960000"
                    },
                    {
                        "id": 18327,
                        "name": "Préverenges",
                        "latitude": "46.51854000",
                        "longitude": "6.52682000"
                    },
                    {
                        "id": 18326,
                        "name": "Prilly",
                        "latitude": "46.53698000",
                        "longitude": "6.60456000"
                    },
                    {
                        "id": 18328,
                        "name": "Puidoux",
                        "latitude": "46.50093000",
                        "longitude": "6.78249000"
                    },
                    {
                        "id": 18329,
                        "name": "Pully",
                        "latitude": "46.51027000",
                        "longitude": "6.66183000"
                    },
                    {
                        "id": 18364,
                        "name": "Renens",
                        "latitude": "46.53989000",
                        "longitude": "6.58810000"
                    },
                    {
                        "id": 18380,
                        "name": "Riviera-Pays-d'Enhaut District",
                        "latitude": "46.46459000",
                        "longitude": "6.88499000"
                    },
                    {
                        "id": 18386,
                        "name": "Rolle",
                        "latitude": "46.45820000",
                        "longitude": "6.33499000"
                    },
                    {
                        "id": 18387,
                        "name": "Romanel-sur-Lausanne",
                        "latitude": "46.56403000",
                        "longitude": "6.60538000"
                    },
                    {
                        "id": 18424,
                        "name": "Saint-Cergue",
                        "latitude": "46.44590000",
                        "longitude": "6.15737000"
                    },
                    {
                        "id": 18426,
                        "name": "Saint-Livres",
                        "latitude": "46.50794000",
                        "longitude": "6.38753000"
                    },
                    {
                        "id": 18430,
                        "name": "Saint-Prex",
                        "latitude": "46.47963000",
                        "longitude": "6.45992000"
                    },
                    {
                        "id": 18431,
                        "name": "Sainte-Croix",
                        "latitude": "46.82203000",
                        "longitude": "6.50283000"
                    },
                    {
                        "id": 18450,
                        "name": "Saubraz",
                        "latitude": "46.51606000",
                        "longitude": "6.33018000"
                    },
                    {
                        "id": 18451,
                        "name": "Savigny",
                        "latitude": "46.53844000",
                        "longitude": "6.73222000"
                    },
                    {
                        "id": 18531,
                        "name": "Sottens",
                        "latitude": "46.65521000",
                        "longitude": "6.74197000"
                    },
                    {
                        "id": 18611,
                        "name": "Trélex",
                        "latitude": "46.41538000",
                        "longitude": "6.20813000"
                    },
                    {
                        "id": 18659,
                        "name": "Vallorbe",
                        "latitude": "46.71256000",
                        "longitude": "6.37894000"
                    },
                    {
                        "id": 18673,
                        "name": "Vevey",
                        "latitude": "46.46299000",
                        "longitude": "6.84345000"
                    },
                    {
                        "id": 18680,
                        "name": "Villars-sur-Ollon",
                        "latitude": "46.29832000",
                        "longitude": "7.05631000"
                    },
                    {
                        "id": 18682,
                        "name": "Villeneuve",
                        "latitude": "46.39869000",
                        "longitude": "6.92654000"
                    },
                    {
                        "id": 18696,
                        "name": "Vuarrens",
                        "latitude": "46.68578000",
                        "longitude": "6.64793000"
                    },
                    {
                        "id": 18790,
                        "name": "Yverdon-les-Bains",
                        "latitude": "46.77852000",
                        "longitude": "6.64115000"
                    },
                    {
                        "id": 18791,
                        "name": "Yvonand",
                        "latitude": "46.80034000",
                        "longitude": "6.74249000"
                    }
                ]
            },
            {
                "id": 1646,
                "name": "Zug",
                "iso2": "ZG",
                "latitude": "47.16615050",
                "longitude": "8.51547490",
                "type": "canton",
                "cities": [
                    {
                        "id": 17428,
                        "name": "Baar",
                        "latitude": "47.19625000",
                        "longitude": "8.52954000"
                    },
                    {
                        "id": 17622,
                        "name": "Cham",
                        "latitude": "47.18213000",
                        "longitude": "8.46358000"
                    },
                    {
                        "id": 17944,
                        "name": "Hünenberg",
                        "latitude": "47.17536000",
                        "longitude": "8.42497000"
                    },
                    {
                        "id": 18152,
                        "name": "Menzingen",
                        "latitude": "47.17764000",
                        "longitude": "8.59215000"
                    },
                    {
                        "id": 18395,
                        "name": "Rotkreuz",
                        "latitude": "47.14283000",
                        "longitude": "8.43140000"
                    },
                    {
                        "id": 18554,
                        "name": "Steinhausen",
                        "latitude": "47.19510000",
                        "longitude": "8.48581000"
                    },
                    {
                        "id": 18638,
                        "name": "Unterägeri",
                        "latitude": "47.13645000",
                        "longitude": "8.58530000"
                    },
                    {
                        "id": 18708,
                        "name": "Walchwil",
                        "latitude": "47.10169000",
                        "longitude": "8.51693000"
                    },
                    {
                        "id": 18801,
                        "name": "Zug",
                        "latitude": "47.17242000",
                        "longitude": "8.51745000"
                    }
                ]
            },
            {
                "id": 1656,
                "name": "Zürich",
                "iso2": "ZH",
                "latitude": "47.35953600",
                "longitude": "8.63564520",
                "type": "canton",
                "cities": [
                    {
                        "id": 17364,
                        "name": "Adliswil",
                        "latitude": "47.30997000",
                        "longitude": "8.52462000"
                    },
                    {
                        "id": 17365,
                        "name": "Adliswil \/ Adliswil (Stadtkern)",
                        "latitude": "47.31128000",
                        "longitude": "8.52675000"
                    },
                    {
                        "id": 17366,
                        "name": "Adliswil \/ Hündli-Zopf",
                        "latitude": "47.31637000",
                        "longitude": "8.51888000"
                    },
                    {
                        "id": 17367,
                        "name": "Adliswil \/ Oberleimbach",
                        "latitude": "47.32020000",
                        "longitude": "8.51508000"
                    },
                    {
                        "id": 17368,
                        "name": "Adliswil \/ Sonnenberg",
                        "latitude": "47.30958000",
                        "longitude": "8.52055000"
                    },
                    {
                        "id": 17369,
                        "name": "Adliswil \/ Sood",
                        "latitude": "47.31870000",
                        "longitude": "8.52425000"
                    },
                    {
                        "id": 17370,
                        "name": "Adliswil \/ Tal",
                        "latitude": "47.31142000",
                        "longitude": "8.53446000"
                    },
                    {
                        "id": 17372,
                        "name": "Aesch",
                        "latitude": "47.32970000",
                        "longitude": "8.65410000"
                    },
                    {
                        "id": 17375,
                        "name": "Affoltern \/ Hasenbüel",
                        "latitude": "47.27324000",
                        "longitude": "8.45218000"
                    },
                    {
                        "id": 17376,
                        "name": "Affoltern \/ Oberdorf",
                        "latitude": "47.27852000",
                        "longitude": "8.45651000"
                    },
                    {
                        "id": 17377,
                        "name": "Affoltern \/ Sonnenberg",
                        "latitude": "47.28055000",
                        "longitude": "8.46008000"
                    },
                    {
                        "id": 17378,
                        "name": "Affoltern \/ Unterdorf",
                        "latitude": "47.28277000",
                        "longitude": "8.45409000"
                    },
                    {
                        "id": 17379,
                        "name": "Affoltern am Albis",
                        "latitude": "47.27743000",
                        "longitude": "8.45128000"
                    },
                    {
                        "id": 17396,
                        "name": "Andelfingen",
                        "latitude": "47.59447000",
                        "longitude": "8.67826000"
                    },
                    {
                        "id": 17418,
                        "name": "Au",
                        "latitude": "47.24185000",
                        "longitude": "8.64406000"
                    },
                    {
                        "id": 17420,
                        "name": "Au \/ Mittel-Dorf",
                        "latitude": "47.24303000",
                        "longitude": "8.64591000"
                    },
                    {
                        "id": 17421,
                        "name": "Au \/ Unter-Dorf",
                        "latitude": "47.24730000",
                        "longitude": "8.63270000"
                    },
                    {
                        "id": 17429,
                        "name": "Bachenbülach",
                        "latitude": "47.50317000",
                        "longitude": "8.54556000"
                    },
                    {
                        "id": 17591,
                        "name": "Bäretswil",
                        "latitude": "47.33709000",
                        "longitude": "8.85645000"
                    },
                    {
                        "id": 17443,
                        "name": "Bassersdorf",
                        "latitude": "47.44342000",
                        "longitude": "8.62851000"
                    },
                    {
                        "id": 17445,
                        "name": "Bauma",
                        "latitude": "47.36745000",
                        "longitude": "8.87905000"
                    },
                    {
                        "id": 17457,
                        "name": "Benglen",
                        "latitude": "47.36077000",
                        "longitude": "8.63687000"
                    },
                    {
                        "id": 17472,
                        "name": "Bezirk Affoltern",
                        "latitude": "47.27311000",
                        "longitude": "8.47444000"
                    },
                    {
                        "id": 17473,
                        "name": "Bezirk Andelfingen",
                        "latitude": "47.61328000",
                        "longitude": "8.68124000"
                    },
                    {
                        "id": 17479,
                        "name": "Bezirk Bülach",
                        "latitude": "47.49706000",
                        "longitude": "8.56764000"
                    },
                    {
                        "id": 17480,
                        "name": "Bezirk Dielsdorf",
                        "latitude": "47.47181000",
                        "longitude": "8.45631000"
                    },
                    {
                        "id": 17481,
                        "name": "Bezirk Dietikon",
                        "latitude": "47.38804000",
                        "longitude": "8.44260000"
                    },
                    {
                        "id": 17488,
                        "name": "Bezirk Hinwil",
                        "latitude": "47.29646000",
                        "longitude": "8.83431000"
                    },
                    {
                        "id": 17489,
                        "name": "Bezirk Horgen",
                        "latitude": "47.25767000",
                        "longitude": "8.59702000"
                    },
                    {
                        "id": 17499,
                        "name": "Bezirk Meilen",
                        "latitude": "47.27920000",
                        "longitude": "8.66259000"
                    },
                    {
                        "id": 17504,
                        "name": "Bezirk Pfäffikon",
                        "latitude": "47.40905000",
                        "longitude": "8.77208000"
                    },
                    {
                        "id": 17516,
                        "name": "Bezirk Uster",
                        "latitude": "47.34952000",
                        "longitude": "8.71353000"
                    },
                    {
                        "id": 17520,
                        "name": "Bezirk Winterthur",
                        "latitude": "47.50781000",
                        "longitude": "8.76900000"
                    },
                    {
                        "id": 17523,
                        "name": "Bezirk Zürich",
                        "latitude": "47.37110000",
                        "longitude": "8.54323000"
                    },
                    {
                        "id": 17531,
                        "name": "Binz",
                        "latitude": "47.35635000",
                        "longitude": "8.62657000"
                    },
                    {
                        "id": 17532,
                        "name": "Binzikon",
                        "latitude": "47.27632000",
                        "longitude": "8.75851000"
                    },
                    {
                        "id": 17534,
                        "name": "Birchwil",
                        "latitude": "47.45431000",
                        "longitude": "8.63477000"
                    },
                    {
                        "id": 17535,
                        "name": "Birmensdorf",
                        "latitude": "47.35515000",
                        "longitude": "8.44256000"
                    },
                    {
                        "id": 17550,
                        "name": "Bonstetten",
                        "latitude": "47.31505000",
                        "longitude": "8.46836000"
                    },
                    {
                        "id": 17573,
                        "name": "Brütten",
                        "latitude": "47.47318000",
                        "longitude": "8.67569000"
                    },
                    {
                        "id": 17574,
                        "name": "Brüttisellen",
                        "latitude": "47.42173000",
                        "longitude": "8.63263000"
                    },
                    {
                        "id": 17576,
                        "name": "Bubikon",
                        "latitude": "47.26698000",
                        "longitude": "8.81790000"
                    },
                    {
                        "id": 17598,
                        "name": "Bülach",
                        "latitude": "47.52197000",
                        "longitude": "8.54049000"
                    },
                    {
                        "id": 17599,
                        "name": "Bülach \/ Gstückt",
                        "latitude": "47.52337000",
                        "longitude": "8.54879000"
                    },
                    {
                        "id": 17600,
                        "name": "Bülach \/ Seematt",
                        "latitude": "47.51716000",
                        "longitude": "8.54651000"
                    },
                    {
                        "id": 17601,
                        "name": "Bülach \/ Soligänter",
                        "latitude": "47.52632000",
                        "longitude": "8.54106000"
                    },
                    {
                        "id": 17673,
                        "name": "Dachsen",
                        "latitude": "47.66515000",
                        "longitude": "8.61790000"
                    },
                    {
                        "id": 17706,
                        "name": "Dällikon \/ Dällikon (Dorf)",
                        "latitude": "47.43983000",
                        "longitude": "8.43813000"
                    },
                    {
                        "id": 17707,
                        "name": "Dänikon",
                        "latitude": "47.44674000",
                        "longitude": "8.40648000"
                    },
                    {
                        "id": 17685,
                        "name": "Dielsdorf",
                        "latitude": "47.48146000",
                        "longitude": "8.45850000"
                    },
                    {
                        "id": 17689,
                        "name": "Dietikon",
                        "latitude": "47.40165000",
                        "longitude": "8.40015000"
                    },
                    {
                        "id": 17690,
                        "name": "Dietikon \/ Almend",
                        "latitude": "47.40477000",
                        "longitude": "8.39168000"
                    },
                    {
                        "id": 17691,
                        "name": "Dietikon \/ Guggenbühl",
                        "latitude": "47.40009000",
                        "longitude": "8.40818000"
                    },
                    {
                        "id": 17692,
                        "name": "Dietikon \/ Hofacker",
                        "latitude": "47.39718000",
                        "longitude": "8.41609000"
                    },
                    {
                        "id": 17693,
                        "name": "Dietikon \/ Kreuzacker",
                        "latitude": "47.39919000",
                        "longitude": "8.40146000"
                    },
                    {
                        "id": 17694,
                        "name": "Dietikon \/ Oberdorf",
                        "latitude": "47.40065000",
                        "longitude": "8.39416000"
                    },
                    {
                        "id": 17695,
                        "name": "Dietikon \/ Schönenwerd",
                        "latitude": "47.39706000",
                        "longitude": "8.42576000"
                    },
                    {
                        "id": 17696,
                        "name": "Dietikon \/ Vorstadt",
                        "latitude": "47.40819000",
                        "longitude": "8.39719000"
                    },
                    {
                        "id": 17697,
                        "name": "Dietlikon \/ Dietlikon (Dorf)",
                        "latitude": "47.41827000",
                        "longitude": "8.61880000"
                    },
                    {
                        "id": 17698,
                        "name": "Dietlikon \/ Eichwiesen",
                        "latitude": "47.41910000",
                        "longitude": "8.62078000"
                    },
                    {
                        "id": 17703,
                        "name": "Dorf",
                        "latitude": "47.23900000",
                        "longitude": "8.73567000"
                    },
                    {
                        "id": 17709,
                        "name": "Dübendorf",
                        "latitude": "47.39724000",
                        "longitude": "8.61872000"
                    },
                    {
                        "id": 17710,
                        "name": "Dübendorf \/ Kunklerstrasse",
                        "latitude": "47.40109000",
                        "longitude": "8.62724000"
                    },
                    {
                        "id": 17711,
                        "name": "Dübendorf \/ Sonnenberg",
                        "latitude": "47.39469000",
                        "longitude": "8.63162000"
                    },
                    {
                        "id": 17712,
                        "name": "Dübendorf \/ Vogelquartier",
                        "latitude": "47.39502000",
                        "longitude": "8.61184000"
                    },
                    {
                        "id": 17713,
                        "name": "Dübendorf \/ Wasserfurren",
                        "latitude": "47.39352000",
                        "longitude": "8.60850000"
                    },
                    {
                        "id": 17715,
                        "name": "Dürnten",
                        "latitude": "47.27856000",
                        "longitude": "8.84156000"
                    },
                    {
                        "id": 17719,
                        "name": "Ebmatingen",
                        "latitude": "47.34987000",
                        "longitude": "8.64013000"
                    },
                    {
                        "id": 17724,
                        "name": "Effretikon",
                        "latitude": "47.42575000",
                        "longitude": "8.69094000"
                    },
                    {
                        "id": 17725,
                        "name": "Effretikon \/ Rappenhalde-Bannhalde",
                        "latitude": "47.42388000",
                        "longitude": "8.69653000"
                    },
                    {
                        "id": 17726,
                        "name": "Effretikon \/ Rikon",
                        "latitude": "47.43099000",
                        "longitude": "8.68624000"
                    },
                    {
                        "id": 17727,
                        "name": "Effretikon \/ Watt",
                        "latitude": "47.42797000",
                        "longitude": "8.69822000"
                    },
                    {
                        "id": 17729,
                        "name": "Egg",
                        "latitude": "47.29976000",
                        "longitude": "8.69032000"
                    },
                    {
                        "id": 17739,
                        "name": "Elgg",
                        "latitude": "47.49715000",
                        "longitude": "8.86523000"
                    },
                    {
                        "id": 17740,
                        "name": "Elgg \/ Städtchen und Umgebung",
                        "latitude": "47.49265000",
                        "longitude": "8.86680000"
                    },
                    {
                        "id": 17741,
                        "name": "Elsau-Räterschen",
                        "latitude": "47.50238000",
                        "longitude": "8.79874000"
                    },
                    {
                        "id": 17742,
                        "name": "Elsau-Räterschen \/ Räterschen",
                        "latitude": "47.49927000",
                        "longitude": "8.79600000"
                    },
                    {
                        "id": 17743,
                        "name": "Embrach",
                        "latitude": "47.50561000",
                        "longitude": "8.59406000"
                    },
                    {
                        "id": 17744,
                        "name": "Embrach \/ Embrach (Dorfkern)",
                        "latitude": "47.50400000",
                        "longitude": "8.59477000"
                    },
                    {
                        "id": 17745,
                        "name": "Embrach \/ Kellersacker",
                        "latitude": "47.51455000",
                        "longitude": "8.59146000"
                    },
                    {
                        "id": 17761,
                        "name": "Erlenbach",
                        "latitude": "47.30298000",
                        "longitude": "8.59743000"
                    },
                    {
                        "id": 17762,
                        "name": "Erlenbach \/ links des Dorfbachs oberhalb Bahnlinie",
                        "latitude": "47.29950000",
                        "longitude": "8.60188000"
                    },
                    {
                        "id": 17763,
                        "name": "Erlenbach \/ rechts des Dorfbachs oberhalb Bahnlinie",
                        "latitude": "47.30658000",
                        "longitude": "8.60271000"
                    },
                    {
                        "id": 17773,
                        "name": "Esslingen",
                        "latitude": "47.28325000",
                        "longitude": "8.71038000"
                    },
                    {
                        "id": 17816,
                        "name": "Fällanden",
                        "latitude": "47.37169000",
                        "longitude": "8.63869000"
                    },
                    {
                        "id": 17781,
                        "name": "Fehraltorf",
                        "latitude": "47.38775000",
                        "longitude": "8.75149000"
                    },
                    {
                        "id": 17782,
                        "name": "Feldmeilen",
                        "latitude": "47.27873000",
                        "longitude": "8.62165000"
                    },
                    {
                        "id": 17786,
                        "name": "Feuerthalen",
                        "latitude": "47.69054000",
                        "longitude": "8.64357000"
                    },
                    {
                        "id": 17795,
                        "name": "Flurlingen",
                        "latitude": "47.68390000",
                        "longitude": "8.62995000"
                    },
                    {
                        "id": 17807,
                        "name": "Freienstein",
                        "latitude": "47.53307000",
                        "longitude": "8.58455000"
                    },
                    {
                        "id": 17823,
                        "name": "Gattikon",
                        "latitude": "47.28439000",
                        "longitude": "8.54830000"
                    },
                    {
                        "id": 17829,
                        "name": "Geroldswil",
                        "latitude": "47.42213000",
                        "longitude": "8.41085000"
                    },
                    {
                        "id": 17840,
                        "name": "Glattbrugg",
                        "latitude": "47.43130000",
                        "longitude": "8.56272000"
                    },
                    {
                        "id": 17841,
                        "name": "Glattbrugg \/ Rohr\/Platten-Balsberg",
                        "latitude": "47.43721000",
                        "longitude": "8.56642000"
                    },
                    {
                        "id": 17842,
                        "name": "Glattbrugg \/ Wydacker\/Bettacker\/Lättenwiesen",
                        "latitude": "47.42908000",
                        "longitude": "8.56657000"
                    },
                    {
                        "id": 17843,
                        "name": "Glattfelden",
                        "latitude": "47.55871000",
                        "longitude": "8.50167000"
                    },
                    {
                        "id": 17846,
                        "name": "Gockhausen",
                        "latitude": "47.38098000",
                        "longitude": "8.59978000"
                    },
                    {
                        "id": 17857,
                        "name": "Gossau",
                        "latitude": "47.30510000",
                        "longitude": "8.75831000"
                    },
                    {
                        "id": 17864,
                        "name": "Greifensee",
                        "latitude": "47.36717000",
                        "longitude": "8.68115000"
                    },
                    {
                        "id": 17865,
                        "name": "Greifensee \/ Müllerwis \/ Seilerwis",
                        "latitude": "47.37042000",
                        "longitude": "8.68151000"
                    },
                    {
                        "id": 17866,
                        "name": "Greifensee \/ Pfisterhölzli",
                        "latitude": "47.36430000",
                        "longitude": "8.68979000"
                    },
                    {
                        "id": 17873,
                        "name": "Grossacker\/Opfikon",
                        "latitude": "47.42696000",
                        "longitude": "8.57886000"
                    },
                    {
                        "id": 17883,
                        "name": "Grüt",
                        "latitude": "47.31151000",
                        "longitude": "8.78339000"
                    },
                    {
                        "id": 17888,
                        "name": "Gutenswil",
                        "latitude": "47.38387000",
                        "longitude": "8.71763000"
                    },
                    {
                        "id": 17891,
                        "name": "Hadlikon",
                        "latitude": "47.28750000",
                        "longitude": "8.85719000"
                    },
                    {
                        "id": 17896,
                        "name": "Hausen am Albis \/ Hausen (Dorf)",
                        "latitude": "47.24496000",
                        "longitude": "8.53299000"
                    },
                    {
                        "id": 17897,
                        "name": "Hedingen",
                        "latitude": "47.29794000",
                        "longitude": "8.44833000"
                    },
                    {
                        "id": 17898,
                        "name": "Hegnau",
                        "latitude": "47.39227000",
                        "longitude": "8.66988000"
                    },
                    {
                        "id": 17899,
                        "name": "Hegnau \/ Dammboden-Grindel",
                        "latitude": "47.38713000",
                        "longitude": "8.66657000"
                    },
                    {
                        "id": 17900,
                        "name": "Hegnau \/ Sunnebüel-Eich",
                        "latitude": "47.39246000",
                        "longitude": "8.67910000"
                    },
                    {
                        "id": 17905,
                        "name": "Henggart",
                        "latitude": "47.56272000",
                        "longitude": "8.68215000"
                    },
                    {
                        "id": 17909,
                        "name": "Herrliberg",
                        "latitude": "47.29064000",
                        "longitude": "8.61464000"
                    },
                    {
                        "id": 17911,
                        "name": "Hettlingen",
                        "latitude": "47.54610000",
                        "longitude": "8.70532000"
                    },
                    {
                        "id": 17916,
                        "name": "Hinteregg",
                        "latitude": "47.30736000",
                        "longitude": "8.68339000"
                    },
                    {
                        "id": 17918,
                        "name": "Hinwil",
                        "latitude": "47.29426000",
                        "longitude": "8.84393000"
                    },
                    {
                        "id": 17919,
                        "name": "Hittnau \/ Hittnau (Dorf)",
                        "latitude": "47.36334000",
                        "longitude": "8.82418000"
                    },
                    {
                        "id": 17923,
                        "name": "Hochfelden",
                        "latitude": "47.52262000",
                        "longitude": "8.51564000"
                    },
                    {
                        "id": 17925,
                        "name": "Hofstetten",
                        "latitude": "47.47778000",
                        "longitude": "8.50646000"
                    },
                    {
                        "id": 17927,
                        "name": "Hombrechtikon",
                        "latitude": "47.25298000",
                        "longitude": "8.77212000"
                    },
                    {
                        "id": 17929,
                        "name": "Horgen",
                        "latitude": "47.25983000",
                        "longitude": "8.59778000"
                    },
                    {
                        "id": 17930,
                        "name": "Horgen \/ Allmend",
                        "latitude": "47.24729000",
                        "longitude": "8.60660000"
                    },
                    {
                        "id": 17931,
                        "name": "Horgen \/ Horgen (Dorfkern)",
                        "latitude": "47.25604000",
                        "longitude": "8.60159000"
                    },
                    {
                        "id": 17932,
                        "name": "Horgen \/ Oberdorf",
                        "latitude": "47.25837000",
                        "longitude": "8.59013000"
                    },
                    {
                        "id": 17933,
                        "name": "Horgen \/ Scheller-Stockerstrasse",
                        "latitude": "47.26584000",
                        "longitude": "8.58760000"
                    },
                    {
                        "id": 17943,
                        "name": "Höri",
                        "latitude": "47.50799000",
                        "longitude": "8.51203000"
                    },
                    {
                        "id": 17949,
                        "name": "Illnau",
                        "latitude": "47.41130000",
                        "longitude": "8.72125000"
                    },
                    {
                        "id": 17950,
                        "name": "Illnau \/ Unter-Illnau",
                        "latitude": "47.40787000",
                        "longitude": "8.72607000"
                    },
                    {
                        "id": 17975,
                        "name": "Kilchberg",
                        "latitude": "47.32438000",
                        "longitude": "8.54548000"
                    },
                    {
                        "id": 17976,
                        "name": "Kilchberg \/ Bächler-Stocken",
                        "latitude": "47.32728000",
                        "longitude": "8.53957000"
                    },
                    {
                        "id": 17977,
                        "name": "Kilchberg \/ Kilchberg (Dorfkern)",
                        "latitude": "47.32012000",
                        "longitude": "8.54306000"
                    },
                    {
                        "id": 17979,
                        "name": "Kindhausen \/ Kindhausen (Dorf)",
                        "latitude": "47.40644000",
                        "longitude": "8.68296000"
                    },
                    {
                        "id": 17983,
                        "name": "Kleinandelfingen",
                        "latitude": "47.60058000",
                        "longitude": "8.68362000"
                    },
                    {
                        "id": 17987,
                        "name": "Kloten",
                        "latitude": "47.45152000",
                        "longitude": "8.58491000"
                    },
                    {
                        "id": 17988,
                        "name": "Kloten \/ Balsberg",
                        "latitude": "47.44233000",
                        "longitude": "8.57496000"
                    },
                    {
                        "id": 17989,
                        "name": "Kloten \/ Freienberg (Chanzler-Chlini Chaseren)",
                        "latitude": "47.46584000",
                        "longitude": "8.58145000"
                    },
                    {
                        "id": 17990,
                        "name": "Kloten \/ Geissberg",
                        "latitude": "47.45424000",
                        "longitude": "8.59066000"
                    },
                    {
                        "id": 17991,
                        "name": "Kloten \/ Holberg",
                        "latitude": "47.44642000",
                        "longitude": "8.57661000"
                    },
                    {
                        "id": 17992,
                        "name": "Kloten \/ Horainli",
                        "latitude": "47.45399000",
                        "longitude": "8.58306000"
                    },
                    {
                        "id": 17993,
                        "name": "Kloten \/ Hostrass",
                        "latitude": "47.45255000",
                        "longitude": "8.59464000"
                    },
                    {
                        "id": 17994,
                        "name": "Kloten \/ Kloten (Zentrum)",
                        "latitude": "47.45134000",
                        "longitude": "8.58683000"
                    },
                    {
                        "id": 17995,
                        "name": "Kloten \/ Rütlen",
                        "latitude": "47.44726000",
                        "longitude": "8.58808000"
                    },
                    {
                        "id": 17996,
                        "name": "Kloten \/ Spitz",
                        "latitude": "47.44455000",
                        "longitude": "8.58724000"
                    },
                    {
                        "id": 17997,
                        "name": "Knonau",
                        "latitude": "47.22350000",
                        "longitude": "8.46197000"
                    },
                    {
                        "id": 18000,
                        "name": "Kollbrunn",
                        "latitude": "47.45793000",
                        "longitude": "8.78295000"
                    },
                    {
                        "id": 18001,
                        "name": "Kollbrunn \/ Kollbrunn (Dorfkern)",
                        "latitude": "47.45748000",
                        "longitude": "8.77413000"
                    },
                    {
                        "id": 18013,
                        "name": "Küsnacht",
                        "latitude": "47.31805000",
                        "longitude": "8.58401000"
                    },
                    {
                        "id": 18014,
                        "name": "Küsnacht \/ Dorf",
                        "latitude": "47.31783000",
                        "longitude": "8.58303000"
                    },
                    {
                        "id": 18015,
                        "name": "Küsnacht \/ Goldbach",
                        "latitude": "47.32729000",
                        "longitude": "8.58077000"
                    },
                    {
                        "id": 18016,
                        "name": "Küsnacht \/ Heslibach",
                        "latitude": "47.31307000",
                        "longitude": "8.58849000"
                    },
                    {
                        "id": 18017,
                        "name": "Küsnacht \/ Itschnach",
                        "latitude": "47.32714000",
                        "longitude": "8.60068000"
                    },
                    {
                        "id": 18018,
                        "name": "Küsnacht \/ Schiedhalden",
                        "latitude": "47.32112000",
                        "longitude": "8.58881000"
                    },
                    {
                        "id": 18038,
                        "name": "Langnau \/ Langnau (Dorf)",
                        "latitude": "47.28643000",
                        "longitude": "8.53627000"
                    },
                    {
                        "id": 18039,
                        "name": "Langnau \/ Vitaquartier",
                        "latitude": "47.29377000",
                        "longitude": "8.53758000"
                    },
                    {
                        "id": 18040,
                        "name": "Langnau am Albis",
                        "latitude": "47.28885000",
                        "longitude": "8.54110000"
                    },
                    {
                        "id": 18186,
                        "name": "Männedorf",
                        "latitude": "47.25686000",
                        "longitude": "8.69893000"
                    },
                    {
                        "id": 18187,
                        "name": "Männedorf \/ Ausserfeld",
                        "latitude": "47.24636000",
                        "longitude": "8.70608000"
                    },
                    {
                        "id": 18188,
                        "name": "Männedorf \/ Dorfkern",
                        "latitude": "47.25612000",
                        "longitude": "8.69161000"
                    },
                    {
                        "id": 18124,
                        "name": "Marthalen",
                        "latitude": "47.62913000",
                        "longitude": "8.65326000"
                    },
                    {
                        "id": 18130,
                        "name": "Mattenbach (Kreis 7)",
                        "latitude": "47.48705000",
                        "longitude": "8.74681000"
                    },
                    {
                        "id": 18131,
                        "name": "Mattenbach (Kreis 7) \/ Deutweg",
                        "latitude": "47.49419000",
                        "longitude": "8.73948000"
                    },
                    {
                        "id": 18132,
                        "name": "Mattenbach (Kreis 7) \/ Endliker",
                        "latitude": "47.48821000",
                        "longitude": "8.74938000"
                    },
                    {
                        "id": 18133,
                        "name": "Mattenbach (Kreis 7) \/ Gutschick",
                        "latitude": "47.49104000",
                        "longitude": "8.75258000"
                    },
                    {
                        "id": 18140,
                        "name": "Meilen",
                        "latitude": "47.27232000",
                        "longitude": "8.64617000"
                    },
                    {
                        "id": 18157,
                        "name": "Mettmenstetten",
                        "latitude": "47.24529000",
                        "longitude": "8.46347000"
                    },
                    {
                        "id": 18192,
                        "name": "Mönchaltorf",
                        "latitude": "47.30958000",
                        "longitude": "8.72029000"
                    },
                    {
                        "id": 18193,
                        "name": "Mönchaltorf \/ Dorf",
                        "latitude": "47.30401000",
                        "longitude": "8.72211000"
                    },
                    {
                        "id": 18196,
                        "name": "Mühlehalde",
                        "latitude": "47.28306000",
                        "longitude": "8.53386000"
                    },
                    {
                        "id": 18236,
                        "name": "Nänikon",
                        "latitude": "47.36975000",
                        "longitude": "8.68894000"
                    },
                    {
                        "id": 18237,
                        "name": "Nänikon \/ Nänikon (Dorfkern)",
                        "latitude": "47.37099000",
                        "longitude": "8.69254000"
                    },
                    {
                        "id": 18209,
                        "name": "Neerach",
                        "latitude": "47.51096000",
                        "longitude": "8.47099000"
                    },
                    {
                        "id": 18210,
                        "name": "Neftenbach \/ Dorf Neftenbach",
                        "latitude": "47.52764000",
                        "longitude": "8.66490000"
                    },
                    {
                        "id": 18222,
                        "name": "Niederglatt",
                        "latitude": "47.49066000",
                        "longitude": "8.49987000"
                    },
                    {
                        "id": 18223,
                        "name": "Niederglatt \/ Niederglatt (Dorfkern)",
                        "latitude": "47.49065000",
                        "longitude": "8.50048000"
                    },
                    {
                        "id": 18225,
                        "name": "Niederhasli",
                        "latitude": "47.48012000",
                        "longitude": "8.48576000"
                    },
                    {
                        "id": 18238,
                        "name": "Nürensdorf",
                        "latitude": "47.44814000",
                        "longitude": "8.64908000"
                    },
                    {
                        "id": 18246,
                        "name": "Oberengstringen",
                        "latitude": "47.40841000",
                        "longitude": "8.46515000"
                    },
                    {
                        "id": 18247,
                        "name": "Oberengstringen \/ Rauchacher",
                        "latitude": "47.40919000",
                        "longitude": "8.45627000"
                    },
                    {
                        "id": 18248,
                        "name": "Oberengstringen \/ Sonnenberg",
                        "latitude": "47.41211000",
                        "longitude": "8.46055000"
                    },
                    {
                        "id": 18249,
                        "name": "Oberengstringen \/ Zentrum",
                        "latitude": "47.40711000",
                        "longitude": "8.46276000"
                    },
                    {
                        "id": 18251,
                        "name": "Oberglatt",
                        "latitude": "47.47576000",
                        "longitude": "8.51896000"
                    },
                    {
                        "id": 18252,
                        "name": "Oberglatt \/ Bahnhofquartier",
                        "latitude": "47.47143000",
                        "longitude": "8.51289000"
                    },
                    {
                        "id": 18253,
                        "name": "Oberglatt \/ Oberglatt (Dorfkern)",
                        "latitude": "47.47596000",
                        "longitude": "8.51929000"
                    },
                    {
                        "id": 18258,
                        "name": "Obermeilen",
                        "latitude": "47.26574000",
                        "longitude": "8.65567000"
                    },
                    {
                        "id": 18259,
                        "name": "Oberrieden",
                        "latitude": "47.27444000",
                        "longitude": "8.57838000"
                    },
                    {
                        "id": 18260,
                        "name": "Oberrieden \/ Berg",
                        "latitude": "47.27628000",
                        "longitude": "8.57257000"
                    },
                    {
                        "id": 18261,
                        "name": "Oberrieden \/ Mitte",
                        "latitude": "47.27242000",
                        "longitude": "8.58021000"
                    },
                    {
                        "id": 18271,
                        "name": "Oberwinterthur (Kreis 2)",
                        "latitude": "47.51692000",
                        "longitude": "8.76863000"
                    },
                    {
                        "id": 18272,
                        "name": "Oberwinterthur (Kreis 2) \/ Guggenbühl",
                        "latitude": "47.51339000",
                        "longitude": "8.75998000"
                    },
                    {
                        "id": 18273,
                        "name": "Oberwinterthur (Kreis 2) \/ Hegi",
                        "latitude": "47.50716000",
                        "longitude": "8.77057000"
                    },
                    {
                        "id": 18274,
                        "name": "Oberwinterthur (Kreis 2) \/ Talacker",
                        "latitude": "47.50596000",
                        "longitude": "8.75150000"
                    },
                    {
                        "id": 18275,
                        "name": "Oberwinterthur (Kreis 2) \/ Zinzikon",
                        "latitude": "47.51950000",
                        "longitude": "8.75640000"
                    },
                    {
                        "id": 18276,
                        "name": "Obfelden",
                        "latitude": "47.26413000",
                        "longitude": "8.42150000"
                    },
                    {
                        "id": 18277,
                        "name": "Obfelden \/ Oberlunnern",
                        "latitude": "47.26197000",
                        "longitude": "8.41588000"
                    },
                    {
                        "id": 18278,
                        "name": "Obfelden \/ Toussen",
                        "latitude": "47.26574000",
                        "longitude": "8.43013000"
                    },
                    {
                        "id": 18280,
                        "name": "Oetwil",
                        "latitude": "47.27049000",
                        "longitude": "8.72023000"
                    },
                    {
                        "id": 18285,
                        "name": "Opfikon",
                        "latitude": "47.43169000",
                        "longitude": "8.57588000"
                    },
                    {
                        "id": 18292,
                        "name": "Otelfingen",
                        "latitude": "47.46053000",
                        "longitude": "8.39141000"
                    },
                    {
                        "id": 18294,
                        "name": "Ottenbach",
                        "latitude": "47.28228000",
                        "longitude": "8.40432000"
                    },
                    {
                        "id": 18305,
                        "name": "Pfaffhausen",
                        "latitude": "47.36476000",
                        "longitude": "8.62375000"
                    },
                    {
                        "id": 18311,
                        "name": "Pfäffikon",
                        "latitude": "47.36453000",
                        "longitude": "8.79202000"
                    },
                    {
                        "id": 18312,
                        "name": "Pfäffikon \/ Irgenhausen",
                        "latitude": "47.36240000",
                        "longitude": "8.79265000"
                    },
                    {
                        "id": 18313,
                        "name": "Pfäffikon \/ Pfäffikon (Dorfkern)",
                        "latitude": "47.36943000",
                        "longitude": "8.78309000"
                    },
                    {
                        "id": 18308,
                        "name": "Pfungen",
                        "latitude": "47.51394000",
                        "longitude": "8.64230000"
                    },
                    {
                        "id": 18335,
                        "name": "Rafz",
                        "latitude": "47.60438000",
                        "longitude": "8.54305000"
                    },
                    {
                        "id": 18344,
                        "name": "Regensdorf",
                        "latitude": "47.43410000",
                        "longitude": "8.46874000"
                    },
                    {
                        "id": 18345,
                        "name": "Regensdorf \/ Feldblumen-Riedthofstrasse",
                        "latitude": "47.43618000",
                        "longitude": "8.46659000"
                    },
                    {
                        "id": 18346,
                        "name": "Regensdorf \/ Hofacher-Geeren",
                        "latitude": "47.43525000",
                        "longitude": "8.46240000"
                    },
                    {
                        "id": 18347,
                        "name": "Regensdorf \/ Obstgarten",
                        "latitude": "47.42772000",
                        "longitude": "8.46566000"
                    },
                    {
                        "id": 18369,
                        "name": "Richterswil",
                        "latitude": "47.20622000",
                        "longitude": "8.69686000"
                    },
                    {
                        "id": 18370,
                        "name": "Richterswil \/ Burghalde",
                        "latitude": "47.20973000",
                        "longitude": "8.69133000"
                    },
                    {
                        "id": 18371,
                        "name": "Richterswil \/ Dorfkern",
                        "latitude": "47.20715000",
                        "longitude": "8.70607000"
                    },
                    {
                        "id": 18372,
                        "name": "Richterswil \/ Richterswil (Dorfkern)",
                        "latitude": "47.20323000",
                        "longitude": "8.70516000"
                    },
                    {
                        "id": 18391,
                        "name": "Rorbas",
                        "latitude": "47.53092000",
                        "longitude": "8.57555000"
                    },
                    {
                        "id": 18406,
                        "name": "Rümlang",
                        "latitude": "47.45041000",
                        "longitude": "8.52993000"
                    },
                    {
                        "id": 18407,
                        "name": "Rümlang \/ Rümlang (Dorfkern)",
                        "latitude": "47.44940000",
                        "longitude": "8.53255000"
                    },
                    {
                        "id": 18409,
                        "name": "Rüschlikon",
                        "latitude": "47.30688000",
                        "longitude": "8.55135000"
                    },
                    {
                        "id": 18400,
                        "name": "Russikon",
                        "latitude": "47.39669000",
                        "longitude": "8.77515000"
                    },
                    {
                        "id": 18411,
                        "name": "Rüti",
                        "latitude": "47.25603000",
                        "longitude": "8.85552000"
                    },
                    {
                        "id": 18412,
                        "name": "Rüti \/ Dorfzentrum Südl. Teil",
                        "latitude": "47.25368000",
                        "longitude": "8.85654000"
                    },
                    {
                        "id": 18413,
                        "name": "Rüti \/ Oberdorf",
                        "latitude": "47.25894000",
                        "longitude": "8.86512000"
                    },
                    {
                        "id": 18414,
                        "name": "Rüti \/ Westlicher Dorfteil",
                        "latitude": "47.25548000",
                        "longitude": "8.84490000"
                    },
                    {
                        "id": 18436,
                        "name": "Samstagern",
                        "latitude": "47.19167000",
                        "longitude": "8.68196000"
                    },
                    {
                        "id": 18454,
                        "name": "Schachen",
                        "latitude": "47.32419000",
                        "longitude": "8.47251000"
                    },
                    {
                        "id": 18465,
                        "name": "Schlieren",
                        "latitude": "47.39668000",
                        "longitude": "8.44763000"
                    },
                    {
                        "id": 18466,
                        "name": "Schlieren \/ Boden",
                        "latitude": "47.39721000",
                        "longitude": "8.45734000"
                    },
                    {
                        "id": 18467,
                        "name": "Schlieren \/ Engstingerquartier",
                        "latitude": "47.40338000",
                        "longitude": "8.44352000"
                    },
                    {
                        "id": 18468,
                        "name": "Schlieren \/ Freiestrasse",
                        "latitude": "47.39598000",
                        "longitude": "8.44202000"
                    },
                    {
                        "id": 18469,
                        "name": "Schlieren \/ Kamp",
                        "latitude": "47.39358000",
                        "longitude": "8.44453000"
                    },
                    {
                        "id": 18470,
                        "name": "Schlieren \/ Spital",
                        "latitude": "47.39489000",
                        "longitude": "8.43027000"
                    },
                    {
                        "id": 18471,
                        "name": "Schlieren \/ Zentrum",
                        "latitude": "47.39779000",
                        "longitude": "8.44770000"
                    },
                    {
                        "id": 18478,
                        "name": "Schwerzenbach",
                        "latitude": "47.38213000",
                        "longitude": "8.65727000"
                    },
                    {
                        "id": 18479,
                        "name": "Schwerzenbach \/ Blatten",
                        "latitude": "47.38308000",
                        "longitude": "8.64954000"
                    },
                    {
                        "id": 18480,
                        "name": "Schwerzenbach \/ Chimli",
                        "latitude": "47.38592000",
                        "longitude": "8.65888000"
                    },
                    {
                        "id": 18495,
                        "name": "Seen (Kreis 3)",
                        "latitude": "47.47646000",
                        "longitude": "8.76996000"
                    },
                    {
                        "id": 18496,
                        "name": "Seen (Kreis 3) \/ Büelwiesen",
                        "latitude": "47.48446000",
                        "longitude": "8.76517000"
                    },
                    {
                        "id": 18497,
                        "name": "Seen (Kreis 3) \/ Ganzenbühl",
                        "latitude": "47.48100000",
                        "longitude": "8.76249000"
                    },
                    {
                        "id": 18498,
                        "name": "Seen (Kreis 3) \/ Oberseen",
                        "latitude": "47.48205000",
                        "longitude": "8.77289000"
                    },
                    {
                        "id": 18499,
                        "name": "Seen (Kreis 3) \/ Waldegg",
                        "latitude": "47.48393000",
                        "longitude": "8.75586000"
                    },
                    {
                        "id": 18500,
                        "name": "Seen (Kreis 3) \/ Waser",
                        "latitude": "47.48913000",
                        "longitude": "8.76034000"
                    },
                    {
                        "id": 18503,
                        "name": "Seglingen",
                        "latitude": "47.57244000",
                        "longitude": "8.52093000"
                    },
                    {
                        "id": 18504,
                        "name": "Sellenbüren",
                        "latitude": "47.34361000",
                        "longitude": "8.48301000"
                    },
                    {
                        "id": 18512,
                        "name": "Seuzach \/ Seuzach (Dorf)",
                        "latitude": "47.53545000",
                        "longitude": "8.73728000"
                    },
                    {
                        "id": 18513,
                        "name": "Seuzach Dorf",
                        "latitude": "47.53560000",
                        "longitude": "8.73209000"
                    },
                    {
                        "id": 18514,
                        "name": "Seuzach Dorf \/ Breite-Weid",
                        "latitude": "47.53345000",
                        "longitude": "8.73415000"
                    },
                    {
                        "id": 18529,
                        "name": "Sonnhalde",
                        "latitude": "47.45329000",
                        "longitude": "8.46091000"
                    },
                    {
                        "id": 18537,
                        "name": "Stadt Winterthur (Kreis 1)",
                        "latitude": "47.49494000",
                        "longitude": "8.71954000"
                    },
                    {
                        "id": 18538,
                        "name": "Stadt Winterthur (Kreis 1) \/ Altstadt",
                        "latitude": "47.49951000",
                        "longitude": "8.72872000"
                    },
                    {
                        "id": 18539,
                        "name": "Stadt Winterthur (Kreis 1) \/ Brühlberg",
                        "latitude": "47.49764000",
                        "longitude": "8.71272000"
                    },
                    {
                        "id": 18540,
                        "name": "Stadt Winterthur (Kreis 1) \/ Heiligberg",
                        "latitude": "47.49409000",
                        "longitude": "8.72334000"
                    },
                    {
                        "id": 18541,
                        "name": "Stadt Winterthur (Kreis 1) \/ Lind",
                        "latitude": "47.50571000",
                        "longitude": "8.73372000"
                    },
                    {
                        "id": 18542,
                        "name": "Stadt Winterthur (Kreis 1) \/ Neuwiesen",
                        "latitude": "47.50207000",
                        "longitude": "8.71625000"
                    },
                    {
                        "id": 18543,
                        "name": "Stadt Winterthur (Kreis 1) \/ Tössfeld",
                        "latitude": "47.49340000",
                        "longitude": "8.71512000"
                    },
                    {
                        "id": 18560,
                        "name": "Stäfa",
                        "latitude": "47.24254000",
                        "longitude": "8.72342000"
                    },
                    {
                        "id": 18555,
                        "name": "Steinmaur",
                        "latitude": "47.49710000",
                        "longitude": "8.45216000"
                    },
                    {
                        "id": 18565,
                        "name": "Sulz",
                        "latitude": "47.53954000",
                        "longitude": "8.78887000"
                    },
                    {
                        "id": 18571,
                        "name": "Tagelswangen",
                        "latitude": "47.43070000",
                        "longitude": "8.67284000"
                    },
                    {
                        "id": 18574,
                        "name": "Tann",
                        "latitude": "47.26898000",
                        "longitude": "8.85024000"
                    },
                    {
                        "id": 18575,
                        "name": "Tann \/ Tann (Dorfkern)",
                        "latitude": "47.26494000",
                        "longitude": "8.85048000"
                    },
                    {
                        "id": 18582,
                        "name": "Thalwil",
                        "latitude": "47.29175000",
                        "longitude": "8.56351000"
                    },
                    {
                        "id": 18583,
                        "name": "Thalwil \/ Berg",
                        "latitude": "47.29178000",
                        "longitude": "8.55602000"
                    },
                    {
                        "id": 18584,
                        "name": "Thalwil \/ Dorfkern",
                        "latitude": "47.29047000",
                        "longitude": "8.56633000"
                    },
                    {
                        "id": 18585,
                        "name": "Thalwil \/ Nord",
                        "latitude": "47.29748000",
                        "longitude": "8.55634000"
                    },
                    {
                        "id": 18586,
                        "name": "Thalwil \/ See",
                        "latitude": "47.29409000",
                        "longitude": "8.56929000"
                    },
                    {
                        "id": 18587,
                        "name": "Thalwil \/ Süd",
                        "latitude": "47.28495000",
                        "longitude": "8.56954000"
                    },
                    {
                        "id": 18618,
                        "name": "Töss (Kreis 4)",
                        "latitude": "47.47890000",
                        "longitude": "8.70215000"
                    },
                    {
                        "id": 18619,
                        "name": "Töss (Kreis 4) \/ Eichliacker",
                        "latitude": "47.48727000",
                        "longitude": "8.70740000"
                    },
                    {
                        "id": 18620,
                        "name": "Töss (Kreis 4) \/ Schlosstal",
                        "latitude": "47.49279000",
                        "longitude": "8.70223000"
                    },
                    {
                        "id": 18621,
                        "name": "Töss (Kreis 4) \/ Vorder-Dättnau",
                        "latitude": "47.48135000",
                        "longitude": "8.69855000"
                    },
                    {
                        "id": 18613,
                        "name": "Turbenthal",
                        "latitude": "47.43633000",
                        "longitude": "8.84629000"
                    },
                    {
                        "id": 18624,
                        "name": "Uerikon",
                        "latitude": "47.23672000",
                        "longitude": "8.75730000"
                    },
                    {
                        "id": 18627,
                        "name": "Uetikon",
                        "latitude": "47.26441000",
                        "longitude": "8.67925000"
                    },
                    {
                        "id": 18628,
                        "name": "Uetikon \/ Grossdorf",
                        "latitude": "47.26654000",
                        "longitude": "8.67765000"
                    },
                    {
                        "id": 18629,
                        "name": "Uhwiesen",
                        "latitude": "47.67074000",
                        "longitude": "8.63542000"
                    },
                    {
                        "id": 18630,
                        "name": "Uitikon",
                        "latitude": "47.36911000",
                        "longitude": "8.45699000"
                    },
                    {
                        "id": 18631,
                        "name": "Unterengstringen",
                        "latitude": "47.41396000",
                        "longitude": "8.44761000"
                    },
                    {
                        "id": 18639,
                        "name": "Urdorf",
                        "latitude": "47.38507000",
                        "longitude": "8.42581000"
                    },
                    {
                        "id": 18640,
                        "name": "Urdorf \/ Bodenfeld",
                        "latitude": "47.38920000",
                        "longitude": "8.42265000"
                    },
                    {
                        "id": 18641,
                        "name": "Urdorf \/ Moos",
                        "latitude": "47.38977000",
                        "longitude": "8.42886000"
                    },
                    {
                        "id": 18642,
                        "name": "Urdorf \/ Oberurdorf",
                        "latitude": "47.38072000",
                        "longitude": "8.42343000"
                    },
                    {
                        "id": 18645,
                        "name": "Uster",
                        "latitude": "47.34713000",
                        "longitude": "8.72091000"
                    },
                    {
                        "id": 18646,
                        "name": "Uster \/ Gschwader",
                        "latitude": "47.36016000",
                        "longitude": "8.71390000"
                    },
                    {
                        "id": 18647,
                        "name": "Uster \/ Kirch-Uster",
                        "latitude": "47.34579000",
                        "longitude": "8.71839000"
                    },
                    {
                        "id": 18648,
                        "name": "Uster \/ Nieder-Uster",
                        "latitude": "47.34743000",
                        "longitude": "8.70088000"
                    },
                    {
                        "id": 18649,
                        "name": "Uster \/ Nossikon",
                        "latitude": "47.34088000",
                        "longitude": "8.72555000"
                    },
                    {
                        "id": 18650,
                        "name": "Uster \/ Ober-Uster",
                        "latitude": "47.34874000",
                        "longitude": "8.73319000"
                    },
                    {
                        "id": 18665,
                        "name": "Veltheim (Kreis 5)",
                        "latitude": "47.51419000",
                        "longitude": "8.71700000"
                    },
                    {
                        "id": 18666,
                        "name": "Veltheim (Kreis 5) \/ Blumenau",
                        "latitude": "47.50618000",
                        "longitude": "8.71563000"
                    },
                    {
                        "id": 18667,
                        "name": "Veltheim (Kreis 5) \/ Rosenberg",
                        "latitude": "47.51386000",
                        "longitude": "8.71583000"
                    },
                    {
                        "id": 18691,
                        "name": "Volketswil \/ Volketswil (Dorf)",
                        "latitude": "47.39016000",
                        "longitude": "8.69085000"
                    },
                    {
                        "id": 18773,
                        "name": "Wädenswil",
                        "latitude": "47.22683000",
                        "longitude": "8.66870000"
                    },
                    {
                        "id": 18774,
                        "name": "Wädenswil \/ Boller-Giessen",
                        "latitude": "47.22115000",
                        "longitude": "8.68385000"
                    },
                    {
                        "id": 18775,
                        "name": "Wädenswil \/ Büelen",
                        "latitude": "47.23395000",
                        "longitude": "8.66346000"
                    },
                    {
                        "id": 18776,
                        "name": "Wädenswil \/ Dorf (Wädenswil)",
                        "latitude": "47.22923000",
                        "longitude": "8.67220000"
                    },
                    {
                        "id": 18777,
                        "name": "Wädenswil \/ Eichweid",
                        "latitude": "47.21847000",
                        "longitude": "8.67440000"
                    },
                    {
                        "id": 18778,
                        "name": "Wädenswil \/ Hangenmoos",
                        "latitude": "47.23367000",
                        "longitude": "8.65251000"
                    },
                    {
                        "id": 18779,
                        "name": "Wädenswil \/ Leihof-Mühlebach",
                        "latitude": "47.22364000",
                        "longitude": "8.67149000"
                    },
                    {
                        "id": 18780,
                        "name": "Wädenswil \/ Untermosen-Fuhr",
                        "latitude": "47.22772000",
                        "longitude": "8.66303000"
                    },
                    {
                        "id": 18709,
                        "name": "Wald",
                        "latitude": "47.27595000",
                        "longitude": "8.91405000"
                    },
                    {
                        "id": 18715,
                        "name": "Wallisellen",
                        "latitude": "47.41499000",
                        "longitude": "8.59672000"
                    },
                    {
                        "id": 18716,
                        "name": "Wallisellen \/ Rieden",
                        "latitude": "47.41738000",
                        "longitude": "8.60028000"
                    },
                    {
                        "id": 18717,
                        "name": "Wallisellen \/ Wallisellen-Ost",
                        "latitude": "47.41446000",
                        "longitude": "8.59727000"
                    },
                    {
                        "id": 18718,
                        "name": "Wallisellen \/ Wallisellen-West",
                        "latitude": "47.41906000",
                        "longitude": "8.58586000"
                    },
                    {
                        "id": 18722,
                        "name": "Wangen",
                        "latitude": "47.41182000",
                        "longitude": "8.64516000"
                    },
                    {
                        "id": 18732,
                        "name": "Weiningen",
                        "latitude": "47.42022000",
                        "longitude": "8.43644000"
                    },
                    {
                        "id": 18733,
                        "name": "Weisslingen",
                        "latitude": "47.43063000",
                        "longitude": "8.76787000"
                    },
                    {
                        "id": 18737,
                        "name": "Wettswil \/ Ausser-Dorf",
                        "latitude": "47.33197000",
                        "longitude": "8.47732000"
                    },
                    {
                        "id": 18738,
                        "name": "Wettswil \/ Wettswil (Dorf)",
                        "latitude": "47.34152000",
                        "longitude": "8.47149000"
                    },
                    {
                        "id": 18739,
                        "name": "Wetzikon",
                        "latitude": "47.32640000",
                        "longitude": "8.79779000"
                    },
                    {
                        "id": 18740,
                        "name": "Wetzikon \/ Kempten",
                        "latitude": "47.33319000",
                        "longitude": "8.80982000"
                    },
                    {
                        "id": 18741,
                        "name": "Wetzikon \/ Ober-Wetzikon",
                        "latitude": "47.32514000",
                        "longitude": "8.80005000"
                    },
                    {
                        "id": 18742,
                        "name": "Wetzikon \/ Robenhausen",
                        "latitude": "47.33089000",
                        "longitude": "8.78762000"
                    },
                    {
                        "id": 18743,
                        "name": "Wetzikon \/ Unter-Wetzikon",
                        "latitude": "47.31637000",
                        "longitude": "8.79369000"
                    },
                    {
                        "id": 18746,
                        "name": "Wiesendangen \/ Wiesendangen (Dorf)",
                        "latitude": "47.52170000",
                        "longitude": "8.78967000"
                    },
                    {
                        "id": 18750,
                        "name": "Wila",
                        "latitude": "47.41928000",
                        "longitude": "8.84524000"
                    },
                    {
                        "id": 18758,
                        "name": "Winterthur",
                        "latitude": "47.50564000",
                        "longitude": "8.72413000"
                    },
                    {
                        "id": 18764,
                        "name": "Wolfhausen",
                        "latitude": "47.25619000",
                        "longitude": "8.79910000"
                    },
                    {
                        "id": 18783,
                        "name": "Wülflingen (Kreis 6)",
                        "latitude": "47.51036000",
                        "longitude": "8.68333000"
                    },
                    {
                        "id": 18784,
                        "name": "Wülflingen (Kreis 6) \/ Härti",
                        "latitude": "47.51262000",
                        "longitude": "8.68400000"
                    },
                    {
                        "id": 18785,
                        "name": "Wülflingen (Kreis 6) \/ Lindenplatz",
                        "latitude": "47.51098000",
                        "longitude": "8.69290000"
                    },
                    {
                        "id": 18786,
                        "name": "Wülflingen (Kreis 6) \/ Niederfeld",
                        "latitude": "47.50904000",
                        "longitude": "8.67968000"
                    },
                    {
                        "id": 18787,
                        "name": "Wülflingen (Kreis 6) \/ Oberfeld",
                        "latitude": "47.49873000",
                        "longitude": "8.69897000"
                    },
                    {
                        "id": 18797,
                        "name": "Zollikerberg",
                        "latitude": "47.34510000",
                        "longitude": "8.60088000"
                    },
                    {
                        "id": 18799,
                        "name": "Zollikon",
                        "latitude": "47.34019000",
                        "longitude": "8.57407000"
                    },
                    {
                        "id": 18802,
                        "name": "Zumikon",
                        "latitude": "47.33158000",
                        "longitude": "8.62271000"
                    },
                    {
                        "id": 18809,
                        "name": "Zürich",
                        "latitude": "47.36667000",
                        "longitude": "8.55000000"
                    },
                    {
                        "id": 18810,
                        "name": "Zürich (Kreis 1)",
                        "latitude": "47.37055000",
                        "longitude": "8.54177000"
                    },
                    {
                        "id": 18811,
                        "name": "Zürich (Kreis 1) \/ City",
                        "latitude": "47.37269000",
                        "longitude": "8.53576000"
                    },
                    {
                        "id": 18812,
                        "name": "Zürich (Kreis 1) \/ Lindenhof",
                        "latitude": "47.37188000",
                        "longitude": "8.54036000"
                    },
                    {
                        "id": 18813,
                        "name": "Zürich (Kreis 1) \/ Rathaus",
                        "latitude": "47.37161000",
                        "longitude": "8.54501000"
                    },
                    {
                        "id": 18814,
                        "name": "Zürich (Kreis 10)",
                        "latitude": "47.40773000",
                        "longitude": "8.50050000"
                    },
                    {
                        "id": 18815,
                        "name": "Zürich (Kreis 10) \/ Höngg",
                        "latitude": "47.40313000",
                        "longitude": "8.49710000"
                    },
                    {
                        "id": 18816,
                        "name": "Zürich (Kreis 10) \/ Rütihof",
                        "latitude": "47.41444000",
                        "longitude": "8.47928000"
                    },
                    {
                        "id": 18817,
                        "name": "Zürich (Kreis 10) \/ Wipkingen",
                        "latitude": "47.39503000",
                        "longitude": "8.52529000"
                    },
                    {
                        "id": 18818,
                        "name": "Zürich (Kreis 11)",
                        "latitude": "47.42326000",
                        "longitude": "8.52166000"
                    },
                    {
                        "id": 18819,
                        "name": "Zürich (Kreis 11) \/ Affoltern",
                        "latitude": "47.41814000",
                        "longitude": "8.51220000"
                    },
                    {
                        "id": 18820,
                        "name": "Zürich (Kreis 11) \/ Oerlikon",
                        "latitude": "47.40823000",
                        "longitude": "8.54258000"
                    },
                    {
                        "id": 18821,
                        "name": "Zürich (Kreis 11) \/ Schwandenholz",
                        "latitude": "47.42476000",
                        "longitude": "8.52125000"
                    },
                    {
                        "id": 18822,
                        "name": "Zürich (Kreis 11) \/ Seebach",
                        "latitude": "47.42181000",
                        "longitude": "8.54779000"
                    },
                    {
                        "id": 18823,
                        "name": "Zürich (Kreis 12)",
                        "latitude": "47.40372000",
                        "longitude": "8.57608000"
                    },
                    {
                        "id": 18824,
                        "name": "Zürich (Kreis 12) \/ Auzelg",
                        "latitude": "47.41511000",
                        "longitude": "8.57014000"
                    },
                    {
                        "id": 18825,
                        "name": "Zürich (Kreis 12) \/ Hirzenbach",
                        "latitude": "47.40187000",
                        "longitude": "8.58633000"
                    },
                    {
                        "id": 18826,
                        "name": "Zürich (Kreis 12) \/ Saatlen",
                        "latitude": "47.41127000",
                        "longitude": "8.56480000"
                    },
                    {
                        "id": 18827,
                        "name": "Zürich (Kreis 12) \/ Schwamendingen-Mitte",
                        "latitude": "47.40630000",
                        "longitude": "8.57242000"
                    },
                    {
                        "id": 18828,
                        "name": "Zürich (Kreis 2)",
                        "latitude": "47.33756000",
                        "longitude": "8.52110000"
                    },
                    {
                        "id": 18829,
                        "name": "Zürich (Kreis 2) \/ Enge",
                        "latitude": "47.36050000",
                        "longitude": "8.53127000"
                    },
                    {
                        "id": 18830,
                        "name": "Zürich (Kreis 2) \/ Mittel-Leimbach",
                        "latitude": "47.32538000",
                        "longitude": "8.51391000"
                    },
                    {
                        "id": 18831,
                        "name": "Zürich (Kreis 2) \/ Unter-Leimbach",
                        "latitude": "47.33362000",
                        "longitude": "8.51433000"
                    },
                    {
                        "id": 18832,
                        "name": "Zürich (Kreis 2) \/ Wollishofen",
                        "latitude": "47.34010000",
                        "longitude": "8.53134000"
                    },
                    {
                        "id": 18833,
                        "name": "Zürich (Kreis 3)",
                        "latitude": "47.35785000",
                        "longitude": "8.50296000"
                    },
                    {
                        "id": 18834,
                        "name": "Zürich (Kreis 3) \/ Alt-Wiedikon",
                        "latitude": "47.36201000",
                        "longitude": "8.51497000"
                    },
                    {
                        "id": 18835,
                        "name": "Zürich (Kreis 3) \/ Friesenberg",
                        "latitude": "47.36372000",
                        "longitude": "8.50417000"
                    },
                    {
                        "id": 18836,
                        "name": "Zürich (Kreis 3) \/ Sihlfeld",
                        "latitude": "47.37382000",
                        "longitude": "8.51164000"
                    },
                    {
                        "id": 18837,
                        "name": "Zürich (Kreis 4) \/ Aussersihl",
                        "latitude": "47.37752000",
                        "longitude": "8.52127000"
                    },
                    {
                        "id": 18838,
                        "name": "Zürich (Kreis 4) \/ Hard",
                        "latitude": "47.38311000",
                        "longitude": "8.50942000"
                    },
                    {
                        "id": 18839,
                        "name": "Zürich (Kreis 4) \/ Langstrasse",
                        "latitude": "47.37767000",
                        "longitude": "8.52854000"
                    },
                    {
                        "id": 18840,
                        "name": "Zürich (Kreis 4) \/ Werd",
                        "latitude": "47.37178000",
                        "longitude": "8.52584000"
                    },
                    {
                        "id": 18841,
                        "name": "Zürich (Kreis 5)",
                        "latitude": "47.38767000",
                        "longitude": "8.52152000"
                    },
                    {
                        "id": 18842,
                        "name": "Zürich (Kreis 5) \/ Escher-Wyss",
                        "latitude": "47.39052000",
                        "longitude": "8.51292000"
                    },
                    {
                        "id": 18843,
                        "name": "Zürich (Kreis 5) \/ Gewerbeschule",
                        "latitude": "47.38481000",
                        "longitude": "8.53011000"
                    },
                    {
                        "id": 18844,
                        "name": "Zürich (Kreis 6)",
                        "latitude": "47.39223000",
                        "longitude": "8.54381000"
                    },
                    {
                        "id": 18845,
                        "name": "Zürich (Kreis 6) \/ Oberstrass",
                        "latitude": "47.38917000",
                        "longitude": "8.55040000"
                    },
                    {
                        "id": 18846,
                        "name": "Zürich (Kreis 6) \/ Unterstrass",
                        "latitude": "47.39530000",
                        "longitude": "8.53721000"
                    },
                    {
                        "id": 18847,
                        "name": "Zürich (Kreis 7)",
                        "latitude": "47.37328000",
                        "longitude": "8.58038000"
                    },
                    {
                        "id": 18848,
                        "name": "Zürich (Kreis 7) \/ Fluntern",
                        "latitude": "47.38013000",
                        "longitude": "8.56133000"
                    },
                    {
                        "id": 18849,
                        "name": "Zürich (Kreis 7) \/ Hirslanden",
                        "latitude": "47.36240000",
                        "longitude": "8.56755000"
                    },
                    {
                        "id": 18850,
                        "name": "Zürich (Kreis 7) \/ Hottingen",
                        "latitude": "47.37011000",
                        "longitude": "8.56306000"
                    },
                    {
                        "id": 18851,
                        "name": "Zürich (Kreis 7) \/ Witikon",
                        "latitude": "47.35751000",
                        "longitude": "8.59105000"
                    },
                    {
                        "id": 18852,
                        "name": "Zürich (Kreis 8)",
                        "latitude": "47.35480000",
                        "longitude": "8.56097000"
                    },
                    {
                        "id": 18853,
                        "name": "Zürich (Kreis 8) \/ Mühlebach",
                        "latitude": "47.35727000",
                        "longitude": "8.55744000"
                    },
                    {
                        "id": 18854,
                        "name": "Zürich (Kreis 8) \/ Seefeld",
                        "latitude": "47.35462000",
                        "longitude": "8.55537000"
                    },
                    {
                        "id": 18855,
                        "name": "Zürich (Kreis 8) \/ Weinegg",
                        "latitude": "47.35250000",
                        "longitude": "8.57011000"
                    },
                    {
                        "id": 18856,
                        "name": "Zürich (Kreis 9)",
                        "latitude": "47.38245000",
                        "longitude": "8.47993000"
                    },
                    {
                        "id": 18857,
                        "name": "Zürich (Kreis 9) \/ Albisrieden",
                        "latitude": "47.37398000",
                        "longitude": "8.49007000"
                    },
                    {
                        "id": 18858,
                        "name": "Zürich (Kreis 9) \/ Altstetten",
                        "latitude": "47.38946000",
                        "longitude": "8.48533000"
                    }
                ]
            }
        ]
    },
    {
        "id": 215,
        "name": "Syria",
        "iso3": "SYR",
        "iso2": "SY",
        "numeric_code": "760",
        "phonecode": "963",
        "capital": "Damascus",
        "currency": "SYP",
        "currency_name": "Syrian pound",
        "currency_symbol": "LS",
        "tld": ".sy",
        "native": "سوريا",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Syrian",
        "timezones": [
            {
                "zoneName": "Asia\/Damascus",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Siria",
            "ko": "시리아",
            "pt-BR": "Síria",
            "pt": "Síria",
            "nl": "Syrië",
            "hr": "Sirija",
            "fa": "سوریه",
            "de": "Syrien",
            "es": "Siria",
            "fr": "Syrie",
            "ja": "シリア・アラブ共和国",
            "it": "Siria",
            "zh-CN": "叙利亚",
            "tr": "Suriye",
            "ru": "Сирия",
            "uk": "Сирія",
            "pl": "Syria"
        },
        "latitude": "35.00000000",
        "longitude": "38.00000000",
        "emoji": "🇸🇾",
        "emojiU": "U+1F1F8 U+1F1FE",
        "states": [
            {
                "id": 2941,
                "name": "Al-Hasakah",
                "iso2": "HA",
                "latitude": "36.40551500",
                "longitude": "40.79691490",
                "type": "province",
                "cities": [
                    {
                        "id": 104940,
                        "name": "Ad Darbāsīyah",
                        "latitude": "37.07279000",
                        "longitude": "40.65199000"
                    },
                    {
                        "id": 104957,
                        "name": "Al Ḩasakah",
                        "latitude": "36.50237000",
                        "longitude": "40.74772000"
                    },
                    {
                        "id": 104950,
                        "name": "Al Mālikīyah",
                        "latitude": "37.17701000",
                        "longitude": "42.14006000"
                    },
                    {
                        "id": 104955,
                        "name": "Al Qāmishlī",
                        "latitude": "37.05215000",
                        "longitude": "41.23142000"
                    },
                    {
                        "id": 104960,
                        "name": "Al-Malikiyah District",
                        "latitude": "36.94113000",
                        "longitude": "41.90157000"
                    },
                    {
                        "id": 104967,
                        "name": "Amude",
                        "latitude": "37.10417000",
                        "longitude": "40.93000000"
                    }
                ]
            },
            {
                "id": 2944,
                "name": "Al-Raqqah",
                "iso2": "RA",
                "latitude": "35.95941060",
                "longitude": "38.99810520",
                "type": "province",
                "cities": [
                    {
                        "id": 104964,
                        "name": "Al-Thawrah District",
                        "latitude": "35.79843000",
                        "longitude": "38.34550000"
                    },
                    {
                        "id": 104969,
                        "name": "Ar Raqqah",
                        "latitude": "35.95283000",
                        "longitude": "39.00788000"
                    },
                    {
                        "id": 104971,
                        "name": "Ar-Raqqah District",
                        "latitude": "35.87204000",
                        "longitude": "39.04706000"
                    },
                    {
                        "id": 104981,
                        "name": "Ath Thawrah",
                        "latitude": "35.83758000",
                        "longitude": "38.54828000"
                    },
                    {
                        "id": 105055,
                        "name": "Tall Abyaḑ",
                        "latitude": "36.69648000",
                        "longitude": "38.95382000"
                    },
                    {
                        "id": 105062,
                        "name": "Tell Abyad District",
                        "latitude": "36.48280000",
                        "longitude": "39.21360000"
                    }
                ]
            },
            {
                "id": 2946,
                "name": "Aleppo",
                "iso2": "HL",
                "latitude": "36.22623930",
                "longitude": "37.46813960",
                "type": "province",
                "cities": [
                    {
                        "id": 105079,
                        "name": "‘Afrīn",
                        "latitude": "36.51194000",
                        "longitude": "36.86954000"
                    },
                    {
                        "id": 105080,
                        "name": "‘Ayn al ‘Arab",
                        "latitude": "36.89095000",
                        "longitude": "38.35347000"
                    },
                    {
                        "id": 104943,
                        "name": "Afrin District",
                        "latitude": "36.54891000",
                        "longitude": "36.79295000"
                    },
                    {
                        "id": 104944,
                        "name": "Al Atārib",
                        "latitude": "36.13907000",
                        "longitude": "36.82504000"
                    },
                    {
                        "id": 104945,
                        "name": "Al Bāb",
                        "latitude": "36.37051000",
                        "longitude": "37.51570000"
                    },
                    {
                        "id": 104958,
                        "name": "Al-Bab District",
                        "latitude": "36.30946000",
                        "longitude": "37.53277000"
                    },
                    {
                        "id": 104966,
                        "name": "Aleppo",
                        "latitude": "36.20124000",
                        "longitude": "37.16117000"
                    },
                    {
                        "id": 104974,
                        "name": "As Safīrah",
                        "latitude": "36.07696000",
                        "longitude": "37.37251000"
                    },
                    {
                        "id": 104983,
                        "name": "Azaz District",
                        "latitude": "36.49986000",
                        "longitude": "37.18382000"
                    },
                    {
                        "id": 104992,
                        "name": "Dayr Ḩāfir",
                        "latitude": "36.15694000",
                        "longitude": "37.70778000"
                    },
                    {
                        "id": 105006,
                        "name": "I‘zāz",
                        "latitude": "36.58662000",
                        "longitude": "37.04628000"
                    },
                    {
                        "id": 105010,
                        "name": "Jarābulus",
                        "latitude": "36.81750000",
                        "longitude": "38.01111000"
                    },
                    {
                        "id": 105019,
                        "name": "Kafr Şaghīr",
                        "latitude": "36.29264000",
                        "longitude": "37.25590000"
                    },
                    {
                        "id": 105022,
                        "name": "Khanāşir",
                        "latitude": "35.78159000",
                        "longitude": "37.49919000"
                    },
                    {
                        "id": 105027,
                        "name": "Manbij",
                        "latitude": "36.52815000",
                        "longitude": "37.95495000"
                    },
                    {
                        "id": 105028,
                        "name": "Manbij District",
                        "latitude": "36.06687000",
                        "longitude": "37.91735000"
                    },
                    {
                        "id": 105034,
                        "name": "Mount Simeon District",
                        "latitude": "35.99956000",
                        "longitude": "37.08473000"
                    },
                    {
                        "id": 105038,
                        "name": "Nubl",
                        "latitude": "36.37867000",
                        "longitude": "36.99294000"
                    },
                    {
                        "id": 105072,
                        "name": "Şūrān",
                        "latitude": "36.56579000",
                        "longitude": "37.21270000"
                    },
                    {
                        "id": 105064,
                        "name": "Tādif",
                        "latitude": "36.34814000",
                        "longitude": "37.53090000"
                    },
                    {
                        "id": 105056,
                        "name": "Tall Rif‘at",
                        "latitude": "36.47229000",
                        "longitude": "37.09471000"
                    }
                ]
            },
            {
                "id": 2936,
                "name": "As-Suwayda",
                "iso2": "SU",
                "latitude": "32.79891560",
                "longitude": "36.78195050",
                "type": "province",
                "cities": [
                    {
                        "id": 104977,
                        "name": "As-Suwayda",
                        "latitude": "32.70896000",
                        "longitude": "36.56951000"
                    },
                    {
                        "id": 104978,
                        "name": "As-Suwayda District",
                        "latitude": "32.78127000",
                        "longitude": "36.86502000"
                    },
                    {
                        "id": 105069,
                        "name": "Şalākhid",
                        "latitude": "32.87271000",
                        "longitude": "36.57271000"
                    },
                    {
                        "id": 105068,
                        "name": "Şalkhad",
                        "latitude": "32.49200000",
                        "longitude": "36.71114000"
                    },
                    {
                        "id": 105043,
                        "name": "Salkhad District",
                        "latitude": "32.51779000",
                        "longitude": "36.91954000"
                    },
                    {
                        "id": 105049,
                        "name": "Shahbā",
                        "latitude": "32.85514000",
                        "longitude": "36.62896000"
                    },
                    {
                        "id": 105048,
                        "name": "Shahba District",
                        "latitude": "33.04282000",
                        "longitude": "36.72034000"
                    }
                ]
            },
            {
                "id": 2939,
                "name": "Damascus",
                "iso2": "DI",
                "latitude": "33.51514440",
                "longitude": "36.39313540",
                "type": "province",
                "cities": [
                    {
                        "id": 104988,
                        "name": "Damascus",
                        "latitude": "33.51020000",
                        "longitude": "36.29128000"
                    }
                ]
            },
            {
                "id": 2945,
                "name": "Daraa",
                "iso2": "DR",
                "latitude": "32.92488130",
                "longitude": "36.17626150",
                "type": "province",
                "cities": [
                    {
                        "id": 104956,
                        "name": "Al Ḩarāk",
                        "latitude": "32.74932000",
                        "longitude": "36.30994000"
                    },
                    {
                        "id": 104949,
                        "name": "Al Muzayrīb",
                        "latitude": "32.71084000",
                        "longitude": "36.02751000"
                    },
                    {
                        "id": 104963,
                        "name": "Al-Sanamayn District",
                        "latitude": "33.12559000",
                        "longitude": "36.27540000"
                    },
                    {
                        "id": 104984,
                        "name": "Aş Şanamayn",
                        "latitude": "33.07186000",
                        "longitude": "36.18316000"
                    },
                    {
                        "id": 104979,
                        "name": "Ash Shaykh Miskīn",
                        "latitude": "32.82944000",
                        "longitude": "36.15933000"
                    },
                    {
                        "id": 104986,
                        "name": "Buşrá ash Shām",
                        "latitude": "32.52013000",
                        "longitude": "36.48256000"
                    },
                    {
                        "id": 104990,
                        "name": "Dar‘ā",
                        "latitude": "32.61889000",
                        "longitude": "36.10213000"
                    },
                    {
                        "id": 104996,
                        "name": "Ghabāghib",
                        "latitude": "33.18235000",
                        "longitude": "36.22534000"
                    },
                    {
                        "id": 105003,
                        "name": "Inkhil",
                        "latitude": "33.01809000",
                        "longitude": "36.12828000"
                    },
                    {
                        "id": 105004,
                        "name": "Izra District",
                        "latitude": "32.90121000",
                        "longitude": "36.16144000"
                    },
                    {
                        "id": 105005,
                        "name": "Izra‘",
                        "latitude": "32.87060000",
                        "longitude": "36.25453000"
                    },
                    {
                        "id": 105014,
                        "name": "Jāsim",
                        "latitude": "32.99233000",
                        "longitude": "36.06018000"
                    },
                    {
                        "id": 105037,
                        "name": "Nawá",
                        "latitude": "32.89044000",
                        "longitude": "36.03990000"
                    },
                    {
                        "id": 105073,
                        "name": "Ţafas",
                        "latitude": "32.73709000",
                        "longitude": "36.06654000"
                    },
                    {
                        "id": 105061,
                        "name": "Tasīl",
                        "latitude": "32.83395000",
                        "longitude": "35.96973000"
                    }
                ]
            },
            {
                "id": 2937,
                "name": "Deir ez-Zor",
                "iso2": "DY",
                "latitude": "35.28797980",
                "longitude": "40.30886260",
                "type": "province",
                "cities": [
                    {
                        "id": 104948,
                        "name": "Al Mayādīn",
                        "latitude": "35.01982000",
                        "longitude": "40.45154000"
                    },
                    {
                        "id": 105066,
                        "name": "Ālbū Kamāl",
                        "latitude": "34.45226000",
                        "longitude": "40.91854000"
                    },
                    {
                        "id": 104993,
                        "name": "Deir ez-Zor",
                        "latitude": "35.33588000",
                        "longitude": "40.14084000"
                    },
                    {
                        "id": 104997,
                        "name": "Hajīn",
                        "latitude": "34.69508000",
                        "longitude": "40.83138000"
                    },
                    {
                        "id": 105051,
                        "name": "Subaykhān",
                        "latitude": "34.85305000",
                        "longitude": "40.59987000"
                    }
                ]
            },
            {
                "id": 2934,
                "name": "Hama",
                "iso2": "HM",
                "latitude": "35.18878650",
                "longitude": "37.21158290",
                "type": "province",
                "cities": [
                    {
                        "id": 104962,
                        "name": "Al-Salamiyah District",
                        "latitude": "35.14398000",
                        "longitude": "37.59235000"
                    },
                    {
                        "id": 104975,
                        "name": "As Salamīyah",
                        "latitude": "35.01127000",
                        "longitude": "37.05324000"
                    },
                    {
                        "id": 104976,
                        "name": "As Suqaylibīyah",
                        "latitude": "35.36674000",
                        "longitude": "36.39359000"
                    },
                    {
                        "id": 105075,
                        "name": "Ḩalfāyā",
                        "latitude": "35.26014000",
                        "longitude": "36.60581000"
                    },
                    {
                        "id": 104998,
                        "name": "Hama District",
                        "latitude": "35.28577000",
                        "longitude": "37.12626000"
                    },
                    {
                        "id": 105076,
                        "name": "Ḩamāh",
                        "latitude": "35.13179000",
                        "longitude": "36.75783000"
                    },
                    {
                        "id": 105018,
                        "name": "Kafr Zaytā",
                        "latitude": "35.37425000",
                        "longitude": "36.60330000"
                    },
                    {
                        "id": 105030,
                        "name": "Maşyāf",
                        "latitude": "35.06530000",
                        "longitude": "36.34060000"
                    },
                    {
                        "id": 105029,
                        "name": "Masyaf District",
                        "latitude": "35.10335000",
                        "longitude": "36.33920000"
                    },
                    {
                        "id": 105036,
                        "name": "Mūrak",
                        "latitude": "35.37615000",
                        "longitude": "36.68970000"
                    },
                    {
                        "id": 105050,
                        "name": "Souran",
                        "latitude": "35.29193000",
                        "longitude": "36.74848000"
                    },
                    {
                        "id": 105057,
                        "name": "Tall Salḩab",
                        "latitude": "35.25884000",
                        "longitude": "36.38461000"
                    },
                    {
                        "id": 105074,
                        "name": "Ţayyibat al Imām",
                        "latitude": "35.26592000",
                        "longitude": "36.71219000"
                    },
                    {
                        "id": 105063,
                        "name": "Tremseh",
                        "latitude": "35.27181000",
                        "longitude": "36.50395000"
                    }
                ]
            },
            {
                "id": 2942,
                "name": "Homs",
                "iso2": "HI",
                "latitude": "34.25671230",
                "longitude": "38.31657250",
                "type": "province",
                "cities": [
                    {
                        "id": 104946,
                        "name": "Al Ghanţū",
                        "latitude": "34.82202000",
                        "longitude": "36.69613000"
                    },
                    {
                        "id": 104951,
                        "name": "Al Qaryatayn",
                        "latitude": "34.22956000",
                        "longitude": "37.24066000"
                    },
                    {
                        "id": 104953,
                        "name": "Al Quşayr",
                        "latitude": "34.50780000",
                        "longitude": "36.58029000"
                    },
                    {
                        "id": 104961,
                        "name": "Al-Rastan District",
                        "latitude": "34.87100000",
                        "longitude": "36.77245000"
                    },
                    {
                        "id": 104970,
                        "name": "Ar Rastan",
                        "latitude": "34.92667000",
                        "longitude": "36.73241000"
                    },
                    {
                        "id": 105000,
                        "name": "Hisya",
                        "latitude": "34.41197000",
                        "longitude": "36.75867000"
                    },
                    {
                        "id": 105001,
                        "name": "Homs",
                        "latitude": "34.72682000",
                        "longitude": "36.72339000"
                    },
                    {
                        "id": 105016,
                        "name": "Kafr Lāhā",
                        "latitude": "34.89469000",
                        "longitude": "36.49582000"
                    },
                    {
                        "id": 105035,
                        "name": "Mukharram al Fawqānī",
                        "latitude": "34.81521000",
                        "longitude": "37.08677000"
                    },
                    {
                        "id": 105067,
                        "name": "Şadad",
                        "latitude": "34.31248000",
                        "longitude": "36.92562000"
                    },
                    {
                        "id": 105052,
                        "name": "Tadmur",
                        "latitude": "34.56240000",
                        "longitude": "38.28402000"
                    },
                    {
                        "id": 105053,
                        "name": "Tadmur District",
                        "latitude": "34.42401000",
                        "longitude": "38.64580000"
                    },
                    {
                        "id": 105058,
                        "name": "Tallbīsah",
                        "latitude": "34.84072000",
                        "longitude": "36.73092000"
                    },
                    {
                        "id": 105059,
                        "name": "Tallkalakh",
                        "latitude": "34.66842000",
                        "longitude": "36.25995000"
                    }
                ]
            },
            {
                "id": 2940,
                "name": "Idlib",
                "iso2": "ID",
                "latitude": "35.82687980",
                "longitude": "36.69572160",
                "type": "province",
                "cities": [
                    {
                        "id": 104942,
                        "name": "Ad Dānā",
                        "latitude": "36.21254000",
                        "longitude": "36.76998000"
                    },
                    {
                        "id": 104973,
                        "name": "Arīḩā",
                        "latitude": "35.81374000",
                        "longitude": "36.60964000"
                    },
                    {
                        "id": 104972,
                        "name": "Armanāz",
                        "latitude": "36.08363000",
                        "longitude": "36.50310000"
                    },
                    {
                        "id": 104985,
                        "name": "Binnish",
                        "latitude": "35.95664000",
                        "longitude": "36.71380000"
                    },
                    {
                        "id": 104989,
                        "name": "Darkūsh",
                        "latitude": "35.99180000",
                        "longitude": "36.39361000"
                    },
                    {
                        "id": 104999,
                        "name": "Harem District",
                        "latitude": "36.14014000",
                        "longitude": "36.56535000"
                    },
                    {
                        "id": 105078,
                        "name": "Ḩārim",
                        "latitude": "36.21176000",
                        "longitude": "36.52078000"
                    },
                    {
                        "id": 105002,
                        "name": "Idlib",
                        "latitude": "35.93062000",
                        "longitude": "36.63393000"
                    },
                    {
                        "id": 105012,
                        "name": "Jisr al-Shughur District",
                        "latitude": "35.87756000",
                        "longitude": "36.32901000"
                    },
                    {
                        "id": 105013,
                        "name": "Jisr ash Shughūr",
                        "latitude": "35.81418000",
                        "longitude": "36.31983000"
                    },
                    {
                        "id": 105017,
                        "name": "Kafr Takhārīm",
                        "latitude": "36.11680000",
                        "longitude": "36.51522000"
                    },
                    {
                        "id": 105020,
                        "name": "Kafranbel",
                        "latitude": "35.61376000",
                        "longitude": "36.56449000"
                    },
                    {
                        "id": 105023,
                        "name": "Khān Shaykhūn",
                        "latitude": "35.44208000",
                        "longitude": "36.65095000"
                    },
                    {
                        "id": 105031,
                        "name": "Ma‘arratmişrīn",
                        "latitude": "36.01152000",
                        "longitude": "36.67183000"
                    },
                    {
                        "id": 105026,
                        "name": "Maarrat al-Nu'man District",
                        "latitude": "35.53858000",
                        "longitude": "36.79193000"
                    },
                    {
                        "id": 105044,
                        "name": "Salqīn",
                        "latitude": "36.13865000",
                        "longitude": "36.45244000"
                    },
                    {
                        "id": 105046,
                        "name": "Sarāqib",
                        "latitude": "35.86447000",
                        "longitude": "36.80591000"
                    },
                    {
                        "id": 105045,
                        "name": "Sarmīn",
                        "latitude": "35.90403000",
                        "longitude": "36.72501000"
                    },
                    {
                        "id": 105054,
                        "name": "Taftanāz",
                        "latitude": "35.99832000",
                        "longitude": "36.78579000"
                    }
                ]
            },
            {
                "id": 2938,
                "name": "Latakia",
                "iso2": "LA",
                "latitude": "35.61297910",
                "longitude": "36.00232250",
                "type": "province",
                "cities": [
                    {
                        "id": 104959,
                        "name": "Al-Haffah District",
                        "latitude": "35.59687000",
                        "longitude": "36.11198000"
                    },
                    {
                        "id": 105007,
                        "name": "Jablah",
                        "latitude": "35.36211000",
                        "longitude": "35.92759000"
                    },
                    {
                        "id": 105008,
                        "name": "Jableh District",
                        "latitude": "35.29048000",
                        "longitude": "36.04490000"
                    },
                    {
                        "id": 105021,
                        "name": "Kassab",
                        "latitude": "35.92639000",
                        "longitude": "35.98970000"
                    },
                    {
                        "id": 105024,
                        "name": "Latakia",
                        "latitude": "35.53168000",
                        "longitude": "35.79011000"
                    },
                    {
                        "id": 105025,
                        "name": "Latakia District",
                        "latitude": "35.72426000",
                        "longitude": "35.94150000"
                    },
                    {
                        "id": 105039,
                        "name": "Qardaha District",
                        "latitude": "35.39593000",
                        "longitude": "36.08603000"
                    },
                    {
                        "id": 105071,
                        "name": "Şlinfah",
                        "latitude": "35.59822000",
                        "longitude": "36.18770000"
                    }
                ]
            },
            {
                "id": 2943,
                "name": "Quneitra",
                "iso2": "QU",
                "latitude": "33.07763180",
                "longitude": "35.89341360",
                "type": "province",
                "cities": [
                    {
                        "id": 104952,
                        "name": "Al Qunayţirah",
                        "latitude": "33.12595000",
                        "longitude": "35.82461000"
                    }
                ]
            },
            {
                "id": 2935,
                "name": "Rif Dimashq",
                "iso2": "RD",
                "latitude": "33.51672890",
                "longitude": "36.95410700",
                "type": "province",
                "cities": [
                    {
                        "id": 105081,
                        "name": "‘Irbīn",
                        "latitude": "33.53719000",
                        "longitude": "36.36635000"
                    },
                    {
                        "id": 104947,
                        "name": "Al Kiswah",
                        "latitude": "33.35810000",
                        "longitude": "36.24190000"
                    },
                    {
                        "id": 104954,
                        "name": "Al Quţayfah",
                        "latitude": "33.73848000",
                        "longitude": "36.60071000"
                    },
                    {
                        "id": 104965,
                        "name": "Al-Zabadani District",
                        "latitude": "33.70819000",
                        "longitude": "36.11198000"
                    },
                    {
                        "id": 104968,
                        "name": "An Nabk",
                        "latitude": "34.02403000",
                        "longitude": "36.72848000"
                    },
                    {
                        "id": 104980,
                        "name": "At Tall",
                        "latitude": "33.61033000",
                        "longitude": "36.31070000"
                    },
                    {
                        "id": 104982,
                        "name": "Az Zabadānī",
                        "latitude": "33.72488000",
                        "longitude": "36.10050000"
                    },
                    {
                        "id": 104995,
                        "name": "Dārayyā",
                        "latitude": "33.45835000",
                        "longitude": "36.23256000"
                    },
                    {
                        "id": 104991,
                        "name": "Dayr al ‘Aşāfīr",
                        "latitude": "33.46585000",
                        "longitude": "36.42044000"
                    },
                    {
                        "id": 104994,
                        "name": "Douma",
                        "latitude": "33.57175000",
                        "longitude": "36.40270000"
                    },
                    {
                        "id": 105077,
                        "name": "Ḩarastā",
                        "latitude": "33.55869000",
                        "longitude": "36.36515000"
                    },
                    {
                        "id": 105009,
                        "name": "Jaramānā",
                        "latitude": "33.48620000",
                        "longitude": "36.34614000"
                    },
                    {
                        "id": 105011,
                        "name": "Jayrūd",
                        "latitude": "33.80709000",
                        "longitude": "36.73861000"
                    },
                    {
                        "id": 105032,
                        "name": "Ma‘lūlā",
                        "latitude": "33.84529000",
                        "longitude": "36.54514000"
                    },
                    {
                        "id": 105033,
                        "name": "Medaya",
                        "latitude": "33.69032000",
                        "longitude": "36.10354000"
                    },
                    {
                        "id": 105041,
                        "name": "Qārah",
                        "latitude": "34.15558000",
                        "longitude": "36.74284000"
                    },
                    {
                        "id": 105040,
                        "name": "Qaţanā",
                        "latitude": "33.43757000",
                        "longitude": "36.07888000"
                    },
                    {
                        "id": 105070,
                        "name": "Şaydnāyā",
                        "latitude": "33.69473000",
                        "longitude": "36.37146000"
                    },
                    {
                        "id": 105065,
                        "name": "Yabrūd",
                        "latitude": "33.96921000",
                        "longitude": "36.65729000"
                    }
                ]
            },
            {
                "id": 2947,
                "name": "Tartus",
                "iso2": "TA",
                "latitude": "35.00066520",
                "longitude": "36.00232250",
                "type": "province",
                "cities": [
                    {
                        "id": 104941,
                        "name": "Ad Duraykīsh",
                        "latitude": "34.89514000",
                        "longitude": "36.14303000"
                    },
                    {
                        "id": 104987,
                        "name": "Bāniyās",
                        "latitude": "35.18188000",
                        "longitude": "35.94871000"
                    },
                    {
                        "id": 105015,
                        "name": "Kaff al-Jaa",
                        "latitude": "35.08638000",
                        "longitude": "36.20605000"
                    },
                    {
                        "id": 105042,
                        "name": "Safita District",
                        "latitude": "34.80419000",
                        "longitude": "36.12293000"
                    },
                    {
                        "id": 105047,
                        "name": "Satita",
                        "latitude": "34.82099000",
                        "longitude": "36.11773000"
                    },
                    {
                        "id": 105060,
                        "name": "Tartouss",
                        "latitude": "34.88902000",
                        "longitude": "35.88659000"
                    }
                ]
            }
        ]
    },
    {
        "id": 216,
        "name": "Taiwan",
        "iso3": "TWN",
        "iso2": "TW",
        "numeric_code": "158",
        "phonecode": "886",
        "capital": "Taipei",
        "currency": "TWD",
        "currency_name": "New Taiwan dollar",
        "currency_symbol": "$",
        "tld": ".tw",
        "native": "臺灣",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Eastern Asia",
        "subregion_id": 12,
        "nationality": "Chinese, Taiwanese",
        "timezones": [
            {
                "zoneName": "Asia\/Taipei",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "CST",
                "tzName": "China Standard Time"
            }
        ],
        "translations": {
            "br": "Taiwan",
            "ko": "대만",
            "pt-BR": "Taiwan",
            "pt": "Taiwan",
            "nl": "Taiwan",
            "hr": "Tajvan",
            "fa": "تایوان",
            "de": "Taiwan",
            "es": "Taiwán",
            "fr": "Taïwan",
            "ja": "台湾（中華民国）",
            "it": "Taiwan",
            "zh-CN": "中国台湾",
            "tr": "Tayvan",
            "ru": "Тайвань",
            "uk": "Тайвань",
            "pl": "Tajwan"
        },
        "latitude": "23.50000000",
        "longitude": "121.00000000",
        "emoji": "🇹🇼",
        "emojiU": "U+1F1F9 U+1F1FC",
        "states": [
            {
                "id": 3404,
                "name": "Changhua",
                "iso2": "CHA",
                "latitude": "24.05179630",
                "longitude": "120.51613520",
                "type": "county",
                "cities": [
                    {
                        "id": 109003,
                        "name": "Changhua",
                        "latitude": "23.95361000",
                        "longitude": "120.49083000"
                    },
                    {
                        "id": 109038,
                        "name": "Yuanlin",
                        "latitude": "23.95671000",
                        "longitude": "120.57608000"
                    }
                ]
            },
            {
                "id": 3408,
                "name": "Chiayi",
                "iso2": "CYI",
                "latitude": "23.45184280",
                "longitude": "120.25546150",
                "type": "city",
                "cities": [
                    {
                        "id": 109004,
                        "name": "Chiayi",
                        "latitude": "23.47722000",
                        "longitude": "120.44527000"
                    },
                    {
                        "id": 109026,
                        "name": "Pizitou",
                        "latitude": "23.48556000",
                        "longitude": "120.44472000"
                    }
                ]
            },
            {
                "id": 3418,
                "name": "Chiayi",
                "iso2": "CYQ",
                "latitude": "23.48007510",
                "longitude": "120.44911130",
                "type": "county",
                "cities": [
                    {
                        "id": 109005,
                        "name": "Chiayi County",
                        "latitude": "23.46333000",
                        "longitude": "120.58166000"
                    }
                ]
            },
            {
                "id": 3423,
                "name": "Hsinchu",
                "iso2": "HSQ",
                "latitude": "24.83872260",
                "longitude": "121.01772460",
                "type": "county",
                "cities": [
                    {
                        "id": 109010,
                        "name": "Hsinchu",
                        "latitude": "24.80361000",
                        "longitude": "120.96861000"
                    }
                ]
            },
            {
                "id": 3417,
                "name": "Hsinchu",
                "iso2": "HSZ",
                "latitude": "24.81382870",
                "longitude": "120.96747980",
                "type": "city",
                "cities": [
                    {
                        "id": 109011,
                        "name": "Hsinchu County",
                        "latitude": "24.67416000",
                        "longitude": "121.16111000"
                    }
                ]
            },
            {
                "id": 3411,
                "name": "Hualien",
                "iso2": "HUA",
                "latitude": "23.98715890",
                "longitude": "121.60157140",
                "type": "county",
                "cities": [
                    {
                        "id": 109012,
                        "name": "Hualien",
                        "latitude": "23.78166000",
                        "longitude": "121.39333000"
                    },
                    {
                        "id": 109013,
                        "name": "Hualien City",
                        "latitude": "23.97694000",
                        "longitude": "121.60444000"
                    }
                ]
            },
            {
                "id": 3412,
                "name": "Kaohsiung",
                "iso2": "KHH",
                "latitude": "22.62727840",
                "longitude": "120.30143530",
                "type": "special municipality",
                "cities": [
                    {
                        "id": 109016,
                        "name": "Kaohsiung",
                        "latitude": "22.61626000",
                        "longitude": "120.31333000"
                    }
                ]
            },
            {
                "id": 4965,
                "name": "Keelung",
                "iso2": "KEE",
                "latitude": "25.12418620",
                "longitude": "121.64758340",
                "type": "city",
                "cities": []
            },
            {
                "id": 3415,
                "name": "Kinmen",
                "iso2": "KIN",
                "latitude": "24.34877920",
                "longitude": "118.32856440",
                "type": "county",
                "cities": [
                    {
                        "id": 109014,
                        "name": "Jincheng",
                        "latitude": "24.43415000",
                        "longitude": "118.31712000"
                    },
                    {
                        "id": 109017,
                        "name": "Kinmen County",
                        "latitude": "24.45333000",
                        "longitude": "118.38861000"
                    }
                ]
            },
            {
                "id": 3420,
                "name": "Lienchiang",
                "iso2": "LIE",
                "latitude": "26.15055560",
                "longitude": "119.92888890",
                "type": "county",
                "cities": [
                    {
                        "id": 109018,
                        "name": "Lienchiang",
                        "latitude": "26.37004000",
                        "longitude": "120.49545000"
                    },
                    {
                        "id": 109022,
                        "name": "Nangan",
                        "latitude": "26.15039000",
                        "longitude": "119.93284000"
                    }
                ]
            },
            {
                "id": 3413,
                "name": "Miaoli",
                "iso2": "MIA",
                "latitude": "24.56015900",
                "longitude": "120.82142650",
                "type": "county",
                "cities": [
                    {
                        "id": 109021,
                        "name": "Miaoli",
                        "latitude": "24.48972000",
                        "longitude": "120.90638000"
                    }
                ]
            },
            {
                "id": 3407,
                "name": "Nantou",
                "iso2": "NAN",
                "latitude": "23.96099810",
                "longitude": "120.97186380",
                "type": "county",
                "cities": [
                    {
                        "id": 109019,
                        "name": "Lugu",
                        "latitude": "23.74639000",
                        "longitude": "120.75250000"
                    },
                    {
                        "id": 109023,
                        "name": "Nantou",
                        "latitude": "23.83419000",
                        "longitude": "120.92704000"
                    },
                    {
                        "id": 109027,
                        "name": "Puli",
                        "latitude": "23.96639000",
                        "longitude": "120.96952000"
                    },
                    {
                        "id": 109041,
                        "name": "Zhongxing New Village",
                        "latitude": "23.95908000",
                        "longitude": "120.68516000"
                    }
                ]
            },
            {
                "id": 4966,
                "name": "New Taipei",
                "iso2": "NWT",
                "latitude": "24.98752780",
                "longitude": "121.36459470",
                "type": "special municipality",
                "cities": []
            },
            {
                "id": 3403,
                "name": "Penghu",
                "iso2": "PEN",
                "latitude": "23.57118990",
                "longitude": "119.57931570",
                "type": "county",
                "cities": [
                    {
                        "id": 109020,
                        "name": "Magong",
                        "latitude": "23.56540000",
                        "longitude": "119.58627000"
                    },
                    {
                        "id": 109024,
                        "name": "Penghu County",
                        "latitude": "23.57111000",
                        "longitude": "119.61138000"
                    }
                ]
            },
            {
                "id": 3405,
                "name": "Pingtung",
                "iso2": "PIF",
                "latitude": "22.55197590",
                "longitude": "120.54875970",
                "type": "county",
                "cities": [
                    {
                        "id": 109007,
                        "name": "Donggang",
                        "latitude": "22.46515000",
                        "longitude": "120.44927000"
                    },
                    {
                        "id": 109009,
                        "name": "Hengchun",
                        "latitude": "22.00417000",
                        "longitude": "120.74389000"
                    },
                    {
                        "id": 109025,
                        "name": "Pingtung",
                        "latitude": "22.49555000",
                        "longitude": "120.61444000"
                    }
                ]
            },
            {
                "id": 3406,
                "name": "Taichung",
                "iso2": "TXG",
                "latitude": "24.14773580",
                "longitude": "120.67364820",
                "type": "special municipality",
                "cities": [
                    {
                        "id": 109028,
                        "name": "Taichung",
                        "latitude": "24.14690000",
                        "longitude": "120.68390000"
                    },
                    {
                        "id": 109029,
                        "name": "Taichung City",
                        "latitude": "24.15472000",
                        "longitude": "120.67297000"
                    }
                ]
            },
            {
                "id": 3421,
                "name": "Tainan",
                "iso2": "TNN",
                "latitude": "22.99972810",
                "longitude": "120.22702770",
                "type": "special municipality",
                "cities": [
                    {
                        "id": 109030,
                        "name": "Tainan",
                        "latitude": "22.99083000",
                        "longitude": "120.21333000"
                    },
                    {
                        "id": 109039,
                        "name": "Yujing",
                        "latitude": "23.12493000",
                        "longitude": "120.46138000"
                    }
                ]
            },
            {
                "id": 3422,
                "name": "Taipei",
                "iso2": "TPE",
                "latitude": "25.03296940",
                "longitude": "121.56541770",
                "type": "special municipality",
                "cities": [
                    {
                        "id": 109002,
                        "name": "Banqiao",
                        "latitude": "25.01427000",
                        "longitude": "121.46719000"
                    },
                    {
                        "id": 109015,
                        "name": "Jiufen",
                        "latitude": "25.10957000",
                        "longitude": "121.84424000"
                    },
                    {
                        "id": 109031,
                        "name": "Taipei",
                        "latitude": "25.04776000",
                        "longitude": "121.53185000"
                    },
                    {
                        "id": 109032,
                        "name": "Taipei City",
                        "latitude": "25.08300000",
                        "longitude": "121.55331000"
                    }
                ]
            },
            {
                "id": 3410,
                "name": "Taitung",
                "iso2": "TTT",
                "latitude": "22.79724470",
                "longitude": "121.07137020",
                "type": "county",
                "cities": [
                    {
                        "id": 109033,
                        "name": "Taitung",
                        "latitude": "22.88361000",
                        "longitude": "121.04833000"
                    },
                    {
                        "id": 109034,
                        "name": "Taitung City",
                        "latitude": "22.75830000",
                        "longitude": "121.14440000"
                    }
                ]
            },
            {
                "id": 3419,
                "name": "Taoyuan",
                "iso2": "TAO",
                "latitude": "24.99362810",
                "longitude": "121.30097980",
                "type": "special municipality",
                "cities": [
                    {
                        "id": 109006,
                        "name": "Daxi",
                        "latitude": "24.88373000",
                        "longitude": "121.29043000"
                    },
                    {
                        "id": 109035,
                        "name": "Taoyuan",
                        "latitude": "24.89500000",
                        "longitude": "121.24611000"
                    },
                    {
                        "id": 109036,
                        "name": "Taoyuan City",
                        "latitude": "24.99368000",
                        "longitude": "121.29696000"
                    }
                ]
            },
            {
                "id": 3402,
                "name": "Yilan",
                "iso2": "ILA",
                "latitude": "24.70210730",
                "longitude": "121.73775020",
                "type": "county",
                "cities": [
                    {
                        "id": 109037,
                        "name": "Yilan",
                        "latitude": "24.54250000",
                        "longitude": "121.63361000"
                    }
                ]
            },
            {
                "id": 3416,
                "name": "Yunlin",
                "iso2": "YUN",
                "latitude": "23.70920330",
                "longitude": "120.43133730",
                "type": "county",
                "cities": [
                    {
                        "id": 109008,
                        "name": "Douliu",
                        "latitude": "23.70944000",
                        "longitude": "120.54333000"
                    },
                    {
                        "id": 109040,
                        "name": "Yunlin",
                        "latitude": "23.70701000",
                        "longitude": "120.38481000"
                    }
                ]
            }
        ]
    },
    {
        "id": 217,
        "name": "Tajikistan",
        "iso3": "TJK",
        "iso2": "TJ",
        "numeric_code": "762",
        "phonecode": "992",
        "capital": "Dushanbe",
        "currency": "TJS",
        "currency_name": "Tajikistani somoni",
        "currency_symbol": "SM",
        "tld": ".tj",
        "native": "Тоҷикистон",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Central Asia",
        "subregion_id": 10,
        "nationality": "Tajikistani",
        "timezones": [
            {
                "zoneName": "Asia\/Dushanbe",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "TJT",
                "tzName": "Tajikistan Time"
            }
        ],
        "translations": {
            "br": "Tadjikistan",
            "ko": "타지키스탄",
            "pt-BR": "Tajiquistão",
            "pt": "Tajiquistão",
            "nl": "Tadzjikistan",
            "hr": "Tađikistan",
            "fa": "تاجیکستان",
            "de": "Tadschikistan",
            "es": "Tayikistán",
            "fr": "Tadjikistan",
            "ja": "タジキスタン",
            "it": "Tagikistan",
            "zh-CN": "塔吉克斯坦",
            "tr": "Tacikistan",
            "ru": "Таджикистан",
            "uk": "Таджикистан",
            "pl": "Tadżykistan"
        },
        "latitude": "39.00000000",
        "longitude": "71.00000000",
        "emoji": "🇹🇯",
        "emojiU": "U+1F1F9 U+1F1EF",
        "states": [
            {
                "id": 3399,
                "name": "Gorno-Badakhshan",
                "iso2": "GB",
                "latitude": "38.41273200",
                "longitude": "73.08774900",
                "type": "autonomous region",
                "cities": [
                    {
                        "id": 106776,
                        "name": "Ishqoshim",
                        "latitude": "36.72484000",
                        "longitude": "71.61331000"
                    },
                    {
                        "id": 106781,
                        "name": "Khorugh",
                        "latitude": "37.48974000",
                        "longitude": "71.55304000"
                    },
                    {
                        "id": 106790,
                        "name": "Murghob",
                        "latitude": "38.17023000",
                        "longitude": "73.96674000"
                    },
                    {
                        "id": 106796,
                        "name": "Nohiyai Shughnon",
                        "latitude": "37.70004000",
                        "longitude": "72.16748000"
                    }
                ]
            },
            {
                "id": 3398,
                "name": "Khatlon",
                "iso2": "KT",
                "latitude": "37.91135620",
                "longitude": "69.09702300",
                "type": "region",
                "cities": [
                    {
                        "id": 106760,
                        "name": "Abdurahmoni Jomí",
                        "latitude": "37.94636000",
                        "longitude": "68.80878000"
                    },
                    {
                        "id": 106763,
                        "name": "Boshchorbogh",
                        "latitude": "37.52027000",
                        "longitude": "68.12825000"
                    },
                    {
                        "id": 106765,
                        "name": "Bŭstonqal’a",
                        "latitude": "37.84783000",
                        "longitude": "68.83125000"
                    },
                    {
                        "id": 106767,
                        "name": "Chubek",
                        "latitude": "37.61453000",
                        "longitude": "69.70525000"
                    },
                    {
                        "id": 106768,
                        "name": "Danghara",
                        "latitude": "38.09578000",
                        "longitude": "69.33998000"
                    },
                    {
                        "id": 106770,
                        "name": "Dŭstí",
                        "latitude": "37.34812000",
                        "longitude": "68.66398000"
                    },
                    {
                        "id": 106771,
                        "name": "Farkhor",
                        "latitude": "37.49219000",
                        "longitude": "69.40356000"
                    },
                    {
                        "id": 106773,
                        "name": "Gharavŭtí",
                        "latitude": "37.56703000",
                        "longitude": "68.44668000"
                    },
                    {
                        "id": 106778,
                        "name": "Jilikŭl",
                        "latitude": "37.49167000",
                        "longitude": "68.53106000"
                    },
                    {
                        "id": 106784,
                        "name": "Kirov",
                        "latitude": "37.81908000",
                        "longitude": "68.85905000"
                    },
                    {
                        "id": 106785,
                        "name": "Kolkhozobod",
                        "latitude": "37.58823000",
                        "longitude": "68.65886000"
                    },
                    {
                        "id": 106788,
                        "name": "Kŭlob",
                        "latitude": "37.91459000",
                        "longitude": "69.78454000"
                    },
                    {
                        "id": 106789,
                        "name": "Moskovskiy",
                        "latitude": "37.60931000",
                        "longitude": "68.58094000"
                    },
                    {
                        "id": 106791,
                        "name": "Mŭ’minobod",
                        "latitude": "38.10714000",
                        "longitude": "70.03213000"
                    },
                    {
                        "id": 106793,
                        "name": "Nohiyai Kolkhozobod",
                        "latitude": "37.57277000",
                        "longitude": "68.81528000"
                    },
                    {
                        "id": 106795,
                        "name": "Nohiyai Panj",
                        "latitude": "37.31611000",
                        "longitude": "69.16679000"
                    },
                    {
                        "id": 106797,
                        "name": "Nohiyai Vakhsh",
                        "latitude": "37.75602000",
                        "longitude": "68.94138000"
                    },
                    {
                        "id": 106798,
                        "name": "Norak",
                        "latitude": "38.38917000",
                        "longitude": "69.32272000"
                    },
                    {
                        "id": 106803,
                        "name": "Orzu",
                        "latitude": "37.55820000",
                        "longitude": "68.81952000"
                    },
                    {
                        "id": 106806,
                        "name": "Panj",
                        "latitude": "37.23634000",
                        "longitude": "69.09911000"
                    },
                    {
                        "id": 106810,
                        "name": "Qŭrghonteppa",
                        "latitude": "37.83399000",
                        "longitude": "68.78186000"
                    },
                    {
                        "id": 106814,
                        "name": "Shahritus",
                        "latitude": "37.26206000",
                        "longitude": "68.13849000"
                    },
                    {
                        "id": 106817,
                        "name": "Sovet",
                        "latitude": "38.04670000",
                        "longitude": "69.58822000"
                    },
                    {
                        "id": 106820,
                        "name": "Tartiki",
                        "latitude": "37.58221000",
                        "longitude": "68.13347000"
                    },
                    {
                        "id": 106824,
                        "name": "Vakhsh",
                        "latitude": "37.71485000",
                        "longitude": "68.83456000"
                    },
                    {
                        "id": 106828,
                        "name": "Vose’",
                        "latitude": "37.80396000",
                        "longitude": "69.64417000"
                    },
                    {
                        "id": 106829,
                        "name": "Yovon",
                        "latitude": "38.31408000",
                        "longitude": "69.03784000"
                    }
                ]
            },
            {
                "id": 3397,
                "name": "Nohiyahoi Tobei Jumhurí ",
                "iso2": "RA",
                "latitude": "39.08579020",
                "longitude": "70.24083250",
                "type": "districts under republic administration",
                "cities": [
                    {
                        "id": 106769,
                        "name": "Darband",
                        "latitude": "38.86776000",
                        "longitude": "69.96642000"
                    },
                    {
                        "id": 106774,
                        "name": "Hisor",
                        "latitude": "38.52504000",
                        "longitude": "68.55124000"
                    },
                    {
                        "id": 106779,
                        "name": "Karakenja",
                        "latitude": "39.23585000",
                        "longitude": "71.52412000"
                    },
                    {
                        "id": 106780,
                        "name": "Khodzha-Maston",
                        "latitude": "38.74457000",
                        "longitude": "68.62702000"
                    },
                    {
                        "id": 106800,
                        "name": "Novobod",
                        "latitude": "39.01084000",
                        "longitude": "70.15082000"
                    },
                    {
                        "id": 106801,
                        "name": "Obigarm",
                        "latitude": "38.71731000",
                        "longitude": "69.70885000"
                    },
                    {
                        "id": 106811,
                        "name": "Rasht",
                        "latitude": "39.02871000",
                        "longitude": "70.37446000"
                    },
                    {
                        "id": 106812,
                        "name": "Roghun",
                        "latitude": "38.69331000",
                        "longitude": "69.73692000"
                    },
                    {
                        "id": 106813,
                        "name": "Shahrinav",
                        "latitude": "38.57085000",
                        "longitude": "68.33498000"
                    },
                    {
                        "id": 106819,
                        "name": "Tagob",
                        "latitude": "38.83827000",
                        "longitude": "68.89847000"
                    },
                    {
                        "id": 106821,
                        "name": "Tursunzoda",
                        "latitude": "38.51271000",
                        "longitude": "68.23163000"
                    },
                    {
                        "id": 106822,
                        "name": "Vahdat",
                        "latitude": "38.55632000",
                        "longitude": "69.01354000"
                    },
                    {
                        "id": 106823,
                        "name": "Vahdat District",
                        "latitude": "38.83333000",
                        "longitude": "69.33333000"
                    },
                    {
                        "id": 106825,
                        "name": "Varzob",
                        "latitude": "38.77369000",
                        "longitude": "68.81776000"
                    },
                    {
                        "id": 106826,
                        "name": "Varzob District",
                        "latitude": "38.75000000",
                        "longitude": "68.75000000"
                    }
                ]
            },
            {
                "id": 3400,
                "name": "Sughd ",
                "iso2": "SU",
                "latitude": "39.51553260",
                "longitude": "69.09702300",
                "type": "region",
                "cities": [
                    {
                        "id": 106761,
                        "name": "Adrasmon",
                        "latitude": "40.64928000",
                        "longitude": "69.98472000"
                    },
                    {
                        "id": 106762,
                        "name": "Ayní",
                        "latitude": "39.39406000",
                        "longitude": "68.53766000"
                    },
                    {
                        "id": 106764,
                        "name": "Bŭston",
                        "latitude": "40.52286000",
                        "longitude": "69.33307000"
                    },
                    {
                        "id": 106766,
                        "name": "Chkalov",
                        "latitude": "40.23417000",
                        "longitude": "69.69481000"
                    },
                    {
                        "id": 106772,
                        "name": "Ghafurov",
                        "latitude": "40.21571000",
                        "longitude": "69.72867000"
                    },
                    {
                        "id": 106775,
                        "name": "Isfara",
                        "latitude": "40.12649000",
                        "longitude": "70.62526000"
                    },
                    {
                        "id": 106777,
                        "name": "Istaravshan",
                        "latitude": "39.91420000",
                        "longitude": "69.00328000"
                    },
                    {
                        "id": 106782,
                        "name": "Khŭjand",
                        "latitude": "40.28256000",
                        "longitude": "69.62216000"
                    },
                    {
                        "id": 106783,
                        "name": "Kim",
                        "latitude": "40.20798000",
                        "longitude": "70.46882000"
                    },
                    {
                        "id": 106786,
                        "name": "Konibodom",
                        "latitude": "40.29414000",
                        "longitude": "70.43122000"
                    },
                    {
                        "id": 106787,
                        "name": "Konsoy",
                        "latitude": "40.49155000",
                        "longitude": "69.70245000"
                    },
                    {
                        "id": 106792,
                        "name": "Neftobod",
                        "latitude": "40.21524000",
                        "longitude": "70.57193000"
                    },
                    {
                        "id": 106794,
                        "name": "Nohiyai Konibodom",
                        "latitude": "40.26877000",
                        "longitude": "70.33057000"
                    },
                    {
                        "id": 106799,
                        "name": "Nov",
                        "latitude": "40.15220000",
                        "longitude": "69.37076000"
                    },
                    {
                        "id": 106802,
                        "name": "Oltintopkan",
                        "latitude": "40.65425000",
                        "longitude": "69.59811000"
                    },
                    {
                        "id": 106804,
                        "name": "Pakhtakoron",
                        "latitude": "40.15709000",
                        "longitude": "68.74659000"
                    },
                    {
                        "id": 106805,
                        "name": "Palos",
                        "latitude": "40.31628000",
                        "longitude": "69.73743000"
                    },
                    {
                        "id": 106807,
                        "name": "Panjakent",
                        "latitude": "39.49524000",
                        "longitude": "67.60931000"
                    },
                    {
                        "id": 106808,
                        "name": "Proletar",
                        "latitude": "40.16713000",
                        "longitude": "69.50163000"
                    },
                    {
                        "id": 106809,
                        "name": "Quruqsoy",
                        "latitude": "40.57648000",
                        "longitude": "69.37962000"
                    },
                    {
                        "id": 106815,
                        "name": "Shaydon",
                        "latitude": "40.66992000",
                        "longitude": "70.35020000"
                    },
                    {
                        "id": 106816,
                        "name": "Shŭrob",
                        "latitude": "40.04605000",
                        "longitude": "70.54117000"
                    },
                    {
                        "id": 106818,
                        "name": "Taboshar",
                        "latitude": "40.57017000",
                        "longitude": "69.64175000"
                    },
                    {
                        "id": 106827,
                        "name": "Vorukh",
                        "latitude": "39.85125000",
                        "longitude": "70.58012000"
                    }
                ]
            }
        ]
    },
    {
        "id": 218,
        "name": "Tanzania",
        "iso3": "TZA",
        "iso2": "TZ",
        "numeric_code": "834",
        "phonecode": "255",
        "capital": "Dodoma",
        "currency": "TZS",
        "currency_name": "Tanzanian shilling",
        "currency_symbol": "TSh",
        "tld": ".tz",
        "native": "Tanzania",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Tanzanian",
        "timezones": [
            {
                "zoneName": "Africa\/Dar_es_Salaam",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Tanzania",
            "ko": "탄자니아",
            "pt-BR": "Tanzânia",
            "pt": "Tanzânia",
            "nl": "Tanzania",
            "hr": "Tanzanija",
            "fa": "تانزانیا",
            "de": "Tansania",
            "es": "Tanzania",
            "fr": "Tanzanie",
            "ja": "タンザニア",
            "it": "Tanzania",
            "zh-CN": "坦桑尼亚",
            "tr": "Tanzanya",
            "ru": "Танзания",
            "uk": "Танзанія",
            "pl": "Tanzania"
        },
        "latitude": "-6.00000000",
        "longitude": "35.00000000",
        "emoji": "🇹🇿",
        "emojiU": "U+1F1F9 U+1F1FF",
        "states": [
            {
                "id": 1491,
                "name": "Arusha",
                "iso2": "01",
                "latitude": "-3.38692540",
                "longitude": "36.68299270",
                "type": "region",
                "cities": [
                    {
                        "id": 109042,
                        "name": "Arusha",
                        "latitude": "-3.36667000",
                        "longitude": "36.68333000"
                    },
                    {
                        "id": 109117,
                        "name": "Kingori",
                        "latitude": "-3.28333000",
                        "longitude": "36.98333000"
                    },
                    {
                        "id": 109121,
                        "name": "Kiratu",
                        "latitude": "-3.33333000",
                        "longitude": "35.66667000"
                    },
                    {
                        "id": 109144,
                        "name": "Longido",
                        "latitude": "-2.73319000",
                        "longitude": "36.69773000"
                    },
                    {
                        "id": 109189,
                        "name": "Mbuguni",
                        "latitude": "-3.56667000",
                        "longitude": "36.95000000"
                    },
                    {
                        "id": 109192,
                        "name": "Merelani",
                        "latitude": "-3.56182000",
                        "longitude": "36.97895000"
                    },
                    {
                        "id": 109193,
                        "name": "Meru",
                        "latitude": "-3.30500000",
                        "longitude": "36.80100000"
                    },
                    {
                        "id": 109207,
                        "name": "Monduli",
                        "latitude": "-3.30000000",
                        "longitude": "36.45000000"
                    },
                    {
                        "id": 109218,
                        "name": "Mto wa Mbu",
                        "latitude": "-3.35000000",
                        "longitude": "35.85000000"
                    },
                    {
                        "id": 109238,
                        "name": "Namanga",
                        "latitude": "-2.55116000",
                        "longitude": "36.78377000"
                    },
                    {
                        "id": 109253,
                        "name": "Ngorongoro",
                        "latitude": "-3.23973000",
                        "longitude": "35.48747000"
                    },
                    {
                        "id": 109257,
                        "name": "Nkoaranga",
                        "latitude": "-3.33333000",
                        "longitude": "36.80000000"
                    },
                    {
                        "id": 109270,
                        "name": "Poli",
                        "latitude": "-3.33333000",
                        "longitude": "36.80000000"
                    },
                    {
                        "id": 109293,
                        "name": "Usa River",
                        "latitude": "-3.36667000",
                        "longitude": "36.85000000"
                    }
                ]
            },
            {
                "id": 1490,
                "name": "Dar es Salaam",
                "iso2": "02",
                "latitude": "-6.79235400",
                "longitude": "39.20832840",
                "type": "region",
                "cities": [
                    {
                        "id": 109063,
                        "name": "Dar es Salaam",
                        "latitude": "-6.82349000",
                        "longitude": "39.26951000"
                    },
                    {
                        "id": 153775,
                        "name": "Ilala",
                        "latitude": "-6.84873800",
                        "longitude": "39.28471300"
                    },
                    {
                        "id": 153776,
                        "name": "Kigamboni",
                        "latitude": "-6.84945500",
                        "longitude": "39.31733300"
                    },
                    {
                        "id": 153777,
                        "name": "Kinondoni",
                        "latitude": "-6.78423100",
                        "longitude": "39.26567600"
                    },
                    {
                        "id": 109157,
                        "name": "Magomeni",
                        "latitude": "-6.80000000",
                        "longitude": "39.25000000"
                    },
                    {
                        "id": 153778,
                        "name": "Temeke",
                        "latitude": "-6.90418400",
                        "longitude": "39.23528200"
                    },
                    {
                        "id": 153779,
                        "name": "Ubungo",
                        "latitude": "-6.80600500",
                        "longitude": "39.24663600"
                    }
                ]
            },
            {
                "id": 1466,
                "name": "Dodoma",
                "iso2": "03",
                "latitude": "-6.57382280",
                "longitude": "36.26308460",
                "type": "region",
                "cities": [
                    {
                        "id": 109065,
                        "name": "Dodoma",
                        "latitude": "-6.17221000",
                        "longitude": "35.73947000"
                    },
                    {
                        "id": 109101,
                        "name": "Kibakwe",
                        "latitude": "-6.71667000",
                        "longitude": "36.36667000"
                    },
                    {
                        "id": 109125,
                        "name": "Kisasa",
                        "latitude": "-6.17526000",
                        "longitude": "35.79266000"
                    },
                    {
                        "id": 109135,
                        "name": "Kondoa",
                        "latitude": "-4.70931000",
                        "longitude": "35.86227000"
                    },
                    {
                        "id": 109136,
                        "name": "Kongwa",
                        "latitude": "-6.20000000",
                        "longitude": "36.41667000"
                    },
                    {
                        "id": 109211,
                        "name": "Mpwapwa",
                        "latitude": "-6.35000000",
                        "longitude": "36.48333000"
                    },
                    {
                        "id": 109212,
                        "name": "Msanga",
                        "latitude": "-6.05000000",
                        "longitude": "36.03333000"
                    }
                ]
            },
            {
                "id": 1481,
                "name": "Geita",
                "iso2": "27",
                "latitude": "-2.82422570",
                "longitude": "32.26538870",
                "type": "region",
                "cities": [
                    {
                        "id": 109055,
                        "name": "Buseresere",
                        "latitude": "-3.02361000",
                        "longitude": "31.87472000"
                    },
                    {
                        "id": 109061,
                        "name": "Chato",
                        "latitude": "-2.63778000",
                        "longitude": "31.76694000"
                    },
                    {
                        "id": 109071,
                        "name": "Geita",
                        "latitude": "-2.87250000",
                        "longitude": "32.23250000"
                    },
                    {
                        "id": 109094,
                        "name": "Kasamwa",
                        "latitude": "-2.85000000",
                        "longitude": "32.43333000"
                    },
                    {
                        "id": 109098,
                        "name": "Katoro",
                        "latitude": "-3.02028000",
                        "longitude": "31.89583000"
                    },
                    {
                        "id": 109178,
                        "name": "Masumbwe",
                        "latitude": "-3.63333000",
                        "longitude": "32.18333000"
                    },
                    {
                        "id": 109296,
                        "name": "Ushirombo",
                        "latitude": "-3.49194000",
                        "longitude": "31.96389000"
                    },
                    {
                        "id": 109301,
                        "name": "Uyovu",
                        "latitude": "-3.28333000",
                        "longitude": "31.52583000"
                    }
                ]
            },
            {
                "id": 1489,
                "name": "Iringa",
                "iso2": "04",
                "latitude": "-7.78874420",
                "longitude": "35.56578620",
                "type": "region",
                "cities": [
                    {
                        "id": 109081,
                        "name": "Ilula",
                        "latitude": "-7.67660000",
                        "longitude": "36.03658000"
                    },
                    {
                        "id": 109083,
                        "name": "Iringa",
                        "latitude": "-7.76667000",
                        "longitude": "35.70000000"
                    },
                    {
                        "id": 109087,
                        "name": "Izazi",
                        "latitude": "-7.20000000",
                        "longitude": "35.73333000"
                    },
                    {
                        "id": 109154,
                        "name": "Mafinga",
                        "latitude": "-7.25000000",
                        "longitude": "35.06667000"
                    },
                    {
                        "id": 109166,
                        "name": "Makungu",
                        "latitude": "-8.73333000",
                        "longitude": "35.28333000"
                    },
                    {
                        "id": 109169,
                        "name": "Malangali",
                        "latitude": "-8.56667000",
                        "longitude": "34.85000000"
                    }
                ]
            },
            {
                "id": 1465,
                "name": "Kagera",
                "iso2": "05",
                "latitude": "-1.30011150",
                "longitude": "31.26263660",
                "type": "region",
                "cities": [
                    {
                        "id": 109048,
                        "name": "Biharamulo",
                        "latitude": "-2.63194000",
                        "longitude": "31.30889000"
                    },
                    {
                        "id": 109049,
                        "name": "Bugarama",
                        "latitude": "-2.87056000",
                        "longitude": "30.52806000"
                    },
                    {
                        "id": 109050,
                        "name": "Bugene",
                        "latitude": "-1.59111000",
                        "longitude": "31.14028000"
                    },
                    {
                        "id": 109052,
                        "name": "Bukoba",
                        "latitude": "-1.33167000",
                        "longitude": "31.81222000"
                    },
                    {
                        "id": 109088,
                        "name": "Kabanga",
                        "latitude": "-2.63861000",
                        "longitude": "30.46778000"
                    },
                    {
                        "id": 109092,
                        "name": "Kamachumu",
                        "latitude": "-1.61861000",
                        "longitude": "31.62000000"
                    },
                    {
                        "id": 109096,
                        "name": "Katerero",
                        "latitude": "-1.40000000",
                        "longitude": "31.73333000"
                    },
                    {
                        "id": 109099,
                        "name": "Katoro",
                        "latitude": "-1.39972000",
                        "longitude": "31.50028000"
                    },
                    {
                        "id": 109138,
                        "name": "Kyaka",
                        "latitude": "-1.25222000",
                        "longitude": "31.42028000"
                    },
                    {
                        "id": 109251,
                        "name": "Ngara",
                        "latitude": "-2.51222000",
                        "longitude": "30.65583000"
                    },
                    {
                        "id": 109259,
                        "name": "Nshamba",
                        "latitude": "-1.79833000",
                        "longitude": "31.55111000"
                    },
                    {
                        "id": 109260,
                        "name": "Nsunga",
                        "latitude": "-1.14389000",
                        "longitude": "31.39472000"
                    },
                    {
                        "id": 109263,
                        "name": "Nyakahanga",
                        "latitude": "-1.60333000",
                        "longitude": "31.14139000"
                    },
                    {
                        "id": 109273,
                        "name": "Rulenge",
                        "latitude": "-2.71750000",
                        "longitude": "30.63250000"
                    }
                ]
            },
            {
                "id": 1482,
                "name": "Katavi",
                "iso2": "28",
                "latitude": "-6.36771250",
                "longitude": "31.26263660",
                "type": "region",
                "cities": [
                    {
                        "id": 109082,
                        "name": "Inyonga",
                        "latitude": "-6.71667000",
                        "longitude": "32.06667000"
                    },
                    {
                        "id": 109093,
                        "name": "Karema",
                        "latitude": "-6.82052000",
                        "longitude": "30.43887000"
                    },
                    {
                        "id": 109210,
                        "name": "Mpanda",
                        "latitude": "-6.34379000",
                        "longitude": "31.06951000"
                    },
                    {
                        "id": 109295,
                        "name": "Usevia",
                        "latitude": "-7.10000000",
                        "longitude": "31.23333000"
                    }
                ]
            },
            {
                "id": 1478,
                "name": "Kigoma",
                "iso2": "08",
                "latitude": "-4.88240920",
                "longitude": "29.66150550",
                "type": "region",
                "cities": [
                    {
                        "id": 109090,
                        "name": "Kakonko",
                        "latitude": "-3.28278000",
                        "longitude": "30.96417000"
                    },
                    {
                        "id": 109095,
                        "name": "Kasulu",
                        "latitude": "-4.57667000",
                        "longitude": "30.10250000"
                    },
                    {
                        "id": 109105,
                        "name": "Kibondo",
                        "latitude": "-3.58639000",
                        "longitude": "30.72028000"
                    },
                    {
                        "id": 109108,
                        "name": "Kigoma",
                        "latitude": "-4.87694000",
                        "longitude": "29.62667000"
                    },
                    {
                        "id": 109152,
                        "name": "Mabamba",
                        "latitude": "-3.59833000",
                        "longitude": "30.50194000"
                    },
                    {
                        "id": 109230,
                        "name": "Mwandiga",
                        "latitude": "-4.83000000",
                        "longitude": "29.65806000"
                    },
                    {
                        "id": 109255,
                        "name": "Nguruka",
                        "latitude": "-5.10917000",
                        "longitude": "31.04194000"
                    },
                    {
                        "id": 109299,
                        "name": "Uvinza",
                        "latitude": "-5.10361000",
                        "longitude": "30.39111000"
                    }
                ]
            },
            {
                "id": 1467,
                "name": "Kilimanjaro",
                "iso2": "09",
                "latitude": "-4.13369270",
                "longitude": "37.80876930",
                "type": "region",
                "cities": [
                    {
                        "id": 109072,
                        "name": "Hedaru",
                        "latitude": "-4.50000000",
                        "longitude": "37.90000000"
                    },
                    {
                        "id": 109164,
                        "name": "Machame",
                        "latitude": "-3.20611000",
                        "longitude": "37.22638890"
                    },
                    {
                        "id": 109233,
                        "name": "Marangu",
                        "latitude": "-3.28333000",
                        "longitude": "37.51667000"
                    },
                    {
                        "id": 109209,
                        "name": "Moshi",
                        "latitude": "-3.35000000",
                        "longitude": "37.33333000"
                    },
                    {
                        "id": 109274,
                        "name": "Same",
                        "latitude": "-4.22199000",
                        "longitude": "37.88278000"
                    }
                ]
            },
            {
                "id": 1483,
                "name": "Lindi",
                "iso2": "12",
                "latitude": "-9.23433940",
                "longitude": "38.31657250",
                "type": "region",
                "cities": [
                    {
                        "id": 109142,
                        "name": "Lindi",
                        "latitude": "-9.99709000",
                        "longitude": "39.71649000"
                    },
                    {
                        "id": 109187,
                        "name": "Mbekenyera",
                        "latitude": "-10.00000000",
                        "longitude": "38.98333000"
                    },
                    {
                        "id": 109198,
                        "name": "Mingoyo",
                        "latitude": "-10.10526000",
                        "longitude": "39.61859000"
                    },
                    {
                        "id": 109214,
                        "name": "Mtama",
                        "latitude": "-10.30000000",
                        "longitude": "39.36667000"
                    },
                    {
                        "id": 109235,
                        "name": "Nachingwea",
                        "latitude": "-10.37250000",
                        "longitude": "38.76251000"
                    },
                    {
                        "id": 109266,
                        "name": "Nyangao",
                        "latitude": "-10.33333000",
                        "longitude": "39.28333000"
                    },
                    {
                        "id": 109272,
                        "name": "Ruangwa",
                        "latitude": "-10.06667000",
                        "longitude": "38.93333000"
                    }
                ]
            },
            {
                "id": 1484,
                "name": "Manyara",
                "iso2": "26",
                "latitude": "-4.31500580",
                "longitude": "36.95410700",
                "type": "region",
                "cities": [
                    {
                        "id": 109043,
                        "name": "Babati",
                        "latitude": "-4.21667000",
                        "longitude": "35.75000000"
                    },
                    {
                        "id": 109046,
                        "name": "Bashanet",
                        "latitude": "-4.23333000",
                        "longitude": "35.41667000"
                    },
                    {
                        "id": 109047,
                        "name": "Basotu",
                        "latitude": "-4.36667000",
                        "longitude": "35.08333000"
                    },
                    {
                        "id": 109064,
                        "name": "Dareda",
                        "latitude": "-4.21667000",
                        "longitude": "35.55000000"
                    },
                    {
                        "id": 109066,
                        "name": "Dongobesh",
                        "latitude": "-4.06667000",
                        "longitude": "35.38333000"
                    },
                    {
                        "id": 109067,
                        "name": "Endasak",
                        "latitude": "-4.41667000",
                        "longitude": "35.51667000"
                    },
                    {
                        "id": 109068,
                        "name": "Galappo",
                        "latitude": "-4.26667000",
                        "longitude": "35.85000000"
                    },
                    {
                        "id": 109097,
                        "name": "Katesh",
                        "latitude": "-4.52483000",
                        "longitude": "35.38490000"
                    },
                    {
                        "id": 109103,
                        "name": "Kibaya",
                        "latitude": "-5.30000000",
                        "longitude": "36.56667000"
                    },
                    {
                        "id": 109122,
                        "name": "Kirya",
                        "latitude": "-3.91667000",
                        "longitude": "37.48333000"
                    },
                    {
                        "id": 109158,
                        "name": "Magugu",
                        "latitude": "-4.01667000",
                        "longitude": "35.76667000"
                    },
                    {
                        "id": 109190,
                        "name": "Mbulu",
                        "latitude": "-3.85000000",
                        "longitude": "35.53333000"
                    },
                    {
                        "id": 109234,
                        "name": "Naberera",
                        "latitude": "-4.20000000",
                        "longitude": "36.93333000"
                    },
                    {
                        "id": 109243,
                        "name": "Nangwa",
                        "latitude": "-4.46667000",
                        "longitude": "35.45000000"
                    }
                ]
            },
            {
                "id": 1468,
                "name": "Mara",
                "iso2": "13",
                "latitude": "-1.77535380",
                "longitude": "34.15319470",
                "type": "region",
                "cities": [
                    {
                        "id": 109053,
                        "name": "Bukonyo",
                        "latitude": "-1.95000000",
                        "longitude": "32.93333000"
                    },
                    {
                        "id": 109056,
                        "name": "Butiama",
                        "latitude": "-1.76667000",
                        "longitude": "33.96667000"
                    },
                    {
                        "id": 109085,
                        "name": "Issenye",
                        "latitude": "-2.00000000",
                        "longitude": "34.33333000"
                    },
                    {
                        "id": 109102,
                        "name": "Kibara",
                        "latitude": "-2.15000000",
                        "longitude": "33.45000000"
                    },
                    {
                        "id": 109221,
                        "name": "Mugango",
                        "latitude": "-1.68333000",
                        "longitude": "33.70000000"
                    },
                    {
                        "id": 109222,
                        "name": "Mugumu",
                        "latitude": "-1.85000000",
                        "longitude": "34.70000000"
                    },
                    {
                        "id": 109225,
                        "name": "Muriti",
                        "latitude": "-1.98333000",
                        "longitude": "32.91667000"
                    },
                    {
                        "id": 109226,
                        "name": "Musoma",
                        "latitude": "-1.50000000",
                        "longitude": "33.80000000"
                    },
                    {
                        "id": 109236,
                        "name": "Nakatunguru",
                        "latitude": "-2.11667000",
                        "longitude": "33.06667000"
                    },
                    {
                        "id": 109245,
                        "name": "Nansio",
                        "latitude": "-2.13333000",
                        "longitude": "33.05000000"
                    },
                    {
                        "id": 109265,
                        "name": "Nyamuswa",
                        "latitude": "-1.90000000",
                        "longitude": "34.01667000"
                    },
                    {
                        "id": 109280,
                        "name": "Sirari",
                        "latitude": "-1.25367000",
                        "longitude": "34.47596000"
                    }
                ]
            },
            {
                "id": 4955,
                "name": "Mbeya",
                "iso2": "14",
                "latitude": "-8.28661120",
                "longitude": "32.81325370",
                "type": "region",
                "cities": [
                    {
                        "id": 149030,
                        "name": "Chimala",
                        "latitude": "-8.85637000",
                        "longitude": "34.02393000"
                    },
                    {
                        "id": 149031,
                        "name": "Hedaru",
                        "latitude": "-4.50000000",
                        "longitude": "37.90000000"
                    },
                    {
                        "id": 149032,
                        "name": "Ibaba",
                        "latitude": "-9.40000000",
                        "longitude": "33.35000000"
                    },
                    {
                        "id": 149033,
                        "name": "Ikama",
                        "latitude": "-9.26666667",
                        "longitude": "33.83333333"
                    },
                    {
                        "id": 149034,
                        "name": "Ikinga",
                        "latitude": "-9.50000000",
                        "longitude": "33.55000000"
                    },
                    {
                        "id": 149035,
                        "name": "Ikolo",
                        "latitude": "-9.65000000",
                        "longitude": "33.90000000"
                    },
                    {
                        "id": 149036,
                        "name": "Ikuti",
                        "latitude": "-9.31666667",
                        "longitude": "33.53333333"
                    },
                    {
                        "id": 149037,
                        "name": "Ilembo",
                        "latitude": "-9.25000000",
                        "longitude": "33.38333333"
                    },
                    {
                        "id": 149038,
                        "name": "Ipinda",
                        "latitude": "-9.48333333",
                        "longitude": "33.90000000"
                    },
                    {
                        "id": 149039,
                        "name": "Kabula",
                        "latitude": "-9.26666667",
                        "longitude": "33.76666667"
                    },
                    {
                        "id": 149040,
                        "name": "Kahe Tanzania",
                        "latitude": "-3.50000000",
                        "longitude": "37.43300000"
                    },
                    {
                        "id": 149041,
                        "name": "Kandete",
                        "latitude": "-9.15000000",
                        "longitude": "33.80000000"
                    },
                    {
                        "id": 149042,
                        "name": "Katumba",
                        "latitude": "-9.23333333",
                        "longitude": "33.61666667"
                    },
                    {
                        "id": 149043,
                        "name": "Kihurio",
                        "latitude": "-4.46666667",
                        "longitude": "38.06666667"
                    },
                    {
                        "id": 149044,
                        "name": "Kisiwani",
                        "latitude": "-4.13333000",
                        "longitude": "37.95000000"
                    },
                    {
                        "id": 149045,
                        "name": "Kiwira",
                        "latitude": "-9.16666667",
                        "longitude": "33.53333333"
                    },
                    {
                        "id": 149046,
                        "name": "Kwakoa",
                        "latitude": "-3.76666667",
                        "longitude": "37.71666667"
                    },
                    {
                        "id": 149047,
                        "name": "Lembeni",
                        "latitude": "-3.78333333",
                        "longitude": "37.61666667"
                    },
                    {
                        "id": 149048,
                        "name": "Lupata",
                        "latitude": "-9.30000000",
                        "longitude": "33.85000000"
                    },
                    {
                        "id": 149049,
                        "name": "Lusungo",
                        "latitude": "-9.50000000",
                        "longitude": "33.98333333"
                    },
                    {
                        "id": 149050,
                        "name": "Machame",
                        "latitude": "-3.20611111",
                        "longitude": "37.22638889"
                    },
                    {
                        "id": 149051,
                        "name": "Makanya",
                        "latitude": "-4.36666667",
                        "longitude": "37.83333333"
                    },
                    {
                        "id": 149052,
                        "name": "Marangu",
                        "latitude": "-3.28333000",
                        "longitude": "37.51667000"
                    },
                    {
                        "id": 149053,
                        "name": "Masukulu",
                        "latitude": "-9.40000000",
                        "longitude": "33.75000000"
                    },
                    {
                        "id": 149054,
                        "name": "Mbeya",
                        "latitude": "-8.90000000",
                        "longitude": "33.45000000"
                    },
                    {
                        "id": 149055,
                        "name": "Mlowo",
                        "latitude": "-9.00000000",
                        "longitude": "32.98333333"
                    },
                    {
                        "id": 149056,
                        "name": "Moshi",
                        "latitude": "-3.33488333",
                        "longitude": "37.34038056"
                    },
                    {
                        "id": 149057,
                        "name": "Mpuguso",
                        "latitude": "-9.31666667",
                        "longitude": "33.65000000"
                    },
                    {
                        "id": 149058,
                        "name": "Mwansanga",
                        "latitude": "-8.76666667",
                        "longitude": "33.53333333"
                    },
                    {
                        "id": 149059,
                        "name": "Mwaya",
                        "latitude": "-9.55000000",
                        "longitude": "33.95000000"
                    },
                    {
                        "id": 149060,
                        "name": "Mwembe",
                        "latitude": "-4.15000000",
                        "longitude": "37.85000000"
                    },
                    {
                        "id": 149061,
                        "name": "Same",
                        "latitude": "-4.06666667",
                        "longitude": "37.78333333"
                    },
                    {
                        "id": 149062,
                        "name": "Tukuyu",
                        "latitude": "-9.25833333",
                        "longitude": "33.64166667"
                    },
                    {
                        "id": 149063,
                        "name": "Tunduma",
                        "latitude": "-9.30000000",
                        "longitude": "32.76670000"
                    },
                    {
                        "id": 149064,
                        "name": "Ugweno",
                        "latitude": "-3.65000000",
                        "longitude": "37.65000000"
                    },
                    {
                        "id": 149065,
                        "name": "Ulanga",
                        "latitude": "-8.34361000",
                        "longitude": "34.28970000"
                    }
                ]
            },
            {
                "id": 1470,
                "name": "Morogoro",
                "iso2": "16",
                "latitude": "-8.81371730",
                "longitude": "36.95410700",
                "type": "region",
                "cities": [
                    {
                        "id": 109070,
                        "name": "Geiro",
                        "latitude": "-6.15000000",
                        "longitude": "36.86667000"
                    },
                    {
                        "id": 109073,
                        "name": "Ifakara",
                        "latitude": "-8.13333000",
                        "longitude": "36.68333000"
                    },
                    {
                        "id": 109106,
                        "name": "Kidatu",
                        "latitude": "-7.69916000",
                        "longitude": "36.95722000"
                    },
                    {
                        "id": 109107,
                        "name": "Kidodi",
                        "latitude": "-7.60361000",
                        "longitude": "37.00438000"
                    },
                    {
                        "id": 109115,
                        "name": "Kilosa",
                        "latitude": "-6.83333000",
                        "longitude": "36.98333000"
                    },
                    {
                        "id": 109116,
                        "name": "Kimamba",
                        "latitude": "-6.78333000",
                        "longitude": "37.13333000"
                    },
                    {
                        "id": 109123,
                        "name": "Kisanga",
                        "latitude": "-7.43622000",
                        "longitude": "37.70337000"
                    },
                    {
                        "id": 109149,
                        "name": "Lupiro",
                        "latitude": "-8.38333000",
                        "longitude": "36.66667000"
                    },
                    {
                        "id": 109155,
                        "name": "Magole",
                        "latitude": "-6.37697000",
                        "longitude": "37.37373000"
                    },
                    {
                        "id": 109160,
                        "name": "Mahenge",
                        "latitude": "-8.68333000",
                        "longitude": "36.71667000"
                    },
                    {
                        "id": 109170,
                        "name": "Malinyi",
                        "latitude": "-8.93333000",
                        "longitude": "36.13333000"
                    },
                    {
                        "id": 109197,
                        "name": "Mikumi",
                        "latitude": "-7.40409000",
                        "longitude": "36.98309000"
                    },
                    {
                        "id": 109206,
                        "name": "Mlimba",
                        "latitude": "-8.80000000",
                        "longitude": "35.81667000"
                    },
                    {
                        "id": 109208,
                        "name": "Morogoro",
                        "latitude": "-6.82102000",
                        "longitude": "37.66122000"
                    },
                    {
                        "id": 109213,
                        "name": "Msowero",
                        "latitude": "-6.53333000",
                        "longitude": "37.20000000"
                    },
                    {
                        "id": 109216,
                        "name": "Mtimbira",
                        "latitude": "-8.78333000",
                        "longitude": "36.35000000"
                    },
                    {
                        "id": 109228,
                        "name": "Mvomero District",
                        "latitude": "-6.30000000",
                        "longitude": "37.45000000"
                    },
                    {
                        "id": 109252,
                        "name": "Ngerengere",
                        "latitude": "-6.75000000",
                        "longitude": "38.11667000"
                    }
                ]
            },
            {
                "id": 1476,
                "name": "Mtwara",
                "iso2": "17",
                "latitude": "-10.33984550",
                "longitude": "40.16574660",
                "type": "region",
                "cities": [
                    {
                        "id": 109062,
                        "name": "Chiungutwa",
                        "latitude": "-10.88333000",
                        "longitude": "38.98333000"
                    },
                    {
                        "id": 109129,
                        "name": "Kitama",
                        "latitude": "-10.71667000",
                        "longitude": "39.73333000"
                    },
                    {
                        "id": 109130,
                        "name": "Kitangari",
                        "latitude": "-10.65000000",
                        "longitude": "39.33333000"
                    },
                    {
                        "id": 109145,
                        "name": "Luchingu",
                        "latitude": "-10.90000000",
                        "longitude": "39.33333000"
                    },
                    {
                        "id": 109147,
                        "name": "Lukuledi",
                        "latitude": "-10.56667000",
                        "longitude": "38.80000000"
                    },
                    {
                        "id": 109148,
                        "name": "Lulindi",
                        "latitude": "-10.81667000",
                        "longitude": "39.13333000"
                    },
                    {
                        "id": 109153,
                        "name": "Madimba",
                        "latitude": "-10.40000000",
                        "longitude": "40.33333000"
                    },
                    {
                        "id": 109162,
                        "name": "Mahuta",
                        "latitude": "-10.86667000",
                        "longitude": "39.45000000"
                    },
                    {
                        "id": 109176,
                        "name": "Masasi",
                        "latitude": "-10.71667000",
                        "longitude": "38.80000000"
                    },
                    {
                        "id": 109177,
                        "name": "Masuguru",
                        "latitude": "-11.36667000",
                        "longitude": "38.41667000"
                    },
                    {
                        "id": 109220,
                        "name": "Mtwara",
                        "latitude": "-10.26667000",
                        "longitude": "40.18333000"
                    },
                    {
                        "id": 109237,
                        "name": "Namalenga",
                        "latitude": "-10.95000000",
                        "longitude": "39.10000000"
                    },
                    {
                        "id": 109240,
                        "name": "Namikupa",
                        "latitude": "-10.83333000",
                        "longitude": "39.60000000"
                    },
                    {
                        "id": 109241,
                        "name": "Nanganga",
                        "latitude": "-10.38333000",
                        "longitude": "39.15000000"
                    },
                    {
                        "id": 109242,
                        "name": "Nangomba",
                        "latitude": "-10.90000000",
                        "longitude": "38.50000000"
                    },
                    {
                        "id": 109244,
                        "name": "Nanhyanga",
                        "latitude": "-10.80000000",
                        "longitude": "39.55000000"
                    },
                    {
                        "id": 109246,
                        "name": "Nanyamba",
                        "latitude": "-10.68333000",
                        "longitude": "39.83333000"
                    },
                    {
                        "id": 109249,
                        "name": "Newala Kisimani",
                        "latitude": "-10.95000000",
                        "longitude": "39.28333000"
                    },
                    {
                        "id": 109288,
                        "name": "Tandahimba",
                        "latitude": "-10.75000000",
                        "longitude": "39.63333000"
                    }
                ]
            },
            {
                "id": 1479,
                "name": "Mwanza",
                "iso2": "18",
                "latitude": "-2.44501080",
                "longitude": "32.15785420",
                "type": "region",
                "cities": [
                    {
                        "id": 109079,
                        "name": "Ilemela District",
                        "latitude": "-2.44783000",
                        "longitude": "33.03177000"
                    },
                    {
                        "id": 109110,
                        "name": "Kihangara",
                        "latitude": "-2.58333000",
                        "longitude": "33.35000000"
                    },
                    {
                        "id": 109171,
                        "name": "Malya",
                        "latitude": "-2.98333000",
                        "longitude": "33.51667000"
                    },
                    {
                        "id": 109199,
                        "name": "Misasi",
                        "latitude": "-3.00000000",
                        "longitude": "33.08333000"
                    },
                    {
                        "id": 109200,
                        "name": "Misungwi",
                        "latitude": "-2.85000000",
                        "longitude": "33.08333000"
                    },
                    {
                        "id": 109232,
                        "name": "Mwanza",
                        "latitude": "-2.51667000",
                        "longitude": "32.90000000"
                    },
                    {
                        "id": 109254,
                        "name": "Ngudu",
                        "latitude": "-2.96667000",
                        "longitude": "33.33333000"
                    },
                    {
                        "id": 109267,
                        "name": "Nyanguge",
                        "latitude": "-2.55000000",
                        "longitude": "33.20000000"
                    },
                    {
                        "id": 109294,
                        "name": "Usagara",
                        "latitude": "-2.68333000",
                        "longitude": "33.00000000"
                    }
                ]
            },
            {
                "id": 1480,
                "name": "Njombe",
                "iso2": "29",
                "latitude": "-9.24226320",
                "longitude": "35.12687810",
                "type": "region",
                "cities": [
                    {
                        "id": 109078,
                        "name": "Ilembula",
                        "latitude": "-8.90000000",
                        "longitude": "34.58333000"
                    },
                    {
                        "id": 109165,
                        "name": "Makumbako",
                        "latitude": "-8.85000000",
                        "longitude": "34.83333000"
                    },
                    {
                        "id": 109172,
                        "name": "Manda",
                        "latitude": "-10.46667000",
                        "longitude": "34.58333000"
                    },
                    {
                        "id": 109181,
                        "name": "Matamba",
                        "latitude": "-8.98333000",
                        "longitude": "33.96667000"
                    },
                    {
                        "id": 109205,
                        "name": "Mlangali",
                        "latitude": "-9.78333000",
                        "longitude": "34.51667000"
                    },
                    {
                        "id": 109219,
                        "name": "Mtwango",
                        "latitude": "-9.01667000",
                        "longitude": "34.80000000"
                    },
                    {
                        "id": 109256,
                        "name": "Njombe",
                        "latitude": "-9.34917000",
                        "longitude": "34.77167000"
                    }
                ]
            },
            {
                "id": 1488,
                "name": "Pemba North",
                "iso2": "06",
                "latitude": "-5.03193520",
                "longitude": "39.77555710",
                "type": "region",
                "cities": [
                    {
                        "id": 109134,
                        "name": "Konde",
                        "latitude": "-4.95000000",
                        "longitude": "39.75000000"
                    },
                    {
                        "id": 109196,
                        "name": "Micheweni",
                        "latitude": "-4.96667000",
                        "longitude": "39.83333000"
                    },
                    {
                        "id": 109303,
                        "name": "Wete",
                        "latitude": "-5.05589000",
                        "longitude": "39.72938000"
                    }
                ]
            },
            {
                "id": 1472,
                "name": "Pemba South",
                "iso2": "10",
                "latitude": "-5.31469610",
                "longitude": "39.75495110",
                "type": "region",
                "cities": [
                    {
                        "id": 109057,
                        "name": "Chake Chake",
                        "latitude": "-5.24586000",
                        "longitude": "39.76659000"
                    },
                    {
                        "id": 109215,
                        "name": "Mtambile",
                        "latitude": "-5.38333000",
                        "longitude": "39.70000000"
                    },
                    {
                        "id": 109300,
                        "name": "Uwelini",
                        "latitude": "-5.40000000",
                        "longitude": "39.68333000"
                    }
                ]
            },
            {
                "id": 1485,
                "name": "Pwani",
                "iso2": "19",
                "latitude": "-7.32377140",
                "longitude": "38.82054540",
                "type": "region",
                "cities": [
                    {
                        "id": 109044,
                        "name": "Bagamoyo",
                        "latitude": "-6.44222000",
                        "longitude": "38.90422000"
                    },
                    {
                        "id": 109054,
                        "name": "Bungu",
                        "latitude": "-7.63369000",
                        "longitude": "39.05818000"
                    },
                    {
                        "id": 109059,
                        "name": "Chalinze",
                        "latitude": "-6.63784000",
                        "longitude": "38.35396000"
                    },
                    {
                        "id": 109077,
                        "name": "Ikwiriri",
                        "latitude": "-7.95618000",
                        "longitude": "38.97164000"
                    },
                    {
                        "id": 109100,
                        "name": "Kibaha",
                        "latitude": "-6.76667000",
                        "longitude": "38.91667000"
                    },
                    {
                        "id": 109104,
                        "name": "Kibiti",
                        "latitude": "-7.72178000",
                        "longitude": "38.93749000"
                    },
                    {
                        "id": 109114,
                        "name": "Kilindoni",
                        "latitude": "-7.91446000",
                        "longitude": "39.66204000"
                    },
                    {
                        "id": 109124,
                        "name": "Kisarawe",
                        "latitude": "-6.90000000",
                        "longitude": "39.06667000"
                    },
                    {
                        "id": 109146,
                        "name": "Lugoba",
                        "latitude": "-6.45000000",
                        "longitude": "38.33333000"
                    },
                    {
                        "id": 109173,
                        "name": "Maneromango",
                        "latitude": "-7.19880000",
                        "longitude": "38.78478000"
                    },
                    {
                        "id": 109191,
                        "name": "Mbumi",
                        "latitude": "-7.90577000",
                        "longitude": "39.21047000"
                    },
                    {
                        "id": 109202,
                        "name": "Mkuranga",
                        "latitude": "-7.27000000",
                        "longitude": "39.20000000"
                    },
                    {
                        "id": 109204,
                        "name": "Mlandizi",
                        "latitude": "-6.70000000",
                        "longitude": "38.73333000"
                    },
                    {
                        "id": 109227,
                        "name": "Mvomero",
                        "latitude": "-6.25000000",
                        "longitude": "38.66667000"
                    },
                    {
                        "id": 109298,
                        "name": "Utete",
                        "latitude": "-7.98598000",
                        "longitude": "38.75795000"
                    },
                    {
                        "id": 109302,
                        "name": "Vikindu",
                        "latitude": "-7.00667000",
                        "longitude": "39.29849000"
                    }
                ]
            },
            {
                "id": 1477,
                "name": "Rukwa",
                "iso2": "20",
                "latitude": "-8.01094440",
                "longitude": "31.44561790",
                "type": "region",
                "cities": [
                    {
                        "id": 109058,
                        "name": "Chala",
                        "latitude": "-7.58333000",
                        "longitude": "31.26667000"
                    },
                    {
                        "id": 109120,
                        "name": "Kirando",
                        "latitude": "-7.41667000",
                        "longitude": "30.60000000"
                    },
                    {
                        "id": 109139,
                        "name": "Laela",
                        "latitude": "-8.56667000",
                        "longitude": "32.05000000"
                    },
                    {
                        "id": 109180,
                        "name": "Matai",
                        "latitude": "-8.30000000",
                        "longitude": "31.51667000"
                    },
                    {
                        "id": 109239,
                        "name": "Namanyere",
                        "latitude": "-7.51667000",
                        "longitude": "31.05000000"
                    },
                    {
                        "id": 109258,
                        "name": "Nkove",
                        "latitude": "-7.95000000",
                        "longitude": "30.85000000"
                    },
                    {
                        "id": 109286,
                        "name": "Sumbawanga",
                        "latitude": "-7.96667000",
                        "longitude": "31.61667000"
                    }
                ]
            },
            {
                "id": 1486,
                "name": "Ruvuma",
                "iso2": "21",
                "latitude": "-10.68787170",
                "longitude": "36.26308460",
                "type": "region",
                "cities": [
                    {
                        "id": 109109,
                        "name": "Kigonsera",
                        "latitude": "-10.80000000",
                        "longitude": "35.05000000"
                    },
                    {
                        "id": 109143,
                        "name": "Liuli",
                        "latitude": "-11.08333000",
                        "longitude": "34.63333000"
                    },
                    {
                        "id": 109159,
                        "name": "Mahanje",
                        "latitude": "-9.93333000",
                        "longitude": "35.33333000"
                    },
                    {
                        "id": 109174,
                        "name": "Maposeni",
                        "latitude": "-10.58333000",
                        "longitude": "35.40000000"
                    },
                    {
                        "id": 109182,
                        "name": "Matiri",
                        "latitude": "-10.75000000",
                        "longitude": "34.90000000"
                    },
                    {
                        "id": 109186,
                        "name": "Mbamba Bay",
                        "latitude": "-11.28333000",
                        "longitude": "34.76667000"
                    },
                    {
                        "id": 109188,
                        "name": "Mbinga",
                        "latitude": "-10.93333000",
                        "longitude": "35.01667000"
                    },
                    {
                        "id": 109283,
                        "name": "Songea",
                        "latitude": "-10.68333000",
                        "longitude": "35.65000000"
                    },
                    {
                        "id": 109291,
                        "name": "Tingi",
                        "latitude": "-11.30000000",
                        "longitude": "35.03333000"
                    }
                ]
            },
            {
                "id": 1463,
                "name": "Shinyanga",
                "iso2": "22",
                "latitude": "-3.68099610",
                "longitude": "33.42714030",
                "type": "region",
                "cities": [
                    {
                        "id": 109084,
                        "name": "Isaka",
                        "latitude": "-3.90000000",
                        "longitude": "32.93333000"
                    },
                    {
                        "id": 109089,
                        "name": "Kahama",
                        "latitude": "-3.83333000",
                        "longitude": "32.60000000"
                    },
                    {
                        "id": 109127,
                        "name": "Kishapu",
                        "latitude": "-3.61667000",
                        "longitude": "33.86667000"
                    },
                    {
                        "id": 109195,
                        "name": "Mhango",
                        "latitude": "-3.28333000",
                        "longitude": "32.85000000"
                    },
                    {
                        "id": 109229,
                        "name": "Mwadui",
                        "latitude": "-3.55000000",
                        "longitude": "33.60000000"
                    },
                    {
                        "id": 109268,
                        "name": "Old Shinyanga",
                        "latitude": "-3.55000000",
                        "longitude": "33.40000000"
                    },
                    {
                        "id": 109277,
                        "name": "Shinyanga",
                        "latitude": "-3.66393000",
                        "longitude": "33.42118000"
                    },
                    {
                        "id": 109284,
                        "name": "Songwa",
                        "latitude": "-3.51667000",
                        "longitude": "33.51667000"
                    },
                    {
                        "id": 109290,
                        "name": "Tinde",
                        "latitude": "-3.88333000",
                        "longitude": "33.20000000"
                    }
                ]
            },
            {
                "id": 1464,
                "name": "Simiyu",
                "iso2": "30",
                "latitude": "-2.83087380",
                "longitude": "34.15319470",
                "type": "region",
                "cities": [
                    {
                        "id": 109045,
                        "name": "Bariadi",
                        "latitude": "-2.80000000",
                        "longitude": "33.98333000"
                    },
                    {
                        "id": 109126,
                        "name": "Kisesa",
                        "latitude": "-3.08333000",
                        "longitude": "34.15000000"
                    },
                    {
                        "id": 109140,
                        "name": "Lalago",
                        "latitude": "-3.45000000",
                        "longitude": "33.95000000"
                    },
                    {
                        "id": 109168,
                        "name": "Malampaka",
                        "latitude": "-3.13333000",
                        "longitude": "33.53333000"
                    },
                    {
                        "id": 109179,
                        "name": "Maswa",
                        "latitude": "-2.68333000",
                        "longitude": "33.98333000"
                    },
                    {
                        "id": 109183,
                        "name": "Matonga",
                        "latitude": "-2.38333000",
                        "longitude": "34.08333000"
                    },
                    {
                        "id": 109262,
                        "name": "Nyakabindi",
                        "latitude": "-2.63333000",
                        "longitude": "33.98333000"
                    },
                    {
                        "id": 109264,
                        "name": "Nyalikungu",
                        "latitude": "-3.18333000",
                        "longitude": "33.78333000"
                    },
                    {
                        "id": 109282,
                        "name": "Somanda",
                        "latitude": "-3.36667000",
                        "longitude": "33.95000000"
                    }
                ]
            },
            {
                "id": 1474,
                "name": "Singida",
                "iso2": "23",
                "latitude": "-6.74533520",
                "longitude": "34.15319470",
                "type": "region",
                "cities": [
                    {
                        "id": 109074,
                        "name": "Igugunu",
                        "latitude": "-4.56667000",
                        "longitude": "34.63333000"
                    },
                    {
                        "id": 109076,
                        "name": "Ikungi",
                        "latitude": "-5.13333000",
                        "longitude": "34.76667000"
                    },
                    {
                        "id": 109080,
                        "name": "Ilongero",
                        "latitude": "-4.66667000",
                        "longitude": "34.86667000"
                    },
                    {
                        "id": 109086,
                        "name": "Itigi",
                        "latitude": "-5.70000000",
                        "longitude": "34.48333000"
                    },
                    {
                        "id": 109113,
                        "name": "Kilimatinde",
                        "latitude": "-5.85000000",
                        "longitude": "34.95000000"
                    },
                    {
                        "id": 109118,
                        "name": "Kintinku",
                        "latitude": "-5.88333000",
                        "longitude": "35.23333000"
                    },
                    {
                        "id": 109119,
                        "name": "Kiomboi",
                        "latitude": "-4.26667000",
                        "longitude": "34.36667000"
                    },
                    {
                        "id": 109194,
                        "name": "Mgandu",
                        "latitude": "-5.95000000",
                        "longitude": "34.13333000"
                    },
                    {
                        "id": 109217,
                        "name": "Mtinko",
                        "latitude": "-4.55000000",
                        "longitude": "34.85000000"
                    },
                    {
                        "id": 109224,
                        "name": "Mungaa",
                        "latitude": "-4.96667000",
                        "longitude": "34.88333000"
                    },
                    {
                        "id": 109247,
                        "name": "Ndago",
                        "latitude": "-4.60000000",
                        "longitude": "34.35000000"
                    },
                    {
                        "id": 109271,
                        "name": "Puma",
                        "latitude": "-5.00000000",
                        "longitude": "34.73333000"
                    },
                    {
                        "id": 109275,
                        "name": "Sepuka",
                        "latitude": "-4.75000000",
                        "longitude": "34.53333000"
                    },
                    {
                        "id": 109276,
                        "name": "Shelui",
                        "latitude": "-4.36667000",
                        "longitude": "34.20000000"
                    },
                    {
                        "id": 109279,
                        "name": "Singida",
                        "latitude": "-4.81629000",
                        "longitude": "34.74358000"
                    }
                ]
            },
            {
                "id": 4956,
                "name": "Songwe",
                "iso2": "31",
                "latitude": "-8.27261200",
                "longitude": "31.71131740",
                "type": "region",
                "cities": [
                    {
                        "id": 154662,
                        "name": "Ileje",
                        "latitude": "-9.60000000",
                        "longitude": "33.48330000"
                    },
                    {
                        "id": 154661,
                        "name": "Mbozi",
                        "latitude": "-9.08330000",
                        "longitude": "33.45000000"
                    },
                    {
                        "id": 154660,
                        "name": "Mkwajuni",
                        "latitude": "-8.42380000",
                        "longitude": "33.02900000"
                    },
                    {
                        "id": 154659,
                        "name": "Mlowo",
                        "latitude": "-9.00000000",
                        "longitude": "32.96670000"
                    },
                    {
                        "id": 154658,
                        "name": "Tunduma",
                        "latitude": "-9.28810000",
                        "longitude": "32.77460000"
                    },
                    {
                        "id": 154657,
                        "name": "Vwawa",
                        "latitude": "-9.11960000",
                        "longitude": "32.93120000"
                    }
                ]
            },
            {
                "id": 1469,
                "name": "Tabora",
                "iso2": "24",
                "latitude": "-5.03421380",
                "longitude": "32.80844960",
                "type": "region",
                "cities": [
                    {
                        "id": 109051,
                        "name": "Bukene",
                        "latitude": "-4.23333000",
                        "longitude": "32.88333000"
                    },
                    {
                        "id": 109075,
                        "name": "Igurubi",
                        "latitude": "-4.00000000",
                        "longitude": "33.70000000"
                    },
                    {
                        "id": 109091,
                        "name": "Kaliua",
                        "latitude": "-5.06056000",
                        "longitude": "31.79361000"
                    },
                    {
                        "id": 109151,
                        "name": "Mabama",
                        "latitude": "-5.13333000",
                        "longitude": "32.53333000"
                    },
                    {
                        "id": 109278,
                        "name": "Sikonge",
                        "latitude": "-5.63333000",
                        "longitude": "32.76667000"
                    },
                    {
                        "id": 109287,
                        "name": "Tabora",
                        "latitude": "-5.01622000",
                        "longitude": "32.82663000"
                    },
                    {
                        "id": 109292,
                        "name": "Tumbi",
                        "latitude": "-5.06667000",
                        "longitude": "32.73333000"
                    },
                    {
                        "id": 109297,
                        "name": "Usoke",
                        "latitude": "-5.16667000",
                        "longitude": "32.35000000"
                    }
                ]
            },
            {
                "id": 1487,
                "name": "Tanga",
                "iso2": "25",
                "latitude": "-5.30497890",
                "longitude": "38.31657250",
                "type": "region",
                "cities": [
                    {
                        "id": 109060,
                        "name": "Chanika",
                        "latitude": "-5.41667000",
                        "longitude": "38.01667000"
                    },
                    {
                        "id": 109150,
                        "name": "Lushoto",
                        "latitude": "-4.78333000",
                        "longitude": "38.28333000"
                    },
                    {
                        "id": 109156,
                        "name": "Magomeni",
                        "latitude": "-5.23333000",
                        "longitude": "38.11667000"
                    },
                    {
                        "id": 109163,
                        "name": "Majengo",
                        "latitude": "-5.15000000",
                        "longitude": "38.98333000"
                    },
                    {
                        "id": 109167,
                        "name": "Makuyuni",
                        "latitude": "-4.73333000",
                        "longitude": "38.10000000"
                    },
                    {
                        "id": 109175,
                        "name": "Maramba",
                        "latitude": "-5.05000000",
                        "longitude": "38.61667000"
                    },
                    {
                        "id": 109184,
                        "name": "Matui",
                        "latitude": "-4.80000000",
                        "longitude": "38.25000000"
                    },
                    {
                        "id": 109185,
                        "name": "Mazinde",
                        "latitude": "-4.80000000",
                        "longitude": "38.21667000"
                    },
                    {
                        "id": 109203,
                        "name": "Mlalo",
                        "latitude": "-4.93333000",
                        "longitude": "38.93333000"
                    },
                    {
                        "id": 109223,
                        "name": "Muheza",
                        "latitude": "-5.16667000",
                        "longitude": "38.78333000"
                    },
                    {
                        "id": 109231,
                        "name": "Mwanga",
                        "latitude": "-4.80000000",
                        "longitude": "38.20000000"
                    },
                    {
                        "id": 109269,
                        "name": "Pangani",
                        "latitude": "-5.42526000",
                        "longitude": "38.97473000"
                    },
                    {
                        "id": 109285,
                        "name": "Soni",
                        "latitude": "-4.85000000",
                        "longitude": "38.36667000"
                    },
                    {
                        "id": 109289,
                        "name": "Tanga",
                        "latitude": "-5.06893000",
                        "longitude": "39.09875000"
                    }
                ]
            },
            {
                "id": 1473,
                "name": "Zanzibar North",
                "iso2": "07",
                "latitude": "-5.93950930",
                "longitude": "39.27910110",
                "type": "region",
                "cities": [
                    {
                        "id": 109069,
                        "name": "Gamba",
                        "latitude": "-5.90000000",
                        "longitude": "39.30000000"
                    },
                    {
                        "id": 109112,
                        "name": "Kijini",
                        "latitude": "-5.85000000",
                        "longitude": "39.31667000"
                    },
                    {
                        "id": 109131,
                        "name": "Kiwengwa",
                        "latitude": "-5.98957000",
                        "longitude": "39.37680000"
                    },
                    {
                        "id": 109201,
                        "name": "Mkokotoni",
                        "latitude": "-5.87506000",
                        "longitude": "39.25523000"
                    },
                    {
                        "id": 109261,
                        "name": "Nungwi",
                        "latitude": "-5.72651000",
                        "longitude": "39.29870000"
                    }
                ]
            },
            {
                "id": 1471,
                "name": "Zanzibar South",
                "iso2": "11",
                "latitude": "-6.26428510",
                "longitude": "39.44502810",
                "type": "region",
                "cities": [
                    {
                        "id": 109132,
                        "name": "Koani",
                        "latitude": "-6.13333000",
                        "longitude": "39.28333000"
                    },
                    {
                        "id": 109133,
                        "name": "Koani Ndogo",
                        "latitude": "-6.13333000",
                        "longitude": "39.28333000"
                    },
                    {
                        "id": 109161,
                        "name": "Mahonda",
                        "latitude": "-6.45000000",
                        "longitude": "39.46667000"
                    },
                    {
                        "id": 109250,
                        "name": "Nganane",
                        "latitude": "-6.40000000",
                        "longitude": "39.55000000"
                    },
                    {
                        "id": 109281,
                        "name": "Sokoni",
                        "latitude": "-6.43333000",
                        "longitude": "39.55000000"
                    }
                ]
            },
            {
                "id": 1475,
                "name": "Zanzibar West",
                "iso2": "15",
                "latitude": "-6.22981360",
                "longitude": "39.25832930",
                "type": "region",
                "cities": [
                    {
                        "id": 109304,
                        "name": "Zanzibar",
                        "latitude": "-6.16394000",
                        "longitude": "39.19793000"
                    }
                ]
            }
        ]
    },
    {
        "id": 219,
        "name": "Thailand",
        "iso3": "THA",
        "iso2": "TH",
        "numeric_code": "764",
        "phonecode": "66",
        "capital": "Bangkok",
        "currency": "THB",
        "currency_name": "Thai baht",
        "currency_symbol": "฿",
        "tld": ".th",
        "native": "ประเทศไทย",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Thai",
        "timezones": [
            {
                "zoneName": "Asia\/Bangkok",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "ICT",
                "tzName": "Indochina Time"
            }
        ],
        "translations": {
            "br": "Thailand",
            "ko": "태국",
            "pt-BR": "Tailândia",
            "pt": "Tailândia",
            "nl": "Thailand",
            "hr": "Tajland",
            "fa": "تایلند",
            "de": "Thailand",
            "es": "Tailandia",
            "fr": "Thaïlande",
            "ja": "タイ",
            "it": "Tailandia",
            "zh-CN": "泰国",
            "tr": "Tayland",
            "ru": "Таиланд",
            "uk": "Таїланд",
            "pl": "Tajlandia"
        },
        "latitude": "15.00000000",
        "longitude": "100.00000000",
        "emoji": "🇹🇭",
        "emojiU": "U+1F1F9 U+1F1ED",
        "states": [
            {
                "id": 3523,
                "name": "Amnat Charoen",
                "iso2": "37",
                "latitude": "15.86567830",
                "longitude": "104.62577740",
                "type": "province",
                "cities": [
                    {
                        "id": 105179,
                        "name": "Amnat Charoen",
                        "latitude": "15.85851000",
                        "longitude": "104.62883000"
                    },
                    {
                        "id": 105286,
                        "name": "Amphoe Chanuman",
                        "latitude": "16.12553000",
                        "longitude": "104.92279000"
                    },
                    {
                        "id": 105351,
                        "name": "Amphoe Hua Taphan",
                        "latitude": "15.67594000",
                        "longitude": "104.52702000"
                    },
                    {
                        "id": 105495,
                        "name": "Amphoe Lue Amnat",
                        "latitude": "15.70781000",
                        "longitude": "104.71118000"
                    },
                    {
                        "id": 105531,
                        "name": "Amphoe Mueang Amnat Charoen",
                        "latitude": "15.87864000",
                        "longitude": "104.64284000"
                    },
                    {
                        "id": 105715,
                        "name": "Amphoe Pathum Ratchawongsa",
                        "latitude": "15.89542000",
                        "longitude": "104.89611000"
                    },
                    {
                        "id": 105722,
                        "name": "Amphoe Phana",
                        "latitude": "15.66895000",
                        "longitude": "104.85675000"
                    },
                    {
                        "id": 106208,
                        "name": "Amphoe Senangkhanikhom",
                        "latitude": "16.05130000",
                        "longitude": "104.68441000"
                    }
                ]
            },
            {
                "id": 3519,
                "name": "Ang Thong",
                "iso2": "15",
                "latitude": "14.58960540",
                "longitude": "100.45505200",
                "type": "province",
                "cities": [
                    {
                        "id": 105274,
                        "name": "Amphoe Chaiyo",
                        "latitude": "14.67225000",
                        "longitude": "100.46786000"
                    },
                    {
                        "id": 105532,
                        "name": "Amphoe Mueang Ang Thong",
                        "latitude": "14.57815000",
                        "longitude": "100.44393000"
                    },
                    {
                        "id": 105695,
                        "name": "Amphoe Pa Mok",
                        "latitude": "14.48620000",
                        "longitude": "100.45730000"
                    },
                    {
                        "id": 105750,
                        "name": "Amphoe Pho Thong",
                        "latitude": "14.67344000",
                        "longitude": "100.34569000"
                    },
                    {
                        "id": 106199,
                        "name": "Amphoe Sawaeng Ha",
                        "latitude": "14.74635000",
                        "longitude": "100.28963000"
                    },
                    {
                        "id": 106371,
                        "name": "Amphoe Wiset Chai Chan",
                        "latitude": "14.54990000",
                        "longitude": "100.31743000"
                    },
                    {
                        "id": 106380,
                        "name": "Ang Thong",
                        "latitude": "14.58839000",
                        "longitude": "100.45283000"
                    },
                    {
                        "id": 106419,
                        "name": "Ban Thai Tan",
                        "latitude": "14.62161000",
                        "longitude": "100.48739000"
                    },
                    {
                        "id": 106466,
                        "name": "Chaiyo",
                        "latitude": "14.67639000",
                        "longitude": "100.46861000"
                    },
                    {
                        "id": 106638,
                        "name": "Pho Thong",
                        "latitude": "14.66731000",
                        "longitude": "100.40878000"
                    },
                    {
                        "id": 106754,
                        "name": "Wiset Chaichan",
                        "latitude": "14.59450000",
                        "longitude": "100.33825000"
                    }
                ]
            },
            {
                "id": 3554,
                "name": "Bangkok",
                "iso2": "10",
                "latitude": "13.75633090",
                "longitude": "100.50176510",
                "type": "metropolitan administration",
                "cities": [
                    {
                        "id": 106422,
                        "name": "Bang Bon",
                        "latitude": "13.65920000",
                        "longitude": "100.38801000"
                    },
                    {
                        "id": 106424,
                        "name": "Bang Kapi",
                        "latitude": "13.77258000",
                        "longitude": "100.63847000"
                    },
                    {
                        "id": 106425,
                        "name": "Bang Khae",
                        "latitude": "13.71927000",
                        "longitude": "100.39278000"
                    },
                    {
                        "id": 106426,
                        "name": "Bang Khen",
                        "latitude": "13.86901000",
                        "longitude": "100.62769000"
                    },
                    {
                        "id": 106428,
                        "name": "Bang Kho laen",
                        "latitude": "13.70025000",
                        "longitude": "100.50971000"
                    },
                    {
                        "id": 106429,
                        "name": "Bang Khun thain",
                        "latitude": "13.59482000",
                        "longitude": "100.42694000"
                    },
                    {
                        "id": 106436,
                        "name": "Bang Na",
                        "latitude": "13.67252000",
                        "longitude": "100.62089000"
                    },
                    {
                        "id": 106441,
                        "name": "Bang Phlat",
                        "latitude": "13.78668000",
                        "longitude": "100.49152000"
                    },
                    {
                        "id": 106443,
                        "name": "Bang Rak",
                        "latitude": "13.73058000",
                        "longitude": "100.52388000"
                    },
                    {
                        "id": 106446,
                        "name": "Bang Sue",
                        "latitude": "13.81921000",
                        "longitude": "100.52790000"
                    },
                    {
                        "id": 106448,
                        "name": "Bangkok",
                        "latitude": "13.75398000",
                        "longitude": "100.50144000"
                    },
                    {
                        "id": 106449,
                        "name": "Bangkok Noi",
                        "latitude": "13.76551000",
                        "longitude": "100.46988000"
                    },
                    {
                        "id": 106450,
                        "name": "Bangkok Yai",
                        "latitude": "13.73748000",
                        "longitude": "100.47428000"
                    },
                    {
                        "id": 106456,
                        "name": "Bueng Kum",
                        "latitude": "13.81023000",
                        "longitude": "100.65140000"
                    },
                    {
                        "id": 106469,
                        "name": "Chatu Chak",
                        "latitude": "13.82888000",
                        "longitude": "100.56374000"
                    },
                    {
                        "id": 106480,
                        "name": "Chom Thong",
                        "latitude": "13.68910000",
                        "longitude": "100.46175000"
                    },
                    {
                        "id": 106489,
                        "name": "Din Daeng",
                        "latitude": "13.77728000",
                        "longitude": "100.56235000"
                    },
                    {
                        "id": 106492,
                        "name": "Don Mueang",
                        "latitude": "13.92601000",
                        "longitude": "100.59365000"
                    },
                    {
                        "id": 106494,
                        "name": "Dusit",
                        "latitude": "13.78235000",
                        "longitude": "100.51677000"
                    },
                    {
                        "id": 106500,
                        "name": "Huai Khwang",
                        "latitude": "13.77060000",
                        "longitude": "100.58119000"
                    },
                    {
                        "id": 106518,
                        "name": "Khan Na Yao",
                        "latitude": "13.82380000",
                        "longitude": "100.67649000"
                    },
                    {
                        "id": 106525,
                        "name": "Khlong Sam Wa",
                        "latitude": "13.87633000",
                        "longitude": "100.73805000"
                    },
                    {
                        "id": 106526,
                        "name": "Khlong San",
                        "latitude": "13.72602000",
                        "longitude": "100.50071000"
                    },
                    {
                        "id": 106527,
                        "name": "Khlong Toei",
                        "latitude": "13.71806000",
                        "longitude": "100.57065000"
                    },
                    {
                        "id": 106548,
                        "name": "Lak Si",
                        "latitude": "13.88210000",
                        "longitude": "100.56889000"
                    },
                    {
                        "id": 106554,
                        "name": "Lat Krabang",
                        "latitude": "13.74500000",
                        "longitude": "100.79224000"
                    },
                    {
                        "id": 106555,
                        "name": "Lat Phrao",
                        "latitude": "13.82779000",
                        "longitude": "100.60672000"
                    },
                    {
                        "id": 106569,
                        "name": "Min Buri",
                        "latitude": "13.81254000",
                        "longitude": "100.75334000"
                    },
                    {
                        "id": 106597,
                        "name": "Nong Chok",
                        "latitude": "13.85280000",
                        "longitude": "100.85788000"
                    },
                    {
                        "id": 106599,
                        "name": "Nong Khaem",
                        "latitude": "13.69979000",
                        "longitude": "100.35364000"
                    },
                    {
                        "id": 106613,
                        "name": "Parthum Wan",
                        "latitude": "13.74265000",
                        "longitude": "100.53398000"
                    },
                    {
                        "id": 106625,
                        "name": "Phasi Charoen",
                        "latitude": "13.72597000",
                        "longitude": "100.44103000"
                    },
                    {
                        "id": 106627,
                        "name": "Phaya Thai",
                        "latitude": "13.78442000",
                        "longitude": "100.54306000"
                    },
                    {
                        "id": 106642,
                        "name": "Phra Khanong",
                        "latitude": "13.69705000",
                        "longitude": "100.61234000"
                    },
                    {
                        "id": 106643,
                        "name": "Phra Nakhon",
                        "latitude": "13.75831000",
                        "longitude": "100.49613000"
                    },
                    {
                        "id": 106651,
                        "name": "Pom Prap Sattru Phai",
                        "latitude": "13.75480000",
                        "longitude": "100.50995000"
                    },
                    {
                        "id": 106654,
                        "name": "Pra Wet",
                        "latitude": "13.71735000",
                        "longitude": "100.69452000"
                    },
                    {
                        "id": 106663,
                        "name": "Rat Burana",
                        "latitude": "13.67633000",
                        "longitude": "100.49881000"
                    },
                    {
                        "id": 106665,
                        "name": "Ratchathewi",
                        "latitude": "13.76029000",
                        "longitude": "100.53724000"
                    },
                    {
                        "id": 106674,
                        "name": "Sai Mai",
                        "latitude": "13.90727000",
                        "longitude": "100.65181000"
                    },
                    {
                        "id": 106679,
                        "name": "Samphanthawong",
                        "latitude": "13.74233000",
                        "longitude": "100.50765000"
                    },
                    {
                        "id": 106687,
                        "name": "Saphan Sung",
                        "latitude": "13.76531000",
                        "longitude": "100.69001000"
                    },
                    {
                        "id": 106689,
                        "name": "Sathon",
                        "latitude": "13.71745000",
                        "longitude": "100.52999000"
                    },
                    {
                        "id": 106706,
                        "name": "Suanluang",
                        "latitude": "13.72989000",
                        "longitude": "100.62677000"
                    },
                    {
                        "id": 106716,
                        "name": "Taling Chan",
                        "latitude": "13.77271000",
                        "longitude": "100.43289000"
                    },
                    {
                        "id": 106730,
                        "name": "Thawi Watthana",
                        "latitude": "13.77637000",
                        "longitude": "100.36620000"
                    },
                    {
                        "id": 106732,
                        "name": "Thon buri",
                        "latitude": "13.71874000",
                        "longitude": "100.48367000"
                    },
                    {
                        "id": 106734,
                        "name": "Thung khru",
                        "latitude": "13.63387000",
                        "longitude": "100.49641000"
                    },
                    {
                        "id": 106741,
                        "name": "Vadhana",
                        "latitude": "13.73501000",
                        "longitude": "100.58280000"
                    },
                    {
                        "id": 106748,
                        "name": "Wang Thong Lang",
                        "latitude": "13.78188000",
                        "longitude": "100.60804000"
                    },
                    {
                        "id": 106756,
                        "name": "Yan na wa",
                        "latitude": "13.69177000",
                        "longitude": "100.53950000"
                    }
                ]
            },
            {
                "id": 3533,
                "name": "Bueng Kan",
                "iso2": "38",
                "latitude": "18.36091040",
                "longitude": "103.64644630",
                "type": "province",
                "cities": [
                    {
                        "id": 105260,
                        "name": "Amphoe Bueng Khong Long",
                        "latitude": "18.00899000",
                        "longitude": "104.07302000"
                    },
                    {
                        "id": 105264,
                        "name": "Amphoe Bung Khla",
                        "latitude": "18.24726000",
                        "longitude": "103.99427000"
                    },
                    {
                        "id": 105533,
                        "name": "Amphoe Mueang Bueng Kan",
                        "latitude": "18.29950000",
                        "longitude": "103.64016000"
                    },
                    {
                        "id": 105702,
                        "name": "Amphoe Pak Khat",
                        "latitude": "18.27738000",
                        "longitude": "103.34140000"
                    },
                    {
                        "id": 105752,
                        "name": "Amphoe Phon Charoen",
                        "latitude": "18.07967000",
                        "longitude": "103.65453000"
                    },
                    {
                        "id": 106205,
                        "name": "Amphoe Seka",
                        "latitude": "17.98734000",
                        "longitude": "103.89616000"
                    },
                    {
                        "id": 106230,
                        "name": "Amphoe Si Wilai",
                        "latitude": "18.15528000",
                        "longitude": "103.77975000"
                    },
                    {
                        "id": 106239,
                        "name": "Amphoe So Phisai",
                        "latitude": "18.14176000",
                        "longitude": "103.44923000"
                    },
                    {
                        "id": 106455,
                        "name": "Bueng Kan",
                        "latitude": "18.36303000",
                        "longitude": "103.65194000"
                    },
                    {
                        "id": 106696,
                        "name": "Seka",
                        "latitude": "17.92851000",
                        "longitude": "103.95519000"
                    }
                ]
            },
            {
                "id": 3534,
                "name": "Buri Ram",
                "iso2": "31",
                "latitude": "14.99510030",
                "longitude": "103.11159150",
                "type": "province",
                "cities": [
                    {
                        "id": 105188,
                        "name": "Amphoe Ban Dan",
                        "latitude": "15.12363000",
                        "longitude": "103.18937000"
                    },
                    {
                        "id": 105197,
                        "name": "Amphoe Ban Kruat",
                        "latitude": "14.39205000",
                        "longitude": "103.11494000"
                    },
                    {
                        "id": 105202,
                        "name": "Amphoe Ban Mai Chaiyaphot",
                        "latitude": "15.57857000",
                        "longitude": "102.84394000"
                    },
                    {
                        "id": 105279,
                        "name": "Amphoe Chaloem Phra Kiat",
                        "latitude": "14.55725000",
                        "longitude": "102.89878000"
                    },
                    {
                        "id": 105281,
                        "name": "Amphoe Chamni",
                        "latitude": "14.78636000",
                        "longitude": "102.85386000"
                    },
                    {
                        "id": 105356,
                        "name": "Amphoe Huai Rat",
                        "latitude": "15.00896000",
                        "longitude": "103.23499000"
                    },
                    {
                        "id": 105381,
                        "name": "Amphoe Khaen Dong",
                        "latitude": "15.30620000",
                        "longitude": "103.13286000"
                    },
                    {
                        "id": 105425,
                        "name": "Amphoe Khu Mueang",
                        "latitude": "15.26844000",
                        "longitude": "103.02717000"
                    },
                    {
                        "id": 105454,
                        "name": "Amphoe Krasang",
                        "latitude": "14.94167000",
                        "longitude": "103.31898000"
                    },
                    {
                        "id": 105472,
                        "name": "Amphoe Lahan Sai",
                        "latitude": "14.32194000",
                        "longitude": "102.87994000"
                    },
                    {
                        "id": 105474,
                        "name": "Amphoe Lam Plai Mat",
                        "latitude": "15.01688000",
                        "longitude": "102.87479000"
                    },
                    {
                        "id": 105534,
                        "name": "Amphoe Mueang Buriram",
                        "latitude": "14.94078000",
                        "longitude": "103.06244000"
                    },
                    {
                        "id": 105621,
                        "name": "Amphoe Na Pho",
                        "latitude": "15.69565000",
                        "longitude": "102.93857000"
                    },
                    {
                        "id": 105641,
                        "name": "Amphoe Nang Rong",
                        "latitude": "14.63333000",
                        "longitude": "102.76667000"
                    },
                    {
                        "id": 105649,
                        "name": "Amphoe Non Din Daeng",
                        "latitude": "14.22010000",
                        "longitude": "102.68233000"
                    },
                    {
                        "id": 105656,
                        "name": "Amphoe Non Suwan",
                        "latitude": "14.55511000",
                        "longitude": "102.58339000"
                    },
                    {
                        "id": 105666,
                        "name": "Amphoe Nong Hong",
                        "latitude": "14.86149000",
                        "longitude": "102.67080000"
                    },
                    {
                        "id": 105669,
                        "name": "Amphoe Nong Ki",
                        "latitude": "14.72696000",
                        "longitude": "102.55798000"
                    },
                    {
                        "id": 105694,
                        "name": "Amphoe Pa Kham",
                        "latitude": "14.40000000",
                        "longitude": "102.66667000"
                    },
                    {
                        "id": 105743,
                        "name": "Amphoe Phlapphla Chai",
                        "latitude": "14.73299000",
                        "longitude": "103.17015000"
                    },
                    {
                        "id": 105785,
                        "name": "Amphoe Phutthaisong",
                        "latitude": "15.53249000",
                        "longitude": "102.98701000"
                    },
                    {
                        "id": 105795,
                        "name": "Amphoe Prakhon Chai",
                        "latitude": "14.61041000",
                        "longitude": "103.06054000"
                    },
                    {
                        "id": 106198,
                        "name": "Amphoe Satuek",
                        "latitude": "15.22699000",
                        "longitude": "103.33006000"
                    },
                    {
                        "id": 106458,
                        "name": "Buri Ram",
                        "latitude": "14.99433000",
                        "longitude": "103.10392000"
                    },
                    {
                        "id": 106589,
                        "name": "Nang Rong",
                        "latitude": "14.63770000",
                        "longitude": "102.79138000"
                    },
                    {
                        "id": 106601,
                        "name": "Nong Ki",
                        "latitude": "14.68679000",
                        "longitude": "102.53800000"
                    },
                    {
                        "id": 106657,
                        "name": "Prakhon Chai",
                        "latitude": "14.60592000",
                        "longitude": "103.12081000"
                    },
                    {
                        "id": 106691,
                        "name": "Satuek",
                        "latitude": "15.29703000",
                        "longitude": "103.29192000"
                    }
                ]
            },
            {
                "id": 3552,
                "name": "Chachoengsao",
                "iso2": "24",
                "latitude": "13.69041940",
                "longitude": "101.07795960",
                "type": "province",
                "cities": [
                    {
                        "id": 105212,
                        "name": "Amphoe Ban Pho",
                        "latitude": "13.61000000",
                        "longitude": "101.07838000"
                    },
                    {
                        "id": 105226,
                        "name": "Amphoe Bang Khla",
                        "latitude": "13.74186000",
                        "longitude": "101.20754000"
                    },
                    {
                        "id": 105233,
                        "name": "Amphoe Bang Nam Priao",
                        "latitude": "13.88034000",
                        "longitude": "101.03232000"
                    },
                    {
                        "id": 105236,
                        "name": "Amphoe Bang Pakong",
                        "latitude": "13.53241000",
                        "longitude": "100.96045000"
                    },
                    {
                        "id": 105408,
                        "name": "Amphoe Khlong Khuean",
                        "latitude": "13.77961000",
                        "longitude": "101.15633000"
                    },
                    {
                        "id": 105535,
                        "name": "Amphoe Mueang Chachoengsao",
                        "latitude": "13.71758000",
                        "longitude": "101.02152000"
                    },
                    {
                        "id": 105729,
                        "name": "Amphoe Phanom Sarakham",
                        "latitude": "13.73806000",
                        "longitude": "101.41202000"
                    },
                    {
                        "id": 105788,
                        "name": "Amphoe Plaeng Yao",
                        "latitude": "13.56381000",
                        "longitude": "101.33972000"
                    },
                    {
                        "id": 105806,
                        "name": "Amphoe Ratchasan",
                        "latitude": "13.78660000",
                        "longitude": "101.28136000"
                    },
                    {
                        "id": 106185,
                        "name": "Amphoe Sanam Chai Khet",
                        "latitude": "13.62612000",
                        "longitude": "101.65475000"
                    },
                    {
                        "id": 106286,
                        "name": "Amphoe Tha Takiap",
                        "latitude": "13.39510000",
                        "longitude": "101.73457000"
                    },
                    {
                        "id": 106427,
                        "name": "Bang Khla",
                        "latitude": "13.72144000",
                        "longitude": "101.20814000"
                    },
                    {
                        "id": 106437,
                        "name": "Bang Nam Priao",
                        "latitude": "13.84739000",
                        "longitude": "101.05306000"
                    },
                    {
                        "id": 106439,
                        "name": "Bang Pakong",
                        "latitude": "13.54297000",
                        "longitude": "100.99333000"
                    },
                    {
                        "id": 106460,
                        "name": "Chachoengsao",
                        "latitude": "13.68820000",
                        "longitude": "101.07156000"
                    },
                    {
                        "id": 106523,
                        "name": "Khlong Khuean",
                        "latitude": "13.79131000",
                        "longitude": "101.16353000"
                    },
                    {
                        "id": 106623,
                        "name": "Phanom Sarakham",
                        "latitude": "13.74872000",
                        "longitude": "101.34888000"
                    }
                ]
            },
            {
                "id": 3522,
                "name": "Chai Nat",
                "iso2": "18",
                "latitude": "15.18519710",
                "longitude": "100.12512500",
                "type": "province",
                "cities": [
                    {
                        "id": 105345,
                        "name": "Amphoe Hankha",
                        "latitude": "15.05048000",
                        "longitude": "99.96090000"
                    },
                    {
                        "id": 105526,
                        "name": "Amphoe Manorom",
                        "latitude": "15.31894000",
                        "longitude": "100.15677000"
                    },
                    {
                        "id": 105536,
                        "name": "Amphoe Mueang Chainat",
                        "latitude": "15.19104000",
                        "longitude": "100.13540000"
                    },
                    {
                        "id": 105646,
                        "name": "Amphoe Noen Kham",
                        "latitude": "14.98254000",
                        "longitude": "99.84590000"
                    },
                    {
                        "id": 105671,
                        "name": "Amphoe Nong Mamong",
                        "latitude": "15.23372000",
                        "longitude": "99.81087000"
                    },
                    {
                        "id": 106190,
                        "name": "Amphoe Sankhaburi",
                        "latitude": "15.02105000",
                        "longitude": "100.17038000"
                    },
                    {
                        "id": 106194,
                        "name": "Amphoe Sapphaya",
                        "latitude": "15.14873000",
                        "longitude": "100.25506000"
                    },
                    {
                        "id": 106357,
                        "name": "Amphoe Wat Sing",
                        "latitude": "15.21574000",
                        "longitude": "99.96680000"
                    },
                    {
                        "id": 106463,
                        "name": "Chai Nat",
                        "latitude": "15.18636000",
                        "longitude": "100.12353000"
                    }
                ]
            },
            {
                "id": 4954,
                "name": "Chaiyaphum",
                "iso2": "36",
                "latitude": "16.00749740",
                "longitude": "101.61291720",
                "type": "province",
                "cities": [
                    {
                        "id": 148554,
                        "name": "Bamnet Narong",
                        "latitude": "15.50189000",
                        "longitude": "101.68982000"
                    },
                    {
                        "id": 148555,
                        "name": "Chaiyaphum",
                        "latitude": "15.81047000",
                        "longitude": "102.02881000"
                    },
                    {
                        "id": 148556,
                        "name": "Kaeng Khro",
                        "latitude": "16.10861111",
                        "longitude": "102.25805556"
                    },
                    {
                        "id": 148557,
                        "name": "Kaset Sombun",
                        "latitude": "16.28053000",
                        "longitude": "101.95422000"
                    },
                    {
                        "id": 148558,
                        "name": "Nakhon Nayok",
                        "latitude": "14.20305600",
                        "longitude": "101.21500000"
                    },
                    {
                        "id": 148559,
                        "name": "Phu Khiao",
                        "latitude": "16.37650000",
                        "longitude": "102.12853000"
                    }
                ]
            },
            {
                "id": 3486,
                "name": "Chanthaburi",
                "iso2": "22",
                "latitude": "12.61124850",
                "longitude": "102.10378060",
                "type": "province",
                "cities": [
                    {
                        "id": 105364,
                        "name": "Amphoe Kaeng Hang Maeo",
                        "latitude": "13.09690000",
                        "longitude": "101.88543000"
                    },
                    {
                        "id": 105394,
                        "name": "Amphoe Khao Khitchakut",
                        "latitude": "12.93726000",
                        "longitude": "102.09762000"
                    },
                    {
                        "id": 105413,
                        "name": "Amphoe Khlung",
                        "latitude": "12.57246000",
                        "longitude": "102.30783000"
                    },
                    {
                        "id": 105471,
                        "name": "Amphoe Laem Sing",
                        "latitude": "12.45689000",
                        "longitude": "102.14262000"
                    },
                    {
                        "id": 105523,
                        "name": "Amphoe Makham",
                        "latitude": "12.73333000",
                        "longitude": "102.21667000"
                    },
                    {
                        "id": 105538,
                        "name": "Amphoe Mueang Chanthaburi",
                        "latitude": "12.59542000",
                        "longitude": "102.12263000"
                    },
                    {
                        "id": 105627,
                        "name": "Amphoe Na Yai Am",
                        "latitude": "12.73833000",
                        "longitude": "101.87502000"
                    },
                    {
                        "id": 105792,
                        "name": "Amphoe Pong Nam Ron",
                        "latitude": "12.93467000",
                        "longitude": "102.37189000"
                    },
                    {
                        "id": 106242,
                        "name": "Amphoe Soi Dao",
                        "latitude": "13.17034000",
                        "longitude": "102.22796000"
                    },
                    {
                        "id": 106277,
                        "name": "Amphoe Tha Mai",
                        "latitude": "12.73848000",
                        "longitude": "101.97696000"
                    },
                    {
                        "id": 106467,
                        "name": "Chanthaburi",
                        "latitude": "12.60961000",
                        "longitude": "102.10447000"
                    },
                    {
                        "id": 106529,
                        "name": "Khlung",
                        "latitude": "12.45467000",
                        "longitude": "102.22142000"
                    },
                    {
                        "id": 106547,
                        "name": "Laem Sing",
                        "latitude": "12.48164000",
                        "longitude": "102.07375000"
                    },
                    {
                        "id": 106653,
                        "name": "Pong Nam Ron",
                        "latitude": "12.90575000",
                        "longitude": "102.26225000"
                    },
                    {
                        "id": 106721,
                        "name": "Tha Mai",
                        "latitude": "12.62137000",
                        "longitude": "102.00481000"
                    }
                ]
            },
            {
                "id": 3491,
                "name": "Chiang Mai",
                "iso2": "50",
                "latitude": "18.78834390",
                "longitude": "98.98530080",
                "type": "province",
                "cities": [
                    {
                        "id": 105271,
                        "name": "Amphoe Chai Prakan",
                        "latitude": "19.67400000",
                        "longitude": "99.17478000"
                    },
                    {
                        "id": 105292,
                        "name": "Amphoe Chiang Dao",
                        "latitude": "19.51279000",
                        "longitude": "98.94180000"
                    },
                    {
                        "id": 105305,
                        "name": "Amphoe Chom Thong",
                        "latitude": "18.39242000",
                        "longitude": "98.59761000"
                    },
                    {
                        "id": 105324,
                        "name": "Amphoe Doi Lo",
                        "latitude": "18.53330000",
                        "longitude": "98.76843000"
                    },
                    {
                        "id": 105326,
                        "name": "Amphoe Doi Saket",
                        "latitude": "18.92372000",
                        "longitude": "99.21272000"
                    },
                    {
                        "id": 105327,
                        "name": "Amphoe Doi Tao",
                        "latitude": "17.89703000",
                        "longitude": "98.66292000"
                    },
                    {
                        "id": 105340,
                        "name": "Amphoe Fang",
                        "latitude": "19.87550000",
                        "longitude": "99.16345000"
                    },
                    {
                        "id": 105342,
                        "name": "Amphoe Galyani Vadhana",
                        "latitude": "18.94439000",
                        "longitude": "98.30329000"
                    },
                    {
                        "id": 105344,
                        "name": "Amphoe Hang Dong",
                        "latitude": "18.73869000",
                        "longitude": "98.88439000"
                    },
                    {
                        "id": 105348,
                        "name": "Amphoe Hot",
                        "latitude": "18.11581000",
                        "longitude": "98.46377000"
                    },
                    {
                        "id": 105496,
                        "name": "Amphoe Mae Ai",
                        "latitude": "19.99136000",
                        "longitude": "99.33976000"
                    },
                    {
                        "id": 105497,
                        "name": "Amphoe Mae Chaem",
                        "latitude": "18.66694000",
                        "longitude": "98.32450000"
                    },
                    {
                        "id": 105506,
                        "name": "Amphoe Mae On",
                        "latitude": "18.73496000",
                        "longitude": "99.30378000"
                    },
                    {
                        "id": 105510,
                        "name": "Amphoe Mae Rim",
                        "latitude": "18.94139000",
                        "longitude": "98.88667000"
                    },
                    {
                        "id": 105515,
                        "name": "Amphoe Mae Taeng",
                        "latitude": "19.16667000",
                        "longitude": "98.83333000"
                    },
                    {
                        "id": 105518,
                        "name": "Amphoe Mae Wang",
                        "latitude": "18.67457000",
                        "longitude": "98.68714000"
                    },
                    {
                        "id": 105539,
                        "name": "Amphoe Mueang Chiang Mai",
                        "latitude": "18.79008000",
                        "longitude": "98.96869000"
                    },
                    {
                        "id": 105690,
                        "name": "Amphoe Om Koi",
                        "latitude": "17.69842000",
                        "longitude": "98.35433000"
                    },
                    {
                        "id": 105769,
                        "name": "Amphoe Phrao",
                        "latitude": "19.28460000",
                        "longitude": "99.22277000"
                    },
                    {
                        "id": 106179,
                        "name": "Amphoe Samoeng",
                        "latitude": "18.90027000",
                        "longitude": "98.65650000"
                    },
                    {
                        "id": 106182,
                        "name": "Amphoe San Kamphaeng",
                        "latitude": "18.73497000",
                        "longitude": "99.18609000"
                    },
                    {
                        "id": 106183,
                        "name": "Amphoe San Pa Tong",
                        "latitude": "18.60567000",
                        "longitude": "98.88531000"
                    },
                    {
                        "id": 106184,
                        "name": "Amphoe San Sai",
                        "latitude": "18.94101000",
                        "longitude": "99.04048000"
                    },
                    {
                        "id": 106195,
                        "name": "Amphoe Saraphi",
                        "latitude": "18.70511000",
                        "longitude": "99.02989000"
                    },
                    {
                        "id": 106361,
                        "name": "Amphoe Wiang Haeng",
                        "latitude": "19.59188000",
                        "longitude": "98.65845000"
                    },
                    {
                        "id": 106464,
                        "name": "Chai Prakan",
                        "latitude": "19.73136000",
                        "longitude": "99.13997000"
                    },
                    {
                        "id": 106474,
                        "name": "Chiang Mai",
                        "latitude": "18.79038000",
                        "longitude": "98.98468000"
                    },
                    {
                        "id": 106479,
                        "name": "Chom Thong",
                        "latitude": "18.41742000",
                        "longitude": "98.67428000"
                    },
                    {
                        "id": 106495,
                        "name": "Fang",
                        "latitude": "19.91689000",
                        "longitude": "99.21450000"
                    },
                    {
                        "id": 106496,
                        "name": "Hang Dong",
                        "latitude": "18.68703000",
                        "longitude": "98.91939000"
                    },
                    {
                        "id": 106608,
                        "name": "Pai",
                        "latitude": "19.36168000",
                        "longitude": "98.43973000"
                    },
                    {
                        "id": 106683,
                        "name": "San Kamphaeng",
                        "latitude": "18.74486000",
                        "longitude": "99.11953000"
                    },
                    {
                        "id": 106684,
                        "name": "San Pa Tong",
                        "latitude": "18.62828000",
                        "longitude": "98.89572000"
                    }
                ]
            },
            {
                "id": 3498,
                "name": "Chiang Rai",
                "iso2": "57",
                "latitude": "19.91047980",
                "longitude": "99.84057600",
                "type": "province",
                "cities": [
                    {
                        "id": 105295,
                        "name": "Amphoe Chiang Khong",
                        "latitude": "20.13587000",
                        "longitude": "100.36527000"
                    },
                    {
                        "id": 105299,
                        "name": "Amphoe Chiang Saen",
                        "latitude": "20.23572000",
                        "longitude": "100.15537000"
                    },
                    {
                        "id": 105325,
                        "name": "Amphoe Doi Luang",
                        "latitude": "20.14496000",
                        "longitude": "100.15712000"
                    },
                    {
                        "id": 105433,
                        "name": "Amphoe Khun Tan",
                        "latitude": "19.86481000",
                        "longitude": "100.28731000"
                    },
                    {
                        "id": 105499,
                        "name": "Amphoe Mae Chan",
                        "latitude": "20.19910000",
                        "longitude": "99.88468000"
                    },
                    {
                        "id": 105501,
                        "name": "Amphoe Mae Fa Luang",
                        "latitude": "20.22228000",
                        "longitude": "99.64147000"
                    },
                    {
                        "id": 105504,
                        "name": "Amphoe Mae Lao",
                        "latitude": "19.77223000",
                        "longitude": "99.71128000"
                    },
                    {
                        "id": 105511,
                        "name": "Amphoe Mae Sai",
                        "latitude": "20.36500000",
                        "longitude": "99.92604000"
                    },
                    {
                        "id": 105514,
                        "name": "Amphoe Mae Suai",
                        "latitude": "19.69037000",
                        "longitude": "99.48459000"
                    },
                    {
                        "id": 105540,
                        "name": "Amphoe Mueang Chiang Rai",
                        "latitude": "19.90824000",
                        "longitude": "99.77299000"
                    },
                    {
                        "id": 105693,
                        "name": "Amphoe Pa Daet",
                        "latitude": "19.50643000",
                        "longitude": "99.97615000"
                    },
                    {
                        "id": 105720,
                        "name": "Amphoe Phan",
                        "latitude": "19.57450000",
                        "longitude": "99.77299000"
                    },
                    {
                        "id": 105733,
                        "name": "Amphoe Phaya Mengrai",
                        "latitude": "19.87320000",
                        "longitude": "100.16257000"
                    },
                    {
                        "id": 106308,
                        "name": "Amphoe Thoeng",
                        "latitude": "19.67650000",
                        "longitude": "100.20095000"
                    },
                    {
                        "id": 106359,
                        "name": "Amphoe Wiang Chai",
                        "latitude": "19.86360000",
                        "longitude": "100.00065000"
                    },
                    {
                        "id": 106360,
                        "name": "Amphoe Wiang Chiang Rung",
                        "latitude": "20.02208000",
                        "longitude": "100.07472000"
                    },
                    {
                        "id": 106362,
                        "name": "Amphoe Wiang Kaen",
                        "latitude": "20.00874000",
                        "longitude": "100.48641000"
                    },
                    {
                        "id": 106365,
                        "name": "Amphoe Wiang Pa Pao",
                        "latitude": "19.30460000",
                        "longitude": "99.44925000"
                    },
                    {
                        "id": 106472,
                        "name": "Chiang Khong",
                        "latitude": "20.26125000",
                        "longitude": "100.40461000"
                    },
                    {
                        "id": 106475,
                        "name": "Chiang Rai",
                        "latitude": "19.90858000",
                        "longitude": "99.83250000"
                    },
                    {
                        "id": 106476,
                        "name": "Chiang Saen",
                        "latitude": "20.27511000",
                        "longitude": "100.08689000"
                    },
                    {
                        "id": 106562,
                        "name": "Mae Chan",
                        "latitude": "20.14675000",
                        "longitude": "99.85256000"
                    },
                    {
                        "id": 106565,
                        "name": "Mae Sai",
                        "latitude": "20.43353000",
                        "longitude": "99.87617000"
                    },
                    {
                        "id": 106606,
                        "name": "Pa Daet",
                        "latitude": "19.50489000",
                        "longitude": "99.99241000"
                    }
                ]
            },
            {
                "id": 3513,
                "name": "Chon Buri",
                "iso2": "20",
                "latitude": "13.36114310",
                "longitude": "100.98467170",
                "type": "province",
                "cities": [
                    {
                        "id": 105186,
                        "name": "Amphoe Ban Bueng",
                        "latitude": "13.25280000",
                        "longitude": "101.18151000"
                    },
                    {
                        "id": 105254,
                        "name": "Amphoe Bo Thong",
                        "latitude": "13.24227000",
                        "longitude": "101.50864000"
                    },
                    {
                        "id": 105438,
                        "name": "Amphoe Ko Chan",
                        "latitude": "13.40253000",
                        "longitude": "101.38800000"
                    },
                    {
                        "id": 105445,
                        "name": "Amphoe Ko Si Chang",
                        "latitude": "13.15286000",
                        "longitude": "100.81156000"
                    },
                    {
                        "id": 105686,
                        "name": "Amphoe Nong Yai",
                        "latitude": "13.11772000",
                        "longitude": "101.37471000"
                    },
                    {
                        "id": 105721,
                        "name": "Amphoe Phan Thong",
                        "latitude": "13.46300000",
                        "longitude": "101.09131000"
                    },
                    {
                        "id": 105723,
                        "name": "Amphoe Phanat Nikhom",
                        "latitude": "13.46434000",
                        "longitude": "101.21428000"
                    },
                    {
                        "id": 106197,
                        "name": "Amphoe Sattahip",
                        "latitude": "12.71743000",
                        "longitude": "100.92754000"
                    },
                    {
                        "id": 106220,
                        "name": "Amphoe Si Racha",
                        "latitude": "13.12976000",
                        "longitude": "101.04008000"
                    },
                    {
                        "id": 106385,
                        "name": "Ban Bueng",
                        "latitude": "13.31100000",
                        "longitude": "101.11214000"
                    },
                    {
                        "id": 106396,
                        "name": "Ban Ko Lan",
                        "latitude": "12.92419000",
                        "longitude": "100.78794000"
                    },
                    {
                        "id": 106416,
                        "name": "Ban Talat Bueng",
                        "latitude": "13.07147000",
                        "longitude": "101.00314000"
                    },
                    {
                        "id": 106432,
                        "name": "Bang Lamung",
                        "latitude": "13.04704000",
                        "longitude": "100.92891000"
                    },
                    {
                        "id": 106433,
                        "name": "Bang Lamung District",
                        "latitude": "12.92579000",
                        "longitude": "100.89243000"
                    },
                    {
                        "id": 106481,
                        "name": "Chon Buri",
                        "latitude": "13.36220000",
                        "longitude": "100.98345000"
                    },
                    {
                        "id": 106537,
                        "name": "Ko Si Chang",
                        "latitude": "13.16389000",
                        "longitude": "100.80547000"
                    },
                    {
                        "id": 106572,
                        "name": "Mueang Chonburi District",
                        "latitude": "13.34271000",
                        "longitude": "101.00111000"
                    },
                    {
                        "id": 106617,
                        "name": "Pattaya",
                        "latitude": "12.93333000",
                        "longitude": "100.88333000"
                    },
                    {
                        "id": 106620,
                        "name": "Phan Thong",
                        "latitude": "13.46804000",
                        "longitude": "101.09532000"
                    },
                    {
                        "id": 106621,
                        "name": "Phanat Nikhom",
                        "latitude": "13.44581000",
                        "longitude": "101.18445000"
                    },
                    {
                        "id": 106690,
                        "name": "Sattahip",
                        "latitude": "12.66644000",
                        "longitude": "100.90073000"
                    },
                    {
                        "id": 106699,
                        "name": "Si Racha",
                        "latitude": "13.17372000",
                        "longitude": "100.93111000"
                    }
                ]
            },
            {
                "id": 3526,
                "name": "Chumphon",
                "iso2": "86",
                "latitude": "10.49304960",
                "longitude": "99.18001990",
                "type": "province",
                "cities": [
                    {
                        "id": 105478,
                        "name": "Amphoe Lamae",
                        "latitude": "9.75567000",
                        "longitude": "99.04378000"
                    },
                    {
                        "id": 105483,
                        "name": "Amphoe Lang Suan",
                        "latitude": "9.93386000",
                        "longitude": "99.05292000"
                    },
                    {
                        "id": 105541,
                        "name": "Amphoe Mueang Chumphon",
                        "latitude": "10.46077000",
                        "longitude": "99.10608000"
                    },
                    {
                        "id": 105713,
                        "name": "Amphoe Pathio",
                        "latitude": "10.81008000",
                        "longitude": "99.33938000"
                    },
                    {
                        "id": 105731,
                        "name": "Amphoe Phato",
                        "latitude": "9.81066000",
                        "longitude": "98.80178000"
                    },
                    {
                        "id": 106204,
                        "name": "Amphoe Sawi",
                        "latitude": "10.24008000",
                        "longitude": "99.01865000"
                    },
                    {
                        "id": 106283,
                        "name": "Amphoe Tha Sae",
                        "latitude": "10.76864000",
                        "longitude": "99.09878000"
                    },
                    {
                        "id": 106318,
                        "name": "Amphoe Thung Tako",
                        "latitude": "10.09223000",
                        "longitude": "99.05337000"
                    },
                    {
                        "id": 106403,
                        "name": "Ban Nam Yuen",
                        "latitude": "9.87686000",
                        "longitude": "98.86592000"
                    },
                    {
                        "id": 106484,
                        "name": "Chumphon",
                        "latitude": "10.49570000",
                        "longitude": "99.17971000"
                    },
                    {
                        "id": 106553,
                        "name": "Lang Suan",
                        "latitude": "9.94561000",
                        "longitude": "99.07847000"
                    }
                ]
            },
            {
                "id": 3550,
                "name": "Kalasin",
                "iso2": "46",
                "latitude": "16.43850800",
                "longitude": "103.50609940",
                "type": "province",
                "cities": [
                    {
                        "id": 105329,
                        "name": "Amphoe Don Chan",
                        "latitude": "16.46667000",
                        "longitude": "103.71667000"
                    },
                    {
                        "id": 105354,
                        "name": "Amphoe Huai Mek",
                        "latitude": "16.58868000",
                        "longitude": "103.24098000"
                    },
                    {
                        "id": 105355,
                        "name": "Amphoe Huai Phueng",
                        "latitude": "16.66972000",
                        "longitude": "103.87997000"
                    },
                    {
                        "id": 105368,
                        "name": "Amphoe Kamalasai",
                        "latitude": "16.27999000",
                        "longitude": "103.60010000"
                    },
                    {
                        "id": 105384,
                        "name": "Amphoe Kham Muang",
                        "latitude": "16.93884000",
                        "longitude": "103.63980000"
                    },
                    {
                        "id": 105399,
                        "name": "Amphoe Khao Wong",
                        "latitude": "16.67959000",
                        "longitude": "104.10030000"
                    },
                    {
                        "id": 105423,
                        "name": "Amphoe Khong Chai",
                        "latitude": "16.25845000",
                        "longitude": "103.48167000"
                    },
                    {
                        "id": 105459,
                        "name": "Amphoe Kuchinarai",
                        "latitude": "16.51977000",
                        "longitude": "104.05097000"
                    },
                    {
                        "id": 105542,
                        "name": "Amphoe Mueang Kalasin",
                        "latitude": "16.50918000",
                        "longitude": "103.54984000"
                    },
                    {
                        "id": 105615,
                        "name": "Amphoe Na Khu",
                        "latitude": "16.75018000",
                        "longitude": "104.00062000"
                    },
                    {
                        "id": 105618,
                        "name": "Amphoe Na Mon",
                        "latitude": "16.56994000",
                        "longitude": "103.78015000"
                    },
                    {
                        "id": 105670,
                        "name": "Amphoe Nong Kung Si",
                        "latitude": "16.71932000",
                        "longitude": "103.31922000"
                    },
                    {
                        "id": 105813,
                        "name": "Amphoe Rong Kham",
                        "latitude": "16.27925000",
                        "longitude": "103.71238000"
                    },
                    {
                        "id": 105820,
                        "name": "Amphoe Sahatsakhan",
                        "latitude": "16.70987000",
                        "longitude": "103.57909000"
                    },
                    {
                        "id": 105828,
                        "name": "Amphoe Sam Chai",
                        "latitude": "16.86909000",
                        "longitude": "103.52243000"
                    },
                    {
                        "id": 106243,
                        "name": "Amphoe Somdet",
                        "latitude": "16.76973000",
                        "longitude": "103.75012000"
                    },
                    {
                        "id": 106274,
                        "name": "Amphoe Tha Khantho",
                        "latitude": "16.88333000",
                        "longitude": "103.25000000"
                    },
                    {
                        "id": 106376,
                        "name": "Amphoe Yang Talat",
                        "latitude": "16.43961000",
                        "longitude": "103.34085000"
                    },
                    {
                        "id": 106501,
                        "name": "Huai Mek",
                        "latitude": "16.58975000",
                        "longitude": "103.23547000"
                    },
                    {
                        "id": 106506,
                        "name": "Kalasin",
                        "latitude": "16.43281000",
                        "longitude": "103.50658000"
                    },
                    {
                        "id": 106507,
                        "name": "Kamalasai",
                        "latitude": "16.33839000",
                        "longitude": "103.57564000"
                    },
                    {
                        "id": 106520,
                        "name": "Khao Wong",
                        "latitude": "16.70008000",
                        "longitude": "104.09019000"
                    },
                    {
                        "id": 106543,
                        "name": "Kuchinarai",
                        "latitude": "16.54100000",
                        "longitude": "104.05004000"
                    },
                    {
                        "id": 106602,
                        "name": "Nong Kung Si",
                        "latitude": "16.65000000",
                        "longitude": "103.30000000"
                    },
                    {
                        "id": 106757,
                        "name": "Yang Talat",
                        "latitude": "16.39982000",
                        "longitude": "103.36785000"
                    }
                ]
            },
            {
                "id": 3516,
                "name": "Kamphaeng Phet",
                "iso2": "62",
                "latitude": "16.48277980",
                "longitude": "99.52266180",
                "type": "province",
                "cities": [
                    {
                        "id": 105263,
                        "name": "Amphoe Bueng Samakkhi",
                        "latitude": "16.21262000",
                        "longitude": "99.96720000"
                    },
                    {
                        "id": 105390,
                        "name": "Amphoe Khanu Woralaksaburi",
                        "latitude": "16.00233000",
                        "longitude": "99.67618000"
                    },
                    {
                        "id": 105407,
                        "name": "Amphoe Khlong Khlung",
                        "latitude": "16.22191000",
                        "longitude": "99.67654000"
                    },
                    {
                        "id": 105409,
                        "name": "Amphoe Khlong Lan",
                        "latitude": "16.25992000",
                        "longitude": "99.21806000"
                    },
                    {
                        "id": 105449,
                        "name": "Amphoe Kosamphi Nakhon",
                        "latitude": "16.60702000",
                        "longitude": "99.34795000"
                    },
                    {
                        "id": 105480,
                        "name": "Amphoe Lan Krabue",
                        "latitude": "16.60348000",
                        "longitude": "99.86521000"
                    },
                    {
                        "id": 105543,
                        "name": "Amphoe Mueang Kamphaeng Phet",
                        "latitude": "16.43254000",
                        "longitude": "99.48831000"
                    },
                    {
                        "id": 105712,
                        "name": "Amphoe Pang Sila Thong",
                        "latitude": "16.02525000",
                        "longitude": "99.35593000"
                    },
                    {
                        "id": 105768,
                        "name": "Amphoe Phran Kratai",
                        "latitude": "16.70541000",
                        "longitude": "99.53704000"
                    },
                    {
                        "id": 105823,
                        "name": "Amphoe Sai Ngam",
                        "latitude": "16.43956000",
                        "longitude": "99.87457000"
                    },
                    {
                        "id": 105825,
                        "name": "Amphoe Sai Thong Watthana",
                        "latitude": "16.30859000",
                        "longitude": "99.87854000"
                    },
                    {
                        "id": 106508,
                        "name": "Kamphaeng Phet",
                        "latitude": "16.48344000",
                        "longitude": "99.52153000"
                    },
                    {
                        "id": 106519,
                        "name": "Khanu Woralaksaburi",
                        "latitude": "16.06170000",
                        "longitude": "99.86058000"
                    },
                    {
                        "id": 106551,
                        "name": "Lan Krabue",
                        "latitude": "16.60003000",
                        "longitude": "99.84889000"
                    }
                ]
            },
            {
                "id": 3511,
                "name": "Kanchanaburi",
                "iso2": "71",
                "latitude": "14.10113930",
                "longitude": "99.41794310",
                "type": "province",
                "cities": [
                    {
                        "id": 105252,
                        "name": "Amphoe Bo Phloi",
                        "latitude": "14.38723000",
                        "longitude": "99.44990000"
                    },
                    {
                        "id": 105319,
                        "name": "Amphoe Dan Makham Tia",
                        "latitude": "13.83422000",
                        "longitude": "99.34125000"
                    },
                    {
                        "id": 105353,
                        "name": "Amphoe Huai Krachao",
                        "latitude": "14.34056000",
                        "longitude": "99.67633000"
                    },
                    {
                        "id": 105484,
                        "name": "Amphoe Lao Khwan",
                        "latitude": "14.59488000",
                        "longitude": "99.68338000"
                    },
                    {
                        "id": 105544,
                        "name": "Amphoe Mueang Kanchanaburi",
                        "latitude": "14.06987000",
                        "longitude": "99.32769000"
                    },
                    {
                        "id": 105677,
                        "name": "Amphoe Nong Prue",
                        "latitude": "14.67801000",
                        "longitude": "99.41075000"
                    },
                    {
                        "id": 105730,
                        "name": "Amphoe Phanom Thuan",
                        "latitude": "14.15941000",
                        "longitude": "99.66904000"
                    },
                    {
                        "id": 105826,
                        "name": "Amphoe Sai Yok",
                        "latitude": "14.25652000",
                        "longitude": "98.93372000"
                    },
                    {
                        "id": 106188,
                        "name": "Amphoe Sangkhla Buri",
                        "latitude": "15.19337000",
                        "longitude": "98.52791000"
                    },
                    {
                        "id": 106225,
                        "name": "Amphoe Si Sawat",
                        "latitude": "14.67254000",
                        "longitude": "99.12992000"
                    },
                    {
                        "id": 106278,
                        "name": "Amphoe Tha Maka",
                        "latitude": "13.94665000",
                        "longitude": "99.77900000"
                    },
                    {
                        "id": 106279,
                        "name": "Amphoe Tha Muang",
                        "latitude": "13.90947000",
                        "longitude": "99.61540000"
                    },
                    {
                        "id": 106309,
                        "name": "Amphoe Thong Pha Phum",
                        "latitude": "14.83277000",
                        "longitude": "98.69233000"
                    },
                    {
                        "id": 106452,
                        "name": "Bo Phloi",
                        "latitude": "14.32517000",
                        "longitude": "99.51467000"
                    },
                    {
                        "id": 106510,
                        "name": "Kanchanaburi",
                        "latitude": "14.00412000",
                        "longitude": "99.54832000"
                    },
                    {
                        "id": 106624,
                        "name": "Phanom Thuan",
                        "latitude": "14.13031000",
                        "longitude": "99.69858000"
                    },
                    {
                        "id": 106685,
                        "name": "Sangkhla Buri",
                        "latitude": "15.15553000",
                        "longitude": "98.45361000"
                    },
                    {
                        "id": 106722,
                        "name": "Tha Maka",
                        "latitude": "13.90000000",
                        "longitude": "99.76667000"
                    },
                    {
                        "id": 106723,
                        "name": "Tha Muang",
                        "latitude": "13.96118000",
                        "longitude": "99.64122000"
                    }
                ]
            },
            {
                "id": 3485,
                "name": "Khon Kaen",
                "iso2": "40",
                "latitude": "16.43219380",
                "longitude": "102.82362140",
                "type": "province",
                "cities": [
                    {
                        "id": 105191,
                        "name": "Amphoe Ban Fang",
                        "latitude": "16.49162000",
                        "longitude": "102.61669000"
                    },
                    {
                        "id": 105192,
                        "name": "Amphoe Ban Haet",
                        "latitude": "16.20067000",
                        "longitude": "102.77465000"
                    },
                    {
                        "id": 105211,
                        "name": "Amphoe Ban Phai",
                        "latitude": "16.04603000",
                        "longitude": "102.77755000"
                    },
                    {
                        "id": 105307,
                        "name": "Amphoe Chonnabot",
                        "latitude": "16.02249000",
                        "longitude": "102.55946000"
                    },
                    {
                        "id": 105310,
                        "name": "Amphoe Chum Phae",
                        "latitude": "16.61591000",
                        "longitude": "102.09619000"
                    },
                    {
                        "id": 105398,
                        "name": "Amphoe Khao Suan Kwang",
                        "latitude": "16.91682000",
                        "longitude": "102.78206000"
                    },
                    {
                        "id": 105417,
                        "name": "Amphoe Khok Pho Chai",
                        "latitude": "16.07194000",
                        "longitude": "102.38428000"
                    },
                    {
                        "id": 105452,
                        "name": "Amphoe Kranuan",
                        "latitude": "16.75261000",
                        "longitude": "103.08044000"
                    },
                    {
                        "id": 105525,
                        "name": "Amphoe Mancha Khiri",
                        "latitude": "16.21242000",
                        "longitude": "102.51973000"
                    },
                    {
                        "id": 105545,
                        "name": "Amphoe Mueang Khon Kaen",
                        "latitude": "16.46048000",
                        "longitude": "102.80873000"
                    },
                    {
                        "id": 105638,
                        "name": "Amphoe Nam Phong",
                        "latitude": "16.69946000",
                        "longitude": "102.88125000"
                    },
                    {
                        "id": 105654,
                        "name": "Amphoe Non Sila",
                        "latitude": "15.96420000",
                        "longitude": "102.69074000"
                    },
                    {
                        "id": 105674,
                        "name": "Amphoe Nong Na Kham",
                        "latitude": "16.81010000",
                        "longitude": "102.32800000"
                    },
                    {
                        "id": 105678,
                        "name": "Amphoe Nong Ruea",
                        "latitude": "16.49166000",
                        "longitude": "102.44572000"
                    },
                    {
                        "id": 105681,
                        "name": "Amphoe Nong Song Hong",
                        "latitude": "15.76419000",
                        "longitude": "102.79174000"
                    },
                    {
                        "id": 105751,
                        "name": "Amphoe Phon",
                        "latitude": "15.80672000",
                        "longitude": "102.59111000"
                    },
                    {
                        "id": 105766,
                        "name": "Amphoe Phra Yuen",
                        "latitude": "16.30823000",
                        "longitude": "102.67108000"
                    },
                    {
                        "id": 105777,
                        "name": "Amphoe Phu Pha Man",
                        "latitude": "16.71864000",
                        "longitude": "101.87081000"
                    },
                    {
                        "id": 105783,
                        "name": "Amphoe Phu Wiang",
                        "latitude": "16.67910000",
                        "longitude": "102.39893000"
                    },
                    {
                        "id": 105801,
                        "name": "Amphoe Pueai Noi",
                        "latitude": "15.88867000",
                        "longitude": "102.87618000"
                    },
                    {
                        "id": 106178,
                        "name": "Amphoe Sam Sung",
                        "latitude": "16.56208000",
                        "longitude": "103.05473000"
                    },
                    {
                        "id": 106212,
                        "name": "Amphoe Si Chom Phu",
                        "latitude": "16.76258000",
                        "longitude": "102.13078000"
                    },
                    {
                        "id": 106325,
                        "name": "Amphoe Ubolratana",
                        "latitude": "16.77766000",
                        "longitude": "102.67536000"
                    },
                    {
                        "id": 106331,
                        "name": "Amphoe Waeng Noi",
                        "latitude": "15.80631000",
                        "longitude": "102.42358000"
                    },
                    {
                        "id": 106332,
                        "name": "Amphoe Waeng Yai",
                        "latitude": "15.92532000",
                        "longitude": "102.46221000"
                    },
                    {
                        "id": 106363,
                        "name": "Amphoe Wiang Kao",
                        "latitude": "16.70138000",
                        "longitude": "102.29186000"
                    },
                    {
                        "id": 106406,
                        "name": "Ban Phai",
                        "latitude": "16.05997000",
                        "longitude": "102.73097000"
                    },
                    {
                        "id": 106483,
                        "name": "Chum Phae",
                        "latitude": "16.54430000",
                        "longitude": "102.09924000"
                    },
                    {
                        "id": 106531,
                        "name": "Khon Kaen",
                        "latitude": "16.44671000",
                        "longitude": "102.83300000"
                    },
                    {
                        "id": 106541,
                        "name": "Kranuan",
                        "latitude": "16.70672000",
                        "longitude": "103.07878000"
                    },
                    {
                        "id": 106639,
                        "name": "Phon",
                        "latitude": "15.81600000",
                        "longitude": "102.59981000"
                    },
                    {
                        "id": 106659,
                        "name": "Pueai Noi",
                        "latitude": "15.86978000",
                        "longitude": "102.90767000"
                    }
                ]
            },
            {
                "id": 3478,
                "name": "Krabi",
                "iso2": "81",
                "latitude": "8.08629970",
                "longitude": "98.90628350",
                "type": "province",
                "cities": [
                    {
                        "id": 105182,
                        "name": "Amphoe Ao Luek",
                        "latitude": "8.38526000",
                        "longitude": "98.75378000"
                    },
                    {
                        "id": 105396,
                        "name": "Amphoe Khao Phanom",
                        "latitude": "8.26953000",
                        "longitude": "99.11813000"
                    },
                    {
                        "id": 105411,
                        "name": "Amphoe Khlong Thom",
                        "latitude": "7.91470000",
                        "longitude": "99.19935000"
                    },
                    {
                        "id": 105442,
                        "name": "Amphoe Ko Lanta",
                        "latitude": "7.71267000",
                        "longitude": "99.07813000"
                    },
                    {
                        "id": 105477,
                        "name": "Amphoe Lam Thap",
                        "latitude": "8.04799000",
                        "longitude": "99.33543000"
                    },
                    {
                        "id": 105546,
                        "name": "Amphoe Mueang Krabi",
                        "latitude": "8.15947000",
                        "longitude": "98.86661000"
                    },
                    {
                        "id": 105689,
                        "name": "Amphoe Nuea Khlong",
                        "latitude": "8.06058000",
                        "longitude": "99.04039000"
                    },
                    {
                        "id": 105789,
                        "name": "Amphoe Plai Phraya",
                        "latitude": "8.54087000",
                        "longitude": "98.83671000"
                    },
                    {
                        "id": 106381,
                        "name": "Ao Luek",
                        "latitude": "8.37803000",
                        "longitude": "98.72117000"
                    },
                    {
                        "id": 106534,
                        "name": "Ko Lanta",
                        "latitude": "7.53362000",
                        "longitude": "99.08647000"
                    },
                    {
                        "id": 106540,
                        "name": "Krabi",
                        "latitude": "8.07257000",
                        "longitude": "98.91052000"
                    },
                    {
                        "id": 106605,
                        "name": "Nuea Khlong",
                        "latitude": "8.07143000",
                        "longitude": "98.99933000"
                    },
                    {
                        "id": 106676,
                        "name": "Saladan",
                        "latitude": "7.61342000",
                        "longitude": "99.03651000"
                    }
                ]
            },
            {
                "id": 3544,
                "name": "Lampang",
                "iso2": "52",
                "latitude": "18.28553950",
                "longitude": "99.51278950",
                "type": "province",
                "cities": [
                    {
                        "id": 105268,
                        "name": "Amphoe Chae Hom",
                        "latitude": "18.75404000",
                        "longitude": "99.66822000"
                    },
                    {
                        "id": 105343,
                        "name": "Amphoe Hang Chat",
                        "latitude": "18.35497000",
                        "longitude": "99.27978000"
                    },
                    {
                        "id": 105440,
                        "name": "Amphoe Ko Kha",
                        "latitude": "18.14408000",
                        "longitude": "99.35229000"
                    },
                    {
                        "id": 105505,
                        "name": "Amphoe Mae Mo",
                        "latitude": "18.40244000",
                        "longitude": "99.82135000"
                    },
                    {
                        "id": 105507,
                        "name": "Amphoe Mae Phrik",
                        "latitude": "17.50450000",
                        "longitude": "99.05847000"
                    },
                    {
                        "id": 105517,
                        "name": "Amphoe Mae Tha",
                        "latitude": "18.11122000",
                        "longitude": "99.57826000"
                    },
                    {
                        "id": 105547,
                        "name": "Amphoe Mueang Lampang",
                        "latitude": "18.38901000",
                        "longitude": "99.54388000"
                    },
                    {
                        "id": 105564,
                        "name": "Amphoe Mueang Pan",
                        "latitude": "18.79093000",
                        "longitude": "99.45408000"
                    },
                    {
                        "id": 105642,
                        "name": "Amphoe Ngao",
                        "latitude": "18.75948000",
                        "longitude": "99.95295000"
                    },
                    {
                        "id": 106240,
                        "name": "Amphoe Soem Ngam",
                        "latitude": "18.09406000",
                        "longitude": "99.17297000"
                    },
                    {
                        "id": 106249,
                        "name": "Amphoe Sop Prap",
                        "latitude": "17.89861000",
                        "longitude": "99.34081000"
                    },
                    {
                        "id": 106307,
                        "name": "Amphoe Thoen",
                        "latitude": "17.58128000",
                        "longitude": "99.28836000"
                    },
                    {
                        "id": 106342,
                        "name": "Amphoe Wang Nuea",
                        "latitude": "19.16011000",
                        "longitude": "99.64767000"
                    },
                    {
                        "id": 106549,
                        "name": "Lampang",
                        "latitude": "18.29232000",
                        "longitude": "99.49277000"
                    },
                    {
                        "id": 106731,
                        "name": "Thoen",
                        "latitude": "17.61289000",
                        "longitude": "99.21612000"
                    },
                    {
                        "id": 106745,
                        "name": "Wang Nuea",
                        "latitude": "19.14678000",
                        "longitude": "99.61933000"
                    }
                ]
            },
            {
                "id": 3483,
                "name": "Lamphun",
                "iso2": "51",
                "latitude": "18.57446060",
                "longitude": "99.00872210",
                "type": "province",
                "cities": [
                    {
                        "id": 105193,
                        "name": "Amphoe Ban Hong",
                        "latitude": "18.27422000",
                        "longitude": "98.83794000"
                    },
                    {
                        "id": 105220,
                        "name": "Amphoe Ban Thi",
                        "latitude": "18.65894000",
                        "longitude": "99.15883000"
                    },
                    {
                        "id": 105490,
                        "name": "Amphoe Li",
                        "latitude": "17.78639000",
                        "longitude": "98.88674000"
                    },
                    {
                        "id": 105516,
                        "name": "Amphoe Mae Tha",
                        "latitude": "18.39540000",
                        "longitude": "99.09233000"
                    },
                    {
                        "id": 105548,
                        "name": "Amphoe Mueang Lamphun",
                        "latitude": "18.55217000",
                        "longitude": "99.05905000"
                    },
                    {
                        "id": 105697,
                        "name": "Amphoe Pa Sang",
                        "latitude": "18.41397000",
                        "longitude": "98.88281000"
                    },
                    {
                        "id": 106313,
                        "name": "Amphoe Thung Hua Chang",
                        "latitude": "17.98333000",
                        "longitude": "99.05000000"
                    },
                    {
                        "id": 106364,
                        "name": "Amphoe Wiang Nong Long",
                        "latitude": "18.41844000",
                        "longitude": "98.75856000"
                    },
                    {
                        "id": 106550,
                        "name": "Lamphun",
                        "latitude": "18.58054000",
                        "longitude": "99.00745000"
                    },
                    {
                        "id": 106567,
                        "name": "Mae Tha",
                        "latitude": "18.46456000",
                        "longitude": "99.14026000"
                    },
                    {
                        "id": 106607,
                        "name": "Pa Sang",
                        "latitude": "18.52617000",
                        "longitude": "98.93936000"
                    }
                ]
            },
            {
                "id": 3509,
                "name": "Loei",
                "iso2": "42",
                "latitude": "17.48602320",
                "longitude": "101.72230020",
                "type": "province",
                "cities": [
                    {
                        "id": 105294,
                        "name": "Amphoe Chiang Khan",
                        "latitude": "17.82441000",
                        "longitude": "101.73424000"
                    },
                    {
                        "id": 105320,
                        "name": "Amphoe Dan Sai",
                        "latitude": "17.22101000",
                        "longitude": "101.22373000"
                    },
                    {
                        "id": 105338,
                        "name": "Amphoe Erawan",
                        "latitude": "17.28823000",
                        "longitude": "101.97443000"
                    },
                    {
                        "id": 105549,
                        "name": "Amphoe Mueang Loei",
                        "latitude": "17.54211000",
                        "longitude": "101.71932000"
                    },
                    {
                        "id": 105611,
                        "name": "Amphoe Na Duang",
                        "latitude": "17.53833000",
                        "longitude": "101.99639000"
                    },
                    {
                        "id": 105613,
                        "name": "Amphoe Na Haeo",
                        "latitude": "17.43942000",
                        "longitude": "100.99654000"
                    },
                    {
                        "id": 105665,
                        "name": "Amphoe Nong Hin",
                        "latitude": "17.08087000",
                        "longitude": "101.82643000"
                    },
                    {
                        "id": 105700,
                        "name": "Amphoe Pak Chom",
                        "latitude": "17.91100000",
                        "longitude": "101.95777000"
                    },
                    {
                        "id": 105716,
                        "name": "Amphoe Pha Khao",
                        "latitude": "17.05638000",
                        "longitude": "102.01575000"
                    },
                    {
                        "id": 105775,
                        "name": "Amphoe Phu Kradueng",
                        "latitude": "16.90190000",
                        "longitude": "101.84562000"
                    },
                    {
                        "id": 105776,
                        "name": "Amphoe Phu Luang",
                        "latitude": "17.09782000",
                        "longitude": "101.64413000"
                    },
                    {
                        "id": 105780,
                        "name": "Amphoe Phu Ruea",
                        "latitude": "17.35076000",
                        "longitude": "101.41329000"
                    },
                    {
                        "id": 106275,
                        "name": "Amphoe Tha Li",
                        "latitude": "17.61279000",
                        "longitude": "101.44141000"
                    },
                    {
                        "id": 106346,
                        "name": "Amphoe Wang Saphung",
                        "latitude": "17.28028000",
                        "longitude": "101.73342000"
                    },
                    {
                        "id": 106557,
                        "name": "Loei",
                        "latitude": "17.49052000",
                        "longitude": "101.72749000"
                    },
                    {
                        "id": 106649,
                        "name": "Phu Kradueng",
                        "latitude": "16.88425000",
                        "longitude": "101.88467000"
                    },
                    {
                        "id": 106747,
                        "name": "Wang Saphung",
                        "latitude": "17.30097000",
                        "longitude": "101.76850000"
                    }
                ]
            },
            {
                "id": 3543,
                "name": "Lop Buri",
                "iso2": "16",
                "latitude": "14.79950810",
                "longitude": "100.65337060",
                "type": "province",
                "cities": [
                    {
                        "id": 105203,
                        "name": "Amphoe Ban Mi",
                        "latitude": "15.06154000",
                        "longitude": "100.55200000"
                    },
                    {
                        "id": 105269,
                        "name": "Amphoe Chai Badan",
                        "latitude": "15.18944000",
                        "longitude": "101.12682000"
                    },
                    {
                        "id": 105415,
                        "name": "Amphoe Khok Charoen",
                        "latitude": "15.40384000",
                        "longitude": "100.84968000"
                    },
                    {
                        "id": 105418,
                        "name": "Amphoe Khok Samrong",
                        "latitude": "15.04303000",
                        "longitude": "100.77151000"
                    },
                    {
                        "id": 105475,
                        "name": "Amphoe Lam Sonthi",
                        "latitude": "15.32833000",
                        "longitude": "101.34783000"
                    },
                    {
                        "id": 105672,
                        "name": "Amphoe Nong Muang",
                        "latitude": "15.27740000",
                        "longitude": "100.70413000"
                    },
                    {
                        "id": 105732,
                        "name": "Amphoe Phatthana Nikhom",
                        "latitude": "14.90917000",
                        "longitude": "101.02673000"
                    },
                    {
                        "id": 105816,
                        "name": "Amphoe Sa Bot",
                        "latitude": "15.23832000",
                        "longitude": "100.88318000"
                    },
                    {
                        "id": 106276,
                        "name": "Amphoe Tha Luang",
                        "latitude": "15.04786000",
                        "longitude": "101.19986000"
                    },
                    {
                        "id": 106291,
                        "name": "Amphoe Tha Wung",
                        "latitude": "14.82506000",
                        "longitude": "100.50921000"
                    },
                    {
                        "id": 106461,
                        "name": "Chai Badan",
                        "latitude": "15.20000000",
                        "longitude": "101.13333000"
                    },
                    {
                        "id": 106560,
                        "name": "Lop Buri",
                        "latitude": "14.79808000",
                        "longitude": "100.65397000"
                    },
                    {
                        "id": 106571,
                        "name": "Muang Lop Buri District",
                        "latitude": "14.82334000",
                        "longitude": "100.67557000"
                    }
                ]
            },
            {
                "id": 3505,
                "name": "Mae Hong Son",
                "iso2": "58",
                "latitude": "19.30202960",
                "longitude": "97.96543680",
                "type": "province",
                "cities": [
                    {
                        "id": 105434,
                        "name": "Amphoe Khun Yuam",
                        "latitude": "18.82643000",
                        "longitude": "97.93303000"
                    },
                    {
                        "id": 105502,
                        "name": "Amphoe Mae La Noi",
                        "latitude": "18.47823000",
                        "longitude": "97.98295000"
                    },
                    {
                        "id": 105512,
                        "name": "Amphoe Mae Sariang",
                        "latitude": "18.26474000",
                        "longitude": "97.77057000"
                    },
                    {
                        "id": 105550,
                        "name": "Amphoe Mueang Mae Hong Son",
                        "latitude": "19.28862000",
                        "longitude": "98.00607000"
                    },
                    {
                        "id": 105699,
                        "name": "Amphoe Pai",
                        "latitude": "19.36036000",
                        "longitude": "98.40638000"
                    },
                    {
                        "id": 105711,
                        "name": "Amphoe Pang Mapha",
                        "latitude": "19.60451000",
                        "longitude": "98.20560000"
                    },
                    {
                        "id": 106248,
                        "name": "Amphoe Sop Moei",
                        "latitude": "17.96333000",
                        "longitude": "97.93149000"
                    },
                    {
                        "id": 106563,
                        "name": "Mae Hong Son",
                        "latitude": "19.30029000",
                        "longitude": "97.96852000"
                    }
                ]
            },
            {
                "id": 3517,
                "name": "Maha Sarakham",
                "iso2": "44",
                "latitude": "16.01320150",
                "longitude": "103.16151690",
                "type": "province",
                "cities": [
                    {
                        "id": 105255,
                        "name": "Amphoe Borabue",
                        "latitude": "15.98881000",
                        "longitude": "103.12521000"
                    },
                    {
                        "id": 105300,
                        "name": "Amphoe Chiang Yuen",
                        "latitude": "16.40942000",
                        "longitude": "103.07005000"
                    },
                    {
                        "id": 105308,
                        "name": "Amphoe Chuen Chom",
                        "latitude": "16.54801000",
                        "longitude": "103.14796000"
                    },
                    {
                        "id": 105363,
                        "name": "Amphoe Kae Dam",
                        "latitude": "16.04961000",
                        "longitude": "103.38953000"
                    },
                    {
                        "id": 105373,
                        "name": "Amphoe Kantharawichai",
                        "latitude": "16.27992000",
                        "longitude": "103.25892000"
                    },
                    {
                        "id": 105450,
                        "name": "Amphoe Kosum Phisai",
                        "latitude": "16.23882000",
                        "longitude": "102.99081000"
                    },
                    {
                        "id": 105467,
                        "name": "Amphoe Kut Rang",
                        "latitude": "16.02970000",
                        "longitude": "102.95059000"
                    },
                    {
                        "id": 105551,
                        "name": "Amphoe Mueang Maha Sarakham",
                        "latitude": "16.11882000",
                        "longitude": "103.31160000"
                    },
                    {
                        "id": 105609,
                        "name": "Amphoe Na Chueak",
                        "latitude": "15.80180000",
                        "longitude": "103.05725000"
                    },
                    {
                        "id": 105612,
                        "name": "Amphoe Na Dun",
                        "latitude": "15.71952000",
                        "longitude": "103.23004000"
                    },
                    {
                        "id": 105734,
                        "name": "Amphoe Phayakkhaphum Phisai",
                        "latitude": "15.51963000",
                        "longitude": "103.23268000"
                    },
                    {
                        "id": 106352,
                        "name": "Amphoe Wapi Pathum",
                        "latitude": "15.85953000",
                        "longitude": "103.34091000"
                    },
                    {
                        "id": 106375,
                        "name": "Amphoe Yang Si Surat",
                        "latitude": "15.64953000",
                        "longitude": "103.08916000"
                    },
                    {
                        "id": 106539,
                        "name": "Kosum Phisai",
                        "latitude": "16.24858000",
                        "longitude": "103.06739000"
                    },
                    {
                        "id": 106568,
                        "name": "Maha Sarakham",
                        "latitude": "16.18483000",
                        "longitude": "103.30067000"
                    },
                    {
                        "id": 106628,
                        "name": "Phayakkhaphum Phisai",
                        "latitude": "15.51631000",
                        "longitude": "103.19367000"
                    },
                    {
                        "id": 106749,
                        "name": "Wapi Pathum",
                        "latitude": "15.84523000",
                        "longitude": "103.37678000"
                    }
                ]
            },
            {
                "id": 3546,
                "name": "Mukdahan",
                "iso2": "49",
                "latitude": "16.54359140",
                "longitude": "104.70241210",
                "type": "province",
                "cities": [
                    {
                        "id": 105334,
                        "name": "Amphoe Don Tan",
                        "latitude": "16.28796000",
                        "longitude": "104.82231000"
                    },
                    {
                        "id": 105337,
                        "name": "Amphoe Dong Luang",
                        "latitude": "16.79649000",
                        "longitude": "104.35562000"
                    },
                    {
                        "id": 105388,
                        "name": "Amphoe Khamcha-i",
                        "latitude": "16.61452000",
                        "longitude": "104.35929000"
                    },
                    {
                        "id": 105552,
                        "name": "Amphoe Mueang Mukdahan",
                        "latitude": "16.55110000",
                        "longitude": "104.64605000"
                    },
                    {
                        "id": 105643,
                        "name": "Amphoe Nikhom Kham Soi",
                        "latitude": "16.35375000",
                        "longitude": "104.55864000"
                    },
                    {
                        "id": 105683,
                        "name": "Amphoe Nong Sung",
                        "latitude": "16.44759000",
                        "longitude": "104.33649000"
                    },
                    {
                        "id": 106333,
                        "name": "Amphoe Wan Yai",
                        "latitude": "16.72030000",
                        "longitude": "104.72865000"
                    },
                    {
                        "id": 106574,
                        "name": "Mukdahan",
                        "latitude": "16.54531000",
                        "longitude": "104.72351000"
                    }
                ]
            },
            {
                "id": 3535,
                "name": "Nakhon Nayok",
                "iso2": "26",
                "latitude": "14.20694660",
                "longitude": "101.21305110",
                "type": "province",
                "cities": [
                    {
                        "id": 105206,
                        "name": "Amphoe Ban Na",
                        "latitude": "14.26799000",
                        "longitude": "101.06445000"
                    },
                    {
                        "id": 105553,
                        "name": "Amphoe Mueang Nakhon Nayok",
                        "latitude": "14.27730000",
                        "longitude": "101.23379000"
                    },
                    {
                        "id": 105691,
                        "name": "Amphoe Ongkharak",
                        "latitude": "14.07554000",
                        "longitude": "101.00891000"
                    },
                    {
                        "id": 105706,
                        "name": "Amphoe Pak Phli",
                        "latitude": "14.22499000",
                        "longitude": "101.34482000"
                    },
                    {
                        "id": 106580,
                        "name": "Nakhon Nayok",
                        "latitude": "14.20463000",
                        "longitude": "101.21295000"
                    }
                ]
            },
            {
                "id": 3503,
                "name": "Nakhon Pathom",
                "iso2": "73",
                "latitude": "13.81402930",
                "longitude": "100.03729290",
                "type": "province",
                "cities": [
                    {
                        "id": 105231,
                        "name": "Amphoe Bang Len",
                        "latitude": "14.05000000",
                        "longitude": "100.18333000"
                    },
                    {
                        "id": 105335,
                        "name": "Amphoe Don Tum",
                        "latitude": "13.94499000",
                        "longitude": "100.09003000"
                    },
                    {
                        "id": 105554,
                        "name": "Amphoe Mueang Nakhon Pathom",
                        "latitude": "13.81944000",
                        "longitude": "100.02375000"
                    },
                    {
                        "id": 105631,
                        "name": "Amphoe Nakhon Chai Si",
                        "latitude": "13.81173000",
                        "longitude": "100.18157000"
                    },
                    {
                        "id": 105786,
                        "name": "Amphoe Phutthamonthon",
                        "latitude": "13.82559000",
                        "longitude": "100.29239000"
                    },
                    {
                        "id": 106176,
                        "name": "Amphoe Sam Phran",
                        "latitude": "13.72035000",
                        "longitude": "100.21071000"
                    },
                    {
                        "id": 106434,
                        "name": "Bang Len",
                        "latitude": "14.02188000",
                        "longitude": "100.17183000"
                    },
                    {
                        "id": 106509,
                        "name": "Kamphaeng Saen District",
                        "latitude": "14.02823000",
                        "longitude": "99.96152000"
                    },
                    {
                        "id": 106581,
                        "name": "Nakhon Pathom",
                        "latitude": "13.81960000",
                        "longitude": "100.04427000"
                    },
                    {
                        "id": 106677,
                        "name": "Sam Phran",
                        "latitude": "13.72698000",
                        "longitude": "100.21526000"
                    }
                ]
            },
            {
                "id": 3548,
                "name": "Nakhon Phanom",
                "iso2": "48",
                "latitude": "17.39203900",
                "longitude": "104.76955080",
                "type": "province",
                "cities": [
                    {
                        "id": 105209,
                        "name": "Amphoe Ban Phaeng",
                        "latitude": "17.86955000",
                        "longitude": "104.22744000"
                    },
                    {
                        "id": 105555,
                        "name": "Amphoe Mueang Nakhon Phanom",
                        "latitude": "17.31965000",
                        "longitude": "104.68232000"
                    },
                    {
                        "id": 105614,
                        "name": "Amphoe Na Kae",
                        "latitude": "16.95737000",
                        "longitude": "104.49349000"
                    },
                    {
                        "id": 105624,
                        "name": "Amphoe Na Thom",
                        "latitude": "17.82134000",
                        "longitude": "104.10871000"
                    },
                    {
                        "id": 105625,
                        "name": "Amphoe Na Wa",
                        "latitude": "17.49922000",
                        "longitude": "104.11833000"
                    },
                    {
                        "id": 105755,
                        "name": "Amphoe Phon Sawan",
                        "latitude": "17.46868000",
                        "longitude": "104.42234000"
                    },
                    {
                        "id": 105787,
                        "name": "Amphoe Pla Pak",
                        "latitude": "17.20133000",
                        "longitude": "104.54674000"
                    },
                    {
                        "id": 105811,
                        "name": "Amphoe Renu Nakhon",
                        "latitude": "17.05080000",
                        "longitude": "104.65664000"
                    },
                    {
                        "id": 106227,
                        "name": "Amphoe Si Songkhram",
                        "latitude": "17.62989000",
                        "longitude": "104.24495000"
                    },
                    {
                        "id": 106289,
                        "name": "Amphoe Tha Uthen",
                        "latitude": "17.59263000",
                        "longitude": "104.49884000"
                    },
                    {
                        "id": 106303,
                        "name": "Amphoe That Phanom",
                        "latitude": "16.96457000",
                        "longitude": "104.70277000"
                    },
                    {
                        "id": 106350,
                        "name": "Amphoe Wangyang",
                        "latitude": "17.07189000",
                        "longitude": "104.45373000"
                    },
                    {
                        "id": 106577,
                        "name": "Na Wa",
                        "latitude": "17.48970000",
                        "longitude": "104.10056000"
                    },
                    {
                        "id": 106582,
                        "name": "Nakhon Phanom",
                        "latitude": "17.41081000",
                        "longitude": "104.77856000"
                    },
                    {
                        "id": 106729,
                        "name": "That Phanom",
                        "latitude": "16.93636000",
                        "longitude": "104.71039000"
                    }
                ]
            },
            {
                "id": 3497,
                "name": "Nakhon Ratchasima",
                "iso2": "30",
                "latitude": "14.97384930",
                "longitude": "102.08365200",
                "type": "province",
                "cities": [
                    {
                        "id": 105201,
                        "name": "Amphoe Ban Lueam",
                        "latitude": "15.57431000",
                        "longitude": "102.14204000"
                    },
                    {
                        "id": 105257,
                        "name": "Amphoe Bua Lai",
                        "latitude": "15.66917000",
                        "longitude": "102.51761000"
                    },
                    {
                        "id": 105258,
                        "name": "Amphoe Bua Yai",
                        "latitude": "15.58488000",
                        "longitude": "102.38738000"
                    },
                    {
                        "id": 105275,
                        "name": "Amphoe Chakkarat",
                        "latitude": "14.95686000",
                        "longitude": "102.43718000"
                    },
                    {
                        "id": 105280,
                        "name": "Amphoe Chaloem Phra Kiat",
                        "latitude": "14.97540000",
                        "longitude": "102.29372000"
                    },
                    {
                        "id": 105302,
                        "name": "Amphoe Chok Chai",
                        "latitude": "14.76341000",
                        "longitude": "102.20338000"
                    },
                    {
                        "id": 105311,
                        "name": "Amphoe Chum Phuang",
                        "latitude": "15.25990000",
                        "longitude": "102.75756000"
                    },
                    {
                        "id": 105318,
                        "name": "Amphoe Dan Khun Thot",
                        "latitude": "15.21835000",
                        "longitude": "101.69790000"
                    },
                    {
                        "id": 105357,
                        "name": "Amphoe Huai Thalaeng",
                        "latitude": "15.04244000",
                        "longitude": "102.63535000"
                    },
                    {
                        "id": 105367,
                        "name": "Amphoe Kaeng Sanam Nang",
                        "latitude": "15.69561000",
                        "longitude": "102.25366000"
                    },
                    {
                        "id": 105385,
                        "name": "Amphoe Kham Sakae Saeng",
                        "latitude": "15.38042000",
                        "longitude": "102.16636000"
                    },
                    {
                        "id": 105387,
                        "name": "Amphoe Kham Thale So",
                        "latitude": "15.03639000",
                        "longitude": "101.93170000"
                    },
                    {
                        "id": 105421,
                        "name": "Amphoe Khon Buri",
                        "latitude": "14.37634000",
                        "longitude": "102.21746000"
                    },
                    {
                        "id": 105422,
                        "name": "Amphoe Khong",
                        "latitude": "15.43311000",
                        "longitude": "102.29617000"
                    },
                    {
                        "id": 105476,
                        "name": "Amphoe Lam Thamen Chai",
                        "latitude": "15.28424000",
                        "longitude": "102.90723000"
                    },
                    {
                        "id": 105556,
                        "name": "Amphoe Mueang Nakhon Ratchasima",
                        "latitude": "14.95678000",
                        "longitude": "102.08933000"
                    },
                    {
                        "id": 105605,
                        "name": "Amphoe Mueang Yang",
                        "latitude": "15.43842000",
                        "longitude": "102.89331000"
                    },
                    {
                        "id": 105648,
                        "name": "Amphoe Non Daeng",
                        "latitude": "15.44479000",
                        "longitude": "102.54565000"
                    },
                    {
                        "id": 105655,
                        "name": "Amphoe Non Sung",
                        "latitude": "15.20892000",
                        "longitude": "102.28400000"
                    },
                    {
                        "id": 105657,
                        "name": "Amphoe Non Thai",
                        "latitude": "15.18106000",
                        "longitude": "102.03001000"
                    },
                    {
                        "id": 105659,
                        "name": "Amphoe Nong Bun Mak",
                        "latitude": "14.71295000",
                        "longitude": "102.37447000"
                    },
                    {
                        "id": 105701,
                        "name": "Amphoe Pak Chong",
                        "latitude": "14.61923000",
                        "longitude": "101.44814000"
                    },
                    {
                        "id": 105708,
                        "name": "Amphoe Pak Thong Chai",
                        "latitude": "14.66228000",
                        "longitude": "101.94227000"
                    },
                    {
                        "id": 105741,
                        "name": "Amphoe Phimai",
                        "latitude": "15.24622000",
                        "longitude": "102.54217000"
                    },
                    {
                        "id": 105765,
                        "name": "Amphoe Phra Thong Kham",
                        "latitude": "15.35114000",
                        "longitude": "101.99355000"
                    },
                    {
                        "id": 105799,
                        "name": "Amphoe Prathai",
                        "latitude": "15.55911000",
                        "longitude": "102.69786000"
                    },
                    {
                        "id": 106232,
                        "name": "Amphoe Sida",
                        "latitude": "15.56406000",
                        "longitude": "102.55823000"
                    },
                    {
                        "id": 106234,
                        "name": "Amphoe Sikhio",
                        "latitude": "14.94275000",
                        "longitude": "101.60672000"
                    },
                    {
                        "id": 106235,
                        "name": "Amphoe Sikhiu",
                        "latitude": "14.89944000",
                        "longitude": "101.70833000"
                    },
                    {
                        "id": 106241,
                        "name": "Amphoe Soeng Sang",
                        "latitude": "14.34456000",
                        "longitude": "102.49297000"
                    },
                    {
                        "id": 106257,
                        "name": "Amphoe Sung Noen",
                        "latitude": "14.85623000",
                        "longitude": "101.83049000"
                    },
                    {
                        "id": 106306,
                        "name": "Amphoe Thepharak",
                        "latitude": "15.28639000",
                        "longitude": "101.50373000"
                    },
                    {
                        "id": 106339,
                        "name": "Amphoe Wang Nam Khiao",
                        "latitude": "14.44786000",
                        "longitude": "101.85533000"
                    },
                    {
                        "id": 106390,
                        "name": "Ban Huai Thalaeng",
                        "latitude": "14.98333000",
                        "longitude": "102.65000000"
                    },
                    {
                        "id": 106454,
                        "name": "Bua Yai",
                        "latitude": "15.58552000",
                        "longitude": "102.42587000"
                    },
                    {
                        "id": 106477,
                        "name": "Chok Chai",
                        "latitude": "14.72844000",
                        "longitude": "102.16524000"
                    },
                    {
                        "id": 106486,
                        "name": "Dan Khun Thot",
                        "latitude": "15.20850000",
                        "longitude": "101.77138000"
                    },
                    {
                        "id": 106517,
                        "name": "Kham Sakae Saeng",
                        "latitude": "15.33221000",
                        "longitude": "102.17278000"
                    },
                    {
                        "id": 106530,
                        "name": "Khon Buri",
                        "latitude": "14.52541000",
                        "longitude": "102.24591000"
                    },
                    {
                        "id": 106583,
                        "name": "Nakhon Ratchasima",
                        "latitude": "14.97066000",
                        "longitude": "102.10196000"
                    },
                    {
                        "id": 106592,
                        "name": "Non Sung",
                        "latitude": "15.18014000",
                        "longitude": "102.25695000"
                    },
                    {
                        "id": 106593,
                        "name": "Non Thai",
                        "latitude": "15.19580000",
                        "longitude": "102.07145000"
                    },
                    {
                        "id": 106609,
                        "name": "Pak Chong",
                        "latitude": "14.70802000",
                        "longitude": "101.41614000"
                    },
                    {
                        "id": 106612,
                        "name": "Pak Thong Chai",
                        "latitude": "14.72260000",
                        "longitude": "102.02512000"
                    },
                    {
                        "id": 106635,
                        "name": "Phimai",
                        "latitude": "15.22324000",
                        "longitude": "102.49473000"
                    },
                    {
                        "id": 106703,
                        "name": "Soeng Sang",
                        "latitude": "14.42642000",
                        "longitude": "102.46058000"
                    },
                    {
                        "id": 106708,
                        "name": "Sung Noen",
                        "latitude": "14.89920000",
                        "longitude": "101.82075000"
                    }
                ]
            },
            {
                "id": 3492,
                "name": "Nakhon Sawan",
                "iso2": "60",
                "latitude": "15.69873820",
                "longitude": "100.11996000",
                "type": "province",
                "cities": [
                    {
                        "id": 105248,
                        "name": "Amphoe Banphot Phisai",
                        "latitude": "15.99714000",
                        "longitude": "99.99409000"
                    },
                    {
                        "id": 105312,
                        "name": "Amphoe Chum Ta Bong",
                        "latitude": "15.68311000",
                        "longitude": "99.56908000"
                    },
                    {
                        "id": 105314,
                        "name": "Amphoe Chumsaeng",
                        "latitude": "15.84745000",
                        "longitude": "100.28971000"
                    },
                    {
                        "id": 105374,
                        "name": "Amphoe Kao Liao",
                        "latitude": "15.88778000",
                        "longitude": "100.09647000"
                    },
                    {
                        "id": 105456,
                        "name": "Amphoe Krok Phra",
                        "latitude": "15.58638000",
                        "longitude": "100.01815000"
                    },
                    {
                        "id": 105489,
                        "name": "Amphoe Lat Yao",
                        "latitude": "15.77526000",
                        "longitude": "99.80046000"
                    },
                    {
                        "id": 105508,
                        "name": "Amphoe Mae Poen",
                        "latitude": "15.70656000",
                        "longitude": "99.34827000"
                    },
                    {
                        "id": 105519,
                        "name": "Amphoe Mae Wong",
                        "latitude": "15.83538000",
                        "longitude": "99.40785000"
                    },
                    {
                        "id": 105557,
                        "name": "Amphoe Mueang Nakhon Sawan",
                        "latitude": "15.71991000",
                        "longitude": "100.10067000"
                    },
                    {
                        "id": 105658,
                        "name": "Amphoe Nong Bua",
                        "latitude": "15.86591000",
                        "longitude": "100.62860000"
                    },
                    {
                        "id": 105718,
                        "name": "Amphoe Phai Sali",
                        "latitude": "15.58723000",
                        "longitude": "100.68530000"
                    },
                    {
                        "id": 105736,
                        "name": "Amphoe Phayuha Khiri",
                        "latitude": "15.50783000",
                        "longitude": "100.21226000"
                    },
                    {
                        "id": 106262,
                        "name": "Amphoe Tak Fa",
                        "latitude": "15.38249000",
                        "longitude": "100.46693000"
                    },
                    {
                        "id": 106263,
                        "name": "Amphoe Takhli",
                        "latitude": "15.25928000",
                        "longitude": "100.38058000"
                    },
                    {
                        "id": 106287,
                        "name": "Amphoe Tha Tako",
                        "latitude": "15.65434000",
                        "longitude": "100.45939000"
                    },
                    {
                        "id": 106514,
                        "name": "Kao Liao",
                        "latitude": "15.85053000",
                        "longitude": "100.07914000"
                    },
                    {
                        "id": 106556,
                        "name": "Lat Yao",
                        "latitude": "15.75100000",
                        "longitude": "99.78925000"
                    },
                    {
                        "id": 106584,
                        "name": "Nakhon Sawan",
                        "latitude": "15.70472000",
                        "longitude": "100.13717000"
                    },
                    {
                        "id": 106594,
                        "name": "Nong Bua",
                        "latitude": "15.86458000",
                        "longitude": "100.58581000"
                    },
                    {
                        "id": 106618,
                        "name": "Phai Sali",
                        "latitude": "15.60003000",
                        "longitude": "100.64937000"
                    },
                    {
                        "id": 106630,
                        "name": "Phayuha Khiri",
                        "latitude": "15.45525000",
                        "longitude": "100.13533000"
                    },
                    {
                        "id": 106715,
                        "name": "Takhli",
                        "latitude": "15.26336000",
                        "longitude": "100.34378000"
                    }
                ]
            },
            {
                "id": 3520,
                "name": "Nakhon Si Thammarat",
                "iso2": "80",
                "latitude": "8.43248310",
                "longitude": "99.95990330",
                "type": "province",
                "cities": [
                    {
                        "id": 105225,
                        "name": "Amphoe Bang Khan",
                        "latitude": "8.01208000",
                        "longitude": "99.48449000"
                    },
                    {
                        "id": 105267,
                        "name": "Amphoe Cha-uat",
                        "latitude": "7.95645000",
                        "longitude": "99.98929000"
                    },
                    {
                        "id": 105278,
                        "name": "Amphoe Chaloem Phra Kiat",
                        "latitude": "8.18333000",
                        "longitude": "100.05000000"
                    },
                    {
                        "id": 105284,
                        "name": "Amphoe Chang Klang",
                        "latitude": "8.35697000",
                        "longitude": "99.64592000"
                    },
                    {
                        "id": 105290,
                        "name": "Amphoe Chawang",
                        "latitude": "8.46322000",
                        "longitude": "99.51107000"
                    },
                    {
                        "id": 105291,
                        "name": "Amphoe Chian Yai",
                        "latitude": "8.11719000",
                        "longitude": "100.15819000"
                    },
                    {
                        "id": 105309,
                        "name": "Amphoe Chulabhorn",
                        "latitude": "8.07591000",
                        "longitude": "99.85365000"
                    },
                    {
                        "id": 105350,
                        "name": "Amphoe Hua Sai",
                        "latitude": "8.01181000",
                        "longitude": "100.24614000"
                    },
                    {
                        "id": 105389,
                        "name": "Amphoe Khanom",
                        "latitude": "9.18317000",
                        "longitude": "99.80192000"
                    },
                    {
                        "id": 105482,
                        "name": "Amphoe Lan Saka",
                        "latitude": "8.37799000",
                        "longitude": "99.78328000"
                    },
                    {
                        "id": 105558,
                        "name": "Amphoe Mueang Nakhon Si Thammarat",
                        "latitude": "8.44013000",
                        "longitude": "99.98537000"
                    },
                    {
                        "id": 105607,
                        "name": "Amphoe Na Bon",
                        "latitude": "8.26976000",
                        "longitude": "99.55694000"
                    },
                    {
                        "id": 105688,
                        "name": "Amphoe Nopphitam",
                        "latitude": "8.75166000",
                        "longitude": "99.67087000"
                    },
                    {
                        "id": 105704,
                        "name": "Amphoe Pak Phanang",
                        "latitude": "8.30711000",
                        "longitude": "100.17361000"
                    },
                    {
                        "id": 105742,
                        "name": "Amphoe Phipun",
                        "latitude": "8.60289000",
                        "longitude": "99.59528000"
                    },
                    {
                        "id": 105761,
                        "name": "Amphoe Phra Phrom",
                        "latitude": "8.32652000",
                        "longitude": "99.93240000"
                    },
                    {
                        "id": 105772,
                        "name": "Amphoe Phrom Khiri",
                        "latitude": "8.54242000",
                        "longitude": "99.79229000"
                    },
                    {
                        "id": 105812,
                        "name": "Amphoe Ron Phibun",
                        "latitude": "8.17997000",
                        "longitude": "99.89248000"
                    },
                    {
                        "id": 106231,
                        "name": "Amphoe Sichon",
                        "latitude": "8.94981000",
                        "longitude": "99.81322000"
                    },
                    {
                        "id": 106284,
                        "name": "Amphoe Tha Sala",
                        "latitude": "8.69367000",
                        "longitude": "99.88539000"
                    },
                    {
                        "id": 106296,
                        "name": "Amphoe Tham Phannara",
                        "latitude": "8.45822000",
                        "longitude": "99.37718000"
                    },
                    {
                        "id": 106317,
                        "name": "Amphoe Thung Song",
                        "latitude": "8.11757000",
                        "longitude": "99.66907000"
                    },
                    {
                        "id": 106320,
                        "name": "Amphoe Thung Yai",
                        "latitude": "8.28708000",
                        "longitude": "99.37196000"
                    },
                    {
                        "id": 106470,
                        "name": "Chawang",
                        "latitude": "8.42614000",
                        "longitude": "99.50472000"
                    },
                    {
                        "id": 106585,
                        "name": "Nakhon Si Thammarat",
                        "latitude": "8.43333000",
                        "longitude": "99.96667000"
                    },
                    {
                        "id": 106611,
                        "name": "Pak Phanang",
                        "latitude": "8.35109000",
                        "longitude": "100.20195000"
                    },
                    {
                        "id": 106669,
                        "name": "Ron Phibun",
                        "latitude": "8.17911000",
                        "longitude": "99.85425000"
                    },
                    {
                        "id": 106726,
                        "name": "Tham Phannara",
                        "latitude": "8.42045000",
                        "longitude": "99.39517000"
                    },
                    {
                        "id": 106733,
                        "name": "Thung Song",
                        "latitude": "8.16453000",
                        "longitude": "99.68039000"
                    }
                ]
            },
            {
                "id": 3530,
                "name": "Nan",
                "iso2": "55",
                "latitude": "45.52220800",
                "longitude": "-122.98632810",
                "type": "province",
                "cities": [
                    {
                        "id": 105200,
                        "name": "Amphoe Ban Luang",
                        "latitude": "18.88375000",
                        "longitude": "100.46014000"
                    },
                    {
                        "id": 105251,
                        "name": "Amphoe Bo Kluea",
                        "latitude": "19.08994000",
                        "longitude": "101.18952000"
                    },
                    {
                        "id": 105276,
                        "name": "Amphoe Chaloem Phra Kiat",
                        "latitude": "19.50618000",
                        "longitude": "101.14249000"
                    },
                    {
                        "id": 105297,
                        "name": "Amphoe Chiang Klang",
                        "latitude": "19.30637000",
                        "longitude": "100.87878000"
                    },
                    {
                        "id": 105500,
                        "name": "Amphoe Mae Charim",
                        "latitude": "18.71336000",
                        "longitude": "101.11011000"
                    },
                    {
                        "id": 105559,
                        "name": "Amphoe Mueang Nan",
                        "latitude": "18.89008000",
                        "longitude": "100.67472000"
                    },
                    {
                        "id": 105619,
                        "name": "Amphoe Na Muen",
                        "latitude": "18.12524000",
                        "longitude": "100.60270000"
                    },
                    {
                        "id": 105620,
                        "name": "Amphoe Na Noi",
                        "latitude": "18.30269000",
                        "longitude": "100.72393000"
                    },
                    {
                        "id": 105779,
                        "name": "Amphoe Phu Phiang",
                        "latitude": "18.78030000",
                        "longitude": "100.87497000"
                    },
                    {
                        "id": 105800,
                        "name": "Amphoe Pua",
                        "latitude": "19.16306000",
                        "longitude": "101.02796000"
                    },
                    {
                        "id": 106192,
                        "name": "Amphoe Santi Suk",
                        "latitude": "18.91190000",
                        "longitude": "101.00016000"
                    },
                    {
                        "id": 106246,
                        "name": "Amphoe Song Khwae",
                        "latitude": "19.40911000",
                        "longitude": "100.66174000"
                    },
                    {
                        "id": 106290,
                        "name": "Amphoe Tha Wang Pha",
                        "latitude": "19.13148000",
                        "longitude": "100.76117000"
                    },
                    {
                        "id": 106311,
                        "name": "Amphoe Thung Chang",
                        "latitude": "19.46342000",
                        "longitude": "100.91937000"
                    },
                    {
                        "id": 106366,
                        "name": "Amphoe Wiang Sa",
                        "latitude": "18.55088000",
                        "longitude": "100.72754000"
                    },
                    {
                        "id": 106473,
                        "name": "Chiang Klang",
                        "latitude": "19.29378000",
                        "longitude": "100.86169000"
                    },
                    {
                        "id": 106588,
                        "name": "Nan",
                        "latitude": "18.78378000",
                        "longitude": "100.77899000"
                    }
                ]
            },
            {
                "id": 3553,
                "name": "Narathiwat",
                "iso2": "96",
                "latitude": "6.42546070",
                "longitude": "101.82531430",
                "type": "province",
                "cities": [
                    {
                        "id": 105185,
                        "name": "Amphoe Ba Cho",
                        "latitude": "6.54591000",
                        "longitude": "101.64923000"
                    },
                    {
                        "id": 105283,
                        "name": "Amphoe Chanae",
                        "latitude": "6.04591000",
                        "longitude": "101.61765000"
                    },
                    {
                        "id": 105301,
                        "name": "Amphoe Cho-airong",
                        "latitude": "6.23011000",
                        "longitude": "101.84721000"
                    },
                    {
                        "id": 105560,
                        "name": "Amphoe Mueang Narathiwat",
                        "latitude": "6.39391000",
                        "longitude": "101.81316000"
                    },
                    {
                        "id": 105802,
                        "name": "Amphoe Ra-ngae",
                        "latitude": "6.25504000",
                        "longitude": "101.70496000"
                    },
                    {
                        "id": 105815,
                        "name": "Amphoe Rueso",
                        "latitude": "6.37450000",
                        "longitude": "101.51491000"
                    },
                    {
                        "id": 106222,
                        "name": "Amphoe Si Sakhon",
                        "latitude": "6.19360000",
                        "longitude": "101.51257000"
                    },
                    {
                        "id": 106251,
                        "name": "Amphoe Su-ngai Kolok",
                        "latitude": "6.07674000",
                        "longitude": "101.99818000"
                    },
                    {
                        "id": 106252,
                        "name": "Amphoe Su-ngai Padi",
                        "latitude": "6.10425000",
                        "longitude": "101.89333000"
                    },
                    {
                        "id": 106255,
                        "name": "Amphoe Sukhirin",
                        "latitude": "5.91513000",
                        "longitude": "101.73811000"
                    },
                    {
                        "id": 106261,
                        "name": "Amphoe Tak Bai",
                        "latitude": "6.23748000",
                        "longitude": "102.00238000"
                    },
                    {
                        "id": 106330,
                        "name": "Amphoe Waeng",
                        "latitude": "5.90042000",
                        "longitude": "101.86195000"
                    },
                    {
                        "id": 106379,
                        "name": "Amphoe Yi-ngo",
                        "latitude": "6.41655000",
                        "longitude": "101.70035000"
                    },
                    {
                        "id": 106414,
                        "name": "Ban Su-ngai Pa Di",
                        "latitude": "6.07239000",
                        "longitude": "101.87172000"
                    },
                    {
                        "id": 106590,
                        "name": "Narathiwat",
                        "latitude": "6.42639000",
                        "longitude": "101.82308000"
                    },
                    {
                        "id": 106660,
                        "name": "Ra-ngae",
                        "latitude": "6.29678000",
                        "longitude": "101.72844000"
                    },
                    {
                        "id": 106705,
                        "name": "Su-ngai Kolok",
                        "latitude": "6.02977000",
                        "longitude": "101.96586000"
                    },
                    {
                        "id": 106714,
                        "name": "Tak Bai",
                        "latitude": "6.25947000",
                        "longitude": "102.05461000"
                    }
                ]
            },
            {
                "id": 3480,
                "name": "Nong Bua Lam Phu",
                "iso2": "39",
                "latitude": "17.22182470",
                "longitude": "102.42603680",
                "type": "province",
                "cities": [
                    {
                        "id": 105561,
                        "name": "Amphoe Mueang Nong Bua Lamphu",
                        "latitude": "17.15818000",
                        "longitude": "102.39860000"
                    },
                    {
                        "id": 105616,
                        "name": "Amphoe Na Klang",
                        "latitude": "17.32466000",
                        "longitude": "102.21456000"
                    },
                    {
                        "id": 105626,
                        "name": "Amphoe Na Wang",
                        "latitude": "17.34290000",
                        "longitude": "102.07157000"
                    },
                    {
                        "id": 105653,
                        "name": "Amphoe Non Sang",
                        "latitude": "16.90220000",
                        "longitude": "102.53084000"
                    },
                    {
                        "id": 106210,
                        "name": "Amphoe Si Bun Rueang",
                        "latitude": "16.99775000",
                        "longitude": "102.22528000"
                    },
                    {
                        "id": 106258,
                        "name": "Amphoe Suwannakhuha",
                        "latitude": "17.54605000",
                        "longitude": "102.24852000"
                    },
                    {
                        "id": 106575,
                        "name": "Na Klang",
                        "latitude": "17.30720000",
                        "longitude": "102.18886000"
                    },
                    {
                        "id": 106591,
                        "name": "Non Sang",
                        "latitude": "16.86870000",
                        "longitude": "102.56642000"
                    },
                    {
                        "id": 106595,
                        "name": "Nong Bua Lamphu",
                        "latitude": "17.20406000",
                        "longitude": "102.44068000"
                    },
                    {
                        "id": 106697,
                        "name": "Si Bun Rueang",
                        "latitude": "16.96705000",
                        "longitude": "102.27607000"
                    }
                ]
            },
            {
                "id": 3484,
                "name": "Nong Khai",
                "iso2": "43",
                "latitude": "17.87828030",
                "longitude": "102.74126380",
                "type": "province",
                "cities": [
                    {
                        "id": 105341,
                        "name": "Amphoe Fao Rai",
                        "latitude": "18.00275000",
                        "longitude": "103.29640000"
                    },
                    {
                        "id": 105562,
                        "name": "Amphoe Mueang Nong Khai",
                        "latitude": "17.84661000",
                        "longitude": "102.78911000"
                    },
                    {
                        "id": 105748,
                        "name": "Amphoe Pho Tak",
                        "latitude": "17.88819000",
                        "longitude": "102.43023000"
                    },
                    {
                        "id": 105757,
                        "name": "Amphoe Phonphisai",
                        "latitude": "17.95443000",
                        "longitude": "103.12279000"
                    },
                    {
                        "id": 105809,
                        "name": "Amphoe Rattanawapi",
                        "latitude": "18.19255000",
                        "longitude": "103.23760000"
                    },
                    {
                        "id": 105817,
                        "name": "Amphoe Sa Khrai",
                        "latitude": "17.65985000",
                        "longitude": "102.70847000"
                    },
                    {
                        "id": 106189,
                        "name": "Amphoe Sangkhom",
                        "latitude": "18.05392000",
                        "longitude": "102.22677000"
                    },
                    {
                        "id": 106211,
                        "name": "Amphoe Si Chiang Mai",
                        "latitude": "17.93574000",
                        "longitude": "102.50306000"
                    },
                    {
                        "id": 106270,
                        "name": "Amphoe Tha Bo",
                        "latitude": "17.79499000",
                        "longitude": "102.56608000"
                    },
                    {
                        "id": 106600,
                        "name": "Nong Khai",
                        "latitude": "17.87847000",
                        "longitude": "102.74200000"
                    },
                    {
                        "id": 106640,
                        "name": "Phon Charoen",
                        "latitude": "18.03333000",
                        "longitude": "103.16667000"
                    },
                    {
                        "id": 106686,
                        "name": "Sangkhom",
                        "latitude": "18.06389000",
                        "longitude": "102.27364000"
                    },
                    {
                        "id": 106698,
                        "name": "Si Chiang Mai",
                        "latitude": "17.95639000",
                        "longitude": "102.58667000"
                    },
                    {
                        "id": 106718,
                        "name": "Tha Bo",
                        "latitude": "17.85003000",
                        "longitude": "102.58139000"
                    }
                ]
            },
            {
                "id": 3495,
                "name": "Nonthaburi",
                "iso2": "12",
                "latitude": "13.85910840",
                "longitude": "100.52165080",
                "type": "province",
                "cities": [
                    {
                        "id": 105223,
                        "name": "Amphoe Bang Bua Thong",
                        "latitude": "13.92641000",
                        "longitude": "100.39360000"
                    },
                    {
                        "id": 105230,
                        "name": "Amphoe Bang Kruai",
                        "latitude": "13.80249000",
                        "longitude": "100.41525000"
                    },
                    {
                        "id": 105246,
                        "name": "Amphoe Bang Yai",
                        "latitude": "13.85385000",
                        "longitude": "100.37318000"
                    },
                    {
                        "id": 105563,
                        "name": "Amphoe Mueang Nonthaburi",
                        "latitude": "13.85581000",
                        "longitude": "100.49264000"
                    },
                    {
                        "id": 105703,
                        "name": "Amphoe Pak Kret",
                        "latitude": "13.91626000",
                        "longitude": "100.50397000"
                    },
                    {
                        "id": 105824,
                        "name": "Amphoe Sai Noi",
                        "latitude": "14.00627000",
                        "longitude": "100.31072000"
                    },
                    {
                        "id": 106423,
                        "name": "Bang Bua Thong",
                        "latitude": "13.91783000",
                        "longitude": "100.42403000"
                    },
                    {
                        "id": 106431,
                        "name": "Bang Kruai",
                        "latitude": "13.80500000",
                        "longitude": "100.47283000"
                    },
                    {
                        "id": 106447,
                        "name": "Bang Yai",
                        "latitude": "13.84341000",
                        "longitude": "100.36251000"
                    },
                    {
                        "id": 106573,
                        "name": "Mueang Nonthaburi",
                        "latitude": "13.86075000",
                        "longitude": "100.51477000"
                    },
                    {
                        "id": 106610,
                        "name": "Pak Kret",
                        "latitude": "13.91301000",
                        "longitude": "100.49883000"
                    }
                ]
            },
            {
                "id": 3500,
                "name": "Pathum Thani",
                "iso2": "13",
                "latitude": "14.02083910",
                "longitude": "100.52502760",
                "type": "province",
                "cities": [
                    {
                        "id": 105410,
                        "name": "Amphoe Khlong Luang",
                        "latitude": "14.09323000",
                        "longitude": "100.68106000"
                    },
                    {
                        "id": 105473,
                        "name": "Amphoe Lam Luk Ka",
                        "latitude": "13.97744000",
                        "longitude": "100.79244000"
                    },
                    {
                        "id": 105488,
                        "name": "Amphoe Lat Lum Kaeo",
                        "latitude": "14.04459000",
                        "longitude": "100.40948000"
                    },
                    {
                        "id": 105565,
                        "name": "Amphoe Mueang Pathum Thani",
                        "latitude": "13.99105000",
                        "longitude": "100.53554000"
                    },
                    {
                        "id": 105682,
                        "name": "Amphoe Nong Suea",
                        "latitude": "14.16030000",
                        "longitude": "100.83929000"
                    },
                    {
                        "id": 106298,
                        "name": "Amphoe Thanyaburi",
                        "latitude": "14.02852000",
                        "longitude": "100.76291000"
                    },
                    {
                        "id": 106397,
                        "name": "Ban Lam Luk Ka",
                        "latitude": "13.97738000",
                        "longitude": "100.77776000"
                    },
                    {
                        "id": 106524,
                        "name": "Khlong Luang",
                        "latitude": "14.06467000",
                        "longitude": "100.64578000"
                    },
                    {
                        "id": 106614,
                        "name": "Pathum Thani",
                        "latitude": "14.01346000",
                        "longitude": "100.53049000"
                    }
                ]
            },
            {
                "id": 3540,
                "name": "Pattani",
                "iso2": "94",
                "latitude": "6.76183080",
                "longitude": "101.32325490",
                "type": "province",
                "cities": [
                    {
                        "id": 105376,
                        "name": "Amphoe Kapho",
                        "latitude": "6.60264000",
                        "longitude": "101.54327000"
                    },
                    {
                        "id": 105416,
                        "name": "Amphoe Khok Pho",
                        "latitude": "6.70858000",
                        "longitude": "101.11693000"
                    },
                    {
                        "id": 105503,
                        "name": "Amphoe Mae Lan",
                        "latitude": "6.66833000",
                        "longitude": "101.23149000"
                    },
                    {
                        "id": 105522,
                        "name": "Amphoe Mai Kaen",
                        "latitude": "6.61603000",
                        "longitude": "101.67864000"
                    },
                    {
                        "id": 105527,
                        "name": "Amphoe Mayo",
                        "latitude": "6.70764000",
                        "longitude": "101.40359000"
                    },
                    {
                        "id": 105566,
                        "name": "Amphoe Mueang Pattani",
                        "latitude": "6.85581000",
                        "longitude": "101.26761000"
                    },
                    {
                        "id": 105661,
                        "name": "Amphoe Nong Chik",
                        "latitude": "6.80011000",
                        "longitude": "101.17057000"
                    },
                    {
                        "id": 105710,
                        "name": "Amphoe Panare",
                        "latitude": "6.81211000",
                        "longitude": "101.51247000"
                    },
                    {
                        "id": 105821,
                        "name": "Amphoe Sai Buri",
                        "latitude": "6.70000000",
                        "longitude": "101.58333000"
                    },
                    {
                        "id": 106321,
                        "name": "Amphoe Thung Yang Daeng",
                        "latitude": "6.64160000",
                        "longitude": "101.44652000"
                    },
                    {
                        "id": 106377,
                        "name": "Amphoe Yarang",
                        "latitude": "6.69240000",
                        "longitude": "101.31408000"
                    },
                    {
                        "id": 106378,
                        "name": "Amphoe Yaring",
                        "latitude": "6.83507000",
                        "longitude": "101.39073000"
                    },
                    {
                        "id": 106596,
                        "name": "Nong Chik",
                        "latitude": "6.84356000",
                        "longitude": "101.17803000"
                    },
                    {
                        "id": 106616,
                        "name": "Pattani",
                        "latitude": "6.86814000",
                        "longitude": "101.25009000"
                    },
                    {
                        "id": 106673,
                        "name": "Sai Buri",
                        "latitude": "6.70131000",
                        "longitude": "101.61675000"
                    },
                    {
                        "id": 106758,
                        "name": "Yaring",
                        "latitude": "6.86617000",
                        "longitude": "101.36894000"
                    }
                ]
            },
            {
                "id": 3507,
                "name": "Pattaya",
                "iso2": "S",
                "latitude": "12.92355570",
                "longitude": "100.88245510",
                "type": "metropolitan administration",
                "cities": []
            },
            {
                "id": 3549,
                "name": "Phangnga",
                "iso2": "82",
                "latitude": "8.45014140",
                "longitude": "98.52553170",
                "type": "province",
                "cities": [
                    {
                        "id": 105378,
                        "name": "Amphoe Kapong",
                        "latitude": "8.74139000",
                        "longitude": "98.47542000"
                    },
                    {
                        "id": 105435,
                        "name": "Amphoe Khura Buri",
                        "latitude": "9.18972000",
                        "longitude": "98.40806000"
                    },
                    {
                        "id": 105446,
                        "name": "Amphoe Ko Yao",
                        "latitude": "8.06549000",
                        "longitude": "98.57851000"
                    },
                    {
                        "id": 105567,
                        "name": "Amphoe Mueang Phangnga",
                        "latitude": "8.49350000",
                        "longitude": "98.50775000"
                    },
                    {
                        "id": 106264,
                        "name": "Amphoe Takua Pa",
                        "latitude": "8.86883000",
                        "longitude": "98.33892000"
                    },
                    {
                        "id": 106265,
                        "name": "Amphoe Takua Thung",
                        "latitude": "8.28433000",
                        "longitude": "98.38950000"
                    },
                    {
                        "id": 106294,
                        "name": "Amphoe Thai Mueang",
                        "latitude": "8.48995000",
                        "longitude": "98.31292000"
                    },
                    {
                        "id": 106300,
                        "name": "Amphoe Thap Put",
                        "latitude": "8.53768000",
                        "longitude": "98.63208000"
                    },
                    {
                        "id": 106383,
                        "name": "Ban Ao Nang",
                        "latitude": "8.04580000",
                        "longitude": "98.81035000"
                    },
                    {
                        "id": 106393,
                        "name": "Ban Khao Lak",
                        "latitude": "8.61501000",
                        "longitude": "98.23994000"
                    },
                    {
                        "id": 106409,
                        "name": "Ban Phru Nai",
                        "latitude": "7.95458000",
                        "longitude": "98.58989000"
                    },
                    {
                        "id": 106622,
                        "name": "Phang Nga",
                        "latitude": "8.45091000",
                        "longitude": "98.52985000"
                    }
                ]
            },
            {
                "id": 3488,
                "name": "Phatthalung",
                "iso2": "93",
                "latitude": "7.61668230",
                "longitude": "100.07402310",
                "type": "province",
                "cities": [
                    {
                        "id": 105224,
                        "name": "Amphoe Bang Kaeo",
                        "latitude": "7.41775000",
                        "longitude": "100.17164000"
                    },
                    {
                        "id": 105391,
                        "name": "Amphoe Khao Chaison",
                        "latitude": "7.46305000",
                        "longitude": "100.09055000"
                    },
                    {
                        "id": 105428,
                        "name": "Amphoe Khuan Khanun",
                        "latitude": "7.76438000",
                        "longitude": "100.04349000"
                    },
                    {
                        "id": 105448,
                        "name": "Amphoe Kong Ra",
                        "latitude": "7.41674000",
                        "longitude": "99.95719000"
                    },
                    {
                        "id": 105568,
                        "name": "Amphoe Mueang Phatthalung",
                        "latitude": "7.60250000",
                        "longitude": "100.07425000"
                    },
                    {
                        "id": 105692,
                        "name": "Amphoe Pa Bon",
                        "latitude": "7.21994000",
                        "longitude": "100.13078000"
                    },
                    {
                        "id": 105696,
                        "name": "Amphoe Pa Phayom",
                        "latitude": "7.83154000",
                        "longitude": "99.87448000"
                    },
                    {
                        "id": 105705,
                        "name": "Amphoe Pak Phayun",
                        "latitude": "7.29622000",
                        "longitude": "100.29542000"
                    },
                    {
                        "id": 106209,
                        "name": "Amphoe Si Banphot",
                        "latitude": "7.69259000",
                        "longitude": "99.87322000"
                    },
                    {
                        "id": 106250,
                        "name": "Amphoe Srinagarindra",
                        "latitude": "7.57574000",
                        "longitude": "99.91053000"
                    },
                    {
                        "id": 106266,
                        "name": "Amphoe Tamot",
                        "latitude": "7.28783000",
                        "longitude": "100.04358000"
                    },
                    {
                        "id": 106626,
                        "name": "Phatthalung",
                        "latitude": "7.61786000",
                        "longitude": "100.07792000"
                    }
                ]
            },
            {
                "id": 3538,
                "name": "Phayao",
                "iso2": "56",
                "latitude": "19.21543670",
                "longitude": "100.20236920",
                "type": "province",
                "cities": [
                    {
                        "id": 105293,
                        "name": "Amphoe Chiang Kham",
                        "latitude": "19.47061000",
                        "longitude": "100.33868000"
                    },
                    {
                        "id": 105298,
                        "name": "Amphoe Chiang Muan",
                        "latitude": "18.90385000",
                        "longitude": "100.31792000"
                    },
                    {
                        "id": 105315,
                        "name": "Amphoe Chun",
                        "latitude": "19.36803000",
                        "longitude": "100.14492000"
                    },
                    {
                        "id": 105328,
                        "name": "Amphoe Dok Kham Tai",
                        "latitude": "19.10813000",
                        "longitude": "100.05657000"
                    },
                    {
                        "id": 105498,
                        "name": "Amphoe Mae Chai",
                        "latitude": "19.37925000",
                        "longitude": "99.80141000"
                    },
                    {
                        "id": 105569,
                        "name": "Amphoe Mueang Phayao",
                        "latitude": "19.14857000",
                        "longitude": "99.87325000"
                    },
                    {
                        "id": 105774,
                        "name": "Amphoe Phu Kam Yao",
                        "latitude": "19.31170000",
                        "longitude": "99.96614000"
                    },
                    {
                        "id": 105781,
                        "name": "Amphoe Phu Sang",
                        "latitude": "19.62372000",
                        "longitude": "100.37246000"
                    },
                    {
                        "id": 105791,
                        "name": "Amphoe Pong",
                        "latitude": "19.18500000",
                        "longitude": "100.38780000"
                    },
                    {
                        "id": 106471,
                        "name": "Chiang Kham",
                        "latitude": "19.52331000",
                        "longitude": "100.30000000"
                    },
                    {
                        "id": 106491,
                        "name": "Dok Kham Tai",
                        "latitude": "19.16242000",
                        "longitude": "99.99342000"
                    },
                    {
                        "id": 106561,
                        "name": "Mae Chai",
                        "latitude": "19.34597000",
                        "longitude": "99.81400000"
                    },
                    {
                        "id": 106629,
                        "name": "Phayao",
                        "latitude": "19.19203000",
                        "longitude": "99.87883000"
                    },
                    {
                        "id": 106652,
                        "name": "Pong",
                        "latitude": "19.14931000",
                        "longitude": "100.27522000"
                    }
                ]
            },
            {
                "id": 3515,
                "name": "Phetchabun",
                "iso2": "67",
                "latitude": "16.30166900",
                "longitude": "101.11928040",
                "type": "province",
                "cities": [
                    {
                        "id": 105262,
                        "name": "Amphoe Bueng Sam Phan",
                        "latitude": "15.81650000",
                        "longitude": "101.00399000"
                    },
                    {
                        "id": 105306,
                        "name": "Amphoe Chon Daen",
                        "latitude": "16.10735000",
                        "longitude": "100.83572000"
                    },
                    {
                        "id": 105395,
                        "name": "Amphoe Khao Kho",
                        "latitude": "16.66313000",
                        "longitude": "100.99450000"
                    },
                    {
                        "id": 105492,
                        "name": "Amphoe Lom Kao",
                        "latitude": "16.97209000",
                        "longitude": "101.26185000"
                    },
                    {
                        "id": 105493,
                        "name": "Amphoe Lom Sak",
                        "latitude": "16.72837000",
                        "longitude": "101.31139000"
                    },
                    {
                        "id": 105570,
                        "name": "Amphoe Mueang Phetchabun",
                        "latitude": "16.38215000",
                        "longitude": "101.17652000"
                    },
                    {
                        "id": 105636,
                        "name": "Amphoe Nam Nao",
                        "latitude": "16.84489000",
                        "longitude": "101.60080000"
                    },
                    {
                        "id": 105675,
                        "name": "Amphoe Nong Phai",
                        "latitude": "16.01162000",
                        "longitude": "101.15042000"
                    },
                    {
                        "id": 106229,
                        "name": "Amphoe Si Thep",
                        "latitude": "15.44253000",
                        "longitude": "101.14767000"
                    },
                    {
                        "id": 106343,
                        "name": "Amphoe Wang Pong",
                        "latitude": "16.35049000",
                        "longitude": "100.80772000"
                    },
                    {
                        "id": 106368,
                        "name": "Amphoe Wichian Buri",
                        "latitude": "15.65000000",
                        "longitude": "101.10000000"
                    },
                    {
                        "id": 106482,
                        "name": "Chon Daen",
                        "latitude": "16.18953000",
                        "longitude": "100.85958000"
                    },
                    {
                        "id": 106558,
                        "name": "Lom Sak",
                        "latitude": "16.77983000",
                        "longitude": "101.24225000"
                    },
                    {
                        "id": 106603,
                        "name": "Nong Phai",
                        "latitude": "15.99025000",
                        "longitude": "101.06183000"
                    },
                    {
                        "id": 106631,
                        "name": "Phetchabun",
                        "latitude": "16.41904000",
                        "longitude": "101.16056000"
                    },
                    {
                        "id": 106752,
                        "name": "Wichian Buri",
                        "latitude": "15.65778000",
                        "longitude": "101.10603000"
                    }
                ]
            },
            {
                "id": 3532,
                "name": "Phetchaburi",
                "iso2": "76",
                "latitude": "12.96492150",
                "longitude": "99.64258830",
                "type": "province",
                "cities": [
                    {
                        "id": 105198,
                        "name": "Amphoe Ban Laem",
                        "latitude": "13.16968000",
                        "longitude": "99.98771000"
                    },
                    {
                        "id": 105199,
                        "name": "Amphoe Ban Lat",
                        "latitude": "13.04533000",
                        "longitude": "99.83788000"
                    },
                    {
                        "id": 105266,
                        "name": "Amphoe Cha-am",
                        "latitude": "12.75374000",
                        "longitude": "99.89828000"
                    },
                    {
                        "id": 105366,
                        "name": "Amphoe Kaeng Krachan",
                        "latitude": "12.85919000",
                        "longitude": "99.46339000"
                    },
                    {
                        "id": 105400,
                        "name": "Amphoe Khao Yoi",
                        "latitude": "13.24240000",
                        "longitude": "99.80753000"
                    },
                    {
                        "id": 105571,
                        "name": "Amphoe Mueang Phetchaburi",
                        "latitude": "13.08173000",
                        "longitude": "99.96721000"
                    },
                    {
                        "id": 105685,
                        "name": "Amphoe Nong Ya Plong",
                        "latitude": "13.12590000",
                        "longitude": "99.46880000"
                    },
                    {
                        "id": 106292,
                        "name": "Amphoe Tha Yang",
                        "latitude": "12.81743000",
                        "longitude": "99.78738000"
                    },
                    {
                        "id": 106459,
                        "name": "Cha-am",
                        "latitude": "12.80000000",
                        "longitude": "99.96667000"
                    },
                    {
                        "id": 106521,
                        "name": "Khao Yoi",
                        "latitude": "13.24025000",
                        "longitude": "99.82428000"
                    },
                    {
                        "id": 106632,
                        "name": "Phetchaburi",
                        "latitude": "13.11189000",
                        "longitude": "99.94467000"
                    },
                    {
                        "id": 106725,
                        "name": "Tha Yang",
                        "latitude": "12.95772000",
                        "longitude": "99.90555000"
                    }
                ]
            },
            {
                "id": 3514,
                "name": "Phichit",
                "iso2": "66",
                "latitude": "16.27408760",
                "longitude": "100.33469910",
                "type": "province",
                "cities": [
                    {
                        "id": 105232,
                        "name": "Amphoe Bang Mun Nak",
                        "latitude": "16.02656000",
                        "longitude": "100.43194000"
                    },
                    {
                        "id": 105261,
                        "name": "Amphoe Bueng Na Rang",
                        "latitude": "16.18642000",
                        "longitude": "100.14293000"
                    },
                    {
                        "id": 105336,
                        "name": "Amphoe Dong Charoen",
                        "latitude": "15.99848000",
                        "longitude": "100.59572000"
                    },
                    {
                        "id": 105572,
                        "name": "Amphoe Mueang Phichit",
                        "latitude": "16.40986000",
                        "longitude": "100.34578000"
                    },
                    {
                        "id": 105745,
                        "name": "Amphoe Pho Prathap Chang",
                        "latitude": "16.31294000",
                        "longitude": "100.19897000"
                    },
                    {
                        "id": 105749,
                        "name": "Amphoe Pho Thale",
                        "latitude": "16.05885000",
                        "longitude": "100.24579000"
                    },
                    {
                        "id": 105827,
                        "name": "Amphoe Sak Lek",
                        "latitude": "16.50717000",
                        "longitude": "100.52350000"
                    },
                    {
                        "id": 106269,
                        "name": "Amphoe Taphan Hin",
                        "latitude": "16.21103000",
                        "longitude": "100.41739000"
                    },
                    {
                        "id": 106299,
                        "name": "Amphoe Thap Khlo",
                        "latitude": "16.19167000",
                        "longitude": "100.60082000"
                    },
                    {
                        "id": 106329,
                        "name": "Amphoe Wachira Barami",
                        "latitude": "16.51667000",
                        "longitude": "100.11667000"
                    },
                    {
                        "id": 106344,
                        "name": "Amphoe Wang Sai Phun",
                        "latitude": "16.37922000",
                        "longitude": "100.53668000"
                    },
                    {
                        "id": 106435,
                        "name": "Bang Mun Nak",
                        "latitude": "16.02781000",
                        "longitude": "100.37917000"
                    },
                    {
                        "id": 106457,
                        "name": "Bueng Na Rang",
                        "latitude": "16.17120000",
                        "longitude": "100.12531000"
                    },
                    {
                        "id": 106634,
                        "name": "Phichit",
                        "latitude": "16.44184000",
                        "longitude": "100.34879000"
                    },
                    {
                        "id": 106717,
                        "name": "Taphan Hin",
                        "latitude": "16.22095000",
                        "longitude": "100.41978000"
                    },
                    {
                        "id": 106727,
                        "name": "Thap Khlo",
                        "latitude": "16.16003000",
                        "longitude": "100.59656000"
                    },
                    {
                        "id": 106746,
                        "name": "Wang Sai Phun",
                        "latitude": "16.38850000",
                        "longitude": "100.53801000"
                    }
                ]
            },
            {
                "id": 3506,
                "name": "Phitsanulok",
                "iso2": "65",
                "latitude": "16.82112380",
                "longitude": "100.26585160",
                "type": "province",
                "cities": [
                    {
                        "id": 105229,
                        "name": "Amphoe Bang Krathum",
                        "latitude": "16.59323000",
                        "longitude": "100.35042000"
                    },
                    {
                        "id": 105241,
                        "name": "Amphoe Bang Rakam",
                        "latitude": "16.71844000",
                        "longitude": "100.04217000"
                    },
                    {
                        "id": 105288,
                        "name": "Amphoe Chat Trakan",
                        "latitude": "17.39357000",
                        "longitude": "100.68460000"
                    },
                    {
                        "id": 105573,
                        "name": "Amphoe Mueang Phitsanulok",
                        "latitude": "16.84040000",
                        "longitude": "100.27298000"
                    },
                    {
                        "id": 105633,
                        "name": "Amphoe Nakhon Thai",
                        "latitude": "17.09426000",
                        "longitude": "100.86437000"
                    },
                    {
                        "id": 105647,
                        "name": "Amphoe Noen Maprang",
                        "latitude": "16.56400000",
                        "longitude": "100.70995000"
                    },
                    {
                        "id": 105773,
                        "name": "Amphoe Phrom Phiram",
                        "latitude": "17.06894000",
                        "longitude": "100.15350000"
                    },
                    {
                        "id": 106348,
                        "name": "Amphoe Wang Thong",
                        "latitude": "16.85000000",
                        "longitude": "100.58333000"
                    },
                    {
                        "id": 106355,
                        "name": "Amphoe Wat Bot",
                        "latitude": "17.16384000",
                        "longitude": "100.36298000"
                    },
                    {
                        "id": 106430,
                        "name": "Bang Krathum",
                        "latitude": "16.57831000",
                        "longitude": "100.30034000"
                    },
                    {
                        "id": 106444,
                        "name": "Bang Rakam",
                        "latitude": "16.75847000",
                        "longitude": "100.11742000"
                    },
                    {
                        "id": 106468,
                        "name": "Chat Trakan",
                        "latitude": "17.27606000",
                        "longitude": "100.60022000"
                    },
                    {
                        "id": 106586,
                        "name": "Nakhon Thai",
                        "latitude": "17.10056000",
                        "longitude": "100.83739000"
                    },
                    {
                        "id": 106636,
                        "name": "Phitsanulok",
                        "latitude": "16.82481000",
                        "longitude": "100.25858000"
                    }
                ]
            },
            {
                "id": 3494,
                "name": "Phra Nakhon Si Ayutthaya",
                "iso2": "14",
                "latitude": "14.36923250",
                "longitude": "100.58766340",
                "type": "province",
                "cities": [
                    {
                        "id": 105213,
                        "name": "Amphoe Ban Phraek",
                        "latitude": "14.64381000",
                        "longitude": "100.54883000"
                    },
                    {
                        "id": 105221,
                        "name": "Amphoe Bang Ban",
                        "latitude": "14.38333000",
                        "longitude": "100.46667000"
                    },
                    {
                        "id": 105234,
                        "name": "Amphoe Bang Pa-in",
                        "latitude": "14.23482000",
                        "longitude": "100.59410000"
                    },
                    {
                        "id": 105235,
                        "name": "Amphoe Bang Pahan",
                        "latitude": "14.47174000",
                        "longitude": "100.54731000"
                    },
                    {
                        "id": 105242,
                        "name": "Amphoe Bang Sai",
                        "latitude": "14.21043000",
                        "longitude": "100.49422000"
                    },
                    {
                        "id": 105487,
                        "name": "Amphoe Lat Bua Luang",
                        "latitude": "14.16810000",
                        "longitude": "100.34892000"
                    },
                    {
                        "id": 105521,
                        "name": "Amphoe Maha Rat",
                        "latitude": "14.57064000",
                        "longitude": "100.54089000"
                    },
                    {
                        "id": 105632,
                        "name": "Amphoe Nakhon Luang",
                        "latitude": "14.46703000",
                        "longitude": "100.62572000"
                    },
                    {
                        "id": 105717,
                        "name": "Amphoe Phachi",
                        "latitude": "14.43795000",
                        "longitude": "100.72780000"
                    },
                    {
                        "id": 105719,
                        "name": "Amphoe Phak Hai",
                        "latitude": "14.45073000",
                        "longitude": "100.33949000"
                    },
                    {
                        "id": 105760,
                        "name": "Amphoe Phra Nakhon Si Ayutthaya",
                        "latitude": "14.35172000",
                        "longitude": "100.56719000"
                    },
                    {
                        "id": 106207,
                        "name": "Amphoe Sena",
                        "latitude": "14.29605000",
                        "longitude": "100.37486000"
                    },
                    {
                        "id": 106282,
                        "name": "Amphoe Tha Ruea",
                        "latitude": "14.53587000",
                        "longitude": "100.71268000"
                    },
                    {
                        "id": 106327,
                        "name": "Amphoe Uthai",
                        "latitude": "14.35321000",
                        "longitude": "100.69643000"
                    },
                    {
                        "id": 106341,
                        "name": "Amphoe Wang Noi",
                        "latitude": "14.24348000",
                        "longitude": "100.72500000"
                    },
                    {
                        "id": 106384,
                        "name": "Ban Bang Kadi Pathum Thani",
                        "latitude": "13.99904000",
                        "longitude": "100.54962000"
                    },
                    {
                        "id": 106420,
                        "name": "Bang Ban",
                        "latitude": "14.37395000",
                        "longitude": "100.48528000"
                    },
                    {
                        "id": 106438,
                        "name": "Bang Pa-in",
                        "latitude": "14.22783000",
                        "longitude": "100.57589000"
                    },
                    {
                        "id": 106579,
                        "name": "Nakhon Luang",
                        "latitude": "14.46281000",
                        "longitude": "100.60832000"
                    },
                    {
                        "id": 106619,
                        "name": "Phak Hai",
                        "latitude": "14.45736000",
                        "longitude": "100.36989000"
                    },
                    {
                        "id": 106644,
                        "name": "Phra Nakhon Si Ayutthaya",
                        "latitude": "14.35167000",
                        "longitude": "100.57739000"
                    },
                    {
                        "id": 106724,
                        "name": "Tha Ruea",
                        "latitude": "14.56739000",
                        "longitude": "100.72598000"
                    },
                    {
                        "id": 106744,
                        "name": "Wang Noi",
                        "latitude": "14.22689000",
                        "longitude": "100.71550000"
                    }
                ]
            },
            {
                "id": 3528,
                "name": "Phrae",
                "iso2": "54",
                "latitude": "18.14457740",
                "longitude": "100.14028310",
                "type": "province",
                "cities": [
                    {
                        "id": 105321,
                        "name": "Amphoe Den Chai",
                        "latitude": "17.91667000",
                        "longitude": "100.03333000"
                    },
                    {
                        "id": 105494,
                        "name": "Amphoe Long",
                        "latitude": "18.14262000",
                        "longitude": "99.90901000"
                    },
                    {
                        "id": 105574,
                        "name": "Amphoe Mueang Phrae",
                        "latitude": "18.12258000",
                        "longitude": "100.25620000"
                    },
                    {
                        "id": 105673,
                        "name": "Amphoe Nong Muang Khai",
                        "latitude": "18.28845000",
                        "longitude": "100.15231000"
                    },
                    {
                        "id": 105814,
                        "name": "Amphoe Rong Kwang",
                        "latitude": "18.32614000",
                        "longitude": "100.39418000"
                    },
                    {
                        "id": 106244,
                        "name": "Amphoe Song",
                        "latitude": "18.57006000",
                        "longitude": "100.22911000"
                    },
                    {
                        "id": 106256,
                        "name": "Amphoe Sung Men",
                        "latitude": "18.03542000",
                        "longitude": "100.12538000"
                    },
                    {
                        "id": 106336,
                        "name": "Amphoe Wang Chin",
                        "latitude": "17.86667000",
                        "longitude": "99.64990000"
                    },
                    {
                        "id": 106487,
                        "name": "Den Chai",
                        "latitude": "17.98372000",
                        "longitude": "100.05217000"
                    },
                    {
                        "id": 106559,
                        "name": "Long",
                        "latitude": "18.07422000",
                        "longitude": "99.83073000"
                    },
                    {
                        "id": 106647,
                        "name": "Phrae",
                        "latitude": "18.14589000",
                        "longitude": "100.14103000"
                    },
                    {
                        "id": 106670,
                        "name": "Rong Kwang",
                        "latitude": "18.33903000",
                        "longitude": "100.31736000"
                    }
                ]
            },
            {
                "id": 3536,
                "name": "Phuket",
                "iso2": "83",
                "latitude": "7.88044790",
                "longitude": "98.39225040",
                "type": "province",
                "cities": [
                    {
                        "id": 105380,
                        "name": "Amphoe Kathu",
                        "latitude": "7.91456000",
                        "longitude": "98.33330000"
                    },
                    {
                        "id": 105575,
                        "name": "Amphoe Mueang Phuket",
                        "latitude": "7.85609000",
                        "longitude": "98.37183000"
                    },
                    {
                        "id": 106295,
                        "name": "Amphoe Thalang",
                        "latitude": "8.03407000",
                        "longitude": "98.33399000"
                    },
                    {
                        "id": 106386,
                        "name": "Ban Chalong",
                        "latitude": "7.84468000",
                        "longitude": "98.33897000"
                    },
                    {
                        "id": 106391,
                        "name": "Ban Karon",
                        "latitude": "7.84769000",
                        "longitude": "98.29850000"
                    },
                    {
                        "id": 106392,
                        "name": "Ban Kata",
                        "latitude": "7.82125000",
                        "longitude": "98.30703000"
                    },
                    {
                        "id": 106395,
                        "name": "Ban Ko Kaeo",
                        "latitude": "7.93599000",
                        "longitude": "98.39664000"
                    },
                    {
                        "id": 106399,
                        "name": "Ban Mai Khao",
                        "latitude": "8.12713000",
                        "longitude": "98.30738000"
                    },
                    {
                        "id": 106411,
                        "name": "Ban Ratsada",
                        "latitude": "7.90963000",
                        "longitude": "98.40248000"
                    },
                    {
                        "id": 106417,
                        "name": "Ban Talat Nua",
                        "latitude": "7.88489000",
                        "longitude": "98.38557000"
                    },
                    {
                        "id": 106418,
                        "name": "Ban Talat Yai",
                        "latitude": "7.88481000",
                        "longitude": "98.40008000"
                    },
                    {
                        "id": 106516,
                        "name": "Kathu",
                        "latitude": "7.91779000",
                        "longitude": "98.33322000"
                    },
                    {
                        "id": 106578,
                        "name": "Nai Harn",
                        "latitude": "7.77859000",
                        "longitude": "98.30661000"
                    },
                    {
                        "id": 106615,
                        "name": "Patong",
                        "latitude": "7.89607000",
                        "longitude": "98.29661000"
                    },
                    {
                        "id": 106650,
                        "name": "Phuket",
                        "latitude": "7.89059000",
                        "longitude": "98.39810000"
                    },
                    {
                        "id": 106666,
                        "name": "Rawai",
                        "latitude": "7.77965000",
                        "longitude": "98.32532000"
                    },
                    {
                        "id": 106753,
                        "name": "Wichit",
                        "latitude": "7.88940000",
                        "longitude": "98.38523000"
                    }
                ]
            },
            {
                "id": 3542,
                "name": "Prachin Buri",
                "iso2": "25",
                "latitude": "14.04206990",
                "longitude": "101.66008740",
                "type": "province",
                "cities": [
                    {
                        "id": 105217,
                        "name": "Amphoe Ban Sang",
                        "latitude": "13.95005000",
                        "longitude": "101.25063000"
                    },
                    {
                        "id": 105362,
                        "name": "Amphoe Kabin Buri",
                        "latitude": "13.90000000",
                        "longitude": "101.80000000"
                    },
                    {
                        "id": 105576,
                        "name": "Amphoe Mueang Prachin Buri",
                        "latitude": "14.09335000",
                        "longitude": "101.39776000"
                    },
                    {
                        "id": 105610,
                        "name": "Amphoe Na Di",
                        "latitude": "14.19253000",
                        "longitude": "101.84557000"
                    },
                    {
                        "id": 105794,
                        "name": "Amphoe Prachantakham",
                        "latitude": "14.22813000",
                        "longitude": "101.57440000"
                    },
                    {
                        "id": 106214,
                        "name": "Amphoe Si Maha Phot",
                        "latitude": "13.89041000",
                        "longitude": "101.54181000"
                    },
                    {
                        "id": 106215,
                        "name": "Amphoe Si Mahosot",
                        "latitude": "13.87669000",
                        "longitude": "101.42499000"
                    },
                    {
                        "id": 106504,
                        "name": "Kabin Buri",
                        "latitude": "13.95114000",
                        "longitude": "101.71769000"
                    },
                    {
                        "id": 106655,
                        "name": "Prachin Buri",
                        "latitude": "14.04992000",
                        "longitude": "101.36864000"
                    }
                ]
            },
            {
                "id": 3508,
                "name": "Prachuap Khiri Khan",
                "iso2": "77",
                "latitude": "11.79383890",
                "longitude": "99.79575640",
                "type": "province",
                "cities": [
                    {
                        "id": 105244,
                        "name": "Amphoe Bang Saphan",
                        "latitude": "11.29402000",
                        "longitude": "99.44406000"
                    },
                    {
                        "id": 105245,
                        "name": "Amphoe Bang Saphan Noi",
                        "latitude": "11.07057000",
                        "longitude": "99.34105000"
                    },
                    {
                        "id": 105349,
                        "name": "Amphoe Hua Hin",
                        "latitude": "12.53522000",
                        "longitude": "99.70366000"
                    },
                    {
                        "id": 105460,
                        "name": "Amphoe Kui Buri",
                        "latitude": "12.11311000",
                        "longitude": "99.75462000"
                    },
                    {
                        "id": 105577,
                        "name": "Amphoe Mueang Prachuap Khiri Khan",
                        "latitude": "11.87144000",
                        "longitude": "99.73563000"
                    },
                    {
                        "id": 105796,
                        "name": "Amphoe Pran Buri",
                        "latitude": "12.39040000",
                        "longitude": "99.69690000"
                    },
                    {
                        "id": 106177,
                        "name": "Amphoe Sam Roi Yot",
                        "latitude": "12.25586000",
                        "longitude": "99.74010000"
                    },
                    {
                        "id": 106301,
                        "name": "Amphoe Thap Sakae",
                        "latitude": "11.54787000",
                        "longitude": "99.57159000"
                    },
                    {
                        "id": 106445,
                        "name": "Bang Saphan",
                        "latitude": "11.21259000",
                        "longitude": "99.51167000"
                    },
                    {
                        "id": 106498,
                        "name": "Hua Hin",
                        "latitude": "12.57065000",
                        "longitude": "99.95876000"
                    },
                    {
                        "id": 106544,
                        "name": "Kui Buri",
                        "latitude": "12.08283000",
                        "longitude": "99.85431000"
                    },
                    {
                        "id": 106656,
                        "name": "Prachuap Khiri Khan",
                        "latitude": "11.82098000",
                        "longitude": "99.78410000"
                    },
                    {
                        "id": 106658,
                        "name": "Pran Buri",
                        "latitude": "12.38487000",
                        "longitude": "99.90157000"
                    },
                    {
                        "id": 106678,
                        "name": "Sam Roi Yot",
                        "latitude": "12.27081000",
                        "longitude": "99.87203000"
                    }
                ]
            },
            {
                "id": 3479,
                "name": "Ranong",
                "iso2": "85",
                "latitude": "9.95287020",
                "longitude": "98.60846410",
                "type": "province",
                "cities": [
                    {
                        "id": 105377,
                        "name": "Amphoe Kapoe",
                        "latitude": "9.53028000",
                        "longitude": "98.62369000"
                    },
                    {
                        "id": 105451,
                        "name": "Amphoe Kra Buri",
                        "latitude": "10.45895000",
                        "longitude": "98.84373000"
                    },
                    {
                        "id": 105469,
                        "name": "Amphoe La-un",
                        "latitude": "10.09691000",
                        "longitude": "98.78498000"
                    },
                    {
                        "id": 105578,
                        "name": "Amphoe Mueang Ranong",
                        "latitude": "9.86238000",
                        "longitude": "98.62229000"
                    },
                    {
                        "id": 106254,
                        "name": "Amphoe Suk Samran",
                        "latitude": "9.41570000",
                        "longitude": "98.49117000"
                    },
                    {
                        "id": 106661,
                        "name": "Ranong",
                        "latitude": "9.96583000",
                        "longitude": "98.63476000"
                    }
                ]
            },
            {
                "id": 3499,
                "name": "Ratchaburi",
                "iso2": "70",
                "latitude": "13.52828930",
                "longitude": "99.81342110",
                "type": "province",
                "cities": [
                    {
                        "id": 105194,
                        "name": "Amphoe Ban Kha",
                        "latitude": "13.32374000",
                        "longitude": "99.37323000"
                    },
                    {
                        "id": 105215,
                        "name": "Amphoe Ban Pong",
                        "latitude": "13.81660000",
                        "longitude": "99.82147000"
                    },
                    {
                        "id": 105237,
                        "name": "Amphoe Bang Phae",
                        "latitude": "13.68333000",
                        "longitude": "99.98333000"
                    },
                    {
                        "id": 105303,
                        "name": "Amphoe Chom Bueng",
                        "latitude": "13.62520000",
                        "longitude": "99.51870000"
                    },
                    {
                        "id": 105316,
                        "name": "Amphoe Damnoen Saduak",
                        "latitude": "13.56537000",
                        "longitude": "99.97042000"
                    },
                    {
                        "id": 105579,
                        "name": "Amphoe Mueang Ratchaburi",
                        "latitude": "13.54559000",
                        "longitude": "99.77678000"
                    },
                    {
                        "id": 105707,
                        "name": "Amphoe Pak Tho",
                        "latitude": "13.38761000",
                        "longitude": "99.67700000"
                    },
                    {
                        "id": 105759,
                        "name": "Amphoe Photharam",
                        "latitude": "13.70707000",
                        "longitude": "99.75622000"
                    },
                    {
                        "id": 106253,
                        "name": "Amphoe Suan Phueng",
                        "latitude": "13.56361000",
                        "longitude": "99.31133000"
                    },
                    {
                        "id": 106356,
                        "name": "Amphoe Wat Phleng",
                        "latitude": "13.44705000",
                        "longitude": "99.86959000"
                    },
                    {
                        "id": 106410,
                        "name": "Ban Pong",
                        "latitude": "13.81629000",
                        "longitude": "99.87739000"
                    },
                    {
                        "id": 106440,
                        "name": "Bang Phae",
                        "latitude": "13.69157000",
                        "longitude": "99.92982000"
                    },
                    {
                        "id": 106478,
                        "name": "Chom Bueng",
                        "latitude": "13.62000000",
                        "longitude": "99.59169000"
                    },
                    {
                        "id": 106485,
                        "name": "Damnoen Saduak",
                        "latitude": "13.51825000",
                        "longitude": "99.95469000"
                    },
                    {
                        "id": 106641,
                        "name": "Photharam",
                        "latitude": "13.69234000",
                        "longitude": "99.84969000"
                    },
                    {
                        "id": 106664,
                        "name": "Ratchaburi",
                        "latitude": "13.53671000",
                        "longitude": "99.81712000"
                    }
                ]
            },
            {
                "id": 3518,
                "name": "Rayong",
                "iso2": "21",
                "latitude": "12.68139570",
                "longitude": "101.28162610",
                "type": "province",
                "cities": [
                    {
                        "id": 105187,
                        "name": "Amphoe Ban Chang",
                        "latitude": "12.73230000",
                        "longitude": "101.04878000"
                    },
                    {
                        "id": 105195,
                        "name": "Amphoe Ban Khai",
                        "latitude": "12.83827000",
                        "longitude": "101.34210000"
                    },
                    {
                        "id": 105393,
                        "name": "Amphoe Khao Chamao",
                        "latitude": "12.99042000",
                        "longitude": "101.67847000"
                    },
                    {
                        "id": 105437,
                        "name": "Amphoe Klaeng",
                        "latitude": "12.77179000",
                        "longitude": "101.65666000"
                    },
                    {
                        "id": 105580,
                        "name": "Amphoe Mueang Rayong",
                        "latitude": "12.71864000",
                        "longitude": "101.34491000"
                    },
                    {
                        "id": 105645,
                        "name": "Amphoe Nikhom Phattana",
                        "latitude": "12.84489000",
                        "longitude": "101.15341000"
                    },
                    {
                        "id": 105790,
                        "name": "Amphoe Pluak Daeng",
                        "latitude": "12.98333000",
                        "longitude": "101.25000000"
                    },
                    {
                        "id": 106334,
                        "name": "Amphoe Wang Chan",
                        "latitude": "12.96245000",
                        "longitude": "101.51533000"
                    },
                    {
                        "id": 106387,
                        "name": "Ban Chang",
                        "latitude": "12.72543000",
                        "longitude": "101.05531000"
                    },
                    {
                        "id": 106408,
                        "name": "Ban Phe",
                        "latitude": "12.62824000",
                        "longitude": "101.43757000"
                    },
                    {
                        "id": 106532,
                        "name": "Klaeng",
                        "latitude": "12.77972000",
                        "longitude": "101.64831000"
                    },
                    {
                        "id": 106667,
                        "name": "Rayong",
                        "latitude": "12.68095000",
                        "longitude": "101.25798000"
                    }
                ]
            },
            {
                "id": 3510,
                "name": "Roi Et",
                "iso2": "45",
                "latitude": "16.05381960",
                "longitude": "103.65200360",
                "type": "province",
                "cities": [
                    {
                        "id": 105184,
                        "name": "Amphoe At Samat",
                        "latitude": "15.84014000",
                        "longitude": "103.86619000"
                    },
                    {
                        "id": 105285,
                        "name": "Amphoe Changhan",
                        "latitude": "16.16213000",
                        "longitude": "103.61605000"
                    },
                    {
                        "id": 105289,
                        "name": "Amphoe Chaturaphak Phiman",
                        "latitude": "15.82670000",
                        "longitude": "103.54934000"
                    },
                    {
                        "id": 105296,
                        "name": "Amphoe Chiang Khwan",
                        "latitude": "16.14887000",
                        "longitude": "103.74924000"
                    },
                    {
                        "id": 105379,
                        "name": "Amphoe Kaset Wisai",
                        "latitude": "15.60285000",
                        "longitude": "103.56652000"
                    },
                    {
                        "id": 105528,
                        "name": "Amphoe Moeiwadi",
                        "latitude": "16.37155000",
                        "longitude": "104.11137000"
                    },
                    {
                        "id": 105581,
                        "name": "Amphoe Mueang Roi Et",
                        "latitude": "16.01497000",
                        "longitude": "103.61584000"
                    },
                    {
                        "id": 105592,
                        "name": "Amphoe Mueang Suang",
                        "latitude": "15.78619000",
                        "longitude": "103.75071000"
                    },
                    {
                        "id": 105664,
                        "name": "Amphoe Nong Hi",
                        "latitude": "15.57983000",
                        "longitude": "104.01134000"
                    },
                    {
                        "id": 105676,
                        "name": "Amphoe Nong Phok",
                        "latitude": "16.30357000",
                        "longitude": "104.22144000"
                    },
                    {
                        "id": 105714,
                        "name": "Amphoe Pathum Rat",
                        "latitude": "15.62371000",
                        "longitude": "103.38733000"
                    },
                    {
                        "id": 105728,
                        "name": "Amphoe Phanom Phrai",
                        "latitude": "15.69300000",
                        "longitude": "104.07550000"
                    },
                    {
                        "id": 105744,
                        "name": "Amphoe Pho Chai",
                        "latitude": "16.30969000",
                        "longitude": "103.79004000"
                    },
                    {
                        "id": 105754,
                        "name": "Amphoe Phon Sai",
                        "latitude": "15.49244000",
                        "longitude": "103.94139000"
                    },
                    {
                        "id": 105756,
                        "name": "Amphoe Phon Thong",
                        "latitude": "16.29007000",
                        "longitude": "103.96388000"
                    },
                    {
                        "id": 106206,
                        "name": "Amphoe Selaphum",
                        "latitude": "16.04700000",
                        "longitude": "104.00031000"
                    },
                    {
                        "id": 106226,
                        "name": "Amphoe Si Somdet",
                        "latitude": "16.01947000",
                        "longitude": "103.51427000"
                    },
                    {
                        "id": 106259,
                        "name": "Amphoe Suwannaphum",
                        "latitude": "15.60529000",
                        "longitude": "103.80630000"
                    },
                    {
                        "id": 106304,
                        "name": "Amphoe Thawatchaburi",
                        "latitude": "16.02783000",
                        "longitude": "103.77833000"
                    },
                    {
                        "id": 106314,
                        "name": "Amphoe Thung Khao Luang",
                        "latitude": "15.98966000",
                        "longitude": "103.87086000"
                    },
                    {
                        "id": 106413,
                        "name": "Ban Selaphum",
                        "latitude": "16.01667000",
                        "longitude": "103.95000000"
                    },
                    {
                        "id": 106515,
                        "name": "Kaset Wisai",
                        "latitude": "15.65558000",
                        "longitude": "103.58361000"
                    },
                    {
                        "id": 106570,
                        "name": "Moeiwadi",
                        "latitude": "16.38944000",
                        "longitude": "104.15720000"
                    },
                    {
                        "id": 106637,
                        "name": "Pho Chai",
                        "latitude": "16.32827000",
                        "longitude": "103.77033000"
                    },
                    {
                        "id": 106668,
                        "name": "Roi Et",
                        "latitude": "16.05670000",
                        "longitude": "103.65309000"
                    },
                    {
                        "id": 106712,
                        "name": "Suwannaphum",
                        "latitude": "15.60348000",
                        "longitude": "103.80207000"
                    },
                    {
                        "id": 106742,
                        "name": "Waeng",
                        "latitude": "16.30006000",
                        "longitude": "103.97786000"
                    }
                ]
            },
            {
                "id": 3529,
                "name": "Sa Kaeo",
                "iso2": "27",
                "latitude": "13.82403800",
                "longitude": "102.06458390",
                "type": "province",
                "cities": [
                    {
                        "id": 105183,
                        "name": "Amphoe Aranyaprathet",
                        "latitude": "13.69086000",
                        "longitude": "102.47693000"
                    },
                    {
                        "id": 105392,
                        "name": "Amphoe Khao Chakan",
                        "latitude": "13.62293000",
                        "longitude": "102.02665000"
                    },
                    {
                        "id": 105405,
                        "name": "Amphoe Khlong Hat",
                        "latitude": "13.47396000",
                        "longitude": "102.27604000"
                    },
                    {
                        "id": 105420,
                        "name": "Amphoe Khok Sung",
                        "latitude": "13.87388000",
                        "longitude": "102.66075000"
                    },
                    {
                        "id": 105582,
                        "name": "Amphoe Mueang Sa Kaeo",
                        "latitude": "13.92969000",
                        "longitude": "102.10626000"
                    },
                    {
                        "id": 106260,
                        "name": "Amphoe Ta Phraya",
                        "latitude": "14.06272000",
                        "longitude": "102.72601000"
                    },
                    {
                        "id": 106340,
                        "name": "Amphoe Wang Nam Yen",
                        "latitude": "13.51900000",
                        "longitude": "102.08718000"
                    },
                    {
                        "id": 106347,
                        "name": "Amphoe Wang Sombun",
                        "latitude": "13.36112000",
                        "longitude": "102.12490000"
                    },
                    {
                        "id": 106358,
                        "name": "Amphoe Watthana Nakhon",
                        "latitude": "13.88582000",
                        "longitude": "102.35652000"
                    },
                    {
                        "id": 106382,
                        "name": "Aranyaprathet",
                        "latitude": "13.69276000",
                        "longitude": "102.50128000"
                    },
                    {
                        "id": 106671,
                        "name": "Sa Kaeo",
                        "latitude": "13.81411000",
                        "longitude": "102.07222000"
                    },
                    {
                        "id": 106743,
                        "name": "Wang Nam Yen",
                        "latitude": "13.50325000",
                        "longitude": "102.18115000"
                    }
                ]
            },
            {
                "id": 3501,
                "name": "Sakon Nakhon",
                "iso2": "47",
                "latitude": "17.16642110",
                "longitude": "104.14860550",
                "type": "province",
                "cities": [
                    {
                        "id": 105180,
                        "name": "Amphoe Akat Amnuai",
                        "latitude": "17.63589000",
                        "longitude": "103.97590000"
                    },
                    {
                        "id": 105205,
                        "name": "Amphoe Ban Muang",
                        "latitude": "17.89569000",
                        "longitude": "103.52793000"
                    },
                    {
                        "id": 105287,
                        "name": "Amphoe Charoen Sin",
                        "latitude": "17.63327000",
                        "longitude": "103.52218000"
                    },
                    {
                        "id": 105386,
                        "name": "Amphoe Kham Ta Kla",
                        "latitude": "17.82547000",
                        "longitude": "103.78598000"
                    },
                    {
                        "id": 105419,
                        "name": "Amphoe Khok Si Suphan",
                        "latitude": "17.02297000",
                        "longitude": "104.30346000"
                    },
                    {
                        "id": 105462,
                        "name": "Amphoe Kusuman",
                        "latitude": "17.35402000",
                        "longitude": "104.26677000"
                    },
                    {
                        "id": 105463,
                        "name": "Amphoe Kut Bak",
                        "latitude": "17.08205000",
                        "longitude": "103.81469000"
                    },
                    {
                        "id": 105583,
                        "name": "Amphoe Mueang Sakon Nakhon",
                        "latitude": "17.16163000",
                        "longitude": "104.10519000"
                    },
                    {
                        "id": 105644,
                        "name": "Amphoe Nikhom Nam Un",
                        "latitude": "17.17349000",
                        "longitude": "103.73511000"
                    },
                    {
                        "id": 105724,
                        "name": "Amphoe Phang Khon",
                        "latitude": "17.38267000",
                        "longitude": "103.75146000"
                    },
                    {
                        "id": 105725,
                        "name": "Amphoe Phanna Nikhom",
                        "latitude": "17.31369000",
                        "longitude": "103.89791000"
                    },
                    {
                        "id": 105753,
                        "name": "Amphoe Phon Na Kaeo",
                        "latitude": "17.21248000",
                        "longitude": "104.30700000"
                    },
                    {
                        "id": 105778,
                        "name": "Amphoe Phu Phan",
                        "latitude": "16.92862000",
                        "longitude": "103.92400000"
                    },
                    {
                        "id": 106201,
                        "name": "Amphoe Sawang Daen Din",
                        "latitude": "17.45590000",
                        "longitude": "103.44950000"
                    },
                    {
                        "id": 106245,
                        "name": "Amphoe Song Dao",
                        "latitude": "17.30883000",
                        "longitude": "103.44987000"
                    },
                    {
                        "id": 106268,
                        "name": "Amphoe Tao Ngoi",
                        "latitude": "16.94022000",
                        "longitude": "104.15863000"
                    },
                    {
                        "id": 106351,
                        "name": "Amphoe Wanon Niwat",
                        "latitude": "17.61516000",
                        "longitude": "103.76536000"
                    },
                    {
                        "id": 106354,
                        "name": "Amphoe Waritchaphum",
                        "latitude": "17.25692000",
                        "longitude": "103.62283000"
                    },
                    {
                        "id": 106675,
                        "name": "Sakon Nakhon",
                        "latitude": "17.16116000",
                        "longitude": "104.14725000"
                    },
                    {
                        "id": 106693,
                        "name": "Sawang Daen Din",
                        "latitude": "17.47531000",
                        "longitude": "103.45753000"
                    }
                ]
            },
            {
                "id": 3481,
                "name": "Samut Prakan",
                "iso2": "11",
                "latitude": "13.59909610",
                "longitude": "100.59983190",
                "type": "province",
                "cities": [
                    {
                        "id": 105222,
                        "name": "Amphoe Bang Bo",
                        "latitude": "13.58960000",
                        "longitude": "100.86711000"
                    },
                    {
                        "id": 105238,
                        "name": "Amphoe Bang Phli",
                        "latitude": "13.61972000",
                        "longitude": "100.72582000"
                    },
                    {
                        "id": 105243,
                        "name": "Amphoe Bang Sao Thong",
                        "latitude": "13.63286000",
                        "longitude": "100.81038000"
                    },
                    {
                        "id": 105584,
                        "name": "Amphoe Mueang Samut Prakan",
                        "latitude": "13.56855000",
                        "longitude": "100.65148000"
                    },
                    {
                        "id": 105763,
                        "name": "Amphoe Phra Pradaeng",
                        "latitude": "13.65246000",
                        "longitude": "100.55271000"
                    },
                    {
                        "id": 105764,
                        "name": "Amphoe Phra Samut Chedi",
                        "latitude": "13.55622000",
                        "longitude": "100.51485000"
                    },
                    {
                        "id": 106394,
                        "name": "Ban Khlong Bang Sao Thong",
                        "latitude": "13.64172000",
                        "longitude": "100.83272000"
                    },
                    {
                        "id": 106421,
                        "name": "Bang Bo District",
                        "latitude": "13.58333000",
                        "longitude": "100.81667000"
                    },
                    {
                        "id": 106646,
                        "name": "Phra Pradaeng",
                        "latitude": "13.65855000",
                        "longitude": "100.53362000"
                    },
                    {
                        "id": 106680,
                        "name": "Samut Prakan",
                        "latitude": "13.59934000",
                        "longitude": "100.59675000"
                    }
                ]
            },
            {
                "id": 3504,
                "name": "Samut Sakhon",
                "iso2": "74",
                "latitude": "13.54752160",
                "longitude": "100.27439560",
                "type": "province",
                "cities": [
                    {
                        "id": 105210,
                        "name": "Amphoe Ban Phaeo",
                        "latitude": "13.58747000",
                        "longitude": "100.11789000"
                    },
                    {
                        "id": 105455,
                        "name": "Amphoe Krathum Baen",
                        "latitude": "13.65570000",
                        "longitude": "100.27282000"
                    },
                    {
                        "id": 105585,
                        "name": "Amphoe Mueang Samut Sakhon",
                        "latitude": "13.53163000",
                        "longitude": "100.25326000"
                    },
                    {
                        "id": 106405,
                        "name": "Ban Phaeo",
                        "latitude": "13.59072000",
                        "longitude": "100.10748000"
                    },
                    {
                        "id": 106542,
                        "name": "Krathum Baen",
                        "latitude": "13.65330000",
                        "longitude": "100.25972000"
                    },
                    {
                        "id": 106681,
                        "name": "Samut Sakhon",
                        "latitude": "13.54753000",
                        "longitude": "100.27362000"
                    }
                ]
            },
            {
                "id": 3502,
                "name": "Samut Songkhram",
                "iso2": "75",
                "latitude": "13.40982170",
                "longitude": "100.00226450",
                "type": "province",
                "cities": [
                    {
                        "id": 105181,
                        "name": "Amphoe Amphawa",
                        "latitude": "13.36721000",
                        "longitude": "99.91232000"
                    },
                    {
                        "id": 105227,
                        "name": "Amphoe Bang Khonthi",
                        "latitude": "13.47448000",
                        "longitude": "99.94838000"
                    },
                    {
                        "id": 105586,
                        "name": "Amphoe Mueang Samut Songkhram",
                        "latitude": "13.39587000",
                        "longitude": "99.99929000"
                    },
                    {
                        "id": 106682,
                        "name": "Samut Songkhram",
                        "latitude": "13.41456000",
                        "longitude": "100.00264000"
                    }
                ]
            },
            {
                "id": 3487,
                "name": "Saraburi",
                "iso2": "19",
                "latitude": "14.52891540",
                "longitude": "100.91014210",
                "type": "province",
                "cities": [
                    {
                        "id": 105204,
                        "name": "Amphoe Ban Mo",
                        "latitude": "14.60804000",
                        "longitude": "100.72404000"
                    },
                    {
                        "id": 105277,
                        "name": "Amphoe Chaloem Phra Kiat",
                        "latitude": "14.65671000",
                        "longitude": "100.90838000"
                    },
                    {
                        "id": 105332,
                        "name": "Amphoe Don Phut",
                        "latitude": "14.60758000",
                        "longitude": "100.61578000"
                    },
                    {
                        "id": 105365,
                        "name": "Amphoe Kaeng Khoi",
                        "latitude": "14.58166000",
                        "longitude": "101.05297000"
                    },
                    {
                        "id": 105529,
                        "name": "Amphoe Muak Lek",
                        "latitude": "14.77706000",
                        "longitude": "101.27151000"
                    },
                    {
                        "id": 105587,
                        "name": "Amphoe Mueang Sara Buri",
                        "latitude": "14.49721000",
                        "longitude": "100.93829000"
                    },
                    {
                        "id": 105662,
                        "name": "Amphoe Nong Don",
                        "latitude": "14.68880000",
                        "longitude": "100.68527000"
                    },
                    {
                        "id": 105667,
                        "name": "Amphoe Nong Khae",
                        "latitude": "14.38125000",
                        "longitude": "100.86451000"
                    },
                    {
                        "id": 105679,
                        "name": "Amphoe Nong Saeng",
                        "latitude": "14.48283000",
                        "longitude": "100.80463000"
                    },
                    {
                        "id": 105762,
                        "name": "Amphoe Phra Phutthabat",
                        "latitude": "14.71912000",
                        "longitude": "100.80622000"
                    },
                    {
                        "id": 106193,
                        "name": "Amphoe Sao Hai",
                        "latitude": "14.57549000",
                        "longitude": "100.84390000"
                    },
                    {
                        "id": 106338,
                        "name": "Amphoe Wang Muang",
                        "latitude": "14.82287000",
                        "longitude": "101.13346000"
                    },
                    {
                        "id": 106369,
                        "name": "Amphoe Wihan Daeng",
                        "latitude": "14.33435000",
                        "longitude": "100.96458000"
                    },
                    {
                        "id": 106400,
                        "name": "Ban Mo",
                        "latitude": "14.61544000",
                        "longitude": "100.72731000"
                    },
                    {
                        "id": 106505,
                        "name": "Kaeng Khoi",
                        "latitude": "14.58617000",
                        "longitude": "100.99758000"
                    },
                    {
                        "id": 106598,
                        "name": "Nong Khae",
                        "latitude": "14.34062000",
                        "longitude": "100.86733000"
                    },
                    {
                        "id": 106645,
                        "name": "Phra Phutthabat",
                        "latitude": "14.72526000",
                        "longitude": "100.79536000"
                    },
                    {
                        "id": 106688,
                        "name": "Saraburi",
                        "latitude": "14.53333000",
                        "longitude": "100.91667000"
                    }
                ]
            },
            {
                "id": 3537,
                "name": "Satun",
                "iso2": "91",
                "latitude": "6.62381580",
                "longitude": "100.06737440",
                "type": "province",
                "cities": [
                    {
                        "id": 105426,
                        "name": "Amphoe Khuan Don",
                        "latitude": "6.76978000",
                        "longitude": "100.12216000"
                    },
                    {
                        "id": 105427,
                        "name": "Amphoe Khuan Kalong",
                        "latitude": "6.90593000",
                        "longitude": "100.04178000"
                    },
                    {
                        "id": 105468,
                        "name": "Amphoe La-Ngu",
                        "latitude": "6.90392000",
                        "longitude": "99.79836000"
                    },
                    {
                        "id": 105524,
                        "name": "Amphoe Manang",
                        "latitude": "7.01822000",
                        "longitude": "99.95399000"
                    },
                    {
                        "id": 105588,
                        "name": "Amphoe Mueang Satun",
                        "latitude": "6.62314000",
                        "longitude": "100.06681000"
                    },
                    {
                        "id": 106280,
                        "name": "Amphoe Tha Phae",
                        "latitude": "6.79542000",
                        "longitude": "99.91985000"
                    },
                    {
                        "id": 106319,
                        "name": "Amphoe Thung Wa",
                        "latitude": "7.04915000",
                        "longitude": "99.76587000"
                    },
                    {
                        "id": 154915,
                        "name": "Koh Lipe",
                        "latitude": "6.48770430",
                        "longitude": "99.27685140"
                    },
                    {
                        "id": 106692,
                        "name": "Satun",
                        "latitude": "6.62314000",
                        "longitude": "100.06676000"
                    }
                ]
            },
            {
                "id": 3547,
                "name": "Si Sa Ket",
                "iso2": "33",
                "latitude": "15.11860090",
                "longitude": "104.32200950",
                "type": "province",
                "cities": [
                    {
                        "id": 105249,
                        "name": "Amphoe Benchalak",
                        "latitude": "14.78319000",
                        "longitude": "104.71879000"
                    },
                    {
                        "id": 105259,
                        "name": "Amphoe Bueng Bun",
                        "latitude": "15.30288000",
                        "longitude": "104.06166000"
                    },
                    {
                        "id": 105358,
                        "name": "Amphoe Huai Thap Than",
                        "latitude": "15.01808000",
                        "longitude": "104.03875000"
                    },
                    {
                        "id": 105371,
                        "name": "Amphoe Kantharalak",
                        "latitude": "14.56800000",
                        "longitude": "104.67080000"
                    },
                    {
                        "id": 105372,
                        "name": "Amphoe Kanthararom",
                        "latitude": "15.12447000",
                        "longitude": "104.57318000"
                    },
                    {
                        "id": 105431,
                        "name": "Amphoe Khukhan",
                        "latitude": "14.73783000",
                        "longitude": "104.18590000"
                    },
                    {
                        "id": 105432,
                        "name": "Amphoe Khun Han",
                        "latitude": "14.53455000",
                        "longitude": "104.40739000"
                    },
                    {
                        "id": 105537,
                        "name": "Amphoe Mueang Chan",
                        "latitude": "15.18249000",
                        "longitude": "104.02471000"
                    },
                    {
                        "id": 105590,
                        "name": "Amphoe Mueang Sisaket",
                        "latitude": "15.08168000",
                        "longitude": "104.35126000"
                    },
                    {
                        "id": 105635,
                        "name": "Amphoe Nam Kliang",
                        "latitude": "14.91022000",
                        "longitude": "104.52545000"
                    },
                    {
                        "id": 105650,
                        "name": "Amphoe Non Khun",
                        "latitude": "14.90188000",
                        "longitude": "104.69564000"
                    },
                    {
                        "id": 105735,
                        "name": "Amphoe Phayu",
                        "latitude": "14.90639000",
                        "longitude": "104.38293000"
                    },
                    {
                        "id": 105747,
                        "name": "Amphoe Pho Si Suwan",
                        "latitude": "15.23370000",
                        "longitude": "104.06739000"
                    },
                    {
                        "id": 105767,
                        "name": "Amphoe Phrai Bueng",
                        "latitude": "14.77989000",
                        "longitude": "104.36599000"
                    },
                    {
                        "id": 105782,
                        "name": "Amphoe Phu Sing",
                        "latitude": "14.48873000",
                        "longitude": "104.15603000"
                    },
                    {
                        "id": 105797,
                        "name": "Amphoe Prang Ku",
                        "latitude": "14.85443000",
                        "longitude": "104.03740000"
                    },
                    {
                        "id": 105805,
                        "name": "Amphoe Rasi Salai",
                        "latitude": "15.34637000",
                        "longitude": "104.18617000"
                    },
                    {
                        "id": 106221,
                        "name": "Amphoe Si Rattana",
                        "latitude": "14.81062000",
                        "longitude": "104.47634000"
                    },
                    {
                        "id": 106236,
                        "name": "Amphoe Sila Lat",
                        "latitude": "15.48070000",
                        "longitude": "104.09478000"
                    },
                    {
                        "id": 106328,
                        "name": "Amphoe Uthumphon Phisai",
                        "latitude": "15.12305000",
                        "longitude": "104.16002000"
                    },
                    {
                        "id": 106337,
                        "name": "Amphoe Wang Hin",
                        "latitude": "14.96133000",
                        "longitude": "104.21928000"
                    },
                    {
                        "id": 106374,
                        "name": "Amphoe Yang Chum Noi",
                        "latitude": "15.23688000",
                        "longitude": "104.39083000"
                    },
                    {
                        "id": 106513,
                        "name": "Kantharalak",
                        "latitude": "14.64056000",
                        "longitude": "104.64992000"
                    },
                    {
                        "id": 106648,
                        "name": "Phrai Bueng",
                        "latitude": "14.74833000",
                        "longitude": "104.36261000"
                    },
                    {
                        "id": 106700,
                        "name": "Si Sa Ket",
                        "latitude": "15.11481000",
                        "longitude": "104.32938000"
                    }
                ]
            },
            {
                "id": 3490,
                "name": "Sing Buri",
                "iso2": "17",
                "latitude": "14.89362530",
                "longitude": "100.39673140",
                "type": "province",
                "cities": [
                    {
                        "id": 105240,
                        "name": "Amphoe Bang Rachan",
                        "latitude": "14.89959000",
                        "longitude": "100.27795000"
                    },
                    {
                        "id": 105360,
                        "name": "Amphoe In Buri",
                        "latitude": "15.02057000",
                        "longitude": "100.34865000"
                    },
                    {
                        "id": 105382,
                        "name": "Amphoe Khai Bang Rachan",
                        "latitude": "14.81438000",
                        "longitude": "100.31389000"
                    },
                    {
                        "id": 105589,
                        "name": "Amphoe Mueang Sing Buri",
                        "latitude": "14.90239000",
                        "longitude": "100.39731000"
                    },
                    {
                        "id": 105771,
                        "name": "Amphoe Phrom Buri",
                        "latitude": "14.78333000",
                        "longitude": "100.45000000"
                    },
                    {
                        "id": 106273,
                        "name": "Amphoe Tha Chang",
                        "latitude": "14.77941000",
                        "longitude": "100.39349000"
                    },
                    {
                        "id": 106442,
                        "name": "Bang Racham",
                        "latitude": "14.89200000",
                        "longitude": "100.31728000"
                    },
                    {
                        "id": 106503,
                        "name": "In Buri",
                        "latitude": "15.00787000",
                        "longitude": "100.32691000"
                    },
                    {
                        "id": 106702,
                        "name": "Sing Buri",
                        "latitude": "14.88786000",
                        "longitude": "100.40464000"
                    }
                ]
            },
            {
                "id": 3539,
                "name": "Songkhla",
                "iso2": "90",
                "latitude": "7.18976590",
                "longitude": "100.59538130",
                "type": "province",
                "cities": [
                    {
                        "id": 105228,
                        "name": "Amphoe Bang Klam",
                        "latitude": "7.06404000",
                        "longitude": "100.40664000"
                    },
                    {
                        "id": 105282,
                        "name": "Amphoe Chana",
                        "latitude": "6.89584000",
                        "longitude": "100.70126000"
                    },
                    {
                        "id": 105347,
                        "name": "Amphoe Hat Yai",
                        "latitude": "6.98092000",
                        "longitude": "100.46539000"
                    },
                    {
                        "id": 105406,
                        "name": "Amphoe Khlong Hoi Khong",
                        "latitude": "6.86623000",
                        "longitude": "100.35353000"
                    },
                    {
                        "id": 105429,
                        "name": "Amphoe Khuan Niang",
                        "latitude": "7.18231000",
                        "longitude": "100.37403000"
                    },
                    {
                        "id": 105453,
                        "name": "Amphoe Krasae Sin",
                        "latitude": "7.61254000",
                        "longitude": "100.32827000"
                    },
                    {
                        "id": 105591,
                        "name": "Amphoe Mueang Songkhla",
                        "latitude": "7.11075000",
                        "longitude": "100.60814000"
                    },
                    {
                        "id": 105617,
                        "name": "Amphoe Na Mom",
                        "latitude": "6.95990000",
                        "longitude": "100.57161000"
                    },
                    {
                        "id": 105623,
                        "name": "Amphoe Na Thawi",
                        "latitude": "6.63849000",
                        "longitude": "100.68173000"
                    },
                    {
                        "id": 105804,
                        "name": "Amphoe Ranot",
                        "latitude": "7.81390000",
                        "longitude": "100.28323000"
                    },
                    {
                        "id": 105810,
                        "name": "Amphoe Rattaphum",
                        "latitude": "7.07488000",
                        "longitude": "100.19515000"
                    },
                    {
                        "id": 105818,
                        "name": "Amphoe Saba Yoi",
                        "latitude": "6.52971000",
                        "longitude": "100.91232000"
                    },
                    {
                        "id": 105819,
                        "name": "Amphoe Sadao",
                        "latitude": "6.67135000",
                        "longitude": "100.42409000"
                    },
                    {
                        "id": 106196,
                        "name": "Amphoe Sathing Phra",
                        "latitude": "7.47963000",
                        "longitude": "100.42227000"
                    },
                    {
                        "id": 106237,
                        "name": "Amphoe Singhanakhon",
                        "latitude": "7.28453000",
                        "longitude": "100.48809000"
                    },
                    {
                        "id": 106305,
                        "name": "Amphoe Thepha",
                        "latitude": "6.79726000",
                        "longitude": "100.91025000"
                    },
                    {
                        "id": 106398,
                        "name": "Ban Mai",
                        "latitude": "7.20411000",
                        "longitude": "100.54508000"
                    },
                    {
                        "id": 106497,
                        "name": "Hat Yai",
                        "latitude": "7.00836000",
                        "longitude": "100.47668000"
                    },
                    {
                        "id": 106576,
                        "name": "Na Mom",
                        "latitude": "6.95856000",
                        "longitude": "100.55683000"
                    },
                    {
                        "id": 106662,
                        "name": "Ranot",
                        "latitude": "7.77768000",
                        "longitude": "100.32134000"
                    },
                    {
                        "id": 106672,
                        "name": "Sadao",
                        "latitude": "6.63883000",
                        "longitude": "100.42342000"
                    },
                    {
                        "id": 106704,
                        "name": "Songkhla",
                        "latitude": "7.19882000",
                        "longitude": "100.59510000"
                    }
                ]
            },
            {
                "id": 3545,
                "name": "Sukhothai",
                "iso2": "64",
                "latitude": "43.64855560",
                "longitude": "-79.37466390",
                "type": "province",
                "cities": [
                    {
                        "id": 105189,
                        "name": "Amphoe Ban Dan Lan Hoi",
                        "latitude": "17.05278000",
                        "longitude": "99.49148000"
                    },
                    {
                        "id": 105403,
                        "name": "Amphoe Khiri Mat",
                        "latitude": "16.82923000",
                        "longitude": "99.73976000"
                    },
                    {
                        "id": 105447,
                        "name": "Amphoe Kong Krailat",
                        "latitude": "16.93115000",
                        "longitude": "99.97414000"
                    },
                    {
                        "id": 105593,
                        "name": "Amphoe Mueang Sukhothai",
                        "latitude": "17.02318000",
                        "longitude": "99.77864000"
                    },
                    {
                        "id": 106203,
                        "name": "Amphoe Sawankhalok",
                        "latitude": "17.29899000",
                        "longitude": "99.85396000"
                    },
                    {
                        "id": 106217,
                        "name": "Amphoe Si Nakhon",
                        "latitude": "17.39275000",
                        "longitude": "99.97666000"
                    },
                    {
                        "id": 106223,
                        "name": "Amphoe Si Samrong",
                        "latitude": "17.16397000",
                        "longitude": "99.74672000"
                    },
                    {
                        "id": 106224,
                        "name": "Amphoe Si Satchanalai",
                        "latitude": "17.59927000",
                        "longitude": "99.70591000"
                    },
                    {
                        "id": 106315,
                        "name": "Amphoe Thung Saliam",
                        "latitude": "17.37082000",
                        "longitude": "99.55265000"
                    },
                    {
                        "id": 106388,
                        "name": "Ban Dan Lan Hoi",
                        "latitude": "17.00683000",
                        "longitude": "99.57497000"
                    },
                    {
                        "id": 106401,
                        "name": "Ban Na",
                        "latitude": "17.01717000",
                        "longitude": "99.73283000"
                    },
                    {
                        "id": 106522,
                        "name": "Khiri Mat",
                        "latitude": "16.83333000",
                        "longitude": "99.80000000"
                    },
                    {
                        "id": 106695,
                        "name": "Sawankhalok",
                        "latitude": "17.31597000",
                        "longitude": "99.83186000"
                    },
                    {
                        "id": 106701,
                        "name": "Si Satchanalai",
                        "latitude": "17.51692000",
                        "longitude": "99.75978000"
                    },
                    {
                        "id": 106707,
                        "name": "Sukhothai",
                        "latitude": "17.00778000",
                        "longitude": "99.82300000"
                    }
                ]
            },
            {
                "id": 3524,
                "name": "Suphan Buri",
                "iso2": "72",
                "latitude": "14.47448920",
                "longitude": "100.11771280",
                "type": "province",
                "cities": [
                    {
                        "id": 105239,
                        "name": "Amphoe Bang Pla Ma",
                        "latitude": "14.34985000",
                        "longitude": "100.14479000"
                    },
                    {
                        "id": 105317,
                        "name": "Amphoe Dan Chang",
                        "latitude": "14.88388000",
                        "longitude": "99.51642000"
                    },
                    {
                        "id": 105323,
                        "name": "Amphoe Doembang Nangbuat",
                        "latitude": "14.87394000",
                        "longitude": "100.04669000"
                    },
                    {
                        "id": 105330,
                        "name": "Amphoe Don Chedi",
                        "latitude": "14.64804000",
                        "longitude": "99.94734000"
                    },
                    {
                        "id": 105594,
                        "name": "Amphoe Mueang Suphan Buri",
                        "latitude": "14.49189000",
                        "longitude": "100.07458000"
                    },
                    {
                        "id": 105687,
                        "name": "Amphoe Nong Yasai",
                        "latitude": "14.77644000",
                        "longitude": "99.85751000"
                    },
                    {
                        "id": 106219,
                        "name": "Amphoe Si Prachan",
                        "latitude": "14.63810000",
                        "longitude": "100.15050000"
                    },
                    {
                        "id": 106247,
                        "name": "Amphoe Song Phi Nong",
                        "latitude": "14.18895000",
                        "longitude": "99.97580000"
                    },
                    {
                        "id": 106324,
                        "name": "Amphoe U Thong",
                        "latitude": "14.41093000",
                        "longitude": "99.88949000"
                    },
                    {
                        "id": 106412,
                        "name": "Ban Sam Chuk",
                        "latitude": "14.74219000",
                        "longitude": "100.09531000"
                    },
                    {
                        "id": 106490,
                        "name": "Doembang Nangbuat",
                        "latitude": "14.83333000",
                        "longitude": "100.10000000"
                    },
                    {
                        "id": 106709,
                        "name": "Suphan Buri",
                        "latitude": "14.47418000",
                        "longitude": "100.12218000"
                    }
                ]
            },
            {
                "id": 3482,
                "name": "Surat Thani",
                "iso2": "84",
                "latitude": "9.13419490",
                "longitude": "99.33341980",
                "type": "province",
                "cities": [
                    {
                        "id": 105207,
                        "name": "Amphoe Ban Na Doem",
                        "latitude": "8.90610000",
                        "longitude": "99.28136000"
                    },
                    {
                        "id": 105208,
                        "name": "Amphoe Ban Na San",
                        "latitude": "8.80063000",
                        "longitude": "99.40201000"
                    },
                    {
                        "id": 105219,
                        "name": "Amphoe Ban Takhun",
                        "latitude": "9.10423000",
                        "longitude": "98.67222000"
                    },
                    {
                        "id": 105270,
                        "name": "Amphoe Chai Buri",
                        "latitude": "8.43883000",
                        "longitude": "99.07721000"
                    },
                    {
                        "id": 105273,
                        "name": "Amphoe Chaiya",
                        "latitude": "9.49141000",
                        "longitude": "98.99568000"
                    },
                    {
                        "id": 105333,
                        "name": "Amphoe Don Sak",
                        "latitude": "9.21063000",
                        "longitude": "99.68887000"
                    },
                    {
                        "id": 105369,
                        "name": "Amphoe Kanchanadit",
                        "latitude": "9.07256000",
                        "longitude": "99.54390000"
                    },
                    {
                        "id": 105402,
                        "name": "Amphoe Khian Sa",
                        "latitude": "8.72766000",
                        "longitude": "99.13240000"
                    },
                    {
                        "id": 105404,
                        "name": "Amphoe Khiri Rat Nikhom",
                        "latitude": "9.00590000",
                        "longitude": "98.94404000"
                    },
                    {
                        "id": 105443,
                        "name": "Amphoe Ko Pha-ngan",
                        "latitude": "9.74939000",
                        "longitude": "100.02649000"
                    },
                    {
                        "id": 105444,
                        "name": "Amphoe Ko Samui",
                        "latitude": "9.50841000",
                        "longitude": "99.99644000"
                    },
                    {
                        "id": 105595,
                        "name": "Amphoe Mueang Surat Thani",
                        "latitude": "9.10132000",
                        "longitude": "99.32614000"
                    },
                    {
                        "id": 105726,
                        "name": "Amphoe Phanom",
                        "latitude": "8.82254000",
                        "longitude": "98.71709000"
                    },
                    {
                        "id": 105770,
                        "name": "Amphoe Phrasaeng",
                        "latitude": "8.55124000",
                        "longitude": "99.10520000"
                    },
                    {
                        "id": 105784,
                        "name": "Amphoe Phunphin",
                        "latitude": "9.02472000",
                        "longitude": "99.14304000"
                    },
                    {
                        "id": 106271,
                        "name": "Amphoe Tha Chana",
                        "latitude": "9.61142000",
                        "longitude": "99.03611000"
                    },
                    {
                        "id": 106272,
                        "name": "Amphoe Tha Chang",
                        "latitude": "9.33475000",
                        "longitude": "98.95619000"
                    },
                    {
                        "id": 106367,
                        "name": "Amphoe Wiang Sa",
                        "latitude": "8.59813000",
                        "longitude": "99.35277000"
                    },
                    {
                        "id": 106370,
                        "name": "Amphoe Wiphawadi",
                        "latitude": "9.21972000",
                        "longitude": "98.87028000"
                    },
                    {
                        "id": 106402,
                        "name": "Ban Na San",
                        "latitude": "8.80036000",
                        "longitude": "99.36372000"
                    },
                    {
                        "id": 106462,
                        "name": "Chai Buri",
                        "latitude": "8.46222000",
                        "longitude": "99.07631000"
                    },
                    {
                        "id": 106465,
                        "name": "Chaiya",
                        "latitude": "9.38625000",
                        "longitude": "99.19861000"
                    },
                    {
                        "id": 106493,
                        "name": "Don Sak",
                        "latitude": "9.31676000",
                        "longitude": "99.69184000"
                    },
                    {
                        "id": 106511,
                        "name": "Kanchanadit",
                        "latitude": "9.16611000",
                        "longitude": "99.47014000"
                    },
                    {
                        "id": 106535,
                        "name": "Ko Pha Ngan",
                        "latitude": "9.75778000",
                        "longitude": "100.02914000"
                    },
                    {
                        "id": 106536,
                        "name": "Ko Samui",
                        "latitude": "9.53567000",
                        "longitude": "99.93567000"
                    },
                    {
                        "id": 106538,
                        "name": "Koh Tao",
                        "latitude": "10.09808000",
                        "longitude": "99.83809000"
                    },
                    {
                        "id": 106710,
                        "name": "Surat Thani",
                        "latitude": "9.14011000",
                        "longitude": "99.33311000"
                    },
                    {
                        "id": 106719,
                        "name": "Tha Kham",
                        "latitude": "9.11072000",
                        "longitude": "99.23208000"
                    },
                    {
                        "id": 106720,
                        "name": "Tha Khanon",
                        "latitude": "9.03020000",
                        "longitude": "98.95286000"
                    },
                    {
                        "id": 106751,
                        "name": "Wiang Sa",
                        "latitude": "8.63585000",
                        "longitude": "99.36660000"
                    }
                ]
            },
            {
                "id": 3531,
                "name": "Surin",
                "iso2": "32",
                "latitude": "37.03582710",
                "longitude": "-95.62763670",
                "type": "province",
                "cities": [
                    {
                        "id": 105256,
                        "name": "Amphoe Bua Chet",
                        "latitude": "14.48406000",
                        "longitude": "103.97809000"
                    },
                    {
                        "id": 105304,
                        "name": "Amphoe Chom Phra",
                        "latitude": "15.14356000",
                        "longitude": "103.57881000"
                    },
                    {
                        "id": 105313,
                        "name": "Amphoe Chumphon Buri",
                        "latitude": "15.37942000",
                        "longitude": "103.37095000"
                    },
                    {
                        "id": 105375,
                        "name": "Amphoe Kap Choeng",
                        "latitude": "14.46795000",
                        "longitude": "103.58476000"
                    },
                    {
                        "id": 105436,
                        "name": "Amphoe Khwao Sinarin",
                        "latitude": "15.00733000",
                        "longitude": "103.62064000"
                    },
                    {
                        "id": 105479,
                        "name": "Amphoe Lamduan",
                        "latitude": "14.71907000",
                        "longitude": "103.69911000"
                    },
                    {
                        "id": 105596,
                        "name": "Amphoe Mueang Surin",
                        "latitude": "14.88359000",
                        "longitude": "103.51272000"
                    },
                    {
                        "id": 105651,
                        "name": "Amphoe Non Narai",
                        "latitude": "15.19111000",
                        "longitude": "103.92242000"
                    },
                    {
                        "id": 105727,
                        "name": "Amphoe Phanom Dong Rak",
                        "latitude": "14.42745000",
                        "longitude": "103.31007000"
                    },
                    {
                        "id": 105798,
                        "name": "Amphoe Prasat",
                        "latitude": "14.62602000",
                        "longitude": "103.41569000"
                    },
                    {
                        "id": 105808,
                        "name": "Amphoe Rattanaburi",
                        "latitude": "15.33780000",
                        "longitude": "103.90541000"
                    },
                    {
                        "id": 106181,
                        "name": "Amphoe Samrong Thap",
                        "latitude": "15.03980000",
                        "longitude": "103.94089000"
                    },
                    {
                        "id": 106187,
                        "name": "Amphoe Sangkha",
                        "latitude": "14.57051000",
                        "longitude": "103.83911000"
                    },
                    {
                        "id": 106191,
                        "name": "Amphoe Sanom",
                        "latitude": "15.17099000",
                        "longitude": "103.78475000"
                    },
                    {
                        "id": 106213,
                        "name": "Amphoe Si Khoraphum",
                        "latitude": "14.94753000",
                        "longitude": "103.78310000"
                    },
                    {
                        "id": 106218,
                        "name": "Amphoe Si Narong",
                        "latitude": "14.78085000",
                        "longitude": "103.88651000"
                    },
                    {
                        "id": 106288,
                        "name": "Amphoe Tha Tum",
                        "latitude": "15.30940000",
                        "longitude": "103.65111000"
                    },
                    {
                        "id": 106711,
                        "name": "Surin",
                        "latitude": "14.88181000",
                        "longitude": "103.49364000"
                    }
                ]
            },
            {
                "id": 3525,
                "name": "Tak",
                "iso2": "63",
                "latitude": "45.02996460",
                "longitude": "-93.10498150",
                "type": "province",
                "cities": [
                    {
                        "id": 105218,
                        "name": "Amphoe Ban Tak",
                        "latitude": "17.09163000",
                        "longitude": "99.06648000"
                    },
                    {
                        "id": 105509,
                        "name": "Amphoe Mae Ramat",
                        "latitude": "17.11180000",
                        "longitude": "98.58635000"
                    },
                    {
                        "id": 105513,
                        "name": "Amphoe Mae Sot",
                        "latitude": "16.72154000",
                        "longitude": "98.71074000"
                    },
                    {
                        "id": 105597,
                        "name": "Amphoe Mueang Tak",
                        "latitude": "16.87650000",
                        "longitude": "99.16617000"
                    },
                    {
                        "id": 105758,
                        "name": "Amphoe Phop Phra",
                        "latitude": "16.47215000",
                        "longitude": "98.83501000"
                    },
                    {
                        "id": 106285,
                        "name": "Amphoe Tha Song Yang",
                        "latitude": "17.47481000",
                        "longitude": "98.12079000"
                    },
                    {
                        "id": 106326,
                        "name": "Amphoe Umphang",
                        "latitude": "15.79496000",
                        "longitude": "98.87787000"
                    },
                    {
                        "id": 106335,
                        "name": "Amphoe Wang Chao",
                        "latitude": "16.63311000",
                        "longitude": "99.14826000"
                    },
                    {
                        "id": 106415,
                        "name": "Ban Tak",
                        "latitude": "17.04325000",
                        "longitude": "99.08128000"
                    },
                    {
                        "id": 106564,
                        "name": "Mae Ramat",
                        "latitude": "16.98403000",
                        "longitude": "98.51665000"
                    },
                    {
                        "id": 106566,
                        "name": "Mae Sot",
                        "latitude": "16.71667000",
                        "longitude": "98.56667000"
                    },
                    {
                        "id": 106713,
                        "name": "Tak",
                        "latitude": "16.86968000",
                        "longitude": "99.12898000"
                    }
                ]
            },
            {
                "id": 3541,
                "name": "Trang",
                "iso2": "92",
                "latitude": "7.56448330",
                "longitude": "99.62393340",
                "type": "province",
                "cities": [
                    {
                        "id": 105346,
                        "name": "Amphoe Hat Samran",
                        "latitude": "7.25733000",
                        "longitude": "99.58160000"
                    },
                    {
                        "id": 105359,
                        "name": "Amphoe Huai Yot",
                        "latitude": "7.80063000",
                        "longitude": "99.60500000"
                    },
                    {
                        "id": 105370,
                        "name": "Amphoe Kantang",
                        "latitude": "7.38563000",
                        "longitude": "99.47064000"
                    },
                    {
                        "id": 105598,
                        "name": "Amphoe Mueang Trang",
                        "latitude": "7.60944000",
                        "longitude": "99.61772000"
                    },
                    {
                        "id": 105629,
                        "name": "Amphoe Na Yong",
                        "latitude": "7.56257000",
                        "longitude": "99.74791000"
                    },
                    {
                        "id": 105709,
                        "name": "Amphoe Palian",
                        "latitude": "7.23340000",
                        "longitude": "99.79491000"
                    },
                    {
                        "id": 105807,
                        "name": "Amphoe Ratsada",
                        "latitude": "7.93779000",
                        "longitude": "99.66771000"
                    },
                    {
                        "id": 106233,
                        "name": "Amphoe Sikao",
                        "latitude": "7.57122000",
                        "longitude": "99.33915000"
                    },
                    {
                        "id": 106349,
                        "name": "Amphoe Wang Wiset",
                        "latitude": "7.76061000",
                        "longitude": "99.40861000"
                    },
                    {
                        "id": 106373,
                        "name": "Amphoe Yan Ta Khao",
                        "latitude": "7.42580000",
                        "longitude": "99.73438000"
                    },
                    {
                        "id": 106502,
                        "name": "Huai Yot",
                        "latitude": "7.78937000",
                        "longitude": "99.63469000"
                    },
                    {
                        "id": 106512,
                        "name": "Kantang",
                        "latitude": "7.40542000",
                        "longitude": "99.51561000"
                    },
                    {
                        "id": 106735,
                        "name": "Trang",
                        "latitude": "7.55633000",
                        "longitude": "99.61141000"
                    }
                ]
            },
            {
                "id": 3496,
                "name": "Trat",
                "iso2": "23",
                "latitude": "12.24275630",
                "longitude": "102.51747340",
                "type": "province",
                "cities": [
                    {
                        "id": 105253,
                        "name": "Amphoe Bo Rai",
                        "latitude": "12.55816000",
                        "longitude": "102.56566000"
                    },
                    {
                        "id": 105397,
                        "name": "Amphoe Khao Saming",
                        "latitude": "12.42885000",
                        "longitude": "102.41784000"
                    },
                    {
                        "id": 105412,
                        "name": "Amphoe Khlong Yai",
                        "latitude": "11.85540000",
                        "longitude": "102.82596000"
                    },
                    {
                        "id": 105439,
                        "name": "Amphoe Ko Chang",
                        "latitude": "12.05947000",
                        "longitude": "102.32941000"
                    },
                    {
                        "id": 105441,
                        "name": "Amphoe Ko Kut",
                        "latitude": "11.65714000",
                        "longitude": "102.56694000"
                    },
                    {
                        "id": 105470,
                        "name": "Amphoe Laem Ngop",
                        "latitude": "12.22028000",
                        "longitude": "102.36558000"
                    },
                    {
                        "id": 105599,
                        "name": "Amphoe Mueang Trat",
                        "latitude": "12.26667000",
                        "longitude": "102.60945000"
                    },
                    {
                        "id": 106453,
                        "name": "Bo Rai",
                        "latitude": "12.57283000",
                        "longitude": "102.53714000"
                    },
                    {
                        "id": 106528,
                        "name": "Khlong Yai",
                        "latitude": "11.77645000",
                        "longitude": "102.88567000"
                    },
                    {
                        "id": 106533,
                        "name": "Ko Chang Tai",
                        "latitude": "12.00171000",
                        "longitude": "102.37267000"
                    },
                    {
                        "id": 106736,
                        "name": "Trat",
                        "latitude": "12.24364000",
                        "longitude": "102.51514000"
                    }
                ]
            },
            {
                "id": 3512,
                "name": "Ubon Ratchathani",
                "iso2": "34",
                "latitude": "15.24484530",
                "longitude": "104.84729950",
                "type": "province",
                "cities": [
                    {
                        "id": 105265,
                        "name": "Amphoe Buntharik",
                        "latitude": "14.70495000",
                        "longitude": "105.40444000"
                    },
                    {
                        "id": 105322,
                        "name": "Amphoe Det Udom",
                        "latitude": "14.85153000",
                        "longitude": "105.07511000"
                    },
                    {
                        "id": 105331,
                        "name": "Amphoe Don Mot Daeng",
                        "latitude": "15.37694000",
                        "longitude": "105.02107000"
                    },
                    {
                        "id": 105401,
                        "name": "Amphoe Khemmarat",
                        "latitude": "15.97114000",
                        "longitude": "105.15168000"
                    },
                    {
                        "id": 105424,
                        "name": "Amphoe Khong Chiam",
                        "latitude": "15.45432000",
                        "longitude": "105.50363000"
                    },
                    {
                        "id": 105430,
                        "name": "Amphoe Khueang Nai",
                        "latitude": "15.39097000",
                        "longitude": "104.54363000"
                    },
                    {
                        "id": 105466,
                        "name": "Amphoe Kut Khaopun",
                        "latitude": "15.81907000",
                        "longitude": "105.04066000"
                    },
                    {
                        "id": 105485,
                        "name": "Amphoe Lao Suea Kok",
                        "latitude": "15.43952000",
                        "longitude": "104.91662000"
                    },
                    {
                        "id": 105530,
                        "name": "Amphoe Muang Sam Sip",
                        "latitude": "15.52637000",
                        "longitude": "104.71661000"
                    },
                    {
                        "id": 105600,
                        "name": "Amphoe Mueang Ubon Ratchathani",
                        "latitude": "15.29662000",
                        "longitude": "104.83052000"
                    },
                    {
                        "id": 105608,
                        "name": "Amphoe Na Chaluai",
                        "latitude": "14.56695000",
                        "longitude": "105.22367000"
                    },
                    {
                        "id": 105622,
                        "name": "Amphoe Na Tan",
                        "latitude": "15.93485000",
                        "longitude": "105.28454000"
                    },
                    {
                        "id": 105628,
                        "name": "Amphoe Na Yia",
                        "latitude": "15.04140000",
                        "longitude": "105.05729000"
                    },
                    {
                        "id": 105634,
                        "name": "Amphoe Nam Khun",
                        "latitude": "14.55508000",
                        "longitude": "104.89872000"
                    },
                    {
                        "id": 105640,
                        "name": "Amphoe Nam Yuen",
                        "latitude": "14.48671000",
                        "longitude": "105.00269000"
                    },
                    {
                        "id": 105738,
                        "name": "Amphoe Phibun Mangsahan",
                        "latitude": "15.14589000",
                        "longitude": "105.24094000"
                    },
                    {
                        "id": 105746,
                        "name": "Amphoe Pho Sai",
                        "latitude": "15.76739000",
                        "longitude": "105.34339000"
                    },
                    {
                        "id": 106180,
                        "name": "Amphoe Samrong",
                        "latitude": "14.98532000",
                        "longitude": "104.79139000"
                    },
                    {
                        "id": 106202,
                        "name": "Amphoe Sawang Wirawong",
                        "latitude": "15.23439000",
                        "longitude": "105.07600000"
                    },
                    {
                        "id": 106216,
                        "name": "Amphoe Si Mueang Mai",
                        "latitude": "15.56297000",
                        "longitude": "105.34830000"
                    },
                    {
                        "id": 106238,
                        "name": "Amphoe Sirindhorn",
                        "latitude": "15.11249000",
                        "longitude": "105.42837000"
                    },
                    {
                        "id": 106267,
                        "name": "Amphoe Tan Sum",
                        "latitude": "15.39035000",
                        "longitude": "105.16273000"
                    },
                    {
                        "id": 106316,
                        "name": "Amphoe Thung Si Udom",
                        "latitude": "14.73936000",
                        "longitude": "104.91731000"
                    },
                    {
                        "id": 106322,
                        "name": "Amphoe Trakan Phuet Phon",
                        "latitude": "15.61360000",
                        "longitude": "105.06444000"
                    },
                    {
                        "id": 106353,
                        "name": "Amphoe Warin Chamrap",
                        "latitude": "15.12394000",
                        "longitude": "104.87499000"
                    },
                    {
                        "id": 106488,
                        "name": "Det Udom",
                        "latitude": "14.90598000",
                        "longitude": "105.07836000"
                    },
                    {
                        "id": 106633,
                        "name": "Phibun Mangsahan",
                        "latitude": "15.24467000",
                        "longitude": "105.22908000"
                    },
                    {
                        "id": 106694,
                        "name": "Sawang Wirawong",
                        "latitude": "15.24158000",
                        "longitude": "105.09220000"
                    },
                    {
                        "id": 106737,
                        "name": "Ubon Ratchathani",
                        "latitude": "15.23844000",
                        "longitude": "104.84866000"
                    },
                    {
                        "id": 106750,
                        "name": "Warin Chamrap",
                        "latitude": "15.19319000",
                        "longitude": "104.86280000"
                    }
                ]
            },
            {
                "id": 3527,
                "name": "Udon Thani",
                "iso2": "41",
                "latitude": "17.36469690",
                "longitude": "102.81589240",
                "type": "province",
                "cities": [
                    {
                        "id": 105190,
                        "name": "Amphoe Ban Dung",
                        "latitude": "17.71134000",
                        "longitude": "103.26729000"
                    },
                    {
                        "id": 105214,
                        "name": "Amphoe Ban Phue",
                        "latitude": "17.67709000",
                        "longitude": "102.44563000"
                    },
                    {
                        "id": 105272,
                        "name": "Amphoe Chai Wan",
                        "latitude": "17.21581000",
                        "longitude": "103.27832000"
                    },
                    {
                        "id": 105458,
                        "name": "Amphoe Ku Kaeo",
                        "latitude": "17.16286000",
                        "longitude": "103.16754000"
                    },
                    {
                        "id": 105461,
                        "name": "Amphoe Kumphawapi",
                        "latitude": "17.09209000",
                        "longitude": "102.99395000"
                    },
                    {
                        "id": 105464,
                        "name": "Amphoe Kut Chap",
                        "latitude": "17.44009000",
                        "longitude": "102.54083000"
                    },
                    {
                        "id": 105601,
                        "name": "Amphoe Mueang Udon Thani",
                        "latitude": "17.39085000",
                        "longitude": "102.78912000"
                    },
                    {
                        "id": 105630,
                        "name": "Amphoe Na Yung",
                        "latitude": "17.93470000",
                        "longitude": "102.13417000"
                    },
                    {
                        "id": 105639,
                        "name": "Amphoe Nam Som",
                        "latitude": "17.74338000",
                        "longitude": "102.17328000"
                    },
                    {
                        "id": 105652,
                        "name": "Amphoe Non Sa-at",
                        "latitude": "16.95002000",
                        "longitude": "102.89990000"
                    },
                    {
                        "id": 105663,
                        "name": "Amphoe Nong Han",
                        "latitude": "17.36853000",
                        "longitude": "103.11510000"
                    },
                    {
                        "id": 105680,
                        "name": "Amphoe Nong Saeng",
                        "latitude": "17.14166000",
                        "longitude": "102.78592000"
                    },
                    {
                        "id": 105684,
                        "name": "Amphoe Nong Wua So",
                        "latitude": "17.18691000",
                        "longitude": "102.58986000"
                    },
                    {
                        "id": 105737,
                        "name": "Amphoe Phen",
                        "latitude": "17.66033000",
                        "longitude": "102.93052000"
                    },
                    {
                        "id": 105739,
                        "name": "Amphoe Phibun Rak",
                        "latitude": "17.52630000",
                        "longitude": "103.07497000"
                    },
                    {
                        "id": 105793,
                        "name": "Amphoe Prachak Sinlapakhom",
                        "latitude": "17.24648000",
                        "longitude": "102.98713000"
                    },
                    {
                        "id": 106186,
                        "name": "Amphoe Sang Khom",
                        "latitude": "17.79433000",
                        "longitude": "103.05114000"
                    },
                    {
                        "id": 106228,
                        "name": "Amphoe Si That",
                        "latitude": "17.03388000",
                        "longitude": "103.23084000"
                    },
                    {
                        "id": 106312,
                        "name": "Amphoe Thung Fon",
                        "latitude": "17.49061000",
                        "longitude": "103.22088000"
                    },
                    {
                        "id": 106345,
                        "name": "Amphoe Wang Sam Mo",
                        "latitude": "17.04595000",
                        "longitude": "103.46262000"
                    },
                    {
                        "id": 106389,
                        "name": "Ban Dung",
                        "latitude": "17.69900000",
                        "longitude": "103.25957000"
                    },
                    {
                        "id": 106404,
                        "name": "Ban Nong Wua So",
                        "latitude": "17.26750000",
                        "longitude": "103.22472000"
                    },
                    {
                        "id": 106407,
                        "name": "Ban Phan Don",
                        "latitude": "17.14272000",
                        "longitude": "102.97261000"
                    },
                    {
                        "id": 106545,
                        "name": "Kumphawapi",
                        "latitude": "17.10875000",
                        "longitude": "103.01487000"
                    },
                    {
                        "id": 106546,
                        "name": "Kut Chap",
                        "latitude": "17.42570000",
                        "longitude": "102.56692000"
                    },
                    {
                        "id": 106587,
                        "name": "Nam Som",
                        "latitude": "17.77036000",
                        "longitude": "102.18947000"
                    },
                    {
                        "id": 106604,
                        "name": "Nong Wua So",
                        "latitude": "17.16261000",
                        "longitude": "102.57272000"
                    },
                    {
                        "id": 106738,
                        "name": "Udon Thani",
                        "latitude": "17.41567000",
                        "longitude": "102.78589000"
                    }
                ]
            },
            {
                "id": 3551,
                "name": "Uthai Thani",
                "iso2": "61",
                "latitude": "15.38350010",
                "longitude": "100.02455270",
                "type": "province",
                "cities": [
                    {
                        "id": 105216,
                        "name": "Amphoe Ban Rai",
                        "latitude": "15.24921000",
                        "longitude": "99.32817000"
                    },
                    {
                        "id": 105352,
                        "name": "Amphoe Huai Khot",
                        "latitude": "15.32761000",
                        "longitude": "99.51941000"
                    },
                    {
                        "id": 105481,
                        "name": "Amphoe Lan Sak",
                        "latitude": "15.52289000",
                        "longitude": "99.46110000"
                    },
                    {
                        "id": 105602,
                        "name": "Amphoe Mueang Uthai Thani",
                        "latitude": "15.40857000",
                        "longitude": "100.02794000"
                    },
                    {
                        "id": 105660,
                        "name": "Amphoe Nong Chang",
                        "latitude": "15.36755000",
                        "longitude": "99.77273000"
                    },
                    {
                        "id": 105668,
                        "name": "Amphoe Nong Khayang",
                        "latitude": "15.34892000",
                        "longitude": "99.94706000"
                    },
                    {
                        "id": 106200,
                        "name": "Amphoe Sawang Arom",
                        "latitude": "15.60250000",
                        "longitude": "99.78490000"
                    },
                    {
                        "id": 106302,
                        "name": "Amphoe Thap Than",
                        "latitude": "15.49057000",
                        "longitude": "99.82224000"
                    },
                    {
                        "id": 106499,
                        "name": "Huai Khot",
                        "latitude": "15.29095000",
                        "longitude": "99.61661000"
                    },
                    {
                        "id": 106552,
                        "name": "Lan Sak",
                        "latitude": "15.45289000",
                        "longitude": "99.57606000"
                    },
                    {
                        "id": 106728,
                        "name": "Thap Than",
                        "latitude": "15.46063000",
                        "longitude": "99.89166000"
                    },
                    {
                        "id": 106739,
                        "name": "Uthai Thani",
                        "latitude": "15.37939000",
                        "longitude": "100.02450000"
                    }
                ]
            },
            {
                "id": 3489,
                "name": "Uttaradit",
                "iso2": "53",
                "latitude": "17.62008860",
                "longitude": "100.09929420",
                "type": "province",
                "cities": [
                    {
                        "id": 105196,
                        "name": "Amphoe Ban Khok",
                        "latitude": "18.14680000",
                        "longitude": "101.06610000"
                    },
                    {
                        "id": 105339,
                        "name": "Amphoe Fak Tha",
                        "latitude": "18.00078000",
                        "longitude": "100.88885000"
                    },
                    {
                        "id": 105486,
                        "name": "Amphoe Lap Lae",
                        "latitude": "17.65741000",
                        "longitude": "100.01484000"
                    },
                    {
                        "id": 105603,
                        "name": "Amphoe Mueang Uttaradit",
                        "latitude": "17.68138000",
                        "longitude": "100.19963000"
                    },
                    {
                        "id": 105637,
                        "name": "Amphoe Nam Pat",
                        "latitude": "17.70025000",
                        "longitude": "100.72738000"
                    },
                    {
                        "id": 105740,
                        "name": "Amphoe Phichai",
                        "latitude": "17.30188000",
                        "longitude": "100.11281000"
                    },
                    {
                        "id": 106281,
                        "name": "Amphoe Tha Pla",
                        "latitude": "17.85868000",
                        "longitude": "100.47061000"
                    },
                    {
                        "id": 106310,
                        "name": "Amphoe Thong Saen Khan",
                        "latitude": "17.49930000",
                        "longitude": "100.39658000"
                    },
                    {
                        "id": 106323,
                        "name": "Amphoe Tron",
                        "latitude": "17.47231000",
                        "longitude": "100.13467000"
                    },
                    {
                        "id": 106740,
                        "name": "Uttaradit",
                        "latitude": "17.62557000",
                        "longitude": "100.09421000"
                    }
                ]
            },
            {
                "id": 3493,
                "name": "Yala",
                "iso2": "95",
                "latitude": "44.05791170",
                "longitude": "-123.16538480",
                "type": "province",
                "cities": [
                    {
                        "id": 105247,
                        "name": "Amphoe Bannang Sata",
                        "latitude": "6.25643000",
                        "longitude": "101.27852000"
                    },
                    {
                        "id": 105250,
                        "name": "Amphoe Betong",
                        "latitude": "5.86362000",
                        "longitude": "101.22737000"
                    },
                    {
                        "id": 105361,
                        "name": "Amphoe Kabang",
                        "latitude": "6.37923000",
                        "longitude": "100.98348000"
                    },
                    {
                        "id": 105457,
                        "name": "Amphoe Krong Pinang",
                        "latitude": "6.39932000",
                        "longitude": "101.25710000"
                    },
                    {
                        "id": 105604,
                        "name": "Amphoe Mueang Yala",
                        "latitude": "6.54378000",
                        "longitude": "101.25105000"
                    },
                    {
                        "id": 105803,
                        "name": "Amphoe Raman",
                        "latitude": "6.48985000",
                        "longitude": "101.43442000"
                    },
                    {
                        "id": 106297,
                        "name": "Amphoe Than To",
                        "latitude": "6.08042000",
                        "longitude": "101.25941000"
                    },
                    {
                        "id": 106372,
                        "name": "Amphoe Yaha",
                        "latitude": "6.40529000",
                        "longitude": "101.12679000"
                    },
                    {
                        "id": 106451,
                        "name": "Betong",
                        "latitude": "5.77434000",
                        "longitude": "101.07231000"
                    },
                    {
                        "id": 106755,
                        "name": "Yala",
                        "latitude": "6.53995000",
                        "longitude": "101.28128000"
                    }
                ]
            },
            {
                "id": 3521,
                "name": "Yasothon",
                "iso2": "35",
                "latitude": "15.79264100",
                "longitude": "104.14528270",
                "type": "province",
                "cities": [
                    {
                        "id": 105383,
                        "name": "Amphoe Kham Khuan Kaeo",
                        "latitude": "15.67197000",
                        "longitude": "104.33372000"
                    },
                    {
                        "id": 105414,
                        "name": "Amphoe Kho Wang",
                        "latitude": "15.38164000",
                        "longitude": "104.34109000"
                    },
                    {
                        "id": 105465,
                        "name": "Amphoe Kut Chum",
                        "latitude": "16.04620000",
                        "longitude": "104.30545000"
                    },
                    {
                        "id": 105491,
                        "name": "Amphoe Loeng Nok Tha",
                        "latitude": "16.20433000",
                        "longitude": "104.51442000"
                    },
                    {
                        "id": 105520,
                        "name": "Amphoe Maha Chana Chai",
                        "latitude": "15.51267000",
                        "longitude": "104.26104000"
                    },
                    {
                        "id": 105606,
                        "name": "Amphoe Mueang Yasothon",
                        "latitude": "15.85550000",
                        "longitude": "104.17804000"
                    },
                    {
                        "id": 105698,
                        "name": "Amphoe Pa Tio",
                        "latitude": "15.84415000",
                        "longitude": "104.39994000"
                    },
                    {
                        "id": 105822,
                        "name": "Amphoe Sai Mun",
                        "latitude": "15.97917000",
                        "longitude": "104.19070000"
                    },
                    {
                        "id": 106293,
                        "name": "Amphoe Thai Charoen",
                        "latitude": "16.07936000",
                        "longitude": "104.42778000"
                    },
                    {
                        "id": 106759,
                        "name": "Yasothon",
                        "latitude": "15.79408000",
                        "longitude": "104.14510000"
                    }
                ]
            }
        ]
    },
    {
        "id": 17,
        "name": "The Bahamas",
        "iso3": "BHS",
        "iso2": "BS",
        "numeric_code": "044",
        "phonecode": "1",
        "capital": "Nassau",
        "currency": "BSD",
        "currency_name": "Bahamian dollar",
        "currency_symbol": "B$",
        "tld": ".bs",
        "native": "Bahamas",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Bahamian",
        "timezones": [
            {
                "zoneName": "America\/Nassau",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America)"
            }
        ],
        "translations": {
            "br": "Bahamas",
            "ko": "바하마",
            "pt-BR": "Bahamas",
            "pt": "Baamas",
            "nl": "Bahama’s",
            "hr": "Bahami",
            "fa": "باهاما",
            "de": "Bahamas",
            "es": "Bahamas",
            "fr": "Bahamas",
            "ja": "バハマ",
            "it": "Bahamas",
            "zh-CN": "巴哈马",
            "tr": "Bahamalar",
            "ru": "Багамы",
            "uk": "Багамські острови",
            "pl": "Bahamy"
        },
        "latitude": "24.25000000",
        "longitude": "-76.00000000",
        "emoji": "🇧🇸",
        "emojiU": "U+1F1E7 U+1F1F8",
        "states": [
            {
                "id": 3601,
                "name": "Acklins",
                "iso2": "AK",
                "latitude": "22.45102090",
                "longitude": "-74.39470650",
                "type": "district",
                "cities": []
            },
            {
                "id": 3628,
                "name": "Acklins and Crooked Islands",
                "iso2": "AC",
                "latitude": "22.50764240",
                "longitude": "-74.44170410",
                "type": "district",
                "cities": []
            },
            {
                "id": 3593,
                "name": "Berry Islands",
                "iso2": "BY",
                "latitude": "25.62500420",
                "longitude": "-77.82522030",
                "type": "district",
                "cities": []
            },
            {
                "id": 3629,
                "name": "Bimini",
                "iso2": "BI",
                "latitude": "24.64153250",
                "longitude": "-79.85062260",
                "type": "district",
                "cities": [
                    {
                        "id": 15686,
                        "name": "Alice Town",
                        "latitude": "25.72800000",
                        "longitude": "-79.29721000"
                    }
                ]
            },
            {
                "id": 3605,
                "name": "Black Point",
                "iso2": "BP",
                "latitude": "41.39510240",
                "longitude": "-71.46505560",
                "type": "district",
                "cities": []
            },
            {
                "id": 3611,
                "name": "Cat Island",
                "iso2": "CI",
                "latitude": "30.22801360",
                "longitude": "-89.10149330",
                "type": "district",
                "cities": [
                    {
                        "id": 15688,
                        "name": "Arthur’s Town",
                        "latitude": "24.62240000",
                        "longitude": "-75.67151000"
                    }
                ]
            },
            {
                "id": 3603,
                "name": "Central Abaco",
                "iso2": "CO",
                "latitude": "26.35550290",
                "longitude": "-77.14851630",
                "type": "district",
                "cities": [
                    {
                        "id": 15699,
                        "name": "Marsh Harbour",
                        "latitude": "26.54124000",
                        "longitude": "-77.06360000"
                    }
                ]
            },
            {
                "id": 3631,
                "name": "Central Andros",
                "iso2": "CS",
                "latitude": "24.46884820",
                "longitude": "-77.97386500",
                "type": "district",
                "cities": []
            },
            {
                "id": 3596,
                "name": "Central Eleuthera",
                "iso2": "CE",
                "latitude": "25.13620370",
                "longitude": "-76.14359150",
                "type": "district",
                "cities": []
            },
            {
                "id": 3621,
                "name": "Crooked Island",
                "iso2": "CK",
                "latitude": "22.63909820",
                "longitude": "-74.00650900",
                "type": "district",
                "cities": [
                    {
                        "id": 15691,
                        "name": "Colonel Hill",
                        "latitude": "22.75450000",
                        "longitude": "-74.20415000"
                    }
                ]
            },
            {
                "id": 3614,
                "name": "East Grand Bahama",
                "iso2": "EG",
                "latitude": "26.65828230",
                "longitude": "-78.22482910",
                "type": "district",
                "cities": [
                    {
                        "id": 15697,
                        "name": "High Rock",
                        "latitude": "26.60999000",
                        "longitude": "-78.27863000"
                    }
                ]
            },
            {
                "id": 3612,
                "name": "Exuma",
                "iso2": "EX",
                "latitude": "23.61925980",
                "longitude": "-75.96954650",
                "type": "district",
                "cities": [
                    {
                        "id": 15696,
                        "name": "George Town",
                        "latitude": "23.51616000",
                        "longitude": "-75.78665000"
                    }
                ]
            },
            {
                "id": 3626,
                "name": "Freeport",
                "iso2": "FP",
                "latitude": "42.29668610",
                "longitude": "-89.62122710",
                "type": "district",
                "cities": [
                    {
                        "id": 15695,
                        "name": "Freeport",
                        "latitude": "26.53333000",
                        "longitude": "-78.70000000"
                    },
                    {
                        "id": 15698,
                        "name": "Lucaya",
                        "latitude": "26.53333000",
                        "longitude": "-78.66667000"
                    }
                ]
            },
            {
                "id": 3619,
                "name": "Fresh Creek",
                "iso2": "FC",
                "latitude": "40.65437560",
                "longitude": "-73.89479390",
                "type": "district",
                "cities": []
            },
            {
                "id": 3597,
                "name": "Governor's Harbour",
                "iso2": "GH",
                "latitude": "25.19480960",
                "longitude": "-76.24396220",
                "type": "district",
                "cities": []
            },
            {
                "id": 3632,
                "name": "Grand Cay",
                "iso2": "GC",
                "latitude": "27.21626150",
                "longitude": "-78.32305590",
                "type": "district",
                "cities": []
            },
            {
                "id": 3595,
                "name": "Green Turtle Cay",
                "iso2": "GT",
                "latitude": "26.77471070",
                "longitude": "-77.32957080",
                "type": "district",
                "cities": []
            },
            {
                "id": 3613,
                "name": "Harbour Island",
                "iso2": "HI",
                "latitude": "25.50011000",
                "longitude": "-76.63405110",
                "type": "district",
                "cities": [
                    {
                        "id": 15694,
                        "name": "Dunmore Town",
                        "latitude": "25.50216000",
                        "longitude": "-76.63633000"
                    }
                ]
            },
            {
                "id": 3598,
                "name": "High Rock",
                "iso2": "HR",
                "latitude": "46.68434150",
                "longitude": "-121.90174610",
                "type": "district",
                "cities": []
            },
            {
                "id": 3624,
                "name": "Hope Town",
                "iso2": "HT",
                "latitude": "26.50095040",
                "longitude": "-76.99598720",
                "type": "district",
                "cities": []
            },
            {
                "id": 3609,
                "name": "Inagua",
                "iso2": "IN",
                "latitude": "21.06560660",
                "longitude": "-73.32370800",
                "type": "district",
                "cities": [
                    {
                        "id": 15700,
                        "name": "Matthew Town",
                        "latitude": "20.94982000",
                        "longitude": "-73.67346000"
                    }
                ]
            },
            {
                "id": 3618,
                "name": "Kemps Bay",
                "iso2": "KB",
                "latitude": "24.02364000",
                "longitude": "-77.54534900",
                "type": "district",
                "cities": []
            },
            {
                "id": 3610,
                "name": "Long Island",
                "iso2": "LI",
                "latitude": "40.78914200",
                "longitude": "-73.13496100",
                "type": "district",
                "cities": [
                    {
                        "id": 15689,
                        "name": "Clarence Town",
                        "latitude": "23.10000000",
                        "longitude": "-74.98333000"
                    }
                ]
            },
            {
                "id": 3625,
                "name": "Mangrove Cay",
                "iso2": "MC",
                "latitude": "24.14814250",
                "longitude": "-77.76809520",
                "type": "district",
                "cities": []
            },
            {
                "id": 3604,
                "name": "Marsh Harbour",
                "iso2": "MH",
                "latitude": "26.52416530",
                "longitude": "-77.09098090",
                "type": "district",
                "cities": []
            },
            {
                "id": 3633,
                "name": "Mayaguana",
                "iso2": "MG",
                "latitude": "22.40177140",
                "longitude": "-73.06413960",
                "type": "district",
                "cities": [
                    {
                        "id": 15685,
                        "name": "Abraham’s Bay",
                        "latitude": "22.36667000",
                        "longitude": "-72.96667000"
                    }
                ]
            },
            {
                "id": 4881,
                "name": "New Providence",
                "iso2": "NP",
                "latitude": "40.69843480",
                "longitude": "-74.40154050",
                "type": "island",
                "cities": [
                    {
                        "id": 143913,
                        "name": "Nassau",
                        "latitude": "25.06666667",
                        "longitude": "-77.33333333"
                    }
                ]
            },
            {
                "id": 3594,
                "name": "Nichollstown and Berry Islands",
                "iso2": "NB",
                "latitude": "25.72362340",
                "longitude": "-77.83101040",
                "type": "district",
                "cities": []
            },
            {
                "id": 3616,
                "name": "North Abaco",
                "iso2": "NO",
                "latitude": "26.78716970",
                "longitude": "-77.43577390",
                "type": "district",
                "cities": [
                    {
                        "id": 15692,
                        "name": "Cooper’s Town",
                        "latitude": "26.87137000",
                        "longitude": "-77.51131000"
                    }
                ]
            },
            {
                "id": 3617,
                "name": "North Andros",
                "iso2": "NS",
                "latitude": "24.70638050",
                "longitude": "-78.01953870",
                "type": "district",
                "cities": [
                    {
                        "id": 15687,
                        "name": "Andros Town",
                        "latitude": "24.70502000",
                        "longitude": "-77.76912000"
                    },
                    {
                        "id": 15702,
                        "name": "San Andros",
                        "latitude": "25.06667000",
                        "longitude": "-78.05000000"
                    }
                ]
            },
            {
                "id": 3602,
                "name": "North Eleuthera",
                "iso2": "NE",
                "latitude": "25.46475170",
                "longitude": "-76.67592200",
                "type": "district",
                "cities": []
            },
            {
                "id": 3615,
                "name": "Ragged Island",
                "iso2": "RI",
                "latitude": "41.59743100",
                "longitude": "-71.26020200",
                "type": "district",
                "cities": [
                    {
                        "id": 15693,
                        "name": "Duncan Town",
                        "latitude": "22.19083000",
                        "longitude": "-75.72583000"
                    }
                ]
            },
            {
                "id": 3623,
                "name": "Rock Sound",
                "iso2": "RS",
                "latitude": "39.01424430",
                "longitude": "-95.67089890",
                "type": "district",
                "cities": []
            },
            {
                "id": 3600,
                "name": "Rum Cay",
                "iso2": "RC",
                "latitude": "23.74581390",
                "longitude": "-75.29009800",
                "type": "district",
                "cities": [
                    {
                        "id": 15701,
                        "name": "Port Nelson",
                        "latitude": "23.64967000",
                        "longitude": "-74.84157000"
                    }
                ]
            },
            {
                "id": 3620,
                "name": "San Salvador and Rum Cay",
                "iso2": "SR",
                "latitude": "23.68546760",
                "longitude": "-74.83901620",
                "type": "district",
                "cities": []
            },
            {
                "id": 3627,
                "name": "San Salvador Island",
                "iso2": "SS",
                "latitude": "24.07755460",
                "longitude": "-74.47600880",
                "type": "district",
                "cities": [
                    {
                        "id": 15690,
                        "name": "Cockburn Town",
                        "latitude": "24.05179000",
                        "longitude": "-74.53138000"
                    }
                ]
            },
            {
                "id": 3606,
                "name": "Sandy Point",
                "iso2": "SP",
                "latitude": "39.01454640",
                "longitude": "-76.39989250",
                "type": "district",
                "cities": []
            },
            {
                "id": 3608,
                "name": "South Abaco",
                "iso2": "SO",
                "latitude": "26.06405910",
                "longitude": "-77.26350380",
                "type": "district",
                "cities": []
            },
            {
                "id": 3622,
                "name": "South Andros",
                "iso2": "SA",
                "latitude": "23.97135560",
                "longitude": "-77.60778650",
                "type": "district",
                "cities": []
            },
            {
                "id": 3607,
                "name": "South Eleuthera",
                "iso2": "SE",
                "latitude": "24.77085620",
                "longitude": "-76.21314740",
                "type": "district",
                "cities": []
            },
            {
                "id": 3630,
                "name": "Spanish Wells",
                "iso2": "SW",
                "latitude": "26.32505990",
                "longitude": "-81.79803280",
                "type": "district",
                "cities": [
                    {
                        "id": 15703,
                        "name": "Spanish Wells",
                        "latitude": "25.54717000",
                        "longitude": "-76.76405000"
                    }
                ]
            },
            {
                "id": 3599,
                "name": "West Grand Bahama",
                "iso2": "WG",
                "latitude": "26.65944700",
                "longitude": "-78.52065000",
                "type": "district",
                "cities": [
                    {
                        "id": 15704,
                        "name": "West End",
                        "latitude": "26.68711000",
                        "longitude": "-78.97702000"
                    }
                ]
            }
        ]
    },
    {
        "id": 80,
        "name": "The Gambia ",
        "iso3": "GMB",
        "iso2": "GM",
        "numeric_code": "270",
        "phonecode": "220",
        "capital": "Banjul",
        "currency": "GMD",
        "currency_name": "Gambian dalasi",
        "currency_symbol": "D",
        "tld": ".gm",
        "native": "Gambia",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Gambian",
        "timezones": [
            {
                "zoneName": "Africa\/Banjul",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Gambia",
            "ko": "감비아",
            "pt-BR": "Gâmbia",
            "pt": "Gâmbia",
            "nl": "Gambia",
            "hr": "Gambija",
            "fa": "گامبیا",
            "de": "Gambia",
            "es": "Gambia",
            "fr": "Gambie",
            "ja": "ガンビア",
            "it": "Gambia",
            "zh-CN": "冈比亚",
            "tr": "Gambiya",
            "ru": "Гамбия",
            "uk": "Гамбія The",
            "pl": "Gambia The"
        },
        "latitude": "13.46666666",
        "longitude": "-16.56666666",
        "emoji": "🇬🇲",
        "emojiU": "U+1F1EC U+1F1F2",
        "states": [
            {
                "id": 2666,
                "name": "Banjul",
                "iso2": "B",
                "latitude": "13.45487610",
                "longitude": "-16.57903230",
                "type": "city",
                "cities": [
                    {
                        "id": 52219,
                        "name": "Bakau",
                        "latitude": "13.47806000",
                        "longitude": "-16.68194000"
                    },
                    {
                        "id": 52221,
                        "name": "Banjul",
                        "latitude": "13.45274000",
                        "longitude": "-16.57803000"
                    },
                    {
                        "id": 52277,
                        "name": "Kombo Saint Mary District",
                        "latitude": "13.44389000",
                        "longitude": "-16.64583000"
                    },
                    {
                        "id": 52304,
                        "name": "Serekunda",
                        "latitude": "13.43833000",
                        "longitude": "-16.67806000"
                    }
                ]
            },
            {
                "id": 2669,
                "name": "Central River",
                "iso2": "M",
                "latitude": "13.59944690",
                "longitude": "-14.89216680",
                "type": "division",
                "cities": [
                    {
                        "id": 52222,
                        "name": "Bansang",
                        "latitude": "13.43333000",
                        "longitude": "-14.65000000"
                    },
                    {
                        "id": 52228,
                        "name": "Brikama Nding",
                        "latitude": "13.53333000",
                        "longitude": "-14.93333000"
                    },
                    {
                        "id": 52233,
                        "name": "Dankunku",
                        "latitude": "13.56667000",
                        "longitude": "-15.31667000"
                    },
                    {
                        "id": 52236,
                        "name": "Denton",
                        "latitude": "13.50000000",
                        "longitude": "-14.93333000"
                    },
                    {
                        "id": 52246,
                        "name": "Fulladu West",
                        "latitude": "13.50000000",
                        "longitude": "-14.75000000"
                    },
                    {
                        "id": 52247,
                        "name": "Galleh Manda",
                        "latitude": "13.43333000",
                        "longitude": "-14.78333000"
                    },
                    {
                        "id": 52248,
                        "name": "Georgetown",
                        "latitude": "13.54039000",
                        "longitude": "-14.76374000"
                    },
                    {
                        "id": 52252,
                        "name": "Jakhaly",
                        "latitude": "13.55000000",
                        "longitude": "-14.96667000"
                    },
                    {
                        "id": 52254,
                        "name": "Janjanbureh",
                        "latitude": "13.53564000",
                        "longitude": "-14.76515000"
                    },
                    {
                        "id": 52258,
                        "name": "Jarreng",
                        "latitude": "13.61667000",
                        "longitude": "-15.18333000"
                    },
                    {
                        "id": 52265,
                        "name": "Karantaba",
                        "latitude": "13.66667000",
                        "longitude": "-15.03333000"
                    },
                    {
                        "id": 52266,
                        "name": "Kass Wollof",
                        "latitude": "13.78333000",
                        "longitude": "-14.93333000"
                    },
                    {
                        "id": 52280,
                        "name": "Kuntaur",
                        "latitude": "13.67085000",
                        "longitude": "-14.88977000"
                    },
                    {
                        "id": 52281,
                        "name": "Kunting",
                        "latitude": "13.53333000",
                        "longitude": "-14.66667000"
                    },
                    {
                        "id": 52285,
                        "name": "Lower Saloum",
                        "latitude": "13.71667000",
                        "longitude": "-15.36667000"
                    },
                    {
                        "id": 52287,
                        "name": "Niamina East District",
                        "latitude": "13.63333000",
                        "longitude": "-15.08333000"
                    },
                    {
                        "id": 52288,
                        "name": "Niamina West District",
                        "latitude": "13.58333000",
                        "longitude": "-15.25000000"
                    },
                    {
                        "id": 52289,
                        "name": "Niani",
                        "latitude": "13.66667000",
                        "longitude": "-14.91667000"
                    },
                    {
                        "id": 52290,
                        "name": "Nianija District",
                        "latitude": "13.72900000",
                        "longitude": "-15.09100000"
                    },
                    {
                        "id": 52294,
                        "name": "Pateh Sam",
                        "latitude": "13.61667000",
                        "longitude": "-15.06667000"
                    },
                    {
                        "id": 52298,
                        "name": "Sami",
                        "latitude": "13.58333000",
                        "longitude": "-15.20000000"
                    },
                    {
                        "id": 52299,
                        "name": "Sami District",
                        "latitude": "13.58333000",
                        "longitude": "-14.58333000"
                    },
                    {
                        "id": 52303,
                        "name": "Saruja",
                        "latitude": "13.55000000",
                        "longitude": "-14.91667000"
                    },
                    {
                        "id": 52309,
                        "name": "Sukuta",
                        "latitude": "13.61667000",
                        "longitude": "-14.91667000"
                    },
                    {
                        "id": 52317,
                        "name": "Upper Saloum",
                        "latitude": "13.75000000",
                        "longitude": "-15.20000000"
                    },
                    {
                        "id": 52318,
                        "name": "Wassu",
                        "latitude": "13.69094000",
                        "longitude": "-14.87884000"
                    }
                ]
            },
            {
                "id": 2670,
                "name": "Lower River",
                "iso2": "L",
                "latitude": "13.35533060",
                "longitude": "-15.92299000",
                "type": "division",
                "cities": [
                    {
                        "id": 52223,
                        "name": "Baro Kunda",
                        "latitude": "13.48333000",
                        "longitude": "-15.26667000"
                    },
                    {
                        "id": 52229,
                        "name": "Bureng",
                        "latitude": "13.41667000",
                        "longitude": "-15.28333000"
                    },
                    {
                        "id": 52253,
                        "name": "Jali",
                        "latitude": "13.35000000",
                        "longitude": "-15.96667000"
                    },
                    {
                        "id": 52255,
                        "name": "Jarra Central",
                        "latitude": "13.41667000",
                        "longitude": "-15.41667000"
                    },
                    {
                        "id": 52256,
                        "name": "Jarra East",
                        "latitude": "13.41667000",
                        "longitude": "-15.25000000"
                    },
                    {
                        "id": 52257,
                        "name": "Jarra West",
                        "latitude": "13.41667000",
                        "longitude": "-15.53333000"
                    },
                    {
                        "id": 52259,
                        "name": "Jenoi",
                        "latitude": "13.48333000",
                        "longitude": "-15.56667000"
                    },
                    {
                        "id": 52260,
                        "name": "Jifarong",
                        "latitude": "13.30000000",
                        "longitude": "-15.86667000"
                    },
                    {
                        "id": 52262,
                        "name": "Kaiaf",
                        "latitude": "13.40000000",
                        "longitude": "-15.61667000"
                    },
                    {
                        "id": 52264,
                        "name": "Karantaba",
                        "latitude": "13.43333000",
                        "longitude": "-15.51667000"
                    },
                    {
                        "id": 52268,
                        "name": "Keneba",
                        "latitude": "13.32889000",
                        "longitude": "-16.01500000"
                    },
                    {
                        "id": 52270,
                        "name": "Kiang Central",
                        "latitude": "13.40000000",
                        "longitude": "-15.75000000"
                    },
                    {
                        "id": 52271,
                        "name": "Kiang East",
                        "latitude": "13.41667000",
                        "longitude": "-15.63333000"
                    },
                    {
                        "id": 52272,
                        "name": "Kiang West District",
                        "latitude": "13.33333000",
                        "longitude": "-16.00000000"
                    },
                    {
                        "id": 52286,
                        "name": "Mansa Konko",
                        "latitude": "13.44325000",
                        "longitude": "-15.53570000"
                    },
                    {
                        "id": 52291,
                        "name": "Nioro",
                        "latitude": "13.35000000",
                        "longitude": "-15.75000000"
                    },
                    {
                        "id": 52301,
                        "name": "Sankwia",
                        "latitude": "13.46667000",
                        "longitude": "-15.51667000"
                    },
                    {
                        "id": 52305,
                        "name": "Si Kunda",
                        "latitude": "13.43333000",
                        "longitude": "-15.56667000"
                    },
                    {
                        "id": 52306,
                        "name": "Soma",
                        "latitude": "13.43333000",
                        "longitude": "-15.53333000"
                    },
                    {
                        "id": 52313,
                        "name": "Sutukung",
                        "latitude": "13.46667000",
                        "longitude": "-15.26667000"
                    },
                    {
                        "id": 52314,
                        "name": "Toniataba",
                        "latitude": "13.43333000",
                        "longitude": "-15.58333000"
                    },
                    {
                        "id": 52319,
                        "name": "Wellingara Ba",
                        "latitude": "13.41667000",
                        "longitude": "-15.40000000"
                    }
                ]
            },
            {
                "id": 2671,
                "name": "North Bank",
                "iso2": "N",
                "latitude": "13.52854360",
                "longitude": "-16.01699710",
                "type": "division",
                "cities": [
                    {
                        "id": 52220,
                        "name": "Bambali",
                        "latitude": "13.48333000",
                        "longitude": "-15.33333000"
                    },
                    {
                        "id": 52224,
                        "name": "Barra",
                        "latitude": "13.48278000",
                        "longitude": "-16.54556000"
                    },
                    {
                        "id": 52230,
                        "name": "Central Baddibu",
                        "latitude": "13.53333000",
                        "longitude": "-15.91667000"
                    },
                    {
                        "id": 52231,
                        "name": "Chilla",
                        "latitude": "13.55000000",
                        "longitude": "-16.28333000"
                    },
                    {
                        "id": 52234,
                        "name": "Daru Rilwan",
                        "latitude": "13.55000000",
                        "longitude": "-15.98333000"
                    },
                    {
                        "id": 52239,
                        "name": "Essau",
                        "latitude": "13.48389000",
                        "longitude": "-16.53472000"
                    },
                    {
                        "id": 52240,
                        "name": "Farafenni",
                        "latitude": "13.56667000",
                        "longitude": "-15.60000000"
                    },
                    {
                        "id": 52250,
                        "name": "Gunjur",
                        "latitude": "13.52278000",
                        "longitude": "-16.02778000"
                    },
                    {
                        "id": 52261,
                        "name": "Jokadu",
                        "latitude": "13.53333000",
                        "longitude": "-16.18333000"
                    },
                    {
                        "id": 52267,
                        "name": "Katchang",
                        "latitude": "13.50000000",
                        "longitude": "-15.75000000"
                    },
                    {
                        "id": 52269,
                        "name": "Kerewan",
                        "latitude": "13.48980000",
                        "longitude": "-16.08879000"
                    },
                    {
                        "id": 52282,
                        "name": "Lamin",
                        "latitude": "13.35222000",
                        "longitude": "-16.43389000"
                    },
                    {
                        "id": 52283,
                        "name": "Lower Baddibu District",
                        "latitude": "13.50000000",
                        "longitude": "-16.05000000"
                    },
                    {
                        "id": 52284,
                        "name": "Lower Niumi District",
                        "latitude": "13.53333000",
                        "longitude": "-16.41667000"
                    },
                    {
                        "id": 52292,
                        "name": "No Kunda",
                        "latitude": "13.56667000",
                        "longitude": "-15.83333000"
                    },
                    {
                        "id": 52296,
                        "name": "Saba",
                        "latitude": "13.51639000",
                        "longitude": "-16.04917000"
                    },
                    {
                        "id": 52302,
                        "name": "Sara Kunda",
                        "latitude": "13.53333000",
                        "longitude": "-15.41667000"
                    },
                    {
                        "id": 52315,
                        "name": "Upper Baddibu",
                        "latitude": "13.55000000",
                        "longitude": "-15.66667000"
                    },
                    {
                        "id": 52316,
                        "name": "Upper Niumi District",
                        "latitude": "13.40000000",
                        "longitude": "-16.33333000"
                    }
                ]
            },
            {
                "id": 2668,
                "name": "Upper River",
                "iso2": "U",
                "latitude": "13.42573660",
                "longitude": "-14.00723480",
                "type": "division",
                "cities": [
                    {
                        "id": 52218,
                        "name": "Bakadagy",
                        "latitude": "13.30000000",
                        "longitude": "-14.38333000"
                    },
                    {
                        "id": 52225,
                        "name": "Basse Santa Su",
                        "latitude": "13.30995000",
                        "longitude": "-14.21373000"
                    },
                    {
                        "id": 52226,
                        "name": "Brifu",
                        "latitude": "13.50000000",
                        "longitude": "-13.93333000"
                    },
                    {
                        "id": 52232,
                        "name": "Daba Kunda",
                        "latitude": "13.31667000",
                        "longitude": "-14.30000000"
                    },
                    {
                        "id": 52235,
                        "name": "Demba Kunda",
                        "latitude": "13.25000000",
                        "longitude": "-14.26667000"
                    },
                    {
                        "id": 52237,
                        "name": "Diabugu",
                        "latitude": "13.38333000",
                        "longitude": "-14.40000000"
                    },
                    {
                        "id": 52238,
                        "name": "Diabugu Basilla",
                        "latitude": "13.33333000",
                        "longitude": "-13.95000000"
                    },
                    {
                        "id": 52245,
                        "name": "Fulladu East",
                        "latitude": "13.33333000",
                        "longitude": "-14.25000000"
                    },
                    {
                        "id": 52251,
                        "name": "Gunjur Kuta",
                        "latitude": "13.53333000",
                        "longitude": "-14.11667000"
                    },
                    {
                        "id": 52263,
                        "name": "Kantora",
                        "latitude": "13.41667000",
                        "longitude": "-13.91667000"
                    },
                    {
                        "id": 52273,
                        "name": "Koina",
                        "latitude": "13.48333000",
                        "longitude": "-13.86667000"
                    },
                    {
                        "id": 52279,
                        "name": "Kumbija",
                        "latitude": "13.26667000",
                        "longitude": "-14.18333000"
                    },
                    {
                        "id": 52293,
                        "name": "Nyamanari",
                        "latitude": "13.33333000",
                        "longitude": "-13.86667000"
                    },
                    {
                        "id": 52295,
                        "name": "Perai",
                        "latitude": "13.38333000",
                        "longitude": "-14.03333000"
                    },
                    {
                        "id": 52297,
                        "name": "Sabi",
                        "latitude": "13.23333000",
                        "longitude": "-14.20000000"
                    },
                    {
                        "id": 52300,
                        "name": "Sandu",
                        "latitude": "13.41667000",
                        "longitude": "-14.36667000"
                    },
                    {
                        "id": 52308,
                        "name": "Sudowol",
                        "latitude": "13.36667000",
                        "longitude": "-13.96667000"
                    },
                    {
                        "id": 52311,
                        "name": "Sun Kunda",
                        "latitude": "13.38333000",
                        "longitude": "-13.85000000"
                    },
                    {
                        "id": 52312,
                        "name": "Sutukoba",
                        "latitude": "13.50000000",
                        "longitude": "-14.01667000"
                    },
                    {
                        "id": 52320,
                        "name": "Wuli",
                        "latitude": "13.50000000",
                        "longitude": "-14.08333000"
                    }
                ]
            },
            {
                "id": 2667,
                "name": "West Coast",
                "iso2": "W",
                "latitude": "5.97727980",
                "longitude": "116.07542880",
                "type": "division",
                "cities": [
                    {
                        "id": 52217,
                        "name": "Abuko",
                        "latitude": "13.40417000",
                        "longitude": "-16.65583000"
                    },
                    {
                        "id": 52227,
                        "name": "Brikama",
                        "latitude": "13.27136000",
                        "longitude": "-16.64944000"
                    },
                    {
                        "id": 52241,
                        "name": "Foni Bondali",
                        "latitude": "13.21667000",
                        "longitude": "-15.93333000"
                    },
                    {
                        "id": 52242,
                        "name": "Foni Brefet",
                        "latitude": "13.21667000",
                        "longitude": "-16.33333000"
                    },
                    {
                        "id": 52243,
                        "name": "Foni Jarrol",
                        "latitude": "13.23333000",
                        "longitude": "-15.83333000"
                    },
                    {
                        "id": 52244,
                        "name": "Foni Kansala",
                        "latitude": "13.21667000",
                        "longitude": "-16.05000000"
                    },
                    {
                        "id": 52249,
                        "name": "Gunjur",
                        "latitude": "13.20194000",
                        "longitude": "-16.73389000"
                    },
                    {
                        "id": 52274,
                        "name": "Kombo Central District",
                        "latitude": "13.25000000",
                        "longitude": "-16.66667000"
                    },
                    {
                        "id": 52275,
                        "name": "Kombo East District",
                        "latitude": "13.21667000",
                        "longitude": "-16.51667000"
                    },
                    {
                        "id": 52276,
                        "name": "Kombo North District",
                        "latitude": "13.36667000",
                        "longitude": "-16.66667000"
                    },
                    {
                        "id": 52278,
                        "name": "Kombo South District",
                        "latitude": "13.25000000",
                        "longitude": "-16.75000000"
                    },
                    {
                        "id": 52307,
                        "name": "Somita",
                        "latitude": "13.20583000",
                        "longitude": "-16.30556000"
                    },
                    {
                        "id": 52310,
                        "name": "Sukuta",
                        "latitude": "13.41033000",
                        "longitude": "-16.70815000"
                    }
                ]
            }
        ]
    },
    {
        "id": 63,
        "name": "Timor-Leste",
        "iso3": "TLS",
        "iso2": "TL",
        "numeric_code": "626",
        "phonecode": "670",
        "capital": "Dili",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".tl",
        "native": "Timor-Leste",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Timorese",
        "timezones": [
            {
                "zoneName": "Asia\/Dili",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "TLT",
                "tzName": "Timor Leste Time"
            }
        ],
        "translations": {
            "br": "Timor ar Reter",
            "ko": "동티모르",
            "pt-BR": "Timor Leste",
            "pt": "Timor Leste",
            "nl": "Oost-Timor",
            "hr": "Istočni Timor",
            "fa": "تیمور شرقی",
            "de": "Timor-Leste",
            "es": "Timor Oriental",
            "fr": "Timor oriental",
            "ja": "東ティモール",
            "it": "Timor Est",
            "zh-CN": "东帝汶",
            "tr": "Doğu Timor",
            "ru": "Тимор-Лешти",
            "uk": "Тимор-Лешті",
            "pl": "Timor Wschodni"
        },
        "latitude": "-8.83333333",
        "longitude": "125.91666666",
        "emoji": "🇹🇱",
        "emojiU": "U+1F1F9 U+1F1F1",
        "states": [
            {
                "id": 4520,
                "name": "Aileu",
                "iso2": "AL",
                "latitude": "-8.70439940",
                "longitude": "125.60954740",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106830,
                        "name": "Aileu",
                        "latitude": "-8.72806000",
                        "longitude": "125.56639000"
                    },
                    {
                        "id": 106854,
                        "name": "Lequidoe",
                        "latitude": "-8.69139000",
                        "longitude": "125.63611000"
                    },
                    {
                        "id": 106868,
                        "name": "Remexio",
                        "latitude": "-8.61667000",
                        "longitude": "125.66667000"
                    }
                ]
            },
            {
                "id": 4518,
                "name": "Ainaro",
                "iso2": "AN",
                "latitude": "-9.01131710",
                "longitude": "125.52200120",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106831,
                        "name": "Ainaro",
                        "latitude": "-8.99241000",
                        "longitude": "125.50816000"
                    },
                    {
                        "id": 106846,
                        "name": "Hato-Udo",
                        "latitude": "-9.12036000",
                        "longitude": "125.58935000"
                    }
                ]
            },
            {
                "id": 4521,
                "name": "Baucau",
                "iso2": "BA",
                "latitude": "-8.47143080",
                "longitude": "126.45759910",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106834,
                        "name": "Baguia",
                        "latitude": "-8.62787000",
                        "longitude": "126.65743000"
                    },
                    {
                        "id": 106836,
                        "name": "Baucau",
                        "latitude": "-8.46667000",
                        "longitude": "126.45000000"
                    },
                    {
                        "id": 106837,
                        "name": "Baukau",
                        "latitude": "-8.47572000",
                        "longitude": "126.45633000"
                    },
                    {
                        "id": 106852,
                        "name": "Laga",
                        "latitude": "-8.47411000",
                        "longitude": "126.59228000"
                    },
                    {
                        "id": 106866,
                        "name": "Quelicai",
                        "latitude": "-8.60135000",
                        "longitude": "126.55904000"
                    },
                    {
                        "id": 106877,
                        "name": "Vemasse",
                        "latitude": "-8.51036000",
                        "longitude": "126.20823000"
                    },
                    {
                        "id": 106878,
                        "name": "Venilale",
                        "latitude": "-8.64306000",
                        "longitude": "126.37833000"
                    }
                ]
            },
            {
                "id": 4525,
                "name": "Bobonaro",
                "iso2": "BO",
                "latitude": "-8.96554060",
                "longitude": "125.25879640",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106859,
                        "name": "Maliana",
                        "latitude": "-8.99167000",
                        "longitude": "125.21972000"
                    }
                ]
            },
            {
                "id": 4522,
                "name": "Cova Lima",
                "iso2": "CO",
                "latitude": "-9.26503750",
                "longitude": "125.25879640",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106843,
                        "name": "Fatumean",
                        "latitude": "-9.22917000",
                        "longitude": "125.03583000"
                    },
                    {
                        "id": 106844,
                        "name": "Fohorem",
                        "latitude": "-9.28361000",
                        "longitude": "125.08944000"
                    },
                    {
                        "id": 106863,
                        "name": "Maucatar",
                        "latitude": "-9.21772000",
                        "longitude": "125.22981000"
                    },
                    {
                        "id": 106871,
                        "name": "Suai",
                        "latitude": "-9.30000000",
                        "longitude": "125.25000000"
                    },
                    {
                        "id": 106872,
                        "name": "Tilomar",
                        "latitude": "-9.34182000",
                        "longitude": "125.10887000"
                    }
                ]
            },
            {
                "id": 4524,
                "name": "Dili",
                "iso2": "DI",
                "latitude": "-8.24496130",
                "longitude": "125.58766970",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106833,
                        "name": "Atauro Island",
                        "latitude": "-8.26785000",
                        "longitude": "125.59699000"
                    },
                    {
                        "id": 106839,
                        "name": "Cristo Rei",
                        "latitude": "-8.52047000",
                        "longitude": "125.60837000"
                    },
                    {
                        "id": 106840,
                        "name": "Dili",
                        "latitude": "-8.55861000",
                        "longitude": "125.57361000"
                    },
                    {
                        "id": 106864,
                        "name": "Metinaro",
                        "latitude": "-8.53007000",
                        "longitude": "125.74163000"
                    }
                ]
            },
            {
                "id": 4516,
                "name": "Ermera",
                "iso2": "ER",
                "latitude": "-8.75248020",
                "longitude": "125.39872940",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106841,
                        "name": "Ermera Villa",
                        "latitude": "-8.75222000",
                        "longitude": "125.39694000"
                    },
                    {
                        "id": 106845,
                        "name": "Gleno",
                        "latitude": "-8.72389000",
                        "longitude": "125.43611000"
                    },
                    {
                        "id": 106847,
                        "name": "Hatulia",
                        "latitude": "-8.81667000",
                        "longitude": "125.31667000"
                    },
                    {
                        "id": 106855,
                        "name": "Letefoho",
                        "latitude": "-8.83444000",
                        "longitude": "125.42639000"
                    },
                    {
                        "id": 106867,
                        "name": "Railaco",
                        "latitude": "-8.67237000",
                        "longitude": "125.42546000"
                    }
                ]
            },
            {
                "id": 4523,
                "name": "Lautém",
                "iso2": "LA",
                "latitude": "-8.36423070",
                "longitude": "126.90438450",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106848,
                        "name": "Iliomar",
                        "latitude": "-8.70917000",
                        "longitude": "126.82833000"
                    },
                    {
                        "id": 106853,
                        "name": "Lautem",
                        "latitude": "-8.36514000",
                        "longitude": "126.90389000"
                    },
                    {
                        "id": 106857,
                        "name": "Lospalos",
                        "latitude": "-8.52167000",
                        "longitude": "126.99833000"
                    },
                    {
                        "id": 106858,
                        "name": "Luro",
                        "latitude": "-8.54359000",
                        "longitude": "126.83003000"
                    },
                    {
                        "id": 106874,
                        "name": "Tutuala",
                        "latitude": "-8.39597000",
                        "longitude": "127.25923000"
                    }
                ]
            },
            {
                "id": 4515,
                "name": "Liquiçá",
                "iso2": "LI",
                "latitude": "-8.66740950",
                "longitude": "125.25879640",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106838,
                        "name": "Bazartete",
                        "latitude": "-8.62464000",
                        "longitude": "125.38168000"
                    },
                    {
                        "id": 106856,
                        "name": "Likisá",
                        "latitude": "-8.58750000",
                        "longitude": "125.34194000"
                    },
                    {
                        "id": 106862,
                        "name": "Maubara",
                        "latitude": "-8.61194000",
                        "longitude": "125.20611000"
                    }
                ]
            },
            {
                "id": 4517,
                "name": "Manatuto",
                "iso2": "MT",
                "latitude": "-8.51556080",
                "longitude": "126.01592550",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106835,
                        "name": "Barique",
                        "latitude": "-8.85472000",
                        "longitude": "126.06556000"
                    },
                    {
                        "id": 106849,
                        "name": "Laclo",
                        "latitude": "-8.55000000",
                        "longitude": "125.91667000"
                    },
                    {
                        "id": 106850,
                        "name": "Laclubar",
                        "latitude": "-8.74975000",
                        "longitude": "125.91186000"
                    },
                    {
                        "id": 106860,
                        "name": "Manatuto",
                        "latitude": "-8.52207000",
                        "longitude": "126.01516000"
                    },
                    {
                        "id": 106861,
                        "name": "Manatutu",
                        "latitude": "-8.51139000",
                        "longitude": "126.01306000"
                    },
                    {
                        "id": 106870,
                        "name": "Soibada",
                        "latitude": "-8.86000000",
                        "longitude": "125.94000000"
                    }
                ]
            },
            {
                "id": 4519,
                "name": "Manufahi",
                "iso2": "MF",
                "latitude": "-9.01454950",
                "longitude": "125.82799590",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106832,
                        "name": "Alas",
                        "latitude": "-9.02730000",
                        "longitude": "125.78680000"
                    },
                    {
                        "id": 106842,
                        "name": "Fatuberliu",
                        "latitude": "-8.94790000",
                        "longitude": "125.86633000"
                    },
                    {
                        "id": 106869,
                        "name": "Same",
                        "latitude": "-9.00000000",
                        "longitude": "125.65000000"
                    },
                    {
                        "id": 106873,
                        "name": "Turiscai",
                        "latitude": "-8.82371000",
                        "longitude": "125.70454000"
                    }
                ]
            },
            {
                "id": 4514,
                "name": "Viqueque",
                "iso2": "VI",
                "latitude": "-8.85979180",
                "longitude": "126.36335160",
                "type": "municipality",
                "cities": [
                    {
                        "id": 106851,
                        "name": "Lacluta",
                        "latitude": "-8.80000000",
                        "longitude": "126.13333000"
                    },
                    {
                        "id": 106865,
                        "name": "Ossu",
                        "latitude": "-8.73477000",
                        "longitude": "126.38324000"
                    },
                    {
                        "id": 106875,
                        "name": "Uatocarabau",
                        "latitude": "-8.75658000",
                        "longitude": "126.68060000"
                    },
                    {
                        "id": 106876,
                        "name": "Uatolari",
                        "latitude": "-8.76277000",
                        "longitude": "126.57353000"
                    },
                    {
                        "id": 106879,
                        "name": "Viqueque",
                        "latitude": "-8.85908000",
                        "longitude": "126.36972000"
                    }
                ]
            }
        ]
    },
    {
        "id": 220,
        "name": "Togo",
        "iso3": "TGO",
        "iso2": "TG",
        "numeric_code": "768",
        "phonecode": "228",
        "capital": "Lome",
        "currency": "XOF",
        "currency_name": "West African CFA franc",
        "currency_symbol": "CFA",
        "tld": ".tg",
        "native": "Togo",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Western Africa",
        "subregion_id": 3,
        "nationality": "Togolese",
        "timezones": [
            {
                "zoneName": "Africa\/Lome",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Togo",
            "ko": "토고",
            "pt-BR": "Togo",
            "pt": "Togo",
            "nl": "Togo",
            "hr": "Togo",
            "fa": "توگو",
            "de": "Togo",
            "es": "Togo",
            "fr": "Togo",
            "ja": "トーゴ",
            "it": "Togo",
            "zh-CN": "多哥",
            "tr": "Togo",
            "ru": "Того",
            "uk": "Того",
            "pl": "Togo"
        },
        "latitude": "8.00000000",
        "longitude": "1.16666666",
        "emoji": "🇹🇬",
        "emojiU": "U+1F1F9 U+1F1EC",
        "states": [
            {
                "id": 2575,
                "name": "Centrale",
                "iso2": "C",
                "latitude": "8.65860290",
                "longitude": "1.05861350",
                "type": "region",
                "cities": [
                    {
                        "id": 105173,
                        "name": "Sokodé",
                        "latitude": "8.98333000",
                        "longitude": "1.13333000"
                    },
                    {
                        "id": 105174,
                        "name": "Sotouboua",
                        "latitude": "8.56340000",
                        "longitude": "0.98399000"
                    },
                    {
                        "id": 105176,
                        "name": "Tchamba",
                        "latitude": "9.03333000",
                        "longitude": "1.41667000"
                    }
                ]
            },
            {
                "id": 2579,
                "name": "Kara",
                "iso2": "K",
                "latitude": "9.72163930",
                "longitude": "1.05861350",
                "type": "region",
                "cities": [
                    {
                        "id": 105161,
                        "name": "Bafilo",
                        "latitude": "9.35000000",
                        "longitude": "1.26667000"
                    },
                    {
                        "id": 105162,
                        "name": "Bassar",
                        "latitude": "9.25025000",
                        "longitude": "0.78213000"
                    },
                    {
                        "id": 105164,
                        "name": "Kandé",
                        "latitude": "9.95778000",
                        "longitude": "1.04472000"
                    },
                    {
                        "id": 105165,
                        "name": "Kara",
                        "latitude": "9.55111000",
                        "longitude": "1.18611000"
                    },
                    {
                        "id": 105168,
                        "name": "Niamtougou",
                        "latitude": "9.76806000",
                        "longitude": "1.10528000"
                    },
                    {
                        "id": 105170,
                        "name": "Pagouda",
                        "latitude": "9.75250000",
                        "longitude": "1.32778000"
                    },
                    {
                        "id": 105171,
                        "name": "Préfecture de Bassar",
                        "latitude": "9.25000000",
                        "longitude": "0.75000000"
                    }
                ]
            },
            {
                "id": 2576,
                "name": "Maritime",
                "iso2": "M",
                "latitude": "41.65514930",
                "longitude": "-83.52784670",
                "type": "region",
                "cities": [
                    {
                        "id": 105158,
                        "name": "Aného",
                        "latitude": "6.22798000",
                        "longitude": "1.59190000"
                    },
                    {
                        "id": 105167,
                        "name": "Lomé",
                        "latitude": "6.12874000",
                        "longitude": "1.22154000"
                    },
                    {
                        "id": 105175,
                        "name": "Tabligbo",
                        "latitude": "6.58333000",
                        "longitude": "1.50000000"
                    },
                    {
                        "id": 105177,
                        "name": "Tsévié",
                        "latitude": "6.42611000",
                        "longitude": "1.21333000"
                    },
                    {
                        "id": 105178,
                        "name": "Vogan",
                        "latitude": "6.33333000",
                        "longitude": "1.53333000"
                    }
                ]
            },
            {
                "id": 2577,
                "name": "Plateaux",
                "iso2": "P",
                "latitude": "7.61013780",
                "longitude": "1.05861350",
                "type": "region",
                "cities": [
                    {
                        "id": 105157,
                        "name": "Amlamé",
                        "latitude": "7.46667000",
                        "longitude": "0.90000000"
                    },
                    {
                        "id": 105159,
                        "name": "Atakpamé",
                        "latitude": "7.53333000",
                        "longitude": "1.13333000"
                    },
                    {
                        "id": 105160,
                        "name": "Badou",
                        "latitude": "7.58333000",
                        "longitude": "0.60000000"
                    },
                    {
                        "id": 105166,
                        "name": "Kpalimé",
                        "latitude": "6.90000000",
                        "longitude": "0.63333000"
                    },
                    {
                        "id": 105169,
                        "name": "Notsé",
                        "latitude": "6.95000000",
                        "longitude": "1.16667000"
                    }
                ]
            },
            {
                "id": 2578,
                "name": "Savanes",
                "iso2": "S",
                "latitude": "10.52917810",
                "longitude": "0.52578230",
                "type": "region",
                "cities": [
                    {
                        "id": 105163,
                        "name": "Dapaong",
                        "latitude": "10.86225000",
                        "longitude": "0.20762000"
                    },
                    {
                        "id": 105172,
                        "name": "Sansanné-Mango",
                        "latitude": "10.35917000",
                        "longitude": "0.47083000"
                    }
                ]
            }
        ]
    },
    {
        "id": 221,
        "name": "Tokelau",
        "iso3": "TKL",
        "iso2": "TK",
        "numeric_code": "772",
        "phonecode": "690",
        "capital": "",
        "currency": "NZD",
        "currency_name": "New Zealand dollar",
        "currency_symbol": "$",
        "tld": ".tk",
        "native": "Tokelau",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Polynesia",
        "subregion_id": 22,
        "nationality": "Tokelauan",
        "timezones": [
            {
                "zoneName": "Pacific\/Fakaofo",
                "gmtOffset": 46800,
                "gmtOffsetName": "UTC+13:00",
                "abbreviation": "TKT",
                "tzName": "Tokelau Time"
            }
        ],
        "translations": {
            "br": "Tokelau",
            "ko": "토켈라우",
            "pt-BR": "Tokelau",
            "pt": "Toquelau",
            "nl": "Tokelau",
            "hr": "Tokelau",
            "fa": "توکلائو",
            "de": "Tokelau",
            "es": "Islas Tokelau",
            "fr": "Tokelau",
            "ja": "トケラウ",
            "it": "Isole Tokelau",
            "zh-CN": "托克劳",
            "tr": "Tokelau",
            "ru": "Токелау",
            "uk": "Токелау",
            "pl": "Tokelau"
        },
        "latitude": "-9.00000000",
        "longitude": "-172.00000000",
        "emoji": "🇹🇰",
        "emojiU": "U+1F1F9 U+1F1F0",
        "states": []
    },
    {
        "id": 222,
        "name": "Tonga",
        "iso3": "TON",
        "iso2": "TO",
        "numeric_code": "776",
        "phonecode": "676",
        "capital": "Nuku'alofa",
        "currency": "TOP",
        "currency_name": "Tongan paʻanga",
        "currency_symbol": "$",
        "tld": ".to",
        "native": "Tonga",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Polynesia",
        "subregion_id": 22,
        "nationality": "Tongan",
        "timezones": [
            {
                "zoneName": "Pacific\/Tongatapu",
                "gmtOffset": 46800,
                "gmtOffsetName": "UTC+13:00",
                "abbreviation": "TOT",
                "tzName": "Tonga Time"
            }
        ],
        "translations": {
            "br": "Tonga",
            "ko": "통가",
            "pt-BR": "Tonga",
            "pt": "Tonga",
            "nl": "Tonga",
            "hr": "Tonga",
            "fa": "تونگا",
            "de": "Tonga",
            "es": "Tonga",
            "fr": "Tonga",
            "ja": "トンガ",
            "it": "Tonga",
            "zh-CN": "汤加",
            "tr": "Tonga",
            "ru": "Тонга",
            "uk": "Тонга",
            "pl": "Tonga"
        },
        "latitude": "-20.00000000",
        "longitude": "-175.00000000",
        "emoji": "🇹🇴",
        "emojiU": "U+1F1F9 U+1F1F4",
        "states": [
            {
                "id": 3913,
                "name": "Haʻapai",
                "iso2": "02",
                "latitude": "-19.75000000",
                "longitude": "-174.36666700",
                "type": "division",
                "cities": [
                    {
                        "id": 107049,
                        "name": "Pangai",
                        "latitude": "-19.81468000",
                        "longitude": "-174.35423000"
                    }
                ]
            },
            {
                "id": 3915,
                "name": "ʻEua",
                "iso2": "01",
                "latitude": "-21.37041460",
                "longitude": "-175.02012900",
                "type": "division",
                "cities": [
                    {
                        "id": 107051,
                        "name": "‘Ohonua",
                        "latitude": "-21.33333000",
                        "longitude": "-174.95000000"
                    }
                ]
            },
            {
                "id": 3914,
                "name": "Niuas",
                "iso2": "03",
                "latitude": "-15.95940000",
                "longitude": "-173.78300000",
                "type": "division",
                "cities": [
                    {
                        "id": 107045,
                        "name": "Hihifo",
                        "latitude": "-15.95440000",
                        "longitude": "-173.79616000"
                    }
                ]
            },
            {
                "id": 3912,
                "name": "Tongatapu",
                "iso2": "04",
                "latitude": "-21.14659680",
                "longitude": "-175.25154820",
                "type": "division",
                "cities": [
                    {
                        "id": 107044,
                        "name": "Haveluloto",
                        "latitude": "-21.15216000",
                        "longitude": "-175.21333000"
                    },
                    {
                        "id": 107046,
                        "name": "Kolonga",
                        "latitude": "-21.13333000",
                        "longitude": "-175.06667000"
                    },
                    {
                        "id": 107048,
                        "name": "Nuku‘alofa",
                        "latitude": "-21.13938000",
                        "longitude": "-175.20180000"
                    },
                    {
                        "id": 107050,
                        "name": "Vaini",
                        "latitude": "-21.19292000",
                        "longitude": "-175.17678000"
                    }
                ]
            },
            {
                "id": 3911,
                "name": "Vavaʻu",
                "iso2": "05",
                "latitude": "-18.62275600",
                "longitude": "-173.99029820",
                "type": "division",
                "cities": [
                    {
                        "id": 107047,
                        "name": "Neiafu",
                        "latitude": "-18.65060000",
                        "longitude": "-173.98404000"
                    }
                ]
            }
        ]
    },
    {
        "id": 223,
        "name": "Trinidad and Tobago",
        "iso3": "TTO",
        "iso2": "TT",
        "numeric_code": "780",
        "phonecode": "1",
        "capital": "Port of Spain",
        "currency": "TTD",
        "currency_name": "Trinidad and Tobago dollar",
        "currency_symbol": "$",
        "tld": ".tt",
        "native": "Trinidad and Tobago",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Trinidadian or Tobagonian",
        "timezones": [
            {
                "zoneName": "America\/Port_of_Spain",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Trinidad ha Tobago",
            "ko": "트리니다드 토바고",
            "pt-BR": "Trinidad e Tobago",
            "pt": "Trindade e Tobago",
            "nl": "Trinidad en Tobago",
            "hr": "Trinidad i Tobago",
            "fa": "ترینیداد و توباگو",
            "de": "Trinidad und Tobago",
            "es": "Trinidad y Tobago",
            "fr": "Trinité et Tobago",
            "ja": "トリニダード・トバゴ",
            "it": "Trinidad e Tobago",
            "zh-CN": "特立尼达和多巴哥",
            "tr": "Trinidad Ve Tobago",
            "ru": "Тринидад и Тобаго",
            "uk": "Тринідад і Тобаго",
            "pl": "Trynidad i Tobago"
        },
        "latitude": "11.00000000",
        "longitude": "-61.00000000",
        "emoji": "🇹🇹",
        "emojiU": "U+1F1F9 U+1F1F9",
        "states": [
            {
                "id": 3362,
                "name": "Arima",
                "iso2": "ARI",
                "latitude": "46.79316040",
                "longitude": "-71.25843110",
                "type": "borough",
                "cities": [
                    {
                        "id": 108968,
                        "name": "Arima",
                        "latitude": "10.63737000",
                        "longitude": "-61.28228000"
                    }
                ]
            },
            {
                "id": 3366,
                "name": "Chaguanas",
                "iso2": "CHA",
                "latitude": "10.51683870",
                "longitude": "-61.41144820",
                "type": "borough",
                "cities": [
                    {
                        "id": 108970,
                        "name": "Chaguanas",
                        "latitude": "10.51667000",
                        "longitude": "-61.41667000"
                    },
                    {
                        "id": 108990,
                        "name": "Ward of Chaguanas",
                        "latitude": "10.50000000",
                        "longitude": "-61.38333000"
                    }
                ]
            },
            {
                "id": 3354,
                "name": "Couva-Tabaquite-Talparo",
                "iso2": "CTT",
                "latitude": "10.42971450",
                "longitude": "-61.37352100",
                "type": "region",
                "cities": [
                    {
                        "id": 108971,
                        "name": "Couva",
                        "latitude": "10.42248000",
                        "longitude": "-61.46748000"
                    },
                    {
                        "id": 108988,
                        "name": "Tabaquite",
                        "latitude": "10.38824000",
                        "longitude": "-61.29704000"
                    }
                ]
            },
            {
                "id": 3367,
                "name": "Diego Martin",
                "iso2": "DMN",
                "latitude": "10.73622860",
                "longitude": "-61.55448360",
                "type": "region",
                "cities": [
                    {
                        "id": 108978,
                        "name": "Petit Valley",
                        "latitude": "10.69974000",
                        "longitude": "-61.54717000"
                    },
                    {
                        "id": 108991,
                        "name": "Ward of Diego Martin",
                        "latitude": "10.70000000",
                        "longitude": "-61.58333000"
                    }
                ]
            },
            {
                "id": 3355,
                "name": "Eastern Tobago",
                "iso2": "ETO",
                "latitude": "11.29793480",
                "longitude": "-60.55885240",
                "type": "region",
                "cities": [
                    {
                        "id": 108986,
                        "name": "Scarborough",
                        "latitude": "11.18229000",
                        "longitude": "-60.73525000"
                    }
                ]
            },
            {
                "id": 3365,
                "name": "Penal-Debe",
                "iso2": "PED",
                "latitude": "10.13374020",
                "longitude": "-61.44354740",
                "type": "region",
                "cities": [
                    {
                        "id": 108972,
                        "name": "Debe",
                        "latitude": "10.20846000",
                        "longitude": "-61.45273000"
                    },
                    {
                        "id": 108979,
                        "name": "Peñal",
                        "latitude": "10.16667000",
                        "longitude": "-61.46667000"
                    }
                ]
            },
            {
                "id": 3360,
                "name": "Point Fortin",
                "iso2": "PTF",
                "latitude": "10.17027370",
                "longitude": "-61.67133860",
                "type": "borough",
                "cities": [
                    {
                        "id": 108980,
                        "name": "Point Fortin",
                        "latitude": "10.17411000",
                        "longitude": "-61.68407000"
                    }
                ]
            },
            {
                "id": 3363,
                "name": "Port of Spain",
                "iso2": "POS",
                "latitude": "10.66031960",
                "longitude": "-61.50856250",
                "type": "city",
                "cities": [
                    {
                        "id": 108976,
                        "name": "Mucurapo",
                        "latitude": "10.66253000",
                        "longitude": "-61.53697000"
                    },
                    {
                        "id": 108981,
                        "name": "Port of Spain",
                        "latitude": "10.66668000",
                        "longitude": "-61.51889000"
                    }
                ]
            },
            {
                "id": 3368,
                "name": "Princes Town",
                "iso2": "PRT",
                "latitude": "10.17867460",
                "longitude": "-61.28019960",
                "type": "region",
                "cities": [
                    {
                        "id": 108982,
                        "name": "Princes Town",
                        "latitude": "10.27184000",
                        "longitude": "-61.37103000"
                    }
                ]
            },
            {
                "id": 3356,
                "name": "Rio Claro-Mayaro",
                "iso2": "MRC",
                "latitude": "10.24128320",
                "longitude": "-61.09372060",
                "type": "region",
                "cities": []
            },
            {
                "id": 3359,
                "name": "San Fernando",
                "iso2": "SFO",
                "latitude": "34.28194610",
                "longitude": "-118.43897190",
                "type": "region",
                "cities": [
                    {
                        "id": 108974,
                        "name": "Marabella",
                        "latitude": "10.30618000",
                        "longitude": "-61.44671000"
                    },
                    {
                        "id": 108975,
                        "name": "Mon Repos",
                        "latitude": "10.27979000",
                        "longitude": "-61.44590000"
                    },
                    {
                        "id": 108984,
                        "name": "San Fernando",
                        "latitude": "10.27969000",
                        "longitude": "-61.46835000"
                    }
                ]
            },
            {
                "id": 3357,
                "name": "San Juan-Laventille",
                "iso2": "SJL",
                "latitude": "10.69085780",
                "longitude": "-61.45522130",
                "type": "region",
                "cities": [
                    {
                        "id": 108973,
                        "name": "Laventille",
                        "latitude": "10.64917000",
                        "longitude": "-61.49889000"
                    }
                ]
            },
            {
                "id": 3361,
                "name": "Sangre Grande",
                "iso2": "SGE",
                "latitude": "10.58529390",
                "longitude": "-61.13158130",
                "type": "region",
                "cities": [
                    {
                        "id": 108985,
                        "name": "Sangre Grande",
                        "latitude": "10.58705000",
                        "longitude": "-61.13008000"
                    }
                ]
            },
            {
                "id": 3364,
                "name": "Siparia",
                "iso2": "SIP",
                "latitude": "10.12456260",
                "longitude": "-61.56032440",
                "type": "region",
                "cities": [
                    {
                        "id": 108987,
                        "name": "Siparia",
                        "latitude": "10.14525000",
                        "longitude": "-61.50740000"
                    },
                    {
                        "id": 108992,
                        "name": "Ward of Siparia",
                        "latitude": "10.15000000",
                        "longitude": "-61.46667000"
                    }
                ]
            },
            {
                "id": 3358,
                "name": "Tunapuna-Piarco",
                "iso2": "TUP",
                "latitude": "10.68590960",
                "longitude": "-61.30352480",
                "type": "region",
                "cities": [
                    {
                        "id": 108969,
                        "name": "Arouca",
                        "latitude": "10.62877000",
                        "longitude": "-61.33487000"
                    },
                    {
                        "id": 108977,
                        "name": "Paradise",
                        "latitude": "10.65298000",
                        "longitude": "-61.36298000"
                    },
                    {
                        "id": 108989,
                        "name": "Tunapuna",
                        "latitude": "10.65245000",
                        "longitude": "-61.38878000"
                    }
                ]
            },
            {
                "id": 3353,
                "name": "Western Tobago",
                "iso2": "WTO",
                "latitude": "11.18970720",
                "longitude": "-60.77954520",
                "type": "region",
                "cities": [
                    {
                        "id": 108983,
                        "name": "Rio Claro",
                        "latitude": "10.30594000",
                        "longitude": "-61.17556000"
                    }
                ]
            }
        ]
    },
    {
        "id": 224,
        "name": "Tunisia",
        "iso3": "TUN",
        "iso2": "TN",
        "numeric_code": "788",
        "phonecode": "216",
        "capital": "Tunis",
        "currency": "TND",
        "currency_name": "Tunisian dinar",
        "currency_symbol": "ت.د",
        "tld": ".tn",
        "native": "تونس",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Northern Africa",
        "subregion_id": 1,
        "nationality": "Tunisian",
        "timezones": [
            {
                "zoneName": "Africa\/Tunis",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Tunizia",
            "ko": "튀니지",
            "pt-BR": "Tunísia",
            "pt": "Tunísia",
            "nl": "Tunesië",
            "hr": "Tunis",
            "fa": "تونس",
            "de": "Tunesien",
            "es": "Túnez",
            "fr": "Tunisie",
            "ja": "チュニジア",
            "it": "Tunisia",
            "zh-CN": "突尼斯",
            "tr": "Tunus",
            "ru": "Тунис",
            "uk": "Туніс",
            "pl": "Tunezja"
        },
        "latitude": "34.00000000",
        "longitude": "9.00000000",
        "emoji": "🇹🇳",
        "emojiU": "U+1F1F9 U+1F1F3",
        "states": [
            {
                "id": 2550,
                "name": "Ariana",
                "iso2": "12",
                "latitude": "36.99227510",
                "longitude": "10.12551640",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106915,
                        "name": "Ariana",
                        "latitude": "36.86012000",
                        "longitude": "10.19337000"
                    },
                    {
                        "id": 153381,
                        "name": "Ettadhamen-Mnihla",
                        "latitude": "36.86250000",
                        "longitude": "10.17030000"
                    },
                    {
                        "id": 106955,
                        "name": "Kalaat el-Andalous",
                        "latitude": "36.88110000",
                        "longitude": "10.26220000"
                    },
                    {
                        "id": 153380,
                        "name": "La Soukra",
                        "latitude": "36.85350000",
                        "longitude": "10.25250000"
                    },
                    {
                        "id": 153382,
                        "name": "Mnihla",
                        "latitude": "36.83690000",
                        "longitude": "10.20020000"
                    },
                    {
                        "id": 153378,
                        "name": "Raoued",
                        "latitude": "36.88500000",
                        "longitude": "10.24650000"
                    },
                    {
                        "id": 153379,
                        "name": "Sidi Thabet",
                        "latitude": "36.83990000",
                        "longitude": "10.04030000"
                    }
                ]
            },
            {
                "id": 2572,
                "name": "Béja",
                "iso2": "31",
                "latitude": "35.17227160",
                "longitude": "8.83076260",
                "type": "governorate",
                "cities": [
                    {
                        "id": 153377,
                        "name": "Amdoun",
                        "latitude": "36.74420000",
                        "longitude": "9.05130000"
                    },
                    {
                        "id": 106930,
                        "name": "Béja",
                        "latitude": "36.72564000",
                        "longitude": "9.18169000"
                    },
                    {
                        "id": 106956,
                        "name": "Goubellat",
                        "latitude": "36.59560000",
                        "longitude": "9.20780000"
                    },
                    {
                        "id": 106986,
                        "name": "Medjez el Bab",
                        "latitude": "36.70640000",
                        "longitude": "9.61060000"
                    },
                    {
                        "id": 106940,
                        "name": "Nefza",
                        "latitude": "36.60490000",
                        "longitude": "8.97020000"
                    },
                    {
                        "id": 107031,
                        "name": "Tabursuq",
                        "latitude": "36.45692000",
                        "longitude": "9.24751000"
                    },
                    {
                        "id": 153376,
                        "name": "Téboursouk",
                        "latitude": "36.71040000",
                        "longitude": "9.00080000"
                    },
                    {
                        "id": 107035,
                        "name": "Testour",
                        "latitude": "36.50140000",
                        "longitude": "9.66640000"
                    },
                    {
                        "id": 153375,
                        "name": "Thibar",
                        "latitude": "36.46560000",
                        "longitude": "9.06220000"
                    }
                ]
            },
            {
                "id": 2566,
                "name": "Ben Arous",
                "iso2": "13",
                "latitude": "36.64356060",
                "longitude": "10.21515780",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106920,
                        "name": "Ben Arous",
                        "latitude": "36.75310000",
                        "longitude": "10.22940000"
                    },
                    {
                        "id": 106959,
                        "name": "Hammam Lif",
                        "latitude": "36.72030000",
                        "longitude": "10.32610000"
                    },
                    {
                        "id": 106977,
                        "name": "Mornag",
                        "latitude": "36.66160000",
                        "longitude": "10.14630000"
                    },
                    {
                        "id": 106961,
                        "name": "Mornaguia",
                        "latitude": "36.72140000",
                        "longitude": "10.04940000"
                    },
                    {
                        "id": 107007,
                        "name": "Radès",
                        "latitude": "36.76946000",
                        "longitude": "10.27468000"
                    }
                ]
            },
            {
                "id": 2551,
                "name": "Bizerte",
                "iso2": "23",
                "latitude": "37.16093970",
                "longitude": "9.63413500",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106913,
                        "name": "Al Matlīn",
                        "latitude": "37.24516000",
                        "longitude": "10.05000000"
                    },
                    {
                        "id": 106926,
                        "name": "Bizerte",
                        "latitude": "37.27442000",
                        "longitude": "9.87391000"
                    },
                    {
                        "id": 106927,
                        "name": "Bizerte Sud",
                        "latitude": "37.25528000",
                        "longitude": "9.67915000"
                    },
                    {
                        "id": 106938,
                        "name": "Douar Tindja",
                        "latitude": "37.16667000",
                        "longitude": "9.75000000"
                    },
                    {
                        "id": 106941,
                        "name": "El Alia",
                        "latitude": "37.16911000",
                        "longitude": "10.03478000"
                    },
                    {
                        "id": 106983,
                        "name": "Mateur",
                        "latitude": "37.04045000",
                        "longitude": "9.66557000"
                    },
                    {
                        "id": 106988,
                        "name": "Menzel Abderhaman",
                        "latitude": "37.23737000",
                        "longitude": "9.86313000"
                    },
                    {
                        "id": 106989,
                        "name": "Menzel Bourguiba",
                        "latitude": "37.15368000",
                        "longitude": "9.78594000"
                    },
                    {
                        "id": 106990,
                        "name": "Menzel Jemil",
                        "latitude": "37.23618000",
                        "longitude": "9.91448000"
                    },
                    {
                        "id": 107008,
                        "name": "Rafrāf",
                        "latitude": "37.19043000",
                        "longitude": "10.18365000"
                    },
                    {
                        "id": 107010,
                        "name": "Rhar el Melah",
                        "latitude": "37.16939000",
                        "longitude": "10.19064000"
                    },
                    {
                        "id": 107017,
                        "name": "Sejenane",
                        "latitude": "37.05722000",
                        "longitude": "9.23806000"
                    },
                    {
                        "id": 107041,
                        "name": "Zahānah",
                        "latitude": "37.03959000",
                        "longitude": "10.03876000"
                    }
                ]
            },
            {
                "id": 2558,
                "name": "Gabès",
                "iso2": "81",
                "latitude": "33.94596480",
                "longitude": "9.72326730",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106929,
                        "name": "Bou Attouche",
                        "latitude": "33.89927000",
                        "longitude": "9.78496000"
                    },
                    {
                        "id": 106945,
                        "name": "El Hamma",
                        "latitude": "33.89152000",
                        "longitude": "9.79629000"
                    },
                    {
                        "id": 106952,
                        "name": "Gabès",
                        "latitude": "33.88146000",
                        "longitude": "10.09820000"
                    },
                    {
                        "id": 106984,
                        "name": "Matmata",
                        "latitude": "33.54445000",
                        "longitude": "9.97157000"
                    }
                ]
            },
            {
                "id": 2556,
                "name": "Gafsa",
                "iso2": "71",
                "latitude": "34.37885050",
                "longitude": "8.66005860",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106914,
                        "name": "Ar Rudayyif",
                        "latitude": "34.38270000",
                        "longitude": "8.15549000"
                    },
                    {
                        "id": 106916,
                        "name": "As Sanad",
                        "latitude": "34.46280000",
                        "longitude": "9.26404000"
                    },
                    {
                        "id": 106954,
                        "name": "Gafsa",
                        "latitude": "34.42500000",
                        "longitude": "8.78417000"
                    },
                    {
                        "id": 106994,
                        "name": "Metlaoui",
                        "latitude": "34.32081000",
                        "longitude": "8.40157000"
                    },
                    {
                        "id": 107000,
                        "name": "Mu‘tamadīyat ar Rudayyif",
                        "latitude": "34.40081000",
                        "longitude": "8.17057000"
                    }
                ]
            },
            {
                "id": 2552,
                "name": "Jendouba",
                "iso2": "32",
                "latitude": "36.71818620",
                "longitude": "8.74811670",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106951,
                        "name": "Fernana",
                        "latitude": "36.65547000",
                        "longitude": "8.69602000"
                    },
                    {
                        "id": 106965,
                        "name": "Jendouba",
                        "latitude": "36.48519000",
                        "longitude": "8.82325000"
                    },
                    {
                        "id": 107005,
                        "name": "Oued Meliz",
                        "latitude": "36.46813000",
                        "longitude": "8.54951000"
                    },
                    {
                        "id": 107030,
                        "name": "Tabarka",
                        "latitude": "36.95442000",
                        "longitude": "8.75801000"
                    }
                ]
            },
            {
                "id": 2564,
                "name": "Kairouan",
                "iso2": "41",
                "latitude": "35.67116630",
                "longitude": "10.10054690",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106958,
                        "name": "Haffouz",
                        "latitude": "35.63235000",
                        "longitude": "9.67624000"
                    },
                    {
                        "id": 106968,
                        "name": "Kairouan",
                        "latitude": "35.67810000",
                        "longitude": "10.09633000"
                    },
                    {
                        "id": 107016,
                        "name": "Sbikha",
                        "latitude": "35.93325000",
                        "longitude": "10.02081000"
                    }
                ]
            },
            {
                "id": 2570,
                "name": "Kasserine",
                "iso2": "42",
                "latitude": "35.08091480",
                "longitude": "8.66005860",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106969,
                        "name": "Kasserine",
                        "latitude": "35.16758000",
                        "longitude": "8.83651000"
                    },
                    {
                        "id": 107011,
                        "name": "Rohia",
                        "latitude": "35.65129000",
                        "longitude": "9.05306000"
                    },
                    {
                        "id": 107015,
                        "name": "Sbiba",
                        "latitude": "35.54332000",
                        "longitude": "9.07370000"
                    },
                    {
                        "id": 107036,
                        "name": "Thala",
                        "latitude": "35.57244000",
                        "longitude": "8.67031000"
                    }
                ]
            },
            {
                "id": 2562,
                "name": "Kebili",
                "iso2": "73",
                "latitude": "33.70715510",
                "longitude": "8.97146230",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106939,
                        "name": "Douz",
                        "latitude": "33.46632000",
                        "longitude": "9.02030000"
                    },
                    {
                        "id": 106944,
                        "name": "El Golaa",
                        "latitude": "33.48485000",
                        "longitude": "9.00678000"
                    },
                    {
                        "id": 106964,
                        "name": "Jemna",
                        "latitude": "33.57778000",
                        "longitude": "9.01472000"
                    },
                    {
                        "id": 106970,
                        "name": "Kebili",
                        "latitude": "33.70439000",
                        "longitude": "8.96903000"
                    }
                ]
            },
            {
                "id": 2561,
                "name": "Kef",
                "iso2": "33",
                "latitude": "36.12305120",
                "longitude": "8.66005860",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106917,
                        "name": "As Sars",
                        "latitude": "36.07640000",
                        "longitude": "9.02117000"
                    },
                    {
                        "id": 106947,
                        "name": "El Kef",
                        "latitude": "36.17424000",
                        "longitude": "8.70486000"
                    },
                    {
                        "id": 106948,
                        "name": "El Ksour",
                        "latitude": "35.89607000",
                        "longitude": "8.88493000"
                    },
                    {
                        "id": 106992,
                        "name": "Menzel Salem",
                        "latitude": "35.85673000",
                        "longitude": "8.47654000"
                    },
                    {
                        "id": 107002,
                        "name": "Nibbar",
                        "latitude": "36.29411000",
                        "longitude": "8.76657000"
                    },
                    {
                        "id": 107013,
                        "name": "Sakiet Sidi Youssef",
                        "latitude": "36.22292000",
                        "longitude": "8.35547000"
                    },
                    {
                        "id": 107032,
                        "name": "Tajerouine",
                        "latitude": "35.89174000",
                        "longitude": "8.55276000"
                    }
                ]
            },
            {
                "id": 2568,
                "name": "Mahdia",
                "iso2": "53",
                "latitude": "35.33525580",
                "longitude": "10.89030990",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106932,
                        "name": "Chebba",
                        "latitude": "35.23722000",
                        "longitude": "11.11500000"
                    },
                    {
                        "id": 106934,
                        "name": "Chorbane",
                        "latitude": "35.28581000",
                        "longitude": "10.38580000"
                    },
                    {
                        "id": 106946,
                        "name": "El Jem",
                        "latitude": "35.30000000",
                        "longitude": "10.71667000"
                    },
                    {
                        "id": 106974,
                        "name": "Ksour Essaf",
                        "latitude": "35.41808000",
                        "longitude": "10.99475000"
                    },
                    {
                        "id": 106980,
                        "name": "Mahdia",
                        "latitude": "35.50472000",
                        "longitude": "11.06222000"
                    },
                    {
                        "id": 106987,
                        "name": "Melloulèche",
                        "latitude": "35.16617000",
                        "longitude": "11.03504000"
                    },
                    {
                        "id": 107014,
                        "name": "Salakta",
                        "latitude": "35.39444000",
                        "longitude": "11.04361000"
                    },
                    {
                        "id": 107020,
                        "name": "Sidi Alouane",
                        "latitude": "35.37505000",
                        "longitude": "10.93899000"
                    },
                    {
                        "id": 107043,
                        "name": "Zouila",
                        "latitude": "35.50056000",
                        "longitude": "11.06056000"
                    }
                ]
            },
            {
                "id": 2555,
                "name": "Manouba",
                "iso2": "14",
                "latitude": "36.84465040",
                "longitude": "9.85714160",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106942,
                        "name": "El Battan",
                        "latitude": "36.80368000",
                        "longitude": "9.84424000"
                    },
                    {
                        "id": 106982,
                        "name": "Manouba",
                        "latitude": "36.81006000",
                        "longitude": "10.09557000"
                    },
                    {
                        "id": 106999,
                        "name": "Mu‘tamadīyat Manūbah",
                        "latitude": "36.80907000",
                        "longitude": "10.09467000"
                    },
                    {
                        "id": 107004,
                        "name": "Oued Lill",
                        "latitude": "36.83408000",
                        "longitude": "10.04057000"
                    }
                ]
            },
            {
                "id": 2560,
                "name": "Medenine",
                "iso2": "82",
                "latitude": "33.22805650",
                "longitude": "10.89030990",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106921,
                        "name": "Ben Gardane",
                        "latitude": "33.13783000",
                        "longitude": "11.21965000"
                    },
                    {
                        "id": 106923,
                        "name": "Beni Kheddache",
                        "latitude": "33.25279000",
                        "longitude": "10.19883000"
                    },
                    {
                        "id": 106950,
                        "name": "Erriadh",
                        "latitude": "33.82063000",
                        "longitude": "10.85394000"
                    },
                    {
                        "id": 106963,
                        "name": "Houmt El Souk",
                        "latitude": "33.87576000",
                        "longitude": "10.85745000"
                    },
                    {
                        "id": 106966,
                        "name": "Jerba Midoun",
                        "latitude": "33.77918000",
                        "longitude": "10.95215000"
                    },
                    {
                        "id": 106985,
                        "name": "Medenine",
                        "latitude": "33.35495000",
                        "longitude": "10.50548000"
                    },
                    {
                        "id": 106996,
                        "name": "Midoun",
                        "latitude": "33.80813000",
                        "longitude": "10.99228000"
                    },
                    {
                        "id": 107042,
                        "name": "Zarzis",
                        "latitude": "33.50398000",
                        "longitude": "11.11215000"
                    }
                ]
            },
            {
                "id": 2553,
                "name": "Monastir",
                "iso2": "52",
                "latitude": "35.76425150",
                "longitude": "10.81128850",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106918,
                        "name": "Banbalah",
                        "latitude": "35.70000000",
                        "longitude": "10.80000000"
                    },
                    {
                        "id": 106919,
                        "name": "Bekalta",
                        "latitude": "35.61739000",
                        "longitude": "10.99466000"
                    },
                    {
                        "id": 106922,
                        "name": "Beni Hassane",
                        "latitude": "35.56720000",
                        "longitude": "10.80869000"
                    },
                    {
                        "id": 106937,
                        "name": "Djemmal",
                        "latitude": "35.62231000",
                        "longitude": "10.75696000"
                    },
                    {
                        "id": 106972,
                        "name": "Ksar Hellal",
                        "latitude": "35.64773000",
                        "longitude": "10.89046000"
                    },
                    {
                        "id": 106973,
                        "name": "Ksibet el Mediouni",
                        "latitude": "35.68561000",
                        "longitude": "10.84256000"
                    },
                    {
                        "id": 106979,
                        "name": "Lemta",
                        "latitude": "35.66667000",
                        "longitude": "10.88333000"
                    },
                    {
                        "id": 106991,
                        "name": "Menzel Kamel",
                        "latitude": "35.62477000",
                        "longitude": "10.66727000"
                    },
                    {
                        "id": 106993,
                        "name": "Mesdour",
                        "latitude": "35.68206000",
                        "longitude": "10.72746000"
                    },
                    {
                        "id": 106997,
                        "name": "Monastir",
                        "latitude": "35.77799000",
                        "longitude": "10.82617000"
                    },
                    {
                        "id": 107003,
                        "name": "Ouardenine",
                        "latitude": "35.70915000",
                        "longitude": "10.67397000"
                    },
                    {
                        "id": 107012,
                        "name": "Sahline",
                        "latitude": "35.75166000",
                        "longitude": "10.71109000"
                    },
                    {
                        "id": 107018,
                        "name": "Seïada",
                        "latitude": "35.66887000",
                        "longitude": "10.89246000"
                    },
                    {
                        "id": 107021,
                        "name": "Sidi Ben Nour",
                        "latitude": "35.53333000",
                        "longitude": "10.91667000"
                    },
                    {
                        "id": 107027,
                        "name": "Skanes",
                        "latitude": "35.78333000",
                        "longitude": "10.80000000"
                    },
                    {
                        "id": 107037,
                        "name": "Touza",
                        "latitude": "35.63544000",
                        "longitude": "10.82732000"
                    }
                ]
            },
            {
                "id": 5116,
                "name": "Nabeul",
                "iso2": "21",
                "latitude": "36.45245910",
                "longitude": "10.68032220",
                "type": "governorate",
                "cities": [
                    {
                        "id": 153265,
                        "name": "Azmour",
                        "latitude": "36.92440000",
                        "longitude": "11.00690000"
                    },
                    {
                        "id": 153266,
                        "name": "Beni Khalled",
                        "latitude": "36.65038000",
                        "longitude": "10.59004000"
                    },
                    {
                        "id": 153268,
                        "name": "Béni Khiar",
                        "latitude": "36.46666667",
                        "longitude": "10.78333333"
                    },
                    {
                        "id": 153267,
                        "name": "Bou Argoub",
                        "latitude": "36.53853000",
                        "longitude": "10.55093000"
                    },
                    {
                        "id": 153269,
                        "name": "Dar Chaabane",
                        "latitude": "36.47000000",
                        "longitude": "10.75000000"
                    },
                    {
                        "id": 153270,
                        "name": "El Haouaria",
                        "latitude": "37.05000000",
                        "longitude": "11.01111111"
                    },
                    {
                        "id": 153271,
                        "name": "El Maâmoura",
                        "latitude": "36.46666667",
                        "longitude": "10.80000000"
                    },
                    {
                        "id": 153272,
                        "name": "El Mida",
                        "latitude": "36.73333333",
                        "longitude": "10.85000000"
                    },
                    {
                        "id": 153273,
                        "name": "El Mrezga",
                        "latitude": "36.42163000",
                        "longitude": "10.66411000"
                    },
                    {
                        "id": 153274,
                        "name": "Grombalia",
                        "latitude": "36.61000000",
                        "longitude": "10.50000000"
                    },
                    {
                        "id": 153275,
                        "name": "Hammamet",
                        "latitude": "36.41666667",
                        "longitude": "10.60000000"
                    },
                    {
                        "id": 153276,
                        "name": "Kelibia",
                        "latitude": "36.84750000",
                        "longitude": "11.09388889"
                    },
                    {
                        "id": 153277,
                        "name": "Korba",
                        "latitude": "36.56666667",
                        "longitude": "10.86666667"
                    },
                    {
                        "id": 153278,
                        "name": "Korbous",
                        "latitude": "36.81638889",
                        "longitude": "10.56861111"
                    },
                    {
                        "id": 153279,
                        "name": "Menzel Bouzelfa",
                        "latitude": "36.68170000",
                        "longitude": "10.58470000"
                    },
                    {
                        "id": 153280,
                        "name": "Menzel Horr",
                        "latitude": "36.73333333",
                        "longitude": "10.95000000"
                    },
                    {
                        "id": 153281,
                        "name": "Menzel Temime",
                        "latitude": "36.78333333",
                        "longitude": "10.98333333"
                    },
                    {
                        "id": 153282,
                        "name": "Nabeul",
                        "latitude": "36.45138900",
                        "longitude": "10.73611100"
                    },
                    {
                        "id": 153283,
                        "name": "Soliman",
                        "latitude": "36.69512600",
                        "longitude": "10.49125700"
                    },
                    {
                        "id": 153284,
                        "name": "Takelsa",
                        "latitude": "36.79000000",
                        "longitude": "10.63000000"
                    },
                    {
                        "id": 153285,
                        "name": "Tazerka",
                        "latitude": "36.55000000",
                        "longitude": "10.80000000"
                    },
                    {
                        "id": 153286,
                        "name": "Zaouiet Djedidi",
                        "latitude": "36.65000000",
                        "longitude": "10.60000000"
                    },
                    {
                        "id": 153287,
                        "name": "Zriba",
                        "latitude": "36.35585000",
                        "longitude": "10.20603400"
                    }
                ]
            },
            {
                "id": 2557,
                "name": "Sfax",
                "iso2": "61",
                "latitude": "34.86065810",
                "longitude": "10.34978950",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106910,
                        "name": "Agareb",
                        "latitude": "34.74406000",
                        "longitude": "10.46110000"
                    },
                    {
                        "id": 106924,
                        "name": "Bir Ali Ben Khalifa",
                        "latitude": "34.73592000",
                        "longitude": "10.09240000"
                    },
                    {
                        "id": 106936,
                        "name": "Djebeniana",
                        "latitude": "35.03500000",
                        "longitude": "10.90809000"
                    },
                    {
                        "id": 106957,
                        "name": "Gremda",
                        "latitude": "34.75000000",
                        "longitude": "10.78333000"
                    },
                    {
                        "id": 107019,
                        "name": "Sfax",
                        "latitude": "34.74056000",
                        "longitude": "10.76028000"
                    },
                    {
                        "id": 107028,
                        "name": "Skhira",
                        "latitude": "34.29920000",
                        "longitude": "10.06999000"
                    }
                ]
            },
            {
                "id": 2567,
                "name": "Sidi Bouzid",
                "iso2": "43",
                "latitude": "35.03543860",
                "longitude": "9.48393920",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106925,
                        "name": "Bir el Hafey",
                        "latitude": "34.93212000",
                        "longitude": "9.19321000"
                    },
                    {
                        "id": 106949,
                        "name": "Er Regueb",
                        "latitude": "34.85932000",
                        "longitude": "9.78654000"
                    },
                    {
                        "id": 106967,
                        "name": "Jilma",
                        "latitude": "35.27311000",
                        "longitude": "9.42385000"
                    },
                    {
                        "id": 106995,
                        "name": "Mezzouna",
                        "latitude": "34.57758000",
                        "longitude": "9.84193000"
                    },
                    {
                        "id": 107024,
                        "name": "Sidi Bouzid",
                        "latitude": "35.03823000",
                        "longitude": "9.48494000"
                    }
                ]
            },
            {
                "id": 2563,
                "name": "Siliana",
                "iso2": "34",
                "latitude": "36.08872080",
                "longitude": "9.36453350",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106928,
                        "name": "Bou Arada",
                        "latitude": "36.35251000",
                        "longitude": "9.62175000"
                    },
                    {
                        "id": 106953,
                        "name": "Gafour",
                        "latitude": "36.32045000",
                        "longitude": "9.32424000"
                    },
                    {
                        "id": 106971,
                        "name": "Kesra",
                        "latitude": "35.81363000",
                        "longitude": "9.36434000"
                    },
                    {
                        "id": 106978,
                        "name": "Le Krib",
                        "latitude": "36.32802000",
                        "longitude": "9.13613000"
                    },
                    {
                        "id": 106981,
                        "name": "Maktar",
                        "latitude": "35.85798000",
                        "longitude": "9.20072000"
                    },
                    {
                        "id": 107026,
                        "name": "Siliana",
                        "latitude": "36.08497000",
                        "longitude": "9.37082000"
                    }
                ]
            },
            {
                "id": 2571,
                "name": "Sousse",
                "iso2": "51",
                "latitude": "35.90222670",
                "longitude": "10.34978950",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106911,
                        "name": "Akouda",
                        "latitude": "35.86910000",
                        "longitude": "10.56530000"
                    },
                    {
                        "id": 106960,
                        "name": "Hammam Sousse",
                        "latitude": "35.86090000",
                        "longitude": "10.60313000"
                    },
                    {
                        "id": 106962,
                        "name": "Harqalah",
                        "latitude": "36.03027000",
                        "longitude": "10.50904000"
                    },
                    {
                        "id": 106998,
                        "name": "Msaken",
                        "latitude": "35.72917000",
                        "longitude": "10.58082000"
                    },
                    {
                        "id": 107006,
                        "name": "Port el Kantaoui",
                        "latitude": "35.89239000",
                        "longitude": "10.59434000"
                    },
                    {
                        "id": 107022,
                        "name": "Sidi Bou Ali",
                        "latitude": "35.95667000",
                        "longitude": "10.47306000"
                    },
                    {
                        "id": 107025,
                        "name": "Sidi el Hani",
                        "latitude": "35.67139000",
                        "longitude": "10.31583000"
                    },
                    {
                        "id": 107029,
                        "name": "Sousse",
                        "latitude": "35.82539000",
                        "longitude": "10.63699000"
                    }
                ]
            },
            {
                "id": 2559,
                "name": "Tataouine",
                "iso2": "83",
                "latitude": "32.13441220",
                "longitude": "10.08072980",
                "type": "governorate",
                "cities": [
                    {
                        "id": 107009,
                        "name": "Remada",
                        "latitude": "32.31662000",
                        "longitude": "10.39551000"
                    },
                    {
                        "id": 107034,
                        "name": "Tataouine",
                        "latitude": "32.92967000",
                        "longitude": "10.45177000"
                    }
                ]
            },
            {
                "id": 2569,
                "name": "Tozeur",
                "iso2": "72",
                "latitude": "33.97894910",
                "longitude": "8.04651850",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106933,
                        "name": "Chebika",
                        "latitude": "34.31909000",
                        "longitude": "7.93519000"
                    },
                    {
                        "id": 106935,
                        "name": "Degache",
                        "latitude": "33.97606000",
                        "longitude": "8.20810000"
                    },
                    {
                        "id": 107001,
                        "name": "Nefta",
                        "latitude": "33.87309000",
                        "longitude": "7.87765000"
                    },
                    {
                        "id": 107033,
                        "name": "Tamaghzah",
                        "latitude": "34.38849000",
                        "longitude": "7.94313000"
                    },
                    {
                        "id": 107038,
                        "name": "Tozeur",
                        "latitude": "33.91968000",
                        "longitude": "8.13352000"
                    }
                ]
            },
            {
                "id": 2554,
                "name": "Tunis",
                "iso2": "11",
                "latitude": "36.83749460",
                "longitude": "10.19273890",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106912,
                        "name": "Al Marsá",
                        "latitude": "36.87818000",
                        "longitude": "10.32466000"
                    },
                    {
                        "id": 106931,
                        "name": "Carthage",
                        "latitude": "36.85961000",
                        "longitude": "10.32978000"
                    },
                    {
                        "id": 106975,
                        "name": "La Goulette",
                        "latitude": "36.81825000",
                        "longitude": "10.30520000"
                    },
                    {
                        "id": 106976,
                        "name": "La Mohammedia",
                        "latitude": "36.67446000",
                        "longitude": "10.15633000"
                    },
                    {
                        "id": 107023,
                        "name": "Sidi Bou Saïd",
                        "latitude": "36.86870000",
                        "longitude": "10.34174000"
                    },
                    {
                        "id": 107039,
                        "name": "Tunis",
                        "latitude": "36.81897000",
                        "longitude": "10.16579000"
                    }
                ]
            },
            {
                "id": 2565,
                "name": "Zaghouan",
                "iso2": "22",
                "latitude": "36.40911880",
                "longitude": "10.14231720",
                "type": "governorate",
                "cities": [
                    {
                        "id": 106943,
                        "name": "El Fahs",
                        "latitude": "36.37419000",
                        "longitude": "9.90651000"
                    },
                    {
                        "id": 107040,
                        "name": "Zaghouan",
                        "latitude": "36.40291000",
                        "longitude": "10.14292000"
                    }
                ]
            }
        ]
    },
    {
        "id": 225,
        "name": "Turkey",
        "iso3": "TUR",
        "iso2": "TR",
        "numeric_code": "792",
        "phonecode": "90",
        "capital": "Ankara",
        "currency": "TRY",
        "currency_name": "Turkish lira",
        "currency_symbol": "₺",
        "tld": ".tr",
        "native": "Türkiye",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Turkish",
        "timezones": [
            {
                "zoneName": "Europe\/Istanbul",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Turkia",
            "ko": "터키",
            "pt-BR": "Turquia",
            "pt": "Turquia",
            "nl": "Turkije",
            "hr": "Turska",
            "fa": "ترکیه",
            "de": "Türkei",
            "es": "Turquía",
            "fr": "Turquie",
            "ja": "トルコ",
            "it": "Turchia",
            "zh-CN": "土耳其",
            "tr": "Türkiye",
            "ru": "Турция",
            "uk": "Туреччина",
            "pl": "Turcja"
        },
        "latitude": "39.00000000",
        "longitude": "35.00000000",
        "emoji": "🇹🇷",
        "emojiU": "U+1F1F9 U+1F1F7",
        "states": [
            {
                "id": 2212,
                "name": "Adana",
                "iso2": "01",
                "latitude": "37.26123150",
                "longitude": "35.39050460",
                "type": "province",
                "cities": [
                    {
                        "id": 153788,
                        "name": "Adana",
                        "latitude": "36.99757530",
                        "longitude": "35.12325260"
                    },
                    {
                        "id": 107120,
                        "name": "Aladağ",
                        "latitude": "37.55854000",
                        "longitude": "35.40196000"
                    },
                    {
                        "id": 107427,
                        "name": "Ceyhan",
                        "latitude": "37.02472000",
                        "longitude": "35.81750000"
                    },
                    {
                        "id": 108848,
                        "name": "Çukurova",
                        "latitude": "37.05627000",
                        "longitude": "35.13119000"
                    },
                    {
                        "id": 107635,
                        "name": "Feke",
                        "latitude": "37.82405000",
                        "longitude": "35.91826000"
                    },
                    {
                        "id": 108893,
                        "name": "İmamoğlu",
                        "latitude": "37.27500000",
                        "longitude": "35.66649000"
                    },
                    {
                        "id": 107896,
                        "name": "Karaisalı",
                        "latitude": "37.26655000",
                        "longitude": "35.05033000"
                    },
                    {
                        "id": 107918,
                        "name": "Karataş",
                        "latitude": "36.57186000",
                        "longitude": "35.36784000"
                    },
                    {
                        "id": 108033,
                        "name": "Kozan",
                        "latitude": "37.50000000",
                        "longitude": "35.75000000"
                    },
                    {
                        "id": 108349,
                        "name": "Pozantı",
                        "latitude": "37.43671000",
                        "longitude": "34.88057000"
                    },
                    {
                        "id": 108374,
                        "name": "Saimbeyli",
                        "latitude": "37.99615000",
                        "longitude": "36.09909000"
                    },
                    {
                        "id": 108414,
                        "name": "Sarıçam",
                        "latitude": "37.14971000",
                        "longitude": "35.50949000"
                    },
                    {
                        "id": 108452,
                        "name": "Seyhan",
                        "latitude": "36.95540000",
                        "longitude": "35.21637000"
                    },
                    {
                        "id": 108597,
                        "name": "Tufanbeyli",
                        "latitude": "38.27343000",
                        "longitude": "36.22731000"
                    },
                    {
                        "id": 108737,
                        "name": "Yumurtalık",
                        "latitude": "36.78245000",
                        "longitude": "35.79949000"
                    },
                    {
                        "id": 108745,
                        "name": "Yüreğir",
                        "latitude": "36.99205000",
                        "longitude": "35.45402000"
                    }
                ]
            },
            {
                "id": 2155,
                "name": "Adıyaman",
                "iso2": "02",
                "latitude": "37.90782910",
                "longitude": "38.48499230",
                "type": "province",
                "cities": [
                    {
                        "id": 107332,
                        "name": "Besni",
                        "latitude": "37.69278000",
                        "longitude": "37.86111000"
                    },
                    {
                        "id": 108814,
                        "name": "Çelikhan",
                        "latitude": "38.02560000",
                        "longitude": "38.23665000"
                    },
                    {
                        "id": 107666,
                        "name": "Gerger",
                        "latitude": "37.95000000",
                        "longitude": "39.01667000"
                    },
                    {
                        "id": 107688,
                        "name": "Gölbaşı",
                        "latitude": "37.78361000",
                        "longitude": "37.63667000"
                    },
                    {
                        "id": 108069,
                        "name": "Kâhta",
                        "latitude": "37.78552000",
                        "longitude": "38.62370000"
                    },
                    {
                        "id": 108194,
                        "name": "Merkez",
                        "latitude": "37.74454000",
                        "longitude": "38.26801000"
                    },
                    {
                        "id": 108379,
                        "name": "Samsat",
                        "latitude": "37.58194000",
                        "longitude": "38.47417000"
                    },
                    {
                        "id": 108471,
                        "name": "Sincik",
                        "latitude": "38.03645000",
                        "longitude": "38.61257000"
                    },
                    {
                        "id": 108606,
                        "name": "Tut",
                        "latitude": "37.79529000",
                        "longitude": "37.91610000"
                    }
                ]
            },
            {
                "id": 2179,
                "name": "Afyonkarahisar",
                "iso2": "03",
                "latitude": "38.73910990",
                "longitude": "30.71200230",
                "type": "province",
                "cities": [
                    {
                        "id": 107318,
                        "name": "Başmakçı",
                        "latitude": "37.89722000",
                        "longitude": "30.01167000"
                    },
                    {
                        "id": 107293,
                        "name": "Bayat",
                        "latitude": "38.98306000",
                        "longitude": "30.92472000"
                    },
                    {
                        "id": 107367,
                        "name": "Bolvadin",
                        "latitude": "38.71111000",
                        "longitude": "31.04861000"
                    },
                    {
                        "id": 108795,
                        "name": "Çay",
                        "latitude": "38.59167000",
                        "longitude": "31.02861000"
                    },
                    {
                        "id": 108841,
                        "name": "Çobanlar",
                        "latitude": "38.71085000",
                        "longitude": "30.78874000"
                    },
                    {
                        "id": 107455,
                        "name": "Dazkırı",
                        "latitude": "37.91861000",
                        "longitude": "29.86056000"
                    },
                    {
                        "id": 107498,
                        "name": "Dinar",
                        "latitude": "38.06500000",
                        "longitude": "30.16557000"
                    },
                    {
                        "id": 107576,
                        "name": "Emirdağ",
                        "latitude": "39.01972000",
                        "longitude": "31.15000000"
                    },
                    {
                        "id": 107612,
                        "name": "Evciler",
                        "latitude": "38.04139000",
                        "longitude": "29.88667000"
                    },
                    {
                        "id": 107831,
                        "name": "Hocalar",
                        "latitude": "38.57824000",
                        "longitude": "29.96768000"
                    },
                    {
                        "id": 108883,
                        "name": "İhsaniye",
                        "latitude": "39.02916000",
                        "longitude": "30.41639000"
                    },
                    {
                        "id": 108912,
                        "name": "İscehisar",
                        "latitude": "38.93900000",
                        "longitude": "30.75002000"
                    },
                    {
                        "id": 108120,
                        "name": "Kızılören",
                        "latitude": "38.25806000",
                        "longitude": "30.15167000"
                    },
                    {
                        "id": 108190,
                        "name": "Merkez",
                        "latitude": "38.79698000",
                        "longitude": "30.51951000"
                    },
                    {
                        "id": 108383,
                        "name": "Sandıklı",
                        "latitude": "38.46472000",
                        "longitude": "30.26946000"
                    },
                    {
                        "id": 108468,
                        "name": "Sinanpaşa",
                        "latitude": "38.74444000",
                        "longitude": "30.24278000"
                    },
                    {
                        "id": 108964,
                        "name": "Şuhut",
                        "latitude": "38.53111000",
                        "longitude": "30.54583000"
                    },
                    {
                        "id": 108493,
                        "name": "Sultandağı",
                        "latitude": "38.53111000",
                        "longitude": "31.22806000"
                    }
                ]
            },
            {
                "id": 2193,
                "name": "Ağrı",
                "iso2": "04",
                "latitude": "39.62692180",
                "longitude": "43.02159650",
                "type": "province",
                "cities": [
                    {
                        "id": 107502,
                        "name": "Diyadin",
                        "latitude": "39.54056000",
                        "longitude": "43.67135000"
                    },
                    {
                        "id": 107527,
                        "name": "Doğubayazıt",
                        "latitude": "39.54694000",
                        "longitude": "44.08417000"
                    },
                    {
                        "id": 107566,
                        "name": "Eleşkirt",
                        "latitude": "39.79803000",
                        "longitude": "42.67574000"
                    },
                    {
                        "id": 107783,
                        "name": "Hamur",
                        "latitude": "39.60561000",
                        "longitude": "42.98500000"
                    },
                    {
                        "id": 107244,
                        "name": "Merkez",
                        "latitude": "39.71944000",
                        "longitude": "43.05139000"
                    },
                    {
                        "id": 108316,
                        "name": "Patnos",
                        "latitude": "39.22493000",
                        "longitude": "42.85693000"
                    },
                    {
                        "id": 108552,
                        "name": "Taşlıçay",
                        "latitude": "39.62966000",
                        "longitude": "43.36878000"
                    },
                    {
                        "id": 108608,
                        "name": "Tutak",
                        "latitude": "39.55042000",
                        "longitude": "42.77572000"
                    }
                ]
            },
            {
                "id": 2210,
                "name": "Aksaray",
                "iso2": "68",
                "latitude": "38.33520430",
                "longitude": "33.97500180",
                "type": "province",
                "cities": [
                    {
                        "id": 107239,
                        "name": "Ağaçören",
                        "latitude": "38.87484000",
                        "longitude": "33.91674000"
                    },
                    {
                        "id": 107606,
                        "name": "Eskil",
                        "latitude": "38.41158000",
                        "longitude": "33.41994000"
                    },
                    {
                        "id": 107727,
                        "name": "Gülağaç",
                        "latitude": "38.40641000",
                        "longitude": "34.35071000"
                    },
                    {
                        "id": 107761,
                        "name": "Güzelyurt",
                        "latitude": "38.27722000",
                        "longitude": "34.37194000"
                    },
                    {
                        "id": 108178,
                        "name": "Merkez",
                        "latitude": "38.37060000",
                        "longitude": "34.02843000"
                    },
                    {
                        "id": 108283,
                        "name": "Ortaköy",
                        "latitude": "38.73728000",
                        "longitude": "34.03866000"
                    },
                    {
                        "id": 108409,
                        "name": "Sarıyahşi",
                        "latitude": "38.98349000",
                        "longitude": "33.84136000"
                    },
                    {
                        "id": 108496,
                        "name": "Sultanhanı",
                        "latitude": "38.24710000",
                        "longitude": "33.54961000"
                    }
                ]
            },
            {
                "id": 2161,
                "name": "Amasya",
                "iso2": "05",
                "latitude": "40.65166080",
                "longitude": "35.90379660",
                "type": "province",
                "cities": [
                    {
                        "id": 107716,
                        "name": "Göynücek",
                        "latitude": "40.39917000",
                        "longitude": "35.52500000"
                    },
                    {
                        "id": 107737,
                        "name": "Gümüşhacıköy",
                        "latitude": "40.87306000",
                        "longitude": "35.21472000"
                    },
                    {
                        "id": 107781,
                        "name": "Hamamözü",
                        "latitude": "40.79539000",
                        "longitude": "35.03367000"
                    },
                    {
                        "id": 108195,
                        "name": "Merkez",
                        "latitude": "40.61939000",
                        "longitude": "35.87016000"
                    },
                    {
                        "id": 108200,
                        "name": "Merzifon",
                        "latitude": "40.88348000",
                        "longitude": "35.47116000"
                    },
                    {
                        "id": 108500,
                        "name": "Suluova",
                        "latitude": "40.83129000",
                        "longitude": "35.64788000"
                    },
                    {
                        "id": 108554,
                        "name": "Taşova",
                        "latitude": "40.75972000",
                        "longitude": "36.32250000"
                    }
                ]
            },
            {
                "id": 2217,
                "name": "Ankara",
                "iso2": "06",
                "latitude": "39.78052450",
                "longitude": "32.71813750",
                "type": "province",
                "cities": [
                    {
                        "id": 107102,
                        "name": "Akyurt",
                        "latitude": "40.13512000",
                        "longitude": "33.08614000"
                    },
                    {
                        "id": 107139,
                        "name": "Altındağ",
                        "latitude": "40.00110000",
                        "longitude": "32.97022000"
                    },
                    {
                        "id": 153787,
                        "name": "Ankara",
                        "latitude": "39.90343670",
                        "longitude": "32.43310030"
                    },
                    {
                        "id": 107217,
                        "name": "Ayaş",
                        "latitude": "40.01933000",
                        "longitude": "32.33221000"
                    },
                    {
                        "id": 107268,
                        "name": "Bala",
                        "latitude": "39.56374000",
                        "longitude": "33.12962000"
                    },
                    {
                        "id": 107343,
                        "name": "Beypazarı",
                        "latitude": "40.16750000",
                        "longitude": "31.92111000"
                    },
                    {
                        "id": 108768,
                        "name": "Çamlıdere",
                        "latitude": "40.48958000",
                        "longitude": "32.47499000"
                    },
                    {
                        "id": 108779,
                        "name": "Çankaya",
                        "latitude": "39.91790000",
                        "longitude": "32.86268000"
                    },
                    {
                        "id": 108844,
                        "name": "Çubuk",
                        "latitude": "40.23861000",
                        "longitude": "33.03222000"
                    },
                    {
                        "id": 107568,
                        "name": "Elmadağ",
                        "latitude": "39.92083000",
                        "longitude": "33.23083000"
                    },
                    {
                        "id": 107611,
                        "name": "Etimesgut",
                        "latitude": "39.96335000",
                        "longitude": "32.63744000"
                    },
                    {
                        "id": 107614,
                        "name": "Evren",
                        "latitude": "39.02402000",
                        "longitude": "33.80626000"
                    },
                    {
                        "id": 107687,
                        "name": "Gölbaşı",
                        "latitude": "39.79043000",
                        "longitude": "32.80903000"
                    },
                    {
                        "id": 107725,
                        "name": "Güdül",
                        "latitude": "40.21051000",
                        "longitude": "32.24552000"
                    },
                    {
                        "id": 107811,
                        "name": "Haymana",
                        "latitude": "39.43212000",
                        "longitude": "32.49732000"
                    },
                    {
                        "id": 107868,
                        "name": "Kahramankazan",
                        "latitude": "40.16502000",
                        "longitude": "32.63904000"
                    },
                    {
                        "id": 107874,
                        "name": "Kalecik",
                        "latitude": "40.09722000",
                        "longitude": "33.40833000"
                    },
                    {
                        "id": 107991,
                        "name": "Keçiören",
                        "latitude": "40.02106000",
                        "longitude": "32.83102000"
                    },
                    {
                        "id": 108113,
                        "name": "Kızılcahamam",
                        "latitude": "40.46972000",
                        "longitude": "32.65056000"
                    },
                    {
                        "id": 108147,
                        "name": "Mamak",
                        "latitude": "39.94587000",
                        "longitude": "32.90811000"
                    },
                    {
                        "id": 108237,
                        "name": "Nallıhan",
                        "latitude": "40.18593000",
                        "longitude": "31.35179000"
                    },
                    {
                        "id": 108346,
                        "name": "Polatlı",
                        "latitude": "39.57715000",
                        "longitude": "32.14132000"
                    },
                    {
                        "id": 108352,
                        "name": "Pursaklar",
                        "latitude": "40.03961000",
                        "longitude": "32.90139000"
                    },
                    {
                        "id": 108956,
                        "name": "Şereflikoçhisar",
                        "latitude": "38.93925000",
                        "longitude": "33.53860000"
                    },
                    {
                        "id": 108470,
                        "name": "Sincan",
                        "latitude": "39.95943000",
                        "longitude": "32.49567000"
                    },
                    {
                        "id": 108703,
                        "name": "Yenimahalle",
                        "latitude": "39.99043000",
                        "longitude": "32.69555000"
                    }
                ]
            },
            {
                "id": 2169,
                "name": "Antalya",
                "iso2": "07",
                "latitude": "37.09516720",
                "longitude": "31.07937050",
                "type": "province",
                "cities": [
                    {
                        "id": 107092,
                        "name": "Akseki",
                        "latitude": "37.04861000",
                        "longitude": "31.79000000"
                    },
                    {
                        "id": 107095,
                        "name": "Aksu",
                        "latitude": "36.95389000",
                        "longitude": "30.84778000"
                    },
                    {
                        "id": 107122,
                        "name": "Alanya",
                        "latitude": "36.54375000",
                        "longitude": "31.99982000"
                    },
                    {
                        "id": 153922,
                        "name": "Antalya",
                        "latitude": "36.89809830",
                        "longitude": "30.55329070"
                    },
                    {
                        "id": 107467,
                        "name": "Demre",
                        "latitude": "36.24444000",
                        "longitude": "29.98500000"
                    },
                    {
                        "id": 107541,
                        "name": "Döşemealtı",
                        "latitude": "37.02366000",
                        "longitude": "30.59040000"
                    },
                    {
                        "id": 107570,
                        "name": "Elmalı",
                        "latitude": "36.73583000",
                        "longitude": "29.91775000"
                    },
                    {
                        "id": 107641,
                        "name": "Finike",
                        "latitude": "36.42355000",
                        "longitude": "30.06645000"
                    },
                    {
                        "id": 107648,
                        "name": "Gazipaşa",
                        "latitude": "36.26942000",
                        "longitude": "32.31792000"
                    },
                    {
                        "id": 107740,
                        "name": "Gündoğmuş",
                        "latitude": "36.82446000",
                        "longitude": "32.00679000"
                    },
                    {
                        "id": 108877,
                        "name": "İbradı",
                        "latitude": "37.09694000",
                        "longitude": "31.59917000"
                    },
                    {
                        "id": 107962,
                        "name": "Kaş",
                        "latitude": "36.20176000",
                        "longitude": "29.63766000"
                    },
                    {
                        "id": 107978,
                        "name": "Kemer",
                        "latitude": "36.59778000",
                        "longitude": "30.56056000"
                    },
                    {
                        "id": 107981,
                        "name": "Kepez",
                        "latitude": "37.01187000",
                        "longitude": "30.75966000"
                    },
                    {
                        "id": 108017,
                        "name": "Konyaaltı",
                        "latitude": "36.86424000",
                        "longitude": "30.62714000"
                    },
                    {
                        "id": 108024,
                        "name": "Korkuteli",
                        "latitude": "37.06498000",
                        "longitude": "30.19565000"
                    },
                    {
                        "id": 108051,
                        "name": "Kumluca",
                        "latitude": "36.58000000",
                        "longitude": "30.30000000"
                    },
                    {
                        "id": 108148,
                        "name": "Manavgat",
                        "latitude": "36.78667000",
                        "longitude": "31.44306000"
                    },
                    {
                        "id": 108224,
                        "name": "Muratpaşa",
                        "latitude": "36.89157000",
                        "longitude": "30.76498000"
                    },
                    {
                        "id": 108441,
                        "name": "Serik",
                        "latitude": "37.07743000",
                        "longitude": "31.00677000"
                    }
                ]
            },
            {
                "id": 2185,
                "name": "Ardahan",
                "iso2": "75",
                "latitude": "41.11129640",
                "longitude": "42.78316740",
                "type": "province",
                "cities": [
                    {
                        "id": 108853,
                        "name": "Çıldır",
                        "latitude": "41.13783000",
                        "longitude": "43.14169000"
                    },
                    {
                        "id": 107444,
                        "name": "Damal",
                        "latitude": "41.34145000",
                        "longitude": "42.83680000"
                    },
                    {
                        "id": 107692,
                        "name": "Göle",
                        "latitude": "40.78746000",
                        "longitude": "42.60603000"
                    },
                    {
                        "id": 107788,
                        "name": "Hanak",
                        "latitude": "41.23344000",
                        "longitude": "42.84037000"
                    },
                    {
                        "id": 107179,
                        "name": "Merkez",
                        "latitude": "41.10871000",
                        "longitude": "42.70222000"
                    },
                    {
                        "id": 108347,
                        "name": "Posof",
                        "latitude": "41.51111000",
                        "longitude": "42.72917000"
                    }
                ]
            },
            {
                "id": 2191,
                "name": "Artvin",
                "iso2": "08",
                "latitude": "41.07866400",
                "longitude": "41.76282230",
                "type": "province",
                "cities": [
                    {
                        "id": 107180,
                        "name": "Ardanuç",
                        "latitude": "41.12738000",
                        "longitude": "42.06292000"
                    },
                    {
                        "id": 107184,
                        "name": "Arhavi",
                        "latitude": "41.35121000",
                        "longitude": "41.30456000"
                    },
                    {
                        "id": 107371,
                        "name": "Borçka",
                        "latitude": "41.35792000",
                        "longitude": "41.66579000"
                    },
                    {
                        "id": 107834,
                        "name": "Hopa",
                        "latitude": "41.39046000",
                        "longitude": "41.41966000"
                    },
                    {
                        "id": 107975,
                        "name": "Kemalpaşa",
                        "latitude": "41.48336000",
                        "longitude": "41.52750000"
                    },
                    {
                        "id": 107196,
                        "name": "Merkez",
                        "latitude": "41.18161000",
                        "longitude": "41.82172000"
                    },
                    {
                        "id": 108226,
                        "name": "Murgul",
                        "latitude": "41.27937000",
                        "longitude": "41.55514000"
                    },
                    {
                        "id": 108940,
                        "name": "Şavşat",
                        "latitude": "41.24027000",
                        "longitude": "42.36109000"
                    },
                    {
                        "id": 108741,
                        "name": "Yusufeli",
                        "latitude": "40.82042000",
                        "longitude": "41.53743000"
                    }
                ]
            },
            {
                "id": 2187,
                "name": "Aydın",
                "iso2": "09",
                "latitude": "37.81170330",
                "longitude": "28.48639630",
                "type": "province",
                "cities": [
                    {
                        "id": 107381,
                        "name": "Bozdoğan",
                        "latitude": "37.67134000",
                        "longitude": "28.31395000"
                    },
                    {
                        "id": 107402,
                        "name": "Buharkent",
                        "latitude": "37.96397000",
                        "longitude": "28.74270000"
                    },
                    {
                        "id": 108834,
                        "name": "Çine",
                        "latitude": "37.61266000",
                        "longitude": "28.05912000"
                    },
                    {
                        "id": 107493,
                        "name": "Didim",
                        "latitude": "37.39305000",
                        "longitude": "27.29357000"
                    },
                    {
                        "id": 107553,
                        "name": "Efeler",
                        "latitude": "37.83835000",
                        "longitude": "27.84557000"
                    },
                    {
                        "id": 107668,
                        "name": "Germencik",
                        "latitude": "37.87056000",
                        "longitude": "27.60283000"
                    },
                    {
                        "id": 108897,
                        "name": "İncirliova",
                        "latitude": "37.85222000",
                        "longitude": "27.72361000"
                    },
                    {
                        "id": 107893,
                        "name": "Karacasu",
                        "latitude": "37.74731000",
                        "longitude": "28.59402000"
                    },
                    {
                        "id": 107929,
                        "name": "Karpuzlu",
                        "latitude": "37.55861000",
                        "longitude": "27.83528000"
                    },
                    {
                        "id": 108036,
                        "name": "Koçarlı",
                        "latitude": "37.76113000",
                        "longitude": "27.70583000"
                    },
                    {
                        "id": 108084,
                        "name": "Köşk",
                        "latitude": "37.85333000",
                        "longitude": "28.05167000"
                    },
                    {
                        "id": 108067,
                        "name": "Kuşadası",
                        "latitude": "37.86014000",
                        "longitude": "27.25713000"
                    },
                    {
                        "id": 108063,
                        "name": "Kuyucak",
                        "latitude": "37.91330000",
                        "longitude": "28.45917000"
                    },
                    {
                        "id": 108243,
                        "name": "Nazilli",
                        "latitude": "37.93570000",
                        "longitude": "28.30609000"
                    },
                    {
                        "id": 108515,
                        "name": "Söke",
                        "latitude": "37.74820000",
                        "longitude": "27.40614000"
                    },
                    {
                        "id": 108497,
                        "name": "Sultanhisar",
                        "latitude": "37.88989000",
                        "longitude": "28.15436000"
                    },
                    {
                        "id": 108704,
                        "name": "Yenipazar",
                        "latitude": "37.82332000",
                        "longitude": "28.19573000"
                    }
                ]
            },
            {
                "id": 2175,
                "name": "Balıkesir",
                "iso2": "10",
                "latitude": "39.76167820",
                "longitude": "28.11226790",
                "type": "province",
                "cities": [
                    {
                        "id": 107138,
                        "name": "Altıeylül",
                        "latitude": "39.64099000",
                        "longitude": "27.88639000"
                    },
                    {
                        "id": 107233,
                        "name": "Ayvalık",
                        "latitude": "39.31927000",
                        "longitude": "26.69341000"
                    },
                    {
                        "id": 107273,
                        "name": "Balya",
                        "latitude": "39.74861000",
                        "longitude": "27.57889000"
                    },
                    {
                        "id": 107283,
                        "name": "Bandırma",
                        "latitude": "40.35222000",
                        "longitude": "27.97667000"
                    },
                    {
                        "id": 107354,
                        "name": "Bigadiç",
                        "latitude": "39.39250000",
                        "longitude": "28.13111000"
                    },
                    {
                        "id": 107412,
                        "name": "Burhaniye",
                        "latitude": "39.50041000",
                        "longitude": "26.97269000"
                    },
                    {
                        "id": 107532,
                        "name": "Dursunbey",
                        "latitude": "39.58596000",
                        "longitude": "28.62568000"
                    },
                    {
                        "id": 107550,
                        "name": "Edremit",
                        "latitude": "39.59611000",
                        "longitude": "27.02444000"
                    },
                    {
                        "id": 107584,
                        "name": "Erdek",
                        "latitude": "40.39960000",
                        "longitude": "27.79348000"
                    },
                    {
                        "id": 107705,
                        "name": "Gömeç",
                        "latitude": "39.39016000",
                        "longitude": "26.84127000"
                    },
                    {
                        "id": 107708,
                        "name": "Gönen",
                        "latitude": "40.10490000",
                        "longitude": "27.65399000"
                    },
                    {
                        "id": 107806,
                        "name": "Havran",
                        "latitude": "39.55833000",
                        "longitude": "27.09833000"
                    },
                    {
                        "id": 108920,
                        "name": "İvrindi",
                        "latitude": "39.58389000",
                        "longitude": "27.48639000"
                    },
                    {
                        "id": 153352,
                        "name": "Karesi",
                        "latitude": "39.64833300",
                        "longitude": "27.88250000"
                    },
                    {
                        "id": 107982,
                        "name": "Kepsut",
                        "latitude": "39.68889000",
                        "longitude": "28.15222000"
                    },
                    {
                        "id": 108151,
                        "name": "Manyas",
                        "latitude": "40.04639000",
                        "longitude": "27.97000000"
                    },
                    {
                        "id": 108155,
                        "name": "Marmara",
                        "latitude": "40.58633000",
                        "longitude": "27.55541000"
                    },
                    {
                        "id": 108417,
                        "name": "Savaştepe",
                        "latitude": "39.38319000",
                        "longitude": "27.65612000"
                    },
                    {
                        "id": 108527,
                        "name": "Sındırgı",
                        "latitude": "39.24128000",
                        "longitude": "28.17842000"
                    },
                    {
                        "id": 108509,
                        "name": "Susurluk",
                        "latitude": "39.91361000",
                        "longitude": "28.15778000"
                    }
                ]
            },
            {
                "id": 2148,
                "name": "Bartın",
                "iso2": "74",
                "latitude": "41.58105090",
                "longitude": "32.46097940",
                "type": "province",
                "cities": [
                    {
                        "id": 107155,
                        "name": "Amasra",
                        "latitude": "41.74633000",
                        "longitude": "32.38633000"
                    },
                    {
                        "id": 108057,
                        "name": "Kurucaşile",
                        "latitude": "41.83781000",
                        "longitude": "32.71621000"
                    },
                    {
                        "id": 107286,
                        "name": "Merkez",
                        "latitude": "41.63583000",
                        "longitude": "32.33750000"
                    },
                    {
                        "id": 108629,
                        "name": "Ulus",
                        "latitude": "41.59373000",
                        "longitude": "32.65066000"
                    }
                ]
            },
            {
                "id": 2194,
                "name": "Batman",
                "iso2": "72",
                "latitude": "37.83624960",
                "longitude": "41.36057390",
                "type": "province",
                "cities": [
                    {
                        "id": 107350,
                        "name": "Beşiri",
                        "latitude": "37.91573000",
                        "longitude": "41.28650000"
                    },
                    {
                        "id": 107663,
                        "name": "Gercüş",
                        "latitude": "37.59139000",
                        "longitude": "41.33278000"
                    },
                    {
                        "id": 107800,
                        "name": "Hasankeyf",
                        "latitude": "37.70612000",
                        "longitude": "41.40480000"
                    },
                    {
                        "id": 108035,
                        "name": "Kozluk",
                        "latitude": "38.19249000",
                        "longitude": "41.48705000"
                    },
                    {
                        "id": 108186,
                        "name": "Merkez",
                        "latitude": "37.84362000",
                        "longitude": "41.18341000"
                    },
                    {
                        "id": 108415,
                        "name": "Sason",
                        "latitude": "38.32767000",
                        "longitude": "41.41377000"
                    }
                ]
            },
            {
                "id": 2177,
                "name": "Bayburt",
                "iso2": "69",
                "latitude": "40.26032000",
                "longitude": "40.22804800",
                "type": "province",
                "cities": [
                    {
                        "id": 107226,
                        "name": "Aydıntepe",
                        "latitude": "40.38325000",
                        "longitude": "40.14272000"
                    },
                    {
                        "id": 107466,
                        "name": "Demirözü",
                        "latitude": "40.16560000",
                        "longitude": "39.89343000"
                    },
                    {
                        "id": 107297,
                        "name": "Merkez",
                        "latitude": "40.25631000",
                        "longitude": "40.22289000"
                    }
                ]
            },
            {
                "id": 2221,
                "name": "Bilecik",
                "iso2": "11",
                "latitude": "40.05665550",
                "longitude": "30.06652360",
                "type": "province",
                "cities": [
                    {
                        "id": 107393,
                        "name": "Bozüyük",
                        "latitude": "39.90778000",
                        "longitude": "30.03667000"
                    },
                    {
                        "id": 107702,
                        "name": "Gölpazarı",
                        "latitude": "40.28472000",
                        "longitude": "30.31722000"
                    },
                    {
                        "id": 108903,
                        "name": "İnhisar",
                        "latitude": "40.04932000",
                        "longitude": "30.38521000"
                    },
                    {
                        "id": 107356,
                        "name": "Merkez",
                        "latitude": "40.14192000",
                        "longitude": "29.97932000"
                    },
                    {
                        "id": 108291,
                        "name": "Osmaneli",
                        "latitude": "40.35722000",
                        "longitude": "30.01417000"
                    },
                    {
                        "id": 108329,
                        "name": "Pazaryeri",
                        "latitude": "39.99395000",
                        "longitude": "29.90424000"
                    },
                    {
                        "id": 108518,
                        "name": "Söğüt",
                        "latitude": "40.02479000",
                        "longitude": "30.17300000"
                    },
                    {
                        "id": 108705,
                        "name": "Yenipazar",
                        "latitude": "40.17833000",
                        "longitude": "30.52000000"
                    }
                ]
            },
            {
                "id": 2153,
                "name": "Bingöl",
                "iso2": "12",
                "latitude": "39.06263540",
                "longitude": "40.76960950",
                "type": "province",
                "cities": [
                    {
                        "id": 107060,
                        "name": "Adaklı",
                        "latitude": "39.22870000",
                        "longitude": "40.48252000"
                    },
                    {
                        "id": 107661,
                        "name": "Genç",
                        "latitude": "38.74773000",
                        "longitude": "40.55343000"
                    },
                    {
                        "id": 107927,
                        "name": "Karlıova",
                        "latitude": "39.29044000",
                        "longitude": "41.00594000"
                    },
                    {
                        "id": 108002,
                        "name": "Kiğı",
                        "latitude": "39.30894000",
                        "longitude": "40.34995000"
                    },
                    {
                        "id": 108182,
                        "name": "Merkez",
                        "latitude": "38.95025000",
                        "longitude": "40.52802000"
                    },
                    {
                        "id": 108483,
                        "name": "Solhan",
                        "latitude": "38.96525000",
                        "longitude": "41.05443000"
                    },
                    {
                        "id": 108681,
                        "name": "Yayladere",
                        "latitude": "39.22614000",
                        "longitude": "40.06950000"
                    },
                    {
                        "id": 108688,
                        "name": "Yedisu",
                        "latitude": "39.43277000",
                        "longitude": "40.53368000"
                    }
                ]
            },
            {
                "id": 2215,
                "name": "Bitlis",
                "iso2": "13",
                "latitude": "38.65231330",
                "longitude": "42.42020280",
                "type": "province",
                "cities": [
                    {
                        "id": 107065,
                        "name": "Adilcevaz",
                        "latitude": "38.79911000",
                        "longitude": "42.73159000"
                    },
                    {
                        "id": 107071,
                        "name": "Ahlat",
                        "latitude": "38.74890000",
                        "longitude": "42.48007000"
                    },
                    {
                        "id": 107751,
                        "name": "Güroymak",
                        "latitude": "38.57580000",
                        "longitude": "42.01558000"
                    },
                    {
                        "id": 107829,
                        "name": "Hizan",
                        "latitude": "38.22498000",
                        "longitude": "42.41830000"
                    },
                    {
                        "id": 108189,
                        "name": "Merkez",
                        "latitude": "38.31702000",
                        "longitude": "42.10065000"
                    },
                    {
                        "id": 108233,
                        "name": "Mutki",
                        "latitude": "38.40624000",
                        "longitude": "41.92018000"
                    },
                    {
                        "id": 108538,
                        "name": "Tatvan",
                        "latitude": "38.49221000",
                        "longitude": "42.28269000"
                    }
                ]
            },
            {
                "id": 2172,
                "name": "Bolu",
                "iso2": "14",
                "latitude": "40.57597660",
                "longitude": "31.57880860",
                "type": "province",
                "cities": [
                    {
                        "id": 107537,
                        "name": "Dörtdivan",
                        "latitude": "40.72052000",
                        "longitude": "32.06314000"
                    },
                    {
                        "id": 107665,
                        "name": "Gerede",
                        "latitude": "40.71364000",
                        "longitude": "32.31263000"
                    },
                    {
                        "id": 107719,
                        "name": "Göynük",
                        "latitude": "40.40028000",
                        "longitude": "30.78833000"
                    },
                    {
                        "id": 108096,
                        "name": "Kıbrıscık",
                        "latitude": "40.40778000",
                        "longitude": "31.85194000"
                    },
                    {
                        "id": 108172,
                        "name": "Mengen",
                        "latitude": "40.93877000",
                        "longitude": "32.07642000"
                    },
                    {
                        "id": 107366,
                        "name": "Merkez",
                        "latitude": "40.73583000",
                        "longitude": "31.60611000"
                    },
                    {
                        "id": 108218,
                        "name": "Mudurnu",
                        "latitude": "40.47300000",
                        "longitude": "31.20755000"
                    },
                    {
                        "id": 108421,
                        "name": "Seben",
                        "latitude": "40.41134000",
                        "longitude": "31.57359000"
                    },
                    {
                        "id": 108709,
                        "name": "Yeniçağa",
                        "latitude": "40.77115000",
                        "longitude": "32.03375000"
                    }
                ]
            },
            {
                "id": 2209,
                "name": "Burdur",
                "iso2": "15",
                "latitude": "37.46126690",
                "longitude": "30.06652360",
                "type": "province",
                "cities": [
                    {
                        "id": 107241,
                        "name": "Ağlasun",
                        "latitude": "37.64944000",
                        "longitude": "30.53417000"
                    },
                    {
                        "id": 107148,
                        "name": "Altınyayla",
                        "latitude": "36.99722000",
                        "longitude": "29.54579000"
                    },
                    {
                        "id": 107400,
                        "name": "Bucak",
                        "latitude": "37.45917000",
                        "longitude": "30.59500000"
                    },
                    {
                        "id": 108793,
                        "name": "Çavdır",
                        "latitude": "37.16483000",
                        "longitude": "29.69937000"
                    },
                    {
                        "id": 108817,
                        "name": "Çeltikçi",
                        "latitude": "37.53885000",
                        "longitude": "30.46823000"
                    },
                    {
                        "id": 107695,
                        "name": "Gölhisar",
                        "latitude": "37.14590000",
                        "longitude": "29.50876000"
                    },
                    {
                        "id": 107906,
                        "name": "Karamanlı",
                        "latitude": "37.37301000",
                        "longitude": "29.82308000"
                    },
                    {
                        "id": 107977,
                        "name": "Kemer",
                        "latitude": "37.35222000",
                        "longitude": "30.06306000"
                    },
                    {
                        "id": 108180,
                        "name": "Merkez",
                        "latitude": "37.62762000",
                        "longitude": "30.20408000"
                    },
                    {
                        "id": 108556,
                        "name": "Tefenni",
                        "latitude": "37.30968000",
                        "longitude": "29.77538000"
                    },
                    {
                        "id": 108726,
                        "name": "Yeşilova",
                        "latitude": "37.50806000",
                        "longitude": "29.75472000"
                    }
                ]
            },
            {
                "id": 2163,
                "name": "Bursa",
                "iso2": "16",
                "latitude": "40.06554590",
                "longitude": "29.23207840",
                "type": "province",
                "cities": [
                    {
                        "id": 107419,
                        "name": "Büyükorhan",
                        "latitude": "39.78223000",
                        "longitude": "28.89338000"
                    },
                    {
                        "id": 107660,
                        "name": "Gemlik",
                        "latitude": "40.43510000",
                        "longitude": "29.14943000"
                    },
                    {
                        "id": 107756,
                        "name": "Gürsu",
                        "latitude": "40.25498000",
                        "longitude": "29.21183000"
                    },
                    {
                        "id": 107795,
                        "name": "Harmancık",
                        "latitude": "39.67743000",
                        "longitude": "29.15523000"
                    },
                    {
                        "id": 108901,
                        "name": "İnegöl",
                        "latitude": "40.07806000",
                        "longitude": "29.51333000"
                    },
                    {
                        "id": 108925,
                        "name": "İznik",
                        "latitude": "40.42861000",
                        "longitude": "29.72111000"
                    },
                    {
                        "id": 107890,
                        "name": "Karacabey",
                        "latitude": "40.21323000",
                        "longitude": "28.36120000"
                    },
                    {
                        "id": 107967,
                        "name": "Keles",
                        "latitude": "39.91361000",
                        "longitude": "29.22944000"
                    },
                    {
                        "id": 107987,
                        "name": "Kestel",
                        "latitude": "40.19828000",
                        "longitude": "29.21237000"
                    },
                    {
                        "id": 108217,
                        "name": "Mudanya",
                        "latitude": "40.33342000",
                        "longitude": "28.77218000"
                    },
                    {
                        "id": 108230,
                        "name": "Mustafakemalpaşa",
                        "latitude": "40.03815000",
                        "longitude": "28.40866000"
                    },
                    {
                        "id": 108249,
                        "name": "Nilüfer",
                        "latitude": "40.21375000",
                        "longitude": "28.98464000"
                    },
                    {
                        "id": 108272,
                        "name": "Orhaneli",
                        "latitude": "39.90333000",
                        "longitude": "28.99056000"
                    },
                    {
                        "id": 108274,
                        "name": "Orhangazi",
                        "latitude": "40.48917000",
                        "longitude": "29.30889000"
                    },
                    {
                        "id": 108293,
                        "name": "Osmangazi",
                        "latitude": "40.15644000",
                        "longitude": "29.08753000"
                    },
                    {
                        "id": 108714,
                        "name": "Yenişehir",
                        "latitude": "40.26444000",
                        "longitude": "29.65306000"
                    },
                    {
                        "id": 108746,
                        "name": "Yıldırım",
                        "latitude": "40.19567000",
                        "longitude": "29.03640000"
                    }
                ]
            },
            {
                "id": 2216,
                "name": "Çanakkale",
                "iso2": "17",
                "latitude": "40.05101040",
                "longitude": "26.98524220",
                "type": "province",
                "cities": [
                    {
                        "id": 107229,
                        "name": "Ayvacık",
                        "latitude": "39.60111000",
                        "longitude": "26.40472000"
                    },
                    {
                        "id": 107301,
                        "name": "Bayramiç",
                        "latitude": "39.81951000",
                        "longitude": "26.62490000"
                    },
                    {
                        "id": 107353,
                        "name": "Biga",
                        "latitude": "40.26921000",
                        "longitude": "27.20841000"
                    },
                    {
                        "id": 107380,
                        "name": "Bozcaada",
                        "latitude": "39.82409000",
                        "longitude": "26.04069000"
                    },
                    {
                        "id": 108773,
                        "name": "Çan",
                        "latitude": "40.03328000",
                        "longitude": "27.05236000"
                    },
                    {
                        "id": 107548,
                        "name": "Eceabat",
                        "latitude": "40.18416000",
                        "longitude": "26.35740000"
                    },
                    {
                        "id": 107623,
                        "name": "Ezine",
                        "latitude": "39.78561000",
                        "longitude": "26.34083000"
                    },
                    {
                        "id": 107655,
                        "name": "Gelibolu",
                        "latitude": "40.41028000",
                        "longitude": "26.67083000"
                    },
                    {
                        "id": 107683,
                        "name": "Gökçeada",
                        "latitude": "40.16523000",
                        "longitude": "25.85907000"
                    },
                    {
                        "id": 108127,
                        "name": "Lapseki",
                        "latitude": "40.34417000",
                        "longitude": "26.68556000"
                    },
                    {
                        "id": 108193,
                        "name": "Merkez",
                        "latitude": "40.05093000",
                        "longitude": "26.49489000"
                    },
                    {
                        "id": 108691,
                        "name": "Yenice",
                        "latitude": "39.93083000",
                        "longitude": "27.25806000"
                    }
                ]
            },
            {
                "id": 2168,
                "name": "Çankırı",
                "iso2": "18",
                "latitude": "40.53690730",
                "longitude": "33.58838930",
                "type": "province",
                "cities": [
                    {
                        "id": 107208,
                        "name": "Atkaracalar",
                        "latitude": "40.81593000",
                        "longitude": "33.07556000"
                    },
                    {
                        "id": 107303,
                        "name": "Bayramören",
                        "latitude": "40.94329000",
                        "longitude": "33.20300000"
                    },
                    {
                        "id": 108820,
                        "name": "Çerkeş",
                        "latitude": "40.81164000",
                        "longitude": "32.89358000"
                    },
                    {
                        "id": 107564,
                        "name": "Eldivan",
                        "latitude": "40.52975000",
                        "longitude": "33.49903000"
                    },
                    {
                        "id": 107844,
                        "name": "Ilgaz",
                        "latitude": "40.92511000",
                        "longitude": "33.62586000"
                    },
                    {
                        "id": 108122,
                        "name": "Kızılırmak",
                        "latitude": "40.34556000",
                        "longitude": "33.98639000"
                    },
                    {
                        "id": 108020,
                        "name": "Korgun",
                        "latitude": "40.73479000",
                        "longitude": "33.51844000"
                    },
                    {
                        "id": 108060,
                        "name": "Kurşunlu",
                        "latitude": "40.84101000",
                        "longitude": "33.26028000"
                    },
                    {
                        "id": 153353,
                        "name": "Merkez",
                        "latitude": "40.60000000",
                        "longitude": "33.61666700"
                    },
                    {
                        "id": 108276,
                        "name": "Orta",
                        "latitude": "40.62420000",
                        "longitude": "33.10928000"
                    },
                    {
                        "id": 108928,
                        "name": "Şabanözü",
                        "latitude": "40.48333000",
                        "longitude": "33.28333000"
                    },
                    {
                        "id": 108673,
                        "name": "Yapraklı",
                        "latitude": "40.75785000",
                        "longitude": "33.77819000"
                    }
                ]
            },
            {
                "id": 2173,
                "name": "Çorum",
                "iso2": "19",
                "latitude": "40.49982110",
                "longitude": "34.59862630",
                "type": "province",
                "cities": [
                    {
                        "id": 107117,
                        "name": "Alaca",
                        "latitude": "40.16833000",
                        "longitude": "34.84250000"
                    },
                    {
                        "id": 107294,
                        "name": "Bayat",
                        "latitude": "40.64583000",
                        "longitude": "34.26139000"
                    },
                    {
                        "id": 107395,
                        "name": "Boğazkale",
                        "latitude": "40.03031000",
                        "longitude": "34.61745000"
                    },
                    {
                        "id": 107506,
                        "name": "Dodurga",
                        "latitude": "40.85489000",
                        "longitude": "34.80703000"
                    },
                    {
                        "id": 108915,
                        "name": "İskilip",
                        "latitude": "40.73528000",
                        "longitude": "34.47389000"
                    },
                    {
                        "id": 107924,
                        "name": "Kargı",
                        "latitude": "41.14377000",
                        "longitude": "34.49342000"
                    },
                    {
                        "id": 108128,
                        "name": "Laçin",
                        "latitude": "40.77486000",
                        "longitude": "34.88068000"
                    },
                    {
                        "id": 108167,
                        "name": "Mecitözü",
                        "latitude": "40.52000000",
                        "longitude": "35.29528000"
                    },
                    {
                        "id": 108185,
                        "name": "Merkez",
                        "latitude": "40.50905000",
                        "longitude": "34.85791000"
                    },
                    {
                        "id": 108305,
                        "name": "Oğuzlar",
                        "latitude": "40.76323000",
                        "longitude": "34.70813000"
                    },
                    {
                        "id": 108286,
                        "name": "Ortaköy",
                        "latitude": "40.27352000",
                        "longitude": "35.25175000"
                    },
                    {
                        "id": 108290,
                        "name": "Osmancık",
                        "latitude": "41.00240000",
                        "longitude": "34.78243000"
                    },
                    {
                        "id": 108505,
                        "name": "Sungurlu",
                        "latitude": "40.18213000",
                        "longitude": "34.28217000"
                    },
                    {
                        "id": 108642,
                        "name": "Uğurludağ",
                        "latitude": "40.44631000",
                        "longitude": "34.45259000"
                    }
                ]
            },
            {
                "id": 2157,
                "name": "Denizli",
                "iso2": "20",
                "latitude": "37.61283950",
                "longitude": "29.23207840",
                "type": "province",
                "cities": [
                    {
                        "id": 107057,
                        "name": "Acıpayam",
                        "latitude": "37.42385000",
                        "longitude": "29.34941000"
                    },
                    {
                        "id": 107252,
                        "name": "Babadağ",
                        "latitude": "37.80764000",
                        "longitude": "28.85665000"
                    },
                    {
                        "id": 107265,
                        "name": "Baklan",
                        "latitude": "37.97694000",
                        "longitude": "29.60861000"
                    },
                    {
                        "id": 107326,
                        "name": "Bekilli",
                        "latitude": "38.24027000",
                        "longitude": "29.42559000"
                    },
                    {
                        "id": 107334,
                        "name": "Beyağaç",
                        "latitude": "37.24546000",
                        "longitude": "28.90041000"
                    },
                    {
                        "id": 107384,
                        "name": "Bozkurt",
                        "latitude": "37.77583000",
                        "longitude": "29.60811000"
                    },
                    {
                        "id": 107408,
                        "name": "Buldan",
                        "latitude": "38.04500000",
                        "longitude": "28.83056000"
                    },
                    {
                        "id": 108759,
                        "name": "Çal",
                        "latitude": "38.09371000",
                        "longitude": "29.40467000"
                    },
                    {
                        "id": 108767,
                        "name": "Çameli",
                        "latitude": "37.08660000",
                        "longitude": "29.35225000"
                    },
                    {
                        "id": 108781,
                        "name": "Çardak",
                        "latitude": "37.77485000",
                        "longitude": "29.70593000"
                    },
                    {
                        "id": 108836,
                        "name": "Çivril",
                        "latitude": "38.30139000",
                        "longitude": "29.73861000"
                    },
                    {
                        "id": 107742,
                        "name": "Güney",
                        "latitude": "38.16454000",
                        "longitude": "29.07324000"
                    },
                    {
                        "id": 107833,
                        "name": "Honaz",
                        "latitude": "37.77146000",
                        "longitude": "29.34466000"
                    },
                    {
                        "id": 107871,
                        "name": "Kale",
                        "latitude": "37.43917000",
                        "longitude": "28.84528000"
                    },
                    {
                        "id": 108196,
                        "name": "Merkezefendi",
                        "latitude": "37.80544000",
                        "longitude": "29.04236000"
                    },
                    {
                        "id": 108310,
                        "name": "Pamukkale",
                        "latitude": "37.91644000",
                        "longitude": "29.11729000"
                    },
                    {
                        "id": 108393,
                        "name": "Sarayköy",
                        "latitude": "37.91580000",
                        "longitude": "28.87999000"
                    },
                    {
                        "id": 108442,
                        "name": "Serinhisar",
                        "latitude": "37.58105000",
                        "longitude": "29.26639000"
                    },
                    {
                        "id": 108540,
                        "name": "Tavas",
                        "latitude": "37.57351000",
                        "longitude": "29.07058000"
                    }
                ]
            },
            {
                "id": 2226,
                "name": "Diyarbakır",
                "iso2": "21",
                "latitude": "38.10663720",
                "longitude": "40.54268960",
                "type": "province",
                "cities": [
                    {
                        "id": 107309,
                        "name": "Bağlar",
                        "latitude": "37.91068000",
                        "longitude": "40.22627000"
                    },
                    {
                        "id": 107362,
                        "name": "Bismil",
                        "latitude": "37.84514000",
                        "longitude": "40.65931000"
                    },
                    {
                        "id": 108822,
                        "name": "Çermik",
                        "latitude": "38.13538000",
                        "longitude": "39.44500000"
                    },
                    {
                        "id": 108854,
                        "name": "Çınar",
                        "latitude": "37.72562000",
                        "longitude": "40.41484000"
                    },
                    {
                        "id": 108851,
                        "name": "Çüngüş",
                        "latitude": "38.20798000",
                        "longitude": "39.28554000"
                    },
                    {
                        "id": 107491,
                        "name": "Dicle",
                        "latitude": "38.36571000",
                        "longitude": "40.06450000"
                    },
                    {
                        "id": 107625,
                        "name": "Eğil",
                        "latitude": "38.25748000",
                        "longitude": "40.07435000"
                    },
                    {
                        "id": 107592,
                        "name": "Ergani",
                        "latitude": "38.26899000",
                        "longitude": "39.75446000"
                    },
                    {
                        "id": 107790,
                        "name": "Hani",
                        "latitude": "38.40741000",
                        "longitude": "40.38578000"
                    },
                    {
                        "id": 107817,
                        "name": "Hazro",
                        "latitude": "38.24903000",
                        "longitude": "40.77129000"
                    },
                    {
                        "id": 107948,
                        "name": "Kayapınar",
                        "latitude": "37.93800000",
                        "longitude": "40.17310000"
                    },
                    {
                        "id": 108008,
                        "name": "Kocaköy",
                        "latitude": "38.28889000",
                        "longitude": "40.49786000"
                    },
                    {
                        "id": 108040,
                        "name": "Kulp",
                        "latitude": "38.49754000",
                        "longitude": "41.00668000"
                    },
                    {
                        "id": 108130,
                        "name": "Lice",
                        "latitude": "38.45821000",
                        "longitude": "40.63888000"
                    },
                    {
                        "id": 108463,
                        "name": "Silvan",
                        "latitude": "38.13708000",
                        "longitude": "41.00817000"
                    },
                    {
                        "id": 108506,
                        "name": "Sur",
                        "latitude": "37.91356000",
                        "longitude": "40.23743000"
                    },
                    {
                        "id": 108716,
                        "name": "Yenişehir",
                        "latitude": "37.91373000",
                        "longitude": "40.20610000"
                    }
                ]
            },
            {
                "id": 2202,
                "name": "Düzce",
                "iso2": "81",
                "latitude": "40.87705310",
                "longitude": "31.31927130",
                "type": "province",
                "cities": [
                    {
                        "id": 107110,
                        "name": "Akçakoca",
                        "latitude": "41.08663000",
                        "longitude": "31.11623000"
                    },
                    {
                        "id": 108833,
                        "name": "Çilimli",
                        "latitude": "40.90267000",
                        "longitude": "31.05913000"
                    },
                    {
                        "id": 107438,
                        "name": "Cumayeri",
                        "latitude": "40.88176000",
                        "longitude": "30.94094000"
                    },
                    {
                        "id": 107704,
                        "name": "Gölyaka",
                        "latitude": "40.78644000",
                        "longitude": "31.00276000"
                    },
                    {
                        "id": 107739,
                        "name": "Gümüşova",
                        "latitude": "40.85640000",
                        "longitude": "30.94935000"
                    },
                    {
                        "id": 107953,
                        "name": "Kaynaşlı",
                        "latitude": "40.77908000",
                        "longitude": "31.31135000"
                    },
                    {
                        "id": 107542,
                        "name": "Merkez",
                        "latitude": "40.83889000",
                        "longitude": "31.16389000"
                    },
                    {
                        "id": 108748,
                        "name": "Yığılca",
                        "latitude": "40.96497000",
                        "longitude": "31.45672000"
                    }
                ]
            },
            {
                "id": 2151,
                "name": "Edirne",
                "iso2": "22",
                "latitude": "41.15172220",
                "longitude": "26.51379640",
                "type": "province",
                "cities": [
                    {
                        "id": 107580,
                        "name": "Enez",
                        "latitude": "40.72472000",
                        "longitude": "26.08250000"
                    },
                    {
                        "id": 107807,
                        "name": "Havsa",
                        "latitude": "41.54898000",
                        "longitude": "26.82207000"
                    },
                    {
                        "id": 108909,
                        "name": "İpsala",
                        "latitude": "40.92115000",
                        "longitude": "26.38273000"
                    },
                    {
                        "id": 107992,
                        "name": "Keşan",
                        "latitude": "40.85583000",
                        "longitude": "26.63028000"
                    },
                    {
                        "id": 108133,
                        "name": "Lâlapaşa",
                        "latitude": "41.83951000",
                        "longitude": "26.73561000"
                    },
                    {
                        "id": 108176,
                        "name": "Meriç",
                        "latitude": "41.19183000",
                        "longitude": "26.42097000"
                    },
                    {
                        "id": 107549,
                        "name": "Merkez",
                        "latitude": "41.67719000",
                        "longitude": "26.55597000"
                    },
                    {
                        "id": 108523,
                        "name": "Süloğlu",
                        "latitude": "41.77956000",
                        "longitude": "26.92602000"
                    },
                    {
                        "id": 108640,
                        "name": "Uzunköprü",
                        "latitude": "41.26597000",
                        "longitude": "26.68850000"
                    }
                ]
            },
            {
                "id": 2159,
                "name": "Elazığ",
                "iso2": "23",
                "latitude": "38.49648040",
                "longitude": "39.21990290",
                "type": "province",
                "cities": [
                    {
                        "id": 107246,
                        "name": "Ağın",
                        "latitude": "38.93792000",
                        "longitude": "38.71155000"
                    },
                    {
                        "id": 153354,
                        "name": "Alacakaya",
                        "latitude": "38.46269800",
                        "longitude": "39.86275800"
                    },
                    {
                        "id": 107197,
                        "name": "Arıcak",
                        "latitude": "38.56340000",
                        "longitude": "40.12480000"
                    },
                    {
                        "id": 107288,
                        "name": "Baskil",
                        "latitude": "38.56866000",
                        "longitude": "38.81634000"
                    },
                    {
                        "id": 107901,
                        "name": "Karakoçan",
                        "latitude": "38.95178000",
                        "longitude": "40.02706000"
                    },
                    {
                        "id": 107964,
                        "name": "Keban",
                        "latitude": "38.79380000",
                        "longitude": "38.73517000"
                    },
                    {
                        "id": 108027,
                        "name": "Kovancılar",
                        "latitude": "38.71882000",
                        "longitude": "39.86268000"
                    },
                    {
                        "id": 108137,
                        "name": "Maden",
                        "latitude": "38.39354000",
                        "longitude": "39.67252000"
                    },
                    {
                        "id": 108188,
                        "name": "Merkez",
                        "latitude": "38.66790000",
                        "longitude": "39.21567000"
                    },
                    {
                        "id": 108308,
                        "name": "Palu",
                        "latitude": "38.69135000",
                        "longitude": "39.91984000"
                    },
                    {
                        "id": 108479,
                        "name": "Sivrice",
                        "latitude": "38.44223000",
                        "longitude": "39.30938000"
                    }
                ]
            },
            {
                "id": 2160,
                "name": "Erzincan",
                "iso2": "24",
                "latitude": "39.76819140",
                "longitude": "39.05013060",
                "type": "province",
                "cities": [
                    {
                        "id": 108806,
                        "name": "Çayırlı",
                        "latitude": "39.80454000",
                        "longitude": "40.03724000"
                    },
                    {
                        "id": 108890,
                        "name": "İliç",
                        "latitude": "39.45587000",
                        "longitude": "38.56409000"
                    },
                    {
                        "id": 107971,
                        "name": "Kemah",
                        "latitude": "39.59606000",
                        "longitude": "39.02329000"
                    },
                    {
                        "id": 107973,
                        "name": "Kemaliye",
                        "latitude": "39.26288000",
                        "longitude": "38.49674000"
                    },
                    {
                        "id": 107602,
                        "name": "Merkez",
                        "latitude": "39.73919000",
                        "longitude": "39.49015000"
                    },
                    {
                        "id": 108295,
                        "name": "Otlukbeli",
                        "latitude": "39.97000000",
                        "longitude": "40.01872000"
                    },
                    {
                        "id": 108365,
                        "name": "Refahiye",
                        "latitude": "39.89315000",
                        "longitude": "38.76607000"
                    },
                    {
                        "id": 108570,
                        "name": "Tercan",
                        "latitude": "39.77709000",
                        "longitude": "40.37783000"
                    },
                    {
                        "id": 108876,
                        "name": "Üzümlü",
                        "latitude": "39.70943000",
                        "longitude": "39.70125000"
                    }
                ]
            },
            {
                "id": 2165,
                "name": "Erzurum",
                "iso2": "25",
                "latitude": "40.07467990",
                "longitude": "41.66945620",
                "type": "province",
                "cities": [
                    {
                        "id": 107250,
                        "name": "Aşkale",
                        "latitude": "39.92083000",
                        "longitude": "40.69500000"
                    },
                    {
                        "id": 107237,
                        "name": "Aziziye",
                        "latitude": "39.94028000",
                        "longitude": "41.11153000"
                    },
                    {
                        "id": 108786,
                        "name": "Çat",
                        "latitude": "39.61055000",
                        "longitude": "40.97851000"
                    },
                    {
                        "id": 107842,
                        "name": "Hınıs",
                        "latitude": "39.35766000",
                        "longitude": "41.69253000"
                    },
                    {
                        "id": 107836,
                        "name": "Horasan",
                        "latitude": "40.03885000",
                        "longitude": "42.16366000"
                    },
                    {
                        "id": 108918,
                        "name": "İspir",
                        "latitude": "40.47981000",
                        "longitude": "40.99373000"
                    },
                    {
                        "id": 107921,
                        "name": "Karaçoban",
                        "latitude": "39.34364000",
                        "longitude": "42.09918000"
                    },
                    {
                        "id": 107919,
                        "name": "Karayazı",
                        "latitude": "39.69604000",
                        "longitude": "42.14277000"
                    },
                    {
                        "id": 108076,
                        "name": "Köprüköy",
                        "latitude": "39.97178000",
                        "longitude": "41.86804000"
                    },
                    {
                        "id": 108241,
                        "name": "Narman",
                        "latitude": "40.34449000",
                        "longitude": "41.86088000"
                    },
                    {
                        "id": 108265,
                        "name": "Oltu",
                        "latitude": "40.53945000",
                        "longitude": "41.98722000"
                    },
                    {
                        "id": 108267,
                        "name": "Olur",
                        "latitude": "40.82165000",
                        "longitude": "42.13055000"
                    },
                    {
                        "id": 108307,
                        "name": "Palandöken",
                        "latitude": "39.85560000",
                        "longitude": "41.27975000"
                    },
                    {
                        "id": 108314,
                        "name": "Pasinler",
                        "latitude": "39.97975000",
                        "longitude": "41.66997000"
                    },
                    {
                        "id": 108331,
                        "name": "Pazaryolu",
                        "latitude": "40.41142000",
                        "longitude": "40.76780000"
                    },
                    {
                        "id": 108950,
                        "name": "Şenkaya",
                        "latitude": "40.55652000",
                        "longitude": "42.34266000"
                    },
                    {
                        "id": 108562,
                        "name": "Tekman",
                        "latitude": "39.64111000",
                        "longitude": "41.50542000"
                    },
                    {
                        "id": 108589,
                        "name": "Tortum",
                        "latitude": "40.28892000",
                        "longitude": "41.54096000"
                    },
                    {
                        "id": 108636,
                        "name": "Uzundere",
                        "latitude": "40.53218000",
                        "longitude": "41.53832000"
                    },
                    {
                        "id": 108663,
                        "name": "Yakutiye",
                        "latitude": "40.00132000",
                        "longitude": "41.30997000"
                    }
                ]
            },
            {
                "id": 2164,
                "name": "Eskişehir",
                "iso2": "26",
                "latitude": "39.63296570",
                "longitude": "31.26263660",
                "type": "province",
                "cities": [
                    {
                        "id": 107133,
                        "name": "Alpu",
                        "latitude": "39.76903000",
                        "longitude": "30.96060000"
                    },
                    {
                        "id": 107339,
                        "name": "Beylikova",
                        "latitude": "39.68694000",
                        "longitude": "31.20556000"
                    },
                    {
                        "id": 108827,
                        "name": "Çifteler",
                        "latitude": "39.38306000",
                        "longitude": "31.03917000"
                    },
                    {
                        "id": 107748,
                        "name": "Günyüzü",
                        "latitude": "39.39410000",
                        "longitude": "31.81400000"
                    },
                    {
                        "id": 107786,
                        "name": "Han",
                        "latitude": "39.15917000",
                        "longitude": "30.86139000"
                    },
                    {
                        "id": 108906,
                        "name": "İnönü",
                        "latitude": "39.81534000",
                        "longitude": "30.14549000"
                    },
                    {
                        "id": 108138,
                        "name": "Mahmudiye",
                        "latitude": "39.50724000",
                        "longitude": "30.99247000"
                    },
                    {
                        "id": 108208,
                        "name": "Mihalgazi",
                        "latitude": "40.02621000",
                        "longitude": "30.57707000"
                    },
                    {
                        "id": 108210,
                        "name": "Mihalıççık",
                        "latitude": "39.87564000",
                        "longitude": "31.50091000"
                    },
                    {
                        "id": 108260,
                        "name": "Odunpazarı",
                        "latitude": "39.76699000",
                        "longitude": "30.54113000"
                    },
                    {
                        "id": 108398,
                        "name": "Sarıcakaya",
                        "latitude": "40.04671000",
                        "longitude": "30.61994000"
                    },
                    {
                        "id": 108453,
                        "name": "Seyitgazi",
                        "latitude": "39.44472000",
                        "longitude": "30.69472000"
                    },
                    {
                        "id": 108481,
                        "name": "Sivrihisar",
                        "latitude": "39.45037000",
                        "longitude": "31.53409000"
                    },
                    {
                        "id": 108566,
                        "name": "Tepebaşı",
                        "latitude": "39.78430000",
                        "longitude": "30.50206000"
                    }
                ]
            },
            {
                "id": 2203,
                "name": "Gaziantep",
                "iso2": "27",
                "latitude": "37.07638820",
                "longitude": "37.38272340",
                "type": "province",
                "cities": [
                    {
                        "id": 107170,
                        "name": "Araban",
                        "latitude": "37.42559000",
                        "longitude": "37.78175000"
                    },
                    {
                        "id": 108917,
                        "name": "İslahiye",
                        "latitude": "36.96528000",
                        "longitude": "36.70972000"
                    },
                    {
                        "id": 107925,
                        "name": "Karkamış",
                        "latitude": "36.83452000",
                        "longitude": "37.99830000"
                    },
                    {
                        "id": 108250,
                        "name": "Nizip",
                        "latitude": "37.00972000",
                        "longitude": "37.79417000"
                    },
                    {
                        "id": 108253,
                        "name": "Nurdağı",
                        "latitude": "37.16821000",
                        "longitude": "36.73623000"
                    },
                    {
                        "id": 108303,
                        "name": "Oğuzeli",
                        "latitude": "36.96572000",
                        "longitude": "37.51339000"
                    },
                    {
                        "id": 108929,
                        "name": "Şahinbey",
                        "latitude": "37.03741000",
                        "longitude": "37.37822000"
                    },
                    {
                        "id": 108946,
                        "name": "Şehitkamil",
                        "latitude": "37.17217000",
                        "longitude": "37.36974000"
                    },
                    {
                        "id": 108677,
                        "name": "Yavuzeli",
                        "latitude": "37.31772000",
                        "longitude": "37.56824000"
                    }
                ]
            },
            {
                "id": 2186,
                "name": "Giresun",
                "iso2": "28",
                "latitude": "40.64616720",
                "longitude": "38.59355110",
                "type": "province",
                "cities": [
                    {
                        "id": 107154,
                        "name": "Alucra",
                        "latitude": "40.31924000",
                        "longitude": "38.76528000"
                    },
                    {
                        "id": 107404,
                        "name": "Bulancak",
                        "latitude": "40.93805000",
                        "longitude": "38.23148000"
                    },
                    {
                        "id": 108772,
                        "name": "Çamoluk",
                        "latitude": "40.13418000",
                        "longitude": "38.73389000"
                    },
                    {
                        "id": 108776,
                        "name": "Çanakçı",
                        "latitude": "40.86000000",
                        "longitude": "39.05000000"
                    },
                    {
                        "id": 107475,
                        "name": "Dereli",
                        "latitude": "40.61300000",
                        "longitude": "38.39000000"
                    },
                    {
                        "id": 107516,
                        "name": "Doğankent",
                        "latitude": "40.80750000",
                        "longitude": "38.91722000"
                    },
                    {
                        "id": 107609,
                        "name": "Espiye",
                        "latitude": "40.94705000",
                        "longitude": "38.70299000"
                    },
                    {
                        "id": 107619,
                        "name": "Eynesil",
                        "latitude": "41.06436000",
                        "longitude": "39.14274000"
                    },
                    {
                        "id": 107713,
                        "name": "Görele",
                        "latitude": "41.03083000",
                        "longitude": "39.00306000"
                    },
                    {
                        "id": 107724,
                        "name": "Güce",
                        "latitude": "40.89368000",
                        "longitude": "38.80855000"
                    },
                    {
                        "id": 107994,
                        "name": "Keşap",
                        "latitude": "40.91387000",
                        "longitude": "38.51442000"
                    },
                    {
                        "id": 108184,
                        "name": "Merkez",
                        "latitude": "40.82660000",
                        "longitude": "38.36085000"
                    },
                    {
                        "id": 108343,
                        "name": "Piraziz",
                        "latitude": "40.92244000",
                        "longitude": "38.12458000"
                    },
                    {
                        "id": 108942,
                        "name": "Şebinkarahisar",
                        "latitude": "40.28833000",
                        "longitude": "38.42361000"
                    },
                    {
                        "id": 108579,
                        "name": "Tirebolu",
                        "latitude": "41.00633000",
                        "longitude": "38.84980000"
                    },
                    {
                        "id": 108687,
                        "name": "Yağlıdere",
                        "latitude": "40.85711000",
                        "longitude": "38.63242000"
                    }
                ]
            },
            {
                "id": 2204,
                "name": "Gümüşhane",
                "iso2": "29",
                "latitude": "40.28036730",
                "longitude": "39.31432530",
                "type": "province",
                "cities": [
                    {
                        "id": 107969,
                        "name": "Kelkit",
                        "latitude": "40.12682000",
                        "longitude": "39.43424000"
                    },
                    {
                        "id": 108079,
                        "name": "Köse",
                        "latitude": "40.20692000",
                        "longitude": "39.64626000"
                    },
                    {
                        "id": 108090,
                        "name": "Kürtün",
                        "latitude": "40.69516000",
                        "longitude": "39.09468000"
                    },
                    {
                        "id": 108181,
                        "name": "Merkez",
                        "latitude": "40.46843000",
                        "longitude": "39.67441000"
                    },
                    {
                        "id": 108959,
                        "name": "Şiran",
                        "latitude": "40.19064000",
                        "longitude": "39.11747000"
                    },
                    {
                        "id": 108591,
                        "name": "Torul",
                        "latitude": "40.55071000",
                        "longitude": "39.28344000"
                    }
                ]
            },
            {
                "id": 2190,
                "name": "Hakkâri",
                "iso2": "30",
                "latitude": "37.44593190",
                "longitude": "43.74498410",
                "type": "province",
                "cities": [
                    {
                        "id": 108846,
                        "name": "Çukurca",
                        "latitude": "37.24806000",
                        "longitude": "43.61361000"
                    },
                    {
                        "id": 153355,
                        "name": "Derecik",
                        "latitude": "37.07242300",
                        "longitude": "44.32434800"
                    },
                    {
                        "id": 107774,
                        "name": "Merkez",
                        "latitude": "37.57444000",
                        "longitude": "43.74083000"
                    },
                    {
                        "id": 108948,
                        "name": "Şemdinli",
                        "latitude": "37.30514000",
                        "longitude": "44.57420000"
                    },
                    {
                        "id": 108744,
                        "name": "Yüksekova",
                        "latitude": "37.54627000",
                        "longitude": "44.25827000"
                    }
                ]
            },
            {
                "id": 2211,
                "name": "Hatay",
                "iso2": "31",
                "latitude": "36.40184880",
                "longitude": "36.34980970",
                "type": "province",
                "cities": [
                    {
                        "id": 107152,
                        "name": "Altınözü",
                        "latitude": "36.11244000",
                        "longitude": "36.24488000"
                    },
                    {
                        "id": 107167,
                        "name": "Antakya",
                        "latitude": "36.20655000",
                        "longitude": "36.15722000"
                    },
                    {
                        "id": 107192,
                        "name": "Arsuz",
                        "latitude": "36.41305000",
                        "longitude": "35.89033000"
                    },
                    {
                        "id": 107328,
                        "name": "Belen",
                        "latitude": "36.48866000",
                        "longitude": "36.19489000"
                    },
                    {
                        "id": 107458,
                        "name": "Defne",
                        "latitude": "36.23739000",
                        "longitude": "36.16364000"
                    },
                    {
                        "id": 107539,
                        "name": "Dörtyol",
                        "latitude": "36.83917000",
                        "longitude": "36.23025000"
                    },
                    {
                        "id": 107600,
                        "name": "Erzin",
                        "latitude": "36.95348000",
                        "longitude": "36.19839000"
                    },
                    {
                        "id": 107804,
                        "name": "Hassa",
                        "latitude": "36.79944000",
                        "longitude": "36.51778000"
                    },
                    {
                        "id": 108913,
                        "name": "İskenderun",
                        "latitude": "36.58718000",
                        "longitude": "36.17347000"
                    },
                    {
                        "id": 108107,
                        "name": "Kırıkhan",
                        "latitude": "36.49939000",
                        "longitude": "36.35755000"
                    },
                    {
                        "id": 108050,
                        "name": "Kumlu",
                        "latitude": "36.36508000",
                        "longitude": "36.45526000"
                    },
                    {
                        "id": 108320,
                        "name": "Payas",
                        "latitude": "36.75600000",
                        "longitude": "36.21432000"
                    },
                    {
                        "id": 108368,
                        "name": "Reyhanlı",
                        "latitude": "36.26791000",
                        "longitude": "36.56747000"
                    },
                    {
                        "id": 153356,
                        "name": "Samandağ",
                        "latitude": "36.08500000",
                        "longitude": "35.98055600"
                    },
                    {
                        "id": 108679,
                        "name": "Yayladağı",
                        "latitude": "35.90250000",
                        "longitude": "36.06272000"
                    }
                ]
            },
            {
                "id": 2166,
                "name": "Iğdır",
                "iso2": "76",
                "latitude": "39.88798410",
                "longitude": "44.00483650",
                "type": "province",
                "cities": [
                    {
                        "id": 153357,
                        "name": "Aralık",
                        "latitude": "39.87277800",
                        "longitude": "44.51916700"
                    },
                    {
                        "id": 107899,
                        "name": "Karakoyunlu",
                        "latitude": "39.87036000",
                        "longitude": "43.63014000"
                    },
                    {
                        "id": 107852,
                        "name": "Merkez",
                        "latitude": "39.92371000",
                        "longitude": "44.04500000"
                    },
                    {
                        "id": 108610,
                        "name": "Tuzluca",
                        "latitude": "40.03863000",
                        "longitude": "43.65212000"
                    }
                ]
            },
            {
                "id": 2222,
                "name": "Isparta",
                "iso2": "32",
                "latitude": "38.02114640",
                "longitude": "31.07937050",
                "type": "province",
                "cities": [
                    {
                        "id": 107094,
                        "name": "Aksu",
                        "latitude": "37.79889000",
                        "longitude": "31.07111000"
                    },
                    {
                        "id": 107204,
                        "name": "Atabey",
                        "latitude": "37.95083000",
                        "longitude": "30.63861000"
                    },
                    {
                        "id": 107627,
                        "name": "Eğirdir",
                        "latitude": "37.87462000",
                        "longitude": "30.85042000"
                    },
                    {
                        "id": 107653,
                        "name": "Gelendost",
                        "latitude": "38.12083000",
                        "longitude": "31.01528000"
                    },
                    {
                        "id": 107707,
                        "name": "Gönen",
                        "latitude": "37.95639000",
                        "longitude": "30.51140000"
                    },
                    {
                        "id": 107989,
                        "name": "Keçiborlu",
                        "latitude": "37.94250000",
                        "longitude": "30.30222000"
                    },
                    {
                        "id": 107850,
                        "name": "Merkez",
                        "latitude": "37.76444000",
                        "longitude": "30.55222000"
                    },
                    {
                        "id": 108935,
                        "name": "Şarkikaraağaç",
                        "latitude": "38.07944000",
                        "longitude": "31.36639000"
                    },
                    {
                        "id": 108436,
                        "name": "Senirkent",
                        "latitude": "38.10444000",
                        "longitude": "30.54861000"
                    },
                    {
                        "id": 108526,
                        "name": "Sütçüler",
                        "latitude": "37.51120000",
                        "longitude": "30.95661000"
                    },
                    {
                        "id": 108624,
                        "name": "Uluborlu",
                        "latitude": "38.07825000",
                        "longitude": "30.45019000"
                    },
                    {
                        "id": 108666,
                        "name": "Yalvaç",
                        "latitude": "38.29556000",
                        "longitude": "31.17778000"
                    },
                    {
                        "id": 108712,
                        "name": "Yenişarbademli",
                        "latitude": "37.70778000",
                        "longitude": "31.38639000"
                    }
                ]
            },
            {
                "id": 2170,
                "name": "İstanbul",
                "iso2": "34",
                "latitude": "41.16343020",
                "longitude": "28.76644080",
                "type": "province",
                "cities": [
                    {
                        "id": 107062,
                        "name": "Adalar",
                        "latitude": "40.86913000",
                        "longitude": "29.12064000"
                    },
                    {
                        "id": 107188,
                        "name": "Arnavutköy",
                        "latitude": "41.19674000",
                        "longitude": "28.73405000"
                    },
                    {
                        "id": 107207,
                        "name": "Ataşehir",
                        "latitude": "40.99104000",
                        "longitude": "29.13471000"
                    },
                    {
                        "id": 107213,
                        "name": "Avcılar",
                        "latitude": "41.02355000",
                        "longitude": "28.71860000"
                    },
                    {
                        "id": 107308,
                        "name": "Bağcılar",
                        "latitude": "41.04275000",
                        "longitude": "28.83625000"
                    },
                    {
                        "id": 107261,
                        "name": "Bahçelievler",
                        "latitude": "41.00652000",
                        "longitude": "28.84099000"
                    },
                    {
                        "id": 107267,
                        "name": "Bakırköy",
                        "latitude": "40.98388000",
                        "longitude": "28.83541000"
                    },
                    {
                        "id": 107312,
                        "name": "Başakşehir",
                        "latitude": "41.09203000",
                        "longitude": "28.80203000"
                    },
                    {
                        "id": 107302,
                        "name": "Bayrampaşa",
                        "latitude": "41.04691000",
                        "longitude": "28.90278000"
                    },
                    {
                        "id": 107349,
                        "name": "Beşiktaş",
                        "latitude": "41.07122000",
                        "longitude": "29.02321000"
                    },
                    {
                        "id": 107337,
                        "name": "Beykoz",
                        "latitude": "41.13774000",
                        "longitude": "29.16932000"
                    },
                    {
                        "id": 107338,
                        "name": "Beylikdüzü",
                        "latitude": "41.00322000",
                        "longitude": "28.64067000"
                    },
                    {
                        "id": 107341,
                        "name": "Beyoğlu",
                        "latitude": "41.03786000",
                        "longitude": "28.96767000"
                    },
                    {
                        "id": 107422,
                        "name": "Büyükçekmece",
                        "latitude": "41.04521000",
                        "longitude": "28.59573000"
                    },
                    {
                        "id": 108788,
                        "name": "Çatalca",
                        "latitude": "41.29651000",
                        "longitude": "28.45419000"
                    },
                    {
                        "id": 108812,
                        "name": "Çekmeköy",
                        "latitude": "41.03819000",
                        "longitude": "29.20029000"
                    },
                    {
                        "id": 107604,
                        "name": "Esenler",
                        "latitude": "41.07925000",
                        "longitude": "28.85235000"
                    },
                    {
                        "id": 107605,
                        "name": "Esenyurt",
                        "latitude": "41.04000000",
                        "longitude": "28.66161000"
                    },
                    {
                        "id": 107622,
                        "name": "Eyüpsultan",
                        "latitude": "41.19904000",
                        "longitude": "28.88667000"
                    },
                    {
                        "id": 107632,
                        "name": "Fatih",
                        "latitude": "41.01746000",
                        "longitude": "28.94053000"
                    },
                    {
                        "id": 107647,
                        "name": "Gaziosmanpaşa",
                        "latitude": "41.07857000",
                        "longitude": "28.89679000"
                    },
                    {
                        "id": 107746,
                        "name": "Güngören",
                        "latitude": "41.01787000",
                        "longitude": "28.87882000"
                    },
                    {
                        "id": 153786,
                        "name": "Istanbul",
                        "latitude": "41.00537020",
                        "longitude": "28.68251620"
                    },
                    {
                        "id": 107863,
                        "name": "Kadıköy",
                        "latitude": "40.98229000",
                        "longitude": "29.09032000"
                    },
                    {
                        "id": 108071,
                        "name": "Kâğıthane",
                        "latitude": "41.08319000",
                        "longitude": "28.97826000"
                    },
                    {
                        "id": 107933,
                        "name": "Kartal",
                        "latitude": "40.91197000",
                        "longitude": "29.21190000"
                    },
                    {
                        "id": 108095,
                        "name": "Küçükçekmece",
                        "latitude": "41.06947000",
                        "longitude": "28.76983000"
                    },
                    {
                        "id": 108146,
                        "name": "Maltepe",
                        "latitude": "40.95890000",
                        "longitude": "29.17866000"
                    },
                    {
                        "id": 108336,
                        "name": "Pendik",
                        "latitude": "40.94577000",
                        "longitude": "29.33019000"
                    },
                    {
                        "id": 108382,
                        "name": "Sancaktepe",
                        "latitude": "40.98949000",
                        "longitude": "29.24320000"
                    },
                    {
                        "id": 108411,
                        "name": "Sarıyer",
                        "latitude": "41.21482000",
                        "longitude": "29.05678000"
                    },
                    {
                        "id": 108958,
                        "name": "Şile",
                        "latitude": "41.12902000",
                        "longitude": "29.61845000"
                    },
                    {
                        "id": 108460,
                        "name": "Silivri",
                        "latitude": "41.18116000",
                        "longitude": "28.19890000"
                    },
                    {
                        "id": 108963,
                        "name": "Şişli",
                        "latitude": "41.12514000",
                        "longitude": "29.00013000"
                    },
                    {
                        "id": 108492,
                        "name": "Sultanbeyli",
                        "latitude": "40.95264000",
                        "longitude": "29.26797000"
                    },
                    {
                        "id": 108495,
                        "name": "Sultangazi",
                        "latitude": "41.21792000",
                        "longitude": "28.71740000"
                    },
                    {
                        "id": 108609,
                        "name": "Tuzla",
                        "latitude": "40.86368000",
                        "longitude": "29.31942000"
                    },
                    {
                        "id": 108631,
                        "name": "Ümraniye",
                        "latitude": "41.01643000",
                        "longitude": "29.12476000"
                    },
                    {
                        "id": 108874,
                        "name": "Üsküdar",
                        "latitude": "41.02274000",
                        "longitude": "29.01366000"
                    },
                    {
                        "id": 108750,
                        "name": "Zeytinburnu",
                        "latitude": "41.00824000",
                        "longitude": "28.90952000"
                    }
                ]
            },
            {
                "id": 2205,
                "name": "İzmir",
                "iso2": "35",
                "latitude": "38.35916930",
                "longitude": "27.26761160",
                "type": "province",
                "cities": [
                    {
                        "id": 107130,
                        "name": "Aliağa",
                        "latitude": "38.80078000",
                        "longitude": "27.04375000"
                    },
                    {
                        "id": 107275,
                        "name": "Balçova",
                        "latitude": "38.37302000",
                        "longitude": "27.08714000"
                    },
                    {
                        "id": 107305,
                        "name": "Bayındır",
                        "latitude": "38.21741000",
                        "longitude": "27.64744000"
                    },
                    {
                        "id": 107300,
                        "name": "Bayraklı",
                        "latitude": "38.46222000",
                        "longitude": "27.16667000"
                    },
                    {
                        "id": 107331,
                        "name": "Bergama",
                        "latitude": "39.17088000",
                        "longitude": "27.18918000"
                    },
                    {
                        "id": 107335,
                        "name": "Beydağ",
                        "latitude": "38.08241000",
                        "longitude": "28.21609000"
                    },
                    {
                        "id": 107370,
                        "name": "Bornova",
                        "latitude": "38.48492000",
                        "longitude": "27.25235000"
                    },
                    {
                        "id": 107399,
                        "name": "Buca",
                        "latitude": "38.34813000",
                        "longitude": "27.25053000"
                    },
                    {
                        "id": 108825,
                        "name": "Çeşme",
                        "latitude": "38.32614000",
                        "longitude": "26.30574000"
                    },
                    {
                        "id": 108840,
                        "name": "Çiğli",
                        "latitude": "38.48802000",
                        "longitude": "26.96596000"
                    },
                    {
                        "id": 107495,
                        "name": "Dikili",
                        "latitude": "39.07100000",
                        "longitude": "26.89017000"
                    },
                    {
                        "id": 107642,
                        "name": "Foça",
                        "latitude": "38.67030000",
                        "longitude": "26.75656000"
                    },
                    {
                        "id": 107646,
                        "name": "Gaziemir",
                        "latitude": "38.31098000",
                        "longitude": "27.15178000"
                    },
                    {
                        "id": 107760,
                        "name": "Güzelbahçe",
                        "latitude": "38.37046000",
                        "longitude": "26.86930000"
                    },
                    {
                        "id": 153785,
                        "name": "İzmir",
                        "latitude": "38.41782870",
                        "longitude": "26.91490300"
                    },
                    {
                        "id": 107886,
                        "name": "Karabağlar",
                        "latitude": "38.36912000",
                        "longitude": "27.12696000"
                    },
                    {
                        "id": 107887,
                        "name": "Karaburun",
                        "latitude": "38.63640000",
                        "longitude": "26.51094000"
                    },
                    {
                        "id": 107937,
                        "name": "Karşıyaka",
                        "latitude": "38.46775000",
                        "longitude": "27.11502000"
                    },
                    {
                        "id": 107976,
                        "name": "Kemalpaşa",
                        "latitude": "38.40883000",
                        "longitude": "27.49100000"
                    },
                    {
                        "id": 107999,
                        "name": "Kiraz",
                        "latitude": "38.23056000",
                        "longitude": "28.20444000"
                    },
                    {
                        "id": 108101,
                        "name": "Kınık",
                        "latitude": "39.08722000",
                        "longitude": "27.38333000"
                    },
                    {
                        "id": 108013,
                        "name": "Konak",
                        "latitude": "38.41448000",
                        "longitude": "27.14412000"
                    },
                    {
                        "id": 108170,
                        "name": "Menderes",
                        "latitude": "38.24963000",
                        "longitude": "27.13429000"
                    },
                    {
                        "id": 108171,
                        "name": "Menemen",
                        "latitude": "38.61608000",
                        "longitude": "27.06315000"
                    },
                    {
                        "id": 108240,
                        "name": "Narlıdere",
                        "latitude": "38.38957000",
                        "longitude": "27.02431000"
                    },
                    {
                        "id": 108860,
                        "name": "Ödemiş",
                        "latitude": "38.22780000",
                        "longitude": "27.96955000"
                    },
                    {
                        "id": 108423,
                        "name": "Seferihisar",
                        "latitude": "38.18144000",
                        "longitude": "26.88877000"
                    },
                    {
                        "id": 108434,
                        "name": "Selçuk",
                        "latitude": "37.95137000",
                        "longitude": "27.36849000"
                    },
                    {
                        "id": 108578,
                        "name": "Tire",
                        "latitude": "38.06582000",
                        "longitude": "27.72730000"
                    },
                    {
                        "id": 108587,
                        "name": "Torbalı",
                        "latitude": "38.17603000",
                        "longitude": "27.37182000"
                    },
                    {
                        "id": 108633,
                        "name": "Urla",
                        "latitude": "38.32292000",
                        "longitude": "26.76403000"
                    }
                ]
            },
            {
                "id": 2227,
                "name": "Kahramanmaraş",
                "iso2": "46",
                "latitude": "37.75030360",
                "longitude": "36.95410700",
                "type": "province",
                "cities": [
                    {
                        "id": 107069,
                        "name": "Afşin",
                        "latitude": "38.24769000",
                        "longitude": "36.91399000"
                    },
                    {
                        "id": 107164,
                        "name": "Andırın",
                        "latitude": "37.57757000",
                        "longitude": "36.35492000"
                    },
                    {
                        "id": 108808,
                        "name": "Çağlayancerit",
                        "latitude": "37.74523000",
                        "longitude": "37.28618000"
                    },
                    {
                        "id": 107529,
                        "name": "Dulkadiroğlu",
                        "latitude": "37.58254000",
                        "longitude": "36.91973000"
                    },
                    {
                        "id": 107556,
                        "name": "Ekinözü",
                        "latitude": "38.07007000",
                        "longitude": "37.19414000"
                    },
                    {
                        "id": 107562,
                        "name": "Elbistan",
                        "latitude": "38.20591000",
                        "longitude": "37.19830000"
                    },
                    {
                        "id": 107681,
                        "name": "Göksun",
                        "latitude": "38.02096000",
                        "longitude": "36.49730000"
                    },
                    {
                        "id": 108255,
                        "name": "Nurhak",
                        "latitude": "37.96366000",
                        "longitude": "37.44047000"
                    },
                    {
                        "id": 108270,
                        "name": "Onikişubat",
                        "latitude": "37.59002000",
                        "longitude": "36.90548000"
                    },
                    {
                        "id": 108325,
                        "name": "Pazarcık",
                        "latitude": "37.48685000",
                        "longitude": "37.29961000"
                    },
                    {
                        "id": 108615,
                        "name": "Türkoğlu",
                        "latitude": "37.38417000",
                        "longitude": "36.84626000"
                    }
                ]
            },
            {
                "id": 2223,
                "name": "Karabük",
                "iso2": "78",
                "latitude": "41.18748900",
                "longitude": "32.74174190",
                "type": "province",
                "cities": [
                    {
                        "id": 107554,
                        "name": "Eflani",
                        "latitude": "41.42289000",
                        "longitude": "32.95761000"
                    },
                    {
                        "id": 107607,
                        "name": "Eskipazar",
                        "latitude": "40.95207000",
                        "longitude": "32.54604000"
                    },
                    {
                        "id": 107889,
                        "name": "Merkez",
                        "latitude": "41.20488000",
                        "longitude": "32.62768000"
                    },
                    {
                        "id": 108299,
                        "name": "Ovacık",
                        "latitude": "41.08029000",
                        "longitude": "32.93224000"
                    },
                    {
                        "id": 108372,
                        "name": "Safranbolu",
                        "latitude": "41.25083000",
                        "longitude": "32.69417000"
                    },
                    {
                        "id": 108693,
                        "name": "Yenice",
                        "latitude": "41.19962000",
                        "longitude": "32.33133000"
                    }
                ]
            },
            {
                "id": 2184,
                "name": "Karaman",
                "iso2": "70",
                "latitude": "37.24363360",
                "longitude": "33.61757700",
                "type": "province",
                "cities": [
                    {
                        "id": 107228,
                        "name": "Ayrancı",
                        "latitude": "37.37111000",
                        "longitude": "33.69291000"
                    },
                    {
                        "id": 107320,
                        "name": "Başyayla",
                        "latitude": "36.75337000",
                        "longitude": "32.68018000"
                    },
                    {
                        "id": 107596,
                        "name": "Ermenek",
                        "latitude": "36.64043000",
                        "longitude": "32.89179000"
                    },
                    {
                        "id": 107958,
                        "name": "Kazımkarabekir",
                        "latitude": "37.23028000",
                        "longitude": "32.95889000"
                    },
                    {
                        "id": 107905,
                        "name": "Merkez",
                        "latitude": "37.18111000",
                        "longitude": "33.21500000"
                    },
                    {
                        "id": 108407,
                        "name": "Sarıveliler",
                        "latitude": "36.69705000",
                        "longitude": "32.61203000"
                    }
                ]
            },
            {
                "id": 2208,
                "name": "Kars",
                "iso2": "36",
                "latitude": "40.28076360",
                "longitude": "42.99195270",
                "type": "province",
                "cities": [
                    {
                        "id": 107098,
                        "name": "Akyaka",
                        "latitude": "40.74093000",
                        "longitude": "43.61432000"
                    },
                    {
                        "id": 107189,
                        "name": "Arpaçay",
                        "latitude": "40.84522000",
                        "longitude": "43.32747000"
                    },
                    {
                        "id": 107494,
                        "name": "Digor",
                        "latitude": "40.37515000",
                        "longitude": "43.41361000"
                    },
                    {
                        "id": 107960,
                        "name": "Kağızman",
                        "latitude": "40.15669000",
                        "longitude": "43.13424000"
                    },
                    {
                        "id": 107931,
                        "name": "Merkez",
                        "latitude": "40.59825000",
                        "longitude": "43.08548000"
                    },
                    {
                        "id": 108401,
                        "name": "Sarıkamış",
                        "latitude": "40.32769000",
                        "longitude": "42.58705000"
                    },
                    {
                        "id": 108430,
                        "name": "Selim",
                        "latitude": "40.45772000",
                        "longitude": "42.78287000"
                    },
                    {
                        "id": 108511,
                        "name": "Susuz",
                        "latitude": "40.77910000",
                        "longitude": "43.12769000"
                    }
                ]
            },
            {
                "id": 2197,
                "name": "Kastamonu",
                "iso2": "37",
                "latitude": "41.41038630",
                "longitude": "33.69983340",
                "type": "province",
                "cities": [
                    {
                        "id": 107052,
                        "name": "Abana",
                        "latitude": "41.97858000",
                        "longitude": "34.01100000"
                    },
                    {
                        "id": 107243,
                        "name": "Ağlı",
                        "latitude": "41.69283000",
                        "longitude": "33.54487000"
                    },
                    {
                        "id": 107177,
                        "name": "Araç",
                        "latitude": "41.24222000",
                        "longitude": "33.32767000"
                    },
                    {
                        "id": 107235,
                        "name": "Azdavay",
                        "latitude": "41.64267000",
                        "longitude": "33.30000000"
                    },
                    {
                        "id": 107383,
                        "name": "Bozkurt",
                        "latitude": "41.95769000",
                        "longitude": "34.01087000"
                    },
                    {
                        "id": 108791,
                        "name": "Çatalzeytin",
                        "latitude": "41.93795000",
                        "longitude": "34.20285000"
                    },
                    {
                        "id": 107430,
                        "name": "Cide",
                        "latitude": "41.85583000",
                        "longitude": "33.03977000"
                    },
                    {
                        "id": 107439,
                        "name": "Daday",
                        "latitude": "41.47866000",
                        "longitude": "33.46667000"
                    },
                    {
                        "id": 107488,
                        "name": "Devrekani",
                        "latitude": "41.60303000",
                        "longitude": "33.83922000"
                    },
                    {
                        "id": 107521,
                        "name": "Doğanyurt",
                        "latitude": "42.00457000",
                        "longitude": "33.46029000"
                    },
                    {
                        "id": 107793,
                        "name": "Hanönü",
                        "latitude": "41.62705000",
                        "longitude": "34.46667000"
                    },
                    {
                        "id": 108881,
                        "name": "İhsangazi",
                        "latitude": "41.20432000",
                        "longitude": "33.55455000"
                    },
                    {
                        "id": 108899,
                        "name": "İnebolu",
                        "latitude": "41.97472000",
                        "longitude": "33.76083000"
                    },
                    {
                        "id": 108088,
                        "name": "Küre",
                        "latitude": "41.80578000",
                        "longitude": "33.71161000"
                    },
                    {
                        "id": 107939,
                        "name": "Merkez",
                        "latitude": "41.37805000",
                        "longitude": "33.77528000"
                    },
                    {
                        "id": 108358,
                        "name": "Pınarbaşı",
                        "latitude": "41.60388000",
                        "longitude": "33.11099000"
                    },
                    {
                        "id": 108954,
                        "name": "Şenpazar",
                        "latitude": "41.81651000",
                        "longitude": "33.21766000"
                    },
                    {
                        "id": 108448,
                        "name": "Seydiler",
                        "latitude": "41.62005000",
                        "longitude": "33.71815000"
                    },
                    {
                        "id": 108548,
                        "name": "Taşköprü",
                        "latitude": "41.50980000",
                        "longitude": "34.21414000"
                    },
                    {
                        "id": 108593,
                        "name": "Tosya",
                        "latitude": "41.01545000",
                        "longitude": "34.04013000"
                    }
                ]
            },
            {
                "id": 2200,
                "name": "Kayseri",
                "iso2": "38",
                "latitude": "38.62568540",
                "longitude": "35.74068820",
                "type": "province",
                "cities": [
                    {
                        "id": 107087,
                        "name": "Akkışla",
                        "latitude": "39.00222000",
                        "longitude": "36.17381000"
                    },
                    {
                        "id": 107416,
                        "name": "Bünyan",
                        "latitude": "38.84630000",
                        "longitude": "35.86033000"
                    },
                    {
                        "id": 107485,
                        "name": "Develi",
                        "latitude": "38.26789000",
                        "longitude": "35.59161000"
                    },
                    {
                        "id": 107636,
                        "name": "Felahiye",
                        "latitude": "39.09056000",
                        "longitude": "35.56722000"
                    },
                    {
                        "id": 107767,
                        "name": "Hacılar",
                        "latitude": "38.64631000",
                        "longitude": "35.44937000"
                    },
                    {
                        "id": 107849,
                        "name": "İncesu",
                        "latitude": "38.63789000",
                        "longitude": "35.19394000"
                    },
                    {
                        "id": 153790,
                        "name": "Kayseri",
                        "latitude": "38.72355320",
                        "longitude": "35.30537320"
                    },
                    {
                        "id": 108010,
                        "name": "Kocasinan",
                        "latitude": "38.87959000",
                        "longitude": "35.35540000"
                    },
                    {
                        "id": 108169,
                        "name": "Melikgazi",
                        "latitude": "38.77933000",
                        "longitude": "35.66076000"
                    },
                    {
                        "id": 108870,
                        "name": "Özvatan",
                        "latitude": "39.11737000",
                        "longitude": "35.71149000"
                    },
                    {
                        "id": 108355,
                        "name": "Pınarbaşı",
                        "latitude": "38.72285000",
                        "longitude": "36.39314000"
                    },
                    {
                        "id": 108405,
                        "name": "Sarıoğlan",
                        "latitude": "39.07694000",
                        "longitude": "35.96671000"
                    },
                    {
                        "id": 108412,
                        "name": "Sarız",
                        "latitude": "38.47917000",
                        "longitude": "36.49898000"
                    },
                    {
                        "id": 108531,
                        "name": "Talas",
                        "latitude": "38.69080000",
                        "longitude": "35.55380000"
                    },
                    {
                        "id": 108581,
                        "name": "Tomarza",
                        "latitude": "38.44722000",
                        "longitude": "35.79917000"
                    },
                    {
                        "id": 108658,
                        "name": "Yahyalı",
                        "latitude": "38.10228000",
                        "longitude": "35.35704000"
                    },
                    {
                        "id": 108720,
                        "name": "Yeşilhisar",
                        "latitude": "38.33475000",
                        "longitude": "35.11795000"
                    }
                ]
            },
            {
                "id": 2154,
                "name": "Kilis",
                "iso2": "79",
                "latitude": "36.82047750",
                "longitude": "37.16873390",
                "type": "province",
                "cities": [
                    {
                        "id": 107559,
                        "name": "Elbeyli",
                        "latitude": "36.67417000",
                        "longitude": "37.46667000"
                    },
                    {
                        "id": 107997,
                        "name": "Merkez",
                        "latitude": "36.71611000",
                        "longitude": "37.11500000"
                    },
                    {
                        "id": 108228,
                        "name": "Musabeyli",
                        "latitude": "36.88639000",
                        "longitude": "36.91861000"
                    },
                    {
                        "id": 108345,
                        "name": "Polateli",
                        "latitude": "36.83694000",
                        "longitude": "37.15083000"
                    }
                ]
            },
            {
                "id": 2178,
                "name": "Kırıkkale",
                "iso2": "71",
                "latitude": "39.88768780",
                "longitude": "33.75552480",
                "type": "province",
                "cities": [
                    {
                        "id": 107264,
                        "name": "Bahşılı",
                        "latitude": "39.80979000",
                        "longitude": "33.44080000"
                    },
                    {
                        "id": 107279,
                        "name": "Balışeyh",
                        "latitude": "39.91411000",
                        "longitude": "33.72333000"
                    },
                    {
                        "id": 108813,
                        "name": "Çelebi",
                        "latitude": "39.47470000",
                        "longitude": "33.52895000"
                    },
                    {
                        "id": 107459,
                        "name": "Delice",
                        "latitude": "39.95371000",
                        "longitude": "34.02587000"
                    },
                    {
                        "id": 107897,
                        "name": "Karakeçili",
                        "latitude": "39.59417000",
                        "longitude": "33.37778000"
                    },
                    {
                        "id": 107985,
                        "name": "Keskin",
                        "latitude": "39.67306000",
                        "longitude": "33.61361000"
                    },
                    {
                        "id": 108109,
                        "name": "Merkez",
                        "latitude": "39.84528000",
                        "longitude": "33.50639000"
                    },
                    {
                        "id": 108490,
                        "name": "Sulakyurt",
                        "latitude": "40.15733000",
                        "longitude": "33.71600000"
                    },
                    {
                        "id": 108659,
                        "name": "Yahşihan",
                        "latitude": "39.85992000",
                        "longitude": "33.45615000"
                    }
                ]
            },
            {
                "id": 2176,
                "name": "Kırklareli",
                "iso2": "39",
                "latitude": "41.72597950",
                "longitude": "27.48383900",
                "type": "province",
                "cities": [
                    {
                        "id": 107254,
                        "name": "Babaeski",
                        "latitude": "41.43250000",
                        "longitude": "27.09306000"
                    },
                    {
                        "id": 107463,
                        "name": "Demirköy",
                        "latitude": "41.83567000",
                        "longitude": "27.77137000"
                    },
                    {
                        "id": 108011,
                        "name": "Kofçaz",
                        "latitude": "41.94481000",
                        "longitude": "27.15829000"
                    },
                    {
                        "id": 108136,
                        "name": "Lüleburgaz",
                        "latitude": "41.41495000",
                        "longitude": "27.37325000"
                    },
                    {
                        "id": 108106,
                        "name": "Merkez",
                        "latitude": "41.73508000",
                        "longitude": "27.22521000"
                    },
                    {
                        "id": 108333,
                        "name": "Pehlivanköy",
                        "latitude": "41.34812000",
                        "longitude": "26.92522000"
                    },
                    {
                        "id": 108362,
                        "name": "Pınarhisar",
                        "latitude": "41.62417000",
                        "longitude": "27.52000000"
                    },
                    {
                        "id": 108655,
                        "name": "Vize",
                        "latitude": "41.57250000",
                        "longitude": "27.76583000"
                    }
                ]
            },
            {
                "id": 2180,
                "name": "Kırşehir",
                "iso2": "40",
                "latitude": "39.22689050",
                "longitude": "33.97500180",
                "type": "province",
                "cities": [
                    {
                        "id": 107109,
                        "name": "Akçakent",
                        "latitude": "39.63184000",
                        "longitude": "34.08468000"
                    },
                    {
                        "id": 107089,
                        "name": "Akpınar",
                        "latitude": "39.45005000",
                        "longitude": "33.96484000"
                    },
                    {
                        "id": 107390,
                        "name": "Boztepe",
                        "latitude": "39.27979000",
                        "longitude": "34.26657000"
                    },
                    {
                        "id": 108838,
                        "name": "Çiçekdağı",
                        "latitude": "39.60694000",
                        "longitude": "34.40861000"
                    },
                    {
                        "id": 107879,
                        "name": "Kaman",
                        "latitude": "39.35750000",
                        "longitude": "33.72389000"
                    },
                    {
                        "id": 108110,
                        "name": "Merkez",
                        "latitude": "39.14583000",
                        "longitude": "34.16389000"
                    },
                    {
                        "id": 108215,
                        "name": "Mucur",
                        "latitude": "39.06147000",
                        "longitude": "34.38286000"
                    }
                ]
            },
            {
                "id": 2195,
                "name": "Kocaeli",
                "iso2": "41",
                "latitude": "40.85327040",
                "longitude": "29.88152030",
                "type": "province",
                "cities": [
                    {
                        "id": 107314,
                        "name": "Başiskele",
                        "latitude": "40.64574000",
                        "longitude": "29.90015000"
                    },
                    {
                        "id": 108807,
                        "name": "Çayırova",
                        "latitude": "40.82784000",
                        "longitude": "29.39014000"
                    },
                    {
                        "id": 107451,
                        "name": "Darıca",
                        "latitude": "40.76780000",
                        "longitude": "29.37126000"
                    },
                    {
                        "id": 107479,
                        "name": "Derince",
                        "latitude": "40.75694000",
                        "longitude": "29.81472000"
                    },
                    {
                        "id": 107497,
                        "name": "Dilovası",
                        "latitude": "40.77972000",
                        "longitude": "29.53500000"
                    },
                    {
                        "id": 107650,
                        "name": "Gebze",
                        "latitude": "40.80276000",
                        "longitude": "29.43068000"
                    },
                    {
                        "id": 107690,
                        "name": "Gölcük",
                        "latitude": "40.70323000",
                        "longitude": "29.87216000"
                    },
                    {
                        "id": 108924,
                        "name": "İzmit",
                        "latitude": "40.77521000",
                        "longitude": "29.94624000"
                    },
                    {
                        "id": 107881,
                        "name": "Kandıra",
                        "latitude": "41.07000000",
                        "longitude": "30.15262000"
                    },
                    {
                        "id": 107908,
                        "name": "Karamürsel",
                        "latitude": "40.69129000",
                        "longitude": "29.61649000"
                    },
                    {
                        "id": 107934,
                        "name": "Kartepe",
                        "latitude": "40.75246000",
                        "longitude": "30.02787000"
                    },
                    {
                        "id": 108077,
                        "name": "Körfez",
                        "latitude": "40.76704000",
                        "longitude": "29.78275000"
                    }
                ]
            },
            {
                "id": 2171,
                "name": "Konya",
                "iso2": "42",
                "latitude": "37.98381340",
                "longitude": "32.71813750",
                "type": "province",
                "cities": [
                    {
                        "id": 107075,
                        "name": "Ahırlı",
                        "latitude": "37.24828000",
                        "longitude": "32.12419000"
                    },
                    {
                        "id": 107112,
                        "name": "Akören",
                        "latitude": "37.46265000",
                        "longitude": "32.37489000"
                    },
                    {
                        "id": 107115,
                        "name": "Akşehir",
                        "latitude": "38.35750000",
                        "longitude": "31.41639000"
                    },
                    {
                        "id": 107140,
                        "name": "Altınekin",
                        "latitude": "38.30778000",
                        "longitude": "32.86861000"
                    },
                    {
                        "id": 107345,
                        "name": "Beyşehir",
                        "latitude": "37.67735000",
                        "longitude": "31.72458000"
                    },
                    {
                        "id": 107386,
                        "name": "Bozkır",
                        "latitude": "37.18963000",
                        "longitude": "32.24736000"
                    },
                    {
                        "id": 108816,
                        "name": "Çeltik",
                        "latitude": "39.03388000",
                        "longitude": "31.79408000"
                    },
                    {
                        "id": 107431,
                        "name": "Cihanbeyli",
                        "latitude": "38.66072000",
                        "longitude": "32.92437000"
                    },
                    {
                        "id": 108849,
                        "name": "Çumra",
                        "latitude": "37.57320000",
                        "longitude": "32.77446000"
                    },
                    {
                        "id": 107471,
                        "name": "Derbent",
                        "latitude": "38.01422000",
                        "longitude": "32.01639000"
                    },
                    {
                        "id": 107473,
                        "name": "Derebucak",
                        "latitude": "37.39179000",
                        "longitude": "31.50918000"
                    },
                    {
                        "id": 107513,
                        "name": "Doğanhisar",
                        "latitude": "38.14630000",
                        "longitude": "31.67648000"
                    },
                    {
                        "id": 107578,
                        "name": "Emirgazi",
                        "latitude": "37.90222000",
                        "longitude": "33.83722000"
                    },
                    {
                        "id": 107589,
                        "name": "Ereğli",
                        "latitude": "37.51333000",
                        "longitude": "34.04672000"
                    },
                    {
                        "id": 107745,
                        "name": "Güneysınır",
                        "latitude": "37.27977000",
                        "longitude": "32.73735000"
                    },
                    {
                        "id": 107770,
                        "name": "Hadim",
                        "latitude": "36.98776000",
                        "longitude": "32.45674000"
                    },
                    {
                        "id": 107778,
                        "name": "Halkapınar",
                        "latitude": "37.43394000",
                        "longitude": "34.18743000"
                    },
                    {
                        "id": 107840,
                        "name": "Hüyük",
                        "latitude": "37.95388000",
                        "longitude": "31.59639000"
                    },
                    {
                        "id": 107846,
                        "name": "Ilgın",
                        "latitude": "38.27917000",
                        "longitude": "31.91389000"
                    },
                    {
                        "id": 107864,
                        "name": "Kadınhanı",
                        "latitude": "38.23972000",
                        "longitude": "32.21139000"
                    },
                    {
                        "id": 107912,
                        "name": "Karapınar",
                        "latitude": "37.71596000",
                        "longitude": "33.55064000"
                    },
                    {
                        "id": 107917,
                        "name": "Karatay",
                        "latitude": "37.94001000",
                        "longitude": "32.99828000"
                    },
                    {
                        "id": 108042,
                        "name": "Kulu",
                        "latitude": "39.09513000",
                        "longitude": "33.07989000"
                    },
                    {
                        "id": 108175,
                        "name": "Meram",
                        "latitude": "37.83984000",
                        "longitude": "32.47111000"
                    },
                    {
                        "id": 108394,
                        "name": "Sarayönü",
                        "latitude": "38.26201000",
                        "longitude": "32.40457000"
                    },
                    {
                        "id": 108427,
                        "name": "Selçuklu",
                        "latitude": "38.05761000",
                        "longitude": "32.54088000"
                    },
                    {
                        "id": 108450,
                        "name": "Seydişehir",
                        "latitude": "37.41926000",
                        "longitude": "31.84527000"
                    },
                    {
                        "id": 108546,
                        "name": "Taşkent",
                        "latitude": "36.92430000",
                        "longitude": "32.49131000"
                    },
                    {
                        "id": 108611,
                        "name": "Tuzlukçu",
                        "latitude": "38.47778000",
                        "longitude": "31.62639000"
                    },
                    {
                        "id": 108668,
                        "name": "Yalıhüyük",
                        "latitude": "37.30077000",
                        "longitude": "32.08548000"
                    },
                    {
                        "id": 108738,
                        "name": "Yunak",
                        "latitude": "38.81418000",
                        "longitude": "31.73223000"
                    }
                ]
            },
            {
                "id": 2149,
                "name": "Kütahya",
                "iso2": "43",
                "latitude": "39.35813700",
                "longitude": "29.60354950",
                "type": "province",
                "cities": [
                    {
                        "id": 107147,
                        "name": "Altıntaş",
                        "latitude": "39.06932000",
                        "longitude": "30.12048000"
                    },
                    {
                        "id": 107202,
                        "name": "Aslanapa",
                        "latitude": "39.21581000",
                        "longitude": "29.86990000"
                    },
                    {
                        "id": 108792,
                        "name": "Çavdarhisar",
                        "latitude": "39.20333000",
                        "longitude": "29.63094000"
                    },
                    {
                        "id": 107508,
                        "name": "Domaniç",
                        "latitude": "39.80194000",
                        "longitude": "29.60918000"
                    },
                    {
                        "id": 107530,
                        "name": "Dumlupınar",
                        "latitude": "38.85408000",
                        "longitude": "29.97720000"
                    },
                    {
                        "id": 107573,
                        "name": "Emet",
                        "latitude": "39.34300000",
                        "longitude": "29.25847000"
                    },
                    {
                        "id": 107651,
                        "name": "Gediz",
                        "latitude": "38.99389000",
                        "longitude": "29.39131000"
                    },
                    {
                        "id": 107828,
                        "name": "Hisarcık",
                        "latitude": "39.25987000",
                        "longitude": "29.24134000"
                    },
                    {
                        "id": 108092,
                        "name": "Merkez",
                        "latitude": "39.42417000",
                        "longitude": "29.98333000"
                    },
                    {
                        "id": 108327,
                        "name": "Pazarlar",
                        "latitude": "38.99500000",
                        "longitude": "29.12583000"
                    },
                    {
                        "id": 108933,
                        "name": "Şaphane",
                        "latitude": "39.02730000",
                        "longitude": "29.22218000"
                    },
                    {
                        "id": 108465,
                        "name": "Simav",
                        "latitude": "39.08820000",
                        "longitude": "28.97767000"
                    },
                    {
                        "id": 108543,
                        "name": "Tavşanlı",
                        "latitude": "39.54237000",
                        "longitude": "29.49866000"
                    }
                ]
            },
            {
                "id": 2158,
                "name": "Malatya",
                "iso2": "44",
                "latitude": "38.40150570",
                "longitude": "37.95362980",
                "type": "province",
                "cities": [
                    {
                        "id": 107105,
                        "name": "Akçadağ",
                        "latitude": "38.33899000",
                        "longitude": "37.97021000"
                    },
                    {
                        "id": 107175,
                        "name": "Arapgir",
                        "latitude": "39.04117000",
                        "longitude": "38.49516000"
                    },
                    {
                        "id": 107183,
                        "name": "Arguvan",
                        "latitude": "38.78172000",
                        "longitude": "38.26349000"
                    },
                    {
                        "id": 107292,
                        "name": "Battalgazi",
                        "latitude": "38.43932000",
                        "longitude": "38.45764000"
                    },
                    {
                        "id": 107447,
                        "name": "Darende",
                        "latitude": "38.54583000",
                        "longitude": "37.50583000"
                    },
                    {
                        "id": 107525,
                        "name": "Doğanşehir",
                        "latitude": "38.08574000",
                        "longitude": "37.87116000"
                    },
                    {
                        "id": 107520,
                        "name": "Doğanyol",
                        "latitude": "38.30746000",
                        "longitude": "39.03431000"
                    },
                    {
                        "id": 107819,
                        "name": "Hekimhan",
                        "latitude": "38.81622000",
                        "longitude": "37.92882000"
                    },
                    {
                        "id": 107870,
                        "name": "Kale",
                        "latitude": "39.03333000",
                        "longitude": "38.00000000"
                    },
                    {
                        "id": 108044,
                        "name": "Kuluncak",
                        "latitude": "38.87656000",
                        "longitude": "37.66279000"
                    },
                    {
                        "id": 108354,
                        "name": "Pütürge",
                        "latitude": "38.19630000",
                        "longitude": "38.87418000"
                    },
                    {
                        "id": 108684,
                        "name": "Yazıhan",
                        "latitude": "38.59292000",
                        "longitude": "38.17327000"
                    },
                    {
                        "id": 108728,
                        "name": "Yeşilyurt",
                        "latitude": "38.29602000",
                        "longitude": "38.24526000"
                    }
                ]
            },
            {
                "id": 2198,
                "name": "Manisa",
                "iso2": "45",
                "latitude": "38.84193730",
                "longitude": "28.11226790",
                "type": "province",
                "cities": [
                    {
                        "id": 107073,
                        "name": "Ahmetli",
                        "latitude": "38.51960000",
                        "longitude": "27.93865000"
                    },
                    {
                        "id": 107082,
                        "name": "Akhisar",
                        "latitude": "38.91852000",
                        "longitude": "27.84006000"
                    },
                    {
                        "id": 107128,
                        "name": "Alaşehir",
                        "latitude": "38.35083000",
                        "longitude": "28.51718000"
                    },
                    {
                        "id": 107461,
                        "name": "Demirci",
                        "latitude": "39.04607000",
                        "longitude": "28.65889000"
                    },
                    {
                        "id": 107698,
                        "name": "Gölmarmara",
                        "latitude": "38.71389000",
                        "longitude": "27.91417000"
                    },
                    {
                        "id": 107711,
                        "name": "Gördes",
                        "latitude": "38.93278000",
                        "longitude": "28.28942000"
                    },
                    {
                        "id": 108104,
                        "name": "Kırkağaç",
                        "latitude": "39.10638000",
                        "longitude": "27.66925000"
                    },
                    {
                        "id": 108072,
                        "name": "Köprübaşı",
                        "latitude": "38.74972000",
                        "longitude": "28.40472000"
                    },
                    {
                        "id": 108038,
                        "name": "Kula",
                        "latitude": "38.56775000",
                        "longitude": "28.64146000"
                    },
                    {
                        "id": 108376,
                        "name": "Salihli",
                        "latitude": "38.49254000",
                        "longitude": "28.15264000"
                    },
                    {
                        "id": 108399,
                        "name": "Sarıgöl",
                        "latitude": "38.23953000",
                        "longitude": "28.69663000"
                    },
                    {
                        "id": 108397,
                        "name": "Saruhanlı",
                        "latitude": "38.76778000",
                        "longitude": "27.64714000"
                    },
                    {
                        "id": 108947,
                        "name": "Şehzadeler",
                        "latitude": "38.61660000",
                        "longitude": "27.43861000"
                    },
                    {
                        "id": 108428,
                        "name": "Selendi",
                        "latitude": "38.74444000",
                        "longitude": "28.86778000"
                    },
                    {
                        "id": 108485,
                        "name": "Soma",
                        "latitude": "39.18554000",
                        "longitude": "27.60945000"
                    },
                    {
                        "id": 108600,
                        "name": "Turgutlu",
                        "latitude": "38.51515000",
                        "longitude": "27.73515000"
                    },
                    {
                        "id": 108740,
                        "name": "Yunusemre",
                        "latitude": "38.62063000",
                        "longitude": "27.40806000"
                    }
                ]
            },
            {
                "id": 2224,
                "name": "Mardin",
                "iso2": "47",
                "latitude": "37.34429290",
                "longitude": "40.61964870",
                "type": "province",
                "cities": [
                    {
                        "id": 107195,
                        "name": "Artuklu",
                        "latitude": "37.31714000",
                        "longitude": "40.72473000"
                    },
                    {
                        "id": 107449,
                        "name": "Dargeçit",
                        "latitude": "37.54616000",
                        "longitude": "41.71652000"
                    },
                    {
                        "id": 107478,
                        "name": "Derik",
                        "latitude": "37.36431000",
                        "longitude": "40.26883000"
                    },
                    {
                        "id": 108118,
                        "name": "Kızıltepe",
                        "latitude": "37.18836000",
                        "longitude": "40.57723000"
                    },
                    {
                        "id": 108163,
                        "name": "Mazıdağı",
                        "latitude": "37.47801000",
                        "longitude": "40.48152000"
                    },
                    {
                        "id": 108206,
                        "name": "Midyat",
                        "latitude": "37.41908000",
                        "longitude": "41.33909000"
                    },
                    {
                        "id": 108258,
                        "name": "Nusaybin",
                        "latitude": "37.07028000",
                        "longitude": "41.21465000"
                    },
                    {
                        "id": 108863,
                        "name": "Ömerli",
                        "latitude": "37.39903000",
                        "longitude": "40.95442000"
                    },
                    {
                        "id": 108419,
                        "name": "Savur",
                        "latitude": "37.53544000",
                        "longitude": "40.87876000"
                    },
                    {
                        "id": 108724,
                        "name": "Yeşilli",
                        "latitude": "37.33813000",
                        "longitude": "40.81739000"
                    }
                ]
            },
            {
                "id": 2156,
                "name": "Mersin",
                "iso2": "33",
                "latitude": "36.81208580",
                "longitude": "34.64147500",
                "type": "province",
                "cities": [
                    {
                        "id": 107079,
                        "name": "Akdeniz",
                        "latitude": "36.86424000",
                        "longitude": "34.67731000"
                    },
                    {
                        "id": 107160,
                        "name": "Anamur",
                        "latitude": "36.07508000",
                        "longitude": "32.83691000"
                    },
                    {
                        "id": 107221,
                        "name": "Aydıncık",
                        "latitude": "36.14370000",
                        "longitude": "33.32016000"
                    },
                    {
                        "id": 107391,
                        "name": "Bozyazı",
                        "latitude": "36.10820000",
                        "longitude": "32.96113000"
                    },
                    {
                        "id": 108771,
                        "name": "Çamlıyayla",
                        "latitude": "37.18000000",
                        "longitude": "34.60678000"
                    },
                    {
                        "id": 107586,
                        "name": "Erdemli",
                        "latitude": "36.60498000",
                        "longitude": "34.30836000"
                    },
                    {
                        "id": 107730,
                        "name": "Gülnar",
                        "latitude": "36.34148000",
                        "longitude": "33.39921000"
                    },
                    {
                        "id": 153789,
                        "name": "Mersin",
                        "latitude": "36.74287670",
                        "longitude": "34.36409150"
                    },
                    {
                        "id": 108204,
                        "name": "Mezitli",
                        "latitude": "36.89400000",
                        "longitude": "34.42987000"
                    },
                    {
                        "id": 108232,
                        "name": "Mut",
                        "latitude": "36.71842000",
                        "longitude": "33.38718000"
                    },
                    {
                        "id": 108458,
                        "name": "Silifke",
                        "latitude": "36.37778000",
                        "longitude": "33.93444000"
                    },
                    {
                        "id": 108536,
                        "name": "Tarsus",
                        "latitude": "36.91766000",
                        "longitude": "34.89277000"
                    },
                    {
                        "id": 108588,
                        "name": "Toroslar",
                        "latitude": "36.87083000",
                        "longitude": "34.60299000"
                    },
                    {
                        "id": 108715,
                        "name": "Yenişehir",
                        "latitude": "36.81602000",
                        "longitude": "34.57621000"
                    }
                ]
            },
            {
                "id": 2182,
                "name": "Muğla",
                "iso2": "48",
                "latitude": "37.18358190",
                "longitude": "28.48639630",
                "type": "province",
                "cities": [
                    {
                        "id": 107365,
                        "name": "Bodrum",
                        "latitude": "37.06500000",
                        "longitude": "27.49819000"
                    },
                    {
                        "id": 107442,
                        "name": "Dalaman",
                        "latitude": "36.81691000",
                        "longitude": "28.87815000"
                    },
                    {
                        "id": 107452,
                        "name": "Datça",
                        "latitude": "36.73778000",
                        "longitude": "27.68417000"
                    },
                    {
                        "id": 107640,
                        "name": "Fethiye",
                        "latitude": "36.64038000",
                        "longitude": "29.12758000"
                    },
                    {
                        "id": 107943,
                        "name": "Kavaklıdere",
                        "latitude": "37.43929000",
                        "longitude": "28.38402000"
                    },
                    {
                        "id": 108083,
                        "name": "Köyceğiz",
                        "latitude": "36.97798000",
                        "longitude": "28.72418000"
                    },
                    {
                        "id": 108160,
                        "name": "Marmaris",
                        "latitude": "36.85500000",
                        "longitude": "28.27417000"
                    },
                    {
                        "id": 108174,
                        "name": "Menteşe",
                        "latitude": "37.21447000",
                        "longitude": "28.36168000"
                    },
                    {
                        "id": 108211,
                        "name": "Milas",
                        "latitude": "37.31639000",
                        "longitude": "27.78389000"
                    },
                    {
                        "id": 108279,
                        "name": "Ortaca",
                        "latitude": "36.83915000",
                        "longitude": "28.76457000"
                    },
                    {
                        "id": 108447,
                        "name": "Seydikemer",
                        "latitude": "36.64308000",
                        "longitude": "29.34929000"
                    },
                    {
                        "id": 108616,
                        "name": "Ula",
                        "latitude": "37.10491000",
                        "longitude": "28.41667000"
                    },
                    {
                        "id": 108676,
                        "name": "Yatağan",
                        "latitude": "37.35864000",
                        "longitude": "28.11441000"
                    }
                ]
            },
            {
                "id": 2162,
                "name": "Muş",
                "iso2": "49",
                "latitude": "38.94618880",
                "longitude": "41.75389310",
                "type": "province",
                "cities": [
                    {
                        "id": 107406,
                        "name": "Bulanık",
                        "latitude": "39.08656000",
                        "longitude": "42.27158000"
                    },
                    {
                        "id": 107802,
                        "name": "Hasköy",
                        "latitude": "38.68231000",
                        "longitude": "41.67851000"
                    },
                    {
                        "id": 108022,
                        "name": "Korkut",
                        "latitude": "38.73390000",
                        "longitude": "41.78396000"
                    },
                    {
                        "id": 108142,
                        "name": "Malazgirt",
                        "latitude": "39.14650000",
                        "longitude": "42.53536000"
                    },
                    {
                        "id": 108191,
                        "name": "Merkez",
                        "latitude": "38.83793000",
                        "longitude": "41.48332000"
                    },
                    {
                        "id": 108647,
                        "name": "Varto",
                        "latitude": "39.17375000",
                        "longitude": "41.45402000"
                    }
                ]
            },
            {
                "id": 2196,
                "name": "Nevşehir",
                "iso2": "50",
                "latitude": "38.69393990",
                "longitude": "34.68565090",
                "type": "province",
                "cities": [
                    {
                        "id": 107055,
                        "name": "Acıgöl",
                        "latitude": "38.55028000",
                        "longitude": "34.50917000"
                    },
                    {
                        "id": 107211,
                        "name": "Avanos",
                        "latitude": "38.71500000",
                        "longitude": "34.84667000"
                    },
                    {
                        "id": 107481,
                        "name": "Derinkuyu",
                        "latitude": "38.37510000",
                        "longitude": "34.73419000"
                    },
                    {
                        "id": 107734,
                        "name": "Gülşehir",
                        "latitude": "38.74594000",
                        "longitude": "34.62524000"
                    },
                    {
                        "id": 107765,
                        "name": "Hacıbektaş",
                        "latitude": "38.94077000",
                        "longitude": "34.55770000"
                    },
                    {
                        "id": 108032,
                        "name": "Kozaklı",
                        "latitude": "39.23204000",
                        "longitude": "34.85585000"
                    },
                    {
                        "id": 108192,
                        "name": "Merkez",
                        "latitude": "38.60039000",
                        "longitude": "34.68537000"
                    },
                    {
                        "id": 108873,
                        "name": "Ürgüp",
                        "latitude": "38.57342000",
                        "longitude": "34.94020000"
                    }
                ]
            },
            {
                "id": 2189,
                "name": "Niğde",
                "iso2": "51",
                "latitude": "38.09930860",
                "longitude": "34.68565090",
                "type": "province",
                "cities": [
                    {
                        "id": 107136,
                        "name": "Altunhisar",
                        "latitude": "37.99159000",
                        "longitude": "34.37334000"
                    },
                    {
                        "id": 107369,
                        "name": "Bor",
                        "latitude": "37.89056000",
                        "longitude": "34.55889000"
                    },
                    {
                        "id": 108764,
                        "name": "Çamardı",
                        "latitude": "37.84157000",
                        "longitude": "34.99005000"
                    },
                    {
                        "id": 108829,
                        "name": "Çiftlik",
                        "latitude": "38.17580000",
                        "longitude": "34.48535000"
                    },
                    {
                        "id": 108252,
                        "name": "Merkez",
                        "latitude": "37.96583000",
                        "longitude": "34.67935000"
                    },
                    {
                        "id": 108628,
                        "name": "Ulukışla",
                        "latitude": "37.54592000",
                        "longitude": "34.58737000"
                    }
                ]
            },
            {
                "id": 2174,
                "name": "Ordu",
                "iso2": "52",
                "latitude": "40.79905800",
                "longitude": "37.38990050",
                "type": "province",
                "cities": [
                    {
                        "id": 107085,
                        "name": "Akkuş",
                        "latitude": "40.81000000",
                        "longitude": "36.96000000"
                    },
                    {
                        "id": 107144,
                        "name": "Altınordu",
                        "latitude": "40.94879000",
                        "longitude": "37.79572000"
                    },
                    {
                        "id": 107219,
                        "name": "Aybastı",
                        "latitude": "40.69690000",
                        "longitude": "37.40794000"
                    },
                    {
                        "id": 108765,
                        "name": "Çamaş",
                        "latitude": "40.90200000",
                        "longitude": "37.52786000"
                    },
                    {
                        "id": 108790,
                        "name": "Çatalpınar",
                        "latitude": "40.88678000",
                        "longitude": "37.44329000"
                    },
                    {
                        "id": 108797,
                        "name": "Çaybaşı",
                        "latitude": "41.02532000",
                        "longitude": "37.10867000"
                    },
                    {
                        "id": 107633,
                        "name": "Fatsa",
                        "latitude": "41.02778000",
                        "longitude": "37.50139000"
                    },
                    {
                        "id": 107697,
                        "name": "Gölköy",
                        "latitude": "40.68726000",
                        "longitude": "37.61660000"
                    },
                    {
                        "id": 107733,
                        "name": "Gülyalı",
                        "latitude": "40.96682000",
                        "longitude": "38.05679000"
                    },
                    {
                        "id": 107749,
                        "name": "Gürgentepe",
                        "latitude": "40.78567000",
                        "longitude": "37.58969000"
                    },
                    {
                        "id": 108887,
                        "name": "İkizce",
                        "latitude": "41.05833000",
                        "longitude": "37.08028000"
                    },
                    {
                        "id": 107855,
                        "name": "Kabadüz",
                        "latitude": "40.86096000",
                        "longitude": "37.88470000"
                    },
                    {
                        "id": 107858,
                        "name": "Kabataş",
                        "latitude": "40.75000000",
                        "longitude": "37.45000000"
                    },
                    {
                        "id": 108018,
                        "name": "Korgan",
                        "latitude": "40.82472000",
                        "longitude": "37.34667000"
                    },
                    {
                        "id": 108052,
                        "name": "Kumru",
                        "latitude": "40.87444000",
                        "longitude": "37.26389000"
                    },
                    {
                        "id": 108201,
                        "name": "Mesudiye",
                        "latitude": "40.45446000",
                        "longitude": "37.77353000"
                    },
                    {
                        "id": 108341,
                        "name": "Perşembe",
                        "latitude": "41.06556000",
                        "longitude": "37.77139000"
                    },
                    {
                        "id": 108622,
                        "name": "Ulubey",
                        "latitude": "40.86863000",
                        "longitude": "37.75405000"
                    },
                    {
                        "id": 108872,
                        "name": "Ünye",
                        "latitude": "41.13921000",
                        "longitude": "37.27246000"
                    }
                ]
            },
            {
                "id": 2214,
                "name": "Osmaniye",
                "iso2": "80",
                "latitude": "37.21302580",
                "longitude": "36.17626150",
                "type": "province",
                "cities": [
                    {
                        "id": 107259,
                        "name": "Bahçe",
                        "latitude": "37.20105000",
                        "longitude": "36.57687000"
                    },
                    {
                        "id": 107543,
                        "name": "Düziçi",
                        "latitude": "37.25062000",
                        "longitude": "36.47051000"
                    },
                    {
                        "id": 107798,
                        "name": "Hasanbeyli",
                        "latitude": "37.12838000",
                        "longitude": "36.54608000"
                    },
                    {
                        "id": 107860,
                        "name": "Kadirli",
                        "latitude": "37.37389000",
                        "longitude": "36.09611000"
                    },
                    {
                        "id": 108294,
                        "name": "Merkez",
                        "latitude": "37.07417000",
                        "longitude": "36.24778000"
                    },
                    {
                        "id": 108504,
                        "name": "Sumbas",
                        "latitude": "37.46169000",
                        "longitude": "36.02914000"
                    },
                    {
                        "id": 108585,
                        "name": "Toprakkale",
                        "latitude": "37.06855000",
                        "longitude": "36.14661000"
                    }
                ]
            },
            {
                "id": 2219,
                "name": "Rize",
                "iso2": "53",
                "latitude": "40.95814970",
                "longitude": "40.92269850",
                "type": "province",
                "cities": [
                    {
                        "id": 107182,
                        "name": "Ardeşen",
                        "latitude": "41.19111000",
                        "longitude": "40.98750000"
                    },
                    {
                        "id": 153358,
                        "name": "Çamlıhemşin",
                        "latitude": "41.04593800",
                        "longitude": "41.00527500"
                    },
                    {
                        "id": 108800,
                        "name": "Çayeli",
                        "latitude": "41.08941000",
                        "longitude": "40.73696000"
                    },
                    {
                        "id": 153359,
                        "name": "Derepazarı",
                        "latitude": "41.02472200",
                        "longitude": "40.42555600"
                    },
                    {
                        "id": 107644,
                        "name": "Fındıklı",
                        "latitude": "41.27110000",
                        "longitude": "41.14449000"
                    },
                    {
                        "id": 107743,
                        "name": "Güneysu",
                        "latitude": "40.98130000",
                        "longitude": "40.60465000"
                    },
                    {
                        "id": 107821,
                        "name": "Hemşin",
                        "latitude": "41.05922000",
                        "longitude": "40.90140000"
                    },
                    {
                        "id": 108889,
                        "name": "İkizdere",
                        "latitude": "40.77713000",
                        "longitude": "40.56076000"
                    },
                    {
                        "id": 108922,
                        "name": "İyidere",
                        "latitude": "41.00905000",
                        "longitude": "40.37776000"
                    },
                    {
                        "id": 107877,
                        "name": "Kalkandere",
                        "latitude": "40.92143000",
                        "longitude": "40.43999000"
                    },
                    {
                        "id": 108371,
                        "name": "Merkez",
                        "latitude": "41.02083000",
                        "longitude": "40.52194000"
                    },
                    {
                        "id": 108321,
                        "name": "Pazar",
                        "latitude": "41.17917000",
                        "longitude": "40.88417000"
                    }
                ]
            },
            {
                "id": 2150,
                "name": "Sakarya",
                "iso2": "54",
                "latitude": "40.78885500",
                "longitude": "30.40595400",
                "type": "province",
                "cities": [
                    {
                        "id": 107064,
                        "name": "Adapazarı",
                        "latitude": "40.78056000",
                        "longitude": "30.40333000"
                    },
                    {
                        "id": 107100,
                        "name": "Akyazı",
                        "latitude": "40.68500000",
                        "longitude": "30.62222000"
                    },
                    {
                        "id": 107186,
                        "name": "Arifiye",
                        "latitude": "40.71327000",
                        "longitude": "30.36128000"
                    },
                    {
                        "id": 107588,
                        "name": "Erenler",
                        "latitude": "40.75564000",
                        "longitude": "30.41453000"
                    },
                    {
                        "id": 107638,
                        "name": "Ferizli",
                        "latitude": "40.94082000",
                        "longitude": "30.48583000"
                    },
                    {
                        "id": 107673,
                        "name": "Geyve",
                        "latitude": "40.50750000",
                        "longitude": "30.29250000"
                    },
                    {
                        "id": 107822,
                        "name": "Hendek",
                        "latitude": "40.79944000",
                        "longitude": "30.74806000"
                    },
                    {
                        "id": 107910,
                        "name": "Karapürçek",
                        "latitude": "40.64194000",
                        "longitude": "30.53944000"
                    },
                    {
                        "id": 107915,
                        "name": "Karasu",
                        "latitude": "41.09983000",
                        "longitude": "30.68241000"
                    },
                    {
                        "id": 107951,
                        "name": "Kaynarca",
                        "latitude": "41.03083000",
                        "longitude": "30.30750000"
                    },
                    {
                        "id": 108003,
                        "name": "Kocaali",
                        "latitude": "41.05336000",
                        "longitude": "30.85278000"
                    },
                    {
                        "id": 108312,
                        "name": "Pamukova",
                        "latitude": "40.50810000",
                        "longitude": "30.16732000"
                    },
                    {
                        "id": 108385,
                        "name": "Sapanca",
                        "latitude": "40.69141000",
                        "longitude": "30.26738000"
                    },
                    {
                        "id": 108438,
                        "name": "Serdivan",
                        "latitude": "40.76371000",
                        "longitude": "30.36784000"
                    },
                    {
                        "id": 108519,
                        "name": "Söğütlü",
                        "latitude": "40.90590000",
                        "longitude": "30.47448000"
                    },
                    {
                        "id": 108534,
                        "name": "Taraklı",
                        "latitude": "40.39694000",
                        "longitude": "30.49278000"
                    }
                ]
            },
            {
                "id": 2220,
                "name": "Samsun",
                "iso2": "55",
                "latitude": "41.18648590",
                "longitude": "36.13226780",
                "type": "province",
                "cities": [
                    {
                        "id": 107126,
                        "name": "Alaçam",
                        "latitude": "41.61563000",
                        "longitude": "35.60632000"
                    },
                    {
                        "id": 107200,
                        "name": "Asarcık",
                        "latitude": "41.03556000",
                        "longitude": "36.23556000"
                    },
                    {
                        "id": 107206,
                        "name": "Atakum",
                        "latitude": "41.34730000",
                        "longitude": "36.23051000"
                    },
                    {
                        "id": 107230,
                        "name": "Ayvacık",
                        "latitude": "40.99111000",
                        "longitude": "36.63139000"
                    },
                    {
                        "id": 107257,
                        "name": "Bafra",
                        "latitude": "41.46082000",
                        "longitude": "35.84435000"
                    },
                    {
                        "id": 107423,
                        "name": "Canik",
                        "latitude": "41.23858000",
                        "longitude": "36.33694000"
                    },
                    {
                        "id": 108783,
                        "name": "Çarşamba",
                        "latitude": "41.19889000",
                        "longitude": "36.72194000"
                    },
                    {
                        "id": 107809,
                        "name": "Havza",
                        "latitude": "40.97056000",
                        "longitude": "35.66222000"
                    },
                    {
                        "id": 108891,
                        "name": "İlkadım",
                        "latitude": "41.29161000",
                        "longitude": "36.30106000"
                    },
                    {
                        "id": 107940,
                        "name": "Kavak",
                        "latitude": "41.07833000",
                        "longitude": "36.04250000"
                    },
                    {
                        "id": 108125,
                        "name": "Ladik",
                        "latitude": "40.91056000",
                        "longitude": "35.89194000"
                    },
                    {
                        "id": 108269,
                        "name": "Ondokuzmayıs",
                        "latitude": "41.51188000",
                        "longitude": "36.07298000"
                    },
                    {
                        "id": 108377,
                        "name": "Salıpazarı",
                        "latitude": "41.09352000",
                        "longitude": "36.81718000"
                    },
                    {
                        "id": 108561,
                        "name": "Tekkeköy",
                        "latitude": "41.14493000",
                        "longitude": "36.46205000"
                    },
                    {
                        "id": 108573,
                        "name": "Terme",
                        "latitude": "41.20917000",
                        "longitude": "36.97389000"
                    },
                    {
                        "id": 108651,
                        "name": "Vezirköprü",
                        "latitude": "41.14361000",
                        "longitude": "35.45472000"
                    },
                    {
                        "id": 108660,
                        "name": "Yakakent",
                        "latitude": "41.63250000",
                        "longitude": "35.52889000"
                    }
                ]
            },
            {
                "id": 2183,
                "name": "Şanlıurfa",
                "iso2": "63",
                "latitude": "37.35691020",
                "longitude": "39.15436770",
                "type": "province",
                "cities": [
                    {
                        "id": 107107,
                        "name": "Akçakale",
                        "latitude": "36.71111000",
                        "longitude": "38.94750000"
                    },
                    {
                        "id": 107359,
                        "name": "Birecik",
                        "latitude": "37.02577000",
                        "longitude": "37.97841000"
                    },
                    {
                        "id": 107388,
                        "name": "Bozova",
                        "latitude": "37.36250000",
                        "longitude": "38.52667000"
                    },
                    {
                        "id": 107428,
                        "name": "Ceylanpınar",
                        "latitude": "36.84722000",
                        "longitude": "40.05000000"
                    },
                    {
                        "id": 107621,
                        "name": "Eyyübiye",
                        "latitude": "37.21434000",
                        "longitude": "38.79358000"
                    },
                    {
                        "id": 107775,
                        "name": "Halfeti",
                        "latitude": "37.24529000",
                        "longitude": "37.86874000"
                    },
                    {
                        "id": 107777,
                        "name": "Haliliye",
                        "latitude": "37.14144000",
                        "longitude": "38.79599000"
                    },
                    {
                        "id": 107796,
                        "name": "Harran",
                        "latitude": "36.86000000",
                        "longitude": "39.03139000"
                    },
                    {
                        "id": 107825,
                        "name": "Hilvan",
                        "latitude": "37.58687000",
                        "longitude": "38.95505000"
                    },
                    {
                        "id": 107903,
                        "name": "Karaköprü",
                        "latitude": "37.18029000",
                        "longitude": "38.81109000"
                    },
                    {
                        "id": 108476,
                        "name": "Siverek",
                        "latitude": "37.75503000",
                        "longitude": "39.31667000"
                    },
                    {
                        "id": 108507,
                        "name": "Suruç",
                        "latitude": "36.97612000",
                        "longitude": "38.42533000"
                    },
                    {
                        "id": 108653,
                        "name": "Viranşehir",
                        "latitude": "37.22349000",
                        "longitude": "39.75519000"
                    }
                ]
            },
            {
                "id": 2207,
                "name": "Siirt",
                "iso2": "56",
                "latitude": "37.86588620",
                "longitude": "42.14945230",
                "type": "province",
                "cities": [
                    {
                        "id": 107298,
                        "name": "Baykan",
                        "latitude": "38.15754000",
                        "longitude": "41.77330000"
                    },
                    {
                        "id": 107598,
                        "name": "Eruh",
                        "latitude": "37.74183000",
                        "longitude": "42.17422000"
                    },
                    {
                        "id": 108055,
                        "name": "Kurtalan",
                        "latitude": "37.92533000",
                        "longitude": "41.68493000"
                    },
                    {
                        "id": 108457,
                        "name": "Merkez",
                        "latitude": "37.92930000",
                        "longitude": "41.94134000"
                    },
                    {
                        "id": 108339,
                        "name": "Pervari",
                        "latitude": "37.93573000",
                        "longitude": "42.54927000"
                    },
                    {
                        "id": 108961,
                        "name": "Şirvan",
                        "latitude": "38.06251000",
                        "longitude": "42.02517000"
                    },
                    {
                        "id": 108576,
                        "name": "Tillo",
                        "latitude": "37.94911000",
                        "longitude": "42.01210000"
                    }
                ]
            },
            {
                "id": 4854,
                "name": "Sinop",
                "iso2": "57",
                "latitude": "41.55947490",
                "longitude": "34.85805320",
                "type": "province",
                "cities": [
                    {
                        "id": 153360,
                        "name": "Ayancık",
                        "latitude": "41.95000000",
                        "longitude": "34.58333300"
                    },
                    {
                        "id": 142113,
                        "name": "Boyabat",
                        "latitude": "41.46889000",
                        "longitude": "34.76667000"
                    },
                    {
                        "id": 142115,
                        "name": "Dikmen",
                        "latitude": "41.66000000",
                        "longitude": "35.27055556"
                    },
                    {
                        "id": 142116,
                        "name": "Durağan",
                        "latitude": "41.42555556",
                        "longitude": "35.05777778"
                    },
                    {
                        "id": 142117,
                        "name": "Erfelek",
                        "latitude": "41.87926000",
                        "longitude": "34.91838000"
                    },
                    {
                        "id": 142119,
                        "name": "Gerze",
                        "latitude": "41.81000000",
                        "longitude": "35.19027778"
                    },
                    {
                        "id": 142120,
                        "name": "Merkez",
                        "latitude": "41.91835000",
                        "longitude": "35.00687000"
                    },
                    {
                        "id": 142121,
                        "name": "Saraydüzü",
                        "latitude": "41.33722222",
                        "longitude": "34.85361111"
                    },
                    {
                        "id": 142123,
                        "name": "Türkeli",
                        "latitude": "41.94777778",
                        "longitude": "34.33861111"
                    }
                ]
            },
            {
                "id": 2181,
                "name": "Sivas",
                "iso2": "58",
                "latitude": "39.44880390",
                "longitude": "37.12944970",
                "type": "province",
                "cities": [
                    {
                        "id": 107113,
                        "name": "Akıncılar",
                        "latitude": "40.07172000",
                        "longitude": "38.34330000"
                    },
                    {
                        "id": 107149,
                        "name": "Altınyayla",
                        "latitude": "39.27249000",
                        "longitude": "36.75098000"
                    },
                    {
                        "id": 107500,
                        "name": "Divriği",
                        "latitude": "39.37100000",
                        "longitude": "38.11370000"
                    },
                    {
                        "id": 107523,
                        "name": "Doğanşar",
                        "latitude": "40.20841000",
                        "longitude": "37.53123000"
                    },
                    {
                        "id": 107658,
                        "name": "Gemerek",
                        "latitude": "39.18342000",
                        "longitude": "36.07189000"
                    },
                    {
                        "id": 107700,
                        "name": "Gölova",
                        "latitude": "40.06194000",
                        "longitude": "38.60667000"
                    },
                    {
                        "id": 107757,
                        "name": "Gürün",
                        "latitude": "38.72225000",
                        "longitude": "37.27097000"
                    },
                    {
                        "id": 107772,
                        "name": "Hafik",
                        "latitude": "39.85639000",
                        "longitude": "37.38639000"
                    },
                    {
                        "id": 108894,
                        "name": "İmranlı",
                        "latitude": "39.87544000",
                        "longitude": "38.11358000"
                    },
                    {
                        "id": 107883,
                        "name": "Kangal",
                        "latitude": "39.23354000",
                        "longitude": "37.39111000"
                    },
                    {
                        "id": 108029,
                        "name": "Koyulhisar",
                        "latitude": "40.30184000",
                        "longitude": "37.82336000"
                    },
                    {
                        "id": 108187,
                        "name": "Merkez",
                        "latitude": "39.71613000",
                        "longitude": "36.97695000"
                    },
                    {
                        "id": 108938,
                        "name": "Şarkışla",
                        "latitude": "39.35186000",
                        "longitude": "36.40976000"
                    },
                    {
                        "id": 108513,
                        "name": "Suşehri",
                        "latitude": "40.16005000",
                        "longitude": "38.08413000"
                    },
                    {
                        "id": 108618,
                        "name": "Ulaş",
                        "latitude": "39.44492000",
                        "longitude": "37.03900000"
                    },
                    {
                        "id": 108747,
                        "name": "Yıldızeli",
                        "latitude": "39.87601000",
                        "longitude": "36.60652000"
                    },
                    {
                        "id": 108749,
                        "name": "Zara",
                        "latitude": "39.82406000",
                        "longitude": "37.77499000"
                    }
                ]
            },
            {
                "id": 2225,
                "name": "Şırnak",
                "iso2": "73",
                "latitude": "37.41874810",
                "longitude": "42.49183380",
                "type": "province",
                "cities": [
                    {
                        "id": 107344,
                        "name": "Beytüşşebap",
                        "latitude": "37.57144000",
                        "longitude": "43.16515000"
                    },
                    {
                        "id": 107436,
                        "name": "Cizre",
                        "latitude": "37.33024000",
                        "longitude": "42.18484000"
                    },
                    {
                        "id": 107763,
                        "name": "Güçlükonak",
                        "latitude": "37.47133000",
                        "longitude": "41.91298000"
                    },
                    {
                        "id": 108879,
                        "name": "İdil",
                        "latitude": "37.33481000",
                        "longitude": "41.88944000"
                    },
                    {
                        "id": 108966,
                        "name": "Merkez",
                        "latitude": "37.51393000",
                        "longitude": "42.45432000"
                    },
                    {
                        "id": 108461,
                        "name": "Silopi",
                        "latitude": "37.24379000",
                        "longitude": "42.46345000"
                    },
                    {
                        "id": 108626,
                        "name": "Uludere",
                        "latitude": "37.44074000",
                        "longitude": "42.85236000"
                    }
                ]
            },
            {
                "id": 2167,
                "name": "Tekirdağ",
                "iso2": "59",
                "latitude": "41.11212270",
                "longitude": "27.26761160",
                "type": "province",
                "cities": [
                    {
                        "id": 108819,
                        "name": "Çerkezköy",
                        "latitude": "41.28616000",
                        "longitude": "27.99969000"
                    },
                    {
                        "id": 108842,
                        "name": "Çorlu",
                        "latitude": "41.15917000",
                        "longitude": "27.80000000"
                    },
                    {
                        "id": 107594,
                        "name": "Ergene",
                        "latitude": "40.85953000",
                        "longitude": "27.27081000"
                    },
                    {
                        "id": 107813,
                        "name": "Hayrabolu",
                        "latitude": "41.21311000",
                        "longitude": "27.10688000"
                    },
                    {
                        "id": 107885,
                        "name": "Kapaklı",
                        "latitude": "41.32912000",
                        "longitude": "27.98064000"
                    },
                    {
                        "id": 108144,
                        "name": "Malkara",
                        "latitude": "40.89000000",
                        "longitude": "26.90111000"
                    },
                    {
                        "id": 108156,
                        "name": "Marmaraereğlisi",
                        "latitude": "40.97003000",
                        "longitude": "27.95528000"
                    },
                    {
                        "id": 108223,
                        "name": "Muratlı",
                        "latitude": "41.18345000",
                        "longitude": "27.51454000"
                    },
                    {
                        "id": 108388,
                        "name": "Saray",
                        "latitude": "41.44431000",
                        "longitude": "27.92194000"
                    },
                    {
                        "id": 108937,
                        "name": "Şarköy",
                        "latitude": "40.62513000",
                        "longitude": "27.10069000"
                    },
                    {
                        "id": 108522,
                        "name": "Süleymanpaşa",
                        "latitude": "40.97990000",
                        "longitude": "27.30377000"
                    }
                ]
            },
            {
                "id": 2199,
                "name": "Tokat",
                "iso2": "60",
                "latitude": "40.39027130",
                "longitude": "36.62518630",
                "type": "province",
                "cities": [
                    {
                        "id": 107131,
                        "name": "Almus",
                        "latitude": "40.37583000",
                        "longitude": "36.90444000"
                    },
                    {
                        "id": 107193,
                        "name": "Artova",
                        "latitude": "40.11578000",
                        "longitude": "36.30010000"
                    },
                    {
                        "id": 107322,
                        "name": "Başçiftlik",
                        "latitude": "40.54694000",
                        "longitude": "37.16917000"
                    },
                    {
                        "id": 107582,
                        "name": "Erbaa",
                        "latitude": "40.71390000",
                        "longitude": "36.59364000"
                    },
                    {
                        "id": 108580,
                        "name": "Merkez",
                        "latitude": "40.31389000",
                        "longitude": "36.55444000"
                    },
                    {
                        "id": 108248,
                        "name": "Niksar",
                        "latitude": "40.60509000",
                        "longitude": "36.97174000"
                    },
                    {
                        "id": 108322,
                        "name": "Pazar",
                        "latitude": "40.27652000",
                        "longitude": "36.28347000"
                    },
                    {
                        "id": 108370,
                        "name": "Reşadiye",
                        "latitude": "40.43284000",
                        "longitude": "37.37652000"
                    },
                    {
                        "id": 108502,
                        "name": "Sulusaray",
                        "latitude": "39.99389000",
                        "longitude": "36.08404000"
                    },
                    {
                        "id": 108602,
                        "name": "Turhal",
                        "latitude": "40.38750000",
                        "longitude": "36.08111000"
                    },
                    {
                        "id": 108729,
                        "name": "Yeşilyurt",
                        "latitude": "39.99916000",
                        "longitude": "36.23479000"
                    },
                    {
                        "id": 108753,
                        "name": "Zile",
                        "latitude": "40.30306000",
                        "longitude": "35.88639000"
                    }
                ]
            },
            {
                "id": 2206,
                "name": "Trabzon",
                "iso2": "61",
                "latitude": "40.79924100",
                "longitude": "39.58479440",
                "type": "province",
                "cities": [
                    {
                        "id": 107104,
                        "name": "Akçaabat",
                        "latitude": "41.01970000",
                        "longitude": "39.56293000"
                    },
                    {
                        "id": 107171,
                        "name": "Araklı",
                        "latitude": "40.74000000",
                        "longitude": "39.96000000"
                    },
                    {
                        "id": 107191,
                        "name": "Arsin",
                        "latitude": "40.86743000",
                        "longitude": "39.92938000"
                    },
                    {
                        "id": 107348,
                        "name": "Beşikdüzü",
                        "latitude": "41.05202000",
                        "longitude": "39.23294000"
                    },
                    {
                        "id": 108785,
                        "name": "Çarşıbaşı",
                        "latitude": "41.04203000",
                        "longitude": "39.40035000"
                    },
                    {
                        "id": 108801,
                        "name": "Çaykara",
                        "latitude": "40.74267000",
                        "longitude": "40.23175000"
                    },
                    {
                        "id": 107483,
                        "name": "Dernekpazarı",
                        "latitude": "40.79658000",
                        "longitude": "40.24460000"
                    },
                    {
                        "id": 107544,
                        "name": "Düzköy",
                        "latitude": "40.87461000",
                        "longitude": "39.41536000"
                    },
                    {
                        "id": 107815,
                        "name": "Hayrat",
                        "latitude": "40.88530000",
                        "longitude": "40.36495000"
                    },
                    {
                        "id": 108073,
                        "name": "Köprübaşı",
                        "latitude": "40.80692000",
                        "longitude": "40.11439000"
                    },
                    {
                        "id": 108165,
                        "name": "Maçka",
                        "latitude": "40.72127000",
                        "longitude": "39.59786000"
                    },
                    {
                        "id": 108261,
                        "name": "Of",
                        "latitude": "40.94055000",
                        "longitude": "40.25918000"
                    },
                    {
                        "id": 108282,
                        "name": "Ortahisar",
                        "latitude": "40.88029000",
                        "longitude": "39.88998000"
                    },
                    {
                        "id": 108930,
                        "name": "Şalpazarı",
                        "latitude": "40.93826000",
                        "longitude": "39.19006000"
                    },
                    {
                        "id": 108524,
                        "name": "Sürmene",
                        "latitude": "40.90588000",
                        "longitude": "40.12792000"
                    },
                    {
                        "id": 108583,
                        "name": "Tonya",
                        "latitude": "40.88402000",
                        "longitude": "39.28486000"
                    },
                    {
                        "id": 108645,
                        "name": "Vakfıkebir",
                        "latitude": "41.04583000",
                        "longitude": "39.27639000"
                    },
                    {
                        "id": 108733,
                        "name": "Yomra",
                        "latitude": "40.95326000",
                        "longitude": "39.85546000"
                    }
                ]
            },
            {
                "id": 2192,
                "name": "Tunceli",
                "iso2": "62",
                "latitude": "39.30735540",
                "longitude": "39.43877780",
                "type": "province",
                "cities": [
                    {
                        "id": 108818,
                        "name": "Çemişgezek",
                        "latitude": "39.06234000",
                        "longitude": "38.91400000"
                    },
                    {
                        "id": 107838,
                        "name": "Hozat",
                        "latitude": "39.10029000",
                        "longitude": "39.20816000"
                    },
                    {
                        "id": 108161,
                        "name": "Mazgirt",
                        "latitude": "39.01783000",
                        "longitude": "39.60064000"
                    },
                    {
                        "id": 108179,
                        "name": "Merkez",
                        "latitude": "39.17114000",
                        "longitude": "39.55570000"
                    },
                    {
                        "id": 108245,
                        "name": "Nazımiye",
                        "latitude": "39.17952000",
                        "longitude": "39.82805000"
                    },
                    {
                        "id": 108297,
                        "name": "Ovacık",
                        "latitude": "39.35259000",
                        "longitude": "39.20890000"
                    },
                    {
                        "id": 108337,
                        "name": "Pertek",
                        "latitude": "38.86574000",
                        "longitude": "39.32273000"
                    },
                    {
                        "id": 108353,
                        "name": "Pülümür",
                        "latitude": "39.48662000",
                        "longitude": "39.89874000"
                    }
                ]
            },
            {
                "id": 2201,
                "name": "Uşak",
                "iso2": "64",
                "latitude": "38.54313190",
                "longitude": "29.23207840",
                "type": "province",
                "cities": [
                    {
                        "id": 107281,
                        "name": "Banaz",
                        "latitude": "38.73707000",
                        "longitude": "29.75194000"
                    },
                    {
                        "id": 107629,
                        "name": "Eşme",
                        "latitude": "38.39976000",
                        "longitude": "28.96905000"
                    },
                    {
                        "id": 107894,
                        "name": "Karahallı",
                        "latitude": "38.32083000",
                        "longitude": "29.53028000"
                    },
                    {
                        "id": 108183,
                        "name": "Merkez",
                        "latitude": "38.68463000",
                        "longitude": "29.29455000"
                    },
                    {
                        "id": 108474,
                        "name": "Sivaslı",
                        "latitude": "38.49944000",
                        "longitude": "29.68361000"
                    },
                    {
                        "id": 108621,
                        "name": "Ulubey",
                        "latitude": "38.41987000",
                        "longitude": "29.29129000"
                    }
                ]
            },
            {
                "id": 2152,
                "name": "Van",
                "iso2": "65",
                "latitude": "38.36794170",
                "longitude": "43.71827870",
                "type": "province",
                "cities": [
                    {
                        "id": 107262,
                        "name": "Bahçesaray",
                        "latitude": "38.12460000",
                        "longitude": "42.79825000"
                    },
                    {
                        "id": 107315,
                        "name": "Başkale",
                        "latitude": "38.04526000",
                        "longitude": "44.01718000"
                    },
                    {
                        "id": 108760,
                        "name": "Çaldıran",
                        "latitude": "39.14317000",
                        "longitude": "43.91068000"
                    },
                    {
                        "id": 108787,
                        "name": "Çatak",
                        "latitude": "38.00780000",
                        "longitude": "43.06195000"
                    },
                    {
                        "id": 107551,
                        "name": "Edremit",
                        "latitude": "38.37889000",
                        "longitude": "43.29717000"
                    },
                    {
                        "id": 107583,
                        "name": "Erciş",
                        "latitude": "39.15123000",
                        "longitude": "43.33705000"
                    },
                    {
                        "id": 107670,
                        "name": "Gevaş",
                        "latitude": "38.29210000",
                        "longitude": "43.10189000"
                    },
                    {
                        "id": 107753,
                        "name": "Gürpınar",
                        "latitude": "38.32372000",
                        "longitude": "43.40991000"
                    },
                    {
                        "id": 108908,
                        "name": "İpekyolu",
                        "latitude": "38.49041000",
                        "longitude": "43.34690000"
                    },
                    {
                        "id": 108220,
                        "name": "Muradiye",
                        "latitude": "38.97889000",
                        "longitude": "43.75374000"
                    },
                    {
                        "id": 108866,
                        "name": "Özalp",
                        "latitude": "38.65455000",
                        "longitude": "43.98869000"
                    },
                    {
                        "id": 108387,
                        "name": "Saray",
                        "latitude": "38.64691000",
                        "longitude": "44.16116000"
                    },
                    {
                        "id": 153361,
                        "name": "Tuşba",
                        "latitude": "38.52117800",
                        "longitude": "43.34909300"
                    }
                ]
            },
            {
                "id": 2218,
                "name": "Yalova",
                "iso2": "77",
                "latitude": "40.57759860",
                "longitude": "29.20883030",
                "type": "province",
                "cities": [
                    {
                        "id": 107145,
                        "name": "Altınova",
                        "latitude": "40.69495000",
                        "longitude": "29.50986000"
                    },
                    {
                        "id": 107187,
                        "name": "Armutlu",
                        "latitude": "40.52919000",
                        "longitude": "28.83871000"
                    },
                    {
                        "id": 108831,
                        "name": "Çiftlikköy",
                        "latitude": "40.66028000",
                        "longitude": "29.32361000"
                    },
                    {
                        "id": 108856,
                        "name": "Çınarcık",
                        "latitude": "40.64538000",
                        "longitude": "29.12450000"
                    },
                    {
                        "id": 108665,
                        "name": "Merkez",
                        "latitude": "40.65501000",
                        "longitude": "29.27693000"
                    },
                    {
                        "id": 108572,
                        "name": "Termal",
                        "latitude": "40.61381000",
                        "longitude": "29.18049000"
                    }
                ]
            },
            {
                "id": 2188,
                "name": "Yozgat",
                "iso2": "66",
                "latitude": "39.72719790",
                "longitude": "35.10778580",
                "type": "province",
                "cities": [
                    {
                        "id": 107077,
                        "name": "Akdağmadeni",
                        "latitude": "39.66028000",
                        "longitude": "35.88361000"
                    },
                    {
                        "id": 107222,
                        "name": "Aydıncık",
                        "latitude": "40.12727000",
                        "longitude": "35.28765000"
                    },
                    {
                        "id": 107397,
                        "name": "Boğazlıyan",
                        "latitude": "39.19627000",
                        "longitude": "35.25420000"
                    },
                    {
                        "id": 108778,
                        "name": "Çandır",
                        "latitude": "39.25445000",
                        "longitude": "35.52284000"
                    },
                    {
                        "id": 108804,
                        "name": "Çayıralan",
                        "latitude": "39.30278000",
                        "longitude": "35.64389000"
                    },
                    {
                        "id": 108810,
                        "name": "Çekerek",
                        "latitude": "40.07306000",
                        "longitude": "35.49472000"
                    },
                    {
                        "id": 107866,
                        "name": "Kadışehri",
                        "latitude": "39.99568000",
                        "longitude": "35.79193000"
                    },
                    {
                        "id": 108735,
                        "name": "Merkez",
                        "latitude": "39.82000000",
                        "longitude": "34.80444000"
                    },
                    {
                        "id": 108391,
                        "name": "Saraykent",
                        "latitude": "39.69361000",
                        "longitude": "35.51111000"
                    },
                    {
                        "id": 108403,
                        "name": "Sarıkaya",
                        "latitude": "39.49361000",
                        "longitude": "35.37694000"
                    },
                    {
                        "id": 108944,
                        "name": "Şefaatli",
                        "latitude": "39.50080000",
                        "longitude": "34.76388000"
                    },
                    {
                        "id": 108487,
                        "name": "Sorgun",
                        "latitude": "39.81012000",
                        "longitude": "35.18596000"
                    },
                    {
                        "id": 108697,
                        "name": "Yenifakılı",
                        "latitude": "39.21142000",
                        "longitude": "35.00036000"
                    },
                    {
                        "id": 108718,
                        "name": "Yerköy",
                        "latitude": "39.63806000",
                        "longitude": "34.46722000"
                    }
                ]
            },
            {
                "id": 2213,
                "name": "Zonguldak",
                "iso2": "67",
                "latitude": "41.31249170",
                "longitude": "31.85982510",
                "type": "province",
                "cities": [
                    {
                        "id": 107124,
                        "name": "Alaplı",
                        "latitude": "41.18140000",
                        "longitude": "31.38514000"
                    },
                    {
                        "id": 108798,
                        "name": "Çaycuma",
                        "latitude": "41.42639000",
                        "longitude": "32.07556000"
                    },
                    {
                        "id": 107486,
                        "name": "Devrek",
                        "latitude": "41.21917000",
                        "longitude": "31.95583000"
                    },
                    {
                        "id": 107590,
                        "name": "Ereğli",
                        "latitude": "41.23807000",
                        "longitude": "31.60581000"
                    },
                    {
                        "id": 107684,
                        "name": "Gökçebey",
                        "latitude": "41.31339000",
                        "longitude": "32.14981000"
                    },
                    {
                        "id": 107996,
                        "name": "Kilimli",
                        "latitude": "41.49111000",
                        "longitude": "31.83861000"
                    },
                    {
                        "id": 108034,
                        "name": "Kozlu",
                        "latitude": "41.43194000",
                        "longitude": "31.74583000"
                    },
                    {
                        "id": 108755,
                        "name": "Merkez",
                        "latitude": "41.45139000",
                        "longitude": "31.79305000"
                    }
                ]
            }
        ]
    },
    {
        "id": 226,
        "name": "Turkmenistan",
        "iso3": "TKM",
        "iso2": "TM",
        "numeric_code": "795",
        "phonecode": "993",
        "capital": "Ashgabat",
        "currency": "TMT",
        "currency_name": "Turkmenistan manat",
        "currency_symbol": "T",
        "tld": ".tm",
        "native": "Türkmenistan",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Central Asia",
        "subregion_id": 10,
        "nationality": "Turkmen",
        "timezones": [
            {
                "zoneName": "Asia\/Ashgabat",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "TMT",
                "tzName": "Turkmenistan Time"
            }
        ],
        "translations": {
            "br": "Turkmenistan",
            "ko": "투르크메니스탄",
            "pt-BR": "Turcomenistão",
            "pt": "Turquemenistão",
            "nl": "Turkmenistan",
            "hr": "Turkmenistan",
            "fa": "ترکمنستان",
            "de": "Turkmenistan",
            "es": "Turkmenistán",
            "fr": "Turkménistan",
            "ja": "トルクメニスタン",
            "it": "Turkmenistan",
            "zh-CN": "土库曼斯坦",
            "tr": "Türkmenistan",
            "ru": "Туркменистан",
            "uk": "Туркменістан",
            "pl": "Turkmenistan"
        },
        "latitude": "40.00000000",
        "longitude": "60.00000000",
        "emoji": "🇹🇲",
        "emojiU": "U+1F1F9 U+1F1F2",
        "states": [
            {
                "id": 3374,
                "name": "Ahal",
                "iso2": "A",
                "latitude": "38.63993980",
                "longitude": "59.47209040",
                "type": "region",
                "cities": [
                    {
                        "id": 106880,
                        "name": "Abadan",
                        "latitude": "38.05415000",
                        "longitude": "58.19721000"
                    },
                    {
                        "id": 106882,
                        "name": "Annau",
                        "latitude": "37.88754000",
                        "longitude": "58.51596000"
                    },
                    {
                        "id": 106883,
                        "name": "Arçabil",
                        "latitude": "37.91500000",
                        "longitude": "58.08987000"
                    },
                    {
                        "id": 106886,
                        "name": "Baharly",
                        "latitude": "38.43624000",
                        "longitude": "57.43158000"
                    },
                    {
                        "id": 106896,
                        "name": "Kaka",
                        "latitude": "37.34821000",
                        "longitude": "59.61431000"
                    },
                    {
                        "id": 106905,
                        "name": "Tejen",
                        "latitude": "37.38338000",
                        "longitude": "60.50545000"
                    }
                ]
            },
            {
                "id": 3371,
                "name": "Ashgabat",
                "iso2": "S",
                "latitude": "37.96007660",
                "longitude": "58.32606290",
                "type": "city",
                "cities": [
                    {
                        "id": 106884,
                        "name": "Ashgabat",
                        "latitude": "37.95000000",
                        "longitude": "58.38333000"
                    }
                ]
            },
            {
                "id": 3372,
                "name": "Balkan",
                "iso2": "B",
                "latitude": "41.81014720",
                "longitude": "21.09373110",
                "type": "region",
                "cities": [
                    {
                        "id": 106887,
                        "name": "Balkanabat",
                        "latitude": "39.51075000",
                        "longitude": "54.36713000"
                    },
                    {
                        "id": 106889,
                        "name": "Bereket",
                        "latitude": "39.24463000",
                        "longitude": "55.51536000"
                    },
                    {
                        "id": 106895,
                        "name": "Gumdag",
                        "latitude": "39.20611000",
                        "longitude": "54.59056000"
                    },
                    {
                        "id": 106898,
                        "name": "Magtymguly",
                        "latitude": "38.43749000",
                        "longitude": "56.28081000"
                    },
                    {
                        "id": 106901,
                        "name": "Serdar",
                        "latitude": "38.97644000",
                        "longitude": "56.27575000"
                    },
                    {
                        "id": 106907,
                        "name": "Türkmenbaşy",
                        "latitude": "40.02216000",
                        "longitude": "52.95517000"
                    }
                ]
            },
            {
                "id": 3373,
                "name": "Daşoguz",
                "iso2": "D",
                "latitude": "41.83687370",
                "longitude": "59.96519040",
                "type": "region",
                "cities": [
                    {
                        "id": 106881,
                        "name": "Akdepe",
                        "latitude": "42.05513000",
                        "longitude": "59.37877000"
                    },
                    {
                        "id": 106890,
                        "name": "Boldumsaz",
                        "latitude": "42.12824000",
                        "longitude": "59.67101000"
                    },
                    {
                        "id": 106891,
                        "name": "Daşoguz",
                        "latitude": "41.83625000",
                        "longitude": "59.96661000"
                    },
                    {
                        "id": 106897,
                        "name": "Köneürgench",
                        "latitude": "42.32773000",
                        "longitude": "59.15442000"
                    },
                    {
                        "id": 106904,
                        "name": "Tagta",
                        "latitude": "41.65041000",
                        "longitude": "59.91640000"
                    },
                    {
                        "id": 106909,
                        "name": "Yylanly",
                        "latitude": "41.83333000",
                        "longitude": "59.65000000"
                    }
                ]
            },
            {
                "id": 3370,
                "name": "Lebap",
                "iso2": "L",
                "latitude": "38.12724620",
                "longitude": "64.71624150",
                "type": "region",
                "cities": [
                    {
                        "id": 106885,
                        "name": "Atamyrat",
                        "latitude": "37.83573000",
                        "longitude": "65.21058000"
                    },
                    {
                        "id": 106892,
                        "name": "Farap",
                        "latitude": "39.17037000",
                        "longitude": "63.61165000"
                    },
                    {
                        "id": 106893,
                        "name": "Gazojak",
                        "latitude": "41.18746000",
                        "longitude": "61.40360000"
                    },
                    {
                        "id": 106894,
                        "name": "Gowurdak",
                        "latitude": "37.81244000",
                        "longitude": "66.04656000"
                    },
                    {
                        "id": 106900,
                        "name": "Saýat",
                        "latitude": "38.78393000",
                        "longitude": "63.88035000"
                    },
                    {
                        "id": 106906,
                        "name": "Türkmenabat",
                        "latitude": "39.07328000",
                        "longitude": "63.57861000"
                    }
                ]
            },
            {
                "id": 3369,
                "name": "Mary",
                "iso2": "M",
                "latitude": "36.94816230",
                "longitude": "62.45041540",
                "type": "region",
                "cities": [
                    {
                        "id": 106888,
                        "name": "Bayramaly",
                        "latitude": "37.61852000",
                        "longitude": "62.16715000"
                    },
                    {
                        "id": 106899,
                        "name": "Mary",
                        "latitude": "37.59378000",
                        "longitude": "61.83031000"
                    },
                    {
                        "id": 106902,
                        "name": "Serhetabat",
                        "latitude": "35.27992000",
                        "longitude": "62.34383000"
                    },
                    {
                        "id": 106903,
                        "name": "Seydi",
                        "latitude": "39.48160000",
                        "longitude": "62.91374000"
                    },
                    {
                        "id": 106908,
                        "name": "Yolöten",
                        "latitude": "37.29886000",
                        "longitude": "62.35975000"
                    }
                ]
            }
        ]
    },
    {
        "id": 227,
        "name": "Turks and Caicos Islands",
        "iso3": "TCA",
        "iso2": "TC",
        "numeric_code": "796",
        "phonecode": "1",
        "capital": "Cockburn Town",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".tc",
        "native": "Turks and Caicos Islands",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "Turks and Caicos Island",
        "timezones": [
            {
                "zoneName": "America\/Grand_Turk",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            }
        ],
        "translations": {
            "br": "Inizi Turks ha Caicos",
            "ko": "터크스 케이커스 제도",
            "pt-BR": "Ilhas Turcas e Caicos",
            "pt": "Ilhas Turcas e Caicos",
            "nl": "Turks- en Caicoseilanden",
            "hr": "Otoci Turks i Caicos",
            "fa": "جزایر تورکس و کایکوس",
            "de": "Turks- und Caicosinseln",
            "es": "Islas Turks y Caicos",
            "fr": "Îles Turques-et-Caïques",
            "ja": "タークス・カイコス諸島",
            "it": "Isole Turks e Caicos",
            "zh-CN": "特克斯和凯科斯群岛",
            "tr": "Turks Ve Caicos Adalari",
            "ru": "Острова Теркс и Кайкос",
            "uk": "Острови Теркс і Кайкос",
            "pl": "Wyspy Turks i Caicos"
        },
        "latitude": "21.75000000",
        "longitude": "-71.58333333",
        "emoji": "🇹🇨",
        "emojiU": "U+1F1F9 U+1F1E8",
        "states": [
            {
                "id": 5367,
                "name": "Grand Turk",
                "iso2": "05",
                "latitude": "21.46808660",
                "longitude": "-71.18102580",
                "type": "district",
                "cities": []
            },
            {
                "id": 5365,
                "name": "Middle Caicos",
                "iso2": "03",
                "latitude": "21.77850560",
                "longitude": "-71.93797700",
                "type": "district",
                "cities": []
            },
            {
                "id": 5364,
                "name": "North Caicos",
                "iso2": "02",
                "latitude": "21.87591620",
                "longitude": "-72.03820280",
                "type": "district",
                "cities": []
            },
            {
                "id": 5363,
                "name": "Providenciales",
                "iso2": "01",
                "latitude": "21.80156180",
                "longitude": "-72.40832920",
                "type": "district",
                "cities": []
            },
            {
                "id": 5368,
                "name": "Salt Cay",
                "iso2": "06",
                "latitude": "21.32425360",
                "longitude": "-71.22076060",
                "type": "district",
                "cities": []
            },
            {
                "id": 5366,
                "name": "South Caicos",
                "iso2": "04",
                "latitude": "21.53024870",
                "longitude": "-71.56044860",
                "type": "district",
                "cities": []
            }
        ]
    },
    {
        "id": 228,
        "name": "Tuvalu",
        "iso3": "TUV",
        "iso2": "TV",
        "numeric_code": "798",
        "phonecode": "688",
        "capital": "Funafuti",
        "currency": "AUD",
        "currency_name": "Australian dollar",
        "currency_symbol": "$",
        "tld": ".tv",
        "native": "Tuvalu",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Polynesia",
        "subregion_id": 22,
        "nationality": "Tuvaluan",
        "timezones": [
            {
                "zoneName": "Pacific\/Funafuti",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "TVT",
                "tzName": "Tuvalu Time"
            }
        ],
        "translations": {
            "br": "Tuvalu",
            "ko": "투발루",
            "pt-BR": "Tuvalu",
            "pt": "Tuvalu",
            "nl": "Tuvalu",
            "hr": "Tuvalu",
            "fa": "تووالو",
            "de": "Tuvalu",
            "es": "Tuvalu",
            "fr": "Tuvalu",
            "ja": "ツバル",
            "it": "Tuvalu",
            "zh-CN": "图瓦卢",
            "tr": "Tuvalu",
            "ru": "Тувалу",
            "uk": "Тувалу",
            "pl": "Tuvalu"
        },
        "latitude": "-8.00000000",
        "longitude": "178.00000000",
        "emoji": "🇹🇻",
        "emojiU": "U+1F1F9 U+1F1FB",
        "states": [
            {
                "id": 3951,
                "name": "Funafuti",
                "iso2": "FUN",
                "latitude": "-8.52114710",
                "longitude": "179.19619260",
                "type": "town council",
                "cities": [
                    {
                        "id": 108993,
                        "name": "Alapi Village",
                        "latitude": "-8.52074000",
                        "longitude": "179.19680000"
                    },
                    {
                        "id": 108995,
                        "name": "Fakaifou Village",
                        "latitude": "-8.51758000",
                        "longitude": "179.20094000"
                    },
                    {
                        "id": 108996,
                        "name": "Funafuti",
                        "latitude": "-8.52425000",
                        "longitude": "179.19417000"
                    }
                ]
            },
            {
                "id": 3947,
                "name": "Nanumanga",
                "iso2": "NMG",
                "latitude": "-6.28580190",
                "longitude": "176.31992800",
                "type": "island council",
                "cities": [
                    {
                        "id": 109001,
                        "name": "Toga Village",
                        "latitude": "-6.28764000",
                        "longitude": "176.31472000"
                    }
                ]
            },
            {
                "id": 3949,
                "name": "Nanumea",
                "iso2": "NMA",
                "latitude": "-5.68816170",
                "longitude": "176.13701480",
                "type": "island council",
                "cities": []
            },
            {
                "id": 3946,
                "name": "Niutao Island Council",
                "iso2": "NIT",
                "latitude": "-6.10642580",
                "longitude": "177.34384290",
                "type": "island council",
                "cities": [
                    {
                        "id": 108997,
                        "name": "Kulia Village",
                        "latitude": "-6.10819000",
                        "longitude": "177.33393000"
                    },
                    {
                        "id": 108998,
                        "name": "Niulakita",
                        "latitude": "-10.78800000",
                        "longitude": "179.46600000"
                    }
                ]
            },
            {
                "id": 3948,
                "name": "Nui",
                "iso2": "NUI",
                "latitude": "-7.23887680",
                "longitude": "177.14852320",
                "type": "island council",
                "cities": [
                    {
                        "id": 109000,
                        "name": "Tanrake Village",
                        "latitude": "-7.24562000",
                        "longitude": "177.14511000"
                    }
                ]
            },
            {
                "id": 3952,
                "name": "Nukufetau",
                "iso2": "NKF",
                "latitude": "-8.00000000",
                "longitude": "178.50000000",
                "type": "island council",
                "cities": [
                    {
                        "id": 108999,
                        "name": "Savave Village",
                        "latitude": "-8.02731000",
                        "longitude": "178.31351000"
                    }
                ]
            },
            {
                "id": 3953,
                "name": "Nukulaelae",
                "iso2": "NKL",
                "latitude": "-9.38111100",
                "longitude": "179.85222200",
                "type": "island council",
                "cities": []
            },
            {
                "id": 3950,
                "name": "Vaitupu",
                "iso2": "VAI",
                "latitude": "-7.47673270",
                "longitude": "178.67476750",
                "type": "island council",
                "cities": [
                    {
                        "id": 108994,
                        "name": "Asau Village",
                        "latitude": "-7.49026000",
                        "longitude": "178.68016000"
                    }
                ]
            }
        ]
    },
    {
        "id": 229,
        "name": "Uganda",
        "iso3": "UGA",
        "iso2": "UG",
        "numeric_code": "800",
        "phonecode": "256",
        "capital": "Kampala",
        "currency": "UGX",
        "currency_name": "Ugandan shilling",
        "currency_symbol": "USh",
        "tld": ".ug",
        "native": "Uganda",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Ugandan",
        "timezones": [
            {
                "zoneName": "Africa\/Kampala",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "br": "Ouganda",
            "ko": "우간다",
            "pt-BR": "Uganda",
            "pt": "Uganda",
            "nl": "Oeganda",
            "hr": "Uganda",
            "fa": "اوگاندا",
            "de": "Uganda",
            "es": "Uganda",
            "fr": "Uganda",
            "ja": "ウガンダ",
            "it": "Uganda",
            "zh-CN": "乌干达",
            "tr": "Uganda",
            "ru": "Уганда",
            "uk": "Уганда",
            "pl": "Uganda"
        },
        "latitude": "1.00000000",
        "longitude": "32.00000000",
        "emoji": "🇺🇬",
        "emojiU": "U+1F1FA U+1F1EC",
        "states": [
            {
                "id": 329,
                "name": "Abim",
                "iso2": "314",
                "latitude": "2.70669800",
                "longitude": "33.65953370",
                "type": "district",
                "cities": []
            },
            {
                "id": 361,
                "name": "Adjumani",
                "iso2": "301",
                "latitude": "3.25485270",
                "longitude": "31.71954590",
                "type": "district",
                "cities": []
            },
            {
                "id": 392,
                "name": "Agago",
                "iso2": "322",
                "latitude": "2.92508200",
                "longitude": "33.34861470",
                "type": "district",
                "cities": []
            },
            {
                "id": 344,
                "name": "Alebtong",
                "iso2": "323",
                "latitude": "2.25457730",
                "longitude": "33.34861470",
                "type": "district",
                "cities": []
            },
            {
                "id": 416,
                "name": "Amolatar",
                "iso2": "315",
                "latitude": "1.60544020",
                "longitude": "32.80844960",
                "type": "district",
                "cities": []
            },
            {
                "id": 353,
                "name": "Amudat",
                "iso2": "324",
                "latitude": "1.79162240",
                "longitude": "34.90655100",
                "type": "district",
                "cities": []
            },
            {
                "id": 352,
                "name": "Amuria",
                "iso2": "216",
                "latitude": "2.03017000",
                "longitude": "33.64275330",
                "type": "district",
                "cities": []
            },
            {
                "id": 335,
                "name": "Amuru",
                "iso2": "316",
                "latitude": "2.96678780",
                "longitude": "32.08374450",
                "type": "district",
                "cities": []
            },
            {
                "id": 328,
                "name": "Apac",
                "iso2": "302",
                "latitude": "1.87302630",
                "longitude": "32.62774550",
                "type": "district",
                "cities": []
            },
            {
                "id": 447,
                "name": "Arua",
                "iso2": "303",
                "latitude": "2.99598460",
                "longitude": "31.17103890",
                "type": "district",
                "cities": []
            },
            {
                "id": 441,
                "name": "Budaka",
                "iso2": "217",
                "latitude": "1.10162770",
                "longitude": "33.93039910",
                "type": "district",
                "cities": []
            },
            {
                "id": 349,
                "name": "Bududa",
                "iso2": "218",
                "latitude": "1.00296930",
                "longitude": "34.33381230",
                "type": "district",
                "cities": []
            },
            {
                "id": 387,
                "name": "Bugiri",
                "iso2": "201",
                "latitude": "0.53161270",
                "longitude": "33.75177230",
                "type": "district",
                "cities": []
            },
            {
                "id": 5350,
                "name": "Bugweri",
                "iso2": "235",
                "latitude": "0.62222290",
                "longitude": "33.44805470",
                "type": "district",
                "cities": []
            },
            {
                "id": 391,
                "name": "Buhweju",
                "iso2": "420",
                "latitude": "-0.29113590",
                "longitude": "30.29741990",
                "type": "district",
                "cities": []
            },
            {
                "id": 377,
                "name": "Buikwe",
                "iso2": "117",
                "latitude": "0.31440460",
                "longitude": "32.98883190",
                "type": "district",
                "cities": []
            },
            {
                "id": 343,
                "name": "Bukedea",
                "iso2": "219",
                "latitude": "1.35568980",
                "longitude": "34.10867930",
                "type": "district",
                "cities": []
            },
            {
                "id": 375,
                "name": "Bukomansimbi",
                "iso2": "118",
                "latitude": "-0.14327520",
                "longitude": "31.60548930",
                "type": "district",
                "cities": []
            },
            {
                "id": 385,
                "name": "Bukwo",
                "iso2": "220",
                "latitude": "1.28186510",
                "longitude": "34.72987650",
                "type": "district",
                "cities": []
            },
            {
                "id": 428,
                "name": "Bulambuli",
                "iso2": "225",
                "latitude": "1.47988460",
                "longitude": "34.37544140",
                "type": "district",
                "cities": []
            },
            {
                "id": 389,
                "name": "Buliisa",
                "iso2": "416",
                "latitude": "2.02996070",
                "longitude": "31.53700030",
                "type": "district",
                "cities": []
            },
            {
                "id": 419,
                "name": "Bundibugyo",
                "iso2": "401",
                "latitude": "0.68517630",
                "longitude": "30.02029640",
                "type": "district",
                "cities": []
            },
            {
                "id": 381,
                "name": "Bunyangabu",
                "iso2": "430",
                "latitude": "0.48709180",
                "longitude": "30.20510960",
                "type": "district",
                "cities": []
            },
            {
                "id": 386,
                "name": "Bushenyi",
                "iso2": "402",
                "latitude": "-0.48709180",
                "longitude": "30.20510960",
                "type": "district",
                "cities": []
            },
            {
                "id": 431,
                "name": "Busia",
                "iso2": "202",
                "latitude": "0.40447310",
                "longitude": "34.01958270",
                "type": "district",
                "cities": []
            },
            {
                "id": 365,
                "name": "Butaleja",
                "iso2": "221",
                "latitude": "0.84749220",
                "longitude": "33.84112880",
                "type": "district",
                "cities": []
            },
            {
                "id": 384,
                "name": "Butambala",
                "iso2": "119",
                "latitude": "0.17425000",
                "longitude": "32.10646680",
                "type": "district",
                "cities": []
            },
            {
                "id": 388,
                "name": "Butebo",
                "iso2": "233",
                "latitude": "1.21411240",
                "longitude": "33.90808960",
                "type": "district",
                "cities": []
            },
            {
                "id": 414,
                "name": "Buvuma",
                "iso2": "120",
                "latitude": "-0.37649120",
                "longitude": "33.25879300",
                "type": "district",
                "cities": []
            },
            {
                "id": 380,
                "name": "Buyende",
                "iso2": "226",
                "latitude": "1.24136820",
                "longitude": "33.12390490",
                "type": "district",
                "cities": []
            },
            {
                "id": 396,
                "name": "Central",
                "iso2": "C",
                "latitude": "44.29687500",
                "longitude": "-94.74017330",
                "type": "region",
                "cities": [
                    {
                        "id": 110880,
                        "name": "Bukomansimbi District",
                        "latitude": "-0.12855000",
                        "longitude": "31.62527000"
                    },
                    {
                        "id": 110886,
                        "name": "Buvuma District",
                        "latitude": "-0.36744000",
                        "longitude": "33.20071000"
                    },
                    {
                        "id": 110888,
                        "name": "Bweyogerere",
                        "latitude": "0.35773000",
                        "longitude": "32.66332000"
                    },
                    {
                        "id": 110890,
                        "name": "Byakabanda",
                        "latitude": "-0.74250000",
                        "longitude": "31.40639000"
                    },
                    {
                        "id": 110891,
                        "name": "Entebbe",
                        "latitude": "0.05621000",
                        "longitude": "32.47949000"
                    },
                    {
                        "id": 110893,
                        "name": "Gomba District",
                        "latitude": "0.20017000",
                        "longitude": "31.75023000"
                    },
                    {
                        "id": 110902,
                        "name": "Kajansi",
                        "latitude": "0.21548000",
                        "longitude": "32.53453000"
                    },
                    {
                        "id": 110903,
                        "name": "Kampala",
                        "latitude": "0.31628000",
                        "longitude": "32.58219000"
                    },
                    {
                        "id": 110904,
                        "name": "Kampala District",
                        "latitude": "0.33508000",
                        "longitude": "32.58313000"
                    },
                    {
                        "id": 110907,
                        "name": "Kanoni",
                        "latitude": "0.17722000",
                        "longitude": "31.88111000"
                    },
                    {
                        "id": 110911,
                        "name": "Kayunga",
                        "latitude": "0.70250000",
                        "longitude": "32.88861000"
                    },
                    {
                        "id": 110913,
                        "name": "Kiboga",
                        "latitude": "0.91611000",
                        "longitude": "31.77417000"
                    },
                    {
                        "id": 110917,
                        "name": "Kireka",
                        "latitude": "0.34750000",
                        "longitude": "32.64917000"
                    },
                    {
                        "id": 110924,
                        "name": "Kyotera",
                        "latitude": "-0.61556000",
                        "longitude": "31.51750000"
                    },
                    {
                        "id": 110926,
                        "name": "Lugazi",
                        "latitude": "0.36788000",
                        "longitude": "32.93760000"
                    },
                    {
                        "id": 110927,
                        "name": "Luwero",
                        "latitude": "0.84917000",
                        "longitude": "32.47306000"
                    },
                    {
                        "id": 110928,
                        "name": "Lyantonde",
                        "latitude": "-0.40306000",
                        "longitude": "31.15722000"
                    },
                    {
                        "id": 110930,
                        "name": "Masaka",
                        "latitude": "-0.33379000",
                        "longitude": "31.73409000"
                    },
                    {
                        "id": 110936,
                        "name": "Mityana",
                        "latitude": "0.41750000",
                        "longitude": "32.02278000"
                    },
                    {
                        "id": 110939,
                        "name": "Mpigi",
                        "latitude": "0.22500000",
                        "longitude": "32.31361000"
                    },
                    {
                        "id": 110940,
                        "name": "Mubende",
                        "latitude": "0.55849000",
                        "longitude": "31.39489000"
                    },
                    {
                        "id": 110941,
                        "name": "Mubende District",
                        "latitude": "0.50000000",
                        "longitude": "31.50000000"
                    },
                    {
                        "id": 110943,
                        "name": "Mukono",
                        "latitude": "0.35333000",
                        "longitude": "32.75528000"
                    },
                    {
                        "id": 110944,
                        "name": "Nakasongola",
                        "latitude": "1.30889000",
                        "longitude": "32.45639000"
                    },
                    {
                        "id": 110945,
                        "name": "Namasuba",
                        "latitude": "0.68944000",
                        "longitude": "32.42139000"
                    },
                    {
                        "id": 110947,
                        "name": "Njeru",
                        "latitude": "0.44166000",
                        "longitude": "33.17917000"
                    },
                    {
                        "id": 110957,
                        "name": "Sembabule",
                        "latitude": "-0.07722000",
                        "longitude": "31.45667000"
                    },
                    {
                        "id": 110961,
                        "name": "Wakiso",
                        "latitude": "0.40444000",
                        "longitude": "32.45944000"
                    },
                    {
                        "id": 110962,
                        "name": "Wakiso District",
                        "latitude": "0.23763000",
                        "longitude": "32.47836000"
                    },
                    {
                        "id": 110963,
                        "name": "Wobulenzi",
                        "latitude": "0.72833000",
                        "longitude": "32.51222000"
                    }
                ]
            },
            {
                "id": 341,
                "name": "Dokolo",
                "iso2": "317",
                "latitude": "1.96364210",
                "longitude": "33.03387670",
                "type": "district",
                "cities": []
            },
            {
                "id": 372,
                "name": "Eastern",
                "iso2": "E",
                "latitude": "6.23740360",
                "longitude": "-0.45023680",
                "type": "region",
                "cities": [
                    {
                        "id": 110878,
                        "name": "Bugembe",
                        "latitude": "0.48213000",
                        "longitude": "33.24065000"
                    },
                    {
                        "id": 110879,
                        "name": "Bugiri",
                        "latitude": "0.57139000",
                        "longitude": "33.74167000"
                    },
                    {
                        "id": 110881,
                        "name": "Bukwa District",
                        "latitude": "1.27115000",
                        "longitude": "34.66778000"
                    },
                    {
                        "id": 110882,
                        "name": "Bulambuli District",
                        "latitude": "1.32055000",
                        "longitude": "34.28062000"
                    },
                    {
                        "id": 110884,
                        "name": "Busembatia",
                        "latitude": "0.77725000",
                        "longitude": "33.62364000"
                    },
                    {
                        "id": 110885,
                        "name": "Busia",
                        "latitude": "0.46588000",
                        "longitude": "34.09221000"
                    },
                    {
                        "id": 110887,
                        "name": "Buwenge",
                        "latitude": "0.64996000",
                        "longitude": "33.17128000"
                    },
                    {
                        "id": 110898,
                        "name": "Iganga",
                        "latitude": "0.60917000",
                        "longitude": "33.46861000"
                    },
                    {
                        "id": 110899,
                        "name": "Jinja",
                        "latitude": "0.43902000",
                        "longitude": "33.20317000"
                    },
                    {
                        "id": 110905,
                        "name": "Kamuli",
                        "latitude": "0.94722000",
                        "longitude": "33.11972000"
                    },
                    {
                        "id": 110909,
                        "name": "Kapchorwa",
                        "latitude": "1.40096000",
                        "longitude": "34.45038000"
                    },
                    {
                        "id": 110914,
                        "name": "Kibuku District",
                        "latitude": "1.05000000",
                        "longitude": "33.80879000"
                    },
                    {
                        "id": 110922,
                        "name": "Kumi",
                        "latitude": "1.46083000",
                        "longitude": "33.93611000"
                    },
                    {
                        "id": 110933,
                        "name": "Mayuge",
                        "latitude": "0.45972000",
                        "longitude": "33.48028000"
                    },
                    {
                        "id": 110934,
                        "name": "Mbale",
                        "latitude": "1.08209000",
                        "longitude": "34.17503000"
                    },
                    {
                        "id": 110955,
                        "name": "Pallisa",
                        "latitude": "1.14500000",
                        "longitude": "33.70944000"
                    },
                    {
                        "id": 110958,
                        "name": "Sironko",
                        "latitude": "1.23132000",
                        "longitude": "34.24773000"
                    },
                    {
                        "id": 110959,
                        "name": "Soroti",
                        "latitude": "1.71464000",
                        "longitude": "33.61113000"
                    },
                    {
                        "id": 110960,
                        "name": "Tororo",
                        "latitude": "0.69299000",
                        "longitude": "34.18085000"
                    }
                ]
            },
            {
                "id": 366,
                "name": "Gomba",
                "iso2": "121",
                "latitude": "0.22297910",
                "longitude": "31.67393710",
                "type": "district",
                "cities": []
            },
            {
                "id": 413,
                "name": "Gulu",
                "iso2": "304",
                "latitude": "2.81857760",
                "longitude": "32.44672380",
                "type": "district",
                "cities": []
            },
            {
                "id": 5358,
                "name": "Hoima",
                "iso2": "403",
                "latitude": "1.56023430",
                "longitude": "30.52043450",
                "type": "district",
                "cities": []
            },
            {
                "id": 339,
                "name": "Ibanda",
                "iso2": "417",
                "latitude": "-0.09648900",
                "longitude": "30.57395790",
                "type": "district",
                "cities": []
            },
            {
                "id": 340,
                "name": "Iganga",
                "iso2": "203",
                "latitude": "0.66001370",
                "longitude": "33.48319060",
                "type": "district",
                "cities": []
            },
            {
                "id": 383,
                "name": "Isingiro",
                "iso2": "418",
                "latitude": "-0.84354300",
                "longitude": "30.80394740",
                "type": "district",
                "cities": []
            },
            {
                "id": 367,
                "name": "Jinja",
                "iso2": "204",
                "latitude": "0.53437430",
                "longitude": "33.30371430",
                "type": "district",
                "cities": []
            },
            {
                "id": 434,
                "name": "Kaabong",
                "iso2": "318",
                "latitude": "3.51262150",
                "longitude": "33.97500180",
                "type": "district",
                "cities": []
            },
            {
                "id": 426,
                "name": "Kabale",
                "iso2": "404",
                "latitude": "-1.24930840",
                "longitude": "30.06652360",
                "type": "district",
                "cities": []
            },
            {
                "id": 326,
                "name": "Kabarole",
                "iso2": "405",
                "latitude": "0.58507910",
                "longitude": "30.25127280",
                "type": "district",
                "cities": []
            },
            {
                "id": 336,
                "name": "Kaberamaido",
                "iso2": "213",
                "latitude": "1.69633220",
                "longitude": "33.21385100",
                "type": "district",
                "cities": []
            },
            {
                "id": 403,
                "name": "Kagadi",
                "iso2": "427",
                "latitude": "0.94007610",
                "longitude": "30.81256380",
                "type": "district",
                "cities": []
            },
            {
                "id": 399,
                "name": "Kakumiro",
                "iso2": "428",
                "latitude": "0.78080350",
                "longitude": "31.32413890",
                "type": "district",
                "cities": []
            },
            {
                "id": 5352,
                "name": "Kalaki",
                "iso2": "237",
                "latitude": "1.82956800",
                "longitude": "33.32930510",
                "type": "district",
                "cities": []
            },
            {
                "id": 405,
                "name": "Kalangala",
                "iso2": "101",
                "latitude": "-0.63505780",
                "longitude": "32.53727410",
                "type": "district",
                "cities": []
            },
            {
                "id": 398,
                "name": "Kaliro",
                "iso2": "222",
                "latitude": "1.04311070",
                "longitude": "33.48319060",
                "type": "district",
                "cities": []
            },
            {
                "id": 394,
                "name": "Kalungu",
                "iso2": "122",
                "latitude": "-0.09528310",
                "longitude": "31.76513620",
                "type": "district",
                "cities": []
            },
            {
                "id": 382,
                "name": "Kampala",
                "iso2": "102",
                "latitude": "0.34759640",
                "longitude": "32.58251970",
                "type": "city",
                "cities": []
            },
            {
                "id": 334,
                "name": "Kamuli",
                "iso2": "205",
                "latitude": "0.91871070",
                "longitude": "33.12390490",
                "type": "district",
                "cities": []
            },
            {
                "id": 360,
                "name": "Kamwenge",
                "iso2": "413",
                "latitude": "0.22579300",
                "longitude": "30.48184460",
                "type": "district",
                "cities": []
            },
            {
                "id": 373,
                "name": "Kanungu",
                "iso2": "414",
                "latitude": "-0.81952530",
                "longitude": "29.74260400",
                "type": "district",
                "cities": []
            },
            {
                "id": 432,
                "name": "Kapchorwa",
                "iso2": "206",
                "latitude": "1.33502050",
                "longitude": "34.39763560",
                "type": "district",
                "cities": []
            },
            {
                "id": 5351,
                "name": "Kapelebyong",
                "iso2": "236",
                "latitude": "2.19597360",
                "longitude": "33.37213830",
                "type": "district",
                "cities": []
            },
            {
                "id": 5355,
                "name": "Karenga",
                "iso2": "335",
                "latitude": "3.58770480",
                "longitude": "33.55711290",
                "type": "district",
                "cities": []
            },
            {
                "id": 5349,
                "name": "Kasanda",
                "iso2": "126",
                "latitude": "0.52794910",
                "longitude": "31.64774850",
                "type": "district",
                "cities": []
            },
            {
                "id": 440,
                "name": "Kasese",
                "iso2": "406",
                "latitude": "0.06462850",
                "longitude": "30.06652360",
                "type": "district",
                "cities": []
            },
            {
                "id": 420,
                "name": "Katakwi",
                "iso2": "207",
                "latitude": "1.97310300",
                "longitude": "34.06414190",
                "type": "district",
                "cities": []
            },
            {
                "id": 368,
                "name": "Kayunga",
                "iso2": "112",
                "latitude": "0.98601820",
                "longitude": "32.85357550",
                "type": "district",
                "cities": []
            },
            {
                "id": 5360,
                "name": "Kazo",
                "iso2": "433",
                "latitude": "-0.05131600",
                "longitude": "30.75170880",
                "type": "district",
                "cities": []
            },
            {
                "id": 436,
                "name": "Kibaale",
                "iso2": "407",
                "latitude": "0.90668020",
                "longitude": "31.07937050",
                "type": "district",
                "cities": []
            },
            {
                "id": 347,
                "name": "Kiboga",
                "iso2": "103",
                "latitude": "0.96575900",
                "longitude": "31.71954590",
                "type": "district",
                "cities": []
            },
            {
                "id": 338,
                "name": "Kibuku",
                "iso2": "227",
                "latitude": "1.04528740",
                "longitude": "33.79925360",
                "type": "district",
                "cities": []
            },
            {
                "id": 5359,
                "name": "Kikuube",
                "iso2": "432",
                "latitude": "1.31021900",
                "longitude": "30.32356340",
                "type": "district",
                "cities": []
            },
            {
                "id": 355,
                "name": "Kiruhura",
                "iso2": "419",
                "latitude": "-0.19279980",
                "longitude": "30.80394740",
                "type": "district",
                "cities": []
            },
            {
                "id": 346,
                "name": "Kiryandongo",
                "iso2": "421",
                "latitude": "2.01799070",
                "longitude": "32.08374450",
                "type": "district",
                "cities": []
            },
            {
                "id": 409,
                "name": "Kisoro",
                "iso2": "408",
                "latitude": "-1.22094300",
                "longitude": "29.64991620",
                "type": "district",
                "cities": []
            },
            {
                "id": 5361,
                "name": "Kitagwenda",
                "iso2": "434",
                "latitude": "0.01432970",
                "longitude": "30.18058940",
                "type": "district",
                "cities": []
            },
            {
                "id": 348,
                "name": "Kitgum",
                "iso2": "305",
                "latitude": "3.33968290",
                "longitude": "33.16888830",
                "type": "district",
                "cities": []
            },
            {
                "id": 345,
                "name": "Koboko",
                "iso2": "319",
                "latitude": "3.52370580",
                "longitude": "31.03351000",
                "type": "district",
                "cities": []
            },
            {
                "id": 401,
                "name": "Kole",
                "iso2": "325",
                "latitude": "2.37010970",
                "longitude": "32.76330360",
                "type": "district",
                "cities": []
            },
            {
                "id": 443,
                "name": "Kotido",
                "iso2": "306",
                "latitude": "3.04156790",
                "longitude": "33.88577470",
                "type": "district",
                "cities": []
            },
            {
                "id": 425,
                "name": "Kumi",
                "iso2": "208",
                "latitude": "1.48769990",
                "longitude": "33.93039910",
                "type": "district",
                "cities": []
            },
            {
                "id": 5353,
                "name": "Kwania",
                "iso2": "333",
                "latitude": "1.90119710",
                "longitude": "32.41264920",
                "type": "district",
                "cities": []
            },
            {
                "id": 369,
                "name": "Kween",
                "iso2": "228",
                "latitude": "1.44387900",
                "longitude": "34.59713200",
                "type": "district",
                "cities": []
            },
            {
                "id": 325,
                "name": "Kyankwanzi",
                "iso2": "123",
                "latitude": "1.09660370",
                "longitude": "31.71954590",
                "type": "district",
                "cities": []
            },
            {
                "id": 437,
                "name": "Kyegegwa",
                "iso2": "422",
                "latitude": "0.48181930",
                "longitude": "31.05500930",
                "type": "district",
                "cities": []
            },
            {
                "id": 402,
                "name": "Kyenjojo",
                "iso2": "415",
                "latitude": "0.60929230",
                "longitude": "30.64012310",
                "type": "district",
                "cities": []
            },
            {
                "id": 448,
                "name": "Kyotera",
                "iso2": "125",
                "latitude": "-0.63589880",
                "longitude": "31.54556370",
                "type": "district",
                "cities": []
            },
            {
                "id": 411,
                "name": "Lamwo",
                "iso2": "326",
                "latitude": "3.57075680",
                "longitude": "32.53727410",
                "type": "district",
                "cities": []
            },
            {
                "id": 342,
                "name": "Lira",
                "iso2": "307",
                "latitude": "2.23161690",
                "longitude": "32.94376670",
                "type": "district",
                "cities": []
            },
            {
                "id": 445,
                "name": "Luuka",
                "iso2": "229",
                "latitude": "0.72505990",
                "longitude": "33.30371430",
                "type": "district",
                "cities": []
            },
            {
                "id": 433,
                "name": "Luwero",
                "iso2": "104",
                "latitude": "0.82711180",
                "longitude": "32.62774550",
                "type": "district",
                "cities": []
            },
            {
                "id": 417,
                "name": "Lwengo",
                "iso2": "124",
                "latitude": "-0.41652880",
                "longitude": "31.39989950",
                "type": "district",
                "cities": []
            },
            {
                "id": 376,
                "name": "Lyantonde",
                "iso2": "114",
                "latitude": "-0.22406960",
                "longitude": "31.21684660",
                "type": "district",
                "cities": []
            },
            {
                "id": 5356,
                "name": "Madi-Okollo",
                "iso2": "336",
                "latitude": "2.86773070",
                "longitude": "30.92752690",
                "type": "district",
                "cities": []
            },
            {
                "id": 438,
                "name": "Manafwa",
                "iso2": "223",
                "latitude": "0.90635990",
                "longitude": "34.28660910",
                "type": "district",
                "cities": []
            },
            {
                "id": 421,
                "name": "Maracha",
                "iso2": "320",
                "latitude": "3.28731270",
                "longitude": "30.94030230",
                "type": "district",
                "cities": []
            },
            {
                "id": 356,
                "name": "Masaka",
                "iso2": "105",
                "latitude": "-0.44636910",
                "longitude": "31.90179540",
                "type": "district",
                "cities": []
            },
            {
                "id": 354,
                "name": "Masindi",
                "iso2": "409",
                "latitude": "1.49203630",
                "longitude": "31.71954590",
                "type": "district",
                "cities": []
            },
            {
                "id": 418,
                "name": "Mayuge",
                "iso2": "214",
                "latitude": "-0.21829820",
                "longitude": "33.57280270",
                "type": "district",
                "cities": []
            },
            {
                "id": 350,
                "name": "Mbale",
                "iso2": "209",
                "latitude": "1.03442740",
                "longitude": "34.19768820",
                "type": "district",
                "cities": []
            },
            {
                "id": 415,
                "name": "Mbarara",
                "iso2": "410",
                "latitude": "-0.60715960",
                "longitude": "30.65450220",
                "type": "district",
                "cities": []
            },
            {
                "id": 435,
                "name": "Mitooma",
                "iso2": "423",
                "latitude": "-0.61932760",
                "longitude": "30.02029640",
                "type": "district",
                "cities": []
            },
            {
                "id": 364,
                "name": "Mityana",
                "iso2": "115",
                "latitude": "0.44548450",
                "longitude": "32.08374450",
                "type": "district",
                "cities": []
            },
            {
                "id": 395,
                "name": "Moroto",
                "iso2": "308",
                "latitude": "2.61685450",
                "longitude": "34.59713200",
                "type": "district",
                "cities": []
            },
            {
                "id": 363,
                "name": "Moyo",
                "iso2": "309",
                "latitude": "3.56964640",
                "longitude": "31.67393710",
                "type": "district",
                "cities": []
            },
            {
                "id": 327,
                "name": "Mpigi",
                "iso2": "106",
                "latitude": "0.22735280",
                "longitude": "32.32492360",
                "type": "district",
                "cities": []
            },
            {
                "id": 371,
                "name": "Mubende",
                "iso2": "107",
                "latitude": "0.57727580",
                "longitude": "31.53700030",
                "type": "district",
                "cities": []
            },
            {
                "id": 410,
                "name": "Mukono",
                "iso2": "108",
                "latitude": "0.28354760",
                "longitude": "32.76330360",
                "type": "district",
                "cities": []
            },
            {
                "id": 5354,
                "name": "Nabilatuk",
                "iso2": "334",
                "latitude": "2.03870330",
                "longitude": "34.17750230",
                "type": "district",
                "cities": []
            },
            {
                "id": 393,
                "name": "Nakapiripirit",
                "iso2": "311",
                "latitude": "1.96061730",
                "longitude": "34.59713200",
                "type": "district",
                "cities": []
            },
            {
                "id": 423,
                "name": "Nakaseke",
                "iso2": "116",
                "latitude": "1.22308480",
                "longitude": "32.08374450",
                "type": "district",
                "cities": []
            },
            {
                "id": 406,
                "name": "Nakasongola",
                "iso2": "109",
                "latitude": "1.34897210",
                "longitude": "32.44672380",
                "type": "district",
                "cities": []
            },
            {
                "id": 351,
                "name": "Namayingo",
                "iso2": "230",
                "latitude": "-0.28035750",
                "longitude": "33.75177230",
                "type": "district",
                "cities": []
            },
            {
                "id": 400,
                "name": "Namisindwa",
                "iso2": "234",
                "latitude": "0.90710100",
                "longitude": "34.35740370",
                "type": "district",
                "cities": []
            },
            {
                "id": 337,
                "name": "Namutumba",
                "iso2": "224",
                "latitude": "0.84926100",
                "longitude": "33.66233010",
                "type": "district",
                "cities": []
            },
            {
                "id": 430,
                "name": "Napak",
                "iso2": "327",
                "latitude": "2.36299450",
                "longitude": "34.24215970",
                "type": "district",
                "cities": []
            },
            {
                "id": 446,
                "name": "Nebbi",
                "iso2": "310",
                "latitude": "2.44093920",
                "longitude": "31.35416310",
                "type": "district",
                "cities": []
            },
            {
                "id": 424,
                "name": "Ngora",
                "iso2": "231",
                "latitude": "1.49081150",
                "longitude": "33.75177230",
                "type": "district",
                "cities": []
            },
            {
                "id": 332,
                "name": "Northern",
                "iso2": "N",
                "latitude": "9.54392690",
                "longitude": "-0.90566230",
                "type": "region",
                "cities": [
                    {
                        "id": 110874,
                        "name": "Adjumani",
                        "latitude": "3.37786000",
                        "longitude": "31.79090000"
                    },
                    {
                        "id": 110875,
                        "name": "Amudat",
                        "latitude": "1.95000000",
                        "longitude": "34.95000000"
                    },
                    {
                        "id": 110876,
                        "name": "Apac",
                        "latitude": "1.97556000",
                        "longitude": "32.53861000"
                    },
                    {
                        "id": 110877,
                        "name": "Arua",
                        "latitude": "3.02013000",
                        "longitude": "30.91105000"
                    },
                    {
                        "id": 110894,
                        "name": "Gulu",
                        "latitude": "2.77457000",
                        "longitude": "32.29899000"
                    },
                    {
                        "id": 110920,
                        "name": "Kitgum",
                        "latitude": "3.27833000",
                        "longitude": "32.88667000"
                    },
                    {
                        "id": 110921,
                        "name": "Kotido",
                        "latitude": "2.98056000",
                        "longitude": "34.13306000"
                    },
                    {
                        "id": 110925,
                        "name": "Lira",
                        "latitude": "2.24990000",
                        "longitude": "32.89985000"
                    },
                    {
                        "id": 110937,
                        "name": "Moroto",
                        "latitude": "2.53453000",
                        "longitude": "34.66659000"
                    },
                    {
                        "id": 110938,
                        "name": "Moyo",
                        "latitude": "3.66088000",
                        "longitude": "31.72474000"
                    },
                    {
                        "id": 110946,
                        "name": "Nebbi",
                        "latitude": "2.47826000",
                        "longitude": "31.08893000"
                    },
                    {
                        "id": 110950,
                        "name": "Otuke District",
                        "latitude": "2.48372000",
                        "longitude": "33.34201000"
                    },
                    {
                        "id": 110951,
                        "name": "Oyam District",
                        "latitude": "2.38129000",
                        "longitude": "32.50071000"
                    },
                    {
                        "id": 110952,
                        "name": "Pader",
                        "latitude": "3.05000000",
                        "longitude": "33.21667000"
                    },
                    {
                        "id": 110953,
                        "name": "Pader Palwo",
                        "latitude": "2.80056000",
                        "longitude": "33.13500000"
                    },
                    {
                        "id": 110954,
                        "name": "Paidha",
                        "latitude": "2.41669000",
                        "longitude": "30.98551000"
                    },
                    {
                        "id": 110964,
                        "name": "Yumbe",
                        "latitude": "3.46506000",
                        "longitude": "31.24689000"
                    }
                ]
            },
            {
                "id": 422,
                "name": "Ntoroko",
                "iso2": "424",
                "latitude": "1.07881780",
                "longitude": "30.38966510",
                "type": "district",
                "cities": []
            },
            {
                "id": 404,
                "name": "Ntungamo",
                "iso2": "411",
                "latitude": "-0.98073410",
                "longitude": "30.25127280",
                "type": "district",
                "cities": []
            },
            {
                "id": 378,
                "name": "Nwoya",
                "iso2": "328",
                "latitude": "2.56244400",
                "longitude": "31.90179540",
                "type": "district",
                "cities": []
            },
            {
                "id": 5357,
                "name": "Obongi",
                "iso2": "337",
                "latitude": "3.36393610",
                "longitude": "31.43316460",
                "type": "district",
                "cities": []
            },
            {
                "id": 374,
                "name": "Omoro",
                "iso2": "331",
                "latitude": "2.71522300",
                "longitude": "32.49200880",
                "type": "district",
                "cities": []
            },
            {
                "id": 390,
                "name": "Otuke",
                "iso2": "329",
                "latitude": "2.52140590",
                "longitude": "33.34861470",
                "type": "district",
                "cities": []
            },
            {
                "id": 397,
                "name": "Oyam",
                "iso2": "321",
                "latitude": "2.27762810",
                "longitude": "32.44672380",
                "type": "district",
                "cities": []
            },
            {
                "id": 408,
                "name": "Pader",
                "iso2": "312",
                "latitude": "2.94306820",
                "longitude": "32.80844960",
                "type": "district",
                "cities": []
            },
            {
                "id": 357,
                "name": "Pakwach",
                "iso2": "332",
                "latitude": "2.46071410",
                "longitude": "31.49417380",
                "type": "district",
                "cities": []
            },
            {
                "id": 412,
                "name": "Pallisa",
                "iso2": "210",
                "latitude": "1.23242060",
                "longitude": "33.75177230",
                "type": "district",
                "cities": []
            },
            {
                "id": 439,
                "name": "Rakai",
                "iso2": "110",
                "latitude": "-0.70691350",
                "longitude": "31.53700030",
                "type": "district",
                "cities": []
            },
            {
                "id": 358,
                "name": "Rubanda",
                "iso2": "429",
                "latitude": "-1.18611900",
                "longitude": "29.84535760",
                "type": "district",
                "cities": []
            },
            {
                "id": 442,
                "name": "Rubirizi",
                "iso2": "425",
                "latitude": "-0.26424100",
                "longitude": "30.10840330",
                "type": "district",
                "cities": []
            },
            {
                "id": 331,
                "name": "Rukiga",
                "iso2": "431",
                "latitude": "-1.13263370",
                "longitude": "30.04341200",
                "type": "district",
                "cities": []
            },
            {
                "id": 324,
                "name": "Rukungiri",
                "iso2": "412",
                "latitude": "-0.75184900",
                "longitude": "29.92779470",
                "type": "district",
                "cities": []
            },
            {
                "id": 5362,
                "name": "Rwampara",
                "iso2": "435",
                "latitude": "-0.73456010",
                "longitude": "30.32019320",
                "type": "district",
                "cities": []
            },
            {
                "id": 427,
                "name": "Sembabule",
                "iso2": "111",
                "latitude": "0.06377150",
                "longitude": "31.35416310",
                "type": "district",
                "cities": []
            },
            {
                "id": 333,
                "name": "Serere",
                "iso2": "232",
                "latitude": "1.49940330",
                "longitude": "33.54900780",
                "type": "district",
                "cities": []
            },
            {
                "id": 407,
                "name": "Sheema",
                "iso2": "426",
                "latitude": "-0.55152980",
                "longitude": "30.38966510",
                "type": "district",
                "cities": []
            },
            {
                "id": 429,
                "name": "Sironko",
                "iso2": "215",
                "latitude": "1.23022740",
                "longitude": "34.24910640",
                "type": "district",
                "cities": []
            },
            {
                "id": 444,
                "name": "Soroti",
                "iso2": "211",
                "latitude": "1.72291170",
                "longitude": "33.52800720",
                "type": "district",
                "cities": []
            },
            {
                "id": 359,
                "name": "Tororo",
                "iso2": "212",
                "latitude": "0.68709940",
                "longitude": "34.06414190",
                "type": "district",
                "cities": []
            },
            {
                "id": 362,
                "name": "Wakiso",
                "iso2": "113",
                "latitude": "0.06301900",
                "longitude": "32.44672380",
                "type": "district",
                "cities": []
            },
            {
                "id": 370,
                "name": "Western",
                "iso2": "W",
                "latitude": "40.76672150",
                "longitude": "-111.88772030",
                "type": "region",
                "cities": [
                    {
                        "id": 110883,
                        "name": "Bundibugyo",
                        "latitude": "0.71117000",
                        "longitude": "30.06469000"
                    },
                    {
                        "id": 110889,
                        "name": "Bwizibwera",
                        "latitude": "-0.59167000",
                        "longitude": "30.62861000"
                    },
                    {
                        "id": 110892,
                        "name": "Fort Portal",
                        "latitude": "0.66174000",
                        "longitude": "30.27480000"
                    },
                    {
                        "id": 110895,
                        "name": "Hoima",
                        "latitude": "1.43314000",
                        "longitude": "31.35241000"
                    },
                    {
                        "id": 110896,
                        "name": "Ibanda",
                        "latitude": "-0.13398000",
                        "longitude": "30.49616000"
                    },
                    {
                        "id": 110897,
                        "name": "Ibanda District",
                        "latitude": "-0.08100000",
                        "longitude": "30.55600000"
                    },
                    {
                        "id": 110900,
                        "name": "Kabale",
                        "latitude": "-1.24857000",
                        "longitude": "29.98993000"
                    },
                    {
                        "id": 110901,
                        "name": "Kagadi",
                        "latitude": "0.93778000",
                        "longitude": "30.80889000"
                    },
                    {
                        "id": 110906,
                        "name": "Kamwenge",
                        "latitude": "0.18660000",
                        "longitude": "30.45393000"
                    },
                    {
                        "id": 110908,
                        "name": "Kanungu",
                        "latitude": "-0.95750000",
                        "longitude": "29.78972000"
                    },
                    {
                        "id": 110910,
                        "name": "Kasese",
                        "latitude": "0.18333000",
                        "longitude": "30.08333000"
                    },
                    {
                        "id": 110912,
                        "name": "Kibale",
                        "latitude": "0.80000000",
                        "longitude": "31.06667000"
                    },
                    {
                        "id": 110915,
                        "name": "Kigorobya",
                        "latitude": "1.61620000",
                        "longitude": "31.30890000"
                    },
                    {
                        "id": 110916,
                        "name": "Kilembe",
                        "latitude": "0.19835000",
                        "longitude": "30.01302000"
                    },
                    {
                        "id": 110918,
                        "name": "Kiruhura",
                        "latitude": "-0.19664000",
                        "longitude": "30.84446000"
                    },
                    {
                        "id": 110919,
                        "name": "Kisoro",
                        "latitude": "-1.28538000",
                        "longitude": "29.68497000"
                    },
                    {
                        "id": 110923,
                        "name": "Kyenjojo",
                        "latitude": "0.63278000",
                        "longitude": "30.62139000"
                    },
                    {
                        "id": 110929,
                        "name": "Margherita",
                        "latitude": "0.41861000",
                        "longitude": "29.89111000"
                    },
                    {
                        "id": 110931,
                        "name": "Masindi",
                        "latitude": "1.67444000",
                        "longitude": "31.71500000"
                    },
                    {
                        "id": 110932,
                        "name": "Masindi Port",
                        "latitude": "1.69606000",
                        "longitude": "32.08608000"
                    },
                    {
                        "id": 110935,
                        "name": "Mbarara",
                        "latitude": "-0.60467000",
                        "longitude": "30.64851000"
                    },
                    {
                        "id": 110942,
                        "name": "Muhororo",
                        "latitude": "0.93806000",
                        "longitude": "30.75944000"
                    },
                    {
                        "id": 110948,
                        "name": "Ntungamo",
                        "latitude": "-0.87944000",
                        "longitude": "30.26417000"
                    },
                    {
                        "id": 110949,
                        "name": "Nyachera",
                        "latitude": "-0.90000000",
                        "longitude": "30.41667000"
                    },
                    {
                        "id": 110956,
                        "name": "Rukungiri",
                        "latitude": "-0.84111000",
                        "longitude": "29.94194000"
                    }
                ]
            },
            {
                "id": 330,
                "name": "Yumbe",
                "iso2": "313",
                "latitude": "3.46980230",
                "longitude": "31.24832910",
                "type": "district",
                "cities": []
            },
            {
                "id": 379,
                "name": "Zombo",
                "iso2": "330",
                "latitude": "2.55442930",
                "longitude": "30.94173680",
                "type": "district",
                "cities": []
            }
        ]
    },
    {
        "id": 230,
        "name": "Ukraine",
        "iso3": "UKR",
        "iso2": "UA",
        "numeric_code": "804",
        "phonecode": "380",
        "capital": "Kyiv",
        "currency": "UAH",
        "currency_name": "Ukrainian hryvnia",
        "currency_symbol": "₴",
        "tld": ".ua",
        "native": "Україна",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Eastern Europe",
        "subregion_id": 15,
        "nationality": "Ukrainian",
        "timezones": [
            {
                "zoneName": "Europe\/Kiev",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            },
            {
                "zoneName": "Europe\/Simferopol",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "MSK",
                "tzName": "Moscow Time"
            },
            {
                "zoneName": "Europe\/Uzhgorod",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            },
            {
                "zoneName": "Europe\/Zaporozhye",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "br": "Ukraina",
            "ko": "우크라이나",
            "pt-BR": "Ucrânia",
            "pt": "Ucrânia",
            "nl": "Oekraïne",
            "hr": "Ukrajina",
            "fa": "وکراین",
            "de": "Ukraine",
            "es": "Ucrania",
            "fr": "Ukraine",
            "ja": "ウクライナ",
            "it": "Ucraina",
            "zh-CN": "乌克兰",
            "tr": "Ukrayna",
            "ru": "Украина",
            "uk": "Україна",
            "pl": "Ukraina"
        },
        "latitude": "49.00000000",
        "longitude": "32.00000000",
        "emoji": "🇺🇦",
        "emojiU": "U+1F1FA U+1F1E6",
        "states": [
            {
                "id": 4689,
                "name": "Autonomous Republic of Crimea",
                "iso2": "43",
                "latitude": "44.95211700",
                "longitude": "34.10241700",
                "type": "republic",
                "cities": [
                    {
                        "id": 109305,
                        "name": "Abrikosovka",
                        "latitude": "45.10759000",
                        "longitude": "35.10139000"
                    },
                    {
                        "id": 109306,
                        "name": "Abrikosovo",
                        "latitude": "45.69236000",
                        "longitude": "34.10156000"
                    },
                    {
                        "id": 109308,
                        "name": "Aeroflotskiy",
                        "latitude": "45.01816000",
                        "longitude": "33.99961000"
                    },
                    {
                        "id": 109309,
                        "name": "Agrarnoye",
                        "latitude": "45.01596000",
                        "longitude": "34.05725000"
                    },
                    {
                        "id": 109310,
                        "name": "Akimovka",
                        "latitude": "45.51981000",
                        "longitude": "34.82438000"
                    },
                    {
                        "id": 109313,
                        "name": "Aleksandrovka",
                        "latitude": "45.57654000",
                        "longitude": "34.09947000"
                    },
                    {
                        "id": 109314,
                        "name": "Alekseyevka",
                        "latitude": "45.58194000",
                        "longitude": "33.62980000"
                    },
                    {
                        "id": 109315,
                        "name": "Alupka",
                        "latitude": "44.41808000",
                        "longitude": "34.04531000"
                    },
                    {
                        "id": 109316,
                        "name": "Alushta",
                        "latitude": "44.67728000",
                        "longitude": "34.40970000"
                    },
                    {
                        "id": 109317,
                        "name": "Amurskoye",
                        "latitude": "45.27822000",
                        "longitude": "34.12823000"
                    },
                    {
                        "id": 109327,
                        "name": "Armyansk",
                        "latitude": "46.10919000",
                        "longitude": "33.69206000"
                    },
                    {
                        "id": 109328,
                        "name": "Aromatnoye",
                        "latitude": "45.03678000",
                        "longitude": "34.39921000"
                    },
                    {
                        "id": 109336,
                        "name": "Azovskoye",
                        "latitude": "45.58604000",
                        "longitude": "34.56680000"
                    },
                    {
                        "id": 109338,
                        "name": "Baherove",
                        "latitude": "45.37417000",
                        "longitude": "36.29705000"
                    },
                    {
                        "id": 109339,
                        "name": "Bakhchysarai",
                        "latitude": "44.75525000",
                        "longitude": "33.85782000"
                    },
                    {
                        "id": 109340,
                        "name": "Bakhchysarai Raion",
                        "latitude": "44.75002000",
                        "longitude": "33.86330000"
                    },
                    {
                        "id": 109356,
                        "name": "Batal’noye",
                        "latitude": "45.19402000",
                        "longitude": "35.61583000"
                    },
                    {
                        "id": 109363,
                        "name": "Belinskoye",
                        "latitude": "45.37465000",
                        "longitude": "36.08212000"
                    },
                    {
                        "id": 109364,
                        "name": "Beloglinka",
                        "latitude": "44.99490000",
                        "longitude": "34.04167000"
                    },
                    {
                        "id": 109365,
                        "name": "Belogorskiy rayon",
                        "latitude": "45.06300000",
                        "longitude": "34.55675000"
                    },
                    {
                        "id": 109372,
                        "name": "Beregovoye",
                        "latitude": "45.09470000",
                        "longitude": "35.43385000"
                    },
                    {
                        "id": 109384,
                        "name": "Berezovka",
                        "latitude": "45.57471000",
                        "longitude": "33.34397000"
                    },
                    {
                        "id": 109399,
                        "name": "Bilohirsk",
                        "latitude": "45.05462000",
                        "longitude": "34.60185000"
                    },
                    {
                        "id": 109412,
                        "name": "Blizhneye",
                        "latitude": "45.05694000",
                        "longitude": "35.33056000"
                    },
                    {
                        "id": 109417,
                        "name": "Bogatoye",
                        "latitude": "45.02933000",
                        "longitude": "34.76732000"
                    },
                    {
                        "id": 109438,
                        "name": "Botanicheskoye",
                        "latitude": "45.78656000",
                        "longitude": "33.54856000"
                    },
                    {
                        "id": 109444,
                        "name": "Bratskoye",
                        "latitude": "45.83170000",
                        "longitude": "33.92151000"
                    },
                    {
                        "id": 109470,
                        "name": "Chapayevka",
                        "latitude": "45.28119000",
                        "longitude": "34.89428000"
                    },
                    {
                        "id": 109474,
                        "name": "Chaykino",
                        "latitude": "45.08223000",
                        "longitude": "34.08673000"
                    },
                    {
                        "id": 109476,
                        "name": "Chelyadinovo",
                        "latitude": "45.20729000",
                        "longitude": "36.37620000"
                    },
                    {
                        "id": 109489,
                        "name": "Chernomorskiy rayon",
                        "latitude": "45.48798000",
                        "longitude": "32.92614000"
                    },
                    {
                        "id": 109490,
                        "name": "Chernomorskoye",
                        "latitude": "45.50657000",
                        "longitude": "32.69776000"
                    },
                    {
                        "id": 109491,
                        "name": "Chernopolye",
                        "latitude": "45.04399000",
                        "longitude": "34.63916000"
                    },
                    {
                        "id": 109492,
                        "name": "Chernovo",
                        "latitude": "45.50833000",
                        "longitude": "33.93397000"
                    },
                    {
                        "id": 109493,
                        "name": "Chernozemnoye",
                        "latitude": "45.40808000",
                        "longitude": "34.81990000"
                    },
                    {
                        "id": 109497,
                        "name": "Chernyshevo",
                        "latitude": "45.78202000",
                        "longitude": "33.42825000"
                    },
                    {
                        "id": 109503,
                        "name": "Chervonoye",
                        "latitude": "45.12294000",
                        "longitude": "33.68662000"
                    },
                    {
                        "id": 109505,
                        "name": "Chisten’koye",
                        "latitude": "44.88152000",
                        "longitude": "34.04716000"
                    },
                    {
                        "id": 109506,
                        "name": "Chistopolye",
                        "latitude": "45.36541000",
                        "longitude": "36.18312000"
                    },
                    {
                        "id": 109507,
                        "name": "Chkalovo",
                        "latitude": "45.60474000",
                        "longitude": "34.83395000"
                    },
                    {
                        "id": 109527,
                        "name": "Dachnoye",
                        "latitude": "44.88448000",
                        "longitude": "34.98333000"
                    },
                    {
                        "id": 109528,
                        "name": "Dalekoye",
                        "latitude": "45.66006000",
                        "longitude": "33.08059000"
                    },
                    {
                        "id": 109543,
                        "name": "Dmitrovka",
                        "latitude": "45.48411000",
                        "longitude": "35.05880000"
                    },
                    {
                        "id": 109547,
                        "name": "Dneprovka",
                        "latitude": "45.71373000",
                        "longitude": "34.36256000"
                    },
                    {
                        "id": 109560,
                        "name": "Dobroye",
                        "latitude": "44.86632000",
                        "longitude": "34.22661000"
                    },
                    {
                        "id": 109561,
                        "name": "Dobrushino",
                        "latitude": "45.37441000",
                        "longitude": "33.36547000"
                    },
                    {
                        "id": 109564,
                        "name": "Dolinnoye",
                        "latitude": "44.75320000",
                        "longitude": "33.77766000"
                    },
                    {
                        "id": 109571,
                        "name": "Donskoye",
                        "latitude": "45.04509000",
                        "longitude": "34.21413000"
                    },
                    {
                        "id": 109577,
                        "name": "Drofino",
                        "latitude": "45.28629000",
                        "longitude": "34.61589000"
                    },
                    {
                        "id": 109582,
                        "name": "Dubki",
                        "latitude": "44.93581000",
                        "longitude": "34.02355000"
                    },
                    {
                        "id": 109592,
                        "name": "Dzhankoy",
                        "latitude": "45.71168000",
                        "longitude": "34.39274000"
                    },
                    {
                        "id": 109593,
                        "name": "Dzhankoyskiy rayon",
                        "latitude": "45.78706000",
                        "longitude": "34.39197000"
                    },
                    {
                        "id": 109599,
                        "name": "Feodosiya",
                        "latitude": "45.03677000",
                        "longitude": "35.37789000"
                    },
                    {
                        "id": 109600,
                        "name": "Filatovka",
                        "latitude": "46.08192000",
                        "longitude": "33.78510000"
                    },
                    {
                        "id": 109602,
                        "name": "Fontany",
                        "latitude": "44.89717000",
                        "longitude": "34.07297000"
                    },
                    {
                        "id": 109603,
                        "name": "Foros",
                        "latitude": "44.39214000",
                        "longitude": "33.78798000"
                    },
                    {
                        "id": 109604,
                        "name": "Frunze",
                        "latitude": "45.02688000",
                        "longitude": "33.62956000"
                    },
                    {
                        "id": 109605,
                        "name": "Gaspra",
                        "latitude": "44.43364000",
                        "longitude": "34.10297000"
                    },
                    {
                        "id": 109606,
                        "name": "Geroyskoye",
                        "latitude": "45.13857000",
                        "longitude": "33.74675000"
                    },
                    {
                        "id": 109607,
                        "name": "Glazovka",
                        "latitude": "45.38792000",
                        "longitude": "36.57965000"
                    },
                    {
                        "id": 109608,
                        "name": "Golubinka",
                        "latitude": "44.59382000",
                        "longitude": "33.91521000"
                    },
                    {
                        "id": 109609,
                        "name": "Gornostayevka",
                        "latitude": "45.27819000",
                        "longitude": "36.18601000"
                    },
                    {
                        "id": 109610,
                        "name": "Gorodskoy okrug Alushta",
                        "latitude": "44.67256000",
                        "longitude": "34.41467000"
                    },
                    {
                        "id": 109611,
                        "name": "Gorodskoy okrug Armyansk",
                        "latitude": "46.10871000",
                        "longitude": "33.69095000"
                    },
                    {
                        "id": 109612,
                        "name": "Gorodskoy okrug Dzhankoy",
                        "latitude": "45.70810000",
                        "longitude": "34.39407000"
                    },
                    {
                        "id": 109613,
                        "name": "Gorodskoy okrug Feodosiya",
                        "latitude": "45.04612000",
                        "longitude": "35.37289000"
                    },
                    {
                        "id": 109614,
                        "name": "Gorodskoy okrug Krasnoperekopsk",
                        "latitude": "45.95330000",
                        "longitude": "33.79669000"
                    },
                    {
                        "id": 109615,
                        "name": "Gorodskoy okrug Saki",
                        "latitude": "45.12780000",
                        "longitude": "33.60134000"
                    },
                    {
                        "id": 109616,
                        "name": "Gorodskoy okrug Simferopol",
                        "latitude": "44.94803000",
                        "longitude": "34.10912000"
                    },
                    {
                        "id": 109617,
                        "name": "Gorodskoy okrug Sudak",
                        "latitude": "44.91667000",
                        "longitude": "35.00202000"
                    },
                    {
                        "id": 109618,
                        "name": "Gorodskoy okrug Yalta",
                        "latitude": "44.49638000",
                        "longitude": "34.16336000"
                    },
                    {
                        "id": 109619,
                        "name": "Gorodskoy okrug Yevpatoriya",
                        "latitude": "45.19559000",
                        "longitude": "33.36342000"
                    },
                    {
                        "id": 109620,
                        "name": "Gresovskiy",
                        "latitude": "45.00804000",
                        "longitude": "34.02657000"
                    },
                    {
                        "id": 109621,
                        "name": "Grishino",
                        "latitude": "45.64219000",
                        "longitude": "33.83098000"
                    },
                    {
                        "id": 109622,
                        "name": "Grushevka",
                        "latitude": "45.02281000",
                        "longitude": "34.97301000"
                    },
                    {
                        "id": 109623,
                        "name": "Gurzuf",
                        "latitude": "44.54624000",
                        "longitude": "34.27841000"
                    },
                    {
                        "id": 109664,
                        "name": "Hvardiiske",
                        "latitude": "45.11692000",
                        "longitude": "34.02188000"
                    },
                    {
                        "id": 109669,
                        "name": "Ilychyovo",
                        "latitude": "45.28348000",
                        "longitude": "35.73864000"
                    },
                    {
                        "id": 109670,
                        "name": "Ilyichevo",
                        "latitude": "45.24524000",
                        "longitude": "35.07127000"
                    },
                    {
                        "id": 109671,
                        "name": "Ilyinka",
                        "latitude": "45.81784000",
                        "longitude": "33.79482000"
                    },
                    {
                        "id": 109676,
                        "name": "Ishun’",
                        "latitude": "45.92403000",
                        "longitude": "33.82364000"
                    },
                    {
                        "id": 109685,
                        "name": "Ivanovka",
                        "latitude": "45.07200000",
                        "longitude": "33.66130000"
                    },
                    {
                        "id": 109688,
                        "name": "Izobil’noye",
                        "latitude": "44.70276000",
                        "longitude": "34.35357000"
                    },
                    {
                        "id": 109689,
                        "name": "Izumrudnoye",
                        "latitude": "45.73704000",
                        "longitude": "34.41299000"
                    },
                    {
                        "id": 109692,
                        "name": "Izyumovka",
                        "latitude": "45.04437000",
                        "longitude": "35.13717000"
                    },
                    {
                        "id": 109700,
                        "name": "Kalinino",
                        "latitude": "45.59521000",
                        "longitude": "34.22030000"
                    },
                    {
                        "id": 109701,
                        "name": "Kalinovka",
                        "latitude": "45.31658000",
                        "longitude": "35.74643000"
                    },
                    {
                        "id": 109707,
                        "name": "Kamenolomnya",
                        "latitude": "45.24804000",
                        "longitude": "33.41773000"
                    },
                    {
                        "id": 109718,
                        "name": "Kashtanovoye",
                        "latitude": "44.83210000",
                        "longitude": "34.05912000"
                    },
                    {
                        "id": 109719,
                        "name": "Kashtany",
                        "latitude": "44.86760000",
                        "longitude": "33.78995000"
                    },
                    {
                        "id": 109725,
                        "name": "Kerch",
                        "latitude": "45.35310000",
                        "longitude": "36.47429000"
                    },
                    {
                        "id": 109726,
                        "name": "Kerchens'ka Mis'ka Rada",
                        "latitude": "45.35307000",
                        "longitude": "36.47414000"
                    },
                    {
                        "id": 109734,
                        "name": "Kholmovka",
                        "latitude": "44.65830000",
                        "longitude": "33.75456000"
                    },
                    {
                        "id": 109750,
                        "name": "Kirovo",
                        "latitude": "45.22106000",
                        "longitude": "35.84227000"
                    },
                    {
                        "id": 109752,
                        "name": "Kirovske Raion",
                        "latitude": "45.15522000",
                        "longitude": "35.17696000"
                    },
                    {
                        "id": 109753,
                        "name": "Kirovskoye",
                        "latitude": "45.22967000",
                        "longitude": "35.19987000"
                    },
                    {
                        "id": 109761,
                        "name": "Klepinino",
                        "latitude": "45.52800000",
                        "longitude": "34.18315000"
                    },
                    {
                        "id": 109771,
                        "name": "Koktebel",
                        "latitude": "44.96155000",
                        "longitude": "35.24660000"
                    },
                    {
                        "id": 109780,
                        "name": "Kol’chugino",
                        "latitude": "44.94367000",
                        "longitude": "33.78865000"
                    },
                    {
                        "id": 109781,
                        "name": "Kol’tsovo",
                        "latitude": "45.32807000",
                        "longitude": "33.44992000"
                    },
                    {
                        "id": 109774,
                        "name": "Kolodeznoye",
                        "latitude": "45.22682000",
                        "longitude": "34.33698000"
                    },
                    {
                        "id": 109779,
                        "name": "Koloski",
                        "latitude": "45.26936000",
                        "longitude": "33.29386000"
                    },
                    {
                        "id": 109784,
                        "name": "Komsomol’skoye",
                        "latitude": "45.01900000",
                        "longitude": "34.03049000"
                    },
                    {
                        "id": 109788,
                        "name": "Kondratyevo",
                        "latitude": "45.63125000",
                        "longitude": "34.47387000"
                    },
                    {
                        "id": 109790,
                        "name": "Konstantinovka",
                        "latitude": "44.85511000",
                        "longitude": "34.12069000"
                    },
                    {
                        "id": 109794,
                        "name": "Koreiz",
                        "latitude": "44.43374000",
                        "longitude": "34.08516000"
                    },
                    {
                        "id": 109796,
                        "name": "Kormovoye",
                        "latitude": "45.50001000",
                        "longitude": "33.61192000"
                    },
                    {
                        "id": 109812,
                        "name": "Kostochkovka",
                        "latitude": "45.31747000",
                        "longitude": "34.67418000"
                    },
                    {
                        "id": 109818,
                        "name": "Kotel’nikovo",
                        "latitude": "45.36584000",
                        "longitude": "34.02575000"
                    },
                    {
                        "id": 109822,
                        "name": "Kovyl’noye",
                        "latitude": "45.69028000",
                        "longitude": "33.52775000"
                    },
                    {
                        "id": 109830,
                        "name": "Krasna Zor'ka",
                        "latitude": "45.13432000",
                        "longitude": "34.04015000"
                    },
                    {
                        "id": 109831,
                        "name": "Krasnaya Polyana",
                        "latitude": "45.48241000",
                        "longitude": "32.93790000"
                    },
                    {
                        "id": 109834,
                        "name": "Krasnoarmeyskoye",
                        "latitude": "45.99103000",
                        "longitude": "34.03037000"
                    },
                    {
                        "id": 109835,
                        "name": "Krasnoflotskoye",
                        "latitude": "45.31572000",
                        "longitude": "34.94756000"
                    },
                    {
                        "id": 109836,
                        "name": "Krasnogorka",
                        "latitude": "45.24513000",
                        "longitude": "35.80739000"
                    },
                    {
                        "id": 109837,
                        "name": "Krasnogvardeyskoye",
                        "latitude": "45.50271000",
                        "longitude": "34.30134000"
                    },
                    {
                        "id": 109839,
                        "name": "Krasnohvardiiske Raion",
                        "latitude": "45.40230000",
                        "longitude": "34.25464000"
                    },
                    {
                        "id": 109840,
                        "name": "Krasnokamenka",
                        "latitude": "44.56383000",
                        "longitude": "34.28877000"
                    },
                    {
                        "id": 109842,
                        "name": "Krasnolesye",
                        "latitude": "44.83259000",
                        "longitude": "34.23086000"
                    },
                    {
                        "id": 109845,
                        "name": "Krasnoperekops’k",
                        "latitude": "45.95716000",
                        "longitude": "33.79650000"
                    },
                    {
                        "id": 109844,
                        "name": "Krasnoperekopsk Raion",
                        "latitude": "45.96992000",
                        "longitude": "33.87990000"
                    },
                    {
                        "id": 109849,
                        "name": "Krasnoyarskoye",
                        "latitude": "45.50661000",
                        "longitude": "33.26641000"
                    },
                    {
                        "id": 109850,
                        "name": "Krasnoye",
                        "latitude": "45.13999000",
                        "longitude": "34.09452000"
                    },
                    {
                        "id": 109851,
                        "name": "Krasnoznamenka",
                        "latitude": "45.28676000",
                        "longitude": "34.00036000"
                    },
                    {
                        "id": 109852,
                        "name": "Krasnyi Mak",
                        "latitude": "44.64218000",
                        "longitude": "33.78130000"
                    },
                    {
                        "id": 109857,
                        "name": "Krayneye",
                        "latitude": "45.22993000",
                        "longitude": "33.83239000"
                    },
                    {
                        "id": 109861,
                        "name": "Krest’yanovka",
                        "latitude": "45.72268000",
                        "longitude": "33.93938000"
                    },
                    {
                        "id": 109863,
                        "name": "Krinichnoye",
                        "latitude": "45.02428000",
                        "longitude": "34.61202000"
                    },
                    {
                        "id": 109869,
                        "name": "Krymka",
                        "latitude": "45.70453000",
                        "longitude": "34.18782000"
                    },
                    {
                        "id": 109870,
                        "name": "Krymskaya Roza",
                        "latitude": "45.05776000",
                        "longitude": "34.35631000"
                    },
                    {
                        "id": 109871,
                        "name": "Krymskoye",
                        "latitude": "45.18836000",
                        "longitude": "33.80106000"
                    },
                    {
                        "id": 109881,
                        "name": "Kuibyshevo",
                        "latitude": "44.62900000",
                        "longitude": "33.86895000"
                    },
                    {
                        "id": 109882,
                        "name": "Kukushkino",
                        "latitude": "45.71924000",
                        "longitude": "33.39030000"
                    },
                    {
                        "id": 109890,
                        "name": "Kurskoye",
                        "latitude": "45.02908000",
                        "longitude": "34.93623000"
                    },
                    {
                        "id": 109968,
                        "name": "L’govskoye",
                        "latitude": "45.09801000",
                        "longitude": "34.95770000"
                    },
                    {
                        "id": 109910,
                        "name": "Lekarstvennoye",
                        "latitude": "44.94194000",
                        "longitude": "33.82229000"
                    },
                    {
                        "id": 109912,
                        "name": "Lenine Raion",
                        "latitude": "45.24693000",
                        "longitude": "36.00540000"
                    },
                    {
                        "id": 109913,
                        "name": "Lenino",
                        "latitude": "45.29857000",
                        "longitude": "35.77708000"
                    },
                    {
                        "id": 109914,
                        "name": "Leninskoye",
                        "latitude": "45.26844000",
                        "longitude": "34.05023000"
                    },
                    {
                        "id": 109915,
                        "name": "Lesnovka",
                        "latitude": "45.15350000",
                        "longitude": "33.61889000"
                    },
                    {
                        "id": 109917,
                        "name": "Levadki",
                        "latitude": "44.87083000",
                        "longitude": "34.04278000"
                    },
                    {
                        "id": 109919,
                        "name": "Listvennoye",
                        "latitude": "45.48086000",
                        "longitude": "34.81087000"
                    },
                    {
                        "id": 109920,
                        "name": "Litvinenkovo",
                        "latitude": "45.08648000",
                        "longitude": "34.31107000"
                    },
                    {
                        "id": 109926,
                        "name": "Livadia",
                        "latitude": "44.47021000",
                        "longitude": "34.14272000"
                    },
                    {
                        "id": 109927,
                        "name": "Lobanovo",
                        "latitude": "45.77552000",
                        "longitude": "34.24236000"
                    },
                    {
                        "id": 109933,
                        "name": "Lozovoye",
                        "latitude": "44.90600000",
                        "longitude": "34.16414000"
                    },
                    {
                        "id": 109935,
                        "name": "Luchistoye",
                        "latitude": "44.73646000",
                        "longitude": "34.40063000"
                    },
                    {
                        "id": 109936,
                        "name": "Luganskoye",
                        "latitude": "45.80190000",
                        "longitude": "34.23786000"
                    },
                    {
                        "id": 109937,
                        "name": "Lugovoye",
                        "latitude": "45.23469000",
                        "longitude": "35.72202000"
                    },
                    {
                        "id": 109969,
                        "name": "Magazinka",
                        "latitude": "45.86312000",
                        "longitude": "34.04969000"
                    },
                    {
                        "id": 109982,
                        "name": "Malen’koye",
                        "latitude": "45.07585000",
                        "longitude": "33.99942000"
                    },
                    {
                        "id": 109985,
                        "name": "Malorechenskoye",
                        "latitude": "44.75888000",
                        "longitude": "34.55789000"
                    },
                    {
                        "id": 109987,
                        "name": "Maly Mayak",
                        "latitude": "44.61356000",
                        "longitude": "34.36469000"
                    },
                    {
                        "id": 110005,
                        "name": "Mar’yanovka",
                        "latitude": "45.44627000",
                        "longitude": "34.29474000"
                    },
                    {
                        "id": 109998,
                        "name": "Marfovka",
                        "latitude": "45.19853000",
                        "longitude": "36.09144000"
                    },
                    {
                        "id": 110004,
                        "name": "Maryevka",
                        "latitude": "45.11330000",
                        "longitude": "36.23992000"
                    },
                    {
                        "id": 110006,
                        "name": "Maslovo",
                        "latitude": "45.79197000",
                        "longitude": "34.36298000"
                    },
                    {
                        "id": 110007,
                        "name": "Massandra",
                        "latitude": "44.50958000",
                        "longitude": "34.18817000"
                    },
                    {
                        "id": 110010,
                        "name": "Mayskoye",
                        "latitude": "45.59555000",
                        "longitude": "34.55213000"
                    },
                    {
                        "id": 110011,
                        "name": "Mazanka",
                        "latitude": "45.00550000",
                        "longitude": "34.25581000"
                    },
                    {
                        "id": 110013,
                        "name": "Medvedevka",
                        "latitude": "45.88389000",
                        "longitude": "34.55562000"
                    },
                    {
                        "id": 110014,
                        "name": "Medvedevo",
                        "latitude": "45.38597000",
                        "longitude": "33.00400000"
                    },
                    {
                        "id": 110020,
                        "name": "Mel’nichnoye",
                        "latitude": "45.19885000",
                        "longitude": "34.42012000"
                    },
                    {
                        "id": 110026,
                        "name": "Mezhvodnoye",
                        "latitude": "45.58751000",
                        "longitude": "32.84501000"
                    },
                    {
                        "id": 110027,
                        "name": "Michurinskoye",
                        "latitude": "45.07430000",
                        "longitude": "34.70672000"
                    },
                    {
                        "id": 110028,
                        "name": "Mikhaylovka",
                        "latitude": "45.11325000",
                        "longitude": "33.61071000"
                    },
                    {
                        "id": 110032,
                        "name": "Mirnovka",
                        "latitude": "45.69083000",
                        "longitude": "34.30966000"
                    },
                    {
                        "id": 110033,
                        "name": "Mirnoye",
                        "latitude": "44.98330000",
                        "longitude": "34.06160000"
                    },
                    {
                        "id": 110034,
                        "name": "Mirny",
                        "latitude": "45.30788000",
                        "longitude": "33.03501000"
                    },
                    {
                        "id": 110036,
                        "name": "Mitrofanovka",
                        "latitude": "45.45114000",
                        "longitude": "34.67883000"
                    },
                    {
                        "id": 110037,
                        "name": "Mityayevo",
                        "latitude": "45.23423000",
                        "longitude": "33.70150000"
                    },
                    {
                        "id": 110046,
                        "name": "Molochnoye",
                        "latitude": "45.19960000",
                        "longitude": "33.22233000"
                    },
                    {
                        "id": 110050,
                        "name": "Molodyozhnoye",
                        "latitude": "45.00354000",
                        "longitude": "34.05634000"
                    },
                    {
                        "id": 110053,
                        "name": "Morskoye",
                        "latitude": "44.82593000",
                        "longitude": "34.80314000"
                    },
                    {
                        "id": 110061,
                        "name": "Muromskoye",
                        "latitude": "45.09051000",
                        "longitude": "34.84900000"
                    },
                    {
                        "id": 110064,
                        "name": "Muskatnoye",
                        "latitude": "45.46586000",
                        "longitude": "34.54316000"
                    },
                    {
                        "id": 110077,
                        "name": "Mysovoe",
                        "latitude": "45.44788000",
                        "longitude": "35.83528000"
                    },
                    {
                        "id": 110083,
                        "name": "Nasypnoe",
                        "latitude": "45.05285000",
                        "longitude": "35.29415000"
                    },
                    {
                        "id": 110085,
                        "name": "Naydenovka",
                        "latitude": "45.27088000",
                        "longitude": "34.44898000"
                    },
                    {
                        "id": 110088,
                        "name": "Nekrasovka",
                        "latitude": "45.44085000",
                        "longitude": "34.98584000"
                    },
                    {
                        "id": 110089,
                        "name": "Nekrasovo",
                        "latitude": "45.42453000",
                        "longitude": "34.28545000"
                    },
                    {
                        "id": 110095,
                        "name": "Nikita",
                        "latitude": "44.51564000",
                        "longitude": "34.23840000"
                    },
                    {
                        "id": 110096,
                        "name": "Nikolayevka",
                        "latitude": "44.96213000",
                        "longitude": "33.61061000"
                    },
                    {
                        "id": 110099,
                        "name": "Nizhnegorskiy",
                        "latitude": "45.44789000",
                        "longitude": "34.73839000"
                    },
                    {
                        "id": 110100,
                        "name": "Nizhnegorskiy rayon",
                        "latitude": "45.48430000",
                        "longitude": "34.76798000"
                    },
                    {
                        "id": 110118,
                        "name": "Novoandreyevka",
                        "latitude": "45.19904000",
                        "longitude": "34.09384000"
                    },
                    {
                        "id": 110124,
                        "name": "Novoestoniya",
                        "latitude": "45.49960000",
                        "longitude": "34.24298000"
                    },
                    {
                        "id": 110126,
                        "name": "Novofedorovka",
                        "latitude": "45.09473000",
                        "longitude": "33.57211000"
                    },
                    {
                        "id": 110127,
                        "name": "Novogrigoryevka",
                        "latitude": "45.45200000",
                        "longitude": "34.60378000"
                    },
                    {
                        "id": 110129,
                        "name": "Novoivanovka",
                        "latitude": "45.44914000",
                        "longitude": "33.09833000"
                    },
                    {
                        "id": 110130,
                        "name": "Novokrymskoye",
                        "latitude": "45.78007000",
                        "longitude": "34.15543000"
                    },
                    {
                        "id": 110136,
                        "name": "Novonikolayevka",
                        "latitude": "45.30855000",
                        "longitude": "36.05749000"
                    },
                    {
                        "id": 110138,
                        "name": "Novoozyornoye",
                        "latitude": "45.38314000",
                        "longitude": "33.11715000"
                    },
                    {
                        "id": 110139,
                        "name": "Novopavlovka",
                        "latitude": "45.86634000",
                        "longitude": "33.89018000"
                    },
                    {
                        "id": 110140,
                        "name": "Novopokrovka",
                        "latitude": "45.16517000",
                        "longitude": "35.25304000"
                    },
                    {
                        "id": 110147,
                        "name": "Novosel’skoye",
                        "latitude": "45.50357000",
                        "longitude": "32.72250000"
                    },
                    {
                        "id": 110144,
                        "name": "Novoselovskoye",
                        "latitude": "45.44276000",
                        "longitude": "33.59795000"
                    },
                    {
                        "id": 110148,
                        "name": "Novostepnoye",
                        "latitude": "45.66206000",
                        "longitude": "34.38700000"
                    },
                    {
                        "id": 110149,
                        "name": "Novosyolovka",
                        "latitude": "44.99377000",
                        "longitude": "33.83525000"
                    },
                    {
                        "id": 110155,
                        "name": "Novozhilovka",
                        "latitude": "45.15960000",
                        "longitude": "34.23270000"
                    },
                    {
                        "id": 110156,
                        "name": "Novy Svet",
                        "latitude": "44.83087000",
                        "longitude": "34.91370000"
                    },
                    {
                        "id": 110178,
                        "name": "Okhotnikovo",
                        "latitude": "45.23985000",
                        "longitude": "33.59405000"
                    },
                    {
                        "id": 110179,
                        "name": "Okhotskoye",
                        "latitude": "45.48612000",
                        "longitude": "34.86401000"
                    },
                    {
                        "id": 110182,
                        "name": "Oktyabr'skoye",
                        "latitude": "45.36215000",
                        "longitude": "36.36803000"
                    },
                    {
                        "id": 110183,
                        "name": "Oktyabr’skoye",
                        "latitude": "45.28866000",
                        "longitude": "34.13521000"
                    },
                    {
                        "id": 110184,
                        "name": "Okunevka",
                        "latitude": "45.36855000",
                        "longitude": "32.76357000"
                    },
                    {
                        "id": 110191,
                        "name": "Olenevka",
                        "latitude": "45.38333000",
                        "longitude": "32.53333000"
                    },
                    {
                        "id": 110201,
                        "name": "Ordzhonikidze",
                        "latitude": "44.96401000",
                        "longitude": "35.35576000"
                    },
                    {
                        "id": 110202,
                        "name": "Orekhovo",
                        "latitude": "45.12944000",
                        "longitude": "33.63180000"
                    },
                    {
                        "id": 110204,
                        "name": "Orlovskoye",
                        "latitude": "45.81070000",
                        "longitude": "33.97308000"
                    },
                    {
                        "id": 110206,
                        "name": "Ostanino",
                        "latitude": "45.32731000",
                        "longitude": "35.91295000"
                    },
                    {
                        "id": 110209,
                        "name": "Ostrovskoye",
                        "latitude": "45.74232000",
                        "longitude": "34.06607000"
                    },
                    {
                        "id": 110220,
                        "name": "Pakharevka",
                        "latitude": "45.83472000",
                        "longitude": "34.16129000"
                    },
                    {
                        "id": 110223,
                        "name": "Partenit",
                        "latitude": "44.57800000",
                        "longitude": "34.34464000"
                    },
                    {
                        "id": 110224,
                        "name": "Partizanskoye",
                        "latitude": "44.83379000",
                        "longitude": "34.08465000"
                    },
                    {
                        "id": 110225,
                        "name": "Partizany",
                        "latitude": "45.14373000",
                        "longitude": "35.15509000"
                    },
                    {
                        "id": 110243,
                        "name": "Pereval'noye",
                        "latitude": "44.84838000",
                        "longitude": "34.31271000"
                    },
                    {
                        "id": 110245,
                        "name": "Perovo",
                        "latitude": "44.92513000",
                        "longitude": "34.05753000"
                    },
                    {
                        "id": 110248,
                        "name": "Pervomayskiy rayon",
                        "latitude": "45.59825000",
                        "longitude": "33.83249000"
                    },
                    {
                        "id": 110249,
                        "name": "Pervomayskoye",
                        "latitude": "45.71744000",
                        "longitude": "33.85596000"
                    },
                    {
                        "id": 110254,
                        "name": "Peschanoye",
                        "latitude": "44.84342000",
                        "longitude": "33.60921000"
                    },
                    {
                        "id": 110260,
                        "name": "Petrovka",
                        "latitude": "45.49776000",
                        "longitude": "34.28816000"
                    },
                    {
                        "id": 110272,
                        "name": "Pionerskoye",
                        "latitude": "44.88083000",
                        "longitude": "34.20194000"
                    },
                    {
                        "id": 110277,
                        "name": "Plodovoye",
                        "latitude": "44.87156000",
                        "longitude": "33.85615000"
                    },
                    {
                        "id": 110280,
                        "name": "Pobednoye",
                        "latitude": "45.70109000",
                        "longitude": "34.44805000"
                    },
                    {
                        "id": 110283,
                        "name": "Pochetnoye",
                        "latitude": "45.99495000",
                        "longitude": "33.76588000"
                    },
                    {
                        "id": 110295,
                        "name": "Poltavka",
                        "latitude": "45.35133000",
                        "longitude": "34.18371000"
                    },
                    {
                        "id": 110305,
                        "name": "Poshtove",
                        "latitude": "44.83540000",
                        "longitude": "33.96159000"
                    },
                    {
                        "id": 110307,
                        "name": "Pozharskoye",
                        "latitude": "44.93554000",
                        "longitude": "33.87109000"
                    },
                    {
                        "id": 110308,
                        "name": "Pravda",
                        "latitude": "45.77903000",
                        "longitude": "33.84649000"
                    },
                    {
                        "id": 110310,
                        "name": "Primorskiy",
                        "latitude": "45.11904000",
                        "longitude": "35.48025000"
                    },
                    {
                        "id": 110311,
                        "name": "Priozyornoye",
                        "latitude": "45.26990000",
                        "longitude": "36.33405000"
                    },
                    {
                        "id": 110312,
                        "name": "Privetnoye",
                        "latitude": "45.11969000",
                        "longitude": "35.05960000"
                    },
                    {
                        "id": 110314,
                        "name": "Prostornoye",
                        "latitude": "45.65597000",
                        "longitude": "34.69837000"
                    },
                    {
                        "id": 110315,
                        "name": "Prudovoye",
                        "latitude": "44.90424000",
                        "longitude": "33.78114000"
                    },
                    {
                        "id": 110316,
                        "name": "Prudy",
                        "latitude": "45.23922000",
                        "longitude": "34.70217000"
                    },
                    {
                        "id": 110326,
                        "name": "Pshenichnoye",
                        "latitude": "45.64627000",
                        "longitude": "34.83767000"
                    },
                    {
                        "id": 110329,
                        "name": "Pushkino",
                        "latitude": "45.20373000",
                        "longitude": "34.97642000"
                    },
                    {
                        "id": 110333,
                        "name": "Pyatikhatka",
                        "latitude": "45.32347000",
                        "longitude": "34.25516000"
                    },
                    {
                        "id": 110348,
                        "name": "Razdol’nenskiy rayon",
                        "latitude": "45.67086000",
                        "longitude": "33.44075000"
                    },
                    {
                        "id": 110349,
                        "name": "Razdol’noye",
                        "latitude": "45.77083000",
                        "longitude": "33.48777000"
                    },
                    {
                        "id": 110358,
                        "name": "Rodnikovo",
                        "latitude": "45.04296000",
                        "longitude": "33.95407000"
                    },
                    {
                        "id": 110367,
                        "name": "Romashkino",
                        "latitude": "45.25647000",
                        "longitude": "33.25517000"
                    },
                    {
                        "id": 110371,
                        "name": "Roshchino",
                        "latitude": "45.60916000",
                        "longitude": "34.37992000"
                    },
                    {
                        "id": 110372,
                        "name": "Roskoshnoye",
                        "latitude": "45.65187000",
                        "longitude": "34.11552000"
                    },
                    {
                        "id": 110375,
                        "name": "Rovnoye",
                        "latitude": "45.35134000",
                        "longitude": "34.35230000"
                    },
                    {
                        "id": 110389,
                        "name": "Ruch’i",
                        "latitude": "45.78564000",
                        "longitude": "33.66093000"
                    },
                    {
                        "id": 110392,
                        "name": "Rusakovka",
                        "latitude": "45.12369000",
                        "longitude": "34.47458000"
                    },
                    {
                        "id": 110395,
                        "name": "Rybach'e",
                        "latitude": "44.77331000",
                        "longitude": "34.59609000"
                    },
                    {
                        "id": 110399,
                        "name": "Sadovoye",
                        "latitude": "45.31037000",
                        "longitude": "34.65260000"
                    },
                    {
                        "id": 110402,
                        "name": "Saki",
                        "latitude": "45.13424000",
                        "longitude": "33.59996000"
                    },
                    {
                        "id": 110403,
                        "name": "Sakskiy rayon",
                        "latitude": "45.27799000",
                        "longitude": "33.52911000"
                    },
                    {
                        "id": 110409,
                        "name": "Sary-Bash",
                        "latitude": "45.57142000",
                        "longitude": "33.78728000"
                    },
                    {
                        "id": 110416,
                        "name": "Semisotka",
                        "latitude": "45.24676000",
                        "longitude": "35.56500000"
                    },
                    {
                        "id": 110418,
                        "name": "Senokosnoye",
                        "latitude": "45.73277000",
                        "longitude": "33.51552000"
                    },
                    {
                        "id": 110421,
                        "name": "Serebryanka",
                        "latitude": "45.63937000",
                        "longitude": "33.49632000"
                    },
                    {
                        "id": 110434,
                        "name": "Shchebetovka",
                        "latitude": "44.93821000",
                        "longitude": "35.15800000"
                    },
                    {
                        "id": 110437,
                        "name": "Shchyolkino",
                        "latitude": "45.42985000",
                        "longitude": "35.82250000"
                    },
                    {
                        "id": 110439,
                        "name": "Shelkovichnoye",
                        "latitude": "45.18748000",
                        "longitude": "33.68807000"
                    },
                    {
                        "id": 110446,
                        "name": "Shirokoye",
                        "latitude": "45.20029000",
                        "longitude": "34.05069000"
                    },
                    {
                        "id": 110448,
                        "name": "Shkol’noye",
                        "latitude": "45.05758000",
                        "longitude": "33.89737000"
                    },
                    {
                        "id": 110452,
                        "name": "Shtormovoye",
                        "latitude": "45.26717000",
                        "longitude": "33.08693000"
                    },
                    {
                        "id": 110459,
                        "name": "Simeiz",
                        "latitude": "44.40646000",
                        "longitude": "34.00704000"
                    },
                    {
                        "id": 110461,
                        "name": "Simferopol",
                        "latitude": "44.95719000",
                        "longitude": "34.11079000"
                    },
                    {
                        "id": 110462,
                        "name": "Simferopol Raion",
                        "latitude": "44.95690000",
                        "longitude": "34.10225000"
                    },
                    {
                        "id": 110463,
                        "name": "Sinitsyno",
                        "latitude": "45.23862000",
                        "longitude": "35.24659000"
                    },
                    {
                        "id": 110465,
                        "name": "Sizovka",
                        "latitude": "45.34892000",
                        "longitude": "33.87669000"
                    },
                    {
                        "id": 110469,
                        "name": "Skalistoye",
                        "latitude": "44.81686000",
                        "longitude": "33.97791000"
                    },
                    {
                        "id": 110473,
                        "name": "Skvortsovo",
                        "latitude": "45.07542000",
                        "longitude": "33.82084000"
                    },
                    {
                        "id": 110477,
                        "name": "Slavnoye",
                        "latitude": "45.72176000",
                        "longitude": "33.23689000"
                    },
                    {
                        "id": 110481,
                        "name": "Slavyanskoye",
                        "latitude": "45.72768000",
                        "longitude": "33.32165000"
                    },
                    {
                        "id": 110497,
                        "name": "Sofiivka",
                        "latitude": "45.08985000",
                        "longitude": "33.99887000"
                    },
                    {
                        "id": 110501,
                        "name": "Sokolinoye",
                        "latitude": "44.55041000",
                        "longitude": "33.95897000"
                    },
                    {
                        "id": 110504,
                        "name": "Solnechnaya Dolina",
                        "latitude": "44.87185000",
                        "longitude": "35.10622000"
                    },
                    {
                        "id": 110505,
                        "name": "Solnechnogorskoye",
                        "latitude": "44.74722000",
                        "longitude": "34.53999000"
                    },
                    {
                        "id": 110506,
                        "name": "Solnechnoye",
                        "latitude": "45.04767000",
                        "longitude": "34.08380000"
                    },
                    {
                        "id": 110517,
                        "name": "Sovetskiy",
                        "latitude": "45.34267000",
                        "longitude": "34.92463000"
                    },
                    {
                        "id": 110518,
                        "name": "Sovietskyi Raion",
                        "latitude": "45.31516000",
                        "longitude": "34.92914000"
                    },
                    {
                        "id": 110519,
                        "name": "Sovkhoznoye",
                        "latitude": "45.96005000",
                        "longitude": "33.77155000"
                    },
                    {
                        "id": 110523,
                        "name": "Stakhanovka",
                        "latitude": "45.37062000",
                        "longitude": "33.94883000"
                    },
                    {
                        "id": 110524,
                        "name": "Stal’noye",
                        "latitude": "45.70814000",
                        "longitude": "34.56238000"
                    },
                    {
                        "id": 110536,
                        "name": "Stary Krym",
                        "latitude": "45.02887000",
                        "longitude": "35.09174000"
                    },
                    {
                        "id": 110549,
                        "name": "Stepnoye",
                        "latitude": "45.65212000",
                        "longitude": "33.77441000"
                    },
                    {
                        "id": 110553,
                        "name": "Stolbovoye",
                        "latitude": "45.36270000",
                        "longitude": "33.49584000"
                    },
                    {
                        "id": 110556,
                        "name": "Strogonovka",
                        "latitude": "44.94970000",
                        "longitude": "34.17924000"
                    },
                    {
                        "id": 110560,
                        "name": "Sudak",
                        "latitude": "44.84924000",
                        "longitude": "34.97471000"
                    },
                    {
                        "id": 110565,
                        "name": "Susanino",
                        "latitude": "45.49898000",
                        "longitude": "33.69854000"
                    },
                    {
                        "id": 110567,
                        "name": "Suvorovo",
                        "latitude": "46.08865000",
                        "longitude": "33.68800000"
                    },
                    {
                        "id": 110568,
                        "name": "Suvorovskoye",
                        "latitude": "45.25171000",
                        "longitude": "33.37194000"
                    },
                    {
                        "id": 110576,
                        "name": "Svetloye",
                        "latitude": "45.63320000",
                        "longitude": "34.66264000"
                    },
                    {
                        "id": 110586,
                        "name": "Tabachnoye",
                        "latitude": "44.90175000",
                        "longitude": "33.67638000"
                    },
                    {
                        "id": 110588,
                        "name": "Tankovoye",
                        "latitude": "44.65829000",
                        "longitude": "33.80929000"
                    },
                    {
                        "id": 110596,
                        "name": "Tenistoye",
                        "latitude": "44.74303000",
                        "longitude": "33.66812000"
                    },
                    {
                        "id": 110599,
                        "name": "Teplovka",
                        "latitude": "45.03239000",
                        "longitude": "33.69588000"
                    },
                    {
                        "id": 110610,
                        "name": "Tokarevo",
                        "latitude": "45.28367000",
                        "longitude": "35.15244000"
                    },
                    {
                        "id": 110622,
                        "name": "Trudovoye",
                        "latitude": "44.99133000",
                        "longitude": "34.20311000"
                    },
                    {
                        "id": 110628,
                        "name": "Tselinnoye",
                        "latitude": "45.90633000",
                        "longitude": "34.18063000"
                    },
                    {
                        "id": 110630,
                        "name": "Tsvetochnoye",
                        "latitude": "45.08655000",
                        "longitude": "34.38521000"
                    },
                    {
                        "id": 110638,
                        "name": "Turgenevka",
                        "latitude": "44.69747000",
                        "longitude": "33.83007000"
                    },
                    {
                        "id": 110648,
                        "name": "Uglovoye",
                        "latitude": "44.82146000",
                        "longitude": "33.60452000"
                    },
                    {
                        "id": 110652,
                        "name": "Ukrainka",
                        "latitude": "44.88730000",
                        "longitude": "34.13973000"
                    },
                    {
                        "id": 110653,
                        "name": "Ukromnoye",
                        "latitude": "45.04272000",
                        "longitude": "34.00312000"
                    },
                    {
                        "id": 110658,
                        "name": "Urozhaynoye",
                        "latitude": "45.04522000",
                        "longitude": "34.13511000"
                    },
                    {
                        "id": 110664,
                        "name": "Uvarovka",
                        "latitude": "45.45108000",
                        "longitude": "34.78812000"
                    },
                    {
                        "id": 110665,
                        "name": "Uvarovo",
                        "latitude": "45.26260000",
                        "longitude": "35.66506000"
                    },
                    {
                        "id": 110666,
                        "name": "Uyutnoye",
                        "latitude": "45.19769000",
                        "longitude": "33.29796000"
                    },
                    {
                        "id": 110676,
                        "name": "Vasilyevka",
                        "latitude": "45.13938000",
                        "longitude": "34.72291000"
                    },
                    {
                        "id": 110703,
                        "name": "Veresayevo",
                        "latitude": "45.30551000",
                        "longitude": "33.50004000"
                    },
                    {
                        "id": 110711,
                        "name": "Verkhorechye",
                        "latitude": "44.69738000",
                        "longitude": "33.98696000"
                    },
                    {
                        "id": 110714,
                        "name": "Vesele",
                        "latitude": "44.85807000",
                        "longitude": "34.87952000"
                    },
                    {
                        "id": 110715,
                        "name": "Veselovka",
                        "latitude": "45.37733000",
                        "longitude": "33.21385000"
                    },
                    {
                        "id": 110717,
                        "name": "Vilino",
                        "latitude": "44.84560000",
                        "longitude": "33.67161000"
                    },
                    {
                        "id": 110721,
                        "name": "Vinnitskoye",
                        "latitude": "44.98129000",
                        "longitude": "33.73920000"
                    },
                    {
                        "id": 110723,
                        "name": "Vinogradnoye",
                        "latitude": "44.48149000",
                        "longitude": "34.12973000"
                    },
                    {
                        "id": 110724,
                        "name": "Vinogradovo",
                        "latitude": "45.39264000",
                        "longitude": "33.64668000"
                    },
                    {
                        "id": 110725,
                        "name": "Vishennoye",
                        "latitude": "45.14509000",
                        "longitude": "34.59691000"
                    },
                    {
                        "id": 110726,
                        "name": "Vishnyovka",
                        "latitude": "45.95966000",
                        "longitude": "33.95289000"
                    },
                    {
                        "id": 110728,
                        "name": "Vladimirovka",
                        "latitude": "45.14760000",
                        "longitude": "33.57583000"
                    },
                    {
                        "id": 110729,
                        "name": "Vladislavovka",
                        "latitude": "45.16828000",
                        "longitude": "35.37658000"
                    },
                    {
                        "id": 110731,
                        "name": "Voinka",
                        "latitude": "45.86990000",
                        "longitude": "33.99138000"
                    },
                    {
                        "id": 110739,
                        "name": "Vol’noye",
                        "latitude": "45.56570000",
                        "longitude": "34.30360000"
                    },
                    {
                        "id": 110740,
                        "name": "Vorobyovo",
                        "latitude": "45.32895000",
                        "longitude": "33.24654000"
                    },
                    {
                        "id": 110746,
                        "name": "Voskhod",
                        "latitude": "45.50999000",
                        "longitude": "34.39355000"
                    },
                    {
                        "id": 110748,
                        "name": "Voykovo",
                        "latitude": "45.38329000",
                        "longitude": "36.43739000"
                    },
                    {
                        "id": 110778,
                        "name": "Yalta",
                        "latitude": "44.50218000",
                        "longitude": "34.16624000"
                    },
                    {
                        "id": 110782,
                        "name": "Yantarnoye",
                        "latitude": "45.43473000",
                        "longitude": "34.22134000"
                    },
                    {
                        "id": 110785,
                        "name": "Yarkoye",
                        "latitude": "45.69120000",
                        "longitude": "34.26323000"
                    },
                    {
                        "id": 110786,
                        "name": "Yarkoye Pole",
                        "latitude": "45.20581000",
                        "longitude": "35.19848000"
                    },
                    {
                        "id": 110789,
                        "name": "Yasnopolyanskoye",
                        "latitude": "45.94097000",
                        "longitude": "34.35262000"
                    },
                    {
                        "id": 110794,
                        "name": "Yemelyanovka",
                        "latitude": "45.53287000",
                        "longitude": "34.89624000"
                    },
                    {
                        "id": 110798,
                        "name": "Yermakovo",
                        "latitude": "45.85364000",
                        "longitude": "34.48644000"
                    },
                    {
                        "id": 110800,
                        "name": "Yevpatoriya",
                        "latitude": "45.20091000",
                        "longitude": "33.36655000"
                    },
                    {
                        "id": 110813,
                        "name": "Zalesye",
                        "latitude": "44.88687000",
                        "longitude": "34.10168000"
                    },
                    {
                        "id": 110819,
                        "name": "Zaozyornoye",
                        "latitude": "45.15816000",
                        "longitude": "33.27866000"
                    },
                    {
                        "id": 110822,
                        "name": "Zarechnoye",
                        "latitude": "44.85048000",
                        "longitude": "34.26426000"
                    },
                    {
                        "id": 110829,
                        "name": "Zavet-Leninskiy",
                        "latitude": "45.86258000",
                        "longitude": "34.39160000"
                    },
                    {
                        "id": 110830,
                        "name": "Zavetnoye",
                        "latitude": "45.32697000",
                        "longitude": "34.80837000"
                    },
                    {
                        "id": 110835,
                        "name": "Zelenogorskoye",
                        "latitude": "45.01249000",
                        "longitude": "34.46848000"
                    },
                    {
                        "id": 110836,
                        "name": "Zelyonoye",
                        "latitude": "44.59583000",
                        "longitude": "34.00921000"
                    },
                    {
                        "id": 110837,
                        "name": "Zemlyanichnoye",
                        "latitude": "44.97444000",
                        "longitude": "34.83553000"
                    },
                    {
                        "id": 110838,
                        "name": "Zernovoye",
                        "latitude": "45.32364000",
                        "longitude": "34.48099000"
                    },
                    {
                        "id": 110841,
                        "name": "Zheleznodorozhnoye",
                        "latitude": "44.71710000",
                        "longitude": "33.80417000"
                    },
                    {
                        "id": 110842,
                        "name": "Zhelyabovka",
                        "latitude": "45.39877000",
                        "longitude": "34.75776000"
                    },
                    {
                        "id": 110843,
                        "name": "Zhemchuzhina",
                        "latitude": "45.27466000",
                        "longitude": "34.65778000"
                    },
                    {
                        "id": 110848,
                        "name": "Zhuravki",
                        "latitude": "45.12629000",
                        "longitude": "35.21513000"
                    },
                    {
                        "id": 110849,
                        "name": "Zhuravli",
                        "latitude": "45.25246000",
                        "longitude": "33.64104000"
                    },
                    {
                        "id": 110850,
                        "name": "Zhuravlyovka",
                        "latitude": "45.17680000",
                        "longitude": "33.99680000"
                    },
                    {
                        "id": 110855,
                        "name": "Zimino",
                        "latitude": "45.50797000",
                        "longitude": "33.51431000"
                    },
                    {
                        "id": 110862,
                        "name": "Zolotoye Pole",
                        "latitude": "45.12774000",
                        "longitude": "34.99148000"
                    },
                    {
                        "id": 110864,
                        "name": "Zorkino",
                        "latitude": "45.54762000",
                        "longitude": "34.71028000"
                    },
                    {
                        "id": 110868,
                        "name": "Zuya",
                        "latitude": "45.05418000",
                        "longitude": "34.32152000"
                    },
                    {
                        "id": 110870,
                        "name": "Zybiny",
                        "latitude": "45.23674000",
                        "longitude": "34.64987000"
                    }
                ]
            },
            {
                "id": 4680,
                "name": "Cherkaska",
                "iso2": "71",
                "latitude": "49.44443300",
                "longitude": "32.05976700",
                "type": "region",
                "cities": [
                    {
                        "id": 109337,
                        "name": "Babanka",
                        "latitude": "48.70971000",
                        "longitude": "30.44827000"
                    },
                    {
                        "id": 109459,
                        "name": "Buky",
                        "latitude": "49.09252000",
                        "longitude": "30.40355000"
                    },
                    {
                        "id": 109477,
                        "name": "Cherkasy",
                        "latitude": "49.42854000",
                        "longitude": "32.06207000"
                    },
                    {
                        "id": 109498,
                        "name": "Chervona Sloboda",
                        "latitude": "49.37281000",
                        "longitude": "32.15742000"
                    },
                    {
                        "id": 109510,
                        "name": "Chornobay",
                        "latitude": "49.66644000",
                        "longitude": "32.32932000"
                    },
                    {
                        "id": 109524,
                        "name": "Chyhyryn",
                        "latitude": "49.08376000",
                        "longitude": "32.65549000"
                    },
                    {
                        "id": 109575,
                        "name": "Drabiv",
                        "latitude": "49.96029000",
                        "longitude": "32.14070000"
                    },
                    {
                        "id": 109651,
                        "name": "Horodyshche",
                        "latitude": "49.28489000",
                        "longitude": "31.44513000"
                    },
                    {
                        "id": 109709,
                        "name": "Kamianka",
                        "latitude": "49.03180000",
                        "longitude": "32.10396000"
                    },
                    {
                        "id": 109714,
                        "name": "Kaniv",
                        "latitude": "49.75182000",
                        "longitude": "31.46004000"
                    },
                    {
                        "id": 109741,
                        "name": "Khrystynivka",
                        "latitude": "48.81577000",
                        "longitude": "29.97703000"
                    },
                    {
                        "id": 109805,
                        "name": "Korsun-Shevchenkivskyi",
                        "latitude": "49.41894000",
                        "longitude": "31.25865000"
                    },
                    {
                        "id": 109909,
                        "name": "Lebedyn",
                        "latitude": "48.96242000",
                        "longitude": "31.52696000"
                    },
                    {
                        "id": 109959,
                        "name": "Lysianka",
                        "latitude": "49.25229000",
                        "longitude": "30.82946000"
                    },
                    {
                        "id": 109995,
                        "name": "Mankivka",
                        "latitude": "48.96349000",
                        "longitude": "30.33366000"
                    },
                    {
                        "id": 110042,
                        "name": "Mliiv",
                        "latitude": "49.33691000",
                        "longitude": "31.51704000"
                    },
                    {
                        "id": 110051,
                        "name": "Monastyryshche",
                        "latitude": "48.99090000",
                        "longitude": "29.80470000"
                    },
                    {
                        "id": 110054,
                        "name": "Moshny",
                        "latitude": "49.52754000",
                        "longitude": "31.73708000"
                    },
                    {
                        "id": 110112,
                        "name": "Nove-Misto",
                        "latitude": "48.98113000",
                        "longitude": "29.82813000"
                    },
                    {
                        "id": 110393,
                        "name": "Ruska Poliana",
                        "latitude": "49.41700000",
                        "longitude": "31.92009000"
                    },
                    {
                        "id": 110451,
                        "name": "Shpola",
                        "latitude": "49.00687000",
                        "longitude": "31.39471000"
                    },
                    {
                        "id": 110488,
                        "name": "Smila",
                        "latitude": "49.22242000",
                        "longitude": "31.88714000"
                    },
                    {
                        "id": 110546,
                        "name": "Stebliv",
                        "latitude": "49.40186000",
                        "longitude": "31.09764000"
                    },
                    {
                        "id": 110587,
                        "name": "Talne",
                        "latitude": "48.88877000",
                        "longitude": "30.69482000"
                    },
                    {
                        "id": 110629,
                        "name": "Tsibulev",
                        "latitude": "49.07907000",
                        "longitude": "29.84727000"
                    },
                    {
                        "id": 110631,
                        "name": "Tsvitkove",
                        "latitude": "49.15231000",
                        "longitude": "31.53739000"
                    },
                    {
                        "id": 110656,
                        "name": "Uman",
                        "latitude": "48.74838000",
                        "longitude": "30.22184000"
                    },
                    {
                        "id": 110681,
                        "name": "Vatutine",
                        "latitude": "49.01502000",
                        "longitude": "31.06211000"
                    },
                    {
                        "id": 110704,
                        "name": "Verkhniachka",
                        "latitude": "48.82849000",
                        "longitude": "30.03957000"
                    },
                    {
                        "id": 110797,
                        "name": "Yerky",
                        "latitude": "48.99062000",
                        "longitude": "30.98818000"
                    },
                    {
                        "id": 110802,
                        "name": "Yurkivka",
                        "latitude": "49.01082000",
                        "longitude": "31.08797000"
                    },
                    {
                        "id": 110840,
                        "name": "Zhashkiv",
                        "latitude": "49.24545000",
                        "longitude": "30.11020000"
                    },
                    {
                        "id": 110861,
                        "name": "Zolotonosha",
                        "latitude": "49.66832000",
                        "longitude": "32.04047000"
                    },
                    {
                        "id": 110869,
                        "name": "Zvenihorodka",
                        "latitude": "49.07866000",
                        "longitude": "30.96755000"
                    }
                ]
            },
            {
                "id": 4692,
                "name": "Chernihivska",
                "iso2": "74",
                "latitude": "51.49820000",
                "longitude": "31.28934990",
                "type": "region",
                "cities": [
                    {
                        "id": 109334,
                        "name": "Avdiyivka",
                        "latitude": "51.77660000",
                        "longitude": "32.79988000"
                    },
                    {
                        "id": 109341,
                        "name": "Bakhmach",
                        "latitude": "51.18144000",
                        "longitude": "32.83463000"
                    },
                    {
                        "id": 109358,
                        "name": "Baturyn",
                        "latitude": "51.34567000",
                        "longitude": "32.87794000"
                    },
                    {
                        "id": 109381,
                        "name": "Berezna",
                        "latitude": "51.57160000",
                        "longitude": "31.78456000"
                    },
                    {
                        "id": 109415,
                        "name": "Bobrovytsya",
                        "latitude": "50.74693000",
                        "longitude": "31.39480000"
                    },
                    {
                        "id": 109437,
                        "name": "Borzna",
                        "latitude": "51.25464000",
                        "longitude": "32.42690000"
                    },
                    {
                        "id": 109480,
                        "name": "Chernihiv",
                        "latitude": "51.50551000",
                        "longitude": "31.28487000"
                    },
                    {
                        "id": 109481,
                        "name": "Chernihiv Raion",
                        "latitude": "51.58333000",
                        "longitude": "31.33333000"
                    },
                    {
                        "id": 109483,
                        "name": "Chernihivs’ka Mis’krada",
                        "latitude": "51.49923000",
                        "longitude": "31.28805000"
                    },
                    {
                        "id": 109540,
                        "name": "Desna",
                        "latitude": "50.92731000",
                        "longitude": "30.76048000"
                    },
                    {
                        "id": 109542,
                        "name": "Dihtyari",
                        "latitude": "50.58264000",
                        "longitude": "32.77012000"
                    },
                    {
                        "id": 109562,
                        "name": "Dobryanka",
                        "latitude": "52.06314000",
                        "longitude": "31.18567000"
                    },
                    {
                        "id": 109645,
                        "name": "Horodnya",
                        "latitude": "51.89085000",
                        "longitude": "31.59741000"
                    },
                    {
                        "id": 109666,
                        "name": "Ichnya",
                        "latitude": "50.86258000",
                        "longitude": "32.39425000"
                    },
                    {
                        "id": 109735,
                        "name": "Kholmy",
                        "latitude": "51.87096000",
                        "longitude": "32.60063000"
                    },
                    {
                        "id": 109766,
                        "name": "Kobyzhcha",
                        "latitude": "50.82854000",
                        "longitude": "31.50439000"
                    },
                    {
                        "id": 109800,
                        "name": "Korop",
                        "latitude": "51.56638000",
                        "longitude": "32.95861000"
                    },
                    {
                        "id": 109806,
                        "name": "Koryukivka",
                        "latitude": "51.76877000",
                        "longitude": "32.24813000"
                    },
                    {
                        "id": 109824,
                        "name": "Kozelets’",
                        "latitude": "50.91334000",
                        "longitude": "31.12140000"
                    },
                    {
                        "id": 109868,
                        "name": "Kruty",
                        "latitude": "51.05974000",
                        "longitude": "32.10634000"
                    },
                    {
                        "id": 109885,
                        "name": "Kulykivka",
                        "latitude": "51.37345000",
                        "longitude": "31.64661000"
                    },
                    {
                        "id": 109901,
                        "name": "Ladan",
                        "latitude": "50.51959000",
                        "longitude": "32.58178000"
                    },
                    {
                        "id": 109918,
                        "name": "Lisovi Sorochyntsi",
                        "latitude": "50.68920000",
                        "longitude": "32.32919000"
                    },
                    {
                        "id": 109963,
                        "name": "Lyubech",
                        "latitude": "51.70260000",
                        "longitude": "30.65692000"
                    },
                    {
                        "id": 110021,
                        "name": "Mena",
                        "latitude": "51.52170000",
                        "longitude": "32.21568000"
                    },
                    {
                        "id": 110022,
                        "name": "Mens’kyy Rayon",
                        "latitude": "51.52148000",
                        "longitude": "32.02166000"
                    },
                    {
                        "id": 110101,
                        "name": "Nizhyn",
                        "latitude": "51.04801000",
                        "longitude": "31.88688000"
                    },
                    {
                        "id": 110102,
                        "name": "Nosivka",
                        "latitude": "50.93152000",
                        "longitude": "31.58282000"
                    },
                    {
                        "id": 110113,
                        "name": "Novhorod-Sivers’kyy",
                        "latitude": "52.00577000",
                        "longitude": "33.26150000"
                    },
                    {
                        "id": 110196,
                        "name": "Olyshivka",
                        "latitude": "51.22266000",
                        "longitude": "31.33314000"
                    },
                    {
                        "id": 110207,
                        "name": "Oster",
                        "latitude": "50.95060000",
                        "longitude": "30.88229000"
                    },
                    {
                        "id": 110320,
                        "name": "Pryluky",
                        "latitude": "50.59323000",
                        "longitude": "32.38761000"
                    },
                    {
                        "id": 110353,
                        "name": "Ripky",
                        "latitude": "51.80105000",
                        "longitude": "31.08383000"
                    },
                    {
                        "id": 110412,
                        "name": "Sedniv",
                        "latitude": "51.64473000",
                        "longitude": "31.56497000"
                    },
                    {
                        "id": 110415,
                        "name": "Semenivka",
                        "latitude": "52.17827000",
                        "longitude": "32.58183000"
                    },
                    {
                        "id": 110436,
                        "name": "Shchors",
                        "latitude": "51.81865000",
                        "longitude": "31.94504000"
                    },
                    {
                        "id": 110494,
                        "name": "Snovs'kyy Rayon",
                        "latitude": "51.83333000",
                        "longitude": "32.00000000"
                    },
                    {
                        "id": 110516,
                        "name": "Sosnytsya",
                        "latitude": "51.52387000",
                        "longitude": "32.49985000"
                    },
                    {
                        "id": 110522,
                        "name": "Sribne",
                        "latitude": "50.66384000",
                        "longitude": "32.91867000"
                    },
                    {
                        "id": 110673,
                        "name": "Varva",
                        "latitude": "50.49503000",
                        "longitude": "32.71968000"
                    },
                    {
                        "id": 110847,
                        "name": "Zhuravka",
                        "latitude": "50.48108000",
                        "longitude": "32.59490000"
                    }
                ]
            },
            {
                "id": 4678,
                "name": "Chernivetska",
                "iso2": "77",
                "latitude": "48.29168300",
                "longitude": "25.93521700",
                "type": "region",
                "cities": [
                    {
                        "id": 109348,
                        "name": "Banyliv",
                        "latitude": "48.36612000",
                        "longitude": "25.34549000"
                    },
                    {
                        "id": 109374,
                        "name": "Berehomet",
                        "latitude": "48.17882000",
                        "longitude": "25.34855000"
                    },
                    {
                        "id": 109439,
                        "name": "Boyany",
                        "latitude": "48.27077000",
                        "longitude": "26.12624000"
                    },
                    {
                        "id": 109486,
                        "name": "Chernivtsi",
                        "latitude": "48.29149000",
                        "longitude": "25.94034000"
                    },
                    {
                        "id": 109487,
                        "name": "Chernivtsi Municipality",
                        "latitude": "48.31932000",
                        "longitude": "25.94104000"
                    },
                    {
                        "id": 109519,
                        "name": "Chudey",
                        "latitude": "48.05247000",
                        "longitude": "25.62208000"
                    },
                    {
                        "id": 109531,
                        "name": "Davydivka",
                        "latitude": "48.12099000",
                        "longitude": "25.56461000"
                    },
                    {
                        "id": 109633,
                        "name": "Hlyboka",
                        "latitude": "48.08971000",
                        "longitude": "25.92933000"
                    },
                    {
                        "id": 109677,
                        "name": "Ispas",
                        "latitude": "48.29734000",
                        "longitude": "25.27406000"
                    },
                    {
                        "id": 109694,
                        "name": "Kadubivtsi",
                        "latitude": "48.58337000",
                        "longitude": "25.76871000"
                    },
                    {
                        "id": 109740,
                        "name": "Khotyn",
                        "latitude": "48.50693000",
                        "longitude": "26.49121000"
                    },
                    {
                        "id": 109763,
                        "name": "Klishkivtsi",
                        "latitude": "48.43161000",
                        "longitude": "26.26231000"
                    },
                    {
                        "id": 109814,
                        "name": "Kostryzhivka",
                        "latitude": "48.65455000",
                        "longitude": "25.71316000"
                    },
                    {
                        "id": 109947,
                        "name": "Luzhany",
                        "latitude": "48.36492000",
                        "longitude": "25.77173000"
                    },
                    {
                        "id": 110003,
                        "name": "Marshintsy",
                        "latitude": "48.21751000",
                        "longitude": "26.29133000"
                    },
                    {
                        "id": 110047,
                        "name": "Molodiya",
                        "latitude": "48.22326000",
                        "longitude": "26.02139000"
                    },
                    {
                        "id": 110067,
                        "name": "Myhove",
                        "latitude": "48.15749000",
                        "longitude": "25.37904000"
                    },
                    {
                        "id": 110122,
                        "name": "Novodnistrovs’k",
                        "latitude": "48.58303000",
                        "longitude": "27.44070000"
                    },
                    {
                        "id": 110145,
                        "name": "Novoselytsya",
                        "latitude": "48.21931000",
                        "longitude": "26.26531000"
                    },
                    {
                        "id": 110164,
                        "name": "Nyzhni Petrivtsi",
                        "latitude": "48.02847000",
                        "longitude": "25.72327000"
                    },
                    {
                        "id": 110331,
                        "name": "Putyla Raion",
                        "latitude": "48.00000000",
                        "longitude": "25.00000000"
                    },
                    {
                        "id": 110370,
                        "name": "Ropcha",
                        "latitude": "48.11988000",
                        "longitude": "25.77421000"
                    },
                    {
                        "id": 110453,
                        "name": "Shypyntsi",
                        "latitude": "48.37677000",
                        "longitude": "25.74664000"
                    },
                    {
                        "id": 110502,
                        "name": "Sokyryany",
                        "latitude": "48.44747000",
                        "longitude": "27.41678000"
                    },
                    {
                        "id": 110675,
                        "name": "Vashkivtsi",
                        "latitude": "48.38491000",
                        "longitude": "25.51023000"
                    },
                    {
                        "id": 110702,
                        "name": "Verenchanka",
                        "latitude": "48.54653000",
                        "longitude": "25.74533000"
                    },
                    {
                        "id": 110736,
                        "name": "Voloka",
                        "latitude": "48.19225000",
                        "longitude": "25.93074000"
                    },
                    {
                        "id": 110769,
                        "name": "Vyzhnytsya",
                        "latitude": "48.24801000",
                        "longitude": "25.19452000"
                    },
                    {
                        "id": 110801,
                        "name": "Yizhivtsi",
                        "latitude": "48.03962000",
                        "longitude": "25.66232000"
                    },
                    {
                        "id": 110825,
                        "name": "Zastavna",
                        "latitude": "48.52307000",
                        "longitude": "25.84369000"
                    }
                ]
            },
            {
                "id": 4675,
                "name": "Dnipropetrovska",
                "iso2": "12",
                "latitude": "48.46471700",
                "longitude": "35.04618300",
                "type": "region",
                "cities": [
                    {
                        "id": 109325,
                        "name": "Apostolove",
                        "latitude": "47.66003000",
                        "longitude": "33.71369000"
                    },
                    {
                        "id": 109332,
                        "name": "Auly",
                        "latitude": "48.56660000",
                        "longitude": "34.46111000"
                    },
                    {
                        "id": 109335,
                        "name": "Aviatorske",
                        "latitude": "48.36714000",
                        "longitude": "35.08132000"
                    },
                    {
                        "id": 109501,
                        "name": "Chervonohryhorivka",
                        "latitude": "47.62298000",
                        "longitude": "34.53887000"
                    },
                    {
                        "id": 109518,
                        "name": "Chortomlyk",
                        "latitude": "47.62315000",
                        "longitude": "34.14198000"
                    },
                    {
                        "id": 109548,
                        "name": "Dnipro",
                        "latitude": "48.45930000",
                        "longitude": "35.03865000"
                    },
                    {
                        "id": 109549,
                        "name": "Dnipro Raion",
                        "latitude": "48.45608000",
                        "longitude": "35.02167000"
                    },
                    {
                        "id": 109553,
                        "name": "Dniprovs’ka Mis’ka Rada",
                        "latitude": "48.46726000",
                        "longitude": "34.99898000"
                    },
                    {
                        "id": 109659,
                        "name": "Hubynykha",
                        "latitude": "48.80980000",
                        "longitude": "35.25602000"
                    },
                    {
                        "id": 109661,
                        "name": "Hupalivka",
                        "latitude": "49.11139000",
                        "longitude": "34.73556000"
                    },
                    {
                        "id": 109710,
                        "name": "Kamianske",
                        "latitude": "48.51134000",
                        "longitude": "34.60210000"
                    },
                    {
                        "id": 109721,
                        "name": "Kaydaki",
                        "latitude": "48.37678000",
                        "longitude": "35.12398000"
                    },
                    {
                        "id": 109872,
                        "name": "Krynychky",
                        "latitude": "48.37551000",
                        "longitude": "34.46701000"
                    },
                    {
                        "id": 109876,
                        "name": "Kryvoriz’ka Mis’krada",
                        "latitude": "47.94730000",
                        "longitude": "33.42489000"
                    },
                    {
                        "id": 109877,
                        "name": "Kryvyi Rih",
                        "latitude": "47.90966000",
                        "longitude": "33.38044000"
                    },
                    {
                        "id": 109949,
                        "name": "Lykhivka",
                        "latitude": "48.68735000",
                        "longitude": "33.92279000"
                    },
                    {
                        "id": 109970,
                        "name": "Mahdalynivka",
                        "latitude": "48.92111000",
                        "longitude": "34.91491000"
                    },
                    {
                        "id": 109971,
                        "name": "Mahdalynivs’kyy Rayon",
                        "latitude": "48.97612000",
                        "longitude": "34.96762000"
                    },
                    {
                        "id": 109999,
                        "name": "Marhanets’",
                        "latitude": "47.63543000",
                        "longitude": "34.62769000"
                    },
                    {
                        "id": 110017,
                        "name": "Melioratyvne",
                        "latitude": "48.63009000",
                        "longitude": "35.41558000"
                    },
                    {
                        "id": 110025,
                        "name": "Mezhova",
                        "latitude": "48.25318000",
                        "longitude": "36.73468000"
                    },
                    {
                        "id": 110098,
                        "name": "Nikopol",
                        "latitude": "47.57119000",
                        "longitude": "34.39637000"
                    },
                    {
                        "id": 110132,
                        "name": "Novomoskovs’k",
                        "latitude": "48.63799000",
                        "longitude": "35.24548000"
                    },
                    {
                        "id": 110131,
                        "name": "Novomoskovsk Raion",
                        "latitude": "48.66667000",
                        "longitude": "35.41667000"
                    },
                    {
                        "id": 110134,
                        "name": "Novomykolayivka",
                        "latitude": "48.55625000",
                        "longitude": "34.37399000"
                    },
                    {
                        "id": 110142,
                        "name": "Novopokrovka",
                        "latitude": "48.05918000",
                        "longitude": "34.60619000"
                    },
                    {
                        "id": 110200,
                        "name": "Ordzhonikidze",
                        "latitude": "47.66763000",
                        "longitude": "34.05957000"
                    },
                    {
                        "id": 110226,
                        "name": "Partyzans’ke",
                        "latitude": "48.58680000",
                        "longitude": "34.80948000"
                    },
                    {
                        "id": 110232,
                        "name": "Pavlohrad",
                        "latitude": "48.53426000",
                        "longitude": "35.87098000"
                    },
                    {
                        "id": 110258,
                        "name": "Petropavlivka",
                        "latitude": "48.45643000",
                        "longitude": "36.43670000"
                    },
                    {
                        "id": 110261,
                        "name": "Petrykivka",
                        "latitude": "48.72933000",
                        "longitude": "34.63358000"
                    },
                    {
                        "id": 110262,
                        "name": "Petrykivs’kyy Rayon",
                        "latitude": "48.68914000",
                        "longitude": "34.61098000"
                    },
                    {
                        "id": 110263,
                        "name": "Piatykhatky",
                        "latitude": "48.41333000",
                        "longitude": "33.71056000"
                    },
                    {
                        "id": 110268,
                        "name": "Pidhorodne",
                        "latitude": "48.57528000",
                        "longitude": "35.10680000"
                    },
                    {
                        "id": 110449,
                        "name": "Sholokhove",
                        "latitude": "47.69453000",
                        "longitude": "34.03119000"
                    },
                    {
                        "id": 110455,
                        "name": "Shyroke",
                        "latitude": "47.69173000",
                        "longitude": "33.25715000"
                    },
                    {
                        "id": 110456,
                        "name": "Shyroke Raion",
                        "latitude": "47.66667000",
                        "longitude": "33.33333000"
                    },
                    {
                        "id": 110498,
                        "name": "Sofiyivka",
                        "latitude": "48.04865000",
                        "longitude": "33.87618000"
                    },
                    {
                        "id": 110508,
                        "name": "Solone",
                        "latitude": "48.20805000",
                        "longitude": "34.87208000"
                    },
                    {
                        "id": 110509,
                        "name": "Solone Raion",
                        "latitude": "48.16667000",
                        "longitude": "35.00000000"
                    },
                    {
                        "id": 110521,
                        "name": "Spas’ke",
                        "latitude": "48.66667000",
                        "longitude": "35.05385000"
                    },
                    {
                        "id": 110564,
                        "name": "Surs’ko-Mykhaylivka",
                        "latitude": "48.27202000",
                        "longitude": "34.72759000"
                    },
                    {
                        "id": 110583,
                        "name": "Synel’nykove",
                        "latitude": "48.32044000",
                        "longitude": "35.51792000"
                    },
                    {
                        "id": 110613,
                        "name": "Tomakivka",
                        "latitude": "47.81569000",
                        "longitude": "34.74137000"
                    },
                    {
                        "id": 110626,
                        "name": "Tsarychanka",
                        "latitude": "48.93697000",
                        "longitude": "34.47860000"
                    },
                    {
                        "id": 110627,
                        "name": "Tsarychans’kyy Rayon",
                        "latitude": "48.93329000",
                        "longitude": "34.53043000"
                    },
                    {
                        "id": 110710,
                        "name": "Verkhn’odniprovs’k",
                        "latitude": "48.65242000",
                        "longitude": "34.33457000"
                    },
                    {
                        "id": 110719,
                        "name": "Vil’ne",
                        "latitude": "47.63645000",
                        "longitude": "34.81387000"
                    },
                    {
                        "id": 110761,
                        "name": "Vyshchetarasivka",
                        "latitude": "47.56851000",
                        "longitude": "34.88096000"
                    },
                    {
                        "id": 110766,
                        "name": "Vyshneve",
                        "latitude": "48.43611000",
                        "longitude": "33.91556000"
                    },
                    {
                        "id": 110803,
                        "name": "Yur”yivs’kyy Rayon",
                        "latitude": "48.80743000",
                        "longitude": "35.91325000"
                    },
                    {
                        "id": 110846,
                        "name": "Zhovti Vody",
                        "latitude": "48.34493000",
                        "longitude": "33.50374000"
                    }
                ]
            },
            {
                "id": 4691,
                "name": "Donetska",
                "iso2": "14",
                "latitude": "48.01588300",
                "longitude": "37.80285000",
                "type": "region",
                "cities": [
                    {
                        "id": 109318,
                        "name": "Amvrosiivka Raion",
                        "latitude": "47.75000000",
                        "longitude": "38.50000000"
                    },
                    {
                        "id": 109319,
                        "name": "Amvrosiyivka",
                        "latitude": "47.79348000",
                        "longitude": "38.47768000"
                    },
                    {
                        "id": 109333,
                        "name": "Avdiyivka",
                        "latitude": "48.13989000",
                        "longitude": "37.74255000"
                    },
                    {
                        "id": 109342,
                        "name": "Bakhmut",
                        "latitude": "48.59559000",
                        "longitude": "37.99987000"
                    },
                    {
                        "id": 109343,
                        "name": "Bakhmut Raion",
                        "latitude": "48.58333000",
                        "longitude": "38.00000000"
                    },
                    {
                        "id": 109389,
                        "name": "Bezimenne",
                        "latitude": "47.10716000",
                        "longitude": "37.93815000"
                    },
                    {
                        "id": 109407,
                        "name": "Bilyts’ke",
                        "latitude": "48.40642000",
                        "longitude": "37.18111000"
                    },
                    {
                        "id": 109410,
                        "name": "Blahodatne",
                        "latitude": "47.87928000",
                        "longitude": "38.48492000"
                    },
                    {
                        "id": 109441,
                        "name": "Boykivske",
                        "latitude": "47.40994000",
                        "longitude": "38.02476000"
                    },
                    {
                        "id": 109442,
                        "name": "Boykivske Raion",
                        "latitude": "47.41667000",
                        "longitude": "38.00000000"
                    },
                    {
                        "id": 109473,
                        "name": "Chasiv Yar",
                        "latitude": "48.59348000",
                        "longitude": "37.85724000"
                    },
                    {
                        "id": 109526,
                        "name": "Chystyakove",
                        "latitude": "48.03876000",
                        "longitude": "38.59685000"
                    },
                    {
                        "id": 109532,
                        "name": "Debal’tseve",
                        "latitude": "48.34072000",
                        "longitude": "38.40490000"
                    },
                    {
                        "id": 109546,
                        "name": "Dmytrivka",
                        "latitude": "47.93611000",
                        "longitude": "38.93661000"
                    },
                    {
                        "id": 109556,
                        "name": "Dobropillia Raion",
                        "latitude": "48.41667000",
                        "longitude": "37.16667000"
                    },
                    {
                        "id": 109557,
                        "name": "Dobropillya",
                        "latitude": "48.46147000",
                        "longitude": "37.08524000"
                    },
                    {
                        "id": 109563,
                        "name": "Dokuchayevs’k",
                        "latitude": "47.75046000",
                        "longitude": "37.67936000"
                    },
                    {
                        "id": 109570,
                        "name": "Donetsk",
                        "latitude": "48.02300000",
                        "longitude": "37.80224000"
                    },
                    {
                        "id": 109581,
                        "name": "Druzhkivka",
                        "latitude": "48.63013000",
                        "longitude": "37.55259000"
                    },
                    {
                        "id": 109641,
                        "name": "Horlivka",
                        "latitude": "48.33576000",
                        "longitude": "38.05325000"
                    },
                    {
                        "id": 109668,
                        "name": "Ilovays’k",
                        "latitude": "47.92498000",
                        "longitude": "38.20235000"
                    },
                    {
                        "id": 109728,
                        "name": "Khartsyz’k",
                        "latitude": "48.04243000",
                        "longitude": "38.14728000"
                    },
                    {
                        "id": 109811,
                        "name": "Kostiantynivka Raion",
                        "latitude": "48.50000000",
                        "longitude": "37.75000000"
                    },
                    {
                        "id": 109817,
                        "name": "Kostyantynivka",
                        "latitude": "48.52770000",
                        "longitude": "37.70690000"
                    },
                    {
                        "id": 109828,
                        "name": "Kramators’k",
                        "latitude": "48.72305000",
                        "longitude": "37.55629000"
                    },
                    {
                        "id": 109848,
                        "name": "Krasnotorka",
                        "latitude": "48.68204000",
                        "longitude": "37.53266000"
                    },
                    {
                        "id": 109862,
                        "name": "Krinichnaya",
                        "latitude": "48.12899000",
                        "longitude": "38.02597000"
                    },
                    {
                        "id": 109888,
                        "name": "Kurakhovo",
                        "latitude": "47.98522000",
                        "longitude": "37.28210000"
                    },
                    {
                        "id": 109893,
                        "name": "Kuteynykove",
                        "latitude": "47.81227000",
                        "longitude": "38.28822000"
                    },
                    {
                        "id": 109940,
                        "name": "Luhans’ke",
                        "latitude": "48.44574000",
                        "longitude": "38.26153000"
                    },
                    {
                        "id": 109950,
                        "name": "Lyman",
                        "latitude": "48.98837000",
                        "longitude": "37.80225000"
                    },
                    {
                        "id": 109952,
                        "name": "Lyman Raion",
                        "latitude": "49.00000000",
                        "longitude": "37.83333000"
                    },
                    {
                        "id": 109976,
                        "name": "Makiyivka",
                        "latitude": "48.04782000",
                        "longitude": "37.92576000"
                    },
                    {
                        "id": 109977,
                        "name": "Makiyivs’ka Mis’krada",
                        "latitude": "48.06287000",
                        "longitude": "38.03075000"
                    },
                    {
                        "id": 109994,
                        "name": "Manhush",
                        "latitude": "47.05582000",
                        "longitude": "37.31068000"
                    },
                    {
                        "id": 109997,
                        "name": "Mar'yinka",
                        "latitude": "47.94527000",
                        "longitude": "37.50544000"
                    },
                    {
                        "id": 110000,
                        "name": "Mariupol",
                        "latitude": "47.09514000",
                        "longitude": "37.54131000"
                    },
                    {
                        "id": 110016,
                        "name": "Melekyne",
                        "latitude": "46.95957000",
                        "longitude": "37.39981000"
                    },
                    {
                        "id": 110055,
                        "name": "Mospyne",
                        "latitude": "47.89081000",
                        "longitude": "38.06395000"
                    },
                    {
                        "id": 110075,
                        "name": "Myrnohrad",
                        "latitude": "48.30523000",
                        "longitude": "37.26091000"
                    },
                    {
                        "id": 110097,
                        "name": "Nikolske Raion",
                        "latitude": "47.25000000",
                        "longitude": "37.25000000"
                    },
                    {
                        "id": 110120,
                        "name": "Novoazovs'k",
                        "latitude": "47.11389000",
                        "longitude": "38.08599000"
                    },
                    {
                        "id": 110123,
                        "name": "Novodonets’ke",
                        "latitude": "48.63526000",
                        "longitude": "36.98477000"
                    },
                    {
                        "id": 110161,
                        "name": "Novyy Svit",
                        "latitude": "47.80591000",
                        "longitude": "38.02112000"
                    },
                    {
                        "id": 110167,
                        "name": "Nyzhnya Krynka",
                        "latitude": "48.11350000",
                        "longitude": "38.16064000"
                    },
                    {
                        "id": 110219,
                        "name": "P'yatypill'ya",
                        "latitude": "48.01590000",
                        "longitude": "38.09979000"
                    },
                    {
                        "id": 110291,
                        "name": "Pokrovsk",
                        "latitude": "48.28198000",
                        "longitude": "37.17585000"
                    },
                    {
                        "id": 110292,
                        "name": "Pokrovsk Raion",
                        "latitude": "48.25000000",
                        "longitude": "37.16667000"
                    },
                    {
                        "id": 110359,
                        "name": "Rodyns’ke",
                        "latitude": "48.35199000",
                        "longitude": "37.20602000"
                    },
                    {
                        "id": 110385,
                        "name": "Rozsypne",
                        "latitude": "48.14966000",
                        "longitude": "38.57619000"
                    },
                    {
                        "id": 110408,
                        "name": "Sartana",
                        "latitude": "47.17436000",
                        "longitude": "37.69266000"
                    },
                    {
                        "id": 110413,
                        "name": "Selydivs’ka Mis’krada",
                        "latitude": "48.14530000",
                        "longitude": "37.29962000"
                    },
                    {
                        "id": 110414,
                        "name": "Selydove",
                        "latitude": "48.14708000",
                        "longitude": "37.30032000"
                    },
                    {
                        "id": 110420,
                        "name": "Serebryanka",
                        "latitude": "48.91917000",
                        "longitude": "38.13494000"
                    },
                    {
                        "id": 110428,
                        "name": "Shakhtars’k",
                        "latitude": "48.05657000",
                        "longitude": "38.43826000"
                    },
                    {
                        "id": 110435,
                        "name": "Shcherbynivka",
                        "latitude": "48.39489000",
                        "longitude": "37.79102000"
                    },
                    {
                        "id": 110454,
                        "name": "Shyroke",
                        "latitude": "47.95711000",
                        "longitude": "38.23160000"
                    },
                    {
                        "id": 110464,
                        "name": "Sivers’k",
                        "latitude": "48.86699000",
                        "longitude": "38.10007000"
                    },
                    {
                        "id": 110486,
                        "name": "Sloviansk",
                        "latitude": "48.86667000",
                        "longitude": "37.61667000"
                    },
                    {
                        "id": 110487,
                        "name": "Sloviansk Raion",
                        "latitude": "48.91667000",
                        "longitude": "37.50000000"
                    },
                    {
                        "id": 110493,
                        "name": "Snizhne",
                        "latitude": "48.02612000",
                        "longitude": "38.77225000"
                    },
                    {
                        "id": 110503,
                        "name": "Soledar",
                        "latitude": "48.67935000",
                        "longitude": "38.08902000"
                    },
                    {
                        "id": 110531,
                        "name": "Starobesheve",
                        "latitude": "47.75038000",
                        "longitude": "38.03051000"
                    },
                    {
                        "id": 110539,
                        "name": "Staryy Krym",
                        "latitude": "47.16146000",
                        "longitude": "37.48934000"
                    },
                    {
                        "id": 110552,
                        "name": "Stizhkivs’ke",
                        "latitude": "48.11333000",
                        "longitude": "38.49250000"
                    },
                    {
                        "id": 110575,
                        "name": "Svetlodarsk",
                        "latitude": "48.43374000",
                        "longitude": "38.22331000"
                    },
                    {
                        "id": 110579,
                        "name": "Svyatogorsk",
                        "latitude": "49.03333000",
                        "longitude": "37.56667000"
                    },
                    {
                        "id": 110581,
                        "name": "Syedove",
                        "latitude": "47.07678000",
                        "longitude": "38.15602000"
                    },
                    {
                        "id": 110595,
                        "name": "Temriuk",
                        "latitude": "47.26857000",
                        "longitude": "36.98115000"
                    },
                    {
                        "id": 110616,
                        "name": "Toretsk",
                        "latitude": "48.39869000",
                        "longitude": "37.84787000"
                    },
                    {
                        "id": 110659,
                        "name": "Urzuf",
                        "latitude": "46.91562000",
                        "longitude": "37.09961000"
                    },
                    {
                        "id": 110732,
                        "name": "Volnovakha",
                        "latitude": "47.60103000",
                        "longitude": "37.49674000"
                    },
                    {
                        "id": 110753,
                        "name": "Vuhlehirs’k",
                        "latitude": "48.31474000",
                        "longitude": "38.27423000"
                    },
                    {
                        "id": 110777,
                        "name": "Yalta",
                        "latitude": "46.96279000",
                        "longitude": "37.27365000"
                    },
                    {
                        "id": 110790,
                        "name": "Yasynuvata",
                        "latitude": "48.12980000",
                        "longitude": "37.85940000"
                    },
                    {
                        "id": 110791,
                        "name": "Yasynuvata Raion",
                        "latitude": "48.16667000",
                        "longitude": "37.83333000"
                    },
                    {
                        "id": 110796,
                        "name": "Yenakiyeve",
                        "latitude": "48.23331000",
                        "longitude": "38.21137000"
                    },
                    {
                        "id": 110867,
                        "name": "Zuhres",
                        "latitude": "48.01140000",
                        "longitude": "38.26444000"
                    }
                ]
            },
            {
                "id": 4682,
                "name": "Ivano-Frankivska",
                "iso2": "26",
                "latitude": "48.92263300",
                "longitude": "24.71111700",
                "type": "region",
                "cities": [
                    {
                        "id": 109397,
                        "name": "Bili Oslavy",
                        "latitude": "48.48722000",
                        "longitude": "24.70078000"
                    },
                    {
                        "id": 109405,
                        "name": "Bilshivtsi",
                        "latitude": "49.18333000",
                        "longitude": "24.75000000"
                    },
                    {
                        "id": 109420,
                        "name": "Bohorodchans’kyy Rayon",
                        "latitude": "48.72278000",
                        "longitude": "24.38042000"
                    },
                    {
                        "id": 109421,
                        "name": "Bohorodchany",
                        "latitude": "48.80700000",
                        "longitude": "24.53834000"
                    },
                    {
                        "id": 109423,
                        "name": "Bolekhiv",
                        "latitude": "49.06607000",
                        "longitude": "23.86435000"
                    },
                    {
                        "id": 109424,
                        "name": "Bolekhivs’ka Mis’krada",
                        "latitude": "49.06255000",
                        "longitude": "23.84339000"
                    },
                    {
                        "id": 109433,
                        "name": "Borshchevskiy Rayon",
                        "latitude": "48.75000000",
                        "longitude": "26.00000000"
                    },
                    {
                        "id": 109447,
                        "name": "Broshniv-Osada",
                        "latitude": "48.99621000",
                        "longitude": "24.19748000"
                    },
                    {
                        "id": 109461,
                        "name": "Burshtyn",
                        "latitude": "49.25867000",
                        "longitude": "24.62777000"
                    },
                    {
                        "id": 109462,
                        "name": "Burshtyns’ka Mis’krada",
                        "latitude": "49.25217000",
                        "longitude": "24.63320000"
                    },
                    {
                        "id": 109466,
                        "name": "Bystrytsya",
                        "latitude": "48.45931000",
                        "longitude": "24.24545000"
                    },
                    {
                        "id": 109467,
                        "name": "Bytkiv",
                        "latitude": "48.62968000",
                        "longitude": "24.47398000"
                    },
                    {
                        "id": 109478,
                        "name": "Chernelytsya",
                        "latitude": "48.81207000",
                        "longitude": "25.42477000"
                    },
                    {
                        "id": 109488,
                        "name": "Cherniyiv",
                        "latitude": "48.85658000",
                        "longitude": "24.71388000"
                    },
                    {
                        "id": 109496,
                        "name": "Chernyatyn",
                        "latitude": "48.66034000",
                        "longitude": "25.44832000"
                    },
                    {
                        "id": 109512,
                        "name": "Chornoliztsi",
                        "latitude": "48.83034000",
                        "longitude": "24.89576000"
                    },
                    {
                        "id": 109533,
                        "name": "Delyatyn",
                        "latitude": "48.52354000",
                        "longitude": "24.62466000"
                    },
                    {
                        "id": 109565,
                        "name": "Dolyna",
                        "latitude": "48.97330000",
                        "longitude": "24.00944000"
                    },
                    {
                        "id": 109567,
                        "name": "Dolyns’kyy Rayon",
                        "latitude": "48.89148000",
                        "longitude": "23.84343000"
                    },
                    {
                        "id": 109625,
                        "name": "Halych",
                        "latitude": "49.12179000",
                        "longitude": "24.72578000"
                    },
                    {
                        "id": 109626,
                        "name": "Halyts’kyy Rayon",
                        "latitude": "49.16169000",
                        "longitude": "24.71797000"
                    },
                    {
                        "id": 109643,
                        "name": "Horodenka",
                        "latitude": "48.67274000",
                        "longitude": "25.50163000"
                    },
                    {
                        "id": 109644,
                        "name": "Horodenkivs’kyy Rayon",
                        "latitude": "48.70617000",
                        "longitude": "25.42008000"
                    },
                    {
                        "id": 109665,
                        "name": "Hvizd",
                        "latitude": "48.68517000",
                        "longitude": "24.55055000"
                    },
                    {
                        "id": 109683,
                        "name": "Ivano-Frankivs’ka Mis’krada",
                        "latitude": "48.91177000",
                        "longitude": "24.72831000"
                    },
                    {
                        "id": 109682,
                        "name": "Ivano-Frankivsk",
                        "latitude": "48.92150000",
                        "longitude": "24.70972000"
                    },
                    {
                        "id": 109703,
                        "name": "Kalus’kyy Rayon",
                        "latitude": "49.06088000",
                        "longitude": "24.38766000"
                    },
                    {
                        "id": 109702,
                        "name": "Kalush",
                        "latitude": "49.01187000",
                        "longitude": "24.37308000"
                    },
                    {
                        "id": 109745,
                        "name": "Khymchyn",
                        "latitude": "48.38639000",
                        "longitude": "25.14803000"
                    },
                    {
                        "id": 109776,
                        "name": "Kolomyia",
                        "latitude": "48.53115000",
                        "longitude": "25.03649000"
                    },
                    {
                        "id": 109777,
                        "name": "Kolomyys’kyy Rayon",
                        "latitude": "48.58586000",
                        "longitude": "24.99300000"
                    },
                    {
                        "id": 109807,
                        "name": "Kosiv",
                        "latitude": "48.31071000",
                        "longitude": "25.09575000"
                    },
                    {
                        "id": 109808,
                        "name": "Kosivs’kyy Rayon",
                        "latitude": "48.32569000",
                        "longitude": "24.98641000"
                    },
                    {
                        "id": 109809,
                        "name": "Kosmach",
                        "latitude": "48.75089000",
                        "longitude": "24.36731000"
                    },
                    {
                        "id": 109829,
                        "name": "Krasna",
                        "latitude": "48.57571000",
                        "longitude": "24.70027000"
                    },
                    {
                        "id": 109894,
                        "name": "Kuty",
                        "latitude": "48.25868000",
                        "longitude": "25.17946000"
                    },
                    {
                        "id": 109903,
                        "name": "Lanchyn",
                        "latitude": "48.55781000",
                        "longitude": "24.75622000"
                    },
                    {
                        "id": 109996,
                        "name": "Manyava",
                        "latitude": "48.65541000",
                        "longitude": "24.37537000"
                    },
                    {
                        "id": 110002,
                        "name": "Markova",
                        "latitude": "48.67576000",
                        "longitude": "24.41382000"
                    },
                    {
                        "id": 110078,
                        "name": "Nadvirna",
                        "latitude": "48.63480000",
                        "longitude": "24.56936000"
                    },
                    {
                        "id": 110079,
                        "name": "Nadvirnyans’kyy Rayon",
                        "latitude": "48.55387000",
                        "longitude": "24.50381000"
                    },
                    {
                        "id": 110086,
                        "name": "Nebyliv",
                        "latitude": "48.81526000",
                        "longitude": "24.21657000"
                    },
                    {
                        "id": 110158,
                        "name": "Novytsya",
                        "latitude": "48.96345000",
                        "longitude": "24.33542000"
                    },
                    {
                        "id": 110170,
                        "name": "Obertyn",
                        "latitude": "48.70032000",
                        "longitude": "25.17012000"
                    },
                    {
                        "id": 110212,
                        "name": "Otyniya",
                        "latitude": "48.73767000",
                        "longitude": "24.86111000"
                    },
                    {
                        "id": 110229,
                        "name": "Pasichna",
                        "latitude": "48.57152000",
                        "longitude": "24.43003000"
                    },
                    {
                        "id": 110234,
                        "name": "Pechenizhyn",
                        "latitude": "48.51551000",
                        "longitude": "24.89423000"
                    },
                    {
                        "id": 110255,
                        "name": "Petranka",
                        "latitude": "48.90246000",
                        "longitude": "24.30347000"
                    },
                    {
                        "id": 110279,
                        "name": "Pniv",
                        "latitude": "48.61783000",
                        "longitude": "24.52872000"
                    },
                    {
                        "id": 110303,
                        "name": "Porohy",
                        "latitude": "48.68755000",
                        "longitude": "24.26322000"
                    },
                    {
                        "id": 110335,
                        "name": "Radcha",
                        "latitude": "48.85023000",
                        "longitude": "24.65502000"
                    },
                    {
                        "id": 110350,
                        "name": "Rechka",
                        "latitude": "48.28034000",
                        "longitude": "24.93330000"
                    },
                    {
                        "id": 110360,
                        "name": "Rohatyn",
                        "latitude": "49.40900000",
                        "longitude": "24.60927000"
                    },
                    {
                        "id": 110361,
                        "name": "Rohatyns’kyy Rayon",
                        "latitude": "49.38025000",
                        "longitude": "24.57111000"
                    },
                    {
                        "id": 110378,
                        "name": "Rozhniativ",
                        "latitude": "48.93576000",
                        "longitude": "24.16379000"
                    },
                    {
                        "id": 110379,
                        "name": "Rozhniv",
                        "latitude": "48.36597000",
                        "longitude": "25.22580000"
                    },
                    {
                        "id": 110380,
                        "name": "Rozhnyativs’kyy Rayon",
                        "latitude": "48.75890000",
                        "longitude": "24.07588000"
                    },
                    {
                        "id": 110400,
                        "name": "Sadzhavka",
                        "latitude": "48.56603000",
                        "longitude": "24.78820000"
                    },
                    {
                        "id": 110441,
                        "name": "Sheshory",
                        "latitude": "48.33197000",
                        "longitude": "24.98329000"
                    },
                    {
                        "id": 110491,
                        "name": "Sniatyn",
                        "latitude": "48.44692000",
                        "longitude": "25.56937000"
                    },
                    {
                        "id": 110495,
                        "name": "Snyatyns’kyy Rayon",
                        "latitude": "48.47674000",
                        "longitude": "25.41153000"
                    },
                    {
                        "id": 110512,
                        "name": "Solotvyn",
                        "latitude": "48.70212000",
                        "longitude": "24.42212000"
                    },
                    {
                        "id": 110520,
                        "name": "Spas",
                        "latitude": "48.88992000",
                        "longitude": "24.06293000"
                    },
                    {
                        "id": 110529,
                        "name": "Stari Bohorodchany",
                        "latitude": "48.83361000",
                        "longitude": "24.52430000"
                    },
                    {
                        "id": 110530,
                        "name": "Stari Kuty",
                        "latitude": "48.27093000",
                        "longitude": "25.17293000"
                    },
                    {
                        "id": 110551,
                        "name": "Stetseva",
                        "latitude": "48.52767000",
                        "longitude": "25.57572000"
                    },
                    {
                        "id": 110571,
                        "name": "Svarychiv",
                        "latitude": "48.96220000",
                        "longitude": "24.19658000"
                    },
                    {
                        "id": 110593,
                        "name": "Tatariv",
                        "latitude": "48.34558000",
                        "longitude": "24.57836000"
                    },
                    {
                        "id": 110608,
                        "name": "Tlumach",
                        "latitude": "48.86403000",
                        "longitude": "25.00325000"
                    },
                    {
                        "id": 110609,
                        "name": "Tlumats’kyy Rayon",
                        "latitude": "48.82924000",
                        "longitude": "25.09055000"
                    },
                    {
                        "id": 110644,
                        "name": "Tysmenychany",
                        "latitude": "48.77168000",
                        "longitude": "24.66626000"
                    },
                    {
                        "id": 110646,
                        "name": "Tysmenyts’kyy Rayon",
                        "latitude": "48.92246000",
                        "longitude": "24.74486000"
                    },
                    {
                        "id": 110645,
                        "name": "Tysmenytsya",
                        "latitude": "48.90219000",
                        "longitude": "24.84482000"
                    },
                    {
                        "id": 110650,
                        "name": "Uhryniv",
                        "latitude": "48.95520000",
                        "longitude": "24.69292000"
                    },
                    {
                        "id": 110697,
                        "name": "Velykyy Klyuchiv",
                        "latitude": "48.47092000",
                        "longitude": "24.94677000"
                    },
                    {
                        "id": 110707,
                        "name": "Verkhniy Yasenov",
                        "latitude": "48.16156000",
                        "longitude": "24.94532000"
                    },
                    {
                        "id": 110712,
                        "name": "Verkhovyna",
                        "latitude": "48.15571000",
                        "longitude": "24.79112000"
                    },
                    {
                        "id": 110741,
                        "name": "Vorokhta",
                        "latitude": "48.28459000",
                        "longitude": "24.56536000"
                    },
                    {
                        "id": 110770,
                        "name": "Yabluniv",
                        "latitude": "48.40418000",
                        "longitude": "24.93874000"
                    },
                    {
                        "id": 110771,
                        "name": "Yablunytsya",
                        "latitude": "48.31742000",
                        "longitude": "24.48448000"
                    },
                    {
                        "id": 110779,
                        "name": "Yamnytsya",
                        "latitude": "48.98972000",
                        "longitude": "24.70750000"
                    },
                    {
                        "id": 110783,
                        "name": "Yaremchans’ks Mis’krada",
                        "latitude": "48.33234000",
                        "longitude": "24.57426000"
                    },
                    {
                        "id": 110784,
                        "name": "Yaremche",
                        "latitude": "48.45157000",
                        "longitude": "24.55436000"
                    },
                    {
                        "id": 110806,
                        "name": "Zabolotiv",
                        "latitude": "48.47054000",
                        "longitude": "25.28571000"
                    },
                    {
                        "id": 110809,
                        "name": "Zahvizdya",
                        "latitude": "48.91836000",
                        "longitude": "24.65275000"
                    },
                    {
                        "id": 110823,
                        "name": "Zarichchya",
                        "latitude": "48.52144000",
                        "longitude": "24.64857000"
                    }
                ]
            },
            {
                "id": 4686,
                "name": "Kharkivska",
                "iso2": "63",
                "latitude": "49.99350000",
                "longitude": "36.23038300",
                "type": "region",
                "cities": [
                    {
                        "id": 109344,
                        "name": "Balakliya",
                        "latitude": "49.46270000",
                        "longitude": "36.85951000"
                    },
                    {
                        "id": 109352,
                        "name": "Barvinkove",
                        "latitude": "48.90970000",
                        "longitude": "37.02051000"
                    },
                    {
                        "id": 109380,
                        "name": "Berezivka",
                        "latitude": "49.43935000",
                        "longitude": "35.70736000"
                    },
                    {
                        "id": 109390,
                        "name": "Bezlyudivka",
                        "latitude": "49.87547000",
                        "longitude": "36.26539000"
                    },
                    {
                        "id": 109413,
                        "name": "Blyznyuky",
                        "latitude": "48.85775000",
                        "longitude": "36.55505000"
                    },
                    {
                        "id": 109419,
                        "name": "Bohodukhiv",
                        "latitude": "50.16466000",
                        "longitude": "35.52765000"
                    },
                    {
                        "id": 109432,
                        "name": "Borova",
                        "latitude": "49.37770000",
                        "longitude": "37.62136000"
                    },
                    {
                        "id": 109458,
                        "name": "Budy",
                        "latitude": "49.89133000",
                        "longitude": "36.02096000"
                    },
                    {
                        "id": 109469,
                        "name": "Chapayeve",
                        "latitude": "49.36625000",
                        "longitude": "35.87486000"
                    },
                    {
                        "id": 109504,
                        "name": "Chervonyy Oskil",
                        "latitude": "49.17906000",
                        "longitude": "37.42593000"
                    },
                    {
                        "id": 109522,
                        "name": "Chuhuyiv",
                        "latitude": "49.83588000",
                        "longitude": "36.68803000"
                    },
                    {
                        "id": 109539,
                        "name": "Derhachi",
                        "latitude": "50.10659000",
                        "longitude": "36.12112000"
                    },
                    {
                        "id": 109590,
                        "name": "Dvorichna",
                        "latitude": "49.85019000",
                        "longitude": "37.68262000"
                    },
                    {
                        "id": 109596,
                        "name": "Eskhar",
                        "latitude": "49.79614000",
                        "longitude": "36.59047000"
                    },
                    {
                        "id": 109663,
                        "name": "Huty",
                        "latitude": "50.13322000",
                        "longitude": "35.34394000"
                    },
                    {
                        "id": 109691,
                        "name": "Izyum",
                        "latitude": "49.20875000",
                        "longitude": "37.24849000"
                    },
                    {
                        "id": 109724,
                        "name": "Kehychivka",
                        "latitude": "49.28656000",
                        "longitude": "35.76153000"
                    },
                    {
                        "id": 109727,
                        "name": "Kharkiv",
                        "latitude": "49.98081000",
                        "longitude": "36.25272000"
                    },
                    {
                        "id": 109736,
                        "name": "Khorosheve",
                        "latitude": "49.85413000",
                        "longitude": "36.21704000"
                    },
                    {
                        "id": 109757,
                        "name": "Kivsharivka",
                        "latitude": "49.63096000",
                        "longitude": "37.68821000"
                    },
                    {
                        "id": 109767,
                        "name": "Kochetok",
                        "latitude": "49.88005000",
                        "longitude": "36.73723000"
                    },
                    {
                        "id": 109775,
                        "name": "Kolomak",
                        "latitude": "49.83987000",
                        "longitude": "35.30441000"
                    },
                    {
                        "id": 109804,
                        "name": "Korotych",
                        "latitude": "49.94737000",
                        "longitude": "36.03736000"
                    },
                    {
                        "id": 109838,
                        "name": "Krasnohrad",
                        "latitude": "49.38009000",
                        "longitude": "35.44186000"
                    },
                    {
                        "id": 109841,
                        "name": "Krasnokuts’k",
                        "latitude": "50.06602000",
                        "longitude": "35.16275000"
                    },
                    {
                        "id": 109843,
                        "name": "Krasnopavlivka",
                        "latitude": "49.13643000",
                        "longitude": "36.31911000"
                    },
                    {
                        "id": 109886,
                        "name": "Kulynychi",
                        "latitude": "49.98178000",
                        "longitude": "36.38283000"
                    },
                    {
                        "id": 109887,
                        "name": "Kupjansk",
                        "latitude": "49.71055000",
                        "longitude": "37.61517000"
                    },
                    {
                        "id": 109932,
                        "name": "Lozova",
                        "latitude": "48.88937000",
                        "longitude": "36.31755000"
                    },
                    {
                        "id": 109951,
                        "name": "Lyman",
                        "latitude": "49.59769000",
                        "longitude": "36.47030000"
                    },
                    {
                        "id": 109966,
                        "name": "Lyubotyn",
                        "latitude": "49.94691000",
                        "longitude": "35.92907000"
                    },
                    {
                        "id": 109979,
                        "name": "Mala Danylivka",
                        "latitude": "50.06354000",
                        "longitude": "36.16564000"
                    },
                    {
                        "id": 109990,
                        "name": "Malynivka",
                        "latitude": "49.81667000",
                        "longitude": "36.73333000"
                    },
                    {
                        "id": 109991,
                        "name": "Manchenky",
                        "latitude": "49.97982000",
                        "longitude": "35.85835000"
                    },
                    {
                        "id": 110023,
                        "name": "Merefa",
                        "latitude": "49.82302000",
                        "longitude": "36.05069000"
                    },
                    {
                        "id": 110110,
                        "name": "Nova Vodolaha",
                        "latitude": "49.71901000",
                        "longitude": "35.86578000"
                    },
                    {
                        "id": 110141,
                        "name": "Novopokrovka",
                        "latitude": "49.83349000",
                        "longitude": "36.54771000"
                    },
                    {
                        "id": 110222,
                        "name": "Panyutyne",
                        "latitude": "48.93692000",
                        "longitude": "36.27563000"
                    },
                    {
                        "id": 110242,
                        "name": "Peresichna",
                        "latitude": "50.02452000",
                        "longitude": "35.97871000"
                    },
                    {
                        "id": 110247,
                        "name": "Pervomaiskyi Raion",
                        "latitude": "49.41667000",
                        "longitude": "36.33333000"
                    },
                    {
                        "id": 110252,
                        "name": "Pervomays’kyy",
                        "latitude": "49.38742000",
                        "longitude": "36.21471000"
                    },
                    {
                        "id": 110257,
                        "name": "Petrivs’ke",
                        "latitude": "49.17695000",
                        "longitude": "36.89999000"
                    },
                    {
                        "id": 110275,
                        "name": "Pivdenne",
                        "latitude": "49.88315000",
                        "longitude": "36.06785000"
                    },
                    {
                        "id": 110290,
                        "name": "Pokotylivka",
                        "latitude": "49.91343000",
                        "longitude": "36.17511000"
                    },
                    {
                        "id": 110317,
                        "name": "Prudyanka",
                        "latitude": "50.23606000",
                        "longitude": "36.16835000"
                    },
                    {
                        "id": 110319,
                        "name": "Prykolotne",
                        "latitude": "50.16273000",
                        "longitude": "37.34524000"
                    },
                    {
                        "id": 110401,
                        "name": "Sakhnovshchyna",
                        "latitude": "49.15166000",
                        "longitude": "35.87198000"
                    },
                    {
                        "id": 110411,
                        "name": "Savyntsi",
                        "latitude": "49.40257000",
                        "longitude": "37.06266000"
                    },
                    {
                        "id": 110445,
                        "name": "Shevchenkove",
                        "latitude": "49.69585000",
                        "longitude": "37.17348000"
                    },
                    {
                        "id": 110476,
                        "name": "Slatyne",
                        "latitude": "50.21041000",
                        "longitude": "36.15376000"
                    },
                    {
                        "id": 110484,
                        "name": "Slobozhans’ke",
                        "latitude": "49.59701000",
                        "longitude": "36.52618000"
                    },
                    {
                        "id": 110511,
                        "name": "Solonytsivka",
                        "latitude": "49.99682000",
                        "longitude": "36.03464000"
                    },
                    {
                        "id": 110540,
                        "name": "Staryy Merchyk",
                        "latitude": "49.98147000",
                        "longitude": "35.75904000"
                    },
                    {
                        "id": 110541,
                        "name": "Staryy Saltiv",
                        "latitude": "50.07619000",
                        "longitude": "36.78852000"
                    },
                    {
                        "id": 110558,
                        "name": "Studenok",
                        "latitude": "49.09107000",
                        "longitude": "37.48697000"
                    },
                    {
                        "id": 110663,
                        "name": "Utkivka",
                        "latitude": "49.78583000",
                        "longitude": "36.07528000"
                    },
                    {
                        "id": 110670,
                        "name": "Valky",
                        "latitude": "49.83597000",
                        "longitude": "35.61223000"
                    },
                    {
                        "id": 110680,
                        "name": "Vasyshcheve",
                        "latitude": "49.82852000",
                        "longitude": "36.32691000"
                    },
                    {
                        "id": 110696,
                        "name": "Velykyy Burluk",
                        "latitude": "50.06170000",
                        "longitude": "37.38373000"
                    },
                    {
                        "id": 110699,
                        "name": "Verbivka",
                        "latitude": "49.41667000",
                        "longitude": "35.53333000"
                    },
                    {
                        "id": 110747,
                        "name": "Vovchans’k",
                        "latitude": "50.29078000",
                        "longitude": "36.94108000"
                    },
                    {
                        "id": 110754,
                        "name": "Vvedenka",
                        "latitude": "49.82372000",
                        "longitude": "36.50264000"
                    },
                    {
                        "id": 110768,
                        "name": "Vysokyy",
                        "latitude": "49.89156000",
                        "longitude": "36.12175000"
                    },
                    {
                        "id": 110807,
                        "name": "Zachepylivka",
                        "latitude": "49.19385000",
                        "longitude": "35.23943000"
                    },
                    {
                        "id": 110857,
                        "name": "Zmiyiv",
                        "latitude": "49.67453000",
                        "longitude": "36.34775000"
                    },
                    {
                        "id": 110859,
                        "name": "Zolochiv",
                        "latitude": "50.27985000",
                        "longitude": "35.98179000"
                    }
                ]
            },
            {
                "id": 4684,
                "name": "Khersonska",
                "iso2": "65",
                "latitude": "46.63541700",
                "longitude": "32.61686700",
                "type": "region",
                "cities": [
                    {
                        "id": 109331,
                        "name": "Askaniya-Nova",
                        "latitude": "46.45135000",
                        "longitude": "33.86889000"
                    },
                    {
                        "id": 109361,
                        "name": "Bekhtery",
                        "latitude": "46.24790000",
                        "longitude": "32.29123000"
                    },
                    {
                        "id": 109388,
                        "name": "Beryslav",
                        "latitude": "46.84152000",
                        "longitude": "33.42838000"
                    },
                    {
                        "id": 109404,
                        "name": "Bilozerka",
                        "latitude": "46.62480000",
                        "longitude": "32.44251000"
                    },
                    {
                        "id": 109454,
                        "name": "Brylivka",
                        "latitude": "46.42476000",
                        "longitude": "33.14721000"
                    },
                    {
                        "id": 109472,
                        "name": "Chaplynka",
                        "latitude": "46.36507000",
                        "longitude": "33.54027000"
                    },
                    {
                        "id": 109511,
                        "name": "Chornobayivka",
                        "latitude": "46.69411000",
                        "longitude": "32.55371000"
                    },
                    {
                        "id": 109516,
                        "name": "Chornyanka",
                        "latitude": "46.65222000",
                        "longitude": "33.35904000"
                    },
                    {
                        "id": 109523,
                        "name": "Chulakivka",
                        "latitude": "46.35763000",
                        "longitude": "32.35140000"
                    },
                    {
                        "id": 109554,
                        "name": "Dnipryany",
                        "latitude": "46.74631000",
                        "longitude": "33.27288000"
                    },
                    {
                        "id": 109587,
                        "name": "Dudchany",
                        "latitude": "47.18557000",
                        "longitude": "33.76390000"
                    },
                    {
                        "id": 109628,
                        "name": "Heniches’k",
                        "latitude": "46.17592000",
                        "longitude": "34.80340000"
                    },
                    {
                        "id": 109629,
                        "name": "Heniches’kyy Rayon",
                        "latitude": "46.26451000",
                        "longitude": "34.74488000"
                    },
                    {
                        "id": 109636,
                        "name": "Hola Prystan’",
                        "latitude": "46.52719000",
                        "longitude": "32.52417000"
                    },
                    {
                        "id": 109642,
                        "name": "Hornostayivka",
                        "latitude": "47.00777000",
                        "longitude": "33.72899000"
                    },
                    {
                        "id": 109679,
                        "name": "Ivanivka",
                        "latitude": "46.72082000",
                        "longitude": "34.55298000"
                    },
                    {
                        "id": 109697,
                        "name": "Kakhovka",
                        "latitude": "46.81371000",
                        "longitude": "33.48698000"
                    },
                    {
                        "id": 109698,
                        "name": "Kalanchak",
                        "latitude": "46.25623000",
                        "longitude": "33.29070000"
                    },
                    {
                        "id": 109722,
                        "name": "Kayiry",
                        "latitude": "46.94537000",
                        "longitude": "33.70591000"
                    },
                    {
                        "id": 109729,
                        "name": "Kherson",
                        "latitude": "46.65581000",
                        "longitude": "32.61780000"
                    },
                    {
                        "id": 109786,
                        "name": "Komyshany",
                        "latitude": "46.63716000",
                        "longitude": "32.50719000"
                    },
                    {
                        "id": 109823,
                        "name": "Kozachi Laheri",
                        "latitude": "46.70372000",
                        "longitude": "32.97760000"
                    },
                    {
                        "id": 109833,
                        "name": "Krasne",
                        "latitude": "46.13088000",
                        "longitude": "32.76910000"
                    },
                    {
                        "id": 109907,
                        "name": "Lazurne",
                        "latitude": "46.08400000",
                        "longitude": "32.52955000"
                    },
                    {
                        "id": 109967,
                        "name": "Lyubymivka",
                        "latitude": "46.81063000",
                        "longitude": "33.56862000"
                    },
                    {
                        "id": 109983,
                        "name": "Malokakhovka",
                        "latitude": "46.78142000",
                        "longitude": "33.44790000"
                    },
                    {
                        "id": 110104,
                        "name": "Nova Kakhovka",
                        "latitude": "46.75451000",
                        "longitude": "33.34864000"
                    },
                    {
                        "id": 110105,
                        "name": "Nova Mayachka",
                        "latitude": "46.59996000",
                        "longitude": "33.22707000"
                    },
                    {
                        "id": 110125,
                        "name": "Novofedorivka",
                        "latitude": "46.17128000",
                        "longitude": "32.31781000"
                    },
                    {
                        "id": 110137,
                        "name": "Novooleksiyivka",
                        "latitude": "46.22472000",
                        "longitude": "34.64031000"
                    },
                    {
                        "id": 110153,
                        "name": "Novovorontsovka",
                        "latitude": "47.50035000",
                        "longitude": "33.91748000"
                    },
                    {
                        "id": 110165,
                        "name": "Nyzhni Sirohozy",
                        "latitude": "46.84842000",
                        "longitude": "34.38044000"
                    },
                    {
                        "id": 110227,
                        "name": "Partyzany",
                        "latitude": "46.33383000",
                        "longitude": "34.75314000"
                    },
                    {
                        "id": 110336,
                        "name": "Radens’k",
                        "latitude": "46.54860000",
                        "longitude": "32.92787000"
                    },
                    {
                        "id": 110466,
                        "name": "Skadovs’k",
                        "latitude": "46.11610000",
                        "longitude": "32.91124000"
                    },
                    {
                        "id": 110525,
                        "name": "Stanislav",
                        "latitude": "46.56909000",
                        "longitude": "32.14777000"
                    },
                    {
                        "id": 110634,
                        "name": "Tsyurupyns’k",
                        "latitude": "46.61842000",
                        "longitude": "32.71890000"
                    },
                    {
                        "id": 110685,
                        "name": "Velyka Lepetykha",
                        "latitude": "47.17572000",
                        "longitude": "33.94362000"
                    },
                    {
                        "id": 110687,
                        "name": "Velyka Oleksandrivka",
                        "latitude": "47.31969000",
                        "longitude": "33.30373000"
                    },
                    {
                        "id": 110690,
                        "name": "Velyki Kopani",
                        "latitude": "46.48684000",
                        "longitude": "32.97498000"
                    },
                    {
                        "id": 110706,
                        "name": "Verkhniy Rohachyk",
                        "latitude": "47.25053000",
                        "longitude": "34.33797000"
                    },
                    {
                        "id": 110760,
                        "name": "Vynohradove",
                        "latitude": "46.36957000",
                        "longitude": "32.93980000"
                    },
                    {
                        "id": 110767,
                        "name": "Vysokopillya",
                        "latitude": "47.49187000",
                        "longitude": "33.53061000"
                    },
                    {
                        "id": 110817,
                        "name": "Zaliznyy Port",
                        "latitude": "46.12337000",
                        "longitude": "32.29892000"
                    }
                ]
            },
            {
                "id": 4681,
                "name": "Khmelnytska",
                "iso2": "68",
                "latitude": "49.42298300",
                "longitude": "26.98713310",
                "type": "region",
                "cities": [
                    {
                        "id": 109322,
                        "name": "Antoniny",
                        "latitude": "49.80974000",
                        "longitude": "26.87714000"
                    },
                    {
                        "id": 109360,
                        "name": "Bazaliya",
                        "latitude": "49.71267000",
                        "longitude": "26.47331000"
                    },
                    {
                        "id": 109537,
                        "name": "Derazhnya",
                        "latitude": "49.26920000",
                        "longitude": "27.43382000"
                    },
                    {
                        "id": 109538,
                        "name": "Derazhnyans’kyy Rayon",
                        "latitude": "49.22676000",
                        "longitude": "27.46603000"
                    },
                    {
                        "id": 109589,
                        "name": "Dunaivtsi",
                        "latitude": "48.88909000",
                        "longitude": "26.85636000"
                    },
                    {
                        "id": 109650,
                        "name": "Horodok",
                        "latitude": "49.16374000",
                        "longitude": "26.58394000"
                    },
                    {
                        "id": 109690,
                        "name": "Izyaslav",
                        "latitude": "50.11947000",
                        "longitude": "26.82125000"
                    },
                    {
                        "id": 109708,
                        "name": "Kamianets-Podilskyi",
                        "latitude": "48.68450000",
                        "longitude": "26.58559000"
                    },
                    {
                        "id": 109731,
                        "name": "Khmel’nyts’kyy Rayon",
                        "latitude": "49.44511000",
                        "longitude": "26.93268000"
                    },
                    {
                        "id": 109730,
                        "name": "Khmelnytskyi",
                        "latitude": "49.42161000",
                        "longitude": "26.99653000"
                    },
                    {
                        "id": 109856,
                        "name": "Krasyliv",
                        "latitude": "49.65186000",
                        "longitude": "26.97253000"
                    },
                    {
                        "id": 109916,
                        "name": "Letychiv",
                        "latitude": "49.38263000",
                        "longitude": "27.63051000"
                    },
                    {
                        "id": 109975,
                        "name": "Makiv",
                        "latitude": "48.79487000",
                        "longitude": "26.69188000"
                    },
                    {
                        "id": 110015,
                        "name": "Medzhybizh",
                        "latitude": "49.43748000",
                        "longitude": "27.40487000"
                    },
                    {
                        "id": 110080,
                        "name": "Narkevychi",
                        "latitude": "49.51717000",
                        "longitude": "26.64178000"
                    },
                    {
                        "id": 110093,
                        "name": "Netishyn",
                        "latitude": "50.34004000",
                        "longitude": "26.64171000"
                    },
                    {
                        "id": 110109,
                        "name": "Nova Ushytsya",
                        "latitude": "48.83716000",
                        "longitude": "27.27434000"
                    },
                    {
                        "id": 110146,
                        "name": "Novoselytsya",
                        "latitude": "50.07030000",
                        "longitude": "27.51955000"
                    },
                    {
                        "id": 110294,
                        "name": "Polonne",
                        "latitude": "50.12424000",
                        "longitude": "27.51087000"
                    },
                    {
                        "id": 110299,
                        "name": "Poninka",
                        "latitude": "50.18492000",
                        "longitude": "27.53629000"
                    },
                    {
                        "id": 110440,
                        "name": "Shepetivka",
                        "latitude": "50.18545000",
                        "longitude": "27.06365000"
                    },
                    {
                        "id": 110479,
                        "name": "Slavuta",
                        "latitude": "50.30155000",
                        "longitude": "26.86506000"
                    },
                    {
                        "id": 110489,
                        "name": "Smotrych",
                        "latitude": "48.66149000",
                        "longitude": "26.56031000"
                    },
                    {
                        "id": 110490,
                        "name": "Smyga",
                        "latitude": "50.23910000",
                        "longitude": "25.76575000"
                    },
                    {
                        "id": 110527,
                        "name": "Stara Syniava",
                        "latitude": "49.60318000",
                        "longitude": "27.61909000"
                    },
                    {
                        "id": 110533,
                        "name": "Starokostiantyniv",
                        "latitude": "49.75764000",
                        "longitude": "27.20342000"
                    },
                    {
                        "id": 110787,
                        "name": "Yarmolyntsi",
                        "latitude": "49.19236000",
                        "longitude": "26.83725000"
                    },
                    {
                        "id": 110811,
                        "name": "Zakupne",
                        "latitude": "49.11944000",
                        "longitude": "26.33756000"
                    },
                    {
                        "id": 110851,
                        "name": "Zhvanets",
                        "latitude": "48.54968000",
                        "longitude": "26.48744000"
                    }
                ]
            },
            {
                "id": 4677,
                "name": "Kirovohradska",
                "iso2": "35",
                "latitude": "48.50793300",
                "longitude": "32.26231700",
                "type": "region",
                "cities": [
                    {
                        "id": 109307,
                        "name": "Adzhamka",
                        "latitude": "48.54245000",
                        "longitude": "32.53542000"
                    },
                    {
                        "id": 109411,
                        "name": "Blahovishchenske Raion",
                        "latitude": "48.25000000",
                        "longitude": "30.25000000"
                    },
                    {
                        "id": 109416,
                        "name": "Bobrynets",
                        "latitude": "48.05896000",
                        "longitude": "32.16641000"
                    },
                    {
                        "id": 109544,
                        "name": "Dmytrivka",
                        "latitude": "48.79690000",
                        "longitude": "32.71645000"
                    },
                    {
                        "id": 109558,
                        "name": "Dobrovelychkivka",
                        "latitude": "48.38778000",
                        "longitude": "31.18028000"
                    },
                    {
                        "id": 109559,
                        "name": "Dobrovelychkivs’kyy Rayon",
                        "latitude": "48.36935000",
                        "longitude": "31.16354000"
                    },
                    {
                        "id": 109566,
                        "name": "Dolyns'ka",
                        "latitude": "48.11041000",
                        "longitude": "32.76449000"
                    },
                    {
                        "id": 109568,
                        "name": "Dolyns’kyy Rayon",
                        "latitude": "48.16327000",
                        "longitude": "32.88318000"
                    },
                    {
                        "id": 109627,
                        "name": "Hayvoron",
                        "latitude": "48.33958000",
                        "longitude": "29.86791000"
                    },
                    {
                        "id": 109715,
                        "name": "Kapitanivka",
                        "latitude": "48.91719000",
                        "longitude": "31.71671000"
                    },
                    {
                        "id": 109751,
                        "name": "Kirovohrads’ka Mis’krada",
                        "latitude": "48.52185000",
                        "longitude": "32.24367000"
                    },
                    {
                        "id": 109783,
                        "name": "Kompaniyivka",
                        "latitude": "48.25115000",
                        "longitude": "32.20795000"
                    },
                    {
                        "id": 109867,
                        "name": "Kropyvnytskyi",
                        "latitude": "48.51320000",
                        "longitude": "32.25970000"
                    },
                    {
                        "id": 109934,
                        "name": "Lozuvatka",
                        "latitude": "48.05710000",
                        "longitude": "33.28581000"
                    },
                    {
                        "id": 109955,
                        "name": "Lypnyazhka",
                        "latitude": "48.44694000",
                        "longitude": "31.07611000"
                    },
                    {
                        "id": 109981,
                        "name": "Mala Vyska",
                        "latitude": "48.64308000",
                        "longitude": "31.63657000"
                    },
                    {
                        "id": 109986,
                        "name": "Malovyskivs’kyy Rayon",
                        "latitude": "48.57680000",
                        "longitude": "31.57594000"
                    },
                    {
                        "id": 110048,
                        "name": "Molodizhne",
                        "latitude": "48.17732000",
                        "longitude": "32.66015000"
                    },
                    {
                        "id": 110107,
                        "name": "Nova Praha",
                        "latitude": "48.56821000",
                        "longitude": "32.90273000"
                    },
                    {
                        "id": 110114,
                        "name": "Novhorodka",
                        "latitude": "48.36506000",
                        "longitude": "32.65785000"
                    },
                    {
                        "id": 110119,
                        "name": "Novoarkhanhel’s’k",
                        "latitude": "48.65803000",
                        "longitude": "30.81821000"
                    },
                    {
                        "id": 110135,
                        "name": "Novomyrhorod",
                        "latitude": "48.78105000",
                        "longitude": "31.64204000"
                    },
                    {
                        "id": 110150,
                        "name": "Novoukrayinka",
                        "latitude": "48.32635000",
                        "longitude": "31.52852000"
                    },
                    {
                        "id": 110160,
                        "name": "Novyy Starodub",
                        "latitude": "48.51580000",
                        "longitude": "33.17329000"
                    },
                    {
                        "id": 110186,
                        "name": "Oleksandrivka",
                        "latitude": "48.96336000",
                        "longitude": "32.23492000"
                    },
                    {
                        "id": 110189,
                        "name": "Oleksandriya",
                        "latitude": "48.66961000",
                        "longitude": "33.11593000"
                    },
                    {
                        "id": 110190,
                        "name": "Oleksandriys’ke",
                        "latitude": "48.60767000",
                        "longitude": "32.98347000"
                    },
                    {
                        "id": 110198,
                        "name": "Onufriyivka",
                        "latitude": "48.90716000",
                        "longitude": "33.44869000"
                    },
                    {
                        "id": 110221,
                        "name": "Pantayivka",
                        "latitude": "48.67400000",
                        "longitude": "32.88410000"
                    },
                    {
                        "id": 110233,
                        "name": "Pavlysh",
                        "latitude": "48.91762000",
                        "longitude": "33.35691000"
                    },
                    {
                        "id": 110238,
                        "name": "Perehonivka",
                        "latitude": "48.53552000",
                        "longitude": "30.51923000"
                    },
                    {
                        "id": 110259,
                        "name": "Petrove",
                        "latitude": "48.32467000",
                        "longitude": "33.25617000"
                    },
                    {
                        "id": 110281,
                        "name": "Pobugskoye",
                        "latitude": "48.16579000",
                        "longitude": "30.59274000"
                    },
                    {
                        "id": 110297,
                        "name": "Pomichna",
                        "latitude": "48.24222000",
                        "longitude": "31.41583000"
                    },
                    {
                        "id": 110325,
                        "name": "Pryyutivka",
                        "latitude": "48.72094000",
                        "longitude": "33.07078000"
                    },
                    {
                        "id": 110355,
                        "name": "Rivne",
                        "latitude": "48.24742000",
                        "longitude": "31.75432000"
                    },
                    {
                        "id": 110559,
                        "name": "Subottsi",
                        "latitude": "48.65545000",
                        "longitude": "32.52093000"
                    },
                    {
                        "id": 110577,
                        "name": "Svitlovods’k",
                        "latitude": "49.04894000",
                        "longitude": "33.24106000"
                    },
                    {
                        "id": 110643,
                        "name": "Tyshkivka",
                        "latitude": "48.49665000",
                        "longitude": "30.94229000"
                    },
                    {
                        "id": 110662,
                        "name": "Ustynivka",
                        "latitude": "47.95507000",
                        "longitude": "32.53674000"
                    },
                    {
                        "id": 110793,
                        "name": "Yelyzavethradka",
                        "latitude": "48.80381000",
                        "longitude": "32.40460000"
                    },
                    {
                        "id": 110828,
                        "name": "Zavallya",
                        "latitude": "48.21354000",
                        "longitude": "30.01558000"
                    },
                    {
                        "id": 110856,
                        "name": "Zlynka",
                        "latitude": "48.48521000",
                        "longitude": "31.53906000"
                    },
                    {
                        "id": 110858,
                        "name": "Znomenka",
                        "latitude": "48.71278000",
                        "longitude": "32.66472000"
                    }
                ]
            },
            {
                "id": 4676,
                "name": "Kyiv",
                "iso2": "30",
                "latitude": "50.45010000",
                "longitude": "30.52340000",
                "type": "city",
                "cities": [
                    {
                        "id": 109529,
                        "name": "Darnytsia Raion",
                        "latitude": "50.41333000",
                        "longitude": "30.69305000"
                    },
                    {
                        "id": 109541,
                        "name": "Desnyans’kyy Rayon",
                        "latitude": "50.53550000",
                        "longitude": "30.60875000"
                    },
                    {
                        "id": 109550,
                        "name": "Dnipro Raion",
                        "latitude": "50.46756000",
                        "longitude": "30.63194000"
                    },
                    {
                        "id": 109637,
                        "name": "Holosiiv Raion",
                        "latitude": "50.32749000",
                        "longitude": "30.56740000"
                    },
                    {
                        "id": 109819,
                        "name": "Kotsyubyns’ke",
                        "latitude": "50.48836000",
                        "longitude": "30.32957000"
                    },
                    {
                        "id": 109897,
                        "name": "Kyiv",
                        "latitude": "50.45466000",
                        "longitude": "30.52380000"
                    },
                    {
                        "id": 110235,
                        "name": "Pechersk Raion",
                        "latitude": "50.41902000",
                        "longitude": "30.56602000"
                    },
                    {
                        "id": 110286,
                        "name": "Podil’s’kyy Rayon",
                        "latitude": "50.45000000",
                        "longitude": "30.53333000"
                    },
                    {
                        "id": 110313,
                        "name": "Prolisky",
                        "latitude": "50.39118000",
                        "longitude": "30.78000000"
                    },
                    {
                        "id": 110442,
                        "name": "Shevchenkivs’kyy Rayon",
                        "latitude": "50.43333000",
                        "longitude": "30.51667000"
                    },
                    {
                        "id": 110507,
                        "name": "Solomianka Rayon",
                        "latitude": "50.42886000",
                        "longitude": "30.45135000"
                    },
                    {
                        "id": 110580,
                        "name": "Svyatoshyns’kyy Rayon",
                        "latitude": "50.48533000",
                        "longitude": "30.38050000"
                    }
                ]
            },
            {
                "id": 4671,
                "name": "Kyivska",
                "iso2": "32",
                "latitude": "50.05295060",
                "longitude": "30.76671340",
                "type": "region",
                "cities": [
                    {
                        "id": 109353,
                        "name": "Baryshivka",
                        "latitude": "50.36098000",
                        "longitude": "31.32173000"
                    },
                    {
                        "id": 109354,
                        "name": "Baryshivs’kyy Rayon",
                        "latitude": "50.36919000",
                        "longitude": "31.34896000"
                    },
                    {
                        "id": 109393,
                        "name": "Bila Tserkva",
                        "latitude": "49.80939000",
                        "longitude": "30.11209000"
                    },
                    {
                        "id": 109394,
                        "name": "Bila Tserkva Raion",
                        "latitude": "49.75000000",
                        "longitude": "30.08333000"
                    },
                    {
                        "id": 109422,
                        "name": "Bohuslav",
                        "latitude": "49.54939000",
                        "longitude": "30.87440000"
                    },
                    {
                        "id": 109426,
                        "name": "Borispol’skiy Rayon",
                        "latitude": "50.33450000",
                        "longitude": "31.02470000"
                    },
                    {
                        "id": 109427,
                        "name": "Borodianka",
                        "latitude": "50.64484000",
                        "longitude": "29.92010000"
                    },
                    {
                        "id": 109429,
                        "name": "Borodyans’kyy Rayon",
                        "latitude": "50.65889000",
                        "longitude": "29.88556000"
                    },
                    {
                        "id": 109431,
                        "name": "Borova",
                        "latitude": "50.17625000",
                        "longitude": "30.10429000"
                    },
                    {
                        "id": 109436,
                        "name": "Boryspil’",
                        "latitude": "50.35269000",
                        "longitude": "30.95501000"
                    },
                    {
                        "id": 109440,
                        "name": "Boyarka",
                        "latitude": "50.31911000",
                        "longitude": "30.29728000"
                    },
                    {
                        "id": 109449,
                        "name": "Brovary",
                        "latitude": "50.51809000",
                        "longitude": "30.80671000"
                    },
                    {
                        "id": 109450,
                        "name": "Brovary Raion",
                        "latitude": "50.58333000",
                        "longitude": "31.00000000"
                    },
                    {
                        "id": 109456,
                        "name": "Bucha",
                        "latitude": "50.54345000",
                        "longitude": "30.21201000"
                    },
                    {
                        "id": 109468,
                        "name": "Chabany",
                        "latitude": "50.34071000",
                        "longitude": "30.42356000"
                    },
                    {
                        "id": 109494,
                        "name": "Chernyakhivka",
                        "latitude": "50.21882000",
                        "longitude": "31.93082000"
                    },
                    {
                        "id": 109591,
                        "name": "Dymer",
                        "latitude": "50.78647000",
                        "longitude": "30.30260000"
                    },
                    {
                        "id": 109597,
                        "name": "Fastiv",
                        "latitude": "50.07670000",
                        "longitude": "29.91770000"
                    },
                    {
                        "id": 109598,
                        "name": "Fastiv Raion",
                        "latitude": "50.08333000",
                        "longitude": "30.00000000"
                    },
                    {
                        "id": 109631,
                        "name": "Hlevakha",
                        "latitude": "50.27423000",
                        "longitude": "30.32706000"
                    },
                    {
                        "id": 109635,
                        "name": "Hnidyn",
                        "latitude": "50.32899000",
                        "longitude": "30.71059000"
                    },
                    {
                        "id": 109639,
                        "name": "Horenka",
                        "latitude": "50.55731000",
                        "longitude": "30.33217000"
                    },
                    {
                        "id": 109655,
                        "name": "Hostomel",
                        "latitude": "50.56841000",
                        "longitude": "30.26510000"
                    },
                    {
                        "id": 109672,
                        "name": "Irpin",
                        "latitude": "50.52175000",
                        "longitude": "30.25055000"
                    },
                    {
                        "id": 109673,
                        "name": "Irpins’ka Mis’krada",
                        "latitude": "50.51585000",
                        "longitude": "30.24099000"
                    },
                    {
                        "id": 109680,
                        "name": "Ivankiv",
                        "latitude": "50.93865000",
                        "longitude": "29.89426000"
                    },
                    {
                        "id": 109681,
                        "name": "Ivankiv Raion",
                        "latitude": "51.00000000",
                        "longitude": "29.91667000"
                    },
                    {
                        "id": 109695,
                        "name": "Kaharlyk",
                        "latitude": "49.86233000",
                        "longitude": "30.82815000"
                    },
                    {
                        "id": 109696,
                        "name": "Kaharlyk Raion",
                        "latitude": "49.91667000",
                        "longitude": "30.75000000"
                    },
                    {
                        "id": 109705,
                        "name": "Kalynove",
                        "latitude": "49.38179000",
                        "longitude": "30.45137000"
                    },
                    {
                        "id": 109716,
                        "name": "Karapyshi",
                        "latitude": "49.64237000",
                        "longitude": "30.79002000"
                    },
                    {
                        "id": 109720,
                        "name": "Katyuzhanka",
                        "latitude": "50.80595000",
                        "longitude": "30.13763000"
                    },
                    {
                        "id": 109739,
                        "name": "Khotiv",
                        "latitude": "50.33069000",
                        "longitude": "30.46836000"
                    },
                    {
                        "id": 109749,
                        "name": "Kirove",
                        "latitude": "50.36890000",
                        "longitude": "31.12066000"
                    },
                    {
                        "id": 109758,
                        "name": "Klavdiyevo-Tarasove",
                        "latitude": "50.58416000",
                        "longitude": "30.01134000"
                    },
                    {
                        "id": 109764,
                        "name": "Knyazhichi",
                        "latitude": "50.46275000",
                        "longitude": "30.78369000"
                    },
                    {
                        "id": 109768,
                        "name": "Kodra",
                        "latitude": "50.59488000",
                        "longitude": "29.55873000"
                    },
                    {
                        "id": 109797,
                        "name": "Korniyivka",
                        "latitude": "50.41661000",
                        "longitude": "31.46261000"
                    },
                    {
                        "id": 109825,
                        "name": "Kozhanka",
                        "latitude": "49.97231000",
                        "longitude": "29.76424000"
                    },
                    {
                        "id": 109855,
                        "name": "Krasyatychi",
                        "latitude": "51.07636000",
                        "longitude": "29.64899000"
                    },
                    {
                        "id": 109865,
                        "name": "Kriukivschina",
                        "latitude": "50.37153000",
                        "longitude": "30.36861000"
                    },
                    {
                        "id": 109874,
                        "name": "Kryva Hora",
                        "latitude": "51.38495000",
                        "longitude": "30.19978000"
                    },
                    {
                        "id": 109900,
                        "name": "Kyyevo-Svyatoshyns’kyy Rayon",
                        "latitude": "50.38530000",
                        "longitude": "30.23129000"
                    },
                    {
                        "id": 109925,
                        "name": "Liutizh",
                        "latitude": "50.68350000",
                        "longitude": "30.39324000"
                    },
                    {
                        "id": 109972,
                        "name": "Makariv",
                        "latitude": "50.46408000",
                        "longitude": "29.81128000"
                    },
                    {
                        "id": 109973,
                        "name": "Makariv Raion",
                        "latitude": "50.50000000",
                        "longitude": "29.75000000"
                    },
                    {
                        "id": 110035,
                        "name": "Mirovka",
                        "latitude": "49.93126000",
                        "longitude": "30.62309000"
                    },
                    {
                        "id": 110057,
                        "name": "Motovylivka",
                        "latitude": "50.15821000",
                        "longitude": "30.07421000"
                    },
                    {
                        "id": 110076,
                        "name": "Myronivka",
                        "latitude": "49.66007000",
                        "longitude": "30.98225000"
                    },
                    {
                        "id": 110116,
                        "name": "Novi Petrivtsi",
                        "latitude": "50.62754000",
                        "longitude": "30.44310000"
                    },
                    {
                        "id": 110173,
                        "name": "Obukhiv",
                        "latitude": "50.10689000",
                        "longitude": "30.61848000"
                    },
                    {
                        "id": 110174,
                        "name": "Obukhiv Raion",
                        "latitude": "50.16667000",
                        "longitude": "30.66667000"
                    },
                    {
                        "id": 110175,
                        "name": "Obukhivs’ka Mis’krada",
                        "latitude": "50.11425000",
                        "longitude": "30.63293000"
                    },
                    {
                        "id": 110239,
                        "name": "Pereiaslav-Khmelnytskyi",
                        "latitude": "50.06739000",
                        "longitude": "31.44969000"
                    },
                    {
                        "id": 110240,
                        "name": "Pereiaslav-Khmelnytskyi Raion",
                        "latitude": "50.08333000",
                        "longitude": "31.50000000"
                    },
                    {
                        "id": 110274,
                        "name": "Piskivka",
                        "latitude": "50.69378000",
                        "longitude": "29.61934000"
                    },
                    {
                        "id": 110287,
                        "name": "Pohreby",
                        "latitude": "50.55453000",
                        "longitude": "30.64455000"
                    },
                    {
                        "id": 110327,
                        "name": "Pukhivka",
                        "latitude": "50.60970000",
                        "longitude": "30.71770000"
                    },
                    {
                        "id": 110363,
                        "name": "Rokytne",
                        "latitude": "49.68665000",
                        "longitude": "30.47384000"
                    },
                    {
                        "id": 110365,
                        "name": "Rokytne Raion",
                        "latitude": "49.75000000",
                        "longitude": "30.50000000"
                    },
                    {
                        "id": 110373,
                        "name": "Roskoshnyy",
                        "latitude": "49.37087000",
                        "longitude": "30.18471000"
                    },
                    {
                        "id": 110398,
                        "name": "Rzhyshchiv",
                        "latitude": "49.96886000",
                        "longitude": "31.04628000"
                    },
                    {
                        "id": 110417,
                        "name": "Semypolky",
                        "latitude": "50.72627000",
                        "longitude": "30.93441000"
                    },
                    {
                        "id": 110474,
                        "name": "Skvyra",
                        "latitude": "49.73177000",
                        "longitude": "29.66569000"
                    },
                    {
                        "id": 110475,
                        "name": "Skvyrs’kyy Rayon",
                        "latitude": "49.74177000",
                        "longitude": "29.70043000"
                    },
                    {
                        "id": 110480,
                        "name": "Slavutych",
                        "latitude": "51.52250000",
                        "longitude": "30.71806000"
                    },
                    {
                        "id": 110499,
                        "name": "Sofiyivska Borschagivka",
                        "latitude": "50.41005000",
                        "longitude": "30.36724000"
                    },
                    {
                        "id": 110543,
                        "name": "Stavyshche",
                        "latitude": "49.39124000",
                        "longitude": "30.19022000"
                    },
                    {
                        "id": 110545,
                        "name": "Stayki",
                        "latitude": "50.07818000",
                        "longitude": "30.90380000"
                    },
                    {
                        "id": 110590,
                        "name": "Tarashcha",
                        "latitude": "49.55832000",
                        "longitude": "30.49259000"
                    },
                    {
                        "id": 110606,
                        "name": "Tetiiv",
                        "latitude": "49.37670000",
                        "longitude": "29.66474000"
                    },
                    {
                        "id": 110620,
                        "name": "Trebukhiv",
                        "latitude": "50.48432000",
                        "longitude": "30.90304000"
                    },
                    {
                        "id": 110624,
                        "name": "Trypillia",
                        "latitude": "50.11802000",
                        "longitude": "30.78141000"
                    },
                    {
                        "id": 110632,
                        "name": "Tsybli",
                        "latitude": "49.99484000",
                        "longitude": "31.56281000"
                    },
                    {
                        "id": 110651,
                        "name": "Ukrainka",
                        "latitude": "50.14317000",
                        "longitude": "30.74612000"
                    },
                    {
                        "id": 110669,
                        "name": "Uzyn",
                        "latitude": "49.82619000",
                        "longitude": "30.41487000"
                    },
                    {
                        "id": 110678,
                        "name": "Vasylkiv",
                        "latitude": "50.18693000",
                        "longitude": "30.31346000"
                    },
                    {
                        "id": 110679,
                        "name": "Vasylkiv Raion",
                        "latitude": "50.16667000",
                        "longitude": "30.33333000"
                    },
                    {
                        "id": 110684,
                        "name": "Velyka Dymerka",
                        "latitude": "50.59333000",
                        "longitude": "30.90313000"
                    },
                    {
                        "id": 110733,
                        "name": "Volodarka",
                        "latitude": "49.52484000",
                        "longitude": "29.91222000"
                    },
                    {
                        "id": 110742,
                        "name": "Voronkov",
                        "latitude": "50.22235000",
                        "longitude": "30.89967000"
                    },
                    {
                        "id": 110745,
                        "name": "Vorzel’",
                        "latitude": "50.54440000",
                        "longitude": "30.15305000"
                    },
                    {
                        "id": 110762,
                        "name": "Vyshgorodskiy Rayon",
                        "latitude": "50.58333000",
                        "longitude": "30.50000000"
                    },
                    {
                        "id": 110763,
                        "name": "Vyshhorod",
                        "latitude": "50.58476000",
                        "longitude": "30.48980000"
                    },
                    {
                        "id": 110765,
                        "name": "Vyshneve",
                        "latitude": "50.38913000",
                        "longitude": "30.37050000"
                    },
                    {
                        "id": 110773,
                        "name": "Yahotyn",
                        "latitude": "50.27975000",
                        "longitude": "31.76246000"
                    },
                    {
                        "id": 110774,
                        "name": "Yahotyns’kyy Rayon",
                        "latitude": "50.25722000",
                        "longitude": "31.89456000"
                    },
                    {
                        "id": 110872,
                        "name": "Z·hurivs’kyy Rayon",
                        "latitude": "50.47192000",
                        "longitude": "31.79423000"
                    },
                    {
                        "id": 110839,
                        "name": "Zgurovka",
                        "latitude": "50.50276000",
                        "longitude": "31.78492000"
                    }
                ]
            },
            {
                "id": 4673,
                "name": "Luhanska",
                "iso2": "09",
                "latitude": "48.57404100",
                "longitude": "39.30781500",
                "type": "region",
                "cities": [
                    {
                        "id": 109311,
                        "name": "Alchevs’k",
                        "latitude": "48.46893000",
                        "longitude": "38.81669000"
                    },
                    {
                        "id": 109312,
                        "name": "Alchevs’ka Mis’krada",
                        "latitude": "48.48029000",
                        "longitude": "38.79690000"
                    },
                    {
                        "id": 109323,
                        "name": "Antratsyt",
                        "latitude": "48.11503000",
                        "longitude": "39.09128000"
                    },
                    {
                        "id": 109324,
                        "name": "Antratsytivs’kyy Rayon",
                        "latitude": "48.12450000",
                        "longitude": "39.05683000"
                    },
                    {
                        "id": 109329,
                        "name": "Artemivs’k",
                        "latitude": "48.44061000",
                        "longitude": "38.73200000"
                    },
                    {
                        "id": 109359,
                        "name": "Bayrachky",
                        "latitude": "48.39200000",
                        "longitude": "38.60174000"
                    },
                    {
                        "id": 109395,
                        "name": "Bile",
                        "latitude": "48.49523000",
                        "longitude": "39.05051000"
                    },
                    {
                        "id": 109400,
                        "name": "Bilohorivka",
                        "latitude": "48.92503000",
                        "longitude": "38.24822000"
                    },
                    {
                        "id": 109401,
                        "name": "Bilokurakyne",
                        "latitude": "49.53410000",
                        "longitude": "38.73067000"
                    },
                    {
                        "id": 109403,
                        "name": "Bilovods'k",
                        "latitude": "49.20846000",
                        "longitude": "39.58975000"
                    },
                    {
                        "id": 109408,
                        "name": "Biryukove",
                        "latitude": "47.95631000",
                        "longitude": "39.73843000"
                    },
                    {
                        "id": 109453,
                        "name": "Bryanka",
                        "latitude": "48.51100000",
                        "longitude": "38.67222000"
                    },
                    {
                        "id": 109460,
                        "name": "Buran",
                        "latitude": "48.30003000",
                        "longitude": "39.61526000"
                    },
                    {
                        "id": 109502,
                        "name": "Chervonopartyzans’k",
                        "latitude": "48.07613000",
                        "longitude": "39.79618000"
                    },
                    {
                        "id": 109515,
                        "name": "Chornukhyne",
                        "latitude": "48.32339000",
                        "longitude": "38.52272000"
                    },
                    {
                        "id": 109574,
                        "name": "Dovzhanskyy Rayon",
                        "latitude": "48.00000000",
                        "longitude": "39.66667000"
                    },
                    {
                        "id": 109630,
                        "name": "Hirs’ke",
                        "latitude": "48.73468000",
                        "longitude": "38.49541000"
                    },
                    {
                        "id": 109693,
                        "name": "Kadiyivka",
                        "latitude": "48.56818000",
                        "longitude": "38.64352000"
                    },
                    {
                        "id": 109754,
                        "name": "Kirovs’k",
                        "latitude": "48.63751000",
                        "longitude": "38.64280000"
                    },
                    {
                        "id": 109755,
                        "name": "Kirovs’ka Mis’krada",
                        "latitude": "48.63485000",
                        "longitude": "38.64753000"
                    },
                    {
                        "id": 109760,
                        "name": "Klenovyy",
                        "latitude": "48.11934000",
                        "longitude": "39.45880000"
                    },
                    {
                        "id": 109853,
                        "name": "Krasnyy Kut",
                        "latitude": "48.20138000",
                        "longitude": "38.79765000"
                    },
                    {
                        "id": 109854,
                        "name": "Krasnyy Luch",
                        "latitude": "48.13954000",
                        "longitude": "38.93715000"
                    },
                    {
                        "id": 109860,
                        "name": "Kreminna",
                        "latitude": "49.04950000",
                        "longitude": "38.21792000"
                    },
                    {
                        "id": 109864,
                        "name": "Kripens’kyy",
                        "latitude": "48.07709000",
                        "longitude": "39.05800000"
                    },
                    {
                        "id": 109911,
                        "name": "Lenina",
                        "latitude": "48.42944000",
                        "longitude": "39.14556000"
                    },
                    {
                        "id": 109931,
                        "name": "Lozno-Oleksandrivka",
                        "latitude": "49.83910000",
                        "longitude": "38.74098000"
                    },
                    {
                        "id": 109939,
                        "name": "Luhans’ka Mis’krada",
                        "latitude": "48.58083000",
                        "longitude": "39.35478000"
                    },
                    {
                        "id": 109938,
                        "name": "Luhansk",
                        "latitude": "48.56705000",
                        "longitude": "39.31706000"
                    },
                    {
                        "id": 109945,
                        "name": "Lutuhyne",
                        "latitude": "48.40507000",
                        "longitude": "39.22675000"
                    },
                    {
                        "id": 109946,
                        "name": "Lutuhyns’kyy Rayon",
                        "latitude": "48.38509000",
                        "longitude": "39.21209000"
                    },
                    {
                        "id": 109960,
                        "name": "Lysychans’k",
                        "latitude": "48.90485000",
                        "longitude": "38.44207000"
                    },
                    {
                        "id": 109974,
                        "name": "Makariv Yar",
                        "latitude": "48.57768000",
                        "longitude": "39.71944000"
                    },
                    {
                        "id": 110001,
                        "name": "Markivka",
                        "latitude": "49.52290000",
                        "longitude": "39.57055000"
                    },
                    {
                        "id": 110030,
                        "name": "Millerovo",
                        "latitude": "48.16829000",
                        "longitude": "39.16537000"
                    },
                    {
                        "id": 110031,
                        "name": "Milove",
                        "latitude": "49.37528000",
                        "longitude": "40.13222000"
                    },
                    {
                        "id": 110038,
                        "name": "Miusyns’k",
                        "latitude": "48.07750000",
                        "longitude": "38.90364000"
                    },
                    {
                        "id": 110049,
                        "name": "Molodohvardiys’k",
                        "latitude": "48.34511000",
                        "longitude": "39.65244000"
                    },
                    {
                        "id": 110143,
                        "name": "Novopskov",
                        "latitude": "49.54640000",
                        "longitude": "39.08987000"
                    },
                    {
                        "id": 110166,
                        "name": "Nyzhnya Duvanka",
                        "latitude": "49.58464000",
                        "longitude": "38.17429000"
                    },
                    {
                        "id": 110231,
                        "name": "Pavlivka",
                        "latitude": "49.60864000",
                        "longitude": "38.70917000"
                    },
                    {
                        "id": 110244,
                        "name": "Pereval’s’k",
                        "latitude": "48.43779000",
                        "longitude": "38.84384000"
                    },
                    {
                        "id": 110250,
                        "name": "Pervomays’k",
                        "latitude": "48.62988000",
                        "longitude": "38.54806000"
                    },
                    {
                        "id": 110300,
                        "name": "Popasna",
                        "latitude": "48.63328000",
                        "longitude": "38.37804000"
                    },
                    {
                        "id": 110324,
                        "name": "Pryvillya",
                        "latitude": "49.01501000",
                        "longitude": "38.30457000"
                    },
                    {
                        "id": 110374,
                        "name": "Roven’ky",
                        "latitude": "48.08331000",
                        "longitude": "39.37764000"
                    },
                    {
                        "id": 110384,
                        "name": "Rozkishne",
                        "latitude": "48.48959000",
                        "longitude": "39.27881000"
                    },
                    {
                        "id": 110387,
                        "name": "Rubizhans’ka Mis’krada",
                        "latitude": "49.01460000",
                        "longitude": "38.38909000"
                    },
                    {
                        "id": 110388,
                        "name": "Rubizhne",
                        "latitude": "49.01229000",
                        "longitude": "38.37967000"
                    },
                    {
                        "id": 110433,
                        "name": "Shchastya",
                        "latitude": "48.73963000",
                        "longitude": "39.23230000"
                    },
                    {
                        "id": 110460,
                        "name": "Simeykyne",
                        "latitude": "48.32643000",
                        "longitude": "39.53366000"
                    },
                    {
                        "id": 110485,
                        "name": "Slov`yanoserbsk",
                        "latitude": "48.69779000",
                        "longitude": "38.98133000"
                    },
                    {
                        "id": 110514,
                        "name": "Sorokyne",
                        "latitude": "48.29235000",
                        "longitude": "39.73921000"
                    },
                    {
                        "id": 110515,
                        "name": "Sorokyns'kyi Rayon",
                        "latitude": "48.33333000",
                        "longitude": "39.75000000"
                    },
                    {
                        "id": 110526,
                        "name": "Stanytsya Luhans’ka",
                        "latitude": "48.65433000",
                        "longitude": "39.47943000"
                    },
                    {
                        "id": 110532,
                        "name": "Starobil’s’k",
                        "latitude": "49.27832000",
                        "longitude": "38.91069000"
                    },
                    {
                        "id": 110572,
                        "name": "Svatove",
                        "latitude": "49.41029000",
                        "longitude": "38.15035000"
                    },
                    {
                        "id": 110573,
                        "name": "Sverdlovs’k",
                        "latitude": "48.08964000",
                        "longitude": "39.65243000"
                    },
                    {
                        "id": 110574,
                        "name": "Sverdlovs’ka Mis’krada",
                        "latitude": "48.06850000",
                        "longitude": "39.58057000"
                    },
                    {
                        "id": 110582,
                        "name": "Syevyerodonets’k",
                        "latitude": "48.94832000",
                        "longitude": "38.49166000"
                    },
                    {
                        "id": 110597,
                        "name": "Teple",
                        "latitude": "48.31245000",
                        "longitude": "39.56284000"
                    },
                    {
                        "id": 110618,
                        "name": "Toshkivka",
                        "latitude": "48.77914000",
                        "longitude": "38.57903000"
                    },
                    {
                        "id": 110625,
                        "name": "Tr’okhizbenka",
                        "latitude": "48.75751000",
                        "longitude": "38.96333000"
                    },
                    {
                        "id": 110657,
                        "name": "Uralo-Kavkaz",
                        "latitude": "48.32110000",
                        "longitude": "39.80302000"
                    },
                    {
                        "id": 110661,
                        "name": "Uspenka",
                        "latitude": "48.39077000",
                        "longitude": "39.16284000"
                    },
                    {
                        "id": 110812,
                        "name": "Zalesnoye",
                        "latitude": "48.03104000",
                        "longitude": "38.80934000"
                    },
                    {
                        "id": 110866,
                        "name": "Zoryns’k",
                        "latitude": "48.41194000",
                        "longitude": "38.62361000"
                    },
                    {
                        "id": 110871,
                        "name": "Zymohiria",
                        "latitude": "48.58528000",
                        "longitude": "38.93750000"
                    }
                ]
            },
            {
                "id": 4672,
                "name": "Lvivska",
                "iso2": "46",
                "latitude": "49.83968300",
                "longitude": "24.02971700",
                "type": "region",
                "cities": [
                    {
                        "id": 109366,
                        "name": "Belz",
                        "latitude": "50.38226000",
                        "longitude": "24.00642000"
                    },
                    {
                        "id": 109391,
                        "name": "Bibrka",
                        "latitude": "49.64093000",
                        "longitude": "24.28874000"
                    },
                    {
                        "id": 109435,
                        "name": "Boryslav",
                        "latitude": "49.28672000",
                        "longitude": "23.43238000"
                    },
                    {
                        "id": 109446,
                        "name": "Brody",
                        "latitude": "50.08791000",
                        "longitude": "25.15027000"
                    },
                    {
                        "id": 109455,
                        "name": "Bryukhovychi",
                        "latitude": "49.90467000",
                        "longitude": "23.95969000"
                    },
                    {
                        "id": 109500,
                        "name": "Chervonohrad",
                        "latitude": "50.39105000",
                        "longitude": "24.23514000"
                    },
                    {
                        "id": 109534,
                        "name": "Demnya",
                        "latitude": "49.56738000",
                        "longitude": "23.94607000"
                    },
                    {
                        "id": 109555,
                        "name": "Dobromyl’",
                        "latitude": "49.57193000",
                        "longitude": "22.78629000"
                    },
                    {
                        "id": 109578,
                        "name": "Drohobych",
                        "latitude": "49.34991000",
                        "longitude": "23.50561000"
                    },
                    {
                        "id": 109583,
                        "name": "Dublyany",
                        "latitude": "49.90411000",
                        "longitude": "24.08637000"
                    },
                    {
                        "id": 109588,
                        "name": "Duliby",
                        "latitude": "49.23134000",
                        "longitude": "23.81532000"
                    },
                    {
                        "id": 109594,
                        "name": "Dzvinogrud",
                        "latitude": "49.73333000",
                        "longitude": "24.25000000"
                    },
                    {
                        "id": 109634,
                        "name": "Hlyns'k",
                        "latitude": "50.06033000",
                        "longitude": "23.89956000"
                    },
                    {
                        "id": 109648,
                        "name": "Horodok",
                        "latitude": "49.78465000",
                        "longitude": "23.64806000"
                    },
                    {
                        "id": 109684,
                        "name": "Ivano-Frankove",
                        "latitude": "49.91978000",
                        "longitude": "23.72913000"
                    },
                    {
                        "id": 109733,
                        "name": "Khodoriv",
                        "latitude": "49.40993000",
                        "longitude": "24.30470000"
                    },
                    {
                        "id": 109746,
                        "name": "Khyriv",
                        "latitude": "49.53417000",
                        "longitude": "22.85538000"
                    },
                    {
                        "id": 109782,
                        "name": "Komarno",
                        "latitude": "49.62739000",
                        "longitude": "23.69952000"
                    },
                    {
                        "id": 109832,
                        "name": "Krasne",
                        "latitude": "49.91447000",
                        "longitude": "24.61340000"
                    },
                    {
                        "id": 109884,
                        "name": "Kulykiv",
                        "latitude": "49.97954000",
                        "longitude": "24.07817000"
                    },
                    {
                        "id": 109929,
                        "name": "Lopatyn",
                        "latitude": "50.22022000",
                        "longitude": "24.84831000"
                    },
                    {
                        "id": 109948,
                        "name": "Lviv",
                        "latitude": "49.83826000",
                        "longitude": "24.02324000"
                    },
                    {
                        "id": 110012,
                        "name": "Medenychi",
                        "latitude": "49.43055000",
                        "longitude": "23.75073000"
                    },
                    {
                        "id": 110052,
                        "name": "Morshyn",
                        "latitude": "49.15652000",
                        "longitude": "23.87232000"
                    },
                    {
                        "id": 110056,
                        "name": "Mostys'ka",
                        "latitude": "49.79467000",
                        "longitude": "23.15077000"
                    },
                    {
                        "id": 110062,
                        "name": "Murovane",
                        "latitude": "49.52143000",
                        "longitude": "22.93670000"
                    },
                    {
                        "id": 110070,
                        "name": "Mykolaiv",
                        "latitude": "49.52372000",
                        "longitude": "23.98522000"
                    },
                    {
                        "id": 110084,
                        "name": "Navaria",
                        "latitude": "49.74952000",
                        "longitude": "23.92746000"
                    },
                    {
                        "id": 110154,
                        "name": "Novoyavorivs'k",
                        "latitude": "49.93023000",
                        "longitude": "23.57357000"
                    },
                    {
                        "id": 110157,
                        "name": "Novyi Yarychiv",
                        "latitude": "49.90444000",
                        "longitude": "24.30523000"
                    },
                    {
                        "id": 110172,
                        "name": "Obroshyne",
                        "latitude": "49.78333000",
                        "longitude": "23.86667000"
                    },
                    {
                        "id": 110193,
                        "name": "Olesko",
                        "latitude": "49.96233000",
                        "longitude": "24.89336000"
                    },
                    {
                        "id": 110241,
                        "name": "Peremyshlyany",
                        "latitude": "49.66523000",
                        "longitude": "24.55846000"
                    },
                    {
                        "id": 110264,
                        "name": "Pidbuzh",
                        "latitude": "49.33483000",
                        "longitude": "23.24887000"
                    },
                    {
                        "id": 110266,
                        "name": "Pidhirtsi",
                        "latitude": "49.94611000",
                        "longitude": "24.97950000"
                    },
                    {
                        "id": 110269,
                        "name": "Pidkamin’",
                        "latitude": "49.94599000",
                        "longitude": "25.31672000"
                    },
                    {
                        "id": 110278,
                        "name": "Pnikut",
                        "latitude": "49.71104000",
                        "longitude": "23.13826000"
                    },
                    {
                        "id": 110298,
                        "name": "Pomoriany",
                        "latitude": "49.64092000",
                        "longitude": "24.93070000"
                    },
                    {
                        "id": 110306,
                        "name": "Potelych",
                        "latitude": "50.20804000",
                        "longitude": "23.54674000"
                    },
                    {
                        "id": 110330,
                        "name": "Pustomyty",
                        "latitude": "49.71532000",
                        "longitude": "23.91295000"
                    },
                    {
                        "id": 110344,
                        "name": "Ralivka",
                        "latitude": "49.49982000",
                        "longitude": "23.23739000"
                    },
                    {
                        "id": 110347,
                        "name": "Rava-Rus’ka",
                        "latitude": "50.23079000",
                        "longitude": "23.62825000"
                    },
                    {
                        "id": 110352,
                        "name": "Richky",
                        "latitude": "50.27706000",
                        "longitude": "23.64617000"
                    },
                    {
                        "id": 110357,
                        "name": "Rodatychi",
                        "latitude": "49.79862000",
                        "longitude": "23.53336000"
                    },
                    {
                        "id": 110376,
                        "name": "Rozdil",
                        "latitude": "49.46144000",
                        "longitude": "24.06230000"
                    },
                    {
                        "id": 110386,
                        "name": "Rozvadiv",
                        "latitude": "49.50323000",
                        "longitude": "23.96200000"
                    },
                    {
                        "id": 110390,
                        "name": "Rudky",
                        "latitude": "49.65306000",
                        "longitude": "23.48702000"
                    },
                    {
                        "id": 110391,
                        "name": "Rudne",
                        "latitude": "49.83333000",
                        "longitude": "23.90000000"
                    },
                    {
                        "id": 110397,
                        "name": "Rykhtychi",
                        "latitude": "49.38511000",
                        "longitude": "23.55662000"
                    },
                    {
                        "id": 110405,
                        "name": "Sambir",
                        "latitude": "49.51830000",
                        "longitude": "23.19752000"
                    },
                    {
                        "id": 110438,
                        "name": "Shchyrets",
                        "latitude": "49.65096000",
                        "longitude": "23.87426000"
                    },
                    {
                        "id": 110447,
                        "name": "Shklo",
                        "latitude": "49.95675000",
                        "longitude": "23.54408000"
                    },
                    {
                        "id": 110458,
                        "name": "Silets’",
                        "latitude": "50.29712000",
                        "longitude": "24.20462000"
                    },
                    {
                        "id": 110470,
                        "name": "Skelivka",
                        "latitude": "49.53728000",
                        "longitude": "22.96467000"
                    },
                    {
                        "id": 110471,
                        "name": "Skhidnytsya",
                        "latitude": "49.22827000",
                        "longitude": "23.35016000"
                    },
                    {
                        "id": 110472,
                        "name": "Skole",
                        "latitude": "49.03717000",
                        "longitude": "23.51346000"
                    },
                    {
                        "id": 110478,
                        "name": "Slavske",
                        "latitude": "48.84734000",
                        "longitude": "23.44587000"
                    },
                    {
                        "id": 110500,
                        "name": "Sokal’",
                        "latitude": "50.47438000",
                        "longitude": "24.28288000"
                    },
                    {
                        "id": 110510,
                        "name": "Solonka",
                        "latitude": "49.75621000",
                        "longitude": "24.01028000"
                    },
                    {
                        "id": 110535,
                        "name": "Staroye Selo",
                        "latitude": "49.71037000",
                        "longitude": "24.18950000"
                    },
                    {
                        "id": 110537,
                        "name": "Starychi",
                        "latitude": "49.98001000",
                        "longitude": "23.55848000"
                    },
                    {
                        "id": 110538,
                        "name": "Staryy Dobrotvir",
                        "latitude": "50.23154000",
                        "longitude": "24.37701000"
                    },
                    {
                        "id": 110542,
                        "name": "Staryy Sambir",
                        "latitude": "49.43856000",
                        "longitude": "23.00056000"
                    },
                    {
                        "id": 110547,
                        "name": "Stebnyk",
                        "latitude": "49.29416000",
                        "longitude": "23.56357000"
                    },
                    {
                        "id": 110557,
                        "name": "Stryi",
                        "latitude": "49.26223000",
                        "longitude": "23.85609000"
                    },
                    {
                        "id": 110561,
                        "name": "Sudova Vyshnya",
                        "latitude": "49.78892000",
                        "longitude": "23.37218000"
                    },
                    {
                        "id": 110562,
                        "name": "Sukhovolya",
                        "latitude": "49.82426000",
                        "longitude": "23.83770000"
                    },
                    {
                        "id": 110623,
                        "name": "Truskavets’",
                        "latitude": "49.27837000",
                        "longitude": "23.50618000"
                    },
                    {
                        "id": 110635,
                        "name": "Tukhlia",
                        "latitude": "48.91218000",
                        "longitude": "23.47303000"
                    },
                    {
                        "id": 110639,
                        "name": "Turka",
                        "latitude": "49.15411000",
                        "longitude": "23.02967000"
                    },
                    {
                        "id": 110649,
                        "name": "Uhniv",
                        "latitude": "50.36811000",
                        "longitude": "23.74895000"
                    },
                    {
                        "id": 110655,
                        "name": "Ulychne",
                        "latitude": "49.23385000",
                        "longitude": "23.65111000"
                    },
                    {
                        "id": 110700,
                        "name": "Verblyany",
                        "latitude": "50.04747000",
                        "longitude": "23.42189000"
                    },
                    {
                        "id": 110701,
                        "name": "Verchnia Rozhanka",
                        "latitude": "48.78050000",
                        "longitude": "23.51545000"
                    },
                    {
                        "id": 110705,
                        "name": "Verkhnie Synevydne",
                        "latitude": "49.10307000",
                        "longitude": "23.59099000"
                    },
                    {
                        "id": 110709,
                        "name": "Verkhnyaya Belka",
                        "latitude": "49.81575000",
                        "longitude": "24.30328000"
                    },
                    {
                        "id": 110749,
                        "name": "Voyutychi",
                        "latitude": "49.55135000",
                        "longitude": "23.10579000"
                    },
                    {
                        "id": 110792,
                        "name": "Yavoriv",
                        "latitude": "49.93864000",
                        "longitude": "23.38254000"
                    },
                    {
                        "id": 110845,
                        "name": "Zhovkva",
                        "latitude": "50.05825000",
                        "longitude": "23.97260000"
                    },
                    {
                        "id": 110852,
                        "name": "Zhydachiv",
                        "latitude": "49.38468000",
                        "longitude": "24.14254000"
                    },
                    {
                        "id": 110860,
                        "name": "Zolochiv",
                        "latitude": "49.80597000",
                        "longitude": "24.89436000"
                    }
                ]
            },
            {
                "id": 4679,
                "name": "Mykolaivska",
                "iso2": "48",
                "latitude": "46.97503300",
                "longitude": "31.99458290",
                "type": "region",
                "cities": [
                    {
                        "id": 109326,
                        "name": "Arbuzynka",
                        "latitude": "47.90972000",
                        "longitude": "31.31963000"
                    },
                    {
                        "id": 109355,
                        "name": "Bashtanka",
                        "latitude": "47.40719000",
                        "longitude": "32.43868000"
                    },
                    {
                        "id": 109378,
                        "name": "Berezanka",
                        "latitude": "46.85262000",
                        "longitude": "31.38802000"
                    },
                    {
                        "id": 109382,
                        "name": "Bereznehuvate",
                        "latitude": "47.30783000",
                        "longitude": "32.84993000"
                    },
                    {
                        "id": 109569,
                        "name": "Domanivka",
                        "latitude": "47.63192000",
                        "longitude": "30.98851000"
                    },
                    {
                        "id": 109723,
                        "name": "Kazanka",
                        "latitude": "47.84625000",
                        "longitude": "32.82177000"
                    },
                    {
                        "id": 109765,
                        "name": "Kobleve",
                        "latitude": "46.66499000",
                        "longitude": "31.20804000"
                    },
                    {
                        "id": 109815,
                        "name": "Kostyantynivka",
                        "latitude": "47.82660000",
                        "longitude": "31.13551000"
                    },
                    {
                        "id": 109875,
                        "name": "Kryve Ozero",
                        "latitude": "47.95242000",
                        "longitude": "30.34928000"
                    },
                    {
                        "id": 109958,
                        "name": "Lysa Hora",
                        "latitude": "48.17059000",
                        "longitude": "31.10994000"
                    },
                    {
                        "id": 110066,
                        "name": "Myhiya",
                        "latitude": "48.03719000",
                        "longitude": "30.95153000"
                    },
                    {
                        "id": 110071,
                        "name": "Mykolayiv",
                        "latitude": "46.96591000",
                        "longitude": "31.99740000"
                    },
                    {
                        "id": 110106,
                        "name": "Nova Odesa",
                        "latitude": "47.30778000",
                        "longitude": "31.78506000"
                    },
                    {
                        "id": 110159,
                        "name": "Novyy Buh",
                        "latitude": "47.69308000",
                        "longitude": "32.52160000"
                    },
                    {
                        "id": 110176,
                        "name": "Ochakiv",
                        "latitude": "46.61283000",
                        "longitude": "31.54982000"
                    },
                    {
                        "id": 110185,
                        "name": "Ol'shanskoye",
                        "latitude": "47.18411000",
                        "longitude": "31.79375000"
                    },
                    {
                        "id": 110187,
                        "name": "Oleksandrivka",
                        "latitude": "46.83826000",
                        "longitude": "32.76116000"
                    },
                    {
                        "id": 110228,
                        "name": "Parutyne",
                        "latitude": "46.70538000",
                        "longitude": "31.89709000"
                    },
                    {
                        "id": 110251,
                        "name": "Pervomays’k",
                        "latitude": "48.04433000",
                        "longitude": "30.85073000"
                    },
                    {
                        "id": 110267,
                        "name": "Pidhorodna",
                        "latitude": "48.10704000",
                        "longitude": "30.88953000"
                    },
                    {
                        "id": 110396,
                        "name": "Rybakivka",
                        "latitude": "46.61712000",
                        "longitude": "31.34995000"
                    },
                    {
                        "id": 110443,
                        "name": "Shevchenkove",
                        "latitude": "46.86289000",
                        "longitude": "32.20387000"
                    },
                    {
                        "id": 110492,
                        "name": "Snihurivka",
                        "latitude": "47.07579000",
                        "longitude": "32.80516000"
                    },
                    {
                        "id": 110716,
                        "name": "Veselynove",
                        "latitude": "47.35666000",
                        "longitude": "31.23488000"
                    },
                    {
                        "id": 110751,
                        "name": "Voznesensk",
                        "latitude": "47.56494000",
                        "longitude": "31.33078000"
                    },
                    {
                        "id": 110752,
                        "name": "Vradiyivka",
                        "latitude": "47.86195000",
                        "longitude": "30.59195000"
                    },
                    {
                        "id": 110805,
                        "name": "Yuzhnoukrains'k",
                        "latitude": "47.81777000",
                        "longitude": "31.18263000"
                    }
                ]
            },
            {
                "id": 4688,
                "name": "Odeska",
                "iso2": "51",
                "latitude": "46.48458300",
                "longitude": "30.73260000",
                "type": "region",
                "cities": [
                    {
                        "id": 109330,
                        "name": "Artsyz",
                        "latitude": "45.99194000",
                        "longitude": "29.41824000"
                    },
                    {
                        "id": 109346,
                        "name": "Balta",
                        "latitude": "47.93548000",
                        "longitude": "29.61982000"
                    },
                    {
                        "id": 109347,
                        "name": "Balts’kyy Rayon",
                        "latitude": "47.99828000",
                        "longitude": "29.64835000"
                    },
                    {
                        "id": 109379,
                        "name": "Berezivka",
                        "latitude": "47.20429000",
                        "longitude": "30.90780000"
                    },
                    {
                        "id": 109386,
                        "name": "Berezyne",
                        "latitude": "46.22968000",
                        "longitude": "29.20436000"
                    },
                    {
                        "id": 109396,
                        "name": "Bilhorod-Dnistrovskyi",
                        "latitude": "46.19520000",
                        "longitude": "30.34938000"
                    },
                    {
                        "id": 109406,
                        "name": "Bilyayivka",
                        "latitude": "46.48319000",
                        "longitude": "30.21678000"
                    },
                    {
                        "id": 109425,
                        "name": "Bolhrad",
                        "latitude": "45.68262000",
                        "longitude": "28.61487000"
                    },
                    {
                        "id": 109428,
                        "name": "Borodino",
                        "latitude": "46.30250000",
                        "longitude": "29.24167000"
                    },
                    {
                        "id": 109448,
                        "name": "Broska",
                        "latitude": "45.37327000",
                        "longitude": "28.78300000"
                    },
                    {
                        "id": 109513,
                        "name": "Chornomors’k",
                        "latitude": "46.30495000",
                        "longitude": "30.65478000"
                    },
                    {
                        "id": 109545,
                        "name": "Dmytrivka",
                        "latitude": "45.97167000",
                        "longitude": "28.98639000"
                    },
                    {
                        "id": 109601,
                        "name": "Fontanka",
                        "latitude": "46.56646000",
                        "longitude": "30.85965000"
                    },
                    {
                        "id": 109646,
                        "name": "Horodnye",
                        "latitude": "45.89083000",
                        "longitude": "28.84833000"
                    },
                    {
                        "id": 109678,
                        "name": "Ivanivka",
                        "latitude": "46.97569000",
                        "longitude": "30.46998000"
                    },
                    {
                        "id": 109687,
                        "name": "Izmayil",
                        "latitude": "45.34929000",
                        "longitude": "28.84079000"
                    },
                    {
                        "id": 109699,
                        "name": "Kalcheva",
                        "latitude": "45.73746000",
                        "longitude": "28.81441000"
                    },
                    {
                        "id": 109713,
                        "name": "Kamyshevka Vtoraya",
                        "latitude": "46.23333000",
                        "longitude": "29.83333000"
                    },
                    {
                        "id": 109717,
                        "name": "Karolino-Buhaz",
                        "latitude": "46.14492000",
                        "longitude": "30.52609000"
                    },
                    {
                        "id": 109747,
                        "name": "Kiliya",
                        "latitude": "45.45518000",
                        "longitude": "29.26367000"
                    },
                    {
                        "id": 109769,
                        "name": "Kodyma",
                        "latitude": "48.09875000",
                        "longitude": "29.12463000"
                    },
                    {
                        "id": 109770,
                        "name": "Kodyms’kyy Rayon",
                        "latitude": "48.02284000",
                        "longitude": "29.14010000"
                    },
                    {
                        "id": 109847,
                        "name": "Krasnosilka",
                        "latitude": "46.62258000",
                        "longitude": "30.77421000"
                    },
                    {
                        "id": 109859,
                        "name": "Kremidivka",
                        "latitude": "46.73351000",
                        "longitude": "30.78472000"
                    },
                    {
                        "id": 109878,
                        "name": "Kryzhanivka",
                        "latitude": "46.56167000",
                        "longitude": "30.79487000"
                    },
                    {
                        "id": 109880,
                        "name": "Kuchurhan",
                        "latitude": "47.16302000",
                        "longitude": "29.78937000"
                    },
                    {
                        "id": 109883,
                        "name": "Kulevcha",
                        "latitude": "46.03034000",
                        "longitude": "29.93614000"
                    },
                    {
                        "id": 109889,
                        "name": "Kurisove",
                        "latitude": "46.96951000",
                        "longitude": "30.95914000"
                    },
                    {
                        "id": 109953,
                        "name": "Lymanske",
                        "latitude": "46.65570000",
                        "longitude": "29.96722000"
                    },
                    {
                        "id": 109962,
                        "name": "Lyubashivka",
                        "latitude": "47.83716000",
                        "longitude": "30.25976000"
                    },
                    {
                        "id": 110009,
                        "name": "Mayaky",
                        "latitude": "46.41748000",
                        "longitude": "30.27413000"
                    },
                    {
                        "id": 110072,
                        "name": "Mykolayivka",
                        "latitude": "47.54135000",
                        "longitude": "30.75615000"
                    },
                    {
                        "id": 110073,
                        "name": "Mykolayivs’kyy Rayon",
                        "latitude": "47.46720000",
                        "longitude": "30.60283000"
                    },
                    {
                        "id": 110117,
                        "name": "Novi Troyany",
                        "latitude": "45.94275000",
                        "longitude": "28.85628000"
                    },
                    {
                        "id": 110177,
                        "name": "Odesa",
                        "latitude": "46.47747000",
                        "longitude": "30.73262000"
                    },
                    {
                        "id": 110181,
                        "name": "Okny",
                        "latitude": "47.54044000",
                        "longitude": "29.46001000"
                    },
                    {
                        "id": 110188,
                        "name": "Oleksandrivka",
                        "latitude": "46.32893000",
                        "longitude": "30.63481000"
                    },
                    {
                        "id": 110213,
                        "name": "Ovidiopol",
                        "latitude": "46.24998000",
                        "longitude": "30.44127000"
                    },
                    {
                        "id": 110218,
                        "name": "Ozerne",
                        "latitude": "45.40300000",
                        "longitude": "28.67546000"
                    },
                    {
                        "id": 110253,
                        "name": "Peschana",
                        "latitude": "48.12918000",
                        "longitude": "29.73086000"
                    },
                    {
                        "id": 110276,
                        "name": "Plakhtiyivka",
                        "latitude": "46.10060000",
                        "longitude": "29.72169000"
                    },
                    {
                        "id": 110285,
                        "name": "Podil’s’k",
                        "latitude": "47.75305000",
                        "longitude": "29.53205000"
                    },
                    {
                        "id": 110284,
                        "name": "Podilsk Raion",
                        "latitude": "47.71642000",
                        "longitude": "29.54509000"
                    },
                    {
                        "id": 110351,
                        "name": "Reni",
                        "latitude": "45.45623000",
                        "longitude": "28.27914000"
                    },
                    {
                        "id": 110377,
                        "name": "Rozdil’na",
                        "latitude": "46.84334000",
                        "longitude": "30.07919000"
                    },
                    {
                        "id": 110404,
                        "name": "Salhany",
                        "latitude": "46.14881000",
                        "longitude": "30.34601000"
                    },
                    {
                        "id": 110406,
                        "name": "Sarata",
                        "latitude": "46.01966000",
                        "longitude": "29.66567000"
                    },
                    {
                        "id": 110410,
                        "name": "Savran",
                        "latitude": "48.13219000",
                        "longitude": "30.08247000"
                    },
                    {
                        "id": 110425,
                        "name": "Serhiyivka",
                        "latitude": "46.02720000",
                        "longitude": "30.37682000"
                    },
                    {
                        "id": 110426,
                        "name": "Serpneve",
                        "latitude": "46.30094000",
                        "longitude": "29.01958000"
                    },
                    {
                        "id": 110427,
                        "name": "Shabo",
                        "latitude": "46.13262000",
                        "longitude": "30.38595000"
                    },
                    {
                        "id": 110444,
                        "name": "Shevchenkove",
                        "latitude": "45.55604000",
                        "longitude": "29.33357000"
                    },
                    {
                        "id": 110457,
                        "name": "Shyryayeve",
                        "latitude": "47.38052000",
                        "longitude": "30.19638000"
                    },
                    {
                        "id": 110482,
                        "name": "Slobidka",
                        "latitude": "47.88694000",
                        "longitude": "29.34611000"
                    },
                    {
                        "id": 110534,
                        "name": "Starokozache",
                        "latitude": "46.33722000",
                        "longitude": "29.98528000"
                    },
                    {
                        "id": 110548,
                        "name": "Stepanivka",
                        "latitude": "46.79489000",
                        "longitude": "29.98684000"
                    },
                    {
                        "id": 110550,
                        "name": "Stepove",
                        "latitude": "46.70385000",
                        "longitude": "30.07919000"
                    },
                    {
                        "id": 110591,
                        "name": "Tarutyne",
                        "latitude": "46.18636000",
                        "longitude": "29.15203000"
                    },
                    {
                        "id": 110592,
                        "name": "Tatarbunary",
                        "latitude": "45.83731000",
                        "longitude": "29.61424000"
                    },
                    {
                        "id": 110594,
                        "name": "Tayirove",
                        "latitude": "46.36313000",
                        "longitude": "30.64891000"
                    },
                    {
                        "id": 110598,
                        "name": "Teplodar",
                        "latitude": "46.50585000",
                        "longitude": "30.32521000"
                    },
                    {
                        "id": 110660,
                        "name": "Usatove",
                        "latitude": "46.53296000",
                        "longitude": "30.65960000"
                    },
                    {
                        "id": 110686,
                        "name": "Velyka Mykhaylivka",
                        "latitude": "47.07971000",
                        "longitude": "29.85753000"
                    },
                    {
                        "id": 110693,
                        "name": "Velykoploske",
                        "latitude": "47.01254000",
                        "longitude": "29.67171000"
                    },
                    {
                        "id": 110755,
                        "name": "Vylkove",
                        "latitude": "45.40214000",
                        "longitude": "29.58595000"
                    },
                    {
                        "id": 110759,
                        "name": "Vynohradivka",
                        "latitude": "45.68119000",
                        "longitude": "28.57138000"
                    },
                    {
                        "id": 110804,
                        "name": "Yuzhne",
                        "latitude": "46.62211000",
                        "longitude": "31.10131000"
                    },
                    {
                        "id": 110808,
                        "name": "Zagnitkiv",
                        "latitude": "48.04878000",
                        "longitude": "28.89234000"
                    },
                    {
                        "id": 110810,
                        "name": "Zakharivka",
                        "latitude": "47.33232000",
                        "longitude": "29.75903000"
                    },
                    {
                        "id": 110815,
                        "name": "Zaliznychne",
                        "latitude": "45.74890000",
                        "longitude": "28.61466000"
                    },
                    {
                        "id": 110826,
                        "name": "Zatoka",
                        "latitude": "46.07251000",
                        "longitude": "30.46538000"
                    },
                    {
                        "id": 110827,
                        "name": "Zatyshshya",
                        "latitude": "47.33351000",
                        "longitude": "29.87327000"
                    },
                    {
                        "id": 110865,
                        "name": "Zorya",
                        "latitude": "45.99080000",
                        "longitude": "29.69672000"
                    }
                ]
            },
            {
                "id": 5071,
                "name": "Poltavska",
                "iso2": "53",
                "latitude": "49.64291960",
                "longitude": "32.66753390",
                "type": "region",
                "cities": [
                    {
                        "id": 149311,
                        "name": "Abramok",
                        "latitude": "50.63694444",
                        "longitude": "27.90750000"
                    },
                    {
                        "id": 149312,
                        "name": "Adamivka",
                        "latitude": "50.37694444",
                        "longitude": "27.91527778"
                    },
                    {
                        "id": 149313,
                        "name": "Adamove",
                        "latitude": "50.83111111",
                        "longitude": "27.48305556"
                    },
                    {
                        "id": 149314,
                        "name": "Agativka",
                        "latitude": "49.98611111",
                        "longitude": "28.60500000"
                    },
                    {
                        "id": 149315,
                        "name": "Andriyivka",
                        "latitude": "49.76293844",
                        "longitude": "34.30037490"
                    },
                    {
                        "id": 149316,
                        "name": "Andrushivka",
                        "latitude": "50.01666667",
                        "longitude": "29.01666667"
                    },
                    {
                        "id": 149317,
                        "name": "Autozavodskoy Raion",
                        "latitude": "49.07173000",
                        "longitude": "33.41552000"
                    },
                    {
                        "id": 149318,
                        "name": "Avratin",
                        "latitude": "49.87611111",
                        "longitude": "27.82638889"
                    },
                    {
                        "id": 149319,
                        "name": "Bairak",
                        "latitude": "49.72043437",
                        "longitude": "34.37378921"
                    },
                    {
                        "id": 149320,
                        "name": "Baliasne",
                        "latitude": "49.82119646",
                        "longitude": "34.33881183"
                    },
                    {
                        "id": 149323,
                        "name": "Barashi",
                        "latitude": "50.71555556",
                        "longitude": "28.03083333"
                    },
                    {
                        "id": 149324,
                        "name": "Bazar",
                        "latitude": "51.04388889",
                        "longitude": "29.29361111"
                    },
                    {
                        "id": 149325,
                        "name": "Bekhi",
                        "latitude": "51.01972222",
                        "longitude": "28.69333333"
                    },
                    {
                        "id": 149326,
                        "name": "Berdychiv",
                        "latitude": "49.89194444",
                        "longitude": "28.60000000"
                    },
                    {
                        "id": 149327,
                        "name": "Berestivka",
                        "latitude": "50.34055556",
                        "longitude": "27.47611111"
                    },
                    {
                        "id": 149328,
                        "name": "Berestovets",
                        "latitude": "51.02000000",
                        "longitude": "28.87027778"
                    },
                    {
                        "id": 149329,
                        "name": "Berezianka",
                        "latitude": "49.69194444",
                        "longitude": "29.45305556"
                    },
                    {
                        "id": 149330,
                        "name": "Berezovii Grud",
                        "latitude": "50.99666667",
                        "longitude": "28.35888889"
                    },
                    {
                        "id": 149331,
                        "name": "Bereztsi",
                        "latitude": "50.50555556",
                        "longitude": "29.31750000"
                    },
                    {
                        "id": 149332,
                        "name": "Bicheva",
                        "latitude": "49.75055556",
                        "longitude": "27.77777778"
                    },
                    {
                        "id": 149333,
                        "name": "Bigun",
                        "latitude": "51.40194444",
                        "longitude": "28.28277778"
                    },
                    {
                        "id": 149334,
                        "name": "Bikiv",
                        "latitude": "50.17833333",
                        "longitude": "29.29638889"
                    },
                    {
                        "id": 149335,
                        "name": "Bila Krynytsia",
                        "latitude": "50.63638889",
                        "longitude": "29.46361111"
                    },
                    {
                        "id": 149336,
                        "name": "Bilii Bereg",
                        "latitude": "50.75638889",
                        "longitude": "29.47888889"
                    },
                    {
                        "id": 149337,
                        "name": "Bilka",
                        "latitude": "50.81861111",
                        "longitude": "28.18777778"
                    },
                    {
                        "id": 149338,
                        "name": "Bilylivka",
                        "latitude": "49.68000000",
                        "longitude": "29.03000000"
                    },
                    {
                        "id": 149339,
                        "name": "Bistrik",
                        "latitude": "49.85638889",
                        "longitude": "28.56638889"
                    },
                    {
                        "id": 149340,
                        "name": "Bistriyivka",
                        "latitude": "50.47777778",
                        "longitude": "29.16472222"
                    },
                    {
                        "id": 149341,
                        "name": "Borisivka",
                        "latitude": "49.76934347",
                        "longitude": "34.33837579"
                    },
                    {
                        "id": 149342,
                        "name": "Broniki",
                        "latitude": "50.55361111",
                        "longitude": "27.80777778"
                    },
                    {
                        "id": 149344,
                        "name": "Bronitsia",
                        "latitude": "50.94666667",
                        "longitude": "27.34527778"
                    },
                    {
                        "id": 149343,
                        "name": "Bronitska Guta",
                        "latitude": "50.93138889",
                        "longitude": "27.31388889"
                    },
                    {
                        "id": 149345,
                        "name": "Brovki Pershi",
                        "latitude": "49.93194444",
                        "longitude": "29.19750000"
                    },
                    {
                        "id": 149346,
                        "name": "Brusyliv",
                        "latitude": "50.28333333",
                        "longitude": "29.53333333"
                    },
                    {
                        "id": 149347,
                        "name": "Buchmany",
                        "latitude": "51.07000000",
                        "longitude": "28.04250000"
                    },
                    {
                        "id": 149348,
                        "name": "Buki",
                        "latitude": "50.19638889",
                        "longitude": "28.32500000"
                    },
                    {
                        "id": 149349,
                        "name": "Buldichiv",
                        "latitude": "50.11361111",
                        "longitude": "27.79666667"
                    },
                    {
                        "id": 149350,
                        "name": "Buriaki",
                        "latitude": "49.81888889",
                        "longitude": "28.28361111"
                    },
                    {
                        "id": 149351,
                        "name": "Burkivtsi",
                        "latitude": "49.87888889",
                        "longitude": "28.04444444"
                    },
                    {
                        "id": 149352,
                        "name": "Bykivka",
                        "latitude": "50.29277778",
                        "longitude": "27.98305556"
                    },
                    {
                        "id": 149353,
                        "name": "Chernechii Iar",
                        "latitude": "49.83543000",
                        "longitude": "34.59174000"
                    },
                    {
                        "id": 149354,
                        "name": "Cherniakhiv",
                        "latitude": "50.45500000",
                        "longitude": "28.66527778"
                    },
                    {
                        "id": 149355,
                        "name": "Chervone",
                        "latitude": "49.94972222",
                        "longitude": "28.86861111"
                    },
                    {
                        "id": 149356,
                        "name": "Chopovychi",
                        "latitude": "50.83333333",
                        "longitude": "28.95250000"
                    },
                    {
                        "id": 149357,
                        "name": "Chornukhy",
                        "latitude": "50.26990573",
                        "longitude": "32.94757796"
                    },
                    {
                        "id": 149358,
                        "name": "Chudniv",
                        "latitude": "50.05277778",
                        "longitude": "28.09694444"
                    },
                    {
                        "id": 149359,
                        "name": "Chutove",
                        "latitude": "49.71689367",
                        "longitude": "35.17463951"
                    },
                    {
                        "id": 149360,
                        "name": "Dashynka",
                        "latitude": "50.64944444",
                        "longitude": "28.39500000"
                    },
                    {
                        "id": 149361,
                        "name": "Davidivka",
                        "latitude": "50.52694444",
                        "longitude": "28.41000000"
                    },
                    {
                        "id": 149362,
                        "name": "Davydky",
                        "latitude": "50.94888889",
                        "longitude": "28.43861111"
                    },
                    {
                        "id": 149363,
                        "name": "Denyshi",
                        "latitude": "50.21527778",
                        "longitude": "28.40777778"
                    },
                    {
                        "id": 149364,
                        "name": "Derhanivka",
                        "latitude": "49.69222222",
                        "longitude": "29.06333333"
                    },
                    {
                        "id": 149365,
                        "name": "Dibrova",
                        "latitude": "51.16027778",
                        "longitude": "27.97277778"
                    },
                    {
                        "id": 149366,
                        "name": "Didkovichi",
                        "latitude": "51.09972222",
                        "longitude": "28.83194444"
                    },
                    {
                        "id": 149367,
                        "name": "Didovichi",
                        "latitude": "50.60916667",
                        "longitude": "27.35583333"
                    },
                    {
                        "id": 149368,
                        "name": "Divochki",
                        "latitude": "50.44694444",
                        "longitude": "28.74972222"
                    },
                    {
                        "id": 149369,
                        "name": "Dovbysh",
                        "latitude": "50.37223889",
                        "longitude": "27.98947500"
                    },
                    {
                        "id": 149370,
                        "name": "Druzhba",
                        "latitude": "51.18611111",
                        "longitude": "27.96611111"
                    },
                    {
                        "id": 149371,
                        "name": "Dubivka",
                        "latitude": "49.90861111",
                        "longitude": "28.78444444"
                    },
                    {
                        "id": 149372,
                        "name": "Dubnyki",
                        "latitude": "50.87416667",
                        "longitude": "27.34888889"
                    },
                    {
                        "id": 149373,
                        "name": "Dubrivka",
                        "latitude": "50.28527778",
                        "longitude": "29.59333333"
                    },
                    {
                        "id": 149374,
                        "name": "Dvorishche",
                        "latitude": "50.56194444",
                        "longitude": "28.39777778"
                    },
                    {
                        "id": 149375,
                        "name": "Dykanka",
                        "latitude": "49.82223788",
                        "longitude": "34.53408003"
                    },
                    {
                        "id": 149376,
                        "name": "Elivka",
                        "latitude": "50.72722222",
                        "longitude": "29.18388889"
                    },
                    {
                        "id": 149377,
                        "name": "Fedorivka",
                        "latitude": "49.77617039",
                        "longitude": "34.43944548"
                    },
                    {
                        "id": 149378,
                        "name": "Filenkove",
                        "latitude": "49.83559723",
                        "longitude": "35.00298408"
                    },
                    {
                        "id": 149379,
                        "name": "Glinivtsi",
                        "latitude": "50.04611111",
                        "longitude": "28.80416667"
                    },
                    {
                        "id": 149380,
                        "name": "Godikha",
                        "latitude": "50.19027778",
                        "longitude": "28.22194444"
                    },
                    {
                        "id": 149381,
                        "name": "Golovenka",
                        "latitude": "50.15361111",
                        "longitude": "28.54388889"
                    },
                    {
                        "id": 149382,
                        "name": "Golovki",
                        "latitude": "50.83972222",
                        "longitude": "29.13333333"
                    },
                    {
                        "id": 149383,
                        "name": "Golubyatin",
                        "latitude": "49.85500000",
                        "longitude": "29.51361111"
                    },
                    {
                        "id": 149384,
                        "name": "Gorbuliv",
                        "latitude": "50.53750000",
                        "longitude": "28.92333333"
                    },
                    {
                        "id": 149385,
                        "name": "Gordiyivka",
                        "latitude": "50.05444444",
                        "longitude": "27.87500000"
                    },
                    {
                        "id": 149386,
                        "name": "Gorianshchina",
                        "latitude": "49.91185729",
                        "longitude": "34.45818988"
                    },
                    {
                        "id": 149387,
                        "name": "Gorodkivka",
                        "latitude": "49.90972222",
                        "longitude": "28.99416667"
                    },
                    {
                        "id": 149388,
                        "name": "Gorodok",
                        "latitude": "49.60027778",
                        "longitude": "29.19500000"
                    },
                    {
                        "id": 149389,
                        "name": "Gorodske",
                        "latitude": "50.37750000",
                        "longitude": "29.16888889"
                    },
                    {
                        "id": 149390,
                        "name": "Goropayi",
                        "latitude": "50.01388889",
                        "longitude": "27.83388889"
                    },
                    {
                        "id": 149391,
                        "name": "Goshiv",
                        "latitude": "51.23916667",
                        "longitude": "28.71388889"
                    },
                    {
                        "id": 149392,
                        "name": "Gromada",
                        "latitude": "49.94638889",
                        "longitude": "27.76222222"
                    },
                    {
                        "id": 149393,
                        "name": "Grozyne",
                        "latitude": "50.95888889",
                        "longitude": "28.73055556"
                    },
                    {
                        "id": 149394,
                        "name": "Grushki",
                        "latitude": "50.49277778",
                        "longitude": "28.45500000"
                    },
                    {
                        "id": 149395,
                        "name": "Gubske",
                        "latitude": "50.09951906",
                        "longitude": "32.83123218"
                    },
                    {
                        "id": 149396,
                        "name": "Gulsk",
                        "latitude": "50.51916667",
                        "longitude": "27.72111111"
                    },
                    {
                        "id": 149397,
                        "name": "Gumenniki",
                        "latitude": "50.39694444",
                        "longitude": "28.92666667"
                    },
                    {
                        "id": 149398,
                        "name": "Guta-Potiyivka",
                        "latitude": "50.69111111",
                        "longitude": "28.87416667"
                    },
                    {
                        "id": 149399,
                        "name": "Guto-Mariatin",
                        "latitude": "51.03000000",
                        "longitude": "29.41666667"
                    },
                    {
                        "id": 149400,
                        "name": "Hadiach",
                        "latitude": "50.36666667",
                        "longitude": "34.00000000"
                    },
                    {
                        "id": 149401,
                        "name": "Hlobyne",
                        "latitude": "49.38856468",
                        "longitude": "33.26320863"
                    },
                    {
                        "id": 149402,
                        "name": "Holovyne",
                        "latitude": "50.47250000",
                        "longitude": "28.82805556"
                    },
                    {
                        "id": 149403,
                        "name": "Holubivka",
                        "latitude": "49.68097000",
                        "longitude": "29.16059000"
                    },
                    {
                        "id": 149404,
                        "name": "Horishni Plavni",
                        "latitude": "49.01066008",
                        "longitude": "33.65624556"
                    },
                    {
                        "id": 149405,
                        "name": "Horodets",
                        "latitude": "51.37000000",
                        "longitude": "28.24138889"
                    },
                    {
                        "id": 149406,
                        "name": "Horodnytsia",
                        "latitude": "50.80944444",
                        "longitude": "27.31833333"
                    },
                    {
                        "id": 149407,
                        "name": "Hradyzk",
                        "latitude": "49.23306925",
                        "longitude": "33.13203713"
                    },
                    {
                        "id": 149408,
                        "name": "Hranitne",
                        "latitude": "50.74277778",
                        "longitude": "29.35222222"
                    },
                    {
                        "id": 149409,
                        "name": "Hrebinka",
                        "latitude": "50.11799594",
                        "longitude": "32.43958508"
                    },
                    {
                        "id": 149410,
                        "name": "Hryshkivtsi",
                        "latitude": "49.93555556",
                        "longitude": "28.60166667"
                    },
                    {
                        "id": 149411,
                        "name": "Iemilivka",
                        "latitude": "50.68777778",
                        "longitude": "28.72805556"
                    },
                    {
                        "id": 149412,
                        "name": "Ievgenivka",
                        "latitude": "50.63833333",
                        "longitude": "27.99833333"
                    },
                    {
                        "id": 149413,
                        "name": "Irshansk",
                        "latitude": "50.71666667",
                        "longitude": "28.71666667"
                    },
                    {
                        "id": 149414,
                        "name": "Ivanivka",
                        "latitude": "50.43777778",
                        "longitude": "27.62944444"
                    },
                    {
                        "id": 149415,
                        "name": "Ivankiv",
                        "latitude": "50.39611111",
                        "longitude": "28.56888889"
                    },
                    {
                        "id": 149416,
                        "name": "Ivanopil",
                        "latitude": "49.85861111",
                        "longitude": "28.21555556"
                    },
                    {
                        "id": 149417,
                        "name": "Kamiani Potoky",
                        "latitude": "48.98589514",
                        "longitude": "33.51862610"
                    },
                    {
                        "id": 149418,
                        "name": "Kardashivka",
                        "latitude": "49.88384899",
                        "longitude": "34.64044604"
                    },
                    {
                        "id": 149419,
                        "name": "Karlivka",
                        "latitude": "49.45474986",
                        "longitude": "35.13079636"
                    },
                    {
                        "id": 149420,
                        "name": "Khodaky",
                        "latitude": "50.97805556",
                        "longitude": "28.80666667"
                    },
                    {
                        "id": 149421,
                        "name": "Khorol",
                        "latitude": "49.78403100",
                        "longitude": "33.25886100"
                    },
                    {
                        "id": 149422,
                        "name": "Khoroshiv",
                        "latitude": "50.60000000",
                        "longitude": "28.45000000"
                    },
                    {
                        "id": 149423,
                        "name": "Kobeliaky",
                        "latitude": "49.14736024",
                        "longitude": "34.19927008"
                    },
                    {
                        "id": 149424,
                        "name": "Kononenki",
                        "latitude": "49.91143501",
                        "longitude": "34.51172749"
                    },
                    {
                        "id": 149425,
                        "name": "Korchak",
                        "latitude": "50.21250000",
                        "longitude": "28.47638889"
                    },
                    {
                        "id": 149426,
                        "name": "Kornyn",
                        "latitude": "50.09527778",
                        "longitude": "29.53583333"
                    },
                    {
                        "id": 149427,
                        "name": "Korosten",
                        "latitude": "50.95000000",
                        "longitude": "28.65000000"
                    },
                    {
                        "id": 149428,
                        "name": "Korostyshiv",
                        "latitude": "50.31861111",
                        "longitude": "29.05916667"
                    },
                    {
                        "id": 149429,
                        "name": "Kotelva",
                        "latitude": "50.06832759",
                        "longitude": "34.75921130"
                    },
                    {
                        "id": 149430,
                        "name": "Kozelshchyna",
                        "latitude": "49.21550000",
                        "longitude": "33.85180000"
                    },
                    {
                        "id": 149431,
                        "name": "Kratova Govtva",
                        "latitude": "49.87362868",
                        "longitude": "34.50805284"
                    },
                    {
                        "id": 149432,
                        "name": "Kremenchuk",
                        "latitude": "49.07750000",
                        "longitude": "33.42388889"
                    },
                    {
                        "id": 149433,
                        "name": "Krukovskiy Raion",
                        "latitude": "49.06672000",
                        "longitude": "33.45320000"
                    },
                    {
                        "id": 149434,
                        "name": "Kucherivka",
                        "latitude": "49.74801949",
                        "longitude": "34.29072744"
                    },
                    {
                        "id": 149435,
                        "name": "Kupech",
                        "latitude": "50.99611111",
                        "longitude": "28.78472222"
                    },
                    {
                        "id": 149436,
                        "name": "Kvitneve",
                        "latitude": "49.98472222",
                        "longitude": "29.51583333"
                    },
                    {
                        "id": 149437,
                        "name": "Landari",
                        "latitude": "49.78295521",
                        "longitude": "34.38817299"
                    },
                    {
                        "id": 149438,
                        "name": "Lani",
                        "latitude": "49.71283212",
                        "longitude": "34.43433283"
                    },
                    {
                        "id": 149439,
                        "name": "Lasky",
                        "latitude": "51.26555556",
                        "longitude": "28.95638889"
                    },
                    {
                        "id": 149440,
                        "name": "Lazarivka",
                        "latitude": "50.31250000",
                        "longitude": "29.58583333"
                    },
                    {
                        "id": 149441,
                        "name": "Lisogirka",
                        "latitude": "49.75916667",
                        "longitude": "27.90305556"
                    },
                    {
                        "id": 149442,
                        "name": "Liubar",
                        "latitude": "49.92138889",
                        "longitude": "27.75833333"
                    },
                    {
                        "id": 149443,
                        "name": "Lokhvytsia",
                        "latitude": "50.36104610",
                        "longitude": "33.26517113"
                    },
                    {
                        "id": 149444,
                        "name": "Lubny",
                        "latitude": "50.01856413",
                        "longitude": "32.98686035"
                    },
                    {
                        "id": 149445,
                        "name": "Luhyny",
                        "latitude": "51.06666667",
                        "longitude": "28.38333333"
                    },
                    {
                        "id": 149446,
                        "name": "Lutovynivka",
                        "latitude": "49.23722222",
                        "longitude": "33.90500000"
                    },
                    {
                        "id": 149447,
                        "name": "Mala Rudka",
                        "latitude": "49.73993159",
                        "longitude": "34.44651297"
                    },
                    {
                        "id": 149448,
                        "name": "Malyn",
                        "latitude": "50.76888889",
                        "longitude": "29.27000000"
                    },
                    {
                        "id": 149449,
                        "name": "Marchenki",
                        "latitude": "49.84310165",
                        "longitude": "34.38291991"
                    },
                    {
                        "id": 149450,
                        "name": "Markivka",
                        "latitude": "49.30247078",
                        "longitude": "34.07348137"
                    },
                    {
                        "id": 149451,
                        "name": "Maschiwka",
                        "latitude": "49.44491715",
                        "longitude": "34.87575392"
                    },
                    {
                        "id": 149452,
                        "name": "Morozivka",
                        "latitude": "50.67138889",
                        "longitude": "27.45166667"
                    },
                    {
                        "id": 149453,
                        "name": "Myrhorod",
                        "latitude": "49.96397912",
                        "longitude": "33.61238091"
                    },
                    {
                        "id": 149454,
                        "name": "Myropil",
                        "latitude": "50.10750000",
                        "longitude": "27.70583333"
                    },
                    {
                        "id": 149455,
                        "name": "Narodychi",
                        "latitude": "51.20231667",
                        "longitude": "29.08139444"
                    },
                    {
                        "id": 149456,
                        "name": "Nedoharky",
                        "latitude": "49.16921500",
                        "longitude": "33.25495000"
                    },
                    {
                        "id": 149457,
                        "name": "Nemyryntsi",
                        "latitude": "49.62000000",
                        "longitude": "29.05000000"
                    },
                    {
                        "id": 149458,
                        "name": "Nova Borova",
                        "latitude": "50.69222222",
                        "longitude": "28.63666667"
                    },
                    {
                        "id": 149459,
                        "name": "Nova Chortoriia",
                        "latitude": "50.02830000",
                        "longitude": "27.70810000"
                    },
                    {
                        "id": 149460,
                        "name": "Novi Bilokorovychi",
                        "latitude": "51.04750000",
                        "longitude": "28.05194444"
                    },
                    {
                        "id": 149461,
                        "name": "Novi Sanzhary",
                        "latitude": "49.33539098",
                        "longitude": "34.31619855"
                    },
                    {
                        "id": 149462,
                        "name": "Novi Vorobyi",
                        "latitude": "50.86972222",
                        "longitude": "29.34333333"
                    },
                    {
                        "id": 149463,
                        "name": "Novohrad-Volynskyi",
                        "latitude": "50.58333333",
                        "longitude": "27.63333333"
                    },
                    {
                        "id": 149464,
                        "name": "Novoozerianka",
                        "latitude": "51.21333333",
                        "longitude": "28.00194444"
                    },
                    {
                        "id": 149465,
                        "name": "Nyvky",
                        "latitude": "51.35000000",
                        "longitude": "29.11666667"
                    },
                    {
                        "id": 149466,
                        "name": "Odariukivka",
                        "latitude": "49.73973669",
                        "longitude": "34.35914676"
                    },
                    {
                        "id": 149467,
                        "name": "Olefirshchina",
                        "latitude": "49.88598650",
                        "longitude": "34.58571058"
                    },
                    {
                        "id": 149468,
                        "name": "Olevsk",
                        "latitude": "51.22777778",
                        "longitude": "27.64805556"
                    },
                    {
                        "id": 149469,
                        "name": "Onatski",
                        "latitude": "49.88676376",
                        "longitude": "34.46003707"
                    },
                    {
                        "id": 149470,
                        "name": "Opishnia",
                        "latitude": "49.95635316",
                        "longitude": "34.61200414"
                    },
                    {
                        "id": 149471,
                        "name": "Orzhytsia",
                        "latitude": "49.79097957",
                        "longitude": "32.70152650"
                    },
                    {
                        "id": 149472,
                        "name": "Ovruch",
                        "latitude": "51.32444444",
                        "longitude": "28.80805556"
                    },
                    {
                        "id": 149473,
                        "name": "Ozerne",
                        "latitude": "50.17944444",
                        "longitude": "28.73611111"
                    },
                    {
                        "id": 149474,
                        "name": "Pavoloch",
                        "latitude": "49.86916667",
                        "longitude": "29.44916667"
                    },
                    {
                        "id": 149475,
                        "name": "Pershotravensk",
                        "latitude": "50.20111111",
                        "longitude": "27.63388889"
                    },
                    {
                        "id": 149476,
                        "name": "Pershotravneve",
                        "latitude": "51.38916667",
                        "longitude": "28.86250000"
                    },
                    {
                        "id": 149477,
                        "name": "Petrenki",
                        "latitude": "49.73164740",
                        "longitude": "34.33764355"
                    },
                    {
                        "id": 149478,
                        "name": "Pisarivshchina",
                        "latitude": "49.85532915",
                        "longitude": "34.63195588"
                    },
                    {
                        "id": 149479,
                        "name": "Pishchiv",
                        "latitude": "50.60555556",
                        "longitude": "27.31694444"
                    },
                    {
                        "id": 149480,
                        "name": "Polianka",
                        "latitude": "50.25620278",
                        "longitude": "27.69518889"
                    },
                    {
                        "id": 149481,
                        "name": "Poltava",
                        "latitude": "49.57444444",
                        "longitude": "34.56861111"
                    },
                    {
                        "id": 149482,
                        "name": "Popilnia",
                        "latitude": "49.94583333",
                        "longitude": "29.45944444"
                    },
                    {
                        "id": 149483,
                        "name": "Popivka",
                        "latitude": "49.82284856",
                        "longitude": "34.36835803"
                    },
                    {
                        "id": 149484,
                        "name": "Potiivka",
                        "latitude": "50.61972222",
                        "longitude": "28.96444444"
                    },
                    {
                        "id": 149485,
                        "name": "Proni",
                        "latitude": "49.78629680",
                        "longitude": "34.54425486"
                    },
                    {
                        "id": 149486,
                        "name": "Pyriatyn",
                        "latitude": "50.24059547",
                        "longitude": "32.50929941"
                    },
                    {
                        "id": 149487,
                        "name": "Radomyshl",
                        "latitude": "50.49472222",
                        "longitude": "29.23333333"
                    },
                    {
                        "id": 149488,
                        "name": "Reshetylivka",
                        "latitude": "49.56360000",
                        "longitude": "34.07630000"
                    },
                    {
                        "id": 149489,
                        "name": "Rohachi",
                        "latitude": "49.64413000",
                        "longitude": "29.36076000"
                    },
                    {
                        "id": 149490,
                        "name": "Romaniv",
                        "latitude": "50.15166667",
                        "longitude": "27.93916667"
                    },
                    {
                        "id": 149491,
                        "name": "Romodan",
                        "latitude": "49.99487495",
                        "longitude": "33.33073071"
                    },
                    {
                        "id": 149492,
                        "name": "Ruzhyn (settlement)",
                        "latitude": "49.72333333",
                        "longitude": "29.22138889"
                    },
                    {
                        "id": 149493,
                        "name": "Schyschaky",
                        "latitude": "49.87689865",
                        "longitude": "34.00709565"
                    },
                    {
                        "id": 149494,
                        "name": "Semenivka",
                        "latitude": "49.60167044",
                        "longitude": "33.18746872"
                    },
                    {
                        "id": 149495,
                        "name": "Sencha",
                        "latitude": "50.25413446",
                        "longitude": "33.35250701"
                    },
                    {
                        "id": 149496,
                        "name": "Shumsk",
                        "latitude": "50.11944444",
                        "longitude": "26.11666667"
                    },
                    {
                        "id": 149497,
                        "name": "Slovechne",
                        "latitude": "51.38111111",
                        "longitude": "28.35444444"
                    },
                    {
                        "id": 149498,
                        "name": "Smolovivshchina",
                        "latitude": "49.06810000",
                        "longitude": "34.43803000"
                    },
                    {
                        "id": 149499,
                        "name": "Sokhatska Balka",
                        "latitude": "49.79953582",
                        "longitude": "34.36245495"
                    },
                    {
                        "id": 149500,
                        "name": "Stepanivka",
                        "latitude": "49.75900311",
                        "longitude": "34.42956716"
                    },
                    {
                        "id": 149501,
                        "name": "Sudivka",
                        "latitude": "49.75552151",
                        "longitude": "34.49162461"
                    },
                    {
                        "id": 149502,
                        "name": "Tabory",
                        "latitude": "50.27833333",
                        "longitude": "27.59750000"
                    },
                    {
                        "id": 149503,
                        "name": "Taraschanka",
                        "latitude": "50.64583333",
                        "longitude": "27.51500000"
                    },
                    {
                        "id": 149504,
                        "name": "Topory",
                        "latitude": "49.65361111",
                        "longitude": "29.31333333"
                    },
                    {
                        "id": 149505,
                        "name": "Travneve",
                        "latitude": "50.42611111",
                        "longitude": "29.08000000"
                    },
                    {
                        "id": 149506,
                        "name": "Troiany",
                        "latitude": "49.84137052",
                        "longitude": "34.46811957"
                    },
                    {
                        "id": 149507,
                        "name": "Vasilivka",
                        "latitude": "49.82960962",
                        "longitude": "34.45204549"
                    },
                    {
                        "id": 149508,
                        "name": "Velika Rudka",
                        "latitude": "49.74811105",
                        "longitude": "34.46531945"
                    },
                    {
                        "id": 149509,
                        "name": "Veliki Budishcha",
                        "latitude": "49.85606039",
                        "longitude": "34.58307084"
                    },
                    {
                        "id": 149510,
                        "name": "Velyka Bahachka",
                        "latitude": "49.79438338",
                        "longitude": "33.72074263"
                    },
                    {
                        "id": 149511,
                        "name": "Velyki Korovyntsi",
                        "latitude": "49.97138889",
                        "longitude": "28.29472222"
                    },
                    {
                        "id": 149512,
                        "name": "Velyki Sorochyntsi",
                        "latitude": "50.02530458",
                        "longitude": "33.94765459"
                    },
                    {
                        "id": 149513,
                        "name": "Veresna",
                        "latitude": "50.38222222",
                        "longitude": "27.30750000"
                    },
                    {
                        "id": 149514,
                        "name": "Veselivka",
                        "latitude": "49.73583840",
                        "longitude": "34.49733875"
                    },
                    {
                        "id": 149515,
                        "name": "Virlya",
                        "latitude": "50.34111111",
                        "longitude": "27.70083333"
                    },
                    {
                        "id": 149516,
                        "name": "Vodiana Balka",
                        "latitude": "49.90247078",
                        "longitude": "34.48073506"
                    },
                    {
                        "id": 149517,
                        "name": "Yablunets",
                        "latitude": "50.80000000",
                        "longitude": "28.06666667"
                    },
                    {
                        "id": 149518,
                        "name": "Yarun",
                        "latitude": "50.54333333",
                        "longitude": "27.46611111"
                    },
                    {
                        "id": 149519,
                        "name": "Yemilchyne",
                        "latitude": "50.87083333",
                        "longitude": "27.80277778"
                    },
                    {
                        "id": 149520,
                        "name": "Zabaro-Davidivka",
                        "latitude": "50.97027778",
                        "longitude": "27.45305556"
                    },
                    {
                        "id": 149521,
                        "name": "Zadovga",
                        "latitude": "49.27884000",
                        "longitude": "33.91136000"
                    },
                    {
                        "id": 149522,
                        "name": "Zakrinichchia",
                        "latitude": "50.40000000",
                        "longitude": "27.28416667"
                    },
                    {
                        "id": 149523,
                        "name": "Zalissia",
                        "latitude": "51.26444444",
                        "longitude": "29.19805556"
                    },
                    {
                        "id": 149524,
                        "name": "Zaliznia",
                        "latitude": "50.15000000",
                        "longitude": "28.52222222"
                    },
                    {
                        "id": 149525,
                        "name": "Zaluzhne",
                        "latitude": "50.23833333",
                        "longitude": "27.96805556"
                    },
                    {
                        "id": 149526,
                        "name": "Zapadnia",
                        "latitude": "50.19055556",
                        "longitude": "29.32916667"
                    },
                    {
                        "id": 149527,
                        "name": "Zarichchia",
                        "latitude": "49.71111111",
                        "longitude": "29.22888889"
                    },
                    {
                        "id": 149528,
                        "name": "Zarudintsi",
                        "latitude": "49.65333333",
                        "longitude": "29.19222222"
                    },
                    {
                        "id": 149529,
                        "name": "Zavodske",
                        "latitude": "50.40019868",
                        "longitude": "33.39081277"
                    },
                    {
                        "id": 149530,
                        "name": "Zbranki",
                        "latitude": "51.29833333",
                        "longitude": "28.64583333"
                    },
                    {
                        "id": 149531,
                        "name": "Zdorovets",
                        "latitude": "50.90694444",
                        "longitude": "27.88611111"
                    },
                    {
                        "id": 149532,
                        "name": "Zherdeli",
                        "latitude": "49.89888889",
                        "longitude": "28.97000000"
                    },
                    {
                        "id": 149533,
                        "name": "Zhitintsi",
                        "latitude": "49.91388889",
                        "longitude": "27.57194444"
                    },
                    {
                        "id": 149534,
                        "name": "Zhovte",
                        "latitude": "50.40444444",
                        "longitude": "27.82166667"
                    },
                    {
                        "id": 149535,
                        "name": "Zhovtii Brid",
                        "latitude": "50.28361111",
                        "longitude": "28.10638889"
                    },
                    {
                        "id": 149536,
                        "name": "Zhupanivka",
                        "latitude": "50.92750000",
                        "longitude": "28.35500000"
                    },
                    {
                        "id": 149537,
                        "name": "Zhurbintsi",
                        "latitude": "49.97944444",
                        "longitude": "28.71583333"
                    },
                    {
                        "id": 149538,
                        "name": "Zhytomyr",
                        "latitude": "50.25444444",
                        "longitude": "28.65777778"
                    },
                    {
                        "id": 149539,
                        "name": "Zinkiv",
                        "latitude": "50.20813908",
                        "longitude": "34.36684182"
                    },
                    {
                        "id": 149540,
                        "name": "Zlobichi",
                        "latitude": "50.85611111",
                        "longitude": "28.69111111"
                    },
                    {
                        "id": 149541,
                        "name": "Zoriane",
                        "latitude": "49.64916667",
                        "longitude": "29.24444444"
                    },
                    {
                        "id": 149542,
                        "name": "Zorokiv",
                        "latitude": "50.39416667",
                        "longitude": "28.62388889"
                    },
                    {
                        "id": 149543,
                        "name": "Zosimivka",
                        "latitude": "50.73888889",
                        "longitude": "27.64888889"
                    },
                    {
                        "id": 149544,
                        "name": "Zubivshchina",
                        "latitude": "50.95944444",
                        "longitude": "28.81722222"
                    },
                    {
                        "id": 149545,
                        "name": "Zvizdal",
                        "latitude": "51.17386000",
                        "longitude": "29.24655000"
                    }
                ]
            },
            {
                "id": 4683,
                "name": "Rivnenska",
                "iso2": "56",
                "latitude": "50.61990000",
                "longitude": "26.25161700",
                "type": "region",
                "cities": [
                    {
                        "id": 109535,
                        "name": "Demydivs’kyy Rayon",
                        "latitude": "50.44302000",
                        "longitude": "25.29061000"
                    },
                    {
                        "id": 109584,
                        "name": "Dubno",
                        "latitude": "50.41694000",
                        "longitude": "25.73432000"
                    },
                    {
                        "id": 109586,
                        "name": "Dubrovytsya",
                        "latitude": "51.57438000",
                        "longitude": "26.56503000"
                    },
                    {
                        "id": 109652,
                        "name": "Horodyshche",
                        "latitude": "50.63965000",
                        "longitude": "26.36573000"
                    },
                    {
                        "id": 109654,
                        "name": "Hoshcha",
                        "latitude": "50.60030000",
                        "longitude": "26.67435000"
                    },
                    {
                        "id": 109762,
                        "name": "Klevan",
                        "latitude": "50.74305000",
                        "longitude": "25.97628000"
                    },
                    {
                        "id": 109773,
                        "name": "Kolodenka",
                        "latitude": "50.58561000",
                        "longitude": "26.31601000"
                    },
                    {
                        "id": 109778,
                        "name": "Koloniya Zastav’ye",
                        "latitude": "50.81667000",
                        "longitude": "27.03333000"
                    },
                    {
                        "id": 109795,
                        "name": "Korets",
                        "latitude": "50.61655000",
                        "longitude": "27.16055000"
                    },
                    {
                        "id": 109813,
                        "name": "Kostopil’",
                        "latitude": "50.87841000",
                        "longitude": "26.45192000"
                    },
                    {
                        "id": 110041,
                        "name": "Mizoch",
                        "latitude": "50.40000000",
                        "longitude": "26.15000000"
                    },
                    {
                        "id": 110043,
                        "name": "Mlyniv",
                        "latitude": "50.50900000",
                        "longitude": "25.61675000"
                    },
                    {
                        "id": 110044,
                        "name": "Mlynivs’kyy Rayon",
                        "latitude": "50.55726000",
                        "longitude": "25.57715000"
                    },
                    {
                        "id": 110205,
                        "name": "Orzhiv",
                        "latitude": "50.80000000",
                        "longitude": "26.12000000"
                    },
                    {
                        "id": 110208,
                        "name": "Ostroh",
                        "latitude": "50.32942000",
                        "longitude": "26.51425000"
                    },
                    {
                        "id": 110210,
                        "name": "Ostroz’ka Mis’krada",
                        "latitude": "50.32726000",
                        "longitude": "26.51765000"
                    },
                    {
                        "id": 110339,
                        "name": "Radyvyliv",
                        "latitude": "50.12994000",
                        "longitude": "25.25576000"
                    },
                    {
                        "id": 110354,
                        "name": "Rivne",
                        "latitude": "50.62308000",
                        "longitude": "26.22743000"
                    },
                    {
                        "id": 110356,
                        "name": "Rivnens’ka Mis’krada",
                        "latitude": "50.61300000",
                        "longitude": "26.24588000"
                    },
                    {
                        "id": 110364,
                        "name": "Rokytne",
                        "latitude": "51.27960000",
                        "longitude": "27.21400000"
                    },
                    {
                        "id": 110407,
                        "name": "Sarny",
                        "latitude": "51.33795000",
                        "longitude": "26.60191000"
                    },
                    {
                        "id": 110589,
                        "name": "Tarakaniv",
                        "latitude": "50.37961000",
                        "longitude": "25.70843000"
                    },
                    {
                        "id": 110642,
                        "name": "Tynne",
                        "latitude": "50.60145000",
                        "longitude": "26.18486000"
                    },
                    {
                        "id": 110672,
                        "name": "Varash",
                        "latitude": "51.35090000",
                        "longitude": "25.84738000"
                    },
                    {
                        "id": 110691,
                        "name": "Velyki Mezhyrichi",
                        "latitude": "50.65431000",
                        "longitude": "26.86626000"
                    },
                    {
                        "id": 110735,
                        "name": "Volodymyrets’",
                        "latitude": "51.42130000",
                        "longitude": "26.14469000"
                    },
                    {
                        "id": 110824,
                        "name": "Zarichne",
                        "latitude": "51.81260000",
                        "longitude": "26.12902000"
                    },
                    {
                        "id": 110833,
                        "name": "Zdolbuniv",
                        "latitude": "50.52060000",
                        "longitude": "26.24251000"
                    },
                    {
                        "id": 110834,
                        "name": "Zdovbytsya",
                        "latitude": "50.49607000",
                        "longitude": "26.24111000"
                    }
                ]
            },
            {
                "id": 1912,
                "name": "Sevastopol",
                "iso2": "40",
                "latitude": "44.61665000",
                "longitude": "33.52536710",
                "type": "city",
                "cities": [
                    {
                        "id": 105829,
                        "name": "Afanas’yeva",
                        "latitude": "54.63958000",
                        "longitude": "100.61755000"
                    },
                    {
                        "id": 105830,
                        "name": "Alarskiy Rayon",
                        "latitude": "53.33333000",
                        "longitude": "103.00000000"
                    },
                    {
                        "id": 105831,
                        "name": "Alekseyevskaya",
                        "latitude": "57.85000000",
                        "longitude": "108.40000000"
                    },
                    {
                        "id": 105832,
                        "name": "Algatuy",
                        "latitude": "54.40090000",
                        "longitude": "100.25500000"
                    },
                    {
                        "id": 105833,
                        "name": "Alzamay",
                        "latitude": "55.55620000",
                        "longitude": "98.66440000"
                    },
                    {
                        "id": 105834,
                        "name": "Andreyevka",
                        "latitude": "44.81663000",
                        "longitude": "33.56313000"
                    },
                    {
                        "id": 105835,
                        "name": "Angarsk",
                        "latitude": "52.53667000",
                        "longitude": "103.88639000"
                    },
                    {
                        "id": 105836,
                        "name": "Angarskiy Rayon",
                        "latitude": "52.33333000",
                        "longitude": "103.66667000"
                    },
                    {
                        "id": 105837,
                        "name": "Atagay",
                        "latitude": "55.10330000",
                        "longitude": "99.38750000"
                    },
                    {
                        "id": 105838,
                        "name": "Badar",
                        "latitude": "54.39948000",
                        "longitude": "100.59436000"
                    },
                    {
                        "id": 105839,
                        "name": "Baklashi",
                        "latitude": "52.22556000",
                        "longitude": "104.04861000"
                    },
                    {
                        "id": 105840,
                        "name": "Balagansk",
                        "latitude": "54.00570000",
                        "longitude": "103.05234000"
                    },
                    {
                        "id": 105841,
                        "name": "Balaganskiy Rayon",
                        "latitude": "54.66667000",
                        "longitude": "102.83333000"
                    },
                    {
                        "id": 105842,
                        "name": "Balakhninskiy",
                        "latitude": "58.01056000",
                        "longitude": "114.27694000"
                    },
                    {
                        "id": 105843,
                        "name": "Balaklava",
                        "latitude": "44.51118000",
                        "longitude": "33.59942000"
                    },
                    {
                        "id": 105844,
                        "name": "Balaklava District",
                        "latitude": "44.50581000",
                        "longitude": "33.67035000"
                    },
                    {
                        "id": 105845,
                        "name": "Bayanday",
                        "latitude": "53.06611000",
                        "longitude": "105.51389000"
                    },
                    {
                        "id": 105846,
                        "name": "Bayandayevskiy Rayon",
                        "latitude": "53.08333000",
                        "longitude": "105.58333000"
                    },
                    {
                        "id": 105847,
                        "name": "Baykal’sk",
                        "latitude": "51.51510000",
                        "longitude": "104.14020000"
                    },
                    {
                        "id": 105848,
                        "name": "Bereznyaki",
                        "latitude": "56.93660000",
                        "longitude": "103.58510000"
                    },
                    {
                        "id": 105849,
                        "name": "Biryusinsk",
                        "latitude": "55.96340000",
                        "longitude": "97.82350000"
                    },
                    {
                        "id": 105850,
                        "name": "Bodaybo",
                        "latitude": "57.85056000",
                        "longitude": "114.19333000"
                    },
                    {
                        "id": 105851,
                        "name": "Bokhan",
                        "latitude": "53.15300000",
                        "longitude": "103.77140000"
                    },
                    {
                        "id": 105852,
                        "name": "Bokhanskiy Rayon",
                        "latitude": "53.16667000",
                        "longitude": "104.00000000"
                    },
                    {
                        "id": 105853,
                        "name": "Bol’shaya Rechka",
                        "latitude": "51.95360000",
                        "longitude": "104.73350000"
                    },
                    {
                        "id": 105854,
                        "name": "Bratsk",
                        "latitude": "56.13250000",
                        "longitude": "101.61417000"
                    },
                    {
                        "id": 105855,
                        "name": "Bratskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "102.00000000"
                    },
                    {
                        "id": 105856,
                        "name": "Budagovo",
                        "latitude": "54.62550000",
                        "longitude": "100.13109000"
                    },
                    {
                        "id": 105857,
                        "name": "Cheremkhovo",
                        "latitude": "53.15611000",
                        "longitude": "103.06750000"
                    },
                    {
                        "id": 105858,
                        "name": "Cheremkhovskiy Rayon",
                        "latitude": "52.66667000",
                        "longitude": "102.33333000"
                    },
                    {
                        "id": 105859,
                        "name": "Chunskiy",
                        "latitude": "56.08150000",
                        "longitude": "99.63420000"
                    },
                    {
                        "id": 105860,
                        "name": "Dzerzhinsk",
                        "latitude": "52.28028000",
                        "longitude": "104.38694000"
                    },
                    {
                        "id": 105861,
                        "name": "Ekhirit-Bulagatskiy Rayon",
                        "latitude": "53.00000000",
                        "longitude": "104.83333000"
                    },
                    {
                        "id": 105862,
                        "name": "Frontovoye",
                        "latitude": "44.66737000",
                        "longitude": "33.73841000"
                    },
                    {
                        "id": 105863,
                        "name": "Gadaley",
                        "latitude": "54.40318000",
                        "longitude": "100.74093000"
                    },
                    {
                        "id": 105864,
                        "name": "Guran",
                        "latitude": "54.76127000",
                        "longitude": "100.64399000"
                    },
                    {
                        "id": 105865,
                        "name": "Haharinskyi District",
                        "latitude": "44.59217000",
                        "longitude": "33.43925000"
                    },
                    {
                        "id": 105866,
                        "name": "Ikey",
                        "latitude": "54.19194000",
                        "longitude": "100.08111000"
                    },
                    {
                        "id": 105867,
                        "name": "Ilir",
                        "latitude": "55.22473000",
                        "longitude": "100.68498000"
                    },
                    {
                        "id": 105868,
                        "name": "Inkerman",
                        "latitude": "44.61391000",
                        "longitude": "33.60980000"
                    },
                    {
                        "id": 105869,
                        "name": "Irkutsk",
                        "latitude": "52.29778000",
                        "longitude": "104.29639000"
                    },
                    {
                        "id": 105870,
                        "name": "Irkutskiy Rayon",
                        "latitude": "52.33333000",
                        "longitude": "104.66667000"
                    },
                    {
                        "id": 105871,
                        "name": "Kacha",
                        "latitude": "44.77635000",
                        "longitude": "33.54387000"
                    },
                    {
                        "id": 105872,
                        "name": "Kachug",
                        "latitude": "53.96056000",
                        "longitude": "105.88167000"
                    },
                    {
                        "id": 105873,
                        "name": "Kachugskiy Rayon",
                        "latitude": "54.00000000",
                        "longitude": "106.50000000"
                    },
                    {
                        "id": 105874,
                        "name": "Katangskiy Rayon",
                        "latitude": "61.00000000",
                        "longitude": "108.00000000"
                    },
                    {
                        "id": 105875,
                        "name": "Kazachinsko-Lenskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "108.00000000"
                    },
                    {
                        "id": 105876,
                        "name": "Kazachinskoye",
                        "latitude": "56.26974000",
                        "longitude": "107.57624000"
                    },
                    {
                        "id": 105877,
                        "name": "Khomutovo",
                        "latitude": "52.46583000",
                        "longitude": "104.40250000"
                    },
                    {
                        "id": 105878,
                        "name": "Khrebtovaya",
                        "latitude": "56.70320000",
                        "longitude": "104.24940000"
                    },
                    {
                        "id": 105879,
                        "name": "Khudoyelanskoye",
                        "latitude": "54.70375000",
                        "longitude": "99.63042000"
                    },
                    {
                        "id": 105880,
                        "name": "Khuzhir",
                        "latitude": "53.19389000",
                        "longitude": "107.33972000"
                    },
                    {
                        "id": 105881,
                        "name": "Kimil’tey",
                        "latitude": "54.13370000",
                        "longitude": "101.98110000"
                    },
                    {
                        "id": 105882,
                        "name": "Kirensk",
                        "latitude": "57.78528000",
                        "longitude": "108.11194000"
                    },
                    {
                        "id": 105883,
                        "name": "Kirenskiy Rayon",
                        "latitude": "58.00000000",
                        "longitude": "109.25000000"
                    },
                    {
                        "id": 105884,
                        "name": "Kitoy",
                        "latitude": "52.60000000",
                        "longitude": "103.90000000"
                    },
                    {
                        "id": 105885,
                        "name": "Kotik",
                        "latitude": "54.65057000",
                        "longitude": "100.45395000"
                    },
                    {
                        "id": 105886,
                        "name": "Kropotkin",
                        "latitude": "58.50944000",
                        "longitude": "115.32167000"
                    },
                    {
                        "id": 105887,
                        "name": "Kultuk",
                        "latitude": "51.72083000",
                        "longitude": "103.69556000"
                    },
                    {
                        "id": 105888,
                        "name": "Kutulik",
                        "latitude": "53.35080000",
                        "longitude": "102.78389000"
                    },
                    {
                        "id": 105889,
                        "name": "Kuytun",
                        "latitude": "54.34241000",
                        "longitude": "101.50917000"
                    },
                    {
                        "id": 105890,
                        "name": "Kuytunskiy Rayon",
                        "latitude": "54.50000000",
                        "longitude": "101.66667000"
                    },
                    {
                        "id": 105891,
                        "name": "Kvitok",
                        "latitude": "56.07240000",
                        "longitude": "98.48130000"
                    },
                    {
                        "id": 105892,
                        "name": "Lenin District",
                        "latitude": "44.60000000",
                        "longitude": "33.53333000"
                    },
                    {
                        "id": 105893,
                        "name": "Lesogorsk",
                        "latitude": "56.04580000",
                        "longitude": "99.51360000"
                    },
                    {
                        "id": 105894,
                        "name": "Listvyanka",
                        "latitude": "51.85350000",
                        "longitude": "104.86930000"
                    },
                    {
                        "id": 105895,
                        "name": "Magistral’nyy",
                        "latitude": "56.17148000",
                        "longitude": "107.44166000"
                    },
                    {
                        "id": 105896,
                        "name": "Mama",
                        "latitude": "58.31056000",
                        "longitude": "112.89861000"
                    },
                    {
                        "id": 105897,
                        "name": "Mamakan",
                        "latitude": "57.81611000",
                        "longitude": "114.00278000"
                    },
                    {
                        "id": 105898,
                        "name": "Mamsko-Chuyskiy Rayon",
                        "latitude": "58.00000000",
                        "longitude": "112.50000000"
                    },
                    {
                        "id": 105899,
                        "name": "Manzurka",
                        "latitude": "53.48556000",
                        "longitude": "106.05444000"
                    },
                    {
                        "id": 105900,
                        "name": "Markova",
                        "latitude": "52.20889000",
                        "longitude": "104.21083000"
                    },
                    {
                        "id": 105901,
                        "name": "Markovo",
                        "latitude": "57.32056000",
                        "longitude": "107.08806000"
                    },
                    {
                        "id": 105902,
                        "name": "Meget",
                        "latitude": "52.41500000",
                        "longitude": "104.04944000"
                    },
                    {
                        "id": 105903,
                        "name": "Mishelevka",
                        "latitude": "52.85750000",
                        "longitude": "103.17194000"
                    },
                    {
                        "id": 105904,
                        "name": "Mugun",
                        "latitude": "54.47143000",
                        "longitude": "100.24831000"
                    },
                    {
                        "id": 105905,
                        "name": "Nakhimovskiy rayon",
                        "latitude": "44.69502000",
                        "longitude": "33.58092000"
                    },
                    {
                        "id": 105906,
                        "name": "Nizhneilimskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "103.50000000"
                    },
                    {
                        "id": 105907,
                        "name": "Nizhneudinsk",
                        "latitude": "54.90760000",
                        "longitude": "99.02760000"
                    },
                    {
                        "id": 105908,
                        "name": "Nizhneudinskiy Rayon",
                        "latitude": "54.33333000",
                        "longitude": "98.50000000"
                    },
                    {
                        "id": 105909,
                        "name": "Novaya Igirma",
                        "latitude": "57.13340000",
                        "longitude": "103.91120000"
                    },
                    {
                        "id": 105910,
                        "name": "Novobiryusinskiy",
                        "latitude": "56.95780000",
                        "longitude": "97.70760000"
                    },
                    {
                        "id": 105911,
                        "name": "Novonukutskiy",
                        "latitude": "53.70000000",
                        "longitude": "102.71170000"
                    },
                    {
                        "id": 105912,
                        "name": "Ol’khonskiy Rayon",
                        "latitude": "53.00000000",
                        "longitude": "106.50000000"
                    },
                    {
                        "id": 105913,
                        "name": "Orlinoye",
                        "latitude": "44.44685000",
                        "longitude": "33.77588000"
                    },
                    {
                        "id": 105914,
                        "name": "Osa",
                        "latitude": "53.38722000",
                        "longitude": "103.87694000"
                    },
                    {
                        "id": 105915,
                        "name": "Oyëk",
                        "latitude": "52.58611000",
                        "longitude": "104.45556000"
                    },
                    {
                        "id": 105916,
                        "name": "Pad’ Mel’nichnaya",
                        "latitude": "52.16000000",
                        "longitude": "104.38000000"
                    },
                    {
                        "id": 105917,
                        "name": "Perfilovo",
                        "latitude": "54.41083000",
                        "longitude": "100.48454000"
                    },
                    {
                        "id": 105918,
                        "name": "Pivovarikha",
                        "latitude": "52.27056000",
                        "longitude": "104.44583000"
                    },
                    {
                        "id": 105919,
                        "name": "Pokosnoye",
                        "latitude": "55.52583000",
                        "longitude": "101.05361000"
                    },
                    {
                        "id": 105920,
                        "name": "Polyushko",
                        "latitude": "44.74219000",
                        "longitude": "33.58913000"
                    },
                    {
                        "id": 105921,
                        "name": "Rudnogorsk",
                        "latitude": "57.26390000",
                        "longitude": "103.75190000"
                    },
                    {
                        "id": 105922,
                        "name": "Sakharnaya Golovka",
                        "latitude": "44.58362000",
                        "longitude": "33.64383000"
                    },
                    {
                        "id": 105923,
                        "name": "Sayansk",
                        "latitude": "54.10880000",
                        "longitude": "102.16480000"
                    },
                    {
                        "id": 105924,
                        "name": "Sevastopol",
                        "latitude": "44.58883000",
                        "longitude": "33.52240000"
                    },
                    {
                        "id": 105925,
                        "name": "Shamanka",
                        "latitude": "52.06667000",
                        "longitude": "103.82028000"
                    },
                    {
                        "id": 105926,
                        "name": "Sheberta",
                        "latitude": "54.64178000",
                        "longitude": "99.89209000"
                    },
                    {
                        "id": 105927,
                        "name": "Shelekhov",
                        "latitude": "52.21389000",
                        "longitude": "104.10000000"
                    },
                    {
                        "id": 105928,
                        "name": "Sheragul",
                        "latitude": "54.46243000",
                        "longitude": "100.90994000"
                    },
                    {
                        "id": 105929,
                        "name": "Shestakovo",
                        "latitude": "56.49150000",
                        "longitude": "103.96000000"
                    },
                    {
                        "id": 105930,
                        "name": "Shitkino",
                        "latitude": "56.37030000",
                        "longitude": "98.35430000"
                    },
                    {
                        "id": 105931,
                        "name": "Shturmovoye",
                        "latitude": "44.56767000",
                        "longitude": "33.62245000"
                    },
                    {
                        "id": 105932,
                        "name": "Shumskiy",
                        "latitude": "54.83180000",
                        "longitude": "99.13280000"
                    },
                    {
                        "id": 105933,
                        "name": "Slyudyanka",
                        "latitude": "51.65944000",
                        "longitude": "103.70611000"
                    },
                    {
                        "id": 105934,
                        "name": "Slyudyanskiy Rayon",
                        "latitude": "51.50000000",
                        "longitude": "104.00000000"
                    },
                    {
                        "id": 105935,
                        "name": "Smolenshchina",
                        "latitude": "52.25528000",
                        "longitude": "104.12806000"
                    },
                    {
                        "id": 105936,
                        "name": "Solnechniy",
                        "latitude": "44.78677000",
                        "longitude": "33.61786000"
                    },
                    {
                        "id": 105937,
                        "name": "Sredniy",
                        "latitude": "52.88840000",
                        "longitude": "103.49040000"
                    },
                    {
                        "id": 105938,
                        "name": "Svirsk",
                        "latitude": "53.08583000",
                        "longitude": "103.33250000"
                    },
                    {
                        "id": 105939,
                        "name": "Tayshet",
                        "latitude": "55.93420000",
                        "longitude": "98.00440000"
                    },
                    {
                        "id": 105940,
                        "name": "Tayshetskiy Rayon",
                        "latitude": "56.00000000",
                        "longitude": "98.00000000"
                    },
                    {
                        "id": 105941,
                        "name": "Tayturka",
                        "latitude": "52.86917000",
                        "longitude": "103.46083000"
                    },
                    {
                        "id": 105942,
                        "name": "Tel’ma",
                        "latitude": "52.69810000",
                        "longitude": "103.71380000"
                    },
                    {
                        "id": 105943,
                        "name": "Ternovka",
                        "latitude": "44.57922000",
                        "longitude": "33.75105000"
                    },
                    {
                        "id": 105944,
                        "name": "Tulun",
                        "latitude": "54.56358000",
                        "longitude": "100.58143000"
                    },
                    {
                        "id": 105945,
                        "name": "Tulunskiy Rayon",
                        "latitude": "54.16667000",
                        "longitude": "100.33333000"
                    },
                    {
                        "id": 105946,
                        "name": "Tulyushka",
                        "latitude": "54.45851000",
                        "longitude": "101.17054000"
                    },
                    {
                        "id": 105947,
                        "name": "Tyret’ Pervaya",
                        "latitude": "53.67028000",
                        "longitude": "102.31056000"
                    },
                    {
                        "id": 105948,
                        "name": "Uk",
                        "latitude": "55.07900000",
                        "longitude": "98.85860000"
                    },
                    {
                        "id": 105949,
                        "name": "Urik",
                        "latitude": "52.46051000",
                        "longitude": "104.24016000"
                    },
                    {
                        "id": 105950,
                        "name": "Usol’skiy Rayon",
                        "latitude": "52.50000000",
                        "longitude": "103.25000000"
                    },
                    {
                        "id": 105951,
                        "name": "Usol’ye-Sibirskoye",
                        "latitude": "52.75194000",
                        "longitude": "103.64528000"
                    },
                    {
                        "id": 105952,
                        "name": "Ust’-Ilimsk",
                        "latitude": "58.00056000",
                        "longitude": "102.66194000"
                    },
                    {
                        "id": 105953,
                        "name": "Ust’-Kut",
                        "latitude": "56.79380000",
                        "longitude": "105.76720000"
                    },
                    {
                        "id": 105954,
                        "name": "Ust’-Kutskiy Rayon",
                        "latitude": "57.00000000",
                        "longitude": "106.00000000"
                    },
                    {
                        "id": 105955,
                        "name": "Ust’-Ordynskiy",
                        "latitude": "52.80500000",
                        "longitude": "104.75083000"
                    },
                    {
                        "id": 105956,
                        "name": "Ust’-Uda",
                        "latitude": "54.17420000",
                        "longitude": "103.03040000"
                    },
                    {
                        "id": 105957,
                        "name": "Ust’-Udinskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "103.66667000"
                    },
                    {
                        "id": 105958,
                        "name": "Verkhnesadovoye",
                        "latitude": "44.68932000",
                        "longitude": "33.70207000"
                    },
                    {
                        "id": 105959,
                        "name": "Vidim",
                        "latitude": "56.40880000",
                        "longitude": "103.11060000"
                    },
                    {
                        "id": 105960,
                        "name": "Vikhorevka",
                        "latitude": "56.12128000",
                        "longitude": "101.17767000"
                    },
                    {
                        "id": 105961,
                        "name": "Voznesenskiy",
                        "latitude": "54.89680000",
                        "longitude": "99.10310000"
                    },
                    {
                        "id": 105962,
                        "name": "Yantal’",
                        "latitude": "56.84710000",
                        "longitude": "105.25420000"
                    },
                    {
                        "id": 105963,
                        "name": "Yedogon",
                        "latitude": "54.25490000",
                        "longitude": "100.23850000"
                    },
                    {
                        "id": 105964,
                        "name": "Yelantsy",
                        "latitude": "52.80286000",
                        "longitude": "106.40466000"
                    },
                    {
                        "id": 105965,
                        "name": "Yerbogachen",
                        "latitude": "61.28016000",
                        "longitude": "108.01535000"
                    },
                    {
                        "id": 105966,
                        "name": "Yurty",
                        "latitude": "56.04980000",
                        "longitude": "97.63480000"
                    },
                    {
                        "id": 105967,
                        "name": "Zalari",
                        "latitude": "53.55840000",
                        "longitude": "102.50650000"
                    },
                    {
                        "id": 105968,
                        "name": "Zalarinskiy Rayon",
                        "latitude": "53.16667000",
                        "longitude": "101.50000000"
                    },
                    {
                        "id": 105969,
                        "name": "Zheleznodorozhnyy",
                        "latitude": "57.90525000",
                        "longitude": "102.77838000"
                    },
                    {
                        "id": 105970,
                        "name": "Zheleznogorsk-Ilimskiy",
                        "latitude": "56.57680000",
                        "longitude": "104.12170000"
                    },
                    {
                        "id": 105971,
                        "name": "Zhigalovo",
                        "latitude": "54.81061000",
                        "longitude": "105.15808000"
                    },
                    {
                        "id": 105972,
                        "name": "Zhigalovskiy Rayon",
                        "latitude": "55.00000000",
                        "longitude": "105.50000000"
                    },
                    {
                        "id": 105973,
                        "name": "Zima",
                        "latitude": "53.92020000",
                        "longitude": "102.04420000"
                    },
                    {
                        "id": 105974,
                        "name": "Ziminskiy Rayon",
                        "latitude": "55.83333000",
                        "longitude": "101.66667000"
                    },
                    {
                        "id": 105975,
                        "name": "Zvëzdnyy",
                        "latitude": "56.74920000",
                        "longitude": "106.47990000"
                    }
                ]
            },
            {
                "id": 4685,
                "name": "Sumska",
                "iso2": "59",
                "latitude": "50.90770000",
                "longitude": "34.79810000",
                "type": "region",
                "cities": [
                    {
                        "id": 109402,
                        "name": "Bilopillya",
                        "latitude": "51.15016000",
                        "longitude": "34.31287000"
                    },
                    {
                        "id": 109430,
                        "name": "Boromlya",
                        "latitude": "50.61839000",
                        "longitude": "34.97042000"
                    },
                    {
                        "id": 109463,
                        "name": "Buryn’",
                        "latitude": "51.19912000",
                        "longitude": "33.83523000"
                    },
                    {
                        "id": 109580,
                        "name": "Druzhba",
                        "latitude": "52.04545000",
                        "longitude": "33.94517000"
                    },
                    {
                        "id": 109632,
                        "name": "Hlukhiv",
                        "latitude": "51.67822000",
                        "longitude": "33.91620000"
                    },
                    {
                        "id": 109789,
                        "name": "Konotop",
                        "latitude": "51.24032000",
                        "longitude": "33.20263000"
                    },
                    {
                        "id": 109846,
                        "name": "Krasnopillya",
                        "latitude": "50.77458000",
                        "longitude": "35.25965000"
                    },
                    {
                        "id": 109866,
                        "name": "Krolevets’",
                        "latitude": "51.54775000",
                        "longitude": "33.38475000"
                    },
                    {
                        "id": 109898,
                        "name": "Kyrykivka",
                        "latitude": "50.36408000",
                        "longitude": "35.11490000"
                    },
                    {
                        "id": 109908,
                        "name": "Lebedyn",
                        "latitude": "50.58518000",
                        "longitude": "34.48490000"
                    },
                    {
                        "id": 109956,
                        "name": "Lypova Dolyna",
                        "latitude": "50.56428000",
                        "longitude": "33.79793000"
                    },
                    {
                        "id": 110024,
                        "name": "Mezenivka",
                        "latitude": "50.63486000",
                        "longitude": "35.31340000"
                    },
                    {
                        "id": 110087,
                        "name": "Nedryhayliv",
                        "latitude": "50.83398000",
                        "longitude": "33.87626000"
                    },
                    {
                        "id": 110169,
                        "name": "Nyzy",
                        "latitude": "50.78281000",
                        "longitude": "34.78441000"
                    },
                    {
                        "id": 110180,
                        "name": "Okhtyrka",
                        "latitude": "50.31036000",
                        "longitude": "34.89879000"
                    },
                    {
                        "id": 110332,
                        "name": "Putyvl’",
                        "latitude": "51.33745000",
                        "longitude": "33.87066000"
                    },
                    {
                        "id": 110368,
                        "name": "Romens’ka Mis’krada",
                        "latitude": "50.74306000",
                        "longitude": "33.48284000"
                    },
                    {
                        "id": 110369,
                        "name": "Romny",
                        "latitude": "50.75104000",
                        "longitude": "33.47471000"
                    },
                    {
                        "id": 110424,
                        "name": "Seredyna-Buda",
                        "latitude": "52.18903000",
                        "longitude": "34.03639000"
                    },
                    {
                        "id": 110429,
                        "name": "Shalyhyne",
                        "latitude": "51.57167000",
                        "longitude": "34.12167000"
                    },
                    {
                        "id": 110450,
                        "name": "Shostka",
                        "latitude": "51.86296000",
                        "longitude": "33.46980000"
                    },
                    {
                        "id": 110483,
                        "name": "Sloboda",
                        "latitude": "51.19806000",
                        "longitude": "33.60695000"
                    },
                    {
                        "id": 110563,
                        "name": "Sumy",
                        "latitude": "50.92160000",
                        "longitude": "34.80029000"
                    },
                    {
                        "id": 110604,
                        "name": "Terny",
                        "latitude": "50.98916000",
                        "longitude": "33.97070000"
                    },
                    {
                        "id": 110621,
                        "name": "Trostyanets’",
                        "latitude": "50.48478000",
                        "longitude": "34.96567000"
                    },
                    {
                        "id": 110688,
                        "name": "Velyka Pysarivka",
                        "latitude": "50.42430000",
                        "longitude": "35.47989000"
                    },
                    {
                        "id": 110708,
                        "name": "Verkhnya Syrovatka",
                        "latitude": "50.82902000",
                        "longitude": "34.95861000"
                    },
                    {
                        "id": 110744,
                        "name": "Vorozhba",
                        "latitude": "51.17334000",
                        "longitude": "34.21917000"
                    },
                    {
                        "id": 110781,
                        "name": "Yampil’",
                        "latitude": "51.94765000",
                        "longitude": "33.78759000"
                    },
                    {
                        "id": 110799,
                        "name": "Yesman’",
                        "latitude": "51.77006000",
                        "longitude": "34.06729000"
                    }
                ]
            },
            {
                "id": 4674,
                "name": "Ternopilska",
                "iso2": "61",
                "latitude": "49.55351700",
                "longitude": "25.59476700",
                "type": "region",
                "cities": [
                    {
                        "id": 109362,
                        "name": "Belaya",
                        "latitude": "49.02900000",
                        "longitude": "25.77059000"
                    },
                    {
                        "id": 109434,
                        "name": "Borshchiv",
                        "latitude": "48.80332000",
                        "longitude": "26.04347000"
                    },
                    {
                        "id": 109457,
                        "name": "Buchach",
                        "latitude": "49.06254000",
                        "longitude": "25.38798000"
                    },
                    {
                        "id": 109517,
                        "name": "Chortkiv",
                        "latitude": "49.01709000",
                        "longitude": "25.79804000"
                    },
                    {
                        "id": 109579,
                        "name": "Druzhba",
                        "latitude": "49.04251000",
                        "longitude": "25.45055000"
                    },
                    {
                        "id": 109657,
                        "name": "Hrymayliv",
                        "latitude": "49.33208000",
                        "longitude": "26.01112000"
                    },
                    {
                        "id": 109662,
                        "name": "Husiatyn",
                        "latitude": "49.07290000",
                        "longitude": "26.18480000"
                    },
                    {
                        "id": 109738,
                        "name": "Khorostkiv",
                        "latitude": "49.21114000",
                        "longitude": "25.92165000"
                    },
                    {
                        "id": 109793,
                        "name": "Kopychyntsi",
                        "latitude": "49.10441000",
                        "longitude": "25.91026000"
                    },
                    {
                        "id": 109826,
                        "name": "Kozova",
                        "latitude": "49.43544000",
                        "longitude": "25.15086000"
                    },
                    {
                        "id": 109858,
                        "name": "Kremenets",
                        "latitude": "50.09693000",
                        "longitude": "25.72459000"
                    },
                    {
                        "id": 109904,
                        "name": "Lanivtsi",
                        "latitude": "49.86328000",
                        "longitude": "26.09082000"
                    },
                    {
                        "id": 110029,
                        "name": "Mikulintsy",
                        "latitude": "49.39600000",
                        "longitude": "25.60518000"
                    },
                    {
                        "id": 110163,
                        "name": "Nyrkiv",
                        "latitude": "48.81492000",
                        "longitude": "25.59989000"
                    },
                    {
                        "id": 110216,
                        "name": "Ozerna",
                        "latitude": "49.62891000",
                        "longitude": "25.32895000"
                    },
                    {
                        "id": 110256,
                        "name": "Petrikov",
                        "latitude": "49.53122000",
                        "longitude": "25.57901000"
                    },
                    {
                        "id": 110265,
                        "name": "Pidhaytsi",
                        "latitude": "49.26853000",
                        "longitude": "25.13341000"
                    },
                    {
                        "id": 110270,
                        "name": "Pidvolochysk",
                        "latitude": "49.53472000",
                        "longitude": "26.14585000"
                    },
                    {
                        "id": 110282,
                        "name": "Pochaiv",
                        "latitude": "50.00509000",
                        "longitude": "25.51183000"
                    },
                    {
                        "id": 110467,
                        "name": "Skala-Podil’s’ka",
                        "latitude": "48.85149000",
                        "longitude": "26.19909000"
                    },
                    {
                        "id": 110468,
                        "name": "Skalat",
                        "latitude": "49.42732000",
                        "longitude": "25.97869000"
                    },
                    {
                        "id": 110601,
                        "name": "Terebovlya",
                        "latitude": "49.30187000",
                        "longitude": "25.70997000"
                    },
                    {
                        "id": 110602,
                        "name": "Ternopil",
                        "latitude": "49.55342000",
                        "longitude": "25.58918000"
                    },
                    {
                        "id": 110619,
                        "name": "Tovste",
                        "latitude": "48.84663000",
                        "longitude": "25.72621000"
                    },
                    {
                        "id": 110682,
                        "name": "Velikiye Borki",
                        "latitude": "49.52363000",
                        "longitude": "25.75753000"
                    },
                    {
                        "id": 110772,
                        "name": "Yahil’nytsya",
                        "latitude": "48.94248000",
                        "longitude": "25.74375000"
                    },
                    {
                        "id": 110814,
                        "name": "Zalishchyky",
                        "latitude": "48.64331000",
                        "longitude": "25.73794000"
                    },
                    {
                        "id": 110818,
                        "name": "Zaliztsi",
                        "latitude": "49.79188000",
                        "longitude": "25.37297000"
                    },
                    {
                        "id": 110831,
                        "name": "Zbarazh",
                        "latitude": "49.66357000",
                        "longitude": "25.77616000"
                    },
                    {
                        "id": 110832,
                        "name": "Zboriv",
                        "latitude": "49.66484000",
                        "longitude": "25.14097000"
                    },
                    {
                        "id": 110863,
                        "name": "Zolotyy Potik",
                        "latitude": "48.90950000",
                        "longitude": "25.33926000"
                    },
                    {
                        "id": 110873,
                        "name": "Бережани",
                        "latitude": "49.45000000",
                        "longitude": "24.93333000"
                    }
                ]
            },
            {
                "id": 4669,
                "name": "Vinnytska",
                "iso2": "05",
                "latitude": "49.23308300",
                "longitude": "28.46821690",
                "type": "region",
                "cities": [
                    {
                        "id": 109349,
                        "name": "Bar",
                        "latitude": "49.07717000",
                        "longitude": "27.68256000"
                    },
                    {
                        "id": 109351,
                        "name": "Barskiy Rayon",
                        "latitude": "49.06667000",
                        "longitude": "27.68333000"
                    },
                    {
                        "id": 109387,
                        "name": "Bershad",
                        "latitude": "48.36782000",
                        "longitude": "29.51726000"
                    },
                    {
                        "id": 109443,
                        "name": "Brailiv",
                        "latitude": "49.10986000",
                        "longitude": "28.17459000"
                    },
                    {
                        "id": 109445,
                        "name": "Bratslav",
                        "latitude": "48.82257000",
                        "longitude": "28.94070000"
                    },
                    {
                        "id": 109475,
                        "name": "Chechelnyk",
                        "latitude": "48.21509000",
                        "longitude": "29.36728000"
                    },
                    {
                        "id": 109484,
                        "name": "Chernivets’kyy Rayon",
                        "latitude": "48.51106000",
                        "longitude": "28.14191000"
                    },
                    {
                        "id": 109485,
                        "name": "Chernivtsi",
                        "latitude": "48.54225000",
                        "longitude": "28.11473000"
                    },
                    {
                        "id": 109530,
                        "name": "Dashiv",
                        "latitude": "49.00449000",
                        "longitude": "29.42559000"
                    },
                    {
                        "id": 109624,
                        "name": "Haisyn",
                        "latitude": "48.81143000",
                        "longitude": "29.38977000"
                    },
                    {
                        "id": 109667,
                        "name": "Illintsi",
                        "latitude": "49.10479000",
                        "longitude": "29.21773000"
                    },
                    {
                        "id": 109704,
                        "name": "Kalynivka",
                        "latitude": "49.45389000",
                        "longitude": "28.52608000"
                    },
                    {
                        "id": 109732,
                        "name": "Khmilnyk",
                        "latitude": "49.55979000",
                        "longitude": "27.95754000"
                    },
                    {
                        "id": 109759,
                        "name": "Klembivka",
                        "latitude": "48.39037000",
                        "longitude": "28.41092000"
                    },
                    {
                        "id": 109792,
                        "name": "Kopayhorod",
                        "latitude": "48.85917000",
                        "longitude": "27.79690000"
                    },
                    {
                        "id": 109827,
                        "name": "Kozyatyn",
                        "latitude": "49.71431000",
                        "longitude": "28.83385000"
                    },
                    {
                        "id": 109879,
                        "name": "Kryzhopil’",
                        "latitude": "48.38289000",
                        "longitude": "28.86622000"
                    },
                    {
                        "id": 109902,
                        "name": "Ladyzhyn",
                        "latitude": "48.68496000",
                        "longitude": "29.23679000"
                    },
                    {
                        "id": 109921,
                        "name": "Lityn",
                        "latitude": "49.32509000",
                        "longitude": "28.08094000"
                    },
                    {
                        "id": 109922,
                        "name": "Lityns’kyy Rayon",
                        "latitude": "49.37138000",
                        "longitude": "28.07033000"
                    },
                    {
                        "id": 109957,
                        "name": "Lypovets’kyy Rayon",
                        "latitude": "49.28006000",
                        "longitude": "28.93205000"
                    },
                    {
                        "id": 110045,
                        "name": "Mohyliv-Podilskyi",
                        "latitude": "48.44598000",
                        "longitude": "27.79820000"
                    },
                    {
                        "id": 110060,
                        "name": "Murafa",
                        "latitude": "48.76763000",
                        "longitude": "28.21569000"
                    },
                    {
                        "id": 110063,
                        "name": "Murovani Kurylivtsi",
                        "latitude": "48.72348000",
                        "longitude": "27.51892000"
                    },
                    {
                        "id": 110091,
                        "name": "Nemyriv",
                        "latitude": "48.97076000",
                        "longitude": "28.83779000"
                    },
                    {
                        "id": 110108,
                        "name": "Nova Pryluka",
                        "latitude": "49.37488000",
                        "longitude": "28.69955000"
                    },
                    {
                        "id": 110171,
                        "name": "Obodivka",
                        "latitude": "48.40514000",
                        "longitude": "29.24775000"
                    },
                    {
                        "id": 110199,
                        "name": "Orativ",
                        "latitude": "49.18889000",
                        "longitude": "29.52697000"
                    },
                    {
                        "id": 110230,
                        "name": "Pavlivka",
                        "latitude": "49.44143000",
                        "longitude": "28.45956000"
                    },
                    {
                        "id": 110288,
                        "name": "Pohrebyshche",
                        "latitude": "49.48639000",
                        "longitude": "29.26361000"
                    },
                    {
                        "id": 110289,
                        "name": "Pohrebyshchens’kyy Rayon",
                        "latitude": "49.48126000",
                        "longitude": "29.25953000"
                    },
                    {
                        "id": 110419,
                        "name": "Serebriya",
                        "latitude": "48.45593000",
                        "longitude": "27.71923000"
                    },
                    {
                        "id": 110430,
                        "name": "Sharhorod",
                        "latitude": "48.75587000",
                        "longitude": "28.07507000"
                    },
                    {
                        "id": 110496,
                        "name": "Sobolivka",
                        "latitude": "49.33604000",
                        "longitude": "28.65096000"
                    },
                    {
                        "id": 110566,
                        "name": "Sutysky",
                        "latitude": "49.04245000",
                        "longitude": "28.41733000"
                    },
                    {
                        "id": 110600,
                        "name": "Teplyk",
                        "latitude": "48.66566000",
                        "longitude": "29.74504000"
                    },
                    {
                        "id": 110614,
                        "name": "Tomashpil’",
                        "latitude": "48.54256000",
                        "longitude": "28.51684000"
                    },
                    {
                        "id": 110617,
                        "name": "Torkanivka",
                        "latitude": "48.32462000",
                        "longitude": "29.14746000"
                    },
                    {
                        "id": 110633,
                        "name": "Tsybulevka",
                        "latitude": "48.38719000",
                        "longitude": "29.10288000"
                    },
                    {
                        "id": 110636,
                        "name": "Tulchyn",
                        "latitude": "48.67448000",
                        "longitude": "28.84641000"
                    },
                    {
                        "id": 110637,
                        "name": "Turbiv",
                        "latitude": "49.34788000",
                        "longitude": "28.72117000"
                    },
                    {
                        "id": 110647,
                        "name": "Tyvriv",
                        "latitude": "49.01404000",
                        "longitude": "28.50846000"
                    },
                    {
                        "id": 110654,
                        "name": "Ulaniv",
                        "latitude": "49.69512000",
                        "longitude": "28.13298000"
                    },
                    {
                        "id": 110671,
                        "name": "Vapnyarka",
                        "latitude": "48.53479000",
                        "longitude": "28.74358000"
                    },
                    {
                        "id": 110698,
                        "name": "Vendychany",
                        "latitude": "48.61176000",
                        "longitude": "27.79324000"
                    },
                    {
                        "id": 110720,
                        "name": "Vinnitskiy Rayon",
                        "latitude": "49.23531000",
                        "longitude": "28.47588000"
                    },
                    {
                        "id": 110722,
                        "name": "Vinnytsia",
                        "latitude": "49.23278000",
                        "longitude": "28.48097000"
                    },
                    {
                        "id": 110727,
                        "name": "Viytivka",
                        "latitude": "48.42603000",
                        "longitude": "29.54291000"
                    },
                    {
                        "id": 110743,
                        "name": "Voronovytsya",
                        "latitude": "49.10954000",
                        "longitude": "28.68078000"
                    },
                    {
                        "id": 110780,
                        "name": "Yampil’",
                        "latitude": "48.24240000",
                        "longitude": "28.28195000"
                    },
                    {
                        "id": 110844,
                        "name": "Zhmerynka",
                        "latitude": "49.03705000",
                        "longitude": "28.11201000"
                    }
                ]
            },
            {
                "id": 4690,
                "name": "Volynska",
                "iso2": "07",
                "latitude": "50.74723300",
                "longitude": "25.32538300",
                "type": "region",
                "cities": [
                    {
                        "id": 109377,
                        "name": "Berestechko",
                        "latitude": "50.36047000",
                        "longitude": "25.11071000"
                    },
                    {
                        "id": 109409,
                        "name": "Blahodatne",
                        "latitude": "50.66365000",
                        "longitude": "24.24918000"
                    },
                    {
                        "id": 109656,
                        "name": "Hołoby",
                        "latitude": "51.08651000",
                        "longitude": "25.00767000"
                    },
                    {
                        "id": 109653,
                        "name": "Horokhiv",
                        "latitude": "50.50186000",
                        "longitude": "24.76149000"
                    },
                    {
                        "id": 109712,
                        "name": "Kamin-Kashyrskyi",
                        "latitude": "51.62412000",
                        "longitude": "24.95864000"
                    },
                    {
                        "id": 109756,
                        "name": "Kivertsi",
                        "latitude": "50.83425000",
                        "longitude": "25.45821000"
                    },
                    {
                        "id": 109820,
                        "name": "Kovel",
                        "latitude": "51.21526000",
                        "longitude": "24.70867000"
                    },
                    {
                        "id": 109821,
                        "name": "Kovel’s’ka Mis’krada",
                        "latitude": "51.21198000",
                        "longitude": "24.70163000"
                    },
                    {
                        "id": 109924,
                        "name": "Liuboml",
                        "latitude": "51.22601000",
                        "longitude": "24.03727000"
                    },
                    {
                        "id": 109928,
                        "name": "Lokachi",
                        "latitude": "50.73700000",
                        "longitude": "24.64944000"
                    },
                    {
                        "id": 109943,
                        "name": "Lukiv",
                        "latitude": "51.05210000",
                        "longitude": "25.40059000"
                    },
                    {
                        "id": 109944,
                        "name": "Lutsk",
                        "latitude": "50.75932000",
                        "longitude": "25.34244000"
                    },
                    {
                        "id": 109964,
                        "name": "Lyubeshivs’kyy Rayon",
                        "latitude": "51.79639000",
                        "longitude": "25.33133000"
                    },
                    {
                        "id": 109965,
                        "name": "Lyuboml’s’kyy Rayon",
                        "latitude": "51.25062000",
                        "longitude": "24.01161000"
                    },
                    {
                        "id": 109992,
                        "name": "Manevychi",
                        "latitude": "51.29405000",
                        "longitude": "25.53436000"
                    },
                    {
                        "id": 109993,
                        "name": "Manevyts’kyy Rayon",
                        "latitude": "51.24513000",
                        "longitude": "25.60945000"
                    },
                    {
                        "id": 110152,
                        "name": "Novovolyns’k",
                        "latitude": "50.72576000",
                        "longitude": "24.16265000"
                    },
                    {
                        "id": 110162,
                        "name": "Nuyno",
                        "latitude": "51.54628000",
                        "longitude": "24.91018000"
                    },
                    {
                        "id": 110195,
                        "name": "Olyka",
                        "latitude": "50.71855000",
                        "longitude": "25.81251000"
                    },
                    {
                        "id": 110273,
                        "name": "Pishcha",
                        "latitude": "51.60928000",
                        "longitude": "23.82079000"
                    },
                    {
                        "id": 110342,
                        "name": "Rakiv Lis",
                        "latitude": "51.62174000",
                        "longitude": "24.92427000"
                    },
                    {
                        "id": 110345,
                        "name": "Ratne",
                        "latitude": "51.66830000",
                        "longitude": "24.53030000"
                    },
                    {
                        "id": 110346,
                        "name": "Ratnivs’kyy Rayon",
                        "latitude": "51.71712000",
                        "longitude": "24.51959000"
                    },
                    {
                        "id": 110381,
                        "name": "Rozhyshche",
                        "latitude": "50.91542000",
                        "longitude": "25.26906000"
                    },
                    {
                        "id": 110431,
                        "name": "Shats’k",
                        "latitude": "51.50208000",
                        "longitude": "23.93806000"
                    },
                    {
                        "id": 110432,
                        "name": "Shats’kyy Rayon",
                        "latitude": "51.52237000",
                        "longitude": "23.86522000"
                    },
                    {
                        "id": 110528,
                        "name": "Stara Vyzhivka",
                        "latitude": "51.43762000",
                        "longitude": "24.43997000"
                    },
                    {
                        "id": 110578,
                        "name": "Svityaz’",
                        "latitude": "51.48211000",
                        "longitude": "23.85904000"
                    },
                    {
                        "id": 110734,
                        "name": "Volodymyr-Volynskyi",
                        "latitude": "50.85253000",
                        "longitude": "24.32364000"
                    }
                ]
            },
            {
                "id": 4670,
                "name": "Zakarpatska",
                "iso2": "21",
                "latitude": "48.62080000",
                "longitude": "22.28788300",
                "type": "region",
                "cities": [
                    {
                        "id": 109357,
                        "name": "Batiovo",
                        "latitude": "48.36166000",
                        "longitude": "22.39970000"
                    },
                    {
                        "id": 109373,
                        "name": "Berehivs’ka Mis’krada",
                        "latitude": "48.21255000",
                        "longitude": "22.65536000"
                    },
                    {
                        "id": 109375,
                        "name": "Berehove",
                        "latitude": "48.20555000",
                        "longitude": "22.64418000"
                    },
                    {
                        "id": 109376,
                        "name": "Berehove Raion",
                        "latitude": "48.16667000",
                        "longitude": "22.66667000"
                    },
                    {
                        "id": 109383,
                        "name": "Bereznyky",
                        "latitude": "48.51407000",
                        "longitude": "23.21982000"
                    },
                    {
                        "id": 109385,
                        "name": "Berezovo",
                        "latitude": "48.30943000",
                        "longitude": "23.47400000"
                    },
                    {
                        "id": 109398,
                        "name": "Bilky",
                        "latitude": "48.31503000",
                        "longitude": "23.13248000"
                    },
                    {
                        "id": 109414,
                        "name": "Bobovo",
                        "latitude": "48.07166000",
                        "longitude": "22.89585000"
                    },
                    {
                        "id": 109418,
                        "name": "Bohdan",
                        "latitude": "48.04122000",
                        "longitude": "24.35222000"
                    },
                    {
                        "id": 109464,
                        "name": "Bushtyno",
                        "latitude": "48.05121000",
                        "longitude": "23.48579000"
                    },
                    {
                        "id": 109508,
                        "name": "Chop",
                        "latitude": "48.43198000",
                        "longitude": "22.20555000"
                    },
                    {
                        "id": 109525,
                        "name": "Chynadiyovo",
                        "latitude": "48.48179000",
                        "longitude": "22.82170000"
                    },
                    {
                        "id": 109573,
                        "name": "Dovhe",
                        "latitude": "48.36527000",
                        "longitude": "23.27904000"
                    },
                    {
                        "id": 109576,
                        "name": "Drahovo",
                        "latitude": "48.23573000",
                        "longitude": "23.54914000"
                    },
                    {
                        "id": 109585,
                        "name": "Dubove",
                        "latitude": "48.17205000",
                        "longitude": "23.88954000"
                    },
                    {
                        "id": 109640,
                        "name": "Horinchovo",
                        "latitude": "48.27076000",
                        "longitude": "23.43475000"
                    },
                    {
                        "id": 109674,
                        "name": "Irshava",
                        "latitude": "48.31667000",
                        "longitude": "23.03846000"
                    },
                    {
                        "id": 109675,
                        "name": "Irshava Raion",
                        "latitude": "48.33333000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 109686,
                        "name": "Iza",
                        "latitude": "48.21525000",
                        "longitude": "23.32867000"
                    },
                    {
                        "id": 109706,
                        "name": "Kalyny",
                        "latitude": "48.14078000",
                        "longitude": "23.87380000"
                    },
                    {
                        "id": 109711,
                        "name": "Kamianytsia",
                        "latitude": "48.69343000",
                        "longitude": "22.39570000"
                    },
                    {
                        "id": 109742,
                        "name": "Khust",
                        "latitude": "48.17930000",
                        "longitude": "23.29909000"
                    },
                    {
                        "id": 109743,
                        "name": "Khust Raion",
                        "latitude": "48.25000000",
                        "longitude": "23.41667000"
                    },
                    {
                        "id": 109744,
                        "name": "Khusts’ka Mis’krada",
                        "latitude": "48.19058000",
                        "longitude": "23.30322000"
                    },
                    {
                        "id": 109772,
                        "name": "Kolochava",
                        "latitude": "48.42851000",
                        "longitude": "23.69590000"
                    },
                    {
                        "id": 109791,
                        "name": "Kopashnovo",
                        "latitude": "48.21970000",
                        "longitude": "23.48457000"
                    },
                    {
                        "id": 109799,
                        "name": "Korolevo",
                        "latitude": "48.15247000",
                        "longitude": "23.13659000"
                    },
                    {
                        "id": 109810,
                        "name": "Koson’",
                        "latitude": "48.25505000",
                        "longitude": "22.45597000"
                    },
                    {
                        "id": 109873,
                        "name": "Kryva",
                        "latitude": "48.17234000",
                        "longitude": "23.23647000"
                    },
                    {
                        "id": 109891,
                        "name": "Kushnytsya",
                        "latitude": "48.43988000",
                        "longitude": "23.25816000"
                    },
                    {
                        "id": 109896,
                        "name": "Kvasy",
                        "latitude": "48.14973000",
                        "longitude": "24.27995000"
                    },
                    {
                        "id": 109905,
                        "name": "Lazeshchyna",
                        "latitude": "48.26852000",
                        "longitude": "24.42010000"
                    },
                    {
                        "id": 109906,
                        "name": "Lazi",
                        "latitude": "48.06667000",
                        "longitude": "24.23333000"
                    },
                    {
                        "id": 109930,
                        "name": "Lopukhiv",
                        "latitude": "48.36527000",
                        "longitude": "23.96382000"
                    },
                    {
                        "id": 109954,
                        "name": "Lypcha",
                        "latitude": "48.26107000",
                        "longitude": "23.38336000"
                    },
                    {
                        "id": 109961,
                        "name": "Lysychovo",
                        "latitude": "48.49677000",
                        "longitude": "23.28992000"
                    },
                    {
                        "id": 110039,
                        "name": "Mizhhirya",
                        "latitude": "48.52458000",
                        "longitude": "23.50563000"
                    },
                    {
                        "id": 110040,
                        "name": "Mizhhirya Raion",
                        "latitude": "48.58333000",
                        "longitude": "23.50000000"
                    },
                    {
                        "id": 110058,
                        "name": "Mukacheve",
                        "latitude": "48.43919000",
                        "longitude": "22.71779000"
                    },
                    {
                        "id": 110059,
                        "name": "Mukachevo Raion",
                        "latitude": "48.41667000",
                        "longitude": "22.66667000"
                    },
                    {
                        "id": 110065,
                        "name": "Muzhiyevo",
                        "latitude": "48.17959000",
                        "longitude": "22.69943000"
                    },
                    {
                        "id": 110074,
                        "name": "Mynay",
                        "latitude": "48.58880000",
                        "longitude": "22.27502000"
                    },
                    {
                        "id": 110090,
                        "name": "Nelipyno",
                        "latitude": "48.56101000",
                        "longitude": "23.03146000"
                    },
                    {
                        "id": 110092,
                        "name": "Neresnytsya",
                        "latitude": "48.11814000",
                        "longitude": "23.76588000"
                    },
                    {
                        "id": 110094,
                        "name": "Nevyts’ke",
                        "latitude": "48.67472000",
                        "longitude": "22.38813000"
                    },
                    {
                        "id": 110111,
                        "name": "Nove Davydkovo",
                        "latitude": "48.44133000",
                        "longitude": "22.62164000"
                    },
                    {
                        "id": 110168,
                        "name": "Nyzhnye Selyshche",
                        "latitude": "48.19911000",
                        "longitude": "23.44757000"
                    },
                    {
                        "id": 110192,
                        "name": "Oleshnyk",
                        "latitude": "48.16406000",
                        "longitude": "22.96167000"
                    },
                    {
                        "id": 110197,
                        "name": "Onokivtsi",
                        "latitude": "48.65763000",
                        "longitude": "22.34183000"
                    },
                    {
                        "id": 110236,
                        "name": "Perechyn",
                        "latitude": "48.73616000",
                        "longitude": "22.48200000"
                    },
                    {
                        "id": 110237,
                        "name": "Perechyn Raion",
                        "latitude": "48.75000000",
                        "longitude": "22.66667000"
                    },
                    {
                        "id": 110271,
                        "name": "Pidvynohradiv",
                        "latitude": "48.13947000",
                        "longitude": "22.97194000"
                    },
                    {
                        "id": 110304,
                        "name": "Poroshkovo",
                        "latitude": "48.66832000",
                        "longitude": "22.75328000"
                    },
                    {
                        "id": 110334,
                        "name": "Pylypets",
                        "latitude": "48.65899000",
                        "longitude": "23.28346000"
                    },
                    {
                        "id": 110340,
                        "name": "Rakhiv",
                        "latitude": "48.05260000",
                        "longitude": "24.20089000"
                    },
                    {
                        "id": 110341,
                        "name": "Rakhiv Raion",
                        "latitude": "48.08333000",
                        "longitude": "24.33333000"
                    },
                    {
                        "id": 110343,
                        "name": "Rakoshyno",
                        "latitude": "48.46713000",
                        "longitude": "22.59687000"
                    },
                    {
                        "id": 110362,
                        "name": "Rokosovo",
                        "latitude": "48.21018000",
                        "longitude": "23.17624000"
                    },
                    {
                        "id": 110422,
                        "name": "Serednye",
                        "latitude": "48.54043000",
                        "longitude": "22.50696000"
                    },
                    {
                        "id": 110423,
                        "name": "Serednye Vodyane",
                        "latitude": "47.98159000",
                        "longitude": "23.91041000"
                    },
                    {
                        "id": 110513,
                        "name": "Solotvyno",
                        "latitude": "47.94604000",
                        "longitude": "23.87035000"
                    },
                    {
                        "id": 110554,
                        "name": "Storozhnytsya",
                        "latitude": "48.60403000",
                        "longitude": "22.23269000"
                    },
                    {
                        "id": 110555,
                        "name": "Strabychovo",
                        "latitude": "48.39247000",
                        "longitude": "22.54308000"
                    },
                    {
                        "id": 110569,
                        "name": "Svaliava Raion",
                        "latitude": "48.55000000",
                        "longitude": "23.00000000"
                    },
                    {
                        "id": 110570,
                        "name": "Svalyava",
                        "latitude": "48.54853000",
                        "longitude": "22.99578000"
                    },
                    {
                        "id": 110584,
                        "name": "Synevyr",
                        "latitude": "48.48745000",
                        "longitude": "23.62575000"
                    },
                    {
                        "id": 110585,
                        "name": "Synevyrska Poliana",
                        "latitude": "48.58484000",
                        "longitude": "23.68910000"
                    },
                    {
                        "id": 110607,
                        "name": "Tiachiv Raion",
                        "latitude": "48.08333000",
                        "longitude": "23.58333000"
                    },
                    {
                        "id": 110640,
                        "name": "Tyachiv",
                        "latitude": "48.01179000",
                        "longitude": "23.57061000"
                    },
                    {
                        "id": 110667,
                        "name": "Uzhgorod",
                        "latitude": "48.61667000",
                        "longitude": "22.30000000"
                    },
                    {
                        "id": 110668,
                        "name": "Uzhhorod Raion",
                        "latitude": "48.58333000",
                        "longitude": "22.33333000"
                    },
                    {
                        "id": 110674,
                        "name": "Vary",
                        "latitude": "48.12207000",
                        "longitude": "22.71281000"
                    },
                    {
                        "id": 110689,
                        "name": "Velyki Berehy",
                        "latitude": "48.23187000",
                        "longitude": "22.74591000"
                    },
                    {
                        "id": 110694,
                        "name": "Velykyi Bereznyi",
                        "latitude": "48.88831000",
                        "longitude": "22.46052000"
                    },
                    {
                        "id": 110695,
                        "name": "Velykyi Bereznyi Raion",
                        "latitude": "48.91667000",
                        "longitude": "22.58333000"
                    },
                    {
                        "id": 110737,
                        "name": "Volovets",
                        "latitude": "48.71090000",
                        "longitude": "23.18510000"
                    },
                    {
                        "id": 110738,
                        "name": "Volovets Raion",
                        "latitude": "48.75000000",
                        "longitude": "23.08333000"
                    },
                    {
                        "id": 110756,
                        "name": "Vylok",
                        "latitude": "48.10915000",
                        "longitude": "22.83865000"
                    },
                    {
                        "id": 110757,
                        "name": "Vynohradiv",
                        "latitude": "48.14135000",
                        "longitude": "23.02666000"
                    },
                    {
                        "id": 110758,
                        "name": "Vynohradiv Raion",
                        "latitude": "48.16667000",
                        "longitude": "23.00000000"
                    },
                    {
                        "id": 110764,
                        "name": "Vyshkovo",
                        "latitude": "48.04911000",
                        "longitude": "23.42113000"
                    },
                    {
                        "id": 110788,
                        "name": "Yasinya",
                        "latitude": "48.27937000",
                        "longitude": "24.36042000"
                    }
                ]
            },
            {
                "id": 4687,
                "name": "Zaporizka",
                "iso2": "23",
                "latitude": "47.83880000",
                "longitude": "35.13956700",
                "type": "region",
                "cities": [
                    {
                        "id": 109345,
                        "name": "Balky",
                        "latitude": "47.38336000",
                        "longitude": "34.94396000"
                    },
                    {
                        "id": 109367,
                        "name": "Berdiansk Raion",
                        "latitude": "46.83333000",
                        "longitude": "36.75000000"
                    },
                    {
                        "id": 109369,
                        "name": "Berdyans’ka Mis’krada",
                        "latitude": "46.81565000",
                        "longitude": "36.77049000"
                    },
                    {
                        "id": 109368,
                        "name": "Berdyansk",
                        "latitude": "46.76644000",
                        "longitude": "36.79872000"
                    },
                    {
                        "id": 109471,
                        "name": "Chapayevka",
                        "latitude": "47.47114000",
                        "longitude": "36.34507000"
                    },
                    {
                        "id": 109482,
                        "name": "Chernihivka Raion",
                        "latitude": "47.16667000",
                        "longitude": "36.25000000"
                    },
                    {
                        "id": 109551,
                        "name": "Dniprorudne",
                        "latitude": "47.38169000",
                        "longitude": "34.97652000"
                    },
                    {
                        "id": 109552,
                        "name": "Dniprovka",
                        "latitude": "47.42945000",
                        "longitude": "34.61805000"
                    },
                    {
                        "id": 109595,
                        "name": "Energodar",
                        "latitude": "47.49865000",
                        "longitude": "34.65740000"
                    },
                    {
                        "id": 109660,
                        "name": "Hulyaypole",
                        "latitude": "47.66389000",
                        "longitude": "36.25633000"
                    },
                    {
                        "id": 109748,
                        "name": "Kirove",
                        "latitude": "47.65311000",
                        "longitude": "35.69512000"
                    },
                    {
                        "id": 109785,
                        "name": "Komysh-Zorya",
                        "latitude": "47.32755000",
                        "longitude": "36.69298000"
                    },
                    {
                        "id": 109787,
                        "name": "Komyshuvakha",
                        "latitude": "47.71598000",
                        "longitude": "35.52981000"
                    },
                    {
                        "id": 109816,
                        "name": "Kostyantynivka",
                        "latitude": "46.81673000",
                        "longitude": "35.42287000"
                    },
                    {
                        "id": 109892,
                        "name": "Kushuhum",
                        "latitude": "47.71278000",
                        "longitude": "35.20917000"
                    },
                    {
                        "id": 109895,
                        "name": "Kuybysheve",
                        "latitude": "47.35800000",
                        "longitude": "36.64908000"
                    },
                    {
                        "id": 109899,
                        "name": "Kyrylivka",
                        "latitude": "46.37592000",
                        "longitude": "35.36753000"
                    },
                    {
                        "id": 109978,
                        "name": "Mala Bilozerka",
                        "latitude": "47.24737000",
                        "longitude": "34.93457000"
                    },
                    {
                        "id": 109980,
                        "name": "Mala Tokmachka",
                        "latitude": "47.53563000",
                        "longitude": "35.89293000"
                    },
                    {
                        "id": 109984,
                        "name": "Malokaterynivka",
                        "latitude": "47.65550000",
                        "longitude": "35.25649000"
                    },
                    {
                        "id": 110008,
                        "name": "Matviyivka",
                        "latitude": "47.07473000",
                        "longitude": "35.14444000"
                    },
                    {
                        "id": 110018,
                        "name": "Melitopol",
                        "latitude": "46.84891000",
                        "longitude": "35.36533000"
                    },
                    {
                        "id": 110019,
                        "name": "Melitopol’s’kyy Rayon",
                        "latitude": "46.90326000",
                        "longitude": "35.34616000"
                    },
                    {
                        "id": 110068,
                        "name": "Mykhaylivka",
                        "latitude": "47.27235000",
                        "longitude": "35.22235000"
                    },
                    {
                        "id": 110069,
                        "name": "Mykhaylivs’kyy Rayon",
                        "latitude": "47.22111000",
                        "longitude": "35.26580000"
                    },
                    {
                        "id": 110121,
                        "name": "Novobohdanivka",
                        "latitude": "47.08524000",
                        "longitude": "35.32945000"
                    },
                    {
                        "id": 110133,
                        "name": "Novomykolayivka",
                        "latitude": "47.97810000",
                        "longitude": "35.91020000"
                    },
                    {
                        "id": 110151,
                        "name": "Novovasylivka",
                        "latitude": "46.83021000",
                        "longitude": "35.75136000"
                    },
                    {
                        "id": 110203,
                        "name": "Orikhiv",
                        "latitude": "47.56731000",
                        "longitude": "35.78575000"
                    },
                    {
                        "id": 110211,
                        "name": "Osypenko",
                        "latitude": "46.91360000",
                        "longitude": "36.82530000"
                    },
                    {
                        "id": 110293,
                        "name": "Polohy",
                        "latitude": "47.48444000",
                        "longitude": "36.25361000"
                    },
                    {
                        "id": 110309,
                        "name": "Preobrazhenka",
                        "latitude": "47.57194000",
                        "longitude": "35.81667000"
                    },
                    {
                        "id": 110318,
                        "name": "Pryazovske Raion",
                        "latitude": "46.66667000",
                        "longitude": "35.66667000"
                    },
                    {
                        "id": 110322,
                        "name": "Prymors’k",
                        "latitude": "46.73479000",
                        "longitude": "36.34425000"
                    },
                    {
                        "id": 110321,
                        "name": "Prymorsk Raion",
                        "latitude": "46.83333000",
                        "longitude": "36.25000000"
                    },
                    {
                        "id": 110323,
                        "name": "Pryshyb",
                        "latitude": "47.25927000",
                        "longitude": "35.31953000"
                    },
                    {
                        "id": 110382,
                        "name": "Rozivka",
                        "latitude": "47.38484000",
                        "longitude": "37.06792000"
                    },
                    {
                        "id": 110383,
                        "name": "Rozivs’kyy Rayon",
                        "latitude": "47.46956000",
                        "longitude": "36.97192000"
                    },
                    {
                        "id": 110603,
                        "name": "Ternuvate",
                        "latitude": "47.83049000",
                        "longitude": "36.12761000"
                    },
                    {
                        "id": 110605,
                        "name": "Terpinnya",
                        "latitude": "46.96942000",
                        "longitude": "35.42100000"
                    },
                    {
                        "id": 110611,
                        "name": "Tokmak",
                        "latitude": "47.25522000",
                        "longitude": "35.71238000"
                    },
                    {
                        "id": 110612,
                        "name": "Tokmak Raion",
                        "latitude": "47.25000000",
                        "longitude": "35.75000000"
                    },
                    {
                        "id": 110641,
                        "name": "Tymoshivka",
                        "latitude": "47.18410000",
                        "longitude": "35.11625000"
                    },
                    {
                        "id": 110677,
                        "name": "Vasylivka",
                        "latitude": "47.43694000",
                        "longitude": "35.27417000"
                    },
                    {
                        "id": 110683,
                        "name": "Velyka Bilozerka",
                        "latitude": "47.27756000",
                        "longitude": "34.70616000"
                    },
                    {
                        "id": 110692,
                        "name": "Velykobilozers’kyy Rayon",
                        "latitude": "47.24341000",
                        "longitude": "34.66137000"
                    },
                    {
                        "id": 110713,
                        "name": "Vesele",
                        "latitude": "47.01479000",
                        "longitude": "34.91504000"
                    },
                    {
                        "id": 110718,
                        "name": "Vilniansk Raion",
                        "latitude": "48.00000000",
                        "longitude": "35.41667000"
                    },
                    {
                        "id": 110730,
                        "name": "Vodyane",
                        "latitude": "47.48746000",
                        "longitude": "34.49235000"
                    },
                    {
                        "id": 110750,
                        "name": "Voznesenka",
                        "latitude": "46.87165000",
                        "longitude": "35.46458000"
                    },
                    {
                        "id": 110775,
                        "name": "Yakymivka",
                        "latitude": "46.69972000",
                        "longitude": "35.15916000"
                    },
                    {
                        "id": 110776,
                        "name": "Yakymivka Raion",
                        "latitude": "46.58333000",
                        "longitude": "35.00000000"
                    },
                    {
                        "id": 110816,
                        "name": "Zaliznychne",
                        "latitude": "47.65238000",
                        "longitude": "36.16524000"
                    },
                    {
                        "id": 110821,
                        "name": "Zaporiz’ka Mis’krada",
                        "latitude": "47.84634000",
                        "longitude": "35.16824000"
                    },
                    {
                        "id": 110820,
                        "name": "Zaporizhia",
                        "latitude": "47.82289000",
                        "longitude": "35.19031000"
                    }
                ]
            },
            {
                "id": 4668,
                "name": "Zhytomyrska",
                "iso2": "18",
                "latitude": "50.25465000",
                "longitude": "28.65866690",
                "type": "region",
                "cities": [
                    {
                        "id": 109320,
                        "name": "Andrushivka",
                        "latitude": "50.02288000",
                        "longitude": "29.02023000"
                    },
                    {
                        "id": 109321,
                        "name": "Andrushivs’kyy Rayon",
                        "latitude": "50.01709000",
                        "longitude": "29.03215000"
                    },
                    {
                        "id": 109350,
                        "name": "Baranivka",
                        "latitude": "50.29691000",
                        "longitude": "27.66220000"
                    },
                    {
                        "id": 109370,
                        "name": "Berdychiv",
                        "latitude": "49.89928000",
                        "longitude": "28.60235000"
                    },
                    {
                        "id": 109371,
                        "name": "Berdychivskyy Rayon",
                        "latitude": "49.91667000",
                        "longitude": "28.58333000"
                    },
                    {
                        "id": 109392,
                        "name": "Bila Krynytsya",
                        "latitude": "50.63982000",
                        "longitude": "29.47041000"
                    },
                    {
                        "id": 109451,
                        "name": "Brusyliv",
                        "latitude": "50.28449000",
                        "longitude": "29.52626000"
                    },
                    {
                        "id": 109452,
                        "name": "Brusylivs’kyy Rayon",
                        "latitude": "50.25638000",
                        "longitude": "29.48742000"
                    },
                    {
                        "id": 109465,
                        "name": "Bykivka",
                        "latitude": "50.29285000",
                        "longitude": "27.98314000"
                    },
                    {
                        "id": 109479,
                        "name": "Cherniakhiv",
                        "latitude": "50.45652000",
                        "longitude": "28.67018000"
                    },
                    {
                        "id": 109495,
                        "name": "Chernyakhivskyy Rayon",
                        "latitude": "50.41667000",
                        "longitude": "28.66667000"
                    },
                    {
                        "id": 109499,
                        "name": "Chervone",
                        "latitude": "49.94975000",
                        "longitude": "28.86874000"
                    },
                    {
                        "id": 109509,
                        "name": "Chopovychi",
                        "latitude": "50.83325000",
                        "longitude": "28.95334000"
                    },
                    {
                        "id": 109514,
                        "name": "Chornorudka",
                        "latitude": "49.84640000",
                        "longitude": "29.06062000"
                    },
                    {
                        "id": 109520,
                        "name": "Chudniv",
                        "latitude": "50.05204000",
                        "longitude": "28.11745000"
                    },
                    {
                        "id": 109521,
                        "name": "Chudniv Raion",
                        "latitude": "50.00000000",
                        "longitude": "28.16667000"
                    },
                    {
                        "id": 109536,
                        "name": "Denyshi",
                        "latitude": "50.21415000",
                        "longitude": "28.40395000"
                    },
                    {
                        "id": 109572,
                        "name": "Dovbysh",
                        "latitude": "50.37332000",
                        "longitude": "27.98742000"
                    },
                    {
                        "id": 109638,
                        "name": "Holovyne",
                        "latitude": "50.47118000",
                        "longitude": "28.82530000"
                    },
                    {
                        "id": 109647,
                        "name": "Horodnytsya",
                        "latitude": "50.80697000",
                        "longitude": "27.31676000"
                    },
                    {
                        "id": 109649,
                        "name": "Horodok",
                        "latitude": "50.59483000",
                        "longitude": "29.46070000"
                    },
                    {
                        "id": 109658,
                        "name": "Hryshkivtsi",
                        "latitude": "49.93529000",
                        "longitude": "28.60383000"
                    },
                    {
                        "id": 109737,
                        "name": "Khoroshiv Raion",
                        "latitude": "50.66667000",
                        "longitude": "28.50000000"
                    },
                    {
                        "id": 109798,
                        "name": "Kornyn",
                        "latitude": "50.09530000",
                        "longitude": "29.53581000"
                    },
                    {
                        "id": 109801,
                        "name": "Korosten’",
                        "latitude": "50.95937000",
                        "longitude": "28.63855000"
                    },
                    {
                        "id": 109802,
                        "name": "Korostyshiv",
                        "latitude": "50.31723000",
                        "longitude": "29.05630000"
                    },
                    {
                        "id": 109803,
                        "name": "Korostyshiv Raion",
                        "latitude": "50.33333000",
                        "longitude": "29.08333000"
                    },
                    {
                        "id": 109923,
                        "name": "Liubar",
                        "latitude": "49.92045000",
                        "longitude": "27.75918000"
                    },
                    {
                        "id": 109941,
                        "name": "Luhyny",
                        "latitude": "51.08203000",
                        "longitude": "28.40057000"
                    },
                    {
                        "id": 109942,
                        "name": "Luhyny Raion",
                        "latitude": "51.08333000",
                        "longitude": "28.33333000"
                    },
                    {
                        "id": 109988,
                        "name": "Malyn",
                        "latitude": "50.77233000",
                        "longitude": "29.23833000"
                    },
                    {
                        "id": 109989,
                        "name": "Malyn Raion",
                        "latitude": "50.83084000",
                        "longitude": "29.19926000"
                    },
                    {
                        "id": 110081,
                        "name": "Narodychi",
                        "latitude": "51.20286000",
                        "longitude": "29.08228000"
                    },
                    {
                        "id": 110082,
                        "name": "Narodychi Raion",
                        "latitude": "51.25000000",
                        "longitude": "29.08333000"
                    },
                    {
                        "id": 110103,
                        "name": "Nova Borova",
                        "latitude": "50.69296000",
                        "longitude": "28.63446000"
                    },
                    {
                        "id": 110115,
                        "name": "Novi Bilokorovychi",
                        "latitude": "51.11548000",
                        "longitude": "28.05463000"
                    },
                    {
                        "id": 110128,
                        "name": "Novohrad-Volynskyi",
                        "latitude": "50.59412000",
                        "longitude": "27.61650000"
                    },
                    {
                        "id": 110194,
                        "name": "Olevs’k",
                        "latitude": "51.22482000",
                        "longitude": "27.65228000"
                    },
                    {
                        "id": 110214,
                        "name": "Ovruch",
                        "latitude": "51.32460000",
                        "longitude": "28.80351000"
                    },
                    {
                        "id": 110215,
                        "name": "Ovruch Raion",
                        "latitude": "51.33333000",
                        "longitude": "28.83333000"
                    },
                    {
                        "id": 110217,
                        "name": "Ozerne",
                        "latitude": "50.17816000",
                        "longitude": "28.73384000"
                    },
                    {
                        "id": 110246,
                        "name": "Pershotravneve",
                        "latitude": "51.39287000",
                        "longitude": "28.86837000"
                    },
                    {
                        "id": 110296,
                        "name": "Polyanka",
                        "latitude": "50.25836000",
                        "longitude": "27.68809000"
                    },
                    {
                        "id": 110301,
                        "name": "Popilnia",
                        "latitude": "49.95320000",
                        "longitude": "29.45265000"
                    },
                    {
                        "id": 110302,
                        "name": "Popilnia Raion",
                        "latitude": "49.91667000",
                        "longitude": "29.50000000"
                    },
                    {
                        "id": 110328,
                        "name": "Pulyny Raion",
                        "latitude": "50.50000000",
                        "longitude": "28.25000000"
                    },
                    {
                        "id": 110337,
                        "name": "Radomyshl",
                        "latitude": "50.49613000",
                        "longitude": "29.22911000"
                    },
                    {
                        "id": 110338,
                        "name": "Radomyshl Raion",
                        "latitude": "50.50000000",
                        "longitude": "29.25000000"
                    },
                    {
                        "id": 110366,
                        "name": "Romaniv",
                        "latitude": "50.14802000",
                        "longitude": "27.93124000"
                    },
                    {
                        "id": 110394,
                        "name": "Ruzhyn",
                        "latitude": "49.72280000",
                        "longitude": "29.20455000"
                    },
                    {
                        "id": 110544,
                        "name": "Stavyshche",
                        "latitude": "50.40051000",
                        "longitude": "29.52796000"
                    },
                    {
                        "id": 110615,
                        "name": "Topory",
                        "latitude": "49.65186000",
                        "longitude": "29.31741000"
                    },
                    {
                        "id": 110795,
                        "name": "Yemil’chyne",
                        "latitude": "50.87349000",
                        "longitude": "27.80604000"
                    },
                    {
                        "id": 110853,
                        "name": "Zhytomyr",
                        "latitude": "50.26487000",
                        "longitude": "28.67669000"
                    },
                    {
                        "id": 110854,
                        "name": "Zhytomyr Raion",
                        "latitude": "50.25000000",
                        "longitude": "28.58333000"
                    }
                ]
            }
        ]
    },
    {
        "id": 231,
        "name": "United Arab Emirates",
        "iso3": "ARE",
        "iso2": "AE",
        "numeric_code": "784",
        "phonecode": "971",
        "capital": "Abu Dhabi",
        "currency": "AED",
        "currency_name": "United Arab Emirates dirham",
        "currency_symbol": "إ.د",
        "tld": ".ae",
        "native": "دولة الإمارات العربية المتحدة",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Emirati, Emirian, Emiri",
        "timezones": [
            {
                "zoneName": "Asia\/Dubai",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "GST",
                "tzName": "Gulf Standard Time"
            }
        ],
        "translations": {
            "br": "Emirelezhioù Arab Unanet",
            "ko": "아랍에미리트",
            "pt-BR": "Emirados árabes Unidos",
            "pt": "Emirados árabes Unidos",
            "nl": "Verenigde Arabische Emiraten",
            "hr": "Ujedinjeni Arapski Emirati",
            "fa": "امارات متحده عربی",
            "de": "Vereinigte Arabische Emirate",
            "es": "Emiratos Árabes Unidos",
            "fr": "Émirats arabes unis",
            "ja": "アラブ首長国連邦",
            "it": "Emirati Arabi Uniti",
            "zh-CN": "阿拉伯联合酋长国",
            "tr": "Birleşik Arap Emirlikleri",
            "ru": "Объединенные Арабские Эмираты",
            "uk": "Об'єднані Арабські Емірати",
            "pl": "Zjednoczone Emiraty Arabskie"
        },
        "latitude": "24.00000000",
        "longitude": "54.00000000",
        "emoji": "🇦🇪",
        "emojiU": "U+1F1E6 U+1F1EA",
        "states": [
            {
                "id": 3396,
                "name": "Abu Dhabi",
                "iso2": "AZ",
                "latitude": "24.45388400",
                "longitude": "54.37734380",
                "type": "emirate",
                "cities": [
                    {
                        "id": 12,
                        "name": "Abu Dhabi",
                        "latitude": "24.41361000",
                        "longitude": "54.43295000"
                    },
                    {
                        "id": 16,
                        "name": "Al Ain City",
                        "latitude": "24.19167000",
                        "longitude": "55.76056000"
                    },
                    {
                        "id": 19,
                        "name": "Al Dhafra",
                        "latitude": "23.65745000",
                        "longitude": "53.72225000"
                    },
                    {
                        "id": 26,
                        "name": "Bani Yas City",
                        "latitude": "24.30978000",
                        "longitude": "54.62944000"
                    },
                    {
                        "id": 11,
                        "name": "Ghayathi",
                        "latitude": "23.90453420",
                        "longitude": "52.58710260"
                    },
                    {
                        "id": 34,
                        "name": "Khalifa City",
                        "latitude": "24.42588000",
                        "longitude": "54.60500000"
                    },
                    {
                        "id": 17,
                        "name": "Liwa Oasis",
                        "latitude": "22.86972550",
                        "longitude": "53.24086080"
                    },
                    {
                        "id": 41,
                        "name": "Mussafah",
                        "latitude": "24.35893000",
                        "longitude": "54.48267000"
                    },
                    {
                        "id": 42,
                        "name": "Muzayri‘",
                        "latitude": "23.14355000",
                        "longitude": "53.78810000"
                    },
                    {
                        "id": 25,
                        "name": "Ruwais",
                        "latitude": "24.11028000",
                        "longitude": "52.73056000"
                    },
                    {
                        "id": 49,
                        "name": "Zayed City",
                        "latitude": "23.65416000",
                        "longitude": "53.70522000"
                    }
                ]
            },
            {
                "id": 3395,
                "name": "Ajman",
                "iso2": "AJ",
                "latitude": "25.40521650",
                "longitude": "55.51364330",
                "type": "emirate",
                "cities": [
                    {
                        "id": 14,
                        "name": "Ajman",
                        "latitude": "25.40328000",
                        "longitude": "55.52341000"
                    },
                    {
                        "id": 15,
                        "name": "Ajman City",
                        "latitude": "25.40177000",
                        "longitude": "55.47878000"
                    },
                    {
                        "id": 37,
                        "name": "Manama",
                        "latitude": "25.32568000",
                        "longitude": "56.00259000"
                    },
                    {
                        "id": 38,
                        "name": "Masfut",
                        "latitude": "24.83982000",
                        "longitude": "56.05158000"
                    }
                ]
            },
            {
                "id": 3391,
                "name": "Dubai",
                "iso2": "DU",
                "latitude": "25.20484930",
                "longitude": "55.27078280",
                "type": "emirate",
                "cities": [
                    {
                        "id": 32,
                        "name": "Dubai",
                        "latitude": "25.06570000",
                        "longitude": "55.17128000"
                    }
                ]
            },
            {
                "id": 3393,
                "name": "Fujairah",
                "iso2": "FU",
                "latitude": "25.12880990",
                "longitude": "56.32648490",
                "type": "emirate",
                "cities": [
                    {
                        "id": 28,
                        "name": "Dibba Al Fujairah Municipality",
                        "latitude": "25.58580000",
                        "longitude": "56.24792000"
                    },
                    {
                        "id": 30,
                        "name": "Dibba Al-Fujairah",
                        "latitude": "25.59246000",
                        "longitude": "56.26176000"
                    },
                    {
                        "id": 31,
                        "name": "Dibba Al-Hisn",
                        "latitude": "25.61955000",
                        "longitude": "56.27291000"
                    },
                    {
                        "id": 20,
                        "name": "Fujairah",
                        "latitude": "25.11641000",
                        "longitude": "56.34141000"
                    }
                ]
            },
            {
                "id": 3394,
                "name": "Ras Al Khaimah",
                "iso2": "RK",
                "latitude": "25.67413430",
                "longitude": "55.98041730",
                "type": "emirate",
                "cities": [
                    {
                        "id": 43,
                        "name": "Ras Al Khaimah",
                        "latitude": "25.46116000",
                        "longitude": "56.04058000"
                    }
                ]
            },
            {
                "id": 3390,
                "name": "Sharjah",
                "iso2": "SH",
                "latitude": "25.07539740",
                "longitude": "55.75784030",
                "type": "emirate",
                "cities": [
                    {
                        "id": 18,
                        "name": "Al Batayih",
                        "latitude": "25.22317000",
                        "longitude": "55.74272000"
                    },
                    {
                        "id": 13,
                        "name": "Al Dhaid",
                        "latitude": "25.28812000",
                        "longitude": "55.88157000"
                    },
                    {
                        "id": 22,
                        "name": "Al Hamriyah",
                        "latitude": "25.46121000",
                        "longitude": "55.54813000"
                    },
                    {
                        "id": 23,
                        "name": "Al Madam",
                        "latitude": "24.95536000",
                        "longitude": "55.76820000"
                    },
                    {
                        "id": 33,
                        "name": "Kalba",
                        "latitude": "24.99816000",
                        "longitude": "56.27207000"
                    },
                    {
                        "id": 36,
                        "name": "Khor Fakkan",
                        "latitude": "25.33966000",
                        "longitude": "56.30280000"
                    },
                    {
                        "id": 39,
                        "name": "Milehah",
                        "latitude": "25.10097000",
                        "longitude": "55.91282000"
                    },
                    {
                        "id": 40,
                        "name": "Murbaḩ",
                        "latitude": "25.27623000",
                        "longitude": "56.36256000"
                    },
                    {
                        "id": 46,
                        "name": "Sharjah",
                        "latitude": "25.33737000",
                        "longitude": "55.41206000"
                    }
                ]
            },
            {
                "id": 3392,
                "name": "Umm Al Quwain",
                "iso2": "UQ",
                "latitude": "25.54263240",
                "longitude": "55.54753480",
                "type": "emirate",
                "cities": [
                    {
                        "id": 47,
                        "name": "Umm AL Quwain",
                        "latitude": "25.49326000",
                        "longitude": "55.73520000"
                    },
                    {
                        "id": 48,
                        "name": "Umm Al Quwain City",
                        "latitude": "25.56473000",
                        "longitude": "55.55517000"
                    }
                ]
            }
        ]
    },
    {
        "id": 232,
        "name": "United Kingdom",
        "iso3": "GBR",
        "iso2": "GB",
        "numeric_code": "826",
        "phonecode": "44",
        "capital": "London",
        "currency": "GBP",
        "currency_name": "British pound",
        "currency_symbol": "£",
        "tld": ".uk",
        "native": "United Kingdom",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Northern Europe",
        "subregion_id": 18,
        "nationality": "British, UK",
        "timezones": [
            {
                "zoneName": "Europe\/London",
                "gmtOffset": 0,
                "gmtOffsetName": "UTC±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "br": "Rouantelezh-Unanet",
            "ko": "영국",
            "pt-BR": "Reino Unido",
            "pt": "Reino Unido",
            "nl": "Verenigd Koninkrijk",
            "hr": "Ujedinjeno Kraljevstvo",
            "fa": "بریتانیای کبیر و ایرلند شمالی",
            "de": "Vereinigtes Königreich",
            "es": "Reino Unido",
            "fr": "Royaume-Uni",
            "ja": "イギリス",
            "it": "Regno Unito",
            "zh-CN": "英国",
            "tr": "Birleşik Krallik",
            "ru": "Великобритания",
            "uk": "Сполучене Королівство",
            "pl": "Wielka Brytania"
        },
        "latitude": "54.00000000",
        "longitude": "-2.00000000",
        "emoji": "🇬🇧",
        "emojiU": "U+1F1EC U+1F1E7",
        "states": [
            {
                "id": 2463,
                "name": "Aberdeen",
                "iso2": "ABE",
                "latitude": "57.14971700",
                "longitude": "-2.09427800",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2401,
                "name": "Aberdeenshire",
                "iso2": "ABD",
                "latitude": "57.28687230",
                "longitude": "-2.38156840",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2387,
                "name": "Angus",
                "iso2": "ANS",
                "latitude": "37.27578860",
                "longitude": "-95.65010330",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2533,
                "name": "Antrim",
                "iso2": "ANT",
                "latitude": "54.71953380",
                "longitude": "-6.20724980",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2412,
                "name": "Antrim and Newtownabbey",
                "iso2": "ANN",
                "latitude": "54.69568870",
                "longitude": "-5.94810690",
                "type": "district",
                "cities": []
            },
            {
                "id": 2498,
                "name": "Ards",
                "iso2": "ARD",
                "latitude": "42.13918510",
                "longitude": "-87.86149720",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2523,
                "name": "Ards and North Down",
                "iso2": "AND",
                "latitude": "54.58996450",
                "longitude": "-5.59849720",
                "type": "district",
                "cities": []
            },
            {
                "id": 2392,
                "name": "Argyll and Bute",
                "iso2": "AGB",
                "latitude": "56.40062140",
                "longitude": "-5.48074800",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2331,
                "name": "Armagh",
                "iso2": "ARM",
                "latitude": "54.39325920",
                "longitude": "-6.45634010",
                "type": "district council",
                "cities": []
            },
            {
                "id": 2324,
                "name": "Armagh, Banbridge and Craigavon",
                "iso2": "ABC",
                "latitude": "54.38426080",
                "longitude": "-7.10672170",
                "type": "district",
                "cities": []
            },
            {
                "id": 2378,
                "name": "Ascension Island",
                "iso2": "SH-AC",
                "latitude": "-7.94671660",
                "longitude": "-14.35591580",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2363,
                "name": "Ballymena",
                "iso2": "BLA",
                "latitude": "54.86426000",
                "longitude": "-6.27910740",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2361,
                "name": "Ballymoney",
                "iso2": "BLY",
                "latitude": "55.07048880",
                "longitude": "-6.51737080",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2315,
                "name": "Banbridge",
                "iso2": "BNB",
                "latitude": "54.34872900",
                "longitude": "-6.27048030",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2356,
                "name": "Barking and Dagenham",
                "iso2": "BDG",
                "latitude": "51.55406660",
                "longitude": "0.13401700",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2520,
                "name": "Barnet",
                "iso2": "BNE",
                "latitude": "51.60496730",
                "longitude": "-0.20762950",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2499,
                "name": "Barnsley",
                "iso2": "BNS",
                "latitude": "34.29949560",
                "longitude": "-84.98458090",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2339,
                "name": "Bath and North East Somerset",
                "iso2": "BAS",
                "latitude": "51.32501020",
                "longitude": "-2.47662410",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2507,
                "name": "Bedford",
                "iso2": "BDF",
                "latitude": "32.84401700",
                "longitude": "-97.14306710",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2311,
                "name": "Belfast",
                "iso2": "BFS",
                "latitude": "54.61703660",
                "longitude": "-5.95318610",
                "type": "district",
                "cities": []
            },
            {
                "id": 2307,
                "name": "Bexley",
                "iso2": "BEX",
                "latitude": "51.45190210",
                "longitude": "0.11717860",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2425,
                "name": "Birmingham",
                "iso2": "BIR",
                "latitude": "33.51858920",
                "longitude": "-86.81035670",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2329,
                "name": "Blackburn with Darwen",
                "iso2": "BBD",
                "latitude": "53.69575220",
                "longitude": "-2.46829850",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2451,
                "name": "Blackpool",
                "iso2": "BPL",
                "latitude": "53.81750530",
                "longitude": "-3.03567480",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2530,
                "name": "Blaenau Gwent",
                "iso2": "BGW",
                "latitude": "51.78757790",
                "longitude": "-3.20439310",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2504,
                "name": "Bolton",
                "iso2": "BOL",
                "latitude": "44.37264760",
                "longitude": "-72.87876250",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2342,
                "name": "Bournemouth",
                "iso2": "BMH",
                "latitude": "50.71916400",
                "longitude": "-1.88076900",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2470,
                "name": "Bracknell Forest",
                "iso2": "BRC",
                "latitude": "51.41538280",
                "longitude": "-0.75364950",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2529,
                "name": "Bradford",
                "iso2": "BRD",
                "latitude": "53.79598400",
                "longitude": "-1.75939800",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2291,
                "name": "Brent",
                "iso2": "BEN",
                "latitude": "51.56728080",
                "longitude": "-0.27105680",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2452,
                "name": "Bridgend",
                "iso2": "BGE",
                "latitude": "51.50831990",
                "longitude": "-3.58120750",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2395,
                "name": "Brighton and Hove",
                "iso2": "BNH",
                "latitude": "50.82262880",
                "longitude": "-0.13704700",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2413,
                "name": "Bristol",
                "iso2": "BST",
                "latitude": "41.67352200",
                "longitude": "-72.94653750",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2490,
                "name": "Bromley",
                "iso2": "BRY",
                "latitude": "51.36797050",
                "longitude": "0.07006200",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2405,
                "name": "Buckinghamshire",
                "iso2": "BKM",
                "latitude": "51.80722040",
                "longitude": "-0.81276640",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2459,
                "name": "Bury",
                "iso2": "BUR",
                "latitude": "53.59334980",
                "longitude": "-2.29660540",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2298,
                "name": "Caerphilly",
                "iso2": "CAY",
                "latitude": "51.66044650",
                "longitude": "-3.21787240",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2517,
                "name": "Calderdale",
                "iso2": "CLD",
                "latitude": "53.72478450",
                "longitude": "-1.86583570",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2423,
                "name": "Cambridgeshire",
                "iso2": "CAM",
                "latitude": "52.20529730",
                "longitude": "0.12181950",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2349,
                "name": "Camden",
                "iso2": "CMD",
                "latitude": "51.54547360",
                "longitude": "-0.16279020",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2528,
                "name": "Cardiff",
                "iso2": "CRF",
                "latitude": "51.48158100",
                "longitude": "-3.17909000",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2484,
                "name": "Carmarthenshire",
                "iso2": "CMN",
                "latitude": "51.85723090",
                "longitude": "-4.31159590",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2439,
                "name": "Carrickfergus",
                "iso2": "CKF",
                "latitude": "54.72568430",
                "longitude": "-5.80937190",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2525,
                "name": "Castlereagh",
                "iso2": "CSR",
                "latitude": "54.57567900",
                "longitude": "-5.88840280",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2316,
                "name": "Causeway Coast and Glens",
                "iso2": "CCG",
                "latitude": "55.04318300",
                "longitude": "-6.67412880",
                "type": "district",
                "cities": []
            },
            {
                "id": 2303,
                "name": "Central Bedfordshire",
                "iso2": "CBF",
                "latitude": "52.00297440",
                "longitude": "-0.46513890",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2509,
                "name": "Ceredigion",
                "iso2": "CGN",
                "latitude": "52.21914290",
                "longitude": "-3.93212560",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2444,
                "name": "Cheshire East",
                "iso2": "CHE",
                "latitude": "53.16104460",
                "longitude": "-2.21859320",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2442,
                "name": "Cheshire West and Chester",
                "iso2": "CHW",
                "latitude": "53.23029740",
                "longitude": "-2.71511170",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2475,
                "name": "City of Kingston upon Hull",
                "iso2": "KHL",
                "latitude": "53.76762360",
                "longitude": "-0.32741980",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2294,
                "name": "City of Southampton",
                "iso2": "STH",
                "latitude": "50.90970040",
                "longitude": "-1.40435090",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2450,
                "name": "Clackmannanshire",
                "iso2": "CLK",
                "latitude": "56.10753510",
                "longitude": "-3.75294090",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2461,
                "name": "Coleraine",
                "iso2": "CLR",
                "latitude": "55.14515700",
                "longitude": "-6.67598140",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2352,
                "name": "Conwy",
                "iso2": "CWY",
                "latitude": "53.29350130",
                "longitude": "-3.72651610",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2445,
                "name": "Cookstown",
                "iso2": "CKT",
                "latitude": "54.64181580",
                "longitude": "-6.74438950",
                "type": "district council",
                "cities": []
            },
            {
                "id": 2312,
                "name": "Cornwall",
                "iso2": "CON",
                "latitude": "50.26604710",
                "longitude": "-5.05271250",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2438,
                "name": "Coventry",
                "iso2": "COV",
                "latitude": "52.40682200",
                "longitude": "-1.51969300",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2449,
                "name": "Craigavon",
                "iso2": "CGV",
                "latitude": "54.43700070",
                "longitude": "-6.45634010",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2512,
                "name": "Croydon",
                "iso2": "CRY",
                "latitude": "51.38274460",
                "longitude": "-0.09851630",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2334,
                "name": "Cumbria",
                "iso2": "CMA",
                "latitude": "54.57723230",
                "longitude": "-2.79748350",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2389,
                "name": "Darlington",
                "iso2": "DAL",
                "latitude": "34.29987620",
                "longitude": "-79.87617410",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2497,
                "name": "Denbighshire",
                "iso2": "DEN",
                "latitude": "53.18422880",
                "longitude": "-3.42249850",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2485,
                "name": "Derby",
                "iso2": "DER",
                "latitude": "37.54837550",
                "longitude": "-97.24851910",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2403,
                "name": "Derbyshire",
                "iso2": "DBY",
                "latitude": "53.10467820",
                "longitude": "-1.56238850",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2417,
                "name": "Derry",
                "iso2": "DRY",
                "latitude": "54.96907780",
                "longitude": "-7.19583510",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2446,
                "name": "Derry City and Strabane",
                "iso2": "DRS",
                "latitude": "55.00474430",
                "longitude": "-7.32092220",
                "type": "district",
                "cities": []
            },
            {
                "id": 2491,
                "name": "Devon",
                "iso2": "DEV",
                "latitude": "50.71555910",
                "longitude": "-3.53087500",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2364,
                "name": "Doncaster",
                "iso2": "DNC",
                "latitude": "53.52282000",
                "longitude": "-1.12846200",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2345,
                "name": "Dorset",
                "iso2": "DOR",
                "latitude": "50.74876350",
                "longitude": "-2.34447860",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2304,
                "name": "Down District Council",
                "iso2": "DOW",
                "latitude": "54.24342870",
                "longitude": "-5.95779590",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2457,
                "name": "Dudley",
                "iso2": "DUD",
                "latitude": "42.04336610",
                "longitude": "-71.92760330",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2415,
                "name": "Dumfries and Galloway",
                "iso2": "DGY",
                "latitude": "55.07010730",
                "longitude": "-3.60525810",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2511,
                "name": "Dundee",
                "iso2": "DND",
                "latitude": "56.46201800",
                "longitude": "-2.97072100",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2508,
                "name": "Dungannon and South Tyrone",
                "iso2": "DGN",
                "latitude": "54.50826840",
                "longitude": "-6.76658910",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2406,
                "name": "Durham",
                "iso2": "DUR",
                "latitude": "54.72940990",
                "longitude": "-1.88115980",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2532,
                "name": "Ealing",
                "iso2": "EAL",
                "latitude": "51.52503660",
                "longitude": "-0.34139650",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2374,
                "name": "East Ayrshire",
                "iso2": "EAY",
                "latitude": "55.45184960",
                "longitude": "-4.26444780",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2454,
                "name": "East Dunbartonshire",
                "iso2": "EDU",
                "latitude": "55.97431620",
                "longitude": "-4.20229800",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2462,
                "name": "East Lothian",
                "iso2": "ELN",
                "latitude": "55.94933830",
                "longitude": "-2.77044640",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2333,
                "name": "East Renfrewshire",
                "iso2": "ERW",
                "latitude": "55.77047350",
                "longitude": "-4.33598210",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2370,
                "name": "East Riding of Yorkshire",
                "iso2": "ERY",
                "latitude": "53.84161680",
                "longitude": "-0.43441060",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2414,
                "name": "East Sussex",
                "iso2": "ESX",
                "latitude": "50.90859550",
                "longitude": "0.24941660",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2428,
                "name": "Edinburgh",
                "iso2": "EDH",
                "latitude": "55.95325200",
                "longitude": "-3.18826700",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2476,
                "name": "Enfield",
                "iso2": "ENF",
                "latitude": "51.66229090",
                "longitude": "-0.11806510",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2336,
                "name": "England",
                "iso2": "ENG",
                "latitude": "52.35551770",
                "longitude": "-1.17431970",
                "type": "country",
                "cities": [
                    {
                        "id": 48157,
                        "name": "Abbey Wood",
                        "latitude": "51.48688000",
                        "longitude": "0.10747000"
                    },
                    {
                        "id": 48158,
                        "name": "Abbots Bromley",
                        "latitude": "52.81705000",
                        "longitude": "-1.87694000"
                    },
                    {
                        "id": 48159,
                        "name": "Abbots Langley",
                        "latitude": "51.70573000",
                        "longitude": "-0.41757000"
                    },
                    {
                        "id": 48160,
                        "name": "Abbotskerswell",
                        "latitude": "50.50816000",
                        "longitude": "-3.61342000"
                    },
                    {
                        "id": 48161,
                        "name": "Abbotts Ann",
                        "latitude": "51.19016000",
                        "longitude": "-1.53234000"
                    },
                    {
                        "id": 48174,
                        "name": "Aberford",
                        "latitude": "53.82604000",
                        "longitude": "-1.34231000"
                    },
                    {
                        "id": 48184,
                        "name": "Abingdon",
                        "latitude": "51.67109000",
                        "longitude": "-1.28278000"
                    },
                    {
                        "id": 48186,
                        "name": "Abram",
                        "latitude": "53.50855000",
                        "longitude": "-2.59266000"
                    },
                    {
                        "id": 48187,
                        "name": "Abridge",
                        "latitude": "51.64950000",
                        "longitude": "0.12033000"
                    },
                    {
                        "id": 48188,
                        "name": "Accrington",
                        "latitude": "53.75379000",
                        "longitude": "-2.35863000"
                    },
                    {
                        "id": 48189,
                        "name": "Acklington",
                        "latitude": "55.30000000",
                        "longitude": "-1.63333000"
                    },
                    {
                        "id": 48190,
                        "name": "Acle",
                        "latitude": "52.63681000",
                        "longitude": "1.54757000"
                    },
                    {
                        "id": 48191,
                        "name": "Acocks Green",
                        "latitude": "52.45000000",
                        "longitude": "-1.81667000"
                    },
                    {
                        "id": 48192,
                        "name": "Acomb",
                        "latitude": "54.99229000",
                        "longitude": "-2.11229000"
                    },
                    {
                        "id": 48193,
                        "name": "Acton",
                        "latitude": "51.50901000",
                        "longitude": "-0.27620000"
                    },
                    {
                        "id": 48194,
                        "name": "Adderbury",
                        "latitude": "52.01690000",
                        "longitude": "-1.31192000"
                    },
                    {
                        "id": 48196,
                        "name": "Addingham",
                        "latitude": "53.94452000",
                        "longitude": "-1.88424000"
                    },
                    {
                        "id": 48197,
                        "name": "Addlestone",
                        "latitude": "51.37135000",
                        "longitude": "-0.49353000"
                    },
                    {
                        "id": 48198,
                        "name": "Adlington",
                        "latitude": "53.61323000",
                        "longitude": "-2.60676000"
                    },
                    {
                        "id": 48199,
                        "name": "Adwick le Street",
                        "latitude": "53.57077000",
                        "longitude": "-1.18454000"
                    },
                    {
                        "id": 48202,
                        "name": "Airmyn",
                        "latitude": "53.72074000",
                        "longitude": "-0.89959000"
                    },
                    {
                        "id": 48204,
                        "name": "Albrighton",
                        "latitude": "52.63640000",
                        "longitude": "-2.27966000"
                    },
                    {
                        "id": 48205,
                        "name": "Alcester",
                        "latitude": "52.21667000",
                        "longitude": "-1.86667000"
                    },
                    {
                        "id": 48206,
                        "name": "Alconbury",
                        "latitude": "52.36900000",
                        "longitude": "-0.26009000"
                    },
                    {
                        "id": 48207,
                        "name": "Aldbourne",
                        "latitude": "51.48098000",
                        "longitude": "-1.61827000"
                    },
                    {
                        "id": 48208,
                        "name": "Aldbrough",
                        "latitude": "53.82893000",
                        "longitude": "-0.11467000"
                    },
                    {
                        "id": 48209,
                        "name": "Aldeburgh",
                        "latitude": "52.15259000",
                        "longitude": "1.60124000"
                    },
                    {
                        "id": 48210,
                        "name": "Alderbury",
                        "latitude": "51.04354000",
                        "longitude": "-1.73382000"
                    },
                    {
                        "id": 48211,
                        "name": "Alderholt",
                        "latitude": "50.91195000",
                        "longitude": "-1.83083000"
                    },
                    {
                        "id": 48212,
                        "name": "Alderley Edge",
                        "latitude": "53.30393000",
                        "longitude": "-2.23773000"
                    },
                    {
                        "id": 48213,
                        "name": "Aldershot",
                        "latitude": "51.24827000",
                        "longitude": "-0.76389000"
                    },
                    {
                        "id": 48214,
                        "name": "Aldford",
                        "latitude": "53.12762000",
                        "longitude": "-2.86812000"
                    },
                    {
                        "id": 48215,
                        "name": "Aldridge",
                        "latitude": "52.60549000",
                        "longitude": "-1.91715000"
                    },
                    {
                        "id": 48217,
                        "name": "Alford",
                        "latitude": "53.25943000",
                        "longitude": "0.17625000"
                    },
                    {
                        "id": 48219,
                        "name": "Alfreton",
                        "latitude": "53.09766000",
                        "longitude": "-1.38376000"
                    },
                    {
                        "id": 48221,
                        "name": "Allhallows",
                        "latitude": "51.46866000",
                        "longitude": "0.63686000"
                    },
                    {
                        "id": 48224,
                        "name": "Almondsbury",
                        "latitude": "51.55407000",
                        "longitude": "-2.57114000"
                    },
                    {
                        "id": 48226,
                        "name": "Alnwick",
                        "latitude": "55.41318000",
                        "longitude": "-1.70563000"
                    },
                    {
                        "id": 48227,
                        "name": "Alresford",
                        "latitude": "51.85389000",
                        "longitude": "1.00203000"
                    },
                    {
                        "id": 48228,
                        "name": "Alrewas",
                        "latitude": "52.73278000",
                        "longitude": "-1.74968000"
                    },
                    {
                        "id": 48229,
                        "name": "Alsager",
                        "latitude": "53.09617000",
                        "longitude": "-2.30649000"
                    },
                    {
                        "id": 48230,
                        "name": "Alston",
                        "latitude": "54.80900000",
                        "longitude": "-2.43931000"
                    },
                    {
                        "id": 48231,
                        "name": "Althorne",
                        "latitude": "51.65722000",
                        "longitude": "0.76085000"
                    },
                    {
                        "id": 48232,
                        "name": "Alton",
                        "latitude": "51.14931000",
                        "longitude": "-0.97469000"
                    },
                    {
                        "id": 48233,
                        "name": "Altrincham",
                        "latitude": "53.38752000",
                        "longitude": "-2.34848000"
                    },
                    {
                        "id": 48235,
                        "name": "Alvechurch",
                        "latitude": "52.35173000",
                        "longitude": "-1.96531000"
                    },
                    {
                        "id": 48236,
                        "name": "Alveley",
                        "latitude": "52.45709000",
                        "longitude": "-2.35434000"
                    },
                    {
                        "id": 48237,
                        "name": "Alveston",
                        "latitude": "51.58806000",
                        "longitude": "-2.53139000"
                    },
                    {
                        "id": 48239,
                        "name": "Amble",
                        "latitude": "55.33333000",
                        "longitude": "-1.58333000"
                    },
                    {
                        "id": 48240,
                        "name": "Ambleside",
                        "latitude": "54.43261000",
                        "longitude": "-2.96167000"
                    },
                    {
                        "id": 48241,
                        "name": "Ambrosden",
                        "latitude": "51.87087000",
                        "longitude": "-1.12129000"
                    },
                    {
                        "id": 48242,
                        "name": "Amersham",
                        "latitude": "51.66667000",
                        "longitude": "-0.61667000"
                    },
                    {
                        "id": 48243,
                        "name": "Amersham on the Hill",
                        "latitude": "51.67468000",
                        "longitude": "-0.60742000"
                    },
                    {
                        "id": 48244,
                        "name": "Amesbury",
                        "latitude": "51.17509000",
                        "longitude": "-1.78064000"
                    },
                    {
                        "id": 48247,
                        "name": "Ampthill",
                        "latitude": "52.02694000",
                        "longitude": "-0.49567000"
                    },
                    {
                        "id": 48248,
                        "name": "Ancaster",
                        "latitude": "52.98276000",
                        "longitude": "-0.53593000"
                    },
                    {
                        "id": 48249,
                        "name": "Andover",
                        "latitude": "51.21135000",
                        "longitude": "-1.49393000"
                    },
                    {
                        "id": 48252,
                        "name": "Anna Valley",
                        "latitude": "51.19317000",
                        "longitude": "-1.50719000"
                    },
                    {
                        "id": 48256,
                        "name": "Annfield Plain",
                        "latitude": "54.85749000",
                        "longitude": "-1.73827000"
                    },
                    {
                        "id": 48257,
                        "name": "Anstey",
                        "latitude": "52.67368000",
                        "longitude": "-1.18841000"
                    },
                    {
                        "id": 48261,
                        "name": "Appleby",
                        "latitude": "53.62198000",
                        "longitude": "-0.56612000"
                    },
                    {
                        "id": 48262,
                        "name": "Appleby-in-Westmorland",
                        "latitude": "54.57704000",
                        "longitude": "-2.48978000"
                    },
                    {
                        "id": 48263,
                        "name": "Appledore",
                        "latitude": "51.05000000",
                        "longitude": "-4.20000000"
                    },
                    {
                        "id": 48264,
                        "name": "Appleton Thorn",
                        "latitude": "53.35045000",
                        "longitude": "-2.54488000"
                    },
                    {
                        "id": 48265,
                        "name": "Appley Bridge",
                        "latitude": "53.57781000",
                        "longitude": "-2.72090000"
                    },
                    {
                        "id": 48267,
                        "name": "Archway",
                        "latitude": "51.56733000",
                        "longitude": "-0.13415000"
                    },
                    {
                        "id": 48270,
                        "name": "Ardingly",
                        "latitude": "51.04865000",
                        "longitude": "-0.07716000"
                    },
                    {
                        "id": 48275,
                        "name": "Arlesey",
                        "latitude": "52.00713000",
                        "longitude": "-0.26565000"
                    },
                    {
                        "id": 48279,
                        "name": "Armitage",
                        "latitude": "52.74193000",
                        "longitude": "-1.88266000"
                    },
                    {
                        "id": 48280,
                        "name": "Armthorpe",
                        "latitude": "53.53518000",
                        "longitude": "-1.05341000"
                    },
                    {
                        "id": 48281,
                        "name": "Arnold",
                        "latitude": "53.00000000",
                        "longitude": "-1.13333000"
                    },
                    {
                        "id": 48282,
                        "name": "Arnside",
                        "latitude": "54.20179000",
                        "longitude": "-2.83374000"
                    },
                    {
                        "id": 48283,
                        "name": "Arundel",
                        "latitude": "50.85423000",
                        "longitude": "-0.55393000"
                    },
                    {
                        "id": 48284,
                        "name": "Ascot",
                        "latitude": "51.41082000",
                        "longitude": "-0.67480000"
                    },
                    {
                        "id": 48285,
                        "name": "Asfordby",
                        "latitude": "52.76331000",
                        "longitude": "-0.95856000"
                    },
                    {
                        "id": 48286,
                        "name": "Ash",
                        "latitude": "51.27883000",
                        "longitude": "1.27974000"
                    },
                    {
                        "id": 48287,
                        "name": "Ashbourne",
                        "latitude": "53.01667000",
                        "longitude": "-1.73333000"
                    },
                    {
                        "id": 48288,
                        "name": "Ashburton",
                        "latitude": "50.51559000",
                        "longitude": "-3.75572000"
                    },
                    {
                        "id": 48289,
                        "name": "Ashby de la Zouch",
                        "latitude": "52.74632000",
                        "longitude": "-1.47320000"
                    },
                    {
                        "id": 48290,
                        "name": "Ashford",
                        "latitude": "51.14648000",
                        "longitude": "0.87376000"
                    },
                    {
                        "id": 48292,
                        "name": "Ashill",
                        "latitude": "52.60435000",
                        "longitude": "0.78574000"
                    },
                    {
                        "id": 48293,
                        "name": "Ashington",
                        "latitude": "55.17719000",
                        "longitude": "-1.56412000"
                    },
                    {
                        "id": 48294,
                        "name": "Ashtead",
                        "latitude": "51.30873000",
                        "longitude": "-0.29972000"
                    },
                    {
                        "id": 48296,
                        "name": "Ashton in Makerfield",
                        "latitude": "53.48333000",
                        "longitude": "-2.65000000"
                    },
                    {
                        "id": 48295,
                        "name": "Ashton Keynes",
                        "latitude": "51.64521000",
                        "longitude": "-1.93232000"
                    },
                    {
                        "id": 48297,
                        "name": "Ashton-under-Lyne",
                        "latitude": "53.48876000",
                        "longitude": "-2.09890000"
                    },
                    {
                        "id": 48298,
                        "name": "Ashurst",
                        "latitude": "50.93236000",
                        "longitude": "-0.32375000"
                    },
                    {
                        "id": 48299,
                        "name": "Ashwell",
                        "latitude": "52.03866000",
                        "longitude": "-0.15398000"
                    },
                    {
                        "id": 48300,
                        "name": "Askam in Furness",
                        "latitude": "54.18718000",
                        "longitude": "-3.20467000"
                    },
                    {
                        "id": 48301,
                        "name": "Askern",
                        "latitude": "53.61639000",
                        "longitude": "-1.15237000"
                    },
                    {
                        "id": 48302,
                        "name": "Aslockton",
                        "latitude": "52.95299000",
                        "longitude": "-0.89700000"
                    },
                    {
                        "id": 48303,
                        "name": "Aspatria",
                        "latitude": "54.76574000",
                        "longitude": "-3.32783000"
                    },
                    {
                        "id": 48304,
                        "name": "Aston",
                        "latitude": "52.50000000",
                        "longitude": "-1.88333000"
                    },
                    {
                        "id": 48305,
                        "name": "Aston Clinton",
                        "latitude": "51.80020000",
                        "longitude": "-0.72540000"
                    },
                    {
                        "id": 48306,
                        "name": "Aston-on-Trent",
                        "latitude": "52.86172000",
                        "longitude": "-1.38642000"
                    },
                    {
                        "id": 48307,
                        "name": "Astwood Bank",
                        "latitude": "52.25993000",
                        "longitude": "-1.93754000"
                    },
                    {
                        "id": 48308,
                        "name": "Atherstone",
                        "latitude": "52.57536000",
                        "longitude": "-1.54693000"
                    },
                    {
                        "id": 48309,
                        "name": "Atherton",
                        "latitude": "53.52371000",
                        "longitude": "-2.49354000"
                    },
                    {
                        "id": 48310,
                        "name": "Attleborough",
                        "latitude": "52.51779000",
                        "longitude": "1.01572000"
                    },
                    {
                        "id": 48311,
                        "name": "Atworth",
                        "latitude": "51.39234000",
                        "longitude": "-2.19297000"
                    },
                    {
                        "id": 48315,
                        "name": "Auckley",
                        "latitude": "53.50386000",
                        "longitude": "-1.02174000"
                    },
                    {
                        "id": 48316,
                        "name": "Audlem",
                        "latitude": "52.98956000",
                        "longitude": "-2.50706000"
                    },
                    {
                        "id": 48317,
                        "name": "Audley",
                        "latitude": "53.05000000",
                        "longitude": "-2.30000000"
                    },
                    {
                        "id": 48318,
                        "name": "Aveley",
                        "latitude": "51.49987000",
                        "longitude": "0.25174000"
                    },
                    {
                        "id": 48319,
                        "name": "Avening",
                        "latitude": "51.68010000",
                        "longitude": "-2.16903000"
                    },
                    {
                        "id": 48321,
                        "name": "Awsworth",
                        "latitude": "52.98912000",
                        "longitude": "-1.28354000"
                    },
                    {
                        "id": 48322,
                        "name": "Axbridge",
                        "latitude": "51.28466000",
                        "longitude": "-2.82078000"
                    },
                    {
                        "id": 48323,
                        "name": "Axminster",
                        "latitude": "50.78259000",
                        "longitude": "-2.99787000"
                    },
                    {
                        "id": 48324,
                        "name": "Aylesbury",
                        "latitude": "51.81665000",
                        "longitude": "-0.81458000"
                    },
                    {
                        "id": 48325,
                        "name": "Aylesford",
                        "latitude": "51.30374000",
                        "longitude": "0.47936000"
                    },
                    {
                        "id": 48326,
                        "name": "Aylesham",
                        "latitude": "51.22539000",
                        "longitude": "1.20157000"
                    },
                    {
                        "id": 48327,
                        "name": "Aylsham",
                        "latitude": "52.79672000",
                        "longitude": "1.25107000"
                    },
                    {
                        "id": 48329,
                        "name": "Babworth",
                        "latitude": "53.31799000",
                        "longitude": "-0.97583000"
                    },
                    {
                        "id": 48330,
                        "name": "Backworth",
                        "latitude": "55.04229000",
                        "longitude": "-1.52779000"
                    },
                    {
                        "id": 48331,
                        "name": "Bacton",
                        "latitude": "52.26667000",
                        "longitude": "1.01667000"
                    },
                    {
                        "id": 48332,
                        "name": "Bacup",
                        "latitude": "53.70336000",
                        "longitude": "-2.20070000"
                    },
                    {
                        "id": 48333,
                        "name": "Badsey",
                        "latitude": "52.08819000",
                        "longitude": "-1.89925000"
                    },
                    {
                        "id": 48334,
                        "name": "Badsworth",
                        "latitude": "53.62876000",
                        "longitude": "-1.30128000"
                    },
                    {
                        "id": 48336,
                        "name": "Bagshot",
                        "latitude": "51.36069000",
                        "longitude": "-0.68802000"
                    },
                    {
                        "id": 48337,
                        "name": "Bagworth",
                        "latitude": "52.67265000",
                        "longitude": "-1.34274000"
                    },
                    {
                        "id": 48338,
                        "name": "Baildon",
                        "latitude": "53.84711000",
                        "longitude": "-1.78785000"
                    },
                    {
                        "id": 48339,
                        "name": "Bakewell",
                        "latitude": "53.21338000",
                        "longitude": "-1.67481000"
                    },
                    {
                        "id": 48341,
                        "name": "Balcombe",
                        "latitude": "51.05726000",
                        "longitude": "-0.13450000"
                    },
                    {
                        "id": 48342,
                        "name": "Baldock",
                        "latitude": "51.98781000",
                        "longitude": "-0.18835000"
                    },
                    {
                        "id": 48362,
                        "name": "Balsall Common",
                        "latitude": "52.39186000",
                        "longitude": "-1.65040000"
                    },
                    {
                        "id": 48363,
                        "name": "Balsham",
                        "latitude": "52.13238000",
                        "longitude": "0.31586000"
                    },
                    {
                        "id": 48364,
                        "name": "Bamburgh",
                        "latitude": "55.60652000",
                        "longitude": "-1.71704000"
                    },
                    {
                        "id": 48365,
                        "name": "Bampton",
                        "latitude": "51.72634000",
                        "longitude": "-1.54547000"
                    },
                    {
                        "id": 48367,
                        "name": "Banbury",
                        "latitude": "52.06320000",
                        "longitude": "-1.34222000"
                    },
                    {
                        "id": 48372,
                        "name": "Banham",
                        "latitude": "52.45240000",
                        "longitude": "1.03683000"
                    },
                    {
                        "id": 48375,
                        "name": "Banks",
                        "latitude": "53.68333000",
                        "longitude": "-2.91667000"
                    },
                    {
                        "id": 48377,
                        "name": "Banstead",
                        "latitude": "51.32233000",
                        "longitude": "-0.20685000"
                    },
                    {
                        "id": 48378,
                        "name": "Banwell",
                        "latitude": "51.32894000",
                        "longitude": "-2.86914000"
                    },
                    {
                        "id": 48379,
                        "name": "Bar Hill",
                        "latitude": "52.24899000",
                        "longitude": "0.02883000"
                    },
                    {
                        "id": 48380,
                        "name": "Barbican",
                        "latitude": "51.51988000",
                        "longitude": "-0.09446000"
                    },
                    {
                        "id": 48381,
                        "name": "Bardney",
                        "latitude": "53.21005000",
                        "longitude": "-0.32371000"
                    },
                    {
                        "id": 48382,
                        "name": "Bardsey",
                        "latitude": "53.88492000",
                        "longitude": "-1.44539000"
                    },
                    {
                        "id": 48385,
                        "name": "Barham",
                        "latitude": "51.20570000",
                        "longitude": "1.15734000"
                    },
                    {
                        "id": 48386,
                        "name": "Barking",
                        "latitude": "51.53333000",
                        "longitude": "0.08333000"
                    },
                    {
                        "id": 48387,
                        "name": "Barkisland",
                        "latitude": "53.67614000",
                        "longitude": "-1.91840000"
                    },
                    {
                        "id": 48388,
                        "name": "Barlaston",
                        "latitude": "52.94200000",
                        "longitude": "-2.17050000"
                    },
                    {
                        "id": 48389,
                        "name": "Barlborough",
                        "latitude": "53.28795000",
                        "longitude": "-1.28815000"
                    },
                    {
                        "id": 48390,
                        "name": "Barlby",
                        "latitude": "53.79964000",
                        "longitude": "-1.04061000"
                    },
                    {
                        "id": 48391,
                        "name": "Barlestone",
                        "latitude": "52.64718000",
                        "longitude": "-1.37013000"
                    },
                    {
                        "id": 48392,
                        "name": "Barmby on the Marsh",
                        "latitude": "53.74896000",
                        "longitude": "-0.95607000"
                    },
                    {
                        "id": 48394,
                        "name": "Barnack",
                        "latitude": "52.63181000",
                        "longitude": "-0.40821000"
                    },
                    {
                        "id": 48395,
                        "name": "Barnard Castle",
                        "latitude": "54.54150000",
                        "longitude": "-1.91900000"
                    },
                    {
                        "id": 48396,
                        "name": "Barnburgh",
                        "latitude": "53.52408000",
                        "longitude": "-1.27300000"
                    },
                    {
                        "id": 48397,
                        "name": "Barnet",
                        "latitude": "51.65000000",
                        "longitude": "-0.20000000"
                    },
                    {
                        "id": 48398,
                        "name": "Barnetby le Wold",
                        "latitude": "53.57480000",
                        "longitude": "-0.40607000"
                    },
                    {
                        "id": 48399,
                        "name": "Barnham",
                        "latitude": "50.83120000",
                        "longitude": "-0.63789000"
                    },
                    {
                        "id": 48400,
                        "name": "Barnoldswick",
                        "latitude": "53.91711000",
                        "longitude": "-2.18705000"
                    },
                    {
                        "id": 48401,
                        "name": "Barnsbury",
                        "latitude": "51.54067000",
                        "longitude": "-0.11675000"
                    },
                    {
                        "id": 48402,
                        "name": "Barnsley",
                        "latitude": "53.53333000",
                        "longitude": "-1.50000000"
                    },
                    {
                        "id": 48403,
                        "name": "Barnstaple",
                        "latitude": "51.08022000",
                        "longitude": "-4.05808000"
                    },
                    {
                        "id": 48404,
                        "name": "Barnt Green",
                        "latitude": "52.35902000",
                        "longitude": "-2.00715000"
                    },
                    {
                        "id": 48405,
                        "name": "Barnwood",
                        "latitude": "51.86393000",
                        "longitude": "-2.20087000"
                    },
                    {
                        "id": 48408,
                        "name": "Barrow in Furness",
                        "latitude": "54.11094000",
                        "longitude": "-3.22758000"
                    },
                    {
                        "id": 48409,
                        "name": "Barrow upon Humber",
                        "latitude": "53.67550000",
                        "longitude": "-0.38062000"
                    },
                    {
                        "id": 48410,
                        "name": "Barrow upon Soar",
                        "latitude": "52.75178000",
                        "longitude": "-1.14601000"
                    },
                    {
                        "id": 48411,
                        "name": "Barrowby",
                        "latitude": "52.91636000",
                        "longitude": "-0.69094000"
                    },
                    {
                        "id": 48412,
                        "name": "Barrowford",
                        "latitude": "53.84650000",
                        "longitude": "-2.21838000"
                    },
                    {
                        "id": 48414,
                        "name": "Bartley Green",
                        "latitude": "52.43532000",
                        "longitude": "-1.99707000"
                    },
                    {
                        "id": 48415,
                        "name": "Barton under Needwood",
                        "latitude": "52.76268000",
                        "longitude": "-1.72400000"
                    },
                    {
                        "id": 48416,
                        "name": "Barton upon Humber",
                        "latitude": "53.68915000",
                        "longitude": "-0.44377000"
                    },
                    {
                        "id": 48417,
                        "name": "Barton-le-Clay",
                        "latitude": "51.96598000",
                        "longitude": "-0.42731000"
                    },
                    {
                        "id": 48418,
                        "name": "Baschurch",
                        "latitude": "52.78848000",
                        "longitude": "-2.85284000"
                    },
                    {
                        "id": 48419,
                        "name": "Basford",
                        "latitude": "52.96667000",
                        "longitude": "-1.18333000"
                    },
                    {
                        "id": 48420,
                        "name": "Basildon",
                        "latitude": "51.56844000",
                        "longitude": "0.45782000"
                    },
                    {
                        "id": 48421,
                        "name": "Basingstoke",
                        "latitude": "51.26249000",
                        "longitude": "-1.08708000"
                    },
                    {
                        "id": 48422,
                        "name": "Baslow",
                        "latitude": "53.24811000",
                        "longitude": "-1.62246000"
                    },
                    {
                        "id": 48423,
                        "name": "Bassingbourn",
                        "latitude": "52.07821000",
                        "longitude": "-0.05390000"
                    },
                    {
                        "id": 48424,
                        "name": "Bassingham",
                        "latitude": "53.12881000",
                        "longitude": "-0.63765000"
                    },
                    {
                        "id": 48425,
                        "name": "Baston",
                        "latitude": "52.71311000",
                        "longitude": "-0.35173000"
                    },
                    {
                        "id": 48426,
                        "name": "Bath",
                        "latitude": "51.37510000",
                        "longitude": "-2.36172000"
                    },
                    {
                        "id": 48427,
                        "name": "Bath and North East Somerset",
                        "latitude": "51.33333000",
                        "longitude": "-2.50000000"
                    },
                    {
                        "id": 48429,
                        "name": "Batley",
                        "latitude": "53.70291000",
                        "longitude": "-1.63370000"
                    },
                    {
                        "id": 48430,
                        "name": "Battersea",
                        "latitude": "51.47475000",
                        "longitude": "-0.15547000"
                    },
                    {
                        "id": 48431,
                        "name": "Battle",
                        "latitude": "50.91732000",
                        "longitude": "0.48417000"
                    },
                    {
                        "id": 48432,
                        "name": "Bawtry",
                        "latitude": "53.43146000",
                        "longitude": "-1.01878000"
                    },
                    {
                        "id": 48433,
                        "name": "Bay Horse",
                        "latitude": "53.96867000",
                        "longitude": "-2.77603000"
                    },
                    {
                        "id": 48434,
                        "name": "Bayston Hill",
                        "latitude": "52.67550000",
                        "longitude": "-2.76156000"
                    },
                    {
                        "id": 48435,
                        "name": "Bayswater",
                        "latitude": "51.51116000",
                        "longitude": "-0.18426000"
                    },
                    {
                        "id": 48436,
                        "name": "Beaconsfield",
                        "latitude": "51.61219000",
                        "longitude": "-0.64732000"
                    },
                    {
                        "id": 48437,
                        "name": "Beadnell",
                        "latitude": "55.55670000",
                        "longitude": "-1.63250000"
                    },
                    {
                        "id": 48438,
                        "name": "Beaminster",
                        "latitude": "50.80900000",
                        "longitude": "-2.73910000"
                    },
                    {
                        "id": 48442,
                        "name": "Bebington",
                        "latitude": "53.35000000",
                        "longitude": "-3.01667000"
                    },
                    {
                        "id": 48443,
                        "name": "Beccles",
                        "latitude": "52.45936000",
                        "longitude": "1.56465000"
                    },
                    {
                        "id": 48444,
                        "name": "Beckenham",
                        "latitude": "51.40878000",
                        "longitude": "-0.02526000"
                    },
                    {
                        "id": 48445,
                        "name": "Beckingham",
                        "latitude": "53.40000000",
                        "longitude": "-0.83333000"
                    },
                    {
                        "id": 48446,
                        "name": "Becontree",
                        "latitude": "51.55290000",
                        "longitude": "0.12900000"
                    },
                    {
                        "id": 48447,
                        "name": "Bedale",
                        "latitude": "54.28811000",
                        "longitude": "-1.59181000"
                    },
                    {
                        "id": 48449,
                        "name": "Bedford",
                        "latitude": "52.18831000",
                        "longitude": "-0.45316000"
                    },
                    {
                        "id": 48450,
                        "name": "Bedlington",
                        "latitude": "55.13061000",
                        "longitude": "-1.59319000"
                    },
                    {
                        "id": 48453,
                        "name": "Bedworth",
                        "latitude": "52.47910000",
                        "longitude": "-1.46909000"
                    },
                    {
                        "id": 48454,
                        "name": "Beeford",
                        "latitude": "53.96999000",
                        "longitude": "-0.28913000"
                    },
                    {
                        "id": 48455,
                        "name": "Beighton",
                        "latitude": "53.33333000",
                        "longitude": "-1.33333000"
                    },
                    {
                        "id": 48457,
                        "name": "Belbroughton",
                        "latitude": "52.39177000",
                        "longitude": "-2.11884000"
                    },
                    {
                        "id": 48459,
                        "name": "Belford",
                        "latitude": "55.60000000",
                        "longitude": "-1.83333000"
                    },
                    {
                        "id": 48461,
                        "name": "Bellingham",
                        "latitude": "55.14464000",
                        "longitude": "-2.25383000"
                    },
                    {
                        "id": 48464,
                        "name": "Belmont",
                        "latitude": "52.04272000",
                        "longitude": "-2.74169000"
                    },
                    {
                        "id": 48465,
                        "name": "Belper",
                        "latitude": "53.02330000",
                        "longitude": "-1.48119000"
                    },
                    {
                        "id": 48466,
                        "name": "Belsize Park",
                        "latitude": "51.54767000",
                        "longitude": "-0.17228000"
                    },
                    {
                        "id": 48467,
                        "name": "Belton",
                        "latitude": "53.55000000",
                        "longitude": "-0.81667000"
                    },
                    {
                        "id": 48468,
                        "name": "Belvedere",
                        "latitude": "51.49114000",
                        "longitude": "0.15136000"
                    },
                    {
                        "id": 48469,
                        "name": "Bembridge",
                        "latitude": "50.68634000",
                        "longitude": "-1.08275000"
                    },
                    {
                        "id": 48470,
                        "name": "Bempton",
                        "latitude": "54.13036000",
                        "longitude": "-0.17853000"
                    },
                    {
                        "id": 48473,
                        "name": "Benson",
                        "latitude": "51.62073000",
                        "longitude": "-1.10979000"
                    },
                    {
                        "id": 48474,
                        "name": "Bentley",
                        "latitude": "53.53333000",
                        "longitude": "-1.15000000"
                    },
                    {
                        "id": 48475,
                        "name": "Benwell",
                        "latitude": "54.97296000",
                        "longitude": "-1.66926000"
                    },
                    {
                        "id": 48476,
                        "name": "Bere Alston",
                        "latitude": "50.48233000",
                        "longitude": "-4.19034000"
                    },
                    {
                        "id": 48477,
                        "name": "Bere Regis",
                        "latitude": "50.75371000",
                        "longitude": "-2.21553000"
                    },
                    {
                        "id": 48478,
                        "name": "Berkeley",
                        "latitude": "51.69111000",
                        "longitude": "-2.45917000"
                    },
                    {
                        "id": 48479,
                        "name": "Berkhamsted",
                        "latitude": "51.76040000",
                        "longitude": "-0.56528000"
                    },
                    {
                        "id": 48480,
                        "name": "Berwick-Upon-Tweed",
                        "latitude": "55.76536000",
                        "longitude": "-2.01186000"
                    },
                    {
                        "id": 48482,
                        "name": "Bethnal Green",
                        "latitude": "51.52718000",
                        "longitude": "-0.06109000"
                    },
                    {
                        "id": 48483,
                        "name": "Betley",
                        "latitude": "53.03439000",
                        "longitude": "-2.36865000"
                    },
                    {
                        "id": 48486,
                        "name": "Beverley",
                        "latitude": "53.84587000",
                        "longitude": "-0.42332000"
                    },
                    {
                        "id": 48487,
                        "name": "Bewbush",
                        "latitude": "51.10329000",
                        "longitude": "-0.22312000"
                    },
                    {
                        "id": 48488,
                        "name": "Bewdley",
                        "latitude": "52.37570000",
                        "longitude": "-2.31833000"
                    },
                    {
                        "id": 48489,
                        "name": "Bexhill-on-Sea",
                        "latitude": "50.85023000",
                        "longitude": "0.47095000"
                    },
                    {
                        "id": 48490,
                        "name": "Bexley",
                        "latitude": "51.44162000",
                        "longitude": "0.14866000"
                    },
                    {
                        "id": 48491,
                        "name": "Bicester",
                        "latitude": "51.89998000",
                        "longitude": "-1.15357000"
                    },
                    {
                        "id": 48492,
                        "name": "Bicknacre",
                        "latitude": "51.69403000",
                        "longitude": "0.58519000"
                    },
                    {
                        "id": 48493,
                        "name": "Bicton",
                        "latitude": "52.72829000",
                        "longitude": "-2.81649000"
                    },
                    {
                        "id": 48494,
                        "name": "Biddenden",
                        "latitude": "51.11489000",
                        "longitude": "0.63819000"
                    },
                    {
                        "id": 48495,
                        "name": "Biddestone",
                        "latitude": "51.46083000",
                        "longitude": "-2.19833000"
                    },
                    {
                        "id": 48496,
                        "name": "Biddulph",
                        "latitude": "53.11724000",
                        "longitude": "-2.17584000"
                    },
                    {
                        "id": 48497,
                        "name": "Bideford",
                        "latitude": "51.01678000",
                        "longitude": "-4.20832000"
                    },
                    {
                        "id": 48498,
                        "name": "Bidford-on-Avon",
                        "latitude": "52.16964000",
                        "longitude": "-1.85955000"
                    },
                    {
                        "id": 48500,
                        "name": "Biggin Hill",
                        "latitude": "51.31329000",
                        "longitude": "0.03433000"
                    },
                    {
                        "id": 48501,
                        "name": "Biggleswade",
                        "latitude": "52.08652000",
                        "longitude": "-0.26493000"
                    },
                    {
                        "id": 48502,
                        "name": "Bildeston",
                        "latitude": "52.10658000",
                        "longitude": "0.90916000"
                    },
                    {
                        "id": 48503,
                        "name": "Billericay",
                        "latitude": "51.62867000",
                        "longitude": "0.41963000"
                    },
                    {
                        "id": 48504,
                        "name": "Billingborough",
                        "latitude": "52.89384000",
                        "longitude": "-0.34186000"
                    },
                    {
                        "id": 48505,
                        "name": "Billinge",
                        "latitude": "53.49795000",
                        "longitude": "-2.70810000"
                    },
                    {
                        "id": 48506,
                        "name": "Billingham",
                        "latitude": "54.58881000",
                        "longitude": "-1.29034000"
                    },
                    {
                        "id": 48507,
                        "name": "Billinghay",
                        "latitude": "53.07959000",
                        "longitude": "-0.27689000"
                    },
                    {
                        "id": 48508,
                        "name": "Billingshurst",
                        "latitude": "51.02312000",
                        "longitude": "-0.45359000"
                    },
                    {
                        "id": 48509,
                        "name": "Billington",
                        "latitude": "53.81570000",
                        "longitude": "-2.42360000"
                    },
                    {
                        "id": 48510,
                        "name": "Bilsdale",
                        "latitude": "54.37356000",
                        "longitude": "-1.11923000"
                    },
                    {
                        "id": 48511,
                        "name": "Bilsthorpe",
                        "latitude": "53.14024000",
                        "longitude": "-1.03392000"
                    },
                    {
                        "id": 48512,
                        "name": "Bilston",
                        "latitude": "52.56568000",
                        "longitude": "-2.07367000"
                    },
                    {
                        "id": 48514,
                        "name": "Bingham",
                        "latitude": "52.94978000",
                        "longitude": "-0.95907000"
                    },
                    {
                        "id": 48515,
                        "name": "Bingley",
                        "latitude": "53.84861000",
                        "longitude": "-1.83857000"
                    },
                    {
                        "id": 48516,
                        "name": "Birchington-on-Sea",
                        "latitude": "51.37575000",
                        "longitude": "1.30480000"
                    },
                    {
                        "id": 48517,
                        "name": "Bircotes",
                        "latitude": "53.41933000",
                        "longitude": "-1.04905000"
                    },
                    {
                        "id": 48518,
                        "name": "Birdham",
                        "latitude": "50.79606000",
                        "longitude": "-0.83067000"
                    },
                    {
                        "id": 48519,
                        "name": "Birdwell",
                        "latitude": "53.51398000",
                        "longitude": "-1.47929000"
                    },
                    {
                        "id": 48520,
                        "name": "Birkenhead",
                        "latitude": "53.39337000",
                        "longitude": "-3.01479000"
                    },
                    {
                        "id": 48521,
                        "name": "Birmingham",
                        "latitude": "52.48142000",
                        "longitude": "-1.89983000"
                    },
                    {
                        "id": 48522,
                        "name": "Bishop Auckland",
                        "latitude": "54.65554000",
                        "longitude": "-1.67706000"
                    },
                    {
                        "id": 48523,
                        "name": "Bishop Middleham",
                        "latitude": "54.67778000",
                        "longitude": "-1.48826000"
                    },
                    {
                        "id": 48524,
                        "name": "Bishop Sutton",
                        "latitude": "51.33444000",
                        "longitude": "-2.59472000"
                    },
                    {
                        "id": 48525,
                        "name": "Bishop's Castle",
                        "latitude": "52.49208000",
                        "longitude": "-3.00210000"
                    },
                    {
                        "id": 48527,
                        "name": "Bishops Cleeve",
                        "latitude": "51.94749000",
                        "longitude": "-2.06277000"
                    },
                    {
                        "id": 48528,
                        "name": "Bishops Lydeard",
                        "latitude": "51.05917000",
                        "longitude": "-3.18778000"
                    },
                    {
                        "id": 48529,
                        "name": "Bishops Stortford",
                        "latitude": "51.87113000",
                        "longitude": "0.15868000"
                    },
                    {
                        "id": 48530,
                        "name": "Bishops Waltham",
                        "latitude": "50.95595000",
                        "longitude": "-1.21476000"
                    },
                    {
                        "id": 48531,
                        "name": "Bishopsteignton",
                        "latitude": "50.55193000",
                        "longitude": "-3.53852000"
                    },
                    {
                        "id": 48532,
                        "name": "Bishopstoke",
                        "latitude": "50.96643000",
                        "longitude": "-1.32832000"
                    },
                    {
                        "id": 48534,
                        "name": "Bishopstone",
                        "latitude": "51.55130000",
                        "longitude": "-1.64701000"
                    },
                    {
                        "id": 48535,
                        "name": "Bishopsworth",
                        "latitude": "51.41479000",
                        "longitude": "-2.62080000"
                    },
                    {
                        "id": 48536,
                        "name": "Bishopthorpe",
                        "latitude": "53.91910000",
                        "longitude": "-1.09915000"
                    },
                    {
                        "id": 48538,
                        "name": "Bishopton",
                        "latitude": "54.58333000",
                        "longitude": "-1.43333000"
                    },
                    {
                        "id": 48539,
                        "name": "Bitton",
                        "latitude": "51.42479000",
                        "longitude": "-2.45965000"
                    },
                    {
                        "id": 48540,
                        "name": "Blaby",
                        "latitude": "52.57577000",
                        "longitude": "-1.16403000"
                    },
                    {
                        "id": 48541,
                        "name": "Black Notley",
                        "latitude": "51.85301000",
                        "longitude": "0.56846000"
                    },
                    {
                        "id": 48543,
                        "name": "Blackburn",
                        "latitude": "53.75000000",
                        "longitude": "-2.48333000"
                    },
                    {
                        "id": 48544,
                        "name": "Blackburn with Darwen",
                        "latitude": "53.66667000",
                        "longitude": "-2.46667000"
                    },
                    {
                        "id": 48545,
                        "name": "Blackheath",
                        "latitude": "51.46470000",
                        "longitude": "0.00790000"
                    },
                    {
                        "id": 48546,
                        "name": "Blackley",
                        "latitude": "53.51765000",
                        "longitude": "-2.21443000"
                    },
                    {
                        "id": 48547,
                        "name": "Blackmoorfoot",
                        "latitude": "53.61423000",
                        "longitude": "-1.85588000"
                    },
                    {
                        "id": 48548,
                        "name": "Blackpool",
                        "latitude": "53.81667000",
                        "longitude": "-3.05000000"
                    },
                    {
                        "id": 48550,
                        "name": "Blackrod",
                        "latitude": "53.59229000",
                        "longitude": "-2.58026000"
                    },
                    {
                        "id": 48551,
                        "name": "Blackwell",
                        "latitude": "53.11667000",
                        "longitude": "-1.33333000"
                    },
                    {
                        "id": 48554,
                        "name": "Blacon",
                        "latitude": "53.20832000",
                        "longitude": "-2.92530000"
                    },
                    {
                        "id": 48559,
                        "name": "Blagdon",
                        "latitude": "51.32688000",
                        "longitude": "-2.71731000"
                    },
                    {
                        "id": 48561,
                        "name": "Blandford Forum",
                        "latitude": "50.86073000",
                        "longitude": "-2.16174000"
                    },
                    {
                        "id": 48563,
                        "name": "Blaydon-on-Tyne",
                        "latitude": "54.96461000",
                        "longitude": "-1.71392000"
                    },
                    {
                        "id": 48564,
                        "name": "Bleadon",
                        "latitude": "51.30861000",
                        "longitude": "-2.94750000"
                    },
                    {
                        "id": 48565,
                        "name": "Blean",
                        "latitude": "51.30679000",
                        "longitude": "1.04301000"
                    },
                    {
                        "id": 48566,
                        "name": "Bletchingley",
                        "latitude": "51.24059000",
                        "longitude": "-0.10038000"
                    },
                    {
                        "id": 48567,
                        "name": "Bletchley",
                        "latitude": "51.99334000",
                        "longitude": "-0.73471000"
                    },
                    {
                        "id": 48568,
                        "name": "Blewbury",
                        "latitude": "51.56880000",
                        "longitude": "-1.23261000"
                    },
                    {
                        "id": 48569,
                        "name": "Blidworth",
                        "latitude": "53.09849000",
                        "longitude": "-1.11689000"
                    },
                    {
                        "id": 48570,
                        "name": "Blindley Heath",
                        "latitude": "51.19344000",
                        "longitude": "-0.05116000"
                    },
                    {
                        "id": 48571,
                        "name": "Blisworth",
                        "latitude": "52.17498000",
                        "longitude": "-0.94131000"
                    },
                    {
                        "id": 48572,
                        "name": "Blockley",
                        "latitude": "52.01220000",
                        "longitude": "-1.76268000"
                    },
                    {
                        "id": 48573,
                        "name": "Bloxham",
                        "latitude": "52.02039000",
                        "longitude": "-1.37321000"
                    },
                    {
                        "id": 48574,
                        "name": "Bloxwich",
                        "latitude": "52.61806000",
                        "longitude": "-2.00431000"
                    },
                    {
                        "id": 48575,
                        "name": "Blunham",
                        "latitude": "52.14695000",
                        "longitude": "-0.32178000"
                    },
                    {
                        "id": 48576,
                        "name": "Bluntisham",
                        "latitude": "52.35479000",
                        "longitude": "0.00854000"
                    },
                    {
                        "id": 48577,
                        "name": "Blyth",
                        "latitude": "55.12708000",
                        "longitude": "-1.50856000"
                    },
                    {
                        "id": 48578,
                        "name": "Blyton",
                        "latitude": "53.44384000",
                        "longitude": "-0.71753000"
                    },
                    {
                        "id": 48582,
                        "name": "Bodle Street",
                        "latitude": "50.91299000",
                        "longitude": "0.34332000"
                    },
                    {
                        "id": 48583,
                        "name": "Bodmin",
                        "latitude": "50.47151000",
                        "longitude": "-4.72430000"
                    },
                    {
                        "id": 48584,
                        "name": "Bognor Regis",
                        "latitude": "50.78206000",
                        "longitude": "-0.67978000"
                    },
                    {
                        "id": 48585,
                        "name": "Bollington",
                        "latitude": "53.29446000",
                        "longitude": "-2.10963000"
                    },
                    {
                        "id": 48586,
                        "name": "Bolsover",
                        "latitude": "53.22846000",
                        "longitude": "-1.29204000"
                    },
                    {
                        "id": 48587,
                        "name": "Bolton",
                        "latitude": "53.58333000",
                        "longitude": "-2.43333000"
                    },
                    {
                        "id": 48588,
                        "name": "Bolton le Sands",
                        "latitude": "54.09632000",
                        "longitude": "-2.80017000"
                    },
                    {
                        "id": 48589,
                        "name": "Bolton upon Dearne",
                        "latitude": "53.51667000",
                        "longitude": "-1.31667000"
                    },
                    {
                        "id": 48593,
                        "name": "Boosbeck",
                        "latitude": "54.54265000",
                        "longitude": "-0.98139000"
                    },
                    {
                        "id": 48594,
                        "name": "Bootle",
                        "latitude": "53.46667000",
                        "longitude": "-3.01667000"
                    },
                    {
                        "id": 48595,
                        "name": "Bordon",
                        "latitude": "51.11357000",
                        "longitude": "-0.86245000"
                    },
                    {
                        "id": 48596,
                        "name": "Boreham",
                        "latitude": "51.75955000",
                        "longitude": "0.54116000"
                    },
                    {
                        "id": 48597,
                        "name": "Borehamwood",
                        "latitude": "51.65468000",
                        "longitude": "-0.27762000"
                    },
                    {
                        "id": 48598,
                        "name": "Borough Green",
                        "latitude": "51.29158000",
                        "longitude": "0.30478000"
                    },
                    {
                        "id": 48599,
                        "name": "Borough of Bolton",
                        "latitude": "53.58333000",
                        "longitude": "-2.50000000"
                    },
                    {
                        "id": 48600,
                        "name": "Borough of Bury",
                        "latitude": "53.58333000",
                        "longitude": "-2.33333000"
                    },
                    {
                        "id": 48601,
                        "name": "Borough of Halton",
                        "latitude": "53.33333000",
                        "longitude": "-2.75000000"
                    },
                    {
                        "id": 48602,
                        "name": "Borough of North Tyneside",
                        "latitude": "55.03333000",
                        "longitude": "-1.50000000"
                    },
                    {
                        "id": 48603,
                        "name": "Borough of Oldham",
                        "latitude": "53.55000000",
                        "longitude": "-2.08333000"
                    },
                    {
                        "id": 48604,
                        "name": "Borough of Rochdale",
                        "latitude": "53.58333000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 48605,
                        "name": "Borough of Stockport",
                        "latitude": "53.41667000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 48606,
                        "name": "Borough of Swindon",
                        "latitude": "51.58333000",
                        "longitude": "-1.75000000"
                    },
                    {
                        "id": 48607,
                        "name": "Borough of Tameside",
                        "latitude": "53.50000000",
                        "longitude": "-2.08333000"
                    },
                    {
                        "id": 48608,
                        "name": "Borough of Thurrock",
                        "latitude": "51.50000000",
                        "longitude": "0.41667000"
                    },
                    {
                        "id": 48609,
                        "name": "Borough of Torbay",
                        "latitude": "50.45160000",
                        "longitude": "-3.55785000"
                    },
                    {
                        "id": 48610,
                        "name": "Borough of Wigan",
                        "latitude": "53.50000000",
                        "longitude": "-2.58333000"
                    },
                    {
                        "id": 48611,
                        "name": "Boroughbridge",
                        "latitude": "54.08950000",
                        "longitude": "-1.40110000"
                    },
                    {
                        "id": 48612,
                        "name": "Borrowash",
                        "latitude": "52.90673000",
                        "longitude": "-1.38411000"
                    },
                    {
                        "id": 48614,
                        "name": "Bosham",
                        "latitude": "50.83088000",
                        "longitude": "-0.85384000"
                    },
                    {
                        "id": 48615,
                        "name": "Boston",
                        "latitude": "52.97633000",
                        "longitude": "-0.02664000"
                    },
                    {
                        "id": 48616,
                        "name": "Boston Spa",
                        "latitude": "53.90419000",
                        "longitude": "-1.34523000"
                    },
                    {
                        "id": 48617,
                        "name": "Botesdale",
                        "latitude": "52.34216000",
                        "longitude": "1.00405000"
                    },
                    {
                        "id": 48619,
                        "name": "Botley",
                        "latitude": "50.91433000",
                        "longitude": "-1.26984000"
                    },
                    {
                        "id": 48620,
                        "name": "Bottesford",
                        "latitude": "52.94131000",
                        "longitude": "-0.80060000"
                    },
                    {
                        "id": 48621,
                        "name": "Bottisham",
                        "latitude": "52.22280000",
                        "longitude": "0.25878000"
                    },
                    {
                        "id": 48622,
                        "name": "Boughton",
                        "latitude": "53.20000000",
                        "longitude": "-0.98333000"
                    },
                    {
                        "id": 48623,
                        "name": "Bourne",
                        "latitude": "52.76667000",
                        "longitude": "-0.38333000"
                    },
                    {
                        "id": 48624,
                        "name": "Bourne End",
                        "latitude": "51.57622000",
                        "longitude": "-0.71291000"
                    },
                    {
                        "id": 48625,
                        "name": "Bournemouth",
                        "latitude": "50.71918000",
                        "longitude": "-1.87806000"
                    },
                    {
                        "id": 48626,
                        "name": "Bourton",
                        "latitude": "51.07444000",
                        "longitude": "-2.32778000"
                    },
                    {
                        "id": 48627,
                        "name": "Bourton on the Water",
                        "latitude": "51.88584000",
                        "longitude": "-1.75492000"
                    },
                    {
                        "id": 48628,
                        "name": "Bovey Tracey",
                        "latitude": "50.59259000",
                        "longitude": "-3.67543000"
                    },
                    {
                        "id": 48629,
                        "name": "Bovingdon",
                        "latitude": "51.72312000",
                        "longitude": "-0.53670000"
                    },
                    {
                        "id": 48630,
                        "name": "Bovington Camp",
                        "latitude": "50.69782000",
                        "longitude": "-2.23506000"
                    },
                    {
                        "id": 48631,
                        "name": "Bow",
                        "latitude": "50.80000000",
                        "longitude": "-3.81667000"
                    },
                    {
                        "id": 48632,
                        "name": "Bow Brickhill",
                        "latitude": "52.00280000",
                        "longitude": "-0.68064000"
                    },
                    {
                        "id": 48634,
                        "name": "Bowburn",
                        "latitude": "54.73850000",
                        "longitude": "-1.52521000"
                    },
                    {
                        "id": 48635,
                        "name": "Bowdon",
                        "latitude": "53.37644000",
                        "longitude": "-2.36532000"
                    },
                    {
                        "id": 48636,
                        "name": "Bowthorpe",
                        "latitude": "52.63884000",
                        "longitude": "1.21885000"
                    },
                    {
                        "id": 48637,
                        "name": "Box",
                        "latitude": "51.41472000",
                        "longitude": "-2.24556000"
                    },
                    {
                        "id": 48638,
                        "name": "Boxgrove",
                        "latitude": "50.85884000",
                        "longitude": "-0.71360000"
                    },
                    {
                        "id": 48639,
                        "name": "Boxted",
                        "latitude": "51.94878000",
                        "longitude": "0.91002000"
                    },
                    {
                        "id": 48640,
                        "name": "Bozeat",
                        "latitude": "52.22270000",
                        "longitude": "-0.67326000"
                    },
                    {
                        "id": 48642,
                        "name": "Bracebridge Heath",
                        "latitude": "53.19647000",
                        "longitude": "-0.53421000"
                    },
                    {
                        "id": 48643,
                        "name": "Brackley",
                        "latitude": "52.03333000",
                        "longitude": "-1.15000000"
                    },
                    {
                        "id": 48644,
                        "name": "Bracknell",
                        "latitude": "51.41363000",
                        "longitude": "-0.75054000"
                    },
                    {
                        "id": 48645,
                        "name": "Bracknell Forest",
                        "latitude": "51.41667000",
                        "longitude": "-0.75000000"
                    },
                    {
                        "id": 48646,
                        "name": "Bradfield",
                        "latitude": "51.44914000",
                        "longitude": "-1.13082000"
                    },
                    {
                        "id": 48647,
                        "name": "Bradford",
                        "latitude": "53.83333000",
                        "longitude": "-1.83333000"
                    },
                    {
                        "id": 48648,
                        "name": "Bradford-on-Avon",
                        "latitude": "51.34772000",
                        "longitude": "-2.25065000"
                    },
                    {
                        "id": 48649,
                        "name": "Brading",
                        "latitude": "50.67990000",
                        "longitude": "-1.14571000"
                    },
                    {
                        "id": 48650,
                        "name": "Bradley Cross",
                        "latitude": "51.27488000",
                        "longitude": "-2.76256000"
                    },
                    {
                        "id": 48651,
                        "name": "Bradninch",
                        "latitude": "50.82491000",
                        "longitude": "-3.42465000"
                    },
                    {
                        "id": 48652,
                        "name": "Bradwell",
                        "latitude": "52.57353000",
                        "longitude": "1.69979000"
                    },
                    {
                        "id": 48653,
                        "name": "Braintree",
                        "latitude": "51.87819000",
                        "longitude": "0.55292000"
                    },
                    {
                        "id": 48654,
                        "name": "Bramford",
                        "latitude": "52.07631000",
                        "longitude": "1.09687000"
                    },
                    {
                        "id": 48655,
                        "name": "Bramhall",
                        "latitude": "53.35801000",
                        "longitude": "-2.16539000"
                    },
                    {
                        "id": 48656,
                        "name": "Bramham",
                        "latitude": "53.88118000",
                        "longitude": "-1.35452000"
                    },
                    {
                        "id": 48657,
                        "name": "Bramhope",
                        "latitude": "53.88489000",
                        "longitude": "-1.61641000"
                    },
                    {
                        "id": 48658,
                        "name": "Bramley",
                        "latitude": "51.32677000",
                        "longitude": "-1.05938000"
                    },
                    {
                        "id": 48659,
                        "name": "Brampton",
                        "latitude": "52.32039000",
                        "longitude": "-0.22007000"
                    },
                    {
                        "id": 48660,
                        "name": "Brandesburton",
                        "latitude": "53.91110000",
                        "longitude": "-0.30122000"
                    },
                    {
                        "id": 48661,
                        "name": "Brandon",
                        "latitude": "54.75000000",
                        "longitude": "-1.61667000"
                    },
                    {
                        "id": 48662,
                        "name": "Bransgore",
                        "latitude": "50.78153000",
                        "longitude": "-1.73771000"
                    },
                    {
                        "id": 48663,
                        "name": "Branston",
                        "latitude": "53.19544000",
                        "longitude": "-0.47482000"
                    },
                    {
                        "id": 48664,
                        "name": "Bratton",
                        "latitude": "51.27056000",
                        "longitude": "-2.12444000"
                    },
                    {
                        "id": 48665,
                        "name": "Braunston",
                        "latitude": "52.28979000",
                        "longitude": "-1.20266000"
                    },
                    {
                        "id": 48666,
                        "name": "Braunton",
                        "latitude": "51.10847000",
                        "longitude": "-4.16131000"
                    },
                    {
                        "id": 48667,
                        "name": "Brayton",
                        "latitude": "53.76510000",
                        "longitude": "-1.08921000"
                    },
                    {
                        "id": 48668,
                        "name": "Bream",
                        "latitude": "51.74822000",
                        "longitude": "-2.57747000"
                    },
                    {
                        "id": 48671,
                        "name": "Bredbury",
                        "latitude": "53.41667000",
                        "longitude": "-2.11667000"
                    },
                    {
                        "id": 48672,
                        "name": "Bredon",
                        "latitude": "52.03008000",
                        "longitude": "-2.11671000"
                    },
                    {
                        "id": 48673,
                        "name": "Brenchley",
                        "latitude": "51.15141000",
                        "longitude": "0.39825000"
                    },
                    {
                        "id": 48674,
                        "name": "Brent",
                        "latitude": "51.55306000",
                        "longitude": "-0.30230000"
                    },
                    {
                        "id": 48675,
                        "name": "Brent Knoll",
                        "latitude": "51.25219000",
                        "longitude": "-2.95744000"
                    },
                    {
                        "id": 48676,
                        "name": "Brentford",
                        "latitude": "51.48619000",
                        "longitude": "-0.30830000"
                    },
                    {
                        "id": 48677,
                        "name": "Brentwood",
                        "latitude": "51.62127000",
                        "longitude": "0.30556000"
                    },
                    {
                        "id": 48678,
                        "name": "Brewood",
                        "latitude": "52.67712000",
                        "longitude": "-2.17414000"
                    },
                    {
                        "id": 48679,
                        "name": "Bridge",
                        "latitude": "51.24513000",
                        "longitude": "1.12640000"
                    },
                    {
                        "id": 48685,
                        "name": "Bridgnorth",
                        "latitude": "52.53661000",
                        "longitude": "-2.42033000"
                    },
                    {
                        "id": 48686,
                        "name": "Bridgwater",
                        "latitude": "51.12837000",
                        "longitude": "-3.00356000"
                    },
                    {
                        "id": 48687,
                        "name": "Bridlington",
                        "latitude": "54.08306000",
                        "longitude": "-0.19192000"
                    },
                    {
                        "id": 48688,
                        "name": "Bridport",
                        "latitude": "50.73380000",
                        "longitude": "-2.75831000"
                    },
                    {
                        "id": 48689,
                        "name": "Brierfield",
                        "latitude": "53.82468000",
                        "longitude": "-2.23415000"
                    },
                    {
                        "id": 48690,
                        "name": "Brierley Hill",
                        "latitude": "52.48173000",
                        "longitude": "-2.12139000"
                    },
                    {
                        "id": 48691,
                        "name": "Brigg",
                        "latitude": "53.55201000",
                        "longitude": "-0.49214000"
                    },
                    {
                        "id": 48692,
                        "name": "Brighouse",
                        "latitude": "53.70322000",
                        "longitude": "-1.78428000"
                    },
                    {
                        "id": 48693,
                        "name": "Brighstone",
                        "latitude": "50.64263000",
                        "longitude": "-1.39479000"
                    },
                    {
                        "id": 48694,
                        "name": "Brightlingsea",
                        "latitude": "51.81164000",
                        "longitude": "1.02336000"
                    },
                    {
                        "id": 48695,
                        "name": "Brighton",
                        "latitude": "50.82838000",
                        "longitude": "-0.13947000"
                    },
                    {
                        "id": 48696,
                        "name": "Brighton and Hove",
                        "latitude": "50.83333000",
                        "longitude": "-0.13333000"
                    },
                    {
                        "id": 48698,
                        "name": "Brigstock",
                        "latitude": "52.45775000",
                        "longitude": "-0.60834000"
                    },
                    {
                        "id": 48699,
                        "name": "Brill",
                        "latitude": "51.81667000",
                        "longitude": "-1.05000000"
                    },
                    {
                        "id": 48700,
                        "name": "Brimscombe",
                        "latitude": "51.71973000",
                        "longitude": "-2.18553000"
                    },
                    {
                        "id": 48701,
                        "name": "Brinklow",
                        "latitude": "52.41091000",
                        "longitude": "-1.36400000"
                    },
                    {
                        "id": 48702,
                        "name": "Brinscall",
                        "latitude": "53.68900000",
                        "longitude": "-2.57208000"
                    },
                    {
                        "id": 48703,
                        "name": "Bristol",
                        "latitude": "51.45523000",
                        "longitude": "-2.59665000"
                    },
                    {
                        "id": 48704,
                        "name": "Briston",
                        "latitude": "52.85369000",
                        "longitude": "1.05899000"
                    },
                    {
                        "id": 48706,
                        "name": "Brixham",
                        "latitude": "50.39431000",
                        "longitude": "-3.51585000"
                    },
                    {
                        "id": 48707,
                        "name": "Brixton",
                        "latitude": "51.46593000",
                        "longitude": "-0.10652000"
                    },
                    {
                        "id": 48708,
                        "name": "Brixton Hill",
                        "latitude": "51.45213000",
                        "longitude": "-0.12300000"
                    },
                    {
                        "id": 48709,
                        "name": "Brixworth",
                        "latitude": "52.32912000",
                        "longitude": "-0.90350000"
                    },
                    {
                        "id": 48710,
                        "name": "Broad Blunsdon",
                        "latitude": "51.61339000",
                        "longitude": "-1.77870000"
                    },
                    {
                        "id": 48711,
                        "name": "Broadfield",
                        "latitude": "51.09714000",
                        "longitude": "-0.20664000"
                    },
                    {
                        "id": 48712,
                        "name": "Broadstairs",
                        "latitude": "51.35908000",
                        "longitude": "1.43938000"
                    },
                    {
                        "id": 48713,
                        "name": "Broadstone",
                        "latitude": "50.75717000",
                        "longitude": "-1.99406000"
                    },
                    {
                        "id": 48714,
                        "name": "Broadwater",
                        "latitude": "50.82887000",
                        "longitude": "-0.37594000"
                    },
                    {
                        "id": 48715,
                        "name": "Broadway",
                        "latitude": "52.03825000",
                        "longitude": "-1.86079000"
                    },
                    {
                        "id": 48716,
                        "name": "Brockenhurst",
                        "latitude": "50.81936000",
                        "longitude": "-1.57303000"
                    },
                    {
                        "id": 48717,
                        "name": "Brockley",
                        "latitude": "51.40000000",
                        "longitude": "-2.76667000"
                    },
                    {
                        "id": 48718,
                        "name": "Bromborough",
                        "latitude": "53.34850000",
                        "longitude": "-2.97935000"
                    },
                    {
                        "id": 48719,
                        "name": "Bromham",
                        "latitude": "52.14508000",
                        "longitude": "-0.52906000"
                    },
                    {
                        "id": 48720,
                        "name": "Brompton",
                        "latitude": "54.36015000",
                        "longitude": "-1.42422000"
                    },
                    {
                        "id": 48721,
                        "name": "Bromsgrove",
                        "latitude": "52.33574000",
                        "longitude": "-2.05983000"
                    },
                    {
                        "id": 48722,
                        "name": "Bromyard",
                        "latitude": "52.19019000",
                        "longitude": "-2.50875000"
                    },
                    {
                        "id": 48723,
                        "name": "Brooke",
                        "latitude": "52.54175000",
                        "longitude": "1.37076000"
                    },
                    {
                        "id": 48725,
                        "name": "Broseley",
                        "latitude": "52.61321000",
                        "longitude": "-2.48269000"
                    },
                    {
                        "id": 48726,
                        "name": "Brotton",
                        "latitude": "54.56661000",
                        "longitude": "-0.93929000"
                    },
                    {
                        "id": 48727,
                        "name": "Brough",
                        "latitude": "53.72861000",
                        "longitude": "-0.57215000"
                    },
                    {
                        "id": 48729,
                        "name": "Broughton",
                        "latitude": "53.56667000",
                        "longitude": "-0.55000000"
                    },
                    {
                        "id": 48731,
                        "name": "Broughton Astley",
                        "latitude": "52.52787000",
                        "longitude": "-1.21768000"
                    },
                    {
                        "id": 48732,
                        "name": "Brownhills",
                        "latitude": "52.63333000",
                        "longitude": "-1.93333000"
                    },
                    {
                        "id": 48733,
                        "name": "Broxbourne",
                        "latitude": "51.74712000",
                        "longitude": "-0.01923000"
                    },
                    {
                        "id": 48735,
                        "name": "Brundall",
                        "latitude": "52.62426000",
                        "longitude": "1.43509000"
                    },
                    {
                        "id": 48736,
                        "name": "Bruton",
                        "latitude": "51.11250000",
                        "longitude": "-2.45278000"
                    },
                    {
                        "id": 48742,
                        "name": "Bubwith",
                        "latitude": "53.81905000",
                        "longitude": "-0.91968000"
                    },
                    {
                        "id": 48743,
                        "name": "Buckden",
                        "latitude": "52.29415000",
                        "longitude": "-0.24912000"
                    },
                    {
                        "id": 48744,
                        "name": "Buckfastleigh",
                        "latitude": "50.48132000",
                        "longitude": "-3.77913000"
                    },
                    {
                        "id": 48746,
                        "name": "Buckhurst Hill",
                        "latitude": "51.62409000",
                        "longitude": "0.03262000"
                    },
                    {
                        "id": 48748,
                        "name": "Buckingham",
                        "latitude": "51.99968000",
                        "longitude": "-0.98779000"
                    },
                    {
                        "id": 48749,
                        "name": "Buckinghamshire",
                        "latitude": "51.75000000",
                        "longitude": "-0.75000000"
                    },
                    {
                        "id": 48751,
                        "name": "Bucknell",
                        "latitude": "52.35997000",
                        "longitude": "-2.95066000"
                    },
                    {
                        "id": 48752,
                        "name": "Bude",
                        "latitude": "50.82435000",
                        "longitude": "-4.54130000"
                    },
                    {
                        "id": 48753,
                        "name": "Budleigh Salterton",
                        "latitude": "50.62983000",
                        "longitude": "-3.32181000"
                    },
                    {
                        "id": 48754,
                        "name": "Bugbrooke",
                        "latitude": "52.21006000",
                        "longitude": "-1.01304000"
                    },
                    {
                        "id": 48755,
                        "name": "Bugle",
                        "latitude": "50.39577000",
                        "longitude": "-4.79334000"
                    },
                    {
                        "id": 48757,
                        "name": "Bulford",
                        "latitude": "51.18930000",
                        "longitude": "-1.76009000"
                    },
                    {
                        "id": 48758,
                        "name": "Bulkington",
                        "latitude": "51.32361000",
                        "longitude": "-2.08361000"
                    },
                    {
                        "id": 48759,
                        "name": "Bulphan",
                        "latitude": "51.54612000",
                        "longitude": "0.36066000"
                    },
                    {
                        "id": 48760,
                        "name": "Bunbury",
                        "latitude": "53.11559000",
                        "longitude": "-2.65151000"
                    },
                    {
                        "id": 48761,
                        "name": "Bungay",
                        "latitude": "52.45434000",
                        "longitude": "1.43818000"
                    },
                    {
                        "id": 48762,
                        "name": "Buntingford",
                        "latitude": "51.94612000",
                        "longitude": "-0.01841000"
                    },
                    {
                        "id": 48763,
                        "name": "Burbage",
                        "latitude": "51.35184000",
                        "longitude": "-1.67087000"
                    },
                    {
                        "id": 48764,
                        "name": "Bures Saint Mary",
                        "latitude": "51.97240000",
                        "longitude": "0.77488000"
                    },
                    {
                        "id": 48765,
                        "name": "Burford",
                        "latitude": "51.80915000",
                        "longitude": "-1.63628000"
                    },
                    {
                        "id": 48766,
                        "name": "Burgess Hill",
                        "latitude": "50.95843000",
                        "longitude": "-0.13287000"
                    },
                    {
                        "id": 48767,
                        "name": "Burgh le Marsh",
                        "latitude": "53.16158000",
                        "longitude": "0.24484000"
                    },
                    {
                        "id": 48769,
                        "name": "Burham",
                        "latitude": "51.33243000",
                        "longitude": "0.47833000"
                    },
                    {
                        "id": 48770,
                        "name": "Burley",
                        "latitude": "50.82800000",
                        "longitude": "-1.69977000"
                    },
                    {
                        "id": 48771,
                        "name": "Burley in Wharfedale",
                        "latitude": "53.91020000",
                        "longitude": "-1.75798000"
                    },
                    {
                        "id": 48772,
                        "name": "Burnage",
                        "latitude": "53.43265000",
                        "longitude": "-2.19967000"
                    },
                    {
                        "id": 48773,
                        "name": "Burneside",
                        "latitude": "54.35271000",
                        "longitude": "-2.76151000"
                    },
                    {
                        "id": 48774,
                        "name": "Burngreave",
                        "latitude": "53.39302000",
                        "longitude": "-1.45789000"
                    },
                    {
                        "id": 48775,
                        "name": "Burnham-on-Crouch",
                        "latitude": "51.63272000",
                        "longitude": "0.81488000"
                    },
                    {
                        "id": 48776,
                        "name": "Burnham-on-Sea",
                        "latitude": "51.23862000",
                        "longitude": "-2.99780000"
                    },
                    {
                        "id": 48777,
                        "name": "Burniston",
                        "latitude": "54.32385000",
                        "longitude": "-0.44813000"
                    },
                    {
                        "id": 48778,
                        "name": "Burnley",
                        "latitude": "53.80000000",
                        "longitude": "-2.23333000"
                    },
                    {
                        "id": 48779,
                        "name": "Burnopfield",
                        "latitude": "54.90624000",
                        "longitude": "-1.72486000"
                    },
                    {
                        "id": 48781,
                        "name": "Burntwood",
                        "latitude": "52.68075000",
                        "longitude": "-1.92759000"
                    },
                    {
                        "id": 48782,
                        "name": "Burringham",
                        "latitude": "53.57402000",
                        "longitude": "-0.73957000"
                    },
                    {
                        "id": 48783,
                        "name": "Burrington",
                        "latitude": "51.32884000",
                        "longitude": "-2.74868000"
                    },
                    {
                        "id": 48785,
                        "name": "Burscough",
                        "latitude": "53.59640000",
                        "longitude": "-2.83972000"
                    },
                    {
                        "id": 48786,
                        "name": "Bursledon",
                        "latitude": "50.88658000",
                        "longitude": "-1.31596000"
                    },
                    {
                        "id": 48787,
                        "name": "Burstwick",
                        "latitude": "53.73211000",
                        "longitude": "-0.13956000"
                    },
                    {
                        "id": 48788,
                        "name": "Burton",
                        "latitude": "53.26667000",
                        "longitude": "-0.56667000"
                    },
                    {
                        "id": 48789,
                        "name": "Burton Joyce",
                        "latitude": "52.98825000",
                        "longitude": "-1.03407000"
                    },
                    {
                        "id": 48790,
                        "name": "Burton Latimer",
                        "latitude": "52.36368000",
                        "longitude": "-0.67853000"
                    },
                    {
                        "id": 48792,
                        "name": "Burton on the Wolds",
                        "latitude": "52.78574000",
                        "longitude": "-1.12988000"
                    },
                    {
                        "id": 48791,
                        "name": "Burton Pidsea",
                        "latitude": "53.76327000",
                        "longitude": "-0.10703000"
                    },
                    {
                        "id": 48793,
                        "name": "Burton upon Stather",
                        "latitude": "53.64911000",
                        "longitude": "-0.68453000"
                    },
                    {
                        "id": 48794,
                        "name": "Burton upon Trent",
                        "latitude": "52.80728000",
                        "longitude": "-1.64263000"
                    },
                    {
                        "id": 48795,
                        "name": "Burtonwood",
                        "latitude": "53.42948000",
                        "longitude": "-2.65852000"
                    },
                    {
                        "id": 48796,
                        "name": "Burwash",
                        "latitude": "50.99755000",
                        "longitude": "0.38504000"
                    },
                    {
                        "id": 48797,
                        "name": "Burwell",
                        "latitude": "52.27632000",
                        "longitude": "0.32732000"
                    },
                    {
                        "id": 48798,
                        "name": "Bury",
                        "latitude": "53.60000000",
                        "longitude": "-2.30000000"
                    },
                    {
                        "id": 48799,
                        "name": "Bury St Edmunds",
                        "latitude": "52.24630000",
                        "longitude": "0.71111000"
                    },
                    {
                        "id": 48801,
                        "name": "Bushey",
                        "latitude": "51.64316000",
                        "longitude": "-0.36053000"
                    },
                    {
                        "id": 48803,
                        "name": "Butterwick",
                        "latitude": "52.98333000",
                        "longitude": "0.06667000"
                    },
                    {
                        "id": 48804,
                        "name": "Buxted",
                        "latitude": "50.99003000",
                        "longitude": "0.13441000"
                    },
                    {
                        "id": 48805,
                        "name": "Buxton",
                        "latitude": "53.25741000",
                        "longitude": "-1.90982000"
                    },
                    {
                        "id": 48806,
                        "name": "Byfield",
                        "latitude": "52.17546000",
                        "longitude": "-1.24566000"
                    },
                    {
                        "id": 48807,
                        "name": "Byram",
                        "latitude": "53.72394000",
                        "longitude": "-1.26128000"
                    },
                    {
                        "id": 48808,
                        "name": "Caddington",
                        "latitude": "51.86621000",
                        "longitude": "-0.45679000"
                    },
                    {
                        "id": 48809,
                        "name": "Cadnam",
                        "latitude": "50.92047000",
                        "longitude": "-1.57970000"
                    },
                    {
                        "id": 48818,
                        "name": "Caister-on-Sea",
                        "latitude": "52.64809000",
                        "longitude": "1.72648000"
                    },
                    {
                        "id": 48819,
                        "name": "Caistor",
                        "latitude": "53.49673000",
                        "longitude": "-0.31538000"
                    },
                    {
                        "id": 48820,
                        "name": "Calcot",
                        "latitude": "51.44058000",
                        "longitude": "-1.05091000"
                    },
                    {
                        "id": 48823,
                        "name": "Calderdale",
                        "latitude": "53.70000000",
                        "longitude": "-2.00000000"
                    },
                    {
                        "id": 48826,
                        "name": "Callington",
                        "latitude": "50.50147000",
                        "longitude": "-4.31314000"
                    },
                    {
                        "id": 48827,
                        "name": "Calne",
                        "latitude": "51.43879000",
                        "longitude": "-2.00571000"
                    },
                    {
                        "id": 48828,
                        "name": "Calverton",
                        "latitude": "53.03728000",
                        "longitude": "-1.08263000"
                    },
                    {
                        "id": 48829,
                        "name": "Camber",
                        "latitude": "50.93473000",
                        "longitude": "0.79848000"
                    },
                    {
                        "id": 48830,
                        "name": "Camberley",
                        "latitude": "51.33705000",
                        "longitude": "-0.74261000"
                    },
                    {
                        "id": 48831,
                        "name": "Camblesforth",
                        "latitude": "53.72680000",
                        "longitude": "-1.01998000"
                    },
                    {
                        "id": 48832,
                        "name": "Camborne",
                        "latitude": "50.21306000",
                        "longitude": "-5.29731000"
                    },
                    {
                        "id": 48833,
                        "name": "Cambourne",
                        "latitude": "52.22115000",
                        "longitude": "-0.07025000"
                    },
                    {
                        "id": 48834,
                        "name": "Cambridge",
                        "latitude": "52.20000000",
                        "longitude": "0.11667000"
                    },
                    {
                        "id": 48835,
                        "name": "Cambridgeshire",
                        "latitude": "52.33333000",
                        "longitude": "0.08333000"
                    },
                    {
                        "id": 48837,
                        "name": "Camden Town",
                        "latitude": "51.54057000",
                        "longitude": "-0.14334000"
                    },
                    {
                        "id": 48838,
                        "name": "Cameley",
                        "latitude": "51.31616000",
                        "longitude": "-2.56079000"
                    },
                    {
                        "id": 48839,
                        "name": "Camelford",
                        "latitude": "50.62185000",
                        "longitude": "-4.67963000"
                    },
                    {
                        "id": 48841,
                        "name": "Campsall",
                        "latitude": "53.61917000",
                        "longitude": "-1.18002000"
                    },
                    {
                        "id": 48842,
                        "name": "Canary Wharf",
                        "latitude": "51.50519000",
                        "longitude": "-0.02085000"
                    },
                    {
                        "id": 48843,
                        "name": "Canewdon",
                        "latitude": "51.61759000",
                        "longitude": "0.74458000"
                    },
                    {
                        "id": 48844,
                        "name": "Canford Heath",
                        "latitude": "50.75100000",
                        "longitude": "-1.96862000"
                    },
                    {
                        "id": 48845,
                        "name": "Cannock",
                        "latitude": "52.69045000",
                        "longitude": "-2.03085000"
                    },
                    {
                        "id": 48846,
                        "name": "Canterbury",
                        "latitude": "51.27904000",
                        "longitude": "1.07992000"
                    },
                    {
                        "id": 48847,
                        "name": "Canvey Island",
                        "latitude": "51.52199000",
                        "longitude": "0.58090000"
                    },
                    {
                        "id": 48849,
                        "name": "Capel",
                        "latitude": "51.14942000",
                        "longitude": "-0.32375000"
                    },
                    {
                        "id": 48851,
                        "name": "Capel le Ferne",
                        "latitude": "51.10339000",
                        "longitude": "1.21165000"
                    },
                    {
                        "id": 48850,
                        "name": "Capel Saint Mary",
                        "latitude": "52.00369000",
                        "longitude": "1.04482000"
                    },
                    {
                        "id": 48852,
                        "name": "Carcroft",
                        "latitude": "53.58282000",
                        "longitude": "-1.17648000"
                    },
                    {
                        "id": 48856,
                        "name": "Cardington",
                        "latitude": "52.11742000",
                        "longitude": "-0.41289000"
                    },
                    {
                        "id": 48859,
                        "name": "Carlisle",
                        "latitude": "54.89510000",
                        "longitude": "-2.93820000"
                    },
                    {
                        "id": 48860,
                        "name": "Carlton",
                        "latitude": "54.59004000",
                        "longitude": "-1.39117000"
                    },
                    {
                        "id": 48865,
                        "name": "Carnforth",
                        "latitude": "54.13163000",
                        "longitude": "-2.76914000"
                    },
                    {
                        "id": 48874,
                        "name": "Carshalton",
                        "latitude": "51.36829000",
                        "longitude": "-0.16755000"
                    },
                    {
                        "id": 48875,
                        "name": "Carterton",
                        "latitude": "51.75905000",
                        "longitude": "-1.59435000"
                    },
                    {
                        "id": 48876,
                        "name": "Castle Cary",
                        "latitude": "51.09000000",
                        "longitude": "-2.51417000"
                    },
                    {
                        "id": 48877,
                        "name": "Castle Donington",
                        "latitude": "52.84291000",
                        "longitude": "-1.34188000"
                    },
                    {
                        "id": 48879,
                        "name": "Castle Hedingham",
                        "latitude": "51.99015000",
                        "longitude": "0.59882000"
                    },
                    {
                        "id": 48880,
                        "name": "Castle Vale",
                        "latitude": "52.51879000",
                        "longitude": "-1.79683000"
                    },
                    {
                        "id": 48883,
                        "name": "Castleford",
                        "latitude": "53.72587000",
                        "longitude": "-1.36256000"
                    },
                    {
                        "id": 48886,
                        "name": "Castleside",
                        "latitude": "54.83429000",
                        "longitude": "-1.87849000"
                    },
                    {
                        "id": 48888,
                        "name": "Castor",
                        "latitude": "52.57319000",
                        "longitude": "-0.34603000"
                    },
                    {
                        "id": 48889,
                        "name": "Catcliffe",
                        "latitude": "53.39316000",
                        "longitude": "-1.36207000"
                    },
                    {
                        "id": 48890,
                        "name": "Caterham",
                        "latitude": "51.28230000",
                        "longitude": "-0.07889000"
                    },
                    {
                        "id": 48891,
                        "name": "Caton",
                        "latitude": "54.07624000",
                        "longitude": "-2.71903000"
                    },
                    {
                        "id": 48893,
                        "name": "Catterall",
                        "latitude": "53.87965000",
                        "longitude": "-2.76478000"
                    },
                    {
                        "id": 48894,
                        "name": "Catterick",
                        "latitude": "54.37542000",
                        "longitude": "-1.63328000"
                    },
                    {
                        "id": 48895,
                        "name": "Catterick Garrison",
                        "latitude": "54.37748000",
                        "longitude": "-1.72232000"
                    },
                    {
                        "id": 48897,
                        "name": "Cawood",
                        "latitude": "53.83303000",
                        "longitude": "-1.12962000"
                    },
                    {
                        "id": 48898,
                        "name": "Cawston",
                        "latitude": "52.76667000",
                        "longitude": "1.16667000"
                    },
                    {
                        "id": 48899,
                        "name": "Cawthorne",
                        "latitude": "53.56687000",
                        "longitude": "-1.57259000"
                    },
                    {
                        "id": 48900,
                        "name": "Caythorpe",
                        "latitude": "53.01667000",
                        "longitude": "-0.60000000"
                    },
                    {
                        "id": 48903,
                        "name": "Central Bedfordshire",
                        "latitude": "51.99755000",
                        "longitude": "-0.42148000"
                    },
                    {
                        "id": 48904,
                        "name": "Chacewater",
                        "latitude": "50.25675000",
                        "longitude": "-5.15757000"
                    },
                    {
                        "id": 48905,
                        "name": "Chadwell Heath",
                        "latitude": "51.57121000",
                        "longitude": "0.13271000"
                    },
                    {
                        "id": 48906,
                        "name": "Chadwell St Mary",
                        "latitude": "51.48140000",
                        "longitude": "0.36343000"
                    },
                    {
                        "id": 48907,
                        "name": "Chafford Hundred",
                        "latitude": "51.48920000",
                        "longitude": "0.29440000"
                    },
                    {
                        "id": 48908,
                        "name": "Chagford",
                        "latitude": "50.67504000",
                        "longitude": "-3.83936000"
                    },
                    {
                        "id": 48909,
                        "name": "Chalfont Saint Peter",
                        "latitude": "51.60885000",
                        "longitude": "-0.55618000"
                    },
                    {
                        "id": 48910,
                        "name": "Chalfont St Giles",
                        "latitude": "51.63184000",
                        "longitude": "-0.57026000"
                    },
                    {
                        "id": 48911,
                        "name": "Chalford",
                        "latitude": "51.72583000",
                        "longitude": "-2.15139000"
                    },
                    {
                        "id": 48912,
                        "name": "Chalgrove",
                        "latitude": "51.66476000",
                        "longitude": "-1.07640000"
                    },
                    {
                        "id": 48913,
                        "name": "Chalton",
                        "latitude": "51.92790000",
                        "longitude": "-0.50147000"
                    },
                    {
                        "id": 48914,
                        "name": "Chapel Allerton",
                        "latitude": "53.82901000",
                        "longitude": "-1.53834000"
                    },
                    {
                        "id": 48916,
                        "name": "Chapel en le Frith",
                        "latitude": "53.32407000",
                        "longitude": "-1.91291000"
                    },
                    {
                        "id": 48915,
                        "name": "Chapel Saint Leonards",
                        "latitude": "53.21667000",
                        "longitude": "0.31667000"
                    },
                    {
                        "id": 48918,
                        "name": "Chapeltown",
                        "latitude": "53.46506000",
                        "longitude": "-1.47217000"
                    },
                    {
                        "id": 48919,
                        "name": "Chapmanslade",
                        "latitude": "51.22917000",
                        "longitude": "-2.24889000"
                    },
                    {
                        "id": 48920,
                        "name": "Chard",
                        "latitude": "50.87270000",
                        "longitude": "-2.96597000"
                    },
                    {
                        "id": 48921,
                        "name": "Charfield",
                        "latitude": "51.62722000",
                        "longitude": "-2.40667000"
                    },
                    {
                        "id": 48922,
                        "name": "Charing",
                        "latitude": "51.21073000",
                        "longitude": "0.79466000"
                    },
                    {
                        "id": 48923,
                        "name": "Charlbury",
                        "latitude": "51.87270000",
                        "longitude": "-1.48247000"
                    },
                    {
                        "id": 48925,
                        "name": "Charlton Kings",
                        "latitude": "51.88374000",
                        "longitude": "-2.04239000"
                    },
                    {
                        "id": 48926,
                        "name": "Charlton Marshall",
                        "latitude": "50.83591000",
                        "longitude": "-2.14231000"
                    },
                    {
                        "id": 48927,
                        "name": "Charminster",
                        "latitude": "50.73333000",
                        "longitude": "-2.45000000"
                    },
                    {
                        "id": 48928,
                        "name": "Charmouth",
                        "latitude": "50.73889000",
                        "longitude": "-2.90055000"
                    },
                    {
                        "id": 48929,
                        "name": "Chartham",
                        "latitude": "51.25620000",
                        "longitude": "1.01836000"
                    },
                    {
                        "id": 48930,
                        "name": "Charvil",
                        "latitude": "51.47573000",
                        "longitude": "-0.88591000"
                    },
                    {
                        "id": 48931,
                        "name": "Chasetown",
                        "latitude": "52.67232000",
                        "longitude": "-1.92535000"
                    },
                    {
                        "id": 48932,
                        "name": "Chatburn",
                        "latitude": "53.89228000",
                        "longitude": "-2.35495000"
                    },
                    {
                        "id": 48933,
                        "name": "Chatham",
                        "latitude": "51.37891000",
                        "longitude": "0.52786000"
                    },
                    {
                        "id": 48934,
                        "name": "Chatteris",
                        "latitude": "52.45624000",
                        "longitude": "0.05236000"
                    },
                    {
                        "id": 48935,
                        "name": "Cheadle",
                        "latitude": "52.98333000",
                        "longitude": "-1.98333000"
                    },
                    {
                        "id": 48936,
                        "name": "Cheadle Heath",
                        "latitude": "53.40186000",
                        "longitude": "-2.19088000"
                    },
                    {
                        "id": 48937,
                        "name": "Cheadle Hulme",
                        "latitude": "53.37610000",
                        "longitude": "-2.18970000"
                    },
                    {
                        "id": 48938,
                        "name": "Cheam",
                        "latitude": "51.36179000",
                        "longitude": "-0.21977000"
                    },
                    {
                        "id": 48939,
                        "name": "Cheddar",
                        "latitude": "51.27537000",
                        "longitude": "-2.77662000"
                    },
                    {
                        "id": 48940,
                        "name": "Cheddington",
                        "latitude": "51.84784000",
                        "longitude": "-0.66429000"
                    },
                    {
                        "id": 48941,
                        "name": "Cheddleton",
                        "latitude": "53.06910000",
                        "longitude": "-2.04228000"
                    },
                    {
                        "id": 48942,
                        "name": "Cheetham Hill",
                        "latitude": "53.49862000",
                        "longitude": "-2.23846000"
                    },
                    {
                        "id": 48943,
                        "name": "Chelford",
                        "latitude": "53.27090000",
                        "longitude": "-2.28329000"
                    },
                    {
                        "id": 48944,
                        "name": "Chelmsford",
                        "latitude": "51.73575000",
                        "longitude": "0.46958000"
                    },
                    {
                        "id": 48945,
                        "name": "Chelmsley Wood",
                        "latitude": "52.47810000",
                        "longitude": "-1.73813000"
                    },
                    {
                        "id": 48946,
                        "name": "Chelsea",
                        "latitude": "51.48755000",
                        "longitude": "-0.16936000"
                    },
                    {
                        "id": 48947,
                        "name": "Cheltenham",
                        "latitude": "51.90006000",
                        "longitude": "-2.07972000"
                    },
                    {
                        "id": 48949,
                        "name": "Cherry Burton",
                        "latitude": "53.86667000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 48950,
                        "name": "Chertsey",
                        "latitude": "51.38812000",
                        "longitude": "-0.50782000"
                    },
                    {
                        "id": 48951,
                        "name": "Chesham",
                        "latitude": "51.70000000",
                        "longitude": "-0.60000000"
                    },
                    {
                        "id": 48952,
                        "name": "Cheshire East",
                        "latitude": "53.16702000",
                        "longitude": "-2.36245000"
                    },
                    {
                        "id": 48953,
                        "name": "Cheshire West and Chester",
                        "latitude": "53.16352000",
                        "longitude": "-2.73595000"
                    },
                    {
                        "id": 48954,
                        "name": "Cheshunt",
                        "latitude": "51.70020000",
                        "longitude": "-0.03026000"
                    },
                    {
                        "id": 48955,
                        "name": "Chessington",
                        "latitude": "51.36240000",
                        "longitude": "-0.30427000"
                    },
                    {
                        "id": 48956,
                        "name": "Chester",
                        "latitude": "53.19050000",
                        "longitude": "-2.89189000"
                    },
                    {
                        "id": 48957,
                        "name": "Chester-le-Street",
                        "latitude": "54.85862000",
                        "longitude": "-1.57408000"
                    },
                    {
                        "id": 48958,
                        "name": "Chesterfield",
                        "latitude": "53.25000000",
                        "longitude": "-1.41667000"
                    },
                    {
                        "id": 48959,
                        "name": "Chew Magna",
                        "latitude": "51.36611000",
                        "longitude": "-2.61028000"
                    },
                    {
                        "id": 48960,
                        "name": "Chichester",
                        "latitude": "50.83673000",
                        "longitude": "-0.78003000"
                    },
                    {
                        "id": 48961,
                        "name": "Chickerell",
                        "latitude": "50.62429000",
                        "longitude": "-2.50280000"
                    },
                    {
                        "id": 48962,
                        "name": "Chicksands",
                        "latitude": "52.04585000",
                        "longitude": "-0.36390000"
                    },
                    {
                        "id": 48963,
                        "name": "Chiddingfold",
                        "latitude": "51.11866000",
                        "longitude": "-0.62262000"
                    },
                    {
                        "id": 48964,
                        "name": "Chigwell",
                        "latitude": "51.61999000",
                        "longitude": "0.07596000"
                    },
                    {
                        "id": 48965,
                        "name": "Chilcompton",
                        "latitude": "51.26391000",
                        "longitude": "-2.50502000"
                    },
                    {
                        "id": 48966,
                        "name": "Child Okeford",
                        "latitude": "50.91370000",
                        "longitude": "-2.23679000"
                    },
                    {
                        "id": 48967,
                        "name": "Chilton Foliat",
                        "latitude": "51.43245000",
                        "longitude": "-1.53912000"
                    },
                    {
                        "id": 48968,
                        "name": "Chilworth",
                        "latitude": "51.21635000",
                        "longitude": "-0.53129000"
                    },
                    {
                        "id": 48969,
                        "name": "Chinley",
                        "latitude": "53.34025000",
                        "longitude": "-1.93900000"
                    },
                    {
                        "id": 48970,
                        "name": "Chinnor",
                        "latitude": "51.70177000",
                        "longitude": "-0.91161000"
                    },
                    {
                        "id": 48971,
                        "name": "Chippenham",
                        "latitude": "51.46000000",
                        "longitude": "-2.12472000"
                    },
                    {
                        "id": 48972,
                        "name": "Chipping Campden",
                        "latitude": "52.04964000",
                        "longitude": "-1.77670000"
                    },
                    {
                        "id": 48973,
                        "name": "Chipping Norton",
                        "latitude": "51.94109000",
                        "longitude": "-1.54530000"
                    },
                    {
                        "id": 48974,
                        "name": "Chipping Ongar",
                        "latitude": "51.70379000",
                        "longitude": "0.24548000"
                    },
                    {
                        "id": 48975,
                        "name": "Chipping Sodbury",
                        "latitude": "51.53813000",
                        "longitude": "-2.39379000"
                    },
                    {
                        "id": 48978,
                        "name": "Chiseldon",
                        "latitude": "51.51606000",
                        "longitude": "-1.73206000"
                    },
                    {
                        "id": 48979,
                        "name": "Chislehurst",
                        "latitude": "51.41709000",
                        "longitude": "0.06858000"
                    },
                    {
                        "id": 48980,
                        "name": "Chobham",
                        "latitude": "51.34836000",
                        "longitude": "-0.60639000"
                    },
                    {
                        "id": 48981,
                        "name": "Cholsey",
                        "latitude": "51.57280000",
                        "longitude": "-1.15356000"
                    },
                    {
                        "id": 48982,
                        "name": "Choppington",
                        "latitude": "55.15004000",
                        "longitude": "-1.60332000"
                    },
                    {
                        "id": 48983,
                        "name": "Chopwell",
                        "latitude": "54.91797000",
                        "longitude": "-1.82013000"
                    },
                    {
                        "id": 48984,
                        "name": "Chorley",
                        "latitude": "53.65000000",
                        "longitude": "-2.61667000"
                    },
                    {
                        "id": 48985,
                        "name": "Chorleywood",
                        "latitude": "51.65472000",
                        "longitude": "-0.51404000"
                    },
                    {
                        "id": 48986,
                        "name": "Chorlton",
                        "latitude": "53.05029000",
                        "longitude": "-2.40541000"
                    },
                    {
                        "id": 48987,
                        "name": "Chorlton cum Hardy",
                        "latitude": "53.43505000",
                        "longitude": "-2.26310000"
                    },
                    {
                        "id": 48988,
                        "name": "Christchurch",
                        "latitude": "50.73583000",
                        "longitude": "-1.78129000"
                    },
                    {
                        "id": 48990,
                        "name": "Chudleigh",
                        "latitude": "50.60496000",
                        "longitude": "-3.60031000"
                    },
                    {
                        "id": 48991,
                        "name": "Chudleigh Knighton",
                        "latitude": "50.58507000",
                        "longitude": "-3.63187000"
                    },
                    {
                        "id": 48992,
                        "name": "Chulmleigh",
                        "latitude": "50.91289000",
                        "longitude": "-3.86938000"
                    },
                    {
                        "id": 48993,
                        "name": "Church",
                        "latitude": "53.75177000",
                        "longitude": "-2.39121000"
                    },
                    {
                        "id": 48994,
                        "name": "Church Fenton",
                        "latitude": "53.82626000",
                        "longitude": "-1.21890000"
                    },
                    {
                        "id": 48995,
                        "name": "Church Stretton",
                        "latitude": "52.53778000",
                        "longitude": "-2.80149000"
                    },
                    {
                        "id": 48996,
                        "name": "Churchdown",
                        "latitude": "51.87739000",
                        "longitude": "-2.17087000"
                    },
                    {
                        "id": 48997,
                        "name": "Churchill",
                        "latitude": "51.34291000",
                        "longitude": "-2.78338000"
                    },
                    {
                        "id": 48998,
                        "name": "Churt",
                        "latitude": "51.13603000",
                        "longitude": "-0.77534000"
                    },
                    {
                        "id": 48999,
                        "name": "Cinderford",
                        "latitude": "51.82421000",
                        "longitude": "-2.49870000"
                    },
                    {
                        "id": 49000,
                        "name": "Cirencester",
                        "latitude": "51.71927000",
                        "longitude": "-1.97145000"
                    },
                    {
                        "id": 49001,
                        "name": "City and Borough of Birmingham",
                        "latitude": "52.48048000",
                        "longitude": "-1.89823000"
                    },
                    {
                        "id": 49002,
                        "name": "City and Borough of Leeds",
                        "latitude": "53.79644000",
                        "longitude": "-1.54770000"
                    },
                    {
                        "id": 49003,
                        "name": "City and Borough of Salford",
                        "latitude": "53.50000000",
                        "longitude": "-2.33333000"
                    },
                    {
                        "id": 49004,
                        "name": "City and Borough of Wakefield",
                        "latitude": "53.68085000",
                        "longitude": "-1.49895000"
                    },
                    {
                        "id": 49007,
                        "name": "City of Bristol",
                        "latitude": "51.45000000",
                        "longitude": "-2.60000000"
                    },
                    {
                        "id": 49009,
                        "name": "City of Kingston upon Hull",
                        "latitude": "53.75000000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 49010,
                        "name": "City of Leicester",
                        "latitude": "52.63333000",
                        "longitude": "-1.13333000"
                    },
                    {
                        "id": 49011,
                        "name": "City of London",
                        "latitude": "51.51279000",
                        "longitude": "-0.09184000"
                    },
                    {
                        "id": 49012,
                        "name": "City of Westminster",
                        "latitude": "51.49750000",
                        "longitude": "-0.13570000"
                    },
                    {
                        "id": 49013,
                        "name": "City of York",
                        "latitude": "53.96396000",
                        "longitude": "-1.09142000"
                    },
                    {
                        "id": 49016,
                        "name": "Clacton-on-Sea",
                        "latitude": "51.78967000",
                        "longitude": "1.15597000"
                    },
                    {
                        "id": 49017,
                        "name": "Clapham",
                        "latitude": "52.16085000",
                        "longitude": "-0.49529000"
                    },
                    {
                        "id": 49018,
                        "name": "Clarborough",
                        "latitude": "53.34549000",
                        "longitude": "-0.90382000"
                    },
                    {
                        "id": 49019,
                        "name": "Clare",
                        "latitude": "52.07861000",
                        "longitude": "0.58167000"
                    },
                    {
                        "id": 49021,
                        "name": "Claydon",
                        "latitude": "52.10672000",
                        "longitude": "1.11134000"
                    },
                    {
                        "id": 49022,
                        "name": "Claypole",
                        "latitude": "53.03144000",
                        "longitude": "-0.73407000"
                    },
                    {
                        "id": 49024,
                        "name": "Clayton le Moors",
                        "latitude": "53.76667000",
                        "longitude": "-2.38333000"
                    },
                    {
                        "id": 49023,
                        "name": "Clayton West",
                        "latitude": "53.59501000",
                        "longitude": "-1.61107000"
                    },
                    {
                        "id": 49025,
                        "name": "Clayton-le-Woods",
                        "latitude": "53.69689000",
                        "longitude": "-2.66818000"
                    },
                    {
                        "id": 49026,
                        "name": "Cleator Moor",
                        "latitude": "54.52143000",
                        "longitude": "-3.51590000"
                    },
                    {
                        "id": 49027,
                        "name": "Cleckheaton",
                        "latitude": "53.72405000",
                        "longitude": "-1.71294000"
                    },
                    {
                        "id": 49028,
                        "name": "Cleethorpes",
                        "latitude": "53.56047000",
                        "longitude": "-0.03225000"
                    },
                    {
                        "id": 49030,
                        "name": "Clenchwarton",
                        "latitude": "52.75604000",
                        "longitude": "0.35790000"
                    },
                    {
                        "id": 49031,
                        "name": "Cleobury Mortimer",
                        "latitude": "52.37853000",
                        "longitude": "-2.48196000"
                    },
                    {
                        "id": 49032,
                        "name": "Clerkenwell",
                        "latitude": "51.52438000",
                        "longitude": "-0.11022000"
                    },
                    {
                        "id": 49033,
                        "name": "Clevedon",
                        "latitude": "51.44227000",
                        "longitude": "-2.85786000"
                    },
                    {
                        "id": 49034,
                        "name": "Cleveleys",
                        "latitude": "53.87750000",
                        "longitude": "-3.03987000"
                    },
                    {
                        "id": 49035,
                        "name": "Cliffe",
                        "latitude": "51.46224000",
                        "longitude": "0.49833000"
                    },
                    {
                        "id": 49036,
                        "name": "Clifton",
                        "latitude": "52.03990000",
                        "longitude": "-0.30051000"
                    },
                    {
                        "id": 49037,
                        "name": "Clitheroe",
                        "latitude": "53.86667000",
                        "longitude": "-2.40000000"
                    },
                    {
                        "id": 49038,
                        "name": "Clive",
                        "latitude": "52.81335000",
                        "longitude": "-2.72295000"
                    },
                    {
                        "id": 49039,
                        "name": "Clophill",
                        "latitude": "52.02727000",
                        "longitude": "-0.42377000"
                    },
                    {
                        "id": 49040,
                        "name": "Clowne",
                        "latitude": "53.27449000",
                        "longitude": "-1.26406000"
                    },
                    {
                        "id": 49041,
                        "name": "Clutton",
                        "latitude": "51.32944000",
                        "longitude": "-2.54306000"
                    },
                    {
                        "id": 49047,
                        "name": "Coalville",
                        "latitude": "52.72247000",
                        "longitude": "-1.37020000"
                    },
                    {
                        "id": 49049,
                        "name": "Coates",
                        "latitude": "51.70750000",
                        "longitude": "-2.03389000"
                    },
                    {
                        "id": 49050,
                        "name": "Cobham",
                        "latitude": "51.32997000",
                        "longitude": "-0.41130000"
                    },
                    {
                        "id": 49052,
                        "name": "Cockermouth",
                        "latitude": "54.66209000",
                        "longitude": "-3.36086000"
                    },
                    {
                        "id": 49053,
                        "name": "Cockfield",
                        "latitude": "54.61373000",
                        "longitude": "-1.80897000"
                    },
                    {
                        "id": 49054,
                        "name": "Cockington",
                        "latitude": "50.46335000",
                        "longitude": "-3.55691000"
                    },
                    {
                        "id": 49055,
                        "name": "Codicote",
                        "latitude": "51.85052000",
                        "longitude": "-0.23670000"
                    },
                    {
                        "id": 49056,
                        "name": "Codsall",
                        "latitude": "52.62989000",
                        "longitude": "-2.20148000"
                    },
                    {
                        "id": 49058,
                        "name": "Cogenhoe",
                        "latitude": "52.23758000",
                        "longitude": "-0.78381000"
                    },
                    {
                        "id": 49059,
                        "name": "Coggeshall",
                        "latitude": "51.87077000",
                        "longitude": "0.68536000"
                    },
                    {
                        "id": 49061,
                        "name": "Colchester",
                        "latitude": "51.88921000",
                        "longitude": "0.90421000"
                    },
                    {
                        "id": 49062,
                        "name": "Cold Ash",
                        "latitude": "51.42426000",
                        "longitude": "-1.26463000"
                    },
                    {
                        "id": 49063,
                        "name": "Cold Norton",
                        "latitude": "51.67209000",
                        "longitude": "0.66997000"
                    },
                    {
                        "id": 49064,
                        "name": "Colden Common",
                        "latitude": "50.99483000",
                        "longitude": "-1.31143000"
                    },
                    {
                        "id": 49066,
                        "name": "Coleford",
                        "latitude": "51.79535000",
                        "longitude": "-2.61354000"
                    },
                    {
                        "id": 49068,
                        "name": "Colerne",
                        "latitude": "51.43833000",
                        "longitude": "-2.26280000"
                    },
                    {
                        "id": 49070,
                        "name": "Collier Row",
                        "latitude": "51.59893000",
                        "longitude": "0.16600000"
                    },
                    {
                        "id": 49071,
                        "name": "Collingbourne Kingston",
                        "latitude": "51.30105000",
                        "longitude": "-1.65876000"
                    },
                    {
                        "id": 49072,
                        "name": "Collingham",
                        "latitude": "53.91167000",
                        "longitude": "-1.41174000"
                    },
                    {
                        "id": 49073,
                        "name": "Colnbrook",
                        "latitude": "51.48384000",
                        "longitude": "-0.52142000"
                    },
                    {
                        "id": 49074,
                        "name": "Colne",
                        "latitude": "53.85713000",
                        "longitude": "-2.16851000"
                    },
                    {
                        "id": 49075,
                        "name": "Colsterworth",
                        "latitude": "52.80660000",
                        "longitude": "-0.62056000"
                    },
                    {
                        "id": 49076,
                        "name": "Coltishall",
                        "latitude": "52.72804000",
                        "longitude": "1.36653000"
                    },
                    {
                        "id": 49077,
                        "name": "Colwich",
                        "latitude": "52.78764000",
                        "longitude": "-1.98206000"
                    },
                    {
                        "id": 49079,
                        "name": "Colyton",
                        "latitude": "50.74006000",
                        "longitude": "-3.07021000"
                    },
                    {
                        "id": 49080,
                        "name": "Combe Martin",
                        "latitude": "51.19873000",
                        "longitude": "-4.02343000"
                    },
                    {
                        "id": 49082,
                        "name": "Comberton",
                        "latitude": "52.18709000",
                        "longitude": "0.01905000"
                    },
                    {
                        "id": 49083,
                        "name": "Compton",
                        "latitude": "51.02385000",
                        "longitude": "-1.33713000"
                    },
                    {
                        "id": 49084,
                        "name": "Compton Martin",
                        "latitude": "51.31056000",
                        "longitude": "-2.65528000"
                    },
                    {
                        "id": 49086,
                        "name": "Congleton",
                        "latitude": "53.16314000",
                        "longitude": "-2.21253000"
                    },
                    {
                        "id": 49087,
                        "name": "Congresbury",
                        "latitude": "51.37135000",
                        "longitude": "-2.81018000"
                    },
                    {
                        "id": 49088,
                        "name": "Coningsby",
                        "latitude": "53.10598000",
                        "longitude": "-0.17595000"
                    },
                    {
                        "id": 49089,
                        "name": "Conisbrough",
                        "latitude": "53.48188000",
                        "longitude": "-1.23214000"
                    },
                    {
                        "id": 49092,
                        "name": "Consett",
                        "latitude": "54.85404000",
                        "longitude": "-1.83160000"
                    },
                    {
                        "id": 49094,
                        "name": "Cookham",
                        "latitude": "51.55936000",
                        "longitude": "-0.70810000"
                    },
                    {
                        "id": 49095,
                        "name": "Cookley",
                        "latitude": "52.31667000",
                        "longitude": "1.45000000"
                    },
                    {
                        "id": 49097,
                        "name": "Cople",
                        "latitude": "52.12342000",
                        "longitude": "-0.38933000"
                    },
                    {
                        "id": 49098,
                        "name": "Copmanthorpe",
                        "latitude": "53.91419000",
                        "longitude": "-1.14209000"
                    },
                    {
                        "id": 49099,
                        "name": "Copplestone",
                        "latitude": "50.81073000",
                        "longitude": "-3.74607000"
                    },
                    {
                        "id": 49100,
                        "name": "Coppull",
                        "latitude": "53.62527000",
                        "longitude": "-2.65854000"
                    },
                    {
                        "id": 49101,
                        "name": "Copthorne",
                        "latitude": "51.13929000",
                        "longitude": "-0.11742000"
                    },
                    {
                        "id": 49102,
                        "name": "Corbridge",
                        "latitude": "54.97365000",
                        "longitude": "-2.01798000"
                    },
                    {
                        "id": 49103,
                        "name": "Corby",
                        "latitude": "52.49637000",
                        "longitude": "-0.68939000"
                    },
                    {
                        "id": 49104,
                        "name": "Corby Glen",
                        "latitude": "52.81262000",
                        "longitude": "-0.51817000"
                    },
                    {
                        "id": 49105,
                        "name": "Corfe Castle",
                        "latitude": "50.63947000",
                        "longitude": "-2.05672000"
                    },
                    {
                        "id": 49106,
                        "name": "Cornholme",
                        "latitude": "53.73230000",
                        "longitude": "-2.13851000"
                    },
                    {
                        "id": 49107,
                        "name": "Cornwall",
                        "latitude": "50.41667000",
                        "longitude": "-4.75000000"
                    },
                    {
                        "id": 49108,
                        "name": "Corse",
                        "latitude": "51.95943000",
                        "longitude": "-2.30636000"
                    },
                    {
                        "id": 49109,
                        "name": "Corsham",
                        "latitude": "51.43433000",
                        "longitude": "-2.18437000"
                    },
                    {
                        "id": 49110,
                        "name": "Corston",
                        "latitude": "51.38500000",
                        "longitude": "-2.44028000"
                    },
                    {
                        "id": 49111,
                        "name": "Cosby",
                        "latitude": "52.55127000",
                        "longitude": "-1.19395000"
                    },
                    {
                        "id": 49112,
                        "name": "Cosham",
                        "latitude": "50.84654000",
                        "longitude": "-1.06344000"
                    },
                    {
                        "id": 49113,
                        "name": "Costessey",
                        "latitude": "52.65914000",
                        "longitude": "1.20970000"
                    },
                    {
                        "id": 49114,
                        "name": "Cotgrave",
                        "latitude": "52.90859000",
                        "longitude": "-1.03752000"
                    },
                    {
                        "id": 49115,
                        "name": "Cottenham",
                        "latitude": "52.28743000",
                        "longitude": "0.12540000"
                    },
                    {
                        "id": 49116,
                        "name": "Cottesmore",
                        "latitude": "52.71384000",
                        "longitude": "-0.66330000"
                    },
                    {
                        "id": 49117,
                        "name": "Cottingham",
                        "latitude": "52.50243000",
                        "longitude": "-0.75540000"
                    },
                    {
                        "id": 49118,
                        "name": "Coulsdon",
                        "latitude": "51.32002000",
                        "longitude": "-0.14088000"
                    },
                    {
                        "id": 49119,
                        "name": "Coundon",
                        "latitude": "54.66280000",
                        "longitude": "-1.62688000"
                    },
                    {
                        "id": 49120,
                        "name": "Countesthorpe",
                        "latitude": "52.55379000",
                        "longitude": "-1.14526000"
                    },
                    {
                        "id": 49121,
                        "name": "County Durham",
                        "latitude": "54.77680000",
                        "longitude": "-1.57575000"
                    },
                    {
                        "id": 49126,
                        "name": "Coven",
                        "latitude": "52.65587000",
                        "longitude": "-2.13530000"
                    },
                    {
                        "id": 49127,
                        "name": "Coventry",
                        "latitude": "52.40656000",
                        "longitude": "-1.51217000"
                    },
                    {
                        "id": 49128,
                        "name": "Cowbit",
                        "latitude": "52.74523000",
                        "longitude": "-0.12978000"
                    },
                    {
                        "id": 49131,
                        "name": "Cowes",
                        "latitude": "50.76306000",
                        "longitude": "-1.29772000"
                    },
                    {
                        "id": 49132,
                        "name": "Cowfold",
                        "latitude": "50.98945000",
                        "longitude": "-0.27243000"
                    },
                    {
                        "id": 49134,
                        "name": "Cowley",
                        "latitude": "51.73213000",
                        "longitude": "-1.20631000"
                    },
                    {
                        "id": 49135,
                        "name": "Cowplain",
                        "latitude": "50.89411000",
                        "longitude": "-1.01824000"
                    },
                    {
                        "id": 49136,
                        "name": "Coxhoe",
                        "latitude": "54.71475000",
                        "longitude": "-1.50356000"
                    },
                    {
                        "id": 49138,
                        "name": "Cradley Heath",
                        "latitude": "52.47214000",
                        "longitude": "-2.08212000"
                    },
                    {
                        "id": 49141,
                        "name": "Cramlington",
                        "latitude": "55.08652000",
                        "longitude": "-1.58598000"
                    },
                    {
                        "id": 49142,
                        "name": "Cranbrook",
                        "latitude": "51.09662000",
                        "longitude": "0.53567000"
                    },
                    {
                        "id": 49143,
                        "name": "Cranfield",
                        "latitude": "52.06869000",
                        "longitude": "-0.60884000"
                    },
                    {
                        "id": 49144,
                        "name": "Cranham",
                        "latitude": "51.56565000",
                        "longitude": "0.26590000"
                    },
                    {
                        "id": 49145,
                        "name": "Cranleigh",
                        "latitude": "51.14209000",
                        "longitude": "-0.48374000"
                    },
                    {
                        "id": 49146,
                        "name": "Cranwell",
                        "latitude": "53.03681000",
                        "longitude": "-0.46176000"
                    },
                    {
                        "id": 49147,
                        "name": "Craven Arms",
                        "latitude": "52.44308000",
                        "longitude": "-2.83562000"
                    },
                    {
                        "id": 49148,
                        "name": "Crawley",
                        "latitude": "51.11303000",
                        "longitude": "-0.18312000"
                    },
                    {
                        "id": 49149,
                        "name": "Crawley Down",
                        "latitude": "51.12061000",
                        "longitude": "-0.07730000"
                    },
                    {
                        "id": 49150,
                        "name": "Credenhill",
                        "latitude": "52.08351000",
                        "longitude": "-2.80804000"
                    },
                    {
                        "id": 49151,
                        "name": "Crediton",
                        "latitude": "50.78333000",
                        "longitude": "-3.65000000"
                    },
                    {
                        "id": 49152,
                        "name": "Creech Saint Michael",
                        "latitude": "51.02333000",
                        "longitude": "-3.03833000"
                    },
                    {
                        "id": 49153,
                        "name": "Creswell",
                        "latitude": "53.26287000",
                        "longitude": "-1.21987000"
                    },
                    {
                        "id": 49154,
                        "name": "Crewe",
                        "latitude": "53.09787000",
                        "longitude": "-2.44161000"
                    },
                    {
                        "id": 49155,
                        "name": "Crewkerne",
                        "latitude": "50.88298000",
                        "longitude": "-2.79588000"
                    },
                    {
                        "id": 49157,
                        "name": "Crick",
                        "latitude": "52.34808000",
                        "longitude": "-1.13708000"
                    },
                    {
                        "id": 49159,
                        "name": "Cricklade",
                        "latitude": "51.64061000",
                        "longitude": "-1.85738000"
                    },
                    {
                        "id": 49161,
                        "name": "Cringleford",
                        "latitude": "52.60482000",
                        "longitude": "1.24334000"
                    },
                    {
                        "id": 49163,
                        "name": "Croft",
                        "latitude": "52.55668000",
                        "longitude": "-1.24643000"
                    },
                    {
                        "id": 49164,
                        "name": "Crofton",
                        "latitude": "53.65639000",
                        "longitude": "-1.42968000"
                    },
                    {
                        "id": 49166,
                        "name": "Cromer",
                        "latitude": "52.93123000",
                        "longitude": "1.29892000"
                    },
                    {
                        "id": 49167,
                        "name": "Cromford",
                        "latitude": "53.10848000",
                        "longitude": "-1.56014000"
                    },
                    {
                        "id": 49168,
                        "name": "Crondall",
                        "latitude": "51.23285000",
                        "longitude": "-0.86329000"
                    },
                    {
                        "id": 49169,
                        "name": "Crook",
                        "latitude": "54.71252000",
                        "longitude": "-1.74970000"
                    },
                    {
                        "id": 49170,
                        "name": "Cropwell Bishop",
                        "latitude": "52.91480000",
                        "longitude": "-0.98482000"
                    },
                    {
                        "id": 49171,
                        "name": "Crosby",
                        "latitude": "53.47778000",
                        "longitude": "-3.03333000"
                    },
                    {
                        "id": 49173,
                        "name": "Cross Hills",
                        "latitude": "53.90606000",
                        "longitude": "-1.98492000"
                    },
                    {
                        "id": 49179,
                        "name": "Croston",
                        "latitude": "53.66217000",
                        "longitude": "-2.77523000"
                    },
                    {
                        "id": 49180,
                        "name": "Crouch End",
                        "latitude": "51.57971000",
                        "longitude": "-0.12373000"
                    },
                    {
                        "id": 49181,
                        "name": "Crowborough",
                        "latitude": "51.06098000",
                        "longitude": "0.16342000"
                    },
                    {
                        "id": 49182,
                        "name": "Crowland",
                        "latitude": "52.67571000",
                        "longitude": "-0.16849000"
                    },
                    {
                        "id": 49183,
                        "name": "Crowle",
                        "latitude": "53.60753000",
                        "longitude": "-0.83256000"
                    },
                    {
                        "id": 49184,
                        "name": "Crowthorne",
                        "latitude": "51.37027000",
                        "longitude": "-0.79219000"
                    },
                    {
                        "id": 49186,
                        "name": "Croydon",
                        "latitude": "51.38333000",
                        "longitude": "-0.10000000"
                    },
                    {
                        "id": 49190,
                        "name": "Crumpsall",
                        "latitude": "53.51827000",
                        "longitude": "-2.24447000"
                    },
                    {
                        "id": 49193,
                        "name": "Cuckfield",
                        "latitude": "51.01073000",
                        "longitude": "-0.14068000"
                    },
                    {
                        "id": 49194,
                        "name": "Cuddington",
                        "latitude": "53.24488000",
                        "longitude": "-2.61879000"
                    },
                    {
                        "id": 49195,
                        "name": "Cudworth",
                        "latitude": "53.57131000",
                        "longitude": "-1.41595000"
                    },
                    {
                        "id": 49196,
                        "name": "Cuffley",
                        "latitude": "51.70799000",
                        "longitude": "-0.11209000"
                    },
                    {
                        "id": 49197,
                        "name": "Culcheth",
                        "latitude": "53.45110000",
                        "longitude": "-2.52104000"
                    },
                    {
                        "id": 49199,
                        "name": "Cullingworth",
                        "latitude": "53.82444000",
                        "longitude": "-1.89730000"
                    },
                    {
                        "id": 49201,
                        "name": "Cullompton",
                        "latitude": "50.85530000",
                        "longitude": "-3.39268000"
                    },
                    {
                        "id": 49205,
                        "name": "Culverstone Green",
                        "latitude": "51.34085000",
                        "longitude": "0.34686000"
                    },
                    {
                        "id": 49207,
                        "name": "Cumbria",
                        "latitude": "54.58333000",
                        "longitude": "-2.83333000"
                    },
                    {
                        "id": 49210,
                        "name": "Curdworth",
                        "latitude": "52.53382000",
                        "longitude": "-1.73687000"
                    },
                    {
                        "id": 49212,
                        "name": "Curry Rivel",
                        "latitude": "51.02306000",
                        "longitude": "-2.86753000"
                    },
                    {
                        "id": 49214,
                        "name": "Cuxton",
                        "latitude": "51.37430000",
                        "longitude": "0.45688000"
                    },
                    {
                        "id": 49219,
                        "name": "Dagenham",
                        "latitude": "51.55000000",
                        "longitude": "0.16667000"
                    },
                    {
                        "id": 49227,
                        "name": "Dalston",
                        "latitude": "54.84207000",
                        "longitude": "-2.98459000"
                    },
                    {
                        "id": 49228,
                        "name": "Dalton in Furness",
                        "latitude": "54.15796000",
                        "longitude": "-3.17977000"
                    },
                    {
                        "id": 49229,
                        "name": "Danbury",
                        "latitude": "51.71645000",
                        "longitude": "0.58245000"
                    },
                    {
                        "id": 49230,
                        "name": "Danby",
                        "latitude": "54.46606000",
                        "longitude": "-0.91073000"
                    },
                    {
                        "id": 49232,
                        "name": "Darenth",
                        "latitude": "51.42137000",
                        "longitude": "0.25784000"
                    },
                    {
                        "id": 49233,
                        "name": "Daresbury",
                        "latitude": "53.34184000",
                        "longitude": "-2.63500000"
                    },
                    {
                        "id": 49234,
                        "name": "Darfield",
                        "latitude": "53.53390000",
                        "longitude": "-1.37595000"
                    },
                    {
                        "id": 49235,
                        "name": "Darlaston",
                        "latitude": "52.56667000",
                        "longitude": "-2.03333000"
                    },
                    {
                        "id": 49236,
                        "name": "Darlington",
                        "latitude": "54.53333000",
                        "longitude": "-1.53333000"
                    },
                    {
                        "id": 49237,
                        "name": "Darras Hall",
                        "latitude": "55.03560000",
                        "longitude": "-1.76425000"
                    },
                    {
                        "id": 49238,
                        "name": "Darrington",
                        "latitude": "53.67566000",
                        "longitude": "-1.26901000"
                    },
                    {
                        "id": 49239,
                        "name": "Dartford",
                        "latitude": "51.44657000",
                        "longitude": "0.21423000"
                    },
                    {
                        "id": 49240,
                        "name": "Dartmouth",
                        "latitude": "50.35220000",
                        "longitude": "-3.57940000"
                    },
                    {
                        "id": 49241,
                        "name": "Darton",
                        "latitude": "53.58705000",
                        "longitude": "-1.52676000"
                    },
                    {
                        "id": 49243,
                        "name": "Darwen",
                        "latitude": "53.69803000",
                        "longitude": "-2.46494000"
                    },
                    {
                        "id": 49244,
                        "name": "Datchet",
                        "latitude": "51.48390000",
                        "longitude": "-0.57893000"
                    },
                    {
                        "id": 49245,
                        "name": "Datchworth",
                        "latitude": "51.85126000",
                        "longitude": "-0.15956000"
                    },
                    {
                        "id": 49246,
                        "name": "Daventry",
                        "latitude": "52.25688000",
                        "longitude": "-1.16066000"
                    },
                    {
                        "id": 49247,
                        "name": "Dawlish",
                        "latitude": "50.58118000",
                        "longitude": "-3.46644000"
                    },
                    {
                        "id": 49248,
                        "name": "Deal",
                        "latitude": "51.22322000",
                        "longitude": "1.40432000"
                    },
                    {
                        "id": 49249,
                        "name": "Deanshanger",
                        "latitude": "52.04996000",
                        "longitude": "-0.88663000"
                    },
                    {
                        "id": 49250,
                        "name": "Dearham",
                        "latitude": "54.71175000",
                        "longitude": "-3.44364000"
                    },
                    {
                        "id": 49251,
                        "name": "Debenham",
                        "latitude": "52.22422000",
                        "longitude": "1.18172000"
                    },
                    {
                        "id": 49252,
                        "name": "Deddington",
                        "latitude": "51.98060000",
                        "longitude": "-1.32055000"
                    },
                    {
                        "id": 49253,
                        "name": "Dedham",
                        "latitude": "51.95892000",
                        "longitude": "0.99336000"
                    },
                    {
                        "id": 49257,
                        "name": "Delabole",
                        "latitude": "50.62347000",
                        "longitude": "-4.73190000"
                    },
                    {
                        "id": 49258,
                        "name": "Delph",
                        "latitude": "53.56667000",
                        "longitude": "-2.01667000"
                    },
                    {
                        "id": 49261,
                        "name": "Denby Dale",
                        "latitude": "53.57228000",
                        "longitude": "-1.65895000"
                    },
                    {
                        "id": 49262,
                        "name": "Denham",
                        "latitude": "51.56667000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 49263,
                        "name": "Denholme",
                        "latitude": "53.80189000",
                        "longitude": "-1.89503000"
                    },
                    {
                        "id": 49264,
                        "name": "Denmead",
                        "latitude": "50.90395000",
                        "longitude": "-1.06744000"
                    },
                    {
                        "id": 49267,
                        "name": "Denton",
                        "latitude": "53.45678000",
                        "longitude": "-2.11822000"
                    },
                    {
                        "id": 49268,
                        "name": "Denton Holme",
                        "latitude": "54.88500000",
                        "longitude": "-2.94100000"
                    },
                    {
                        "id": 49269,
                        "name": "Derby",
                        "latitude": "52.92277000",
                        "longitude": "-1.47663000"
                    },
                    {
                        "id": 49270,
                        "name": "Derbyshire",
                        "latitude": "53.16667000",
                        "longitude": "-1.58333000"
                    },
                    {
                        "id": 49274,
                        "name": "Dersingham",
                        "latitude": "52.84549000",
                        "longitude": "0.50339000"
                    },
                    {
                        "id": 49275,
                        "name": "Desborough",
                        "latitude": "52.44183000",
                        "longitude": "-0.82126000"
                    },
                    {
                        "id": 49276,
                        "name": "Desford",
                        "latitude": "52.62598000",
                        "longitude": "-1.29395000"
                    },
                    {
                        "id": 49277,
                        "name": "Devizes",
                        "latitude": "51.35084000",
                        "longitude": "-1.99421000"
                    },
                    {
                        "id": 49278,
                        "name": "Devon",
                        "latitude": "50.75000000",
                        "longitude": "-3.75000000"
                    },
                    {
                        "id": 49279,
                        "name": "Dewsbury",
                        "latitude": "53.69076000",
                        "longitude": "-1.62907000"
                    },
                    {
                        "id": 49280,
                        "name": "Dickens Heath",
                        "latitude": "52.38568000",
                        "longitude": "-1.83935000"
                    },
                    {
                        "id": 49281,
                        "name": "Dickleburgh",
                        "latitude": "52.39650000",
                        "longitude": "1.18498000"
                    },
                    {
                        "id": 49282,
                        "name": "Didcot",
                        "latitude": "51.60928000",
                        "longitude": "-1.24214000"
                    },
                    {
                        "id": 49283,
                        "name": "Didsbury",
                        "latitude": "53.41698000",
                        "longitude": "-2.23145000"
                    },
                    {
                        "id": 49284,
                        "name": "Diggle",
                        "latitude": "53.56744000",
                        "longitude": "-1.99723000"
                    },
                    {
                        "id": 49287,
                        "name": "Dinnington",
                        "latitude": "53.36667000",
                        "longitude": "-1.20000000"
                    },
                    {
                        "id": 49288,
                        "name": "Dinton",
                        "latitude": "51.08333000",
                        "longitude": "-1.98333000"
                    },
                    {
                        "id": 49289,
                        "name": "Disley",
                        "latitude": "53.35865000",
                        "longitude": "-2.03848000"
                    },
                    {
                        "id": 49290,
                        "name": "Diss",
                        "latitude": "52.37675000",
                        "longitude": "1.10910000"
                    },
                    {
                        "id": 49291,
                        "name": "Distington",
                        "latitude": "54.59733000",
                        "longitude": "-3.53880000"
                    },
                    {
                        "id": 49292,
                        "name": "District of Rutland",
                        "latitude": "52.66667000",
                        "longitude": "-0.66667000"
                    },
                    {
                        "id": 49293,
                        "name": "Ditchingham",
                        "latitude": "52.46729000",
                        "longitude": "1.44370000"
                    },
                    {
                        "id": 49294,
                        "name": "Ditchling",
                        "latitude": "50.92100000",
                        "longitude": "-0.11536000"
                    },
                    {
                        "id": 49295,
                        "name": "Ditton Hill",
                        "latitude": "51.37947000",
                        "longitude": "-0.31281000"
                    },
                    {
                        "id": 49297,
                        "name": "Dobwalls",
                        "latitude": "50.45768000",
                        "longitude": "-4.51735000"
                    },
                    {
                        "id": 49298,
                        "name": "Doddington",
                        "latitude": "52.49671000",
                        "longitude": "0.06017000"
                    },
                    {
                        "id": 49299,
                        "name": "Dodworth",
                        "latitude": "53.54306000",
                        "longitude": "-1.52779000"
                    },
                    {
                        "id": 49303,
                        "name": "Doncaster",
                        "latitude": "53.50000000",
                        "longitude": "-1.08333000"
                    },
                    {
                        "id": 49304,
                        "name": "Donington",
                        "latitude": "52.90461000",
                        "longitude": "-0.20505000"
                    },
                    {
                        "id": 49305,
                        "name": "Donisthorpe",
                        "latitude": "52.72401000",
                        "longitude": "-1.53800000"
                    },
                    {
                        "id": 49306,
                        "name": "Donnington",
                        "latitude": "51.95135000",
                        "longitude": "-1.72142000"
                    },
                    {
                        "id": 49307,
                        "name": "Dorchester",
                        "latitude": "50.71667000",
                        "longitude": "-2.43333000"
                    },
                    {
                        "id": 49308,
                        "name": "Dorking",
                        "latitude": "51.23228000",
                        "longitude": "-0.33380000"
                    },
                    {
                        "id": 49309,
                        "name": "Dormansland",
                        "latitude": "51.16024000",
                        "longitude": "0.00618000"
                    },
                    {
                        "id": 49311,
                        "name": "Dorridge",
                        "latitude": "52.37259000",
                        "longitude": "-1.75318000"
                    },
                    {
                        "id": 49312,
                        "name": "Dorset",
                        "latitude": "50.75000000",
                        "longitude": "-2.33333000"
                    },
                    {
                        "id": 49313,
                        "name": "Dorstone",
                        "latitude": "52.06667000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 49316,
                        "name": "Dove Holes",
                        "latitude": "53.29828000",
                        "longitude": "-1.88775000"
                    },
                    {
                        "id": 49317,
                        "name": "Dover",
                        "latitude": "51.12598000",
                        "longitude": "1.31257000"
                    },
                    {
                        "id": 49318,
                        "name": "Dovercourt",
                        "latitude": "51.93649000",
                        "longitude": "1.27831000"
                    },
                    {
                        "id": 49319,
                        "name": "Doveridge",
                        "latitude": "52.90526000",
                        "longitude": "-1.82480000"
                    },
                    {
                        "id": 49320,
                        "name": "Downham Market",
                        "latitude": "52.60714000",
                        "longitude": "0.38375000"
                    },
                    {
                        "id": 49322,
                        "name": "Downton",
                        "latitude": "50.99366000",
                        "longitude": "-1.75129000"
                    },
                    {
                        "id": 49324,
                        "name": "Draycott",
                        "latitude": "51.25615000",
                        "longitude": "-2.75116000"
                    },
                    {
                        "id": 49326,
                        "name": "Driffield",
                        "latitude": "54.00613000",
                        "longitude": "-0.44495000"
                    },
                    {
                        "id": 49327,
                        "name": "Droitwich",
                        "latitude": "52.26667000",
                        "longitude": "-2.15000000"
                    },
                    {
                        "id": 49329,
                        "name": "Dronfield",
                        "latitude": "53.30221000",
                        "longitude": "-1.47507000"
                    },
                    {
                        "id": 49331,
                        "name": "Droylsden",
                        "latitude": "53.48005000",
                        "longitude": "-2.14543000"
                    },
                    {
                        "id": 49333,
                        "name": "Drybrook",
                        "latitude": "51.85550000",
                        "longitude": "-2.51681000"
                    },
                    {
                        "id": 49334,
                        "name": "Ducklington",
                        "latitude": "51.76763000",
                        "longitude": "-1.48418000"
                    },
                    {
                        "id": 49335,
                        "name": "Dudley",
                        "latitude": "52.50000000",
                        "longitude": "-2.11667000"
                    },
                    {
                        "id": 49336,
                        "name": "Duffield",
                        "latitude": "52.98627000",
                        "longitude": "-1.48865000"
                    },
                    {
                        "id": 49338,
                        "name": "Dukinfield",
                        "latitude": "53.47497000",
                        "longitude": "-2.08809000"
                    },
                    {
                        "id": 49339,
                        "name": "Dulverton",
                        "latitude": "51.04007000",
                        "longitude": "-3.55035000"
                    },
                    {
                        "id": 49345,
                        "name": "Dunchurch",
                        "latitude": "52.33757000",
                        "longitude": "-1.29136000"
                    },
                    {
                        "id": 49351,
                        "name": "Dundry",
                        "latitude": "51.39880000",
                        "longitude": "-2.63964000"
                    },
                    {
                        "id": 49355,
                        "name": "Dunholme",
                        "latitude": "53.30067000",
                        "longitude": "-0.46541000"
                    },
                    {
                        "id": 49357,
                        "name": "Dunkeswell",
                        "latitude": "50.86301000",
                        "longitude": "-3.22289000"
                    },
                    {
                        "id": 49360,
                        "name": "Dunnington",
                        "latitude": "53.95000000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 49363,
                        "name": "Dunstable",
                        "latitude": "51.88571000",
                        "longitude": "-0.52288000"
                    },
                    {
                        "id": 49364,
                        "name": "Dunswell",
                        "latitude": "53.80106000",
                        "longitude": "-0.37139000"
                    },
                    {
                        "id": 49366,
                        "name": "Durham",
                        "latitude": "54.77676000",
                        "longitude": "-1.57566000"
                    },
                    {
                        "id": 49367,
                        "name": "Dursley",
                        "latitude": "51.68139000",
                        "longitude": "-2.35333000"
                    },
                    {
                        "id": 49368,
                        "name": "Duxford",
                        "latitude": "52.09393000",
                        "longitude": "0.15917000"
                    },
                    {
                        "id": 49371,
                        "name": "Dymchurch",
                        "latitude": "51.02544000",
                        "longitude": "0.99392000"
                    },
                    {
                        "id": 49373,
                        "name": "Eaglescliffe",
                        "latitude": "54.52521000",
                        "longitude": "-1.35043000"
                    },
                    {
                        "id": 49375,
                        "name": "Earby",
                        "latitude": "53.91546000",
                        "longitude": "-2.14285000"
                    },
                    {
                        "id": 49376,
                        "name": "Earith",
                        "latitude": "52.35422000",
                        "longitude": "0.03056000"
                    },
                    {
                        "id": 49377,
                        "name": "Earl Shilton",
                        "latitude": "52.57682000",
                        "longitude": "-1.31536000"
                    },
                    {
                        "id": 49378,
                        "name": "Earls Barton",
                        "latitude": "52.26627000",
                        "longitude": "-0.75248000"
                    },
                    {
                        "id": 49379,
                        "name": "Earls Colne",
                        "latitude": "51.92744000",
                        "longitude": "0.70107000"
                    },
                    {
                        "id": 49380,
                        "name": "Earlsfield",
                        "latitude": "51.44390000",
                        "longitude": "-0.18540000"
                    },
                    {
                        "id": 49382,
                        "name": "Easington",
                        "latitude": "54.78528000",
                        "longitude": "-1.35917000"
                    },
                    {
                        "id": 49383,
                        "name": "Easingwold",
                        "latitude": "54.12010000",
                        "longitude": "-1.19390000"
                    },
                    {
                        "id": 49385,
                        "name": "East Ayton",
                        "latitude": "54.25480000",
                        "longitude": "-0.47483000"
                    },
                    {
                        "id": 49386,
                        "name": "East Bergholt",
                        "latitude": "51.97785000",
                        "longitude": "1.01761000"
                    },
                    {
                        "id": 49387,
                        "name": "East Boldon",
                        "latitude": "54.94452000",
                        "longitude": "-1.42815000"
                    },
                    {
                        "id": 49388,
                        "name": "East Bridgford",
                        "latitude": "52.97954000",
                        "longitude": "-0.96563000"
                    },
                    {
                        "id": 49390,
                        "name": "East Chevington",
                        "latitude": "55.28333000",
                        "longitude": "-1.58333000"
                    },
                    {
                        "id": 49391,
                        "name": "East Cowes",
                        "latitude": "50.75774000",
                        "longitude": "-1.28815000"
                    },
                    {
                        "id": 49392,
                        "name": "East Dean",
                        "latitude": "51.03979000",
                        "longitude": "-1.60941000"
                    },
                    {
                        "id": 49393,
                        "name": "East Dereham",
                        "latitude": "52.68333000",
                        "longitude": "0.93333000"
                    },
                    {
                        "id": 49395,
                        "name": "East Grinstead",
                        "latitude": "51.12382000",
                        "longitude": "-0.00610000"
                    },
                    {
                        "id": 49396,
                        "name": "East Hanney",
                        "latitude": "51.63443000",
                        "longitude": "-1.39518000"
                    },
                    {
                        "id": 49397,
                        "name": "East Harling",
                        "latitude": "52.43843000",
                        "longitude": "0.93353000"
                    },
                    {
                        "id": 49398,
                        "name": "East Harptree",
                        "latitude": "51.30111000",
                        "longitude": "-2.62167000"
                    },
                    {
                        "id": 49399,
                        "name": "East Horsley",
                        "latitude": "51.27358000",
                        "longitude": "-0.43207000"
                    },
                    {
                        "id": 49400,
                        "name": "East Keswick",
                        "latitude": "53.89430000",
                        "longitude": "-1.45221000"
                    },
                    {
                        "id": 49402,
                        "name": "East Leake",
                        "latitude": "52.83015000",
                        "longitude": "-1.18103000"
                    },
                    {
                        "id": 49405,
                        "name": "East Markham",
                        "latitude": "53.25221000",
                        "longitude": "-0.89385000"
                    },
                    {
                        "id": 49406,
                        "name": "East Molesey",
                        "latitude": "51.39872000",
                        "longitude": "-0.34916000"
                    },
                    {
                        "id": 49407,
                        "name": "East Peckham",
                        "latitude": "51.21234000",
                        "longitude": "0.38624000"
                    },
                    {
                        "id": 49408,
                        "name": "East Rainton",
                        "latitude": "54.82513000",
                        "longitude": "-1.48036000"
                    },
                    {
                        "id": 49410,
                        "name": "East Riding of Yorkshire",
                        "latitude": "53.91667000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 49411,
                        "name": "East Sussex",
                        "latitude": "50.91667000",
                        "longitude": "0.33333000"
                    },
                    {
                        "id": 49412,
                        "name": "East Tilbury",
                        "latitude": "51.48053000",
                        "longitude": "0.41714000"
                    },
                    {
                        "id": 49415,
                        "name": "East Wittering",
                        "latitude": "50.76969000",
                        "longitude": "-0.87444000"
                    },
                    {
                        "id": 49416,
                        "name": "Eastbourne",
                        "latitude": "50.76871000",
                        "longitude": "0.28453000"
                    },
                    {
                        "id": 49417,
                        "name": "Eastchurch",
                        "latitude": "51.40673000",
                        "longitude": "0.85766000"
                    },
                    {
                        "id": 49418,
                        "name": "Eastington",
                        "latitude": "51.74722000",
                        "longitude": "-2.32639000"
                    },
                    {
                        "id": 49419,
                        "name": "Eastleigh",
                        "latitude": "50.96667000",
                        "longitude": "-1.35000000"
                    },
                    {
                        "id": 49420,
                        "name": "Eastoft",
                        "latitude": "53.63624000",
                        "longitude": "-0.78492000"
                    },
                    {
                        "id": 49421,
                        "name": "Easton",
                        "latitude": "50.53333000",
                        "longitude": "-2.45000000"
                    },
                    {
                        "id": 49422,
                        "name": "Easton on the Hill",
                        "latitude": "52.62733000",
                        "longitude": "-0.50571000"
                    },
                    {
                        "id": 49423,
                        "name": "Easton-in-Gordano",
                        "latitude": "51.47592000",
                        "longitude": "-2.69987000"
                    },
                    {
                        "id": 49425,
                        "name": "Eastrington",
                        "latitude": "53.76038000",
                        "longitude": "-0.79325000"
                    },
                    {
                        "id": 49426,
                        "name": "Eastry",
                        "latitude": "51.24639000",
                        "longitude": "1.30776000"
                    },
                    {
                        "id": 49427,
                        "name": "Eastwood",
                        "latitude": "53.00000000",
                        "longitude": "-1.30000000"
                    },
                    {
                        "id": 49428,
                        "name": "Eaton Bray",
                        "latitude": "51.87697000",
                        "longitude": "-0.59167000"
                    },
                    {
                        "id": 49429,
                        "name": "Eaton Socon",
                        "latitude": "52.21752000",
                        "longitude": "-0.28925000"
                    },
                    {
                        "id": 49430,
                        "name": "Eattington",
                        "latitude": "52.13333000",
                        "longitude": "-1.60000000"
                    },
                    {
                        "id": 49432,
                        "name": "Eccles",
                        "latitude": "53.48333000",
                        "longitude": "-2.33333000"
                    },
                    {
                        "id": 49433,
                        "name": "Eccleshall",
                        "latitude": "52.85789000",
                        "longitude": "-2.24971000"
                    },
                    {
                        "id": 49434,
                        "name": "Eccleston",
                        "latitude": "53.64236000",
                        "longitude": "-2.72162000"
                    },
                    {
                        "id": 49435,
                        "name": "Eckington",
                        "latitude": "52.06667000",
                        "longitude": "-2.11667000"
                    },
                    {
                        "id": 49436,
                        "name": "Edenbridge",
                        "latitude": "51.19172000",
                        "longitude": "0.06729000"
                    },
                    {
                        "id": 49437,
                        "name": "Edenfield",
                        "latitude": "53.66674000",
                        "longitude": "-2.30481000"
                    },
                    {
                        "id": 49438,
                        "name": "Edgmond",
                        "latitude": "52.77400000",
                        "longitude": "-2.40967000"
                    },
                    {
                        "id": 49439,
                        "name": "Edgware",
                        "latitude": "51.61280000",
                        "longitude": "-0.27539000"
                    },
                    {
                        "id": 49440,
                        "name": "Edgworth",
                        "latitude": "53.64636000",
                        "longitude": "-2.39401000"
                    },
                    {
                        "id": 49442,
                        "name": "Edington",
                        "latitude": "51.27583000",
                        "longitude": "-2.10639000"
                    },
                    {
                        "id": 49443,
                        "name": "Edith Weston",
                        "latitude": "52.63786000",
                        "longitude": "-0.63189000"
                    },
                    {
                        "id": 49444,
                        "name": "Edwinstowe",
                        "latitude": "53.19454000",
                        "longitude": "-1.06439000"
                    },
                    {
                        "id": 49445,
                        "name": "Egham",
                        "latitude": "51.43158000",
                        "longitude": "-0.55239000"
                    },
                    {
                        "id": 49447,
                        "name": "Egremont",
                        "latitude": "54.47941000",
                        "longitude": "-3.52756000"
                    },
                    {
                        "id": 49448,
                        "name": "Eight Ash Green",
                        "latitude": "51.89587000",
                        "longitude": "0.82280000"
                    },
                    {
                        "id": 49452,
                        "name": "Elland",
                        "latitude": "53.68510000",
                        "longitude": "-1.83878000"
                    },
                    {
                        "id": 49453,
                        "name": "Ellerker",
                        "latitude": "53.75323000",
                        "longitude": "-0.60416000"
                    },
                    {
                        "id": 49454,
                        "name": "Ellerton",
                        "latitude": "53.85000000",
                        "longitude": "-0.93333000"
                    },
                    {
                        "id": 49455,
                        "name": "Ellesmere",
                        "latitude": "52.90838000",
                        "longitude": "-2.89806000"
                    },
                    {
                        "id": 49456,
                        "name": "Ellesmere Port",
                        "latitude": "53.27875000",
                        "longitude": "-2.90134000"
                    },
                    {
                        "id": 49458,
                        "name": "Elm Park",
                        "latitude": "51.54970000",
                        "longitude": "0.20136000"
                    },
                    {
                        "id": 49459,
                        "name": "Elmstead Market",
                        "latitude": "51.88219000",
                        "longitude": "0.99482000"
                    },
                    {
                        "id": 49460,
                        "name": "Elmswell",
                        "latitude": "52.23616000",
                        "longitude": "0.91247000"
                    },
                    {
                        "id": 49461,
                        "name": "Elsenham",
                        "latitude": "51.91431000",
                        "longitude": "0.22934000"
                    },
                    {
                        "id": 49462,
                        "name": "Elstead",
                        "latitude": "51.18548000",
                        "longitude": "-0.70536000"
                    },
                    {
                        "id": 49463,
                        "name": "Elstree",
                        "latitude": "51.64030000",
                        "longitude": "-0.29693000"
                    },
                    {
                        "id": 49464,
                        "name": "Elswick",
                        "latitude": "53.83836000",
                        "longitude": "-2.88147000"
                    },
                    {
                        "id": 49465,
                        "name": "Elvington",
                        "latitude": "53.92087000",
                        "longitude": "-0.93495000"
                    },
                    {
                        "id": 49466,
                        "name": "Elwick",
                        "latitude": "54.68455000",
                        "longitude": "-1.29559000"
                    },
                    {
                        "id": 49467,
                        "name": "Ely",
                        "latitude": "52.39964000",
                        "longitude": "0.26196000"
                    },
                    {
                        "id": 49468,
                        "name": "Emberton",
                        "latitude": "52.13691000",
                        "longitude": "-0.70673000"
                    },
                    {
                        "id": 49469,
                        "name": "Embleton",
                        "latitude": "55.49592000",
                        "longitude": "-1.63619000"
                    },
                    {
                        "id": 49470,
                        "name": "Embsay",
                        "latitude": "53.97664000",
                        "longitude": "-1.99282000"
                    },
                    {
                        "id": 49471,
                        "name": "Emley",
                        "latitude": "53.61395000",
                        "longitude": "-1.63130000"
                    },
                    {
                        "id": 49472,
                        "name": "Emneth",
                        "latitude": "52.64244000",
                        "longitude": "0.20857000"
                    },
                    {
                        "id": 49473,
                        "name": "Empingham",
                        "latitude": "52.66722000",
                        "longitude": "-0.59601000"
                    },
                    {
                        "id": 49474,
                        "name": "Emsworth",
                        "latitude": "50.84779000",
                        "longitude": "-0.93697000"
                    },
                    {
                        "id": 49475,
                        "name": "Enderby",
                        "latitude": "52.58778000",
                        "longitude": "-1.20619000"
                    },
                    {
                        "id": 49476,
                        "name": "Enfield Town",
                        "latitude": "51.65147000",
                        "longitude": "-0.08497000"
                    },
                    {
                        "id": 49478,
                        "name": "Epping",
                        "latitude": "51.69815000",
                        "longitude": "0.11055000"
                    },
                    {
                        "id": 49479,
                        "name": "Epsom",
                        "latitude": "51.33050000",
                        "longitude": "-0.27011000"
                    },
                    {
                        "id": 49480,
                        "name": "Epworth",
                        "latitude": "53.52602000",
                        "longitude": "-0.82399000"
                    },
                    {
                        "id": 49481,
                        "name": "Erith",
                        "latitude": "51.48315000",
                        "longitude": "0.17484000"
                    },
                    {
                        "id": 49484,
                        "name": "Esher",
                        "latitude": "51.36969000",
                        "longitude": "-0.36693000"
                    },
                    {
                        "id": 49485,
                        "name": "Essendine",
                        "latitude": "52.70187000",
                        "longitude": "-0.45250000"
                    },
                    {
                        "id": 49486,
                        "name": "Essex",
                        "latitude": "51.83333000",
                        "longitude": "0.58333000"
                    },
                    {
                        "id": 49487,
                        "name": "Essington",
                        "latitude": "52.62910000",
                        "longitude": "-2.05770000"
                    },
                    {
                        "id": 49488,
                        "name": "Eton",
                        "latitude": "51.48833000",
                        "longitude": "-0.60905000"
                    },
                    {
                        "id": 49489,
                        "name": "Eton Wick",
                        "latitude": "51.49722000",
                        "longitude": "-0.63437000"
                    },
                    {
                        "id": 49490,
                        "name": "Etton",
                        "latitude": "53.87848000",
                        "longitude": "-0.51314000"
                    },
                    {
                        "id": 49491,
                        "name": "Etwall",
                        "latitude": "52.88353000",
                        "longitude": "-1.60023000"
                    },
                    {
                        "id": 49492,
                        "name": "Euxton",
                        "latitude": "53.66990000",
                        "longitude": "-2.67615000"
                    },
                    {
                        "id": 49494,
                        "name": "Evenwood",
                        "latitude": "54.62213000",
                        "longitude": "-1.76133000"
                    },
                    {
                        "id": 49495,
                        "name": "Evercreech",
                        "latitude": "51.14806000",
                        "longitude": "-2.50556000"
                    },
                    {
                        "id": 49496,
                        "name": "Eversholt",
                        "latitude": "51.98702000",
                        "longitude": "-0.55983000"
                    },
                    {
                        "id": 49497,
                        "name": "Eversley",
                        "latitude": "51.35387000",
                        "longitude": "-0.88888000"
                    },
                    {
                        "id": 49498,
                        "name": "Everton",
                        "latitude": "52.14581000",
                        "longitude": "-0.24616000"
                    },
                    {
                        "id": 49499,
                        "name": "Evesham",
                        "latitude": "52.09237000",
                        "longitude": "-1.94887000"
                    },
                    {
                        "id": 49500,
                        "name": "Ewell",
                        "latitude": "51.34948000",
                        "longitude": "-0.24940000"
                    },
                    {
                        "id": 49501,
                        "name": "Ewhurst",
                        "latitude": "51.15448000",
                        "longitude": "-0.44344000"
                    },
                    {
                        "id": 49502,
                        "name": "Ewyas Harold",
                        "latitude": "51.95358000",
                        "longitude": "-2.89325000"
                    },
                    {
                        "id": 49503,
                        "name": "Exeter",
                        "latitude": "50.72360000",
                        "longitude": "-3.52751000"
                    },
                    {
                        "id": 49504,
                        "name": "Exhall",
                        "latitude": "52.46464000",
                        "longitude": "-1.48144000"
                    },
                    {
                        "id": 49505,
                        "name": "Exminster",
                        "latitude": "50.68075000",
                        "longitude": "-3.49706000"
                    },
                    {
                        "id": 49506,
                        "name": "Exmouth",
                        "latitude": "50.61723000",
                        "longitude": "-3.40233000"
                    },
                    {
                        "id": 49507,
                        "name": "Exning",
                        "latitude": "52.26642000",
                        "longitude": "0.37439000"
                    },
                    {
                        "id": 49508,
                        "name": "Exton",
                        "latitude": "52.69106000",
                        "longitude": "-0.63463000"
                    },
                    {
                        "id": 49509,
                        "name": "Eye",
                        "latitude": "52.60800000",
                        "longitude": "-0.19209000"
                    },
                    {
                        "id": 49511,
                        "name": "Eynsford",
                        "latitude": "51.36765000",
                        "longitude": "0.21132000"
                    },
                    {
                        "id": 49512,
                        "name": "Eynsham",
                        "latitude": "51.78077000",
                        "longitude": "-1.37454000"
                    },
                    {
                        "id": 49513,
                        "name": "Eythorne",
                        "latitude": "51.19710000",
                        "longitude": "1.26620000"
                    },
                    {
                        "id": 49515,
                        "name": "Failsworth",
                        "latitude": "53.50484000",
                        "longitude": "-2.16568000"
                    },
                    {
                        "id": 49516,
                        "name": "Fairford",
                        "latitude": "51.70816000",
                        "longitude": "-1.78128000"
                    },
                    {
                        "id": 49517,
                        "name": "Fairlands",
                        "latitude": "51.26178000",
                        "longitude": "-0.62141000"
                    },
                    {
                        "id": 49519,
                        "name": "Fairlight",
                        "latitude": "50.87802000",
                        "longitude": "0.65669000"
                    },
                    {
                        "id": 49520,
                        "name": "Fakenham",
                        "latitude": "52.82996000",
                        "longitude": "0.84770000"
                    },
                    {
                        "id": 49524,
                        "name": "Fallowfield",
                        "latitude": "53.43981000",
                        "longitude": "-2.21572000"
                    },
                    {
                        "id": 49525,
                        "name": "Falmouth",
                        "latitude": "50.15441000",
                        "longitude": "-5.07113000"
                    },
                    {
                        "id": 49526,
                        "name": "Fareham",
                        "latitude": "50.85162000",
                        "longitude": "-1.17929000"
                    },
                    {
                        "id": 49527,
                        "name": "Faringdon",
                        "latitude": "51.65644000",
                        "longitude": "-1.58676000"
                    },
                    {
                        "id": 49528,
                        "name": "Farnborough",
                        "latitude": "51.29424000",
                        "longitude": "-0.75565000"
                    },
                    {
                        "id": 49529,
                        "name": "Farndon",
                        "latitude": "53.05000000",
                        "longitude": "-0.85000000"
                    },
                    {
                        "id": 49530,
                        "name": "Farnham",
                        "latitude": "51.21444000",
                        "longitude": "-0.80054000"
                    },
                    {
                        "id": 49531,
                        "name": "Farnham Royal",
                        "latitude": "51.54208000",
                        "longitude": "-0.61584000"
                    },
                    {
                        "id": 49532,
                        "name": "Farnsfield",
                        "latitude": "53.10223000",
                        "longitude": "-1.03320000"
                    },
                    {
                        "id": 49533,
                        "name": "Farnworth",
                        "latitude": "53.55000000",
                        "longitude": "-2.40000000"
                    },
                    {
                        "id": 49535,
                        "name": "Faversham",
                        "latitude": "51.31480000",
                        "longitude": "0.88856000"
                    },
                    {
                        "id": 49536,
                        "name": "Fazeley",
                        "latitude": "52.61443000",
                        "longitude": "-1.69850000"
                    },
                    {
                        "id": 49537,
                        "name": "Featherstone",
                        "latitude": "52.64483000",
                        "longitude": "-2.09315000"
                    },
                    {
                        "id": 49538,
                        "name": "Felixstowe",
                        "latitude": "51.96375000",
                        "longitude": "1.35110000"
                    },
                    {
                        "id": 49539,
                        "name": "Felling",
                        "latitude": "54.95297000",
                        "longitude": "-1.57152000"
                    },
                    {
                        "id": 49540,
                        "name": "Feltham",
                        "latitude": "51.44620000",
                        "longitude": "-0.41388000"
                    },
                    {
                        "id": 49541,
                        "name": "Felton",
                        "latitude": "55.29768000",
                        "longitude": "-1.71143000"
                    },
                    {
                        "id": 49542,
                        "name": "Feltwell",
                        "latitude": "52.48581000",
                        "longitude": "0.51945000"
                    },
                    {
                        "id": 49543,
                        "name": "Fenstanton",
                        "latitude": "52.29903000",
                        "longitude": "-0.06712000"
                    },
                    {
                        "id": 49547,
                        "name": "Ferndown",
                        "latitude": "50.80743000",
                        "longitude": "-1.89975000"
                    },
                    {
                        "id": 49548,
                        "name": "Fernhill Heath",
                        "latitude": "52.23002000",
                        "longitude": "-2.19659000"
                    },
                    {
                        "id": 49549,
                        "name": "Fernhurst",
                        "latitude": "51.04873000",
                        "longitude": "-0.71789000"
                    },
                    {
                        "id": 49550,
                        "name": "Ferrybridge",
                        "latitude": "53.71058000",
                        "longitude": "-1.27948000"
                    },
                    {
                        "id": 49551,
                        "name": "Ferryhill",
                        "latitude": "54.68333000",
                        "longitude": "-1.55000000"
                    },
                    {
                        "id": 49553,
                        "name": "Filey",
                        "latitude": "54.21000000",
                        "longitude": "-0.28917000"
                    },
                    {
                        "id": 49554,
                        "name": "Finchampstead",
                        "latitude": "51.36149000",
                        "longitude": "-0.85728000"
                    },
                    {
                        "id": 49555,
                        "name": "Findern",
                        "latitude": "52.87037000",
                        "longitude": "-1.54409000"
                    },
                    {
                        "id": 49557,
                        "name": "Findon",
                        "latitude": "50.86816000",
                        "longitude": "-0.40735000"
                    },
                    {
                        "id": 49558,
                        "name": "Finedon",
                        "latitude": "52.33917000",
                        "longitude": "-0.65008000"
                    },
                    {
                        "id": 49559,
                        "name": "Finningley",
                        "latitude": "53.48696000",
                        "longitude": "-0.99083000"
                    },
                    {
                        "id": 49561,
                        "name": "Fishburn",
                        "latitude": "54.68296000",
                        "longitude": "-1.43631000"
                    },
                    {
                        "id": 49563,
                        "name": "Fishtoft",
                        "latitude": "52.96095000",
                        "longitude": "0.02702000"
                    },
                    {
                        "id": 49564,
                        "name": "Fitzwilliam",
                        "latitude": "53.63288000",
                        "longitude": "-1.37690000"
                    },
                    {
                        "id": 49565,
                        "name": "Five Oak Green",
                        "latitude": "51.18338000",
                        "longitude": "0.35517000"
                    },
                    {
                        "id": 49567,
                        "name": "Flamborough",
                        "latitude": "54.11487000",
                        "longitude": "-0.12274000"
                    },
                    {
                        "id": 49568,
                        "name": "Fleckney",
                        "latitude": "52.53497000",
                        "longitude": "-1.04598000"
                    },
                    {
                        "id": 49569,
                        "name": "Fleet",
                        "latitude": "51.28333000",
                        "longitude": "-0.83333000"
                    },
                    {
                        "id": 49570,
                        "name": "Fleetwood",
                        "latitude": "53.92527000",
                        "longitude": "-3.01085000"
                    },
                    {
                        "id": 49571,
                        "name": "Flexbury",
                        "latitude": "50.83509000",
                        "longitude": "-4.54499000"
                    },
                    {
                        "id": 49572,
                        "name": "Flimby",
                        "latitude": "54.68956000",
                        "longitude": "-3.52092000"
                    },
                    {
                        "id": 49573,
                        "name": "Flimwell",
                        "latitude": "51.05502000",
                        "longitude": "0.44531000"
                    },
                    {
                        "id": 49575,
                        "name": "Flitwick",
                        "latitude": "52.00338000",
                        "longitude": "-0.49472000"
                    },
                    {
                        "id": 49576,
                        "name": "Flockton",
                        "latitude": "53.63034000",
                        "longitude": "-1.63945000"
                    },
                    {
                        "id": 49577,
                        "name": "Flookburgh",
                        "latitude": "54.17415000",
                        "longitude": "-2.97214000"
                    },
                    {
                        "id": 49578,
                        "name": "Flore",
                        "latitude": "52.23647000",
                        "longitude": "-1.05726000"
                    },
                    {
                        "id": 49581,
                        "name": "Folkestone",
                        "latitude": "51.08169000",
                        "longitude": "1.16734000"
                    },
                    {
                        "id": 49582,
                        "name": "Fontwell",
                        "latitude": "50.85520000",
                        "longitude": "-0.64831000"
                    },
                    {
                        "id": 49583,
                        "name": "Ford",
                        "latitude": "52.71693000",
                        "longitude": "-2.86881000"
                    },
                    {
                        "id": 49584,
                        "name": "Fordham",
                        "latitude": "52.31129000",
                        "longitude": "0.39057000"
                    },
                    {
                        "id": 49585,
                        "name": "Fordingbridge",
                        "latitude": "50.92747000",
                        "longitude": "-1.79029000"
                    },
                    {
                        "id": 49586,
                        "name": "Forest Row",
                        "latitude": "51.09641000",
                        "longitude": "0.03262000"
                    },
                    {
                        "id": 49588,
                        "name": "Formby",
                        "latitude": "53.55838000",
                        "longitude": "-3.06999000"
                    },
                    {
                        "id": 49593,
                        "name": "Fortuneswell",
                        "latitude": "50.56030000",
                        "longitude": "-2.44243000"
                    },
                    {
                        "id": 49594,
                        "name": "Foulridge",
                        "latitude": "53.87579000",
                        "longitude": "-2.16864000"
                    },
                    {
                        "id": 49595,
                        "name": "Foulsham",
                        "latitude": "52.78182000",
                        "longitude": "1.01049000"
                    },
                    {
                        "id": 49597,
                        "name": "Four Lanes",
                        "latitude": "50.20163000",
                        "longitude": "-5.24014000"
                    },
                    {
                        "id": 49598,
                        "name": "Four Marks",
                        "latitude": "51.10735000",
                        "longitude": "-1.04945000"
                    },
                    {
                        "id": 49599,
                        "name": "Fowey",
                        "latitude": "50.33634000",
                        "longitude": "-4.63860000"
                    },
                    {
                        "id": 49600,
                        "name": "Fowlmere",
                        "latitude": "52.09343000",
                        "longitude": "0.07433000"
                    },
                    {
                        "id": 49601,
                        "name": "Framlingham",
                        "latitude": "52.22117000",
                        "longitude": "1.34205000"
                    },
                    {
                        "id": 49602,
                        "name": "Frampton on Severn",
                        "latitude": "51.77054000",
                        "longitude": "-2.36382000"
                    },
                    {
                        "id": 49604,
                        "name": "Freckleton",
                        "latitude": "53.75433000",
                        "longitude": "-2.86489000"
                    },
                    {
                        "id": 49605,
                        "name": "Fremington",
                        "latitude": "51.06955000",
                        "longitude": "-4.13660000"
                    },
                    {
                        "id": 49606,
                        "name": "Freshwater",
                        "latitude": "50.68365000",
                        "longitude": "-1.52616000"
                    },
                    {
                        "id": 49608,
                        "name": "Frimley",
                        "latitude": "51.31667000",
                        "longitude": "-0.74544000"
                    },
                    {
                        "id": 49609,
                        "name": "Frinton-on-Sea",
                        "latitude": "51.83061000",
                        "longitude": "1.24424000"
                    },
                    {
                        "id": 49611,
                        "name": "Friston",
                        "latitude": "50.76402000",
                        "longitude": "0.19930000"
                    },
                    {
                        "id": 49612,
                        "name": "Frizington",
                        "latitude": "54.54185000",
                        "longitude": "-3.49460000"
                    },
                    {
                        "id": 49613,
                        "name": "Frodsham",
                        "latitude": "53.29485000",
                        "longitude": "-2.72745000"
                    },
                    {
                        "id": 49614,
                        "name": "Frome",
                        "latitude": "51.22834000",
                        "longitude": "-2.32211000"
                    },
                    {
                        "id": 49615,
                        "name": "Fulbourn",
                        "latitude": "52.18283000",
                        "longitude": "0.22046000"
                    },
                    {
                        "id": 49616,
                        "name": "Full Sutton",
                        "latitude": "53.98869000",
                        "longitude": "-0.86758000"
                    },
                    {
                        "id": 49617,
                        "name": "Furnace Green",
                        "latitude": "51.10742000",
                        "longitude": "-0.16889000"
                    },
                    {
                        "id": 49618,
                        "name": "Fylde",
                        "latitude": "53.83333000",
                        "longitude": "-2.91667000"
                    },
                    {
                        "id": 49620,
                        "name": "Gainford",
                        "latitude": "54.54718000",
                        "longitude": "-1.73601000"
                    },
                    {
                        "id": 49621,
                        "name": "Gainsborough",
                        "latitude": "53.38333000",
                        "longitude": "-0.76667000"
                    },
                    {
                        "id": 49623,
                        "name": "Galgate",
                        "latitude": "53.99362000",
                        "longitude": "-2.79201000"
                    },
                    {
                        "id": 49625,
                        "name": "Gamlingay",
                        "latitude": "52.15561000",
                        "longitude": "-0.19303000"
                    },
                    {
                        "id": 49627,
                        "name": "Garforth",
                        "latitude": "53.79173000",
                        "longitude": "-1.38067000"
                    },
                    {
                        "id": 49628,
                        "name": "Gargrave",
                        "latitude": "53.98353000",
                        "longitude": "-2.10459000"
                    },
                    {
                        "id": 49629,
                        "name": "Garsington",
                        "latitude": "51.71623000",
                        "longitude": "-1.16129000"
                    },
                    {
                        "id": 49630,
                        "name": "Garstang",
                        "latitude": "53.90081000",
                        "longitude": "-2.77417000"
                    },
                    {
                        "id": 49633,
                        "name": "Gateshead",
                        "latitude": "54.93333000",
                        "longitude": "-1.66667000"
                    },
                    {
                        "id": 49634,
                        "name": "Geddington",
                        "latitude": "52.43757000",
                        "longitude": "-0.68965000"
                    },
                    {
                        "id": 49635,
                        "name": "Gedney Hill",
                        "latitude": "52.68434000",
                        "longitude": "-0.02008000"
                    },
                    {
                        "id": 49637,
                        "name": "Germoe",
                        "latitude": "50.11539000",
                        "longitude": "-5.37881000"
                    },
                    {
                        "id": 49638,
                        "name": "Gerrards Cross",
                        "latitude": "51.58610000",
                        "longitude": "-0.55543000"
                    },
                    {
                        "id": 49640,
                        "name": "Gilberdyke",
                        "latitude": "53.75297000",
                        "longitude": "-0.73892000"
                    },
                    {
                        "id": 49643,
                        "name": "Gillingham",
                        "latitude": "51.38914000",
                        "longitude": "0.54863000"
                    },
                    {
                        "id": 49645,
                        "name": "Girton",
                        "latitude": "52.23333000",
                        "longitude": "0.08333000"
                    },
                    {
                        "id": 49649,
                        "name": "Glapwell",
                        "latitude": "53.18917000",
                        "longitude": "-1.28334000"
                    },
                    {
                        "id": 49652,
                        "name": "Glastonbury",
                        "latitude": "51.14745000",
                        "longitude": "-2.72075000"
                    },
                    {
                        "id": 49653,
                        "name": "Glazebury",
                        "latitude": "53.47078000",
                        "longitude": "-2.49823000"
                    },
                    {
                        "id": 49654,
                        "name": "Glemsford",
                        "latitude": "52.10351000",
                        "longitude": "0.66912000"
                    },
                    {
                        "id": 49658,
                        "name": "Glenfield",
                        "latitude": "52.64660000",
                        "longitude": "-1.19493000"
                    },
                    {
                        "id": 49661,
                        "name": "Glinton",
                        "latitude": "52.63921000",
                        "longitude": "-0.29629000"
                    },
                    {
                        "id": 49662,
                        "name": "Glossop",
                        "latitude": "53.44325000",
                        "longitude": "-1.94900000"
                    },
                    {
                        "id": 49663,
                        "name": "Gloucester",
                        "latitude": "51.86568000",
                        "longitude": "-2.24310000"
                    },
                    {
                        "id": 49664,
                        "name": "Gloucestershire",
                        "latitude": "51.83333000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 49665,
                        "name": "Glusburn",
                        "latitude": "53.90000000",
                        "longitude": "-2.00000000"
                    },
                    {
                        "id": 49668,
                        "name": "Gnosall",
                        "latitude": "52.78558000",
                        "longitude": "-2.25483000"
                    },
                    {
                        "id": 49669,
                        "name": "Gobowen",
                        "latitude": "52.89615000",
                        "longitude": "-3.03686000"
                    },
                    {
                        "id": 49670,
                        "name": "Godalming",
                        "latitude": "51.18580000",
                        "longitude": "-0.61489000"
                    },
                    {
                        "id": 49671,
                        "name": "Godmanchester",
                        "latitude": "52.31939000",
                        "longitude": "-0.17509000"
                    },
                    {
                        "id": 49672,
                        "name": "Godshill",
                        "latitude": "50.63308000",
                        "longitude": "-1.25476000"
                    },
                    {
                        "id": 49673,
                        "name": "Godstone",
                        "latitude": "51.24779000",
                        "longitude": "-0.06914000"
                    },
                    {
                        "id": 49674,
                        "name": "Golborne",
                        "latitude": "53.47693000",
                        "longitude": "-2.59651000"
                    },
                    {
                        "id": 49677,
                        "name": "Goole",
                        "latitude": "53.70324000",
                        "longitude": "-0.87732000"
                    },
                    {
                        "id": 49678,
                        "name": "Goosnargh",
                        "latitude": "53.82200000",
                        "longitude": "-2.67017000"
                    },
                    {
                        "id": 49679,
                        "name": "Goostrey",
                        "latitude": "53.22731000",
                        "longitude": "-2.33919000"
                    },
                    {
                        "id": 49681,
                        "name": "Goring",
                        "latitude": "51.52322000",
                        "longitude": "-1.13342000"
                    },
                    {
                        "id": 49682,
                        "name": "Goring-by-Sea",
                        "latitude": "50.81239000",
                        "longitude": "-0.42194000"
                    },
                    {
                        "id": 49683,
                        "name": "Gorleston-on-Sea",
                        "latitude": "52.57301000",
                        "longitude": "1.73069000"
                    },
                    {
                        "id": 49685,
                        "name": "Gosberton",
                        "latitude": "52.86913000",
                        "longitude": "-0.16102000"
                    },
                    {
                        "id": 49686,
                        "name": "Gosfield",
                        "latitude": "51.93657000",
                        "longitude": "0.59197000"
                    },
                    {
                        "id": 49687,
                        "name": "Gosforth",
                        "latitude": "55.00000000",
                        "longitude": "-1.61667000"
                    },
                    {
                        "id": 49688,
                        "name": "Gosport",
                        "latitude": "50.79509000",
                        "longitude": "-1.12902000"
                    },
                    {
                        "id": 49689,
                        "name": "Gossops Green",
                        "latitude": "51.11105000",
                        "longitude": "-0.21728000"
                    },
                    {
                        "id": 49690,
                        "name": "Gotham",
                        "latitude": "52.86799000",
                        "longitude": "-1.20558000"
                    },
                    {
                        "id": 49691,
                        "name": "Goudhurst",
                        "latitude": "51.11314000",
                        "longitude": "0.45615000"
                    },
                    {
                        "id": 49694,
                        "name": "Goxhill",
                        "latitude": "53.67635000",
                        "longitude": "-0.33759000"
                    },
                    {
                        "id": 49695,
                        "name": "Grain",
                        "latitude": "51.45591000",
                        "longitude": "0.71126000"
                    },
                    {
                        "id": 49696,
                        "name": "Grange Hill",
                        "latitude": "51.61185000",
                        "longitude": "0.08612000"
                    },
                    {
                        "id": 49697,
                        "name": "Grange-over-Sands",
                        "latitude": "54.18508000",
                        "longitude": "-2.92488000"
                    },
                    {
                        "id": 49699,
                        "name": "Grantham",
                        "latitude": "52.91149000",
                        "longitude": "-0.64184000"
                    },
                    {
                        "id": 49701,
                        "name": "Grappenhall",
                        "latitude": "53.37204000",
                        "longitude": "-2.54675000"
                    },
                    {
                        "id": 49702,
                        "name": "Grassington",
                        "latitude": "54.07140000",
                        "longitude": "-1.99822000"
                    },
                    {
                        "id": 49703,
                        "name": "Gravesend",
                        "latitude": "51.44206000",
                        "longitude": "0.37106000"
                    },
                    {
                        "id": 49704,
                        "name": "Grays",
                        "latitude": "51.47566000",
                        "longitude": "0.32521000"
                    },
                    {
                        "id": 49705,
                        "name": "Greasby",
                        "latitude": "53.37300000",
                        "longitude": "-3.12330000"
                    },
                    {
                        "id": 49706,
                        "name": "Great Amwell",
                        "latitude": "51.79014000",
                        "longitude": "-0.01669000"
                    },
                    {
                        "id": 49707,
                        "name": "Great Ayton",
                        "latitude": "54.49148000",
                        "longitude": "-1.13623000"
                    },
                    {
                        "id": 49708,
                        "name": "Great Bardfield",
                        "latitude": "51.94813000",
                        "longitude": "0.43645000"
                    },
                    {
                        "id": 49709,
                        "name": "Great Barford",
                        "latitude": "52.15791000",
                        "longitude": "-0.35235000"
                    },
                    {
                        "id": 49710,
                        "name": "Great Barton",
                        "latitude": "52.27257000",
                        "longitude": "0.76679000"
                    },
                    {
                        "id": 49711,
                        "name": "Great Bedwyn",
                        "latitude": "51.37950000",
                        "longitude": "-1.60151000"
                    },
                    {
                        "id": 49712,
                        "name": "Great Bentley",
                        "latitude": "51.85333000",
                        "longitude": "1.06379000"
                    },
                    {
                        "id": 49713,
                        "name": "Great Bookham",
                        "latitude": "51.27916000",
                        "longitude": "-0.37423000"
                    },
                    {
                        "id": 49714,
                        "name": "Great Chesterford",
                        "latitude": "52.06431000",
                        "longitude": "0.19720000"
                    },
                    {
                        "id": 49715,
                        "name": "Great Dunmow",
                        "latitude": "51.87230000",
                        "longitude": "0.36255000"
                    },
                    {
                        "id": 49716,
                        "name": "Great Eccleston",
                        "latitude": "53.85315000",
                        "longitude": "-2.87026000"
                    },
                    {
                        "id": 49717,
                        "name": "Great Glen",
                        "latitude": "52.57548000",
                        "longitude": "-1.03490000"
                    },
                    {
                        "id": 49718,
                        "name": "Great Gonerby",
                        "latitude": "52.93507000",
                        "longitude": "-0.66685000"
                    },
                    {
                        "id": 49719,
                        "name": "Great Gransden",
                        "latitude": "52.18546000",
                        "longitude": "-0.14574000"
                    },
                    {
                        "id": 49720,
                        "name": "Great Hanwood",
                        "latitude": "52.68333000",
                        "longitude": "-2.81667000"
                    },
                    {
                        "id": 49721,
                        "name": "Great Harwood",
                        "latitude": "53.78512000",
                        "longitude": "-2.40865000"
                    },
                    {
                        "id": 49722,
                        "name": "Great Haywood",
                        "latitude": "52.80785000",
                        "longitude": "-2.00024000"
                    },
                    {
                        "id": 49723,
                        "name": "Great Horkesley",
                        "latitude": "51.93821000",
                        "longitude": "0.87551000"
                    },
                    {
                        "id": 49724,
                        "name": "Great Horwood",
                        "latitude": "51.97351000",
                        "longitude": "-0.88088000"
                    },
                    {
                        "id": 49725,
                        "name": "Great Houghton",
                        "latitude": "53.55352000",
                        "longitude": "-1.34952000"
                    },
                    {
                        "id": 49726,
                        "name": "Great Leighs",
                        "latitude": "51.82761000",
                        "longitude": "0.50640000"
                    },
                    {
                        "id": 49727,
                        "name": "Great Malvern",
                        "latitude": "52.11161000",
                        "longitude": "-2.32515000"
                    },
                    {
                        "id": 49728,
                        "name": "Great Marton",
                        "latitude": "53.81185000",
                        "longitude": "-3.02261000"
                    },
                    {
                        "id": 49729,
                        "name": "Great Missenden",
                        "latitude": "51.70419000",
                        "longitude": "-0.70797000"
                    },
                    {
                        "id": 49730,
                        "name": "Great Paxton",
                        "latitude": "52.26057000",
                        "longitude": "-0.22818000"
                    },
                    {
                        "id": 49731,
                        "name": "Great Sankey",
                        "latitude": "53.39234000",
                        "longitude": "-2.63994000"
                    },
                    {
                        "id": 49732,
                        "name": "Great Torrington",
                        "latitude": "50.95309000",
                        "longitude": "-4.14401000"
                    },
                    {
                        "id": 49733,
                        "name": "Great Wakering",
                        "latitude": "51.55242000",
                        "longitude": "0.80380000"
                    },
                    {
                        "id": 49734,
                        "name": "Great Waldingfield",
                        "latitude": "52.05545000",
                        "longitude": "0.77436000"
                    },
                    {
                        "id": 49735,
                        "name": "Great Wyrley",
                        "latitude": "52.66277000",
                        "longitude": "-2.01111000"
                    },
                    {
                        "id": 49736,
                        "name": "Great Yarmouth",
                        "latitude": "52.60831000",
                        "longitude": "1.73052000"
                    },
                    {
                        "id": 49737,
                        "name": "Great Yeldham",
                        "latitude": "52.01347000",
                        "longitude": "0.56540000"
                    },
                    {
                        "id": 49738,
                        "name": "Greater London",
                        "latitude": "51.50000000",
                        "longitude": "-0.16667000"
                    },
                    {
                        "id": 49739,
                        "name": "Greatham",
                        "latitude": "54.64183000",
                        "longitude": "-1.23806000"
                    },
                    {
                        "id": 49741,
                        "name": "Greenfield",
                        "latitude": "52.00278000",
                        "longitude": "-0.46605000"
                    },
                    {
                        "id": 49742,
                        "name": "Greenford",
                        "latitude": "51.52866000",
                        "longitude": "-0.35508000"
                    },
                    {
                        "id": 49744,
                        "name": "Greenhill",
                        "latitude": "51.58342000",
                        "longitude": "-0.33860000"
                    },
                    {
                        "id": 49745,
                        "name": "Greenhithe",
                        "latitude": "51.45026000",
                        "longitude": "0.28539000"
                    },
                    {
                        "id": 49748,
                        "name": "Greetham",
                        "latitude": "52.72059000",
                        "longitude": "-0.63068000"
                    },
                    {
                        "id": 49752,
                        "name": "Grimethorpe",
                        "latitude": "53.57650000",
                        "longitude": "-1.37688000"
                    },
                    {
                        "id": 49753,
                        "name": "Grimsby",
                        "latitude": "53.56539000",
                        "longitude": "-0.07553000"
                    },
                    {
                        "id": 49754,
                        "name": "Grimston",
                        "latitude": "52.77312000",
                        "longitude": "0.54846000"
                    },
                    {
                        "id": 49755,
                        "name": "Griston",
                        "latitude": "52.55720000",
                        "longitude": "0.86436000"
                    },
                    {
                        "id": 49757,
                        "name": "Groombridge",
                        "latitude": "51.11543000",
                        "longitude": "0.18295000"
                    },
                    {
                        "id": 49758,
                        "name": "Grove",
                        "latitude": "51.60954000",
                        "longitude": "-1.42187000"
                    },
                    {
                        "id": 49760,
                        "name": "Grundisburgh",
                        "latitude": "52.11222000",
                        "longitude": "1.24618000"
                    },
                    {
                        "id": 49761,
                        "name": "Guilden Sutton",
                        "latitude": "53.20809000",
                        "longitude": "-2.82984000"
                    },
                    {
                        "id": 49762,
                        "name": "Guildford",
                        "latitude": "51.23536000",
                        "longitude": "-0.57427000"
                    },
                    {
                        "id": 49764,
                        "name": "Guisborough",
                        "latitude": "54.53478000",
                        "longitude": "-1.05606000"
                    },
                    {
                        "id": 49765,
                        "name": "Guiseley",
                        "latitude": "53.87561000",
                        "longitude": "-1.71232000"
                    },
                    {
                        "id": 49767,
                        "name": "Gunness",
                        "latitude": "53.59080000",
                        "longitude": "-0.72834000"
                    },
                    {
                        "id": 49768,
                        "name": "Gunnislake",
                        "latitude": "50.52441000",
                        "longitude": "-4.21333000"
                    },
                    {
                        "id": 49770,
                        "name": "Hackleton",
                        "latitude": "52.18798000",
                        "longitude": "-0.82312000"
                    },
                    {
                        "id": 49771,
                        "name": "Haddenham",
                        "latitude": "51.77326000",
                        "longitude": "-0.92628000"
                    },
                    {
                        "id": 49773,
                        "name": "Hadleigh",
                        "latitude": "51.55269000",
                        "longitude": "0.60983000"
                    },
                    {
                        "id": 49774,
                        "name": "Hadley",
                        "latitude": "52.70000000",
                        "longitude": "-2.48333000"
                    },
                    {
                        "id": 49775,
                        "name": "Hadley Wood",
                        "latitude": "51.66669000",
                        "longitude": "-0.16981000"
                    },
                    {
                        "id": 49776,
                        "name": "Hadlow",
                        "latitude": "51.22417000",
                        "longitude": "0.33914000"
                    },
                    {
                        "id": 49777,
                        "name": "Hadston",
                        "latitude": "55.29428000",
                        "longitude": "-1.60392000"
                    },
                    {
                        "id": 49778,
                        "name": "Hagley",
                        "latitude": "52.42620000",
                        "longitude": "-2.12819000"
                    },
                    {
                        "id": 49779,
                        "name": "Hailsham",
                        "latitude": "50.86220000",
                        "longitude": "0.25775000"
                    },
                    {
                        "id": 49780,
                        "name": "Hainault",
                        "latitude": "51.60836000",
                        "longitude": "0.10716000"
                    },
                    {
                        "id": 49781,
                        "name": "Hale",
                        "latitude": "53.37831000",
                        "longitude": "-2.33271000"
                    },
                    {
                        "id": 49782,
                        "name": "Halesowen",
                        "latitude": "52.44859000",
                        "longitude": "-2.04938000"
                    },
                    {
                        "id": 49783,
                        "name": "Halesworth",
                        "latitude": "52.34640000",
                        "longitude": "1.50290000"
                    },
                    {
                        "id": 49784,
                        "name": "Halifax",
                        "latitude": "53.71667000",
                        "longitude": "-1.85000000"
                    },
                    {
                        "id": 49787,
                        "name": "Halling",
                        "latitude": "51.35142000",
                        "longitude": "0.44520000"
                    },
                    {
                        "id": 49788,
                        "name": "Hallow",
                        "latitude": "52.22344000",
                        "longitude": "-2.25468000"
                    },
                    {
                        "id": 49789,
                        "name": "Halstead",
                        "latitude": "51.94506000",
                        "longitude": "0.63927000"
                    },
                    {
                        "id": 49790,
                        "name": "Halton",
                        "latitude": "53.31667000",
                        "longitude": "-2.70000000"
                    },
                    {
                        "id": 49791,
                        "name": "Haltwhistle",
                        "latitude": "54.97101000",
                        "longitude": "-2.45682000"
                    },
                    {
                        "id": 49792,
                        "name": "Hamble-le-Rice",
                        "latitude": "50.85966000",
                        "longitude": "-1.32432000"
                    },
                    {
                        "id": 49793,
                        "name": "Hambleton",
                        "latitude": "53.76667000",
                        "longitude": "-1.16667000"
                    },
                    {
                        "id": 49794,
                        "name": "Hameldon Hill",
                        "latitude": "53.75570000",
                        "longitude": "-2.29190000"
                    },
                    {
                        "id": 49796,
                        "name": "Hampshire",
                        "latitude": "51.00000000",
                        "longitude": "-1.25000000"
                    },
                    {
                        "id": 49797,
                        "name": "Hampton",
                        "latitude": "51.41334000",
                        "longitude": "-0.36701000"
                    },
                    {
                        "id": 49798,
                        "name": "Hampton in Arden",
                        "latitude": "52.42540000",
                        "longitude": "-1.70271000"
                    },
                    {
                        "id": 49799,
                        "name": "Handcross",
                        "latitude": "51.05383000",
                        "longitude": "-0.20076000"
                    },
                    {
                        "id": 49800,
                        "name": "Hannington",
                        "latitude": "51.63333000",
                        "longitude": "-1.75000000"
                    },
                    {
                        "id": 49801,
                        "name": "Hanslope",
                        "latitude": "52.11425000",
                        "longitude": "-0.82672000"
                    },
                    {
                        "id": 49802,
                        "name": "Hapton",
                        "latitude": "53.78333000",
                        "longitude": "-2.31667000"
                    },
                    {
                        "id": 49803,
                        "name": "Harbury",
                        "latitude": "52.23537000",
                        "longitude": "-1.45706000"
                    },
                    {
                        "id": 49804,
                        "name": "Hardingstone",
                        "latitude": "52.21358000",
                        "longitude": "-0.88582000"
                    },
                    {
                        "id": 49805,
                        "name": "Hardwick Village",
                        "latitude": "53.27372000",
                        "longitude": "-1.04320000"
                    },
                    {
                        "id": 49806,
                        "name": "Harefield",
                        "latitude": "51.60333000",
                        "longitude": "-0.48546000"
                    },
                    {
                        "id": 49808,
                        "name": "Harleston",
                        "latitude": "52.40302000",
                        "longitude": "1.29664000"
                    },
                    {
                        "id": 49809,
                        "name": "Harlington",
                        "latitude": "51.96288000",
                        "longitude": "-0.49241000"
                    },
                    {
                        "id": 49810,
                        "name": "Harlow",
                        "latitude": "51.77655000",
                        "longitude": "0.11158000"
                    },
                    {
                        "id": 49811,
                        "name": "Harold Wood",
                        "latitude": "51.59462000",
                        "longitude": "0.23294000"
                    },
                    {
                        "id": 49812,
                        "name": "Harpenden",
                        "latitude": "51.81684000",
                        "longitude": "-0.35706000"
                    },
                    {
                        "id": 49813,
                        "name": "Harpole",
                        "latitude": "52.24246000",
                        "longitude": "-0.98937000"
                    },
                    {
                        "id": 49814,
                        "name": "Harrietsham",
                        "latitude": "51.24252000",
                        "longitude": "0.67060000"
                    },
                    {
                        "id": 49815,
                        "name": "Harringay",
                        "latitude": "51.58240000",
                        "longitude": "-0.09956000"
                    },
                    {
                        "id": 49816,
                        "name": "Harrogate",
                        "latitude": "53.99078000",
                        "longitude": "-1.53730000"
                    },
                    {
                        "id": 49817,
                        "name": "Harrold",
                        "latitude": "52.20127000",
                        "longitude": "-0.61038000"
                    },
                    {
                        "id": 49818,
                        "name": "Harrow on the Hill",
                        "latitude": "51.57142000",
                        "longitude": "-0.33371000"
                    },
                    {
                        "id": 49819,
                        "name": "Harston",
                        "latitude": "52.13691000",
                        "longitude": "0.07999000"
                    },
                    {
                        "id": 49820,
                        "name": "Harthill",
                        "latitude": "53.31667000",
                        "longitude": "-1.26667000"
                    },
                    {
                        "id": 49822,
                        "name": "Hartlebury",
                        "latitude": "52.33333000",
                        "longitude": "-2.23333000"
                    },
                    {
                        "id": 49823,
                        "name": "Hartlepool",
                        "latitude": "54.66667000",
                        "longitude": "-1.25000000"
                    },
                    {
                        "id": 49824,
                        "name": "Hartley",
                        "latitude": "51.38673000",
                        "longitude": "0.30367000"
                    },
                    {
                        "id": 49825,
                        "name": "Hartley Wintney",
                        "latitude": "51.30379000",
                        "longitude": "-0.90019000"
                    },
                    {
                        "id": 49826,
                        "name": "Hartshill",
                        "latitude": "52.54831000",
                        "longitude": "-1.52221000"
                    },
                    {
                        "id": 49827,
                        "name": "Hartwell",
                        "latitude": "52.14616000",
                        "longitude": "-0.85376000"
                    },
                    {
                        "id": 49828,
                        "name": "Harvington",
                        "latitude": "52.14095000",
                        "longitude": "-1.92313000"
                    },
                    {
                        "id": 49829,
                        "name": "Harwell",
                        "latitude": "51.59947000",
                        "longitude": "-1.29175000"
                    },
                    {
                        "id": 49830,
                        "name": "Harwich",
                        "latitude": "51.94194000",
                        "longitude": "1.28437000"
                    },
                    {
                        "id": 49831,
                        "name": "Haslemere",
                        "latitude": "51.09015000",
                        "longitude": "-0.70785000"
                    },
                    {
                        "id": 49832,
                        "name": "Haslingden",
                        "latitude": "53.70326000",
                        "longitude": "-2.32382000"
                    },
                    {
                        "id": 49833,
                        "name": "Haslingfield",
                        "latitude": "52.15016000",
                        "longitude": "0.05579000"
                    },
                    {
                        "id": 49834,
                        "name": "Hassocks",
                        "latitude": "50.92814000",
                        "longitude": "-0.16617000"
                    },
                    {
                        "id": 49835,
                        "name": "Hastings",
                        "latitude": "50.85519000",
                        "longitude": "0.57292000"
                    },
                    {
                        "id": 49836,
                        "name": "Haswell",
                        "latitude": "54.78333000",
                        "longitude": "-1.41667000"
                    },
                    {
                        "id": 49837,
                        "name": "Hatfield",
                        "latitude": "51.76338000",
                        "longitude": "-0.22419000"
                    },
                    {
                        "id": 49838,
                        "name": "Hatfield Heath",
                        "latitude": "51.81233000",
                        "longitude": "0.21243000"
                    },
                    {
                        "id": 49839,
                        "name": "Hatfield Peverel",
                        "latitude": "51.77591000",
                        "longitude": "0.59489000"
                    },
                    {
                        "id": 49840,
                        "name": "Hatherleigh",
                        "latitude": "50.82144000",
                        "longitude": "-4.07228000"
                    },
                    {
                        "id": 49841,
                        "name": "Hathern",
                        "latitude": "52.79548000",
                        "longitude": "-1.25644000"
                    },
                    {
                        "id": 49842,
                        "name": "Hathersage",
                        "latitude": "53.33030000",
                        "longitude": "-1.65398000"
                    },
                    {
                        "id": 49843,
                        "name": "Hatton",
                        "latitude": "52.30007000",
                        "longitude": "-1.63260000"
                    },
                    {
                        "id": 49844,
                        "name": "Haughley",
                        "latitude": "52.21907000",
                        "longitude": "0.96800000"
                    },
                    {
                        "id": 49845,
                        "name": "Haughton Green",
                        "latitude": "53.44118000",
                        "longitude": "-2.09827000"
                    },
                    {
                        "id": 49846,
                        "name": "Havant",
                        "latitude": "50.85670000",
                        "longitude": "-0.98559000"
                    },
                    {
                        "id": 49848,
                        "name": "Haverhill",
                        "latitude": "52.08226000",
                        "longitude": "0.43891000"
                    },
                    {
                        "id": 49849,
                        "name": "Haverigg",
                        "latitude": "54.19973000",
                        "longitude": "-3.29263000"
                    },
                    {
                        "id": 49852,
                        "name": "Hawkhurst",
                        "latitude": "51.04790000",
                        "longitude": "0.51095000"
                    },
                    {
                        "id": 49853,
                        "name": "Hawkinge",
                        "latitude": "51.11276000",
                        "longitude": "1.16176000"
                    },
                    {
                        "id": 49854,
                        "name": "Haworth",
                        "latitude": "53.82905000",
                        "longitude": "-1.94827000"
                    },
                    {
                        "id": 49855,
                        "name": "Hawthorn",
                        "latitude": "54.80000000",
                        "longitude": "-1.35000000"
                    },
                    {
                        "id": 49856,
                        "name": "Haxby",
                        "latitude": "54.01422000",
                        "longitude": "-1.07121000"
                    },
                    {
                        "id": 49857,
                        "name": "Haxey",
                        "latitude": "53.48937000",
                        "longitude": "-0.84020000"
                    },
                    {
                        "id": 49859,
                        "name": "Haydock",
                        "latitude": "53.46723000",
                        "longitude": "-2.68166000"
                    },
                    {
                        "id": 49860,
                        "name": "Haydon Bridge",
                        "latitude": "54.97486000",
                        "longitude": "-2.24680000"
                    },
                    {
                        "id": 49861,
                        "name": "Hayes",
                        "latitude": "51.51579000",
                        "longitude": "-0.42340000"
                    },
                    {
                        "id": 49862,
                        "name": "Hayfield",
                        "latitude": "53.37893000",
                        "longitude": "-1.94544000"
                    },
                    {
                        "id": 49863,
                        "name": "Hayle",
                        "latitude": "50.18392000",
                        "longitude": "-5.42137000"
                    },
                    {
                        "id": 49864,
                        "name": "Hayling Island",
                        "latitude": "50.78380000",
                        "longitude": "-0.96869000"
                    },
                    {
                        "id": 49865,
                        "name": "Haynes",
                        "latitude": "52.06646000",
                        "longitude": "-0.39946000"
                    },
                    {
                        "id": 49866,
                        "name": "Hayton",
                        "latitude": "53.90000000",
                        "longitude": "-0.75000000"
                    },
                    {
                        "id": 49867,
                        "name": "Haywards Heath",
                        "latitude": "50.99769000",
                        "longitude": "-0.10313000"
                    },
                    {
                        "id": 49868,
                        "name": "Hazel Grove",
                        "latitude": "53.38333000",
                        "longitude": "-2.11667000"
                    },
                    {
                        "id": 49869,
                        "name": "Hazlerigg",
                        "latitude": "55.04135000",
                        "longitude": "-1.63912000"
                    },
                    {
                        "id": 49870,
                        "name": "Heacham",
                        "latitude": "52.90782000",
                        "longitude": "0.49387000"
                    },
                    {
                        "id": 49872,
                        "name": "Headcorn",
                        "latitude": "51.16966000",
                        "longitude": "0.62433000"
                    },
                    {
                        "id": 49873,
                        "name": "Heage",
                        "latitude": "53.05050000",
                        "longitude": "-1.44688000"
                    },
                    {
                        "id": 49874,
                        "name": "Healing",
                        "latitude": "53.58101000",
                        "longitude": "-0.16202000"
                    },
                    {
                        "id": 49875,
                        "name": "Heanor",
                        "latitude": "53.01372000",
                        "longitude": "-1.35383000"
                    },
                    {
                        "id": 49876,
                        "name": "Heath and Reach",
                        "latitude": "51.94517000",
                        "longitude": "-0.65697000"
                    },
                    {
                        "id": 49877,
                        "name": "Heathfield",
                        "latitude": "50.96718000",
                        "longitude": "0.25612000"
                    },
                    {
                        "id": 49878,
                        "name": "Heaton Chapel",
                        "latitude": "53.43015000",
                        "longitude": "-2.17538000"
                    },
                    {
                        "id": 49879,
                        "name": "Heavitree",
                        "latitude": "50.72044000",
                        "longitude": "-3.49646000"
                    },
                    {
                        "id": 49880,
                        "name": "Hebburn",
                        "latitude": "54.97302000",
                        "longitude": "-1.51546000"
                    },
                    {
                        "id": 49881,
                        "name": "Hebden Bridge",
                        "latitude": "53.74093000",
                        "longitude": "-2.01337000"
                    },
                    {
                        "id": 49882,
                        "name": "Heckington",
                        "latitude": "52.98183000",
                        "longitude": "-0.29903000"
                    },
                    {
                        "id": 49883,
                        "name": "Heckmondwike",
                        "latitude": "53.70646000",
                        "longitude": "-1.67747000"
                    },
                    {
                        "id": 49884,
                        "name": "Heddon on the Wall",
                        "latitude": "54.99692000",
                        "longitude": "-1.79386000"
                    },
                    {
                        "id": 49885,
                        "name": "Hedge End",
                        "latitude": "50.91234000",
                        "longitude": "-1.30076000"
                    },
                    {
                        "id": 49886,
                        "name": "Hedon",
                        "latitude": "53.73962000",
                        "longitude": "-0.19655000"
                    },
                    {
                        "id": 49887,
                        "name": "Heighington",
                        "latitude": "53.21241000",
                        "longitude": "-0.45902000"
                    },
                    {
                        "id": 49889,
                        "name": "Hellaby",
                        "latitude": "53.42257000",
                        "longitude": "-1.24125000"
                    },
                    {
                        "id": 49890,
                        "name": "Hellifield",
                        "latitude": "54.00486000",
                        "longitude": "-2.22302000"
                    },
                    {
                        "id": 49891,
                        "name": "Helmsley",
                        "latitude": "54.24577000",
                        "longitude": "-1.05683000"
                    },
                    {
                        "id": 49892,
                        "name": "Helpston",
                        "latitude": "52.63233000",
                        "longitude": "-0.34676000"
                    },
                    {
                        "id": 49893,
                        "name": "Helsby",
                        "latitude": "53.27396000",
                        "longitude": "-2.76905000"
                    },
                    {
                        "id": 49894,
                        "name": "Helston",
                        "latitude": "50.10319000",
                        "longitude": "-5.27045000"
                    },
                    {
                        "id": 49895,
                        "name": "Hemel Hempstead",
                        "latitude": "51.75368000",
                        "longitude": "-0.44975000"
                    },
                    {
                        "id": 49896,
                        "name": "Hemingbrough",
                        "latitude": "53.76863000",
                        "longitude": "-0.97673000"
                    },
                    {
                        "id": 49897,
                        "name": "Hemingford Grey",
                        "latitude": "52.31756000",
                        "longitude": "-0.10029000"
                    },
                    {
                        "id": 49898,
                        "name": "Hemsby",
                        "latitude": "52.69714000",
                        "longitude": "1.69181000"
                    },
                    {
                        "id": 49899,
                        "name": "Hemsworth",
                        "latitude": "53.61267000",
                        "longitude": "-1.35424000"
                    },
                    {
                        "id": 49900,
                        "name": "Hemyock",
                        "latitude": "50.91234000",
                        "longitude": "-3.22807000"
                    },
                    {
                        "id": 49901,
                        "name": "Henfield",
                        "latitude": "50.92995000",
                        "longitude": "-0.27071000"
                    },
                    {
                        "id": 49903,
                        "name": "Henley in Arden",
                        "latitude": "52.29032000",
                        "longitude": "-1.77807000"
                    },
                    {
                        "id": 49904,
                        "name": "Henley-on-Thames",
                        "latitude": "51.53333000",
                        "longitude": "-0.90000000"
                    },
                    {
                        "id": 49906,
                        "name": "Henlow",
                        "latitude": "52.03021000",
                        "longitude": "-0.28599000"
                    },
                    {
                        "id": 49907,
                        "name": "Henstridge",
                        "latitude": "50.97717000",
                        "longitude": "-2.39500000"
                    },
                    {
                        "id": 49908,
                        "name": "Hereford",
                        "latitude": "52.05684000",
                        "longitude": "-2.71482000"
                    },
                    {
                        "id": 49909,
                        "name": "Herefordshire",
                        "latitude": "52.08333000",
                        "longitude": "-2.75000000"
                    },
                    {
                        "id": 49910,
                        "name": "Hermitage",
                        "latitude": "51.45540000",
                        "longitude": "-1.26823000"
                    },
                    {
                        "id": 49911,
                        "name": "Herne Bay",
                        "latitude": "51.37300000",
                        "longitude": "1.12857000"
                    },
                    {
                        "id": 49912,
                        "name": "Herstmonceux",
                        "latitude": "50.88958000",
                        "longitude": "0.32290000"
                    },
                    {
                        "id": 49913,
                        "name": "Hertford",
                        "latitude": "51.79588000",
                        "longitude": "-0.07854000"
                    },
                    {
                        "id": 49914,
                        "name": "Hertfordshire",
                        "latitude": "51.83333000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 49915,
                        "name": "Heswall",
                        "latitude": "53.32733000",
                        "longitude": "-3.09648000"
                    },
                    {
                        "id": 49916,
                        "name": "Hethersett",
                        "latitude": "52.59761000",
                        "longitude": "1.17359000"
                    },
                    {
                        "id": 49917,
                        "name": "Hetton-Le-Hole",
                        "latitude": "54.81667000",
                        "longitude": "-1.45000000"
                    },
                    {
                        "id": 49918,
                        "name": "Hexham",
                        "latitude": "54.96986000",
                        "longitude": "-2.10400000"
                    },
                    {
                        "id": 49919,
                        "name": "Heysham",
                        "latitude": "54.04367000",
                        "longitude": "-2.89322000"
                    },
                    {
                        "id": 49920,
                        "name": "Heywood",
                        "latitude": "53.59245000",
                        "longitude": "-2.21941000"
                    },
                    {
                        "id": 49921,
                        "name": "Hibaldstow",
                        "latitude": "53.51133000",
                        "longitude": "-0.52082000"
                    },
                    {
                        "id": 49922,
                        "name": "High Barnet",
                        "latitude": "51.65621000",
                        "longitude": "-0.20768000"
                    },
                    {
                        "id": 49923,
                        "name": "High Bentham",
                        "latitude": "54.11823000",
                        "longitude": "-2.51199000"
                    },
                    {
                        "id": 49925,
                        "name": "High Etherley",
                        "latitude": "54.65391000",
                        "longitude": "-1.74363000"
                    },
                    {
                        "id": 49926,
                        "name": "High Halden",
                        "latitude": "51.10331000",
                        "longitude": "0.71394000"
                    },
                    {
                        "id": 49927,
                        "name": "High Halstow",
                        "latitude": "51.44775000",
                        "longitude": "0.55558000"
                    },
                    {
                        "id": 49928,
                        "name": "High Legh",
                        "latitude": "53.35139000",
                        "longitude": "-2.45380000"
                    },
                    {
                        "id": 49929,
                        "name": "High Ongar",
                        "latitude": "51.70953000",
                        "longitude": "0.26221000"
                    },
                    {
                        "id": 49930,
                        "name": "High Peak",
                        "latitude": "53.36797000",
                        "longitude": "-1.84536000"
                    },
                    {
                        "id": 49932,
                        "name": "High Wycombe",
                        "latitude": "51.62907000",
                        "longitude": "-0.74934000"
                    },
                    {
                        "id": 49933,
                        "name": "Higham Ferrers",
                        "latitude": "52.30596000",
                        "longitude": "-0.59342000"
                    },
                    {
                        "id": 49934,
                        "name": "Highbridge",
                        "latitude": "51.21667000",
                        "longitude": "-2.98333000"
                    },
                    {
                        "id": 49935,
                        "name": "Highclere",
                        "latitude": "51.33860000",
                        "longitude": "-1.37569000"
                    },
                    {
                        "id": 49937,
                        "name": "Highley",
                        "latitude": "52.44866000",
                        "longitude": "-2.38251000"
                    },
                    {
                        "id": 49938,
                        "name": "Hightown",
                        "latitude": "53.52452000",
                        "longitude": "-3.06192000"
                    },
                    {
                        "id": 49939,
                        "name": "Highworth",
                        "latitude": "51.63051000",
                        "longitude": "-1.71100000"
                    },
                    {
                        "id": 49942,
                        "name": "Hilton",
                        "latitude": "52.27908000",
                        "longitude": "-0.11222000"
                    },
                    {
                        "id": 49943,
                        "name": "Hinchley Wood",
                        "latitude": "51.37461000",
                        "longitude": "-0.33838000"
                    },
                    {
                        "id": 49944,
                        "name": "Hinckley",
                        "latitude": "52.53890000",
                        "longitude": "-1.37613000"
                    },
                    {
                        "id": 49945,
                        "name": "Hindhead",
                        "latitude": "51.11381000",
                        "longitude": "-0.73351000"
                    },
                    {
                        "id": 49946,
                        "name": "Hindley",
                        "latitude": "53.53333000",
                        "longitude": "-2.58333000"
                    },
                    {
                        "id": 49947,
                        "name": "Hindon",
                        "latitude": "51.09222000",
                        "longitude": "-2.12583000"
                    },
                    {
                        "id": 49948,
                        "name": "Hingham",
                        "latitude": "52.57969000",
                        "longitude": "0.98422000"
                    },
                    {
                        "id": 49949,
                        "name": "Hinton",
                        "latitude": "52.16798000",
                        "longitude": "-1.21837000"
                    },
                    {
                        "id": 49951,
                        "name": "Histon",
                        "latitude": "52.25166000",
                        "longitude": "0.10643000"
                    },
                    {
                        "id": 49952,
                        "name": "Hitchin",
                        "latitude": "51.94924000",
                        "longitude": "-0.28496000"
                    },
                    {
                        "id": 49953,
                        "name": "Hockley",
                        "latitude": "52.50000000",
                        "longitude": "-1.91667000"
                    },
                    {
                        "id": 49954,
                        "name": "Hockley Heath",
                        "latitude": "52.35294000",
                        "longitude": "-1.77816000"
                    },
                    {
                        "id": 49955,
                        "name": "Hockliffe",
                        "latitude": "51.93109000",
                        "longitude": "-0.58652000"
                    },
                    {
                        "id": 49956,
                        "name": "Hockwold cum Wilton",
                        "latitude": "52.46380000",
                        "longitude": "0.54614000"
                    },
                    {
                        "id": 49957,
                        "name": "Hoddesdon",
                        "latitude": "51.76148000",
                        "longitude": "-0.01144000"
                    },
                    {
                        "id": 49958,
                        "name": "Holbeach",
                        "latitude": "52.80401000",
                        "longitude": "0.01442000"
                    },
                    {
                        "id": 49959,
                        "name": "Holbeck",
                        "latitude": "53.78359000",
                        "longitude": "-1.56791000"
                    },
                    {
                        "id": 49960,
                        "name": "Holbrook",
                        "latitude": "51.98340000",
                        "longitude": "1.15854000"
                    },
                    {
                        "id": 49961,
                        "name": "Hollingworth",
                        "latitude": "53.46300000",
                        "longitude": "-1.99100000"
                    },
                    {
                        "id": 49962,
                        "name": "Holloway",
                        "latitude": "51.55237000",
                        "longitude": "-0.12497000"
                    },
                    {
                        "id": 49963,
                        "name": "Hollym",
                        "latitude": "53.70402000",
                        "longitude": "0.04008000"
                    },
                    {
                        "id": 49964,
                        "name": "Holmes Chapel",
                        "latitude": "53.20140000",
                        "longitude": "-2.35742000"
                    },
                    {
                        "id": 49965,
                        "name": "Holmfirth",
                        "latitude": "53.56968000",
                        "longitude": "-1.78777000"
                    },
                    {
                        "id": 49966,
                        "name": "Holmwood",
                        "latitude": "51.18049000",
                        "longitude": "-0.32176000"
                    },
                    {
                        "id": 49967,
                        "name": "Holsworthy",
                        "latitude": "50.81196000",
                        "longitude": "-4.35383000"
                    },
                    {
                        "id": 49968,
                        "name": "Holt",
                        "latitude": "51.35556000",
                        "longitude": "-2.19722000"
                    },
                    {
                        "id": 49969,
                        "name": "Holtby",
                        "latitude": "53.97876000",
                        "longitude": "-0.97255000"
                    },
                    {
                        "id": 49970,
                        "name": "Holton le Clay",
                        "latitude": "53.50520000",
                        "longitude": "-0.06300000"
                    },
                    {
                        "id": 49974,
                        "name": "Holywell Green",
                        "latitude": "53.67406000",
                        "longitude": "-1.86682000"
                    },
                    {
                        "id": 49976,
                        "name": "Honeybourne",
                        "latitude": "52.09513000",
                        "longitude": "-1.83129000"
                    },
                    {
                        "id": 49977,
                        "name": "Honiton",
                        "latitude": "50.79960000",
                        "longitude": "-3.18899000"
                    },
                    {
                        "id": 49978,
                        "name": "Hoo",
                        "latitude": "51.42050000",
                        "longitude": "0.56300000"
                    },
                    {
                        "id": 49979,
                        "name": "Hook",
                        "latitude": "51.36803000",
                        "longitude": "-0.30650000"
                    },
                    {
                        "id": 49981,
                        "name": "Hook Norton",
                        "latitude": "51.99564000",
                        "longitude": "-1.48277000"
                    },
                    {
                        "id": 49982,
                        "name": "Hoole",
                        "latitude": "53.19980000",
                        "longitude": "-2.87689000"
                    },
                    {
                        "id": 49984,
                        "name": "Hope Valley",
                        "latitude": "53.34819000",
                        "longitude": "-1.74485000"
                    },
                    {
                        "id": 49986,
                        "name": "Hopton on Sea",
                        "latitude": "52.53333000",
                        "longitude": "1.73333000"
                    },
                    {
                        "id": 49987,
                        "name": "Horam",
                        "latitude": "50.93523000",
                        "longitude": "0.24436000"
                    },
                    {
                        "id": 49988,
                        "name": "Horbury",
                        "latitude": "53.66051000",
                        "longitude": "-1.56014000"
                    },
                    {
                        "id": 49989,
                        "name": "Horley",
                        "latitude": "51.17423000",
                        "longitude": "-0.15919000"
                    },
                    {
                        "id": 49990,
                        "name": "Horncastle",
                        "latitude": "53.20775000",
                        "longitude": "-0.11720000"
                    },
                    {
                        "id": 49991,
                        "name": "Hornchurch",
                        "latitude": "51.55685000",
                        "longitude": "0.21664000"
                    },
                    {
                        "id": 49992,
                        "name": "Horndon on the Hill",
                        "latitude": "51.52358000",
                        "longitude": "0.40491000"
                    },
                    {
                        "id": 49993,
                        "name": "Horning",
                        "latitude": "52.70460000",
                        "longitude": "1.46294000"
                    },
                    {
                        "id": 49994,
                        "name": "Hornsea",
                        "latitude": "53.91041000",
                        "longitude": "-0.16806000"
                    },
                    {
                        "id": 49995,
                        "name": "Horrabridge",
                        "latitude": "50.50843000",
                        "longitude": "-4.10042000"
                    },
                    {
                        "id": 49996,
                        "name": "Horsford",
                        "latitude": "52.70153000",
                        "longitude": "1.24015000"
                    },
                    {
                        "id": 49997,
                        "name": "Horsforth",
                        "latitude": "53.84260000",
                        "longitude": "-1.63754000"
                    },
                    {
                        "id": 49998,
                        "name": "Horsham",
                        "latitude": "51.06314000",
                        "longitude": "-0.32757000"
                    },
                    {
                        "id": 49999,
                        "name": "Horsmonden",
                        "latitude": "51.13908000",
                        "longitude": "0.42881000"
                    },
                    {
                        "id": 50000,
                        "name": "Horsted Keynes",
                        "latitude": "51.03659000",
                        "longitude": "-0.02798000"
                    },
                    {
                        "id": 50001,
                        "name": "Horton",
                        "latitude": "51.47315000",
                        "longitude": "-0.54245000"
                    },
                    {
                        "id": 50002,
                        "name": "Horton Kirby",
                        "latitude": "51.39481000",
                        "longitude": "0.24483000"
                    },
                    {
                        "id": 50003,
                        "name": "Horwich",
                        "latitude": "53.60126000",
                        "longitude": "-2.54975000"
                    },
                    {
                        "id": 50004,
                        "name": "Hotham",
                        "latitude": "53.79583000",
                        "longitude": "-0.64253000"
                    },
                    {
                        "id": 50005,
                        "name": "Houghton",
                        "latitude": "52.33282000",
                        "longitude": "-0.12068000"
                    },
                    {
                        "id": 50006,
                        "name": "Houghton Conquest",
                        "latitude": "52.06178000",
                        "longitude": "-0.47756000"
                    },
                    {
                        "id": 50007,
                        "name": "Houghton on the Hill",
                        "latitude": "52.62663000",
                        "longitude": "-0.99546000"
                    },
                    {
                        "id": 50008,
                        "name": "Houghton-Le-Spring",
                        "latitude": "54.84034000",
                        "longitude": "-1.46427000"
                    },
                    {
                        "id": 50009,
                        "name": "Hounslow",
                        "latitude": "51.46839000",
                        "longitude": "-0.36092000"
                    },
                    {
                        "id": 50011,
                        "name": "Hove",
                        "latitude": "50.83088000",
                        "longitude": "-0.16720000"
                    },
                    {
                        "id": 50012,
                        "name": "Hoveton",
                        "latitude": "52.71490000",
                        "longitude": "1.41054000"
                    },
                    {
                        "id": 50013,
                        "name": "Howden",
                        "latitude": "53.74630000",
                        "longitude": "-0.86994000"
                    },
                    {
                        "id": 50015,
                        "name": "Hoylake",
                        "latitude": "53.39046000",
                        "longitude": "-3.18066000"
                    },
                    {
                        "id": 50016,
                        "name": "Hoyland Nether",
                        "latitude": "53.50000000",
                        "longitude": "-1.45000000"
                    },
                    {
                        "id": 50017,
                        "name": "Hucknall",
                        "latitude": "53.03333000",
                        "longitude": "-1.20000000"
                    },
                    {
                        "id": 50018,
                        "name": "Huddersfield",
                        "latitude": "53.64904000",
                        "longitude": "-1.78416000"
                    },
                    {
                        "id": 50019,
                        "name": "Hugh Town",
                        "latitude": "49.91447000",
                        "longitude": "-6.31145000"
                    },
                    {
                        "id": 50020,
                        "name": "Hulme",
                        "latitude": "53.46572000",
                        "longitude": "-2.24885000"
                    },
                    {
                        "id": 50021,
                        "name": "Humberston",
                        "latitude": "53.53036000",
                        "longitude": "-0.02465000"
                    },
                    {
                        "id": 50023,
                        "name": "Hungerford",
                        "latitude": "51.41513000",
                        "longitude": "-1.51556000"
                    },
                    {
                        "id": 50024,
                        "name": "Hunmanby",
                        "latitude": "54.17957000",
                        "longitude": "-0.32007000"
                    },
                    {
                        "id": 50025,
                        "name": "Hunstanton",
                        "latitude": "52.95000000",
                        "longitude": "0.50000000"
                    },
                    {
                        "id": 50026,
                        "name": "Huntingdon",
                        "latitude": "52.33049000",
                        "longitude": "-0.18651000"
                    },
                    {
                        "id": 50027,
                        "name": "Huntley",
                        "latitude": "51.87172000",
                        "longitude": "-2.40137000"
                    },
                    {
                        "id": 50029,
                        "name": "Huntspill",
                        "latitude": "51.20562000",
                        "longitude": "-2.98735000"
                    },
                    {
                        "id": 50030,
                        "name": "Hunwick",
                        "latitude": "54.68791000",
                        "longitude": "-1.70539000"
                    },
                    {
                        "id": 50031,
                        "name": "Hurst",
                        "latitude": "51.45791000",
                        "longitude": "-0.85196000"
                    },
                    {
                        "id": 50032,
                        "name": "Hurstpierpoint",
                        "latitude": "50.93388000",
                        "longitude": "-0.18007000"
                    },
                    {
                        "id": 50033,
                        "name": "Husbands Bosworth",
                        "latitude": "52.45232000",
                        "longitude": "-1.05557000"
                    },
                    {
                        "id": 50034,
                        "name": "Husborne Crawley",
                        "latitude": "52.01637000",
                        "longitude": "-0.61056000"
                    },
                    {
                        "id": 50035,
                        "name": "Huyton",
                        "latitude": "53.41150000",
                        "longitude": "-2.83935000"
                    },
                    {
                        "id": 50036,
                        "name": "Hyde",
                        "latitude": "53.45131000",
                        "longitude": "-2.07943000"
                    },
                    {
                        "id": 50037,
                        "name": "Hyde Heath",
                        "latitude": "51.69336000",
                        "longitude": "-0.65437000"
                    },
                    {
                        "id": 50038,
                        "name": "Hythe",
                        "latitude": "50.86004000",
                        "longitude": "-1.40162000"
                    },
                    {
                        "id": 50039,
                        "name": "Ibstock",
                        "latitude": "52.68554000",
                        "longitude": "-1.39965000"
                    },
                    {
                        "id": 50040,
                        "name": "Ilchester",
                        "latitude": "51.00587000",
                        "longitude": "-2.67981000"
                    },
                    {
                        "id": 50041,
                        "name": "Ilfracombe",
                        "latitude": "51.20930000",
                        "longitude": "-4.11344000"
                    },
                    {
                        "id": 50042,
                        "name": "Ilkeston",
                        "latitude": "52.97055000",
                        "longitude": "-1.30951000"
                    },
                    {
                        "id": 50043,
                        "name": "Ilkley",
                        "latitude": "53.92449000",
                        "longitude": "-1.82326000"
                    },
                    {
                        "id": 50044,
                        "name": "Ilminster",
                        "latitude": "50.92684000",
                        "longitude": "-2.91009000"
                    },
                    {
                        "id": 50045,
                        "name": "Immingham",
                        "latitude": "53.61239000",
                        "longitude": "-0.22219000"
                    },
                    {
                        "id": 50046,
                        "name": "Ince Blundell",
                        "latitude": "53.52429000",
                        "longitude": "-3.02733000"
                    },
                    {
                        "id": 50047,
                        "name": "Ince-in-Makerfield",
                        "latitude": "53.53333000",
                        "longitude": "-2.61667000"
                    },
                    {
                        "id": 50050,
                        "name": "Ingatestone",
                        "latitude": "51.67027000",
                        "longitude": "0.38359000"
                    },
                    {
                        "id": 50051,
                        "name": "Ingleby Greenhow",
                        "latitude": "54.44983000",
                        "longitude": "-1.10687000"
                    },
                    {
                        "id": 50052,
                        "name": "Ingleton",
                        "latitude": "54.15392000",
                        "longitude": "-2.46849000"
                    },
                    {
                        "id": 50053,
                        "name": "Ingoldmells",
                        "latitude": "53.19414000",
                        "longitude": "0.33358000"
                    },
                    {
                        "id": 50054,
                        "name": "Ingrave",
                        "latitude": "51.60416000",
                        "longitude": "0.34058000"
                    },
                    {
                        "id": 50055,
                        "name": "Inkberrow",
                        "latitude": "52.21284000",
                        "longitude": "-1.98093000"
                    },
                    {
                        "id": 50066,
                        "name": "Ipplepen",
                        "latitude": "50.48919000",
                        "longitude": "-3.63900000"
                    },
                    {
                        "id": 50067,
                        "name": "Ipswich",
                        "latitude": "52.05917000",
                        "longitude": "1.15545000"
                    },
                    {
                        "id": 50068,
                        "name": "Irchester",
                        "latitude": "52.28108000",
                        "longitude": "-0.64510000"
                    },
                    {
                        "id": 50069,
                        "name": "Irlam",
                        "latitude": "53.44253000",
                        "longitude": "-2.42323000"
                    },
                    {
                        "id": 50070,
                        "name": "Ironbridge",
                        "latitude": "52.62795000",
                        "longitude": "-2.48465000"
                    },
                    {
                        "id": 50071,
                        "name": "Irthlingborough",
                        "latitude": "52.32674000",
                        "longitude": "-0.61129000"
                    },
                    {
                        "id": 50082,
                        "name": "Isle of Wight",
                        "latitude": "50.66667000",
                        "longitude": "-1.33333000"
                    },
                    {
                        "id": 50083,
                        "name": "Isleham",
                        "latitude": "52.34289000",
                        "longitude": "0.41212000"
                    },
                    {
                        "id": 50084,
                        "name": "Isles of Scilly",
                        "latitude": "49.92117000",
                        "longitude": "-6.29431000"
                    },
                    {
                        "id": 50085,
                        "name": "Isleworth",
                        "latitude": "51.47518000",
                        "longitude": "-0.34246000"
                    },
                    {
                        "id": 50086,
                        "name": "Islington",
                        "latitude": "51.53622000",
                        "longitude": "-0.10304000"
                    },
                    {
                        "id": 50087,
                        "name": "Iver",
                        "latitude": "51.50000000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 50088,
                        "name": "Iver Heath",
                        "latitude": "51.53642000",
                        "longitude": "-0.51790000"
                    },
                    {
                        "id": 50089,
                        "name": "Ivinghoe",
                        "latitude": "51.83602000",
                        "longitude": "-0.62983000"
                    },
                    {
                        "id": 50090,
                        "name": "Ivybridge",
                        "latitude": "50.39039000",
                        "longitude": "-3.91914000"
                    },
                    {
                        "id": 50091,
                        "name": "Iwade",
                        "latitude": "51.37754000",
                        "longitude": "0.72935000"
                    },
                    {
                        "id": 50092,
                        "name": "Ixworth",
                        "latitude": "52.29893000",
                        "longitude": "0.83410000"
                    },
                    {
                        "id": 50093,
                        "name": "Jarrow",
                        "latitude": "54.98036000",
                        "longitude": "-1.48423000"
                    },
                    {
                        "id": 50098,
                        "name": "Keadby",
                        "latitude": "53.59308000",
                        "longitude": "-0.74021000"
                    },
                    {
                        "id": 50100,
                        "name": "Kearsley",
                        "latitude": "53.53333000",
                        "longitude": "-2.38333000"
                    },
                    {
                        "id": 50101,
                        "name": "Kedington",
                        "latitude": "52.09282000",
                        "longitude": "0.48675000"
                    },
                    {
                        "id": 50102,
                        "name": "Keelby",
                        "latitude": "53.57580000",
                        "longitude": "-0.24701000"
                    },
                    {
                        "id": 50103,
                        "name": "Keele",
                        "latitude": "53.00382000",
                        "longitude": "-2.28741000"
                    },
                    {
                        "id": 50104,
                        "name": "Kegworth",
                        "latitude": "52.83482000",
                        "longitude": "-1.28042000"
                    },
                    {
                        "id": 50105,
                        "name": "Keighley",
                        "latitude": "53.86791000",
                        "longitude": "-1.90664000"
                    },
                    {
                        "id": 50107,
                        "name": "Kelloe",
                        "latitude": "54.71894000",
                        "longitude": "-1.47495000"
                    },
                    {
                        "id": 50108,
                        "name": "Kelsall",
                        "latitude": "53.20775000",
                        "longitude": "-2.71242000"
                    },
                    {
                        "id": 50111,
                        "name": "Kelvedon",
                        "latitude": "51.84007000",
                        "longitude": "0.70570000"
                    },
                    {
                        "id": 50112,
                        "name": "Kelvedon Hatch",
                        "latitude": "51.66739000",
                        "longitude": "0.26814000"
                    },
                    {
                        "id": 50114,
                        "name": "Kempsey",
                        "latitude": "52.13936000",
                        "longitude": "-2.21751000"
                    },
                    {
                        "id": 50115,
                        "name": "Kempston",
                        "latitude": "52.11599000",
                        "longitude": "-0.50044000"
                    },
                    {
                        "id": 50116,
                        "name": "Kempston Hardwick",
                        "latitude": "52.08956000",
                        "longitude": "-0.49908000"
                    },
                    {
                        "id": 50117,
                        "name": "Kemsing",
                        "latitude": "51.30604000",
                        "longitude": "0.22917000"
                    },
                    {
                        "id": 50118,
                        "name": "Kendal",
                        "latitude": "54.32681000",
                        "longitude": "-2.74757000"
                    },
                    {
                        "id": 50119,
                        "name": "Kenilworth",
                        "latitude": "52.34958000",
                        "longitude": "-1.58276000"
                    },
                    {
                        "id": 50120,
                        "name": "Kennington",
                        "latitude": "51.16740000",
                        "longitude": "0.88491000"
                    },
                    {
                        "id": 50122,
                        "name": "Kensworth",
                        "latitude": "51.85173000",
                        "longitude": "-0.50386000"
                    },
                    {
                        "id": 50123,
                        "name": "Kent",
                        "latitude": "51.16667000",
                        "longitude": "0.66667000"
                    },
                    {
                        "id": 50124,
                        "name": "Kenton",
                        "latitude": "50.63978000",
                        "longitude": "-3.47151000"
                    },
                    {
                        "id": 50125,
                        "name": "Keresley",
                        "latitude": "52.45156000",
                        "longitude": "-1.53319000"
                    },
                    {
                        "id": 50126,
                        "name": "Kesgrave",
                        "latitude": "52.06241000",
                        "longitude": "1.23650000"
                    },
                    {
                        "id": 50127,
                        "name": "Kessingland",
                        "latitude": "52.41987000",
                        "longitude": "1.70878000"
                    },
                    {
                        "id": 50128,
                        "name": "Keswick",
                        "latitude": "54.59947000",
                        "longitude": "-3.13256000"
                    },
                    {
                        "id": 50129,
                        "name": "Kettering",
                        "latitude": "52.39836000",
                        "longitude": "-0.72571000"
                    },
                    {
                        "id": 50130,
                        "name": "Ketton",
                        "latitude": "52.62804000",
                        "longitude": "-0.55459000"
                    },
                    {
                        "id": 50131,
                        "name": "Keyingham",
                        "latitude": "53.70961000",
                        "longitude": "-0.11325000"
                    },
                    {
                        "id": 50132,
                        "name": "Keynsham",
                        "latitude": "51.41387000",
                        "longitude": "-2.49780000"
                    },
                    {
                        "id": 50133,
                        "name": "Keyworth",
                        "latitude": "52.87122000",
                        "longitude": "-1.08991000"
                    },
                    {
                        "id": 50134,
                        "name": "Kibworth Harcourt",
                        "latitude": "52.54439000",
                        "longitude": "-0.99491000"
                    },
                    {
                        "id": 50135,
                        "name": "Kidderminster",
                        "latitude": "52.38819000",
                        "longitude": "-2.25000000"
                    },
                    {
                        "id": 50136,
                        "name": "Kidlington",
                        "latitude": "51.82166000",
                        "longitude": "-1.28860000"
                    },
                    {
                        "id": 50137,
                        "name": "Kidsgrove",
                        "latitude": "53.08691000",
                        "longitude": "-2.23777000"
                    },
                    {
                        "id": 50141,
                        "name": "Kilburn",
                        "latitude": "53.00580000",
                        "longitude": "-1.43869000"
                    },
                    {
                        "id": 50144,
                        "name": "Kilham",
                        "latitude": "54.06413000",
                        "longitude": "-0.38057000"
                    },
                    {
                        "id": 50146,
                        "name": "Killamarsh",
                        "latitude": "53.32395000",
                        "longitude": "-1.31688000"
                    },
                    {
                        "id": 50153,
                        "name": "Kilsby",
                        "latitude": "52.33375000",
                        "longitude": "-1.17505000"
                    },
                    {
                        "id": 50156,
                        "name": "Kimberley",
                        "latitude": "52.98333000",
                        "longitude": "-1.26667000"
                    },
                    {
                        "id": 50157,
                        "name": "Kimbolton",
                        "latitude": "52.29704000",
                        "longitude": "-0.38916000"
                    },
                    {
                        "id": 50158,
                        "name": "Kimpton",
                        "latitude": "51.85089000",
                        "longitude": "-0.29980000"
                    },
                    {
                        "id": 50160,
                        "name": "Kineton",
                        "latitude": "52.15645000",
                        "longitude": "-1.51148000"
                    },
                    {
                        "id": 50161,
                        "name": "King's Clipstone",
                        "latitude": "53.17690000",
                        "longitude": "-1.10129000"
                    },
                    {
                        "id": 50162,
                        "name": "King's Lynn",
                        "latitude": "52.75172000",
                        "longitude": "0.39516000"
                    },
                    {
                        "id": 50165,
                        "name": "Kings Hill",
                        "latitude": "51.27437000",
                        "longitude": "0.40237000"
                    },
                    {
                        "id": 50166,
                        "name": "Kings Langley",
                        "latitude": "51.71395000",
                        "longitude": "-0.45044000"
                    },
                    {
                        "id": 50167,
                        "name": "Kings Sutton",
                        "latitude": "52.02313000",
                        "longitude": "-1.27613000"
                    },
                    {
                        "id": 50168,
                        "name": "Kings Worthy",
                        "latitude": "51.08862000",
                        "longitude": "-1.29780000"
                    },
                    {
                        "id": 50169,
                        "name": "Kingsbridge",
                        "latitude": "50.28451000",
                        "longitude": "-3.77638000"
                    },
                    {
                        "id": 50170,
                        "name": "Kingsbury",
                        "latitude": "52.56106000",
                        "longitude": "-1.67936000"
                    },
                    {
                        "id": 50171,
                        "name": "Kingsclere",
                        "latitude": "51.32487000",
                        "longitude": "-1.24339000"
                    },
                    {
                        "id": 50172,
                        "name": "Kingskerswell",
                        "latitude": "50.49915000",
                        "longitude": "-3.58195000"
                    },
                    {
                        "id": 50174,
                        "name": "Kingsland",
                        "latitude": "52.24911000",
                        "longitude": "-2.81542000"
                    },
                    {
                        "id": 50175,
                        "name": "Kingsley",
                        "latitude": "53.26667000",
                        "longitude": "-2.66667000"
                    },
                    {
                        "id": 50176,
                        "name": "Kingsteignton",
                        "latitude": "50.55000000",
                        "longitude": "-3.58333000"
                    },
                    {
                        "id": 50177,
                        "name": "Kingston Bagpuize",
                        "latitude": "51.68150000",
                        "longitude": "-1.42041000"
                    },
                    {
                        "id": 50178,
                        "name": "Kingston Seymour",
                        "latitude": "51.39833000",
                        "longitude": "-2.86111000"
                    },
                    {
                        "id": 50179,
                        "name": "Kingston upon Hull",
                        "latitude": "53.74460000",
                        "longitude": "-0.33525000"
                    },
                    {
                        "id": 50180,
                        "name": "Kingston upon Thames",
                        "latitude": "51.41259000",
                        "longitude": "-0.29740000"
                    },
                    {
                        "id": 50182,
                        "name": "Kingswinford",
                        "latitude": "52.49755000",
                        "longitude": "-2.16889000"
                    },
                    {
                        "id": 50183,
                        "name": "Kingswood",
                        "latitude": "51.45278000",
                        "longitude": "-2.50833000"
                    },
                    {
                        "id": 50184,
                        "name": "Kington",
                        "latitude": "52.20000000",
                        "longitude": "-2.01667000"
                    },
                    {
                        "id": 50188,
                        "name": "Kintbury",
                        "latitude": "51.39958000",
                        "longitude": "-1.44865000"
                    },
                    {
                        "id": 50190,
                        "name": "Kinvere",
                        "latitude": "52.45000000",
                        "longitude": "-2.23333000"
                    },
                    {
                        "id": 50191,
                        "name": "Kippax",
                        "latitude": "53.76687000",
                        "longitude": "-1.37099000"
                    },
                    {
                        "id": 50193,
                        "name": "Kirby Muxloe",
                        "latitude": "52.63025000",
                        "longitude": "-1.22755000"
                    },
                    {
                        "id": 50195,
                        "name": "Kirk Sandall",
                        "latitude": "53.56211000",
                        "longitude": "-1.06876000"
                    },
                    {
                        "id": 50196,
                        "name": "Kirkburton",
                        "latitude": "53.61047000",
                        "longitude": "-1.70292000"
                    },
                    {
                        "id": 50197,
                        "name": "Kirkby",
                        "latitude": "53.48138000",
                        "longitude": "-2.89215000"
                    },
                    {
                        "id": 50200,
                        "name": "Kirkby in Ashfield",
                        "latitude": "53.09982000",
                        "longitude": "-1.24379000"
                    },
                    {
                        "id": 50198,
                        "name": "Kirkby Lonsdale",
                        "latitude": "54.20259000",
                        "longitude": "-2.59827000"
                    },
                    {
                        "id": 50199,
                        "name": "Kirkby Stephen",
                        "latitude": "54.47229000",
                        "longitude": "-2.34865000"
                    },
                    {
                        "id": 50201,
                        "name": "Kirkbymoorside",
                        "latitude": "54.27014000",
                        "longitude": "-0.93218000"
                    },
                    {
                        "id": 50205,
                        "name": "Kirkham",
                        "latitude": "53.78244000",
                        "longitude": "-2.87189000"
                    },
                    {
                        "id": 50207,
                        "name": "Kirklees",
                        "latitude": "53.58333000",
                        "longitude": "-1.75000000"
                    },
                    {
                        "id": 50212,
                        "name": "Kirton",
                        "latitude": "52.92774000",
                        "longitude": "-0.06008000"
                    },
                    {
                        "id": 50213,
                        "name": "Kirton in Lindsey",
                        "latitude": "53.47548000",
                        "longitude": "-0.59566000"
                    },
                    {
                        "id": 50214,
                        "name": "Kislingbury",
                        "latitude": "52.22976000",
                        "longitude": "-0.97914000"
                    },
                    {
                        "id": 50215,
                        "name": "Kiveton Park",
                        "latitude": "53.34120000",
                        "longitude": "-1.25498000"
                    },
                    {
                        "id": 50216,
                        "name": "Knaphill",
                        "latitude": "51.32010000",
                        "longitude": "-0.61584000"
                    },
                    {
                        "id": 50217,
                        "name": "Knaresborough",
                        "latitude": "54.00910000",
                        "longitude": "-1.46851000"
                    },
                    {
                        "id": 50218,
                        "name": "Knebworth",
                        "latitude": "51.86674000",
                        "longitude": "-0.18394000"
                    },
                    {
                        "id": 50220,
                        "name": "Knottingley",
                        "latitude": "53.70778000",
                        "longitude": "-1.25639000"
                    },
                    {
                        "id": 50221,
                        "name": "Knowle",
                        "latitude": "52.38333000",
                        "longitude": "-1.73333000"
                    },
                    {
                        "id": 50222,
                        "name": "Knowsley",
                        "latitude": "53.41667000",
                        "longitude": "-2.83333000"
                    },
                    {
                        "id": 50223,
                        "name": "Knutsford",
                        "latitude": "53.30289000",
                        "longitude": "-2.37482000"
                    },
                    {
                        "id": 50224,
                        "name": "Laceby",
                        "latitude": "53.54092000",
                        "longitude": "-0.16830000"
                    },
                    {
                        "id": 50225,
                        "name": "Lacock",
                        "latitude": "51.41528000",
                        "longitude": "-2.12194000"
                    },
                    {
                        "id": 50227,
                        "name": "Lakenheath",
                        "latitude": "52.41755000",
                        "longitude": "0.52211000"
                    },
                    {
                        "id": 50228,
                        "name": "Lamberhurst",
                        "latitude": "51.10050000",
                        "longitude": "0.38967000"
                    },
                    {
                        "id": 50229,
                        "name": "Lambeth",
                        "latitude": "51.49635000",
                        "longitude": "-0.11152000"
                    },
                    {
                        "id": 50230,
                        "name": "Lambourn",
                        "latitude": "51.50805000",
                        "longitude": "-1.53105000"
                    },
                    {
                        "id": 50231,
                        "name": "Lamesley",
                        "latitude": "54.91567000",
                        "longitude": "-1.60945000"
                    },
                    {
                        "id": 50235,
                        "name": "Lancashire",
                        "latitude": "53.83333000",
                        "longitude": "-2.50000000"
                    },
                    {
                        "id": 50236,
                        "name": "Lancaster",
                        "latitude": "54.04649000",
                        "longitude": "-2.79988000"
                    },
                    {
                        "id": 50237,
                        "name": "Lanchester",
                        "latitude": "54.82108000",
                        "longitude": "-1.74256000"
                    },
                    {
                        "id": 50238,
                        "name": "Lancing",
                        "latitude": "50.82882000",
                        "longitude": "-0.32247000"
                    },
                    {
                        "id": 50239,
                        "name": "Landrake",
                        "latitude": "50.42265000",
                        "longitude": "-4.29023000"
                    },
                    {
                        "id": 50240,
                        "name": "Langford",
                        "latitude": "52.05460000",
                        "longitude": "-0.27165000"
                    },
                    {
                        "id": 50241,
                        "name": "Langham",
                        "latitude": "52.69152000",
                        "longitude": "-0.75385000"
                    },
                    {
                        "id": 50242,
                        "name": "Langho",
                        "latitude": "53.80217000",
                        "longitude": "-2.45076000"
                    },
                    {
                        "id": 50244,
                        "name": "Langley Green",
                        "latitude": "51.12817000",
                        "longitude": "-0.19835000"
                    },
                    {
                        "id": 50245,
                        "name": "Langley Park",
                        "latitude": "54.79979000",
                        "longitude": "-1.67005000"
                    },
                    {
                        "id": 50246,
                        "name": "Langport",
                        "latitude": "51.03778000",
                        "longitude": "-2.82806000"
                    },
                    {
                        "id": 50247,
                        "name": "Langtoft",
                        "latitude": "52.69834000",
                        "longitude": "-0.34040000"
                    },
                    {
                        "id": 50250,
                        "name": "Lark Hill",
                        "latitude": "51.20000000",
                        "longitude": "-1.81667000"
                    },
                    {
                        "id": 50251,
                        "name": "Larkfield",
                        "latitude": "51.30143000",
                        "longitude": "0.44855000"
                    },
                    {
                        "id": 50254,
                        "name": "Latchingdon and Snoreham",
                        "latitude": "51.67160000",
                        "longitude": "0.72578000"
                    },
                    {
                        "id": 50256,
                        "name": "Launceston",
                        "latitude": "50.63699000",
                        "longitude": "-4.36006000"
                    },
                    {
                        "id": 50259,
                        "name": "Lavendon",
                        "latitude": "52.17279000",
                        "longitude": "-0.66109000"
                    },
                    {
                        "id": 50260,
                        "name": "Lavenham",
                        "latitude": "52.10861000",
                        "longitude": "0.79617000"
                    },
                    {
                        "id": 50262,
                        "name": "Layer de la Haye",
                        "latitude": "51.84593000",
                        "longitude": "0.85745000"
                    },
                    {
                        "id": 50263,
                        "name": "Leasingham",
                        "latitude": "53.02573000",
                        "longitude": "-0.42606000"
                    },
                    {
                        "id": 50264,
                        "name": "Leatherhead",
                        "latitude": "51.29652000",
                        "longitude": "-0.33380000"
                    },
                    {
                        "id": 50265,
                        "name": "Lechlade",
                        "latitude": "51.69403000",
                        "longitude": "-1.69128000"
                    },
                    {
                        "id": 50266,
                        "name": "Leconfield",
                        "latitude": "53.87730000",
                        "longitude": "-0.45729000"
                    },
                    {
                        "id": 50267,
                        "name": "Ledbury",
                        "latitude": "52.03639000",
                        "longitude": "-2.42635000"
                    },
                    {
                        "id": 50268,
                        "name": "Ledsham",
                        "latitude": "53.76322000",
                        "longitude": "-1.30857000"
                    },
                    {
                        "id": 50269,
                        "name": "Lee-on-the-Solent",
                        "latitude": "50.80169000",
                        "longitude": "-1.20174000"
                    },
                    {
                        "id": 50270,
                        "name": "Leeds",
                        "latitude": "53.79648000",
                        "longitude": "-1.54785000"
                    },
                    {
                        "id": 50271,
                        "name": "Leek",
                        "latitude": "53.10434000",
                        "longitude": "-2.02207000"
                    },
                    {
                        "id": 50272,
                        "name": "Leek Wootton",
                        "latitude": "52.31782000",
                        "longitude": "-1.57933000"
                    },
                    {
                        "id": 50274,
                        "name": "Leicester",
                        "latitude": "52.63860000",
                        "longitude": "-1.13169000"
                    },
                    {
                        "id": 50275,
                        "name": "Leicestershire",
                        "latitude": "52.66667000",
                        "longitude": "-1.00000000"
                    },
                    {
                        "id": 50276,
                        "name": "Leigh",
                        "latitude": "53.49642000",
                        "longitude": "-2.51973000"
                    },
                    {
                        "id": 50277,
                        "name": "Leighton Buzzard",
                        "latitude": "51.91722000",
                        "longitude": "-0.65802000"
                    },
                    {
                        "id": 50278,
                        "name": "Leiston",
                        "latitude": "52.20611000",
                        "longitude": "1.57757000"
                    },
                    {
                        "id": 50279,
                        "name": "Lenham",
                        "latitude": "51.23705000",
                        "longitude": "0.71892000"
                    },
                    {
                        "id": 50282,
                        "name": "Leominster",
                        "latitude": "52.22583000",
                        "longitude": "-2.74491000"
                    },
                    {
                        "id": 50284,
                        "name": "Lesbury",
                        "latitude": "55.39832000",
                        "longitude": "-1.62830000"
                    },
                    {
                        "id": 50287,
                        "name": "Letchworth",
                        "latitude": "51.97944000",
                        "longitude": "-0.22840000"
                    },
                    {
                        "id": 50288,
                        "name": "Letchworth Garden City",
                        "latitude": "51.97938000",
                        "longitude": "-0.22664000"
                    },
                    {
                        "id": 50293,
                        "name": "Leven",
                        "latitude": "53.89028000",
                        "longitude": "-0.31783000"
                    },
                    {
                        "id": 50294,
                        "name": "Lewes",
                        "latitude": "50.87398000",
                        "longitude": "0.00880000"
                    },
                    {
                        "id": 50295,
                        "name": "Leyburn",
                        "latitude": "54.31004000",
                        "longitude": "-1.83041000"
                    },
                    {
                        "id": 50296,
                        "name": "Leyland",
                        "latitude": "53.69786000",
                        "longitude": "-2.68758000"
                    },
                    {
                        "id": 50297,
                        "name": "Leysdown-on-Sea",
                        "latitude": "51.39730000",
                        "longitude": "0.92156000"
                    },
                    {
                        "id": 50299,
                        "name": "Lichfield",
                        "latitude": "52.68154000",
                        "longitude": "-1.82549000"
                    },
                    {
                        "id": 50300,
                        "name": "Lidlington",
                        "latitude": "52.04154000",
                        "longitude": "-0.55914000"
                    },
                    {
                        "id": 50301,
                        "name": "Lifton",
                        "latitude": "50.64356000",
                        "longitude": "-4.28216000"
                    },
                    {
                        "id": 50302,
                        "name": "Lightwater",
                        "latitude": "51.34846000",
                        "longitude": "-0.67147000"
                    },
                    {
                        "id": 50305,
                        "name": "Limpley Stoke",
                        "latitude": "51.34487000",
                        "longitude": "-2.31409000"
                    },
                    {
                        "id": 50306,
                        "name": "Lincoln",
                        "latitude": "53.22683000",
                        "longitude": "-0.53792000"
                    },
                    {
                        "id": 50307,
                        "name": "Lincolnshire",
                        "latitude": "53.16667000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 50308,
                        "name": "Lingdale",
                        "latitude": "54.53787000",
                        "longitude": "-0.95864000"
                    },
                    {
                        "id": 50309,
                        "name": "Lingfield",
                        "latitude": "51.17719000",
                        "longitude": "-0.01558000"
                    },
                    {
                        "id": 50310,
                        "name": "Lingwood",
                        "latitude": "52.62104000",
                        "longitude": "1.48616000"
                    },
                    {
                        "id": 50312,
                        "name": "Linthwaite",
                        "latitude": "53.62418000",
                        "longitude": "-1.85017000"
                    },
                    {
                        "id": 50313,
                        "name": "Linton",
                        "latitude": "52.09783000",
                        "longitude": "0.27672000"
                    },
                    {
                        "id": 50314,
                        "name": "Linton upon Ouse",
                        "latitude": "54.04639000",
                        "longitude": "-1.24920000"
                    },
                    {
                        "id": 50316,
                        "name": "Liphook",
                        "latitude": "51.07673000",
                        "longitude": "-0.80320000"
                    },
                    {
                        "id": 50319,
                        "name": "Liskeard",
                        "latitude": "50.45450000",
                        "longitude": "-4.46517000"
                    },
                    {
                        "id": 50321,
                        "name": "Liss",
                        "latitude": "51.04277000",
                        "longitude": "-0.89238000"
                    },
                    {
                        "id": 50322,
                        "name": "Litherland",
                        "latitude": "53.46993000",
                        "longitude": "-2.99809000"
                    },
                    {
                        "id": 50323,
                        "name": "Little Amwell",
                        "latitude": "51.78333000",
                        "longitude": "-0.03333000"
                    },
                    {
                        "id": 50324,
                        "name": "Little Chalfont",
                        "latitude": "51.66829000",
                        "longitude": "-0.57038000"
                    },
                    {
                        "id": 50325,
                        "name": "Little Clacton",
                        "latitude": "51.82557000",
                        "longitude": "1.14215000"
                    },
                    {
                        "id": 50326,
                        "name": "Little Dunmow",
                        "latitude": "51.86096000",
                        "longitude": "0.41478000"
                    },
                    {
                        "id": 50327,
                        "name": "Little Eaton",
                        "latitude": "52.97028000",
                        "longitude": "-1.45950000"
                    },
                    {
                        "id": 50328,
                        "name": "Little Hallingbury",
                        "latitude": "51.83324000",
                        "longitude": "0.18151000"
                    },
                    {
                        "id": 50329,
                        "name": "Little Hulton",
                        "latitude": "53.53333000",
                        "longitude": "-2.41667000"
                    },
                    {
                        "id": 50330,
                        "name": "Little Lever",
                        "latitude": "53.56346000",
                        "longitude": "-2.37803000"
                    },
                    {
                        "id": 50331,
                        "name": "Little Paxton",
                        "latitude": "52.25045000",
                        "longitude": "-0.25801000"
                    },
                    {
                        "id": 50332,
                        "name": "Little Weighton",
                        "latitude": "53.79021000",
                        "longitude": "-0.50679000"
                    },
                    {
                        "id": 50333,
                        "name": "Littleborough",
                        "latitude": "53.64413000",
                        "longitude": "-2.09581000"
                    },
                    {
                        "id": 50334,
                        "name": "Littlebourne",
                        "latitude": "51.27445000",
                        "longitude": "1.16687000"
                    },
                    {
                        "id": 50335,
                        "name": "Littlehampton",
                        "latitude": "50.81137000",
                        "longitude": "-0.54078000"
                    },
                    {
                        "id": 50336,
                        "name": "Littleport",
                        "latitude": "52.45784000",
                        "longitude": "0.30603000"
                    },
                    {
                        "id": 50337,
                        "name": "Liverpool",
                        "latitude": "53.41058000",
                        "longitude": "-2.97794000"
                    },
                    {
                        "id": 50338,
                        "name": "Liversedge",
                        "latitude": "53.70514000",
                        "longitude": "-1.69327000"
                    },
                    {
                        "id": 50382,
                        "name": "Locking",
                        "latitude": "51.33327000",
                        "longitude": "-2.91387000"
                    },
                    {
                        "id": 50383,
                        "name": "Lockington",
                        "latitude": "53.91415000",
                        "longitude": "-0.48572000"
                    },
                    {
                        "id": 50384,
                        "name": "Loddon",
                        "latitude": "52.53270000",
                        "longitude": "1.48183000"
                    },
                    {
                        "id": 50385,
                        "name": "Lofthouse",
                        "latitude": "53.72947000",
                        "longitude": "-1.49697000"
                    },
                    {
                        "id": 50386,
                        "name": "Loftus",
                        "latitude": "54.55543000",
                        "longitude": "-0.89459000"
                    },
                    {
                        "id": 50388,
                        "name": "London",
                        "latitude": "51.50853000",
                        "longitude": "-0.12574000"
                    },
                    {
                        "id": 50390,
                        "name": "Long Ashton",
                        "latitude": "51.42997000",
                        "longitude": "-2.66098000"
                    },
                    {
                        "id": 50391,
                        "name": "Long Bennington",
                        "latitude": "52.99314000",
                        "longitude": "-0.75803000"
                    },
                    {
                        "id": 50392,
                        "name": "Long Buckby",
                        "latitude": "52.30260000",
                        "longitude": "-1.08113000"
                    },
                    {
                        "id": 50393,
                        "name": "Long Clawson",
                        "latitude": "52.83725000",
                        "longitude": "-0.92880000"
                    },
                    {
                        "id": 50394,
                        "name": "Long Crendon",
                        "latitude": "51.77294000",
                        "longitude": "-0.99684000"
                    },
                    {
                        "id": 50395,
                        "name": "Long Eaton",
                        "latitude": "52.89855000",
                        "longitude": "-1.27136000"
                    },
                    {
                        "id": 50396,
                        "name": "Long Itchington",
                        "latitude": "52.28396000",
                        "longitude": "-1.39243000"
                    },
                    {
                        "id": 50397,
                        "name": "Long Lawford",
                        "latitude": "52.38176000",
                        "longitude": "-1.30716000"
                    },
                    {
                        "id": 50398,
                        "name": "Long Melford",
                        "latitude": "52.07481000",
                        "longitude": "0.71639000"
                    },
                    {
                        "id": 50399,
                        "name": "Long Stratton",
                        "latitude": "52.48803000",
                        "longitude": "1.23478000"
                    },
                    {
                        "id": 50400,
                        "name": "Long Sutton",
                        "latitude": "51.21978000",
                        "longitude": "-0.94293000"
                    },
                    {
                        "id": 50401,
                        "name": "Long Whatton",
                        "latitude": "52.80577000",
                        "longitude": "-1.28506000"
                    },
                    {
                        "id": 50402,
                        "name": "Longdendale",
                        "latitude": "53.46667000",
                        "longitude": "-2.00000000"
                    },
                    {
                        "id": 50403,
                        "name": "Longfield",
                        "latitude": "51.39690000",
                        "longitude": "0.30212000"
                    },
                    {
                        "id": 50405,
                        "name": "Longhope",
                        "latitude": "51.86667000",
                        "longitude": "-2.45000000"
                    },
                    {
                        "id": 50406,
                        "name": "Longhorsley",
                        "latitude": "55.24586000",
                        "longitude": "-1.76914000"
                    },
                    {
                        "id": 50407,
                        "name": "Longhoughton",
                        "latitude": "55.43131000",
                        "longitude": "-1.61691000"
                    },
                    {
                        "id": 50409,
                        "name": "Longridge",
                        "latitude": "53.83212000",
                        "longitude": "-2.59964000"
                    },
                    {
                        "id": 50410,
                        "name": "Longsight",
                        "latitude": "53.45801000",
                        "longitude": "-2.20104000"
                    },
                    {
                        "id": 50411,
                        "name": "Longstanton",
                        "latitude": "52.28076000",
                        "longitude": "0.04558000"
                    },
                    {
                        "id": 50412,
                        "name": "Longton",
                        "latitude": "52.98333000",
                        "longitude": "-2.13333000"
                    },
                    {
                        "id": 50413,
                        "name": "Longtown",
                        "latitude": "51.95000000",
                        "longitude": "-2.98333000"
                    },
                    {
                        "id": 50414,
                        "name": "Longwick",
                        "latitude": "51.73607000",
                        "longitude": "-0.85676000"
                    },
                    {
                        "id": 50415,
                        "name": "Looe",
                        "latitude": "50.35778000",
                        "longitude": "-4.45418000"
                    },
                    {
                        "id": 50417,
                        "name": "Lostwithiel",
                        "latitude": "50.40784000",
                        "longitude": "-4.67023000"
                    },
                    {
                        "id": 50418,
                        "name": "Loughborough",
                        "latitude": "52.76667000",
                        "longitude": "-1.20000000"
                    },
                    {
                        "id": 50419,
                        "name": "Louth",
                        "latitude": "53.36664000",
                        "longitude": "-0.00438000"
                    },
                    {
                        "id": 50420,
                        "name": "Low Ackworth",
                        "latitude": "53.65023000",
                        "longitude": "-1.32334000"
                    },
                    {
                        "id": 50421,
                        "name": "Low Bradley",
                        "latitude": "53.93217000",
                        "longitude": "-1.99646000"
                    },
                    {
                        "id": 50422,
                        "name": "Low Etherley",
                        "latitude": "54.65349000",
                        "longitude": "-1.74315000"
                    },
                    {
                        "id": 50423,
                        "name": "Lowdham",
                        "latitude": "53.01205000",
                        "longitude": "-1.00483000"
                    },
                    {
                        "id": 50424,
                        "name": "Lower Brailes",
                        "latitude": "52.05034000",
                        "longitude": "-1.54176000"
                    },
                    {
                        "id": 50425,
                        "name": "Lower Broadheath",
                        "latitude": "52.21379000",
                        "longitude": "-2.27724000"
                    },
                    {
                        "id": 50426,
                        "name": "Lower Earley",
                        "latitude": "51.42708000",
                        "longitude": "-0.91979000"
                    },
                    {
                        "id": 50427,
                        "name": "Lower Halstow",
                        "latitude": "51.37395000",
                        "longitude": "0.66819000"
                    },
                    {
                        "id": 50428,
                        "name": "Lower Kingswood",
                        "latitude": "51.26968000",
                        "longitude": "-0.21230000"
                    },
                    {
                        "id": 50429,
                        "name": "Lowestoft",
                        "latitude": "52.47523000",
                        "longitude": "1.75167000"
                    },
                    {
                        "id": 50430,
                        "name": "Lowick",
                        "latitude": "55.65044000",
                        "longitude": "-1.97809000"
                    },
                    {
                        "id": 50431,
                        "name": "Luckington",
                        "latitude": "51.55444000",
                        "longitude": "-2.24222000"
                    },
                    {
                        "id": 50432,
                        "name": "Luddenden Foot",
                        "latitude": "53.71873000",
                        "longitude": "-1.94582000"
                    },
                    {
                        "id": 50433,
                        "name": "Ludgershall",
                        "latitude": "51.25558000",
                        "longitude": "-1.62220000"
                    },
                    {
                        "id": 50434,
                        "name": "Ludlow",
                        "latitude": "52.37431000",
                        "longitude": "-2.71311000"
                    },
                    {
                        "id": 50435,
                        "name": "Lugwardine",
                        "latitude": "52.06583000",
                        "longitude": "-2.65780000"
                    },
                    {
                        "id": 50437,
                        "name": "Lund",
                        "latitude": "53.91920000",
                        "longitude": "-0.52211000"
                    },
                    {
                        "id": 50439,
                        "name": "Luton",
                        "latitude": "51.87967000",
                        "longitude": "-0.41748000"
                    },
                    {
                        "id": 50440,
                        "name": "Lutterworth",
                        "latitude": "52.45634000",
                        "longitude": "-1.20218000"
                    },
                    {
                        "id": 50441,
                        "name": "Lydbrook",
                        "latitude": "51.83763000",
                        "longitude": "-2.57818000"
                    },
                    {
                        "id": 50442,
                        "name": "Lydd",
                        "latitude": "50.95132000",
                        "longitude": "0.90654000"
                    },
                    {
                        "id": 50443,
                        "name": "Lydiard Millicent",
                        "latitude": "51.57117000",
                        "longitude": "-1.86346000"
                    },
                    {
                        "id": 50444,
                        "name": "Lydney",
                        "latitude": "51.72598000",
                        "longitude": "-2.52605000"
                    },
                    {
                        "id": 50445,
                        "name": "Lyme Regis",
                        "latitude": "50.72654000",
                        "longitude": "-2.93477000"
                    },
                    {
                        "id": 50446,
                        "name": "Lyminge",
                        "latitude": "51.12951000",
                        "longitude": "1.08896000"
                    },
                    {
                        "id": 50447,
                        "name": "Lymington",
                        "latitude": "50.75767000",
                        "longitude": "-1.54430000"
                    },
                    {
                        "id": 50448,
                        "name": "Lymm",
                        "latitude": "53.38105000",
                        "longitude": "-2.47763000"
                    },
                    {
                        "id": 50449,
                        "name": "Lympne",
                        "latitude": "51.07773000",
                        "longitude": "1.02808000"
                    },
                    {
                        "id": 50450,
                        "name": "Lympstone",
                        "latitude": "50.64751000",
                        "longitude": "-3.43162000"
                    },
                    {
                        "id": 50451,
                        "name": "Lyndhurst",
                        "latitude": "50.87259000",
                        "longitude": "-1.57662000"
                    },
                    {
                        "id": 50452,
                        "name": "Lyneham",
                        "latitude": "51.51667000",
                        "longitude": "-1.96667000"
                    },
                    {
                        "id": 50453,
                        "name": "Lynemouth",
                        "latitude": "55.21306000",
                        "longitude": "-1.54250000"
                    },
                    {
                        "id": 50454,
                        "name": "Lynton",
                        "latitude": "51.22968000",
                        "longitude": "-3.84131000"
                    },
                    {
                        "id": 50455,
                        "name": "Lytchett Matravers",
                        "latitude": "50.75826000",
                        "longitude": "-2.07806000"
                    },
                    {
                        "id": 50456,
                        "name": "Lytham St Annes",
                        "latitude": "53.74260000",
                        "longitude": "-2.99700000"
                    },
                    {
                        "id": 50457,
                        "name": "Mablethorpe",
                        "latitude": "53.34090000",
                        "longitude": "0.26102000"
                    },
                    {
                        "id": 50458,
                        "name": "Macclesfield",
                        "latitude": "53.26023000",
                        "longitude": "-2.12564000"
                    },
                    {
                        "id": 50464,
                        "name": "Madeley",
                        "latitude": "53.00000000",
                        "longitude": "-2.33333000"
                    },
                    {
                        "id": 50469,
                        "name": "Maghull",
                        "latitude": "53.51619000",
                        "longitude": "-2.94117000"
                    },
                    {
                        "id": 50471,
                        "name": "Maiden Newton",
                        "latitude": "50.77909000",
                        "longitude": "-2.57226000"
                    },
                    {
                        "id": 50472,
                        "name": "Maidenbower",
                        "latitude": "51.10781000",
                        "longitude": "-0.15286000"
                    },
                    {
                        "id": 50473,
                        "name": "Maidenhead",
                        "latitude": "51.52279000",
                        "longitude": "-0.71986000"
                    },
                    {
                        "id": 50474,
                        "name": "Maidstone",
                        "latitude": "51.26667000",
                        "longitude": "0.51667000"
                    },
                    {
                        "id": 50475,
                        "name": "Maldon",
                        "latitude": "51.73110000",
                        "longitude": "0.67463000"
                    },
                    {
                        "id": 50476,
                        "name": "Malmesbury",
                        "latitude": "51.58175000",
                        "longitude": "-2.09708000"
                    },
                    {
                        "id": 50477,
                        "name": "Malpas",
                        "latitude": "53.01667000",
                        "longitude": "-2.76667000"
                    },
                    {
                        "id": 50478,
                        "name": "Maltby",
                        "latitude": "53.41667000",
                        "longitude": "-1.20000000"
                    },
                    {
                        "id": 50479,
                        "name": "Malton",
                        "latitude": "54.13695000",
                        "longitude": "-0.79960000"
                    },
                    {
                        "id": 50480,
                        "name": "Manby",
                        "latitude": "53.36291000",
                        "longitude": "0.09653000"
                    },
                    {
                        "id": 50481,
                        "name": "Manchester",
                        "latitude": "53.41667000",
                        "longitude": "-2.25000000"
                    },
                    {
                        "id": 50482,
                        "name": "Manea",
                        "latitude": "52.48487000",
                        "longitude": "0.17930000"
                    },
                    {
                        "id": 50483,
                        "name": "Mangotsfield",
                        "latitude": "51.48780000",
                        "longitude": "-2.50403000"
                    },
                    {
                        "id": 50484,
                        "name": "Manningtree",
                        "latitude": "51.94538000",
                        "longitude": "1.06112000"
                    },
                    {
                        "id": 50485,
                        "name": "Mansfield",
                        "latitude": "53.13333000",
                        "longitude": "-1.20000000"
                    },
                    {
                        "id": 50486,
                        "name": "Mansfield Woodhouse",
                        "latitude": "53.16495000",
                        "longitude": "-1.19384000"
                    },
                    {
                        "id": 50487,
                        "name": "Manston",
                        "latitude": "50.95000000",
                        "longitude": "-2.26667000"
                    },
                    {
                        "id": 50488,
                        "name": "Manton",
                        "latitude": "52.63223000",
                        "longitude": "-0.70038000"
                    },
                    {
                        "id": 50489,
                        "name": "Maple Cross",
                        "latitude": "51.62500000",
                        "longitude": "-0.50800000"
                    },
                    {
                        "id": 50490,
                        "name": "Marazion",
                        "latitude": "50.12556000",
                        "longitude": "-5.47505000"
                    },
                    {
                        "id": 50491,
                        "name": "March",
                        "latitude": "52.55131000",
                        "longitude": "0.08828000"
                    },
                    {
                        "id": 50492,
                        "name": "Marcham",
                        "latitude": "51.66755000",
                        "longitude": "-1.34295000"
                    },
                    {
                        "id": 50494,
                        "name": "Marchwood",
                        "latitude": "50.88966000",
                        "longitude": "-1.45440000"
                    },
                    {
                        "id": 50495,
                        "name": "Marden",
                        "latitude": "51.17482000",
                        "longitude": "0.48855000"
                    },
                    {
                        "id": 50496,
                        "name": "Margate",
                        "latitude": "51.38132000",
                        "longitude": "1.38617000"
                    },
                    {
                        "id": 50497,
                        "name": "Market Bosworth",
                        "latitude": "52.62428000",
                        "longitude": "-1.40174000"
                    },
                    {
                        "id": 50498,
                        "name": "Market Deeping",
                        "latitude": "52.67654000",
                        "longitude": "-0.31629000"
                    },
                    {
                        "id": 50499,
                        "name": "Market Drayton",
                        "latitude": "52.90538000",
                        "longitude": "-2.49012000"
                    },
                    {
                        "id": 50500,
                        "name": "Market Harborough",
                        "latitude": "52.47760000",
                        "longitude": "-0.92053000"
                    },
                    {
                        "id": 50501,
                        "name": "Market Lavington",
                        "latitude": "51.28756000",
                        "longitude": "-1.97729000"
                    },
                    {
                        "id": 50502,
                        "name": "Market Overton",
                        "latitude": "52.73806000",
                        "longitude": "-0.68630000"
                    },
                    {
                        "id": 50503,
                        "name": "Market Rasen",
                        "latitude": "53.38764000",
                        "longitude": "-0.33781000"
                    },
                    {
                        "id": 50504,
                        "name": "Market Warsop",
                        "latitude": "53.20516000",
                        "longitude": "-1.15257000"
                    },
                    {
                        "id": 50505,
                        "name": "Market Weighton",
                        "latitude": "53.86310000",
                        "longitude": "-0.66505000"
                    },
                    {
                        "id": 50506,
                        "name": "Markfield",
                        "latitude": "52.68747000",
                        "longitude": "-1.27476000"
                    },
                    {
                        "id": 50508,
                        "name": "Marks Tey",
                        "latitude": "51.87628000",
                        "longitude": "0.76424000"
                    },
                    {
                        "id": 50509,
                        "name": "Markyate",
                        "latitude": "51.83846000",
                        "longitude": "-0.46345000"
                    },
                    {
                        "id": 50510,
                        "name": "Marlborough",
                        "latitude": "51.42027000",
                        "longitude": "-1.72949000"
                    },
                    {
                        "id": 50511,
                        "name": "Marldon",
                        "latitude": "50.45512000",
                        "longitude": "-3.59678000"
                    },
                    {
                        "id": 50512,
                        "name": "Marlow",
                        "latitude": "51.56933000",
                        "longitude": "-0.77415000"
                    },
                    {
                        "id": 50513,
                        "name": "Marnhull",
                        "latitude": "50.97045000",
                        "longitude": "-2.31327000"
                    },
                    {
                        "id": 50514,
                        "name": "Marple",
                        "latitude": "53.39452000",
                        "longitude": "-2.06292000"
                    },
                    {
                        "id": 50515,
                        "name": "Marr",
                        "latitude": "53.54296000",
                        "longitude": "-1.22051000"
                    },
                    {
                        "id": 50516,
                        "name": "Marsden",
                        "latitude": "53.60000000",
                        "longitude": "-1.91667000"
                    },
                    {
                        "id": 50517,
                        "name": "Marshfield",
                        "latitude": "51.46194000",
                        "longitude": "-2.32000000"
                    },
                    {
                        "id": 50519,
                        "name": "Marske-by-the-Sea",
                        "latitude": "54.59147000",
                        "longitude": "-1.01959000"
                    },
                    {
                        "id": 50520,
                        "name": "Marston Moretaine",
                        "latitude": "52.06410000",
                        "longitude": "-0.54932000"
                    },
                    {
                        "id": 50521,
                        "name": "Martham",
                        "latitude": "52.70464000",
                        "longitude": "1.63636000"
                    },
                    {
                        "id": 50522,
                        "name": "Martock",
                        "latitude": "50.97361000",
                        "longitude": "-2.76684000"
                    },
                    {
                        "id": 50524,
                        "name": "Maryport",
                        "latitude": "54.71434000",
                        "longitude": "-3.49509000"
                    },
                    {
                        "id": 50525,
                        "name": "Masham",
                        "latitude": "54.22270000",
                        "longitude": "-1.65718000"
                    },
                    {
                        "id": 50526,
                        "name": "Matlock",
                        "latitude": "53.13838000",
                        "longitude": "-1.55560000"
                    },
                    {
                        "id": 50527,
                        "name": "Mattishall",
                        "latitude": "52.65905000",
                        "longitude": "1.03250000"
                    },
                    {
                        "id": 50529,
                        "name": "Maulden",
                        "latitude": "52.03063000",
                        "longitude": "-0.46975000"
                    },
                    {
                        "id": 50532,
                        "name": "Mayfield",
                        "latitude": "53.00000000",
                        "longitude": "-1.76667000"
                    },
                    {
                        "id": 50534,
                        "name": "Mayland",
                        "latitude": "51.68033000",
                        "longitude": "0.76715000"
                    },
                    {
                        "id": 50535,
                        "name": "Measham",
                        "latitude": "52.70644000",
                        "longitude": "-1.50637000"
                    },
                    {
                        "id": 50536,
                        "name": "Medway",
                        "latitude": "51.41667000",
                        "longitude": "0.50000000"
                    },
                    {
                        "id": 50537,
                        "name": "Melbourn",
                        "latitude": "52.08128000",
                        "longitude": "0.01514000"
                    },
                    {
                        "id": 50538,
                        "name": "Melbourne",
                        "latitude": "52.82190000",
                        "longitude": "-1.42522000"
                    },
                    {
                        "id": 50539,
                        "name": "Meldreth",
                        "latitude": "52.09396000",
                        "longitude": "0.00807000"
                    },
                    {
                        "id": 50540,
                        "name": "Melksham",
                        "latitude": "51.37281000",
                        "longitude": "-2.14002000"
                    },
                    {
                        "id": 50542,
                        "name": "Meltham",
                        "latitude": "53.59305000",
                        "longitude": "-1.84861000"
                    },
                    {
                        "id": 50543,
                        "name": "Meltham Mills",
                        "latitude": "53.59388000",
                        "longitude": "-1.83989000"
                    },
                    {
                        "id": 50544,
                        "name": "Melton Mowbray",
                        "latitude": "52.76588000",
                        "longitude": "-0.88693000"
                    },
                    {
                        "id": 50546,
                        "name": "Mendip",
                        "latitude": "51.23720000",
                        "longitude": "-2.62660000"
                    },
                    {
                        "id": 50547,
                        "name": "Menston",
                        "latitude": "53.89041000",
                        "longitude": "-1.74395000"
                    },
                    {
                        "id": 50549,
                        "name": "Meopham",
                        "latitude": "51.36844000",
                        "longitude": "0.36007000"
                    },
                    {
                        "id": 50550,
                        "name": "Meppershall",
                        "latitude": "52.01713000",
                        "longitude": "-0.33991000"
                    },
                    {
                        "id": 50551,
                        "name": "Mere",
                        "latitude": "51.08889000",
                        "longitude": "-2.26694000"
                    },
                    {
                        "id": 50552,
                        "name": "Meriden",
                        "latitude": "52.43770000",
                        "longitude": "-1.64366000"
                    },
                    {
                        "id": 50553,
                        "name": "Merriott",
                        "latitude": "50.91275000",
                        "longitude": "-2.79538000"
                    },
                    {
                        "id": 50556,
                        "name": "Messingham",
                        "latitude": "53.52828000",
                        "longitude": "-0.65385000"
                    },
                    {
                        "id": 50557,
                        "name": "Metheringham",
                        "latitude": "53.14015000",
                        "longitude": "-0.40368000"
                    },
                    {
                        "id": 50559,
                        "name": "Methley",
                        "latitude": "53.72887000",
                        "longitude": "-1.40318000"
                    },
                    {
                        "id": 50561,
                        "name": "Metropolitan Borough of Wirral",
                        "latitude": "53.33333000",
                        "longitude": "-3.08333000"
                    },
                    {
                        "id": 50562,
                        "name": "Mevagissey",
                        "latitude": "50.27324000",
                        "longitude": "-4.79166000"
                    },
                    {
                        "id": 50563,
                        "name": "Mexborough",
                        "latitude": "53.49389000",
                        "longitude": "-1.29243000"
                    },
                    {
                        "id": 50564,
                        "name": "Mickle Trafford",
                        "latitude": "53.22146000",
                        "longitude": "-2.83225000"
                    },
                    {
                        "id": 50565,
                        "name": "Mickleton",
                        "latitude": "52.09152000",
                        "longitude": "-1.76623000"
                    },
                    {
                        "id": 50569,
                        "name": "Middle Rasen",
                        "latitude": "53.38722000",
                        "longitude": "-0.36202000"
                    },
                    {
                        "id": 50570,
                        "name": "Middle Winterslow",
                        "latitude": "51.09346000",
                        "longitude": "-1.65453000"
                    },
                    {
                        "id": 50571,
                        "name": "Middlesbrough",
                        "latitude": "54.57623000",
                        "longitude": "-1.23483000"
                    },
                    {
                        "id": 50572,
                        "name": "Middlestown",
                        "latitude": "53.65079000",
                        "longitude": "-1.59762000"
                    },
                    {
                        "id": 50573,
                        "name": "Middleton",
                        "latitude": "53.55000000",
                        "longitude": "-2.20000000"
                    },
                    {
                        "id": 50574,
                        "name": "Middlewich",
                        "latitude": "53.19296000",
                        "longitude": "-2.44402000"
                    },
                    {
                        "id": 50575,
                        "name": "Midhurst",
                        "latitude": "50.98559000",
                        "longitude": "-0.74003000"
                    },
                    {
                        "id": 50577,
                        "name": "Midsomer Norton",
                        "latitude": "51.28567000",
                        "longitude": "-2.48591000"
                    },
                    {
                        "id": 50578,
                        "name": "Milborne Port",
                        "latitude": "50.96605000",
                        "longitude": "-2.46248000"
                    },
                    {
                        "id": 50579,
                        "name": "Milborne St Andrew",
                        "latitude": "50.77829000",
                        "longitude": "-2.28114000"
                    },
                    {
                        "id": 50580,
                        "name": "Mildenhall",
                        "latitude": "52.34446000",
                        "longitude": "0.51086000"
                    },
                    {
                        "id": 50581,
                        "name": "Milford",
                        "latitude": "51.17272000",
                        "longitude": "-0.65042000"
                    },
                    {
                        "id": 50583,
                        "name": "Milford on Sea",
                        "latitude": "50.72561000",
                        "longitude": "-1.59004000"
                    },
                    {
                        "id": 50584,
                        "name": "Millbrook",
                        "latitude": "52.03882000",
                        "longitude": "-0.52438000"
                    },
                    {
                        "id": 50586,
                        "name": "Millom",
                        "latitude": "54.21072000",
                        "longitude": "-3.27200000"
                    },
                    {
                        "id": 50591,
                        "name": "Milnrow",
                        "latitude": "53.61115000",
                        "longitude": "-2.11266000"
                    },
                    {
                        "id": 50592,
                        "name": "Milnthorpe",
                        "latitude": "54.22785000",
                        "longitude": "-2.76939000"
                    },
                    {
                        "id": 50593,
                        "name": "Milton Keynes",
                        "latitude": "52.08333000",
                        "longitude": "-0.75000000"
                    },
                    {
                        "id": 50596,
                        "name": "Milverton",
                        "latitude": "51.02333000",
                        "longitude": "-3.25222000"
                    },
                    {
                        "id": 50597,
                        "name": "Minchinhampton",
                        "latitude": "51.70675000",
                        "longitude": "-2.18502000"
                    },
                    {
                        "id": 50598,
                        "name": "Minehead",
                        "latitude": "51.20452000",
                        "longitude": "-3.48284000"
                    },
                    {
                        "id": 50599,
                        "name": "Minety",
                        "latitude": "51.61667000",
                        "longitude": "-1.95000000"
                    },
                    {
                        "id": 50600,
                        "name": "Minster Lovell",
                        "latitude": "51.79274000",
                        "longitude": "-1.54830000"
                    },
                    {
                        "id": 50601,
                        "name": "Minsterley",
                        "latitude": "52.63989000",
                        "longitude": "-2.92807000"
                    },
                    {
                        "id": 50603,
                        "name": "Mirfield",
                        "latitude": "53.67343000",
                        "longitude": "-1.69636000"
                    },
                    {
                        "id": 50604,
                        "name": "Misterton",
                        "latitude": "53.44492000",
                        "longitude": "-0.85032000"
                    },
                    {
                        "id": 50605,
                        "name": "Mistley",
                        "latitude": "51.94331000",
                        "longitude": "1.08254000"
                    },
                    {
                        "id": 50606,
                        "name": "Mitcham",
                        "latitude": "51.40322000",
                        "longitude": "-0.16831000"
                    },
                    {
                        "id": 50607,
                        "name": "Mitcheldean",
                        "latitude": "51.86440000",
                        "longitude": "-2.48950000"
                    },
                    {
                        "id": 50608,
                        "name": "Mobberley",
                        "latitude": "53.31667000",
                        "longitude": "-2.31667000"
                    },
                    {
                        "id": 50609,
                        "name": "Modbury",
                        "latitude": "50.34957000",
                        "longitude": "-3.88684000"
                    },
                    {
                        "id": 50613,
                        "name": "Moira",
                        "latitude": "52.73698000",
                        "longitude": "-1.53496000"
                    },
                    {
                        "id": 50615,
                        "name": "Mollington",
                        "latitude": "53.22934000",
                        "longitude": "-2.92159000"
                    },
                    {
                        "id": 50618,
                        "name": "Monk Fryston",
                        "latitude": "53.76160000",
                        "longitude": "-1.23751000"
                    },
                    {
                        "id": 50624,
                        "name": "Morchard Bishop",
                        "latitude": "50.85416000",
                        "longitude": "-3.74894000"
                    },
                    {
                        "id": 50625,
                        "name": "Morcott",
                        "latitude": "52.59669000",
                        "longitude": "-0.63704000"
                    },
                    {
                        "id": 50626,
                        "name": "Morden",
                        "latitude": "51.39822000",
                        "longitude": "-0.19837000"
                    },
                    {
                        "id": 50627,
                        "name": "Morecambe",
                        "latitude": "54.06835000",
                        "longitude": "-2.86108000"
                    },
                    {
                        "id": 50628,
                        "name": "Moreton",
                        "latitude": "53.40000000",
                        "longitude": "-3.11667000"
                    },
                    {
                        "id": 50629,
                        "name": "Moreton in Marsh",
                        "latitude": "51.98964000",
                        "longitude": "-1.70297000"
                    },
                    {
                        "id": 50630,
                        "name": "Moretonhampstead",
                        "latitude": "50.66077000",
                        "longitude": "-3.76495000"
                    },
                    {
                        "id": 50631,
                        "name": "Morley",
                        "latitude": "53.74013000",
                        "longitude": "-1.59877000"
                    },
                    {
                        "id": 50632,
                        "name": "Morpeth",
                        "latitude": "55.16882000",
                        "longitude": "-1.68893000"
                    },
                    {
                        "id": 50633,
                        "name": "Moss",
                        "latitude": "53.61667000",
                        "longitude": "-1.10000000"
                    },
                    {
                        "id": 50635,
                        "name": "Mossley",
                        "latitude": "53.51454000",
                        "longitude": "-2.03462000"
                    },
                    {
                        "id": 50637,
                        "name": "Motcombe",
                        "latitude": "51.02929000",
                        "longitude": "-2.21627000"
                    },
                    {
                        "id": 50639,
                        "name": "Mouldsworth",
                        "latitude": "53.23333000",
                        "longitude": "-2.73333000"
                    },
                    {
                        "id": 50640,
                        "name": "Moulton Chapel",
                        "latitude": "52.74668000",
                        "longitude": "-0.08274000"
                    },
                    {
                        "id": 50641,
                        "name": "Mount Hawke",
                        "latitude": "50.28229000",
                        "longitude": "-5.20855000"
                    },
                    {
                        "id": 50643,
                        "name": "Mountsorrel",
                        "latitude": "52.71667000",
                        "longitude": "-1.15000000"
                    },
                    {
                        "id": 50645,
                        "name": "Much Hadham",
                        "latitude": "51.85407000",
                        "longitude": "0.07188000"
                    },
                    {
                        "id": 50646,
                        "name": "Much Wenlock",
                        "latitude": "52.59582000",
                        "longitude": "-2.55749000"
                    },
                    {
                        "id": 50650,
                        "name": "Mulbarton",
                        "latitude": "52.55913000",
                        "longitude": "1.23327000"
                    },
                    {
                        "id": 50651,
                        "name": "Mullion",
                        "latitude": "50.02706000",
                        "longitude": "-5.24248000"
                    },
                    {
                        "id": 50652,
                        "name": "Mundesley",
                        "latitude": "52.87842000",
                        "longitude": "1.42970000"
                    },
                    {
                        "id": 50653,
                        "name": "Mundford",
                        "latitude": "52.50930000",
                        "longitude": "0.64991000"
                    },
                    {
                        "id": 50654,
                        "name": "Murton",
                        "latitude": "54.81812000",
                        "longitude": "-1.39036000"
                    },
                    {
                        "id": 50656,
                        "name": "Mylor Bridge",
                        "latitude": "50.18506000",
                        "longitude": "-5.07963000"
                    },
                    {
                        "id": 50657,
                        "name": "Mytholmroyd",
                        "latitude": "53.73065000",
                        "longitude": "-1.98258000"
                    },
                    {
                        "id": 50658,
                        "name": "Nafferton",
                        "latitude": "54.01965000",
                        "longitude": "-0.39190000"
                    },
                    {
                        "id": 50659,
                        "name": "Nailsea",
                        "latitude": "51.43239000",
                        "longitude": "-2.75847000"
                    },
                    {
                        "id": 50660,
                        "name": "Nailsworth",
                        "latitude": "51.69382000",
                        "longitude": "-2.21990000"
                    },
                    {
                        "id": 50662,
                        "name": "Nanpean",
                        "latitude": "50.36884000",
                        "longitude": "-4.86935000"
                    },
                    {
                        "id": 50663,
                        "name": "Nantwich",
                        "latitude": "53.06878000",
                        "longitude": "-2.52051000"
                    },
                    {
                        "id": 50665,
                        "name": "Narborough",
                        "latitude": "52.56667000",
                        "longitude": "-1.20000000"
                    },
                    {
                        "id": 50666,
                        "name": "Navenby",
                        "latitude": "53.10680000",
                        "longitude": "-0.52494000"
                    },
                    {
                        "id": 50669,
                        "name": "Necton",
                        "latitude": "52.64994000",
                        "longitude": "0.77539000"
                    },
                    {
                        "id": 50670,
                        "name": "Needham Market",
                        "latitude": "52.15550000",
                        "longitude": "1.05160000"
                    },
                    {
                        "id": 50671,
                        "name": "Needingworth",
                        "latitude": "52.33051000",
                        "longitude": "-0.03116000"
                    },
                    {
                        "id": 50674,
                        "name": "Nelson",
                        "latitude": "53.83333000",
                        "longitude": "-2.20000000"
                    },
                    {
                        "id": 50676,
                        "name": "Neston",
                        "latitude": "53.28333000",
                        "longitude": "-3.05000000"
                    },
                    {
                        "id": 50677,
                        "name": "Nether Heyford",
                        "latitude": "52.22123000",
                        "longitude": "-1.03452000"
                    },
                    {
                        "id": 50678,
                        "name": "Nether Poppleton",
                        "latitude": "53.98793000",
                        "longitude": "-1.15062000"
                    },
                    {
                        "id": 50679,
                        "name": "Nether Stowey",
                        "latitude": "51.15101000",
                        "longitude": "-3.15676000"
                    },
                    {
                        "id": 50680,
                        "name": "Netheravon",
                        "latitude": "51.23613000",
                        "longitude": "-1.79083000"
                    },
                    {
                        "id": 50682,
                        "name": "Netherton",
                        "latitude": "52.48333000",
                        "longitude": "-2.08333000"
                    },
                    {
                        "id": 50683,
                        "name": "Netley",
                        "latitude": "50.87634000",
                        "longitude": "-1.35398000"
                    },
                    {
                        "id": 50684,
                        "name": "Nettleham",
                        "latitude": "53.26603000",
                        "longitude": "-0.48866000"
                    },
                    {
                        "id": 50685,
                        "name": "New Alresford",
                        "latitude": "51.08624000",
                        "longitude": "-1.17011000"
                    },
                    {
                        "id": 50686,
                        "name": "New Basford",
                        "latitude": "52.97336000",
                        "longitude": "-1.16564000"
                    },
                    {
                        "id": 50688,
                        "name": "New Ferry",
                        "latitude": "53.36046000",
                        "longitude": "-2.99377000"
                    },
                    {
                        "id": 50689,
                        "name": "New Malden",
                        "latitude": "51.40065000",
                        "longitude": "-0.26170000"
                    },
                    {
                        "id": 50690,
                        "name": "New Marske",
                        "latitude": "54.57848000",
                        "longitude": "-1.04224000"
                    },
                    {
                        "id": 50691,
                        "name": "New Mills",
                        "latitude": "53.36592000",
                        "longitude": "-1.99986000"
                    },
                    {
                        "id": 50692,
                        "name": "New Milton",
                        "latitude": "50.75601000",
                        "longitude": "-1.66580000"
                    },
                    {
                        "id": 50695,
                        "name": "New Romney",
                        "latitude": "50.98599000",
                        "longitude": "0.94122000"
                    },
                    {
                        "id": 50698,
                        "name": "Newark on Trent",
                        "latitude": "53.06667000",
                        "longitude": "-0.81667000"
                    },
                    {
                        "id": 50700,
                        "name": "Newbiggin-by-the-Sea",
                        "latitude": "55.18532000",
                        "longitude": "-1.51469000"
                    },
                    {
                        "id": 50701,
                        "name": "Newbold Verdon",
                        "latitude": "52.62959000",
                        "longitude": "-1.34220000"
                    },
                    {
                        "id": 50705,
                        "name": "Newburn",
                        "latitude": "54.98760000",
                        "longitude": "-1.74415000"
                    },
                    {
                        "id": 50706,
                        "name": "Newbury",
                        "latitude": "51.40148000",
                        "longitude": "-1.32471000"
                    },
                    {
                        "id": 50709,
                        "name": "Newcastle under Lyme",
                        "latitude": "53.00000000",
                        "longitude": "-2.23333000"
                    },
                    {
                        "id": 50710,
                        "name": "Newcastle upon Tyne",
                        "latitude": "55.00000000",
                        "longitude": "-1.66667000"
                    },
                    {
                        "id": 50711,
                        "name": "Newchurch",
                        "latitude": "50.66744000",
                        "longitude": "-1.20828000"
                    },
                    {
                        "id": 50712,
                        "name": "Newent",
                        "latitude": "51.93365000",
                        "longitude": "-2.40815000"
                    },
                    {
                        "id": 50713,
                        "name": "Newhaven",
                        "latitude": "50.79693000",
                        "longitude": "0.05545000"
                    },
                    {
                        "id": 50714,
                        "name": "Newick",
                        "latitude": "50.97518000",
                        "longitude": "0.01579000"
                    },
                    {
                        "id": 50715,
                        "name": "Newington",
                        "latitude": "51.35217000",
                        "longitude": "0.66768000"
                    },
                    {
                        "id": 50718,
                        "name": "Newmarket",
                        "latitude": "52.24467000",
                        "longitude": "0.40418000"
                    },
                    {
                        "id": 50721,
                        "name": "Newport",
                        "latitude": "50.70146000",
                        "longitude": "-1.29124000"
                    },
                    {
                        "id": 50722,
                        "name": "Newport Pagnell",
                        "latitude": "52.08731000",
                        "longitude": "-0.72218000"
                    },
                    {
                        "id": 50724,
                        "name": "Newquay",
                        "latitude": "50.41557000",
                        "longitude": "-5.07319000"
                    },
                    {
                        "id": 50727,
                        "name": "Newton Abbot",
                        "latitude": "50.52858000",
                        "longitude": "-3.61186000"
                    },
                    {
                        "id": 50728,
                        "name": "Newton Aycliffe",
                        "latitude": "54.61842000",
                        "longitude": "-1.57190000"
                    },
                    {
                        "id": 50729,
                        "name": "Newton Ferrers",
                        "latitude": "50.31467000",
                        "longitude": "-4.03920000"
                    },
                    {
                        "id": 50730,
                        "name": "Newton Longville",
                        "latitude": "51.97600000",
                        "longitude": "-0.76595000"
                    },
                    {
                        "id": 50732,
                        "name": "Newton Poppleford",
                        "latitude": "50.70000000",
                        "longitude": "-3.29586000"
                    },
                    {
                        "id": 50734,
                        "name": "Newton-le-Willows",
                        "latitude": "53.45000000",
                        "longitude": "-2.60000000"
                    },
                    {
                        "id": 50743,
                        "name": "Ninfield",
                        "latitude": "50.88641000",
                        "longitude": "0.42529000"
                    },
                    {
                        "id": 50744,
                        "name": "Niton",
                        "latitude": "50.58702000",
                        "longitude": "-1.28489000"
                    },
                    {
                        "id": 50745,
                        "name": "Norfolk",
                        "latitude": "52.66667000",
                        "longitude": "1.00000000"
                    },
                    {
                        "id": 50746,
                        "name": "Normandy",
                        "latitude": "51.25751000",
                        "longitude": "-0.67472000"
                    },
                    {
                        "id": 50748,
                        "name": "North Baddesley",
                        "latitude": "50.97745000",
                        "longitude": "-1.44547000"
                    },
                    {
                        "id": 50750,
                        "name": "North Cave",
                        "latitude": "53.78012000",
                        "longitude": "-0.64965000"
                    },
                    {
                        "id": 50751,
                        "name": "North Collingham",
                        "latitude": "53.15000000",
                        "longitude": "-0.75000000"
                    },
                    {
                        "id": 50752,
                        "name": "North Duffield",
                        "latitude": "53.82579000",
                        "longitude": "-0.96414000"
                    },
                    {
                        "id": 50753,
                        "name": "North East Lincolnshire",
                        "latitude": "53.53333000",
                        "longitude": "-0.08333000"
                    },
                    {
                        "id": 50754,
                        "name": "North Elmham",
                        "latitude": "52.74640000",
                        "longitude": "0.94611000"
                    },
                    {
                        "id": 50755,
                        "name": "North Ferriby",
                        "latitude": "53.72124000",
                        "longitude": "-0.50520000"
                    },
                    {
                        "id": 50757,
                        "name": "North Leigh",
                        "latitude": "51.81432000",
                        "longitude": "-1.44144000"
                    },
                    {
                        "id": 50758,
                        "name": "North Lincolnshire",
                        "latitude": "53.58333000",
                        "longitude": "-0.50000000"
                    },
                    {
                        "id": 50759,
                        "name": "North Luffenham",
                        "latitude": "52.62108000",
                        "longitude": "-0.61987000"
                    },
                    {
                        "id": 50760,
                        "name": "North Newbald",
                        "latitude": "53.81667000",
                        "longitude": "-0.61667000"
                    },
                    {
                        "id": 50761,
                        "name": "North Petherton",
                        "latitude": "51.09243000",
                        "longitude": "-3.01549000"
                    },
                    {
                        "id": 50763,
                        "name": "North Shields",
                        "latitude": "55.01646000",
                        "longitude": "-1.44925000"
                    },
                    {
                        "id": 50764,
                        "name": "North Somercotes",
                        "latitude": "53.44573000",
                        "longitude": "0.14103000"
                    },
                    {
                        "id": 50765,
                        "name": "North Somerset",
                        "latitude": "51.33333000",
                        "longitude": "-2.83333000"
                    },
                    {
                        "id": 50766,
                        "name": "North Sunderland",
                        "latitude": "55.57688000",
                        "longitude": "-1.66436000"
                    },
                    {
                        "id": 50767,
                        "name": "North Tawton",
                        "latitude": "50.79968000",
                        "longitude": "-3.89759000"
                    },
                    {
                        "id": 50768,
                        "name": "North Thoresby",
                        "latitude": "53.46651000",
                        "longitude": "-0.05575000"
                    },
                    {
                        "id": 50769,
                        "name": "North Walsham",
                        "latitude": "52.82121000",
                        "longitude": "1.38746000"
                    },
                    {
                        "id": 50770,
                        "name": "North Yorkshire",
                        "latitude": "54.16667000",
                        "longitude": "-1.50000000"
                    },
                    {
                        "id": 50771,
                        "name": "Northallerton",
                        "latitude": "54.33901000",
                        "longitude": "-1.43243000"
                    },
                    {
                        "id": 50772,
                        "name": "Northam",
                        "latitude": "51.03333000",
                        "longitude": "-4.21667000"
                    },
                    {
                        "id": 50773,
                        "name": "Northampton",
                        "latitude": "52.25000000",
                        "longitude": "-0.88333000"
                    },
                    {
                        "id": 50774,
                        "name": "Northamptonshire",
                        "latitude": "52.25000000",
                        "longitude": "-0.83333000"
                    },
                    {
                        "id": 50775,
                        "name": "Northborough",
                        "latitude": "52.65868000",
                        "longitude": "-0.29818000"
                    },
                    {
                        "id": 50776,
                        "name": "Northiam",
                        "latitude": "50.99439000",
                        "longitude": "0.60026000"
                    },
                    {
                        "id": 50777,
                        "name": "Northleach",
                        "latitude": "51.82994000",
                        "longitude": "-1.83712000"
                    },
                    {
                        "id": 50778,
                        "name": "Northolt",
                        "latitude": "51.54855000",
                        "longitude": "-0.36778000"
                    },
                    {
                        "id": 50780,
                        "name": "Northorpe",
                        "latitude": "53.46307000",
                        "longitude": "-0.65347000"
                    },
                    {
                        "id": 50781,
                        "name": "Northumberland",
                        "latitude": "55.25000000",
                        "longitude": "-2.00000000"
                    },
                    {
                        "id": 50782,
                        "name": "Northwich",
                        "latitude": "53.25882000",
                        "longitude": "-2.52025000"
                    },
                    {
                        "id": 50783,
                        "name": "Norton",
                        "latitude": "53.63333000",
                        "longitude": "-1.18333000"
                    },
                    {
                        "id": 50784,
                        "name": "Norton Canes",
                        "latitude": "52.67142000",
                        "longitude": "-1.96262000"
                    },
                    {
                        "id": 50785,
                        "name": "Norwich",
                        "latitude": "52.62783000",
                        "longitude": "1.29834000"
                    },
                    {
                        "id": 50786,
                        "name": "Nottingham",
                        "latitude": "52.95360000",
                        "longitude": "-1.15047000"
                    },
                    {
                        "id": 50787,
                        "name": "Nottinghamshire",
                        "latitude": "53.16667000",
                        "longitude": "-1.00000000"
                    },
                    {
                        "id": 50788,
                        "name": "Notton",
                        "latitude": "53.61267000",
                        "longitude": "-1.47234000"
                    },
                    {
                        "id": 50789,
                        "name": "Nuneaton",
                        "latitude": "52.52323000",
                        "longitude": "-1.46523000"
                    },
                    {
                        "id": 50790,
                        "name": "Oadby",
                        "latitude": "52.60621000",
                        "longitude": "-1.08354000"
                    },
                    {
                        "id": 50791,
                        "name": "Oakengates",
                        "latitude": "52.69501000",
                        "longitude": "-2.45036000"
                    },
                    {
                        "id": 50792,
                        "name": "Oakham",
                        "latitude": "52.66667000",
                        "longitude": "-0.73333000"
                    },
                    {
                        "id": 50793,
                        "name": "Oakington",
                        "latitude": "52.26044000",
                        "longitude": "0.06849000"
                    },
                    {
                        "id": 50795,
                        "name": "Oakley",
                        "latitude": "52.16862000",
                        "longitude": "-0.52649000"
                    },
                    {
                        "id": 50798,
                        "name": "Odiham",
                        "latitude": "51.25407000",
                        "longitude": "-0.93933000"
                    },
                    {
                        "id": 50800,
                        "name": "Okehampton",
                        "latitude": "50.73841000",
                        "longitude": "-4.00160000"
                    },
                    {
                        "id": 50801,
                        "name": "Old Basing",
                        "latitude": "51.26667000",
                        "longitude": "-1.03333000"
                    },
                    {
                        "id": 50802,
                        "name": "Old Harlow",
                        "latitude": "51.78353000",
                        "longitude": "0.13381000"
                    },
                    {
                        "id": 50804,
                        "name": "Old Leake",
                        "latitude": "53.03108000",
                        "longitude": "0.09873000"
                    },
                    {
                        "id": 50805,
                        "name": "Old Windsor",
                        "latitude": "51.45807000",
                        "longitude": "-0.58674000"
                    },
                    {
                        "id": 50806,
                        "name": "Oldbury",
                        "latitude": "52.50000000",
                        "longitude": "-2.01667000"
                    },
                    {
                        "id": 50807,
                        "name": "Oldham",
                        "latitude": "53.54051000",
                        "longitude": "-2.11830000"
                    },
                    {
                        "id": 50809,
                        "name": "Olney",
                        "latitude": "52.15345000",
                        "longitude": "-0.70201000"
                    },
                    {
                        "id": 50810,
                        "name": "Olveston",
                        "latitude": "51.58032000",
                        "longitude": "-2.57750000"
                    },
                    {
                        "id": 50814,
                        "name": "Orleton",
                        "latitude": "52.30000000",
                        "longitude": "-2.75000000"
                    },
                    {
                        "id": 50815,
                        "name": "Ormesby St Margaret",
                        "latitude": "52.67506000",
                        "longitude": "1.68850000"
                    },
                    {
                        "id": 50817,
                        "name": "Ormskirk",
                        "latitude": "53.56685000",
                        "longitude": "-2.88178000"
                    },
                    {
                        "id": 50818,
                        "name": "Orpington",
                        "latitude": "51.37457000",
                        "longitude": "0.09785000"
                    },
                    {
                        "id": 50819,
                        "name": "Orsett",
                        "latitude": "51.51232000",
                        "longitude": "0.36753000"
                    },
                    {
                        "id": 50820,
                        "name": "Orwell",
                        "latitude": "52.13560000",
                        "longitude": "-0.01099000"
                    },
                    {
                        "id": 50821,
                        "name": "Ossett",
                        "latitude": "53.67978000",
                        "longitude": "-1.58006000"
                    },
                    {
                        "id": 50822,
                        "name": "Oswestry",
                        "latitude": "52.86195000",
                        "longitude": "-3.05497000"
                    },
                    {
                        "id": 50823,
                        "name": "Otford",
                        "latitude": "51.31283000",
                        "longitude": "0.19046000"
                    },
                    {
                        "id": 50824,
                        "name": "Otley",
                        "latitude": "53.90553000",
                        "longitude": "-1.69383000"
                    },
                    {
                        "id": 50825,
                        "name": "Otterburn",
                        "latitude": "55.23340000",
                        "longitude": "-2.18059000"
                    },
                    {
                        "id": 50826,
                        "name": "Ottershaw",
                        "latitude": "51.36262000",
                        "longitude": "-0.52752000"
                    },
                    {
                        "id": 50827,
                        "name": "Ottery St Mary",
                        "latitude": "50.75000000",
                        "longitude": "-3.26667000"
                    },
                    {
                        "id": 50828,
                        "name": "Ottringham",
                        "latitude": "53.70092000",
                        "longitude": "-0.07909000"
                    },
                    {
                        "id": 50829,
                        "name": "Oughtibridge",
                        "latitude": "53.43612000",
                        "longitude": "-1.53902000"
                    },
                    {
                        "id": 50830,
                        "name": "Oundle",
                        "latitude": "52.48093000",
                        "longitude": "-0.46732000"
                    },
                    {
                        "id": 50831,
                        "name": "Outwell",
                        "latitude": "52.60946000",
                        "longitude": "0.23333000"
                    },
                    {
                        "id": 50832,
                        "name": "Over",
                        "latitude": "52.31667000",
                        "longitude": "0.01667000"
                    },
                    {
                        "id": 50833,
                        "name": "Overcombe",
                        "latitude": "50.63509000",
                        "longitude": "-2.43207000"
                    },
                    {
                        "id": 50834,
                        "name": "Overstrand",
                        "latitude": "52.91623000",
                        "longitude": "1.33900000"
                    },
                    {
                        "id": 50835,
                        "name": "Overton",
                        "latitude": "51.24389000",
                        "longitude": "-1.26154000"
                    },
                    {
                        "id": 50838,
                        "name": "Owston Ferry",
                        "latitude": "53.49407000",
                        "longitude": "-0.78045000"
                    },
                    {
                        "id": 50839,
                        "name": "Oxenhope",
                        "latitude": "53.81233000",
                        "longitude": "-1.95196000"
                    },
                    {
                        "id": 50840,
                        "name": "Oxford",
                        "latitude": "51.75222000",
                        "longitude": "-1.25596000"
                    },
                    {
                        "id": 50841,
                        "name": "Oxfordshire",
                        "latitude": "51.83333000",
                        "longitude": "-1.25000000"
                    },
                    {
                        "id": 50842,
                        "name": "Oxted",
                        "latitude": "51.25687000",
                        "longitude": "-0.00601000"
                    },
                    {
                        "id": 50843,
                        "name": "Paddock Wood",
                        "latitude": "51.18187000",
                        "longitude": "0.38229000"
                    },
                    {
                        "id": 50844,
                        "name": "Padiham",
                        "latitude": "53.80187000",
                        "longitude": "-2.31511000"
                    },
                    {
                        "id": 50845,
                        "name": "Padstow",
                        "latitude": "50.53885000",
                        "longitude": "-4.93664000"
                    },
                    {
                        "id": 50846,
                        "name": "Paignton",
                        "latitude": "50.43565000",
                        "longitude": "-3.56789000"
                    },
                    {
                        "id": 50847,
                        "name": "Painswick",
                        "latitude": "51.78568000",
                        "longitude": "-2.19555000"
                    },
                    {
                        "id": 50849,
                        "name": "Pangbourne",
                        "latitude": "51.48370000",
                        "longitude": "-1.08519000"
                    },
                    {
                        "id": 50850,
                        "name": "Pannal",
                        "latitude": "53.96031000",
                        "longitude": "-1.53573000"
                    },
                    {
                        "id": 50851,
                        "name": "Pant",
                        "latitude": "52.79005000",
                        "longitude": "-3.08031000"
                    },
                    {
                        "id": 50852,
                        "name": "Papworth Everard",
                        "latitude": "52.24893000",
                        "longitude": "-0.11827000"
                    },
                    {
                        "id": 50853,
                        "name": "Par",
                        "latitude": "50.35107000",
                        "longitude": "-4.70288000"
                    },
                    {
                        "id": 50854,
                        "name": "Parbold",
                        "latitude": "53.59145000",
                        "longitude": "-2.77028000"
                    },
                    {
                        "id": 50855,
                        "name": "Parkstone",
                        "latitude": "50.72994000",
                        "longitude": "-1.94492000"
                    },
                    {
                        "id": 50856,
                        "name": "Partington",
                        "latitude": "53.41884000",
                        "longitude": "-2.42815000"
                    },
                    {
                        "id": 50857,
                        "name": "Partridge Green",
                        "latitude": "50.95940000",
                        "longitude": "-0.30796000"
                    },
                    {
                        "id": 50858,
                        "name": "Pateley Bridge",
                        "latitude": "54.08616000",
                        "longitude": "-1.75981000"
                    },
                    {
                        "id": 50860,
                        "name": "Patrington",
                        "latitude": "53.68395000",
                        "longitude": "-0.01330000"
                    },
                    {
                        "id": 50861,
                        "name": "Pattingham",
                        "latitude": "52.58910000",
                        "longitude": "-2.26538000"
                    },
                    {
                        "id": 50862,
                        "name": "Paulton",
                        "latitude": "51.30472000",
                        "longitude": "-2.50028000"
                    },
                    {
                        "id": 50863,
                        "name": "Peacehaven",
                        "latitude": "50.79270000",
                        "longitude": "-0.00652000"
                    },
                    {
                        "id": 50864,
                        "name": "Peasedown Saint John",
                        "latitude": "51.31667000",
                        "longitude": "-2.42417000"
                    },
                    {
                        "id": 50865,
                        "name": "Peaslake",
                        "latitude": "51.19156000",
                        "longitude": "-0.44658000"
                    },
                    {
                        "id": 50866,
                        "name": "Peckham",
                        "latitude": "51.47403000",
                        "longitude": "-0.06969000"
                    },
                    {
                        "id": 50868,
                        "name": "Pegswood",
                        "latitude": "55.17930000",
                        "longitude": "-1.64525000"
                    },
                    {
                        "id": 50869,
                        "name": "Pelsall",
                        "latitude": "52.62910000",
                        "longitude": "-1.96738000"
                    },
                    {
                        "id": 50870,
                        "name": "Pelton",
                        "latitude": "54.87305000",
                        "longitude": "-1.60950000"
                    },
                    {
                        "id": 50874,
                        "name": "Pembury",
                        "latitude": "51.14296000",
                        "longitude": "0.32187000"
                    },
                    {
                        "id": 50882,
                        "name": "Penistone",
                        "latitude": "53.52572000",
                        "longitude": "-1.63027000"
                    },
                    {
                        "id": 50883,
                        "name": "Penkridge",
                        "latitude": "52.72556000",
                        "longitude": "-2.11560000"
                    },
                    {
                        "id": 50887,
                        "name": "Penrith",
                        "latitude": "54.66579000",
                        "longitude": "-2.75757000"
                    },
                    {
                        "id": 50888,
                        "name": "Penryn",
                        "latitude": "50.16812000",
                        "longitude": "-5.10416000"
                    },
                    {
                        "id": 50889,
                        "name": "Pensilva",
                        "latitude": "50.50302000",
                        "longitude": "-4.41491000"
                    },
                    {
                        "id": 50894,
                        "name": "Penzance",
                        "latitude": "50.11861000",
                        "longitude": "-5.53715000"
                    },
                    {
                        "id": 50895,
                        "name": "Perranporth",
                        "latitude": "50.34377000",
                        "longitude": "-5.15558000"
                    },
                    {
                        "id": 50896,
                        "name": "Perranwell",
                        "latitude": "50.21333000",
                        "longitude": "-5.12053000"
                    },
                    {
                        "id": 50897,
                        "name": "Pershore",
                        "latitude": "52.11163000",
                        "longitude": "-2.07586000"
                    },
                    {
                        "id": 50900,
                        "name": "Peterborough",
                        "latitude": "52.58333000",
                        "longitude": "-0.25000000"
                    },
                    {
                        "id": 50903,
                        "name": "Peterlee",
                        "latitude": "54.76032000",
                        "longitude": "-1.33649000"
                    },
                    {
                        "id": 50904,
                        "name": "Petersfield",
                        "latitude": "51.00495000",
                        "longitude": "-0.93375000"
                    },
                    {
                        "id": 50905,
                        "name": "Petworth",
                        "latitude": "50.98669000",
                        "longitude": "-0.61000000"
                    },
                    {
                        "id": 50906,
                        "name": "Pevensey",
                        "latitude": "50.81966000",
                        "longitude": "0.33963000"
                    },
                    {
                        "id": 50907,
                        "name": "Pevensey Bay",
                        "latitude": "50.81242000",
                        "longitude": "0.34864000"
                    },
                    {
                        "id": 50908,
                        "name": "Pewsey",
                        "latitude": "51.33855000",
                        "longitude": "-1.76545000"
                    },
                    {
                        "id": 50909,
                        "name": "Pickering",
                        "latitude": "54.25000000",
                        "longitude": "-0.76667000"
                    },
                    {
                        "id": 50910,
                        "name": "Pilning",
                        "latitude": "51.56337000",
                        "longitude": "-2.64264000"
                    },
                    {
                        "id": 50911,
                        "name": "Pilsley",
                        "latitude": "53.15000000",
                        "longitude": "-1.36667000"
                    },
                    {
                        "id": 50912,
                        "name": "Pimperne",
                        "latitude": "50.88374000",
                        "longitude": "-2.13620000"
                    },
                    {
                        "id": 50913,
                        "name": "Pinchbeck",
                        "latitude": "52.81303000",
                        "longitude": "-0.16256000"
                    },
                    {
                        "id": 50914,
                        "name": "Pinner",
                        "latitude": "51.59384000",
                        "longitude": "-0.38216000"
                    },
                    {
                        "id": 50915,
                        "name": "Pinxton",
                        "latitude": "53.09062000",
                        "longitude": "-1.31767000"
                    },
                    {
                        "id": 50916,
                        "name": "Pirton",
                        "latitude": "51.97120000",
                        "longitude": "-0.33394000"
                    },
                    {
                        "id": 50919,
                        "name": "Pitsea",
                        "latitude": "51.56387000",
                        "longitude": "0.50859000"
                    },
                    {
                        "id": 50920,
                        "name": "Pitstone",
                        "latitude": "51.82830000",
                        "longitude": "-0.63987000"
                    },
                    {
                        "id": 50924,
                        "name": "Plumpton Green",
                        "latitude": "50.93420000",
                        "longitude": "-0.06120000"
                    },
                    {
                        "id": 50925,
                        "name": "Plymouth",
                        "latitude": "50.38333000",
                        "longitude": "-4.13333000"
                    },
                    {
                        "id": 50926,
                        "name": "Plympton",
                        "latitude": "50.39074000",
                        "longitude": "-4.06022000"
                    },
                    {
                        "id": 50927,
                        "name": "Plymstock",
                        "latitude": "50.35999000",
                        "longitude": "-4.09049000"
                    },
                    {
                        "id": 50928,
                        "name": "Pocklington",
                        "latitude": "53.93335000",
                        "longitude": "-0.78106000"
                    },
                    {
                        "id": 50929,
                        "name": "Podington",
                        "latitude": "52.25424000",
                        "longitude": "-0.62463000"
                    },
                    {
                        "id": 50931,
                        "name": "Polesworth",
                        "latitude": "52.61962000",
                        "longitude": "-1.61036000"
                    },
                    {
                        "id": 50932,
                        "name": "Pollington",
                        "latitude": "53.67093000",
                        "longitude": "-1.07237000"
                    },
                    {
                        "id": 50934,
                        "name": "Polperro",
                        "latitude": "50.33130000",
                        "longitude": "-4.52220000"
                    },
                    {
                        "id": 50935,
                        "name": "Polzeath",
                        "latitude": "50.56956000",
                        "longitude": "-4.91759000"
                    },
                    {
                        "id": 50938,
                        "name": "Pontefract",
                        "latitude": "53.69107000",
                        "longitude": "-1.31269000"
                    },
                    {
                        "id": 50939,
                        "name": "Ponteland",
                        "latitude": "55.05024000",
                        "longitude": "-1.74532000"
                    },
                    {
                        "id": 50940,
                        "name": "Pontesbury",
                        "latitude": "52.64826000",
                        "longitude": "-2.89035000"
                    },
                    {
                        "id": 50948,
                        "name": "Pool",
                        "latitude": "53.90000000",
                        "longitude": "-1.61667000"
                    },
                    {
                        "id": 50949,
                        "name": "Poole",
                        "latitude": "50.73333000",
                        "longitude": "-1.96667000"
                    },
                    {
                        "id": 50950,
                        "name": "Poringland",
                        "latitude": "52.56756000",
                        "longitude": "1.34961000"
                    },
                    {
                        "id": 50951,
                        "name": "Porlock",
                        "latitude": "51.20889000",
                        "longitude": "-3.59556000"
                    },
                    {
                        "id": 50961,
                        "name": "Porthleven",
                        "latitude": "50.08618000",
                        "longitude": "-5.31501000"
                    },
                    {
                        "id": 50963,
                        "name": "Portishead",
                        "latitude": "51.48199000",
                        "longitude": "-2.76973000"
                    },
                    {
                        "id": 50965,
                        "name": "Portland",
                        "latitude": "50.56748000",
                        "longitude": "-2.44472000"
                    },
                    {
                        "id": 50969,
                        "name": "Portscatho",
                        "latitude": "50.17271000",
                        "longitude": "-4.97356000"
                    },
                    {
                        "id": 50970,
                        "name": "Portslade",
                        "latitude": "50.84286000",
                        "longitude": "-0.21608000"
                    },
                    {
                        "id": 50971,
                        "name": "Portsmouth",
                        "latitude": "50.80000000",
                        "longitude": "-1.06667000"
                    },
                    {
                        "id": 50974,
                        "name": "Potterne",
                        "latitude": "51.32917000",
                        "longitude": "-2.00519000"
                    },
                    {
                        "id": 50975,
                        "name": "Potters Bar",
                        "latitude": "51.69353000",
                        "longitude": "-0.17835000"
                    },
                    {
                        "id": 50976,
                        "name": "Potterspury",
                        "latitude": "52.08288000",
                        "longitude": "-0.89676000"
                    },
                    {
                        "id": 50977,
                        "name": "Potton",
                        "latitude": "52.12911000",
                        "longitude": "-0.21561000"
                    },
                    {
                        "id": 50978,
                        "name": "Poulton-le-Fylde",
                        "latitude": "53.83333000",
                        "longitude": "-2.98333000"
                    },
                    {
                        "id": 50979,
                        "name": "Poynton",
                        "latitude": "53.35000000",
                        "longitude": "-2.11667000"
                    },
                    {
                        "id": 50980,
                        "name": "Prees",
                        "latitude": "52.89689000",
                        "longitude": "-2.66401000"
                    },
                    {
                        "id": 50981,
                        "name": "Preesall",
                        "latitude": "53.91820000",
                        "longitude": "-2.96633000"
                    },
                    {
                        "id": 50982,
                        "name": "Prenton",
                        "latitude": "53.36762000",
                        "longitude": "-3.05479000"
                    },
                    {
                        "id": 50983,
                        "name": "Prescot",
                        "latitude": "53.42948000",
                        "longitude": "-2.80031000"
                    },
                    {
                        "id": 50985,
                        "name": "Prestbury",
                        "latitude": "53.28333000",
                        "longitude": "-2.15000000"
                    },
                    {
                        "id": 50987,
                        "name": "Preston",
                        "latitude": "53.76282000",
                        "longitude": "-2.70452000"
                    },
                    {
                        "id": 50989,
                        "name": "Prestwich",
                        "latitude": "53.53333000",
                        "longitude": "-2.28333000"
                    },
                    {
                        "id": 50992,
                        "name": "Princes Risborough",
                        "latitude": "51.72549000",
                        "longitude": "-0.83144000"
                    },
                    {
                        "id": 50993,
                        "name": "Princetown",
                        "latitude": "50.54393000",
                        "longitude": "-3.98855000"
                    },
                    {
                        "id": 50994,
                        "name": "Priston",
                        "latitude": "51.34306000",
                        "longitude": "-2.43917000"
                    },
                    {
                        "id": 50995,
                        "name": "Probus",
                        "latitude": "50.29267000",
                        "longitude": "-4.95401000"
                    },
                    {
                        "id": 50996,
                        "name": "Prudhoe",
                        "latitude": "54.96154000",
                        "longitude": "-1.85168000"
                    },
                    {
                        "id": 50997,
                        "name": "Publow",
                        "latitude": "51.37877000",
                        "longitude": "-2.54351000"
                    },
                    {
                        "id": 50998,
                        "name": "Puckeridge",
                        "latitude": "51.89013000",
                        "longitude": "0.01309000"
                    },
                    {
                        "id": 50999,
                        "name": "Pucklechurch",
                        "latitude": "51.48583000",
                        "longitude": "-2.43389000"
                    },
                    {
                        "id": 51000,
                        "name": "Puddletown",
                        "latitude": "50.75000000",
                        "longitude": "-2.35000000"
                    },
                    {
                        "id": 51001,
                        "name": "Pudsey",
                        "latitude": "53.79538000",
                        "longitude": "-1.66134000"
                    },
                    {
                        "id": 51002,
                        "name": "Pulborough",
                        "latitude": "50.95753000",
                        "longitude": "-0.51280000"
                    },
                    {
                        "id": 51003,
                        "name": "Pulloxhill",
                        "latitude": "51.99487000",
                        "longitude": "-0.45316000"
                    },
                    {
                        "id": 51004,
                        "name": "Purfleet",
                        "latitude": "51.48390000",
                        "longitude": "0.24247000"
                    },
                    {
                        "id": 51005,
                        "name": "Puriton",
                        "latitude": "51.16933000",
                        "longitude": "-2.97198000"
                    },
                    {
                        "id": 51006,
                        "name": "Purley",
                        "latitude": "51.33678000",
                        "longitude": "-0.11201000"
                    },
                    {
                        "id": 51007,
                        "name": "Purton",
                        "latitude": "51.58889000",
                        "longitude": "-1.87419000"
                    },
                    {
                        "id": 51010,
                        "name": "Queenborough",
                        "latitude": "51.41760000",
                        "longitude": "0.74441000"
                    },
                    {
                        "id": 51011,
                        "name": "Queensbury",
                        "latitude": "53.76657000",
                        "longitude": "-1.84912000"
                    },
                    {
                        "id": 51013,
                        "name": "Queniborough",
                        "latitude": "52.70591000",
                        "longitude": "-1.04749000"
                    },
                    {
                        "id": 51014,
                        "name": "Quorndon",
                        "latitude": "52.74461000",
                        "longitude": "-1.17348000"
                    },
                    {
                        "id": 51015,
                        "name": "Rackheath",
                        "latitude": "52.66254000",
                        "longitude": "1.38032000"
                    },
                    {
                        "id": 51016,
                        "name": "Radcliffe",
                        "latitude": "53.56178000",
                        "longitude": "-2.32455000"
                    },
                    {
                        "id": 51017,
                        "name": "Radcliffe on Trent",
                        "latitude": "52.94802000",
                        "longitude": "-1.03855000"
                    },
                    {
                        "id": 51018,
                        "name": "Radlett",
                        "latitude": "51.68593000",
                        "longitude": "-0.31868000"
                    },
                    {
                        "id": 51019,
                        "name": "Radley",
                        "latitude": "51.68746000",
                        "longitude": "-1.24025000"
                    },
                    {
                        "id": 51020,
                        "name": "Radstock",
                        "latitude": "51.28862000",
                        "longitude": "-2.46003000"
                    },
                    {
                        "id": 51023,
                        "name": "Rainford",
                        "latitude": "53.50223000",
                        "longitude": "-2.78839000"
                    },
                    {
                        "id": 51024,
                        "name": "Rainham",
                        "latitude": "51.36323000",
                        "longitude": "0.60893000"
                    },
                    {
                        "id": 51025,
                        "name": "Rainworth",
                        "latitude": "53.11883000",
                        "longitude": "-1.11852000"
                    },
                    {
                        "id": 51026,
                        "name": "Ramsbottom",
                        "latitude": "53.64789000",
                        "longitude": "-2.31683000"
                    },
                    {
                        "id": 51027,
                        "name": "Ramsbury",
                        "latitude": "51.44373000",
                        "longitude": "-1.60257000"
                    },
                    {
                        "id": 51028,
                        "name": "Ramsey",
                        "latitude": "52.45058000",
                        "longitude": "-0.10932000"
                    },
                    {
                        "id": 51029,
                        "name": "Ramsgate",
                        "latitude": "51.33568000",
                        "longitude": "1.41797000"
                    },
                    {
                        "id": 51031,
                        "name": "Ranskill",
                        "latitude": "53.38281000",
                        "longitude": "-1.01402000"
                    },
                    {
                        "id": 51032,
                        "name": "Rastrick",
                        "latitude": "53.69210000",
                        "longitude": "-1.78830000"
                    },
                    {
                        "id": 51033,
                        "name": "Ratby",
                        "latitude": "52.64989000",
                        "longitude": "-1.24137000"
                    },
                    {
                        "id": 51037,
                        "name": "Raunds",
                        "latitude": "52.34428000",
                        "longitude": "-0.53657000"
                    },
                    {
                        "id": 51038,
                        "name": "Ravenshead",
                        "latitude": "53.08650000",
                        "longitude": "-1.16026000"
                    },
                    {
                        "id": 51039,
                        "name": "Ravenstone",
                        "latitude": "52.72111000",
                        "longitude": "-1.40582000"
                    },
                    {
                        "id": 51040,
                        "name": "Rawcliffe",
                        "latitude": "53.69777000",
                        "longitude": "-0.96319000"
                    },
                    {
                        "id": 51041,
                        "name": "Rawmarsh",
                        "latitude": "53.46062000",
                        "longitude": "-1.34437000"
                    },
                    {
                        "id": 51042,
                        "name": "Rawtenstall",
                        "latitude": "53.70076000",
                        "longitude": "-2.28442000"
                    },
                    {
                        "id": 51043,
                        "name": "Rayleigh",
                        "latitude": "51.58571000",
                        "longitude": "0.60459000"
                    },
                    {
                        "id": 51044,
                        "name": "Rayne",
                        "latitude": "51.86667000",
                        "longitude": "0.58333000"
                    },
                    {
                        "id": 51045,
                        "name": "Reading",
                        "latitude": "51.45625000",
                        "longitude": "-0.97113000"
                    },
                    {
                        "id": 51046,
                        "name": "Redbourn",
                        "latitude": "51.79896000",
                        "longitude": "-0.39594000"
                    },
                    {
                        "id": 51047,
                        "name": "Redbourne",
                        "latitude": "53.48728000",
                        "longitude": "-0.53567000"
                    },
                    {
                        "id": 51048,
                        "name": "Redcar",
                        "latitude": "54.61657000",
                        "longitude": "-1.05999000"
                    },
                    {
                        "id": 51049,
                        "name": "Redcar and Cleveland",
                        "latitude": "54.55000000",
                        "longitude": "-1.00000000"
                    },
                    {
                        "id": 51052,
                        "name": "Redditch",
                        "latitude": "52.30650000",
                        "longitude": "-1.94569000"
                    },
                    {
                        "id": 51053,
                        "name": "Redhill",
                        "latitude": "51.24048000",
                        "longitude": "-0.17044000"
                    },
                    {
                        "id": 51054,
                        "name": "Redlynch",
                        "latitude": "51.09861000",
                        "longitude": "-2.42667000"
                    },
                    {
                        "id": 51055,
                        "name": "Redruth",
                        "latitude": "50.23315000",
                        "longitude": "-5.22434000"
                    },
                    {
                        "id": 51056,
                        "name": "Reedham",
                        "latitude": "52.56054000",
                        "longitude": "1.57122000"
                    },
                    {
                        "id": 51057,
                        "name": "Reepham",
                        "latitude": "52.76320000",
                        "longitude": "1.11099000"
                    },
                    {
                        "id": 51058,
                        "name": "Reigate",
                        "latitude": "51.23736000",
                        "longitude": "-0.20582000"
                    },
                    {
                        "id": 51059,
                        "name": "Rendlesham",
                        "latitude": "52.12665000",
                        "longitude": "1.41536000"
                    },
                    {
                        "id": 51063,
                        "name": "Repton",
                        "latitude": "52.83983000",
                        "longitude": "-1.55061000"
                    },
                    {
                        "id": 51065,
                        "name": "Retford",
                        "latitude": "53.32213000",
                        "longitude": "-0.94315000"
                    },
                    {
                        "id": 51076,
                        "name": "Riccall",
                        "latitude": "53.83331000",
                        "longitude": "-1.05730000"
                    },
                    {
                        "id": 51077,
                        "name": "Richmond",
                        "latitude": "54.40360000",
                        "longitude": "-1.73434000"
                    },
                    {
                        "id": 51078,
                        "name": "Rickinghall",
                        "latitude": "52.33649000",
                        "longitude": "0.99272000"
                    },
                    {
                        "id": 51079,
                        "name": "Rickmansworth",
                        "latitude": "51.63898000",
                        "longitude": "-0.47718000"
                    },
                    {
                        "id": 51080,
                        "name": "Ridgmont",
                        "latitude": "52.01532000",
                        "longitude": "-0.57871000"
                    },
                    {
                        "id": 51081,
                        "name": "Rillington",
                        "latitude": "54.15779000",
                        "longitude": "-0.69494000"
                    },
                    {
                        "id": 51082,
                        "name": "Ringmer",
                        "latitude": "50.89264000",
                        "longitude": "0.05472000"
                    },
                    {
                        "id": 51083,
                        "name": "Ringstead",
                        "latitude": "52.36528000",
                        "longitude": "-0.55490000"
                    },
                    {
                        "id": 51084,
                        "name": "Ringwood",
                        "latitude": "50.84541000",
                        "longitude": "-1.78871000"
                    },
                    {
                        "id": 51085,
                        "name": "Ripley",
                        "latitude": "53.03333000",
                        "longitude": "-1.40000000"
                    },
                    {
                        "id": 51086,
                        "name": "Ripon",
                        "latitude": "54.13579000",
                        "longitude": "-1.52826000"
                    },
                    {
                        "id": 51087,
                        "name": "Ripponden",
                        "latitude": "53.67449000",
                        "longitude": "-1.94183000"
                    },
                    {
                        "id": 51089,
                        "name": "Riseley",
                        "latitude": "52.25213000",
                        "longitude": "-0.47928000"
                    },
                    {
                        "id": 51090,
                        "name": "Rishton",
                        "latitude": "53.76806000",
                        "longitude": "-2.41444000"
                    },
                    {
                        "id": 51091,
                        "name": "Roade",
                        "latitude": "52.15824000",
                        "longitude": "-0.89745000"
                    },
                    {
                        "id": 51092,
                        "name": "Robertsbridge",
                        "latitude": "50.98569000",
                        "longitude": "0.47253000"
                    },
                    {
                        "id": 51093,
                        "name": "Rochdale",
                        "latitude": "53.61766000",
                        "longitude": "-2.15520000"
                    },
                    {
                        "id": 51094,
                        "name": "Roche",
                        "latitude": "50.40808000",
                        "longitude": "-4.83373000"
                    },
                    {
                        "id": 51095,
                        "name": "Rochester",
                        "latitude": "51.38764000",
                        "longitude": "0.50546000"
                    },
                    {
                        "id": 51096,
                        "name": "Rochford",
                        "latitude": "51.58198000",
                        "longitude": "0.70673000"
                    },
                    {
                        "id": 51097,
                        "name": "Rock",
                        "latitude": "50.54978000",
                        "longitude": "-4.90462000"
                    },
                    {
                        "id": 51098,
                        "name": "Rode",
                        "latitude": "51.28390000",
                        "longitude": "-2.28141000"
                    },
                    {
                        "id": 51099,
                        "name": "Rode Heath",
                        "latitude": "53.11387000",
                        "longitude": "-2.29186000"
                    },
                    {
                        "id": 51101,
                        "name": "Romford",
                        "latitude": "51.57515000",
                        "longitude": "0.18582000"
                    },
                    {
                        "id": 51102,
                        "name": "Romney Marsh",
                        "latitude": "51.02299000",
                        "longitude": "0.91504000"
                    },
                    {
                        "id": 51103,
                        "name": "Romsey",
                        "latitude": "50.98906000",
                        "longitude": "-1.49989000"
                    },
                    {
                        "id": 51104,
                        "name": "Romsley",
                        "latitude": "52.41996000",
                        "longitude": "-2.05695000"
                    },
                    {
                        "id": 51105,
                        "name": "Roos",
                        "latitude": "53.75292000",
                        "longitude": "-0.04463000"
                    },
                    {
                        "id": 51110,
                        "name": "Ross on Wye",
                        "latitude": "51.91667000",
                        "longitude": "-2.56667000"
                    },
                    {
                        "id": 51111,
                        "name": "Rossendale",
                        "latitude": "53.68456000",
                        "longitude": "-2.27690000"
                    },
                    {
                        "id": 51115,
                        "name": "Rothbury",
                        "latitude": "55.31059000",
                        "longitude": "-1.90845000"
                    },
                    {
                        "id": 51116,
                        "name": "Rotherfield Peppard",
                        "latitude": "51.53064000",
                        "longitude": "-0.97847000"
                    },
                    {
                        "id": 51117,
                        "name": "Rotherham",
                        "latitude": "53.41667000",
                        "longitude": "-1.25000000"
                    },
                    {
                        "id": 51121,
                        "name": "Rothley",
                        "latitude": "52.70916000",
                        "longitude": "-1.13739000"
                    },
                    {
                        "id": 51122,
                        "name": "Rothwell",
                        "latitude": "52.41667000",
                        "longitude": "-0.80000000"
                    },
                    {
                        "id": 51123,
                        "name": "Rottingdean",
                        "latitude": "50.80984000",
                        "longitude": "-0.05939000"
                    },
                    {
                        "id": 51124,
                        "name": "Rowde",
                        "latitude": "51.36325000",
                        "longitude": "-2.03098000"
                    },
                    {
                        "id": 51125,
                        "name": "Rowhedge",
                        "latitude": "51.85738000",
                        "longitude": "0.94534000"
                    },
                    {
                        "id": 51126,
                        "name": "Rowlands Gill",
                        "latitude": "54.91922000",
                        "longitude": "-1.74489000"
                    },
                    {
                        "id": 51127,
                        "name": "Rowley Regis",
                        "latitude": "52.48292000",
                        "longitude": "-2.04376000"
                    },
                    {
                        "id": 51128,
                        "name": "Roxton",
                        "latitude": "52.17756000",
                        "longitude": "-0.31594000"
                    },
                    {
                        "id": 51129,
                        "name": "Royal Borough of Windsor and Maidenhead",
                        "latitude": "51.46667000",
                        "longitude": "-0.66667000"
                    },
                    {
                        "id": 51130,
                        "name": "Royal Leamington Spa",
                        "latitude": "52.28520000",
                        "longitude": "-1.52000000"
                    },
                    {
                        "id": 51131,
                        "name": "Royal Tunbridge Wells",
                        "latitude": "51.13321000",
                        "longitude": "0.26256000"
                    },
                    {
                        "id": 51132,
                        "name": "Royal Wootton Bassett",
                        "latitude": "51.54190000",
                        "longitude": "-1.90450000"
                    },
                    {
                        "id": 51133,
                        "name": "Roydon",
                        "latitude": "51.77180000",
                        "longitude": "0.04030000"
                    },
                    {
                        "id": 51134,
                        "name": "Royston",
                        "latitude": "52.04832000",
                        "longitude": "-0.02438000"
                    },
                    {
                        "id": 51135,
                        "name": "Royton",
                        "latitude": "53.56507000",
                        "longitude": "-2.12267000"
                    },
                    {
                        "id": 51137,
                        "name": "Ruardean",
                        "latitude": "51.85501000",
                        "longitude": "-2.55054000"
                    },
                    {
                        "id": 51138,
                        "name": "Ruddington",
                        "latitude": "52.89254000",
                        "longitude": "-1.14953000"
                    },
                    {
                        "id": 51139,
                        "name": "Rudgwick",
                        "latitude": "51.08735000",
                        "longitude": "-0.45164000"
                    },
                    {
                        "id": 51140,
                        "name": "Rufford",
                        "latitude": "53.63375000",
                        "longitude": "-2.81662000"
                    },
                    {
                        "id": 51141,
                        "name": "Rugby",
                        "latitude": "52.37092000",
                        "longitude": "-1.26417000"
                    },
                    {
                        "id": 51142,
                        "name": "Rugeley",
                        "latitude": "52.75930000",
                        "longitude": "-1.93694000"
                    },
                    {
                        "id": 51143,
                        "name": "Ruislip",
                        "latitude": "51.57344000",
                        "longitude": "-0.42341000"
                    },
                    {
                        "id": 51144,
                        "name": "Runcorn",
                        "latitude": "53.34174000",
                        "longitude": "-2.73124000"
                    },
                    {
                        "id": 51145,
                        "name": "Rushden",
                        "latitude": "52.28927000",
                        "longitude": "-0.60184000"
                    },
                    {
                        "id": 51146,
                        "name": "Ruskington",
                        "latitude": "53.04544000",
                        "longitude": "-0.38692000"
                    },
                    {
                        "id": 51147,
                        "name": "Rusthall",
                        "latitude": "51.13643000",
                        "longitude": "0.22931000"
                    },
                    {
                        "id": 51148,
                        "name": "Rustington",
                        "latitude": "50.81027000",
                        "longitude": "-0.50674000"
                    },
                    {
                        "id": 51151,
                        "name": "Ruyton-XI-Towns",
                        "latitude": "52.79555000",
                        "longitude": "-2.90318000"
                    },
                    {
                        "id": 51152,
                        "name": "Ryde",
                        "latitude": "50.72999000",
                        "longitude": "-1.16210000"
                    },
                    {
                        "id": 51153,
                        "name": "Rye",
                        "latitude": "50.95114000",
                        "longitude": "0.73370000"
                    },
                    {
                        "id": 51154,
                        "name": "Ryhall",
                        "latitude": "52.68585000",
                        "longitude": "-0.46846000"
                    },
                    {
                        "id": 51155,
                        "name": "Ryhill",
                        "latitude": "53.62204000",
                        "longitude": "-1.41071000"
                    },
                    {
                        "id": 51156,
                        "name": "Ryhope",
                        "latitude": "54.87139000",
                        "longitude": "-1.37000000"
                    },
                    {
                        "id": 51157,
                        "name": "Ryton",
                        "latitude": "52.61667000",
                        "longitude": "-2.35000000"
                    },
                    {
                        "id": 51158,
                        "name": "Ryton on Dunsmore",
                        "latitude": "52.36667000",
                        "longitude": "-1.43333000"
                    },
                    {
                        "id": 51159,
                        "name": "Sabden",
                        "latitude": "53.83355000",
                        "longitude": "-2.33728000"
                    },
                    {
                        "id": 51160,
                        "name": "Sacriston",
                        "latitude": "54.81769000",
                        "longitude": "-1.62410000"
                    },
                    {
                        "id": 51161,
                        "name": "Saffron Walden",
                        "latitude": "52.02337000",
                        "longitude": "0.24234000"
                    },
                    {
                        "id": 51162,
                        "name": "Saint Agnes",
                        "latitude": "50.31278000",
                        "longitude": "-5.20456000"
                    },
                    {
                        "id": 51165,
                        "name": "Saint Bees",
                        "latitude": "54.49183000",
                        "longitude": "-3.58987000"
                    },
                    {
                        "id": 51168,
                        "name": "Saint Columb Major",
                        "latitude": "50.43163000",
                        "longitude": "-4.94336000"
                    },
                    {
                        "id": 51171,
                        "name": "Saint Dennis",
                        "latitude": "50.38333000",
                        "longitude": "-4.88333000"
                    },
                    {
                        "id": 51172,
                        "name": "Saint Leonards-on-Sea",
                        "latitude": "50.85565000",
                        "longitude": "0.54520000"
                    },
                    {
                        "id": 51174,
                        "name": "Saint Neots",
                        "latitude": "52.21667000",
                        "longitude": "-0.26667000"
                    },
                    {
                        "id": 51175,
                        "name": "Saint Osyth",
                        "latitude": "51.80000000",
                        "longitude": "1.08333000"
                    },
                    {
                        "id": 51176,
                        "name": "Saint Peters",
                        "latitude": "51.36667000",
                        "longitude": "1.41667000"
                    },
                    {
                        "id": 51177,
                        "name": "Saint Stephen",
                        "latitude": "50.34469000",
                        "longitude": "-4.89973000"
                    },
                    {
                        "id": 51179,
                        "name": "Salcombe",
                        "latitude": "50.23743000",
                        "longitude": "-3.76874000"
                    },
                    {
                        "id": 51180,
                        "name": "Sale",
                        "latitude": "53.42519000",
                        "longitude": "-2.32443000"
                    },
                    {
                        "id": 51181,
                        "name": "Salford",
                        "latitude": "53.48771000",
                        "longitude": "-2.29042000"
                    },
                    {
                        "id": 51182,
                        "name": "Salfords",
                        "latitude": "51.20430000",
                        "longitude": "-0.16947000"
                    },
                    {
                        "id": 51184,
                        "name": "Salisbury",
                        "latitude": "51.06931000",
                        "longitude": "-1.79569000"
                    },
                    {
                        "id": 51186,
                        "name": "Saltash",
                        "latitude": "50.40959000",
                        "longitude": "-4.22514000"
                    },
                    {
                        "id": 51187,
                        "name": "Saltburn-by-the-Sea",
                        "latitude": "54.58237000",
                        "longitude": "-0.97367000"
                    },
                    {
                        "id": 51189,
                        "name": "Saltford",
                        "latitude": "51.40139000",
                        "longitude": "-2.45944000"
                    },
                    {
                        "id": 51190,
                        "name": "Sampford Peverell",
                        "latitude": "50.91945000",
                        "longitude": "-3.38081000"
                    },
                    {
                        "id": 51191,
                        "name": "Sandbach",
                        "latitude": "53.14515000",
                        "longitude": "-2.36251000"
                    },
                    {
                        "id": 51193,
                        "name": "Sandford",
                        "latitude": "51.33228000",
                        "longitude": "-2.83122000"
                    },
                    {
                        "id": 51194,
                        "name": "Sandown",
                        "latitude": "50.65158000",
                        "longitude": "-1.16103000"
                    },
                    {
                        "id": 51195,
                        "name": "Sandwell",
                        "latitude": "52.50000000",
                        "longitude": "-2.00000000"
                    },
                    {
                        "id": 51196,
                        "name": "Sandwich",
                        "latitude": "51.27223000",
                        "longitude": "1.33776000"
                    },
                    {
                        "id": 51198,
                        "name": "Sandy",
                        "latitude": "52.12927000",
                        "longitude": "-0.28925000"
                    },
                    {
                        "id": 51200,
                        "name": "Sapcote",
                        "latitude": "52.53707000",
                        "longitude": "-1.27900000"
                    },
                    {
                        "id": 51201,
                        "name": "Saughall",
                        "latitude": "53.22618000",
                        "longitude": "-2.95649000"
                    },
                    {
                        "id": 51203,
                        "name": "Sawbridgeworth",
                        "latitude": "51.81667000",
                        "longitude": "0.15000000"
                    },
                    {
                        "id": 51204,
                        "name": "Sawston",
                        "latitude": "52.12089000",
                        "longitude": "0.16943000"
                    },
                    {
                        "id": 51205,
                        "name": "Sawtry",
                        "latitude": "52.43984000",
                        "longitude": "-0.28422000"
                    },
                    {
                        "id": 51206,
                        "name": "Saxilby",
                        "latitude": "53.26746000",
                        "longitude": "-0.66253000"
                    },
                    {
                        "id": 51207,
                        "name": "Saxmundham",
                        "latitude": "52.21497000",
                        "longitude": "1.48805000"
                    },
                    {
                        "id": 51208,
                        "name": "Scalby",
                        "latitude": "53.76667000",
                        "longitude": "-0.71667000"
                    },
                    {
                        "id": 51210,
                        "name": "Scarborough",
                        "latitude": "54.27966000",
                        "longitude": "-0.40443000"
                    },
                    {
                        "id": 51211,
                        "name": "Scarcroft",
                        "latitude": "53.86667000",
                        "longitude": "-1.45000000"
                    },
                    {
                        "id": 51212,
                        "name": "Scawby",
                        "latitude": "53.53787000",
                        "longitude": "-0.54085000"
                    },
                    {
                        "id": 51213,
                        "name": "Scholes",
                        "latitude": "53.82346000",
                        "longitude": "-1.42805000"
                    },
                    {
                        "id": 51214,
                        "name": "Scole",
                        "latitude": "52.36706000",
                        "longitude": "1.15674000"
                    },
                    {
                        "id": 51216,
                        "name": "Scorton",
                        "latitude": "54.39785000",
                        "longitude": "-1.61276000"
                    },
                    {
                        "id": 51217,
                        "name": "Scotby",
                        "latitude": "54.89004000",
                        "longitude": "-2.87464000"
                    },
                    {
                        "id": 51218,
                        "name": "Scotter",
                        "latitude": "53.49652000",
                        "longitude": "-0.67429000"
                    },
                    {
                        "id": 51219,
                        "name": "Scunthorpe",
                        "latitude": "53.57905000",
                        "longitude": "-0.65437000"
                    },
                    {
                        "id": 51221,
                        "name": "Seaford",
                        "latitude": "50.77141000",
                        "longitude": "0.10268000"
                    },
                    {
                        "id": 51222,
                        "name": "Seaham",
                        "latitude": "54.83903000",
                        "longitude": "-1.34575000"
                    },
                    {
                        "id": 51223,
                        "name": "Seahouses",
                        "latitude": "55.58063000",
                        "longitude": "-1.65497000"
                    },
                    {
                        "id": 51224,
                        "name": "Seascale",
                        "latitude": "54.39831000",
                        "longitude": "-3.47961000"
                    },
                    {
                        "id": 51225,
                        "name": "Seaton",
                        "latitude": "52.57489000",
                        "longitude": "-0.66759000"
                    },
                    {
                        "id": 51226,
                        "name": "Seaton Delaval",
                        "latitude": "55.07196000",
                        "longitude": "-1.52609000"
                    },
                    {
                        "id": 51227,
                        "name": "Seaview",
                        "latitude": "50.71956000",
                        "longitude": "-1.11164000"
                    },
                    {
                        "id": 51228,
                        "name": "Sedbergh",
                        "latitude": "54.32123000",
                        "longitude": "-2.52514000"
                    },
                    {
                        "id": 51229,
                        "name": "Sedgefield",
                        "latitude": "54.65329000",
                        "longitude": "-1.44952000"
                    },
                    {
                        "id": 51230,
                        "name": "Seend",
                        "latitude": "51.34806000",
                        "longitude": "-2.08472000"
                    },
                    {
                        "id": 51231,
                        "name": "Seer Green",
                        "latitude": "51.61796000",
                        "longitude": "-0.60592000"
                    },
                    {
                        "id": 51232,
                        "name": "Sefton",
                        "latitude": "53.50000000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 51233,
                        "name": "Seghill",
                        "latitude": "55.06225000",
                        "longitude": "-1.55027000"
                    },
                    {
                        "id": 51234,
                        "name": "Selby",
                        "latitude": "53.78333000",
                        "longitude": "-1.06667000"
                    },
                    {
                        "id": 51236,
                        "name": "Selsey",
                        "latitude": "50.73501000",
                        "longitude": "-0.78979000"
                    },
                    {
                        "id": 51237,
                        "name": "Send",
                        "latitude": "51.28875000",
                        "longitude": "-0.52666000"
                    },
                    {
                        "id": 51238,
                        "name": "Settle",
                        "latitude": "54.06865000",
                        "longitude": "-2.27720000"
                    },
                    {
                        "id": 51240,
                        "name": "Sevenoaks",
                        "latitude": "51.27266000",
                        "longitude": "0.18883000"
                    },
                    {
                        "id": 51241,
                        "name": "Severn Beach",
                        "latitude": "51.56036000",
                        "longitude": "-2.66279000"
                    },
                    {
                        "id": 51242,
                        "name": "Shadoxhurst",
                        "latitude": "51.10797000",
                        "longitude": "0.81917000"
                    },
                    {
                        "id": 51243,
                        "name": "Shadwell",
                        "latitude": "53.85460000",
                        "longitude": "-1.47260000"
                    },
                    {
                        "id": 51244,
                        "name": "Shaftesbury",
                        "latitude": "51.00528000",
                        "longitude": "-2.19333000"
                    },
                    {
                        "id": 51245,
                        "name": "Shalbourne",
                        "latitude": "51.36358000",
                        "longitude": "-1.55053000"
                    },
                    {
                        "id": 51246,
                        "name": "Shalfleet",
                        "latitude": "50.70113000",
                        "longitude": "-1.42007000"
                    },
                    {
                        "id": 51247,
                        "name": "Shanklin",
                        "latitude": "50.62613000",
                        "longitude": "-1.17850000"
                    },
                    {
                        "id": 51248,
                        "name": "Shap",
                        "latitude": "54.53149000",
                        "longitude": "-2.67551000"
                    },
                    {
                        "id": 51249,
                        "name": "Sharlston",
                        "latitude": "53.66956000",
                        "longitude": "-1.41294000"
                    },
                    {
                        "id": 51250,
                        "name": "Sharnbrook",
                        "latitude": "52.22606000",
                        "longitude": "-0.54425000"
                    },
                    {
                        "id": 51251,
                        "name": "Sharpness",
                        "latitude": "51.71972000",
                        "longitude": "-2.47750000"
                    },
                    {
                        "id": 51252,
                        "name": "Shaw",
                        "latitude": "53.56667000",
                        "longitude": "-2.08333000"
                    },
                    {
                        "id": 51253,
                        "name": "Shawbury",
                        "latitude": "52.79098000",
                        "longitude": "-2.66183000"
                    },
                    {
                        "id": 51254,
                        "name": "Sheerness",
                        "latitude": "51.44042000",
                        "longitude": "0.76252000"
                    },
                    {
                        "id": 51255,
                        "name": "Sheffield",
                        "latitude": "53.38297000",
                        "longitude": "-1.46590000"
                    },
                    {
                        "id": 51256,
                        "name": "Shefford",
                        "latitude": "52.03870000",
                        "longitude": "-0.33399000"
                    },
                    {
                        "id": 51257,
                        "name": "Shelley",
                        "latitude": "53.60000000",
                        "longitude": "-1.68333000"
                    },
                    {
                        "id": 51258,
                        "name": "Shenley",
                        "latitude": "51.69054000",
                        "longitude": "-0.28067000"
                    },
                    {
                        "id": 51259,
                        "name": "Shenstone",
                        "latitude": "52.63802000",
                        "longitude": "-1.84147000"
                    },
                    {
                        "id": 51260,
                        "name": "Shepherdswell",
                        "latitude": "51.18713000",
                        "longitude": "1.23049000"
                    },
                    {
                        "id": 51261,
                        "name": "Shepley",
                        "latitude": "53.58333000",
                        "longitude": "-1.71667000"
                    },
                    {
                        "id": 51262,
                        "name": "Shepperton",
                        "latitude": "51.39546000",
                        "longitude": "-0.44889000"
                    },
                    {
                        "id": 51263,
                        "name": "Shepshed",
                        "latitude": "52.76570000",
                        "longitude": "-1.29021000"
                    },
                    {
                        "id": 51264,
                        "name": "Shepton Mallet",
                        "latitude": "51.18972000",
                        "longitude": "-2.54722000"
                    },
                    {
                        "id": 51265,
                        "name": "Sherborne",
                        "latitude": "50.94599000",
                        "longitude": "-2.51776000"
                    },
                    {
                        "id": 51266,
                        "name": "Sherborne St John",
                        "latitude": "51.29705000",
                        "longitude": "-1.11387000"
                    },
                    {
                        "id": 51267,
                        "name": "Sherburn",
                        "latitude": "54.77606000",
                        "longitude": "-1.50474000"
                    },
                    {
                        "id": 51268,
                        "name": "Sherburn Hill",
                        "latitude": "54.77270000",
                        "longitude": "-1.47985000"
                    },
                    {
                        "id": 51269,
                        "name": "Sherburn in Elmet",
                        "latitude": "53.79519000",
                        "longitude": "-1.24660000"
                    },
                    {
                        "id": 51270,
                        "name": "Sheriff Hutton",
                        "latitude": "54.08904000",
                        "longitude": "-1.00639000"
                    },
                    {
                        "id": 51271,
                        "name": "Sheringham",
                        "latitude": "52.94078000",
                        "longitude": "1.20931000"
                    },
                    {
                        "id": 51272,
                        "name": "Sherington",
                        "latitude": "52.11172000",
                        "longitude": "-0.69973000"
                    },
                    {
                        "id": 51273,
                        "name": "Sherston",
                        "latitude": "51.57205000",
                        "longitude": "-2.21278000"
                    },
                    {
                        "id": 51275,
                        "name": "Shevington",
                        "latitude": "53.57236000",
                        "longitude": "-2.69316000"
                    },
                    {
                        "id": 51277,
                        "name": "Shifnal",
                        "latitude": "52.67043000",
                        "longitude": "-2.37248000"
                    },
                    {
                        "id": 51278,
                        "name": "Shilbottle",
                        "latitude": "55.37099000",
                        "longitude": "-1.68820000"
                    },
                    {
                        "id": 51279,
                        "name": "Shildon",
                        "latitude": "54.62997000",
                        "longitude": "-1.64295000"
                    },
                    {
                        "id": 51280,
                        "name": "Shillingstone",
                        "latitude": "50.89567000",
                        "longitude": "-2.24495000"
                    },
                    {
                        "id": 51281,
                        "name": "Shillington",
                        "latitude": "51.99344000",
                        "longitude": "-0.36006000"
                    },
                    {
                        "id": 51282,
                        "name": "Shipdham",
                        "latitude": "52.62923000",
                        "longitude": "0.88577000"
                    },
                    {
                        "id": 51283,
                        "name": "Shipham",
                        "latitude": "51.31428000",
                        "longitude": "-2.80010000"
                    },
                    {
                        "id": 51284,
                        "name": "Shipley",
                        "latitude": "53.83333000",
                        "longitude": "-1.76667000"
                    },
                    {
                        "id": 51285,
                        "name": "Shipston on Stour",
                        "latitude": "52.06057000",
                        "longitude": "-1.62778000"
                    },
                    {
                        "id": 51286,
                        "name": "Shipton under Wychwood",
                        "latitude": "51.86035000",
                        "longitude": "-1.59847000"
                    },
                    {
                        "id": 51287,
                        "name": "Shirebrook",
                        "latitude": "53.20333000",
                        "longitude": "-1.21336000"
                    },
                    {
                        "id": 51288,
                        "name": "Shiremoor",
                        "latitude": "55.03535000",
                        "longitude": "-1.50950000"
                    },
                    {
                        "id": 51289,
                        "name": "Shirland",
                        "latitude": "53.12155000",
                        "longitude": "-1.40464000"
                    },
                    {
                        "id": 51290,
                        "name": "Shirley",
                        "latitude": "52.41074000",
                        "longitude": "-1.81952000"
                    },
                    {
                        "id": 51291,
                        "name": "Shoreham-by-Sea",
                        "latitude": "50.83413000",
                        "longitude": "-0.27431000"
                    },
                    {
                        "id": 51292,
                        "name": "Shortlands",
                        "latitude": "51.39914000",
                        "longitude": "0.00440000"
                    },
                    {
                        "id": 51293,
                        "name": "Shotley Gate",
                        "latitude": "51.95791000",
                        "longitude": "1.26871000"
                    },
                    {
                        "id": 51295,
                        "name": "Shrewsbury",
                        "latitude": "52.71009000",
                        "longitude": "-2.75208000"
                    },
                    {
                        "id": 51296,
                        "name": "Shrewton",
                        "latitude": "51.19194000",
                        "longitude": "-1.90264000"
                    },
                    {
                        "id": 51297,
                        "name": "Shrivenham",
                        "latitude": "51.59853000",
                        "longitude": "-1.65461000"
                    },
                    {
                        "id": 51298,
                        "name": "Shropshire",
                        "latitude": "52.66667000",
                        "longitude": "-2.75000000"
                    },
                    {
                        "id": 51299,
                        "name": "Shurdington",
                        "latitude": "51.86264000",
                        "longitude": "-2.12060000"
                    },
                    {
                        "id": 51300,
                        "name": "Sible Hedingham",
                        "latitude": "51.97772000",
                        "longitude": "0.59262000"
                    },
                    {
                        "id": 51301,
                        "name": "Sibsey",
                        "latitude": "53.03858000",
                        "longitude": "0.01579000"
                    },
                    {
                        "id": 51302,
                        "name": "Sidcup",
                        "latitude": "51.42619000",
                        "longitude": "0.10360000"
                    },
                    {
                        "id": 51303,
                        "name": "Sidmouth",
                        "latitude": "50.69094000",
                        "longitude": "-3.23970000"
                    },
                    {
                        "id": 51304,
                        "name": "Sileby",
                        "latitude": "52.73286000",
                        "longitude": "-1.10773000"
                    },
                    {
                        "id": 51305,
                        "name": "Silkstone",
                        "latitude": "53.54808000",
                        "longitude": "-1.56381000"
                    },
                    {
                        "id": 51306,
                        "name": "Silloth",
                        "latitude": "54.86870000",
                        "longitude": "-3.38448000"
                    },
                    {
                        "id": 51307,
                        "name": "Silsden",
                        "latitude": "53.91443000",
                        "longitude": "-1.93802000"
                    },
                    {
                        "id": 51308,
                        "name": "Silsoe",
                        "latitude": "52.00854000",
                        "longitude": "-0.42484000"
                    },
                    {
                        "id": 51309,
                        "name": "Silver End",
                        "latitude": "51.84734000",
                        "longitude": "0.62399000"
                    },
                    {
                        "id": 51310,
                        "name": "Silverdale",
                        "latitude": "54.16667000",
                        "longitude": "-2.81667000"
                    },
                    {
                        "id": 51311,
                        "name": "Silverstone",
                        "latitude": "52.09216000",
                        "longitude": "-1.02602000"
                    },
                    {
                        "id": 51312,
                        "name": "Silverton",
                        "latitude": "50.81667000",
                        "longitude": "-3.48333000"
                    },
                    {
                        "id": 51313,
                        "name": "Sinfin",
                        "latitude": "52.88157000",
                        "longitude": "-1.48681000"
                    },
                    {
                        "id": 51316,
                        "name": "Sissinghurst",
                        "latitude": "51.10905000",
                        "longitude": "0.56000000"
                    },
                    {
                        "id": 51317,
                        "name": "Sittingbourne",
                        "latitude": "51.34128000",
                        "longitude": "0.73282000"
                    },
                    {
                        "id": 51318,
                        "name": "Skegness",
                        "latitude": "53.14362000",
                        "longitude": "0.33630000"
                    },
                    {
                        "id": 51319,
                        "name": "Skellingthorpe",
                        "latitude": "53.23531000",
                        "longitude": "-0.61905000"
                    },
                    {
                        "id": 51320,
                        "name": "Skelmersdale",
                        "latitude": "53.55024000",
                        "longitude": "-2.77348000"
                    },
                    {
                        "id": 51322,
                        "name": "Skelton",
                        "latitude": "53.72521000",
                        "longitude": "-0.84187000"
                    },
                    {
                        "id": 51323,
                        "name": "Skidby",
                        "latitude": "53.78921000",
                        "longitude": "-0.46131000"
                    },
                    {
                        "id": 51324,
                        "name": "Skinningrove",
                        "latitude": "54.56908000",
                        "longitude": "-0.89869000"
                    },
                    {
                        "id": 51325,
                        "name": "Skipsea",
                        "latitude": "53.97674000",
                        "longitude": "-0.22084000"
                    },
                    {
                        "id": 51326,
                        "name": "Skipton",
                        "latitude": "53.96144000",
                        "longitude": "-2.01676000"
                    },
                    {
                        "id": 51327,
                        "name": "Slaley",
                        "latitude": "54.91368000",
                        "longitude": "-2.03711000"
                    },
                    {
                        "id": 51329,
                        "name": "Sleaford",
                        "latitude": "52.99826000",
                        "longitude": "-0.40941000"
                    },
                    {
                        "id": 51330,
                        "name": "Sleights",
                        "latitude": "54.45506000",
                        "longitude": "-0.66484000"
                    },
                    {
                        "id": 51331,
                        "name": "Slinfold",
                        "latitude": "51.07209000",
                        "longitude": "-0.40658000"
                    },
                    {
                        "id": 51332,
                        "name": "Slough",
                        "latitude": "51.50949000",
                        "longitude": "-0.59541000"
                    },
                    {
                        "id": 51333,
                        "name": "Smethwick",
                        "latitude": "52.49268000",
                        "longitude": "-1.96745000"
                    },
                    {
                        "id": 51335,
                        "name": "Snaith",
                        "latitude": "53.69112000",
                        "longitude": "-1.02859000"
                    },
                    {
                        "id": 51336,
                        "name": "Snettisham",
                        "latitude": "52.87882000",
                        "longitude": "0.50099000"
                    },
                    {
                        "id": 51337,
                        "name": "Snodland",
                        "latitude": "51.32971000",
                        "longitude": "0.44305000"
                    },
                    {
                        "id": 51338,
                        "name": "Soham",
                        "latitude": "52.33543000",
                        "longitude": "0.33654000"
                    },
                    {
                        "id": 51339,
                        "name": "Solihull",
                        "latitude": "52.41667000",
                        "longitude": "-1.75000000"
                    },
                    {
                        "id": 51340,
                        "name": "Somerset",
                        "latitude": "51.08333000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 51341,
                        "name": "Somersham",
                        "latitude": "52.38333000",
                        "longitude": "0.00000000"
                    },
                    {
                        "id": 51342,
                        "name": "Somerton",
                        "latitude": "51.95421000",
                        "longitude": "-1.27613000"
                    },
                    {
                        "id": 51343,
                        "name": "Sonning Common",
                        "latitude": "51.51873000",
                        "longitude": "-0.97753000"
                    },
                    {
                        "id": 51345,
                        "name": "South Benfleet",
                        "latitude": "51.55295000",
                        "longitude": "0.55962000"
                    },
                    {
                        "id": 51346,
                        "name": "South Brent",
                        "latitude": "50.42654000",
                        "longitude": "-3.83426000"
                    },
                    {
                        "id": 51347,
                        "name": "South Cave",
                        "latitude": "53.76987000",
                        "longitude": "-0.60107000"
                    },
                    {
                        "id": 51348,
                        "name": "South Cerney",
                        "latitude": "51.67319000",
                        "longitude": "-1.93097000"
                    },
                    {
                        "id": 51349,
                        "name": "South Chailey",
                        "latitude": "50.93831000",
                        "longitude": "-0.02105000"
                    },
                    {
                        "id": 51350,
                        "name": "South Collingham",
                        "latitude": "53.13333000",
                        "longitude": "-0.76667000"
                    },
                    {
                        "id": 51351,
                        "name": "South Croydon",
                        "latitude": "51.36217000",
                        "longitude": "-0.09421000"
                    },
                    {
                        "id": 51352,
                        "name": "South Elmsall",
                        "latitude": "53.59709000",
                        "longitude": "-1.28034000"
                    },
                    {
                        "id": 51353,
                        "name": "South Gloucestershire",
                        "latitude": "51.50000000",
                        "longitude": "-2.41667000"
                    },
                    {
                        "id": 51354,
                        "name": "South Harting",
                        "latitude": "50.96924000",
                        "longitude": "-0.88388000"
                    },
                    {
                        "id": 51355,
                        "name": "South Hayling",
                        "latitude": "50.78773000",
                        "longitude": "-0.97697000"
                    },
                    {
                        "id": 51356,
                        "name": "South Hetton",
                        "latitude": "54.79906000",
                        "longitude": "-1.40671000"
                    },
                    {
                        "id": 51358,
                        "name": "South Littleton",
                        "latitude": "52.11416000",
                        "longitude": "-1.89014000"
                    },
                    {
                        "id": 51359,
                        "name": "South Luffenham",
                        "latitude": "52.60857000",
                        "longitude": "-0.61232000"
                    },
                    {
                        "id": 51360,
                        "name": "South Milford",
                        "latitude": "53.77672000",
                        "longitude": "-1.24609000"
                    },
                    {
                        "id": 51361,
                        "name": "South Molton",
                        "latitude": "51.01667000",
                        "longitude": "-3.83333000"
                    },
                    {
                        "id": 51362,
                        "name": "South Nutfield",
                        "latitude": "51.01667000",
                        "longitude": "-0.13333000"
                    },
                    {
                        "id": 51363,
                        "name": "South Ockendon",
                        "latitude": "51.50799000",
                        "longitude": "0.28333000"
                    },
                    {
                        "id": 51364,
                        "name": "South Petherton",
                        "latitude": "50.94829000",
                        "longitude": "-2.80708000"
                    },
                    {
                        "id": 51365,
                        "name": "South Shields",
                        "latitude": "54.99859000",
                        "longitude": "-1.43230000"
                    },
                    {
                        "id": 51366,
                        "name": "South Tyneside",
                        "latitude": "54.95000000",
                        "longitude": "-1.41667000"
                    },
                    {
                        "id": 51367,
                        "name": "South Wingfield",
                        "latitude": "53.09593000",
                        "longitude": "-1.43998000"
                    },
                    {
                        "id": 51368,
                        "name": "South Witham",
                        "latitude": "52.76476000",
                        "longitude": "-0.62811000"
                    },
                    {
                        "id": 51369,
                        "name": "Southall",
                        "latitude": "51.50896000",
                        "longitude": "-0.37130000"
                    },
                    {
                        "id": 51370,
                        "name": "Southam",
                        "latitude": "52.25266000",
                        "longitude": "-1.38840000"
                    },
                    {
                        "id": 51371,
                        "name": "Southampton",
                        "latitude": "50.91667000",
                        "longitude": "-1.38333000"
                    },
                    {
                        "id": 51372,
                        "name": "Southchurch Village",
                        "latitude": "51.54049000",
                        "longitude": "0.72935000"
                    },
                    {
                        "id": 51373,
                        "name": "Southend-on-Sea",
                        "latitude": "51.53782000",
                        "longitude": "0.71433000"
                    },
                    {
                        "id": 51374,
                        "name": "Southery",
                        "latitude": "52.52714000",
                        "longitude": "0.38783000"
                    },
                    {
                        "id": 51376,
                        "name": "Southminster",
                        "latitude": "51.66228000",
                        "longitude": "0.82968000"
                    },
                    {
                        "id": 51377,
                        "name": "Southowram",
                        "latitude": "53.70988000",
                        "longitude": "-1.83181000"
                    },
                    {
                        "id": 51378,
                        "name": "Southport",
                        "latitude": "53.64581000",
                        "longitude": "-3.01008000"
                    },
                    {
                        "id": 51379,
                        "name": "Southsea",
                        "latitude": "50.79205000",
                        "longitude": "-1.08593000"
                    },
                    {
                        "id": 51380,
                        "name": "Southwater",
                        "latitude": "51.02369000",
                        "longitude": "-0.35173000"
                    },
                    {
                        "id": 51381,
                        "name": "Southwell",
                        "latitude": "53.07804000",
                        "longitude": "-0.95538000"
                    },
                    {
                        "id": 51382,
                        "name": "Southwick",
                        "latitude": "51.29694000",
                        "longitude": "-2.23250000"
                    },
                    {
                        "id": 51383,
                        "name": "Southwold",
                        "latitude": "52.32721000",
                        "longitude": "1.68017000"
                    },
                    {
                        "id": 51384,
                        "name": "Sowerby Bridge",
                        "latitude": "53.70903000",
                        "longitude": "-1.90929000"
                    },
                    {
                        "id": 51385,
                        "name": "Spalding",
                        "latitude": "52.78709000",
                        "longitude": "-0.15141000"
                    },
                    {
                        "id": 51386,
                        "name": "Speldhurst",
                        "latitude": "51.15076000",
                        "longitude": "0.21947000"
                    },
                    {
                        "id": 51387,
                        "name": "Spennymoor",
                        "latitude": "54.69880000",
                        "longitude": "-1.60229000"
                    },
                    {
                        "id": 51388,
                        "name": "Spilsby",
                        "latitude": "53.17363000",
                        "longitude": "0.09373000"
                    },
                    {
                        "id": 51390,
                        "name": "Spixworth",
                        "latitude": "52.68529000",
                        "longitude": "1.32027000"
                    },
                    {
                        "id": 51391,
                        "name": "Spofforth",
                        "latitude": "53.95427000",
                        "longitude": "-1.44848000"
                    },
                    {
                        "id": 51392,
                        "name": "Spratton",
                        "latitude": "52.32447000",
                        "longitude": "-0.95386000"
                    },
                    {
                        "id": 51394,
                        "name": "Sproatley",
                        "latitude": "53.79379000",
                        "longitude": "-0.19130000"
                    },
                    {
                        "id": 51395,
                        "name": "St Albans",
                        "latitude": "51.75000000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 51396,
                        "name": "St Austell",
                        "latitude": "50.34250000",
                        "longitude": "-4.77442000"
                    },
                    {
                        "id": 51397,
                        "name": "St Helens",
                        "latitude": "53.45000000",
                        "longitude": "-2.73333000"
                    },
                    {
                        "id": 51398,
                        "name": "St Ives",
                        "latitude": "50.20861000",
                        "longitude": "-5.48750000"
                    },
                    {
                        "id": 51399,
                        "name": "St Just",
                        "latitude": "50.12379000",
                        "longitude": "-5.68065000"
                    },
                    {
                        "id": 51400,
                        "name": "St Leonards",
                        "latitude": "50.83077000",
                        "longitude": "-1.84377000"
                    },
                    {
                        "id": 51401,
                        "name": "St Mary's",
                        "latitude": "49.91719000",
                        "longitude": "-6.29517000"
                    },
                    {
                        "id": 51402,
                        "name": "St Mary's Bay",
                        "latitude": "51.01003000",
                        "longitude": "0.97710000"
                    },
                    {
                        "id": 51403,
                        "name": "St. Day",
                        "latitude": "50.23958000",
                        "longitude": "-5.18572000"
                    },
                    {
                        "id": 51404,
                        "name": "St. Helens",
                        "latitude": "50.69688000",
                        "longitude": "-1.11159000"
                    },
                    {
                        "id": 51405,
                        "name": "Stafford",
                        "latitude": "52.80521000",
                        "longitude": "-2.11636000"
                    },
                    {
                        "id": 51406,
                        "name": "Staffordshire",
                        "latitude": "52.83333000",
                        "longitude": "-2.00000000"
                    },
                    {
                        "id": 51407,
                        "name": "Stagsden",
                        "latitude": "52.13046000",
                        "longitude": "-0.56678000"
                    },
                    {
                        "id": 51408,
                        "name": "Stainburn",
                        "latitude": "53.93333000",
                        "longitude": "-1.61667000"
                    },
                    {
                        "id": 51409,
                        "name": "Staindrop",
                        "latitude": "54.58102000",
                        "longitude": "-1.80708000"
                    },
                    {
                        "id": 51410,
                        "name": "Staines",
                        "latitude": "51.43092000",
                        "longitude": "-0.50606000"
                    },
                    {
                        "id": 51411,
                        "name": "Stainforth",
                        "latitude": "53.60000000",
                        "longitude": "-1.03333000"
                    },
                    {
                        "id": 51412,
                        "name": "Stakeford",
                        "latitude": "55.16110000",
                        "longitude": "-1.57529000"
                    },
                    {
                        "id": 51413,
                        "name": "Stalbridge",
                        "latitude": "50.95807000",
                        "longitude": "-2.37548000"
                    },
                    {
                        "id": 51414,
                        "name": "Stalham",
                        "latitude": "52.77079000",
                        "longitude": "1.51783000"
                    },
                    {
                        "id": 51415,
                        "name": "Stallingborough",
                        "latitude": "53.58675000",
                        "longitude": "-0.18489000"
                    },
                    {
                        "id": 51416,
                        "name": "Stalybridge",
                        "latitude": "53.48414000",
                        "longitude": "-2.05908000"
                    },
                    {
                        "id": 51417,
                        "name": "Stamford",
                        "latitude": "52.65000000",
                        "longitude": "-0.48333000"
                    },
                    {
                        "id": 51418,
                        "name": "Stamford Bridge",
                        "latitude": "53.98850000",
                        "longitude": "-0.91547000"
                    },
                    {
                        "id": 51419,
                        "name": "Stanbridge",
                        "latitude": "51.90864000",
                        "longitude": "-0.59815000"
                    },
                    {
                        "id": 51420,
                        "name": "Standlake",
                        "latitude": "51.72690000",
                        "longitude": "-1.42436000"
                    },
                    {
                        "id": 51421,
                        "name": "Standon",
                        "latitude": "52.91667000",
                        "longitude": "-2.28333000"
                    },
                    {
                        "id": 51422,
                        "name": "Stanford in the Vale",
                        "latitude": "51.63969000",
                        "longitude": "-1.50652000"
                    },
                    {
                        "id": 51423,
                        "name": "Stanford-le-Hope",
                        "latitude": "51.52274000",
                        "longitude": "0.43422000"
                    },
                    {
                        "id": 51424,
                        "name": "Stanhope",
                        "latitude": "54.75000000",
                        "longitude": "-2.01667000"
                    },
                    {
                        "id": 51426,
                        "name": "Stanley",
                        "latitude": "54.86796000",
                        "longitude": "-1.69846000"
                    },
                    {
                        "id": 51427,
                        "name": "Stanmore",
                        "latitude": "51.61667000",
                        "longitude": "-0.31667000"
                    },
                    {
                        "id": 51428,
                        "name": "Stannington",
                        "latitude": "55.10862000",
                        "longitude": "-1.66855000"
                    },
                    {
                        "id": 51429,
                        "name": "Stansted Mountfitchet",
                        "latitude": "51.90000000",
                        "longitude": "0.20000000"
                    },
                    {
                        "id": 51430,
                        "name": "Stanwick",
                        "latitude": "52.33198000",
                        "longitude": "-0.56348000"
                    },
                    {
                        "id": 51431,
                        "name": "Staplehurst",
                        "latitude": "51.16110000",
                        "longitude": "0.55249000"
                    },
                    {
                        "id": 51432,
                        "name": "Starcross",
                        "latitude": "50.62734000",
                        "longitude": "-3.44797000"
                    },
                    {
                        "id": 51433,
                        "name": "Startforth",
                        "latitude": "54.53851000",
                        "longitude": "-1.93016000"
                    },
                    {
                        "id": 51434,
                        "name": "Staveley",
                        "latitude": "53.26667000",
                        "longitude": "-1.35000000"
                    },
                    {
                        "id": 51435,
                        "name": "Steeple Bumpstead",
                        "latitude": "52.04346000",
                        "longitude": "0.44808000"
                    },
                    {
                        "id": 51436,
                        "name": "Steeple Claydon",
                        "latitude": "51.93643000",
                        "longitude": "-0.98328000"
                    },
                    {
                        "id": 51437,
                        "name": "Steeton",
                        "latitude": "53.88333000",
                        "longitude": "-1.95000000"
                    },
                    {
                        "id": 51440,
                        "name": "Stevenage",
                        "latitude": "51.90224000",
                        "longitude": "-0.20256000"
                    },
                    {
                        "id": 51442,
                        "name": "Steventon",
                        "latitude": "51.62473000",
                        "longitude": "-1.32145000"
                    },
                    {
                        "id": 51443,
                        "name": "Stevington",
                        "latitude": "52.16848000",
                        "longitude": "-0.55515000"
                    },
                    {
                        "id": 51444,
                        "name": "Stewartby",
                        "latitude": "52.07044000",
                        "longitude": "-0.51490000"
                    },
                    {
                        "id": 51446,
                        "name": "Stewkley",
                        "latitude": "51.92744000",
                        "longitude": "-0.76381000"
                    },
                    {
                        "id": 51447,
                        "name": "Steyning",
                        "latitude": "50.88744000",
                        "longitude": "-0.32787000"
                    },
                    {
                        "id": 51449,
                        "name": "Stickney",
                        "latitude": "53.08949000",
                        "longitude": "0.00545000"
                    },
                    {
                        "id": 51450,
                        "name": "Stillington",
                        "latitude": "54.60529000",
                        "longitude": "-1.42191000"
                    },
                    {
                        "id": 51451,
                        "name": "Stilton",
                        "latitude": "52.48788000",
                        "longitude": "-0.28894000"
                    },
                    {
                        "id": 51453,
                        "name": "Stithians",
                        "latitude": "50.18870000",
                        "longitude": "-5.17807000"
                    },
                    {
                        "id": 51454,
                        "name": "Stock",
                        "latitude": "51.66351000",
                        "longitude": "0.44263000"
                    },
                    {
                        "id": 51455,
                        "name": "Stockport",
                        "latitude": "53.40979000",
                        "longitude": "-2.15761000"
                    },
                    {
                        "id": 51456,
                        "name": "Stocksbridge",
                        "latitude": "53.48249000",
                        "longitude": "-1.59373000"
                    },
                    {
                        "id": 51457,
                        "name": "Stocksfield",
                        "latitude": "54.94026000",
                        "longitude": "-1.90398000"
                    },
                    {
                        "id": 51458,
                        "name": "Stockton",
                        "latitude": "52.27181000",
                        "longitude": "-1.36055000"
                    },
                    {
                        "id": 51459,
                        "name": "Stockton Heath",
                        "latitude": "53.37084000",
                        "longitude": "-2.57406000"
                    },
                    {
                        "id": 51460,
                        "name": "Stockton-on-Tees",
                        "latitude": "54.55000000",
                        "longitude": "-1.33333000"
                    },
                    {
                        "id": 51461,
                        "name": "Stoke Ferry",
                        "latitude": "52.57051000",
                        "longitude": "0.51320000"
                    },
                    {
                        "id": 51462,
                        "name": "Stoke Gabriel",
                        "latitude": "50.40328000",
                        "longitude": "-3.62111000"
                    },
                    {
                        "id": 51463,
                        "name": "Stoke Gifford",
                        "latitude": "51.51686000",
                        "longitude": "-2.54053000"
                    },
                    {
                        "id": 51464,
                        "name": "Stoke Golding",
                        "latitude": "52.57060000",
                        "longitude": "-1.41124000"
                    },
                    {
                        "id": 51465,
                        "name": "Stoke Goldington",
                        "latitude": "52.13133000",
                        "longitude": "-0.77814000"
                    },
                    {
                        "id": 51466,
                        "name": "Stoke Poges",
                        "latitude": "51.54441000",
                        "longitude": "-0.58880000"
                    },
                    {
                        "id": 51467,
                        "name": "Stoke Prior",
                        "latitude": "52.29978000",
                        "longitude": "-2.08034000"
                    },
                    {
                        "id": 51468,
                        "name": "Stoke-on-Trent",
                        "latitude": "53.00415000",
                        "longitude": "-2.18538000"
                    },
                    {
                        "id": 51469,
                        "name": "Stoke-sub-Hamdon",
                        "latitude": "50.95397000",
                        "longitude": "-2.74971000"
                    },
                    {
                        "id": 51470,
                        "name": "Stokenchurch",
                        "latitude": "51.65831000",
                        "longitude": "-0.89740000"
                    },
                    {
                        "id": 51471,
                        "name": "Stokesley",
                        "latitude": "54.46998000",
                        "longitude": "-1.19330000"
                    },
                    {
                        "id": 51472,
                        "name": "Stone",
                        "latitude": "52.90590000",
                        "longitude": "-2.15409000"
                    },
                    {
                        "id": 51474,
                        "name": "Stonehouse",
                        "latitude": "51.75000000",
                        "longitude": "-2.28333000"
                    },
                    {
                        "id": 51476,
                        "name": "Stonesfield",
                        "latitude": "51.85142000",
                        "longitude": "-1.42960000"
                    },
                    {
                        "id": 51477,
                        "name": "Stoney Stanton",
                        "latitude": "52.54839000",
                        "longitude": "-1.27930000"
                    },
                    {
                        "id": 51480,
                        "name": "Storrington",
                        "latitude": "50.91765000",
                        "longitude": "-0.45473000"
                    },
                    {
                        "id": 51481,
                        "name": "Stotfold",
                        "latitude": "52.01632000",
                        "longitude": "-0.23209000"
                    },
                    {
                        "id": 51482,
                        "name": "Stourbridge",
                        "latitude": "52.45608000",
                        "longitude": "-2.14317000"
                    },
                    {
                        "id": 51483,
                        "name": "Stourport-on-Severn",
                        "latitude": "52.33976000",
                        "longitude": "-2.28034000"
                    },
                    {
                        "id": 51484,
                        "name": "Stow on the Wold",
                        "latitude": "51.93008000",
                        "longitude": "-1.72382000"
                    },
                    {
                        "id": 51485,
                        "name": "Stowmarket",
                        "latitude": "52.18893000",
                        "longitude": "0.99774000"
                    },
                    {
                        "id": 51487,
                        "name": "Stradbroke",
                        "latitude": "52.31819000",
                        "longitude": "1.27278000"
                    },
                    {
                        "id": 51489,
                        "name": "Stratfield Mortimer",
                        "latitude": "51.37339000",
                        "longitude": "-1.03495000"
                    },
                    {
                        "id": 51490,
                        "name": "Stratford-upon-Avon",
                        "latitude": "52.19166000",
                        "longitude": "-1.70734000"
                    },
                    {
                        "id": 51494,
                        "name": "Stratton",
                        "latitude": "51.73394000",
                        "longitude": "-1.97968000"
                    },
                    {
                        "id": 51495,
                        "name": "Streatley",
                        "latitude": "51.94628000",
                        "longitude": "-0.44374000"
                    },
                    {
                        "id": 51496,
                        "name": "Street",
                        "latitude": "51.12472000",
                        "longitude": "-2.74000000"
                    },
                    {
                        "id": 51497,
                        "name": "Streetly",
                        "latitude": "52.58333000",
                        "longitude": "-1.88333000"
                    },
                    {
                        "id": 51498,
                        "name": "Strensall",
                        "latitude": "54.03999000",
                        "longitude": "-1.03512000"
                    },
                    {
                        "id": 51499,
                        "name": "Stretford",
                        "latitude": "53.45000000",
                        "longitude": "-2.31667000"
                    },
                    {
                        "id": 51500,
                        "name": "Stretham",
                        "latitude": "52.34709000",
                        "longitude": "0.21852000"
                    },
                    {
                        "id": 51502,
                        "name": "Strood",
                        "latitude": "51.39323000",
                        "longitude": "0.47713000"
                    },
                    {
                        "id": 51503,
                        "name": "Stroud",
                        "latitude": "51.75000000",
                        "longitude": "-2.20000000"
                    },
                    {
                        "id": 51504,
                        "name": "Studley",
                        "latitude": "52.27026000",
                        "longitude": "-1.89188000"
                    },
                    {
                        "id": 51505,
                        "name": "Sturminster Marshall",
                        "latitude": "50.79968000",
                        "longitude": "-2.07615000"
                    },
                    {
                        "id": 51506,
                        "name": "Sturminster Newton",
                        "latitude": "50.92681000",
                        "longitude": "-2.30515000"
                    },
                    {
                        "id": 51507,
                        "name": "Sturry",
                        "latitude": "51.30132000",
                        "longitude": "1.12155000"
                    },
                    {
                        "id": 51508,
                        "name": "Sudbrooke",
                        "latitude": "53.26667000",
                        "longitude": "-0.45000000"
                    },
                    {
                        "id": 51509,
                        "name": "Sudbury",
                        "latitude": "52.03890000",
                        "longitude": "0.73117000"
                    },
                    {
                        "id": 51510,
                        "name": "Suffolk",
                        "latitude": "52.16667000",
                        "longitude": "1.00000000"
                    },
                    {
                        "id": 51511,
                        "name": "Sunbury-on-Thames",
                        "latitude": "51.40424000",
                        "longitude": "-0.41817000"
                    },
                    {
                        "id": 51512,
                        "name": "Sunderland",
                        "latitude": "54.90465000",
                        "longitude": "-1.38222000"
                    },
                    {
                        "id": 51513,
                        "name": "Sundridge",
                        "latitude": "51.27797000",
                        "longitude": "0.12231000"
                    },
                    {
                        "id": 51514,
                        "name": "Surbiton",
                        "latitude": "51.39148000",
                        "longitude": "-0.29825000"
                    },
                    {
                        "id": 51515,
                        "name": "Surrey",
                        "latitude": "51.25000000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 51516,
                        "name": "Sutterton",
                        "latitude": "52.90269000",
                        "longitude": "-0.09235000"
                    },
                    {
                        "id": 51517,
                        "name": "Sutton",
                        "latitude": "51.35000000",
                        "longitude": "-0.20000000"
                    },
                    {
                        "id": 51518,
                        "name": "Sutton Benger",
                        "latitude": "51.50685000",
                        "longitude": "-2.08015000"
                    },
                    {
                        "id": 51519,
                        "name": "Sutton Bonington",
                        "latitude": "52.82144000",
                        "longitude": "-1.24969000"
                    },
                    {
                        "id": 51520,
                        "name": "Sutton Bridge",
                        "latitude": "52.76995000",
                        "longitude": "0.18550000"
                    },
                    {
                        "id": 51521,
                        "name": "Sutton Coldfield",
                        "latitude": "52.56667000",
                        "longitude": "-1.81667000"
                    },
                    {
                        "id": 51522,
                        "name": "Sutton Courtenay",
                        "latitude": "51.64130000",
                        "longitude": "-1.27682000"
                    },
                    {
                        "id": 51523,
                        "name": "Sutton in Ashfield",
                        "latitude": "53.12542000",
                        "longitude": "-1.26135000"
                    },
                    {
                        "id": 51524,
                        "name": "Sutton on Trent",
                        "latitude": "53.18437000",
                        "longitude": "-0.81091000"
                    },
                    {
                        "id": 51525,
                        "name": "Sutton upon Derwent",
                        "latitude": "53.91314000",
                        "longitude": "-0.92465000"
                    },
                    {
                        "id": 51526,
                        "name": "Swadlincote",
                        "latitude": "52.77400000",
                        "longitude": "-1.55744000"
                    },
                    {
                        "id": 51527,
                        "name": "Swaffham",
                        "latitude": "52.64770000",
                        "longitude": "0.68570000"
                    },
                    {
                        "id": 51528,
                        "name": "Swanage",
                        "latitude": "50.60923000",
                        "longitude": "-1.96260000"
                    },
                    {
                        "id": 51529,
                        "name": "Swanley",
                        "latitude": "51.39717000",
                        "longitude": "0.17321000"
                    },
                    {
                        "id": 51530,
                        "name": "Swanmore",
                        "latitude": "50.94404000",
                        "longitude": "-1.18021000"
                    },
                    {
                        "id": 51531,
                        "name": "Swanscombe",
                        "latitude": "51.44713000",
                        "longitude": "0.31028000"
                    },
                    {
                        "id": 51533,
                        "name": "Swarthmoor",
                        "latitude": "54.18466000",
                        "longitude": "-3.11707000"
                    },
                    {
                        "id": 51534,
                        "name": "Swavesey",
                        "latitude": "52.30155000",
                        "longitude": "-0.00476000"
                    },
                    {
                        "id": 51535,
                        "name": "Sway",
                        "latitude": "50.78685000",
                        "longitude": "-1.60294000"
                    },
                    {
                        "id": 51536,
                        "name": "Swillington",
                        "latitude": "53.76846000",
                        "longitude": "-1.41750000"
                    },
                    {
                        "id": 51537,
                        "name": "Swindon",
                        "latitude": "51.55797000",
                        "longitude": "-1.78116000"
                    },
                    {
                        "id": 51538,
                        "name": "Swineshead",
                        "latitude": "52.94543000",
                        "longitude": "-0.15947000"
                    },
                    {
                        "id": 51539,
                        "name": "Swinton",
                        "latitude": "53.50000000",
                        "longitude": "-2.35000000"
                    },
                    {
                        "id": 51541,
                        "name": "Syston",
                        "latitude": "52.68333000",
                        "longitude": "-1.06667000"
                    },
                    {
                        "id": 51542,
                        "name": "Sywell",
                        "latitude": "52.29856000",
                        "longitude": "-0.79728000"
                    },
                    {
                        "id": 51543,
                        "name": "Tadcaster",
                        "latitude": "53.88322000",
                        "longitude": "-1.26344000"
                    },
                    {
                        "id": 51544,
                        "name": "Tadley",
                        "latitude": "51.35045000",
                        "longitude": "-1.12850000"
                    },
                    {
                        "id": 51545,
                        "name": "Tadworth",
                        "latitude": "51.29169000",
                        "longitude": "-0.23582000"
                    },
                    {
                        "id": 51548,
                        "name": "Takeley",
                        "latitude": "51.87089000",
                        "longitude": "0.26583000"
                    },
                    {
                        "id": 51552,
                        "name": "Tamworth",
                        "latitude": "52.63399000",
                        "longitude": "-1.69587000"
                    },
                    {
                        "id": 51554,
                        "name": "Tanfield",
                        "latitude": "54.89288000",
                        "longitude": "-1.71316000"
                    },
                    {
                        "id": 51555,
                        "name": "Tangmere",
                        "latitude": "50.85131000",
                        "longitude": "-0.71633000"
                    },
                    {
                        "id": 51556,
                        "name": "Tankerton",
                        "latitude": "51.36370000",
                        "longitude": "1.04913000"
                    },
                    {
                        "id": 51557,
                        "name": "Tansley",
                        "latitude": "53.13197000",
                        "longitude": "-1.51882000"
                    },
                    {
                        "id": 51560,
                        "name": "Tarleton",
                        "latitude": "53.68005000",
                        "longitude": "-2.82968000"
                    },
                    {
                        "id": 51561,
                        "name": "Tarporley",
                        "latitude": "53.15918000",
                        "longitude": "-2.66867000"
                    },
                    {
                        "id": 51562,
                        "name": "Tarvin",
                        "latitude": "53.19737000",
                        "longitude": "-2.76548000"
                    },
                    {
                        "id": 51563,
                        "name": "Tattenhall",
                        "latitude": "53.12188000",
                        "longitude": "-2.76746000"
                    },
                    {
                        "id": 51564,
                        "name": "Taunton",
                        "latitude": "51.01494000",
                        "longitude": "-3.10293000"
                    },
                    {
                        "id": 51565,
                        "name": "Tavistock",
                        "latitude": "50.54944000",
                        "longitude": "-4.14418000"
                    },
                    {
                        "id": 51567,
                        "name": "Teddington",
                        "latitude": "51.42233000",
                        "longitude": "-0.33053000"
                    },
                    {
                        "id": 51568,
                        "name": "Teignmouth",
                        "latitude": "50.54768000",
                        "longitude": "-3.49637000"
                    },
                    {
                        "id": 51569,
                        "name": "Telford",
                        "latitude": "52.67659000",
                        "longitude": "-2.44926000"
                    },
                    {
                        "id": 51570,
                        "name": "Telford and Wrekin",
                        "latitude": "52.75000000",
                        "longitude": "-2.50000000"
                    },
                    {
                        "id": 51571,
                        "name": "Templecombe",
                        "latitude": "50.99908000",
                        "longitude": "-2.41578000"
                    },
                    {
                        "id": 51574,
                        "name": "Tempsford",
                        "latitude": "52.17051000",
                        "longitude": "-0.29586000"
                    },
                    {
                        "id": 51575,
                        "name": "Tenbury Wells",
                        "latitude": "52.31077000",
                        "longitude": "-2.59621000"
                    },
                    {
                        "id": 51577,
                        "name": "Tenterden",
                        "latitude": "51.06845000",
                        "longitude": "0.68776000"
                    },
                    {
                        "id": 51578,
                        "name": "Terrington Saint John",
                        "latitude": "52.70546000",
                        "longitude": "0.27389000"
                    },
                    {
                        "id": 51579,
                        "name": "Terrington St Clement",
                        "latitude": "52.75813000",
                        "longitude": "0.29732000"
                    },
                    {
                        "id": 51580,
                        "name": "Tetbury",
                        "latitude": "51.63944000",
                        "longitude": "-2.16222000"
                    },
                    {
                        "id": 51581,
                        "name": "Tetney",
                        "latitude": "53.49239000",
                        "longitude": "-0.02106000"
                    },
                    {
                        "id": 51582,
                        "name": "Tewkesbury",
                        "latitude": "51.99244000",
                        "longitude": "-2.16010000"
                    },
                    {
                        "id": 51583,
                        "name": "Teynham",
                        "latitude": "51.33045000",
                        "longitude": "0.80526000"
                    },
                    {
                        "id": 51584,
                        "name": "Thame",
                        "latitude": "51.74840000",
                        "longitude": "-0.97624000"
                    },
                    {
                        "id": 51585,
                        "name": "Thames Ditton",
                        "latitude": "51.38964000",
                        "longitude": "-0.33928000"
                    },
                    {
                        "id": 51586,
                        "name": "Thatcham",
                        "latitude": "51.40366000",
                        "longitude": "-1.26049000"
                    },
                    {
                        "id": 51587,
                        "name": "Thaxted",
                        "latitude": "51.95326000",
                        "longitude": "0.34478000"
                    },
                    {
                        "id": 51588,
                        "name": "The Boldons",
                        "latitude": "54.94260000",
                        "longitude": "-1.45349000"
                    },
                    {
                        "id": 51590,
                        "name": "Theale",
                        "latitude": "51.43694000",
                        "longitude": "-1.07700000"
                    },
                    {
                        "id": 51591,
                        "name": "Thetford",
                        "latitude": "52.41667000",
                        "longitude": "0.75000000"
                    },
                    {
                        "id": 51592,
                        "name": "Theydon Bois",
                        "latitude": "51.67426000",
                        "longitude": "0.09781000"
                    },
                    {
                        "id": 51593,
                        "name": "Thirsk",
                        "latitude": "54.23298000",
                        "longitude": "-1.34411000"
                    },
                    {
                        "id": 51594,
                        "name": "Thornaby-on-Tees",
                        "latitude": "54.53333000",
                        "longitude": "-1.30000000"
                    },
                    {
                        "id": 51595,
                        "name": "Thornbury",
                        "latitude": "51.60889000",
                        "longitude": "-2.52028000"
                    },
                    {
                        "id": 51596,
                        "name": "Thorne",
                        "latitude": "53.61122000",
                        "longitude": "-0.96308000"
                    },
                    {
                        "id": 51597,
                        "name": "Thorner",
                        "latitude": "53.86093000",
                        "longitude": "-1.42676000"
                    },
                    {
                        "id": 51598,
                        "name": "Thorney",
                        "latitude": "52.62147000",
                        "longitude": "-0.10815000"
                    },
                    {
                        "id": 51599,
                        "name": "Thorngumbald",
                        "latitude": "53.72100000",
                        "longitude": "-0.17175000"
                    },
                    {
                        "id": 51601,
                        "name": "Thornley",
                        "latitude": "54.75000000",
                        "longitude": "-1.43333000"
                    },
                    {
                        "id": 51604,
                        "name": "Thornton Dale",
                        "latitude": "54.23528000",
                        "longitude": "-0.72016000"
                    },
                    {
                        "id": 51605,
                        "name": "Thornton Heath",
                        "latitude": "51.39884000",
                        "longitude": "-0.09872000"
                    },
                    {
                        "id": 51606,
                        "name": "Thornton-Cleveleys",
                        "latitude": "53.87389000",
                        "longitude": "-3.02244000"
                    },
                    {
                        "id": 51607,
                        "name": "Thorp Arch",
                        "latitude": "53.91584000",
                        "longitude": "-1.31980000"
                    },
                    {
                        "id": 51608,
                        "name": "Thorpe Hamlet",
                        "latitude": "52.62770000",
                        "longitude": "1.31175000"
                    },
                    {
                        "id": 51609,
                        "name": "Thorpe le Soken",
                        "latitude": "51.85603000",
                        "longitude": "1.16580000"
                    },
                    {
                        "id": 51610,
                        "name": "Thrapston",
                        "latitude": "52.39675000",
                        "longitude": "-0.53920000"
                    },
                    {
                        "id": 51612,
                        "name": "Three Legged Cross",
                        "latitude": "50.85000000",
                        "longitude": "-1.88333000"
                    },
                    {
                        "id": 51613,
                        "name": "Thurlby",
                        "latitude": "52.73879000",
                        "longitude": "-0.37868000"
                    },
                    {
                        "id": 51614,
                        "name": "Thurlton",
                        "latitude": "52.52881000",
                        "longitude": "1.55617000"
                    },
                    {
                        "id": 51616,
                        "name": "Thurston",
                        "latitude": "52.25244000",
                        "longitude": "0.80749000"
                    },
                    {
                        "id": 51617,
                        "name": "Tibshelf",
                        "latitude": "53.14436000",
                        "longitude": "-1.34056000"
                    },
                    {
                        "id": 51618,
                        "name": "Ticehurst",
                        "latitude": "51.04652000",
                        "longitude": "0.40860000"
                    },
                    {
                        "id": 51619,
                        "name": "Tickhill",
                        "latitude": "53.43194000",
                        "longitude": "-1.10859000"
                    },
                    {
                        "id": 51620,
                        "name": "Tickton",
                        "latitude": "53.86233000",
                        "longitude": "-0.38330000"
                    },
                    {
                        "id": 51621,
                        "name": "Tideswell",
                        "latitude": "53.27807000",
                        "longitude": "-1.77292000"
                    },
                    {
                        "id": 51622,
                        "name": "Tidworth",
                        "latitude": "51.23142000",
                        "longitude": "-1.66324000"
                    },
                    {
                        "id": 51623,
                        "name": "Tilbury",
                        "latitude": "51.46248000",
                        "longitude": "0.35856000"
                    },
                    {
                        "id": 51625,
                        "name": "Timperley",
                        "latitude": "53.40000000",
                        "longitude": "-2.33333000"
                    },
                    {
                        "id": 51626,
                        "name": "Timsbury",
                        "latitude": "51.32444000",
                        "longitude": "-2.47917000"
                    },
                    {
                        "id": 51627,
                        "name": "Tingewick",
                        "latitude": "51.99031000",
                        "longitude": "-1.04804000"
                    },
                    {
                        "id": 51628,
                        "name": "Tintagel",
                        "latitude": "50.66317000",
                        "longitude": "-4.75047000"
                    },
                    {
                        "id": 51630,
                        "name": "Tipton",
                        "latitude": "52.52956000",
                        "longitude": "-2.06773000"
                    },
                    {
                        "id": 51631,
                        "name": "Tiptree",
                        "latitude": "51.81230000",
                        "longitude": "0.74540000"
                    },
                    {
                        "id": 51632,
                        "name": "Tisbury",
                        "latitude": "51.06283000",
                        "longitude": "-2.08058000"
                    },
                    {
                        "id": 51633,
                        "name": "Tiverton",
                        "latitude": "50.90241000",
                        "longitude": "-3.49232000"
                    },
                    {
                        "id": 51635,
                        "name": "Toddington",
                        "latitude": "51.94922000",
                        "longitude": "-0.53277000"
                    },
                    {
                        "id": 51636,
                        "name": "Todmorden",
                        "latitude": "53.71434000",
                        "longitude": "-2.09701000"
                    },
                    {
                        "id": 51637,
                        "name": "Todwick",
                        "latitude": "53.35373000",
                        "longitude": "-1.25673000"
                    },
                    {
                        "id": 51638,
                        "name": "Tollesbury",
                        "latitude": "51.75913000",
                        "longitude": "0.83462000"
                    },
                    {
                        "id": 51639,
                        "name": "Tolleshunt Knights",
                        "latitude": "51.79869000",
                        "longitude": "0.77651000"
                    },
                    {
                        "id": 51640,
                        "name": "Tonbridge",
                        "latitude": "51.19532000",
                        "longitude": "0.27363000"
                    },
                    {
                        "id": 51643,
                        "name": "Topsham",
                        "latitude": "50.68596000",
                        "longitude": "-3.46696000"
                    },
                    {
                        "id": 51646,
                        "name": "Torpoint",
                        "latitude": "50.37505000",
                        "longitude": "-4.19566000"
                    },
                    {
                        "id": 51647,
                        "name": "Torquay",
                        "latitude": "50.46198000",
                        "longitude": "-3.52522000"
                    },
                    {
                        "id": 51649,
                        "name": "Totnes",
                        "latitude": "50.43107000",
                        "longitude": "-3.68430000"
                    },
                    {
                        "id": 51650,
                        "name": "Totternhoe",
                        "latitude": "51.88555000",
                        "longitude": "-0.57343000"
                    },
                    {
                        "id": 51651,
                        "name": "Tottington",
                        "latitude": "53.61326000",
                        "longitude": "-2.34071000"
                    },
                    {
                        "id": 51652,
                        "name": "Totton",
                        "latitude": "50.91877000",
                        "longitude": "-1.49037000"
                    },
                    {
                        "id": 51653,
                        "name": "Tow Law",
                        "latitude": "54.74456000",
                        "longitude": "-1.81434000"
                    },
                    {
                        "id": 51654,
                        "name": "Towcester",
                        "latitude": "52.13359000",
                        "longitude": "-0.99057000"
                    },
                    {
                        "id": 51655,
                        "name": "Town Row",
                        "latitude": "51.05302000",
                        "longitude": "0.23217000"
                    },
                    {
                        "id": 51657,
                        "name": "Trafford",
                        "latitude": "53.41667000",
                        "longitude": "-2.33333000"
                    },
                    {
                        "id": 51658,
                        "name": "Trafford Park",
                        "latitude": "53.46879000",
                        "longitude": "-2.31194000"
                    },
                    {
                        "id": 51662,
                        "name": "Treeton",
                        "latitude": "53.38564000",
                        "longitude": "-1.35189000"
                    },
                    {
                        "id": 51669,
                        "name": "Trimdon",
                        "latitude": "54.69878000",
                        "longitude": "-1.42881000"
                    },
                    {
                        "id": 51670,
                        "name": "Trimdon Grange",
                        "latitude": "54.71414000",
                        "longitude": "-1.42611000"
                    },
                    {
                        "id": 51672,
                        "name": "Tring",
                        "latitude": "51.79471000",
                        "longitude": "-0.65824000"
                    },
                    {
                        "id": 51674,
                        "name": "Trowbridge",
                        "latitude": "51.31889000",
                        "longitude": "-2.20861000"
                    },
                    {
                        "id": 51675,
                        "name": "Truro",
                        "latitude": "50.26526000",
                        "longitude": "-5.05436000"
                    },
                    {
                        "id": 51678,
                        "name": "Tunstall",
                        "latitude": "53.05830000",
                        "longitude": "-2.21140000"
                    },
                    {
                        "id": 51680,
                        "name": "Tuxford",
                        "latitude": "53.23004000",
                        "longitude": "-0.89325000"
                    },
                    {
                        "id": 51683,
                        "name": "Twyford",
                        "latitude": "51.47518000",
                        "longitude": "-0.86037000"
                    },
                    {
                        "id": 51685,
                        "name": "Tyldesley",
                        "latitude": "53.51393000",
                        "longitude": "-2.46754000"
                    },
                    {
                        "id": 51686,
                        "name": "Tynemouth",
                        "latitude": "55.01788000",
                        "longitude": "-1.42559000"
                    },
                    {
                        "id": 51687,
                        "name": "Tytherington",
                        "latitude": "51.59250000",
                        "longitude": "-2.47972000"
                    },
                    {
                        "id": 51689,
                        "name": "Uckfield",
                        "latitude": "50.96948000",
                        "longitude": "0.09589000"
                    },
                    {
                        "id": 51691,
                        "name": "Uffculme",
                        "latitude": "50.90604000",
                        "longitude": "-3.32746000"
                    },
                    {
                        "id": 51692,
                        "name": "Ulceby",
                        "latitude": "53.61667000",
                        "longitude": "-0.33333000"
                    },
                    {
                        "id": 51694,
                        "name": "Ulrome",
                        "latitude": "53.99198000",
                        "longitude": "-0.22968000"
                    },
                    {
                        "id": 51695,
                        "name": "Ulverston",
                        "latitude": "54.19594000",
                        "longitude": "-3.09626000"
                    },
                    {
                        "id": 51697,
                        "name": "Uny Lelant",
                        "latitude": "50.18298000",
                        "longitude": "-5.44047000"
                    },
                    {
                        "id": 51698,
                        "name": "Upchurch",
                        "latitude": "51.37620000",
                        "longitude": "0.64789000"
                    },
                    {
                        "id": 51699,
                        "name": "Upminster",
                        "latitude": "51.55594000",
                        "longitude": "0.25560000"
                    },
                    {
                        "id": 51700,
                        "name": "Upper Basildon",
                        "latitude": "51.48165000",
                        "longitude": "-1.14075000"
                    },
                    {
                        "id": 51701,
                        "name": "Upper Langwith",
                        "latitude": "53.22919000",
                        "longitude": "-1.20695000"
                    },
                    {
                        "id": 51702,
                        "name": "Upper Poppleton",
                        "latitude": "53.97907000",
                        "longitude": "-1.15204000"
                    },
                    {
                        "id": 51703,
                        "name": "Uppingham",
                        "latitude": "52.58803000",
                        "longitude": "-0.72272000"
                    },
                    {
                        "id": 51704,
                        "name": "Upton",
                        "latitude": "53.61466000",
                        "longitude": "-1.28677000"
                    },
                    {
                        "id": 51705,
                        "name": "Upton Scudamore",
                        "latitude": "51.23000000",
                        "longitude": "-2.19333000"
                    },
                    {
                        "id": 51706,
                        "name": "Upton upon Severn",
                        "latitude": "52.06258000",
                        "longitude": "-2.21802000"
                    },
                    {
                        "id": 51707,
                        "name": "Upwell",
                        "latitude": "52.60249000",
                        "longitude": "0.22190000"
                    },
                    {
                        "id": 51708,
                        "name": "Urmston",
                        "latitude": "53.44852000",
                        "longitude": "-2.35419000"
                    },
                    {
                        "id": 51709,
                        "name": "Ushaw Moor",
                        "latitude": "54.77803000",
                        "longitude": "-1.64720000"
                    },
                    {
                        "id": 51711,
                        "name": "Uttoxeter",
                        "latitude": "52.89838000",
                        "longitude": "-1.86488000"
                    },
                    {
                        "id": 51715,
                        "name": "Ventnor",
                        "latitude": "50.59449000",
                        "longitude": "-1.20672000"
                    },
                    {
                        "id": 51716,
                        "name": "Verwood",
                        "latitude": "50.87575000",
                        "longitude": "-1.87023000"
                    },
                    {
                        "id": 51719,
                        "name": "Virginia Water",
                        "latitude": "51.40343000",
                        "longitude": "-0.56651000"
                    },
                    {
                        "id": 51720,
                        "name": "Waddesdon",
                        "latitude": "51.84675000",
                        "longitude": "-0.92105000"
                    },
                    {
                        "id": 51721,
                        "name": "Waddington",
                        "latitude": "53.16667000",
                        "longitude": "-0.53333000"
                    },
                    {
                        "id": 51722,
                        "name": "Wadebridge",
                        "latitude": "50.51734000",
                        "longitude": "-4.83633000"
                    },
                    {
                        "id": 51723,
                        "name": "Wadhurst",
                        "latitude": "51.06230000",
                        "longitude": "0.33929000"
                    },
                    {
                        "id": 51724,
                        "name": "Wadworth",
                        "latitude": "53.46726000",
                        "longitude": "-1.14261000"
                    },
                    {
                        "id": 51725,
                        "name": "Wainfleet All Saints",
                        "latitude": "53.10570000",
                        "longitude": "0.23583000"
                    },
                    {
                        "id": 51726,
                        "name": "Wakefield",
                        "latitude": "53.68331000",
                        "longitude": "-1.49768000"
                    },
                    {
                        "id": 51727,
                        "name": "Walberton",
                        "latitude": "50.84475000",
                        "longitude": "-0.62013000"
                    },
                    {
                        "id": 51728,
                        "name": "Wales",
                        "latitude": "53.34061000",
                        "longitude": "-1.28162000"
                    },
                    {
                        "id": 51729,
                        "name": "Walkden",
                        "latitude": "53.51667000",
                        "longitude": "-2.40000000"
                    },
                    {
                        "id": 51730,
                        "name": "Walkern",
                        "latitude": "51.91888000",
                        "longitude": "-0.12758000"
                    },
                    {
                        "id": 51731,
                        "name": "Walkington",
                        "latitude": "53.81950000",
                        "longitude": "-0.48958000"
                    },
                    {
                        "id": 51732,
                        "name": "Wallasey",
                        "latitude": "53.42324000",
                        "longitude": "-3.06497000"
                    },
                    {
                        "id": 51733,
                        "name": "Wallingford",
                        "latitude": "51.59982000",
                        "longitude": "-1.12480000"
                    },
                    {
                        "id": 51734,
                        "name": "Wallsend",
                        "latitude": "54.99111000",
                        "longitude": "-1.53397000"
                    },
                    {
                        "id": 51735,
                        "name": "Walsall",
                        "latitude": "52.58333000",
                        "longitude": "-2.00000000"
                    },
                    {
                        "id": 51736,
                        "name": "Walsden",
                        "latitude": "53.69361000",
                        "longitude": "-2.10001000"
                    },
                    {
                        "id": 51737,
                        "name": "Waltham",
                        "latitude": "53.51667000",
                        "longitude": "-0.10000000"
                    },
                    {
                        "id": 51738,
                        "name": "Waltham Abbey",
                        "latitude": "51.68700000",
                        "longitude": "-0.00421000"
                    },
                    {
                        "id": 51739,
                        "name": "Waltham Cross",
                        "latitude": "51.68602000",
                        "longitude": "-0.03575000"
                    },
                    {
                        "id": 51740,
                        "name": "Walton",
                        "latitude": "53.22284000",
                        "longitude": "-1.46084000"
                    },
                    {
                        "id": 51741,
                        "name": "Walton-on-Thames",
                        "latitude": "51.38678000",
                        "longitude": "-0.41319000"
                    },
                    {
                        "id": 51742,
                        "name": "Walton-on-the-Naze",
                        "latitude": "51.84819000",
                        "longitude": "1.26738000"
                    },
                    {
                        "id": 51743,
                        "name": "Wanborough",
                        "latitude": "51.54263000",
                        "longitude": "-1.69837000"
                    },
                    {
                        "id": 51744,
                        "name": "Wansford",
                        "latitude": "52.57851000",
                        "longitude": "-0.42001000"
                    },
                    {
                        "id": 51745,
                        "name": "Wantage",
                        "latitude": "51.58846000",
                        "longitude": "-1.42565000"
                    },
                    {
                        "id": 51746,
                        "name": "Warboys",
                        "latitude": "52.40352000",
                        "longitude": "-0.07931000"
                    },
                    {
                        "id": 51747,
                        "name": "Wardle",
                        "latitude": "53.65000000",
                        "longitude": "-2.13333000"
                    },
                    {
                        "id": 51748,
                        "name": "Ware",
                        "latitude": "51.81058000",
                        "longitude": "-0.02875000"
                    },
                    {
                        "id": 51749,
                        "name": "Wareham",
                        "latitude": "50.68792000",
                        "longitude": "-2.11058000"
                    },
                    {
                        "id": 51750,
                        "name": "Wargrave",
                        "latitude": "51.50068000",
                        "longitude": "-0.86577000"
                    },
                    {
                        "id": 51752,
                        "name": "Warkworth",
                        "latitude": "55.35000000",
                        "longitude": "-1.61667000"
                    },
                    {
                        "id": 51753,
                        "name": "Warlingham",
                        "latitude": "51.30953000",
                        "longitude": "-0.05794000"
                    },
                    {
                        "id": 51754,
                        "name": "Warminster",
                        "latitude": "51.20434000",
                        "longitude": "-2.17873000"
                    },
                    {
                        "id": 51755,
                        "name": "Warnham",
                        "latitude": "51.09107000",
                        "longitude": "-0.34847000"
                    },
                    {
                        "id": 51757,
                        "name": "Warrington",
                        "latitude": "53.41667000",
                        "longitude": "-2.58333000"
                    },
                    {
                        "id": 51758,
                        "name": "Warsop",
                        "latitude": "53.21402000",
                        "longitude": "-1.15091000"
                    },
                    {
                        "id": 51759,
                        "name": "Warton",
                        "latitude": "54.14715000",
                        "longitude": "-2.76435000"
                    },
                    {
                        "id": 51760,
                        "name": "Warwick",
                        "latitude": "52.28333000",
                        "longitude": "-1.58333000"
                    },
                    {
                        "id": 51761,
                        "name": "Warwickshire",
                        "latitude": "52.33333000",
                        "longitude": "-1.58333000"
                    },
                    {
                        "id": 51762,
                        "name": "Washingborough",
                        "latitude": "53.22425000",
                        "longitude": "-0.47485000"
                    },
                    {
                        "id": 51763,
                        "name": "Washington",
                        "latitude": "54.90000000",
                        "longitude": "-1.51667000"
                    },
                    {
                        "id": 51764,
                        "name": "Washwood Heath",
                        "latitude": "52.50054000",
                        "longitude": "-1.82657000"
                    },
                    {
                        "id": 51765,
                        "name": "Watchet",
                        "latitude": "51.18189000",
                        "longitude": "-3.33079000"
                    },
                    {
                        "id": 51766,
                        "name": "Water Eaton",
                        "latitude": "51.98697000",
                        "longitude": "-0.72188000"
                    },
                    {
                        "id": 51767,
                        "name": "Water Orton",
                        "latitude": "52.51575000",
                        "longitude": "-1.74005000"
                    },
                    {
                        "id": 51768,
                        "name": "Waterbeach",
                        "latitude": "52.26553000",
                        "longitude": "0.19123000"
                    },
                    {
                        "id": 51770,
                        "name": "Wateringbury",
                        "latitude": "51.25543000",
                        "longitude": "0.42317000"
                    },
                    {
                        "id": 51771,
                        "name": "Waterloo",
                        "latitude": "53.47454000",
                        "longitude": "-3.03017000"
                    },
                    {
                        "id": 51772,
                        "name": "Waterlooville",
                        "latitude": "50.88067000",
                        "longitude": "-1.03040000"
                    },
                    {
                        "id": 51773,
                        "name": "Watford",
                        "latitude": "51.65531000",
                        "longitude": "-0.39602000"
                    },
                    {
                        "id": 51774,
                        "name": "Wath upon Dearne",
                        "latitude": "53.50291000",
                        "longitude": "-1.34580000"
                    },
                    {
                        "id": 51775,
                        "name": "Watlington",
                        "latitude": "51.64327000",
                        "longitude": "-1.00448000"
                    },
                    {
                        "id": 51776,
                        "name": "Wattisham",
                        "latitude": "52.12543000",
                        "longitude": "0.93864000"
                    },
                    {
                        "id": 51777,
                        "name": "Watton",
                        "latitude": "52.56667000",
                        "longitude": "0.83333000"
                    },
                    {
                        "id": 51778,
                        "name": "Watton at Stone",
                        "latitude": "51.85842000",
                        "longitude": "-0.11381000"
                    },
                    {
                        "id": 51779,
                        "name": "Weaverham",
                        "latitude": "53.26018000",
                        "longitude": "-2.57291000"
                    },
                    {
                        "id": 51780,
                        "name": "Wedmore",
                        "latitude": "51.22727000",
                        "longitude": "-2.81152000"
                    },
                    {
                        "id": 51781,
                        "name": "Wednesbury",
                        "latitude": "52.55140000",
                        "longitude": "-2.02355000"
                    },
                    {
                        "id": 51782,
                        "name": "Wednesfield",
                        "latitude": "52.59630000",
                        "longitude": "-2.08508000"
                    },
                    {
                        "id": 51783,
                        "name": "Weedon Beck",
                        "latitude": "52.22955000",
                        "longitude": "-1.08371000"
                    },
                    {
                        "id": 51784,
                        "name": "Weeting",
                        "latitude": "52.46440000",
                        "longitude": "0.61485000"
                    },
                    {
                        "id": 51785,
                        "name": "Welford",
                        "latitude": "52.41706000",
                        "longitude": "-1.05871000"
                    },
                    {
                        "id": 51786,
                        "name": "Wellesbourne",
                        "latitude": "52.19709000",
                        "longitude": "-1.59053000"
                    },
                    {
                        "id": 51787,
                        "name": "Wellesbourne Mountford",
                        "latitude": "52.19246000",
                        "longitude": "-1.60967000"
                    },
                    {
                        "id": 51788,
                        "name": "Welling",
                        "latitude": "51.46246000",
                        "longitude": "0.10759000"
                    },
                    {
                        "id": 51789,
                        "name": "Wellingborough",
                        "latitude": "52.30273000",
                        "longitude": "-0.69446000"
                    },
                    {
                        "id": 51790,
                        "name": "Wellington",
                        "latitude": "52.70000000",
                        "longitude": "-2.51667000"
                    },
                    {
                        "id": 51791,
                        "name": "Wellow",
                        "latitude": "51.32444000",
                        "longitude": "-2.37417000"
                    },
                    {
                        "id": 51792,
                        "name": "Wells",
                        "latitude": "51.20794000",
                        "longitude": "-2.64896000"
                    },
                    {
                        "id": 51793,
                        "name": "Wells-next-the-Sea",
                        "latitude": "52.95164000",
                        "longitude": "0.85110000"
                    },
                    {
                        "id": 51795,
                        "name": "Welwyn",
                        "latitude": "51.83310000",
                        "longitude": "-0.21359000"
                    },
                    {
                        "id": 51796,
                        "name": "Welwyn Garden City",
                        "latitude": "51.80174000",
                        "longitude": "-0.20691000"
                    },
                    {
                        "id": 51797,
                        "name": "Wem",
                        "latitude": "52.85835000",
                        "longitude": "-2.71826000"
                    },
                    {
                        "id": 51798,
                        "name": "Wembley",
                        "latitude": "51.55242000",
                        "longitude": "-0.29686000"
                    },
                    {
                        "id": 51799,
                        "name": "Wembury",
                        "latitude": "50.32272000",
                        "longitude": "-4.07529000"
                    },
                    {
                        "id": 51801,
                        "name": "Wendover",
                        "latitude": "51.76194000",
                        "longitude": "-0.73986000"
                    },
                    {
                        "id": 51802,
                        "name": "Wentworth",
                        "latitude": "53.47816000",
                        "longitude": "-1.41500000"
                    },
                    {
                        "id": 51804,
                        "name": "Weobley",
                        "latitude": "52.15960000",
                        "longitude": "-2.87500000"
                    },
                    {
                        "id": 51805,
                        "name": "West Bergholt",
                        "latitude": "51.91221000",
                        "longitude": "0.84986000"
                    },
                    {
                        "id": 51806,
                        "name": "West Berkshire",
                        "latitude": "51.41667000",
                        "longitude": "-1.25000000"
                    },
                    {
                        "id": 51807,
                        "name": "West Bridgford",
                        "latitude": "52.92979000",
                        "longitude": "-1.12537000"
                    },
                    {
                        "id": 51808,
                        "name": "West Bromwich",
                        "latitude": "52.51868000",
                        "longitude": "-1.99450000"
                    },
                    {
                        "id": 51809,
                        "name": "West Byfleet",
                        "latitude": "51.33764000",
                        "longitude": "-0.50649000"
                    },
                    {
                        "id": 51811,
                        "name": "West Clandon",
                        "latitude": "51.26063000",
                        "longitude": "-0.50323000"
                    },
                    {
                        "id": 51812,
                        "name": "West Coker",
                        "latitude": "50.91912000",
                        "longitude": "-2.68707000"
                    },
                    {
                        "id": 51813,
                        "name": "West Cornforth",
                        "latitude": "54.70286000",
                        "longitude": "-1.51938000"
                    },
                    {
                        "id": 51814,
                        "name": "West Drayton",
                        "latitude": "51.50000000",
                        "longitude": "-0.46667000"
                    },
                    {
                        "id": 51816,
                        "name": "West End",
                        "latitude": "50.92741000",
                        "longitude": "-1.33282000"
                    },
                    {
                        "id": 51817,
                        "name": "West End of London",
                        "latitude": "51.51414000",
                        "longitude": "-0.15510000"
                    },
                    {
                        "id": 51818,
                        "name": "West Haddon",
                        "latitude": "52.34168000",
                        "longitude": "-1.07804000"
                    },
                    {
                        "id": 51819,
                        "name": "West Hallam",
                        "latitude": "52.97093000",
                        "longitude": "-1.35846000"
                    },
                    {
                        "id": 51820,
                        "name": "West Horsley",
                        "latitude": "51.26033000",
                        "longitude": "-0.45563000"
                    },
                    {
                        "id": 51821,
                        "name": "West Ilsley",
                        "latitude": "51.53993000",
                        "longitude": "-1.32368000"
                    },
                    {
                        "id": 51823,
                        "name": "West Kingsdown",
                        "latitude": "51.34281000",
                        "longitude": "0.26127000"
                    },
                    {
                        "id": 51824,
                        "name": "West Kirby",
                        "latitude": "53.37302000",
                        "longitude": "-3.18417000"
                    },
                    {
                        "id": 51827,
                        "name": "West Malling",
                        "latitude": "51.29273000",
                        "longitude": "0.40907000"
                    },
                    {
                        "id": 51828,
                        "name": "West Mersea",
                        "latitude": "51.77798000",
                        "longitude": "0.91873000"
                    },
                    {
                        "id": 51829,
                        "name": "West Molesey",
                        "latitude": "51.39985000",
                        "longitude": "-0.37997000"
                    },
                    {
                        "id": 51830,
                        "name": "West Rainton",
                        "latitude": "54.81667000",
                        "longitude": "-1.50000000"
                    },
                    {
                        "id": 51831,
                        "name": "West Sussex",
                        "latitude": "51.00000000",
                        "longitude": "-0.41667000"
                    },
                    {
                        "id": 51832,
                        "name": "West Thurrock",
                        "latitude": "51.47828000",
                        "longitude": "0.27672000"
                    },
                    {
                        "id": 51833,
                        "name": "West Walton",
                        "latitude": "52.69782000",
                        "longitude": "0.17406000"
                    },
                    {
                        "id": 51834,
                        "name": "West Wellow",
                        "latitude": "50.97273000",
                        "longitude": "-1.58293000"
                    },
                    {
                        "id": 51835,
                        "name": "West Wickham",
                        "latitude": "51.36667000",
                        "longitude": "-0.01667000"
                    },
                    {
                        "id": 51836,
                        "name": "Westbury",
                        "latitude": "51.26000000",
                        "longitude": "-2.18750000"
                    },
                    {
                        "id": 51837,
                        "name": "Westcliff-on-Sea",
                        "latitude": "51.54424000",
                        "longitude": "0.69179000"
                    },
                    {
                        "id": 51838,
                        "name": "Westcott",
                        "latitude": "51.22438000",
                        "longitude": "-0.37195000"
                    },
                    {
                        "id": 51839,
                        "name": "Westergate",
                        "latitude": "50.83988000",
                        "longitude": "-0.67123000"
                    },
                    {
                        "id": 51840,
                        "name": "Westerham",
                        "latitude": "51.26632000",
                        "longitude": "0.06892000"
                    },
                    {
                        "id": 51841,
                        "name": "Westfield",
                        "latitude": "51.88333000",
                        "longitude": "-1.86667000"
                    },
                    {
                        "id": 51842,
                        "name": "Westgate on Sea",
                        "latitude": "51.38239000",
                        "longitude": "1.33673000"
                    },
                    {
                        "id": 51844,
                        "name": "Westhoughton",
                        "latitude": "53.54899000",
                        "longitude": "-2.52464000"
                    },
                    {
                        "id": 51845,
                        "name": "Weston",
                        "latitude": "53.06667000",
                        "longitude": "-2.40000000"
                    },
                    {
                        "id": 51846,
                        "name": "Weston Turville",
                        "latitude": "51.79168000",
                        "longitude": "-0.75767000"
                    },
                    {
                        "id": 51847,
                        "name": "Weston-super-Mare",
                        "latitude": "51.34603000",
                        "longitude": "-2.97665000"
                    },
                    {
                        "id": 51848,
                        "name": "Westoning",
                        "latitude": "51.98140000",
                        "longitude": "-0.49698000"
                    },
                    {
                        "id": 51849,
                        "name": "Westonzoyland",
                        "latitude": "51.10854000",
                        "longitude": "-2.92843000"
                    },
                    {
                        "id": 51851,
                        "name": "Westwood",
                        "latitude": "51.33462000",
                        "longitude": "-2.27975000"
                    },
                    {
                        "id": 51852,
                        "name": "Wetheral",
                        "latitude": "54.88401000",
                        "longitude": "-2.83327000"
                    },
                    {
                        "id": 51853,
                        "name": "Wetherby",
                        "latitude": "53.92836000",
                        "longitude": "-1.38672000"
                    },
                    {
                        "id": 51854,
                        "name": "Wetwang",
                        "latitude": "54.01750000",
                        "longitude": "-0.57738000"
                    },
                    {
                        "id": 51855,
                        "name": "Weybridge",
                        "latitude": "51.37178000",
                        "longitude": "-0.45975000"
                    },
                    {
                        "id": 51856,
                        "name": "Weymouth",
                        "latitude": "50.61448000",
                        "longitude": "-2.45991000"
                    },
                    {
                        "id": 51857,
                        "name": "Whaley Bridge",
                        "latitude": "53.33031000",
                        "longitude": "-1.98260000"
                    },
                    {
                        "id": 51858,
                        "name": "Whalley",
                        "latitude": "53.82209000",
                        "longitude": "-2.40712000"
                    },
                    {
                        "id": 51859,
                        "name": "Whaplode",
                        "latitude": "52.79934000",
                        "longitude": "-0.03639000"
                    },
                    {
                        "id": 51860,
                        "name": "Wheathampstead",
                        "latitude": "51.81148000",
                        "longitude": "-0.29371000"
                    },
                    {
                        "id": 51861,
                        "name": "Wheatley",
                        "latitude": "51.74731000",
                        "longitude": "-1.13936000"
                    },
                    {
                        "id": 51862,
                        "name": "Wheaton Aston",
                        "latitude": "52.71145000",
                        "longitude": "-2.22064000"
                    },
                    {
                        "id": 51863,
                        "name": "Wheldrake",
                        "latitude": "53.89624000",
                        "longitude": "-0.96303000"
                    },
                    {
                        "id": 51864,
                        "name": "Whickham",
                        "latitude": "54.94561000",
                        "longitude": "-1.67635000"
                    },
                    {
                        "id": 51865,
                        "name": "Whimple",
                        "latitude": "50.76649000",
                        "longitude": "-3.35655000"
                    },
                    {
                        "id": 51867,
                        "name": "Whitburn",
                        "latitude": "54.95333000",
                        "longitude": "-1.36861000"
                    },
                    {
                        "id": 51868,
                        "name": "Whitby",
                        "latitude": "54.48774000",
                        "longitude": "-0.61498000"
                    },
                    {
                        "id": 51869,
                        "name": "Whitchurch",
                        "latitude": "52.96667000",
                        "longitude": "-2.68333000"
                    },
                    {
                        "id": 51870,
                        "name": "White Waltham",
                        "latitude": "51.49225000",
                        "longitude": "-0.77239000"
                    },
                    {
                        "id": 51872,
                        "name": "Whitefield",
                        "latitude": "53.55000000",
                        "longitude": "-2.30000000"
                    },
                    {
                        "id": 51873,
                        "name": "Whitehaven",
                        "latitude": "54.54897000",
                        "longitude": "-3.58412000"
                    },
                    {
                        "id": 51876,
                        "name": "Whiteparish",
                        "latitude": "51.01041000",
                        "longitude": "-1.64855000"
                    },
                    {
                        "id": 51878,
                        "name": "Whitley",
                        "latitude": "51.39528000",
                        "longitude": "-2.16444000"
                    },
                    {
                        "id": 51879,
                        "name": "Whitley Bay",
                        "latitude": "55.03973000",
                        "longitude": "-1.44713000"
                    },
                    {
                        "id": 51880,
                        "name": "Whitstable",
                        "latitude": "51.36070000",
                        "longitude": "1.02570000"
                    },
                    {
                        "id": 51881,
                        "name": "Whittingham",
                        "latitude": "55.40115000",
                        "longitude": "-1.89340000"
                    },
                    {
                        "id": 51882,
                        "name": "Whittington",
                        "latitude": "52.67372000",
                        "longitude": "-1.76091000"
                    },
                    {
                        "id": 51883,
                        "name": "Whittlesey",
                        "latitude": "52.55804000",
                        "longitude": "-0.13016000"
                    },
                    {
                        "id": 51884,
                        "name": "Whittlesford",
                        "latitude": "52.11345000",
                        "longitude": "0.14969000"
                    },
                    {
                        "id": 51885,
                        "name": "Whitwell",
                        "latitude": "53.28333000",
                        "longitude": "-1.21667000"
                    },
                    {
                        "id": 51886,
                        "name": "Whitworth",
                        "latitude": "53.65601000",
                        "longitude": "-2.17710000"
                    },
                    {
                        "id": 51887,
                        "name": "Whyteleafe",
                        "latitude": "51.30808000",
                        "longitude": "-0.08429000"
                    },
                    {
                        "id": 51889,
                        "name": "Wick",
                        "latitude": "51.45306000",
                        "longitude": "-2.42361000"
                    },
                    {
                        "id": 51891,
                        "name": "Wickford",
                        "latitude": "51.61101000",
                        "longitude": "0.52331000"
                    },
                    {
                        "id": 51892,
                        "name": "Wickham",
                        "latitude": "50.89924000",
                        "longitude": "-1.18815000"
                    },
                    {
                        "id": 51893,
                        "name": "Wickham Bishops",
                        "latitude": "51.77830000",
                        "longitude": "0.66823000"
                    },
                    {
                        "id": 51894,
                        "name": "Wickham Market",
                        "latitude": "52.15298000",
                        "longitude": "1.36299000"
                    },
                    {
                        "id": 51895,
                        "name": "Wickwar",
                        "latitude": "51.59404000",
                        "longitude": "-2.39968000"
                    },
                    {
                        "id": 51896,
                        "name": "Wideopen",
                        "latitude": "55.04514000",
                        "longitude": "-1.62246000"
                    },
                    {
                        "id": 51897,
                        "name": "Widnes",
                        "latitude": "53.36180000",
                        "longitude": "-2.73406000"
                    },
                    {
                        "id": 51898,
                        "name": "Wigan",
                        "latitude": "53.54296000",
                        "longitude": "-2.63706000"
                    },
                    {
                        "id": 51899,
                        "name": "Wigmore",
                        "latitude": "52.31474000",
                        "longitude": "-2.85802000"
                    },
                    {
                        "id": 51900,
                        "name": "Wigston Magna",
                        "latitude": "52.58128000",
                        "longitude": "-1.09248000"
                    },
                    {
                        "id": 51901,
                        "name": "Wigton",
                        "latitude": "54.82482000",
                        "longitude": "-3.16114000"
                    },
                    {
                        "id": 51902,
                        "name": "Wilberfoss",
                        "latitude": "53.94854000",
                        "longitude": "-0.88945000"
                    },
                    {
                        "id": 51903,
                        "name": "Wilburton",
                        "latitude": "52.35191000",
                        "longitude": "0.17673000"
                    },
                    {
                        "id": 51904,
                        "name": "Willand",
                        "latitude": "50.88333000",
                        "longitude": "-3.36667000"
                    },
                    {
                        "id": 51905,
                        "name": "Willaston",
                        "latitude": "53.29550000",
                        "longitude": "-2.99732000"
                    },
                    {
                        "id": 51906,
                        "name": "Willenhall",
                        "latitude": "52.58514000",
                        "longitude": "-2.05934000"
                    },
                    {
                        "id": 51907,
                        "name": "Willingham",
                        "latitude": "52.31404000",
                        "longitude": "0.05776000"
                    },
                    {
                        "id": 51908,
                        "name": "Willington",
                        "latitude": "54.71667000",
                        "longitude": "-1.70000000"
                    },
                    {
                        "id": 51909,
                        "name": "Williton",
                        "latitude": "51.16236000",
                        "longitude": "-3.32208000"
                    },
                    {
                        "id": 51910,
                        "name": "Wilmcote",
                        "latitude": "52.22081000",
                        "longitude": "-1.76528000"
                    },
                    {
                        "id": 51911,
                        "name": "Wilmslow",
                        "latitude": "53.32803000",
                        "longitude": "-2.23148000"
                    },
                    {
                        "id": 51912,
                        "name": "Wilsden",
                        "latitude": "53.82084000",
                        "longitude": "-1.85959000"
                    },
                    {
                        "id": 51913,
                        "name": "Wilstead",
                        "latitude": "52.08088000",
                        "longitude": "-0.44889000"
                    },
                    {
                        "id": 51914,
                        "name": "Wilton",
                        "latitude": "51.07926000",
                        "longitude": "-1.86210000"
                    },
                    {
                        "id": 51915,
                        "name": "Wiltshire",
                        "latitude": "51.25000000",
                        "longitude": "-1.91667000"
                    },
                    {
                        "id": 51916,
                        "name": "Wimblington",
                        "latitude": "52.50925000",
                        "longitude": "0.08416000"
                    },
                    {
                        "id": 51917,
                        "name": "Wimborne Minster",
                        "latitude": "50.78333000",
                        "longitude": "-1.98333000"
                    },
                    {
                        "id": 51918,
                        "name": "Wincanton",
                        "latitude": "51.05676000",
                        "longitude": "-2.40574000"
                    },
                    {
                        "id": 51920,
                        "name": "Winchcombe",
                        "latitude": "51.95363000",
                        "longitude": "-1.96398000"
                    },
                    {
                        "id": 51921,
                        "name": "Winchelsea Beach",
                        "latitude": "50.91691000",
                        "longitude": "0.72158000"
                    },
                    {
                        "id": 51922,
                        "name": "Winchester",
                        "latitude": "51.06513000",
                        "longitude": "-1.31870000"
                    },
                    {
                        "id": 51923,
                        "name": "Windermere",
                        "latitude": "54.38086000",
                        "longitude": "-2.90709000"
                    },
                    {
                        "id": 51924,
                        "name": "Windlesham",
                        "latitude": "51.36509000",
                        "longitude": "-0.65476000"
                    },
                    {
                        "id": 51925,
                        "name": "Windsor",
                        "latitude": "51.48333000",
                        "longitude": "-0.60000000"
                    },
                    {
                        "id": 51927,
                        "name": "Winford",
                        "latitude": "51.38333000",
                        "longitude": "-2.66111000"
                    },
                    {
                        "id": 51928,
                        "name": "Wing",
                        "latitude": "51.89524000",
                        "longitude": "-0.71956000"
                    },
                    {
                        "id": 51929,
                        "name": "Wingate",
                        "latitude": "54.73242000",
                        "longitude": "-1.37896000"
                    },
                    {
                        "id": 51930,
                        "name": "Wingerworth",
                        "latitude": "53.20200000",
                        "longitude": "-1.43359000"
                    },
                    {
                        "id": 51931,
                        "name": "Wingham",
                        "latitude": "51.27168000",
                        "longitude": "1.21463000"
                    },
                    {
                        "id": 51932,
                        "name": "Wingrave",
                        "latitude": "51.86494000",
                        "longitude": "-0.74244000"
                    },
                    {
                        "id": 51933,
                        "name": "Winkleigh",
                        "latitude": "50.85581000",
                        "longitude": "-3.94300000"
                    },
                    {
                        "id": 51934,
                        "name": "Winscombe",
                        "latitude": "51.31810000",
                        "longitude": "-2.83224000"
                    },
                    {
                        "id": 51935,
                        "name": "Winsford",
                        "latitude": "53.19146000",
                        "longitude": "-2.52398000"
                    },
                    {
                        "id": 51936,
                        "name": "Winslow",
                        "latitude": "51.94284000",
                        "longitude": "-0.88131000"
                    },
                    {
                        "id": 51937,
                        "name": "Winterbourne",
                        "latitude": "51.44609000",
                        "longitude": "-1.34660000"
                    },
                    {
                        "id": 51938,
                        "name": "Winterton",
                        "latitude": "53.65497000",
                        "longitude": "-0.59885000"
                    },
                    {
                        "id": 51939,
                        "name": "Winwick",
                        "latitude": "53.43333000",
                        "longitude": "-2.60000000"
                    },
                    {
                        "id": 51940,
                        "name": "Wirksworth",
                        "latitude": "53.08232000",
                        "longitude": "-1.57391000"
                    },
                    {
                        "id": 51941,
                        "name": "Wisbech",
                        "latitude": "52.66622000",
                        "longitude": "0.15938000"
                    },
                    {
                        "id": 51943,
                        "name": "Witchford",
                        "latitude": "52.38699000",
                        "longitude": "0.20602000"
                    },
                    {
                        "id": 51944,
                        "name": "Witham",
                        "latitude": "51.80007000",
                        "longitude": "0.64038000"
                    },
                    {
                        "id": 51945,
                        "name": "Witheridge",
                        "latitude": "50.91743000",
                        "longitude": "-3.70351000"
                    },
                    {
                        "id": 51946,
                        "name": "Withernsea",
                        "latitude": "53.73110000",
                        "longitude": "0.03347000"
                    },
                    {
                        "id": 51947,
                        "name": "Witley",
                        "latitude": "51.14993000",
                        "longitude": "-0.64768000"
                    },
                    {
                        "id": 51948,
                        "name": "Witney",
                        "latitude": "51.78360000",
                        "longitude": "-1.48540000"
                    },
                    {
                        "id": 51949,
                        "name": "Wittering",
                        "latitude": "52.60698000",
                        "longitude": "-0.44048000"
                    },
                    {
                        "id": 51950,
                        "name": "Witton Gilbert",
                        "latitude": "54.80572000",
                        "longitude": "-1.63686000"
                    },
                    {
                        "id": 51951,
                        "name": "Wiveliscombe",
                        "latitude": "51.04139000",
                        "longitude": "-3.31278000"
                    },
                    {
                        "id": 51952,
                        "name": "Wivelsfield Green",
                        "latitude": "50.96313000",
                        "longitude": "-0.07133000"
                    },
                    {
                        "id": 51953,
                        "name": "Wivenhoe",
                        "latitude": "51.85553000",
                        "longitude": "0.95796000"
                    },
                    {
                        "id": 51954,
                        "name": "Woburn",
                        "latitude": "51.98865000",
                        "longitude": "-0.61903000"
                    },
                    {
                        "id": 51955,
                        "name": "Woburn Sands",
                        "latitude": "52.01579000",
                        "longitude": "-0.64982000"
                    },
                    {
                        "id": 51956,
                        "name": "Woking",
                        "latitude": "51.31903000",
                        "longitude": "-0.55893000"
                    },
                    {
                        "id": 51957,
                        "name": "Wokingham",
                        "latitude": "51.41667000",
                        "longitude": "-0.91667000"
                    },
                    {
                        "id": 51958,
                        "name": "Wold Newton",
                        "latitude": "54.14280000",
                        "longitude": "-0.39993000"
                    },
                    {
                        "id": 51959,
                        "name": "Woldingham",
                        "latitude": "51.28527000",
                        "longitude": "-0.03372000"
                    },
                    {
                        "id": 51960,
                        "name": "Wollaston",
                        "latitude": "52.25794000",
                        "longitude": "-0.67038000"
                    },
                    {
                        "id": 51961,
                        "name": "Wolsingham",
                        "latitude": "54.73085000",
                        "longitude": "-1.88319000"
                    },
                    {
                        "id": 51962,
                        "name": "Wolston",
                        "latitude": "52.37717000",
                        "longitude": "-1.39544000"
                    },
                    {
                        "id": 51963,
                        "name": "Wolvercote",
                        "latitude": "51.78406000",
                        "longitude": "-1.29338000"
                    },
                    {
                        "id": 51964,
                        "name": "Wolverhampton",
                        "latitude": "52.58333000",
                        "longitude": "-2.11667000"
                    },
                    {
                        "id": 51965,
                        "name": "Wombourn",
                        "latitude": "52.53333000",
                        "longitude": "-2.18333000"
                    },
                    {
                        "id": 51966,
                        "name": "Wombwell",
                        "latitude": "53.52189000",
                        "longitude": "-1.39698000"
                    },
                    {
                        "id": 51967,
                        "name": "Wood Street Village",
                        "latitude": "51.25098000",
                        "longitude": "-0.63695000"
                    },
                    {
                        "id": 51968,
                        "name": "Woodborough",
                        "latitude": "51.33852000",
                        "longitude": "-1.83976000"
                    },
                    {
                        "id": 51969,
                        "name": "Woodbridge",
                        "latitude": "52.09332000",
                        "longitude": "1.32042000"
                    },
                    {
                        "id": 51970,
                        "name": "Woodbury",
                        "latitude": "50.67664000",
                        "longitude": "-3.40160000"
                    },
                    {
                        "id": 51971,
                        "name": "Woodchurch",
                        "latitude": "51.07605000",
                        "longitude": "0.77346000"
                    },
                    {
                        "id": 51972,
                        "name": "Woodcote",
                        "latitude": "52.73333000",
                        "longitude": "-2.33333000"
                    },
                    {
                        "id": 51973,
                        "name": "Woodford",
                        "latitude": "52.38231000",
                        "longitude": "-0.58099000"
                    },
                    {
                        "id": 51974,
                        "name": "Woodford Green",
                        "latitude": "51.60938000",
                        "longitude": "0.02329000"
                    },
                    {
                        "id": 51975,
                        "name": "Woodhall Spa",
                        "latitude": "53.15215000",
                        "longitude": "-0.21453000"
                    },
                    {
                        "id": 51976,
                        "name": "Woodsetts",
                        "latitude": "53.34804000",
                        "longitude": "-1.17204000"
                    },
                    {
                        "id": 51977,
                        "name": "Woodstock",
                        "latitude": "51.84850000",
                        "longitude": "-1.35132000"
                    },
                    {
                        "id": 51978,
                        "name": "Wool",
                        "latitude": "50.67966000",
                        "longitude": "-2.21890000"
                    },
                    {
                        "id": 51979,
                        "name": "Woolavington",
                        "latitude": "51.16493000",
                        "longitude": "-2.93814000"
                    },
                    {
                        "id": 51980,
                        "name": "Wooler",
                        "latitude": "55.54755000",
                        "longitude": "-2.01186000"
                    },
                    {
                        "id": 51981,
                        "name": "Woolley",
                        "latitude": "53.61339000",
                        "longitude": "-1.51457000"
                    },
                    {
                        "id": 51982,
                        "name": "Woolpit",
                        "latitude": "52.22454000",
                        "longitude": "0.88826000"
                    },
                    {
                        "id": 51983,
                        "name": "Wootton",
                        "latitude": "51.17380000",
                        "longitude": "1.17940000"
                    },
                    {
                        "id": 51984,
                        "name": "Worcester",
                        "latitude": "52.18935000",
                        "longitude": "-2.22001000"
                    },
                    {
                        "id": 51985,
                        "name": "Worcester Park",
                        "latitude": "51.37992000",
                        "longitude": "-0.24445000"
                    },
                    {
                        "id": 51986,
                        "name": "Worcestershire",
                        "latitude": "52.16667000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 51987,
                        "name": "Workington",
                        "latitude": "54.64250000",
                        "longitude": "-3.54413000"
                    },
                    {
                        "id": 51988,
                        "name": "Worksop",
                        "latitude": "53.30182000",
                        "longitude": "-1.12404000"
                    },
                    {
                        "id": 51989,
                        "name": "Worlaby",
                        "latitude": "53.61130000",
                        "longitude": "-0.46685000"
                    },
                    {
                        "id": 51990,
                        "name": "Wormley",
                        "latitude": "51.13622000",
                        "longitude": "-0.64673000"
                    },
                    {
                        "id": 51991,
                        "name": "Worthing",
                        "latitude": "50.81795000",
                        "longitude": "-0.37538000"
                    },
                    {
                        "id": 51992,
                        "name": "Worton",
                        "latitude": "51.31611000",
                        "longitude": "-2.04111000"
                    },
                    {
                        "id": 51993,
                        "name": "Wotton-under-Edge",
                        "latitude": "51.63242000",
                        "longitude": "-2.34512000"
                    },
                    {
                        "id": 51994,
                        "name": "Wouldham",
                        "latitude": "51.34986000",
                        "longitude": "0.45816000"
                    },
                    {
                        "id": 51995,
                        "name": "Wragby",
                        "latitude": "53.28333000",
                        "longitude": "-0.30000000"
                    },
                    {
                        "id": 51996,
                        "name": "Wrawby",
                        "latitude": "53.56672000",
                        "longitude": "-0.46194000"
                    },
                    {
                        "id": 51997,
                        "name": "Wrea Green",
                        "latitude": "53.77651000",
                        "longitude": "-2.91573000"
                    },
                    {
                        "id": 51999,
                        "name": "Wrington",
                        "latitude": "51.36173000",
                        "longitude": "-2.76319000"
                    },
                    {
                        "id": 52000,
                        "name": "Writtle",
                        "latitude": "51.72906000",
                        "longitude": "0.42938000"
                    },
                    {
                        "id": 52001,
                        "name": "Wrotham",
                        "latitude": "51.30856000",
                        "longitude": "0.30899000"
                    },
                    {
                        "id": 52002,
                        "name": "Wroughton",
                        "latitude": "51.52411000",
                        "longitude": "-1.79559000"
                    },
                    {
                        "id": 52003,
                        "name": "Wroxall",
                        "latitude": "52.33791000",
                        "longitude": "-1.66898000"
                    },
                    {
                        "id": 52004,
                        "name": "Wychbold",
                        "latitude": "52.29045000",
                        "longitude": "-2.11555000"
                    },
                    {
                        "id": 52005,
                        "name": "Wye",
                        "latitude": "51.18249000",
                        "longitude": "0.93678000"
                    },
                    {
                        "id": 52006,
                        "name": "Wylam",
                        "latitude": "54.97654000",
                        "longitude": "-1.82187000"
                    },
                    {
                        "id": 52007,
                        "name": "Wymeswold",
                        "latitude": "52.80536000",
                        "longitude": "-1.11288000"
                    },
                    {
                        "id": 52009,
                        "name": "Yalding",
                        "latitude": "51.22387000",
                        "longitude": "0.42920000"
                    },
                    {
                        "id": 52010,
                        "name": "Yapton",
                        "latitude": "50.82090000",
                        "longitude": "-0.61300000"
                    },
                    {
                        "id": 52011,
                        "name": "Yarm",
                        "latitude": "54.50364000",
                        "longitude": "-1.35793000"
                    },
                    {
                        "id": 52012,
                        "name": "Yarmouth",
                        "latitude": "50.70529000",
                        "longitude": "-1.49929000"
                    },
                    {
                        "id": 52013,
                        "name": "Yarnton",
                        "latitude": "51.80448000",
                        "longitude": "-1.31149000"
                    },
                    {
                        "id": 52014,
                        "name": "Yate",
                        "latitude": "51.54074000",
                        "longitude": "-2.41839000"
                    },
                    {
                        "id": 52015,
                        "name": "Yateley",
                        "latitude": "51.34305000",
                        "longitude": "-0.82985000"
                    },
                    {
                        "id": 52016,
                        "name": "Yatton",
                        "latitude": "51.38839000",
                        "longitude": "-2.82353000"
                    },
                    {
                        "id": 52017,
                        "name": "Yaxley",
                        "latitude": "52.51768000",
                        "longitude": "-0.25852000"
                    },
                    {
                        "id": 52018,
                        "name": "Yeadon",
                        "latitude": "53.86437000",
                        "longitude": "-1.68743000"
                    },
                    {
                        "id": 52019,
                        "name": "Yealmpton",
                        "latitude": "50.34856000",
                        "longitude": "-3.99877000"
                    },
                    {
                        "id": 52020,
                        "name": "Yelverton",
                        "latitude": "50.49290000",
                        "longitude": "-4.08382000"
                    },
                    {
                        "id": 52021,
                        "name": "Yeovil",
                        "latitude": "50.94159000",
                        "longitude": "-2.63211000"
                    },
                    {
                        "id": 52022,
                        "name": "Yetminster",
                        "latitude": "50.89579000",
                        "longitude": "-2.57959000"
                    },
                    {
                        "id": 52024,
                        "name": "York",
                        "latitude": "53.95763000",
                        "longitude": "-1.08271000"
                    },
                    {
                        "id": 52025,
                        "name": "Youlgreave",
                        "latitude": "53.17399000",
                        "longitude": "-1.69044000"
                    },
                    {
                        "id": 52026,
                        "name": "Yoxall",
                        "latitude": "52.76659000",
                        "longitude": "-1.79068000"
                    }
                ]
            },
            {
                "id": 2410,
                "name": "Essex",
                "iso2": "ESS",
                "latitude": "51.57424470",
                "longitude": "0.48567810",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2344,
                "name": "Falkirk",
                "iso2": "FAL",
                "latitude": "56.00187750",
                "longitude": "-3.78391310",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2531,
                "name": "Fermanagh",
                "iso2": "FER",
                "latitude": "54.34479780",
                "longitude": "-7.63842180",
                "type": "district council",
                "cities": []
            },
            {
                "id": 2366,
                "name": "Fermanagh and Omagh",
                "iso2": "FMO",
                "latitude": "54.44594080",
                "longitude": "-8.21513430",
                "type": "district",
                "cities": []
            },
            {
                "id": 2479,
                "name": "Fife",
                "iso2": "FIF",
                "latitude": "56.20820780",
                "longitude": "-3.14951750",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2437,
                "name": "Flintshire",
                "iso2": "FLN",
                "latitude": "53.16686580",
                "longitude": "-3.14189080",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2431,
                "name": "Gateshead",
                "iso2": "GAT",
                "latitude": "54.95268000",
                "longitude": "-1.60341100",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2404,
                "name": "Glasgow",
                "iso2": "GLG",
                "latitude": "55.86423700",
                "longitude": "-4.25180600",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2373,
                "name": "Gloucestershire",
                "iso2": "GLS",
                "latitude": "51.86421120",
                "longitude": "-2.23803350",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2492,
                "name": "Greenwich",
                "iso2": "GRE",
                "latitude": "51.48346270",
                "longitude": "0.05862020",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2379,
                "name": "Gwynedd",
                "iso2": "GWN",
                "latitude": "52.92772660",
                "longitude": "-4.13348360",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2411,
                "name": "Hackney",
                "iso2": "HCK",
                "latitude": "51.57344500",
                "longitude": "-0.07243760",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2466,
                "name": "Halton",
                "iso2": "HAL",
                "latitude": "43.53253720",
                "longitude": "-79.87448360",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2448,
                "name": "Hammersmith and Fulham",
                "iso2": "HMF",
                "latitude": "51.49901560",
                "longitude": "-0.22915000",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2435,
                "name": "Hampshire",
                "iso2": "HAM",
                "latitude": "51.05769480",
                "longitude": "-1.30806290",
                "type": "two-tier county",
                "cities": [
                    {
                        "id": 153926,
                        "name": "Basingstoke and Deane",
                        "latitude": "51.25869640",
                        "longitude": "-1.54714010"
                    },
                    {
                        "id": 153933,
                        "name": "Borough of Eastleigh",
                        "latitude": "50.92329300",
                        "longitude": "-1.49372050"
                    },
                    {
                        "id": 153934,
                        "name": "Borough of Fareham",
                        "latitude": "50.85415160",
                        "longitude": "-1.29500360"
                    },
                    {
                        "id": 153937,
                        "name": "Borough of Havant",
                        "latitude": "50.84054370",
                        "longitude": "-1.15549270"
                    },
                    {
                        "id": 153929,
                        "name": "City of Winchester",
                        "latitude": "51.02602660",
                        "longitude": "-1.57486330"
                    },
                    {
                        "id": 153930,
                        "name": "East Hampshire",
                        "latitude": "51.03996830",
                        "longitude": "-1.26791280"
                    },
                    {
                        "id": 153935,
                        "name": "Gosport",
                        "latitude": "50.80684660",
                        "longitude": "-1.23298150"
                    },
                    {
                        "id": 153927,
                        "name": "Hart",
                        "latitude": "51.27626210",
                        "longitude": "-1.04741840"
                    },
                    {
                        "id": 153931,
                        "name": "New Forest",
                        "latitude": "50.85755500",
                        "longitude": "-1.95892620"
                    },
                    {
                        "id": 153936,
                        "name": "Portsmouth",
                        "latitude": "50.80481520",
                        "longitude": "-1.17913160"
                    },
                    {
                        "id": 153928,
                        "name": "Rushmoor",
                        "latitude": "51.27534950",
                        "longitude": "-0.85084390"
                    },
                    {
                        "id": 153932,
                        "name": "Southampton",
                        "latitude": "50.98636630",
                        "longitude": "-1.94300190"
                    },
                    {
                        "id": 153925,
                        "name": "Test Valley",
                        "latitude": "51.13375560",
                        "longitude": "-1.83112950"
                    }
                ]
            },
            {
                "id": 2306,
                "name": "Haringey",
                "iso2": "HRY",
                "latitude": "51.59061130",
                "longitude": "-0.11097090",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2385,
                "name": "Harrow",
                "iso2": "HRW",
                "latitude": "51.58816270",
                "longitude": "-0.34228510",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2309,
                "name": "Hartlepool",
                "iso2": "HPL",
                "latitude": "54.69174500",
                "longitude": "-1.21292600",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2347,
                "name": "Havering",
                "iso2": "HAV",
                "latitude": "51.57792400",
                "longitude": "0.21208290",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2500,
                "name": "Herefordshire",
                "iso2": "HEF",
                "latitude": "52.07651640",
                "longitude": "-2.65441820",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2369,
                "name": "Hertfordshire",
                "iso2": "HRT",
                "latitude": "51.80978230",
                "longitude": "-0.23767440",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2383,
                "name": "Highland",
                "iso2": "HLD",
                "latitude": "36.29675080",
                "longitude": "-95.83803660",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2376,
                "name": "Hillingdon",
                "iso2": "HIL",
                "latitude": "51.53518320",
                "longitude": "-0.44813780",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2380,
                "name": "Hounslow",
                "iso2": "HNS",
                "latitude": "51.48283580",
                "longitude": "-0.38820620",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2388,
                "name": "Inverclyde",
                "iso2": "IVC",
                "latitude": "55.93165690",
                "longitude": "-4.68001580",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2289,
                "name": "Isle of Wight",
                "iso2": "IOW",
                "latitude": "50.69384790",
                "longitude": "-1.30473400",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2343,
                "name": "Isles of Scilly",
                "iso2": "IOS",
                "latitude": "49.92772610",
                "longitude": "-6.32749660",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2319,
                "name": "Islington",
                "iso2": "ISL",
                "latitude": "51.54650630",
                "longitude": "-0.10580580",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2368,
                "name": "Kensington and Chelsea",
                "iso2": "KEC",
                "latitude": "51.49908050",
                "longitude": "-0.19382530",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2464,
                "name": "Kent",
                "iso2": "KEN",
                "latitude": "51.19005020",
                "longitude": "-0.57462030",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2481,
                "name": "Kingston upon Thames",
                "iso2": "KTT",
                "latitude": "51.37811700",
                "longitude": "-0.29270900",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2371,
                "name": "Kirklees",
                "iso2": "KIR",
                "latitude": "53.59334320",
                "longitude": "-1.80095090",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2330,
                "name": "Knowsley",
                "iso2": "KWL",
                "latitude": "53.45459400",
                "longitude": "-2.85290700",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2396,
                "name": "Lambeth",
                "iso2": "LBH",
                "latitude": "51.45714770",
                "longitude": "-0.12306810",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2495,
                "name": "Lancashire",
                "iso2": "LAN",
                "latitude": "53.76322540",
                "longitude": "-2.70440520",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2515,
                "name": "Larne",
                "iso2": "LRN",
                "latitude": "54.85780030",
                "longitude": "-5.82362240",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2503,
                "name": "Leeds",
                "iso2": "LDS",
                "latitude": "53.80075540",
                "longitude": "-1.54907740",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2318,
                "name": "Leicester",
                "iso2": "LCE",
                "latitude": "52.63687780",
                "longitude": "-1.13975920",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2516,
                "name": "Leicestershire",
                "iso2": "LEC",
                "latitude": "52.77257100",
                "longitude": "-1.20521260",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2358,
                "name": "Lewisham",
                "iso2": "LEW",
                "latitude": "51.44145790",
                "longitude": "-0.01170060",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2382,
                "name": "Limavady",
                "iso2": "LMV",
                "latitude": "55.05168200",
                "longitude": "-6.94919440",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2355,
                "name": "Lincolnshire",
                "iso2": "LIN",
                "latitude": "52.94518890",
                "longitude": "-0.16012460",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2494,
                "name": "Lisburn",
                "iso2": "LSB",
                "latitude": "54.51643050",
                "longitude": "-6.14452050",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2460,
                "name": "Lisburn and Castlereagh",
                "iso2": "LBC",
                "latitude": "54.49815840",
                "longitude": "-6.13067910",
                "type": "district",
                "cities": []
            },
            {
                "id": 2340,
                "name": "Liverpool",
                "iso2": "LIV",
                "latitude": "32.65649810",
                "longitude": "-115.47632410",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2424,
                "name": "London",
                "iso2": "LND",
                "latitude": "51.51234430",
                "longitude": "-0.09098520",
                "type": "city",
                "cities": []
            },
            {
                "id": 2322,
                "name": "Magherafelt",
                "iso2": "MFT",
                "latitude": "54.75532790",
                "longitude": "-6.60774870",
                "type": "district council",
                "cities": []
            },
            {
                "id": 2398,
                "name": "Manchester",
                "iso2": "MAN",
                "latitude": "53.48075930",
                "longitude": "-2.24263050",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2381,
                "name": "Medway",
                "iso2": "MDW",
                "latitude": "42.14176410",
                "longitude": "-71.39672560",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2328,
                "name": "Merthyr Tydfil",
                "iso2": "MTY",
                "latitude": "51.74674740",
                "longitude": "-3.38132750",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2483,
                "name": "Merton",
                "iso2": "MRT",
                "latitude": "51.40977420",
                "longitude": "-0.21080840",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2429,
                "name": "Mid and East Antrim",
                "iso2": "MEA",
                "latitude": "54.93993410",
                "longitude": "-6.11374230",
                "type": "district",
                "cities": []
            },
            {
                "id": 2399,
                "name": "Mid Ulster",
                "iso2": "MUL",
                "latitude": "54.64113010",
                "longitude": "-6.75225490",
                "type": "district",
                "cities": []
            },
            {
                "id": 2332,
                "name": "Middlesbrough",
                "iso2": "MDB",
                "latitude": "54.57422700",
                "longitude": "-1.23495600",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2519,
                "name": "Midlothian",
                "iso2": "MLN",
                "latitude": "32.47533500",
                "longitude": "-97.01031810",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2416,
                "name": "Milton Keynes",
                "iso2": "MIK",
                "latitude": "52.08520380",
                "longitude": "-0.73331330",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2402,
                "name": "Monmouthshire",
                "iso2": "MON",
                "latitude": "51.81161000",
                "longitude": "-2.71634170",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2360,
                "name": "Moray",
                "iso2": "MRY",
                "latitude": "57.64984760",
                "longitude": "-3.31680390",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2348,
                "name": "Moyle",
                "iso2": "MYL",
                "latitude": "55.20473270",
                "longitude": "-6.25317400",
                "type": "district council",
                "cities": []
            },
            {
                "id": 2351,
                "name": "Neath Port Talbot",
                "iso2": "NTL",
                "latitude": "51.59785190",
                "longitude": "-3.78396680",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2458,
                "name": "Newcastle upon Tyne",
                "iso2": "NET",
                "latitude": "54.97825200",
                "longitude": "-1.61778000",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2418,
                "name": "Newham",
                "iso2": "NWM",
                "latitude": "51.52551620",
                "longitude": "0.03521630",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2524,
                "name": "Newport",
                "iso2": "NWP",
                "latitude": "37.52782340",
                "longitude": "-94.10438760",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2350,
                "name": "Newry and Mourne",
                "iso2": "NYM",
                "latitude": "54.17425050",
                "longitude": "-6.33919920",
                "type": "district council",
                "cities": []
            },
            {
                "id": 2534,
                "name": "Newry, Mourne and Down",
                "iso2": "NMD",
                "latitude": "54.25820030",
                "longitude": "-6.75378890",
                "type": "district",
                "cities": []
            },
            {
                "id": 2317,
                "name": "Newtownabbey",
                "iso2": "NTA",
                "latitude": "54.67924220",
                "longitude": "-5.95911020",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2473,
                "name": "Norfolk",
                "iso2": "NFK",
                "latitude": "36.85076890",
                "longitude": "-76.28587260",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2535,
                "name": "North Ayrshire",
                "iso2": "NAY",
                "latitude": "55.64167310",
                "longitude": "-4.75946000",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2513,
                "name": "North Down",
                "iso2": "NDN",
                "latitude": "54.65362970",
                "longitude": "-5.67249250",
                "type": "borough council",
                "cities": []
            },
            {
                "id": 2384,
                "name": "North East Lincolnshire",
                "iso2": "NEL",
                "latitude": "53.56682010",
                "longitude": "-0.08150660",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2487,
                "name": "North Lanarkshire",
                "iso2": "NLK",
                "latitude": "55.86624320",
                "longitude": "-3.96131440",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2453,
                "name": "North Lincolnshire",
                "iso2": "NLN",
                "latitude": "53.60555920",
                "longitude": "-0.55965820",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2430,
                "name": "North Somerset",
                "iso2": "NSM",
                "latitude": "51.38790280",
                "longitude": "-2.77810910",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2521,
                "name": "North Tyneside",
                "iso2": "NTY",
                "latitude": "55.01823990",
                "longitude": "-1.48584360",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2522,
                "name": "North Yorkshire",
                "iso2": "NYK",
                "latitude": "53.99150280",
                "longitude": "-1.54120150",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2480,
                "name": "Northamptonshire",
                "iso2": "NTH",
                "latitude": "52.27299440",
                "longitude": "-0.87555150",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2337,
                "name": "Northern Ireland",
                "iso2": "NIR",
                "latitude": "54.78771490",
                "longitude": "-6.49231450",
                "type": "province",
                "cities": [
                    {
                        "id": 48200,
                        "name": "Ahoghill",
                        "latitude": "54.86667000",
                        "longitude": "-6.36667000"
                    },
                    {
                        "id": 48253,
                        "name": "Annahilt",
                        "latitude": "54.43333000",
                        "longitude": "-6.00000000"
                    },
                    {
                        "id": 48254,
                        "name": "Annalong",
                        "latitude": "54.10823000",
                        "longitude": "-5.89966000"
                    },
                    {
                        "id": 48259,
                        "name": "Antrim",
                        "latitude": "54.70000000",
                        "longitude": "-6.20000000"
                    },
                    {
                        "id": 48260,
                        "name": "Antrim and Newtownabbey",
                        "latitude": "54.70177000",
                        "longitude": "-6.19770000"
                    },
                    {
                        "id": 48269,
                        "name": "Ardglass",
                        "latitude": "54.26312000",
                        "longitude": "-5.60981000"
                    },
                    {
                        "id": 48273,
                        "name": "Ards and North Down",
                        "latitude": "54.53439000",
                        "longitude": "-5.62947000"
                    },
                    {
                        "id": 48277,
                        "name": "Armagh",
                        "latitude": "54.35000000",
                        "longitude": "-6.66667000"
                    },
                    {
                        "id": 48278,
                        "name": "Armagh City Banbridge and Craigavon",
                        "latitude": "54.36922000",
                        "longitude": "-6.45651000"
                    },
                    {
                        "id": 48347,
                        "name": "Ballinamallard",
                        "latitude": "54.40000000",
                        "longitude": "-7.58333000"
                    },
                    {
                        "id": 48349,
                        "name": "Ballintoy Harbour",
                        "latitude": "55.24422000",
                        "longitude": "-6.36919000"
                    },
                    {
                        "id": 48351,
                        "name": "Ballycastle",
                        "latitude": "55.20444000",
                        "longitude": "-6.24298000"
                    },
                    {
                        "id": 48352,
                        "name": "Ballyclare",
                        "latitude": "54.75089000",
                        "longitude": "-5.99944000"
                    },
                    {
                        "id": 48353,
                        "name": "Ballygowan",
                        "latitude": "54.50165000",
                        "longitude": "-5.79168000"
                    },
                    {
                        "id": 48354,
                        "name": "Ballykelly",
                        "latitude": "55.04425000",
                        "longitude": "-7.01855000"
                    },
                    {
                        "id": 48355,
                        "name": "Ballymena",
                        "latitude": "54.86357000",
                        "longitude": "-6.27628000"
                    },
                    {
                        "id": 48356,
                        "name": "Ballymoney",
                        "latitude": "55.07080000",
                        "longitude": "-6.51009000"
                    },
                    {
                        "id": 48357,
                        "name": "Ballynahinch",
                        "latitude": "54.40230000",
                        "longitude": "-5.89717000"
                    },
                    {
                        "id": 48358,
                        "name": "Ballypatrick",
                        "latitude": "55.18112000",
                        "longitude": "-6.15020000"
                    },
                    {
                        "id": 48359,
                        "name": "Ballywalter",
                        "latitude": "54.54329000",
                        "longitude": "-5.48475000"
                    },
                    {
                        "id": 48366,
                        "name": "Banbridge",
                        "latitude": "54.35000000",
                        "longitude": "-6.28333000"
                    },
                    {
                        "id": 48371,
                        "name": "Bangor",
                        "latitude": "54.65338000",
                        "longitude": "-5.66895000"
                    },
                    {
                        "id": 48458,
                        "name": "Belfast",
                        "latitude": "54.59682000",
                        "longitude": "-5.92541000"
                    },
                    {
                        "id": 48460,
                        "name": "Bellaghy",
                        "latitude": "54.80870000",
                        "longitude": "-6.51918000"
                    },
                    {
                        "id": 48728,
                        "name": "Broughshane",
                        "latitude": "54.89260000",
                        "longitude": "-6.20899000"
                    },
                    {
                        "id": 48802,
                        "name": "Bushmills",
                        "latitude": "55.20493000",
                        "longitude": "-6.51918000"
                    },
                    {
                        "id": 48866,
                        "name": "Carnlough",
                        "latitude": "54.99185000",
                        "longitude": "-5.99038000"
                    },
                    {
                        "id": 48867,
                        "name": "Carnmoney",
                        "latitude": "54.68333000",
                        "longitude": "-5.95000000"
                    },
                    {
                        "id": 48870,
                        "name": "Carrickfergus",
                        "latitude": "54.71580000",
                        "longitude": "-5.80580000"
                    },
                    {
                        "id": 48873,
                        "name": "Carryduff",
                        "latitude": "54.51799000",
                        "longitude": "-5.88713000"
                    },
                    {
                        "id": 48881,
                        "name": "Castledawson",
                        "latitude": "54.77723000",
                        "longitude": "-6.56227000"
                    },
                    {
                        "id": 48882,
                        "name": "Castlederg",
                        "latitude": "54.70699000",
                        "longitude": "-7.59336000"
                    },
                    {
                        "id": 48884,
                        "name": "Castlereagh",
                        "latitude": "54.57350000",
                        "longitude": "-5.88472000"
                    },
                    {
                        "id": 48885,
                        "name": "Castlerock",
                        "latitude": "55.15000000",
                        "longitude": "-6.78333000"
                    },
                    {
                        "id": 48887,
                        "name": "Castlewellan",
                        "latitude": "54.25690000",
                        "longitude": "-5.94446000"
                    },
                    {
                        "id": 48896,
                        "name": "Causeway Coast and Glens",
                        "latitude": "55.06014000",
                        "longitude": "-6.59081000"
                    },
                    {
                        "id": 49006,
                        "name": "City of Belfast",
                        "latitude": "54.58333000",
                        "longitude": "-5.91667000"
                    },
                    {
                        "id": 49045,
                        "name": "Coalisland",
                        "latitude": "54.54180000",
                        "longitude": "-6.70166000"
                    },
                    {
                        "id": 49067,
                        "name": "Coleraine",
                        "latitude": "55.13333000",
                        "longitude": "-6.66667000"
                    },
                    {
                        "id": 49081,
                        "name": "Comber",
                        "latitude": "54.54937000",
                        "longitude": "-5.74379000"
                    },
                    {
                        "id": 49090,
                        "name": "Connor",
                        "latitude": "54.80000000",
                        "longitude": "-6.20000000"
                    },
                    {
                        "id": 49096,
                        "name": "Cookstown",
                        "latitude": "54.64305000",
                        "longitude": "-6.74595000"
                    },
                    {
                        "id": 49139,
                        "name": "Craigavon",
                        "latitude": "54.44709000",
                        "longitude": "-6.38700000"
                    },
                    {
                        "id": 49175,
                        "name": "Crossgar",
                        "latitude": "54.39675000",
                        "longitude": "-5.76061000"
                    },
                    {
                        "id": 49178,
                        "name": "Crossmaglen",
                        "latitude": "54.08333000",
                        "longitude": "-6.60000000"
                    },
                    {
                        "id": 49188,
                        "name": "Crumlin",
                        "latitude": "54.62054000",
                        "longitude": "-6.21414000"
                    },
                    {
                        "id": 49202,
                        "name": "Cullybackey",
                        "latitude": "54.88875000",
                        "longitude": "-6.34701000"
                    },
                    {
                        "id": 49203,
                        "name": "Culmore",
                        "latitude": "55.05000000",
                        "longitude": "-7.26667000"
                    },
                    {
                        "id": 49213,
                        "name": "Cushendall",
                        "latitude": "55.08033000",
                        "longitude": "-6.06291000"
                    },
                    {
                        "id": 49272,
                        "name": "Derry",
                        "latitude": "54.99810000",
                        "longitude": "-7.30934000"
                    },
                    {
                        "id": 49273,
                        "name": "Derry City and Strabane",
                        "latitude": "54.82045000",
                        "longitude": "-7.35958000"
                    },
                    {
                        "id": 49296,
                        "name": "Doagh",
                        "latitude": "54.75000000",
                        "longitude": "-6.08333000"
                    },
                    {
                        "id": 49302,
                        "name": "Donaghadee",
                        "latitude": "54.64126000",
                        "longitude": "-5.53591000"
                    },
                    {
                        "id": 49321,
                        "name": "Downpatrick",
                        "latitude": "54.32814000",
                        "longitude": "-5.71529000"
                    },
                    {
                        "id": 49323,
                        "name": "Draperstown",
                        "latitude": "54.80000000",
                        "longitude": "-6.76667000"
                    },
                    {
                        "id": 49328,
                        "name": "Dromore",
                        "latitude": "54.51331000",
                        "longitude": "-7.45886000"
                    },
                    {
                        "id": 49348,
                        "name": "Dundonald",
                        "latitude": "54.59196000",
                        "longitude": "-5.79803000"
                    },
                    {
                        "id": 49350,
                        "name": "Dundrum",
                        "latitude": "54.25750000",
                        "longitude": "-5.84455000"
                    },
                    {
                        "id": 49353,
                        "name": "Dungannon",
                        "latitude": "54.50344000",
                        "longitude": "-6.76723000"
                    },
                    {
                        "id": 49354,
                        "name": "Dungiven",
                        "latitude": "54.93333000",
                        "longitude": "-6.91667000"
                    },
                    {
                        "id": 49359,
                        "name": "Dunloy",
                        "latitude": "55.01100000",
                        "longitude": "-6.41087000"
                    },
                    {
                        "id": 49446,
                        "name": "Eglinton",
                        "latitude": "55.01667000",
                        "longitude": "-7.18333000"
                    },
                    {
                        "id": 49477,
                        "name": "Enniskillen",
                        "latitude": "54.34615000",
                        "longitude": "-7.64133000"
                    },
                    {
                        "id": 49545,
                        "name": "Fermanagh and Omagh",
                        "latitude": "54.44257000",
                        "longitude": "-7.50299000"
                    },
                    {
                        "id": 49560,
                        "name": "Fintona",
                        "latitude": "54.50000000",
                        "longitude": "-7.31667000"
                    },
                    {
                        "id": 49566,
                        "name": "Fivemiletown",
                        "latitude": "54.38333000",
                        "longitude": "-7.30000000"
                    },
                    {
                        "id": 49632,
                        "name": "Garvagh",
                        "latitude": "54.98333000",
                        "longitude": "-6.66667000"
                    },
                    {
                        "id": 49642,
                        "name": "Gilford",
                        "latitude": "54.37256000",
                        "longitude": "-6.36126000"
                    },
                    {
                        "id": 49655,
                        "name": "Glenariff",
                        "latitude": "55.05000000",
                        "longitude": "-6.06667000"
                    },
                    {
                        "id": 49656,
                        "name": "Glenavy",
                        "latitude": "54.59231000",
                        "longitude": "-6.21371000"
                    },
                    {
                        "id": 49746,
                        "name": "Greenisland",
                        "latitude": "54.70081000",
                        "longitude": "-5.87479000"
                    },
                    {
                        "id": 49751,
                        "name": "Greyabbey",
                        "latitude": "54.53483000",
                        "longitude": "-5.56028000"
                    },
                    {
                        "id": 49940,
                        "name": "Hillsborough",
                        "latitude": "54.46345000",
                        "longitude": "-6.07664000"
                    },
                    {
                        "id": 49975,
                        "name": "Holywood",
                        "latitude": "54.63863000",
                        "longitude": "-5.82473000"
                    },
                    {
                        "id": 50073,
                        "name": "Irvinestown",
                        "latitude": "54.46667000",
                        "longitude": "-7.63333000"
                    },
                    {
                        "id": 50097,
                        "name": "Jordanstown",
                        "latitude": "54.68333000",
                        "longitude": "-5.90000000"
                    },
                    {
                        "id": 50099,
                        "name": "Keady",
                        "latitude": "54.25000000",
                        "longitude": "-6.70000000"
                    },
                    {
                        "id": 50145,
                        "name": "Kilkeel",
                        "latitude": "54.06196000",
                        "longitude": "-6.00308000"
                    },
                    {
                        "id": 50148,
                        "name": "Killyleagh",
                        "latitude": "54.40135000",
                        "longitude": "-5.64800000"
                    },
                    {
                        "id": 50152,
                        "name": "Kilrea",
                        "latitude": "54.95091000",
                        "longitude": "-6.55695000"
                    },
                    {
                        "id": 50194,
                        "name": "Kircubbin",
                        "latitude": "54.48739000",
                        "longitude": "-5.53385000"
                    },
                    {
                        "id": 50253,
                        "name": "Larne",
                        "latitude": "54.85000000",
                        "longitude": "-5.81667000"
                    },
                    {
                        "id": 50303,
                        "name": "Limavady",
                        "latitude": "55.05045000",
                        "longitude": "-6.95074000"
                    },
                    {
                        "id": 50317,
                        "name": "Lisburn",
                        "latitude": "54.52337000",
                        "longitude": "-6.03527000"
                    },
                    {
                        "id": 50318,
                        "name": "Lisburn and Castlereagh",
                        "latitude": "54.50824000",
                        "longitude": "-6.05246000"
                    },
                    {
                        "id": 50320,
                        "name": "Lisnaskea",
                        "latitude": "54.25000000",
                        "longitude": "-7.45000000"
                    },
                    {
                        "id": 50389,
                        "name": "Londonderry County Borough",
                        "latitude": "54.99721000",
                        "longitude": "-7.30917000"
                    },
                    {
                        "id": 50466,
                        "name": "Maghera",
                        "latitude": "54.84390000",
                        "longitude": "-6.67145000"
                    },
                    {
                        "id": 50467,
                        "name": "Magherafelt",
                        "latitude": "54.75356000",
                        "longitude": "-6.60656000"
                    },
                    {
                        "id": 50468,
                        "name": "Magheralin",
                        "latitude": "54.46695000",
                        "longitude": "-6.25980000"
                    },
                    {
                        "id": 50568,
                        "name": "Mid and East Antrim",
                        "latitude": "54.87436000",
                        "longitude": "-6.10141000"
                    },
                    {
                        "id": 50567,
                        "name": "Mid Ulster",
                        "latitude": "54.62190000",
                        "longitude": "-6.79097000"
                    },
                    {
                        "id": 50585,
                        "name": "Millisle",
                        "latitude": "54.60638000",
                        "longitude": "-5.52973000"
                    },
                    {
                        "id": 50612,
                        "name": "Moira",
                        "latitude": "54.48021000",
                        "longitude": "-6.22822000"
                    },
                    {
                        "id": 50616,
                        "name": "Moneymore",
                        "latitude": "54.69229000",
                        "longitude": "-6.66956000"
                    },
                    {
                        "id": 50644,
                        "name": "Moy",
                        "latitude": "54.45000000",
                        "longitude": "-6.66667000"
                    },
                    {
                        "id": 50707,
                        "name": "Newcastle",
                        "latitude": "54.21804000",
                        "longitude": "-5.88979000"
                    },
                    {
                        "id": 50725,
                        "name": "Newry",
                        "latitude": "54.17841000",
                        "longitude": "-6.33739000"
                    },
                    {
                        "id": 50726,
                        "name": "Newry Mourne and Down",
                        "latitude": "54.23616000",
                        "longitude": "-6.06687000"
                    },
                    {
                        "id": 50739,
                        "name": "Newtownabbey",
                        "latitude": "54.65983000",
                        "longitude": "-5.90858000"
                    },
                    {
                        "id": 50740,
                        "name": "Newtownards",
                        "latitude": "54.59236000",
                        "longitude": "-5.69092000"
                    },
                    {
                        "id": 50741,
                        "name": "Newtownstewart",
                        "latitude": "54.71778000",
                        "longitude": "-7.37886000"
                    },
                    {
                        "id": 50811,
                        "name": "Omagh",
                        "latitude": "54.60000000",
                        "longitude": "-7.30000000"
                    },
                    {
                        "id": 50956,
                        "name": "Portadown",
                        "latitude": "54.42302000",
                        "longitude": "-6.44434000"
                    },
                    {
                        "id": 50957,
                        "name": "Portaferry",
                        "latitude": "54.38086000",
                        "longitude": "-5.54569000"
                    },
                    {
                        "id": 50958,
                        "name": "Portavogie",
                        "latitude": "54.45916000",
                        "longitude": "-5.44304000"
                    },
                    {
                        "id": 50959,
                        "name": "Portglenone",
                        "latitude": "54.87147000",
                        "longitude": "-6.47146000"
                    },
                    {
                        "id": 50968,
                        "name": "Portrush",
                        "latitude": "55.19592000",
                        "longitude": "-6.64930000"
                    },
                    {
                        "id": 50973,
                        "name": "Portstewart",
                        "latitude": "55.18132000",
                        "longitude": "-6.71402000"
                    },
                    {
                        "id": 51030,
                        "name": "Randalstown",
                        "latitude": "54.75000000",
                        "longitude": "-6.30000000"
                    },
                    {
                        "id": 51034,
                        "name": "Rathfriland",
                        "latitude": "54.25000000",
                        "longitude": "-6.16667000"
                    },
                    {
                        "id": 51113,
                        "name": "Rostrevor",
                        "latitude": "54.10000000",
                        "longitude": "-6.20000000"
                    },
                    {
                        "id": 51178,
                        "name": "Saintfield",
                        "latitude": "54.46046000",
                        "longitude": "-5.83065000"
                    },
                    {
                        "id": 51314,
                        "name": "Sion Mills",
                        "latitude": "54.78752000",
                        "longitude": "-7.47276000"
                    },
                    {
                        "id": 51486,
                        "name": "Strabane",
                        "latitude": "54.82373000",
                        "longitude": "-7.46916000"
                    },
                    {
                        "id": 51553,
                        "name": "Tandragee",
                        "latitude": "54.35486000",
                        "longitude": "-6.41396000"
                    },
                    {
                        "id": 51572,
                        "name": "Templepatrick",
                        "latitude": "54.68333000",
                        "longitude": "-6.08333000"
                    },
                    {
                        "id": 51751,
                        "name": "Waringstown",
                        "latitude": "54.43431000",
                        "longitude": "-6.29929000"
                    },
                    {
                        "id": 51756,
                        "name": "Warrenpoint",
                        "latitude": "54.10148000",
                        "longitude": "-6.25731000"
                    },
                    {
                        "id": 51874,
                        "name": "Whitehead",
                        "latitude": "54.75371000",
                        "longitude": "-5.70933000"
                    }
                ]
            },
            {
                "id": 2365,
                "name": "Northumberland",
                "iso2": "NBL",
                "latitude": "55.20825420",
                "longitude": "-2.07841380",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2359,
                "name": "Nottingham",
                "iso2": "NGM",
                "latitude": "52.95478320",
                "longitude": "-1.15810860",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2456,
                "name": "Nottinghamshire",
                "iso2": "NTT",
                "latitude": "53.10031900",
                "longitude": "-0.99363060",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2477,
                "name": "Oldham",
                "iso2": "OLD",
                "latitude": "42.20405980",
                "longitude": "-71.20481190",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2314,
                "name": "Omagh",
                "iso2": "OMH",
                "latitude": "54.45135240",
                "longitude": "-7.71250180",
                "type": "district council",
                "cities": []
            },
            {
                "id": 2474,
                "name": "Orkney Islands",
                "iso2": "ORK",
                "latitude": "58.98094010",
                "longitude": "-2.96052060",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2353,
                "name": "Outer Hebrides",
                "iso2": "ELS",
                "latitude": "57.75989180",
                "longitude": "-7.01940340",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2321,
                "name": "Oxfordshire",
                "iso2": "OXF",
                "latitude": "51.76120560",
                "longitude": "-1.24646740",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2486,
                "name": "Pembrokeshire",
                "iso2": "PEM",
                "latitude": "51.67407800",
                "longitude": "-4.90887850",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2325,
                "name": "Perth and Kinross",
                "iso2": "PKN",
                "latitude": "56.39538170",
                "longitude": "-3.42835470",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2297,
                "name": "Peterborough",
                "iso2": "PTE",
                "latitude": "44.30936360",
                "longitude": "-78.32015300",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2514,
                "name": "Plymouth",
                "iso2": "PLY",
                "latitude": "42.37089410",
                "longitude": "-83.46971410",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2302,
                "name": "Poole",
                "iso2": "POL",
                "latitude": "50.71505000",
                "longitude": "-1.98724800",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2305,
                "name": "Portsmouth",
                "iso2": "POR",
                "latitude": "36.83291500",
                "longitude": "-76.29755490",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2441,
                "name": "Powys",
                "iso2": "POW",
                "latitude": "52.64642490",
                "longitude": "-3.32609040",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2455,
                "name": "Reading",
                "iso2": "RDG",
                "latitude": "51.45153490",
                "longitude": "-1.07827620",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2397,
                "name": "Redbridge",
                "iso2": "RDB",
                "latitude": "51.58861210",
                "longitude": "0.08239820",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2527,
                "name": "Redcar and Cleveland",
                "iso2": "RCC",
                "latitude": "54.59713440",
                "longitude": "-1.07759970",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2443,
                "name": "Renfrewshire",
                "iso2": "RFW",
                "latitude": "55.84665400",
                "longitude": "-4.53312590",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2301,
                "name": "Rhondda Cynon Taf",
                "iso2": "RCT",
                "latitude": "51.64902070",
                "longitude": "-3.42886920",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2501,
                "name": "Richmond upon Thames",
                "iso2": "RIC",
                "latitude": "51.46130540",
                "longitude": "-0.30377090",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2327,
                "name": "Rochdale",
                "iso2": "RCH",
                "latitude": "53.60971360",
                "longitude": "-2.15610000",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2308,
                "name": "Rotherham",
                "iso2": "ROT",
                "latitude": "53.43260350",
                "longitude": "-1.36350090",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2472,
                "name": "Rutland",
                "iso2": "RUT",
                "latitude": "43.61062370",
                "longitude": "-72.97260650",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2502,
                "name": "Saint Helena",
                "iso2": "SH-HL",
                "latitude": "-15.96501040",
                "longitude": "-5.70892410",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2493,
                "name": "Salford",
                "iso2": "SLF",
                "latitude": "53.48752350",
                "longitude": "-2.29012640",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2341,
                "name": "Sandwell",
                "iso2": "SAW",
                "latitude": "52.53616740",
                "longitude": "-2.01079300",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2335,
                "name": "Scotland",
                "iso2": "SCT",
                "latitude": "56.49067120",
                "longitude": "-4.20264580",
                "type": "country",
                "cities": [
                    {
                        "id": 48165,
                        "name": "Aberchirder",
                        "latitude": "57.56012000",
                        "longitude": "-2.62856000"
                    },
                    {
                        "id": 48168,
                        "name": "Aberdeen",
                        "latitude": "57.14369000",
                        "longitude": "-2.09814000"
                    },
                    {
                        "id": 48169,
                        "name": "Aberdeen City",
                        "latitude": "57.16667000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 48170,
                        "name": "Aberdeenshire",
                        "latitude": "57.16667000",
                        "longitude": "-2.66667000"
                    },
                    {
                        "id": 48171,
                        "name": "Aberdour",
                        "latitude": "56.05417000",
                        "longitude": "-3.30058000"
                    },
                    {
                        "id": 48173,
                        "name": "Aberfeldy",
                        "latitude": "56.62196000",
                        "longitude": "-3.86693000"
                    },
                    {
                        "id": 48178,
                        "name": "Aberlady",
                        "latitude": "56.00884000",
                        "longitude": "-2.85851000"
                    },
                    {
                        "id": 48179,
                        "name": "Abernethy",
                        "latitude": "56.33247000",
                        "longitude": "-3.31226000"
                    },
                    {
                        "id": 48185,
                        "name": "Aboyne",
                        "latitude": "57.07546000",
                        "longitude": "-2.78023000"
                    },
                    {
                        "id": 48195,
                        "name": "Addiebrownhill",
                        "latitude": "55.84289000",
                        "longitude": "-3.61667000"
                    },
                    {
                        "id": 48201,
                        "name": "Airdrie",
                        "latitude": "55.86602000",
                        "longitude": "-3.98025000"
                    },
                    {
                        "id": 48203,
                        "name": "Airth",
                        "latitude": "56.06983000",
                        "longitude": "-3.77209000"
                    },
                    {
                        "id": 48216,
                        "name": "Alexandria",
                        "latitude": "55.99379000",
                        "longitude": "-4.58640000"
                    },
                    {
                        "id": 48218,
                        "name": "Alford",
                        "latitude": "57.23257000",
                        "longitude": "-2.70298000"
                    },
                    {
                        "id": 48220,
                        "name": "Allanton",
                        "latitude": "55.78333000",
                        "longitude": "-2.21667000"
                    },
                    {
                        "id": 48222,
                        "name": "Alloa",
                        "latitude": "56.11586000",
                        "longitude": "-3.78997000"
                    },
                    {
                        "id": 48223,
                        "name": "Almondbank",
                        "latitude": "56.41729000",
                        "longitude": "-3.51733000"
                    },
                    {
                        "id": 48225,
                        "name": "Alness",
                        "latitude": "57.69596000",
                        "longitude": "-4.25510000"
                    },
                    {
                        "id": 48234,
                        "name": "Alva",
                        "latitude": "56.15284000",
                        "longitude": "-3.80505000"
                    },
                    {
                        "id": 48238,
                        "name": "Alyth",
                        "latitude": "56.62209000",
                        "longitude": "-3.23005000"
                    },
                    {
                        "id": 48251,
                        "name": "Angus",
                        "latitude": "56.66667000",
                        "longitude": "-2.91667000"
                    },
                    {
                        "id": 48255,
                        "name": "Annan",
                        "latitude": "54.98839000",
                        "longitude": "-3.25647000"
                    },
                    {
                        "id": 48258,
                        "name": "Anstruther",
                        "latitude": "56.22315000",
                        "longitude": "-2.70229000"
                    },
                    {
                        "id": 48266,
                        "name": "Arbroath",
                        "latitude": "56.56317000",
                        "longitude": "-2.58736000"
                    },
                    {
                        "id": 48268,
                        "name": "Ardersier",
                        "latitude": "57.56681000",
                        "longitude": "-4.03784000"
                    },
                    {
                        "id": 48271,
                        "name": "Ardrishaig",
                        "latitude": "56.01566000",
                        "longitude": "-5.44806000"
                    },
                    {
                        "id": 48272,
                        "name": "Ardrossan",
                        "latitude": "55.65018000",
                        "longitude": "-4.80659000"
                    },
                    {
                        "id": 48274,
                        "name": "Argyll and Bute",
                        "latitude": "56.03693000",
                        "longitude": "-5.43679000"
                    },
                    {
                        "id": 48276,
                        "name": "Armadale",
                        "latitude": "55.88333000",
                        "longitude": "-3.70000000"
                    },
                    {
                        "id": 48291,
                        "name": "Ashgill",
                        "latitude": "55.73119000",
                        "longitude": "-3.93019000"
                    },
                    {
                        "id": 48312,
                        "name": "Auchinleck",
                        "latitude": "55.47157000",
                        "longitude": "-4.29337000"
                    },
                    {
                        "id": 48313,
                        "name": "Auchterarder",
                        "latitude": "56.29612000",
                        "longitude": "-3.70692000"
                    },
                    {
                        "id": 48314,
                        "name": "Auchtermuchty",
                        "latitude": "56.29158000",
                        "longitude": "-3.23428000"
                    },
                    {
                        "id": 48320,
                        "name": "Aviemore",
                        "latitude": "57.19553000",
                        "longitude": "-3.82590000"
                    },
                    {
                        "id": 48328,
                        "name": "Ayr",
                        "latitude": "55.46273000",
                        "longitude": "-4.63393000"
                    },
                    {
                        "id": 48343,
                        "name": "Balerno",
                        "latitude": "55.88437000",
                        "longitude": "-3.33975000"
                    },
                    {
                        "id": 48344,
                        "name": "Balfron",
                        "latitude": "56.06809000",
                        "longitude": "-4.33559000"
                    },
                    {
                        "id": 48345,
                        "name": "Balintore",
                        "latitude": "57.75564000",
                        "longitude": "-3.91232000"
                    },
                    {
                        "id": 48346,
                        "name": "Ballater",
                        "latitude": "57.05011000",
                        "longitude": "-3.03798000"
                    },
                    {
                        "id": 48348,
                        "name": "Ballingry",
                        "latitude": "56.16392000",
                        "longitude": "-3.32841000"
                    },
                    {
                        "id": 48350,
                        "name": "Balloch",
                        "latitude": "56.00000000",
                        "longitude": "-4.58333000"
                    },
                    {
                        "id": 48360,
                        "name": "Balmedie",
                        "latitude": "57.25052000",
                        "longitude": "-2.06163000"
                    },
                    {
                        "id": 48361,
                        "name": "Balmullo",
                        "latitude": "56.37694000",
                        "longitude": "-2.92940000"
                    },
                    {
                        "id": 48368,
                        "name": "Banchory",
                        "latitude": "57.05168000",
                        "longitude": "-2.48824000"
                    },
                    {
                        "id": 48369,
                        "name": "Banff",
                        "latitude": "57.66477000",
                        "longitude": "-2.52964000"
                    },
                    {
                        "id": 48373,
                        "name": "Bankfoot",
                        "latitude": "56.50058000",
                        "longitude": "-3.51707000"
                    },
                    {
                        "id": 48374,
                        "name": "Banknock",
                        "latitude": "55.98967000",
                        "longitude": "-3.95611000"
                    },
                    {
                        "id": 48376,
                        "name": "Bannockburn",
                        "latitude": "56.08978000",
                        "longitude": "-3.91092000"
                    },
                    {
                        "id": 48383,
                        "name": "Bargeddie",
                        "latitude": "55.85366000",
                        "longitude": "-4.07846000"
                    },
                    {
                        "id": 48406,
                        "name": "Barra",
                        "latitude": "56.98035000",
                        "longitude": "-7.45731000"
                    },
                    {
                        "id": 48407,
                        "name": "Barrhead",
                        "latitude": "55.79916000",
                        "longitude": "-4.39285000"
                    },
                    {
                        "id": 48428,
                        "name": "Bathgate",
                        "latitude": "55.90204000",
                        "longitude": "-3.64398000"
                    },
                    {
                        "id": 48439,
                        "name": "Bearsden",
                        "latitude": "55.91536000",
                        "longitude": "-4.33279000"
                    },
                    {
                        "id": 48440,
                        "name": "Beauly",
                        "latitude": "57.48345000",
                        "longitude": "-4.46144000"
                    },
                    {
                        "id": 48456,
                        "name": "Beith",
                        "latitude": "55.74923000",
                        "longitude": "-4.63680000"
                    },
                    {
                        "id": 48462,
                        "name": "Bellsbank",
                        "latitude": "55.31310000",
                        "longitude": "-4.39869000"
                    },
                    {
                        "id": 48463,
                        "name": "Bellshill",
                        "latitude": "55.81667000",
                        "longitude": "-4.01667000"
                    },
                    {
                        "id": 48471,
                        "name": "Benbecula",
                        "latitude": "57.44737000",
                        "longitude": "-7.34273000"
                    },
                    {
                        "id": 48499,
                        "name": "Biggar",
                        "latitude": "55.62297000",
                        "longitude": "-3.52455000"
                    },
                    {
                        "id": 48513,
                        "name": "Bilston",
                        "latitude": "55.87030000",
                        "longitude": "-3.17814000"
                    },
                    {
                        "id": 48526,
                        "name": "Bishopbriggs",
                        "latitude": "55.90669000",
                        "longitude": "-4.21869000"
                    },
                    {
                        "id": 48537,
                        "name": "Bishopton",
                        "latitude": "55.90969000",
                        "longitude": "-4.50560000"
                    },
                    {
                        "id": 48542,
                        "name": "Blackburn",
                        "latitude": "55.86667000",
                        "longitude": "-3.63333000"
                    },
                    {
                        "id": 48549,
                        "name": "Blackridge",
                        "latitude": "55.88523000",
                        "longitude": "-3.77479000"
                    },
                    {
                        "id": 48552,
                        "name": "Blackwood",
                        "latitude": "55.66667000",
                        "longitude": "-3.91667000"
                    },
                    {
                        "id": 48560,
                        "name": "Blairgowrie",
                        "latitude": "56.59157000",
                        "longitude": "-3.34045000"
                    },
                    {
                        "id": 48562,
                        "name": "Blantyre",
                        "latitude": "55.79634000",
                        "longitude": "-4.09485000"
                    },
                    {
                        "id": 48641,
                        "name": "Bo’ness",
                        "latitude": "56.01667000",
                        "longitude": "-3.61667000"
                    },
                    {
                        "id": 48579,
                        "name": "Boddam",
                        "latitude": "57.47076000",
                        "longitude": "-1.78009000"
                    },
                    {
                        "id": 48590,
                        "name": "Bonhill",
                        "latitude": "55.97944000",
                        "longitude": "-4.56380000"
                    },
                    {
                        "id": 48591,
                        "name": "Bonnybridge",
                        "latitude": "56.00152000",
                        "longitude": "-3.88860000"
                    },
                    {
                        "id": 48592,
                        "name": "Bonnyrigg",
                        "latitude": "55.87329000",
                        "longitude": "-3.10510000"
                    },
                    {
                        "id": 48618,
                        "name": "Bothwell",
                        "latitude": "55.80272000",
                        "longitude": "-4.06835000"
                    },
                    {
                        "id": 48669,
                        "name": "Brechin",
                        "latitude": "56.72993000",
                        "longitude": "-2.65729000"
                    },
                    {
                        "id": 48680,
                        "name": "Bridge of Allan",
                        "latitude": "56.15402000",
                        "longitude": "-3.94631000"
                    },
                    {
                        "id": 48681,
                        "name": "Bridge of Earn",
                        "latitude": "56.34842000",
                        "longitude": "-3.40650000"
                    },
                    {
                        "id": 48682,
                        "name": "Bridge of Weir",
                        "latitude": "55.85582000",
                        "longitude": "-4.57894000"
                    },
                    {
                        "id": 48697,
                        "name": "Brightons",
                        "latitude": "55.98028000",
                        "longitude": "-3.71613000"
                    },
                    {
                        "id": 48724,
                        "name": "Brora",
                        "latitude": "58.00989000",
                        "longitude": "-3.85182000"
                    },
                    {
                        "id": 48734,
                        "name": "Broxburn",
                        "latitude": "55.93415000",
                        "longitude": "-3.47133000"
                    },
                    {
                        "id": 48745,
                        "name": "Buckhaven",
                        "latitude": "56.17149000",
                        "longitude": "-3.03377000"
                    },
                    {
                        "id": 48747,
                        "name": "Buckie",
                        "latitude": "57.67570000",
                        "longitude": "-2.96238000"
                    },
                    {
                        "id": 48768,
                        "name": "Burghead",
                        "latitude": "57.70113000",
                        "longitude": "-3.48992000"
                    },
                    {
                        "id": 48780,
                        "name": "Burntisland",
                        "latitude": "56.06248000",
                        "longitude": "-3.23176000"
                    },
                    {
                        "id": 48800,
                        "name": "Busby",
                        "latitude": "55.77995000",
                        "longitude": "-4.27711000"
                    },
                    {
                        "id": 48816,
                        "name": "Cairneyhill",
                        "latitude": "56.05908000",
                        "longitude": "-3.53518000"
                    },
                    {
                        "id": 48817,
                        "name": "Cairnryan",
                        "latitude": "54.97104000",
                        "longitude": "-5.01982000"
                    },
                    {
                        "id": 48821,
                        "name": "Calderbank",
                        "latitude": "55.84318000",
                        "longitude": "-3.97070000"
                    },
                    {
                        "id": 48822,
                        "name": "Caldercruix",
                        "latitude": "55.88886000",
                        "longitude": "-3.88664000"
                    },
                    {
                        "id": 48825,
                        "name": "Callander",
                        "latitude": "56.24410000",
                        "longitude": "-4.21637000"
                    },
                    {
                        "id": 48836,
                        "name": "Cambuslang",
                        "latitude": "55.80966000",
                        "longitude": "-4.16096000"
                    },
                    {
                        "id": 48840,
                        "name": "Campbeltown",
                        "latitude": "55.42583000",
                        "longitude": "-5.60764000"
                    },
                    {
                        "id": 48848,
                        "name": "Caol",
                        "latitude": "56.83721000",
                        "longitude": "-5.10062000"
                    },
                    {
                        "id": 48853,
                        "name": "Cardenden",
                        "latitude": "56.14310000",
                        "longitude": "-3.25687000"
                    },
                    {
                        "id": 48857,
                        "name": "Cardross",
                        "latitude": "55.96184000",
                        "longitude": "-4.65316000"
                    },
                    {
                        "id": 48858,
                        "name": "Carfin",
                        "latitude": "55.80502000",
                        "longitude": "-3.96076000"
                    },
                    {
                        "id": 48861,
                        "name": "Carluke",
                        "latitude": "55.73595000",
                        "longitude": "-3.83019000"
                    },
                    {
                        "id": 48864,
                        "name": "Carmunnock",
                        "latitude": "55.79062000",
                        "longitude": "-4.23584000"
                    },
                    {
                        "id": 48868,
                        "name": "Carnoustie",
                        "latitude": "56.50263000",
                        "longitude": "-2.70530000"
                    },
                    {
                        "id": 48869,
                        "name": "Carnwath",
                        "latitude": "55.70036000",
                        "longitude": "-3.62579000"
                    },
                    {
                        "id": 48871,
                        "name": "Carron",
                        "latitude": "56.02611000",
                        "longitude": "-3.79251000"
                    },
                    {
                        "id": 48872,
                        "name": "Carronshore",
                        "latitude": "56.03146000",
                        "longitude": "-3.78290000"
                    },
                    {
                        "id": 48878,
                        "name": "Castle Douglas",
                        "latitude": "54.94095000",
                        "longitude": "-3.92784000"
                    },
                    {
                        "id": 48892,
                        "name": "Catrine",
                        "latitude": "55.50422000",
                        "longitude": "-4.33026000"
                    },
                    {
                        "id": 48917,
                        "name": "Chapelhall",
                        "latitude": "55.84349000",
                        "longitude": "-3.94881000"
                    },
                    {
                        "id": 48924,
                        "name": "Charlestown of Aberlour",
                        "latitude": "57.47076000",
                        "longitude": "-3.22509000"
                    },
                    {
                        "id": 48977,
                        "name": "Chirnside",
                        "latitude": "55.80215000",
                        "longitude": "-2.20927000"
                    },
                    {
                        "id": 48989,
                        "name": "Chryston",
                        "latitude": "55.90280000",
                        "longitude": "-4.10759000"
                    },
                    {
                        "id": 49008,
                        "name": "City of Edinburgh",
                        "latitude": "55.94973000",
                        "longitude": "-3.19333000"
                    },
                    {
                        "id": 49014,
                        "name": "Clackmannan",
                        "latitude": "56.10743000",
                        "longitude": "-3.75098000"
                    },
                    {
                        "id": 49015,
                        "name": "Clackmannanshire",
                        "latitude": "56.16667000",
                        "longitude": "-3.75000000"
                    },
                    {
                        "id": 49020,
                        "name": "Clarkston",
                        "latitude": "55.78594000",
                        "longitude": "-4.27651000"
                    },
                    {
                        "id": 49029,
                        "name": "Cleland",
                        "latitude": "55.80243000",
                        "longitude": "-3.91420000"
                    },
                    {
                        "id": 49043,
                        "name": "Clydebank",
                        "latitude": "55.90137000",
                        "longitude": "-4.40570000"
                    },
                    {
                        "id": 49044,
                        "name": "Coalburn",
                        "latitude": "55.59295000",
                        "longitude": "-3.88637000"
                    },
                    {
                        "id": 49046,
                        "name": "Coaltown of Balgonie",
                        "latitude": "56.18474000",
                        "longitude": "-3.12578000"
                    },
                    {
                        "id": 49048,
                        "name": "Coatbridge",
                        "latitude": "55.86216000",
                        "longitude": "-4.02469000"
                    },
                    {
                        "id": 49051,
                        "name": "Cockenzie",
                        "latitude": "55.96823000",
                        "longitude": "-2.96562000"
                    },
                    {
                        "id": 49065,
                        "name": "Coldstream",
                        "latitude": "55.65111000",
                        "longitude": "-2.25295000"
                    },
                    {
                        "id": 49069,
                        "name": "Colinton",
                        "latitude": "55.90739000",
                        "longitude": "-3.25609000"
                    },
                    {
                        "id": 49085,
                        "name": "Comrie",
                        "latitude": "56.36880000",
                        "longitude": "-3.97882000"
                    },
                    {
                        "id": 49091,
                        "name": "Conon Bridge",
                        "latitude": "57.56630000",
                        "longitude": "-4.43678000"
                    },
                    {
                        "id": 49124,
                        "name": "Coupar Angus",
                        "latitude": "56.54552000",
                        "longitude": "-3.26774000"
                    },
                    {
                        "id": 49125,
                        "name": "Cove",
                        "latitude": "57.10000000",
                        "longitude": "-2.08333000"
                    },
                    {
                        "id": 49130,
                        "name": "Cowdenbeath",
                        "latitude": "56.11194000",
                        "longitude": "-3.34426000"
                    },
                    {
                        "id": 49133,
                        "name": "Cowie",
                        "latitude": "56.07974000",
                        "longitude": "-3.86753000"
                    },
                    {
                        "id": 49137,
                        "name": "Coylton",
                        "latitude": "55.44528000",
                        "longitude": "-4.51950000"
                    },
                    {
                        "id": 49140,
                        "name": "Crail",
                        "latitude": "56.26042000",
                        "longitude": "-2.62676000"
                    },
                    {
                        "id": 49160,
                        "name": "Crieff",
                        "latitude": "56.37268000",
                        "longitude": "-3.83891000"
                    },
                    {
                        "id": 49174,
                        "name": "Crossford",
                        "latitude": "56.06303000",
                        "longitude": "-3.49674000"
                    },
                    {
                        "id": 49176,
                        "name": "Crossgates",
                        "latitude": "56.08366000",
                        "longitude": "-3.37712000"
                    },
                    {
                        "id": 49177,
                        "name": "Crosshouse",
                        "latitude": "55.61258000",
                        "longitude": "-4.55091000"
                    },
                    {
                        "id": 49185,
                        "name": "Croy",
                        "latitude": "55.96064000",
                        "longitude": "-4.03932000"
                    },
                    {
                        "id": 49187,
                        "name": "Cruden Bay",
                        "latitude": "57.41797000",
                        "longitude": "-1.85313000"
                    },
                    {
                        "id": 49198,
                        "name": "Cullen",
                        "latitude": "57.69045000",
                        "longitude": "-2.81818000"
                    },
                    {
                        "id": 49200,
                        "name": "Culloden",
                        "latitude": "57.48699000",
                        "longitude": "-4.14150000"
                    },
                    {
                        "id": 49204,
                        "name": "Cults",
                        "latitude": "57.11667000",
                        "longitude": "-2.16667000"
                    },
                    {
                        "id": 49206,
                        "name": "Cumbernauld",
                        "latitude": "55.94685000",
                        "longitude": "-3.99051000"
                    },
                    {
                        "id": 49208,
                        "name": "Cumnock",
                        "latitude": "55.45445000",
                        "longitude": "-4.26644000"
                    },
                    {
                        "id": 49209,
                        "name": "Cupar",
                        "latitude": "56.31876000",
                        "longitude": "-3.01204000"
                    },
                    {
                        "id": 49211,
                        "name": "Currie",
                        "latitude": "55.89640000",
                        "longitude": "-3.30845000"
                    },
                    {
                        "id": 49220,
                        "name": "Dalbeattie",
                        "latitude": "54.93278000",
                        "longitude": "-3.82271000"
                    },
                    {
                        "id": 49221,
                        "name": "Dalgety Bay",
                        "latitude": "56.03496000",
                        "longitude": "-3.35049000"
                    },
                    {
                        "id": 49222,
                        "name": "Dalkeith",
                        "latitude": "55.89317000",
                        "longitude": "-3.06806000"
                    },
                    {
                        "id": 49223,
                        "name": "Dalmellington",
                        "latitude": "55.32419000",
                        "longitude": "-4.40200000"
                    },
                    {
                        "id": 49224,
                        "name": "Dalry",
                        "latitude": "55.70956000",
                        "longitude": "-4.72167000"
                    },
                    {
                        "id": 49225,
                        "name": "Dalrymple",
                        "latitude": "55.39757000",
                        "longitude": "-4.59169000"
                    },
                    {
                        "id": 49226,
                        "name": "Dalserf",
                        "latitude": "55.73333000",
                        "longitude": "-3.91667000"
                    },
                    {
                        "id": 49231,
                        "name": "Danderhall",
                        "latitude": "55.91434000",
                        "longitude": "-3.11062000"
                    },
                    {
                        "id": 49242,
                        "name": "Darvel",
                        "latitude": "55.60976000",
                        "longitude": "-4.28142000"
                    },
                    {
                        "id": 49265,
                        "name": "Denny",
                        "latitude": "56.02350000",
                        "longitude": "-3.90812000"
                    },
                    {
                        "id": 49266,
                        "name": "Dennyloanhead",
                        "latitude": "55.99886000",
                        "longitude": "-3.91306000"
                    },
                    {
                        "id": 49286,
                        "name": "Dingwall",
                        "latitude": "57.59531000",
                        "longitude": "-4.42721000"
                    },
                    {
                        "id": 49301,
                        "name": "Dollar",
                        "latitude": "56.16245000",
                        "longitude": "-3.67135000"
                    },
                    {
                        "id": 49310,
                        "name": "Dornoch",
                        "latitude": "57.88050000",
                        "longitude": "-4.02879000"
                    },
                    {
                        "id": 49314,
                        "name": "Douglas",
                        "latitude": "55.55000000",
                        "longitude": "-3.85000000"
                    },
                    {
                        "id": 49315,
                        "name": "Doune",
                        "latitude": "56.18995000",
                        "longitude": "-4.05288000"
                    },
                    {
                        "id": 49325,
                        "name": "Dreghorn",
                        "latitude": "55.60807000",
                        "longitude": "-4.62226000"
                    },
                    {
                        "id": 49330,
                        "name": "Drongan",
                        "latitude": "55.43498000",
                        "longitude": "-4.45551000"
                    },
                    {
                        "id": 49332,
                        "name": "Drumnadrochit",
                        "latitude": "57.33438000",
                        "longitude": "-4.47989000"
                    },
                    {
                        "id": 49337,
                        "name": "Dufftown",
                        "latitude": "57.44571000",
                        "longitude": "-3.12708000"
                    },
                    {
                        "id": 49340,
                        "name": "Dumbarton",
                        "latitude": "55.94433000",
                        "longitude": "-4.57061000"
                    },
                    {
                        "id": 49341,
                        "name": "Dumfries",
                        "latitude": "55.06959000",
                        "longitude": "-3.61139000"
                    },
                    {
                        "id": 49342,
                        "name": "Dumfries and Galloway",
                        "latitude": "55.08333000",
                        "longitude": "-3.83333000"
                    },
                    {
                        "id": 49343,
                        "name": "Dunbar",
                        "latitude": "56.00062000",
                        "longitude": "-2.51418000"
                    },
                    {
                        "id": 49344,
                        "name": "Dunblane",
                        "latitude": "56.18843000",
                        "longitude": "-3.96417000"
                    },
                    {
                        "id": 49346,
                        "name": "Dundee",
                        "latitude": "56.46913000",
                        "longitude": "-2.97489000"
                    },
                    {
                        "id": 49347,
                        "name": "Dundee City",
                        "latitude": "56.46667000",
                        "longitude": "-2.91667000"
                    },
                    {
                        "id": 49349,
                        "name": "Dundonald",
                        "latitude": "55.57939000",
                        "longitude": "-4.59473000"
                    },
                    {
                        "id": 49352,
                        "name": "Dunfermline",
                        "latitude": "56.07156000",
                        "longitude": "-3.45887000"
                    },
                    {
                        "id": 49356,
                        "name": "Dunipace",
                        "latitude": "56.02700000",
                        "longitude": "-3.91471000"
                    },
                    {
                        "id": 49358,
                        "name": "Dunlop",
                        "latitude": "55.71198000",
                        "longitude": "-4.53622000"
                    },
                    {
                        "id": 49361,
                        "name": "Dunoon",
                        "latitude": "55.95031000",
                        "longitude": "-4.92734000"
                    },
                    {
                        "id": 49362,
                        "name": "Duns",
                        "latitude": "55.77704000",
                        "longitude": "-2.34575000"
                    },
                    {
                        "id": 49365,
                        "name": "Duntocher",
                        "latitude": "55.92437000",
                        "longitude": "-4.41545000"
                    },
                    {
                        "id": 49369,
                        "name": "Dyce",
                        "latitude": "57.20522000",
                        "longitude": "-2.17676000"
                    },
                    {
                        "id": 49374,
                        "name": "Eaglesham",
                        "latitude": "55.74119000",
                        "longitude": "-4.27459000"
                    },
                    {
                        "id": 49381,
                        "name": "Earlston",
                        "latitude": "55.63856000",
                        "longitude": "-2.67495000"
                    },
                    {
                        "id": 49384,
                        "name": "East Ayrshire",
                        "latitude": "55.50000000",
                        "longitude": "-4.25000000"
                    },
                    {
                        "id": 49389,
                        "name": "East Calder",
                        "latitude": "55.89186000",
                        "longitude": "-3.46372000"
                    },
                    {
                        "id": 49394,
                        "name": "East Dunbartonshire",
                        "latitude": "55.93333000",
                        "longitude": "-4.20000000"
                    },
                    {
                        "id": 49401,
                        "name": "East Kilbride",
                        "latitude": "55.76412000",
                        "longitude": "-4.17669000"
                    },
                    {
                        "id": 49403,
                        "name": "East Linton",
                        "latitude": "55.98737000",
                        "longitude": "-2.65682000"
                    },
                    {
                        "id": 49404,
                        "name": "East Lothian",
                        "latitude": "55.91667000",
                        "longitude": "-2.75000000"
                    },
                    {
                        "id": 49409,
                        "name": "East Renfrewshire",
                        "latitude": "55.75000000",
                        "longitude": "-4.33333000"
                    },
                    {
                        "id": 49413,
                        "name": "East Wemyss",
                        "latitude": "56.16018000",
                        "longitude": "-3.06422000"
                    },
                    {
                        "id": 49414,
                        "name": "East Whitburn",
                        "latitude": "55.86855000",
                        "longitude": "-3.66295000"
                    },
                    {
                        "id": 49424,
                        "name": "Eastriggs",
                        "latitude": "54.98597000",
                        "longitude": "-3.18051000"
                    },
                    {
                        "id": 49441,
                        "name": "Edinburgh",
                        "latitude": "55.95206000",
                        "longitude": "-3.19648000"
                    },
                    {
                        "id": 49449,
                        "name": "Eilean Siar",
                        "latitude": "57.66667000",
                        "longitude": "-7.16667000"
                    },
                    {
                        "id": 49450,
                        "name": "Elderslie",
                        "latitude": "55.83327000",
                        "longitude": "-4.48598000"
                    },
                    {
                        "id": 49451,
                        "name": "Elgin",
                        "latitude": "57.64947000",
                        "longitude": "-3.31843000"
                    },
                    {
                        "id": 49457,
                        "name": "Ellon",
                        "latitude": "57.36405000",
                        "longitude": "-2.07313000"
                    },
                    {
                        "id": 49482,
                        "name": "Errol",
                        "latitude": "56.39234000",
                        "longitude": "-3.21275000"
                    },
                    {
                        "id": 49483,
                        "name": "Erskine",
                        "latitude": "55.90050000",
                        "longitude": "-4.45028000"
                    },
                    {
                        "id": 49493,
                        "name": "Evanton",
                        "latitude": "57.66385000",
                        "longitude": "-4.34004000"
                    },
                    {
                        "id": 49510,
                        "name": "Eyemouth",
                        "latitude": "55.87130000",
                        "longitude": "-2.09010000"
                    },
                    {
                        "id": 49514,
                        "name": "Faifley",
                        "latitude": "55.92853000",
                        "longitude": "-4.38509000"
                    },
                    {
                        "id": 49518,
                        "name": "Fairlie",
                        "latitude": "55.75602000",
                        "longitude": "-4.85564000"
                    },
                    {
                        "id": 49521,
                        "name": "Falkirk",
                        "latitude": "56.00000000",
                        "longitude": "-3.75000000"
                    },
                    {
                        "id": 49522,
                        "name": "Falkland",
                        "latitude": "56.25255000",
                        "longitude": "-3.20389000"
                    },
                    {
                        "id": 49523,
                        "name": "Fallin",
                        "latitude": "56.10479000",
                        "longitude": "-3.87616000"
                    },
                    {
                        "id": 49534,
                        "name": "Fauldhouse",
                        "latitude": "55.82749000",
                        "longitude": "-3.70741000"
                    },
                    {
                        "id": 49544,
                        "name": "Fenwick",
                        "latitude": "55.65823000",
                        "longitude": "-4.44342000"
                    },
                    {
                        "id": 49552,
                        "name": "Fife",
                        "latitude": "56.25000000",
                        "longitude": "-3.16667000"
                    },
                    {
                        "id": 49556,
                        "name": "Findochty",
                        "latitude": "57.69735000",
                        "longitude": "-2.90104000"
                    },
                    {
                        "id": 49579,
                        "name": "Fochabers",
                        "latitude": "57.61445000",
                        "longitude": "-3.09947000"
                    },
                    {
                        "id": 49587,
                        "name": "Forfar",
                        "latitude": "56.64382000",
                        "longitude": "-2.89001000"
                    },
                    {
                        "id": 49589,
                        "name": "Forres",
                        "latitude": "57.60997000",
                        "longitude": "-3.62115000"
                    },
                    {
                        "id": 49590,
                        "name": "Fort William",
                        "latitude": "56.81648000",
                        "longitude": "-5.11208000"
                    },
                    {
                        "id": 49591,
                        "name": "Forth",
                        "latitude": "55.76502000",
                        "longitude": "-3.68874000"
                    },
                    {
                        "id": 49592,
                        "name": "Fortrose",
                        "latitude": "57.58087000",
                        "longitude": "-4.13263000"
                    },
                    {
                        "id": 49603,
                        "name": "Fraserburgh",
                        "latitude": "57.68744000",
                        "longitude": "-2.01844000"
                    },
                    {
                        "id": 49607,
                        "name": "Freuchie",
                        "latitude": "56.24688000",
                        "longitude": "-3.15861000"
                    },
                    {
                        "id": 49610,
                        "name": "Friockheim",
                        "latitude": "56.63688000",
                        "longitude": "-2.66806000"
                    },
                    {
                        "id": 49622,
                        "name": "Galashiels",
                        "latitude": "55.61458000",
                        "longitude": "-2.80695000"
                    },
                    {
                        "id": 49624,
                        "name": "Galston",
                        "latitude": "55.60093000",
                        "longitude": "-4.38172000"
                    },
                    {
                        "id": 49626,
                        "name": "Garelochhead",
                        "latitude": "56.08203000",
                        "longitude": "-4.82909000"
                    },
                    {
                        "id": 49631,
                        "name": "Gartcosh",
                        "latitude": "55.88841000",
                        "longitude": "-4.08170000"
                    },
                    {
                        "id": 49639,
                        "name": "Giffnock",
                        "latitude": "55.80373000",
                        "longitude": "-4.29488000"
                    },
                    {
                        "id": 49646,
                        "name": "Girvan",
                        "latitude": "55.24255000",
                        "longitude": "-4.85551000"
                    },
                    {
                        "id": 49650,
                        "name": "Glasgow",
                        "latitude": "55.86515000",
                        "longitude": "-4.25763000"
                    },
                    {
                        "id": 49651,
                        "name": "Glasgow City",
                        "latitude": "55.86667000",
                        "longitude": "-4.25000000"
                    },
                    {
                        "id": 49657,
                        "name": "Glenboig",
                        "latitude": "55.89422000",
                        "longitude": "-4.04619000"
                    },
                    {
                        "id": 49659,
                        "name": "Glenmavis",
                        "latitude": "55.88913000",
                        "longitude": "-3.98726000"
                    },
                    {
                        "id": 49660,
                        "name": "Glenrothes",
                        "latitude": "56.19514000",
                        "longitude": "-3.17316000"
                    },
                    {
                        "id": 49675,
                        "name": "Golspie",
                        "latitude": "57.97266000",
                        "longitude": "-3.97798000"
                    },
                    {
                        "id": 49680,
                        "name": "Gorebridge",
                        "latitude": "55.84594000",
                        "longitude": "-3.04563000"
                    },
                    {
                        "id": 49692,
                        "name": "Gourock",
                        "latitude": "55.96157000",
                        "longitude": "-4.81789000"
                    },
                    {
                        "id": 49698,
                        "name": "Grangemouth",
                        "latitude": "56.01141000",
                        "longitude": "-3.72183000"
                    },
                    {
                        "id": 49700,
                        "name": "Grantown on Spey",
                        "latitude": "57.33051000",
                        "longitude": "-3.60867000"
                    },
                    {
                        "id": 49743,
                        "name": "Greenhill",
                        "latitude": "55.99204000",
                        "longitude": "-3.89096000"
                    },
                    {
                        "id": 49747,
                        "name": "Greenock",
                        "latitude": "55.94838000",
                        "longitude": "-4.76121000"
                    },
                    {
                        "id": 49750,
                        "name": "Gretna",
                        "latitude": "54.99380000",
                        "longitude": "-3.06594000"
                    },
                    {
                        "id": 49766,
                        "name": "Gullane",
                        "latitude": "56.03652000",
                        "longitude": "-2.82829000"
                    },
                    {
                        "id": 49772,
                        "name": "Haddington",
                        "latitude": "55.95612000",
                        "longitude": "-2.78332000"
                    },
                    {
                        "id": 49785,
                        "name": "Halkirk",
                        "latitude": "58.51227000",
                        "longitude": "-3.49155000"
                    },
                    {
                        "id": 49786,
                        "name": "Hallglen",
                        "latitude": "55.98573000",
                        "longitude": "-3.78535000"
                    },
                    {
                        "id": 49795,
                        "name": "Hamilton",
                        "latitude": "55.76667000",
                        "longitude": "-4.03333000"
                    },
                    {
                        "id": 49821,
                        "name": "Harthill",
                        "latitude": "55.86067000",
                        "longitude": "-3.75166000"
                    },
                    {
                        "id": 49851,
                        "name": "Hawick",
                        "latitude": "55.42273000",
                        "longitude": "-2.78666000"
                    },
                    {
                        "id": 49871,
                        "name": "Head of Muir",
                        "latitude": "56.00623000",
                        "longitude": "-3.91358000"
                    },
                    {
                        "id": 49888,
                        "name": "Helensburgh",
                        "latitude": "56.00614000",
                        "longitude": "-4.72648000"
                    },
                    {
                        "id": 49924,
                        "name": "High Blantyre",
                        "latitude": "55.78438000",
                        "longitude": "-4.10007000"
                    },
                    {
                        "id": 49931,
                        "name": "High Valleyfield",
                        "latitude": "56.06357000",
                        "longitude": "-3.59913000"
                    },
                    {
                        "id": 49936,
                        "name": "Highland",
                        "latitude": "57.50000000",
                        "longitude": "-5.00000000"
                    },
                    {
                        "id": 49941,
                        "name": "Hillside",
                        "latitude": "56.74483000",
                        "longitude": "-2.47400000"
                    },
                    {
                        "id": 49972,
                        "name": "Holytown",
                        "latitude": "55.82011000",
                        "longitude": "-3.97270000"
                    },
                    {
                        "id": 49985,
                        "name": "Hopeman",
                        "latitude": "57.70681000",
                        "longitude": "-3.42911000"
                    },
                    {
                        "id": 50010,
                        "name": "Houston",
                        "latitude": "55.86859000",
                        "longitude": "-4.55201000"
                    },
                    {
                        "id": 50014,
                        "name": "Howwood",
                        "latitude": "55.81060000",
                        "longitude": "-4.55733000"
                    },
                    {
                        "id": 50028,
                        "name": "Huntly",
                        "latitude": "57.44741000",
                        "longitude": "-2.78608000"
                    },
                    {
                        "id": 50048,
                        "name": "Inchinnan",
                        "latitude": "55.88995000",
                        "longitude": "-4.43842000"
                    },
                    {
                        "id": 50049,
                        "name": "Inchture",
                        "latitude": "56.44551000",
                        "longitude": "-3.16956000"
                    },
                    {
                        "id": 50056,
                        "name": "Innerleithen",
                        "latitude": "55.61927000",
                        "longitude": "-3.06301000"
                    },
                    {
                        "id": 50057,
                        "name": "Insch",
                        "latitude": "57.34273000",
                        "longitude": "-2.61321000"
                    },
                    {
                        "id": 50058,
                        "name": "Inverbervie",
                        "latitude": "56.84463000",
                        "longitude": "-2.27997000"
                    },
                    {
                        "id": 50059,
                        "name": "Inverclyde",
                        "latitude": "55.90000000",
                        "longitude": "-4.75000000"
                    },
                    {
                        "id": 50060,
                        "name": "Invergordon",
                        "latitude": "57.68860000",
                        "longitude": "-4.16745000"
                    },
                    {
                        "id": 50061,
                        "name": "Invergowrie",
                        "latitude": "56.46111000",
                        "longitude": "-3.06158000"
                    },
                    {
                        "id": 50062,
                        "name": "Inverkeithing",
                        "latitude": "56.03297000",
                        "longitude": "-3.39555000"
                    },
                    {
                        "id": 50063,
                        "name": "Inverkip",
                        "latitude": "55.90831000",
                        "longitude": "-4.87051000"
                    },
                    {
                        "id": 50064,
                        "name": "Inverness",
                        "latitude": "57.47908000",
                        "longitude": "-4.22398000"
                    },
                    {
                        "id": 50065,
                        "name": "Inverurie",
                        "latitude": "57.28446000",
                        "longitude": "-2.37736000"
                    },
                    {
                        "id": 50072,
                        "name": "Irvine",
                        "latitude": "55.61940000",
                        "longitude": "-4.65508000"
                    },
                    {
                        "id": 50075,
                        "name": "Isle of Arran",
                        "latitude": "55.58145000",
                        "longitude": "-5.21233000"
                    },
                    {
                        "id": 50076,
                        "name": "Isle of Bute",
                        "latitude": "55.83663000",
                        "longitude": "-5.05586000"
                    },
                    {
                        "id": 50077,
                        "name": "Isle of Cumbrae",
                        "latitude": "55.76933000",
                        "longitude": "-4.91913000"
                    },
                    {
                        "id": 50078,
                        "name": "Isle of Islay",
                        "latitude": "55.78526000",
                        "longitude": "-6.23886000"
                    },
                    {
                        "id": 50079,
                        "name": "Isle of Lewis",
                        "latitude": "58.21901000",
                        "longitude": "-6.38803000"
                    },
                    {
                        "id": 50074,
                        "name": "Isle Of Mull",
                        "latitude": "56.44703000",
                        "longitude": "-5.77404000"
                    },
                    {
                        "id": 50080,
                        "name": "Isle of North Uist",
                        "latitude": "57.60581000",
                        "longitude": "-7.34024000"
                    },
                    {
                        "id": 50081,
                        "name": "Isle of South Uist",
                        "latitude": "57.24562000",
                        "longitude": "-7.33337000"
                    },
                    {
                        "id": 50094,
                        "name": "Jedburgh",
                        "latitude": "55.47997000",
                        "longitude": "-2.55200000"
                    },
                    {
                        "id": 50096,
                        "name": "Johnstone",
                        "latitude": "55.82906000",
                        "longitude": "-4.51605000"
                    },
                    {
                        "id": 50106,
                        "name": "Keith",
                        "latitude": "57.53633000",
                        "longitude": "-2.94811000"
                    },
                    {
                        "id": 50109,
                        "name": "Kelso",
                        "latitude": "55.59814000",
                        "longitude": "-2.43382000"
                    },
                    {
                        "id": 50110,
                        "name": "Kelty",
                        "latitude": "56.13362000",
                        "longitude": "-3.38690000"
                    },
                    {
                        "id": 50113,
                        "name": "Kemnay",
                        "latitude": "57.23573000",
                        "longitude": "-2.44395000"
                    },
                    {
                        "id": 50121,
                        "name": "Kennoway",
                        "latitude": "56.21081000",
                        "longitude": "-3.04917000"
                    },
                    {
                        "id": 50139,
                        "name": "Kilbarchan",
                        "latitude": "55.83620000",
                        "longitude": "-4.55356000"
                    },
                    {
                        "id": 50140,
                        "name": "Kilbirnie",
                        "latitude": "55.75082000",
                        "longitude": "-4.68791000"
                    },
                    {
                        "id": 50142,
                        "name": "Kilcreggan",
                        "latitude": "55.98460000",
                        "longitude": "-4.82100000"
                    },
                    {
                        "id": 50147,
                        "name": "Killearn",
                        "latitude": "56.04239000",
                        "longitude": "-4.36840000"
                    },
                    {
                        "id": 50149,
                        "name": "Kilmacolm",
                        "latitude": "55.89470000",
                        "longitude": "-4.62643000"
                    },
                    {
                        "id": 50150,
                        "name": "Kilmarnock",
                        "latitude": "55.61171000",
                        "longitude": "-4.49581000"
                    },
                    {
                        "id": 50151,
                        "name": "Kilmaurs",
                        "latitude": "55.63801000",
                        "longitude": "-4.52730000"
                    },
                    {
                        "id": 50154,
                        "name": "Kilsyth",
                        "latitude": "55.97596000",
                        "longitude": "-4.05916000"
                    },
                    {
                        "id": 50155,
                        "name": "Kilwinning",
                        "latitude": "55.65333000",
                        "longitude": "-4.70666000"
                    },
                    {
                        "id": 50159,
                        "name": "Kincardine",
                        "latitude": "56.06945000",
                        "longitude": "-3.71964000"
                    },
                    {
                        "id": 50163,
                        "name": "Kinghorn",
                        "latitude": "56.06896000",
                        "longitude": "-3.17607000"
                    },
                    {
                        "id": 50164,
                        "name": "Kinglassie",
                        "latitude": "56.17371000",
                        "longitude": "-3.24241000"
                    },
                    {
                        "id": 50173,
                        "name": "Kingskettle",
                        "latitude": "56.26215000",
                        "longitude": "-3.11693000"
                    },
                    {
                        "id": 50181,
                        "name": "Kingswells",
                        "latitude": "57.15798000",
                        "longitude": "-2.22426000"
                    },
                    {
                        "id": 50185,
                        "name": "Kingussie",
                        "latitude": "57.07996000",
                        "longitude": "-4.05231000"
                    },
                    {
                        "id": 50186,
                        "name": "Kinloss",
                        "latitude": "57.63494000",
                        "longitude": "-3.57012000"
                    },
                    {
                        "id": 50187,
                        "name": "Kinross",
                        "latitude": "56.20466000",
                        "longitude": "-3.42138000"
                    },
                    {
                        "id": 50189,
                        "name": "Kintore",
                        "latitude": "57.23721000",
                        "longitude": "-2.34540000"
                    },
                    {
                        "id": 50192,
                        "name": "Kippen",
                        "latitude": "56.12673000",
                        "longitude": "-4.17083000"
                    },
                    {
                        "id": 50202,
                        "name": "Kirkcaldy",
                        "latitude": "56.11683000",
                        "longitude": "-3.15999000"
                    },
                    {
                        "id": 50203,
                        "name": "Kirkconnel",
                        "latitude": "55.38561000",
                        "longitude": "-3.99836000"
                    },
                    {
                        "id": 50204,
                        "name": "Kirkcudbright",
                        "latitude": "54.83830000",
                        "longitude": "-4.04908000"
                    },
                    {
                        "id": 50206,
                        "name": "Kirkintilloch",
                        "latitude": "55.93933000",
                        "longitude": "-4.15262000"
                    },
                    {
                        "id": 50208,
                        "name": "Kirkliston",
                        "latitude": "55.95364000",
                        "longitude": "-3.40288000"
                    },
                    {
                        "id": 50209,
                        "name": "Kirknewton",
                        "latitude": "55.88754000",
                        "longitude": "-3.41898000"
                    },
                    {
                        "id": 50210,
                        "name": "Kirkwall",
                        "latitude": "58.98479000",
                        "longitude": "-2.95873000"
                    },
                    {
                        "id": 50211,
                        "name": "Kirriemuir",
                        "latitude": "56.67398000",
                        "longitude": "-3.00343000"
                    },
                    {
                        "id": 50226,
                        "name": "Ladybank",
                        "latitude": "56.27421000",
                        "longitude": "-3.12390000"
                    },
                    {
                        "id": 50232,
                        "name": "Lamlash",
                        "latitude": "55.53358000",
                        "longitude": "-5.12956000"
                    },
                    {
                        "id": 50234,
                        "name": "Lanark",
                        "latitude": "55.67371000",
                        "longitude": "-3.78170000"
                    },
                    {
                        "id": 50243,
                        "name": "Langholm",
                        "latitude": "55.15101000",
                        "longitude": "-2.99889000"
                    },
                    {
                        "id": 50248,
                        "name": "Larbert",
                        "latitude": "56.02246000",
                        "longitude": "-3.82872000"
                    },
                    {
                        "id": 50249,
                        "name": "Largs",
                        "latitude": "55.79629000",
                        "longitude": "-4.86337000"
                    },
                    {
                        "id": 50252,
                        "name": "Larkhall",
                        "latitude": "55.73333000",
                        "longitude": "-3.96667000"
                    },
                    {
                        "id": 50255,
                        "name": "Lauder",
                        "latitude": "55.71908000",
                        "longitude": "-2.74755000"
                    },
                    {
                        "id": 50257,
                        "name": "Laurencekirk",
                        "latitude": "56.83338000",
                        "longitude": "-2.46540000"
                    },
                    {
                        "id": 50258,
                        "name": "Laurieston",
                        "latitude": "55.99562000",
                        "longitude": "-3.74801000"
                    },
                    {
                        "id": 50261,
                        "name": "Law",
                        "latitude": "55.75000000",
                        "longitude": "-3.88333000"
                    },
                    {
                        "id": 50280,
                        "name": "Lennoxtown",
                        "latitude": "55.97263000",
                        "longitude": "-4.20001000"
                    },
                    {
                        "id": 50281,
                        "name": "Lenzie",
                        "latitude": "55.92762000",
                        "longitude": "-4.15399000"
                    },
                    {
                        "id": 50283,
                        "name": "Lerwick",
                        "latitude": "60.15339000",
                        "longitude": "-1.14427000"
                    },
                    {
                        "id": 50285,
                        "name": "Leslie",
                        "latitude": "56.20000000",
                        "longitude": "-3.21667000"
                    },
                    {
                        "id": 50286,
                        "name": "Lesmahagow",
                        "latitude": "55.63668000",
                        "longitude": "-3.88736000"
                    },
                    {
                        "id": 50289,
                        "name": "Letham",
                        "latitude": "56.62683000",
                        "longitude": "-2.77060000"
                    },
                    {
                        "id": 50291,
                        "name": "Leuchars",
                        "latitude": "56.38174000",
                        "longitude": "-2.88253000"
                    },
                    {
                        "id": 50292,
                        "name": "Leven",
                        "latitude": "56.20000000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 50298,
                        "name": "Lhanbryde",
                        "latitude": "57.63529000",
                        "longitude": "-3.21839000"
                    },
                    {
                        "id": 50304,
                        "name": "Limekilns",
                        "latitude": "56.03336000",
                        "longitude": "-3.47713000"
                    },
                    {
                        "id": 50311,
                        "name": "Linlithgow",
                        "latitude": "55.97639000",
                        "longitude": "-3.60364000"
                    },
                    {
                        "id": 50315,
                        "name": "Linwood",
                        "latitude": "55.84834000",
                        "longitude": "-4.49337000"
                    },
                    {
                        "id": 50339,
                        "name": "Livingston",
                        "latitude": "55.90288000",
                        "longitude": "-3.52261000"
                    },
                    {
                        "id": 50375,
                        "name": "Loanhead",
                        "latitude": "55.87945000",
                        "longitude": "-3.15874000"
                    },
                    {
                        "id": 50376,
                        "name": "Locharbriggs",
                        "latitude": "55.10337000",
                        "longitude": "-3.58438000"
                    },
                    {
                        "id": 50377,
                        "name": "Lochgelly",
                        "latitude": "56.12826000",
                        "longitude": "-3.30964000"
                    },
                    {
                        "id": 50378,
                        "name": "Lochgilphead",
                        "latitude": "56.03796000",
                        "longitude": "-5.43206000"
                    },
                    {
                        "id": 50379,
                        "name": "Lochmaben",
                        "latitude": "55.13011000",
                        "longitude": "-3.44286000"
                    },
                    {
                        "id": 50380,
                        "name": "Lochwinnoch",
                        "latitude": "55.79521000",
                        "longitude": "-4.63034000"
                    },
                    {
                        "id": 50381,
                        "name": "Lockerbie",
                        "latitude": "55.12302000",
                        "longitude": "-3.35635000"
                    },
                    {
                        "id": 50387,
                        "name": "Logan",
                        "latitude": "55.45466000",
                        "longitude": "-4.23514000"
                    },
                    {
                        "id": 50404,
                        "name": "Longforgan",
                        "latitude": "56.45732000",
                        "longitude": "-3.11437000"
                    },
                    {
                        "id": 50408,
                        "name": "Longniddry",
                        "latitude": "55.97543000",
                        "longitude": "-2.89593000"
                    },
                    {
                        "id": 50416,
                        "name": "Lossiemouth",
                        "latitude": "57.72136000",
                        "longitude": "-3.28341000"
                    },
                    {
                        "id": 50436,
                        "name": "Luncarty",
                        "latitude": "56.45308000",
                        "longitude": "-3.47007000"
                    },
                    {
                        "id": 50438,
                        "name": "Lundin Links",
                        "latitude": "56.21240000",
                        "longitude": "-2.95296000"
                    },
                    {
                        "id": 50459,
                        "name": "Macduff",
                        "latitude": "57.67012000",
                        "longitude": "-2.49686000"
                    },
                    {
                        "id": 50462,
                        "name": "Macmerry",
                        "latitude": "55.94045000",
                        "longitude": "-2.90503000"
                    },
                    {
                        "id": 50463,
                        "name": "Maddiston",
                        "latitude": "55.97365000",
                        "longitude": "-3.69900000"
                    },
                    {
                        "id": 50507,
                        "name": "Markinch",
                        "latitude": "56.20214000",
                        "longitude": "-3.13517000"
                    },
                    {
                        "id": 50523,
                        "name": "Maryburgh",
                        "latitude": "57.57420000",
                        "longitude": "-4.44178000"
                    },
                    {
                        "id": 50528,
                        "name": "Mauchline",
                        "latitude": "55.51604000",
                        "longitude": "-4.37928000"
                    },
                    {
                        "id": 50530,
                        "name": "Maxwellheugh",
                        "latitude": "55.59253000",
                        "longitude": "-2.42871000"
                    },
                    {
                        "id": 50531,
                        "name": "Maybole",
                        "latitude": "55.35503000",
                        "longitude": "-4.68026000"
                    },
                    {
                        "id": 50533,
                        "name": "Mayfield",
                        "latitude": "55.87172000",
                        "longitude": "-3.03875000"
                    },
                    {
                        "id": 50541,
                        "name": "Melrose",
                        "latitude": "55.59969000",
                        "longitude": "-2.72770000"
                    },
                    {
                        "id": 50548,
                        "name": "Menstrie",
                        "latitude": "56.15138000",
                        "longitude": "-3.85466000"
                    },
                    {
                        "id": 50558,
                        "name": "Methil",
                        "latitude": "56.18543000",
                        "longitude": "-3.02157000"
                    },
                    {
                        "id": 50560,
                        "name": "Methven",
                        "latitude": "56.41737000",
                        "longitude": "-3.57832000"
                    },
                    {
                        "id": 50566,
                        "name": "Mid Calder",
                        "latitude": "55.89261000",
                        "longitude": "-3.48002000"
                    },
                    {
                        "id": 50576,
                        "name": "Midlothian",
                        "latitude": "55.82347000",
                        "longitude": "-3.09334000"
                    },
                    {
                        "id": 50587,
                        "name": "Millport",
                        "latitude": "55.75348000",
                        "longitude": "-4.92559000"
                    },
                    {
                        "id": 50588,
                        "name": "Milltimber",
                        "latitude": "57.10424000",
                        "longitude": "-2.24099000"
                    },
                    {
                        "id": 50589,
                        "name": "Milnathort",
                        "latitude": "56.22688000",
                        "longitude": "-3.41930000"
                    },
                    {
                        "id": 50590,
                        "name": "Milngavie",
                        "latitude": "55.94071000",
                        "longitude": "-4.32311000"
                    },
                    {
                        "id": 50594,
                        "name": "Milton of Campsie",
                        "latitude": "55.96120000",
                        "longitude": "-4.16508000"
                    },
                    {
                        "id": 50595,
                        "name": "Milton of Leys",
                        "latitude": "57.45125000",
                        "longitude": "-4.17592000"
                    },
                    {
                        "id": 50602,
                        "name": "Mintlaw",
                        "latitude": "57.52414000",
                        "longitude": "-2.00099000"
                    },
                    {
                        "id": 50611,
                        "name": "Moffat",
                        "latitude": "55.33527000",
                        "longitude": "-3.44142000"
                    },
                    {
                        "id": 50617,
                        "name": "Monifieth",
                        "latitude": "56.48227000",
                        "longitude": "-2.81732000"
                    },
                    {
                        "id": 50621,
                        "name": "Montrose",
                        "latitude": "56.71683000",
                        "longitude": "-2.46695000"
                    },
                    {
                        "id": 50622,
                        "name": "Moodiesburn",
                        "latitude": "55.91501000",
                        "longitude": "-4.08331000"
                    },
                    {
                        "id": 50623,
                        "name": "Moray",
                        "latitude": "57.41667000",
                        "longitude": "-3.25000000"
                    },
                    {
                        "id": 50634,
                        "name": "Mossblown",
                        "latitude": "55.48941000",
                        "longitude": "-4.52787000"
                    },
                    {
                        "id": 50638,
                        "name": "Motherwell",
                        "latitude": "55.78924000",
                        "longitude": "-3.99187000"
                    },
                    {
                        "id": 50647,
                        "name": "Muir of Ord",
                        "latitude": "57.51976000",
                        "longitude": "-4.45939000"
                    },
                    {
                        "id": 50648,
                        "name": "Muirhead",
                        "latitude": "56.50000000",
                        "longitude": "-3.06667000"
                    },
                    {
                        "id": 50649,
                        "name": "Muirkirk",
                        "latitude": "55.52272000",
                        "longitude": "-4.06551000"
                    },
                    {
                        "id": 50655,
                        "name": "Musselburgh",
                        "latitude": "55.94170000",
                        "longitude": "-3.04991000"
                    },
                    {
                        "id": 50661,
                        "name": "Nairn",
                        "latitude": "57.58094000",
                        "longitude": "-3.87973000"
                    },
                    {
                        "id": 50673,
                        "name": "Neilston",
                        "latitude": "55.78574000",
                        "longitude": "-4.42637000"
                    },
                    {
                        "id": 50681,
                        "name": "Netherlee",
                        "latitude": "55.80157000",
                        "longitude": "-4.27325000"
                    },
                    {
                        "id": 50687,
                        "name": "New Cumnock",
                        "latitude": "55.39563000",
                        "longitude": "-4.18458000"
                    },
                    {
                        "id": 50693,
                        "name": "New Pitsligo",
                        "latitude": "57.59019000",
                        "longitude": "-2.19535000"
                    },
                    {
                        "id": 50696,
                        "name": "New Stevenston",
                        "latitude": "55.81669000",
                        "longitude": "-3.97357000"
                    },
                    {
                        "id": 50699,
                        "name": "Newarthill",
                        "latitude": "55.81510000",
                        "longitude": "-3.93733000"
                    },
                    {
                        "id": 50702,
                        "name": "Newbridge",
                        "latitude": "55.93333000",
                        "longitude": "-3.40000000"
                    },
                    {
                        "id": 50704,
                        "name": "Newburgh",
                        "latitude": "56.35079000",
                        "longitude": "-3.23650000"
                    },
                    {
                        "id": 50716,
                        "name": "Newmacher",
                        "latitude": "57.26667000",
                        "longitude": "-2.18333000"
                    },
                    {
                        "id": 50717,
                        "name": "Newmains",
                        "latitude": "55.78514000",
                        "longitude": "-3.87465000"
                    },
                    {
                        "id": 50719,
                        "name": "Newmilns",
                        "latitude": "55.60751000",
                        "longitude": "-4.32416000"
                    },
                    {
                        "id": 50723,
                        "name": "Newport-on-Tay",
                        "latitude": "56.43911000",
                        "longitude": "-2.93670000"
                    },
                    {
                        "id": 50731,
                        "name": "Newton Mearns",
                        "latitude": "55.77334000",
                        "longitude": "-4.33339000"
                    },
                    {
                        "id": 50733,
                        "name": "Newton Stewart",
                        "latitude": "54.95784000",
                        "longitude": "-4.48315000"
                    },
                    {
                        "id": 50735,
                        "name": "Newtonhill",
                        "latitude": "57.03333000",
                        "longitude": "-2.15000000"
                    },
                    {
                        "id": 50736,
                        "name": "Newtonmore",
                        "latitude": "57.06567000",
                        "longitude": "-4.12097000"
                    },
                    {
                        "id": 50738,
                        "name": "Newtown St Boswells",
                        "latitude": "55.57887000",
                        "longitude": "-2.66874000"
                    },
                    {
                        "id": 50747,
                        "name": "North Ayrshire",
                        "latitude": "55.69694000",
                        "longitude": "-4.73373000"
                    },
                    {
                        "id": 50749,
                        "name": "North Berwick",
                        "latitude": "56.05825000",
                        "longitude": "-2.72290000"
                    },
                    {
                        "id": 50756,
                        "name": "North Lanarkshire",
                        "latitude": "55.86667000",
                        "longitude": "-3.91667000"
                    },
                    {
                        "id": 50762,
                        "name": "North Queensferry",
                        "latitude": "56.00899000",
                        "longitude": "-3.39134000"
                    },
                    {
                        "id": 50794,
                        "name": "Oakley",
                        "latitude": "56.08421000",
                        "longitude": "-3.56311000"
                    },
                    {
                        "id": 50796,
                        "name": "Oban",
                        "latitude": "56.41535000",
                        "longitude": "-5.47184000"
                    },
                    {
                        "id": 50797,
                        "name": "Ochiltree",
                        "latitude": "55.45981000",
                        "longitude": "-4.36782000"
                    },
                    {
                        "id": 50803,
                        "name": "Old Kilpatrick",
                        "latitude": "55.92241000",
                        "longitude": "-4.45567000"
                    },
                    {
                        "id": 50808,
                        "name": "Oldmeldrum",
                        "latitude": "57.33492000",
                        "longitude": "-2.31990000"
                    },
                    {
                        "id": 50812,
                        "name": "Orkney",
                        "latitude": "58.98465000",
                        "longitude": "-2.95953000"
                    },
                    {
                        "id": 50813,
                        "name": "Orkney Islands",
                        "latitude": "59.00000000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 50816,
                        "name": "Ormiston",
                        "latitude": "55.91302000",
                        "longitude": "-2.93985000"
                    },
                    {
                        "id": 50837,
                        "name": "Overtown",
                        "latitude": "55.75719000",
                        "longitude": "-3.91645000"
                    },
                    {
                        "id": 50848,
                        "name": "Paisley",
                        "latitude": "55.83173000",
                        "longitude": "-4.43254000"
                    },
                    {
                        "id": 50859,
                        "name": "Patna",
                        "latitude": "55.36406000",
                        "longitude": "-4.50594000"
                    },
                    {
                        "id": 50867,
                        "name": "Peebles",
                        "latitude": "55.65190000",
                        "longitude": "-3.18880000"
                    },
                    {
                        "id": 50879,
                        "name": "Pencaitland",
                        "latitude": "55.90727000",
                        "longitude": "-2.89490000"
                    },
                    {
                        "id": 50881,
                        "name": "Penicuik",
                        "latitude": "55.83116000",
                        "longitude": "-3.22608000"
                    },
                    {
                        "id": 50898,
                        "name": "Perth",
                        "latitude": "56.39522000",
                        "longitude": "-3.43139000"
                    },
                    {
                        "id": 50899,
                        "name": "Perth and Kinross",
                        "latitude": "56.50000000",
                        "longitude": "-3.75000000"
                    },
                    {
                        "id": 50901,
                        "name": "Peterculter",
                        "latitude": "57.09929000",
                        "longitude": "-2.26588000"
                    },
                    {
                        "id": 50902,
                        "name": "Peterhead",
                        "latitude": "57.50584000",
                        "longitude": "-1.79806000"
                    },
                    {
                        "id": 50917,
                        "name": "Pitlochry",
                        "latitude": "56.70514000",
                        "longitude": "-3.73432000"
                    },
                    {
                        "id": 50918,
                        "name": "Pitmedden",
                        "latitude": "57.33691000",
                        "longitude": "-2.18022000"
                    },
                    {
                        "id": 50921,
                        "name": "Pittenweem",
                        "latitude": "56.21406000",
                        "longitude": "-2.72839000"
                    },
                    {
                        "id": 50922,
                        "name": "Plains",
                        "latitude": "55.88044000",
                        "longitude": "-3.92349000"
                    },
                    {
                        "id": 50923,
                        "name": "Plean",
                        "latitude": "56.06516000",
                        "longitude": "-3.87596000"
                    },
                    {
                        "id": 50930,
                        "name": "Polbeth",
                        "latitude": "55.86072000",
                        "longitude": "-3.54901000"
                    },
                    {
                        "id": 50933,
                        "name": "Polmont",
                        "latitude": "55.99050000",
                        "longitude": "-3.70737000"
                    },
                    {
                        "id": 50952,
                        "name": "Port Bannatyne",
                        "latitude": "55.85660000",
                        "longitude": "-5.06503000"
                    },
                    {
                        "id": 50953,
                        "name": "Port Erroll",
                        "latitude": "57.41427000",
                        "longitude": "-1.84596000"
                    },
                    {
                        "id": 50954,
                        "name": "Port Glasgow",
                        "latitude": "55.93464000",
                        "longitude": "-4.68950000"
                    },
                    {
                        "id": 50964,
                        "name": "Portknockie",
                        "latitude": "57.70248000",
                        "longitude": "-2.85989000"
                    },
                    {
                        "id": 50966,
                        "name": "Portlethen",
                        "latitude": "57.06942000",
                        "longitude": "-2.13246000"
                    },
                    {
                        "id": 50967,
                        "name": "Portree",
                        "latitude": "57.41288000",
                        "longitude": "-6.19418000"
                    },
                    {
                        "id": 50972,
                        "name": "Portsoy",
                        "latitude": "57.68144000",
                        "longitude": "-2.68956000"
                    },
                    {
                        "id": 50988,
                        "name": "Prestonpans",
                        "latitude": "55.95939000",
                        "longitude": "-2.98038000"
                    },
                    {
                        "id": 50990,
                        "name": "Prestwick",
                        "latitude": "55.48333000",
                        "longitude": "-4.61667000"
                    },
                    {
                        "id": 51012,
                        "name": "Queensferry",
                        "latitude": "55.99089000",
                        "longitude": "-3.39847000"
                    },
                    {
                        "id": 51035,
                        "name": "Ratho",
                        "latitude": "55.92164000",
                        "longitude": "-3.38028000"
                    },
                    {
                        "id": 51036,
                        "name": "Ratho Station",
                        "latitude": "55.93670000",
                        "longitude": "-3.38890000"
                    },
                    {
                        "id": 51050,
                        "name": "Redding",
                        "latitude": "55.98861000",
                        "longitude": "-3.73230000"
                    },
                    {
                        "id": 51051,
                        "name": "Reddingmuirhead",
                        "latitude": "55.98026000",
                        "longitude": "-3.74853000"
                    },
                    {
                        "id": 51060,
                        "name": "Renfrew",
                        "latitude": "55.87197000",
                        "longitude": "-4.39253000"
                    },
                    {
                        "id": 51061,
                        "name": "Renfrewshire",
                        "latitude": "55.83333000",
                        "longitude": "-4.50000000"
                    },
                    {
                        "id": 51062,
                        "name": "Renton",
                        "latitude": "55.97200000",
                        "longitude": "-4.58399000"
                    },
                    {
                        "id": 51072,
                        "name": "Rhu",
                        "latitude": "56.01667000",
                        "longitude": "-4.76667000"
                    },
                    {
                        "id": 51106,
                        "name": "Rosehearty",
                        "latitude": "57.69700000",
                        "longitude": "-2.11322000"
                    },
                    {
                        "id": 51107,
                        "name": "Rosewell",
                        "latitude": "55.85075000",
                        "longitude": "-3.13625000"
                    },
                    {
                        "id": 51108,
                        "name": "Roslin",
                        "latitude": "55.85749000",
                        "longitude": "-3.16895000"
                    },
                    {
                        "id": 51109,
                        "name": "Rosneath",
                        "latitude": "56.00985000",
                        "longitude": "-4.80151000"
                    },
                    {
                        "id": 51114,
                        "name": "Rosyth",
                        "latitude": "56.03689000",
                        "longitude": "-3.43800000"
                    },
                    {
                        "id": 51118,
                        "name": "Rothes",
                        "latitude": "57.52624000",
                        "longitude": "-3.20663000"
                    },
                    {
                        "id": 51119,
                        "name": "Rothesay",
                        "latitude": "55.83648000",
                        "longitude": "-5.05508000"
                    },
                    {
                        "id": 51120,
                        "name": "Rothienorman",
                        "latitude": "57.41145000",
                        "longitude": "-2.46455000"
                    },
                    {
                        "id": 51149,
                        "name": "Rutherglen",
                        "latitude": "55.82885000",
                        "longitude": "-4.21376000"
                    },
                    {
                        "id": 51163,
                        "name": "Saint Andrews",
                        "latitude": "56.33871000",
                        "longitude": "-2.79902000"
                    },
                    {
                        "id": 51166,
                        "name": "Saint Boswells",
                        "latitude": "55.57301000",
                        "longitude": "-2.64410000"
                    },
                    {
                        "id": 51169,
                        "name": "Saint Cyrus",
                        "latitude": "56.77504000",
                        "longitude": "-2.41553000"
                    },
                    {
                        "id": 51173,
                        "name": "Saint Monans",
                        "latitude": "56.20651000",
                        "longitude": "-2.76821000"
                    },
                    {
                        "id": 51183,
                        "name": "Saline",
                        "latitude": "56.11399000",
                        "longitude": "-3.57034000"
                    },
                    {
                        "id": 51185,
                        "name": "Salsburgh",
                        "latitude": "55.84277000",
                        "longitude": "-3.87264000"
                    },
                    {
                        "id": 51188,
                        "name": "Saltcoats",
                        "latitude": "55.63616000",
                        "longitude": "-4.78588000"
                    },
                    {
                        "id": 51192,
                        "name": "Sandbank",
                        "latitude": "55.98203000",
                        "longitude": "-4.94973000"
                    },
                    {
                        "id": 51197,
                        "name": "Sandwick",
                        "latitude": "60.00000000",
                        "longitude": "-1.25000000"
                    },
                    {
                        "id": 51199,
                        "name": "Sanquhar",
                        "latitude": "55.36527000",
                        "longitude": "-3.92160000"
                    },
                    {
                        "id": 51209,
                        "name": "Scalloway",
                        "latitude": "60.13832000",
                        "longitude": "-1.27690000"
                    },
                    {
                        "id": 51215,
                        "name": "Scone",
                        "latitude": "56.41942000",
                        "longitude": "-3.40507000"
                    },
                    {
                        "id": 51220,
                        "name": "Seafield",
                        "latitude": "55.87791000",
                        "longitude": "-3.58781000"
                    },
                    {
                        "id": 51235,
                        "name": "Selkirk",
                        "latitude": "55.54738000",
                        "longitude": "-2.83911000"
                    },
                    {
                        "id": 51274,
                        "name": "Shetland Islands",
                        "latitude": "60.33333000",
                        "longitude": "-1.33333000"
                    },
                    {
                        "id": 51276,
                        "name": "Shieldhill",
                        "latitude": "55.97277000",
                        "longitude": "-3.76788000"
                    },
                    {
                        "id": 51294,
                        "name": "Shotts",
                        "latitude": "55.81951000",
                        "longitude": "-3.79749000"
                    },
                    {
                        "id": 51321,
                        "name": "Skelmorlie",
                        "latitude": "55.86950000",
                        "longitude": "-4.88475000"
                    },
                    {
                        "id": 51328,
                        "name": "Slamannan",
                        "latitude": "55.93729000",
                        "longitude": "-3.83311000"
                    },
                    {
                        "id": 51334,
                        "name": "Smithton",
                        "latitude": "57.47956000",
                        "longitude": "-4.15141000"
                    },
                    {
                        "id": 51344,
                        "name": "South Ayrshire",
                        "latitude": "55.25000000",
                        "longitude": "-4.66667000"
                    },
                    {
                        "id": 51357,
                        "name": "South Lanarkshire",
                        "latitude": "55.58333000",
                        "longitude": "-3.83333000"
                    },
                    {
                        "id": 51393,
                        "name": "Springside",
                        "latitude": "55.61514000",
                        "longitude": "-4.59062000"
                    },
                    {
                        "id": 51425,
                        "name": "Stanley",
                        "latitude": "56.48540000",
                        "longitude": "-3.45184000"
                    },
                    {
                        "id": 51438,
                        "name": "Stenhousemuir",
                        "latitude": "56.02676000",
                        "longitude": "-3.81462000"
                    },
                    {
                        "id": 51439,
                        "name": "Stepps",
                        "latitude": "55.88899000",
                        "longitude": "-4.15210000"
                    },
                    {
                        "id": 51441,
                        "name": "Stevenston",
                        "latitude": "55.63970000",
                        "longitude": "-4.75339000"
                    },
                    {
                        "id": 51445,
                        "name": "Stewarton",
                        "latitude": "55.67986000",
                        "longitude": "-4.51435000"
                    },
                    {
                        "id": 51452,
                        "name": "Stirling",
                        "latitude": "56.11532000",
                        "longitude": "-4.23386000"
                    },
                    {
                        "id": 51473,
                        "name": "Stonehaven",
                        "latitude": "56.96365000",
                        "longitude": "-2.21177000"
                    },
                    {
                        "id": 51475,
                        "name": "Stonehouse",
                        "latitude": "55.69435000",
                        "longitude": "-3.98780000"
                    },
                    {
                        "id": 51478,
                        "name": "Stoneyburn",
                        "latitude": "55.84371000",
                        "longitude": "-3.63862000"
                    },
                    {
                        "id": 51479,
                        "name": "Stornoway",
                        "latitude": "58.20925000",
                        "longitude": "-6.38649000"
                    },
                    {
                        "id": 51488,
                        "name": "Stranraer",
                        "latitude": "54.90234000",
                        "longitude": "-5.02731000"
                    },
                    {
                        "id": 51491,
                        "name": "Strathaven",
                        "latitude": "55.67710000",
                        "longitude": "-4.06680000"
                    },
                    {
                        "id": 51492,
                        "name": "Strathblane",
                        "latitude": "55.98596000",
                        "longitude": "-4.30658000"
                    },
                    {
                        "id": 51493,
                        "name": "Strathpeffer",
                        "latitude": "57.58522000",
                        "longitude": "-4.54195000"
                    },
                    {
                        "id": 51501,
                        "name": "Stromness",
                        "latitude": "58.96498000",
                        "longitude": "-3.29601000"
                    },
                    {
                        "id": 51540,
                        "name": "Symington",
                        "latitude": "55.55176000",
                        "longitude": "-4.55835000"
                    },
                    {
                        "id": 51547,
                        "name": "Tain",
                        "latitude": "57.80903000",
                        "longitude": "-4.05991000"
                    },
                    {
                        "id": 51558,
                        "name": "Tarbert",
                        "latitude": "55.86277000",
                        "longitude": "-5.41622000"
                    },
                    {
                        "id": 51559,
                        "name": "Tarbolton",
                        "latitude": "55.51292000",
                        "longitude": "-4.48648000"
                    },
                    {
                        "id": 51566,
                        "name": "Tayport",
                        "latitude": "56.44699000",
                        "longitude": "-2.87966000"
                    },
                    {
                        "id": 51589,
                        "name": "The Scottish Borders",
                        "latitude": "55.58333000",
                        "longitude": "-2.83333000"
                    },
                    {
                        "id": 51600,
                        "name": "Thornhill",
                        "latitude": "55.23333000",
                        "longitude": "-3.76667000"
                    },
                    {
                        "id": 51602,
                        "name": "Thornliebank",
                        "latitude": "55.80454000",
                        "longitude": "-4.31746000"
                    },
                    {
                        "id": 51603,
                        "name": "Thornton",
                        "latitude": "56.16667000",
                        "longitude": "-3.15000000"
                    },
                    {
                        "id": 51615,
                        "name": "Thurso",
                        "latitude": "58.59271000",
                        "longitude": "-3.52594000"
                    },
                    {
                        "id": 51624,
                        "name": "Tillicoultry",
                        "latitude": "56.15251000",
                        "longitude": "-3.74015000"
                    },
                    {
                        "id": 51634,
                        "name": "Tobermory",
                        "latitude": "56.62198000",
                        "longitude": "-6.07231000"
                    },
                    {
                        "id": 51645,
                        "name": "Torphins",
                        "latitude": "57.10561000",
                        "longitude": "-2.62398000"
                    },
                    {
                        "id": 51648,
                        "name": "Torrance",
                        "latitude": "55.93995000",
                        "longitude": "-4.21025000"
                    },
                    {
                        "id": 51656,
                        "name": "Townhill",
                        "latitude": "56.08910000",
                        "longitude": "-3.43889000"
                    },
                    {
                        "id": 51659,
                        "name": "Tranent",
                        "latitude": "55.94439000",
                        "longitude": "-2.95412000"
                    },
                    {
                        "id": 51673,
                        "name": "Troon",
                        "latitude": "55.54359000",
                        "longitude": "-4.66335000"
                    },
                    {
                        "id": 51676,
                        "name": "Tullibody",
                        "latitude": "56.13364000",
                        "longitude": "-3.83835000"
                    },
                    {
                        "id": 51679,
                        "name": "Turriff",
                        "latitude": "57.53840000",
                        "longitude": "-2.45932000"
                    },
                    {
                        "id": 51681,
                        "name": "Twechar",
                        "latitude": "55.95415000",
                        "longitude": "-4.08219000"
                    },
                    {
                        "id": 51682,
                        "name": "Tweedbank",
                        "latitude": "55.60449000",
                        "longitude": "-2.76692000"
                    },
                    {
                        "id": 51690,
                        "name": "Uddingston",
                        "latitude": "55.81971000",
                        "longitude": "-4.08362000"
                    },
                    {
                        "id": 51693,
                        "name": "Ullapool",
                        "latitude": "57.89872000",
                        "longitude": "-5.16039000"
                    },
                    {
                        "id": 51713,
                        "name": "Vale of Leven",
                        "latitude": "55.97132000",
                        "longitude": "-4.57928000"
                    },
                    {
                        "id": 51718,
                        "name": "Viewpark",
                        "latitude": "55.82737000",
                        "longitude": "-4.05730000"
                    },
                    {
                        "id": 51769,
                        "name": "Waterfoot",
                        "latitude": "55.76938000",
                        "longitude": "-4.28372000"
                    },
                    {
                        "id": 51800,
                        "name": "Wemyss Bay",
                        "latitude": "55.87614000",
                        "longitude": "-4.88950000"
                    },
                    {
                        "id": 51810,
                        "name": "West Calder",
                        "latitude": "55.85188000",
                        "longitude": "-3.56981000"
                    },
                    {
                        "id": 51815,
                        "name": "West Dunbartonshire",
                        "latitude": "55.96667000",
                        "longitude": "-4.53333000"
                    },
                    {
                        "id": 51822,
                        "name": "West Kilbride",
                        "latitude": "55.69004000",
                        "longitude": "-4.85771000"
                    },
                    {
                        "id": 51825,
                        "name": "West Linton",
                        "latitude": "55.74972000",
                        "longitude": "-3.35607000"
                    },
                    {
                        "id": 51826,
                        "name": "West Lothian",
                        "latitude": "55.91667000",
                        "longitude": "-3.50000000"
                    },
                    {
                        "id": 51843,
                        "name": "Westhill",
                        "latitude": "57.15263000",
                        "longitude": "-2.27966000"
                    },
                    {
                        "id": 51850,
                        "name": "Westquarter",
                        "latitude": "55.99142000",
                        "longitude": "-3.74016000"
                    },
                    {
                        "id": 51866,
                        "name": "Whitburn",
                        "latitude": "55.86667000",
                        "longitude": "-3.68333000"
                    },
                    {
                        "id": 51871,
                        "name": "Whitecraig",
                        "latitude": "55.91937000",
                        "longitude": "-3.04231000"
                    },
                    {
                        "id": 51875,
                        "name": "Whitehills",
                        "latitude": "57.67730000",
                        "longitude": "-2.57863000"
                    },
                    {
                        "id": 51890,
                        "name": "Wick",
                        "latitude": "58.43906000",
                        "longitude": "-3.09424000"
                    },
                    {
                        "id": 51919,
                        "name": "Winchburgh",
                        "latitude": "55.95795000",
                        "longitude": "-3.46464000"
                    },
                    {
                        "id": 51926,
                        "name": "Windygates",
                        "latitude": "56.19546000",
                        "longitude": "-3.05274000"
                    },
                    {
                        "id": 51942,
                        "name": "Wishaw",
                        "latitude": "55.76667000",
                        "longitude": "-3.91667000"
                    }
                ]
            },
            {
                "id": 2346,
                "name": "Scottish Borders",
                "iso2": "SCB",
                "latitude": "55.54856970",
                "longitude": "-2.78613880",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2518,
                "name": "Sefton",
                "iso2": "SFT",
                "latitude": "53.50344490",
                "longitude": "-2.97035900",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2295,
                "name": "Sheffield",
                "iso2": "SHF",
                "latitude": "36.09507430",
                "longitude": "-80.27884660",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2300,
                "name": "Shetland Islands",
                "iso2": "ZET",
                "latitude": "60.52965070",
                "longitude": "-1.26594090",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2407,
                "name": "Shropshire",
                "iso2": "SHR",
                "latitude": "52.70636570",
                "longitude": "-2.74178490",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2427,
                "name": "Slough",
                "iso2": "SLG",
                "latitude": "51.51053840",
                "longitude": "-0.59504060",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2469,
                "name": "Solihull",
                "iso2": "SOL",
                "latitude": "52.41181100",
                "longitude": "-1.77761000",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2386,
                "name": "Somerset",
                "iso2": "SOM",
                "latitude": "51.10509700",
                "longitude": "-2.92623070",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2377,
                "name": "South Ayrshire",
                "iso2": "SAY",
                "latitude": "55.45889880",
                "longitude": "-4.62919940",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2400,
                "name": "South Gloucestershire",
                "iso2": "SGC",
                "latitude": "51.52643610",
                "longitude": "-2.47284870",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2362,
                "name": "South Lanarkshire",
                "iso2": "SLK",
                "latitude": "55.67359090",
                "longitude": "-3.78196610",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2409,
                "name": "South Tyneside",
                "iso2": "STY",
                "latitude": "54.96366930",
                "longitude": "-1.44186340",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2323,
                "name": "Southend-on-Sea",
                "iso2": "SOS",
                "latitude": "51.54592690",
                "longitude": "0.70771230",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2432,
                "name": "Southwark",
                "iso2": "SWK",
                "latitude": "51.48805720",
                "longitude": "-0.07628380",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2290,
                "name": "St Helens",
                "iso2": "SHN",
                "latitude": "45.85896100",
                "longitude": "-122.82123560",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2447,
                "name": "Staffordshire",
                "iso2": "STS",
                "latitude": "52.87927450",
                "longitude": "-2.05718680",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2488,
                "name": "Stirling",
                "iso2": "STG",
                "latitude": "56.11652270",
                "longitude": "-3.93690290",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2394,
                "name": "Stockport",
                "iso2": "SKP",
                "latitude": "53.41063160",
                "longitude": "-2.15753320",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2421,
                "name": "Stockton-on-Tees",
                "iso2": "STT",
                "latitude": "54.57045510",
                "longitude": "-1.32898210",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2506,
                "name": "Stoke-on-Trent",
                "iso2": "STE",
                "latitude": "53.00266800",
                "longitude": "-2.17940400",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2393,
                "name": "Strabane",
                "iso2": "STB",
                "latitude": "54.82738650",
                "longitude": "-7.46331030",
                "type": "district council",
                "cities": []
            },
            {
                "id": 2467,
                "name": "Suffolk",
                "iso2": "SFK",
                "latitude": "52.18724720",
                "longitude": "0.97078010",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2372,
                "name": "Sunderland",
                "iso2": "SND",
                "latitude": "54.88614890",
                "longitude": "-1.47857970",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2526,
                "name": "Surrey",
                "iso2": "SRY",
                "latitude": "51.31475930",
                "longitude": "-0.55995010",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2313,
                "name": "Sutton",
                "iso2": "STN",
                "latitude": "51.35737620",
                "longitude": "-0.17527960",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2433,
                "name": "Swansea",
                "iso2": "SWA",
                "latitude": "51.62144000",
                "longitude": "-3.94364600",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2422,
                "name": "Swindon",
                "iso2": "SWD",
                "latitude": "51.55577390",
                "longitude": "-1.77971760",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2367,
                "name": "Tameside",
                "iso2": "TAM",
                "latitude": "53.48058280",
                "longitude": "-2.08098910",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2310,
                "name": "Telford and Wrekin",
                "iso2": "TFW",
                "latitude": "52.74099160",
                "longitude": "-2.48685860",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2468,
                "name": "Thurrock",
                "iso2": "THR",
                "latitude": "51.49345570",
                "longitude": "0.35291970",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2478,
                "name": "Torbay",
                "iso2": "TOB",
                "latitude": "50.43923290",
                "longitude": "-3.53698990",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2496,
                "name": "Torfaen",
                "iso2": "TOF",
                "latitude": "51.70022530",
                "longitude": "-3.04460150",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2390,
                "name": "Tower Hamlets",
                "iso2": "TWH",
                "latitude": "51.52026070",
                "longitude": "-0.02933960",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2293,
                "name": "Trafford",
                "iso2": "TRF",
                "latitude": "40.38562460",
                "longitude": "-79.75893470",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2375,
                "name": "United Kingdom",
                "iso2": "UKM",
                "latitude": "55.37805100",
                "longitude": "-3.43597300",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2299,
                "name": "Vale of Glamorgan",
                "iso2": "VGL",
                "latitude": "51.40959580",
                "longitude": "-3.48481670",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2465,
                "name": "Wakefield",
                "iso2": "WKF",
                "latitude": "42.50393950",
                "longitude": "-71.07233910",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2338,
                "name": "Wales",
                "iso2": "WLS",
                "latitude": "52.13066070",
                "longitude": "-3.78371170",
                "type": "unitary authority",
                "cities": [
                    {
                        "id": 48162,
                        "name": "Aberaeron",
                        "latitude": "52.24247000",
                        "longitude": "-4.25871000"
                    },
                    {
                        "id": 48163,
                        "name": "Abercanaid",
                        "latitude": "51.72361000",
                        "longitude": "-3.36611000"
                    },
                    {
                        "id": 48164,
                        "name": "Abercarn",
                        "latitude": "51.64733000",
                        "longitude": "-3.13476000"
                    },
                    {
                        "id": 48166,
                        "name": "Abercynon",
                        "latitude": "51.64548000",
                        "longitude": "-3.32727000"
                    },
                    {
                        "id": 48167,
                        "name": "Aberdare",
                        "latitude": "51.71438000",
                        "longitude": "-3.44918000"
                    },
                    {
                        "id": 48172,
                        "name": "Aberfan",
                        "latitude": "51.68892000",
                        "longitude": "-3.34178000"
                    },
                    {
                        "id": 48175,
                        "name": "Abergavenny",
                        "latitude": "51.82098000",
                        "longitude": "-3.01743000"
                    },
                    {
                        "id": 48176,
                        "name": "Abergele",
                        "latitude": "53.28436000",
                        "longitude": "-3.58220000"
                    },
                    {
                        "id": 48177,
                        "name": "Aberkenfig",
                        "latitude": "51.54000000",
                        "longitude": "-3.59556000"
                    },
                    {
                        "id": 48180,
                        "name": "Aberporth",
                        "latitude": "52.13248000",
                        "longitude": "-4.54173000"
                    },
                    {
                        "id": 48181,
                        "name": "Abertillery",
                        "latitude": "51.72981000",
                        "longitude": "-3.13432000"
                    },
                    {
                        "id": 48182,
                        "name": "Abertridwr",
                        "latitude": "51.59583000",
                        "longitude": "-3.26833000"
                    },
                    {
                        "id": 48183,
                        "name": "Aberystwyth",
                        "latitude": "52.41548000",
                        "longitude": "-4.08292000"
                    },
                    {
                        "id": 48245,
                        "name": "Amlwch",
                        "latitude": "53.40986000",
                        "longitude": "-4.34712000"
                    },
                    {
                        "id": 48246,
                        "name": "Ammanford",
                        "latitude": "51.79279000",
                        "longitude": "-3.98833000"
                    },
                    {
                        "id": 48250,
                        "name": "Anglesey",
                        "latitude": "53.25000000",
                        "longitude": "-4.33333000"
                    },
                    {
                        "id": 48335,
                        "name": "Bagillt",
                        "latitude": "53.26540000",
                        "longitude": "-3.16551000"
                    },
                    {
                        "id": 48340,
                        "name": "Bala",
                        "latitude": "52.91111000",
                        "longitude": "-3.59722000"
                    },
                    {
                        "id": 48370,
                        "name": "Bangor",
                        "latitude": "53.22752000",
                        "longitude": "-4.12936000"
                    },
                    {
                        "id": 48384,
                        "name": "Bargoed",
                        "latitude": "51.68333000",
                        "longitude": "-3.23333000"
                    },
                    {
                        "id": 48393,
                        "name": "Barmouth",
                        "latitude": "52.72377000",
                        "longitude": "-4.05748000"
                    },
                    {
                        "id": 48413,
                        "name": "Barry",
                        "latitude": "51.39979000",
                        "longitude": "-3.28380000"
                    },
                    {
                        "id": 48441,
                        "name": "Beaumaris",
                        "latitude": "53.26315000",
                        "longitude": "-4.09233000"
                    },
                    {
                        "id": 48448,
                        "name": "Beddau",
                        "latitude": "51.55398000",
                        "longitude": "-3.35814000"
                    },
                    {
                        "id": 48451,
                        "name": "Bedlinog",
                        "latitude": "51.70432000",
                        "longitude": "-3.31306000"
                    },
                    {
                        "id": 48452,
                        "name": "Bedwas",
                        "latitude": "51.59183000",
                        "longitude": "-3.19886000"
                    },
                    {
                        "id": 48472,
                        "name": "Benllech",
                        "latitude": "53.32044000",
                        "longitude": "-4.22607000"
                    },
                    {
                        "id": 48481,
                        "name": "Bethesda",
                        "latitude": "53.18150000",
                        "longitude": "-4.05828000"
                    },
                    {
                        "id": 48484,
                        "name": "Betws",
                        "latitude": "51.56917000",
                        "longitude": "-3.58833000"
                    },
                    {
                        "id": 48485,
                        "name": "Betws-y-Coed",
                        "latitude": "53.09382000",
                        "longitude": "-3.80668000"
                    },
                    {
                        "id": 48533,
                        "name": "Bishopston",
                        "latitude": "51.57750000",
                        "longitude": "-4.04806000"
                    },
                    {
                        "id": 48553,
                        "name": "Blackwood",
                        "latitude": "51.66778000",
                        "longitude": "-3.20750000"
                    },
                    {
                        "id": 48555,
                        "name": "Blaenau Gwent",
                        "latitude": "51.75000000",
                        "longitude": "-3.16667000"
                    },
                    {
                        "id": 48556,
                        "name": "Blaenau-Ffestiniog",
                        "latitude": "52.99464000",
                        "longitude": "-3.93697000"
                    },
                    {
                        "id": 48557,
                        "name": "Blaenavon",
                        "latitude": "51.77402000",
                        "longitude": "-3.08537000"
                    },
                    {
                        "id": 48558,
                        "name": "Blaengwynfi",
                        "latitude": "51.65623000",
                        "longitude": "-3.60371000"
                    },
                    {
                        "id": 48580,
                        "name": "Bodedern",
                        "latitude": "53.29232000",
                        "longitude": "-4.50303000"
                    },
                    {
                        "id": 48581,
                        "name": "Bodelwyddan",
                        "latitude": "53.26827000",
                        "longitude": "-3.50078000"
                    },
                    {
                        "id": 48613,
                        "name": "Borth",
                        "latitude": "52.48887000",
                        "longitude": "-4.05039000"
                    },
                    {
                        "id": 48633,
                        "name": "Bow Street",
                        "latitude": "52.44213000",
                        "longitude": "-4.02783000"
                    },
                    {
                        "id": 48670,
                        "name": "Brecon",
                        "latitude": "51.94612000",
                        "longitude": "-3.38887000"
                    },
                    {
                        "id": 48683,
                        "name": "Bridgend",
                        "latitude": "51.50583000",
                        "longitude": "-3.57722000"
                    },
                    {
                        "id": 48684,
                        "name": "Bridgend county borough",
                        "latitude": "51.55000000",
                        "longitude": "-3.58333000"
                    },
                    {
                        "id": 48705,
                        "name": "Briton Ferry",
                        "latitude": "51.63106000",
                        "longitude": "-3.81898000"
                    },
                    {
                        "id": 48730,
                        "name": "Broughton",
                        "latitude": "53.16303000",
                        "longitude": "-2.99309000"
                    },
                    {
                        "id": 48737,
                        "name": "Brymbo",
                        "latitude": "53.06667000",
                        "longitude": "-3.06667000"
                    },
                    {
                        "id": 48738,
                        "name": "Bryn",
                        "latitude": "51.61639000",
                        "longitude": "-3.71167000"
                    },
                    {
                        "id": 48739,
                        "name": "Brynamman",
                        "latitude": "51.80000000",
                        "longitude": "-3.86667000"
                    },
                    {
                        "id": 48740,
                        "name": "Brynmawr",
                        "latitude": "51.80000000",
                        "longitude": "-3.18333000"
                    },
                    {
                        "id": 48741,
                        "name": "Brynna",
                        "latitude": "51.53845000",
                        "longitude": "-3.46378000"
                    },
                    {
                        "id": 48750,
                        "name": "Buckley",
                        "latitude": "53.16667000",
                        "longitude": "-3.08333000"
                    },
                    {
                        "id": 48756,
                        "name": "Builth Wells",
                        "latitude": "52.14940000",
                        "longitude": "-3.40469000"
                    },
                    {
                        "id": 48784,
                        "name": "Burry Port",
                        "latitude": "51.68435000",
                        "longitude": "-4.24687000"
                    },
                    {
                        "id": 48810,
                        "name": "Caergwrle",
                        "latitude": "53.10953000",
                        "longitude": "-3.03808000"
                    },
                    {
                        "id": 48811,
                        "name": "Caerleon",
                        "latitude": "51.60952000",
                        "longitude": "-2.95378000"
                    },
                    {
                        "id": 48812,
                        "name": "Caernarfon",
                        "latitude": "53.14126000",
                        "longitude": "-4.27016000"
                    },
                    {
                        "id": 48813,
                        "name": "Caerphilly",
                        "latitude": "51.57452000",
                        "longitude": "-3.21800000"
                    },
                    {
                        "id": 48814,
                        "name": "Caerphilly County Borough",
                        "latitude": "51.66667000",
                        "longitude": "-3.16667000"
                    },
                    {
                        "id": 48815,
                        "name": "Caerwent",
                        "latitude": "51.61120000",
                        "longitude": "-2.76865000"
                    },
                    {
                        "id": 48824,
                        "name": "Caldicot",
                        "latitude": "51.58661000",
                        "longitude": "-2.75736000"
                    },
                    {
                        "id": 48854,
                        "name": "Cardiff",
                        "latitude": "51.48000000",
                        "longitude": "-3.18000000"
                    },
                    {
                        "id": 48855,
                        "name": "Cardigan",
                        "latitude": "52.08373000",
                        "longitude": "-4.66228000"
                    },
                    {
                        "id": 48862,
                        "name": "Carmarthen",
                        "latitude": "51.85552000",
                        "longitude": "-4.30535000"
                    },
                    {
                        "id": 48863,
                        "name": "Carmarthenshire",
                        "latitude": "51.83333000",
                        "longitude": "-4.16667000"
                    },
                    {
                        "id": 48901,
                        "name": "Cefn Cribwr",
                        "latitude": "51.53167000",
                        "longitude": "-3.65278000"
                    },
                    {
                        "id": 48902,
                        "name": "Cemaes Bay",
                        "latitude": "53.41211000",
                        "longitude": "-4.45190000"
                    },
                    {
                        "id": 48948,
                        "name": "Chepstow",
                        "latitude": "51.64087000",
                        "longitude": "-2.67683000"
                    },
                    {
                        "id": 48976,
                        "name": "Chirk",
                        "latitude": "52.93586000",
                        "longitude": "-3.05738000"
                    },
                    {
                        "id": 49005,
                        "name": "City and County of Swansea",
                        "latitude": "51.58333000",
                        "longitude": "-4.00000000"
                    },
                    {
                        "id": 49042,
                        "name": "Clydach",
                        "latitude": "51.68333000",
                        "longitude": "-3.90000000"
                    },
                    {
                        "id": 49057,
                        "name": "Coedpoeth",
                        "latitude": "53.05391000",
                        "longitude": "-3.06234000"
                    },
                    {
                        "id": 49060,
                        "name": "Coity",
                        "latitude": "51.52200000",
                        "longitude": "-3.55531000"
                    },
                    {
                        "id": 49078,
                        "name": "Colwyn Bay",
                        "latitude": "53.29483000",
                        "longitude": "-3.72674000"
                    },
                    {
                        "id": 49093,
                        "name": "Conwy",
                        "latitude": "53.08333000",
                        "longitude": "-3.75000000"
                    },
                    {
                        "id": 49122,
                        "name": "County of Ceredigion",
                        "latitude": "52.25000000",
                        "longitude": "-4.00000000"
                    },
                    {
                        "id": 49123,
                        "name": "County of Flintshire",
                        "latitude": "53.25000000",
                        "longitude": "-3.16667000"
                    },
                    {
                        "id": 49129,
                        "name": "Cowbridge",
                        "latitude": "51.46028000",
                        "longitude": "-3.44167000"
                    },
                    {
                        "id": 49156,
                        "name": "Criccieth",
                        "latitude": "52.92053000",
                        "longitude": "-4.23460000"
                    },
                    {
                        "id": 49158,
                        "name": "Crickhowell",
                        "latitude": "51.85992000",
                        "longitude": "-3.13771000"
                    },
                    {
                        "id": 49162,
                        "name": "Croeserw",
                        "latitude": "51.64472000",
                        "longitude": "-3.64028000"
                    },
                    {
                        "id": 49165,
                        "name": "Crofty",
                        "latitude": "51.63448000",
                        "longitude": "-4.12937000"
                    },
                    {
                        "id": 49172,
                        "name": "Cross Hands",
                        "latitude": "51.79306000",
                        "longitude": "-4.08750000"
                    },
                    {
                        "id": 49189,
                        "name": "Crumlin",
                        "latitude": "51.67778000",
                        "longitude": "-3.13528000"
                    },
                    {
                        "id": 49191,
                        "name": "Crymych",
                        "latitude": "51.97361000",
                        "longitude": "-4.64722000"
                    },
                    {
                        "id": 49192,
                        "name": "Crynant",
                        "latitude": "51.72889000",
                        "longitude": "-3.74806000"
                    },
                    {
                        "id": 49215,
                        "name": "Cwm",
                        "latitude": "51.74000000",
                        "longitude": "-3.18028000"
                    },
                    {
                        "id": 49216,
                        "name": "Cwmafan",
                        "latitude": "51.61671000",
                        "longitude": "-3.76205000"
                    },
                    {
                        "id": 49217,
                        "name": "Cwmbach",
                        "latitude": "51.70556000",
                        "longitude": "-3.40944000"
                    },
                    {
                        "id": 49218,
                        "name": "Cwmbran",
                        "latitude": "51.65446000",
                        "longitude": "-3.02281000"
                    },
                    {
                        "id": 49254,
                        "name": "Deeside",
                        "latitude": "53.20053000",
                        "longitude": "-3.03841000"
                    },
                    {
                        "id": 49255,
                        "name": "Deganwy",
                        "latitude": "53.30446000",
                        "longitude": "-3.82735000"
                    },
                    {
                        "id": 49256,
                        "name": "Deiniolen",
                        "latitude": "53.14819000",
                        "longitude": "-4.13185000"
                    },
                    {
                        "id": 49259,
                        "name": "Denbigh",
                        "latitude": "53.18333000",
                        "longitude": "-3.41667000"
                    },
                    {
                        "id": 49260,
                        "name": "Denbighshire",
                        "latitude": "53.08333000",
                        "longitude": "-3.33333000"
                    },
                    {
                        "id": 49271,
                        "name": "Deri",
                        "latitude": "51.70812000",
                        "longitude": "-3.26312000"
                    },
                    {
                        "id": 49285,
                        "name": "Dinas Powys",
                        "latitude": "51.43486000",
                        "longitude": "-3.21398000"
                    },
                    {
                        "id": 49300,
                        "name": "Dolgellau",
                        "latitude": "52.74222000",
                        "longitude": "-3.88611000"
                    },
                    {
                        "id": 49370,
                        "name": "Dyffryn Ardudwy",
                        "latitude": "52.77748000",
                        "longitude": "-4.06468000"
                    },
                    {
                        "id": 49372,
                        "name": "Dyserth",
                        "latitude": "53.30032000",
                        "longitude": "-3.41262000"
                    },
                    {
                        "id": 49431,
                        "name": "Ebbw Vale",
                        "latitude": "51.77714000",
                        "longitude": "-3.20792000"
                    },
                    {
                        "id": 49546,
                        "name": "Ferndale",
                        "latitude": "51.66056000",
                        "longitude": "-3.44750000"
                    },
                    {
                        "id": 49562,
                        "name": "Fishguard",
                        "latitude": "51.99376000",
                        "longitude": "-4.97631000"
                    },
                    {
                        "id": 49574,
                        "name": "Flint",
                        "latitude": "53.24488000",
                        "longitude": "-3.13231000"
                    },
                    {
                        "id": 49580,
                        "name": "Fochriw",
                        "latitude": "51.74003000",
                        "longitude": "-3.29861000"
                    },
                    {
                        "id": 49596,
                        "name": "Four Crosses",
                        "latitude": "52.75941000",
                        "longitude": "-3.08106000"
                    },
                    {
                        "id": 49619,
                        "name": "Gaerwen",
                        "latitude": "53.22112000",
                        "longitude": "-4.27362000"
                    },
                    {
                        "id": 49636,
                        "name": "Gelligaer",
                        "latitude": "51.66444000",
                        "longitude": "-3.25611000"
                    },
                    {
                        "id": 49641,
                        "name": "Gilfach Goch",
                        "latitude": "51.59213000",
                        "longitude": "-3.47296000"
                    },
                    {
                        "id": 49644,
                        "name": "Gilwern",
                        "latitude": "51.82475000",
                        "longitude": "-3.09355000"
                    },
                    {
                        "id": 49647,
                        "name": "Glanamman",
                        "latitude": "51.80000000",
                        "longitude": "-3.93333000"
                    },
                    {
                        "id": 49648,
                        "name": "Glandwr",
                        "latitude": "51.92833000",
                        "longitude": "-4.63333000"
                    },
                    {
                        "id": 49666,
                        "name": "Glyn-neath",
                        "latitude": "51.74750000",
                        "longitude": "-3.61833000"
                    },
                    {
                        "id": 49667,
                        "name": "Glyncorrwg",
                        "latitude": "51.67944000",
                        "longitude": "-3.62806000"
                    },
                    {
                        "id": 49676,
                        "name": "Goodwick",
                        "latitude": "52.00491000",
                        "longitude": "-4.99511000"
                    },
                    {
                        "id": 49684,
                        "name": "Gorseinon",
                        "latitude": "51.66931000",
                        "longitude": "-4.04163000"
                    },
                    {
                        "id": 49693,
                        "name": "Govilon",
                        "latitude": "51.81928000",
                        "longitude": "-3.06295000"
                    },
                    {
                        "id": 49740,
                        "name": "Greenfield",
                        "latitude": "53.28333000",
                        "longitude": "-3.21667000"
                    },
                    {
                        "id": 49749,
                        "name": "Gresford",
                        "latitude": "53.08539000",
                        "longitude": "-2.97062000"
                    },
                    {
                        "id": 49756,
                        "name": "Gronant",
                        "latitude": "53.33669000",
                        "longitude": "-3.36031000"
                    },
                    {
                        "id": 49759,
                        "name": "Grovesend",
                        "latitude": "51.68472000",
                        "longitude": "-4.03833000"
                    },
                    {
                        "id": 49763,
                        "name": "Guilsfield",
                        "latitude": "52.69634000",
                        "longitude": "-3.15712000"
                    },
                    {
                        "id": 49769,
                        "name": "Gwynedd",
                        "latitude": "52.83333000",
                        "longitude": "-3.91667000"
                    },
                    {
                        "id": 49807,
                        "name": "Harlech",
                        "latitude": "52.85941000",
                        "longitude": "-4.10831000"
                    },
                    {
                        "id": 49847,
                        "name": "Haverfordwest",
                        "latitude": "51.80169000",
                        "longitude": "-4.96914000"
                    },
                    {
                        "id": 49850,
                        "name": "Hawarden",
                        "latitude": "53.18478000",
                        "longitude": "-3.02578000"
                    },
                    {
                        "id": 49858,
                        "name": "Hay",
                        "latitude": "52.07049000",
                        "longitude": "-3.12741000"
                    },
                    {
                        "id": 49902,
                        "name": "Hengoed",
                        "latitude": "51.65083000",
                        "longitude": "-3.23167000"
                    },
                    {
                        "id": 49905,
                        "name": "Henllan",
                        "latitude": "53.20000000",
                        "longitude": "-3.46667000"
                    },
                    {
                        "id": 49950,
                        "name": "Hirwaun",
                        "latitude": "51.73917000",
                        "longitude": "-3.51028000"
                    },
                    {
                        "id": 49971,
                        "name": "Holyhead",
                        "latitude": "53.30621000",
                        "longitude": "-4.63211000"
                    },
                    {
                        "id": 49973,
                        "name": "Holywell",
                        "latitude": "53.27466000",
                        "longitude": "-3.22895000"
                    },
                    {
                        "id": 49980,
                        "name": "Hook",
                        "latitude": "51.76500000",
                        "longitude": "-4.93167000"
                    },
                    {
                        "id": 49983,
                        "name": "Hope",
                        "latitude": "53.11667000",
                        "longitude": "-3.03333000"
                    },
                    {
                        "id": 50022,
                        "name": "Hundleton",
                        "latitude": "51.66694000",
                        "longitude": "-4.94917000"
                    },
                    {
                        "id": 50095,
                        "name": "Johnston",
                        "latitude": "51.75556000",
                        "longitude": "-4.99667000"
                    },
                    {
                        "id": 50138,
                        "name": "Kidwelly",
                        "latitude": "51.73639000",
                        "longitude": "-4.30333000"
                    },
                    {
                        "id": 50143,
                        "name": "Kilgetty",
                        "latitude": "51.73203000",
                        "longitude": "-4.71983000"
                    },
                    {
                        "id": 50219,
                        "name": "Knighton",
                        "latitude": "52.34251000",
                        "longitude": "-3.04708000"
                    },
                    {
                        "id": 50233,
                        "name": "Lampeter",
                        "latitude": "52.11285000",
                        "longitude": "-4.08039000"
                    },
                    {
                        "id": 50273,
                        "name": "Leeswood",
                        "latitude": "53.13347000",
                        "longitude": "-3.09466000"
                    },
                    {
                        "id": 50290,
                        "name": "Letterston",
                        "latitude": "51.92757000",
                        "longitude": "-4.99141000"
                    },
                    {
                        "id": 50340,
                        "name": "Llanarth",
                        "latitude": "52.19424000",
                        "longitude": "-4.30811000"
                    },
                    {
                        "id": 50341,
                        "name": "Llanbedr",
                        "latitude": "52.81667000",
                        "longitude": "-4.10000000"
                    },
                    {
                        "id": 50342,
                        "name": "Llanberis",
                        "latitude": "53.11809000",
                        "longitude": "-4.12923000"
                    },
                    {
                        "id": 50343,
                        "name": "Llanbradach",
                        "latitude": "51.60639000",
                        "longitude": "-3.23028000"
                    },
                    {
                        "id": 50344,
                        "name": "Llandeilo",
                        "latitude": "51.88459000",
                        "longitude": "-3.99154000"
                    },
                    {
                        "id": 50345,
                        "name": "Llandovery",
                        "latitude": "51.99415000",
                        "longitude": "-3.79637000"
                    },
                    {
                        "id": 50346,
                        "name": "Llandrindod Wells",
                        "latitude": "52.24164000",
                        "longitude": "-3.37868000"
                    },
                    {
                        "id": 50347,
                        "name": "Llandudno",
                        "latitude": "53.32498000",
                        "longitude": "-3.83148000"
                    },
                    {
                        "id": 50348,
                        "name": "Llandybie",
                        "latitude": "51.82044000",
                        "longitude": "-4.00710000"
                    },
                    {
                        "id": 50349,
                        "name": "Llandysul",
                        "latitude": "52.04166000",
                        "longitude": "-4.30909000"
                    },
                    {
                        "id": 50350,
                        "name": "Llanelli",
                        "latitude": "51.68195000",
                        "longitude": "-4.16191000"
                    },
                    {
                        "id": 50351,
                        "name": "Llanerchymedd",
                        "latitude": "53.33055000",
                        "longitude": "-4.37700000"
                    },
                    {
                        "id": 50352,
                        "name": "Llanfair Caereinion",
                        "latitude": "52.64790000",
                        "longitude": "-3.32668000"
                    },
                    {
                        "id": 50353,
                        "name": "Llanfairfechan",
                        "latitude": "53.25779000",
                        "longitude": "-3.97423000"
                    },
                    {
                        "id": 50354,
                        "name": "Llanfairpwllgwyngyll",
                        "latitude": "53.22141000",
                        "longitude": "-4.20329000"
                    },
                    {
                        "id": 50355,
                        "name": "Llanfyllin",
                        "latitude": "52.76570000",
                        "longitude": "-3.27187000"
                    },
                    {
                        "id": 50356,
                        "name": "Llangefni",
                        "latitude": "53.25561000",
                        "longitude": "-4.31063000"
                    },
                    {
                        "id": 50357,
                        "name": "Llangoed",
                        "latitude": "53.29420000",
                        "longitude": "-4.08772000"
                    },
                    {
                        "id": 50358,
                        "name": "Llangollen",
                        "latitude": "52.96829000",
                        "longitude": "-3.17127000"
                    },
                    {
                        "id": 50359,
                        "name": "Llangwm",
                        "latitude": "51.74833000",
                        "longitude": "-4.91361000"
                    },
                    {
                        "id": 50360,
                        "name": "Llangybi",
                        "latitude": "51.66583000",
                        "longitude": "-2.90806000"
                    },
                    {
                        "id": 50361,
                        "name": "Llangynidr",
                        "latitude": "51.86730000",
                        "longitude": "-3.22762000"
                    },
                    {
                        "id": 50362,
                        "name": "Llanharan",
                        "latitude": "51.53805000",
                        "longitude": "-3.43906000"
                    },
                    {
                        "id": 50363,
                        "name": "Llanharry",
                        "latitude": "51.51422000",
                        "longitude": "-3.43240000"
                    },
                    {
                        "id": 50364,
                        "name": "Llanidloes",
                        "latitude": "52.44977000",
                        "longitude": "-3.53997000"
                    },
                    {
                        "id": 50365,
                        "name": "Llanilar",
                        "latitude": "52.35657000",
                        "longitude": "-4.02574000"
                    },
                    {
                        "id": 50366,
                        "name": "Llanrhaeadr-ym-Mochnant",
                        "latitude": "52.82507000",
                        "longitude": "-3.30225000"
                    },
                    {
                        "id": 50367,
                        "name": "Llanrug",
                        "latitude": "53.14788000",
                        "longitude": "-4.19596000"
                    },
                    {
                        "id": 50368,
                        "name": "Llanrwst",
                        "latitude": "53.14021000",
                        "longitude": "-3.79527000"
                    },
                    {
                        "id": 50369,
                        "name": "Llansantffraid Glan Conwy",
                        "latitude": "53.26667000",
                        "longitude": "-3.80000000"
                    },
                    {
                        "id": 50370,
                        "name": "Llansteffan",
                        "latitude": "51.77222000",
                        "longitude": "-4.39139000"
                    },
                    {
                        "id": 50371,
                        "name": "Llantrisant",
                        "latitude": "51.54028000",
                        "longitude": "-3.37389000"
                    },
                    {
                        "id": 50372,
                        "name": "Llantwit Fardre",
                        "latitude": "51.55460000",
                        "longitude": "-3.33241000"
                    },
                    {
                        "id": 50373,
                        "name": "Llantwit Major",
                        "latitude": "51.41070000",
                        "longitude": "-3.48632000"
                    },
                    {
                        "id": 50374,
                        "name": "Llwynypia",
                        "latitude": "51.63333000",
                        "longitude": "-3.45000000"
                    },
                    {
                        "id": 50460,
                        "name": "Machen",
                        "latitude": "51.59599000",
                        "longitude": "-3.14190000"
                    },
                    {
                        "id": 50461,
                        "name": "Machynlleth",
                        "latitude": "52.59097000",
                        "longitude": "-3.85051000"
                    },
                    {
                        "id": 50465,
                        "name": "Maesteg",
                        "latitude": "51.60926000",
                        "longitude": "-3.65823000"
                    },
                    {
                        "id": 50470,
                        "name": "Magor",
                        "latitude": "51.57944000",
                        "longitude": "-2.83139000"
                    },
                    {
                        "id": 50493,
                        "name": "Marchwiel",
                        "latitude": "53.02390000",
                        "longitude": "-2.96106000"
                    },
                    {
                        "id": 50518,
                        "name": "Marshfield",
                        "latitude": "51.53389000",
                        "longitude": "-3.07306000"
                    },
                    {
                        "id": 50545,
                        "name": "Menai Bridge",
                        "latitude": "53.22775000",
                        "longitude": "-4.16926000"
                    },
                    {
                        "id": 50554,
                        "name": "Merthyr Tydfil",
                        "latitude": "51.74794000",
                        "longitude": "-3.37779000"
                    },
                    {
                        "id": 50555,
                        "name": "Merthyr Tydfil County Borough",
                        "latitude": "51.75000000",
                        "longitude": "-3.33333000"
                    },
                    {
                        "id": 50582,
                        "name": "Milford Haven",
                        "latitude": "51.71278000",
                        "longitude": "-5.03410000"
                    },
                    {
                        "id": 50610,
                        "name": "Moelfre",
                        "latitude": "53.35228000",
                        "longitude": "-4.23734000"
                    },
                    {
                        "id": 50614,
                        "name": "Mold",
                        "latitude": "53.16674000",
                        "longitude": "-3.14143000"
                    },
                    {
                        "id": 50619,
                        "name": "Monmouth",
                        "latitude": "51.81265000",
                        "longitude": "-2.71363000"
                    },
                    {
                        "id": 50620,
                        "name": "Monmouthshire",
                        "latitude": "51.75000000",
                        "longitude": "-2.83333000"
                    },
                    {
                        "id": 50636,
                        "name": "Mostyn",
                        "latitude": "53.31271000",
                        "longitude": "-3.26765000"
                    },
                    {
                        "id": 50642,
                        "name": "Mountain Ash",
                        "latitude": "51.68361000",
                        "longitude": "-3.38008000"
                    },
                    {
                        "id": 50664,
                        "name": "Narberth",
                        "latitude": "51.79784000",
                        "longitude": "-4.74275000"
                    },
                    {
                        "id": 50667,
                        "name": "Neath",
                        "latitude": "51.66317000",
                        "longitude": "-3.80443000"
                    },
                    {
                        "id": 50668,
                        "name": "Neath Port Talbot",
                        "latitude": "51.66667000",
                        "longitude": "-3.75000000"
                    },
                    {
                        "id": 50672,
                        "name": "Nefyn",
                        "latitude": "52.93538000",
                        "longitude": "-4.52250000"
                    },
                    {
                        "id": 50675,
                        "name": "Nelson",
                        "latitude": "51.65333000",
                        "longitude": "-3.28444000"
                    },
                    {
                        "id": 50694,
                        "name": "New Quay",
                        "latitude": "52.21515000",
                        "longitude": "-4.35887000"
                    },
                    {
                        "id": 50697,
                        "name": "New Tredegar",
                        "latitude": "51.72051000",
                        "longitude": "-3.24130000"
                    },
                    {
                        "id": 50703,
                        "name": "Newbridge",
                        "latitude": "51.66667000",
                        "longitude": "-3.13333000"
                    },
                    {
                        "id": 50708,
                        "name": "Newcastle Emlyn",
                        "latitude": "52.04056000",
                        "longitude": "-4.46670000"
                    },
                    {
                        "id": 50720,
                        "name": "Newport",
                        "latitude": "51.58774000",
                        "longitude": "-2.99835000"
                    },
                    {
                        "id": 50737,
                        "name": "Newtown",
                        "latitude": "52.51667000",
                        "longitude": "-3.30000000"
                    },
                    {
                        "id": 50742,
                        "name": "Neyland",
                        "latitude": "51.71014000",
                        "longitude": "-4.95155000"
                    },
                    {
                        "id": 50779,
                        "name": "Northop",
                        "latitude": "53.20692000",
                        "longitude": "-3.13277000"
                    },
                    {
                        "id": 50799,
                        "name": "Ogmore Vale",
                        "latitude": "51.60230000",
                        "longitude": "-3.54217000"
                    },
                    {
                        "id": 50836,
                        "name": "Overton",
                        "latitude": "52.96667000",
                        "longitude": "-2.93333000"
                    },
                    {
                        "id": 50871,
                        "name": "Pembroke",
                        "latitude": "51.67464000",
                        "longitude": "-4.91286000"
                    },
                    {
                        "id": 50872,
                        "name": "Pembroke Dock",
                        "latitude": "51.69161000",
                        "longitude": "-4.94036000"
                    },
                    {
                        "id": 50873,
                        "name": "Pembrokeshire",
                        "latitude": "51.83333000",
                        "longitude": "-4.91667000"
                    },
                    {
                        "id": 50875,
                        "name": "Pen-clawdd",
                        "latitude": "51.64028000",
                        "longitude": "-4.09917000"
                    },
                    {
                        "id": 50876,
                        "name": "Penally",
                        "latitude": "51.65986000",
                        "longitude": "-4.72399000"
                    },
                    {
                        "id": 50877,
                        "name": "Penarth",
                        "latitude": "51.43860000",
                        "longitude": "-3.17342000"
                    },
                    {
                        "id": 50878,
                        "name": "Pencader",
                        "latitude": "52.00080000",
                        "longitude": "-4.26575000"
                    },
                    {
                        "id": 50880,
                        "name": "Pencoed",
                        "latitude": "51.52371000",
                        "longitude": "-3.50016000"
                    },
                    {
                        "id": 50884,
                        "name": "Penmaenmawr",
                        "latitude": "53.26667000",
                        "longitude": "-3.93333000"
                    },
                    {
                        "id": 50885,
                        "name": "Penparcau",
                        "latitude": "52.40333000",
                        "longitude": "-4.07417000"
                    },
                    {
                        "id": 50886,
                        "name": "Penrhyndeudraeth",
                        "latitude": "52.93333000",
                        "longitude": "-4.06667000"
                    },
                    {
                        "id": 50890,
                        "name": "Pentre",
                        "latitude": "51.65429000",
                        "longitude": "-3.49133000"
                    },
                    {
                        "id": 50891,
                        "name": "Pentyrch",
                        "latitude": "51.52889000",
                        "longitude": "-3.29500000"
                    },
                    {
                        "id": 50892,
                        "name": "Penyffordd",
                        "latitude": "53.14829000",
                        "longitude": "-3.04584000"
                    },
                    {
                        "id": 50893,
                        "name": "Penygroes",
                        "latitude": "53.05502000",
                        "longitude": "-4.28535000"
                    },
                    {
                        "id": 50936,
                        "name": "Pont Rhyd-y-cyff",
                        "latitude": "51.58694000",
                        "longitude": "-3.63639000"
                    },
                    {
                        "id": 50937,
                        "name": "Pontarddulais",
                        "latitude": "51.71423000",
                        "longitude": "-4.03859000"
                    },
                    {
                        "id": 50941,
                        "name": "Pontlliw",
                        "latitude": "51.69139000",
                        "longitude": "-4.01056000"
                    },
                    {
                        "id": 50942,
                        "name": "Pontyates",
                        "latitude": "51.75182000",
                        "longitude": "-4.21718000"
                    },
                    {
                        "id": 50943,
                        "name": "Pontyberem",
                        "latitude": "51.77826000",
                        "longitude": "-4.16890000"
                    },
                    {
                        "id": 50944,
                        "name": "Pontyclun",
                        "latitude": "51.52162000",
                        "longitude": "-3.39145000"
                    },
                    {
                        "id": 50945,
                        "name": "Pontycymer",
                        "latitude": "51.61118000",
                        "longitude": "-3.58421000"
                    },
                    {
                        "id": 50946,
                        "name": "Pontypool",
                        "latitude": "51.70111000",
                        "longitude": "-3.04444000"
                    },
                    {
                        "id": 50947,
                        "name": "Pontypridd",
                        "latitude": "51.60210000",
                        "longitude": "-3.34211000"
                    },
                    {
                        "id": 50955,
                        "name": "Port Talbot",
                        "latitude": "51.59241000",
                        "longitude": "-3.78019000"
                    },
                    {
                        "id": 50960,
                        "name": "Porthcawl",
                        "latitude": "51.47903000",
                        "longitude": "-3.70362000"
                    },
                    {
                        "id": 50962,
                        "name": "Porthmadog",
                        "latitude": "52.92924000",
                        "longitude": "-4.13137000"
                    },
                    {
                        "id": 50984,
                        "name": "Prestatyn",
                        "latitude": "53.33748000",
                        "longitude": "-3.40776000"
                    },
                    {
                        "id": 50986,
                        "name": "Presteigne",
                        "latitude": "52.27183000",
                        "longitude": "-3.00579000"
                    },
                    {
                        "id": 50991,
                        "name": "Price Town",
                        "latitude": "51.61832000",
                        "longitude": "-3.53662000"
                    },
                    {
                        "id": 51008,
                        "name": "Pwllheli",
                        "latitude": "52.88990000",
                        "longitude": "-4.41451000"
                    },
                    {
                        "id": 51009,
                        "name": "Pyle",
                        "latitude": "51.51667000",
                        "longitude": "-3.70000000"
                    },
                    {
                        "id": 51021,
                        "name": "Radyr",
                        "latitude": "51.51864000",
                        "longitude": "-3.25829000"
                    },
                    {
                        "id": 51022,
                        "name": "Raglan",
                        "latitude": "51.76500000",
                        "longitude": "-2.85331000"
                    },
                    {
                        "id": 51064,
                        "name": "Resolven",
                        "latitude": "51.71193000",
                        "longitude": "-3.69745000"
                    },
                    {
                        "id": 51066,
                        "name": "Rhayader",
                        "latitude": "52.30154000",
                        "longitude": "-3.51146000"
                    },
                    {
                        "id": 51067,
                        "name": "Rhondda",
                        "latitude": "51.65896000",
                        "longitude": "-3.44885000"
                    },
                    {
                        "id": 51068,
                        "name": "Rhondda Cynon Taf",
                        "latitude": "51.66667000",
                        "longitude": "-3.50000000"
                    },
                    {
                        "id": 51069,
                        "name": "Rhoose",
                        "latitude": "51.38818000",
                        "longitude": "-3.35430000"
                    },
                    {
                        "id": 51070,
                        "name": "Rhosllanerchrugog",
                        "latitude": "53.00974000",
                        "longitude": "-3.05814000"
                    },
                    {
                        "id": 51071,
                        "name": "Rhosneigr",
                        "latitude": "53.23186000",
                        "longitude": "-4.51480000"
                    },
                    {
                        "id": 51073,
                        "name": "Rhuddlan",
                        "latitude": "53.29203000",
                        "longitude": "-3.46996000"
                    },
                    {
                        "id": 51074,
                        "name": "Rhyl",
                        "latitude": "53.31929000",
                        "longitude": "-3.49228000"
                    },
                    {
                        "id": 51075,
                        "name": "Rhymney",
                        "latitude": "51.75998000",
                        "longitude": "-3.28553000"
                    },
                    {
                        "id": 51088,
                        "name": "Risca",
                        "latitude": "51.60799000",
                        "longitude": "-3.10081000"
                    },
                    {
                        "id": 51100,
                        "name": "Rogiet",
                        "latitude": "51.58854000",
                        "longitude": "-2.77868000"
                    },
                    {
                        "id": 51112,
                        "name": "Rossett",
                        "latitude": "53.10921000",
                        "longitude": "-2.94478000"
                    },
                    {
                        "id": 51136,
                        "name": "Ruabon",
                        "latitude": "52.98780000",
                        "longitude": "-3.03883000"
                    },
                    {
                        "id": 51150,
                        "name": "Ruthin",
                        "latitude": "53.11368000",
                        "longitude": "-3.31782000"
                    },
                    {
                        "id": 51164,
                        "name": "Saint Asaph",
                        "latitude": "53.25815000",
                        "longitude": "-3.44524000"
                    },
                    {
                        "id": 51167,
                        "name": "Saint Clears",
                        "latitude": "51.81989000",
                        "longitude": "-4.49783000"
                    },
                    {
                        "id": 51170,
                        "name": "Saint Davids",
                        "latitude": "51.88094000",
                        "longitude": "-5.26554000"
                    },
                    {
                        "id": 51202,
                        "name": "Saundersfoot",
                        "latitude": "51.70945000",
                        "longitude": "-4.70215000"
                    },
                    {
                        "id": 51239,
                        "name": "Seven Sisters",
                        "latitude": "51.76667000",
                        "longitude": "-3.71667000"
                    },
                    {
                        "id": 51315,
                        "name": "Sir Powys",
                        "latitude": "52.33333000",
                        "longitude": "-3.41667000"
                    },
                    {
                        "id": 51375,
                        "name": "Southgate",
                        "latitude": "51.56944000",
                        "longitude": "-4.08972000"
                    },
                    {
                        "id": 51389,
                        "name": "Spittal",
                        "latitude": "51.86889000",
                        "longitude": "-4.94250000"
                    },
                    {
                        "id": 51448,
                        "name": "Steynton",
                        "latitude": "51.72917000",
                        "longitude": "-5.01722000"
                    },
                    {
                        "id": 51532,
                        "name": "Swansea",
                        "latitude": "51.62079000",
                        "longitude": "-3.94323000"
                    },
                    {
                        "id": 51546,
                        "name": "Taibach",
                        "latitude": "51.58333000",
                        "longitude": "-3.76667000"
                    },
                    {
                        "id": 51549,
                        "name": "Tal-y-bont",
                        "latitude": "52.77471000",
                        "longitude": "-4.09224000"
                    },
                    {
                        "id": 51550,
                        "name": "Talgarth",
                        "latitude": "51.99588000",
                        "longitude": "-3.23205000"
                    },
                    {
                        "id": 51551,
                        "name": "Talysarn",
                        "latitude": "53.05365000",
                        "longitude": "-4.25767000"
                    },
                    {
                        "id": 51573,
                        "name": "Templeton",
                        "latitude": "51.77194000",
                        "longitude": "-4.73778000"
                    },
                    {
                        "id": 51576,
                        "name": "Tenby",
                        "latitude": "51.67279000",
                        "longitude": "-4.70447000"
                    },
                    {
                        "id": 51611,
                        "name": "Three Crosses",
                        "latitude": "51.62865000",
                        "longitude": "-4.06263000"
                    },
                    {
                        "id": 51629,
                        "name": "Tintern",
                        "latitude": "51.69677000",
                        "longitude": "-2.68142000"
                    },
                    {
                        "id": 51641,
                        "name": "Tonypandy",
                        "latitude": "51.62202000",
                        "longitude": "-3.45544000"
                    },
                    {
                        "id": 51642,
                        "name": "Tonyrefail",
                        "latitude": "51.58402000",
                        "longitude": "-3.43041000"
                    },
                    {
                        "id": 51644,
                        "name": "Torfaen County Borough",
                        "latitude": "51.70146000",
                        "longitude": "-3.05136000"
                    },
                    {
                        "id": 51660,
                        "name": "Trawsfynydd",
                        "latitude": "52.90212000",
                        "longitude": "-3.92289000"
                    },
                    {
                        "id": 51661,
                        "name": "Tredegar",
                        "latitude": "51.77251000",
                        "longitude": "-3.24679000"
                    },
                    {
                        "id": 51663,
                        "name": "Trefnant",
                        "latitude": "53.22526000",
                        "longitude": "-3.42030000"
                    },
                    {
                        "id": 51664,
                        "name": "Tregaron",
                        "latitude": "52.21950000",
                        "longitude": "-3.93295000"
                    },
                    {
                        "id": 51665,
                        "name": "Tregarth",
                        "latitude": "53.19012000",
                        "longitude": "-4.08780000"
                    },
                    {
                        "id": 51666,
                        "name": "Treharris",
                        "latitude": "51.66457000",
                        "longitude": "-3.30725000"
                    },
                    {
                        "id": 51667,
                        "name": "Treorchy",
                        "latitude": "51.65958000",
                        "longitude": "-3.50587000"
                    },
                    {
                        "id": 51668,
                        "name": "Treuddyn",
                        "latitude": "53.11480000",
                        "longitude": "-3.12003000"
                    },
                    {
                        "id": 51671,
                        "name": "Trimsaran",
                        "latitude": "51.71988000",
                        "longitude": "-4.24168000"
                    },
                    {
                        "id": 51677,
                        "name": "Tumble",
                        "latitude": "51.78361000",
                        "longitude": "-4.10972000"
                    },
                    {
                        "id": 51684,
                        "name": "Tycroes",
                        "latitude": "51.77806000",
                        "longitude": "-4.02000000"
                    },
                    {
                        "id": 51688,
                        "name": "Tywyn",
                        "latitude": "52.58578000",
                        "longitude": "-4.09276000"
                    },
                    {
                        "id": 51696,
                        "name": "Undy",
                        "latitude": "51.57526000",
                        "longitude": "-2.81453000"
                    },
                    {
                        "id": 51710,
                        "name": "Usk",
                        "latitude": "51.70347000",
                        "longitude": "-2.90332000"
                    },
                    {
                        "id": 51712,
                        "name": "Vale of Glamorgan",
                        "latitude": "51.41667000",
                        "longitude": "-3.41667000"
                    },
                    {
                        "id": 51714,
                        "name": "Valley",
                        "latitude": "53.28490000",
                        "longitude": "-4.56644000"
                    },
                    {
                        "id": 51717,
                        "name": "Victoria",
                        "latitude": "51.75000000",
                        "longitude": "-3.20000000"
                    },
                    {
                        "id": 51794,
                        "name": "Welshpool",
                        "latitude": "52.65973000",
                        "longitude": "-3.14710000"
                    },
                    {
                        "id": 51803,
                        "name": "Wenvoe",
                        "latitude": "51.44776000",
                        "longitude": "-3.26369000"
                    },
                    {
                        "id": 51877,
                        "name": "Whitland",
                        "latitude": "51.81889000",
                        "longitude": "-4.61528000"
                    },
                    {
                        "id": 51888,
                        "name": "Wick",
                        "latitude": "51.43944000",
                        "longitude": "-3.54944000"
                    },
                    {
                        "id": 51998,
                        "name": "Wrexham",
                        "latitude": "53.00000000",
                        "longitude": "-3.00000000"
                    },
                    {
                        "id": 52008,
                        "name": "Y Felinheli",
                        "latitude": "53.18737000",
                        "longitude": "-4.20476000"
                    },
                    {
                        "id": 52023,
                        "name": "Ynysybwl",
                        "latitude": "51.63922000",
                        "longitude": "-3.36036000"
                    },
                    {
                        "id": 52027,
                        "name": "Ystalyfera",
                        "latitude": "51.76716000",
                        "longitude": "-3.78082000"
                    }
                ]
            },
            {
                "id": 2292,
                "name": "Walsall",
                "iso2": "WLL",
                "latitude": "52.58621400",
                "longitude": "-1.98291900",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2326,
                "name": "Waltham Forest",
                "iso2": "WFT",
                "latitude": "51.58863830",
                "longitude": "-0.01176250",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2434,
                "name": "Wandsworth",
                "iso2": "WND",
                "latitude": "51.45682740",
                "longitude": "-0.18966380",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2420,
                "name": "Warrington",
                "iso2": "WRT",
                "latitude": "40.24927410",
                "longitude": "-75.13406040",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2505,
                "name": "Warwickshire",
                "iso2": "WAR",
                "latitude": "52.26713530",
                "longitude": "-1.46752160",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2471,
                "name": "West Berkshire",
                "iso2": "WBK",
                "latitude": "51.43082550",
                "longitude": "-1.14449270",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2440,
                "name": "West Dunbartonshire",
                "iso2": "WDU",
                "latitude": "55.94509250",
                "longitude": "-4.56462590",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2354,
                "name": "West Lothian",
                "iso2": "WLN",
                "latitude": "55.90701980",
                "longitude": "-3.55171670",
                "type": "council area",
                "cities": []
            },
            {
                "id": 2296,
                "name": "West Sussex",
                "iso2": "WSX",
                "latitude": "50.92801430",
                "longitude": "-0.46170750",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2357,
                "name": "Westminster",
                "iso2": "WSM",
                "latitude": "39.57659770",
                "longitude": "-76.99721260",
                "type": "london borough",
                "cities": []
            },
            {
                "id": 2320,
                "name": "Wigan",
                "iso2": "WGN",
                "latitude": "53.51348120",
                "longitude": "-2.61069990",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2391,
                "name": "Wiltshire",
                "iso2": "WIL",
                "latitude": "51.34919960",
                "longitude": "-1.99271050",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2482,
                "name": "Windsor and Maidenhead",
                "iso2": "WNM",
                "latitude": "51.47997120",
                "longitude": "-0.62425650",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2408,
                "name": "Wirral",
                "iso2": "WRL",
                "latitude": "53.37271810",
                "longitude": "-3.07375400",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2419,
                "name": "Wokingham",
                "iso2": "WOK",
                "latitude": "51.41045700",
                "longitude": "-0.83386100",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2489,
                "name": "Wolverhampton",
                "iso2": "WLV",
                "latitude": "52.58891200",
                "longitude": "-2.15646300",
                "type": "metropolitan district",
                "cities": []
            },
            {
                "id": 2510,
                "name": "Worcestershire",
                "iso2": "WOR",
                "latitude": "52.25452250",
                "longitude": "-2.26683820",
                "type": "two-tier county",
                "cities": []
            },
            {
                "id": 2436,
                "name": "Wrexham",
                "iso2": "WRX",
                "latitude": "53.03013780",
                "longitude": "-3.02614870",
                "type": "unitary authority",
                "cities": []
            },
            {
                "id": 2426,
                "name": "York",
                "iso2": "YOR",
                "latitude": "53.95996510",
                "longitude": "-1.08729790",
                "type": "unitary authority",
                "cities": []
            }
        ]
    },
    {
        "id": 233,
        "name": "United States",
        "iso3": "USA",
        "iso2": "US",
        "numeric_code": "840",
        "phonecode": "1",
        "capital": "Washington",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".us",
        "native": "United States",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Northern America",
        "subregion_id": 6,
        "nationality": "American",
        "timezones": [
            {
                "zoneName": "America\/Adak",
                "gmtOffset": -36000,
                "gmtOffsetName": "UTC-10:00",
                "abbreviation": "HST",
                "tzName": "Hawaii–Aleutian Standard Time"
            },
            {
                "zoneName": "America\/Anchorage",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "America\/Boise",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Chicago",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Denver",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Detroit",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Indianapolis",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Knox",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Marengo",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Petersburg",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Tell_City",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Vevay",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Vincennes",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Winamac",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Juneau",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "America\/Kentucky\/Louisville",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Kentucky\/Monticello",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Los_Angeles",
                "gmtOffset": -28800,
                "gmtOffsetName": "UTC-08:00",
                "abbreviation": "PST",
                "tzName": "Pacific Standard Time (North America"
            },
            {
                "zoneName": "America\/Menominee",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Metlakatla",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "America\/New_York",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Nome",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "America\/North_Dakota\/Beulah",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/North_Dakota\/Center",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/North_Dakota\/New_Salem",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Phoenix",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Sitka",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "America\/Yakutat",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "Pacific\/Honolulu",
                "gmtOffset": -36000,
                "gmtOffsetName": "UTC-10:00",
                "abbreviation": "HST",
                "tzName": "Hawaii–Aleutian Standard Time"
            }
        ],
        "translations": {
            "br": "Stadoù-Unanet",
            "ko": "미국",
            "pt-BR": "Estados Unidos",
            "pt": "Estados Unidos",
            "nl": "Verenigde Staten",
            "hr": "Sjedinjene Američke Države",
            "fa": "ایالات متحده آمریکا",
            "de": "Vereinigte Staaten von Amerika",
            "es": "Estados Unidos",
            "fr": "États-Unis",
            "ja": "アメリカ合衆国",
            "it": "Stati Uniti D'America",
            "zh-CN": "美国",
            "tr": "Amerika",
            "ru": "Соединенные Штаты",
            "uk": "Сполучені Штати",
            "pl": "Stany Zjednoczone"
        },
        "latitude": "38.00000000",
        "longitude": "-97.00000000",
        "emoji": "🇺🇸",
        "emojiU": "U+1F1FA U+1F1F8",
        "states": [
            {
                "id": 1456,
                "name": "Alabama",
                "iso2": "AL",
                "latitude": "32.31823140",
                "longitude": "-86.90229800",
                "type": "state",
                "cities": [
                    {
                        "id": 110968,
                        "name": "Abbeville",
                        "latitude": "31.57184000",
                        "longitude": "-85.25049000"
                    },
                    {
                        "id": 111032,
                        "name": "Adamsville",
                        "latitude": "33.60094000",
                        "longitude": "-86.95611000"
                    },
                    {
                        "id": 111083,
                        "name": "Alabaster",
                        "latitude": "33.24428000",
                        "longitude": "-86.81638000"
                    },
                    {
                        "id": 111120,
                        "name": "Albertville",
                        "latitude": "34.26783000",
                        "longitude": "-86.20878000"
                    },
                    {
                        "id": 111146,
                        "name": "Alexander City",
                        "latitude": "32.94401000",
                        "longitude": "-85.95385000"
                    },
                    {
                        "id": 111152,
                        "name": "Alexandria",
                        "latitude": "33.77399000",
                        "longitude": "-85.88552000"
                    },
                    {
                        "id": 111172,
                        "name": "Aliceville",
                        "latitude": "33.12957000",
                        "longitude": "-88.15142000"
                    },
                    {
                        "id": 111309,
                        "name": "Andalusia",
                        "latitude": "31.30808000",
                        "longitude": "-86.48243000"
                    },
                    {
                        "id": 111355,
                        "name": "Anniston",
                        "latitude": "33.65983000",
                        "longitude": "-85.83163000"
                    },
                    {
                        "id": 111407,
                        "name": "Arab",
                        "latitude": "34.31815000",
                        "longitude": "-86.49582000"
                    },
                    {
                        "id": 111448,
                        "name": "Argo",
                        "latitude": "33.68778000",
                        "longitude": "-86.50051000"
                    },
                    {
                        "id": 111524,
                        "name": "Ashford",
                        "latitude": "31.18296000",
                        "longitude": "-85.23632000"
                    },
                    {
                        "id": 111533,
                        "name": "Ashland",
                        "latitude": "33.27373000",
                        "longitude": "-85.83607000"
                    },
                    {
                        "id": 111548,
                        "name": "Ashville",
                        "latitude": "33.83704000",
                        "longitude": "-86.25442000"
                    },
                    {
                        "id": 111577,
                        "name": "Athens",
                        "latitude": "34.80243000",
                        "longitude": "-86.97219000"
                    },
                    {
                        "id": 111602,
                        "name": "Atmore",
                        "latitude": "31.02379000",
                        "longitude": "-87.49387000"
                    },
                    {
                        "id": 111608,
                        "name": "Attalla",
                        "latitude": "34.02176000",
                        "longitude": "-86.08859000"
                    },
                    {
                        "id": 111623,
                        "name": "Auburn",
                        "latitude": "32.60986000",
                        "longitude": "-85.48078000"
                    },
                    {
                        "id": 111671,
                        "name": "Autauga County",
                        "latitude": "32.53492000",
                        "longitude": "-86.64276000"
                    },
                    {
                        "id": 111761,
                        "name": "Baldwin County",
                        "latitude": "30.66097000",
                        "longitude": "-87.74984000"
                    },
                    {
                        "id": 111774,
                        "name": "Ballplay",
                        "latitude": "34.05871000",
                        "longitude": "-85.80802000"
                    },
                    {
                        "id": 111815,
                        "name": "Barbour County",
                        "latitude": "31.86960000",
                        "longitude": "-85.39320000"
                    },
                    {
                        "id": 111929,
                        "name": "Bay Minette",
                        "latitude": "30.88296000",
                        "longitude": "-87.77305000"
                    },
                    {
                        "id": 111948,
                        "name": "Bayou La Batre",
                        "latitude": "30.40352000",
                        "longitude": "-88.24852000"
                    },
                    {
                        "id": 111975,
                        "name": "Bear Creek",
                        "latitude": "34.27482000",
                        "longitude": "-87.70058000"
                    },
                    {
                        "id": 112252,
                        "name": "Berry",
                        "latitude": "33.65983000",
                        "longitude": "-87.60001000"
                    },
                    {
                        "id": 112267,
                        "name": "Bessemer",
                        "latitude": "33.40178000",
                        "longitude": "-86.95444000"
                    },
                    {
                        "id": 112309,
                        "name": "Bibb County",
                        "latitude": "32.99864000",
                        "longitude": "-87.12644000"
                    },
                    {
                        "id": 112358,
                        "name": "Birmingham",
                        "latitude": "33.52066000",
                        "longitude": "-86.80249000"
                    },
                    {
                        "id": 112457,
                        "name": "Blount County",
                        "latitude": "33.98087000",
                        "longitude": "-86.56737000"
                    },
                    {
                        "id": 112460,
                        "name": "Blountsville",
                        "latitude": "34.08149000",
                        "longitude": "-86.59110000"
                    },
                    {
                        "id": 112474,
                        "name": "Blue Ridge",
                        "latitude": "32.49264000",
                        "longitude": "-86.19052000"
                    },
                    {
                        "id": 112490,
                        "name": "Boaz",
                        "latitude": "34.20065000",
                        "longitude": "-86.16637000"
                    },
                    {
                        "id": 112725,
                        "name": "Brent",
                        "latitude": "32.93735000",
                        "longitude": "-87.16472000"
                    },
                    {
                        "id": 112747,
                        "name": "Brewton",
                        "latitude": "31.10518000",
                        "longitude": "-87.07219000"
                    },
                    {
                        "id": 112758,
                        "name": "Bridgeport",
                        "latitude": "34.94758000",
                        "longitude": "-85.71442000"
                    },
                    {
                        "id": 112786,
                        "name": "Brighton",
                        "latitude": "33.43428000",
                        "longitude": "-86.94721000"
                    },
                    {
                        "id": 112848,
                        "name": "Brook Highland",
                        "latitude": "33.43566000",
                        "longitude": "-86.67388000"
                    },
                    {
                        "id": 112886,
                        "name": "Brookside",
                        "latitude": "33.63788000",
                        "longitude": "-86.91666000"
                    },
                    {
                        "id": 112897,
                        "name": "Brookwood",
                        "latitude": "33.25567000",
                        "longitude": "-87.32083000"
                    },
                    {
                        "id": 112946,
                        "name": "Brundidge",
                        "latitude": "31.72016000",
                        "longitude": "-85.81606000"
                    },
                    {
                        "id": 113034,
                        "name": "Bullock County",
                        "latitude": "32.10055000",
                        "longitude": "-85.71570000"
                    },
                    {
                        "id": 113106,
                        "name": "Butler",
                        "latitude": "32.08959000",
                        "longitude": "-88.22197000"
                    },
                    {
                        "id": 113114,
                        "name": "Butler County",
                        "latitude": "31.75243000",
                        "longitude": "-86.68029000"
                    },
                    {
                        "id": 113138,
                        "name": "Bynum",
                        "latitude": "33.61316000",
                        "longitude": "-85.96108000"
                    },
                    {
                        "id": 113167,
                        "name": "Cahaba Heights",
                        "latitude": "33.46400000",
                        "longitude": "-86.73193000"
                    },
                    {
                        "id": 113194,
                        "name": "Calera",
                        "latitude": "33.10290000",
                        "longitude": "-86.75360000"
                    },
                    {
                        "id": 113200,
                        "name": "Calhoun County",
                        "latitude": "33.77143000",
                        "longitude": "-85.82603000"
                    },
                    {
                        "id": 113259,
                        "name": "Camden",
                        "latitude": "31.99098000",
                        "longitude": "-87.29055000"
                    },
                    {
                        "id": 113386,
                        "name": "Carbon Hill",
                        "latitude": "33.89177000",
                        "longitude": "-87.52612000"
                    },
                    {
                        "id": 113407,
                        "name": "Carlisle-Rockledge",
                        "latitude": "34.11445000",
                        "longitude": "-86.12407000"
                    },
                    {
                        "id": 113463,
                        "name": "Carrollton",
                        "latitude": "33.26169000",
                        "longitude": "-88.09503000"
                    },
                    {
                        "id": 113601,
                        "name": "Cedar Bluff",
                        "latitude": "34.22009000",
                        "longitude": "-85.60774000"
                    },
                    {
                        "id": 113646,
                        "name": "Center Point",
                        "latitude": "33.64566000",
                        "longitude": "-86.68360000"
                    },
                    {
                        "id": 113688,
                        "name": "Centre",
                        "latitude": "34.15204000",
                        "longitude": "-85.67885000"
                    },
                    {
                        "id": 113691,
                        "name": "Centreville",
                        "latitude": "32.94620000",
                        "longitude": "-87.11669000"
                    },
                    {
                        "id": 113713,
                        "name": "Chalkville",
                        "latitude": "33.65316000",
                        "longitude": "-86.64777000"
                    },
                    {
                        "id": 113720,
                        "name": "Chambers County",
                        "latitude": "32.91437000",
                        "longitude": "-85.39204000"
                    },
                    {
                        "id": 113804,
                        "name": "Chatom",
                        "latitude": "31.46517000",
                        "longitude": "-88.25446000"
                    },
                    {
                        "id": 113829,
                        "name": "Chelsea",
                        "latitude": "33.34011000",
                        "longitude": "-86.63026000"
                    },
                    {
                        "id": 113845,
                        "name": "Cherokee",
                        "latitude": "34.75703000",
                        "longitude": "-87.97281000"
                    },
                    {
                        "id": 113849,
                        "name": "Cherokee County",
                        "latitude": "34.17596000",
                        "longitude": "-85.60379000"
                    },
                    {
                        "id": 113938,
                        "name": "Chickasaw",
                        "latitude": "30.76380000",
                        "longitude": "-88.07472000"
                    },
                    {
                        "id": 113949,
                        "name": "Childersburg",
                        "latitude": "33.27817000",
                        "longitude": "-86.35498000"
                    },
                    {
                        "id": 113957,
                        "name": "Chilton County",
                        "latitude": "32.84785000",
                        "longitude": "-86.71881000"
                    },
                    {
                        "id": 113984,
                        "name": "Choccolocco",
                        "latitude": "33.65927000",
                        "longitude": "-85.70357000"
                    },
                    {
                        "id": 113986,
                        "name": "Choctaw County",
                        "latitude": "32.01961000",
                        "longitude": "-88.26320000"
                    },
                    {
                        "id": 114033,
                        "name": "Citronelle",
                        "latitude": "31.09073000",
                        "longitude": "-88.22806000"
                    },
                    {
                        "id": 114099,
                        "name": "Clanton",
                        "latitude": "32.83874000",
                        "longitude": "-86.62943000"
                    },
                    {
                        "id": 114134,
                        "name": "Clarke County",
                        "latitude": "31.67666000",
                        "longitude": "-87.83081000"
                    },
                    {
                        "id": 114165,
                        "name": "Clay",
                        "latitude": "33.70260000",
                        "longitude": "-86.59971000"
                    },
                    {
                        "id": 114173,
                        "name": "Clay County",
                        "latitude": "33.26909000",
                        "longitude": "-85.86055000"
                    },
                    {
                        "id": 114196,
                        "name": "Clayton",
                        "latitude": "31.87822000",
                        "longitude": "-85.44966000"
                    },
                    {
                        "id": 114230,
                        "name": "Cleburne County",
                        "latitude": "33.67456000",
                        "longitude": "-85.51877000"
                    },
                    {
                        "id": 114240,
                        "name": "Cleveland",
                        "latitude": "33.99093000",
                        "longitude": "-86.57749000"
                    },
                    {
                        "id": 114301,
                        "name": "Clio",
                        "latitude": "31.70878000",
                        "longitude": "-85.61050000"
                    },
                    {
                        "id": 114337,
                        "name": "Coaling",
                        "latitude": "33.15901000",
                        "longitude": "-87.34083000"
                    },
                    {
                        "id": 114367,
                        "name": "Coffee County",
                        "latitude": "31.40263000",
                        "longitude": "-85.98821000"
                    },
                    {
                        "id": 114379,
                        "name": "Colbert County",
                        "latitude": "34.70043000",
                        "longitude": "-87.80498000"
                    },
                    {
                        "id": 114433,
                        "name": "Collinsville",
                        "latitude": "34.26398000",
                        "longitude": "-85.86053000"
                    },
                    {
                        "id": 114487,
                        "name": "Columbiana",
                        "latitude": "33.17817000",
                        "longitude": "-86.60721000"
                    },
                    {
                        "id": 114534,
                        "name": "Concord",
                        "latitude": "33.46761000",
                        "longitude": "-87.03111000"
                    },
                    {
                        "id": 114550,
                        "name": "Conecuh County",
                        "latitude": "31.42927000",
                        "longitude": "-86.99368000"
                    },
                    {
                        "id": 114613,
                        "name": "Coosa County",
                        "latitude": "32.93623000",
                        "longitude": "-86.24766000"
                    },
                    {
                        "id": 114614,
                        "name": "Coosada",
                        "latitude": "32.49791000",
                        "longitude": "-86.33136000"
                    },
                    {
                        "id": 114638,
                        "name": "Cordova",
                        "latitude": "33.75983000",
                        "longitude": "-87.18333000"
                    },
                    {
                        "id": 114699,
                        "name": "Cottonwood",
                        "latitude": "31.04879000",
                        "longitude": "-85.30493000"
                    },
                    {
                        "id": 114742,
                        "name": "Covington County",
                        "latitude": "31.24849000",
                        "longitude": "-86.45125000"
                    },
                    {
                        "id": 114745,
                        "name": "Cowarts",
                        "latitude": "31.20018000",
                        "longitude": "-85.30465000"
                    },
                    {
                        "id": 114791,
                        "name": "Crenshaw County",
                        "latitude": "31.73149000",
                        "longitude": "-86.31355000"
                    },
                    {
                        "id": 114792,
                        "name": "Creola",
                        "latitude": "30.89185000",
                        "longitude": "-88.03972000"
                    },
                    {
                        "id": 114855,
                        "name": "Crossville",
                        "latitude": "34.28759000",
                        "longitude": "-85.99414000"
                    },
                    {
                        "id": 114895,
                        "name": "Cullman",
                        "latitude": "34.17482000",
                        "longitude": "-86.84361000"
                    },
                    {
                        "id": 114896,
                        "name": "Cullman County",
                        "latitude": "34.13194000",
                        "longitude": "-86.86762000"
                    },
                    {
                        "id": 114968,
                        "name": "Dadeville",
                        "latitude": "32.83124000",
                        "longitude": "-85.76357000"
                    },
                    {
                        "id": 114982,
                        "name": "Dale County",
                        "latitude": "31.43182000",
                        "longitude": "-85.61103000"
                    },
                    {
                        "id": 114983,
                        "name": "Daleville",
                        "latitude": "31.31017000",
                        "longitude": "-85.71299000"
                    },
                    {
                        "id": 114994,
                        "name": "Dallas County",
                        "latitude": "32.32597000",
                        "longitude": "-87.10648000"
                    },
                    {
                        "id": 115032,
                        "name": "Danville",
                        "latitude": "34.41454000",
                        "longitude": "-87.08751000"
                    },
                    {
                        "id": 115040,
                        "name": "Daphne",
                        "latitude": "30.60353000",
                        "longitude": "-87.90360000"
                    },
                    {
                        "id": 115057,
                        "name": "Dauphin Island",
                        "latitude": "30.25548000",
                        "longitude": "-88.10972000"
                    },
                    {
                        "id": 115148,
                        "name": "Deatsville",
                        "latitude": "32.60819000",
                        "longitude": "-86.39581000"
                    },
                    {
                        "id": 115149,
                        "name": "Decatur",
                        "latitude": "34.60593000",
                        "longitude": "-86.98334000"
                    },
                    {
                        "id": 115128,
                        "name": "DeKalb County",
                        "latitude": "34.45977000",
                        "longitude": "-85.80414000"
                    },
                    {
                        "id": 115232,
                        "name": "Demopolis",
                        "latitude": "32.51764000",
                        "longitude": "-87.83640000"
                    },
                    {
                        "id": 115360,
                        "name": "Dixiana",
                        "latitude": "33.74021000",
                        "longitude": "-86.64938000"
                    },
                    {
                        "id": 115407,
                        "name": "Dora",
                        "latitude": "33.72872000",
                        "longitude": "-87.09028000"
                    },
                    {
                        "id": 115415,
                        "name": "Dothan",
                        "latitude": "31.22323000",
                        "longitude": "-85.39049000"
                    },
                    {
                        "id": 115417,
                        "name": "Double Springs",
                        "latitude": "34.14637000",
                        "longitude": "-87.40247000"
                    },
                    {
                        "id": 115636,
                        "name": "East Brewton",
                        "latitude": "31.09323000",
                        "longitude": "-87.06275000"
                    },
                    {
                        "id": 115662,
                        "name": "East Florence",
                        "latitude": "34.80953000",
                        "longitude": "-87.64947000"
                    },
                    {
                        "id": 115816,
                        "name": "Eclectic",
                        "latitude": "32.63541000",
                        "longitude": "-86.03441000"
                    },
                    {
                        "id": 115941,
                        "name": "Elba",
                        "latitude": "31.41461000",
                        "longitude": "-86.06772000"
                    },
                    {
                        "id": 115944,
                        "name": "Elberta",
                        "latitude": "30.41436000",
                        "longitude": "-87.59776000"
                    },
                    {
                        "id": 116056,
                        "name": "Elmore",
                        "latitude": "32.53874000",
                        "longitude": "-86.31497000"
                    },
                    {
                        "id": 116057,
                        "name": "Elmore County",
                        "latitude": "32.59665000",
                        "longitude": "-86.14915000"
                    },
                    {
                        "id": 116092,
                        "name": "Emerald Mountain",
                        "latitude": "32.44793000",
                        "longitude": "-86.09429000"
                    },
                    {
                        "id": 116148,
                        "name": "Enterprise",
                        "latitude": "31.31517000",
                        "longitude": "-85.85522000"
                    },
                    {
                        "id": 116179,
                        "name": "Escambia County",
                        "latitude": "31.12612000",
                        "longitude": "-87.16162000"
                    },
                    {
                        "id": 116219,
                        "name": "Etowah County",
                        "latitude": "34.04525000",
                        "longitude": "-86.03476000"
                    },
                    {
                        "id": 116224,
                        "name": "Eufaula",
                        "latitude": "31.89127000",
                        "longitude": "-85.14549000"
                    },
                    {
                        "id": 116242,
                        "name": "Eutaw",
                        "latitude": "32.84059000",
                        "longitude": "-87.88762000"
                    },
                    {
                        "id": 116261,
                        "name": "Evergreen",
                        "latitude": "31.43350000",
                        "longitude": "-86.95692000"
                    },
                    {
                        "id": 116309,
                        "name": "Fairfield",
                        "latitude": "33.48594000",
                        "longitude": "-86.91194000"
                    },
                    {
                        "id": 116326,
                        "name": "Fairhope",
                        "latitude": "30.52297000",
                        "longitude": "-87.90333000"
                    },
                    {
                        "id": 116369,
                        "name": "Falkville",
                        "latitude": "34.36843000",
                        "longitude": "-86.90862000"
                    },
                    {
                        "id": 116438,
                        "name": "Fayette",
                        "latitude": "33.68455000",
                        "longitude": "-87.83085000"
                    },
                    {
                        "id": 116443,
                        "name": "Fayette County",
                        "latitude": "33.72121000",
                        "longitude": "-87.73886000"
                    },
                    {
                        "id": 116453,
                        "name": "Fayetteville",
                        "latitude": "33.14567000",
                        "longitude": "-86.40581000"
                    },
                    {
                        "id": 116567,
                        "name": "Flint City",
                        "latitude": "34.52315000",
                        "longitude": "-86.97029000"
                    },
                    {
                        "id": 116569,
                        "name": "Flomaton",
                        "latitude": "31.00018000",
                        "longitude": "-87.26081000"
                    },
                    {
                        "id": 116576,
                        "name": "Florala",
                        "latitude": "31.00518000",
                        "longitude": "-86.32800000"
                    },
                    {
                        "id": 116577,
                        "name": "Florence",
                        "latitude": "34.79981000",
                        "longitude": "-87.67725000"
                    },
                    {
                        "id": 116619,
                        "name": "Foley",
                        "latitude": "30.40659000",
                        "longitude": "-87.68360000"
                    },
                    {
                        "id": 116669,
                        "name": "Forestdale",
                        "latitude": "33.57011000",
                        "longitude": "-86.89638000"
                    },
                    {
                        "id": 116705,
                        "name": "Fort Deposit",
                        "latitude": "31.98459000",
                        "longitude": "-86.57859000"
                    },
                    {
                        "id": 116738,
                        "name": "Fort Payne",
                        "latitude": "34.44425000",
                        "longitude": "-85.71969000"
                    },
                    {
                        "id": 116747,
                        "name": "Fort Rucker",
                        "latitude": "31.34282000",
                        "longitude": "-85.71538000"
                    },
                    {
                        "id": 116843,
                        "name": "Franklin County",
                        "latitude": "34.44167000",
                        "longitude": "-87.84381000"
                    },
                    {
                        "id": 116957,
                        "name": "Frisco City",
                        "latitude": "31.43350000",
                        "longitude": "-87.40138000"
                    },
                    {
                        "id": 116999,
                        "name": "Fultondale",
                        "latitude": "33.60483000",
                        "longitude": "-86.79388000"
                    },
                    {
                        "id": 117003,
                        "name": "Fyffe",
                        "latitude": "34.44676000",
                        "longitude": "-85.90414000"
                    },
                    {
                        "id": 117004,
                        "name": "Gadsden",
                        "latitude": "34.01434000",
                        "longitude": "-86.00639000"
                    },
                    {
                        "id": 117070,
                        "name": "Gardendale",
                        "latitude": "33.66010000",
                        "longitude": "-86.81277000"
                    },
                    {
                        "id": 117139,
                        "name": "Geneva",
                        "latitude": "31.03296000",
                        "longitude": "-85.86382000"
                    },
                    {
                        "id": 117146,
                        "name": "Geneva County",
                        "latitude": "31.09502000",
                        "longitude": "-85.83898000"
                    },
                    {
                        "id": 117167,
                        "name": "Georgiana",
                        "latitude": "31.63710000",
                        "longitude": "-86.74192000"
                    },
                    {
                        "id": 117276,
                        "name": "Glencoe",
                        "latitude": "33.95704000",
                        "longitude": "-85.93247000"
                    },
                    {
                        "id": 117377,
                        "name": "Good Hope",
                        "latitude": "34.11593000",
                        "longitude": "-86.86361000"
                    },
                    {
                        "id": 117391,
                        "name": "Goodwater",
                        "latitude": "33.06567000",
                        "longitude": "-86.05330000"
                    },
                    {
                        "id": 117395,
                        "name": "Gordo",
                        "latitude": "33.32012000",
                        "longitude": "-87.90280000"
                    },
                    {
                        "id": 117449,
                        "name": "Grand Bay",
                        "latitude": "30.47631000",
                        "longitude": "-88.34223000"
                    },
                    {
                        "id": 117565,
                        "name": "Grayson Valley",
                        "latitude": "33.64816000",
                        "longitude": "-86.63943000"
                    },
                    {
                        "id": 117566,
                        "name": "Graysville",
                        "latitude": "33.62066000",
                        "longitude": "-86.97138000"
                    },
                    {
                        "id": 117631,
                        "name": "Greene County",
                        "latitude": "32.85314000",
                        "longitude": "-87.95223000"
                    },
                    {
                        "id": 117664,
                        "name": "Greensboro",
                        "latitude": "32.70415000",
                        "longitude": "-87.59550000"
                    },
                    {
                        "id": 117680,
                        "name": "Greenville",
                        "latitude": "31.82960000",
                        "longitude": "-86.61775000"
                    },
                    {
                        "id": 117757,
                        "name": "Grove Hill",
                        "latitude": "31.70877000",
                        "longitude": "-87.77722000"
                    },
                    {
                        "id": 117789,
                        "name": "Guin",
                        "latitude": "33.96566000",
                        "longitude": "-87.91475000"
                    },
                    {
                        "id": 117795,
                        "name": "Gulf Shores",
                        "latitude": "30.24604000",
                        "longitude": "-87.70082000"
                    },
                    {
                        "id": 117806,
                        "name": "Guntersville",
                        "latitude": "34.35823000",
                        "longitude": "-86.29446000"
                    },
                    {
                        "id": 117830,
                        "name": "Hackleburg",
                        "latitude": "34.27732000",
                        "longitude": "-87.82864000"
                    },
                    {
                        "id": 117848,
                        "name": "Hale County",
                        "latitude": "32.76266000",
                        "longitude": "-87.62912000"
                    },
                    {
                        "id": 117853,
                        "name": "Haleyville",
                        "latitude": "34.22649000",
                        "longitude": "-87.62141000"
                    },
                    {
                        "id": 117887,
                        "name": "Hamilton",
                        "latitude": "34.14232000",
                        "longitude": "-87.98864000"
                    },
                    {
                        "id": 117946,
                        "name": "Hanceville",
                        "latitude": "34.06065000",
                        "longitude": "-86.76750000"
                    },
                    {
                        "id": 118036,
                        "name": "Harpersville",
                        "latitude": "33.34400000",
                        "longitude": "-86.43804000"
                    },
                    {
                        "id": 118084,
                        "name": "Hartford",
                        "latitude": "31.10240000",
                        "longitude": "-85.69688000"
                    },
                    {
                        "id": 118102,
                        "name": "Hartselle",
                        "latitude": "34.44343000",
                        "longitude": "-86.93528000"
                    },
                    {
                        "id": 118110,
                        "name": "Harvest",
                        "latitude": "34.85564000",
                        "longitude": "-86.75083000"
                    },
                    {
                        "id": 118177,
                        "name": "Hayden",
                        "latitude": "33.89260000",
                        "longitude": "-86.75777000"
                    },
                    {
                        "id": 118189,
                        "name": "Hayneville",
                        "latitude": "32.18403000",
                        "longitude": "-86.58025000"
                    },
                    {
                        "id": 118204,
                        "name": "Hazel Green",
                        "latitude": "34.93231000",
                        "longitude": "-86.57194000"
                    },
                    {
                        "id": 118216,
                        "name": "Headland",
                        "latitude": "31.35128000",
                        "longitude": "-85.34216000"
                    },
                    {
                        "id": 118243,
                        "name": "Heflin",
                        "latitude": "33.64899000",
                        "longitude": "-85.58746000"
                    },
                    {
                        "id": 118246,
                        "name": "Helena",
                        "latitude": "33.29622000",
                        "longitude": "-86.84360000"
                    },
                    {
                        "id": 118272,
                        "name": "Henagar",
                        "latitude": "34.63508000",
                        "longitude": "-85.76719000"
                    },
                    {
                        "id": 118297,
                        "name": "Henry County",
                        "latitude": "31.51469000",
                        "longitude": "-85.24141000"
                    },
                    {
                        "id": 118408,
                        "name": "Highland Lakes",
                        "latitude": "33.39838000",
                        "longitude": "-86.65130000"
                    },
                    {
                        "id": 118516,
                        "name": "Hokes Bluff",
                        "latitude": "33.99815000",
                        "longitude": "-85.86636000"
                    },
                    {
                        "id": 118574,
                        "name": "Holt",
                        "latitude": "33.23401000",
                        "longitude": "-87.48445000"
                    },
                    {
                        "id": 118581,
                        "name": "Holtville",
                        "latitude": "32.63624000",
                        "longitude": "-86.32664000"
                    },
                    {
                        "id": 118607,
                        "name": "Homewood",
                        "latitude": "33.47177000",
                        "longitude": "-86.80082000"
                    },
                    {
                        "id": 118638,
                        "name": "Hoover",
                        "latitude": "33.40539000",
                        "longitude": "-86.81138000"
                    },
                    {
                        "id": 118702,
                        "name": "Houston County",
                        "latitude": "31.15318000",
                        "longitude": "-85.30252000"
                    },
                    {
                        "id": 118756,
                        "name": "Hueytown",
                        "latitude": "33.45122000",
                        "longitude": "-86.99666000"
                    },
                    {
                        "id": 118770,
                        "name": "Huguley",
                        "latitude": "32.83457000",
                        "longitude": "-85.22966000"
                    },
                    {
                        "id": 118814,
                        "name": "Huntsville",
                        "latitude": "34.73040000",
                        "longitude": "-86.58594000"
                    },
                    {
                        "id": 118919,
                        "name": "Indian Springs Village",
                        "latitude": "33.35539000",
                        "longitude": "-86.75443000"
                    },
                    {
                        "id": 118954,
                        "name": "Inverness",
                        "latitude": "32.01488000",
                        "longitude": "-85.74606000"
                    },
                    {
                        "id": 118994,
                        "name": "Irondale",
                        "latitude": "33.53816000",
                        "longitude": "-86.70721000"
                    },
                    {
                        "id": 119060,
                        "name": "Jackson",
                        "latitude": "31.50905000",
                        "longitude": "-87.89444000"
                    },
                    {
                        "id": 119075,
                        "name": "Jackson County",
                        "latitude": "34.77941000",
                        "longitude": "-85.99930000"
                    },
                    {
                        "id": 119099,
                        "name": "Jacksonville",
                        "latitude": "33.81382000",
                        "longitude": "-85.76130000"
                    },
                    {
                        "id": 119138,
                        "name": "Jasper",
                        "latitude": "33.83122000",
                        "longitude": "-87.27751000"
                    },
                    {
                        "id": 119175,
                        "name": "Jefferson County",
                        "latitude": "33.55431000",
                        "longitude": "-86.89649000"
                    },
                    {
                        "id": 119211,
                        "name": "Jemison",
                        "latitude": "32.95985000",
                        "longitude": "-86.74665000"
                    },
                    {
                        "id": 119569,
                        "name": "Kimberly",
                        "latitude": "33.77344000",
                        "longitude": "-86.81388000"
                    },
                    {
                        "id": 119641,
                        "name": "Kinsey",
                        "latitude": "31.29906000",
                        "longitude": "-85.34438000"
                    },
                    {
                        "id": 119826,
                        "name": "Ladonia",
                        "latitude": "32.46820000",
                        "longitude": "-85.07910000"
                    },
                    {
                        "id": 119831,
                        "name": "Lafayette",
                        "latitude": "32.89985000",
                        "longitude": "-85.40106000"
                    },
                    {
                        "id": 119967,
                        "name": "Lake Purdy",
                        "latitude": "33.43011000",
                        "longitude": "-86.68054000"
                    },
                    {
                        "id": 119986,
                        "name": "Lake View",
                        "latitude": "33.28067000",
                        "longitude": "-87.13750000"
                    },
                    {
                        "id": 120061,
                        "name": "Lamar County",
                        "latitude": "33.77921000",
                        "longitude": "-88.09690000"
                    },
                    {
                        "id": 120108,
                        "name": "Lanett",
                        "latitude": "32.86874000",
                        "longitude": "-85.19050000"
                    },
                    {
                        "id": 120179,
                        "name": "Lauderdale County",
                        "latitude": "34.90137000",
                        "longitude": "-87.65400000"
                    },
                    {
                        "id": 120229,
                        "name": "Lawrence County",
                        "latitude": "34.52165000",
                        "longitude": "-87.31104000"
                    },
                    {
                        "id": 120306,
                        "name": "Lee County",
                        "latitude": "32.60114000",
                        "longitude": "-85.35556000"
                    },
                    {
                        "id": 120320,
                        "name": "Leeds",
                        "latitude": "33.54816000",
                        "longitude": "-86.54443000"
                    },
                    {
                        "id": 120323,
                        "name": "Leesburg",
                        "latitude": "34.17982000",
                        "longitude": "-85.76136000"
                    },
                    {
                        "id": 120404,
                        "name": "Level Plains",
                        "latitude": "31.29962000",
                        "longitude": "-85.77799000"
                    },
                    {
                        "id": 120494,
                        "name": "Limestone County",
                        "latitude": "34.81008000",
                        "longitude": "-86.98137000"
                    },
                    {
                        "id": 120499,
                        "name": "Lincoln",
                        "latitude": "33.61316000",
                        "longitude": "-86.11831000"
                    },
                    {
                        "id": 120560,
                        "name": "Linden",
                        "latitude": "32.30625000",
                        "longitude": "-87.79807000"
                    },
                    {
                        "id": 120577,
                        "name": "Lineville",
                        "latitude": "33.31067000",
                        "longitude": "-85.75441000"
                    },
                    {
                        "id": 120595,
                        "name": "Lipscomb",
                        "latitude": "33.42566000",
                        "longitude": "-86.92666000"
                    },
                    {
                        "id": 120647,
                        "name": "Livingston",
                        "latitude": "32.58430000",
                        "longitude": "-88.18725000"
                    },
                    {
                        "id": 120685,
                        "name": "Locust Fork",
                        "latitude": "33.90760000",
                        "longitude": "-86.61527000"
                    },
                    {
                        "id": 120846,
                        "name": "Lowndes County",
                        "latitude": "32.15475000",
                        "longitude": "-86.65011000"
                    },
                    {
                        "id": 120852,
                        "name": "Loxley",
                        "latitude": "30.61825000",
                        "longitude": "-87.75305000"
                    },
                    {
                        "id": 120899,
                        "name": "Luverne",
                        "latitude": "31.71655000",
                        "longitude": "-86.26385000"
                    },
                    {
                        "id": 120967,
                        "name": "Macon County",
                        "latitude": "32.38597000",
                        "longitude": "-85.69267000"
                    },
                    {
                        "id": 120984,
                        "name": "Madison",
                        "latitude": "34.69926000",
                        "longitude": "-86.74833000"
                    },
                    {
                        "id": 121002,
                        "name": "Madison County",
                        "latitude": "34.76309000",
                        "longitude": "-86.55021000"
                    },
                    {
                        "id": 121070,
                        "name": "Malvern",
                        "latitude": "31.13934000",
                        "longitude": "-85.51910000"
                    },
                    {
                        "id": 121192,
                        "name": "Marbury",
                        "latitude": "32.70124000",
                        "longitude": "-86.47109000"
                    },
                    {
                        "id": 121203,
                        "name": "Marengo County",
                        "latitude": "32.24761000",
                        "longitude": "-87.78952000"
                    },
                    {
                        "id": 121205,
                        "name": "Margaret",
                        "latitude": "33.68621000",
                        "longitude": "-86.47498000"
                    },
                    {
                        "id": 121231,
                        "name": "Marion",
                        "latitude": "32.63235000",
                        "longitude": "-87.31917000"
                    },
                    {
                        "id": 121247,
                        "name": "Marion County",
                        "latitude": "34.13655000",
                        "longitude": "-87.88714000"
                    },
                    {
                        "id": 121310,
                        "name": "Marshall County",
                        "latitude": "34.36696000",
                        "longitude": "-86.30664000"
                    },
                    {
                        "id": 121565,
                        "name": "Meadowbrook",
                        "latitude": "33.40205000",
                        "longitude": "-86.69665000"
                    },
                    {
                        "id": 121698,
                        "name": "Meridianville",
                        "latitude": "34.85148000",
                        "longitude": "-86.57222000"
                    },
                    {
                        "id": 121796,
                        "name": "Midfield",
                        "latitude": "33.46150000",
                        "longitude": "-86.90888000"
                    },
                    {
                        "id": 121803,
                        "name": "Midland City",
                        "latitude": "31.31906000",
                        "longitude": "-85.49382000"
                    },
                    {
                        "id": 121829,
                        "name": "Mignon",
                        "latitude": "33.18345000",
                        "longitude": "-86.26109000"
                    },
                    {
                        "id": 121872,
                        "name": "Millbrook",
                        "latitude": "32.47986000",
                        "longitude": "-86.36192000"
                    },
                    {
                        "id": 121963,
                        "name": "Minor",
                        "latitude": "33.53733000",
                        "longitude": "-86.94055000"
                    },
                    {
                        "id": 122010,
                        "name": "Mobile",
                        "latitude": "30.69436000",
                        "longitude": "-88.04305000"
                    },
                    {
                        "id": 122011,
                        "name": "Mobile County",
                        "latitude": "30.68515000",
                        "longitude": "-88.19753000"
                    },
                    {
                        "id": 122067,
                        "name": "Monroe County",
                        "latitude": "31.57084000",
                        "longitude": "-87.36543000"
                    },
                    {
                        "id": 122084,
                        "name": "Monroeville",
                        "latitude": "31.52794000",
                        "longitude": "-87.32471000"
                    },
                    {
                        "id": 122125,
                        "name": "Montevallo",
                        "latitude": "33.10067000",
                        "longitude": "-86.86416000"
                    },
                    {
                        "id": 122130,
                        "name": "Montgomery",
                        "latitude": "32.36681000",
                        "longitude": "-86.29997000"
                    },
                    {
                        "id": 122139,
                        "name": "Montgomery County",
                        "latitude": "32.22026000",
                        "longitude": "-86.20761000"
                    },
                    {
                        "id": 122195,
                        "name": "Moody",
                        "latitude": "33.59094000",
                        "longitude": "-86.49082000"
                    },
                    {
                        "id": 122207,
                        "name": "Moores Mill",
                        "latitude": "34.84398000",
                        "longitude": "-86.51832000"
                    },
                    {
                        "id": 122236,
                        "name": "Morgan County",
                        "latitude": "34.45347000",
                        "longitude": "-86.85293000"
                    },
                    {
                        "id": 122265,
                        "name": "Morris",
                        "latitude": "33.74816000",
                        "longitude": "-86.80860000"
                    },
                    {
                        "id": 122314,
                        "name": "Moulton",
                        "latitude": "34.48121000",
                        "longitude": "-87.29335000"
                    },
                    {
                        "id": 122328,
                        "name": "Moundville",
                        "latitude": "32.99762000",
                        "longitude": "-87.63001000"
                    },
                    {
                        "id": 122367,
                        "name": "Mount Olive",
                        "latitude": "33.67094000",
                        "longitude": "-86.85610000"
                    },
                    {
                        "id": 122393,
                        "name": "Mount Vernon",
                        "latitude": "31.08518000",
                        "longitude": "-88.01333000"
                    },
                    {
                        "id": 122410,
                        "name": "Mountain Brook",
                        "latitude": "33.50094000",
                        "longitude": "-86.75221000"
                    },
                    {
                        "id": 122470,
                        "name": "Munford",
                        "latitude": "33.52983000",
                        "longitude": "-85.95080000"
                    },
                    {
                        "id": 122503,
                        "name": "Muscle Shoals",
                        "latitude": "34.74481000",
                        "longitude": "-87.66753000"
                    },
                    {
                        "id": 122676,
                        "name": "New Brockton",
                        "latitude": "31.38572000",
                        "longitude": "-85.92939000"
                    },
                    {
                        "id": 122723,
                        "name": "New Hope",
                        "latitude": "34.53712000",
                        "longitude": "-86.39426000"
                    },
                    {
                        "id": 122749,
                        "name": "New Market",
                        "latitude": "34.91003000",
                        "longitude": "-86.42779000"
                    },
                    {
                        "id": 122857,
                        "name": "Newton",
                        "latitude": "31.33517000",
                        "longitude": "-85.60521000"
                    },
                    {
                        "id": 122990,
                        "name": "North Bibb",
                        "latitude": "33.20401000",
                        "longitude": "-87.15305000"
                    },
                    {
                        "id": 123160,
                        "name": "Northport",
                        "latitude": "33.22901000",
                        "longitude": "-87.57723000"
                    },
                    {
                        "id": 123357,
                        "name": "Odenville",
                        "latitude": "33.67732000",
                        "longitude": "-86.39665000"
                    },
                    {
                        "id": 123381,
                        "name": "Ohatchee",
                        "latitude": "33.78343000",
                        "longitude": "-86.00247000"
                    },
                    {
                        "id": 123478,
                        "name": "Oneonta",
                        "latitude": "33.94815000",
                        "longitude": "-86.47276000"
                    },
                    {
                        "id": 123496,
                        "name": "Opelika",
                        "latitude": "32.64541000",
                        "longitude": "-85.37828000"
                    },
                    {
                        "id": 123498,
                        "name": "Opp",
                        "latitude": "31.28267000",
                        "longitude": "-86.25551000"
                    },
                    {
                        "id": 123511,
                        "name": "Orange Beach",
                        "latitude": "30.29437000",
                        "longitude": "-87.57359000"
                    },
                    {
                        "id": 123663,
                        "name": "Owens Cross Roads",
                        "latitude": "34.58815000",
                        "longitude": "-86.45888000"
                    },
                    {
                        "id": 123675,
                        "name": "Oxford",
                        "latitude": "33.61427000",
                        "longitude": "-85.83496000"
                    },
                    {
                        "id": 123696,
                        "name": "Ozark",
                        "latitude": "31.45906000",
                        "longitude": "-85.64049000"
                    },
                    {
                        "id": 123988,
                        "name": "Pelham",
                        "latitude": "33.28567000",
                        "longitude": "-86.80999000"
                    },
                    {
                        "id": 123997,
                        "name": "Pell City",
                        "latitude": "33.58621000",
                        "longitude": "-86.28609000"
                    },
                    {
                        "id": 124074,
                        "name": "Perry County",
                        "latitude": "32.63847000",
                        "longitude": "-87.29440000"
                    },
                    {
                        "id": 124123,
                        "name": "Phenix City",
                        "latitude": "32.47098000",
                        "longitude": "-85.00077000"
                    },
                    {
                        "id": 124124,
                        "name": "Phil Campbell",
                        "latitude": "34.35093000",
                        "longitude": "-87.70642000"
                    },
                    {
                        "id": 124156,
                        "name": "Pickens County",
                        "latitude": "33.28088000",
                        "longitude": "-88.08869000"
                    },
                    {
                        "id": 124164,
                        "name": "Piedmont",
                        "latitude": "33.92455000",
                        "longitude": "-85.61135000"
                    },
                    {
                        "id": 124185,
                        "name": "Pike County",
                        "latitude": "31.80272000",
                        "longitude": "-85.94092000"
                    },
                    {
                        "id": 124196,
                        "name": "Pike Road",
                        "latitude": "32.28431000",
                        "longitude": "-86.10302000"
                    },
                    {
                        "id": 124235,
                        "name": "Pine Level",
                        "latitude": "32.58374000",
                        "longitude": "-86.46553000"
                    },
                    {
                        "id": 124272,
                        "name": "Pinson",
                        "latitude": "33.68899000",
                        "longitude": "-86.68332000"
                    },
                    {
                        "id": 124366,
                        "name": "Pleasant Grove",
                        "latitude": "33.49094000",
                        "longitude": "-86.97027000"
                    },
                    {
                        "id": 124427,
                        "name": "Point Clear",
                        "latitude": "30.47408000",
                        "longitude": "-87.91916000"
                    },
                    {
                        "id": 124638,
                        "name": "Prattville",
                        "latitude": "32.46402000",
                        "longitude": "-86.45970000"
                    },
                    {
                        "id": 124666,
                        "name": "Priceville",
                        "latitude": "34.52509000",
                        "longitude": "-86.89473000"
                    },
                    {
                        "id": 124667,
                        "name": "Prichard",
                        "latitude": "30.73880000",
                        "longitude": "-88.07889000"
                    },
                    {
                        "id": 124821,
                        "name": "Ragland",
                        "latitude": "33.74454000",
                        "longitude": "-86.15581000"
                    },
                    {
                        "id": 124824,
                        "name": "Rainbow City",
                        "latitude": "33.95482000",
                        "longitude": "-86.04192000"
                    },
                    {
                        "id": 124829,
                        "name": "Rainsville",
                        "latitude": "34.49425000",
                        "longitude": "-85.84775000"
                    },
                    {
                        "id": 124872,
                        "name": "Randolph County",
                        "latitude": "33.29379000",
                        "longitude": "-85.45907000"
                    },
                    {
                        "id": 124939,
                        "name": "Red Bay",
                        "latitude": "34.43982000",
                        "longitude": "-88.14087000"
                    },
                    {
                        "id": 124981,
                        "name": "Redstone Arsenal",
                        "latitude": "34.68387000",
                        "longitude": "-86.64764000"
                    },
                    {
                        "id": 124999,
                        "name": "Reform",
                        "latitude": "33.37845000",
                        "longitude": "-88.01530000"
                    },
                    {
                        "id": 125003,
                        "name": "Rehobeth",
                        "latitude": "31.12296000",
                        "longitude": "-85.45271000"
                    },
                    {
                        "id": 125201,
                        "name": "Riverside",
                        "latitude": "33.60621000",
                        "longitude": "-86.20442000"
                    },
                    {
                        "id": 125226,
                        "name": "Roanoke",
                        "latitude": "33.15123000",
                        "longitude": "-85.37217000"
                    },
                    {
                        "id": 125244,
                        "name": "Robertsdale",
                        "latitude": "30.55380000",
                        "longitude": "-87.71193000"
                    },
                    {
                        "id": 125275,
                        "name": "Rock Creek",
                        "latitude": "33.47705000",
                        "longitude": "-87.08027000"
                    },
                    {
                        "id": 125299,
                        "name": "Rockford",
                        "latitude": "32.88957000",
                        "longitude": "-86.21969000"
                    },
                    {
                        "id": 125354,
                        "name": "Rogersville",
                        "latitude": "34.82578000",
                        "longitude": "-87.29676000"
                    },
                    {
                        "id": 125536,
                        "name": "Russell County",
                        "latitude": "32.28838000",
                        "longitude": "-85.18496000"
                    },
                    {
                        "id": 125542,
                        "name": "Russellville",
                        "latitude": "34.50787000",
                        "longitude": "-87.72864000"
                    },
                    {
                        "id": 125621,
                        "name": "Saint Clair County",
                        "latitude": "33.71570000",
                        "longitude": "-86.31469000"
                    },
                    {
                        "id": 125721,
                        "name": "Saks",
                        "latitude": "33.69871000",
                        "longitude": "-85.83969000"
                    },
                    {
                        "id": 125781,
                        "name": "Samson",
                        "latitude": "31.11295000",
                        "longitude": "-86.04605000"
                    },
                    {
                        "id": 125934,
                        "name": "Saraland",
                        "latitude": "30.82074000",
                        "longitude": "-88.07056000"
                    },
                    {
                        "id": 125949,
                        "name": "Sardis City",
                        "latitude": "34.17426000",
                        "longitude": "-86.12275000"
                    },
                    {
                        "id": 125957,
                        "name": "Satsuma",
                        "latitude": "30.85324000",
                        "longitude": "-88.05611000"
                    },
                    {
                        "id": 126061,
                        "name": "Scottsboro",
                        "latitude": "34.67231000",
                        "longitude": "-86.03415000"
                    },
                    {
                        "id": 126138,
                        "name": "Selma",
                        "latitude": "32.40736000",
                        "longitude": "-87.02110000"
                    },
                    {
                        "id": 126143,
                        "name": "Selmont-West Selmont",
                        "latitude": "32.37843000",
                        "longitude": "-87.00740000"
                    },
                    {
                        "id": 126151,
                        "name": "Semmes",
                        "latitude": "30.77824000",
                        "longitude": "-88.25917000"
                    },
                    {
                        "id": 126259,
                        "name": "Sheffield",
                        "latitude": "34.76509000",
                        "longitude": "-87.69864000"
                    },
                    {
                        "id": 126267,
                        "name": "Shelby",
                        "latitude": "33.11040000",
                        "longitude": "-86.58415000"
                    },
                    {
                        "id": 126272,
                        "name": "Shelby County",
                        "latitude": "33.26428000",
                        "longitude": "-86.66065000"
                    },
                    {
                        "id": 126363,
                        "name": "Shoal Creek",
                        "latitude": "33.43076000",
                        "longitude": "-86.61092000"
                    },
                    {
                        "id": 126506,
                        "name": "Slocomb",
                        "latitude": "31.10823000",
                        "longitude": "-85.59438000"
                    },
                    {
                        "id": 126523,
                        "name": "Smiths Station",
                        "latitude": "32.54014000",
                        "longitude": "-85.09855000"
                    },
                    {
                        "id": 126532,
                        "name": "Smoke Rise",
                        "latitude": "33.89177000",
                        "longitude": "-86.82027000"
                    },
                    {
                        "id": 126786,
                        "name": "Southside",
                        "latitude": "33.92454000",
                        "longitude": "-86.02247000"
                    },
                    {
                        "id": 126799,
                        "name": "Spanish Fort",
                        "latitude": "30.67491000",
                        "longitude": "-87.91527000"
                    },
                    {
                        "id": 126914,
                        "name": "Springville",
                        "latitude": "33.77505000",
                        "longitude": "-86.47191000"
                    },
                    {
                        "id": 127007,
                        "name": "Steele",
                        "latitude": "33.93982000",
                        "longitude": "-86.20164000"
                    },
                    {
                        "id": 127044,
                        "name": "Stevenson",
                        "latitude": "34.86869000",
                        "longitude": "-85.83942000"
                    },
                    {
                        "id": 127054,
                        "name": "Stewartville",
                        "latitude": "33.07929000",
                        "longitude": "-86.24442000"
                    },
                    {
                        "id": 127180,
                        "name": "Sulligent",
                        "latitude": "33.90177000",
                        "longitude": "-88.13448000"
                    },
                    {
                        "id": 127200,
                        "name": "Sumiton",
                        "latitude": "33.75566000",
                        "longitude": "-87.05000000"
                    },
                    {
                        "id": 127201,
                        "name": "Summerdale",
                        "latitude": "30.48770000",
                        "longitude": "-87.69971000"
                    },
                    {
                        "id": 127228,
                        "name": "Sumter County",
                        "latitude": "32.59101000",
                        "longitude": "-88.19879000"
                    },
                    {
                        "id": 127354,
                        "name": "Sylacauga",
                        "latitude": "33.17317000",
                        "longitude": "-86.25164000"
                    },
                    {
                        "id": 127358,
                        "name": "Sylvan Springs",
                        "latitude": "33.51566000",
                        "longitude": "-87.01499000"
                    },
                    {
                        "id": 127359,
                        "name": "Sylvania",
                        "latitude": "34.56231000",
                        "longitude": "-85.81247000"
                    },
                    {
                        "id": 127389,
                        "name": "Talladega",
                        "latitude": "33.43594000",
                        "longitude": "-86.10580000"
                    },
                    {
                        "id": 127390,
                        "name": "Talladega County",
                        "latitude": "33.38006000",
                        "longitude": "-86.16591000"
                    },
                    {
                        "id": 127394,
                        "name": "Tallapoosa County",
                        "latitude": "32.86240000",
                        "longitude": "-85.79750000"
                    },
                    {
                        "id": 127395,
                        "name": "Tallassee",
                        "latitude": "32.53597000",
                        "longitude": "-85.89329000"
                    },
                    {
                        "id": 127434,
                        "name": "Tarrant",
                        "latitude": "33.58344000",
                        "longitude": "-86.77277000"
                    },
                    {
                        "id": 127445,
                        "name": "Taylor",
                        "latitude": "31.16490000",
                        "longitude": "-85.46827000"
                    },
                    {
                        "id": 127568,
                        "name": "Theodore",
                        "latitude": "30.54769000",
                        "longitude": "-88.17528000"
                    },
                    {
                        "id": 127587,
                        "name": "Thomasville",
                        "latitude": "31.91349000",
                        "longitude": "-87.73584000"
                    },
                    {
                        "id": 127608,
                        "name": "Thorsby",
                        "latitude": "32.91568000",
                        "longitude": "-86.71582000"
                    },
                    {
                        "id": 127651,
                        "name": "Tillmans Corner",
                        "latitude": "30.59019000",
                        "longitude": "-88.17084000"
                    },
                    {
                        "id": 127757,
                        "name": "Town Creek",
                        "latitude": "34.68120000",
                        "longitude": "-87.40613000"
                    },
                    {
                        "id": 127825,
                        "name": "Trinity",
                        "latitude": "34.60676000",
                        "longitude": "-87.08835000"
                    },
                    {
                        "id": 127841,
                        "name": "Troy",
                        "latitude": "31.80877000",
                        "longitude": "-85.96995000"
                    },
                    {
                        "id": 127860,
                        "name": "Trussville",
                        "latitude": "33.61983000",
                        "longitude": "-86.60888000"
                    },
                    {
                        "id": 127909,
                        "name": "Tuscaloosa",
                        "latitude": "33.20984000",
                        "longitude": "-87.56917000"
                    },
                    {
                        "id": 127910,
                        "name": "Tuscaloosa County",
                        "latitude": "33.28955000",
                        "longitude": "-87.52503000"
                    },
                    {
                        "id": 127914,
                        "name": "Tuscumbia",
                        "latitude": "34.73120000",
                        "longitude": "-87.70253000"
                    },
                    {
                        "id": 127916,
                        "name": "Tuskegee",
                        "latitude": "32.42415000",
                        "longitude": "-85.69096000"
                    },
                    {
                        "id": 127968,
                        "name": "Underwood-Petersville",
                        "latitude": "34.87695000",
                        "longitude": "-87.69717000"
                    },
                    {
                        "id": 128011,
                        "name": "Union Springs",
                        "latitude": "32.14432000",
                        "longitude": "-85.71495000"
                    },
                    {
                        "id": 128015,
                        "name": "Uniontown",
                        "latitude": "32.44958000",
                        "longitude": "-87.51417000"
                    },
                    {
                        "id": 128097,
                        "name": "Valley",
                        "latitude": "32.81874000",
                        "longitude": "-85.17939000"
                    },
                    {
                        "id": 128110,
                        "name": "Valley Grande",
                        "latitude": "32.50902000",
                        "longitude": "-86.98749000"
                    },
                    {
                        "id": 128140,
                        "name": "Vance",
                        "latitude": "33.17428000",
                        "longitude": "-87.23361000"
                    },
                    {
                        "id": 128153,
                        "name": "Vandiver",
                        "latitude": "33.47066000",
                        "longitude": "-86.51332000"
                    },
                    {
                        "id": 128188,
                        "name": "Vernon",
                        "latitude": "33.75705000",
                        "longitude": "-88.10892000"
                    },
                    {
                        "id": 128212,
                        "name": "Vestavia Hills",
                        "latitude": "33.44872000",
                        "longitude": "-86.78777000"
                    },
                    {
                        "id": 128264,
                        "name": "Vincent",
                        "latitude": "33.38455000",
                        "longitude": "-86.41192000"
                    },
                    {
                        "id": 128386,
                        "name": "Walker County",
                        "latitude": "33.80333000",
                        "longitude": "-87.29736000"
                    },
                    {
                        "id": 128513,
                        "name": "Warrior",
                        "latitude": "33.81427000",
                        "longitude": "-86.80944000"
                    },
                    {
                        "id": 128552,
                        "name": "Washington County",
                        "latitude": "31.40760000",
                        "longitude": "-88.20788000"
                    },
                    {
                        "id": 128721,
                        "name": "Weaver",
                        "latitude": "33.75205000",
                        "longitude": "-85.81135000"
                    },
                    {
                        "id": 128724,
                        "name": "Webb",
                        "latitude": "31.26045000",
                        "longitude": "-85.27327000"
                    },
                    {
                        "id": 128750,
                        "name": "Wedowee",
                        "latitude": "33.30900000",
                        "longitude": "-85.48467000"
                    },
                    {
                        "id": 128827,
                        "name": "West Blocton",
                        "latitude": "33.11817000",
                        "longitude": "-87.12500000"
                    },
                    {
                        "id": 128864,
                        "name": "West End-Cobb Town",
                        "latitude": "33.65250000",
                        "longitude": "-85.87420000"
                    },
                    {
                        "id": 129067,
                        "name": "Westover",
                        "latitude": "33.34955000",
                        "longitude": "-86.53582000"
                    },
                    {
                        "id": 129092,
                        "name": "Wetumpka",
                        "latitude": "32.54374000",
                        "longitude": "-86.21191000"
                    },
                    {
                        "id": 129180,
                        "name": "Whitesboro",
                        "latitude": "34.16343000",
                        "longitude": "-86.06942000"
                    },
                    {
                        "id": 129228,
                        "name": "Wilcox County",
                        "latitude": "31.98924000",
                        "longitude": "-87.30820000"
                    },
                    {
                        "id": 129340,
                        "name": "Wilsonville",
                        "latitude": "33.23428000",
                        "longitude": "-86.48359000"
                    },
                    {
                        "id": 129392,
                        "name": "Winfield",
                        "latitude": "33.92899000",
                        "longitude": "-87.81725000"
                    },
                    {
                        "id": 129434,
                        "name": "Winston County",
                        "latitude": "34.14923000",
                        "longitude": "-87.37368000"
                    },
                    {
                        "id": 129560,
                        "name": "Woodstock",
                        "latitude": "33.20678000",
                        "longitude": "-87.15000000"
                    },
                    {
                        "id": 129690,
                        "name": "York",
                        "latitude": "32.48625000",
                        "longitude": "-88.29642000"
                    }
                ]
            },
            {
                "id": 1400,
                "name": "Alaska",
                "iso2": "AK",
                "latitude": "64.20084130",
                "longitude": "-149.49367330",
                "type": "state",
                "cities": [
                    {
                        "id": 111081,
                        "name": "Akutan",
                        "latitude": "54.13350000",
                        "longitude": "-165.77686000"
                    },
                    {
                        "id": 111143,
                        "name": "Aleutians East Borough",
                        "latitude": "54.85000000",
                        "longitude": "-163.41667000"
                    },
                    {
                        "id": 111144,
                        "name": "Aleutians West Census Area",
                        "latitude": "52.16298000",
                        "longitude": "-174.28505000"
                    },
                    {
                        "id": 111303,
                        "name": "Anchor Point",
                        "latitude": "59.77667000",
                        "longitude": "-151.83139000"
                    },
                    {
                        "id": 111305,
                        "name": "Anchorage",
                        "latitude": "61.21806000",
                        "longitude": "-149.90028000"
                    },
                    {
                        "id": 111306,
                        "name": "Anchorage Municipality",
                        "latitude": "61.16667000",
                        "longitude": "-149.25056000"
                    },
                    {
                        "id": 111724,
                        "name": "Badger",
                        "latitude": "64.80000000",
                        "longitude": "-147.53333000"
                    },
                    {
                        "id": 111852,
                        "name": "Barrow",
                        "latitude": "71.29058000",
                        "longitude": "-156.78872000"
                    },
                    {
                        "id": 111976,
                        "name": "Bear Creek",
                        "latitude": "60.16417000",
                        "longitude": "-149.39500000"
                    },
                    {
                        "id": 112281,
                        "name": "Bethel",
                        "latitude": "60.79222000",
                        "longitude": "-161.75583000"
                    },
                    {
                        "id": 112284,
                        "name": "Bethel Census Area",
                        "latitude": "60.75056000",
                        "longitude": "-160.50056000"
                    },
                    {
                        "id": 112325,
                        "name": "Big Lake",
                        "latitude": "61.52139000",
                        "longitude": "-149.95444000"
                    },
                    {
                        "id": 112813,
                        "name": "Bristol Bay Borough",
                        "latitude": "58.75056000",
                        "longitude": "-156.83333000"
                    },
                    {
                        "id": 113124,
                        "name": "Butte",
                        "latitude": "61.54222000",
                        "longitude": "-149.03333000"
                    },
                    {
                        "id": 113917,
                        "name": "Chevak",
                        "latitude": "61.52778000",
                        "longitude": "-165.58639000"
                    },
                    {
                        "id": 114045,
                        "name": "City and Borough of Wrangell",
                        "latitude": "56.41331000",
                        "longitude": "-132.32009000"
                    },
                    {
                        "id": 114374,
                        "name": "Cohoe",
                        "latitude": "60.36861000",
                        "longitude": "-151.30639000"
                    },
                    {
                        "id": 114412,
                        "name": "College",
                        "latitude": "64.85694000",
                        "longitude": "-147.80278000"
                    },
                    {
                        "id": 114640,
                        "name": "Cordova",
                        "latitude": "60.54320000",
                        "longitude": "-145.75867000"
                    },
                    {
                        "id": 114756,
                        "name": "Craig",
                        "latitude": "55.47639000",
                        "longitude": "-133.14833000"
                    },
                    {
                        "id": 115227,
                        "name": "Deltana",
                        "latitude": "63.87217000",
                        "longitude": "-145.21773000"
                    },
                    {
                        "id": 115235,
                        "name": "Denali Borough",
                        "latitude": "63.78889000",
                        "longitude": "-150.19167000"
                    },
                    {
                        "id": 115315,
                        "name": "Diamond Ridge",
                        "latitude": "59.67611000",
                        "longitude": "-151.55750000"
                    },
                    {
                        "id": 115340,
                        "name": "Dillingham",
                        "latitude": "59.03972000",
                        "longitude": "-158.45750000"
                    },
                    {
                        "id": 115341,
                        "name": "Dillingham Census Area",
                        "latitude": "59.76193000",
                        "longitude": "-158.31848000"
                    },
                    {
                        "id": 115578,
                        "name": "Dutch Harbor",
                        "latitude": "53.88980000",
                        "longitude": "-166.54220000"
                    },
                    {
                        "id": 115612,
                        "name": "Eagle River",
                        "latitude": "61.32139000",
                        "longitude": "-149.56778000"
                    },
                    {
                        "id": 115909,
                        "name": "Eielson Air Force Base",
                        "latitude": "64.66327000",
                        "longitude": "-147.05442000"
                    },
                    {
                        "id": 116049,
                        "name": "Elmendorf Air Force Base",
                        "latitude": "61.25703000",
                        "longitude": "-149.63139000"
                    },
                    {
                        "id": 116206,
                        "name": "Ester",
                        "latitude": "64.84722000",
                        "longitude": "-148.01444000"
                    },
                    {
                        "id": 116290,
                        "name": "Fairbanks",
                        "latitude": "64.83778000",
                        "longitude": "-147.71639000"
                    },
                    {
                        "id": 116291,
                        "name": "Fairbanks North Star Borough",
                        "latitude": "64.83333000",
                        "longitude": "-146.41667000"
                    },
                    {
                        "id": 116401,
                        "name": "Farm Loop",
                        "latitude": "61.63891000",
                        "longitude": "-149.14215000"
                    },
                    {
                        "id": 116404,
                        "name": "Farmers Loop",
                        "latitude": "64.90822000",
                        "longitude": "-147.69866000"
                    },
                    {
                        "id": 116531,
                        "name": "Fishhook",
                        "latitude": "61.74402000",
                        "longitude": "-149.23613000"
                    },
                    {
                        "id": 116959,
                        "name": "Fritz Creek",
                        "latitude": "59.73611000",
                        "longitude": "-151.29528000"
                    },
                    {
                        "id": 117124,
                        "name": "Gateway",
                        "latitude": "61.57278000",
                        "longitude": "-149.24083000"
                    },
                    {
                        "id": 117230,
                        "name": "Girdwood",
                        "latitude": "60.94250000",
                        "longitude": "-149.16639000"
                    },
                    {
                        "id": 117843,
                        "name": "Haines",
                        "latitude": "59.23595000",
                        "longitude": "-135.44533000"
                    },
                    {
                        "id": 117844,
                        "name": "Haines Borough",
                        "latitude": "59.25056000",
                        "longitude": "-135.50056000"
                    },
                    {
                        "id": 118219,
                        "name": "Healy",
                        "latitude": "63.85694000",
                        "longitude": "-148.96611000"
                    },
                    {
                        "id": 118597,
                        "name": "Homer",
                        "latitude": "59.64250000",
                        "longitude": "-151.54940000"
                    },
                    {
                        "id": 118632,
                        "name": "Hoonah-Angoon Census Area",
                        "latitude": "57.94807000",
                        "longitude": "-134.94153000"
                    },
                    {
                        "id": 118634,
                        "name": "Hooper Bay",
                        "latitude": "61.53111000",
                        "longitude": "-166.09667000"
                    },
                    {
                        "id": 118701,
                        "name": "Houston",
                        "latitude": "61.63028000",
                        "longitude": "-149.81806000"
                    },
                    {
                        "id": 119338,
                        "name": "Juneau",
                        "latitude": "58.30194000",
                        "longitude": "-134.41972000"
                    },
                    {
                        "id": 119364,
                        "name": "Kalifornsky",
                        "latitude": "60.41833000",
                        "longitude": "-151.29000000"
                    },
                    {
                        "id": 119440,
                        "name": "Kenai",
                        "latitude": "60.55444000",
                        "longitude": "-151.25833000"
                    },
                    {
                        "id": 119441,
                        "name": "Kenai Peninsula Borough",
                        "latitude": "60.41667000",
                        "longitude": "-151.25056000"
                    },
                    {
                        "id": 119523,
                        "name": "Ketchikan",
                        "latitude": "55.34180000",
                        "longitude": "-131.64757000"
                    },
                    {
                        "id": 119524,
                        "name": "Ketchikan Gateway Borough",
                        "latitude": "55.50056000",
                        "longitude": "-131.41667000"
                    },
                    {
                        "id": 119583,
                        "name": "King Cove",
                        "latitude": "55.06087000",
                        "longitude": "-162.31853000"
                    },
                    {
                        "id": 119677,
                        "name": "Knik-Fairview",
                        "latitude": "61.51262000",
                        "longitude": "-149.60012000"
                    },
                    {
                        "id": 119698,
                        "name": "Kodiak",
                        "latitude": "57.78852000",
                        "longitude": "-152.40533000"
                    },
                    {
                        "id": 119699,
                        "name": "Kodiak Island Borough",
                        "latitude": "57.33333000",
                        "longitude": "-153.33333000"
                    },
                    {
                        "id": 119700,
                        "name": "Kodiak Station",
                        "latitude": "57.76587000",
                        "longitude": "-152.60004000"
                    },
                    {
                        "id": 119712,
                        "name": "Kotzebue",
                        "latitude": "66.89846000",
                        "longitude": "-162.59809000"
                    },
                    {
                        "id": 120003,
                        "name": "Lake and Peninsula Borough",
                        "latitude": "57.00056000",
                        "longitude": "-158.00056000"
                    },
                    {
                        "id": 120024,
                        "name": "Lakes",
                        "latitude": "61.60713000",
                        "longitude": "-149.30861000"
                    },
                    {
                        "id": 120256,
                        "name": "Lazy Mountain",
                        "latitude": "61.62611000",
                        "longitude": "-148.94556000"
                    },
                    {
                        "id": 153919,
                        "name": "Marshall",
                        "latitude": "61.87811100",
                        "longitude": "162.08500000"
                    },
                    {
                        "id": 121399,
                        "name": "Matanuska-Susitna Borough",
                        "latitude": "62.50056000",
                        "longitude": "-150.00556000"
                    },
                    {
                        "id": 121561,
                        "name": "Meadow Lakes",
                        "latitude": "61.62472000",
                        "longitude": "-149.60111000"
                    },
                    {
                        "id": 121735,
                        "name": "Metlakatla",
                        "latitude": "55.12848000",
                        "longitude": "-131.57519000"
                    },
                    {
                        "id": 122898,
                        "name": "Nikiski",
                        "latitude": "60.69028000",
                        "longitude": "-151.28889000"
                    },
                    {
                        "id": 122934,
                        "name": "Nome",
                        "latitude": "64.50111000",
                        "longitude": "-165.40639000"
                    },
                    {
                        "id": 122935,
                        "name": "Nome Census Area",
                        "latitude": "64.83333000",
                        "longitude": "-163.75056000"
                    },
                    {
                        "id": 123084,
                        "name": "North Pole",
                        "latitude": "64.75111000",
                        "longitude": "-147.34944000"
                    },
                    {
                        "id": 123107,
                        "name": "North Slope Borough",
                        "latitude": "69.25056000",
                        "longitude": "-152.00056000"
                    },
                    {
                        "id": 123173,
                        "name": "Northwest Arctic Borough",
                        "latitude": "66.83333000",
                        "longitude": "-161.00056000"
                    },
                    {
                        "id": 123760,
                        "name": "Palmer",
                        "latitude": "61.59941000",
                        "longitude": "-149.11456000"
                    },
                    {
                        "id": 124108,
                        "name": "Petersburg",
                        "latitude": "56.81250000",
                        "longitude": "-132.95556000"
                    },
                    {
                        "id": 124110,
                        "name": "Petersburg Borough",
                        "latitude": "56.76529000",
                        "longitude": "-133.19313000"
                    },
                    {
                        "id": 124724,
                        "name": "Prudhoe Bay",
                        "latitude": "70.25528000",
                        "longitude": "-148.33722000"
                    },
                    {
                        "id": 125130,
                        "name": "Ridgeway",
                        "latitude": "60.53194000",
                        "longitude": "-151.08528000"
                    },
                    {
                        "id": 125724,
                        "name": "Salcha",
                        "latitude": "64.52399000",
                        "longitude": "-146.90210000"
                    },
                    {
                        "id": 125860,
                        "name": "Sand Point",
                        "latitude": "55.33655000",
                        "longitude": "-160.49880000"
                    },
                    {
                        "id": 126187,
                        "name": "Seward",
                        "latitude": "60.10426000",
                        "longitude": "-149.44350000"
                    },
                    {
                        "id": 126470,
                        "name": "Sitka",
                        "latitude": "57.05315000",
                        "longitude": "-135.33088000"
                    },
                    {
                        "id": 126471,
                        "name": "Sitka City and Borough",
                        "latitude": "57.08255000",
                        "longitude": "-135.26917000"
                    },
                    {
                        "id": 126475,
                        "name": "Skagway Municipality",
                        "latitude": "59.46852000",
                        "longitude": "-135.30596000"
                    },
                    {
                        "id": 126567,
                        "name": "Soldotna",
                        "latitude": "60.48778000",
                        "longitude": "-151.05833000"
                    },
                    {
                        "id": 126766,
                        "name": "Southeast Fairbanks Census Area",
                        "latitude": "63.75056000",
                        "longitude": "-143.25056000"
                    },
                    {
                        "id": 127031,
                        "name": "Sterling",
                        "latitude": "60.53722000",
                        "longitude": "-150.76472000"
                    },
                    {
                        "id": 127316,
                        "name": "Sutton-Alpine",
                        "latitude": "61.77789000",
                        "longitude": "-148.76450000"
                    },
                    {
                        "id": 127409,
                        "name": "Tanaina",
                        "latitude": "61.62694000",
                        "longitude": "-149.42806000"
                    },
                    {
                        "id": 127697,
                        "name": "Tok",
                        "latitude": "63.33667000",
                        "longitude": "-142.98556000"
                    },
                    {
                        "id": 127966,
                        "name": "Unalaska",
                        "latitude": "53.87413000",
                        "longitude": "-166.53408000"
                    },
                    {
                        "id": 128083,
                        "name": "Valdez",
                        "latitude": "61.13083000",
                        "longitude": "-146.34833000"
                    },
                    {
                        "id": 128084,
                        "name": "Valdez-Cordova Census Area",
                        "latitude": "61.50056000",
                        "longitude": "-144.50056000"
                    },
                    {
                        "id": 128593,
                        "name": "Wasilla",
                        "latitude": "61.58090000",
                        "longitude": "-149.44150000"
                    },
                    {
                        "id": 129304,
                        "name": "Willow",
                        "latitude": "61.74722000",
                        "longitude": "-150.03750000"
                    },
                    {
                        "id": 129601,
                        "name": "Wrangell",
                        "latitude": "56.47083000",
                        "longitude": "-132.37667000"
                    },
                    {
                        "id": 129646,
                        "name": "Y",
                        "latitude": "62.16129000",
                        "longitude": "-149.85075000"
                    },
                    {
                        "id": 129652,
                        "name": "Yakutat City and Borough",
                        "latitude": "59.66667000",
                        "longitude": "-139.13333000"
                    },
                    {
                        "id": 129731,
                        "name": "Yukon-Koyukuk Census Area",
                        "latitude": "65.70000000",
                        "longitude": "-152.71667000"
                    }
                ]
            },
            {
                "id": 1424,
                "name": "American Samoa",
                "iso2": "AS",
                "latitude": "-14.27097200",
                "longitude": "-170.13221700",
                "type": "outlying area",
                "cities": []
            },
            {
                "id": 1434,
                "name": "Arizona",
                "iso2": "AZ",
                "latitude": "34.04892810",
                "longitude": "-111.09373110",
                "type": "state",
                "cities": [
                    {
                        "id": 111065,
                        "name": "Ahwatukee Foothills",
                        "latitude": "33.34171000",
                        "longitude": "-111.98403000"
                    },
                    {
                        "id": 111075,
                        "name": "Ajo",
                        "latitude": "32.37172000",
                        "longitude": "-112.86071000"
                    },
                    {
                        "id": 111170,
                        "name": "Alhambra",
                        "latitude": "33.49838000",
                        "longitude": "-112.13432000"
                    },
                    {
                        "id": 111367,
                        "name": "Anthem",
                        "latitude": "33.86726000",
                        "longitude": "-112.14682000"
                    },
                    {
                        "id": 111380,
                        "name": "Apache County",
                        "latitude": "35.39560000",
                        "longitude": "-109.48884000"
                    },
                    {
                        "id": 111381,
                        "name": "Apache Junction",
                        "latitude": "33.41505000",
                        "longitude": "-111.54958000"
                    },
                    {
                        "id": 111453,
                        "name": "Arivaca Junction",
                        "latitude": "31.72731000",
                        "longitude": "-111.06120000"
                    },
                    {
                        "id": 111454,
                        "name": "Arizona City",
                        "latitude": "32.75589000",
                        "longitude": "-111.67096000"
                    },
                    {
                        "id": 111679,
                        "name": "Avenue B and C",
                        "latitude": "32.71904000",
                        "longitude": "-114.66005000"
                    },
                    {
                        "id": 111701,
                        "name": "Avondale",
                        "latitude": "33.43560000",
                        "longitude": "-112.34960000"
                    },
                    {
                        "id": 111705,
                        "name": "Avra Valley",
                        "latitude": "32.43785000",
                        "longitude": "-111.31539000"
                    },
                    {
                        "id": 111727,
                        "name": "Bagdad",
                        "latitude": "34.58113000",
                        "longitude": "-113.20464000"
                    },
                    {
                        "id": 112002,
                        "name": "Beaver Dam",
                        "latitude": "36.89942000",
                        "longitude": "-113.93274000"
                    },
                    {
                        "id": 112184,
                        "name": "Benson",
                        "latitude": "31.96786000",
                        "longitude": "-110.29452000"
                    },
                    {
                        "id": 112327,
                        "name": "Big Park",
                        "latitude": "34.78030000",
                        "longitude": "-111.76265000"
                    },
                    {
                        "id": 112360,
                        "name": "Bisbee",
                        "latitude": "31.44815000",
                        "longitude": "-109.92841000"
                    },
                    {
                        "id": 112371,
                        "name": "Black Canyon City",
                        "latitude": "34.07087000",
                        "longitude": "-112.15071000"
                    },
                    {
                        "id": 112395,
                        "name": "Blackwater",
                        "latitude": "33.03117000",
                        "longitude": "-111.58263000"
                    },
                    {
                        "id": 112977,
                        "name": "Buckeye",
                        "latitude": "33.37032000",
                        "longitude": "-112.58378000"
                    },
                    {
                        "id": 113031,
                        "name": "Bullhead City",
                        "latitude": "35.14778000",
                        "longitude": "-114.56830000"
                    },
                    {
                        "id": 113136,
                        "name": "Bylas",
                        "latitude": "33.13428000",
                        "longitude": "-110.12004000"
                    },
                    {
                        "id": 113158,
                        "name": "Cactus Flat",
                        "latitude": "32.75840000",
                        "longitude": "-109.71619000"
                    },
                    {
                        "id": 113295,
                        "name": "Camp Verde",
                        "latitude": "34.56364000",
                        "longitude": "-111.85432000"
                    },
                    {
                        "id": 113357,
                        "name": "Canyon Day",
                        "latitude": "33.78477000",
                        "longitude": "-110.02649000"
                    },
                    {
                        "id": 113392,
                        "name": "Carefree",
                        "latitude": "33.82226000",
                        "longitude": "-111.91820000"
                    },
                    {
                        "id": 113508,
                        "name": "Casa Blanca",
                        "latitude": "33.12033000",
                        "longitude": "-111.88819000"
                    },
                    {
                        "id": 113510,
                        "name": "Casa Grande",
                        "latitude": "32.87950000",
                        "longitude": "-111.75735000"
                    },
                    {
                        "id": 113512,
                        "name": "Casas Adobes",
                        "latitude": "32.32341000",
                        "longitude": "-110.99510000"
                    },
                    {
                        "id": 113563,
                        "name": "Catalina",
                        "latitude": "32.50556000",
                        "longitude": "-110.92111000"
                    },
                    {
                        "id": 113564,
                        "name": "Catalina Foothills",
                        "latitude": "32.29785000",
                        "longitude": "-110.91870000"
                    },
                    {
                        "id": 113585,
                        "name": "Cave Creek",
                        "latitude": "33.83333000",
                        "longitude": "-111.95083000"
                    },
                    {
                        "id": 113635,
                        "name": "Centennial Park",
                        "latitude": "36.95381000",
                        "longitude": "-112.98132000"
                    },
                    {
                        "id": 113672,
                        "name": "Central City",
                        "latitude": "33.44001000",
                        "longitude": "-112.05805000"
                    },
                    {
                        "id": 113676,
                        "name": "Central Heights-Midland City",
                        "latitude": "33.40372000",
                        "longitude": "-110.81541000"
                    },
                    {
                        "id": 113731,
                        "name": "Chandler",
                        "latitude": "33.30616000",
                        "longitude": "-111.84125000"
                    },
                    {
                        "id": 113967,
                        "name": "Chinle",
                        "latitude": "36.15445000",
                        "longitude": "-109.55261000"
                    },
                    {
                        "id": 113970,
                        "name": "Chino Valley",
                        "latitude": "34.75752000",
                        "longitude": "-112.45378000"
                    },
                    {
                        "id": 114016,
                        "name": "Cibecue",
                        "latitude": "34.04477000",
                        "longitude": "-110.48539000"
                    },
                    {
                        "id": 114021,
                        "name": "Cienega Springs",
                        "latitude": "34.18863000",
                        "longitude": "-114.22467000"
                    },
                    {
                        "id": 114040,
                        "name": "Citrus Park",
                        "latitude": "33.54865000",
                        "longitude": "-112.44433000"
                    },
                    {
                        "id": 114133,
                        "name": "Clarkdale",
                        "latitude": "34.77113000",
                        "longitude": "-112.05794000"
                    },
                    {
                        "id": 114193,
                        "name": "Claypool",
                        "latitude": "33.41117000",
                        "longitude": "-110.84261000"
                    },
                    {
                        "id": 114260,
                        "name": "Clifton",
                        "latitude": "33.05090000",
                        "longitude": "-109.29618000"
                    },
                    {
                        "id": 114349,
                        "name": "Cochise County",
                        "latitude": "31.87957000",
                        "longitude": "-109.75114000"
                    },
                    {
                        "id": 114360,
                        "name": "Coconino County",
                        "latitude": "35.83873000",
                        "longitude": "-111.77050000"
                    },
                    {
                        "id": 114454,
                        "name": "Colorado City",
                        "latitude": "36.99026000",
                        "longitude": "-112.97577000"
                    },
                    {
                        "id": 114558,
                        "name": "Congress",
                        "latitude": "34.16253000",
                        "longitude": "-112.85074000"
                    },
                    {
                        "id": 114598,
                        "name": "Coolidge",
                        "latitude": "32.97784000",
                        "longitude": "-111.51762000"
                    },
                    {
                        "id": 114637,
                        "name": "Cordes Lakes",
                        "latitude": "34.30781000",
                        "longitude": "-112.10349000"
                    },
                    {
                        "id": 114657,
                        "name": "Cornville",
                        "latitude": "34.71780000",
                        "longitude": "-111.92154000"
                    },
                    {
                        "id": 114663,
                        "name": "Corona de Tucson",
                        "latitude": "31.96536000",
                        "longitude": "-110.77564000"
                    },
                    {
                        "id": 114701,
                        "name": "Cottonwood",
                        "latitude": "34.73919000",
                        "longitude": "-112.00988000"
                    },
                    {
                        "id": 115180,
                        "name": "Deer Valley",
                        "latitude": "33.68393000",
                        "longitude": "-112.13488000"
                    },
                    {
                        "id": 115281,
                        "name": "Desert Hills",
                        "latitude": "34.55390000",
                        "longitude": "-114.37246000"
                    },
                    {
                        "id": 115305,
                        "name": "Dewey-Humboldt",
                        "latitude": "34.53000000",
                        "longitude": "-112.24222000"
                    },
                    {
                        "id": 115338,
                        "name": "Dilkon",
                        "latitude": "35.38529000",
                        "longitude": "-110.32068000"
                    },
                    {
                        "id": 115386,
                        "name": "Dolan Springs",
                        "latitude": "35.59194000",
                        "longitude": "-114.27329000"
                    },
                    {
                        "id": 115402,
                        "name": "Donovan Estates",
                        "latitude": "32.70935000",
                        "longitude": "-114.67822000"
                    },
                    {
                        "id": 115423,
                        "name": "Douglas",
                        "latitude": "31.34455000",
                        "longitude": "-109.54534000"
                    },
                    {
                        "id": 115476,
                        "name": "Drexel Heights",
                        "latitude": "32.14119000",
                        "longitude": "-111.02843000"
                    },
                    {
                        "id": 115594,
                        "name": "Eagar",
                        "latitude": "34.11124000",
                        "longitude": "-109.29238000"
                    },
                    {
                        "id": 115753,
                        "name": "East Sahuarita",
                        "latitude": "31.94286000",
                        "longitude": "-110.92842000"
                    },
                    {
                        "id": 115907,
                        "name": "Ehrenberg",
                        "latitude": "33.60419000",
                        "longitude": "-114.52523000"
                    },
                    {
                        "id": 115927,
                        "name": "El Mirage",
                        "latitude": "33.61309000",
                        "longitude": "-112.32460000"
                    },
                    {
                        "id": 116065,
                        "name": "Eloy",
                        "latitude": "32.75590000",
                        "longitude": "-111.55484000"
                    },
                    {
                        "id": 116116,
                        "name": "Encanto",
                        "latitude": "33.47937000",
                        "longitude": "-112.07823000"
                    },
                    {
                        "id": 116523,
                        "name": "First Mesa",
                        "latitude": "35.83667000",
                        "longitude": "-110.38152000"
                    },
                    {
                        "id": 116546,
                        "name": "Flagstaff",
                        "latitude": "35.19807000",
                        "longitude": "-111.65127000"
                    },
                    {
                        "id": 116583,
                        "name": "Florence",
                        "latitude": "33.03145000",
                        "longitude": "-111.38734000"
                    },
                    {
                        "id": 116603,
                        "name": "Flowing Wells",
                        "latitude": "32.29396000",
                        "longitude": "-111.00982000"
                    },
                    {
                        "id": 116704,
                        "name": "Fort Defiance",
                        "latitude": "35.74446000",
                        "longitude": "-109.07648000"
                    },
                    {
                        "id": 116768,
                        "name": "Fortuna Foothills",
                        "latitude": "32.65783000",
                        "longitude": "-114.41189000"
                    },
                    {
                        "id": 116782,
                        "name": "Fountain Hills",
                        "latitude": "33.61171000",
                        "longitude": "-111.71736000"
                    },
                    {
                        "id": 116898,
                        "name": "Fredonia",
                        "latitude": "36.94554000",
                        "longitude": "-112.52659000"
                    },
                    {
                        "id": 117048,
                        "name": "Ganado",
                        "latitude": "35.71140000",
                        "longitude": "-109.54205000"
                    },
                    {
                        "id": 117200,
                        "name": "Gila Bend",
                        "latitude": "32.94782000",
                        "longitude": "-112.71683000"
                    },
                    {
                        "id": 117201,
                        "name": "Gila County",
                        "latitude": "33.79975000",
                        "longitude": "-110.81174000"
                    },
                    {
                        "id": 117204,
                        "name": "Gilbert",
                        "latitude": "33.35283000",
                        "longitude": "-111.78903000"
                    },
                    {
                        "id": 117285,
                        "name": "Glendale",
                        "latitude": "33.53865000",
                        "longitude": "-112.18599000"
                    },
                    {
                        "id": 117321,
                        "name": "Globe",
                        "latitude": "33.39422000",
                        "longitude": "-110.78650000"
                    },
                    {
                        "id": 117341,
                        "name": "Gold Camp",
                        "latitude": "33.29367000",
                        "longitude": "-111.30429000"
                    },
                    {
                        "id": 117342,
                        "name": "Gold Canyon",
                        "latitude": "33.37145000",
                        "longitude": "-111.43691000"
                    },
                    {
                        "id": 117353,
                        "name": "Golden Shores",
                        "latitude": "34.78188000",
                        "longitude": "-114.47775000"
                    },
                    {
                        "id": 117356,
                        "name": "Golden Valley",
                        "latitude": "35.22333000",
                        "longitude": "-114.22301000"
                    },
                    {
                        "id": 117393,
                        "name": "Goodyear",
                        "latitude": "33.43532000",
                        "longitude": "-112.35821000"
                    },
                    {
                        "id": 117439,
                        "name": "Graham County",
                        "latitude": "32.93272000",
                        "longitude": "-109.88744000"
                    },
                    {
                        "id": 117452,
                        "name": "Grand Canyon",
                        "latitude": "36.05443000",
                        "longitude": "-112.13934000"
                    },
                    {
                        "id": 117453,
                        "name": "Grand Canyon Village",
                        "latitude": "36.04637000",
                        "longitude": "-112.15406000"
                    },
                    {
                        "id": 117610,
                        "name": "Green Valley",
                        "latitude": "31.85425000",
                        "longitude": "-110.99370000"
                    },
                    {
                        "id": 117659,
                        "name": "Greenlee County",
                        "latitude": "33.21536000",
                        "longitude": "-109.24010000"
                    },
                    {
                        "id": 117776,
                        "name": "Guadalupe",
                        "latitude": "33.37088000",
                        "longitude": "-111.96292000"
                    },
                    {
                        "id": 118231,
                        "name": "Heber-Overgaard",
                        "latitude": "34.41414000",
                        "longitude": "-110.56956000"
                    },
                    {
                        "id": 118519,
                        "name": "Holbrook",
                        "latitude": "34.90225000",
                        "longitude": "-110.15818000"
                    },
                    {
                        "id": 118688,
                        "name": "Houck",
                        "latitude": "35.28308000",
                        "longitude": "-109.20704000"
                    },
                    {
                        "id": 118729,
                        "name": "Huachuca City",
                        "latitude": "31.62787000",
                        "longitude": "-110.33397000"
                    },
                    {
                        "id": 119319,
                        "name": "Joseph City",
                        "latitude": "34.95586000",
                        "longitude": "-110.33401000"
                    },
                    {
                        "id": 119349,
                        "name": "Kachina Village",
                        "latitude": "35.09696000",
                        "longitude": "-111.69266000"
                    },
                    {
                        "id": 119356,
                        "name": "Kaibito",
                        "latitude": "36.59722000",
                        "longitude": "-111.07431000"
                    },
                    {
                        "id": 119402,
                        "name": "Kayenta",
                        "latitude": "36.72778000",
                        "longitude": "-110.25458000"
                    },
                    {
                        "id": 119413,
                        "name": "Kearny",
                        "latitude": "33.05701000",
                        "longitude": "-110.91067000"
                    },
                    {
                        "id": 119595,
                        "name": "Kingman",
                        "latitude": "35.18944000",
                        "longitude": "-114.05301000"
                    },
                    {
                        "id": 119771,
                        "name": "La Paz County",
                        "latitude": "33.72926000",
                        "longitude": "-113.98134000"
                    },
                    {
                        "id": 119918,
                        "name": "Lake Havasu City",
                        "latitude": "34.48390000",
                        "longitude": "-114.32245000"
                    },
                    {
                        "id": 119946,
                        "name": "Lake Montezuma",
                        "latitude": "34.63224000",
                        "longitude": "-111.77793000"
                    },
                    {
                        "id": 120007,
                        "name": "Lake of the Woods",
                        "latitude": "34.16393000",
                        "longitude": "-109.98955000"
                    },
                    {
                        "id": 120217,
                        "name": "Laveen",
                        "latitude": "33.36282000",
                        "longitude": "-112.16932000"
                    },
                    {
                        "id": 120266,
                        "name": "LeChee",
                        "latitude": "36.86211000",
                        "longitude": "-111.44063000"
                    },
                    {
                        "id": 120565,
                        "name": "Linden",
                        "latitude": "34.28504000",
                        "longitude": "-110.15706000"
                    },
                    {
                        "id": 120609,
                        "name": "Litchfield Park",
                        "latitude": "33.49337000",
                        "longitude": "-112.35794000"
                    },
                    {
                        "id": 120874,
                        "name": "Lukachukai",
                        "latitude": "36.41695000",
                        "longitude": "-109.22871000"
                    },
                    {
                        "id": 121076,
                        "name": "Mammoth",
                        "latitude": "32.72257000",
                        "longitude": "-110.64065000"
                    },
                    {
                        "id": 121164,
                        "name": "Many Farms",
                        "latitude": "36.35278000",
                        "longitude": "-109.61789000"
                    },
                    {
                        "id": 121183,
                        "name": "Marana",
                        "latitude": "32.43674000",
                        "longitude": "-111.22538000"
                    },
                    {
                        "id": 121211,
                        "name": "Maricopa",
                        "latitude": "33.05811000",
                        "longitude": "-112.04764000"
                    },
                    {
                        "id": 121213,
                        "name": "Maricopa County",
                        "latitude": "33.34883000",
                        "longitude": "-112.49123000"
                    },
                    {
                        "id": 121362,
                        "name": "Maryvale",
                        "latitude": "33.50199000",
                        "longitude": "-112.17765000"
                    },
                    {
                        "id": 121433,
                        "name": "Mayer",
                        "latitude": "34.39781000",
                        "longitude": "-112.23627000"
                    },
                    {
                        "id": 121573,
                        "name": "Meadview",
                        "latitude": "36.00221000",
                        "longitude": "-114.06829000"
                    },
                    {
                        "id": 121720,
                        "name": "Mesa",
                        "latitude": "33.42227000",
                        "longitude": "-111.82264000"
                    },
                    {
                        "id": 121723,
                        "name": "Mescal",
                        "latitude": "31.99008000",
                        "longitude": "-110.43535000"
                    },
                    {
                        "id": 121748,
                        "name": "Miami",
                        "latitude": "33.39922000",
                        "longitude": "-110.86872000"
                    },
                    {
                        "id": 122019,
                        "name": "Mohave County",
                        "latitude": "35.70404000",
                        "longitude": "-113.75791000"
                    },
                    {
                        "id": 122020,
                        "name": "Mohave Valley",
                        "latitude": "34.93306000",
                        "longitude": "-114.58885000"
                    },
                    {
                        "id": 122230,
                        "name": "Morenci",
                        "latitude": "33.07867000",
                        "longitude": "-109.36535000"
                    },
                    {
                        "id": 122436,
                        "name": "Mountainaire",
                        "latitude": "35.08529000",
                        "longitude": "-111.66599000"
                    },
                    {
                        "id": 122531,
                        "name": "Naco",
                        "latitude": "31.33538000",
                        "longitude": "-109.94813000"
                    },
                    {
                        "id": 122598,
                        "name": "Navajo County",
                        "latitude": "35.39963000",
                        "longitude": "-110.32140000"
                    },
                    {
                        "id": 122736,
                        "name": "New Kingman-Butler",
                        "latitude": "35.26504000",
                        "longitude": "-114.03226000"
                    },
                    {
                        "id": 122771,
                        "name": "New River",
                        "latitude": "33.91587000",
                        "longitude": "-112.13599000"
                    },
                    {
                        "id": 122927,
                        "name": "Nogales",
                        "latitude": "31.34038000",
                        "longitude": "-110.93425000"
                    },
                    {
                        "id": 123027,
                        "name": "North Fork",
                        "latitude": "34.00167000",
                        "longitude": "-109.96355000"
                    },
                    {
                        "id": 123502,
                        "name": "Oracle",
                        "latitude": "32.61091000",
                        "longitude": "-110.77093000"
                    },
                    {
                        "id": 123571,
                        "name": "Oro Valley",
                        "latitude": "32.39091000",
                        "longitude": "-110.96649000"
                    },
                    {
                        "id": 123717,
                        "name": "Page",
                        "latitude": "36.91472000",
                        "longitude": "-111.45583000"
                    },
                    {
                        "id": 123822,
                        "name": "Paradise Valley",
                        "latitude": "33.53115000",
                        "longitude": "-111.94265000"
                    },
                    {
                        "id": 123861,
                        "name": "Parker",
                        "latitude": "34.15002000",
                        "longitude": "-114.28912000"
                    },
                    {
                        "id": 123873,
                        "name": "Parks",
                        "latitude": "35.26057000",
                        "longitude": "-111.94877000"
                    },
                    {
                        "id": 123921,
                        "name": "Paulden",
                        "latitude": "34.88558000",
                        "longitude": "-112.46823000"
                    },
                    {
                        "id": 123949,
                        "name": "Payson",
                        "latitude": "34.23087000",
                        "longitude": "-111.32514000"
                    },
                    {
                        "id": 123958,
                        "name": "Peach Springs",
                        "latitude": "35.52916000",
                        "longitude": "-113.42549000"
                    },
                    {
                        "id": 124047,
                        "name": "Peoria",
                        "latitude": "33.58060000",
                        "longitude": "-112.23738000"
                    },
                    {
                        "id": 124060,
                        "name": "Peridot",
                        "latitude": "33.31034000",
                        "longitude": "-110.45538000"
                    },
                    {
                        "id": 124148,
                        "name": "Phoenix",
                        "latitude": "33.44838000",
                        "longitude": "-112.07404000"
                    },
                    {
                        "id": 124163,
                        "name": "Picture Rocks",
                        "latitude": "32.34591000",
                        "longitude": "-111.24621000"
                    },
                    {
                        "id": 124203,
                        "name": "Pima",
                        "latitude": "32.89656000",
                        "longitude": "-109.82835000"
                    },
                    {
                        "id": 124204,
                        "name": "Pima County",
                        "latitude": "32.09738000",
                        "longitude": "-111.78995000"
                    },
                    {
                        "id": 124206,
                        "name": "Pinal County",
                        "latitude": "32.90431000",
                        "longitude": "-111.34471000"
                    },
                    {
                        "id": 124212,
                        "name": "Pine",
                        "latitude": "34.38447000",
                        "longitude": "-111.45514000"
                    },
                    {
                        "id": 124257,
                        "name": "Pinetop-Lakeside",
                        "latitude": "34.14254000",
                        "longitude": "-109.96038000"
                    },
                    {
                        "id": 124279,
                        "name": "Pirtleville",
                        "latitude": "31.35716000",
                        "longitude": "-109.56352000"
                    },
                    {
                        "id": 124643,
                        "name": "Prescott",
                        "latitude": "34.54002000",
                        "longitude": "-112.46850000"
                    },
                    {
                        "id": 124645,
                        "name": "Prescott Valley",
                        "latitude": "34.61002000",
                        "longitude": "-112.31572000"
                    },
                    {
                        "id": 124783,
                        "name": "Quartzsite",
                        "latitude": "33.66391000",
                        "longitude": "-114.22995000"
                    },
                    {
                        "id": 124788,
                        "name": "Queen Creek",
                        "latitude": "33.24866000",
                        "longitude": "-111.63430000"
                    },
                    {
                        "id": 125159,
                        "name": "Rio Rico",
                        "latitude": "31.47148000",
                        "longitude": "-110.97648000"
                    },
                    {
                        "id": 125160,
                        "name": "Rio Verde",
                        "latitude": "33.72254000",
                        "longitude": "-111.67569000"
                    },
                    {
                        "id": 125573,
                        "name": "Sacaton",
                        "latitude": "33.07672000",
                        "longitude": "-111.73930000"
                    },
                    {
                        "id": 125580,
                        "name": "Saddle Brooke",
                        "latitude": "32.53472000",
                        "longitude": "-110.87361000"
                    },
                    {
                        "id": 125583,
                        "name": "Safford",
                        "latitude": "32.83395000",
                        "longitude": "-109.70758000"
                    },
                    {
                        "id": 125593,
                        "name": "Sahuarita",
                        "latitude": "31.95758000",
                        "longitude": "-110.95565000"
                    },
                    {
                        "id": 125630,
                        "name": "Saint David",
                        "latitude": "31.90425000",
                        "longitude": "-110.21424000"
                    },
                    {
                        "id": 125666,
                        "name": "Saint Johns",
                        "latitude": "34.50587000",
                        "longitude": "-109.36093000"
                    },
                    {
                        "id": 125699,
                        "name": "Saint Michaels",
                        "latitude": "35.64474000",
                        "longitude": "-109.09565000"
                    },
                    {
                        "id": 125766,
                        "name": "Salome",
                        "latitude": "33.78114000",
                        "longitude": "-113.61465000"
                    },
                    {
                        "id": 125797,
                        "name": "San Carlos",
                        "latitude": "33.34562000",
                        "longitude": "-110.45504000"
                    },
                    {
                        "id": 125827,
                        "name": "San Luis",
                        "latitude": "32.48700000",
                        "longitude": "-114.78218000"
                    },
                    {
                        "id": 125831,
                        "name": "San Manuel",
                        "latitude": "32.59979000",
                        "longitude": "-110.63093000"
                    },
                    {
                        "id": 125850,
                        "name": "San Tan Valley",
                        "latitude": "33.19110000",
                        "longitude": "-111.52800000"
                    },
                    {
                        "id": 125911,
                        "name": "Santa Cruz County",
                        "latitude": "31.52600000",
                        "longitude": "-110.84657000"
                    },
                    {
                        "id": 125999,
                        "name": "Scenic",
                        "latitude": "36.79359000",
                        "longitude": "-114.01275000"
                    },
                    {
                        "id": 126063,
                        "name": "Scottsdale",
                        "latitude": "33.50921000",
                        "longitude": "-111.89903000"
                    },
                    {
                        "id": 126121,
                        "name": "Sedona",
                        "latitude": "34.86974000",
                        "longitude": "-111.76099000"
                    },
                    {
                        "id": 126137,
                        "name": "Sells",
                        "latitude": "31.91202000",
                        "longitude": "-111.88123000"
                    },
                    {
                        "id": 126381,
                        "name": "Show Low",
                        "latitude": "34.25421000",
                        "longitude": "-110.02983000"
                    },
                    {
                        "id": 126406,
                        "name": "Sierra Vista",
                        "latitude": "31.55454000",
                        "longitude": "-110.30369000"
                    },
                    {
                        "id": 126407,
                        "name": "Sierra Vista Southeast",
                        "latitude": "31.45385000",
                        "longitude": "-110.21637000"
                    },
                    {
                        "id": 126472,
                        "name": "Six Shooter Canyon",
                        "latitude": "33.36678000",
                        "longitude": "-110.77460000"
                    },
                    {
                        "id": 126547,
                        "name": "Snowflake",
                        "latitude": "34.51337000",
                        "longitude": "-110.07845000"
                    },
                    {
                        "id": 126591,
                        "name": "Somerton",
                        "latitude": "32.59644000",
                        "longitude": "-114.70968000"
                    },
                    {
                        "id": 126737,
                        "name": "South Tucson",
                        "latitude": "32.19952000",
                        "longitude": "-110.96842000"
                    },
                    {
                        "id": 126878,
                        "name": "Spring Valley",
                        "latitude": "34.34503000",
                        "longitude": "-112.15905000"
                    },
                    {
                        "id": 126888,
                        "name": "Springerville",
                        "latitude": "34.13355000",
                        "longitude": "-109.28834000"
                    },
                    {
                        "id": 126981,
                        "name": "Star Valley",
                        "latitude": "34.25504000",
                        "longitude": "-111.25847000"
                    },
                    {
                        "id": 127214,
                        "name": "Summit",
                        "latitude": "32.06702000",
                        "longitude": "-110.95148000"
                    },
                    {
                        "id": 127232,
                        "name": "Sun City",
                        "latitude": "33.59754000",
                        "longitude": "-112.27182000"
                    },
                    {
                        "id": 127235,
                        "name": "Sun City West",
                        "latitude": "33.66198000",
                        "longitude": "-112.34127000"
                    },
                    {
                        "id": 127236,
                        "name": "Sun Lakes",
                        "latitude": "33.21116000",
                        "longitude": "-111.87542000"
                    },
                    {
                        "id": 127240,
                        "name": "Sun Valley",
                        "latitude": "34.25420000",
                        "longitude": "-111.26125000"
                    },
                    {
                        "id": 127280,
                        "name": "Superior",
                        "latitude": "33.29395000",
                        "longitude": "-111.09623000"
                    },
                    {
                        "id": 127290,
                        "name": "Surprise",
                        "latitude": "33.63059000",
                        "longitude": "-112.33322000"
                    },
                    {
                        "id": 127346,
                        "name": "Swift Trail Junction",
                        "latitude": "32.72979000",
                        "longitude": "-109.71397000"
                    },
                    {
                        "id": 127420,
                        "name": "Tanque Verde",
                        "latitude": "32.25174000",
                        "longitude": "-110.73731000"
                    },
                    {
                        "id": 127450,
                        "name": "Taylor",
                        "latitude": "34.46504000",
                        "longitude": "-110.09123000"
                    },
                    {
                        "id": 127494,
                        "name": "Tempe",
                        "latitude": "33.41477000",
                        "longitude": "-111.90931000"
                    },
                    {
                        "id": 127495,
                        "name": "Tempe Junction",
                        "latitude": "33.41421000",
                        "longitude": "-111.94348000"
                    },
                    {
                        "id": 127550,
                        "name": "Thatcher",
                        "latitude": "32.84923000",
                        "longitude": "-109.75925000"
                    },
                    {
                        "id": 127616,
                        "name": "Three Points",
                        "latitude": "32.07675000",
                        "longitude": "-111.31371000"
                    },
                    {
                        "id": 127703,
                        "name": "Tolleson",
                        "latitude": "33.45004000",
                        "longitude": "-112.25932000"
                    },
                    {
                        "id": 127711,
                        "name": "Tombstone",
                        "latitude": "31.71287000",
                        "longitude": "-110.06758000"
                    },
                    {
                        "id": 127724,
                        "name": "Tonto Basin",
                        "latitude": "33.83171000",
                        "longitude": "-111.29457000"
                    },
                    {
                        "id": 127746,
                        "name": "Tortolita",
                        "latitude": "32.41035000",
                        "longitude": "-111.01732000"
                    },
                    {
                        "id": 127864,
                        "name": "Tsaile",
                        "latitude": "36.30330000",
                        "longitude": "-109.21566000"
                    },
                    {
                        "id": 127866,
                        "name": "Tuba City",
                        "latitude": "36.13499000",
                        "longitude": "-111.23986000"
                    },
                    {
                        "id": 127867,
                        "name": "Tubac",
                        "latitude": "31.61259000",
                        "longitude": "-111.04592000"
                    },
                    {
                        "id": 127874,
                        "name": "Tucson",
                        "latitude": "32.22174000",
                        "longitude": "-110.92648000"
                    },
                    {
                        "id": 127875,
                        "name": "Tucson Estates",
                        "latitude": "32.18758000",
                        "longitude": "-111.09093000"
                    },
                    {
                        "id": 128075,
                        "name": "Vail",
                        "latitude": "32.04786000",
                        "longitude": "-110.71203000"
                    },
                    {
                        "id": 128090,
                        "name": "Valencia West",
                        "latitude": "32.13238000",
                        "longitude": "-111.11414000"
                    },
                    {
                        "id": 128095,
                        "name": "Valle Vista",
                        "latitude": "35.41088000",
                        "longitude": "-113.86271000"
                    },
                    {
                        "id": 128179,
                        "name": "Verde Village",
                        "latitude": "34.71050000",
                        "longitude": "-112.01152000"
                    },
                    {
                        "id": 128253,
                        "name": "Village of Oak Creek (Big Park)",
                        "latitude": "34.78090000",
                        "longitude": "-111.76227000"
                    },
                    {
                        "id": 128795,
                        "name": "Wellton",
                        "latitude": "32.67283000",
                        "longitude": "-114.14688000"
                    },
                    {
                        "id": 128978,
                        "name": "West Sedona",
                        "latitude": "34.86724000",
                        "longitude": "-111.80543000"
                    },
                    {
                        "id": 129122,
                        "name": "Whetstone",
                        "latitude": "31.95731000",
                        "longitude": "-110.34202000"
                    },
                    {
                        "id": 129147,
                        "name": "White Mountain Lake",
                        "latitude": "34.34865000",
                        "longitude": "-109.99789000"
                    },
                    {
                        "id": 129179,
                        "name": "Whiteriver",
                        "latitude": "33.83699000",
                        "longitude": "-109.96427000"
                    },
                    {
                        "id": 129219,
                        "name": "Wickenburg",
                        "latitude": "33.96864000",
                        "longitude": "-112.72962000"
                    },
                    {
                        "id": 129259,
                        "name": "Willcox",
                        "latitude": "32.25285000",
                        "longitude": "-109.83201000"
                    },
                    {
                        "id": 129260,
                        "name": "Williams",
                        "latitude": "35.24946000",
                        "longitude": "-112.19100000"
                    },
                    {
                        "id": 129275,
                        "name": "Williamson",
                        "latitude": "34.69002000",
                        "longitude": "-112.54101000"
                    },
                    {
                        "id": 129312,
                        "name": "Willow Valley",
                        "latitude": "34.91195000",
                        "longitude": "-114.60663000"
                    },
                    {
                        "id": 129376,
                        "name": "Window Rock",
                        "latitude": "35.68057000",
                        "longitude": "-109.05259000"
                    },
                    {
                        "id": 129429,
                        "name": "Winslow",
                        "latitude": "35.02419000",
                        "longitude": "-110.69736000"
                    },
                    {
                        "id": 129672,
                        "name": "Yavapai County",
                        "latitude": "34.59988000",
                        "longitude": "-112.55387000"
                    },
                    {
                        "id": 129721,
                        "name": "Youngtown",
                        "latitude": "33.59393000",
                        "longitude": "-112.30294000"
                    },
                    {
                        "id": 129733,
                        "name": "Yuma",
                        "latitude": "32.72532000",
                        "longitude": "-114.62440000"
                    },
                    {
                        "id": 129735,
                        "name": "Yuma County",
                        "latitude": "32.76940000",
                        "longitude": "-113.90556000"
                    }
                ]
            },
            {
                "id": 1444,
                "name": "Arkansas",
                "iso2": "AR",
                "latitude": "35.20105000",
                "longitude": "-91.83183340",
                "type": "state",
                "cities": [
                    {
                        "id": 111145,
                        "name": "Alexander",
                        "latitude": "34.62954000",
                        "longitude": "-92.44127000"
                    },
                    {
                        "id": 111206,
                        "name": "Alma",
                        "latitude": "35.47787000",
                        "longitude": "-94.22188000"
                    },
                    {
                        "id": 111455,
                        "name": "Arkadelphia",
                        "latitude": "34.12093000",
                        "longitude": "-93.05378000"
                    },
                    {
                        "id": 111456,
                        "name": "Arkansas City",
                        "latitude": "33.60872000",
                        "longitude": "-91.20678000"
                    },
                    {
                        "id": 111458,
                        "name": "Arkansas County",
                        "latitude": "34.29081000",
                        "longitude": "-91.37491000"
                    },
                    {
                        "id": 111510,
                        "name": "Ash Flat",
                        "latitude": "36.22396000",
                        "longitude": "-91.60848000"
                    },
                    {
                        "id": 111518,
                        "name": "Ashdown",
                        "latitude": "33.67429000",
                        "longitude": "-94.13131000"
                    },
                    {
                        "id": 111545,
                        "name": "Ashley County",
                        "latitude": "33.19122000",
                        "longitude": "-91.76845000"
                    },
                    {
                        "id": 111584,
                        "name": "Atkins",
                        "latitude": "35.24647000",
                        "longitude": "-92.93656000"
                    },
                    {
                        "id": 111645,
                        "name": "Augusta",
                        "latitude": "35.28231000",
                        "longitude": "-91.36541000"
                    },
                    {
                        "id": 111666,
                        "name": "Austin",
                        "latitude": "34.99842000",
                        "longitude": "-91.98376000"
                    },
                    {
                        "id": 111751,
                        "name": "Bald Knob",
                        "latitude": "35.30981000",
                        "longitude": "-91.56791000"
                    },
                    {
                        "id": 111824,
                        "name": "Barling",
                        "latitude": "35.32565000",
                        "longitude": "-94.30160000"
                    },
                    {
                        "id": 111892,
                        "name": "Batesville",
                        "latitude": "35.76980000",
                        "longitude": "-91.64097000"
                    },
                    {
                        "id": 111917,
                        "name": "Baxter County",
                        "latitude": "36.28719000",
                        "longitude": "-92.33697000"
                    },
                    {
                        "id": 111920,
                        "name": "Bay",
                        "latitude": "35.74230000",
                        "longitude": "-90.56233000"
                    },
                    {
                        "id": 112036,
                        "name": "Beebe",
                        "latitude": "35.07064000",
                        "longitude": "-91.87959000"
                    },
                    {
                        "id": 112071,
                        "name": "Bella Vista",
                        "latitude": "36.48070000",
                        "longitude": "-94.27134000"
                    },
                    {
                        "id": 112191,
                        "name": "Benton",
                        "latitude": "34.56454000",
                        "longitude": "-92.58683000"
                    },
                    {
                        "id": 112199,
                        "name": "Benton County",
                        "latitude": "36.33872000",
                        "longitude": "-94.25619000"
                    },
                    {
                        "id": 112210,
                        "name": "Bentonville",
                        "latitude": "36.37285000",
                        "longitude": "-94.20882000"
                    },
                    {
                        "id": 112254,
                        "name": "Berryville",
                        "latitude": "36.36479000",
                        "longitude": "-93.56797000"
                    },
                    {
                        "id": 112285,
                        "name": "Bethel Heights",
                        "latitude": "36.21424000",
                        "longitude": "-94.12937000"
                    },
                    {
                        "id": 112486,
                        "name": "Blytheville",
                        "latitude": "35.92730000",
                        "longitude": "-89.91898000"
                    },
                    {
                        "id": 112549,
                        "name": "Bono",
                        "latitude": "35.90868000",
                        "longitude": "-90.80262000"
                    },
                    {
                        "id": 112555,
                        "name": "Boone County",
                        "latitude": "36.30859000",
                        "longitude": "-93.09150000"
                    },
                    {
                        "id": 112562,
                        "name": "Booneville",
                        "latitude": "35.14009000",
                        "longitude": "-93.92159000"
                    },
                    {
                        "id": 112675,
                        "name": "Bradley County",
                        "latitude": "33.46642000",
                        "longitude": "-92.16240000"
                    },
                    {
                        "id": 112799,
                        "name": "Brinkley",
                        "latitude": "34.88787000",
                        "longitude": "-91.19457000"
                    },
                    {
                        "id": 112864,
                        "name": "Brookland",
                        "latitude": "35.90007000",
                        "longitude": "-90.58205000"
                    },
                    {
                        "id": 112963,
                        "name": "Bryant",
                        "latitude": "34.59593000",
                        "longitude": "-92.48905000"
                    },
                    {
                        "id": 113028,
                        "name": "Bull Shoals",
                        "latitude": "36.38396000",
                        "longitude": "-92.58155000"
                    },
                    {
                        "id": 113154,
                        "name": "Cabot",
                        "latitude": "34.97453000",
                        "longitude": "-92.01653000"
                    },
                    {
                        "id": 113201,
                        "name": "Calhoun County",
                        "latitude": "33.55803000",
                        "longitude": "-92.50304000"
                    },
                    {
                        "id": 113212,
                        "name": "Calico Rock",
                        "latitude": "36.11951000",
                        "longitude": "-92.13599000"
                    },
                    {
                        "id": 113260,
                        "name": "Camden",
                        "latitude": "33.58456000",
                        "longitude": "-92.83433000"
                    },
                    {
                        "id": 113380,
                        "name": "Caraway",
                        "latitude": "35.75813000",
                        "longitude": "-90.32232000"
                    },
                    {
                        "id": 113401,
                        "name": "Carlisle",
                        "latitude": "34.78315000",
                        "longitude": "-91.74652000"
                    },
                    {
                        "id": 113450,
                        "name": "Carroll County",
                        "latitude": "36.34102000",
                        "longitude": "-93.53818000"
                    },
                    {
                        "id": 113583,
                        "name": "Cave City",
                        "latitude": "35.94174000",
                        "longitude": "-91.54847000"
                    },
                    {
                        "id": 113589,
                        "name": "Cave Springs",
                        "latitude": "36.26341000",
                        "longitude": "-94.23187000"
                    },
                    {
                        "id": 113628,
                        "name": "Cedarville",
                        "latitude": "35.56981000",
                        "longitude": "-94.36688000"
                    },
                    {
                        "id": 113651,
                        "name": "Centerton",
                        "latitude": "36.35980000",
                        "longitude": "-94.28521000"
                    },
                    {
                        "id": 113761,
                        "name": "Charleston",
                        "latitude": "35.29704000",
                        "longitude": "-94.03632000"
                    },
                    {
                        "id": 113857,
                        "name": "Cherokee Village",
                        "latitude": "36.29784000",
                        "longitude": "-91.51597000"
                    },
                    {
                        "id": 113947,
                        "name": "Chicot County",
                        "latitude": "33.26725000",
                        "longitude": "-91.29397000"
                    },
                    {
                        "id": 114110,
                        "name": "Clarendon",
                        "latitude": "34.69315000",
                        "longitude": "-91.31374000"
                    },
                    {
                        "id": 114121,
                        "name": "Clark County",
                        "latitude": "34.05096000",
                        "longitude": "-93.17637000"
                    },
                    {
                        "id": 114152,
                        "name": "Clarksville",
                        "latitude": "35.47147000",
                        "longitude": "-93.46657000"
                    },
                    {
                        "id": 114174,
                        "name": "Clay County",
                        "latitude": "36.36839000",
                        "longitude": "-90.41738000"
                    },
                    {
                        "id": 114231,
                        "name": "Cleburne County",
                        "latitude": "35.53811000",
                        "longitude": "-92.02674000"
                    },
                    {
                        "id": 114248,
                        "name": "Cleveland County",
                        "latitude": "33.89836000",
                        "longitude": "-92.18514000"
                    },
                    {
                        "id": 114267,
                        "name": "Clinton",
                        "latitude": "35.59147000",
                        "longitude": "-92.46044000"
                    },
                    {
                        "id": 114331,
                        "name": "Coal Hill",
                        "latitude": "35.43731000",
                        "longitude": "-93.67297000"
                    },
                    {
                        "id": 114477,
                        "name": "Columbia County",
                        "latitude": "33.21429000",
                        "longitude": "-93.22731000"
                    },
                    {
                        "id": 114581,
                        "name": "Conway",
                        "latitude": "35.08870000",
                        "longitude": "-92.44210000"
                    },
                    {
                        "id": 114587,
                        "name": "Conway County",
                        "latitude": "35.26221000",
                        "longitude": "-92.70132000"
                    },
                    {
                        "id": 114651,
                        "name": "Corning",
                        "latitude": "36.40784000",
                        "longitude": "-90.57983000"
                    },
                    {
                        "id": 114759,
                        "name": "Craighead County",
                        "latitude": "35.83079000",
                        "longitude": "-90.63285000"
                    },
                    {
                        "id": 114774,
                        "name": "Crawford County",
                        "latitude": "35.58883000",
                        "longitude": "-94.24312000"
                    },
                    {
                        "id": 114825,
                        "name": "Crittenden County",
                        "latitude": "35.20794000",
                        "longitude": "-90.30886000"
                    },
                    {
                        "id": 114848,
                        "name": "Cross County",
                        "latitude": "35.29573000",
                        "longitude": "-90.77123000"
                    },
                    {
                        "id": 114854,
                        "name": "Crossett",
                        "latitude": "33.12818000",
                        "longitude": "-91.96124000"
                    },
                    {
                        "id": 114995,
                        "name": "Dallas County",
                        "latitude": "33.96983000",
                        "longitude": "-92.65444000"
                    },
                    {
                        "id": 115031,
                        "name": "Danville",
                        "latitude": "35.05398000",
                        "longitude": "-93.39352000"
                    },
                    {
                        "id": 115042,
                        "name": "Dardanelle",
                        "latitude": "35.22314000",
                        "longitude": "-93.15795000"
                    },
                    {
                        "id": 115113,
                        "name": "De Queen",
                        "latitude": "34.03789000",
                        "longitude": "-94.34132000"
                    },
                    {
                        "id": 115121,
                        "name": "De Witt",
                        "latitude": "34.29288000",
                        "longitude": "-91.33790000"
                    },
                    {
                        "id": 115150,
                        "name": "Decatur",
                        "latitude": "36.33591000",
                        "longitude": "-94.46077000"
                    },
                    {
                        "id": 115264,
                        "name": "Dermott",
                        "latitude": "33.52539000",
                        "longitude": "-91.43595000"
                    },
                    {
                        "id": 115270,
                        "name": "Des Arc",
                        "latitude": "34.97704000",
                        "longitude": "-91.49513000"
                    },
                    {
                        "id": 115285,
                        "name": "Desha County",
                        "latitude": "33.83333000",
                        "longitude": "-91.25395000"
                    },
                    {
                        "id": 115318,
                        "name": "Diaz",
                        "latitude": "35.63841000",
                        "longitude": "-91.26513000"
                    },
                    {
                        "id": 115334,
                        "name": "Dierks",
                        "latitude": "34.11928000",
                        "longitude": "-94.01658000"
                    },
                    {
                        "id": 115444,
                        "name": "Dover",
                        "latitude": "35.40147000",
                        "longitude": "-93.11434000"
                    },
                    {
                        "id": 115474,
                        "name": "Drew County",
                        "latitude": "33.58945000",
                        "longitude": "-91.72002000"
                    },
                    {
                        "id": 115514,
                        "name": "Dumas",
                        "latitude": "33.88705000",
                        "longitude": "-91.49179000"
                    },
                    {
                        "id": 115616,
                        "name": "Earle",
                        "latitude": "35.27509000",
                        "longitude": "-90.46677000"
                    },
                    {
                        "id": 115656,
                        "name": "East End",
                        "latitude": "34.55065000",
                        "longitude": "-92.34099000"
                    },
                    {
                        "id": 115919,
                        "name": "El Dorado",
                        "latitude": "33.20763000",
                        "longitude": "-92.66627000"
                    },
                    {
                        "id": 116005,
                        "name": "Elkins",
                        "latitude": "36.00147000",
                        "longitude": "-94.00825000"
                    },
                    {
                        "id": 116045,
                        "name": "Elm Springs",
                        "latitude": "36.20619000",
                        "longitude": "-94.23437000"
                    },
                    {
                        "id": 116128,
                        "name": "England",
                        "latitude": "34.54426000",
                        "longitude": "-91.96903000"
                    },
                    {
                        "id": 116222,
                        "name": "Eudora",
                        "latitude": "33.10957000",
                        "longitude": "-91.26206000"
                    },
                    {
                        "id": 116240,
                        "name": "Eureka Springs",
                        "latitude": "36.40118000",
                        "longitude": "-93.73797000"
                    },
                    {
                        "id": 116318,
                        "name": "Fairfield Bay",
                        "latitude": "35.59424000",
                        "longitude": "-92.27793000"
                    },
                    {
                        "id": 116412,
                        "name": "Farmington",
                        "latitude": "36.04202000",
                        "longitude": "-94.24715000"
                    },
                    {
                        "id": 116434,
                        "name": "Faulkner County",
                        "latitude": "35.14698000",
                        "longitude": "-92.33204000"
                    },
                    {
                        "id": 116454,
                        "name": "Fayetteville",
                        "latitude": "36.06258000",
                        "longitude": "-94.15743000"
                    },
                    {
                        "id": 116568,
                        "name": "Flippin",
                        "latitude": "36.27896000",
                        "longitude": "-92.59711000"
                    },
                    {
                        "id": 116642,
                        "name": "Fordyce",
                        "latitude": "33.81372000",
                        "longitude": "-92.41293000"
                    },
                    {
                        "id": 116679,
                        "name": "Forrest City",
                        "latitude": "35.00815000",
                        "longitude": "-90.78983000"
                    },
                    {
                        "id": 116750,
                        "name": "Fort Smith",
                        "latitude": "35.38592000",
                        "longitude": "-94.39855000"
                    },
                    {
                        "id": 116844,
                        "name": "Franklin County",
                        "latitude": "35.51235000",
                        "longitude": "-93.89062000"
                    },
                    {
                        "id": 116992,
                        "name": "Fulton County",
                        "latitude": "36.38167000",
                        "longitude": "-91.81824000"
                    },
                    {
                        "id": 117091,
                        "name": "Garland County",
                        "latitude": "34.57669000",
                        "longitude": "-93.15043000"
                    },
                    {
                        "id": 117112,
                        "name": "Gassville",
                        "latitude": "36.28312000",
                        "longitude": "-92.49405000"
                    },
                    {
                        "id": 117150,
                        "name": "Gentry",
                        "latitude": "36.26758000",
                        "longitude": "-94.48466000"
                    },
                    {
                        "id": 117186,
                        "name": "Gibson",
                        "latitude": "34.88426000",
                        "longitude": "-92.23570000"
                    },
                    {
                        "id": 117312,
                        "name": "Glenwood",
                        "latitude": "34.32677000",
                        "longitude": "-93.55074000"
                    },
                    {
                        "id": 117407,
                        "name": "Goshen",
                        "latitude": "36.10119000",
                        "longitude": "-93.99131000"
                    },
                    {
                        "id": 117412,
                        "name": "Gosnell",
                        "latitude": "35.95979000",
                        "longitude": "-89.97203000"
                    },
                    {
                        "id": 117508,
                        "name": "Grant County",
                        "latitude": "34.29002000",
                        "longitude": "-92.42358000"
                    },
                    {
                        "id": 117546,
                        "name": "Gravel Ridge",
                        "latitude": "34.86842000",
                        "longitude": "-92.19070000"
                    },
                    {
                        "id": 117549,
                        "name": "Gravette",
                        "latitude": "36.42202000",
                        "longitude": "-94.45355000"
                    },
                    {
                        "id": 117595,
                        "name": "Green Forest",
                        "latitude": "36.33535000",
                        "longitude": "-93.43602000"
                    },
                    {
                        "id": 117619,
                        "name": "Greenbrier",
                        "latitude": "35.23397000",
                        "longitude": "-92.38765000"
                    },
                    {
                        "id": 117632,
                        "name": "Greene County",
                        "latitude": "36.11769000",
                        "longitude": "-90.55908000"
                    },
                    {
                        "id": 117656,
                        "name": "Greenland",
                        "latitude": "35.99425000",
                        "longitude": "-94.17520000"
                    },
                    {
                        "id": 117701,
                        "name": "Greenwood",
                        "latitude": "35.21565000",
                        "longitude": "-94.25577000"
                    },
                    {
                        "id": 117808,
                        "name": "Gurdon",
                        "latitude": "33.92094000",
                        "longitude": "-93.15406000"
                    },
                    {
                        "id": 117881,
                        "name": "Hamburg",
                        "latitude": "33.22818000",
                        "longitude": "-91.79763000"
                    },
                    {
                        "id": 117926,
                        "name": "Hampton",
                        "latitude": "33.53789000",
                        "longitude": "-92.46988000"
                    },
                    {
                        "id": 118047,
                        "name": "Harrisburg",
                        "latitude": "35.56425000",
                        "longitude": "-90.71678000"
                    },
                    {
                        "id": 118054,
                        "name": "Harrison",
                        "latitude": "36.22979000",
                        "longitude": "-93.10768000"
                    },
                    {
                        "id": 118122,
                        "name": "Haskell",
                        "latitude": "34.50148000",
                        "longitude": "-92.63655000"
                    },
                    {
                        "id": 118209,
                        "name": "Hazen",
                        "latitude": "34.78093000",
                        "longitude": "-91.58097000"
                    },
                    {
                        "id": 118230,
                        "name": "Heber Springs",
                        "latitude": "35.49147000",
                        "longitude": "-92.03126000"
                    },
                    {
                        "id": 118247,
                        "name": "Helena",
                        "latitude": "34.52955000",
                        "longitude": "-90.59177000"
                    },
                    {
                        "id": 118257,
                        "name": "Helena-West Helena",
                        "latitude": "34.52910000",
                        "longitude": "-90.59000000"
                    },
                    {
                        "id": 118271,
                        "name": "Hempstead County",
                        "latitude": "33.73530000",
                        "longitude": "-93.66844000"
                    },
                    {
                        "id": 118392,
                        "name": "Highland",
                        "latitude": "36.27590000",
                        "longitude": "-91.52403000"
                    },
                    {
                        "id": 118533,
                        "name": "Holiday Island",
                        "latitude": "36.48535000",
                        "longitude": "-93.73214000"
                    },
                    {
                        "id": 118642,
                        "name": "Hope",
                        "latitude": "33.66706000",
                        "longitude": "-93.59157000"
                    },
                    {
                        "id": 118662,
                        "name": "Horatio",
                        "latitude": "33.93845000",
                        "longitude": "-94.35715000"
                    },
                    {
                        "id": 118676,
                        "name": "Horseshoe Bend",
                        "latitude": "36.22923000",
                        "longitude": "-91.76431000"
                    },
                    {
                        "id": 118681,
                        "name": "Hot Spring County",
                        "latitude": "34.31763000",
                        "longitude": "-92.94601000"
                    },
                    {
                        "id": 118682,
                        "name": "Hot Springs",
                        "latitude": "34.50370000",
                        "longitude": "-93.05518000"
                    },
                    {
                        "id": 118685,
                        "name": "Hot Springs National Park",
                        "latitude": "34.53170000",
                        "longitude": "-93.06377000"
                    },
                    {
                        "id": 118686,
                        "name": "Hot Springs Village",
                        "latitude": "34.67204000",
                        "longitude": "-92.99879000"
                    },
                    {
                        "id": 118712,
                        "name": "Howard County",
                        "latitude": "34.08874000",
                        "longitude": "-93.99349000"
                    },
                    {
                        "id": 118726,
                        "name": "Hoxie",
                        "latitude": "36.05035000",
                        "longitude": "-90.97512000"
                    },
                    {
                        "id": 118757,
                        "name": "Hughes",
                        "latitude": "34.94926000",
                        "longitude": "-90.47149000"
                    },
                    {
                        "id": 118815,
                        "name": "Huntsville",
                        "latitude": "36.08619000",
                        "longitude": "-93.74130000"
                    },
                    {
                        "id": 118898,
                        "name": "Independence County",
                        "latitude": "35.74158000",
                        "longitude": "-91.56972000"
                    },
                    {
                        "id": 119054,
                        "name": "Izard County",
                        "latitude": "36.09487000",
                        "longitude": "-91.91342000"
                    },
                    {
                        "id": 119076,
                        "name": "Jackson County",
                        "latitude": "35.59923000",
                        "longitude": "-91.21457000"
                    },
                    {
                        "id": 119100,
                        "name": "Jacksonville",
                        "latitude": "34.86620000",
                        "longitude": "-92.11015000"
                    },
                    {
                        "id": 119139,
                        "name": "Jasper",
                        "latitude": "36.00813000",
                        "longitude": "-93.18657000"
                    },
                    {
                        "id": 119176,
                        "name": "Jefferson County",
                        "latitude": "34.26879000",
                        "longitude": "-91.93151000"
                    },
                    {
                        "id": 119254,
                        "name": "Johnson",
                        "latitude": "36.13286000",
                        "longitude": "-94.16548000"
                    },
                    {
                        "id": 119260,
                        "name": "Johnson County",
                        "latitude": "35.57005000",
                        "longitude": "-93.45991000"
                    },
                    {
                        "id": 119299,
                        "name": "Jonesboro",
                        "latitude": "35.84230000",
                        "longitude": "-90.70428000"
                    },
                    {
                        "id": 119328,
                        "name": "Judsonia",
                        "latitude": "35.27009000",
                        "longitude": "-91.63986000"
                    },
                    {
                        "id": 119479,
                        "name": "Kensett",
                        "latitude": "35.23175000",
                        "longitude": "-91.66764000"
                    },
                    {
                        "id": 119838,
                        "name": "Lafayette County",
                        "latitude": "33.24098000",
                        "longitude": "-93.60704000"
                    },
                    {
                        "id": 119878,
                        "name": "Lake City",
                        "latitude": "35.81619000",
                        "longitude": "-90.43427000"
                    },
                    {
                        "id": 119916,
                        "name": "Lake Hamilton",
                        "latitude": "34.42453000",
                        "longitude": "-93.09518000"
                    },
                    {
                        "id": 119989,
                        "name": "Lake Village",
                        "latitude": "33.32873000",
                        "longitude": "-91.28178000"
                    },
                    {
                        "id": 120058,
                        "name": "Lamar",
                        "latitude": "35.44064000",
                        "longitude": "-93.38796000"
                    },
                    {
                        "id": 120101,
                        "name": "Landmark",
                        "latitude": "34.61120000",
                        "longitude": "-92.31960000"
                    },
                    {
                        "id": 120213,
                        "name": "Lavaca",
                        "latitude": "35.33620000",
                        "longitude": "-94.17326000"
                    },
                    {
                        "id": 120230,
                        "name": "Lawrence County",
                        "latitude": "36.04125000",
                        "longitude": "-91.10708000"
                    },
                    {
                        "id": 120269,
                        "name": "Leachville",
                        "latitude": "35.93591000",
                        "longitude": "-90.25788000"
                    },
                    {
                        "id": 120307,
                        "name": "Lee County",
                        "latitude": "34.78062000",
                        "longitude": "-90.78207000"
                    },
                    {
                        "id": 120394,
                        "name": "Lepanto",
                        "latitude": "35.61119000",
                        "longitude": "-90.32982000"
                    },
                    {
                        "id": 120434,
                        "name": "Lewisville",
                        "latitude": "33.35846000",
                        "longitude": "-93.57768000"
                    },
                    {
                        "id": 120500,
                        "name": "Lincoln",
                        "latitude": "35.94953000",
                        "longitude": "-94.42355000"
                    },
                    {
                        "id": 120516,
                        "name": "Lincoln County",
                        "latitude": "33.95747000",
                        "longitude": "-91.73332000"
                    },
                    {
                        "id": 120621,
                        "name": "Little Flock",
                        "latitude": "36.38591000",
                        "longitude": "-94.13520000"
                    },
                    {
                        "id": 120624,
                        "name": "Little River County",
                        "latitude": "33.70054000",
                        "longitude": "-94.23434000"
                    },
                    {
                        "id": 120626,
                        "name": "Little Rock",
                        "latitude": "34.74648000",
                        "longitude": "-92.28959000"
                    },
                    {
                        "id": 120628,
                        "name": "Little Rock Air Force Base",
                        "latitude": "34.89149000",
                        "longitude": "-92.15955000"
                    },
                    {
                        "id": 120696,
                        "name": "Logan County",
                        "latitude": "35.21527000",
                        "longitude": "-93.71631000"
                    },
                    {
                        "id": 120720,
                        "name": "London",
                        "latitude": "35.32897000",
                        "longitude": "-93.25296000"
                    },
                    {
                        "id": 120761,
                        "name": "Lonoke",
                        "latitude": "34.78398000",
                        "longitude": "-91.89986000"
                    },
                    {
                        "id": 120762,
                        "name": "Lonoke County",
                        "latitude": "34.75427000",
                        "longitude": "-91.88867000"
                    },
                    {
                        "id": 120833,
                        "name": "Lowell",
                        "latitude": "36.25535000",
                        "longitude": "-94.13076000"
                    },
                    {
                        "id": 120902,
                        "name": "Luxora",
                        "latitude": "35.75619000",
                        "longitude": "-89.92814000"
                    },
                    {
                        "id": 121003,
                        "name": "Madison County",
                        "latitude": "36.01096000",
                        "longitude": "-93.72456000"
                    },
                    {
                        "id": 121035,
                        "name": "Magnolia",
                        "latitude": "33.26707000",
                        "longitude": "-93.23933000"
                    },
                    {
                        "id": 121071,
                        "name": "Malvern",
                        "latitude": "34.36231000",
                        "longitude": "-92.81295000"
                    },
                    {
                        "id": 121119,
                        "name": "Manila",
                        "latitude": "35.88007000",
                        "longitude": "-90.16704000"
                    },
                    {
                        "id": 121142,
                        "name": "Mansfield",
                        "latitude": "35.05954000",
                        "longitude": "-94.25271000"
                    },
                    {
                        "id": 121208,
                        "name": "Marianna",
                        "latitude": "34.77371000",
                        "longitude": "-90.75761000"
                    },
                    {
                        "id": 121232,
                        "name": "Marion",
                        "latitude": "35.21453000",
                        "longitude": "-90.19648000"
                    },
                    {
                        "id": 121248,
                        "name": "Marion County",
                        "latitude": "36.26835000",
                        "longitude": "-92.68422000"
                    },
                    {
                        "id": 121267,
                        "name": "Marked Tree",
                        "latitude": "35.53286000",
                        "longitude": "-90.42066000"
                    },
                    {
                        "id": 121289,
                        "name": "Marmaduke",
                        "latitude": "36.18701000",
                        "longitude": "-90.38316000"
                    },
                    {
                        "id": 121301,
                        "name": "Marshall",
                        "latitude": "35.90896000",
                        "longitude": "-92.63127000"
                    },
                    {
                        "id": 121352,
                        "name": "Marvell",
                        "latitude": "34.55566000",
                        "longitude": "-90.91289000"
                    },
                    {
                        "id": 121421,
                        "name": "Maumelle",
                        "latitude": "34.86676000",
                        "longitude": "-92.40432000"
                    },
                    {
                        "id": 121438,
                        "name": "Mayflower",
                        "latitude": "34.95703000",
                        "longitude": "-92.42738000"
                    },
                    {
                        "id": 121464,
                        "name": "McAlmont",
                        "latitude": "34.80842000",
                        "longitude": "-92.18181000"
                    },
                    {
                        "id": 121487,
                        "name": "McCrory",
                        "latitude": "35.25620000",
                        "longitude": "-91.20012000"
                    },
                    {
                        "id": 121501,
                        "name": "McGehee",
                        "latitude": "33.62900000",
                        "longitude": "-91.39956000"
                    },
                    {
                        "id": 121621,
                        "name": "Melbourne",
                        "latitude": "36.05951000",
                        "longitude": "-91.90848000"
                    },
                    {
                        "id": 121643,
                        "name": "Mena",
                        "latitude": "34.58622000",
                        "longitude": "-94.23966000"
                    },
                    {
                        "id": 121812,
                        "name": "Midway",
                        "latitude": "36.38534000",
                        "longitude": "-92.46183000"
                    },
                    {
                        "id": 121880,
                        "name": "Miller County",
                        "latitude": "33.31215000",
                        "longitude": "-93.89156000"
                    },
                    {
                        "id": 121939,
                        "name": "Mineral Springs",
                        "latitude": "33.87512000",
                        "longitude": "-93.91380000"
                    },
                    {
                        "id": 121989,
                        "name": "Mississippi County",
                        "latitude": "35.76390000",
                        "longitude": "-90.05417000"
                    },
                    {
                        "id": 122040,
                        "name": "Monette",
                        "latitude": "35.89063000",
                        "longitude": "-90.34427000"
                    },
                    {
                        "id": 122068,
                        "name": "Monroe County",
                        "latitude": "34.67784000",
                        "longitude": "-91.20389000"
                    },
                    {
                        "id": 122140,
                        "name": "Montgomery County",
                        "latitude": "34.53879000",
                        "longitude": "-93.65953000"
                    },
                    {
                        "id": 122158,
                        "name": "Monticello",
                        "latitude": "33.62900000",
                        "longitude": "-91.79096000"
                    },
                    {
                        "id": 122264,
                        "name": "Morrilton",
                        "latitude": "35.15092000",
                        "longitude": "-92.74405000"
                    },
                    {
                        "id": 122355,
                        "name": "Mount Ida",
                        "latitude": "34.55676000",
                        "longitude": "-93.63408000"
                    },
                    {
                        "id": 122415,
                        "name": "Mountain Home",
                        "latitude": "36.33534000",
                        "longitude": "-92.38516000"
                    },
                    {
                        "id": 122428,
                        "name": "Mountain View",
                        "latitude": "35.86841000",
                        "longitude": "-92.11765000"
                    },
                    {
                        "id": 122452,
                        "name": "Mulberry",
                        "latitude": "35.50064000",
                        "longitude": "-94.05159000"
                    },
                    {
                        "id": 122480,
                        "name": "Murfreesboro",
                        "latitude": "34.06233000",
                        "longitude": "-93.68990000"
                    },
                    {
                        "id": 122572,
                        "name": "Nashville",
                        "latitude": "33.94567000",
                        "longitude": "-93.84713000"
                    },
                    {
                        "id": 122652,
                        "name": "Nevada County",
                        "latitude": "33.66397000",
                        "longitude": "-93.30714000"
                    },
                    {
                        "id": 122800,
                        "name": "Newark",
                        "latitude": "35.70174000",
                        "longitude": "-91.44152000"
                    },
                    {
                        "id": 122839,
                        "name": "Newport",
                        "latitude": "35.60480000",
                        "longitude": "-91.28180000"
                    },
                    {
                        "id": 122868,
                        "name": "Newton County",
                        "latitude": "35.91997000",
                        "longitude": "-93.21787000"
                    },
                    {
                        "id": 123012,
                        "name": "North Crossett",
                        "latitude": "33.16568000",
                        "longitude": "-91.94152000"
                    },
                    {
                        "id": 123059,
                        "name": "North Little Rock",
                        "latitude": "34.76954000",
                        "longitude": "-92.26709000"
                    },
                    {
                        "id": 123411,
                        "name": "Ola",
                        "latitude": "35.03231000",
                        "longitude": "-93.22323000"
                    },
                    {
                        "id": 123597,
                        "name": "Osceola",
                        "latitude": "35.70508000",
                        "longitude": "-89.96953000"
                    },
                    {
                        "id": 123644,
                        "name": "Ouachita County",
                        "latitude": "33.59336000",
                        "longitude": "-92.88193000"
                    },
                    {
                        "id": 123697,
                        "name": "Ozark",
                        "latitude": "35.48703000",
                        "longitude": "-93.82770000"
                    },
                    {
                        "id": 123823,
                        "name": "Paragould",
                        "latitude": "36.05840000",
                        "longitude": "-90.49733000"
                    },
                    {
                        "id": 123829,
                        "name": "Paris",
                        "latitude": "35.29203000",
                        "longitude": "-93.72992000"
                    },
                    {
                        "id": 123870,
                        "name": "Parkin",
                        "latitude": "35.26342000",
                        "longitude": "-90.57122000"
                    },
                    {
                        "id": 123951,
                        "name": "Pea Ridge",
                        "latitude": "36.45396000",
                        "longitude": "-94.11520000"
                    },
                    {
                        "id": 124075,
                        "name": "Perry County",
                        "latitude": "34.94737000",
                        "longitude": "-92.93147000"
                    },
                    {
                        "id": 124088,
                        "name": "Perryville",
                        "latitude": "35.00481000",
                        "longitude": "-92.80267000"
                    },
                    {
                        "id": 124135,
                        "name": "Phillips County",
                        "latitude": "34.42829000",
                        "longitude": "-90.84802000"
                    },
                    {
                        "id": 124184,
                        "name": "Piggott",
                        "latitude": "36.38284000",
                        "longitude": "-90.19065000"
                    },
                    {
                        "id": 124186,
                        "name": "Pike County",
                        "latitude": "34.16350000",
                        "longitude": "-93.65634000"
                    },
                    {
                        "id": 124214,
                        "name": "Pine Bluff",
                        "latitude": "34.22843000",
                        "longitude": "-92.00320000"
                    },
                    {
                        "id": 124266,
                        "name": "Piney",
                        "latitude": "34.50314000",
                        "longitude": "-93.12602000"
                    },
                    {
                        "id": 124413,
                        "name": "Pocahontas",
                        "latitude": "36.26146000",
                        "longitude": "-90.97123000"
                    },
                    {
                        "id": 124425,
                        "name": "Poinsett County",
                        "latitude": "35.57404000",
                        "longitude": "-90.66293000"
                    },
                    {
                        "id": 124440,
                        "name": "Polk County",
                        "latitude": "34.48584000",
                        "longitude": "-94.22807000"
                    },
                    {
                        "id": 124481,
                        "name": "Pope County",
                        "latitude": "35.44763000",
                        "longitude": "-93.03416000"
                    },
                    {
                        "id": 124600,
                        "name": "Pottsville",
                        "latitude": "35.24814000",
                        "longitude": "-93.04906000"
                    },
                    {
                        "id": 124624,
                        "name": "Prairie County",
                        "latitude": "34.82979000",
                        "longitude": "-91.55277000"
                    },
                    {
                        "id": 124626,
                        "name": "Prairie Creek",
                        "latitude": "36.34202000",
                        "longitude": "-94.06187000"
                    },
                    {
                        "id": 124627,
                        "name": "Prairie Grove",
                        "latitude": "35.97591000",
                        "longitude": "-94.31771000"
                    },
                    {
                        "id": 124642,
                        "name": "Prescott",
                        "latitude": "33.80261000",
                        "longitude": "-93.38101000"
                    },
                    {
                        "id": 124737,
                        "name": "Pulaski County",
                        "latitude": "34.76993000",
                        "longitude": "-92.31180000"
                    },
                    {
                        "id": 124873,
                        "name": "Randolph County",
                        "latitude": "36.34148000",
                        "longitude": "-91.02772000"
                    },
                    {
                        "id": 124935,
                        "name": "Rector",
                        "latitude": "36.26312000",
                        "longitude": "-90.29260000"
                    },
                    {
                        "id": 124967,
                        "name": "Redfield",
                        "latitude": "34.44510000",
                        "longitude": "-92.18320000"
                    },
                    {
                        "id": 125172,
                        "name": "Rison",
                        "latitude": "33.95843000",
                        "longitude": "-92.19015000"
                    },
                    {
                        "id": 125328,
                        "name": "Rockwell",
                        "latitude": "34.46426000",
                        "longitude": "-93.13379000"
                    },
                    {
                        "id": 125348,
                        "name": "Rogers",
                        "latitude": "36.33202000",
                        "longitude": "-94.11854000"
                    },
                    {
                        "id": 125543,
                        "name": "Russellville",
                        "latitude": "35.27842000",
                        "longitude": "-93.13379000"
                    },
                    {
                        "id": 125636,
                        "name": "Saint Francis County",
                        "latitude": "35.02200000",
                        "longitude": "-90.74778000"
                    },
                    {
                        "id": 125726,
                        "name": "Salem",
                        "latitude": "34.62898000",
                        "longitude": "-92.55822000"
                    },
                    {
                        "id": 125749,
                        "name": "Saline County",
                        "latitude": "34.64662000",
                        "longitude": "-92.67657000"
                    },
                    {
                        "id": 126043,
                        "name": "Scott County",
                        "latitude": "34.86077000",
                        "longitude": "-94.06325000"
                    },
                    {
                        "id": 126092,
                        "name": "Searcy",
                        "latitude": "35.25064000",
                        "longitude": "-91.73625000"
                    },
                    {
                        "id": 126093,
                        "name": "Searcy County",
                        "latitude": "35.91090000",
                        "longitude": "-92.69949000"
                    },
                    {
                        "id": 126107,
                        "name": "Sebastian County",
                        "latitude": "35.19926000",
                        "longitude": "-94.27391000"
                    },
                    {
                        "id": 126180,
                        "name": "Sevier County",
                        "latitude": "33.99720000",
                        "longitude": "-94.24122000"
                    },
                    {
                        "id": 126221,
                        "name": "Shannon Hills",
                        "latitude": "34.62009000",
                        "longitude": "-92.39543000"
                    },
                    {
                        "id": 126233,
                        "name": "Sharp County",
                        "latitude": "36.16116000",
                        "longitude": "-91.47986000"
                    },
                    {
                        "id": 126317,
                        "name": "Sheridan",
                        "latitude": "34.30704000",
                        "longitude": "-92.40127000"
                    },
                    {
                        "id": 126340,
                        "name": "Sherwood",
                        "latitude": "34.81509000",
                        "longitude": "-92.22432000"
                    },
                    {
                        "id": 126417,
                        "name": "Siloam Springs",
                        "latitude": "36.18814000",
                        "longitude": "-94.54050000"
                    },
                    {
                        "id": 126508,
                        "name": "Smackover",
                        "latitude": "33.36485000",
                        "longitude": "-92.72488000"
                    },
                    {
                        "id": 126787,
                        "name": "Southside",
                        "latitude": "35.69841000",
                        "longitude": "-91.62347000"
                    },
                    {
                        "id": 126883,
                        "name": "Springdale",
                        "latitude": "36.18674000",
                        "longitude": "-94.12881000"
                    },
                    {
                        "id": 126946,
                        "name": "Stamps",
                        "latitude": "33.36540000",
                        "longitude": "-93.49518000"
                    },
                    {
                        "id": 126979,
                        "name": "Star City",
                        "latitude": "33.94288000",
                        "longitude": "-91.84347000"
                    },
                    {
                        "id": 127080,
                        "name": "Stone County",
                        "latitude": "35.85987000",
                        "longitude": "-92.15668000"
                    },
                    {
                        "id": 127155,
                        "name": "Stuttgart",
                        "latitude": "34.50037000",
                        "longitude": "-91.55263000"
                    },
                    {
                        "id": 127196,
                        "name": "Sulphur Springs",
                        "latitude": "34.18065000",
                        "longitude": "-92.12348000"
                    },
                    {
                        "id": 127544,
                        "name": "Texarkana",
                        "latitude": "33.44179000",
                        "longitude": "-94.03769000"
                    },
                    {
                        "id": 127723,
                        "name": "Tontitown",
                        "latitude": "36.17786000",
                        "longitude": "-94.23354000"
                    },
                    {
                        "id": 127856,
                        "name": "Trumann",
                        "latitude": "35.67369000",
                        "longitude": "-90.50733000"
                    },
                    {
                        "id": 127872,
                        "name": "Tuckerman",
                        "latitude": "35.73063000",
                        "longitude": "-91.19846000"
                    },
                    {
                        "id": 127988,
                        "name": "Union County",
                        "latitude": "33.17136000",
                        "longitude": "-92.59729000"
                    },
                    {
                        "id": 128126,
                        "name": "Van Buren",
                        "latitude": "35.43676000",
                        "longitude": "-94.34827000"
                    },
                    {
                        "id": 128129,
                        "name": "Van Buren County",
                        "latitude": "35.58065000",
                        "longitude": "-92.51570000"
                    },
                    {
                        "id": 128261,
                        "name": "Vilonia",
                        "latitude": "35.08398000",
                        "longitude": "-92.20793000"
                    },
                    {
                        "id": 128370,
                        "name": "Waldo",
                        "latitude": "33.35151000",
                        "longitude": "-93.29573000"
                    },
                    {
                        "id": 128377,
                        "name": "Waldron",
                        "latitude": "34.89843000",
                        "longitude": "-94.09076000"
                    },
                    {
                        "id": 128423,
                        "name": "Walnut Ridge",
                        "latitude": "36.06840000",
                        "longitude": "-90.95595000"
                    },
                    {
                        "id": 128457,
                        "name": "Ward",
                        "latitude": "35.03036000",
                        "longitude": "-91.95042000"
                    },
                    {
                        "id": 128476,
                        "name": "Warren",
                        "latitude": "33.61261000",
                        "longitude": "-92.06458000"
                    },
                    {
                        "id": 128553,
                        "name": "Washington County",
                        "latitude": "35.97907000",
                        "longitude": "-94.21558000"
                    },
                    {
                        "id": 128854,
                        "name": "West Crossett",
                        "latitude": "33.14096000",
                        "longitude": "-91.99402000"
                    },
                    {
                        "id": 128872,
                        "name": "West Fork",
                        "latitude": "35.92425000",
                        "longitude": "-94.18854000"
                    },
                    {
                        "id": 128893,
                        "name": "West Helena",
                        "latitude": "34.55066000",
                        "longitude": "-90.64177000"
                    },
                    {
                        "id": 128928,
                        "name": "West Memphis",
                        "latitude": "35.14648000",
                        "longitude": "-90.18454000"
                    },
                    {
                        "id": 129134,
                        "name": "White County",
                        "latitude": "35.25627000",
                        "longitude": "-91.74555000"
                    },
                    {
                        "id": 129139,
                        "name": "White Hall",
                        "latitude": "34.27399000",
                        "longitude": "-92.09098000"
                    },
                    {
                        "id": 129548,
                        "name": "Woodruff County",
                        "latitude": "35.18633000",
                        "longitude": "-91.24307000"
                    },
                    {
                        "id": 129613,
                        "name": "Wrightsville",
                        "latitude": "34.60232000",
                        "longitude": "-92.21681000"
                    },
                    {
                        "id": 129632,
                        "name": "Wynne",
                        "latitude": "35.22453000",
                        "longitude": "-90.78678000"
                    },
                    {
                        "id": 129677,
                        "name": "Yell County",
                        "latitude": "35.00260000",
                        "longitude": "-93.41125000"
                    },
                    {
                        "id": 129680,
                        "name": "Yellville",
                        "latitude": "36.22618000",
                        "longitude": "-92.68489000"
                    }
                ]
            },
            {
                "id": 1402,
                "name": "Baker Island",
                "iso2": "UM-81",
                "latitude": "0.19362660",
                "longitude": "-176.47690800",
                "type": "islands \/ groups of islands",
                "cities": []
            },
            {
                "id": 1416,
                "name": "California",
                "iso2": "CA",
                "latitude": "36.77826100",
                "longitude": "-119.41793240",
                "type": "state",
                "cities": [
                    {
                        "id": 110992,
                        "name": "Acalanes Ridge",
                        "latitude": "37.90472000",
                        "longitude": "-122.07857000"
                    },
                    {
                        "id": 111001,
                        "name": "Acton",
                        "latitude": "34.46999000",
                        "longitude": "-118.19674000"
                    },
                    {
                        "id": 111043,
                        "name": "Adelanto",
                        "latitude": "34.58277000",
                        "longitude": "-117.40922000"
                    },
                    {
                        "id": 111056,
                        "name": "Agoura",
                        "latitude": "34.14306000",
                        "longitude": "-118.73787000"
                    },
                    {
                        "id": 111057,
                        "name": "Agoura Hills",
                        "latitude": "34.13639000",
                        "longitude": "-118.77453000"
                    },
                    {
                        "id": 111058,
                        "name": "Agua Dulce",
                        "latitude": "34.49638000",
                        "longitude": "-118.32563000"
                    },
                    {
                        "id": 111061,
                        "name": "Aguanga",
                        "latitude": "33.44281000",
                        "longitude": "-116.86502000"
                    },
                    {
                        "id": 111064,
                        "name": "Ahwahnee",
                        "latitude": "37.36550000",
                        "longitude": "-119.72627000"
                    },
                    {
                        "id": 111088,
                        "name": "Alameda",
                        "latitude": "37.76521000",
                        "longitude": "-122.24164000"
                    },
                    {
                        "id": 111089,
                        "name": "Alameda County",
                        "latitude": "37.65055000",
                        "longitude": "-121.91789000"
                    },
                    {
                        "id": 111093,
                        "name": "Alamo",
                        "latitude": "37.85020000",
                        "longitude": "-122.03218000"
                    },
                    {
                        "id": 111110,
                        "name": "Albany",
                        "latitude": "37.88687000",
                        "longitude": "-122.29775000"
                    },
                    {
                        "id": 111169,
                        "name": "Alhambra",
                        "latitude": "34.09529000",
                        "longitude": "-118.12701000"
                    },
                    {
                        "id": 111175,
                        "name": "Aliso Viejo",
                        "latitude": "33.56504000",
                        "longitude": "-117.72712000"
                    },
                    {
                        "id": 111196,
                        "name": "Allendale",
                        "latitude": "38.44463000",
                        "longitude": "-121.94302000"
                    },
                    {
                        "id": 111215,
                        "name": "Alondra Park",
                        "latitude": "33.88946000",
                        "longitude": "-118.33091000"
                    },
                    {
                        "id": 111217,
                        "name": "Alpaugh",
                        "latitude": "35.88773000",
                        "longitude": "-119.48734000"
                    },
                    {
                        "id": 111223,
                        "name": "Alpine",
                        "latitude": "32.83505000",
                        "longitude": "-116.76641000"
                    },
                    {
                        "id": 111226,
                        "name": "Alpine County",
                        "latitude": "38.59725000",
                        "longitude": "-119.82065000"
                    },
                    {
                        "id": 111230,
                        "name": "Alta Sierra",
                        "latitude": "35.73126000",
                        "longitude": "-118.55390000"
                    },
                    {
                        "id": 111231,
                        "name": "Altadena",
                        "latitude": "34.18973000",
                        "longitude": "-118.13118000"
                    },
                    {
                        "id": 111251,
                        "name": "Alturas",
                        "latitude": "41.48714000",
                        "longitude": "-120.54349000"
                    },
                    {
                        "id": 111254,
                        "name": "Alum Rock",
                        "latitude": "37.36605000",
                        "longitude": "-121.82718000"
                    },
                    {
                        "id": 111261,
                        "name": "Amador County",
                        "latitude": "38.44639000",
                        "longitude": "-120.65112000"
                    },
                    {
                        "id": 111271,
                        "name": "American Canyon",
                        "latitude": "38.17492000",
                        "longitude": "-122.26080000"
                    },
                    {
                        "id": 111280,
                        "name": "Amesti",
                        "latitude": "36.96356000",
                        "longitude": "-121.77912000"
                    },
                    {
                        "id": 111299,
                        "name": "Anaheim",
                        "latitude": "33.83529000",
                        "longitude": "-117.91450000"
                    },
                    {
                        "id": 111314,
                        "name": "Anderson",
                        "latitude": "40.44821000",
                        "longitude": "-122.29778000"
                    },
                    {
                        "id": 111337,
                        "name": "Angels Camp",
                        "latitude": "38.06826000",
                        "longitude": "-120.53965000"
                    },
                    {
                        "id": 111343,
                        "name": "Angwin",
                        "latitude": "38.57574000",
                        "longitude": "-122.44998000"
                    },
                    {
                        "id": 111364,
                        "name": "Antelope",
                        "latitude": "38.70824000",
                        "longitude": "-121.32995000"
                    },
                    {
                        "id": 111373,
                        "name": "Antioch",
                        "latitude": "38.00492000",
                        "longitude": "-121.80579000"
                    },
                    {
                        "id": 111378,
                        "name": "Anza",
                        "latitude": "33.55503000",
                        "longitude": "-116.67363000"
                    },
                    {
                        "id": 111394,
                        "name": "Apple Valley",
                        "latitude": "34.50083000",
                        "longitude": "-117.18588000"
                    },
                    {
                        "id": 111403,
                        "name": "Aptos",
                        "latitude": "36.97717000",
                        "longitude": "-121.89940000"
                    },
                    {
                        "id": 111404,
                        "name": "Aptos Hills-Larkin Valley",
                        "latitude": "36.96064000",
                        "longitude": "-121.83404000"
                    },
                    {
                        "id": 111416,
                        "name": "Arbuckle",
                        "latitude": "39.01740000",
                        "longitude": "-122.05775000"
                    },
                    {
                        "id": 111425,
                        "name": "Arcadia",
                        "latitude": "34.13973000",
                        "longitude": "-118.03534000"
                    },
                    {
                        "id": 111426,
                        "name": "Arcata",
                        "latitude": "40.86652000",
                        "longitude": "-124.08284000"
                    },
                    {
                        "id": 111440,
                        "name": "Arden-Arcade",
                        "latitude": "38.60250000",
                        "longitude": "-121.37854000"
                    },
                    {
                        "id": 111477,
                        "name": "Armona",
                        "latitude": "36.31578000",
                        "longitude": "-119.70846000"
                    },
                    {
                        "id": 111488,
                        "name": "Arnold",
                        "latitude": "38.25547000",
                        "longitude": "-120.35103000"
                    },
                    {
                        "id": 111491,
                        "name": "Aromas",
                        "latitude": "36.88856000",
                        "longitude": "-121.64300000"
                    },
                    {
                        "id": 111494,
                        "name": "Arroyo Grande",
                        "latitude": "35.11859000",
                        "longitude": "-120.59073000"
                    },
                    {
                        "id": 111496,
                        "name": "Artesia",
                        "latitude": "33.86585000",
                        "longitude": "-118.08312000"
                    },
                    {
                        "id": 111505,
                        "name": "Arvin",
                        "latitude": "35.20913000",
                        "longitude": "-118.82843000"
                    },
                    {
                        "id": 111538,
                        "name": "Ashland",
                        "latitude": "37.69465000",
                        "longitude": "-122.11385000"
                    },
                    {
                        "id": 111564,
                        "name": "Atascadero",
                        "latitude": "35.48942000",
                        "longitude": "-120.67073000"
                    },
                    {
                        "id": 111582,
                        "name": "Atherton",
                        "latitude": "37.46133000",
                        "longitude": "-122.19774000"
                    },
                    {
                        "id": 111613,
                        "name": "Atwater",
                        "latitude": "37.34772000",
                        "longitude": "-120.60908000"
                    },
                    {
                        "id": 111617,
                        "name": "Auberry",
                        "latitude": "37.08078000",
                        "longitude": "-119.48541000"
                    },
                    {
                        "id": 111631,
                        "name": "Auburn",
                        "latitude": "38.89657000",
                        "longitude": "-121.07689000"
                    },
                    {
                        "id": 111635,
                        "name": "Auburn Lake Trails",
                        "latitude": "38.91434000",
                        "longitude": "-120.95244000"
                    },
                    {
                        "id": 111644,
                        "name": "August",
                        "latitude": "37.97881000",
                        "longitude": "-121.26217000"
                    },
                    {
                        "id": 111675,
                        "name": "Avalon",
                        "latitude": "33.34281000",
                        "longitude": "-118.32785000"
                    },
                    {
                        "id": 111676,
                        "name": "Avenal",
                        "latitude": "36.00412000",
                        "longitude": "-120.12903000"
                    },
                    {
                        "id": 111683,
                        "name": "Avila Beach",
                        "latitude": "35.17998000",
                        "longitude": "-120.73184000"
                    },
                    {
                        "id": 111689,
                        "name": "Avocado Heights",
                        "latitude": "34.03612000",
                        "longitude": "-117.99118000"
                    },
                    {
                        "id": 111713,
                        "name": "Azusa",
                        "latitude": "34.13362000",
                        "longitude": "-117.90756000"
                    },
                    {
                        "id": 111744,
                        "name": "Bakersfield",
                        "latitude": "35.37329000",
                        "longitude": "-119.01871000"
                    },
                    {
                        "id": 111763,
                        "name": "Baldwin Park",
                        "latitude": "34.08529000",
                        "longitude": "-117.96090000"
                    },
                    {
                        "id": 111803,
                        "name": "Banning",
                        "latitude": "33.92557000",
                        "longitude": "-116.87641000"
                    },
                    {
                        "id": 111857,
                        "name": "Barstow",
                        "latitude": "34.89859000",
                        "longitude": "-117.02282000"
                    },
                    {
                        "id": 111858,
                        "name": "Barstow Heights",
                        "latitude": "34.86971000",
                        "longitude": "-117.05615000"
                    },
                    {
                        "id": 111932,
                        "name": "Bay Point",
                        "latitude": "38.02909000",
                        "longitude": "-121.96163000"
                    },
                    {
                        "id": 111957,
                        "name": "Bayside",
                        "latitude": "40.84235000",
                        "longitude": "-124.06367000"
                    },
                    {
                        "id": 111959,
                        "name": "Bayview",
                        "latitude": "40.77263000",
                        "longitude": "-124.18395000"
                    },
                    {
                        "id": 111971,
                        "name": "Beale Air Force Base",
                        "latitude": "39.10917000",
                        "longitude": "-121.35444000"
                    },
                    {
                        "id": 111979,
                        "name": "Bear Valley Springs",
                        "latitude": "35.15913000",
                        "longitude": "-118.62842000"
                    },
                    {
                        "id": 111990,
                        "name": "Beaumont",
                        "latitude": "33.92946000",
                        "longitude": "-116.97725000"
                    },
                    {
                        "id": 112066,
                        "name": "Bell",
                        "latitude": "33.97751000",
                        "longitude": "-118.18702000"
                    },
                    {
                        "id": 112070,
                        "name": "Bell Gardens",
                        "latitude": "33.96529000",
                        "longitude": "-118.15146000"
                    },
                    {
                        "id": 112072,
                        "name": "Bella Vista",
                        "latitude": "40.64071000",
                        "longitude": "-122.23250000"
                    },
                    {
                        "id": 112118,
                        "name": "Bellflower",
                        "latitude": "33.88168000",
                        "longitude": "-118.11701000"
                    },
                    {
                        "id": 112142,
                        "name": "Belmont",
                        "latitude": "37.52021000",
                        "longitude": "-122.27580000"
                    },
                    {
                        "id": 112153,
                        "name": "Belvedere",
                        "latitude": "37.87270000",
                        "longitude": "-122.46442000"
                    },
                    {
                        "id": 112163,
                        "name": "Ben Lomond",
                        "latitude": "37.08911000",
                        "longitude": "-122.08635000"
                    },
                    {
                        "id": 112168,
                        "name": "Benicia",
                        "latitude": "38.04937000",
                        "longitude": "-122.15858000"
                    },
                    {
                        "id": 112223,
                        "name": "Berkeley",
                        "latitude": "37.87159000",
                        "longitude": "-122.27275000"
                    },
                    {
                        "id": 112240,
                        "name": "Bermuda Dunes",
                        "latitude": "33.74280000",
                        "longitude": "-116.28918000"
                    },
                    {
                        "id": 112253,
                        "name": "Berry Creek",
                        "latitude": "39.64516000",
                        "longitude": "-121.40330000"
                    },
                    {
                        "id": 112260,
                        "name": "Bertsch-Oceanview",
                        "latitude": "41.75250000",
                        "longitude": "-124.15875000"
                    },
                    {
                        "id": 112286,
                        "name": "Bethel Island",
                        "latitude": "38.01492000",
                        "longitude": "-121.64051000"
                    },
                    {
                        "id": 112306,
                        "name": "Beverly Hills",
                        "latitude": "34.07362000",
                        "longitude": "-118.40036000"
                    },
                    {
                        "id": 112315,
                        "name": "Big Bear City",
                        "latitude": "34.26112000",
                        "longitude": "-116.84503000"
                    },
                    {
                        "id": 112316,
                        "name": "Big Bear Lake",
                        "latitude": "34.24390000",
                        "longitude": "-116.91142000"
                    },
                    {
                        "id": 112328,
                        "name": "Big Pine",
                        "latitude": "37.16493000",
                        "longitude": "-118.28955000"
                    },
                    {
                        "id": 112331,
                        "name": "Big River",
                        "latitude": "34.14002000",
                        "longitude": "-114.36134000"
                    },
                    {
                        "id": 112340,
                        "name": "Biggs",
                        "latitude": "39.41239000",
                        "longitude": "-121.71275000"
                    },
                    {
                        "id": 112352,
                        "name": "Biola",
                        "latitude": "36.80217000",
                        "longitude": "-120.01627000"
                    },
                    {
                        "id": 112364,
                        "name": "Bishop",
                        "latitude": "37.36354000",
                        "longitude": "-118.39511000"
                    },
                    {
                        "id": 112381,
                        "name": "Black Point-Green Point",
                        "latitude": "38.11547000",
                        "longitude": "-122.51318000"
                    },
                    {
                        "id": 112387,
                        "name": "Blackhawk",
                        "latitude": "37.82076000",
                        "longitude": "-121.90774000"
                    },
                    {
                        "id": 112453,
                        "name": "Bloomington",
                        "latitude": "34.07029000",
                        "longitude": "-117.39588000"
                    },
                    {
                        "id": 112470,
                        "name": "Blue Lake",
                        "latitude": "40.88291000",
                        "longitude": "-123.98395000"
                    },
                    {
                        "id": 112485,
                        "name": "Blythe",
                        "latitude": "33.61030000",
                        "longitude": "-114.59635000"
                    },
                    {
                        "id": 112495,
                        "name": "Bodega Bay",
                        "latitude": "38.33325000",
                        "longitude": "-123.04806000"
                    },
                    {
                        "id": 112496,
                        "name": "Bodfish",
                        "latitude": "35.58801000",
                        "longitude": "-118.49203000"
                    },
                    {
                        "id": 112514,
                        "name": "Bolinas",
                        "latitude": "37.90937000",
                        "longitude": "-122.68637000"
                    },
                    {
                        "id": 112529,
                        "name": "Bonadelle Ranchos-Madera Ranchos",
                        "latitude": "36.98467000",
                        "longitude": "-119.87463000"
                    },
                    {
                        "id": 112537,
                        "name": "Bonita",
                        "latitude": "32.65783000",
                        "longitude": "-117.03003000"
                    },
                    {
                        "id": 112548,
                        "name": "Bonny Doon",
                        "latitude": "37.04162000",
                        "longitude": "-122.15052000"
                    },
                    {
                        "id": 112550,
                        "name": "Bonsall",
                        "latitude": "33.28892000",
                        "longitude": "-117.22559000"
                    },
                    {
                        "id": 112571,
                        "name": "Boonville",
                        "latitude": "39.00907000",
                        "longitude": "-123.36612000"
                    },
                    {
                        "id": 112578,
                        "name": "Boron",
                        "latitude": "34.99942000",
                        "longitude": "-117.64978000"
                    },
                    {
                        "id": 112579,
                        "name": "Boronda",
                        "latitude": "36.69885000",
                        "longitude": "-121.67495000"
                    },
                    {
                        "id": 112581,
                        "name": "Borrego Springs",
                        "latitude": "33.25587000",
                        "longitude": "-116.37501000"
                    },
                    {
                        "id": 112591,
                        "name": "Bostonia",
                        "latitude": "32.80755000",
                        "longitude": "-116.93642000"
                    },
                    {
                        "id": 112604,
                        "name": "Boulder Creek",
                        "latitude": "37.12606000",
                        "longitude": "-122.12219000"
                    },
                    {
                        "id": 112646,
                        "name": "Boyes Hot Springs",
                        "latitude": "38.31380000",
                        "longitude": "-122.48193000"
                    },
                    {
                        "id": 112649,
                        "name": "Boyle Heights",
                        "latitude": "34.03390000",
                        "longitude": "-118.20535000"
                    },
                    {
                        "id": 112658,
                        "name": "Bradbury",
                        "latitude": "34.14695000",
                        "longitude": "-117.97090000"
                    },
                    {
                        "id": 112700,
                        "name": "Brawley",
                        "latitude": "32.97866000",
                        "longitude": "-115.53027000"
                    },
                    {
                        "id": 112707,
                        "name": "Brea",
                        "latitude": "33.91668000",
                        "longitude": "-117.90006000"
                    },
                    {
                        "id": 112733,
                        "name": "Brentwood",
                        "latitude": "37.93187000",
                        "longitude": "-121.69579000"
                    },
                    {
                        "id": 112736,
                        "name": "Bret Harte",
                        "latitude": "37.60207000",
                        "longitude": "-121.00519000"
                    },
                    {
                        "id": 112765,
                        "name": "Bridgeport",
                        "latitude": "38.25575000",
                        "longitude": "-119.23127000"
                    },
                    {
                        "id": 112800,
                        "name": "Brisbane",
                        "latitude": "37.68077000",
                        "longitude": "-122.39997000"
                    },
                    {
                        "id": 112825,
                        "name": "Broadmoor",
                        "latitude": "37.68660000",
                        "longitude": "-122.48275000"
                    },
                    {
                        "id": 112851,
                        "name": "Brookdale",
                        "latitude": "37.10634000",
                        "longitude": "-122.10608000"
                    },
                    {
                        "id": 112893,
                        "name": "Brooktrails",
                        "latitude": "39.44377000",
                        "longitude": "-123.38529000"
                    },
                    {
                        "id": 112983,
                        "name": "Buckhorn",
                        "latitude": "38.45216000",
                        "longitude": "-120.52854000"
                    },
                    {
                        "id": 112997,
                        "name": "Buellton",
                        "latitude": "34.61360000",
                        "longitude": "-120.19265000"
                    },
                    {
                        "id": 112999,
                        "name": "Buena Park",
                        "latitude": "33.86751000",
                        "longitude": "-117.99812000"
                    },
                    {
                        "id": 113003,
                        "name": "Buena Vista",
                        "latitude": "37.32133000",
                        "longitude": "-121.91662000"
                    },
                    {
                        "id": 113047,
                        "name": "Burbank",
                        "latitude": "34.18084000",
                        "longitude": "-118.30897000"
                    },
                    {
                        "id": 113065,
                        "name": "Burlingame",
                        "latitude": "37.58410000",
                        "longitude": "-122.36608000"
                    },
                    {
                        "id": 113082,
                        "name": "Burney",
                        "latitude": "40.88238000",
                        "longitude": "-121.66082000"
                    },
                    {
                        "id": 113125,
                        "name": "Butte County",
                        "latitude": "39.66693000",
                        "longitude": "-121.60067000"
                    },
                    {
                        "id": 113129,
                        "name": "Buttonwillow",
                        "latitude": "35.40052000",
                        "longitude": "-119.46956000"
                    },
                    {
                        "id": 113146,
                        "name": "Byron",
                        "latitude": "37.86715000",
                        "longitude": "-121.63801000"
                    },
                    {
                        "id": 113148,
                        "name": "Bystrom",
                        "latitude": "37.62076000",
                        "longitude": "-120.98577000"
                    },
                    {
                        "id": 113150,
                        "name": "Cabazon",
                        "latitude": "33.91752000",
                        "longitude": "-116.78724000"
                    },
                    {
                        "id": 113173,
                        "name": "Calabasas",
                        "latitude": "34.15778000",
                        "longitude": "-118.63842000"
                    },
                    {
                        "id": 113176,
                        "name": "Calaveras County",
                        "latitude": "38.20461000",
                        "longitude": "-120.55413000"
                    },
                    {
                        "id": 113196,
                        "name": "Calexico",
                        "latitude": "32.67895000",
                        "longitude": "-115.49888000"
                    },
                    {
                        "id": 113218,
                        "name": "California City",
                        "latitude": "35.12580000",
                        "longitude": "-117.98590000"
                    },
                    {
                        "id": 113219,
                        "name": "Calimesa",
                        "latitude": "34.00390000",
                        "longitude": "-117.06198000"
                    },
                    {
                        "id": 113220,
                        "name": "Calipatria",
                        "latitude": "33.12560000",
                        "longitude": "-115.51415000"
                    },
                    {
                        "id": 113221,
                        "name": "Calistoga",
                        "latitude": "38.57880000",
                        "longitude": "-122.57971000"
                    },
                    {
                        "id": 113226,
                        "name": "Callender",
                        "latitude": "35.05303000",
                        "longitude": "-120.59628000"
                    },
                    {
                        "id": 113242,
                        "name": "Camarillo",
                        "latitude": "34.21639000",
                        "longitude": "-119.03760000"
                    },
                    {
                        "id": 113246,
                        "name": "Cambria",
                        "latitude": "35.56414000",
                        "longitude": "-121.08075000"
                    },
                    {
                        "id": 113249,
                        "name": "Cambrian Park",
                        "latitude": "37.25689000",
                        "longitude": "-121.93079000"
                    },
                    {
                        "id": 113281,
                        "name": "Cameron Park",
                        "latitude": "38.66879000",
                        "longitude": "-120.98716000"
                    },
                    {
                        "id": 113285,
                        "name": "Camino",
                        "latitude": "38.73824000",
                        "longitude": "-120.67493000"
                    },
                    {
                        "id": 113289,
                        "name": "Camp Meeker",
                        "latitude": "38.42519000",
                        "longitude": "-122.95944000"
                    },
                    {
                        "id": 113290,
                        "name": "Camp Pendleton North",
                        "latitude": "33.31465000",
                        "longitude": "-117.31603000"
                    },
                    {
                        "id": 113291,
                        "name": "Camp Pendleton South",
                        "latitude": "33.22844000",
                        "longitude": "-117.37929000"
                    },
                    {
                        "id": 113298,
                        "name": "Campbell",
                        "latitude": "37.28717000",
                        "longitude": "-121.94996000"
                    },
                    {
                        "id": 113308,
                        "name": "Campo",
                        "latitude": "32.60645000",
                        "longitude": "-116.46891000"
                    },
                    {
                        "id": 113335,
                        "name": "Canoga Park",
                        "latitude": "34.20112000",
                        "longitude": "-118.59814000"
                    },
                    {
                        "id": 113359,
                        "name": "Canyon Lake",
                        "latitude": "33.68502000",
                        "longitude": "-117.27309000"
                    },
                    {
                        "id": 113376,
                        "name": "Capitola",
                        "latitude": "36.97523000",
                        "longitude": "-121.95329000"
                    },
                    {
                        "id": 113408,
                        "name": "Carlsbad",
                        "latitude": "33.15809000",
                        "longitude": "-117.35059000"
                    },
                    {
                        "id": 113420,
                        "name": "Carmel Valley Village",
                        "latitude": "36.50605000",
                        "longitude": "-121.76594000"
                    },
                    {
                        "id": 113421,
                        "name": "Carmel-by-the-Sea",
                        "latitude": "36.55524000",
                        "longitude": "-121.92329000"
                    },
                    {
                        "id": 113423,
                        "name": "Carmichael",
                        "latitude": "38.61713000",
                        "longitude": "-121.32828000"
                    },
                    {
                        "id": 113440,
                        "name": "Carpinteria",
                        "latitude": "34.39888000",
                        "longitude": "-119.51846000"
                    },
                    {
                        "id": 113474,
                        "name": "Carson",
                        "latitude": "33.83141000",
                        "longitude": "-118.28202000"
                    },
                    {
                        "id": 113498,
                        "name": "Caruthers",
                        "latitude": "36.54273000",
                        "longitude": "-119.83320000"
                    },
                    {
                        "id": 113509,
                        "name": "Casa Conejo",
                        "latitude": "34.18362000",
                        "longitude": "-118.94343000"
                    },
                    {
                        "id": 113511,
                        "name": "Casa de Oro-Mount Helix",
                        "latitude": "32.76397000",
                        "longitude": "-116.96877000"
                    },
                    {
                        "id": 113540,
                        "name": "Castaic",
                        "latitude": "34.48888000",
                        "longitude": "-118.62287000"
                    },
                    {
                        "id": 113557,
                        "name": "Castro Valley",
                        "latitude": "37.69410000",
                        "longitude": "-122.08635000"
                    },
                    {
                        "id": 113559,
                        "name": "Castroville",
                        "latitude": "36.76579000",
                        "longitude": "-121.75800000"
                    },
                    {
                        "id": 113570,
                        "name": "Cathedral City",
                        "latitude": "33.77974000",
                        "longitude": "-116.46529000"
                    },
                    {
                        "id": 113592,
                        "name": "Cayucos",
                        "latitude": "35.44275000",
                        "longitude": "-120.89213000"
                    },
                    {
                        "id": 113622,
                        "name": "Cedar Ridge",
                        "latitude": "38.06576000",
                        "longitude": "-120.27686000"
                    },
                    {
                        "id": 113683,
                        "name": "Central Valley (historical)",
                        "latitude": "40.68043000",
                        "longitude": "-122.37112000"
                    },
                    {
                        "id": 113698,
                        "name": "Century City",
                        "latitude": "34.05557000",
                        "longitude": "-118.41786000"
                    },
                    {
                        "id": 113700,
                        "name": "Ceres",
                        "latitude": "37.59493000",
                        "longitude": "-120.95771000"
                    },
                    {
                        "id": 113701,
                        "name": "Cerritos",
                        "latitude": "33.85835000",
                        "longitude": "-118.06479000"
                    },
                    {
                        "id": 113714,
                        "name": "Challenge-Brownsville",
                        "latitude": "39.46447000",
                        "longitude": "-121.26338000"
                    },
                    {
                        "id": 113734,
                        "name": "Channel Islands Beach",
                        "latitude": "34.15806000",
                        "longitude": "-119.22316000"
                    },
                    {
                        "id": 113790,
                        "name": "Charter Oak",
                        "latitude": "34.10306000",
                        "longitude": "-117.84589000"
                    },
                    {
                        "id": 113807,
                        "name": "Chatsworth",
                        "latitude": "34.25723000",
                        "longitude": "-118.60120000"
                    },
                    {
                        "id": 113865,
                        "name": "Cherry Valley",
                        "latitude": "33.97252000",
                        "longitude": "-116.97725000"
                    },
                    {
                        "id": 113867,
                        "name": "Cherryland",
                        "latitude": "37.67938000",
                        "longitude": "-122.10330000"
                    },
                    {
                        "id": 113892,
                        "name": "Chester",
                        "latitude": "40.30627000",
                        "longitude": "-121.23191000"
                    },
                    {
                        "id": 113943,
                        "name": "Chico",
                        "latitude": "39.72849000",
                        "longitude": "-121.83748000"
                    },
                    {
                        "id": 113963,
                        "name": "China Lake Acres",
                        "latitude": "35.64051000",
                        "longitude": "-117.76395000"
                    },
                    {
                        "id": 113964,
                        "name": "Chinatown",
                        "latitude": "37.79660000",
                        "longitude": "-122.40858000"
                    },
                    {
                        "id": 113968,
                        "name": "Chino",
                        "latitude": "34.01223000",
                        "longitude": "-117.68894000"
                    },
                    {
                        "id": 113969,
                        "name": "Chino Hills",
                        "latitude": "33.99380000",
                        "longitude": "-117.75888000"
                    },
                    {
                        "id": 113993,
                        "name": "Chowchilla",
                        "latitude": "37.12300000",
                        "longitude": "-120.26018000"
                    },
                    {
                        "id": 114003,
                        "name": "Chualar",
                        "latitude": "36.57052000",
                        "longitude": "-121.51855000"
                    },
                    {
                        "id": 114005,
                        "name": "Chula Vista",
                        "latitude": "32.64005000",
                        "longitude": "-117.08420000"
                    },
                    {
                        "id": 114034,
                        "name": "Citrus",
                        "latitude": "34.11501000",
                        "longitude": "-117.89173000"
                    },
                    {
                        "id": 114037,
                        "name": "Citrus Heights",
                        "latitude": "38.70712000",
                        "longitude": "-121.28106000"
                    },
                    {
                        "id": 114046,
                        "name": "City and County of San Francisco",
                        "latitude": "37.77823000",
                        "longitude": "-122.44250000"
                    },
                    {
                        "id": 153627,
                        "name": "City of Industry",
                        "latitude": "34.01583333",
                        "longitude": "-117.95083333"
                    },
                    {
                        "id": 114106,
                        "name": "Claremont",
                        "latitude": "34.09668000",
                        "longitude": "-117.71978000"
                    },
                    {
                        "id": 114169,
                        "name": "Clay",
                        "latitude": "38.33602000",
                        "longitude": "-121.15939000"
                    },
                    {
                        "id": 114203,
                        "name": "Clayton",
                        "latitude": "37.94103000",
                        "longitude": "-121.93579000"
                    },
                    {
                        "id": 114213,
                        "name": "Clear Lake Riviera",
                        "latitude": "38.95406000",
                        "longitude": "-122.72082000"
                    },
                    {
                        "id": 114219,
                        "name": "Clearlake",
                        "latitude": "38.95823000",
                        "longitude": "-122.62637000"
                    },
                    {
                        "id": 114220,
                        "name": "Clearlake Oaks",
                        "latitude": "39.02628000",
                        "longitude": "-122.67193000"
                    },
                    {
                        "id": 114311,
                        "name": "Cloverdale",
                        "latitude": "38.80546000",
                        "longitude": "-123.01722000"
                    },
                    {
                        "id": 114315,
                        "name": "Clovis",
                        "latitude": "36.82523000",
                        "longitude": "-119.70292000"
                    },
                    {
                        "id": 114324,
                        "name": "Coachella",
                        "latitude": "33.68030000",
                        "longitude": "-116.17389000"
                    },
                    {
                        "id": 114338,
                        "name": "Coalinga",
                        "latitude": "36.13968000",
                        "longitude": "-120.36015000"
                    },
                    {
                        "id": 114340,
                        "name": "Coarsegold",
                        "latitude": "37.26217000",
                        "longitude": "-119.70098000"
                    },
                    {
                        "id": 114343,
                        "name": "Cobb",
                        "latitude": "38.82213000",
                        "longitude": "-122.72305000"
                    },
                    {
                        "id": 114408,
                        "name": "Colfax",
                        "latitude": "39.10073000",
                        "longitude": "-120.95328000"
                    },
                    {
                        "id": 114425,
                        "name": "Collierville",
                        "latitude": "38.21464000",
                        "longitude": "-121.26884000"
                    },
                    {
                        "id": 114440,
                        "name": "Colma",
                        "latitude": "37.67688000",
                        "longitude": "-122.45969000"
                    },
                    {
                        "id": 114463,
                        "name": "Colton",
                        "latitude": "34.07390000",
                        "longitude": "-117.31365000"
                    },
                    {
                        "id": 114474,
                        "name": "Columbia",
                        "latitude": "38.03631000",
                        "longitude": "-120.40131000"
                    },
                    {
                        "id": 114504,
                        "name": "Colusa",
                        "latitude": "39.21433000",
                        "longitude": "-122.00942000"
                    },
                    {
                        "id": 114505,
                        "name": "Colusa County",
                        "latitude": "39.17757000",
                        "longitude": "-122.23703000"
                    },
                    {
                        "id": 114525,
                        "name": "Commerce",
                        "latitude": "34.00057000",
                        "longitude": "-118.15979000"
                    },
                    {
                        "id": 114529,
                        "name": "Compton",
                        "latitude": "33.89585000",
                        "longitude": "-118.22007000"
                    },
                    {
                        "id": 114543,
                        "name": "Concord",
                        "latitude": "37.97798000",
                        "longitude": "-122.03107000"
                    },
                    {
                        "id": 114575,
                        "name": "Contra Costa Centre",
                        "latitude": "37.92752000",
                        "longitude": "-122.05786000"
                    },
                    {
                        "id": 114576,
                        "name": "Contra Costa County",
                        "latitude": "37.92342000",
                        "longitude": "-121.95121000"
                    },
                    {
                        "id": 114596,
                        "name": "Cool",
                        "latitude": "38.88722000",
                        "longitude": "-121.01472000"
                    },
                    {
                        "id": 114622,
                        "name": "Copperopolis",
                        "latitude": "37.98104000",
                        "longitude": "-120.64187000"
                    },
                    {
                        "id": 114633,
                        "name": "Corcoran",
                        "latitude": "36.09801000",
                        "longitude": "-119.56040000"
                    },
                    {
                        "id": 114654,
                        "name": "Corning",
                        "latitude": "39.92766000",
                        "longitude": "-122.17916000"
                    },
                    {
                        "id": 114662,
                        "name": "Corona",
                        "latitude": "33.87529000",
                        "longitude": "-117.56644000"
                    },
                    {
                        "id": 114664,
                        "name": "Coronado",
                        "latitude": "32.68589000",
                        "longitude": "-117.18309000"
                    },
                    {
                        "id": 114667,
                        "name": "Corralitos",
                        "latitude": "36.98856000",
                        "longitude": "-121.80634000"
                    },
                    {
                        "id": 114672,
                        "name": "Corte Madera",
                        "latitude": "37.92548000",
                        "longitude": "-122.52748000"
                    },
                    {
                        "id": 114686,
                        "name": "Costa Mesa",
                        "latitude": "33.64113000",
                        "longitude": "-117.91867000"
                    },
                    {
                        "id": 114688,
                        "name": "Cotati",
                        "latitude": "38.32686000",
                        "longitude": "-122.70721000"
                    },
                    {
                        "id": 114689,
                        "name": "Coto De Caza",
                        "latitude": "33.60419000",
                        "longitude": "-117.58699000"
                    },
                    {
                        "id": 114702,
                        "name": "Cottonwood",
                        "latitude": "40.38571000",
                        "longitude": "-122.28084000"
                    },
                    {
                        "id": 114715,
                        "name": "Country Club",
                        "latitude": "37.96881000",
                        "longitude": "-121.34078000"
                    },
                    {
                        "id": 114731,
                        "name": "Covelo",
                        "latitude": "39.79327000",
                        "longitude": "-123.24922000"
                    },
                    {
                        "id": 114734,
                        "name": "Covina",
                        "latitude": "34.09001000",
                        "longitude": "-117.89034000"
                    },
                    {
                        "id": 114796,
                        "name": "Crescent City",
                        "latitude": "41.75595000",
                        "longitude": "-124.20175000"
                    },
                    {
                        "id": 114802,
                        "name": "Crest",
                        "latitude": "32.80727000",
                        "longitude": "-116.86808000"
                    },
                    {
                        "id": 114805,
                        "name": "Crestline",
                        "latitude": "34.24195000",
                        "longitude": "-117.28560000"
                    },
                    {
                        "id": 114830,
                        "name": "Crockett",
                        "latitude": "38.05242000",
                        "longitude": "-122.21302000"
                    },
                    {
                        "id": 114890,
                        "name": "Cudahy",
                        "latitude": "33.96057000",
                        "longitude": "-118.18535000"
                    },
                    {
                        "id": 114904,
                        "name": "Culver City",
                        "latitude": "34.02112000",
                        "longitude": "-118.39647000"
                    },
                    {
                        "id": 114924,
                        "name": "Cupertino",
                        "latitude": "37.32300000",
                        "longitude": "-122.03218000"
                    },
                    {
                        "id": 114947,
                        "name": "Cutler",
                        "latitude": "36.52328000",
                        "longitude": "-119.28678000"
                    },
                    {
                        "id": 114951,
                        "name": "Cutten",
                        "latitude": "40.76985000",
                        "longitude": "-124.14284000"
                    },
                    {
                        "id": 114954,
                        "name": "Cypress",
                        "latitude": "33.81696000",
                        "longitude": "-118.03729000"
                    },
                    {
                        "id": 115006,
                        "name": "Daly City",
                        "latitude": "37.70577000",
                        "longitude": "-122.46192000"
                    },
                    {
                        "id": 115012,
                        "name": "Dana Point",
                        "latitude": "33.46697000",
                        "longitude": "-117.69811000"
                    },
                    {
                        "id": 115038,
                        "name": "Danville",
                        "latitude": "37.82159000",
                        "longitude": "-121.99996000"
                    },
                    {
                        "id": 115073,
                        "name": "Davis",
                        "latitude": "38.54491000",
                        "longitude": "-121.74052000"
                    },
                    {
                        "id": 115090,
                        "name": "Day Valley",
                        "latitude": "37.03578000",
                        "longitude": "-121.86246000"
                    },
                    {
                        "id": 115178,
                        "name": "Deer Park",
                        "latitude": "38.68185000",
                        "longitude": "-120.82327000"
                    },
                    {
                        "id": 115186,
                        "name": "Del Aire",
                        "latitude": "33.91613000",
                        "longitude": "-118.36952000"
                    },
                    {
                        "id": 115188,
                        "name": "Del Mar",
                        "latitude": "32.95949000",
                        "longitude": "-117.26531000"
                    },
                    {
                        "id": 115189,
                        "name": "Del Monte Forest",
                        "latitude": "36.58635000",
                        "longitude": "-121.94746000"
                    },
                    {
                        "id": 115191,
                        "name": "Del Norte County",
                        "latitude": "41.74496000",
                        "longitude": "-123.95781000"
                    },
                    {
                        "id": 115192,
                        "name": "Del Rey",
                        "latitude": "36.65912000",
                        "longitude": "-119.59374000"
                    },
                    {
                        "id": 115193,
                        "name": "Del Rey Oaks",
                        "latitude": "36.59329000",
                        "longitude": "-121.83495000"
                    },
                    {
                        "id": 115194,
                        "name": "Del Rio",
                        "latitude": "37.74354000",
                        "longitude": "-121.01188000"
                    },
                    {
                        "id": 115199,
                        "name": "Delano",
                        "latitude": "35.76884000",
                        "longitude": "-119.24705000"
                    },
                    {
                        "id": 115213,
                        "name": "Delhi",
                        "latitude": "37.43216000",
                        "longitude": "-120.77854000"
                    },
                    {
                        "id": 115234,
                        "name": "Denair",
                        "latitude": "37.52632000",
                        "longitude": "-120.79687000"
                    },
                    {
                        "id": 115276,
                        "name": "Descanso",
                        "latitude": "32.85283000",
                        "longitude": "-116.61585000"
                    },
                    {
                        "id": 115280,
                        "name": "Desert Edge",
                        "latitude": "33.92417000",
                        "longitude": "-116.44139000"
                    },
                    {
                        "id": 115282,
                        "name": "Desert Hot Springs",
                        "latitude": "33.96173000",
                        "longitude": "-116.50353000"
                    },
                    {
                        "id": 115283,
                        "name": "Desert Shores",
                        "latitude": "33.40420000",
                        "longitude": "-116.03972000"
                    },
                    {
                        "id": 115284,
                        "name": "Desert View Highlands",
                        "latitude": "34.59082000",
                        "longitude": "-118.15257000"
                    },
                    {
                        "id": 115312,
                        "name": "Diablo",
                        "latitude": "37.83493000",
                        "longitude": "-121.95801000"
                    },
                    {
                        "id": 115314,
                        "name": "Diamond Bar",
                        "latitude": "34.02862000",
                        "longitude": "-117.81034000"
                    },
                    {
                        "id": 115316,
                        "name": "Diamond Springs",
                        "latitude": "38.69463000",
                        "longitude": "-120.81494000"
                    },
                    {
                        "id": 115351,
                        "name": "Dinuba",
                        "latitude": "36.54328000",
                        "longitude": "-119.38707000"
                    },
                    {
                        "id": 115353,
                        "name": "Discovery Bay",
                        "latitude": "37.90854000",
                        "longitude": "-121.60023000"
                    },
                    {
                        "id": 115367,
                        "name": "Dixon",
                        "latitude": "38.44546000",
                        "longitude": "-121.82330000"
                    },
                    {
                        "id": 115369,
                        "name": "Dixon Lane-Meadow Creek",
                        "latitude": "37.38639000",
                        "longitude": "-118.41527000"
                    },
                    {
                        "id": 115385,
                        "name": "Dogtown",
                        "latitude": "38.21381000",
                        "longitude": "-121.08855000"
                    },
                    {
                        "id": 115390,
                        "name": "Dollar Point",
                        "latitude": "39.18796000",
                        "longitude": "-120.09991000"
                    },
                    {
                        "id": 115414,
                        "name": "Dos Palos",
                        "latitude": "36.98606000",
                        "longitude": "-120.62657000"
                    },
                    {
                        "id": 115460,
                        "name": "Downey",
                        "latitude": "33.94001000",
                        "longitude": "-118.13257000"
                    },
                    {
                        "id": 115461,
                        "name": "Downieville",
                        "latitude": "39.55934000",
                        "longitude": "-120.82689000"
                    },
                    {
                        "id": 115490,
                        "name": "Duarte",
                        "latitude": "34.13945000",
                        "longitude": "-117.97729000"
                    },
                    {
                        "id": 115496,
                        "name": "Dublin",
                        "latitude": "37.70215000",
                        "longitude": "-121.93579000"
                    },
                    {
                        "id": 115551,
                        "name": "Dunnigan",
                        "latitude": "38.88518000",
                        "longitude": "-121.96969000"
                    },
                    {
                        "id": 115553,
                        "name": "Dunsmuir",
                        "latitude": "41.20821000",
                        "longitude": "-122.27195000"
                    },
                    {
                        "id": 115573,
                        "name": "Durham",
                        "latitude": "39.64627000",
                        "longitude": "-121.79998000"
                    },
                    {
                        "id": 115618,
                        "name": "Earlimart",
                        "latitude": "35.88412000",
                        "longitude": "-119.27233000"
                    },
                    {
                        "id": 115663,
                        "name": "East Foothills",
                        "latitude": "37.38105000",
                        "longitude": "-121.81745000"
                    },
                    {
                        "id": 115689,
                        "name": "East Hemet",
                        "latitude": "33.74002000",
                        "longitude": "-116.93891000"
                    },
                    {
                        "id": 115699,
                        "name": "East La Mirada",
                        "latitude": "33.92446000",
                        "longitude": "-117.98895000"
                    },
                    {
                        "id": 115706,
                        "name": "East Los Angeles",
                        "latitude": "34.02390000",
                        "longitude": "-118.17202000"
                    },
                    {
                        "id": 115725,
                        "name": "East Oakdale",
                        "latitude": "37.78798000",
                        "longitude": "-120.80382000"
                    },
                    {
                        "id": 115728,
                        "name": "East Palo Alto",
                        "latitude": "37.46883000",
                        "longitude": "-122.14108000"
                    },
                    {
                        "id": 115729,
                        "name": "East Pasadena",
                        "latitude": "34.13814000",
                        "longitude": "-118.07384000"
                    },
                    {
                        "id": 115739,
                        "name": "East Porterville",
                        "latitude": "36.05745000",
                        "longitude": "-118.97566000"
                    },
                    {
                        "id": 115742,
                        "name": "East Quincy",
                        "latitude": "39.93406000",
                        "longitude": "-120.89801000"
                    },
                    {
                        "id": 115744,
                        "name": "East Rancho Dominguez",
                        "latitude": "33.89807000",
                        "longitude": "-118.19535000"
                    },
                    {
                        "id": 115746,
                        "name": "East Richmond Heights",
                        "latitude": "37.94492000",
                        "longitude": "-122.31358000"
                    },
                    {
                        "id": 115755,
                        "name": "East San Gabriel",
                        "latitude": "34.09168000",
                        "longitude": "-118.09118000"
                    },
                    {
                        "id": 115759,
                        "name": "East Sonora",
                        "latitude": "37.97770000",
                        "longitude": "-120.36130000"
                    },
                    {
                        "id": 115791,
                        "name": "Easton",
                        "latitude": "36.65023000",
                        "longitude": "-119.79070000"
                    },
                    {
                        "id": 115797,
                        "name": "Eastvale",
                        "latitude": "33.96358000",
                        "longitude": "-117.56418000"
                    },
                    {
                        "id": 115814,
                        "name": "Echo Park",
                        "latitude": "34.07808000",
                        "longitude": "-118.26066000"
                    },
                    {
                        "id": 115888,
                        "name": "Edwards Air Force Base",
                        "latitude": "34.91637000",
                        "longitude": "-117.93535000"
                    },
                    {
                        "id": 115911,
                        "name": "El Cajon",
                        "latitude": "32.79477000",
                        "longitude": "-116.96253000"
                    },
                    {
                        "id": 115914,
                        "name": "El Centro",
                        "latitude": "32.79200000",
                        "longitude": "-115.56305000"
                    },
                    {
                        "id": 115915,
                        "name": "El Cerrito",
                        "latitude": "37.91576000",
                        "longitude": "-122.31164000"
                    },
                    {
                        "id": 115916,
                        "name": "El Cerrito Corona",
                        "latitude": "33.84057000",
                        "longitude": "-117.52283000"
                    },
                    {
                        "id": 115921,
                        "name": "El Dorado County",
                        "latitude": "38.77874000",
                        "longitude": "-120.52465000"
                    },
                    {
                        "id": 115922,
                        "name": "El Dorado Hills",
                        "latitude": "38.68574000",
                        "longitude": "-121.08217000"
                    },
                    {
                        "id": 115924,
                        "name": "El Granada",
                        "latitude": "37.50272000",
                        "longitude": "-122.46942000"
                    },
                    {
                        "id": 115928,
                        "name": "El Monte",
                        "latitude": "34.06862000",
                        "longitude": "-118.02757000"
                    },
                    {
                        "id": 115936,
                        "name": "El Rio",
                        "latitude": "34.23578000",
                        "longitude": "-119.16383000"
                    },
                    {
                        "id": 115937,
                        "name": "El Segundo",
                        "latitude": "33.91918000",
                        "longitude": "-118.41647000"
                    },
                    {
                        "id": 115938,
                        "name": "El Sobrante",
                        "latitude": "37.97715000",
                        "longitude": "-122.29525000"
                    },
                    {
                        "id": 115940,
                        "name": "El Verano",
                        "latitude": "38.29769000",
                        "longitude": "-122.49165000"
                    },
                    {
                        "id": 115957,
                        "name": "Eldridge",
                        "latitude": "38.34880000",
                        "longitude": "-122.51081000"
                    },
                    {
                        "id": 115987,
                        "name": "Elk Grove",
                        "latitude": "38.40880000",
                        "longitude": "-121.37162000"
                    },
                    {
                        "id": 116003,
                        "name": "Elkhorn",
                        "latitude": "36.82440000",
                        "longitude": "-121.74050000"
                    },
                    {
                        "id": 116075,
                        "name": "Elverta",
                        "latitude": "38.71379000",
                        "longitude": "-121.46273000"
                    },
                    {
                        "id": 116090,
                        "name": "Emerald Lake Hills",
                        "latitude": "37.46466000",
                        "longitude": "-122.26802000"
                    },
                    {
                        "id": 116097,
                        "name": "Emeryville",
                        "latitude": "37.83132000",
                        "longitude": "-122.28525000"
                    },
                    {
                        "id": 116110,
                        "name": "Empire",
                        "latitude": "37.63826000",
                        "longitude": "-120.90215000"
                    },
                    {
                        "id": 116118,
                        "name": "Encinitas",
                        "latitude": "33.03699000",
                        "longitude": "-117.29198000"
                    },
                    {
                        "id": 116119,
                        "name": "Encino",
                        "latitude": "34.15917000",
                        "longitude": "-118.50119000"
                    },
                    {
                        "id": 116178,
                        "name": "Escalon",
                        "latitude": "37.79781000",
                        "longitude": "-120.99792000"
                    },
                    {
                        "id": 116184,
                        "name": "Escondido",
                        "latitude": "33.11921000",
                        "longitude": "-117.08642000"
                    },
                    {
                        "id": 116187,
                        "name": "Esparto",
                        "latitude": "38.69213000",
                        "longitude": "-122.01719000"
                    },
                    {
                        "id": 116221,
                        "name": "Eucalyptus Hills",
                        "latitude": "32.87977000",
                        "longitude": "-116.94669000"
                    },
                    {
                        "id": 116235,
                        "name": "Eureka",
                        "latitude": "40.80207000",
                        "longitude": "-124.16367000"
                    },
                    {
                        "id": 116274,
                        "name": "Exeter",
                        "latitude": "36.29606000",
                        "longitude": "-119.14205000"
                    },
                    {
                        "id": 116286,
                        "name": "Fair Oaks",
                        "latitude": "38.64463000",
                        "longitude": "-121.27217000"
                    },
                    {
                        "id": 116292,
                        "name": "Fairbanks Ranch",
                        "latitude": "32.99393000",
                        "longitude": "-117.18726000"
                    },
                    {
                        "id": 116306,
                        "name": "Fairfax",
                        "latitude": "37.98715000",
                        "longitude": "-122.58887000"
                    },
                    {
                        "id": 116316,
                        "name": "Fairfield",
                        "latitude": "38.24936000",
                        "longitude": "-122.03997000"
                    },
                    {
                        "id": 116333,
                        "name": "Fairmead",
                        "latitude": "37.07633000",
                        "longitude": "-120.19295000"
                    },
                    {
                        "id": 116355,
                        "name": "Fairview",
                        "latitude": "37.67854000",
                        "longitude": "-122.04580000"
                    },
                    {
                        "id": 116376,
                        "name": "Fallbrook",
                        "latitude": "33.37642000",
                        "longitude": "-117.25115000"
                    },
                    {
                        "id": 116407,
                        "name": "Farmersville",
                        "latitude": "36.29773000",
                        "longitude": "-119.20678000"
                    },
                    {
                        "id": 116471,
                        "name": "Felton",
                        "latitude": "37.05134000",
                        "longitude": "-122.07330000"
                    },
                    {
                        "id": 116489,
                        "name": "Ferndale",
                        "latitude": "40.57624000",
                        "longitude": "-124.26394000"
                    },
                    {
                        "id": 116503,
                        "name": "Fetters Hot Springs-Agua Caliente",
                        "latitude": "38.32140000",
                        "longitude": "-122.48682000"
                    },
                    {
                        "id": 116508,
                        "name": "Fillmore",
                        "latitude": "34.39916000",
                        "longitude": "-118.91815000"
                    },
                    {
                        "id": 116520,
                        "name": "Firebaugh",
                        "latitude": "36.85884000",
                        "longitude": "-120.45601000"
                    },
                    {
                        "id": 116589,
                        "name": "Florence-Graham",
                        "latitude": "33.96772000",
                        "longitude": "-118.24438000"
                    },
                    {
                        "id": 116595,
                        "name": "Florin",
                        "latitude": "38.49602000",
                        "longitude": "-121.40884000"
                    },
                    {
                        "id": 116626,
                        "name": "Folsom",
                        "latitude": "38.67796000",
                        "longitude": "-121.17606000"
                    },
                    {
                        "id": 116631,
                        "name": "Fontana",
                        "latitude": "34.09223000",
                        "longitude": "-117.43505000"
                    },
                    {
                        "id": 116632,
                        "name": "Foothill Farms",
                        "latitude": "38.67877000",
                        "longitude": "-121.35114000"
                    },
                    {
                        "id": 116633,
                        "name": "Foothill Ranch",
                        "latitude": "33.68641000",
                        "longitude": "-117.66088000"
                    },
                    {
                        "id": 116635,
                        "name": "Ford City",
                        "latitude": "35.15441000",
                        "longitude": "-119.45623000"
                    },
                    {
                        "id": 116662,
                        "name": "Forest Meadows",
                        "latitude": "38.16851000",
                        "longitude": "-120.40659000"
                    },
                    {
                        "id": 116667,
                        "name": "Forest Ranch",
                        "latitude": "39.88211000",
                        "longitude": "-121.67275000"
                    },
                    {
                        "id": 116671,
                        "name": "Foresthill",
                        "latitude": "39.02018000",
                        "longitude": "-120.81799000"
                    },
                    {
                        "id": 116673,
                        "name": "Forestville",
                        "latitude": "38.47352000",
                        "longitude": "-122.89027000"
                    },
                    {
                        "id": 116695,
                        "name": "Fort Bragg",
                        "latitude": "39.44572000",
                        "longitude": "-123.80529000"
                    },
                    {
                        "id": 116719,
                        "name": "Fort Irwin",
                        "latitude": "35.26275000",
                        "longitude": "-116.68475000"
                    },
                    {
                        "id": 116767,
                        "name": "Fortuna",
                        "latitude": "40.59819000",
                        "longitude": "-124.15728000"
                    },
                    {
                        "id": 116776,
                        "name": "Foster City",
                        "latitude": "37.55855000",
                        "longitude": "-122.27108000"
                    },
                    {
                        "id": 116784,
                        "name": "Fountain Valley",
                        "latitude": "33.70918000",
                        "longitude": "-117.95367000"
                    },
                    {
                        "id": 116797,
                        "name": "Fowler",
                        "latitude": "36.63051000",
                        "longitude": "-119.67847000"
                    },
                    {
                        "id": 116883,
                        "name": "Frazier Park",
                        "latitude": "34.82276000",
                        "longitude": "-118.94482000"
                    },
                    {
                        "id": 116903,
                        "name": "Freedom",
                        "latitude": "36.93523000",
                        "longitude": "-121.77301000"
                    },
                    {
                        "id": 116924,
                        "name": "Fremont",
                        "latitude": "37.54827000",
                        "longitude": "-121.98857000"
                    },
                    {
                        "id": 116929,
                        "name": "French Camp",
                        "latitude": "37.88409000",
                        "longitude": "-121.27106000"
                    },
                    {
                        "id": 116939,
                        "name": "Fresno",
                        "latitude": "36.74773000",
                        "longitude": "-119.77237000"
                    },
                    {
                        "id": 116940,
                        "name": "Fresno County",
                        "latitude": "36.75818000",
                        "longitude": "-119.64932000"
                    },
                    {
                        "id": 116975,
                        "name": "Fruitridge Pocket",
                        "latitude": "38.53265000",
                        "longitude": "-121.45581000"
                    },
                    {
                        "id": 116983,
                        "name": "Fullerton",
                        "latitude": "33.87029000",
                        "longitude": "-117.92534000"
                    },
                    {
                        "id": 117040,
                        "name": "Galt",
                        "latitude": "38.25464000",
                        "longitude": "-121.29995000"
                    },
                    {
                        "id": 117053,
                        "name": "Garden Acres",
                        "latitude": "37.96381000",
                        "longitude": "-121.22939000"
                    },
                    {
                        "id": 117065,
                        "name": "Garden Grove",
                        "latitude": "33.77391000",
                        "longitude": "-117.94145000"
                    },
                    {
                        "id": 117069,
                        "name": "Gardena",
                        "latitude": "33.88835000",
                        "longitude": "-118.30896000"
                    },
                    {
                        "id": 117094,
                        "name": "Garnet",
                        "latitude": "33.90196000",
                        "longitude": "-116.54557000"
                    },
                    {
                        "id": 117165,
                        "name": "Georgetown",
                        "latitude": "38.90684000",
                        "longitude": "-120.83855000"
                    },
                    {
                        "id": 117169,
                        "name": "Gerber",
                        "latitude": "40.05627000",
                        "longitude": "-122.15027000"
                    },
                    {
                        "id": 117225,
                        "name": "Gilroy",
                        "latitude": "37.00578000",
                        "longitude": "-121.56828000"
                    },
                    {
                        "id": 117261,
                        "name": "Glen Avon",
                        "latitude": "34.01168000",
                        "longitude": "-117.48477000"
                    },
                    {
                        "id": 117286,
                        "name": "Glendale",
                        "latitude": "34.14251000",
                        "longitude": "-118.25508000"
                    },
                    {
                        "id": 117291,
                        "name": "Glendora",
                        "latitude": "34.13612000",
                        "longitude": "-117.86534000"
                    },
                    {
                        "id": 117296,
                        "name": "Glenn County",
                        "latitude": "39.59840000",
                        "longitude": "-122.39221000"
                    },
                    {
                        "id": 117345,
                        "name": "Gold River",
                        "latitude": "38.62629000",
                        "longitude": "-121.24662000"
                    },
                    {
                        "id": 117351,
                        "name": "Golden Hills",
                        "latitude": "35.14247000",
                        "longitude": "-118.49036000"
                    },
                    {
                        "id": 117367,
                        "name": "Goleta",
                        "latitude": "34.43583000",
                        "longitude": "-119.82764000"
                    },
                    {
                        "id": 117372,
                        "name": "Gonzales",
                        "latitude": "36.50663000",
                        "longitude": "-121.44438000"
                    },
                    {
                        "id": 117378,
                        "name": "Good Hope",
                        "latitude": "33.76474000",
                        "longitude": "-117.26698000"
                    },
                    {
                        "id": 117410,
                        "name": "Goshen",
                        "latitude": "36.35106000",
                        "longitude": "-119.42012000"
                    },
                    {
                        "id": 117476,
                        "name": "Grand Terrace",
                        "latitude": "34.03390000",
                        "longitude": "-117.31365000"
                    },
                    {
                        "id": 117493,
                        "name": "Granite Bay",
                        "latitude": "38.76323000",
                        "longitude": "-121.16384000"
                    },
                    {
                        "id": 117499,
                        "name": "Granite Hills",
                        "latitude": "32.80311000",
                        "longitude": "-116.90475000"
                    },
                    {
                        "id": 117543,
                        "name": "Grass Valley",
                        "latitude": "39.21906000",
                        "longitude": "-121.06106000"
                    },
                    {
                        "id": 117545,
                        "name": "Graton",
                        "latitude": "38.43630000",
                        "longitude": "-122.86972000"
                    },
                    {
                        "id": 117590,
                        "name": "Green Acres",
                        "latitude": "33.73808000",
                        "longitude": "-117.07642000"
                    },
                    {
                        "id": 117611,
                        "name": "Green Valley",
                        "latitude": "38.25297000",
                        "longitude": "-122.16219000"
                    },
                    {
                        "id": 117613,
                        "name": "Greenacres",
                        "latitude": "35.38329000",
                        "longitude": "-119.10983000"
                    },
                    {
                        "id": 117654,
                        "name": "Greenfield",
                        "latitude": "36.32080000",
                        "longitude": "-121.24381000"
                    },
                    {
                        "id": 117696,
                        "name": "Greenville",
                        "latitude": "40.13961000",
                        "longitude": "-120.95107000"
                    },
                    {
                        "id": 117730,
                        "name": "Gridley",
                        "latitude": "39.36378000",
                        "longitude": "-121.69358000"
                    },
                    {
                        "id": 117760,
                        "name": "Grover Beach",
                        "latitude": "35.12164000",
                        "longitude": "-120.62128000"
                    },
                    {
                        "id": 117777,
                        "name": "Guadalupe",
                        "latitude": "34.97164000",
                        "longitude": "-120.57184000"
                    },
                    {
                        "id": 117780,
                        "name": "Guerneville",
                        "latitude": "38.50186000",
                        "longitude": "-122.99611000"
                    },
                    {
                        "id": 117810,
                        "name": "Gustine",
                        "latitude": "37.25772000",
                        "longitude": "-120.99882000"
                    },
                    {
                        "id": 117825,
                        "name": "Hacienda Heights",
                        "latitude": "33.99307000",
                        "longitude": "-117.96868000"
                    },
                    {
                        "id": 117856,
                        "name": "Half Moon Bay",
                        "latitude": "37.46355000",
                        "longitude": "-122.42859000"
                    },
                    {
                        "id": 117895,
                        "name": "Hamilton City",
                        "latitude": "39.74266000",
                        "longitude": "-122.01359000"
                    },
                    {
                        "id": 117960,
                        "name": "Hanford",
                        "latitude": "36.32745000",
                        "longitude": "-119.64568000"
                    },
                    {
                        "id": 117982,
                        "name": "Happy Camp",
                        "latitude": "41.79275000",
                        "longitude": "-123.38080000"
                    },
                    {
                        "id": 117986,
                        "name": "Harbison Canyon",
                        "latitude": "32.82033000",
                        "longitude": "-116.83002000"
                    },
                    {
                        "id": 118099,
                        "name": "Hartley",
                        "latitude": "38.41713000",
                        "longitude": "-121.94691000"
                    },
                    {
                        "id": 118160,
                        "name": "Hawaiian Gardens",
                        "latitude": "33.83140000",
                        "longitude": "-118.07284000"
                    },
                    {
                        "id": 118175,
                        "name": "Hawthorne",
                        "latitude": "33.91640000",
                        "longitude": "-118.35257000"
                    },
                    {
                        "id": 118186,
                        "name": "Hayfork",
                        "latitude": "40.55431000",
                        "longitude": "-123.18308000"
                    },
                    {
                        "id": 118197,
                        "name": "Hayward",
                        "latitude": "37.66882000",
                        "longitude": "-122.08080000"
                    },
                    {
                        "id": 118217,
                        "name": "Healdsburg",
                        "latitude": "38.61047000",
                        "longitude": "-122.86916000"
                    },
                    {
                        "id": 118228,
                        "name": "Heber",
                        "latitude": "32.73089000",
                        "longitude": "-115.52972000"
                    },
                    {
                        "id": 118264,
                        "name": "Hemet",
                        "latitude": "33.74761000",
                        "longitude": "-116.97307000"
                    },
                    {
                        "id": 118311,
                        "name": "Herald",
                        "latitude": "38.29575000",
                        "longitude": "-121.24439000"
                    },
                    {
                        "id": 118314,
                        "name": "Hercules",
                        "latitude": "38.01714000",
                        "longitude": "-122.28858000"
                    },
                    {
                        "id": 118331,
                        "name": "Hermosa Beach",
                        "latitude": "33.86224000",
                        "longitude": "-118.39952000"
                    },
                    {
                        "id": 118344,
                        "name": "Hesperia",
                        "latitude": "34.42639000",
                        "longitude": "-117.30088000"
                    },
                    {
                        "id": 118376,
                        "name": "Hidden Hills",
                        "latitude": "34.16028000",
                        "longitude": "-118.65231000"
                    },
                    {
                        "id": 118377,
                        "name": "Hidden Meadows",
                        "latitude": "33.22531000",
                        "longitude": "-117.11253000"
                    },
                    {
                        "id": 118380,
                        "name": "Hidden Valley Lake",
                        "latitude": "38.80796000",
                        "longitude": "-122.55832000"
                    },
                    {
                        "id": 118391,
                        "name": "Highgrove",
                        "latitude": "34.01585000",
                        "longitude": "-117.33338000"
                    },
                    {
                        "id": 118398,
                        "name": "Highland",
                        "latitude": "34.12834000",
                        "longitude": "-117.20865000"
                    },
                    {
                        "id": 118421,
                        "name": "Highlands-Baywood Park",
                        "latitude": "37.52272000",
                        "longitude": "-122.34506000"
                    },
                    {
                        "id": 118455,
                        "name": "Hillsborough",
                        "latitude": "37.57410000",
                        "longitude": "-122.37942000"
                    },
                    {
                        "id": 118471,
                        "name": "Hilmar-Irwin",
                        "latitude": "37.40454000",
                        "longitude": "-120.85042000"
                    },
                    {
                        "id": 118552,
                        "name": "Hollister",
                        "latitude": "36.85245000",
                        "longitude": "-121.40160000"
                    },
                    {
                        "id": 118567,
                        "name": "Hollywood",
                        "latitude": "34.09834000",
                        "longitude": "-118.32674000"
                    },
                    {
                        "id": 118582,
                        "name": "Holtville",
                        "latitude": "32.81116000",
                        "longitude": "-115.38026000"
                    },
                    {
                        "id": 118586,
                        "name": "Home Garden",
                        "latitude": "36.30328000",
                        "longitude": "-119.63624000"
                    },
                    {
                        "id": 118587,
                        "name": "Home Gardens",
                        "latitude": "33.87807000",
                        "longitude": "-117.52088000"
                    },
                    {
                        "id": 118590,
                        "name": "Homeland",
                        "latitude": "33.74308000",
                        "longitude": "-117.10920000"
                    },
                    {
                        "id": 118764,
                        "name": "Hughson",
                        "latitude": "37.59688000",
                        "longitude": "-120.86604000"
                    },
                    {
                        "id": 118779,
                        "name": "Humboldt County",
                        "latitude": "40.70501000",
                        "longitude": "-123.91582000"
                    },
                    {
                        "id": 118781,
                        "name": "Humboldt Hill",
                        "latitude": "40.72596000",
                        "longitude": "-124.18978000"
                    },
                    {
                        "id": 118805,
                        "name": "Huntington Beach",
                        "latitude": "33.66030000",
                        "longitude": "-117.99923000"
                    },
                    {
                        "id": 118807,
                        "name": "Huntington Park",
                        "latitude": "33.98168000",
                        "longitude": "-118.22507000"
                    },
                    {
                        "id": 118825,
                        "name": "Huron",
                        "latitude": "36.20273000",
                        "longitude": "-120.10292000"
                    },
                    {
                        "id": 118855,
                        "name": "Hydesville",
                        "latitude": "40.54763000",
                        "longitude": "-124.09727000"
                    },
                    {
                        "id": 118874,
                        "name": "Idyllwild",
                        "latitude": "33.74002000",
                        "longitude": "-116.71891000"
                    },
                    {
                        "id": 118875,
                        "name": "Idyllwild-Pine Cove",
                        "latitude": "33.74429000",
                        "longitude": "-116.72587000"
                    },
                    {
                        "id": 118883,
                        "name": "Imperial",
                        "latitude": "32.84755000",
                        "longitude": "-115.56944000"
                    },
                    {
                        "id": 118885,
                        "name": "Imperial Beach",
                        "latitude": "32.58394000",
                        "longitude": "-117.11308000"
                    },
                    {
                        "id": 118886,
                        "name": "Imperial County",
                        "latitude": "33.03951000",
                        "longitude": "-115.36532000"
                    },
                    {
                        "id": 118921,
                        "name": "Indian Wells",
                        "latitude": "33.71791000",
                        "longitude": "-116.34311000"
                    },
                    {
                        "id": 118929,
                        "name": "Indio",
                        "latitude": "33.72070000",
                        "longitude": "-116.21677000"
                    },
                    {
                        "id": 118937,
                        "name": "Inglewood",
                        "latitude": "33.96168000",
                        "longitude": "-118.35313000"
                    },
                    {
                        "id": 118951,
                        "name": "Interlaken",
                        "latitude": "36.95134000",
                        "longitude": "-121.73384000"
                    },
                    {
                        "id": 118957,
                        "name": "Inverness",
                        "latitude": "38.10103000",
                        "longitude": "-122.85694000"
                    },
                    {
                        "id": 118964,
                        "name": "Inyo County",
                        "latitude": "36.51113000",
                        "longitude": "-117.41079000"
                    },
                    {
                        "id": 118965,
                        "name": "Inyokern",
                        "latitude": "35.64690000",
                        "longitude": "-117.81257000"
                    },
                    {
                        "id": 118970,
                        "name": "Ione",
                        "latitude": "38.35269000",
                        "longitude": "-120.93272000"
                    },
                    {
                        "id": 119004,
                        "name": "Irvine",
                        "latitude": "33.66946000",
                        "longitude": "-117.82311000"
                    },
                    {
                        "id": 119014,
                        "name": "Irwindale",
                        "latitude": "34.10695000",
                        "longitude": "-117.93534000"
                    },
                    {
                        "id": 119021,
                        "name": "Isla Vista",
                        "latitude": "34.41333000",
                        "longitude": "-119.86097000"
                    },
                    {
                        "id": 119049,
                        "name": "Ivanhoe",
                        "latitude": "36.38717000",
                        "longitude": "-119.21789000"
                    },
                    {
                        "id": 119073,
                        "name": "Jackson",
                        "latitude": "38.34880000",
                        "longitude": "-120.77410000"
                    },
                    {
                        "id": 119126,
                        "name": "Jamestown",
                        "latitude": "37.95326000",
                        "longitude": "-120.42270000"
                    },
                    {
                        "id": 119128,
                        "name": "Jamul",
                        "latitude": "32.71700000",
                        "longitude": "-116.87613000"
                    },
                    {
                        "id": 119132,
                        "name": "Janesville",
                        "latitude": "40.29656000",
                        "longitude": "-120.52411000"
                    },
                    {
                        "id": 119283,
                        "name": "Johnstonville",
                        "latitude": "40.38434000",
                        "longitude": "-120.58745000"
                    },
                    {
                        "id": 119323,
                        "name": "Joshua Tree",
                        "latitude": "34.13473000",
                        "longitude": "-116.31307000"
                    },
                    {
                        "id": 119330,
                        "name": "Julian",
                        "latitude": "33.07866000",
                        "longitude": "-116.60196000"
                    },
                    {
                        "id": 119343,
                        "name": "Jurupa Valley",
                        "latitude": "33.99251000",
                        "longitude": "-117.51644000"
                    },
                    {
                        "id": 119431,
                        "name": "Kelseyville",
                        "latitude": "38.97795000",
                        "longitude": "-122.83944000"
                    },
                    {
                        "id": 119469,
                        "name": "Kennedy",
                        "latitude": "37.92992000",
                        "longitude": "-121.25272000"
                    },
                    {
                        "id": 119484,
                        "name": "Kensington",
                        "latitude": "37.91048000",
                        "longitude": "-122.28025000"
                    },
                    {
                        "id": 119495,
                        "name": "Kentfield",
                        "latitude": "37.95215000",
                        "longitude": "-122.55720000"
                    },
                    {
                        "id": 119505,
                        "name": "Kenwood",
                        "latitude": "38.41380000",
                        "longitude": "-122.54609000"
                    },
                    {
                        "id": 119512,
                        "name": "Kerman",
                        "latitude": "36.72356000",
                        "longitude": "-120.05988000"
                    },
                    {
                        "id": 119514,
                        "name": "Kern County",
                        "latitude": "35.34285000",
                        "longitude": "-118.72990000"
                    },
                    {
                        "id": 119516,
                        "name": "Kernville",
                        "latitude": "35.75467000",
                        "longitude": "-118.42536000"
                    },
                    {
                        "id": 119528,
                        "name": "Kettleman City",
                        "latitude": "36.00829000",
                        "longitude": "-119.96180000"
                    },
                    {
                        "id": 119543,
                        "name": "Keyes",
                        "latitude": "37.55660000",
                        "longitude": "-120.91549000"
                    },
                    {
                        "id": 119579,
                        "name": "King City",
                        "latitude": "36.21274000",
                        "longitude": "-121.12603000"
                    },
                    {
                        "id": 119598,
                        "name": "Kings Beach",
                        "latitude": "39.23768000",
                        "longitude": "-120.02658000"
                    },
                    {
                        "id": 119600,
                        "name": "Kings County",
                        "latitude": "36.07536000",
                        "longitude": "-119.81550000"
                    },
                    {
                        "id": 119609,
                        "name": "Kingsburg",
                        "latitude": "36.51384000",
                        "longitude": "-119.55402000"
                    },
                    {
                        "id": 119675,
                        "name": "Knightsen",
                        "latitude": "37.96881000",
                        "longitude": "-121.66801000"
                    },
                    {
                        "id": 119708,
                        "name": "Koreatown",
                        "latitude": "34.05779000",
                        "longitude": "-118.30091000"
                    },
                    {
                        "id": 119736,
                        "name": "La Cañada Flintridge",
                        "latitude": "34.19917000",
                        "longitude": "-118.18785000"
                    },
                    {
                        "id": 119742,
                        "name": "La Crescenta-Montrose",
                        "latitude": "34.23216000",
                        "longitude": "-118.23529000"
                    },
                    {
                        "id": 119755,
                        "name": "La Habra",
                        "latitude": "33.93196000",
                        "longitude": "-117.94617000"
                    },
                    {
                        "id": 119756,
                        "name": "La Habra Heights",
                        "latitude": "33.96085000",
                        "longitude": "-117.95062000"
                    },
                    {
                        "id": 119760,
                        "name": "La Jolla",
                        "latitude": "32.84727000",
                        "longitude": "-117.27420000"
                    },
                    {
                        "id": 119765,
                        "name": "La Mesa",
                        "latitude": "32.76783000",
                        "longitude": "-117.02308000"
                    },
                    {
                        "id": 119767,
                        "name": "La Mirada",
                        "latitude": "33.91724000",
                        "longitude": "-118.01201000"
                    },
                    {
                        "id": 119769,
                        "name": "La Palma",
                        "latitude": "33.84640000",
                        "longitude": "-118.04673000"
                    },
                    {
                        "id": 119779,
                        "name": "La Presa",
                        "latitude": "32.70811000",
                        "longitude": "-116.99725000"
                    },
                    {
                        "id": 119782,
                        "name": "La Puente",
                        "latitude": "34.02001000",
                        "longitude": "-117.94951000"
                    },
                    {
                        "id": 119783,
                        "name": "La Quinta",
                        "latitude": "33.66336000",
                        "longitude": "-116.31001000"
                    },
                    {
                        "id": 119784,
                        "name": "La Riviera",
                        "latitude": "38.56685000",
                        "longitude": "-121.35690000"
                    },
                    {
                        "id": 119789,
                        "name": "La Selva Beach",
                        "latitude": "36.93662000",
                        "longitude": "-121.86468000"
                    },
                    {
                        "id": 119793,
                        "name": "La Verne",
                        "latitude": "34.10084000",
                        "longitude": "-117.76784000"
                    },
                    {
                        "id": 119823,
                        "name": "Ladera",
                        "latitude": "37.39994000",
                        "longitude": "-122.19830000"
                    },
                    {
                        "id": 119824,
                        "name": "Ladera Heights",
                        "latitude": "33.99418000",
                        "longitude": "-118.37535000"
                    },
                    {
                        "id": 119825,
                        "name": "Ladera Ranch",
                        "latitude": "33.57086000",
                        "longitude": "-117.63561000"
                    },
                    {
                        "id": 119835,
                        "name": "Lafayette",
                        "latitude": "37.88576000",
                        "longitude": "-122.11802000"
                    },
                    {
                        "id": 119849,
                        "name": "Laguna",
                        "latitude": "38.42102000",
                        "longitude": "-121.42384000"
                    },
                    {
                        "id": 119852,
                        "name": "Laguna Beach",
                        "latitude": "33.54225000",
                        "longitude": "-117.78311000"
                    },
                    {
                        "id": 119854,
                        "name": "Laguna Hills",
                        "latitude": "33.61252000",
                        "longitude": "-117.71283000"
                    },
                    {
                        "id": 119855,
                        "name": "Laguna Niguel",
                        "latitude": "33.52253000",
                        "longitude": "-117.70755000"
                    },
                    {
                        "id": 119858,
                        "name": "Laguna Woods",
                        "latitude": "33.61030000",
                        "longitude": "-117.72533000"
                    },
                    {
                        "id": 119859,
                        "name": "Lagunitas-Forest Knolls",
                        "latitude": "38.01793000",
                        "longitude": "-122.69124000"
                    },
                    {
                        "id": 119866,
                        "name": "Lake Arrowhead",
                        "latitude": "34.24834000",
                        "longitude": "-117.18921000"
                    },
                    {
                        "id": 119896,
                        "name": "Lake County",
                        "latitude": "39.09965000",
                        "longitude": "-122.75318000"
                    },
                    {
                        "id": 119906,
                        "name": "Lake Elsinore",
                        "latitude": "33.66808000",
                        "longitude": "-117.32726000"
                    },
                    {
                        "id": 119911,
                        "name": "Lake Forest",
                        "latitude": "33.64697000",
                        "longitude": "-117.68922000"
                    },
                    {
                        "id": 119923,
                        "name": "Lake Isabella",
                        "latitude": "35.61801000",
                        "longitude": "-118.47314000"
                    },
                    {
                        "id": 119931,
                        "name": "Lake Los Angeles",
                        "latitude": "34.61249000",
                        "longitude": "-117.82812000"
                    },
                    {
                        "id": 119950,
                        "name": "Lake Nacimiento",
                        "latitude": "35.72830000",
                        "longitude": "-120.87963000"
                    },
                    {
                        "id": 120005,
                        "name": "Lake of the Pines",
                        "latitude": "39.03962000",
                        "longitude": "-121.05661000"
                    },
                    {
                        "id": 119973,
                        "name": "Lake San Marcos",
                        "latitude": "33.12615000",
                        "longitude": "-117.20837000"
                    },
                    {
                        "id": 119993,
                        "name": "Lake Wildwood",
                        "latitude": "39.23295000",
                        "longitude": "-121.20051000"
                    },
                    {
                        "id": 120020,
                        "name": "Lakeland Village",
                        "latitude": "33.63863000",
                        "longitude": "-117.34393000"
                    },
                    {
                        "id": 120023,
                        "name": "Lakeport",
                        "latitude": "39.04295000",
                        "longitude": "-122.91583000"
                    },
                    {
                        "id": 120032,
                        "name": "Lakeside",
                        "latitude": "32.85727000",
                        "longitude": "-116.92225000"
                    },
                    {
                        "id": 120040,
                        "name": "Lakeview",
                        "latitude": "33.83863000",
                        "longitude": "-117.11809000"
                    },
                    {
                        "id": 120051,
                        "name": "Lakewood",
                        "latitude": "33.85363000",
                        "longitude": "-118.13396000"
                    },
                    {
                        "id": 120074,
                        "name": "Lamont",
                        "latitude": "35.25968000",
                        "longitude": "-118.91427000"
                    },
                    {
                        "id": 120089,
                        "name": "Lancaster",
                        "latitude": "34.69804000",
                        "longitude": "-118.13674000"
                    },
                    {
                        "id": 120147,
                        "name": "Larkfield-Wikiup",
                        "latitude": "38.51342000",
                        "longitude": "-122.75094000"
                    },
                    {
                        "id": 120148,
                        "name": "Larkspur",
                        "latitude": "37.93409000",
                        "longitude": "-122.53525000"
                    },
                    {
                        "id": 120156,
                        "name": "Las Flores",
                        "latitude": "33.58808000",
                        "longitude": "-117.62672000"
                    },
                    {
                        "id": 120158,
                        "name": "Las Lomas",
                        "latitude": "36.86523000",
                        "longitude": "-121.73495000"
                    },
                    {
                        "id": 120166,
                        "name": "Lassen County",
                        "latitude": "40.67359000",
                        "longitude": "-120.59433000"
                    },
                    {
                        "id": 120170,
                        "name": "Lathrop",
                        "latitude": "37.82270000",
                        "longitude": "-121.27661000"
                    },
                    {
                        "id": 120174,
                        "name": "Laton",
                        "latitude": "36.43328000",
                        "longitude": "-119.68680000"
                    },
                    {
                        "id": 120222,
                        "name": "Lawndale",
                        "latitude": "33.88724000",
                        "longitude": "-118.35257000"
                    },
                    {
                        "id": 120255,
                        "name": "Laytonville",
                        "latitude": "39.68821000",
                        "longitude": "-123.48279000"
                    },
                    {
                        "id": 120260,
                        "name": "Le Grand",
                        "latitude": "37.22855000",
                        "longitude": "-120.24823000"
                    },
                    {
                        "id": 120298,
                        "name": "Lebec",
                        "latitude": "34.84164000",
                        "longitude": "-118.86482000"
                    },
                    {
                        "id": 120359,
                        "name": "Lemon Grove",
                        "latitude": "32.74255000",
                        "longitude": "-117.03142000"
                    },
                    {
                        "id": 120362,
                        "name": "Lemoore",
                        "latitude": "36.30078000",
                        "longitude": "-119.78291000"
                    },
                    {
                        "id": 120363,
                        "name": "Lemoore Station",
                        "latitude": "36.26326000",
                        "longitude": "-119.90476000"
                    },
                    {
                        "id": 120371,
                        "name": "Lennox",
                        "latitude": "33.93807000",
                        "longitude": "-118.35258000"
                    },
                    {
                        "id": 120378,
                        "name": "Lenwood",
                        "latitude": "34.87665000",
                        "longitude": "-117.10393000"
                    },
                    {
                        "id": 120387,
                        "name": "Leona Valley",
                        "latitude": "34.61832000",
                        "longitude": "-118.28813000"
                    },
                    {
                        "id": 120427,
                        "name": "Lewiston",
                        "latitude": "40.70737000",
                        "longitude": "-122.80752000"
                    },
                    {
                        "id": 120454,
                        "name": "Lexington Hills",
                        "latitude": "37.16467000",
                        "longitude": "-121.97301000"
                    },
                    {
                        "id": 120509,
                        "name": "Lincoln",
                        "latitude": "38.89156000",
                        "longitude": "-121.29301000"
                    },
                    {
                        "id": 120547,
                        "name": "Lincoln Village",
                        "latitude": "38.00520000",
                        "longitude": "-121.32828000"
                    },
                    {
                        "id": 120557,
                        "name": "Linda",
                        "latitude": "39.12767000",
                        "longitude": "-121.55080000"
                    },
                    {
                        "id": 120566,
                        "name": "Linden",
                        "latitude": "38.02131000",
                        "longitude": "-121.08383000"
                    },
                    {
                        "id": 120574,
                        "name": "Lindsay",
                        "latitude": "36.20301000",
                        "longitude": "-119.08816000"
                    },
                    {
                        "id": 120633,
                        "name": "Littlerock",
                        "latitude": "34.52110000",
                        "longitude": "-117.98368000"
                    },
                    {
                        "id": 120640,
                        "name": "Live Oak",
                        "latitude": "36.98356000",
                        "longitude": "-121.98052000"
                    },
                    {
                        "id": 120644,
                        "name": "Livermore",
                        "latitude": "37.68187000",
                        "longitude": "-121.76801000"
                    },
                    {
                        "id": 120652,
                        "name": "Livingston",
                        "latitude": "37.38688000",
                        "longitude": "-120.72353000"
                    },
                    {
                        "id": 120675,
                        "name": "Lockeford",
                        "latitude": "38.16353000",
                        "longitude": "-121.14994000"
                    },
                    {
                        "id": 120691,
                        "name": "Lodi",
                        "latitude": "38.13020000",
                        "longitude": "-121.27245000"
                    },
                    {
                        "id": 120712,
                        "name": "Loma Linda",
                        "latitude": "34.04835000",
                        "longitude": "-117.26115000"
                    },
                    {
                        "id": 120713,
                        "name": "Loma Rica",
                        "latitude": "39.31183000",
                        "longitude": "-121.41774000"
                    },
                    {
                        "id": 120716,
                        "name": "Lomita",
                        "latitude": "33.79224000",
                        "longitude": "-118.31507000"
                    },
                    {
                        "id": 120717,
                        "name": "Lompico",
                        "latitude": "37.10550000",
                        "longitude": "-122.05274000"
                    },
                    {
                        "id": 120718,
                        "name": "Lompoc",
                        "latitude": "34.63915000",
                        "longitude": "-120.45794000"
                    },
                    {
                        "id": 120722,
                        "name": "London",
                        "latitude": "36.47606000",
                        "longitude": "-119.44318000"
                    },
                    {
                        "id": 120729,
                        "name": "Lone Pine",
                        "latitude": "36.60626000",
                        "longitude": "-118.06462000"
                    },
                    {
                        "id": 120738,
                        "name": "Long Beach",
                        "latitude": "33.76696000",
                        "longitude": "-118.18923000"
                    },
                    {
                        "id": 120767,
                        "name": "Loomis",
                        "latitude": "38.82129000",
                        "longitude": "-121.19300000"
                    },
                    {
                        "id": 120778,
                        "name": "Los Alamitos",
                        "latitude": "33.80307000",
                        "longitude": "-118.07256000"
                    },
                    {
                        "id": 120779,
                        "name": "Los Alamos",
                        "latitude": "34.74443000",
                        "longitude": "-120.27821000"
                    },
                    {
                        "id": 120782,
                        "name": "Los Altos",
                        "latitude": "37.38522000",
                        "longitude": "-122.11413000"
                    },
                    {
                        "id": 120783,
                        "name": "Los Altos Hills",
                        "latitude": "37.37966000",
                        "longitude": "-122.13746000"
                    },
                    {
                        "id": 120784,
                        "name": "Los Angeles",
                        "latitude": "34.05223000",
                        "longitude": "-118.24368000"
                    },
                    {
                        "id": 120785,
                        "name": "Los Angeles County",
                        "latitude": "34.19801000",
                        "longitude": "-118.26102000"
                    },
                    {
                        "id": 120786,
                        "name": "Los Banos",
                        "latitude": "37.05828000",
                        "longitude": "-120.84992000"
                    },
                    {
                        "id": 120789,
                        "name": "Los Gatos",
                        "latitude": "37.22661000",
                        "longitude": "-121.97468000"
                    },
                    {
                        "id": 120792,
                        "name": "Los Molinos",
                        "latitude": "40.02127000",
                        "longitude": "-122.10027000"
                    },
                    {
                        "id": 120793,
                        "name": "Los Olivos",
                        "latitude": "34.66776000",
                        "longitude": "-120.11487000"
                    },
                    {
                        "id": 120794,
                        "name": "Los Osos",
                        "latitude": "35.31109000",
                        "longitude": "-120.83240000"
                    },
                    {
                        "id": 120796,
                        "name": "Los Serranos",
                        "latitude": "33.97279000",
                        "longitude": "-117.70811000"
                    },
                    {
                        "id": 120798,
                        "name": "Lost Hills",
                        "latitude": "35.61635000",
                        "longitude": "-119.69429000"
                    },
                    {
                        "id": 120842,
                        "name": "Lower Lake",
                        "latitude": "38.91045000",
                        "longitude": "-122.61026000"
                    },
                    {
                        "id": 120855,
                        "name": "Loyola",
                        "latitude": "37.35133000",
                        "longitude": "-122.10052000"
                    },
                    {
                        "id": 120862,
                        "name": "Lucas Valley-Marinwood",
                        "latitude": "38.04011000",
                        "longitude": "-122.57550000"
                    },
                    {
                        "id": 120865,
                        "name": "Lucerne",
                        "latitude": "36.38078000",
                        "longitude": "-119.66430000"
                    },
                    {
                        "id": 120866,
                        "name": "Lucerne Valley",
                        "latitude": "34.44389000",
                        "longitude": "-116.96781000"
                    },
                    {
                        "id": 120934,
                        "name": "Lynwood",
                        "latitude": "33.93029000",
                        "longitude": "-118.21146000"
                    },
                    {
                        "id": 120980,
                        "name": "Madera",
                        "latitude": "36.96134000",
                        "longitude": "-120.06072000"
                    },
                    {
                        "id": 120981,
                        "name": "Madera Acres",
                        "latitude": "37.01911000",
                        "longitude": "-120.06683000"
                    },
                    {
                        "id": 120982,
                        "name": "Madera County",
                        "latitude": "37.21804000",
                        "longitude": "-119.76265000"
                    },
                    {
                        "id": 121031,
                        "name": "Magalia",
                        "latitude": "39.81211000",
                        "longitude": "-121.57831000"
                    },
                    {
                        "id": 121062,
                        "name": "Malibu",
                        "latitude": "34.02577000",
                        "longitude": "-118.78040000"
                    },
                    {
                        "id": 121077,
                        "name": "Mammoth Lakes",
                        "latitude": "37.64855000",
                        "longitude": "-118.97208000"
                    },
                    {
                        "id": 121117,
                        "name": "Manhattan Beach",
                        "latitude": "33.88474000",
                        "longitude": "-118.41091000"
                    },
                    {
                        "id": 121154,
                        "name": "Manteca",
                        "latitude": "37.79743000",
                        "longitude": "-121.21605000"
                    },
                    {
                        "id": 121196,
                        "name": "March Air Force Base",
                        "latitude": "33.89209000",
                        "longitude": "-117.26310000"
                    },
                    {
                        "id": 121212,
                        "name": "Maricopa",
                        "latitude": "35.05886000",
                        "longitude": "-119.40095000"
                    },
                    {
                        "id": 121221,
                        "name": "Marin City",
                        "latitude": "37.86854000",
                        "longitude": "-122.50914000"
                    },
                    {
                        "id": 121222,
                        "name": "Marin County",
                        "latitude": "38.05518000",
                        "longitude": "-122.74886000"
                    },
                    {
                        "id": 121223,
                        "name": "Marina",
                        "latitude": "36.68440000",
                        "longitude": "-121.80217000"
                    },
                    {
                        "id": 121224,
                        "name": "Marina del Rey",
                        "latitude": "33.98029000",
                        "longitude": "-118.45174000"
                    },
                    {
                        "id": 121264,
                        "name": "Mariposa",
                        "latitude": "37.48494000",
                        "longitude": "-119.96628000"
                    },
                    {
                        "id": 121265,
                        "name": "Mariposa County",
                        "latitude": "37.58152000",
                        "longitude": "-119.90552000"
                    },
                    {
                        "id": 121345,
                        "name": "Martinez",
                        "latitude": "38.01937000",
                        "longitude": "-122.13413000"
                    },
                    {
                        "id": 121360,
                        "name": "Marysville",
                        "latitude": "39.14573000",
                        "longitude": "-121.59135000"
                    },
                    {
                        "id": 121401,
                        "name": "Matheny",
                        "latitude": "36.17066000",
                        "longitude": "-119.35158000"
                    },
                    {
                        "id": 121430,
                        "name": "Maxwell",
                        "latitude": "39.27628000",
                        "longitude": "-122.19137000"
                    },
                    {
                        "id": 121439,
                        "name": "Mayflower Village",
                        "latitude": "34.11501000",
                        "longitude": "-118.00979000"
                    },
                    {
                        "id": 121459,
                        "name": "Maywood",
                        "latitude": "33.98668000",
                        "longitude": "-118.18535000"
                    },
                    {
                        "id": 121471,
                        "name": "McCloud",
                        "latitude": "41.25571000",
                        "longitude": "-122.13945000"
                    },
                    {
                        "id": 121500,
                        "name": "McFarland",
                        "latitude": "35.67801000",
                        "longitude": "-119.22927000"
                    },
                    {
                        "id": 121524,
                        "name": "McKinleyville",
                        "latitude": "40.94652000",
                        "longitude": "-124.10062000"
                    },
                    {
                        "id": 121554,
                        "name": "Mead Valley",
                        "latitude": "33.83335000",
                        "longitude": "-117.29615000"
                    },
                    {
                        "id": 121563,
                        "name": "Meadow Vista",
                        "latitude": "39.00101000",
                        "longitude": "-121.02189000"
                    },
                    {
                        "id": 121567,
                        "name": "Meadowbrook",
                        "latitude": "33.72578000",
                        "longitude": "-117.28509000"
                    },
                    {
                        "id": 121578,
                        "name": "Mecca",
                        "latitude": "33.57219000",
                        "longitude": "-116.07820000"
                    },
                    {
                        "id": 121619,
                        "name": "Meiners Oaks",
                        "latitude": "34.44694000",
                        "longitude": "-119.27928000"
                    },
                    {
                        "id": 121652,
                        "name": "Mendocino County",
                        "latitude": "39.43362000",
                        "longitude": "-123.43155000"
                    },
                    {
                        "id": 121657,
                        "name": "Mendota",
                        "latitude": "36.75356000",
                        "longitude": "-120.38156000"
                    },
                    {
                        "id": 121659,
                        "name": "Menifee",
                        "latitude": "33.72835000",
                        "longitude": "-117.14642000"
                    },
                    {
                        "id": 121661,
                        "name": "Menlo Park",
                        "latitude": "37.45383000",
                        "longitude": "-122.18219000"
                    },
                    {
                        "id": 121667,
                        "name": "Mentone",
                        "latitude": "34.07001000",
                        "longitude": "-117.13448000"
                    },
                    {
                        "id": 121671,
                        "name": "Merced",
                        "latitude": "37.30216000",
                        "longitude": "-120.48297000"
                    },
                    {
                        "id": 121672,
                        "name": "Merced County",
                        "latitude": "37.19186000",
                        "longitude": "-120.71767000"
                    },
                    {
                        "id": 121722,
                        "name": "Mesa Verde",
                        "latitude": "33.60586000",
                        "longitude": "-114.73107000"
                    },
                    {
                        "id": 121794,
                        "name": "Middletown",
                        "latitude": "38.75240000",
                        "longitude": "-122.61499000"
                    },
                    {
                        "id": 121809,
                        "name": "Midpines",
                        "latitude": "37.54438000",
                        "longitude": "-119.92045000"
                    },
                    {
                        "id": 121821,
                        "name": "Midway City",
                        "latitude": "33.74474000",
                        "longitude": "-117.98923000"
                    },
                    {
                        "id": 121868,
                        "name": "Mill Valley",
                        "latitude": "37.90604000",
                        "longitude": "-122.54498000"
                    },
                    {
                        "id": 121871,
                        "name": "Millbrae",
                        "latitude": "37.59855000",
                        "longitude": "-122.38719000"
                    },
                    {
                        "id": 121909,
                        "name": "Milpitas",
                        "latitude": "37.42827000",
                        "longitude": "-121.90662000"
                    },
                    {
                        "id": 121949,
                        "name": "Minkler",
                        "latitude": "36.72384000",
                        "longitude": "-119.45818000"
                    },
                    {
                        "id": 121971,
                        "name": "Mira Mesa",
                        "latitude": "32.91560000",
                        "longitude": "-117.14392000"
                    },
                    {
                        "id": 121972,
                        "name": "Mira Monte",
                        "latitude": "34.43361000",
                        "longitude": "-119.28511000"
                    },
                    {
                        "id": 121984,
                        "name": "Mission Canyon",
                        "latitude": "34.45083000",
                        "longitude": "-119.71291000"
                    },
                    {
                        "id": 121985,
                        "name": "Mission District",
                        "latitude": "37.75993000",
                        "longitude": "-122.41914000"
                    },
                    {
                        "id": 121987,
                        "name": "Mission Hills",
                        "latitude": "34.68609000",
                        "longitude": "-120.43683000"
                    },
                    {
                        "id": 121988,
                        "name": "Mission Viejo",
                        "latitude": "33.60002000",
                        "longitude": "-117.67200000"
                    },
                    {
                        "id": 122014,
                        "name": "Modesto",
                        "latitude": "37.63910000",
                        "longitude": "-120.99688000"
                    },
                    {
                        "id": 122015,
                        "name": "Modoc County",
                        "latitude": "41.58985000",
                        "longitude": "-120.72497000"
                    },
                    {
                        "id": 122023,
                        "name": "Mojave",
                        "latitude": "35.05247000",
                        "longitude": "-118.17396000"
                    },
                    {
                        "id": 122048,
                        "name": "Mono County",
                        "latitude": "37.93899000",
                        "longitude": "-118.88671000"
                    },
                    {
                        "id": 122049,
                        "name": "Mono Vista",
                        "latitude": "37.99770000",
                        "longitude": "-120.26991000"
                    },
                    {
                        "id": 122088,
                        "name": "Monrovia",
                        "latitude": "34.14806000",
                        "longitude": "-117.99895000"
                    },
                    {
                        "id": 122098,
                        "name": "Montague",
                        "latitude": "41.72820000",
                        "longitude": "-122.52780000"
                    },
                    {
                        "id": 122100,
                        "name": "Montalvin",
                        "latitude": "37.99548000",
                        "longitude": "-122.33275000"
                    },
                    {
                        "id": 122102,
                        "name": "Montara",
                        "latitude": "37.54216000",
                        "longitude": "-122.51609000"
                    },
                    {
                        "id": 122107,
                        "name": "Montclair",
                        "latitude": "34.07751000",
                        "longitude": "-117.68978000"
                    },
                    {
                        "id": 122109,
                        "name": "Monte Rio",
                        "latitude": "38.46547000",
                        "longitude": "-123.00889000"
                    },
                    {
                        "id": 122110,
                        "name": "Monte Sereno",
                        "latitude": "37.23633000",
                        "longitude": "-121.99246000"
                    },
                    {
                        "id": 122114,
                        "name": "Montebello",
                        "latitude": "34.00946000",
                        "longitude": "-118.10535000"
                    },
                    {
                        "id": 122115,
                        "name": "Montecito",
                        "latitude": "34.43666000",
                        "longitude": "-119.63208000"
                    },
                    {
                        "id": 122120,
                        "name": "Monterey",
                        "latitude": "36.60024000",
                        "longitude": "-121.89468000"
                    },
                    {
                        "id": 122121,
                        "name": "Monterey County",
                        "latitude": "36.23977000",
                        "longitude": "-121.30890000"
                    },
                    {
                        "id": 122122,
                        "name": "Monterey Park",
                        "latitude": "34.06251000",
                        "longitude": "-118.12285000"
                    },
                    {
                        "id": 122193,
                        "name": "Monument Hills",
                        "latitude": "38.66429000",
                        "longitude": "-121.87566000"
                    },
                    {
                        "id": 122213,
                        "name": "Moorpark",
                        "latitude": "34.28556000",
                        "longitude": "-118.88204000"
                    },
                    {
                        "id": 122221,
                        "name": "Morada",
                        "latitude": "38.03853000",
                        "longitude": "-121.24578000"
                    },
                    {
                        "id": 122222,
                        "name": "Moraga",
                        "latitude": "37.83493000",
                        "longitude": "-122.12969000"
                    },
                    {
                        "id": 122231,
                        "name": "Moreno Valley",
                        "latitude": "33.93752000",
                        "longitude": "-117.23059000"
                    },
                    {
                        "id": 122246,
                        "name": "Morgan Hill",
                        "latitude": "37.13050000",
                        "longitude": "-121.65439000"
                    },
                    {
                        "id": 122261,
                        "name": "Morongo Valley",
                        "latitude": "34.04695000",
                        "longitude": "-116.58085000"
                    },
                    {
                        "id": 122288,
                        "name": "Morro Bay",
                        "latitude": "35.36581000",
                        "longitude": "-120.84990000"
                    },
                    {
                        "id": 122307,
                        "name": "Moss Beach",
                        "latitude": "37.52744000",
                        "longitude": "-122.51331000"
                    },
                    {
                        "id": 122347,
                        "name": "Mount Hermon",
                        "latitude": "37.05106000",
                        "longitude": "-122.05857000"
                    },
                    {
                        "id": 122388,
                        "name": "Mount Shasta",
                        "latitude": "41.31024000",
                        "longitude": "-122.31225000"
                    },
                    {
                        "id": 122418,
                        "name": "Mountain House",
                        "latitude": "37.78326000",
                        "longitude": "-121.54273000"
                    },
                    {
                        "id": 122425,
                        "name": "Mountain Ranch",
                        "latitude": "38.22825000",
                        "longitude": "-120.54076000"
                    },
                    {
                        "id": 122431,
                        "name": "Mountain View",
                        "latitude": "37.38605000",
                        "longitude": "-122.08385000"
                    },
                    {
                        "id": 122434,
                        "name": "Mountain View Acres",
                        "latitude": "34.49666000",
                        "longitude": "-117.34894000"
                    },
                    {
                        "id": 122488,
                        "name": "Murphys",
                        "latitude": "38.13762000",
                        "longitude": "-120.46105000"
                    },
                    {
                        "id": 122498,
                        "name": "Murrieta",
                        "latitude": "33.55391000",
                        "longitude": "-117.21392000"
                    },
                    {
                        "id": 122499,
                        "name": "Murrieta Hot Springs",
                        "latitude": "33.56058000",
                        "longitude": "-117.15809000"
                    },
                    {
                        "id": 122506,
                        "name": "Muscoy",
                        "latitude": "34.15418000",
                        "longitude": "-117.34421000"
                    },
                    {
                        "id": 122525,
                        "name": "Myrtletown",
                        "latitude": "40.78874000",
                        "longitude": "-124.13034000"
                    },
                    {
                        "id": 122546,
                        "name": "Napa",
                        "latitude": "38.29714000",
                        "longitude": "-122.28553000"
                    },
                    {
                        "id": 122547,
                        "name": "Napa County",
                        "latitude": "38.50647000",
                        "longitude": "-122.33053000"
                    },
                    {
                        "id": 122591,
                        "name": "National City",
                        "latitude": "32.67811000",
                        "longitude": "-117.09920000"
                    },
                    {
                        "id": 122614,
                        "name": "Needles",
                        "latitude": "34.84806000",
                        "longitude": "-114.61413000"
                    },
                    {
                        "id": 122651,
                        "name": "Nevada City",
                        "latitude": "39.26173000",
                        "longitude": "-121.01779000"
                    },
                    {
                        "id": 122653,
                        "name": "Nevada County",
                        "latitude": "39.30137000",
                        "longitude": "-120.76875000"
                    },
                    {
                        "id": 122805,
                        "name": "Newark",
                        "latitude": "37.52966000",
                        "longitude": "-122.04024000"
                    },
                    {
                        "id": 122821,
                        "name": "Newcastle",
                        "latitude": "38.87407000",
                        "longitude": "-121.13328000"
                    },
                    {
                        "id": 122834,
                        "name": "Newman",
                        "latitude": "37.31383000",
                        "longitude": "-121.02076000"
                    },
                    {
                        "id": 122853,
                        "name": "Newport Beach",
                        "latitude": "33.61891000",
                        "longitude": "-117.92895000"
                    },
                    {
                        "id": 122885,
                        "name": "Nice",
                        "latitude": "39.12323000",
                        "longitude": "-122.84833000"
                    },
                    {
                        "id": 122899,
                        "name": "Niland",
                        "latitude": "33.24004000",
                        "longitude": "-115.51888000"
                    },
                    {
                        "id": 122905,
                        "name": "Nipomo",
                        "latitude": "35.04275000",
                        "longitude": "-120.47600000"
                    },
                    {
                        "id": 122925,
                        "name": "Noe Valley",
                        "latitude": "37.75018000",
                        "longitude": "-122.43369000"
                    },
                    {
                        "id": 122939,
                        "name": "Norco",
                        "latitude": "33.93113000",
                        "longitude": "-117.54866000"
                    },
                    {
                        "id": 122968,
                        "name": "North Auburn",
                        "latitude": "38.93129000",
                        "longitude": "-121.08189000"
                    },
                    {
                        "id": 123020,
                        "name": "North Edwards",
                        "latitude": "35.01664000",
                        "longitude": "-117.83284000"
                    },
                    {
                        "id": 123021,
                        "name": "North El Monte",
                        "latitude": "34.10279000",
                        "longitude": "-118.02423000"
                    },
                    {
                        "id": 123024,
                        "name": "North Fair Oaks",
                        "latitude": "37.47438000",
                        "longitude": "-122.19663000"
                    },
                    {
                        "id": 123039,
                        "name": "North Highlands",
                        "latitude": "38.68574000",
                        "longitude": "-121.37217000"
                    },
                    {
                        "id": 123041,
                        "name": "North Hills",
                        "latitude": "34.23639000",
                        "longitude": "-118.48472000"
                    },
                    {
                        "id": 123042,
                        "name": "North Hollywood",
                        "latitude": "34.17223000",
                        "longitude": "-118.37897000"
                    },
                    {
                        "id": 123050,
                        "name": "North Lakeport",
                        "latitude": "39.08831000",
                        "longitude": "-122.90538000"
                    },
                    {
                        "id": 123094,
                        "name": "North Richmond",
                        "latitude": "37.95881000",
                        "longitude": "-122.36747000"
                    },
                    {
                        "id": 123117,
                        "name": "North Tustin",
                        "latitude": "33.76446000",
                        "longitude": "-117.79394000"
                    },
                    {
                        "id": 123163,
                        "name": "Northridge",
                        "latitude": "34.22834000",
                        "longitude": "-118.53675000"
                    },
                    {
                        "id": 123191,
                        "name": "Norwalk",
                        "latitude": "33.90224000",
                        "longitude": "-118.08173000"
                    },
                    {
                        "id": 123207,
                        "name": "Novato",
                        "latitude": "38.10742000",
                        "longitude": "-122.56970000"
                    },
                    {
                        "id": 123216,
                        "name": "Nuevo",
                        "latitude": "33.80141000",
                        "longitude": "-117.14587000"
                    },
                    {
                        "id": 123248,
                        "name": "Oak Hills",
                        "latitude": "34.38313000",
                        "longitude": "-117.38135000"
                    },
                    {
                        "id": 123257,
                        "name": "Oak Park",
                        "latitude": "34.17917000",
                        "longitude": "-118.76287000"
                    },
                    {
                        "id": 123266,
                        "name": "Oak View",
                        "latitude": "34.40000000",
                        "longitude": "-119.30011000"
                    },
                    {
                        "id": 123274,
                        "name": "Oakdale",
                        "latitude": "37.76659000",
                        "longitude": "-120.84715000"
                    },
                    {
                        "id": 123281,
                        "name": "Oakhurst",
                        "latitude": "37.32800000",
                        "longitude": "-119.64932000"
                    },
                    {
                        "id": 123293,
                        "name": "Oakland",
                        "latitude": "37.80437000",
                        "longitude": "-122.27080000"
                    },
                    {
                        "id": 123298,
                        "name": "Oakley",
                        "latitude": "37.99742000",
                        "longitude": "-121.71245000"
                    },
                    {
                        "id": 123313,
                        "name": "Oasis",
                        "latitude": "33.46586000",
                        "longitude": "-116.09889000"
                    },
                    {
                        "id": 123321,
                        "name": "Occidental",
                        "latitude": "38.40741000",
                        "longitude": "-122.94833000"
                    },
                    {
                        "id": 123341,
                        "name": "Oceano",
                        "latitude": "35.09886000",
                        "longitude": "-120.61239000"
                    },
                    {
                        "id": 123344,
                        "name": "Oceanside",
                        "latitude": "33.19587000",
                        "longitude": "-117.37948000"
                    },
                    {
                        "id": 123388,
                        "name": "Oildale",
                        "latitude": "35.41968000",
                        "longitude": "-119.01955000"
                    },
                    {
                        "id": 123390,
                        "name": "Ojai",
                        "latitude": "34.44805000",
                        "longitude": "-119.24289000"
                    },
                    {
                        "id": 123418,
                        "name": "Old Fig Garden",
                        "latitude": "36.79885000",
                        "longitude": "-119.80515000"
                    },
                    {
                        "id": 123441,
                        "name": "Olivehurst",
                        "latitude": "39.09545000",
                        "longitude": "-121.55219000"
                    },
                    {
                        "id": 123486,
                        "name": "Ontario",
                        "latitude": "34.06334000",
                        "longitude": "-117.65089000"
                    },
                    {
                        "id": 123495,
                        "name": "Opal Cliffs",
                        "latitude": "36.96078000",
                        "longitude": "-121.96413000"
                    },
                    {
                        "id": 123510,
                        "name": "Orange",
                        "latitude": "33.78779000",
                        "longitude": "-117.85311000"
                    },
                    {
                        "id": 123521,
                        "name": "Orange County",
                        "latitude": "33.67691000",
                        "longitude": "-117.77617000"
                    },
                    {
                        "id": 123522,
                        "name": "Orange Cove",
                        "latitude": "36.62439000",
                        "longitude": "-119.31373000"
                    },
                    {
                        "id": 123530,
                        "name": "Orangevale",
                        "latitude": "38.67851000",
                        "longitude": "-121.22578000"
                    },
                    {
                        "id": 123541,
                        "name": "Orcutt",
                        "latitude": "34.86526000",
                        "longitude": "-120.43600000"
                    },
                    {
                        "id": 123554,
                        "name": "Orinda",
                        "latitude": "37.87715000",
                        "longitude": "-122.17969000"
                    },
                    {
                        "id": 123559,
                        "name": "Orland",
                        "latitude": "39.74738000",
                        "longitude": "-122.19637000"
                    },
                    {
                        "id": 123577,
                        "name": "Orosi",
                        "latitude": "36.54495000",
                        "longitude": "-119.28734000"
                    },
                    {
                        "id": 123578,
                        "name": "Oroville",
                        "latitude": "39.51394000",
                        "longitude": "-121.55776000"
                    },
                    {
                        "id": 123580,
                        "name": "Oroville East",
                        "latitude": "39.51126000",
                        "longitude": "-121.47519000"
                    },
                    {
                        "id": 123689,
                        "name": "Oxnard",
                        "latitude": "34.19750000",
                        "longitude": "-119.17705000"
                    },
                    {
                        "id": 123705,
                        "name": "Pacheco",
                        "latitude": "37.98353000",
                        "longitude": "-122.07524000"
                    },
                    {
                        "id": 123710,
                        "name": "Pacific Grove",
                        "latitude": "36.61774000",
                        "longitude": "-121.91662000"
                    },
                    {
                        "id": 123711,
                        "name": "Pacifica",
                        "latitude": "37.61383000",
                        "longitude": "-122.48692000"
                    },
                    {
                        "id": 123729,
                        "name": "Pajaro",
                        "latitude": "36.90412000",
                        "longitude": "-121.74856000"
                    },
                    {
                        "id": 123735,
                        "name": "Palermo",
                        "latitude": "39.43544000",
                        "longitude": "-121.53802000"
                    },
                    {
                        "id": 123748,
                        "name": "Palm Desert",
                        "latitude": "33.72255000",
                        "longitude": "-116.37697000"
                    },
                    {
                        "id": 123752,
                        "name": "Palm Springs",
                        "latitude": "33.83030000",
                        "longitude": "-116.54529000"
                    },
                    {
                        "id": 123757,
                        "name": "Palmdale",
                        "latitude": "34.57943000",
                        "longitude": "-118.11646000"
                    },
                    {
                        "id": 123781,
                        "name": "Palo Alto",
                        "latitude": "37.44188000",
                        "longitude": "-122.14302000"
                    },
                    {
                        "id": 123783,
                        "name": "Palo Cedro",
                        "latitude": "40.56376000",
                        "longitude": "-122.23889000"
                    },
                    {
                        "id": 123791,
                        "name": "Palos Verdes Estates",
                        "latitude": "33.80105000",
                        "longitude": "-118.39245000"
                    },
                    {
                        "id": 123818,
                        "name": "Paradise",
                        "latitude": "39.75961000",
                        "longitude": "-121.62192000"
                    },
                    {
                        "id": 123824,
                        "name": "Paramount",
                        "latitude": "33.88946000",
                        "longitude": "-118.15979000"
                    },
                    {
                        "id": 123874,
                        "name": "Parksdale",
                        "latitude": "36.94717000",
                        "longitude": "-120.02294000"
                    },
                    {
                        "id": 123881,
                        "name": "Parkway",
                        "latitude": "38.49602000",
                        "longitude": "-121.45884000"
                    },
                    {
                        "id": 123882,
                        "name": "Parkwood",
                        "latitude": "36.92689000",
                        "longitude": "-120.04461000"
                    },
                    {
                        "id": 123884,
                        "name": "Parlier",
                        "latitude": "36.61162000",
                        "longitude": "-119.52707000"
                    },
                    {
                        "id": 123897,
                        "name": "Pasadena",
                        "latitude": "34.14778000",
                        "longitude": "-118.14452000"
                    },
                    {
                        "id": 123899,
                        "name": "Pasatiempo",
                        "latitude": "37.00439000",
                        "longitude": "-122.02580000"
                    },
                    {
                        "id": 123904,
                        "name": "Paso Robles",
                        "latitude": "35.62664000",
                        "longitude": "-120.69100000"
                    },
                    {
                        "id": 123916,
                        "name": "Patterson",
                        "latitude": "37.47160000",
                        "longitude": "-121.12966000"
                    },
                    {
                        "id": 123917,
                        "name": "Patterson Tract",
                        "latitude": "36.37952000",
                        "longitude": "-119.29560000"
                    },
                    {
                        "id": 123983,
                        "name": "Pedley",
                        "latitude": "33.97529000",
                        "longitude": "-117.47588000"
                    },
                    {
                        "id": 124024,
                        "name": "Penn Valley",
                        "latitude": "39.19600000",
                        "longitude": "-121.19107000"
                    },
                    {
                        "id": 124028,
                        "name": "Penngrove",
                        "latitude": "38.29964000",
                        "longitude": "-122.66665000"
                    },
                    {
                        "id": 124066,
                        "name": "Perris",
                        "latitude": "33.78252000",
                        "longitude": "-117.22865000"
                    },
                    {
                        "id": 124101,
                        "name": "Petaluma",
                        "latitude": "38.23242000",
                        "longitude": "-122.63665000"
                    },
                    {
                        "id": 124119,
                        "name": "Phelan",
                        "latitude": "34.42611000",
                        "longitude": "-117.57228000"
                    },
                    {
                        "id": 124150,
                        "name": "Phoenix Lake",
                        "latitude": "38.00594000",
                        "longitude": "-120.30702000"
                    },
                    {
                        "id": 124162,
                        "name": "Pico Rivera",
                        "latitude": "33.98307000",
                        "longitude": "-118.09673000"
                    },
                    {
                        "id": 124168,
                        "name": "Piedmont",
                        "latitude": "37.82437000",
                        "longitude": "-122.23163000"
                    },
                    {
                        "id": 124222,
                        "name": "Pine Grove",
                        "latitude": "38.41297000",
                        "longitude": "-120.65882000"
                    },
                    {
                        "id": 124226,
                        "name": "Pine Hills",
                        "latitude": "40.73318000",
                        "longitude": "-124.15228000"
                    },
                    {
                        "id": 124239,
                        "name": "Pine Mountain Club",
                        "latitude": "34.84637000",
                        "longitude": "-119.14955000"
                    },
                    {
                        "id": 124246,
                        "name": "Pine Valley",
                        "latitude": "32.82144000",
                        "longitude": "-116.52918000"
                    },
                    {
                        "id": 124271,
                        "name": "Pinole",
                        "latitude": "38.00437000",
                        "longitude": "-122.29886000"
                    },
                    {
                        "id": 124309,
                        "name": "Piñon Hills",
                        "latitude": "34.43333000",
                        "longitude": "-117.64672000"
                    },
                    {
                        "id": 124274,
                        "name": "Pioneer",
                        "latitude": "38.43186000",
                        "longitude": "-120.57187000"
                    },
                    {
                        "id": 124280,
                        "name": "Piru",
                        "latitude": "34.41527000",
                        "longitude": "-118.79398000"
                    },
                    {
                        "id": 124283,
                        "name": "Pismo Beach",
                        "latitude": "35.14275000",
                        "longitude": "-120.64128000"
                    },
                    {
                        "id": 124294,
                        "name": "Pittsburg",
                        "latitude": "38.02798000",
                        "longitude": "-121.88468000"
                    },
                    {
                        "id": 124308,
                        "name": "Pixley",
                        "latitude": "35.96856000",
                        "longitude": "-119.29178000"
                    },
                    {
                        "id": 124310,
                        "name": "Placentia",
                        "latitude": "33.87224000",
                        "longitude": "-117.87034000"
                    },
                    {
                        "id": 124311,
                        "name": "Placer County",
                        "latitude": "39.06343000",
                        "longitude": "-120.71766000"
                    },
                    {
                        "id": 124312,
                        "name": "Placerville",
                        "latitude": "38.72963000",
                        "longitude": "-120.79855000"
                    },
                    {
                        "id": 124338,
                        "name": "Planada",
                        "latitude": "37.29077000",
                        "longitude": "-120.31852000"
                    },
                    {
                        "id": 124372,
                        "name": "Pleasant Hill",
                        "latitude": "37.94798000",
                        "longitude": "-122.06080000"
                    },
                    {
                        "id": 124384,
                        "name": "Pleasanton",
                        "latitude": "37.66243000",
                        "longitude": "-121.87468000"
                    },
                    {
                        "id": 124395,
                        "name": "Plumas County",
                        "latitude": "40.00468000",
                        "longitude": "-120.83860000"
                    },
                    {
                        "id": 124396,
                        "name": "Plumas Lake",
                        "latitude": "39.02073000",
                        "longitude": "-121.55802000"
                    },
                    {
                        "id": 124453,
                        "name": "Pollock Pines",
                        "latitude": "38.76158000",
                        "longitude": "-120.58611000"
                    },
                    {
                        "id": 124459,
                        "name": "Pomona",
                        "latitude": "34.05529000",
                        "longitude": "-117.75228000"
                    },
                    {
                        "id": 124486,
                        "name": "Poplar-Cotton Center",
                        "latitude": "36.05635000",
                        "longitude": "-119.14919000"
                    },
                    {
                        "id": 124510,
                        "name": "Port Hueneme",
                        "latitude": "34.14778000",
                        "longitude": "-119.19511000"
                    },
                    {
                        "id": 124556,
                        "name": "Porterville",
                        "latitude": "36.06523000",
                        "longitude": "-119.01677000"
                    },
                    {
                        "id": 124566,
                        "name": "Portola",
                        "latitude": "39.81046000",
                        "longitude": "-120.46910000"
                    },
                    {
                        "id": 124567,
                        "name": "Portola Hills",
                        "latitude": "33.67919000",
                        "longitude": "-117.63116000"
                    },
                    {
                        "id": 124568,
                        "name": "Portola Valley",
                        "latitude": "37.38411000",
                        "longitude": "-122.23524000"
                    },
                    {
                        "id": 124606,
                        "name": "Poway",
                        "latitude": "32.96282000",
                        "longitude": "-117.03586000"
                    },
                    {
                        "id": 124725,
                        "name": "Prunedale",
                        "latitude": "36.77579000",
                        "longitude": "-121.66967000"
                    },
                    {
                        "id": 124777,
                        "name": "Quail Valley",
                        "latitude": "33.70697000",
                        "longitude": "-117.24504000"
                    },
                    {
                        "id": 124782,
                        "name": "Quartz Hill",
                        "latitude": "34.64526000",
                        "longitude": "-118.21813000"
                    },
                    {
                        "id": 124799,
                        "name": "Quincy",
                        "latitude": "39.93682000",
                        "longitude": "-120.94647000"
                    },
                    {
                        "id": 124823,
                        "name": "Rainbow",
                        "latitude": "33.41031000",
                        "longitude": "-117.14781000"
                    },
                    {
                        "id": 124838,
                        "name": "Ramona",
                        "latitude": "33.04171000",
                        "longitude": "-116.86808000"
                    },
                    {
                        "id": 124848,
                        "name": "Rancho Calaveras",
                        "latitude": "38.12742000",
                        "longitude": "-120.85827000"
                    },
                    {
                        "id": 124849,
                        "name": "Rancho Cordova",
                        "latitude": "38.58907000",
                        "longitude": "-121.30273000"
                    },
                    {
                        "id": 124850,
                        "name": "Rancho Cucamonga",
                        "latitude": "34.10640000",
                        "longitude": "-117.59311000"
                    },
                    {
                        "id": 124851,
                        "name": "Rancho Mirage",
                        "latitude": "33.73974000",
                        "longitude": "-116.41279000"
                    },
                    {
                        "id": 124852,
                        "name": "Rancho Murieta",
                        "latitude": "38.50185000",
                        "longitude": "-121.09467000"
                    },
                    {
                        "id": 124853,
                        "name": "Rancho Palos Verdes",
                        "latitude": "33.74446000",
                        "longitude": "-118.38702000"
                    },
                    {
                        "id": 124854,
                        "name": "Rancho Penasquitos",
                        "latitude": "32.95949000",
                        "longitude": "-117.11531000"
                    },
                    {
                        "id": 124855,
                        "name": "Rancho San Diego",
                        "latitude": "32.74727000",
                        "longitude": "-116.93530000"
                    },
                    {
                        "id": 124856,
                        "name": "Rancho Santa Fe",
                        "latitude": "33.02032000",
                        "longitude": "-117.20281000"
                    },
                    {
                        "id": 124857,
                        "name": "Rancho Santa Margarita",
                        "latitude": "33.64086000",
                        "longitude": "-117.60310000"
                    },
                    {
                        "id": 124858,
                        "name": "Rancho Tehama Reserve",
                        "latitude": "40.01569000",
                        "longitude": "-122.40072000"
                    },
                    {
                        "id": 124940,
                        "name": "Red Bluff",
                        "latitude": "40.17849000",
                        "longitude": "-122.23583000"
                    },
                    {
                        "id": 124945,
                        "name": "Red Corral",
                        "latitude": "38.41165000",
                        "longitude": "-120.60552000"
                    },
                    {
                        "id": 124966,
                        "name": "Redding",
                        "latitude": "40.58654000",
                        "longitude": "-122.39168000"
                    },
                    {
                        "id": 124976,
                        "name": "Redlands",
                        "latitude": "34.05557000",
                        "longitude": "-117.18254000"
                    },
                    {
                        "id": 124980,
                        "name": "Redondo Beach",
                        "latitude": "33.84918000",
                        "longitude": "-118.38841000"
                    },
                    {
                        "id": 124983,
                        "name": "Redway",
                        "latitude": "40.12014000",
                        "longitude": "-123.82336000"
                    },
                    {
                        "id": 124986,
                        "name": "Redwood City",
                        "latitude": "37.48522000",
                        "longitude": "-122.23635000"
                    },
                    {
                        "id": 124989,
                        "name": "Redwood Shores",
                        "latitude": "37.53188000",
                        "longitude": "-122.24802000"
                    },
                    {
                        "id": 124990,
                        "name": "Redwood Valley",
                        "latitude": "39.26544000",
                        "longitude": "-123.20445000"
                    },
                    {
                        "id": 124993,
                        "name": "Reedley",
                        "latitude": "36.59634000",
                        "longitude": "-119.45040000"
                    },
                    {
                        "id": 125049,
                        "name": "Rialto",
                        "latitude": "34.10640000",
                        "longitude": "-117.37032000"
                    },
                    {
                        "id": 125066,
                        "name": "Richgrove",
                        "latitude": "35.79662000",
                        "longitude": "-119.10788000"
                    },
                    {
                        "id": 125096,
                        "name": "Richmond",
                        "latitude": "37.93576000",
                        "longitude": "-122.34775000"
                    },
                    {
                        "id": 125118,
                        "name": "Ridgecrest",
                        "latitude": "35.62246000",
                        "longitude": "-117.67090000"
                    },
                    {
                        "id": 125127,
                        "name": "Ridgemark",
                        "latitude": "36.81246000",
                        "longitude": "-121.36577000"
                    },
                    {
                        "id": 125151,
                        "name": "Rio Del Mar",
                        "latitude": "36.96828000",
                        "longitude": "-121.90023000"
                    },
                    {
                        "id": 125152,
                        "name": "Rio Dell",
                        "latitude": "40.49930000",
                        "longitude": "-124.10644000"
                    },
                    {
                        "id": 125157,
                        "name": "Rio Linda",
                        "latitude": "38.69101000",
                        "longitude": "-121.44857000"
                    },
                    {
                        "id": 125161,
                        "name": "Rio Vista",
                        "latitude": "38.16389000",
                        "longitude": "-121.69583000"
                    },
                    {
                        "id": 125168,
                        "name": "Ripon",
                        "latitude": "37.74159000",
                        "longitude": "-121.12438000"
                    },
                    {
                        "id": 125190,
                        "name": "Riverbank",
                        "latitude": "37.73604000",
                        "longitude": "-120.93549000"
                    },
                    {
                        "id": 125196,
                        "name": "Riverdale",
                        "latitude": "36.43106000",
                        "longitude": "-119.85958000"
                    },
                    {
                        "id": 125199,
                        "name": "Riverdale Park",
                        "latitude": "37.60938000",
                        "longitude": "-121.05188000"
                    },
                    {
                        "id": 125209,
                        "name": "Riverside",
                        "latitude": "33.95335000",
                        "longitude": "-117.39616000"
                    },
                    {
                        "id": 125210,
                        "name": "Riverside County",
                        "latitude": "33.74368000",
                        "longitude": "-115.99386000"
                    },
                    {
                        "id": 125313,
                        "name": "Rocklin",
                        "latitude": "38.79073000",
                        "longitude": "-121.23578000"
                    },
                    {
                        "id": 125341,
                        "name": "Rodeo",
                        "latitude": "38.03298000",
                        "longitude": "-122.26691000"
                    },
                    {
                        "id": 125358,
                        "name": "Rohnert Park",
                        "latitude": "38.33964000",
                        "longitude": "-122.70110000"
                    },
                    {
                        "id": 125366,
                        "name": "Rolling Hills",
                        "latitude": "33.75739000",
                        "longitude": "-118.35752000"
                    },
                    {
                        "id": 125367,
                        "name": "Rolling Hills Estates",
                        "latitude": "33.78779000",
                        "longitude": "-118.35813000"
                    },
                    {
                        "id": 125370,
                        "name": "Rollingwood",
                        "latitude": "37.96520000",
                        "longitude": "-122.32997000"
                    },
                    {
                        "id": 125384,
                        "name": "Romoland",
                        "latitude": "33.74585000",
                        "longitude": "-117.17503000"
                    },
                    {
                        "id": 125397,
                        "name": "Rosamond",
                        "latitude": "34.86414000",
                        "longitude": "-118.16341000"
                    },
                    {
                        "id": 125419,
                        "name": "Rosedale",
                        "latitude": "35.38357000",
                        "longitude": "-119.14538000"
                    },
                    {
                        "id": 125424,
                        "name": "Roseland",
                        "latitude": "38.42213000",
                        "longitude": "-122.72804000"
                    },
                    {
                        "id": 125429,
                        "name": "Rosemead",
                        "latitude": "34.08057000",
                        "longitude": "-118.07285000"
                    },
                    {
                        "id": 125431,
                        "name": "Rosemont",
                        "latitude": "38.55185000",
                        "longitude": "-121.36467000"
                    },
                    {
                        "id": 125441,
                        "name": "Roseville",
                        "latitude": "38.75212000",
                        "longitude": "-121.28801000"
                    },
                    {
                        "id": 125451,
                        "name": "Ross",
                        "latitude": "37.96242000",
                        "longitude": "-122.55498000"
                    },
                    {
                        "id": 125455,
                        "name": "Rossmoor",
                        "latitude": "33.78557000",
                        "longitude": "-118.08506000"
                    },
                    {
                        "id": 125480,
                        "name": "Rowland Heights",
                        "latitude": "33.97612000",
                        "longitude": "-117.90534000"
                    },
                    {
                        "id": 125501,
                        "name": "Rubidoux",
                        "latitude": "33.99613000",
                        "longitude": "-117.40560000"
                    },
                    {
                        "id": 125514,
                        "name": "Running Springs",
                        "latitude": "34.20779000",
                        "longitude": "-117.10920000"
                    },
                    {
                        "id": 125577,
                        "name": "Sacramento",
                        "latitude": "38.58157000",
                        "longitude": "-121.49440000"
                    },
                    {
                        "id": 125578,
                        "name": "Sacramento County",
                        "latitude": "38.44932000",
                        "longitude": "-121.34424000"
                    },
                    {
                        "id": 125647,
                        "name": "Saint Helena",
                        "latitude": "38.50519000",
                        "longitude": "-122.47026000"
                    },
                    {
                        "id": 125742,
                        "name": "Salida",
                        "latitude": "37.70576000",
                        "longitude": "-121.08494000"
                    },
                    {
                        "id": 125747,
                        "name": "Salinas",
                        "latitude": "36.67774000",
                        "longitude": "-121.65550000"
                    },
                    {
                        "id": 125770,
                        "name": "Salton City",
                        "latitude": "33.29865000",
                        "longitude": "-115.95611000"
                    },
                    {
                        "id": 125783,
                        "name": "San Andreas",
                        "latitude": "38.19603000",
                        "longitude": "-120.68049000"
                    },
                    {
                        "id": 125785,
                        "name": "San Anselmo",
                        "latitude": "37.97465000",
                        "longitude": "-122.56164000"
                    },
                    {
                        "id": 125788,
                        "name": "San Antonio Heights",
                        "latitude": "34.15556000",
                        "longitude": "-117.65644000"
                    },
                    {
                        "id": 125792,
                        "name": "San Benito County",
                        "latitude": "36.60571000",
                        "longitude": "-121.07500000"
                    },
                    {
                        "id": 125793,
                        "name": "San Bernardino",
                        "latitude": "34.10834000",
                        "longitude": "-117.28977000"
                    },
                    {
                        "id": 125794,
                        "name": "San Bernardino County",
                        "latitude": "34.84143000",
                        "longitude": "-116.17846000"
                    },
                    {
                        "id": 125795,
                        "name": "San Bruno",
                        "latitude": "37.63049000",
                        "longitude": "-122.41108000"
                    },
                    {
                        "id": 125798,
                        "name": "San Carlos",
                        "latitude": "37.50716000",
                        "longitude": "-122.26052000"
                    },
                    {
                        "id": 125800,
                        "name": "San Clemente",
                        "latitude": "33.42697000",
                        "longitude": "-117.61199000"
                    },
                    {
                        "id": 125802,
                        "name": "San Diego",
                        "latitude": "32.71571000",
                        "longitude": "-117.16472000"
                    },
                    {
                        "id": 125803,
                        "name": "San Diego Country Estates",
                        "latitude": "33.00671000",
                        "longitude": "-116.78364000"
                    },
                    {
                        "id": 125804,
                        "name": "San Diego County",
                        "latitude": "33.02820000",
                        "longitude": "-116.77021000"
                    },
                    {
                        "id": 125805,
                        "name": "San Dimas",
                        "latitude": "34.10668000",
                        "longitude": "-117.80673000"
                    },
                    {
                        "id": 125808,
                        "name": "San Fernando",
                        "latitude": "34.28195000",
                        "longitude": "-118.43897000"
                    },
                    {
                        "id": 125809,
                        "name": "San Francisco",
                        "latitude": "37.77493000",
                        "longitude": "-122.41942000"
                    },
                    {
                        "id": 125810,
                        "name": "San Gabriel",
                        "latitude": "34.09611000",
                        "longitude": "-118.10583000"
                    },
                    {
                        "id": 125811,
                        "name": "San Jacinto",
                        "latitude": "33.78391000",
                        "longitude": "-116.95864000"
                    },
                    {
                        "id": 125813,
                        "name": "San Joaquin",
                        "latitude": "36.60662000",
                        "longitude": "-120.18904000"
                    },
                    {
                        "id": 125814,
                        "name": "San Joaquin County",
                        "latitude": "37.93478000",
                        "longitude": "-121.27145000"
                    },
                    {
                        "id": 125815,
                        "name": "San Joaquin Hills",
                        "latitude": "33.61169000",
                        "longitude": "-117.83672000"
                    },
                    {
                        "id": 125816,
                        "name": "San Jose",
                        "latitude": "37.33939000",
                        "longitude": "-121.89496000"
                    },
                    {
                        "id": 125818,
                        "name": "San Juan Bautista",
                        "latitude": "36.84551000",
                        "longitude": "-121.53800000"
                    },
                    {
                        "id": 125819,
                        "name": "San Juan Capistrano",
                        "latitude": "33.50169000",
                        "longitude": "-117.66255000"
                    },
                    {
                        "id": 125824,
                        "name": "San Leandro",
                        "latitude": "37.72493000",
                        "longitude": "-122.15608000"
                    },
                    {
                        "id": 125826,
                        "name": "San Lorenzo",
                        "latitude": "37.68104000",
                        "longitude": "-122.12441000"
                    },
                    {
                        "id": 125829,
                        "name": "San Luis Obispo",
                        "latitude": "35.28275000",
                        "longitude": "-120.65962000"
                    },
                    {
                        "id": 125830,
                        "name": "San Luis Obispo County",
                        "latitude": "35.38742000",
                        "longitude": "-120.45220000"
                    },
                    {
                        "id": 125833,
                        "name": "San Marcos",
                        "latitude": "33.14337000",
                        "longitude": "-117.16614000"
                    },
                    {
                        "id": 125834,
                        "name": "San Marino",
                        "latitude": "34.12140000",
                        "longitude": "-118.10646000"
                    },
                    {
                        "id": 125835,
                        "name": "San Martin",
                        "latitude": "37.08495000",
                        "longitude": "-121.61022000"
                    },
                    {
                        "id": 125836,
                        "name": "San Mateo",
                        "latitude": "37.56299000",
                        "longitude": "-122.32553000"
                    },
                    {
                        "id": 125837,
                        "name": "San Mateo County",
                        "latitude": "37.43621000",
                        "longitude": "-122.35566000"
                    },
                    {
                        "id": 125838,
                        "name": "San Miguel",
                        "latitude": "35.75247000",
                        "longitude": "-120.69628000"
                    },
                    {
                        "id": 125842,
                        "name": "San Pablo",
                        "latitude": "37.96215000",
                        "longitude": "-122.34553000"
                    },
                    {
                        "id": 125843,
                        "name": "San Pasqual",
                        "latitude": "33.09171000",
                        "longitude": "-116.95392000"
                    },
                    {
                        "id": 125845,
                        "name": "San Pedro",
                        "latitude": "33.73585000",
                        "longitude": "-118.29229000"
                    },
                    {
                        "id": 125846,
                        "name": "San Rafael",
                        "latitude": "37.97353000",
                        "longitude": "-122.53109000"
                    },
                    {
                        "id": 125847,
                        "name": "San Ramon",
                        "latitude": "37.77993000",
                        "longitude": "-121.97802000"
                    },
                    {
                        "id": 125892,
                        "name": "Sanger",
                        "latitude": "36.70801000",
                        "longitude": "-119.55597000"
                    },
                    {
                        "id": 125899,
                        "name": "Santa Ana",
                        "latitude": "33.74557000",
                        "longitude": "-117.86783000"
                    },
                    {
                        "id": 125901,
                        "name": "Santa Barbara",
                        "latitude": "34.42083000",
                        "longitude": "-119.69819000"
                    },
                    {
                        "id": 125902,
                        "name": "Santa Barbara County",
                        "latitude": "34.53834000",
                        "longitude": "-120.03078000"
                    },
                    {
                        "id": 125903,
                        "name": "Santa Clara",
                        "latitude": "37.35411000",
                        "longitude": "-121.95524000"
                    },
                    {
                        "id": 125906,
                        "name": "Santa Clara County",
                        "latitude": "37.23249000",
                        "longitude": "-121.69627000"
                    },
                    {
                        "id": 125908,
                        "name": "Santa Clarita",
                        "latitude": "34.39166000",
                        "longitude": "-118.54259000"
                    },
                    {
                        "id": 125910,
                        "name": "Santa Cruz",
                        "latitude": "36.97412000",
                        "longitude": "-122.03080000"
                    },
                    {
                        "id": 125912,
                        "name": "Santa Cruz County",
                        "latitude": "37.02161000",
                        "longitude": "-122.00979000"
                    },
                    {
                        "id": 125916,
                        "name": "Santa Fe Springs",
                        "latitude": "33.94724000",
                        "longitude": "-118.08535000"
                    },
                    {
                        "id": 125917,
                        "name": "Santa Margarita",
                        "latitude": "35.38997000",
                        "longitude": "-120.60906000"
                    },
                    {
                        "id": 125918,
                        "name": "Santa Maria",
                        "latitude": "34.95303000",
                        "longitude": "-120.43572000"
                    },
                    {
                        "id": 125919,
                        "name": "Santa Monica",
                        "latitude": "34.01945000",
                        "longitude": "-118.49119000"
                    },
                    {
                        "id": 125920,
                        "name": "Santa Paula",
                        "latitude": "34.35417000",
                        "longitude": "-119.05927000"
                    },
                    {
                        "id": 125922,
                        "name": "Santa Rosa",
                        "latitude": "38.44047000",
                        "longitude": "-122.71443000"
                    },
                    {
                        "id": 125925,
                        "name": "Santa Susana",
                        "latitude": "34.27167000",
                        "longitude": "-118.70898000"
                    },
                    {
                        "id": 125927,
                        "name": "Santa Venetia",
                        "latitude": "37.99853000",
                        "longitude": "-122.52525000"
                    },
                    {
                        "id": 125928,
                        "name": "Santa Ynez",
                        "latitude": "34.61443000",
                        "longitude": "-120.07987000"
                    },
                    {
                        "id": 125930,
                        "name": "Santee",
                        "latitude": "32.83838000",
                        "longitude": "-116.97392000"
                    },
                    {
                        "id": 125937,
                        "name": "Saranap",
                        "latitude": "37.88492000",
                        "longitude": "-122.07607000"
                    },
                    {
                        "id": 125941,
                        "name": "Saratoga",
                        "latitude": "37.26383000",
                        "longitude": "-122.02301000"
                    },
                    {
                        "id": 125956,
                        "name": "Saticoy",
                        "latitude": "34.28306000",
                        "longitude": "-119.14983000"
                    },
                    {
                        "id": 125970,
                        "name": "Sausalito",
                        "latitude": "37.85909000",
                        "longitude": "-122.48525000"
                    },
                    {
                        "id": 126059,
                        "name": "Scotts Valley",
                        "latitude": "37.05106000",
                        "longitude": "-122.01468000"
                    },
                    {
                        "id": 126075,
                        "name": "Sea Ranch",
                        "latitude": "38.71519000",
                        "longitude": "-123.45445000"
                    },
                    {
                        "id": 126083,
                        "name": "Seacliff",
                        "latitude": "36.97412000",
                        "longitude": "-121.91579000"
                    },
                    {
                        "id": 126090,
                        "name": "Seal Beach",
                        "latitude": "33.74141000",
                        "longitude": "-118.10479000"
                    },
                    {
                        "id": 126095,
                        "name": "Searles Valley",
                        "latitude": "35.76745000",
                        "longitude": "-117.40395000"
                    },
                    {
                        "id": 126099,
                        "name": "Seaside",
                        "latitude": "36.61107000",
                        "longitude": "-121.85162000"
                    },
                    {
                        "id": 126108,
                        "name": "Sebastopol",
                        "latitude": "38.40214000",
                        "longitude": "-122.82388000"
                    },
                    {
                        "id": 126116,
                        "name": "Sedco Hills",
                        "latitude": "33.64169000",
                        "longitude": "-117.29087000"
                    },
                    {
                        "id": 126124,
                        "name": "Seeley",
                        "latitude": "32.79311000",
                        "longitude": "-115.69111000"
                    },
                    {
                        "id": 126141,
                        "name": "Selma",
                        "latitude": "36.57078000",
                        "longitude": "-119.61208000"
                    },
                    {
                        "id": 126176,
                        "name": "Seven Trees",
                        "latitude": "37.28605000",
                        "longitude": "-121.83856000"
                    },
                    {
                        "id": 126198,
                        "name": "Shackelford",
                        "latitude": "37.61382000",
                        "longitude": "-120.99271000"
                    },
                    {
                        "id": 126202,
                        "name": "Shadow Hills",
                        "latitude": "34.26195000",
                        "longitude": "-118.35175000"
                    },
                    {
                        "id": 126210,
                        "name": "Shafter",
                        "latitude": "35.50051000",
                        "longitude": "-119.27178000"
                    },
                    {
                        "id": 126217,
                        "name": "Shandon",
                        "latitude": "35.65525000",
                        "longitude": "-120.37543000"
                    },
                    {
                        "id": 126238,
                        "name": "Shasta",
                        "latitude": "40.59932000",
                        "longitude": "-122.49196000"
                    },
                    {
                        "id": 126239,
                        "name": "Shasta County",
                        "latitude": "40.76377000",
                        "longitude": "-122.04052000"
                    },
                    {
                        "id": 126240,
                        "name": "Shasta Lake",
                        "latitude": "40.68043000",
                        "longitude": "-122.37084000"
                    },
                    {
                        "id": 126321,
                        "name": "Sheridan",
                        "latitude": "38.97962000",
                        "longitude": "-121.37551000"
                    },
                    {
                        "id": 126336,
                        "name": "Sherman Oaks",
                        "latitude": "34.15112000",
                        "longitude": "-118.44925000"
                    },
                    {
                        "id": 126351,
                        "name": "Shingle Springs",
                        "latitude": "38.66574000",
                        "longitude": "-120.92605000"
                    },
                    {
                        "id": 126353,
                        "name": "Shingletown",
                        "latitude": "40.49238000",
                        "longitude": "-121.88916000"
                    },
                    {
                        "id": 126402,
                        "name": "Sierra County",
                        "latitude": "39.58040000",
                        "longitude": "-120.51600000"
                    },
                    {
                        "id": 126404,
                        "name": "Sierra Madre",
                        "latitude": "34.16167000",
                        "longitude": "-118.05285000"
                    },
                    {
                        "id": 126411,
                        "name": "Signal Hill",
                        "latitude": "33.80446000",
                        "longitude": "-118.16785000"
                    },
                    {
                        "id": 126431,
                        "name": "Silver Lake",
                        "latitude": "34.08668000",
                        "longitude": "-118.27023000"
                    },
                    {
                        "id": 126432,
                        "name": "Silver Lakes",
                        "latitude": "34.74558000",
                        "longitude": "-117.34098000"
                    },
                    {
                        "id": 126445,
                        "name": "Simi Valley",
                        "latitude": "34.26945000",
                        "longitude": "-118.78148000"
                    },
                    {
                        "id": 126465,
                        "name": "Siskiyou County",
                        "latitude": "41.59265000",
                        "longitude": "-122.54037000"
                    },
                    {
                        "id": 126486,
                        "name": "Sky Valley",
                        "latitude": "33.89001000",
                        "longitude": "-116.35251000"
                    },
                    {
                        "id": 126499,
                        "name": "Sleepy Hollow",
                        "latitude": "38.01048000",
                        "longitude": "-122.58442000"
                    },
                    {
                        "id": 126561,
                        "name": "Soda Bay",
                        "latitude": "39.00101000",
                        "longitude": "-122.78916000"
                    },
                    {
                        "id": 126565,
                        "name": "Solana Beach",
                        "latitude": "32.99115000",
                        "longitude": "-117.27115000"
                    },
                    {
                        "id": 126566,
                        "name": "Solano County",
                        "latitude": "38.26692000",
                        "longitude": "-121.94001000"
                    },
                    {
                        "id": 126568,
                        "name": "Soledad",
                        "latitude": "36.42469000",
                        "longitude": "-121.32632000"
                    },
                    {
                        "id": 126572,
                        "name": "Solvang",
                        "latitude": "34.59582000",
                        "longitude": "-120.13765000"
                    },
                    {
                        "id": 126598,
                        "name": "Sonoma",
                        "latitude": "38.29186000",
                        "longitude": "-122.45804000"
                    },
                    {
                        "id": 126599,
                        "name": "Sonoma County",
                        "latitude": "38.52529000",
                        "longitude": "-122.92254000"
                    },
                    {
                        "id": 126600,
                        "name": "Sonora",
                        "latitude": "37.98409000",
                        "longitude": "-120.38214000"
                    },
                    {
                        "id": 126604,
                        "name": "Soquel",
                        "latitude": "36.98801000",
                        "longitude": "-121.95663000"
                    },
                    {
                        "id": 126606,
                        "name": "Sorrento Valley",
                        "latitude": "32.89991000",
                        "longitude": "-117.19451000"
                    },
                    {
                        "id": 126608,
                        "name": "Soulsbyville",
                        "latitude": "37.98465000",
                        "longitude": "-120.26380000"
                    },
                    {
                        "id": 126648,
                        "name": "South Dos Palos",
                        "latitude": "36.96439000",
                        "longitude": "-120.65324000"
                    },
                    {
                        "id": 126650,
                        "name": "South El Monte",
                        "latitude": "34.05195000",
                        "longitude": "-118.04673000"
                    },
                    {
                        "id": 126659,
                        "name": "South Gate",
                        "latitude": "33.95474000",
                        "longitude": "-118.21202000"
                    },
                    {
                        "id": 126684,
                        "name": "South Lake Tahoe",
                        "latitude": "38.93324000",
                        "longitude": "-119.98435000"
                    },
                    {
                        "id": 126699,
                        "name": "South Oroville",
                        "latitude": "39.49655000",
                        "longitude": "-121.55219000"
                    },
                    {
                        "id": 126706,
                        "name": "South Pasadena",
                        "latitude": "34.11612000",
                        "longitude": "-118.15035000"
                    },
                    {
                        "id": 126723,
                        "name": "South San Francisco",
                        "latitude": "37.65466000",
                        "longitude": "-122.40775000"
                    },
                    {
                        "id": 126724,
                        "name": "South San Gabriel",
                        "latitude": "34.04915000",
                        "longitude": "-118.09462000"
                    },
                    {
                        "id": 126725,
                        "name": "South San Jose Hills",
                        "latitude": "34.01279000",
                        "longitude": "-117.90478000"
                    },
                    {
                        "id": 126733,
                        "name": "South Taft",
                        "latitude": "35.13469000",
                        "longitude": "-119.45623000"
                    },
                    {
                        "id": 126748,
                        "name": "South Whittier",
                        "latitude": "33.95015000",
                        "longitude": "-118.03917000"
                    },
                    {
                        "id": 126756,
                        "name": "South Yuba City",
                        "latitude": "39.11656000",
                        "longitude": "-121.63913000"
                    },
                    {
                        "id": 126880,
                        "name": "Spring Valley",
                        "latitude": "32.74477000",
                        "longitude": "-116.99892000"
                    },
                    {
                        "id": 126882,
                        "name": "Spring Valley Lake",
                        "latitude": "34.49364000",
                        "longitude": "-117.26832000"
                    },
                    {
                        "id": 126924,
                        "name": "Squaw Valley",
                        "latitude": "36.74023000",
                        "longitude": "-119.24679000"
                    },
                    {
                        "id": 126941,
                        "name": "Stallion Springs",
                        "latitude": "35.08886000",
                        "longitude": "-118.64259000"
                    },
                    {
                        "id": 126954,
                        "name": "Stanford",
                        "latitude": "37.42411000",
                        "longitude": "-122.16608000"
                    },
                    {
                        "id": 126957,
                        "name": "Stanislaus County",
                        "latitude": "37.55914000",
                        "longitude": "-120.99769000"
                    },
                    {
                        "id": 126969,
                        "name": "Stanton",
                        "latitude": "33.80252000",
                        "longitude": "-117.99312000"
                    },
                    {
                        "id": 127046,
                        "name": "Stevenson Ranch",
                        "latitude": "34.39048000",
                        "longitude": "-118.57372000"
                    },
                    {
                        "id": 127074,
                        "name": "Stockton",
                        "latitude": "37.95770000",
                        "longitude": "-121.29078000"
                    },
                    {
                        "id": 127127,
                        "name": "Stratford",
                        "latitude": "36.18940000",
                        "longitude": "-119.82319000"
                    },
                    {
                        "id": 127131,
                        "name": "Strathmore",
                        "latitude": "36.14551000",
                        "longitude": "-119.06066000"
                    },
                    {
                        "id": 127133,
                        "name": "Strawberry",
                        "latitude": "37.89687000",
                        "longitude": "-122.50886000"
                    },
                    {
                        "id": 127146,
                        "name": "Studio City",
                        "latitude": "34.14862000",
                        "longitude": "-118.39647000"
                    },
                    {
                        "id": 127177,
                        "name": "Suisun",
                        "latitude": "38.23825000",
                        "longitude": "-122.04024000"
                    },
                    {
                        "id": 127204,
                        "name": "Summerland",
                        "latitude": "34.42138000",
                        "longitude": "-119.59652000"
                    },
                    {
                        "id": 127233,
                        "name": "Sun City",
                        "latitude": "33.70919000",
                        "longitude": "-117.19726000"
                    },
                    {
                        "id": 127243,
                        "name": "Sun Village",
                        "latitude": "34.55952000",
                        "longitude": "-117.95676000"
                    },
                    {
                        "id": 127253,
                        "name": "Sunland",
                        "latitude": "34.26695000",
                        "longitude": "-118.30230000"
                    },
                    {
                        "id": 127259,
                        "name": "Sunnyside",
                        "latitude": "36.74912000",
                        "longitude": "-119.69931000"
                    },
                    {
                        "id": 127261,
                        "name": "Sunnyside-Tahoe City",
                        "latitude": "39.15023000",
                        "longitude": "-120.16120000"
                    },
                    {
                        "id": 127262,
                        "name": "Sunnyslope",
                        "latitude": "34.01196000",
                        "longitude": "-117.43338000"
                    },
                    {
                        "id": 127265,
                        "name": "Sunnyvale",
                        "latitude": "37.36883000",
                        "longitude": "-122.03635000"
                    },
                    {
                        "id": 127296,
                        "name": "Susanville",
                        "latitude": "40.41628000",
                        "longitude": "-120.65301000"
                    },
                    {
                        "id": 127308,
                        "name": "Sutter",
                        "latitude": "39.15989000",
                        "longitude": "-121.75275000"
                    },
                    {
                        "id": 127309,
                        "name": "Sutter County",
                        "latitude": "39.03452000",
                        "longitude": "-121.69484000"
                    },
                    {
                        "id": 127310,
                        "name": "Sutter Creek",
                        "latitude": "38.39297000",
                        "longitude": "-120.80244000"
                    },
                    {
                        "id": 127373,
                        "name": "Taft",
                        "latitude": "35.14247000",
                        "longitude": "-119.45651000"
                    },
                    {
                        "id": 127374,
                        "name": "Taft Heights",
                        "latitude": "35.13469000",
                        "longitude": "-119.47262000"
                    },
                    {
                        "id": 127375,
                        "name": "Taft Mosswood",
                        "latitude": "37.91385000",
                        "longitude": "-121.28316000"
                    },
                    {
                        "id": 127378,
                        "name": "Tahoe Vista",
                        "latitude": "39.23991000",
                        "longitude": "-120.05102000"
                    },
                    {
                        "id": 127380,
                        "name": "Tahoma",
                        "latitude": "39.06741000",
                        "longitude": "-120.12824000"
                    },
                    {
                        "id": 127397,
                        "name": "Talmage",
                        "latitude": "39.13323000",
                        "longitude": "-123.16778000"
                    },
                    {
                        "id": 127402,
                        "name": "Tamalpais Valley",
                        "latitude": "37.87965000",
                        "longitude": "-122.54581000"
                    },
                    {
                        "id": 127403,
                        "name": "Tamalpais-Homestead Valley",
                        "latitude": "37.87834000",
                        "longitude": "-122.53625000"
                    },
                    {
                        "id": 127427,
                        "name": "Tara Hills",
                        "latitude": "37.99353000",
                        "longitude": "-122.31636000"
                    },
                    {
                        "id": 127432,
                        "name": "Tarpey Village",
                        "latitude": "36.79301000",
                        "longitude": "-119.70097000"
                    },
                    {
                        "id": 127483,
                        "name": "Tehachapi",
                        "latitude": "35.13219000",
                        "longitude": "-118.44897000"
                    },
                    {
                        "id": 127484,
                        "name": "Tehama County",
                        "latitude": "40.12574000",
                        "longitude": "-122.23388000"
                    },
                    {
                        "id": 127492,
                        "name": "Temecula",
                        "latitude": "33.49364000",
                        "longitude": "-117.14836000"
                    },
                    {
                        "id": 127493,
                        "name": "Temelec",
                        "latitude": "38.26658000",
                        "longitude": "-122.49276000"
                    },
                    {
                        "id": 127501,
                        "name": "Temple City",
                        "latitude": "34.10723000",
                        "longitude": "-118.05785000"
                    },
                    {
                        "id": 127505,
                        "name": "Templeton",
                        "latitude": "35.54969000",
                        "longitude": "-120.70600000"
                    },
                    {
                        "id": 127515,
                        "name": "Terra Bella",
                        "latitude": "35.96245000",
                        "longitude": "-119.04427000"
                    },
                    {
                        "id": 127541,
                        "name": "Teviston",
                        "latitude": "35.92894000",
                        "longitude": "-119.27831000"
                    },
                    {
                        "id": 127570,
                        "name": "Thermal",
                        "latitude": "33.64030000",
                        "longitude": "-116.13945000"
                    },
                    {
                        "id": 127571,
                        "name": "Thermalito",
                        "latitude": "39.51128000",
                        "longitude": "-121.58692000"
                    },
                    {
                        "id": 127604,
                        "name": "Thornton",
                        "latitude": "38.22603000",
                        "longitude": "-121.42467000"
                    },
                    {
                        "id": 127609,
                        "name": "Thousand Oaks",
                        "latitude": "34.17056000",
                        "longitude": "-118.83759000"
                    },
                    {
                        "id": 127610,
                        "name": "Thousand Palms",
                        "latitude": "33.82002000",
                        "longitude": "-116.39029000"
                    },
                    {
                        "id": 127620,
                        "name": "Three Rivers",
                        "latitude": "36.43884000",
                        "longitude": "-118.90454000"
                    },
                    {
                        "id": 127632,
                        "name": "Tiburon",
                        "latitude": "37.87354000",
                        "longitude": "-122.45664000"
                    },
                    {
                        "id": 127637,
                        "name": "Tierra Buena",
                        "latitude": "39.14878000",
                        "longitude": "-121.66691000"
                    },
                    {
                        "id": 127678,
                        "name": "Tipton",
                        "latitude": "36.05940000",
                        "longitude": "-119.31206000"
                    },
                    {
                        "id": 127730,
                        "name": "Topanga",
                        "latitude": "34.09362000",
                        "longitude": "-118.60147000"
                    },
                    {
                        "id": 127741,
                        "name": "Toro Canyon",
                        "latitude": "34.42000000",
                        "longitude": "-119.56707000"
                    },
                    {
                        "id": 127742,
                        "name": "Torrance",
                        "latitude": "33.83585000",
                        "longitude": "-118.34063000"
                    },
                    {
                        "id": 127769,
                        "name": "Trabuco Canyon",
                        "latitude": "33.66252000",
                        "longitude": "-117.59033000"
                    },
                    {
                        "id": 127771,
                        "name": "Tracy",
                        "latitude": "37.73987000",
                        "longitude": "-121.42618000"
                    },
                    {
                        "id": 127829,
                        "name": "Trinity County",
                        "latitude": "40.65069000",
                        "longitude": "-123.11263000"
                    },
                    {
                        "id": 127853,
                        "name": "Truckee",
                        "latitude": "39.32796000",
                        "longitude": "-120.18325000"
                    },
                    {
                        "id": 127878,
                        "name": "Tujunga",
                        "latitude": "34.25223000",
                        "longitude": "-118.28841000"
                    },
                    {
                        "id": 127882,
                        "name": "Tulare",
                        "latitude": "36.20773000",
                        "longitude": "-119.34734000"
                    },
                    {
                        "id": 127883,
                        "name": "Tulare County",
                        "latitude": "36.22016000",
                        "longitude": "-118.80047000"
                    },
                    {
                        "id": 127895,
                        "name": "Tuolumne City",
                        "latitude": "37.96270000",
                        "longitude": "-120.24130000"
                    },
                    {
                        "id": 127896,
                        "name": "Tuolumne County",
                        "latitude": "38.02760000",
                        "longitude": "-119.95475000"
                    },
                    {
                        "id": 127900,
                        "name": "Turlock",
                        "latitude": "37.49466000",
                        "longitude": "-120.84659000"
                    },
                    {
                        "id": 127917,
                        "name": "Tustin",
                        "latitude": "33.74585000",
                        "longitude": "-117.82617000"
                    },
                    {
                        "id": 127920,
                        "name": "Twain Harte",
                        "latitude": "38.03965000",
                        "longitude": "-120.23269000"
                    },
                    {
                        "id": 127921,
                        "name": "Twentynine Palms",
                        "latitude": "34.13556000",
                        "longitude": "-116.05417000"
                    },
                    {
                        "id": 127930,
                        "name": "Twin Lakes",
                        "latitude": "36.96745000",
                        "longitude": "-121.99802000"
                    },
                    {
                        "id": 127958,
                        "name": "Ukiah",
                        "latitude": "39.15017000",
                        "longitude": "-123.20778000"
                    },
                    {
                        "id": 127987,
                        "name": "Union City",
                        "latitude": "37.59577000",
                        "longitude": "-122.01913000"
                    },
                    {
                        "id": 128023,
                        "name": "Universal City",
                        "latitude": "34.13890000",
                        "longitude": "-118.35341000"
                    },
                    {
                        "id": 128039,
                        "name": "Upland",
                        "latitude": "34.09751000",
                        "longitude": "-117.64839000"
                    },
                    {
                        "id": 128045,
                        "name": "Upper Lake",
                        "latitude": "39.16461000",
                        "longitude": "-122.91055000"
                    },
                    {
                        "id": 128072,
                        "name": "Vacaville",
                        "latitude": "38.35658000",
                        "longitude": "-121.98774000"
                    },
                    {
                        "id": 128078,
                        "name": "Val Verde",
                        "latitude": "34.44500000",
                        "longitude": "-118.65759000"
                    },
                    {
                        "id": 128087,
                        "name": "Valencia",
                        "latitude": "34.44361000",
                        "longitude": "-118.60953000"
                    },
                    {
                        "id": 128093,
                        "name": "Valinda",
                        "latitude": "34.04529000",
                        "longitude": "-117.94367000"
                    },
                    {
                        "id": 128094,
                        "name": "Valle Vista",
                        "latitude": "33.74780000",
                        "longitude": "-116.89336000"
                    },
                    {
                        "id": 128096,
                        "name": "Vallejo",
                        "latitude": "38.10409000",
                        "longitude": "-122.25664000"
                    },
                    {
                        "id": 128100,
                        "name": "Valley Center",
                        "latitude": "33.21837000",
                        "longitude": "-117.03420000"
                    },
                    {
                        "id": 128109,
                        "name": "Valley Glen",
                        "latitude": "34.18991000",
                        "longitude": "-118.44953000"
                    },
                    {
                        "id": 128115,
                        "name": "Valley Springs",
                        "latitude": "38.19159000",
                        "longitude": "-120.82910000"
                    },
                    {
                        "id": 128137,
                        "name": "Van Nuys",
                        "latitude": "34.18667000",
                        "longitude": "-118.44897000"
                    },
                    {
                        "id": 128147,
                        "name": "Vandenberg Air Force Base",
                        "latitude": "34.74830000",
                        "longitude": "-120.51817000"
                    },
                    {
                        "id": 128148,
                        "name": "Vandenberg Village",
                        "latitude": "34.70832000",
                        "longitude": "-120.46766000"
                    },
                    {
                        "id": 128172,
                        "name": "Venice",
                        "latitude": "33.99084000",
                        "longitude": "-118.46008000"
                    },
                    {
                        "id": 128175,
                        "name": "Ventura",
                        "latitude": "34.27834000",
                        "longitude": "-119.29317000"
                    },
                    {
                        "id": 128176,
                        "name": "Ventura County",
                        "latitude": "34.35753000",
                        "longitude": "-119.12603000"
                    },
                    {
                        "id": 128224,
                        "name": "Victorville",
                        "latitude": "34.53611000",
                        "longitude": "-117.29116000"
                    },
                    {
                        "id": 128238,
                        "name": "View Park-Windsor Hills",
                        "latitude": "33.99551000",
                        "longitude": "-118.34835000"
                    },
                    {
                        "id": 128244,
                        "name": "Villa Park",
                        "latitude": "33.81446000",
                        "longitude": "-117.81311000"
                    },
                    {
                        "id": 128265,
                        "name": "Vincent",
                        "latitude": "34.50055000",
                        "longitude": "-118.11646000"
                    },
                    {
                        "id": 128269,
                        "name": "Vine Hill",
                        "latitude": "38.00853000",
                        "longitude": "-122.09608000"
                    },
                    {
                        "id": 128273,
                        "name": "Vineyard",
                        "latitude": "38.46449000",
                        "longitude": "-121.34692000"
                    },
                    {
                        "id": 128293,
                        "name": "Visalia",
                        "latitude": "36.33023000",
                        "longitude": "-119.29206000"
                    },
                    {
                        "id": 128294,
                        "name": "Visitacion Valley",
                        "latitude": "37.71715000",
                        "longitude": "-122.40433000"
                    },
                    {
                        "id": 128295,
                        "name": "Vista",
                        "latitude": "33.20004000",
                        "longitude": "-117.24254000"
                    },
                    {
                        "id": 128297,
                        "name": "Vista Santa Rosa",
                        "latitude": "33.62780000",
                        "longitude": "-116.21806000"
                    },
                    {
                        "id": 128374,
                        "name": "Waldon",
                        "latitude": "37.92631000",
                        "longitude": "-122.05552000"
                    },
                    {
                        "id": 128414,
                        "name": "Walnut",
                        "latitude": "34.02029000",
                        "longitude": "-117.86534000"
                    },
                    {
                        "id": 128416,
                        "name": "Walnut Creek",
                        "latitude": "37.90631000",
                        "longitude": "-122.06496000"
                    },
                    {
                        "id": 128419,
                        "name": "Walnut Grove",
                        "latitude": "38.24214000",
                        "longitude": "-121.51162000"
                    },
                    {
                        "id": 128422,
                        "name": "Walnut Park",
                        "latitude": "33.96807000",
                        "longitude": "-118.22507000"
                    },
                    {
                        "id": 128528,
                        "name": "Wasco",
                        "latitude": "35.59412000",
                        "longitude": "-119.34095000"
                    },
                    {
                        "id": 128609,
                        "name": "Waterford",
                        "latitude": "37.64132000",
                        "longitude": "-120.76048000"
                    },
                    {
                        "id": 128641,
                        "name": "Watsonville",
                        "latitude": "36.91023000",
                        "longitude": "-121.75689000"
                    },
                    {
                        "id": 128723,
                        "name": "Weaverville",
                        "latitude": "40.73098000",
                        "longitude": "-122.94197000"
                    },
                    {
                        "id": 128751,
                        "name": "Weed",
                        "latitude": "41.42265000",
                        "longitude": "-122.38613000"
                    },
                    {
                        "id": 128752,
                        "name": "Weedpatch",
                        "latitude": "35.23802000",
                        "longitude": "-118.91510000"
                    },
                    {
                        "id": 128770,
                        "name": "Weldon",
                        "latitude": "35.66579000",
                        "longitude": "-118.29036000"
                    },
                    {
                        "id": 128818,
                        "name": "West Athens",
                        "latitude": "33.92335000",
                        "longitude": "-118.30341000"
                    },
                    {
                        "id": 128826,
                        "name": "West Bishop",
                        "latitude": "37.36104000",
                        "longitude": "-118.45511000"
                    },
                    {
                        "id": 128842,
                        "name": "West Carson",
                        "latitude": "33.82168000",
                        "longitude": "-118.29257000"
                    },
                    {
                        "id": 128853,
                        "name": "West Covina",
                        "latitude": "34.06862000",
                        "longitude": "-117.93895000"
                    },
                    {
                        "id": 128897,
                        "name": "West Hills",
                        "latitude": "34.19731000",
                        "longitude": "-118.64398000"
                    },
                    {
                        "id": 128899,
                        "name": "West Hollywood",
                        "latitude": "34.09001000",
                        "longitude": "-118.36174000"
                    },
                    {
                        "id": 128929,
                        "name": "West Menlo Park",
                        "latitude": "37.43355000",
                        "longitude": "-122.20302000"
                    },
                    {
                        "id": 128934,
                        "name": "West Modesto",
                        "latitude": "37.61754000",
                        "longitude": "-121.03914000"
                    },
                    {
                        "id": 128950,
                        "name": "West Park",
                        "latitude": "36.71023000",
                        "longitude": "-119.85126000"
                    },
                    {
                        "id": 128964,
                        "name": "West Puente Valley",
                        "latitude": "34.05168000",
                        "longitude": "-117.96840000"
                    },
                    {
                        "id": 128966,
                        "name": "West Rancho Dominguez",
                        "latitude": "33.89390000",
                        "longitude": "-118.27063000"
                    },
                    {
                        "id": 128971,
                        "name": "West Sacramento",
                        "latitude": "38.58046000",
                        "longitude": "-121.53023000"
                    },
                    {
                        "id": 129005,
                        "name": "West Whittier-Los Nietos",
                        "latitude": "33.97600000",
                        "longitude": "-118.06909000"
                    },
                    {
                        "id": 129037,
                        "name": "Westhaven-Moonstone",
                        "latitude": "41.04489000",
                        "longitude": "-124.10239000"
                    },
                    {
                        "id": 129040,
                        "name": "Westlake Village",
                        "latitude": "34.14584000",
                        "longitude": "-118.80565000"
                    },
                    {
                        "id": 129048,
                        "name": "Westminster",
                        "latitude": "33.75918000",
                        "longitude": "-118.00673000"
                    },
                    {
                        "id": 129051,
                        "name": "Westmont",
                        "latitude": "33.94140000",
                        "longitude": "-118.30230000"
                    },
                    {
                        "id": 129057,
                        "name": "Westmorland",
                        "latitude": "33.03727000",
                        "longitude": "-115.62138000"
                    },
                    {
                        "id": 129087,
                        "name": "Westwood",
                        "latitude": "34.05612000",
                        "longitude": "-118.43063000"
                    },
                    {
                        "id": 129108,
                        "name": "Wheatland",
                        "latitude": "39.00989000",
                        "longitude": "-121.42301000"
                    },
                    {
                        "id": 129210,
                        "name": "Whittier",
                        "latitude": "33.97918000",
                        "longitude": "-118.03284000"
                    },
                    {
                        "id": 129235,
                        "name": "Wildomar",
                        "latitude": "33.59891000",
                        "longitude": "-117.28004000"
                    },
                    {
                        "id": 129261,
                        "name": "Williams",
                        "latitude": "39.15461000",
                        "longitude": "-122.14942000"
                    },
                    {
                        "id": 129302,
                        "name": "Willits",
                        "latitude": "39.40961000",
                        "longitude": "-123.35557000"
                    },
                    {
                        "id": 129305,
                        "name": "Willow Creek",
                        "latitude": "40.93958000",
                        "longitude": "-123.63144000"
                    },
                    {
                        "id": 129315,
                        "name": "Willowbrook",
                        "latitude": "33.91696000",
                        "longitude": "-118.25507000"
                    },
                    {
                        "id": 129316,
                        "name": "Willows",
                        "latitude": "39.52433000",
                        "longitude": "-122.19359000"
                    },
                    {
                        "id": 157017,
                        "name": "Wilmington",
                        "latitude": "33.78953550",
                        "longitude": "-118.25909280"
                    },
                    {
                        "id": 129346,
                        "name": "Wilton",
                        "latitude": "38.41186000",
                        "longitude": "-121.27217000"
                    },
                    {
                        "id": 129360,
                        "name": "Winchester",
                        "latitude": "33.70697000",
                        "longitude": "-117.08447000"
                    },
                    {
                        "id": 129386,
                        "name": "Windsor",
                        "latitude": "38.54713000",
                        "longitude": "-122.81638000"
                    },
                    {
                        "id": 129439,
                        "name": "Winter Gardens",
                        "latitude": "32.83116000",
                        "longitude": "-116.93336000"
                    },
                    {
                        "id": 129445,
                        "name": "Winters",
                        "latitude": "38.52491000",
                        "longitude": "-121.97080000"
                    },
                    {
                        "id": 129454,
                        "name": "Winton",
                        "latitude": "37.38938000",
                        "longitude": "-120.61325000"
                    },
                    {
                        "id": 129467,
                        "name": "Wofford Heights",
                        "latitude": "35.70690000",
                        "longitude": "-118.45620000"
                    },
                    {
                        "id": 129493,
                        "name": "Woodacre",
                        "latitude": "38.01270000",
                        "longitude": "-122.64526000"
                    },
                    {
                        "id": 129502,
                        "name": "Woodbridge",
                        "latitude": "38.15408000",
                        "longitude": "-121.30134000"
                    },
                    {
                        "id": 129516,
                        "name": "Woodcrest",
                        "latitude": "33.88224000",
                        "longitude": "-117.35727000"
                    },
                    {
                        "id": 129524,
                        "name": "Woodlake",
                        "latitude": "36.41356000",
                        "longitude": "-119.09872000"
                    },
                    {
                        "id": 129526,
                        "name": "Woodland",
                        "latitude": "38.67852000",
                        "longitude": "-121.77330000"
                    },
                    {
                        "id": 129530,
                        "name": "Woodland Hills",
                        "latitude": "34.16834000",
                        "longitude": "-118.60592000"
                    },
                    {
                        "id": 129556,
                        "name": "Woodside",
                        "latitude": "37.42994000",
                        "longitude": "-122.25386000"
                    },
                    {
                        "id": 129574,
                        "name": "Woodville",
                        "latitude": "36.09356000",
                        "longitude": "-119.19900000"
                    },
                    {
                        "id": 129617,
                        "name": "Wrightwood",
                        "latitude": "34.36083000",
                        "longitude": "-117.63339000"
                    },
                    {
                        "id": 129686,
                        "name": "Yolo County",
                        "latitude": "38.68665000",
                        "longitude": "-121.90162000"
                    },
                    {
                        "id": 129689,
                        "name": "Yorba Linda",
                        "latitude": "33.88863000",
                        "longitude": "-117.81311000"
                    },
                    {
                        "id": 129711,
                        "name": "Yosemite Lakes",
                        "latitude": "37.19106000",
                        "longitude": "-119.77265000"
                    },
                    {
                        "id": 129712,
                        "name": "Yosemite Valley",
                        "latitude": "37.74075000",
                        "longitude": "-119.57788000"
                    },
                    {
                        "id": 129723,
                        "name": "Yountville",
                        "latitude": "38.40158000",
                        "longitude": "-122.36081000"
                    },
                    {
                        "id": 129725,
                        "name": "Yreka",
                        "latitude": "41.73542000",
                        "longitude": "-122.63447000"
                    },
                    {
                        "id": 129726,
                        "name": "Yuba City",
                        "latitude": "39.14045000",
                        "longitude": "-121.61691000"
                    },
                    {
                        "id": 129727,
                        "name": "Yuba County",
                        "latitude": "39.26902000",
                        "longitude": "-121.35126000"
                    },
                    {
                        "id": 129728,
                        "name": "Yucaipa",
                        "latitude": "34.03363000",
                        "longitude": "-117.04309000"
                    },
                    {
                        "id": 129729,
                        "name": "Yucca Valley",
                        "latitude": "34.11417000",
                        "longitude": "-116.43224000"
                    }
                ]
            },
            {
                "id": 1450,
                "name": "Colorado",
                "iso2": "CO",
                "latitude": "39.55005070",
                "longitude": "-105.78206740",
                "type": "state",
                "cities": [
                    {
                        "id": 110998,
                        "name": "Acres Green",
                        "latitude": "39.55666000",
                        "longitude": "-104.89609000"
                    },
                    {
                        "id": 111024,
                        "name": "Adams County",
                        "latitude": "39.87363000",
                        "longitude": "-104.33791000"
                    },
                    {
                        "id": 111070,
                        "name": "Air Force Academy",
                        "latitude": "38.99425000",
                        "longitude": "-104.86375000"
                    },
                    {
                        "id": 111080,
                        "name": "Akron",
                        "latitude": "40.16054000",
                        "longitude": "-103.21438000"
                    },
                    {
                        "id": 111098,
                        "name": "Alamosa",
                        "latitude": "37.46945000",
                        "longitude": "-105.87002000"
                    },
                    {
                        "id": 111099,
                        "name": "Alamosa County",
                        "latitude": "37.57289000",
                        "longitude": "-105.78829000"
                    },
                    {
                        "id": 111100,
                        "name": "Alamosa East",
                        "latitude": "37.47735000",
                        "longitude": "-105.84217000"
                    },
                    {
                        "id": 111399,
                        "name": "Applewood",
                        "latitude": "39.75778000",
                        "longitude": "-105.16250000"
                    },
                    {
                        "id": 111415,
                        "name": "Arapahoe County",
                        "latitude": "39.64977000",
                        "longitude": "-104.33924000"
                    },
                    {
                        "id": 111434,
                        "name": "Archuleta County",
                        "latitude": "37.19360000",
                        "longitude": "-107.04833000"
                    },
                    {
                        "id": 111452,
                        "name": "Aristocrat Ranchettes",
                        "latitude": "40.10915000",
                        "longitude": "-104.76247000"
                    },
                    {
                        "id": 111503,
                        "name": "Arvada",
                        "latitude": "39.80276000",
                        "longitude": "-105.08748000"
                    },
                    {
                        "id": 111552,
                        "name": "Aspen",
                        "latitude": "39.19110000",
                        "longitude": "-106.81754000"
                    },
                    {
                        "id": 111653,
                        "name": "Ault",
                        "latitude": "40.58248000",
                        "longitude": "-104.73191000"
                    },
                    {
                        "id": 111662,
                        "name": "Aurora",
                        "latitude": "39.72943000",
                        "longitude": "-104.83192000"
                    },
                    {
                        "id": 111695,
                        "name": "Avon",
                        "latitude": "39.63137000",
                        "longitude": "-106.52225000"
                    },
                    {
                        "id": 111717,
                        "name": "Baca County",
                        "latitude": "37.31918000",
                        "longitude": "-102.56047000"
                    },
                    {
                        "id": 111875,
                        "name": "Basalt",
                        "latitude": "39.36887000",
                        "longitude": "-107.03282000"
                    },
                    {
                        "id": 111910,
                        "name": "Battlement Mesa",
                        "latitude": "39.44137000",
                        "longitude": "-108.02507000"
                    },
                    {
                        "id": 111941,
                        "name": "Bayfield",
                        "latitude": "37.22556000",
                        "longitude": "-107.59811000"
                    },
                    {
                        "id": 112173,
                        "name": "Bennett",
                        "latitude": "39.75887000",
                        "longitude": "-104.42746000"
                    },
                    {
                        "id": 112188,
                        "name": "Bent County",
                        "latitude": "37.95509000",
                        "longitude": "-103.07170000"
                    },
                    {
                        "id": 112231,
                        "name": "Berkley",
                        "latitude": "39.80443000",
                        "longitude": "-105.02609000"
                    },
                    {
                        "id": 112257,
                        "name": "Berthoud",
                        "latitude": "40.30832000",
                        "longitude": "-105.08109000"
                    },
                    {
                        "id": 112376,
                        "name": "Black Forest",
                        "latitude": "39.01305000",
                        "longitude": "-104.70081000"
                    },
                    {
                        "id": 112600,
                        "name": "Boulder",
                        "latitude": "40.01499000",
                        "longitude": "-105.27055000"
                    },
                    {
                        "id": 112603,
                        "name": "Boulder County",
                        "latitude": "40.09246000",
                        "longitude": "-105.35770000"
                    },
                    {
                        "id": 112713,
                        "name": "Breckenridge",
                        "latitude": "39.48165000",
                        "longitude": "-106.03835000"
                    },
                    {
                        "id": 112791,
                        "name": "Brighton",
                        "latitude": "39.98526000",
                        "longitude": "-104.82053000"
                    },
                    {
                        "id": 112900,
                        "name": "Broomfield",
                        "latitude": "39.92054000",
                        "longitude": "-105.08665000"
                    },
                    {
                        "id": 112901,
                        "name": "Broomfield County",
                        "latitude": "39.95413000",
                        "longitude": "-105.05266000"
                    },
                    {
                        "id": 112953,
                        "name": "Brush",
                        "latitude": "40.25887000",
                        "longitude": "-103.62384000"
                    },
                    {
                        "id": 113004,
                        "name": "Buena Vista",
                        "latitude": "38.84222000",
                        "longitude": "-106.13113000"
                    },
                    {
                        "id": 113074,
                        "name": "Burlington",
                        "latitude": "39.30611000",
                        "longitude": "-102.26936000"
                    },
                    {
                        "id": 113134,
                        "name": "Byers",
                        "latitude": "39.71137000",
                        "longitude": "-104.22774000"
                    },
                    {
                        "id": 113307,
                        "name": "Campion",
                        "latitude": "40.34943000",
                        "longitude": "-105.07776000"
                    },
                    {
                        "id": 113597,
                        "name": "Cañon City",
                        "latitude": "38.44098000",
                        "longitude": "-105.24245000"
                    },
                    {
                        "id": 113390,
                        "name": "Carbondale",
                        "latitude": "39.40221000",
                        "longitude": "-107.21116000"
                    },
                    {
                        "id": 113443,
                        "name": "Carriage Club",
                        "latitude": "39.53249000",
                        "longitude": "-104.90109000"
                    },
                    {
                        "id": 113518,
                        "name": "Cascade-Chipita Park",
                        "latitude": "38.94354000",
                        "longitude": "-105.00237000"
                    },
                    {
                        "id": 113546,
                        "name": "Castle Pines",
                        "latitude": "39.45804000",
                        "longitude": "-104.89609000"
                    },
                    {
                        "id": 113547,
                        "name": "Castle Pines North",
                        "latitude": "39.47174000",
                        "longitude": "-104.89482000"
                    },
                    {
                        "id": 113549,
                        "name": "Castle Rock",
                        "latitude": "39.37221000",
                        "longitude": "-104.85609000"
                    },
                    {
                        "id": 113555,
                        "name": "Castlewood",
                        "latitude": "39.58471000",
                        "longitude": "-104.90109000"
                    },
                    {
                        "id": 113625,
                        "name": "Cedaredge",
                        "latitude": "38.90165000",
                        "longitude": "-107.92645000"
                    },
                    {
                        "id": 113634,
                        "name": "Centennial",
                        "latitude": "39.57916000",
                        "longitude": "-104.87692000"
                    },
                    {
                        "id": 113638,
                        "name": "Center",
                        "latitude": "37.75306000",
                        "longitude": "-106.10864000"
                    },
                    {
                        "id": 113671,
                        "name": "Central City",
                        "latitude": "39.80193000",
                        "longitude": "-105.51416000"
                    },
                    {
                        "id": 113710,
                        "name": "Chaffee County",
                        "latitude": "38.74690000",
                        "longitude": "-106.19407000"
                    },
                    {
                        "id": 113859,
                        "name": "Cherry Creek",
                        "latitude": "39.63455000",
                        "longitude": "-104.88286000"
                    },
                    {
                        "id": 113863,
                        "name": "Cherry Hills Village",
                        "latitude": "39.64165000",
                        "longitude": "-104.95943000"
                    },
                    {
                        "id": 113927,
                        "name": "Cheyenne County",
                        "latitude": "38.82794000",
                        "longitude": "-102.60340000"
                    },
                    {
                        "id": 113930,
                        "name": "Cheyenne Wells",
                        "latitude": "38.82140000",
                        "longitude": "-102.35324000"
                    },
                    {
                        "id": 114025,
                        "name": "Cimarron Hills",
                        "latitude": "38.85861000",
                        "longitude": "-104.69886000"
                    },
                    {
                        "id": 114208,
                        "name": "Clear Creek County",
                        "latitude": "39.68910000",
                        "longitude": "-105.64436000"
                    },
                    {
                        "id": 114261,
                        "name": "Clifton",
                        "latitude": "39.09193000",
                        "longitude": "-108.44898000"
                    },
                    {
                        "id": 114329,
                        "name": "Coal Creek",
                        "latitude": "39.90638000",
                        "longitude": "-105.37749000"
                    },
                    {
                        "id": 114455,
                        "name": "Colorado City",
                        "latitude": "37.94529000",
                        "longitude": "-104.83526000"
                    },
                    {
                        "id": 114458,
                        "name": "Colorado Springs",
                        "latitude": "38.83388000",
                        "longitude": "-104.82136000"
                    },
                    {
                        "id": 114488,
                        "name": "Columbine",
                        "latitude": "39.58777000",
                        "longitude": "-105.06943000"
                    },
                    {
                        "id": 114489,
                        "name": "Columbine Valley",
                        "latitude": "39.60110000",
                        "longitude": "-105.03221000"
                    },
                    {
                        "id": 114526,
                        "name": "Commerce City",
                        "latitude": "39.80832000",
                        "longitude": "-104.93387000"
                    },
                    {
                        "id": 114552,
                        "name": "Conejos",
                        "latitude": "37.08835000",
                        "longitude": "-106.01974000"
                    },
                    {
                        "id": 114553,
                        "name": "Conejos County",
                        "latitude": "37.20070000",
                        "longitude": "-106.19163000"
                    },
                    {
                        "id": 114674,
                        "name": "Cortez",
                        "latitude": "37.34888000",
                        "longitude": "-108.58593000"
                    },
                    {
                        "id": 114687,
                        "name": "Costilla County",
                        "latitude": "37.27810000",
                        "longitude": "-105.42827000"
                    },
                    {
                        "id": 114755,
                        "name": "Craig",
                        "latitude": "40.51525000",
                        "longitude": "-107.54645000"
                    },
                    {
                        "id": 114787,
                        "name": "Creede",
                        "latitude": "37.84917000",
                        "longitude": "-106.92643000"
                    },
                    {
                        "id": 114804,
                        "name": "Crested Butte",
                        "latitude": "38.86971000",
                        "longitude": "-106.98782000"
                    },
                    {
                        "id": 114821,
                        "name": "Cripple Creek",
                        "latitude": "38.74666000",
                        "longitude": "-105.17831000"
                    },
                    {
                        "id": 114865,
                        "name": "Crowley County",
                        "latitude": "38.32666000",
                        "longitude": "-103.78483000"
                    },
                    {
                        "id": 114937,
                        "name": "Custer County",
                        "latitude": "38.10868000",
                        "longitude": "-105.36747000"
                    },
                    {
                        "id": 114962,
                        "name": "Dacono",
                        "latitude": "40.08471000",
                        "longitude": "-104.93942000"
                    },
                    {
                        "id": 115190,
                        "name": "Del Norte",
                        "latitude": "37.67889000",
                        "longitude": "-106.35337000"
                    },
                    {
                        "id": 115222,
                        "name": "Delta",
                        "latitude": "38.74221000",
                        "longitude": "-108.06896000"
                    },
                    {
                        "id": 115226,
                        "name": "Delta County",
                        "latitude": "38.86137000",
                        "longitude": "-107.86288000"
                    },
                    {
                        "id": 115253,
                        "name": "Denver",
                        "latitude": "39.73915000",
                        "longitude": "-104.98470000"
                    },
                    {
                        "id": 115255,
                        "name": "Denver County",
                        "latitude": "39.76204000",
                        "longitude": "-104.87635000"
                    },
                    {
                        "id": 115262,
                        "name": "Derby",
                        "latitude": "39.83943000",
                        "longitude": "-104.91859000"
                    },
                    {
                        "id": 115391,
                        "name": "Dolores County",
                        "latitude": "37.75160000",
                        "longitude": "-108.51722000"
                    },
                    {
                        "id": 115433,
                        "name": "Douglas County",
                        "latitude": "39.32972000",
                        "longitude": "-104.92956000"
                    },
                    {
                        "id": 115442,
                        "name": "Dove Creek",
                        "latitude": "37.76610000",
                        "longitude": "-108.90594000"
                    },
                    {
                        "id": 115443,
                        "name": "Dove Valley",
                        "latitude": "39.57771000",
                        "longitude": "-104.82940000"
                    },
                    {
                        "id": 115565,
                        "name": "Durango",
                        "latitude": "37.27528000",
                        "longitude": "-107.88007000"
                    },
                    {
                        "id": 115592,
                        "name": "Eads",
                        "latitude": "38.48056000",
                        "longitude": "-102.78186000"
                    },
                    {
                        "id": 115597,
                        "name": "Eagle",
                        "latitude": "39.65526000",
                        "longitude": "-106.82865000"
                    },
                    {
                        "id": 115600,
                        "name": "Eagle County",
                        "latitude": "39.62783000",
                        "longitude": "-106.69530000"
                    },
                    {
                        "id": 115802,
                        "name": "Eaton",
                        "latitude": "40.53026000",
                        "longitude": "-104.71135000"
                    },
                    {
                        "id": 115855,
                        "name": "Edgewater",
                        "latitude": "39.75304000",
                        "longitude": "-105.06415000"
                    },
                    {
                        "id": 115887,
                        "name": "Edwards",
                        "latitude": "39.64499000",
                        "longitude": "-106.59420000"
                    },
                    {
                        "id": 115925,
                        "name": "El Jebel",
                        "latitude": "39.39498000",
                        "longitude": "-107.09033000"
                    },
                    {
                        "id": 115931,
                        "name": "El Paso County",
                        "latitude": "38.83209000",
                        "longitude": "-104.52558000"
                    },
                    {
                        "id": 115943,
                        "name": "Elbert County",
                        "latitude": "39.28656000",
                        "longitude": "-104.13589000"
                    },
                    {
                        "id": 115974,
                        "name": "Elizabeth",
                        "latitude": "39.36027000",
                        "longitude": "-104.59691000"
                    },
                    {
                        "id": 116023,
                        "name": "Ellicott",
                        "latitude": "38.83833000",
                        "longitude": "-104.38691000"
                    },
                    {
                        "id": 116133,
                        "name": "Englewood",
                        "latitude": "39.64777000",
                        "longitude": "-104.98776000"
                    },
                    {
                        "id": 116167,
                        "name": "Erie",
                        "latitude": "40.05026000",
                        "longitude": "-105.04998000"
                    },
                    {
                        "id": 116208,
                        "name": "Estes Park",
                        "latitude": "40.37721000",
                        "longitude": "-105.52167000"
                    },
                    {
                        "id": 116246,
                        "name": "Evans",
                        "latitude": "40.37637000",
                        "longitude": "-104.69219000"
                    },
                    {
                        "id": 116263,
                        "name": "Evergreen",
                        "latitude": "39.63332000",
                        "longitude": "-105.31721000"
                    },
                    {
                        "id": 116344,
                        "name": "Fairplay",
                        "latitude": "39.22471000",
                        "longitude": "-106.00196000"
                    },
                    {
                        "id": 116464,
                        "name": "Federal Heights",
                        "latitude": "39.85137000",
                        "longitude": "-104.99859000"
                    },
                    {
                        "id": 116521,
                        "name": "Firestone",
                        "latitude": "40.11248000",
                        "longitude": "-104.93664000"
                    },
                    {
                        "id": 116585,
                        "name": "Florence",
                        "latitude": "38.39028000",
                        "longitude": "-105.11860000"
                    },
                    {
                        "id": 116699,
                        "name": "Fort Carson",
                        "latitude": "38.73749000",
                        "longitude": "-104.78886000"
                    },
                    {
                        "id": 116701,
                        "name": "Fort Collins",
                        "latitude": "40.58526000",
                        "longitude": "-105.08442000"
                    },
                    {
                        "id": 116726,
                        "name": "Fort Lupton",
                        "latitude": "40.08471000",
                        "longitude": "-104.81303000"
                    },
                    {
                        "id": 116733,
                        "name": "Fort Morgan",
                        "latitude": "40.25026000",
                        "longitude": "-103.79995000"
                    },
                    {
                        "id": 116778,
                        "name": "Fountain",
                        "latitude": "38.68222000",
                        "longitude": "-104.70081000"
                    },
                    {
                        "id": 116796,
                        "name": "Fowler",
                        "latitude": "38.12917000",
                        "longitude": "-104.02329000"
                    },
                    {
                        "id": 116881,
                        "name": "Fraser",
                        "latitude": "39.94499000",
                        "longitude": "-105.81723000"
                    },
                    {
                        "id": 116887,
                        "name": "Frederick",
                        "latitude": "40.09915000",
                        "longitude": "-104.93720000"
                    },
                    {
                        "id": 116926,
                        "name": "Fremont County",
                        "latitude": "38.47297000",
                        "longitude": "-105.43966000"
                    },
                    {
                        "id": 116956,
                        "name": "Frisco",
                        "latitude": "39.57443000",
                        "longitude": "-106.09752000"
                    },
                    {
                        "id": 116968,
                        "name": "Fruita",
                        "latitude": "39.15887000",
                        "longitude": "-108.72899000"
                    },
                    {
                        "id": 116976,
                        "name": "Fruitvale",
                        "latitude": "39.08165000",
                        "longitude": "-108.49676000"
                    },
                    {
                        "id": 117084,
                        "name": "Garfield County",
                        "latitude": "39.59931000",
                        "longitude": "-107.90395000"
                    },
                    {
                        "id": 117134,
                        "name": "Genesee",
                        "latitude": "39.68582000",
                        "longitude": "-105.27277000"
                    },
                    {
                        "id": 117164,
                        "name": "Georgetown",
                        "latitude": "39.70610000",
                        "longitude": "-105.69750000"
                    },
                    {
                        "id": 117209,
                        "name": "Gilcrest",
                        "latitude": "40.28193000",
                        "longitude": "-104.77775000"
                    },
                    {
                        "id": 117224,
                        "name": "Gilpin County",
                        "latitude": "39.85756000",
                        "longitude": "-105.52253000"
                    },
                    {
                        "id": 117287,
                        "name": "Glendale",
                        "latitude": "39.70499000",
                        "longitude": "-104.93359000"
                    },
                    {
                        "id": 117292,
                        "name": "Gleneagle",
                        "latitude": "39.04527000",
                        "longitude": "-104.82442000"
                    },
                    {
                        "id": 117318,
                        "name": "Glenwood Springs",
                        "latitude": "39.55054000",
                        "longitude": "-107.32478000"
                    },
                    {
                        "id": 117346,
                        "name": "Golden",
                        "latitude": "39.75554000",
                        "longitude": "-105.22110000"
                    },
                    {
                        "id": 117448,
                        "name": "Granby",
                        "latitude": "40.08610000",
                        "longitude": "-105.93946000"
                    },
                    {
                        "id": 117456,
                        "name": "Grand County",
                        "latitude": "40.10261000",
                        "longitude": "-106.11836000"
                    },
                    {
                        "id": 117465,
                        "name": "Grand Junction",
                        "latitude": "39.06387000",
                        "longitude": "-108.55065000"
                    },
                    {
                        "id": 117586,
                        "name": "Greeley",
                        "latitude": "40.42331000",
                        "longitude": "-104.70913000"
                    },
                    {
                        "id": 117712,
                        "name": "Greenwood Village",
                        "latitude": "39.61721000",
                        "longitude": "-104.95081000"
                    },
                    {
                        "id": 117801,
                        "name": "Gunbarrel",
                        "latitude": "40.06335000",
                        "longitude": "-105.17107000"
                    },
                    {
                        "id": 117802,
                        "name": "Gunnison",
                        "latitude": "38.54582000",
                        "longitude": "-106.92532000"
                    },
                    {
                        "id": 117804,
                        "name": "Gunnison County",
                        "latitude": "38.66680000",
                        "longitude": "-107.03170000"
                    },
                    {
                        "id": 117822,
                        "name": "Gypsum",
                        "latitude": "39.64693000",
                        "longitude": "-106.95171000"
                    },
                    {
                        "id": 118178,
                        "name": "Hayden",
                        "latitude": "40.49529000",
                        "longitude": "-107.25729000"
                    },
                    {
                        "id": 118420,
                        "name": "Highlands Ranch",
                        "latitude": "39.55388000",
                        "longitude": "-104.96943000"
                    },
                    {
                        "id": 118487,
                        "name": "Hinsdale County",
                        "latitude": "37.82134000",
                        "longitude": "-107.30031000"
                    },
                    {
                        "id": 118558,
                        "name": "Holly Hills",
                        "latitude": "39.66757000",
                        "longitude": "-104.91797000"
                    },
                    {
                        "id": 118584,
                        "name": "Holyoke",
                        "latitude": "40.58444000",
                        "longitude": "-102.30241000"
                    },
                    {
                        "id": 118687,
                        "name": "Hot Sulphur Springs",
                        "latitude": "40.07304000",
                        "longitude": "-106.10280000"
                    },
                    {
                        "id": 118747,
                        "name": "Hudson",
                        "latitude": "40.07359000",
                        "longitude": "-104.64302000"
                    },
                    {
                        "id": 118755,
                        "name": "Huerfano County",
                        "latitude": "37.68468000",
                        "longitude": "-104.96058000"
                    },
                    {
                        "id": 118767,
                        "name": "Hugo",
                        "latitude": "39.13610000",
                        "longitude": "-103.46994000"
                    },
                    {
                        "id": 118872,
                        "name": "Idaho Springs",
                        "latitude": "39.74249000",
                        "longitude": "-105.51361000"
                    },
                    {
                        "id": 118908,
                        "name": "Indian Hills",
                        "latitude": "39.61665000",
                        "longitude": "-105.23721000"
                    },
                    {
                        "id": 118958,
                        "name": "Inverness",
                        "latitude": "39.57738000",
                        "longitude": "-104.86135000"
                    },
                    {
                        "id": 119094,
                        "name": "Jackson County",
                        "latitude": "40.66643000",
                        "longitude": "-106.34279000"
                    },
                    {
                        "id": 119194,
                        "name": "Jefferson County",
                        "latitude": "39.58642000",
                        "longitude": "-105.25047000"
                    },
                    {
                        "id": 119286,
                        "name": "Johnstown",
                        "latitude": "40.33693000",
                        "longitude": "-104.91220000"
                    },
                    {
                        "id": 119329,
                        "name": "Julesburg",
                        "latitude": "40.98833000",
                        "longitude": "-102.26435000"
                    },
                    {
                        "id": 119422,
                        "name": "Keenesburg",
                        "latitude": "40.10832000",
                        "longitude": "-104.51996000"
                    },
                    {
                        "id": 119439,
                        "name": "Ken Caryl",
                        "latitude": "39.57582000",
                        "longitude": "-105.11221000"
                    },
                    {
                        "id": 119519,
                        "name": "Kersey",
                        "latitude": "40.38748000",
                        "longitude": "-104.56163000"
                    },
                    {
                        "id": 119547,
                        "name": "Keystone",
                        "latitude": "39.59943000",
                        "longitude": "-105.98724000"
                    },
                    {
                        "id": 119645,
                        "name": "Kiowa",
                        "latitude": "39.34721000",
                        "longitude": "-104.46441000"
                    },
                    {
                        "id": 119648,
                        "name": "Kiowa County",
                        "latitude": "38.43269000",
                        "longitude": "-102.74034000"
                    },
                    {
                        "id": 119659,
                        "name": "Kit Carson County",
                        "latitude": "39.30544000",
                        "longitude": "-102.60289000"
                    },
                    {
                        "id": 119666,
                        "name": "Kittredge",
                        "latitude": "39.65471000",
                        "longitude": "-105.29971000"
                    },
                    {
                        "id": 119716,
                        "name": "Kremmling",
                        "latitude": "40.05887000",
                        "longitude": "-106.38892000"
                    },
                    {
                        "id": 119762,
                        "name": "La Junta",
                        "latitude": "37.98501000",
                        "longitude": "-103.54383000"
                    },
                    {
                        "id": 119775,
                        "name": "La Plata County",
                        "latitude": "37.28656000",
                        "longitude": "-107.84334000"
                    },
                    {
                        "id": 119786,
                        "name": "La Salle",
                        "latitude": "40.34887000",
                        "longitude": "-104.70191000"
                    },
                    {
                        "id": 119836,
                        "name": "Lafayette",
                        "latitude": "39.99360000",
                        "longitude": "-105.08971000"
                    },
                    {
                        "id": 119886,
                        "name": "Lake City",
                        "latitude": "38.03000000",
                        "longitude": "-107.31533000"
                    },
                    {
                        "id": 119897,
                        "name": "Lake County",
                        "latitude": "39.20238000",
                        "longitude": "-106.34484000"
                    },
                    {
                        "id": 120050,
                        "name": "Lakewood",
                        "latitude": "39.70471000",
                        "longitude": "-105.08137000"
                    },
                    {
                        "id": 120060,
                        "name": "Lamar",
                        "latitude": "38.08723000",
                        "longitude": "-102.62075000"
                    },
                    {
                        "id": 120136,
                        "name": "Laporte",
                        "latitude": "40.62633000",
                        "longitude": "-105.13916000"
                    },
                    {
                        "id": 120145,
                        "name": "Larimer County",
                        "latitude": "40.66641000",
                        "longitude": "-105.46116000"
                    },
                    {
                        "id": 120153,
                        "name": "Las Animas",
                        "latitude": "38.06667000",
                        "longitude": "-103.22271000"
                    },
                    {
                        "id": 120154,
                        "name": "Las Animas County",
                        "latitude": "37.31585000",
                        "longitude": "-104.03872000"
                    },
                    {
                        "id": 120271,
                        "name": "Leadville",
                        "latitude": "39.25082000",
                        "longitude": "-106.29252000"
                    },
                    {
                        "id": 120272,
                        "name": "Leadville North",
                        "latitude": "39.25760000",
                        "longitude": "-106.30138000"
                    },
                    {
                        "id": 120498,
                        "name": "Limon",
                        "latitude": "39.26388000",
                        "longitude": "-103.69217000"
                    },
                    {
                        "id": 120530,
                        "name": "Lincoln County",
                        "latitude": "38.98807000",
                        "longitude": "-103.51397000"
                    },
                    {
                        "id": 120545,
                        "name": "Lincoln Park",
                        "latitude": "38.42916000",
                        "longitude": "-105.21999000"
                    },
                    {
                        "id": 120636,
                        "name": "Littleton",
                        "latitude": "39.61332000",
                        "longitude": "-105.01665000"
                    },
                    {
                        "id": 120670,
                        "name": "Lochbuie",
                        "latitude": "40.00721000",
                        "longitude": "-104.71608000"
                    },
                    {
                        "id": 120703,
                        "name": "Logan County",
                        "latitude": "40.72468000",
                        "longitude": "-103.11010000"
                    },
                    {
                        "id": 120711,
                        "name": "Loma",
                        "latitude": "39.19581000",
                        "longitude": "-108.81316000"
                    },
                    {
                        "id": 120732,
                        "name": "Lone Tree",
                        "latitude": "39.55171000",
                        "longitude": "-104.88630000"
                    },
                    {
                        "id": 120754,
                        "name": "Longmont",
                        "latitude": "40.16721000",
                        "longitude": "-105.10193000"
                    },
                    {
                        "id": 120817,
                        "name": "Louisville",
                        "latitude": "39.97776000",
                        "longitude": "-105.13193000"
                    },
                    {
                        "id": 120822,
                        "name": "Loveland",
                        "latitude": "40.39776000",
                        "longitude": "-105.07498000"
                    },
                    {
                        "id": 120945,
                        "name": "Lyons",
                        "latitude": "40.22471000",
                        "longitude": "-105.27138000"
                    },
                    {
                        "id": 121105,
                        "name": "Mancos",
                        "latitude": "37.34500000",
                        "longitude": "-108.28925000"
                    },
                    {
                        "id": 121126,
                        "name": "Manitou Springs",
                        "latitude": "38.85971000",
                        "longitude": "-104.91720000"
                    },
                    {
                        "id": 121552,
                        "name": "Mead",
                        "latitude": "40.23332000",
                        "longitude": "-104.99859000"
                    },
                    {
                        "id": 121613,
                        "name": "Meeker",
                        "latitude": "40.03747000",
                        "longitude": "-107.91313000"
                    },
                    {
                        "id": 121694,
                        "name": "Meridian",
                        "latitude": "39.53957000",
                        "longitude": "-104.84528000"
                    },
                    {
                        "id": 121721,
                        "name": "Mesa County",
                        "latitude": "39.01828000",
                        "longitude": "-108.46645000"
                    },
                    {
                        "id": 121890,
                        "name": "Milliken",
                        "latitude": "40.32943000",
                        "longitude": "-104.85525000"
                    },
                    {
                        "id": 121935,
                        "name": "Mineral County",
                        "latitude": "37.66900000",
                        "longitude": "-106.92409000"
                    },
                    {
                        "id": 121969,
                        "name": "Minturn",
                        "latitude": "39.58637000",
                        "longitude": "-106.43086000"
                    },
                    {
                        "id": 122016,
                        "name": "Moffat County",
                        "latitude": "40.61843000",
                        "longitude": "-108.20730000"
                    },
                    {
                        "id": 122111,
                        "name": "Monte Vista",
                        "latitude": "37.57917000",
                        "longitude": "-106.14808000"
                    },
                    {
                        "id": 122129,
                        "name": "Montezuma County",
                        "latitude": "37.33841000",
                        "longitude": "-108.59671000"
                    },
                    {
                        "id": 122184,
                        "name": "Montrose",
                        "latitude": "38.47832000",
                        "longitude": "-107.87617000"
                    },
                    {
                        "id": 122185,
                        "name": "Montrose County",
                        "latitude": "38.40218000",
                        "longitude": "-108.26936000"
                    },
                    {
                        "id": 122191,
                        "name": "Monument",
                        "latitude": "39.09166000",
                        "longitude": "-104.87276000"
                    },
                    {
                        "id": 122244,
                        "name": "Morgan County",
                        "latitude": "40.26271000",
                        "longitude": "-103.80982000"
                    },
                    {
                        "id": 122435,
                        "name": "Mountain Village",
                        "latitude": "37.93138000",
                        "longitude": "-107.85645000"
                    },
                    {
                        "id": 122611,
                        "name": "Nederland",
                        "latitude": "39.96138000",
                        "longitude": "-105.51083000"
                    },
                    {
                        "id": 122689,
                        "name": "New Castle",
                        "latitude": "39.57276000",
                        "longitude": "-107.53644000"
                    },
                    {
                        "id": 122911,
                        "name": "Niwot",
                        "latitude": "40.10387000",
                        "longitude": "-105.17082000"
                    },
                    {
                        "id": 123155,
                        "name": "Northglenn",
                        "latitude": "39.88554000",
                        "longitude": "-104.98720000"
                    },
                    {
                        "id": 123413,
                        "name": "Olathe",
                        "latitude": "38.60499000",
                        "longitude": "-107.98229000"
                    },
                    {
                        "id": 123532,
                        "name": "Orchard City",
                        "latitude": "38.82832000",
                        "longitude": "-107.97090000"
                    },
                    {
                        "id": 123537,
                        "name": "Orchard Mesa",
                        "latitude": "39.04304000",
                        "longitude": "-108.55232000"
                    },
                    {
                        "id": 123543,
                        "name": "Ordway",
                        "latitude": "38.21806000",
                        "longitude": "-103.75606000"
                    },
                    {
                        "id": 123625,
                        "name": "Otero County",
                        "latitude": "37.90270000",
                        "longitude": "-103.71645000"
                    },
                    {
                        "id": 123646,
                        "name": "Ouray",
                        "latitude": "38.02277000",
                        "longitude": "-107.67145000"
                    },
                    {
                        "id": 123647,
                        "name": "Ouray County",
                        "latitude": "38.15550000",
                        "longitude": "-107.76932000"
                    },
                    {
                        "id": 123722,
                        "name": "Pagosa Springs",
                        "latitude": "37.26945000",
                        "longitude": "-107.00976000"
                    },
                    {
                        "id": 123738,
                        "name": "Palisade",
                        "latitude": "39.11026000",
                        "longitude": "-108.35092000"
                    },
                    {
                        "id": 123762,
                        "name": "Palmer Lake",
                        "latitude": "39.12221000",
                        "longitude": "-104.91720000"
                    },
                    {
                        "id": 123813,
                        "name": "Paonia",
                        "latitude": "38.86832000",
                        "longitude": "-107.59200000"
                    },
                    {
                        "id": 123815,
                        "name": "Parachute",
                        "latitude": "39.45192000",
                        "longitude": "-108.05285000"
                    },
                    {
                        "id": 123841,
                        "name": "Park County",
                        "latitude": "39.11930000",
                        "longitude": "-105.71717000"
                    },
                    {
                        "id": 123863,
                        "name": "Parker",
                        "latitude": "39.51860000",
                        "longitude": "-104.76136000"
                    },
                    {
                        "id": 124043,
                        "name": "Penrose",
                        "latitude": "38.42500000",
                        "longitude": "-105.02276000"
                    },
                    {
                        "id": 124084,
                        "name": "Perry Park",
                        "latitude": "39.25666000",
                        "longitude": "-104.99248000"
                    },
                    {
                        "id": 124137,
                        "name": "Phillips County",
                        "latitude": "40.59388000",
                        "longitude": "-102.35758000"
                    },
                    {
                        "id": 124286,
                        "name": "Pitkin County",
                        "latitude": "39.21711000",
                        "longitude": "-106.91658000"
                    },
                    {
                        "id": 124358,
                        "name": "Platteville",
                        "latitude": "40.21498000",
                        "longitude": "-104.82275000"
                    },
                    {
                        "id": 124470,
                        "name": "Ponderosa Park",
                        "latitude": "39.40832000",
                        "longitude": "-104.65108000"
                    },
                    {
                        "id": 124722,
                        "name": "Prowers County",
                        "latitude": "37.95518000",
                        "longitude": "-102.39335000"
                    },
                    {
                        "id": 124728,
                        "name": "Pueblo",
                        "latitude": "38.25445000",
                        "longitude": "-104.60914000"
                    },
                    {
                        "id": 124729,
                        "name": "Pueblo County",
                        "latitude": "38.17342000",
                        "longitude": "-104.51285000"
                    },
                    {
                        "id": 124730,
                        "name": "Pueblo West",
                        "latitude": "38.35000000",
                        "longitude": "-104.72275000"
                    },
                    {
                        "id": 124881,
                        "name": "Rangely",
                        "latitude": "40.08748000",
                        "longitude": "-108.80483000"
                    },
                    {
                        "id": 124977,
                        "name": "Redlands",
                        "latitude": "39.07887000",
                        "longitude": "-108.63565000"
                    },
                    {
                        "id": 125136,
                        "name": "Rifle",
                        "latitude": "39.53470000",
                        "longitude": "-107.78312000"
                    },
                    {
                        "id": 125148,
                        "name": "Rio Blanco County",
                        "latitude": "39.97984000",
                        "longitude": "-108.21721000"
                    },
                    {
                        "id": 125155,
                        "name": "Rio Grande County",
                        "latitude": "37.58252000",
                        "longitude": "-106.38321000"
                    },
                    {
                        "id": 125334,
                        "name": "Rocky Ford",
                        "latitude": "38.05251000",
                        "longitude": "-103.72023000"
                    },
                    {
                        "id": 125476,
                        "name": "Routt County",
                        "latitude": "40.48507000",
                        "longitude": "-106.99119000"
                    },
                    {
                        "id": 125485,
                        "name": "Roxborough Park",
                        "latitude": "39.47388000",
                        "longitude": "-105.08526000"
                    },
                    {
                        "id": 125591,
                        "name": "Saguache",
                        "latitude": "38.08750000",
                        "longitude": "-106.14197000"
                    },
                    {
                        "id": 125592,
                        "name": "Saguache County",
                        "latitude": "38.08055000",
                        "longitude": "-106.28156000"
                    },
                    {
                        "id": 125743,
                        "name": "Salida",
                        "latitude": "38.53472000",
                        "longitude": "-105.99890000"
                    },
                    {
                        "id": 125820,
                        "name": "San Juan County",
                        "latitude": "37.76404000",
                        "longitude": "-107.67615000"
                    },
                    {
                        "id": 125828,
                        "name": "San Luis",
                        "latitude": "37.20085000",
                        "longitude": "-105.42390000"
                    },
                    {
                        "id": 125840,
                        "name": "San Miguel County",
                        "latitude": "38.00374000",
                        "longitude": "-108.40583000"
                    },
                    {
                        "id": 126113,
                        "name": "Security-Widefield",
                        "latitude": "38.74728000",
                        "longitude": "-104.71439000"
                    },
                    {
                        "id": 126120,
                        "name": "Sedgwick County",
                        "latitude": "40.87591000",
                        "longitude": "-102.35179000"
                    },
                    {
                        "id": 126177,
                        "name": "Severance",
                        "latitude": "40.52415000",
                        "longitude": "-104.85108000"
                    },
                    {
                        "id": 126246,
                        "name": "Shaw Heights",
                        "latitude": "39.85250000",
                        "longitude": "-105.04306000"
                    },
                    {
                        "id": 126320,
                        "name": "Sheridan",
                        "latitude": "39.64693000",
                        "longitude": "-105.02526000"
                    },
                    {
                        "id": 126337,
                        "name": "Sherrelwood",
                        "latitude": "39.83776000",
                        "longitude": "-105.00137000"
                    },
                    {
                        "id": 126419,
                        "name": "Silt",
                        "latitude": "39.54859000",
                        "longitude": "-107.65617000"
                    },
                    {
                        "id": 126440,
                        "name": "Silverthorne",
                        "latitude": "39.63214000",
                        "longitude": "-106.07428000"
                    },
                    {
                        "id": 126441,
                        "name": "Silverton",
                        "latitude": "37.81194000",
                        "longitude": "-107.66451000"
                    },
                    {
                        "id": 126548,
                        "name": "Snowmass Village",
                        "latitude": "39.21304000",
                        "longitude": "-106.93782000"
                    },
                    {
                        "id": 126776,
                        "name": "Southglenn",
                        "latitude": "39.58721000",
                        "longitude": "-104.95276000"
                    },
                    {
                        "id": 126906,
                        "name": "Springfield",
                        "latitude": "37.40835000",
                        "longitude": "-102.61436000"
                    },
                    {
                        "id": 127003,
                        "name": "Steamboat Springs",
                        "latitude": "40.48498000",
                        "longitude": "-106.83172000"
                    },
                    {
                        "id": 127030,
                        "name": "Sterling",
                        "latitude": "40.62554000",
                        "longitude": "-103.20771000"
                    },
                    {
                        "id": 127088,
                        "name": "Stonegate",
                        "latitude": "39.53082000",
                        "longitude": "-104.80386000"
                    },
                    {
                        "id": 127121,
                        "name": "Strasburg",
                        "latitude": "39.73832000",
                        "longitude": "-104.32329000"
                    },
                    {
                        "id": 127132,
                        "name": "Stratmoor",
                        "latitude": "38.77388000",
                        "longitude": "-104.77970000"
                    },
                    {
                        "id": 127216,
                        "name": "Summit County",
                        "latitude": "39.63417000",
                        "longitude": "-106.11638000"
                    },
                    {
                        "id": 127281,
                        "name": "Superior",
                        "latitude": "39.95276000",
                        "longitude": "-105.16860000"
                    },
                    {
                        "id": 127489,
                        "name": "Teller County",
                        "latitude": "38.88217000",
                        "longitude": "-105.16183000"
                    },
                    {
                        "id": 127491,
                        "name": "Telluride",
                        "latitude": "37.93749000",
                        "longitude": "-107.81229000"
                    },
                    {
                        "id": 127563,
                        "name": "The Pinery",
                        "latitude": "39.45527000",
                        "longitude": "-104.73442000"
                    },
                    {
                        "id": 127603,
                        "name": "Thornton",
                        "latitude": "39.86804000",
                        "longitude": "-104.97192000"
                    },
                    {
                        "id": 127695,
                        "name": "Todd Creek",
                        "latitude": "39.97804000",
                        "longitude": "-104.87331000"
                    },
                    {
                        "id": 127753,
                        "name": "Towaoc",
                        "latitude": "37.20444000",
                        "longitude": "-108.72954000"
                    },
                    {
                        "id": 127823,
                        "name": "Trinidad",
                        "latitude": "37.16946000",
                        "longitude": "-104.50054000"
                    },
                    {
                        "id": 127931,
                        "name": "Twin Lakes",
                        "latitude": "39.82499000",
                        "longitude": "-105.00470000"
                    },
                    {
                        "id": 128041,
                        "name": "Upper Bear Creek",
                        "latitude": "39.62385000",
                        "longitude": "-105.41780000"
                    },
                    {
                        "id": 128076,
                        "name": "Vail",
                        "latitude": "39.64026000",
                        "longitude": "-106.37420000"
                    },
                    {
                        "id": 128369,
                        "name": "Walden",
                        "latitude": "40.73164000",
                        "longitude": "-106.28364000"
                    },
                    {
                        "id": 128426,
                        "name": "Walsenburg",
                        "latitude": "37.62418000",
                        "longitude": "-104.78026000"
                    },
                    {
                        "id": 128577,
                        "name": "Washington County",
                        "latitude": "39.97106000",
                        "longitude": "-103.20125000"
                    },
                    {
                        "id": 128764,
                        "name": "Welby",
                        "latitude": "39.83665000",
                        "longitude": "-104.95915000"
                    },
                    {
                        "id": 128768,
                        "name": "Weld County",
                        "latitude": "40.55484000",
                        "longitude": "-104.39253000"
                    },
                    {
                        "id": 128778,
                        "name": "Wellington",
                        "latitude": "40.70387000",
                        "longitude": "-105.00859000"
                    },
                    {
                        "id": 128957,
                        "name": "West Pleasant View",
                        "latitude": "39.73256000",
                        "longitude": "-105.17852000"
                    },
                    {
                        "id": 129021,
                        "name": "Westcliffe",
                        "latitude": "38.13472000",
                        "longitude": "-105.46584000"
                    },
                    {
                        "id": 129047,
                        "name": "Westminster",
                        "latitude": "39.83665000",
                        "longitude": "-105.03720000"
                    },
                    {
                        "id": 129107,
                        "name": "Wheat Ridge",
                        "latitude": "39.76610000",
                        "longitude": "-105.07721000"
                    },
                    {
                        "id": 129387,
                        "name": "Windsor",
                        "latitude": "40.47748000",
                        "longitude": "-104.90136000"
                    },
                    {
                        "id": 129533,
                        "name": "Woodland Park",
                        "latitude": "38.99388000",
                        "longitude": "-105.05693000"
                    },
                    {
                        "id": 129543,
                        "name": "Woodmoor",
                        "latitude": "39.10138000",
                        "longitude": "-104.84748000"
                    },
                    {
                        "id": 129602,
                        "name": "Wray",
                        "latitude": "40.07582000",
                        "longitude": "-102.22325000"
                    },
                    {
                        "id": 129734,
                        "name": "Yuma",
                        "latitude": "40.12221000",
                        "longitude": "-102.72521000"
                    },
                    {
                        "id": 129736,
                        "name": "Yuma County",
                        "latitude": "40.00290000",
                        "longitude": "-102.42423000"
                    }
                ]
            },
            {
                "id": 1435,
                "name": "Connecticut",
                "iso2": "CT",
                "latitude": "41.60322070",
                "longitude": "-73.08774900",
                "type": "state",
                "cities": [
                    {
                        "id": 111362,
                        "name": "Ansonia",
                        "latitude": "41.34621000",
                        "longitude": "-73.07900000"
                    },
                    {
                        "id": 111781,
                        "name": "Baltic",
                        "latitude": "41.61704000",
                        "longitude": "-72.08452000"
                    },
                    {
                        "id": 153920,
                        "name": "Berlin",
                        "latitude": "41.62223400",
                        "longitude": "-72.77362800"
                    },
                    {
                        "id": 112280,
                        "name": "Bethel",
                        "latitude": "41.37121000",
                        "longitude": "-73.41401000"
                    },
                    {
                        "id": 112292,
                        "name": "Bethlehem Village",
                        "latitude": "41.64010000",
                        "longitude": "-73.20308000"
                    },
                    {
                        "id": 112468,
                        "name": "Blue Hills",
                        "latitude": "41.81288000",
                        "longitude": "-72.69759000"
                    },
                    {
                        "id": 112693,
                        "name": "Branford",
                        "latitude": "41.27954000",
                        "longitude": "-72.81510000"
                    },
                    {
                        "id": 112694,
                        "name": "Branford Center",
                        "latitude": "41.27738000",
                        "longitude": "-72.81511000"
                    },
                    {
                        "id": 112766,
                        "name": "Bridgeport",
                        "latitude": "41.17923000",
                        "longitude": "-73.18945000"
                    },
                    {
                        "id": 112809,
                        "name": "Bristol",
                        "latitude": "41.67176000",
                        "longitude": "-72.94927000"
                    },
                    {
                        "id": 113140,
                        "name": "Byram",
                        "latitude": "41.00426000",
                        "longitude": "-73.65374000"
                    },
                    {
                        "id": 113313,
                        "name": "Canaan",
                        "latitude": "42.02731000",
                        "longitude": "-73.32928000"
                    },
                    {
                        "id": 113351,
                        "name": "Canton Valley",
                        "latitude": "41.83426000",
                        "longitude": "-72.89177000"
                    },
                    {
                        "id": 113684,
                        "name": "Central Waterford",
                        "latitude": "41.34504000",
                        "longitude": "-72.12948000"
                    },
                    {
                        "id": 113877,
                        "name": "Cheshire",
                        "latitude": "41.49899000",
                        "longitude": "-72.90066000"
                    },
                    {
                        "id": 113879,
                        "name": "Cheshire Village",
                        "latitude": "41.50260000",
                        "longitude": "-72.89952000"
                    },
                    {
                        "id": 113894,
                        "name": "Chester Center",
                        "latitude": "41.40132000",
                        "longitude": "-72.45270000"
                    },
                    {
                        "id": 114071,
                        "name": "City of Milford (balance)",
                        "latitude": "41.22374000",
                        "longitude": "-73.06164000"
                    },
                    {
                        "id": 114285,
                        "name": "Clinton",
                        "latitude": "41.27871000",
                        "longitude": "-72.52759000"
                    },
                    {
                        "id": 114383,
                        "name": "Colchester",
                        "latitude": "41.57565000",
                        "longitude": "-72.33203000"
                    },
                    {
                        "id": 114439,
                        "name": "Collinsville",
                        "latitude": "41.81288000",
                        "longitude": "-72.92010000"
                    },
                    {
                        "id": 114566,
                        "name": "Conning Towers-Nautilus Park",
                        "latitude": "41.38548000",
                        "longitude": "-72.06877000"
                    },
                    {
                        "id": 114684,
                        "name": "Cos Cob",
                        "latitude": "41.03343000",
                        "longitude": "-73.59957000"
                    },
                    {
                        "id": 114733,
                        "name": "Coventry Lake",
                        "latitude": "41.77232000",
                        "longitude": "-72.33258000"
                    },
                    {
                        "id": 114835,
                        "name": "Cromwell",
                        "latitude": "41.59510000",
                        "longitude": "-72.64537000"
                    },
                    {
                        "id": 114879,
                        "name": "Crystal Lake",
                        "latitude": "41.93176000",
                        "longitude": "-72.37842000"
                    },
                    {
                        "id": 115015,
                        "name": "Danbury",
                        "latitude": "41.39482000",
                        "longitude": "-73.45401000"
                    },
                    {
                        "id": 115025,
                        "name": "Danielson",
                        "latitude": "41.80260000",
                        "longitude": "-71.88591000"
                    },
                    {
                        "id": 115046,
                        "name": "Darien",
                        "latitude": "41.07871000",
                        "longitude": "-73.46929000"
                    },
                    {
                        "id": 115170,
                        "name": "Deep River Center",
                        "latitude": "41.38221000",
                        "longitude": "-72.43862000"
                    },
                    {
                        "id": 115261,
                        "name": "Derby",
                        "latitude": "41.32065000",
                        "longitude": "-73.08900000"
                    },
                    {
                        "id": 115570,
                        "name": "Durham",
                        "latitude": "41.48176000",
                        "longitude": "-72.68121000"
                    },
                    {
                        "id": 115640,
                        "name": "East Brooklyn",
                        "latitude": "41.79677000",
                        "longitude": "-71.89729000"
                    },
                    {
                        "id": 115677,
                        "name": "East Haddam",
                        "latitude": "41.45315000",
                        "longitude": "-72.46120000"
                    },
                    {
                        "id": 115678,
                        "name": "East Hampton",
                        "latitude": "41.57593000",
                        "longitude": "-72.50259000"
                    },
                    {
                        "id": 115684,
                        "name": "East Hartford",
                        "latitude": "41.78232000",
                        "longitude": "-72.61203000"
                    },
                    {
                        "id": 115686,
                        "name": "East Haven",
                        "latitude": "41.27621000",
                        "longitude": "-72.86843000"
                    },
                    {
                        "id": 115723,
                        "name": "East Norwalk",
                        "latitude": "41.10565000",
                        "longitude": "-73.39845000"
                    },
                    {
                        "id": 115774,
                        "name": "East Windsor",
                        "latitude": "41.91232000",
                        "longitude": "-72.54509000"
                    },
                    {
                        "id": 115786,
                        "name": "Easton",
                        "latitude": "41.25287000",
                        "longitude": "-73.29734000"
                    },
                    {
                        "id": 116026,
                        "name": "Ellington",
                        "latitude": "41.90399000",
                        "longitude": "-72.46981000"
                    },
                    {
                        "id": 116125,
                        "name": "Enfield",
                        "latitude": "41.97621000",
                        "longitude": "-72.59176000"
                    },
                    {
                        "id": 116200,
                        "name": "Essex Village",
                        "latitude": "41.35544000",
                        "longitude": "-72.39101000"
                    },
                    {
                        "id": 116312,
                        "name": "Fairfield",
                        "latitude": "41.14121000",
                        "longitude": "-73.26373000"
                    },
                    {
                        "id": 116320,
                        "name": "Fairfield County",
                        "latitude": "41.22496000",
                        "longitude": "-73.37120000"
                    },
                    {
                        "id": 116415,
                        "name": "Farmington",
                        "latitude": "41.71982000",
                        "longitude": "-72.83204000"
                    },
                    {
                        "id": 117026,
                        "name": "Gales Ferry",
                        "latitude": "41.42982000",
                        "longitude": "-72.08202000"
                    },
                    {
                        "id": 117161,
                        "name": "Georgetown",
                        "latitude": "41.25565000",
                        "longitude": "-73.43484000"
                    },
                    {
                        "id": 117255,
                        "name": "Glastonbury",
                        "latitude": "41.71232000",
                        "longitude": "-72.60815000"
                    },
                    {
                        "id": 117256,
                        "name": "Glastonbury Center",
                        "latitude": "41.70093000",
                        "longitude": "-72.59953000"
                    },
                    {
                        "id": 117311,
                        "name": "Glenville",
                        "latitude": "41.03538000",
                        "longitude": "-73.65985000"
                    },
                    {
                        "id": 117698,
                        "name": "Greenwich",
                        "latitude": "41.02649000",
                        "longitude": "-73.62846000"
                    },
                    {
                        "id": 117749,
                        "name": "Groton",
                        "latitude": "41.35010000",
                        "longitude": "-72.07841000"
                    },
                    {
                        "id": 117784,
                        "name": "Guilford",
                        "latitude": "41.28899000",
                        "longitude": "-72.68176000"
                    },
                    {
                        "id": 117786,
                        "name": "Guilford Center",
                        "latitude": "41.28156000",
                        "longitude": "-72.67619000"
                    },
                    {
                        "id": 117886,
                        "name": "Hamden",
                        "latitude": "41.39593000",
                        "longitude": "-72.89677000"
                    },
                    {
                        "id": 118087,
                        "name": "Hartford",
                        "latitude": "41.76371000",
                        "longitude": "-72.68509000"
                    },
                    {
                        "id": 118095,
                        "name": "Hartford County",
                        "latitude": "41.80642000",
                        "longitude": "-72.73284000"
                    },
                    {
                        "id": 118201,
                        "name": "Hazardville",
                        "latitude": "41.98732000",
                        "longitude": "-72.54481000"
                    },
                    {
                        "id": 118234,
                        "name": "Hebron",
                        "latitude": "41.65788000",
                        "longitude": "-72.36592000"
                    },
                    {
                        "id": 118322,
                        "name": "Heritage Village",
                        "latitude": "41.48565000",
                        "longitude": "-73.23789000"
                    },
                    {
                        "id": 118383,
                        "name": "Higganum",
                        "latitude": "41.49704000",
                        "longitude": "-72.55703000"
                    },
                    {
                        "id": 119245,
                        "name": "Jewett City",
                        "latitude": "41.60677000",
                        "longitude": "-71.98091000"
                    },
                    {
                        "id": 119481,
                        "name": "Kensington",
                        "latitude": "41.63538000",
                        "longitude": "-72.76871000"
                    },
                    {
                        "id": 119486,
                        "name": "Kent",
                        "latitude": "41.72482000",
                        "longitude": "-73.47707000"
                    },
                    {
                        "id": 119561,
                        "name": "Killingly Center",
                        "latitude": "41.83871000",
                        "longitude": "-71.86924000"
                    },
                    {
                        "id": 119965,
                        "name": "Lake Pocotopaug",
                        "latitude": "41.59843000",
                        "longitude": "-72.51037000"
                    },
                    {
                        "id": 120302,
                        "name": "Ledyard",
                        "latitude": "41.43982000",
                        "longitude": "-72.01424000"
                    },
                    {
                        "id": 120597,
                        "name": "Lisbon",
                        "latitude": "41.60399000",
                        "longitude": "-72.01174000"
                    },
                    {
                        "id": 120604,
                        "name": "Litchfield",
                        "latitude": "41.74732000",
                        "longitude": "-73.18872000"
                    },
                    {
                        "id": 120608,
                        "name": "Litchfield County",
                        "latitude": "41.79249000",
                        "longitude": "-73.24532000"
                    },
                    {
                        "id": 120744,
                        "name": "Long Hill",
                        "latitude": "41.35399000",
                        "longitude": "-72.05230000"
                    },
                    {
                        "id": 120992,
                        "name": "Madison",
                        "latitude": "41.27954000",
                        "longitude": "-72.59843000"
                    },
                    {
                        "id": 121001,
                        "name": "Madison Center",
                        "latitude": "41.27925000",
                        "longitude": "-72.60048000"
                    },
                    {
                        "id": 121094,
                        "name": "Manchester",
                        "latitude": "41.77593000",
                        "longitude": "-72.52148000"
                    },
                    {
                        "id": 121149,
                        "name": "Mansfield City",
                        "latitude": "41.76593000",
                        "longitude": "-72.23369000"
                    },
                    {
                        "id": 121689,
                        "name": "Meriden",
                        "latitude": "41.53815000",
                        "longitude": "-72.80704000"
                    },
                    {
                        "id": 121771,
                        "name": "Middlebury",
                        "latitude": "41.52787000",
                        "longitude": "-73.12761000"
                    },
                    {
                        "id": 121779,
                        "name": "Middlesex County",
                        "latitude": "41.43538000",
                        "longitude": "-72.52312000"
                    },
                    {
                        "id": 121788,
                        "name": "Middletown",
                        "latitude": "41.56232000",
                        "longitude": "-72.65065000"
                    },
                    {
                        "id": 121847,
                        "name": "Milford",
                        "latitude": "41.22232000",
                        "longitude": "-73.05650000"
                    },
                    {
                        "id": 122189,
                        "name": "Montville Center",
                        "latitude": "41.47899000",
                        "longitude": "-72.15119000"
                    },
                    {
                        "id": 122194,
                        "name": "Moodus",
                        "latitude": "41.50288000",
                        "longitude": "-72.45009000"
                    },
                    {
                        "id": 122217,
                        "name": "Moosup",
                        "latitude": "41.71288000",
                        "longitude": "-71.88091000"
                    },
                    {
                        "id": 122526,
                        "name": "Mystic",
                        "latitude": "41.35427000",
                        "longitude": "-71.96646000"
                    },
                    {
                        "id": 122595,
                        "name": "Naugatuck",
                        "latitude": "41.48593000",
                        "longitude": "-73.05066000"
                    },
                    {
                        "id": 122674,
                        "name": "New Britain",
                        "latitude": "41.66121000",
                        "longitude": "-72.77954000"
                    },
                    {
                        "id": 122679,
                        "name": "New Canaan",
                        "latitude": "41.14676000",
                        "longitude": "-73.49484000"
                    },
                    {
                        "id": 122705,
                        "name": "New Fairfield",
                        "latitude": "41.46648000",
                        "longitude": "-73.48568000"
                    },
                    {
                        "id": 122713,
                        "name": "New Hartford Center",
                        "latitude": "41.87996000",
                        "longitude": "-72.97530000"
                    },
                    {
                        "id": 122716,
                        "name": "New Haven",
                        "latitude": "41.30815000",
                        "longitude": "-72.92816000"
                    },
                    {
                        "id": 122719,
                        "name": "New Haven County",
                        "latitude": "41.34882000",
                        "longitude": "-72.89986000"
                    },
                    {
                        "id": 122741,
                        "name": "New London",
                        "latitude": "41.35565000",
                        "longitude": "-72.09952000"
                    },
                    {
                        "id": 122746,
                        "name": "New London County",
                        "latitude": "41.46678000",
                        "longitude": "-72.10650000"
                    },
                    {
                        "id": 122754,
                        "name": "New Milford",
                        "latitude": "41.57704000",
                        "longitude": "-73.40845000"
                    },
                    {
                        "id": 122767,
                        "name": "New Preston",
                        "latitude": "41.67510000",
                        "longitude": "-73.35179000"
                    },
                    {
                        "id": 122831,
                        "name": "Newington",
                        "latitude": "41.69788000",
                        "longitude": "-72.72371000"
                    },
                    {
                        "id": 122875,
                        "name": "Newtown",
                        "latitude": "41.41398000",
                        "longitude": "-73.30345000"
                    },
                    {
                        "id": 122883,
                        "name": "Niantic",
                        "latitude": "41.32538000",
                        "longitude": "-72.19313000"
                    },
                    {
                        "id": 122915,
                        "name": "Noank",
                        "latitude": "41.32788000",
                        "longitude": "-71.99063000"
                    },
                    {
                        "id": 122995,
                        "name": "North Branford",
                        "latitude": "41.32760000",
                        "longitude": "-72.76732000"
                    },
                    {
                        "id": 123031,
                        "name": "North Granby",
                        "latitude": "41.99593000",
                        "longitude": "-72.82954000"
                    },
                    {
                        "id": 123033,
                        "name": "North Grosvenor Dale",
                        "latitude": "41.98565000",
                        "longitude": "-71.89868000"
                    },
                    {
                        "id": 123037,
                        "name": "North Haven",
                        "latitude": "41.39093000",
                        "longitude": "-72.85954000"
                    },
                    {
                        "id": 123111,
                        "name": "North Stamford",
                        "latitude": "41.13815000",
                        "longitude": "-73.54346000"
                    },
                    {
                        "id": 123177,
                        "name": "Northwest Harwinton",
                        "latitude": "41.77685000",
                        "longitude": "-73.07922000"
                    },
                    {
                        "id": 123190,
                        "name": "Norwalk",
                        "latitude": "41.11760000",
                        "longitude": "-73.40790000"
                    },
                    {
                        "id": 123195,
                        "name": "Norwich",
                        "latitude": "41.52426000",
                        "longitude": "-72.07591000"
                    },
                    {
                        "id": 123307,
                        "name": "Oakville",
                        "latitude": "41.59343000",
                        "longitude": "-73.08539000"
                    },
                    {
                        "id": 123420,
                        "name": "Old Greenwich",
                        "latitude": "41.02287000",
                        "longitude": "-73.56485000"
                    },
                    {
                        "id": 123423,
                        "name": "Old Mystic",
                        "latitude": "41.39149000",
                        "longitude": "-71.96174000"
                    },
                    {
                        "id": 123427,
                        "name": "Old Saybrook",
                        "latitude": "41.29177000",
                        "longitude": "-72.37620000"
                    },
                    {
                        "id": 123428,
                        "name": "Old Saybrook Center",
                        "latitude": "41.29150000",
                        "longitude": "-72.36528000"
                    },
                    {
                        "id": 123507,
                        "name": "Orange",
                        "latitude": "41.27843000",
                        "longitude": "-73.02566000"
                    },
                    {
                        "id": 123681,
                        "name": "Oxford",
                        "latitude": "41.43399000",
                        "longitude": "-73.11678000"
                    },
                    {
                        "id": 123690,
                        "name": "Oxoboxo River",
                        "latitude": "41.44391000",
                        "longitude": "-72.12502000"
                    },
                    {
                        "id": 123929,
                        "name": "Pawcatuck",
                        "latitude": "41.37732000",
                        "longitude": "-71.83368000"
                    },
                    {
                        "id": 124002,
                        "name": "Pemberwick",
                        "latitude": "41.02565000",
                        "longitude": "-73.66068000"
                    },
                    {
                        "id": 124319,
                        "name": "Plainfield",
                        "latitude": "41.67649000",
                        "longitude": "-71.91507000"
                    },
                    {
                        "id": 124322,
                        "name": "Plainfield Village",
                        "latitude": "41.67686000",
                        "longitude": "-71.92489000"
                    },
                    {
                        "id": 124334,
                        "name": "Plainville",
                        "latitude": "41.67454000",
                        "longitude": "-72.85816000"
                    },
                    {
                        "id": 124400,
                        "name": "Plymouth",
                        "latitude": "41.67204000",
                        "longitude": "-73.05289000"
                    },
                    {
                        "id": 124488,
                        "name": "Poquonock Bridge",
                        "latitude": "41.34510000",
                        "longitude": "-72.02480000"
                    },
                    {
                        "id": 124559,
                        "name": "Portland",
                        "latitude": "41.57288000",
                        "longitude": "-72.64065000"
                    },
                    {
                        "id": 124658,
                        "name": "Preston City",
                        "latitude": "41.52899000",
                        "longitude": "-71.97396000"
                    },
                    {
                        "id": 124706,
                        "name": "Prospect",
                        "latitude": "41.50232000",
                        "longitude": "-72.97872000"
                    },
                    {
                        "id": 124760,
                        "name": "Putnam",
                        "latitude": "41.91510000",
                        "longitude": "-71.90896000"
                    },
                    {
                        "id": 124801,
                        "name": "Quinebaug",
                        "latitude": "42.02371000",
                        "longitude": "-71.94980000"
                    },
                    {
                        "id": 125119,
                        "name": "Ridgefield",
                        "latitude": "41.28148000",
                        "longitude": "-73.49818000"
                    },
                    {
                        "id": 125204,
                        "name": "Riverside",
                        "latitude": "41.03371000",
                        "longitude": "-73.57818000"
                    },
                    {
                        "id": 125323,
                        "name": "Rockville",
                        "latitude": "41.86676000",
                        "longitude": "-72.44953000"
                    },
                    {
                        "id": 125732,
                        "name": "Salem",
                        "latitude": "41.49038000",
                        "longitude": "-72.27536000"
                    },
                    {
                        "id": 125764,
                        "name": "Salmon Brook",
                        "latitude": "41.95649000",
                        "longitude": "-72.79537000"
                    },
                    {
                        "id": 125986,
                        "name": "Saybrook Manor",
                        "latitude": "41.28538000",
                        "longitude": "-72.39897000"
                    },
                    {
                        "id": 126196,
                        "name": "Seymour",
                        "latitude": "41.39676000",
                        "longitude": "-73.07594000"
                    },
                    {
                        "id": 126297,
                        "name": "Shelton",
                        "latitude": "41.31649000",
                        "longitude": "-73.09316000"
                    },
                    {
                        "id": 126331,
                        "name": "Sherman",
                        "latitude": "41.57926000",
                        "longitude": "-73.49568000"
                    },
                    {
                        "id": 126343,
                        "name": "Sherwood Manor",
                        "latitude": "42.01343000",
                        "longitude": "-72.56425000"
                    },
                    {
                        "id": 126453,
                        "name": "Simsbury Center",
                        "latitude": "41.88088000",
                        "longitude": "-72.81116000"
                    },
                    {
                        "id": 126575,
                        "name": "Somers",
                        "latitude": "41.98537000",
                        "longitude": "-72.44620000"
                    },
                    {
                        "id": 126644,
                        "name": "South Coventry",
                        "latitude": "41.77010000",
                        "longitude": "-72.30508000"
                    },
                    {
                        "id": 126751,
                        "name": "South Windham",
                        "latitude": "41.67954000",
                        "longitude": "-72.17036000"
                    },
                    {
                        "id": 126753,
                        "name": "South Windsor",
                        "latitude": "41.82371000",
                        "longitude": "-72.62120000"
                    },
                    {
                        "id": 126754,
                        "name": "South Woodstock",
                        "latitude": "41.93899000",
                        "longitude": "-71.95952000"
                    },
                    {
                        "id": 126763,
                        "name": "Southbury",
                        "latitude": "41.48148000",
                        "longitude": "-73.21317000"
                    },
                    {
                        "id": 126784,
                        "name": "Southport",
                        "latitude": "41.13649000",
                        "longitude": "-73.28345000"
                    },
                    {
                        "id": 126792,
                        "name": "Southwood Acres",
                        "latitude": "41.96260000",
                        "longitude": "-72.57148000"
                    },
                    {
                        "id": 126934,
                        "name": "Stafford",
                        "latitude": "41.98482000",
                        "longitude": "-72.28897000"
                    },
                    {
                        "id": 126938,
                        "name": "Stafford Springs",
                        "latitude": "41.95426000",
                        "longitude": "-72.30230000"
                    },
                    {
                        "id": 126944,
                        "name": "Stamford",
                        "latitude": "41.05343000",
                        "longitude": "-73.53873000"
                    },
                    {
                        "id": 127105,
                        "name": "Storrs",
                        "latitude": "41.80843000",
                        "longitude": "-72.24952000"
                    },
                    {
                        "id": 127124,
                        "name": "Stratford",
                        "latitude": "41.18454000",
                        "longitude": "-73.13317000"
                    },
                    {
                        "id": 127165,
                        "name": "Suffield Depot",
                        "latitude": "41.98121000",
                        "longitude": "-72.64981000"
                    },
                    {
                        "id": 127430,
                        "name": "Tariffville",
                        "latitude": "41.90871000",
                        "longitude": "-72.76010000"
                    },
                    {
                        "id": 127519,
                        "name": "Terramuggus",
                        "latitude": "41.63510000",
                        "longitude": "-72.47036000"
                    },
                    {
                        "id": 127535,
                        "name": "Terryville",
                        "latitude": "41.67815000",
                        "longitude": "-73.01094000"
                    },
                    {
                        "id": 127584,
                        "name": "Thomaston",
                        "latitude": "41.67399000",
                        "longitude": "-73.07316000"
                    },
                    {
                        "id": 127590,
                        "name": "Thompson",
                        "latitude": "41.95871000",
                        "longitude": "-71.86257000"
                    },
                    {
                        "id": 127594,
                        "name": "Thompsonville",
                        "latitude": "41.99704000",
                        "longitude": "-72.59898000"
                    },
                    {
                        "id": 127701,
                        "name": "Tolland",
                        "latitude": "41.87149000",
                        "longitude": "-72.36869000"
                    },
                    {
                        "id": 127702,
                        "name": "Tolland County",
                        "latitude": "41.85501000",
                        "longitude": "-72.33649000"
                    },
                    {
                        "id": 127744,
                        "name": "Torrington",
                        "latitude": "41.80065000",
                        "longitude": "-73.12122000"
                    },
                    {
                        "id": 127858,
                        "name": "Trumbull",
                        "latitude": "41.24287000",
                        "longitude": "-73.20067000"
                    },
                    {
                        "id": 127967,
                        "name": "Uncasville",
                        "latitude": "41.43454000",
                        "longitude": "-72.10980000"
                    },
                    {
                        "id": 128406,
                        "name": "Wallingford",
                        "latitude": "41.45704000",
                        "longitude": "-72.82316000"
                    },
                    {
                        "id": 128407,
                        "name": "Wallingford Center",
                        "latitude": "41.44987000",
                        "longitude": "-72.81892000"
                    },
                    {
                        "id": 128545,
                        "name": "Washington",
                        "latitude": "41.63148000",
                        "longitude": "-73.31067000"
                    },
                    {
                        "id": 128602,
                        "name": "Waterbury",
                        "latitude": "41.55815000",
                        "longitude": "-73.05150000"
                    },
                    {
                        "id": 128610,
                        "name": "Waterford",
                        "latitude": "41.34170000",
                        "longitude": "-72.13597000"
                    },
                    {
                        "id": 128620,
                        "name": "Watertown",
                        "latitude": "41.60621000",
                        "longitude": "-73.11817000"
                    },
                    {
                        "id": 128658,
                        "name": "Wauregan",
                        "latitude": "41.74427000",
                        "longitude": "-71.90924000"
                    },
                    {
                        "id": 128720,
                        "name": "Weatogue",
                        "latitude": "41.84371000",
                        "longitude": "-72.82843000"
                    },
                    {
                        "id": 128885,
                        "name": "West Hartford",
                        "latitude": "41.76204000",
                        "longitude": "-72.74204000"
                    },
                    {
                        "id": 128887,
                        "name": "West Haven",
                        "latitude": "41.27065000",
                        "longitude": "-72.94705000"
                    },
                    {
                        "id": 128982,
                        "name": "West Simsbury",
                        "latitude": "41.87315000",
                        "longitude": "-72.85815000"
                    },
                    {
                        "id": 128991,
                        "name": "West Torrington",
                        "latitude": "41.81843000",
                        "longitude": "-73.14372000"
                    },
                    {
                        "id": 129014,
                        "name": "Westbrook Center",
                        "latitude": "41.27997000",
                        "longitude": "-72.44254000"
                    },
                    {
                        "id": 129072,
                        "name": "Westport",
                        "latitude": "41.14149000",
                        "longitude": "-73.35790000"
                    },
                    {
                        "id": 129090,
                        "name": "Wethersfield",
                        "latitude": "41.71427000",
                        "longitude": "-72.65259000"
                    },
                    {
                        "id": 129293,
                        "name": "Willimantic",
                        "latitude": "41.71065000",
                        "longitude": "-72.20813000"
                    },
                    {
                        "id": 129342,
                        "name": "Wilton",
                        "latitude": "41.19537000",
                        "longitude": "-73.43790000"
                    },
                    {
                        "id": 129362,
                        "name": "Winchester Center",
                        "latitude": "41.90010000",
                        "longitude": "-73.13483000"
                    },
                    {
                        "id": 129371,
                        "name": "Windham",
                        "latitude": "41.69982000",
                        "longitude": "-72.15702000"
                    },
                    {
                        "id": 129373,
                        "name": "Windham County",
                        "latitude": "41.83003000",
                        "longitude": "-71.98749000"
                    },
                    {
                        "id": 129382,
                        "name": "Windsor",
                        "latitude": "41.85260000",
                        "longitude": "-72.64370000"
                    },
                    {
                        "id": 129390,
                        "name": "Windsor Locks",
                        "latitude": "41.92926000",
                        "longitude": "-72.62731000"
                    },
                    {
                        "id": 129430,
                        "name": "Winsted",
                        "latitude": "41.92121000",
                        "longitude": "-73.06011000"
                    },
                    {
                        "id": 129468,
                        "name": "Wolcott",
                        "latitude": "41.60232000",
                        "longitude": "-72.98677000"
                    },
                    {
                        "id": 129499,
                        "name": "Woodbridge",
                        "latitude": "41.35260000",
                        "longitude": "-73.00844000"
                    },
                    {
                        "id": 129508,
                        "name": "Woodbury",
                        "latitude": "41.54454000",
                        "longitude": "-73.20900000"
                    },
                    {
                        "id": 129511,
                        "name": "Woodbury Center",
                        "latitude": "41.54453000",
                        "longitude": "-73.20476000"
                    },
                    {
                        "id": 129542,
                        "name": "Woodmont",
                        "latitude": "41.22815000",
                        "longitude": "-72.99149000"
                    }
                ]
            },
            {
                "id": 1399,
                "name": "Delaware",
                "iso2": "DE",
                "latitude": "38.91083250",
                "longitude": "-75.52766990",
                "type": "state",
                "cities": [
                    {
                        "id": 111974,
                        "name": "Bear",
                        "latitude": "39.62928000",
                        "longitude": "-75.65826000"
                    },
                    {
                        "id": 112098,
                        "name": "Bellefonte",
                        "latitude": "39.76622000",
                        "longitude": "-75.50936000"
                    },
                    {
                        "id": 112277,
                        "name": "Bethany Beach",
                        "latitude": "38.53956000",
                        "longitude": "-75.05518000"
                    },
                    {
                        "id": 112401,
                        "name": "Blades",
                        "latitude": "38.63567000",
                        "longitude": "-75.60993000"
                    },
                    {
                        "id": 112772,
                        "name": "Bridgeville",
                        "latitude": "38.74261000",
                        "longitude": "-75.60437000"
                    },
                    {
                        "id": 112887,
                        "name": "Brookside",
                        "latitude": "39.66706000",
                        "longitude": "-75.72688000"
                    },
                    {
                        "id": 113261,
                        "name": "Camden",
                        "latitude": "39.11345000",
                        "longitude": "-75.54187000"
                    },
                    {
                        "id": 113914,
                        "name": "Cheswold",
                        "latitude": "39.21928000",
                        "longitude": "-75.58576000"
                    },
                    {
                        "id": 114192,
                        "name": "Claymont",
                        "latitude": "39.80067000",
                        "longitude": "-75.45964000"
                    },
                    {
                        "id": 114197,
                        "name": "Clayton",
                        "latitude": "39.29067000",
                        "longitude": "-75.63437000"
                    },
                    {
                        "id": 115203,
                        "name": "Delaware City",
                        "latitude": "39.57789000",
                        "longitude": "-75.58881000"
                    },
                    {
                        "id": 115217,
                        "name": "Delmar",
                        "latitude": "38.45651000",
                        "longitude": "-75.57715000"
                    },
                    {
                        "id": 115445,
                        "name": "Dover",
                        "latitude": "39.15817000",
                        "longitude": "-75.52437000"
                    },
                    {
                        "id": 115453,
                        "name": "Dover Base Housing",
                        "latitude": "39.11763000",
                        "longitude": "-75.48393000"
                    },
                    {
                        "id": 115847,
                        "name": "Edgemoor",
                        "latitude": "39.75011000",
                        "longitude": "-75.49964000"
                    },
                    {
                        "id": 116070,
                        "name": "Elsmere",
                        "latitude": "39.73928000",
                        "longitude": "-75.59798000"
                    },
                    {
                        "id": 116470,
                        "name": "Felton",
                        "latitude": "39.00845000",
                        "longitude": "-75.57798000"
                    },
                    {
                        "id": 117155,
                        "name": "Georgetown",
                        "latitude": "38.69011000",
                        "longitude": "-75.38547000"
                    },
                    {
                        "id": 117245,
                        "name": "Glasgow",
                        "latitude": "39.60483000",
                        "longitude": "-75.74521000"
                    },
                    {
                        "id": 117681,
                        "name": "Greenville",
                        "latitude": "39.77900000",
                        "longitude": "-75.59826000"
                    },
                    {
                        "id": 117700,
                        "name": "Greenwood",
                        "latitude": "38.80706000",
                        "longitude": "-75.59132000"
                    },
                    {
                        "id": 118041,
                        "name": "Harrington",
                        "latitude": "38.92372000",
                        "longitude": "-75.57770000"
                    },
                    {
                        "id": 118401,
                        "name": "Highland Acres",
                        "latitude": "39.12095000",
                        "longitude": "-75.52187000"
                    },
                    {
                        "id": 118503,
                        "name": "Hockessin",
                        "latitude": "39.78761000",
                        "longitude": "-75.69660000"
                    },
                    {
                        "id": 119488,
                        "name": "Kent Acres",
                        "latitude": "39.13178000",
                        "longitude": "-75.52492000"
                    },
                    {
                        "id": 119490,
                        "name": "Kent County",
                        "latitude": "39.09595000",
                        "longitude": "-75.50461000"
                    },
                    {
                        "id": 120187,
                        "name": "Laurel",
                        "latitude": "38.55650000",
                        "longitude": "-75.57131000"
                    },
                    {
                        "id": 120410,
                        "name": "Lewes",
                        "latitude": "38.77456000",
                        "longitude": "-75.13935000"
                    },
                    {
                        "id": 120748,
                        "name": "Long Neck",
                        "latitude": "38.62011000",
                        "longitude": "-75.15074000"
                    },
                    {
                        "id": 121785,
                        "name": "Middletown",
                        "latitude": "39.44956000",
                        "longitude": "-75.71632000"
                    },
                    {
                        "id": 121846,
                        "name": "Milford",
                        "latitude": "38.91261000",
                        "longitude": "-75.42797000"
                    },
                    {
                        "id": 121900,
                        "name": "Millsboro",
                        "latitude": "38.59150000",
                        "longitude": "-75.29130000"
                    },
                    {
                        "id": 121911,
                        "name": "Milton",
                        "latitude": "38.77761000",
                        "longitude": "-75.30991000"
                    },
                    {
                        "id": 122683,
                        "name": "New Castle",
                        "latitude": "39.66206000",
                        "longitude": "-75.56631000"
                    },
                    {
                        "id": 122690,
                        "name": "New Castle County",
                        "latitude": "39.57833000",
                        "longitude": "-75.63898000"
                    },
                    {
                        "id": 122799,
                        "name": "Newark",
                        "latitude": "39.68372000",
                        "longitude": "-75.74966000"
                    },
                    {
                        "id": 122838,
                        "name": "Newport",
                        "latitude": "39.71372000",
                        "longitude": "-75.60937000"
                    },
                    {
                        "id": 123112,
                        "name": "North Star",
                        "latitude": "39.76122000",
                        "longitude": "-75.71910000"
                    },
                    {
                        "id": 123338,
                        "name": "Ocean View",
                        "latitude": "38.54511000",
                        "longitude": "-75.08907000"
                    },
                    {
                        "id": 124194,
                        "name": "Pike Creek",
                        "latitude": "39.73095000",
                        "longitude": "-75.70410000"
                    },
                    {
                        "id": 124195,
                        "name": "Pike Creek Valley",
                        "latitude": "39.73622000",
                        "longitude": "-75.69827000"
                    },
                    {
                        "id": 125005,
                        "name": "Rehoboth Beach",
                        "latitude": "38.72095000",
                        "longitude": "-75.07601000"
                    },
                    {
                        "id": 125171,
                        "name": "Rising Sun-Lebanon",
                        "latitude": "39.09977000",
                        "longitude": "-75.50488000"
                    },
                    {
                        "id": 125217,
                        "name": "Riverview",
                        "latitude": "39.02650000",
                        "longitude": "-75.51076000"
                    },
                    {
                        "id": 125342,
                        "name": "Rodney Village",
                        "latitude": "39.13206000",
                        "longitude": "-75.53242000"
                    },
                    {
                        "id": 126085,
                        "name": "Seaford",
                        "latitude": "38.64123000",
                        "longitude": "-75.61104000"
                    },
                    {
                        "id": 126132,
                        "name": "Selbyville",
                        "latitude": "38.46039000",
                        "longitude": "-75.22074000"
                    },
                    {
                        "id": 126534,
                        "name": "Smyrna",
                        "latitude": "39.29983000",
                        "longitude": "-75.60465000"
                    },
                    {
                        "id": 127303,
                        "name": "Sussex County",
                        "latitude": "38.68330000",
                        "longitude": "-75.33954000"
                    },
                    {
                        "id": 127764,
                        "name": "Townsend",
                        "latitude": "39.39511000",
                        "longitude": "-75.69160000"
                    },
                    {
                        "id": 129321,
                        "name": "Wilmington",
                        "latitude": "39.74595000",
                        "longitude": "-75.54659000"
                    },
                    {
                        "id": 129326,
                        "name": "Wilmington Manor",
                        "latitude": "39.68678000",
                        "longitude": "-75.58437000"
                    },
                    {
                        "id": 129557,
                        "name": "Woodside East",
                        "latitude": "39.06756000",
                        "longitude": "-75.53748000"
                    },
                    {
                        "id": 129634,
                        "name": "Wyoming",
                        "latitude": "39.11817000",
                        "longitude": "-75.55881000"
                    }
                ]
            },
            {
                "id": 1437,
                "name": "District of Columbia",
                "iso2": "DC",
                "latitude": "38.90719230",
                "longitude": "-77.03687070",
                "type": "district",
                "cities": [
                    {
                        "id": 111028,
                        "name": "Adams Morgan",
                        "latitude": "38.92150000",
                        "longitude": "-77.04220000"
                    },
                    {
                        "id": 112444,
                        "name": "Bloomingdale",
                        "latitude": "38.91678000",
                        "longitude": "-77.01137000"
                    },
                    {
                        "id": 113920,
                        "name": "Chevy Chase",
                        "latitude": "38.96400000",
                        "longitude": "-77.06776000"
                    },
                    {
                        "id": 128587,
                        "name": "Washington D.C.",
                        "latitude": "38.89511000",
                        "longitude": "-77.03637000"
                    }
                ]
            },
            {
                "id": 1436,
                "name": "Florida",
                "iso2": "FL",
                "latitude": "27.21090890",
                "longitude": "-94.41216910",
                "type": "state",
                "cities": [
                    {
                        "id": 110972,
                        "name": "Aberdeen",
                        "latitude": "26.55063000",
                        "longitude": "-80.14866000"
                    },
                    {
                        "id": 111084,
                        "name": "Alachua",
                        "latitude": "29.75163000",
                        "longitude": "-82.42483000"
                    },
                    {
                        "id": 111085,
                        "name": "Alachua County",
                        "latitude": "29.67476000",
                        "longitude": "-82.35770000"
                    },
                    {
                        "id": 111086,
                        "name": "Alafaya",
                        "latitude": "28.56410000",
                        "longitude": "-81.21140000"
                    },
                    {
                        "id": 111177,
                        "name": "Allapattah",
                        "latitude": "25.81454000",
                        "longitude": "-80.22394000"
                    },
                    {
                        "id": 111237,
                        "name": "Altamonte Springs",
                        "latitude": "28.66111000",
                        "longitude": "-81.36562000"
                    },
                    {
                        "id": 111250,
                        "name": "Alturas",
                        "latitude": "27.87169000",
                        "longitude": "-81.71508000"
                    },
                    {
                        "id": 111255,
                        "name": "Alva",
                        "latitude": "26.71562000",
                        "longitude": "-81.61008000"
                    },
                    {
                        "id": 111321,
                        "name": "Andover",
                        "latitude": "25.96843000",
                        "longitude": "-80.21283000"
                    },
                    {
                        "id": 111348,
                        "name": "Anna Maria",
                        "latitude": "27.53115000",
                        "longitude": "-82.73343000"
                    },
                    {
                        "id": 111382,
                        "name": "Apalachicola",
                        "latitude": "29.72600000",
                        "longitude": "-84.98560000"
                    },
                    {
                        "id": 111388,
                        "name": "Apollo Beach",
                        "latitude": "27.77308000",
                        "longitude": "-82.40759000"
                    },
                    {
                        "id": 111389,
                        "name": "Apopka",
                        "latitude": "28.67617000",
                        "longitude": "-81.51186000"
                    },
                    {
                        "id": 111420,
                        "name": "Arcadia",
                        "latitude": "27.21588000",
                        "longitude": "-81.85842000"
                    },
                    {
                        "id": 111429,
                        "name": "Archer",
                        "latitude": "29.52997000",
                        "longitude": "-82.51900000"
                    },
                    {
                        "id": 111507,
                        "name": "Asbury Lake",
                        "latitude": "30.04913000",
                        "longitude": "-81.82149000"
                    },
                    {
                        "id": 111559,
                        "name": "Astatula",
                        "latitude": "28.70972000",
                        "longitude": "-81.73285000"
                    },
                    {
                        "id": 111560,
                        "name": "Astor",
                        "latitude": "29.16248000",
                        "longitude": "-81.52535000"
                    },
                    {
                        "id": 111595,
                        "name": "Atlantic Beach",
                        "latitude": "30.33441000",
                        "longitude": "-81.39870000"
                    },
                    {
                        "id": 111601,
                        "name": "Atlantis",
                        "latitude": "26.59090000",
                        "longitude": "-80.10088000"
                    },
                    {
                        "id": 111636,
                        "name": "Auburndale",
                        "latitude": "28.06530000",
                        "longitude": "-81.78869000"
                    },
                    {
                        "id": 111678,
                        "name": "Aventura",
                        "latitude": "25.95648000",
                        "longitude": "-80.13921000"
                    },
                    {
                        "id": 111696,
                        "name": "Avon Park",
                        "latitude": "27.59587000",
                        "longitude": "-81.50619000"
                    },
                    {
                        "id": 111709,
                        "name": "Azalea Park",
                        "latitude": "28.54111000",
                        "longitude": "-81.30062000"
                    },
                    {
                        "id": 111715,
                        "name": "Babson Park",
                        "latitude": "27.83197000",
                        "longitude": "-81.52230000"
                    },
                    {
                        "id": 111726,
                        "name": "Bagdad",
                        "latitude": "30.59880000",
                        "longitude": "-87.03223000"
                    },
                    {
                        "id": 111741,
                        "name": "Baker County",
                        "latitude": "30.33107000",
                        "longitude": "-82.28459000"
                    },
                    {
                        "id": 111747,
                        "name": "Bal Harbour",
                        "latitude": "25.89176000",
                        "longitude": "-80.12699000"
                    },
                    {
                        "id": 111753,
                        "name": "Baldwin",
                        "latitude": "30.30274000",
                        "longitude": "-81.97539000"
                    },
                    {
                        "id": 111778,
                        "name": "Balm",
                        "latitude": "27.75947000",
                        "longitude": "-82.26120000"
                    },
                    {
                        "id": 111872,
                        "name": "Bartow",
                        "latitude": "27.89641000",
                        "longitude": "-81.84314000"
                    },
                    {
                        "id": 111924,
                        "name": "Bay County",
                        "latitude": "30.23765000",
                        "longitude": "-85.63262000"
                    },
                    {
                        "id": 111927,
                        "name": "Bay Harbor Islands",
                        "latitude": "25.88759000",
                        "longitude": "-80.13116000"
                    },
                    {
                        "id": 111928,
                        "name": "Bay Hill",
                        "latitude": "28.46806000",
                        "longitude": "-81.51618000"
                    },
                    {
                        "id": 111931,
                        "name": "Bay Pines",
                        "latitude": "27.81419000",
                        "longitude": "-82.77816000"
                    },
                    {
                        "id": 111944,
                        "name": "Bayonet Point",
                        "latitude": "28.32667000",
                        "longitude": "-82.68343000"
                    },
                    {
                        "id": 111954,
                        "name": "Bayshore Gardens",
                        "latitude": "27.42532000",
                        "longitude": "-82.59038000"
                    },
                    {
                        "id": 111969,
                        "name": "Beacon Square",
                        "latitude": "28.20862000",
                        "longitude": "-82.75538000"
                    },
                    {
                        "id": 112035,
                        "name": "Bee Ridge",
                        "latitude": "27.28394000",
                        "longitude": "-82.48065000"
                    },
                    {
                        "id": 112073,
                        "name": "Bellair-Meadowbrook Terrace",
                        "latitude": "30.17881000",
                        "longitude": "-81.74341000"
                    },
                    {
                        "id": 112082,
                        "name": "Belle Glade",
                        "latitude": "26.68451000",
                        "longitude": "-80.66756000"
                    },
                    {
                        "id": 112083,
                        "name": "Belle Glade Camp",
                        "latitude": "26.65757000",
                        "longitude": "-80.68284000"
                    },
                    {
                        "id": 112086,
                        "name": "Belle Isle",
                        "latitude": "28.45834000",
                        "longitude": "-81.35924000"
                    },
                    {
                        "id": 112094,
                        "name": "Belleair",
                        "latitude": "27.93585000",
                        "longitude": "-82.80621000"
                    },
                    {
                        "id": 112095,
                        "name": "Belleair Beach",
                        "latitude": "27.92308000",
                        "longitude": "-82.84316000"
                    },
                    {
                        "id": 112096,
                        "name": "Belleair Bluffs",
                        "latitude": "27.92141000",
                        "longitude": "-82.81705000"
                    },
                    {
                        "id": 112102,
                        "name": "Belleview",
                        "latitude": "29.05526000",
                        "longitude": "-82.06231000"
                    },
                    {
                        "id": 112128,
                        "name": "Bellview",
                        "latitude": "30.46159000",
                        "longitude": "-87.31497000"
                    },
                    {
                        "id": 112303,
                        "name": "Beverly Hills",
                        "latitude": "28.91692000",
                        "longitude": "-82.45815000"
                    },
                    {
                        "id": 112319,
                        "name": "Big Coppitt Key",
                        "latitude": "24.59653000",
                        "longitude": "-81.66009000"
                    },
                    {
                        "id": 112329,
                        "name": "Big Pine Key",
                        "latitude": "24.66987000",
                        "longitude": "-81.35397000"
                    },
                    {
                        "id": 112361,
                        "name": "Biscayne Park",
                        "latitude": "25.88260000",
                        "longitude": "-80.18060000"
                    },
                    {
                        "id": 112369,
                        "name": "Bithlo",
                        "latitude": "28.55472000",
                        "longitude": "-81.10645000"
                    },
                    {
                        "id": 112373,
                        "name": "Black Diamond",
                        "latitude": "28.91248000",
                        "longitude": "-82.48593000"
                    },
                    {
                        "id": 112445,
                        "name": "Bloomingdale",
                        "latitude": "27.89364000",
                        "longitude": "-82.24037000"
                    },
                    {
                        "id": 112459,
                        "name": "Blountstown",
                        "latitude": "30.44379000",
                        "longitude": "-85.04744000"
                    },
                    {
                        "id": 112492,
                        "name": "Boca Del Mar",
                        "latitude": "26.34508000",
                        "longitude": "-80.14671000"
                    },
                    {
                        "id": 112493,
                        "name": "Boca Pointe",
                        "latitude": "26.33313000",
                        "longitude": "-80.15949000"
                    },
                    {
                        "id": 112494,
                        "name": "Boca Raton",
                        "latitude": "26.35869000",
                        "longitude": "-80.08310000"
                    },
                    {
                        "id": 112511,
                        "name": "Bokeelia",
                        "latitude": "26.70563000",
                        "longitude": "-82.15898000"
                    },
                    {
                        "id": 112536,
                        "name": "Bonifay",
                        "latitude": "30.79186000",
                        "longitude": "-85.67965000"
                    },
                    {
                        "id": 112538,
                        "name": "Bonita Springs",
                        "latitude": "26.33981000",
                        "longitude": "-81.77870000"
                    },
                    {
                        "id": 112606,
                        "name": "Boulevard Gardens",
                        "latitude": "26.12326000",
                        "longitude": "-80.17997000"
                    },
                    {
                        "id": 112627,
                        "name": "Bowling Green",
                        "latitude": "27.63837000",
                        "longitude": "-81.82397000"
                    },
                    {
                        "id": 112647,
                        "name": "Boyette",
                        "latitude": "27.81753000",
                        "longitude": "-82.22259000"
                    },
                    {
                        "id": 112652,
                        "name": "Boynton Beach",
                        "latitude": "26.52535000",
                        "longitude": "-80.06643000"
                    },
                    {
                        "id": 112662,
                        "name": "Bradenton",
                        "latitude": "27.49893000",
                        "longitude": "-82.57482000"
                    },
                    {
                        "id": 112663,
                        "name": "Bradenton Beach",
                        "latitude": "27.46698000",
                        "longitude": "-82.70399000"
                    },
                    {
                        "id": 112668,
                        "name": "Bradford County",
                        "latitude": "29.94996000",
                        "longitude": "-82.16878000"
                    },
                    {
                        "id": 112688,
                        "name": "Brandon",
                        "latitude": "27.93780000",
                        "longitude": "-82.28592000"
                    },
                    {
                        "id": 112726,
                        "name": "Brent",
                        "latitude": "30.46881000",
                        "longitude": "-87.23608000"
                    },
                    {
                        "id": 112738,
                        "name": "Brevard County",
                        "latitude": "28.30031000",
                        "longitude": "-80.70121000"
                    },
                    {
                        "id": 112802,
                        "name": "Bristol",
                        "latitude": "30.43247000",
                        "longitude": "-84.97702000"
                    },
                    {
                        "id": 112828,
                        "name": "Broadview Park",
                        "latitude": "26.09953000",
                        "longitude": "-80.20866000"
                    },
                    {
                        "id": 112844,
                        "name": "Bronson",
                        "latitude": "29.44774000",
                        "longitude": "-82.64233000"
                    },
                    {
                        "id": 112880,
                        "name": "Brookridge",
                        "latitude": "28.55110000",
                        "longitude": "-82.49204000"
                    },
                    {
                        "id": 112890,
                        "name": "Brooksville",
                        "latitude": "28.55554000",
                        "longitude": "-82.38991000"
                    },
                    {
                        "id": 112904,
                        "name": "Broward County",
                        "latitude": "26.15186000",
                        "longitude": "-80.45589000"
                    },
                    {
                        "id": 112905,
                        "name": "Broward Estates",
                        "latitude": "26.12564000",
                        "longitude": "-80.19338000"
                    },
                    {
                        "id": 112928,
                        "name": "Brownsville",
                        "latitude": "25.82176000",
                        "longitude": "-80.24116000"
                    },
                    {
                        "id": 112982,
                        "name": "Buckhead Ridge",
                        "latitude": "27.13033000",
                        "longitude": "-80.89367000"
                    },
                    {
                        "id": 112984,
                        "name": "Buckingham",
                        "latitude": "26.67507000",
                        "longitude": "-81.73203000"
                    },
                    {
                        "id": 113006,
                        "name": "Buenaventura Lakes",
                        "latitude": "28.33584000",
                        "longitude": "-81.35313000"
                    },
                    {
                        "id": 113037,
                        "name": "Bunche Park",
                        "latitude": "25.92065000",
                        "longitude": "-80.23699000"
                    },
                    {
                        "id": 113045,
                        "name": "Bunnell",
                        "latitude": "29.46609000",
                        "longitude": "-81.25784000"
                    },
                    {
                        "id": 113092,
                        "name": "Burnt Store Marina",
                        "latitude": "26.76507000",
                        "longitude": "-82.05092000"
                    },
                    {
                        "id": 113101,
                        "name": "Bushnell",
                        "latitude": "28.66499000",
                        "longitude": "-82.11286000"
                    },
                    {
                        "id": 113113,
                        "name": "Butler Beach",
                        "latitude": "29.79830000",
                        "longitude": "-81.26701000"
                    },
                    {
                        "id": 113202,
                        "name": "Calhoun County",
                        "latitude": "30.40603000",
                        "longitude": "-85.19721000"
                    },
                    {
                        "id": 113222,
                        "name": "Callahan",
                        "latitude": "30.56218000",
                        "longitude": "-81.83066000"
                    },
                    {
                        "id": 113224,
                        "name": "Callaway",
                        "latitude": "30.15298000",
                        "longitude": "-85.56993000"
                    },
                    {
                        "id": 113296,
                        "name": "Campbell",
                        "latitude": "28.25890000",
                        "longitude": "-81.45646000"
                    },
                    {
                        "id": 113352,
                        "name": "Cantonment",
                        "latitude": "30.60853000",
                        "longitude": "-87.33998000"
                    },
                    {
                        "id": 113363,
                        "name": "Cape Canaveral",
                        "latitude": "28.40584000",
                        "longitude": "-80.60477000"
                    },
                    {
                        "id": 113366,
                        "name": "Cape Coral",
                        "latitude": "26.56285000",
                        "longitude": "-81.94953000"
                    },
                    {
                        "id": 113433,
                        "name": "Carol City",
                        "latitude": "25.94065000",
                        "longitude": "-80.24560000"
                    },
                    {
                        "id": 113441,
                        "name": "Carrabelle",
                        "latitude": "29.85326000",
                        "longitude": "-84.66435000"
                    },
                    {
                        "id": 113472,
                        "name": "Carrollwood",
                        "latitude": "28.05002000",
                        "longitude": "-82.49287000"
                    },
                    {
                        "id": 113473,
                        "name": "Carrollwood Village",
                        "latitude": "28.06752000",
                        "longitude": "-82.52093000"
                    },
                    {
                        "id": 113503,
                        "name": "Carver Ranches",
                        "latitude": "25.98842000",
                        "longitude": "-80.19227000"
                    },
                    {
                        "id": 113535,
                        "name": "Casselberry",
                        "latitude": "28.67778000",
                        "longitude": "-81.32785000"
                    },
                    {
                        "id": 113610,
                        "name": "Cedar Grove",
                        "latitude": "30.17103000",
                        "longitude": "-85.62520000"
                    },
                    {
                        "id": 113629,
                        "name": "Celebration",
                        "latitude": "28.32529000",
                        "longitude": "-81.53313000"
                    },
                    {
                        "id": 113643,
                        "name": "Center Hill",
                        "latitude": "28.64999000",
                        "longitude": "-81.99258000"
                    },
                    {
                        "id": 113697,
                        "name": "Century",
                        "latitude": "30.97324000",
                        "longitude": "-87.26386000"
                    },
                    {
                        "id": 113781,
                        "name": "Charlotte County",
                        "latitude": "26.89985000",
                        "longitude": "-81.95031000"
                    },
                    {
                        "id": 113785,
                        "name": "Charlotte Harbor",
                        "latitude": "26.95839000",
                        "longitude": "-82.06703000"
                    },
                    {
                        "id": 113786,
                        "name": "Charlotte Park",
                        "latitude": "26.91006000",
                        "longitude": "-82.05398000"
                    },
                    {
                        "id": 113808,
                        "name": "Chattahoochee",
                        "latitude": "30.70546000",
                        "longitude": "-84.84574000"
                    },
                    {
                        "id": 113918,
                        "name": "Cheval",
                        "latitude": "28.14862000",
                        "longitude": "-82.51454000"
                    },
                    {
                        "id": 113948,
                        "name": "Chiefland",
                        "latitude": "29.47496000",
                        "longitude": "-82.85984000"
                    },
                    {
                        "id": 113972,
                        "name": "Chipley",
                        "latitude": "30.78186000",
                        "longitude": "-85.53854000"
                    },
                    {
                        "id": 114001,
                        "name": "Christmas",
                        "latitude": "28.53639000",
                        "longitude": "-81.01756000"
                    },
                    {
                        "id": 114006,
                        "name": "Chuluota",
                        "latitude": "28.64194000",
                        "longitude": "-81.12340000"
                    },
                    {
                        "id": 114032,
                        "name": "Citra",
                        "latitude": "29.41192000",
                        "longitude": "-82.10982000"
                    },
                    {
                        "id": 114036,
                        "name": "Citrus County",
                        "latitude": "28.84757000",
                        "longitude": "-82.52011000"
                    },
                    {
                        "id": 114038,
                        "name": "Citrus Hills",
                        "latitude": "28.88831000",
                        "longitude": "-82.43260000"
                    },
                    {
                        "id": 114039,
                        "name": "Citrus Park",
                        "latitude": "28.07835000",
                        "longitude": "-82.56982000"
                    },
                    {
                        "id": 114041,
                        "name": "Citrus Ridge",
                        "latitude": "28.33385000",
                        "longitude": "-81.64232000"
                    },
                    {
                        "id": 114042,
                        "name": "Citrus Springs",
                        "latitude": "28.99748000",
                        "longitude": "-82.47065000"
                    },
                    {
                        "id": 114101,
                        "name": "Clarcona",
                        "latitude": "28.61278000",
                        "longitude": "-81.49868000"
                    },
                    {
                        "id": 114175,
                        "name": "Clay County",
                        "latitude": "29.98307000",
                        "longitude": "-81.85789000"
                    },
                    {
                        "id": 114222,
                        "name": "Clearwater",
                        "latitude": "27.96585000",
                        "longitude": "-82.80010000"
                    },
                    {
                        "id": 114238,
                        "name": "Clermont",
                        "latitude": "28.54944000",
                        "longitude": "-81.77285000"
                    },
                    {
                        "id": 114241,
                        "name": "Cleveland",
                        "latitude": "26.96173000",
                        "longitude": "-81.98398000"
                    },
                    {
                        "id": 114252,
                        "name": "Clewiston",
                        "latitude": "26.75423000",
                        "longitude": "-80.93368000"
                    },
                    {
                        "id": 114357,
                        "name": "Cocoa",
                        "latitude": "28.38612000",
                        "longitude": "-80.74200000"
                    },
                    {
                        "id": 114358,
                        "name": "Cocoa Beach",
                        "latitude": "28.32055000",
                        "longitude": "-80.60922000"
                    },
                    {
                        "id": 114359,
                        "name": "Cocoa West",
                        "latitude": "28.35942000",
                        "longitude": "-80.77109000"
                    },
                    {
                        "id": 114361,
                        "name": "Coconut Creek",
                        "latitude": "26.25175000",
                        "longitude": "-80.17894000"
                    },
                    {
                        "id": 114362,
                        "name": "Coconut Grove",
                        "latitude": "25.71260000",
                        "longitude": "-80.25699000"
                    },
                    {
                        "id": 114423,
                        "name": "Collier County",
                        "latitude": "26.09924000",
                        "longitude": "-81.38097000"
                    },
                    {
                        "id": 114478,
                        "name": "Columbia County",
                        "latitude": "30.22424000",
                        "longitude": "-82.62154000"
                    },
                    {
                        "id": 114515,
                        "name": "Combee Settlement",
                        "latitude": "28.05835000",
                        "longitude": "-81.90536000"
                    },
                    {
                        "id": 114565,
                        "name": "Connerton",
                        "latitude": "28.31441000",
                        "longitude": "-82.47539000"
                    },
                    {
                        "id": 114582,
                        "name": "Conway",
                        "latitude": "28.50278000",
                        "longitude": "-81.33062000"
                    },
                    {
                        "id": 114602,
                        "name": "Cooper City",
                        "latitude": "26.05731000",
                        "longitude": "-80.27172000"
                    },
                    {
                        "id": 114624,
                        "name": "Coral Gables",
                        "latitude": "25.72149000",
                        "longitude": "-80.26838000"
                    },
                    {
                        "id": 114626,
                        "name": "Coral Springs",
                        "latitude": "26.27119000",
                        "longitude": "-80.27060000"
                    },
                    {
                        "id": 114627,
                        "name": "Coral Terrace",
                        "latitude": "25.74593000",
                        "longitude": "-80.30450000"
                    },
                    {
                        "id": 114673,
                        "name": "Cortez",
                        "latitude": "27.46921000",
                        "longitude": "-82.68621000"
                    },
                    {
                        "id": 114714,
                        "name": "Country Club",
                        "latitude": "25.94815000",
                        "longitude": "-80.31700000"
                    },
                    {
                        "id": 114724,
                        "name": "Country Walk",
                        "latitude": "25.63399000",
                        "longitude": "-80.43228000"
                    },
                    {
                        "id": 114785,
                        "name": "Crawfordville",
                        "latitude": "30.17604000",
                        "longitude": "-84.37518000"
                    },
                    {
                        "id": 114795,
                        "name": "Crescent City",
                        "latitude": "29.43025000",
                        "longitude": "-81.51063000"
                    },
                    {
                        "id": 114807,
                        "name": "Crestview",
                        "latitude": "30.76213000",
                        "longitude": "-86.57051000"
                    },
                    {
                        "id": 114838,
                        "name": "Crooked Lake Park",
                        "latitude": "27.82919000",
                        "longitude": "-81.58397000"
                    },
                    {
                        "id": 114847,
                        "name": "Cross City",
                        "latitude": "29.63465000",
                        "longitude": "-83.12694000"
                    },
                    {
                        "id": 114878,
                        "name": "Crystal Lake",
                        "latitude": "28.03558000",
                        "longitude": "-81.90841000"
                    },
                    {
                        "id": 114882,
                        "name": "Crystal River",
                        "latitude": "28.90248000",
                        "longitude": "-82.59260000"
                    },
                    {
                        "id": 114883,
                        "name": "Crystal Springs",
                        "latitude": "28.18140000",
                        "longitude": "-82.15758000"
                    },
                    {
                        "id": 114891,
                        "name": "Cudjoe Key",
                        "latitude": "24.67153000",
                        "longitude": "-81.49842000"
                    },
                    {
                        "id": 114946,
                        "name": "Cutler",
                        "latitude": "25.61510000",
                        "longitude": "-80.31061000"
                    },
                    {
                        "id": 114948,
                        "name": "Cutler Bay",
                        "latitude": "25.57830000",
                        "longitude": "-80.33770000"
                    },
                    {
                        "id": 114949,
                        "name": "Cutler Ridge",
                        "latitude": "25.58066000",
                        "longitude": "-80.34672000"
                    },
                    {
                        "id": 114955,
                        "name": "Cypress Gardens",
                        "latitude": "27.99391000",
                        "longitude": "-81.69008000"
                    },
                    {
                        "id": 114957,
                        "name": "Cypress Lake",
                        "latitude": "26.53813000",
                        "longitude": "-81.89925000"
                    },
                    {
                        "id": 114958,
                        "name": "Cypress Quarters",
                        "latitude": "27.25199000",
                        "longitude": "-80.81395000"
                    },
                    {
                        "id": 114964,
                        "name": "Dade City",
                        "latitude": "28.36472000",
                        "longitude": "-82.19592000"
                    },
                    {
                        "id": 114965,
                        "name": "Dade City North",
                        "latitude": "28.38334000",
                        "longitude": "-82.19389000"
                    },
                    {
                        "id": 115021,
                        "name": "Dania Beach",
                        "latitude": "26.05231000",
                        "longitude": "-80.14393000"
                    },
                    {
                        "id": 115058,
                        "name": "Davenport",
                        "latitude": "28.16140000",
                        "longitude": "-81.60174000"
                    },
                    {
                        "id": 115067,
                        "name": "Davie",
                        "latitude": "26.06287000",
                        "longitude": "-80.23310000"
                    },
                    {
                        "id": 115102,
                        "name": "Daytona Beach",
                        "latitude": "29.21081000",
                        "longitude": "-81.02283000"
                    },
                    {
                        "id": 115103,
                        "name": "Daytona Beach Shores",
                        "latitude": "29.17609000",
                        "longitude": "-80.98283000"
                    },
                    {
                        "id": 115108,
                        "name": "De Land Southwest",
                        "latitude": "29.00770000",
                        "longitude": "-81.31129000"
                    },
                    {
                        "id": 115110,
                        "name": "De Leon Springs",
                        "latitude": "29.11989000",
                        "longitude": "-81.35286000"
                    },
                    {
                        "id": 115124,
                        "name": "DeBary",
                        "latitude": "28.88305000",
                        "longitude": "-81.30868000"
                    },
                    {
                        "id": 115184,
                        "name": "Deerfield Beach",
                        "latitude": "26.31841000",
                        "longitude": "-80.09977000"
                    },
                    {
                        "id": 115126,
                        "name": "DeFuniak Springs",
                        "latitude": "30.72102000",
                        "longitude": "-86.11522000"
                    },
                    {
                        "id": 115134,
                        "name": "DeLand",
                        "latitude": "29.02832000",
                        "longitude": "-81.30312000"
                    },
                    {
                        "id": 115221,
                        "name": "Delray Beach",
                        "latitude": "26.46146000",
                        "longitude": "-80.07282000"
                    },
                    {
                        "id": 115229,
                        "name": "Deltona",
                        "latitude": "28.90054000",
                        "longitude": "-81.26367000"
                    },
                    {
                        "id": 115139,
                        "name": "DeSoto County",
                        "latitude": "27.18632000",
                        "longitude": "-81.80930000"
                    },
                    {
                        "id": 115287,
                        "name": "Desoto Lakes",
                        "latitude": "27.37143000",
                        "longitude": "-82.48982000"
                    },
                    {
                        "id": 115289,
                        "name": "Destin",
                        "latitude": "30.39353000",
                        "longitude": "-86.49578000"
                    },
                    {
                        "id": 115361,
                        "name": "Dixie County",
                        "latitude": "29.58124000",
                        "longitude": "-83.18703000"
                    },
                    {
                        "id": 115373,
                        "name": "Doctor Phillips",
                        "latitude": "28.44945000",
                        "longitude": "-81.49229000"
                    },
                    {
                        "id": 115408,
                        "name": "Doral",
                        "latitude": "25.81954000",
                        "longitude": "-80.35533000"
                    },
                    {
                        "id": 115446,
                        "name": "Dover",
                        "latitude": "27.99419000",
                        "longitude": "-82.21953000"
                    },
                    {
                        "id": 115528,
                        "name": "Dundee",
                        "latitude": "28.02252000",
                        "longitude": "-81.61924000"
                    },
                    {
                        "id": 115534,
                        "name": "Dunedin",
                        "latitude": "28.01990000",
                        "longitude": "-82.77323000"
                    },
                    {
                        "id": 115550,
                        "name": "Dunnellon",
                        "latitude": "29.04914000",
                        "longitude": "-82.46093000"
                    },
                    {
                        "id": 115580,
                        "name": "Duval County",
                        "latitude": "30.33544000",
                        "longitude": "-81.64801000"
                    },
                    {
                        "id": 115602,
                        "name": "Eagle Lake",
                        "latitude": "27.97836000",
                        "longitude": "-81.75647000"
                    },
                    {
                        "id": 115638,
                        "name": "East Bronson",
                        "latitude": "29.45928000",
                        "longitude": "-82.59040000"
                    },
                    {
                        "id": 115700,
                        "name": "East Lake",
                        "latitude": "28.11085000",
                        "longitude": "-82.69482000"
                    },
                    {
                        "id": 115701,
                        "name": "East Lake-Orient Park",
                        "latitude": "27.98269000",
                        "longitude": "-82.37878000"
                    },
                    {
                        "id": 115714,
                        "name": "East Milton",
                        "latitude": "30.61519000",
                        "longitude": "-87.02163000"
                    },
                    {
                        "id": 115718,
                        "name": "East Naples",
                        "latitude": "26.13842000",
                        "longitude": "-81.76648000"
                    },
                    {
                        "id": 115727,
                        "name": "East Palatka",
                        "latitude": "29.65830000",
                        "longitude": "-81.59841000"
                    },
                    {
                        "id": 115731,
                        "name": "East Pensacola Heights",
                        "latitude": "30.42881000",
                        "longitude": "-87.17997000"
                    },
                    {
                        "id": 115734,
                        "name": "East Perrine",
                        "latitude": "25.60872000",
                        "longitude": "-80.33894000"
                    },
                    {
                        "id": 115793,
                        "name": "Eastpoint",
                        "latitude": "29.73660000",
                        "longitude": "-84.87852000"
                    },
                    {
                        "id": 115808,
                        "name": "Eatonville",
                        "latitude": "28.61472000",
                        "longitude": "-81.38062000"
                    },
                    {
                        "id": 115851,
                        "name": "Edgewater",
                        "latitude": "28.98888000",
                        "longitude": "-80.90228000"
                    },
                    {
                        "id": 115857,
                        "name": "Edgewood",
                        "latitude": "28.48612000",
                        "longitude": "-81.37229000"
                    },
                    {
                        "id": 115903,
                        "name": "Eglin Air Force Base",
                        "latitude": "30.45907000",
                        "longitude": "-86.55026000"
                    },
                    {
                        "id": 115904,
                        "name": "Eglin Village",
                        "latitude": "30.46298000",
                        "longitude": "-86.53940000"
                    },
                    {
                        "id": 115906,
                        "name": "Egypt Lake-Leto",
                        "latitude": "28.01769000",
                        "longitude": "-82.50619000"
                    },
                    {
                        "id": 115933,
                        "name": "El Portal",
                        "latitude": "25.85537000",
                        "longitude": "-80.19310000"
                    },
                    {
                        "id": 115962,
                        "name": "Elfers",
                        "latitude": "28.21668000",
                        "longitude": "-82.72232000"
                    },
                    {
                        "id": 116019,
                        "name": "Ellenton",
                        "latitude": "27.52171000",
                        "longitude": "-82.52760000"
                    },
                    {
                        "id": 116129,
                        "name": "Englewood",
                        "latitude": "26.96201000",
                        "longitude": "-82.35260000"
                    },
                    {
                        "id": 116147,
                        "name": "Ensley",
                        "latitude": "30.51881000",
                        "longitude": "-87.27275000"
                    },
                    {
                        "id": 116180,
                        "name": "Escambia County",
                        "latitude": "30.61440000",
                        "longitude": "-87.34136000"
                    },
                    {
                        "id": 116207,
                        "name": "Estero",
                        "latitude": "26.43814000",
                        "longitude": "-81.80675000"
                    },
                    {
                        "id": 116241,
                        "name": "Eustis",
                        "latitude": "28.85277000",
                        "longitude": "-81.68535000"
                    },
                    {
                        "id": 116360,
                        "name": "Fairview Shores",
                        "latitude": "28.59111000",
                        "longitude": "-81.39424000"
                    },
                    {
                        "id": 116463,
                        "name": "Feather Sound",
                        "latitude": "27.90079000",
                        "longitude": "-82.67349000"
                    },
                    {
                        "id": 116469,
                        "name": "Fellsmere",
                        "latitude": "27.76781000",
                        "longitude": "-80.60144000"
                    },
                    {
                        "id": 116483,
                        "name": "Fern Park",
                        "latitude": "28.64916000",
                        "longitude": "-81.35118000"
                    },
                    {
                        "id": 116485,
                        "name": "Fernandina Beach",
                        "latitude": "30.66968000",
                        "longitude": "-81.46259000"
                    },
                    {
                        "id": 116499,
                        "name": "Ferry Pass",
                        "latitude": "30.51020000",
                        "longitude": "-87.21247000"
                    },
                    {
                        "id": 116525,
                        "name": "Fish Hawk",
                        "latitude": "27.85058000",
                        "longitude": "-82.21092000"
                    },
                    {
                        "id": 116540,
                        "name": "Five Points",
                        "latitude": "30.20912000",
                        "longitude": "-82.63735000"
                    },
                    {
                        "id": 116542,
                        "name": "Flagami",
                        "latitude": "25.76232000",
                        "longitude": "-80.31616000"
                    },
                    {
                        "id": 116543,
                        "name": "Flagler Beach",
                        "latitude": "29.47498000",
                        "longitude": "-81.12700000"
                    },
                    {
                        "id": 116544,
                        "name": "Flagler County",
                        "latitude": "29.47115000",
                        "longitude": "-81.29299000"
                    },
                    {
                        "id": 116545,
                        "name": "Flagler Estates",
                        "latitude": "29.64553000",
                        "longitude": "-81.45700000"
                    },
                    {
                        "id": 116560,
                        "name": "Fleming Island",
                        "latitude": "30.09330000",
                        "longitude": "-81.71898000"
                    },
                    {
                        "id": 116574,
                        "name": "Floral City",
                        "latitude": "28.74999000",
                        "longitude": "-82.29676000"
                    },
                    {
                        "id": 116593,
                        "name": "Florida City",
                        "latitude": "25.44789000",
                        "longitude": "-80.47922000"
                    },
                    {
                        "id": 116594,
                        "name": "Florida Ridge",
                        "latitude": "27.58031000",
                        "longitude": "-80.38672000"
                    },
                    {
                        "id": 116646,
                        "name": "Forest City",
                        "latitude": "28.66678000",
                        "longitude": "-81.44334000"
                    },
                    {
                        "id": 116722,
                        "name": "Fort Lauderdale",
                        "latitude": "26.12231000",
                        "longitude": "-80.14338000"
                    },
                    {
                        "id": 116728,
                        "name": "Fort Meade",
                        "latitude": "27.75225000",
                        "longitude": "-81.80175000"
                    },
                    {
                        "id": 116734,
                        "name": "Fort Myers",
                        "latitude": "26.62168000",
                        "longitude": "-81.84059000"
                    },
                    {
                        "id": 116735,
                        "name": "Fort Myers Beach",
                        "latitude": "26.45271000",
                        "longitude": "-81.95011000"
                    },
                    {
                        "id": 116736,
                        "name": "Fort Myers Shores",
                        "latitude": "26.70924000",
                        "longitude": "-81.74592000"
                    },
                    {
                        "id": 116739,
                        "name": "Fort Pierce",
                        "latitude": "27.44671000",
                        "longitude": "-80.32561000"
                    },
                    {
                        "id": 116740,
                        "name": "Fort Pierce North",
                        "latitude": "27.47364000",
                        "longitude": "-80.35930000"
                    },
                    {
                        "id": 116741,
                        "name": "Fort Pierce South",
                        "latitude": "27.40962000",
                        "longitude": "-80.35483000"
                    },
                    {
                        "id": 116759,
                        "name": "Fort Walton Beach",
                        "latitude": "30.42059000",
                        "longitude": "-86.61707000"
                    },
                    {
                        "id": 116785,
                        "name": "Fountainebleau",
                        "latitude": "25.77288000",
                        "longitude": "-80.34783000"
                    },
                    {
                        "id": 116791,
                        "name": "Four Corners",
                        "latitude": "28.33287000",
                        "longitude": "-81.64738000"
                    },
                    {
                        "id": 116845,
                        "name": "Franklin County",
                        "latitude": "29.81168000",
                        "longitude": "-84.80046000"
                    },
                    {
                        "id": 116910,
                        "name": "Freeport",
                        "latitude": "30.49825000",
                        "longitude": "-86.13605000"
                    },
                    {
                        "id": 116965,
                        "name": "Frostproof",
                        "latitude": "27.74586000",
                        "longitude": "-81.53063000"
                    },
                    {
                        "id": 116966,
                        "name": "Fruit Cove",
                        "latitude": "30.11107000",
                        "longitude": "-81.64176000"
                    },
                    {
                        "id": 116973,
                        "name": "Fruitland Park",
                        "latitude": "28.86138000",
                        "longitude": "-81.90647000"
                    },
                    {
                        "id": 116977,
                        "name": "Fruitville",
                        "latitude": "27.32977000",
                        "longitude": "-82.45760000"
                    },
                    {
                        "id": 116980,
                        "name": "Fuller Heights",
                        "latitude": "27.90919000",
                        "longitude": "-81.99814000"
                    },
                    {
                        "id": 117002,
                        "name": "Fussels Corner",
                        "latitude": "28.05419000",
                        "longitude": "-81.86064000"
                    },
                    {
                        "id": 117006,
                        "name": "Gadsden County",
                        "latitude": "30.57947000",
                        "longitude": "-84.61360000"
                    },
                    {
                        "id": 117014,
                        "name": "Gainesville",
                        "latitude": "29.65163000",
                        "longitude": "-82.32483000"
                    },
                    {
                        "id": 117049,
                        "name": "Gandy",
                        "latitude": "27.86850000",
                        "longitude": "-82.61612000"
                    },
                    {
                        "id": 117123,
                        "name": "Gateway",
                        "latitude": "26.57757000",
                        "longitude": "-81.75036000"
                    },
                    {
                        "id": 117140,
                        "name": "Geneva",
                        "latitude": "28.73972000",
                        "longitude": "-81.11506000"
                    },
                    {
                        "id": 117191,
                        "name": "Gibsonia",
                        "latitude": "28.11474000",
                        "longitude": "-81.97369000"
                    },
                    {
                        "id": 117193,
                        "name": "Gibsonton",
                        "latitude": "27.85364000",
                        "longitude": "-82.38259000"
                    },
                    {
                        "id": 117197,
                        "name": "Gifford",
                        "latitude": "27.67531000",
                        "longitude": "-80.40922000"
                    },
                    {
                        "id": 117208,
                        "name": "Gilchrist County",
                        "latitude": "29.72582000",
                        "longitude": "-82.80037000"
                    },
                    {
                        "id": 117233,
                        "name": "Glades County",
                        "latitude": "26.95648000",
                        "longitude": "-81.18898000"
                    },
                    {
                        "id": 117234,
                        "name": "Gladeview",
                        "latitude": "25.83926000",
                        "longitude": "-80.23560000"
                    },
                    {
                        "id": 117277,
                        "name": "Glencoe",
                        "latitude": "29.02582000",
                        "longitude": "-80.97200000"
                    },
                    {
                        "id": 117308,
                        "name": "Glenvar Heights",
                        "latitude": "25.70760000",
                        "longitude": "-80.32561000"
                    },
                    {
                        "id": 117348,
                        "name": "Golden Gate",
                        "latitude": "26.18787000",
                        "longitude": "-81.69509000"
                    },
                    {
                        "id": 117349,
                        "name": "Golden Glades",
                        "latitude": "25.91176000",
                        "longitude": "-80.20033000"
                    },
                    {
                        "id": 117361,
                        "name": "Goldenrod",
                        "latitude": "28.61028000",
                        "longitude": "-81.28868000"
                    },
                    {
                        "id": 117374,
                        "name": "Gonzalez",
                        "latitude": "30.58158000",
                        "longitude": "-87.29136000"
                    },
                    {
                        "id": 117414,
                        "name": "Gotha",
                        "latitude": "28.52778000",
                        "longitude": "-81.52313000"
                    },
                    {
                        "id": 117416,
                        "name": "Goulding",
                        "latitude": "30.44298000",
                        "longitude": "-87.22247000"
                    },
                    {
                        "id": 117417,
                        "name": "Goulds",
                        "latitude": "25.56261000",
                        "longitude": "-80.38228000"
                    },
                    {
                        "id": 117425,
                        "name": "Graceville",
                        "latitude": "30.95685000",
                        "longitude": "-85.51660000"
                    },
                    {
                        "id": 117524,
                        "name": "Grant-Valkaria",
                        "latitude": "27.93980000",
                        "longitude": "-80.57104000"
                    },
                    {
                        "id": 117581,
                        "name": "Greater Northdale",
                        "latitude": "28.10545000",
                        "longitude": "-82.52594000"
                    },
                    {
                        "id": 117594,
                        "name": "Green Cove Springs",
                        "latitude": "29.99191000",
                        "longitude": "-81.67815000"
                    },
                    {
                        "id": 117614,
                        "name": "Greenacres City",
                        "latitude": "26.62368000",
                        "longitude": "-80.12532000"
                    },
                    {
                        "id": 117618,
                        "name": "Greenbriar",
                        "latitude": "28.01128000",
                        "longitude": "-82.75272000"
                    },
                    {
                        "id": 117724,
                        "name": "Gretna",
                        "latitude": "30.61714000",
                        "longitude": "-84.65991000"
                    },
                    {
                        "id": 117755,
                        "name": "Grove City",
                        "latitude": "26.91423000",
                        "longitude": "-82.32704000"
                    },
                    {
                        "id": 117758,
                        "name": "Groveland",
                        "latitude": "28.55805000",
                        "longitude": "-81.85119000"
                    },
                    {
                        "id": 117790,
                        "name": "Gulf Breeze",
                        "latitude": "30.35714000",
                        "longitude": "-87.16386000"
                    },
                    {
                        "id": 117791,
                        "name": "Gulf County",
                        "latitude": "29.90862000",
                        "longitude": "-85.26101000"
                    },
                    {
                        "id": 117792,
                        "name": "Gulf Gate Estates",
                        "latitude": "27.25173000",
                        "longitude": "-82.51471000"
                    },
                    {
                        "id": 117796,
                        "name": "Gulfport",
                        "latitude": "27.74836000",
                        "longitude": "-82.70343000"
                    },
                    {
                        "id": 117845,
                        "name": "Haines City",
                        "latitude": "28.11450000",
                        "longitude": "-81.62009000"
                    },
                    {
                        "id": 117869,
                        "name": "Hallandale Beach",
                        "latitude": "25.98120000",
                        "longitude": "-80.14838000"
                    },
                    {
                        "id": 117896,
                        "name": "Hamilton County",
                        "latitude": "30.49643000",
                        "longitude": "-82.94796000"
                    },
                    {
                        "id": 117989,
                        "name": "Harbor Bluffs",
                        "latitude": "27.90947000",
                        "longitude": "-82.82760000"
                    },
                    {
                        "id": 117992,
                        "name": "Harbour Heights",
                        "latitude": "26.99089000",
                        "longitude": "-82.00231000"
                    },
                    {
                        "id": 117993,
                        "name": "Hardee County",
                        "latitude": "27.49270000",
                        "longitude": "-81.80993000"
                    },
                    {
                        "id": 118021,
                        "name": "Harlem",
                        "latitude": "26.73757000",
                        "longitude": "-80.95090000"
                    },
                    {
                        "id": 118024,
                        "name": "Harlem Heights",
                        "latitude": "26.51619000",
                        "longitude": "-81.92787000"
                    },
                    {
                        "id": 118145,
                        "name": "Havana",
                        "latitude": "30.62381000",
                        "longitude": "-84.41463000"
                    },
                    {
                        "id": 118149,
                        "name": "Haverhill",
                        "latitude": "26.69118000",
                        "longitude": "-80.12004000"
                    },
                    {
                        "id": 118172,
                        "name": "Hawthorne",
                        "latitude": "29.59191000",
                        "longitude": "-82.08732000"
                    },
                    {
                        "id": 118224,
                        "name": "Heathrow",
                        "latitude": "28.76333000",
                        "longitude": "-81.37225000"
                    },
                    {
                        "id": 118289,
                        "name": "Hendry County",
                        "latitude": "26.55349000",
                        "longitude": "-81.16590000"
                    },
                    {
                        "id": 118321,
                        "name": "Heritage Pines",
                        "latitude": "28.42522000",
                        "longitude": "-82.62111000"
                    },
                    {
                        "id": 118332,
                        "name": "Hernando",
                        "latitude": "28.89998000",
                        "longitude": "-82.37454000"
                    },
                    {
                        "id": 118334,
                        "name": "Hernando Beach",
                        "latitude": "28.46944000",
                        "longitude": "-82.65927000"
                    },
                    {
                        "id": 118335,
                        "name": "Hernando County",
                        "latitude": "28.55617000",
                        "longitude": "-82.46849000"
                    },
                    {
                        "id": 118354,
                        "name": "Hialeah",
                        "latitude": "25.85760000",
                        "longitude": "-80.27811000"
                    },
                    {
                        "id": 118355,
                        "name": "Hialeah Gardens",
                        "latitude": "25.86510000",
                        "longitude": "-80.32450000"
                    },
                    {
                        "id": 118387,
                        "name": "High Point",
                        "latitude": "28.54687000",
                        "longitude": "-82.52468000"
                    },
                    {
                        "id": 118389,
                        "name": "High Springs",
                        "latitude": "29.82691000",
                        "longitude": "-82.59678000"
                    },
                    {
                        "id": 118402,
                        "name": "Highland Beach",
                        "latitude": "26.39952000",
                        "longitude": "-80.06560000"
                    },
                    {
                        "id": 118403,
                        "name": "Highland City",
                        "latitude": "27.96530000",
                        "longitude": "-81.87786000"
                    },
                    {
                        "id": 118419,
                        "name": "Highlands County",
                        "latitude": "27.34340000",
                        "longitude": "-81.34097000"
                    },
                    {
                        "id": 118427,
                        "name": "Hiland Park",
                        "latitude": "30.20103000",
                        "longitude": "-85.62687000"
                    },
                    {
                        "id": 118432,
                        "name": "Hill 'n Dale",
                        "latitude": "28.51972000",
                        "longitude": "-82.29926000"
                    },
                    {
                        "id": 118444,
                        "name": "Hilliard",
                        "latitude": "30.69107000",
                        "longitude": "-81.91733000"
                    },
                    {
                        "id": 118453,
                        "name": "Hillsboro Beach",
                        "latitude": "26.29397000",
                        "longitude": "-80.07893000"
                    },
                    {
                        "id": 118457,
                        "name": "Hillsborough County",
                        "latitude": "27.90623000",
                        "longitude": "-82.34692000"
                    },
                    {
                        "id": 118501,
                        "name": "Hobe Sound",
                        "latitude": "27.05950000",
                        "longitude": "-80.13643000"
                    },
                    {
                        "id": 118525,
                        "name": "Holden Heights",
                        "latitude": "28.49667000",
                        "longitude": "-81.38785000"
                    },
                    {
                        "id": 118529,
                        "name": "Holiday",
                        "latitude": "28.18779000",
                        "longitude": "-82.73955000"
                    },
                    {
                        "id": 118542,
                        "name": "Holley",
                        "latitude": "30.44686000",
                        "longitude": "-86.90691000"
                    },
                    {
                        "id": 118556,
                        "name": "Holly Hill",
                        "latitude": "29.24359000",
                        "longitude": "-81.03756000"
                    },
                    {
                        "id": 118565,
                        "name": "Hollywood",
                        "latitude": "26.01120000",
                        "longitude": "-80.14949000"
                    },
                    {
                        "id": 118570,
                        "name": "Holmes Beach",
                        "latitude": "27.49532000",
                        "longitude": "-82.71093000"
                    },
                    {
                        "id": 118571,
                        "name": "Holmes County",
                        "latitude": "30.86789000",
                        "longitude": "-85.81410000"
                    },
                    {
                        "id": 118601,
                        "name": "Homestead",
                        "latitude": "25.46872000",
                        "longitude": "-80.47756000"
                    },
                    {
                        "id": 118610,
                        "name": "Homosassa",
                        "latitude": "28.78137000",
                        "longitude": "-82.61510000"
                    },
                    {
                        "id": 118611,
                        "name": "Homosassa Springs",
                        "latitude": "28.80359000",
                        "longitude": "-82.57593000"
                    },
                    {
                        "id": 118665,
                        "name": "Horizon West",
                        "latitude": "28.43383000",
                        "longitude": "-81.62270000"
                    },
                    {
                        "id": 118724,
                        "name": "Howey-in-the-Hills",
                        "latitude": "28.71694000",
                        "longitude": "-81.77341000"
                    },
                    {
                        "id": 118735,
                        "name": "Hudson",
                        "latitude": "28.36445000",
                        "longitude": "-82.69343000"
                    },
                    {
                        "id": 118790,
                        "name": "Hunters Creek",
                        "latitude": "28.36056000",
                        "longitude": "-81.42229000"
                    },
                    {
                        "id": 118839,
                        "name": "Hutchinson Island South",
                        "latitude": "27.29949000",
                        "longitude": "-80.22045000"
                    },
                    {
                        "id": 118856,
                        "name": "Hypoluxo",
                        "latitude": "26.56646000",
                        "longitude": "-80.05337000"
                    },
                    {
                        "id": 118880,
                        "name": "Immokalee",
                        "latitude": "26.41869000",
                        "longitude": "-81.41730000"
                    },
                    {
                        "id": 118901,
                        "name": "Indialantic",
                        "latitude": "28.08946000",
                        "longitude": "-80.56561000"
                    },
                    {
                        "id": 118902,
                        "name": "Indian Harbour Beach",
                        "latitude": "28.14890000",
                        "longitude": "-80.58839000"
                    },
                    {
                        "id": 118913,
                        "name": "Indian River County",
                        "latitude": "27.69639000",
                        "longitude": "-80.57409000"
                    },
                    {
                        "id": 118914,
                        "name": "Indian River Estates",
                        "latitude": "27.36449000",
                        "longitude": "-80.30977000"
                    },
                    {
                        "id": 118915,
                        "name": "Indian River Shores",
                        "latitude": "27.71670000",
                        "longitude": "-80.38422000"
                    },
                    {
                        "id": 118916,
                        "name": "Indian Rocks Beach",
                        "latitude": "27.87530000",
                        "longitude": "-82.85122000"
                    },
                    {
                        "id": 118917,
                        "name": "Indian Shores",
                        "latitude": "27.86280000",
                        "longitude": "-82.84844000"
                    },
                    {
                        "id": 118928,
                        "name": "Indiantown",
                        "latitude": "27.02728000",
                        "longitude": "-80.48561000"
                    },
                    {
                        "id": 118939,
                        "name": "Inglis",
                        "latitude": "29.03025000",
                        "longitude": "-82.66872000"
                    },
                    {
                        "id": 118950,
                        "name": "Interlachen",
                        "latitude": "29.62421000",
                        "longitude": "-81.89256000"
                    },
                    {
                        "id": 118955,
                        "name": "Inverness",
                        "latitude": "28.83582000",
                        "longitude": "-82.33037000"
                    },
                    {
                        "id": 118959,
                        "name": "Inverness Highlands North",
                        "latitude": "28.86420000",
                        "longitude": "-82.37688000"
                    },
                    {
                        "id": 118960,
                        "name": "Inverness Highlands South",
                        "latitude": "28.80055000",
                        "longitude": "-82.33710000"
                    },
                    {
                        "id": 118961,
                        "name": "Inwood",
                        "latitude": "28.03697000",
                        "longitude": "-81.76508000"
                    },
                    {
                        "id": 118968,
                        "name": "Iona",
                        "latitude": "26.52036000",
                        "longitude": "-81.96398000"
                    },
                    {
                        "id": 119022,
                        "name": "Islamorada",
                        "latitude": "24.92430000",
                        "longitude": "-80.62784000"
                    },
                    {
                        "id": 119028,
                        "name": "Island Walk",
                        "latitude": "26.25099000",
                        "longitude": "-81.71101000"
                    },
                    {
                        "id": 119031,
                        "name": "Isle of Normandy",
                        "latitude": "25.85287000",
                        "longitude": "-80.13505000"
                    },
                    {
                        "id": 119050,
                        "name": "Ives Estates",
                        "latitude": "25.96231000",
                        "longitude": "-80.17671000"
                    },
                    {
                        "id": 119077,
                        "name": "Jackson County",
                        "latitude": "30.79539000",
                        "longitude": "-85.21546000"
                    },
                    {
                        "id": 119101,
                        "name": "Jacksonville",
                        "latitude": "30.33218000",
                        "longitude": "-81.65565000"
                    },
                    {
                        "id": 119106,
                        "name": "Jacksonville Beach",
                        "latitude": "30.29469000",
                        "longitude": "-81.39314000"
                    },
                    {
                        "id": 119129,
                        "name": "Jan-Phyl Village",
                        "latitude": "28.01474000",
                        "longitude": "-81.77175000"
                    },
                    {
                        "id": 119136,
                        "name": "Jasmine Estates",
                        "latitude": "28.29306000",
                        "longitude": "-82.69010000"
                    },
                    {
                        "id": 119140,
                        "name": "Jasper",
                        "latitude": "30.51827000",
                        "longitude": "-82.94819000"
                    },
                    {
                        "id": 119177,
                        "name": "Jefferson County",
                        "latitude": "30.42346000",
                        "longitude": "-83.90047000"
                    },
                    {
                        "id": 119222,
                        "name": "Jensen Beach",
                        "latitude": "27.25449000",
                        "longitude": "-80.22977000"
                    },
                    {
                        "id": 119336,
                        "name": "June Park",
                        "latitude": "28.07224000",
                        "longitude": "-80.68006000"
                    },
                    {
                        "id": 119341,
                        "name": "Juno Beach",
                        "latitude": "26.87978000",
                        "longitude": "-80.05337000"
                    },
                    {
                        "id": 119342,
                        "name": "Jupiter",
                        "latitude": "26.93422000",
                        "longitude": "-80.09421000"
                    },
                    {
                        "id": 119393,
                        "name": "Kathleen",
                        "latitude": "28.12085000",
                        "longitude": "-82.02314000"
                    },
                    {
                        "id": 119444,
                        "name": "Kendale Lakes",
                        "latitude": "25.70816000",
                        "longitude": "-80.40700000"
                    },
                    {
                        "id": 119445,
                        "name": "Kendall",
                        "latitude": "25.67927000",
                        "longitude": "-80.31727000"
                    },
                    {
                        "id": 119448,
                        "name": "Kendall Green",
                        "latitude": "26.25397000",
                        "longitude": "-80.12393000"
                    },
                    {
                        "id": 119450,
                        "name": "Kendall West",
                        "latitude": "25.70650000",
                        "longitude": "-80.43880000"
                    },
                    {
                        "id": 119472,
                        "name": "Kenneth City",
                        "latitude": "27.81558000",
                        "longitude": "-82.72010000"
                    },
                    {
                        "id": 119485,
                        "name": "Kensington Park",
                        "latitude": "27.35949000",
                        "longitude": "-82.49649000"
                    },
                    {
                        "id": 119537,
                        "name": "Key Biscayne",
                        "latitude": "25.69371000",
                        "longitude": "-80.16282000"
                    },
                    {
                        "id": 119539,
                        "name": "Key Largo",
                        "latitude": "25.08652000",
                        "longitude": "-80.44728000"
                    },
                    {
                        "id": 119540,
                        "name": "Key Vista",
                        "latitude": "28.19470000",
                        "longitude": "-82.77038000"
                    },
                    {
                        "id": 119541,
                        "name": "Key West",
                        "latitude": "24.55524000",
                        "longitude": "-81.78163000"
                    },
                    {
                        "id": 119546,
                        "name": "Keystone",
                        "latitude": "28.15585000",
                        "longitude": "-82.62121000"
                    },
                    {
                        "id": 119548,
                        "name": "Keystone Heights",
                        "latitude": "29.78608000",
                        "longitude": "-82.03149000"
                    },
                    {
                        "id": 119607,
                        "name": "Kings Point",
                        "latitude": "26.44535000",
                        "longitude": "-80.13977000"
                    },
                    {
                        "id": 119658,
                        "name": "Kissimmee",
                        "latitude": "28.30468000",
                        "longitude": "-81.41667000"
                    },
                    {
                        "id": 119798,
                        "name": "LaBelle",
                        "latitude": "26.76173000",
                        "longitude": "-81.43841000"
                    },
                    {
                        "id": 119820,
                        "name": "Lacoochee",
                        "latitude": "28.46583000",
                        "longitude": "-82.17203000"
                    },
                    {
                        "id": 119829,
                        "name": "Lady Lake",
                        "latitude": "28.91749000",
                        "longitude": "-81.92286000"
                    },
                    {
                        "id": 119839,
                        "name": "Lafayette County",
                        "latitude": "29.98552000",
                        "longitude": "-83.18107000"
                    },
                    {
                        "id": 119851,
                        "name": "Laguna Beach",
                        "latitude": "30.23965000",
                        "longitude": "-85.92410000"
                    },
                    {
                        "id": 119862,
                        "name": "Lake Alfred",
                        "latitude": "28.09196000",
                        "longitude": "-81.72341000"
                    },
                    {
                        "id": 119870,
                        "name": "Lake Belvedere Estates",
                        "latitude": "26.68923000",
                        "longitude": "-80.13338000"
                    },
                    {
                        "id": 119873,
                        "name": "Lake Butler",
                        "latitude": "30.02274000",
                        "longitude": "-82.33956000"
                    },
                    {
                        "id": 119879,
                        "name": "Lake City",
                        "latitude": "30.18968000",
                        "longitude": "-82.63929000"
                    },
                    {
                        "id": 119887,
                        "name": "Lake Clarke Shores",
                        "latitude": "26.64534000",
                        "longitude": "-80.07588000"
                    },
                    {
                        "id": 119889,
                        "name": "Lake County",
                        "latitude": "28.76147000",
                        "longitude": "-81.71130000"
                    },
                    {
                        "id": 119909,
                        "name": "Lake Forest",
                        "latitude": "25.97759000",
                        "longitude": "-80.18310000"
                    },
                    {
                        "id": 119917,
                        "name": "Lake Hamilton",
                        "latitude": "28.04446000",
                        "longitude": "-81.62785000"
                    },
                    {
                        "id": 119919,
                        "name": "Lake Helen",
                        "latitude": "28.98082000",
                        "longitude": "-81.23339000"
                    },
                    {
                        "id": 119930,
                        "name": "Lake Lorraine",
                        "latitude": "30.44159000",
                        "longitude": "-86.56523000"
                    },
                    {
                        "id": 119933,
                        "name": "Lake Lucerne",
                        "latitude": "25.96509000",
                        "longitude": "-80.24144000"
                    },
                    {
                        "id": 119936,
                        "name": "Lake Mack-Forest Hills",
                        "latitude": "29.00074000",
                        "longitude": "-81.42397000"
                    },
                    {
                        "id": 119937,
                        "name": "Lake Magdalene",
                        "latitude": "28.07418000",
                        "longitude": "-82.47176000"
                    },
                    {
                        "id": 119939,
                        "name": "Lake Mary",
                        "latitude": "28.75888000",
                        "longitude": "-81.31784000"
                    },
                    {
                        "id": 119957,
                        "name": "Lake Panasoffkee",
                        "latitude": "28.75582000",
                        "longitude": "-82.09481000"
                    },
                    {
                        "id": 119959,
                        "name": "Lake Park",
                        "latitude": "26.80034000",
                        "longitude": "-80.06643000"
                    },
                    {
                        "id": 119962,
                        "name": "Lake Placid",
                        "latitude": "27.35197000",
                        "longitude": "-81.32631000"
                    },
                    {
                        "id": 119974,
                        "name": "Lake Sarasota",
                        "latitude": "27.29255000",
                        "longitude": "-82.43760000"
                    },
                    {
                        "id": 119991,
                        "name": "Lake Wales",
                        "latitude": "27.90141000",
                        "longitude": "-81.58591000"
                    },
                    {
                        "id": 119997,
                        "name": "Lake Worth",
                        "latitude": "26.61708000",
                        "longitude": "-80.07231000"
                    },
                    {
                        "id": 119999,
                        "name": "Lake Worth Corridor",
                        "latitude": "26.61649000",
                        "longitude": "-80.10102000"
                    },
                    {
                        "id": 120012,
                        "name": "Lakeland",
                        "latitude": "28.03947000",
                        "longitude": "-81.94980000"
                    },
                    {
                        "id": 120017,
                        "name": "Lakeland Highlands",
                        "latitude": "27.95975000",
                        "longitude": "-81.95008000"
                    },
                    {
                        "id": 120025,
                        "name": "Lakes by the Bay",
                        "latitude": "25.57233000",
                        "longitude": "-80.32533000"
                    },
                    {
                        "id": 120029,
                        "name": "Lakeside",
                        "latitude": "30.12996000",
                        "longitude": "-81.76815000"
                    },
                    {
                        "id": 120054,
                        "name": "Lakewood Park",
                        "latitude": "27.54309000",
                        "longitude": "-80.40227000"
                    },
                    {
                        "id": 120095,
                        "name": "Land O' Lakes",
                        "latitude": "28.21890000",
                        "longitude": "-82.45759000"
                    },
                    {
                        "id": 120129,
                        "name": "Lantana",
                        "latitude": "26.58674000",
                        "longitude": "-80.05199000"
                    },
                    {
                        "id": 120143,
                        "name": "Largo",
                        "latitude": "27.90979000",
                        "longitude": "-82.78842000"
                    },
                    {
                        "id": 120182,
                        "name": "Lauderdale Lakes",
                        "latitude": "26.16647000",
                        "longitude": "-80.20838000"
                    },
                    {
                        "id": 120183,
                        "name": "Lauderdale-by-the-Sea",
                        "latitude": "26.19203000",
                        "longitude": "-80.09643000"
                    },
                    {
                        "id": 120184,
                        "name": "Lauderhill",
                        "latitude": "26.14036000",
                        "longitude": "-80.21338000"
                    },
                    {
                        "id": 120188,
                        "name": "Laurel",
                        "latitude": "27.14378000",
                        "longitude": "-82.46158000"
                    },
                    {
                        "id": 120278,
                        "name": "Lealman",
                        "latitude": "27.82114000",
                        "longitude": "-82.67927000"
                    },
                    {
                        "id": 120299,
                        "name": "Lecanto",
                        "latitude": "28.85165000",
                        "longitude": "-82.48760000"
                    },
                    {
                        "id": 120308,
                        "name": "Lee County",
                        "latitude": "26.62536000",
                        "longitude": "-81.84952000"
                    },
                    {
                        "id": 120324,
                        "name": "Leesburg",
                        "latitude": "28.81082000",
                        "longitude": "-81.87786000"
                    },
                    {
                        "id": 120334,
                        "name": "Lehigh Acres",
                        "latitude": "26.62535000",
                        "longitude": "-81.62480000"
                    },
                    {
                        "id": 120340,
                        "name": "Leisure City",
                        "latitude": "25.49539000",
                        "longitude": "-80.42922000"
                    },
                    {
                        "id": 120353,
                        "name": "Lely",
                        "latitude": "26.10065000",
                        "longitude": "-81.72842000"
                    },
                    {
                        "id": 120354,
                        "name": "Lely Resort",
                        "latitude": "26.08093000",
                        "longitude": "-81.69786000"
                    },
                    {
                        "id": 120384,
                        "name": "Leon County",
                        "latitude": "30.45804000",
                        "longitude": "-84.27788000"
                    },
                    {
                        "id": 120409,
                        "name": "Levy County",
                        "latitude": "29.28221000",
                        "longitude": "-82.78861000"
                    },
                    {
                        "id": 120470,
                        "name": "Liberty County",
                        "latitude": "30.24136000",
                        "longitude": "-84.88291000"
                    },
                    {
                        "id": 120480,
                        "name": "Lighthouse Point",
                        "latitude": "26.27564000",
                        "longitude": "-80.08727000"
                    },
                    {
                        "id": 120496,
                        "name": "Limestone Creek",
                        "latitude": "26.94284000",
                        "longitude": "-80.14115000"
                    },
                    {
                        "id": 120638,
                        "name": "Live Oak",
                        "latitude": "30.29495000",
                        "longitude": "-82.98402000"
                    },
                    {
                        "id": 120672,
                        "name": "Lochmoor Waterway Estates",
                        "latitude": "26.64424000",
                        "longitude": "-81.90981000"
                    },
                    {
                        "id": 120676,
                        "name": "Lockhart",
                        "latitude": "28.61944000",
                        "longitude": "-81.44257000"
                    },
                    {
                        "id": 120751,
                        "name": "Longboat Key",
                        "latitude": "27.41254000",
                        "longitude": "-82.65899000"
                    },
                    {
                        "id": 120760,
                        "name": "Longwood",
                        "latitude": "28.70305000",
                        "longitude": "-81.33840000"
                    },
                    {
                        "id": 120803,
                        "name": "Loughman",
                        "latitude": "28.24196000",
                        "longitude": "-81.56674000"
                    },
                    {
                        "id": 120841,
                        "name": "Lower Grand Lagoon",
                        "latitude": "30.14409000",
                        "longitude": "-85.75076000"
                    },
                    {
                        "id": 120851,
                        "name": "Loxahatchee Groves",
                        "latitude": "26.68368000",
                        "longitude": "-80.27977000"
                    },
                    {
                        "id": 120898,
                        "name": "Lutz",
                        "latitude": "28.15112000",
                        "longitude": "-82.46148000"
                    },
                    {
                        "id": 120929,
                        "name": "Lynn Haven",
                        "latitude": "30.24548000",
                        "longitude": "-85.64826000"
                    },
                    {
                        "id": 120953,
                        "name": "Macclenny",
                        "latitude": "30.28218000",
                        "longitude": "-82.12206000"
                    },
                    {
                        "id": 120978,
                        "name": "Madeira Beach",
                        "latitude": "27.79808000",
                        "longitude": "-82.79732000"
                    },
                    {
                        "id": 120985,
                        "name": "Madison",
                        "latitude": "30.46938000",
                        "longitude": "-83.41293000"
                    },
                    {
                        "id": 121004,
                        "name": "Madison County",
                        "latitude": "30.44414000",
                        "longitude": "-83.47012000"
                    },
                    {
                        "id": 121051,
                        "name": "Maitland",
                        "latitude": "28.62778000",
                        "longitude": "-81.36312000"
                    },
                    {
                        "id": 121056,
                        "name": "Malabar",
                        "latitude": "28.00363000",
                        "longitude": "-80.56561000"
                    },
                    {
                        "id": 121065,
                        "name": "Malone",
                        "latitude": "30.95769000",
                        "longitude": "-85.16215000"
                    },
                    {
                        "id": 121080,
                        "name": "Manasota Key",
                        "latitude": "26.92534000",
                        "longitude": "-82.35204000"
                    },
                    {
                        "id": 121084,
                        "name": "Manatee County",
                        "latitude": "27.47752000",
                        "longitude": "-82.35754000"
                    },
                    {
                        "id": 121085,
                        "name": "Manatee Road",
                        "latitude": "29.51302000",
                        "longitude": "-82.91429000"
                    },
                    {
                        "id": 121108,
                        "name": "Mango",
                        "latitude": "27.97974000",
                        "longitude": "-82.30648000"
                    },
                    {
                        "id": 121109,
                        "name": "Mangonia Park",
                        "latitude": "26.76034000",
                        "longitude": "-80.07365000"
                    },
                    {
                        "id": 121184,
                        "name": "Marathon",
                        "latitude": "24.71375000",
                        "longitude": "-81.09035000"
                    },
                    {
                        "id": 121197,
                        "name": "Marco",
                        "latitude": "25.97260000",
                        "longitude": "-81.72898000"
                    },
                    {
                        "id": 121198,
                        "name": "Marco Island",
                        "latitude": "25.94121000",
                        "longitude": "-81.71842000"
                    },
                    {
                        "id": 121206,
                        "name": "Margate",
                        "latitude": "26.24453000",
                        "longitude": "-80.20644000"
                    },
                    {
                        "id": 121209,
                        "name": "Marianna",
                        "latitude": "30.77436000",
                        "longitude": "-85.22687000"
                    },
                    {
                        "id": 121249,
                        "name": "Marion County",
                        "latitude": "29.21020000",
                        "longitude": "-82.05668000"
                    },
                    {
                        "id": 121337,
                        "name": "Martin County",
                        "latitude": "27.08157000",
                        "longitude": "-80.39851000"
                    },
                    {
                        "id": 121354,
                        "name": "Mary Esther",
                        "latitude": "30.41015000",
                        "longitude": "-86.66509000"
                    },
                    {
                        "id": 121366,
                        "name": "Masaryktown",
                        "latitude": "28.44167000",
                        "longitude": "-82.45704000"
                    },
                    {
                        "id": 121368,
                        "name": "Mascotte",
                        "latitude": "28.57833000",
                        "longitude": "-81.88675000"
                    },
                    {
                        "id": 121442,
                        "name": "Mayo",
                        "latitude": "30.05300000",
                        "longitude": "-83.17486000"
                    },
                    {
                        "id": 121505,
                        "name": "McGregor",
                        "latitude": "26.56091000",
                        "longitude": "-81.91453000"
                    },
                    {
                        "id": 121562,
                        "name": "Meadow Oaks",
                        "latitude": "28.34619000",
                        "longitude": "-82.60284000"
                    },
                    {
                        "id": 121564,
                        "name": "Meadow Woods",
                        "latitude": "28.38556000",
                        "longitude": "-81.36646000"
                    },
                    {
                        "id": 121609,
                        "name": "Medulla",
                        "latitude": "27.96780000",
                        "longitude": "-81.97342000"
                    },
                    {
                        "id": 121620,
                        "name": "Melbourne",
                        "latitude": "28.08363000",
                        "longitude": "-80.60811000"
                    },
                    {
                        "id": 121622,
                        "name": "Melbourne Beach",
                        "latitude": "28.06835000",
                        "longitude": "-80.56033000"
                    },
                    {
                        "id": 121631,
                        "name": "Melrose Park",
                        "latitude": "26.11342000",
                        "longitude": "-80.19338000"
                    },
                    {
                        "id": 121638,
                        "name": "Memphis",
                        "latitude": "27.53587000",
                        "longitude": "-82.56121000"
                    },
                    {
                        "id": 121714,
                        "name": "Merritt Island",
                        "latitude": "28.53917000",
                        "longitude": "-80.67200000"
                    },
                    {
                        "id": 121744,
                        "name": "Mexico Beach",
                        "latitude": "29.94809000",
                        "longitude": "-85.41995000"
                    },
                    {
                        "id": 121746,
                        "name": "Miami",
                        "latitude": "25.77427000",
                        "longitude": "-80.19366000"
                    },
                    {
                        "id": 121750,
                        "name": "Miami Beach",
                        "latitude": "25.79065000",
                        "longitude": "-80.13005000"
                    },
                    {
                        "id": 121753,
                        "name": "Miami Gardens",
                        "latitude": "25.94204000",
                        "longitude": "-80.24560000"
                    },
                    {
                        "id": 121754,
                        "name": "Miami Lakes",
                        "latitude": "25.90871000",
                        "longitude": "-80.30866000"
                    },
                    {
                        "id": 121755,
                        "name": "Miami Shores",
                        "latitude": "25.86315000",
                        "longitude": "-80.19283000"
                    },
                    {
                        "id": 121756,
                        "name": "Miami Springs",
                        "latitude": "25.82232000",
                        "longitude": "-80.28950000"
                    },
                    {
                        "id": 121757,
                        "name": "Miami-Dade County",
                        "latitude": "25.60897000",
                        "longitude": "-80.49867000"
                    },
                    {
                        "id": 121758,
                        "name": "Micco",
                        "latitude": "27.88058000",
                        "longitude": "-80.50033000"
                    },
                    {
                        "id": 121768,
                        "name": "Middleburg",
                        "latitude": "30.06885000",
                        "longitude": "-81.86038000"
                    },
                    {
                        "id": 121820,
                        "name": "Midway",
                        "latitude": "30.40648000",
                        "longitude": "-87.00553000"
                    },
                    {
                        "id": 121912,
                        "name": "Milton",
                        "latitude": "30.63241000",
                        "longitude": "-87.03969000"
                    },
                    {
                        "id": 121926,
                        "name": "Mims",
                        "latitude": "28.66527000",
                        "longitude": "-80.84478000"
                    },
                    {
                        "id": 121954,
                        "name": "Minneola",
                        "latitude": "28.57444000",
                        "longitude": "-81.74619000"
                    },
                    {
                        "id": 121973,
                        "name": "Miramar",
                        "latitude": "25.98731000",
                        "longitude": "-80.23227000"
                    },
                    {
                        "id": 121974,
                        "name": "Miramar Beach",
                        "latitude": "30.37437000",
                        "longitude": "-86.35856000"
                    },
                    {
                        "id": 122029,
                        "name": "Molino",
                        "latitude": "30.72408000",
                        "longitude": "-87.31414000"
                    },
                    {
                        "id": 122069,
                        "name": "Monroe County",
                        "latitude": "25.55731000",
                        "longitude": "-80.91705000"
                    },
                    {
                        "id": 122159,
                        "name": "Monticello",
                        "latitude": "30.54515000",
                        "longitude": "-83.87130000"
                    },
                    {
                        "id": 122188,
                        "name": "Montverde",
                        "latitude": "28.60028000",
                        "longitude": "-81.67396000"
                    },
                    {
                        "id": 122204,
                        "name": "Moore Haven",
                        "latitude": "26.83312000",
                        "longitude": "-81.09312000"
                    },
                    {
                        "id": 122341,
                        "name": "Mount Dora",
                        "latitude": "28.80249000",
                        "longitude": "-81.64452000"
                    },
                    {
                        "id": 122383,
                        "name": "Mount Plymouth",
                        "latitude": "28.80805000",
                        "longitude": "-81.53313000"
                    },
                    {
                        "id": 122453,
                        "name": "Mulberry",
                        "latitude": "27.89530000",
                        "longitude": "-81.97342000"
                    },
                    {
                        "id": 122522,
                        "name": "Myrtle Grove",
                        "latitude": "30.42103000",
                        "longitude": "-87.30747000"
                    },
                    {
                        "id": 122552,
                        "name": "Naples",
                        "latitude": "26.14234000",
                        "longitude": "-81.79596000"
                    },
                    {
                        "id": 122556,
                        "name": "Naples Manor",
                        "latitude": "26.08870000",
                        "longitude": "-81.72620000"
                    },
                    {
                        "id": 122557,
                        "name": "Naples Park",
                        "latitude": "26.26175000",
                        "longitude": "-81.80925000"
                    },
                    {
                        "id": 122562,
                        "name": "Naranja",
                        "latitude": "25.51816000",
                        "longitude": "-80.42283000"
                    },
                    {
                        "id": 122582,
                        "name": "Nassau County",
                        "latitude": "30.61058000",
                        "longitude": "-81.77142000"
                    },
                    {
                        "id": 122584,
                        "name": "Nassau Village-Ratliff",
                        "latitude": "30.51111000",
                        "longitude": "-81.80925000"
                    },
                    {
                        "id": 122600,
                        "name": "Navarre",
                        "latitude": "30.40159000",
                        "longitude": "-86.86357000"
                    },
                    {
                        "id": 122637,
                        "name": "Neptune Beach",
                        "latitude": "30.31191000",
                        "longitude": "-81.39647000"
                    },
                    {
                        "id": 122764,
                        "name": "New Port Richey",
                        "latitude": "28.24418000",
                        "longitude": "-82.71927000"
                    },
                    {
                        "id": 122765,
                        "name": "New Port Richey East",
                        "latitude": "28.26027000",
                        "longitude": "-82.69261000"
                    },
                    {
                        "id": 122779,
                        "name": "New Smyrna Beach",
                        "latitude": "29.02582000",
                        "longitude": "-80.92700000"
                    },
                    {
                        "id": 122810,
                        "name": "Newberry",
                        "latitude": "29.64635000",
                        "longitude": "-82.60650000"
                    },
                    {
                        "id": 122886,
                        "name": "Niceville",
                        "latitude": "30.51686000",
                        "longitude": "-86.48217000"
                    },
                    {
                        "id": 122922,
                        "name": "Nocatee",
                        "latitude": "27.16033000",
                        "longitude": "-81.88231000"
                    },
                    {
                        "id": 122929,
                        "name": "Nokomis",
                        "latitude": "27.11922000",
                        "longitude": "-82.44426000"
                    },
                    {
                        "id": 122946,
                        "name": "Norland",
                        "latitude": "25.94898000",
                        "longitude": "-80.21227000"
                    },
                    {
                        "id": 122963,
                        "name": "North Andrews Gardens",
                        "latitude": "26.19147000",
                        "longitude": "-80.14421000"
                    },
                    {
                        "id": 122976,
                        "name": "North Bay Village",
                        "latitude": "25.84621000",
                        "longitude": "-80.15394000"
                    },
                    {
                        "id": 122997,
                        "name": "North Brooksville",
                        "latitude": "28.57305000",
                        "longitude": "-82.40815000"
                    },
                    {
                        "id": 123013,
                        "name": "North DeLand",
                        "latitude": "29.04943000",
                        "longitude": "-81.29812000"
                    },
                    {
                        "id": 123029,
                        "name": "North Fort Myers",
                        "latitude": "26.66729000",
                        "longitude": "-81.88009000"
                    },
                    {
                        "id": 123047,
                        "name": "North Key Largo",
                        "latitude": "25.26734000",
                        "longitude": "-80.32339000"
                    },
                    {
                        "id": 123053,
                        "name": "North Lauderdale",
                        "latitude": "26.21730000",
                        "longitude": "-80.22588000"
                    },
                    {
                        "id": 123066,
                        "name": "North Miami",
                        "latitude": "25.89009000",
                        "longitude": "-80.18671000"
                    },
                    {
                        "id": 123067,
                        "name": "North Miami Beach",
                        "latitude": "25.93315000",
                        "longitude": "-80.16255000"
                    },
                    {
                        "id": 123075,
                        "name": "North Palm Beach",
                        "latitude": "26.81756000",
                        "longitude": "-80.08199000"
                    },
                    {
                        "id": 123085,
                        "name": "North Port",
                        "latitude": "27.04422000",
                        "longitude": "-82.23593000"
                    },
                    {
                        "id": 123092,
                        "name": "North Redington Beach",
                        "latitude": "27.81614000",
                        "longitude": "-82.82066000"
                    },
                    {
                        "id": 123095,
                        "name": "North River Shores",
                        "latitude": "27.21755000",
                        "longitude": "-80.26977000"
                    },
                    {
                        "id": 123100,
                        "name": "North Sarasota",
                        "latitude": "27.37393000",
                        "longitude": "-82.51843000"
                    },
                    {
                        "id": 123127,
                        "name": "North Weeki Wachee",
                        "latitude": "28.55014000",
                        "longitude": "-82.55888000"
                    },
                    {
                        "id": 123145,
                        "name": "Northdale",
                        "latitude": "28.09390000",
                        "longitude": "-82.50561000"
                    },
                    {
                        "id": 123243,
                        "name": "Oak Hill",
                        "latitude": "28.86443000",
                        "longitude": "-80.85450000"
                    },
                    {
                        "id": 123260,
                        "name": "Oak Ridge",
                        "latitude": "28.47112000",
                        "longitude": "-81.42452000"
                    },
                    {
                        "id": 123282,
                        "name": "Oakland",
                        "latitude": "28.55500000",
                        "longitude": "-81.63313000"
                    },
                    {
                        "id": 123296,
                        "name": "Oakland Park",
                        "latitude": "26.17231000",
                        "longitude": "-80.13199000"
                    },
                    {
                        "id": 123297,
                        "name": "Oakleaf Plantation",
                        "latitude": "30.17083000",
                        "longitude": "-81.83549000"
                    },
                    {
                        "id": 123320,
                        "name": "Ocala",
                        "latitude": "29.18720000",
                        "longitude": "-82.14009000"
                    },
                    {
                        "id": 123325,
                        "name": "Ocean City",
                        "latitude": "30.44103000",
                        "longitude": "-86.61356000"
                    },
                    {
                        "id": 123335,
                        "name": "Ocean Ridge",
                        "latitude": "26.52702000",
                        "longitude": "-80.04837000"
                    },
                    {
                        "id": 123347,
                        "name": "Ocoee",
                        "latitude": "28.56917000",
                        "longitude": "-81.54396000"
                    },
                    {
                        "id": 123358,
                        "name": "Odessa",
                        "latitude": "28.19390000",
                        "longitude": "-82.59176000"
                    },
                    {
                        "id": 123391,
                        "name": "Ojus",
                        "latitude": "25.94843000",
                        "longitude": "-80.15060000"
                    },
                    {
                        "id": 123392,
                        "name": "Okaloosa County",
                        "latitude": "30.66503000",
                        "longitude": "-86.59218000"
                    },
                    {
                        "id": 123398,
                        "name": "Okeechobee",
                        "latitude": "27.24393000",
                        "longitude": "-80.82978000"
                    },
                    {
                        "id": 123399,
                        "name": "Okeechobee County",
                        "latitude": "27.38629000",
                        "longitude": "-80.88858000"
                    },
                    {
                        "id": 123434,
                        "name": "Oldsmar",
                        "latitude": "28.03418000",
                        "longitude": "-82.66510000"
                    },
                    {
                        "id": 123437,
                        "name": "Olga",
                        "latitude": "26.71896000",
                        "longitude": "-81.71230000"
                    },
                    {
                        "id": 123461,
                        "name": "Olympia Heights",
                        "latitude": "25.72677000",
                        "longitude": "-80.35533000"
                    },
                    {
                        "id": 123494,
                        "name": "Opa-locka",
                        "latitude": "25.90232000",
                        "longitude": "-80.25033000"
                    },
                    {
                        "id": 123512,
                        "name": "Orange City",
                        "latitude": "28.94888000",
                        "longitude": "-81.29867000"
                    },
                    {
                        "id": 123514,
                        "name": "Orange County",
                        "latitude": "28.51442000",
                        "longitude": "-81.32348000"
                    },
                    {
                        "id": 123525,
                        "name": "Orange Park",
                        "latitude": "30.16607000",
                        "longitude": "-81.70648000"
                    },
                    {
                        "id": 123529,
                        "name": "Orangetree",
                        "latitude": "26.29286000",
                        "longitude": "-81.58842000"
                    },
                    {
                        "id": 123555,
                        "name": "Oriole Beach",
                        "latitude": "30.37381000",
                        "longitude": "-87.09136000"
                    },
                    {
                        "id": 123562,
                        "name": "Orlando",
                        "latitude": "28.53834000",
                        "longitude": "-81.37924000"
                    },
                    {
                        "id": 123568,
                        "name": "Orlovista",
                        "latitude": "28.53834000",
                        "longitude": "-81.46035000"
                    },
                    {
                        "id": 123569,
                        "name": "Ormond Beach",
                        "latitude": "29.28581000",
                        "longitude": "-81.05589000"
                    },
                    {
                        "id": 123570,
                        "name": "Ormond-by-the-Sea",
                        "latitude": "29.34914000",
                        "longitude": "-81.06645000"
                    },
                    {
                        "id": 123603,
                        "name": "Osceola County",
                        "latitude": "28.06266000",
                        "longitude": "-81.14948000"
                    },
                    {
                        "id": 123613,
                        "name": "Osprey",
                        "latitude": "27.19616000",
                        "longitude": "-82.49037000"
                    },
                    {
                        "id": 123656,
                        "name": "Oviedo",
                        "latitude": "28.67000000",
                        "longitude": "-81.20812000"
                    },
                    {
                        "id": 123704,
                        "name": "Pace",
                        "latitude": "30.59936000",
                        "longitude": "-87.16108000"
                    },
                    {
                        "id": 123723,
                        "name": "Pahokee",
                        "latitude": "26.82006000",
                        "longitude": "-80.66534000"
                    },
                    {
                        "id": 123732,
                        "name": "Palatka",
                        "latitude": "29.64858000",
                        "longitude": "-81.63758000"
                    },
                    {
                        "id": 123740,
                        "name": "Palm Aire",
                        "latitude": "26.20619000",
                        "longitude": "-80.19171000"
                    },
                    {
                        "id": 123741,
                        "name": "Palm Bay",
                        "latitude": "28.03446000",
                        "longitude": "-80.58866000"
                    },
                    {
                        "id": 123742,
                        "name": "Palm Beach",
                        "latitude": "26.70562000",
                        "longitude": "-80.03643000"
                    },
                    {
                        "id": 123743,
                        "name": "Palm Beach County",
                        "latitude": "26.64757000",
                        "longitude": "-80.43651000"
                    },
                    {
                        "id": 123744,
                        "name": "Palm Beach Gardens",
                        "latitude": "26.82339000",
                        "longitude": "-80.13865000"
                    },
                    {
                        "id": 123745,
                        "name": "Palm Beach Shores",
                        "latitude": "26.77812000",
                        "longitude": "-80.03560000"
                    },
                    {
                        "id": 123746,
                        "name": "Palm City",
                        "latitude": "27.16783000",
                        "longitude": "-80.26616000"
                    },
                    {
                        "id": 123747,
                        "name": "Palm Coast",
                        "latitude": "29.58497000",
                        "longitude": "-81.20784000"
                    },
                    {
                        "id": 123749,
                        "name": "Palm Harbor",
                        "latitude": "28.07807000",
                        "longitude": "-82.76371000"
                    },
                    {
                        "id": 123750,
                        "name": "Palm River-Clair Mel",
                        "latitude": "27.92386000",
                        "longitude": "-82.37939000"
                    },
                    {
                        "id": 123751,
                        "name": "Palm Springs",
                        "latitude": "26.63590000",
                        "longitude": "-80.09615000"
                    },
                    {
                        "id": 123753,
                        "name": "Palm Springs North",
                        "latitude": "25.93510000",
                        "longitude": "-80.33383000"
                    },
                    {
                        "id": 123754,
                        "name": "Palm Valley",
                        "latitude": "30.17746000",
                        "longitude": "-81.38758000"
                    },
                    {
                        "id": 123764,
                        "name": "Palmetto",
                        "latitude": "27.52143000",
                        "longitude": "-82.57232000"
                    },
                    {
                        "id": 123766,
                        "name": "Palmetto Bay",
                        "latitude": "25.62177000",
                        "longitude": "-80.32477000"
                    },
                    {
                        "id": 123767,
                        "name": "Palmetto Estates",
                        "latitude": "25.62149000",
                        "longitude": "-80.36200000"
                    },
                    {
                        "id": 123769,
                        "name": "Palmona Park",
                        "latitude": "26.68646000",
                        "longitude": "-81.89648000"
                    },
                    {
                        "id": 123798,
                        "name": "Panama City",
                        "latitude": "30.15946000",
                        "longitude": "-85.65983000"
                    },
                    {
                        "id": 123799,
                        "name": "Panama City Beach",
                        "latitude": "30.17659000",
                        "longitude": "-85.80549000"
                    },
                    {
                        "id": 123820,
                        "name": "Paradise Heights",
                        "latitude": "28.62361000",
                        "longitude": "-81.54396000"
                    },
                    {
                        "id": 123858,
                        "name": "Parker",
                        "latitude": "30.13104000",
                        "longitude": "-85.60326000"
                    },
                    {
                        "id": 123871,
                        "name": "Parkland",
                        "latitude": "26.31008000",
                        "longitude": "-80.23727000"
                    },
                    {
                        "id": 123898,
                        "name": "Pasadena Hills",
                        "latitude": "28.28001000",
                        "longitude": "-82.22438000"
                    },
                    {
                        "id": 123902,
                        "name": "Pasco County",
                        "latitude": "28.30674000",
                        "longitude": "-82.43887000"
                    },
                    {
                        "id": 123974,
                        "name": "Pebble Creek",
                        "latitude": "28.14835000",
                        "longitude": "-82.34565000"
                    },
                    {
                        "id": 123994,
                        "name": "Pelican Bay",
                        "latitude": "26.23120000",
                        "longitude": "-81.80564000"
                    },
                    {
                        "id": 124008,
                        "name": "Pembroke Park",
                        "latitude": "25.98787000",
                        "longitude": "-80.17477000"
                    },
                    {
                        "id": 124009,
                        "name": "Pembroke Pines",
                        "latitude": "26.00315000",
                        "longitude": "-80.22394000"
                    },
                    {
                        "id": 124045,
                        "name": "Pensacola",
                        "latitude": "30.42131000",
                        "longitude": "-87.21691000"
                    },
                    {
                        "id": 124067,
                        "name": "Perry",
                        "latitude": "30.11766000",
                        "longitude": "-83.58274000"
                    },
                    {
                        "id": 124180,
                        "name": "Pierson",
                        "latitude": "29.23942000",
                        "longitude": "-81.46563000"
                    },
                    {
                        "id": 124217,
                        "name": "Pine Castle",
                        "latitude": "28.47195000",
                        "longitude": "-81.36785000"
                    },
                    {
                        "id": 124225,
                        "name": "Pine Hills",
                        "latitude": "28.55778000",
                        "longitude": "-81.45340000"
                    },
                    {
                        "id": 124229,
                        "name": "Pine Island Center",
                        "latitude": "26.61369000",
                        "longitude": "-82.11815000"
                    },
                    {
                        "id": 124230,
                        "name": "Pine Island Ridge",
                        "latitude": "26.09481000",
                        "longitude": "-80.27394000"
                    },
                    {
                        "id": 124237,
                        "name": "Pine Manor",
                        "latitude": "26.57285000",
                        "longitude": "-81.87814000"
                    },
                    {
                        "id": 124242,
                        "name": "Pine Ridge",
                        "latitude": "28.93831000",
                        "longitude": "-82.47343000"
                    },
                    {
                        "id": 124248,
                        "name": "Pinecrest",
                        "latitude": "25.66705000",
                        "longitude": "-80.30811000"
                    },
                    {
                        "id": 124254,
                        "name": "Pinellas County",
                        "latitude": "27.90268000",
                        "longitude": "-82.73955000"
                    },
                    {
                        "id": 124255,
                        "name": "Pinellas Park",
                        "latitude": "27.84280000",
                        "longitude": "-82.69954000"
                    },
                    {
                        "id": 124264,
                        "name": "Pinewood",
                        "latitude": "25.86898000",
                        "longitude": "-80.21699000"
                    },
                    {
                        "id": 124313,
                        "name": "Placid Lakes",
                        "latitude": "27.24144000",
                        "longitude": "-81.40702000"
                    },
                    {
                        "id": 124345,
                        "name": "Plant City",
                        "latitude": "28.01888000",
                        "longitude": "-82.11469000"
                    },
                    {
                        "id": 124346,
                        "name": "Plantation",
                        "latitude": "26.13421000",
                        "longitude": "-80.23184000"
                    },
                    {
                        "id": 124347,
                        "name": "Plantation Mobile Home Park",
                        "latitude": "26.70312000",
                        "longitude": "-80.13227000"
                    },
                    {
                        "id": 124424,
                        "name": "Poinciana",
                        "latitude": "28.14029000",
                        "longitude": "-81.45841000"
                    },
                    {
                        "id": 124426,
                        "name": "Point Baker",
                        "latitude": "30.69019000",
                        "longitude": "-87.05358000"
                    },
                    {
                        "id": 124438,
                        "name": "Polk City",
                        "latitude": "28.18251000",
                        "longitude": "-81.82397000"
                    },
                    {
                        "id": 124441,
                        "name": "Polk County",
                        "latitude": "27.94888000",
                        "longitude": "-81.69767000"
                    },
                    {
                        "id": 124460,
                        "name": "Pompano Beach",
                        "latitude": "26.23786000",
                        "longitude": "-80.12477000"
                    },
                    {
                        "id": 124461,
                        "name": "Pompano Beach Highlands",
                        "latitude": "26.28286000",
                        "longitude": "-80.10699000"
                    },
                    {
                        "id": 124465,
                        "name": "Ponce Inlet",
                        "latitude": "29.09637000",
                        "longitude": "-80.93700000"
                    },
                    {
                        "id": 124472,
                        "name": "Ponte Vedra Beach",
                        "latitude": "30.23969000",
                        "longitude": "-81.38564000"
                    },
                    {
                        "id": 124502,
                        "name": "Port Charlotte",
                        "latitude": "26.97617000",
                        "longitude": "-82.09064000"
                    },
                    {
                        "id": 124516,
                        "name": "Port LaBelle",
                        "latitude": "26.75645000",
                        "longitude": "-81.40508000"
                    },
                    {
                        "id": 124524,
                        "name": "Port Orange",
                        "latitude": "29.13832000",
                        "longitude": "-80.99561000"
                    },
                    {
                        "id": 124529,
                        "name": "Port Richey",
                        "latitude": "28.27168000",
                        "longitude": "-82.71955000"
                    },
                    {
                        "id": 124532,
                        "name": "Port Saint Joe",
                        "latitude": "29.81188000",
                        "longitude": "-85.30297000"
                    },
                    {
                        "id": 124533,
                        "name": "Port Saint John",
                        "latitude": "28.47695000",
                        "longitude": "-80.78867000"
                    },
                    {
                        "id": 124534,
                        "name": "Port Saint Lucie",
                        "latitude": "27.29393000",
                        "longitude": "-80.35033000"
                    },
                    {
                        "id": 124535,
                        "name": "Port Salerno",
                        "latitude": "27.14422000",
                        "longitude": "-80.20060000"
                    },
                    {
                        "id": 124662,
                        "name": "Pretty Bayou",
                        "latitude": "30.19659000",
                        "longitude": "-85.69660000"
                    },
                    {
                        "id": 124680,
                        "name": "Princeton",
                        "latitude": "25.53844000",
                        "longitude": "-80.40894000"
                    },
                    {
                        "id": 124703,
                        "name": "Progress Village",
                        "latitude": "27.90030000",
                        "longitude": "-82.36454000"
                    },
                    {
                        "id": 124748,
                        "name": "Punta Gorda",
                        "latitude": "26.92978000",
                        "longitude": "-82.04537000"
                    },
                    {
                        "id": 124749,
                        "name": "Punta Gorda Isles",
                        "latitude": "26.91756000",
                        "longitude": "-82.07842000"
                    },
                    {
                        "id": 124750,
                        "name": "Punta Rassa",
                        "latitude": "26.48786000",
                        "longitude": "-82.01231000"
                    },
                    {
                        "id": 124761,
                        "name": "Putnam County",
                        "latitude": "29.60863000",
                        "longitude": "-81.74430000"
                    },
                    {
                        "id": 124776,
                        "name": "Quail Ridge",
                        "latitude": "28.34905000",
                        "longitude": "-82.55532000"
                    },
                    {
                        "id": 124795,
                        "name": "Quincy",
                        "latitude": "30.58714000",
                        "longitude": "-84.58325000"
                    },
                    {
                        "id": 124971,
                        "name": "Redington Beach",
                        "latitude": "27.80864000",
                        "longitude": "-82.81121000"
                    },
                    {
                        "id": 124972,
                        "name": "Redington Shores",
                        "latitude": "27.82614000",
                        "longitude": "-82.82899000"
                    },
                    {
                        "id": 125102,
                        "name": "Richmond Heights",
                        "latitude": "25.63149000",
                        "longitude": "-80.36894000"
                    },
                    {
                        "id": 125106,
                        "name": "Richmond West",
                        "latitude": "25.61050000",
                        "longitude": "-80.42971000"
                    },
                    {
                        "id": 125115,
                        "name": "Ridge Manor",
                        "latitude": "28.50750000",
                        "longitude": "-82.17036000"
                    },
                    {
                        "id": 125116,
                        "name": "Ridge Wood Heights",
                        "latitude": "27.28727000",
                        "longitude": "-82.51315000"
                    },
                    {
                        "id": 125117,
                        "name": "Ridgecrest",
                        "latitude": "27.89750000",
                        "longitude": "-82.80529000"
                    },
                    {
                        "id": 125184,
                        "name": "River Park",
                        "latitude": "27.31421000",
                        "longitude": "-80.34727000"
                    },
                    {
                        "id": 125216,
                        "name": "Riverview",
                        "latitude": "27.86614000",
                        "longitude": "-82.32648000"
                    },
                    {
                        "id": 125221,
                        "name": "Riviera Beach",
                        "latitude": "26.77534000",
                        "longitude": "-80.05810000"
                    },
                    {
                        "id": 125282,
                        "name": "Rock Island",
                        "latitude": "26.15509000",
                        "longitude": "-80.17699000"
                    },
                    {
                        "id": 125311,
                        "name": "Rockledge",
                        "latitude": "28.35084000",
                        "longitude": "-80.72533000"
                    },
                    {
                        "id": 125395,
                        "name": "Roosevelt Gardens",
                        "latitude": "26.14087000",
                        "longitude": "-80.18027000"
                    },
                    {
                        "id": 125421,
                        "name": "Roseland",
                        "latitude": "27.83586000",
                        "longitude": "-80.49311000"
                    },
                    {
                        "id": 125467,
                        "name": "Rotonda West",
                        "latitude": "26.88368000",
                        "longitude": "-82.29009000"
                    },
                    {
                        "id": 125491,
                        "name": "Royal Palm Beach",
                        "latitude": "26.70840000",
                        "longitude": "-80.23060000"
                    },
                    {
                        "id": 125492,
                        "name": "Royal Palm Estates",
                        "latitude": "26.68173000",
                        "longitude": "-80.12504000"
                    },
                    {
                        "id": 125531,
                        "name": "Ruskin",
                        "latitude": "27.72086000",
                        "longitude": "-82.43315000"
                    },
                    {
                        "id": 125582,
                        "name": "Safety Harbor",
                        "latitude": "27.99085000",
                        "longitude": "-82.69316000"
                    },
                    {
                        "id": 125604,
                        "name": "Saint Augustine",
                        "latitude": "29.89469000",
                        "longitude": "-81.31452000"
                    },
                    {
                        "id": 125605,
                        "name": "Saint Augustine Beach",
                        "latitude": "29.85053000",
                        "longitude": "-81.26535000"
                    },
                    {
                        "id": 125606,
                        "name": "Saint Augustine Shores",
                        "latitude": "29.81080000",
                        "longitude": "-81.31035000"
                    },
                    {
                        "id": 125607,
                        "name": "Saint Augustine South",
                        "latitude": "29.84249000",
                        "longitude": "-81.31448000"
                    },
                    {
                        "id": 125626,
                        "name": "Saint Cloud",
                        "latitude": "28.24890000",
                        "longitude": "-81.28118000"
                    },
                    {
                        "id": 125640,
                        "name": "Saint George",
                        "latitude": "28.05641000",
                        "longitude": "-82.72788000"
                    },
                    {
                        "id": 125657,
                        "name": "Saint James City",
                        "latitude": "26.49758000",
                        "longitude": "-82.07843000"
                    },
                    {
                        "id": 125667,
                        "name": "Saint Johns County",
                        "latitude": "29.91218000",
                        "longitude": "-81.40989000"
                    },
                    {
                        "id": 125679,
                        "name": "Saint Leo",
                        "latitude": "28.33723000",
                        "longitude": "-82.25842000"
                    },
                    {
                        "id": 125684,
                        "name": "Saint Lucie County",
                        "latitude": "27.38081000",
                        "longitude": "-80.44554000"
                    },
                    {
                        "id": 125707,
                        "name": "Saint Pete Beach",
                        "latitude": "27.72531000",
                        "longitude": "-82.74121000"
                    },
                    {
                        "id": 125779,
                        "name": "Samoset",
                        "latitude": "27.46948000",
                        "longitude": "-82.54149000"
                    },
                    {
                        "id": 125782,
                        "name": "Samsula-Spruce Creek",
                        "latitude": "29.04932000",
                        "longitude": "-81.06192000"
                    },
                    {
                        "id": 125786,
                        "name": "San Antonio",
                        "latitude": "28.33611000",
                        "longitude": "-82.27453000"
                    },
                    {
                        "id": 125799,
                        "name": "San Carlos Park",
                        "latitude": "26.46730000",
                        "longitude": "-81.80147000"
                    },
                    {
                        "id": 125862,
                        "name": "Sandalfoot Cove",
                        "latitude": "26.33863000",
                        "longitude": "-80.18690000"
                    },
                    {
                        "id": 125886,
                        "name": "Sanford",
                        "latitude": "28.80055000",
                        "longitude": "-81.27312000"
                    },
                    {
                        "id": 125894,
                        "name": "Sanibel",
                        "latitude": "26.44897000",
                        "longitude": "-82.02231000"
                    },
                    {
                        "id": 125924,
                        "name": "Santa Rosa County",
                        "latitude": "30.69290000",
                        "longitude": "-87.01845000"
                    },
                    {
                        "id": 125938,
                        "name": "Sarasota",
                        "latitude": "27.33643000",
                        "longitude": "-82.53065000"
                    },
                    {
                        "id": 125939,
                        "name": "Sarasota County",
                        "latitude": "27.18248000",
                        "longitude": "-82.36498000"
                    },
                    {
                        "id": 125940,
                        "name": "Sarasota Springs",
                        "latitude": "27.30894000",
                        "longitude": "-82.47954000"
                    },
                    {
                        "id": 125955,
                        "name": "Satellite Beach",
                        "latitude": "28.17612000",
                        "longitude": "-80.59005000"
                    },
                    {
                        "id": 125980,
                        "name": "Sawgrass",
                        "latitude": "30.19274000",
                        "longitude": "-81.37064000"
                    },
                    {
                        "id": 126001,
                        "name": "Schall Circle",
                        "latitude": "26.71562000",
                        "longitude": "-80.11504000"
                    },
                    {
                        "id": 126054,
                        "name": "Scott Lake",
                        "latitude": "25.94148000",
                        "longitude": "-80.23199000"
                    },
                    {
                        "id": 126097,
                        "name": "Seaside",
                        "latitude": "30.32103000",
                        "longitude": "-86.14161000"
                    },
                    {
                        "id": 126105,
                        "name": "Sebastian",
                        "latitude": "27.81641000",
                        "longitude": "-80.47061000"
                    },
                    {
                        "id": 126111,
                        "name": "Sebring",
                        "latitude": "27.49559000",
                        "longitude": "-81.44091000"
                    },
                    {
                        "id": 126127,
                        "name": "Seffner",
                        "latitude": "27.98363000",
                        "longitude": "-82.27565000"
                    },
                    {
                        "id": 126144,
                        "name": "Seminole",
                        "latitude": "27.83975000",
                        "longitude": "-82.79121000"
                    },
                    {
                        "id": 126147,
                        "name": "Seminole County",
                        "latitude": "28.71698000",
                        "longitude": "-81.23630000"
                    },
                    {
                        "id": 126150,
                        "name": "Seminole Manor",
                        "latitude": "26.58368000",
                        "longitude": "-80.10032000"
                    },
                    {
                        "id": 126184,
                        "name": "Sewall's Point",
                        "latitude": "27.19949000",
                        "longitude": "-80.20227000"
                    },
                    {
                        "id": 126204,
                        "name": "Shady Hills",
                        "latitude": "28.41000000",
                        "longitude": "-82.54288000"
                    },
                    {
                        "id": 126234,
                        "name": "Sharpes",
                        "latitude": "28.43223000",
                        "longitude": "-80.76005000"
                    },
                    {
                        "id": 126409,
                        "name": "Siesta Key",
                        "latitude": "27.26785000",
                        "longitude": "-82.54526000"
                    },
                    {
                        "id": 126427,
                        "name": "Silver Lake",
                        "latitude": "28.84193000",
                        "longitude": "-81.79841000"
                    },
                    {
                        "id": 126436,
                        "name": "Silver Springs",
                        "latitude": "29.21664000",
                        "longitude": "-82.05759000"
                    },
                    {
                        "id": 126437,
                        "name": "Silver Springs Shores",
                        "latitude": "29.10442000",
                        "longitude": "-82.02064000"
                    },
                    {
                        "id": 126485,
                        "name": "Sky Lake",
                        "latitude": "28.45723000",
                        "longitude": "-81.39146000"
                    },
                    {
                        "id": 126538,
                        "name": "Sneads",
                        "latitude": "30.70801000",
                        "longitude": "-84.92552000"
                    },
                    {
                        "id": 126614,
                        "name": "South Apopka",
                        "latitude": "28.66194000",
                        "longitude": "-81.50952000"
                    },
                    {
                        "id": 126618,
                        "name": "South Bay",
                        "latitude": "26.66396000",
                        "longitude": "-80.71617000"
                    },
                    {
                        "id": 126619,
                        "name": "South Beach",
                        "latitude": "27.59115000",
                        "longitude": "-80.34422000"
                    },
                    {
                        "id": 126631,
                        "name": "South Bradenton",
                        "latitude": "27.46310000",
                        "longitude": "-82.58176000"
                    },
                    {
                        "id": 126632,
                        "name": "South Brooksville",
                        "latitude": "28.53582000",
                        "longitude": "-82.38403000"
                    },
                    {
                        "id": 126645,
                        "name": "South Daytona",
                        "latitude": "29.16582000",
                        "longitude": "-81.00450000"
                    },
                    {
                        "id": 126660,
                        "name": "South Gate Ridge",
                        "latitude": "27.28644000",
                        "longitude": "-82.49676000"
                    },
                    {
                        "id": 126670,
                        "name": "South Highpoint",
                        "latitude": "27.91697000",
                        "longitude": "-82.71288000"
                    },
                    {
                        "id": 126691,
                        "name": "South Miami",
                        "latitude": "25.70760000",
                        "longitude": "-80.29338000"
                    },
                    {
                        "id": 126692,
                        "name": "South Miami Heights",
                        "latitude": "25.59761000",
                        "longitude": "-80.38061000"
                    },
                    {
                        "id": 126701,
                        "name": "South Palm Beach",
                        "latitude": "26.58896000",
                        "longitude": "-80.03865000"
                    },
                    {
                        "id": 126705,
                        "name": "South Pasadena",
                        "latitude": "27.75503000",
                        "longitude": "-82.73760000"
                    },
                    {
                        "id": 126707,
                        "name": "South Patrick Shores",
                        "latitude": "28.20223000",
                        "longitude": "-80.60950000"
                    },
                    {
                        "id": 126727,
                        "name": "South Sarasota",
                        "latitude": "27.28616000",
                        "longitude": "-82.53288000"
                    },
                    {
                        "id": 126742,
                        "name": "South Venice",
                        "latitude": "27.05311000",
                        "longitude": "-82.42426000"
                    },
                    {
                        "id": 126764,
                        "name": "Southchase",
                        "latitude": "28.39306000",
                        "longitude": "-81.38340000"
                    },
                    {
                        "id": 126765,
                        "name": "Southeast Arcadia",
                        "latitude": "27.18629000",
                        "longitude": "-81.85210000"
                    },
                    {
                        "id": 126773,
                        "name": "Southgate",
                        "latitude": "27.30810000",
                        "longitude": "-82.50982000"
                    },
                    {
                        "id": 126790,
                        "name": "Southwest Ranches",
                        "latitude": "26.05870000",
                        "longitude": "-80.33727000"
                    },
                    {
                        "id": 126860,
                        "name": "Spring Hill",
                        "latitude": "28.47688000",
                        "longitude": "-82.52546000"
                    },
                    {
                        "id": 126889,
                        "name": "Springfield",
                        "latitude": "30.15326000",
                        "longitude": "-85.61132000"
                    },
                    {
                        "id": 126926,
                        "name": "St. Johns",
                        "latitude": "30.08150000",
                        "longitude": "-81.54774000"
                    },
                    {
                        "id": 126930,
                        "name": "St. Petersburg",
                        "latitude": "27.77086000",
                        "longitude": "-82.67927000"
                    },
                    {
                        "id": 126986,
                        "name": "Starke",
                        "latitude": "29.94413000",
                        "longitude": "-82.10983000"
                    },
                    {
                        "id": 127018,
                        "name": "Steinhatchee",
                        "latitude": "29.67106000",
                        "longitude": "-83.38764000"
                    },
                    {
                        "id": 127066,
                        "name": "Stock Island",
                        "latitude": "24.56709000",
                        "longitude": "-81.73842000"
                    },
                    {
                        "id": 127142,
                        "name": "Stuart",
                        "latitude": "27.19755000",
                        "longitude": "-80.25283000"
                    },
                    {
                        "id": 127176,
                        "name": "Sugarmill Woods",
                        "latitude": "28.73221000",
                        "longitude": "-82.50621000"
                    },
                    {
                        "id": 127229,
                        "name": "Sumter County",
                        "latitude": "28.70482000",
                        "longitude": "-82.08100000"
                    },
                    {
                        "id": 127234,
                        "name": "Sun City Center",
                        "latitude": "27.71809000",
                        "longitude": "-82.35176000"
                    },
                    {
                        "id": 127246,
                        "name": "Suncoast Estates",
                        "latitude": "26.71174000",
                        "longitude": "-81.86897000"
                    },
                    {
                        "id": 127256,
                        "name": "Sunny Isles Beach",
                        "latitude": "25.95065000",
                        "longitude": "-80.12282000"
                    },
                    {
                        "id": 127267,
                        "name": "Sunrise",
                        "latitude": "26.13397000",
                        "longitude": "-80.11310000"
                    },
                    {
                        "id": 127271,
                        "name": "Sunset",
                        "latitude": "25.70594000",
                        "longitude": "-80.35228000"
                    },
                    {
                        "id": 127277,
                        "name": "Sunshine Ranches",
                        "latitude": "26.04592000",
                        "longitude": "-80.32894000"
                    },
                    {
                        "id": 127287,
                        "name": "Surfside",
                        "latitude": "25.87843000",
                        "longitude": "-80.12560000"
                    },
                    {
                        "id": 127318,
                        "name": "Suwannee County",
                        "latitude": "30.19561000",
                        "longitude": "-82.99149000"
                    },
                    {
                        "id": 127340,
                        "name": "Sweetwater",
                        "latitude": "25.76343000",
                        "longitude": "-80.37311000"
                    },
                    {
                        "id": 127371,
                        "name": "Taft",
                        "latitude": "28.42973000",
                        "longitude": "-81.36507000"
                    },
                    {
                        "id": 127391,
                        "name": "Tallahassee",
                        "latitude": "30.43826000",
                        "longitude": "-84.28073000"
                    },
                    {
                        "id": 127405,
                        "name": "Tamarac",
                        "latitude": "26.21286000",
                        "longitude": "-80.24977000"
                    },
                    {
                        "id": 127406,
                        "name": "Tamiami",
                        "latitude": "25.75871000",
                        "longitude": "-80.39839000"
                    },
                    {
                        "id": 127407,
                        "name": "Tampa",
                        "latitude": "27.94752000",
                        "longitude": "-82.45843000"
                    },
                    {
                        "id": 127412,
                        "name": "Tangelo Park",
                        "latitude": "28.45584000",
                        "longitude": "-81.44590000"
                    },
                    {
                        "id": 127414,
                        "name": "Tangerine",
                        "latitude": "28.76499000",
                        "longitude": "-81.63063000"
                    },
                    {
                        "id": 127433,
                        "name": "Tarpon Springs",
                        "latitude": "28.14612000",
                        "longitude": "-82.75677000"
                    },
                    {
                        "id": 127442,
                        "name": "Tavares",
                        "latitude": "28.80416000",
                        "longitude": "-81.72563000"
                    },
                    {
                        "id": 127443,
                        "name": "Tavernier",
                        "latitude": "25.01152000",
                        "longitude": "-80.51506000"
                    },
                    {
                        "id": 127451,
                        "name": "Taylor County",
                        "latitude": "30.01957000",
                        "longitude": "-83.61897000"
                    },
                    {
                        "id": 127458,
                        "name": "Taylor Creek",
                        "latitude": "27.21671000",
                        "longitude": "-80.78950000"
                    },
                    {
                        "id": 127481,
                        "name": "Tedder",
                        "latitude": "26.28425000",
                        "longitude": "-80.12227000"
                    },
                    {
                        "id": 127503,
                        "name": "Temple Terrace",
                        "latitude": "28.03530000",
                        "longitude": "-82.38926000"
                    },
                    {
                        "id": 127513,
                        "name": "Tequesta",
                        "latitude": "26.96811000",
                        "longitude": "-80.12865000"
                    },
                    {
                        "id": 127516,
                        "name": "Terra Mar",
                        "latitude": "26.21619000",
                        "longitude": "-80.09532000"
                    },
                    {
                        "id": 127553,
                        "name": "The Acreage",
                        "latitude": "26.79404000",
                        "longitude": "-80.26749000"
                    },
                    {
                        "id": 127556,
                        "name": "The Crossings",
                        "latitude": "25.67066000",
                        "longitude": "-80.40117000"
                    },
                    {
                        "id": 127559,
                        "name": "The Hammocks",
                        "latitude": "25.67149000",
                        "longitude": "-80.44450000"
                    },
                    {
                        "id": 127562,
                        "name": "The Meadows",
                        "latitude": "27.36171000",
                        "longitude": "-82.46898000"
                    },
                    {
                        "id": 127565,
                        "name": "The Villages",
                        "latitude": "28.93408000",
                        "longitude": "-81.95994000"
                    },
                    {
                        "id": 127597,
                        "name": "Thonotosassa",
                        "latitude": "28.06141000",
                        "longitude": "-82.30231000"
                    },
                    {
                        "id": 127612,
                        "name": "Three Lakes",
                        "latitude": "25.64205000",
                        "longitude": "-80.39839000"
                    },
                    {
                        "id": 127614,
                        "name": "Three Oaks",
                        "latitude": "26.47008000",
                        "longitude": "-81.79397000"
                    },
                    {
                        "id": 127633,
                        "name": "Tice",
                        "latitude": "26.67479000",
                        "longitude": "-81.81508000"
                    },
                    {
                        "id": 127638,
                        "name": "Tierra Verde",
                        "latitude": "27.69197000",
                        "longitude": "-82.72343000"
                    },
                    {
                        "id": 127644,
                        "name": "Tiger Point",
                        "latitude": "30.37853000",
                        "longitude": "-87.05552000"
                    },
                    {
                        "id": 127657,
                        "name": "Timber Pines",
                        "latitude": "28.47028000",
                        "longitude": "-82.60316000"
                    },
                    {
                        "id": 127685,
                        "name": "Titusville",
                        "latitude": "28.61222000",
                        "longitude": "-80.80755000"
                    },
                    {
                        "id": 127756,
                        "name": "Town 'n' Country",
                        "latitude": "28.01057000",
                        "longitude": "-82.57732000"
                    },
                    {
                        "id": 127790,
                        "name": "Treasure Island",
                        "latitude": "27.76919000",
                        "longitude": "-82.76899000"
                    },
                    {
                        "id": 127801,
                        "name": "Trenton",
                        "latitude": "29.61329000",
                        "longitude": "-82.81762000"
                    },
                    {
                        "id": 127824,
                        "name": "Trinity",
                        "latitude": "28.18085000",
                        "longitude": "-82.68177000"
                    },
                    {
                        "id": 127928,
                        "name": "Twin Lakes",
                        "latitude": "26.18092000",
                        "longitude": "-80.16005000"
                    },
                    {
                        "id": 127946,
                        "name": "Tyndall Air Force Base",
                        "latitude": "30.08535000",
                        "longitude": "-85.60731000"
                    },
                    {
                        "id": 127961,
                        "name": "Umatilla",
                        "latitude": "28.92943000",
                        "longitude": "-81.66563000"
                    },
                    {
                        "id": 127989,
                        "name": "Union County",
                        "latitude": "30.04384000",
                        "longitude": "-82.37144000"
                    },
                    {
                        "id": 128009,
                        "name": "Union Park",
                        "latitude": "28.56806000",
                        "longitude": "-81.28618000"
                    },
                    {
                        "id": 128025,
                        "name": "University",
                        "latitude": "28.07389000",
                        "longitude": "-82.43902000"
                    },
                    {
                        "id": 128031,
                        "name": "University Park",
                        "latitude": "25.74649000",
                        "longitude": "-80.36755000"
                    },
                    {
                        "id": 128044,
                        "name": "Upper Grand Lagoon",
                        "latitude": "30.16326000",
                        "longitude": "-85.74076000"
                    },
                    {
                        "id": 128120,
                        "name": "Valparaiso",
                        "latitude": "30.50853000",
                        "longitude": "-86.50273000"
                    },
                    {
                        "id": 128122,
                        "name": "Valrico",
                        "latitude": "27.93789000",
                        "longitude": "-82.23644000"
                    },
                    {
                        "id": 128123,
                        "name": "Vamo",
                        "latitude": "27.22200000",
                        "longitude": "-82.49787000"
                    },
                    {
                        "id": 128170,
                        "name": "Venice",
                        "latitude": "27.09978000",
                        "longitude": "-82.45426000"
                    },
                    {
                        "id": 128173,
                        "name": "Venice Gardens",
                        "latitude": "27.07311000",
                        "longitude": "-82.40760000"
                    },
                    {
                        "id": 128198,
                        "name": "Vero Beach",
                        "latitude": "27.63864000",
                        "longitude": "-80.39727000"
                    },
                    {
                        "id": 128199,
                        "name": "Vero Beach South",
                        "latitude": "27.61638000",
                        "longitude": "-80.41308000"
                    },
                    {
                        "id": 128206,
                        "name": "Verona Walk",
                        "latitude": "26.08412000",
                        "longitude": "-81.67985000"
                    },
                    {
                        "id": 128236,
                        "name": "Viera East",
                        "latitude": "28.26234000",
                        "longitude": "-80.71449000"
                    },
                    {
                        "id": 128237,
                        "name": "Viera West",
                        "latitude": "28.24504000",
                        "longitude": "-80.73380000"
                    },
                    {
                        "id": 128255,
                        "name": "Villages of Oriole",
                        "latitude": "26.46230000",
                        "longitude": "-80.15282000"
                    },
                    {
                        "id": 128256,
                        "name": "Villano Beach",
                        "latitude": "29.93858000",
                        "longitude": "-81.30202000"
                    },
                    {
                        "id": 128257,
                        "name": "Villas",
                        "latitude": "26.55035000",
                        "longitude": "-81.86870000"
                    },
                    {
                        "id": 128275,
                        "name": "Vineyards",
                        "latitude": "26.22373000",
                        "longitude": "-81.72798000"
                    },
                    {
                        "id": 128291,
                        "name": "Virginia Gardens",
                        "latitude": "25.81038000",
                        "longitude": "-80.30227000"
                    },
                    {
                        "id": 128303,
                        "name": "Volusia County",
                        "latitude": "29.06345000",
                        "longitude": "-81.14857000"
                    },
                    {
                        "id": 128314,
                        "name": "Wabasso Beach",
                        "latitude": "27.76475000",
                        "longitude": "-80.39894000"
                    },
                    {
                        "id": 128333,
                        "name": "Wahneta",
                        "latitude": "27.95280000",
                        "longitude": "-81.72702000"
                    },
                    {
                        "id": 128365,
                        "name": "Wakulla County",
                        "latitude": "30.14777000",
                        "longitude": "-84.37561000"
                    },
                    {
                        "id": 128371,
                        "name": "Waldo",
                        "latitude": "29.78969000",
                        "longitude": "-82.16732000"
                    },
                    {
                        "id": 128396,
                        "name": "Wallace",
                        "latitude": "30.67741000",
                        "longitude": "-87.17997000"
                    },
                    {
                        "id": 128437,
                        "name": "Walton County",
                        "latitude": "30.61847000",
                        "longitude": "-86.17152000"
                    },
                    {
                        "id": 128468,
                        "name": "Warm Mineral Springs",
                        "latitude": "27.05978000",
                        "longitude": "-82.26009000"
                    },
                    {
                        "id": 128512,
                        "name": "Warrington",
                        "latitude": "30.38409000",
                        "longitude": "-87.27497000"
                    },
                    {
                        "id": 128554,
                        "name": "Washington County",
                        "latitude": "30.61059000",
                        "longitude": "-85.66533000"
                    },
                    {
                        "id": 128584,
                        "name": "Washington Park",
                        "latitude": "26.13259000",
                        "longitude": "-80.18116000"
                    },
                    {
                        "id": 128618,
                        "name": "Watertown",
                        "latitude": "30.19245000",
                        "longitude": "-82.61457000"
                    },
                    {
                        "id": 128645,
                        "name": "Wauchula",
                        "latitude": "27.54726000",
                        "longitude": "-81.81147000"
                    },
                    {
                        "id": 128747,
                        "name": "Wedgefield",
                        "latitude": "28.48778000",
                        "longitude": "-81.07729000"
                    },
                    {
                        "id": 128755,
                        "name": "Weeki Wachee Gardens",
                        "latitude": "28.53361000",
                        "longitude": "-82.62954000"
                    },
                    {
                        "id": 128763,
                        "name": "Wekiwa Springs",
                        "latitude": "28.69861000",
                        "longitude": "-81.42563000"
                    },
                    {
                        "id": 128772,
                        "name": "Wellborn",
                        "latitude": "30.23106000",
                        "longitude": "-82.81957000"
                    },
                    {
                        "id": 128776,
                        "name": "Wellington",
                        "latitude": "26.65868000",
                        "longitude": "-80.24144000"
                    },
                    {
                        "id": 128809,
                        "name": "Wesley Chapel",
                        "latitude": "28.23973000",
                        "longitude": "-82.32787000"
                    },
                    {
                        "id": 129011,
                        "name": "West and East Lealman",
                        "latitude": "27.81993000",
                        "longitude": "-82.68944000"
                    },
                    {
                        "id": 128831,
                        "name": "West Bradenton",
                        "latitude": "27.50254000",
                        "longitude": "-82.61399000"
                    },
                    {
                        "id": 128855,
                        "name": "West DeLand",
                        "latitude": "29.01582000",
                        "longitude": "-81.33312000"
                    },
                    {
                        "id": 128876,
                        "name": "West Gate",
                        "latitude": "26.70257000",
                        "longitude": "-80.09810000"
                    },
                    {
                        "id": 128898,
                        "name": "West Hollywood",
                        "latitude": "26.02065000",
                        "longitude": "-80.18394000"
                    },
                    {
                        "id": 128920,
                        "name": "West Little River",
                        "latitude": "25.85704000",
                        "longitude": "-80.23699000"
                    },
                    {
                        "id": 128927,
                        "name": "West Melbourne",
                        "latitude": "28.07168000",
                        "longitude": "-80.65339000"
                    },
                    {
                        "id": 128930,
                        "name": "West Miami",
                        "latitude": "25.76343000",
                        "longitude": "-80.29616000"
                    },
                    {
                        "id": 128947,
                        "name": "West Palm Beach",
                        "latitude": "26.71534000",
                        "longitude": "-80.05337000"
                    },
                    {
                        "id": 128949,
                        "name": "West Park",
                        "latitude": "25.98454000",
                        "longitude": "-80.19894000"
                    },
                    {
                        "id": 128952,
                        "name": "West Pensacola",
                        "latitude": "30.42659000",
                        "longitude": "-87.27969000"
                    },
                    {
                        "id": 128954,
                        "name": "West Perrine",
                        "latitude": "25.60594000",
                        "longitude": "-80.36283000"
                    },
                    {
                        "id": 128974,
                        "name": "West Samoset",
                        "latitude": "27.46948000",
                        "longitude": "-82.55676000"
                    },
                    {
                        "id": 128998,
                        "name": "West Vero Corridor",
                        "latitude": "27.63775000",
                        "longitude": "-80.48576000"
                    },
                    {
                        "id": 129017,
                        "name": "Westchase",
                        "latitude": "28.05502000",
                        "longitude": "-82.60982000"
                    },
                    {
                        "id": 129018,
                        "name": "Westchester",
                        "latitude": "25.75482000",
                        "longitude": "-80.32727000"
                    },
                    {
                        "id": 129058,
                        "name": "Weston",
                        "latitude": "26.10037000",
                        "longitude": "-80.39977000"
                    },
                    {
                        "id": 129075,
                        "name": "Westview",
                        "latitude": "25.88204000",
                        "longitude": "-80.24199000"
                    },
                    {
                        "id": 129088,
                        "name": "Westwood Lake",
                        "latitude": "25.72927000",
                        "longitude": "-80.37283000"
                    },
                    {
                        "id": 129094,
                        "name": "Wewahitchka",
                        "latitude": "30.11270000",
                        "longitude": "-85.20047000"
                    },
                    {
                        "id": 129123,
                        "name": "Whiskey Creek",
                        "latitude": "26.57258000",
                        "longitude": "-81.89009000"
                    },
                    {
                        "id": 129130,
                        "name": "White City",
                        "latitude": "27.37393000",
                        "longitude": "-80.33394000"
                    },
                    {
                        "id": 129193,
                        "name": "Whitfield",
                        "latitude": "27.41171000",
                        "longitude": "-82.56593000"
                    },
                    {
                        "id": 129236,
                        "name": "Wildwood",
                        "latitude": "28.86542000",
                        "longitude": "-82.04058000"
                    },
                    {
                        "id": 129265,
                        "name": "Williamsburg",
                        "latitude": "28.41445000",
                        "longitude": "-81.44285000"
                    },
                    {
                        "id": 129296,
                        "name": "Williston",
                        "latitude": "29.38747000",
                        "longitude": "-82.44677000"
                    },
                    {
                        "id": 129300,
                        "name": "Williston Highlands",
                        "latitude": "29.34052000",
                        "longitude": "-82.54150000"
                    },
                    {
                        "id": 129307,
                        "name": "Willow Oak",
                        "latitude": "27.91614000",
                        "longitude": "-82.01786000"
                    },
                    {
                        "id": 129347,
                        "name": "Wilton Manors",
                        "latitude": "26.16036000",
                        "longitude": "-80.13893000"
                    },
                    {
                        "id": 129348,
                        "name": "Wimauma",
                        "latitude": "27.71253000",
                        "longitude": "-82.29898000"
                    },
                    {
                        "id": 129370,
                        "name": "Windermere",
                        "latitude": "28.49556000",
                        "longitude": "-81.53480000"
                    },
                    {
                        "id": 129432,
                        "name": "Winston",
                        "latitude": "28.03169000",
                        "longitude": "-82.01481000"
                    },
                    {
                        "id": 129437,
                        "name": "Winter Beach",
                        "latitude": "27.71920000",
                        "longitude": "-80.42061000"
                    },
                    {
                        "id": 129438,
                        "name": "Winter Garden",
                        "latitude": "28.56528000",
                        "longitude": "-81.58618000"
                    },
                    {
                        "id": 129440,
                        "name": "Winter Haven",
                        "latitude": "28.02224000",
                        "longitude": "-81.73286000"
                    },
                    {
                        "id": 129441,
                        "name": "Winter Park",
                        "latitude": "28.60000000",
                        "longitude": "-81.33924000"
                    },
                    {
                        "id": 129442,
                        "name": "Winter Springs",
                        "latitude": "28.69889000",
                        "longitude": "-81.30812000"
                    },
                    {
                        "id": 129538,
                        "name": "Woodlawn Beach",
                        "latitude": "30.38825000",
                        "longitude": "-86.99080000"
                    },
                    {
                        "id": 129570,
                        "name": "Woodville",
                        "latitude": "30.31409000",
                        "longitude": "-84.24740000"
                    },
                    {
                        "id": 129605,
                        "name": "Wright",
                        "latitude": "30.45575000",
                        "longitude": "-86.63829000"
                    },
                    {
                        "id": 129653,
                        "name": "Yalaha",
                        "latitude": "28.73860000",
                        "longitude": "-81.80869000"
                    },
                    {
                        "id": 129716,
                        "name": "Youngstown",
                        "latitude": "30.36436000",
                        "longitude": "-85.43826000"
                    },
                    {
                        "id": 129732,
                        "name": "Yulee",
                        "latitude": "30.63190000",
                        "longitude": "-81.60649000"
                    },
                    {
                        "id": 129747,
                        "name": "Zellwood",
                        "latitude": "28.73111000",
                        "longitude": "-81.60118000"
                    },
                    {
                        "id": 129749,
                        "name": "Zephyrhills",
                        "latitude": "28.23362000",
                        "longitude": "-82.18119000"
                    },
                    {
                        "id": 129750,
                        "name": "Zephyrhills North",
                        "latitude": "28.25172000",
                        "longitude": "-82.16557000"
                    },
                    {
                        "id": 129751,
                        "name": "Zephyrhills South",
                        "latitude": "28.21492000",
                        "longitude": "-82.18873000"
                    },
                    {
                        "id": 129752,
                        "name": "Zephyrhills West",
                        "latitude": "28.23081000",
                        "longitude": "-82.20556000"
                    },
                    {
                        "id": 129760,
                        "name": "Zolfo Springs",
                        "latitude": "27.49337000",
                        "longitude": "-81.79592000"
                    }
                ]
            },
            {
                "id": 1455,
                "name": "Georgia",
                "iso2": "GA",
                "latitude": "32.16562210",
                "longitude": "-82.90007510",
                "type": "state",
                "cities": [
                    {
                        "id": 110965,
                        "name": "Abbeville",
                        "latitude": "31.99212000",
                        "longitude": "-83.30682000"
                    },
                    {
                        "id": 111004,
                        "name": "Acworth",
                        "latitude": "34.06635000",
                        "longitude": "-84.67837000"
                    },
                    {
                        "id": 111012,
                        "name": "Adairsville",
                        "latitude": "34.36870000",
                        "longitude": "-84.93411000"
                    },
                    {
                        "id": 111041,
                        "name": "Adel",
                        "latitude": "31.13727000",
                        "longitude": "-83.42408000"
                    },
                    {
                        "id": 111090,
                        "name": "Alamo",
                        "latitude": "32.14712000",
                        "longitude": "-82.77792000"
                    },
                    {
                        "id": 111101,
                        "name": "Albany",
                        "latitude": "31.57851000",
                        "longitude": "-84.15574000"
                    },
                    {
                        "id": 111207,
                        "name": "Alma",
                        "latitude": "31.53937000",
                        "longitude": "-82.46236000"
                    },
                    {
                        "id": 111221,
                        "name": "Alpharetta",
                        "latitude": "34.07538000",
                        "longitude": "-84.29409000"
                    },
                    {
                        "id": 111239,
                        "name": "Alto",
                        "latitude": "34.46732000",
                        "longitude": "-83.57378000"
                    },
                    {
                        "id": 111274,
                        "name": "Americus",
                        "latitude": "32.07239000",
                        "longitude": "-84.23269000"
                    },
                    {
                        "id": 111400,
                        "name": "Appling County",
                        "latitude": "31.74928000",
                        "longitude": "-82.28898000"
                    },
                    {
                        "id": 111409,
                        "name": "Aragon",
                        "latitude": "34.04565000",
                        "longitude": "-85.05606000"
                    },
                    {
                        "id": 111418,
                        "name": "Arcade",
                        "latitude": "34.07789000",
                        "longitude": "-83.56155000"
                    },
                    {
                        "id": 111460,
                        "name": "Arlington",
                        "latitude": "31.43990000",
                        "longitude": "-84.72492000"
                    },
                    {
                        "id": 111513,
                        "name": "Ashburn",
                        "latitude": "31.70601000",
                        "longitude": "-83.65322000"
                    },
                    {
                        "id": 111573,
                        "name": "Athens",
                        "latitude": "33.96095000",
                        "longitude": "-83.37794000"
                    },
                    {
                        "id": 111589,
                        "name": "Atkinson County",
                        "latitude": "31.29711000",
                        "longitude": "-82.87999000"
                    },
                    {
                        "id": 111590,
                        "name": "Atlanta",
                        "latitude": "33.74900000",
                        "longitude": "-84.38798000"
                    },
                    {
                        "id": 111619,
                        "name": "Auburn",
                        "latitude": "34.01372000",
                        "longitude": "-83.82768000"
                    },
                    {
                        "id": 111646,
                        "name": "Augusta",
                        "latitude": "33.47097000",
                        "longitude": "-81.97484000"
                    },
                    {
                        "id": 111665,
                        "name": "Austell",
                        "latitude": "33.81261000",
                        "longitude": "-84.63438000"
                    },
                    {
                        "id": 111702,
                        "name": "Avondale Estates",
                        "latitude": "33.77149000",
                        "longitude": "-84.26714000"
                    },
                    {
                        "id": 111720,
                        "name": "Bacon County",
                        "latitude": "31.55367000",
                        "longitude": "-82.45269000"
                    },
                    {
                        "id": 111732,
                        "name": "Bainbridge",
                        "latitude": "30.90380000",
                        "longitude": "-84.57547000"
                    },
                    {
                        "id": 111742,
                        "name": "Baker County",
                        "latitude": "31.32618000",
                        "longitude": "-84.44467000"
                    },
                    {
                        "id": 111752,
                        "name": "Baldwin",
                        "latitude": "34.49177000",
                        "longitude": "-83.53739000"
                    },
                    {
                        "id": 111760,
                        "name": "Baldwin County",
                        "latitude": "33.06928000",
                        "longitude": "-83.24959000"
                    },
                    {
                        "id": 111769,
                        "name": "Ball Ground",
                        "latitude": "34.33815000",
                        "longitude": "-84.37659000"
                    },
                    {
                        "id": 111798,
                        "name": "Banks County",
                        "latitude": "34.35413000",
                        "longitude": "-83.49737000"
                    },
                    {
                        "id": 111829,
                        "name": "Barnesville",
                        "latitude": "33.05457000",
                        "longitude": "-84.15575000"
                    },
                    {
                        "id": 111853,
                        "name": "Barrow County",
                        "latitude": "33.99320000",
                        "longitude": "-83.71276000"
                    },
                    {
                        "id": 111873,
                        "name": "Bartow County",
                        "latitude": "34.23786000",
                        "longitude": "-84.84050000"
                    },
                    {
                        "id": 111913,
                        "name": "Baxley",
                        "latitude": "31.77825000",
                        "longitude": "-82.34846000"
                    },
                    {
                        "id": 112154,
                        "name": "Belvedere Park",
                        "latitude": "33.75483000",
                        "longitude": "-84.26742000"
                    },
                    {
                        "id": 112162,
                        "name": "Ben Hill County",
                        "latitude": "31.75978000",
                        "longitude": "-83.22046000"
                    },
                    {
                        "id": 112227,
                        "name": "Berkeley Lake",
                        "latitude": "33.98371000",
                        "longitude": "-84.18658000"
                    },
                    {
                        "id": 112249,
                        "name": "Berrien County",
                        "latitude": "31.27606000",
                        "longitude": "-83.22962000"
                    },
                    {
                        "id": 112310,
                        "name": "Bibb County",
                        "latitude": "32.80659000",
                        "longitude": "-83.69776000"
                    },
                    {
                        "id": 112391,
                        "name": "Blackshear",
                        "latitude": "31.30605000",
                        "longitude": "-82.24207000"
                    },
                    {
                        "id": 112412,
                        "name": "Blairsville",
                        "latitude": "34.87620000",
                        "longitude": "-83.95824000"
                    },
                    {
                        "id": 112414,
                        "name": "Blakely",
                        "latitude": "31.37768000",
                        "longitude": "-84.93409000"
                    },
                    {
                        "id": 112427,
                        "name": "Bleckley County",
                        "latitude": "32.43444000",
                        "longitude": "-83.32784000"
                    },
                    {
                        "id": 112443,
                        "name": "Bloomingdale",
                        "latitude": "32.13242000",
                        "longitude": "-81.29900000"
                    },
                    {
                        "id": 112475,
                        "name": "Blue Ridge",
                        "latitude": "34.86397000",
                        "longitude": "-84.32409000"
                    },
                    {
                        "id": 112499,
                        "name": "Bogart",
                        "latitude": "33.94928000",
                        "longitude": "-83.53461000"
                    },
                    {
                        "id": 112530,
                        "name": "Bonanza",
                        "latitude": "33.46567000",
                        "longitude": "-84.33659000"
                    },
                    {
                        "id": 112588,
                        "name": "Boston",
                        "latitude": "30.79186000",
                        "longitude": "-83.78989000"
                    },
                    {
                        "id": 112622,
                        "name": "Bowdon",
                        "latitude": "33.53789000",
                        "longitude": "-85.25328000"
                    },
                    {
                        "id": 112696,
                        "name": "Brantley County",
                        "latitude": "31.19688000",
                        "longitude": "-81.98190000"
                    },
                    {
                        "id": 112697,
                        "name": "Braselton",
                        "latitude": "34.10927000",
                        "longitude": "-83.76267000"
                    },
                    {
                        "id": 112720,
                        "name": "Bremen",
                        "latitude": "33.72122000",
                        "longitude": "-85.14550000"
                    },
                    {
                        "id": 112856,
                        "name": "Brookhaven",
                        "latitude": "33.85844000",
                        "longitude": "-84.34020000"
                    },
                    {
                        "id": 112866,
                        "name": "Brooklet",
                        "latitude": "32.37963000",
                        "longitude": "-81.66317000"
                    },
                    {
                        "id": 112883,
                        "name": "Brooks County",
                        "latitude": "30.84197000",
                        "longitude": "-83.58021000"
                    },
                    {
                        "id": 112941,
                        "name": "Broxton",
                        "latitude": "31.62519000",
                        "longitude": "-82.88681000"
                    },
                    {
                        "id": 112947,
                        "name": "Brunswick",
                        "latitude": "31.14995000",
                        "longitude": "-81.49149000"
                    },
                    {
                        "id": 112960,
                        "name": "Bryan County",
                        "latitude": "32.01322000",
                        "longitude": "-81.44247000"
                    },
                    {
                        "id": 112969,
                        "name": "Buchanan",
                        "latitude": "33.80260000",
                        "longitude": "-85.18856000"
                    },
                    {
                        "id": 113000,
                        "name": "Buena Vista",
                        "latitude": "32.31904000",
                        "longitude": "-84.51714000"
                    },
                    {
                        "id": 113022,
                        "name": "Buford",
                        "latitude": "34.12066000",
                        "longitude": "-84.00435000"
                    },
                    {
                        "id": 113033,
                        "name": "Bulloch County",
                        "latitude": "32.39681000",
                        "longitude": "-81.74318000"
                    },
                    {
                        "id": 113056,
                        "name": "Burke County",
                        "latitude": "33.06115000",
                        "longitude": "-82.00078000"
                    },
                    {
                        "id": 113107,
                        "name": "Butler",
                        "latitude": "32.55709000",
                        "longitude": "-84.23825000"
                    },
                    {
                        "id": 113130,
                        "name": "Butts County",
                        "latitude": "33.28785000",
                        "longitude": "-83.95717000"
                    },
                    {
                        "id": 113143,
                        "name": "Byron",
                        "latitude": "32.65376000",
                        "longitude": "-83.75963000"
                    },
                    {
                        "id": 113169,
                        "name": "Cairo",
                        "latitude": "30.87751000",
                        "longitude": "-84.20214000"
                    },
                    {
                        "id": 113197,
                        "name": "Calhoun",
                        "latitude": "34.50259000",
                        "longitude": "-84.95105000"
                    },
                    {
                        "id": 113203,
                        "name": "Calhoun County",
                        "latitude": "31.52920000",
                        "longitude": "-84.62451000"
                    },
                    {
                        "id": 113268,
                        "name": "Camden County",
                        "latitude": "30.92249000",
                        "longitude": "-81.63639000"
                    },
                    {
                        "id": 113283,
                        "name": "Camilla",
                        "latitude": "31.23129000",
                        "longitude": "-84.21046000"
                    },
                    {
                        "id": 113324,
                        "name": "Candler County",
                        "latitude": "32.40344000",
                        "longitude": "-82.07367000"
                    },
                    {
                        "id": 113325,
                        "name": "Candler-McAfee",
                        "latitude": "33.72672000",
                        "longitude": "-84.27246000"
                    },
                    {
                        "id": 113339,
                        "name": "Canton",
                        "latitude": "34.23676000",
                        "longitude": "-84.49076000"
                    },
                    {
                        "id": 113427,
                        "name": "Carnesville",
                        "latitude": "34.36983000",
                        "longitude": "-83.23516000"
                    },
                    {
                        "id": 113451,
                        "name": "Carroll County",
                        "latitude": "33.58282000",
                        "longitude": "-85.07974000"
                    },
                    {
                        "id": 113464,
                        "name": "Carrollton",
                        "latitude": "33.58011000",
                        "longitude": "-85.07661000"
                    },
                    {
                        "id": 113488,
                        "name": "Cartersville",
                        "latitude": "34.16533000",
                        "longitude": "-84.80231000"
                    },
                    {
                        "id": 113577,
                        "name": "Catoosa County",
                        "latitude": "34.90366000",
                        "longitude": "-85.13825000"
                    },
                    {
                        "id": 113587,
                        "name": "Cave Spring",
                        "latitude": "34.10760000",
                        "longitude": "-85.33634000"
                    },
                    {
                        "id": 113627,
                        "name": "Cedartown",
                        "latitude": "34.01123000",
                        "longitude": "-85.25593000"
                    },
                    {
                        "id": 113652,
                        "name": "Centerville",
                        "latitude": "32.63014000",
                        "longitude": "-83.68963000"
                    },
                    {
                        "id": 113723,
                        "name": "Chamblee",
                        "latitude": "33.89205000",
                        "longitude": "-84.29881000"
                    },
                    {
                        "id": 113789,
                        "name": "Charlton County",
                        "latitude": "30.78172000",
                        "longitude": "-82.13769000"
                    },
                    {
                        "id": 113801,
                        "name": "Chatham County",
                        "latitude": "31.97402000",
                        "longitude": "-81.09243000"
                    },
                    {
                        "id": 113805,
                        "name": "Chatsworth",
                        "latitude": "34.76591000",
                        "longitude": "-84.76994000"
                    },
                    {
                        "id": 113809,
                        "name": "Chattahoochee County",
                        "latitude": "32.34697000",
                        "longitude": "-84.78705000"
                    },
                    {
                        "id": 113810,
                        "name": "Chattahoochee Hills",
                        "latitude": "33.55063000",
                        "longitude": "-84.76049000"
                    },
                    {
                        "id": 113812,
                        "name": "Chattanooga Valley",
                        "latitude": "34.93285000",
                        "longitude": "-85.35551000"
                    },
                    {
                        "id": 113813,
                        "name": "Chattooga County",
                        "latitude": "34.47502000",
                        "longitude": "-85.34529000"
                    },
                    {
                        "id": 113850,
                        "name": "Cherokee County",
                        "latitude": "34.24393000",
                        "longitude": "-84.47620000"
                    },
                    {
                        "id": 113881,
                        "name": "Chester",
                        "latitude": "32.39378000",
                        "longitude": "-83.15293000"
                    },
                    {
                        "id": 113937,
                        "name": "Chickamauga",
                        "latitude": "34.87119000",
                        "longitude": "-85.29079000"
                    },
                    {
                        "id": 114135,
                        "name": "Clarke County",
                        "latitude": "33.95117000",
                        "longitude": "-83.36733000"
                    },
                    {
                        "id": 114139,
                        "name": "Clarkesville",
                        "latitude": "34.61260000",
                        "longitude": "-83.52489000"
                    },
                    {
                        "id": 114148,
                        "name": "Clarkston",
                        "latitude": "33.80955000",
                        "longitude": "-84.23964000"
                    },
                    {
                        "id": 114164,
                        "name": "Claxton",
                        "latitude": "32.16158000",
                        "longitude": "-81.90400000"
                    },
                    {
                        "id": 114176,
                        "name": "Clay County",
                        "latitude": "31.62628000",
                        "longitude": "-84.98010000"
                    },
                    {
                        "id": 114198,
                        "name": "Clayton",
                        "latitude": "34.87815000",
                        "longitude": "-83.40099000"
                    },
                    {
                        "id": 114205,
                        "name": "Clayton County",
                        "latitude": "33.54189000",
                        "longitude": "-84.35769000"
                    },
                    {
                        "id": 114242,
                        "name": "Cleveland",
                        "latitude": "34.59704000",
                        "longitude": "-83.76324000"
                    },
                    {
                        "id": 114265,
                        "name": "Clinch County",
                        "latitude": "30.91495000",
                        "longitude": "-82.70624000"
                    },
                    {
                        "id": 114344,
                        "name": "Cobb County",
                        "latitude": "33.94147000",
                        "longitude": "-84.57667000"
                    },
                    {
                        "id": 114351,
                        "name": "Cochran",
                        "latitude": "32.38683000",
                        "longitude": "-83.35461000"
                    },
                    {
                        "id": 114368,
                        "name": "Coffee County",
                        "latitude": "31.54927000",
                        "longitude": "-82.84920000"
                    },
                    {
                        "id": 114413,
                        "name": "College Park",
                        "latitude": "33.65344000",
                        "longitude": "-84.44937000"
                    },
                    {
                        "id": 114459,
                        "name": "Colquitt",
                        "latitude": "31.17129000",
                        "longitude": "-84.73325000"
                    },
                    {
                        "id": 114460,
                        "name": "Colquitt County",
                        "latitude": "31.18839000",
                        "longitude": "-83.76885000"
                    },
                    {
                        "id": 114479,
                        "name": "Columbia County",
                        "latitude": "33.54412000",
                        "longitude": "-82.26406000"
                    },
                    {
                        "id": 114491,
                        "name": "Columbus",
                        "latitude": "32.46098000",
                        "longitude": "-84.98771000"
                    },
                    {
                        "id": 114519,
                        "name": "Comer",
                        "latitude": "34.06372000",
                        "longitude": "-83.12543000"
                    },
                    {
                        "id": 114522,
                        "name": "Commerce",
                        "latitude": "34.20400000",
                        "longitude": "-83.45711000"
                    },
                    {
                        "id": 114559,
                        "name": "Conley",
                        "latitude": "33.64483000",
                        "longitude": "-84.32576000"
                    },
                    {
                        "id": 114589,
                        "name": "Conyers",
                        "latitude": "33.66761000",
                        "longitude": "-84.01769000"
                    },
                    {
                        "id": 114591,
                        "name": "Cook County",
                        "latitude": "31.15399000",
                        "longitude": "-83.43047000"
                    },
                    {
                        "id": 114635,
                        "name": "Cordele",
                        "latitude": "31.96351000",
                        "longitude": "-83.78239000"
                    },
                    {
                        "id": 114646,
                        "name": "Cornelia",
                        "latitude": "34.51149000",
                        "longitude": "-83.52712000"
                    },
                    {
                        "id": 114716,
                        "name": "Country Club Estates",
                        "latitude": "31.21273000",
                        "longitude": "-81.46427000"
                    },
                    {
                        "id": 114735,
                        "name": "Covington",
                        "latitude": "33.59678000",
                        "longitude": "-83.86018000"
                    },
                    {
                        "id": 114747,
                        "name": "Coweta County",
                        "latitude": "33.35346000",
                        "longitude": "-84.76337000"
                    },
                    {
                        "id": 114775,
                        "name": "Crawford County",
                        "latitude": "32.71450000",
                        "longitude": "-83.98634000"
                    },
                    {
                        "id": 114786,
                        "name": "Crawfordville",
                        "latitude": "33.55402000",
                        "longitude": "-82.89598000"
                    },
                    {
                        "id": 114823,
                        "name": "Crisp County",
                        "latitude": "31.92293000",
                        "longitude": "-83.76810000"
                    },
                    {
                        "id": 114923,
                        "name": "Cumming",
                        "latitude": "34.20732000",
                        "longitude": "-84.14019000"
                    },
                    {
                        "id": 114933,
                        "name": "Cusseta",
                        "latitude": "32.30543000",
                        "longitude": "-84.77270000"
                    },
                    {
                        "id": 114945,
                        "name": "Cuthbert",
                        "latitude": "31.77127000",
                        "longitude": "-84.78937000"
                    },
                    {
                        "id": 114963,
                        "name": "Dacula",
                        "latitude": "33.98872000",
                        "longitude": "-83.89796000"
                    },
                    {
                        "id": 114966,
                        "name": "Dade County",
                        "latitude": "34.85452000",
                        "longitude": "-85.50453000"
                    },
                    {
                        "id": 114971,
                        "name": "Dahlonega",
                        "latitude": "34.53259000",
                        "longitude": "-83.98491000"
                    },
                    {
                        "id": 114988,
                        "name": "Dallas",
                        "latitude": "33.92371000",
                        "longitude": "-84.84077000"
                    },
                    {
                        "id": 115001,
                        "name": "Dalton",
                        "latitude": "34.76980000",
                        "longitude": "-84.97022000"
                    },
                    {
                        "id": 115026,
                        "name": "Danielsville",
                        "latitude": "34.12428000",
                        "longitude": "-83.22126000"
                    },
                    {
                        "id": 115045,
                        "name": "Darien",
                        "latitude": "31.37023000",
                        "longitude": "-81.43399000"
                    },
                    {
                        "id": 115077,
                        "name": "Davisboro",
                        "latitude": "32.97904000",
                        "longitude": "-82.60791000"
                    },
                    {
                        "id": 115081,
                        "name": "Dawson",
                        "latitude": "31.77382000",
                        "longitude": "-84.44800000"
                    },
                    {
                        "id": 115083,
                        "name": "Dawson County",
                        "latitude": "34.44430000",
                        "longitude": "-84.17064000"
                    },
                    {
                        "id": 115088,
                        "name": "Dawsonville",
                        "latitude": "34.42121000",
                        "longitude": "-84.11908000"
                    },
                    {
                        "id": 115152,
                        "name": "Decatur",
                        "latitude": "33.77483000",
                        "longitude": "-84.29631000"
                    },
                    {
                        "id": 115159,
                        "name": "Decatur County",
                        "latitude": "30.87834000",
                        "longitude": "-84.57907000"
                    },
                    {
                        "id": 115169,
                        "name": "Deenwood",
                        "latitude": "31.22201000",
                        "longitude": "-82.38725000"
                    },
                    {
                        "id": 115129,
                        "name": "DeKalb County",
                        "latitude": "33.77153000",
                        "longitude": "-84.22641000"
                    },
                    {
                        "id": 115233,
                        "name": "Demorest",
                        "latitude": "34.56510000",
                        "longitude": "-83.54517000"
                    },
                    {
                        "id": 115372,
                        "name": "Dock Junction",
                        "latitude": "31.20245000",
                        "longitude": "-81.51677000"
                    },
                    {
                        "id": 115377,
                        "name": "Dodge County",
                        "latitude": "32.17218000",
                        "longitude": "-83.16840000"
                    },
                    {
                        "id": 115395,
                        "name": "Donalsonville",
                        "latitude": "31.04046000",
                        "longitude": "-84.87909000"
                    },
                    {
                        "id": 115404,
                        "name": "Dooly County",
                        "latitude": "32.15718000",
                        "longitude": "-83.79875000"
                    },
                    {
                        "id": 115409,
                        "name": "Doraville",
                        "latitude": "33.89816000",
                        "longitude": "-84.28326000"
                    },
                    {
                        "id": 115418,
                        "name": "Dougherty County",
                        "latitude": "31.53337000",
                        "longitude": "-84.21625000"
                    },
                    {
                        "id": 115419,
                        "name": "Douglas",
                        "latitude": "31.50881000",
                        "longitude": "-82.84987000"
                    },
                    {
                        "id": 115425,
                        "name": "Douglas County",
                        "latitude": "33.70182000",
                        "longitude": "-84.76793000"
                    },
                    {
                        "id": 115440,
                        "name": "Douglasville",
                        "latitude": "33.75150000",
                        "longitude": "-84.74771000"
                    },
                    {
                        "id": 115480,
                        "name": "Druid Hills",
                        "latitude": "33.78038000",
                        "longitude": "-84.33604000"
                    },
                    {
                        "id": 115491,
                        "name": "Dublin",
                        "latitude": "32.54044000",
                        "longitude": "-82.90375000"
                    },
                    {
                        "id": 115512,
                        "name": "Duluth",
                        "latitude": "34.00288000",
                        "longitude": "-84.14464000"
                    },
                    {
                        "id": 115555,
                        "name": "Dunwoody",
                        "latitude": "33.94621000",
                        "longitude": "-84.33465000"
                    },
                    {
                        "id": 115623,
                        "name": "Early County",
                        "latitude": "31.32283000",
                        "longitude": "-84.90364000"
                    },
                    {
                        "id": 115651,
                        "name": "East Dublin",
                        "latitude": "32.54822000",
                        "longitude": "-82.87181000"
                    },
                    {
                        "id": 115675,
                        "name": "East Griffin",
                        "latitude": "33.24373000",
                        "longitude": "-84.22881000"
                    },
                    {
                        "id": 115721,
                        "name": "East Newnan",
                        "latitude": "33.35067000",
                        "longitude": "-84.77660000"
                    },
                    {
                        "id": 115737,
                        "name": "East Point",
                        "latitude": "33.67955000",
                        "longitude": "-84.43937000"
                    },
                    {
                        "id": 115783,
                        "name": "Eastman",
                        "latitude": "32.19767000",
                        "longitude": "-83.17765000"
                    },
                    {
                        "id": 115806,
                        "name": "Eatonton",
                        "latitude": "33.32680000",
                        "longitude": "-83.38850000"
                    },
                    {
                        "id": 115815,
                        "name": "Echols County",
                        "latitude": "30.71009000",
                        "longitude": "-82.89394000"
                    },
                    {
                        "id": 115874,
                        "name": "Edison",
                        "latitude": "31.55823000",
                        "longitude": "-84.73825000"
                    },
                    {
                        "id": 115898,
                        "name": "Effingham County",
                        "latitude": "32.36731000",
                        "longitude": "-81.34134000"
                    },
                    {
                        "id": 115942,
                        "name": "Elbert County",
                        "latitude": "34.11679000",
                        "longitude": "-82.84010000"
                    },
                    {
                        "id": 115945,
                        "name": "Elberton",
                        "latitude": "34.11159000",
                        "longitude": "-82.86863000"
                    },
                    {
                        "id": 116016,
                        "name": "Ellaville",
                        "latitude": "32.23821000",
                        "longitude": "-84.30908000"
                    },
                    {
                        "id": 116025,
                        "name": "Ellijay",
                        "latitude": "34.69481000",
                        "longitude": "-84.48215000"
                    },
                    {
                        "id": 116088,
                        "name": "Emanuel County",
                        "latitude": "32.58976000",
                        "longitude": "-82.30171000"
                    },
                    {
                        "id": 116093,
                        "name": "Emerson",
                        "latitude": "34.12704000",
                        "longitude": "-84.75549000"
                    },
                    {
                        "id": 116139,
                        "name": "Enigma",
                        "latitude": "31.41297000",
                        "longitude": "-83.32905000"
                    },
                    {
                        "id": 116227,
                        "name": "Euharlee",
                        "latitude": "34.14482000",
                        "longitude": "-84.93300000"
                    },
                    {
                        "id": 116245,
                        "name": "Evans",
                        "latitude": "33.53375000",
                        "longitude": "-82.13067000"
                    },
                    {
                        "id": 116248,
                        "name": "Evans County",
                        "latitude": "32.15676000",
                        "longitude": "-81.88688000"
                    },
                    {
                        "id": 116276,
                        "name": "Experiment",
                        "latitude": "33.26539000",
                        "longitude": "-84.28159000"
                    },
                    {
                        "id": 116285,
                        "name": "Fair Oaks",
                        "latitude": "33.91649000",
                        "longitude": "-84.54465000"
                    },
                    {
                        "id": 116293,
                        "name": "Fairburn",
                        "latitude": "33.56706000",
                        "longitude": "-84.58104000"
                    },
                    {
                        "id": 116347,
                        "name": "Fairview",
                        "latitude": "34.94563000",
                        "longitude": "-85.28440000"
                    },
                    {
                        "id": 116392,
                        "name": "Fannin County",
                        "latitude": "34.86411000",
                        "longitude": "-84.31985000"
                    },
                    {
                        "id": 116444,
                        "name": "Fayette County",
                        "latitude": "33.41394000",
                        "longitude": "-84.49419000"
                    },
                    {
                        "id": 116455,
                        "name": "Fayetteville",
                        "latitude": "33.44873000",
                        "longitude": "-84.45493000"
                    },
                    {
                        "id": 116522,
                        "name": "Firing Range",
                        "latitude": "33.43752000",
                        "longitude": "-82.69068000"
                    },
                    {
                        "id": 116536,
                        "name": "Fitzgerald",
                        "latitude": "31.71491000",
                        "longitude": "-83.25265000"
                    },
                    {
                        "id": 116602,
                        "name": "Flowery Branch",
                        "latitude": "34.18510000",
                        "longitude": "-83.92518000"
                    },
                    {
                        "id": 116606,
                        "name": "Floyd County",
                        "latitude": "34.26316000",
                        "longitude": "-85.21428000"
                    },
                    {
                        "id": 116621,
                        "name": "Folkston",
                        "latitude": "30.83095000",
                        "longitude": "-82.01131000"
                    },
                    {
                        "id": 116664,
                        "name": "Forest Park",
                        "latitude": "33.62205000",
                        "longitude": "-84.36909000"
                    },
                    {
                        "id": 116683,
                        "name": "Forsyth",
                        "latitude": "33.03430000",
                        "longitude": "-83.93824000"
                    },
                    {
                        "id": 116686,
                        "name": "Forsyth County",
                        "latitude": "34.22551000",
                        "longitude": "-84.12502000"
                    },
                    {
                        "id": 116711,
                        "name": "Fort Gaines",
                        "latitude": "31.60924000",
                        "longitude": "-85.04933000"
                    },
                    {
                        "id": 116737,
                        "name": "Fort Oglethorpe",
                        "latitude": "34.94896000",
                        "longitude": "-85.25690000"
                    },
                    {
                        "id": 116751,
                        "name": "Fort Stewart",
                        "latitude": "31.87217000",
                        "longitude": "-81.61001000"
                    },
                    {
                        "id": 116757,
                        "name": "Fort Valley",
                        "latitude": "32.55376000",
                        "longitude": "-83.88741000"
                    },
                    {
                        "id": 116826,
                        "name": "Franklin",
                        "latitude": "33.27762000",
                        "longitude": "-85.09800000"
                    },
                    {
                        "id": 116846,
                        "name": "Franklin County",
                        "latitude": "34.37544000",
                        "longitude": "-83.22918000"
                    },
                    {
                        "id": 116871,
                        "name": "Franklin Springs",
                        "latitude": "34.28483000",
                        "longitude": "-83.14432000"
                    },
                    {
                        "id": 116993,
                        "name": "Fulton County",
                        "latitude": "33.79025000",
                        "longitude": "-84.46702000"
                    },
                    {
                        "id": 117015,
                        "name": "Gainesville",
                        "latitude": "34.29788000",
                        "longitude": "-83.82407000"
                    },
                    {
                        "id": 117054,
                        "name": "Garden City",
                        "latitude": "32.11437000",
                        "longitude": "-81.15400000"
                    },
                    {
                        "id": 117156,
                        "name": "Georgetown",
                        "latitude": "31.98326000",
                        "longitude": "-81.22733000"
                    },
                    {
                        "id": 117187,
                        "name": "Gibson",
                        "latitude": "33.23348000",
                        "longitude": "-82.59541000"
                    },
                    {
                        "id": 117222,
                        "name": "Gilmer County",
                        "latitude": "34.69121000",
                        "longitude": "-84.45559000"
                    },
                    {
                        "id": 117243,
                        "name": "Glascock County",
                        "latitude": "33.22928000",
                        "longitude": "-82.61070000"
                    },
                    {
                        "id": 117300,
                        "name": "Glennville",
                        "latitude": "31.93659000",
                        "longitude": "-81.92845000"
                    },
                    {
                        "id": 117331,
                        "name": "Glynn County",
                        "latitude": "31.21324000",
                        "longitude": "-81.49370000"
                    },
                    {
                        "id": 117396,
                        "name": "Gordon",
                        "latitude": "32.88209000",
                        "longitude": "-83.33238000"
                    },
                    {
                        "id": 117398,
                        "name": "Gordon County",
                        "latitude": "34.50336000",
                        "longitude": "-84.87575000"
                    },
                    {
                        "id": 117426,
                        "name": "Grady County",
                        "latitude": "30.87467000",
                        "longitude": "-84.23443000"
                    },
                    {
                        "id": 117532,
                        "name": "Grantville",
                        "latitude": "33.23484000",
                        "longitude": "-84.83577000"
                    },
                    {
                        "id": 117550,
                        "name": "Gray",
                        "latitude": "33.00958000",
                        "longitude": "-83.53378000"
                    },
                    {
                        "id": 117560,
                        "name": "Grayson",
                        "latitude": "33.89427000",
                        "longitude": "-83.95574000"
                    },
                    {
                        "id": 117633,
                        "name": "Greene County",
                        "latitude": "33.57878000",
                        "longitude": "-83.16666000"
                    },
                    {
                        "id": 117665,
                        "name": "Greensboro",
                        "latitude": "33.57568000",
                        "longitude": "-83.18238000"
                    },
                    {
                        "id": 117684,
                        "name": "Greenville",
                        "latitude": "33.02874000",
                        "longitude": "-84.71298000"
                    },
                    {
                        "id": 117723,
                        "name": "Gresham Park",
                        "latitude": "33.70344000",
                        "longitude": "-84.31437000"
                    },
                    {
                        "id": 117731,
                        "name": "Griffin",
                        "latitude": "33.24678000",
                        "longitude": "-84.26409000"
                    },
                    {
                        "id": 117765,
                        "name": "Grovetown",
                        "latitude": "33.45042000",
                        "longitude": "-82.19818000"
                    },
                    {
                        "id": 117799,
                        "name": "Gumlog",
                        "latitude": "34.49177000",
                        "longitude": "-83.09654000"
                    },
                    {
                        "id": 117819,
                        "name": "Guyton",
                        "latitude": "32.33630000",
                        "longitude": "-81.39150000"
                    },
                    {
                        "id": 117821,
                        "name": "Gwinnett County",
                        "latitude": "33.96173000",
                        "longitude": "-84.02363000"
                    },
                    {
                        "id": 117824,
                        "name": "Habersham County",
                        "latitude": "34.63102000",
                        "longitude": "-83.53112000"
                    },
                    {
                        "id": 117839,
                        "name": "Hahira",
                        "latitude": "30.99131000",
                        "longitude": "-83.37266000"
                    },
                    {
                        "id": 117864,
                        "name": "Hall County",
                        "latitude": "34.31689000",
                        "longitude": "-83.81968000"
                    },
                    {
                        "id": 117888,
                        "name": "Hamilton",
                        "latitude": "32.75791000",
                        "longitude": "-84.87493000"
                    },
                    {
                        "id": 117927,
                        "name": "Hampton",
                        "latitude": "33.38706000",
                        "longitude": "-84.28298000"
                    },
                    {
                        "id": 117950,
                        "name": "Hancock County",
                        "latitude": "33.27043000",
                        "longitude": "-83.00069000"
                    },
                    {
                        "id": 117963,
                        "name": "Hannahs Mill",
                        "latitude": "32.93291000",
                        "longitude": "-84.34936000"
                    },
                    {
                        "id": 117981,
                        "name": "Hapeville",
                        "latitude": "33.66011000",
                        "longitude": "-84.41020000"
                    },
                    {
                        "id": 117985,
                        "name": "Haralson County",
                        "latitude": "33.79423000",
                        "longitude": "-85.21103000"
                    },
                    {
                        "id": 118007,
                        "name": "Hardwick",
                        "latitude": "33.06820000",
                        "longitude": "-83.22349000"
                    },
                    {
                        "id": 118022,
                        "name": "Harlem",
                        "latitude": "33.41458000",
                        "longitude": "-82.31262000"
                    },
                    {
                        "id": 118044,
                        "name": "Harris County",
                        "latitude": "32.73600000",
                        "longitude": "-84.90899000"
                    },
                    {
                        "id": 118082,
                        "name": "Hart County",
                        "latitude": "34.35090000",
                        "longitude": "-82.96425000"
                    },
                    {
                        "id": 118107,
                        "name": "Hartwell",
                        "latitude": "34.35288000",
                        "longitude": "-82.93209000"
                    },
                    {
                        "id": 118167,
                        "name": "Hawkinsville",
                        "latitude": "32.28377000",
                        "longitude": "-83.47212000"
                    },
                    {
                        "id": 118211,
                        "name": "Hazlehurst",
                        "latitude": "31.86963000",
                        "longitude": "-82.59430000"
                    },
                    {
                        "id": 118220,
                        "name": "Heard County",
                        "latitude": "33.29703000",
                        "longitude": "-85.12827000"
                    },
                    {
                        "id": 118248,
                        "name": "Helena",
                        "latitude": "32.07379000",
                        "longitude": "-82.91459000"
                    },
                    {
                        "id": 118279,
                        "name": "Henderson",
                        "latitude": "32.00813000",
                        "longitude": "-81.25887000"
                    },
                    {
                        "id": 118298,
                        "name": "Henry County",
                        "latitude": "33.45300000",
                        "longitude": "-84.15420000"
                    },
                    {
                        "id": 118309,
                        "name": "Hephzibah",
                        "latitude": "33.31403000",
                        "longitude": "-82.09679000"
                    },
                    {
                        "id": 118356,
                        "name": "Hiawassee",
                        "latitude": "34.94926000",
                        "longitude": "-83.75739000"
                    },
                    {
                        "id": 118482,
                        "name": "Hinesville",
                        "latitude": "31.84688000",
                        "longitude": "-81.59595000"
                    },
                    {
                        "id": 118490,
                        "name": "Hiram",
                        "latitude": "33.87566000",
                        "longitude": "-84.76216000"
                    },
                    {
                        "id": 118511,
                        "name": "Hogansville",
                        "latitude": "33.17318000",
                        "longitude": "-84.91494000"
                    },
                    {
                        "id": 118561,
                        "name": "Holly Springs",
                        "latitude": "34.17399000",
                        "longitude": "-84.50132000"
                    },
                    {
                        "id": 118592,
                        "name": "Homer",
                        "latitude": "34.33372000",
                        "longitude": "-83.49905000"
                    },
                    {
                        "id": 118600,
                        "name": "Homerville",
                        "latitude": "31.03660000",
                        "longitude": "-82.74708000"
                    },
                    {
                        "id": 118680,
                        "name": "Hoschton",
                        "latitude": "34.09650000",
                        "longitude": "-83.76128000"
                    },
                    {
                        "id": 118703,
                        "name": "Houston County",
                        "latitude": "32.45901000",
                        "longitude": "-83.66624000"
                    },
                    {
                        "id": 118918,
                        "name": "Indian Springs",
                        "latitude": "34.95785000",
                        "longitude": "-85.16440000"
                    },
                    {
                        "id": 118995,
                        "name": "Irondale",
                        "latitude": "33.48067000",
                        "longitude": "-84.35881000"
                    },
                    {
                        "id": 119013,
                        "name": "Irwin County",
                        "latitude": "31.60228000",
                        "longitude": "-83.27638000"
                    },
                    {
                        "id": 119015,
                        "name": "Irwinton",
                        "latitude": "32.81126000",
                        "longitude": "-83.17265000"
                    },
                    {
                        "id": 119030,
                        "name": "Isle of Hope",
                        "latitude": "31.98188000",
                        "longitude": "-81.06094000"
                    },
                    {
                        "id": 119061,
                        "name": "Jackson",
                        "latitude": "33.29457000",
                        "longitude": "-83.96602000"
                    },
                    {
                        "id": 119078,
                        "name": "Jackson County",
                        "latitude": "34.13388000",
                        "longitude": "-83.56635000"
                    },
                    {
                        "id": 119142,
                        "name": "Jasper",
                        "latitude": "34.46787000",
                        "longitude": "-84.42909000"
                    },
                    {
                        "id": 119145,
                        "name": "Jasper County",
                        "latitude": "33.31643000",
                        "longitude": "-83.68809000"
                    },
                    {
                        "id": 119160,
                        "name": "Jeff Davis County",
                        "latitude": "31.80560000",
                        "longitude": "-82.63694000"
                    },
                    {
                        "id": 119162,
                        "name": "Jefferson",
                        "latitude": "34.11705000",
                        "longitude": "-83.57239000"
                    },
                    {
                        "id": 119178,
                        "name": "Jefferson County",
                        "latitude": "33.05484000",
                        "longitude": "-82.41815000"
                    },
                    {
                        "id": 119207,
                        "name": "Jeffersonville",
                        "latitude": "32.68765000",
                        "longitude": "-83.34656000"
                    },
                    {
                        "id": 119215,
                        "name": "Jenkins County",
                        "latitude": "32.79247000",
                        "longitude": "-81.96353000"
                    },
                    {
                        "id": 119239,
                        "name": "Jesup",
                        "latitude": "31.60785000",
                        "longitude": "-81.88634000"
                    },
                    {
                        "id": 119252,
                        "name": "Johns Creek",
                        "latitude": "34.02893000",
                        "longitude": "-84.19858000"
                    },
                    {
                        "id": 119261,
                        "name": "Johnson County",
                        "latitude": "32.70146000",
                        "longitude": "-82.66008000"
                    },
                    {
                        "id": 119292,
                        "name": "Jones County",
                        "latitude": "33.02513000",
                        "longitude": "-83.56052000"
                    },
                    {
                        "id": 119300,
                        "name": "Jonesboro",
                        "latitude": "33.52150000",
                        "longitude": "-84.35381000"
                    },
                    {
                        "id": 119471,
                        "name": "Kennesaw",
                        "latitude": "34.02343000",
                        "longitude": "-84.61549000"
                    },
                    {
                        "id": 119597,
                        "name": "Kings Bay Base",
                        "latitude": "30.79836000",
                        "longitude": "-81.56589000"
                    },
                    {
                        "id": 119615,
                        "name": "Kingsland",
                        "latitude": "30.79996000",
                        "longitude": "-81.68983000"
                    },
                    {
                        "id": 119693,
                        "name": "Knoxville",
                        "latitude": "32.72431000",
                        "longitude": "-83.99769000"
                    },
                    {
                        "id": 119799,
                        "name": "LaFayette",
                        "latitude": "34.70480000",
                        "longitude": "-85.28190000"
                    },
                    {
                        "id": 119801,
                        "name": "LaGrange",
                        "latitude": "33.03929000",
                        "longitude": "-85.03133000"
                    },
                    {
                        "id": 119880,
                        "name": "Lake City",
                        "latitude": "33.60650000",
                        "longitude": "-84.33520000"
                    },
                    {
                        "id": 120013,
                        "name": "Lakeland",
                        "latitude": "31.04104000",
                        "longitude": "-83.07515000"
                    },
                    {
                        "id": 120037,
                        "name": "Lakeview",
                        "latitude": "34.97924000",
                        "longitude": "-85.25884000"
                    },
                    {
                        "id": 120042,
                        "name": "Lakeview Estates",
                        "latitude": "33.70678000",
                        "longitude": "-84.03158000"
                    },
                    {
                        "id": 120062,
                        "name": "Lamar County",
                        "latitude": "33.07654000",
                        "longitude": "-84.13946000"
                    },
                    {
                        "id": 120119,
                        "name": "Lanier County",
                        "latitude": "31.03789000",
                        "longitude": "-83.06265000"
                    },
                    {
                        "id": 120208,
                        "name": "Laurens County",
                        "latitude": "32.46366000",
                        "longitude": "-82.92224000"
                    },
                    {
                        "id": 120220,
                        "name": "Lavonia",
                        "latitude": "34.43594000",
                        "longitude": "-83.10682000"
                    },
                    {
                        "id": 120243,
                        "name": "Lawrenceville",
                        "latitude": "33.95621000",
                        "longitude": "-83.98796000"
                    },
                    {
                        "id": 120309,
                        "name": "Lee County",
                        "latitude": "31.77951000",
                        "longitude": "-84.14113000"
                    },
                    {
                        "id": 120325,
                        "name": "Leesburg",
                        "latitude": "31.73212000",
                        "longitude": "-84.17074000"
                    },
                    {
                        "id": 120438,
                        "name": "Lexington",
                        "latitude": "33.86984000",
                        "longitude": "-83.11182000"
                    },
                    {
                        "id": 120471,
                        "name": "Liberty County",
                        "latitude": "31.80723000",
                        "longitude": "-81.45626000"
                    },
                    {
                        "id": 120485,
                        "name": "Lilburn",
                        "latitude": "33.89010000",
                        "longitude": "-84.14297000"
                    },
                    {
                        "id": 120517,
                        "name": "Lincoln County",
                        "latitude": "33.79366000",
                        "longitude": "-82.45121000"
                    },
                    {
                        "id": 120551,
                        "name": "Lincolnton",
                        "latitude": "33.79235000",
                        "longitude": "-82.47902000"
                    },
                    {
                        "id": 120558,
                        "name": "Lindale",
                        "latitude": "34.18676000",
                        "longitude": "-85.17467000"
                    },
                    {
                        "id": 120610,
                        "name": "Lithia Springs",
                        "latitude": "33.79400000",
                        "longitude": "-84.66049000"
                    },
                    {
                        "id": 120611,
                        "name": "Lithonia",
                        "latitude": "33.71233000",
                        "longitude": "-84.10519000"
                    },
                    {
                        "id": 120686,
                        "name": "Locust Grove",
                        "latitude": "33.34595000",
                        "longitude": "-84.10908000"
                    },
                    {
                        "id": 120708,
                        "name": "Loganville",
                        "latitude": "33.83900000",
                        "longitude": "-83.90074000"
                    },
                    {
                        "id": 120741,
                        "name": "Long County",
                        "latitude": "31.75258000",
                        "longitude": "-81.74577000"
                    },
                    {
                        "id": 120765,
                        "name": "Lookout Mountain",
                        "latitude": "34.97758000",
                        "longitude": "-85.35774000"
                    },
                    {
                        "id": 120811,
                        "name": "Louisville",
                        "latitude": "33.00154000",
                        "longitude": "-82.41124000"
                    },
                    {
                        "id": 120821,
                        "name": "Lovejoy",
                        "latitude": "33.43622000",
                        "longitude": "-84.31437000"
                    },
                    {
                        "id": 120847,
                        "name": "Lowndes County",
                        "latitude": "30.83386000",
                        "longitude": "-83.26771000"
                    },
                    {
                        "id": 120871,
                        "name": "Ludowici",
                        "latitude": "31.70799000",
                        "longitude": "-81.74234000"
                    },
                    {
                        "id": 120875,
                        "name": "Lula",
                        "latitude": "34.38760000",
                        "longitude": "-83.66629000"
                    },
                    {
                        "id": 120878,
                        "name": "Lumber City",
                        "latitude": "31.92935000",
                        "longitude": "-82.67958000"
                    },
                    {
                        "id": 120882,
                        "name": "Lumpkin",
                        "latitude": "32.05099000",
                        "longitude": "-84.79909000"
                    },
                    {
                        "id": 120883,
                        "name": "Lumpkin County",
                        "latitude": "34.57219000",
                        "longitude": "-84.00265000"
                    },
                    {
                        "id": 120940,
                        "name": "Lyons",
                        "latitude": "32.20435000",
                        "longitude": "-82.32179000"
                    },
                    {
                        "id": 120949,
                        "name": "Mableton",
                        "latitude": "33.81872000",
                        "longitude": "-84.58243000"
                    },
                    {
                        "id": 120964,
                        "name": "Macon",
                        "latitude": "32.84069000",
                        "longitude": "-83.63240000"
                    },
                    {
                        "id": 120968,
                        "name": "Macon County",
                        "latitude": "32.35839000",
                        "longitude": "-84.04248000"
                    },
                    {
                        "id": 120986,
                        "name": "Madison",
                        "latitude": "33.59568000",
                        "longitude": "-83.46794000"
                    },
                    {
                        "id": 121005,
                        "name": "Madison County",
                        "latitude": "34.12778000",
                        "longitude": "-83.20904000"
                    },
                    {
                        "id": 121089,
                        "name": "Manchester",
                        "latitude": "32.85985000",
                        "longitude": "-84.61993000"
                    },
                    {
                        "id": 121216,
                        "name": "Marietta",
                        "latitude": "33.95260000",
                        "longitude": "-84.54993000"
                    },
                    {
                        "id": 121250,
                        "name": "Marion County",
                        "latitude": "32.35338000",
                        "longitude": "-84.52464000"
                    },
                    {
                        "id": 121324,
                        "name": "Marshallville",
                        "latitude": "32.45626000",
                        "longitude": "-83.94019000"
                    },
                    {
                        "id": 121344,
                        "name": "Martinez",
                        "latitude": "33.51736000",
                        "longitude": "-82.07567000"
                    },
                    {
                        "id": 121448,
                        "name": "Maysville",
                        "latitude": "34.25288000",
                        "longitude": "-83.56155000"
                    },
                    {
                        "id": 121467,
                        "name": "McCaysville",
                        "latitude": "34.98619000",
                        "longitude": "-84.37131000"
                    },
                    {
                        "id": 121493,
                        "name": "McDonough",
                        "latitude": "33.44734000",
                        "longitude": "-84.14686000"
                    },
                    {
                        "id": 121497,
                        "name": "McDuffie County",
                        "latitude": "33.48285000",
                        "longitude": "-82.48137000"
                    },
                    {
                        "id": 121513,
                        "name": "McIntosh County",
                        "latitude": "31.48381000",
                        "longitude": "-81.37557000"
                    },
                    {
                        "id": 121550,
                        "name": "McRae",
                        "latitude": "32.06795000",
                        "longitude": "-82.90070000"
                    },
                    {
                        "id": 121617,
                        "name": "Meigs",
                        "latitude": "31.07241000",
                        "longitude": "-84.08907000"
                    },
                    {
                        "id": 121699,
                        "name": "Meriwether County",
                        "latitude": "33.04066000",
                        "longitude": "-84.68831000"
                    },
                    {
                        "id": 121737,
                        "name": "Metter",
                        "latitude": "32.39712000",
                        "longitude": "-82.06012000"
                    },
                    {
                        "id": 121813,
                        "name": "Midway",
                        "latitude": "31.80577000",
                        "longitude": "-81.43066000"
                    },
                    {
                        "id": 121877,
                        "name": "Milledgeville",
                        "latitude": "33.08014000",
                        "longitude": "-83.23210000"
                    },
                    {
                        "id": 121878,
                        "name": "Millen",
                        "latitude": "32.80405000",
                        "longitude": "-81.94928000"
                    },
                    {
                        "id": 121881,
                        "name": "Miller County",
                        "latitude": "31.16399000",
                        "longitude": "-84.73072000"
                    },
                    {
                        "id": 121920,
                        "name": "Milton",
                        "latitude": "34.13216000",
                        "longitude": "-84.30067000"
                    },
                    {
                        "id": 121999,
                        "name": "Mitchell County",
                        "latitude": "31.22532000",
                        "longitude": "-84.19431000"
                    },
                    {
                        "id": 122057,
                        "name": "Monroe",
                        "latitude": "33.79484000",
                        "longitude": "-83.71323000"
                    },
                    {
                        "id": 122070,
                        "name": "Monroe County",
                        "latitude": "33.01408000",
                        "longitude": "-83.91872000"
                    },
                    {
                        "id": 122127,
                        "name": "Montezuma",
                        "latitude": "32.30516000",
                        "longitude": "-84.02741000"
                    },
                    {
                        "id": 122131,
                        "name": "Montgomery",
                        "latitude": "31.94049000",
                        "longitude": "-81.12205000"
                    },
                    {
                        "id": 122141,
                        "name": "Montgomery County",
                        "latitude": "32.17336000",
                        "longitude": "-82.53482000"
                    },
                    {
                        "id": 122160,
                        "name": "Monticello",
                        "latitude": "33.30485000",
                        "longitude": "-83.68323000"
                    },
                    {
                        "id": 122233,
                        "name": "Morgan",
                        "latitude": "31.53767000",
                        "longitude": "-84.59936000"
                    },
                    {
                        "id": 122237,
                        "name": "Morgan County",
                        "latitude": "33.59083000",
                        "longitude": "-83.49238000"
                    },
                    {
                        "id": 122289,
                        "name": "Morrow",
                        "latitude": "33.58317000",
                        "longitude": "-84.33937000"
                    },
                    {
                        "id": 122316,
                        "name": "Moultrie",
                        "latitude": "31.17991000",
                        "longitude": "-83.78906000"
                    },
                    {
                        "id": 122329,
                        "name": "Mount Airy",
                        "latitude": "34.51871000",
                        "longitude": "-83.50073000"
                    },
                    {
                        "id": 122395,
                        "name": "Mount Vernon",
                        "latitude": "32.17851000",
                        "longitude": "-82.59458000"
                    },
                    {
                        "id": 122408,
                        "name": "Mount Zion",
                        "latitude": "33.63428000",
                        "longitude": "-85.18717000"
                    },
                    {
                        "id": 122411,
                        "name": "Mountain City",
                        "latitude": "34.91815000",
                        "longitude": "-83.38544000"
                    },
                    {
                        "id": 122424,
                        "name": "Mountain Park",
                        "latitude": "33.84427000",
                        "longitude": "-84.12936000"
                    },
                    {
                        "id": 122493,
                        "name": "Murray County",
                        "latitude": "34.78845000",
                        "longitude": "-84.74809000"
                    },
                    {
                        "id": 122505,
                        "name": "Muscogee County",
                        "latitude": "32.50996000",
                        "longitude": "-84.87704000"
                    },
                    {
                        "id": 122536,
                        "name": "Nahunta",
                        "latitude": "31.20439000",
                        "longitude": "-81.98123000"
                    },
                    {
                        "id": 122575,
                        "name": "Nashville",
                        "latitude": "31.20742000",
                        "longitude": "-83.25015000"
                    },
                    {
                        "id": 122624,
                        "name": "Nelson",
                        "latitude": "34.38204000",
                        "longitude": "-84.37103000"
                    },
                    {
                        "id": 122837,
                        "name": "Newnan",
                        "latitude": "33.38067000",
                        "longitude": "-84.79966000"
                    },
                    {
                        "id": 122859,
                        "name": "Newton",
                        "latitude": "31.31296000",
                        "longitude": "-84.33574000"
                    },
                    {
                        "id": 122869,
                        "name": "Newton County",
                        "latitude": "33.55505000",
                        "longitude": "-83.85019000"
                    },
                    {
                        "id": 122890,
                        "name": "Nicholls",
                        "latitude": "31.51742000",
                        "longitude": "-82.63486000"
                    },
                    {
                        "id": 122892,
                        "name": "Nicholson",
                        "latitude": "34.11400000",
                        "longitude": "-83.43155000"
                    },
                    {
                        "id": 122940,
                        "name": "Norcross",
                        "latitude": "33.94121000",
                        "longitude": "-84.21353000"
                    },
                    {
                        "id": 122966,
                        "name": "North Atlanta",
                        "latitude": "33.86510000",
                        "longitude": "-84.33659000"
                    },
                    {
                        "id": 123014,
                        "name": "North Decatur",
                        "latitude": "33.79038000",
                        "longitude": "-84.30603000"
                    },
                    {
                        "id": 123015,
                        "name": "North Druid Hills",
                        "latitude": "33.81677000",
                        "longitude": "-84.31326000"
                    },
                    {
                        "id": 123308,
                        "name": "Oakwood",
                        "latitude": "34.22760000",
                        "longitude": "-83.88435000"
                    },
                    {
                        "id": 123346,
                        "name": "Ocilla",
                        "latitude": "31.59447000",
                        "longitude": "-83.25130000"
                    },
                    {
                        "id": 123348,
                        "name": "Oconee County",
                        "latitude": "33.83494000",
                        "longitude": "-83.43705000"
                    },
                    {
                        "id": 123378,
                        "name": "Oglethorpe",
                        "latitude": "32.29377000",
                        "longitude": "-84.06102000"
                    },
                    {
                        "id": 123379,
                        "name": "Oglethorpe County",
                        "latitude": "33.88065000",
                        "longitude": "-83.08070000"
                    },
                    {
                        "id": 123465,
                        "name": "Omega",
                        "latitude": "31.34102000",
                        "longitude": "-83.59350000"
                    },
                    {
                        "id": 123676,
                        "name": "Oxford",
                        "latitude": "33.61900000",
                        "longitude": "-83.86741000"
                    },
                    {
                        "id": 123765,
                        "name": "Palmetto",
                        "latitude": "33.51789000",
                        "longitude": "-84.66965000"
                    },
                    {
                        "id": 123808,
                        "name": "Panthersville",
                        "latitude": "33.70733000",
                        "longitude": "-84.27187000"
                    },
                    {
                        "id": 123922,
                        "name": "Paulding County",
                        "latitude": "33.92055000",
                        "longitude": "-84.86729000"
                    },
                    {
                        "id": 123956,
                        "name": "Peach County",
                        "latitude": "32.56878000",
                        "longitude": "-83.82688000"
                    },
                    {
                        "id": 123959,
                        "name": "Peachtree City",
                        "latitude": "33.39678000",
                        "longitude": "-84.59576000"
                    },
                    {
                        "id": 123960,
                        "name": "Peachtree Corners",
                        "latitude": "33.97010000",
                        "longitude": "-84.22159000"
                    },
                    {
                        "id": 123973,
                        "name": "Pearson",
                        "latitude": "31.29770000",
                        "longitude": "-82.85237000"
                    },
                    {
                        "id": 123989,
                        "name": "Pelham",
                        "latitude": "31.12802000",
                        "longitude": "-84.15304000"
                    },
                    {
                        "id": 124004,
                        "name": "Pembroke",
                        "latitude": "32.13634000",
                        "longitude": "-81.62348000"
                    },
                    {
                        "id": 124068,
                        "name": "Perry",
                        "latitude": "32.45821000",
                        "longitude": "-83.73157000"
                    },
                    {
                        "id": 124157,
                        "name": "Pickens County",
                        "latitude": "34.46432000",
                        "longitude": "-84.46564000"
                    },
                    {
                        "id": 124171,
                        "name": "Pierce County",
                        "latitude": "31.35876000",
                        "longitude": "-82.21274000"
                    },
                    {
                        "id": 124187,
                        "name": "Pike County",
                        "latitude": "33.09227000",
                        "longitude": "-84.38923000"
                    },
                    {
                        "id": 124238,
                        "name": "Pine Mountain",
                        "latitude": "32.86485000",
                        "longitude": "-84.85410000"
                    },
                    {
                        "id": 124442,
                        "name": "Polk County",
                        "latitude": "34.00178000",
                        "longitude": "-85.18815000"
                    },
                    {
                        "id": 124479,
                        "name": "Pooler",
                        "latitude": "32.11548000",
                        "longitude": "-81.24706000"
                    },
                    {
                        "id": 124542,
                        "name": "Port Wentworth",
                        "latitude": "32.14909000",
                        "longitude": "-81.16317000"
                    },
                    {
                        "id": 124555,
                        "name": "Porterdale",
                        "latitude": "33.57511000",
                        "longitude": "-83.89380000"
                    },
                    {
                        "id": 124608,
                        "name": "Powder Springs",
                        "latitude": "33.85955000",
                        "longitude": "-84.68382000"
                    },
                    {
                        "id": 124653,
                        "name": "Preston",
                        "latitude": "32.06599000",
                        "longitude": "-84.53742000"
                    },
                    {
                        "id": 124738,
                        "name": "Pulaski County",
                        "latitude": "32.23230000",
                        "longitude": "-83.47596000"
                    },
                    {
                        "id": 124762,
                        "name": "Putnam County",
                        "latitude": "33.32177000",
                        "longitude": "-83.37284000"
                    },
                    {
                        "id": 124770,
                        "name": "Putney",
                        "latitude": "31.47018000",
                        "longitude": "-84.11768000"
                    },
                    {
                        "id": 124805,
                        "name": "Quitman",
                        "latitude": "30.78492000",
                        "longitude": "-83.55988000"
                    },
                    {
                        "id": 124808,
                        "name": "Quitman County",
                        "latitude": "31.86733000",
                        "longitude": "-85.01878000"
                    },
                    {
                        "id": 124810,
                        "name": "Rabun County",
                        "latitude": "34.88168000",
                        "longitude": "-83.40214000"
                    },
                    {
                        "id": 124874,
                        "name": "Randolph County",
                        "latitude": "31.76262000",
                        "longitude": "-84.75419000"
                    },
                    {
                        "id": 124892,
                        "name": "Raoul",
                        "latitude": "34.44954000",
                        "longitude": "-83.59434000"
                    },
                    {
                        "id": 124915,
                        "name": "Ray City",
                        "latitude": "31.07464000",
                        "longitude": "-83.19932000"
                    },
                    {
                        "id": 124964,
                        "name": "Redan",
                        "latitude": "33.74538000",
                        "longitude": "-84.13158000"
                    },
                    {
                        "id": 124992,
                        "name": "Reed Creek",
                        "latitude": "34.44594000",
                        "longitude": "-82.92487000"
                    },
                    {
                        "id": 125007,
                        "name": "Reidsville",
                        "latitude": "32.08686000",
                        "longitude": "-82.11790000"
                    },
                    {
                        "id": 125013,
                        "name": "Remerton",
                        "latitude": "30.84409000",
                        "longitude": "-83.31043000"
                    },
                    {
                        "id": 125039,
                        "name": "Reynolds",
                        "latitude": "32.55987000",
                        "longitude": "-84.09630000"
                    },
                    {
                        "id": 125067,
                        "name": "Richland",
                        "latitude": "32.08793000",
                        "longitude": "-84.66742000"
                    },
                    {
                        "id": 125098,
                        "name": "Richmond County",
                        "latitude": "33.35963000",
                        "longitude": "-82.07355000"
                    },
                    {
                        "id": 125104,
                        "name": "Richmond Hill",
                        "latitude": "31.93827000",
                        "longitude": "-81.30344000"
                    },
                    {
                        "id": 125139,
                        "name": "Rincon",
                        "latitude": "32.29603000",
                        "longitude": "-81.23539000"
                    },
                    {
                        "id": 125141,
                        "name": "Ringgold",
                        "latitude": "34.91591000",
                        "longitude": "-85.10912000"
                    },
                    {
                        "id": 125192,
                        "name": "Riverdale",
                        "latitude": "33.57261000",
                        "longitude": "-84.41326000"
                    },
                    {
                        "id": 125252,
                        "name": "Robins Air Force Base",
                        "latitude": "32.60911000",
                        "longitude": "-83.58444000"
                    },
                    {
                        "id": 125258,
                        "name": "Rochelle",
                        "latitude": "31.95101000",
                        "longitude": "-83.45627000"
                    },
                    {
                        "id": 125297,
                        "name": "Rockdale County",
                        "latitude": "33.65424000",
                        "longitude": "-84.02661000"
                    },
                    {
                        "id": 125314,
                        "name": "Rockmart",
                        "latitude": "34.00260000",
                        "longitude": "-85.04161000"
                    },
                    {
                        "id": 125375,
                        "name": "Rome",
                        "latitude": "34.25704000",
                        "longitude": "-85.16467000"
                    },
                    {
                        "id": 125456,
                        "name": "Rossville",
                        "latitude": "34.98313000",
                        "longitude": "-85.28607000"
                    },
                    {
                        "id": 125462,
                        "name": "Roswell",
                        "latitude": "34.02316000",
                        "longitude": "-84.36159000"
                    },
                    {
                        "id": 125500,
                        "name": "Royston",
                        "latitude": "34.28705000",
                        "longitude": "-83.11015000"
                    },
                    {
                        "id": 125532,
                        "name": "Russell",
                        "latitude": "33.97872000",
                        "longitude": "-83.70017000"
                    },
                    {
                        "id": 125560,
                        "name": "Rydal",
                        "latitude": "34.33537000",
                        "longitude": "-84.71549000"
                    },
                    {
                        "id": 125714,
                        "name": "Saint Simon Mills",
                        "latitude": "31.17079000",
                        "longitude": "-81.40732000"
                    },
                    {
                        "id": 125715,
                        "name": "Saint Simons Island",
                        "latitude": "31.15051000",
                        "longitude": "-81.36954000"
                    },
                    {
                        "id": 125865,
                        "name": "Sandersville",
                        "latitude": "32.98154000",
                        "longitude": "-82.81014000"
                    },
                    {
                        "id": 125884,
                        "name": "Sandy Springs",
                        "latitude": "33.92427000",
                        "longitude": "-84.37854000"
                    },
                    {
                        "id": 125947,
                        "name": "Sardis",
                        "latitude": "32.79652000",
                        "longitude": "-84.63881000"
                    },
                    {
                        "id": 125974,
                        "name": "Savannah",
                        "latitude": "32.08354000",
                        "longitude": "-81.09983000"
                    },
                    {
                        "id": 126009,
                        "name": "Schley County",
                        "latitude": "32.26169000",
                        "longitude": "-84.31472000"
                    },
                    {
                        "id": 126055,
                        "name": "Scottdale",
                        "latitude": "33.78983000",
                        "longitude": "-84.26409000"
                    },
                    {
                        "id": 126068,
                        "name": "Screven County",
                        "latitude": "32.75059000",
                        "longitude": "-81.61193000"
                    },
                    {
                        "id": 126148,
                        "name": "Seminole County",
                        "latitude": "30.93878000",
                        "longitude": "-84.86887000"
                    },
                    {
                        "id": 126162,
                        "name": "Senoia",
                        "latitude": "33.30234000",
                        "longitude": "-84.55382000"
                    },
                    {
                        "id": 126218,
                        "name": "Shannon",
                        "latitude": "34.33676000",
                        "longitude": "-85.07134000"
                    },
                    {
                        "id": 126479,
                        "name": "Skidaway Island",
                        "latitude": "31.93494000",
                        "longitude": "-81.04705000"
                    },
                    {
                        "id": 126535,
                        "name": "Smyrna",
                        "latitude": "33.88399000",
                        "longitude": "-84.51438000"
                    },
                    {
                        "id": 126541,
                        "name": "Snellville",
                        "latitude": "33.85733000",
                        "longitude": "-84.01991000"
                    },
                    {
                        "id": 126555,
                        "name": "Social Circle",
                        "latitude": "33.65623000",
                        "longitude": "-83.71823000"
                    },
                    {
                        "id": 126602,
                        "name": "Soperton",
                        "latitude": "32.37712000",
                        "longitude": "-82.59236000"
                    },
                    {
                        "id": 126795,
                        "name": "Spalding County",
                        "latitude": "33.26087000",
                        "longitude": "-84.28416000"
                    },
                    {
                        "id": 126803,
                        "name": "Sparks",
                        "latitude": "31.16686000",
                        "longitude": "-83.43738000"
                    },
                    {
                        "id": 126807,
                        "name": "Sparta",
                        "latitude": "33.27570000",
                        "longitude": "-82.97626000"
                    },
                    {
                        "id": 126891,
                        "name": "Springfield",
                        "latitude": "32.37241000",
                        "longitude": "-81.31150000"
                    },
                    {
                        "id": 126929,
                        "name": "St. Marys",
                        "latitude": "30.73051000",
                        "longitude": "-81.54649000"
                    },
                    {
                        "id": 126996,
                        "name": "Statenville",
                        "latitude": "30.70327000",
                        "longitude": "-83.02764000"
                    },
                    {
                        "id": 126997,
                        "name": "Statesboro",
                        "latitude": "32.44879000",
                        "longitude": "-81.78317000"
                    },
                    {
                        "id": 126999,
                        "name": "Statham",
                        "latitude": "33.96511000",
                        "longitude": "-83.59655000"
                    },
                    {
                        "id": 127021,
                        "name": "Stephens County",
                        "latitude": "34.55394000",
                        "longitude": "-83.29343000"
                    },
                    {
                        "id": 127050,
                        "name": "Stewart County",
                        "latitude": "32.07846000",
                        "longitude": "-84.83520000"
                    },
                    {
                        "id": 127067,
                        "name": "Stockbridge",
                        "latitude": "33.54428000",
                        "longitude": "-84.23381000"
                    },
                    {
                        "id": 127083,
                        "name": "Stone Mountain",
                        "latitude": "33.80816000",
                        "longitude": "-84.17020000"
                    },
                    {
                        "id": 127087,
                        "name": "Stonecrest",
                        "latitude": "33.70849000",
                        "longitude": "-84.13485000"
                    },
                    {
                        "id": 127172,
                        "name": "Sugar Hill",
                        "latitude": "34.10649000",
                        "longitude": "-84.03352000"
                    },
                    {
                        "id": 127209,
                        "name": "Summerville",
                        "latitude": "34.48064000",
                        "longitude": "-85.34773000"
                    },
                    {
                        "id": 127230,
                        "name": "Sumter County",
                        "latitude": "32.03997000",
                        "longitude": "-84.19704000"
                    },
                    {
                        "id": 127257,
                        "name": "Sunnyside",
                        "latitude": "31.23938000",
                        "longitude": "-82.34207000"
                    },
                    {
                        "id": 127317,
                        "name": "Suwanee",
                        "latitude": "34.05149000",
                        "longitude": "-84.07130000"
                    },
                    {
                        "id": 127320,
                        "name": "Swainsboro",
                        "latitude": "32.59739000",
                        "longitude": "-82.33374000"
                    },
                    {
                        "id": 127360,
                        "name": "Sylvania",
                        "latitude": "32.75044000",
                        "longitude": "-81.63678000"
                    },
                    {
                        "id": 127361,
                        "name": "Sylvester",
                        "latitude": "31.53092000",
                        "longitude": "-83.83693000"
                    },
                    {
                        "id": 127383,
                        "name": "Talbot County",
                        "latitude": "32.69949000",
                        "longitude": "-84.53301000"
                    },
                    {
                        "id": 127385,
                        "name": "Talbotton",
                        "latitude": "32.67764000",
                        "longitude": "-84.53937000"
                    },
                    {
                        "id": 127387,
                        "name": "Taliaferro County",
                        "latitude": "33.56609000",
                        "longitude": "-82.87876000"
                    },
                    {
                        "id": 127393,
                        "name": "Tallapoosa",
                        "latitude": "33.74455000",
                        "longitude": "-85.28801000"
                    },
                    {
                        "id": 127439,
                        "name": "Tattnall County",
                        "latitude": "32.04575000",
                        "longitude": "-82.05818000"
                    },
                    {
                        "id": 127452,
                        "name": "Taylor County",
                        "latitude": "32.55546000",
                        "longitude": "-84.25046000"
                    },
                    {
                        "id": 127486,
                        "name": "Telfair County",
                        "latitude": "31.92980000",
                        "longitude": "-82.93899000"
                    },
                    {
                        "id": 127497,
                        "name": "Temple",
                        "latitude": "33.73705000",
                        "longitude": "-85.03244000"
                    },
                    {
                        "id": 127511,
                        "name": "Tennille",
                        "latitude": "32.93599000",
                        "longitude": "-82.81153000"
                    },
                    {
                        "id": 127527,
                        "name": "Terrell County",
                        "latitude": "31.77688000",
                        "longitude": "-84.43692000"
                    },
                    {
                        "id": 127579,
                        "name": "Thomas County",
                        "latitude": "30.86368000",
                        "longitude": "-83.91931000"
                    },
                    {
                        "id": 127583,
                        "name": "Thomaston",
                        "latitude": "32.88819000",
                        "longitude": "-84.32659000"
                    },
                    {
                        "id": 127588,
                        "name": "Thomasville",
                        "latitude": "30.83658000",
                        "longitude": "-83.97878000"
                    },
                    {
                        "id": 127596,
                        "name": "Thomson",
                        "latitude": "33.47069000",
                        "longitude": "-82.50457000"
                    },
                    {
                        "id": 127627,
                        "name": "Thunderbolt",
                        "latitude": "32.03354000",
                        "longitude": "-81.04983000"
                    },
                    {
                        "id": 127641,
                        "name": "Tift County",
                        "latitude": "31.45744000",
                        "longitude": "-83.52659000"
                    },
                    {
                        "id": 127642,
                        "name": "Tifton",
                        "latitude": "31.45046000",
                        "longitude": "-83.50850000"
                    },
                    {
                        "id": 127691,
                        "name": "Toccoa",
                        "latitude": "34.57732000",
                        "longitude": "-83.33239000"
                    },
                    {
                        "id": 127729,
                        "name": "Toombs County",
                        "latitude": "32.12172000",
                        "longitude": "-82.33129000"
                    },
                    {
                        "id": 127763,
                        "name": "Towns County",
                        "latitude": "34.91665000",
                        "longitude": "-83.73728000"
                    },
                    {
                        "id": 127802,
                        "name": "Trenton",
                        "latitude": "34.87202000",
                        "longitude": "-85.50913000"
                    },
                    {
                        "id": 127812,
                        "name": "Treutlen County",
                        "latitude": "32.40388000",
                        "longitude": "-82.56728000"
                    },
                    {
                        "id": 127830,
                        "name": "Trion",
                        "latitude": "34.54397000",
                        "longitude": "-85.31051000"
                    },
                    {
                        "id": 127836,
                        "name": "Troup County",
                        "latitude": "33.03351000",
                        "longitude": "-85.02834000"
                    },
                    {
                        "id": 127870,
                        "name": "Tucker",
                        "latitude": "33.85455000",
                        "longitude": "-84.21714000"
                    },
                    {
                        "id": 127903,
                        "name": "Turner County",
                        "latitude": "31.71638000",
                        "longitude": "-83.62409000"
                    },
                    {
                        "id": 127922,
                        "name": "Twiggs County",
                        "latitude": "32.66720000",
                        "longitude": "-83.42708000"
                    },
                    {
                        "id": 127923,
                        "name": "Twin City",
                        "latitude": "32.58294000",
                        "longitude": "-82.15512000"
                    },
                    {
                        "id": 127937,
                        "name": "Tybee Island",
                        "latitude": "32.00022000",
                        "longitude": "-80.84567000"
                    },
                    {
                        "id": 127949,
                        "name": "Tyrone",
                        "latitude": "33.47123000",
                        "longitude": "-84.59715000"
                    },
                    {
                        "id": 127964,
                        "name": "Unadilla",
                        "latitude": "32.26155000",
                        "longitude": "-83.73657000"
                    },
                    {
                        "id": 127980,
                        "name": "Union City",
                        "latitude": "33.58706000",
                        "longitude": "-84.54243000"
                    },
                    {
                        "id": 127990,
                        "name": "Union County",
                        "latitude": "34.83401000",
                        "longitude": "-83.99076000"
                    },
                    {
                        "id": 128010,
                        "name": "Union Point",
                        "latitude": "33.61568000",
                        "longitude": "-83.07460000"
                    },
                    {
                        "id": 128017,
                        "name": "Unionville",
                        "latitude": "31.43491000",
                        "longitude": "-83.50961000"
                    },
                    {
                        "id": 128054,
                        "name": "Upson County",
                        "latitude": "32.88127000",
                        "longitude": "-84.29934000"
                    },
                    {
                        "id": 128085,
                        "name": "Valdosta",
                        "latitude": "30.83334000",
                        "longitude": "-83.28032000"
                    },
                    {
                        "id": 128155,
                        "name": "Varnell",
                        "latitude": "34.90119000",
                        "longitude": "-84.97383000"
                    },
                    {
                        "id": 128227,
                        "name": "Vidalia",
                        "latitude": "32.21769000",
                        "longitude": "-82.41346000"
                    },
                    {
                        "id": 128230,
                        "name": "Vienna",
                        "latitude": "32.09156000",
                        "longitude": "-83.79545000"
                    },
                    {
                        "id": 128245,
                        "name": "Villa Rica",
                        "latitude": "33.73205000",
                        "longitude": "-84.91911000"
                    },
                    {
                        "id": 128276,
                        "name": "Vinings",
                        "latitude": "33.86483000",
                        "longitude": "-84.46437000"
                    },
                    {
                        "id": 128325,
                        "name": "Wadley",
                        "latitude": "32.86682000",
                        "longitude": "-82.40402000"
                    },
                    {
                        "id": 128387,
                        "name": "Walker County",
                        "latitude": "34.73566000",
                        "longitude": "-85.30098000"
                    },
                    {
                        "id": 128417,
                        "name": "Walnut Grove",
                        "latitude": "33.74261000",
                        "longitude": "-83.85240000"
                    },
                    {
                        "id": 128433,
                        "name": "Walthourville",
                        "latitude": "31.77410000",
                        "longitude": "-81.63261000"
                    },
                    {
                        "id": 128438,
                        "name": "Walton County",
                        "latitude": "33.78156000",
                        "longitude": "-83.73385000"
                    },
                    {
                        "id": 128463,
                        "name": "Ware County",
                        "latitude": "31.05363000",
                        "longitude": "-82.42368000"
                    },
                    {
                        "id": 128474,
                        "name": "Warner Robins",
                        "latitude": "32.61574000",
                        "longitude": "-83.62664000"
                    },
                    {
                        "id": 128486,
                        "name": "Warren County",
                        "latitude": "33.40896000",
                        "longitude": "-82.67676000"
                    },
                    {
                        "id": 128504,
                        "name": "Warrenton",
                        "latitude": "33.40708000",
                        "longitude": "-82.66208000"
                    },
                    {
                        "id": 128539,
                        "name": "Washington",
                        "latitude": "33.73679000",
                        "longitude": "-82.73931000"
                    },
                    {
                        "id": 128555,
                        "name": "Washington County",
                        "latitude": "32.96954000",
                        "longitude": "-82.79590000"
                    },
                    {
                        "id": 128635,
                        "name": "Watkinsville",
                        "latitude": "33.86290000",
                        "longitude": "-83.40877000"
                    },
                    {
                        "id": 128676,
                        "name": "Waycross",
                        "latitude": "31.21368000",
                        "longitude": "-82.35570000"
                    },
                    {
                        "id": 128689,
                        "name": "Wayne County",
                        "latitude": "31.55143000",
                        "longitude": "-81.91676000"
                    },
                    {
                        "id": 128705,
                        "name": "Waynesboro",
                        "latitude": "33.08987000",
                        "longitude": "-82.01567000"
                    },
                    {
                        "id": 128736,
                        "name": "Webster County",
                        "latitude": "32.04665000",
                        "longitude": "-84.55105000"
                    },
                    {
                        "id": 128958,
                        "name": "West Point",
                        "latitude": "32.87791000",
                        "longitude": "-85.18327000"
                    },
                    {
                        "id": 129001,
                        "name": "West Warrenton",
                        "latitude": "33.41217000",
                        "longitude": "-82.67517000"
                    },
                    {
                        "id": 129116,
                        "name": "Wheeler County",
                        "latitude": "32.11707000",
                        "longitude": "-82.72459000"
                    },
                    {
                        "id": 129135,
                        "name": "White County",
                        "latitude": "34.64636000",
                        "longitude": "-83.74711000"
                    },
                    {
                        "id": 129178,
                        "name": "Whitemarsh Island",
                        "latitude": "32.02882000",
                        "longitude": "-81.01678000"
                    },
                    {
                        "id": 129195,
                        "name": "Whitfield County",
                        "latitude": "34.80561000",
                        "longitude": "-84.96722000"
                    },
                    {
                        "id": 129229,
                        "name": "Wilcox County",
                        "latitude": "31.97290000",
                        "longitude": "-83.43236000"
                    },
                    {
                        "id": 129244,
                        "name": "Wilkes County",
                        "latitude": "33.78195000",
                        "longitude": "-82.74323000"
                    },
                    {
                        "id": 129250,
                        "name": "Wilkinson County",
                        "latitude": "32.80241000",
                        "longitude": "-83.17125000"
                    },
                    {
                        "id": 129254,
                        "name": "Willacoochee",
                        "latitude": "31.34076000",
                        "longitude": "-83.04598000"
                    },
                    {
                        "id": 129325,
                        "name": "Wilmington Island",
                        "latitude": "32.00355000",
                        "longitude": "-80.97372000"
                    },
                    {
                        "id": 129369,
                        "name": "Winder",
                        "latitude": "33.99261000",
                        "longitude": "-83.72017000"
                    },
                    {
                        "id": 129447,
                        "name": "Winterville",
                        "latitude": "33.96706000",
                        "longitude": "-83.27821000"
                    },
                    {
                        "id": 129494,
                        "name": "Woodbine",
                        "latitude": "30.96396000",
                        "longitude": "-81.72416000"
                    },
                    {
                        "id": 129561,
                        "name": "Woodstock",
                        "latitude": "34.10149000",
                        "longitude": "-84.51938000"
                    },
                    {
                        "id": 129592,
                        "name": "Worth County",
                        "latitude": "31.55151000",
                        "longitude": "-83.85088000"
                    },
                    {
                        "id": 129603,
                        "name": "Wrens",
                        "latitude": "33.20765000",
                        "longitude": "-82.39179000"
                    },
                    {
                        "id": 129614,
                        "name": "Wrightsville",
                        "latitude": "32.72933000",
                        "longitude": "-82.71986000"
                    },
                    {
                        "id": 129715,
                        "name": "Young Harris",
                        "latitude": "34.93315000",
                        "longitude": "-83.84712000"
                    },
                    {
                        "id": 129742,
                        "name": "Zebulon",
                        "latitude": "33.10235000",
                        "longitude": "-84.34270000"
                    }
                ]
            },
            {
                "id": 1412,
                "name": "Guam",
                "iso2": "GU",
                "latitude": "13.44430400",
                "longitude": "144.79373100",
                "type": "outlying area",
                "cities": []
            },
            {
                "id": 1411,
                "name": "Hawaii",
                "iso2": "HI",
                "latitude": "19.89676620",
                "longitude": "-155.58278180",
                "type": "state",
                "cities": [
                    {
                        "id": 129769,
                        "name": "‘Āhuimanu",
                        "latitude": "21.44472000",
                        "longitude": "-157.83778000"
                    },
                    {
                        "id": 129764,
                        "name": "‘Aiea",
                        "latitude": "21.38222000",
                        "longitude": "-157.93361000"
                    },
                    {
                        "id": 129765,
                        "name": "‘Ele‘ele",
                        "latitude": "21.90738000",
                        "longitude": "-159.58322000"
                    },
                    {
                        "id": 129766,
                        "name": "‘Ewa Beach",
                        "latitude": "21.31556000",
                        "longitude": "-158.00722000"
                    },
                    {
                        "id": 129767,
                        "name": "‘Ewa Gentry",
                        "latitude": "21.33999000",
                        "longitude": "-158.03039000"
                    },
                    {
                        "id": 129768,
                        "name": "‘Ewa Villages",
                        "latitude": "21.34127000",
                        "longitude": "-158.03970000"
                    },
                    {
                        "id": 129770,
                        "name": "‘Ōma‘o",
                        "latitude": "21.92581000",
                        "longitude": "-159.48818000"
                    },
                    {
                        "id": 111068,
                        "name": "Ainaloa",
                        "latitude": "19.52694000",
                        "longitude": "-154.99306000"
                    },
                    {
                        "id": 111300,
                        "name": "Anahola",
                        "latitude": "22.14226000",
                        "longitude": "-159.31388000"
                    },
                    {
                        "id": 113378,
                        "name": "Captain Cook",
                        "latitude": "19.49694000",
                        "longitude": "-155.92167000"
                    },
                    {
                        "id": 115693,
                        "name": "East Honolulu",
                        "latitude": "21.28906000",
                        "longitude": "-157.71734000"
                    },
                    {
                        "id": 116481,
                        "name": "Fern Acres",
                        "latitude": "19.51222000",
                        "longitude": "-155.08028000"
                    },
                    {
                        "id": 117841,
                        "name": "Haiku-Pauwela",
                        "latitude": "20.92187000",
                        "longitude": "-156.30508000"
                    },
                    {
                        "id": 118859,
                        "name": "Hālawa",
                        "latitude": "21.37944000",
                        "longitude": "-157.92167000"
                    },
                    {
                        "id": 118860,
                        "name": "Hālawa Heights",
                        "latitude": "21.37848000",
                        "longitude": "-157.91388000"
                    },
                    {
                        "id": 117854,
                        "name": "Hale‘iwa",
                        "latitude": "21.59284000",
                        "longitude": "-158.10339000"
                    },
                    {
                        "id": 117941,
                        "name": "Hana",
                        "latitude": "20.75806000",
                        "longitude": "-155.99028000"
                    },
                    {
                        "id": 117943,
                        "name": "Hanamā‘ulu",
                        "latitude": "21.99773000",
                        "longitude": "-159.35918000"
                    },
                    {
                        "id": 117944,
                        "name": "Hanapēpē",
                        "latitude": "21.90733000",
                        "longitude": "-159.59440000"
                    },
                    {
                        "id": 117945,
                        "name": "Hanapēpē Heights",
                        "latitude": "21.91633000",
                        "longitude": "-159.58995000"
                    },
                    {
                        "id": 118144,
                        "name": "Hau‘ula",
                        "latitude": "21.60760000",
                        "longitude": "-157.90868000"
                    },
                    {
                        "id": 118157,
                        "name": "Hawaii County",
                        "latitude": "19.60240000",
                        "longitude": "-155.52289000"
                    },
                    {
                        "id": 118158,
                        "name": "Hawaiian Acres",
                        "latitude": "19.53806000",
                        "longitude": "-155.05222000"
                    },
                    {
                        "id": 118159,
                        "name": "Hawaiian Beaches",
                        "latitude": "19.54306000",
                        "longitude": "-154.91583000"
                    },
                    {
                        "id": 118161,
                        "name": "Hawaiian Ocean View",
                        "latitude": "19.06861000",
                        "longitude": "-155.76500000"
                    },
                    {
                        "id": 118162,
                        "name": "Hawaiian Paradise Park",
                        "latitude": "19.59333000",
                        "longitude": "-154.97306000"
                    },
                    {
                        "id": 118861,
                        "name": "Hāwī",
                        "latitude": "20.24122000",
                        "longitude": "-155.83351000"
                    },
                    {
                        "id": 118353,
                        "name": "He‘eia",
                        "latitude": "21.43054000",
                        "longitude": "-157.81611000"
                    },
                    {
                        "id": 118360,
                        "name": "Hickam Field",
                        "latitude": "21.33967000",
                        "longitude": "-157.96018000"
                    },
                    {
                        "id": 118472,
                        "name": "Hilo",
                        "latitude": "19.72991000",
                        "longitude": "-155.09073000"
                    },
                    {
                        "id": 118862,
                        "name": "Hōlualoa",
                        "latitude": "19.61979000",
                        "longitude": "-155.94831000"
                    },
                    {
                        "id": 118613,
                        "name": "Honalo",
                        "latitude": "19.54639000",
                        "longitude": "-155.93194000"
                    },
                    {
                        "id": 118614,
                        "name": "Honaunau-Napoopoo",
                        "latitude": "19.45627000",
                        "longitude": "-155.86466000"
                    },
                    {
                        "id": 118622,
                        "name": "Honoka‘a",
                        "latitude": "20.07931000",
                        "longitude": "-155.46691000"
                    },
                    {
                        "id": 118623,
                        "name": "Honolulu",
                        "latitude": "21.30694000",
                        "longitude": "-157.85833000"
                    },
                    {
                        "id": 118624,
                        "name": "Honolulu County",
                        "latitude": "21.45543000",
                        "longitude": "-157.96138000"
                    },
                    {
                        "id": 119001,
                        "name": "Iroquois Point",
                        "latitude": "21.32776000",
                        "longitude": "-157.98301000"
                    },
                    {
                        "id": 119404,
                        "name": "Ka‘a‘awa",
                        "latitude": "21.55445000",
                        "longitude": "-157.85103000"
                    },
                    {
                        "id": 119730,
                        "name": "Kā‘anapali",
                        "latitude": "20.92881000",
                        "longitude": "-156.69422000"
                    },
                    {
                        "id": 119348,
                        "name": "Kaanapali Landing",
                        "latitude": "20.93090000",
                        "longitude": "-156.68778000"
                    },
                    {
                        "id": 119352,
                        "name": "Kahalu‘u",
                        "latitude": "21.45759000",
                        "longitude": "-157.84431000"
                    },
                    {
                        "id": 119351,
                        "name": "Kahaluu-Keauhou",
                        "latitude": "19.57181000",
                        "longitude": "-155.96172000"
                    },
                    {
                        "id": 119354,
                        "name": "Kahuku",
                        "latitude": "21.68048000",
                        "longitude": "-157.95237000"
                    },
                    {
                        "id": 119355,
                        "name": "Kahului",
                        "latitude": "20.88953000",
                        "longitude": "-156.47432000"
                    },
                    {
                        "id": 119357,
                        "name": "Kailua",
                        "latitude": "21.40241000",
                        "longitude": "-157.74054000"
                    },
                    {
                        "id": 119358,
                        "name": "Kailua-Kona",
                        "latitude": "19.64016000",
                        "longitude": "-155.99912000"
                    },
                    {
                        "id": 119369,
                        "name": "Kalāheo",
                        "latitude": "21.92416000",
                        "longitude": "-159.52686000"
                    },
                    {
                        "id": 119362,
                        "name": "Kalaoa",
                        "latitude": "19.72861000",
                        "longitude": "-155.98167000"
                    },
                    {
                        "id": 119363,
                        "name": "Kalawao County",
                        "latitude": "21.18569000",
                        "longitude": "-156.95944000"
                    },
                    {
                        "id": 119379,
                        "name": "Kaneohe",
                        "latitude": "21.39994000",
                        "longitude": "-157.79895000"
                    },
                    {
                        "id": 119386,
                        "name": "Kapa‘a",
                        "latitude": "22.07521000",
                        "longitude": "-159.31895000"
                    },
                    {
                        "id": 119385,
                        "name": "Kapaau",
                        "latitude": "20.23389000",
                        "longitude": "-155.80194000"
                    },
                    {
                        "id": 119388,
                        "name": "Kapolei",
                        "latitude": "21.33555000",
                        "longitude": "-158.05820000"
                    },
                    {
                        "id": 119396,
                        "name": "Kauai County",
                        "latitude": "22.01108000",
                        "longitude": "-159.70544000"
                    },
                    {
                        "id": 119400,
                        "name": "Kaunakakai",
                        "latitude": "21.09363000",
                        "longitude": "-157.02613000"
                    },
                    {
                        "id": 119415,
                        "name": "Kea‘au",
                        "latitude": "19.62265000",
                        "longitude": "-155.03744000"
                    },
                    {
                        "id": 119405,
                        "name": "Kealakekua",
                        "latitude": "19.52083000",
                        "longitude": "-155.92250000"
                    },
                    {
                        "id": 119427,
                        "name": "Kekaha",
                        "latitude": "21.96686000",
                        "longitude": "-159.71186000"
                    },
                    {
                        "id": 119731,
                        "name": "Kēōkea",
                        "latitude": "20.70711000",
                        "longitude": "-156.35446000"
                    },
                    {
                        "id": 119732,
                        "name": "Kīhei",
                        "latitude": "20.76462000",
                        "longitude": "-156.44578000"
                    },
                    {
                        "id": 119733,
                        "name": "Kīlauea",
                        "latitude": "22.21208000",
                        "longitude": "-159.41342000"
                    },
                    {
                        "id": 119697,
                        "name": "Ko Olina",
                        "latitude": "21.33993000",
                        "longitude": "-158.12562000"
                    },
                    {
                        "id": 119703,
                        "name": "Koloa",
                        "latitude": "21.90690000",
                        "longitude": "-159.46994000"
                    },
                    {
                        "id": 119721,
                        "name": "Kualapu‘u",
                        "latitude": "21.15306000",
                        "longitude": "-157.03677000"
                    },
                    {
                        "id": 119722,
                        "name": "Kula",
                        "latitude": "20.79094000",
                        "longitude": "-156.32695000"
                    },
                    {
                        "id": 119727,
                        "name": "Kurtistown",
                        "latitude": "19.60361000",
                        "longitude": "-155.05722000"
                    },
                    {
                        "id": 120947,
                        "name": "Lā‘ie",
                        "latitude": "21.64547000",
                        "longitude": "-157.92250000"
                    },
                    {
                        "id": 119860,
                        "name": "Lahaina",
                        "latitude": "20.87429000",
                        "longitude": "-156.67663000"
                    },
                    {
                        "id": 120078,
                        "name": "Lanai City",
                        "latitude": "20.82757000",
                        "longitude": "-156.92399000"
                    },
                    {
                        "id": 120221,
                        "name": "Lawai",
                        "latitude": "21.92159000",
                        "longitude": "-159.50376000"
                    },
                    {
                        "id": 120339,
                        "name": "Leilani Estates",
                        "latitude": "19.46972000",
                        "longitude": "-154.91778000"
                    },
                    {
                        "id": 120483,
                        "name": "Lihue",
                        "latitude": "21.98121000",
                        "longitude": "-159.37210000"
                    },
                    {
                        "id": 122530,
                        "name": "Mā‘ili",
                        "latitude": "21.41629000",
                        "longitude": "-158.17531000"
                    },
                    {
                        "id": 122528,
                        "name": "Mākaha",
                        "latitude": "21.46627000",
                        "longitude": "-158.21037000"
                    },
                    {
                        "id": 122529,
                        "name": "Mākaha Valley",
                        "latitude": "21.47583000",
                        "longitude": "-158.19918000"
                    },
                    {
                        "id": 121054,
                        "name": "Makakilo City",
                        "latitude": "21.34694000",
                        "longitude": "-158.08583000"
                    },
                    {
                        "id": 121055,
                        "name": "Makawao",
                        "latitude": "20.85694000",
                        "longitude": "-156.31306000"
                    },
                    {
                        "id": 121226,
                        "name": "Marine Corps Base Hawaii - MCBH",
                        "latitude": "21.44336000",
                        "longitude": "-157.74981000"
                    },
                    {
                        "id": 121419,
                        "name": "Maui",
                        "latitude": "20.80332290",
                        "longitude": "-156.66763530"
                    },
                    {
                        "id": 121422,
                        "name": "Maunawili",
                        "latitude": "21.37278000",
                        "longitude": "-157.77056000"
                    },
                    {
                        "id": 121861,
                        "name": "Mililani Town",
                        "latitude": "21.45000000",
                        "longitude": "-158.00111000"
                    },
                    {
                        "id": 122025,
                        "name": "Mokulēia",
                        "latitude": "21.57967000",
                        "longitude": "-158.15313000"
                    },
                    {
                        "id": 122432,
                        "name": "Mountain View",
                        "latitude": "19.55583000",
                        "longitude": "-155.10806000"
                    },
                    {
                        "id": 123224,
                        "name": "Nānākuli",
                        "latitude": "21.39362000",
                        "longitude": "-158.15429000"
                    },
                    {
                        "id": 122539,
                        "name": "Nanawale Estates",
                        "latitude": "19.50611000",
                        "longitude": "-154.91194000"
                    },
                    {
                        "id": 122551,
                        "name": "Napili-Honokowai",
                        "latitude": "20.97533000",
                        "longitude": "-156.67826000"
                    },
                    {
                        "id": 123334,
                        "name": "Ocean Pointe",
                        "latitude": "21.31066000",
                        "longitude": "-158.03638000"
                    },
                    {
                        "id": 123540,
                        "name": "Orchidlands Estates",
                        "latitude": "19.56084000",
                        "longitude": "-155.01527000"
                    },
                    {
                        "id": 124773,
                        "name": "Pāhala",
                        "latitude": "19.20297000",
                        "longitude": "-155.47860000"
                    },
                    {
                        "id": 123725,
                        "name": "Paia",
                        "latitude": "20.90333000",
                        "longitude": "-156.36944000"
                    },
                    {
                        "id": 124774,
                        "name": "Pāpa‘ikou",
                        "latitude": "19.78718000",
                        "longitude": "-155.09326000"
                    },
                    {
                        "id": 123965,
                        "name": "Pearl City",
                        "latitude": "21.39734000",
                        "longitude": "-157.97516000"
                    },
                    {
                        "id": 124052,
                        "name": "Pepeekeo",
                        "latitude": "19.83361000",
                        "longitude": "-155.10722000"
                    },
                    {
                        "id": 124696,
                        "name": "Princeville",
                        "latitude": "22.21758000",
                        "longitude": "-159.47888000"
                    },
                    {
                        "id": 124731,
                        "name": "Puhi",
                        "latitude": "21.96888000",
                        "longitude": "-159.40012000"
                    },
                    {
                        "id": 124732,
                        "name": "Pukalani",
                        "latitude": "20.83667000",
                        "longitude": "-156.33667000"
                    },
                    {
                        "id": 124747,
                        "name": "Punalu‘u",
                        "latitude": "21.57045000",
                        "longitude": "-157.87557000"
                    },
                    {
                        "id": 124752,
                        "name": "Pupukea",
                        "latitude": "21.65456000",
                        "longitude": "-158.06065000"
                    },
                    {
                        "id": 125489,
                        "name": "Royal Kunia",
                        "latitude": "21.39392000",
                        "longitude": "-158.02670000"
                    },
                    {
                        "id": 126014,
                        "name": "Schofield Barracks",
                        "latitude": "21.49837000",
                        "longitude": "-158.06515000"
                    },
                    {
                        "id": 128249,
                        "name": "Village Park",
                        "latitude": "21.39806000",
                        "longitude": "-158.03028000"
                    },
                    {
                        "id": 128299,
                        "name": "Volcano",
                        "latitude": "19.44276000",
                        "longitude": "-155.23398000"
                    },
                    {
                        "id": 128331,
                        "name": "Wahiawā",
                        "latitude": "21.50279000",
                        "longitude": "-158.02464000"
                    },
                    {
                        "id": 128336,
                        "name": "Waialua",
                        "latitude": "21.57688000",
                        "longitude": "-158.13154000"
                    },
                    {
                        "id": 128337,
                        "name": "Waianae",
                        "latitude": "21.43785000",
                        "longitude": "-158.18555000"
                    },
                    {
                        "id": 128338,
                        "name": "Waihee-Waiehu",
                        "latitude": "20.93022000",
                        "longitude": "-156.50458000"
                    },
                    {
                        "id": 128339,
                        "name": "Waikapū",
                        "latitude": "20.85806000",
                        "longitude": "-156.50694000"
                    },
                    {
                        "id": 128340,
                        "name": "Waikoloa",
                        "latitude": "19.93942000",
                        "longitude": "-155.78931000"
                    },
                    {
                        "id": 128341,
                        "name": "Wailea",
                        "latitude": "20.68973000",
                        "longitude": "-156.44190000"
                    },
                    {
                        "id": 128342,
                        "name": "Wailua",
                        "latitude": "22.05271000",
                        "longitude": "-159.33781000"
                    },
                    {
                        "id": 128343,
                        "name": "Wailua Homesteads",
                        "latitude": "22.07244000",
                        "longitude": "-159.37677000"
                    },
                    {
                        "id": 128344,
                        "name": "Wailuku",
                        "latitude": "20.89133000",
                        "longitude": "-156.50604000"
                    },
                    {
                        "id": 128345,
                        "name": "Waimalu",
                        "latitude": "21.40472000",
                        "longitude": "-157.94333000"
                    },
                    {
                        "id": 128346,
                        "name": "Waimanalo",
                        "latitude": "21.34614000",
                        "longitude": "-157.72380000"
                    },
                    {
                        "id": 128348,
                        "name": "Waimānalo Beach",
                        "latitude": "21.33407000",
                        "longitude": "-157.70003000"
                    },
                    {
                        "id": 128347,
                        "name": "Waimea",
                        "latitude": "20.02323000",
                        "longitude": "-155.67288000"
                    },
                    {
                        "id": 128349,
                        "name": "Wainaku",
                        "latitude": "19.74472000",
                        "longitude": "-155.09500000"
                    },
                    {
                        "id": 128350,
                        "name": "Waipahu",
                        "latitude": "21.38667000",
                        "longitude": "-158.00917000"
                    },
                    {
                        "id": 128352,
                        "name": "Waipi‘o Acres",
                        "latitude": "21.46485000",
                        "longitude": "-158.01331000"
                    },
                    {
                        "id": 128351,
                        "name": "Waipio",
                        "latitude": "21.41823000",
                        "longitude": "-157.99906000"
                    },
                    {
                        "id": 129207,
                        "name": "Whitmore Village",
                        "latitude": "21.51429000",
                        "longitude": "-158.02464000"
                    }
                ]
            },
            {
                "id": 1398,
                "name": "Howland Island",
                "iso2": "UM-84",
                "latitude": "0.81132190",
                "longitude": "-176.61827360",
                "type": "islands \/ groups of islands",
                "cities": []
            },
            {
                "id": 1460,
                "name": "Idaho",
                "iso2": "ID",
                "latitude": "44.06820190",
                "longitude": "-114.74204080",
                "type": "state",
                "cities": [
                    {
                        "id": 110978,
                        "name": "Aberdeen",
                        "latitude": "42.94408000",
                        "longitude": "-112.83833000"
                    },
                    {
                        "id": 111007,
                        "name": "Ada County",
                        "latitude": "43.45112000",
                        "longitude": "-116.24109000"
                    },
                    {
                        "id": 111025,
                        "name": "Adams County",
                        "latitude": "44.88965000",
                        "longitude": "-116.45387000"
                    },
                    {
                        "id": 111272,
                        "name": "American Falls",
                        "latitude": "42.78602000",
                        "longitude": "-112.85444000"
                    },
                    {
                        "id": 111293,
                        "name": "Ammon",
                        "latitude": "43.46964000",
                        "longitude": "-111.96664000"
                    },
                    {
                        "id": 111435,
                        "name": "Arco",
                        "latitude": "43.63657000",
                        "longitude": "-113.30028000"
                    },
                    {
                        "id": 111546,
                        "name": "Ashton",
                        "latitude": "44.07158000",
                        "longitude": "-111.44829000"
                    },
                    {
                        "id": 111804,
                        "name": "Bannock County",
                        "latitude": "42.66851000",
                        "longitude": "-112.22463000"
                    },
                    {
                        "id": 111977,
                        "name": "Bear Lake County",
                        "latitude": "42.28479000",
                        "longitude": "-111.32965000"
                    },
                    {
                        "id": 112116,
                        "name": "Bellevue",
                        "latitude": "43.46352000",
                        "longitude": "-114.26060000"
                    },
                    {
                        "id": 112167,
                        "name": "Benewah County",
                        "latitude": "47.21755000",
                        "longitude": "-116.65883000"
                    },
                    {
                        "id": 112349,
                        "name": "Bingham County",
                        "latitude": "43.21652000",
                        "longitude": "-112.39805000"
                    },
                    {
                        "id": 112385,
                        "name": "Blackfoot",
                        "latitude": "43.19047000",
                        "longitude": "-112.34498000"
                    },
                    {
                        "id": 112407,
                        "name": "Blaine County",
                        "latitude": "43.41233000",
                        "longitude": "-113.98040000"
                    },
                    {
                        "id": 112508,
                        "name": "Boise",
                        "latitude": "43.61350000",
                        "longitude": "-116.20345000"
                    },
                    {
                        "id": 112510,
                        "name": "Boise County",
                        "latitude": "43.98913000",
                        "longitude": "-115.73024000"
                    },
                    {
                        "id": 112542,
                        "name": "Bonner County",
                        "latitude": "48.29975000",
                        "longitude": "-116.60097000"
                    },
                    {
                        "id": 112545,
                        "name": "Bonners Ferry",
                        "latitude": "48.69133000",
                        "longitude": "-116.31631000"
                    },
                    {
                        "id": 112546,
                        "name": "Bonneville County",
                        "latitude": "43.38773000",
                        "longitude": "-111.61493000"
                    },
                    {
                        "id": 112609,
                        "name": "Boundary County",
                        "latitude": "48.76702000",
                        "longitude": "-116.46288000"
                    },
                    {
                        "id": 113023,
                        "name": "Buhl",
                        "latitude": "42.59907000",
                        "longitude": "-114.75949000"
                    },
                    {
                        "id": 113063,
                        "name": "Burley",
                        "latitude": "42.53574000",
                        "longitude": "-113.79279000"
                    },
                    {
                        "id": 113126,
                        "name": "Butte County",
                        "latitude": "43.72287000",
                        "longitude": "-113.17202000"
                    },
                    {
                        "id": 113182,
                        "name": "Caldwell",
                        "latitude": "43.66294000",
                        "longitude": "-116.68736000"
                    },
                    {
                        "id": 113244,
                        "name": "Camas County",
                        "latitude": "43.46325000",
                        "longitude": "-114.80585000"
                    },
                    {
                        "id": 113356,
                        "name": "Canyon County",
                        "latitude": "43.62513000",
                        "longitude": "-116.70929000"
                    },
                    {
                        "id": 113395,
                        "name": "Caribou County",
                        "latitude": "42.77051000",
                        "longitude": "-111.56224000"
                    },
                    {
                        "id": 113514,
                        "name": "Cascade",
                        "latitude": "44.51628000",
                        "longitude": "-116.04180000"
                    },
                    {
                        "id": 113537,
                        "name": "Cassia County",
                        "latitude": "42.28387000",
                        "longitude": "-113.60037000"
                    },
                    {
                        "id": 113715,
                        "name": "Challis",
                        "latitude": "44.50464000",
                        "longitude": "-114.23173000"
                    },
                    {
                        "id": 114004,
                        "name": "Chubbuck",
                        "latitude": "42.92075000",
                        "longitude": "-112.46609000"
                    },
                    {
                        "id": 114130,
                        "name": "Clark County",
                        "latitude": "44.28398000",
                        "longitude": "-112.35135000"
                    },
                    {
                        "id": 114227,
                        "name": "Clearwater County",
                        "latitude": "46.67370000",
                        "longitude": "-115.65686000"
                    },
                    {
                        "id": 114366,
                        "name": "Coeur d'Alene",
                        "latitude": "47.67768000",
                        "longitude": "-116.78047000"
                    },
                    {
                        "id": 114711,
                        "name": "Council",
                        "latitude": "44.72989000",
                        "longitude": "-116.43820000"
                    },
                    {
                        "id": 114938,
                        "name": "Custer County",
                        "latitude": "44.24142000",
                        "longitude": "-114.28180000"
                    },
                    {
                        "id": 115004,
                        "name": "Dalton Gardens",
                        "latitude": "47.72963000",
                        "longitude": "-116.77019000"
                    },
                    {
                        "id": 115478,
                        "name": "Driggs",
                        "latitude": "43.72325000",
                        "longitude": "-111.11133000"
                    },
                    {
                        "id": 115497,
                        "name": "Dubois",
                        "latitude": "44.17630000",
                        "longitude": "-112.23082000"
                    },
                    {
                        "id": 115598,
                        "name": "Eagle",
                        "latitude": "43.69544000",
                        "longitude": "-116.35401000"
                    },
                    {
                        "id": 116058,
                        "name": "Elmore County",
                        "latitude": "43.35390000",
                        "longitude": "-115.46918000"
                    },
                    {
                        "id": 116105,
                        "name": "Emmett",
                        "latitude": "43.87350000",
                        "longitude": "-116.49930000"
                    },
                    {
                        "id": 116317,
                        "name": "Fairfield",
                        "latitude": "43.34657000",
                        "longitude": "-114.79173000"
                    },
                    {
                        "id": 116507,
                        "name": "Filer",
                        "latitude": "42.57019000",
                        "longitude": "-114.60782000"
                    },
                    {
                        "id": 116714,
                        "name": "Fort Hall",
                        "latitude": "43.03325000",
                        "longitude": "-112.43831000"
                    },
                    {
                        "id": 116864,
                        "name": "Franklin County",
                        "latitude": "42.18117000",
                        "longitude": "-111.81323000"
                    },
                    {
                        "id": 116927,
                        "name": "Fremont County",
                        "latitude": "44.22879000",
                        "longitude": "-111.48202000"
                    },
                    {
                        "id": 116972,
                        "name": "Fruitland",
                        "latitude": "44.00766000",
                        "longitude": "-116.91655000"
                    },
                    {
                        "id": 117061,
                        "name": "Garden City",
                        "latitude": "43.62211000",
                        "longitude": "-116.23817000"
                    },
                    {
                        "id": 117133,
                        "name": "Gem County",
                        "latitude": "44.06169000",
                        "longitude": "-116.39723000"
                    },
                    {
                        "id": 117299,
                        "name": "Glenns Ferry",
                        "latitude": "42.95490000",
                        "longitude": "-115.30090000"
                    },
                    {
                        "id": 117381,
                        "name": "Gooding",
                        "latitude": "42.93879000",
                        "longitude": "-114.71311000"
                    },
                    {
                        "id": 117382,
                        "name": "Gooding County",
                        "latitude": "42.97090000",
                        "longitude": "-114.81152000"
                    },
                    {
                        "id": 117490,
                        "name": "Grangeville",
                        "latitude": "45.92655000",
                        "longitude": "-116.12237000"
                    },
                    {
                        "id": 117842,
                        "name": "Hailey",
                        "latitude": "43.51963000",
                        "longitude": "-114.31532000"
                    },
                    {
                        "id": 117976,
                        "name": "Hansen",
                        "latitude": "42.53068000",
                        "longitude": "-114.30101000"
                    },
                    {
                        "id": 118179,
                        "name": "Hayden",
                        "latitude": "47.76602000",
                        "longitude": "-116.78658000"
                    },
                    {
                        "id": 118351,
                        "name": "Heyburn",
                        "latitude": "42.55852000",
                        "longitude": "-113.76390000"
                    },
                    {
                        "id": 118378,
                        "name": "Hidden Spring",
                        "latitude": "43.72216000",
                        "longitude": "-116.25093000"
                    },
                    {
                        "id": 118589,
                        "name": "Homedale",
                        "latitude": "43.61766000",
                        "longitude": "-116.93376000"
                    },
                    {
                        "id": 118869,
                        "name": "Idaho City",
                        "latitude": "43.82850000",
                        "longitude": "-115.83455000"
                    },
                    {
                        "id": 118870,
                        "name": "Idaho County",
                        "latitude": "45.84420000",
                        "longitude": "-115.46745000"
                    },
                    {
                        "id": 118871,
                        "name": "Idaho Falls",
                        "latitude": "43.46658000",
                        "longitude": "-112.03414000"
                    },
                    {
                        "id": 118969,
                        "name": "Iona",
                        "latitude": "43.52630000",
                        "longitude": "-111.93302000"
                    },
                    {
                        "id": 119195,
                        "name": "Jefferson County",
                        "latitude": "43.82014000",
                        "longitude": "-112.31128000"
                    },
                    {
                        "id": 119229,
                        "name": "Jerome",
                        "latitude": "42.72407000",
                        "longitude": "-114.51865000"
                    },
                    {
                        "id": 119230,
                        "name": "Jerome County",
                        "latitude": "42.68990000",
                        "longitude": "-114.26403000"
                    },
                    {
                        "id": 119371,
                        "name": "Kamiah",
                        "latitude": "46.22712000",
                        "longitude": "-116.02931000"
                    },
                    {
                        "id": 119429,
                        "name": "Kellogg",
                        "latitude": "47.53826000",
                        "longitude": "-116.11933000"
                    },
                    {
                        "id": 119525,
                        "name": "Ketchum",
                        "latitude": "43.68074000",
                        "longitude": "-114.36366000"
                    },
                    {
                        "id": 119571,
                        "name": "Kimberly",
                        "latitude": "42.53380000",
                        "longitude": "-114.36476000"
                    },
                    {
                        "id": 119707,
                        "name": "Kootenai County",
                        "latitude": "47.67456000",
                        "longitude": "-116.70001000"
                    },
                    {
                        "id": 119725,
                        "name": "Kuna",
                        "latitude": "43.49183000",
                        "longitude": "-116.42012000"
                    },
                    {
                        "id": 120137,
                        "name": "Lapwai",
                        "latitude": "46.40489000",
                        "longitude": "-116.80487000"
                    },
                    {
                        "id": 120167,
                        "name": "Latah County",
                        "latitude": "46.81613000",
                        "longitude": "-116.71168000"
                    },
                    {
                        "id": 120356,
                        "name": "Lemhi County",
                        "latitude": "44.94331000",
                        "longitude": "-113.93324000"
                    },
                    {
                        "id": 120416,
                        "name": "Lewis County",
                        "latitude": "46.23702000",
                        "longitude": "-116.42625000"
                    },
                    {
                        "id": 120428,
                        "name": "Lewiston",
                        "latitude": "46.41655000",
                        "longitude": "-117.01766000"
                    },
                    {
                        "id": 120430,
                        "name": "Lewiston Orchards",
                        "latitude": "46.38044000",
                        "longitude": "-116.97543000"
                    },
                    {
                        "id": 120511,
                        "name": "Lincoln",
                        "latitude": "43.51297000",
                        "longitude": "-111.96441000"
                    },
                    {
                        "id": 120533,
                        "name": "Lincoln County",
                        "latitude": "43.00241000",
                        "longitude": "-114.13831000"
                    },
                    {
                        "id": 121018,
                        "name": "Madison County",
                        "latitude": "43.78419000",
                        "longitude": "-111.65934000"
                    },
                    {
                        "id": 121057,
                        "name": "Malad City",
                        "latitude": "42.19159000",
                        "longitude": "-112.25080000"
                    },
                    {
                        "id": 121330,
                        "name": "Marsing",
                        "latitude": "43.54544000",
                        "longitude": "-116.81320000"
                    },
                    {
                        "id": 121465,
                        "name": "McCall",
                        "latitude": "44.91101000",
                        "longitude": "-116.09874000"
                    },
                    {
                        "id": 121695,
                        "name": "Meridian",
                        "latitude": "43.61211000",
                        "longitude": "-116.39151000"
                    },
                    {
                        "id": 121784,
                        "name": "Middleton",
                        "latitude": "43.70683000",
                        "longitude": "-116.62014000"
                    },
                    {
                        "id": 121947,
                        "name": "Minidoka County",
                        "latitude": "42.85440000",
                        "longitude": "-113.63752000"
                    },
                    {
                        "id": 122178,
                        "name": "Montpelier",
                        "latitude": "42.32215000",
                        "longitude": "-111.29770000"
                    },
                    {
                        "id": 122228,
                        "name": "Moreland",
                        "latitude": "43.22269000",
                        "longitude": "-112.44248000"
                    },
                    {
                        "id": 122300,
                        "name": "Moscow",
                        "latitude": "46.73239000",
                        "longitude": "-117.00017000"
                    },
                    {
                        "id": 122417,
                        "name": "Mountain Home",
                        "latitude": "43.13295000",
                        "longitude": "-115.69120000"
                    },
                    {
                        "id": 122487,
                        "name": "Murphy",
                        "latitude": "43.21822000",
                        "longitude": "-116.55234000"
                    },
                    {
                        "id": 122538,
                        "name": "Nampa",
                        "latitude": "43.54072000",
                        "longitude": "-116.56346000"
                    },
                    {
                        "id": 122763,
                        "name": "New Plymouth",
                        "latitude": "43.96989000",
                        "longitude": "-116.81904000"
                    },
                    {
                        "id": 122878,
                        "name": "Nez Perce County",
                        "latitude": "46.32676000",
                        "longitude": "-116.75024000"
                    },
                    {
                        "id": 122879,
                        "name": "Nezperce",
                        "latitude": "46.23489000",
                        "longitude": "-116.24070000"
                    },
                    {
                        "id": 123477,
                        "name": "Oneida County",
                        "latitude": "42.19490000",
                        "longitude": "-112.53962000"
                    },
                    {
                        "id": 123572,
                        "name": "Orofino",
                        "latitude": "46.47935000",
                        "longitude": "-116.25514000"
                    },
                    {
                        "id": 123596,
                        "name": "Osburn",
                        "latitude": "47.50604000",
                        "longitude": "-115.99933000"
                    },
                    {
                        "id": 123674,
                        "name": "Owyhee County",
                        "latitude": "42.58153000",
                        "longitude": "-116.16998000"
                    },
                    {
                        "id": 123836,
                        "name": "Paris",
                        "latitude": "42.22715000",
                        "longitude": "-111.40104000"
                    },
                    {
                        "id": 123885,
                        "name": "Parma",
                        "latitude": "43.78516000",
                        "longitude": "-116.94321000"
                    },
                    {
                        "id": 123920,
                        "name": "Paul",
                        "latitude": "42.60796000",
                        "longitude": "-113.78335000"
                    },
                    {
                        "id": 123944,
                        "name": "Payette",
                        "latitude": "44.07822000",
                        "longitude": "-116.93377000"
                    },
                    {
                        "id": 123945,
                        "name": "Payette County",
                        "latitude": "44.00674000",
                        "longitude": "-116.76084000"
                    },
                    {
                        "id": 124253,
                        "name": "Pinehurst",
                        "latitude": "47.53881000",
                        "longitude": "-116.23739000"
                    },
                    {
                        "id": 124397,
                        "name": "Plummer",
                        "latitude": "47.33518000",
                        "longitude": "-116.88851000"
                    },
                    {
                        "id": 124418,
                        "name": "Pocatello",
                        "latitude": "42.87130000",
                        "longitude": "-112.44553000"
                    },
                    {
                        "id": 124469,
                        "name": "Ponderay",
                        "latitude": "48.30548000",
                        "longitude": "-116.53380000"
                    },
                    {
                        "id": 124577,
                        "name": "Post Falls",
                        "latitude": "47.71796000",
                        "longitude": "-116.95159000"
                    },
                    {
                        "id": 124615,
                        "name": "Power County",
                        "latitude": "42.69369000",
                        "longitude": "-112.84067000"
                    },
                    {
                        "id": 124657,
                        "name": "Preston",
                        "latitude": "42.09631000",
                        "longitude": "-111.87662000"
                    },
                    {
                        "id": 124669,
                        "name": "Priest River",
                        "latitude": "48.18097000",
                        "longitude": "-116.91157000"
                    },
                    {
                        "id": 124900,
                        "name": "Rathdrum",
                        "latitude": "47.81240000",
                        "longitude": "-116.89659000"
                    },
                    {
                        "id": 125038,
                        "name": "Rexburg",
                        "latitude": "43.82602000",
                        "longitude": "-111.78969000"
                    },
                    {
                        "id": 125137,
                        "name": "Rigby",
                        "latitude": "43.67241000",
                        "longitude": "-111.91497000"
                    },
                    {
                        "id": 125515,
                        "name": "Rupert",
                        "latitude": "42.61908000",
                        "longitude": "-113.67723000"
                    },
                    {
                        "id": 125602,
                        "name": "Saint Anthony",
                        "latitude": "43.96630000",
                        "longitude": "-111.68218000"
                    },
                    {
                        "id": 125685,
                        "name": "Saint Maries",
                        "latitude": "47.31435000",
                        "longitude": "-116.56267000"
                    },
                    {
                        "id": 125763,
                        "name": "Salmon",
                        "latitude": "45.17575000",
                        "longitude": "-113.89590000"
                    },
                    {
                        "id": 125871,
                        "name": "Sandpoint",
                        "latitude": "48.27659000",
                        "longitude": "-116.55325000"
                    },
                    {
                        "id": 126294,
                        "name": "Shelley",
                        "latitude": "43.38130000",
                        "longitude": "-112.12331000"
                    },
                    {
                        "id": 126379,
                        "name": "Shoshone",
                        "latitude": "42.93602000",
                        "longitude": "-114.40588000"
                    },
                    {
                        "id": 126380,
                        "name": "Shoshone County",
                        "latitude": "47.35167000",
                        "longitude": "-115.89103000"
                    },
                    {
                        "id": 126562,
                        "name": "Soda Springs",
                        "latitude": "42.65437000",
                        "longitude": "-111.60467000"
                    },
                    {
                        "id": 126839,
                        "name": "Spirit Lake",
                        "latitude": "47.96629000",
                        "longitude": "-116.86853000"
                    },
                    {
                        "id": 126978,
                        "name": "Star",
                        "latitude": "43.69211000",
                        "longitude": "-116.49346000"
                    },
                    {
                        "id": 127169,
                        "name": "Sugar City",
                        "latitude": "43.87297000",
                        "longitude": "-111.74830000"
                    },
                    {
                        "id": 127241,
                        "name": "Sun Valley",
                        "latitude": "43.69713000",
                        "longitude": "-114.35172000"
                    },
                    {
                        "id": 127537,
                        "name": "Teton County",
                        "latitude": "43.75946000",
                        "longitude": "-111.20770000"
                    },
                    {
                        "id": 127924,
                        "name": "Twin Falls",
                        "latitude": "42.56297000",
                        "longitude": "-114.46087000"
                    },
                    {
                        "id": 127925,
                        "name": "Twin Falls County",
                        "latitude": "42.35598000",
                        "longitude": "-114.66716000"
                    },
                    {
                        "id": 127939,
                        "name": "Tyhee",
                        "latitude": "42.95158000",
                        "longitude": "-112.46637000"
                    },
                    {
                        "id": 127953,
                        "name": "Ucon",
                        "latitude": "43.59630000",
                        "longitude": "-111.96386000"
                    },
                    {
                        "id": 128104,
                        "name": "Valley County",
                        "latitude": "44.76670000",
                        "longitude": "-115.56613000"
                    },
                    {
                        "id": 128218,
                        "name": "Victor",
                        "latitude": "43.60270000",
                        "longitude": "-111.11133000"
                    },
                    {
                        "id": 128398,
                        "name": "Wallace",
                        "latitude": "47.47409000",
                        "longitude": "-115.92794000"
                    },
                    {
                        "id": 128579,
                        "name": "Washington County",
                        "latitude": "44.45243000",
                        "longitude": "-116.78477000"
                    },
                    {
                        "id": 128761,
                        "name": "Weiser",
                        "latitude": "44.25100000",
                        "longitude": "-116.96933000"
                    },
                    {
                        "id": 128800,
                        "name": "Wendell",
                        "latitude": "42.77574000",
                        "longitude": "-114.70422000"
                    },
                    {
                        "id": 129233,
                        "name": "Wilder",
                        "latitude": "43.67655000",
                        "longitude": "-116.91182000"
                    }
                ]
            },
            {
                "id": 1425,
                "name": "Illinois",
                "iso2": "IL",
                "latitude": "40.63312490",
                "longitude": "-89.39852830",
                "type": "state",
                "cities": [
                    {
                        "id": 110985,
                        "name": "Abingdon",
                        "latitude": "40.80448000",
                        "longitude": "-90.40180000"
                    },
                    {
                        "id": 111017,
                        "name": "Adams County",
                        "latitude": "39.98789000",
                        "longitude": "-91.18849000"
                    },
                    {
                        "id": 111035,
                        "name": "Addison",
                        "latitude": "41.93170000",
                        "longitude": "-87.98896000"
                    },
                    {
                        "id": 111114,
                        "name": "Albany Park",
                        "latitude": "41.96836000",
                        "longitude": "-87.72339000"
                    },
                    {
                        "id": 111117,
                        "name": "Albers",
                        "latitude": "38.54338000",
                        "longitude": "-89.61231000"
                    },
                    {
                        "id": 111123,
                        "name": "Albion",
                        "latitude": "38.37755000",
                        "longitude": "-88.05615000"
                    },
                    {
                        "id": 111142,
                        "name": "Aledo",
                        "latitude": "41.19976000",
                        "longitude": "-90.74931000"
                    },
                    {
                        "id": 111147,
                        "name": "Alexander County",
                        "latitude": "37.19160000",
                        "longitude": "-89.33764000"
                    },
                    {
                        "id": 111167,
                        "name": "Algonquin",
                        "latitude": "42.16558000",
                        "longitude": "-88.29425000"
                    },
                    {
                        "id": 111216,
                        "name": "Alorton",
                        "latitude": "38.58977000",
                        "longitude": "-90.12011000"
                    },
                    {
                        "id": 111227,
                        "name": "Alsip",
                        "latitude": "41.66892000",
                        "longitude": "-87.73866000"
                    },
                    {
                        "id": 111232,
                        "name": "Altamont",
                        "latitude": "39.06199000",
                        "longitude": "-88.74811000"
                    },
                    {
                        "id": 111242,
                        "name": "Alton",
                        "latitude": "38.89060000",
                        "longitude": "-90.18428000"
                    },
                    {
                        "id": 111265,
                        "name": "Amboy",
                        "latitude": "41.71420000",
                        "longitude": "-89.32871000"
                    },
                    {
                        "id": 111308,
                        "name": "Andalusia",
                        "latitude": "41.43920000",
                        "longitude": "-90.71764000"
                    },
                    {
                        "id": 111346,
                        "name": "Anna",
                        "latitude": "37.46033000",
                        "longitude": "-89.24703000"
                    },
                    {
                        "id": 111372,
                        "name": "Antioch",
                        "latitude": "42.47724000",
                        "longitude": "-88.09564000"
                    },
                    {
                        "id": 111436,
                        "name": "Arcola",
                        "latitude": "39.68476000",
                        "longitude": "-88.30644000"
                    },
                    {
                        "id": 111472,
                        "name": "Arlington Heights",
                        "latitude": "42.08836000",
                        "longitude": "-87.98063000"
                    },
                    {
                        "id": 111498,
                        "name": "Arthur",
                        "latitude": "39.71476000",
                        "longitude": "-88.47228000"
                    },
                    {
                        "id": 111515,
                        "name": "Ashburn",
                        "latitude": "41.74753000",
                        "longitude": "-87.71116000"
                    },
                    {
                        "id": 111528,
                        "name": "Ashland",
                        "latitude": "39.88783000",
                        "longitude": "-90.00789000"
                    },
                    {
                        "id": 111557,
                        "name": "Assumption",
                        "latitude": "39.52032000",
                        "longitude": "-89.04897000"
                    },
                    {
                        "id": 111561,
                        "name": "Astoria",
                        "latitude": "40.22754000",
                        "longitude": "-90.35957000"
                    },
                    {
                        "id": 111574,
                        "name": "Athens",
                        "latitude": "39.96088000",
                        "longitude": "-89.72399000"
                    },
                    {
                        "id": 111592,
                        "name": "Atlanta",
                        "latitude": "40.25948000",
                        "longitude": "-89.23342000"
                    },
                    {
                        "id": 111614,
                        "name": "Atwood",
                        "latitude": "39.79948000",
                        "longitude": "-88.46228000"
                    },
                    {
                        "id": 111621,
                        "name": "Auburn",
                        "latitude": "39.59172000",
                        "longitude": "-89.74649000"
                    },
                    {
                        "id": 111633,
                        "name": "Auburn Gresham",
                        "latitude": "41.74179000",
                        "longitude": "-87.65322000"
                    },
                    {
                        "id": 111659,
                        "name": "Aurora",
                        "latitude": "41.76058000",
                        "longitude": "-88.32007000"
                    },
                    {
                        "id": 111686,
                        "name": "Aviston",
                        "latitude": "38.60672000",
                        "longitude": "-89.60759000"
                    },
                    {
                        "id": 111700,
                        "name": "Avondale",
                        "latitude": "41.93892000",
                        "longitude": "-87.71117000"
                    },
                    {
                        "id": 111805,
                        "name": "Bannockburn",
                        "latitude": "42.19336000",
                        "longitude": "-87.86646000"
                    },
                    {
                        "id": 111846,
                        "name": "Barrington",
                        "latitude": "42.15391000",
                        "longitude": "-88.13619000"
                    },
                    {
                        "id": 111849,
                        "name": "Barrington Hills",
                        "latitude": "42.14475000",
                        "longitude": "-88.15563000"
                    },
                    {
                        "id": 111854,
                        "name": "Barry",
                        "latitude": "39.69421000",
                        "longitude": "-91.03902000"
                    },
                    {
                        "id": 111863,
                        "name": "Bartlett",
                        "latitude": "41.99503000",
                        "longitude": "-88.18563000"
                    },
                    {
                        "id": 111871,
                        "name": "Bartonville",
                        "latitude": "40.65032000",
                        "longitude": "-89.65205000"
                    },
                    {
                        "id": 111887,
                        "name": "Batavia",
                        "latitude": "41.85003000",
                        "longitude": "-88.31257000"
                    },
                    {
                        "id": 111966,
                        "name": "Beach Park",
                        "latitude": "42.42224000",
                        "longitude": "-87.85730000"
                    },
                    {
                        "id": 111980,
                        "name": "Beardstown",
                        "latitude": "40.01755000",
                        "longitude": "-90.42429000"
                    },
                    {
                        "id": 112011,
                        "name": "Beckemeyer",
                        "latitude": "38.60560000",
                        "longitude": "-89.43592000"
                    },
                    {
                        "id": 112039,
                        "name": "Beecher",
                        "latitude": "41.34059000",
                        "longitude": "-87.62143000"
                    },
                    {
                        "id": 112103,
                        "name": "Belleville",
                        "latitude": "38.52005000",
                        "longitude": "-89.98399000"
                    },
                    {
                        "id": 112110,
                        "name": "Bellevue",
                        "latitude": "40.68448000",
                        "longitude": "-89.68010000"
                    },
                    {
                        "id": 112131,
                        "name": "Bellwood",
                        "latitude": "41.88142000",
                        "longitude": "-87.88312000"
                    },
                    {
                        "id": 112143,
                        "name": "Belmont Cragin",
                        "latitude": "41.93170000",
                        "longitude": "-87.76867000"
                    },
                    {
                        "id": 112155,
                        "name": "Belvidere",
                        "latitude": "42.26391000",
                        "longitude": "-88.84427000"
                    },
                    {
                        "id": 112159,
                        "name": "Bement",
                        "latitude": "39.92198000",
                        "longitude": "-88.57201000"
                    },
                    {
                        "id": 112172,
                        "name": "Benld",
                        "latitude": "39.09282000",
                        "longitude": "-89.80398000"
                    },
                    {
                        "id": 112180,
                        "name": "Bensenville",
                        "latitude": "41.95503000",
                        "longitude": "-87.94007000"
                    },
                    {
                        "id": 112193,
                        "name": "Benton",
                        "latitude": "37.99672000",
                        "longitude": "-88.92007000"
                    },
                    {
                        "id": 112222,
                        "name": "Berkeley",
                        "latitude": "41.88892000",
                        "longitude": "-87.90340000"
                    },
                    {
                        "id": 112264,
                        "name": "Berwyn",
                        "latitude": "41.85059000",
                        "longitude": "-87.79367000"
                    },
                    {
                        "id": 112271,
                        "name": "Bethalto",
                        "latitude": "38.90921000",
                        "longitude": "-90.04066000"
                    },
                    {
                        "id": 112272,
                        "name": "Bethany",
                        "latitude": "39.64559000",
                        "longitude": "-88.73813000"
                    },
                    {
                        "id": 112332,
                        "name": "Big Rock",
                        "latitude": "41.76392000",
                        "longitude": "-88.54702000"
                    },
                    {
                        "id": 112447,
                        "name": "Bloomingdale",
                        "latitude": "41.95753000",
                        "longitude": "-88.08090000"
                    },
                    {
                        "id": 112451,
                        "name": "Bloomington",
                        "latitude": "40.48420000",
                        "longitude": "-88.99369000"
                    },
                    {
                        "id": 112469,
                        "name": "Blue Island",
                        "latitude": "41.65726000",
                        "longitude": "-87.68005000"
                    },
                    {
                        "id": 112471,
                        "name": "Blue Mound",
                        "latitude": "39.70115000",
                        "longitude": "-89.12314000"
                    },
                    {
                        "id": 112516,
                        "name": "Bolingbrook",
                        "latitude": "41.69864000",
                        "longitude": "-88.06840000"
                    },
                    {
                        "id": 112531,
                        "name": "Bond County",
                        "latitude": "38.88682000",
                        "longitude": "-89.43555000"
                    },
                    {
                        "id": 112559,
                        "name": "Boone County",
                        "latitude": "42.32308000",
                        "longitude": "-88.82336000"
                    },
                    {
                        "id": 112605,
                        "name": "Boulder Hill",
                        "latitude": "41.71253000",
                        "longitude": "-88.33618000"
                    },
                    {
                        "id": 112615,
                        "name": "Bourbonnais",
                        "latitude": "41.15376000",
                        "longitude": "-87.88754000"
                    },
                    {
                        "id": 112672,
                        "name": "Bradley",
                        "latitude": "41.14198000",
                        "longitude": "-87.86115000"
                    },
                    {
                        "id": 112680,
                        "name": "Braidwood",
                        "latitude": "41.26503000",
                        "longitude": "-88.21228000"
                    },
                    {
                        "id": 112717,
                        "name": "Breese",
                        "latitude": "38.61060000",
                        "longitude": "-89.52703000"
                    },
                    {
                        "id": 112761,
                        "name": "Bridgeport",
                        "latitude": "41.83809000",
                        "longitude": "-87.65116000"
                    },
                    {
                        "id": 112771,
                        "name": "Bridgeview",
                        "latitude": "41.75003000",
                        "longitude": "-87.80422000"
                    },
                    {
                        "id": 112787,
                        "name": "Brighton",
                        "latitude": "39.03977000",
                        "longitude": "-90.14066000"
                    },
                    {
                        "id": 112793,
                        "name": "Brighton Park",
                        "latitude": "41.81892000",
                        "longitude": "-87.69894000"
                    },
                    {
                        "id": 112827,
                        "name": "Broadview",
                        "latitude": "41.86392000",
                        "longitude": "-87.85339000"
                    },
                    {
                        "id": 112854,
                        "name": "Brookfield",
                        "latitude": "41.82392000",
                        "longitude": "-87.85173000"
                    },
                    {
                        "id": 112907,
                        "name": "Brown County",
                        "latitude": "39.96181000",
                        "longitude": "-90.75034000"
                    },
                    {
                        "id": 113021,
                        "name": "Buffalo Grove",
                        "latitude": "42.15141000",
                        "longitude": "-87.95979000"
                    },
                    {
                        "id": 113029,
                        "name": "Bull Valley",
                        "latitude": "42.32058000",
                        "longitude": "-88.35509000"
                    },
                    {
                        "id": 113040,
                        "name": "Bunker Hill",
                        "latitude": "39.04282000",
                        "longitude": "-89.95177000"
                    },
                    {
                        "id": 113046,
                        "name": "Burbank",
                        "latitude": "41.73392000",
                        "longitude": "-87.77950000"
                    },
                    {
                        "id": 113049,
                        "name": "Bureau County",
                        "latitude": "41.40415000",
                        "longitude": "-89.52868000"
                    },
                    {
                        "id": 113083,
                        "name": "Burnham",
                        "latitude": "41.63892000",
                        "longitude": "-87.55671000"
                    },
                    {
                        "id": 113093,
                        "name": "Burr Ridge",
                        "latitude": "41.74892000",
                        "longitude": "-87.91839000"
                    },
                    {
                        "id": 113102,
                        "name": "Bushnell",
                        "latitude": "40.55282000",
                        "longitude": "-90.50624000"
                    },
                    {
                        "id": 113144,
                        "name": "Byron",
                        "latitude": "42.12697000",
                        "longitude": "-89.25566000"
                    },
                    {
                        "id": 113168,
                        "name": "Cahokia",
                        "latitude": "38.57088000",
                        "longitude": "-90.19011000"
                    },
                    {
                        "id": 113170,
                        "name": "Cairo",
                        "latitude": "37.00533000",
                        "longitude": "-89.17646000"
                    },
                    {
                        "id": 113204,
                        "name": "Calhoun County",
                        "latitude": "39.16930000",
                        "longitude": "-90.66753000"
                    },
                    {
                        "id": 113230,
                        "name": "Calumet City",
                        "latitude": "41.61559000",
                        "longitude": "-87.52949000"
                    },
                    {
                        "id": 113232,
                        "name": "Calumet Park",
                        "latitude": "41.66281000",
                        "longitude": "-87.66060000"
                    },
                    {
                        "id": 113245,
                        "name": "Cambria",
                        "latitude": "37.78144000",
                        "longitude": "-89.11925000"
                    },
                    {
                        "id": 113251,
                        "name": "Cambridge",
                        "latitude": "41.30365000",
                        "longitude": "-90.19290000"
                    },
                    {
                        "id": 113292,
                        "name": "Camp Point",
                        "latitude": "40.03921000",
                        "longitude": "-91.06930000"
                    },
                    {
                        "id": 113343,
                        "name": "Canton",
                        "latitude": "40.55809000",
                        "longitude": "-90.03512000"
                    },
                    {
                        "id": 113377,
                        "name": "Capron",
                        "latitude": "42.39974000",
                        "longitude": "-88.74038000"
                    },
                    {
                        "id": 113381,
                        "name": "Carbon Cliff",
                        "latitude": "41.49476000",
                        "longitude": "-90.39068000"
                    },
                    {
                        "id": 113388,
                        "name": "Carbondale",
                        "latitude": "37.72727000",
                        "longitude": "-89.21675000"
                    },
                    {
                        "id": 113400,
                        "name": "Carlinville",
                        "latitude": "39.27977000",
                        "longitude": "-89.88177000"
                    },
                    {
                        "id": 113414,
                        "name": "Carlyle",
                        "latitude": "38.61033000",
                        "longitude": "-89.37258000"
                    },
                    {
                        "id": 113422,
                        "name": "Carmi",
                        "latitude": "38.09088000",
                        "longitude": "-88.15865000"
                    },
                    {
                        "id": 113434,
                        "name": "Carol Stream",
                        "latitude": "41.91253000",
                        "longitude": "-88.13479000"
                    },
                    {
                        "id": 113439,
                        "name": "Carpentersville",
                        "latitude": "42.12114000",
                        "longitude": "-88.25786000"
                    },
                    {
                        "id": 113444,
                        "name": "Carrier Mills",
                        "latitude": "37.68422000",
                        "longitude": "-88.63283000"
                    },
                    {
                        "id": 113459,
                        "name": "Carroll County",
                        "latitude": "42.06861000",
                        "longitude": "-89.93433000"
                    },
                    {
                        "id": 113465,
                        "name": "Carrollton",
                        "latitude": "39.30227000",
                        "longitude": "-90.40706000"
                    },
                    {
                        "id": 113489,
                        "name": "Carterville",
                        "latitude": "37.76005000",
                        "longitude": "-89.07730000"
                    },
                    {
                        "id": 113496,
                        "name": "Carthage",
                        "latitude": "40.41643000",
                        "longitude": "-91.13625000"
                    },
                    {
                        "id": 113506,
                        "name": "Cary",
                        "latitude": "42.21197000",
                        "longitude": "-88.23814000"
                    },
                    {
                        "id": 113519,
                        "name": "Casey",
                        "latitude": "39.29920000",
                        "longitude": "-87.99253000"
                    },
                    {
                        "id": 113521,
                        "name": "Caseyville",
                        "latitude": "38.63672000",
                        "longitude": "-90.02566000"
                    },
                    {
                        "id": 113526,
                        "name": "Cass County",
                        "latitude": "39.97356000",
                        "longitude": "-90.24738000"
                    },
                    {
                        "id": 113573,
                        "name": "Catlin",
                        "latitude": "40.06504000",
                        "longitude": "-87.70197000"
                    },
                    {
                        "id": 113667,
                        "name": "Central City",
                        "latitude": "38.54894000",
                        "longitude": "-89.12701000"
                    },
                    {
                        "id": 113685,
                        "name": "Centralia",
                        "latitude": "38.52505000",
                        "longitude": "-89.13340000"
                    },
                    {
                        "id": 113692,
                        "name": "Centreville",
                        "latitude": "38.58338000",
                        "longitude": "-90.12511000"
                    },
                    {
                        "id": 113702,
                        "name": "Cerro Gordo",
                        "latitude": "39.89059000",
                        "longitude": "-88.72813000"
                    },
                    {
                        "id": 113724,
                        "name": "Champaign",
                        "latitude": "40.11642000",
                        "longitude": "-88.24338000"
                    },
                    {
                        "id": 113725,
                        "name": "Champaign County",
                        "latitude": "40.14008000",
                        "longitude": "-88.19919000"
                    },
                    {
                        "id": 113733,
                        "name": "Channahon",
                        "latitude": "41.42948000",
                        "longitude": "-88.22867000"
                    },
                    {
                        "id": 113735,
                        "name": "Channel Lake",
                        "latitude": "42.47863000",
                        "longitude": "-88.13759000"
                    },
                    {
                        "id": 113762,
                        "name": "Charleston",
                        "latitude": "39.49615000",
                        "longitude": "-88.17615000"
                    },
                    {
                        "id": 113797,
                        "name": "Chatham",
                        "latitude": "41.74115000",
                        "longitude": "-87.61255000"
                    },
                    {
                        "id": 113806,
                        "name": "Chatsworth",
                        "latitude": "40.75365000",
                        "longitude": "-88.29199000"
                    },
                    {
                        "id": 113820,
                        "name": "Chebanse",
                        "latitude": "41.00309000",
                        "longitude": "-87.90810000"
                    },
                    {
                        "id": 113841,
                        "name": "Chenoa",
                        "latitude": "40.74170000",
                        "longitude": "-88.71979000"
                    },
                    {
                        "id": 113864,
                        "name": "Cherry Valley",
                        "latitude": "42.23474000",
                        "longitude": "-88.94899000"
                    },
                    {
                        "id": 113882,
                        "name": "Chester",
                        "latitude": "37.91366000",
                        "longitude": "-89.82205000"
                    },
                    {
                        "id": 113931,
                        "name": "Chicago",
                        "latitude": "41.85003000",
                        "longitude": "-87.65005000"
                    },
                    {
                        "id": 113932,
                        "name": "Chicago Heights",
                        "latitude": "41.50615000",
                        "longitude": "-87.63560000"
                    },
                    {
                        "id": 113933,
                        "name": "Chicago Lawn",
                        "latitude": "41.77503000",
                        "longitude": "-87.69644000"
                    },
                    {
                        "id": 113934,
                        "name": "Chicago Loop",
                        "latitude": "41.88407000",
                        "longitude": "-87.63330000"
                    },
                    {
                        "id": 113935,
                        "name": "Chicago Ridge",
                        "latitude": "41.70142000",
                        "longitude": "-87.77922000"
                    },
                    {
                        "id": 113954,
                        "name": "Chillicothe",
                        "latitude": "40.92226000",
                        "longitude": "-89.48620000"
                    },
                    {
                        "id": 113994,
                        "name": "Chrisman",
                        "latitude": "39.80365000",
                        "longitude": "-87.67364000"
                    },
                    {
                        "id": 113995,
                        "name": "Christian County",
                        "latitude": "39.54579000",
                        "longitude": "-89.27727000"
                    },
                    {
                        "id": 114002,
                        "name": "Christopher",
                        "latitude": "37.97255000",
                        "longitude": "-89.05341000"
                    },
                    {
                        "id": 114019,
                        "name": "Cicero",
                        "latitude": "41.84559000",
                        "longitude": "-87.75394000"
                    },
                    {
                        "id": 114114,
                        "name": "Clarendon Hills",
                        "latitude": "41.79753000",
                        "longitude": "-87.95478000"
                    },
                    {
                        "id": 114122,
                        "name": "Clark County",
                        "latitude": "39.33357000",
                        "longitude": "-87.78772000"
                    },
                    {
                        "id": 114177,
                        "name": "Clay County",
                        "latitude": "38.75416000",
                        "longitude": "-88.49019000"
                    },
                    {
                        "id": 114257,
                        "name": "Clifton",
                        "latitude": "40.93531000",
                        "longitude": "-87.93449000"
                    },
                    {
                        "id": 114279,
                        "name": "Clinton",
                        "latitude": "40.15365000",
                        "longitude": "-88.96453000"
                    },
                    {
                        "id": 114289,
                        "name": "Clinton County",
                        "latitude": "38.60645000",
                        "longitude": "-89.42248000"
                    },
                    {
                        "id": 114327,
                        "name": "Coal City",
                        "latitude": "41.28781000",
                        "longitude": "-88.28562000"
                    },
                    {
                        "id": 114333,
                        "name": "Coal Valley",
                        "latitude": "41.42865000",
                        "longitude": "-90.46096000"
                    },
                    {
                        "id": 114346,
                        "name": "Cobden",
                        "latitude": "37.53144000",
                        "longitude": "-89.25342000"
                    },
                    {
                        "id": 114382,
                        "name": "Colchester",
                        "latitude": "40.42643000",
                        "longitude": "-90.79263000"
                    },
                    {
                        "id": 114402,
                        "name": "Coles County",
                        "latitude": "39.52029000",
                        "longitude": "-88.22180000"
                    },
                    {
                        "id": 114406,
                        "name": "Colfax",
                        "latitude": "40.56698000",
                        "longitude": "-88.61645000"
                    },
                    {
                        "id": 114434,
                        "name": "Collinsville",
                        "latitude": "38.67033000",
                        "longitude": "-89.98455000"
                    },
                    {
                        "id": 114445,
                        "name": "Colona",
                        "latitude": "41.48392000",
                        "longitude": "-90.35318000"
                    },
                    {
                        "id": 114465,
                        "name": "Columbia",
                        "latitude": "38.44366000",
                        "longitude": "-90.20122000"
                    },
                    {
                        "id": 114592,
                        "name": "Cook County",
                        "latitude": "41.89540000",
                        "longitude": "-87.64616000"
                    },
                    {
                        "id": 114675,
                        "name": "Cortland",
                        "latitude": "41.92003000",
                        "longitude": "-88.68870000"
                    },
                    {
                        "id": 114718,
                        "name": "Country Club Hills",
                        "latitude": "41.56809000",
                        "longitude": "-87.72033000"
                    },
                    {
                        "id": 114726,
                        "name": "Countryside",
                        "latitude": "41.78281000",
                        "longitude": "-87.87811000"
                    },
                    {
                        "id": 114761,
                        "name": "Crainville",
                        "latitude": "37.75199000",
                        "longitude": "-89.06785000"
                    },
                    {
                        "id": 114776,
                        "name": "Crawford County",
                        "latitude": "39.00269000",
                        "longitude": "-87.75956000"
                    },
                    {
                        "id": 114803,
                        "name": "Crest Hill",
                        "latitude": "41.55475000",
                        "longitude": "-88.09867000"
                    },
                    {
                        "id": 114811,
                        "name": "Crestwood",
                        "latitude": "41.64463000",
                        "longitude": "-87.74154000"
                    },
                    {
                        "id": 114814,
                        "name": "Crete",
                        "latitude": "41.44448000",
                        "longitude": "-87.63143000"
                    },
                    {
                        "id": 114817,
                        "name": "Creve Coeur",
                        "latitude": "40.64726000",
                        "longitude": "-89.59121000"
                    },
                    {
                        "id": 114880,
                        "name": "Crystal Lake",
                        "latitude": "42.24113000",
                        "longitude": "-88.31620000"
                    },
                    {
                        "id": 114881,
                        "name": "Crystal Lawns",
                        "latitude": "41.57031000",
                        "longitude": "-88.15812000"
                    },
                    {
                        "id": 114886,
                        "name": "Cuba",
                        "latitude": "42.18391000",
                        "longitude": "-88.19091000"
                    },
                    {
                        "id": 114912,
                        "name": "Cumberland County",
                        "latitude": "39.27332000",
                        "longitude": "-88.24023000"
                    },
                    {
                        "id": 115030,
                        "name": "Danvers",
                        "latitude": "40.52948000",
                        "longitude": "-89.17731000"
                    },
                    {
                        "id": 115035,
                        "name": "Danville",
                        "latitude": "40.12448000",
                        "longitude": "-87.63002000"
                    },
                    {
                        "id": 115047,
                        "name": "Darien",
                        "latitude": "41.75198000",
                        "longitude": "-87.97395000"
                    },
                    {
                        "id": 115076,
                        "name": "Davis Junction",
                        "latitude": "42.10169000",
                        "longitude": "-89.09316000"
                    },
                    {
                        "id": 115116,
                        "name": "De Soto",
                        "latitude": "37.81755000",
                        "longitude": "-89.22786000"
                    },
                    {
                        "id": 115123,
                        "name": "De Witt County",
                        "latitude": "40.17463000",
                        "longitude": "-88.90409000"
                    },
                    {
                        "id": 115151,
                        "name": "Decatur",
                        "latitude": "39.84031000",
                        "longitude": "-88.95480000"
                    },
                    {
                        "id": 115176,
                        "name": "Deer Park",
                        "latitude": "42.16086000",
                        "longitude": "-88.08147000"
                    },
                    {
                        "id": 115181,
                        "name": "Deerfield",
                        "latitude": "42.17114000",
                        "longitude": "-87.84451000"
                    },
                    {
                        "id": 115127,
                        "name": "DeKalb",
                        "latitude": "41.92947000",
                        "longitude": "-88.75036000"
                    },
                    {
                        "id": 115132,
                        "name": "DeKalb County",
                        "latitude": "41.89353000",
                        "longitude": "-88.77031000"
                    },
                    {
                        "id": 115200,
                        "name": "Delavan",
                        "latitude": "40.37254000",
                        "longitude": "-89.54732000"
                    },
                    {
                        "id": 115259,
                        "name": "Depue",
                        "latitude": "41.32420000",
                        "longitude": "-89.30675000"
                    },
                    {
                        "id": 115275,
                        "name": "Des Plaines",
                        "latitude": "42.03336000",
                        "longitude": "-87.88340000"
                    },
                    {
                        "id": 115313,
                        "name": "Diamond",
                        "latitude": "41.28864000",
                        "longitude": "-88.25173000"
                    },
                    {
                        "id": 115356,
                        "name": "Divernon",
                        "latitude": "39.56561000",
                        "longitude": "-89.65732000"
                    },
                    {
                        "id": 115363,
                        "name": "Dixmoor",
                        "latitude": "41.63170000",
                        "longitude": "-87.66088000"
                    },
                    {
                        "id": 115366,
                        "name": "Dixon",
                        "latitude": "41.83892000",
                        "longitude": "-89.47955000"
                    },
                    {
                        "id": 115392,
                        "name": "Dolton",
                        "latitude": "41.63892000",
                        "longitude": "-87.60727000"
                    },
                    {
                        "id": 115420,
                        "name": "Douglas",
                        "latitude": "41.83476000",
                        "longitude": "-87.61811000"
                    },
                    {
                        "id": 115426,
                        "name": "Douglas County",
                        "latitude": "39.76946000",
                        "longitude": "-88.21735000"
                    },
                    {
                        "id": 115459,
                        "name": "Downers Grove",
                        "latitude": "41.80892000",
                        "longitude": "-88.01117000"
                    },
                    {
                        "id": 115486,
                        "name": "Du Quoin",
                        "latitude": "38.01144000",
                        "longitude": "-89.23619000"
                    },
                    {
                        "id": 115544,
                        "name": "Dunlap",
                        "latitude": "40.86170000",
                        "longitude": "-89.67871000"
                    },
                    {
                        "id": 115488,
                        "name": "DuPage County",
                        "latitude": "41.85195000",
                        "longitude": "-88.08567000"
                    },
                    {
                        "id": 115557,
                        "name": "Dupo",
                        "latitude": "38.51616000",
                        "longitude": "-90.21039000"
                    },
                    {
                        "id": 115562,
                        "name": "Durand",
                        "latitude": "42.43640000",
                        "longitude": "-89.33206000"
                    },
                    {
                        "id": 115584,
                        "name": "Dwight",
                        "latitude": "41.09448000",
                        "longitude": "-88.42506000"
                    },
                    {
                        "id": 115621,
                        "name": "Earlville",
                        "latitude": "41.58948000",
                        "longitude": "-88.92203000"
                    },
                    {
                        "id": 115626,
                        "name": "East Alton",
                        "latitude": "38.88033000",
                        "longitude": "-90.11122000"
                    },
                    {
                        "id": 115652,
                        "name": "East Dubuque",
                        "latitude": "42.49223000",
                        "longitude": "-90.64291000"
                    },
                    {
                        "id": 115653,
                        "name": "East Dundee",
                        "latitude": "42.09891000",
                        "longitude": "-88.27147000"
                    },
                    {
                        "id": 115668,
                        "name": "East Garfield Park",
                        "latitude": "41.88087000",
                        "longitude": "-87.70283000"
                    },
                    {
                        "id": 115687,
                        "name": "East Hazel Crest",
                        "latitude": "41.57365000",
                        "longitude": "-87.64643000"
                    },
                    {
                        "id": 115716,
                        "name": "East Moline",
                        "latitude": "41.50087000",
                        "longitude": "-90.44430000"
                    },
                    {
                        "id": 115732,
                        "name": "East Peoria",
                        "latitude": "40.66615000",
                        "longitude": "-89.58010000"
                    },
                    {
                        "id": 115754,
                        "name": "East Saint Louis",
                        "latitude": "38.62450000",
                        "longitude": "-90.15094000"
                    },
                    {
                        "id": 115836,
                        "name": "Edgar County",
                        "latitude": "39.67853000",
                        "longitude": "-87.74557000"
                    },
                    {
                        "id": 115853,
                        "name": "Edgewater",
                        "latitude": "41.98337000",
                        "longitude": "-87.66395000"
                    },
                    {
                        "id": 115869,
                        "name": "Edinburg",
                        "latitude": "39.65727000",
                        "longitude": "-89.38953000"
                    },
                    {
                        "id": 115889,
                        "name": "Edwards County",
                        "latitude": "38.41653000",
                        "longitude": "-88.05327000"
                    },
                    {
                        "id": 115894,
                        "name": "Edwardsville",
                        "latitude": "38.81144000",
                        "longitude": "-89.95316000"
                    },
                    {
                        "id": 115896,
                        "name": "Effingham",
                        "latitude": "39.12004000",
                        "longitude": "-88.54338000"
                    },
                    {
                        "id": 115899,
                        "name": "Effingham County",
                        "latitude": "39.05977000",
                        "longitude": "-88.58986000"
                    },
                    {
                        "id": 115929,
                        "name": "El Paso",
                        "latitude": "40.73920000",
                        "longitude": "-89.01646000"
                    },
                    {
                        "id": 115948,
                        "name": "Elburn",
                        "latitude": "41.89225000",
                        "longitude": "-88.47230000"
                    },
                    {
                        "id": 115952,
                        "name": "Eldorado",
                        "latitude": "37.81366000",
                        "longitude": "-88.43810000"
                    },
                    {
                        "id": 115966,
                        "name": "Elgin",
                        "latitude": "42.03725000",
                        "longitude": "-88.28119000"
                    },
                    {
                        "id": 115977,
                        "name": "Elizabethtown",
                        "latitude": "37.44588000",
                        "longitude": "-88.30504000"
                    },
                    {
                        "id": 115988,
                        "name": "Elk Grove Village",
                        "latitude": "42.00392000",
                        "longitude": "-87.97035000"
                    },
                    {
                        "id": 116051,
                        "name": "Elmhurst",
                        "latitude": "41.89947000",
                        "longitude": "-87.94034000"
                    },
                    {
                        "id": 116061,
                        "name": "Elmwood",
                        "latitude": "40.77782000",
                        "longitude": "-89.96650000"
                    },
                    {
                        "id": 116062,
                        "name": "Elmwood Park",
                        "latitude": "41.92114000",
                        "longitude": "-87.80923000"
                    },
                    {
                        "id": 116080,
                        "name": "Elwood",
                        "latitude": "41.40392000",
                        "longitude": "-88.11172000"
                    },
                    {
                        "id": 116122,
                        "name": "Energy",
                        "latitude": "37.77394000",
                        "longitude": "-89.02646000"
                    },
                    {
                        "id": 116131,
                        "name": "Englewood",
                        "latitude": "41.77976000",
                        "longitude": "-87.64588000"
                    },
                    {
                        "id": 116165,
                        "name": "Erie",
                        "latitude": "41.65642000",
                        "longitude": "-90.07929000"
                    },
                    {
                        "id": 116234,
                        "name": "Eureka",
                        "latitude": "40.72143000",
                        "longitude": "-89.27286000"
                    },
                    {
                        "id": 116251,
                        "name": "Evanston",
                        "latitude": "42.04114000",
                        "longitude": "-87.69006000"
                    },
                    {
                        "id": 116265,
                        "name": "Evergreen Park",
                        "latitude": "41.72059000",
                        "longitude": "-87.70172000"
                    },
                    {
                        "id": 116294,
                        "name": "Fairbury",
                        "latitude": "40.74726000",
                        "longitude": "-88.51478000"
                    },
                    {
                        "id": 116310,
                        "name": "Fairfield",
                        "latitude": "38.37894000",
                        "longitude": "-88.35977000"
                    },
                    {
                        "id": 116336,
                        "name": "Fairmont",
                        "latitude": "41.55614000",
                        "longitude": "-88.05923000"
                    },
                    {
                        "id": 116338,
                        "name": "Fairmont City",
                        "latitude": "38.64977000",
                        "longitude": "-90.09316000"
                    },
                    {
                        "id": 116358,
                        "name": "Fairview Heights",
                        "latitude": "38.58894000",
                        "longitude": "-89.99038000"
                    },
                    {
                        "id": 116402,
                        "name": "Farmer City",
                        "latitude": "40.24337000",
                        "longitude": "-88.64257000"
                    },
                    {
                        "id": 116416,
                        "name": "Farmington",
                        "latitude": "40.69809000",
                        "longitude": "-90.00595000"
                    },
                    {
                        "id": 116445,
                        "name": "Fayette County",
                        "latitude": "39.00019000",
                        "longitude": "-89.02414000"
                    },
                    {
                        "id": 116527,
                        "name": "Fisher",
                        "latitude": "40.31476000",
                        "longitude": "-88.35005000"
                    },
                    {
                        "id": 116547,
                        "name": "Flanagan",
                        "latitude": "40.87809000",
                        "longitude": "-88.86118000"
                    },
                    {
                        "id": 116570,
                        "name": "Flora",
                        "latitude": "38.66894000",
                        "longitude": "-88.48560000"
                    },
                    {
                        "id": 116598,
                        "name": "Flossmoor",
                        "latitude": "41.54281000",
                        "longitude": "-87.68477000"
                    },
                    {
                        "id": 116637,
                        "name": "Ford County",
                        "latitude": "40.59718000",
                        "longitude": "-88.22326000"
                    },
                    {
                        "id": 116638,
                        "name": "Ford Heights",
                        "latitude": "41.50642000",
                        "longitude": "-87.59171000"
                    },
                    {
                        "id": 116660,
                        "name": "Forest Lake",
                        "latitude": "42.20752000",
                        "longitude": "-88.05563000"
                    },
                    {
                        "id": 116666,
                        "name": "Forest Park",
                        "latitude": "41.87948000",
                        "longitude": "-87.81367000"
                    },
                    {
                        "id": 116678,
                        "name": "Forrest",
                        "latitude": "40.75198000",
                        "longitude": "-88.41116000"
                    },
                    {
                        "id": 116681,
                        "name": "Forreston",
                        "latitude": "42.12614000",
                        "longitude": "-89.57928000"
                    },
                    {
                        "id": 116682,
                        "name": "Forsyth",
                        "latitude": "39.93254000",
                        "longitude": "-88.95119000"
                    },
                    {
                        "id": 116803,
                        "name": "Fox Lake",
                        "latitude": "42.39669000",
                        "longitude": "-88.18370000"
                    },
                    {
                        "id": 116805,
                        "name": "Fox Lake Hills",
                        "latitude": "42.40808000",
                        "longitude": "-88.13175000"
                    },
                    {
                        "id": 116807,
                        "name": "Fox River Grove",
                        "latitude": "42.20086000",
                        "longitude": "-88.21453000"
                    },
                    {
                        "id": 116819,
                        "name": "Frankfort",
                        "latitude": "41.49587000",
                        "longitude": "-87.84866000"
                    },
                    {
                        "id": 116824,
                        "name": "Frankfort Square",
                        "latitude": "41.51892000",
                        "longitude": "-87.80310000"
                    },
                    {
                        "id": 116847,
                        "name": "Franklin County",
                        "latitude": "37.99229000",
                        "longitude": "-88.92415000"
                    },
                    {
                        "id": 116868,
                        "name": "Franklin Park",
                        "latitude": "41.93531000",
                        "longitude": "-87.86562000"
                    },
                    {
                        "id": 116900,
                        "name": "Freeburg",
                        "latitude": "38.42755000",
                        "longitude": "-89.91371000"
                    },
                    {
                        "id": 116912,
                        "name": "Freeport",
                        "latitude": "42.29669000",
                        "longitude": "-89.62123000"
                    },
                    {
                        "id": 116990,
                        "name": "Fulton",
                        "latitude": "41.86725000",
                        "longitude": "-90.15957000"
                    },
                    {
                        "id": 116995,
                        "name": "Fulton County",
                        "latitude": "40.47277000",
                        "longitude": "-90.20747000"
                    },
                    {
                        "id": 117009,
                        "name": "Gage Park",
                        "latitude": "41.79503000",
                        "longitude": "-87.69616000"
                    },
                    {
                        "id": 117010,
                        "name": "Gages Lake",
                        "latitude": "42.35169000",
                        "longitude": "-87.98258000"
                    },
                    {
                        "id": 117024,
                        "name": "Galena",
                        "latitude": "42.41667000",
                        "longitude": "-90.42902000"
                    },
                    {
                        "id": 117027,
                        "name": "Galesburg",
                        "latitude": "40.94782000",
                        "longitude": "-90.37124000"
                    },
                    {
                        "id": 117034,
                        "name": "Gallatin County",
                        "latitude": "37.76275000",
                        "longitude": "-88.23050000"
                    },
                    {
                        "id": 117041,
                        "name": "Galva",
                        "latitude": "41.16754000",
                        "longitude": "-90.04261000"
                    },
                    {
                        "id": 117076,
                        "name": "Gardner",
                        "latitude": "41.18559000",
                        "longitude": "-88.30978000"
                    },
                    {
                        "id": 117137,
                        "name": "Geneseo",
                        "latitude": "41.44809000",
                        "longitude": "-90.15428000"
                    },
                    {
                        "id": 117142,
                        "name": "Geneva",
                        "latitude": "41.88753000",
                        "longitude": "-88.30535000"
                    },
                    {
                        "id": 117147,
                        "name": "Genoa",
                        "latitude": "42.09725000",
                        "longitude": "-88.69287000"
                    },
                    {
                        "id": 117162,
                        "name": "Georgetown",
                        "latitude": "42.13975000",
                        "longitude": "-89.82873000"
                    },
                    {
                        "id": 117171,
                        "name": "Germantown",
                        "latitude": "38.55366000",
                        "longitude": "-89.53842000"
                    },
                    {
                        "id": 117175,
                        "name": "Germantown Hills",
                        "latitude": "40.76643000",
                        "longitude": "-89.46787000"
                    },
                    {
                        "id": 117188,
                        "name": "Gibson City",
                        "latitude": "40.45843000",
                        "longitude": "-88.38460000"
                    },
                    {
                        "id": 117198,
                        "name": "Gifford",
                        "latitude": "40.30587000",
                        "longitude": "-88.02115000"
                    },
                    {
                        "id": 117206,
                        "name": "Gilberts",
                        "latitude": "42.10336000",
                        "longitude": "-88.37286000"
                    },
                    {
                        "id": 117214,
                        "name": "Gillespie",
                        "latitude": "39.12977000",
                        "longitude": "-89.81954000"
                    },
                    {
                        "id": 117219,
                        "name": "Gilman",
                        "latitude": "40.76670000",
                        "longitude": "-87.99226000"
                    },
                    {
                        "id": 117226,
                        "name": "Girard",
                        "latitude": "39.44644000",
                        "longitude": "-89.78093000"
                    },
                    {
                        "id": 117244,
                        "name": "Glasford",
                        "latitude": "40.57254000",
                        "longitude": "-89.81344000"
                    },
                    {
                        "id": 117263,
                        "name": "Glen Carbon",
                        "latitude": "38.74838000",
                        "longitude": "-89.98316000"
                    },
                    {
                        "id": 117265,
                        "name": "Glen Ellyn",
                        "latitude": "41.87753000",
                        "longitude": "-88.06701000"
                    },
                    {
                        "id": 117278,
                        "name": "Glencoe",
                        "latitude": "42.13503000",
                        "longitude": "-87.75812000"
                    },
                    {
                        "id": 117288,
                        "name": "Glendale Heights",
                        "latitude": "41.91460000",
                        "longitude": "-88.06486000"
                    },
                    {
                        "id": 117309,
                        "name": "Glenview",
                        "latitude": "42.06975000",
                        "longitude": "-87.78784000"
                    },
                    {
                        "id": 117314,
                        "name": "Glenwood",
                        "latitude": "41.54253000",
                        "longitude": "-87.60227000"
                    },
                    {
                        "id": 117334,
                        "name": "Godfrey",
                        "latitude": "38.95560000",
                        "longitude": "-90.18678000"
                    },
                    {
                        "id": 117338,
                        "name": "Golconda",
                        "latitude": "37.36727000",
                        "longitude": "-88.48643000"
                    },
                    {
                        "id": 117383,
                        "name": "Goodings Grove",
                        "latitude": "41.62920000",
                        "longitude": "-87.93089000"
                    },
                    {
                        "id": 117402,
                        "name": "Goreville",
                        "latitude": "37.55450000",
                        "longitude": "-88.97229000"
                    },
                    {
                        "id": 117451,
                        "name": "Grand Boulevard",
                        "latitude": "41.81392000",
                        "longitude": "-87.61727000"
                    },
                    {
                        "id": 117478,
                        "name": "Grandview",
                        "latitude": "39.81644000",
                        "longitude": "-89.61871000"
                    },
                    {
                        "id": 117484,
                        "name": "Grandwood Park",
                        "latitude": "42.39308000",
                        "longitude": "-87.98674000"
                    },
                    {
                        "id": 117494,
                        "name": "Granite City",
                        "latitude": "38.70144000",
                        "longitude": "-90.14872000"
                    },
                    {
                        "id": 117523,
                        "name": "Grant Park",
                        "latitude": "41.24114000",
                        "longitude": "-87.64615000"
                    },
                    {
                        "id": 117535,
                        "name": "Granville",
                        "latitude": "41.26115000",
                        "longitude": "-89.22759000"
                    },
                    {
                        "id": 117559,
                        "name": "Grayslake",
                        "latitude": "42.34447000",
                        "longitude": "-88.04175000"
                    },
                    {
                        "id": 117568,
                        "name": "Grayville",
                        "latitude": "38.25755000",
                        "longitude": "-87.99364000"
                    },
                    {
                        "id": 117580,
                        "name": "Greater Grand Crossing",
                        "latitude": "41.76113000",
                        "longitude": "-87.61485000"
                    },
                    {
                        "id": 117604,
                        "name": "Green Oaks",
                        "latitude": "42.29002000",
                        "longitude": "-87.90341000"
                    },
                    {
                        "id": 117607,
                        "name": "Green Rock",
                        "latitude": "41.47309000",
                        "longitude": "-90.35763000"
                    },
                    {
                        "id": 117634,
                        "name": "Greene County",
                        "latitude": "39.35620000",
                        "longitude": "-90.39049000"
                    },
                    {
                        "id": 117645,
                        "name": "Greenfield",
                        "latitude": "39.34366000",
                        "longitude": "-90.21261000"
                    },
                    {
                        "id": 117676,
                        "name": "Greenup",
                        "latitude": "39.24782000",
                        "longitude": "-88.16337000"
                    },
                    {
                        "id": 117683,
                        "name": "Greenville",
                        "latitude": "38.89227000",
                        "longitude": "-89.41314000"
                    },
                    {
                        "id": 117729,
                        "name": "Gridley",
                        "latitude": "40.74337000",
                        "longitude": "-88.88146000"
                    },
                    {
                        "id": 117735,
                        "name": "Griggsville",
                        "latitude": "39.70894000",
                        "longitude": "-90.72457000"
                    },
                    {
                        "id": 117772,
                        "name": "Grundy County",
                        "latitude": "41.28509000",
                        "longitude": "-88.41850000"
                    },
                    {
                        "id": 117809,
                        "name": "Gurnee",
                        "latitude": "42.37030000",
                        "longitude": "-87.90202000"
                    },
                    {
                        "id": 117846,
                        "name": "Hainesville",
                        "latitude": "42.34502000",
                        "longitude": "-88.06786000"
                    },
                    {
                        "id": 117892,
                        "name": "Hamilton",
                        "latitude": "40.39643000",
                        "longitude": "-91.33904000"
                    },
                    {
                        "id": 117897,
                        "name": "Hamilton County",
                        "latitude": "38.08157000",
                        "longitude": "-88.53911000"
                    },
                    {
                        "id": 117920,
                        "name": "Hampshire",
                        "latitude": "42.09780000",
                        "longitude": "-88.53036000"
                    },
                    {
                        "id": 117932,
                        "name": "Hampton",
                        "latitude": "41.55587000",
                        "longitude": "-90.40930000"
                    },
                    {
                        "id": 117956,
                        "name": "Hancock County",
                        "latitude": "40.40378000",
                        "longitude": "-91.16470000"
                    },
                    {
                        "id": 117962,
                        "name": "Hanna City",
                        "latitude": "40.69170000",
                        "longitude": "-89.79511000"
                    },
                    {
                        "id": 117975,
                        "name": "Hanover Park",
                        "latitude": "41.99947000",
                        "longitude": "-88.14507000"
                    },
                    {
                        "id": 117997,
                        "name": "Hardin",
                        "latitude": "39.15671000",
                        "longitude": "-90.61790000"
                    },
                    {
                        "id": 117999,
                        "name": "Hardin County",
                        "latitude": "37.51820000",
                        "longitude": "-88.26685000"
                    },
                    {
                        "id": 118048,
                        "name": "Harrisburg",
                        "latitude": "37.73838000",
                        "longitude": "-88.54061000"
                    },
                    {
                        "id": 118072,
                        "name": "Harristown",
                        "latitude": "39.85393000",
                        "longitude": "-89.08397000"
                    },
                    {
                        "id": 118085,
                        "name": "Hartford",
                        "latitude": "38.83338000",
                        "longitude": "-90.09594000"
                    },
                    {
                        "id": 118108,
                        "name": "Harvard",
                        "latitude": "42.42224000",
                        "longitude": "-88.61371000"
                    },
                    {
                        "id": 118112,
                        "name": "Harvey",
                        "latitude": "41.61003000",
                        "longitude": "-87.64671000"
                    },
                    {
                        "id": 118120,
                        "name": "Harwood Heights",
                        "latitude": "41.96725000",
                        "longitude": "-87.80756000"
                    },
                    {
                        "id": 118146,
                        "name": "Havana",
                        "latitude": "40.30004000",
                        "longitude": "-90.06095000"
                    },
                    {
                        "id": 118171,
                        "name": "Hawthorn Woods",
                        "latitude": "42.21697000",
                        "longitude": "-88.04952000"
                    },
                    {
                        "id": 118202,
                        "name": "Hazel Crest",
                        "latitude": "41.57170000",
                        "longitude": "-87.69449000"
                    },
                    {
                        "id": 118236,
                        "name": "Hebron",
                        "latitude": "42.47169000",
                        "longitude": "-88.43232000"
                    },
                    {
                        "id": 118284,
                        "name": "Henderson County",
                        "latitude": "40.81812000",
                        "longitude": "-90.92511000"
                    },
                    {
                        "id": 118290,
                        "name": "Hennepin",
                        "latitude": "41.25420000",
                        "longitude": "-89.34231000"
                    },
                    {
                        "id": 118296,
                        "name": "Henry",
                        "latitude": "41.11142000",
                        "longitude": "-89.35648000"
                    },
                    {
                        "id": 118305,
                        "name": "Henry County",
                        "latitude": "41.35313000",
                        "longitude": "-90.13142000"
                    },
                    {
                        "id": 118319,
                        "name": "Heritage Lake",
                        "latitude": "40.54745000",
                        "longitude": "-89.32581000"
                    },
                    {
                        "id": 118339,
                        "name": "Herrin",
                        "latitude": "37.80311000",
                        "longitude": "-89.02757000"
                    },
                    {
                        "id": 118340,
                        "name": "Herscher",
                        "latitude": "41.04920000",
                        "longitude": "-88.09783000"
                    },
                    {
                        "id": 118352,
                        "name": "Heyworth",
                        "latitude": "40.31337000",
                        "longitude": "-88.97369000"
                    },
                    {
                        "id": 118369,
                        "name": "Hickory Hills",
                        "latitude": "41.72559000",
                        "longitude": "-87.82506000"
                    },
                    {
                        "id": 118393,
                        "name": "Highland",
                        "latitude": "38.73949000",
                        "longitude": "-89.67120000"
                    },
                    {
                        "id": 118411,
                        "name": "Highland Park",
                        "latitude": "42.18169000",
                        "longitude": "-87.80034000"
                    },
                    {
                        "id": 118426,
                        "name": "Highwood",
                        "latitude": "42.19975000",
                        "longitude": "-87.80923000"
                    },
                    {
                        "id": 118439,
                        "name": "Hillcrest",
                        "latitude": "41.95114000",
                        "longitude": "-89.06454000"
                    },
                    {
                        "id": 118446,
                        "name": "Hillsboro",
                        "latitude": "39.16128000",
                        "longitude": "-89.49540000"
                    },
                    {
                        "id": 118463,
                        "name": "Hillside",
                        "latitude": "41.87781000",
                        "longitude": "-87.90284000"
                    },
                    {
                        "id": 118476,
                        "name": "Hinckley",
                        "latitude": "41.76892000",
                        "longitude": "-88.64091000"
                    },
                    {
                        "id": 118485,
                        "name": "Hinsdale",
                        "latitude": "41.80086000",
                        "longitude": "-87.93701000"
                    },
                    {
                        "id": 118509,
                        "name": "Hodgkins",
                        "latitude": "41.76892000",
                        "longitude": "-87.85783000"
                    },
                    {
                        "id": 118510,
                        "name": "Hoffman Estates",
                        "latitude": "42.04281000",
                        "longitude": "-88.07980000"
                    },
                    {
                        "id": 118535,
                        "name": "Holiday Shores",
                        "latitude": "38.92199000",
                        "longitude": "-89.94066000"
                    },
                    {
                        "id": 118594,
                        "name": "Homer",
                        "latitude": "40.03476000",
                        "longitude": "-87.95809000"
                    },
                    {
                        "id": 118599,
                        "name": "Homer Glen",
                        "latitude": "41.60003000",
                        "longitude": "-87.93811000"
                    },
                    {
                        "id": 118605,
                        "name": "Hometown",
                        "latitude": "41.73448000",
                        "longitude": "-87.73144000"
                    },
                    {
                        "id": 118608,
                        "name": "Homewood",
                        "latitude": "41.55726000",
                        "longitude": "-87.66560000"
                    },
                    {
                        "id": 118636,
                        "name": "Hoopeston",
                        "latitude": "40.46726000",
                        "longitude": "-87.66836000"
                    },
                    {
                        "id": 118739,
                        "name": "Hudson",
                        "latitude": "40.60587000",
                        "longitude": "-88.98730000"
                    },
                    {
                        "id": 118812,
                        "name": "Huntley",
                        "latitude": "42.16808000",
                        "longitude": "-88.42814000"
                    },
                    {
                        "id": 118849,
                        "name": "Hyde Park",
                        "latitude": "41.79420000",
                        "longitude": "-87.59394000"
                    },
                    {
                        "id": 118887,
                        "name": "Ina",
                        "latitude": "38.15116000",
                        "longitude": "-88.90396000"
                    },
                    {
                        "id": 118904,
                        "name": "Indian Head Park",
                        "latitude": "41.77031000",
                        "longitude": "-87.90228000"
                    },
                    {
                        "id": 118934,
                        "name": "Ingalls Park",
                        "latitude": "41.52253000",
                        "longitude": "-88.04283000"
                    },
                    {
                        "id": 118956,
                        "name": "Inverness",
                        "latitude": "42.11808000",
                        "longitude": "-88.09619000"
                    },
                    {
                        "id": 119000,
                        "name": "Iroquois County",
                        "latitude": "40.74723000",
                        "longitude": "-87.82430000"
                    },
                    {
                        "id": 119006,
                        "name": "Irving Park",
                        "latitude": "41.95336000",
                        "longitude": "-87.73645000"
                    },
                    {
                        "id": 119026,
                        "name": "Island Lake",
                        "latitude": "42.27613000",
                        "longitude": "-88.19203000"
                    },
                    {
                        "id": 119040,
                        "name": "Itasca",
                        "latitude": "41.97503000",
                        "longitude": "-88.00729000"
                    },
                    {
                        "id": 119079,
                        "name": "Jackson County",
                        "latitude": "37.78514000",
                        "longitude": "-89.38212000"
                    },
                    {
                        "id": 119102,
                        "name": "Jacksonville",
                        "latitude": "39.73394000",
                        "longitude": "-90.22901000"
                    },
                    {
                        "id": 119146,
                        "name": "Jasper County",
                        "latitude": "39.01003000",
                        "longitude": "-88.15381000"
                    },
                    {
                        "id": 119179,
                        "name": "Jefferson County",
                        "latitude": "38.30052000",
                        "longitude": "-88.92401000"
                    },
                    {
                        "id": 119227,
                        "name": "Jerome",
                        "latitude": "39.76755000",
                        "longitude": "-89.68066000"
                    },
                    {
                        "id": 119232,
                        "name": "Jersey County",
                        "latitude": "39.08566000",
                        "longitude": "-90.35668000"
                    },
                    {
                        "id": 119235,
                        "name": "Jerseyville",
                        "latitude": "39.12005000",
                        "longitude": "-90.32845000"
                    },
                    {
                        "id": 119249,
                        "name": "Jo Daviess County",
                        "latitude": "42.36571000",
                        "longitude": "-90.21241000"
                    },
                    {
                        "id": 119253,
                        "name": "Johnsburg",
                        "latitude": "42.38002000",
                        "longitude": "-88.24203000"
                    },
                    {
                        "id": 119262,
                        "name": "Johnson County",
                        "latitude": "37.45963000",
                        "longitude": "-88.88089000"
                    },
                    {
                        "id": 119280,
                        "name": "Johnston City",
                        "latitude": "37.82061000",
                        "longitude": "-88.92757000"
                    },
                    {
                        "id": 119288,
                        "name": "Joliet",
                        "latitude": "41.52519000",
                        "longitude": "-88.08340000"
                    },
                    {
                        "id": 119301,
                        "name": "Jonesboro",
                        "latitude": "37.45172000",
                        "longitude": "-89.26814000"
                    },
                    {
                        "id": 119345,
                        "name": "Justice",
                        "latitude": "41.74448000",
                        "longitude": "-87.83783000"
                    },
                    {
                        "id": 119377,
                        "name": "Kane County",
                        "latitude": "41.93894000",
                        "longitude": "-88.42866000"
                    },
                    {
                        "id": 119380,
                        "name": "Kankakee",
                        "latitude": "41.12003000",
                        "longitude": "-87.86115000"
                    },
                    {
                        "id": 119381,
                        "name": "Kankakee County",
                        "latitude": "41.13770000",
                        "longitude": "-87.86180000"
                    },
                    {
                        "id": 119447,
                        "name": "Kendall County",
                        "latitude": "41.59056000",
                        "longitude": "-88.42885000"
                    },
                    {
                        "id": 119456,
                        "name": "Kenilworth",
                        "latitude": "42.08586000",
                        "longitude": "-87.71756000"
                    },
                    {
                        "id": 119504,
                        "name": "Kenwood",
                        "latitude": "41.80920000",
                        "longitude": "-87.59755000"
                    },
                    {
                        "id": 119532,
                        "name": "Kewanee",
                        "latitude": "41.24559000",
                        "longitude": "-89.92483000"
                    },
                    {
                        "id": 119555,
                        "name": "Kildeer",
                        "latitude": "42.17058000",
                        "longitude": "-88.04785000"
                    },
                    {
                        "id": 119573,
                        "name": "Kincaid",
                        "latitude": "39.58866000",
                        "longitude": "-89.41454000"
                    },
                    {
                        "id": 119624,
                        "name": "Kingston",
                        "latitude": "42.09975000",
                        "longitude": "-88.75898000"
                    },
                    {
                        "id": 119651,
                        "name": "Kirkland",
                        "latitude": "42.09253000",
                        "longitude": "-88.85121000"
                    },
                    {
                        "id": 119679,
                        "name": "Knollwood",
                        "latitude": "42.28613000",
                        "longitude": "-87.88563000"
                    },
                    {
                        "id": 119689,
                        "name": "Knox County",
                        "latitude": "40.93182000",
                        "longitude": "-90.21326000"
                    },
                    {
                        "id": 119696,
                        "name": "Knoxville",
                        "latitude": "40.90837000",
                        "longitude": "-90.28485000"
                    },
                    {
                        "id": 119752,
                        "name": "La Grange",
                        "latitude": "41.80503000",
                        "longitude": "-87.86923000"
                    },
                    {
                        "id": 119753,
                        "name": "La Grange Park",
                        "latitude": "41.83475000",
                        "longitude": "-87.86173000"
                    },
                    {
                        "id": 119757,
                        "name": "La Harpe",
                        "latitude": "40.58337000",
                        "longitude": "-90.96931000"
                    },
                    {
                        "id": 119785,
                        "name": "La Salle",
                        "latitude": "41.33337000",
                        "longitude": "-89.09175000"
                    },
                    {
                        "id": 119818,
                        "name": "Lacon",
                        "latitude": "41.02476000",
                        "longitude": "-89.41120000"
                    },
                    {
                        "id": 119822,
                        "name": "Ladd",
                        "latitude": "41.38253000",
                        "longitude": "-89.21897000"
                    },
                    {
                        "id": 119869,
                        "name": "Lake Barrington",
                        "latitude": "42.21252000",
                        "longitude": "-88.15258000"
                    },
                    {
                        "id": 119871,
                        "name": "Lake Bluff",
                        "latitude": "42.27891000",
                        "longitude": "-87.83424000"
                    },
                    {
                        "id": 119874,
                        "name": "Lake Camelot",
                        "latitude": "40.63065000",
                        "longitude": "-89.74210000"
                    },
                    {
                        "id": 119876,
                        "name": "Lake Catherine",
                        "latitude": "42.47919000",
                        "longitude": "-88.13342000"
                    },
                    {
                        "id": 119891,
                        "name": "Lake County",
                        "latitude": "42.34941000",
                        "longitude": "-87.86179000"
                    },
                    {
                        "id": 119910,
                        "name": "Lake Forest",
                        "latitude": "42.25863000",
                        "longitude": "-87.84063000"
                    },
                    {
                        "id": 119921,
                        "name": "Lake Holiday",
                        "latitude": "41.61292000",
                        "longitude": "-88.67209000"
                    },
                    {
                        "id": 120004,
                        "name": "Lake in the Hills",
                        "latitude": "42.18169000",
                        "longitude": "-88.33036000"
                    },
                    {
                        "id": 120006,
                        "name": "Lake of the Woods",
                        "latitude": "40.20642000",
                        "longitude": "-88.36867000"
                    },
                    {
                        "id": 119983,
                        "name": "Lake Summerset",
                        "latitude": "42.45446000",
                        "longitude": "-89.38956000"
                    },
                    {
                        "id": 119988,
                        "name": "Lake Villa",
                        "latitude": "42.41697000",
                        "longitude": "-88.07397000"
                    },
                    {
                        "id": 120002,
                        "name": "Lake Zurich",
                        "latitude": "42.19697000",
                        "longitude": "-88.09341000"
                    },
                    {
                        "id": 120022,
                        "name": "Lakemoor",
                        "latitude": "42.32863000",
                        "longitude": "-88.19897000"
                    },
                    {
                        "id": 120047,
                        "name": "Lakewood",
                        "latitude": "42.22919000",
                        "longitude": "-88.35509000"
                    },
                    {
                        "id": 120055,
                        "name": "Lakewood Shores",
                        "latitude": "41.28170000",
                        "longitude": "-88.14478000"
                    },
                    {
                        "id": 120079,
                        "name": "Lanark",
                        "latitude": "42.10225000",
                        "longitude": "-89.83345000"
                    },
                    {
                        "id": 120126,
                        "name": "Lansing",
                        "latitude": "41.56476000",
                        "longitude": "-87.53893000"
                    },
                    {
                        "id": 119806,
                        "name": "LaSalle County",
                        "latitude": "41.34399000",
                        "longitude": "-88.88595000"
                    },
                    {
                        "id": 120231,
                        "name": "Lawrence County",
                        "latitude": "38.71995000",
                        "longitude": "-87.72673000"
                    },
                    {
                        "id": 120244,
                        "name": "Lawrenceville",
                        "latitude": "38.72921000",
                        "longitude": "-87.68169000"
                    },
                    {
                        "id": 120262,
                        "name": "Le Roy",
                        "latitude": "40.35198000",
                        "longitude": "-88.76424000"
                    },
                    {
                        "id": 120284,
                        "name": "Lebanon",
                        "latitude": "38.60394000",
                        "longitude": "-89.80732000"
                    },
                    {
                        "id": 120317,
                        "name": "Lee County",
                        "latitude": "41.74619000",
                        "longitude": "-89.30039000"
                    },
                    {
                        "id": 120352,
                        "name": "Leland Grove",
                        "latitude": "39.77700000",
                        "longitude": "-89.67927000"
                    },
                    {
                        "id": 120360,
                        "name": "Lemont",
                        "latitude": "41.67364000",
                        "longitude": "-88.00173000"
                    },
                    {
                        "id": 120366,
                        "name": "Lena",
                        "latitude": "42.37946000",
                        "longitude": "-89.82234000"
                    },
                    {
                        "id": 120431,
                        "name": "Lewistown",
                        "latitude": "40.39310000",
                        "longitude": "-90.15484000"
                    },
                    {
                        "id": 120449,
                        "name": "Lexington",
                        "latitude": "40.64142000",
                        "longitude": "-88.78340000"
                    },
                    {
                        "id": 120476,
                        "name": "Libertyville",
                        "latitude": "42.28308000",
                        "longitude": "-87.95313000"
                    },
                    {
                        "id": 120487,
                        "name": "Lily Lake",
                        "latitude": "41.94892000",
                        "longitude": "-88.47786000"
                    },
                    {
                        "id": 120493,
                        "name": "Limestone",
                        "latitude": "41.13237000",
                        "longitude": "-87.96840000"
                    },
                    {
                        "id": 120503,
                        "name": "Lincoln",
                        "latitude": "40.14838000",
                        "longitude": "-89.36482000"
                    },
                    {
                        "id": 120540,
                        "name": "Lincoln Park",
                        "latitude": "41.92170000",
                        "longitude": "-87.64783000"
                    },
                    {
                        "id": 120546,
                        "name": "Lincoln Square",
                        "latitude": "41.97587000",
                        "longitude": "-87.68922000"
                    },
                    {
                        "id": 120550,
                        "name": "Lincolnshire",
                        "latitude": "42.19002000",
                        "longitude": "-87.90840000"
                    },
                    {
                        "id": 120555,
                        "name": "Lincolnwood",
                        "latitude": "42.00448000",
                        "longitude": "-87.73006000"
                    },
                    {
                        "id": 120567,
                        "name": "Lindenhurst",
                        "latitude": "42.41058000",
                        "longitude": "-88.02619000"
                    },
                    {
                        "id": 120602,
                        "name": "Lisle",
                        "latitude": "41.80114000",
                        "longitude": "-88.07479000"
                    },
                    {
                        "id": 120603,
                        "name": "Litchfield",
                        "latitude": "39.17533000",
                        "longitude": "-89.65426000"
                    },
                    {
                        "id": 120656,
                        "name": "Livingston County",
                        "latitude": "40.89156000",
                        "longitude": "-88.55772000"
                    },
                    {
                        "id": 120680,
                        "name": "Lockport",
                        "latitude": "41.58948000",
                        "longitude": "-88.05784000"
                    },
                    {
                        "id": 120700,
                        "name": "Logan County",
                        "latitude": "40.12456000",
                        "longitude": "-89.36755000"
                    },
                    {
                        "id": 120705,
                        "name": "Logan Square",
                        "latitude": "41.92337000",
                        "longitude": "-87.69922000"
                    },
                    {
                        "id": 120714,
                        "name": "Lombard",
                        "latitude": "41.88003000",
                        "longitude": "-88.00784000"
                    },
                    {
                        "id": 120742,
                        "name": "Long Creek",
                        "latitude": "39.81198000",
                        "longitude": "-88.84757000"
                    },
                    {
                        "id": 120743,
                        "name": "Long Grove",
                        "latitude": "42.17836000",
                        "longitude": "-87.99785000"
                    },
                    {
                        "id": 120746,
                        "name": "Long Lake",
                        "latitude": "42.37085000",
                        "longitude": "-88.12758000"
                    },
                    {
                        "id": 120812,
                        "name": "Louisville",
                        "latitude": "38.77227000",
                        "longitude": "-88.50255000"
                    },
                    {
                        "id": 120826,
                        "name": "Loves Park",
                        "latitude": "42.32002000",
                        "longitude": "-89.05816000"
                    },
                    {
                        "id": 120831,
                        "name": "Lovington",
                        "latitude": "39.71559000",
                        "longitude": "-88.63256000"
                    },
                    {
                        "id": 120843,
                        "name": "Lower West Side",
                        "latitude": "41.85420000",
                        "longitude": "-87.66561000"
                    },
                    {
                        "id": 120933,
                        "name": "Lynwood",
                        "latitude": "41.52642000",
                        "longitude": "-87.53865000"
                    },
                    {
                        "id": 120942,
                        "name": "Lyons",
                        "latitude": "41.81337000",
                        "longitude": "-87.81811000"
                    },
                    {
                        "id": 120955,
                        "name": "Machesney Park",
                        "latitude": "42.34724000",
                        "longitude": "-89.03900000"
                    },
                    {
                        "id": 120960,
                        "name": "Mackinaw",
                        "latitude": "40.53698000",
                        "longitude": "-89.35759000"
                    },
                    {
                        "id": 120961,
                        "name": "Macomb",
                        "latitude": "40.45921000",
                        "longitude": "-90.67180000"
                    },
                    {
                        "id": 120963,
                        "name": "Macon",
                        "latitude": "39.71282000",
                        "longitude": "-88.99702000"
                    },
                    {
                        "id": 120969,
                        "name": "Macon County",
                        "latitude": "39.86000000",
                        "longitude": "-88.96160000"
                    },
                    {
                        "id": 120973,
                        "name": "Macoupin County",
                        "latitude": "39.26102000",
                        "longitude": "-89.92443000"
                    },
                    {
                        "id": 120987,
                        "name": "Madison",
                        "latitude": "38.68255000",
                        "longitude": "-90.15705000"
                    },
                    {
                        "id": 121006,
                        "name": "Madison County",
                        "latitude": "38.82985000",
                        "longitude": "-89.90517000"
                    },
                    {
                        "id": 121045,
                        "name": "Mahomet",
                        "latitude": "40.19531000",
                        "longitude": "-88.40422000"
                    },
                    {
                        "id": 121067,
                        "name": "Malta",
                        "latitude": "41.92975000",
                        "longitude": "-88.86092000"
                    },
                    {
                        "id": 121114,
                        "name": "Manhattan",
                        "latitude": "41.42253000",
                        "longitude": "-87.98589000"
                    },
                    {
                        "id": 121124,
                        "name": "Manito",
                        "latitude": "40.42587000",
                        "longitude": "-89.77928000"
                    },
                    {
                        "id": 121155,
                        "name": "Manteno",
                        "latitude": "41.25059000",
                        "longitude": "-87.83143000"
                    },
                    {
                        "id": 121170,
                        "name": "Maple Park",
                        "latitude": "41.90753000",
                        "longitude": "-88.59925000"
                    },
                    {
                        "id": 121202,
                        "name": "Marengo",
                        "latitude": "42.24863000",
                        "longitude": "-88.60843000"
                    },
                    {
                        "id": 121233,
                        "name": "Marion",
                        "latitude": "37.73061000",
                        "longitude": "-88.93313000"
                    },
                    {
                        "id": 121251,
                        "name": "Marion County",
                        "latitude": "38.64959000",
                        "longitude": "-88.91897000"
                    },
                    {
                        "id": 121266,
                        "name": "Marissa",
                        "latitude": "38.25005000",
                        "longitude": "-89.75010000"
                    },
                    {
                        "id": 121270,
                        "name": "Markham",
                        "latitude": "41.59365000",
                        "longitude": "-87.69477000"
                    },
                    {
                        "id": 121291,
                        "name": "Maroa",
                        "latitude": "40.03643000",
                        "longitude": "-88.95703000"
                    },
                    {
                        "id": 121295,
                        "name": "Marquette Heights",
                        "latitude": "40.61754000",
                        "longitude": "-89.60038000"
                    },
                    {
                        "id": 121300,
                        "name": "Marseilles",
                        "latitude": "41.33087000",
                        "longitude": "-88.70813000"
                    },
                    {
                        "id": 121302,
                        "name": "Marshall",
                        "latitude": "39.39143000",
                        "longitude": "-87.69364000"
                    },
                    {
                        "id": 121318,
                        "name": "Marshall County",
                        "latitude": "41.03317000",
                        "longitude": "-89.34478000"
                    },
                    {
                        "id": 121349,
                        "name": "Martinsville",
                        "latitude": "39.33559000",
                        "longitude": "-87.88198000"
                    },
                    {
                        "id": 121363,
                        "name": "Maryville",
                        "latitude": "38.72366000",
                        "longitude": "-89.95593000"
                    },
                    {
                        "id": 121369,
                        "name": "Mascoutah",
                        "latitude": "38.49033000",
                        "longitude": "-89.79315000"
                    },
                    {
                        "id": 121376,
                        "name": "Mason City",
                        "latitude": "40.20227000",
                        "longitude": "-89.69816000"
                    },
                    {
                        "id": 121380,
                        "name": "Mason County",
                        "latitude": "40.23965000",
                        "longitude": "-89.91678000"
                    },
                    {
                        "id": 121388,
                        "name": "Massac County",
                        "latitude": "37.21903000",
                        "longitude": "-88.70774000"
                    },
                    {
                        "id": 121411,
                        "name": "Matteson",
                        "latitude": "41.50392000",
                        "longitude": "-87.71310000"
                    },
                    {
                        "id": 121414,
                        "name": "Mattoon",
                        "latitude": "39.48309000",
                        "longitude": "-88.37283000"
                    },
                    {
                        "id": 121457,
                        "name": "Maywood",
                        "latitude": "41.87920000",
                        "longitude": "-87.84312000"
                    },
                    {
                        "id": 121489,
                        "name": "McCullom Lake",
                        "latitude": "42.36835000",
                        "longitude": "-88.29259000"
                    },
                    {
                        "id": 121494,
                        "name": "McDonough County",
                        "latitude": "40.45621000",
                        "longitude": "-90.67791000"
                    },
                    {
                        "id": 121508,
                        "name": "McHenry",
                        "latitude": "42.33335000",
                        "longitude": "-88.26675000"
                    },
                    {
                        "id": 121509,
                        "name": "McHenry County",
                        "latitude": "42.32439000",
                        "longitude": "-88.45245000"
                    },
                    {
                        "id": 121523,
                        "name": "McKinley Park",
                        "latitude": "41.83170000",
                        "longitude": "-87.67366000"
                    },
                    {
                        "id": 121529,
                        "name": "McLean County",
                        "latitude": "40.49089000",
                        "longitude": "-88.84732000"
                    },
                    {
                        "id": 121531,
                        "name": "McLeansboro",
                        "latitude": "38.09338000",
                        "longitude": "-88.53561000"
                    },
                    {
                        "id": 121632,
                        "name": "Melrose Park",
                        "latitude": "41.90059000",
                        "longitude": "-87.85673000"
                    },
                    {
                        "id": 121648,
                        "name": "Menard County",
                        "latitude": "40.02740000",
                        "longitude": "-89.80217000"
                    },
                    {
                        "id": 121656,
                        "name": "Mendota",
                        "latitude": "41.54725000",
                        "longitude": "-89.11759000"
                    },
                    {
                        "id": 121677,
                        "name": "Mercer County",
                        "latitude": "41.20534000",
                        "longitude": "-90.74141000"
                    },
                    {
                        "id": 121688,
                        "name": "Meredosia",
                        "latitude": "39.83116000",
                        "longitude": "-90.55957000"
                    },
                    {
                        "id": 121713,
                        "name": "Merrionette Park",
                        "latitude": "41.68420000",
                        "longitude": "-87.70033000"
                    },
                    {
                        "id": 121731,
                        "name": "Metamora",
                        "latitude": "40.79059000",
                        "longitude": "-89.36064000"
                    },
                    {
                        "id": 121736,
                        "name": "Metropolis",
                        "latitude": "37.15117000",
                        "longitude": "-88.73200000"
                    },
                    {
                        "id": 121808,
                        "name": "Midlothian",
                        "latitude": "41.62531000",
                        "longitude": "-87.71755000"
                    },
                    {
                        "id": 121837,
                        "name": "Milan",
                        "latitude": "41.45309000",
                        "longitude": "-90.57208000"
                    },
                    {
                        "id": 121851,
                        "name": "Milford",
                        "latitude": "40.62837000",
                        "longitude": "-87.69614000"
                    },
                    {
                        "id": 121901,
                        "name": "Millstadt",
                        "latitude": "38.46144000",
                        "longitude": "-90.09178000"
                    },
                    {
                        "id": 121948,
                        "name": "Minier",
                        "latitude": "40.43365000",
                        "longitude": "-89.31315000"
                    },
                    {
                        "id": 121961,
                        "name": "Minonk",
                        "latitude": "40.90448000",
                        "longitude": "-89.03452000"
                    },
                    {
                        "id": 121962,
                        "name": "Minooka",
                        "latitude": "41.45531000",
                        "longitude": "-88.26173000"
                    },
                    {
                        "id": 121995,
                        "name": "Mitchell",
                        "latitude": "38.76199000",
                        "longitude": "-90.08538000"
                    },
                    {
                        "id": 122024,
                        "name": "Mokena",
                        "latitude": "41.52614000",
                        "longitude": "-87.88922000"
                    },
                    {
                        "id": 122027,
                        "name": "Moline",
                        "latitude": "41.50670000",
                        "longitude": "-90.51513000"
                    },
                    {
                        "id": 122030,
                        "name": "Momence",
                        "latitude": "41.16670000",
                        "longitude": "-87.66281000"
                    },
                    {
                        "id": 122037,
                        "name": "Monee",
                        "latitude": "41.42003000",
                        "longitude": "-87.74171000"
                    },
                    {
                        "id": 122042,
                        "name": "Monmouth",
                        "latitude": "40.91143000",
                        "longitude": "-90.64736000"
                    },
                    {
                        "id": 122071,
                        "name": "Monroe County",
                        "latitude": "38.27865000",
                        "longitude": "-90.17738000"
                    },
                    {
                        "id": 122133,
                        "name": "Montgomery",
                        "latitude": "41.73058000",
                        "longitude": "-88.34590000"
                    },
                    {
                        "id": 122142,
                        "name": "Montgomery County",
                        "latitude": "39.23104000",
                        "longitude": "-89.47887000"
                    },
                    {
                        "id": 122166,
                        "name": "Monticello",
                        "latitude": "40.02781000",
                        "longitude": "-88.57340000"
                    },
                    {
                        "id": 122238,
                        "name": "Morgan County",
                        "latitude": "39.71556000",
                        "longitude": "-90.20150000"
                    },
                    {
                        "id": 122247,
                        "name": "Morgan Park",
                        "latitude": "41.69031000",
                        "longitude": "-87.66672000"
                    },
                    {
                        "id": 122267,
                        "name": "Morris",
                        "latitude": "41.35725000",
                        "longitude": "-88.42118000"
                    },
                    {
                        "id": 122276,
                        "name": "Morrison",
                        "latitude": "41.80975000",
                        "longitude": "-89.96512000"
                    },
                    {
                        "id": 122278,
                        "name": "Morrisonville",
                        "latitude": "39.42005000",
                        "longitude": "-89.45565000"
                    },
                    {
                        "id": 122293,
                        "name": "Morton",
                        "latitude": "40.61282000",
                        "longitude": "-89.45926000"
                    },
                    {
                        "id": 122298,
                        "name": "Morton Grove",
                        "latitude": "42.04059000",
                        "longitude": "-87.78256000"
                    },
                    {
                        "id": 122317,
                        "name": "Moultrie County",
                        "latitude": "39.64148000",
                        "longitude": "-88.61930000"
                    },
                    {
                        "id": 122320,
                        "name": "Mound City",
                        "latitude": "37.08533000",
                        "longitude": "-89.16257000"
                    },
                    {
                        "id": 122335,
                        "name": "Mount Carmel",
                        "latitude": "38.41088000",
                        "longitude": "-87.76142000"
                    },
                    {
                        "id": 122338,
                        "name": "Mount Carroll",
                        "latitude": "42.09502000",
                        "longitude": "-89.97818000"
                    },
                    {
                        "id": 122345,
                        "name": "Mount Greenwood",
                        "latitude": "41.69809000",
                        "longitude": "-87.70866000"
                    },
                    {
                        "id": 122363,
                        "name": "Mount Morris",
                        "latitude": "42.05031000",
                        "longitude": "-89.43122000"
                    },
                    {
                        "id": 122368,
                        "name": "Mount Olive",
                        "latitude": "39.07227000",
                        "longitude": "-89.72731000"
                    },
                    {
                        "id": 122385,
                        "name": "Mount Prospect",
                        "latitude": "42.06642000",
                        "longitude": "-87.93729000"
                    },
                    {
                        "id": 122386,
                        "name": "Mount Pulaski",
                        "latitude": "40.01088000",
                        "longitude": "-89.28231000"
                    },
                    {
                        "id": 122390,
                        "name": "Mount Sterling",
                        "latitude": "39.98727000",
                        "longitude": "-90.76346000"
                    },
                    {
                        "id": 122396,
                        "name": "Mount Vernon",
                        "latitude": "38.31727000",
                        "longitude": "-88.90312000"
                    },
                    {
                        "id": 122409,
                        "name": "Mount Zion",
                        "latitude": "39.77143000",
                        "longitude": "-88.87424000"
                    },
                    {
                        "id": 122444,
                        "name": "Moweaqua",
                        "latitude": "39.62476000",
                        "longitude": "-89.01897000"
                    },
                    {
                        "id": 122468,
                        "name": "Mundelein",
                        "latitude": "42.26308000",
                        "longitude": "-88.00397000"
                    },
                    {
                        "id": 122490,
                        "name": "Murphysboro",
                        "latitude": "37.76450000",
                        "longitude": "-89.33509000"
                    },
                    {
                        "id": 122550,
                        "name": "Naperville",
                        "latitude": "41.78586000",
                        "longitude": "-88.14729000"
                    },
                    {
                        "id": 122574,
                        "name": "Nashville",
                        "latitude": "38.34366000",
                        "longitude": "-89.38064000"
                    },
                    {
                        "id": 122596,
                        "name": "Nauvoo",
                        "latitude": "40.55004000",
                        "longitude": "-91.38487000"
                    },
                    {
                        "id": 122607,
                        "name": "Near North Side",
                        "latitude": "41.90003000",
                        "longitude": "-87.63450000"
                    },
                    {
                        "id": 122608,
                        "name": "Near South Side",
                        "latitude": "41.85670000",
                        "longitude": "-87.62477000"
                    },
                    {
                        "id": 122632,
                        "name": "Neoga",
                        "latitude": "39.31948000",
                        "longitude": "-88.45283000"
                    },
                    {
                        "id": 122656,
                        "name": "New Athens",
                        "latitude": "38.32644000",
                        "longitude": "-89.87705000"
                    },
                    {
                        "id": 122658,
                        "name": "New Baden",
                        "latitude": "38.53505000",
                        "longitude": "-89.70065000"
                    },
                    {
                        "id": 122663,
                        "name": "New Berlin",
                        "latitude": "39.72533000",
                        "longitude": "-89.91066000"
                    },
                    {
                        "id": 122694,
                        "name": "New City",
                        "latitude": "41.80753000",
                        "longitude": "-87.65644000"
                    },
                    {
                        "id": 122737,
                        "name": "New Lenox",
                        "latitude": "41.51198000",
                        "longitude": "-87.96561000"
                    },
                    {
                        "id": 122802,
                        "name": "Newark",
                        "latitude": "41.53697000",
                        "longitude": "-88.58341000"
                    },
                    {
                        "id": 122864,
                        "name": "Newton",
                        "latitude": "38.99088000",
                        "longitude": "-88.16254000"
                    },
                    {
                        "id": 122900,
                        "name": "Niles",
                        "latitude": "42.01892000",
                        "longitude": "-87.80284000"
                    },
                    {
                        "id": 122930,
                        "name": "Nokomis",
                        "latitude": "39.30116000",
                        "longitude": "-89.28508000"
                    },
                    {
                        "id": 122948,
                        "name": "Normal",
                        "latitude": "40.51420000",
                        "longitude": "-88.99063000"
                    },
                    {
                        "id": 122953,
                        "name": "Norridge",
                        "latitude": "41.96336000",
                        "longitude": "-87.82728000"
                    },
                    {
                        "id": 122956,
                        "name": "Norris City",
                        "latitude": "37.98116000",
                        "longitude": "-88.32921000"
                    },
                    {
                        "id": 122970,
                        "name": "North Aurora",
                        "latitude": "41.80614000",
                        "longitude": "-88.32730000"
                    },
                    {
                        "id": 122973,
                        "name": "North Barrington",
                        "latitude": "42.20780000",
                        "longitude": "-88.14063000"
                    },
                    {
                        "id": 123003,
                        "name": "North Center",
                        "latitude": "41.95392000",
                        "longitude": "-87.67895000"
                    },
                    {
                        "id": 123006,
                        "name": "North Chicago",
                        "latitude": "42.32558000",
                        "longitude": "-87.84118000"
                    },
                    {
                        "id": 123055,
                        "name": "North Lawndale",
                        "latitude": "41.86003000",
                        "longitude": "-87.71839000"
                    },
                    {
                        "id": 123077,
                        "name": "North Pekin",
                        "latitude": "40.61504000",
                        "longitude": "-89.62232000"
                    },
                    {
                        "id": 123079,
                        "name": "North Peoria",
                        "latitude": "40.71754000",
                        "longitude": "-89.58426000"
                    },
                    {
                        "id": 123096,
                        "name": "North Riverside",
                        "latitude": "41.84281000",
                        "longitude": "-87.82311000"
                    },
                    {
                        "id": 123141,
                        "name": "Northbrook",
                        "latitude": "42.12753000",
                        "longitude": "-87.82895000"
                    },
                    {
                        "id": 123151,
                        "name": "Northfield",
                        "latitude": "42.09975000",
                        "longitude": "-87.78090000"
                    },
                    {
                        "id": 123158,
                        "name": "Northlake",
                        "latitude": "41.91725000",
                        "longitude": "-87.89562000"
                    },
                    {
                        "id": 123226,
                        "name": "O'Fallon",
                        "latitude": "38.59227000",
                        "longitude": "-89.91121000"
                    },
                    {
                        "id": 123230,
                        "name": "Oak Brook",
                        "latitude": "41.83281000",
                        "longitude": "-87.92895000"
                    },
                    {
                        "id": 123233,
                        "name": "Oak Forest",
                        "latitude": "41.60281000",
                        "longitude": "-87.74394000"
                    },
                    {
                        "id": 123252,
                        "name": "Oak Lawn",
                        "latitude": "41.71087000",
                        "longitude": "-87.75811000"
                    },
                    {
                        "id": 123255,
                        "name": "Oak Park",
                        "latitude": "41.88503000",
                        "longitude": "-87.78450000"
                    },
                    {
                        "id": 123269,
                        "name": "Oakbrook Terrace",
                        "latitude": "41.85003000",
                        "longitude": "-87.96451000"
                    },
                    {
                        "id": 123309,
                        "name": "Oakwood",
                        "latitude": "40.11615000",
                        "longitude": "-87.77836000"
                    },
                    {
                        "id": 123312,
                        "name": "Oakwood Hills",
                        "latitude": "42.24641000",
                        "longitude": "-88.24286000"
                    },
                    {
                        "id": 123319,
                        "name": "Oblong",
                        "latitude": "39.00199000",
                        "longitude": "-87.90892000"
                    },
                    {
                        "id": 123361,
                        "name": "Odin",
                        "latitude": "38.61727000",
                        "longitude": "-89.05229000"
                    },
                    {
                        "id": 123376,
                        "name": "Ogle County",
                        "latitude": "42.04264000",
                        "longitude": "-89.32065000"
                    },
                    {
                        "id": 123377,
                        "name": "Oglesby",
                        "latitude": "41.29531000",
                        "longitude": "-89.05953000"
                    },
                    {
                        "id": 123397,
                        "name": "Okawville",
                        "latitude": "38.43422000",
                        "longitude": "-89.55037000"
                    },
                    {
                        "id": 123455,
                        "name": "Olney",
                        "latitude": "38.73088000",
                        "longitude": "-88.08532000"
                    },
                    {
                        "id": 123460,
                        "name": "Olympia Fields",
                        "latitude": "41.51337000",
                        "longitude": "-87.67421000"
                    },
                    {
                        "id": 123470,
                        "name": "Onarga",
                        "latitude": "40.71504000",
                        "longitude": "-88.00615000"
                    },
                    {
                        "id": 123500,
                        "name": "Oquawka",
                        "latitude": "40.93198000",
                        "longitude": "-90.94709000"
                    },
                    {
                        "id": 123546,
                        "name": "Oregon",
                        "latitude": "42.01475000",
                        "longitude": "-89.33233000"
                    },
                    {
                        "id": 123556,
                        "name": "Orion",
                        "latitude": "41.35476000",
                        "longitude": "-90.38152000"
                    },
                    {
                        "id": 123560,
                        "name": "Orland Hills",
                        "latitude": "41.58531000",
                        "longitude": "-87.84311000"
                    },
                    {
                        "id": 123561,
                        "name": "Orland Park",
                        "latitude": "41.63031000",
                        "longitude": "-87.85394000"
                    },
                    {
                        "id": 123622,
                        "name": "Oswego",
                        "latitude": "41.68281000",
                        "longitude": "-88.35146000"
                    },
                    {
                        "id": 123637,
                        "name": "Ottawa",
                        "latitude": "41.34559000",
                        "longitude": "-88.84258000"
                    },
                    {
                        "id": 123731,
                        "name": "Palatine",
                        "latitude": "42.11030000",
                        "longitude": "-88.03424000"
                    },
                    {
                        "id": 123736,
                        "name": "Palestine",
                        "latitude": "39.00365000",
                        "longitude": "-87.61280000"
                    },
                    {
                        "id": 123788,
                        "name": "Palos Heights",
                        "latitude": "41.66809000",
                        "longitude": "-87.79644000"
                    },
                    {
                        "id": 123789,
                        "name": "Palos Hills",
                        "latitude": "41.69670000",
                        "longitude": "-87.81700000"
                    },
                    {
                        "id": 123790,
                        "name": "Palos Park",
                        "latitude": "41.66725000",
                        "longitude": "-87.83033000"
                    },
                    {
                        "id": 123796,
                        "name": "Pana",
                        "latitude": "39.38893000",
                        "longitude": "-89.08008000"
                    },
                    {
                        "id": 123830,
                        "name": "Paris",
                        "latitude": "39.61115000",
                        "longitude": "-87.69614000"
                    },
                    {
                        "id": 123839,
                        "name": "Park City",
                        "latitude": "42.34836000",
                        "longitude": "-87.88424000"
                    },
                    {
                        "id": 123845,
                        "name": "Park Forest",
                        "latitude": "41.49142000",
                        "longitude": "-87.67449000"
                    },
                    {
                        "id": 123851,
                        "name": "Park Ridge",
                        "latitude": "42.01114000",
                        "longitude": "-87.84062000"
                    },
                    {
                        "id": 123933,
                        "name": "Pawnee",
                        "latitude": "39.59172000",
                        "longitude": "-89.58037000"
                    },
                    {
                        "id": 123941,
                        "name": "Paxton",
                        "latitude": "40.46031000",
                        "longitude": "-88.09532000"
                    },
                    {
                        "id": 123948,
                        "name": "Payson",
                        "latitude": "39.81699000",
                        "longitude": "-91.24237000"
                    },
                    {
                        "id": 123978,
                        "name": "Pecatonica",
                        "latitude": "42.31391000",
                        "longitude": "-89.35928000"
                    },
                    {
                        "id": 123986,
                        "name": "Pekin",
                        "latitude": "40.56754000",
                        "longitude": "-89.64066000"
                    },
                    {
                        "id": 124046,
                        "name": "Peoria",
                        "latitude": "40.69365000",
                        "longitude": "-89.58899000"
                    },
                    {
                        "id": 124048,
                        "name": "Peoria County",
                        "latitude": "40.78808000",
                        "longitude": "-89.75999000"
                    },
                    {
                        "id": 124049,
                        "name": "Peoria Heights",
                        "latitude": "40.74726000",
                        "longitude": "-89.57398000"
                    },
                    {
                        "id": 124051,
                        "name": "Peotone",
                        "latitude": "41.33226000",
                        "longitude": "-87.78532000"
                    },
                    {
                        "id": 124076,
                        "name": "Perry County",
                        "latitude": "38.08376000",
                        "longitude": "-89.36702000"
                    },
                    {
                        "id": 124095,
                        "name": "Peru",
                        "latitude": "41.32753000",
                        "longitude": "-89.12897000"
                    },
                    {
                        "id": 124106,
                        "name": "Petersburg",
                        "latitude": "40.01172000",
                        "longitude": "-89.84817000"
                    },
                    {
                        "id": 124143,
                        "name": "Philo",
                        "latitude": "40.00698000",
                        "longitude": "-88.15810000"
                    },
                    {
                        "id": 124146,
                        "name": "Phoenix",
                        "latitude": "41.61115000",
                        "longitude": "-87.63477000"
                    },
                    {
                        "id": 124152,
                        "name": "Piatt County",
                        "latitude": "40.01037000",
                        "longitude": "-88.59109000"
                    },
                    {
                        "id": 124188,
                        "name": "Pike County",
                        "latitude": "39.62250000",
                        "longitude": "-90.88629000"
                    },
                    {
                        "id": 124210,
                        "name": "Pinckneyville",
                        "latitude": "38.08033000",
                        "longitude": "-89.38203000"
                    },
                    {
                        "id": 124269,
                        "name": "Pingree Grove",
                        "latitude": "42.06864000",
                        "longitude": "-88.41342000"
                    },
                    {
                        "id": 124284,
                        "name": "Pistakee Highlands",
                        "latitude": "42.40863000",
                        "longitude": "-88.20648000"
                    },
                    {
                        "id": 124297,
                        "name": "Pittsfield",
                        "latitude": "39.60783000",
                        "longitude": "-90.80513000"
                    },
                    {
                        "id": 124320,
                        "name": "Plainfield",
                        "latitude": "41.62697000",
                        "longitude": "-88.20395000"
                    },
                    {
                        "id": 124344,
                        "name": "Plano",
                        "latitude": "41.66281000",
                        "longitude": "-88.53702000"
                    },
                    {
                        "id": 124454,
                        "name": "Polo",
                        "latitude": "41.98614000",
                        "longitude": "-89.57928000"
                    },
                    {
                        "id": 124473,
                        "name": "Pontiac",
                        "latitude": "40.88087000",
                        "longitude": "-88.62978000"
                    },
                    {
                        "id": 124475,
                        "name": "Pontoon Beach",
                        "latitude": "38.73172000",
                        "longitude": "-90.08038000"
                    },
                    {
                        "id": 124482,
                        "name": "Pope County",
                        "latitude": "37.41276000",
                        "longitude": "-88.56158000"
                    },
                    {
                        "id": 124485,
                        "name": "Poplar Grove",
                        "latitude": "42.36835000",
                        "longitude": "-88.82205000"
                    },
                    {
                        "id": 124498,
                        "name": "Port Barrington",
                        "latitude": "42.24252000",
                        "longitude": "-88.20203000"
                    },
                    {
                        "id": 124499,
                        "name": "Port Byron",
                        "latitude": "41.60642000",
                        "longitude": "-90.33541000"
                    },
                    {
                        "id": 124548,
                        "name": "Portage Park",
                        "latitude": "41.95781000",
                        "longitude": "-87.76506000"
                    },
                    {
                        "id": 124573,
                        "name": "Posen",
                        "latitude": "41.63170000",
                        "longitude": "-87.68144000"
                    },
                    {
                        "id": 124628,
                        "name": "Prairie Grove",
                        "latitude": "42.27863000",
                        "longitude": "-88.26092000"
                    },
                    {
                        "id": 124652,
                        "name": "Prestbury",
                        "latitude": "41.78329000",
                        "longitude": "-88.41764000"
                    },
                    {
                        "id": 124660,
                        "name": "Preston Heights",
                        "latitude": "41.49170000",
                        "longitude": "-88.08172000"
                    },
                    {
                        "id": 124686,
                        "name": "Princeton",
                        "latitude": "41.36809000",
                        "longitude": "-89.46481000"
                    },
                    {
                        "id": 124695,
                        "name": "Princeville",
                        "latitude": "40.92976000",
                        "longitude": "-89.75760000"
                    },
                    {
                        "id": 124704,
                        "name": "Prophetstown",
                        "latitude": "41.67142000",
                        "longitude": "-89.93622000"
                    },
                    {
                        "id": 124708,
                        "name": "Prospect Heights",
                        "latitude": "42.09530000",
                        "longitude": "-87.93757000"
                    },
                    {
                        "id": 124739,
                        "name": "Pulaski County",
                        "latitude": "37.22291000",
                        "longitude": "-89.12657000"
                    },
                    {
                        "id": 124766,
                        "name": "Putnam County",
                        "latitude": "41.20447000",
                        "longitude": "-89.28583000"
                    },
                    {
                        "id": 124796,
                        "name": "Quincy",
                        "latitude": "39.93560000",
                        "longitude": "-91.40987000"
                    },
                    {
                        "id": 124840,
                        "name": "Ramsey",
                        "latitude": "39.14449000",
                        "longitude": "-89.10868000"
                    },
                    {
                        "id": 124875,
                        "name": "Randolph County",
                        "latitude": "38.05212000",
                        "longitude": "-89.82531000"
                    },
                    {
                        "id": 124891,
                        "name": "Rantoul",
                        "latitude": "40.30837000",
                        "longitude": "-88.15588000"
                    },
                    {
                        "id": 124942,
                        "name": "Red Bud",
                        "latitude": "38.21172000",
                        "longitude": "-89.99427000"
                    },
                    {
                        "id": 125074,
                        "name": "Richland County",
                        "latitude": "38.71236000",
                        "longitude": "-88.08510000"
                    },
                    {
                        "id": 125089,
                        "name": "Richmond",
                        "latitude": "42.47585000",
                        "longitude": "-88.30593000"
                    },
                    {
                        "id": 125108,
                        "name": "Richton Park",
                        "latitude": "41.48448000",
                        "longitude": "-87.70338000"
                    },
                    {
                        "id": 125179,
                        "name": "River Forest",
                        "latitude": "41.89781000",
                        "longitude": "-87.81395000"
                    },
                    {
                        "id": 125180,
                        "name": "River Grove",
                        "latitude": "41.92586000",
                        "longitude": "-87.83589000"
                    },
                    {
                        "id": 125193,
                        "name": "Riverdale",
                        "latitude": "41.63337000",
                        "longitude": "-87.63310000"
                    },
                    {
                        "id": 125206,
                        "name": "Riverside",
                        "latitude": "41.83503000",
                        "longitude": "-87.82284000"
                    },
                    {
                        "id": 125211,
                        "name": "Riverton",
                        "latitude": "39.84422000",
                        "longitude": "-89.53954000"
                    },
                    {
                        "id": 125220,
                        "name": "Riverwoods",
                        "latitude": "42.16753000",
                        "longitude": "-87.89701000"
                    },
                    {
                        "id": 125229,
                        "name": "Roanoke",
                        "latitude": "40.79615000",
                        "longitude": "-89.19730000"
                    },
                    {
                        "id": 125235,
                        "name": "Robbins",
                        "latitude": "41.64392000",
                        "longitude": "-87.70366000"
                    },
                    {
                        "id": 125253,
                        "name": "Robinson",
                        "latitude": "39.00532000",
                        "longitude": "-87.73919000"
                    },
                    {
                        "id": 125259,
                        "name": "Rochelle",
                        "latitude": "41.92392000",
                        "longitude": "-89.06871000"
                    },
                    {
                        "id": 125261,
                        "name": "Rochester",
                        "latitude": "39.74949000",
                        "longitude": "-89.53176000"
                    },
                    {
                        "id": 125277,
                        "name": "Rock Falls",
                        "latitude": "41.77975000",
                        "longitude": "-89.68900000"
                    },
                    {
                        "id": 125283,
                        "name": "Rock Island",
                        "latitude": "41.50948000",
                        "longitude": "-90.57875000"
                    },
                    {
                        "id": 125284,
                        "name": "Rock Island County",
                        "latitude": "41.46733000",
                        "longitude": "-90.56743000"
                    },
                    {
                        "id": 125296,
                        "name": "Rockdale",
                        "latitude": "41.50614000",
                        "longitude": "-88.11450000"
                    },
                    {
                        "id": 125300,
                        "name": "Rockford",
                        "latitude": "42.27113000",
                        "longitude": "-89.09400000"
                    },
                    {
                        "id": 125320,
                        "name": "Rockton",
                        "latitude": "42.45252000",
                        "longitude": "-89.07233000"
                    },
                    {
                        "id": 125353,
                        "name": "Rogers Park",
                        "latitude": "42.00864000",
                        "longitude": "-87.66672000"
                    },
                    {
                        "id": 125368,
                        "name": "Rolling Meadows",
                        "latitude": "42.08419000",
                        "longitude": "-88.01313000"
                    },
                    {
                        "id": 125376,
                        "name": "Rome",
                        "latitude": "40.88309000",
                        "longitude": "-89.50259000"
                    },
                    {
                        "id": 125382,
                        "name": "Romeoville",
                        "latitude": "41.64753000",
                        "longitude": "-88.08951000"
                    },
                    {
                        "id": 125389,
                        "name": "Roodhouse",
                        "latitude": "39.48394000",
                        "longitude": "-90.37151000"
                    },
                    {
                        "id": 125399,
                        "name": "Roscoe",
                        "latitude": "42.41335000",
                        "longitude": "-89.00927000"
                    },
                    {
                        "id": 125426,
                        "name": "Roselle",
                        "latitude": "41.98475000",
                        "longitude": "-88.07979000"
                    },
                    {
                        "id": 125430,
                        "name": "Rosemont",
                        "latitude": "41.99531000",
                        "longitude": "-87.88451000"
                    },
                    {
                        "id": 125442,
                        "name": "Rosewood Heights",
                        "latitude": "38.88783000",
                        "longitude": "-90.08483000"
                    },
                    {
                        "id": 125444,
                        "name": "Rosiclare",
                        "latitude": "37.42366000",
                        "longitude": "-88.34615000"
                    },
                    {
                        "id": 125459,
                        "name": "Rossville",
                        "latitude": "40.37920000",
                        "longitude": "-87.66863000"
                    },
                    {
                        "id": 125469,
                        "name": "Round Lake",
                        "latitude": "42.35336000",
                        "longitude": "-88.09341000"
                    },
                    {
                        "id": 125470,
                        "name": "Round Lake Beach",
                        "latitude": "42.37169000",
                        "longitude": "-88.09008000"
                    },
                    {
                        "id": 125471,
                        "name": "Round Lake Heights",
                        "latitude": "42.38002000",
                        "longitude": "-88.10425000"
                    },
                    {
                        "id": 125472,
                        "name": "Round Lake Park",
                        "latitude": "42.35697000",
                        "longitude": "-88.07675000"
                    },
                    {
                        "id": 125483,
                        "name": "Roxana",
                        "latitude": "38.84838000",
                        "longitude": "-90.07622000"
                    },
                    {
                        "id": 125495,
                        "name": "Royalton",
                        "latitude": "37.87699000",
                        "longitude": "-89.11452000"
                    },
                    {
                        "id": 125526,
                        "name": "Rushville",
                        "latitude": "40.12116000",
                        "longitude": "-90.56318000"
                    },
                    {
                        "id": 125599,
                        "name": "Saint Anne",
                        "latitude": "41.02503000",
                        "longitude": "-87.71392000"
                    },
                    {
                        "id": 125613,
                        "name": "Saint Charles",
                        "latitude": "41.91419000",
                        "longitude": "-88.30869000"
                    },
                    {
                        "id": 125622,
                        "name": "Saint Clair County",
                        "latitude": "38.47031000",
                        "longitude": "-89.92841000"
                    },
                    {
                        "id": 125632,
                        "name": "Saint Elmo",
                        "latitude": "39.02727000",
                        "longitude": "-88.84811000"
                    },
                    {
                        "id": 125651,
                        "name": "Saint Jacob",
                        "latitude": "38.71394000",
                        "longitude": "-89.76815000"
                    },
                    {
                        "id": 125672,
                        "name": "Saint Joseph",
                        "latitude": "40.11170000",
                        "longitude": "-88.04170000"
                    },
                    {
                        "id": 125728,
                        "name": "Salem",
                        "latitude": "38.62699000",
                        "longitude": "-88.94562000"
                    },
                    {
                        "id": 125750,
                        "name": "Saline County",
                        "latitude": "37.75318000",
                        "longitude": "-88.54080000"
                    },
                    {
                        "id": 125868,
                        "name": "Sandoval",
                        "latitude": "38.61560000",
                        "longitude": "-89.11423000"
                    },
                    {
                        "id": 125876,
                        "name": "Sandwich",
                        "latitude": "41.64586000",
                        "longitude": "-88.62174000"
                    },
                    {
                        "id": 125889,
                        "name": "Sangamon County",
                        "latitude": "39.75817000",
                        "longitude": "-89.65890000"
                    },
                    {
                        "id": 125966,
                        "name": "Sauk Village",
                        "latitude": "41.48837000",
                        "longitude": "-87.56754000"
                    },
                    {
                        "id": 125973,
                        "name": "Savanna",
                        "latitude": "42.09447000",
                        "longitude": "-90.15679000"
                    },
                    {
                        "id": 125978,
                        "name": "Savoy",
                        "latitude": "40.05475000",
                        "longitude": "-88.25172000"
                    },
                    {
                        "id": 126002,
                        "name": "Schaumburg",
                        "latitude": "42.03336000",
                        "longitude": "-88.08341000"
                    },
                    {
                        "id": 126007,
                        "name": "Schiller Park",
                        "latitude": "41.95586000",
                        "longitude": "-87.87090000"
                    },
                    {
                        "id": 126022,
                        "name": "Schuyler County",
                        "latitude": "40.15803000",
                        "longitude": "-90.61507000"
                    },
                    {
                        "id": 126040,
                        "name": "Scott Air Force Base",
                        "latitude": "38.54270000",
                        "longitude": "-89.85035000"
                    },
                    {
                        "id": 126044,
                        "name": "Scott County",
                        "latitude": "39.64414000",
                        "longitude": "-90.47470000"
                    },
                    {
                        "id": 126157,
                        "name": "Seneca",
                        "latitude": "41.31114000",
                        "longitude": "-88.60979000"
                    },
                    {
                        "id": 126168,
                        "name": "Sesser",
                        "latitude": "38.09172000",
                        "longitude": "-89.05035000"
                    },
                    {
                        "id": 126253,
                        "name": "Shawneetown",
                        "latitude": "37.71310000",
                        "longitude": "-88.18670000"
                    },
                    {
                        "id": 126273,
                        "name": "Shelby County",
                        "latitude": "39.39116000",
                        "longitude": "-88.80554000"
                    },
                    {
                        "id": 126281,
                        "name": "Shelbyville",
                        "latitude": "39.40643000",
                        "longitude": "-88.79007000"
                    },
                    {
                        "id": 126287,
                        "name": "Sheldon",
                        "latitude": "40.76920000",
                        "longitude": "-87.56392000"
                    },
                    {
                        "id": 126319,
                        "name": "Sheridan",
                        "latitude": "41.53003000",
                        "longitude": "-88.67980000"
                    },
                    {
                        "id": 126329,
                        "name": "Sherman",
                        "latitude": "39.89366000",
                        "longitude": "-89.60482000"
                    },
                    {
                        "id": 126348,
                        "name": "Shiloh",
                        "latitude": "38.56144000",
                        "longitude": "-89.89732000"
                    },
                    {
                        "id": 126370,
                        "name": "Shorewood",
                        "latitude": "41.52003000",
                        "longitude": "-88.20173000"
                    },
                    {
                        "id": 126395,
                        "name": "Sidney",
                        "latitude": "40.02503000",
                        "longitude": "-88.07337000"
                    },
                    {
                        "id": 126444,
                        "name": "Silvis",
                        "latitude": "41.51226000",
                        "longitude": "-90.41513000"
                    },
                    {
                        "id": 126483,
                        "name": "Skokie",
                        "latitude": "42.03336000",
                        "longitude": "-87.73339000"
                    },
                    {
                        "id": 126497,
                        "name": "Sleepy Hollow",
                        "latitude": "42.09419000",
                        "longitude": "-88.30258000"
                    },
                    {
                        "id": 126525,
                        "name": "Smithton",
                        "latitude": "38.40866000",
                        "longitude": "-89.99205000"
                    },
                    {
                        "id": 126597,
                        "name": "Somonauk",
                        "latitude": "41.63364000",
                        "longitude": "-88.68119000"
                    },
                    {
                        "id": 126617,
                        "name": "South Barrington",
                        "latitude": "42.09142000",
                        "longitude": "-88.12174000"
                    },
                    {
                        "id": 126623,
                        "name": "South Beloit",
                        "latitude": "42.49307000",
                        "longitude": "-89.03678000"
                    },
                    {
                        "id": 126637,
                        "name": "South Chicago",
                        "latitude": "41.73977000",
                        "longitude": "-87.55425000"
                    },
                    {
                        "id": 126638,
                        "name": "South Chicago Heights",
                        "latitude": "41.48087000",
                        "longitude": "-87.63782000"
                    },
                    {
                        "id": 126651,
                        "name": "South Elgin",
                        "latitude": "41.99419000",
                        "longitude": "-88.29230000"
                    },
                    {
                        "id": 126674,
                        "name": "South Holland",
                        "latitude": "41.60087000",
                        "longitude": "-87.60699000"
                    },
                    {
                        "id": 126679,
                        "name": "South Jacksonville",
                        "latitude": "39.70866000",
                        "longitude": "-90.22818000"
                    },
                    {
                        "id": 126687,
                        "name": "South Lawndale",
                        "latitude": "41.84364000",
                        "longitude": "-87.71255000"
                    },
                    {
                        "id": 126709,
                        "name": "South Pekin",
                        "latitude": "40.49448000",
                        "longitude": "-89.65177000"
                    },
                    {
                        "id": 126720,
                        "name": "South Roxana",
                        "latitude": "38.82949000",
                        "longitude": "-90.06288000"
                    },
                    {
                        "id": 126729,
                        "name": "South Shore",
                        "latitude": "41.76198000",
                        "longitude": "-87.57783000"
                    },
                    {
                        "id": 126771,
                        "name": "Southern View",
                        "latitude": "39.75727000",
                        "longitude": "-89.65371000"
                    },
                    {
                        "id": 126806,
                        "name": "Sparta",
                        "latitude": "38.12311000",
                        "longitude": "-89.70177000"
                    },
                    {
                        "id": 126858,
                        "name": "Spring Grove",
                        "latitude": "42.44363000",
                        "longitude": "-88.23648000"
                    },
                    {
                        "id": 126875,
                        "name": "Spring Valley",
                        "latitude": "41.32754000",
                        "longitude": "-89.19981000"
                    },
                    {
                        "id": 126890,
                        "name": "Springfield",
                        "latitude": "39.80172000",
                        "longitude": "-89.64371000"
                    },
                    {
                        "id": 126984,
                        "name": "Stark County",
                        "latitude": "41.09336000",
                        "longitude": "-89.79749000"
                    },
                    {
                        "id": 127000,
                        "name": "Staunton",
                        "latitude": "39.01227000",
                        "longitude": "-89.79121000"
                    },
                    {
                        "id": 127012,
                        "name": "Steeleville",
                        "latitude": "38.00727000",
                        "longitude": "-89.65843000"
                    },
                    {
                        "id": 127016,
                        "name": "Steger",
                        "latitude": "41.47003000",
                        "longitude": "-87.63643000"
                    },
                    {
                        "id": 127024,
                        "name": "Stephenson County",
                        "latitude": "42.35175000",
                        "longitude": "-89.66235000"
                    },
                    {
                        "id": 127029,
                        "name": "Sterling",
                        "latitude": "41.78864000",
                        "longitude": "-89.69622000"
                    },
                    {
                        "id": 127056,
                        "name": "Stickney",
                        "latitude": "41.82142000",
                        "longitude": "-87.78283000"
                    },
                    {
                        "id": 127059,
                        "name": "Stillman Valley",
                        "latitude": "42.10725000",
                        "longitude": "-89.17927000"
                    },
                    {
                        "id": 127073,
                        "name": "Stockton",
                        "latitude": "42.34974000",
                        "longitude": "-90.00679000"
                    },
                    {
                        "id": 127084,
                        "name": "Stone Park",
                        "latitude": "41.90559000",
                        "longitude": "-87.88367000"
                    },
                    {
                        "id": 127135,
                        "name": "Streamwood",
                        "latitude": "42.02558000",
                        "longitude": "-88.17841000"
                    },
                    {
                        "id": 127136,
                        "name": "Streator",
                        "latitude": "41.12087000",
                        "longitude": "-88.83535000"
                    },
                    {
                        "id": 127171,
                        "name": "Sugar Grove",
                        "latitude": "41.76142000",
                        "longitude": "-88.44369000"
                    },
                    {
                        "id": 127181,
                        "name": "Sullivan",
                        "latitude": "39.59948000",
                        "longitude": "-88.60784000"
                    },
                    {
                        "id": 127212,
                        "name": "Summit",
                        "latitude": "41.78809000",
                        "longitude": "-87.81033000"
                    },
                    {
                        "id": 127221,
                        "name": "Sumner",
                        "latitude": "38.71699000",
                        "longitude": "-87.86142000"
                    },
                    {
                        "id": 127325,
                        "name": "Swansea",
                        "latitude": "38.53394000",
                        "longitude": "-89.98899000"
                    },
                    {
                        "id": 127351,
                        "name": "Sycamore",
                        "latitude": "41.98892000",
                        "longitude": "-88.68675000"
                    },
                    {
                        "id": 127467,
                        "name": "Taylorville",
                        "latitude": "39.54894000",
                        "longitude": "-89.29453000"
                    },
                    {
                        "id": 127471,
                        "name": "Tazewell County",
                        "latitude": "40.50752000",
                        "longitude": "-89.51342000"
                    },
                    {
                        "id": 127540,
                        "name": "Teutopolis",
                        "latitude": "39.13310000",
                        "longitude": "-88.47199000"
                    },
                    {
                        "id": 127558,
                        "name": "The Galena Territory",
                        "latitude": "42.39343000",
                        "longitude": "-90.32582000"
                    },
                    {
                        "id": 127577,
                        "name": "Third Lake",
                        "latitude": "42.37391000",
                        "longitude": "-88.01091000"
                    },
                    {
                        "id": 127582,
                        "name": "Thomasboro",
                        "latitude": "40.24170000",
                        "longitude": "-88.18421000"
                    },
                    {
                        "id": 127601,
                        "name": "Thornton",
                        "latitude": "41.56809000",
                        "longitude": "-87.60810000"
                    },
                    {
                        "id": 127653,
                        "name": "Tilton",
                        "latitude": "40.09531000",
                        "longitude": "-87.64752000"
                    },
                    {
                        "id": 127666,
                        "name": "Tinley Park",
                        "latitude": "41.57337000",
                        "longitude": "-87.78449000"
                    },
                    {
                        "id": 127698,
                        "name": "Toledo",
                        "latitude": "39.27365000",
                        "longitude": "-88.24365000"
                    },
                    {
                        "id": 127704,
                        "name": "Tolono",
                        "latitude": "39.98614000",
                        "longitude": "-88.25894000"
                    },
                    {
                        "id": 127705,
                        "name": "Toluca",
                        "latitude": "41.00226000",
                        "longitude": "-89.13342000"
                    },
                    {
                        "id": 127749,
                        "name": "Toulon",
                        "latitude": "41.09365000",
                        "longitude": "-89.86483000"
                    },
                    {
                        "id": 127755,
                        "name": "Tower Lake",
                        "latitude": "42.23197000",
                        "longitude": "-88.15202000"
                    },
                    {
                        "id": 127793,
                        "name": "Tremont",
                        "latitude": "40.52754000",
                        "longitude": "-89.49260000"
                    },
                    {
                        "id": 127803,
                        "name": "Trenton",
                        "latitude": "38.60560000",
                        "longitude": "-89.68204000"
                    },
                    {
                        "id": 127843,
                        "name": "Troy",
                        "latitude": "38.72921000",
                        "longitude": "-89.88315000"
                    },
                    {
                        "id": 127911,
                        "name": "Tuscola",
                        "latitude": "39.79920000",
                        "longitude": "-88.28310000"
                    },
                    {
                        "id": 127926,
                        "name": "Twin Grove",
                        "latitude": "40.49337000",
                        "longitude": "-89.07980000"
                    },
                    {
                        "id": 127991,
                        "name": "Union County",
                        "latitude": "37.47123000",
                        "longitude": "-89.25509000"
                    },
                    {
                        "id": 128035,
                        "name": "University Park",
                        "latitude": "41.44298000",
                        "longitude": "-87.68360000"
                    },
                    {
                        "id": 128040,
                        "name": "Upper Alton",
                        "latitude": "38.91144000",
                        "longitude": "-90.15066000"
                    },
                    {
                        "id": 128058,
                        "name": "Uptown",
                        "latitude": "41.96590000",
                        "longitude": "-87.65262000"
                    },
                    {
                        "id": 128062,
                        "name": "Urbana",
                        "latitude": "40.11059000",
                        "longitude": "-88.20727000"
                    },
                    {
                        "id": 128119,
                        "name": "Valmeyer",
                        "latitude": "38.30561000",
                        "longitude": "-90.27651000"
                    },
                    {
                        "id": 128145,
                        "name": "Vandalia",
                        "latitude": "38.96060000",
                        "longitude": "-89.09368000"
                    },
                    {
                        "id": 128169,
                        "name": "Venetian Village",
                        "latitude": "42.39863000",
                        "longitude": "-88.05258000"
                    },
                    {
                        "id": 128171,
                        "name": "Venice",
                        "latitude": "38.67227000",
                        "longitude": "-90.16983000"
                    },
                    {
                        "id": 128183,
                        "name": "Vermilion County",
                        "latitude": "40.18342000",
                        "longitude": "-87.73283000"
                    },
                    {
                        "id": 128194,
                        "name": "Vernon Hills",
                        "latitude": "42.21947000",
                        "longitude": "-87.97952000"
                    },
                    {
                        "id": 128231,
                        "name": "Vienna",
                        "latitude": "37.41533000",
                        "longitude": "-88.89784000"
                    },
                    {
                        "id": 128241,
                        "name": "Villa Grove",
                        "latitude": "39.86281000",
                        "longitude": "-88.16227000"
                    },
                    {
                        "id": 128243,
                        "name": "Villa Park",
                        "latitude": "41.88975000",
                        "longitude": "-87.98895000"
                    },
                    {
                        "id": 128252,
                        "name": "Village of Campton Hills",
                        "latitude": "41.93660000",
                        "longitude": "-88.39750000"
                    },
                    {
                        "id": 128285,
                        "name": "Virden",
                        "latitude": "39.50089000",
                        "longitude": "-89.76787000"
                    },
                    {
                        "id": 128286,
                        "name": "Virginia",
                        "latitude": "39.95116000",
                        "longitude": "-90.21234000"
                    },
                    {
                        "id": 128302,
                        "name": "Volo",
                        "latitude": "42.32613000",
                        "longitude": "-88.16786000"
                    },
                    {
                        "id": 128310,
                        "name": "Wabash County",
                        "latitude": "38.44607000",
                        "longitude": "-87.84425000"
                    },
                    {
                        "id": 128326,
                        "name": "Wadsworth",
                        "latitude": "42.42863000",
                        "longitude": "-87.92397000"
                    },
                    {
                        "id": 128413,
                        "name": "Walnut",
                        "latitude": "41.55670000",
                        "longitude": "-89.59343000"
                    },
                    {
                        "id": 128443,
                        "name": "Wamac",
                        "latitude": "38.50894000",
                        "longitude": "-89.14063000"
                    },
                    {
                        "id": 128479,
                        "name": "Warren",
                        "latitude": "42.49640000",
                        "longitude": "-89.98957000"
                    },
                    {
                        "id": 128494,
                        "name": "Warren County",
                        "latitude": "40.84883000",
                        "longitude": "-90.61503000"
                    },
                    {
                        "id": 128501,
                        "name": "Warrensburg",
                        "latitude": "39.93282000",
                        "longitude": "-89.06203000"
                    },
                    {
                        "id": 128510,
                        "name": "Warrenville",
                        "latitude": "41.81781000",
                        "longitude": "-88.17340000"
                    },
                    {
                        "id": 128519,
                        "name": "Warsaw",
                        "latitude": "40.35921000",
                        "longitude": "-91.43460000"
                    },
                    {
                        "id": 128527,
                        "name": "Wasco",
                        "latitude": "41.93808000",
                        "longitude": "-88.40452000"
                    },
                    {
                        "id": 128533,
                        "name": "Washburn",
                        "latitude": "40.91920000",
                        "longitude": "-89.29120000"
                    },
                    {
                        "id": 128546,
                        "name": "Washington",
                        "latitude": "40.70365000",
                        "longitude": "-89.40731000"
                    },
                    {
                        "id": 128556,
                        "name": "Washington County",
                        "latitude": "38.35217000",
                        "longitude": "-89.41045000"
                    },
                    {
                        "id": 128585,
                        "name": "Washington Park",
                        "latitude": "38.63505000",
                        "longitude": "-90.09289000"
                    },
                    {
                        "id": 128611,
                        "name": "Waterloo",
                        "latitude": "38.33589000",
                        "longitude": "-90.14983000"
                    },
                    {
                        "id": 128617,
                        "name": "Waterman",
                        "latitude": "41.77170000",
                        "longitude": "-88.77369000"
                    },
                    {
                        "id": 128638,
                        "name": "Watseka",
                        "latitude": "40.77615000",
                        "longitude": "-87.73642000"
                    },
                    {
                        "id": 128646,
                        "name": "Wauconda",
                        "latitude": "42.25891000",
                        "longitude": "-88.13925000"
                    },
                    {
                        "id": 128648,
                        "name": "Waukegan",
                        "latitude": "42.36363000",
                        "longitude": "-87.84479000"
                    },
                    {
                        "id": 128665,
                        "name": "Waverly",
                        "latitude": "39.59172000",
                        "longitude": "-89.95288000"
                    },
                    {
                        "id": 128682,
                        "name": "Wayne",
                        "latitude": "41.95086000",
                        "longitude": "-88.24230000"
                    },
                    {
                        "id": 128688,
                        "name": "Wayne City",
                        "latitude": "38.34533000",
                        "longitude": "-88.58783000"
                    },
                    {
                        "id": 128690,
                        "name": "Wayne County",
                        "latitude": "38.42956000",
                        "longitude": "-88.42561000"
                    },
                    {
                        "id": 128846,
                        "name": "West Chicago",
                        "latitude": "41.88475000",
                        "longitude": "-88.20396000"
                    },
                    {
                        "id": 128858,
                        "name": "West Dundee",
                        "latitude": "42.09808000",
                        "longitude": "-88.28286000"
                    },
                    {
                        "id": 128862,
                        "name": "West Elsdon",
                        "latitude": "41.79392000",
                        "longitude": "-87.72450000"
                    },
                    {
                        "id": 128865,
                        "name": "West Englewood",
                        "latitude": "41.77809000",
                        "longitude": "-87.66672000"
                    },
                    {
                        "id": 128873,
                        "name": "West Frankfort",
                        "latitude": "37.89783000",
                        "longitude": "-88.93146000"
                    },
                    {
                        "id": 128875,
                        "name": "West Garfield Park",
                        "latitude": "41.88059000",
                        "longitude": "-87.72922000"
                    },
                    {
                        "id": 128913,
                        "name": "West Lawn",
                        "latitude": "41.77281000",
                        "longitude": "-87.72227000"
                    },
                    {
                        "id": 128953,
                        "name": "West Peoria",
                        "latitude": "40.69254000",
                        "longitude": "-89.62788000"
                    },
                    {
                        "id": 128969,
                        "name": "West Ridge",
                        "latitude": "41.99975000",
                        "longitude": "-87.69284000"
                    },
                    {
                        "id": 128992,
                        "name": "West Town",
                        "latitude": "41.89381000",
                        "longitude": "-87.67493000"
                    },
                    {
                        "id": 129019,
                        "name": "Westchester",
                        "latitude": "41.85059000",
                        "longitude": "-87.88200000"
                    },
                    {
                        "id": 129025,
                        "name": "Western Springs",
                        "latitude": "41.80975000",
                        "longitude": "-87.90062000"
                    },
                    {
                        "id": 129049,
                        "name": "Westmont",
                        "latitude": "41.79586000",
                        "longitude": "-87.97562000"
                    },
                    {
                        "id": 129078,
                        "name": "Westville",
                        "latitude": "40.04226000",
                        "longitude": "-87.63863000"
                    },
                    {
                        "id": 129113,
                        "name": "Wheaton",
                        "latitude": "41.86614000",
                        "longitude": "-88.10701000"
                    },
                    {
                        "id": 129120,
                        "name": "Wheeling",
                        "latitude": "42.13919000",
                        "longitude": "-87.92896000"
                    },
                    {
                        "id": 129136,
                        "name": "White County",
                        "latitude": "38.08748000",
                        "longitude": "-88.17957000"
                    },
                    {
                        "id": 129140,
                        "name": "White Hall",
                        "latitude": "39.43699000",
                        "longitude": "-90.40318000"
                    },
                    {
                        "id": 129186,
                        "name": "Whiteside County",
                        "latitude": "41.75626000",
                        "longitude": "-89.91409000"
                    },
                    {
                        "id": 129253,
                        "name": "Will County",
                        "latitude": "41.44503000",
                        "longitude": "-87.97866000"
                    },
                    {
                        "id": 129276,
                        "name": "Williamson County",
                        "latitude": "37.73025000",
                        "longitude": "-88.92994000"
                    },
                    {
                        "id": 129291,
                        "name": "Williamsville",
                        "latitude": "39.95422000",
                        "longitude": "-89.54871000"
                    },
                    {
                        "id": 129310,
                        "name": "Willow Springs",
                        "latitude": "41.74087000",
                        "longitude": "-87.86033000"
                    },
                    {
                        "id": 129313,
                        "name": "Willowbrook",
                        "latitude": "41.76975000",
                        "longitude": "-87.93589000"
                    },
                    {
                        "id": 129320,
                        "name": "Wilmette",
                        "latitude": "42.07225000",
                        "longitude": "-87.72284000"
                    },
                    {
                        "id": 129323,
                        "name": "Wilmington",
                        "latitude": "41.30781000",
                        "longitude": "-88.14672000"
                    },
                    {
                        "id": 129352,
                        "name": "Winchester",
                        "latitude": "39.62977000",
                        "longitude": "-90.45624000"
                    },
                    {
                        "id": 129377,
                        "name": "Windsor",
                        "latitude": "39.44087000",
                        "longitude": "-88.59478000"
                    },
                    {
                        "id": 129397,
                        "name": "Winfield",
                        "latitude": "41.86170000",
                        "longitude": "-88.16090000"
                    },
                    {
                        "id": 129405,
                        "name": "Winnebago",
                        "latitude": "42.26613000",
                        "longitude": "-89.24122000"
                    },
                    {
                        "id": 129408,
                        "name": "Winnebago County",
                        "latitude": "42.33626000",
                        "longitude": "-89.16085000"
                    },
                    {
                        "id": 129414,
                        "name": "Winnetka",
                        "latitude": "42.10808000",
                        "longitude": "-87.73590000"
                    },
                    {
                        "id": 129452,
                        "name": "Winthrop Harbor",
                        "latitude": "42.47891000",
                        "longitude": "-87.82368000"
                    },
                    {
                        "id": 129483,
                        "name": "Wonder Lake",
                        "latitude": "42.38530000",
                        "longitude": "-88.34731000"
                    },
                    {
                        "id": 129487,
                        "name": "Wood Dale",
                        "latitude": "41.96336000",
                        "longitude": "-87.97896000"
                    },
                    {
                        "id": 129488,
                        "name": "Wood River",
                        "latitude": "38.86116000",
                        "longitude": "-90.09761000"
                    },
                    {
                        "id": 129520,
                        "name": "Woodford County",
                        "latitude": "40.78823000",
                        "longitude": "-89.21114000"
                    },
                    {
                        "id": 129536,
                        "name": "Woodlawn",
                        "latitude": "41.77948000",
                        "longitude": "-87.59949000"
                    },
                    {
                        "id": 129545,
                        "name": "Woodridge",
                        "latitude": "41.74697000",
                        "longitude": "-88.05034000"
                    },
                    {
                        "id": 129563,
                        "name": "Woodstock",
                        "latitude": "42.31474000",
                        "longitude": "-88.44870000"
                    },
                    {
                        "id": 129588,
                        "name": "Worden",
                        "latitude": "38.93144000",
                        "longitude": "-89.83899000"
                    },
                    {
                        "id": 129591,
                        "name": "Worth",
                        "latitude": "41.68975000",
                        "longitude": "-87.79728000"
                    },
                    {
                        "id": 129635,
                        "name": "Wyoming",
                        "latitude": "41.06170000",
                        "longitude": "-89.77316000"
                    },
                    {
                        "id": 129709,
                        "name": "Yorkville",
                        "latitude": "41.64114000",
                        "longitude": "-88.44729000"
                    },
                    {
                        "id": 129745,
                        "name": "Zeigler",
                        "latitude": "37.89949000",
                        "longitude": "-89.05202000"
                    },
                    {
                        "id": 129757,
                        "name": "Zion",
                        "latitude": "42.44613000",
                        "longitude": "-87.83285000"
                    }
                ]
            },
            {
                "id": 1440,
                "name": "Indiana",
                "iso2": "IN",
                "latitude": "40.26719410",
                "longitude": "-86.13490190",
                "type": "state",
                "cities": [
                    {
                        "id": 110976,
                        "name": "Aberdeen",
                        "latitude": "41.43893000",
                        "longitude": "-87.11142000"
                    },
                    {
                        "id": 111021,
                        "name": "Adams County",
                        "latitude": "40.74566000",
                        "longitude": "-84.93665000"
                    },
                    {
                        "id": 111077,
                        "name": "Akron",
                        "latitude": "41.03838000",
                        "longitude": "-86.02805000"
                    },
                    {
                        "id": 111105,
                        "name": "Albany",
                        "latitude": "40.30088000",
                        "longitude": "-85.24191000"
                    },
                    {
                        "id": 111124,
                        "name": "Albion",
                        "latitude": "41.39560000",
                        "longitude": "-85.42442000"
                    },
                    {
                        "id": 111153,
                        "name": "Alexandria",
                        "latitude": "40.26282000",
                        "longitude": "-85.67581000"
                    },
                    {
                        "id": 111190,
                        "name": "Allen County",
                        "latitude": "41.09087000",
                        "longitude": "-85.06656000"
                    },
                    {
                        "id": 111313,
                        "name": "Anderson",
                        "latitude": "40.10532000",
                        "longitude": "-85.68025000"
                    },
                    {
                        "id": 111330,
                        "name": "Andrews",
                        "latitude": "40.86254000",
                        "longitude": "-85.60165000"
                    },
                    {
                        "id": 111340,
                        "name": "Angola",
                        "latitude": "41.63477000",
                        "longitude": "-84.99941000"
                    },
                    {
                        "id": 111423,
                        "name": "Arcadia",
                        "latitude": "40.17587000",
                        "longitude": "-86.02165000"
                    },
                    {
                        "id": 111449,
                        "name": "Argos",
                        "latitude": "41.23780000",
                        "longitude": "-86.21465000"
                    },
                    {
                        "id": 111609,
                        "name": "Attica",
                        "latitude": "40.29420000",
                        "longitude": "-87.24890000"
                    },
                    {
                        "id": 111625,
                        "name": "Auburn",
                        "latitude": "41.36699000",
                        "longitude": "-85.05886000"
                    },
                    {
                        "id": 111656,
                        "name": "Aurora",
                        "latitude": "39.05700000",
                        "longitude": "-84.90134000"
                    },
                    {
                        "id": 111667,
                        "name": "Austin",
                        "latitude": "38.75839000",
                        "longitude": "-85.80803000"
                    },
                    {
                        "id": 111684,
                        "name": "Avilla",
                        "latitude": "41.36588000",
                        "longitude": "-85.23886000"
                    },
                    {
                        "id": 111690,
                        "name": "Avon",
                        "latitude": "39.76282000",
                        "longitude": "-86.39972000"
                    },
                    {
                        "id": 111822,
                        "name": "Bargersville",
                        "latitude": "39.52088000",
                        "longitude": "-86.16777000"
                    },
                    {
                        "id": 111859,
                        "name": "Bartholomew County",
                        "latitude": "39.20597000",
                        "longitude": "-85.89760000"
                    },
                    {
                        "id": 111880,
                        "name": "Bass Lake",
                        "latitude": "41.20726000",
                        "longitude": "-86.60196000"
                    },
                    {
                        "id": 111893,
                        "name": "Batesville",
                        "latitude": "39.30005000",
                        "longitude": "-85.22218000"
                    },
                    {
                        "id": 111906,
                        "name": "Battle Ground",
                        "latitude": "40.50837000",
                        "longitude": "-86.84168000"
                    },
                    {
                        "id": 112018,
                        "name": "Bedford",
                        "latitude": "38.86116000",
                        "longitude": "-86.48721000"
                    },
                    {
                        "id": 112037,
                        "name": "Beech Grove",
                        "latitude": "39.72199000",
                        "longitude": "-86.08998000"
                    },
                    {
                        "id": 112204,
                        "name": "Benton County",
                        "latitude": "40.60626000",
                        "longitude": "-87.31091000"
                    },
                    {
                        "id": 112246,
                        "name": "Berne",
                        "latitude": "40.65782000",
                        "longitude": "-84.95191000"
                    },
                    {
                        "id": 112311,
                        "name": "Bicknell",
                        "latitude": "38.77421000",
                        "longitude": "-87.30779000"
                    },
                    {
                        "id": 112386,
                        "name": "Blackford County",
                        "latitude": "40.47360000",
                        "longitude": "-85.32482000"
                    },
                    {
                        "id": 112434,
                        "name": "Bloomfield",
                        "latitude": "39.02699000",
                        "longitude": "-86.93751000"
                    },
                    {
                        "id": 112449,
                        "name": "Bloomington",
                        "latitude": "39.16533000",
                        "longitude": "-86.52639000"
                    },
                    {
                        "id": 112484,
                        "name": "Bluffton",
                        "latitude": "40.73866000",
                        "longitude": "-85.17164000"
                    },
                    {
                        "id": 112560,
                        "name": "Boone County",
                        "latitude": "40.05080000",
                        "longitude": "-86.46870000"
                    },
                    {
                        "id": 112567,
                        "name": "Boonville",
                        "latitude": "38.04921000",
                        "longitude": "-87.27417000"
                    },
                    {
                        "id": 112612,
                        "name": "Bourbon",
                        "latitude": "41.29560000",
                        "longitude": "-86.11639000"
                    },
                    {
                        "id": 112703,
                        "name": "Brazil",
                        "latitude": "39.52365000",
                        "longitude": "-87.12502000"
                    },
                    {
                        "id": 112721,
                        "name": "Bremen",
                        "latitude": "41.44644000",
                        "longitude": "-86.14806000"
                    },
                    {
                        "id": 112785,
                        "name": "Bright",
                        "latitude": "39.21839000",
                        "longitude": "-84.85606000"
                    },
                    {
                        "id": 112805,
                        "name": "Bristol",
                        "latitude": "41.72144000",
                        "longitude": "-85.81749000"
                    },
                    {
                        "id": 112822,
                        "name": "Broad Ripple",
                        "latitude": "39.86671000",
                        "longitude": "-86.14165000"
                    },
                    {
                        "id": 112869,
                        "name": "Brooklyn",
                        "latitude": "39.53921000",
                        "longitude": "-86.36916000"
                    },
                    {
                        "id": 112889,
                        "name": "Brookston",
                        "latitude": "40.60281000",
                        "longitude": "-86.86723000"
                    },
                    {
                        "id": 112894,
                        "name": "Brookville",
                        "latitude": "39.42311000",
                        "longitude": "-85.01274000"
                    },
                    {
                        "id": 112908,
                        "name": "Brown County",
                        "latitude": "39.19621000",
                        "longitude": "-86.22737000"
                    },
                    {
                        "id": 112924,
                        "name": "Brownsburg",
                        "latitude": "39.84338000",
                        "longitude": "-86.39777000"
                    },
                    {
                        "id": 112926,
                        "name": "Brownstown",
                        "latitude": "38.87894000",
                        "longitude": "-86.04192000"
                    },
                    {
                        "id": 113089,
                        "name": "Burns Harbor",
                        "latitude": "41.62587000",
                        "longitude": "-87.13337000"
                    },
                    {
                        "id": 113109,
                        "name": "Butler",
                        "latitude": "41.42977000",
                        "longitude": "-84.87135000"
                    },
                    {
                        "id": 113257,
                        "name": "Cambridge City",
                        "latitude": "39.81255000",
                        "longitude": "-85.17163000"
                    },
                    {
                        "id": 113330,
                        "name": "Cannelton",
                        "latitude": "37.91144000",
                        "longitude": "-86.74443000"
                    },
                    {
                        "id": 113416,
                        "name": "Carmel",
                        "latitude": "39.97837000",
                        "longitude": "-86.11804000"
                    },
                    {
                        "id": 113460,
                        "name": "Carroll County",
                        "latitude": "40.58286000",
                        "longitude": "-86.56348000"
                    },
                    {
                        "id": 113530,
                        "name": "Cass County",
                        "latitude": "40.76149000",
                        "longitude": "-86.34595000"
                    },
                    {
                        "id": 113593,
                        "name": "Cayuga",
                        "latitude": "39.94865000",
                        "longitude": "-87.45974000"
                    },
                    {
                        "id": 113617,
                        "name": "Cedar Lake",
                        "latitude": "41.36476000",
                        "longitude": "-87.44115000"
                    },
                    {
                        "id": 113653,
                        "name": "Centerville",
                        "latitude": "39.81782000",
                        "longitude": "-84.99635000"
                    },
                    {
                        "id": 113728,
                        "name": "Chandler",
                        "latitude": "38.04171000",
                        "longitude": "-87.36806000"
                    },
                    {
                        "id": 113770,
                        "name": "Charlestown",
                        "latitude": "38.45312000",
                        "longitude": "-85.67024000"
                    },
                    {
                        "id": 113903,
                        "name": "Chesterfield",
                        "latitude": "40.11254000",
                        "longitude": "-85.59692000"
                    },
                    {
                        "id": 113909,
                        "name": "Chesterton",
                        "latitude": "41.61059000",
                        "longitude": "-87.06420000"
                    },
                    {
                        "id": 114015,
                        "name": "Churubusco",
                        "latitude": "41.23060000",
                        "longitude": "-85.31942000"
                    },
                    {
                        "id": 114020,
                        "name": "Cicero",
                        "latitude": "40.12393000",
                        "longitude": "-86.01332000"
                    },
                    {
                        "id": 114123,
                        "name": "Clark County",
                        "latitude": "38.47718000",
                        "longitude": "-85.70728000"
                    },
                    {
                        "id": 114153,
                        "name": "Clarksville",
                        "latitude": "38.29674000",
                        "longitude": "-85.75996000"
                    },
                    {
                        "id": 114178,
                        "name": "Clay County",
                        "latitude": "39.39273000",
                        "longitude": "-87.11576000"
                    },
                    {
                        "id": 114239,
                        "name": "Clermont",
                        "latitude": "39.80977000",
                        "longitude": "-86.32249000"
                    },
                    {
                        "id": 114268,
                        "name": "Clinton",
                        "latitude": "39.65698000",
                        "longitude": "-87.39807000"
                    },
                    {
                        "id": 114293,
                        "name": "Clinton County",
                        "latitude": "40.30169000",
                        "longitude": "-86.47516000"
                    },
                    {
                        "id": 114309,
                        "name": "Cloverdale",
                        "latitude": "39.51477000",
                        "longitude": "-86.79390000"
                    },
                    {
                        "id": 114475,
                        "name": "Columbia City",
                        "latitude": "41.15727000",
                        "longitude": "-85.48831000"
                    },
                    {
                        "id": 114490,
                        "name": "Columbus",
                        "latitude": "39.20144000",
                        "longitude": "-85.92138000"
                    },
                    {
                        "id": 114564,
                        "name": "Connersville",
                        "latitude": "39.64116000",
                        "longitude": "-85.14107000"
                    },
                    {
                        "id": 114579,
                        "name": "Converse",
                        "latitude": "40.57754000",
                        "longitude": "-85.87332000"
                    },
                    {
                        "id": 114641,
                        "name": "Cordry Sweetwater Lakes",
                        "latitude": "39.30464000",
                        "longitude": "-86.11837000"
                    },
                    {
                        "id": 114681,
                        "name": "Corydon",
                        "latitude": "38.21201000",
                        "longitude": "-86.12192000"
                    },
                    {
                        "id": 114723,
                        "name": "Country Squire Lakes",
                        "latitude": "39.03478000",
                        "longitude": "-85.69858000"
                    },
                    {
                        "id": 114740,
                        "name": "Covington",
                        "latitude": "40.14170000",
                        "longitude": "-87.39474000"
                    },
                    {
                        "id": 114777,
                        "name": "Crawford County",
                        "latitude": "38.29241000",
                        "longitude": "-86.45171000"
                    },
                    {
                        "id": 114784,
                        "name": "Crawfordsville",
                        "latitude": "40.04115000",
                        "longitude": "-86.87445000"
                    },
                    {
                        "id": 114858,
                        "name": "Crothersville",
                        "latitude": "38.80061000",
                        "longitude": "-85.84164000"
                    },
                    {
                        "id": 114867,
                        "name": "Crown Point",
                        "latitude": "41.41698000",
                        "longitude": "-87.36531000"
                    },
                    {
                        "id": 114902,
                        "name": "Culver",
                        "latitude": "41.21893000",
                        "longitude": "-86.42306000"
                    },
                    {
                        "id": 114905,
                        "name": "Cumberland",
                        "latitude": "39.77615000",
                        "longitude": "-85.95720000"
                    },
                    {
                        "id": 114979,
                        "name": "Dale",
                        "latitude": "38.16894000",
                        "longitude": "-86.99000000"
                    },
                    {
                        "id": 114985,
                        "name": "Daleville",
                        "latitude": "40.12115000",
                        "longitude": "-85.55803000"
                    },
                    {
                        "id": 115034,
                        "name": "Danville",
                        "latitude": "39.76060000",
                        "longitude": "-86.52639000"
                    },
                    {
                        "id": 115052,
                        "name": "Darmstadt",
                        "latitude": "38.09921000",
                        "longitude": "-87.57891000"
                    },
                    {
                        "id": 115069,
                        "name": "Daviess County",
                        "latitude": "38.70241000",
                        "longitude": "-87.07207000"
                    },
                    {
                        "id": 115095,
                        "name": "Dayton",
                        "latitude": "40.37420000",
                        "longitude": "-86.76890000"
                    },
                    {
                        "id": 115146,
                        "name": "Dearborn County",
                        "latitude": "39.14519000",
                        "longitude": "-84.97326000"
                    },
                    {
                        "id": 115156,
                        "name": "Decatur",
                        "latitude": "40.83060000",
                        "longitude": "-84.92913000"
                    },
                    {
                        "id": 115160,
                        "name": "Decatur County",
                        "latitude": "39.30700000",
                        "longitude": "-85.50114000"
                    },
                    {
                        "id": 115133,
                        "name": "DeKalb County",
                        "latitude": "41.39758000",
                        "longitude": "-84.99909000"
                    },
                    {
                        "id": 115206,
                        "name": "Delaware County",
                        "latitude": "40.22753000",
                        "longitude": "-85.39690000"
                    },
                    {
                        "id": 115220,
                        "name": "Delphi",
                        "latitude": "40.58754000",
                        "longitude": "-86.67501000"
                    },
                    {
                        "id": 115135,
                        "name": "DeMotte",
                        "latitude": "41.19504000",
                        "longitude": "-87.19864000"
                    },
                    {
                        "id": 115345,
                        "name": "Dillsboro",
                        "latitude": "39.01783000",
                        "longitude": "-85.05884000"
                    },
                    {
                        "id": 115498,
                        "name": "Dubois County",
                        "latitude": "38.36428000",
                        "longitude": "-86.87980000"
                    },
                    {
                        "id": 115538,
                        "name": "Dunkirk",
                        "latitude": "40.75643000",
                        "longitude": "-86.39361000"
                    },
                    {
                        "id": 115543,
                        "name": "Dunlap",
                        "latitude": "41.63783000",
                        "longitude": "-85.92166000"
                    },
                    {
                        "id": 115586,
                        "name": "Dyer",
                        "latitude": "41.49420000",
                        "longitude": "-87.52171000"
                    },
                    {
                        "id": 115645,
                        "name": "East Chicago",
                        "latitude": "41.63920000",
                        "longitude": "-87.45476000"
                    },
                    {
                        "id": 115801,
                        "name": "Eaton",
                        "latitude": "40.34032000",
                        "longitude": "-85.35080000"
                    },
                    {
                        "id": 115861,
                        "name": "Edgewood",
                        "latitude": "40.10337000",
                        "longitude": "-85.73414000"
                    },
                    {
                        "id": 115873,
                        "name": "Edinburgh",
                        "latitude": "39.35422000",
                        "longitude": "-85.96666000"
                    },
                    {
                        "id": 115998,
                        "name": "Elkhart",
                        "latitude": "41.68199000",
                        "longitude": "-85.97667000"
                    },
                    {
                        "id": 116000,
                        "name": "Elkhart County",
                        "latitude": "41.59738000",
                        "longitude": "-85.85876000"
                    },
                    {
                        "id": 116022,
                        "name": "Ellettsville",
                        "latitude": "39.23393000",
                        "longitude": "-86.62500000"
                    },
                    {
                        "id": 116079,
                        "name": "Elwood",
                        "latitude": "40.27698000",
                        "longitude": "-85.84192000"
                    },
                    {
                        "id": 116135,
                        "name": "English",
                        "latitude": "38.33450000",
                        "longitude": "-86.46415000"
                    },
                    {
                        "id": 116253,
                        "name": "Evansville",
                        "latitude": "37.97476000",
                        "longitude": "-87.55585000"
                    },
                    {
                        "id": 116323,
                        "name": "Fairfield Heights",
                        "latitude": "39.82861000",
                        "longitude": "-86.38224000"
                    },
                    {
                        "id": 116340,
                        "name": "Fairmount",
                        "latitude": "40.41532000",
                        "longitude": "-85.65053000"
                    },
                    {
                        "id": 116359,
                        "name": "Fairview Park",
                        "latitude": "39.68031000",
                        "longitude": "-87.41752000"
                    },
                    {
                        "id": 116405,
                        "name": "Farmersburg",
                        "latitude": "39.24865000",
                        "longitude": "-87.38196000"
                    },
                    {
                        "id": 116425,
                        "name": "Farmland",
                        "latitude": "40.18782000",
                        "longitude": "-85.12747000"
                    },
                    {
                        "id": 116446,
                        "name": "Fayette County",
                        "latitude": "39.64006000",
                        "longitude": "-85.17873000"
                    },
                    {
                        "id": 116477,
                        "name": "Ferdinand",
                        "latitude": "38.22394000",
                        "longitude": "-86.86222000"
                    },
                    {
                        "id": 116526,
                        "name": "Fish Lake",
                        "latitude": "41.56671000",
                        "longitude": "-86.55196000"
                    },
                    {
                        "id": 116529,
                        "name": "Fishers",
                        "latitude": "39.95559000",
                        "longitude": "-86.01387000"
                    },
                    {
                        "id": 116572,
                        "name": "Flora",
                        "latitude": "40.54726000",
                        "longitude": "-86.52444000"
                    },
                    {
                        "id": 116607,
                        "name": "Floyd County",
                        "latitude": "38.31891000",
                        "longitude": "-85.90687000"
                    },
                    {
                        "id": 116697,
                        "name": "Fort Branch",
                        "latitude": "38.25116000",
                        "longitude": "-87.58113000"
                    },
                    {
                        "id": 116763,
                        "name": "Fort Wayne",
                        "latitude": "41.13060000",
                        "longitude": "-85.12886000"
                    },
                    {
                        "id": 116769,
                        "name": "Fortville",
                        "latitude": "39.93226000",
                        "longitude": "-85.84804000"
                    },
                    {
                        "id": 116779,
                        "name": "Fountain County",
                        "latitude": "40.12087000",
                        "longitude": "-87.24199000"
                    },
                    {
                        "id": 116794,
                        "name": "Fowler",
                        "latitude": "40.61670000",
                        "longitude": "-87.32085000"
                    },
                    {
                        "id": 116820,
                        "name": "Frankfort",
                        "latitude": "40.27948000",
                        "longitude": "-86.51084000"
                    },
                    {
                        "id": 116833,
                        "name": "Franklin",
                        "latitude": "39.48061000",
                        "longitude": "-86.05499000"
                    },
                    {
                        "id": 116848,
                        "name": "Franklin County",
                        "latitude": "39.41486000",
                        "longitude": "-85.06028000"
                    },
                    {
                        "id": 116879,
                        "name": "Frankton",
                        "latitude": "40.22282000",
                        "longitude": "-85.77887000"
                    },
                    {
                        "id": 116920,
                        "name": "Fremont",
                        "latitude": "41.73088000",
                        "longitude": "-84.93274000"
                    },
                    {
                        "id": 116931,
                        "name": "French Lick",
                        "latitude": "38.54894000",
                        "longitude": "-86.61999000"
                    },
                    {
                        "id": 116996,
                        "name": "Fulton County",
                        "latitude": "41.04696000",
                        "longitude": "-86.26358000"
                    },
                    {
                        "id": 117021,
                        "name": "Galena",
                        "latitude": "38.35173000",
                        "longitude": "-85.94164000"
                    },
                    {
                        "id": 117043,
                        "name": "Galveston",
                        "latitude": "40.57893000",
                        "longitude": "-86.19027000"
                    },
                    {
                        "id": 117098,
                        "name": "Garrett",
                        "latitude": "41.34949000",
                        "longitude": "-85.13553000"
                    },
                    {
                        "id": 117106,
                        "name": "Gary",
                        "latitude": "41.59337000",
                        "longitude": "-87.34643000"
                    },
                    {
                        "id": 117109,
                        "name": "Gas City",
                        "latitude": "40.48726000",
                        "longitude": "-85.61303000"
                    },
                    {
                        "id": 117141,
                        "name": "Geneva",
                        "latitude": "40.59199000",
                        "longitude": "-84.95719000"
                    },
                    {
                        "id": 117163,
                        "name": "Georgetown",
                        "latitude": "40.74060000",
                        "longitude": "-86.50473000"
                    },
                    {
                        "id": 117189,
                        "name": "Gibson County",
                        "latitude": "38.31183000",
                        "longitude": "-87.58459000"
                    },
                    {
                        "id": 117384,
                        "name": "Goodland",
                        "latitude": "40.76337000",
                        "longitude": "-87.29363000"
                    },
                    {
                        "id": 117408,
                        "name": "Goshen",
                        "latitude": "41.58227000",
                        "longitude": "-85.83444000"
                    },
                    {
                        "id": 117424,
                        "name": "Grabill",
                        "latitude": "41.21088000",
                        "longitude": "-84.96691000"
                    },
                    {
                        "id": 117488,
                        "name": "Granger",
                        "latitude": "41.75338000",
                        "longitude": "-86.11084000"
                    },
                    {
                        "id": 117512,
                        "name": "Grant County",
                        "latitude": "40.51584000",
                        "longitude": "-85.65473000"
                    },
                    {
                        "id": 117624,
                        "name": "Greencastle",
                        "latitude": "39.64449000",
                        "longitude": "-86.86473000"
                    },
                    {
                        "id": 117626,
                        "name": "Greendale",
                        "latitude": "39.11256000",
                        "longitude": "-84.86412000"
                    },
                    {
                        "id": 117635,
                        "name": "Greene County",
                        "latitude": "39.03633000",
                        "longitude": "-86.96205000"
                    },
                    {
                        "id": 117646,
                        "name": "Greenfield",
                        "latitude": "39.78504000",
                        "longitude": "-85.76942000"
                    },
                    {
                        "id": 117669,
                        "name": "Greensburg",
                        "latitude": "39.33727000",
                        "longitude": "-85.48358000"
                    },
                    {
                        "id": 117674,
                        "name": "Greentown",
                        "latitude": "40.47809000",
                        "longitude": "-85.96665000"
                    },
                    {
                        "id": 117702,
                        "name": "Greenwood",
                        "latitude": "39.61366000",
                        "longitude": "-86.10665000"
                    },
                    {
                        "id": 117732,
                        "name": "Griffith",
                        "latitude": "41.52837000",
                        "longitude": "-87.42365000"
                    },
                    {
                        "id": 117741,
                        "name": "Grissom Air Force Base",
                        "latitude": "40.65753000",
                        "longitude": "-86.14755000"
                    },
                    {
                        "id": 117798,
                        "name": "Gulivoire Park",
                        "latitude": "41.61338000",
                        "longitude": "-86.24528000"
                    },
                    {
                        "id": 117837,
                        "name": "Hagerstown",
                        "latitude": "39.91116000",
                        "longitude": "-85.16163000"
                    },
                    {
                        "id": 117891,
                        "name": "Hamilton",
                        "latitude": "41.53366000",
                        "longitude": "-84.91274000"
                    },
                    {
                        "id": 117901,
                        "name": "Hamilton County",
                        "latitude": "40.07249000",
                        "longitude": "-86.05201000"
                    },
                    {
                        "id": 117913,
                        "name": "Hammond",
                        "latitude": "41.58337000",
                        "longitude": "-87.50004000"
                    },
                    {
                        "id": 117951,
                        "name": "Hancock County",
                        "latitude": "39.82355000",
                        "longitude": "-85.77324000"
                    },
                    {
                        "id": 117966,
                        "name": "Hanover",
                        "latitude": "38.71423000",
                        "longitude": "-85.47357000"
                    },
                    {
                        "id": 118017,
                        "name": "Harlan",
                        "latitude": "41.19616000",
                        "longitude": "-84.91969000"
                    },
                    {
                        "id": 118062,
                        "name": "Harrison County",
                        "latitude": "38.19512000",
                        "longitude": "-86.11131000"
                    },
                    {
                        "id": 118094,
                        "name": "Hartford City",
                        "latitude": "40.45115000",
                        "longitude": "-85.36997000"
                    },
                    {
                        "id": 118141,
                        "name": "Haubstadt",
                        "latitude": "38.20504000",
                        "longitude": "-87.57419000"
                    },
                    {
                        "id": 118235,
                        "name": "Hebron",
                        "latitude": "41.31865000",
                        "longitude": "-87.20031000"
                    },
                    {
                        "id": 118287,
                        "name": "Hendricks County",
                        "latitude": "39.76952000",
                        "longitude": "-86.50998000"
                    },
                    {
                        "id": 118299,
                        "name": "Henry County",
                        "latitude": "39.93104000",
                        "longitude": "-85.39644000"
                    },
                    {
                        "id": 118308,
                        "name": "Henryville",
                        "latitude": "38.54173000",
                        "longitude": "-85.76774000"
                    },
                    {
                        "id": 118320,
                        "name": "Heritage Lake",
                        "latitude": "39.72779000",
                        "longitude": "-86.71022000"
                    },
                    {
                        "id": 118379,
                        "name": "Hidden Valley",
                        "latitude": "39.16228000",
                        "longitude": "-84.84301000"
                    },
                    {
                        "id": 118396,
                        "name": "Highland",
                        "latitude": "41.55365000",
                        "longitude": "-87.45198000"
                    },
                    {
                        "id": 118497,
                        "name": "Hobart",
                        "latitude": "41.53226000",
                        "longitude": "-87.25504000"
                    },
                    {
                        "id": 118643,
                        "name": "Hope",
                        "latitude": "39.30394000",
                        "longitude": "-85.77137000"
                    },
                    {
                        "id": 118716,
                        "name": "Howard County",
                        "latitude": "40.48359000",
                        "longitude": "-86.11693000"
                    },
                    {
                        "id": 118751,
                        "name": "Hudson Lake",
                        "latitude": "41.71032000",
                        "longitude": "-86.53419000"
                    },
                    {
                        "id": 118793,
                        "name": "Huntertown",
                        "latitude": "41.22838000",
                        "longitude": "-85.17247000"
                    },
                    {
                        "id": 118794,
                        "name": "Huntingburg",
                        "latitude": "38.29894000",
                        "longitude": "-86.95500000"
                    },
                    {
                        "id": 118801,
                        "name": "Huntington",
                        "latitude": "40.88310000",
                        "longitude": "-85.49748000"
                    },
                    {
                        "id": 118806,
                        "name": "Huntington County",
                        "latitude": "40.82924000",
                        "longitude": "-85.48817000"
                    },
                    {
                        "id": 118905,
                        "name": "Indian Heights",
                        "latitude": "40.42726000",
                        "longitude": "-86.12555000"
                    },
                    {
                        "id": 118924,
                        "name": "Indianapolis",
                        "latitude": "39.76838000",
                        "longitude": "-86.15804000"
                    },
                    {
                        "id": 118933,
                        "name": "Ingalls",
                        "latitude": "39.95699000",
                        "longitude": "-85.80526000"
                    },
                    {
                        "id": 119080,
                        "name": "Jackson County",
                        "latitude": "38.90642000",
                        "longitude": "-86.03754000"
                    },
                    {
                        "id": 119137,
                        "name": "Jasonville",
                        "latitude": "39.16310000",
                        "longitude": "-87.19918000"
                    },
                    {
                        "id": 119141,
                        "name": "Jasper",
                        "latitude": "38.39144000",
                        "longitude": "-86.93111000"
                    },
                    {
                        "id": 119152,
                        "name": "Jasper County",
                        "latitude": "41.02300000",
                        "longitude": "-87.11612000"
                    },
                    {
                        "id": 119155,
                        "name": "Jay County",
                        "latitude": "40.43792000",
                        "longitude": "-85.00564000"
                    },
                    {
                        "id": 119180,
                        "name": "Jefferson County",
                        "latitude": "38.78582000",
                        "longitude": "-85.43857000"
                    },
                    {
                        "id": 119208,
                        "name": "Jeffersonville",
                        "latitude": "38.27757000",
                        "longitude": "-85.73718000"
                    },
                    {
                        "id": 119220,
                        "name": "Jennings County",
                        "latitude": "38.99693000",
                        "longitude": "-85.62806000"
                    },
                    {
                        "id": 119263,
                        "name": "Johnson County",
                        "latitude": "39.48997000",
                        "longitude": "-86.10164000"
                    },
                    {
                        "id": 119303,
                        "name": "Jonesboro",
                        "latitude": "40.47976000",
                        "longitude": "-85.62775000"
                    },
                    {
                        "id": 119451,
                        "name": "Kendallville",
                        "latitude": "41.44144000",
                        "longitude": "-85.26498000"
                    },
                    {
                        "id": 119496,
                        "name": "Kentland",
                        "latitude": "40.77032000",
                        "longitude": "-87.44530000"
                    },
                    {
                        "id": 119613,
                        "name": "Kingsford Heights",
                        "latitude": "41.48060000",
                        "longitude": "-86.69169000"
                    },
                    {
                        "id": 119676,
                        "name": "Knightstown",
                        "latitude": "39.79560000",
                        "longitude": "-85.52636000"
                    },
                    {
                        "id": 119682,
                        "name": "Knox",
                        "latitude": "41.29588000",
                        "longitude": "-86.62501000"
                    },
                    {
                        "id": 119685,
                        "name": "Knox County",
                        "latitude": "38.68909000",
                        "longitude": "-87.41801000"
                    },
                    {
                        "id": 119702,
                        "name": "Kokomo",
                        "latitude": "40.48643000",
                        "longitude": "-86.13360000"
                    },
                    {
                        "id": 119706,
                        "name": "Koontz Lake",
                        "latitude": "41.41810000",
                        "longitude": "-86.48585000"
                    },
                    {
                        "id": 119710,
                        "name": "Kosciusko County",
                        "latitude": "41.24410000",
                        "longitude": "-85.86072000"
                    },
                    {
                        "id": 119714,
                        "name": "Kouts",
                        "latitude": "41.31671000",
                        "longitude": "-87.02586000"
                    },
                    {
                        "id": 119777,
                        "name": "La Porte",
                        "latitude": "41.60774000",
                        "longitude": "-86.71389000"
                    },
                    {
                        "id": 119834,
                        "name": "Lafayette",
                        "latitude": "40.41670000",
                        "longitude": "-86.87529000"
                    },
                    {
                        "id": 119848,
                        "name": "Lagrange",
                        "latitude": "41.64172000",
                        "longitude": "-85.41665000"
                    },
                    {
                        "id": 119802,
                        "name": "LaGrange County",
                        "latitude": "41.64261000",
                        "longitude": "-85.42650000"
                    },
                    {
                        "id": 119892,
                        "name": "Lake County",
                        "latitude": "41.47221000",
                        "longitude": "-87.37637000"
                    },
                    {
                        "id": 119901,
                        "name": "Lake Dalecarlia",
                        "latitude": "41.33087000",
                        "longitude": "-87.39476000"
                    },
                    {
                        "id": 119979,
                        "name": "Lake Station",
                        "latitude": "41.57504000",
                        "longitude": "-87.23892000"
                    },
                    {
                        "id": 120026,
                        "name": "Lakes of the Four Seasons",
                        "latitude": "41.41032000",
                        "longitude": "-87.21309000"
                    },
                    {
                        "id": 120133,
                        "name": "Lapel",
                        "latitude": "40.06837000",
                        "longitude": "-85.84831000"
                    },
                    {
                        "id": 119804,
                        "name": "LaPorte",
                        "latitude": "41.61060000",
                        "longitude": "-86.72252000"
                    },
                    {
                        "id": 119805,
                        "name": "LaPorte County",
                        "latitude": "41.54902000",
                        "longitude": "-86.74237000"
                    },
                    {
                        "id": 120225,
                        "name": "Lawrence",
                        "latitude": "39.83865000",
                        "longitude": "-86.02526000"
                    },
                    {
                        "id": 120232,
                        "name": "Lawrence County",
                        "latitude": "38.84116000",
                        "longitude": "-86.48345000"
                    },
                    {
                        "id": 120240,
                        "name": "Lawrenceburg",
                        "latitude": "39.09089000",
                        "longitude": "-84.84995000"
                    },
                    {
                        "id": 120289,
                        "name": "Lebanon",
                        "latitude": "40.04837000",
                        "longitude": "-86.46917000"
                    },
                    {
                        "id": 120379,
                        "name": "Leo-Cedarville",
                        "latitude": "41.21255000",
                        "longitude": "-85.01664000"
                    },
                    {
                        "id": 120460,
                        "name": "Liberty",
                        "latitude": "39.63560000",
                        "longitude": "-84.93107000"
                    },
                    {
                        "id": 120481,
                        "name": "Ligonier",
                        "latitude": "41.46588000",
                        "longitude": "-85.58748000"
                    },
                    {
                        "id": 120589,
                        "name": "Linton",
                        "latitude": "39.03477000",
                        "longitude": "-87.16585000"
                    },
                    {
                        "id": 120707,
                        "name": "Logansport",
                        "latitude": "40.75448000",
                        "longitude": "-86.35667000"
                    },
                    {
                        "id": 120736,
                        "name": "Long Beach",
                        "latitude": "41.73893000",
                        "longitude": "-86.85697000"
                    },
                    {
                        "id": 120764,
                        "name": "Loogootee",
                        "latitude": "38.67699000",
                        "longitude": "-86.91417000"
                    },
                    {
                        "id": 120835,
                        "name": "Lowell",
                        "latitude": "41.29142000",
                        "longitude": "-87.42059000"
                    },
                    {
                        "id": 120926,
                        "name": "Lynn",
                        "latitude": "40.04977000",
                        "longitude": "-84.93969000"
                    },
                    {
                        "id": 120988,
                        "name": "Madison",
                        "latitude": "38.73589000",
                        "longitude": "-85.37996000"
                    },
                    {
                        "id": 121015,
                        "name": "Madison County",
                        "latitude": "40.16166000",
                        "longitude": "-85.71935000"
                    },
                    {
                        "id": 121243,
                        "name": "Marion",
                        "latitude": "40.55837000",
                        "longitude": "-85.65914000"
                    },
                    {
                        "id": 121252,
                        "name": "Marion County",
                        "latitude": "39.78171000",
                        "longitude": "-86.13847000"
                    },
                    {
                        "id": 121271,
                        "name": "Markle",
                        "latitude": "40.82462000",
                        "longitude": "-85.33884000"
                    },
                    {
                        "id": 121319,
                        "name": "Marshall County",
                        "latitude": "41.32485000",
                        "longitude": "-86.26176000"
                    },
                    {
                        "id": 121338,
                        "name": "Martin County",
                        "latitude": "38.70801000",
                        "longitude": "-86.80307000"
                    },
                    {
                        "id": 121348,
                        "name": "Martinsville",
                        "latitude": "39.42783000",
                        "longitude": "-86.42833000"
                    },
                    {
                        "id": 121482,
                        "name": "McCordsville",
                        "latitude": "39.90810000",
                        "longitude": "-85.92276000"
                    },
                    {
                        "id": 121627,
                        "name": "Melody Hill",
                        "latitude": "38.02615000",
                        "longitude": "-87.51585000"
                    },
                    {
                        "id": 121696,
                        "name": "Meridian Hills",
                        "latitude": "39.89004000",
                        "longitude": "-86.15721000"
                    },
                    {
                        "id": 121708,
                        "name": "Merrillville",
                        "latitude": "41.48281000",
                        "longitude": "-87.33281000"
                    },
                    {
                        "id": 121752,
                        "name": "Miami County",
                        "latitude": "40.76950000",
                        "longitude": "-86.04502000"
                    },
                    {
                        "id": 121760,
                        "name": "Michigan City",
                        "latitude": "41.70754000",
                        "longitude": "-86.89503000"
                    },
                    {
                        "id": 121772,
                        "name": "Middlebury",
                        "latitude": "41.67533000",
                        "longitude": "-85.70610000"
                    },
                    {
                        "id": 121790,
                        "name": "Middletown",
                        "latitude": "40.05727000",
                        "longitude": "-85.53720000"
                    },
                    {
                        "id": 121835,
                        "name": "Milan",
                        "latitude": "39.12117000",
                        "longitude": "-85.13135000"
                    },
                    {
                        "id": 121849,
                        "name": "Milford",
                        "latitude": "41.40977000",
                        "longitude": "-85.84555000"
                    },
                    {
                        "id": 121976,
                        "name": "Mishawaka",
                        "latitude": "41.66199000",
                        "longitude": "-86.15862000"
                    },
                    {
                        "id": 121996,
                        "name": "Mitchell",
                        "latitude": "38.73283000",
                        "longitude": "-86.47360000"
                    },
                    {
                        "id": 122050,
                        "name": "Monon",
                        "latitude": "40.86782000",
                        "longitude": "-86.87890000"
                    },
                    {
                        "id": 122072,
                        "name": "Monroe County",
                        "latitude": "39.16092000",
                        "longitude": "-86.52314000"
                    },
                    {
                        "id": 122085,
                        "name": "Monroeville",
                        "latitude": "40.97477000",
                        "longitude": "-84.86830000"
                    },
                    {
                        "id": 122087,
                        "name": "Monrovia",
                        "latitude": "39.57894000",
                        "longitude": "-86.48222000"
                    },
                    {
                        "id": 122153,
                        "name": "Montgomery County",
                        "latitude": "40.04038000",
                        "longitude": "-86.89330000"
                    },
                    {
                        "id": 122165,
                        "name": "Monticello",
                        "latitude": "40.74532000",
                        "longitude": "-86.76473000"
                    },
                    {
                        "id": 122176,
                        "name": "Montpelier",
                        "latitude": "40.55393000",
                        "longitude": "-85.27747000"
                    },
                    {
                        "id": 122209,
                        "name": "Mooresville",
                        "latitude": "39.61282000",
                        "longitude": "-86.37416000"
                    },
                    {
                        "id": 122239,
                        "name": "Morgan County",
                        "latitude": "39.48155000",
                        "longitude": "-86.44621000"
                    },
                    {
                        "id": 122260,
                        "name": "Morocco",
                        "latitude": "40.94615000",
                        "longitude": "-87.45336000"
                    },
                    {
                        "id": 122280,
                        "name": "Morristown",
                        "latitude": "39.67338000",
                        "longitude": "-85.69859000"
                    },
                    {
                        "id": 122394,
                        "name": "Mount Vernon",
                        "latitude": "37.93227000",
                        "longitude": "-87.89503000"
                    },
                    {
                        "id": 122455,
                        "name": "Mulberry",
                        "latitude": "40.34448000",
                        "longitude": "-86.66528000"
                    },
                    {
                        "id": 122465,
                        "name": "Muncie",
                        "latitude": "40.19338000",
                        "longitude": "-85.38636000"
                    },
                    {
                        "id": 122478,
                        "name": "Munster",
                        "latitude": "41.56448000",
                        "longitude": "-87.51254000"
                    },
                    {
                        "id": 122561,
                        "name": "Nappanee",
                        "latitude": "41.44283000",
                        "longitude": "-86.00139000"
                    },
                    {
                        "id": 122573,
                        "name": "Nashville",
                        "latitude": "39.20727000",
                        "longitude": "-86.25110000"
                    },
                    {
                        "id": 122654,
                        "name": "New Albany",
                        "latitude": "38.28562000",
                        "longitude": "-85.82413000"
                    },
                    {
                        "id": 122680,
                        "name": "New Carlisle",
                        "latitude": "41.70032000",
                        "longitude": "-86.50946000"
                    },
                    {
                        "id": 122684,
                        "name": "New Castle",
                        "latitude": "39.92894000",
                        "longitude": "-85.37025000"
                    },
                    {
                        "id": 122693,
                        "name": "New Chicago",
                        "latitude": "41.55837000",
                        "longitude": "-87.27448000"
                    },
                    {
                        "id": 122717,
                        "name": "New Haven",
                        "latitude": "41.07060000",
                        "longitude": "-85.01441000"
                    },
                    {
                        "id": 122758,
                        "name": "New Palestine",
                        "latitude": "39.72199000",
                        "longitude": "-85.88915000"
                    },
                    {
                        "id": 122760,
                        "name": "New Paris",
                        "latitude": "41.50033000",
                        "longitude": "-85.82805000"
                    },
                    {
                        "id": 122761,
                        "name": "New Pekin",
                        "latitude": "38.50506000",
                        "longitude": "-86.01692000"
                    },
                    {
                        "id": 122791,
                        "name": "New Whiteland",
                        "latitude": "39.55810000",
                        "longitude": "-86.09526000"
                    },
                    {
                        "id": 122816,
                        "name": "Newburgh",
                        "latitude": "37.94449000",
                        "longitude": "-87.40529000"
                    },
                    {
                        "id": 122840,
                        "name": "Newport",
                        "latitude": "39.88420000",
                        "longitude": "-87.40863000"
                    },
                    {
                        "id": 122873,
                        "name": "Newton County",
                        "latitude": "40.95585000",
                        "longitude": "-87.39754000"
                    },
                    {
                        "id": 122918,
                        "name": "Noble County",
                        "latitude": "41.39860000",
                        "longitude": "-85.41747000"
                    },
                    {
                        "id": 122921,
                        "name": "Noblesville",
                        "latitude": "40.04559000",
                        "longitude": "-86.00860000"
                    },
                    {
                        "id": 123044,
                        "name": "North Judson",
                        "latitude": "41.21504000",
                        "longitude": "-86.77585000"
                    },
                    {
                        "id": 123057,
                        "name": "North Liberty",
                        "latitude": "41.53421000",
                        "longitude": "-86.42723000"
                    },
                    {
                        "id": 123061,
                        "name": "North Madison",
                        "latitude": "38.76784000",
                        "longitude": "-85.39663000"
                    },
                    {
                        "id": 123062,
                        "name": "North Manchester",
                        "latitude": "41.00060000",
                        "longitude": "-85.76860000"
                    },
                    {
                        "id": 123114,
                        "name": "North Terre Haute",
                        "latitude": "39.52781000",
                        "longitude": "-87.36030000"
                    },
                    {
                        "id": 123121,
                        "name": "North Vernon",
                        "latitude": "39.00617000",
                        "longitude": "-85.62358000"
                    },
                    {
                        "id": 123126,
                        "name": "North Webster",
                        "latitude": "41.32560000",
                        "longitude": "-85.69776000"
                    },
                    {
                        "id": 123204,
                        "name": "Notre Dame",
                        "latitude": "41.70019000",
                        "longitude": "-86.23793000"
                    },
                    {
                        "id": 123254,
                        "name": "Oak Park",
                        "latitude": "38.30562000",
                        "longitude": "-85.69635000"
                    },
                    {
                        "id": 123294,
                        "name": "Oakland City",
                        "latitude": "38.33866000",
                        "longitude": "-87.34501000"
                    },
                    {
                        "id": 123362,
                        "name": "Odon",
                        "latitude": "38.84283000",
                        "longitude": "-86.99140000"
                    },
                    {
                        "id": 123370,
                        "name": "Ogden Dunes",
                        "latitude": "41.62281000",
                        "longitude": "-87.19170000"
                    },
                    {
                        "id": 123382,
                        "name": "Ohio County",
                        "latitude": "38.95010000",
                        "longitude": "-84.96503000"
                    },
                    {
                        "id": 123491,
                        "name": "Oolitic",
                        "latitude": "38.90088000",
                        "longitude": "-86.52527000"
                    },
                    {
                        "id": 123515,
                        "name": "Orange County",
                        "latitude": "38.54178000",
                        "longitude": "-86.49507000"
                    },
                    {
                        "id": 123563,
                        "name": "Orleans",
                        "latitude": "38.66172000",
                        "longitude": "-86.45166000"
                    },
                    {
                        "id": 123600,
                        "name": "Osceola",
                        "latitude": "41.66505000",
                        "longitude": "-86.07584000"
                    },
                    {
                        "id": 123608,
                        "name": "Osgood",
                        "latitude": "39.12922000",
                        "longitude": "-85.29163000"
                    },
                    {
                        "id": 123616,
                        "name": "Ossian",
                        "latitude": "40.88060000",
                        "longitude": "-85.16636000"
                    },
                    {
                        "id": 123642,
                        "name": "Otterbein",
                        "latitude": "40.49059000",
                        "longitude": "-87.09640000"
                    },
                    {
                        "id": 123661,
                        "name": "Owen County",
                        "latitude": "39.31281000",
                        "longitude": "-86.83765000"
                    },
                    {
                        "id": 123665,
                        "name": "Owensville",
                        "latitude": "38.27199000",
                        "longitude": "-87.68780000"
                    },
                    {
                        "id": 123682,
                        "name": "Oxford",
                        "latitude": "40.51976000",
                        "longitude": "-87.24779000"
                    },
                    {
                        "id": 123811,
                        "name": "Paoli",
                        "latitude": "38.55617000",
                        "longitude": "-86.46832000"
                    },
                    {
                        "id": 123857,
                        "name": "Parke County",
                        "latitude": "39.77363000",
                        "longitude": "-87.20636000"
                    },
                    {
                        "id": 123864,
                        "name": "Parker City",
                        "latitude": "40.18893000",
                        "longitude": "-85.20413000"
                    },
                    {
                        "id": 124016,
                        "name": "Pendleton",
                        "latitude": "39.99754000",
                        "longitude": "-85.74664000"
                    },
                    {
                        "id": 124077,
                        "name": "Perry County",
                        "latitude": "38.07965000",
                        "longitude": "-86.63803000"
                    },
                    {
                        "id": 124096,
                        "name": "Peru",
                        "latitude": "40.75365000",
                        "longitude": "-86.06888000"
                    },
                    {
                        "id": 124103,
                        "name": "Petersburg",
                        "latitude": "38.49199000",
                        "longitude": "-87.27862000"
                    },
                    {
                        "id": 124176,
                        "name": "Pierceton",
                        "latitude": "41.20032000",
                        "longitude": "-85.70554000"
                    },
                    {
                        "id": 124189,
                        "name": "Pike County",
                        "latitude": "38.39878000",
                        "longitude": "-87.23216000"
                    },
                    {
                        "id": 124289,
                        "name": "Pittsboro",
                        "latitude": "39.86393000",
                        "longitude": "-86.46694000"
                    },
                    {
                        "id": 124318,
                        "name": "Plainfield",
                        "latitude": "39.70421000",
                        "longitude": "-86.39944000"
                    },
                    {
                        "id": 124401,
                        "name": "Plymouth",
                        "latitude": "41.34366000",
                        "longitude": "-86.30973000"
                    },
                    {
                        "id": 124543,
                        "name": "Portage",
                        "latitude": "41.57587000",
                        "longitude": "-87.17615000"
                    },
                    {
                        "id": 124551,
                        "name": "Porter",
                        "latitude": "41.61559000",
                        "longitude": "-87.07420000"
                    },
                    {
                        "id": 124553,
                        "name": "Porter County",
                        "latitude": "41.50884000",
                        "longitude": "-87.07332000"
                    },
                    {
                        "id": 124560,
                        "name": "Portland",
                        "latitude": "40.43449000",
                        "longitude": "-84.97775000"
                    },
                    {
                        "id": 124574,
                        "name": "Posey County",
                        "latitude": "38.02189000",
                        "longitude": "-87.86847000"
                    },
                    {
                        "id": 124575,
                        "name": "Poseyville",
                        "latitude": "38.17004000",
                        "longitude": "-87.78308000"
                    },
                    {
                        "id": 124678,
                        "name": "Princes Lakes",
                        "latitude": "39.35366000",
                        "longitude": "-86.09805000"
                    },
                    {
                        "id": 124681,
                        "name": "Princeton",
                        "latitude": "38.35532000",
                        "longitude": "-87.56752000"
                    },
                    {
                        "id": 124743,
                        "name": "Pulaski County",
                        "latitude": "41.04183000",
                        "longitude": "-86.69878000"
                    },
                    {
                        "id": 124763,
                        "name": "Putnam County",
                        "latitude": "39.66626000",
                        "longitude": "-86.84500000"
                    },
                    {
                        "id": 124879,
                        "name": "Randolph County",
                        "latitude": "40.15764000",
                        "longitude": "-85.01131000"
                    },
                    {
                        "id": 124973,
                        "name": "Redkey",
                        "latitude": "40.34893000",
                        "longitude": "-85.14997000"
                    },
                    {
                        "id": 125014,
                        "name": "Remington",
                        "latitude": "40.76087000",
                        "longitude": "-87.15085000"
                    },
                    {
                        "id": 125023,
                        "name": "Rensselaer",
                        "latitude": "40.93670000",
                        "longitude": "-87.15086000"
                    },
                    {
                        "id": 125084,
                        "name": "Richmond",
                        "latitude": "39.82894000",
                        "longitude": "-84.89024000"
                    },
                    {
                        "id": 125165,
                        "name": "Ripley County",
                        "latitude": "39.10345000",
                        "longitude": "-85.26239000"
                    },
                    {
                        "id": 125169,
                        "name": "Rising Sun",
                        "latitude": "38.94950000",
                        "longitude": "-84.85384000"
                    },
                    {
                        "id": 125230,
                        "name": "Roanoke",
                        "latitude": "40.96255000",
                        "longitude": "-85.37331000"
                    },
                    {
                        "id": 125263,
                        "name": "Rochester",
                        "latitude": "41.06476000",
                        "longitude": "-86.21583000"
                    },
                    {
                        "id": 125315,
                        "name": "Rockport",
                        "latitude": "37.88311000",
                        "longitude": "-87.04944000"
                    },
                    {
                        "id": 125321,
                        "name": "Rockville",
                        "latitude": "39.76254000",
                        "longitude": "-87.22918000"
                    },
                    {
                        "id": 125380,
                        "name": "Rome City",
                        "latitude": "41.49616000",
                        "longitude": "-85.37665000"
                    },
                    {
                        "id": 125425,
                        "name": "Roselawn",
                        "latitude": "41.14170000",
                        "longitude": "-87.31475000"
                    },
                    {
                        "id": 125460,
                        "name": "Rossville",
                        "latitude": "40.41698000",
                        "longitude": "-86.59472000"
                    },
                    {
                        "id": 125520,
                        "name": "Rush County",
                        "latitude": "39.61995000",
                        "longitude": "-85.46576000"
                    },
                    {
                        "id": 125525,
                        "name": "Rushville",
                        "latitude": "39.60921000",
                        "longitude": "-85.44636000"
                    },
                    {
                        "id": 125545,
                        "name": "Russiaville",
                        "latitude": "40.41754000",
                        "longitude": "-86.27138000"
                    },
                    {
                        "id": 125662,
                        "name": "Saint John",
                        "latitude": "41.45004000",
                        "longitude": "-87.47004000"
                    },
                    {
                        "id": 125675,
                        "name": "Saint Joseph County",
                        "latitude": "41.61672000",
                        "longitude": "-86.28986000"
                    },
                    {
                        "id": 125700,
                        "name": "Saint Paul",
                        "latitude": "39.42810000",
                        "longitude": "-85.62831000"
                    },
                    {
                        "id": 125727,
                        "name": "Salem",
                        "latitude": "38.60561000",
                        "longitude": "-86.10109000"
                    },
                    {
                        "id": 125909,
                        "name": "Santa Claus",
                        "latitude": "38.12005000",
                        "longitude": "-86.91416000"
                    },
                    {
                        "id": 126005,
                        "name": "Schererville",
                        "latitude": "41.47892000",
                        "longitude": "-87.45476000"
                    },
                    {
                        "id": 126045,
                        "name": "Scott County",
                        "latitude": "38.68507000",
                        "longitude": "-85.74747000"
                    },
                    {
                        "id": 126062,
                        "name": "Scottsburg",
                        "latitude": "38.68561000",
                        "longitude": "-85.77025000"
                    },
                    {
                        "id": 126126,
                        "name": "Seelyville",
                        "latitude": "39.49198000",
                        "longitude": "-87.26724000"
                    },
                    {
                        "id": 126135,
                        "name": "Sellersburg",
                        "latitude": "38.39812000",
                        "longitude": "-85.75496000"
                    },
                    {
                        "id": 126192,
                        "name": "Seymour",
                        "latitude": "38.95922000",
                        "longitude": "-85.89025000"
                    },
                    {
                        "id": 126201,
                        "name": "Shadeland",
                        "latitude": "40.37365000",
                        "longitude": "-86.94890000"
                    },
                    {
                        "id": 126264,
                        "name": "Shelburn",
                        "latitude": "39.17837000",
                        "longitude": "-87.39363000"
                    },
                    {
                        "id": 126274,
                        "name": "Shelby County",
                        "latitude": "39.52369000",
                        "longitude": "-85.79170000"
                    },
                    {
                        "id": 126280,
                        "name": "Shelbyville",
                        "latitude": "39.52144000",
                        "longitude": "-85.77692000"
                    },
                    {
                        "id": 126318,
                        "name": "Sheridan",
                        "latitude": "40.13504000",
                        "longitude": "-86.22055000"
                    },
                    {
                        "id": 126364,
                        "name": "Shoals",
                        "latitude": "38.66644000",
                        "longitude": "-86.79111000"
                    },
                    {
                        "id": 126373,
                        "name": "Shorewood Forest",
                        "latitude": "41.46315000",
                        "longitude": "-87.14472000"
                    },
                    {
                        "id": 126447,
                        "name": "Simonton Lake",
                        "latitude": "41.75422000",
                        "longitude": "-85.97500000"
                    },
                    {
                        "id": 126531,
                        "name": "Smithville-Sanders",
                        "latitude": "39.05969000",
                        "longitude": "-86.51077000"
                    },
                    {
                        "id": 126624,
                        "name": "South Bend",
                        "latitude": "41.68338000",
                        "longitude": "-86.25001000"
                    },
                    {
                        "id": 126666,
                        "name": "South Haven",
                        "latitude": "41.54198000",
                        "longitude": "-87.13726000"
                    },
                    {
                        "id": 126747,
                        "name": "South Whitley",
                        "latitude": "41.08477000",
                        "longitude": "-85.62804000"
                    },
                    {
                        "id": 126782,
                        "name": "Southport",
                        "latitude": "39.66505000",
                        "longitude": "-86.12776000"
                    },
                    {
                        "id": 126818,
                        "name": "Speedway",
                        "latitude": "39.80227000",
                        "longitude": "-86.26721000"
                    },
                    {
                        "id": 126820,
                        "name": "Spencer",
                        "latitude": "39.28671000",
                        "longitude": "-86.76251000"
                    },
                    {
                        "id": 126828,
                        "name": "Spencer County",
                        "latitude": "38.01406000",
                        "longitude": "-87.00771000"
                    },
                    {
                        "id": 126987,
                        "name": "Starke County",
                        "latitude": "41.28093000",
                        "longitude": "-86.64765000"
                    },
                    {
                        "id": 127038,
                        "name": "Steuben County",
                        "latitude": "41.64387000",
                        "longitude": "-85.00077000"
                    },
                    {
                        "id": 127182,
                        "name": "Sullivan",
                        "latitude": "39.09532000",
                        "longitude": "-87.40585000"
                    },
                    {
                        "id": 127186,
                        "name": "Sullivan County",
                        "latitude": "39.08883000",
                        "longitude": "-87.41469000"
                    },
                    {
                        "id": 127255,
                        "name": "Sunman",
                        "latitude": "39.23700000",
                        "longitude": "-85.09468000"
                    },
                    {
                        "id": 127339,
                        "name": "Sweetser",
                        "latitude": "40.57198000",
                        "longitude": "-85.76915000"
                    },
                    {
                        "id": 127349,
                        "name": "Switzerland County",
                        "latitude": "38.82616000",
                        "longitude": "-85.03700000"
                    },
                    {
                        "id": 127363,
                        "name": "Syracuse",
                        "latitude": "41.42783000",
                        "longitude": "-85.75249000"
                    },
                    {
                        "id": 127488,
                        "name": "Tell City",
                        "latitude": "37.95144000",
                        "longitude": "-86.76777000"
                    },
                    {
                        "id": 127520,
                        "name": "Terre Haute",
                        "latitude": "39.46670000",
                        "longitude": "-87.41391000"
                    },
                    {
                        "id": 127605,
                        "name": "Thorntown",
                        "latitude": "40.12948000",
                        "longitude": "-86.60667000"
                    },
                    {
                        "id": 127673,
                        "name": "Tippecanoe County",
                        "latitude": "40.38862000",
                        "longitude": "-86.89410000"
                    },
                    {
                        "id": 127676,
                        "name": "Tipton",
                        "latitude": "40.28226000",
                        "longitude": "-86.04110000"
                    },
                    {
                        "id": 127680,
                        "name": "Tipton County",
                        "latitude": "40.31135000",
                        "longitude": "-86.05186000"
                    },
                    {
                        "id": 127733,
                        "name": "Topeka",
                        "latitude": "41.53922000",
                        "longitude": "-85.53971000"
                    },
                    {
                        "id": 127775,
                        "name": "Trafalgar",
                        "latitude": "39.41616000",
                        "longitude": "-86.15082000"
                    },
                    {
                        "id": 127777,
                        "name": "Trail Creek",
                        "latitude": "41.69837000",
                        "longitude": "-86.85920000"
                    },
                    {
                        "id": 127817,
                        "name": "Tri-Lakes",
                        "latitude": "41.24588000",
                        "longitude": "-85.44192000"
                    },
                    {
                        "id": 127983,
                        "name": "Union City",
                        "latitude": "40.20199000",
                        "longitude": "-84.80913000"
                    },
                    {
                        "id": 127992,
                        "name": "Union County",
                        "latitude": "39.62555000",
                        "longitude": "-84.92514000"
                    },
                    {
                        "id": 128038,
                        "name": "Upland",
                        "latitude": "40.47560000",
                        "longitude": "-85.49442000"
                    },
                    {
                        "id": 128121,
                        "name": "Valparaiso",
                        "latitude": "41.47309000",
                        "longitude": "-87.06114000"
                    },
                    {
                        "id": 128150,
                        "name": "Vanderburgh County",
                        "latitude": "38.02514000",
                        "longitude": "-87.58578000"
                    },
                    {
                        "id": 128161,
                        "name": "Veedersburg",
                        "latitude": "40.11309000",
                        "longitude": "-87.26251000"
                    },
                    {
                        "id": 128186,
                        "name": "Vermillion County",
                        "latitude": "39.85380000",
                        "longitude": "-87.46397000"
                    },
                    {
                        "id": 128208,
                        "name": "Versailles",
                        "latitude": "39.07200000",
                        "longitude": "-85.25190000"
                    },
                    {
                        "id": 128213,
                        "name": "Vevay",
                        "latitude": "38.74784000",
                        "longitude": "-85.06717000"
                    },
                    {
                        "id": 128239,
                        "name": "Vigo County",
                        "latitude": "39.43064000",
                        "longitude": "-87.38996000"
                    },
                    {
                        "id": 128263,
                        "name": "Vincennes",
                        "latitude": "38.67727000",
                        "longitude": "-87.52863000"
                    },
                    {
                        "id": 128309,
                        "name": "Wabash",
                        "latitude": "40.79782000",
                        "longitude": "-85.82054000"
                    },
                    {
                        "id": 128311,
                        "name": "Wabash County",
                        "latitude": "40.84569000",
                        "longitude": "-85.79401000"
                    },
                    {
                        "id": 128355,
                        "name": "Wakarusa",
                        "latitude": "41.53616000",
                        "longitude": "-86.02083000"
                    },
                    {
                        "id": 128391,
                        "name": "Walkerton",
                        "latitude": "41.46671000",
                        "longitude": "-86.48307000"
                    },
                    {
                        "id": 128435,
                        "name": "Walton",
                        "latitude": "40.66087000",
                        "longitude": "-86.24194000"
                    },
                    {
                        "id": 128450,
                        "name": "Wanatah",
                        "latitude": "41.43060000",
                        "longitude": "-86.89836000"
                    },
                    {
                        "id": 128477,
                        "name": "Warren",
                        "latitude": "40.68282000",
                        "longitude": "-85.42720000"
                    },
                    {
                        "id": 128495,
                        "name": "Warren County",
                        "latitude": "40.34690000",
                        "longitude": "-87.35331000"
                    },
                    {
                        "id": 128499,
                        "name": "Warren Park",
                        "latitude": "39.78199000",
                        "longitude": "-86.05026000"
                    },
                    {
                        "id": 128511,
                        "name": "Warrick County",
                        "latitude": "38.09217000",
                        "longitude": "-87.27205000"
                    },
                    {
                        "id": 128520,
                        "name": "Warsaw",
                        "latitude": "41.23810000",
                        "longitude": "-85.85305000"
                    },
                    {
                        "id": 128538,
                        "name": "Washington",
                        "latitude": "38.65922000",
                        "longitude": "-87.17279000"
                    },
                    {
                        "id": 128557,
                        "name": "Washington County",
                        "latitude": "38.59998000",
                        "longitude": "-86.10531000"
                    },
                    {
                        "id": 128613,
                        "name": "Waterloo",
                        "latitude": "41.43199000",
                        "longitude": "-85.01997000"
                    },
                    {
                        "id": 128691,
                        "name": "Wayne County",
                        "latitude": "39.86442000",
                        "longitude": "-85.00988000"
                    },
                    {
                        "id": 128786,
                        "name": "Wells County",
                        "latitude": "40.72919000",
                        "longitude": "-85.22122000"
                    },
                    {
                        "id": 128908,
                        "name": "West Lafayette",
                        "latitude": "40.42587000",
                        "longitude": "-86.90807000"
                    },
                    {
                        "id": 128989,
                        "name": "West Terre Haute",
                        "latitude": "39.46504000",
                        "longitude": "-87.45002000"
                    },
                    {
                        "id": 129027,
                        "name": "Westfield",
                        "latitude": "40.04282000",
                        "longitude": "-86.12749000"
                    },
                    {
                        "id": 129070,
                        "name": "Westport",
                        "latitude": "39.17589000",
                        "longitude": "-85.57303000"
                    },
                    {
                        "id": 129079,
                        "name": "Westville",
                        "latitude": "41.54143000",
                        "longitude": "-86.90058000"
                    },
                    {
                        "id": 129138,
                        "name": "White County",
                        "latitude": "40.74977000",
                        "longitude": "-86.86547000"
                    },
                    {
                        "id": 129176,
                        "name": "Whiteland",
                        "latitude": "39.55005000",
                        "longitude": "-86.07971000"
                    },
                    {
                        "id": 129188,
                        "name": "Whitestown",
                        "latitude": "39.99726000",
                        "longitude": "-86.34583000"
                    },
                    {
                        "id": 129196,
                        "name": "Whiting",
                        "latitude": "41.67976000",
                        "longitude": "-87.49449000"
                    },
                    {
                        "id": 129201,
                        "name": "Whitley County",
                        "latitude": "41.13938000",
                        "longitude": "-85.50512000"
                    },
                    {
                        "id": 129280,
                        "name": "Williamsport",
                        "latitude": "40.28837000",
                        "longitude": "-87.29390000"
                    },
                    {
                        "id": 129350,
                        "name": "Winamac",
                        "latitude": "41.05143000",
                        "longitude": "-86.60306000"
                    },
                    {
                        "id": 129357,
                        "name": "Winchester",
                        "latitude": "40.17199000",
                        "longitude": "-84.98135000"
                    },
                    {
                        "id": 129398,
                        "name": "Winfield",
                        "latitude": "41.40531000",
                        "longitude": "-87.27531000"
                    },
                    {
                        "id": 129426,
                        "name": "Winona Lake",
                        "latitude": "41.22727000",
                        "longitude": "-85.82193000"
                    },
                    {
                        "id": 129470,
                        "name": "Wolcottville",
                        "latitude": "41.52588000",
                        "longitude": "-85.36665000"
                    },
                    {
                        "id": 129503,
                        "name": "Woodburn",
                        "latitude": "41.12533000",
                        "longitude": "-84.85330000"
                    },
                    {
                        "id": 129596,
                        "name": "Worthington",
                        "latitude": "39.12504000",
                        "longitude": "-86.97945000"
                    },
                    {
                        "id": 129707,
                        "name": "Yorktown",
                        "latitude": "40.17365000",
                        "longitude": "-85.49414000"
                    },
                    {
                        "id": 129759,
                        "name": "Zionsville",
                        "latitude": "39.95087000",
                        "longitude": "-86.26194000"
                    }
                ]
            },
            {
                "id": 1459,
                "name": "Iowa",
                "iso2": "IA",
                "latitude": "41.87800250",
                "longitude": "-93.09770200",
                "type": "state",
                "cities": [
                    {
                        "id": 110997,
                        "name": "Ackley",
                        "latitude": "42.55415000",
                        "longitude": "-93.05326000"
                    },
                    {
                        "id": 111010,
                        "name": "Adair County",
                        "latitude": "41.33075000",
                        "longitude": "-94.47094000"
                    },
                    {
                        "id": 111020,
                        "name": "Adams County",
                        "latitude": "41.02898000",
                        "longitude": "-94.69918000"
                    },
                    {
                        "id": 111042,
                        "name": "Adel",
                        "latitude": "41.61443000",
                        "longitude": "-94.01745000"
                    },
                    {
                        "id": 111076,
                        "name": "Akron",
                        "latitude": "42.82888000",
                        "longitude": "-96.55948000"
                    },
                    {
                        "id": 111122,
                        "name": "Albia",
                        "latitude": "41.02667000",
                        "longitude": "-92.80575000"
                    },
                    {
                        "id": 111163,
                        "name": "Algona",
                        "latitude": "43.06997000",
                        "longitude": "-94.23302000"
                    },
                    {
                        "id": 111176,
                        "name": "Allamakee County",
                        "latitude": "43.28428000",
                        "longitude": "-91.37809000"
                    },
                    {
                        "id": 111201,
                        "name": "Allison",
                        "latitude": "42.75275000",
                        "longitude": "-92.79519000"
                    },
                    {
                        "id": 111229,
                        "name": "Alta",
                        "latitude": "42.67359000",
                        "longitude": "-95.29055000"
                    },
                    {
                        "id": 111245,
                        "name": "Alton",
                        "latitude": "42.98749000",
                        "longitude": "-96.01057000"
                    },
                    {
                        "id": 111247,
                        "name": "Altoona",
                        "latitude": "41.64416000",
                        "longitude": "-93.46466000"
                    },
                    {
                        "id": 111277,
                        "name": "Ames",
                        "latitude": "42.03471000",
                        "longitude": "-93.61994000"
                    },
                    {
                        "id": 111302,
                        "name": "Anamosa",
                        "latitude": "42.10834000",
                        "longitude": "-91.28516000"
                    },
                    {
                        "id": 111344,
                        "name": "Ankeny",
                        "latitude": "41.72971000",
                        "longitude": "-93.60577000"
                    },
                    {
                        "id": 111386,
                        "name": "Aplington",
                        "latitude": "42.58415000",
                        "longitude": "-92.88436000"
                    },
                    {
                        "id": 111391,
                        "name": "Appanoose County",
                        "latitude": "40.74316000",
                        "longitude": "-92.86861000"
                    },
                    {
                        "id": 111490,
                        "name": "Arnolds Park",
                        "latitude": "43.37274000",
                        "longitude": "-95.12388000"
                    },
                    {
                        "id": 111506,
                        "name": "Asbury",
                        "latitude": "42.51445000",
                        "longitude": "-90.75152000"
                    },
                    {
                        "id": 111586,
                        "name": "Atkins",
                        "latitude": "41.99694000",
                        "longitude": "-91.86213000"
                    },
                    {
                        "id": 111594,
                        "name": "Atlantic",
                        "latitude": "41.40360000",
                        "longitude": "-95.01388000"
                    },
                    {
                        "id": 111639,
                        "name": "Audubon",
                        "latitude": "41.71804000",
                        "longitude": "-94.93249000"
                    },
                    {
                        "id": 111641,
                        "name": "Audubon County",
                        "latitude": "41.68459000",
                        "longitude": "-94.90582000"
                    },
                    {
                        "id": 111687,
                        "name": "Avoca",
                        "latitude": "41.47666000",
                        "longitude": "-95.33805000"
                    },
                    {
                        "id": 111915,
                        "name": "Baxter",
                        "latitude": "41.82610000",
                        "longitude": "-93.15159000"
                    },
                    {
                        "id": 112022,
                        "name": "Bedford",
                        "latitude": "40.66693000",
                        "longitude": "-94.72136000"
                    },
                    {
                        "id": 112089,
                        "name": "Belle Plaine",
                        "latitude": "41.89694000",
                        "longitude": "-92.27824000"
                    },
                    {
                        "id": 112111,
                        "name": "Bellevue",
                        "latitude": "42.25863000",
                        "longitude": "-90.42291000"
                    },
                    {
                        "id": 112134,
                        "name": "Belmond",
                        "latitude": "42.84608000",
                        "longitude": "-93.61410000"
                    },
                    {
                        "id": 112203,
                        "name": "Benton County",
                        "latitude": "42.08019000",
                        "longitude": "-92.06569000"
                    },
                    {
                        "id": 112294,
                        "name": "Bettendorf",
                        "latitude": "41.52448000",
                        "longitude": "-90.51569000"
                    },
                    {
                        "id": 112377,
                        "name": "Black Hawk County",
                        "latitude": "42.47010000",
                        "longitude": "-92.30882000"
                    },
                    {
                        "id": 112436,
                        "name": "Bloomfield",
                        "latitude": "40.75169000",
                        "longitude": "-92.41491000"
                    },
                    {
                        "id": 112467,
                        "name": "Blue Grass",
                        "latitude": "41.50892000",
                        "longitude": "-90.76598000"
                    },
                    {
                        "id": 112534,
                        "name": "Bondurant",
                        "latitude": "41.70054000",
                        "longitude": "-93.46216000"
                    },
                    {
                        "id": 112553,
                        "name": "Boone",
                        "latitude": "42.05970000",
                        "longitude": "-93.88023000"
                    },
                    {
                        "id": 112558,
                        "name": "Boone County",
                        "latitude": "42.03655000",
                        "longitude": "-93.93167000"
                    },
                    {
                        "id": 112722,
                        "name": "Bremer County",
                        "latitude": "42.77459000",
                        "longitude": "-92.31805000"
                    },
                    {
                        "id": 112817,
                        "name": "Britt",
                        "latitude": "43.09774000",
                        "longitude": "-93.80189000"
                    },
                    {
                        "id": 112870,
                        "name": "Brooklyn",
                        "latitude": "41.73361000",
                        "longitude": "-92.44546000"
                    },
                    {
                        "id": 112975,
                        "name": "Buchanan County",
                        "latitude": "42.47078000",
                        "longitude": "-91.83784000"
                    },
                    {
                        "id": 113005,
                        "name": "Buena Vista County",
                        "latitude": "42.73549000",
                        "longitude": "-95.15115000"
                    },
                    {
                        "id": 113012,
                        "name": "Buffalo",
                        "latitude": "41.45642000",
                        "longitude": "-90.72347000"
                    },
                    {
                        "id": 113017,
                        "name": "Buffalo (historical)",
                        "latitude": "41.31110000",
                        "longitude": "-94.00356000"
                    },
                    {
                        "id": 113069,
                        "name": "Burlington",
                        "latitude": "40.80754000",
                        "longitude": "-91.11292000"
                    },
                    {
                        "id": 113118,
                        "name": "Butler County",
                        "latitude": "42.73157000",
                        "longitude": "-92.79019000"
                    },
                    {
                        "id": 113209,
                        "name": "Calhoun County",
                        "latitude": "42.38518000",
                        "longitude": "-94.64041000"
                    },
                    {
                        "id": 113239,
                        "name": "Camanche",
                        "latitude": "41.78809000",
                        "longitude": "-90.25624000"
                    },
                    {
                        "id": 113403,
                        "name": "Carlisle",
                        "latitude": "41.50082000",
                        "longitude": "-93.49105000"
                    },
                    {
                        "id": 113449,
                        "name": "Carroll",
                        "latitude": "42.06582000",
                        "longitude": "-94.86693000"
                    },
                    {
                        "id": 113458,
                        "name": "Carroll County",
                        "latitude": "42.03624000",
                        "longitude": "-94.86056000"
                    },
                    {
                        "id": 113485,
                        "name": "Carter Lake",
                        "latitude": "41.29055000",
                        "longitude": "-95.91807000"
                    },
                    {
                        "id": 113513,
                        "name": "Cascade",
                        "latitude": "42.29862000",
                        "longitude": "-91.01486000"
                    },
                    {
                        "id": 113529,
                        "name": "Cass County",
                        "latitude": "41.33149000",
                        "longitude": "-94.92783000"
                    },
                    {
                        "id": 113605,
                        "name": "Cedar County",
                        "latitude": "41.77232000",
                        "longitude": "-91.13241000"
                    },
                    {
                        "id": 113607,
                        "name": "Cedar Falls",
                        "latitude": "42.52776000",
                        "longitude": "-92.44547000"
                    },
                    {
                        "id": 113621,
                        "name": "Cedar Rapids",
                        "latitude": "42.00833000",
                        "longitude": "-91.64407000"
                    },
                    {
                        "id": 113647,
                        "name": "Center Point",
                        "latitude": "42.19083000",
                        "longitude": "-91.78518000"
                    },
                    {
                        "id": 113658,
                        "name": "Centerville",
                        "latitude": "40.73418000",
                        "longitude": "-92.87409000"
                    },
                    {
                        "id": 113668,
                        "name": "Central City",
                        "latitude": "42.20388000",
                        "longitude": "-91.52406000"
                    },
                    {
                        "id": 113703,
                        "name": "Cerro Gordo County",
                        "latitude": "43.08156000",
                        "longitude": "-93.26082000"
                    },
                    {
                        "id": 113749,
                        "name": "Chariton",
                        "latitude": "41.01389000",
                        "longitude": "-93.30660000"
                    },
                    {
                        "id": 113754,
                        "name": "Charles City",
                        "latitude": "43.06636000",
                        "longitude": "-92.67241000"
                    },
                    {
                        "id": 113848,
                        "name": "Cherokee",
                        "latitude": "42.74943000",
                        "longitude": "-95.55167000"
                    },
                    {
                        "id": 113856,
                        "name": "Cherokee County",
                        "latitude": "42.73562000",
                        "longitude": "-95.62381000"
                    },
                    {
                        "id": 113940,
                        "name": "Chickasaw County",
                        "latitude": "43.06004000",
                        "longitude": "-92.31766000"
                    },
                    {
                        "id": 114115,
                        "name": "Clarinda",
                        "latitude": "40.73981000",
                        "longitude": "-95.03800000"
                    },
                    {
                        "id": 114116,
                        "name": "Clarion",
                        "latitude": "42.73164000",
                        "longitude": "-93.73299000"
                    },
                    {
                        "id": 114138,
                        "name": "Clarke County",
                        "latitude": "41.02903000",
                        "longitude": "-93.78516000"
                    },
                    {
                        "id": 114156,
                        "name": "Clarksville",
                        "latitude": "42.78470000",
                        "longitude": "-92.66769000"
                    },
                    {
                        "id": 114187,
                        "name": "Clay County",
                        "latitude": "43.08258000",
                        "longitude": "-95.15092000"
                    },
                    {
                        "id": 114206,
                        "name": "Clayton County",
                        "latitude": "42.84475000",
                        "longitude": "-91.34143000"
                    },
                    {
                        "id": 114209,
                        "name": "Clear Lake",
                        "latitude": "43.13802000",
                        "longitude": "-93.37937000"
                    },
                    {
                        "id": 114278,
                        "name": "Clinton",
                        "latitude": "41.84447000",
                        "longitude": "-90.18874000"
                    },
                    {
                        "id": 114292,
                        "name": "Clinton County",
                        "latitude": "41.89804000",
                        "longitude": "-90.53197000"
                    },
                    {
                        "id": 114303,
                        "name": "Clive",
                        "latitude": "41.60304000",
                        "longitude": "-93.72411000"
                    },
                    {
                        "id": 114405,
                        "name": "Colfax",
                        "latitude": "41.67777000",
                        "longitude": "-93.24520000"
                    },
                    {
                        "id": 114503,
                        "name": "Columbus Junction",
                        "latitude": "41.28003000",
                        "longitude": "-91.36071000"
                    },
                    {
                        "id": 114568,
                        "name": "Conrad",
                        "latitude": "42.22471000",
                        "longitude": "-92.87465000"
                    },
                    {
                        "id": 114599,
                        "name": "Coon Rapids",
                        "latitude": "41.87082000",
                        "longitude": "-94.67748000"
                    },
                    {
                        "id": 114628,
                        "name": "Coralville",
                        "latitude": "41.67640000",
                        "longitude": "-91.58045000"
                    },
                    {
                        "id": 114652,
                        "name": "Corning",
                        "latitude": "40.98999000",
                        "longitude": "-94.74081000"
                    },
                    {
                        "id": 114682,
                        "name": "Corydon",
                        "latitude": "40.75695000",
                        "longitude": "-93.31882000"
                    },
                    {
                        "id": 114712,
                        "name": "Council Bluffs",
                        "latitude": "41.26194000",
                        "longitude": "-95.86083000"
                    },
                    {
                        "id": 114780,
                        "name": "Crawford County",
                        "latitude": "42.03721000",
                        "longitude": "-95.38197000"
                    },
                    {
                        "id": 114798,
                        "name": "Cresco",
                        "latitude": "43.38136000",
                        "longitude": "-92.11405000"
                    },
                    {
                        "id": 114806,
                        "name": "Creston",
                        "latitude": "41.05860000",
                        "longitude": "-94.36135000"
                    },
                    {
                        "id": 114974,
                        "name": "Dakota City",
                        "latitude": "42.72219000",
                        "longitude": "-94.19718000"
                    },
                    {
                        "id": 114993,
                        "name": "Dallas Center",
                        "latitude": "41.68443000",
                        "longitude": "-93.96106000"
                    },
                    {
                        "id": 114998,
                        "name": "Dallas County",
                        "latitude": "41.68489000",
                        "longitude": "-94.03974000"
                    },
                    {
                        "id": 115059,
                        "name": "Davenport",
                        "latitude": "41.52364000",
                        "longitude": "-90.57764000"
                    },
                    {
                        "id": 115074,
                        "name": "Davis County",
                        "latitude": "40.74769000",
                        "longitude": "-92.40972000"
                    },
                    {
                        "id": 115118,
                        "name": "De Soto",
                        "latitude": "41.53166000",
                        "longitude": "-94.00967000"
                    },
                    {
                        "id": 115122,
                        "name": "De Witt",
                        "latitude": "41.82336000",
                        "longitude": "-90.53819000"
                    },
                    {
                        "id": 115162,
                        "name": "Decatur County",
                        "latitude": "40.73768000",
                        "longitude": "-93.78628000"
                    },
                    {
                        "id": 115166,
                        "name": "Decorah",
                        "latitude": "43.30331000",
                        "longitude": "-91.78571000"
                    },
                    {
                        "id": 115205,
                        "name": "Delaware County",
                        "latitude": "42.47121000",
                        "longitude": "-91.36735000"
                    },
                    {
                        "id": 115238,
                        "name": "Denison",
                        "latitude": "42.01777000",
                        "longitude": "-95.35528000"
                    },
                    {
                        "id": 115251,
                        "name": "Denver",
                        "latitude": "42.67137000",
                        "longitude": "-92.33740000"
                    },
                    {
                        "id": 115271,
                        "name": "Des Moines",
                        "latitude": "41.60054000",
                        "longitude": "-93.60911000"
                    },
                    {
                        "id": 115273,
                        "name": "Des Moines County",
                        "latitude": "40.92318000",
                        "longitude": "-91.18147000"
                    },
                    {
                        "id": 115328,
                        "name": "Dickinson County",
                        "latitude": "43.37798000",
                        "longitude": "-95.15083000"
                    },
                    {
                        "id": 115337,
                        "name": "Dike",
                        "latitude": "42.46415000",
                        "longitude": "-92.62825000"
                    },
                    {
                        "id": 115500,
                        "name": "Dubuque",
                        "latitude": "42.50056000",
                        "longitude": "-90.66457000"
                    },
                    {
                        "id": 115501,
                        "name": "Dubuque County",
                        "latitude": "42.46883000",
                        "longitude": "-90.88246000"
                    },
                    {
                        "id": 115568,
                        "name": "Durant",
                        "latitude": "41.59975000",
                        "longitude": "-90.91070000"
                    },
                    {
                        "id": 115589,
                        "name": "Dyersville",
                        "latitude": "42.48444000",
                        "longitude": "-91.12291000"
                    },
                    {
                        "id": 115591,
                        "name": "Dysart",
                        "latitude": "42.17166000",
                        "longitude": "-92.30630000"
                    },
                    {
                        "id": 115601,
                        "name": "Eagle Grove",
                        "latitude": "42.66414000",
                        "longitude": "-93.90439000"
                    },
                    {
                        "id": 115617,
                        "name": "Earlham",
                        "latitude": "41.49193000",
                        "longitude": "-94.12412000"
                    },
                    {
                        "id": 115827,
                        "name": "Eddyville",
                        "latitude": "41.15650000",
                        "longitude": "-92.63739000"
                    },
                    {
                        "id": 115951,
                        "name": "Eldora",
                        "latitude": "42.36082000",
                        "longitude": "-93.09965000"
                    },
                    {
                        "id": 115956,
                        "name": "Eldridge",
                        "latitude": "41.65809000",
                        "longitude": "-90.58458000"
                    },
                    {
                        "id": 115994,
                        "name": "Elk Run Heights",
                        "latitude": "42.46693000",
                        "longitude": "-92.25657000"
                    },
                    {
                        "id": 115995,
                        "name": "Elkader",
                        "latitude": "42.85387000",
                        "longitude": "-91.40542000"
                    },
                    {
                        "id": 116084,
                        "name": "Ely",
                        "latitude": "41.87362000",
                        "longitude": "-91.58518000"
                    },
                    {
                        "id": 116102,
                        "name": "Emmet County",
                        "latitude": "43.37802000",
                        "longitude": "-94.67848000"
                    },
                    {
                        "id": 116104,
                        "name": "Emmetsburg",
                        "latitude": "43.11274000",
                        "longitude": "-94.68304000"
                    },
                    {
                        "id": 116159,
                        "name": "Epworth",
                        "latitude": "42.44500000",
                        "longitude": "-90.93208000"
                    },
                    {
                        "id": 116210,
                        "name": "Estherville",
                        "latitude": "43.40163000",
                        "longitude": "-94.83276000"
                    },
                    {
                        "id": 116250,
                        "name": "Evansdale",
                        "latitude": "42.46915000",
                        "longitude": "-92.28102000"
                    },
                    {
                        "id": 116289,
                        "name": "Fairbank",
                        "latitude": "42.63915000",
                        "longitude": "-92.04712000"
                    },
                    {
                        "id": 116304,
                        "name": "Fairfax",
                        "latitude": "41.91945000",
                        "longitude": "-91.78101000"
                    },
                    {
                        "id": 116313,
                        "name": "Fairfield",
                        "latitude": "41.00863000",
                        "longitude": "-91.96267000"
                    },
                    {
                        "id": 116399,
                        "name": "Farley",
                        "latitude": "42.44278000",
                        "longitude": "-91.00625000"
                    },
                    {
                        "id": 116441,
                        "name": "Fayette",
                        "latitude": "42.84193000",
                        "longitude": "-91.80211000"
                    },
                    {
                        "id": 116451,
                        "name": "Fayette County",
                        "latitude": "42.86259000",
                        "longitude": "-91.84432000"
                    },
                    {
                        "id": 116610,
                        "name": "Floyd County",
                        "latitude": "43.05992000",
                        "longitude": "-92.78900000"
                    },
                    {
                        "id": 116648,
                        "name": "Forest City",
                        "latitude": "43.26246000",
                        "longitude": "-93.63716000"
                    },
                    {
                        "id": 116707,
                        "name": "Fort Dodge",
                        "latitude": "42.49747000",
                        "longitude": "-94.16802000"
                    },
                    {
                        "id": 116727,
                        "name": "Fort Madison",
                        "latitude": "40.62976000",
                        "longitude": "-91.31515000"
                    },
                    {
                        "id": 116857,
                        "name": "Franklin County",
                        "latitude": "42.73255000",
                        "longitude": "-93.26247000"
                    },
                    {
                        "id": 116925,
                        "name": "Fremont County",
                        "latitude": "40.74559000",
                        "longitude": "-95.60468000"
                    },
                    {
                        "id": 117093,
                        "name": "Garner",
                        "latitude": "43.10246000",
                        "longitude": "-93.60188000"
                    },
                    {
                        "id": 117152,
                        "name": "George",
                        "latitude": "43.34386000",
                        "longitude": "-96.00224000"
                    },
                    {
                        "id": 117202,
                        "name": "Gilbert",
                        "latitude": "42.10693000",
                        "longitude": "-93.64966000"
                    },
                    {
                        "id": 117313,
                        "name": "Glenwood",
                        "latitude": "41.04694000",
                        "longitude": "-95.74251000"
                    },
                    {
                        "id": 117319,
                        "name": "Glidden",
                        "latitude": "42.05693000",
                        "longitude": "-94.72887000"
                    },
                    {
                        "id": 117487,
                        "name": "Granger",
                        "latitude": "41.76110000",
                        "longitude": "-93.82439000"
                    },
                    {
                        "id": 117628,
                        "name": "Greene",
                        "latitude": "42.89581000",
                        "longitude": "-92.80242000"
                    },
                    {
                        "id": 117641,
                        "name": "Greene County",
                        "latitude": "42.03624000",
                        "longitude": "-94.39684000"
                    },
                    {
                        "id": 117649,
                        "name": "Greenfield",
                        "latitude": "41.30527000",
                        "longitude": "-94.46135000"
                    },
                    {
                        "id": 117737,
                        "name": "Grimes",
                        "latitude": "41.68832000",
                        "longitude": "-93.79106000"
                    },
                    {
                        "id": 117740,
                        "name": "Grinnell",
                        "latitude": "41.74305000",
                        "longitude": "-92.72241000"
                    },
                    {
                        "id": 117769,
                        "name": "Grundy Center",
                        "latitude": "42.36165000",
                        "longitude": "-92.76853000"
                    },
                    {
                        "id": 117771,
                        "name": "Grundy County",
                        "latitude": "42.40187000",
                        "longitude": "-92.79142000"
                    },
                    {
                        "id": 117814,
                        "name": "Guthrie Center",
                        "latitude": "41.67721000",
                        "longitude": "-94.50330000"
                    },
                    {
                        "id": 117815,
                        "name": "Guthrie County",
                        "latitude": "41.68375000",
                        "longitude": "-94.50105000"
                    },
                    {
                        "id": 117816,
                        "name": "Guttenberg",
                        "latitude": "42.78582000",
                        "longitude": "-91.09957000"
                    },
                    {
                        "id": 117882,
                        "name": "Hamburg",
                        "latitude": "40.60445000",
                        "longitude": "-95.65777000"
                    },
                    {
                        "id": 117900,
                        "name": "Hamilton County",
                        "latitude": "42.38377000",
                        "longitude": "-93.70681000"
                    },
                    {
                        "id": 117930,
                        "name": "Hampton",
                        "latitude": "42.74192000",
                        "longitude": "-93.20242000"
                    },
                    {
                        "id": 117955,
                        "name": "Hancock County",
                        "latitude": "43.08189000",
                        "longitude": "-93.73427000"
                    },
                    {
                        "id": 118003,
                        "name": "Hardin County",
                        "latitude": "42.38388000",
                        "longitude": "-93.24040000"
                    },
                    {
                        "id": 118016,
                        "name": "Harlan",
                        "latitude": "41.65304000",
                        "longitude": "-95.32555000"
                    },
                    {
                        "id": 118067,
                        "name": "Harrison County",
                        "latitude": "41.68285000",
                        "longitude": "-95.81692000"
                    },
                    {
                        "id": 118098,
                        "name": "Hartley",
                        "latitude": "43.17997000",
                        "longitude": "-95.47695000"
                    },
                    {
                        "id": 118163,
                        "name": "Hawarden",
                        "latitude": "42.99582000",
                        "longitude": "-96.48531000"
                    },
                    {
                        "id": 118304,
                        "name": "Henry County",
                        "latitude": "40.98794000",
                        "longitude": "-91.54452000"
                    },
                    {
                        "id": 118358,
                        "name": "Hiawatha",
                        "latitude": "42.03583000",
                        "longitude": "-91.68212000"
                    },
                    {
                        "id": 118573,
                        "name": "Holstein",
                        "latitude": "42.48915000",
                        "longitude": "-95.54500000"
                    },
                    {
                        "id": 118715,
                        "name": "Howard County",
                        "latitude": "43.35677000",
                        "longitude": "-92.31720000"
                    },
                    {
                        "id": 118738,
                        "name": "Hudson",
                        "latitude": "42.40665000",
                        "longitude": "-92.45547000"
                    },
                    {
                        "id": 118771,
                        "name": "Hull",
                        "latitude": "43.18859000",
                        "longitude": "-96.13363000"
                    },
                    {
                        "id": 118777,
                        "name": "Humboldt",
                        "latitude": "42.72080000",
                        "longitude": "-94.21524000"
                    },
                    {
                        "id": 118778,
                        "name": "Humboldt County",
                        "latitude": "42.77647000",
                        "longitude": "-94.20719000"
                    },
                    {
                        "id": 118841,
                        "name": "Huxley",
                        "latitude": "41.89527000",
                        "longitude": "-93.60077000"
                    },
                    {
                        "id": 118866,
                        "name": "Ida County",
                        "latitude": "42.38687000",
                        "longitude": "-95.51350000"
                    },
                    {
                        "id": 118867,
                        "name": "Ida Grove",
                        "latitude": "42.34499000",
                        "longitude": "-95.47167000"
                    },
                    {
                        "id": 118893,
                        "name": "Independence",
                        "latitude": "42.46860000",
                        "longitude": "-91.88934000"
                    },
                    {
                        "id": 118926,
                        "name": "Indianola",
                        "latitude": "41.35805000",
                        "longitude": "-93.55744000"
                    },
                    {
                        "id": 118976,
                        "name": "Iowa City",
                        "latitude": "41.66113000",
                        "longitude": "-91.53017000"
                    },
                    {
                        "id": 118978,
                        "name": "Iowa County",
                        "latitude": "41.68632000",
                        "longitude": "-92.06552000"
                    },
                    {
                        "id": 118980,
                        "name": "Iowa Falls",
                        "latitude": "42.52248000",
                        "longitude": "-93.25131000"
                    },
                    {
                        "id": 119090,
                        "name": "Jackson County",
                        "latitude": "42.17174000",
                        "longitude": "-90.57423000"
                    },
                    {
                        "id": 119151,
                        "name": "Jasper County",
                        "latitude": "41.68604000",
                        "longitude": "-93.05376000"
                    },
                    {
                        "id": 119168,
                        "name": "Jefferson",
                        "latitude": "42.01526000",
                        "longitude": "-94.37747000"
                    },
                    {
                        "id": 119189,
                        "name": "Jefferson County",
                        "latitude": "41.03176000",
                        "longitude": "-91.94888000"
                    },
                    {
                        "id": 119240,
                        "name": "Jesup",
                        "latitude": "42.47554000",
                        "longitude": "-92.06379000"
                    },
                    {
                        "id": 119242,
                        "name": "Jewell",
                        "latitude": "42.30693000",
                        "longitude": "-93.64022000"
                    },
                    {
                        "id": 119269,
                        "name": "Johnson County",
                        "latitude": "41.67155000",
                        "longitude": "-91.58808000"
                    },
                    {
                        "id": 119278,
                        "name": "Johnston",
                        "latitude": "41.67304000",
                        "longitude": "-93.69772000"
                    },
                    {
                        "id": 119296,
                        "name": "Jones County",
                        "latitude": "42.12124000",
                        "longitude": "-91.13144000"
                    },
                    {
                        "id": 119368,
                        "name": "Kalona",
                        "latitude": "41.48307000",
                        "longitude": "-91.70600000"
                    },
                    {
                        "id": 119507,
                        "name": "Keokuk",
                        "latitude": "40.39727000",
                        "longitude": "-91.38487000"
                    },
                    {
                        "id": 119508,
                        "name": "Keokuk County",
                        "latitude": "41.33646000",
                        "longitude": "-92.17864000"
                    },
                    {
                        "id": 119509,
                        "name": "Keosauqua",
                        "latitude": "40.73031000",
                        "longitude": "-91.96239000"
                    },
                    {
                        "id": 119617,
                        "name": "Kingsley",
                        "latitude": "42.58832000",
                        "longitude": "-95.96752000"
                    },
                    {
                        "id": 119695,
                        "name": "Knoxville",
                        "latitude": "41.32083000",
                        "longitude": "-93.10937000"
                    },
                    {
                        "id": 119711,
                        "name": "Kossuth County",
                        "latitude": "43.20413000",
                        "longitude": "-94.20672000"
                    },
                    {
                        "id": 119778,
                        "name": "La Porte City",
                        "latitude": "42.31499000",
                        "longitude": "-92.19213000"
                    },
                    {
                        "id": 119882,
                        "name": "Lake City",
                        "latitude": "42.26748000",
                        "longitude": "-94.73387000"
                    },
                    {
                        "id": 119942,
                        "name": "Lake Mills",
                        "latitude": "43.41940000",
                        "longitude": "-93.53327000"
                    },
                    {
                        "id": 119958,
                        "name": "Lake Panorama",
                        "latitude": "41.71105000",
                        "longitude": "-94.39059000"
                    },
                    {
                        "id": 119961,
                        "name": "Lake Park",
                        "latitude": "43.45552000",
                        "longitude": "-95.32083000"
                    },
                    {
                        "id": 119987,
                        "name": "Lake View",
                        "latitude": "42.31165000",
                        "longitude": "-95.05332000"
                    },
                    {
                        "id": 120073,
                        "name": "Lamoni",
                        "latitude": "40.62278000",
                        "longitude": "-93.93412000"
                    },
                    {
                        "id": 120207,
                        "name": "Laurens",
                        "latitude": "42.84664000",
                        "longitude": "-94.85193000"
                    },
                    {
                        "id": 120258,
                        "name": "Le Claire",
                        "latitude": "41.59864000",
                        "longitude": "-90.34346000"
                    },
                    {
                        "id": 120261,
                        "name": "Le Mars",
                        "latitude": "42.79416000",
                        "longitude": "-96.16558000"
                    },
                    {
                        "id": 120316,
                        "name": "Lee County",
                        "latitude": "40.64198000",
                        "longitude": "-91.47926000"
                    },
                    {
                        "id": 120375,
                        "name": "Lenox",
                        "latitude": "40.88165000",
                        "longitude": "-94.56191000"
                    },
                    {
                        "id": 120383,
                        "name": "Leon",
                        "latitude": "40.73972000",
                        "longitude": "-93.74772000"
                    },
                    {
                        "id": 120583,
                        "name": "Linn County",
                        "latitude": "42.07895000",
                        "longitude": "-91.59896000"
                    },
                    {
                        "id": 120598,
                        "name": "Lisbon",
                        "latitude": "41.92112000",
                        "longitude": "-91.38545000"
                    },
                    {
                        "id": 120694,
                        "name": "Logan",
                        "latitude": "41.64305000",
                        "longitude": "-95.78890000"
                    },
                    {
                        "id": 120731,
                        "name": "Lone Tree",
                        "latitude": "41.48808000",
                        "longitude": "-91.42599000"
                    },
                    {
                        "id": 120807,
                        "name": "Louisa County",
                        "latitude": "41.21851000",
                        "longitude": "-91.25962000"
                    },
                    {
                        "id": 120861,
                        "name": "Lucas County",
                        "latitude": "41.02937000",
                        "longitude": "-93.32772000"
                    },
                    {
                        "id": 120937,
                        "name": "Lyon County",
                        "latitude": "43.38050000",
                        "longitude": "-96.21029000"
                    },
                    {
                        "id": 121014,
                        "name": "Madison County",
                        "latitude": "41.33071000",
                        "longitude": "-94.01556000"
                    },
                    {
                        "id": 121029,
                        "name": "Madrid",
                        "latitude": "41.87665000",
                        "longitude": "-93.82328000"
                    },
                    {
                        "id": 121041,
                        "name": "Maharishi Vedic City",
                        "latitude": "41.05252000",
                        "longitude": "-91.99490000"
                    },
                    {
                        "id": 121042,
                        "name": "Mahaska County",
                        "latitude": "41.33520000",
                        "longitude": "-92.64091000"
                    },
                    {
                        "id": 121072,
                        "name": "Malvern",
                        "latitude": "41.00278000",
                        "longitude": "-95.58528000"
                    },
                    {
                        "id": 121095,
                        "name": "Manchester",
                        "latitude": "42.48415000",
                        "longitude": "-91.45543000"
                    },
                    {
                        "id": 121132,
                        "name": "Manly",
                        "latitude": "43.28718000",
                        "longitude": "-93.20215000"
                    },
                    {
                        "id": 121135,
                        "name": "Manning",
                        "latitude": "41.90915000",
                        "longitude": "-95.06499000"
                    },
                    {
                        "id": 121150,
                        "name": "Manson",
                        "latitude": "42.52914000",
                        "longitude": "-94.53414000"
                    },
                    {
                        "id": 121174,
                        "name": "Mapleton",
                        "latitude": "42.16582000",
                        "longitude": "-95.79306000"
                    },
                    {
                        "id": 121181,
                        "name": "Maquoketa",
                        "latitude": "42.06891000",
                        "longitude": "-90.66569000"
                    },
                    {
                        "id": 121199,
                        "name": "Marcus",
                        "latitude": "42.82582000",
                        "longitude": "-95.80751000"
                    },
                    {
                        "id": 121201,
                        "name": "Marengo",
                        "latitude": "41.79806000",
                        "longitude": "-92.07074000"
                    },
                    {
                        "id": 121240,
                        "name": "Marion",
                        "latitude": "42.03417000",
                        "longitude": "-91.59768000"
                    },
                    {
                        "id": 121261,
                        "name": "Marion County",
                        "latitude": "41.33445000",
                        "longitude": "-93.09944000"
                    },
                    {
                        "id": 121317,
                        "name": "Marshall County",
                        "latitude": "42.03585000",
                        "longitude": "-92.99877000"
                    },
                    {
                        "id": 121323,
                        "name": "Marshalltown",
                        "latitude": "42.04943000",
                        "longitude": "-92.90798000"
                    },
                    {
                        "id": 121375,
                        "name": "Mason City",
                        "latitude": "43.15357000",
                        "longitude": "-93.20104000"
                    },
                    {
                        "id": 121584,
                        "name": "Mechanicsville",
                        "latitude": "41.90446000",
                        "longitude": "-91.25461000"
                    },
                    {
                        "id": 121599,
                        "name": "Mediapolis",
                        "latitude": "41.00809000",
                        "longitude": "-91.16404000"
                    },
                    {
                        "id": 121623,
                        "name": "Melcher-Dallas",
                        "latitude": "41.22500000",
                        "longitude": "-93.24132000"
                    },
                    {
                        "id": 121848,
                        "name": "Milford",
                        "latitude": "43.32469000",
                        "longitude": "-95.15000000"
                    },
                    {
                        "id": 121898,
                        "name": "Mills County",
                        "latitude": "41.03345000",
                        "longitude": "-95.62133000"
                    },
                    {
                        "id": 121994,
                        "name": "Missouri Valley",
                        "latitude": "41.55638000",
                        "longitude": "-95.88779000"
                    },
                    {
                        "id": 122002,
                        "name": "Mitchell County",
                        "latitude": "43.35641000",
                        "longitude": "-92.78903000"
                    },
                    {
                        "id": 122005,
                        "name": "Mitchellville",
                        "latitude": "41.66860000",
                        "longitude": "-93.35771000"
                    },
                    {
                        "id": 122051,
                        "name": "Monona",
                        "latitude": "43.05165000",
                        "longitude": "-91.38930000"
                    },
                    {
                        "id": 122053,
                        "name": "Monona County",
                        "latitude": "42.05167000",
                        "longitude": "-95.95992000"
                    },
                    {
                        "id": 122060,
                        "name": "Monroe",
                        "latitude": "41.52221000",
                        "longitude": "-93.10187000"
                    },
                    {
                        "id": 122078,
                        "name": "Monroe County",
                        "latitude": "41.02978000",
                        "longitude": "-92.86899000"
                    },
                    {
                        "id": 122128,
                        "name": "Montezuma",
                        "latitude": "41.58583000",
                        "longitude": "-92.52741000"
                    },
                    {
                        "id": 122152,
                        "name": "Montgomery County",
                        "latitude": "41.03014000",
                        "longitude": "-95.15638000"
                    },
                    {
                        "id": 122164,
                        "name": "Monticello",
                        "latitude": "42.23834000",
                        "longitude": "-91.18709000"
                    },
                    {
                        "id": 122334,
                        "name": "Mount Ayr",
                        "latitude": "40.71471000",
                        "longitude": "-94.23523000"
                    },
                    {
                        "id": 122378,
                        "name": "Mount Pleasant",
                        "latitude": "40.96364000",
                        "longitude": "-91.55794000"
                    },
                    {
                        "id": 122400,
                        "name": "Mount Vernon",
                        "latitude": "41.92195000",
                        "longitude": "-91.41684000"
                    },
                    {
                        "id": 122442,
                        "name": "Moville",
                        "latitude": "42.48888000",
                        "longitude": "-96.07252000"
                    },
                    {
                        "id": 122501,
                        "name": "Muscatine",
                        "latitude": "41.42447000",
                        "longitude": "-91.04321000"
                    },
                    {
                        "id": 122502,
                        "name": "Muscatine County",
                        "latitude": "41.48392000",
                        "longitude": "-91.11276000"
                    },
                    {
                        "id": 122570,
                        "name": "Nashua",
                        "latitude": "42.95275000",
                        "longitude": "-92.53630000"
                    },
                    {
                        "id": 122650,
                        "name": "Nevada",
                        "latitude": "42.02277000",
                        "longitude": "-93.45243000"
                    },
                    {
                        "id": 122710,
                        "name": "New Hampton",
                        "latitude": "43.05914000",
                        "longitude": "-92.31768000"
                    },
                    {
                        "id": 122742,
                        "name": "New London",
                        "latitude": "40.92698000",
                        "longitude": "-91.39960000"
                    },
                    {
                        "id": 122776,
                        "name": "New Sharon",
                        "latitude": "41.47000000",
                        "longitude": "-92.65130000"
                    },
                    {
                        "id": 122863,
                        "name": "Newton",
                        "latitude": "41.69971000",
                        "longitude": "-93.04798000"
                    },
                    {
                        "id": 122937,
                        "name": "Nora Springs",
                        "latitude": "43.14275000",
                        "longitude": "-93.00437000"
                    },
                    {
                        "id": 123023,
                        "name": "North English",
                        "latitude": "41.51390000",
                        "longitude": "-92.07629000"
                    },
                    {
                        "id": 123056,
                        "name": "North Liberty",
                        "latitude": "41.74918000",
                        "longitude": "-91.59795000"
                    },
                    {
                        "id": 123179,
                        "name": "Northwood",
                        "latitude": "43.44412000",
                        "longitude": "-93.22104000"
                    },
                    {
                        "id": 123189,
                        "name": "Norwalk",
                        "latitude": "41.47555000",
                        "longitude": "-93.67883000"
                    },
                    {
                        "id": 123225,
                        "name": "O'Brien County",
                        "latitude": "43.08375000",
                        "longitude": "-95.62488000"
                    },
                    {
                        "id": 123288,
                        "name": "Oakland",
                        "latitude": "41.30916000",
                        "longitude": "-95.39667000"
                    },
                    {
                        "id": 123363,
                        "name": "Oelwein",
                        "latitude": "42.67332000",
                        "longitude": "-91.91350000"
                    },
                    {
                        "id": 123368,
                        "name": "Ogden",
                        "latitude": "42.03915000",
                        "longitude": "-94.02773000"
                    },
                    {
                        "id": 123471,
                        "name": "Onawa",
                        "latitude": "42.02665000",
                        "longitude": "-96.09724000"
                    },
                    {
                        "id": 123513,
                        "name": "Orange City",
                        "latitude": "43.00721000",
                        "longitude": "-96.05835000"
                    },
                    {
                        "id": 123586,
                        "name": "Osage",
                        "latitude": "43.28414000",
                        "longitude": "-92.81103000"
                    },
                    {
                        "id": 123599,
                        "name": "Osceola",
                        "latitude": "41.03389000",
                        "longitude": "-93.76550000"
                    },
                    {
                        "id": 123604,
                        "name": "Osceola County",
                        "latitude": "43.37857000",
                        "longitude": "-95.62369000"
                    },
                    {
                        "id": 123612,
                        "name": "Oskaloosa",
                        "latitude": "41.29639000",
                        "longitude": "-92.64436000"
                    },
                    {
                        "id": 123643,
                        "name": "Ottumwa",
                        "latitude": "41.02001000",
                        "longitude": "-92.41130000"
                    },
                    {
                        "id": 123719,
                        "name": "Page County",
                        "latitude": "40.73914000",
                        "longitude": "-95.15017000"
                    },
                    {
                        "id": 123779,
                        "name": "Palo",
                        "latitude": "42.06611000",
                        "longitude": "-91.79546000"
                    },
                    {
                        "id": 123782,
                        "name": "Palo Alto County",
                        "latitude": "43.08206000",
                        "longitude": "-94.67814000"
                    },
                    {
                        "id": 123805,
                        "name": "Panora",
                        "latitude": "41.69165000",
                        "longitude": "-94.36302000"
                    },
                    {
                        "id": 123855,
                        "name": "Park View",
                        "latitude": "41.69420000",
                        "longitude": "-90.54569000"
                    },
                    {
                        "id": 123867,
                        "name": "Parkersburg",
                        "latitude": "42.57748000",
                        "longitude": "-92.78686000"
                    },
                    {
                        "id": 123924,
                        "name": "Paullina",
                        "latitude": "42.97915000",
                        "longitude": "-95.68807000"
                    },
                    {
                        "id": 123999,
                        "name": "Pella",
                        "latitude": "41.40805000",
                        "longitude": "-92.91631000"
                    },
                    {
                        "id": 124050,
                        "name": "Peosta",
                        "latitude": "42.45056000",
                        "longitude": "-90.85041000"
                    },
                    {
                        "id": 124070,
                        "name": "Perry",
                        "latitude": "41.83860000",
                        "longitude": "-94.10718000"
                    },
                    {
                        "id": 124370,
                        "name": "Pleasant Hill",
                        "latitude": "41.58388000",
                        "longitude": "-93.51994000"
                    },
                    {
                        "id": 124387,
                        "name": "Pleasantville",
                        "latitude": "41.38583000",
                        "longitude": "-93.26937000"
                    },
                    {
                        "id": 124409,
                        "name": "Plymouth County",
                        "latitude": "42.73783000",
                        "longitude": "-96.21404000"
                    },
                    {
                        "id": 124414,
                        "name": "Pocahontas",
                        "latitude": "42.73553000",
                        "longitude": "-94.66915000"
                    },
                    {
                        "id": 124416,
                        "name": "Pocahontas County",
                        "latitude": "42.73414000",
                        "longitude": "-94.67875000"
                    },
                    {
                        "id": 124439,
                        "name": "Polk City",
                        "latitude": "41.77138000",
                        "longitude": "-93.71300000"
                    },
                    {
                        "id": 124447,
                        "name": "Polk County",
                        "latitude": "41.68550000",
                        "longitude": "-93.57353000"
                    },
                    {
                        "id": 124578,
                        "name": "Postville",
                        "latitude": "43.08470000",
                        "longitude": "-91.56820000"
                    },
                    {
                        "id": 124591,
                        "name": "Pottawattamie County",
                        "latitude": "41.33661000",
                        "longitude": "-95.54239000"
                    },
                    {
                        "id": 124617,
                        "name": "Poweshiek County",
                        "latitude": "41.68644000",
                        "longitude": "-92.53147000"
                    },
                    {
                        "id": 124623,
                        "name": "Prairie City",
                        "latitude": "41.59943000",
                        "longitude": "-93.23521000"
                    },
                    {
                        "id": 124655,
                        "name": "Preston",
                        "latitude": "42.05030000",
                        "longitude": "-90.41402000"
                    },
                    {
                        "id": 124671,
                        "name": "Primghar",
                        "latitude": "43.08692000",
                        "longitude": "-95.62723000"
                    },
                    {
                        "id": 124957,
                        "name": "Red Oak",
                        "latitude": "41.00972000",
                        "longitude": "-95.22555000"
                    },
                    {
                        "id": 125010,
                        "name": "Reinbeck",
                        "latitude": "42.32360000",
                        "longitude": "-92.59936000"
                    },
                    {
                        "id": 125015,
                        "name": "Remsen",
                        "latitude": "42.81471000",
                        "longitude": "-95.97335000"
                    },
                    {
                        "id": 125143,
                        "name": "Ringgold County",
                        "latitude": "40.73520000",
                        "longitude": "-94.24397000"
                    },
                    {
                        "id": 125205,
                        "name": "Riverside",
                        "latitude": "41.47974000",
                        "longitude": "-91.58128000"
                    },
                    {
                        "id": 125251,
                        "name": "Robins",
                        "latitude": "42.07111000",
                        "longitude": "-91.66684000"
                    },
                    {
                        "id": 125286,
                        "name": "Rock Rapids",
                        "latitude": "43.42719000",
                        "longitude": "-96.17586000"
                    },
                    {
                        "id": 125288,
                        "name": "Rock Valley",
                        "latitude": "43.20526000",
                        "longitude": "-96.29503000"
                    },
                    {
                        "id": 125330,
                        "name": "Rockwell",
                        "latitude": "42.98524000",
                        "longitude": "-93.19187000"
                    },
                    {
                        "id": 125331,
                        "name": "Rockwell City",
                        "latitude": "42.39526000",
                        "longitude": "-94.63387000"
                    },
                    {
                        "id": 125360,
                        "name": "Roland",
                        "latitude": "42.16637000",
                        "longitude": "-93.50188000"
                    },
                    {
                        "id": 125571,
                        "name": "Sac City",
                        "latitude": "42.42220000",
                        "longitude": "-94.98971000"
                    },
                    {
                        "id": 125572,
                        "name": "Sac County",
                        "latitude": "42.38626000",
                        "longitude": "-95.10539000"
                    },
                    {
                        "id": 125600,
                        "name": "Saint Ansgar",
                        "latitude": "43.37830000",
                        "longitude": "-92.91881000"
                    },
                    {
                        "id": 125853,
                        "name": "Sanborn",
                        "latitude": "43.18164000",
                        "longitude": "-95.65557000"
                    },
                    {
                        "id": 125988,
                        "name": "Saylorville",
                        "latitude": "41.67860000",
                        "longitude": "-93.62966000"
                    },
                    {
                        "id": 126051,
                        "name": "Scott County",
                        "latitude": "41.63710000",
                        "longitude": "-90.62324000"
                    },
                    {
                        "id": 126167,
                        "name": "Sergeant Bluff",
                        "latitude": "42.40388000",
                        "longitude": "-96.35864000"
                    },
                    {
                        "id": 126260,
                        "name": "Sheffield",
                        "latitude": "42.89330000",
                        "longitude": "-93.21520000"
                    },
                    {
                        "id": 126279,
                        "name": "Shelby County",
                        "latitude": "41.68509000",
                        "longitude": "-95.31021000"
                    },
                    {
                        "id": 126286,
                        "name": "Sheldon",
                        "latitude": "43.18109000",
                        "longitude": "-95.85613000"
                    },
                    {
                        "id": 126292,
                        "name": "Shell Rock",
                        "latitude": "42.71026000",
                        "longitude": "-92.58297000"
                    },
                    {
                        "id": 126302,
                        "name": "Shenandoah",
                        "latitude": "40.76555000",
                        "longitude": "-95.37221000"
                    },
                    {
                        "id": 126391,
                        "name": "Sibley",
                        "latitude": "43.39914000",
                        "longitude": "-95.75196000"
                    },
                    {
                        "id": 126394,
                        "name": "Sidney",
                        "latitude": "40.74833000",
                        "longitude": "-95.64750000"
                    },
                    {
                        "id": 126413,
                        "name": "Sigourney",
                        "latitude": "41.33334000",
                        "longitude": "-92.20463000"
                    },
                    {
                        "id": 126457,
                        "name": "Sioux Center",
                        "latitude": "43.07971000",
                        "longitude": "-96.17558000"
                    },
                    {
                        "id": 126458,
                        "name": "Sioux City",
                        "latitude": "42.49999000",
                        "longitude": "-96.40031000"
                    },
                    {
                        "id": 126459,
                        "name": "Sioux County",
                        "latitude": "43.08262000",
                        "longitude": "-96.17788000"
                    },
                    {
                        "id": 126490,
                        "name": "Slater",
                        "latitude": "41.87776000",
                        "longitude": "-93.67855000"
                    },
                    {
                        "id": 126571,
                        "name": "Solon",
                        "latitude": "41.80723000",
                        "longitude": "-91.49406000"
                    },
                    {
                        "id": 126825,
                        "name": "Spencer",
                        "latitude": "43.14136000",
                        "longitude": "-95.14444000"
                    },
                    {
                        "id": 126838,
                        "name": "Spirit Lake",
                        "latitude": "43.42218000",
                        "longitude": "-95.10222000"
                    },
                    {
                        "id": 126915,
                        "name": "Springville",
                        "latitude": "42.05945000",
                        "longitude": "-91.44267000"
                    },
                    {
                        "id": 126991,
                        "name": "State Center",
                        "latitude": "42.01665000",
                        "longitude": "-93.16354000"
                    },
                    {
                        "id": 127103,
                        "name": "Storm Lake",
                        "latitude": "42.64109000",
                        "longitude": "-95.20972000"
                    },
                    {
                        "id": 127106,
                        "name": "Story City",
                        "latitude": "42.18721000",
                        "longitude": "-93.59577000"
                    },
                    {
                        "id": 127107,
                        "name": "Story County",
                        "latitude": "42.03624000",
                        "longitude": "-93.46504000"
                    },
                    {
                        "id": 127134,
                        "name": "Strawberry Point",
                        "latitude": "42.68360000",
                        "longitude": "-91.53403000"
                    },
                    {
                        "id": 127143,
                        "name": "Stuart",
                        "latitude": "41.50332000",
                        "longitude": "-94.31857000"
                    },
                    {
                        "id": 127222,
                        "name": "Sumner",
                        "latitude": "42.84748000",
                        "longitude": "-92.09156000"
                    },
                    {
                        "id": 127400,
                        "name": "Tama",
                        "latitude": "41.96666000",
                        "longitude": "-92.57686000"
                    },
                    {
                        "id": 127401,
                        "name": "Tama County",
                        "latitude": "42.07981000",
                        "longitude": "-92.53254000"
                    },
                    {
                        "id": 127456,
                        "name": "Taylor County",
                        "latitude": "40.73743000",
                        "longitude": "-94.69641000"
                    },
                    {
                        "id": 127640,
                        "name": "Tiffin",
                        "latitude": "41.70585000",
                        "longitude": "-91.66295000"
                    },
                    {
                        "id": 127675,
                        "name": "Tipton",
                        "latitude": "41.76974000",
                        "longitude": "-91.12793000"
                    },
                    {
                        "id": 127699,
                        "name": "Toledo",
                        "latitude": "41.99555000",
                        "longitude": "-92.57686000"
                    },
                    {
                        "id": 127774,
                        "name": "Traer",
                        "latitude": "42.19360000",
                        "longitude": "-92.46547000"
                    },
                    {
                        "id": 127831,
                        "name": "Tripoli",
                        "latitude": "42.80804000",
                        "longitude": "-92.25823000"
                    },
                    {
                        "id": 127998,
                        "name": "Union County",
                        "latitude": "41.02773000",
                        "longitude": "-94.24238000"
                    },
                    {
                        "id": 128029,
                        "name": "University Heights",
                        "latitude": "41.65502000",
                        "longitude": "-91.55684000"
                    },
                    {
                        "id": 128061,
                        "name": "Urbana",
                        "latitude": "42.22416000",
                        "longitude": "-91.87434000"
                    },
                    {
                        "id": 128063,
                        "name": "Urbandale",
                        "latitude": "41.62666000",
                        "longitude": "-93.71217000"
                    },
                    {
                        "id": 128131,
                        "name": "Van Buren County",
                        "latitude": "40.75323000",
                        "longitude": "-91.94999000"
                    },
                    {
                        "id": 128135,
                        "name": "Van Meter",
                        "latitude": "41.53193000",
                        "longitude": "-93.95412000"
                    },
                    {
                        "id": 128260,
                        "name": "Villisca",
                        "latitude": "40.92971000",
                        "longitude": "-94.97609000"
                    },
                    {
                        "id": 128280,
                        "name": "Vinton",
                        "latitude": "42.16861000",
                        "longitude": "-92.02351000"
                    },
                    {
                        "id": 128366,
                        "name": "Walcott",
                        "latitude": "41.58475000",
                        "longitude": "-90.77209000"
                    },
                    {
                        "id": 128381,
                        "name": "Walford",
                        "latitude": "41.87834000",
                        "longitude": "-91.83462000"
                    },
                    {
                        "id": 128454,
                        "name": "Wapello",
                        "latitude": "41.18142000",
                        "longitude": "-91.18543000"
                    },
                    {
                        "id": 128455,
                        "name": "Wapello County",
                        "latitude": "41.03058000",
                        "longitude": "-92.40945000"
                    },
                    {
                        "id": 128493,
                        "name": "Warren County",
                        "latitude": "41.33437000",
                        "longitude": "-93.56136000"
                    },
                    {
                        "id": 128542,
                        "name": "Washington",
                        "latitude": "41.29918000",
                        "longitude": "-91.69294000"
                    },
                    {
                        "id": 128568,
                        "name": "Washington County",
                        "latitude": "41.33559000",
                        "longitude": "-91.71787000"
                    },
                    {
                        "id": 128612,
                        "name": "Waterloo",
                        "latitude": "42.49276000",
                        "longitude": "-92.34296000"
                    },
                    {
                        "id": 128647,
                        "name": "Waukee",
                        "latitude": "41.61166000",
                        "longitude": "-93.88523000"
                    },
                    {
                        "id": 128652,
                        "name": "Waukon",
                        "latitude": "43.26942000",
                        "longitude": "-91.47570000"
                    },
                    {
                        "id": 128668,
                        "name": "Waverly",
                        "latitude": "42.72581000",
                        "longitude": "-92.47546000"
                    },
                    {
                        "id": 128698,
                        "name": "Wayne County",
                        "latitude": "40.73947000",
                        "longitude": "-93.32736000"
                    },
                    {
                        "id": 128735,
                        "name": "Webster City",
                        "latitude": "42.46942000",
                        "longitude": "-93.81605000"
                    },
                    {
                        "id": 128741,
                        "name": "Webster County",
                        "latitude": "42.42797000",
                        "longitude": "-94.18179000"
                    },
                    {
                        "id": 128781,
                        "name": "Wellman",
                        "latitude": "41.46418000",
                        "longitude": "-91.83823000"
                    },
                    {
                        "id": 128832,
                        "name": "West Branch",
                        "latitude": "41.67141000",
                        "longitude": "-91.34655000"
                    },
                    {
                        "id": 128838,
                        "name": "West Burlington",
                        "latitude": "40.82504000",
                        "longitude": "-91.15654000"
                    },
                    {
                        "id": 128857,
                        "name": "West Des Moines",
                        "latitude": "41.57721000",
                        "longitude": "-93.71133000"
                    },
                    {
                        "id": 128917,
                        "name": "West Liberty",
                        "latitude": "41.57002000",
                        "longitude": "-91.26377000"
                    },
                    {
                        "id": 128993,
                        "name": "West Union",
                        "latitude": "42.96276000",
                        "longitude": "-91.80822000"
                    },
                    {
                        "id": 129267,
                        "name": "Williamsburg",
                        "latitude": "41.66112000",
                        "longitude": "-92.00907000"
                    },
                    {
                        "id": 129343,
                        "name": "Wilton",
                        "latitude": "41.58892000",
                        "longitude": "-91.01682000"
                    },
                    {
                        "id": 129389,
                        "name": "Windsor Heights",
                        "latitude": "41.59777000",
                        "longitude": "-93.70828000"
                    },
                    {
                        "id": 129395,
                        "name": "Winfield",
                        "latitude": "41.12308000",
                        "longitude": "-91.44127000"
                    },
                    {
                        "id": 129407,
                        "name": "Winnebago County",
                        "latitude": "43.37757000",
                        "longitude": "-93.73420000"
                    },
                    {
                        "id": 129413,
                        "name": "Winneshiek County",
                        "latitude": "43.29067000",
                        "longitude": "-91.84371000"
                    },
                    {
                        "id": 129446,
                        "name": "Winterset",
                        "latitude": "41.33082000",
                        "longitude": "-94.01384000"
                    },
                    {
                        "id": 129496,
                        "name": "Woodbine",
                        "latitude": "41.73832000",
                        "longitude": "-95.70278000"
                    },
                    {
                        "id": 129512,
                        "name": "Woodbury County",
                        "latitude": "42.38972000",
                        "longitude": "-96.04477000"
                    },
                    {
                        "id": 129576,
                        "name": "Woodward",
                        "latitude": "41.85693000",
                        "longitude": "-93.92190000"
                    },
                    {
                        "id": 129593,
                        "name": "Worth County",
                        "latitude": "43.37740000",
                        "longitude": "-93.26085000"
                    },
                    {
                        "id": 129609,
                        "name": "Wright County",
                        "latitude": "42.73312000",
                        "longitude": "-93.73515000"
                    }
                ]
            },
            {
                "id": 1410,
                "name": "Jarvis Island",
                "iso2": "UM-86",
                "latitude": "-0.37435030",
                "longitude": "-159.99672060",
                "type": "islands \/ groups of islands",
                "cities": []
            },
            {
                "id": 1428,
                "name": "Johnston Atoll",
                "iso2": "UM-67",
                "latitude": "16.72950350",
                "longitude": "-169.53364770",
                "type": "islands \/ groups of islands",
                "cities": []
            },
            {
                "id": 1406,
                "name": "Kansas",
                "iso2": "KS",
                "latitude": "39.01190200",
                "longitude": "-98.48424650",
                "type": "state",
                "cities": [
                    {
                        "id": 110982,
                        "name": "Abilene",
                        "latitude": "38.91722000",
                        "longitude": "-97.21391000"
                    },
                    {
                        "id": 111188,
                        "name": "Allen County",
                        "latitude": "37.88573000",
                        "longitude": "-95.30139000"
                    },
                    {
                        "id": 111208,
                        "name": "Alma",
                        "latitude": "39.01667000",
                        "longitude": "-96.28916000"
                    },
                    {
                        "id": 111233,
                        "name": "Altamont",
                        "latitude": "37.19034000",
                        "longitude": "-95.29719000"
                    },
                    {
                        "id": 111315,
                        "name": "Anderson County",
                        "latitude": "38.21420000",
                        "longitude": "-95.29333000"
                    },
                    {
                        "id": 111322,
                        "name": "Andover",
                        "latitude": "37.71390000",
                        "longitude": "-97.13643000"
                    },
                    {
                        "id": 111368,
                        "name": "Anthony",
                        "latitude": "37.15336000",
                        "longitude": "-98.03117000"
                    },
                    {
                        "id": 111457,
                        "name": "Arkansas City",
                        "latitude": "37.06197000",
                        "longitude": "-97.03837000"
                    },
                    {
                        "id": 111475,
                        "name": "Arma",
                        "latitude": "37.54394000",
                        "longitude": "-94.70024000"
                    },
                    {
                        "id": 111527,
                        "name": "Ashland",
                        "latitude": "37.18864000",
                        "longitude": "-99.76568000"
                    },
                    {
                        "id": 111567,
                        "name": "Atchison",
                        "latitude": "39.56305000",
                        "longitude": "-95.12164000"
                    },
                    {
                        "id": 111568,
                        "name": "Atchison County",
                        "latitude": "39.53174000",
                        "longitude": "-95.31344000"
                    },
                    {
                        "id": 111615,
                        "name": "Atwood",
                        "latitude": "39.80667000",
                        "longitude": "-101.04210000"
                    },
                    {
                        "id": 111622,
                        "name": "Auburn",
                        "latitude": "38.90611000",
                        "longitude": "-95.81610000"
                    },
                    {
                        "id": 111647,
                        "name": "Augusta",
                        "latitude": "37.68668000",
                        "longitude": "-96.97670000"
                    },
                    {
                        "id": 111759,
                        "name": "Baldwin City",
                        "latitude": "38.77501000",
                        "longitude": "-95.18636000"
                    },
                    {
                        "id": 111812,
                        "name": "Barber County",
                        "latitude": "37.22884000",
                        "longitude": "-98.68479000"
                    },
                    {
                        "id": 111866,
                        "name": "Barton County",
                        "latitude": "38.47896000",
                        "longitude": "-98.75646000"
                    },
                    {
                        "id": 111876,
                        "name": "Basehor",
                        "latitude": "39.14167000",
                        "longitude": "-94.93858000"
                    },
                    {
                        "id": 111919,
                        "name": "Baxter Springs",
                        "latitude": "37.02368000",
                        "longitude": "-94.73550000"
                    },
                    {
                        "id": 112074,
                        "name": "Bellaire",
                        "latitude": "37.76251000",
                        "longitude": "-97.26699000"
                    },
                    {
                        "id": 112088,
                        "name": "Belle Plaine",
                        "latitude": "37.39391000",
                        "longitude": "-97.28115000"
                    },
                    {
                        "id": 112104,
                        "name": "Belleville",
                        "latitude": "39.82445000",
                        "longitude": "-97.63254000"
                    },
                    {
                        "id": 112145,
                        "name": "Beloit",
                        "latitude": "39.45612000",
                        "longitude": "-98.10616000"
                    },
                    {
                        "id": 112543,
                        "name": "Bonner Springs",
                        "latitude": "39.05973000",
                        "longitude": "-94.88358000"
                    },
                    {
                        "id": 112613,
                        "name": "Bourbon County",
                        "latitude": "37.85523000",
                        "longitude": "-94.84930000"
                    },
                    {
                        "id": 112909,
                        "name": "Brown County",
                        "latitude": "39.82650000",
                        "longitude": "-95.56422000"
                    },
                    {
                        "id": 113024,
                        "name": "Buhler",
                        "latitude": "38.13445000",
                        "longitude": "-97.77005000"
                    },
                    {
                        "id": 113066,
                        "name": "Burlington",
                        "latitude": "38.19447000",
                        "longitude": "-95.74276000"
                    },
                    {
                        "id": 113115,
                        "name": "Butler County",
                        "latitude": "37.78127000",
                        "longitude": "-96.83907000"
                    },
                    {
                        "id": 113179,
                        "name": "Caldwell",
                        "latitude": "37.03225000",
                        "longitude": "-97.60699000"
                    },
                    {
                        "id": 113328,
                        "name": "Caney",
                        "latitude": "37.01146000",
                        "longitude": "-95.93526000"
                    },
                    {
                        "id": 113387,
                        "name": "Carbondale",
                        "latitude": "38.81862000",
                        "longitude": "-95.68915000"
                    },
                    {
                        "id": 113739,
                        "name": "Chanute",
                        "latitude": "37.67921000",
                        "longitude": "-95.45720000"
                    },
                    {
                        "id": 113744,
                        "name": "Chapman",
                        "latitude": "38.97222000",
                        "longitude": "-97.02251000"
                    },
                    {
                        "id": 113792,
                        "name": "Chase County",
                        "latitude": "38.30205000",
                        "longitude": "-96.59393000"
                    },
                    {
                        "id": 113814,
                        "name": "Chautauqua County",
                        "latitude": "37.15006000",
                        "longitude": "-96.24538000"
                    },
                    {
                        "id": 113839,
                        "name": "Cheney",
                        "latitude": "37.63001000",
                        "longitude": "-97.78255000"
                    },
                    {
                        "id": 113851,
                        "name": "Cherokee County",
                        "latitude": "37.16931000",
                        "longitude": "-94.84627000"
                    },
                    {
                        "id": 113868,
                        "name": "Cherryvale",
                        "latitude": "37.27034000",
                        "longitude": "-95.55248000"
                    },
                    {
                        "id": 113916,
                        "name": "Chetopa",
                        "latitude": "37.03729000",
                        "longitude": "-95.08996000"
                    },
                    {
                        "id": 113928,
                        "name": "Cheyenne County",
                        "latitude": "39.78587000",
                        "longitude": "-101.73110000"
                    },
                    {
                        "id": 114023,
                        "name": "Cimarron",
                        "latitude": "37.80669000",
                        "longitude": "-100.34820000"
                    },
                    {
                        "id": 114124,
                        "name": "Clark County",
                        "latitude": "37.23552000",
                        "longitude": "-99.82031000"
                    },
                    {
                        "id": 114170,
                        "name": "Clay Center",
                        "latitude": "39.37694000",
                        "longitude": "-97.12474000"
                    },
                    {
                        "id": 114179,
                        "name": "Clay County",
                        "latitude": "39.34971000",
                        "longitude": "-97.16517000"
                    },
                    {
                        "id": 114223,
                        "name": "Clearwater",
                        "latitude": "37.50280000",
                        "longitude": "-97.50449000"
                    },
                    {
                        "id": 114306,
                        "name": "Cloud County",
                        "latitude": "39.48030000",
                        "longitude": "-97.64928000"
                    },
                    {
                        "id": 114370,
                        "name": "Coffey County",
                        "latitude": "38.23684000",
                        "longitude": "-95.73411000"
                    },
                    {
                        "id": 114371,
                        "name": "Coffeyville",
                        "latitude": "37.03730000",
                        "longitude": "-95.61637000"
                    },
                    {
                        "id": 114381,
                        "name": "Colby",
                        "latitude": "39.39584000",
                        "longitude": "-101.05238000"
                    },
                    {
                        "id": 114392,
                        "name": "Coldwater",
                        "latitude": "37.26891000",
                        "longitude": "-99.32678000"
                    },
                    {
                        "id": 114492,
                        "name": "Columbus",
                        "latitude": "37.16923000",
                        "longitude": "-94.84412000"
                    },
                    {
                        "id": 114507,
                        "name": "Colwich",
                        "latitude": "37.77918000",
                        "longitude": "-97.53644000"
                    },
                    {
                        "id": 114512,
                        "name": "Comanche County",
                        "latitude": "37.19128000",
                        "longitude": "-99.27187000"
                    },
                    {
                        "id": 114544,
                        "name": "Concordia",
                        "latitude": "39.57084000",
                        "longitude": "-97.66254000"
                    },
                    {
                        "id": 114588,
                        "name": "Conway Springs",
                        "latitude": "37.39030000",
                        "longitude": "-97.64227000"
                    },
                    {
                        "id": 114704,
                        "name": "Cottonwood Falls",
                        "latitude": "38.37224000",
                        "longitude": "-96.54278000"
                    },
                    {
                        "id": 114713,
                        "name": "Council Grove",
                        "latitude": "38.66112000",
                        "longitude": "-96.49195000"
                    },
                    {
                        "id": 114748,
                        "name": "Cowley County",
                        "latitude": "37.23775000",
                        "longitude": "-96.83749000"
                    },
                    {
                        "id": 114778,
                        "name": "Crawford County",
                        "latitude": "37.50732000",
                        "longitude": "-94.85181000"
                    },
                    {
                        "id": 115115,
                        "name": "De Soto",
                        "latitude": "38.97917000",
                        "longitude": "-94.96858000"
                    },
                    {
                        "id": 115163,
                        "name": "Decatur County",
                        "latitude": "39.78476000",
                        "longitude": "-100.45990000"
                    },
                    {
                        "id": 115260,
                        "name": "Derby",
                        "latitude": "37.54557000",
                        "longitude": "-97.26893000"
                    },
                    {
                        "id": 115327,
                        "name": "Dickinson County",
                        "latitude": "38.86650000",
                        "longitude": "-97.15270000"
                    },
                    {
                        "id": 115336,
                        "name": "Dighton",
                        "latitude": "38.48196000",
                        "longitude": "-100.46708000"
                    },
                    {
                        "id": 115376,
                        "name": "Dodge City",
                        "latitude": "37.75280000",
                        "longitude": "-100.01708000"
                    },
                    {
                        "id": 115398,
                        "name": "Doniphan County",
                        "latitude": "39.78808000",
                        "longitude": "-95.14679000"
                    },
                    {
                        "id": 115427,
                        "name": "Douglas County",
                        "latitude": "38.88466000",
                        "longitude": "-95.29261000"
                    },
                    {
                        "id": 115437,
                        "name": "Douglass",
                        "latitude": "37.51946000",
                        "longitude": "-97.01281000"
                    },
                    {
                        "id": 115848,
                        "name": "Edgerton",
                        "latitude": "38.76473000",
                        "longitude": "-95.00802000"
                    },
                    {
                        "id": 115890,
                        "name": "Edwards County",
                        "latitude": "37.88765000",
                        "longitude": "-99.31217000"
                    },
                    {
                        "id": 115893,
                        "name": "Edwardsville",
                        "latitude": "39.06112000",
                        "longitude": "-94.81968000"
                    },
                    {
                        "id": 115920,
                        "name": "El Dorado",
                        "latitude": "37.81724000",
                        "longitude": "-96.86225000"
                    },
                    {
                        "id": 115984,
                        "name": "Elk County",
                        "latitude": "37.45369000",
                        "longitude": "-96.24409000"
                    },
                    {
                        "id": 115999,
                        "name": "Elkhart",
                        "latitude": "37.00808000",
                        "longitude": "-101.89017000"
                    },
                    {
                        "id": 116027,
                        "name": "Ellinwood",
                        "latitude": "38.35557000",
                        "longitude": "-98.58091000"
                    },
                    {
                        "id": 116029,
                        "name": "Ellis",
                        "latitude": "38.93807000",
                        "longitude": "-99.56067000"
                    },
                    {
                        "id": 116030,
                        "name": "Ellis County",
                        "latitude": "38.91475000",
                        "longitude": "-99.31723000"
                    },
                    {
                        "id": 116037,
                        "name": "Ellsworth",
                        "latitude": "38.73056000",
                        "longitude": "-98.22811000"
                    },
                    {
                        "id": 116040,
                        "name": "Ellsworth County",
                        "latitude": "38.69663000",
                        "longitude": "-98.20473000"
                    },
                    {
                        "id": 116077,
                        "name": "Elwood",
                        "latitude": "39.75555000",
                        "longitude": "-94.87247000"
                    },
                    {
                        "id": 116111,
                        "name": "Emporia",
                        "latitude": "38.40390000",
                        "longitude": "-96.18166000"
                    },
                    {
                        "id": 116164,
                        "name": "Erie",
                        "latitude": "37.56811000",
                        "longitude": "-95.24331000"
                    },
                    {
                        "id": 116223,
                        "name": "Eudora",
                        "latitude": "38.94334000",
                        "longitude": "-95.09858000"
                    },
                    {
                        "id": 116232,
                        "name": "Eureka",
                        "latitude": "37.82392000",
                        "longitude": "-96.28917000"
                    },
                    {
                        "id": 116362,
                        "name": "Fairway",
                        "latitude": "39.02223000",
                        "longitude": "-94.63190000"
                    },
                    {
                        "id": 116518,
                        "name": "Finney County",
                        "latitude": "38.04430000",
                        "longitude": "-100.73699000"
                    },
                    {
                        "id": 116636,
                        "name": "Ford County",
                        "latitude": "37.69170000",
                        "longitude": "-99.88794000"
                    },
                    {
                        "id": 116746,
                        "name": "Fort Riley North",
                        "latitude": "39.11081000",
                        "longitude": "-96.81392000"
                    },
                    {
                        "id": 116749,
                        "name": "Fort Scott",
                        "latitude": "37.83976000",
                        "longitude": "-94.70830000"
                    },
                    {
                        "id": 116849,
                        "name": "Franklin County",
                        "latitude": "38.56452000",
                        "longitude": "-95.28595000"
                    },
                    {
                        "id": 116895,
                        "name": "Fredonia",
                        "latitude": "37.53394000",
                        "longitude": "-95.82665000"
                    },
                    {
                        "id": 116961,
                        "name": "Frontenac",
                        "latitude": "37.45560000",
                        "longitude": "-94.68913000"
                    },
                    {
                        "id": 117022,
                        "name": "Galena",
                        "latitude": "37.07590000",
                        "longitude": "-94.63967000"
                    },
                    {
                        "id": 117059,
                        "name": "Garden City",
                        "latitude": "37.97169000",
                        "longitude": "-100.87266000"
                    },
                    {
                        "id": 117074,
                        "name": "Gardner",
                        "latitude": "38.81084000",
                        "longitude": "-94.92719000"
                    },
                    {
                        "id": 117095,
                        "name": "Garnett",
                        "latitude": "38.28058000",
                        "longitude": "-95.24192000"
                    },
                    {
                        "id": 117131,
                        "name": "Geary County",
                        "latitude": "39.00236000",
                        "longitude": "-96.75254000"
                    },
                    {
                        "id": 117227,
                        "name": "Girard",
                        "latitude": "37.51116000",
                        "longitude": "-94.83802000"
                    },
                    {
                        "id": 117332,
                        "name": "Goddard",
                        "latitude": "37.65974000",
                        "longitude": "-97.57533000"
                    },
                    {
                        "id": 117385,
                        "name": "Goodland",
                        "latitude": "39.35083000",
                        "longitude": "-101.71017000"
                    },
                    {
                        "id": 117420,
                        "name": "Gove",
                        "latitude": "38.95779000",
                        "longitude": "-100.48875000"
                    },
                    {
                        "id": 117421,
                        "name": "Gove County",
                        "latitude": "38.91610000",
                        "longitude": "-100.48290000"
                    },
                    {
                        "id": 117437,
                        "name": "Graham County",
                        "latitude": "39.34972000",
                        "longitude": "-99.88325000"
                    },
                    {
                        "id": 117482,
                        "name": "Grandview Plaza",
                        "latitude": "39.02916000",
                        "longitude": "-96.78917000"
                    },
                    {
                        "id": 117516,
                        "name": "Grant County",
                        "latitude": "37.56219000",
                        "longitude": "-101.30802000"
                    },
                    {
                        "id": 117553,
                        "name": "Gray County",
                        "latitude": "37.73820000",
                        "longitude": "-100.43786000"
                    },
                    {
                        "id": 117570,
                        "name": "Great Bend",
                        "latitude": "38.36446000",
                        "longitude": "-98.76481000"
                    },
                    {
                        "id": 117588,
                        "name": "Greeley County",
                        "latitude": "38.48054000",
                        "longitude": "-101.80597000"
                    },
                    {
                        "id": 117670,
                        "name": "Greensburg",
                        "latitude": "37.60280000",
                        "longitude": "-99.29261000"
                    },
                    {
                        "id": 117709,
                        "name": "Greenwood County",
                        "latitude": "37.87779000",
                        "longitude": "-96.23264000"
                    },
                    {
                        "id": 117877,
                        "name": "Halstead",
                        "latitude": "38.00140000",
                        "longitude": "-97.50865000"
                    },
                    {
                        "id": 117904,
                        "name": "Hamilton County",
                        "latitude": "37.99915000",
                        "longitude": "-101.79126000"
                    },
                    {
                        "id": 118031,
                        "name": "Harper",
                        "latitude": "37.28669000",
                        "longitude": "-98.02589000"
                    },
                    {
                        "id": 118033,
                        "name": "Harper County",
                        "latitude": "37.19160000",
                        "longitude": "-98.07550000"
                    },
                    {
                        "id": 118115,
                        "name": "Harvey County",
                        "latitude": "38.04322000",
                        "longitude": "-97.42727000"
                    },
                    {
                        "id": 118127,
                        "name": "Haskell County",
                        "latitude": "37.56225000",
                        "longitude": "-100.87119000"
                    },
                    {
                        "id": 118148,
                        "name": "Haven",
                        "latitude": "37.89890000",
                        "longitude": "-97.78283000"
                    },
                    {
                        "id": 118190,
                        "name": "Hays",
                        "latitude": "38.87918000",
                        "longitude": "-99.32677000"
                    },
                    {
                        "id": 118193,
                        "name": "Haysville",
                        "latitude": "37.56446000",
                        "longitude": "-97.35227000"
                    },
                    {
                        "id": 118316,
                        "name": "Herington",
                        "latitude": "38.67112000",
                        "longitude": "-96.94251000"
                    },
                    {
                        "id": 118345,
                        "name": "Hesston",
                        "latitude": "38.13834000",
                        "longitude": "-97.43143000"
                    },
                    {
                        "id": 118357,
                        "name": "Hiawatha",
                        "latitude": "39.85250000",
                        "longitude": "-95.53582000"
                    },
                    {
                        "id": 118394,
                        "name": "Highland",
                        "latitude": "39.85972000",
                        "longitude": "-95.26970000"
                    },
                    {
                        "id": 118434,
                        "name": "Hill City",
                        "latitude": "39.36473000",
                        "longitude": "-99.84206000"
                    },
                    {
                        "id": 118445,
                        "name": "Hillsboro",
                        "latitude": "38.35196000",
                        "longitude": "-97.20447000"
                    },
                    {
                        "id": 118507,
                        "name": "Hodgeman County",
                        "latitude": "38.08748000",
                        "longitude": "-99.89794000"
                    },
                    {
                        "id": 118513,
                        "name": "Hoisington",
                        "latitude": "38.51807000",
                        "longitude": "-98.77814000"
                    },
                    {
                        "id": 118521,
                        "name": "Holcomb",
                        "latitude": "37.98614000",
                        "longitude": "-100.98933000"
                    },
                    {
                        "id": 118578,
                        "name": "Holton",
                        "latitude": "39.46527000",
                        "longitude": "-95.73637000"
                    },
                    {
                        "id": 118678,
                        "name": "Horton",
                        "latitude": "39.66056000",
                        "longitude": "-95.52637000"
                    },
                    {
                        "id": 118707,
                        "name": "Howard",
                        "latitude": "37.47031000",
                        "longitude": "-96.26361000"
                    },
                    {
                        "id": 118727,
                        "name": "Hoxie",
                        "latitude": "39.35750000",
                        "longitude": "-100.44181000"
                    },
                    {
                        "id": 118768,
                        "name": "Hugoton",
                        "latitude": "37.17530000",
                        "longitude": "-101.34960000"
                    },
                    {
                        "id": 118775,
                        "name": "Humboldt",
                        "latitude": "37.81060000",
                        "longitude": "-95.43693000"
                    },
                    {
                        "id": 118835,
                        "name": "Hutchinson",
                        "latitude": "38.06084000",
                        "longitude": "-97.92977000"
                    },
                    {
                        "id": 118889,
                        "name": "Independence",
                        "latitude": "37.22424000",
                        "longitude": "-95.70831000"
                    },
                    {
                        "id": 118944,
                        "name": "Inman",
                        "latitude": "38.23195000",
                        "longitude": "-97.77338000"
                    },
                    {
                        "id": 118966,
                        "name": "Iola",
                        "latitude": "37.92448000",
                        "longitude": "-95.39998000"
                    },
                    {
                        "id": 119081,
                        "name": "Jackson County",
                        "latitude": "39.41682000",
                        "longitude": "-95.79366000"
                    },
                    {
                        "id": 119181,
                        "name": "Jefferson County",
                        "latitude": "39.23576000",
                        "longitude": "-95.38345000"
                    },
                    {
                        "id": 119241,
                        "name": "Jetmore",
                        "latitude": "38.08446000",
                        "longitude": "-99.89346000"
                    },
                    {
                        "id": 119243,
                        "name": "Jewell County",
                        "latitude": "39.78473000",
                        "longitude": "-98.21834000"
                    },
                    {
                        "id": 119256,
                        "name": "Johnson",
                        "latitude": "37.57057000",
                        "longitude": "-101.75100000"
                    },
                    {
                        "id": 119264,
                        "name": "Johnson County",
                        "latitude": "38.88376000",
                        "longitude": "-94.82226000"
                    },
                    {
                        "id": 119334,
                        "name": "Junction City",
                        "latitude": "39.02861000",
                        "longitude": "-96.83140000"
                    },
                    {
                        "id": 119383,
                        "name": "Kansas City",
                        "latitude": "39.11417000",
                        "longitude": "-94.62746000"
                    },
                    {
                        "id": 119414,
                        "name": "Kearny County",
                        "latitude": "38.00020000",
                        "longitude": "-101.31986000"
                    },
                    {
                        "id": 119416,
                        "name": "Kechi",
                        "latitude": "37.79585000",
                        "longitude": "-97.27949000"
                    },
                    {
                        "id": 119594,
                        "name": "Kingman",
                        "latitude": "37.64585000",
                        "longitude": "-98.11367000"
                    },
                    {
                        "id": 119596,
                        "name": "Kingman County",
                        "latitude": "37.55888000",
                        "longitude": "-98.13633000"
                    },
                    {
                        "id": 119642,
                        "name": "Kinsley",
                        "latitude": "37.92307000",
                        "longitude": "-99.40984000"
                    },
                    {
                        "id": 119644,
                        "name": "Kiowa",
                        "latitude": "37.01725000",
                        "longitude": "-98.48535000"
                    },
                    {
                        "id": 119646,
                        "name": "Kiowa County",
                        "latitude": "37.55826000",
                        "longitude": "-99.28605000"
                    },
                    {
                        "id": 119743,
                        "name": "La Crosse",
                        "latitude": "38.53140000",
                        "longitude": "-99.30872000"
                    },
                    {
                        "id": 119746,
                        "name": "La Cygne",
                        "latitude": "38.35002000",
                        "longitude": "-94.76135000"
                    },
                    {
                        "id": 119809,
                        "name": "Labette County",
                        "latitude": "37.19133000",
                        "longitude": "-95.29758000"
                    },
                    {
                        "id": 120056,
                        "name": "Lakin",
                        "latitude": "37.94058000",
                        "longitude": "-101.25489000"
                    },
                    {
                        "id": 120105,
                        "name": "Lane County",
                        "latitude": "38.48130000",
                        "longitude": "-100.46640000"
                    },
                    {
                        "id": 120125,
                        "name": "Lansing",
                        "latitude": "39.24861000",
                        "longitude": "-94.90024000"
                    },
                    {
                        "id": 120150,
                        "name": "Larned",
                        "latitude": "38.18057000",
                        "longitude": "-99.09871000"
                    },
                    {
                        "id": 120226,
                        "name": "Lawrence",
                        "latitude": "38.97167000",
                        "longitude": "-95.23525000"
                    },
                    {
                        "id": 120280,
                        "name": "Leavenworth",
                        "latitude": "39.31111000",
                        "longitude": "-94.92246000"
                    },
                    {
                        "id": 120282,
                        "name": "Leavenworth County",
                        "latitude": "39.19932000",
                        "longitude": "-95.03790000"
                    },
                    {
                        "id": 120283,
                        "name": "Leawood",
                        "latitude": "38.96667000",
                        "longitude": "-94.61690000"
                    },
                    {
                        "id": 120369,
                        "name": "Lenexa",
                        "latitude": "38.95362000",
                        "longitude": "-94.73357000"
                    },
                    {
                        "id": 120393,
                        "name": "Leoti",
                        "latitude": "38.47974000",
                        "longitude": "-101.35877000"
                    },
                    {
                        "id": 120458,
                        "name": "Liberal",
                        "latitude": "37.04308000",
                        "longitude": "-100.92100000"
                    },
                    {
                        "id": 120501,
                        "name": "Lincoln",
                        "latitude": "39.04084000",
                        "longitude": "-98.14477000"
                    },
                    {
                        "id": 120518,
                        "name": "Lincoln County",
                        "latitude": "39.04533000",
                        "longitude": "-98.20770000"
                    },
                    {
                        "id": 120575,
                        "name": "Lindsborg",
                        "latitude": "38.57362000",
                        "longitude": "-97.67448000"
                    },
                    {
                        "id": 120581,
                        "name": "Linn County",
                        "latitude": "38.21227000",
                        "longitude": "-94.84293000"
                    },
                    {
                        "id": 120702,
                        "name": "Logan County",
                        "latitude": "38.91734000",
                        "longitude": "-101.14839000"
                    },
                    {
                        "id": 120808,
                        "name": "Louisburg",
                        "latitude": "38.61946000",
                        "longitude": "-94.68079000"
                    },
                    {
                        "id": 120922,
                        "name": "Lyndon",
                        "latitude": "38.61001000",
                        "longitude": "-95.68443000"
                    },
                    {
                        "id": 120935,
                        "name": "Lyon County",
                        "latitude": "38.45619000",
                        "longitude": "-96.15264000"
                    },
                    {
                        "id": 120941,
                        "name": "Lyons",
                        "latitude": "38.34501000",
                        "longitude": "-98.20173000"
                    },
                    {
                        "id": 121052,
                        "name": "Maize",
                        "latitude": "37.77918000",
                        "longitude": "-97.46727000"
                    },
                    {
                        "id": 121113,
                        "name": "Manhattan",
                        "latitude": "39.18361000",
                        "longitude": "-96.57167000"
                    },
                    {
                        "id": 121129,
                        "name": "Mankato",
                        "latitude": "39.78723000",
                        "longitude": "-98.21005000"
                    },
                    {
                        "id": 121234,
                        "name": "Marion",
                        "latitude": "38.34835000",
                        "longitude": "-97.01725000"
                    },
                    {
                        "id": 121253,
                        "name": "Marion County",
                        "latitude": "38.35887000",
                        "longitude": "-97.09689000"
                    },
                    {
                        "id": 121311,
                        "name": "Marshall County",
                        "latitude": "39.78362000",
                        "longitude": "-96.52294000"
                    },
                    {
                        "id": 121357,
                        "name": "Marysville",
                        "latitude": "39.84111000",
                        "longitude": "-96.64724000"
                    },
                    {
                        "id": 121476,
                        "name": "McConnell AFB",
                        "latitude": "37.63007000",
                        "longitude": "-97.25869000"
                    },
                    {
                        "id": 121545,
                        "name": "McPherson",
                        "latitude": "38.37084000",
                        "longitude": "-97.66421000"
                    },
                    {
                        "id": 121546,
                        "name": "McPherson County",
                        "latitude": "38.39167000",
                        "longitude": "-97.64808000"
                    },
                    {
                        "id": 121555,
                        "name": "Meade",
                        "latitude": "37.28558000",
                        "longitude": "-100.34015000"
                    },
                    {
                        "id": 121557,
                        "name": "Meade County",
                        "latitude": "37.23820000",
                        "longitude": "-100.36618000"
                    },
                    {
                        "id": 121601,
                        "name": "Medicine Lodge",
                        "latitude": "37.28113000",
                        "longitude": "-98.58036000"
                    },
                    {
                        "id": 121702,
                        "name": "Merriam",
                        "latitude": "39.02362000",
                        "longitude": "-94.69357000"
                    },
                    {
                        "id": 121751,
                        "name": "Miami County",
                        "latitude": "38.56358000",
                        "longitude": "-94.83806000"
                    },
                    {
                        "id": 121950,
                        "name": "Minneapolis",
                        "latitude": "39.12194000",
                        "longitude": "-97.70670000"
                    },
                    {
                        "id": 121979,
                        "name": "Mission",
                        "latitude": "39.02778000",
                        "longitude": "-94.65579000"
                    },
                    {
                        "id": 121986,
                        "name": "Mission Hills",
                        "latitude": "39.01778000",
                        "longitude": "-94.61690000"
                    },
                    {
                        "id": 122000,
                        "name": "Mitchell County",
                        "latitude": "39.39327000",
                        "longitude": "-98.20936000"
                    },
                    {
                        "id": 122143,
                        "name": "Montgomery County",
                        "latitude": "37.19252000",
                        "longitude": "-95.74288000"
                    },
                    {
                        "id": 122269,
                        "name": "Morris County",
                        "latitude": "38.68743000",
                        "longitude": "-96.64985000"
                    },
                    {
                        "id": 122296,
                        "name": "Morton County",
                        "latitude": "37.19140000",
                        "longitude": "-101.79925000"
                    },
                    {
                        "id": 122321,
                        "name": "Mound City",
                        "latitude": "38.14281000",
                        "longitude": "-94.81357000"
                    },
                    {
                        "id": 122324,
                        "name": "Moundridge",
                        "latitude": "38.20307000",
                        "longitude": "-97.51921000"
                    },
                    {
                        "id": 122464,
                        "name": "Mulvane",
                        "latitude": "37.47446000",
                        "longitude": "-97.24393000"
                    },
                    {
                        "id": 122629,
                        "name": "Nemaha County",
                        "latitude": "39.78345000",
                        "longitude": "-96.01410000"
                    },
                    {
                        "id": 122631,
                        "name": "Neodesha",
                        "latitude": "37.41839000",
                        "longitude": "-95.68026000"
                    },
                    {
                        "id": 122634,
                        "name": "Neosho County",
                        "latitude": "37.55849000",
                        "longitude": "-95.30679000"
                    },
                    {
                        "id": 122643,
                        "name": "Ness City",
                        "latitude": "38.45279000",
                        "longitude": "-99.90651000"
                    },
                    {
                        "id": 122644,
                        "name": "Ness County",
                        "latitude": "38.47942000",
                        "longitude": "-99.91618000"
                    },
                    {
                        "id": 122692,
                        "name": "New Century KS",
                        "latitude": "38.82253000",
                        "longitude": "-94.89971000"
                    },
                    {
                        "id": 122858,
                        "name": "Newton",
                        "latitude": "38.04668000",
                        "longitude": "-97.34504000"
                    },
                    {
                        "id": 122894,
                        "name": "Nickerson",
                        "latitude": "38.14723000",
                        "longitude": "-98.08367000"
                    },
                    {
                        "id": 123072,
                        "name": "North Newton",
                        "latitude": "38.07223000",
                        "longitude": "-97.34559000"
                    },
                    {
                        "id": 123182,
                        "name": "Norton",
                        "latitude": "39.83389000",
                        "longitude": "-99.89151000"
                    },
                    {
                        "id": 123186,
                        "name": "Norton County",
                        "latitude": "39.78439000",
                        "longitude": "-99.90348000"
                    },
                    {
                        "id": 123299,
                        "name": "Oakley",
                        "latitude": "39.13334000",
                        "longitude": "-100.86376000"
                    },
                    {
                        "id": 123316,
                        "name": "Oberlin",
                        "latitude": "39.81834000",
                        "longitude": "-100.52820000"
                    },
                    {
                        "id": 123366,
                        "name": "Ogden",
                        "latitude": "39.11111000",
                        "longitude": "-96.70612000"
                    },
                    {
                        "id": 123412,
                        "name": "Olathe",
                        "latitude": "38.88140000",
                        "longitude": "-94.81913000"
                    },
                    {
                        "id": 123588,
                        "name": "Osage City",
                        "latitude": "38.63390000",
                        "longitude": "-95.82582000"
                    },
                    {
                        "id": 123589,
                        "name": "Osage County",
                        "latitude": "38.65233000",
                        "longitude": "-95.72695000"
                    },
                    {
                        "id": 123593,
                        "name": "Osawatomie",
                        "latitude": "38.49724000",
                        "longitude": "-94.95052000"
                    },
                    {
                        "id": 123594,
                        "name": "Osborne",
                        "latitude": "39.43914000",
                        "longitude": "-98.69624000"
                    },
                    {
                        "id": 123595,
                        "name": "Osborne County",
                        "latitude": "39.35033000",
                        "longitude": "-98.76799000"
                    },
                    {
                        "id": 123611,
                        "name": "Oskaloosa",
                        "latitude": "39.21528000",
                        "longitude": "-95.31275000"
                    },
                    {
                        "id": 123621,
                        "name": "Oswego",
                        "latitude": "37.16757000",
                        "longitude": "-95.10996000"
                    },
                    {
                        "id": 123636,
                        "name": "Ottawa",
                        "latitude": "38.61557000",
                        "longitude": "-95.26775000"
                    },
                    {
                        "id": 123638,
                        "name": "Ottawa County",
                        "latitude": "39.13254000",
                        "longitude": "-97.65022000"
                    },
                    {
                        "id": 123649,
                        "name": "Overbrook",
                        "latitude": "38.78056000",
                        "longitude": "-95.55720000"
                    },
                    {
                        "id": 123651,
                        "name": "Overland Park",
                        "latitude": "38.98223000",
                        "longitude": "-94.67079000"
                    },
                    {
                        "id": 123677,
                        "name": "Oxford",
                        "latitude": "37.27419000",
                        "longitude": "-97.16893000"
                    },
                    {
                        "id": 123810,
                        "name": "Paola",
                        "latitude": "38.57224000",
                        "longitude": "-94.87913000"
                    },
                    {
                        "id": 123837,
                        "name": "Park City",
                        "latitude": "37.80001000",
                        "longitude": "-97.31838000"
                    },
                    {
                        "id": 123891,
                        "name": "Parsons",
                        "latitude": "37.34034000",
                        "longitude": "-95.26108000"
                    },
                    {
                        "id": 123936,
                        "name": "Pawnee County",
                        "latitude": "38.18133000",
                        "longitude": "-99.23673000"
                    },
                    {
                        "id": 123953,
                        "name": "Peabody",
                        "latitude": "38.16946000",
                        "longitude": "-97.10670000"
                    },
                    {
                        "id": 124136,
                        "name": "Phillips County",
                        "latitude": "39.78458000",
                        "longitude": "-99.34702000"
                    },
                    {
                        "id": 124139,
                        "name": "Phillipsburg",
                        "latitude": "39.75612000",
                        "longitude": "-99.32399000"
                    },
                    {
                        "id": 124292,
                        "name": "Pittsburg",
                        "latitude": "37.41088000",
                        "longitude": "-94.70496000"
                    },
                    {
                        "id": 124325,
                        "name": "Plains",
                        "latitude": "37.26030000",
                        "longitude": "-100.59265000"
                    },
                    {
                        "id": 124333,
                        "name": "Plainville",
                        "latitude": "39.23473000",
                        "longitude": "-99.29816000"
                    },
                    {
                        "id": 124382,
                        "name": "Pleasanton",
                        "latitude": "38.17781000",
                        "longitude": "-94.71135000"
                    },
                    {
                        "id": 124589,
                        "name": "Pottawatomie County",
                        "latitude": "39.37901000",
                        "longitude": "-96.34244000"
                    },
                    {
                        "id": 124632,
                        "name": "Prairie Village",
                        "latitude": "38.99167000",
                        "longitude": "-94.63357000"
                    },
                    {
                        "id": 124636,
                        "name": "Pratt",
                        "latitude": "37.64391000",
                        "longitude": "-98.73759000"
                    },
                    {
                        "id": 124637,
                        "name": "Pratt County",
                        "latitude": "37.64774000",
                        "longitude": "-98.73960000"
                    },
                    {
                        "id": 124913,
                        "name": "Rawlins County",
                        "latitude": "39.78524000",
                        "longitude": "-101.07571000"
                    },
                    {
                        "id": 125021,
                        "name": "Reno County",
                        "latitude": "37.95295000",
                        "longitude": "-98.08601000"
                    },
                    {
                        "id": 125033,
                        "name": "Republic County",
                        "latitude": "39.82780000",
                        "longitude": "-97.65062000"
                    },
                    {
                        "id": 125053,
                        "name": "Rice County",
                        "latitude": "38.34714000",
                        "longitude": "-98.20103000"
                    },
                    {
                        "id": 125138,
                        "name": "Riley County",
                        "latitude": "39.29646000",
                        "longitude": "-96.73518000"
                    },
                    {
                        "id": 125345,
                        "name": "Roeland Park",
                        "latitude": "39.03751000",
                        "longitude": "-94.63218000"
                    },
                    {
                        "id": 125390,
                        "name": "Rooks County",
                        "latitude": "39.35023000",
                        "longitude": "-99.32505000"
                    },
                    {
                        "id": 125403,
                        "name": "Rose Hill",
                        "latitude": "37.55835000",
                        "longitude": "-97.13504000"
                    },
                    {
                        "id": 125457,
                        "name": "Rossville",
                        "latitude": "39.13611000",
                        "longitude": "-95.95166000"
                    },
                    {
                        "id": 125521,
                        "name": "Rush County",
                        "latitude": "38.52316000",
                        "longitude": "-99.30924000"
                    },
                    {
                        "id": 125533,
                        "name": "Russell",
                        "latitude": "38.89527000",
                        "longitude": "-98.86103000"
                    },
                    {
                        "id": 125537,
                        "name": "Russell County",
                        "latitude": "38.91478000",
                        "longitude": "-98.76235000"
                    },
                    {
                        "id": 125567,
                        "name": "Sabetha",
                        "latitude": "39.90222000",
                        "longitude": "-95.80082000"
                    },
                    {
                        "id": 125635,
                        "name": "Saint Francis",
                        "latitude": "39.77222000",
                        "longitude": "-101.79990000"
                    },
                    {
                        "id": 125660,
                        "name": "Saint John",
                        "latitude": "38.00224000",
                        "longitude": "-98.76009000"
                    },
                    {
                        "id": 125692,
                        "name": "Saint Marys",
                        "latitude": "39.19416000",
                        "longitude": "-96.07110000"
                    },
                    {
                        "id": 125744,
                        "name": "Salina",
                        "latitude": "38.84028000",
                        "longitude": "-97.61142000"
                    },
                    {
                        "id": 125751,
                        "name": "Saline County",
                        "latitude": "38.78381000",
                        "longitude": "-97.64993000"
                    },
                    {
                        "id": 125954,
                        "name": "Satanta",
                        "latitude": "37.43725000",
                        "longitude": "-100.97211000"
                    },
                    {
                        "id": 126042,
                        "name": "Scott City",
                        "latitude": "38.48252000",
                        "longitude": "-100.90709000"
                    },
                    {
                        "id": 126053,
                        "name": "Scott County",
                        "latitude": "38.48217000",
                        "longitude": "-100.90686000"
                    },
                    {
                        "id": 126115,
                        "name": "Sedan",
                        "latitude": "37.12672000",
                        "longitude": "-96.18694000"
                    },
                    {
                        "id": 126117,
                        "name": "Sedgwick",
                        "latitude": "37.91668000",
                        "longitude": "-97.42254000"
                    },
                    {
                        "id": 126119,
                        "name": "Sedgwick County",
                        "latitude": "37.68476000",
                        "longitude": "-97.46097000"
                    },
                    {
                        "id": 126154,
                        "name": "Seneca",
                        "latitude": "39.83416000",
                        "longitude": "-96.06417000"
                    },
                    {
                        "id": 126189,
                        "name": "Seward County",
                        "latitude": "37.19330000",
                        "longitude": "-100.85129000"
                    },
                    {
                        "id": 126232,
                        "name": "Sharon Springs",
                        "latitude": "38.89779000",
                        "longitude": "-101.75212000"
                    },
                    {
                        "id": 126249,
                        "name": "Shawnee",
                        "latitude": "39.04167000",
                        "longitude": "-94.72024000"
                    },
                    {
                        "id": 126251,
                        "name": "Shawnee County",
                        "latitude": "39.04151000",
                        "longitude": "-95.75653000"
                    },
                    {
                        "id": 126324,
                        "name": "Sheridan County",
                        "latitude": "39.35036000",
                        "longitude": "-100.44183000"
                    },
                    {
                        "id": 126333,
                        "name": "Sherman County",
                        "latitude": "39.35143000",
                        "longitude": "-101.71998000"
                    },
                    {
                        "id": 126428,
                        "name": "Silver Lake",
                        "latitude": "39.10417000",
                        "longitude": "-95.85860000"
                    },
                    {
                        "id": 126511,
                        "name": "Smith Center",
                        "latitude": "39.77918000",
                        "longitude": "-98.78507000"
                    },
                    {
                        "id": 126512,
                        "name": "Smith County",
                        "latitude": "39.78516000",
                        "longitude": "-98.78547000"
                    },
                    {
                        "id": 126569,
                        "name": "Solomon",
                        "latitude": "38.91944000",
                        "longitude": "-97.37114000"
                    },
                    {
                        "id": 126678,
                        "name": "South Hutchinson",
                        "latitude": "38.02807000",
                        "longitude": "-97.94033000"
                    },
                    {
                        "id": 126861,
                        "name": "Spring Hill",
                        "latitude": "38.74306000",
                        "longitude": "-94.82552000"
                    },
                    {
                        "id": 126936,
                        "name": "Stafford County",
                        "latitude": "38.03100000",
                        "longitude": "-98.71744000"
                    },
                    {
                        "id": 126973,
                        "name": "Stanton County",
                        "latitude": "37.56306000",
                        "longitude": "-101.78418000"
                    },
                    {
                        "id": 127026,
                        "name": "Sterling",
                        "latitude": "38.21001000",
                        "longitude": "-98.20701000"
                    },
                    {
                        "id": 127041,
                        "name": "Stevens County",
                        "latitude": "37.19232000",
                        "longitude": "-101.31205000"
                    },
                    {
                        "id": 127071,
                        "name": "Stockton",
                        "latitude": "39.43807000",
                        "longitude": "-99.26510000"
                    },
                    {
                        "id": 127157,
                        "name": "Sublette",
                        "latitude": "37.48169000",
                        "longitude": "-100.84377000"
                    },
                    {
                        "id": 127224,
                        "name": "Sumner County",
                        "latitude": "37.23728000",
                        "longitude": "-97.47655000"
                    },
                    {
                        "id": 127366,
                        "name": "Syracuse",
                        "latitude": "37.98071000",
                        "longitude": "-101.75430000"
                    },
                    {
                        "id": 127580,
                        "name": "Thomas County",
                        "latitude": "39.35097000",
                        "longitude": "-101.05553000"
                    },
                    {
                        "id": 127719,
                        "name": "Tonganoxie",
                        "latitude": "39.10972000",
                        "longitude": "-95.08775000"
                    },
                    {
                        "id": 127732,
                        "name": "Topeka",
                        "latitude": "39.04833000",
                        "longitude": "-95.67804000"
                    },
                    {
                        "id": 127751,
                        "name": "Towanda",
                        "latitude": "37.79752000",
                        "longitude": "-96.99976000"
                    },
                    {
                        "id": 127792,
                        "name": "Trego County",
                        "latitude": "38.91432000",
                        "longitude": "-99.87274000"
                    },
                    {
                        "id": 127820,
                        "name": "Tribune",
                        "latitude": "38.46974000",
                        "longitude": "-101.75267000"
                    },
                    {
                        "id": 127842,
                        "name": "Troy",
                        "latitude": "39.78305000",
                        "longitude": "-95.08997000"
                    },
                    {
                        "id": 127960,
                        "name": "Ulysses",
                        "latitude": "37.58141000",
                        "longitude": "-101.35517000"
                    },
                    {
                        "id": 128099,
                        "name": "Valley Center",
                        "latitude": "37.83473000",
                        "longitude": "-97.37338000"
                    },
                    {
                        "id": 128106,
                        "name": "Valley Falls",
                        "latitude": "39.34333000",
                        "longitude": "-95.46025000"
                    },
                    {
                        "id": 128219,
                        "name": "Victoria",
                        "latitude": "38.85279000",
                        "longitude": "-99.14760000"
                    },
                    {
                        "id": 128315,
                        "name": "Wabaunsee County",
                        "latitude": "38.95328000",
                        "longitude": "-96.20499000"
                    },
                    {
                        "id": 128308,
                        "name": "WaKeeney",
                        "latitude": "39.02501000",
                        "longitude": "-99.87957000"
                    },
                    {
                        "id": 128399,
                        "name": "Wallace County",
                        "latitude": "38.91666000",
                        "longitude": "-101.76357000"
                    },
                    {
                        "id": 128444,
                        "name": "Wamego",
                        "latitude": "39.20194000",
                        "longitude": "-96.30500000"
                    },
                    {
                        "id": 128537,
                        "name": "Washington",
                        "latitude": "39.81806000",
                        "longitude": "-97.05086000"
                    },
                    {
                        "id": 128558,
                        "name": "Washington County",
                        "latitude": "39.78420000",
                        "longitude": "-97.08754000"
                    },
                    {
                        "id": 128633,
                        "name": "Wathena",
                        "latitude": "39.75916000",
                        "longitude": "-94.94969000"
                    },
                    {
                        "id": 128777,
                        "name": "Wellington",
                        "latitude": "37.26530000",
                        "longitude": "-97.37171000"
                    },
                    {
                        "id": 128791,
                        "name": "Wellsville",
                        "latitude": "38.71834000",
                        "longitude": "-95.08164000"
                    },
                    {
                        "id": 129052,
                        "name": "Westmoreland",
                        "latitude": "39.39389000",
                        "longitude": "-96.41361000"
                    },
                    {
                        "id": 129082,
                        "name": "Westwood",
                        "latitude": "39.04056000",
                        "longitude": "-94.61690000"
                    },
                    {
                        "id": 129215,
                        "name": "Wichita",
                        "latitude": "37.69224000",
                        "longitude": "-97.33754000"
                    },
                    {
                        "id": 129217,
                        "name": "Wichita County",
                        "latitude": "38.48208000",
                        "longitude": "-101.34736000"
                    },
                    {
                        "id": 129334,
                        "name": "Wilson County",
                        "latitude": "37.55924000",
                        "longitude": "-95.74339000"
                    },
                    {
                        "id": 129393,
                        "name": "Winfield",
                        "latitude": "37.23975000",
                        "longitude": "-96.99559000"
                    },
                    {
                        "id": 129558,
                        "name": "Woodson County",
                        "latitude": "37.88667000",
                        "longitude": "-95.74017000"
                    },
                    {
                        "id": 129622,
                        "name": "Wyandotte County",
                        "latitude": "39.11465000",
                        "longitude": "-94.76448000"
                    },
                    {
                        "id": 129670,
                        "name": "Yates Center",
                        "latitude": "37.88115000",
                        "longitude": "-95.73332000"
                    }
                ]
            },
            {
                "id": 1419,
                "name": "Kentucky",
                "iso2": "KY",
                "latitude": "37.83933320",
                "longitude": "-84.27001790",
                "type": "state",
                "cities": [
                    {
                        "id": 111008,
                        "name": "Adair County",
                        "latitude": "37.10416000",
                        "longitude": "-85.28065000"
                    },
                    {
                        "id": 111102,
                        "name": "Albany",
                        "latitude": "36.69090000",
                        "longitude": "-85.13468000"
                    },
                    {
                        "id": 111149,
                        "name": "Alexandria",
                        "latitude": "38.95951000",
                        "longitude": "-84.38799000"
                    },
                    {
                        "id": 111189,
                        "name": "Allen County",
                        "latitude": "36.75132000",
                        "longitude": "-86.19042000"
                    },
                    {
                        "id": 111304,
                        "name": "Anchorage",
                        "latitude": "38.26674000",
                        "longitude": "-85.53302000"
                    },
                    {
                        "id": 111316,
                        "name": "Anderson County",
                        "latitude": "38.00391000",
                        "longitude": "-84.99101000"
                    },
                    {
                        "id": 111356,
                        "name": "Annville",
                        "latitude": "37.31925000",
                        "longitude": "-83.97048000"
                    },
                    {
                        "id": 111526,
                        "name": "Ashland",
                        "latitude": "38.47841000",
                        "longitude": "-82.63794000"
                    },
                    {
                        "id": 111620,
                        "name": "Auburn",
                        "latitude": "36.86421000",
                        "longitude": "-86.71027000"
                    },
                    {
                        "id": 111642,
                        "name": "Audubon Park",
                        "latitude": "38.20396000",
                        "longitude": "-85.72524000"
                    },
                    {
                        "id": 111648,
                        "name": "Augusta",
                        "latitude": "38.77174000",
                        "longitude": "-84.00576000"
                    },
                    {
                        "id": 111771,
                        "name": "Ballard County",
                        "latitude": "37.05843000",
                        "longitude": "-88.99934000"
                    },
                    {
                        "id": 111816,
                        "name": "Barbourmeade",
                        "latitude": "38.29729000",
                        "longitude": "-85.60329000"
                    },
                    {
                        "id": 111818,
                        "name": "Barbourville",
                        "latitude": "36.86648000",
                        "longitude": "-83.88881000"
                    },
                    {
                        "id": 111820,
                        "name": "Bardstown",
                        "latitude": "37.80923000",
                        "longitude": "-85.46690000"
                    },
                    {
                        "id": 111821,
                        "name": "Bardwell",
                        "latitude": "36.87061000",
                        "longitude": "-89.00979000"
                    },
                    {
                        "id": 111843,
                        "name": "Barren County",
                        "latitude": "36.96558000",
                        "longitude": "-85.93366000"
                    },
                    {
                        "id": 111901,
                        "name": "Bath County",
                        "latitude": "38.14497000",
                        "longitude": "-83.74267000"
                    },
                    {
                        "id": 111984,
                        "name": "Beattyville",
                        "latitude": "37.57175000",
                        "longitude": "-83.70686000"
                    },
                    {
                        "id": 112000,
                        "name": "Beaver Dam",
                        "latitude": "37.40199000",
                        "longitude": "-86.87583000"
                    },
                    {
                        "id": 112019,
                        "name": "Bedford",
                        "latitude": "38.59256000",
                        "longitude": "-85.31773000"
                    },
                    {
                        "id": 112043,
                        "name": "Beechwood Village",
                        "latitude": "38.25479000",
                        "longitude": "-85.63135000"
                    },
                    {
                        "id": 112068,
                        "name": "Bell County",
                        "latitude": "36.73065000",
                        "longitude": "-83.67409000"
                    },
                    {
                        "id": 112109,
                        "name": "Bellevue",
                        "latitude": "39.10645000",
                        "longitude": "-84.47883000"
                    },
                    {
                        "id": 112192,
                        "name": "Benton",
                        "latitude": "36.85728000",
                        "longitude": "-88.35031000"
                    },
                    {
                        "id": 112213,
                        "name": "Berea",
                        "latitude": "37.56869000",
                        "longitude": "-84.29632000"
                    },
                    {
                        "id": 112433,
                        "name": "Bloomfield",
                        "latitude": "37.91034000",
                        "longitude": "-85.31662000"
                    },
                    {
                        "id": 112554,
                        "name": "Boone County",
                        "latitude": "38.96986000",
                        "longitude": "-84.72787000"
                    },
                    {
                        "id": 112563,
                        "name": "Booneville",
                        "latitude": "37.47620000",
                        "longitude": "-83.67491000"
                    },
                    {
                        "id": 112614,
                        "name": "Bourbon County",
                        "latitude": "38.20673000",
                        "longitude": "-84.21715000"
                    },
                    {
                        "id": 112628,
                        "name": "Bowling Green",
                        "latitude": "36.99032000",
                        "longitude": "-86.44360000"
                    },
                    {
                        "id": 112642,
                        "name": "Boyd County",
                        "latitude": "38.35957000",
                        "longitude": "-82.68773000"
                    },
                    {
                        "id": 112648,
                        "name": "Boyle County",
                        "latitude": "37.62433000",
                        "longitude": "-84.86681000"
                    },
                    {
                        "id": 112655,
                        "name": "Bracken County",
                        "latitude": "38.68881000",
                        "longitude": "-84.09019000"
                    },
                    {
                        "id": 112686,
                        "name": "Brandenburg",
                        "latitude": "37.99896000",
                        "longitude": "-86.16941000"
                    },
                    {
                        "id": 112708,
                        "name": "Breathitt County",
                        "latitude": "37.52162000",
                        "longitude": "-83.32409000"
                    },
                    {
                        "id": 112715,
                        "name": "Breckinridge Center",
                        "latitude": "37.68282000",
                        "longitude": "-87.86308000"
                    },
                    {
                        "id": 112716,
                        "name": "Breckinridge County",
                        "latitude": "37.77327000",
                        "longitude": "-86.42928000"
                    },
                    {
                        "id": 112837,
                        "name": "Brodhead",
                        "latitude": "37.40425000",
                        "longitude": "-84.41383000"
                    },
                    {
                        "id": 112881,
                        "name": "Brooks",
                        "latitude": "38.06118000",
                        "longitude": "-85.70968000"
                    },
                    {
                        "id": 112891,
                        "name": "Brooksville",
                        "latitude": "38.68257000",
                        "longitude": "-84.06576000"
                    },
                    {
                        "id": 112929,
                        "name": "Brownsville",
                        "latitude": "37.19255000",
                        "longitude": "-86.26775000"
                    },
                    {
                        "id": 112989,
                        "name": "Buckner",
                        "latitude": "38.38368000",
                        "longitude": "-85.43996000"
                    },
                    {
                        "id": 112996,
                        "name": "Buechel",
                        "latitude": "38.19507000",
                        "longitude": "-85.65190000"
                    },
                    {
                        "id": 113032,
                        "name": "Bullitt County",
                        "latitude": "37.97008000",
                        "longitude": "-85.69586000"
                    },
                    {
                        "id": 113059,
                        "name": "Burkesville",
                        "latitude": "36.79034000",
                        "longitude": "-85.37052000"
                    },
                    {
                        "id": 113067,
                        "name": "Burlington",
                        "latitude": "39.02756000",
                        "longitude": "-84.72411000"
                    },
                    {
                        "id": 113116,
                        "name": "Butler County",
                        "latitude": "37.20728000",
                        "longitude": "-86.68176000"
                    },
                    {
                        "id": 113165,
                        "name": "Cadiz",
                        "latitude": "36.86505000",
                        "longitude": "-87.83530000"
                    },
                    {
                        "id": 113183,
                        "name": "Caldwell County",
                        "latitude": "37.14533000",
                        "longitude": "-87.86791000"
                    },
                    {
                        "id": 113198,
                        "name": "Calhoun",
                        "latitude": "37.53894000",
                        "longitude": "-87.25833000"
                    },
                    {
                        "id": 113227,
                        "name": "Calloway County",
                        "latitude": "36.62110000",
                        "longitude": "-88.27220000"
                    },
                    {
                        "id": 113234,
                        "name": "Calvert City",
                        "latitude": "37.03339000",
                        "longitude": "-88.35004000"
                    },
                    {
                        "id": 113241,
                        "name": "Camargo",
                        "latitude": "37.99425000",
                        "longitude": "-83.88770000"
                    },
                    {
                        "id": 113300,
                        "name": "Campbell County",
                        "latitude": "38.94648000",
                        "longitude": "-84.37970000"
                    },
                    {
                        "id": 113305,
                        "name": "Campbellsville",
                        "latitude": "37.34340000",
                        "longitude": "-85.34191000"
                    },
                    {
                        "id": 113310,
                        "name": "Campton",
                        "latitude": "37.73425000",
                        "longitude": "-83.54741000"
                    },
                    {
                        "id": 113402,
                        "name": "Carlisle",
                        "latitude": "38.31202000",
                        "longitude": "-84.02743000"
                    },
                    {
                        "id": 113406,
                        "name": "Carlisle County",
                        "latitude": "36.85322000",
                        "longitude": "-88.97106000"
                    },
                    {
                        "id": 113452,
                        "name": "Carroll County",
                        "latitude": "38.66786000",
                        "longitude": "-85.12359000"
                    },
                    {
                        "id": 113466,
                        "name": "Carrollton",
                        "latitude": "38.68090000",
                        "longitude": "-85.17940000"
                    },
                    {
                        "id": 113480,
                        "name": "Carter County",
                        "latitude": "38.31817000",
                        "longitude": "-83.04954000"
                    },
                    {
                        "id": 113520,
                        "name": "Casey County",
                        "latitude": "37.32228000",
                        "longitude": "-84.92837000"
                    },
                    {
                        "id": 113572,
                        "name": "Catlettsburg",
                        "latitude": "38.40480000",
                        "longitude": "-82.60044000"
                    },
                    {
                        "id": 113584,
                        "name": "Cave City",
                        "latitude": "37.13672000",
                        "longitude": "-85.95692000"
                    },
                    {
                        "id": 113666,
                        "name": "Central City",
                        "latitude": "37.29393000",
                        "longitude": "-87.12333000"
                    },
                    {
                        "id": 113996,
                        "name": "Christian County",
                        "latitude": "36.89418000",
                        "longitude": "-87.49038000"
                    },
                    {
                        "id": 114125,
                        "name": "Clark County",
                        "latitude": "37.97085000",
                        "longitude": "-84.14740000"
                    },
                    {
                        "id": 114159,
                        "name": "Claryville",
                        "latitude": "38.91923000",
                        "longitude": "-84.39549000"
                    },
                    {
                        "id": 114166,
                        "name": "Clay",
                        "latitude": "37.47671000",
                        "longitude": "-87.82002000"
                    },
                    {
                        "id": 114172,
                        "name": "Clay City",
                        "latitude": "37.85925000",
                        "longitude": "-83.91853000"
                    },
                    {
                        "id": 114180,
                        "name": "Clay County",
                        "latitude": "37.15971000",
                        "longitude": "-83.71468000"
                    },
                    {
                        "id": 114269,
                        "name": "Clinton",
                        "latitude": "36.66728000",
                        "longitude": "-88.99340000"
                    },
                    {
                        "id": 114290,
                        "name": "Clinton County",
                        "latitude": "36.72748000",
                        "longitude": "-85.13601000"
                    },
                    {
                        "id": 114314,
                        "name": "Cloverport",
                        "latitude": "37.83339000",
                        "longitude": "-86.63276000"
                    },
                    {
                        "id": 114332,
                        "name": "Coal Run Village",
                        "latitude": "37.51316000",
                        "longitude": "-82.55849000"
                    },
                    {
                        "id": 114385,
                        "name": "Cold Spring",
                        "latitude": "39.02173000",
                        "longitude": "-84.43994000"
                    },
                    {
                        "id": 114391,
                        "name": "Coldstream",
                        "latitude": "38.31479000",
                        "longitude": "-85.52385000"
                    },
                    {
                        "id": 114464,
                        "name": "Columbia",
                        "latitude": "37.10284000",
                        "longitude": "-85.30635000"
                    },
                    {
                        "id": 114631,
                        "name": "Corbin",
                        "latitude": "36.94870000",
                        "longitude": "-84.09688000"
                    },
                    {
                        "id": 114736,
                        "name": "Covington",
                        "latitude": "39.08367000",
                        "longitude": "-84.50855000"
                    },
                    {
                        "id": 114797,
                        "name": "Crescent Springs",
                        "latitude": "39.05145000",
                        "longitude": "-84.58161000"
                    },
                    {
                        "id": 114808,
                        "name": "Crestview Hills",
                        "latitude": "39.02728000",
                        "longitude": "-84.58494000"
                    },
                    {
                        "id": 114809,
                        "name": "Crestwood",
                        "latitude": "38.32424000",
                        "longitude": "-85.47246000"
                    },
                    {
                        "id": 114824,
                        "name": "Crittenden",
                        "latitude": "38.78284000",
                        "longitude": "-84.60522000"
                    },
                    {
                        "id": 114826,
                        "name": "Crittenden County",
                        "latitude": "37.35272000",
                        "longitude": "-88.09722000"
                    },
                    {
                        "id": 114906,
                        "name": "Cumberland",
                        "latitude": "36.97815000",
                        "longitude": "-82.98850000"
                    },
                    {
                        "id": 114913,
                        "name": "Cumberland County",
                        "latitude": "36.78653000",
                        "longitude": "-85.38845000"
                    },
                    {
                        "id": 114952,
                        "name": "Cynthiana",
                        "latitude": "38.39035000",
                        "longitude": "-84.29410000"
                    },
                    {
                        "id": 115033,
                        "name": "Danville",
                        "latitude": "37.64563000",
                        "longitude": "-84.77217000"
                    },
                    {
                        "id": 115070,
                        "name": "Daviess County",
                        "latitude": "37.73177000",
                        "longitude": "-87.08723000"
                    },
                    {
                        "id": 115087,
                        "name": "Dawson Springs",
                        "latitude": "37.16727000",
                        "longitude": "-87.69251000"
                    },
                    {
                        "id": 115091,
                        "name": "Dayton",
                        "latitude": "39.11284000",
                        "longitude": "-84.47272000"
                    },
                    {
                        "id": 115364,
                        "name": "Dixon",
                        "latitude": "37.51782000",
                        "longitude": "-87.69029000"
                    },
                    {
                        "id": 115383,
                        "name": "Doe Valley",
                        "latitude": "37.95665000",
                        "longitude": "-86.11653000"
                    },
                    {
                        "id": 115438,
                        "name": "Douglass Hills",
                        "latitude": "38.23785000",
                        "longitude": "-85.55274000"
                    },
                    {
                        "id": 115483,
                        "name": "Dry Ridge",
                        "latitude": "38.68201000",
                        "longitude": "-84.58994000"
                    },
                    {
                        "id": 115619,
                        "name": "Earlington",
                        "latitude": "37.27421000",
                        "longitude": "-87.51194000"
                    },
                    {
                        "id": 115826,
                        "name": "Eddyville",
                        "latitude": "37.09450000",
                        "longitude": "-88.08030000"
                    },
                    {
                        "id": 115858,
                        "name": "Edgewood",
                        "latitude": "39.01867000",
                        "longitude": "-84.58189000"
                    },
                    {
                        "id": 115879,
                        "name": "Edmonson County",
                        "latitude": "37.20884000",
                        "longitude": "-86.23862000"
                    },
                    {
                        "id": 115881,
                        "name": "Edmonton",
                        "latitude": "36.98006000",
                        "longitude": "-85.61219000"
                    },
                    {
                        "id": 115978,
                        "name": "Elizabethtown",
                        "latitude": "37.69395000",
                        "longitude": "-85.85913000"
                    },
                    {
                        "id": 115986,
                        "name": "Elk Creek",
                        "latitude": "38.10034000",
                        "longitude": "-85.37107000"
                    },
                    {
                        "id": 115996,
                        "name": "Elkfork",
                        "latitude": "37.96481000",
                        "longitude": "-83.13295000"
                    },
                    {
                        "id": 116012,
                        "name": "Elkton",
                        "latitude": "36.81004000",
                        "longitude": "-87.15417000"
                    },
                    {
                        "id": 116028,
                        "name": "Elliott County",
                        "latitude": "38.11789000",
                        "longitude": "-83.09762000"
                    },
                    {
                        "id": 116071,
                        "name": "Elsmere",
                        "latitude": "39.01256000",
                        "longitude": "-84.60467000"
                    },
                    {
                        "id": 116099,
                        "name": "Eminence",
                        "latitude": "38.37007000",
                        "longitude": "-85.18051000"
                    },
                    {
                        "id": 116172,
                        "name": "Erlanger",
                        "latitude": "39.01673000",
                        "longitude": "-84.60078000"
                    },
                    {
                        "id": 116212,
                        "name": "Estill County",
                        "latitude": "37.69248000",
                        "longitude": "-83.96433000"
                    },
                    {
                        "id": 116299,
                        "name": "Fairdale",
                        "latitude": "38.10507000",
                        "longitude": "-85.75885000"
                    },
                    {
                        "id": 116386,
                        "name": "Falmouth",
                        "latitude": "38.67674000",
                        "longitude": "-84.33021000"
                    },
                    {
                        "id": 116400,
                        "name": "Farley",
                        "latitude": "37.04634000",
                        "longitude": "-88.56856000"
                    },
                    {
                        "id": 116447,
                        "name": "Fayette County",
                        "latitude": "38.04233000",
                        "longitude": "-84.45873000"
                    },
                    {
                        "id": 116482,
                        "name": "Fern Creek",
                        "latitude": "38.15979000",
                        "longitude": "-85.58774000"
                    },
                    {
                        "id": 116557,
                        "name": "Flatwoods",
                        "latitude": "38.52258000",
                        "longitude": "-82.71711000"
                    },
                    {
                        "id": 116559,
                        "name": "Fleming County",
                        "latitude": "38.37011000",
                        "longitude": "-83.69665000"
                    },
                    {
                        "id": 116561,
                        "name": "Flemingsburg",
                        "latitude": "38.42230000",
                        "longitude": "-83.73381000"
                    },
                    {
                        "id": 116578,
                        "name": "Florence",
                        "latitude": "38.99895000",
                        "longitude": "-84.62661000"
                    },
                    {
                        "id": 116608,
                        "name": "Floyd County",
                        "latitude": "37.55711000",
                        "longitude": "-82.74570000"
                    },
                    {
                        "id": 116698,
                        "name": "Fort Campbell North",
                        "latitude": "36.65429000",
                        "longitude": "-87.46056000"
                    },
                    {
                        "id": 116721,
                        "name": "Fort Knox",
                        "latitude": "37.89113000",
                        "longitude": "-85.96363000"
                    },
                    {
                        "id": 116731,
                        "name": "Fort Mitchell",
                        "latitude": "39.05950000",
                        "longitude": "-84.54744000"
                    },
                    {
                        "id": 116754,
                        "name": "Fort Thomas",
                        "latitude": "39.07506000",
                        "longitude": "-84.44716000"
                    },
                    {
                        "id": 116765,
                        "name": "Fort Wright",
                        "latitude": "39.05173000",
                        "longitude": "-84.53411000"
                    },
                    {
                        "id": 116815,
                        "name": "Francisville",
                        "latitude": "39.10506000",
                        "longitude": "-84.72439000"
                    },
                    {
                        "id": 116818,
                        "name": "Frankfort",
                        "latitude": "38.20091000",
                        "longitude": "-84.87328000"
                    },
                    {
                        "id": 116825,
                        "name": "Franklin",
                        "latitude": "36.72226000",
                        "longitude": "-86.57722000"
                    },
                    {
                        "id": 116850,
                        "name": "Franklin County",
                        "latitude": "38.23915000",
                        "longitude": "-84.87707000"
                    },
                    {
                        "id": 116933,
                        "name": "Frenchburg",
                        "latitude": "37.95092000",
                        "longitude": "-83.62575000"
                    },
                    {
                        "id": 116985,
                        "name": "Fulton",
                        "latitude": "36.50423000",
                        "longitude": "-88.87423000"
                    },
                    {
                        "id": 116994,
                        "name": "Fulton County",
                        "latitude": "36.55408000",
                        "longitude": "-89.18761000"
                    },
                    {
                        "id": 117035,
                        "name": "Gallatin County",
                        "latitude": "38.75687000",
                        "longitude": "-84.85931000"
                    },
                    {
                        "id": 117096,
                        "name": "Garrard County",
                        "latitude": "37.63958000",
                        "longitude": "-84.53763000"
                    },
                    {
                        "id": 117157,
                        "name": "Georgetown",
                        "latitude": "38.20980000",
                        "longitude": "-84.55883000"
                    },
                    {
                        "id": 117246,
                        "name": "Glasgow",
                        "latitude": "36.99588000",
                        "longitude": "-85.91192000"
                    },
                    {
                        "id": 117509,
                        "name": "Grant County",
                        "latitude": "38.64881000",
                        "longitude": "-84.62461000"
                    },
                    {
                        "id": 117547,
                        "name": "Graves County",
                        "latitude": "36.72314000",
                        "longitude": "-88.65121000"
                    },
                    {
                        "id": 117557,
                        "name": "Graymoor-Devondale",
                        "latitude": "38.27313000",
                        "longitude": "-85.62302000"
                    },
                    {
                        "id": 117561,
                        "name": "Grayson",
                        "latitude": "38.33258000",
                        "longitude": "-82.94850000"
                    },
                    {
                        "id": 117562,
                        "name": "Grayson County",
                        "latitude": "37.46082000",
                        "longitude": "-86.34388000"
                    },
                    {
                        "id": 117592,
                        "name": "Green County",
                        "latitude": "37.26411000",
                        "longitude": "-85.55311000"
                    },
                    {
                        "id": 117668,
                        "name": "Greensburg",
                        "latitude": "37.26089000",
                        "longitude": "-85.49885000"
                    },
                    {
                        "id": 117677,
                        "name": "Greenup",
                        "latitude": "38.57313000",
                        "longitude": "-82.83017000"
                    },
                    {
                        "id": 117678,
                        "name": "Greenup County",
                        "latitude": "38.54566000",
                        "longitude": "-82.92229000"
                    },
                    {
                        "id": 117682,
                        "name": "Greenville",
                        "latitude": "37.20115000",
                        "longitude": "-87.17889000"
                    },
                    {
                        "id": 117811,
                        "name": "Guthrie",
                        "latitude": "36.64838000",
                        "longitude": "-87.16639000"
                    },
                    {
                        "id": 117952,
                        "name": "Hancock County",
                        "latitude": "37.84151000",
                        "longitude": "-86.77793000"
                    },
                    {
                        "id": 118000,
                        "name": "Hardin County",
                        "latitude": "37.69792000",
                        "longitude": "-85.96337000"
                    },
                    {
                        "id": 118006,
                        "name": "Hardinsburg",
                        "latitude": "37.78006000",
                        "longitude": "-86.46053000"
                    },
                    {
                        "id": 118015,
                        "name": "Harlan",
                        "latitude": "36.84314000",
                        "longitude": "-83.32185000"
                    },
                    {
                        "id": 118018,
                        "name": "Harlan County",
                        "latitude": "36.85697000",
                        "longitude": "-83.21795000"
                    },
                    {
                        "id": 118063,
                        "name": "Harrison County",
                        "latitude": "38.44181000",
                        "longitude": "-84.33139000"
                    },
                    {
                        "id": 118078,
                        "name": "Harrodsburg",
                        "latitude": "37.76230000",
                        "longitude": "-84.84329000"
                    },
                    {
                        "id": 118083,
                        "name": "Hart County",
                        "latitude": "37.29993000",
                        "longitude": "-85.88471000"
                    },
                    {
                        "id": 118086,
                        "name": "Hartford",
                        "latitude": "37.45116000",
                        "longitude": "-86.90916000"
                    },
                    {
                        "id": 118164,
                        "name": "Hawesville",
                        "latitude": "37.90006000",
                        "longitude": "-86.75499000"
                    },
                    {
                        "id": 118200,
                        "name": "Hazard",
                        "latitude": "37.24954000",
                        "longitude": "-83.19323000"
                    },
                    {
                        "id": 118232,
                        "name": "Hebron",
                        "latitude": "39.06589000",
                        "longitude": "-84.70106000"
                    },
                    {
                        "id": 118240,
                        "name": "Hebron Estates",
                        "latitude": "38.04951000",
                        "longitude": "-85.66607000"
                    },
                    {
                        "id": 118274,
                        "name": "Henderson",
                        "latitude": "37.83615000",
                        "longitude": "-87.59001000"
                    },
                    {
                        "id": 118280,
                        "name": "Henderson County",
                        "latitude": "37.79590000",
                        "longitude": "-87.57316000"
                    },
                    {
                        "id": 118288,
                        "name": "Hendron",
                        "latitude": "37.03950000",
                        "longitude": "-88.62922000"
                    },
                    {
                        "id": 118300,
                        "name": "Henry County",
                        "latitude": "38.44847000",
                        "longitude": "-85.11893000"
                    },
                    {
                        "id": 118317,
                        "name": "Heritage Creek",
                        "latitude": "38.12368000",
                        "longitude": "-85.71968000"
                    },
                    {
                        "id": 118361,
                        "name": "Hickman",
                        "latitude": "36.57117000",
                        "longitude": "-89.18618000"
                    },
                    {
                        "id": 118363,
                        "name": "Hickman County",
                        "latitude": "36.67817000",
                        "longitude": "-88.97622000"
                    },
                    {
                        "id": 118406,
                        "name": "Highland Heights",
                        "latitude": "39.03312000",
                        "longitude": "-84.45189000"
                    },
                    {
                        "id": 118425,
                        "name": "Highview",
                        "latitude": "38.14285000",
                        "longitude": "-85.62413000"
                    },
                    {
                        "id": 118470,
                        "name": "Hillview",
                        "latitude": "38.06979000",
                        "longitude": "-85.68551000"
                    },
                    {
                        "id": 118478,
                        "name": "Hindman",
                        "latitude": "37.33593000",
                        "longitude": "-82.98044000"
                    },
                    {
                        "id": 118508,
                        "name": "Hodgenville",
                        "latitude": "37.57395000",
                        "longitude": "-85.73996000"
                    },
                    {
                        "id": 118653,
                        "name": "Hopkins County",
                        "latitude": "37.30882000",
                        "longitude": "-87.54084000"
                    },
                    {
                        "id": 118655,
                        "name": "Hopkinsville",
                        "latitude": "36.86561000",
                        "longitude": "-87.49117000"
                    },
                    {
                        "id": 118670,
                        "name": "Horse Cave",
                        "latitude": "37.17950000",
                        "longitude": "-85.90692000"
                    },
                    {
                        "id": 118830,
                        "name": "Hurstbourne",
                        "latitude": "38.23813000",
                        "longitude": "-85.58829000"
                    },
                    {
                        "id": 118831,
                        "name": "Hurstbourne Acres",
                        "latitude": "38.22118000",
                        "longitude": "-85.58913000"
                    },
                    {
                        "id": 118854,
                        "name": "Hyden",
                        "latitude": "37.16093000",
                        "longitude": "-83.37324000"
                    },
                    {
                        "id": 118890,
                        "name": "Independence",
                        "latitude": "38.94312000",
                        "longitude": "-84.54411000"
                    },
                    {
                        "id": 118906,
                        "name": "Indian Hills",
                        "latitude": "38.27257000",
                        "longitude": "-85.66274000"
                    },
                    {
                        "id": 118910,
                        "name": "Indian Hills Cherokee Section",
                        "latitude": "38.27951000",
                        "longitude": "-85.64996000"
                    },
                    {
                        "id": 118931,
                        "name": "Inez",
                        "latitude": "37.86648000",
                        "longitude": "-82.53876000"
                    },
                    {
                        "id": 118998,
                        "name": "Ironville",
                        "latitude": "38.45647000",
                        "longitude": "-82.69238000"
                    },
                    {
                        "id": 119003,
                        "name": "Irvine",
                        "latitude": "37.70064000",
                        "longitude": "-83.97381000"
                    },
                    {
                        "id": 119007,
                        "name": "Irvington",
                        "latitude": "37.88034000",
                        "longitude": "-86.28386000"
                    },
                    {
                        "id": 119062,
                        "name": "Jackson",
                        "latitude": "37.55315000",
                        "longitude": "-83.38351000"
                    },
                    {
                        "id": 119082,
                        "name": "Jackson County",
                        "latitude": "37.41978000",
                        "longitude": "-84.00577000"
                    },
                    {
                        "id": 119120,
                        "name": "Jamestown",
                        "latitude": "36.98479000",
                        "longitude": "-85.06301000"
                    },
                    {
                        "id": 119182,
                        "name": "Jefferson County",
                        "latitude": "38.18719000",
                        "longitude": "-85.65916000"
                    },
                    {
                        "id": 119205,
                        "name": "Jeffersontown",
                        "latitude": "38.19424000",
                        "longitude": "-85.56440000"
                    },
                    {
                        "id": 119206,
                        "name": "Jeffersonville",
                        "latitude": "37.97369000",
                        "longitude": "-83.84186000"
                    },
                    {
                        "id": 119214,
                        "name": "Jenkins",
                        "latitude": "37.17344000",
                        "longitude": "-82.63099000"
                    },
                    {
                        "id": 119236,
                        "name": "Jessamine County",
                        "latitude": "37.87203000",
                        "longitude": "-84.58093000"
                    },
                    {
                        "id": 119265,
                        "name": "Johnson County",
                        "latitude": "37.84664000",
                        "longitude": "-82.83154000"
                    },
                    {
                        "id": 119333,
                        "name": "Junction City",
                        "latitude": "37.58674000",
                        "longitude": "-84.79384000"
                    },
                    {
                        "id": 119499,
                        "name": "Kenton County",
                        "latitude": "38.93346000",
                        "longitude": "-84.53334000"
                    },
                    {
                        "id": 119680,
                        "name": "Knott County",
                        "latitude": "37.35405000",
                        "longitude": "-82.95413000"
                    },
                    {
                        "id": 119681,
                        "name": "Knottsville",
                        "latitude": "37.77172000",
                        "longitude": "-86.90416000"
                    },
                    {
                        "id": 119686,
                        "name": "Knox County",
                        "latitude": "36.89067000",
                        "longitude": "-83.85404000"
                    },
                    {
                        "id": 119737,
                        "name": "La Center",
                        "latitude": "37.07672000",
                        "longitude": "-88.97368000"
                    },
                    {
                        "id": 119749,
                        "name": "La Grange",
                        "latitude": "38.40757000",
                        "longitude": "-85.37885000"
                    },
                    {
                        "id": 120035,
                        "name": "Lakeside Park",
                        "latitude": "39.03562000",
                        "longitude": "-84.56911000"
                    },
                    {
                        "id": 120080,
                        "name": "Lancaster",
                        "latitude": "37.61952000",
                        "longitude": "-84.57800000"
                    },
                    {
                        "id": 120152,
                        "name": "Larue County",
                        "latitude": "37.54580000",
                        "longitude": "-85.69792000"
                    },
                    {
                        "id": 120195,
                        "name": "Laurel County",
                        "latitude": "37.11067000",
                        "longitude": "-84.11780000"
                    },
                    {
                        "id": 120233,
                        "name": "Lawrence County",
                        "latitude": "38.06788000",
                        "longitude": "-82.73475000"
                    },
                    {
                        "id": 120241,
                        "name": "Lawrenceburg",
                        "latitude": "38.03730000",
                        "longitude": "-84.89662000"
                    },
                    {
                        "id": 120285,
                        "name": "Lebanon",
                        "latitude": "37.56979000",
                        "longitude": "-85.25274000"
                    },
                    {
                        "id": 120296,
                        "name": "Lebanon Junction",
                        "latitude": "37.83451000",
                        "longitude": "-85.73190000"
                    },
                    {
                        "id": 120301,
                        "name": "Ledbetter",
                        "latitude": "37.04756000",
                        "longitude": "-88.47699000"
                    },
                    {
                        "id": 120310,
                        "name": "Lee County",
                        "latitude": "37.59480000",
                        "longitude": "-83.71628000"
                    },
                    {
                        "id": 120347,
                        "name": "Leitchfield",
                        "latitude": "37.48005000",
                        "longitude": "-86.29386000"
                    },
                    {
                        "id": 120397,
                        "name": "Leslie County",
                        "latitude": "37.09406000",
                        "longitude": "-83.38116000"
                    },
                    {
                        "id": 120400,
                        "name": "Letcher County",
                        "latitude": "37.12119000",
                        "longitude": "-82.85528000"
                    },
                    {
                        "id": 120411,
                        "name": "Lewis County",
                        "latitude": "38.53154000",
                        "longitude": "-83.37805000"
                    },
                    {
                        "id": 120422,
                        "name": "Lewisport",
                        "latitude": "37.93700000",
                        "longitude": "-86.90221000"
                    },
                    {
                        "id": 120439,
                        "name": "Lexington",
                        "latitude": "37.98869000",
                        "longitude": "-84.47772000"
                    },
                    {
                        "id": 120456,
                        "name": "Lexington-Fayette",
                        "latitude": "38.04980000",
                        "longitude": "-84.45855000"
                    },
                    {
                        "id": 120459,
                        "name": "Liberty",
                        "latitude": "37.31841000",
                        "longitude": "-84.93940000"
                    },
                    {
                        "id": 120519,
                        "name": "Lincoln County",
                        "latitude": "37.45535000",
                        "longitude": "-84.66081000"
                    },
                    {
                        "id": 120642,
                        "name": "Livermore",
                        "latitude": "37.49310000",
                        "longitude": "-87.13194000"
                    },
                    {
                        "id": 120654,
                        "name": "Livingston County",
                        "latitude": "37.20970000",
                        "longitude": "-88.35381000"
                    },
                    {
                        "id": 120697,
                        "name": "Logan County",
                        "latitude": "36.85970000",
                        "longitude": "-86.87894000"
                    },
                    {
                        "id": 120721,
                        "name": "London",
                        "latitude": "37.12898000",
                        "longitude": "-84.08326000"
                    },
                    {
                        "id": 120804,
                        "name": "Louisa",
                        "latitude": "38.11425000",
                        "longitude": "-82.60321000"
                    },
                    {
                        "id": 120813,
                        "name": "Louisville",
                        "latitude": "38.25424000",
                        "longitude": "-85.75941000"
                    },
                    {
                        "id": 120869,
                        "name": "Ludlow",
                        "latitude": "39.09256000",
                        "longitude": "-84.54744000"
                    },
                    {
                        "id": 120923,
                        "name": "Lyndon",
                        "latitude": "38.25674000",
                        "longitude": "-85.60163000"
                    },
                    {
                        "id": 120936,
                        "name": "Lyon County",
                        "latitude": "37.01913000",
                        "longitude": "-88.08328000"
                    },
                    {
                        "id": 121007,
                        "name": "Madison County",
                        "latitude": "37.72018000",
                        "longitude": "-84.27800000"
                    },
                    {
                        "id": 121025,
                        "name": "Madisonville",
                        "latitude": "37.32810000",
                        "longitude": "-87.49889000"
                    },
                    {
                        "id": 121039,
                        "name": "Magoffin County",
                        "latitude": "37.70647000",
                        "longitude": "-83.06491000"
                    },
                    {
                        "id": 121091,
                        "name": "Manchester",
                        "latitude": "37.15370000",
                        "longitude": "-83.76186000"
                    },
                    {
                        "id": 121235,
                        "name": "Marion",
                        "latitude": "37.33283000",
                        "longitude": "-88.08113000"
                    },
                    {
                        "id": 121254,
                        "name": "Marion County",
                        "latitude": "37.55253000",
                        "longitude": "-85.26963000"
                    },
                    {
                        "id": 121312,
                        "name": "Marshall County",
                        "latitude": "36.88345000",
                        "longitude": "-88.32938000"
                    },
                    {
                        "id": 121339,
                        "name": "Martin County",
                        "latitude": "37.80158000",
                        "longitude": "-82.51329000"
                    },
                    {
                        "id": 121377,
                        "name": "Mason County",
                        "latitude": "38.59517000",
                        "longitude": "-83.82425000"
                    },
                    {
                        "id": 121385,
                        "name": "Masonville",
                        "latitude": "37.67505000",
                        "longitude": "-87.03472000"
                    },
                    {
                        "id": 121387,
                        "name": "Massac",
                        "latitude": "37.01672000",
                        "longitude": "-88.73061000"
                    },
                    {
                        "id": 121436,
                        "name": "Mayfield",
                        "latitude": "36.74172000",
                        "longitude": "-88.63672000"
                    },
                    {
                        "id": 121450,
                        "name": "Maysville",
                        "latitude": "38.64119000",
                        "longitude": "-83.74437000"
                    },
                    {
                        "id": 121485,
                        "name": "McCracken County",
                        "latitude": "37.05408000",
                        "longitude": "-88.71272000"
                    },
                    {
                        "id": 121486,
                        "name": "McCreary County",
                        "latitude": "36.73714000",
                        "longitude": "-84.48417000"
                    },
                    {
                        "id": 121517,
                        "name": "McKee",
                        "latitude": "37.43036000",
                        "longitude": "-83.99798000"
                    },
                    {
                        "id": 121528,
                        "name": "McLean County",
                        "latitude": "37.52919000",
                        "longitude": "-87.26361000"
                    },
                    {
                        "id": 121556,
                        "name": "Meade County",
                        "latitude": "37.96984000",
                        "longitude": "-86.21718000"
                    },
                    {
                        "id": 121572,
                        "name": "Meads",
                        "latitude": "38.41258000",
                        "longitude": "-82.70905000"
                    },
                    {
                        "id": 121660,
                        "name": "Menifee County",
                        "latitude": "37.94138000",
                        "longitude": "-83.59887000"
                    },
                    {
                        "id": 121675,
                        "name": "Mercer County",
                        "latitude": "37.81103000",
                        "longitude": "-84.87444000"
                    },
                    {
                        "id": 121733,
                        "name": "Metcalfe County",
                        "latitude": "36.99054000",
                        "longitude": "-85.62925000"
                    },
                    {
                        "id": 121776,
                        "name": "Middlesboro",
                        "latitude": "36.60842000",
                        "longitude": "-83.71658000"
                    },
                    {
                        "id": 121787,
                        "name": "Middletown",
                        "latitude": "38.24535000",
                        "longitude": "-85.53885000"
                    },
                    {
                        "id": 121814,
                        "name": "Midway",
                        "latitude": "38.15091000",
                        "longitude": "-84.68383000"
                    },
                    {
                        "id": 122073,
                        "name": "Monroe County",
                        "latitude": "36.71218000",
                        "longitude": "-85.71652000"
                    },
                    {
                        "id": 122144,
                        "name": "Montgomery County",
                        "latitude": "38.03353000",
                        "longitude": "-83.91310000"
                    },
                    {
                        "id": 122162,
                        "name": "Monticello",
                        "latitude": "36.82979000",
                        "longitude": "-84.84911000"
                    },
                    {
                        "id": 122225,
                        "name": "Morehead",
                        "latitude": "38.18397000",
                        "longitude": "-83.43268000"
                    },
                    {
                        "id": 122240,
                        "name": "Morgan County",
                        "latitude": "37.92228000",
                        "longitude": "-83.25889000"
                    },
                    {
                        "id": 122248,
                        "name": "Morganfield",
                        "latitude": "37.68338000",
                        "longitude": "-87.91669000"
                    },
                    {
                        "id": 122251,
                        "name": "Morgantown",
                        "latitude": "37.22560000",
                        "longitude": "-86.68360000"
                    },
                    {
                        "id": 122371,
                        "name": "Mount Olivet",
                        "latitude": "38.53146000",
                        "longitude": "-84.03687000"
                    },
                    {
                        "id": 122391,
                        "name": "Mount Sterling",
                        "latitude": "38.05647000",
                        "longitude": "-83.94326000"
                    },
                    {
                        "id": 122397,
                        "name": "Mount Vernon",
                        "latitude": "37.35286000",
                        "longitude": "-84.34049000"
                    },
                    {
                        "id": 122406,
                        "name": "Mount Washington",
                        "latitude": "38.05006000",
                        "longitude": "-85.54579000"
                    },
                    {
                        "id": 122448,
                        "name": "Muhlenberg County",
                        "latitude": "37.21579000",
                        "longitude": "-87.14204000"
                    },
                    {
                        "id": 122472,
                        "name": "Munfordville",
                        "latitude": "37.27228000",
                        "longitude": "-85.89108000"
                    },
                    {
                        "id": 122491,
                        "name": "Murray",
                        "latitude": "36.61033000",
                        "longitude": "-88.31476000"
                    },
                    {
                        "id": 122626,
                        "name": "Nelson County",
                        "latitude": "37.80513000",
                        "longitude": "-85.46599000"
                    },
                    {
                        "id": 122685,
                        "name": "New Castle",
                        "latitude": "38.43340000",
                        "longitude": "-85.16968000"
                    },
                    {
                        "id": 122814,
                        "name": "Newburg",
                        "latitude": "38.16007000",
                        "longitude": "-85.65968000"
                    },
                    {
                        "id": 122841,
                        "name": "Newport",
                        "latitude": "39.09145000",
                        "longitude": "-84.49578000"
                    },
                    {
                        "id": 122887,
                        "name": "Nicholas County",
                        "latitude": "38.33560000",
                        "longitude": "-84.01533000"
                    },
                    {
                        "id": 122889,
                        "name": "Nicholasville",
                        "latitude": "37.88063000",
                        "longitude": "-84.57300000"
                    },
                    {
                        "id": 123010,
                        "name": "North Corbin",
                        "latitude": "36.96064000",
                        "longitude": "-84.09326000"
                    },
                    {
                        "id": 123148,
                        "name": "Northfield",
                        "latitude": "38.28701000",
                        "longitude": "-85.64107000"
                    },
                    {
                        "id": 123188,
                        "name": "Nortonville",
                        "latitude": "37.19088000",
                        "longitude": "-87.45278000"
                    },
                    {
                        "id": 123234,
                        "name": "Oak Grove",
                        "latitude": "36.66505000",
                        "longitude": "-87.44279000"
                    },
                    {
                        "id": 123268,
                        "name": "Oakbrook",
                        "latitude": "38.99978000",
                        "longitude": "-84.68522000"
                    },
                    {
                        "id": 123383,
                        "name": "Ohio County",
                        "latitude": "37.47819000",
                        "longitude": "-86.84889000"
                    },
                    {
                        "id": 123408,
                        "name": "Okolona",
                        "latitude": "38.14118000",
                        "longitude": "-85.68774000"
                    },
                    {
                        "id": 123432,
                        "name": "Oldham County",
                        "latitude": "38.39944000",
                        "longitude": "-85.44837000"
                    },
                    {
                        "id": 123440,
                        "name": "Olive Hill",
                        "latitude": "38.30008000",
                        "longitude": "-83.17407000"
                    },
                    {
                        "id": 123533,
                        "name": "Orchard Grass Hills",
                        "latitude": "38.32368000",
                        "longitude": "-85.52135000"
                    },
                    {
                        "id": 123662,
                        "name": "Owen County",
                        "latitude": "38.51964000",
                        "longitude": "-84.82811000"
                    },
                    {
                        "id": 123664,
                        "name": "Owensboro",
                        "latitude": "37.77422000",
                        "longitude": "-87.11333000"
                    },
                    {
                        "id": 123667,
                        "name": "Owenton",
                        "latitude": "38.53672000",
                        "longitude": "-84.84338000"
                    },
                    {
                        "id": 123670,
                        "name": "Owingsville",
                        "latitude": "38.14480000",
                        "longitude": "-83.76408000"
                    },
                    {
                        "id": 123673,
                        "name": "Owsley County",
                        "latitude": "37.41920000",
                        "longitude": "-83.68311000"
                    },
                    {
                        "id": 123715,
                        "name": "Paducah",
                        "latitude": "37.08339000",
                        "longitude": "-88.60005000"
                    },
                    {
                        "id": 123728,
                        "name": "Paintsville",
                        "latitude": "37.81454000",
                        "longitude": "-82.80711000"
                    },
                    {
                        "id": 123831,
                        "name": "Paris",
                        "latitude": "38.20980000",
                        "longitude": "-84.25299000"
                    },
                    {
                        "id": 123849,
                        "name": "Park Hills",
                        "latitude": "39.07145000",
                        "longitude": "-84.53217000"
                    },
                    {
                        "id": 124019,
                        "name": "Pendleton County",
                        "latitude": "38.69563000",
                        "longitude": "-84.36027000"
                    },
                    {
                        "id": 124078,
                        "name": "Perry County",
                        "latitude": "37.24429000",
                        "longitude": "-83.22148000"
                    },
                    {
                        "id": 124116,
                        "name": "Pewee Valley",
                        "latitude": "38.31062000",
                        "longitude": "-85.48746000"
                    },
                    {
                        "id": 124190,
                        "name": "Pike County",
                        "latitude": "37.46902000",
                        "longitude": "-82.39587000"
                    },
                    {
                        "id": 124198,
                        "name": "Pikeville",
                        "latitude": "37.47927000",
                        "longitude": "-82.51876000"
                    },
                    {
                        "id": 124232,
                        "name": "Pine Knot",
                        "latitude": "36.65091000",
                        "longitude": "-84.43855000"
                    },
                    {
                        "id": 124259,
                        "name": "Pineville",
                        "latitude": "36.76203000",
                        "longitude": "-83.69492000"
                    },
                    {
                        "id": 124275,
                        "name": "Pioneer Village",
                        "latitude": "38.06062000",
                        "longitude": "-85.67774000"
                    },
                    {
                        "id": 124342,
                        "name": "Plano",
                        "latitude": "36.88032000",
                        "longitude": "-86.41832000"
                    },
                    {
                        "id": 124389,
                        "name": "Pleasure Ridge Park",
                        "latitude": "38.14535000",
                        "longitude": "-85.85830000"
                    },
                    {
                        "id": 124612,
                        "name": "Powell County",
                        "latitude": "37.83115000",
                        "longitude": "-83.82377000"
                    },
                    {
                        "id": 124661,
                        "name": "Prestonsburg",
                        "latitude": "37.66565000",
                        "longitude": "-82.77155000"
                    },
                    {
                        "id": 124682,
                        "name": "Princeton",
                        "latitude": "37.10922000",
                        "longitude": "-87.88196000"
                    },
                    {
                        "id": 124705,
                        "name": "Prospect",
                        "latitude": "38.34507000",
                        "longitude": "-85.61552000"
                    },
                    {
                        "id": 124715,
                        "name": "Providence",
                        "latitude": "38.57451000",
                        "longitude": "-85.22107000"
                    },
                    {
                        "id": 124740,
                        "name": "Pulaski County",
                        "latitude": "37.10393000",
                        "longitude": "-84.57718000"
                    },
                    {
                        "id": 124812,
                        "name": "Raceland",
                        "latitude": "38.54008000",
                        "longitude": "-82.72850000"
                    },
                    {
                        "id": 124815,
                        "name": "Radcliff",
                        "latitude": "37.84035000",
                        "longitude": "-85.94913000"
                    },
                    {
                        "id": 125006,
                        "name": "Reidland",
                        "latitude": "37.01756000",
                        "longitude": "-88.53143000"
                    },
                    {
                        "id": 125085,
                        "name": "Richmond",
                        "latitude": "37.74786000",
                        "longitude": "-84.29465000"
                    },
                    {
                        "id": 125245,
                        "name": "Robertson County",
                        "latitude": "38.51882000",
                        "longitude": "-84.05203000"
                    },
                    {
                        "id": 125293,
                        "name": "Rockcastle County",
                        "latitude": "37.36518000",
                        "longitude": "-84.31594000"
                    },
                    {
                        "id": 125477,
                        "name": "Rowan County",
                        "latitude": "38.19626000",
                        "longitude": "-83.42108000"
                    },
                    {
                        "id": 125534,
                        "name": "Russell",
                        "latitude": "38.51730000",
                        "longitude": "-82.69766000"
                    },
                    {
                        "id": 125538,
                        "name": "Russell County",
                        "latitude": "36.99103000",
                        "longitude": "-85.05869000"
                    },
                    {
                        "id": 125540,
                        "name": "Russell Springs",
                        "latitude": "37.05618000",
                        "longitude": "-85.08857000"
                    },
                    {
                        "id": 125544,
                        "name": "Russellville",
                        "latitude": "36.84532000",
                        "longitude": "-86.88722000"
                    },
                    {
                        "id": 125565,
                        "name": "Ryland Heights",
                        "latitude": "38.95756000",
                        "longitude": "-84.46300000"
                    },
                    {
                        "id": 125631,
                        "name": "Saint Dennis",
                        "latitude": "38.18840000",
                        "longitude": "-85.84580000"
                    },
                    {
                        "id": 125695,
                        "name": "Saint Matthews",
                        "latitude": "38.25285000",
                        "longitude": "-85.65579000"
                    },
                    {
                        "id": 125711,
                        "name": "Saint Regis Park",
                        "latitude": "38.22674000",
                        "longitude": "-85.61663000"
                    },
                    {
                        "id": 125776,
                        "name": "Salyersville",
                        "latitude": "37.75259000",
                        "longitude": "-83.06878000"
                    },
                    {
                        "id": 125883,
                        "name": "Sandy Hook",
                        "latitude": "38.08647000",
                        "longitude": "-83.12628000"
                    },
                    {
                        "id": 126046,
                        "name": "Scott County",
                        "latitude": "38.29156000",
                        "longitude": "-84.58393000"
                    },
                    {
                        "id": 126064,
                        "name": "Scottsville",
                        "latitude": "36.75338000",
                        "longitude": "-86.19054000"
                    },
                    {
                        "id": 126110,
                        "name": "Sebree",
                        "latitude": "37.60699000",
                        "longitude": "-87.52862000"
                    },
                    {
                        "id": 126275,
                        "name": "Shelby County",
                        "latitude": "38.21544000",
                        "longitude": "-85.19477000"
                    },
                    {
                        "id": 126282,
                        "name": "Shelbyville",
                        "latitude": "38.21201000",
                        "longitude": "-85.22357000"
                    },
                    {
                        "id": 126312,
                        "name": "Shepherdsville",
                        "latitude": "37.98840000",
                        "longitude": "-85.71579000"
                    },
                    {
                        "id": 126362,
                        "name": "Shively",
                        "latitude": "38.20007000",
                        "longitude": "-85.82274000"
                    },
                    {
                        "id": 126425,
                        "name": "Silver Grove",
                        "latitude": "39.03451000",
                        "longitude": "-84.39022000"
                    },
                    {
                        "id": 126449,
                        "name": "Simpson County",
                        "latitude": "36.74194000",
                        "longitude": "-86.58232000"
                    },
                    {
                        "id": 126451,
                        "name": "Simpsonville",
                        "latitude": "38.22257000",
                        "longitude": "-85.35523000"
                    },
                    {
                        "id": 126522,
                        "name": "Smithland",
                        "latitude": "37.13894000",
                        "longitude": "-88.40337000"
                    },
                    {
                        "id": 126580,
                        "name": "Somerset",
                        "latitude": "37.09202000",
                        "longitude": "-84.60411000"
                    },
                    {
                        "id": 126728,
                        "name": "South Shore",
                        "latitude": "38.72091000",
                        "longitude": "-82.95823000"
                    },
                    {
                        "id": 126774,
                        "name": "Southgate",
                        "latitude": "39.07200000",
                        "longitude": "-84.47272000"
                    },
                    {
                        "id": 126829,
                        "name": "Spencer County",
                        "latitude": "38.03251000",
                        "longitude": "-85.32785000"
                    },
                    {
                        "id": 126892,
                        "name": "Springfield",
                        "latitude": "37.68534000",
                        "longitude": "-85.22218000"
                    },
                    {
                        "id": 126953,
                        "name": "Stanford",
                        "latitude": "37.53119000",
                        "longitude": "-84.66189000"
                    },
                    {
                        "id": 126966,
                        "name": "Stanton",
                        "latitude": "37.84564000",
                        "longitude": "-83.85825000"
                    },
                    {
                        "id": 127004,
                        "name": "Stearns",
                        "latitude": "36.69897000",
                        "longitude": "-84.47744000"
                    },
                    {
                        "id": 127150,
                        "name": "Sturgis",
                        "latitude": "37.54671000",
                        "longitude": "-87.98391000"
                    },
                    {
                        "id": 127453,
                        "name": "Taylor County",
                        "latitude": "37.36646000",
                        "longitude": "-85.32784000"
                    },
                    {
                        "id": 127460,
                        "name": "Taylor Mill",
                        "latitude": "38.99756000",
                        "longitude": "-84.49633000"
                    },
                    {
                        "id": 127463,
                        "name": "Taylorsville",
                        "latitude": "38.03173000",
                        "longitude": "-85.34245000"
                    },
                    {
                        "id": 127692,
                        "name": "Todd County",
                        "latitude": "36.83556000",
                        "longitude": "-87.17915000"
                    },
                    {
                        "id": 127714,
                        "name": "Tompkinsville",
                        "latitude": "36.70228000",
                        "longitude": "-85.69164000"
                    },
                    {
                        "id": 127821,
                        "name": "Trigg County",
                        "latitude": "36.80632000",
                        "longitude": "-87.87337000"
                    },
                    {
                        "id": 127822,
                        "name": "Trimble County",
                        "latitude": "38.61303000",
                        "longitude": "-85.33757000"
                    },
                    {
                        "id": 127971,
                        "name": "Union",
                        "latitude": "38.94590000",
                        "longitude": "-84.68050000"
                    },
                    {
                        "id": 127993,
                        "name": "Union County",
                        "latitude": "37.65845000",
                        "longitude": "-87.94538000"
                    },
                    {
                        "id": 128116,
                        "name": "Valley Station",
                        "latitude": "38.11118000",
                        "longitude": "-85.87024000"
                    },
                    {
                        "id": 128134,
                        "name": "Van Lear",
                        "latitude": "37.77121000",
                        "longitude": "-82.75794000"
                    },
                    {
                        "id": 128142,
                        "name": "Vanceburg",
                        "latitude": "38.59924000",
                        "longitude": "-83.31880000"
                    },
                    {
                        "id": 128200,
                        "name": "Verona",
                        "latitude": "38.81840000",
                        "longitude": "-84.66078000"
                    },
                    {
                        "id": 128209,
                        "name": "Versailles",
                        "latitude": "38.05258000",
                        "longitude": "-84.72995000"
                    },
                    {
                        "id": 128242,
                        "name": "Villa Hills",
                        "latitude": "39.06339000",
                        "longitude": "-84.59300000"
                    },
                    {
                        "id": 128268,
                        "name": "Vine Grove",
                        "latitude": "37.81007000",
                        "longitude": "-85.98135000"
                    },
                    {
                        "id": 128434,
                        "name": "Walton",
                        "latitude": "38.87562000",
                        "longitude": "-84.61022000"
                    },
                    {
                        "id": 128487,
                        "name": "Warren County",
                        "latitude": "36.99358000",
                        "longitude": "-86.42380000"
                    },
                    {
                        "id": 128515,
                        "name": "Warsaw",
                        "latitude": "38.78340000",
                        "longitude": "-84.90162000"
                    },
                    {
                        "id": 128559,
                        "name": "Washington County",
                        "latitude": "37.75338000",
                        "longitude": "-85.17475000"
                    },
                    {
                        "id": 128642,
                        "name": "Watterson Park",
                        "latitude": "38.19229000",
                        "longitude": "-85.68329000"
                    },
                    {
                        "id": 128692,
                        "name": "Wayne County",
                        "latitude": "36.80127000",
                        "longitude": "-84.82863000"
                    },
                    {
                        "id": 128737,
                        "name": "Webster County",
                        "latitude": "37.51842000",
                        "longitude": "-87.68316000"
                    },
                    {
                        "id": 128837,
                        "name": "West Buechel",
                        "latitude": "38.19701000",
                        "longitude": "-85.66329000"
                    },
                    {
                        "id": 128916,
                        "name": "West Liberty",
                        "latitude": "37.92148000",
                        "longitude": "-83.25962000"
                    },
                    {
                        "id": 129083,
                        "name": "Westwood",
                        "latitude": "38.48314000",
                        "longitude": "-82.66988000"
                    },
                    {
                        "id": 129185,
                        "name": "Whitesburg",
                        "latitude": "37.11843000",
                        "longitude": "-82.82683000"
                    },
                    {
                        "id": 129199,
                        "name": "Whitley City",
                        "latitude": "36.72341000",
                        "longitude": "-84.47049000"
                    },
                    {
                        "id": 129200,
                        "name": "Whitley County",
                        "latitude": "36.75807000",
                        "longitude": "-84.14518000"
                    },
                    {
                        "id": 129221,
                        "name": "Wickliffe",
                        "latitude": "36.96478000",
                        "longitude": "-89.08923000"
                    },
                    {
                        "id": 129231,
                        "name": "Wilder",
                        "latitude": "39.05645000",
                        "longitude": "-84.48689000"
                    },
                    {
                        "id": 129266,
                        "name": "Williamsburg",
                        "latitude": "36.74342000",
                        "longitude": "-84.15966000"
                    },
                    {
                        "id": 129285,
                        "name": "Williamstown",
                        "latitude": "38.63812000",
                        "longitude": "-84.56050000"
                    },
                    {
                        "id": 129327,
                        "name": "Wilmore",
                        "latitude": "37.86202000",
                        "longitude": "-84.66161000"
                    },
                    {
                        "id": 129353,
                        "name": "Winchester",
                        "latitude": "37.99008000",
                        "longitude": "-84.17965000"
                    },
                    {
                        "id": 129391,
                        "name": "Windy Hills",
                        "latitude": "38.27396000",
                        "longitude": "-85.63441000"
                    },
                    {
                        "id": 129477,
                        "name": "Wolfe County",
                        "latitude": "37.73932000",
                        "longitude": "-83.49318000"
                    },
                    {
                        "id": 129519,
                        "name": "Woodford County",
                        "latitude": "38.04239000",
                        "longitude": "-84.74359000"
                    },
                    {
                        "id": 129597,
                        "name": "Worthington",
                        "latitude": "38.54841000",
                        "longitude": "-82.72433000"
                    },
                    {
                        "id": 129599,
                        "name": "Worthington Hills",
                        "latitude": "38.30896000",
                        "longitude": "-85.52690000"
                    },
                    {
                        "id": 129618,
                        "name": "Wurtland",
                        "latitude": "38.55036000",
                        "longitude": "-82.77794000"
                    }
                ]
            },
            {
                "id": 1403,
                "name": "Kingman Reef",
                "iso2": "UM-89",
                "latitude": "6.38333300",
                "longitude": "-162.41666700",
                "type": "islands \/ groups of islands",
                "cities": []
            },
            {
                "id": 1457,
                "name": "Louisiana",
                "iso2": "LA",
                "latitude": "30.98429770",
                "longitude": "-91.96233270",
                "type": "state",
                "cities": [
                    {
                        "id": 110966,
                        "name": "Abbeville",
                        "latitude": "29.97465000",
                        "longitude": "-92.13429000"
                    },
                    {
                        "id": 110987,
                        "name": "Abita Springs",
                        "latitude": "30.47864000",
                        "longitude": "-90.04008000"
                    },
                    {
                        "id": 110991,
                        "name": "Acadia Parish",
                        "latitude": "30.29053000",
                        "longitude": "-92.41198000"
                    },
                    {
                        "id": 111033,
                        "name": "Addis",
                        "latitude": "30.35380000",
                        "longitude": "-91.26539000"
                    },
                    {
                        "id": 111103,
                        "name": "Albany",
                        "latitude": "30.50436000",
                        "longitude": "-90.58231000"
                    },
                    {
                        "id": 111150,
                        "name": "Alexandria",
                        "latitude": "31.31129000",
                        "longitude": "-92.44514000"
                    },
                    {
                        "id": 111191,
                        "name": "Allen Parish",
                        "latitude": "30.65287000",
                        "longitude": "-92.82788000"
                    },
                    {
                        "id": 111260,
                        "name": "Ama",
                        "latitude": "29.95215000",
                        "longitude": "-90.29647000"
                    },
                    {
                        "id": 111268,
                        "name": "Amelia",
                        "latitude": "29.66632000",
                        "longitude": "-91.10204000"
                    },
                    {
                        "id": 111288,
                        "name": "Amite",
                        "latitude": "30.72657000",
                        "longitude": "-90.50898000"
                    },
                    {
                        "id": 111408,
                        "name": "Arabi",
                        "latitude": "29.95437000",
                        "longitude": "-90.00535000"
                    },
                    {
                        "id": 111421,
                        "name": "Arcadia",
                        "latitude": "32.54904000",
                        "longitude": "-92.92016000"
                    },
                    {
                        "id": 111482,
                        "name": "Arnaudville",
                        "latitude": "30.39770000",
                        "longitude": "-91.93151000"
                    },
                    {
                        "id": 111509,
                        "name": "Ascension Parish",
                        "latitude": "30.20354000",
                        "longitude": "-90.91129000"
                    },
                    {
                        "id": 111558,
                        "name": "Assumption Parish",
                        "latitude": "29.90077000",
                        "longitude": "-91.06259000"
                    },
                    {
                        "id": 111698,
                        "name": "Avondale",
                        "latitude": "29.91298000",
                        "longitude": "-90.20369000"
                    },
                    {
                        "id": 111704,
                        "name": "Avoyelles Parish",
                        "latitude": "31.07624000",
                        "longitude": "-92.00138000"
                    },
                    {
                        "id": 111738,
                        "name": "Baker",
                        "latitude": "30.58824000",
                        "longitude": "-91.16816000"
                    },
                    {
                        "id": 111754,
                        "name": "Baldwin",
                        "latitude": "29.83798000",
                        "longitude": "-91.54428000"
                    },
                    {
                        "id": 111768,
                        "name": "Ball",
                        "latitude": "31.41546000",
                        "longitude": "-92.41180000"
                    },
                    {
                        "id": 111799,
                        "name": "Banks Springs",
                        "latitude": "32.08210000",
                        "longitude": "-92.09291000"
                    },
                    {
                        "id": 111811,
                        "name": "Barataria",
                        "latitude": "29.72327000",
                        "longitude": "-90.12369000"
                    },
                    {
                        "id": 111877,
                        "name": "Basile",
                        "latitude": "30.48520000",
                        "longitude": "-92.59597000"
                    },
                    {
                        "id": 111883,
                        "name": "Bastrop",
                        "latitude": "32.77828000",
                        "longitude": "-91.91144000"
                    },
                    {
                        "id": 111903,
                        "name": "Baton Rouge",
                        "latitude": "30.44332000",
                        "longitude": "-91.18747000"
                    },
                    {
                        "id": 111912,
                        "name": "Bawcomville",
                        "latitude": "32.47042000",
                        "longitude": "-92.16736000"
                    },
                    {
                        "id": 111946,
                        "name": "Bayou Cane",
                        "latitude": "29.62410000",
                        "longitude": "-90.75120000"
                    },
                    {
                        "id": 111947,
                        "name": "Bayou Gauche",
                        "latitude": "29.78743000",
                        "longitude": "-90.41314000"
                    },
                    {
                        "id": 111949,
                        "name": "Bayou Vista",
                        "latitude": "29.68965000",
                        "longitude": "-91.27094000"
                    },
                    {
                        "id": 111991,
                        "name": "Beauregard Parish",
                        "latitude": "30.64847000",
                        "longitude": "-93.34334000"
                    },
                    {
                        "id": 112080,
                        "name": "Belle Chasse",
                        "latitude": "29.85493000",
                        "longitude": "-89.99063000"
                    },
                    {
                        "id": 112092,
                        "name": "Belle Rose",
                        "latitude": "30.05048000",
                        "longitude": "-91.04149000"
                    },
                    {
                        "id": 112194,
                        "name": "Benton",
                        "latitude": "32.69487000",
                        "longitude": "-93.74185000"
                    },
                    {
                        "id": 112247,
                        "name": "Bernice",
                        "latitude": "32.82209000",
                        "longitude": "-92.65793000"
                    },
                    {
                        "id": 112261,
                        "name": "Berwick",
                        "latitude": "29.69465000",
                        "longitude": "-91.21899000"
                    },
                    {
                        "id": 112313,
                        "name": "Bienville Parish",
                        "latitude": "32.34722000",
                        "longitude": "-93.05595000"
                    },
                    {
                        "id": 112416,
                        "name": "Blanchard",
                        "latitude": "32.58098000",
                        "longitude": "-93.89268000"
                    },
                    {
                        "id": 112498,
                        "name": "Bogalusa",
                        "latitude": "30.79102000",
                        "longitude": "-89.84869000"
                    },
                    {
                        "id": 112586,
                        "name": "Bossier City",
                        "latitude": "32.51599000",
                        "longitude": "-93.73212000"
                    },
                    {
                        "id": 112587,
                        "name": "Bossier Parish",
                        "latitude": "32.67899000",
                        "longitude": "-93.60500000"
                    },
                    {
                        "id": 112616,
                        "name": "Bourg",
                        "latitude": "29.55355000",
                        "longitude": "-90.60231000"
                    },
                    {
                        "id": 112618,
                        "name": "Boutte",
                        "latitude": "29.90243000",
                        "longitude": "-90.38814000"
                    },
                    {
                        "id": 112709,
                        "name": "Breaux Bridge",
                        "latitude": "30.27353000",
                        "longitude": "-91.89928000"
                    },
                    {
                        "id": 112755,
                        "name": "Bridge City",
                        "latitude": "29.93326000",
                        "longitude": "-90.17007000"
                    },
                    {
                        "id": 112903,
                        "name": "Broussard",
                        "latitude": "30.14715000",
                        "longitude": "-91.96123000"
                    },
                    {
                        "id": 112925,
                        "name": "Brownsfield",
                        "latitude": "30.54658000",
                        "longitude": "-91.12066000"
                    },
                    {
                        "id": 112930,
                        "name": "Brownsville",
                        "latitude": "32.48709000",
                        "longitude": "-92.15430000"
                    },
                    {
                        "id": 112957,
                        "name": "Brusly",
                        "latitude": "30.39436000",
                        "longitude": "-91.25372000"
                    },
                    {
                        "id": 113044,
                        "name": "Bunkie",
                        "latitude": "30.95325000",
                        "longitude": "-92.18263000"
                    },
                    {
                        "id": 113162,
                        "name": "Caddo Parish",
                        "latitude": "32.58017000",
                        "longitude": "-93.88235000"
                    },
                    {
                        "id": 113163,
                        "name": "Cade",
                        "latitude": "30.08742000",
                        "longitude": "-91.90540000"
                    },
                    {
                        "id": 113177,
                        "name": "Calcasieu Parish",
                        "latitude": "30.22922000",
                        "longitude": "-93.35795000"
                    },
                    {
                        "id": 113187,
                        "name": "Caldwell Parish",
                        "latitude": "32.09227000",
                        "longitude": "-92.11661000"
                    },
                    {
                        "id": 113274,
                        "name": "Cameron",
                        "latitude": "29.79772000",
                        "longitude": "-93.32515000"
                    },
                    {
                        "id": 113279,
                        "name": "Cameron Parish",
                        "latitude": "29.84687000",
                        "longitude": "-93.19890000"
                    },
                    {
                        "id": 113309,
                        "name": "Campti",
                        "latitude": "31.89350000",
                        "longitude": "-93.11822000"
                    },
                    {
                        "id": 113393,
                        "name": "Carencro",
                        "latitude": "30.31714000",
                        "longitude": "-92.04901000"
                    },
                    {
                        "id": 113415,
                        "name": "Carlyss",
                        "latitude": "30.16882000",
                        "longitude": "-93.37599000"
                    },
                    {
                        "id": 113504,
                        "name": "Carville",
                        "latitude": "30.21742000",
                        "longitude": "-91.09621000"
                    },
                    {
                        "id": 113561,
                        "name": "Catahoula",
                        "latitude": "30.21464000",
                        "longitude": "-91.70900000"
                    },
                    {
                        "id": 113562,
                        "name": "Catahoula Parish",
                        "latitude": "31.66617000",
                        "longitude": "-91.84707000"
                    },
                    {
                        "id": 113600,
                        "name": "Cecilia",
                        "latitude": "30.33714000",
                        "longitude": "-91.85317000"
                    },
                    {
                        "id": 113663,
                        "name": "Central",
                        "latitude": "30.55435000",
                        "longitude": "-91.03677000"
                    },
                    {
                        "id": 113705,
                        "name": "Chackbay",
                        "latitude": "29.88354000",
                        "longitude": "-90.79732000"
                    },
                    {
                        "id": 113716,
                        "name": "Chalmette",
                        "latitude": "29.94296000",
                        "longitude": "-89.96537000"
                    },
                    {
                        "id": 113748,
                        "name": "Charenton",
                        "latitude": "29.88159000",
                        "longitude": "-91.52511000"
                    },
                    {
                        "id": 113816,
                        "name": "Chauvin",
                        "latitude": "29.43855000",
                        "longitude": "-90.59537000"
                    },
                    {
                        "id": 114009,
                        "name": "Church Point",
                        "latitude": "30.40298000",
                        "longitude": "-92.21513000"
                    },
                    {
                        "id": 114092,
                        "name": "Claiborne",
                        "latitude": "32.51598000",
                        "longitude": "-92.19180000"
                    },
                    {
                        "id": 114095,
                        "name": "Claiborne Parish",
                        "latitude": "32.82269000",
                        "longitude": "-92.99573000"
                    },
                    {
                        "id": 114140,
                        "name": "Clarks",
                        "latitude": "32.02655000",
                        "longitude": "-92.13903000"
                    },
                    {
                        "id": 114270,
                        "name": "Clinton",
                        "latitude": "30.86574000",
                        "longitude": "-91.01566000"
                    },
                    {
                        "id": 114404,
                        "name": "Colfax",
                        "latitude": "31.51906000",
                        "longitude": "-92.70682000"
                    },
                    {
                        "id": 114466,
                        "name": "Columbia",
                        "latitude": "32.10516000",
                        "longitude": "-92.07791000"
                    },
                    {
                        "id": 114547,
                        "name": "Concordia Parish",
                        "latitude": "31.44584000",
                        "longitude": "-91.64006000"
                    },
                    {
                        "id": 114577,
                        "name": "Convent",
                        "latitude": "30.02076000",
                        "longitude": "-90.82982000"
                    },
                    {
                        "id": 114698,
                        "name": "Cottonport",
                        "latitude": "30.98408000",
                        "longitude": "-92.05346000"
                    },
                    {
                        "id": 114729,
                        "name": "Coushatta",
                        "latitude": "32.01488000",
                        "longitude": "-93.34212000"
                    },
                    {
                        "id": 114737,
                        "name": "Covington",
                        "latitude": "30.47549000",
                        "longitude": "-90.10042000"
                    },
                    {
                        "id": 114863,
                        "name": "Crowley",
                        "latitude": "30.21409000",
                        "longitude": "-92.37458000"
                    },
                    {
                        "id": 114894,
                        "name": "Cullen",
                        "latitude": "32.96903000",
                        "longitude": "-93.45073000"
                    },
                    {
                        "id": 114942,
                        "name": "Cut Off",
                        "latitude": "29.54272000",
                        "longitude": "-90.33814000"
                    },
                    {
                        "id": 115120,
                        "name": "De Soto Parish",
                        "latitude": "32.05545000",
                        "longitude": "-93.73728000"
                    },
                    {
                        "id": 115209,
                        "name": "Delcambre",
                        "latitude": "29.94826000",
                        "longitude": "-91.98873000"
                    },
                    {
                        "id": 115211,
                        "name": "Delhi",
                        "latitude": "32.45764000",
                        "longitude": "-91.49317000"
                    },
                    {
                        "id": 115236,
                        "name": "Denham Springs",
                        "latitude": "30.48740000",
                        "longitude": "-90.95753000"
                    },
                    {
                        "id": 115136,
                        "name": "DeQuincy",
                        "latitude": "30.45048000",
                        "longitude": "-93.43322000"
                    },
                    {
                        "id": 115137,
                        "name": "DeRidder",
                        "latitude": "30.84631000",
                        "longitude": "-93.28905000"
                    },
                    {
                        "id": 115269,
                        "name": "Des Allemands",
                        "latitude": "29.82382000",
                        "longitude": "-90.47508000"
                    },
                    {
                        "id": 115290,
                        "name": "Destrehan",
                        "latitude": "29.94322000",
                        "longitude": "-90.35345000"
                    },
                    {
                        "id": 115297,
                        "name": "Deville",
                        "latitude": "31.35740000",
                        "longitude": "-92.16541000"
                    },
                    {
                        "id": 115394,
                        "name": "Donaldsonville",
                        "latitude": "30.10114000",
                        "longitude": "-90.99412000"
                    },
                    {
                        "id": 115509,
                        "name": "Dulac",
                        "latitude": "29.38883000",
                        "longitude": "-90.71398000"
                    },
                    {
                        "id": 115577,
                        "name": "Duson",
                        "latitude": "30.23576000",
                        "longitude": "-92.18540000"
                    },
                    {
                        "id": 115630,
                        "name": "East Baton Rouge Parish",
                        "latitude": "30.53824000",
                        "longitude": "-91.09562000"
                    },
                    {
                        "id": 115643,
                        "name": "East Carroll Parish",
                        "latitude": "32.73255000",
                        "longitude": "-91.23507000"
                    },
                    {
                        "id": 115659,
                        "name": "East Feliciana Parish",
                        "latitude": "30.84507000",
                        "longitude": "-91.04554000"
                    },
                    {
                        "id": 115799,
                        "name": "Eastwood",
                        "latitude": "32.55626000",
                        "longitude": "-93.56712000"
                    },
                    {
                        "id": 115831,
                        "name": "Eden Isle",
                        "latitude": "30.22853000",
                        "longitude": "-89.79867000"
                    },
                    {
                        "id": 115837,
                        "name": "Edgard",
                        "latitude": "30.04326000",
                        "longitude": "-90.56009000"
                    },
                    {
                        "id": 116060,
                        "name": "Elmwood",
                        "latitude": "29.95659000",
                        "longitude": "-90.18980000"
                    },
                    {
                        "id": 116073,
                        "name": "Elton",
                        "latitude": "30.48131000",
                        "longitude": "-92.69570000"
                    },
                    {
                        "id": 116160,
                        "name": "Erath",
                        "latitude": "29.95826000",
                        "longitude": "-92.03596000"
                    },
                    {
                        "id": 116177,
                        "name": "Erwinville",
                        "latitude": "30.53102000",
                        "longitude": "-91.40789000"
                    },
                    {
                        "id": 116205,
                        "name": "Estelle",
                        "latitude": "29.84576000",
                        "longitude": "-90.10674000"
                    },
                    {
                        "id": 116229,
                        "name": "Eunice",
                        "latitude": "30.49437000",
                        "longitude": "-92.41763000"
                    },
                    {
                        "id": 116244,
                        "name": "Evangeline Parish",
                        "latitude": "30.72894000",
                        "longitude": "-92.40590000"
                    },
                    {
                        "id": 116408,
                        "name": "Farmerville",
                        "latitude": "32.77347000",
                        "longitude": "-92.40570000"
                    },
                    {
                        "id": 116493,
                        "name": "Ferriday",
                        "latitude": "31.63017000",
                        "longitude": "-91.55456000"
                    },
                    {
                        "id": 116744,
                        "name": "Fort Polk North",
                        "latitude": "31.10302000",
                        "longitude": "-93.17913000"
                    },
                    {
                        "id": 116745,
                        "name": "Fort Polk South",
                        "latitude": "31.05110000",
                        "longitude": "-93.21578000"
                    },
                    {
                        "id": 116827,
                        "name": "Franklin",
                        "latitude": "29.79604000",
                        "longitude": "-91.50150000"
                    },
                    {
                        "id": 116867,
                        "name": "Franklin Parish",
                        "latitude": "32.13322000",
                        "longitude": "-91.67377000"
                    },
                    {
                        "id": 116873,
                        "name": "Franklinton",
                        "latitude": "30.84731000",
                        "longitude": "-90.15527000"
                    },
                    {
                        "id": 116932,
                        "name": "French Settlement",
                        "latitude": "30.29599000",
                        "longitude": "-90.79630000"
                    },
                    {
                        "id": 117037,
                        "name": "Galliano",
                        "latitude": "29.44216000",
                        "longitude": "-90.29925000"
                    },
                    {
                        "id": 117072,
                        "name": "Gardere",
                        "latitude": "30.34575000",
                        "longitude": "-91.14011000"
                    },
                    {
                        "id": 117107,
                        "name": "Garyville",
                        "latitude": "30.05604000",
                        "longitude": "-90.61926000"
                    },
                    {
                        "id": 117294,
                        "name": "Glenmora",
                        "latitude": "30.97658000",
                        "longitude": "-92.58514000"
                    },
                    {
                        "id": 117352,
                        "name": "Golden Meadow",
                        "latitude": "29.37911000",
                        "longitude": "-90.26008000"
                    },
                    {
                        "id": 117370,
                        "name": "Gonzales",
                        "latitude": "30.23853000",
                        "longitude": "-90.92010000"
                    },
                    {
                        "id": 117442,
                        "name": "Grambling",
                        "latitude": "32.52765000",
                        "longitude": "-92.71404000"
                    },
                    {
                        "id": 117443,
                        "name": "Gramercy",
                        "latitude": "30.04742000",
                        "longitude": "-90.68981000"
                    },
                    {
                        "id": 117463,
                        "name": "Grand Isle",
                        "latitude": "29.23662000",
                        "longitude": "-89.98729000"
                    },
                    {
                        "id": 117470,
                        "name": "Grand Point",
                        "latitude": "30.06131000",
                        "longitude": "-90.75343000"
                    },
                    {
                        "id": 117522,
                        "name": "Grant Parish",
                        "latitude": "31.59970000",
                        "longitude": "-92.55952000"
                    },
                    {
                        "id": 117551,
                        "name": "Gray",
                        "latitude": "29.69771000",
                        "longitude": "-90.78648000"
                    },
                    {
                        "id": 117671,
                        "name": "Greensburg",
                        "latitude": "30.83074000",
                        "longitude": "-90.67176000"
                    },
                    {
                        "id": 117704,
                        "name": "Greenwood",
                        "latitude": "32.44293000",
                        "longitude": "-93.97296000"
                    },
                    {
                        "id": 117725,
                        "name": "Gretna",
                        "latitude": "29.91465000",
                        "longitude": "-90.05396000"
                    },
                    {
                        "id": 117782,
                        "name": "Gueydan",
                        "latitude": "30.02604000",
                        "longitude": "-92.50847000"
                    },
                    {
                        "id": 117826,
                        "name": "Hackberry",
                        "latitude": "29.99605000",
                        "longitude": "-93.34210000"
                    },
                    {
                        "id": 117840,
                        "name": "Hahnville",
                        "latitude": "29.97659000",
                        "longitude": "-90.40897000"
                    },
                    {
                        "id": 117912,
                        "name": "Hammond",
                        "latitude": "30.50463000",
                        "longitude": "-90.46293000"
                    },
                    {
                        "id": 117984,
                        "name": "Harahan",
                        "latitude": "29.94048000",
                        "longitude": "-90.20313000"
                    },
                    {
                        "id": 118069,
                        "name": "Harrisonburg",
                        "latitude": "31.77211000",
                        "longitude": "-91.82152000"
                    },
                    {
                        "id": 118111,
                        "name": "Harvey",
                        "latitude": "29.90354000",
                        "longitude": "-90.07729000"
                    },
                    {
                        "id": 118142,
                        "name": "Haughton",
                        "latitude": "32.53265000",
                        "longitude": "-93.50406000"
                    },
                    {
                        "id": 118188,
                        "name": "Haynesville",
                        "latitude": "32.96208000",
                        "longitude": "-93.14016000"
                    },
                    {
                        "id": 118275,
                        "name": "Henderson",
                        "latitude": "30.31325000",
                        "longitude": "-91.79039000"
                    },
                    {
                        "id": 118593,
                        "name": "Homer",
                        "latitude": "32.79192000",
                        "longitude": "-93.05503000"
                    },
                    {
                        "id": 118694,
                        "name": "Houma",
                        "latitude": "29.59577000",
                        "longitude": "-90.71953000"
                    },
                    {
                        "id": 118863,
                        "name": "Iberia Parish",
                        "latitude": "29.51353000",
                        "longitude": "-91.83964000"
                    },
                    {
                        "id": 118864,
                        "name": "Iberville Parish",
                        "latitude": "30.25850000",
                        "longitude": "-91.34936000"
                    },
                    {
                        "id": 118891,
                        "name": "Independence",
                        "latitude": "30.63551000",
                        "longitude": "-90.50335000"
                    },
                    {
                        "id": 118947,
                        "name": "Inniswold",
                        "latitude": "30.40491000",
                        "longitude": "-91.08344000"
                    },
                    {
                        "id": 118974,
                        "name": "Iota",
                        "latitude": "30.33131000",
                        "longitude": "-92.49569000"
                    },
                    {
                        "id": 118975,
                        "name": "Iowa",
                        "latitude": "30.23687000",
                        "longitude": "-93.01376000"
                    },
                    {
                        "id": 119063,
                        "name": "Jackson",
                        "latitude": "30.83740000",
                        "longitude": "-91.21761000"
                    },
                    {
                        "id": 119098,
                        "name": "Jackson Parish",
                        "latitude": "32.30203000",
                        "longitude": "-92.55774000"
                    },
                    {
                        "id": 119157,
                        "name": "Jean Lafitte",
                        "latitude": "29.73604000",
                        "longitude": "-90.12674000"
                    },
                    {
                        "id": 119158,
                        "name": "Jeanerette",
                        "latitude": "29.91104000",
                        "longitude": "-91.66345000"
                    },
                    {
                        "id": 119163,
                        "name": "Jefferson",
                        "latitude": "29.96604000",
                        "longitude": "-90.15313000"
                    },
                    {
                        "id": 119200,
                        "name": "Jefferson Davis Parish",
                        "latitude": "30.26772000",
                        "longitude": "-92.81412000"
                    },
                    {
                        "id": 119203,
                        "name": "Jefferson Parish",
                        "latitude": "29.68097000",
                        "longitude": "-90.09798000"
                    },
                    {
                        "id": 119212,
                        "name": "Jena",
                        "latitude": "31.68323000",
                        "longitude": "-92.13374000"
                    },
                    {
                        "id": 119218,
                        "name": "Jennings",
                        "latitude": "30.22243000",
                        "longitude": "-92.65708000"
                    },
                    {
                        "id": 119302,
                        "name": "Jonesboro",
                        "latitude": "32.24127000",
                        "longitude": "-92.71599000"
                    },
                    {
                        "id": 119309,
                        "name": "Jonesville",
                        "latitude": "31.62656000",
                        "longitude": "-91.81818000"
                    },
                    {
                        "id": 119387,
                        "name": "Kaplan",
                        "latitude": "29.99798000",
                        "longitude": "-92.28485000"
                    },
                    {
                        "id": 119470,
                        "name": "Kenner",
                        "latitude": "29.99409000",
                        "longitude": "-90.24174000"
                    },
                    {
                        "id": 119500,
                        "name": "Kentwood",
                        "latitude": "30.93824000",
                        "longitude": "-90.50898000"
                    },
                    {
                        "id": 119560,
                        "name": "Killian",
                        "latitude": "30.35881000",
                        "longitude": "-90.58620000"
                    },
                    {
                        "id": 119574,
                        "name": "Kinder",
                        "latitude": "30.48548000",
                        "longitude": "-92.85070000"
                    },
                    {
                        "id": 119718,
                        "name": "Krotz Springs",
                        "latitude": "30.53686000",
                        "longitude": "-91.75289000"
                    },
                    {
                        "id": 119788,
                        "name": "La Salle Parish",
                        "latitude": "31.67673000",
                        "longitude": "-92.16044000"
                    },
                    {
                        "id": 119808,
                        "name": "Labadieville",
                        "latitude": "29.83743000",
                        "longitude": "-90.95621000"
                    },
                    {
                        "id": 119817,
                        "name": "Lacombe",
                        "latitude": "30.31353000",
                        "longitude": "-89.94313000"
                    },
                    {
                        "id": 119832,
                        "name": "Lafayette",
                        "latitude": "30.22409000",
                        "longitude": "-92.01984000"
                    },
                    {
                        "id": 119844,
                        "name": "Lafayette Parish",
                        "latitude": "30.20677000",
                        "longitude": "-92.06388000"
                    },
                    {
                        "id": 119846,
                        "name": "Lafourche Parish",
                        "latitude": "29.50033000",
                        "longitude": "-90.40259000"
                    },
                    {
                        "id": 119867,
                        "name": "Lake Arthur",
                        "latitude": "30.08076000",
                        "longitude": "-92.67153000"
                    },
                    {
                        "id": 119877,
                        "name": "Lake Charles",
                        "latitude": "30.21309000",
                        "longitude": "-93.20440000"
                    },
                    {
                        "id": 119966,
                        "name": "Lake Providence",
                        "latitude": "32.80499000",
                        "longitude": "-91.17098000"
                    },
                    {
                        "id": 120028,
                        "name": "Lakeshore",
                        "latitude": "32.53514000",
                        "longitude": "-92.02958000"
                    },
                    {
                        "id": 120134,
                        "name": "Laplace",
                        "latitude": "30.06698000",
                        "longitude": "-90.48147000"
                    },
                    {
                        "id": 120151,
                        "name": "Larose",
                        "latitude": "29.57244000",
                        "longitude": "-90.38175000"
                    },
                    {
                        "id": 120249,
                        "name": "Lawtell",
                        "latitude": "30.51853000",
                        "longitude": "-92.18485000"
                    },
                    {
                        "id": 120300,
                        "name": "Lecompte",
                        "latitude": "31.09463000",
                        "longitude": "-92.40041000"
                    },
                    {
                        "id": 120328,
                        "name": "Leesville",
                        "latitude": "31.14352000",
                        "longitude": "-93.26100000"
                    },
                    {
                        "id": 120392,
                        "name": "Leonville",
                        "latitude": "30.47047000",
                        "longitude": "-91.97845000"
                    },
                    {
                        "id": 120539,
                        "name": "Lincoln Parish",
                        "latitude": "32.60164000",
                        "longitude": "-92.66482000"
                    },
                    {
                        "id": 120648,
                        "name": "Livingston",
                        "latitude": "30.50213000",
                        "longitude": "-90.74787000"
                    },
                    {
                        "id": 120660,
                        "name": "Livingston Parish",
                        "latitude": "30.44014000",
                        "longitude": "-90.72791000"
                    },
                    {
                        "id": 120661,
                        "name": "Livonia",
                        "latitude": "30.55908000",
                        "longitude": "-91.55594000"
                    },
                    {
                        "id": 120679,
                        "name": "Lockport",
                        "latitude": "29.64605000",
                        "longitude": "-90.53925000"
                    },
                    {
                        "id": 120682,
                        "name": "Lockport Heights",
                        "latitude": "29.65049000",
                        "longitude": "-90.54647000"
                    },
                    {
                        "id": 120706,
                        "name": "Logansport",
                        "latitude": "31.97545000",
                        "longitude": "-93.99797000"
                    },
                    {
                        "id": 120876,
                        "name": "Luling",
                        "latitude": "29.93215000",
                        "longitude": "-90.36647000"
                    },
                    {
                        "id": 120893,
                        "name": "Lutcher",
                        "latitude": "30.04048000",
                        "longitude": "-90.69898000"
                    },
                    {
                        "id": 121023,
                        "name": "Madison Parish",
                        "latitude": "32.36440000",
                        "longitude": "-91.24258000"
                    },
                    {
                        "id": 121078,
                        "name": "Mamou",
                        "latitude": "30.63381000",
                        "longitude": "-92.41930000"
                    },
                    {
                        "id": 121107,
                        "name": "Mandeville",
                        "latitude": "30.35825000",
                        "longitude": "-90.06563000"
                    },
                    {
                        "id": 121144,
                        "name": "Mansfield",
                        "latitude": "32.03766000",
                        "longitude": "-93.70018000"
                    },
                    {
                        "id": 121152,
                        "name": "Mansura",
                        "latitude": "31.05797000",
                        "longitude": "-92.04901000"
                    },
                    {
                        "id": 121163,
                        "name": "Many",
                        "latitude": "31.56878000",
                        "longitude": "-93.48406000"
                    },
                    {
                        "id": 121230,
                        "name": "Maringouin",
                        "latitude": "30.49130000",
                        "longitude": "-91.51955000"
                    },
                    {
                        "id": 121273,
                        "name": "Marksville",
                        "latitude": "31.12797000",
                        "longitude": "-92.06624000"
                    },
                    {
                        "id": 121296,
                        "name": "Marrero",
                        "latitude": "29.89937000",
                        "longitude": "-90.10035000"
                    },
                    {
                        "id": 121402,
                        "name": "Mathews",
                        "latitude": "29.68632000",
                        "longitude": "-90.54675000"
                    },
                    {
                        "id": 121423,
                        "name": "Maurice",
                        "latitude": "30.10854000",
                        "longitude": "-92.12457000"
                    },
                    {
                        "id": 121634,
                        "name": "Melville",
                        "latitude": "30.69297000",
                        "longitude": "-91.74400000"
                    },
                    {
                        "id": 121670,
                        "name": "Meraux",
                        "latitude": "29.93017000",
                        "longitude": "-89.91623000"
                    },
                    {
                        "id": 121716,
                        "name": "Merrydale",
                        "latitude": "30.50130000",
                        "longitude": "-91.10844000"
                    },
                    {
                        "id": 121717,
                        "name": "Merryville",
                        "latitude": "30.75437000",
                        "longitude": "-93.54045000"
                    },
                    {
                        "id": 121729,
                        "name": "Metairie",
                        "latitude": "29.98409000",
                        "longitude": "-90.15285000"
                    },
                    {
                        "id": 121730,
                        "name": "Metairie Terrace",
                        "latitude": "29.97854000",
                        "longitude": "-90.16396000"
                    },
                    {
                        "id": 121815,
                        "name": "Midway",
                        "latitude": "31.69212000",
                        "longitude": "-92.15236000"
                    },
                    {
                        "id": 121913,
                        "name": "Milton",
                        "latitude": "30.10381000",
                        "longitude": "-92.07651000"
                    },
                    {
                        "id": 121928,
                        "name": "Minden",
                        "latitude": "32.61543000",
                        "longitude": "-93.28684000"
                    },
                    {
                        "id": 121964,
                        "name": "Minorca",
                        "latitude": "31.57933000",
                        "longitude": "-91.48179000"
                    },
                    {
                        "id": 122058,
                        "name": "Monroe",
                        "latitude": "32.50931000",
                        "longitude": "-92.11930000"
                    },
                    {
                        "id": 122116,
                        "name": "Montegut",
                        "latitude": "29.47439000",
                        "longitude": "-90.55703000"
                    },
                    {
                        "id": 122161,
                        "name": "Monticello",
                        "latitude": "30.48908000",
                        "longitude": "-91.04872000"
                    },
                    {
                        "id": 122190,
                        "name": "Montz",
                        "latitude": "30.00687000",
                        "longitude": "-90.46869000"
                    },
                    {
                        "id": 122227,
                        "name": "Morehouse Parish",
                        "latitude": "32.82022000",
                        "longitude": "-91.80180000"
                    },
                    {
                        "id": 122235,
                        "name": "Morgan City",
                        "latitude": "29.69937000",
                        "longitude": "-91.20677000"
                    },
                    {
                        "id": 122308,
                        "name": "Moss Bluff",
                        "latitude": "30.30270000",
                        "longitude": "-93.19071000"
                    },
                    {
                        "id": 122560,
                        "name": "Napoleonville",
                        "latitude": "29.94048000",
                        "longitude": "-91.02482000"
                    },
                    {
                        "id": 122585,
                        "name": "Natalbany",
                        "latitude": "30.54622000",
                        "longitude": "-90.48619000"
                    },
                    {
                        "id": 122588,
                        "name": "Natchitoches",
                        "latitude": "31.76072000",
                        "longitude": "-93.08627000"
                    },
                    {
                        "id": 122589,
                        "name": "Natchitoches Parish",
                        "latitude": "31.72354000",
                        "longitude": "-93.09624000"
                    },
                    {
                        "id": 122730,
                        "name": "New Iberia",
                        "latitude": "30.00354000",
                        "longitude": "-91.81873000"
                    },
                    {
                        "id": 122739,
                        "name": "New Llano",
                        "latitude": "31.11491000",
                        "longitude": "-93.27155000"
                    },
                    {
                        "id": 122756,
                        "name": "New Orleans",
                        "latitude": "29.95465000",
                        "longitude": "-90.07507000"
                    },
                    {
                        "id": 122772,
                        "name": "New Roads",
                        "latitude": "30.70157000",
                        "longitude": "-91.43622000"
                    },
                    {
                        "id": 122775,
                        "name": "New Sarpy",
                        "latitude": "29.97817000",
                        "longitude": "-90.38963000"
                    },
                    {
                        "id": 122825,
                        "name": "Newellton",
                        "latitude": "32.07265000",
                        "longitude": "-91.24095000"
                    },
                    {
                        "id": 122938,
                        "name": "Norco",
                        "latitude": "29.99909000",
                        "longitude": "-90.41230000"
                    },
                    {
                        "id": 123118,
                        "name": "North Vacherie",
                        "latitude": "29.99687000",
                        "longitude": "-90.70565000"
                    },
                    {
                        "id": 123235,
                        "name": "Oak Grove",
                        "latitude": "32.86096000",
                        "longitude": "-91.38845000"
                    },
                    {
                        "id": 123250,
                        "name": "Oak Hills Place",
                        "latitude": "30.35992000",
                        "longitude": "-91.08760000"
                    },
                    {
                        "id": 123270,
                        "name": "Oakdale",
                        "latitude": "30.81603000",
                        "longitude": "-92.66042000"
                    },
                    {
                        "id": 123315,
                        "name": "Oberlin",
                        "latitude": "30.62020000",
                        "longitude": "-92.76265000"
                    },
                    {
                        "id": 123422,
                        "name": "Old Jefferson",
                        "latitude": "30.38269000",
                        "longitude": "-91.01705000"
                    },
                    {
                        "id": 123451,
                        "name": "Olla",
                        "latitude": "31.90294000",
                        "longitude": "-92.24319000"
                    },
                    {
                        "id": 123497,
                        "name": "Opelousas",
                        "latitude": "30.53353000",
                        "longitude": "-92.08151000"
                    },
                    {
                        "id": 123567,
                        "name": "Orleans Parish",
                        "latitude": "30.06864000",
                        "longitude": "-89.92813000"
                    },
                    {
                        "id": 123619,
                        "name": "Ossun",
                        "latitude": "30.27603000",
                        "longitude": "-92.11235000"
                    },
                    {
                        "id": 123645,
                        "name": "Ouachita Parish",
                        "latitude": "32.47831000",
                        "longitude": "-92.15487000"
                    },
                    {
                        "id": 123816,
                        "name": "Paradis",
                        "latitude": "29.87965000",
                        "longitude": "-90.43397000"
                    },
                    {
                        "id": 123915,
                        "name": "Patterson",
                        "latitude": "29.69326000",
                        "longitude": "-91.30205000"
                    },
                    {
                        "id": 123923,
                        "name": "Paulina",
                        "latitude": "30.02631000",
                        "longitude": "-90.71315000"
                    },
                    {
                        "id": 123966,
                        "name": "Pearl River",
                        "latitude": "30.37603000",
                        "longitude": "-89.74840000"
                    },
                    {
                        "id": 124179,
                        "name": "Pierre Part",
                        "latitude": "29.96520000",
                        "longitude": "-91.20316000"
                    },
                    {
                        "id": 124241,
                        "name": "Pine Prairie",
                        "latitude": "30.78381000",
                        "longitude": "-92.42541000"
                    },
                    {
                        "id": 124260,
                        "name": "Pineville",
                        "latitude": "31.32240000",
                        "longitude": "-92.43430000"
                    },
                    {
                        "id": 124349,
                        "name": "Plaquemine",
                        "latitude": "30.29005000",
                        "longitude": "-91.23497000"
                    },
                    {
                        "id": 124350,
                        "name": "Plaquemines Parish",
                        "latitude": "29.54421000",
                        "longitude": "-89.82047000"
                    },
                    {
                        "id": 124435,
                        "name": "Pointe Coupee Parish",
                        "latitude": "30.70940000",
                        "longitude": "-91.60079000"
                    },
                    {
                        "id": 124466,
                        "name": "Ponchatoula",
                        "latitude": "30.43880000",
                        "longitude": "-90.44148000"
                    },
                    {
                        "id": 124492,
                        "name": "Port Allen",
                        "latitude": "30.45214000",
                        "longitude": "-91.21011000"
                    },
                    {
                        "id": 124497,
                        "name": "Port Barre",
                        "latitude": "30.56020000",
                        "longitude": "-91.95401000"
                    },
                    {
                        "id": 124536,
                        "name": "Port Sulphur",
                        "latitude": "29.48049000",
                        "longitude": "-89.69395000"
                    },
                    {
                        "id": 124620,
                        "name": "Poydras",
                        "latitude": "29.86937000",
                        "longitude": "-89.88895000"
                    },
                    {
                        "id": 124635,
                        "name": "Prairieville",
                        "latitude": "30.30297000",
                        "longitude": "-90.97205000"
                    },
                    {
                        "id": 124651,
                        "name": "Presquille",
                        "latitude": "29.56383000",
                        "longitude": "-90.64620000"
                    },
                    {
                        "id": 124668,
                        "name": "Prien",
                        "latitude": "30.18187000",
                        "longitude": "-93.27377000"
                    },
                    {
                        "id": 124811,
                        "name": "Raceland",
                        "latitude": "29.72743000",
                        "longitude": "-90.59898000"
                    },
                    {
                        "id": 124896,
                        "name": "Rapides Parish",
                        "latitude": "31.19862000",
                        "longitude": "-92.53320000"
                    },
                    {
                        "id": 124923,
                        "name": "Rayne",
                        "latitude": "30.23493000",
                        "longitude": "-92.26846000"
                    },
                    {
                        "id": 124927,
                        "name": "Rayville",
                        "latitude": "32.47736000",
                        "longitude": "-91.75485000"
                    },
                    {
                        "id": 124943,
                        "name": "Red Chute",
                        "latitude": "32.55598000",
                        "longitude": "-93.61323000"
                    },
                    {
                        "id": 124960,
                        "name": "Red River Parish",
                        "latitude": "32.09315000",
                        "longitude": "-93.33988000"
                    },
                    {
                        "id": 125034,
                        "name": "Reserve",
                        "latitude": "30.05381000",
                        "longitude": "-90.55175000"
                    },
                    {
                        "id": 125080,
                        "name": "Richland Parish",
                        "latitude": "32.41779000",
                        "longitude": "-91.76349000"
                    },
                    {
                        "id": 125109,
                        "name": "Richwood",
                        "latitude": "32.44876000",
                        "longitude": "-92.08486000"
                    },
                    {
                        "id": 125142,
                        "name": "Ringgold",
                        "latitude": "32.32849000",
                        "longitude": "-93.27989000"
                    },
                    {
                        "id": 125185,
                        "name": "River Ridge",
                        "latitude": "29.96020000",
                        "longitude": "-90.21563000"
                    },
                    {
                        "id": 125422,
                        "name": "Roseland",
                        "latitude": "30.76491000",
                        "longitude": "-90.51176000"
                    },
                    {
                        "id": 125437,
                        "name": "Rosepine",
                        "latitude": "30.91991000",
                        "longitude": "-93.28239000"
                    },
                    {
                        "id": 125547,
                        "name": "Ruston",
                        "latitude": "32.52321000",
                        "longitude": "-92.63793000"
                    },
                    {
                        "id": 125570,
                        "name": "Sabine Parish",
                        "latitude": "31.56401000",
                        "longitude": "-93.55470000"
                    },
                    {
                        "id": 125608,
                        "name": "Saint Bernard Parish",
                        "latitude": "29.87399000",
                        "longitude": "-89.82422000"
                    },
                    {
                        "id": 125617,
                        "name": "Saint Charles Parish",
                        "latitude": "29.90553000",
                        "longitude": "-90.35822000"
                    },
                    {
                        "id": 125637,
                        "name": "Saint Francisville",
                        "latitude": "30.77990000",
                        "longitude": "-91.37650000"
                    },
                    {
                        "id": 125639,
                        "name": "Saint Gabriel",
                        "latitude": "30.25770000",
                        "longitude": "-91.09927000"
                    },
                    {
                        "id": 125648,
                        "name": "Saint Helena Parish",
                        "latitude": "30.82198000",
                        "longitude": "-90.71032000"
                    },
                    {
                        "id": 125658,
                        "name": "Saint James Parish",
                        "latitude": "30.02630000",
                        "longitude": "-90.79632000"
                    },
                    {
                        "id": 125663,
                        "name": "Saint John the Baptist Parish",
                        "latitude": "30.12646000",
                        "longitude": "-90.47088000"
                    },
                    {
                        "id": 125670,
                        "name": "Saint Joseph",
                        "latitude": "31.91849000",
                        "longitude": "-91.23345000"
                    },
                    {
                        "id": 125677,
                        "name": "Saint Landry Parish",
                        "latitude": "30.59885000",
                        "longitude": "-92.00586000"
                    },
                    {
                        "id": 125687,
                        "name": "Saint Martin Parish",
                        "latitude": "30.12907000",
                        "longitude": "-91.60830000"
                    },
                    {
                        "id": 125689,
                        "name": "Saint Martinville",
                        "latitude": "30.12520000",
                        "longitude": "-91.83345000"
                    },
                    {
                        "id": 125690,
                        "name": "Saint Mary Parish",
                        "latitude": "29.63462000",
                        "longitude": "-91.47293000"
                    },
                    {
                        "id": 125713,
                        "name": "Saint Rose",
                        "latitude": "29.94687000",
                        "longitude": "-90.32313000"
                    },
                    {
                        "id": 125718,
                        "name": "Saint Tammany Parish",
                        "latitude": "30.40875000",
                        "longitude": "-89.95393000"
                    },
                    {
                        "id": 126019,
                        "name": "Schriever",
                        "latitude": "29.74215000",
                        "longitude": "-90.81037000"
                    },
                    {
                        "id": 126039,
                        "name": "Scott",
                        "latitude": "30.23576000",
                        "longitude": "-92.09457000"
                    },
                    {
                        "id": 126300,
                        "name": "Shenandoah",
                        "latitude": "30.40130000",
                        "longitude": "-91.00094000"
                    },
                    {
                        "id": 126382,
                        "name": "Shreveport",
                        "latitude": "32.52515000",
                        "longitude": "-93.75018000"
                    },
                    {
                        "id": 126390,
                        "name": "Sibley",
                        "latitude": "32.53932000",
                        "longitude": "-93.29628000"
                    },
                    {
                        "id": 126446,
                        "name": "Simmesport",
                        "latitude": "30.98352000",
                        "longitude": "-91.80012000"
                    },
                    {
                        "id": 126501,
                        "name": "Slidell",
                        "latitude": "30.27519000",
                        "longitude": "-89.78117000"
                    },
                    {
                        "id": 126605,
                        "name": "Sorrento",
                        "latitude": "30.18436000",
                        "longitude": "-90.85926000"
                    },
                    {
                        "id": 126739,
                        "name": "South Vacherie",
                        "latitude": "29.92743000",
                        "longitude": "-90.69981000"
                    },
                    {
                        "id": 126909,
                        "name": "Springhill",
                        "latitude": "33.00597000",
                        "longitude": "-93.46684000"
                    },
                    {
                        "id": 127035,
                        "name": "Sterlington",
                        "latitude": "32.69625000",
                        "longitude": "-92.08597000"
                    },
                    {
                        "id": 127091,
                        "name": "Stonewall",
                        "latitude": "32.28183000",
                        "longitude": "-93.82407000"
                    },
                    {
                        "id": 127194,
                        "name": "Sulphur",
                        "latitude": "30.23659000",
                        "longitude": "-93.37738000"
                    },
                    {
                        "id": 127272,
                        "name": "Sunset",
                        "latitude": "30.41131000",
                        "longitude": "-92.06845000"
                    },
                    {
                        "id": 127283,
                        "name": "Supreme",
                        "latitude": "29.85937000",
                        "longitude": "-90.98121000"
                    },
                    {
                        "id": 127331,
                        "name": "Swartz",
                        "latitude": "32.56875000",
                        "longitude": "-91.98513000"
                    },
                    {
                        "id": 127396,
                        "name": "Tallulah",
                        "latitude": "32.40848000",
                        "longitude": "-91.18678000"
                    },
                    {
                        "id": 127415,
                        "name": "Tangipahoa Parish",
                        "latitude": "30.62665000",
                        "longitude": "-90.40568000"
                    },
                    {
                        "id": 127512,
                        "name": "Tensas Parish",
                        "latitude": "32.00166000",
                        "longitude": "-91.34007000"
                    },
                    {
                        "id": 127525,
                        "name": "Terrebonne Parish",
                        "latitude": "29.33744000",
                        "longitude": "-90.83764000"
                    },
                    {
                        "id": 127533,
                        "name": "Terrytown",
                        "latitude": "29.91021000",
                        "longitude": "-90.03257000"
                    },
                    {
                        "id": 127573,
                        "name": "Thibodaux",
                        "latitude": "29.79576000",
                        "longitude": "-90.82287000"
                    },
                    {
                        "id": 127659,
                        "name": "Timberlane",
                        "latitude": "29.87743000",
                        "longitude": "-90.03202000"
                    },
                    {
                        "id": 128008,
                        "name": "Union Parish",
                        "latitude": "32.83190000",
                        "longitude": "-92.37482000"
                    },
                    {
                        "id": 128059,
                        "name": "Urania",
                        "latitude": "31.86378000",
                        "longitude": "-92.29597000"
                    },
                    {
                        "id": 128184,
                        "name": "Vermilion Parish",
                        "latitude": "29.80939000",
                        "longitude": "-92.30428000"
                    },
                    {
                        "id": 128195,
                        "name": "Vernon Parish",
                        "latitude": "31.10829000",
                        "longitude": "-93.18415000"
                    },
                    {
                        "id": 128228,
                        "name": "Vidalia",
                        "latitude": "31.56544000",
                        "longitude": "-91.42595000"
                    },
                    {
                        "id": 128235,
                        "name": "Vienna Bend",
                        "latitude": "31.73239000",
                        "longitude": "-93.04100000"
                    },
                    {
                        "id": 128250,
                        "name": "Village Saint George",
                        "latitude": "30.36214000",
                        "longitude": "-91.06733000"
                    },
                    {
                        "id": 128259,
                        "name": "Ville Platte",
                        "latitude": "30.68797000",
                        "longitude": "-92.27152000"
                    },
                    {
                        "id": 128279,
                        "name": "Vinton",
                        "latitude": "30.19076000",
                        "longitude": "-93.58127000"
                    },
                    {
                        "id": 128284,
                        "name": "Violet",
                        "latitude": "29.89576000",
                        "longitude": "-89.89784000"
                    },
                    {
                        "id": 128298,
                        "name": "Vivian",
                        "latitude": "32.87153000",
                        "longitude": "-93.98740000"
                    },
                    {
                        "id": 128327,
                        "name": "Waggaman",
                        "latitude": "29.91854000",
                        "longitude": "-90.21091000"
                    },
                    {
                        "id": 128383,
                        "name": "Walker",
                        "latitude": "30.48797000",
                        "longitude": "-90.86149000"
                    },
                    {
                        "id": 128583,
                        "name": "Washington Parish",
                        "latitude": "30.85334000",
                        "longitude": "-90.04052000"
                    },
                    {
                        "id": 128639,
                        "name": "Watson",
                        "latitude": "30.57574000",
                        "longitude": "-90.95316000"
                    },
                    {
                        "id": 128744,
                        "name": "Webster Parish",
                        "latitude": "32.71345000",
                        "longitude": "-93.33498000"
                    },
                    {
                        "id": 128796,
                        "name": "Welsh",
                        "latitude": "30.23604000",
                        "longitude": "-92.82265000"
                    },
                    {
                        "id": 128822,
                        "name": "West Baton Rouge Parish",
                        "latitude": "30.46341000",
                        "longitude": "-91.31275000"
                    },
                    {
                        "id": 128841,
                        "name": "West Carroll Parish",
                        "latitude": "32.78856000",
                        "longitude": "-91.45674000"
                    },
                    {
                        "id": 128870,
                        "name": "West Feliciana Parish",
                        "latitude": "30.87977000",
                        "longitude": "-91.42003000"
                    },
                    {
                        "id": 128871,
                        "name": "West Ferriday",
                        "latitude": "31.64044000",
                        "longitude": "-91.57318000"
                    },
                    {
                        "id": 128935,
                        "name": "West Monroe",
                        "latitude": "32.51848000",
                        "longitude": "-92.14764000"
                    },
                    {
                        "id": 129038,
                        "name": "Westlake",
                        "latitude": "30.24215000",
                        "longitude": "-93.25071000"
                    },
                    {
                        "id": 129044,
                        "name": "Westminster",
                        "latitude": "30.41380000",
                        "longitude": "-91.08760000"
                    },
                    {
                        "id": 129081,
                        "name": "Westwego",
                        "latitude": "29.90604000",
                        "longitude": "-90.14230000"
                    },
                    {
                        "id": 129128,
                        "name": "White Castle",
                        "latitude": "30.16992000",
                        "longitude": "-91.14705000"
                    },
                    {
                        "id": 129404,
                        "name": "Winn Parish",
                        "latitude": "31.94425000",
                        "longitude": "-92.63677000"
                    },
                    {
                        "id": 129416,
                        "name": "Winnfield",
                        "latitude": "31.92558000",
                        "longitude": "-92.64131000"
                    },
                    {
                        "id": 129418,
                        "name": "Winnsboro",
                        "latitude": "32.16321000",
                        "longitude": "-91.72068000"
                    },
                    {
                        "id": 129540,
                        "name": "Woodmere",
                        "latitude": "29.85798000",
                        "longitude": "-90.08035000"
                    },
                    {
                        "id": 129580,
                        "name": "Woodworth",
                        "latitude": "31.14658000",
                        "longitude": "-92.49736000"
                    },
                    {
                        "id": 129718,
                        "name": "Youngsville",
                        "latitude": "30.09965000",
                        "longitude": "-91.99012000"
                    },
                    {
                        "id": 129738,
                        "name": "Zachary",
                        "latitude": "30.64852000",
                        "longitude": "-91.15650000"
                    },
                    {
                        "id": 129763,
                        "name": "Zwolle",
                        "latitude": "31.63156000",
                        "longitude": "-93.64407000"
                    }
                ]
            },
            {
                "id": 1453,
                "name": "Maine",
                "iso2": "ME",
                "latitude": "45.25378300",
                "longitude": "-69.44546890",
                "type": "state",
                "cities": [
                    {
                        "id": 111000,
                        "name": "Acton",
                        "latitude": "43.53425000",
                        "longitude": "-70.90978000"
                    },
                    {
                        "id": 111036,
                        "name": "Addison",
                        "latitude": "44.61841000",
                        "longitude": "-67.74416000"
                    },
                    {
                        "id": 111125,
                        "name": "Albion",
                        "latitude": "44.53229000",
                        "longitude": "-69.44254000"
                    },
                    {
                        "id": 111159,
                        "name": "Alfred",
                        "latitude": "43.47647000",
                        "longitude": "-70.71839000"
                    },
                    {
                        "id": 111334,
                        "name": "Androscoggin County",
                        "latitude": "44.16585000",
                        "longitude": "-70.20645000"
                    },
                    {
                        "id": 111395,
                        "name": "Appleton",
                        "latitude": "44.28924000",
                        "longitude": "-69.25088000"
                    },
                    {
                        "id": 111492,
                        "name": "Aroostook County",
                        "latitude": "46.65881000",
                        "longitude": "-68.59889000"
                    },
                    {
                        "id": 111502,
                        "name": "Arundel",
                        "latitude": "43.38259000",
                        "longitude": "-70.47783000"
                    },
                    {
                        "id": 111627,
                        "name": "Auburn",
                        "latitude": "44.09785000",
                        "longitude": "-70.23117000"
                    },
                    {
                        "id": 111649,
                        "name": "Augusta",
                        "latitude": "44.31062000",
                        "longitude": "-69.77949000"
                    },
                    {
                        "id": 111792,
                        "name": "Bangor",
                        "latitude": "44.80118000",
                        "longitude": "-68.77781000"
                    },
                    {
                        "id": 111806,
                        "name": "Bar Harbor",
                        "latitude": "44.38758000",
                        "longitude": "-68.20390000"
                    },
                    {
                        "id": 111897,
                        "name": "Bath",
                        "latitude": "43.91064000",
                        "longitude": "-69.82060000"
                    },
                    {
                        "id": 112056,
                        "name": "Belfast",
                        "latitude": "44.42591000",
                        "longitude": "-69.00642000"
                    },
                    {
                        "id": 112061,
                        "name": "Belgrade",
                        "latitude": "44.44729000",
                        "longitude": "-69.83255000"
                    },
                    {
                        "id": 112197,
                        "name": "Benton",
                        "latitude": "44.58618000",
                        "longitude": "-69.55088000"
                    },
                    {
                        "id": 112262,
                        "name": "Berwick",
                        "latitude": "43.26592000",
                        "longitude": "-70.86450000"
                    },
                    {
                        "id": 112279,
                        "name": "Bethel",
                        "latitude": "44.40423000",
                        "longitude": "-70.79062000"
                    },
                    {
                        "id": 112312,
                        "name": "Biddeford",
                        "latitude": "43.49258000",
                        "longitude": "-70.45338000"
                    },
                    {
                        "id": 112572,
                        "name": "Boothbay",
                        "latitude": "43.87647000",
                        "longitude": "-69.63366000"
                    },
                    {
                        "id": 112573,
                        "name": "Boothbay Harbor",
                        "latitude": "43.85230000",
                        "longitude": "-69.62810000"
                    },
                    {
                        "id": 112665,
                        "name": "Bradford",
                        "latitude": "45.06673000",
                        "longitude": "-68.93781000"
                    },
                    {
                        "id": 112673,
                        "name": "Bradley",
                        "latitude": "44.92090000",
                        "longitude": "-68.62809000"
                    },
                    {
                        "id": 112739,
                        "name": "Brewer",
                        "latitude": "44.79674000",
                        "longitude": "-68.76142000"
                    },
                    {
                        "id": 112779,
                        "name": "Bridgton",
                        "latitude": "44.05479000",
                        "longitude": "-70.71284000"
                    },
                    {
                        "id": 112806,
                        "name": "Bristol",
                        "latitude": "43.95758000",
                        "longitude": "-69.50921000"
                    },
                    {
                        "id": 112882,
                        "name": "Brooks",
                        "latitude": "44.55035000",
                        "longitude": "-69.12087000"
                    },
                    {
                        "id": 112916,
                        "name": "Brownfield",
                        "latitude": "43.93813000",
                        "longitude": "-70.90868000"
                    },
                    {
                        "id": 112937,
                        "name": "Brownville",
                        "latitude": "45.30700000",
                        "longitude": "-69.03337000"
                    },
                    {
                        "id": 112950,
                        "name": "Brunswick",
                        "latitude": "43.91452000",
                        "longitude": "-69.96533000"
                    },
                    {
                        "id": 112979,
                        "name": "Buckfield",
                        "latitude": "44.28951000",
                        "longitude": "-70.36534000"
                    },
                    {
                        "id": 112992,
                        "name": "Bucksport",
                        "latitude": "44.57369000",
                        "longitude": "-68.79559000"
                    },
                    {
                        "id": 113084,
                        "name": "Burnham",
                        "latitude": "44.69284000",
                        "longitude": "-69.42755000"
                    },
                    {
                        "id": 113132,
                        "name": "Buxton",
                        "latitude": "43.63786000",
                        "longitude": "-70.51894000"
                    },
                    {
                        "id": 113175,
                        "name": "Calais",
                        "latitude": "45.18376000",
                        "longitude": "-67.27662000"
                    },
                    {
                        "id": 113266,
                        "name": "Camden",
                        "latitude": "44.20980000",
                        "longitude": "-69.06476000"
                    },
                    {
                        "id": 113312,
                        "name": "Canaan",
                        "latitude": "44.76173000",
                        "longitude": "-69.56144000"
                    },
                    {
                        "id": 113346,
                        "name": "Canton",
                        "latitude": "44.44080000",
                        "longitude": "-70.31649000"
                    },
                    {
                        "id": 113372,
                        "name": "Cape Neddick",
                        "latitude": "43.19370000",
                        "longitude": "-70.62089000"
                    },
                    {
                        "id": 113394,
                        "name": "Caribou",
                        "latitude": "46.86060000",
                        "longitude": "-68.01197000"
                    },
                    {
                        "id": 113418,
                        "name": "Carmel",
                        "latitude": "44.79757000",
                        "longitude": "-69.05115000"
                    },
                    {
                        "id": 113542,
                        "name": "Castine",
                        "latitude": "44.38785000",
                        "longitude": "-68.79975000"
                    },
                    {
                        "id": 113767,
                        "name": "Charleston",
                        "latitude": "45.08506000",
                        "longitude": "-69.04059000"
                    },
                    {
                        "id": 113832,
                        "name": "Chelsea",
                        "latitude": "44.25035000",
                        "longitude": "-69.71727000"
                    },
                    {
                        "id": 113866,
                        "name": "Cherryfield",
                        "latitude": "44.60730000",
                        "longitude": "-67.92584000"
                    },
                    {
                        "id": 113911,
                        "name": "Chesterville",
                        "latitude": "44.55117000",
                        "longitude": "-70.08617000"
                    },
                    {
                        "id": 113960,
                        "name": "China",
                        "latitude": "44.47868000",
                        "longitude": "-69.51726000"
                    },
                    {
                        "id": 113980,
                        "name": "Chisholm",
                        "latitude": "44.48145000",
                        "longitude": "-70.19950000"
                    },
                    {
                        "id": 114281,
                        "name": "Clinton",
                        "latitude": "44.63784000",
                        "longitude": "-69.50310000"
                    },
                    {
                        "id": 114642,
                        "name": "Corinna",
                        "latitude": "44.92117000",
                        "longitude": "-69.26171000"
                    },
                    {
                        "id": 114655,
                        "name": "Cornish",
                        "latitude": "43.80480000",
                        "longitude": "-70.80117000"
                    },
                    {
                        "id": 114656,
                        "name": "Cornville",
                        "latitude": "44.83673000",
                        "longitude": "-69.67311000"
                    },
                    {
                        "id": 114911,
                        "name": "Cumberland Center",
                        "latitude": "43.79647000",
                        "longitude": "-70.25894000"
                    },
                    {
                        "id": 114918,
                        "name": "Cumberland County",
                        "latitude": "43.80608000",
                        "longitude": "-70.33020000"
                    },
                    {
                        "id": 114932,
                        "name": "Cushing",
                        "latitude": "44.01925000",
                        "longitude": "-69.23977000"
                    },
                    {
                        "id": 115008,
                        "name": "Damariscotta",
                        "latitude": "44.03286000",
                        "longitude": "-69.51866000"
                    },
                    {
                        "id": 115100,
                        "name": "Dayton",
                        "latitude": "43.54972000",
                        "longitude": "-70.57555000"
                    },
                    {
                        "id": 115168,
                        "name": "Dedham",
                        "latitude": "44.69174000",
                        "longitude": "-68.66198000"
                    },
                    {
                        "id": 115172,
                        "name": "Deer Isle",
                        "latitude": "44.22397000",
                        "longitude": "-68.67753000"
                    },
                    {
                        "id": 115240,
                        "name": "Denmark",
                        "latitude": "43.97035000",
                        "longitude": "-70.80340000"
                    },
                    {
                        "id": 115308,
                        "name": "Dexter",
                        "latitude": "45.02395000",
                        "longitude": "-69.28977000"
                    },
                    {
                        "id": 115359,
                        "name": "Dixfield",
                        "latitude": "44.53395000",
                        "longitude": "-70.45590000"
                    },
                    {
                        "id": 115362,
                        "name": "Dixmont",
                        "latitude": "44.68035000",
                        "longitude": "-69.16282000"
                    },
                    {
                        "id": 115457,
                        "name": "Dover-Foxcroft",
                        "latitude": "45.18339000",
                        "longitude": "-69.22699000"
                    },
                    {
                        "id": 115707,
                        "name": "East Machias",
                        "latitude": "44.73924000",
                        "longitude": "-67.38999000"
                    },
                    {
                        "id": 115713,
                        "name": "East Millinocket",
                        "latitude": "45.62755000",
                        "longitude": "-68.57448000"
                    },
                    {
                        "id": 115788,
                        "name": "Easton",
                        "latitude": "46.64115000",
                        "longitude": "-67.90947000"
                    },
                    {
                        "id": 115795,
                        "name": "Eastport",
                        "latitude": "44.90619000",
                        "longitude": "-66.98998000"
                    },
                    {
                        "id": 115821,
                        "name": "Eddington",
                        "latitude": "44.82618000",
                        "longitude": "-68.69337000"
                    },
                    {
                        "id": 115840,
                        "name": "Edgecomb",
                        "latitude": "43.95841000",
                        "longitude": "-69.63060000"
                    },
                    {
                        "id": 115970,
                        "name": "Eliot",
                        "latitude": "43.15314000",
                        "longitude": "-70.80006000"
                    },
                    {
                        "id": 116038,
                        "name": "Ellsworth",
                        "latitude": "44.54341000",
                        "longitude": "-68.41946000"
                    },
                    {
                        "id": 116126,
                        "name": "Enfield",
                        "latitude": "45.24894000",
                        "longitude": "-68.56836000"
                    },
                    {
                        "id": 116215,
                        "name": "Etna",
                        "latitude": "44.82090000",
                        "longitude": "-69.11115000"
                    },
                    {
                        "id": 116314,
                        "name": "Fairfield",
                        "latitude": "44.58840000",
                        "longitude": "-69.59866000"
                    },
                    {
                        "id": 116389,
                        "name": "Falmouth",
                        "latitude": "43.72953000",
                        "longitude": "-70.24199000"
                    },
                    {
                        "id": 116390,
                        "name": "Falmouth Foreside",
                        "latitude": "43.73480000",
                        "longitude": "-70.20783000"
                    },
                    {
                        "id": 116409,
                        "name": "Farmingdale",
                        "latitude": "44.24451000",
                        "longitude": "-69.77143000"
                    },
                    {
                        "id": 116418,
                        "name": "Farmington",
                        "latitude": "44.67062000",
                        "longitude": "-70.15117000"
                    },
                    {
                        "id": 116442,
                        "name": "Fayette",
                        "latitude": "44.40896000",
                        "longitude": "-70.03367000"
                    },
                    {
                        "id": 116710,
                        "name": "Fort Fairfield",
                        "latitude": "46.77227000",
                        "longitude": "-67.83391000"
                    },
                    {
                        "id": 116720,
                        "name": "Fort Kent",
                        "latitude": "47.25865000",
                        "longitude": "-68.58949000"
                    },
                    {
                        "id": 116822,
                        "name": "Frankfort",
                        "latitude": "44.60980000",
                        "longitude": "-68.87670000"
                    },
                    {
                        "id": 116835,
                        "name": "Franklin",
                        "latitude": "44.58702000",
                        "longitude": "-68.23224000"
                    },
                    {
                        "id": 116859,
                        "name": "Franklin County",
                        "latitude": "44.97417000",
                        "longitude": "-70.44410000"
                    },
                    {
                        "id": 116913,
                        "name": "Freeport",
                        "latitude": "43.85702000",
                        "longitude": "-70.10311000"
                    },
                    {
                        "id": 116936,
                        "name": "Frenchville",
                        "latitude": "47.28087000",
                        "longitude": "-68.37976000"
                    },
                    {
                        "id": 116948,
                        "name": "Friendship",
                        "latitude": "43.98369000",
                        "longitude": "-69.33394000"
                    },
                    {
                        "id": 116978,
                        "name": "Fryeburg",
                        "latitude": "44.01646000",
                        "longitude": "-70.98062000"
                    },
                    {
                        "id": 117073,
                        "name": "Gardiner",
                        "latitude": "44.23007000",
                        "longitude": "-69.77532000"
                    },
                    {
                        "id": 117089,
                        "name": "Garland",
                        "latitude": "45.03840000",
                        "longitude": "-69.16032000"
                    },
                    {
                        "id": 117403,
                        "name": "Gorham",
                        "latitude": "43.67952000",
                        "longitude": "-70.44422000"
                    },
                    {
                        "id": 117418,
                        "name": "Gouldsboro",
                        "latitude": "44.47841000",
                        "longitude": "-68.03834000"
                    },
                    {
                        "id": 117623,
                        "name": "Greenbush",
                        "latitude": "45.08034000",
                        "longitude": "-68.65086000"
                    },
                    {
                        "id": 117629,
                        "name": "Greene",
                        "latitude": "44.18979000",
                        "longitude": "-70.14033000"
                    },
                    {
                        "id": 117691,
                        "name": "Greenville",
                        "latitude": "45.45949000",
                        "longitude": "-69.59061000"
                    },
                    {
                        "id": 117872,
                        "name": "Hallowell",
                        "latitude": "44.28590000",
                        "longitude": "-69.79088000"
                    },
                    {
                        "id": 117917,
                        "name": "Hampden",
                        "latitude": "44.74452000",
                        "longitude": "-68.83698000"
                    },
                    {
                        "id": 117948,
                        "name": "Hancock",
                        "latitude": "44.52924000",
                        "longitude": "-68.25363000"
                    },
                    {
                        "id": 117957,
                        "name": "Hancock County",
                        "latitude": "44.56289000",
                        "longitude": "-68.36821000"
                    },
                    {
                        "id": 118037,
                        "name": "Harpswell Center",
                        "latitude": "43.80175000",
                        "longitude": "-69.98421000"
                    },
                    {
                        "id": 118056,
                        "name": "Harrison",
                        "latitude": "44.11035000",
                        "longitude": "-70.67923000"
                    },
                    {
                        "id": 118089,
                        "name": "Hartford",
                        "latitude": "44.37284000",
                        "longitude": "-70.34673000"
                    },
                    {
                        "id": 118237,
                        "name": "Hebron",
                        "latitude": "44.19813000",
                        "longitude": "-70.40645000"
                    },
                    {
                        "id": 118330,
                        "name": "Hermon",
                        "latitude": "44.81007000",
                        "longitude": "-68.91337000"
                    },
                    {
                        "id": 118491,
                        "name": "Hiram",
                        "latitude": "43.87868000",
                        "longitude": "-70.80340000"
                    },
                    {
                        "id": 118506,
                        "name": "Hodgdon",
                        "latitude": "46.05394000",
                        "longitude": "-67.86668000"
                    },
                    {
                        "id": 118524,
                        "name": "Holden",
                        "latitude": "44.75285000",
                        "longitude": "-68.67892000"
                    },
                    {
                        "id": 118550,
                        "name": "Hollis Center",
                        "latitude": "43.60508000",
                        "longitude": "-70.59311000"
                    },
                    {
                        "id": 118644,
                        "name": "Hope",
                        "latitude": "44.26508000",
                        "longitude": "-69.15893000"
                    },
                    {
                        "id": 118693,
                        "name": "Houlton",
                        "latitude": "46.12616000",
                        "longitude": "-67.84030000"
                    },
                    {
                        "id": 118725,
                        "name": "Howland",
                        "latitude": "45.23867000",
                        "longitude": "-68.66364000"
                    },
                    {
                        "id": 118742,
                        "name": "Hudson",
                        "latitude": "45.00118000",
                        "longitude": "-68.88059000"
                    },
                    {
                        "id": 119154,
                        "name": "Jay",
                        "latitude": "44.50395000",
                        "longitude": "-70.21617000"
                    },
                    {
                        "id": 119169,
                        "name": "Jefferson",
                        "latitude": "44.20674000",
                        "longitude": "-69.45254000"
                    },
                    {
                        "id": 119305,
                        "name": "Jonesport",
                        "latitude": "44.53286000",
                        "longitude": "-67.59833000"
                    },
                    {
                        "id": 119452,
                        "name": "Kenduskeag",
                        "latitude": "44.91951000",
                        "longitude": "-68.93170000"
                    },
                    {
                        "id": 119465,
                        "name": "Kennebec County",
                        "latitude": "44.40916000",
                        "longitude": "-69.76726000"
                    },
                    {
                        "id": 119466,
                        "name": "Kennebunk",
                        "latitude": "43.38397000",
                        "longitude": "-70.54478000"
                    },
                    {
                        "id": 119467,
                        "name": "Kennebunkport",
                        "latitude": "43.36175000",
                        "longitude": "-70.47672000"
                    },
                    {
                        "id": 119591,
                        "name": "Kingfield",
                        "latitude": "44.95922000",
                        "longitude": "-70.15395000"
                    },
                    {
                        "id": 119662,
                        "name": "Kittery",
                        "latitude": "43.08814000",
                        "longitude": "-70.73616000"
                    },
                    {
                        "id": 119663,
                        "name": "Kittery Point",
                        "latitude": "43.08342000",
                        "longitude": "-70.70783000"
                    },
                    {
                        "id": 119690,
                        "name": "Knox County",
                        "latitude": "44.07575000",
                        "longitude": "-69.12598000"
                    },
                    {
                        "id": 119865,
                        "name": "Lake Arrowhead",
                        "latitude": "43.66369000",
                        "longitude": "-70.73478000"
                    },
                    {
                        "id": 120290,
                        "name": "Lebanon",
                        "latitude": "43.39453000",
                        "longitude": "-70.85089000"
                    },
                    {
                        "id": 120321,
                        "name": "Leeds",
                        "latitude": "44.30340000",
                        "longitude": "-70.11950000"
                    },
                    {
                        "id": 120401,
                        "name": "Levant",
                        "latitude": "44.86924000",
                        "longitude": "-68.93476000"
                    },
                    {
                        "id": 120423,
                        "name": "Lewiston",
                        "latitude": "44.10035000",
                        "longitude": "-70.21478000"
                    },
                    {
                        "id": 120490,
                        "name": "Limerick",
                        "latitude": "43.68841000",
                        "longitude": "-70.79367000"
                    },
                    {
                        "id": 120492,
                        "name": "Limestone",
                        "latitude": "46.90866000",
                        "longitude": "-67.82585000"
                    },
                    {
                        "id": 120497,
                        "name": "Limington",
                        "latitude": "43.73174000",
                        "longitude": "-70.71089000"
                    },
                    {
                        "id": 120505,
                        "name": "Lincoln",
                        "latitude": "45.36228000",
                        "longitude": "-68.50502000"
                    },
                    {
                        "id": 120526,
                        "name": "Lincoln County",
                        "latitude": "43.99779000",
                        "longitude": "-69.52576000"
                    },
                    {
                        "id": 120554,
                        "name": "Lincolnville",
                        "latitude": "44.28119000",
                        "longitude": "-69.00865000"
                    },
                    {
                        "id": 120599,
                        "name": "Lisbon",
                        "latitude": "44.03146000",
                        "longitude": "-70.10450000"
                    },
                    {
                        "id": 120601,
                        "name": "Lisbon Falls",
                        "latitude": "43.99619000",
                        "longitude": "-70.06061000"
                    },
                    {
                        "id": 120643,
                        "name": "Livermore",
                        "latitude": "44.38396000",
                        "longitude": "-70.24922000"
                    },
                    {
                        "id": 120645,
                        "name": "Livermore Falls",
                        "latitude": "44.47534000",
                        "longitude": "-70.18811000"
                    },
                    {
                        "id": 120823,
                        "name": "Lovell",
                        "latitude": "44.12674000",
                        "longitude": "-70.89173000"
                    },
                    {
                        "id": 120956,
                        "name": "Machias",
                        "latitude": "44.71508000",
                        "longitude": "-67.46138000"
                    },
                    {
                        "id": 120958,
                        "name": "Machiasport",
                        "latitude": "44.69869000",
                        "longitude": "-67.39471000"
                    },
                    {
                        "id": 120976,
                        "name": "Madawaska",
                        "latitude": "46.88421000",
                        "longitude": "-67.94725000"
                    },
                    {
                        "id": 120995,
                        "name": "Madison",
                        "latitude": "44.79756000",
                        "longitude": "-69.87978000"
                    },
                    {
                        "id": 121097,
                        "name": "Manchester",
                        "latitude": "44.32451000",
                        "longitude": "-69.86033000"
                    },
                    {
                        "id": 121579,
                        "name": "Mechanic Falls",
                        "latitude": "44.11174000",
                        "longitude": "-70.39172000"
                    },
                    {
                        "id": 121611,
                        "name": "Medway",
                        "latitude": "45.60894000",
                        "longitude": "-68.53086000"
                    },
                    {
                        "id": 121742,
                        "name": "Mexico",
                        "latitude": "44.56090000",
                        "longitude": "-70.54534000"
                    },
                    {
                        "id": 121843,
                        "name": "Milbridge",
                        "latitude": "44.53536000",
                        "longitude": "-67.88083000"
                    },
                    {
                        "id": 121853,
                        "name": "Milford",
                        "latitude": "44.94618000",
                        "longitude": "-68.64392000"
                    },
                    {
                        "id": 121893,
                        "name": "Millinocket",
                        "latitude": "45.65727000",
                        "longitude": "-68.70976000"
                    },
                    {
                        "id": 121908,
                        "name": "Milo",
                        "latitude": "45.25366000",
                        "longitude": "-68.98587000"
                    },
                    {
                        "id": 121965,
                        "name": "Minot",
                        "latitude": "44.08563000",
                        "longitude": "-70.32006000"
                    },
                    {
                        "id": 122043,
                        "name": "Monmouth",
                        "latitude": "44.23868000",
                        "longitude": "-70.03561000"
                    },
                    {
                        "id": 122401,
                        "name": "Mount Vernon",
                        "latitude": "44.50118000",
                        "longitude": "-69.98756000"
                    },
                    {
                        "id": 122709,
                        "name": "New Gloucester",
                        "latitude": "43.96285000",
                        "longitude": "-70.28255000"
                    },
                    {
                        "id": 122777,
                        "name": "New Sharon",
                        "latitude": "44.63895000",
                        "longitude": "-70.01561000"
                    },
                    {
                        "id": 122829,
                        "name": "Newfield",
                        "latitude": "43.64813000",
                        "longitude": "-70.84701000"
                    },
                    {
                        "id": 122846,
                        "name": "Newport",
                        "latitude": "44.83534000",
                        "longitude": "-69.27394000"
                    },
                    {
                        "id": 122919,
                        "name": "Nobleboro",
                        "latitude": "44.07952000",
                        "longitude": "-69.48505000"
                    },
                    {
                        "id": 122954,
                        "name": "Norridgewock",
                        "latitude": "44.71312000",
                        "longitude": "-69.79061000"
                    },
                    {
                        "id": 122974,
                        "name": "North Bath",
                        "latitude": "43.93480000",
                        "longitude": "-69.81588000"
                    },
                    {
                        "id": 122988,
                        "name": "North Berwick",
                        "latitude": "43.30370000",
                        "longitude": "-70.73339000"
                    },
                    {
                        "id": 123131,
                        "name": "North Windham",
                        "latitude": "43.83424000",
                        "longitude": "-70.43839000"
                    },
                    {
                        "id": 123161,
                        "name": "Northport",
                        "latitude": "44.33786000",
                        "longitude": "-68.96142000"
                    },
                    {
                        "id": 123193,
                        "name": "Norway",
                        "latitude": "44.21396000",
                        "longitude": "-70.54478000"
                    },
                    {
                        "id": 123289,
                        "name": "Oakland",
                        "latitude": "44.54034000",
                        "longitude": "-69.72199000"
                    },
                    {
                        "id": 123380,
                        "name": "Ogunquit",
                        "latitude": "43.24898000",
                        "longitude": "-70.59922000"
                    },
                    {
                        "id": 123425,
                        "name": "Old Orchard Beach",
                        "latitude": "43.51731000",
                        "longitude": "-70.37755000"
                    },
                    {
                        "id": 123430,
                        "name": "Old Town",
                        "latitude": "44.93423000",
                        "longitude": "-68.64531000"
                    },
                    {
                        "id": 123558,
                        "name": "Orland",
                        "latitude": "44.57035000",
                        "longitude": "-68.73586000"
                    },
                    {
                        "id": 123574,
                        "name": "Orono",
                        "latitude": "44.88312000",
                        "longitude": "-68.67198000"
                    },
                    {
                        "id": 123581,
                        "name": "Orrington",
                        "latitude": "44.73118000",
                        "longitude": "-68.82643000"
                    },
                    {
                        "id": 123671,
                        "name": "Owls Head",
                        "latitude": "44.08230000",
                        "longitude": "-69.05726000"
                    },
                    {
                        "id": 123684,
                        "name": "Oxford",
                        "latitude": "44.13174000",
                        "longitude": "-70.49311000"
                    },
                    {
                        "id": 123688,
                        "name": "Oxford County",
                        "latitude": "44.49977000",
                        "longitude": "-70.75657000"
                    },
                    {
                        "id": 123734,
                        "name": "Palermo",
                        "latitude": "44.40785000",
                        "longitude": "-69.47393000"
                    },
                    {
                        "id": 123774,
                        "name": "Palmyra",
                        "latitude": "44.84645000",
                        "longitude": "-69.35866000"
                    },
                    {
                        "id": 123835,
                        "name": "Paris",
                        "latitude": "44.25979000",
                        "longitude": "-70.50062000"
                    },
                    {
                        "id": 123894,
                        "name": "Parsonsfield",
                        "latitude": "43.72702000",
                        "longitude": "-70.92868000"
                    },
                    {
                        "id": 123914,
                        "name": "Patten",
                        "latitude": "45.99644000",
                        "longitude": "-68.44614000"
                    },
                    {
                        "id": 124041,
                        "name": "Penobscot",
                        "latitude": "44.46452000",
                        "longitude": "-68.71114000"
                    },
                    {
                        "id": 124042,
                        "name": "Penobscot County",
                        "latitude": "45.40051000",
                        "longitude": "-68.64943000"
                    },
                    {
                        "id": 124097,
                        "name": "Peru",
                        "latitude": "44.50673000",
                        "longitude": "-70.40534000"
                    },
                    {
                        "id": 124133,
                        "name": "Phillips",
                        "latitude": "44.82311000",
                        "longitude": "-70.33951000"
                    },
                    {
                        "id": 124145,
                        "name": "Phippsburg",
                        "latitude": "43.82064000",
                        "longitude": "-69.81477000"
                    },
                    {
                        "id": 124281,
                        "name": "Piscataquis County",
                        "latitude": "45.83736000",
                        "longitude": "-69.28452000"
                    },
                    {
                        "id": 124299,
                        "name": "Pittsfield",
                        "latitude": "44.78256000",
                        "longitude": "-69.38338000"
                    },
                    {
                        "id": 124303,
                        "name": "Pittston",
                        "latitude": "44.22174000",
                        "longitude": "-69.75560000"
                    },
                    {
                        "id": 124404,
                        "name": "Plymouth",
                        "latitude": "44.76729000",
                        "longitude": "-69.21033000"
                    },
                    {
                        "id": 124437,
                        "name": "Poland",
                        "latitude": "44.06063000",
                        "longitude": "-70.39367000"
                    },
                    {
                        "id": 124552,
                        "name": "Porter",
                        "latitude": "43.79591000",
                        "longitude": "-70.93256000"
                    },
                    {
                        "id": 124562,
                        "name": "Portland",
                        "latitude": "43.65737000",
                        "longitude": "-70.25890000"
                    },
                    {
                        "id": 124649,
                        "name": "Presque Isle",
                        "latitude": "46.68115000",
                        "longitude": "-68.01586000"
                    },
                    {
                        "id": 124866,
                        "name": "Randolph",
                        "latitude": "44.23035000",
                        "longitude": "-69.76671000"
                    },
                    {
                        "id": 124918,
                        "name": "Raymond",
                        "latitude": "43.90146000",
                        "longitude": "-70.47033000"
                    },
                    {
                        "id": 124928,
                        "name": "Readfield",
                        "latitude": "44.38785000",
                        "longitude": "-69.96672000"
                    },
                    {
                        "id": 125091,
                        "name": "Richmond",
                        "latitude": "44.08730000",
                        "longitude": "-69.79893000"
                    },
                    {
                        "id": 125308,
                        "name": "Rockland",
                        "latitude": "44.10369000",
                        "longitude": "-69.10893000"
                    },
                    {
                        "id": 125318,
                        "name": "Rockport",
                        "latitude": "44.18452000",
                        "longitude": "-69.07615000"
                    },
                    {
                        "id": 125377,
                        "name": "Rome",
                        "latitude": "44.58506000",
                        "longitude": "-69.86922000"
                    },
                    {
                        "id": 125507,
                        "name": "Rumford",
                        "latitude": "44.55367000",
                        "longitude": "-70.55090000"
                    },
                    {
                        "id": 125566,
                        "name": "Sabattus",
                        "latitude": "44.11980000",
                        "longitude": "-70.10755000"
                    },
                    {
                        "id": 125576,
                        "name": "Saco",
                        "latitude": "43.50092000",
                        "longitude": "-70.44283000"
                    },
                    {
                        "id": 125585,
                        "name": "Sagadahoc County",
                        "latitude": "43.91173000",
                        "longitude": "-69.83931000"
                    },
                    {
                        "id": 125595,
                        "name": "Saint Albans",
                        "latitude": "44.91006000",
                        "longitude": "-69.41005000"
                    },
                    {
                        "id": 125643,
                        "name": "Saint George",
                        "latitude": "44.01647000",
                        "longitude": "-69.19893000"
                    },
                    {
                        "id": 125888,
                        "name": "Sanford",
                        "latitude": "43.43925000",
                        "longitude": "-70.77422000"
                    },
                    {
                        "id": 125893,
                        "name": "Sangerville",
                        "latitude": "45.16478000",
                        "longitude": "-69.35644000"
                    },
                    {
                        "id": 125997,
                        "name": "Scarborough",
                        "latitude": "43.57814000",
                        "longitude": "-70.32172000"
                    },
                    {
                        "id": 126096,
                        "name": "Searsmont",
                        "latitude": "44.36174000",
                        "longitude": "-69.19504000"
                    },
                    {
                        "id": 126118,
                        "name": "Sedgwick",
                        "latitude": "44.30369000",
                        "longitude": "-68.61614000"
                    },
                    {
                        "id": 126224,
                        "name": "Shapleigh",
                        "latitude": "43.54064000",
                        "longitude": "-70.84812000"
                    },
                    {
                        "id": 126396,
                        "name": "Sidney",
                        "latitude": "44.41312000",
                        "longitude": "-69.72893000"
                    },
                    {
                        "id": 126484,
                        "name": "Skowhegan",
                        "latitude": "44.76506000",
                        "longitude": "-69.71922000"
                    },
                    {
                        "id": 126587,
                        "name": "Somerset County",
                        "latitude": "45.51385000",
                        "longitude": "-69.95882000"
                    },
                    {
                        "id": 126626,
                        "name": "South Berwick",
                        "latitude": "43.23453000",
                        "longitude": "-70.80950000"
                    },
                    {
                        "id": 126652,
                        "name": "South Eliot",
                        "latitude": "43.10814000",
                        "longitude": "-70.77755000"
                    },
                    {
                        "id": 126702,
                        "name": "South Paris",
                        "latitude": "44.22368000",
                        "longitude": "-70.51339000"
                    },
                    {
                        "id": 126713,
                        "name": "South Portland",
                        "latitude": "43.64147000",
                        "longitude": "-70.24088000"
                    },
                    {
                        "id": 126714,
                        "name": "South Portland Gardens",
                        "latitude": "43.63897000",
                        "longitude": "-70.31533000"
                    },
                    {
                        "id": 126726,
                        "name": "South Sanford",
                        "latitude": "43.41119000",
                        "longitude": "-70.74256000"
                    },
                    {
                        "id": 126735,
                        "name": "South Thomaston",
                        "latitude": "44.05147000",
                        "longitude": "-69.12782000"
                    },
                    {
                        "id": 126752,
                        "name": "South Windham",
                        "latitude": "43.73619000",
                        "longitude": "-70.42366000"
                    },
                    {
                        "id": 126912,
                        "name": "Springvale",
                        "latitude": "43.46675000",
                        "longitude": "-70.79367000"
                    },
                    {
                        "id": 127015,
                        "name": "Steep Falls",
                        "latitude": "43.79397000",
                        "longitude": "-70.65256000"
                    },
                    {
                        "id": 127036,
                        "name": "Stetson",
                        "latitude": "44.89173000",
                        "longitude": "-69.14282000"
                    },
                    {
                        "id": 127037,
                        "name": "Steuben",
                        "latitude": "44.51098000",
                        "longitude": "-67.96662000"
                    },
                    {
                        "id": 127075,
                        "name": "Stockton Springs",
                        "latitude": "44.48952000",
                        "longitude": "-68.85698000"
                    },
                    {
                        "id": 127095,
                        "name": "Stonington",
                        "latitude": "44.15619000",
                        "longitude": "-68.66669000"
                    },
                    {
                        "id": 127138,
                        "name": "Strong",
                        "latitude": "44.80756000",
                        "longitude": "-70.22090000"
                    },
                    {
                        "id": 127184,
                        "name": "Sullivan",
                        "latitude": "44.52036000",
                        "longitude": "-68.19668000"
                    },
                    {
                        "id": 127293,
                        "name": "Surry",
                        "latitude": "44.49591000",
                        "longitude": "-68.50169000"
                    },
                    {
                        "id": 127328,
                        "name": "Swanville",
                        "latitude": "44.52119000",
                        "longitude": "-68.99781000"
                    },
                    {
                        "id": 127585,
                        "name": "Thomaston",
                        "latitude": "44.07897000",
                        "longitude": "-69.18171000"
                    },
                    {
                        "id": 127736,
                        "name": "Topsham",
                        "latitude": "43.92758000",
                        "longitude": "-69.97588000"
                    },
                    {
                        "id": 127794,
                        "name": "Tremont",
                        "latitude": "44.25369000",
                        "longitude": "-68.35141000"
                    },
                    {
                        "id": 127807,
                        "name": "Trenton",
                        "latitude": "44.43897000",
                        "longitude": "-68.37002000"
                    },
                    {
                        "id": 127849,
                        "name": "Troy",
                        "latitude": "44.66479000",
                        "longitude": "-69.24088000"
                    },
                    {
                        "id": 127901,
                        "name": "Turner",
                        "latitude": "44.25646000",
                        "longitude": "-70.25617000"
                    },
                    {
                        "id": 127975,
                        "name": "Union",
                        "latitude": "44.21147000",
                        "longitude": "-69.27421000"
                    },
                    {
                        "id": 128128,
                        "name": "Van Buren",
                        "latitude": "47.15727000",
                        "longitude": "-67.93530000"
                    },
                    {
                        "id": 128158,
                        "name": "Vassalboro",
                        "latitude": "44.45923000",
                        "longitude": "-69.67755000"
                    },
                    {
                        "id": 128160,
                        "name": "Veazie",
                        "latitude": "44.83868000",
                        "longitude": "-68.70531000"
                    },
                    {
                        "id": 128262,
                        "name": "Vinalhaven",
                        "latitude": "44.04814000",
                        "longitude": "-68.83170000"
                    },
                    {
                        "id": 128372,
                        "name": "Waldo County",
                        "latitude": "44.48525000",
                        "longitude": "-69.12188000"
                    },
                    {
                        "id": 128373,
                        "name": "Waldoboro",
                        "latitude": "44.09536000",
                        "longitude": "-69.37560000"
                    },
                    {
                        "id": 128480,
                        "name": "Warren",
                        "latitude": "44.12036000",
                        "longitude": "-69.24005000"
                    },
                    {
                        "id": 128547,
                        "name": "Washington",
                        "latitude": "44.27369000",
                        "longitude": "-69.36727000"
                    },
                    {
                        "id": 128569,
                        "name": "Washington County",
                        "latitude": "44.96946000",
                        "longitude": "-67.60906000"
                    },
                    {
                        "id": 128601,
                        "name": "Waterboro",
                        "latitude": "43.53564000",
                        "longitude": "-70.71506000"
                    },
                    {
                        "id": 128626,
                        "name": "Waterville",
                        "latitude": "44.55201000",
                        "longitude": "-69.63171000"
                    },
                    {
                        "id": 128684,
                        "name": "Wayne",
                        "latitude": "44.34868000",
                        "longitude": "-70.06616000"
                    },
                    {
                        "id": 128784,
                        "name": "Wells Beach Station",
                        "latitude": "43.32397000",
                        "longitude": "-70.59144000"
                    },
                    {
                        "id": 128906,
                        "name": "West Kennebunk",
                        "latitude": "43.40870000",
                        "longitude": "-70.58144000"
                    },
                    {
                        "id": 128948,
                        "name": "West Paris",
                        "latitude": "44.32423000",
                        "longitude": "-70.57395000"
                    },
                    {
                        "id": 128977,
                        "name": "West Scarborough",
                        "latitude": "43.57036000",
                        "longitude": "-70.38783000"
                    },
                    {
                        "id": 129013,
                        "name": "Westbrook",
                        "latitude": "43.67703000",
                        "longitude": "-70.37116000"
                    },
                    {
                        "id": 129164,
                        "name": "Whitefield",
                        "latitude": "44.17007000",
                        "longitude": "-69.62532000"
                    },
                    {
                        "id": 129344,
                        "name": "Wilton",
                        "latitude": "44.59284000",
                        "longitude": "-70.22812000"
                    },
                    {
                        "id": 129383,
                        "name": "Windsor",
                        "latitude": "44.31063000",
                        "longitude": "-69.58060000"
                    },
                    {
                        "id": 129428,
                        "name": "Winslow",
                        "latitude": "44.54701000",
                        "longitude": "-69.62116000"
                    },
                    {
                        "id": 129443,
                        "name": "Winterport",
                        "latitude": "44.63785000",
                        "longitude": "-68.84504000"
                    },
                    {
                        "id": 129449,
                        "name": "Winthrop",
                        "latitude": "44.30507000",
                        "longitude": "-69.97700000"
                    },
                    {
                        "id": 129456,
                        "name": "Wiscasset",
                        "latitude": "44.00286000",
                        "longitude": "-69.66560000"
                    },
                    {
                        "id": 129567,
                        "name": "Woodstock",
                        "latitude": "44.37494000",
                        "longitude": "-70.60849000"
                    },
                    {
                        "id": 129581,
                        "name": "Woolwich",
                        "latitude": "43.91869000",
                        "longitude": "-69.80116000"
                    },
                    {
                        "id": 129666,
                        "name": "Yarmouth",
                        "latitude": "43.80064000",
                        "longitude": "-70.18672000"
                    },
                    {
                        "id": 129694,
                        "name": "York Beach",
                        "latitude": "43.17148000",
                        "longitude": "-70.60894000"
                    },
                    {
                        "id": 129697,
                        "name": "York County",
                        "latitude": "43.42923000",
                        "longitude": "-70.67015000"
                    },
                    {
                        "id": 129700,
                        "name": "York Harbor",
                        "latitude": "43.13676000",
                        "longitude": "-70.64561000"
                    }
                ]
            },
            {
                "id": 1401,
                "name": "Maryland",
                "iso2": "MD",
                "latitude": "38.77952510",
                "longitude": "-79.87137150",
                "type": "state",
                "cities": [
                    {
                        "id": 110973,
                        "name": "Aberdeen",
                        "latitude": "39.50956000",
                        "longitude": "-76.16412000"
                    },
                    {
                        "id": 110980,
                        "name": "Aberdeen Proving Ground",
                        "latitude": "39.46686000",
                        "longitude": "-76.13066000"
                    },
                    {
                        "id": 110993,
                        "name": "Accokeek",
                        "latitude": "38.66762000",
                        "longitude": "-77.02831000"
                    },
                    {
                        "id": 111029,
                        "name": "Adamstown",
                        "latitude": "39.31094000",
                        "longitude": "-77.47471000"
                    },
                    {
                        "id": 111044,
                        "name": "Adelphi",
                        "latitude": "39.00317000",
                        "longitude": "-76.97192000"
                    },
                    {
                        "id": 111166,
                        "name": "Algonquin",
                        "latitude": "38.58290000",
                        "longitude": "-76.10577000"
                    },
                    {
                        "id": 111181,
                        "name": "Allegany County",
                        "latitude": "39.62148000",
                        "longitude": "-78.69890000"
                    },
                    {
                        "id": 111332,
                        "name": "Andrews AFB",
                        "latitude": "38.80531000",
                        "longitude": "-76.87460000"
                    },
                    {
                        "id": 111352,
                        "name": "Annapolis",
                        "latitude": "38.97845000",
                        "longitude": "-76.49218000"
                    },
                    {
                        "id": 111353,
                        "name": "Anne Arundel County",
                        "latitude": "38.99416000",
                        "longitude": "-76.56760000"
                    },
                    {
                        "id": 111417,
                        "name": "Arbutus",
                        "latitude": "39.25455000",
                        "longitude": "-76.69997000"
                    },
                    {
                        "id": 111439,
                        "name": "Arden on the Severn",
                        "latitude": "39.06594000",
                        "longitude": "-76.57885000"
                    },
                    {
                        "id": 111461,
                        "name": "Arlington",
                        "latitude": "39.34857000",
                        "longitude": "-76.68324000"
                    },
                    {
                        "id": 111485,
                        "name": "Arnold",
                        "latitude": "39.03206000",
                        "longitude": "-76.50274000"
                    },
                    {
                        "id": 111547,
                        "name": "Ashton-Sandy Spring",
                        "latitude": "39.14976000",
                        "longitude": "-77.00504000"
                    },
                    {
                        "id": 111553,
                        "name": "Aspen Hill",
                        "latitude": "39.07955000",
                        "longitude": "-77.07303000"
                    },
                    {
                        "id": 111722,
                        "name": "Baden",
                        "latitude": "38.65928000",
                        "longitude": "-76.77775000"
                    },
                    {
                        "id": 111772,
                        "name": "Ballenger Creek",
                        "latitude": "39.37260000",
                        "longitude": "-77.43526000"
                    },
                    {
                        "id": 111783,
                        "name": "Baltimore",
                        "latitude": "39.29038000",
                        "longitude": "-76.61219000"
                    },
                    {
                        "id": 111784,
                        "name": "Baltimore County",
                        "latitude": "39.44307000",
                        "longitude": "-76.61632000"
                    },
                    {
                        "id": 111785,
                        "name": "Baltimore Highlands",
                        "latitude": "39.23316000",
                        "longitude": "-76.63663000"
                    },
                    {
                        "id": 111869,
                        "name": "Bartonsville",
                        "latitude": "39.39260000",
                        "longitude": "-77.35804000"
                    },
                    {
                        "id": 112046,
                        "name": "Bel Air",
                        "latitude": "39.53594000",
                        "longitude": "-76.34829000"
                    },
                    {
                        "id": 112047,
                        "name": "Bel Air North",
                        "latitude": "39.55429000",
                        "longitude": "-76.37309000"
                    },
                    {
                        "id": 112048,
                        "name": "Bel Air South",
                        "latitude": "39.50506000",
                        "longitude": "-76.31977000"
                    },
                    {
                        "id": 112151,
                        "name": "Beltsville",
                        "latitude": "39.03483000",
                        "longitude": "-76.90747000"
                    },
                    {
                        "id": 112179,
                        "name": "Bennsville",
                        "latitude": "38.60929000",
                        "longitude": "-77.01220000"
                    },
                    {
                        "id": 112234,
                        "name": "Berlin",
                        "latitude": "38.32262000",
                        "longitude": "-75.21769000"
                    },
                    {
                        "id": 112266,
                        "name": "Berwyn Heights",
                        "latitude": "38.99400000",
                        "longitude": "-76.91053000"
                    },
                    {
                        "id": 112288,
                        "name": "Bethesda",
                        "latitude": "38.98067000",
                        "longitude": "-77.10026000"
                    },
                    {
                        "id": 112400,
                        "name": "Bladensburg",
                        "latitude": "38.93928000",
                        "longitude": "-76.93386000"
                    },
                    {
                        "id": 112565,
                        "name": "Boonsboro",
                        "latitude": "39.50621000",
                        "longitude": "-77.65249000"
                    },
                    {
                        "id": 112623,
                        "name": "Bowie",
                        "latitude": "38.94278000",
                        "longitude": "-76.73028000"
                    },
                    {
                        "id": 112626,
                        "name": "Bowleys Quarters",
                        "latitude": "39.33539000",
                        "longitude": "-76.39024000"
                    },
                    {
                        "id": 112629,
                        "name": "Bowling Green",
                        "latitude": "39.62370000",
                        "longitude": "-78.80446000"
                    },
                    {
                        "id": 112660,
                        "name": "Braddock Heights",
                        "latitude": "39.41871000",
                        "longitude": "-77.50360000"
                    },
                    {
                        "id": 112692,
                        "name": "Brandywine",
                        "latitude": "38.69678000",
                        "longitude": "-76.84775000"
                    },
                    {
                        "id": 112728,
                        "name": "Brentwood",
                        "latitude": "38.94317000",
                        "longitude": "-76.95664000"
                    },
                    {
                        "id": 112832,
                        "name": "Brock Hall",
                        "latitude": "38.85011000",
                        "longitude": "-76.76108000"
                    },
                    {
                        "id": 112876,
                        "name": "Brooklyn Park",
                        "latitude": "39.22844000",
                        "longitude": "-76.61636000"
                    },
                    {
                        "id": 112878,
                        "name": "Brookmont",
                        "latitude": "38.94206000",
                        "longitude": "-77.12026000"
                    },
                    {
                        "id": 112948,
                        "name": "Brunswick",
                        "latitude": "39.31427000",
                        "longitude": "-77.62777000"
                    },
                    {
                        "id": 112962,
                        "name": "Bryans Road",
                        "latitude": "38.62706000",
                        "longitude": "-77.07303000"
                    },
                    {
                        "id": 112978,
                        "name": "Buckeystown",
                        "latitude": "39.33482000",
                        "longitude": "-77.43165000"
                    },
                    {
                        "id": 113098,
                        "name": "Burtonsville",
                        "latitude": "39.11122000",
                        "longitude": "-76.93248000"
                    },
                    {
                        "id": 113105,
                        "name": "Butcher's Hill",
                        "latitude": "39.28955000",
                        "longitude": "-76.58830000"
                    },
                    {
                        "id": 113152,
                        "name": "Cabin John",
                        "latitude": "38.97539000",
                        "longitude": "-77.15803000"
                    },
                    {
                        "id": 113216,
                        "name": "California",
                        "latitude": "38.30040000",
                        "longitude": "-76.50745000"
                    },
                    {
                        "id": 113235,
                        "name": "Calvert County",
                        "latitude": "38.53471000",
                        "longitude": "-76.53056000"
                    },
                    {
                        "id": 113236,
                        "name": "Calverton",
                        "latitude": "39.05761000",
                        "longitude": "-76.93581000"
                    },
                    {
                        "id": 113250,
                        "name": "Cambridge",
                        "latitude": "38.56317000",
                        "longitude": "-76.07883000"
                    },
                    {
                        "id": 113293,
                        "name": "Camp Springs",
                        "latitude": "38.80400000",
                        "longitude": "-76.90664000"
                    },
                    {
                        "id": 113373,
                        "name": "Cape Saint Claire",
                        "latitude": "39.04317000",
                        "longitude": "-76.44496000"
                    },
                    {
                        "id": 113375,
                        "name": "Capitol Heights",
                        "latitude": "38.88511000",
                        "longitude": "-76.91581000"
                    },
                    {
                        "id": 113428,
                        "name": "Carney",
                        "latitude": "39.39427000",
                        "longitude": "-76.52358000"
                    },
                    {
                        "id": 113437,
                        "name": "Caroline County",
                        "latitude": "38.87173000",
                        "longitude": "-75.83160000"
                    },
                    {
                        "id": 113453,
                        "name": "Carroll County",
                        "latitude": "39.56286000",
                        "longitude": "-77.02252000"
                    },
                    {
                        "id": 113575,
                        "name": "Catonsville",
                        "latitude": "39.27205000",
                        "longitude": "-76.73192000"
                    },
                    {
                        "id": 113590,
                        "name": "Cavetown",
                        "latitude": "39.64426000",
                        "longitude": "-77.58582000"
                    },
                    {
                        "id": 113598,
                        "name": "Cecil County",
                        "latitude": "39.56242000",
                        "longitude": "-75.94811000"
                    },
                    {
                        "id": 113693,
                        "name": "Centreville",
                        "latitude": "39.04178000",
                        "longitude": "-76.06633000"
                    },
                    {
                        "id": 113757,
                        "name": "Charles County",
                        "latitude": "38.47368000",
                        "longitude": "-77.01348000"
                    },
                    {
                        "id": 113760,
                        "name": "Charles Village",
                        "latitude": "39.32316000",
                        "longitude": "-76.61330000"
                    },
                    {
                        "id": 113771,
                        "name": "Charlestown",
                        "latitude": "39.57373000",
                        "longitude": "-75.97495000"
                    },
                    {
                        "id": 113784,
                        "name": "Charlotte Hall",
                        "latitude": "38.48096000",
                        "longitude": "-76.77802000"
                    },
                    {
                        "id": 113875,
                        "name": "Chesapeake Beach",
                        "latitude": "38.68623000",
                        "longitude": "-76.53468000"
                    },
                    {
                        "id": 113876,
                        "name": "Chesapeake Ranch Estates",
                        "latitude": "38.34624000",
                        "longitude": "-76.41773000"
                    },
                    {
                        "id": 113883,
                        "name": "Chester",
                        "latitude": "38.97539000",
                        "longitude": "-76.28940000"
                    },
                    {
                        "id": 113910,
                        "name": "Chestertown",
                        "latitude": "39.20900000",
                        "longitude": "-76.06661000"
                    },
                    {
                        "id": 113919,
                        "name": "Cheverly",
                        "latitude": "38.92817000",
                        "longitude": "-76.91581000"
                    },
                    {
                        "id": 113921,
                        "name": "Chevy Chase",
                        "latitude": "39.00287000",
                        "longitude": "-77.07115000"
                    },
                    {
                        "id": 113923,
                        "name": "Chevy Chase Village",
                        "latitude": "38.96928000",
                        "longitude": "-77.07887000"
                    },
                    {
                        "id": 113955,
                        "name": "Chillum",
                        "latitude": "38.96372000",
                        "longitude": "-76.99081000"
                    },
                    {
                        "id": 114048,
                        "name": "City of Baltimore",
                        "latitude": "39.29038000",
                        "longitude": "-76.61219000"
                    },
                    {
                        "id": 114143,
                        "name": "Clarksburg",
                        "latitude": "39.23872000",
                        "longitude": "-77.27943000"
                    },
                    {
                        "id": 114272,
                        "name": "Clinton",
                        "latitude": "38.76511000",
                        "longitude": "-76.89831000"
                    },
                    {
                        "id": 114308,
                        "name": "Clover Hill",
                        "latitude": "39.45621000",
                        "longitude": "-77.42887000"
                    },
                    {
                        "id": 114313,
                        "name": "Cloverly",
                        "latitude": "39.10816000",
                        "longitude": "-76.99775000"
                    },
                    {
                        "id": 114345,
                        "name": "Cobb Island",
                        "latitude": "38.25846000",
                        "longitude": "-76.84386000"
                    },
                    {
                        "id": 114355,
                        "name": "Cockeysville",
                        "latitude": "39.48122000",
                        "longitude": "-76.64386000"
                    },
                    {
                        "id": 114403,
                        "name": "Colesville",
                        "latitude": "39.07566000",
                        "longitude": "-77.00192000"
                    },
                    {
                        "id": 114414,
                        "name": "College Park",
                        "latitude": "38.98067000",
                        "longitude": "-76.93692000"
                    },
                    {
                        "id": 114441,
                        "name": "Colmar Manor",
                        "latitude": "38.93317000",
                        "longitude": "-76.94581000"
                    },
                    {
                        "id": 114467,
                        "name": "Columbia",
                        "latitude": "39.24038000",
                        "longitude": "-76.83942000"
                    },
                    {
                        "id": 114625,
                        "name": "Coral Hills",
                        "latitude": "38.87039000",
                        "longitude": "-76.92108000"
                    },
                    {
                        "id": 114690,
                        "name": "Cottage City",
                        "latitude": "38.93817000",
                        "longitude": "-76.94831000"
                    },
                    {
                        "id": 114793,
                        "name": "Cresaptown",
                        "latitude": "39.59287000",
                        "longitude": "-78.83335000"
                    },
                    {
                        "id": 114822,
                        "name": "Crisfield",
                        "latitude": "37.98346000",
                        "longitude": "-75.85382000"
                    },
                    {
                        "id": 114833,
                        "name": "Crofton",
                        "latitude": "39.00178000",
                        "longitude": "-76.68747000"
                    },
                    {
                        "id": 114841,
                        "name": "Croom",
                        "latitude": "38.75262000",
                        "longitude": "-76.76386000"
                    },
                    {
                        "id": 114869,
                        "name": "Crownsville",
                        "latitude": "39.02844000",
                        "longitude": "-76.60135000"
                    },
                    {
                        "id": 114907,
                        "name": "Cumberland",
                        "latitude": "39.65287000",
                        "longitude": "-78.76252000"
                    },
                    {
                        "id": 115009,
                        "name": "Damascus",
                        "latitude": "39.28844000",
                        "longitude": "-77.20387000"
                    },
                    {
                        "id": 115053,
                        "name": "Darnestown",
                        "latitude": "39.10344000",
                        "longitude": "-77.29082000"
                    },
                    {
                        "id": 115065,
                        "name": "Davidsonville",
                        "latitude": "38.92289000",
                        "longitude": "-76.62830000"
                    },
                    {
                        "id": 115144,
                        "name": "Deale",
                        "latitude": "38.77651000",
                        "longitude": "-76.55524000"
                    },
                    {
                        "id": 115245,
                        "name": "Denton",
                        "latitude": "38.88456000",
                        "longitude": "-75.82716000"
                    },
                    {
                        "id": 115268,
                        "name": "Derwood",
                        "latitude": "39.11733000",
                        "longitude": "-77.16109000"
                    },
                    {
                        "id": 115355,
                        "name": "District Heights",
                        "latitude": "38.85761000",
                        "longitude": "-76.88942000"
                    },
                    {
                        "id": 115410,
                        "name": "Dorchester County",
                        "latitude": "38.42261000",
                        "longitude": "-76.08332000"
                    },
                    {
                        "id": 115481,
                        "name": "Drum Point",
                        "latitude": "38.32679000",
                        "longitude": "-76.42606000"
                    },
                    {
                        "id": 115526,
                        "name": "Dundalk",
                        "latitude": "39.25066000",
                        "longitude": "-76.52052000"
                    },
                    {
                        "id": 115537,
                        "name": "Dunkirk",
                        "latitude": "38.72178000",
                        "longitude": "-76.66052000"
                    },
                    {
                        "id": 115540,
                        "name": "Dunkirk Town Center",
                        "latitude": "38.72039000",
                        "longitude": "-76.65857000"
                    },
                    {
                        "id": 115748,
                        "name": "East Riverdale",
                        "latitude": "38.96206000",
                        "longitude": "-76.92192000"
                    },
                    {
                        "id": 115785,
                        "name": "Easton",
                        "latitude": "38.77428000",
                        "longitude": "-76.07633000"
                    },
                    {
                        "id": 115844,
                        "name": "Edgemere",
                        "latitude": "39.24205000",
                        "longitude": "-76.44802000"
                    },
                    {
                        "id": 115852,
                        "name": "Edgewater",
                        "latitude": "38.95706000",
                        "longitude": "-76.54996000"
                    },
                    {
                        "id": 115859,
                        "name": "Edgewood",
                        "latitude": "39.41872000",
                        "longitude": "-76.29440000"
                    },
                    {
                        "id": 115880,
                        "name": "Edmonston",
                        "latitude": "38.94678000",
                        "longitude": "-76.93109000"
                    },
                    {
                        "id": 115949,
                        "name": "Eldersburg",
                        "latitude": "39.40371000",
                        "longitude": "-76.95026000"
                    },
                    {
                        "id": 116011,
                        "name": "Elkridge",
                        "latitude": "39.21261000",
                        "longitude": "-76.71358000"
                    },
                    {
                        "id": 116013,
                        "name": "Elkton",
                        "latitude": "39.60678000",
                        "longitude": "-75.83327000"
                    },
                    {
                        "id": 116024,
                        "name": "Ellicott City",
                        "latitude": "39.26733000",
                        "longitude": "-76.79831000"
                    },
                    {
                        "id": 116106,
                        "name": "Emmitsburg",
                        "latitude": "39.70454000",
                        "longitude": "-77.32693000"
                    },
                    {
                        "id": 116191,
                        "name": "Essex",
                        "latitude": "39.30927000",
                        "longitude": "-76.47496000"
                    },
                    {
                        "id": 116328,
                        "name": "Fairland",
                        "latitude": "39.07622000",
                        "longitude": "-76.95775000"
                    },
                    {
                        "id": 116342,
                        "name": "Fairmount Heights",
                        "latitude": "38.90095000",
                        "longitude": "-76.91553000"
                    },
                    {
                        "id": 116364,
                        "name": "Fairwood",
                        "latitude": "38.95665000",
                        "longitude": "-76.77772000"
                    },
                    {
                        "id": 116385,
                        "name": "Fallston",
                        "latitude": "39.51455000",
                        "longitude": "-76.41107000"
                    },
                    {
                        "id": 116466,
                        "name": "Federalsburg",
                        "latitude": "38.69428000",
                        "longitude": "-75.77216000"
                    },
                    {
                        "id": 116486,
                        "name": "Ferndale",
                        "latitude": "39.18316000",
                        "longitude": "-76.64024000"
                    },
                    {
                        "id": 116652,
                        "name": "Forest Glen",
                        "latitude": "39.01455000",
                        "longitude": "-77.05470000"
                    },
                    {
                        "id": 116654,
                        "name": "Forest Heights",
                        "latitude": "38.80956000",
                        "longitude": "-76.99803000"
                    },
                    {
                        "id": 116672,
                        "name": "Forestville",
                        "latitude": "38.84511000",
                        "longitude": "-76.87497000"
                    },
                    {
                        "id": 116712,
                        "name": "Fort George G Mead Junction",
                        "latitude": "39.12594000",
                        "longitude": "-76.78914000"
                    },
                    {
                        "id": 116729,
                        "name": "Fort Meade",
                        "latitude": "39.10815000",
                        "longitude": "-76.74323000"
                    },
                    {
                        "id": 116761,
                        "name": "Fort Washington",
                        "latitude": "38.70734000",
                        "longitude": "-77.02303000"
                    },
                    {
                        "id": 116786,
                        "name": "Fountainhead-Orchard Hills",
                        "latitude": "39.68636000",
                        "longitude": "-77.71901000"
                    },
                    {
                        "id": 116787,
                        "name": "Four Corners",
                        "latitude": "39.02039000",
                        "longitude": "-77.01275000"
                    },
                    {
                        "id": 116885,
                        "name": "Frederick",
                        "latitude": "39.41427000",
                        "longitude": "-77.41054000"
                    },
                    {
                        "id": 116888,
                        "name": "Frederick County",
                        "latitude": "39.47222000",
                        "longitude": "-77.39799000"
                    },
                    {
                        "id": 116947,
                        "name": "Friendly",
                        "latitude": "38.75178000",
                        "longitude": "-76.97859000"
                    },
                    {
                        "id": 116951,
                        "name": "Friendship Village",
                        "latitude": "38.96289000",
                        "longitude": "-77.08887000"
                    },
                    {
                        "id": 116964,
                        "name": "Frostburg",
                        "latitude": "39.65814000",
                        "longitude": "-78.92836000"
                    },
                    {
                        "id": 116970,
                        "name": "Fruitland",
                        "latitude": "38.32206000",
                        "longitude": "-75.62020000"
                    },
                    {
                        "id": 116987,
                        "name": "Fulton",
                        "latitude": "39.15094000",
                        "longitude": "-76.92303000"
                    },
                    {
                        "id": 117019,
                        "name": "Gaithersburg",
                        "latitude": "39.14344000",
                        "longitude": "-77.20137000"
                    },
                    {
                        "id": 117045,
                        "name": "Gambrills",
                        "latitude": "39.06705000",
                        "longitude": "-76.66524000"
                    },
                    {
                        "id": 117100,
                        "name": "Garrett County",
                        "latitude": "39.52860000",
                        "longitude": "-79.27388000"
                    },
                    {
                        "id": 117101,
                        "name": "Garrett Park",
                        "latitude": "39.03816000",
                        "longitude": "-77.09303000"
                    },
                    {
                        "id": 117102,
                        "name": "Garrison",
                        "latitude": "39.40594000",
                        "longitude": "-76.76053000"
                    },
                    {
                        "id": 117172,
                        "name": "Germantown",
                        "latitude": "39.17316000",
                        "longitude": "-77.27165000"
                    },
                    {
                        "id": 117253,
                        "name": "Glassmanor",
                        "latitude": "38.81900000",
                        "longitude": "-76.99859000"
                    },
                    {
                        "id": 117262,
                        "name": "Glen Burnie",
                        "latitude": "39.16261000",
                        "longitude": "-76.62469000"
                    },
                    {
                        "id": 117275,
                        "name": "Glenarden",
                        "latitude": "38.92928000",
                        "longitude": "-76.86164000"
                    },
                    {
                        "id": 117293,
                        "name": "Glenmont",
                        "latitude": "39.05789000",
                        "longitude": "-77.04970000"
                    },
                    {
                        "id": 117297,
                        "name": "Glenn Dale",
                        "latitude": "38.98761000",
                        "longitude": "-76.82053000"
                    },
                    {
                        "id": 117333,
                        "name": "Goddard",
                        "latitude": "38.98955000",
                        "longitude": "-76.85331000"
                    },
                    {
                        "id": 117347,
                        "name": "Golden Beach",
                        "latitude": "38.48985000",
                        "longitude": "-76.68218000"
                    },
                    {
                        "id": 117541,
                        "name": "Grasonville",
                        "latitude": "38.95817000",
                        "longitude": "-76.21023000"
                    },
                    {
                        "id": 117582,
                        "name": "Greater Upper Marlboro",
                        "latitude": "38.83142000",
                        "longitude": "-76.74827000"
                    },
                    {
                        "id": 117597,
                        "name": "Green Haven",
                        "latitude": "39.13955000",
                        "longitude": "-76.54774000"
                    },
                    {
                        "id": 117609,
                        "name": "Green Valley",
                        "latitude": "39.30927000",
                        "longitude": "-77.29721000"
                    },
                    {
                        "id": 117616,
                        "name": "Greenbelt",
                        "latitude": "39.00455000",
                        "longitude": "-76.87553000"
                    },
                    {
                        "id": 117666,
                        "name": "Greensboro",
                        "latitude": "38.97372000",
                        "longitude": "-75.80493000"
                    },
                    {
                        "id": 117838,
                        "name": "Hagerstown",
                        "latitude": "39.64176000",
                        "longitude": "-77.71999000"
                    },
                    {
                        "id": 117857,
                        "name": "Halfway",
                        "latitude": "39.62065000",
                        "longitude": "-77.75888000"
                    },
                    {
                        "id": 117923,
                        "name": "Hampstead",
                        "latitude": "39.60483000",
                        "longitude": "-76.84998000"
                    },
                    {
                        "id": 117928,
                        "name": "Hampton",
                        "latitude": "39.42288000",
                        "longitude": "-76.58469000"
                    },
                    {
                        "id": 117947,
                        "name": "Hancock",
                        "latitude": "39.69898000",
                        "longitude": "-78.17973000"
                    },
                    {
                        "id": 117967,
                        "name": "Hanover",
                        "latitude": "39.19289000",
                        "longitude": "-76.72414000"
                    },
                    {
                        "id": 118012,
                        "name": "Harford County",
                        "latitude": "39.53644000",
                        "longitude": "-76.29887000"
                    },
                    {
                        "id": 118155,
                        "name": "Havre de Grace",
                        "latitude": "39.54928000",
                        "longitude": "-76.09162000"
                    },
                    {
                        "id": 118233,
                        "name": "Hebron",
                        "latitude": "38.42012000",
                        "longitude": "-75.68771000"
                    },
                    {
                        "id": 118312,
                        "name": "Herald Harbor",
                        "latitude": "39.05372000",
                        "longitude": "-76.56913000"
                    },
                    {
                        "id": 118390,
                        "name": "Highfield-Cascade",
                        "latitude": "39.71616000",
                        "longitude": "-77.48282000"
                    },
                    {
                        "id": 118395,
                        "name": "Highland",
                        "latitude": "39.17900000",
                        "longitude": "-76.95748000"
                    },
                    {
                        "id": 118438,
                        "name": "Hillandale",
                        "latitude": "39.02650000",
                        "longitude": "-76.97414000"
                    },
                    {
                        "id": 118441,
                        "name": "Hillcrest Heights",
                        "latitude": "38.83289000",
                        "longitude": "-76.95942000"
                    },
                    {
                        "id": 118467,
                        "name": "Hillsmere Shores",
                        "latitude": "38.94011000",
                        "longitude": "-76.49496000"
                    },
                    {
                        "id": 118713,
                        "name": "Howard County",
                        "latitude": "39.25072000",
                        "longitude": "-76.93119000"
                    },
                    {
                        "id": 118762,
                        "name": "Hughesville",
                        "latitude": "38.53262000",
                        "longitude": "-76.78386000"
                    },
                    {
                        "id": 118787,
                        "name": "Hunt Valley",
                        "latitude": "39.49983000",
                        "longitude": "-76.64108000"
                    },
                    {
                        "id": 118810,
                        "name": "Huntingtown",
                        "latitude": "38.61595000",
                        "longitude": "-76.61302000"
                    },
                    {
                        "id": 118811,
                        "name": "Huntingtown Town Center",
                        "latitude": "38.62095000",
                        "longitude": "-76.61607000"
                    },
                    {
                        "id": 118823,
                        "name": "Hurlock",
                        "latitude": "38.62428000",
                        "longitude": "-75.85438000"
                    },
                    {
                        "id": 118844,
                        "name": "Hyattsville",
                        "latitude": "38.95594000",
                        "longitude": "-76.94553000"
                    },
                    {
                        "id": 118877,
                        "name": "Ilchester",
                        "latitude": "39.25094000",
                        "longitude": "-76.76469000"
                    },
                    {
                        "id": 118903,
                        "name": "Indian Head",
                        "latitude": "38.60012000",
                        "longitude": "-77.16220000"
                    },
                    {
                        "id": 119008,
                        "name": "Irvington",
                        "latitude": "39.28288000",
                        "longitude": "-76.68608000"
                    },
                    {
                        "id": 119135,
                        "name": "Jarrettsville",
                        "latitude": "39.60455000",
                        "longitude": "-76.47774000"
                    },
                    {
                        "id": 119164,
                        "name": "Jefferson",
                        "latitude": "39.36205000",
                        "longitude": "-77.53165000"
                    },
                    {
                        "id": 119237,
                        "name": "Jessup",
                        "latitude": "39.14927000",
                        "longitude": "-76.77525000"
                    },
                    {
                        "id": 119314,
                        "name": "Joppatowne",
                        "latitude": "39.45789000",
                        "longitude": "-76.35524000"
                    },
                    {
                        "id": 119417,
                        "name": "Keedysville",
                        "latitude": "39.48621000",
                        "longitude": "-77.69971000"
                    },
                    {
                        "id": 119436,
                        "name": "Kemp Mill",
                        "latitude": "39.03900000",
                        "longitude": "-77.01914000"
                    },
                    {
                        "id": 119480,
                        "name": "Kensington",
                        "latitude": "39.02567000",
                        "longitude": "-77.07637000"
                    },
                    {
                        "id": 119491,
                        "name": "Kent County",
                        "latitude": "39.23560000",
                        "longitude": "-76.09582000"
                    },
                    {
                        "id": 119526,
                        "name": "Kettering",
                        "latitude": "38.88456000",
                        "longitude": "-76.81469000"
                    },
                    {
                        "id": 119633,
                        "name": "Kingstown",
                        "latitude": "39.20483000",
                        "longitude": "-76.05133000"
                    },
                    {
                        "id": 119635,
                        "name": "Kingsville",
                        "latitude": "39.44872000",
                        "longitude": "-76.41774000"
                    },
                    {
                        "id": 119773,
                        "name": "La Plata",
                        "latitude": "38.52929000",
                        "longitude": "-76.97525000"
                    },
                    {
                        "id": 119791,
                        "name": "La Vale",
                        "latitude": "39.65564000",
                        "longitude": "-78.81058000"
                    },
                    {
                        "id": 119864,
                        "name": "Lake Arbor",
                        "latitude": "38.90789000",
                        "longitude": "-76.82969000"
                    },
                    {
                        "id": 119976,
                        "name": "Lake Shore",
                        "latitude": "39.10705000",
                        "longitude": "-76.48496000"
                    },
                    {
                        "id": 120102,
                        "name": "Landover",
                        "latitude": "38.93400000",
                        "longitude": "-76.89664000"
                    },
                    {
                        "id": 120103,
                        "name": "Landover Hills",
                        "latitude": "38.94317000",
                        "longitude": "-76.89220000"
                    },
                    {
                        "id": 120115,
                        "name": "Langley Park",
                        "latitude": "38.98872000",
                        "longitude": "-76.98136000"
                    },
                    {
                        "id": 120117,
                        "name": "Lanham",
                        "latitude": "38.96875000",
                        "longitude": "-76.86340000"
                    },
                    {
                        "id": 120118,
                        "name": "Lanham-Seabrook",
                        "latitude": "38.96835000",
                        "longitude": "-76.85108000"
                    },
                    {
                        "id": 120122,
                        "name": "Lansdowne",
                        "latitude": "39.24511000",
                        "longitude": "-76.66052000"
                    },
                    {
                        "id": 120144,
                        "name": "Largo",
                        "latitude": "38.89761000",
                        "longitude": "-76.83025000"
                    },
                    {
                        "id": 120189,
                        "name": "Laurel",
                        "latitude": "39.09928000",
                        "longitude": "-76.84831000"
                    },
                    {
                        "id": 120252,
                        "name": "Layhill",
                        "latitude": "39.09233000",
                        "longitude": "-77.04442000"
                    },
                    {
                        "id": 120345,
                        "name": "Leisure World",
                        "latitude": "39.10230000",
                        "longitude": "-77.06898000"
                    },
                    {
                        "id": 120390,
                        "name": "Leonardtown",
                        "latitude": "38.29124000",
                        "longitude": "-76.63579000"
                    },
                    {
                        "id": 120455,
                        "name": "Lexington Park",
                        "latitude": "38.26679000",
                        "longitude": "-76.45384000"
                    },
                    {
                        "id": 120578,
                        "name": "Linganore",
                        "latitude": "39.44038000",
                        "longitude": "-77.20804000"
                    },
                    {
                        "id": 120588,
                        "name": "Linthicum",
                        "latitude": "39.20511000",
                        "longitude": "-76.65275000"
                    },
                    {
                        "id": 120671,
                        "name": "Lochearn",
                        "latitude": "39.34066000",
                        "longitude": "-76.72219000"
                    },
                    {
                        "id": 120719,
                        "name": "Lonaconing",
                        "latitude": "39.56592000",
                        "longitude": "-78.98030000"
                    },
                    {
                        "id": 120725,
                        "name": "Londontowne",
                        "latitude": "38.93345000",
                        "longitude": "-76.54941000"
                    },
                    {
                        "id": 120733,
                        "name": "Long Beach",
                        "latitude": "38.46096000",
                        "longitude": "-76.46884000"
                    },
                    {
                        "id": 120891,
                        "name": "Lusby",
                        "latitude": "38.41068000",
                        "longitude": "-76.45523000"
                    },
                    {
                        "id": 120895,
                        "name": "Lutherville",
                        "latitude": "39.42122000",
                        "longitude": "-76.62608000"
                    },
                    {
                        "id": 120896,
                        "name": "Lutherville-Timonium",
                        "latitude": "39.43997000",
                        "longitude": "-76.61099000"
                    },
                    {
                        "id": 121090,
                        "name": "Manchester",
                        "latitude": "39.66121000",
                        "longitude": "-76.88498000"
                    },
                    {
                        "id": 121277,
                        "name": "Marlboro Meadows",
                        "latitude": "38.83622000",
                        "longitude": "-76.71497000"
                    },
                    {
                        "id": 121278,
                        "name": "Marlboro Village",
                        "latitude": "38.83054000",
                        "longitude": "-76.76965000"
                    },
                    {
                        "id": 121286,
                        "name": "Marlow Heights",
                        "latitude": "38.83345000",
                        "longitude": "-76.95164000"
                    },
                    {
                        "id": 121287,
                        "name": "Marlton",
                        "latitude": "38.77373000",
                        "longitude": "-76.78997000"
                    },
                    {
                        "id": 121355,
                        "name": "Maryland City",
                        "latitude": "39.09205000",
                        "longitude": "-76.81775000"
                    },
                    {
                        "id": 121418,
                        "name": "Maugansville",
                        "latitude": "39.69287000",
                        "longitude": "-77.74472000"
                    },
                    {
                        "id": 121443,
                        "name": "Mayo",
                        "latitude": "38.88761000",
                        "longitude": "-76.51190000"
                    },
                    {
                        "id": 121446,
                        "name": "Mays Chapel",
                        "latitude": "39.43316000",
                        "longitude": "-76.64941000"
                    },
                    {
                        "id": 121582,
                        "name": "Mechanicsville",
                        "latitude": "38.44290000",
                        "longitude": "-76.74385000"
                    },
                    {
                        "id": 121626,
                        "name": "Mellwood",
                        "latitude": "38.81039000",
                        "longitude": "-76.82414000"
                    },
                    {
                        "id": 121762,
                        "name": "Middle River",
                        "latitude": "39.33427000",
                        "longitude": "-76.43941000"
                    },
                    {
                        "id": 121786,
                        "name": "Middletown",
                        "latitude": "39.44371000",
                        "longitude": "-77.54471000"
                    },
                    {
                        "id": 121860,
                        "name": "Milford Mill",
                        "latitude": "39.34788000",
                        "longitude": "-76.76997000"
                    },
                    {
                        "id": 122004,
                        "name": "Mitchellville",
                        "latitude": "38.92511000",
                        "longitude": "-76.74275000"
                    },
                    {
                        "id": 122145,
                        "name": "Montgomery County",
                        "latitude": "39.13638000",
                        "longitude": "-77.20424000"
                    },
                    {
                        "id": 122156,
                        "name": "Montgomery Village",
                        "latitude": "39.17677000",
                        "longitude": "-77.19526000"
                    },
                    {
                        "id": 122257,
                        "name": "Morningside",
                        "latitude": "38.83011000",
                        "longitude": "-76.89136000"
                    },
                    {
                        "id": 122330,
                        "name": "Mount Airy",
                        "latitude": "39.37621000",
                        "longitude": "-77.15470000"
                    },
                    {
                        "id": 122387,
                        "name": "Mount Rainier",
                        "latitude": "38.94150000",
                        "longitude": "-76.96498000"
                    },
                    {
                        "id": 122421,
                        "name": "Mountain Lake Park",
                        "latitude": "39.39843000",
                        "longitude": "-79.38171000"
                    },
                    {
                        "id": 122519,
                        "name": "Myersville",
                        "latitude": "39.50510000",
                        "longitude": "-77.56638000"
                    },
                    {
                        "id": 122592,
                        "name": "National Harbor",
                        "latitude": "38.78264000",
                        "longitude": "-77.01506000"
                    },
                    {
                        "id": 122599,
                        "name": "Naval Academy",
                        "latitude": "38.98568000",
                        "longitude": "-76.48774000"
                    },
                    {
                        "id": 122681,
                        "name": "New Carrollton",
                        "latitude": "38.96983000",
                        "longitude": "-76.87997000"
                    },
                    {
                        "id": 122793,
                        "name": "New Windsor",
                        "latitude": "39.54205000",
                        "longitude": "-77.10804000"
                    },
                    {
                        "id": 122977,
                        "name": "North Beach",
                        "latitude": "38.70734000",
                        "longitude": "-76.53107000"
                    },
                    {
                        "id": 122979,
                        "name": "North Bel Air",
                        "latitude": "39.53983000",
                        "longitude": "-76.35496000"
                    },
                    {
                        "id": 122989,
                        "name": "North Bethesda",
                        "latitude": "39.04455000",
                        "longitude": "-77.11887000"
                    },
                    {
                        "id": 123017,
                        "name": "North East",
                        "latitude": "39.60011000",
                        "longitude": "-75.94133000"
                    },
                    {
                        "id": 123046,
                        "name": "North Kensington",
                        "latitude": "39.03039000",
                        "longitude": "-77.07248000"
                    },
                    {
                        "id": 123054,
                        "name": "North Laurel",
                        "latitude": "39.13900000",
                        "longitude": "-76.87053000"
                    },
                    {
                        "id": 123087,
                        "name": "North Potomac",
                        "latitude": "39.08289000",
                        "longitude": "-77.26498000"
                    },
                    {
                        "id": 123284,
                        "name": "Oakland",
                        "latitude": "39.40787000",
                        "longitude": "-79.40671000"
                    },
                    {
                        "id": 123326,
                        "name": "Ocean City",
                        "latitude": "38.33650000",
                        "longitude": "-75.08491000"
                    },
                    {
                        "id": 123333,
                        "name": "Ocean Pines",
                        "latitude": "38.39539000",
                        "longitude": "-75.15574000"
                    },
                    {
                        "id": 123356,
                        "name": "Odenton",
                        "latitude": "39.08400000",
                        "longitude": "-76.70025000"
                    },
                    {
                        "id": 123456,
                        "name": "Olney",
                        "latitude": "39.15316000",
                        "longitude": "-77.06692000"
                    },
                    {
                        "id": 123652,
                        "name": "Overlea",
                        "latitude": "39.36344000",
                        "longitude": "-76.52052000"
                    },
                    {
                        "id": 123668,
                        "name": "Owings",
                        "latitude": "38.71762000",
                        "longitude": "-76.60135000"
                    },
                    {
                        "id": 123669,
                        "name": "Owings Mills",
                        "latitude": "39.41955000",
                        "longitude": "-76.78025000"
                    },
                    {
                        "id": 123691,
                        "name": "Oxon Hill",
                        "latitude": "38.80345000",
                        "longitude": "-76.98970000"
                    },
                    {
                        "id": 123692,
                        "name": "Oxon Hill-Glassmanor",
                        "latitude": "38.79615000",
                        "longitude": "-76.97499000"
                    },
                    {
                        "id": 123825,
                        "name": "Paramount-Long Meadow",
                        "latitude": "39.68042000",
                        "longitude": "-77.69290000"
                    },
                    {
                        "id": 123877,
                        "name": "Parkville",
                        "latitude": "39.37733000",
                        "longitude": "-76.53969000"
                    },
                    {
                        "id": 123887,
                        "name": "Parole",
                        "latitude": "38.97956000",
                        "longitude": "-76.53052000"
                    },
                    {
                        "id": 123895,
                        "name": "Pasadena",
                        "latitude": "39.10733000",
                        "longitude": "-76.57108000"
                    },
                    {
                        "id": 124055,
                        "name": "Peppermill Village",
                        "latitude": "38.89472000",
                        "longitude": "-76.88654000"
                    },
                    {
                        "id": 124083,
                        "name": "Perry Hall",
                        "latitude": "39.41261000",
                        "longitude": "-76.46357000"
                    },
                    {
                        "id": 124085,
                        "name": "Perryman",
                        "latitude": "39.46955000",
                        "longitude": "-76.20440000"
                    },
                    {
                        "id": 124090,
                        "name": "Perryville",
                        "latitude": "39.56011000",
                        "longitude": "-76.07134000"
                    },
                    {
                        "id": 124197,
                        "name": "Pikesville",
                        "latitude": "39.37427000",
                        "longitude": "-76.72247000"
                    },
                    {
                        "id": 124305,
                        "name": "Pittsville",
                        "latitude": "38.39539000",
                        "longitude": "-75.41297000"
                    },
                    {
                        "id": 124373,
                        "name": "Pleasant Hills",
                        "latitude": "39.47955000",
                        "longitude": "-76.39413000"
                    },
                    {
                        "id": 124420,
                        "name": "Pocomoke City",
                        "latitude": "38.07568000",
                        "longitude": "-75.56798000"
                    },
                    {
                        "id": 124434,
                        "name": "Point of Rocks",
                        "latitude": "39.27594000",
                        "longitude": "-77.53915000"
                    },
                    {
                        "id": 124480,
                        "name": "Poolesville",
                        "latitude": "39.14594000",
                        "longitude": "-77.41693000"
                    },
                    {
                        "id": 124582,
                        "name": "Potomac",
                        "latitude": "39.01817000",
                        "longitude": "-77.20859000"
                    },
                    {
                        "id": 124583,
                        "name": "Potomac Heights",
                        "latitude": "38.60873000",
                        "longitude": "-77.14053000"
                    },
                    {
                        "id": 124585,
                        "name": "Potomac Park",
                        "latitude": "39.61176000",
                        "longitude": "-78.80585000"
                    },
                    {
                        "id": 124673,
                        "name": "Prince Frederick",
                        "latitude": "38.54040000",
                        "longitude": "-76.58440000"
                    },
                    {
                        "id": 124676,
                        "name": "Prince George's County",
                        "latitude": "38.82952000",
                        "longitude": "-76.84729000"
                    },
                    {
                        "id": 124679,
                        "name": "Princess Anne",
                        "latitude": "38.20290000",
                        "longitude": "-75.69243000"
                    },
                    {
                        "id": 124745,
                        "name": "Pumphrey",
                        "latitude": "39.21733000",
                        "longitude": "-76.63719000"
                    },
                    {
                        "id": 124785,
                        "name": "Queen Anne",
                        "latitude": "38.89872000",
                        "longitude": "-76.67830000"
                    },
                    {
                        "id": 124786,
                        "name": "Queen Anne's County",
                        "latitude": "39.03763000",
                        "longitude": "-76.08504000"
                    },
                    {
                        "id": 124789,
                        "name": "Queenland",
                        "latitude": "38.80524000",
                        "longitude": "-76.79126000"
                    },
                    {
                        "id": 124863,
                        "name": "Randallstown",
                        "latitude": "39.36733000",
                        "longitude": "-76.79525000"
                    },
                    {
                        "id": 124974,
                        "name": "Redland",
                        "latitude": "39.14539000",
                        "longitude": "-77.14415000"
                    },
                    {
                        "id": 125012,
                        "name": "Reisterstown",
                        "latitude": "39.46976000",
                        "longitude": "-76.83190000"
                    },
                    {
                        "id": 125125,
                        "name": "Ridgely",
                        "latitude": "38.94789000",
                        "longitude": "-75.88438000"
                    },
                    {
                        "id": 125170,
                        "name": "Rising Sun",
                        "latitude": "39.69789000",
                        "longitude": "-76.06273000"
                    },
                    {
                        "id": 125175,
                        "name": "Riva",
                        "latitude": "38.95206000",
                        "longitude": "-76.57802000"
                    },
                    {
                        "id": 125198,
                        "name": "Riverdale Park",
                        "latitude": "38.96344000",
                        "longitude": "-76.93164000"
                    },
                    {
                        "id": 125202,
                        "name": "Riverside",
                        "latitude": "39.47372000",
                        "longitude": "-76.24134000"
                    },
                    {
                        "id": 125222,
                        "name": "Riviera Beach",
                        "latitude": "39.16678000",
                        "longitude": "-76.50802000"
                    },
                    {
                        "id": 125255,
                        "name": "Robinwood",
                        "latitude": "39.63704000",
                        "longitude": "-77.65694000"
                    },
                    {
                        "id": 125278,
                        "name": "Rock Hall",
                        "latitude": "39.13817000",
                        "longitude": "-76.23495000"
                    },
                    {
                        "id": 125322,
                        "name": "Rockville",
                        "latitude": "39.08400000",
                        "longitude": "-77.15276000"
                    },
                    {
                        "id": 125398,
                        "name": "Rosaryville",
                        "latitude": "38.75678000",
                        "longitude": "-76.80969000"
                    },
                    {
                        "id": 125416,
                        "name": "Rosedale",
                        "latitude": "39.32011000",
                        "longitude": "-76.51552000"
                    },
                    {
                        "id": 125453,
                        "name": "Rossmoor",
                        "latitude": "39.10372000",
                        "longitude": "-77.07109000"
                    },
                    {
                        "id": 125458,
                        "name": "Rossville",
                        "latitude": "39.33844000",
                        "longitude": "-76.47968000"
                    },
                    {
                        "id": 125611,
                        "name": "Saint Charles",
                        "latitude": "38.60317000",
                        "longitude": "-76.93858000"
                    },
                    {
                        "id": 125652,
                        "name": "Saint James",
                        "latitude": "39.56260000",
                        "longitude": "-77.75805000"
                    },
                    {
                        "id": 125691,
                        "name": "Saint Mary's County",
                        "latitude": "38.21586000",
                        "longitude": "-76.52906000"
                    },
                    {
                        "id": 125698,
                        "name": "Saint Michaels",
                        "latitude": "38.78512000",
                        "longitude": "-76.22439000"
                    },
                    {
                        "id": 125754,
                        "name": "Salisbury",
                        "latitude": "38.36067000",
                        "longitude": "-75.59937000"
                    },
                    {
                        "id": 125971,
                        "name": "Savage",
                        "latitude": "39.13789000",
                        "longitude": "-76.82386000"
                    },
                    {
                        "id": 125994,
                        "name": "Scaggsville",
                        "latitude": "39.14511000",
                        "longitude": "-76.90025000"
                    },
                    {
                        "id": 126078,
                        "name": "Seabrook",
                        "latitude": "38.96805000",
                        "longitude": "-76.84658000"
                    },
                    {
                        "id": 126103,
                        "name": "Seat Pleasant",
                        "latitude": "38.89622000",
                        "longitude": "-76.90664000"
                    },
                    {
                        "id": 126131,
                        "name": "Selby-on-the-Bay",
                        "latitude": "38.91622000",
                        "longitude": "-76.52246000"
                    },
                    {
                        "id": 126178,
                        "name": "Severn",
                        "latitude": "39.13705000",
                        "longitude": "-76.69830000"
                    },
                    {
                        "id": 126179,
                        "name": "Severna Park",
                        "latitude": "39.07039000",
                        "longitude": "-76.54524000"
                    },
                    {
                        "id": 126207,
                        "name": "Shady Side",
                        "latitude": "38.84178000",
                        "longitude": "-76.51218000"
                    },
                    {
                        "id": 126426,
                        "name": "Silver Hill",
                        "latitude": "38.84178000",
                        "longitude": "-76.94581000"
                    },
                    {
                        "id": 126434,
                        "name": "Silver Spring",
                        "latitude": "38.99067000",
                        "longitude": "-77.02609000"
                    },
                    {
                        "id": 126524,
                        "name": "Smithsburg",
                        "latitude": "39.65482000",
                        "longitude": "-77.57277000"
                    },
                    {
                        "id": 126545,
                        "name": "Snow Hill",
                        "latitude": "38.17706000",
                        "longitude": "-75.39270000"
                    },
                    {
                        "id": 126570,
                        "name": "Solomons",
                        "latitude": "38.31846000",
                        "longitude": "-76.45412000"
                    },
                    {
                        "id": 126579,
                        "name": "Somerset",
                        "latitude": "38.96594000",
                        "longitude": "-77.09609000"
                    },
                    {
                        "id": 126586,
                        "name": "Somerset County",
                        "latitude": "38.08007000",
                        "longitude": "-75.85347000"
                    },
                    {
                        "id": 126621,
                        "name": "South Bel Air",
                        "latitude": "39.53316000",
                        "longitude": "-76.33746000"
                    },
                    {
                        "id": 126658,
                        "name": "South Gate",
                        "latitude": "39.12900000",
                        "longitude": "-76.62580000"
                    },
                    {
                        "id": 126682,
                        "name": "South Kensington",
                        "latitude": "39.01900000",
                        "longitude": "-77.07998000"
                    },
                    {
                        "id": 126686,
                        "name": "South Laurel",
                        "latitude": "39.06983000",
                        "longitude": "-76.85025000"
                    },
                    {
                        "id": 126831,
                        "name": "Spencerville",
                        "latitude": "39.11427000",
                        "longitude": "-76.97831000"
                    },
                    {
                        "id": 126872,
                        "name": "Spring Ridge",
                        "latitude": "39.40149000",
                        "longitude": "-77.35248000"
                    },
                    {
                        "id": 126884,
                        "name": "Springdale",
                        "latitude": "38.93761000",
                        "longitude": "-76.83886000"
                    },
                    {
                        "id": 127047,
                        "name": "Stevensville",
                        "latitude": "38.98067000",
                        "longitude": "-76.31440000"
                    },
                    {
                        "id": 127178,
                        "name": "Suitland",
                        "latitude": "38.84872000",
                        "longitude": "-76.92386000"
                    },
                    {
                        "id": 127179,
                        "name": "Suitland-Silver Hill",
                        "latitude": "38.84685000",
                        "longitude": "-76.92591000"
                    },
                    {
                        "id": 127203,
                        "name": "Summerfield",
                        "latitude": "38.90454000",
                        "longitude": "-76.86830000"
                    },
                    {
                        "id": 127352,
                        "name": "Sykesville",
                        "latitude": "39.37371000",
                        "longitude": "-76.96776000"
                    },
                    {
                        "id": 127382,
                        "name": "Takoma Park",
                        "latitude": "38.97789000",
                        "longitude": "-77.00748000"
                    },
                    {
                        "id": 127384,
                        "name": "Talbot County",
                        "latitude": "38.74910000",
                        "longitude": "-76.17862000"
                    },
                    {
                        "id": 127411,
                        "name": "Taneytown",
                        "latitude": "39.65788000",
                        "longitude": "-77.17443000"
                    },
                    {
                        "id": 127502,
                        "name": "Temple Hills",
                        "latitude": "38.81400000",
                        "longitude": "-76.94553000"
                    },
                    {
                        "id": 127629,
                        "name": "Thurmont",
                        "latitude": "39.62371000",
                        "longitude": "-77.41082000"
                    },
                    {
                        "id": 127663,
                        "name": "Timonium",
                        "latitude": "39.43705000",
                        "longitude": "-76.61969000"
                    },
                    {
                        "id": 127768,
                        "name": "Towson",
                        "latitude": "39.40150000",
                        "longitude": "-76.60191000"
                    },
                    {
                        "id": 127781,
                        "name": "Trappe",
                        "latitude": "38.65845000",
                        "longitude": "-76.05800000"
                    },
                    {
                        "id": 127786,
                        "name": "Travilah",
                        "latitude": "39.06900000",
                        "longitude": "-77.26304000"
                    },
                    {
                        "id": 128032,
                        "name": "University Park",
                        "latitude": "38.97039000",
                        "longitude": "-76.94192000"
                    },
                    {
                        "id": 128046,
                        "name": "Upper Marlboro",
                        "latitude": "38.81595000",
                        "longitude": "-76.74969000"
                    },
                    {
                        "id": 128060,
                        "name": "Urbana",
                        "latitude": "39.32594000",
                        "longitude": "-77.35137000"
                    },
                    {
                        "id": 128375,
                        "name": "Waldorf",
                        "latitude": "38.62456000",
                        "longitude": "-76.93914000"
                    },
                    {
                        "id": 128389,
                        "name": "Walker Mill",
                        "latitude": "38.87539000",
                        "longitude": "-76.88831000"
                    },
                    {
                        "id": 128390,
                        "name": "Walkersville",
                        "latitude": "39.48621000",
                        "longitude": "-77.35193000"
                    },
                    {
                        "id": 128560,
                        "name": "Washington County",
                        "latitude": "39.60367000",
                        "longitude": "-77.81398000"
                    },
                    {
                        "id": 128860,
                        "name": "West Elkridge",
                        "latitude": "39.20705000",
                        "longitude": "-76.72692000"
                    },
                    {
                        "id": 128912,
                        "name": "West Laurel",
                        "latitude": "39.10122000",
                        "longitude": "-76.89970000"
                    },
                    {
                        "id": 128943,
                        "name": "West Ocean City",
                        "latitude": "38.33150000",
                        "longitude": "-75.10685000"
                    },
                    {
                        "id": 129026,
                        "name": "Westernport",
                        "latitude": "39.48537000",
                        "longitude": "-79.04475000"
                    },
                    {
                        "id": 129043,
                        "name": "Westminster",
                        "latitude": "39.57538000",
                        "longitude": "-76.99581000"
                    },
                    {
                        "id": 129069,
                        "name": "Westphalia",
                        "latitude": "38.84539000",
                        "longitude": "-76.81108000"
                    },
                    {
                        "id": 129112,
                        "name": "Wheaton",
                        "latitude": "39.03983000",
                        "longitude": "-77.05526000"
                    },
                    {
                        "id": 129145,
                        "name": "White Marsh",
                        "latitude": "39.38372000",
                        "longitude": "-76.43218000"
                    },
                    {
                        "id": 129148,
                        "name": "White Oak",
                        "latitude": "39.03983000",
                        "longitude": "-76.99303000"
                    },
                    {
                        "id": 129222,
                        "name": "Wicomico County",
                        "latitude": "38.36942000",
                        "longitude": "-75.63151000"
                    },
                    {
                        "id": 129279,
                        "name": "Williamsport",
                        "latitude": "39.60065000",
                        "longitude": "-77.82055000"
                    },
                    {
                        "id": 129338,
                        "name": "Wilson-Conococheague",
                        "latitude": "39.65351000",
                        "longitude": "-77.83157000"
                    },
                    {
                        "id": 129534,
                        "name": "Woodlawn",
                        "latitude": "39.32288000",
                        "longitude": "-76.72803000"
                    },
                    {
                        "id": 129544,
                        "name": "Woodmore",
                        "latitude": "38.92122000",
                        "longitude": "-76.80303000"
                    },
                    {
                        "id": 129552,
                        "name": "Woodsboro",
                        "latitude": "39.53316000",
                        "longitude": "-77.31471000"
                    },
                    {
                        "id": 129586,
                        "name": "Worcester County",
                        "latitude": "38.21650000",
                        "longitude": "-75.29667000"
                    }
                ]
            },
            {
                "id": 1433,
                "name": "Massachusetts",
                "iso2": "MA",
                "latitude": "42.40721070",
                "longitude": "-71.38243740",
                "type": "state",
                "cities": [
                    {
                        "id": 110986,
                        "name": "Abington",
                        "latitude": "42.10482000",
                        "longitude": "-70.94532000"
                    },
                    {
                        "id": 110999,
                        "name": "Acton",
                        "latitude": "42.48509000",
                        "longitude": "-71.43284000"
                    },
                    {
                        "id": 111002,
                        "name": "Acushnet",
                        "latitude": "41.68066000",
                        "longitude": "-70.90782000"
                    },
                    {
                        "id": 111003,
                        "name": "Acushnet Center",
                        "latitude": "41.68508000",
                        "longitude": "-70.90642000"
                    },
                    {
                        "id": 111013,
                        "name": "Adams",
                        "latitude": "42.62425000",
                        "longitude": "-73.11760000"
                    },
                    {
                        "id": 111055,
                        "name": "Agawam",
                        "latitude": "42.06954000",
                        "longitude": "-72.61481000"
                    },
                    {
                        "id": 111279,
                        "name": "Amesbury",
                        "latitude": "42.85842000",
                        "longitude": "-70.93005000"
                    },
                    {
                        "id": 111282,
                        "name": "Amherst",
                        "latitude": "42.36723000",
                        "longitude": "-72.51852000"
                    },
                    {
                        "id": 111285,
                        "name": "Amherst Center",
                        "latitude": "42.37537000",
                        "longitude": "-72.51925000"
                    },
                    {
                        "id": 111323,
                        "name": "Andover",
                        "latitude": "42.65843000",
                        "longitude": "-71.13700000"
                    },
                    {
                        "id": 111465,
                        "name": "Arlington",
                        "latitude": "42.41537000",
                        "longitude": "-71.15644000"
                    },
                    {
                        "id": 111516,
                        "name": "Ashburnham",
                        "latitude": "42.63620000",
                        "longitude": "-71.90785000"
                    },
                    {
                        "id": 111517,
                        "name": "Ashby",
                        "latitude": "42.67787000",
                        "longitude": "-71.82035000"
                    },
                    {
                        "id": 111523,
                        "name": "Ashfield",
                        "latitude": "42.52647000",
                        "longitude": "-72.78843000"
                    },
                    {
                        "id": 111534,
                        "name": "Ashland",
                        "latitude": "42.26121000",
                        "longitude": "-71.46340000"
                    },
                    {
                        "id": 111556,
                        "name": "Assonet",
                        "latitude": "41.79594000",
                        "longitude": "-71.06782000"
                    },
                    {
                        "id": 111583,
                        "name": "Athol",
                        "latitude": "42.59592000",
                        "longitude": "-72.22675000"
                    },
                    {
                        "id": 111611,
                        "name": "Attleboro",
                        "latitude": "41.94454000",
                        "longitude": "-71.28561000"
                    },
                    {
                        "id": 111624,
                        "name": "Auburn",
                        "latitude": "42.19454000",
                        "longitude": "-71.83563000"
                    },
                    {
                        "id": 111691,
                        "name": "Avon",
                        "latitude": "42.13066000",
                        "longitude": "-71.04116000"
                    },
                    {
                        "id": 111708,
                        "name": "Ayer",
                        "latitude": "42.56120000",
                        "longitude": "-71.58979000"
                    },
                    {
                        "id": 111765,
                        "name": "Baldwinville",
                        "latitude": "42.60842000",
                        "longitude": "-72.07591000"
                    },
                    {
                        "id": 111834,
                        "name": "Barnstable",
                        "latitude": "41.70011000",
                        "longitude": "-70.29947000"
                    },
                    {
                        "id": 111835,
                        "name": "Barnstable County",
                        "latitude": "41.68419000",
                        "longitude": "-70.27405000"
                    },
                    {
                        "id": 111841,
                        "name": "Barre",
                        "latitude": "42.42287000",
                        "longitude": "-72.10508000"
                    },
                    {
                        "id": 112014,
                        "name": "Becket",
                        "latitude": "42.33203000",
                        "longitude": "-73.08288000"
                    },
                    {
                        "id": 112023,
                        "name": "Bedford",
                        "latitude": "42.49065000",
                        "longitude": "-71.27617000"
                    },
                    {
                        "id": 112051,
                        "name": "Belchertown",
                        "latitude": "42.27704000",
                        "longitude": "-72.40092000"
                    },
                    {
                        "id": 112119,
                        "name": "Bellingham",
                        "latitude": "42.08676000",
                        "longitude": "-71.47451000"
                    },
                    {
                        "id": 112138,
                        "name": "Belmont",
                        "latitude": "42.39593000",
                        "longitude": "-71.17867000"
                    },
                    {
                        "id": 112229,
                        "name": "Berkley",
                        "latitude": "41.84593000",
                        "longitude": "-71.08282000"
                    },
                    {
                        "id": 112233,
                        "name": "Berkshire County",
                        "latitude": "42.37067000",
                        "longitude": "-73.20640000"
                    },
                    {
                        "id": 112237,
                        "name": "Berlin",
                        "latitude": "42.38120000",
                        "longitude": "-71.63701000"
                    },
                    {
                        "id": 112244,
                        "name": "Bernardston",
                        "latitude": "42.67092000",
                        "longitude": "-72.54953000"
                    },
                    {
                        "id": 112300,
                        "name": "Beverly",
                        "latitude": "42.55843000",
                        "longitude": "-70.88005000"
                    },
                    {
                        "id": 112302,
                        "name": "Beverly Cove",
                        "latitude": "42.55343000",
                        "longitude": "-70.85366000"
                    },
                    {
                        "id": 112342,
                        "name": "Billerica",
                        "latitude": "42.55843000",
                        "longitude": "-71.26895000"
                    },
                    {
                        "id": 112393,
                        "name": "Blackstone",
                        "latitude": "42.01788000",
                        "longitude": "-71.54117000"
                    },
                    {
                        "id": 112430,
                        "name": "Bliss Corner",
                        "latitude": "41.61177000",
                        "longitude": "-70.93837000"
                    },
                    {
                        "id": 112525,
                        "name": "Bolton",
                        "latitude": "42.43343000",
                        "longitude": "-71.60784000"
                    },
                    {
                        "id": 112532,
                        "name": "Bondsville",
                        "latitude": "42.21259000",
                        "longitude": "-72.34536000"
                    },
                    {
                        "id": 112589,
                        "name": "Boston",
                        "latitude": "42.35843000",
                        "longitude": "-71.05977000"
                    },
                    {
                        "id": 112617,
                        "name": "Bourne",
                        "latitude": "41.74122000",
                        "longitude": "-70.59892000"
                    },
                    {
                        "id": 112638,
                        "name": "Boxborough",
                        "latitude": "42.49084000",
                        "longitude": "-71.52851000"
                    },
                    {
                        "id": 112639,
                        "name": "Boxford",
                        "latitude": "42.66120000",
                        "longitude": "-70.99672000"
                    },
                    {
                        "id": 112650,
                        "name": "Boylston",
                        "latitude": "42.39176000",
                        "longitude": "-71.70368000"
                    },
                    {
                        "id": 112682,
                        "name": "Braintree",
                        "latitude": "42.20384000",
                        "longitude": "-71.00215000"
                    },
                    {
                        "id": 112741,
                        "name": "Brewster",
                        "latitude": "41.76011000",
                        "longitude": "-70.08280000"
                    },
                    {
                        "id": 112775,
                        "name": "Bridgewater",
                        "latitude": "41.99038000",
                        "longitude": "-70.97504000"
                    },
                    {
                        "id": 112797,
                        "name": "Brimfield",
                        "latitude": "42.12287000",
                        "longitude": "-72.20091000"
                    },
                    {
                        "id": 112814,
                        "name": "Bristol County",
                        "latitude": "41.75709000",
                        "longitude": "-71.08852000"
                    },
                    {
                        "id": 112834,
                        "name": "Brockton",
                        "latitude": "42.08343000",
                        "longitude": "-71.01838000"
                    },
                    {
                        "id": 112867,
                        "name": "Brookline",
                        "latitude": "42.33176000",
                        "longitude": "-71.12116000"
                    },
                    {
                        "id": 112987,
                        "name": "Buckland",
                        "latitude": "42.59231000",
                        "longitude": "-72.79176000"
                    },
                    {
                        "id": 113070,
                        "name": "Burlington",
                        "latitude": "42.50482000",
                        "longitude": "-71.19561000"
                    },
                    {
                        "id": 113133,
                        "name": "Buzzards Bay",
                        "latitude": "41.74538000",
                        "longitude": "-70.61809000"
                    },
                    {
                        "id": 113252,
                        "name": "Cambridge",
                        "latitude": "42.37510000",
                        "longitude": "-71.10561000"
                    },
                    {
                        "id": 113344,
                        "name": "Canton",
                        "latitude": "42.15843000",
                        "longitude": "-71.14477000"
                    },
                    {
                        "id": 113404,
                        "name": "Carlisle",
                        "latitude": "42.52926000",
                        "longitude": "-71.34950000"
                    },
                    {
                        "id": 113500,
                        "name": "Carver",
                        "latitude": "41.88344000",
                        "longitude": "-70.76254000"
                    },
                    {
                        "id": 113659,
                        "name": "Centerville",
                        "latitude": "41.64872000",
                        "longitude": "-70.34808000"
                    },
                    {
                        "id": 113752,
                        "name": "Charlemont",
                        "latitude": "42.62786000",
                        "longitude": "-72.86982000"
                    },
                    {
                        "id": 113788,
                        "name": "Charlton",
                        "latitude": "42.13565000",
                        "longitude": "-71.97007000"
                    },
                    {
                        "id": 113798,
                        "name": "Chatham",
                        "latitude": "41.68206000",
                        "longitude": "-69.95974000"
                    },
                    {
                        "id": 113828,
                        "name": "Chelmsford",
                        "latitude": "42.59981000",
                        "longitude": "-71.36728000"
                    },
                    {
                        "id": 113831,
                        "name": "Chelsea",
                        "latitude": "42.39176000",
                        "longitude": "-71.03283000"
                    },
                    {
                        "id": 113904,
                        "name": "Chesterfield",
                        "latitude": "42.39175000",
                        "longitude": "-72.83982000"
                    },
                    {
                        "id": 113945,
                        "name": "Chicopee",
                        "latitude": "42.14870000",
                        "longitude": "-72.60787000"
                    },
                    {
                        "id": 114280,
                        "name": "Clinton",
                        "latitude": "42.41676000",
                        "longitude": "-71.68285000"
                    },
                    {
                        "id": 114350,
                        "name": "Cochituate",
                        "latitude": "42.32093000",
                        "longitude": "-71.36423000"
                    },
                    {
                        "id": 114372,
                        "name": "Cohasset",
                        "latitude": "42.24177000",
                        "longitude": "-70.80365000"
                    },
                    {
                        "id": 114461,
                        "name": "Colrain",
                        "latitude": "42.67314000",
                        "longitude": "-72.69676000"
                    },
                    {
                        "id": 114538,
                        "name": "Concord",
                        "latitude": "42.46037000",
                        "longitude": "-71.34895000"
                    },
                    {
                        "id": 114584,
                        "name": "Conway",
                        "latitude": "42.50981000",
                        "longitude": "-72.69953000"
                    },
                    {
                        "id": 114634,
                        "name": "Cordaville",
                        "latitude": "42.26898000",
                        "longitude": "-71.52395000"
                    },
                    {
                        "id": 114707,
                        "name": "Cotuit",
                        "latitude": "41.61678000",
                        "longitude": "-70.43697000"
                    },
                    {
                        "id": 115002,
                        "name": "Dalton",
                        "latitude": "42.47370000",
                        "longitude": "-73.16621000"
                    },
                    {
                        "id": 115029,
                        "name": "Danvers",
                        "latitude": "42.57509000",
                        "longitude": "-70.93005000"
                    },
                    {
                        "id": 149310,
                        "name": "Dartmouth",
                        "latitude": "41.59419180",
                        "longitude": "-71.11043520"
                    },
                    {
                        "id": 115167,
                        "name": "Dedham",
                        "latitude": "42.24177000",
                        "longitude": "-71.16616000"
                    },
                    {
                        "id": 115242,
                        "name": "Dennis",
                        "latitude": "41.73539000",
                        "longitude": "-70.19391000"
                    },
                    {
                        "id": 115243,
                        "name": "Dennis Port",
                        "latitude": "41.65845000",
                        "longitude": "-70.12863000"
                    },
                    {
                        "id": 115296,
                        "name": "Devens",
                        "latitude": "42.54470000",
                        "longitude": "-71.61318000"
                    },
                    {
                        "id": 115335,
                        "name": "Dighton",
                        "latitude": "41.81399000",
                        "longitude": "-71.12032000"
                    },
                    {
                        "id": 115421,
                        "name": "Douglas",
                        "latitude": "42.05426000",
                        "longitude": "-71.73951000"
                    },
                    {
                        "id": 115448,
                        "name": "Dover",
                        "latitude": "42.24593000",
                        "longitude": "-71.28283000"
                    },
                    {
                        "id": 115466,
                        "name": "Dracut",
                        "latitude": "42.67037000",
                        "longitude": "-71.30201000"
                    },
                    {
                        "id": 115505,
                        "name": "Dudley",
                        "latitude": "42.04510000",
                        "longitude": "-71.93007000"
                    },
                    {
                        "id": 115508,
                        "name": "Dukes County",
                        "latitude": "41.38877000",
                        "longitude": "-70.69877000"
                    },
                    {
                        "id": 115554,
                        "name": "Dunstable",
                        "latitude": "42.67509000",
                        "longitude": "-71.48284000"
                    },
                    {
                        "id": 115583,
                        "name": "Duxbury",
                        "latitude": "42.04177000",
                        "longitude": "-70.67226000"
                    },
                    {
                        "id": 115637,
                        "name": "East Bridgewater",
                        "latitude": "42.03343000",
                        "longitude": "-70.95921000"
                    },
                    {
                        "id": 115639,
                        "name": "East Brookfield",
                        "latitude": "42.22787000",
                        "longitude": "-72.04674000"
                    },
                    {
                        "id": 115649,
                        "name": "East Dennis",
                        "latitude": "41.74261000",
                        "longitude": "-70.16196000"
                    },
                    {
                        "id": 115650,
                        "name": "East Douglas",
                        "latitude": "42.07232000",
                        "longitude": "-71.71340000"
                    },
                    {
                        "id": 115657,
                        "name": "East Falmouth",
                        "latitude": "41.57844000",
                        "longitude": "-70.55864000"
                    },
                    {
                        "id": 115685,
                        "name": "East Harwich",
                        "latitude": "41.70011000",
                        "longitude": "-70.02724000"
                    },
                    {
                        "id": 115705,
                        "name": "East Longmeadow",
                        "latitude": "42.06454000",
                        "longitude": "-72.51259000"
                    },
                    {
                        "id": 115733,
                        "name": "East Pepperell",
                        "latitude": "42.66537000",
                        "longitude": "-71.57312000"
                    },
                    {
                        "id": 115756,
                        "name": "East Sandwich",
                        "latitude": "41.74177000",
                        "longitude": "-70.45169000"
                    },
                    {
                        "id": 115778,
                        "name": "Eastham",
                        "latitude": "41.83011000",
                        "longitude": "-69.97391000"
                    },
                    {
                        "id": 115779,
                        "name": "Easthampton",
                        "latitude": "42.26676000",
                        "longitude": "-72.66898000"
                    },
                    {
                        "id": 115787,
                        "name": "Easton",
                        "latitude": "42.02454000",
                        "longitude": "-71.12866000"
                    },
                    {
                        "id": 115838,
                        "name": "Edgartown",
                        "latitude": "41.38901000",
                        "longitude": "-70.51336000"
                    },
                    {
                        "id": 116174,
                        "name": "Erving",
                        "latitude": "42.60009000",
                        "longitude": "-72.39814000"
                    },
                    {
                        "id": 116192,
                        "name": "Essex",
                        "latitude": "42.63204000",
                        "longitude": "-70.78283000"
                    },
                    {
                        "id": 116194,
                        "name": "Essex County",
                        "latitude": "42.63887000",
                        "longitude": "-70.86792000"
                    },
                    {
                        "id": 116258,
                        "name": "Everett",
                        "latitude": "42.40843000",
                        "longitude": "-71.05366000"
                    },
                    {
                        "id": 116325,
                        "name": "Fairhaven",
                        "latitude": "41.63760000",
                        "longitude": "-70.90365000"
                    },
                    {
                        "id": 116373,
                        "name": "Fall River",
                        "latitude": "41.70149000",
                        "longitude": "-71.15505000"
                    },
                    {
                        "id": 116388,
                        "name": "Falmouth",
                        "latitude": "41.55150000",
                        "longitude": "-70.61475000"
                    },
                    {
                        "id": 116533,
                        "name": "Fiskdale",
                        "latitude": "42.11621000",
                        "longitude": "-72.11341000"
                    },
                    {
                        "id": 116534,
                        "name": "Fitchburg",
                        "latitude": "42.58342000",
                        "longitude": "-71.80230000"
                    },
                    {
                        "id": 116670,
                        "name": "Forestdale",
                        "latitude": "41.69177000",
                        "longitude": "-70.49947000"
                    },
                    {
                        "id": 116809,
                        "name": "Foxborough",
                        "latitude": "42.06538000",
                        "longitude": "-71.24783000"
                    },
                    {
                        "id": 116811,
                        "name": "Framingham",
                        "latitude": "42.27926000",
                        "longitude": "-71.41617000"
                    },
                    {
                        "id": 116812,
                        "name": "Framingham Center",
                        "latitude": "42.29732000",
                        "longitude": "-71.43701000"
                    },
                    {
                        "id": 116834,
                        "name": "Franklin",
                        "latitude": "42.08343000",
                        "longitude": "-71.39673000"
                    },
                    {
                        "id": 116858,
                        "name": "Franklin County",
                        "latitude": "42.58312000",
                        "longitude": "-72.59187000"
                    },
                    {
                        "id": 116918,
                        "name": "Freetown",
                        "latitude": "41.76677000",
                        "longitude": "-71.03282000"
                    },
                    {
                        "id": 117075,
                        "name": "Gardner",
                        "latitude": "42.57509000",
                        "longitude": "-71.99813000"
                    },
                    {
                        "id": 117213,
                        "name": "Gill",
                        "latitude": "42.64036000",
                        "longitude": "-72.49953000"
                    },
                    {
                        "id": 117322,
                        "name": "Gloucester",
                        "latitude": "42.61405000",
                        "longitude": "-70.66313000"
                    },
                    {
                        "id": 117429,
                        "name": "Grafton",
                        "latitude": "42.20704000",
                        "longitude": "-71.68562000"
                    },
                    {
                        "id": 117447,
                        "name": "Granby",
                        "latitude": "42.25648000",
                        "longitude": "-72.51620000"
                    },
                    {
                        "id": 117534,
                        "name": "Granville",
                        "latitude": "42.06676000",
                        "longitude": "-72.86149000"
                    },
                    {
                        "id": 117569,
                        "name": "Great Barrington",
                        "latitude": "42.19592000",
                        "longitude": "-73.36206000"
                    },
                    {
                        "id": 117596,
                        "name": "Green Harbor-Cedar Crest",
                        "latitude": "42.07495000",
                        "longitude": "-70.65843000"
                    },
                    {
                        "id": 117650,
                        "name": "Greenfield",
                        "latitude": "42.58759000",
                        "longitude": "-72.59953000"
                    },
                    {
                        "id": 117752,
                        "name": "Groton",
                        "latitude": "42.61120000",
                        "longitude": "-71.57451000"
                    },
                    {
                        "id": 117759,
                        "name": "Groveland",
                        "latitude": "42.76037000",
                        "longitude": "-71.03145000"
                    },
                    {
                        "id": 117833,
                        "name": "Hadley",
                        "latitude": "42.34176000",
                        "longitude": "-72.58842000"
                    },
                    {
                        "id": 117861,
                        "name": "Halifax",
                        "latitude": "41.99121000",
                        "longitude": "-70.86199000"
                    },
                    {
                        "id": 117906,
                        "name": "Hamilton Worcester",
                        "latitude": "42.25620000",
                        "longitude": "-71.76757000"
                    },
                    {
                        "id": 117916,
                        "name": "Hampden",
                        "latitude": "42.06398000",
                        "longitude": "-72.41342000"
                    },
                    {
                        "id": 117918,
                        "name": "Hampden County",
                        "latitude": "42.13511000",
                        "longitude": "-72.63162000"
                    },
                    {
                        "id": 117922,
                        "name": "Hampshire County",
                        "latitude": "42.34014000",
                        "longitude": "-72.66377000"
                    },
                    {
                        "id": 117970,
                        "name": "Hanover",
                        "latitude": "42.11316000",
                        "longitude": "-70.81199000"
                    },
                    {
                        "id": 117978,
                        "name": "Hanson",
                        "latitude": "42.07510000",
                        "longitude": "-70.88004000"
                    },
                    {
                        "id": 118008,
                        "name": "Hardwick",
                        "latitude": "42.35009000",
                        "longitude": "-72.19952000"
                    },
                    {
                        "id": 118109,
                        "name": "Harvard",
                        "latitude": "42.50009000",
                        "longitude": "-71.58284000"
                    },
                    {
                        "id": 118117,
                        "name": "Harwich",
                        "latitude": "41.68622000",
                        "longitude": "-70.07585000"
                    },
                    {
                        "id": 118118,
                        "name": "Harwich Center",
                        "latitude": "41.69235000",
                        "longitude": "-70.06938000"
                    },
                    {
                        "id": 118119,
                        "name": "Harwich Port",
                        "latitude": "41.66678000",
                        "longitude": "-70.07863000"
                    },
                    {
                        "id": 118138,
                        "name": "Hatfield",
                        "latitude": "42.37092000",
                        "longitude": "-72.59814000"
                    },
                    {
                        "id": 118150,
                        "name": "Haverhill",
                        "latitude": "42.77620000",
                        "longitude": "-71.07728000"
                    },
                    {
                        "id": 118214,
                        "name": "Head of Westport",
                        "latitude": "41.62094000",
                        "longitude": "-71.06199000"
                    },
                    {
                        "id": 118483,
                        "name": "Hingham",
                        "latitude": "42.24177000",
                        "longitude": "-70.88977000"
                    },
                    {
                        "id": 118484,
                        "name": "Hinsdale",
                        "latitude": "42.43870000",
                        "longitude": "-73.12538000"
                    },
                    {
                        "id": 118517,
                        "name": "Holbrook",
                        "latitude": "42.15510000",
                        "longitude": "-71.00866000"
                    },
                    {
                        "id": 118523,
                        "name": "Holden",
                        "latitude": "42.35176000",
                        "longitude": "-71.86341000"
                    },
                    {
                        "id": 118538,
                        "name": "Holland",
                        "latitude": "42.06398000",
                        "longitude": "-72.15730000"
                    },
                    {
                        "id": 118553,
                        "name": "Holliston",
                        "latitude": "42.20010000",
                        "longitude": "-71.42450000"
                    },
                    {
                        "id": 118583,
                        "name": "Holyoke",
                        "latitude": "42.20426000",
                        "longitude": "-72.61620000"
                    },
                    {
                        "id": 118647,
                        "name": "Hopedale",
                        "latitude": "42.13065000",
                        "longitude": "-71.54117000"
                    },
                    {
                        "id": 118656,
                        "name": "Hopkinton",
                        "latitude": "42.22871000",
                        "longitude": "-71.52256000"
                    },
                    {
                        "id": 118695,
                        "name": "Housatonic",
                        "latitude": "42.25425000",
                        "longitude": "-73.36622000"
                    },
                    {
                        "id": 118734,
                        "name": "Hubbardston",
                        "latitude": "42.47370000",
                        "longitude": "-72.00619000"
                    },
                    {
                        "id": 118740,
                        "name": "Hudson",
                        "latitude": "42.39176000",
                        "longitude": "-71.56618000"
                    },
                    {
                        "id": 118772,
                        "name": "Hull",
                        "latitude": "42.30204000",
                        "longitude": "-70.90782000"
                    },
                    {
                        "id": 118842,
                        "name": "Hyannis",
                        "latitude": "41.65289000",
                        "longitude": "-70.28280000"
                    },
                    {
                        "id": 118982,
                        "name": "Ipswich",
                        "latitude": "42.67926000",
                        "longitude": "-70.84116000"
                    },
                    {
                        "id": 119114,
                        "name": "Jamaica Plain",
                        "latitude": "42.30982000",
                        "longitude": "-71.12033000"
                    },
                    {
                        "id": 119623,
                        "name": "Kingston",
                        "latitude": "41.99455000",
                        "longitude": "-70.72448000"
                    },
                    {
                        "id": 120083,
                        "name": "Lancaster",
                        "latitude": "42.45565000",
                        "longitude": "-71.67312000"
                    },
                    {
                        "id": 120107,
                        "name": "Lanesborough",
                        "latitude": "42.51731000",
                        "longitude": "-73.22816000"
                    },
                    {
                        "id": 120227,
                        "name": "Lawrence",
                        "latitude": "42.70704000",
                        "longitude": "-71.16311000"
                    },
                    {
                        "id": 120303,
                        "name": "Lee",
                        "latitude": "42.30425000",
                        "longitude": "-73.24816000"
                    },
                    {
                        "id": 120337,
                        "name": "Leicester",
                        "latitude": "42.24593000",
                        "longitude": "-71.90868000"
                    },
                    {
                        "id": 120376,
                        "name": "Lenox",
                        "latitude": "42.35648000",
                        "longitude": "-73.28483000"
                    },
                    {
                        "id": 120382,
                        "name": "Leominster",
                        "latitude": "42.52509000",
                        "longitude": "-71.75979000"
                    },
                    {
                        "id": 120406,
                        "name": "Leverett",
                        "latitude": "42.45203000",
                        "longitude": "-72.50148000"
                    },
                    {
                        "id": 120448,
                        "name": "Lexington",
                        "latitude": "42.44732000",
                        "longitude": "-71.22450000"
                    },
                    {
                        "id": 120504,
                        "name": "Lincoln",
                        "latitude": "42.42593000",
                        "longitude": "-71.30395000"
                    },
                    {
                        "id": 120637,
                        "name": "Littleton Common",
                        "latitude": "42.54593000",
                        "longitude": "-71.47451000"
                    },
                    {
                        "id": 120753,
                        "name": "Longmeadow",
                        "latitude": "42.05010000",
                        "longitude": "-72.58287000"
                    },
                    {
                        "id": 120836,
                        "name": "Lowell",
                        "latitude": "42.63342000",
                        "longitude": "-71.31617000"
                    },
                    {
                        "id": 120870,
                        "name": "Ludlow",
                        "latitude": "42.16009000",
                        "longitude": "-72.47592000"
                    },
                    {
                        "id": 120887,
                        "name": "Lunenburg",
                        "latitude": "42.59453000",
                        "longitude": "-71.72452000"
                    },
                    {
                        "id": 120927,
                        "name": "Lynn",
                        "latitude": "42.46676000",
                        "longitude": "-70.94949000"
                    },
                    {
                        "id": 120930,
                        "name": "Lynnfield",
                        "latitude": "42.53898000",
                        "longitude": "-71.04811000"
                    },
                    {
                        "id": 121060,
                        "name": "Malden",
                        "latitude": "42.42510000",
                        "longitude": "-71.06616000"
                    },
                    {
                        "id": 121104,
                        "name": "Manchester-by-the-Sea",
                        "latitude": "42.57787000",
                        "longitude": "-70.76894000"
                    },
                    {
                        "id": 121146,
                        "name": "Mansfield",
                        "latitude": "42.03343000",
                        "longitude": "-71.21894000"
                    },
                    {
                        "id": 121148,
                        "name": "Mansfield Center",
                        "latitude": "42.02262000",
                        "longitude": "-71.21808000"
                    },
                    {
                        "id": 121189,
                        "name": "Marblehead",
                        "latitude": "42.50010000",
                        "longitude": "-70.85783000"
                    },
                    {
                        "id": 121242,
                        "name": "Marion",
                        "latitude": "41.70010000",
                        "longitude": "-70.76281000"
                    },
                    {
                        "id": 121246,
                        "name": "Marion Center",
                        "latitude": "41.70424000",
                        "longitude": "-70.76286000"
                    },
                    {
                        "id": 121280,
                        "name": "Marlborough",
                        "latitude": "42.34593000",
                        "longitude": "-71.55229000"
                    },
                    {
                        "id": 121326,
                        "name": "Marshfield",
                        "latitude": "42.09177000",
                        "longitude": "-70.70559000"
                    },
                    {
                        "id": 121328,
                        "name": "Marshfield Hills",
                        "latitude": "42.14594000",
                        "longitude": "-70.73976000"
                    },
                    {
                        "id": 121331,
                        "name": "Marstons Mills",
                        "latitude": "41.65622000",
                        "longitude": "-70.41614000"
                    },
                    {
                        "id": 121370,
                        "name": "Mashpee",
                        "latitude": "41.64844000",
                        "longitude": "-70.48114000"
                    },
                    {
                        "id": 121407,
                        "name": "Mattapoisett",
                        "latitude": "41.65844000",
                        "longitude": "-70.81615000"
                    },
                    {
                        "id": 121408,
                        "name": "Mattapoisett Center",
                        "latitude": "41.66595000",
                        "longitude": "-70.80720000"
                    },
                    {
                        "id": 121440,
                        "name": "Maynard",
                        "latitude": "42.43343000",
                        "longitude": "-71.44951000"
                    },
                    {
                        "id": 121590,
                        "name": "Medfield",
                        "latitude": "42.18760000",
                        "longitude": "-71.30645000"
                    },
                    {
                        "id": 121592,
                        "name": "Medford",
                        "latitude": "42.41843000",
                        "longitude": "-71.10616000"
                    },
                    {
                        "id": 121610,
                        "name": "Medway",
                        "latitude": "42.14176000",
                        "longitude": "-71.39673000"
                    },
                    {
                        "id": 121628,
                        "name": "Melrose",
                        "latitude": "42.45843000",
                        "longitude": "-71.06616000"
                    },
                    {
                        "id": 121653,
                        "name": "Mendon",
                        "latitude": "42.10565000",
                        "longitude": "-71.55229000"
                    },
                    {
                        "id": 121710,
                        "name": "Merrimac",
                        "latitude": "42.83065000",
                        "longitude": "-71.00228000"
                    },
                    {
                        "id": 121734,
                        "name": "Methuen",
                        "latitude": "42.72620000",
                        "longitude": "-71.19089000"
                    },
                    {
                        "id": 121765,
                        "name": "Middleborough",
                        "latitude": "41.89316000",
                        "longitude": "-70.91115000"
                    },
                    {
                        "id": 121766,
                        "name": "Middleborough Center",
                        "latitude": "41.89460000",
                        "longitude": "-70.92618000"
                    },
                    {
                        "id": 121780,
                        "name": "Middlesex County",
                        "latitude": "42.48555000",
                        "longitude": "-71.39184000"
                    },
                    {
                        "id": 121782,
                        "name": "Middleton",
                        "latitude": "42.59509000",
                        "longitude": "-71.01616000"
                    },
                    {
                        "id": 121850,
                        "name": "Milford",
                        "latitude": "42.13982000",
                        "longitude": "-71.51617000"
                    },
                    {
                        "id": 121874,
                        "name": "Millbury",
                        "latitude": "42.19398000",
                        "longitude": "-71.76007000"
                    },
                    {
                        "id": 121885,
                        "name": "Millers Falls",
                        "latitude": "42.58203000",
                        "longitude": "-72.49259000"
                    },
                    {
                        "id": 121894,
                        "name": "Millis",
                        "latitude": "42.16760000",
                        "longitude": "-71.35784000"
                    },
                    {
                        "id": 121895,
                        "name": "Millis-Clicquot",
                        "latitude": "42.16480000",
                        "longitude": "-71.35442000"
                    },
                    {
                        "id": 121905,
                        "name": "Millville",
                        "latitude": "42.02788000",
                        "longitude": "-71.58090000"
                    },
                    {
                        "id": 121915,
                        "name": "Milton",
                        "latitude": "42.24954000",
                        "longitude": "-71.06616000"
                    },
                    {
                        "id": 122090,
                        "name": "Monson",
                        "latitude": "42.10426000",
                        "longitude": "-72.31897000"
                    },
                    {
                        "id": 122091,
                        "name": "Monson Center",
                        "latitude": "42.09898000",
                        "longitude": "-72.30481000"
                    },
                    {
                        "id": 122096,
                        "name": "Montague",
                        "latitude": "42.53564000",
                        "longitude": "-72.53509000"
                    },
                    {
                        "id": 122192,
                        "name": "Monument Beach",
                        "latitude": "41.71955000",
                        "longitude": "-70.61198000"
                    },
                    {
                        "id": 122535,
                        "name": "Nahant",
                        "latitude": "42.42649000",
                        "longitude": "-70.91894000"
                    },
                    {
                        "id": 122542,
                        "name": "Nantucket",
                        "latitude": "41.28346000",
                        "longitude": "-70.09946000"
                    },
                    {
                        "id": 122543,
                        "name": "Nantucket County",
                        "latitude": "41.26955000",
                        "longitude": "-70.02171000"
                    },
                    {
                        "id": 122590,
                        "name": "Natick",
                        "latitude": "42.28343000",
                        "longitude": "-71.34950000"
                    },
                    {
                        "id": 122613,
                        "name": "Needham",
                        "latitude": "42.28343000",
                        "longitude": "-71.23283000"
                    },
                    {
                        "id": 122662,
                        "name": "New Bedford",
                        "latitude": "41.63526000",
                        "longitude": "-70.92701000"
                    },
                    {
                        "id": 122752,
                        "name": "New Marlborough",
                        "latitude": "42.12287000",
                        "longitude": "-73.22872000"
                    },
                    {
                        "id": 122819,
                        "name": "Newburyport",
                        "latitude": "42.81259000",
                        "longitude": "-70.87728000"
                    },
                    {
                        "id": 122865,
                        "name": "Newton",
                        "latitude": "42.33704000",
                        "longitude": "-71.20922000"
                    },
                    {
                        "id": 122942,
                        "name": "Norfolk",
                        "latitude": "42.11954000",
                        "longitude": "-71.32506000"
                    },
                    {
                        "id": 122945,
                        "name": "Norfolk County",
                        "latitude": "42.17097000",
                        "longitude": "-71.18381000"
                    },
                    {
                        "id": 122958,
                        "name": "North Adams",
                        "latitude": "42.70092000",
                        "longitude": "-73.10871000"
                    },
                    {
                        "id": 122960,
                        "name": "North Amherst",
                        "latitude": "42.41037000",
                        "longitude": "-72.53092000"
                    },
                    {
                        "id": 122962,
                        "name": "North Andover",
                        "latitude": "42.69870000",
                        "longitude": "-71.13506000"
                    },
                    {
                        "id": 122967,
                        "name": "North Attleborough Center",
                        "latitude": "41.97263000",
                        "longitude": "-71.32474000"
                    },
                    {
                        "id": 122996,
                        "name": "North Brookfield",
                        "latitude": "42.26676000",
                        "longitude": "-72.08285000"
                    },
                    {
                        "id": 123007,
                        "name": "North Chicopee",
                        "latitude": "42.18343000",
                        "longitude": "-72.59953000"
                    },
                    {
                        "id": 123019,
                        "name": "North Eastham",
                        "latitude": "41.86511000",
                        "longitude": "-69.99113000"
                    },
                    {
                        "id": 123025,
                        "name": "North Falmouth",
                        "latitude": "41.64594000",
                        "longitude": "-70.61836000"
                    },
                    {
                        "id": 123051,
                        "name": "North Lakeville",
                        "latitude": "41.85760000",
                        "longitude": "-70.94226000"
                    },
                    {
                        "id": 123078,
                        "name": "North Pembroke",
                        "latitude": "42.09316000",
                        "longitude": "-70.79254000"
                    },
                    {
                        "id": 123083,
                        "name": "North Plymouth",
                        "latitude": "41.97094000",
                        "longitude": "-70.68281000"
                    },
                    {
                        "id": 123091,
                        "name": "North Reading",
                        "latitude": "42.57509000",
                        "longitude": "-71.07867000"
                    },
                    {
                        "id": 123101,
                        "name": "North Scituate",
                        "latitude": "42.21899000",
                        "longitude": "-70.78560000"
                    },
                    {
                        "id": 123104,
                        "name": "North Seekonk",
                        "latitude": "41.88927000",
                        "longitude": "-71.33005000"
                    },
                    {
                        "id": 123128,
                        "name": "North Westport",
                        "latitude": "41.66038000",
                        "longitude": "-71.08838000"
                    },
                    {
                        "id": 123134,
                        "name": "Northampton",
                        "latitude": "42.32509000",
                        "longitude": "-72.64120000"
                    },
                    {
                        "id": 123139,
                        "name": "Northborough",
                        "latitude": "42.31954000",
                        "longitude": "-71.64118000"
                    },
                    {
                        "id": 123140,
                        "name": "Northbridge",
                        "latitude": "42.15148000",
                        "longitude": "-71.64951000"
                    },
                    {
                        "id": 123150,
                        "name": "Northfield",
                        "latitude": "42.69592000",
                        "longitude": "-72.45287000"
                    },
                    {
                        "id": 123176,
                        "name": "Northwest Harwich",
                        "latitude": "41.69029000",
                        "longitude": "-70.10250000"
                    },
                    {
                        "id": 123184,
                        "name": "Norton",
                        "latitude": "41.96677000",
                        "longitude": "-71.18699000"
                    },
                    {
                        "id": 123185,
                        "name": "Norton Center",
                        "latitude": "41.97254000",
                        "longitude": "-71.18535000"
                    },
                    {
                        "id": 123194,
                        "name": "Norwell",
                        "latitude": "42.16177000",
                        "longitude": "-70.79393000"
                    },
                    {
                        "id": 123199,
                        "name": "Norwood",
                        "latitude": "42.19454000",
                        "longitude": "-71.19950000"
                    },
                    {
                        "id": 123229,
                        "name": "Oak Bluffs",
                        "latitude": "41.45428000",
                        "longitude": "-70.56197000"
                    },
                    {
                        "id": 123278,
                        "name": "Oakham",
                        "latitude": "42.35287000",
                        "longitude": "-72.04535000"
                    },
                    {
                        "id": 123324,
                        "name": "Ocean Bluff-Brant Rock",
                        "latitude": "42.10234000",
                        "longitude": "-70.65736000"
                    },
                    {
                        "id": 123330,
                        "name": "Ocean Grove",
                        "latitude": "41.72927000",
                        "longitude": "-71.20921000"
                    },
                    {
                        "id": 123483,
                        "name": "Onset",
                        "latitude": "41.74177000",
                        "longitude": "-70.65781000"
                    },
                    {
                        "id": 123508,
                        "name": "Orange",
                        "latitude": "42.59036000",
                        "longitude": "-72.30981000"
                    },
                    {
                        "id": 123564,
                        "name": "Orleans",
                        "latitude": "41.78983000",
                        "longitude": "-69.98974000"
                    },
                    {
                        "id": 123620,
                        "name": "Osterville",
                        "latitude": "41.62844000",
                        "longitude": "-70.38697000"
                    },
                    {
                        "id": 123628,
                        "name": "Otis",
                        "latitude": "42.19315000",
                        "longitude": "-73.09177000"
                    },
                    {
                        "id": 123683,
                        "name": "Oxford",
                        "latitude": "42.11676000",
                        "longitude": "-71.86479000"
                    },
                    {
                        "id": 123759,
                        "name": "Palmer",
                        "latitude": "42.15843000",
                        "longitude": "-72.32869000"
                    },
                    {
                        "id": 123942,
                        "name": "Paxton",
                        "latitude": "42.31120000",
                        "longitude": "-71.92813000"
                    },
                    {
                        "id": 123954,
                        "name": "Peabody",
                        "latitude": "42.52787000",
                        "longitude": "-70.92866000"
                    },
                    {
                        "id": 123990,
                        "name": "Pelham",
                        "latitude": "42.39315000",
                        "longitude": "-72.40370000"
                    },
                    {
                        "id": 124054,
                        "name": "Pepperell",
                        "latitude": "42.66592000",
                        "longitude": "-71.58840000"
                    },
                    {
                        "id": 124141,
                        "name": "Phillipston",
                        "latitude": "42.54870000",
                        "longitude": "-72.13286000"
                    },
                    {
                        "id": 124252,
                        "name": "Pinehurst",
                        "latitude": "42.52926000",
                        "longitude": "-71.22811000"
                    },
                    {
                        "id": 124298,
                        "name": "Pittsfield",
                        "latitude": "42.45008000",
                        "longitude": "-73.24538000"
                    },
                    {
                        "id": 124335,
                        "name": "Plainville",
                        "latitude": "42.00427000",
                        "longitude": "-71.33283000"
                    },
                    {
                        "id": 124402,
                        "name": "Plymouth",
                        "latitude": "41.95844000",
                        "longitude": "-70.66726000"
                    },
                    {
                        "id": 124410,
                        "name": "Plymouth County",
                        "latitude": "41.98743000",
                        "longitude": "-70.73707000"
                    },
                    {
                        "id": 124412,
                        "name": "Plympton",
                        "latitude": "41.95288000",
                        "longitude": "-70.81448000"
                    },
                    {
                        "id": 124417,
                        "name": "Pocasset",
                        "latitude": "41.68622000",
                        "longitude": "-70.61614000"
                    },
                    {
                        "id": 124687,
                        "name": "Princeton",
                        "latitude": "42.44870000",
                        "longitude": "-71.87730000"
                    },
                    {
                        "id": 124720,
                        "name": "Provincetown",
                        "latitude": "42.05295000",
                        "longitude": "-70.18640000"
                    },
                    {
                        "id": 124797,
                        "name": "Quincy",
                        "latitude": "42.25288000",
                        "longitude": "-71.00227000"
                    },
                    {
                        "id": 124865,
                        "name": "Randolph",
                        "latitude": "42.16260000",
                        "longitude": "-71.04116000"
                    },
                    {
                        "id": 124924,
                        "name": "Raynham",
                        "latitude": "41.94871000",
                        "longitude": "-71.07310000"
                    },
                    {
                        "id": 124925,
                        "name": "Raynham Center",
                        "latitude": "41.92371000",
                        "longitude": "-71.05227000"
                    },
                    {
                        "id": 124929,
                        "name": "Reading",
                        "latitude": "42.52565000",
                        "longitude": "-71.09533000"
                    },
                    {
                        "id": 125004,
                        "name": "Rehoboth",
                        "latitude": "41.84038000",
                        "longitude": "-71.24949000"
                    },
                    {
                        "id": 125037,
                        "name": "Revere",
                        "latitude": "42.40843000",
                        "longitude": "-71.01199000"
                    },
                    {
                        "id": 125090,
                        "name": "Richmond",
                        "latitude": "42.37314000",
                        "longitude": "-73.36761000"
                    },
                    {
                        "id": 125262,
                        "name": "Rochester",
                        "latitude": "41.73177000",
                        "longitude": "-70.82004000"
                    },
                    {
                        "id": 125309,
                        "name": "Rockland",
                        "latitude": "42.13066000",
                        "longitude": "-70.91616000"
                    },
                    {
                        "id": 125317,
                        "name": "Rockport",
                        "latitude": "42.65565000",
                        "longitude": "-70.62032000"
                    },
                    {
                        "id": 125482,
                        "name": "Rowley",
                        "latitude": "42.71676000",
                        "longitude": "-70.87866000"
                    },
                    {
                        "id": 125494,
                        "name": "Royalston",
                        "latitude": "42.67759000",
                        "longitude": "-72.18786000"
                    },
                    {
                        "id": 125555,
                        "name": "Rutland",
                        "latitude": "42.36954000",
                        "longitude": "-71.94813000"
                    },
                    {
                        "id": 125586,
                        "name": "Sagamore",
                        "latitude": "41.77011000",
                        "longitude": "-70.52836000"
                    },
                    {
                        "id": 125735,
                        "name": "Salem",
                        "latitude": "42.51954000",
                        "longitude": "-70.89672000"
                    },
                    {
                        "id": 125757,
                        "name": "Salisbury",
                        "latitude": "42.84176000",
                        "longitude": "-70.86061000"
                    },
                    {
                        "id": 125877,
                        "name": "Sandwich",
                        "latitude": "41.75900000",
                        "longitude": "-70.49392000"
                    },
                    {
                        "id": 125961,
                        "name": "Saugus",
                        "latitude": "42.46482000",
                        "longitude": "-71.01005000"
                    },
                    {
                        "id": 126030,
                        "name": "Scituate",
                        "latitude": "42.19593000",
                        "longitude": "-70.72587000"
                    },
                    {
                        "id": 126123,
                        "name": "Seekonk",
                        "latitude": "41.80843000",
                        "longitude": "-71.33700000"
                    },
                    {
                        "id": 126228,
                        "name": "Sharon",
                        "latitude": "42.12371000",
                        "longitude": "-71.17866000"
                    },
                    {
                        "id": 126262,
                        "name": "Sheffield",
                        "latitude": "42.11037000",
                        "longitude": "-73.35511000"
                    },
                    {
                        "id": 126265,
                        "name": "Shelburne",
                        "latitude": "42.58981000",
                        "longitude": "-72.68842000"
                    },
                    {
                        "id": 126266,
                        "name": "Shelburne Falls",
                        "latitude": "42.60425000",
                        "longitude": "-72.73926000"
                    },
                    {
                        "id": 126313,
                        "name": "Sherborn",
                        "latitude": "42.23899000",
                        "longitude": "-71.36978000"
                    },
                    {
                        "id": 126360,
                        "name": "Shirley",
                        "latitude": "42.54370000",
                        "longitude": "-71.64951000"
                    },
                    {
                        "id": 126385,
                        "name": "Shrewsbury",
                        "latitude": "42.29593000",
                        "longitude": "-71.71285000"
                    },
                    {
                        "id": 126389,
                        "name": "Shutesbury",
                        "latitude": "42.45648000",
                        "longitude": "-72.40981000"
                    },
                    {
                        "id": 126516,
                        "name": "Smith Mills",
                        "latitude": "41.63899000",
                        "longitude": "-70.99115000"
                    },
                    {
                        "id": 126582,
                        "name": "Somerset",
                        "latitude": "41.76955000",
                        "longitude": "-71.12866000"
                    },
                    {
                        "id": 126595,
                        "name": "Somerville",
                        "latitude": "42.38760000",
                        "longitude": "-71.09950000"
                    },
                    {
                        "id": 126613,
                        "name": "South Amherst",
                        "latitude": "42.34037000",
                        "longitude": "-72.50509000"
                    },
                    {
                        "id": 126615,
                        "name": "South Ashburnham",
                        "latitude": "42.61037000",
                        "longitude": "-71.93897000"
                    },
                    {
                        "id": 126629,
                        "name": "South Boston",
                        "latitude": "42.33343000",
                        "longitude": "-71.04949000"
                    },
                    {
                        "id": 126646,
                        "name": "South Deerfield",
                        "latitude": "42.47731000",
                        "longitude": "-72.60787000"
                    },
                    {
                        "id": 126647,
                        "name": "South Dennis",
                        "latitude": "41.68956000",
                        "longitude": "-70.15641000"
                    },
                    {
                        "id": 126649,
                        "name": "South Duxbury",
                        "latitude": "42.02316000",
                        "longitude": "-70.68281000"
                    },
                    {
                        "id": 126665,
                        "name": "South Hadley",
                        "latitude": "42.25842000",
                        "longitude": "-72.57453000"
                    },
                    {
                        "id": 126685,
                        "name": "South Lancaster",
                        "latitude": "42.44454000",
                        "longitude": "-71.68701000"
                    },
                    {
                        "id": 126708,
                        "name": "South Peabody",
                        "latitude": "42.50982000",
                        "longitude": "-70.94949000"
                    },
                    {
                        "id": 126755,
                        "name": "South Yarmouth",
                        "latitude": "41.66678000",
                        "longitude": "-70.18474000"
                    },
                    {
                        "id": 126757,
                        "name": "Southampton",
                        "latitude": "42.22926000",
                        "longitude": "-72.73009000"
                    },
                    {
                        "id": 126761,
                        "name": "Southborough",
                        "latitude": "42.30565000",
                        "longitude": "-71.52451000"
                    },
                    {
                        "id": 126762,
                        "name": "Southbridge",
                        "latitude": "42.07510000",
                        "longitude": "-72.03341000"
                    },
                    {
                        "id": 126791,
                        "name": "Southwick",
                        "latitude": "42.05482000",
                        "longitude": "-72.77037000"
                    },
                    {
                        "id": 126826,
                        "name": "Spencer",
                        "latitude": "42.24398000",
                        "longitude": "-71.99230000"
                    },
                    {
                        "id": 126897,
                        "name": "Springfield",
                        "latitude": "42.10148000",
                        "longitude": "-72.58981000"
                    },
                    {
                        "id": 127028,
                        "name": "Sterling",
                        "latitude": "42.43759000",
                        "longitude": "-71.76063000"
                    },
                    {
                        "id": 127068,
                        "name": "Stockbridge",
                        "latitude": "42.28759000",
                        "longitude": "-73.32039000"
                    },
                    {
                        "id": 127089,
                        "name": "Stoneham",
                        "latitude": "42.48010000",
                        "longitude": "-71.09950000"
                    },
                    {
                        "id": 127109,
                        "name": "Stoughton",
                        "latitude": "42.12510000",
                        "longitude": "-71.10227000"
                    },
                    {
                        "id": 127112,
                        "name": "Stow",
                        "latitude": "42.43704000",
                        "longitude": "-71.50562000"
                    },
                    {
                        "id": 127147,
                        "name": "Sturbridge",
                        "latitude": "42.10843000",
                        "longitude": "-72.07869000"
                    },
                    {
                        "id": 127161,
                        "name": "Sudbury",
                        "latitude": "42.38343000",
                        "longitude": "-71.41617000"
                    },
                    {
                        "id": 127167,
                        "name": "Suffolk County",
                        "latitude": "42.35550000",
                        "longitude": "-71.06575000"
                    },
                    {
                        "id": 127249,
                        "name": "Sunderland",
                        "latitude": "42.24454000",
                        "longitude": "-71.77174000"
                    },
                    {
                        "id": 127312,
                        "name": "Sutton",
                        "latitude": "42.15010000",
                        "longitude": "-71.76285000"
                    },
                    {
                        "id": 127321,
                        "name": "Swampscott",
                        "latitude": "42.47093000",
                        "longitude": "-70.91755000"
                    },
                    {
                        "id": 127326,
                        "name": "Swansea",
                        "latitude": "41.74816000",
                        "longitude": "-71.18977000"
                    },
                    {
                        "id": 127441,
                        "name": "Taunton",
                        "latitude": "41.90010000",
                        "longitude": "-71.08977000"
                    },
                    {
                        "id": 127476,
                        "name": "Teaticket",
                        "latitude": "41.56455000",
                        "longitude": "-70.59586000"
                    },
                    {
                        "id": 127504,
                        "name": "Templeton",
                        "latitude": "42.55564000",
                        "longitude": "-72.06758000"
                    },
                    {
                        "id": 127542,
                        "name": "Tewksbury",
                        "latitude": "42.61065000",
                        "longitude": "-71.23422000"
                    },
                    {
                        "id": 127619,
                        "name": "Three Rivers",
                        "latitude": "42.18120000",
                        "longitude": "-72.36064000"
                    },
                    {
                        "id": 127735,
                        "name": "Topsfield",
                        "latitude": "42.63759000",
                        "longitude": "-70.94950000"
                    },
                    {
                        "id": 127765,
                        "name": "Townsend",
                        "latitude": "42.66676000",
                        "longitude": "-71.70507000"
                    },
                    {
                        "id": 127859,
                        "name": "Truro",
                        "latitude": "41.99344000",
                        "longitude": "-70.04975000"
                    },
                    {
                        "id": 127905,
                        "name": "Turners Falls",
                        "latitude": "42.60425000",
                        "longitude": "-72.55648000"
                    },
                    {
                        "id": 127947,
                        "name": "Tyngsboro",
                        "latitude": "42.67676000",
                        "longitude": "-71.42451000"
                    },
                    {
                        "id": 128055,
                        "name": "Upton",
                        "latitude": "42.17454000",
                        "longitude": "-71.60229000"
                    },
                    {
                        "id": 128071,
                        "name": "Uxbridge",
                        "latitude": "42.07732000",
                        "longitude": "-71.62951000"
                    },
                    {
                        "id": 128274,
                        "name": "Vineyard Haven",
                        "latitude": "41.45428000",
                        "longitude": "-70.60364000"
                    },
                    {
                        "id": 128359,
                        "name": "Wakefield",
                        "latitude": "42.50648000",
                        "longitude": "-71.07283000"
                    },
                    {
                        "id": 128379,
                        "name": "Wales",
                        "latitude": "42.06954000",
                        "longitude": "-72.22230000"
                    },
                    {
                        "id": 128425,
                        "name": "Walpole",
                        "latitude": "42.14177000",
                        "longitude": "-71.24950000"
                    },
                    {
                        "id": 128432,
                        "name": "Waltham",
                        "latitude": "42.37649000",
                        "longitude": "-71.23561000"
                    },
                    {
                        "id": 128462,
                        "name": "Ware",
                        "latitude": "42.25981000",
                        "longitude": "-72.23980000"
                    },
                    {
                        "id": 128465,
                        "name": "Wareham Center",
                        "latitude": "41.76677000",
                        "longitude": "-70.72615000"
                    },
                    {
                        "id": 128478,
                        "name": "Warren",
                        "latitude": "42.21259000",
                        "longitude": "-72.19119000"
                    },
                    {
                        "id": 128621,
                        "name": "Watertown",
                        "latitude": "42.37093000",
                        "longitude": "-71.18283000"
                    },
                    {
                        "id": 128678,
                        "name": "Wayland",
                        "latitude": "42.36260000",
                        "longitude": "-71.36145000"
                    },
                    {
                        "id": 128731,
                        "name": "Webster",
                        "latitude": "42.05010000",
                        "longitude": "-71.88007000"
                    },
                    {
                        "id": 128773,
                        "name": "Wellesley",
                        "latitude": "42.29649000",
                        "longitude": "-71.29256000"
                    },
                    {
                        "id": 128774,
                        "name": "Wellfleet",
                        "latitude": "41.93761000",
                        "longitude": "-70.03280000"
                    },
                    {
                        "id": 128799,
                        "name": "Wendell",
                        "latitude": "42.54814000",
                        "longitude": "-72.39675000"
                    },
                    {
                        "id": 128802,
                        "name": "Wenham",
                        "latitude": "42.60426000",
                        "longitude": "-70.89116000"
                    },
                    {
                        "id": 128821,
                        "name": "West Barnstable",
                        "latitude": "41.70566000",
                        "longitude": "-70.37447000"
                    },
                    {
                        "id": 128830,
                        "name": "West Boylston",
                        "latitude": "42.36676000",
                        "longitude": "-71.78563000"
                    },
                    {
                        "id": 128835,
                        "name": "West Bridgewater",
                        "latitude": "42.01899000",
                        "longitude": "-71.00782000"
                    },
                    {
                        "id": 128836,
                        "name": "West Brookfield",
                        "latitude": "42.23537000",
                        "longitude": "-72.14119000"
                    },
                    {
                        "id": 128844,
                        "name": "West Chatham",
                        "latitude": "41.68122000",
                        "longitude": "-69.99113000"
                    },
                    {
                        "id": 128850,
                        "name": "West Concord",
                        "latitude": "42.45843000",
                        "longitude": "-71.39534000"
                    },
                    {
                        "id": 128856,
                        "name": "West Dennis",
                        "latitude": "41.66456000",
                        "longitude": "-70.17280000"
                    },
                    {
                        "id": 128868,
                        "name": "West Falmouth",
                        "latitude": "41.60427000",
                        "longitude": "-70.63447000"
                    },
                    {
                        "id": 128939,
                        "name": "West Newbury",
                        "latitude": "42.80148000",
                        "longitude": "-70.98978000"
                    },
                    {
                        "id": 128985,
                        "name": "West Springfield",
                        "latitude": "42.10704000",
                        "longitude": "-72.62037000"
                    },
                    {
                        "id": 128986,
                        "name": "West Stockbridge",
                        "latitude": "42.34592000",
                        "longitude": "-73.36622000"
                    },
                    {
                        "id": 128990,
                        "name": "West Tisbury",
                        "latitude": "41.38122000",
                        "longitude": "-70.67447000"
                    },
                    {
                        "id": 129000,
                        "name": "West Wareham",
                        "latitude": "41.78983000",
                        "longitude": "-70.76031000"
                    },
                    {
                        "id": 129008,
                        "name": "West Yarmouth",
                        "latitude": "41.65011000",
                        "longitude": "-70.24113000"
                    },
                    {
                        "id": 129012,
                        "name": "Westborough",
                        "latitude": "42.26954000",
                        "longitude": "-71.61618000"
                    },
                    {
                        "id": 129028,
                        "name": "Westfield",
                        "latitude": "42.12509000",
                        "longitude": "-72.74954000"
                    },
                    {
                        "id": 129033,
                        "name": "Westford",
                        "latitude": "42.57926000",
                        "longitude": "-71.43784000"
                    },
                    {
                        "id": 129034,
                        "name": "Westhampton",
                        "latitude": "42.30287000",
                        "longitude": "-72.77454000"
                    },
                    {
                        "id": 129046,
                        "name": "Westminster",
                        "latitude": "42.54592000",
                        "longitude": "-71.91063000"
                    },
                    {
                        "id": 129061,
                        "name": "Weston",
                        "latitude": "42.36676000",
                        "longitude": "-71.30311000"
                    },
                    {
                        "id": 129085,
                        "name": "Westwood",
                        "latitude": "42.21399000",
                        "longitude": "-71.22450000"
                    },
                    {
                        "id": 129095,
                        "name": "Weweantic",
                        "latitude": "41.73538000",
                        "longitude": "-70.73198000"
                    },
                    {
                        "id": 129100,
                        "name": "Weymouth",
                        "latitude": "42.22093000",
                        "longitude": "-70.93977000"
                    },
                    {
                        "id": 129106,
                        "name": "Whately",
                        "latitude": "42.43981000",
                        "longitude": "-72.63481000"
                    },
                    {
                        "id": 129144,
                        "name": "White Island Shores",
                        "latitude": "41.80010000",
                        "longitude": "-70.63475000"
                    },
                    {
                        "id": 129198,
                        "name": "Whitinsville",
                        "latitude": "42.11121000",
                        "longitude": "-71.66618000"
                    },
                    {
                        "id": 129203,
                        "name": "Whitman",
                        "latitude": "42.08066000",
                        "longitude": "-70.93560000"
                    },
                    {
                        "id": 129226,
                        "name": "Wilbraham",
                        "latitude": "42.12371000",
                        "longitude": "-72.43147000"
                    },
                    {
                        "id": 129269,
                        "name": "Williamsburg",
                        "latitude": "42.39314000",
                        "longitude": "-72.73009000"
                    },
                    {
                        "id": 129288,
                        "name": "Williamstown",
                        "latitude": "42.71202000",
                        "longitude": "-73.20372000"
                    },
                    {
                        "id": 129324,
                        "name": "Wilmington",
                        "latitude": "42.54648000",
                        "longitude": "-71.17367000"
                    },
                    {
                        "id": 129351,
                        "name": "Winchendon",
                        "latitude": "42.68620000",
                        "longitude": "-72.04397000"
                    },
                    {
                        "id": 129358,
                        "name": "Winchester",
                        "latitude": "42.45232000",
                        "longitude": "-71.13700000"
                    },
                    {
                        "id": 129450,
                        "name": "Winthrop",
                        "latitude": "42.37510000",
                        "longitude": "-70.98283000"
                    },
                    {
                        "id": 129466,
                        "name": "Woburn",
                        "latitude": "42.47926000",
                        "longitude": "-71.15228000"
                    },
                    {
                        "id": 129584,
                        "name": "Worcester",
                        "latitude": "42.26259000",
                        "longitude": "-71.80229000"
                    },
                    {
                        "id": 129587,
                        "name": "Worcester County",
                        "latitude": "42.35140000",
                        "longitude": "-71.90774000"
                    },
                    {
                        "id": 129604,
                        "name": "Wrentham",
                        "latitude": "42.06677000",
                        "longitude": "-71.32811000"
                    },
                    {
                        "id": 129667,
                        "name": "Yarmouth",
                        "latitude": "41.70567000",
                        "longitude": "-70.22863000"
                    },
                    {
                        "id": 129668,
                        "name": "Yarmouth Port",
                        "latitude": "41.70205000",
                        "longitude": "-70.24947000"
                    }
                ]
            },
            {
                "id": 1426,
                "name": "Michigan",
                "iso2": "MI",
                "latitude": "44.31484430",
                "longitude": "-85.60236430",
                "type": "state",
                "cities": [
                    {
                        "id": 111046,
                        "name": "Adrian",
                        "latitude": "41.89755000",
                        "longitude": "-84.03717000"
                    },
                    {
                        "id": 111126,
                        "name": "Albion",
                        "latitude": "42.24310000",
                        "longitude": "-84.75303000"
                    },
                    {
                        "id": 111133,
                        "name": "Alcona County",
                        "latitude": "44.71161000",
                        "longitude": "-83.34366000"
                    },
                    {
                        "id": 111161,
                        "name": "Alger County",
                        "latitude": "46.45110000",
                        "longitude": "-86.54755000"
                    },
                    {
                        "id": 111165,
                        "name": "Algonac",
                        "latitude": "42.61858000",
                        "longitude": "-82.53230000"
                    },
                    {
                        "id": 111178,
                        "name": "Allegan",
                        "latitude": "42.52920000",
                        "longitude": "-85.85530000"
                    },
                    {
                        "id": 111179,
                        "name": "Allegan County",
                        "latitude": "42.51766000",
                        "longitude": "-85.91034000"
                    },
                    {
                        "id": 111192,
                        "name": "Allen Park",
                        "latitude": "42.25754000",
                        "longitude": "-83.21104000"
                    },
                    {
                        "id": 111194,
                        "name": "Allendale",
                        "latitude": "42.97225000",
                        "longitude": "-85.95365000"
                    },
                    {
                        "id": 111209,
                        "name": "Alma",
                        "latitude": "43.37892000",
                        "longitude": "-84.65973000"
                    },
                    {
                        "id": 111213,
                        "name": "Almont",
                        "latitude": "42.92058000",
                        "longitude": "-83.04493000"
                    },
                    {
                        "id": 111218,
                        "name": "Alpena",
                        "latitude": "45.06168000",
                        "longitude": "-83.43275000"
                    },
                    {
                        "id": 111219,
                        "name": "Alpena County",
                        "latitude": "45.06350000",
                        "longitude": "-83.46039000"
                    },
                    {
                        "id": 111345,
                        "name": "Ann Arbor",
                        "latitude": "42.27756000",
                        "longitude": "-83.74088000"
                    },
                    {
                        "id": 111377,
                        "name": "Antrim County",
                        "latitude": "45.00737000",
                        "longitude": "-85.17579000"
                    },
                    {
                        "id": 111445,
                        "name": "Arenac County",
                        "latitude": "44.04289000",
                        "longitude": "-83.74725000"
                    },
                    {
                        "id": 111447,
                        "name": "Argentine",
                        "latitude": "42.79142000",
                        "longitude": "-83.84634000"
                    },
                    {
                        "id": 111476,
                        "name": "Armada",
                        "latitude": "42.84420000",
                        "longitude": "-82.88437000"
                    },
                    {
                        "id": 111578,
                        "name": "Athens",
                        "latitude": "42.08866000",
                        "longitude": "-85.23471000"
                    },
                    {
                        "id": 111593,
                        "name": "Atlanta",
                        "latitude": "45.00473000",
                        "longitude": "-84.14389000"
                    },
                    {
                        "id": 111616,
                        "name": "Au Sable",
                        "latitude": "44.41085000",
                        "longitude": "-83.33219000"
                    },
                    {
                        "id": 111626,
                        "name": "Auburn",
                        "latitude": "43.60336000",
                        "longitude": "-84.06970000"
                    },
                    {
                        "id": 111634,
                        "name": "Auburn Hills",
                        "latitude": "42.68753000",
                        "longitude": "-83.23410000"
                    },
                    {
                        "id": 111721,
                        "name": "Bad Axe",
                        "latitude": "43.80196000",
                        "longitude": "-83.00078000"
                    },
                    {
                        "id": 111755,
                        "name": "Baldwin",
                        "latitude": "43.90112000",
                        "longitude": "-85.85173000"
                    },
                    {
                        "id": 111791,
                        "name": "Bangor",
                        "latitude": "42.31254000",
                        "longitude": "-86.11308000"
                    },
                    {
                        "id": 111809,
                        "name": "Baraga",
                        "latitude": "46.77854000",
                        "longitude": "-88.48902000"
                    },
                    {
                        "id": 111810,
                        "name": "Baraga County",
                        "latitude": "46.69976000",
                        "longitude": "-88.35215000"
                    },
                    {
                        "id": 111827,
                        "name": "Barnes Lake-Millers Lake",
                        "latitude": "43.17956000",
                        "longitude": "-83.31230000"
                    },
                    {
                        "id": 111856,
                        "name": "Barry County",
                        "latitude": "42.59503000",
                        "longitude": "-85.30897000"
                    },
                    {
                        "id": 111896,
                        "name": "Bath",
                        "latitude": "42.81864000",
                        "longitude": "-84.44859000"
                    },
                    {
                        "id": 111904,
                        "name": "Battle Creek",
                        "latitude": "42.31730000",
                        "longitude": "-85.17816000"
                    },
                    {
                        "id": 111922,
                        "name": "Bay City",
                        "latitude": "43.59447000",
                        "longitude": "-83.88886000"
                    },
                    {
                        "id": 111925,
                        "name": "Bay County",
                        "latitude": "43.72137000",
                        "longitude": "-83.94184000"
                    },
                    {
                        "id": 111926,
                        "name": "Bay Harbor",
                        "latitude": "45.36413000",
                        "longitude": "-85.08208000"
                    },
                    {
                        "id": 112009,
                        "name": "Beaverton",
                        "latitude": "43.88225000",
                        "longitude": "-84.48473000"
                    },
                    {
                        "id": 112040,
                        "name": "Beecher",
                        "latitude": "43.09003000",
                        "longitude": "-83.69440000"
                    },
                    {
                        "id": 112042,
                        "name": "Beechwood",
                        "latitude": "42.79697000",
                        "longitude": "-86.12588000"
                    },
                    {
                        "id": 112053,
                        "name": "Belding",
                        "latitude": "43.09781000",
                        "longitude": "-85.22891000"
                    },
                    {
                        "id": 112076,
                        "name": "Bellaire",
                        "latitude": "44.98028000",
                        "longitude": "-85.21117000"
                    },
                    {
                        "id": 112105,
                        "name": "Belleville",
                        "latitude": "42.20476000",
                        "longitude": "-83.48521000"
                    },
                    {
                        "id": 112112,
                        "name": "Bellevue",
                        "latitude": "42.44337000",
                        "longitude": "-85.01805000"
                    },
                    {
                        "id": 112208,
                        "name": "Benton Harbor",
                        "latitude": "42.11671000",
                        "longitude": "-86.45419000"
                    },
                    {
                        "id": 112209,
                        "name": "Benton Heights",
                        "latitude": "42.13115000",
                        "longitude": "-86.40724000"
                    },
                    {
                        "id": 112212,
                        "name": "Benzie County",
                        "latitude": "44.61687000",
                        "longitude": "-86.13899000"
                    },
                    {
                        "id": 112230,
                        "name": "Berkley",
                        "latitude": "42.50309000",
                        "longitude": "-83.18354000"
                    },
                    {
                        "id": 112250,
                        "name": "Berrien County",
                        "latitude": "41.91863000",
                        "longitude": "-86.42807000"
                    },
                    {
                        "id": 112251,
                        "name": "Berrien Springs",
                        "latitude": "41.94643000",
                        "longitude": "-86.33890000"
                    },
                    {
                        "id": 112268,
                        "name": "Bessemer",
                        "latitude": "46.48134000",
                        "longitude": "-90.05295000"
                    },
                    {
                        "id": 112295,
                        "name": "Beulah",
                        "latitude": "44.63194000",
                        "longitude": "-86.09092000"
                    },
                    {
                        "id": 112305,
                        "name": "Beverly Hills",
                        "latitude": "42.52392000",
                        "longitude": "-83.22326000"
                    },
                    {
                        "id": 112330,
                        "name": "Big Rapids",
                        "latitude": "43.69808000",
                        "longitude": "-85.48366000"
                    },
                    {
                        "id": 112350,
                        "name": "Bingham Farms",
                        "latitude": "42.51587000",
                        "longitude": "-83.27326000"
                    },
                    {
                        "id": 112354,
                        "name": "Birch Run",
                        "latitude": "43.25086000",
                        "longitude": "-83.79413000"
                    },
                    {
                        "id": 112359,
                        "name": "Birmingham",
                        "latitude": "42.54670000",
                        "longitude": "-83.21132000"
                    },
                    {
                        "id": 112431,
                        "name": "Blissfield",
                        "latitude": "41.83255000",
                        "longitude": "-83.86244000"
                    },
                    {
                        "id": 112441,
                        "name": "Bloomfield Hills",
                        "latitude": "42.58364000",
                        "longitude": "-83.24549000"
                    },
                    {
                        "id": 112651,
                        "name": "Boyne City",
                        "latitude": "45.21668000",
                        "longitude": "-85.01394000"
                    },
                    {
                        "id": 112685,
                        "name": "Branch County",
                        "latitude": "41.91611000",
                        "longitude": "-85.05903000"
                    },
                    {
                        "id": 112711,
                        "name": "Breckenridge",
                        "latitude": "43.40808000",
                        "longitude": "-84.47500000"
                    },
                    {
                        "id": 112762,
                        "name": "Bridgeport",
                        "latitude": "43.35947000",
                        "longitude": "-83.88164000"
                    },
                    {
                        "id": 112778,
                        "name": "Bridgman",
                        "latitude": "41.94310000",
                        "longitude": "-86.55697000"
                    },
                    {
                        "id": 112789,
                        "name": "Brighton",
                        "latitude": "42.52948000",
                        "longitude": "-83.78022000"
                    },
                    {
                        "id": 112845,
                        "name": "Bronson",
                        "latitude": "41.87227000",
                        "longitude": "-85.19470000"
                    },
                    {
                        "id": 112871,
                        "name": "Brooklyn",
                        "latitude": "42.10587000",
                        "longitude": "-84.24828000"
                    },
                    {
                        "id": 112906,
                        "name": "Brown City",
                        "latitude": "43.21225000",
                        "longitude": "-82.98966000"
                    },
                    {
                        "id": 112919,
                        "name": "Brownlee Park",
                        "latitude": "42.31893000",
                        "longitude": "-85.14249000"
                    },
                    {
                        "id": 112971,
                        "name": "Buchanan",
                        "latitude": "41.82727000",
                        "longitude": "-86.36112000"
                    },
                    {
                        "id": 113002,
                        "name": "Buena Vista",
                        "latitude": "43.42030000",
                        "longitude": "-83.89858000"
                    },
                    {
                        "id": 113094,
                        "name": "Burt",
                        "latitude": "43.23669000",
                        "longitude": "-83.90636000"
                    },
                    {
                        "id": 113097,
                        "name": "Burton",
                        "latitude": "42.99947000",
                        "longitude": "-83.61634000"
                    },
                    {
                        "id": 113147,
                        "name": "Byron Center",
                        "latitude": "42.81225000",
                        "longitude": "-85.72281000"
                    },
                    {
                        "id": 113164,
                        "name": "Cadillac",
                        "latitude": "44.25195000",
                        "longitude": "-85.40116000"
                    },
                    {
                        "id": 113189,
                        "name": "Caledonia",
                        "latitude": "42.78920000",
                        "longitude": "-85.51669000"
                    },
                    {
                        "id": 113210,
                        "name": "Calhoun County",
                        "latitude": "42.24653000",
                        "longitude": "-85.00559000"
                    },
                    {
                        "id": 113316,
                        "name": "Canadian Lakes",
                        "latitude": "43.57919000",
                        "longitude": "-85.30170000"
                    },
                    {
                        "id": 113345,
                        "name": "Canton",
                        "latitude": "42.30865000",
                        "longitude": "-83.48216000"
                    },
                    {
                        "id": 113362,
                        "name": "Capac",
                        "latitude": "43.01253000",
                        "longitude": "-82.92799000"
                    },
                    {
                        "id": 113398,
                        "name": "Carleton",
                        "latitude": "42.05921000",
                        "longitude": "-83.39077000"
                    },
                    {
                        "id": 113432,
                        "name": "Caro",
                        "latitude": "43.49073000",
                        "longitude": "-83.39885000"
                    },
                    {
                        "id": 113471,
                        "name": "Carrollton",
                        "latitude": "43.45864000",
                        "longitude": "-83.93025000"
                    },
                    {
                        "id": 113477,
                        "name": "Carson City",
                        "latitude": "43.17698000",
                        "longitude": "-84.84639000"
                    },
                    {
                        "id": 113525,
                        "name": "Cass City",
                        "latitude": "43.60085000",
                        "longitude": "-83.17467000"
                    },
                    {
                        "id": 113531,
                        "name": "Cass County",
                        "latitude": "41.91540000",
                        "longitude": "-85.99346000"
                    },
                    {
                        "id": 113538,
                        "name": "Cassopolis",
                        "latitude": "41.91171000",
                        "longitude": "-86.01001000"
                    },
                    {
                        "id": 113623,
                        "name": "Cedar Springs",
                        "latitude": "43.22336000",
                        "longitude": "-85.55142000"
                    },
                    {
                        "id": 113644,
                        "name": "Center Line",
                        "latitude": "42.48504000",
                        "longitude": "-83.02770000"
                    },
                    {
                        "id": 113696,
                        "name": "Centreville",
                        "latitude": "41.92338000",
                        "longitude": "-85.52832000"
                    },
                    {
                        "id": 113774,
                        "name": "Charlevoix",
                        "latitude": "45.31806000",
                        "longitude": "-85.25840000"
                    },
                    {
                        "id": 113775,
                        "name": "Charlevoix County",
                        "latitude": "45.26715000",
                        "longitude": "-85.24017000"
                    },
                    {
                        "id": 113779,
                        "name": "Charlotte",
                        "latitude": "42.56365000",
                        "longitude": "-84.83582000"
                    },
                    {
                        "id": 113821,
                        "name": "Cheboygan",
                        "latitude": "45.64696000",
                        "longitude": "-84.47448000"
                    },
                    {
                        "id": 113822,
                        "name": "Cheboygan County",
                        "latitude": "45.47294000",
                        "longitude": "-84.49206000"
                    },
                    {
                        "id": 113833,
                        "name": "Chelsea",
                        "latitude": "42.31807000",
                        "longitude": "-84.02181000"
                    },
                    {
                        "id": 113872,
                        "name": "Chesaning",
                        "latitude": "43.18475000",
                        "longitude": "-84.11497000"
                    },
                    {
                        "id": 113973,
                        "name": "Chippewa County",
                        "latitude": "46.32818000",
                        "longitude": "-84.52936000"
                    },
                    {
                        "id": 114102,
                        "name": "Clare",
                        "latitude": "43.81947000",
                        "longitude": "-84.76863000"
                    },
                    {
                        "id": 114103,
                        "name": "Clare County",
                        "latitude": "43.98787000",
                        "longitude": "-84.84784000"
                    },
                    {
                        "id": 114149,
                        "name": "Clarkston",
                        "latitude": "42.73586000",
                        "longitude": "-83.41883000"
                    },
                    {
                        "id": 114163,
                        "name": "Clawson",
                        "latitude": "42.53337000",
                        "longitude": "-83.14632000"
                    },
                    {
                        "id": 114282,
                        "name": "Clinton",
                        "latitude": "42.07199000",
                        "longitude": "-83.97161000"
                    },
                    {
                        "id": 114294,
                        "name": "Clinton County",
                        "latitude": "42.94365000",
                        "longitude": "-84.60152000"
                    },
                    {
                        "id": 114297,
                        "name": "Clinton Township",
                        "latitude": "42.58698000",
                        "longitude": "-82.91992000"
                    },
                    {
                        "id": 114302,
                        "name": "Clio",
                        "latitude": "43.17753000",
                        "longitude": "-83.73413000"
                    },
                    {
                        "id": 114394,
                        "name": "Coldwater",
                        "latitude": "41.94033000",
                        "longitude": "-85.00052000"
                    },
                    {
                        "id": 114399,
                        "name": "Coleman",
                        "latitude": "43.75669000",
                        "longitude": "-84.58584000"
                    },
                    {
                        "id": 114443,
                        "name": "Coloma",
                        "latitude": "42.18615000",
                        "longitude": "-86.30836000"
                    },
                    {
                        "id": 114444,
                        "name": "Colon",
                        "latitude": "41.95838000",
                        "longitude": "-85.32498000"
                    },
                    {
                        "id": 114530,
                        "name": "Comstock Northwest",
                        "latitude": "42.32182000",
                        "longitude": "-85.51759000"
                    },
                    {
                        "id": 114531,
                        "name": "Comstock Park",
                        "latitude": "43.03864000",
                        "longitude": "-85.67003000"
                    },
                    {
                        "id": 114539,
                        "name": "Concord",
                        "latitude": "42.17782000",
                        "longitude": "-84.64302000"
                    },
                    {
                        "id": 114573,
                        "name": "Constantine",
                        "latitude": "41.84116000",
                        "longitude": "-85.66860000"
                    },
                    {
                        "id": 114608,
                        "name": "Coopersville",
                        "latitude": "43.06391000",
                        "longitude": "-85.93477000"
                    },
                    {
                        "id": 114679,
                        "name": "Corunna",
                        "latitude": "42.98197000",
                        "longitude": "-84.11775000"
                    },
                    {
                        "id": 114781,
                        "name": "Crawford County",
                        "latitude": "44.68361000",
                        "longitude": "-84.61030000"
                    },
                    {
                        "id": 114857,
                        "name": "Croswell",
                        "latitude": "43.27558000",
                        "longitude": "-82.62104000"
                    },
                    {
                        "id": 114877,
                        "name": "Crystal Falls",
                        "latitude": "46.09801000",
                        "longitude": "-88.33402000"
                    },
                    {
                        "id": 114950,
                        "name": "Cutlerville",
                        "latitude": "42.84086000",
                        "longitude": "-85.66364000"
                    },
                    {
                        "id": 115078,
                        "name": "Davison",
                        "latitude": "43.03475000",
                        "longitude": "-83.51801000"
                    },
                    {
                        "id": 115145,
                        "name": "Dearborn",
                        "latitude": "42.32226000",
                        "longitude": "-83.17631000"
                    },
                    {
                        "id": 115147,
                        "name": "Dearborn Heights",
                        "latitude": "42.33698000",
                        "longitude": "-83.27326000"
                    },
                    {
                        "id": 115157,
                        "name": "Decatur",
                        "latitude": "42.10810000",
                        "longitude": "-85.97446000"
                    },
                    {
                        "id": 115225,
                        "name": "Delta County",
                        "latitude": "45.79162000",
                        "longitude": "-86.87060000"
                    },
                    {
                        "id": 115291,
                        "name": "Detroit",
                        "latitude": "42.33143000",
                        "longitude": "-83.04575000"
                    },
                    {
                        "id": 115292,
                        "name": "Detroit Beach",
                        "latitude": "41.93116000",
                        "longitude": "-83.32688000"
                    },
                    {
                        "id": 115140,
                        "name": "DeWitt",
                        "latitude": "42.84226000",
                        "longitude": "-84.56915000"
                    },
                    {
                        "id": 115309,
                        "name": "Dexter",
                        "latitude": "42.33834000",
                        "longitude": "-83.88954000"
                    },
                    {
                        "id": 115329,
                        "name": "Dickinson County",
                        "latitude": "46.00935000",
                        "longitude": "-87.87021000"
                    },
                    {
                        "id": 115350,
                        "name": "Dimondale",
                        "latitude": "42.64559000",
                        "longitude": "-84.64887000"
                    },
                    {
                        "id": 115388,
                        "name": "Dollar Bay",
                        "latitude": "47.11965000",
                        "longitude": "-88.51151000"
                    },
                    {
                        "id": 115422,
                        "name": "Douglas",
                        "latitude": "42.64336000",
                        "longitude": "-86.20059000"
                    },
                    {
                        "id": 115458,
                        "name": "Dowagiac",
                        "latitude": "41.98421000",
                        "longitude": "-86.10862000"
                    },
                    {
                        "id": 115529,
                        "name": "Dundee",
                        "latitude": "41.95727000",
                        "longitude": "-83.65966000"
                    },
                    {
                        "id": 115563,
                        "name": "Durand",
                        "latitude": "42.91198000",
                        "longitude": "-83.98468000"
                    },
                    {
                        "id": 115610,
                        "name": "Eagle River",
                        "latitude": "47.41381000",
                        "longitude": "-88.29566000"
                    },
                    {
                        "id": 115671,
                        "name": "East Grand Rapids",
                        "latitude": "42.94114000",
                        "longitude": "-85.61003000"
                    },
                    {
                        "id": 115697,
                        "name": "East Jordan",
                        "latitude": "45.15806000",
                        "longitude": "-85.12423000"
                    },
                    {
                        "id": 115703,
                        "name": "East Lansing",
                        "latitude": "42.73698000",
                        "longitude": "-84.48387000"
                    },
                    {
                        "id": 115764,
                        "name": "East Tawas",
                        "latitude": "44.27946000",
                        "longitude": "-83.49025000"
                    },
                    {
                        "id": 115794,
                        "name": "Eastpointe",
                        "latitude": "42.46837000",
                        "longitude": "-82.95547000"
                    },
                    {
                        "id": 115800,
                        "name": "Eastwood",
                        "latitude": "42.30310000",
                        "longitude": "-85.55028000"
                    },
                    {
                        "id": 115803,
                        "name": "Eaton County",
                        "latitude": "42.59607000",
                        "longitude": "-84.83831000"
                    },
                    {
                        "id": 115804,
                        "name": "Eaton Rapids",
                        "latitude": "42.50920000",
                        "longitude": "-84.65581000"
                    },
                    {
                        "id": 115818,
                        "name": "Ecorse",
                        "latitude": "42.24448000",
                        "longitude": "-83.14576000"
                    },
                    {
                        "id": 115846,
                        "name": "Edgemont Park",
                        "latitude": "42.74670000",
                        "longitude": "-84.59359000"
                    },
                    {
                        "id": 115882,
                        "name": "Edmore",
                        "latitude": "43.40809000",
                        "longitude": "-85.03863000"
                    },
                    {
                        "id": 115892,
                        "name": "Edwardsburg",
                        "latitude": "41.79560000",
                        "longitude": "-86.08084000"
                    },
                    {
                        "id": 115991,
                        "name": "Elk Rapids",
                        "latitude": "44.89556000",
                        "longitude": "-85.41646000"
                    },
                    {
                        "id": 116103,
                        "name": "Emmet County",
                        "latitude": "45.58754000",
                        "longitude": "-84.98147000"
                    },
                    {
                        "id": 116181,
                        "name": "Escanaba",
                        "latitude": "45.74525000",
                        "longitude": "-87.06458000"
                    },
                    {
                        "id": 116201,
                        "name": "Essexville",
                        "latitude": "43.61530000",
                        "longitude": "-83.84192000"
                    },
                    {
                        "id": 116256,
                        "name": "Evart",
                        "latitude": "43.90058000",
                        "longitude": "-85.25810000"
                    },
                    {
                        "id": 116288,
                        "name": "Fair Plain",
                        "latitude": "42.08699000",
                        "longitude": "-86.45586000"
                    },
                    {
                        "id": 116417,
                        "name": "Farmington",
                        "latitude": "42.46448000",
                        "longitude": "-83.37632000"
                    },
                    {
                        "id": 116423,
                        "name": "Farmington Hills",
                        "latitude": "42.48531000",
                        "longitude": "-83.37716000"
                    },
                    {
                        "id": 116473,
                        "name": "Fennville",
                        "latitude": "42.59392000",
                        "longitude": "-86.10170000"
                    },
                    {
                        "id": 116475,
                        "name": "Fenton",
                        "latitude": "42.79781000",
                        "longitude": "-83.70495000"
                    },
                    {
                        "id": 116487,
                        "name": "Ferndale",
                        "latitude": "42.46059000",
                        "longitude": "-83.13465000"
                    },
                    {
                        "id": 116500,
                        "name": "Ferrysburg",
                        "latitude": "43.08446000",
                        "longitude": "-86.22033000"
                    },
                    {
                        "id": 116552,
                        "name": "Flat Rock",
                        "latitude": "42.09643000",
                        "longitude": "-83.29187000"
                    },
                    {
                        "id": 116566,
                        "name": "Flint",
                        "latitude": "43.01253000",
                        "longitude": "-83.68746000"
                    },
                    {
                        "id": 116613,
                        "name": "Flushing",
                        "latitude": "43.06308000",
                        "longitude": "-83.85107000"
                    },
                    {
                        "id": 116657,
                        "name": "Forest Hills",
                        "latitude": "42.95947000",
                        "longitude": "-85.48975000"
                    },
                    {
                        "id": 116795,
                        "name": "Fowler",
                        "latitude": "43.00170000",
                        "longitude": "-84.73972000"
                    },
                    {
                        "id": 116798,
                        "name": "Fowlerville",
                        "latitude": "42.66059000",
                        "longitude": "-84.07301000"
                    },
                    {
                        "id": 116817,
                        "name": "Frankenmuth",
                        "latitude": "43.33169000",
                        "longitude": "-83.73802000"
                    },
                    {
                        "id": 116821,
                        "name": "Frankfort",
                        "latitude": "44.63361000",
                        "longitude": "-86.23454000"
                    },
                    {
                        "id": 116836,
                        "name": "Franklin",
                        "latitude": "42.52226000",
                        "longitude": "-83.30604000"
                    },
                    {
                        "id": 116880,
                        "name": "Fraser",
                        "latitude": "42.53920000",
                        "longitude": "-82.94937000"
                    },
                    {
                        "id": 116905,
                        "name": "Freeland",
                        "latitude": "43.52503000",
                        "longitude": "-84.12276000"
                    },
                    {
                        "id": 116921,
                        "name": "Fremont",
                        "latitude": "43.46752000",
                        "longitude": "-85.94200000"
                    },
                    {
                        "id": 116974,
                        "name": "Fruitport",
                        "latitude": "43.13196000",
                        "longitude": "-86.15478000"
                    },
                    {
                        "id": 117028,
                        "name": "Galesburg",
                        "latitude": "42.28865000",
                        "longitude": "-85.41806000"
                    },
                    {
                        "id": 117057,
                        "name": "Garden City",
                        "latitude": "42.32559000",
                        "longitude": "-83.33104000"
                    },
                    {
                        "id": 117127,
                        "name": "Gaylord",
                        "latitude": "45.02751000",
                        "longitude": "-84.67475000"
                    },
                    {
                        "id": 117135,
                        "name": "Genesee County",
                        "latitude": "43.02172000",
                        "longitude": "-83.70671000"
                    },
                    {
                        "id": 117185,
                        "name": "Gibraltar",
                        "latitude": "42.09504000",
                        "longitude": "-83.18965000"
                    },
                    {
                        "id": 117237,
                        "name": "Gladstone",
                        "latitude": "45.85274000",
                        "longitude": "-87.02180000"
                    },
                    {
                        "id": 117240,
                        "name": "Gladwin",
                        "latitude": "43.98085000",
                        "longitude": "-84.48640000"
                    },
                    {
                        "id": 117241,
                        "name": "Gladwin County",
                        "latitude": "43.99067000",
                        "longitude": "-84.38825000"
                    },
                    {
                        "id": 117337,
                        "name": "Gogebic County",
                        "latitude": "46.49552000",
                        "longitude": "-89.79555000"
                    },
                    {
                        "id": 117389,
                        "name": "Goodrich",
                        "latitude": "42.91697000",
                        "longitude": "-83.50634000"
                    },
                    {
                        "id": 117450,
                        "name": "Grand Blanc",
                        "latitude": "42.92753000",
                        "longitude": "-83.62995000"
                    },
                    {
                        "id": 117460,
                        "name": "Grand Haven",
                        "latitude": "43.06307000",
                        "longitude": "-86.22839000"
                    },
                    {
                        "id": 117466,
                        "name": "Grand Ledge",
                        "latitude": "42.75337000",
                        "longitude": "-84.74638000"
                    },
                    {
                        "id": 117473,
                        "name": "Grand Rapids",
                        "latitude": "42.96336000",
                        "longitude": "-85.66809000"
                    },
                    {
                        "id": 117477,
                        "name": "Grand Traverse County",
                        "latitude": "44.71624000",
                        "longitude": "-85.55220000"
                    },
                    {
                        "id": 117483,
                        "name": "Grandville",
                        "latitude": "42.90975000",
                        "longitude": "-85.76309000"
                    },
                    {
                        "id": 117542,
                        "name": "Grass Lake",
                        "latitude": "42.25087000",
                        "longitude": "-84.21301000"
                    },
                    {
                        "id": 117544,
                        "name": "Gratiot County",
                        "latitude": "43.29273000",
                        "longitude": "-84.60491000"
                    },
                    {
                        "id": 117556,
                        "name": "Grayling",
                        "latitude": "44.66140000",
                        "longitude": "-84.71475000"
                    },
                    {
                        "id": 117690,
                        "name": "Greenville",
                        "latitude": "43.17753000",
                        "longitude": "-85.25280000"
                    },
                    {
                        "id": 117719,
                        "name": "Greilickville",
                        "latitude": "44.78306000",
                        "longitude": "-85.63869000"
                    },
                    {
                        "id": 117743,
                        "name": "Grosse Ile",
                        "latitude": "42.12921000",
                        "longitude": "-83.14437000"
                    },
                    {
                        "id": 117744,
                        "name": "Grosse Pointe",
                        "latitude": "42.38615000",
                        "longitude": "-82.91186000"
                    },
                    {
                        "id": 117745,
                        "name": "Grosse Pointe Farms",
                        "latitude": "42.40920000",
                        "longitude": "-82.89186000"
                    },
                    {
                        "id": 117746,
                        "name": "Grosse Pointe Park",
                        "latitude": "42.37587000",
                        "longitude": "-82.93742000"
                    },
                    {
                        "id": 117747,
                        "name": "Grosse Pointe Shores",
                        "latitude": "42.43670000",
                        "longitude": "-82.87686000"
                    },
                    {
                        "id": 117748,
                        "name": "Grosse Pointe Woods",
                        "latitude": "42.44365000",
                        "longitude": "-82.90686000"
                    },
                    {
                        "id": 117820,
                        "name": "Gwinn",
                        "latitude": "46.28106000",
                        "longitude": "-87.44097000"
                    },
                    {
                        "id": 117940,
                        "name": "Hamtramck",
                        "latitude": "42.39282000",
                        "longitude": "-83.04964000"
                    },
                    {
                        "id": 117949,
                        "name": "Hancock",
                        "latitude": "47.12687000",
                        "longitude": "-88.58096000"
                    },
                    {
                        "id": 117988,
                        "name": "Harbor Beach",
                        "latitude": "43.84474000",
                        "longitude": "-82.65132000"
                    },
                    {
                        "id": 117991,
                        "name": "Harbor Springs",
                        "latitude": "45.43168000",
                        "longitude": "-84.99200000"
                    },
                    {
                        "id": 118035,
                        "name": "Harper Woods",
                        "latitude": "42.43309000",
                        "longitude": "-82.92408000"
                    },
                    {
                        "id": 118057,
                        "name": "Harrison",
                        "latitude": "44.01919000",
                        "longitude": "-84.79947000"
                    },
                    {
                        "id": 118074,
                        "name": "Harrisville",
                        "latitude": "44.65640000",
                        "longitude": "-83.29469000"
                    },
                    {
                        "id": 118080,
                        "name": "Hart",
                        "latitude": "43.69834000",
                        "longitude": "-86.36397000"
                    },
                    {
                        "id": 118088,
                        "name": "Hartford",
                        "latitude": "42.20671000",
                        "longitude": "-86.16669000"
                    },
                    {
                        "id": 118113,
                        "name": "Harvey",
                        "latitude": "46.49466000",
                        "longitude": "-87.35431000"
                    },
                    {
                        "id": 118129,
                        "name": "Haslett",
                        "latitude": "42.74698000",
                        "longitude": "-84.40108000"
                    },
                    {
                        "id": 118131,
                        "name": "Hastings",
                        "latitude": "42.64587000",
                        "longitude": "-85.29084000"
                    },
                    {
                        "id": 118206,
                        "name": "Hazel Park",
                        "latitude": "42.46254000",
                        "longitude": "-83.10409000"
                    },
                    {
                        "id": 118265,
                        "name": "Hemlock",
                        "latitude": "43.41475000",
                        "longitude": "-84.23054000"
                    },
                    {
                        "id": 118412,
                        "name": "Highland Park",
                        "latitude": "42.40559000",
                        "longitude": "-83.09687000"
                    },
                    {
                        "id": 118460,
                        "name": "Hillsdale",
                        "latitude": "41.92005000",
                        "longitude": "-84.63051000"
                    },
                    {
                        "id": 118462,
                        "name": "Hillsdale County",
                        "latitude": "41.88777000",
                        "longitude": "-84.59293000"
                    },
                    {
                        "id": 118539,
                        "name": "Holland",
                        "latitude": "42.78752000",
                        "longitude": "-86.10893000"
                    },
                    {
                        "id": 118555,
                        "name": "Holly",
                        "latitude": "42.79197000",
                        "longitude": "-83.62773000"
                    },
                    {
                        "id": 118575,
                        "name": "Holt",
                        "latitude": "42.64059000",
                        "longitude": "-84.51525000"
                    },
                    {
                        "id": 118595,
                        "name": "Homer",
                        "latitude": "42.14588000",
                        "longitude": "-84.80886000"
                    },
                    {
                        "id": 118689,
                        "name": "Houghton",
                        "latitude": "47.12187000",
                        "longitude": "-88.56901000"
                    },
                    {
                        "id": 118691,
                        "name": "Houghton County",
                        "latitude": "46.99155000",
                        "longitude": "-88.65206000"
                    },
                    {
                        "id": 118692,
                        "name": "Houghton Lake",
                        "latitude": "44.31474000",
                        "longitude": "-84.76475000"
                    },
                    {
                        "id": 118711,
                        "name": "Howard City",
                        "latitude": "43.39558000",
                        "longitude": "-85.46782000"
                    },
                    {
                        "id": 118722,
                        "name": "Howell",
                        "latitude": "42.60726000",
                        "longitude": "-83.92940000"
                    },
                    {
                        "id": 118733,
                        "name": "Hubbard Lake",
                        "latitude": "44.75973000",
                        "longitude": "-83.54442000"
                    },
                    {
                        "id": 118741,
                        "name": "Hudson",
                        "latitude": "41.85505000",
                        "longitude": "-84.35384000"
                    },
                    {
                        "id": 118753,
                        "name": "Hudsonville",
                        "latitude": "42.87086000",
                        "longitude": "-85.86504000"
                    },
                    {
                        "id": 118809,
                        "name": "Huntington Woods",
                        "latitude": "42.48059000",
                        "longitude": "-83.16687000"
                    },
                    {
                        "id": 118826,
                        "name": "Huron County",
                        "latitude": "43.91007000",
                        "longitude": "-82.85551000"
                    },
                    {
                        "id": 118879,
                        "name": "Imlay City",
                        "latitude": "43.02475000",
                        "longitude": "-83.07772000"
                    },
                    {
                        "id": 118912,
                        "name": "Indian River",
                        "latitude": "45.41251000",
                        "longitude": "-84.61254000"
                    },
                    {
                        "id": 118935,
                        "name": "Ingham County",
                        "latitude": "42.59710000",
                        "longitude": "-84.37354000"
                    },
                    {
                        "id": 118943,
                        "name": "Inkster",
                        "latitude": "42.29420000",
                        "longitude": "-83.30993000"
                    },
                    {
                        "id": 118971,
                        "name": "Ionia",
                        "latitude": "42.98725000",
                        "longitude": "-85.07112000"
                    },
                    {
                        "id": 118972,
                        "name": "Ionia County",
                        "latitude": "42.94509000",
                        "longitude": "-85.07460000"
                    },
                    {
                        "id": 118973,
                        "name": "Iosco County",
                        "latitude": "44.30125000",
                        "longitude": "-83.51395000"
                    },
                    {
                        "id": 118989,
                        "name": "Iron County",
                        "latitude": "46.20869000",
                        "longitude": "-88.53053000"
                    },
                    {
                        "id": 118992,
                        "name": "Iron Mountain",
                        "latitude": "45.82023000",
                        "longitude": "-88.06596000"
                    },
                    {
                        "id": 118993,
                        "name": "Iron River",
                        "latitude": "46.09273000",
                        "longitude": "-88.64235000"
                    },
                    {
                        "id": 118999,
                        "name": "Ironwood",
                        "latitude": "46.45467000",
                        "longitude": "-90.17101000"
                    },
                    {
                        "id": 119016,
                        "name": "Isabella County",
                        "latitude": "43.64060000",
                        "longitude": "-84.84680000"
                    },
                    {
                        "id": 119020,
                        "name": "Ishpeming",
                        "latitude": "46.48855000",
                        "longitude": "-87.66764000"
                    },
                    {
                        "id": 119043,
                        "name": "Ithaca",
                        "latitude": "43.29170000",
                        "longitude": "-84.60750000"
                    },
                    {
                        "id": 119071,
                        "name": "Jackson",
                        "latitude": "42.24587000",
                        "longitude": "-84.40135000"
                    },
                    {
                        "id": 119091,
                        "name": "Jackson County",
                        "latitude": "42.24849000",
                        "longitude": "-84.42344000"
                    },
                    {
                        "id": 119213,
                        "name": "Jenison",
                        "latitude": "42.90725000",
                        "longitude": "-85.79198000"
                    },
                    {
                        "id": 119312,
                        "name": "Jonesville",
                        "latitude": "41.98421000",
                        "longitude": "-84.66190000"
                    },
                    {
                        "id": 119347,
                        "name": "K. I. Sawyer Air Force Base",
                        "latitude": "46.34651000",
                        "longitude": "-87.38632000"
                    },
                    {
                        "id": 119360,
                        "name": "Kalamazoo",
                        "latitude": "42.29171000",
                        "longitude": "-85.58723000"
                    },
                    {
                        "id": 119361,
                        "name": "Kalamazoo County",
                        "latitude": "42.24545000",
                        "longitude": "-85.53118000"
                    },
                    {
                        "id": 119366,
                        "name": "Kalkaska",
                        "latitude": "44.73417000",
                        "longitude": "-85.17589000"
                    },
                    {
                        "id": 119367,
                        "name": "Kalkaska County",
                        "latitude": "44.68466000",
                        "longitude": "-85.09023000"
                    },
                    {
                        "id": 119418,
                        "name": "Keego Harbor",
                        "latitude": "42.60809000",
                        "longitude": "-83.34382000"
                    },
                    {
                        "id": 119489,
                        "name": "Kent City",
                        "latitude": "43.22002000",
                        "longitude": "-85.75115000"
                    },
                    {
                        "id": 119492,
                        "name": "Kent County",
                        "latitude": "43.03216000",
                        "longitude": "-85.54930000"
                    },
                    {
                        "id": 119501,
                        "name": "Kentwood",
                        "latitude": "42.86947000",
                        "longitude": "-85.64475000"
                    },
                    {
                        "id": 119536,
                        "name": "Keweenaw County",
                        "latitude": "47.28296000",
                        "longitude": "-88.21198000"
                    },
                    {
                        "id": 119562,
                        "name": "Kilmanagh",
                        "latitude": "43.75613000",
                        "longitude": "-83.35690000"
                    },
                    {
                        "id": 119612,
                        "name": "Kingsford",
                        "latitude": "45.79496000",
                        "longitude": "-88.07207000"
                    },
                    {
                        "id": 119618,
                        "name": "Kingsley",
                        "latitude": "44.58473000",
                        "longitude": "-85.53590000"
                    },
                    {
                        "id": 119734,
                        "name": "L'Anse",
                        "latitude": "46.75660000",
                        "longitude": "-88.45291000"
                    },
                    {
                        "id": 119861,
                        "name": "Laingsburg",
                        "latitude": "42.89031000",
                        "longitude": "-84.35136000"
                    },
                    {
                        "id": 119884,
                        "name": "Lake City",
                        "latitude": "44.33529000",
                        "longitude": "-85.21505000"
                    },
                    {
                        "id": 119893,
                        "name": "Lake County",
                        "latitude": "43.99001000",
                        "longitude": "-85.80170000"
                    },
                    {
                        "id": 119908,
                        "name": "Lake Fenton",
                        "latitude": "42.84614000",
                        "longitude": "-83.70773000"
                    },
                    {
                        "id": 119922,
                        "name": "Lake Isabella",
                        "latitude": "43.64364000",
                        "longitude": "-84.99725000"
                    },
                    {
                        "id": 119941,
                        "name": "Lake Michigan Beach",
                        "latitude": "42.22087000",
                        "longitude": "-86.36947000"
                    },
                    {
                        "id": 119953,
                        "name": "Lake Odessa",
                        "latitude": "42.78476000",
                        "longitude": "-85.13834000"
                    },
                    {
                        "id": 119954,
                        "name": "Lake Orion",
                        "latitude": "42.78448000",
                        "longitude": "-83.23966000"
                    },
                    {
                        "id": 120038,
                        "name": "Lakeview",
                        "latitude": "43.44642000",
                        "longitude": "-85.27420000"
                    },
                    {
                        "id": 120053,
                        "name": "Lakewood Club",
                        "latitude": "43.37112000",
                        "longitude": "-86.26034000"
                    },
                    {
                        "id": 120068,
                        "name": "Lambertville",
                        "latitude": "41.76588000",
                        "longitude": "-83.62799000"
                    },
                    {
                        "id": 120127,
                        "name": "Lansing",
                        "latitude": "42.73253000",
                        "longitude": "-84.55553000"
                    },
                    {
                        "id": 120131,
                        "name": "Lapeer",
                        "latitude": "43.05142000",
                        "longitude": "-83.31883000"
                    },
                    {
                        "id": 120132,
                        "name": "Lapeer County",
                        "latitude": "43.09015000",
                        "longitude": "-83.22178000"
                    },
                    {
                        "id": 120171,
                        "name": "Lathrup Village",
                        "latitude": "42.49642000",
                        "longitude": "-83.22271000"
                    },
                    {
                        "id": 120211,
                        "name": "Laurium",
                        "latitude": "47.23743000",
                        "longitude": "-88.44317000"
                    },
                    {
                        "id": 120251,
                        "name": "Lawton",
                        "latitude": "42.16726000",
                        "longitude": "-85.84695000"
                    },
                    {
                        "id": 120322,
                        "name": "Leelanau County",
                        "latitude": "45.15177000",
                        "longitude": "-86.03850000"
                    },
                    {
                        "id": 120351,
                        "name": "Leland",
                        "latitude": "45.02305000",
                        "longitude": "-85.75981000"
                    },
                    {
                        "id": 120368,
                        "name": "Lenawee County",
                        "latitude": "41.89508000",
                        "longitude": "-84.06636000"
                    },
                    {
                        "id": 120396,
                        "name": "Leslie",
                        "latitude": "42.45143000",
                        "longitude": "-84.43247000"
                    },
                    {
                        "id": 120403,
                        "name": "Level Park-Oak Park",
                        "latitude": "42.36418000",
                        "longitude": "-85.26650000"
                    },
                    {
                        "id": 120424,
                        "name": "Lewiston",
                        "latitude": "44.88390000",
                        "longitude": "-84.30557000"
                    },
                    {
                        "id": 120451,
                        "name": "Lexington",
                        "latitude": "43.26808000",
                        "longitude": "-82.53076000"
                    },
                    {
                        "id": 120541,
                        "name": "Lincoln Park",
                        "latitude": "42.25059000",
                        "longitude": "-83.17854000"
                    },
                    {
                        "id": 120563,
                        "name": "Linden",
                        "latitude": "42.81447000",
                        "longitude": "-83.78245000"
                    },
                    {
                        "id": 120606,
                        "name": "Litchfield",
                        "latitude": "42.04393000",
                        "longitude": "-84.75746000"
                    },
                    {
                        "id": 120657,
                        "name": "Livingston County",
                        "latitude": "42.60292000",
                        "longitude": "-83.91153000"
                    },
                    {
                        "id": 120662,
                        "name": "Livonia",
                        "latitude": "42.36837000",
                        "longitude": "-83.35271000"
                    },
                    {
                        "id": 120837,
                        "name": "Lowell",
                        "latitude": "42.93364000",
                        "longitude": "-85.34196000"
                    },
                    {
                        "id": 120863,
                        "name": "Luce County",
                        "latitude": "46.36778000",
                        "longitude": "-85.50934000"
                    },
                    {
                        "id": 120868,
                        "name": "Ludington",
                        "latitude": "43.95528000",
                        "longitude": "-86.45258000"
                    },
                    {
                        "id": 120885,
                        "name": "Luna Pier",
                        "latitude": "41.80699000",
                        "longitude": "-83.44243000"
                    },
                    {
                        "id": 120959,
                        "name": "Mackinac County",
                        "latitude": "45.87184000",
                        "longitude": "-84.76227000"
                    },
                    {
                        "id": 120962,
                        "name": "Macomb County",
                        "latitude": "42.67279000",
                        "longitude": "-82.91016000"
                    },
                    {
                        "id": 121021,
                        "name": "Madison Heights",
                        "latitude": "42.48587000",
                        "longitude": "-83.10520000"
                    },
                    {
                        "id": 121087,
                        "name": "Mancelona",
                        "latitude": "44.90223000",
                        "longitude": "-85.06088000"
                    },
                    {
                        "id": 121096,
                        "name": "Manchester",
                        "latitude": "42.15032000",
                        "longitude": "-84.03772000"
                    },
                    {
                        "id": 121121,
                        "name": "Manistee",
                        "latitude": "44.24445000",
                        "longitude": "-86.32425000"
                    },
                    {
                        "id": 121122,
                        "name": "Manistee County",
                        "latitude": "44.23831000",
                        "longitude": "-86.28799000"
                    },
                    {
                        "id": 121123,
                        "name": "Manistique",
                        "latitude": "45.95775000",
                        "longitude": "-86.24625000"
                    },
                    {
                        "id": 121125,
                        "name": "Manitou Beach-Devils Lake",
                        "latitude": "41.97565000",
                        "longitude": "-84.28616000"
                    },
                    {
                        "id": 121158,
                        "name": "Manton",
                        "latitude": "44.41084000",
                        "longitude": "-85.39894000"
                    },
                    {
                        "id": 121194,
                        "name": "Marcellus",
                        "latitude": "42.02588000",
                        "longitude": "-85.81556000"
                    },
                    {
                        "id": 121225,
                        "name": "Marine City",
                        "latitude": "42.71948000",
                        "longitude": "-82.49213000"
                    },
                    {
                        "id": 121282,
                        "name": "Marlette",
                        "latitude": "43.32697000",
                        "longitude": "-83.08022000"
                    },
                    {
                        "id": 121292,
                        "name": "Marquette",
                        "latitude": "46.54354000",
                        "longitude": "-87.39542000"
                    },
                    {
                        "id": 121293,
                        "name": "Marquette County",
                        "latitude": "46.66295000",
                        "longitude": "-87.57350000"
                    },
                    {
                        "id": 121307,
                        "name": "Marshall",
                        "latitude": "42.27226000",
                        "longitude": "-84.96331000"
                    },
                    {
                        "id": 121358,
                        "name": "Marysville",
                        "latitude": "42.91253000",
                        "longitude": "-82.48686000"
                    },
                    {
                        "id": 121373,
                        "name": "Mason",
                        "latitude": "42.57920000",
                        "longitude": "-84.44358000"
                    },
                    {
                        "id": 121381,
                        "name": "Mason County",
                        "latitude": "43.95625000",
                        "longitude": "-86.42258000"
                    },
                    {
                        "id": 121410,
                        "name": "Mattawan",
                        "latitude": "42.20948000",
                        "longitude": "-85.78445000"
                    },
                    {
                        "id": 121589,
                        "name": "Mecosta County",
                        "latitude": "43.64080000",
                        "longitude": "-85.32462000"
                    },
                    {
                        "id": 121637,
                        "name": "Melvindale",
                        "latitude": "42.28254000",
                        "longitude": "-83.17520000"
                    },
                    {
                        "id": 121640,
                        "name": "Memphis",
                        "latitude": "42.89642000",
                        "longitude": "-82.76881000"
                    },
                    {
                        "id": 121662,
                        "name": "Menominee",
                        "latitude": "45.10776000",
                        "longitude": "-87.61427000"
                    },
                    {
                        "id": 121663,
                        "name": "Menominee County",
                        "latitude": "45.52514000",
                        "longitude": "-87.50969000"
                    },
                    {
                        "id": 121759,
                        "name": "Michigan Center",
                        "latitude": "42.23309000",
                        "longitude": "-84.32718000"
                    },
                    {
                        "id": 121795,
                        "name": "Middleville",
                        "latitude": "42.71309000",
                        "longitude": "-85.46196000"
                    },
                    {
                        "id": 121798,
                        "name": "Midland",
                        "latitude": "43.61558000",
                        "longitude": "-84.24721000"
                    },
                    {
                        "id": 121804,
                        "name": "Midland County",
                        "latitude": "43.64686000",
                        "longitude": "-84.38811000"
                    },
                    {
                        "id": 121838,
                        "name": "Milan",
                        "latitude": "42.08532000",
                        "longitude": "-83.68244000"
                    },
                    {
                        "id": 121852,
                        "name": "Milford",
                        "latitude": "42.59364000",
                        "longitude": "-83.59939000"
                    },
                    {
                        "id": 121892,
                        "name": "Millington",
                        "latitude": "43.28141000",
                        "longitude": "-83.52968000"
                    },
                    {
                        "id": 121970,
                        "name": "Mio",
                        "latitude": "44.65224000",
                        "longitude": "-84.12973000"
                    },
                    {
                        "id": 121978,
                        "name": "Missaukee County",
                        "latitude": "44.33730000",
                        "longitude": "-85.09467000"
                    },
                    {
                        "id": 122061,
                        "name": "Monroe",
                        "latitude": "41.91643000",
                        "longitude": "-83.39771000"
                    },
                    {
                        "id": 122079,
                        "name": "Monroe County",
                        "latitude": "41.92140000",
                        "longitude": "-83.49426000"
                    },
                    {
                        "id": 122097,
                        "name": "Montague",
                        "latitude": "43.41668000",
                        "longitude": "-86.35701000"
                    },
                    {
                        "id": 122104,
                        "name": "Montcalm County",
                        "latitude": "43.31096000",
                        "longitude": "-85.15252000"
                    },
                    {
                        "id": 122172,
                        "name": "Montmorency County",
                        "latitude": "45.02755000",
                        "longitude": "-84.12721000"
                    },
                    {
                        "id": 122181,
                        "name": "Montrose",
                        "latitude": "43.17669000",
                        "longitude": "-83.89274000"
                    },
                    {
                        "id": 122229,
                        "name": "Morenci",
                        "latitude": "41.71949000",
                        "longitude": "-84.21800000"
                    },
                    {
                        "id": 122339,
                        "name": "Mount Clemens",
                        "latitude": "42.59726000",
                        "longitude": "-82.87798000"
                    },
                    {
                        "id": 122364,
                        "name": "Mount Morris",
                        "latitude": "43.11864000",
                        "longitude": "-83.69496000"
                    },
                    {
                        "id": 122379,
                        "name": "Mount Pleasant",
                        "latitude": "43.59781000",
                        "longitude": "-84.76751000"
                    },
                    {
                        "id": 122474,
                        "name": "Munising",
                        "latitude": "46.41120000",
                        "longitude": "-86.64926000"
                    },
                    {
                        "id": 122509,
                        "name": "Muskegon",
                        "latitude": "43.23418000",
                        "longitude": "-86.24839000"
                    },
                    {
                        "id": 122510,
                        "name": "Muskegon County",
                        "latitude": "43.21919000",
                        "longitude": "-86.21246000"
                    },
                    {
                        "id": 122511,
                        "name": "Muskegon Heights",
                        "latitude": "43.20113000",
                        "longitude": "-86.23895000"
                    },
                    {
                        "id": 122558,
                        "name": "Napoleon",
                        "latitude": "42.16059000",
                        "longitude": "-84.24606000"
                    },
                    {
                        "id": 122578,
                        "name": "Nashville",
                        "latitude": "42.60281000",
                        "longitude": "-85.09305000"
                    },
                    {
                        "id": 122617,
                        "name": "Negaunee",
                        "latitude": "46.49910000",
                        "longitude": "-87.61180000"
                    },
                    {
                        "id": 122660,
                        "name": "New Baltimore",
                        "latitude": "42.68114000",
                        "longitude": "-82.73686000"
                    },
                    {
                        "id": 122678,
                        "name": "New Buffalo",
                        "latitude": "41.79393000",
                        "longitude": "-86.74392000"
                    },
                    {
                        "id": 122718,
                        "name": "New Haven",
                        "latitude": "42.72948000",
                        "longitude": "-82.80131000"
                    },
                    {
                        "id": 122806,
                        "name": "Newaygo",
                        "latitude": "43.41974000",
                        "longitude": "-85.80005000"
                    },
                    {
                        "id": 122807,
                        "name": "Newaygo County",
                        "latitude": "43.55417000",
                        "longitude": "-85.80091000"
                    },
                    {
                        "id": 122812,
                        "name": "Newberry",
                        "latitude": "46.35500000",
                        "longitude": "-85.50956000"
                    },
                    {
                        "id": 122901,
                        "name": "Niles",
                        "latitude": "41.82977000",
                        "longitude": "-86.25418000"
                    },
                    {
                        "id": 122993,
                        "name": "North Branch",
                        "latitude": "43.22947000",
                        "longitude": "-83.19661000"
                    },
                    {
                        "id": 123069,
                        "name": "North Muskegon",
                        "latitude": "43.25613000",
                        "longitude": "-86.26756000"
                    },
                    {
                        "id": 123170,
                        "name": "Northview",
                        "latitude": "43.04558000",
                        "longitude": "-85.60059000"
                    },
                    {
                        "id": 123171,
                        "name": "Northville",
                        "latitude": "42.43115000",
                        "longitude": "-83.48327000"
                    },
                    {
                        "id": 123187,
                        "name": "Norton Shores",
                        "latitude": "43.16890000",
                        "longitude": "-86.26395000"
                    },
                    {
                        "id": 123192,
                        "name": "Norway",
                        "latitude": "45.78690000",
                        "longitude": "-87.90374000"
                    },
                    {
                        "id": 123208,
                        "name": "Novi",
                        "latitude": "42.48059000",
                        "longitude": "-83.47549000"
                    },
                    {
                        "id": 123256,
                        "name": "Oak Park",
                        "latitude": "42.45948000",
                        "longitude": "-83.18271000"
                    },
                    {
                        "id": 123295,
                        "name": "Oakland County",
                        "latitude": "42.66041000",
                        "longitude": "-83.38580000"
                    },
                    {
                        "id": 123340,
                        "name": "Oceana County",
                        "latitude": "43.68178000",
                        "longitude": "-86.31683000"
                    },
                    {
                        "id": 123373,
                        "name": "Ogemaw County",
                        "latitude": "44.33494000",
                        "longitude": "-84.12641000"
                    },
                    {
                        "id": 123402,
                        "name": "Okemos",
                        "latitude": "42.72226000",
                        "longitude": "-84.42747000"
                    },
                    {
                        "id": 123447,
                        "name": "Olivet",
                        "latitude": "42.44143000",
                        "longitude": "-84.92415000"
                    },
                    {
                        "id": 123489,
                        "name": "Ontonagon",
                        "latitude": "46.87105000",
                        "longitude": "-89.31403000"
                    },
                    {
                        "id": 123490,
                        "name": "Ontonagon County",
                        "latitude": "46.77749000",
                        "longitude": "-89.30511000"
                    },
                    {
                        "id": 123536,
                        "name": "Orchard Lake",
                        "latitude": "42.58309000",
                        "longitude": "-83.35938000"
                    },
                    {
                        "id": 123583,
                        "name": "Ortonville",
                        "latitude": "42.85225000",
                        "longitude": "-83.44300000"
                    },
                    {
                        "id": 123605,
                        "name": "Osceola County",
                        "latitude": "43.98987000",
                        "longitude": "-85.32528000"
                    },
                    {
                        "id": 123607,
                        "name": "Oscoda County",
                        "latitude": "44.68175000",
                        "longitude": "-84.12974000"
                    },
                    {
                        "id": 123632,
                        "name": "Otsego",
                        "latitude": "42.46059000",
                        "longitude": "-85.69641000"
                    },
                    {
                        "id": 123634,
                        "name": "Otsego County",
                        "latitude": "45.02144000",
                        "longitude": "-84.59898000"
                    },
                    {
                        "id": 123640,
                        "name": "Ottawa County",
                        "latitude": "43.00264000",
                        "longitude": "-86.17950000"
                    },
                    {
                        "id": 123655,
                        "name": "Ovid",
                        "latitude": "43.00586000",
                        "longitude": "-84.37164000"
                    },
                    {
                        "id": 123672,
                        "name": "Owosso",
                        "latitude": "42.99780000",
                        "longitude": "-84.17664000"
                    },
                    {
                        "id": 123685,
                        "name": "Oxford",
                        "latitude": "42.82475000",
                        "longitude": "-83.26466000"
                    },
                    {
                        "id": 123827,
                        "name": "Parchment",
                        "latitude": "42.32810000",
                        "longitude": "-85.56973000"
                    },
                    {
                        "id": 123927,
                        "name": "Paw Paw",
                        "latitude": "42.21782000",
                        "longitude": "-85.89112000"
                    },
                    {
                        "id": 123928,
                        "name": "Paw Paw Lake",
                        "latitude": "42.21226000",
                        "longitude": "-86.27197000"
                    },
                    {
                        "id": 123964,
                        "name": "Pearl Beach",
                        "latitude": "42.62670000",
                        "longitude": "-82.59769000"
                    },
                    {
                        "id": 124071,
                        "name": "Perry",
                        "latitude": "42.82642000",
                        "longitude": "-84.21941000"
                    },
                    {
                        "id": 124107,
                        "name": "Petersburg",
                        "latitude": "41.90116000",
                        "longitude": "-83.71494000"
                    },
                    {
                        "id": 124111,
                        "name": "Petoskey",
                        "latitude": "45.37334000",
                        "longitude": "-84.95533000"
                    },
                    {
                        "id": 124182,
                        "name": "Pigeon",
                        "latitude": "43.83002000",
                        "longitude": "-83.26996000"
                    },
                    {
                        "id": 124209,
                        "name": "Pinckney",
                        "latitude": "42.45700000",
                        "longitude": "-83.94791000"
                    },
                    {
                        "id": 124211,
                        "name": "Pinconning",
                        "latitude": "43.85363000",
                        "longitude": "-83.96499000"
                    },
                    {
                        "id": 124336,
                        "name": "Plainwell",
                        "latitude": "42.44004000",
                        "longitude": "-85.64890000"
                    },
                    {
                        "id": 124376,
                        "name": "Pleasant Ridge",
                        "latitude": "42.47115000",
                        "longitude": "-83.14215000"
                    },
                    {
                        "id": 124403,
                        "name": "Plymouth",
                        "latitude": "42.37143000",
                        "longitude": "-83.47021000"
                    },
                    {
                        "id": 124474,
                        "name": "Pontiac",
                        "latitude": "42.63892000",
                        "longitude": "-83.29105000"
                    },
                    {
                        "id": 124511,
                        "name": "Port Huron",
                        "latitude": "42.97086000",
                        "longitude": "-82.42491000"
                    },
                    {
                        "id": 124544,
                        "name": "Portage",
                        "latitude": "42.20115000",
                        "longitude": "-85.58000000"
                    },
                    {
                        "id": 124561,
                        "name": "Portland",
                        "latitude": "42.86920000",
                        "longitude": "-84.90305000"
                    },
                    {
                        "id": 124596,
                        "name": "Potterville",
                        "latitude": "42.62920000",
                        "longitude": "-84.73887000"
                    },
                    {
                        "id": 124650,
                        "name": "Presque Isle County",
                        "latitude": "45.39845000",
                        "longitude": "-83.84354000"
                    },
                    {
                        "id": 124723,
                        "name": "Prudenville",
                        "latitude": "44.29835000",
                        "longitude": "-84.65197000"
                    },
                    {
                        "id": 124798,
                        "name": "Quincy",
                        "latitude": "41.94421000",
                        "longitude": "-84.88385000"
                    },
                    {
                        "id": 124803,
                        "name": "Quinnesec",
                        "latitude": "45.80635000",
                        "longitude": "-87.98846000"
                    },
                    {
                        "id": 124893,
                        "name": "Rapid City",
                        "latitude": "44.83445000",
                        "longitude": "-85.28256000"
                    },
                    {
                        "id": 124907,
                        "name": "Ravenna",
                        "latitude": "43.18947000",
                        "longitude": "-85.93699000"
                    },
                    {
                        "id": 124930,
                        "name": "Reading",
                        "latitude": "41.83949000",
                        "longitude": "-84.74801000"
                    },
                    {
                        "id": 124969,
                        "name": "Redford",
                        "latitude": "42.38337000",
                        "longitude": "-83.29660000"
                    },
                    {
                        "id": 124991,
                        "name": "Reed City",
                        "latitude": "43.87502000",
                        "longitude": "-85.51005000"
                    },
                    {
                        "id": 124997,
                        "name": "Reese",
                        "latitude": "43.45058000",
                        "longitude": "-83.69635000"
                    },
                    {
                        "id": 125092,
                        "name": "Richmond",
                        "latitude": "42.80920000",
                        "longitude": "-82.75576000"
                    },
                    {
                        "id": 125187,
                        "name": "River Rouge",
                        "latitude": "42.27337000",
                        "longitude": "-83.13437000"
                    },
                    {
                        "id": 125219,
                        "name": "Riverview",
                        "latitude": "42.17421000",
                        "longitude": "-83.17937000"
                    },
                    {
                        "id": 125264,
                        "name": "Rochester",
                        "latitude": "42.68059000",
                        "longitude": "-83.13382000"
                    },
                    {
                        "id": 125271,
                        "name": "Rochester Hills",
                        "latitude": "42.65837000",
                        "longitude": "-83.14993000"
                    },
                    {
                        "id": 125301,
                        "name": "Rockford",
                        "latitude": "43.12003000",
                        "longitude": "-85.56003000"
                    },
                    {
                        "id": 125333,
                        "name": "Rockwood",
                        "latitude": "42.07088000",
                        "longitude": "-83.24660000"
                    },
                    {
                        "id": 125351,
                        "name": "Rogers City",
                        "latitude": "45.42140000",
                        "longitude": "-83.81833000"
                    },
                    {
                        "id": 125381,
                        "name": "Romeo",
                        "latitude": "42.80281000",
                        "longitude": "-83.01299000"
                    },
                    {
                        "id": 125385,
                        "name": "Romulus",
                        "latitude": "42.22226000",
                        "longitude": "-83.39660000"
                    },
                    {
                        "id": 125396,
                        "name": "Roosevelt Park",
                        "latitude": "43.19640000",
                        "longitude": "-86.27228000"
                    },
                    {
                        "id": 125401,
                        "name": "Roscommon",
                        "latitude": "44.49835000",
                        "longitude": "-84.59197000"
                    },
                    {
                        "id": 125402,
                        "name": "Roscommon County",
                        "latitude": "44.33561000",
                        "longitude": "-84.61160000"
                    },
                    {
                        "id": 125439,
                        "name": "Roseville",
                        "latitude": "42.49726000",
                        "longitude": "-82.93714000"
                    },
                    {
                        "id": 125490,
                        "name": "Royal Oak",
                        "latitude": "42.48948000",
                        "longitude": "-83.14465000"
                    },
                    {
                        "id": 125588,
                        "name": "Saginaw",
                        "latitude": "43.41947000",
                        "longitude": "-83.95081000"
                    },
                    {
                        "id": 125589,
                        "name": "Saginaw County",
                        "latitude": "43.33503000",
                        "longitude": "-84.05319000"
                    },
                    {
                        "id": 125590,
                        "name": "Saginaw Township North",
                        "latitude": "43.46004000",
                        "longitude": "-84.00674000"
                    },
                    {
                        "id": 125614,
                        "name": "Saint Charles",
                        "latitude": "43.29697000",
                        "longitude": "-84.14053000"
                    },
                    {
                        "id": 125619,
                        "name": "Saint Clair",
                        "latitude": "42.82087000",
                        "longitude": "-82.48602000"
                    },
                    {
                        "id": 125624,
                        "name": "Saint Clair County",
                        "latitude": "42.93112000",
                        "longitude": "-82.66437000"
                    },
                    {
                        "id": 125625,
                        "name": "Saint Clair Shores",
                        "latitude": "42.49698000",
                        "longitude": "-82.88881000"
                    },
                    {
                        "id": 125646,
                        "name": "Saint Helen",
                        "latitude": "44.36363000",
                        "longitude": "-84.41029000"
                    },
                    {
                        "id": 125650,
                        "name": "Saint Ignace",
                        "latitude": "45.86614000",
                        "longitude": "-84.72751000"
                    },
                    {
                        "id": 125665,
                        "name": "Saint Johns",
                        "latitude": "43.00114000",
                        "longitude": "-84.55915000"
                    },
                    {
                        "id": 125673,
                        "name": "Saint Joseph",
                        "latitude": "42.10976000",
                        "longitude": "-86.48002000"
                    },
                    {
                        "id": 125676,
                        "name": "Saint Joseph County",
                        "latitude": "41.91441000",
                        "longitude": "-85.52774000"
                    },
                    {
                        "id": 125680,
                        "name": "Saint Louis",
                        "latitude": "43.40836000",
                        "longitude": "-84.60667000"
                    },
                    {
                        "id": 125748,
                        "name": "Saline",
                        "latitude": "42.16671000",
                        "longitude": "-83.78161000"
                    },
                    {
                        "id": 125859,
                        "name": "Sand Lake",
                        "latitude": "44.31918000",
                        "longitude": "-83.68470000"
                    },
                    {
                        "id": 125875,
                        "name": "Sandusky",
                        "latitude": "43.42030000",
                        "longitude": "-82.82966000"
                    },
                    {
                        "id": 125895,
                        "name": "Sanilac County",
                        "latitude": "43.44331000",
                        "longitude": "-82.64575000"
                    },
                    {
                        "id": 125935,
                        "name": "Saranac",
                        "latitude": "42.92948000",
                        "longitude": "-85.21307000"
                    },
                    {
                        "id": 125968,
                        "name": "Sault Ste. Marie",
                        "latitude": "46.49530000",
                        "longitude": "-84.34532000"
                    },
                    {
                        "id": 126017,
                        "name": "Schoolcraft",
                        "latitude": "42.11421000",
                        "longitude": "-85.63778000"
                    },
                    {
                        "id": 126018,
                        "name": "Schoolcraft County",
                        "latitude": "46.04249000",
                        "longitude": "-86.17730000"
                    },
                    {
                        "id": 126066,
                        "name": "Scottville",
                        "latitude": "43.95473000",
                        "longitude": "-86.28008000"
                    },
                    {
                        "id": 126109,
                        "name": "Sebewaing",
                        "latitude": "43.73224000",
                        "longitude": "-83.45107000"
                    },
                    {
                        "id": 126270,
                        "name": "Shelby",
                        "latitude": "43.60862000",
                        "longitude": "-86.36396000"
                    },
                    {
                        "id": 126310,
                        "name": "Shepherd",
                        "latitude": "43.52447000",
                        "longitude": "-84.69473000"
                    },
                    {
                        "id": 126345,
                        "name": "Shiawassee County",
                        "latitude": "42.95373000",
                        "longitude": "-84.14673000"
                    },
                    {
                        "id": 126346,
                        "name": "Shields",
                        "latitude": "43.41530000",
                        "longitude": "-84.05637000"
                    },
                    {
                        "id": 126375,
                        "name": "Shorewood-Tower Hills-Harbert",
                        "latitude": "41.88169000",
                        "longitude": "-86.61409000"
                    },
                    {
                        "id": 126480,
                        "name": "Skidway Lake",
                        "latitude": "44.18335000",
                        "longitude": "-84.03527000"
                    },
                    {
                        "id": 126664,
                        "name": "South Gull Lake",
                        "latitude": "42.38754000",
                        "longitude": "-85.39667000"
                    },
                    {
                        "id": 126667,
                        "name": "South Haven",
                        "latitude": "42.40309000",
                        "longitude": "-86.27364000"
                    },
                    {
                        "id": 126690,
                        "name": "South Lyon",
                        "latitude": "42.46059000",
                        "longitude": "-83.65161000"
                    },
                    {
                        "id": 126694,
                        "name": "South Monroe",
                        "latitude": "41.89588000",
                        "longitude": "-83.41771000"
                    },
                    {
                        "id": 126718,
                        "name": "South Rockwood",
                        "latitude": "42.06393000",
                        "longitude": "-83.26104000"
                    },
                    {
                        "id": 126772,
                        "name": "Southfield",
                        "latitude": "42.47337000",
                        "longitude": "-83.22187000"
                    },
                    {
                        "id": 126775,
                        "name": "Southgate",
                        "latitude": "42.21393000",
                        "longitude": "-83.19381000"
                    },
                    {
                        "id": 126811,
                        "name": "Sparta",
                        "latitude": "43.16086000",
                        "longitude": "-85.71004000"
                    },
                    {
                        "id": 126850,
                        "name": "Spring Arbor",
                        "latitude": "42.20504000",
                        "longitude": "-84.55274000"
                    },
                    {
                        "id": 126866,
                        "name": "Spring Lake",
                        "latitude": "43.07696000",
                        "longitude": "-86.19700000"
                    },
                    {
                        "id": 126898,
                        "name": "Springfield",
                        "latitude": "42.32643000",
                        "longitude": "-85.23916000"
                    },
                    {
                        "id": 126942,
                        "name": "Stambaugh Iron River",
                        "latitude": "46.08107000",
                        "longitude": "-88.62708000"
                    },
                    {
                        "id": 126950,
                        "name": "Standish",
                        "latitude": "43.98308000",
                        "longitude": "-83.95888000"
                    },
                    {
                        "id": 126967,
                        "name": "Stanton",
                        "latitude": "43.29253000",
                        "longitude": "-85.08141000"
                    },
                    {
                        "id": 127034,
                        "name": "Sterling Heights",
                        "latitude": "42.58031000",
                        "longitude": "-83.03020000"
                    },
                    {
                        "id": 127048,
                        "name": "Stevensville",
                        "latitude": "42.01449000",
                        "longitude": "-86.51947000"
                    },
                    {
                        "id": 127069,
                        "name": "Stockbridge",
                        "latitude": "42.45115000",
                        "longitude": "-84.18051000"
                    },
                    {
                        "id": 127099,
                        "name": "Stony Point",
                        "latitude": "41.94143000",
                        "longitude": "-83.26493000"
                    },
                    {
                        "id": 127151,
                        "name": "Sturgis",
                        "latitude": "41.79922000",
                        "longitude": "-85.41915000"
                    },
                    {
                        "id": 127332,
                        "name": "Swartz Creek",
                        "latitude": "42.95725000",
                        "longitude": "-83.83051000"
                    },
                    {
                        "id": 127357,
                        "name": "Sylvan Lake",
                        "latitude": "42.61142000",
                        "longitude": "-83.32855000"
                    },
                    {
                        "id": 127444,
                        "name": "Tawas City",
                        "latitude": "44.26946000",
                        "longitude": "-83.51470000"
                    },
                    {
                        "id": 127447,
                        "name": "Taylor",
                        "latitude": "42.24087000",
                        "longitude": "-83.26965000"
                    },
                    {
                        "id": 127479,
                        "name": "Tecumseh",
                        "latitude": "42.00393000",
                        "longitude": "-83.94494000"
                    },
                    {
                        "id": 127496,
                        "name": "Temperance",
                        "latitude": "41.77921000",
                        "longitude": "-83.56882000"
                    },
                    {
                        "id": 127615,
                        "name": "Three Oaks",
                        "latitude": "41.79865000",
                        "longitude": "-86.61058000"
                    },
                    {
                        "id": 127618,
                        "name": "Three Rivers",
                        "latitude": "41.94394000",
                        "longitude": "-85.63249000"
                    },
                    {
                        "id": 127784,
                        "name": "Traverse City",
                        "latitude": "44.76306000",
                        "longitude": "-85.62063000"
                    },
                    {
                        "id": 127806,
                        "name": "Trenton",
                        "latitude": "42.13949000",
                        "longitude": "-83.17826000"
                    },
                    {
                        "id": 127840,
                        "name": "Trowbridge Park",
                        "latitude": "46.55660000",
                        "longitude": "-87.43736000"
                    },
                    {
                        "id": 127848,
                        "name": "Troy",
                        "latitude": "42.60559000",
                        "longitude": "-83.14993000"
                    },
                    {
                        "id": 127912,
                        "name": "Tuscola County",
                        "latitude": "43.49134000",
                        "longitude": "-83.43987000"
                    },
                    {
                        "id": 127927,
                        "name": "Twin Lake",
                        "latitude": "43.36279000",
                        "longitude": "-86.16478000"
                    },
                    {
                        "id": 127984,
                        "name": "Union City",
                        "latitude": "42.06671000",
                        "longitude": "-85.13609000"
                    },
                    {
                        "id": 128066,
                        "name": "Utica",
                        "latitude": "42.62614000",
                        "longitude": "-83.03354000"
                    },
                    {
                        "id": 128132,
                        "name": "Van Buren County",
                        "latitude": "42.28511000",
                        "longitude": "-86.30642000"
                    },
                    {
                        "id": 128151,
                        "name": "Vandercook Lake",
                        "latitude": "42.19337000",
                        "longitude": "-84.39107000"
                    },
                    {
                        "id": 128159,
                        "name": "Vassar",
                        "latitude": "43.37197000",
                        "longitude": "-83.58329000"
                    },
                    {
                        "id": 128216,
                        "name": "Vicksburg",
                        "latitude": "42.12005000",
                        "longitude": "-85.53278000"
                    },
                    {
                        "id": 128318,
                        "name": "Wacousta",
                        "latitude": "42.82781000",
                        "longitude": "-84.70082000"
                    },
                    {
                        "id": 128360,
                        "name": "Wakefield",
                        "latitude": "46.47523000",
                        "longitude": "-89.93989000"
                    },
                    {
                        "id": 128384,
                        "name": "Walker",
                        "latitude": "43.00141000",
                        "longitude": "-85.76809000"
                    },
                    {
                        "id": 128401,
                        "name": "Walled Lake",
                        "latitude": "42.53781000",
                        "longitude": "-83.48105000"
                    },
                    {
                        "id": 128481,
                        "name": "Warren",
                        "latitude": "42.49044000",
                        "longitude": "-83.01304000"
                    },
                    {
                        "id": 128592,
                        "name": "Washtenaw County",
                        "latitude": "42.25323000",
                        "longitude": "-83.83877000"
                    },
                    {
                        "id": 128605,
                        "name": "Waterford",
                        "latitude": "42.69303000",
                        "longitude": "-83.41181000"
                    },
                    {
                        "id": 128631,
                        "name": "Watervliet",
                        "latitude": "42.18671000",
                        "longitude": "-86.26058000"
                    },
                    {
                        "id": 128669,
                        "name": "Waverly",
                        "latitude": "42.73920000",
                        "longitude": "-84.62081000"
                    },
                    {
                        "id": 128679,
                        "name": "Wayland",
                        "latitude": "42.67392000",
                        "longitude": "-85.64474000"
                    },
                    {
                        "id": 128683,
                        "name": "Wayne",
                        "latitude": "42.28143000",
                        "longitude": "-83.38632000"
                    },
                    {
                        "id": 128699,
                        "name": "Wayne County",
                        "latitude": "42.28478000",
                        "longitude": "-83.26113000"
                    },
                    {
                        "id": 128727,
                        "name": "Webberville",
                        "latitude": "42.66698000",
                        "longitude": "-84.17413000"
                    },
                    {
                        "id": 128828,
                        "name": "West Bloomfield Township",
                        "latitude": "42.56891000",
                        "longitude": "-83.38356000"
                    },
                    {
                        "id": 128833,
                        "name": "West Branch",
                        "latitude": "44.27641000",
                        "longitude": "-84.23861000"
                    },
                    {
                        "id": 128902,
                        "name": "West Ishpeming",
                        "latitude": "46.48355000",
                        "longitude": "-87.70097000"
                    },
                    {
                        "id": 128936,
                        "name": "West Monroe",
                        "latitude": "41.91393000",
                        "longitude": "-83.43160000"
                    },
                    {
                        "id": 129041,
                        "name": "Westland",
                        "latitude": "42.32420000",
                        "longitude": "-83.40021000"
                    },
                    {
                        "id": 129084,
                        "name": "Westwood",
                        "latitude": "42.30282000",
                        "longitude": "-85.63362000"
                    },
                    {
                        "id": 129097,
                        "name": "Wexford County",
                        "latitude": "44.33835000",
                        "longitude": "-85.57842000"
                    },
                    {
                        "id": 129133,
                        "name": "White Cloud",
                        "latitude": "43.55030000",
                        "longitude": "-85.77200000"
                    },
                    {
                        "id": 129151,
                        "name": "White Pigeon",
                        "latitude": "41.79811000",
                        "longitude": "-85.64332000"
                    },
                    {
                        "id": 129168,
                        "name": "Whitehall",
                        "latitude": "43.41001000",
                        "longitude": "-86.34868000"
                    },
                    {
                        "id": 129206,
                        "name": "Whitmore Lake",
                        "latitude": "42.43970000",
                        "longitude": "-83.74530000"
                    },
                    {
                        "id": 129284,
                        "name": "Williamston",
                        "latitude": "42.68892000",
                        "longitude": "-84.28302000"
                    },
                    {
                        "id": 129465,
                        "name": "Wixom",
                        "latitude": "42.52476000",
                        "longitude": "-83.53633000"
                    },
                    {
                        "id": 129472,
                        "name": "Wolf Lake",
                        "latitude": "43.25474000",
                        "longitude": "-86.10978000"
                    },
                    {
                        "id": 129481,
                        "name": "Wolverine Lake",
                        "latitude": "42.55670000",
                        "longitude": "-83.47383000"
                    },
                    {
                        "id": 129521,
                        "name": "Woodhaven",
                        "latitude": "42.13893000",
                        "longitude": "-83.24160000"
                    },
                    {
                        "id": 129528,
                        "name": "Woodland Beach",
                        "latitude": "41.94005000",
                        "longitude": "-83.31326000"
                    },
                    {
                        "id": 129621,
                        "name": "Wyandotte",
                        "latitude": "42.21421000",
                        "longitude": "-83.14992000"
                    },
                    {
                        "id": 129636,
                        "name": "Wyoming",
                        "latitude": "42.91336000",
                        "longitude": "-85.70531000"
                    },
                    {
                        "id": 129655,
                        "name": "Yale",
                        "latitude": "43.13003000",
                        "longitude": "-82.79826000"
                    },
                    {
                        "id": 129724,
                        "name": "Ypsilanti",
                        "latitude": "42.24115000",
                        "longitude": "-83.61299000"
                    },
                    {
                        "id": 129744,
                        "name": "Zeeland",
                        "latitude": "42.81252000",
                        "longitude": "-86.01865000"
                    },
                    {
                        "id": 129755,
                        "name": "Zilwaukee",
                        "latitude": "43.47641000",
                        "longitude": "-83.92053000"
                    }
                ]
            },
            {
                "id": 1438,
                "name": "Midway Atoll",
                "iso2": "UM-71",
                "latitude": "28.20721680",
                "longitude": "-177.37349260",
                "type": "islands \/ groups of islands",
                "cities": []
            },
            {
                "id": 1420,
                "name": "Minnesota",
                "iso2": "MN",
                "latitude": "46.72955300",
                "longitude": "-94.68589980",
                "type": "state",
                "cities": [
                    {
                        "id": 111006,
                        "name": "Ada",
                        "latitude": "47.29969000",
                        "longitude": "-96.51535000"
                    },
                    {
                        "id": 111047,
                        "name": "Adrian",
                        "latitude": "43.63497000",
                        "longitude": "-95.93280000"
                    },
                    {
                        "id": 111053,
                        "name": "Afton",
                        "latitude": "44.90275000",
                        "longitude": "-92.78354000"
                    },
                    {
                        "id": 111073,
                        "name": "Aitkin",
                        "latitude": "46.53301000",
                        "longitude": "-93.71025000"
                    },
                    {
                        "id": 111074,
                        "name": "Aitkin County",
                        "latitude": "46.60826000",
                        "longitude": "-93.41543000"
                    },
                    {
                        "id": 111106,
                        "name": "Albany",
                        "latitude": "45.62996000",
                        "longitude": "-94.57000000"
                    },
                    {
                        "id": 111118,
                        "name": "Albert Lea",
                        "latitude": "43.64801000",
                        "longitude": "-93.36827000"
                    },
                    {
                        "id": 111121,
                        "name": "Albertville",
                        "latitude": "45.23774000",
                        "longitude": "-93.65441000"
                    },
                    {
                        "id": 111154,
                        "name": "Alexandria",
                        "latitude": "45.88524000",
                        "longitude": "-95.37754000"
                    },
                    {
                        "id": 111324,
                        "name": "Andover",
                        "latitude": "45.23330000",
                        "longitude": "-93.29134000"
                    },
                    {
                        "id": 111350,
                        "name": "Annandale",
                        "latitude": "45.26274000",
                        "longitude": "-94.12443000"
                    },
                    {
                        "id": 111358,
                        "name": "Anoka",
                        "latitude": "45.19774000",
                        "longitude": "-93.38718000"
                    },
                    {
                        "id": 111359,
                        "name": "Anoka County",
                        "latitude": "45.27324000",
                        "longitude": "-93.24645000"
                    },
                    {
                        "id": 111393,
                        "name": "Apple Valley",
                        "latitude": "44.73191000",
                        "longitude": "-93.21772000"
                    },
                    {
                        "id": 111396,
                        "name": "Appleton",
                        "latitude": "45.19691000",
                        "longitude": "-96.01977000"
                    },
                    {
                        "id": 111438,
                        "name": "Arden Hills",
                        "latitude": "45.05024000",
                        "longitude": "-93.15661000"
                    },
                    {
                        "id": 111466,
                        "name": "Arlington",
                        "latitude": "44.60830000",
                        "longitude": "-94.08053000"
                    },
                    {
                        "id": 111486,
                        "name": "Arnold",
                        "latitude": "46.88022000",
                        "longitude": "-92.09047000"
                    },
                    {
                        "id": 111612,
                        "name": "Atwater",
                        "latitude": "45.13885000",
                        "longitude": "-94.77806000"
                    },
                    {
                        "id": 111660,
                        "name": "Aurora",
                        "latitude": "47.52993000",
                        "longitude": "-92.23712000"
                    },
                    {
                        "id": 111669,
                        "name": "Austin",
                        "latitude": "43.66663000",
                        "longitude": "-92.97464000"
                    },
                    {
                        "id": 111692,
                        "name": "Avon",
                        "latitude": "45.60913000",
                        "longitude": "-94.45167000"
                    },
                    {
                        "id": 111714,
                        "name": "Babbitt",
                        "latitude": "47.70853000",
                        "longitude": "-91.94460000"
                    },
                    {
                        "id": 111728,
                        "name": "Bagley",
                        "latitude": "47.52162000",
                        "longitude": "-95.39835000"
                    },
                    {
                        "id": 111830,
                        "name": "Barnesville",
                        "latitude": "46.65218000",
                        "longitude": "-96.41979000"
                    },
                    {
                        "id": 111911,
                        "name": "Baudette",
                        "latitude": "48.71247000",
                        "longitude": "-94.59993000"
                    },
                    {
                        "id": 111916,
                        "name": "Baxter",
                        "latitude": "46.34330000",
                        "longitude": "-94.28667000"
                    },
                    {
                        "id": 111951,
                        "name": "Bayport",
                        "latitude": "45.02136000",
                        "longitude": "-92.78104000"
                    },
                    {
                        "id": 112012,
                        "name": "Becker",
                        "latitude": "45.39330000",
                        "longitude": "-93.87692000"
                    },
                    {
                        "id": 112013,
                        "name": "Becker County",
                        "latitude": "46.93465000",
                        "longitude": "-95.67392000"
                    },
                    {
                        "id": 112090,
                        "name": "Belle Plaine",
                        "latitude": "44.62274000",
                        "longitude": "-93.76857000"
                    },
                    {
                        "id": 112150,
                        "name": "Beltrami County",
                        "latitude": "47.97378000",
                        "longitude": "-94.93765000"
                    },
                    {
                        "id": 112160,
                        "name": "Bemidji",
                        "latitude": "47.47356000",
                        "longitude": "-94.88028000"
                    },
                    {
                        "id": 112183,
                        "name": "Benson",
                        "latitude": "45.31496000",
                        "longitude": "-95.60003000"
                    },
                    {
                        "id": 112205,
                        "name": "Benton County",
                        "latitude": "45.69913000",
                        "longitude": "-93.99884000"
                    },
                    {
                        "id": 112323,
                        "name": "Big Lake",
                        "latitude": "45.33246000",
                        "longitude": "-93.74608000"
                    },
                    {
                        "id": 112336,
                        "name": "Big Stone County",
                        "latitude": "45.42610000",
                        "longitude": "-96.41092000"
                    },
                    {
                        "id": 112355,
                        "name": "Birchwood",
                        "latitude": "45.06108000",
                        "longitude": "-92.97605000"
                    },
                    {
                        "id": 112403,
                        "name": "Blaine",
                        "latitude": "45.16080000",
                        "longitude": "-93.23495000"
                    },
                    {
                        "id": 112442,
                        "name": "Blooming Prairie",
                        "latitude": "43.86663000",
                        "longitude": "-93.05103000"
                    },
                    {
                        "id": 112452,
                        "name": "Bloomington",
                        "latitude": "44.84080000",
                        "longitude": "-93.29828000"
                    },
                    {
                        "id": 112465,
                        "name": "Blue Earth",
                        "latitude": "43.63746000",
                        "longitude": "-94.10218000"
                    },
                    {
                        "id": 112466,
                        "name": "Blue Earth County",
                        "latitude": "44.03459000",
                        "longitude": "-94.06703000"
                    },
                    {
                        "id": 112679,
                        "name": "Braham",
                        "latitude": "45.72274000",
                        "longitude": "-93.17078000"
                    },
                    {
                        "id": 112681,
                        "name": "Brainerd",
                        "latitude": "46.35802000",
                        "longitude": "-94.20083000"
                    },
                    {
                        "id": 112684,
                        "name": "Branch",
                        "latitude": "45.48524000",
                        "longitude": "-92.96188000"
                    },
                    {
                        "id": 112712,
                        "name": "Breckenridge",
                        "latitude": "46.26357000",
                        "longitude": "-96.58813000"
                    },
                    {
                        "id": 112718,
                        "name": "Breezy Point",
                        "latitude": "46.59001000",
                        "longitude": "-94.21982000"
                    },
                    {
                        "id": 112874,
                        "name": "Brooklyn Center",
                        "latitude": "45.07608000",
                        "longitude": "-93.33273000"
                    },
                    {
                        "id": 112877,
                        "name": "Brooklyn Park",
                        "latitude": "45.09413000",
                        "longitude": "-93.35634000"
                    },
                    {
                        "id": 112911,
                        "name": "Brown County",
                        "latitude": "44.24217000",
                        "longitude": "-94.72748000"
                    },
                    {
                        "id": 113013,
                        "name": "Buffalo",
                        "latitude": "45.17191000",
                        "longitude": "-93.87469000"
                    },
                    {
                        "id": 113091,
                        "name": "Burnsville",
                        "latitude": "44.76774000",
                        "longitude": "-93.27772000"
                    },
                    {
                        "id": 113145,
                        "name": "Byron",
                        "latitude": "44.03274000",
                        "longitude": "-92.64546000"
                    },
                    {
                        "id": 113190,
                        "name": "Caledonia",
                        "latitude": "43.63469000",
                        "longitude": "-91.49681000"
                    },
                    {
                        "id": 113253,
                        "name": "Cambridge",
                        "latitude": "45.57274000",
                        "longitude": "-93.22439000"
                    },
                    {
                        "id": 113321,
                        "name": "Canby",
                        "latitude": "44.70885000",
                        "longitude": "-96.27643000"
                    },
                    {
                        "id": 113334,
                        "name": "Cannon Falls",
                        "latitude": "44.50691000",
                        "longitude": "-92.90548000"
                    },
                    {
                        "id": 113411,
                        "name": "Carlton",
                        "latitude": "46.66383000",
                        "longitude": "-92.42491000"
                    },
                    {
                        "id": 113413,
                        "name": "Carlton County",
                        "latitude": "46.59240000",
                        "longitude": "-92.67705000"
                    },
                    {
                        "id": 113501,
                        "name": "Carver",
                        "latitude": "44.76357000",
                        "longitude": "-93.62579000"
                    },
                    {
                        "id": 113502,
                        "name": "Carver County",
                        "latitude": "44.82076000",
                        "longitude": "-93.80258000"
                    },
                    {
                        "id": 113532,
                        "name": "Cass County",
                        "latitude": "46.94959000",
                        "longitude": "-94.32535000"
                    },
                    {
                        "id": 113640,
                        "name": "Center City",
                        "latitude": "45.39385000",
                        "longitude": "-92.81660000"
                    },
                    {
                        "id": 113660,
                        "name": "Centerville",
                        "latitude": "45.16302000",
                        "longitude": "-93.05578000"
                    },
                    {
                        "id": 113727,
                        "name": "Champlin",
                        "latitude": "45.18885000",
                        "longitude": "-93.39745000"
                    },
                    {
                        "id": 113732,
                        "name": "Chanhassen",
                        "latitude": "44.86219000",
                        "longitude": "-93.53079000"
                    },
                    {
                        "id": 113794,
                        "name": "Chaska",
                        "latitude": "44.78941000",
                        "longitude": "-93.60218000"
                    },
                    {
                        "id": 113795,
                        "name": "Chatfield",
                        "latitude": "43.84552000",
                        "longitude": "-92.18905000"
                    },
                    {
                        "id": 113974,
                        "name": "Chippewa County",
                        "latitude": "45.02234000",
                        "longitude": "-95.56669000"
                    },
                    {
                        "id": 113977,
                        "name": "Chisago City",
                        "latitude": "45.37358000",
                        "longitude": "-92.88994000"
                    },
                    {
                        "id": 113978,
                        "name": "Chisago County",
                        "latitude": "45.50247000",
                        "longitude": "-92.90834000"
                    },
                    {
                        "id": 113979,
                        "name": "Chisholm",
                        "latitude": "47.48910000",
                        "longitude": "-92.88380000"
                    },
                    {
                        "id": 114030,
                        "name": "Circle Pines",
                        "latitude": "45.14858000",
                        "longitude": "-93.15161000"
                    },
                    {
                        "id": 114100,
                        "name": "Clara City",
                        "latitude": "44.95496000",
                        "longitude": "-95.36640000"
                    },
                    {
                        "id": 114188,
                        "name": "Clay County",
                        "latitude": "46.89234000",
                        "longitude": "-96.49065000"
                    },
                    {
                        "id": 114225,
                        "name": "Clearwater",
                        "latitude": "45.41941000",
                        "longitude": "-94.04887000"
                    },
                    {
                        "id": 114226,
                        "name": "Clearwater County",
                        "latitude": "47.57766000",
                        "longitude": "-95.37903000"
                    },
                    {
                        "id": 114304,
                        "name": "Cloquet",
                        "latitude": "46.72161000",
                        "longitude": "-92.45936000"
                    },
                    {
                        "id": 114373,
                        "name": "Cohasset",
                        "latitude": "47.26356000",
                        "longitude": "-93.62022000"
                    },
                    {
                        "id": 114376,
                        "name": "Cokato",
                        "latitude": "45.07580000",
                        "longitude": "-94.18998000"
                    },
                    {
                        "id": 114386,
                        "name": "Cold Spring",
                        "latitude": "45.45580000",
                        "longitude": "-94.42888000"
                    },
                    {
                        "id": 114401,
                        "name": "Coleraine",
                        "latitude": "47.28883000",
                        "longitude": "-93.42771000"
                    },
                    {
                        "id": 114419,
                        "name": "Collegeville",
                        "latitude": "45.59441000",
                        "longitude": "-94.36305000"
                    },
                    {
                        "id": 114442,
                        "name": "Cologne",
                        "latitude": "44.77163000",
                        "longitude": "-93.78135000"
                    },
                    {
                        "id": 114486,
                        "name": "Columbia Heights",
                        "latitude": "45.04080000",
                        "longitude": "-93.26300000"
                    },
                    {
                        "id": 114500,
                        "name": "Columbus",
                        "latitude": "45.26522000",
                        "longitude": "-93.05015000"
                    },
                    {
                        "id": 114593,
                        "name": "Cook County",
                        "latitude": "47.81684000",
                        "longitude": "-90.54108000"
                    },
                    {
                        "id": 114600,
                        "name": "Coon Rapids",
                        "latitude": "45.11997000",
                        "longitude": "-93.28773000"
                    },
                    {
                        "id": 114632,
                        "name": "Corcoran",
                        "latitude": "45.09524000",
                        "longitude": "-93.54746000"
                    },
                    {
                        "id": 114691,
                        "name": "Cottage Grove",
                        "latitude": "44.82774000",
                        "longitude": "-92.94382000"
                    },
                    {
                        "id": 114700,
                        "name": "Cottonwood",
                        "latitude": "44.60885000",
                        "longitude": "-95.67419000"
                    },
                    {
                        "id": 114703,
                        "name": "Cottonwood County",
                        "latitude": "44.00711000",
                        "longitude": "-95.18115000"
                    },
                    {
                        "id": 114840,
                        "name": "Crookston",
                        "latitude": "47.77414000",
                        "longitude": "-96.60812000"
                    },
                    {
                        "id": 114843,
                        "name": "Crosby",
                        "latitude": "46.48218000",
                        "longitude": "-93.95776000"
                    },
                    {
                        "id": 114849,
                        "name": "Cross Lake",
                        "latitude": "46.65941000",
                        "longitude": "-94.11387000"
                    },
                    {
                        "id": 114861,
                        "name": "Crow Wing County",
                        "latitude": "46.48237000",
                        "longitude": "-94.07087000"
                    },
                    {
                        "id": 114874,
                        "name": "Crystal",
                        "latitude": "45.03274000",
                        "longitude": "-93.36023000"
                    },
                    {
                        "id": 114976,
                        "name": "Dakota County",
                        "latitude": "44.67189000",
                        "longitude": "-93.06544000"
                    },
                    {
                        "id": 115055,
                        "name": "Dassel",
                        "latitude": "45.08163000",
                        "longitude": "-94.30693000"
                    },
                    {
                        "id": 115082,
                        "name": "Dawson",
                        "latitude": "44.93274000",
                        "longitude": "-96.05448000"
                    },
                    {
                        "id": 115096,
                        "name": "Dayton",
                        "latitude": "45.24385000",
                        "longitude": "-93.51496000"
                    },
                    {
                        "id": 115171,
                        "name": "Deephaven",
                        "latitude": "44.92969000",
                        "longitude": "-93.52246000"
                    },
                    {
                        "id": 115198,
                        "name": "Delano",
                        "latitude": "45.04191000",
                        "longitude": "-93.78913000"
                    },
                    {
                        "id": 115216,
                        "name": "Dellwood",
                        "latitude": "45.08997000",
                        "longitude": "-92.97244000"
                    },
                    {
                        "id": 115293,
                        "name": "Detroit Lakes",
                        "latitude": "46.81718000",
                        "longitude": "-95.84533000"
                    },
                    {
                        "id": 115347,
                        "name": "Dilworth",
                        "latitude": "46.87663000",
                        "longitude": "-96.70341000"
                    },
                    {
                        "id": 115375,
                        "name": "Dodge Center",
                        "latitude": "44.02802000",
                        "longitude": "-92.85464000"
                    },
                    {
                        "id": 115378,
                        "name": "Dodge County",
                        "latitude": "44.02259000",
                        "longitude": "-92.86205000"
                    },
                    {
                        "id": 115429,
                        "name": "Douglas County",
                        "latitude": "45.93372000",
                        "longitude": "-95.45352000"
                    },
                    {
                        "id": 115513,
                        "name": "Duluth",
                        "latitude": "46.78327000",
                        "longitude": "-92.10658000"
                    },
                    {
                        "id": 115527,
                        "name": "Dundas",
                        "latitude": "44.42941000",
                        "longitude": "-93.20188000"
                    },
                    {
                        "id": 115593,
                        "name": "Eagan",
                        "latitude": "44.80413000",
                        "longitude": "-93.16689000"
                    },
                    {
                        "id": 115604,
                        "name": "Eagle Lake",
                        "latitude": "44.16497000",
                        "longitude": "-93.88134000"
                    },
                    {
                        "id": 115634,
                        "name": "East Bethel",
                        "latitude": "45.31941000",
                        "longitude": "-93.20245000"
                    },
                    {
                        "id": 115670,
                        "name": "East Grand Forks",
                        "latitude": "47.92998000",
                        "longitude": "-97.02452000"
                    },
                    {
                        "id": 115676,
                        "name": "East Gull Lake",
                        "latitude": "46.40802000",
                        "longitude": "-94.35584000"
                    },
                    {
                        "id": 115832,
                        "name": "Eden Prairie",
                        "latitude": "44.85469000",
                        "longitude": "-93.47079000"
                    },
                    {
                        "id": 115833,
                        "name": "Eden Valley",
                        "latitude": "45.32607000",
                        "longitude": "-94.54611000"
                    },
                    {
                        "id": 115849,
                        "name": "Edgerton",
                        "latitude": "43.87247000",
                        "longitude": "-96.12864000"
                    },
                    {
                        "id": 115867,
                        "name": "Edina",
                        "latitude": "44.88969000",
                        "longitude": "-93.34995000"
                    },
                    {
                        "id": 115946,
                        "name": "Elbow Lake",
                        "latitude": "45.99413000",
                        "longitude": "-95.97672000"
                    },
                    {
                        "id": 115967,
                        "name": "Elgin",
                        "latitude": "44.13024000",
                        "longitude": "-92.25156000"
                    },
                    {
                        "id": 115993,
                        "name": "Elk River",
                        "latitude": "45.30385000",
                        "longitude": "-93.56718000"
                    },
                    {
                        "id": 116010,
                        "name": "Elko New Market",
                        "latitude": "44.56472000",
                        "longitude": "-93.32694000"
                    },
                    {
                        "id": 116085,
                        "name": "Ely",
                        "latitude": "47.90324000",
                        "longitude": "-91.86709000"
                    },
                    {
                        "id": 116185,
                        "name": "Esko",
                        "latitude": "46.70578000",
                        "longitude": "-92.36325000"
                    },
                    {
                        "id": 116257,
                        "name": "Eveleth",
                        "latitude": "47.46243000",
                        "longitude": "-92.53991000"
                    },
                    {
                        "id": 116269,
                        "name": "Excelsior",
                        "latitude": "44.90330000",
                        "longitude": "-93.56635000"
                    },
                    {
                        "id": 116278,
                        "name": "Eyota",
                        "latitude": "43.98830000",
                        "longitude": "-92.22850000"
                    },
                    {
                        "id": 116305,
                        "name": "Fairfax",
                        "latitude": "44.52913000",
                        "longitude": "-94.72082000"
                    },
                    {
                        "id": 116337,
                        "name": "Fairmont",
                        "latitude": "43.65218000",
                        "longitude": "-94.46108000"
                    },
                    {
                        "id": 116365,
                        "name": "Falcon Heights",
                        "latitude": "44.99163000",
                        "longitude": "-93.16633000"
                    },
                    {
                        "id": 116397,
                        "name": "Faribault",
                        "latitude": "44.29496000",
                        "longitude": "-93.26883000"
                    },
                    {
                        "id": 116398,
                        "name": "Faribault County",
                        "latitude": "43.67393000",
                        "longitude": "-93.94800000"
                    },
                    {
                        "id": 116419,
                        "name": "Farmington",
                        "latitude": "44.64024000",
                        "longitude": "-93.14355000"
                    },
                    {
                        "id": 116479,
                        "name": "Fergus Falls",
                        "latitude": "46.28302000",
                        "longitude": "-96.07756000"
                    },
                    {
                        "id": 116510,
                        "name": "Fillmore County",
                        "latitude": "43.67400000",
                        "longitude": "-92.09017000"
                    },
                    {
                        "id": 116620,
                        "name": "Foley",
                        "latitude": "45.66469000",
                        "longitude": "-93.90970000"
                    },
                    {
                        "id": 116661,
                        "name": "Forest Lake",
                        "latitude": "45.27886000",
                        "longitude": "-92.98522000"
                    },
                    {
                        "id": 116773,
                        "name": "Fosston",
                        "latitude": "47.57635000",
                        "longitude": "-95.75141000"
                    },
                    {
                        "id": 116882,
                        "name": "Frazee",
                        "latitude": "46.72801000",
                        "longitude": "-95.70088000"
                    },
                    {
                        "id": 116899,
                        "name": "Freeborn County",
                        "latitude": "43.67384000",
                        "longitude": "-93.34882000"
                    },
                    {
                        "id": 116944,
                        "name": "Fridley",
                        "latitude": "45.08608000",
                        "longitude": "-93.26328000"
                    },
                    {
                        "id": 116979,
                        "name": "Fulda",
                        "latitude": "43.87052000",
                        "longitude": "-95.60029000"
                    },
                    {
                        "id": 117128,
                        "name": "Gaylord",
                        "latitude": "44.55302000",
                        "longitude": "-94.22053000"
                    },
                    {
                        "id": 117203,
                        "name": "Gilbert",
                        "latitude": "47.48882000",
                        "longitude": "-92.46491000"
                    },
                    {
                        "id": 117279,
                        "name": "Glencoe",
                        "latitude": "44.76913000",
                        "longitude": "-94.15164000"
                    },
                    {
                        "id": 117315,
                        "name": "Glenwood",
                        "latitude": "45.65024000",
                        "longitude": "-95.38976000"
                    },
                    {
                        "id": 117330,
                        "name": "Glyndon",
                        "latitude": "46.87524000",
                        "longitude": "-96.57896000"
                    },
                    {
                        "id": 117355,
                        "name": "Golden Valley",
                        "latitude": "45.00969000",
                        "longitude": "-93.34912000"
                    },
                    {
                        "id": 117379,
                        "name": "Goodhue",
                        "latitude": "44.40052000",
                        "longitude": "-92.62380000"
                    },
                    {
                        "id": 117380,
                        "name": "Goodhue County",
                        "latitude": "44.40985000",
                        "longitude": "-92.72259000"
                    },
                    {
                        "id": 117390,
                        "name": "Goodview",
                        "latitude": "44.06246000",
                        "longitude": "-91.69571000"
                    },
                    {
                        "id": 117467,
                        "name": "Grand Marais",
                        "latitude": "47.75045000",
                        "longitude": "-90.33427000"
                    },
                    {
                        "id": 117468,
                        "name": "Grand Meadow",
                        "latitude": "43.70580000",
                        "longitude": "-92.57212000"
                    },
                    {
                        "id": 117472,
                        "name": "Grand Rapids",
                        "latitude": "47.23717000",
                        "longitude": "-93.53021000"
                    },
                    {
                        "id": 117497,
                        "name": "Granite Falls",
                        "latitude": "44.80996000",
                        "longitude": "-95.54558000"
                    },
                    {
                        "id": 117504,
                        "name": "Grant",
                        "latitude": "45.08441000",
                        "longitude": "-92.91049000"
                    },
                    {
                        "id": 117513,
                        "name": "Grant County",
                        "latitude": "45.93405000",
                        "longitude": "-96.01218000"
                    },
                    {
                        "id": 117651,
                        "name": "Greenfield",
                        "latitude": "45.10330000",
                        "longitude": "-93.69135000"
                    },
                    {
                        "id": 117871,
                        "name": "Hallock",
                        "latitude": "48.77443000",
                        "longitude": "-96.94645000"
                    },
                    {
                        "id": 117879,
                        "name": "Ham Lake",
                        "latitude": "45.25024000",
                        "longitude": "-93.24995000"
                    },
                    {
                        "id": 117971,
                        "name": "Hanover",
                        "latitude": "45.15580000",
                        "longitude": "-93.66635000"
                    },
                    {
                        "id": 118043,
                        "name": "Harris",
                        "latitude": "45.58635000",
                        "longitude": "-92.97466000"
                    },
                    {
                        "id": 118132,
                        "name": "Hastings",
                        "latitude": "44.74330000",
                        "longitude": "-92.85243000"
                    },
                    {
                        "id": 118168,
                        "name": "Hawley",
                        "latitude": "46.88079000",
                        "longitude": "-96.31673000"
                    },
                    {
                        "id": 118185,
                        "name": "Hayfield",
                        "latitude": "43.89052000",
                        "longitude": "-92.84769000"
                    },
                    {
                        "id": 118241,
                        "name": "Hector",
                        "latitude": "44.74385000",
                        "longitude": "-94.71555000"
                    },
                    {
                        "id": 118291,
                        "name": "Hennepin County",
                        "latitude": "45.00458000",
                        "longitude": "-93.47688000"
                    },
                    {
                        "id": 118326,
                        "name": "Hermantown",
                        "latitude": "46.80689000",
                        "longitude": "-92.23825000"
                    },
                    {
                        "id": 118359,
                        "name": "Hibbing",
                        "latitude": "47.42715000",
                        "longitude": "-92.93769000"
                    },
                    {
                        "id": 118477,
                        "name": "Hinckley",
                        "latitude": "46.01134000",
                        "longitude": "-92.94437000"
                    },
                    {
                        "id": 118652,
                        "name": "Hopkins",
                        "latitude": "44.92496000",
                        "longitude": "-93.46273000"
                    },
                    {
                        "id": 118706,
                        "name": "Houston County",
                        "latitude": "43.67144000",
                        "longitude": "-91.49283000"
                    },
                    {
                        "id": 118719,
                        "name": "Howard Lake",
                        "latitude": "45.06080000",
                        "longitude": "-94.07331000"
                    },
                    {
                        "id": 118728,
                        "name": "Hoyt Lakes",
                        "latitude": "47.51965000",
                        "longitude": "-92.13851000"
                    },
                    {
                        "id": 118732,
                        "name": "Hubbard County",
                        "latitude": "47.10865000",
                        "longitude": "-94.91664000"
                    },
                    {
                        "id": 118766,
                        "name": "Hugo",
                        "latitude": "45.15997000",
                        "longitude": "-92.99327000"
                    },
                    {
                        "id": 118836,
                        "name": "Hutchinson",
                        "latitude": "44.88774000",
                        "longitude": "-94.36971000"
                    },
                    {
                        "id": 118895,
                        "name": "Independence",
                        "latitude": "45.02524000",
                        "longitude": "-93.70746000"
                    },
                    {
                        "id": 118952,
                        "name": "International Falls",
                        "latitude": "48.60105000",
                        "longitude": "-93.41098000"
                    },
                    {
                        "id": 118953,
                        "name": "Inver Grove Heights",
                        "latitude": "44.84802000",
                        "longitude": "-93.04272000"
                    },
                    {
                        "id": 119017,
                        "name": "Isanti",
                        "latitude": "45.49024000",
                        "longitude": "-93.24773000"
                    },
                    {
                        "id": 119018,
                        "name": "Isanti County",
                        "latitude": "45.56149000",
                        "longitude": "-93.29518000"
                    },
                    {
                        "id": 119041,
                        "name": "Itasca County",
                        "latitude": "47.50953000",
                        "longitude": "-93.63200000"
                    },
                    {
                        "id": 119048,
                        "name": "Ivanhoe",
                        "latitude": "44.46330000",
                        "longitude": "-96.24726000"
                    },
                    {
                        "id": 119070,
                        "name": "Jackson",
                        "latitude": "43.62079000",
                        "longitude": "-94.98860000"
                    },
                    {
                        "id": 119092,
                        "name": "Jackson County",
                        "latitude": "43.67417000",
                        "longitude": "-95.15411000"
                    },
                    {
                        "id": 119130,
                        "name": "Janesville",
                        "latitude": "44.11608000",
                        "longitude": "-93.70800000"
                    },
                    {
                        "id": 119315,
                        "name": "Jordan",
                        "latitude": "44.66691000",
                        "longitude": "-93.62690000"
                    },
                    {
                        "id": 119373,
                        "name": "Kanabec County",
                        "latitude": "45.94522000",
                        "longitude": "-93.29343000"
                    },
                    {
                        "id": 119375,
                        "name": "Kandiyohi County",
                        "latitude": "45.15238000",
                        "longitude": "-95.00474000"
                    },
                    {
                        "id": 119392,
                        "name": "Kasson",
                        "latitude": "44.02996000",
                        "longitude": "-92.75074000"
                    },
                    {
                        "id": 119424,
                        "name": "Keewatin",
                        "latitude": "47.39966000",
                        "longitude": "-93.07242000"
                    },
                    {
                        "id": 119506,
                        "name": "Kenyon",
                        "latitude": "44.27219000",
                        "longitude": "-92.98548000"
                    },
                    {
                        "id": 119667,
                        "name": "Kittson County",
                        "latitude": "48.77663000",
                        "longitude": "-96.78285000"
                    },
                    {
                        "id": 119705,
                        "name": "Koochiching County",
                        "latitude": "48.24527000",
                        "longitude": "-93.78337000"
                    },
                    {
                        "id": 119741,
                        "name": "La Crescent",
                        "latitude": "43.82802000",
                        "longitude": "-91.30403000"
                    },
                    {
                        "id": 119811,
                        "name": "Lac qui Parle County",
                        "latitude": "44.99549000",
                        "longitude": "-96.17348000"
                    },
                    {
                        "id": 119883,
                        "name": "Lake City",
                        "latitude": "44.44968000",
                        "longitude": "-92.26820000"
                    },
                    {
                        "id": 119894,
                        "name": "Lake County",
                        "latitude": "47.52317000",
                        "longitude": "-91.40885000"
                    },
                    {
                        "id": 119900,
                        "name": "Lake Crystal",
                        "latitude": "44.10580000",
                        "longitude": "-94.21885000"
                    },
                    {
                        "id": 119905,
                        "name": "Lake Elmo",
                        "latitude": "44.99580000",
                        "longitude": "-92.87938000"
                    },
                    {
                        "id": 120008,
                        "name": "Lake of the Woods County",
                        "latitude": "48.77051000",
                        "longitude": "-94.90503000"
                    },
                    {
                        "id": 119971,
                        "name": "Lake Saint Croix Beach",
                        "latitude": "44.92080000",
                        "longitude": "-92.76687000"
                    },
                    {
                        "id": 119977,
                        "name": "Lake Shore",
                        "latitude": "46.48552000",
                        "longitude": "-94.36056000"
                    },
                    {
                        "id": 120009,
                        "name": "Lakefield",
                        "latitude": "43.67746000",
                        "longitude": "-95.17166000"
                    },
                    {
                        "id": 120015,
                        "name": "Lakeland",
                        "latitude": "44.95636000",
                        "longitude": "-92.76576000"
                    },
                    {
                        "id": 120043,
                        "name": "Lakeville",
                        "latitude": "44.64969000",
                        "longitude": "-93.24272000"
                    },
                    {
                        "id": 120178,
                        "name": "Lauderdale",
                        "latitude": "44.99858000",
                        "longitude": "-93.20578000"
                    },
                    {
                        "id": 120257,
                        "name": "Le Center",
                        "latitude": "44.38941000",
                        "longitude": "-93.73023000"
                    },
                    {
                        "id": 120264,
                        "name": "Le Sueur",
                        "latitude": "44.46135000",
                        "longitude": "-93.91524000"
                    },
                    {
                        "id": 120265,
                        "name": "Le Sueur County",
                        "latitude": "44.37143000",
                        "longitude": "-93.73008000"
                    },
                    {
                        "id": 120399,
                        "name": "Lester Prairie",
                        "latitude": "44.88385000",
                        "longitude": "-94.04164000"
                    },
                    {
                        "id": 120425,
                        "name": "Lewiston",
                        "latitude": "43.98441000",
                        "longitude": "-91.86932000"
                    },
                    {
                        "id": 120450,
                        "name": "Lexington",
                        "latitude": "45.14247000",
                        "longitude": "-93.16328000"
                    },
                    {
                        "id": 120527,
                        "name": "Lincoln County",
                        "latitude": "44.41260000",
                        "longitude": "-96.26709000"
                    },
                    {
                        "id": 120576,
                        "name": "Lindstrom",
                        "latitude": "45.38941000",
                        "longitude": "-92.84799000"
                    },
                    {
                        "id": 120587,
                        "name": "Lino Lakes",
                        "latitude": "45.16024000",
                        "longitude": "-93.08883000"
                    },
                    {
                        "id": 120605,
                        "name": "Litchfield",
                        "latitude": "45.12718000",
                        "longitude": "-94.52805000"
                    },
                    {
                        "id": 120613,
                        "name": "Little Canada",
                        "latitude": "45.02691000",
                        "longitude": "-93.08772000"
                    },
                    {
                        "id": 120617,
                        "name": "Little Falls",
                        "latitude": "45.97635000",
                        "longitude": "-94.36250000"
                    },
                    {
                        "id": 120627,
                        "name": "Little Rock",
                        "latitude": "47.86801000",
                        "longitude": "-95.11055000"
                    },
                    {
                        "id": 120747,
                        "name": "Long Lake",
                        "latitude": "44.98663000",
                        "longitude": "-93.57162000"
                    },
                    {
                        "id": 120749,
                        "name": "Long Prairie",
                        "latitude": "45.97469000",
                        "longitude": "-94.86558000"
                    },
                    {
                        "id": 120763,
                        "name": "Lonsdale",
                        "latitude": "44.48024000",
                        "longitude": "-93.42856000"
                    },
                    {
                        "id": 120900,
                        "name": "Luverne",
                        "latitude": "43.65414000",
                        "longitude": "-96.21281000"
                    },
                    {
                        "id": 120938,
                        "name": "Lyon County",
                        "latitude": "44.41349000",
                        "longitude": "-95.83897000"
                    },
                    {
                        "id": 120979,
                        "name": "Madelia",
                        "latitude": "44.05079000",
                        "longitude": "-94.41830000"
                    },
                    {
                        "id": 120994,
                        "name": "Madison",
                        "latitude": "45.00968000",
                        "longitude": "-96.19588000"
                    },
                    {
                        "id": 121022,
                        "name": "Madison Lake",
                        "latitude": "44.20441000",
                        "longitude": "-93.81551000"
                    },
                    {
                        "id": 121043,
                        "name": "Mahnomen",
                        "latitude": "47.31524000",
                        "longitude": "-95.96865000"
                    },
                    {
                        "id": 121044,
                        "name": "Mahnomen County",
                        "latitude": "47.32524000",
                        "longitude": "-95.80905000"
                    },
                    {
                        "id": 121047,
                        "name": "Mahtomedi",
                        "latitude": "45.06969000",
                        "longitude": "-92.95160000"
                    },
                    {
                        "id": 121130,
                        "name": "Mankato",
                        "latitude": "44.15906000",
                        "longitude": "-94.00915000"
                    },
                    {
                        "id": 121159,
                        "name": "Mantorville",
                        "latitude": "44.06913000",
                        "longitude": "-92.75575000"
                    },
                    {
                        "id": 121167,
                        "name": "Maple Grove",
                        "latitude": "45.07246000",
                        "longitude": "-93.45579000"
                    },
                    {
                        "id": 121169,
                        "name": "Maple Lake",
                        "latitude": "45.22913000",
                        "longitude": "-94.00192000"
                    },
                    {
                        "id": 121171,
                        "name": "Maple Plain",
                        "latitude": "45.00719000",
                        "longitude": "-93.65579000"
                    },
                    {
                        "id": 121175,
                        "name": "Mapleton",
                        "latitude": "43.92885000",
                        "longitude": "-93.95606000"
                    },
                    {
                        "id": 121178,
                        "name": "Maplewood",
                        "latitude": "44.95302000",
                        "longitude": "-92.99522000"
                    },
                    {
                        "id": 121308,
                        "name": "Marshall",
                        "latitude": "44.44690000",
                        "longitude": "-95.78835000"
                    },
                    {
                        "id": 121320,
                        "name": "Marshall County",
                        "latitude": "48.35813000",
                        "longitude": "-96.36847000"
                    },
                    {
                        "id": 121341,
                        "name": "Martin County",
                        "latitude": "43.67436000",
                        "longitude": "-94.55107000"
                    },
                    {
                        "id": 121432,
                        "name": "Mayer",
                        "latitude": "44.88496000",
                        "longitude": "-93.88775000"
                    },
                    {
                        "id": 121535,
                        "name": "McLeod County",
                        "latitude": "44.82354000",
                        "longitude": "-94.27242000"
                    },
                    {
                        "id": 121593,
                        "name": "Medford",
                        "latitude": "44.17413000",
                        "longitude": "-93.24632000"
                    },
                    {
                        "id": 121604,
                        "name": "Medina",
                        "latitude": "45.03524000",
                        "longitude": "-93.58246000"
                    },
                    {
                        "id": 121614,
                        "name": "Meeker County",
                        "latitude": "45.12312000",
                        "longitude": "-94.52731000"
                    },
                    {
                        "id": 121629,
                        "name": "Melrose",
                        "latitude": "45.67469000",
                        "longitude": "-94.80752000"
                    },
                    {
                        "id": 121644,
                        "name": "Menahga",
                        "latitude": "46.75385000",
                        "longitude": "-95.09808000"
                    },
                    {
                        "id": 121658,
                        "name": "Mendota Heights",
                        "latitude": "44.88358000",
                        "longitude": "-93.13827000"
                    },
                    {
                        "id": 121832,
                        "name": "Milaca",
                        "latitude": "45.75580000",
                        "longitude": "-93.65441000"
                    },
                    {
                        "id": 121876,
                        "name": "Mille Lacs County",
                        "latitude": "45.93805000",
                        "longitude": "-93.63009000"
                    },
                    {
                        "id": 121951,
                        "name": "Minneapolis",
                        "latitude": "44.97997000",
                        "longitude": "-93.26384000"
                    },
                    {
                        "id": 121955,
                        "name": "Minneota",
                        "latitude": "44.55885000",
                        "longitude": "-95.98559000"
                    },
                    {
                        "id": 121956,
                        "name": "Minnetonka",
                        "latitude": "44.91330000",
                        "longitude": "-93.50329000"
                    },
                    {
                        "id": 121957,
                        "name": "Minnetonka Mills",
                        "latitude": "44.94107000",
                        "longitude": "-93.44190000"
                    },
                    {
                        "id": 121958,
                        "name": "Minnetrista",
                        "latitude": "44.93830000",
                        "longitude": "-93.71774000"
                    },
                    {
                        "id": 122126,
                        "name": "Montevideo",
                        "latitude": "44.94803000",
                        "longitude": "-95.71701000"
                    },
                    {
                        "id": 122134,
                        "name": "Montgomery",
                        "latitude": "44.43885000",
                        "longitude": "-93.58134000"
                    },
                    {
                        "id": 122167,
                        "name": "Monticello",
                        "latitude": "45.30552000",
                        "longitude": "-93.79414000"
                    },
                    {
                        "id": 122180,
                        "name": "Montrose",
                        "latitude": "45.06496000",
                        "longitude": "-93.91108000"
                    },
                    {
                        "id": 122212,
                        "name": "Moorhead",
                        "latitude": "46.87386000",
                        "longitude": "-96.76951000"
                    },
                    {
                        "id": 122214,
                        "name": "Moose Lake",
                        "latitude": "46.45411000",
                        "longitude": "-92.76187000"
                    },
                    {
                        "id": 122218,
                        "name": "Mora",
                        "latitude": "45.87690000",
                        "longitude": "-93.29384000"
                    },
                    {
                        "id": 122268,
                        "name": "Morris",
                        "latitude": "45.58607000",
                        "longitude": "-95.91394000"
                    },
                    {
                        "id": 122277,
                        "name": "Morrison County",
                        "latitude": "46.01262000",
                        "longitude": "-94.26842000"
                    },
                    {
                        "id": 122318,
                        "name": "Mound",
                        "latitude": "44.93663000",
                        "longitude": "-93.66607000"
                    },
                    {
                        "id": 122326,
                        "name": "Mounds View",
                        "latitude": "45.10497000",
                        "longitude": "-93.20856000"
                    },
                    {
                        "id": 122419,
                        "name": "Mountain Iron",
                        "latitude": "47.53243000",
                        "longitude": "-92.62351000"
                    },
                    {
                        "id": 122420,
                        "name": "Mountain Lake",
                        "latitude": "43.93885000",
                        "longitude": "-94.92971000"
                    },
                    {
                        "id": 122445,
                        "name": "Mower County",
                        "latitude": "43.67147000",
                        "longitude": "-92.75251000"
                    },
                    {
                        "id": 122495,
                        "name": "Murray County",
                        "latitude": "44.02212000",
                        "longitude": "-95.76328000"
                    },
                    {
                        "id": 122671,
                        "name": "New Brighton",
                        "latitude": "45.06552000",
                        "longitude": "-93.20189000"
                    },
                    {
                        "id": 122726,
                        "name": "New Hope",
                        "latitude": "45.03802000",
                        "longitude": "-93.38662000"
                    },
                    {
                        "id": 122743,
                        "name": "New London",
                        "latitude": "45.30108000",
                        "longitude": "-94.94418000"
                    },
                    {
                        "id": 122766,
                        "name": "New Prague",
                        "latitude": "44.54330000",
                        "longitude": "-93.57607000"
                    },
                    {
                        "id": 122769,
                        "name": "New Richland",
                        "latitude": "43.89385000",
                        "longitude": "-93.49383000"
                    },
                    {
                        "id": 122788,
                        "name": "New Ulm",
                        "latitude": "44.31246000",
                        "longitude": "-94.46053000"
                    },
                    {
                        "id": 122797,
                        "name": "New York Mills",
                        "latitude": "46.51802000",
                        "longitude": "-95.37615000"
                    },
                    {
                        "id": 122845,
                        "name": "Newport",
                        "latitude": "44.86636000",
                        "longitude": "-93.00049000"
                    },
                    {
                        "id": 122895,
                        "name": "Nicollet",
                        "latitude": "44.27608000",
                        "longitude": "-94.18746000"
                    },
                    {
                        "id": 122896,
                        "name": "Nicollet County",
                        "latitude": "44.34989000",
                        "longitude": "-94.24730000"
                    },
                    {
                        "id": 122908,
                        "name": "Nisswa",
                        "latitude": "46.52052000",
                        "longitude": "-94.28861000"
                    },
                    {
                        "id": 122920,
                        "name": "Nobles County",
                        "latitude": "43.67424000",
                        "longitude": "-95.75339000"
                    },
                    {
                        "id": 122950,
                        "name": "Norman County",
                        "latitude": "47.32648000",
                        "longitude": "-96.45528000"
                    },
                    {
                        "id": 122994,
                        "name": "North Branch",
                        "latitude": "45.51135000",
                        "longitude": "-92.98022000"
                    },
                    {
                        "id": 123063,
                        "name": "North Mankato",
                        "latitude": "44.17330000",
                        "longitude": "-94.03385000"
                    },
                    {
                        "id": 123073,
                        "name": "North Oaks",
                        "latitude": "45.10274000",
                        "longitude": "-93.07911000"
                    },
                    {
                        "id": 123098,
                        "name": "North Saint Paul",
                        "latitude": "45.01247000",
                        "longitude": "-92.99188000"
                    },
                    {
                        "id": 123152,
                        "name": "Northfield",
                        "latitude": "44.45830000",
                        "longitude": "-93.16160000"
                    },
                    {
                        "id": 123202,
                        "name": "Norwood (historical)",
                        "latitude": "44.76802000",
                        "longitude": "-93.92747000"
                    },
                    {
                        "id": 123203,
                        "name": "Norwood Young America",
                        "latitude": "44.77357000",
                        "longitude": "-93.92163000"
                    },
                    {
                        "id": 123211,
                        "name": "Nowthen",
                        "latitude": "45.32802000",
                        "longitude": "-93.47023000"
                    },
                    {
                        "id": 123239,
                        "name": "Oak Grove",
                        "latitude": "45.34080000",
                        "longitude": "-93.32690000"
                    },
                    {
                        "id": 123258,
                        "name": "Oak Park Heights",
                        "latitude": "45.03136000",
                        "longitude": "-92.79298000"
                    },
                    {
                        "id": 123271,
                        "name": "Oakdale",
                        "latitude": "44.96302000",
                        "longitude": "-92.96494000"
                    },
                    {
                        "id": 123303,
                        "name": "Oakport",
                        "latitude": "46.93191000",
                        "longitude": "-96.77897000"
                    },
                    {
                        "id": 123450,
                        "name": "Olivia",
                        "latitude": "44.77635000",
                        "longitude": "-94.98972000"
                    },
                    {
                        "id": 123454,
                        "name": "Olmsted County",
                        "latitude": "44.00375000",
                        "longitude": "-92.40177000"
                    },
                    {
                        "id": 123573,
                        "name": "Orono",
                        "latitude": "44.97135000",
                        "longitude": "-93.60440000"
                    },
                    {
                        "id": 123575,
                        "name": "Oronoco",
                        "latitude": "44.16608000",
                        "longitude": "-92.53491000"
                    },
                    {
                        "id": 123584,
                        "name": "Ortonville",
                        "latitude": "45.30469000",
                        "longitude": "-96.44478000"
                    },
                    {
                        "id": 123592,
                        "name": "Osakis",
                        "latitude": "45.86691000",
                        "longitude": "-95.15225000"
                    },
                    {
                        "id": 123614,
                        "name": "Osseo",
                        "latitude": "45.11941000",
                        "longitude": "-93.40245000"
                    },
                    {
                        "id": 123633,
                        "name": "Otsego",
                        "latitude": "45.27413000",
                        "longitude": "-93.59135000"
                    },
                    {
                        "id": 123641,
                        "name": "Otter Tail County",
                        "latitude": "46.40880000",
                        "longitude": "-95.70800000"
                    },
                    {
                        "id": 123659,
                        "name": "Owatonna",
                        "latitude": "44.08385000",
                        "longitude": "-93.22604000"
                    },
                    {
                        "id": 123850,
                        "name": "Park Rapids",
                        "latitude": "46.92218000",
                        "longitude": "-95.05863000"
                    },
                    {
                        "id": 123866,
                        "name": "Parkers Prairie",
                        "latitude": "46.15302000",
                        "longitude": "-95.32892000"
                    },
                    {
                        "id": 123880,
                        "name": "Parkville",
                        "latitude": "47.53104000",
                        "longitude": "-92.57907000"
                    },
                    {
                        "id": 123947,
                        "name": "Paynesville",
                        "latitude": "45.38052000",
                        "longitude": "-94.71195000"
                    },
                    {
                        "id": 123996,
                        "name": "Pelican Rapids",
                        "latitude": "46.57079000",
                        "longitude": "-96.08311000"
                    },
                    {
                        "id": 124030,
                        "name": "Pennington County",
                        "latitude": "48.06623000",
                        "longitude": "-96.03667000"
                    },
                    {
                        "id": 124056,
                        "name": "Pequot Lakes",
                        "latitude": "46.60302000",
                        "longitude": "-94.30944000"
                    },
                    {
                        "id": 124059,
                        "name": "Perham",
                        "latitude": "46.59440000",
                        "longitude": "-95.57254000"
                    },
                    {
                        "id": 124181,
                        "name": "Pierz",
                        "latitude": "45.98163000",
                        "longitude": "-94.10471000"
                    },
                    {
                        "id": 124218,
                        "name": "Pine City",
                        "latitude": "45.82607000",
                        "longitude": "-92.96854000"
                    },
                    {
                        "id": 124219,
                        "name": "Pine County",
                        "latitude": "46.12077000",
                        "longitude": "-92.74127000"
                    },
                    {
                        "id": 124228,
                        "name": "Pine Island",
                        "latitude": "44.20135000",
                        "longitude": "-92.64630000"
                    },
                    {
                        "id": 124277,
                        "name": "Pipestone",
                        "latitude": "44.00053000",
                        "longitude": "-96.31753000"
                    },
                    {
                        "id": 124278,
                        "name": "Pipestone County",
                        "latitude": "44.02300000",
                        "longitude": "-96.25864000"
                    },
                    {
                        "id": 124328,
                        "name": "Plainview",
                        "latitude": "44.16497000",
                        "longitude": "-92.17156000"
                    },
                    {
                        "id": 124405,
                        "name": "Plymouth",
                        "latitude": "45.01052000",
                        "longitude": "-93.45551000"
                    },
                    {
                        "id": 124448,
                        "name": "Polk County",
                        "latitude": "47.77385000",
                        "longitude": "-96.40181000"
                    },
                    {
                        "id": 124483,
                        "name": "Pope County",
                        "latitude": "45.58602000",
                        "longitude": "-95.44448000"
                    },
                    {
                        "id": 124656,
                        "name": "Preston",
                        "latitude": "43.67024000",
                        "longitude": "-92.08322000"
                    },
                    {
                        "id": 124688,
                        "name": "Princeton",
                        "latitude": "45.56997000",
                        "longitude": "-93.58163000"
                    },
                    {
                        "id": 124698,
                        "name": "Prior Lake",
                        "latitude": "44.71330000",
                        "longitude": "-93.42273000"
                    },
                    {
                        "id": 124700,
                        "name": "Proctor",
                        "latitude": "46.74716000",
                        "longitude": "-92.22547000"
                    },
                    {
                        "id": 124841,
                        "name": "Ramsey",
                        "latitude": "45.26110000",
                        "longitude": "-93.45000000"
                    },
                    {
                        "id": 124843,
                        "name": "Ramsey County",
                        "latitude": "45.01706000",
                        "longitude": "-93.09961000"
                    },
                    {
                        "id": 124949,
                        "name": "Red Lake",
                        "latitude": "47.87635000",
                        "longitude": "-95.01694000"
                    },
                    {
                        "id": 124950,
                        "name": "Red Lake County",
                        "latitude": "47.87169000",
                        "longitude": "-96.09530000"
                    },
                    {
                        "id": 124951,
                        "name": "Red Lake Falls",
                        "latitude": "47.88219000",
                        "longitude": "-96.27421000"
                    },
                    {
                        "id": 124963,
                        "name": "Red Wing",
                        "latitude": "44.56247000",
                        "longitude": "-92.53380000"
                    },
                    {
                        "id": 124965,
                        "name": "Redby",
                        "latitude": "47.87857000",
                        "longitude": "-94.91305000"
                    },
                    {
                        "id": 124987,
                        "name": "Redwood County",
                        "latitude": "44.40366000",
                        "longitude": "-95.25383000"
                    },
                    {
                        "id": 124988,
                        "name": "Redwood Falls",
                        "latitude": "44.53940000",
                        "longitude": "-95.11694000"
                    },
                    {
                        "id": 125027,
                        "name": "Renville",
                        "latitude": "44.78913000",
                        "longitude": "-95.21167000"
                    },
                    {
                        "id": 125028,
                        "name": "Renville County",
                        "latitude": "44.72681000",
                        "longitude": "-94.94714000"
                    },
                    {
                        "id": 125052,
                        "name": "Rice",
                        "latitude": "45.75191000",
                        "longitude": "-94.22027000"
                    },
                    {
                        "id": 125054,
                        "name": "Rice County",
                        "latitude": "44.35426000",
                        "longitude": "-93.29668000"
                    },
                    {
                        "id": 125061,
                        "name": "Richfield",
                        "latitude": "44.88330000",
                        "longitude": "-93.28300000"
                    },
                    {
                        "id": 125094,
                        "name": "Richmond",
                        "latitude": "45.45413000",
                        "longitude": "-94.51833000"
                    },
                    {
                        "id": 125236,
                        "name": "Robbinsdale",
                        "latitude": "45.03219000",
                        "longitude": "-93.33856000"
                    },
                    {
                        "id": 125266,
                        "name": "Rochester",
                        "latitude": "44.02163000",
                        "longitude": "-92.46990000"
                    },
                    {
                        "id": 125272,
                        "name": "Rock County",
                        "latitude": "43.67463000",
                        "longitude": "-96.25321000"
                    },
                    {
                        "id": 125276,
                        "name": "Rock Creek",
                        "latitude": "45.75746000",
                        "longitude": "-92.96243000"
                    },
                    {
                        "id": 125302,
                        "name": "Rockford",
                        "latitude": "45.08830000",
                        "longitude": "-93.73441000"
                    },
                    {
                        "id": 125324,
                        "name": "Rockville",
                        "latitude": "45.47191000",
                        "longitude": "-94.34083000"
                    },
                    {
                        "id": 125350,
                        "name": "Rogers",
                        "latitude": "45.18885000",
                        "longitude": "-93.55301000"
                    },
                    {
                        "id": 125407,
                        "name": "Roseau",
                        "latitude": "48.84609000",
                        "longitude": "-95.76277000"
                    },
                    {
                        "id": 125408,
                        "name": "Roseau County",
                        "latitude": "48.77514000",
                        "longitude": "-95.81082000"
                    },
                    {
                        "id": 125432,
                        "name": "Rosemount",
                        "latitude": "44.73941000",
                        "longitude": "-93.12577000"
                    },
                    {
                        "id": 125440,
                        "name": "Roseville",
                        "latitude": "45.00608000",
                        "longitude": "-93.15661000"
                    },
                    {
                        "id": 125496,
                        "name": "Royalton",
                        "latitude": "45.82997000",
                        "longitude": "-94.29361000"
                    },
                    {
                        "id": 125519,
                        "name": "Rush City",
                        "latitude": "45.68551000",
                        "longitude": "-92.96549000"
                    },
                    {
                        "id": 125523,
                        "name": "Rushford",
                        "latitude": "43.80830000",
                        "longitude": "-91.75293000"
                    },
                    {
                        "id": 125601,
                        "name": "Saint Anthony",
                        "latitude": "45.02052000",
                        "longitude": "-93.21800000"
                    },
                    {
                        "id": 125603,
                        "name": "Saint Augusta",
                        "latitude": "45.45830000",
                        "longitude": "-94.19804000"
                    },
                    {
                        "id": 125610,
                        "name": "Saint Bonifacius",
                        "latitude": "44.90552000",
                        "longitude": "-93.74746000"
                    },
                    {
                        "id": 125615,
                        "name": "Saint Charles",
                        "latitude": "43.96941000",
                        "longitude": "-92.06433000"
                    },
                    {
                        "id": 125627,
                        "name": "Saint Cloud",
                        "latitude": "45.56080000",
                        "longitude": "-94.16249000"
                    },
                    {
                        "id": 125633,
                        "name": "Saint Francis",
                        "latitude": "45.38691000",
                        "longitude": "-93.35940000"
                    },
                    {
                        "id": 125655,
                        "name": "Saint James",
                        "latitude": "43.98246000",
                        "longitude": "-94.62692000"
                    },
                    {
                        "id": 125674,
                        "name": "Saint Joseph",
                        "latitude": "45.56496000",
                        "longitude": "-94.31833000"
                    },
                    {
                        "id": 125682,
                        "name": "Saint Louis County",
                        "latitude": "47.58986000",
                        "longitude": "-92.46147000"
                    },
                    {
                        "id": 125683,
                        "name": "Saint Louis Park",
                        "latitude": "44.94830000",
                        "longitude": "-93.34801000"
                    },
                    {
                        "id": 125697,
                        "name": "Saint Michael",
                        "latitude": "45.20996000",
                        "longitude": "-93.66496000"
                    },
                    {
                        "id": 125703,
                        "name": "Saint Paul",
                        "latitude": "44.94441000",
                        "longitude": "-93.09327000"
                    },
                    {
                        "id": 125705,
                        "name": "Saint Paul Park",
                        "latitude": "44.84219000",
                        "longitude": "-92.99132000"
                    },
                    {
                        "id": 125708,
                        "name": "Saint Peter",
                        "latitude": "44.32358000",
                        "longitude": "-93.95801000"
                    },
                    {
                        "id": 125874,
                        "name": "Sandstone",
                        "latitude": "46.13106000",
                        "longitude": "-92.86742000"
                    },
                    {
                        "id": 125953,
                        "name": "Sartell",
                        "latitude": "45.62163000",
                        "longitude": "-94.20694000"
                    },
                    {
                        "id": 125962,
                        "name": "Sauk Centre",
                        "latitude": "45.73747000",
                        "longitude": "-94.95252000"
                    },
                    {
                        "id": 125965,
                        "name": "Sauk Rapids",
                        "latitude": "45.59191000",
                        "longitude": "-94.16610000"
                    },
                    {
                        "id": 125972,
                        "name": "Savage",
                        "latitude": "44.77913000",
                        "longitude": "-93.33634000"
                    },
                    {
                        "id": 125995,
                        "name": "Scandia",
                        "latitude": "45.25358000",
                        "longitude": "-92.80577000"
                    },
                    {
                        "id": 126052,
                        "name": "Scott County",
                        "latitude": "44.64846000",
                        "longitude": "-93.53593000"
                    },
                    {
                        "id": 126209,
                        "name": "Shafer",
                        "latitude": "45.38691000",
                        "longitude": "-92.74771000"
                    },
                    {
                        "id": 126211,
                        "name": "Shakopee",
                        "latitude": "44.79802000",
                        "longitude": "-93.52690000"
                    },
                    {
                        "id": 126314,
                        "name": "Sherburn",
                        "latitude": "43.65218000",
                        "longitude": "-94.72692000"
                    },
                    {
                        "id": 126316,
                        "name": "Sherburne County",
                        "latitude": "45.44395000",
                        "longitude": "-93.77459000"
                    },
                    {
                        "id": 126369,
                        "name": "Shoreview",
                        "latitude": "45.07913000",
                        "longitude": "-93.14717000"
                    },
                    {
                        "id": 126371,
                        "name": "Shorewood",
                        "latitude": "44.90080000",
                        "longitude": "-93.58912000"
                    },
                    {
                        "id": 126392,
                        "name": "Sibley County",
                        "latitude": "44.57948000",
                        "longitude": "-94.23216000"
                    },
                    {
                        "id": 126420,
                        "name": "Silver Bay",
                        "latitude": "47.29436000",
                        "longitude": "-91.25739000"
                    },
                    {
                        "id": 126495,
                        "name": "Slayton",
                        "latitude": "43.98774000",
                        "longitude": "-95.75585000"
                    },
                    {
                        "id": 126496,
                        "name": "Sleepy Eye",
                        "latitude": "44.29718000",
                        "longitude": "-94.72415000"
                    },
                    {
                        "id": 126721,
                        "name": "South Saint Paul",
                        "latitude": "44.89274000",
                        "longitude": "-93.03494000"
                    },
                    {
                        "id": 126834,
                        "name": "Spicer",
                        "latitude": "45.23302000",
                        "longitude": "-94.94001000"
                    },
                    {
                        "id": 126859,
                        "name": "Spring Grove",
                        "latitude": "43.56108000",
                        "longitude": "-91.63598000"
                    },
                    {
                        "id": 126869,
                        "name": "Spring Lake Park",
                        "latitude": "45.10774000",
                        "longitude": "-93.23800000"
                    },
                    {
                        "id": 126871,
                        "name": "Spring Park",
                        "latitude": "44.93524000",
                        "longitude": "-93.63218000"
                    },
                    {
                        "id": 126876,
                        "name": "Spring Valley",
                        "latitude": "43.68691000",
                        "longitude": "-92.38906000"
                    },
                    {
                        "id": 126902,
                        "name": "Springfield",
                        "latitude": "44.23885000",
                        "longitude": "-94.97582000"
                    },
                    {
                        "id": 126931,
                        "name": "Stacy",
                        "latitude": "45.39802000",
                        "longitude": "-92.98744000"
                    },
                    {
                        "id": 126975,
                        "name": "Staples",
                        "latitude": "46.35552000",
                        "longitude": "-94.79224000"
                    },
                    {
                        "id": 126983,
                        "name": "Starbuck",
                        "latitude": "45.61440000",
                        "longitude": "-95.53115000"
                    },
                    {
                        "id": 127005,
                        "name": "Stearns County",
                        "latitude": "45.55215000",
                        "longitude": "-94.61302000"
                    },
                    {
                        "id": 127010,
                        "name": "Steele County",
                        "latitude": "44.02234000",
                        "longitude": "-93.22604000"
                    },
                    {
                        "id": 127040,
                        "name": "Stevens County",
                        "latitude": "45.58613000",
                        "longitude": "-96.00030000"
                    },
                    {
                        "id": 127055,
                        "name": "Stewartville",
                        "latitude": "43.85552000",
                        "longitude": "-92.48851000"
                    },
                    {
                        "id": 127061,
                        "name": "Stillwater",
                        "latitude": "45.05636000",
                        "longitude": "-92.80604000"
                    },
                    {
                        "id": 127345,
                        "name": "Swift County",
                        "latitude": "45.28271000",
                        "longitude": "-95.68143000"
                    },
                    {
                        "id": 127462,
                        "name": "Taylors Falls",
                        "latitude": "45.40191000",
                        "longitude": "-92.65243000"
                    },
                    {
                        "id": 127574,
                        "name": "Thief River Falls",
                        "latitude": "48.11914000",
                        "longitude": "-96.18115000"
                    },
                    {
                        "id": 127693,
                        "name": "Todd County",
                        "latitude": "46.07062000",
                        "longitude": "-94.89760000"
                    },
                    {
                        "id": 127720,
                        "name": "Tonka Bay",
                        "latitude": "44.90857000",
                        "longitude": "-93.59301000"
                    },
                    {
                        "id": 127770,
                        "name": "Tracy",
                        "latitude": "44.23329000",
                        "longitude": "-95.61918000"
                    },
                    {
                        "id": 127785,
                        "name": "Traverse County",
                        "latitude": "45.77218000",
                        "longitude": "-96.47164000"
                    },
                    {
                        "id": 127855,
                        "name": "Truman",
                        "latitude": "43.82773000",
                        "longitude": "-94.43719000"
                    },
                    {
                        "id": 127935,
                        "name": "Two Harbors",
                        "latitude": "47.02271000",
                        "longitude": "-91.67073000"
                    },
                    {
                        "id": 127941,
                        "name": "Tyler",
                        "latitude": "44.27830000",
                        "longitude": "-96.13475000"
                    },
                    {
                        "id": 128073,
                        "name": "Vadnais Heights",
                        "latitude": "45.05747000",
                        "longitude": "-93.07383000"
                    },
                    {
                        "id": 128222,
                        "name": "Victoria",
                        "latitude": "44.85857000",
                        "longitude": "-93.66163000"
                    },
                    {
                        "id": 128271,
                        "name": "Vineland",
                        "latitude": "46.16357000",
                        "longitude": "-93.75747000"
                    },
                    {
                        "id": 128287,
                        "name": "Virginia",
                        "latitude": "47.52326000",
                        "longitude": "-92.53657000"
                    },
                    {
                        "id": 128312,
                        "name": "Wabasha",
                        "latitude": "44.38386000",
                        "longitude": "-92.03294000"
                    },
                    {
                        "id": 128313,
                        "name": "Wabasha County",
                        "latitude": "44.28428000",
                        "longitude": "-92.23027000"
                    },
                    {
                        "id": 128317,
                        "name": "Waconia",
                        "latitude": "44.85080000",
                        "longitude": "-93.78691000"
                    },
                    {
                        "id": 128321,
                        "name": "Wadena",
                        "latitude": "46.44246000",
                        "longitude": "-95.13614000"
                    },
                    {
                        "id": 128322,
                        "name": "Wadena County",
                        "latitude": "46.58576000",
                        "longitude": "-94.96941000"
                    },
                    {
                        "id": 128353,
                        "name": "Waite Park",
                        "latitude": "45.55719000",
                        "longitude": "-94.22416000"
                    },
                    {
                        "id": 128385,
                        "name": "Walker",
                        "latitude": "47.10135000",
                        "longitude": "-94.58722000"
                    },
                    {
                        "id": 128448,
                        "name": "Wanamingo",
                        "latitude": "44.30441000",
                        "longitude": "-92.79047000"
                    },
                    {
                        "id": 128482,
                        "name": "Warren",
                        "latitude": "48.19664000",
                        "longitude": "-96.77284000"
                    },
                    {
                        "id": 128514,
                        "name": "Warroad",
                        "latitude": "48.90527000",
                        "longitude": "-95.31440000"
                    },
                    {
                        "id": 128530,
                        "name": "Waseca",
                        "latitude": "44.07774000",
                        "longitude": "-93.50744000"
                    },
                    {
                        "id": 128531,
                        "name": "Waseca County",
                        "latitude": "44.02212000",
                        "longitude": "-93.58728000"
                    },
                    {
                        "id": 128570,
                        "name": "Washington County",
                        "latitude": "45.03873000",
                        "longitude": "-92.88396000"
                    },
                    {
                        "id": 128622,
                        "name": "Watertown",
                        "latitude": "44.96357000",
                        "longitude": "-93.84719000"
                    },
                    {
                        "id": 128627,
                        "name": "Waterville",
                        "latitude": "44.21885000",
                        "longitude": "-93.56800000"
                    },
                    {
                        "id": 128637,
                        "name": "Watonwan County",
                        "latitude": "43.97843000",
                        "longitude": "-94.61406000"
                    },
                    {
                        "id": 128670,
                        "name": "Waverly",
                        "latitude": "45.06663000",
                        "longitude": "-93.96636000"
                    },
                    {
                        "id": 128713,
                        "name": "Wayzata",
                        "latitude": "44.97413000",
                        "longitude": "-93.50662000"
                    },
                    {
                        "id": 128782,
                        "name": "Wells",
                        "latitude": "43.74607000",
                        "longitude": "-93.72884000"
                    },
                    {
                        "id": 128852,
                        "name": "West Coon Rapids",
                        "latitude": "45.15969000",
                        "longitude": "-93.34967000"
                    },
                    {
                        "id": 128972,
                        "name": "West Saint Paul",
                        "latitude": "44.91608000",
                        "longitude": "-93.10161000"
                    },
                    {
                        "id": 129114,
                        "name": "Wheaton",
                        "latitude": "45.80441000",
                        "longitude": "-96.49923000"
                    },
                    {
                        "id": 129126,
                        "name": "White Bear Lake",
                        "latitude": "45.08469000",
                        "longitude": "-93.00994000"
                    },
                    {
                        "id": 129248,
                        "name": "Wilkin County",
                        "latitude": "46.35708000",
                        "longitude": "-96.46835000"
                    },
                    {
                        "id": 129303,
                        "name": "Willmar",
                        "latitude": "45.12191000",
                        "longitude": "-95.04334000"
                    },
                    {
                        "id": 129375,
                        "name": "Windom",
                        "latitude": "43.86635000",
                        "longitude": "-95.11694000"
                    },
                    {
                        "id": 129406,
                        "name": "Winnebago",
                        "latitude": "43.76773000",
                        "longitude": "-94.16579000"
                    },
                    {
                        "id": 129424,
                        "name": "Winona",
                        "latitude": "44.04996000",
                        "longitude": "-91.63932000"
                    },
                    {
                        "id": 129425,
                        "name": "Winona County",
                        "latitude": "43.98685000",
                        "longitude": "-91.77913000"
                    },
                    {
                        "id": 129431,
                        "name": "Winsted",
                        "latitude": "44.96385000",
                        "longitude": "-94.04747000"
                    },
                    {
                        "id": 129451,
                        "name": "Winthrop",
                        "latitude": "44.54302000",
                        "longitude": "-94.36637000"
                    },
                    {
                        "id": 129509,
                        "name": "Woodbury",
                        "latitude": "44.92386000",
                        "longitude": "-92.95938000"
                    },
                    {
                        "id": 129598,
                        "name": "Worthington",
                        "latitude": "43.61996000",
                        "longitude": "-95.59640000"
                    },
                    {
                        "id": 129610,
                        "name": "Wright County",
                        "latitude": "45.17393000",
                        "longitude": "-93.96305000"
                    },
                    {
                        "id": 129637,
                        "name": "Wyoming",
                        "latitude": "45.33636000",
                        "longitude": "-92.99716000"
                    },
                    {
                        "id": 129678,
                        "name": "Yellow Medicine County",
                        "latitude": "44.71625000",
                        "longitude": "-95.86836000"
                    },
                    {
                        "id": 129713,
                        "name": "Young America (historical)",
                        "latitude": "44.78274000",
                        "longitude": "-93.91358000"
                    },
                    {
                        "id": 129756,
                        "name": "Zimmerman",
                        "latitude": "45.44330000",
                        "longitude": "-93.58996000"
                    },
                    {
                        "id": 129761,
                        "name": "Zumbrota",
                        "latitude": "44.29413000",
                        "longitude": "-92.66908000"
                    }
                ]
            },
            {
                "id": 1430,
                "name": "Mississippi",
                "iso2": "MS",
                "latitude": "32.35466790",
                "longitude": "-89.39852830",
                "type": "state",
                "cities": [
                    {
                        "id": 110974,
                        "name": "Aberdeen",
                        "latitude": "33.82511000",
                        "longitude": "-88.54366000"
                    },
                    {
                        "id": 110996,
                        "name": "Ackerman",
                        "latitude": "33.31012000",
                        "longitude": "-89.17284000"
                    },
                    {
                        "id": 111018,
                        "name": "Adams County",
                        "latitude": "31.48294000",
                        "longitude": "-91.35350000"
                    },
                    {
                        "id": 111134,
                        "name": "Alcorn County",
                        "latitude": "34.88077000",
                        "longitude": "-88.58026000"
                    },
                    {
                        "id": 111289,
                        "name": "Amite County",
                        "latitude": "31.17440000",
                        "longitude": "-90.80443000"
                    },
                    {
                        "id": 111294,
                        "name": "Amory",
                        "latitude": "33.98428000",
                        "longitude": "-88.48810000"
                    },
                    {
                        "id": 111489,
                        "name": "Arnold Line",
                        "latitude": "31.33517000",
                        "longitude": "-89.37340000"
                    },
                    {
                        "id": 111530,
                        "name": "Ashland",
                        "latitude": "34.83287000",
                        "longitude": "-89.17590000"
                    },
                    {
                        "id": 111607,
                        "name": "Attala County",
                        "latitude": "33.08629000",
                        "longitude": "-89.58155000"
                    },
                    {
                        "id": 111766,
                        "name": "Baldwyn",
                        "latitude": "34.50954000",
                        "longitude": "-88.63533000"
                    },
                    {
                        "id": 111894,
                        "name": "Batesville",
                        "latitude": "34.31150000",
                        "longitude": "-89.94426000"
                    },
                    {
                        "id": 111933,
                        "name": "Bay Saint Louis",
                        "latitude": "30.30881000",
                        "longitude": "-89.33005000"
                    },
                    {
                        "id": 111935,
                        "name": "Bay Springs",
                        "latitude": "31.97904000",
                        "longitude": "-89.28728000"
                    },
                    {
                        "id": 112041,
                        "name": "Beechwood",
                        "latitude": "32.32765000",
                        "longitude": "-90.82677000"
                    },
                    {
                        "id": 112135,
                        "name": "Belmont",
                        "latitude": "34.50982000",
                        "longitude": "-88.20921000"
                    },
                    {
                        "id": 112158,
                        "name": "Belzoni",
                        "latitude": "33.18429000",
                        "longitude": "-90.48926000"
                    },
                    {
                        "id": 112201,
                        "name": "Benton County",
                        "latitude": "34.81729000",
                        "longitude": "-89.18848000"
                    },
                    {
                        "id": 112347,
                        "name": "Biloxi",
                        "latitude": "30.39603000",
                        "longitude": "-88.88531000"
                    },
                    {
                        "id": 112521,
                        "name": "Bolivar County",
                        "latitude": "33.79554000",
                        "longitude": "-90.88040000"
                    },
                    {
                        "id": 112564,
                        "name": "Booneville",
                        "latitude": "34.65815000",
                        "longitude": "-88.56672000"
                    },
                    {
                        "id": 112689,
                        "name": "Brandon",
                        "latitude": "32.27320000",
                        "longitude": "-89.98592000"
                    },
                    {
                        "id": 112857,
                        "name": "Brookhaven",
                        "latitude": "31.57906000",
                        "longitude": "-90.44065000"
                    },
                    {
                        "id": 112892,
                        "name": "Brooksville",
                        "latitude": "33.23457000",
                        "longitude": "-88.58227000"
                    },
                    {
                        "id": 112942,
                        "name": "Bruce",
                        "latitude": "33.99206000",
                        "longitude": "-89.34896000"
                    },
                    {
                        "id": 112995,
                        "name": "Bude",
                        "latitude": "31.46295000",
                        "longitude": "-90.85010000"
                    },
                    {
                        "id": 113135,
                        "name": "Byhalia",
                        "latitude": "34.87232000",
                        "longitude": "-89.69064000"
                    },
                    {
                        "id": 113139,
                        "name": "Byram",
                        "latitude": "32.17932000",
                        "longitude": "-90.24537000"
                    },
                    {
                        "id": 113188,
                        "name": "Caledonia",
                        "latitude": "33.68289000",
                        "longitude": "-88.32448000"
                    },
                    {
                        "id": 113199,
                        "name": "Calhoun City",
                        "latitude": "33.85539000",
                        "longitude": "-89.31146000"
                    },
                    {
                        "id": 113205,
                        "name": "Calhoun County",
                        "latitude": "33.93645000",
                        "longitude": "-89.33645000"
                    },
                    {
                        "id": 113340,
                        "name": "Canton",
                        "latitude": "32.61264000",
                        "longitude": "-90.03675000"
                    },
                    {
                        "id": 113445,
                        "name": "Carriere",
                        "latitude": "30.61686000",
                        "longitude": "-89.65256000"
                    },
                    {
                        "id": 113455,
                        "name": "Carroll County",
                        "latitude": "33.44853000",
                        "longitude": "-89.92020000"
                    },
                    {
                        "id": 113468,
                        "name": "Carrollton",
                        "latitude": "33.50818000",
                        "longitude": "-89.92036000"
                    },
                    {
                        "id": 113492,
                        "name": "Carthage",
                        "latitude": "32.73264000",
                        "longitude": "-89.53618000"
                    },
                    {
                        "id": 113694,
                        "name": "Centreville",
                        "latitude": "31.08962000",
                        "longitude": "-91.06844000"
                    },
                    {
                        "id": 113764,
                        "name": "Charleston",
                        "latitude": "34.00678000",
                        "longitude": "-90.05676000"
                    },
                    {
                        "id": 113939,
                        "name": "Chickasaw County",
                        "latitude": "33.92080000",
                        "longitude": "-88.94786000"
                    },
                    {
                        "id": 113987,
                        "name": "Choctaw County",
                        "latitude": "33.34731000",
                        "longitude": "-89.24838000"
                    },
                    {
                        "id": 114093,
                        "name": "Claiborne County",
                        "latitude": "31.97369000",
                        "longitude": "-90.91181000"
                    },
                    {
                        "id": 114136,
                        "name": "Clarke County",
                        "latitude": "32.04140000",
                        "longitude": "-88.68940000"
                    },
                    {
                        "id": 114145,
                        "name": "Clarksdale",
                        "latitude": "34.20011000",
                        "longitude": "-90.57093000"
                    },
                    {
                        "id": 114182,
                        "name": "Clay County",
                        "latitude": "33.65567000",
                        "longitude": "-88.78157000"
                    },
                    {
                        "id": 114228,
                        "name": "Cleary",
                        "latitude": "32.16543000",
                        "longitude": "-90.18064000"
                    },
                    {
                        "id": 114243,
                        "name": "Cleveland",
                        "latitude": "33.74400000",
                        "longitude": "-90.72482000"
                    },
                    {
                        "id": 114274,
                        "name": "Clinton",
                        "latitude": "32.34153000",
                        "longitude": "-90.32176000"
                    },
                    {
                        "id": 114325,
                        "name": "Coahoma County",
                        "latitude": "34.22917000",
                        "longitude": "-90.60269000"
                    },
                    {
                        "id": 114393,
                        "name": "Coldwater",
                        "latitude": "34.69177000",
                        "longitude": "-89.97731000"
                    },
                    {
                        "id": 114431,
                        "name": "Collins",
                        "latitude": "31.64544000",
                        "longitude": "-89.55535000"
                    },
                    {
                        "id": 114435,
                        "name": "Collinsville",
                        "latitude": "32.49792000",
                        "longitude": "-88.84588000"
                    },
                    {
                        "id": 114469,
                        "name": "Columbia",
                        "latitude": "31.25184000",
                        "longitude": "-89.83758000"
                    },
                    {
                        "id": 114494,
                        "name": "Columbus",
                        "latitude": "33.49567000",
                        "longitude": "-88.42726000"
                    },
                    {
                        "id": 114501,
                        "name": "Columbus Air Force Base",
                        "latitude": "33.63239000",
                        "longitude": "-88.45153000"
                    },
                    {
                        "id": 114527,
                        "name": "Como",
                        "latitude": "34.51066000",
                        "longitude": "-89.93981000"
                    },
                    {
                        "id": 114551,
                        "name": "Conehatta",
                        "latitude": "32.45125000",
                        "longitude": "-89.28534000"
                    },
                    {
                        "id": 114617,
                        "name": "Copiah County",
                        "latitude": "31.86924000",
                        "longitude": "-90.44880000"
                    },
                    {
                        "id": 114643,
                        "name": "Corinth",
                        "latitude": "34.93425000",
                        "longitude": "-88.52227000"
                    },
                    {
                        "id": 114743,
                        "name": "Covington County",
                        "latitude": "31.63322000",
                        "longitude": "-89.55263000"
                    },
                    {
                        "id": 114884,
                        "name": "Crystal Springs",
                        "latitude": "31.98738000",
                        "longitude": "-90.35704000"
                    },
                    {
                        "id": 114961,
                        "name": "D'Iberville",
                        "latitude": "30.42631000",
                        "longitude": "-88.89086000"
                    },
                    {
                        "id": 115106,
                        "name": "De Kalb",
                        "latitude": "32.76763000",
                        "longitude": "-88.65088000"
                    },
                    {
                        "id": 115111,
                        "name": "De Lisle",
                        "latitude": "30.37936000",
                        "longitude": "-89.26449000"
                    },
                    {
                        "id": 115119,
                        "name": "De Soto County",
                        "latitude": "34.87540000",
                        "longitude": "-89.99178000"
                    },
                    {
                        "id": 115153,
                        "name": "Decatur",
                        "latitude": "32.43903000",
                        "longitude": "-89.10839000"
                    },
                    {
                        "id": 115263,
                        "name": "Derma",
                        "latitude": "33.85567000",
                        "longitude": "-89.28452000"
                    },
                    {
                        "id": 115317,
                        "name": "Diamondhead",
                        "latitude": "30.39464000",
                        "longitude": "-89.36394000"
                    },
                    {
                        "id": 115473,
                        "name": "Drew",
                        "latitude": "33.80956000",
                        "longitude": "-90.52648000"
                    },
                    {
                        "id": 115504,
                        "name": "Duck Hill",
                        "latitude": "33.63318000",
                        "longitude": "-89.71119000"
                    },
                    {
                        "id": 115566,
                        "name": "Durant",
                        "latitude": "33.07513000",
                        "longitude": "-89.85453000"
                    },
                    {
                        "id": 115886,
                        "name": "Edwards",
                        "latitude": "32.33015000",
                        "longitude": "-90.60565000"
                    },
                    {
                        "id": 116035,
                        "name": "Ellisville",
                        "latitude": "31.60405000",
                        "longitude": "-89.19561000"
                    },
                    {
                        "id": 116182,
                        "name": "Escatawpa",
                        "latitude": "30.44048000",
                        "longitude": "-88.54363000"
                    },
                    {
                        "id": 116231,
                        "name": "Eupora",
                        "latitude": "33.54068000",
                        "longitude": "-89.26701000"
                    },
                    {
                        "id": 116414,
                        "name": "Farmington",
                        "latitude": "34.93009000",
                        "longitude": "-88.45227000"
                    },
                    {
                        "id": 116440,
                        "name": "Fayette",
                        "latitude": "31.71155000",
                        "longitude": "-91.06066000"
                    },
                    {
                        "id": 116571,
                        "name": "Flora",
                        "latitude": "32.54320000",
                        "longitude": "-90.30926000"
                    },
                    {
                        "id": 116579,
                        "name": "Florence",
                        "latitude": "32.15348000",
                        "longitude": "-90.13120000"
                    },
                    {
                        "id": 116604,
                        "name": "Flowood",
                        "latitude": "32.30959000",
                        "longitude": "-90.13898000"
                    },
                    {
                        "id": 116643,
                        "name": "Forest",
                        "latitude": "32.36459000",
                        "longitude": "-89.47423000"
                    },
                    {
                        "id": 116680,
                        "name": "Forrest County",
                        "latitude": "31.18887000",
                        "longitude": "-89.25786000"
                    },
                    {
                        "id": 116852,
                        "name": "Franklin County",
                        "latitude": "31.47715000",
                        "longitude": "-90.89785000"
                    },
                    {
                        "id": 116942,
                        "name": "Friars Point",
                        "latitude": "34.37088000",
                        "longitude": "-90.63834000"
                    },
                    {
                        "id": 116988,
                        "name": "Fulton",
                        "latitude": "34.27399000",
                        "longitude": "-88.40921000"
                    },
                    {
                        "id": 117126,
                        "name": "Gautier",
                        "latitude": "30.38575000",
                        "longitude": "-88.61169000"
                    },
                    {
                        "id": 117153,
                        "name": "George County",
                        "latitude": "30.86261000",
                        "longitude": "-88.64403000"
                    },
                    {
                        "id": 117281,
                        "name": "Glendale",
                        "latitude": "31.36462000",
                        "longitude": "-89.30617000"
                    },
                    {
                        "id": 117388,
                        "name": "Goodman",
                        "latitude": "32.97013000",
                        "longitude": "-89.91231000"
                    },
                    {
                        "id": 117637,
                        "name": "Greene County",
                        "latitude": "31.21422000",
                        "longitude": "-88.63916000"
                    },
                    {
                        "id": 117686,
                        "name": "Greenville",
                        "latitude": "33.40898000",
                        "longitude": "-91.05978000"
                    },
                    {
                        "id": 117705,
                        "name": "Greenwood",
                        "latitude": "33.51623000",
                        "longitude": "-90.17953000"
                    },
                    {
                        "id": 117720,
                        "name": "Grenada",
                        "latitude": "33.76900000",
                        "longitude": "-89.80842000"
                    },
                    {
                        "id": 117721,
                        "name": "Grenada County",
                        "latitude": "33.76995000",
                        "longitude": "-89.80201000"
                    },
                    {
                        "id": 117793,
                        "name": "Gulf Hills",
                        "latitude": "30.43048000",
                        "longitude": "-88.84225000"
                    },
                    {
                        "id": 117794,
                        "name": "Gulf Park Estates",
                        "latitude": "30.39187000",
                        "longitude": "-88.76114000"
                    },
                    {
                        "id": 117797,
                        "name": "Gulfport",
                        "latitude": "30.36742000",
                        "longitude": "-89.09282000"
                    },
                    {
                        "id": 117807,
                        "name": "Guntown",
                        "latitude": "34.44316000",
                        "longitude": "-88.65978000"
                    },
                    {
                        "id": 117953,
                        "name": "Hancock County",
                        "latitude": "30.39378000",
                        "longitude": "-89.47456000"
                    },
                    {
                        "id": 118064,
                        "name": "Harrison County",
                        "latitude": "30.41605000",
                        "longitude": "-89.08164000"
                    },
                    {
                        "id": 118140,
                        "name": "Hattiesburg",
                        "latitude": "31.32712000",
                        "longitude": "-89.29034000"
                    },
                    {
                        "id": 118212,
                        "name": "Hazlehurst",
                        "latitude": "31.86044000",
                        "longitude": "-90.39593000"
                    },
                    {
                        "id": 118249,
                        "name": "Helena",
                        "latitude": "30.49464000",
                        "longitude": "-88.49585000"
                    },
                    {
                        "id": 118333,
                        "name": "Hernando",
                        "latitude": "34.82399000",
                        "longitude": "-89.99370000"
                    },
                    {
                        "id": 118368,
                        "name": "Hickory Hills",
                        "latitude": "30.45687000",
                        "longitude": "-88.63919000"
                    },
                    {
                        "id": 118381,
                        "name": "Hide-A-Way Lake",
                        "latitude": "30.56492000",
                        "longitude": "-89.64020000"
                    },
                    {
                        "id": 118448,
                        "name": "Hillsboro",
                        "latitude": "32.45931000",
                        "longitude": "-89.51146000"
                    },
                    {
                        "id": 118479,
                        "name": "Hinds County",
                        "latitude": "32.26670000",
                        "longitude": "-90.44282000"
                    },
                    {
                        "id": 118541,
                        "name": "Hollandale",
                        "latitude": "33.16901000",
                        "longitude": "-90.85399000"
                    },
                    {
                        "id": 118563,
                        "name": "Holly Springs",
                        "latitude": "34.76760000",
                        "longitude": "-89.44869000"
                    },
                    {
                        "id": 118572,
                        "name": "Holmes County",
                        "latitude": "33.12351000",
                        "longitude": "-90.09205000"
                    },
                    {
                        "id": 118666,
                        "name": "Horn Lake",
                        "latitude": "34.95537000",
                        "longitude": "-90.03481000"
                    },
                    {
                        "id": 118698,
                        "name": "Houston",
                        "latitude": "33.89845000",
                        "longitude": "-88.99923000"
                    },
                    {
                        "id": 118784,
                        "name": "Humphreys County",
                        "latitude": "33.12870000",
                        "longitude": "-90.52662000"
                    },
                    {
                        "id": 118819,
                        "name": "Hurley",
                        "latitude": "30.66103000",
                        "longitude": "-88.49418000"
                    },
                    {
                        "id": 118925,
                        "name": "Indianola",
                        "latitude": "33.45095000",
                        "longitude": "-90.65509000"
                    },
                    {
                        "id": 119037,
                        "name": "Issaquena County",
                        "latitude": "32.74139000",
                        "longitude": "-90.98921000"
                    },
                    {
                        "id": 119042,
                        "name": "Itawamba County",
                        "latitude": "34.27999000",
                        "longitude": "-88.36132000"
                    },
                    {
                        "id": 119045,
                        "name": "Itta Bena",
                        "latitude": "33.49512000",
                        "longitude": "-90.31981000"
                    },
                    {
                        "id": 119046,
                        "name": "Iuka",
                        "latitude": "34.81176000",
                        "longitude": "-88.19004000"
                    },
                    {
                        "id": 119065,
                        "name": "Jackson",
                        "latitude": "32.29876000",
                        "longitude": "-90.18481000"
                    },
                    {
                        "id": 119084,
                        "name": "Jackson County",
                        "latitude": "30.46289000",
                        "longitude": "-88.62284000"
                    },
                    {
                        "id": 119148,
                        "name": "Jasper County",
                        "latitude": "32.01911000",
                        "longitude": "-89.11886000"
                    },
                    {
                        "id": 119184,
                        "name": "Jefferson County",
                        "latitude": "31.73421000",
                        "longitude": "-91.03718000"
                    },
                    {
                        "id": 119199,
                        "name": "Jefferson Davis County",
                        "latitude": "31.56964000",
                        "longitude": "-89.82300000"
                    },
                    {
                        "id": 119293,
                        "name": "Jones County",
                        "latitude": "31.62256000",
                        "longitude": "-89.16879000"
                    },
                    {
                        "id": 119306,
                        "name": "Jonestown",
                        "latitude": "34.31955000",
                        "longitude": "-90.45565000"
                    },
                    {
                        "id": 119410,
                        "name": "Kearney Park",
                        "latitude": "32.58903000",
                        "longitude": "-90.31537000"
                    },
                    {
                        "id": 119437,
                        "name": "Kemper County",
                        "latitude": "32.75456000",
                        "longitude": "-88.64116000"
                    },
                    {
                        "id": 119564,
                        "name": "Kiln",
                        "latitude": "30.40908000",
                        "longitude": "-89.43505000"
                    },
                    {
                        "id": 119709,
                        "name": "Kosciusko",
                        "latitude": "33.05800000",
                        "longitude": "-89.58956000"
                    },
                    {
                        "id": 119841,
                        "name": "Lafayette County",
                        "latitude": "34.35675000",
                        "longitude": "-89.48492000"
                    },
                    {
                        "id": 120063,
                        "name": "Lamar County",
                        "latitude": "31.20587000",
                        "longitude": "-89.50869000"
                    },
                    {
                        "id": 120067,
                        "name": "Lambert",
                        "latitude": "34.20178000",
                        "longitude": "-90.28343000"
                    },
                    {
                        "id": 120172,
                        "name": "Latimer",
                        "latitude": "30.53464000",
                        "longitude": "-88.86670000"
                    },
                    {
                        "id": 120180,
                        "name": "Lauderdale County",
                        "latitude": "32.40429000",
                        "longitude": "-88.66254000"
                    },
                    {
                        "id": 120190,
                        "name": "Laurel",
                        "latitude": "31.69405000",
                        "longitude": "-89.13061000"
                    },
                    {
                        "id": 120235,
                        "name": "Lawrence County",
                        "latitude": "31.55020000",
                        "longitude": "-90.10699000"
                    },
                    {
                        "id": 120275,
                        "name": "Leake County",
                        "latitude": "32.75353000",
                        "longitude": "-89.52406000"
                    },
                    {
                        "id": 120276,
                        "name": "Leakesville",
                        "latitude": "31.15574000",
                        "longitude": "-88.55780000"
                    },
                    {
                        "id": 120311,
                        "name": "Lee County",
                        "latitude": "34.28989000",
                        "longitude": "-88.68042000"
                    },
                    {
                        "id": 120331,
                        "name": "Leflore County",
                        "latitude": "33.55052000",
                        "longitude": "-90.30106000"
                    },
                    {
                        "id": 120349,
                        "name": "Leland",
                        "latitude": "33.40539000",
                        "longitude": "-90.89760000"
                    },
                    {
                        "id": 120441,
                        "name": "Lexington",
                        "latitude": "33.11318000",
                        "longitude": "-90.05314000"
                    },
                    {
                        "id": 120463,
                        "name": "Liberty",
                        "latitude": "31.15823000",
                        "longitude": "-90.81232000"
                    },
                    {
                        "id": 120521,
                        "name": "Lincoln County",
                        "latitude": "31.53239000",
                        "longitude": "-90.45400000"
                    },
                    {
                        "id": 120735,
                        "name": "Long Beach",
                        "latitude": "30.35048000",
                        "longitude": "-89.15282000"
                    },
                    {
                        "id": 120814,
                        "name": "Louisville",
                        "latitude": "33.12374000",
                        "longitude": "-89.05506000"
                    },
                    {
                        "id": 120848,
                        "name": "Lowndes County",
                        "latitude": "33.47291000",
                        "longitude": "-88.44331000"
                    },
                    {
                        "id": 120864,
                        "name": "Lucedale",
                        "latitude": "30.92519000",
                        "longitude": "-88.59002000"
                    },
                    {
                        "id": 120879,
                        "name": "Lumberton",
                        "latitude": "31.00129000",
                        "longitude": "-89.45229000"
                    },
                    {
                        "id": 120908,
                        "name": "Lyman",
                        "latitude": "30.49474000",
                        "longitude": "-89.12561000"
                    },
                    {
                        "id": 120914,
                        "name": "Lynchburg",
                        "latitude": "34.96232000",
                        "longitude": "-90.09593000"
                    },
                    {
                        "id": 120966,
                        "name": "Macon",
                        "latitude": "33.10540000",
                        "longitude": "-88.56088000"
                    },
                    {
                        "id": 120989,
                        "name": "Madison",
                        "latitude": "32.46181000",
                        "longitude": "-90.11536000"
                    },
                    {
                        "id": 121009,
                        "name": "Madison County",
                        "latitude": "32.63466000",
                        "longitude": "-90.03376000"
                    },
                    {
                        "id": 121032,
                        "name": "Magee",
                        "latitude": "31.87377000",
                        "longitude": "-89.73369000"
                    },
                    {
                        "id": 121036,
                        "name": "Magnolia",
                        "latitude": "31.14323000",
                        "longitude": "-90.45871000"
                    },
                    {
                        "id": 121153,
                        "name": "Mantachie",
                        "latitude": "34.32427000",
                        "longitude": "-88.49116000"
                    },
                    {
                        "id": 121237,
                        "name": "Marion",
                        "latitude": "32.41736000",
                        "longitude": "-88.64782000"
                    },
                    {
                        "id": 121256,
                        "name": "Marion County",
                        "latitude": "31.23082000",
                        "longitude": "-89.82244000"
                    },
                    {
                        "id": 121272,
                        "name": "Marks",
                        "latitude": "34.25683000",
                        "longitude": "-90.27298000"
                    },
                    {
                        "id": 121313,
                        "name": "Marshall County",
                        "latitude": "34.76225000",
                        "longitude": "-89.50305000"
                    },
                    {
                        "id": 121434,
                        "name": "Mayersville",
                        "latitude": "32.90207000",
                        "longitude": "-91.05122000"
                    },
                    {
                        "id": 121474,
                        "name": "McComb",
                        "latitude": "31.24379000",
                        "longitude": "-90.45315000"
                    },
                    {
                        "id": 121574,
                        "name": "Meadville",
                        "latitude": "31.47239000",
                        "longitude": "-90.89677000"
                    },
                    {
                        "id": 121650,
                        "name": "Mendenhall",
                        "latitude": "31.96182000",
                        "longitude": "-89.87008000"
                    },
                    {
                        "id": 121690,
                        "name": "Meridian",
                        "latitude": "32.36431000",
                        "longitude": "-88.70366000"
                    },
                    {
                        "id": 121697,
                        "name": "Meridian Station",
                        "latitude": "32.55049000",
                        "longitude": "-88.61849000"
                    },
                    {
                        "id": 121732,
                        "name": "Metcalfe",
                        "latitude": "33.45400000",
                        "longitude": "-91.00733000"
                    },
                    {
                        "id": 121830,
                        "name": "Mikoma",
                        "latitude": "33.95039000",
                        "longitude": "-90.28398000"
                    },
                    {
                        "id": 122075,
                        "name": "Monroe County",
                        "latitude": "33.89224000",
                        "longitude": "-88.48047000"
                    },
                    {
                        "id": 122147,
                        "name": "Montgomery County",
                        "latitude": "33.49410000",
                        "longitude": "-89.61640000"
                    },
                    {
                        "id": 122163,
                        "name": "Monticello",
                        "latitude": "31.55378000",
                        "longitude": "-90.10731000"
                    },
                    {
                        "id": 122211,
                        "name": "Moorhead",
                        "latitude": "33.45012000",
                        "longitude": "-90.50564000"
                    },
                    {
                        "id": 122252,
                        "name": "Morgantown",
                        "latitude": "31.57267000",
                        "longitude": "-91.34761000"
                    },
                    {
                        "id": 122291,
                        "name": "Morton",
                        "latitude": "32.35376000",
                        "longitude": "-89.65452000"
                    },
                    {
                        "id": 122309,
                        "name": "Moss Point",
                        "latitude": "30.41159000",
                        "longitude": "-88.53446000"
                    },
                    {
                        "id": 122319,
                        "name": "Mound Bayou",
                        "latitude": "33.87817000",
                        "longitude": "-90.72732000"
                    },
                    {
                        "id": 122587,
                        "name": "Natchez",
                        "latitude": "31.56017000",
                        "longitude": "-91.40329000"
                    },
                    {
                        "id": 122621,
                        "name": "Nellieburg",
                        "latitude": "32.40681000",
                        "longitude": "-88.77727000"
                    },
                    {
                        "id": 122641,
                        "name": "Neshoba County",
                        "latitude": "32.75350000",
                        "longitude": "-89.11757000"
                    },
                    {
                        "id": 122646,
                        "name": "Nettleton",
                        "latitude": "34.08900000",
                        "longitude": "-88.62227000"
                    },
                    {
                        "id": 122655,
                        "name": "New Albany",
                        "latitude": "34.49427000",
                        "longitude": "-89.00784000"
                    },
                    {
                        "id": 122657,
                        "name": "New Augusta",
                        "latitude": "31.20263000",
                        "longitude": "-89.03668000"
                    },
                    {
                        "id": 122724,
                        "name": "New Hope",
                        "latitude": "33.46817000",
                        "longitude": "-88.32670000"
                    },
                    {
                        "id": 122860,
                        "name": "Newton",
                        "latitude": "32.32126000",
                        "longitude": "-89.16339000"
                    },
                    {
                        "id": 122871,
                        "name": "Newton County",
                        "latitude": "32.40023000",
                        "longitude": "-89.11881000"
                    },
                    {
                        "id": 122893,
                        "name": "Nicholson",
                        "latitude": "30.47714000",
                        "longitude": "-89.69367000"
                    },
                    {
                        "id": 123116,
                        "name": "North Tunica",
                        "latitude": "34.70093000",
                        "longitude": "-90.37815000"
                    },
                    {
                        "id": 123212,
                        "name": "Noxubee County",
                        "latitude": "33.11011000",
                        "longitude": "-88.56982000"
                    },
                    {
                        "id": 123337,
                        "name": "Ocean Springs",
                        "latitude": "30.41131000",
                        "longitude": "-88.82781000"
                    },
                    {
                        "id": 123409,
                        "name": "Okolona",
                        "latitude": "34.00178000",
                        "longitude": "-88.75533000"
                    },
                    {
                        "id": 123410,
                        "name": "Oktibbeha County",
                        "latitude": "33.42495000",
                        "longitude": "-88.87930000"
                    },
                    {
                        "id": 123439,
                        "name": "Olive Branch",
                        "latitude": "34.96176000",
                        "longitude": "-89.82953000"
                    },
                    {
                        "id": 123678,
                        "name": "Oxford",
                        "latitude": "34.36650000",
                        "longitude": "-89.51925000"
                    },
                    {
                        "id": 123803,
                        "name": "Panola County",
                        "latitude": "34.36394000",
                        "longitude": "-89.95057000"
                    },
                    {
                        "id": 123900,
                        "name": "Pascagoula",
                        "latitude": "30.36576000",
                        "longitude": "-88.55613000"
                    },
                    {
                        "id": 123906,
                        "name": "Pass Christian",
                        "latitude": "30.31575000",
                        "longitude": "-89.24754000"
                    },
                    {
                        "id": 123963,
                        "name": "Pearl",
                        "latitude": "32.27459000",
                        "longitude": "-90.13203000"
                    },
                    {
                        "id": 123967,
                        "name": "Pearl River",
                        "latitude": "32.78347000",
                        "longitude": "-89.22784000"
                    },
                    {
                        "id": 123969,
                        "name": "Pearl River County",
                        "latitude": "30.76858000",
                        "longitude": "-89.58978000"
                    },
                    {
                        "id": 123971,
                        "name": "Pearlington",
                        "latitude": "30.24658000",
                        "longitude": "-89.61117000"
                    },
                    {
                        "id": 123987,
                        "name": "Pelahatchie",
                        "latitude": "32.31292000",
                        "longitude": "-89.79841000"
                    },
                    {
                        "id": 124080,
                        "name": "Perry County",
                        "latitude": "31.17202000",
                        "longitude": "-88.99233000"
                    },
                    {
                        "id": 124100,
                        "name": "Petal",
                        "latitude": "31.34656000",
                        "longitude": "-89.26006000"
                    },
                    {
                        "id": 124125,
                        "name": "Philadelphia",
                        "latitude": "32.77152000",
                        "longitude": "-89.11673000"
                    },
                    {
                        "id": 124153,
                        "name": "Picayune",
                        "latitude": "30.52556000",
                        "longitude": "-89.67788000"
                    },
                    {
                        "id": 124154,
                        "name": "Pickens",
                        "latitude": "32.88374000",
                        "longitude": "-89.97147000"
                    },
                    {
                        "id": 124192,
                        "name": "Pike County",
                        "latitude": "31.17491000",
                        "longitude": "-90.40416000"
                    },
                    {
                        "id": 124290,
                        "name": "Pittsboro",
                        "latitude": "33.94039000",
                        "longitude": "-89.33757000"
                    },
                    {
                        "id": 124348,
                        "name": "Plantersville",
                        "latitude": "34.21344000",
                        "longitude": "-88.66450000"
                    },
                    {
                        "id": 124476,
                        "name": "Pontotoc",
                        "latitude": "34.24788000",
                        "longitude": "-88.99867000"
                    },
                    {
                        "id": 124477,
                        "name": "Pontotoc County",
                        "latitude": "34.22544000",
                        "longitude": "-89.03741000"
                    },
                    {
                        "id": 124487,
                        "name": "Poplarville",
                        "latitude": "30.84019000",
                        "longitude": "-89.53423000"
                    },
                    {
                        "id": 124507,
                        "name": "Port Gibson",
                        "latitude": "31.96099000",
                        "longitude": "-90.98399000"
                    },
                    {
                        "id": 124640,
                        "name": "Prentiss",
                        "latitude": "31.59850000",
                        "longitude": "-89.86702000"
                    },
                    {
                        "id": 124641,
                        "name": "Prentiss County",
                        "latitude": "34.61829000",
                        "longitude": "-88.52010000"
                    },
                    {
                        "id": 124758,
                        "name": "Purvis",
                        "latitude": "31.14324000",
                        "longitude": "-89.40979000"
                    },
                    {
                        "id": 124806,
                        "name": "Quitman",
                        "latitude": "32.04015000",
                        "longitude": "-88.72810000"
                    },
                    {
                        "id": 124809,
                        "name": "Quitman County",
                        "latitude": "34.25141000",
                        "longitude": "-90.28912000"
                    },
                    {
                        "id": 124830,
                        "name": "Raleigh",
                        "latitude": "32.03349000",
                        "longitude": "-89.52229000"
                    },
                    {
                        "id": 124885,
                        "name": "Rankin County",
                        "latitude": "32.26412000",
                        "longitude": "-89.94580000"
                    },
                    {
                        "id": 124914,
                        "name": "Rawls Springs",
                        "latitude": "31.38073000",
                        "longitude": "-89.37145000"
                    },
                    {
                        "id": 124917,
                        "name": "Raymond",
                        "latitude": "32.25931000",
                        "longitude": "-90.42260000"
                    },
                    {
                        "id": 125069,
                        "name": "Richland",
                        "latitude": "32.23904000",
                        "longitude": "-90.15842000"
                    },
                    {
                        "id": 125107,
                        "name": "Richton",
                        "latitude": "31.34934000",
                        "longitude": "-88.94005000"
                    },
                    {
                        "id": 125123,
                        "name": "Ridgeland",
                        "latitude": "32.42848000",
                        "longitude": "-90.13231000"
                    },
                    {
                        "id": 125162,
                        "name": "Ripley",
                        "latitude": "34.72982000",
                        "longitude": "-88.95062000"
                    },
                    {
                        "id": 125365,
                        "name": "Rolling Fork",
                        "latitude": "32.90652000",
                        "longitude": "-90.87816000"
                    },
                    {
                        "id": 125417,
                        "name": "Rosedale",
                        "latitude": "33.85344000",
                        "longitude": "-91.02789000"
                    },
                    {
                        "id": 125506,
                        "name": "Ruleville",
                        "latitude": "33.72595000",
                        "longitude": "-90.55148000"
                    },
                    {
                        "id": 125686,
                        "name": "Saint Martin",
                        "latitude": "30.43798000",
                        "longitude": "-88.86809000"
                    },
                    {
                        "id": 125769,
                        "name": "Saltillo",
                        "latitude": "34.37649000",
                        "longitude": "-88.68172000"
                    },
                    {
                        "id": 125948,
                        "name": "Sardis",
                        "latitude": "34.43705000",
                        "longitude": "-89.91592000"
                    },
                    {
                        "id": 125958,
                        "name": "Saucier",
                        "latitude": "30.63575000",
                        "longitude": "-89.13504000"
                    },
                    {
                        "id": 126048,
                        "name": "Scott County",
                        "latitude": "32.40638000",
                        "longitude": "-89.53764000"
                    },
                    {
                        "id": 126153,
                        "name": "Senatobia",
                        "latitude": "34.61760000",
                        "longitude": "-89.96870000"
                    },
                    {
                        "id": 126219,
                        "name": "Shannon",
                        "latitude": "34.11622000",
                        "longitude": "-88.71172000"
                    },
                    {
                        "id": 126226,
                        "name": "Sharkey County",
                        "latitude": "32.87972000",
                        "longitude": "-90.81321000"
                    },
                    {
                        "id": 126227,
                        "name": "Sharon",
                        "latitude": "31.78960000",
                        "longitude": "-89.09867000"
                    },
                    {
                        "id": 126244,
                        "name": "Shaw",
                        "latitude": "33.60179100",
                        "longitude": "-90.78138720"
                    },
                    {
                        "id": 126245,
                        "name": "Shaw",
                        "latitude": "33.60211000",
                        "longitude": "-90.77458000"
                    },
                    {
                        "id": 126269,
                        "name": "Shelby",
                        "latitude": "33.95094000",
                        "longitude": "-90.76788000"
                    },
                    {
                        "id": 126450,
                        "name": "Simpson County",
                        "latitude": "31.91317000",
                        "longitude": "-89.91949000"
                    },
                    {
                        "id": 126513,
                        "name": "Smith County",
                        "latitude": "32.01769000",
                        "longitude": "-89.50668000"
                    },
                    {
                        "id": 126760,
                        "name": "Southaven",
                        "latitude": "34.98898000",
                        "longitude": "-90.01259000"
                    },
                    {
                        "id": 126989,
                        "name": "Starkville",
                        "latitude": "33.45049000",
                        "longitude": "-88.81961000"
                    },
                    {
                        "id": 127082,
                        "name": "Stone County",
                        "latitude": "30.78995000",
                        "longitude": "-89.11771000"
                    },
                    {
                        "id": 127092,
                        "name": "Stonewall",
                        "latitude": "32.13181000",
                        "longitude": "-88.79338000"
                    },
                    {
                        "id": 127211,
                        "name": "Summit",
                        "latitude": "31.28379000",
                        "longitude": "-90.46843000"
                    },
                    {
                        "id": 127226,
                        "name": "Sumrall",
                        "latitude": "31.41739000",
                        "longitude": "-89.54229000"
                    },
                    {
                        "id": 127251,
                        "name": "Sunflower",
                        "latitude": "33.54290000",
                        "longitude": "-90.53703000"
                    },
                    {
                        "id": 127252,
                        "name": "Sunflower County",
                        "latitude": "33.60231000",
                        "longitude": "-90.58862000"
                    },
                    {
                        "id": 127392,
                        "name": "Tallahatchie County",
                        "latitude": "33.95047000",
                        "longitude": "-90.17326000"
                    },
                    {
                        "id": 127438,
                        "name": "Tate County",
                        "latitude": "34.65032000",
                        "longitude": "-89.94478000"
                    },
                    {
                        "id": 127464,
                        "name": "Taylorsville",
                        "latitude": "31.82960000",
                        "longitude": "-89.42812000"
                    },
                    {
                        "id": 127472,
                        "name": "Tchula",
                        "latitude": "33.18290000",
                        "longitude": "-90.22286000"
                    },
                    {
                        "id": 127530,
                        "name": "Terry",
                        "latitude": "32.09626000",
                        "longitude": "-90.29426000"
                    },
                    {
                        "id": 127672,
                        "name": "Tippah County",
                        "latitude": "34.76840000",
                        "longitude": "-88.90890000"
                    },
                    {
                        "id": 127683,
                        "name": "Tishomingo County",
                        "latitude": "34.74043000",
                        "longitude": "-88.23932000"
                    },
                    {
                        "id": 127891,
                        "name": "Tunica",
                        "latitude": "34.68455000",
                        "longitude": "-90.38288000"
                    },
                    {
                        "id": 127892,
                        "name": "Tunica County",
                        "latitude": "34.65194000",
                        "longitude": "-90.37551000"
                    },
                    {
                        "id": 127893,
                        "name": "Tunica Resorts",
                        "latitude": "34.83613000",
                        "longitude": "-90.34723000"
                    },
                    {
                        "id": 127897,
                        "name": "Tupelo",
                        "latitude": "34.25807000",
                        "longitude": "-88.70464000"
                    },
                    {
                        "id": 127919,
                        "name": "Tutwiler",
                        "latitude": "34.01483000",
                        "longitude": "-90.43176000"
                    },
                    {
                        "id": 127944,
                        "name": "Tylertown",
                        "latitude": "31.11601000",
                        "longitude": "-90.14203000"
                    },
                    {
                        "id": 127972,
                        "name": "Union",
                        "latitude": "32.57153000",
                        "longitude": "-89.12145000"
                    },
                    {
                        "id": 127994,
                        "name": "Union County",
                        "latitude": "34.49047000",
                        "longitude": "-89.00386000"
                    },
                    {
                        "id": 128024,
                        "name": "University",
                        "latitude": "34.36594000",
                        "longitude": "-89.52536000"
                    },
                    {
                        "id": 128143,
                        "name": "Vancleave",
                        "latitude": "30.54047000",
                        "longitude": "-88.68752000"
                    },
                    {
                        "id": 128154,
                        "name": "Vardaman",
                        "latitude": "33.87567000",
                        "longitude": "-89.17729000"
                    },
                    {
                        "id": 128201,
                        "name": "Verona",
                        "latitude": "34.19427000",
                        "longitude": "-88.71977000"
                    },
                    {
                        "id": 128215,
                        "name": "Vicksburg",
                        "latitude": "32.35265000",
                        "longitude": "-90.87788000"
                    },
                    {
                        "id": 128319,
                        "name": "Wade",
                        "latitude": "30.64242000",
                        "longitude": "-88.56974000"
                    },
                    {
                        "id": 128412,
                        "name": "Walls",
                        "latitude": "34.95824000",
                        "longitude": "-90.15256000"
                    },
                    {
                        "id": 128418,
                        "name": "Walnut Grove",
                        "latitude": "32.59042000",
                        "longitude": "-89.45840000"
                    },
                    {
                        "id": 128430,
                        "name": "Walthall",
                        "latitude": "33.60734000",
                        "longitude": "-89.27729000"
                    },
                    {
                        "id": 128431,
                        "name": "Walthall County",
                        "latitude": "31.14842000",
                        "longitude": "-90.10614000"
                    },
                    {
                        "id": 128489,
                        "name": "Warren County",
                        "latitude": "32.35723000",
                        "longitude": "-90.85201000"
                    },
                    {
                        "id": 128562,
                        "name": "Washington County",
                        "latitude": "33.28370000",
                        "longitude": "-90.94745000"
                    },
                    {
                        "id": 128600,
                        "name": "Water Valley",
                        "latitude": "34.15150000",
                        "longitude": "-89.63147000"
                    },
                    {
                        "id": 128664,
                        "name": "Waveland",
                        "latitude": "30.28686000",
                        "longitude": "-89.37616000"
                    },
                    {
                        "id": 128694,
                        "name": "Wayne County",
                        "latitude": "31.64078000",
                        "longitude": "-88.69580000"
                    },
                    {
                        "id": 128706,
                        "name": "Waynesboro",
                        "latitude": "31.67488000",
                        "longitude": "-88.64615000"
                    },
                    {
                        "id": 128739,
                        "name": "Webster County",
                        "latitude": "33.61307000",
                        "longitude": "-89.28482000"
                    },
                    {
                        "id": 128814,
                        "name": "Wesson",
                        "latitude": "31.70128000",
                        "longitude": "-90.39759000"
                    },
                    {
                        "id": 128882,
                        "name": "West Gulfport",
                        "latitude": "30.40409000",
                        "longitude": "-89.09420000"
                    },
                    {
                        "id": 128886,
                        "name": "West Hattiesburg",
                        "latitude": "31.31906000",
                        "longitude": "-89.37506000"
                    },
                    {
                        "id": 128959,
                        "name": "West Point",
                        "latitude": "33.60762000",
                        "longitude": "-88.65033000"
                    },
                    {
                        "id": 129223,
                        "name": "Wiggins",
                        "latitude": "30.85824000",
                        "longitude": "-89.13533000"
                    },
                    {
                        "id": 129251,
                        "name": "Wilkinson County",
                        "latitude": "31.16107000",
                        "longitude": "-91.31092000"
                    },
                    {
                        "id": 129422,
                        "name": "Winona",
                        "latitude": "33.48207000",
                        "longitude": "-89.72814000"
                    },
                    {
                        "id": 129435,
                        "name": "Winston County",
                        "latitude": "33.08849000",
                        "longitude": "-89.03443000"
                    },
                    {
                        "id": 129571,
                        "name": "Woodville",
                        "latitude": "31.10462000",
                        "longitude": "-91.29956000"
                    },
                    {
                        "id": 129656,
                        "name": "Yalobusha County",
                        "latitude": "34.02821000",
                        "longitude": "-89.70763000"
                    },
                    {
                        "id": 129673,
                        "name": "Yazoo City",
                        "latitude": "32.85513000",
                        "longitude": "-90.40565000"
                    },
                    {
                        "id": 129674,
                        "name": "Yazoo County",
                        "latitude": "32.78031000",
                        "longitude": "-90.39642000"
                    }
                ]
            },
            {
                "id": 1451,
                "name": "Missouri",
                "iso2": "MO",
                "latitude": "37.96425290",
                "longitude": "-91.83183340",
                "type": "state",
                "cities": [
                    {
                        "id": 111011,
                        "name": "Adair County",
                        "latitude": "40.19056000",
                        "longitude": "-92.60072000"
                    },
                    {
                        "id": 111045,
                        "name": "Adrian",
                        "latitude": "38.39752000",
                        "longitude": "-94.35162000"
                    },
                    {
                        "id": 111048,
                        "name": "Advance",
                        "latitude": "37.10455000",
                        "longitude": "-89.90953000"
                    },
                    {
                        "id": 111051,
                        "name": "Affton",
                        "latitude": "38.55061000",
                        "longitude": "-90.33317000"
                    },
                    {
                        "id": 111107,
                        "name": "Albany",
                        "latitude": "40.24861000",
                        "longitude": "-94.33107000"
                    },
                    {
                        "id": 111243,
                        "name": "Alton",
                        "latitude": "36.69423000",
                        "longitude": "-91.39930000"
                    },
                    {
                        "id": 111310,
                        "name": "Anderson",
                        "latitude": "36.65063000",
                        "longitude": "-94.44355000"
                    },
                    {
                        "id": 111327,
                        "name": "Andrew County",
                        "latitude": "39.98349000",
                        "longitude": "-94.80205000"
                    },
                    {
                        "id": 111398,
                        "name": "Appleton City",
                        "latitude": "38.19058000",
                        "longitude": "-94.02939000"
                    },
                    {
                        "id": 111433,
                        "name": "Archie",
                        "latitude": "38.48168000",
                        "longitude": "-94.35439000"
                    },
                    {
                        "id": 111484,
                        "name": "Arnold",
                        "latitude": "38.43283000",
                        "longitude": "-90.37762000"
                    },
                    {
                        "id": 111511,
                        "name": "Ash Grove",
                        "latitude": "37.31533000",
                        "longitude": "-93.58520000"
                    },
                    {
                        "id": 111529,
                        "name": "Ashland",
                        "latitude": "38.77448000",
                        "longitude": "-92.25713000"
                    },
                    {
                        "id": 111569,
                        "name": "Atchison County",
                        "latitude": "40.43085000",
                        "longitude": "-95.42809000"
                    },
                    {
                        "id": 111637,
                        "name": "Audrain County",
                        "latitude": "39.21576000",
                        "longitude": "-91.84159000"
                    },
                    {
                        "id": 111657,
                        "name": "Aurora",
                        "latitude": "36.97089000",
                        "longitude": "-93.71798000"
                    },
                    {
                        "id": 111672,
                        "name": "Ava",
                        "latitude": "36.95200000",
                        "longitude": "-92.66045000"
                    },
                    {
                        "id": 111776,
                        "name": "Ballwin",
                        "latitude": "38.59505000",
                        "longitude": "-90.54623000"
                    },
                    {
                        "id": 111832,
                        "name": "Barnhart",
                        "latitude": "38.34422000",
                        "longitude": "-90.39345000"
                    },
                    {
                        "id": 111855,
                        "name": "Barry County",
                        "latitude": "36.70987000",
                        "longitude": "-93.82907000"
                    },
                    {
                        "id": 111867,
                        "name": "Barton County",
                        "latitude": "37.50230000",
                        "longitude": "-94.34711000"
                    },
                    {
                        "id": 111889,
                        "name": "Bates County",
                        "latitude": "38.25729000",
                        "longitude": "-94.34000000"
                    },
                    {
                        "id": 111909,
                        "name": "Battlefield",
                        "latitude": "37.11561000",
                        "longitude": "-93.37019000"
                    },
                    {
                        "id": 112049,
                        "name": "Bel-Nor",
                        "latitude": "38.70200000",
                        "longitude": "-90.31678000"
                    },
                    {
                        "id": 112050,
                        "name": "Bel-Ridge",
                        "latitude": "38.70950000",
                        "longitude": "-90.32539000"
                    },
                    {
                        "id": 112078,
                        "name": "Belle",
                        "latitude": "38.28588000",
                        "longitude": "-91.72044000"
                    },
                    {
                        "id": 112097,
                        "name": "Bellefontaine Neighbors",
                        "latitude": "38.74033000",
                        "longitude": "-90.22650000"
                    },
                    {
                        "id": 112147,
                        "name": "Belton",
                        "latitude": "38.81195000",
                        "longitude": "-94.53190000"
                    },
                    {
                        "id": 112195,
                        "name": "Benton",
                        "latitude": "37.09783000",
                        "longitude": "-89.56258000"
                    },
                    {
                        "id": 112200,
                        "name": "Benton County",
                        "latitude": "38.29485000",
                        "longitude": "-93.28795000"
                    },
                    {
                        "id": 112221,
                        "name": "Berkeley",
                        "latitude": "38.75450000",
                        "longitude": "-90.33123000"
                    },
                    {
                        "id": 112248,
                        "name": "Bernie",
                        "latitude": "36.66894000",
                        "longitude": "-89.96870000"
                    },
                    {
                        "id": 112274,
                        "name": "Bethany",
                        "latitude": "40.26833000",
                        "longitude": "-94.02829000"
                    },
                    {
                        "id": 112343,
                        "name": "Billings",
                        "latitude": "37.06755000",
                        "longitude": "-93.55214000"
                    },
                    {
                        "id": 112366,
                        "name": "Bismarck",
                        "latitude": "37.76922000",
                        "longitude": "-90.62485000"
                    },
                    {
                        "id": 112378,
                        "name": "Black Jack",
                        "latitude": "38.79338000",
                        "longitude": "-90.26733000"
                    },
                    {
                        "id": 112435,
                        "name": "Bloomfield",
                        "latitude": "36.88589000",
                        "longitude": "-89.92926000"
                    },
                    {
                        "id": 112477,
                        "name": "Blue Springs",
                        "latitude": "39.01695000",
                        "longitude": "-94.28161000"
                    },
                    {
                        "id": 112517,
                        "name": "Bolivar",
                        "latitude": "37.61448000",
                        "longitude": "-93.41047000"
                    },
                    {
                        "id": 112524,
                        "name": "Bollinger County",
                        "latitude": "37.32219000",
                        "longitude": "-90.02595000"
                    },
                    {
                        "id": 112539,
                        "name": "Bonne Terre",
                        "latitude": "37.92311000",
                        "longitude": "-90.55540000"
                    },
                    {
                        "id": 112556,
                        "name": "Boone County",
                        "latitude": "38.99062000",
                        "longitude": "-92.30968000"
                    },
                    {
                        "id": 112568,
                        "name": "Boonville",
                        "latitude": "38.97364000",
                        "longitude": "-92.74324000"
                    },
                    {
                        "id": 112611,
                        "name": "Bourbon",
                        "latitude": "38.15477000",
                        "longitude": "-91.24403000"
                    },
                    {
                        "id": 112630,
                        "name": "Bowling Green",
                        "latitude": "39.34199000",
                        "longitude": "-91.19514000"
                    },
                    {
                        "id": 112695,
                        "name": "Branson",
                        "latitude": "36.64367000",
                        "longitude": "-93.21851000"
                    },
                    {
                        "id": 112714,
                        "name": "Breckenridge Hills",
                        "latitude": "38.71450000",
                        "longitude": "-90.36734000"
                    },
                    {
                        "id": 112727,
                        "name": "Brentwood",
                        "latitude": "38.61755000",
                        "longitude": "-90.34928000"
                    },
                    {
                        "id": 112769,
                        "name": "Bridgeton",
                        "latitude": "38.76700000",
                        "longitude": "-90.41151000"
                    },
                    {
                        "id": 112853,
                        "name": "Brookfield",
                        "latitude": "39.78447000",
                        "longitude": "-93.07353000"
                    },
                    {
                        "id": 112973,
                        "name": "Buchanan County",
                        "latitude": "39.65986000",
                        "longitude": "-94.80616000"
                    },
                    {
                        "id": 112990,
                        "name": "Buckner",
                        "latitude": "39.13251000",
                        "longitude": "-94.19856000"
                    },
                    {
                        "id": 113007,
                        "name": "Buffalo",
                        "latitude": "37.64393000",
                        "longitude": "-93.09241000"
                    },
                    {
                        "id": 113108,
                        "name": "Butler",
                        "latitude": "38.25863000",
                        "longitude": "-94.33051000"
                    },
                    {
                        "id": 113117,
                        "name": "Butler County",
                        "latitude": "36.71642000",
                        "longitude": "-90.40656000"
                    },
                    {
                        "id": 113142,
                        "name": "Byrnes Mill",
                        "latitude": "38.43783000",
                        "longitude": "-90.58179000"
                    },
                    {
                        "id": 113153,
                        "name": "Cabool",
                        "latitude": "37.12394000",
                        "longitude": "-92.10127000"
                    },
                    {
                        "id": 113184,
                        "name": "Caldwell County",
                        "latitude": "39.65575000",
                        "longitude": "-93.98280000"
                    },
                    {
                        "id": 113215,
                        "name": "California",
                        "latitude": "38.62753000",
                        "longitude": "-92.56658000"
                    },
                    {
                        "id": 113225,
                        "name": "Callaway County",
                        "latitude": "38.83552000",
                        "longitude": "-91.92601000"
                    },
                    {
                        "id": 113238,
                        "name": "Calverton Park",
                        "latitude": "38.76477000",
                        "longitude": "-90.31373000"
                    },
                    {
                        "id": 113269,
                        "name": "Camden County",
                        "latitude": "38.02704000",
                        "longitude": "-92.76605000"
                    },
                    {
                        "id": 113272,
                        "name": "Camdenton",
                        "latitude": "38.00809000",
                        "longitude": "-92.74463000"
                    },
                    {
                        "id": 113273,
                        "name": "Cameron",
                        "latitude": "39.74028000",
                        "longitude": "-94.24106000"
                    },
                    {
                        "id": 113297,
                        "name": "Campbell",
                        "latitude": "36.49339000",
                        "longitude": "-90.07509000"
                    },
                    {
                        "id": 113348,
                        "name": "Canton",
                        "latitude": "40.12504000",
                        "longitude": "-91.62516000"
                    },
                    {
                        "id": 113367,
                        "name": "Cape Girardeau",
                        "latitude": "37.30588000",
                        "longitude": "-89.51815000"
                    },
                    {
                        "id": 113368,
                        "name": "Cape Girardeau County",
                        "latitude": "37.38404000",
                        "longitude": "-89.68445000"
                    },
                    {
                        "id": 113396,
                        "name": "Carl Junction",
                        "latitude": "37.17672000",
                        "longitude": "-94.56551000"
                    },
                    {
                        "id": 113454,
                        "name": "Carroll County",
                        "latitude": "39.42698000",
                        "longitude": "-93.50518000"
                    },
                    {
                        "id": 113467,
                        "name": "Carrollton",
                        "latitude": "39.35835000",
                        "longitude": "-93.49577000"
                    },
                    {
                        "id": 113481,
                        "name": "Carter County",
                        "latitude": "36.94127000",
                        "longitude": "-90.96231000"
                    },
                    {
                        "id": 113490,
                        "name": "Carterville",
                        "latitude": "37.14923000",
                        "longitude": "-94.44300000"
                    },
                    {
                        "id": 113491,
                        "name": "Carthage",
                        "latitude": "37.17645000",
                        "longitude": "-94.31022000"
                    },
                    {
                        "id": 113499,
                        "name": "Caruthersville",
                        "latitude": "36.19312000",
                        "longitude": "-89.65564000"
                    },
                    {
                        "id": 113527,
                        "name": "Cass County",
                        "latitude": "38.64700000",
                        "longitude": "-94.35482000"
                    },
                    {
                        "id": 113539,
                        "name": "Cassville",
                        "latitude": "36.67701000",
                        "longitude": "-93.86881000"
                    },
                    {
                        "id": 113548,
                        "name": "Castle Point",
                        "latitude": "38.75811000",
                        "longitude": "-90.24817000"
                    },
                    {
                        "id": 113604,
                        "name": "Cedar County",
                        "latitude": "37.72385000",
                        "longitude": "-93.85661000"
                    },
                    {
                        "id": 113613,
                        "name": "Cedar Hill",
                        "latitude": "38.35339000",
                        "longitude": "-90.64124000"
                    },
                    {
                        "id": 113654,
                        "name": "Centerville",
                        "latitude": "37.43505000",
                        "longitude": "-90.95846000"
                    },
                    {
                        "id": 113686,
                        "name": "Centralia",
                        "latitude": "39.21032000",
                        "longitude": "-92.13795000"
                    },
                    {
                        "id": 113709,
                        "name": "Chaffee",
                        "latitude": "37.18005000",
                        "longitude": "-89.65509000"
                    },
                    {
                        "id": 113750,
                        "name": "Chariton County",
                        "latitude": "39.51508000",
                        "longitude": "-92.96262000"
                    },
                    {
                        "id": 113751,
                        "name": "Charlack",
                        "latitude": "38.70255000",
                        "longitude": "-90.34345000"
                    },
                    {
                        "id": 113763,
                        "name": "Charleston",
                        "latitude": "36.92089000",
                        "longitude": "-89.35063000"
                    },
                    {
                        "id": 113901,
                        "name": "Chesterfield",
                        "latitude": "38.66311000",
                        "longitude": "-90.57707000"
                    },
                    {
                        "id": 113953,
                        "name": "Chillicothe",
                        "latitude": "39.79529000",
                        "longitude": "-93.55244000"
                    },
                    {
                        "id": 113997,
                        "name": "Christian County",
                        "latitude": "36.96957000",
                        "longitude": "-93.18885000"
                    },
                    {
                        "id": 114081,
                        "name": "City of Saint Louis",
                        "latitude": "38.62727000",
                        "longitude": "-90.19789000"
                    },
                    {
                        "id": 114126,
                        "name": "Clark County",
                        "latitude": "40.41036000",
                        "longitude": "-91.73840000"
                    },
                    {
                        "id": 114147,
                        "name": "Clarkson Valley",
                        "latitude": "38.61839000",
                        "longitude": "-90.58929000"
                    },
                    {
                        "id": 114158,
                        "name": "Clarkton",
                        "latitude": "36.45173000",
                        "longitude": "-89.96704000"
                    },
                    {
                        "id": 114181,
                        "name": "Clay County",
                        "latitude": "39.31052000",
                        "longitude": "-94.42087000"
                    },
                    {
                        "id": 114191,
                        "name": "Claycomo",
                        "latitude": "39.20250000",
                        "longitude": "-94.49245000"
                    },
                    {
                        "id": 114199,
                        "name": "Clayton",
                        "latitude": "38.64255000",
                        "longitude": "-90.32373000"
                    },
                    {
                        "id": 114251,
                        "name": "Clever",
                        "latitude": "37.03033000",
                        "longitude": "-93.47297000"
                    },
                    {
                        "id": 114271,
                        "name": "Clinton",
                        "latitude": "38.36863000",
                        "longitude": "-93.77827000"
                    },
                    {
                        "id": 114291,
                        "name": "Clinton County",
                        "latitude": "39.60178000",
                        "longitude": "-94.40459000"
                    },
                    {
                        "id": 114395,
                        "name": "Cole Camp",
                        "latitude": "38.46002000",
                        "longitude": "-93.20270000"
                    },
                    {
                        "id": 114396,
                        "name": "Cole County",
                        "latitude": "38.50541000",
                        "longitude": "-92.28160000"
                    },
                    {
                        "id": 114468,
                        "name": "Columbia",
                        "latitude": "38.95171000",
                        "longitude": "-92.33407000"
                    },
                    {
                        "id": 114535,
                        "name": "Concord",
                        "latitude": "38.52450000",
                        "longitude": "-90.35734000"
                    },
                    {
                        "id": 114545,
                        "name": "Concordia",
                        "latitude": "38.98335000",
                        "longitude": "-93.56855000"
                    },
                    {
                        "id": 114597,
                        "name": "Cool Valley",
                        "latitude": "38.72783000",
                        "longitude": "-90.31011000"
                    },
                    {
                        "id": 114603,
                        "name": "Cooper County",
                        "latitude": "38.84354000",
                        "longitude": "-92.81012000"
                    },
                    {
                        "id": 114696,
                        "name": "Cottleville",
                        "latitude": "38.74616000",
                        "longitude": "-90.65401000"
                    },
                    {
                        "id": 114717,
                        "name": "Country Club Hills",
                        "latitude": "38.72088000",
                        "longitude": "-90.27484000"
                    },
                    {
                        "id": 114719,
                        "name": "Country Club Village",
                        "latitude": "39.83222000",
                        "longitude": "-94.82163000"
                    },
                    {
                        "id": 114768,
                        "name": "Crane",
                        "latitude": "36.90534000",
                        "longitude": "-93.57158000"
                    },
                    {
                        "id": 114779,
                        "name": "Crawford County",
                        "latitude": "37.97638000",
                        "longitude": "-91.30396000"
                    },
                    {
                        "id": 114810,
                        "name": "Crestwood",
                        "latitude": "38.55700000",
                        "longitude": "-90.38178000"
                    },
                    {
                        "id": 114816,
                        "name": "Creve Coeur",
                        "latitude": "38.66089000",
                        "longitude": "-90.42262000"
                    },
                    {
                        "id": 114827,
                        "name": "Crocker",
                        "latitude": "37.94893000",
                        "longitude": "-92.26378000"
                    },
                    {
                        "id": 114875,
                        "name": "Crystal City",
                        "latitude": "38.22117000",
                        "longitude": "-90.37901000"
                    },
                    {
                        "id": 114885,
                        "name": "Cuba",
                        "latitude": "38.06282000",
                        "longitude": "-91.40348000"
                    },
                    {
                        "id": 114967,
                        "name": "Dade County",
                        "latitude": "37.43204000",
                        "longitude": "-93.85029000"
                    },
                    {
                        "id": 114996,
                        "name": "Dallas County",
                        "latitude": "37.68041000",
                        "longitude": "-93.02366000"
                    },
                    {
                        "id": 115043,
                        "name": "Dardenne Prairie",
                        "latitude": "38.76950000",
                        "longitude": "-90.72902000"
                    },
                    {
                        "id": 115071,
                        "name": "Daviess County",
                        "latitude": "39.96075000",
                        "longitude": "-93.98547000"
                    },
                    {
                        "id": 115117,
                        "name": "De Soto",
                        "latitude": "38.13950000",
                        "longitude": "-90.55513000"
                    },
                    {
                        "id": 115130,
                        "name": "DeKalb County",
                        "latitude": "39.89318000",
                        "longitude": "-94.40471000"
                    },
                    {
                        "id": 115215,
                        "name": "Dellwood",
                        "latitude": "38.74950000",
                        "longitude": "-90.28567000"
                    },
                    {
                        "id": 115244,
                        "name": "Dent County",
                        "latitude": "37.60663000",
                        "longitude": "-91.50788000"
                    },
                    {
                        "id": 115274,
                        "name": "Des Peres",
                        "latitude": "38.60089000",
                        "longitude": "-90.43290000"
                    },
                    {
                        "id": 115286,
                        "name": "Desloge",
                        "latitude": "37.87088000",
                        "longitude": "-90.52735000"
                    },
                    {
                        "id": 115307,
                        "name": "Dexter",
                        "latitude": "36.79589000",
                        "longitude": "-89.95787000"
                    },
                    {
                        "id": 115365,
                        "name": "Dixon",
                        "latitude": "37.99171000",
                        "longitude": "-92.09378000"
                    },
                    {
                        "id": 115397,
                        "name": "Doniphan",
                        "latitude": "36.62089000",
                        "longitude": "-90.82346000"
                    },
                    {
                        "id": 115428,
                        "name": "Douglas County",
                        "latitude": "36.93260000",
                        "longitude": "-92.49881000"
                    },
                    {
                        "id": 115507,
                        "name": "Duenweg",
                        "latitude": "37.08367000",
                        "longitude": "-94.41356000"
                    },
                    {
                        "id": 115541,
                        "name": "Dunklin County",
                        "latitude": "36.10597000",
                        "longitude": "-90.16576000"
                    },
                    {
                        "id": 115560,
                        "name": "Duquesne",
                        "latitude": "37.07673000",
                        "longitude": "-94.45939000"
                    },
                    {
                        "id": 115694,
                        "name": "East Independence",
                        "latitude": "39.09556000",
                        "longitude": "-94.35523000"
                    },
                    {
                        "id": 115740,
                        "name": "East Prairie",
                        "latitude": "36.77978000",
                        "longitude": "-89.38563000"
                    },
                    {
                        "id": 115866,
                        "name": "Edina",
                        "latitude": "40.16754000",
                        "longitude": "-92.17268000"
                    },
                    {
                        "id": 115923,
                        "name": "El Dorado Springs",
                        "latitude": "37.87698000",
                        "longitude": "-94.02133000"
                    },
                    {
                        "id": 115950,
                        "name": "Eldon",
                        "latitude": "38.34836000",
                        "longitude": "-92.58158000"
                    },
                    {
                        "id": 116034,
                        "name": "Ellisville",
                        "latitude": "38.59255000",
                        "longitude": "-90.58707000"
                    },
                    {
                        "id": 116069,
                        "name": "Elsberry",
                        "latitude": "39.16672000",
                        "longitude": "-90.78096000"
                    },
                    {
                        "id": 116076,
                        "name": "Elvins",
                        "latitude": "37.83672000",
                        "longitude": "-90.53290000"
                    },
                    {
                        "id": 116100,
                        "name": "Eminence",
                        "latitude": "37.15060000",
                        "longitude": "-91.35764000"
                    },
                    {
                        "id": 116209,
                        "name": "Esther",
                        "latitude": "37.85033000",
                        "longitude": "-90.49874000"
                    },
                    {
                        "id": 116233,
                        "name": "Eureka",
                        "latitude": "38.50255000",
                        "longitude": "-90.62790000"
                    },
                    {
                        "id": 116270,
                        "name": "Excelsior Springs",
                        "latitude": "39.33917000",
                        "longitude": "-94.22606000"
                    },
                    {
                        "id": 116281,
                        "name": "Fair Grove",
                        "latitude": "37.38393000",
                        "longitude": "-93.15130000"
                    },
                    {
                        "id": 116413,
                        "name": "Farmington",
                        "latitude": "37.78088000",
                        "longitude": "-90.42179000"
                    },
                    {
                        "id": 116439,
                        "name": "Fayette",
                        "latitude": "39.14587000",
                        "longitude": "-92.68379000"
                    },
                    {
                        "id": 116474,
                        "name": "Fenton",
                        "latitude": "38.51311000",
                        "longitude": "-90.43595000"
                    },
                    {
                        "id": 116480,
                        "name": "Ferguson",
                        "latitude": "38.74422000",
                        "longitude": "-90.30539000"
                    },
                    {
                        "id": 116502,
                        "name": "Festus",
                        "latitude": "38.22061000",
                        "longitude": "-90.39595000"
                    },
                    {
                        "id": 116550,
                        "name": "Flat River",
                        "latitude": "37.85005000",
                        "longitude": "-90.51679000"
                    },
                    {
                        "id": 116597,
                        "name": "Florissant",
                        "latitude": "38.78922000",
                        "longitude": "-90.32261000"
                    },
                    {
                        "id": 116684,
                        "name": "Forsyth",
                        "latitude": "36.68506000",
                        "longitude": "-93.11990000"
                    },
                    {
                        "id": 116725,
                        "name": "Fort Leonard Wood",
                        "latitude": "37.70573000",
                        "longitude": "-92.15717000"
                    },
                    {
                        "id": 116793,
                        "name": "Four Seasons",
                        "latitude": "38.19809000",
                        "longitude": "-92.71102000"
                    },
                    {
                        "id": 116851,
                        "name": "Franklin County",
                        "latitude": "38.41114000",
                        "longitude": "-91.07499000"
                    },
                    {
                        "id": 116894,
                        "name": "Fredericktown",
                        "latitude": "37.55978000",
                        "longitude": "-90.29401000"
                    },
                    {
                        "id": 116962,
                        "name": "Frontenac",
                        "latitude": "38.63561000",
                        "longitude": "-90.41512000"
                    },
                    {
                        "id": 116986,
                        "name": "Fulton",
                        "latitude": "38.84671000",
                        "longitude": "-91.94796000"
                    },
                    {
                        "id": 117016,
                        "name": "Gainesville",
                        "latitude": "36.60312000",
                        "longitude": "-92.42822000"
                    },
                    {
                        "id": 117023,
                        "name": "Galena",
                        "latitude": "36.80534000",
                        "longitude": "-93.46658000"
                    },
                    {
                        "id": 117032,
                        "name": "Gallatin",
                        "latitude": "39.91445000",
                        "longitude": "-93.96217000"
                    },
                    {
                        "id": 117055,
                        "name": "Garden City",
                        "latitude": "38.56112000",
                        "longitude": "-94.19133000"
                    },
                    {
                        "id": 117110,
                        "name": "Gasconade County",
                        "latitude": "38.44087000",
                        "longitude": "-91.50793000"
                    },
                    {
                        "id": 117151,
                        "name": "Gentry County",
                        "latitude": "40.21211000",
                        "longitude": "-94.40992000"
                    },
                    {
                        "id": 117168,
                        "name": "Gerald",
                        "latitude": "38.39977000",
                        "longitude": "-91.33071000"
                    },
                    {
                        "id": 117196,
                        "name": "Gideon",
                        "latitude": "36.45201000",
                        "longitude": "-89.91926000"
                    },
                    {
                        "id": 117236,
                        "name": "Gladstone",
                        "latitude": "39.20389000",
                        "longitude": "-94.55468000"
                    },
                    {
                        "id": 117247,
                        "name": "Glasgow",
                        "latitude": "39.22725000",
                        "longitude": "-92.84658000"
                    },
                    {
                        "id": 117250,
                        "name": "Glasgow Village",
                        "latitude": "38.75366000",
                        "longitude": "-90.19844000"
                    },
                    {
                        "id": 117280,
                        "name": "Glendale",
                        "latitude": "38.59589000",
                        "longitude": "-90.37706000"
                    },
                    {
                        "id": 117387,
                        "name": "Goodman",
                        "latitude": "36.74174000",
                        "longitude": "-94.39911000"
                    },
                    {
                        "id": 117423,
                        "name": "Gower",
                        "latitude": "39.61083000",
                        "longitude": "-94.59940000"
                    },
                    {
                        "id": 117440,
                        "name": "Grain Valley",
                        "latitude": "39.01501000",
                        "longitude": "-94.19856000"
                    },
                    {
                        "id": 117446,
                        "name": "Granby",
                        "latitude": "36.91923000",
                        "longitude": "-94.25522000"
                    },
                    {
                        "id": 117479,
                        "name": "Grandview",
                        "latitude": "38.88584000",
                        "longitude": "-94.53301000"
                    },
                    {
                        "id": 117506,
                        "name": "Grant City",
                        "latitude": "40.48749000",
                        "longitude": "-94.41107000"
                    },
                    {
                        "id": 117555,
                        "name": "Gray Summit",
                        "latitude": "38.48978000",
                        "longitude": "-90.81680000"
                    },
                    {
                        "id": 117605,
                        "name": "Green Park",
                        "latitude": "38.52366000",
                        "longitude": "-90.33845000"
                    },
                    {
                        "id": 117636,
                        "name": "Greene County",
                        "latitude": "37.25805000",
                        "longitude": "-93.34199000"
                    },
                    {
                        "id": 117647,
                        "name": "Greenfield",
                        "latitude": "37.41532000",
                        "longitude": "-93.84104000"
                    },
                    {
                        "id": 117685,
                        "name": "Greenville",
                        "latitude": "37.12727000",
                        "longitude": "-90.45011000"
                    },
                    {
                        "id": 117703,
                        "name": "Greenwood",
                        "latitude": "38.85168000",
                        "longitude": "-94.34384000"
                    },
                    {
                        "id": 117773,
                        "name": "Grundy County",
                        "latitude": "40.11393000",
                        "longitude": "-93.56534000"
                    },
                    {
                        "id": 117875,
                        "name": "Hallsville",
                        "latitude": "39.11699000",
                        "longitude": "-92.22074000"
                    },
                    {
                        "id": 117889,
                        "name": "Hamilton",
                        "latitude": "39.74362000",
                        "longitude": "-93.99827000"
                    },
                    {
                        "id": 117961,
                        "name": "Hanley Hills",
                        "latitude": "38.68588000",
                        "longitude": "-90.32373000"
                    },
                    {
                        "id": 117965,
                        "name": "Hannibal",
                        "latitude": "39.70838000",
                        "longitude": "-91.35848000"
                    },
                    {
                        "id": 118068,
                        "name": "Harrison County",
                        "latitude": "40.35467000",
                        "longitude": "-93.99206000"
                    },
                    {
                        "id": 118071,
                        "name": "Harrisonville",
                        "latitude": "38.65334000",
                        "longitude": "-94.34884000"
                    },
                    {
                        "id": 118106,
                        "name": "Hartville",
                        "latitude": "37.25088000",
                        "longitude": "-92.51044000"
                    },
                    {
                        "id": 118194,
                        "name": "Hayti",
                        "latitude": "36.23368000",
                        "longitude": "-89.74953000"
                    },
                    {
                        "id": 118207,
                        "name": "Hazelwood",
                        "latitude": "38.77144000",
                        "longitude": "-90.37095000"
                    },
                    {
                        "id": 118301,
                        "name": "Henry County",
                        "latitude": "38.38516000",
                        "longitude": "-93.79275000"
                    },
                    {
                        "id": 118313,
                        "name": "Herculaneum",
                        "latitude": "38.26839000",
                        "longitude": "-90.38012000"
                    },
                    {
                        "id": 118325,
                        "name": "Hermann",
                        "latitude": "38.70421000",
                        "longitude": "-91.43738000"
                    },
                    {
                        "id": 118328,
                        "name": "Hermitage",
                        "latitude": "37.94142000",
                        "longitude": "-93.31631000"
                    },
                    {
                        "id": 118366,
                        "name": "Hickory County",
                        "latitude": "37.94079000",
                        "longitude": "-93.32072000"
                    },
                    {
                        "id": 118384,
                        "name": "Higginsville",
                        "latitude": "39.07251000",
                        "longitude": "-93.71716000"
                    },
                    {
                        "id": 118388,
                        "name": "High Ridge",
                        "latitude": "38.45894000",
                        "longitude": "-90.53651000"
                    },
                    {
                        "id": 118447,
                        "name": "Hillsboro",
                        "latitude": "38.23228000",
                        "longitude": "-90.56290000"
                    },
                    {
                        "id": 118459,
                        "name": "Hillsdale",
                        "latitude": "38.68338000",
                        "longitude": "-90.28400000"
                    },
                    {
                        "id": 118522,
                        "name": "Holden",
                        "latitude": "38.71418000",
                        "longitude": "-93.99133000"
                    },
                    {
                        "id": 118551,
                        "name": "Hollister",
                        "latitude": "36.62117000",
                        "longitude": "-93.21546000"
                    },
                    {
                        "id": 118576,
                        "name": "Holt County",
                        "latitude": "40.09443000",
                        "longitude": "-95.21551000"
                    },
                    {
                        "id": 118579,
                        "name": "Holts Summit",
                        "latitude": "38.64032000",
                        "longitude": "-92.12241000"
                    },
                    {
                        "id": 118697,
                        "name": "Houston",
                        "latitude": "37.32616000",
                        "longitude": "-91.95599000"
                    },
                    {
                        "id": 118714,
                        "name": "Howard County",
                        "latitude": "39.14250000",
                        "longitude": "-92.69627000"
                    },
                    {
                        "id": 118723,
                        "name": "Howell County",
                        "latitude": "36.77401000",
                        "longitude": "-91.88654000"
                    },
                    {
                        "id": 118773,
                        "name": "Humansville",
                        "latitude": "37.79448000",
                        "longitude": "-93.57798000"
                    },
                    {
                        "id": 118816,
                        "name": "Huntsville",
                        "latitude": "39.44059000",
                        "longitude": "-92.54518000"
                    },
                    {
                        "id": 118881,
                        "name": "Imperial",
                        "latitude": "38.36978000",
                        "longitude": "-90.37845000"
                    },
                    {
                        "id": 118892,
                        "name": "Independence",
                        "latitude": "39.09112000",
                        "longitude": "-94.41551000"
                    },
                    {
                        "id": 118988,
                        "name": "Iron County",
                        "latitude": "37.50426000",
                        "longitude": "-90.69003000"
                    },
                    {
                        "id": 118997,
                        "name": "Ironton",
                        "latitude": "37.59727000",
                        "longitude": "-90.62734000"
                    },
                    {
                        "id": 119064,
                        "name": "Jackson",
                        "latitude": "37.38227000",
                        "longitude": "-89.66621000"
                    },
                    {
                        "id": 119083,
                        "name": "Jackson County",
                        "latitude": "39.00850000",
                        "longitude": "-94.34609000"
                    },
                    {
                        "id": 119147,
                        "name": "Jasper County",
                        "latitude": "37.20355000",
                        "longitude": "-94.34061000"
                    },
                    {
                        "id": 119173,
                        "name": "Jefferson City",
                        "latitude": "38.57670000",
                        "longitude": "-92.17352000"
                    },
                    {
                        "id": 119183,
                        "name": "Jefferson County",
                        "latitude": "38.26107000",
                        "longitude": "-90.53769000"
                    },
                    {
                        "id": 119219,
                        "name": "Jennings",
                        "latitude": "38.71922000",
                        "longitude": "-90.26039000"
                    },
                    {
                        "id": 119266,
                        "name": "Johnson County",
                        "latitude": "38.74409000",
                        "longitude": "-93.80637000"
                    },
                    {
                        "id": 119313,
                        "name": "Joplin",
                        "latitude": "37.08423000",
                        "longitude": "-94.51328000"
                    },
                    {
                        "id": 119353,
                        "name": "Kahoka",
                        "latitude": "40.42032000",
                        "longitude": "-91.71961000"
                    },
                    {
                        "id": 119384,
                        "name": "Kansas City",
                        "latitude": "39.09973000",
                        "longitude": "-94.57857000"
                    },
                    {
                        "id": 119407,
                        "name": "Kearney",
                        "latitude": "39.36778000",
                        "longitude": "-94.36217000"
                    },
                    {
                        "id": 119473,
                        "name": "Kennett",
                        "latitude": "36.23618000",
                        "longitude": "-90.05565000"
                    },
                    {
                        "id": 119549,
                        "name": "Keytesville",
                        "latitude": "39.43447000",
                        "longitude": "-92.93825000"
                    },
                    {
                        "id": 119568,
                        "name": "Kimberling City",
                        "latitude": "36.63340000",
                        "longitude": "-93.41685000"
                    },
                    {
                        "id": 119578,
                        "name": "King City",
                        "latitude": "40.05138000",
                        "longitude": "-94.52412000"
                    },
                    {
                        "id": 119620,
                        "name": "Kingston",
                        "latitude": "39.64417000",
                        "longitude": "-94.03855000"
                    },
                    {
                        "id": 119653,
                        "name": "Kirksville",
                        "latitude": "40.19475000",
                        "longitude": "-92.58325000"
                    },
                    {
                        "id": 119654,
                        "name": "Kirkwood",
                        "latitude": "38.58339000",
                        "longitude": "-90.40678000"
                    },
                    {
                        "id": 119657,
                        "name": "Kissee Mills",
                        "latitude": "36.68367000",
                        "longitude": "-93.04990000"
                    },
                    {
                        "id": 119678,
                        "name": "Knob Noster",
                        "latitude": "38.76668000",
                        "longitude": "-93.55855000"
                    },
                    {
                        "id": 119691,
                        "name": "Knox County",
                        "latitude": "40.12825000",
                        "longitude": "-92.14807000"
                    },
                    {
                        "id": 119768,
                        "name": "La Monte",
                        "latitude": "38.77418000",
                        "longitude": "-93.42521000"
                    },
                    {
                        "id": 119774,
                        "name": "La Plata",
                        "latitude": "40.02337000",
                        "longitude": "-92.49158000"
                    },
                    {
                        "id": 119797,
                        "name": "LaBarque Creek",
                        "latitude": "38.41701000",
                        "longitude": "-90.67989000"
                    },
                    {
                        "id": 119816,
                        "name": "Laclede County",
                        "latitude": "37.65832000",
                        "longitude": "-92.59035000"
                    },
                    {
                        "id": 119828,
                        "name": "Ladue",
                        "latitude": "38.64977000",
                        "longitude": "-90.38067000"
                    },
                    {
                        "id": 119840,
                        "name": "Lafayette County",
                        "latitude": "39.06559000",
                        "longitude": "-93.78554000"
                    },
                    {
                        "id": 119932,
                        "name": "Lake Lotawana",
                        "latitude": "38.92306000",
                        "longitude": "-94.24411000"
                    },
                    {
                        "id": 119956,
                        "name": "Lake Ozark",
                        "latitude": "38.19864000",
                        "longitude": "-92.63880000"
                    },
                    {
                        "id": 119972,
                        "name": "Lake Saint Louis",
                        "latitude": "38.79755000",
                        "longitude": "-90.78568000"
                    },
                    {
                        "id": 119994,
                        "name": "Lake Winnebago",
                        "latitude": "38.83140000",
                        "longitude": "-94.35856000"
                    },
                    {
                        "id": 120027,
                        "name": "Lakeshire",
                        "latitude": "38.53866000",
                        "longitude": "-90.33512000"
                    },
                    {
                        "id": 120059,
                        "name": "Lamar",
                        "latitude": "37.49505000",
                        "longitude": "-94.27661000"
                    },
                    {
                        "id": 120085,
                        "name": "Lancaster",
                        "latitude": "40.52086000",
                        "longitude": "-92.52797000"
                    },
                    {
                        "id": 120169,
                        "name": "Lathrop",
                        "latitude": "39.54834000",
                        "longitude": "-94.32995000"
                    },
                    {
                        "id": 120234,
                        "name": "Lawrence County",
                        "latitude": "37.10635000",
                        "longitude": "-93.83294000"
                    },
                    {
                        "id": 120247,
                        "name": "Lawson",
                        "latitude": "39.43834000",
                        "longitude": "-94.20411000"
                    },
                    {
                        "id": 120273,
                        "name": "Leadwood",
                        "latitude": "37.86727000",
                        "longitude": "-90.59318000"
                    },
                    {
                        "id": 120286,
                        "name": "Lebanon",
                        "latitude": "37.68060000",
                        "longitude": "-92.66379000"
                    },
                    {
                        "id": 120318,
                        "name": "Lee's Summit",
                        "latitude": "38.91084000",
                        "longitude": "-94.38217000"
                    },
                    {
                        "id": 120355,
                        "name": "Lemay",
                        "latitude": "38.53339000",
                        "longitude": "-90.27928000"
                    },
                    {
                        "id": 120414,
                        "name": "Lewis County",
                        "latitude": "40.09690000",
                        "longitude": "-91.72214000"
                    },
                    {
                        "id": 120440,
                        "name": "Lexington",
                        "latitude": "39.18473000",
                        "longitude": "-93.87994000"
                    },
                    {
                        "id": 120461,
                        "name": "Liberty",
                        "latitude": "39.24611000",
                        "longitude": "-94.41912000"
                    },
                    {
                        "id": 120477,
                        "name": "Licking",
                        "latitude": "37.49949000",
                        "longitude": "-91.85710000"
                    },
                    {
                        "id": 120484,
                        "name": "Lilbourn",
                        "latitude": "36.59228000",
                        "longitude": "-89.61536000"
                    },
                    {
                        "id": 120502,
                        "name": "Lincoln",
                        "latitude": "38.39086000",
                        "longitude": "-93.33465000"
                    },
                    {
                        "id": 120520,
                        "name": "Lincoln County",
                        "latitude": "39.05802000",
                        "longitude": "-90.96005000"
                    },
                    {
                        "id": 120580,
                        "name": "Linn",
                        "latitude": "38.48587000",
                        "longitude": "-91.85045000"
                    },
                    {
                        "id": 120582,
                        "name": "Linn County",
                        "latitude": "39.87021000",
                        "longitude": "-93.10718000"
                    },
                    {
                        "id": 120585,
                        "name": "Linneus",
                        "latitude": "39.87863000",
                        "longitude": "-93.18882000"
                    },
                    {
                        "id": 120655,
                        "name": "Livingston County",
                        "latitude": "39.78211000",
                        "longitude": "-93.54828000"
                    },
                    {
                        "id": 120727,
                        "name": "Lone Jack",
                        "latitude": "38.87084000",
                        "longitude": "-94.17383000"
                    },
                    {
                        "id": 120810,
                        "name": "Louisiana",
                        "latitude": "39.44894000",
                        "longitude": "-91.05153000"
                    },
                    {
                        "id": 120965,
                        "name": "Macon",
                        "latitude": "39.74226000",
                        "longitude": "-92.47269000"
                    },
                    {
                        "id": 120970,
                        "name": "Macon County",
                        "latitude": "39.83080000",
                        "longitude": "-92.56461000"
                    },
                    {
                        "id": 121008,
                        "name": "Madison County",
                        "latitude": "37.47810000",
                        "longitude": "-90.34503000"
                    },
                    {
                        "id": 121059,
                        "name": "Malden",
                        "latitude": "36.55700000",
                        "longitude": "-89.96648000"
                    },
                    {
                        "id": 121092,
                        "name": "Manchester",
                        "latitude": "38.59700000",
                        "longitude": "-90.50929000"
                    },
                    {
                        "id": 121143,
                        "name": "Mansfield",
                        "latitude": "37.10672000",
                        "longitude": "-92.58072000"
                    },
                    {
                        "id": 121177,
                        "name": "Maplewood",
                        "latitude": "38.61255000",
                        "longitude": "-90.32456000"
                    },
                    {
                        "id": 121188,
                        "name": "Marble Hill",
                        "latitude": "37.30589000",
                        "longitude": "-89.97038000"
                    },
                    {
                        "id": 121193,
                        "name": "Marceline",
                        "latitude": "39.71197000",
                        "longitude": "-92.94825000"
                    },
                    {
                        "id": 121215,
                        "name": "Maries County",
                        "latitude": "38.16163000",
                        "longitude": "-91.92489000"
                    },
                    {
                        "id": 121255,
                        "name": "Marion County",
                        "latitude": "39.80596000",
                        "longitude": "-91.62235000"
                    },
                    {
                        "id": 121263,
                        "name": "Marionville",
                        "latitude": "37.00311000",
                        "longitude": "-93.63742000"
                    },
                    {
                        "id": 121279,
                        "name": "Marlborough",
                        "latitude": "38.57033000",
                        "longitude": "-90.33706000"
                    },
                    {
                        "id": 121303,
                        "name": "Marshall",
                        "latitude": "39.12308000",
                        "longitude": "-93.19687000"
                    },
                    {
                        "id": 121325,
                        "name": "Marshfield",
                        "latitude": "37.33866000",
                        "longitude": "-92.90712000"
                    },
                    {
                        "id": 121334,
                        "name": "Marthasville",
                        "latitude": "38.62838000",
                        "longitude": "-91.05764000"
                    },
                    {
                        "id": 121356,
                        "name": "Maryland Heights",
                        "latitude": "38.71311000",
                        "longitude": "-90.42984000"
                    },
                    {
                        "id": 121365,
                        "name": "Maryville",
                        "latitude": "40.34610000",
                        "longitude": "-94.87247000"
                    },
                    {
                        "id": 121449,
                        "name": "Maysville",
                        "latitude": "39.88917000",
                        "longitude": "-94.36190000"
                    },
                    {
                        "id": 121492,
                        "name": "McDonald County",
                        "latitude": "36.62867000",
                        "longitude": "-94.34836000"
                    },
                    {
                        "id": 121616,
                        "name": "Mehlville",
                        "latitude": "38.50839000",
                        "longitude": "-90.32289000"
                    },
                    {
                        "id": 121641,
                        "name": "Memphis",
                        "latitude": "40.45781000",
                        "longitude": "-92.17129000"
                    },
                    {
                        "id": 121678,
                        "name": "Mercer County",
                        "latitude": "40.42233000",
                        "longitude": "-93.56856000"
                    },
                    {
                        "id": 121703,
                        "name": "Merriam Woods",
                        "latitude": "36.71395000",
                        "longitude": "-93.16185000"
                    },
                    {
                        "id": 121741,
                        "name": "Mexico",
                        "latitude": "39.16976000",
                        "longitude": "-91.88295000"
                    },
                    {
                        "id": 121839,
                        "name": "Milan",
                        "latitude": "40.20224000",
                        "longitude": "-93.12521000"
                    },
                    {
                        "id": 121882,
                        "name": "Miller County",
                        "latitude": "38.21453000",
                        "longitude": "-92.42841000"
                    },
                    {
                        "id": 121990,
                        "name": "Mississippi County",
                        "latitude": "36.82810000",
                        "longitude": "-89.29118000"
                    },
                    {
                        "id": 122009,
                        "name": "Moberly",
                        "latitude": "39.41837000",
                        "longitude": "-92.43824000"
                    },
                    {
                        "id": 122028,
                        "name": "Moline Acres",
                        "latitude": "38.74699000",
                        "longitude": "-90.24011000"
                    },
                    {
                        "id": 122039,
                        "name": "Monett",
                        "latitude": "36.92895000",
                        "longitude": "-93.92771000"
                    },
                    {
                        "id": 122041,
                        "name": "Moniteau County",
                        "latitude": "38.63275000",
                        "longitude": "-92.58305000"
                    },
                    {
                        "id": 122066,
                        "name": "Monroe City",
                        "latitude": "39.65365000",
                        "longitude": "-91.73461000"
                    },
                    {
                        "id": 122074,
                        "name": "Monroe County",
                        "latitude": "39.49546000",
                        "longitude": "-92.00074000"
                    },
                    {
                        "id": 122138,
                        "name": "Montgomery City",
                        "latitude": "38.97754000",
                        "longitude": "-91.50488000"
                    },
                    {
                        "id": 122146,
                        "name": "Montgomery County",
                        "latitude": "38.94149000",
                        "longitude": "-91.47021000"
                    },
                    {
                        "id": 122168,
                        "name": "Monticello",
                        "latitude": "40.11838000",
                        "longitude": "-91.71211000"
                    },
                    {
                        "id": 122241,
                        "name": "Morgan County",
                        "latitude": "38.42374000",
                        "longitude": "-92.88598000"
                    },
                    {
                        "id": 122301,
                        "name": "Moscow Mills",
                        "latitude": "38.94783000",
                        "longitude": "-90.91819000"
                    },
                    {
                        "id": 122322,
                        "name": "Mound City",
                        "latitude": "40.13111000",
                        "longitude": "-95.23164000"
                    },
                    {
                        "id": 122398,
                        "name": "Mount Vernon",
                        "latitude": "37.10367000",
                        "longitude": "-93.81854000"
                    },
                    {
                        "id": 122414,
                        "name": "Mountain Grove",
                        "latitude": "37.13061000",
                        "longitude": "-92.26349000"
                    },
                    {
                        "id": 122429,
                        "name": "Mountain View",
                        "latitude": "36.99533000",
                        "longitude": "-91.70376000"
                    },
                    {
                        "id": 122484,
                        "name": "Murphy",
                        "latitude": "38.49033000",
                        "longitude": "-90.48707000"
                    },
                    {
                        "id": 122633,
                        "name": "Neosho",
                        "latitude": "36.86896000",
                        "longitude": "-94.36800000"
                    },
                    {
                        "id": 122648,
                        "name": "Nevada",
                        "latitude": "37.83921000",
                        "longitude": "-94.35467000"
                    },
                    {
                        "id": 122706,
                        "name": "New Franklin",
                        "latitude": "39.01725000",
                        "longitude": "-92.73741000"
                    },
                    {
                        "id": 122714,
                        "name": "New Haven",
                        "latitude": "38.60838000",
                        "longitude": "-91.21904000"
                    },
                    {
                        "id": 122740,
                        "name": "New London",
                        "latitude": "39.58532000",
                        "longitude": "-91.40098000"
                    },
                    {
                        "id": 122747,
                        "name": "New Madrid",
                        "latitude": "36.58645000",
                        "longitude": "-89.52785000"
                    },
                    {
                        "id": 122748,
                        "name": "New Madrid County",
                        "latitude": "36.59465000",
                        "longitude": "-89.65183000"
                    },
                    {
                        "id": 122870,
                        "name": "Newton County",
                        "latitude": "36.90551000",
                        "longitude": "-94.33925000"
                    },
                    {
                        "id": 122912,
                        "name": "Nixa",
                        "latitude": "37.04339000",
                        "longitude": "-93.29435000"
                    },
                    {
                        "id": 122924,
                        "name": "Nodaway County",
                        "latitude": "40.36077000",
                        "longitude": "-94.88343000"
                    },
                    {
                        "id": 122926,
                        "name": "Noel",
                        "latitude": "36.54563000",
                        "longitude": "-94.48522000"
                    },
                    {
                        "id": 122951,
                        "name": "Normandy",
                        "latitude": "38.72088000",
                        "longitude": "-90.29734000"
                    },
                    {
                        "id": 123045,
                        "name": "North Kansas City",
                        "latitude": "39.13000000",
                        "longitude": "-94.56218000"
                    },
                    {
                        "id": 123181,
                        "name": "Northwoods",
                        "latitude": "38.70422000",
                        "longitude": "-90.28345000"
                    },
                    {
                        "id": 123227,
                        "name": "O'Fallon",
                        "latitude": "38.81061000",
                        "longitude": "-90.69985000"
                    },
                    {
                        "id": 123236,
                        "name": "Oak Grove",
                        "latitude": "39.00501000",
                        "longitude": "-94.12939000"
                    },
                    {
                        "id": 123283,
                        "name": "Oakland",
                        "latitude": "38.57644000",
                        "longitude": "-90.38567000"
                    },
                    {
                        "id": 123306,
                        "name": "Oakville",
                        "latitude": "38.47005000",
                        "longitude": "-90.30456000"
                    },
                    {
                        "id": 123359,
                        "name": "Odessa",
                        "latitude": "38.99917000",
                        "longitude": "-93.95356000"
                    },
                    {
                        "id": 123421,
                        "name": "Old Jamestown",
                        "latitude": "38.83494000",
                        "longitude": "-90.28511000"
                    },
                    {
                        "id": 123449,
                        "name": "Olivette",
                        "latitude": "38.66533000",
                        "longitude": "-90.37595000"
                    },
                    {
                        "id": 123504,
                        "name": "Oran",
                        "latitude": "37.08505000",
                        "longitude": "-89.65536000"
                    },
                    {
                        "id": 123545,
                        "name": "Oregon",
                        "latitude": "39.98694000",
                        "longitude": "-95.14498000"
                    },
                    {
                        "id": 123549,
                        "name": "Oregon County",
                        "latitude": "36.68672000",
                        "longitude": "-91.40329000"
                    },
                    {
                        "id": 123576,
                        "name": "Oronogo",
                        "latitude": "37.18839000",
                        "longitude": "-94.47023000"
                    },
                    {
                        "id": 123587,
                        "name": "Osage Beach",
                        "latitude": "38.12956000",
                        "longitude": "-92.65277000"
                    },
                    {
                        "id": 123590,
                        "name": "Osage County",
                        "latitude": "38.46037000",
                        "longitude": "-91.86184000"
                    },
                    {
                        "id": 123598,
                        "name": "Osceola",
                        "latitude": "38.04670000",
                        "longitude": "-93.70438000"
                    },
                    {
                        "id": 123650,
                        "name": "Overland",
                        "latitude": "38.70116000",
                        "longitude": "-90.36234000"
                    },
                    {
                        "id": 123666,
                        "name": "Owensville",
                        "latitude": "38.34560000",
                        "longitude": "-91.50155000"
                    },
                    {
                        "id": 123698,
                        "name": "Ozark",
                        "latitude": "37.02089000",
                        "longitude": "-93.20602000"
                    },
                    {
                        "id": 123699,
                        "name": "Ozark County",
                        "latitude": "36.64932000",
                        "longitude": "-92.44466000"
                    },
                    {
                        "id": 123706,
                        "name": "Pacific",
                        "latitude": "38.48200000",
                        "longitude": "-90.74152000"
                    },
                    {
                        "id": 123720,
                        "name": "Pagedale",
                        "latitude": "38.68338000",
                        "longitude": "-90.30761000"
                    },
                    {
                        "id": 123772,
                        "name": "Palmyra",
                        "latitude": "39.79421000",
                        "longitude": "-91.52321000"
                    },
                    {
                        "id": 123832,
                        "name": "Paris",
                        "latitude": "39.48087000",
                        "longitude": "-92.00128000"
                    },
                    {
                        "id": 123848,
                        "name": "Park Hills",
                        "latitude": "37.85422000",
                        "longitude": "-90.51818000"
                    },
                    {
                        "id": 123878,
                        "name": "Parkville",
                        "latitude": "39.19500000",
                        "longitude": "-94.68218000"
                    },
                    {
                        "id": 123982,
                        "name": "Peculiar",
                        "latitude": "38.71918000",
                        "longitude": "-94.45856000"
                    },
                    {
                        "id": 124010,
                        "name": "Pemiscot County",
                        "latitude": "36.21145000",
                        "longitude": "-89.78538000"
                    },
                    {
                        "id": 124079,
                        "name": "Perry County",
                        "latitude": "37.70714000",
                        "longitude": "-89.82441000"
                    },
                    {
                        "id": 124089,
                        "name": "Perryville",
                        "latitude": "37.72422000",
                        "longitude": "-89.86122000"
                    },
                    {
                        "id": 124113,
                        "name": "Pettis County",
                        "latitude": "38.72829000",
                        "longitude": "-93.28510000"
                    },
                    {
                        "id": 124114,
                        "name": "Pevely",
                        "latitude": "38.28339000",
                        "longitude": "-90.39512000"
                    },
                    {
                        "id": 124121,
                        "name": "Phelps County",
                        "latitude": "37.87713000",
                        "longitude": "-91.79236000"
                    },
                    {
                        "id": 124165,
                        "name": "Piedmont",
                        "latitude": "37.15449000",
                        "longitude": "-90.69567000"
                    },
                    {
                        "id": 124170,
                        "name": "Pierce City",
                        "latitude": "36.94590000",
                        "longitude": "-94.00021000"
                    },
                    {
                        "id": 124191,
                        "name": "Pike County",
                        "latitude": "39.34384000",
                        "longitude": "-91.17136000"
                    },
                    {
                        "id": 124234,
                        "name": "Pine Lawn",
                        "latitude": "38.69588000",
                        "longitude": "-90.27511000"
                    },
                    {
                        "id": 124261,
                        "name": "Pineville",
                        "latitude": "36.59452000",
                        "longitude": "-94.38410000"
                    },
                    {
                        "id": 124352,
                        "name": "Platte City",
                        "latitude": "39.37028000",
                        "longitude": "-94.78246000"
                    },
                    {
                        "id": 124353,
                        "name": "Platte County",
                        "latitude": "39.38050000",
                        "longitude": "-94.77359000"
                    },
                    {
                        "id": 124359,
                        "name": "Plattsburg",
                        "latitude": "39.56555000",
                        "longitude": "-94.44801000"
                    },
                    {
                        "id": 124368,
                        "name": "Pleasant Hill",
                        "latitude": "38.78751000",
                        "longitude": "-94.26939000"
                    },
                    {
                        "id": 124377,
                        "name": "Pleasant Valley",
                        "latitude": "39.21639000",
                        "longitude": "-94.48412000"
                    },
                    {
                        "id": 124443,
                        "name": "Polk County",
                        "latitude": "37.61648000",
                        "longitude": "-93.40053000"
                    },
                    {
                        "id": 124484,
                        "name": "Poplar Bluff",
                        "latitude": "36.75700000",
                        "longitude": "-90.39289000"
                    },
                    {
                        "id": 124549,
                        "name": "Portageville",
                        "latitude": "36.42534000",
                        "longitude": "-89.69953000"
                    },
                    {
                        "id": 124586,
                        "name": "Potosi",
                        "latitude": "37.93644000",
                        "longitude": "-90.78791000"
                    },
                    {
                        "id": 124690,
                        "name": "Princeton",
                        "latitude": "40.40084000",
                        "longitude": "-93.58050000"
                    },
                    {
                        "id": 124741,
                        "name": "Pulaski County",
                        "latitude": "37.82463000",
                        "longitude": "-92.20766000"
                    },
                    {
                        "id": 124756,
                        "name": "Purdy",
                        "latitude": "36.81729000",
                        "longitude": "-93.92076000"
                    },
                    {
                        "id": 124767,
                        "name": "Putnam County",
                        "latitude": "40.47891000",
                        "longitude": "-93.01613000"
                    },
                    {
                        "id": 124835,
                        "name": "Ralls County",
                        "latitude": "39.52767000",
                        "longitude": "-91.52202000"
                    },
                    {
                        "id": 124876,
                        "name": "Randolph County",
                        "latitude": "39.44017000",
                        "longitude": "-92.49708000"
                    },
                    {
                        "id": 124916,
                        "name": "Ray County",
                        "latitude": "39.35241000",
                        "longitude": "-93.98988000"
                    },
                    {
                        "id": 124922,
                        "name": "Raymore",
                        "latitude": "38.80195000",
                        "longitude": "-94.45273000"
                    },
                    {
                        "id": 124926,
                        "name": "Raytown",
                        "latitude": "39.00862000",
                        "longitude": "-94.46356000"
                    },
                    {
                        "id": 125030,
                        "name": "Republic",
                        "latitude": "37.12005000",
                        "longitude": "-93.48019000"
                    },
                    {
                        "id": 125040,
                        "name": "Reynolds County",
                        "latitude": "37.36233000",
                        "longitude": "-90.96908000"
                    },
                    {
                        "id": 125057,
                        "name": "Rich Hill",
                        "latitude": "38.09642000",
                        "longitude": "-94.36106000"
                    },
                    {
                        "id": 125068,
                        "name": "Richland",
                        "latitude": "37.85698000",
                        "longitude": "-92.40434000"
                    },
                    {
                        "id": 125086,
                        "name": "Richmond",
                        "latitude": "39.27862000",
                        "longitude": "-93.97689000"
                    },
                    {
                        "id": 125103,
                        "name": "Richmond Heights",
                        "latitude": "38.62866000",
                        "longitude": "-90.31956000"
                    },
                    {
                        "id": 125166,
                        "name": "Ripley County",
                        "latitude": "36.65282000",
                        "longitude": "-90.86388000"
                    },
                    {
                        "id": 125203,
                        "name": "Riverside",
                        "latitude": "39.17750000",
                        "longitude": "-94.61301000"
                    },
                    {
                        "id": 125218,
                        "name": "Riverview",
                        "latitude": "38.74783000",
                        "longitude": "-90.21150000"
                    },
                    {
                        "id": 125279,
                        "name": "Rock Hill",
                        "latitude": "38.60755000",
                        "longitude": "-90.37845000"
                    },
                    {
                        "id": 125285,
                        "name": "Rock Port",
                        "latitude": "40.41111000",
                        "longitude": "-95.51693000"
                    },
                    {
                        "id": 125355,
                        "name": "Rogersville",
                        "latitude": "37.11700000",
                        "longitude": "-93.05573000"
                    },
                    {
                        "id": 125363,
                        "name": "Rolla",
                        "latitude": "37.95143000",
                        "longitude": "-91.77127000"
                    },
                    {
                        "id": 125598,
                        "name": "Saint Ann",
                        "latitude": "38.72727000",
                        "longitude": "-90.38317000"
                    },
                    {
                        "id": 125612,
                        "name": "Saint Charles",
                        "latitude": "38.78394000",
                        "longitude": "-90.48123000"
                    },
                    {
                        "id": 125616,
                        "name": "Saint Charles County",
                        "latitude": "38.78192000",
                        "longitude": "-90.67490000"
                    },
                    {
                        "id": 125618,
                        "name": "Saint Clair",
                        "latitude": "38.34533000",
                        "longitude": "-90.98097000"
                    },
                    {
                        "id": 125623,
                        "name": "Saint Clair County",
                        "latitude": "38.03718000",
                        "longitude": "-93.77598000"
                    },
                    {
                        "id": 125638,
                        "name": "Saint Francois County",
                        "latitude": "37.81028000",
                        "longitude": "-90.47227000"
                    },
                    {
                        "id": 125641,
                        "name": "Saint George",
                        "latitude": "38.53672000",
                        "longitude": "-90.31484000"
                    },
                    {
                        "id": 125653,
                        "name": "Saint James",
                        "latitude": "37.99726000",
                        "longitude": "-91.61432000"
                    },
                    {
                        "id": 125661,
                        "name": "Saint John",
                        "latitude": "38.71484000",
                        "longitude": "-90.34627000"
                    },
                    {
                        "id": 125664,
                        "name": "Saint Johns",
                        "latitude": "38.71338000",
                        "longitude": "-90.34317000"
                    },
                    {
                        "id": 125671,
                        "name": "Saint Joseph",
                        "latitude": "39.76861000",
                        "longitude": "-94.84663000"
                    },
                    {
                        "id": 125681,
                        "name": "Saint Louis County",
                        "latitude": "38.64068000",
                        "longitude": "-90.44341000"
                    },
                    {
                        "id": 125688,
                        "name": "Saint Martins",
                        "latitude": "38.59420000",
                        "longitude": "-92.33713000"
                    },
                    {
                        "id": 125701,
                        "name": "Saint Paul",
                        "latitude": "38.86144000",
                        "longitude": "-90.74179000"
                    },
                    {
                        "id": 125710,
                        "name": "Saint Peters",
                        "latitude": "38.80033000",
                        "longitude": "-90.62651000"
                    },
                    {
                        "id": 125712,
                        "name": "Saint Robert",
                        "latitude": "37.82810000",
                        "longitude": "-92.17767000"
                    },
                    {
                        "id": 125719,
                        "name": "Sainte Genevieve",
                        "latitude": "37.98144000",
                        "longitude": "-90.04178000"
                    },
                    {
                        "id": 125720,
                        "name": "Sainte Genevieve County",
                        "latitude": "37.89440000",
                        "longitude": "-90.19442000"
                    },
                    {
                        "id": 125730,
                        "name": "Salem",
                        "latitude": "37.64560000",
                        "longitude": "-91.53598000"
                    },
                    {
                        "id": 125752,
                        "name": "Saline County",
                        "latitude": "39.13684000",
                        "longitude": "-93.20185000"
                    },
                    {
                        "id": 125755,
                        "name": "Salisbury",
                        "latitude": "39.42392000",
                        "longitude": "-92.80158000"
                    },
                    {
                        "id": 125932,
                        "name": "Sappington",
                        "latitude": "38.53700000",
                        "longitude": "-90.37984000"
                    },
                    {
                        "id": 125946,
                        "name": "Sarcoxie",
                        "latitude": "37.06923000",
                        "longitude": "-94.11660000"
                    },
                    {
                        "id": 125975,
                        "name": "Savannah",
                        "latitude": "39.94166000",
                        "longitude": "-94.83025000"
                    },
                    {
                        "id": 126023,
                        "name": "Schuyler County",
                        "latitude": "40.47027000",
                        "longitude": "-92.52094000"
                    },
                    {
                        "id": 126037,
                        "name": "Scotland County",
                        "latitude": "40.45260000",
                        "longitude": "-92.14705000"
                    },
                    {
                        "id": 126041,
                        "name": "Scott City",
                        "latitude": "37.21672000",
                        "longitude": "-89.52453000"
                    },
                    {
                        "id": 126047,
                        "name": "Scott County",
                        "latitude": "37.05305000",
                        "longitude": "-89.56851000"
                    },
                    {
                        "id": 126114,
                        "name": "Sedalia",
                        "latitude": "38.70446000",
                        "longitude": "-93.22826000"
                    },
                    {
                        "id": 126152,
                        "name": "Senath",
                        "latitude": "36.13423000",
                        "longitude": "-90.15982000"
                    },
                    {
                        "id": 126155,
                        "name": "Seneca",
                        "latitude": "36.84146000",
                        "longitude": "-94.61106000"
                    },
                    {
                        "id": 126193,
                        "name": "Seymour",
                        "latitude": "37.14644000",
                        "longitude": "-92.76878000"
                    },
                    {
                        "id": 126220,
                        "name": "Shannon County",
                        "latitude": "37.15739000",
                        "longitude": "-91.40051000"
                    },
                    {
                        "id": 126263,
                        "name": "Shelbina",
                        "latitude": "39.69393000",
                        "longitude": "-92.04295000"
                    },
                    {
                        "id": 126276,
                        "name": "Shelby County",
                        "latitude": "39.79778000",
                        "longitude": "-92.07662000"
                    },
                    {
                        "id": 126283,
                        "name": "Shelbyville",
                        "latitude": "39.80587000",
                        "longitude": "-92.04156000"
                    },
                    {
                        "id": 126289,
                        "name": "Shell Knob",
                        "latitude": "36.63229000",
                        "longitude": "-93.63436000"
                    },
                    {
                        "id": 126383,
                        "name": "Shrewsbury",
                        "latitude": "38.59033000",
                        "longitude": "-90.33678000"
                    },
                    {
                        "id": 126414,
                        "name": "Sikeston",
                        "latitude": "36.87672000",
                        "longitude": "-89.58786000"
                    },
                    {
                        "id": 126489,
                        "name": "Slater",
                        "latitude": "39.21808000",
                        "longitude": "-93.06909000"
                    },
                    {
                        "id": 126528,
                        "name": "Smithville",
                        "latitude": "39.38694000",
                        "longitude": "-94.58107000"
                    },
                    {
                        "id": 126800,
                        "name": "Spanish Lake",
                        "latitude": "38.78783000",
                        "longitude": "-90.21594000"
                    },
                    {
                        "id": 126809,
                        "name": "Sparta",
                        "latitude": "37.00116000",
                        "longitude": "-93.08157000"
                    },
                    {
                        "id": 126893,
                        "name": "Springfield",
                        "latitude": "37.21533000",
                        "longitude": "-93.29824000"
                    },
                    {
                        "id": 126928,
                        "name": "St. Louis",
                        "latitude": "38.62727000",
                        "longitude": "-90.19789000"
                    },
                    {
                        "id": 126949,
                        "name": "Stanberry",
                        "latitude": "40.21777000",
                        "longitude": "-94.53829000"
                    },
                    {
                        "id": 127008,
                        "name": "Steele",
                        "latitude": "36.08396000",
                        "longitude": "-89.82925000"
                    },
                    {
                        "id": 127014,
                        "name": "Steelville",
                        "latitude": "37.96810000",
                        "longitude": "-91.35487000"
                    },
                    {
                        "id": 127072,
                        "name": "Stockton",
                        "latitude": "37.69893000",
                        "longitude": "-93.79604000"
                    },
                    {
                        "id": 127077,
                        "name": "Stoddard County",
                        "latitude": "36.85562000",
                        "longitude": "-89.94431000"
                    },
                    {
                        "id": 127081,
                        "name": "Stone County",
                        "latitude": "36.74694000",
                        "longitude": "-93.45600000"
                    },
                    {
                        "id": 127111,
                        "name": "Stover",
                        "latitude": "38.44086000",
                        "longitude": "-92.99187000"
                    },
                    {
                        "id": 127116,
                        "name": "Strafford",
                        "latitude": "37.26838000",
                        "longitude": "-93.11713000"
                    },
                    {
                        "id": 127170,
                        "name": "Sugar Creek",
                        "latitude": "39.10973000",
                        "longitude": "-94.44467000"
                    },
                    {
                        "id": 127183,
                        "name": "Sullivan",
                        "latitude": "38.20810000",
                        "longitude": "-91.16042000"
                    },
                    {
                        "id": 127188,
                        "name": "Sullivan County",
                        "latitude": "40.21064000",
                        "longitude": "-93.11152000"
                    },
                    {
                        "id": 127275,
                        "name": "Sunset Hills",
                        "latitude": "38.53894000",
                        "longitude": "-90.40734000"
                    },
                    {
                        "id": 127338,
                        "name": "Sweet Springs",
                        "latitude": "38.96363000",
                        "longitude": "-93.41493000"
                    },
                    {
                        "id": 127410,
                        "name": "Taney County",
                        "latitude": "36.65473000",
                        "longitude": "-93.04111000"
                    },
                    {
                        "id": 127421,
                        "name": "Taos",
                        "latitude": "38.50643000",
                        "longitude": "-92.07101000"
                    },
                    {
                        "id": 127431,
                        "name": "Tarkio",
                        "latitude": "40.44028000",
                        "longitude": "-95.37776000"
                    },
                    {
                        "id": 127523,
                        "name": "Terre du Lac",
                        "latitude": "37.91172000",
                        "longitude": "-90.62541000"
                    },
                    {
                        "id": 127521,
                        "name": "Terre Haute",
                        "latitude": "40.43946000",
                        "longitude": "-93.23410000"
                    },
                    {
                        "id": 127547,
                        "name": "Texas County",
                        "latitude": "37.31731000",
                        "longitude": "-91.96505000"
                    },
                    {
                        "id": 127551,
                        "name": "Thayer",
                        "latitude": "36.52451000",
                        "longitude": "-91.53820000"
                    },
                    {
                        "id": 127674,
                        "name": "Tipton",
                        "latitude": "38.65558000",
                        "longitude": "-92.77992000"
                    },
                    {
                        "id": 127759,
                        "name": "Town and Country",
                        "latitude": "38.61228000",
                        "longitude": "-90.46345000"
                    },
                    {
                        "id": 127809,
                        "name": "Trenton",
                        "latitude": "40.07890000",
                        "longitude": "-93.61661000"
                    },
                    {
                        "id": 127844,
                        "name": "Troy",
                        "latitude": "38.97949000",
                        "longitude": "-90.98070000"
                    },
                    {
                        "id": 127915,
                        "name": "Tuscumbia",
                        "latitude": "38.23309000",
                        "longitude": "-92.45852000"
                    },
                    {
                        "id": 127973,
                        "name": "Union",
                        "latitude": "38.45005000",
                        "longitude": "-91.00848000"
                    },
                    {
                        "id": 128020,
                        "name": "Unionville",
                        "latitude": "40.47696000",
                        "longitude": "-93.00326000"
                    },
                    {
                        "id": 128027,
                        "name": "University City",
                        "latitude": "38.65588000",
                        "longitude": "-90.30928000"
                    },
                    {
                        "id": 128114,
                        "name": "Valley Park",
                        "latitude": "38.54922000",
                        "longitude": "-90.49262000"
                    },
                    {
                        "id": 128127,
                        "name": "Van Buren",
                        "latitude": "36.99561000",
                        "longitude": "-91.01457000"
                    },
                    {
                        "id": 128146,
                        "name": "Vandalia",
                        "latitude": "39.31087000",
                        "longitude": "-91.48849000"
                    },
                    {
                        "id": 128163,
                        "name": "Velda Village",
                        "latitude": "38.69005000",
                        "longitude": "-90.29428000"
                    },
                    {
                        "id": 128164,
                        "name": "Velda Village Hills",
                        "latitude": "38.69061000",
                        "longitude": "-90.28734000"
                    },
                    {
                        "id": 128192,
                        "name": "Vernon County",
                        "latitude": "37.85058000",
                        "longitude": "-94.34244000"
                    },
                    {
                        "id": 128210,
                        "name": "Versailles",
                        "latitude": "38.43141000",
                        "longitude": "-92.84103000"
                    },
                    {
                        "id": 128232,
                        "name": "Vienna",
                        "latitude": "38.18671000",
                        "longitude": "-91.94711000"
                    },
                    {
                        "id": 128246,
                        "name": "Villa Ridge",
                        "latitude": "38.47255000",
                        "longitude": "-90.88680000"
                    },
                    {
                        "id": 128278,
                        "name": "Vinita Park",
                        "latitude": "38.69005000",
                        "longitude": "-90.34262000"
                    },
                    {
                        "id": 128461,
                        "name": "Wardsville",
                        "latitude": "38.48892000",
                        "longitude": "-92.17435000"
                    },
                    {
                        "id": 128488,
                        "name": "Warren County",
                        "latitude": "38.76462000",
                        "longitude": "-91.16069000"
                    },
                    {
                        "id": 128502,
                        "name": "Warrensburg",
                        "latitude": "38.76279000",
                        "longitude": "-93.73605000"
                    },
                    {
                        "id": 128505,
                        "name": "Warrenton",
                        "latitude": "38.81144000",
                        "longitude": "-91.14154000"
                    },
                    {
                        "id": 128517,
                        "name": "Warsaw",
                        "latitude": "38.24308000",
                        "longitude": "-93.38187000"
                    },
                    {
                        "id": 128522,
                        "name": "Warson Woods",
                        "latitude": "38.60727000",
                        "longitude": "-90.38345000"
                    },
                    {
                        "id": 128540,
                        "name": "Washington",
                        "latitude": "38.55811000",
                        "longitude": "-91.01209000"
                    },
                    {
                        "id": 128561,
                        "name": "Washington County",
                        "latitude": "37.96168000",
                        "longitude": "-90.87742000"
                    },
                    {
                        "id": 128693,
                        "name": "Wayne County",
                        "latitude": "37.11264000",
                        "longitude": "-90.46143000"
                    },
                    {
                        "id": 128712,
                        "name": "Waynesville",
                        "latitude": "37.82865000",
                        "longitude": "-92.20072000"
                    },
                    {
                        "id": 128716,
                        "name": "Weatherby Lake",
                        "latitude": "39.23778000",
                        "longitude": "-94.69607000"
                    },
                    {
                        "id": 128725,
                        "name": "Webb City",
                        "latitude": "37.14645000",
                        "longitude": "-94.46300000"
                    },
                    {
                        "id": 128738,
                        "name": "Webster County",
                        "latitude": "37.28091000",
                        "longitude": "-92.87588000"
                    },
                    {
                        "id": 128743,
                        "name": "Webster Groves",
                        "latitude": "38.59255000",
                        "longitude": "-90.35734000"
                    },
                    {
                        "id": 128771,
                        "name": "Weldon Spring",
                        "latitude": "38.71339000",
                        "longitude": "-90.68929000"
                    },
                    {
                        "id": 128790,
                        "name": "Wellston",
                        "latitude": "38.67283000",
                        "longitude": "-90.29928000"
                    },
                    {
                        "id": 128792,
                        "name": "Wellsville",
                        "latitude": "39.07198000",
                        "longitude": "-91.57016000"
                    },
                    {
                        "id": 128805,
                        "name": "Wentzville",
                        "latitude": "38.81144000",
                        "longitude": "-90.85291000"
                    },
                    {
                        "id": 128956,
                        "name": "West Plains",
                        "latitude": "36.72812000",
                        "longitude": "-91.85237000"
                    },
                    {
                        "id": 129059,
                        "name": "Weston",
                        "latitude": "39.41111000",
                        "longitude": "-94.90163000"
                    },
                    {
                        "id": 129177,
                        "name": "Whiteman Air Force Base",
                        "latitude": "38.73018000",
                        "longitude": "-93.55895000"
                    },
                    {
                        "id": 129237,
                        "name": "Wildwood",
                        "latitude": "38.58283000",
                        "longitude": "-90.66290000"
                    },
                    {
                        "id": 129257,
                        "name": "Willard",
                        "latitude": "37.30505000",
                        "longitude": "-93.42853000"
                    },
                    {
                        "id": 129309,
                        "name": "Willow Springs",
                        "latitude": "36.99228000",
                        "longitude": "-91.96987000"
                    },
                    {
                        "id": 129354,
                        "name": "Winchester",
                        "latitude": "38.59033000",
                        "longitude": "-90.52790000"
                    },
                    {
                        "id": 129379,
                        "name": "Windsor",
                        "latitude": "38.53224000",
                        "longitude": "-93.52215000"
                    },
                    {
                        "id": 129394,
                        "name": "Winfield",
                        "latitude": "38.99727000",
                        "longitude": "-90.73846000"
                    },
                    {
                        "id": 129423,
                        "name": "Winona",
                        "latitude": "37.00977000",
                        "longitude": "-91.32347000"
                    },
                    {
                        "id": 129559,
                        "name": "Woodson Terrace",
                        "latitude": "38.72505000",
                        "longitude": "-90.35845000"
                    },
                    {
                        "id": 129594,
                        "name": "Worth County",
                        "latitude": "40.47914000",
                        "longitude": "-94.42210000"
                    },
                    {
                        "id": 129607,
                        "name": "Wright City",
                        "latitude": "38.82755000",
                        "longitude": "-91.02014000"
                    },
                    {
                        "id": 129608,
                        "name": "Wright County",
                        "latitude": "37.27014000",
                        "longitude": "-92.46870000"
                    }
                ]
            },
            {
                "id": 1446,
                "name": "Montana",
                "iso2": "MT",
                "latitude": "46.87968220",
                "longitude": "-110.36256580",
                "type": "state",
                "cities": [
                    {
                        "id": 110989,
                        "name": "Absarokee",
                        "latitude": "45.52050000",
                        "longitude": "-109.44294000"
                    },
                    {
                        "id": 111296,
                        "name": "Anaconda",
                        "latitude": "46.12854000",
                        "longitude": "-112.94226000"
                    },
                    {
                        "id": 111739,
                        "name": "Baker",
                        "latitude": "46.36695000",
                        "longitude": "-104.28466000"
                    },
                    {
                        "id": 112008,
                        "name": "Beaverhead County",
                        "latitude": "45.13273000",
                        "longitude": "-112.89889000"
                    },
                    {
                        "id": 112062,
                        "name": "Belgrade",
                        "latitude": "45.77604000",
                        "longitude": "-111.17690000"
                    },
                    {
                        "id": 112321,
                        "name": "Big Horn County",
                        "latitude": "45.42346000",
                        "longitude": "-107.48970000"
                    },
                    {
                        "id": 112334,
                        "name": "Big Sky",
                        "latitude": "45.28465000",
                        "longitude": "-111.36829000"
                    },
                    {
                        "id": 112338,
                        "name": "Big Timber",
                        "latitude": "45.83494000",
                        "longitude": "-109.95546000"
                    },
                    {
                        "id": 112339,
                        "name": "Bigfork",
                        "latitude": "48.06329000",
                        "longitude": "-114.07261000"
                    },
                    {
                        "id": 112344,
                        "name": "Billings",
                        "latitude": "45.78329000",
                        "longitude": "-108.50069000"
                    },
                    {
                        "id": 112408,
                        "name": "Blaine County",
                        "latitude": "48.43276000",
                        "longitude": "-108.95866000"
                    },
                    {
                        "id": 112544,
                        "name": "Bonner-West Riverside",
                        "latitude": "46.87669000",
                        "longitude": "-113.88678000"
                    },
                    {
                        "id": 112601,
                        "name": "Boulder",
                        "latitude": "46.23659000",
                        "longitude": "-112.12083000"
                    },
                    {
                        "id": 112653,
                        "name": "Bozeman",
                        "latitude": "45.67965000",
                        "longitude": "-111.03856000"
                    },
                    {
                        "id": 112826,
                        "name": "Broadus",
                        "latitude": "45.44387000",
                        "longitude": "-105.41133000"
                    },
                    {
                        "id": 112829,
                        "name": "Broadwater County",
                        "latitude": "46.33199000",
                        "longitude": "-111.49547000"
                    },
                    {
                        "id": 112918,
                        "name": "Browning",
                        "latitude": "48.55692000",
                        "longitude": "-113.01342000"
                    },
                    {
                        "id": 113123,
                        "name": "Butte",
                        "latitude": "46.00382000",
                        "longitude": "-112.53474000"
                    },
                    {
                        "id": 113128,
                        "name": "Butte-Silver Bow (Balance)",
                        "latitude": "45.90194000",
                        "longitude": "-112.65708000"
                    },
                    {
                        "id": 113384,
                        "name": "Carbon County",
                        "latitude": "45.22737000",
                        "longitude": "-109.02832000"
                    },
                    {
                        "id": 113484,
                        "name": "Carter County",
                        "latitude": "45.51677000",
                        "longitude": "-104.53616000"
                    },
                    {
                        "id": 113515,
                        "name": "Cascade County",
                        "latitude": "47.30802000",
                        "longitude": "-111.34715000"
                    },
                    {
                        "id": 113893,
                        "name": "Chester",
                        "latitude": "48.51054000",
                        "longitude": "-110.96747000"
                    },
                    {
                        "id": 113971,
                        "name": "Chinook",
                        "latitude": "48.59000000",
                        "longitude": "-109.23128000"
                    },
                    {
                        "id": 113989,
                        "name": "Choteau",
                        "latitude": "47.81245000",
                        "longitude": "-112.18363000"
                    },
                    {
                        "id": 113991,
                        "name": "Chouteau County",
                        "latitude": "47.88056000",
                        "longitude": "-110.43520000"
                    },
                    {
                        "id": 114028,
                        "name": "Circle",
                        "latitude": "47.41667000",
                        "longitude": "-105.59222000"
                    },
                    {
                        "id": 114098,
                        "name": "Clancy",
                        "latitude": "46.46521000",
                        "longitude": "-111.98638000"
                    },
                    {
                        "id": 114287,
                        "name": "Clinton",
                        "latitude": "46.76909000",
                        "longitude": "-113.71260000"
                    },
                    {
                        "id": 114462,
                        "name": "Colstrip",
                        "latitude": "45.88416000",
                        "longitude": "-106.62364000"
                    },
                    {
                        "id": 114485,
                        "name": "Columbia Falls",
                        "latitude": "48.37246000",
                        "longitude": "-114.18152000"
                    },
                    {
                        "id": 114499,
                        "name": "Columbus",
                        "latitude": "45.63661000",
                        "longitude": "-109.25211000"
                    },
                    {
                        "id": 114569,
                        "name": "Conrad",
                        "latitude": "48.17025000",
                        "longitude": "-111.94613000"
                    },
                    {
                        "id": 114860,
                        "name": "Crow Agency",
                        "latitude": "45.60164000",
                        "longitude": "-107.46119000"
                    },
                    {
                        "id": 114939,
                        "name": "Custer County",
                        "latitude": "46.25270000",
                        "longitude": "-105.57178000"
                    },
                    {
                        "id": 114941,
                        "name": "Cut Bank",
                        "latitude": "48.63304000",
                        "longitude": "-112.32616000"
                    },
                    {
                        "id": 115024,
                        "name": "Daniels County",
                        "latitude": "48.78381000",
                        "longitude": "-105.54857000"
                    },
                    {
                        "id": 115086,
                        "name": "Dawson County",
                        "latitude": "47.26638000",
                        "longitude": "-104.89946000"
                    },
                    {
                        "id": 115173,
                        "name": "Deer Lodge",
                        "latitude": "46.39576000",
                        "longitude": "-112.73004000"
                    },
                    {
                        "id": 115174,
                        "name": "Deer Lodge County",
                        "latitude": "46.06079000",
                        "longitude": "-113.06775000"
                    },
                    {
                        "id": 115343,
                        "name": "Dillon",
                        "latitude": "45.21631000",
                        "longitude": "-112.63752000"
                    },
                    {
                        "id": 115688,
                        "name": "East Helena",
                        "latitude": "46.58966000",
                        "longitude": "-111.91555000"
                    },
                    {
                        "id": 115715,
                        "name": "East Missoula",
                        "latitude": "46.87076000",
                        "longitude": "-113.94455000"
                    },
                    {
                        "id": 115910,
                        "name": "Ekalaka",
                        "latitude": "45.88889000",
                        "longitude": "-104.55273000"
                    },
                    {
                        "id": 116236,
                        "name": "Eureka",
                        "latitude": "48.87996000",
                        "longitude": "-115.05350000"
                    },
                    {
                        "id": 116264,
                        "name": "Evergreen",
                        "latitude": "48.22579000",
                        "longitude": "-114.27624000"
                    },
                    {
                        "id": 116379,
                        "name": "Fallon County",
                        "latitude": "46.33402000",
                        "longitude": "-104.41742000"
                    },
                    {
                        "id": 116478,
                        "name": "Fergus County",
                        "latitude": "47.26357000",
                        "longitude": "-109.22433000"
                    },
                    {
                        "id": 116554,
                        "name": "Flathead County",
                        "latitude": "48.29516000",
                        "longitude": "-114.04981000"
                    },
                    {
                        "id": 116685,
                        "name": "Forsyth",
                        "latitude": "46.26638000",
                        "longitude": "-106.67781000"
                    },
                    {
                        "id": 116690,
                        "name": "Fort Belknap Agency",
                        "latitude": "48.48250000",
                        "longitude": "-108.76544000"
                    },
                    {
                        "id": 116693,
                        "name": "Fort Benton",
                        "latitude": "47.81830000",
                        "longitude": "-110.66744000"
                    },
                    {
                        "id": 116790,
                        "name": "Four Corners",
                        "latitude": "45.62965000",
                        "longitude": "-111.18606000"
                    },
                    {
                        "id": 116935,
                        "name": "Frenchtown",
                        "latitude": "47.01492000",
                        "longitude": "-114.22984000"
                    },
                    {
                        "id": 117036,
                        "name": "Gallatin County",
                        "latitude": "45.54049000",
                        "longitude": "-111.17035000"
                    },
                    {
                        "id": 117086,
                        "name": "Garfield County",
                        "latitude": "47.27770000",
                        "longitude": "-106.99283000"
                    },
                    {
                        "id": 117231,
                        "name": "Glacier County",
                        "latitude": "48.70508000",
                        "longitude": "-112.99475000"
                    },
                    {
                        "id": 117249,
                        "name": "Glasgow",
                        "latitude": "48.19696000",
                        "longitude": "-106.63671000"
                    },
                    {
                        "id": 117289,
                        "name": "Glendive",
                        "latitude": "47.10529000",
                        "longitude": "-104.71246000"
                    },
                    {
                        "id": 117358,
                        "name": "Golden Valley County",
                        "latitude": "46.38126000",
                        "longitude": "-109.17494000"
                    },
                    {
                        "id": 117495,
                        "name": "Granite County",
                        "latitude": "46.40444000",
                        "longitude": "-113.44026000"
                    },
                    {
                        "id": 117573,
                        "name": "Great Falls",
                        "latitude": "47.50024000",
                        "longitude": "-111.30081000"
                    },
                    {
                        "id": 117894,
                        "name": "Hamilton",
                        "latitude": "46.24687000",
                        "longitude": "-114.16037000"
                    },
                    {
                        "id": 117998,
                        "name": "Hardin",
                        "latitude": "45.73248000",
                        "longitude": "-107.61203000"
                    },
                    {
                        "id": 118027,
                        "name": "Harlowton",
                        "latitude": "46.43551000",
                        "longitude": "-109.83435000"
                    },
                    {
                        "id": 118154,
                        "name": "Havre",
                        "latitude": "48.55000000",
                        "longitude": "-109.68409000"
                    },
                    {
                        "id": 118251,
                        "name": "Helena",
                        "latitude": "46.59271000",
                        "longitude": "-112.03611000"
                    },
                    {
                        "id": 118252,
                        "name": "Helena Valley Northeast",
                        "latitude": "46.69882000",
                        "longitude": "-111.95207000"
                    },
                    {
                        "id": 118253,
                        "name": "Helena Valley Northwest",
                        "latitude": "46.72894000",
                        "longitude": "-112.06275000"
                    },
                    {
                        "id": 118254,
                        "name": "Helena Valley Southeast",
                        "latitude": "46.61527000",
                        "longitude": "-111.92156000"
                    },
                    {
                        "id": 118255,
                        "name": "Helena Valley West Central",
                        "latitude": "46.66291000",
                        "longitude": "-112.06044000"
                    },
                    {
                        "id": 118256,
                        "name": "Helena West Side",
                        "latitude": "46.59672000",
                        "longitude": "-112.11304000"
                    },
                    {
                        "id": 118437,
                        "name": "Hill County",
                        "latitude": "48.62823000",
                        "longitude": "-110.11131000"
                    },
                    {
                        "id": 118858,
                        "name": "Hysham",
                        "latitude": "46.29277000",
                        "longitude": "-107.23423000"
                    },
                    {
                        "id": 119196,
                        "name": "Jefferson County",
                        "latitude": "46.14849000",
                        "longitude": "-112.09374000"
                    },
                    {
                        "id": 119317,
                        "name": "Jordan",
                        "latitude": "47.32083000",
                        "longitude": "-106.91007000"
                    },
                    {
                        "id": 119326,
                        "name": "Judith Basin County",
                        "latitude": "47.04546000",
                        "longitude": "-110.26607000"
                    },
                    {
                        "id": 119365,
                        "name": "Kalispell",
                        "latitude": "48.19579000",
                        "longitude": "-114.31291000"
                    },
                    {
                        "id": 119898,
                        "name": "Lake County",
                        "latitude": "47.64594000",
                        "longitude": "-114.08935000"
                    },
                    {
                        "id": 120033,
                        "name": "Lakeside",
                        "latitude": "48.01939000",
                        "longitude": "-114.22457000"
                    },
                    {
                        "id": 120070,
                        "name": "Lame Deer",
                        "latitude": "45.62305000",
                        "longitude": "-106.66670000"
                    },
                    {
                        "id": 120193,
                        "name": "Laurel",
                        "latitude": "45.66912000",
                        "longitude": "-108.77153000"
                    },
                    {
                        "id": 120418,
                        "name": "Lewis and Clark County",
                        "latitude": "47.12234000",
                        "longitude": "-112.39035000"
                    },
                    {
                        "id": 120433,
                        "name": "Lewistown",
                        "latitude": "47.06247000",
                        "longitude": "-109.42824000"
                    },
                    {
                        "id": 120457,
                        "name": "Libby",
                        "latitude": "48.38829000",
                        "longitude": "-115.55600000"
                    },
                    {
                        "id": 120473,
                        "name": "Liberty County",
                        "latitude": "48.56169000",
                        "longitude": "-111.02461000"
                    },
                    {
                        "id": 120512,
                        "name": "Lincoln",
                        "latitude": "46.95494000",
                        "longitude": "-112.68171000"
                    },
                    {
                        "id": 120534,
                        "name": "Lincoln County",
                        "latitude": "48.54253000",
                        "longitude": "-115.40519000"
                    },
                    {
                        "id": 120653,
                        "name": "Livingston",
                        "latitude": "45.66244000",
                        "longitude": "-110.56104000"
                    },
                    {
                        "id": 120683,
                        "name": "Lockwood",
                        "latitude": "45.81912000",
                        "longitude": "-108.41486000"
                    },
                    {
                        "id": 120710,
                        "name": "Lolo",
                        "latitude": "46.75881000",
                        "longitude": "-114.08094000"
                    },
                    {
                        "id": 121019,
                        "name": "Madison County",
                        "latitude": "45.30074000",
                        "longitude": "-111.92033000"
                    },
                    {
                        "id": 121064,
                        "name": "Malmstrom Air Force Base",
                        "latitude": "47.50549000",
                        "longitude": "-111.18302000"
                    },
                    {
                        "id": 121068,
                        "name": "Malta",
                        "latitude": "48.35972000",
                        "longitude": "-107.87428000"
                    },
                    {
                        "id": 121116,
                        "name": "Manhattan",
                        "latitude": "45.85660000",
                        "longitude": "-111.33246000"
                    },
                    {
                        "id": 121475,
                        "name": "McCone County",
                        "latitude": "47.64523000",
                        "longitude": "-105.79534000"
                    },
                    {
                        "id": 121576,
                        "name": "Meagher County",
                        "latitude": "46.59819000",
                        "longitude": "-110.88564000"
                    },
                    {
                        "id": 121844,
                        "name": "Miles City",
                        "latitude": "46.40834000",
                        "longitude": "-105.84056000"
                    },
                    {
                        "id": 121937,
                        "name": "Mineral County",
                        "latitude": "47.14732000",
                        "longitude": "-114.99850000"
                    },
                    {
                        "id": 121991,
                        "name": "Missoula",
                        "latitude": "46.87215000",
                        "longitude": "-113.99400000"
                    },
                    {
                        "id": 121992,
                        "name": "Missoula County",
                        "latitude": "47.03649000",
                        "longitude": "-113.92371000"
                    },
                    {
                        "id": 122101,
                        "name": "Montana City",
                        "latitude": "46.53771000",
                        "longitude": "-111.93277000"
                    },
                    {
                        "id": 122514,
                        "name": "Musselshell County",
                        "latitude": "46.49655000",
                        "longitude": "-108.39771000"
                    },
                    {
                        "id": 122998,
                        "name": "North Browning",
                        "latitude": "48.57025000",
                        "longitude": "-113.00953000"
                    },
                    {
                        "id": 123535,
                        "name": "Orchard Homes",
                        "latitude": "46.86326000",
                        "longitude": "-114.04844000"
                    },
                    {
                        "id": 123703,
                        "name": "Pablo",
                        "latitude": "47.60021000",
                        "longitude": "-114.11900000"
                    },
                    {
                        "id": 123842,
                        "name": "Park County",
                        "latitude": "45.48834000",
                        "longitude": "-110.52632000"
                    },
                    {
                        "id": 124112,
                        "name": "Petroleum County",
                        "latitude": "47.11751000",
                        "longitude": "-108.25012000"
                    },
                    {
                        "id": 124132,
                        "name": "Philipsburg",
                        "latitude": "46.33215000",
                        "longitude": "-113.29423000"
                    },
                    {
                        "id": 124138,
                        "name": "Phillips County",
                        "latitude": "48.25909000",
                        "longitude": "-107.91329000"
                    },
                    {
                        "id": 124326,
                        "name": "Plains",
                        "latitude": "47.46021000",
                        "longitude": "-114.88291000"
                    },
                    {
                        "id": 124390,
                        "name": "Plentywood",
                        "latitude": "48.77475000",
                        "longitude": "-104.56246000"
                    },
                    {
                        "id": 124455,
                        "name": "Polson",
                        "latitude": "47.69355000",
                        "longitude": "-114.16317000"
                    },
                    {
                        "id": 124468,
                        "name": "Pondera County",
                        "latitude": "48.22798000",
                        "longitude": "-112.22639000"
                    },
                    {
                        "id": 124607,
                        "name": "Powder River County",
                        "latitude": "45.39501000",
                        "longitude": "-105.63010000"
                    },
                    {
                        "id": 124613,
                        "name": "Powell County",
                        "latitude": "46.85663000",
                        "longitude": "-112.93620000"
                    },
                    {
                        "id": 124625,
                        "name": "Prairie County",
                        "latitude": "46.86049000",
                        "longitude": "-105.37794000"
                    },
                    {
                        "id": 124903,
                        "name": "Ravalli County",
                        "latitude": "46.08170000",
                        "longitude": "-114.12069000"
                    },
                    {
                        "id": 124954,
                        "name": "Red Lodge",
                        "latitude": "45.18578000",
                        "longitude": "-109.24682000"
                    },
                    {
                        "id": 125078,
                        "name": "Richland County",
                        "latitude": "47.78792000",
                        "longitude": "-104.56134000"
                    },
                    {
                        "id": 125386,
                        "name": "Ronan",
                        "latitude": "47.52882000",
                        "longitude": "-114.10150000"
                    },
                    {
                        "id": 125394,
                        "name": "Roosevelt County",
                        "latitude": "48.29455000",
                        "longitude": "-105.01652000"
                    },
                    {
                        "id": 125413,
                        "name": "Rosebud County",
                        "latitude": "46.22974000",
                        "longitude": "-106.73082000"
                    },
                    {
                        "id": 125474,
                        "name": "Roundup",
                        "latitude": "46.44524000",
                        "longitude": "-108.54180000"
                    },
                    {
                        "id": 125564,
                        "name": "Ryegate",
                        "latitude": "46.29718000",
                        "longitude": "-109.25879000"
                    },
                    {
                        "id": 125863,
                        "name": "Sanders County",
                        "latitude": "47.67483000",
                        "longitude": "-115.13329000"
                    },
                    {
                        "id": 126031,
                        "name": "Scobey",
                        "latitude": "48.79252000",
                        "longitude": "-105.42083000"
                    },
                    {
                        "id": 126125,
                        "name": "Seeley Lake",
                        "latitude": "47.17938000",
                        "longitude": "-113.48452000"
                    },
                    {
                        "id": 126271,
                        "name": "Shelby",
                        "latitude": "48.50526000",
                        "longitude": "-111.85697000"
                    },
                    {
                        "id": 126325,
                        "name": "Sheridan County",
                        "latitude": "48.72120000",
                        "longitude": "-104.50468000"
                    },
                    {
                        "id": 126399,
                        "name": "Sidney",
                        "latitude": "47.71668000",
                        "longitude": "-104.15633000"
                    },
                    {
                        "id": 126421,
                        "name": "Silver Bow County",
                        "latitude": "45.90236000",
                        "longitude": "-112.65672000"
                    },
                    {
                        "id": 126577,
                        "name": "Somers",
                        "latitude": "48.08023000",
                        "longitude": "-114.22151000"
                    },
                    {
                        "id": 126633,
                        "name": "South Browning",
                        "latitude": "48.54608000",
                        "longitude": "-113.01425000"
                    },
                    {
                        "id": 126955,
                        "name": "Stanford",
                        "latitude": "47.15358000",
                        "longitude": "-110.21826000"
                    },
                    {
                        "id": 127049,
                        "name": "Stevensville",
                        "latitude": "46.50992000",
                        "longitude": "-114.09316000"
                    },
                    {
                        "id": 127063,
                        "name": "Stillwater County",
                        "latitude": "45.66944000",
                        "longitude": "-109.39477000"
                    },
                    {
                        "id": 127238,
                        "name": "Sun Prairie",
                        "latitude": "47.53690000",
                        "longitude": "-111.48136000"
                    },
                    {
                        "id": 127282,
                        "name": "Superior",
                        "latitude": "47.19159000",
                        "longitude": "-114.89180000"
                    },
                    {
                        "id": 127336,
                        "name": "Sweet Grass County",
                        "latitude": "45.81373000",
                        "longitude": "-109.94105000"
                    },
                    {
                        "id": 127531,
                        "name": "Terry",
                        "latitude": "46.79306000",
                        "longitude": "-105.31221000"
                    },
                    {
                        "id": 127538,
                        "name": "Teton County",
                        "latitude": "47.83729000",
                        "longitude": "-112.24080000"
                    },
                    {
                        "id": 127592,
                        "name": "Thompson Falls",
                        "latitude": "47.59489000",
                        "longitude": "-115.33834000"
                    },
                    {
                        "id": 127611,
                        "name": "Three Forks",
                        "latitude": "45.89243000",
                        "longitude": "-111.55219000"
                    },
                    {
                        "id": 127728,
                        "name": "Toole County",
                        "latitude": "48.65530000",
                        "longitude": "-111.69570000"
                    },
                    {
                        "id": 127766,
                        "name": "Townsend",
                        "latitude": "46.31910000",
                        "longitude": "-111.52080000"
                    },
                    {
                        "id": 127789,
                        "name": "Treasure County",
                        "latitude": "46.21147000",
                        "longitude": "-107.27170000"
                    },
                    {
                        "id": 128105,
                        "name": "Valley County",
                        "latitude": "48.36531000",
                        "longitude": "-106.66752000"
                    },
                    {
                        "id": 128289,
                        "name": "Virginia City",
                        "latitude": "45.29381000",
                        "longitude": "-111.94609000"
                    },
                    {
                        "id": 128470,
                        "name": "Warm Springs",
                        "latitude": "46.18131000",
                        "longitude": "-112.78476000"
                    },
                    {
                        "id": 128878,
                        "name": "West Glendive",
                        "latitude": "47.11085000",
                        "longitude": "-104.74968000"
                    },
                    {
                        "id": 129009,
                        "name": "West Yellowstone",
                        "latitude": "44.66215000",
                        "longitude": "-111.10411000"
                    },
                    {
                        "id": 129110,
                        "name": "Wheatland County",
                        "latitude": "46.46634000",
                        "longitude": "-109.84440000"
                    },
                    {
                        "id": 129163,
                        "name": "White Sulphur Springs",
                        "latitude": "46.54828000",
                        "longitude": "-110.90216000"
                    },
                    {
                        "id": 129166,
                        "name": "Whitefish",
                        "latitude": "48.41108000",
                        "longitude": "-114.33763000"
                    },
                    {
                        "id": 129172,
                        "name": "Whitehall",
                        "latitude": "45.87076000",
                        "longitude": "-112.09749000"
                    },
                    {
                        "id": 129213,
                        "name": "Wibaux",
                        "latitude": "46.98501000",
                        "longitude": "-104.18827000"
                    },
                    {
                        "id": 129214,
                        "name": "Wibaux County",
                        "latitude": "46.96535000",
                        "longitude": "-104.24897000"
                    },
                    {
                        "id": 129415,
                        "name": "Winnett",
                        "latitude": "47.00276000",
                        "longitude": "-108.35207000"
                    },
                    {
                        "id": 129473,
                        "name": "Wolf Point",
                        "latitude": "48.09057000",
                        "longitude": "-105.64056000"
                    },
                    {
                        "id": 129679,
                        "name": "Yellowstone County",
                        "latitude": "45.93725000",
                        "longitude": "-108.27435000"
                    }
                ]
            },
            {
                "id": 1439,
                "name": "Navassa Island",
                "iso2": "UM-76",
                "latitude": "18.41006890",
                "longitude": "-75.01146120",
                "type": "islands \/ groups of islands",
                "cities": []
            },
            {
                "id": 1408,
                "name": "Nebraska",
                "iso2": "NE",
                "latitude": "41.49253740",
                "longitude": "-99.90181310",
                "type": "state",
                "cities": [
                    {
                        "id": 111022,
                        "name": "Adams County",
                        "latitude": "40.52447000",
                        "longitude": "-98.50121000"
                    },
                    {
                        "id": 111069,
                        "name": "Ainsworth",
                        "latitude": "42.55000000",
                        "longitude": "-99.86262000"
                    },
                    {
                        "id": 111127,
                        "name": "Albion",
                        "latitude": "41.69084000",
                        "longitude": "-98.00367000"
                    },
                    {
                        "id": 111200,
                        "name": "Alliance",
                        "latitude": "42.10163000",
                        "longitude": "-102.87215000"
                    },
                    {
                        "id": 111210,
                        "name": "Alma",
                        "latitude": "40.09751000",
                        "longitude": "-99.36204000"
                    },
                    {
                        "id": 111365,
                        "name": "Antelope County",
                        "latitude": "42.17690000",
                        "longitude": "-98.06669000"
                    },
                    {
                        "id": 111413,
                        "name": "Arapahoe",
                        "latitude": "40.30417000",
                        "longitude": "-99.90040000"
                    },
                    {
                        "id": 111467,
                        "name": "Arlington",
                        "latitude": "41.45250000",
                        "longitude": "-96.35113000"
                    },
                    {
                        "id": 111499,
                        "name": "Arthur",
                        "latitude": "41.57165000",
                        "longitude": "-101.69156000"
                    },
                    {
                        "id": 111500,
                        "name": "Arthur County",
                        "latitude": "41.56890000",
                        "longitude": "-101.69591000"
                    },
                    {
                        "id": 111536,
                        "name": "Ashland",
                        "latitude": "41.03916000",
                        "longitude": "-96.36835000"
                    },
                    {
                        "id": 111588,
                        "name": "Atkinson",
                        "latitude": "42.53139000",
                        "longitude": "-98.97815000"
                    },
                    {
                        "id": 111630,
                        "name": "Auburn",
                        "latitude": "40.39278000",
                        "longitude": "-95.83889000"
                    },
                    {
                        "id": 111661,
                        "name": "Aurora",
                        "latitude": "40.86723000",
                        "longitude": "-98.00422000"
                    },
                    {
                        "id": 111800,
                        "name": "Banner County",
                        "latitude": "41.54597000",
                        "longitude": "-103.71048000"
                    },
                    {
                        "id": 111864,
                        "name": "Bartlett",
                        "latitude": "41.88529000",
                        "longitude": "-98.55230000"
                    },
                    {
                        "id": 111882,
                        "name": "Bassett",
                        "latitude": "42.58583000",
                        "longitude": "-99.53789000"
                    },
                    {
                        "id": 111905,
                        "name": "Battle Creek",
                        "latitude": "41.99945000",
                        "longitude": "-97.59839000"
                    },
                    {
                        "id": 111938,
                        "name": "Bayard",
                        "latitude": "41.75497000",
                        "longitude": "-103.32410000"
                    },
                    {
                        "id": 111981,
                        "name": "Beatrice",
                        "latitude": "40.26806000",
                        "longitude": "-96.74697000"
                    },
                    {
                        "id": 111996,
                        "name": "Beaver City",
                        "latitude": "40.13751000",
                        "longitude": "-99.82956000"
                    },
                    {
                        "id": 112113,
                        "name": "Bellevue",
                        "latitude": "41.13667000",
                        "longitude": "-95.89084000"
                    },
                    {
                        "id": 112171,
                        "name": "Benkelman",
                        "latitude": "40.04916000",
                        "longitude": "-101.53294000"
                    },
                    {
                        "id": 112176,
                        "name": "Bennington",
                        "latitude": "41.36472000",
                        "longitude": "-96.15780000"
                    },
                    {
                        "id": 112406,
                        "name": "Blaine County",
                        "latitude": "41.91276000",
                        "longitude": "-99.97690000"
                    },
                    {
                        "id": 112409,
                        "name": "Blair",
                        "latitude": "41.54444000",
                        "longitude": "-96.12502000"
                    },
                    {
                        "id": 112561,
                        "name": "Boone County",
                        "latitude": "41.70678000",
                        "longitude": "-98.06726000"
                    },
                    {
                        "id": 112635,
                        "name": "Box Butte County",
                        "latitude": "42.21977000",
                        "longitude": "-103.08568000"
                    },
                    {
                        "id": 112643,
                        "name": "Boyd County",
                        "latitude": "42.89968000",
                        "longitude": "-98.76646000"
                    },
                    {
                        "id": 112742,
                        "name": "Brewster",
                        "latitude": "41.93889000",
                        "longitude": "-99.86485000"
                    },
                    {
                        "id": 112767,
                        "name": "Bridgeport",
                        "latitude": "41.66525000",
                        "longitude": "-103.09910000"
                    },
                    {
                        "id": 112843,
                        "name": "Broken Bow",
                        "latitude": "41.40195000",
                        "longitude": "-99.63928000"
                    },
                    {
                        "id": 112912,
                        "name": "Brown County",
                        "latitude": "42.43002000",
                        "longitude": "-99.92951000"
                    },
                    {
                        "id": 113018,
                        "name": "Buffalo County",
                        "latitude": "40.85515000",
                        "longitude": "-99.07497000"
                    },
                    {
                        "id": 113095,
                        "name": "Burt County",
                        "latitude": "41.85156000",
                        "longitude": "-96.32860000"
                    },
                    {
                        "id": 113099,
                        "name": "Burwell",
                        "latitude": "41.78167000",
                        "longitude": "-99.13315000"
                    },
                    {
                        "id": 113119,
                        "name": "Butler County",
                        "latitude": "41.22608000",
                        "longitude": "-97.13177000"
                    },
                    {
                        "id": 113122,
                        "name": "Butte",
                        "latitude": "42.91139000",
                        "longitude": "-98.84926000"
                    },
                    {
                        "id": 113256,
                        "name": "Cambridge",
                        "latitude": "40.28195000",
                        "longitude": "-100.16569000"
                    },
                    {
                        "id": 113534,
                        "name": "Cass County",
                        "latitude": "40.90972000",
                        "longitude": "-96.14087000"
                    },
                    {
                        "id": 113606,
                        "name": "Cedar County",
                        "latitude": "42.59926000",
                        "longitude": "-97.25240000"
                    },
                    {
                        "id": 113637,
                        "name": "Center",
                        "latitude": "42.60945000",
                        "longitude": "-97.87673000"
                    },
                    {
                        "id": 113669,
                        "name": "Central City",
                        "latitude": "41.11585000",
                        "longitude": "-98.00172000"
                    },
                    {
                        "id": 113707,
                        "name": "Chadron",
                        "latitude": "42.82942000",
                        "longitude": "-102.99991000"
                    },
                    {
                        "id": 113711,
                        "name": "Chalco",
                        "latitude": "41.18389000",
                        "longitude": "-96.15030000"
                    },
                    {
                        "id": 113747,
                        "name": "Chappell",
                        "latitude": "41.09277000",
                        "longitude": "-102.47074000"
                    },
                    {
                        "id": 113793,
                        "name": "Chase County",
                        "latitude": "40.52420000",
                        "longitude": "-101.69795000"
                    },
                    {
                        "id": 113858,
                        "name": "Cherry County",
                        "latitude": "42.54493000",
                        "longitude": "-101.11858000"
                    },
                    {
                        "id": 113929,
                        "name": "Cheyenne County",
                        "latitude": "41.21978000",
                        "longitude": "-102.99498000"
                    },
                    {
                        "id": 114171,
                        "name": "Clay Center",
                        "latitude": "40.52168000",
                        "longitude": "-98.05533000"
                    },
                    {
                        "id": 114189,
                        "name": "Clay County",
                        "latitude": "40.52443000",
                        "longitude": "-98.05128000"
                    },
                    {
                        "id": 114410,
                        "name": "Colfax County",
                        "latitude": "41.57402000",
                        "longitude": "-97.08646000"
                    },
                    {
                        "id": 114496,
                        "name": "Columbus",
                        "latitude": "41.42973000",
                        "longitude": "-97.36838000"
                    },
                    {
                        "id": 114752,
                        "name": "Cozad",
                        "latitude": "40.85973000",
                        "longitude": "-99.98734000"
                    },
                    {
                        "id": 114790,
                        "name": "Creighton",
                        "latitude": "42.46667000",
                        "longitude": "-97.90618000"
                    },
                    {
                        "id": 114815,
                        "name": "Crete",
                        "latitude": "40.62778000",
                        "longitude": "-96.96142000"
                    },
                    {
                        "id": 114922,
                        "name": "Cuming County",
                        "latitude": "41.91640000",
                        "longitude": "-96.78740000"
                    },
                    {
                        "id": 114936,
                        "name": "Custer County",
                        "latitude": "41.39426000",
                        "longitude": "-99.72614000"
                    },
                    {
                        "id": 114975,
                        "name": "Dakota City",
                        "latitude": "42.41555000",
                        "longitude": "-96.41836000"
                    },
                    {
                        "id": 114977,
                        "name": "Dakota County",
                        "latitude": "42.39111000",
                        "longitude": "-96.56451000"
                    },
                    {
                        "id": 115061,
                        "name": "David City",
                        "latitude": "41.25279000",
                        "longitude": "-97.13004000"
                    },
                    {
                        "id": 115080,
                        "name": "Dawes County",
                        "latitude": "42.71972000",
                        "longitude": "-103.13544000"
                    },
                    {
                        "id": 115084,
                        "name": "Dawson County",
                        "latitude": "40.86994000",
                        "longitude": "-99.81957000"
                    },
                    {
                        "id": 115295,
                        "name": "Deuel County",
                        "latitude": "41.11160000",
                        "longitude": "-102.33395000"
                    },
                    {
                        "id": 115368,
                        "name": "Dixon County",
                        "latitude": "42.49319000",
                        "longitude": "-96.86775000"
                    },
                    {
                        "id": 115379,
                        "name": "Dodge County",
                        "latitude": "41.57789000",
                        "longitude": "-96.65398000"
                    },
                    {
                        "id": 115430,
                        "name": "Douglas County",
                        "latitude": "41.29535000",
                        "longitude": "-96.15448000"
                    },
                    {
                        "id": 115532,
                        "name": "Dundy County",
                        "latitude": "40.17624000",
                        "longitude": "-101.68796000"
                    },
                    {
                        "id": 115595,
                        "name": "Eagle",
                        "latitude": "40.81667000",
                        "longitude": "-96.43029000"
                    },
                    {
                        "id": 116001,
                        "name": "Elkhorn",
                        "latitude": "41.28639000",
                        "longitude": "-96.23447000"
                    },
                    {
                        "id": 116081,
                        "name": "Elwood",
                        "latitude": "40.59028000",
                        "longitude": "-99.86095000"
                    },
                    {
                        "id": 116295,
                        "name": "Fairbury",
                        "latitude": "40.13722000",
                        "longitude": "-97.18059000"
                    },
                    {
                        "id": 116381,
                        "name": "Falls City",
                        "latitude": "40.06084000",
                        "longitude": "-95.60193000"
                    },
                    {
                        "id": 116511,
                        "name": "Fillmore County",
                        "latitude": "40.52467000",
                        "longitude": "-97.59650000"
                    },
                    {
                        "id": 116839,
                        "name": "Franklin",
                        "latitude": "40.09612000",
                        "longitude": "-98.95258000"
                    },
                    {
                        "id": 116860,
                        "name": "Franklin County",
                        "latitude": "40.17634000",
                        "longitude": "-98.95280000"
                    },
                    {
                        "id": 116923,
                        "name": "Fremont",
                        "latitude": "41.43333000",
                        "longitude": "-96.49808000"
                    },
                    {
                        "id": 116946,
                        "name": "Friend",
                        "latitude": "40.65362000",
                        "longitude": "-97.28616000"
                    },
                    {
                        "id": 116963,
                        "name": "Frontier County",
                        "latitude": "40.53008000",
                        "longitude": "-100.39420000"
                    },
                    {
                        "id": 116981,
                        "name": "Fullerton",
                        "latitude": "41.36335000",
                        "longitude": "-97.96923000"
                    },
                    {
                        "id": 117001,
                        "name": "Furnas County",
                        "latitude": "40.17647000",
                        "longitude": "-99.91227000"
                    },
                    {
                        "id": 117008,
                        "name": "Gage County",
                        "latitude": "40.26193000",
                        "longitude": "-96.68944000"
                    },
                    {
                        "id": 117064,
                        "name": "Garden County",
                        "latitude": "41.61943000",
                        "longitude": "-102.33544000"
                    },
                    {
                        "id": 117083,
                        "name": "Garfield County",
                        "latitude": "41.91436000",
                        "longitude": "-98.99139000"
                    },
                    {
                        "id": 117143,
                        "name": "Geneva",
                        "latitude": "40.52695000",
                        "longitude": "-97.59588000"
                    },
                    {
                        "id": 117170,
                        "name": "Gering",
                        "latitude": "41.82580000",
                        "longitude": "-103.66050000"
                    },
                    {
                        "id": 117182,
                        "name": "Gibbon",
                        "latitude": "40.74835000",
                        "longitude": "-98.84480000"
                    },
                    {
                        "id": 117397,
                        "name": "Gordon",
                        "latitude": "42.80472000",
                        "longitude": "-102.20322000"
                    },
                    {
                        "id": 117413,
                        "name": "Gosper County",
                        "latitude": "40.51482000",
                        "longitude": "-99.83070000"
                    },
                    {
                        "id": 117415,
                        "name": "Gothenburg",
                        "latitude": "40.92945000",
                        "longitude": "-100.16068000"
                    },
                    {
                        "id": 117461,
                        "name": "Grand Island",
                        "latitude": "40.92501000",
                        "longitude": "-98.34201000"
                    },
                    {
                        "id": 117505,
                        "name": "Grant",
                        "latitude": "40.84194000",
                        "longitude": "-101.72517000"
                    },
                    {
                        "id": 117519,
                        "name": "Grant County",
                        "latitude": "41.91499000",
                        "longitude": "-101.74052000"
                    },
                    {
                        "id": 117585,
                        "name": "Greeley",
                        "latitude": "41.54862000",
                        "longitude": "-98.53118000"
                    },
                    {
                        "id": 117587,
                        "name": "Greeley County",
                        "latitude": "41.56744000",
                        "longitude": "-98.52124000"
                    },
                    {
                        "id": 117727,
                        "name": "Gretna",
                        "latitude": "41.14083000",
                        "longitude": "-96.23974000"
                    },
                    {
                        "id": 117865,
                        "name": "Hall County",
                        "latitude": "40.87257000",
                        "longitude": "-98.50217000"
                    },
                    {
                        "id": 117902,
                        "name": "Hamilton County",
                        "latitude": "40.87356000",
                        "longitude": "-98.02323000"
                    },
                    {
                        "id": 118019,
                        "name": "Harlan County",
                        "latitude": "40.17650000",
                        "longitude": "-99.40464000"
                    },
                    {
                        "id": 118052,
                        "name": "Harrisburg",
                        "latitude": "41.55636000",
                        "longitude": "-103.73856000"
                    },
                    {
                        "id": 118060,
                        "name": "Harrison",
                        "latitude": "42.68719000",
                        "longitude": "-103.88271000"
                    },
                    {
                        "id": 118096,
                        "name": "Hartington",
                        "latitude": "42.62250000",
                        "longitude": "-97.26450000"
                    },
                    {
                        "id": 118133,
                        "name": "Hastings",
                        "latitude": "40.58612000",
                        "longitude": "-98.38839000"
                    },
                    {
                        "id": 118180,
                        "name": "Hayes Center",
                        "latitude": "40.51084000",
                        "longitude": "-101.01960000"
                    },
                    {
                        "id": 118181,
                        "name": "Hayes County",
                        "latitude": "40.52478000",
                        "longitude": "-101.06184000"
                    },
                    {
                        "id": 118238,
                        "name": "Hebron",
                        "latitude": "40.16639000",
                        "longitude": "-97.58588000"
                    },
                    {
                        "id": 118362,
                        "name": "Hickman",
                        "latitude": "40.62000000",
                        "longitude": "-96.62918000"
                    },
                    {
                        "id": 118493,
                        "name": "Hitchcock County",
                        "latitude": "40.17635000",
                        "longitude": "-101.04227000"
                    },
                    {
                        "id": 118528,
                        "name": "Holdrege",
                        "latitude": "40.44029000",
                        "longitude": "-99.36982000"
                    },
                    {
                        "id": 118577,
                        "name": "Holt County",
                        "latitude": "42.45571000",
                        "longitude": "-98.78384000"
                    },
                    {
                        "id": 118629,
                        "name": "Hooker County",
                        "latitude": "41.91591000",
                        "longitude": "-101.13533000"
                    },
                    {
                        "id": 118717,
                        "name": "Howard County",
                        "latitude": "41.22004000",
                        "longitude": "-98.51709000"
                    },
                    {
                        "id": 118843,
                        "name": "Hyannis",
                        "latitude": "42.00054000",
                        "longitude": "-101.76184000"
                    },
                    {
                        "id": 118884,
                        "name": "Imperial",
                        "latitude": "40.51694000",
                        "longitude": "-101.64323000"
                    },
                    {
                        "id": 119190,
                        "name": "Jefferson County",
                        "latitude": "40.17576000",
                        "longitude": "-97.14272000"
                    },
                    {
                        "id": 119270,
                        "name": "Johnson County",
                        "latitude": "40.39263000",
                        "longitude": "-96.26510000"
                    },
                    {
                        "id": 119408,
                        "name": "Kearney",
                        "latitude": "40.69946000",
                        "longitude": "-99.08148000"
                    },
                    {
                        "id": 119409,
                        "name": "Kearney County",
                        "latitude": "40.50671000",
                        "longitude": "-98.94802000"
                    },
                    {
                        "id": 119425,
                        "name": "Keith County",
                        "latitude": "41.19879000",
                        "longitude": "-101.66135000"
                    },
                    {
                        "id": 119542,
                        "name": "Keya Paha County",
                        "latitude": "42.87883000",
                        "longitude": "-99.71235000"
                    },
                    {
                        "id": 119566,
                        "name": "Kimball",
                        "latitude": "41.23581000",
                        "longitude": "-103.66300000"
                    },
                    {
                        "id": 119567,
                        "name": "Kimball County",
                        "latitude": "41.19766000",
                        "longitude": "-103.71495000"
                    },
                    {
                        "id": 119692,
                        "name": "Knox County",
                        "latitude": "42.63678000",
                        "longitude": "-97.89190000"
                    },
                    {
                        "id": 119796,
                        "name": "La Vista",
                        "latitude": "41.18389000",
                        "longitude": "-96.03113000"
                    },
                    {
                        "id": 120092,
                        "name": "Lancaster County",
                        "latitude": "40.78417000",
                        "longitude": "-96.68776000"
                    },
                    {
                        "id": 120452,
                        "name": "Lexington",
                        "latitude": "40.78084000",
                        "longitude": "-99.74150000"
                    },
                    {
                        "id": 120506,
                        "name": "Lincoln",
                        "latitude": "40.80000000",
                        "longitude": "-96.66696000"
                    },
                    {
                        "id": 120535,
                        "name": "Lincoln County",
                        "latitude": "41.04777000",
                        "longitude": "-100.74523000"
                    },
                    {
                        "id": 120704,
                        "name": "Logan County",
                        "latitude": "41.56649000",
                        "longitude": "-100.48286000"
                    },
                    {
                        "id": 120816,
                        "name": "Louisville",
                        "latitude": "40.99778000",
                        "longitude": "-96.16224000"
                    },
                    {
                        "id": 120818,
                        "name": "Loup City",
                        "latitude": "41.27557000",
                        "longitude": "-98.96675000"
                    },
                    {
                        "id": 120819,
                        "name": "Loup County",
                        "latitude": "41.91385000",
                        "longitude": "-99.45442000"
                    },
                    {
                        "id": 120975,
                        "name": "Macy",
                        "latitude": "42.11305000",
                        "longitude": "-96.35642000"
                    },
                    {
                        "id": 120997,
                        "name": "Madison",
                        "latitude": "41.82834000",
                        "longitude": "-97.45505000"
                    },
                    {
                        "id": 121016,
                        "name": "Madison County",
                        "latitude": "41.91670000",
                        "longitude": "-97.60078000"
                    },
                    {
                        "id": 121479,
                        "name": "McCook",
                        "latitude": "40.20195000",
                        "longitude": "-100.62571000"
                    },
                    {
                        "id": 121548,
                        "name": "McPherson County",
                        "latitude": "41.56808000",
                        "longitude": "-101.06053000"
                    },
                    {
                        "id": 121705,
                        "name": "Merrick County",
                        "latitude": "41.16982000",
                        "longitude": "-98.03765000"
                    },
                    {
                        "id": 121855,
                        "name": "Milford",
                        "latitude": "40.77445000",
                        "longitude": "-97.05059000"
                    },
                    {
                        "id": 121929,
                        "name": "Minden",
                        "latitude": "40.49863000",
                        "longitude": "-98.94786000"
                    },
                    {
                        "id": 121998,
                        "name": "Mitchell",
                        "latitude": "41.94024000",
                        "longitude": "-103.80856000"
                    },
                    {
                        "id": 122263,
                        "name": "Morrill County",
                        "latitude": "41.71600000",
                        "longitude": "-103.01055000"
                    },
                    {
                        "id": 122459,
                        "name": "Mullen",
                        "latitude": "42.04278000",
                        "longitude": "-101.04266000"
                    },
                    {
                        "id": 122540,
                        "name": "Nance County",
                        "latitude": "41.39730000",
                        "longitude": "-97.99225000"
                    },
                    {
                        "id": 122609,
                        "name": "Nebraska City",
                        "latitude": "40.67667000",
                        "longitude": "-95.85917000"
                    },
                    {
                        "id": 122620,
                        "name": "Neligh",
                        "latitude": "42.12862000",
                        "longitude": "-98.02979000"
                    },
                    {
                        "id": 122625,
                        "name": "Nelson",
                        "latitude": "40.20168000",
                        "longitude": "-98.06782000"
                    },
                    {
                        "id": 122630,
                        "name": "Nemaha County",
                        "latitude": "40.38765000",
                        "longitude": "-95.84982000"
                    },
                    {
                        "id": 122943,
                        "name": "Norfolk",
                        "latitude": "42.02834000",
                        "longitude": "-97.41700000"
                    },
                    {
                        "id": 122983,
                        "name": "North Bend",
                        "latitude": "41.46195000",
                        "longitude": "-96.77975000"
                    },
                    {
                        "id": 123082,
                        "name": "North Platte",
                        "latitude": "41.12389000",
                        "longitude": "-100.76542000"
                    },
                    {
                        "id": 123214,
                        "name": "Nuckolls County",
                        "latitude": "40.17638000",
                        "longitude": "-98.04718000"
                    },
                    {
                        "id": 123228,
                        "name": "O'Neill",
                        "latitude": "42.45778000",
                        "longitude": "-98.64759000"
                    },
                    {
                        "id": 123291,
                        "name": "Oakland",
                        "latitude": "41.83583000",
                        "longitude": "-96.46697000"
                    },
                    {
                        "id": 123364,
                        "name": "Offutt Air Force Base",
                        "latitude": "41.12024000",
                        "longitude": "-95.92095000"
                    },
                    {
                        "id": 123365,
                        "name": "Ogallala",
                        "latitude": "41.12805000",
                        "longitude": "-101.71962000"
                    },
                    {
                        "id": 123463,
                        "name": "Omaha",
                        "latitude": "41.25626000",
                        "longitude": "-95.94043000"
                    },
                    {
                        "id": 123542,
                        "name": "Ord",
                        "latitude": "41.60334000",
                        "longitude": "-98.92620000"
                    },
                    {
                        "id": 123601,
                        "name": "Osceola",
                        "latitude": "41.17974000",
                        "longitude": "-97.54755000"
                    },
                    {
                        "id": 123610,
                        "name": "Oshkosh",
                        "latitude": "41.40498000",
                        "longitude": "-102.34436000"
                    },
                    {
                        "id": 123631,
                        "name": "Otoe County",
                        "latitude": "40.64850000",
                        "longitude": "-96.13478000"
                    },
                    {
                        "id": 123814,
                        "name": "Papillion",
                        "latitude": "41.15444000",
                        "longitude": "-96.04224000"
                    },
                    {
                        "id": 123935,
                        "name": "Pawnee City",
                        "latitude": "40.10833000",
                        "longitude": "-96.15445000"
                    },
                    {
                        "id": 123938,
                        "name": "Pawnee County",
                        "latitude": "40.13154000",
                        "longitude": "-96.23706000"
                    },
                    {
                        "id": 124014,
                        "name": "Pender",
                        "latitude": "42.11416000",
                        "longitude": "-96.70726000"
                    },
                    {
                        "id": 124063,
                        "name": "Perkins County",
                        "latitude": "40.85094000",
                        "longitude": "-101.64961000"
                    },
                    {
                        "id": 124122,
                        "name": "Phelps County",
                        "latitude": "40.51111000",
                        "longitude": "-99.41454000"
                    },
                    {
                        "id": 124169,
                        "name": "Pierce",
                        "latitude": "42.19917000",
                        "longitude": "-97.52672000"
                    },
                    {
                        "id": 124172,
                        "name": "Pierce County",
                        "latitude": "42.26437000",
                        "longitude": "-97.60129000"
                    },
                    {
                        "id": 124329,
                        "name": "Plainview",
                        "latitude": "42.34973000",
                        "longitude": "-97.79201000"
                    },
                    {
                        "id": 124354,
                        "name": "Platte County",
                        "latitude": "41.57129000",
                        "longitude": "-97.52116000"
                    },
                    {
                        "id": 124362,
                        "name": "Plattsmouth",
                        "latitude": "41.01139000",
                        "longitude": "-95.88223000"
                    },
                    {
                        "id": 124449,
                        "name": "Polk County",
                        "latitude": "41.18690000",
                        "longitude": "-97.56842000"
                    },
                    {
                        "id": 124463,
                        "name": "Ponca",
                        "latitude": "42.56250000",
                        "longitude": "-96.70559000"
                    },
                    {
                        "id": 124836,
                        "name": "Ralston",
                        "latitude": "41.20528000",
                        "longitude": "-96.04252000"
                    },
                    {
                        "id": 124908,
                        "name": "Ravenna",
                        "latitude": "41.02612000",
                        "longitude": "-98.91258000"
                    },
                    {
                        "id": 124944,
                        "name": "Red Cloud",
                        "latitude": "40.08890000",
                        "longitude": "-98.51950000"
                    },
                    {
                        "id": 124962,
                        "name": "Red Willow County",
                        "latitude": "40.17583000",
                        "longitude": "-100.47686000"
                    },
                    {
                        "id": 125059,
                        "name": "Richardson County",
                        "latitude": "40.12506000",
                        "longitude": "-95.71753000"
                    },
                    {
                        "id": 125273,
                        "name": "Rock County",
                        "latitude": "42.42129000",
                        "longitude": "-99.44993000"
                    },
                    {
                        "id": 125527,
                        "name": "Rushville",
                        "latitude": "42.71832000",
                        "longitude": "-102.46406000"
                    },
                    {
                        "id": 125704,
                        "name": "Saint Paul",
                        "latitude": "41.21473000",
                        "longitude": "-98.45812000"
                    },
                    {
                        "id": 125753,
                        "name": "Saline County",
                        "latitude": "40.52406000",
                        "longitude": "-97.14091000"
                    },
                    {
                        "id": 125952,
                        "name": "Sarpy County",
                        "latitude": "41.11293000",
                        "longitude": "-96.11199000"
                    },
                    {
                        "id": 125969,
                        "name": "Saunders County",
                        "latitude": "41.22637000",
                        "longitude": "-96.63740000"
                    },
                    {
                        "id": 126021,
                        "name": "Schuyler",
                        "latitude": "41.44723000",
                        "longitude": "-97.05948000"
                    },
                    {
                        "id": 126057,
                        "name": "Scotts Bluff County",
                        "latitude": "41.85061000",
                        "longitude": "-103.70795000"
                    },
                    {
                        "id": 126060,
                        "name": "Scottsbluff",
                        "latitude": "41.86663000",
                        "longitude": "-103.66717000"
                    },
                    {
                        "id": 126186,
                        "name": "Seward",
                        "latitude": "40.90695000",
                        "longitude": "-97.09892000"
                    },
                    {
                        "id": 126188,
                        "name": "Seward County",
                        "latitude": "40.87239000",
                        "longitude": "-97.13951000"
                    },
                    {
                        "id": 126298,
                        "name": "Shelton",
                        "latitude": "40.77918000",
                        "longitude": "-98.73091000"
                    },
                    {
                        "id": 126327,
                        "name": "Sheridan County",
                        "latitude": "42.50477000",
                        "longitude": "-102.40896000"
                    },
                    {
                        "id": 126332,
                        "name": "Sherman County",
                        "latitude": "41.22059000",
                        "longitude": "-98.97621000"
                    },
                    {
                        "id": 126398,
                        "name": "Sidney",
                        "latitude": "41.14276000",
                        "longitude": "-102.97798000"
                    },
                    {
                        "id": 126461,
                        "name": "Sioux County",
                        "latitude": "42.48771000",
                        "longitude": "-103.75888000"
                    },
                    {
                        "id": 126730,
                        "name": "South Sioux City",
                        "latitude": "42.47388000",
                        "longitude": "-96.41364000"
                    },
                    {
                        "id": 126899,
                        "name": "Springfield",
                        "latitude": "41.08194000",
                        "longitude": "-96.13446000"
                    },
                    {
                        "id": 126913,
                        "name": "Springview",
                        "latitude": "42.82444000",
                        "longitude": "-99.74901000"
                    },
                    {
                        "id": 126968,
                        "name": "Stanton",
                        "latitude": "41.95028000",
                        "longitude": "-97.22393000"
                    },
                    {
                        "id": 126972,
                        "name": "Stanton County",
                        "latitude": "41.91692000",
                        "longitude": "-97.19392000"
                    },
                    {
                        "id": 126977,
                        "name": "Stapleton",
                        "latitude": "41.48028000",
                        "longitude": "-100.51292000"
                    },
                    {
                        "id": 127076,
                        "name": "Stockville",
                        "latitude": "40.53279000",
                        "longitude": "-100.38348000"
                    },
                    {
                        "id": 127137,
                        "name": "Stromsburg",
                        "latitude": "41.11418000",
                        "longitude": "-97.59894000"
                    },
                    {
                        "id": 127278,
                        "name": "Superior",
                        "latitude": "40.02085000",
                        "longitude": "-98.07004000"
                    },
                    {
                        "id": 127306,
                        "name": "Sutherland",
                        "latitude": "41.15694000",
                        "longitude": "-101.12627000"
                    },
                    {
                        "id": 127314,
                        "name": "Sutton",
                        "latitude": "40.60557000",
                        "longitude": "-97.85921000"
                    },
                    {
                        "id": 127364,
                        "name": "Syracuse",
                        "latitude": "40.65722000",
                        "longitude": "-96.18640000"
                    },
                    {
                        "id": 127448,
                        "name": "Taylor",
                        "latitude": "41.77028000",
                        "longitude": "-99.37872000"
                    },
                    {
                        "id": 127480,
                        "name": "Tecumseh",
                        "latitude": "40.36667000",
                        "longitude": "-96.19612000"
                    },
                    {
                        "id": 127485,
                        "name": "Tekamah",
                        "latitude": "41.77832000",
                        "longitude": "-96.22113000"
                    },
                    {
                        "id": 127534,
                        "name": "Terrytown",
                        "latitude": "41.84747000",
                        "longitude": "-103.66161000"
                    },
                    {
                        "id": 127552,
                        "name": "Thayer County",
                        "latitude": "40.17629000",
                        "longitude": "-97.59492000"
                    },
                    {
                        "id": 127567,
                        "name": "Thedford",
                        "latitude": "41.97833000",
                        "longitude": "-100.57625000"
                    },
                    {
                        "id": 127581,
                        "name": "Thomas County",
                        "latitude": "41.91351000",
                        "longitude": "-100.55585000"
                    },
                    {
                        "id": 127630,
                        "name": "Thurston County",
                        "latitude": "42.15819000",
                        "longitude": "-96.54410000"
                    },
                    {
                        "id": 127810,
                        "name": "Trenton",
                        "latitude": "40.17555000",
                        "longitude": "-101.01294000"
                    },
                    {
                        "id": 127863,
                        "name": "Tryon",
                        "latitude": "41.55277000",
                        "longitude": "-100.95765000"
                    },
                    {
                        "id": 128091,
                        "name": "Valentine",
                        "latitude": "42.87278000",
                        "longitude": "-100.55097000"
                    },
                    {
                        "id": 128098,
                        "name": "Valley",
                        "latitude": "41.31278000",
                        "longitude": "-96.34614000"
                    },
                    {
                        "id": 128103,
                        "name": "Valley County",
                        "latitude": "41.56731000",
                        "longitude": "-98.98190000"
                    },
                    {
                        "id": 128334,
                        "name": "Wahoo",
                        "latitude": "41.21139000",
                        "longitude": "-96.62030000"
                    },
                    {
                        "id": 128362,
                        "name": "Wakefield",
                        "latitude": "42.26917000",
                        "longitude": "-96.86504000"
                    },
                    {
                        "id": 128571,
                        "name": "Washington County",
                        "latitude": "41.53104000",
                        "longitude": "-96.22203000"
                    },
                    {
                        "id": 128614,
                        "name": "Waterloo",
                        "latitude": "41.28694000",
                        "longitude": "-96.28558000"
                    },
                    {
                        "id": 128671,
                        "name": "Waverly",
                        "latitude": "40.91750000",
                        "longitude": "-96.52834000"
                    },
                    {
                        "id": 128686,
                        "name": "Wayne",
                        "latitude": "42.23056000",
                        "longitude": "-97.01782000"
                    },
                    {
                        "id": 128700,
                        "name": "Wayne County",
                        "latitude": "42.20929000",
                        "longitude": "-97.11926000"
                    },
                    {
                        "id": 128742,
                        "name": "Webster County",
                        "latitude": "40.17643000",
                        "longitude": "-98.49995000"
                    },
                    {
                        "id": 128756,
                        "name": "Weeping Water",
                        "latitude": "40.87000000",
                        "longitude": "-96.14057000"
                    },
                    {
                        "id": 128961,
                        "name": "West Point",
                        "latitude": "41.84167000",
                        "longitude": "-96.70864000"
                    },
                    {
                        "id": 129117,
                        "name": "Wheeler County",
                        "latitude": "41.91477000",
                        "longitude": "-98.52819000"
                    },
                    {
                        "id": 129225,
                        "name": "Wilber",
                        "latitude": "40.48139000",
                        "longitude": "-96.96058000"
                    },
                    {
                        "id": 129462,
                        "name": "Wisner",
                        "latitude": "41.98722000",
                        "longitude": "-96.91421000"
                    },
                    {
                        "id": 129489,
                        "name": "Wood River",
                        "latitude": "40.82057000",
                        "longitude": "-98.60007000"
                    },
                    {
                        "id": 129627,
                        "name": "Wymore",
                        "latitude": "40.12222000",
                        "longitude": "-96.66252000"
                    },
                    {
                        "id": 129693,
                        "name": "York",
                        "latitude": "40.86807000",
                        "longitude": "-97.59200000"
                    },
                    {
                        "id": 129698,
                        "name": "York County",
                        "latitude": "40.87275000",
                        "longitude": "-97.59711000"
                    },
                    {
                        "id": 129737,
                        "name": "Yutan",
                        "latitude": "41.24500000",
                        "longitude": "-96.39725000"
                    }
                ]
            },
            {
                "id": 1458,
                "name": "Nevada",
                "iso2": "NV",
                "latitude": "38.80260970",
                "longitude": "-116.41938900",
                "type": "state",
                "cities": [
                    {
                        "id": 111095,
                        "name": "Alamo",
                        "latitude": "37.36496000",
                        "longitude": "-115.16446000"
                    },
                    {
                        "id": 111908,
                        "name": "Battle Mountain",
                        "latitude": "40.64213000",
                        "longitude": "-116.93427000"
                    },
                    {
                        "id": 111982,
                        "name": "Beatty",
                        "latitude": "36.90856000",
                        "longitude": "-116.75923000"
                    },
                    {
                        "id": 112602,
                        "name": "Boulder City",
                        "latitude": "35.97859000",
                        "longitude": "-114.83249000"
                    },
                    {
                        "id": 113043,
                        "name": "Bunkerville",
                        "latitude": "36.77303000",
                        "longitude": "-114.12802000"
                    },
                    {
                        "id": 113213,
                        "name": "Caliente",
                        "latitude": "37.61496000",
                        "longitude": "-114.51194000"
                    },
                    {
                        "id": 113399,
                        "name": "Carlin",
                        "latitude": "40.71381000",
                        "longitude": "-116.10397000"
                    },
                    {
                        "id": 113478,
                        "name": "Carson City",
                        "latitude": "39.16380000",
                        "longitude": "-119.76740000"
                    },
                    {
                        "id": 114012,
                        "name": "Churchill County",
                        "latitude": "39.58088000",
                        "longitude": "-118.33578000"
                    },
                    {
                        "id": 114129,
                        "name": "Clark County",
                        "latitude": "36.21520000",
                        "longitude": "-115.01356000"
                    },
                    {
                        "id": 114389,
                        "name": "Cold Springs",
                        "latitude": "39.68019000",
                        "longitude": "-119.97659000"
                    },
                    {
                        "id": 115098,
                        "name": "Dayton",
                        "latitude": "39.23714000",
                        "longitude": "-119.59295000"
                    },
                    {
                        "id": 115434,
                        "name": "Douglas County",
                        "latitude": "38.91224000",
                        "longitude": "-119.61637000"
                    },
                    {
                        "id": 115768,
                        "name": "East Valley",
                        "latitude": "38.94340000",
                        "longitude": "-119.69923000"
                    },
                    {
                        "id": 116008,
                        "name": "Elko",
                        "latitude": "40.83242000",
                        "longitude": "-115.76312000"
                    },
                    {
                        "id": 116009,
                        "name": "Elko County",
                        "latitude": "41.14583000",
                        "longitude": "-115.35776000"
                    },
                    {
                        "id": 116086,
                        "name": "Ely",
                        "latitude": "39.24744000",
                        "longitude": "-114.88863000"
                    },
                    {
                        "id": 116149,
                        "name": "Enterprise",
                        "latitude": "36.02525000",
                        "longitude": "-115.24194000"
                    },
                    {
                        "id": 116186,
                        "name": "Esmeralda County",
                        "latitude": "37.78470000",
                        "longitude": "-117.63237000"
                    },
                    {
                        "id": 116237,
                        "name": "Eureka",
                        "latitude": "39.51271000",
                        "longitude": "-115.96061000"
                    },
                    {
                        "id": 116238,
                        "name": "Eureka County",
                        "latitude": "39.98389000",
                        "longitude": "-116.26856000"
                    },
                    {
                        "id": 116378,
                        "name": "Fallon",
                        "latitude": "39.47353000",
                        "longitude": "-118.77737000"
                    },
                    {
                        "id": 116491,
                        "name": "Fernley",
                        "latitude": "39.60797000",
                        "longitude": "-119.25183000"
                    },
                    {
                        "id": 117078,
                        "name": "Gardnerville",
                        "latitude": "38.94130000",
                        "longitude": "-119.74962000"
                    },
                    {
                        "id": 117079,
                        "name": "Gardnerville Ranchos",
                        "latitude": "38.88824000",
                        "longitude": "-119.74129000"
                    },
                    {
                        "id": 117357,
                        "name": "Golden Valley",
                        "latitude": "39.61547000",
                        "longitude": "-119.82658000"
                    },
                    {
                        "id": 117363,
                        "name": "Goldfield",
                        "latitude": "37.70854000",
                        "longitude": "-117.23563000"
                    },
                    {
                        "id": 118176,
                        "name": "Hawthorne",
                        "latitude": "38.52464000",
                        "longitude": "-118.62458000"
                    },
                    {
                        "id": 118278,
                        "name": "Henderson",
                        "latitude": "36.03970000",
                        "longitude": "-114.98194000"
                    },
                    {
                        "id": 118780,
                        "name": "Humboldt County",
                        "latitude": "41.40684000",
                        "longitude": "-118.11197000"
                    },
                    {
                        "id": 118888,
                        "name": "Incline Village",
                        "latitude": "39.25130000",
                        "longitude": "-119.97297000"
                    },
                    {
                        "id": 118909,
                        "name": "Indian Hills",
                        "latitude": "39.08602000",
                        "longitude": "-119.78407000"
                    },
                    {
                        "id": 119057,
                        "name": "Jackpot",
                        "latitude": "41.98324000",
                        "longitude": "-114.67476000"
                    },
                    {
                        "id": 119273,
                        "name": "Johnson Lane",
                        "latitude": "39.04796000",
                        "longitude": "-119.72212000"
                    },
                    {
                        "id": 119610,
                        "name": "Kingsbury",
                        "latitude": "38.97713000",
                        "longitude": "-119.90685000"
                    },
                    {
                        "id": 120097,
                        "name": "Lander County",
                        "latitude": "39.93381000",
                        "longitude": "-117.03791000"
                    },
                    {
                        "id": 120163,
                        "name": "Las Vegas",
                        "latitude": "36.17497000",
                        "longitude": "-115.13722000"
                    },
                    {
                        "id": 120185,
                        "name": "Laughlin",
                        "latitude": "35.16778000",
                        "longitude": "-114.57302000"
                    },
                    {
                        "id": 120358,
                        "name": "Lemmon Valley",
                        "latitude": "39.63602000",
                        "longitude": "-119.84325000"
                    },
                    {
                        "id": 120532,
                        "name": "Lincoln County",
                        "latitude": "37.64335000",
                        "longitude": "-114.87755000"
                    },
                    {
                        "id": 120825,
                        "name": "Lovelock",
                        "latitude": "40.17935000",
                        "longitude": "-118.47348000"
                    },
                    {
                        "id": 120939,
                        "name": "Lyon County",
                        "latitude": "39.02040000",
                        "longitude": "-119.18920000"
                    },
                    {
                        "id": 121502,
                        "name": "McGill",
                        "latitude": "39.40494000",
                        "longitude": "-114.77863000"
                    },
                    {
                        "id": 121727,
                        "name": "Mesquite",
                        "latitude": "36.80553000",
                        "longitude": "-114.06719000"
                    },
                    {
                        "id": 121930,
                        "name": "Minden",
                        "latitude": "38.95407000",
                        "longitude": "-119.76573000"
                    },
                    {
                        "id": 121936,
                        "name": "Mineral County",
                        "latitude": "38.53881000",
                        "longitude": "-118.43521000"
                    },
                    {
                        "id": 122007,
                        "name": "Moapa Town",
                        "latitude": "36.68219000",
                        "longitude": "-114.59416000"
                    },
                    {
                        "id": 122008,
                        "name": "Moapa Valley",
                        "latitude": "36.58053000",
                        "longitude": "-114.47026000"
                    },
                    {
                        "id": 122017,
                        "name": "Mogul",
                        "latitude": "39.51380000",
                        "longitude": "-119.92603000"
                    },
                    {
                        "id": 122622,
                        "name": "Nellis Air Force Base",
                        "latitude": "36.24607000",
                        "longitude": "-115.05721000"
                    },
                    {
                        "id": 123052,
                        "name": "North Las Vegas",
                        "latitude": "36.19886000",
                        "longitude": "-115.11750000"
                    },
                    {
                        "id": 123222,
                        "name": "Nye County",
                        "latitude": "38.04238000",
                        "longitude": "-116.47193000"
                    },
                    {
                        "id": 123724,
                        "name": "Pahrump",
                        "latitude": "36.20829000",
                        "longitude": "-115.98391000"
                    },
                    {
                        "id": 123819,
                        "name": "Paradise",
                        "latitude": "36.09719000",
                        "longitude": "-115.14666000"
                    },
                    {
                        "id": 124091,
                        "name": "Pershing County",
                        "latitude": "40.44036000",
                        "longitude": "-118.40444000"
                    },
                    {
                        "id": 124273,
                        "name": "Pioche",
                        "latitude": "37.92969000",
                        "longitude": "-114.45221000"
                    },
                    {
                        "id": 125020,
                        "name": "Reno",
                        "latitude": "39.52963000",
                        "longitude": "-119.81380000"
                    },
                    {
                        "id": 125885,
                        "name": "Sandy Valley",
                        "latitude": "35.81692000",
                        "longitude": "-115.63223000"
                    },
                    {
                        "id": 126435,
                        "name": "Silver Springs",
                        "latitude": "39.41547000",
                        "longitude": "-119.22461000"
                    },
                    {
                        "id": 126510,
                        "name": "Smith",
                        "latitude": "38.80047000",
                        "longitude": "-119.32738000"
                    },
                    {
                        "id": 126517,
                        "name": "Smith Valley",
                        "latitude": "38.78421000",
                        "longitude": "-119.34425000"
                    },
                    {
                        "id": 126801,
                        "name": "Spanish Springs",
                        "latitude": "39.64908000",
                        "longitude": "-119.70741000"
                    },
                    {
                        "id": 126805,
                        "name": "Sparks",
                        "latitude": "39.53491000",
                        "longitude": "-119.75269000"
                    },
                    {
                        "id": 126854,
                        "name": "Spring Creek",
                        "latitude": "40.72659000",
                        "longitude": "-115.58590000"
                    },
                    {
                        "id": 126881,
                        "name": "Spring Valley",
                        "latitude": "36.10803000",
                        "longitude": "-115.24500000"
                    },
                    {
                        "id": 126939,
                        "name": "Stagecoach",
                        "latitude": "39.37380000",
                        "longitude": "-119.37406000"
                    },
                    {
                        "id": 127102,
                        "name": "Storey County",
                        "latitude": "39.44653000",
                        "longitude": "-119.52917000"
                    },
                    {
                        "id": 127205,
                        "name": "Summerlin South",
                        "latitude": "36.11708000",
                        "longitude": "-115.33001000"
                    },
                    {
                        "id": 127242,
                        "name": "Sun Valley",
                        "latitude": "39.59630000",
                        "longitude": "-119.77602000"
                    },
                    {
                        "id": 127269,
                        "name": "Sunrise Manor",
                        "latitude": "36.21108000",
                        "longitude": "-115.07306000"
                    },
                    {
                        "id": 127722,
                        "name": "Tonopah",
                        "latitude": "38.06716000",
                        "longitude": "-117.23008000"
                    },
                    {
                        "id": 127731,
                        "name": "Topaz Ranch Estates",
                        "latitude": "38.73565000",
                        "longitude": "-119.50079000"
                    },
                    {
                        "id": 128180,
                        "name": "Verdi",
                        "latitude": "39.51824000",
                        "longitude": "-119.98881000"
                    },
                    {
                        "id": 128290,
                        "name": "Virginia City",
                        "latitude": "39.30963000",
                        "longitude": "-119.64962000"
                    },
                    {
                        "id": 128590,
                        "name": "Washoe County",
                        "latitude": "40.66542000",
                        "longitude": "-119.66430000"
                    },
                    {
                        "id": 128783,
                        "name": "Wells",
                        "latitude": "41.11159000",
                        "longitude": "-114.96449000"
                    },
                    {
                        "id": 129004,
                        "name": "West Wendover",
                        "latitude": "40.73910000",
                        "longitude": "-114.07335000"
                    },
                    {
                        "id": 129153,
                        "name": "White Pine County",
                        "latitude": "39.44216000",
                        "longitude": "-114.90159000"
                    },
                    {
                        "id": 129209,
                        "name": "Whitney",
                        "latitude": "36.09831000",
                        "longitude": "-115.03630000"
                    },
                    {
                        "id": 129361,
                        "name": "Winchester",
                        "latitude": "36.12997000",
                        "longitude": "-115.11889000"
                    },
                    {
                        "id": 129411,
                        "name": "Winnemucca",
                        "latitude": "40.97296000",
                        "longitude": "-117.73568000"
                    },
                    {
                        "id": 129682,
                        "name": "Yerington",
                        "latitude": "38.98575000",
                        "longitude": "-119.16293000"
                    }
                ]
            },
            {
                "id": 1404,
                "name": "New Hampshire",
                "iso2": "NH",
                "latitude": "43.19385160",
                "longitude": "-71.57239530",
                "type": "state",
                "cities": [
                    {
                        "id": 111155,
                        "name": "Alexandria",
                        "latitude": "43.61146000",
                        "longitude": "-71.79286000"
                    },
                    {
                        "id": 111228,
                        "name": "Alstead",
                        "latitude": "43.14897000",
                        "longitude": "-72.36064000"
                    },
                    {
                        "id": 111326,
                        "name": "Andover",
                        "latitude": "43.43702000",
                        "longitude": "-71.82341000"
                    },
                    {
                        "id": 111376,
                        "name": "Antrim",
                        "latitude": "43.03091000",
                        "longitude": "-71.93897000"
                    },
                    {
                        "id": 111535,
                        "name": "Ashland",
                        "latitude": "43.69535000",
                        "longitude": "-71.63063000"
                    },
                    {
                        "id": 111587,
                        "name": "Atkinson",
                        "latitude": "42.83842000",
                        "longitude": "-71.14700000"
                    },
                    {
                        "id": 111629,
                        "name": "Auburn",
                        "latitude": "43.00453000",
                        "longitude": "-71.34840000"
                    },
                    {
                        "id": 111836,
                        "name": "Barnstead",
                        "latitude": "43.33397000",
                        "longitude": "-71.29284000"
                    },
                    {
                        "id": 111847,
                        "name": "Barrington",
                        "latitude": "43.22286000",
                        "longitude": "-71.04701000"
                    },
                    {
                        "id": 112024,
                        "name": "Bedford",
                        "latitude": "42.94647000",
                        "longitude": "-71.51590000"
                    },
                    {
                        "id": 112065,
                        "name": "Belknap County",
                        "latitude": "43.51869000",
                        "longitude": "-71.42336000"
                    },
                    {
                        "id": 112139,
                        "name": "Belmont",
                        "latitude": "43.44536000",
                        "longitude": "-71.47785000"
                    },
                    {
                        "id": 112238,
                        "name": "Berlin",
                        "latitude": "44.46867000",
                        "longitude": "-71.18508000"
                    },
                    {
                        "id": 112582,
                        "name": "Boscawen",
                        "latitude": "43.31508000",
                        "longitude": "-71.62091000"
                    },
                    {
                        "id": 112620,
                        "name": "Bow Bog",
                        "latitude": "43.12064000",
                        "longitude": "-71.51146000"
                    },
                    {
                        "id": 112730,
                        "name": "Brentwood",
                        "latitude": "42.97870000",
                        "longitude": "-71.07284000"
                    },
                    {
                        "id": 112776,
                        "name": "Bridgewater",
                        "latitude": "43.63841000",
                        "longitude": "-71.73647000"
                    },
                    {
                        "id": 112807,
                        "name": "Bristol",
                        "latitude": "43.59119000",
                        "longitude": "-71.73675000"
                    },
                    {
                        "id": 112868,
                        "name": "Brookline",
                        "latitude": "42.73481000",
                        "longitude": "-71.65813000"
                    },
                    {
                        "id": 113323,
                        "name": "Candia",
                        "latitude": "43.07786000",
                        "longitude": "-71.27673000"
                    },
                    {
                        "id": 113337,
                        "name": "Canterbury",
                        "latitude": "43.33702000",
                        "longitude": "-71.56535000"
                    },
                    {
                        "id": 113461,
                        "name": "Carroll County",
                        "latitude": "43.87391000",
                        "longitude": "-71.20277000"
                    },
                    {
                        "id": 113642,
                        "name": "Center Harbor",
                        "latitude": "43.70980000",
                        "longitude": "-71.46035000"
                    },
                    {
                        "id": 113772,
                        "name": "Charlestown",
                        "latitude": "43.23869000",
                        "longitude": "-72.42453000"
                    },
                    {
                        "id": 113878,
                        "name": "Cheshire County",
                        "latitude": "42.91932000",
                        "longitude": "-72.25118000"
                    },
                    {
                        "id": 113887,
                        "name": "Chester",
                        "latitude": "42.95675000",
                        "longitude": "-71.25728000"
                    },
                    {
                        "id": 113905,
                        "name": "Chesterfield",
                        "latitude": "42.88730000",
                        "longitude": "-72.47037000"
                    },
                    {
                        "id": 113936,
                        "name": "Chichester",
                        "latitude": "43.24925000",
                        "longitude": "-71.39979000"
                    },
                    {
                        "id": 114105,
                        "name": "Claremont",
                        "latitude": "43.37674000",
                        "longitude": "-72.34676000"
                    },
                    {
                        "id": 114397,
                        "name": "Colebrook",
                        "latitude": "44.89449000",
                        "longitude": "-71.49592000"
                    },
                    {
                        "id": 114541,
                        "name": "Concord",
                        "latitude": "43.20814000",
                        "longitude": "-71.53757000"
                    },
                    {
                        "id": 114574,
                        "name": "Contoocook",
                        "latitude": "43.22202000",
                        "longitude": "-71.71397000"
                    },
                    {
                        "id": 114585,
                        "name": "Conway",
                        "latitude": "43.97924000",
                        "longitude": "-71.12035000"
                    },
                    {
                        "id": 114611,
                        "name": "Coos County",
                        "latitude": "44.68960000",
                        "longitude": "-71.30542000"
                    },
                    {
                        "id": 115016,
                        "name": "Danbury",
                        "latitude": "43.52563000",
                        "longitude": "-71.86175000"
                    },
                    {
                        "id": 115036,
                        "name": "Danville",
                        "latitude": "42.91259000",
                        "longitude": "-71.12450000"
                    },
                    {
                        "id": 115182,
                        "name": "Deerfield",
                        "latitude": "44.23062000",
                        "longitude": "-71.61703000"
                    },
                    {
                        "id": 115185,
                        "name": "Deering",
                        "latitude": "43.07314000",
                        "longitude": "-71.84452000"
                    },
                    {
                        "id": 115265,
                        "name": "Derry",
                        "latitude": "42.88064000",
                        "longitude": "-71.32729000"
                    },
                    {
                        "id": 115267,
                        "name": "Derry Village",
                        "latitude": "42.89175000",
                        "longitude": "-71.31201000"
                    },
                    {
                        "id": 115450,
                        "name": "Dover",
                        "latitude": "43.19786000",
                        "longitude": "-70.87367000"
                    },
                    {
                        "id": 115494,
                        "name": "Dublin",
                        "latitude": "42.90758000",
                        "longitude": "-72.06258000"
                    },
                    {
                        "id": 115571,
                        "name": "Durham",
                        "latitude": "43.13397000",
                        "longitude": "-70.92645000"
                    },
                    {
                        "id": 115647,
                        "name": "East Concord",
                        "latitude": "43.24202000",
                        "longitude": "-71.53813000"
                    },
                    {
                        "id": 115698,
                        "name": "East Kingston",
                        "latitude": "42.92564000",
                        "longitude": "-71.01672000"
                    },
                    {
                        "id": 115711,
                        "name": "East Merrimack",
                        "latitude": "42.86814000",
                        "longitude": "-71.48340000"
                    },
                    {
                        "id": 115897,
                        "name": "Effingham",
                        "latitude": "43.76119000",
                        "longitude": "-70.99645000"
                    },
                    {
                        "id": 116127,
                        "name": "Enfield",
                        "latitude": "43.64063000",
                        "longitude": "-72.14398000"
                    },
                    {
                        "id": 116157,
                        "name": "Epping",
                        "latitude": "43.03342000",
                        "longitude": "-71.07423000"
                    },
                    {
                        "id": 116158,
                        "name": "Epsom",
                        "latitude": "43.22286000",
                        "longitude": "-71.33201000"
                    },
                    {
                        "id": 116271,
                        "name": "Exeter",
                        "latitude": "42.98148000",
                        "longitude": "-70.94783000"
                    },
                    {
                        "id": 116420,
                        "name": "Farmington",
                        "latitude": "43.38980000",
                        "longitude": "-71.06506000"
                    },
                    {
                        "id": 116537,
                        "name": "Fitzwilliam",
                        "latitude": "42.78064000",
                        "longitude": "-72.14175000"
                    },
                    {
                        "id": 116813,
                        "name": "Francestown",
                        "latitude": "42.98758000",
                        "longitude": "-71.81258000"
                    },
                    {
                        "id": 116837,
                        "name": "Franklin",
                        "latitude": "43.44424000",
                        "longitude": "-71.64730000"
                    },
                    {
                        "id": 116901,
                        "name": "Freedom",
                        "latitude": "43.81230000",
                        "longitude": "-71.03562000"
                    },
                    {
                        "id": 116922,
                        "name": "Fremont",
                        "latitude": "42.99092000",
                        "longitude": "-71.14256000"
                    },
                    {
                        "id": 117212,
                        "name": "Gilford",
                        "latitude": "43.54758000",
                        "longitude": "-71.40674000"
                    },
                    {
                        "id": 117220,
                        "name": "Gilmanton",
                        "latitude": "43.42425000",
                        "longitude": "-71.41452000"
                    },
                    {
                        "id": 117336,
                        "name": "Goffstown",
                        "latitude": "43.02036000",
                        "longitude": "-71.60035000"
                    },
                    {
                        "id": 117404,
                        "name": "Gorham",
                        "latitude": "44.38784000",
                        "longitude": "-71.17313000"
                    },
                    {
                        "id": 117430,
                        "name": "Grafton",
                        "latitude": "43.55868000",
                        "longitude": "-71.94397000"
                    },
                    {
                        "id": 117433,
                        "name": "Grafton County",
                        "latitude": "43.94074000",
                        "longitude": "-71.82055000"
                    },
                    {
                        "id": 117525,
                        "name": "Grantham",
                        "latitude": "43.48952000",
                        "longitude": "-72.13759000"
                    },
                    {
                        "id": 117652,
                        "name": "Greenfield",
                        "latitude": "42.95064000",
                        "longitude": "-71.87230000"
                    },
                    {
                        "id": 117657,
                        "name": "Greenland",
                        "latitude": "43.03620000",
                        "longitude": "-70.83283000"
                    },
                    {
                        "id": 117692,
                        "name": "Greenville",
                        "latitude": "42.76731000",
                        "longitude": "-71.81230000"
                    },
                    {
                        "id": 117764,
                        "name": "Groveton",
                        "latitude": "44.59867000",
                        "longitude": "-71.51120000"
                    },
                    {
                        "id": 117925,
                        "name": "Hampstead",
                        "latitude": "42.87453000",
                        "longitude": "-71.18117000"
                    },
                    {
                        "id": 117934,
                        "name": "Hampton",
                        "latitude": "42.93759000",
                        "longitude": "-70.83894000"
                    },
                    {
                        "id": 117936,
                        "name": "Hampton Beach",
                        "latitude": "42.90731000",
                        "longitude": "-70.81200000"
                    },
                    {
                        "id": 117938,
                        "name": "Hampton Falls",
                        "latitude": "42.91620000",
                        "longitude": "-70.86366000"
                    },
                    {
                        "id": 117972,
                        "name": "Hanover",
                        "latitude": "43.70229000",
                        "longitude": "-72.28954000"
                    },
                    {
                        "id": 118075,
                        "name": "Harrisville",
                        "latitude": "42.94508000",
                        "longitude": "-72.09647000"
                    },
                    {
                        "id": 118151,
                        "name": "Haverhill",
                        "latitude": "44.03451000",
                        "longitude": "-72.06398000"
                    },
                    {
                        "id": 118293,
                        "name": "Henniker",
                        "latitude": "43.17980000",
                        "longitude": "-71.82230000"
                    },
                    {
                        "id": 118431,
                        "name": "Hill",
                        "latitude": "43.52424000",
                        "longitude": "-71.70091000"
                    },
                    {
                        "id": 118456,
                        "name": "Hillsborough",
                        "latitude": "43.11410000",
                        "longitude": "-71.89920000"
                    },
                    {
                        "id": 118458,
                        "name": "Hillsborough County",
                        "latitude": "42.91531000",
                        "longitude": "-71.71601000"
                    },
                    {
                        "id": 118486,
                        "name": "Hinsdale",
                        "latitude": "42.78619000",
                        "longitude": "-72.48648000"
                    },
                    {
                        "id": 118527,
                        "name": "Holderness",
                        "latitude": "43.73202000",
                        "longitude": "-71.58841000"
                    },
                    {
                        "id": 118548,
                        "name": "Hollis",
                        "latitude": "42.74314000",
                        "longitude": "-71.59174000"
                    },
                    {
                        "id": 118631,
                        "name": "Hooksett",
                        "latitude": "43.09675000",
                        "longitude": "-71.46507000"
                    },
                    {
                        "id": 118657,
                        "name": "Hopkinton",
                        "latitude": "43.19147000",
                        "longitude": "-71.67535000"
                    },
                    {
                        "id": 118743,
                        "name": "Hudson",
                        "latitude": "42.76481000",
                        "longitude": "-71.43979000"
                    },
                    {
                        "id": 119109,
                        "name": "Jaffrey",
                        "latitude": "42.81397000",
                        "longitude": "-72.02314000"
                    },
                    {
                        "id": 119170,
                        "name": "Jefferson",
                        "latitude": "44.41895000",
                        "longitude": "-71.47453000"
                    },
                    {
                        "id": 119421,
                        "name": "Keene",
                        "latitude": "42.93369000",
                        "longitude": "-72.27814000"
                    },
                    {
                        "id": 119482,
                        "name": "Kensington",
                        "latitude": "42.92703000",
                        "longitude": "-70.94394000"
                    },
                    {
                        "id": 119625,
                        "name": "Kingston",
                        "latitude": "42.93648000",
                        "longitude": "-71.05339000"
                    },
                    {
                        "id": 119819,
                        "name": "Laconia",
                        "latitude": "43.52785000",
                        "longitude": "-71.47035000"
                    },
                    {
                        "id": 120084,
                        "name": "Lancaster",
                        "latitude": "44.48895000",
                        "longitude": "-71.56925000"
                    },
                    {
                        "id": 120291,
                        "name": "Lebanon",
                        "latitude": "43.64229000",
                        "longitude": "-72.25176000"
                    },
                    {
                        "id": 120304,
                        "name": "Lee",
                        "latitude": "43.12314000",
                        "longitude": "-71.01145000"
                    },
                    {
                        "id": 120365,
                        "name": "Lempster",
                        "latitude": "43.23841000",
                        "longitude": "-72.21064000"
                    },
                    {
                        "id": 120607,
                        "name": "Litchfield",
                        "latitude": "42.84425000",
                        "longitude": "-71.47979000"
                    },
                    {
                        "id": 120635,
                        "name": "Littleton",
                        "latitude": "44.30617000",
                        "longitude": "-71.77009000"
                    },
                    {
                        "id": 120723,
                        "name": "Londonderry",
                        "latitude": "42.86509000",
                        "longitude": "-71.37395000"
                    },
                    {
                        "id": 120912,
                        "name": "Lyme",
                        "latitude": "43.80951000",
                        "longitude": "-72.15592000"
                    },
                    {
                        "id": 120918,
                        "name": "Lyndeborough",
                        "latitude": "42.90758000",
                        "longitude": "-71.76646000"
                    },
                    {
                        "id": 120977,
                        "name": "Madbury",
                        "latitude": "43.16925000",
                        "longitude": "-70.92395000"
                    },
                    {
                        "id": 120996,
                        "name": "Madison",
                        "latitude": "43.89924000",
                        "longitude": "-71.14840000"
                    },
                    {
                        "id": 121098,
                        "name": "Manchester",
                        "latitude": "42.99564000",
                        "longitude": "-71.45479000"
                    },
                    {
                        "id": 121281,
                        "name": "Marlborough",
                        "latitude": "42.90425000",
                        "longitude": "-72.20786000"
                    },
                    {
                        "id": 121374,
                        "name": "Mason",
                        "latitude": "42.74370000",
                        "longitude": "-71.76896000"
                    },
                    {
                        "id": 121687,
                        "name": "Meredith",
                        "latitude": "43.65757000",
                        "longitude": "-71.50035000"
                    },
                    {
                        "id": 121711,
                        "name": "Merrimack",
                        "latitude": "42.86509000",
                        "longitude": "-71.49340000"
                    },
                    {
                        "id": 121712,
                        "name": "Merrimack County",
                        "latitude": "43.29765000",
                        "longitude": "-71.68019000"
                    },
                    {
                        "id": 121840,
                        "name": "Milan",
                        "latitude": "44.57339000",
                        "longitude": "-71.18508000"
                    },
                    {
                        "id": 121856,
                        "name": "Milford",
                        "latitude": "42.83536000",
                        "longitude": "-71.64896000"
                    },
                    {
                        "id": 122094,
                        "name": "Mont Vernon",
                        "latitude": "42.89453000",
                        "longitude": "-71.67424000"
                    },
                    {
                        "id": 122315,
                        "name": "Moultonborough",
                        "latitude": "43.75480000",
                        "longitude": "-71.39674000"
                    },
                    {
                        "id": 122571,
                        "name": "Nashua",
                        "latitude": "42.76537000",
                        "longitude": "-71.46757000"
                    },
                    {
                        "id": 122669,
                        "name": "New Boston",
                        "latitude": "42.97619000",
                        "longitude": "-71.69396000"
                    },
                    {
                        "id": 122687,
                        "name": "New Castle",
                        "latitude": "43.07231000",
                        "longitude": "-70.71616000"
                    },
                    {
                        "id": 122701,
                        "name": "New Durham",
                        "latitude": "43.43675000",
                        "longitude": "-71.17229000"
                    },
                    {
                        "id": 122731,
                        "name": "New Ipswich",
                        "latitude": "42.74814000",
                        "longitude": "-71.85424000"
                    },
                    {
                        "id": 122744,
                        "name": "New London",
                        "latitude": "43.41396000",
                        "longitude": "-71.98508000"
                    },
                    {
                        "id": 122818,
                        "name": "Newbury",
                        "latitude": "43.32146000",
                        "longitude": "-72.03592000"
                    },
                    {
                        "id": 122836,
                        "name": "Newmarket",
                        "latitude": "43.08286000",
                        "longitude": "-70.93506000"
                    },
                    {
                        "id": 122847,
                        "name": "Newport",
                        "latitude": "43.36535000",
                        "longitude": "-72.17342000"
                    },
                    {
                        "id": 122866,
                        "name": "Newton",
                        "latitude": "42.86953000",
                        "longitude": "-71.03450000"
                    },
                    {
                        "id": 123009,
                        "name": "North Conway",
                        "latitude": "44.05368000",
                        "longitude": "-71.12840000"
                    },
                    {
                        "id": 123035,
                        "name": "North Hampton",
                        "latitude": "42.97259000",
                        "longitude": "-70.82978000"
                    },
                    {
                        "id": 123153,
                        "name": "Northfield",
                        "latitude": "43.43313000",
                        "longitude": "-71.59230000"
                    },
                    {
                        "id": 123164,
                        "name": "Northumberland",
                        "latitude": "44.56339000",
                        "longitude": "-71.55870000"
                    },
                    {
                        "id": 123180,
                        "name": "Northwood",
                        "latitude": "43.19425000",
                        "longitude": "-71.15090000"
                    },
                    {
                        "id": 123205,
                        "name": "Nottingham",
                        "latitude": "43.11453000",
                        "longitude": "-71.09978000"
                    },
                    {
                        "id": 123552,
                        "name": "Orford",
                        "latitude": "43.90535000",
                        "longitude": "-72.14009000"
                    },
                    {
                        "id": 123618,
                        "name": "Ossipee",
                        "latitude": "43.68536000",
                        "longitude": "-71.11673000"
                    },
                    {
                        "id": 123991,
                        "name": "Pelham",
                        "latitude": "42.73453000",
                        "longitude": "-71.32451000"
                    },
                    {
                        "id": 124007,
                        "name": "Pembroke",
                        "latitude": "43.14675000",
                        "longitude": "-71.45757000"
                    },
                    {
                        "id": 124102,
                        "name": "Peterborough",
                        "latitude": "42.87064000",
                        "longitude": "-71.95175000"
                    },
                    {
                        "id": 124207,
                        "name": "Pinardville",
                        "latitude": "42.99425000",
                        "longitude": "-71.50729000"
                    },
                    {
                        "id": 124300,
                        "name": "Pittsfield",
                        "latitude": "43.30591000",
                        "longitude": "-71.32423000"
                    },
                    {
                        "id": 124337,
                        "name": "Plaistow",
                        "latitude": "42.83648000",
                        "longitude": "-71.09478000"
                    },
                    {
                        "id": 124406,
                        "name": "Plymouth",
                        "latitude": "43.75702000",
                        "longitude": "-71.68813000"
                    },
                    {
                        "id": 124570,
                        "name": "Portsmouth",
                        "latitude": "43.07704000",
                        "longitude": "-70.75766000"
                    },
                    {
                        "id": 124919,
                        "name": "Raymond",
                        "latitude": "43.03620000",
                        "longitude": "-71.18340000"
                    },
                    {
                        "id": 125093,
                        "name": "Richmond",
                        "latitude": "42.75481000",
                        "longitude": "-72.27175000"
                    },
                    {
                        "id": 125140,
                        "name": "Rindge",
                        "latitude": "42.75120000",
                        "longitude": "-72.00980000"
                    },
                    {
                        "id": 125265,
                        "name": "Rochester",
                        "latitude": "43.30453000",
                        "longitude": "-70.97562000"
                    },
                    {
                        "id": 125307,
                        "name": "Rockingham County",
                        "latitude": "42.98454000",
                        "longitude": "-71.08897000"
                    },
                    {
                        "id": 125371,
                        "name": "Rollinsford",
                        "latitude": "43.23620000",
                        "longitude": "-70.82034000"
                    },
                    {
                        "id": 125508,
                        "name": "Rumney",
                        "latitude": "43.80535000",
                        "longitude": "-71.81258000"
                    },
                    {
                        "id": 125561,
                        "name": "Rye",
                        "latitude": "43.01342000",
                        "longitude": "-70.77089000"
                    },
                    {
                        "id": 125736,
                        "name": "Salem",
                        "latitude": "42.78842000",
                        "longitude": "-71.20089000"
                    },
                    {
                        "id": 125758,
                        "name": "Salisbury",
                        "latitude": "43.38008000",
                        "longitude": "-71.71702000"
                    },
                    {
                        "id": 125856,
                        "name": "Sanbornton",
                        "latitude": "43.48924000",
                        "longitude": "-71.58230000"
                    },
                    {
                        "id": 125857,
                        "name": "Sanbornville",
                        "latitude": "43.55425000",
                        "longitude": "-71.03090000"
                    },
                    {
                        "id": 125870,
                        "name": "Sandown",
                        "latitude": "42.92870000",
                        "longitude": "-71.18701000"
                    },
                    {
                        "id": 125878,
                        "name": "Sandwich",
                        "latitude": "43.79035000",
                        "longitude": "-71.41118000"
                    },
                    {
                        "id": 126080,
                        "name": "Seabrook",
                        "latitude": "42.89481000",
                        "longitude": "-70.87116000"
                    },
                    {
                        "id": 126590,
                        "name": "Somersworth",
                        "latitude": "43.26175000",
                        "longitude": "-70.86534000"
                    },
                    {
                        "id": 126675,
                        "name": "South Hooksett",
                        "latitude": "43.02647000",
                        "longitude": "-71.43534000"
                    },
                    {
                        "id": 126901,
                        "name": "Springfield",
                        "latitude": "43.49507000",
                        "longitude": "-72.03342000"
                    },
                    {
                        "id": 127117,
                        "name": "Strafford",
                        "latitude": "43.32703000",
                        "longitude": "-71.18423000"
                    },
                    {
                        "id": 127118,
                        "name": "Strafford County",
                        "latitude": "43.29743000",
                        "longitude": "-71.02940000"
                    },
                    {
                        "id": 127125,
                        "name": "Stratford",
                        "latitude": "44.65505000",
                        "longitude": "-71.55564000"
                    },
                    {
                        "id": 127129,
                        "name": "Stratham Station",
                        "latitude": "43.05287000",
                        "longitude": "-70.89533000"
                    },
                    {
                        "id": 127189,
                        "name": "Sullivan County",
                        "latitude": "43.36122000",
                        "longitude": "-72.22240000"
                    },
                    {
                        "id": 127244,
                        "name": "Sunapee",
                        "latitude": "43.38757000",
                        "longitude": "-72.08786000"
                    },
                    {
                        "id": 127247,
                        "name": "Suncook",
                        "latitude": "43.13064000",
                        "longitude": "-71.45312000"
                    },
                    {
                        "id": 127313,
                        "name": "Sutton",
                        "latitude": "43.33424000",
                        "longitude": "-71.95147000"
                    },
                    {
                        "id": 127329,
                        "name": "Swanzey",
                        "latitude": "42.86980000",
                        "longitude": "-72.28175000"
                    },
                    {
                        "id": 127408,
                        "name": "Tamworth",
                        "latitude": "43.85980000",
                        "longitude": "-71.26313000"
                    },
                    {
                        "id": 127499,
                        "name": "Temple",
                        "latitude": "42.81814000",
                        "longitude": "-71.85147000"
                    },
                    {
                        "id": 127602,
                        "name": "Thornton",
                        "latitude": "43.89285000",
                        "longitude": "-71.67591000"
                    },
                    {
                        "id": 127654,
                        "name": "Tilton",
                        "latitude": "43.44230000",
                        "longitude": "-71.58896000"
                    },
                    {
                        "id": 127655,
                        "name": "Tilton-Northfield",
                        "latitude": "43.44300000",
                        "longitude": "-71.59364000"
                    },
                    {
                        "id": 127850,
                        "name": "Troy",
                        "latitude": "42.82397000",
                        "longitude": "-72.18119000"
                    },
                    {
                        "id": 127877,
                        "name": "Tuftonboro",
                        "latitude": "43.69647000",
                        "longitude": "-71.22201000"
                    },
                    {
                        "id": 128021,
                        "name": "Unity",
                        "latitude": "43.29396000",
                        "longitude": "-72.26037000"
                    },
                    {
                        "id": 128361,
                        "name": "Wakefield",
                        "latitude": "43.56813000",
                        "longitude": "-71.03007000"
                    },
                    {
                        "id": 128715,
                        "name": "Weare",
                        "latitude": "43.09480000",
                        "longitude": "-71.73063000"
                    },
                    {
                        "id": 128732,
                        "name": "Webster",
                        "latitude": "43.32897000",
                        "longitude": "-71.71786000"
                    },
                    {
                        "id": 128987,
                        "name": "West Swanzey",
                        "latitude": "42.87008000",
                        "longitude": "-72.32175000"
                    },
                    {
                        "id": 129054,
                        "name": "Westmoreland",
                        "latitude": "42.96203000",
                        "longitude": "-72.44231000"
                    },
                    {
                        "id": 129165,
                        "name": "Whitefield",
                        "latitude": "44.37312000",
                        "longitude": "-71.61008000"
                    },
                    {
                        "id": 129328,
                        "name": "Wilmot",
                        "latitude": "43.45174000",
                        "longitude": "-71.91369000"
                    },
                    {
                        "id": 129345,
                        "name": "Wilton",
                        "latitude": "42.84342000",
                        "longitude": "-71.73507000"
                    },
                    {
                        "id": 129359,
                        "name": "Winchester",
                        "latitude": "42.77342000",
                        "longitude": "-72.38314000"
                    },
                    {
                        "id": 129372,
                        "name": "Windham",
                        "latitude": "42.80064000",
                        "longitude": "-71.30423000"
                    },
                    {
                        "id": 129478,
                        "name": "Wolfeboro",
                        "latitude": "43.58397000",
                        "longitude": "-71.20729000"
                    },
                    {
                        "id": 129564,
                        "name": "Woodstock",
                        "latitude": "43.97757000",
                        "longitude": "-71.68508000"
                    },
                    {
                        "id": 129569,
                        "name": "Woodsville",
                        "latitude": "44.15229000",
                        "longitude": "-72.03731000"
                    }
                ]
            },
            {
                "id": 1417,
                "name": "New Jersey",
                "iso2": "NJ",
                "latitude": "40.05832380",
                "longitude": "-74.40566120",
                "type": "state",
                "cities": [
                    {
                        "id": 110990,
                        "name": "Absecon",
                        "latitude": "39.42845000",
                        "longitude": "-74.49571000"
                    },
                    {
                        "id": 111195,
                        "name": "Allendale",
                        "latitude": "41.04149000",
                        "longitude": "-74.12903000"
                    },
                    {
                        "id": 111198,
                        "name": "Allentown",
                        "latitude": "40.17789000",
                        "longitude": "-74.58349000"
                    },
                    {
                        "id": 111204,
                        "name": "Alloway",
                        "latitude": "39.56095000",
                        "longitude": "-75.36242000"
                    },
                    {
                        "id": 111220,
                        "name": "Alpha",
                        "latitude": "40.66704000",
                        "longitude": "-75.15740000"
                    },
                    {
                        "id": 111222,
                        "name": "Alpine",
                        "latitude": "40.95593000",
                        "longitude": "-73.93125000"
                    },
                    {
                        "id": 111351,
                        "name": "Annandale",
                        "latitude": "40.64093000",
                        "longitude": "-74.88128000"
                    },
                    {
                        "id": 111508,
                        "name": "Asbury Park",
                        "latitude": "40.22039000",
                        "longitude": "-74.01208000"
                    },
                    {
                        "id": 111531,
                        "name": "Ashland",
                        "latitude": "39.86317000",
                        "longitude": "-75.00600000"
                    },
                    {
                        "id": 111570,
                        "name": "Atco",
                        "latitude": "39.76984000",
                        "longitude": "-74.88739000"
                    },
                    {
                        "id": 111598,
                        "name": "Atlantic City",
                        "latitude": "39.36415000",
                        "longitude": "-74.42306000"
                    },
                    {
                        "id": 111599,
                        "name": "Atlantic County",
                        "latitude": "39.46883000",
                        "longitude": "-74.63373000"
                    },
                    {
                        "id": 111600,
                        "name": "Atlantic Highlands",
                        "latitude": "40.40789000",
                        "longitude": "-74.03431000"
                    },
                    {
                        "id": 111638,
                        "name": "Audubon",
                        "latitude": "39.89095000",
                        "longitude": "-75.07295000"
                    },
                    {
                        "id": 111643,
                        "name": "Audubon Park",
                        "latitude": "39.89650000",
                        "longitude": "-75.08767000"
                    },
                    {
                        "id": 111673,
                        "name": "Avalon",
                        "latitude": "39.10122000",
                        "longitude": "-74.71766000"
                    },
                    {
                        "id": 111677,
                        "name": "Avenel",
                        "latitude": "40.58038000",
                        "longitude": "-74.28515000"
                    },
                    {
                        "id": 111697,
                        "name": "Avon-by-the-Sea",
                        "latitude": "40.19234000",
                        "longitude": "-74.01597000"
                    },
                    {
                        "id": 111825,
                        "name": "Barnegat",
                        "latitude": "39.75318000",
                        "longitude": "-74.22292000"
                    },
                    {
                        "id": 111845,
                        "name": "Barrington",
                        "latitude": "39.86484000",
                        "longitude": "-75.05517000"
                    },
                    {
                        "id": 111945,
                        "name": "Bayonne",
                        "latitude": "40.66871000",
                        "longitude": "-74.11431000"
                    },
                    {
                        "id": 111960,
                        "name": "Bayville",
                        "latitude": "39.90929000",
                        "longitude": "-74.15486000"
                    },
                    {
                        "id": 111964,
                        "name": "Beach Haven",
                        "latitude": "39.55928000",
                        "longitude": "-74.24320000"
                    },
                    {
                        "id": 111965,
                        "name": "Beach Haven West",
                        "latitude": "39.66984000",
                        "longitude": "-74.23181000"
                    },
                    {
                        "id": 111967,
                        "name": "Beachwood",
                        "latitude": "39.93901000",
                        "longitude": "-74.19292000"
                    },
                    {
                        "id": 111983,
                        "name": "Beattystown",
                        "latitude": "40.81315000",
                        "longitude": "-74.84294000"
                    },
                    {
                        "id": 112015,
                        "name": "Beckett",
                        "latitude": "39.75400000",
                        "longitude": "-75.35741000"
                    },
                    {
                        "id": 112031,
                        "name": "Bedminster",
                        "latitude": "40.68066000",
                        "longitude": "-74.64544000"
                    },
                    {
                        "id": 112059,
                        "name": "Belford",
                        "latitude": "40.42594000",
                        "longitude": "-74.08681000"
                    },
                    {
                        "id": 112106,
                        "name": "Belleville",
                        "latitude": "40.79371000",
                        "longitude": "-74.15014000"
                    },
                    {
                        "id": 112121,
                        "name": "Bellmawr",
                        "latitude": "39.86761000",
                        "longitude": "-75.09462000"
                    },
                    {
                        "id": 112133,
                        "name": "Belmar",
                        "latitude": "40.17845000",
                        "longitude": "-74.02180000"
                    },
                    {
                        "id": 112156,
                        "name": "Belvidere",
                        "latitude": "40.82982000",
                        "longitude": "-75.07767000"
                    },
                    {
                        "id": 112218,
                        "name": "Bergen County",
                        "latitude": "40.95977000",
                        "longitude": "-74.07441000"
                    },
                    {
                        "id": 112219,
                        "name": "Bergenfield",
                        "latitude": "40.92760000",
                        "longitude": "-73.99736000"
                    },
                    {
                        "id": 112226,
                        "name": "Berkeley Heights",
                        "latitude": "40.68343000",
                        "longitude": "-74.44265000"
                    },
                    {
                        "id": 112235,
                        "name": "Berlin",
                        "latitude": "39.79123000",
                        "longitude": "-74.92905000"
                    },
                    {
                        "id": 112245,
                        "name": "Bernardsville",
                        "latitude": "40.71871000",
                        "longitude": "-74.56932000"
                    },
                    {
                        "id": 112301,
                        "name": "Beverly",
                        "latitude": "40.06539000",
                        "longitude": "-74.91906000"
                    },
                    {
                        "id": 112397,
                        "name": "Blackwood",
                        "latitude": "39.80234000",
                        "longitude": "-75.06406000"
                    },
                    {
                        "id": 112437,
                        "name": "Bloomfield",
                        "latitude": "40.80677000",
                        "longitude": "-74.18542000"
                    },
                    {
                        "id": 112448,
                        "name": "Bloomingdale",
                        "latitude": "41.00204000",
                        "longitude": "-74.32654000"
                    },
                    {
                        "id": 112501,
                        "name": "Bogota",
                        "latitude": "40.87621000",
                        "longitude": "-74.02986000"
                    },
                    {
                        "id": 112566,
                        "name": "Boonton",
                        "latitude": "40.90260000",
                        "longitude": "-74.40710000"
                    },
                    {
                        "id": 112576,
                        "name": "Bordentown",
                        "latitude": "40.14622000",
                        "longitude": "-74.71183000"
                    },
                    {
                        "id": 112608,
                        "name": "Bound Brook",
                        "latitude": "40.56844000",
                        "longitude": "-74.53849000"
                    },
                    {
                        "id": 112674,
                        "name": "Bradley Beach",
                        "latitude": "40.20234000",
                        "longitude": "-74.01208000"
                    },
                    {
                        "id": 112677,
                        "name": "Bradley Gardens",
                        "latitude": "40.56288000",
                        "longitude": "-74.65460000"
                    },
                    {
                        "id": 112698,
                        "name": "Brass Castle",
                        "latitude": "40.76482000",
                        "longitude": "-75.01101000"
                    },
                    {
                        "id": 112770,
                        "name": "Bridgeton",
                        "latitude": "39.42734000",
                        "longitude": "-75.23408000"
                    },
                    {
                        "id": 112777,
                        "name": "Bridgewater",
                        "latitude": "40.60079000",
                        "longitude": "-74.64815000"
                    },
                    {
                        "id": 112781,
                        "name": "Brielle",
                        "latitude": "40.10789000",
                        "longitude": "-74.05653000"
                    },
                    {
                        "id": 112783,
                        "name": "Brigantine",
                        "latitude": "39.41012000",
                        "longitude": "-74.36459000"
                    },
                    {
                        "id": 112850,
                        "name": "Brookdale",
                        "latitude": "40.83371000",
                        "longitude": "-74.18292000"
                    },
                    {
                        "id": 112865,
                        "name": "Brooklawn",
                        "latitude": "39.87817000",
                        "longitude": "-75.12073000"
                    },
                    {
                        "id": 112921,
                        "name": "Browns Mills",
                        "latitude": "39.97261000",
                        "longitude": "-74.58293000"
                    },
                    {
                        "id": 112939,
                        "name": "Brownville",
                        "latitude": "40.40066000",
                        "longitude": "-74.29515000"
                    },
                    {
                        "id": 112994,
                        "name": "Budd Lake",
                        "latitude": "40.87121000",
                        "longitude": "-74.73405000"
                    },
                    {
                        "id": 112998,
                        "name": "Buena",
                        "latitude": "39.51373000",
                        "longitude": "-74.92462000"
                    },
                    {
                        "id": 113071,
                        "name": "Burlington",
                        "latitude": "40.07122000",
                        "longitude": "-74.86489000"
                    },
                    {
                        "id": 113077,
                        "name": "Burlington County",
                        "latitude": "39.87769000",
                        "longitude": "-74.66820000"
                    },
                    {
                        "id": 113110,
                        "name": "Butler",
                        "latitude": "41.00371000",
                        "longitude": "-74.34154000"
                    },
                    {
                        "id": 113181,
                        "name": "Caldwell",
                        "latitude": "40.83982000",
                        "longitude": "-74.27654000"
                    },
                    {
                        "id": 113214,
                        "name": "Califon",
                        "latitude": "40.71954000",
                        "longitude": "-74.83572000"
                    },
                    {
                        "id": 113263,
                        "name": "Camden",
                        "latitude": "39.92595000",
                        "longitude": "-75.11962000"
                    },
                    {
                        "id": 113271,
                        "name": "Camden County",
                        "latitude": "39.80353000",
                        "longitude": "-74.95976000"
                    },
                    {
                        "id": 113369,
                        "name": "Cape May",
                        "latitude": "38.93511000",
                        "longitude": "-74.90601000"
                    },
                    {
                        "id": 113370,
                        "name": "Cape May County",
                        "latitude": "39.08513000",
                        "longitude": "-74.84998000"
                    },
                    {
                        "id": 113371,
                        "name": "Cape May Court House",
                        "latitude": "39.08261000",
                        "longitude": "-74.82378000"
                    },
                    {
                        "id": 113410,
                        "name": "Carlstadt",
                        "latitude": "40.84038000",
                        "longitude": "-74.09070000"
                    },
                    {
                        "id": 113429,
                        "name": "Carneys Point",
                        "latitude": "39.71122000",
                        "longitude": "-75.47020000"
                    },
                    {
                        "id": 113486,
                        "name": "Carteret",
                        "latitude": "40.57733000",
                        "longitude": "-74.22820000"
                    },
                    {
                        "id": 113608,
                        "name": "Cedar Glen Lakes",
                        "latitude": "39.95234000",
                        "longitude": "-74.39987000"
                    },
                    {
                        "id": 113609,
                        "name": "Cedar Glen West",
                        "latitude": "40.04206000",
                        "longitude": "-74.29265000"
                    },
                    {
                        "id": 113611,
                        "name": "Cedar Grove",
                        "latitude": "40.85177000",
                        "longitude": "-74.22903000"
                    },
                    {
                        "id": 113800,
                        "name": "Chatham",
                        "latitude": "40.74093000",
                        "longitude": "-74.38376000"
                    },
                    {
                        "id": 113860,
                        "name": "Cherry Hill",
                        "latitude": "39.93484000",
                        "longitude": "-75.03073000"
                    },
                    {
                        "id": 113862,
                        "name": "Cherry Hill Mall",
                        "latitude": "39.93595000",
                        "longitude": "-75.00906000"
                    },
                    {
                        "id": 113880,
                        "name": "Chesilhurst",
                        "latitude": "39.73234000",
                        "longitude": "-74.88100000"
                    },
                    {
                        "id": 113889,
                        "name": "Chester",
                        "latitude": "40.78427000",
                        "longitude": "-74.69683000"
                    },
                    {
                        "id": 114027,
                        "name": "Cinnaminson",
                        "latitude": "39.99678000",
                        "longitude": "-74.99267000"
                    },
                    {
                        "id": 114119,
                        "name": "Clark",
                        "latitude": "40.64094000",
                        "longitude": "-74.31070000"
                    },
                    {
                        "id": 114201,
                        "name": "Clayton",
                        "latitude": "39.66011000",
                        "longitude": "-75.09212000"
                    },
                    {
                        "id": 114215,
                        "name": "Clearbrook Park",
                        "latitude": "40.30983000",
                        "longitude": "-74.46460000"
                    },
                    {
                        "id": 114232,
                        "name": "Clementon",
                        "latitude": "39.81150000",
                        "longitude": "-74.98294000"
                    },
                    {
                        "id": 114253,
                        "name": "Cliffside Park",
                        "latitude": "40.82149000",
                        "longitude": "-73.98764000"
                    },
                    {
                        "id": 114254,
                        "name": "Cliffwood Beach",
                        "latitude": "40.44205000",
                        "longitude": "-74.21681000"
                    },
                    {
                        "id": 114259,
                        "name": "Clifton",
                        "latitude": "40.85843000",
                        "longitude": "-74.16376000"
                    },
                    {
                        "id": 114284,
                        "name": "Clinton",
                        "latitude": "40.63677000",
                        "longitude": "-74.90989000"
                    },
                    {
                        "id": 114305,
                        "name": "Closter",
                        "latitude": "40.97315000",
                        "longitude": "-73.96153000"
                    },
                    {
                        "id": 114428,
                        "name": "Collings Lakes",
                        "latitude": "39.59567000",
                        "longitude": "-74.88156000"
                    },
                    {
                        "id": 114429,
                        "name": "Collingswood",
                        "latitude": "39.91817000",
                        "longitude": "-75.07128000"
                    },
                    {
                        "id": 114446,
                        "name": "Colonia",
                        "latitude": "40.57455000",
                        "longitude": "-74.30209000"
                    },
                    {
                        "id": 114546,
                        "name": "Concordia",
                        "latitude": "40.31094000",
                        "longitude": "-74.44821000"
                    },
                    {
                        "id": 114722,
                        "name": "Country Lake Estates",
                        "latitude": "39.94262000",
                        "longitude": "-74.54404000"
                    },
                    {
                        "id": 114764,
                        "name": "Cranbury",
                        "latitude": "40.31622000",
                        "longitude": "-74.51376000"
                    },
                    {
                        "id": 114767,
                        "name": "Crandon Lakes",
                        "latitude": "41.12426000",
                        "longitude": "-74.83989000"
                    },
                    {
                        "id": 114771,
                        "name": "Cranford",
                        "latitude": "40.65844000",
                        "longitude": "-74.29959000"
                    },
                    {
                        "id": 114799,
                        "name": "Cresskill",
                        "latitude": "40.94149000",
                        "longitude": "-73.95930000"
                    },
                    {
                        "id": 114812,
                        "name": "Crestwood Village",
                        "latitude": "39.94817000",
                        "longitude": "-74.36070000"
                    },
                    {
                        "id": 114915,
                        "name": "Cumberland County",
                        "latitude": "39.32807000",
                        "longitude": "-75.12934000"
                    },
                    {
                        "id": 115097,
                        "name": "Dayton",
                        "latitude": "40.37261000",
                        "longitude": "-74.51015000"
                    },
                    {
                        "id": 115197,
                        "name": "Delanco",
                        "latitude": "40.05067000",
                        "longitude": "-74.95350000"
                    },
                    {
                        "id": 115230,
                        "name": "Demarest",
                        "latitude": "40.95732000",
                        "longitude": "-73.96347000"
                    },
                    {
                        "id": 115449,
                        "name": "Dover",
                        "latitude": "40.88399000",
                        "longitude": "-74.56210000"
                    },
                    {
                        "id": 115454,
                        "name": "Dover Beaches North",
                        "latitude": "39.99123000",
                        "longitude": "-74.06375000"
                    },
                    {
                        "id": 115455,
                        "name": "Dover Beaches South",
                        "latitude": "39.95567000",
                        "longitude": "-74.07430000"
                    },
                    {
                        "id": 115518,
                        "name": "Dumont",
                        "latitude": "40.94065000",
                        "longitude": "-73.99681000"
                    },
                    {
                        "id": 115535,
                        "name": "Dunellen",
                        "latitude": "40.58927000",
                        "longitude": "-74.47182000"
                    },
                    {
                        "id": 115641,
                        "name": "East Brunswick",
                        "latitude": "40.42788000",
                        "longitude": "-74.41598000"
                    },
                    {
                        "id": 115664,
                        "name": "East Franklin",
                        "latitude": "40.49330000",
                        "longitude": "-74.47110000"
                    },
                    {
                        "id": 115665,
                        "name": "East Freehold",
                        "latitude": "40.28094000",
                        "longitude": "-74.25126000"
                    },
                    {
                        "id": 115682,
                        "name": "East Hanover",
                        "latitude": "40.82010000",
                        "longitude": "-74.36487000"
                    },
                    {
                        "id": 115720,
                        "name": "East Newark",
                        "latitude": "40.74843000",
                        "longitude": "-74.16181000"
                    },
                    {
                        "id": 115726,
                        "name": "East Orange",
                        "latitude": "40.76732000",
                        "longitude": "-74.20487000"
                    },
                    {
                        "id": 115752,
                        "name": "East Rutherford",
                        "latitude": "40.83399000",
                        "longitude": "-74.09709000"
                    },
                    {
                        "id": 115807,
                        "name": "Eatontown",
                        "latitude": "40.29622000",
                        "longitude": "-74.05097000"
                    },
                    {
                        "id": 115813,
                        "name": "Echelon",
                        "latitude": "39.84845000",
                        "longitude": "-74.99572000"
                    },
                    {
                        "id": 115854,
                        "name": "Edgewater",
                        "latitude": "40.82704000",
                        "longitude": "-73.97569000"
                    },
                    {
                        "id": 115856,
                        "name": "Edgewater Park",
                        "latitude": "40.06817000",
                        "longitude": "-74.90072000"
                    },
                    {
                        "id": 115875,
                        "name": "Edison",
                        "latitude": "40.51872000",
                        "longitude": "-74.41210000"
                    },
                    {
                        "id": 115901,
                        "name": "Egg Harbor City",
                        "latitude": "39.52873000",
                        "longitude": "-74.64794000"
                    },
                    {
                        "id": 115972,
                        "name": "Elizabeth",
                        "latitude": "40.66399000",
                        "longitude": "-74.21070000"
                    },
                    {
                        "id": 116033,
                        "name": "Ellisburg",
                        "latitude": "39.91372000",
                        "longitude": "-75.01045000"
                    },
                    {
                        "id": 116050,
                        "name": "Elmer",
                        "latitude": "39.59511000",
                        "longitude": "-75.17018000"
                    },
                    {
                        "id": 116063,
                        "name": "Elmwood Park",
                        "latitude": "40.90399000",
                        "longitude": "-74.11848000"
                    },
                    {
                        "id": 116078,
                        "name": "Elwood",
                        "latitude": "39.57651000",
                        "longitude": "-74.71683000"
                    },
                    {
                        "id": 116094,
                        "name": "Emerson",
                        "latitude": "40.97621000",
                        "longitude": "-74.02625000"
                    },
                    {
                        "id": 116132,
                        "name": "Englewood",
                        "latitude": "40.89288000",
                        "longitude": "-73.97264000"
                    },
                    {
                        "id": 116134,
                        "name": "Englewood Cliffs",
                        "latitude": "40.88538000",
                        "longitude": "-73.95236000"
                    },
                    {
                        "id": 116136,
                        "name": "Englishtown",
                        "latitude": "40.29733000",
                        "longitude": "-74.35820000"
                    },
                    {
                        "id": 116173,
                        "name": "Erma",
                        "latitude": "38.98776000",
                        "longitude": "-74.90170000"
                    },
                    {
                        "id": 116195,
                        "name": "Essex County",
                        "latitude": "40.78707000",
                        "longitude": "-74.24687000"
                    },
                    {
                        "id": 116198,
                        "name": "Essex Fells",
                        "latitude": "40.82454000",
                        "longitude": "-74.28459000"
                    },
                    {
                        "id": 116204,
                        "name": "Estell Manor",
                        "latitude": "39.41206000",
                        "longitude": "-74.74239000"
                    },
                    {
                        "id": 116268,
                        "name": "Ewing",
                        "latitude": "40.26983000",
                        "longitude": "-74.79988000"
                    },
                    {
                        "id": 116282,
                        "name": "Fair Haven",
                        "latitude": "40.36067000",
                        "longitude": "-74.03819000"
                    },
                    {
                        "id": 116284,
                        "name": "Fair Lawn",
                        "latitude": "40.94038000",
                        "longitude": "-74.13181000"
                    },
                    {
                        "id": 116315,
                        "name": "Fairfield",
                        "latitude": "40.88371000",
                        "longitude": "-74.30598000"
                    },
                    {
                        "id": 116346,
                        "name": "Fairton",
                        "latitude": "39.38178000",
                        "longitude": "-75.21991000"
                    },
                    {
                        "id": 116352,
                        "name": "Fairview",
                        "latitude": "40.81260000",
                        "longitude": "-73.99903000"
                    },
                    {
                        "id": 116394,
                        "name": "Fanwood",
                        "latitude": "40.64094000",
                        "longitude": "-74.38348000"
                    },
                    {
                        "id": 116410,
                        "name": "Farmingdale",
                        "latitude": "40.19650000",
                        "longitude": "-74.16848000"
                    },
                    {
                        "id": 116515,
                        "name": "Finderne",
                        "latitude": "40.56316000",
                        "longitude": "-74.57766000"
                    },
                    {
                        "id": 116562,
                        "name": "Flemington",
                        "latitude": "40.51233000",
                        "longitude": "-74.85933000"
                    },
                    {
                        "id": 116582,
                        "name": "Florence",
                        "latitude": "39.73428000",
                        "longitude": "-74.91822000"
                    },
                    {
                        "id": 116591,
                        "name": "Florham Park",
                        "latitude": "40.78788000",
                        "longitude": "-74.38821000"
                    },
                    {
                        "id": 116624,
                        "name": "Folsom",
                        "latitude": "39.60206000",
                        "longitude": "-74.84267000"
                    },
                    {
                        "id": 116640,
                        "name": "Fords",
                        "latitude": "40.52927000",
                        "longitude": "-74.31598000"
                    },
                    {
                        "id": 116674,
                        "name": "Forked River",
                        "latitude": "39.83984000",
                        "longitude": "-74.19014000"
                    },
                    {
                        "id": 116706,
                        "name": "Fort Dix",
                        "latitude": "40.02984000",
                        "longitude": "-74.61849000"
                    },
                    {
                        "id": 116723,
                        "name": "Fort Lee",
                        "latitude": "40.85093000",
                        "longitude": "-73.97014000"
                    },
                    {
                        "id": 116838,
                        "name": "Franklin",
                        "latitude": "41.12204000",
                        "longitude": "-74.58044000"
                    },
                    {
                        "id": 116842,
                        "name": "Franklin Center",
                        "latitude": "40.53153000",
                        "longitude": "-74.54141000"
                    },
                    {
                        "id": 116866,
                        "name": "Franklin Lakes",
                        "latitude": "41.01676000",
                        "longitude": "-74.20570000"
                    },
                    {
                        "id": 116869,
                        "name": "Franklin Park",
                        "latitude": "40.43899000",
                        "longitude": "-74.53515000"
                    },
                    {
                        "id": 116904,
                        "name": "Freehold",
                        "latitude": "40.26011000",
                        "longitude": "-74.27376000"
                    },
                    {
                        "id": 116934,
                        "name": "Frenchtown",
                        "latitude": "40.52621000",
                        "longitude": "-75.06156000"
                    },
                    {
                        "id": 117081,
                        "name": "Garfield",
                        "latitude": "40.88149000",
                        "longitude": "-74.11320000"
                    },
                    {
                        "id": 117105,
                        "name": "Garwood",
                        "latitude": "40.65177000",
                        "longitude": "-74.32293000"
                    },
                    {
                        "id": 117183,
                        "name": "Gibbsboro",
                        "latitude": "39.83817000",
                        "longitude": "-74.96489000"
                    },
                    {
                        "id": 117184,
                        "name": "Gibbstown",
                        "latitude": "39.82511000",
                        "longitude": "-75.28352000"
                    },
                    {
                        "id": 117238,
                        "name": "Gladstone",
                        "latitude": "40.72260000",
                        "longitude": "-74.66544000"
                    },
                    {
                        "id": 117251,
                        "name": "Glassboro",
                        "latitude": "39.70289000",
                        "longitude": "-75.11184000"
                    },
                    {
                        "id": 117266,
                        "name": "Glen Gardner",
                        "latitude": "40.69677000",
                        "longitude": "-74.94072000"
                    },
                    {
                        "id": 117271,
                        "name": "Glen Ridge",
                        "latitude": "40.80538000",
                        "longitude": "-74.20376000"
                    },
                    {
                        "id": 117273,
                        "name": "Glen Rock",
                        "latitude": "40.96288000",
                        "longitude": "-74.13292000"
                    },
                    {
                        "id": 117290,
                        "name": "Glendora",
                        "latitude": "39.83956000",
                        "longitude": "-75.07351000"
                    },
                    {
                        "id": 117323,
                        "name": "Gloucester City",
                        "latitude": "39.89178000",
                        "longitude": "-75.11629000"
                    },
                    {
                        "id": 117324,
                        "name": "Gloucester County",
                        "latitude": "39.71731000",
                        "longitude": "-75.14167000"
                    },
                    {
                        "id": 117354,
                        "name": "Golden Triangle",
                        "latitude": "39.92789000",
                        "longitude": "-75.03878000"
                    },
                    {
                        "id": 117600,
                        "name": "Green Knoll",
                        "latitude": "40.60010000",
                        "longitude": "-74.61210000"
                    },
                    {
                        "id": 117675,
                        "name": "Greentree",
                        "latitude": "39.89706000",
                        "longitude": "-74.95572000"
                    },
                    {
                        "id": 117766,
                        "name": "Groveville",
                        "latitude": "40.16983000",
                        "longitude": "-74.67155000"
                    },
                    {
                        "id": 117817,
                        "name": "Guttenberg",
                        "latitude": "40.79205000",
                        "longitude": "-74.00375000"
                    },
                    {
                        "id": 117828,
                        "name": "Hackensack",
                        "latitude": "40.88593000",
                        "longitude": "-74.04347000"
                    },
                    {
                        "id": 117829,
                        "name": "Hackettstown",
                        "latitude": "40.85399000",
                        "longitude": "-74.82906000"
                    },
                    {
                        "id": 117831,
                        "name": "Haddon Heights",
                        "latitude": "39.87734000",
                        "longitude": "-75.06462000"
                    },
                    {
                        "id": 117832,
                        "name": "Haddonfield",
                        "latitude": "39.89150000",
                        "longitude": "-75.03767000"
                    },
                    {
                        "id": 117850,
                        "name": "Haledon",
                        "latitude": "40.93565000",
                        "longitude": "-74.18626000"
                    },
                    {
                        "id": 117883,
                        "name": "Hamburg",
                        "latitude": "41.15343000",
                        "longitude": "-74.57627000"
                    },
                    {
                        "id": 117905,
                        "name": "Hamilton Square",
                        "latitude": "40.22733000",
                        "longitude": "-74.65321000"
                    },
                    {
                        "id": 117915,
                        "name": "Hammonton",
                        "latitude": "39.63651000",
                        "longitude": "-74.80239000"
                    },
                    {
                        "id": 117933,
                        "name": "Hampton",
                        "latitude": "40.70704000",
                        "longitude": "-74.95600000"
                    },
                    {
                        "id": 117973,
                        "name": "Hanover",
                        "latitude": "40.80454000",
                        "longitude": "-74.36682000"
                    },
                    {
                        "id": 118009,
                        "name": "Hardwick",
                        "latitude": "41.05454000",
                        "longitude": "-74.93212000"
                    },
                    {
                        "id": 118042,
                        "name": "Harrington Park",
                        "latitude": "40.98371000",
                        "longitude": "-73.97986000"
                    },
                    {
                        "id": 118058,
                        "name": "Harrison",
                        "latitude": "40.74649000",
                        "longitude": "-74.15626000"
                    },
                    {
                        "id": 118121,
                        "name": "Hasbrouck Heights",
                        "latitude": "40.85816000",
                        "longitude": "-74.08070000"
                    },
                    {
                        "id": 118170,
                        "name": "Haworth",
                        "latitude": "40.96093000",
                        "longitude": "-73.99014000"
                    },
                    {
                        "id": 118173,
                        "name": "Hawthorne",
                        "latitude": "40.94926000",
                        "longitude": "-74.15375000"
                    },
                    {
                        "id": 149546,
                        "name": "Hazlet Township",
                        "latitude": "40.42685010",
                        "longitude": "-74.20682440"
                    },
                    {
                        "id": 118223,
                        "name": "Heathcote",
                        "latitude": "40.38872000",
                        "longitude": "-74.57571000"
                    },
                    {
                        "id": 118260,
                        "name": "Helmetta",
                        "latitude": "40.37677000",
                        "longitude": "-74.42460000"
                    },
                    {
                        "id": 118385,
                        "name": "High Bridge",
                        "latitude": "40.66705000",
                        "longitude": "-74.89572000"
                    },
                    {
                        "id": 118407,
                        "name": "Highland Lake",
                        "latitude": "41.17676000",
                        "longitude": "-74.45655000"
                    },
                    {
                        "id": 118413,
                        "name": "Highland Park",
                        "latitude": "40.49594000",
                        "longitude": "-74.42432000"
                    },
                    {
                        "id": 118418,
                        "name": "Highlands",
                        "latitude": "40.40372000",
                        "longitude": "-73.99153000"
                    },
                    {
                        "id": 118424,
                        "name": "Hightstown",
                        "latitude": "40.26955000",
                        "longitude": "-74.52321000"
                    },
                    {
                        "id": 153288,
                        "name": "Hillsborough",
                        "latitude": "40.49807090",
                        "longitude": "-74.68498850"
                    },
                    {
                        "id": 118461,
                        "name": "Hillsdale",
                        "latitude": "41.00260000",
                        "longitude": "-74.04042000"
                    },
                    {
                        "id": 118464,
                        "name": "Hillside",
                        "latitude": "40.70121000",
                        "longitude": "-74.23015000"
                    },
                    {
                        "id": 118494,
                        "name": "Ho-Ho-Kus",
                        "latitude": "40.99649000",
                        "longitude": "-74.10125000"
                    },
                    {
                        "id": 118502,
                        "name": "Hoboken",
                        "latitude": "40.74399000",
                        "longitude": "-74.03236000"
                    },
                    {
                        "id": 118530,
                        "name": "Holiday City South",
                        "latitude": "39.95324000",
                        "longitude": "-74.23778000"
                    },
                    {
                        "id": 118531,
                        "name": "Holiday City-Berkeley",
                        "latitude": "39.96380000",
                        "longitude": "-74.27803000"
                    },
                    {
                        "id": 118532,
                        "name": "Holiday Heights",
                        "latitude": "39.94595000",
                        "longitude": "-74.25403000"
                    },
                    {
                        "id": 118640,
                        "name": "Hopatcong",
                        "latitude": "40.93288000",
                        "longitude": "-74.65933000"
                    },
                    {
                        "id": 118641,
                        "name": "Hopatcong Hills",
                        "latitude": "40.94399000",
                        "longitude": "-74.67072000"
                    },
                    {
                        "id": 118650,
                        "name": "Hopewell",
                        "latitude": "40.38927000",
                        "longitude": "-74.76183000"
                    },
                    {
                        "id": 118749,
                        "name": "Hudson County",
                        "latitude": "40.73094000",
                        "longitude": "-74.07594000"
                    },
                    {
                        "id": 118789,
                        "name": "Hunterdon County",
                        "latitude": "40.56729000",
                        "longitude": "-74.91222000"
                    },
                    {
                        "id": 119009,
                        "name": "Irvington",
                        "latitude": "40.73232000",
                        "longitude": "-74.23487000"
                    },
                    {
                        "id": 119019,
                        "name": "Iselin",
                        "latitude": "40.57538000",
                        "longitude": "-74.32237000"
                    },
                    {
                        "id": 119025,
                        "name": "Island Heights",
                        "latitude": "39.94206000",
                        "longitude": "-74.14986000"
                    },
                    {
                        "id": 119066,
                        "name": "Jackson",
                        "latitude": "39.77650000",
                        "longitude": "-74.86238000"
                    },
                    {
                        "id": 119118,
                        "name": "Jamesburg",
                        "latitude": "40.35261000",
                        "longitude": "-74.44015000"
                    },
                    {
                        "id": 119231,
                        "name": "Jersey City",
                        "latitude": "40.72816000",
                        "longitude": "-74.07764000"
                    },
                    {
                        "id": 119406,
                        "name": "Keansburg",
                        "latitude": "40.44177000",
                        "longitude": "-74.12986000"
                    },
                    {
                        "id": 119412,
                        "name": "Kearny",
                        "latitude": "40.76843000",
                        "longitude": "-74.14542000"
                    },
                    {
                        "id": 119449,
                        "name": "Kendall Park",
                        "latitude": "40.42094000",
                        "longitude": "-74.56071000"
                    },
                    {
                        "id": 119457,
                        "name": "Kenilworth",
                        "latitude": "40.67649000",
                        "longitude": "-74.29070000"
                    },
                    {
                        "id": 119502,
                        "name": "Kenvil",
                        "latitude": "40.87982000",
                        "longitude": "-74.61849000"
                    },
                    {
                        "id": 119544,
                        "name": "Keyport",
                        "latitude": "40.43316000",
                        "longitude": "-74.19959000"
                    },
                    {
                        "id": 119626,
                        "name": "Kingston",
                        "latitude": "40.37538000",
                        "longitude": "-74.61349000"
                    },
                    {
                        "id": 119631,
                        "name": "Kingston Estates",
                        "latitude": "39.92372000",
                        "longitude": "-74.98795000"
                    },
                    {
                        "id": 119639,
                        "name": "Kinnelon",
                        "latitude": "41.00176000",
                        "longitude": "-74.36710000"
                    },
                    {
                        "id": 119888,
                        "name": "Lake Como",
                        "latitude": "40.15984000",
                        "longitude": "-74.02819000"
                    },
                    {
                        "id": 119944,
                        "name": "Lake Mohawk",
                        "latitude": "41.01843000",
                        "longitude": "-74.66016000"
                    },
                    {
                        "id": 119985,
                        "name": "Lake Telemark",
                        "latitude": "40.95677000",
                        "longitude": "-74.49793000"
                    },
                    {
                        "id": 120011,
                        "name": "Lakehurst",
                        "latitude": "40.01456000",
                        "longitude": "-74.31126000"
                    },
                    {
                        "id": 120048,
                        "name": "Lakewood",
                        "latitude": "40.09789000",
                        "longitude": "-74.21764000"
                    },
                    {
                        "id": 120069,
                        "name": "Lambertville",
                        "latitude": "40.36594000",
                        "longitude": "-74.94294000"
                    },
                    {
                        "id": 120098,
                        "name": "Landing",
                        "latitude": "40.90510000",
                        "longitude": "-74.66516000"
                    },
                    {
                        "id": 120199,
                        "name": "Laurel Lake",
                        "latitude": "39.33956000",
                        "longitude": "-75.02990000"
                    },
                    {
                        "id": 120201,
                        "name": "Laurel Springs",
                        "latitude": "39.82011000",
                        "longitude": "-75.00628000"
                    },
                    {
                        "id": 120205,
                        "name": "Laurence Harbor",
                        "latitude": "40.45677000",
                        "longitude": "-74.24653000"
                    },
                    {
                        "id": 120216,
                        "name": "Lavallette",
                        "latitude": "39.97040000",
                        "longitude": "-74.06875000"
                    },
                    {
                        "id": 120223,
                        "name": "Lawnside",
                        "latitude": "39.86650000",
                        "longitude": "-75.02823000"
                    },
                    {
                        "id": 120246,
                        "name": "Lawrenceville",
                        "latitude": "40.29733000",
                        "longitude": "-74.72960000"
                    },
                    {
                        "id": 120292,
                        "name": "Lebanon",
                        "latitude": "40.64177000",
                        "longitude": "-74.83600000"
                    },
                    {
                        "id": 120341,
                        "name": "Leisure Knoll",
                        "latitude": "40.01901000",
                        "longitude": "-74.29209000"
                    },
                    {
                        "id": 120342,
                        "name": "Leisure Village",
                        "latitude": "40.04262000",
                        "longitude": "-74.18486000"
                    },
                    {
                        "id": 120343,
                        "name": "Leisure Village East",
                        "latitude": "40.03012000",
                        "longitude": "-74.16431000"
                    },
                    {
                        "id": 120344,
                        "name": "Leisure Village West-Pine Lake Park",
                        "latitude": "40.00416000",
                        "longitude": "-74.26629000"
                    },
                    {
                        "id": 120346,
                        "name": "Leisuretowne",
                        "latitude": "39.89234000",
                        "longitude": "-74.70210000"
                    },
                    {
                        "id": 120389,
                        "name": "Leonardo",
                        "latitude": "40.41733000",
                        "longitude": "-74.06208000"
                    },
                    {
                        "id": 120391,
                        "name": "Leonia",
                        "latitude": "40.86149000",
                        "longitude": "-73.98819000"
                    },
                    {
                        "id": 120542,
                        "name": "Lincoln Park",
                        "latitude": "40.92427000",
                        "longitude": "-74.30209000"
                    },
                    {
                        "id": 120556,
                        "name": "Lincroft",
                        "latitude": "40.33067000",
                        "longitude": "-74.12097000"
                    },
                    {
                        "id": 120564,
                        "name": "Linden",
                        "latitude": "40.62205000",
                        "longitude": "-74.24459000"
                    },
                    {
                        "id": 120569,
                        "name": "Lindenwold",
                        "latitude": "39.82428000",
                        "longitude": "-74.99767000"
                    },
                    {
                        "id": 120592,
                        "name": "Linwood",
                        "latitude": "39.33984000",
                        "longitude": "-74.57516000"
                    },
                    {
                        "id": 120618,
                        "name": "Little Falls",
                        "latitude": "40.86899000",
                        "longitude": "-74.20820000"
                    },
                    {
                        "id": 120620,
                        "name": "Little Ferry",
                        "latitude": "40.85288000",
                        "longitude": "-74.04208000"
                    },
                    {
                        "id": 120630,
                        "name": "Little Silver",
                        "latitude": "40.33678000",
                        "longitude": "-74.04708000"
                    },
                    {
                        "id": 120651,
                        "name": "Livingston",
                        "latitude": "40.79593000",
                        "longitude": "-74.31487000"
                    },
                    {
                        "id": 120689,
                        "name": "Lodi",
                        "latitude": "40.88232000",
                        "longitude": "-74.08320000"
                    },
                    {
                        "id": 120740,
                        "name": "Long Branch",
                        "latitude": "40.30428000",
                        "longitude": "-73.99236000"
                    },
                    {
                        "id": 120750,
                        "name": "Long Valley",
                        "latitude": "40.78593000",
                        "longitude": "-74.78016000"
                    },
                    {
                        "id": 120921,
                        "name": "Lyndhurst",
                        "latitude": "40.81204000",
                        "longitude": "-74.12431000"
                    },
                    {
                        "id": 120998,
                        "name": "Madison",
                        "latitude": "40.75982000",
                        "longitude": "-74.41710000"
                    },
                    {
                        "id": 121024,
                        "name": "Madison Park",
                        "latitude": "40.45150000",
                        "longitude": "-74.30792000"
                    },
                    {
                        "id": 121037,
                        "name": "Magnolia",
                        "latitude": "39.85456000",
                        "longitude": "-75.03906000"
                    },
                    {
                        "id": 121048,
                        "name": "Mahwah",
                        "latitude": "41.08871000",
                        "longitude": "-74.14376000"
                    },
                    {
                        "id": 121079,
                        "name": "Manahawkin",
                        "latitude": "39.69540000",
                        "longitude": "-74.25875000"
                    },
                    {
                        "id": 121081,
                        "name": "Manasquan",
                        "latitude": "40.12623000",
                        "longitude": "-74.04930000"
                    },
                    {
                        "id": 149067,
                        "name": "Mantua Township",
                        "latitude": "39.75687570",
                        "longitude": "-75.20697550"
                    },
                    {
                        "id": 121162,
                        "name": "Manville",
                        "latitude": "40.54094000",
                        "longitude": "-74.58766000"
                    },
                    {
                        "id": 121172,
                        "name": "Maple Shade",
                        "latitude": "39.95261000",
                        "longitude": "-74.99239000"
                    },
                    {
                        "id": 121179,
                        "name": "Maplewood",
                        "latitude": "40.73121000",
                        "longitude": "-74.27348000"
                    },
                    {
                        "id": 121207,
                        "name": "Margate City",
                        "latitude": "39.32789000",
                        "longitude": "-74.50349000"
                    },
                    {
                        "id": 121274,
                        "name": "Marlboro",
                        "latitude": "40.31539000",
                        "longitude": "-74.24626000"
                    },
                    {
                        "id": 121288,
                        "name": "Marlton",
                        "latitude": "39.89122000",
                        "longitude": "-74.92183000"
                    },
                    {
                        "id": 121351,
                        "name": "Martinsville",
                        "latitude": "40.60121000",
                        "longitude": "-74.55905000"
                    },
                    {
                        "id": 121400,
                        "name": "Matawan",
                        "latitude": "40.41483000",
                        "longitude": "-74.22959000"
                    },
                    {
                        "id": 121447,
                        "name": "Mays Landing",
                        "latitude": "39.45234000",
                        "longitude": "-74.72766000"
                    },
                    {
                        "id": 121458,
                        "name": "Maywood",
                        "latitude": "40.90260000",
                        "longitude": "-74.06181000"
                    },
                    {
                        "id": 121507,
                        "name": "McGuire AFB",
                        "latitude": "40.03977000",
                        "longitude": "-74.58174000"
                    },
                    {
                        "id": 121597,
                        "name": "Medford Lakes",
                        "latitude": "39.85845000",
                        "longitude": "-74.80294000"
                    },
                    {
                        "id": 121651,
                        "name": "Mendham",
                        "latitude": "40.77593000",
                        "longitude": "-74.60071000"
                    },
                    {
                        "id": 121679,
                        "name": "Mercer County",
                        "latitude": "40.28340000",
                        "longitude": "-74.70169000"
                    },
                    {
                        "id": 121684,
                        "name": "Mercerville",
                        "latitude": "40.23705000",
                        "longitude": "-74.68655000"
                    },
                    {
                        "id": 121685,
                        "name": "Mercerville-Hamilton Square",
                        "latitude": "40.23126000",
                        "longitude": "-74.67223000"
                    },
                    {
                        "id": 121686,
                        "name": "Merchantville",
                        "latitude": "39.94734000",
                        "longitude": "-75.06656000"
                    },
                    {
                        "id": 121738,
                        "name": "Metuchen",
                        "latitude": "40.54316000",
                        "longitude": "-74.36320000"
                    },
                    {
                        "id": 121774,
                        "name": "Middlebush",
                        "latitude": "40.49760000",
                        "longitude": "-74.52932000"
                    },
                    {
                        "id": 121777,
                        "name": "Middlesex",
                        "latitude": "40.57260000",
                        "longitude": "-74.49265000"
                    },
                    {
                        "id": 121781,
                        "name": "Middlesex County",
                        "latitude": "40.44004000",
                        "longitude": "-74.40889000"
                    },
                    {
                        "id": 121806,
                        "name": "Midland Park",
                        "latitude": "40.98926000",
                        "longitude": "-74.14070000"
                    },
                    {
                        "id": 121854,
                        "name": "Milford",
                        "latitude": "40.56871000",
                        "longitude": "-75.09462000"
                    },
                    {
                        "id": 121902,
                        "name": "Milltown",
                        "latitude": "40.45622000",
                        "longitude": "-74.44321000"
                    },
                    {
                        "id": 121904,
                        "name": "Millville",
                        "latitude": "39.40206000",
                        "longitude": "-75.03934000"
                    },
                    {
                        "id": 122045,
                        "name": "Monmouth Beach",
                        "latitude": "40.33039000",
                        "longitude": "-73.98153000"
                    },
                    {
                        "id": 122046,
                        "name": "Monmouth County",
                        "latitude": "40.28755000",
                        "longitude": "-74.15815000"
                    },
                    {
                        "id": 122047,
                        "name": "Monmouth Junction",
                        "latitude": "40.37900000",
                        "longitude": "-74.54654000"
                    },
                    {
                        "id": 122106,
                        "name": "Montclair",
                        "latitude": "40.82593000",
                        "longitude": "-74.20903000"
                    },
                    {
                        "id": 153289,
                        "name": "Montgomery",
                        "latitude": "40.42350110",
                        "longitude": "-74.74351950"
                    },
                    {
                        "id": 122187,
                        "name": "Montvale",
                        "latitude": "41.04676000",
                        "longitude": "-74.02292000"
                    },
                    {
                        "id": 122198,
                        "name": "Moonachie",
                        "latitude": "40.84121000",
                        "longitude": "-74.04514000"
                    },
                    {
                        "id": 122208,
                        "name": "Moorestown-Lenola",
                        "latitude": "39.96591000",
                        "longitude": "-74.96441000"
                    },
                    {
                        "id": 122254,
                        "name": "Morganville",
                        "latitude": "40.37650000",
                        "longitude": "-74.24431000"
                    },
                    {
                        "id": 122271,
                        "name": "Morris County",
                        "latitude": "40.86203000",
                        "longitude": "-74.54444000"
                    },
                    {
                        "id": 122274,
                        "name": "Morris Plains",
                        "latitude": "40.82177000",
                        "longitude": "-74.48099000"
                    },
                    {
                        "id": 122282,
                        "name": "Morristown",
                        "latitude": "40.79677000",
                        "longitude": "-74.48154000"
                    },
                    {
                        "id": 122333,
                        "name": "Mount Arlington",
                        "latitude": "40.92593000",
                        "longitude": "-74.63488000"
                    },
                    {
                        "id": 122342,
                        "name": "Mount Ephraim",
                        "latitude": "39.87845000",
                        "longitude": "-75.09267000"
                    },
                    {
                        "id": 122348,
                        "name": "Mount Holly",
                        "latitude": "39.99289000",
                        "longitude": "-74.78766000"
                    },
                    {
                        "id": 122361,
                        "name": "Mount Laurel",
                        "latitude": "39.93400000",
                        "longitude": "-74.89100000"
                    },
                    {
                        "id": 122422,
                        "name": "Mountain Lakes",
                        "latitude": "40.89482000",
                        "longitude": "-74.43293000"
                    },
                    {
                        "id": 122438,
                        "name": "Mountainside",
                        "latitude": "40.67232000",
                        "longitude": "-74.35737000"
                    },
                    {
                        "id": 122461,
                        "name": "Mullica Hill",
                        "latitude": "39.73928000",
                        "longitude": "-75.22407000"
                    },
                    {
                        "id": 122527,
                        "name": "Mystic Island",
                        "latitude": "39.54428000",
                        "longitude": "-74.38237000"
                    },
                    {
                        "id": 122593,
                        "name": "National Park",
                        "latitude": "39.86595000",
                        "longitude": "-75.17879000"
                    },
                    {
                        "id": 122604,
                        "name": "Navesink",
                        "latitude": "40.39955000",
                        "longitude": "-74.03542000"
                    },
                    {
                        "id": 122638,
                        "name": "Neptune City",
                        "latitude": "40.20011000",
                        "longitude": "-74.02792000"
                    },
                    {
                        "id": 122645,
                        "name": "Netcong",
                        "latitude": "40.89899000",
                        "longitude": "-74.70655000"
                    },
                    {
                        "id": 122677,
                        "name": "New Brunswick",
                        "latitude": "40.48622000",
                        "longitude": "-74.45182000"
                    },
                    {
                        "id": 122703,
                        "name": "New Egypt",
                        "latitude": "40.06761000",
                        "longitude": "-74.53071000"
                    },
                    {
                        "id": 122755,
                        "name": "New Milford",
                        "latitude": "40.93510000",
                        "longitude": "-74.01903000"
                    },
                    {
                        "id": 122768,
                        "name": "New Providence",
                        "latitude": "40.69843000",
                        "longitude": "-74.40154000"
                    },
                    {
                        "id": 122803,
                        "name": "Newark",
                        "latitude": "40.73566000",
                        "longitude": "-74.17237000"
                    },
                    {
                        "id": 122828,
                        "name": "Newfield",
                        "latitude": "39.54688000",
                        "longitude": "-75.02636000"
                    },
                    {
                        "id": 122867,
                        "name": "Newton",
                        "latitude": "41.05815000",
                        "longitude": "-74.75267000"
                    },
                    {
                        "id": 122965,
                        "name": "North Arlington",
                        "latitude": "40.78843000",
                        "longitude": "-74.13320000"
                    },
                    {
                        "id": 122978,
                        "name": "North Beach Haven",
                        "latitude": "39.57317000",
                        "longitude": "-74.23153000"
                    },
                    {
                        "id": 122987,
                        "name": "North Bergen",
                        "latitude": "40.80427000",
                        "longitude": "-74.01208000"
                    },
                    {
                        "id": 122999,
                        "name": "North Caldwell",
                        "latitude": "40.86482000",
                        "longitude": "-74.25820000"
                    },
                    {
                        "id": 123000,
                        "name": "North Cape May",
                        "latitude": "38.98206000",
                        "longitude": "-74.95795000"
                    },
                    {
                        "id": 123034,
                        "name": "North Haledon",
                        "latitude": "40.95510000",
                        "longitude": "-74.18598000"
                    },
                    {
                        "id": 123068,
                        "name": "North Middletown",
                        "latitude": "40.43955000",
                        "longitude": "-74.11903000"
                    },
                    {
                        "id": 123080,
                        "name": "North Plainfield",
                        "latitude": "40.63010000",
                        "longitude": "-74.42737000"
                    },
                    {
                        "id": 123129,
                        "name": "North Wildwood",
                        "latitude": "39.00067000",
                        "longitude": "-74.79933000"
                    },
                    {
                        "id": 123149,
                        "name": "Northfield",
                        "latitude": "39.37039000",
                        "longitude": "-74.55015000"
                    },
                    {
                        "id": 123169,
                        "name": "Northvale",
                        "latitude": "41.00649000",
                        "longitude": "-73.94903000"
                    },
                    {
                        "id": 123200,
                        "name": "Norwood",
                        "latitude": "40.99815000",
                        "longitude": "-73.96180000"
                    },
                    {
                        "id": 123219,
                        "name": "Nutley",
                        "latitude": "40.82232000",
                        "longitude": "-74.15987000"
                    },
                    {
                        "id": 123265,
                        "name": "Oak Valley",
                        "latitude": "39.80122000",
                        "longitude": "-75.16240000"
                    },
                    {
                        "id": 123280,
                        "name": "Oakhurst",
                        "latitude": "40.27094000",
                        "longitude": "-74.01625000"
                    },
                    {
                        "id": 123290,
                        "name": "Oakland",
                        "latitude": "41.01315000",
                        "longitude": "-74.26431000"
                    },
                    {
                        "id": 123301,
                        "name": "Oaklyn",
                        "latitude": "39.90095000",
                        "longitude": "-75.08462000"
                    },
                    {
                        "id": 123323,
                        "name": "Ocean Acres",
                        "latitude": "39.74345000",
                        "longitude": "-74.28098000"
                    },
                    {
                        "id": 123327,
                        "name": "Ocean City",
                        "latitude": "39.27762000",
                        "longitude": "-74.57460000"
                    },
                    {
                        "id": 123328,
                        "name": "Ocean County",
                        "latitude": "39.86600000",
                        "longitude": "-74.25003000"
                    },
                    {
                        "id": 123329,
                        "name": "Ocean Gate",
                        "latitude": "39.92679000",
                        "longitude": "-74.13375000"
                    },
                    {
                        "id": 123331,
                        "name": "Ocean Grove",
                        "latitude": "40.21206000",
                        "longitude": "-74.00653000"
                    },
                    {
                        "id": 123342,
                        "name": "Oceanport",
                        "latitude": "40.31817000",
                        "longitude": "-74.01514000"
                    },
                    {
                        "id": 123371,
                        "name": "Ogdensburg",
                        "latitude": "41.08176000",
                        "longitude": "-74.59238000"
                    },
                    {
                        "id": 123416,
                        "name": "Old Bridge",
                        "latitude": "40.41483000",
                        "longitude": "-74.36543000"
                    },
                    {
                        "id": 123429,
                        "name": "Old Tappan",
                        "latitude": "41.01065000",
                        "longitude": "-73.99125000"
                    },
                    {
                        "id": 123445,
                        "name": "Olivet",
                        "latitude": "39.54817000",
                        "longitude": "-75.15463000"
                    },
                    {
                        "id": 123503,
                        "name": "Oradell",
                        "latitude": "40.95871000",
                        "longitude": "-74.03681000"
                    },
                    {
                        "id": 123509,
                        "name": "Orange",
                        "latitude": "40.77066000",
                        "longitude": "-74.23265000"
                    },
                    {
                        "id": 123686,
                        "name": "Oxford",
                        "latitude": "40.80315000",
                        "longitude": "-74.98962000"
                    },
                    {
                        "id": 123739,
                        "name": "Palisades Park",
                        "latitude": "40.84816000",
                        "longitude": "-73.99764000"
                    },
                    {
                        "id": 123775,
                        "name": "Palmyra",
                        "latitude": "40.00706000",
                        "longitude": "-75.02823000"
                    },
                    {
                        "id": 123826,
                        "name": "Paramus",
                        "latitude": "40.94454000",
                        "longitude": "-74.07542000"
                    },
                    {
                        "id": 123852,
                        "name": "Park Ridge",
                        "latitude": "41.03760000",
                        "longitude": "-74.04070000"
                    },
                    {
                        "id": 123890,
                        "name": "Parsippany",
                        "latitude": "40.85788000",
                        "longitude": "-74.42599000"
                    },
                    {
                        "id": 123907,
                        "name": "Passaic",
                        "latitude": "40.85677000",
                        "longitude": "-74.12848000"
                    },
                    {
                        "id": 123908,
                        "name": "Passaic County",
                        "latitude": "41.03370000",
                        "longitude": "-74.30032000"
                    },
                    {
                        "id": 123911,
                        "name": "Paterson",
                        "latitude": "40.91677000",
                        "longitude": "-74.17181000"
                    },
                    {
                        "id": 123926,
                        "name": "Paulsboro",
                        "latitude": "39.83039000",
                        "longitude": "-75.24046000"
                    },
                    {
                        "id": 123961,
                        "name": "Peapack",
                        "latitude": "40.71677000",
                        "longitude": "-74.65655000"
                    },
                    {
                        "id": 124000,
                        "name": "Pemberton",
                        "latitude": "39.97206000",
                        "longitude": "-74.68294000"
                    },
                    {
                        "id": 124001,
                        "name": "Pemberton Heights",
                        "latitude": "39.96261000",
                        "longitude": "-74.67877000"
                    },
                    {
                        "id": 124029,
                        "name": "Pennington",
                        "latitude": "40.32844000",
                        "longitude": "-74.79072000"
                    },
                    {
                        "id": 124033,
                        "name": "Penns Grove",
                        "latitude": "39.72956000",
                        "longitude": "-75.46797000"
                    },
                    {
                        "id": 124034,
                        "name": "Pennsauken",
                        "latitude": "39.95622000",
                        "longitude": "-75.05795000"
                    },
                    {
                        "id": 124039,
                        "name": "Pennsville",
                        "latitude": "39.65345000",
                        "longitude": "-75.51659000"
                    },
                    {
                        "id": 124094,
                        "name": "Perth Amboy",
                        "latitude": "40.50677000",
                        "longitude": "-74.26542000"
                    },
                    {
                        "id": 124140,
                        "name": "Phillipsburg",
                        "latitude": "40.69371000",
                        "longitude": "-75.19018000"
                    },
                    {
                        "id": 124213,
                        "name": "Pine Beach",
                        "latitude": "39.93595000",
                        "longitude": "-74.17097000"
                    },
                    {
                        "id": 124224,
                        "name": "Pine Hill",
                        "latitude": "39.78428000",
                        "longitude": "-74.99211000"
                    },
                    {
                        "id": 124233,
                        "name": "Pine Lake Park",
                        "latitude": "40.00317000",
                        "longitude": "-74.25653000"
                    },
                    {
                        "id": 124245,
                        "name": "Pine Ridge at Crestwood",
                        "latitude": "39.95456000",
                        "longitude": "-74.31515000"
                    },
                    {
                        "id": 124282,
                        "name": "Piscataway",
                        "latitude": "40.49927000",
                        "longitude": "-74.39904000"
                    },
                    {
                        "id": 124287,
                        "name": "Pitman",
                        "latitude": "39.73289000",
                        "longitude": "-75.13157000"
                    },
                    {
                        "id": 124321,
                        "name": "Plainfield",
                        "latitude": "40.63371000",
                        "longitude": "-74.40737000"
                    },
                    {
                        "id": 124327,
                        "name": "Plainsboro Center",
                        "latitude": "40.33177000",
                        "longitude": "-74.59460000"
                    },
                    {
                        "id": 124386,
                        "name": "Pleasantville",
                        "latitude": "39.38984000",
                        "longitude": "-74.52404000"
                    },
                    {
                        "id": 124431,
                        "name": "Point Pleasant",
                        "latitude": "40.08317000",
                        "longitude": "-74.06819000"
                    },
                    {
                        "id": 124432,
                        "name": "Point Pleasant Beach",
                        "latitude": "40.09123000",
                        "longitude": "-74.04791000"
                    },
                    {
                        "id": 124457,
                        "name": "Pomona",
                        "latitude": "39.47845000",
                        "longitude": "-74.57516000"
                    },
                    {
                        "id": 124462,
                        "name": "Pompton Lakes",
                        "latitude": "41.00538000",
                        "longitude": "-74.29070000"
                    },
                    {
                        "id": 124519,
                        "name": "Port Monmouth",
                        "latitude": "40.43011000",
                        "longitude": "-74.09847000"
                    },
                    {
                        "id": 124522,
                        "name": "Port Norris",
                        "latitude": "39.24595000",
                        "longitude": "-75.03518000"
                    },
                    {
                        "id": 124527,
                        "name": "Port Reading",
                        "latitude": "40.56538000",
                        "longitude": "-74.26042000"
                    },
                    {
                        "id": 124528,
                        "name": "Port Republic",
                        "latitude": "39.52067000",
                        "longitude": "-74.48571000"
                    },
                    {
                        "id": 124646,
                        "name": "Presidential Lakes Estates",
                        "latitude": "39.91373000",
                        "longitude": "-74.56460000"
                    },
                    {
                        "id": 124689,
                        "name": "Princeton",
                        "latitude": "40.34872000",
                        "longitude": "-74.65905000"
                    },
                    {
                        "id": 124692,
                        "name": "Princeton Junction",
                        "latitude": "40.31733000",
                        "longitude": "-74.61988000"
                    },
                    {
                        "id": 124693,
                        "name": "Princeton Meadows",
                        "latitude": "40.33177000",
                        "longitude": "-74.56377000"
                    },
                    {
                        "id": 124710,
                        "name": "Prospect Park",
                        "latitude": "40.93704000",
                        "longitude": "-74.17431000"
                    },
                    {
                        "id": 124822,
                        "name": "Rahway",
                        "latitude": "40.60816000",
                        "longitude": "-74.27765000"
                    },
                    {
                        "id": 124837,
                        "name": "Ramblewood",
                        "latitude": "39.92872000",
                        "longitude": "-74.94378000"
                    },
                    {
                        "id": 124842,
                        "name": "Ramsey",
                        "latitude": "41.05732000",
                        "longitude": "-74.14098000"
                    },
                    {
                        "id": 124845,
                        "name": "Ramtown",
                        "latitude": "40.12095000",
                        "longitude": "-74.14375000"
                    },
                    {
                        "id": 124871,
                        "name": "Randolph",
                        "latitude": "40.84829000",
                        "longitude": "-74.58148000"
                    },
                    {
                        "id": 124899,
                        "name": "Raritan",
                        "latitude": "40.56955000",
                        "longitude": "-74.63294000"
                    },
                    {
                        "id": 124938,
                        "name": "Red Bank",
                        "latitude": "40.34705000",
                        "longitude": "-74.06431000"
                    },
                    {
                        "id": 125110,
                        "name": "Richwood",
                        "latitude": "39.72261000",
                        "longitude": "-75.16546000"
                    },
                    {
                        "id": 125120,
                        "name": "Ridgefield",
                        "latitude": "40.83427000",
                        "longitude": "-74.00875000"
                    },
                    {
                        "id": 125122,
                        "name": "Ridgefield Park",
                        "latitude": "40.85704000",
                        "longitude": "-74.02153000"
                    },
                    {
                        "id": 125131,
                        "name": "Ridgewood",
                        "latitude": "40.97926000",
                        "longitude": "-74.11653000"
                    },
                    {
                        "id": 125145,
                        "name": "Ringwood",
                        "latitude": "41.11343000",
                        "longitude": "-74.24543000"
                    },
                    {
                        "id": 125153,
                        "name": "Rio Grande",
                        "latitude": "39.01456000",
                        "longitude": "-74.88156000"
                    },
                    {
                        "id": 125177,
                        "name": "River Edge",
                        "latitude": "40.92871000",
                        "longitude": "-74.03986000"
                    },
                    {
                        "id": 125188,
                        "name": "River Vale",
                        "latitude": "40.99538000",
                        "longitude": "-74.01208000"
                    },
                    {
                        "id": 125194,
                        "name": "Riverdale",
                        "latitude": "40.99399000",
                        "longitude": "-74.30348000"
                    },
                    {
                        "id": 125212,
                        "name": "Riverton",
                        "latitude": "40.01150000",
                        "longitude": "-75.01489000"
                    },
                    {
                        "id": 125238,
                        "name": "Robbinsville",
                        "latitude": "40.21455000",
                        "longitude": "-74.61932000"
                    },
                    {
                        "id": 125248,
                        "name": "Robertsville",
                        "latitude": "40.34622000",
                        "longitude": "-74.28792000"
                    },
                    {
                        "id": 125260,
                        "name": "Rochelle Park",
                        "latitude": "40.90732000",
                        "longitude": "-74.07514000"
                    },
                    {
                        "id": 125289,
                        "name": "Rockaway",
                        "latitude": "40.90121000",
                        "longitude": "-74.51432000"
                    },
                    {
                        "id": 125343,
                        "name": "Roebling",
                        "latitude": "40.11594000",
                        "longitude": "-74.78627000"
                    },
                    {
                        "id": 125423,
                        "name": "Roseland",
                        "latitude": "40.82066000",
                        "longitude": "-74.29376000"
                    },
                    {
                        "id": 125427,
                        "name": "Roselle",
                        "latitude": "40.65223000",
                        "longitude": "-74.25882000"
                    },
                    {
                        "id": 125428,
                        "name": "Roselle Park",
                        "latitude": "40.66455000",
                        "longitude": "-74.26431000"
                    },
                    {
                        "id": 125436,
                        "name": "Rosenhayn",
                        "latitude": "39.47817000",
                        "longitude": "-75.13129000"
                    },
                    {
                        "id": 125454,
                        "name": "Rossmoor",
                        "latitude": "40.33650000",
                        "longitude": "-74.47349000"
                    },
                    {
                        "id": 125509,
                        "name": "Rumson",
                        "latitude": "40.37205000",
                        "longitude": "-73.99903000"
                    },
                    {
                        "id": 125513,
                        "name": "Runnemede",
                        "latitude": "39.85234000",
                        "longitude": "-75.06795000"
                    },
                    {
                        "id": 125549,
                        "name": "Rutherford",
                        "latitude": "40.82649000",
                        "longitude": "-74.10681000"
                    },
                    {
                        "id": 125579,
                        "name": "Saddle Brook",
                        "latitude": "40.89899000",
                        "longitude": "-74.09264000"
                    },
                    {
                        "id": 125581,
                        "name": "Saddle River",
                        "latitude": "41.03176000",
                        "longitude": "-74.10209000"
                    },
                    {
                        "id": 125729,
                        "name": "Salem",
                        "latitude": "39.57178000",
                        "longitude": "-75.46714000"
                    },
                    {
                        "id": 125741,
                        "name": "Salem County",
                        "latitude": "39.57658000",
                        "longitude": "-75.35791000"
                    },
                    {
                        "id": 125991,
                        "name": "Sayreville",
                        "latitude": "40.45927000",
                        "longitude": "-74.36098000"
                    },
                    {
                        "id": 125992,
                        "name": "Sayreville Junction",
                        "latitude": "40.46538000",
                        "longitude": "-74.33043000"
                    },
                    {
                        "id": 126032,
                        "name": "Scotch Plains",
                        "latitude": "40.65538000",
                        "longitude": "-74.38987000"
                    },
                    {
                        "id": 126071,
                        "name": "Sea Bright",
                        "latitude": "40.36150000",
                        "longitude": "-73.97403000"
                    },
                    {
                        "id": 126073,
                        "name": "Sea Girt",
                        "latitude": "40.13206000",
                        "longitude": "-74.03458000"
                    },
                    {
                        "id": 126074,
                        "name": "Sea Isle City",
                        "latitude": "39.15345000",
                        "longitude": "-74.69294000"
                    },
                    {
                        "id": 126081,
                        "name": "Seabrook Farms",
                        "latitude": "39.50095000",
                        "longitude": "-75.21796000"
                    },
                    {
                        "id": 126101,
                        "name": "Seaside Heights",
                        "latitude": "39.94429000",
                        "longitude": "-74.07291000"
                    },
                    {
                        "id": 126102,
                        "name": "Seaside Park",
                        "latitude": "39.92679000",
                        "longitude": "-74.07708000"
                    },
                    {
                        "id": 126112,
                        "name": "Secaucus",
                        "latitude": "40.78955000",
                        "longitude": "-74.05653000"
                    },
                    {
                        "id": 126190,
                        "name": "Sewaren",
                        "latitude": "40.55205000",
                        "longitude": "-74.25876000"
                    },
                    {
                        "id": 126225,
                        "name": "Shark River Hills",
                        "latitude": "40.19400000",
                        "longitude": "-74.04875000"
                    },
                    {
                        "id": 126356,
                        "name": "Ship Bottom",
                        "latitude": "39.64290000",
                        "longitude": "-74.18042000"
                    },
                    {
                        "id": 126376,
                        "name": "Short Hills",
                        "latitude": "40.74788000",
                        "longitude": "-74.32543000"
                    },
                    {
                        "id": 126386,
                        "name": "Shrewsbury",
                        "latitude": "40.32955000",
                        "longitude": "-74.06153000"
                    },
                    {
                        "id": 126393,
                        "name": "Sicklerville",
                        "latitude": "39.71734000",
                        "longitude": "-74.96933000"
                    },
                    {
                        "id": 126433,
                        "name": "Silver Ridge",
                        "latitude": "39.95928000",
                        "longitude": "-74.21848000"
                    },
                    {
                        "id": 126454,
                        "name": "Singac",
                        "latitude": "40.88677000",
                        "longitude": "-74.24098000"
                    },
                    {
                        "id": 126473,
                        "name": "Sixmile Run",
                        "latitude": "40.45761000",
                        "longitude": "-74.51154000"
                    },
                    {
                        "id": 126527,
                        "name": "Smithville",
                        "latitude": "39.49401000",
                        "longitude": "-74.45709000"
                    },
                    {
                        "id": 126556,
                        "name": "Society Hill",
                        "latitude": "40.53399000",
                        "longitude": "-74.45793000"
                    },
                    {
                        "id": 126574,
                        "name": "Somerdale",
                        "latitude": "39.84400000",
                        "longitude": "-75.02267000"
                    },
                    {
                        "id": 126578,
                        "name": "Somers Point",
                        "latitude": "39.31762000",
                        "longitude": "-74.59460000"
                    },
                    {
                        "id": 126583,
                        "name": "Somerset",
                        "latitude": "40.49760000",
                        "longitude": "-74.48849000"
                    },
                    {
                        "id": 126588,
                        "name": "Somerset County",
                        "latitude": "40.56351000",
                        "longitude": "-74.61631000"
                    },
                    {
                        "id": 126596,
                        "name": "Somerville",
                        "latitude": "40.57427000",
                        "longitude": "-74.60988000"
                    },
                    {
                        "id": 126612,
                        "name": "South Amboy",
                        "latitude": "40.47788000",
                        "longitude": "-74.29070000"
                    },
                    {
                        "id": 126622,
                        "name": "South Belmar",
                        "latitude": "40.17095000",
                        "longitude": "-74.02736000"
                    },
                    {
                        "id": 126630,
                        "name": "South Bound Brook",
                        "latitude": "40.55344000",
                        "longitude": "-74.53154000"
                    },
                    {
                        "id": 126697,
                        "name": "South Old Bridge",
                        "latitude": "40.40816000",
                        "longitude": "-74.35432000"
                    },
                    {
                        "id": 126698,
                        "name": "South Orange",
                        "latitude": "40.74899000",
                        "longitude": "-74.26126000"
                    },
                    {
                        "id": 126711,
                        "name": "South Plainfield",
                        "latitude": "40.57927000",
                        "longitude": "-74.41154000"
                    },
                    {
                        "id": 126717,
                        "name": "South River",
                        "latitude": "40.44649000",
                        "longitude": "-74.38598000"
                    },
                    {
                        "id": 126736,
                        "name": "South Toms River",
                        "latitude": "39.94206000",
                        "longitude": "-74.20431000"
                    },
                    {
                        "id": 126743,
                        "name": "South Vineland",
                        "latitude": "39.44595000",
                        "longitude": "-75.02879000"
                    },
                    {
                        "id": 126812,
                        "name": "Sparta",
                        "latitude": "41.03343000",
                        "longitude": "-74.63849000"
                    },
                    {
                        "id": 126846,
                        "name": "Spotswood",
                        "latitude": "40.39177000",
                        "longitude": "-74.39848000"
                    },
                    {
                        "id": 126867,
                        "name": "Spring Lake",
                        "latitude": "40.15345000",
                        "longitude": "-74.02819000"
                    },
                    {
                        "id": 126868,
                        "name": "Spring Lake Heights",
                        "latitude": "40.15039000",
                        "longitude": "-74.03097000"
                    },
                    {
                        "id": 126885,
                        "name": "Springdale",
                        "latitude": "39.90261000",
                        "longitude": "-74.96628000"
                    },
                    {
                        "id": 126900,
                        "name": "Springfield",
                        "latitude": "40.70491000",
                        "longitude": "-74.31723000"
                    },
                    {
                        "id": 126956,
                        "name": "Stanhope",
                        "latitude": "40.90288000",
                        "longitude": "-74.70905000"
                    },
                    {
                        "id": 127122,
                        "name": "Stratford",
                        "latitude": "39.82678000",
                        "longitude": "-75.01545000"
                    },
                    {
                        "id": 127130,
                        "name": "Strathmore",
                        "latitude": "40.39594000",
                        "longitude": "-74.21348000"
                    },
                    {
                        "id": 127160,
                        "name": "Succasunna",
                        "latitude": "40.86843000",
                        "longitude": "-74.64044000"
                    },
                    {
                        "id": 127213,
                        "name": "Summit",
                        "latitude": "40.71562000",
                        "longitude": "-74.36468000"
                    },
                    {
                        "id": 127286,
                        "name": "Surf City",
                        "latitude": "39.66206000",
                        "longitude": "-74.16514000"
                    },
                    {
                        "id": 127301,
                        "name": "Sussex",
                        "latitude": "41.20982000",
                        "longitude": "-74.60766000"
                    },
                    {
                        "id": 127305,
                        "name": "Sussex County",
                        "latitude": "41.13946000",
                        "longitude": "-74.69023000"
                    },
                    {
                        "id": 127334,
                        "name": "Swedesboro",
                        "latitude": "39.74761000",
                        "longitude": "-75.31047000"
                    },
                    {
                        "id": 127475,
                        "name": "Teaneck",
                        "latitude": "40.89760000",
                        "longitude": "-74.01597000"
                    },
                    {
                        "id": 127506,
                        "name": "Ten Mile Run",
                        "latitude": "40.41301000",
                        "longitude": "-74.60223000"
                    },
                    {
                        "id": 127507,
                        "name": "Tenafly",
                        "latitude": "40.92538000",
                        "longitude": "-73.96292000"
                    },
                    {
                        "id": 127667,
                        "name": "Tinton Falls",
                        "latitude": "40.30428000",
                        "longitude": "-74.10042000"
                    },
                    {
                        "id": 127716,
                        "name": "Toms River",
                        "latitude": "39.95373000",
                        "longitude": "-74.19792000"
                    },
                    {
                        "id": 127747,
                        "name": "Totowa",
                        "latitude": "40.90510000",
                        "longitude": "-74.20987000"
                    },
                    {
                        "id": 127808,
                        "name": "Trenton",
                        "latitude": "40.21705000",
                        "longitude": "-74.74294000"
                    },
                    {
                        "id": 127873,
                        "name": "Tuckerton",
                        "latitude": "39.60317000",
                        "longitude": "-74.34015000"
                    },
                    {
                        "id": 127906,
                        "name": "Turnersville",
                        "latitude": "39.77317000",
                        "longitude": "-75.05128000"
                    },
                    {
                        "id": 127934,
                        "name": "Twin Rivers",
                        "latitude": "40.26400000",
                        "longitude": "-74.49126000"
                    },
                    {
                        "id": 127977,
                        "name": "Union",
                        "latitude": "40.69760000",
                        "longitude": "-74.26320000"
                    },
                    {
                        "id": 127979,
                        "name": "Union Beach",
                        "latitude": "40.44650000",
                        "longitude": "-74.17820000"
                    },
                    {
                        "id": 127985,
                        "name": "Union City",
                        "latitude": "40.77955000",
                        "longitude": "-74.02375000"
                    },
                    {
                        "id": 127999,
                        "name": "Union County",
                        "latitude": "40.65980000",
                        "longitude": "-74.30859000"
                    },
                    {
                        "id": 128047,
                        "name": "Upper Montclair",
                        "latitude": "40.84621000",
                        "longitude": "-74.20126000"
                    },
                    {
                        "id": 128049,
                        "name": "Upper Pohatcong",
                        "latitude": "40.67747000",
                        "longitude": "-75.15580000"
                    },
                    {
                        "id": 128050,
                        "name": "Upper Saddle River",
                        "latitude": "41.05843000",
                        "longitude": "-74.09848000"
                    },
                    {
                        "id": 128174,
                        "name": "Ventnor City",
                        "latitude": "39.34039000",
                        "longitude": "-74.47737000"
                    },
                    {
                        "id": 128191,
                        "name": "Vernon Center",
                        "latitude": "41.18879000",
                        "longitude": "-74.50405000"
                    },
                    {
                        "id": 128196,
                        "name": "Vernon Valley",
                        "latitude": "41.23676000",
                        "longitude": "-74.48710000"
                    },
                    {
                        "id": 128203,
                        "name": "Verona",
                        "latitude": "40.82982000",
                        "longitude": "-74.24015000"
                    },
                    {
                        "id": 128225,
                        "name": "Victory Gardens",
                        "latitude": "40.87593000",
                        "longitude": "-74.54238000"
                    },
                    {
                        "id": 128226,
                        "name": "Victory Lakes",
                        "latitude": "39.63317000",
                        "longitude": "-74.96600000"
                    },
                    {
                        "id": 128258,
                        "name": "Villas",
                        "latitude": "39.02872000",
                        "longitude": "-74.93851000"
                    },
                    {
                        "id": 128266,
                        "name": "Vincentown",
                        "latitude": "39.93400000",
                        "longitude": "-74.74849000"
                    },
                    {
                        "id": 128270,
                        "name": "Vineland",
                        "latitude": "39.48623000",
                        "longitude": "-75.02573000"
                    },
                    {
                        "id": 128296,
                        "name": "Vista Center",
                        "latitude": "40.15928000",
                        "longitude": "-74.31792000"
                    },
                    {
                        "id": 128306,
                        "name": "Voorhees",
                        "latitude": "40.48122000",
                        "longitude": "-74.48321000"
                    },
                    {
                        "id": 128378,
                        "name": "Waldwick",
                        "latitude": "41.01065000",
                        "longitude": "-74.11792000"
                    },
                    {
                        "id": 128408,
                        "name": "Wallington",
                        "latitude": "40.85316000",
                        "longitude": "-74.11375000"
                    },
                    {
                        "id": 128447,
                        "name": "Wanamassa",
                        "latitude": "40.23178000",
                        "longitude": "-74.02542000"
                    },
                    {
                        "id": 128449,
                        "name": "Wanaque",
                        "latitude": "41.03815000",
                        "longitude": "-74.29404000"
                    },
                    {
                        "id": 128466,
                        "name": "Waretown",
                        "latitude": "39.79151000",
                        "longitude": "-74.19514000"
                    },
                    {
                        "id": 128496,
                        "name": "Warren County",
                        "latitude": "40.85725000",
                        "longitude": "-74.99702000"
                    },
                    {
                        "id": 128500,
                        "name": "Warren Township",
                        "latitude": "40.60822000",
                        "longitude": "-74.51803000"
                    },
                    {
                        "id": 128548,
                        "name": "Washington",
                        "latitude": "40.75843000",
                        "longitude": "-74.97934000"
                    },
                    {
                        "id": 128598,
                        "name": "Watchung",
                        "latitude": "40.63788000",
                        "longitude": "-74.45099000"
                    },
                    {
                        "id": 128685,
                        "name": "Wayne",
                        "latitude": "40.92538000",
                        "longitude": "-74.27654000"
                    },
                    {
                        "id": 128754,
                        "name": "Weehawken",
                        "latitude": "40.76955000",
                        "longitude": "-74.02042000"
                    },
                    {
                        "id": 128803,
                        "name": "Wenonah",
                        "latitude": "39.79456000",
                        "longitude": "-75.14879000"
                    },
                    {
                        "id": 128824,
                        "name": "West Belmar",
                        "latitude": "40.16928000",
                        "longitude": "-74.03542000"
                    },
                    {
                        "id": 128840,
                        "name": "West Cape May",
                        "latitude": "38.93872000",
                        "longitude": "-74.94184000"
                    },
                    {
                        "id": 128874,
                        "name": "West Freehold",
                        "latitude": "40.24206000",
                        "longitude": "-74.30126000"
                    },
                    {
                        "id": 128922,
                        "name": "West Long Branch",
                        "latitude": "40.29039000",
                        "longitude": "-74.01764000"
                    },
                    {
                        "id": 128932,
                        "name": "West Milford",
                        "latitude": "41.13121000",
                        "longitude": "-74.36737000"
                    },
                    {
                        "id": 128938,
                        "name": "West New York",
                        "latitude": "40.78788000",
                        "longitude": "-74.01431000"
                    },
                    {
                        "id": 128946,
                        "name": "West Orange",
                        "latitude": "40.79871000",
                        "longitude": "-74.23904000"
                    },
                    {
                        "id": 129029,
                        "name": "Westfield",
                        "latitude": "40.65899000",
                        "longitude": "-74.34737000"
                    },
                    {
                        "id": 129062,
                        "name": "Weston",
                        "latitude": "40.53510000",
                        "longitude": "-74.59071000"
                    },
                    {
                        "id": 129076,
                        "name": "Westville",
                        "latitude": "39.86789000",
                        "longitude": "-75.13156000"
                    },
                    {
                        "id": 129086,
                        "name": "Westwood",
                        "latitude": "40.99121000",
                        "longitude": "-74.03264000"
                    },
                    {
                        "id": 129103,
                        "name": "Wharton",
                        "latitude": "40.89315000",
                        "longitude": "-74.58183000"
                    },
                    {
                        "id": 129142,
                        "name": "White Horse",
                        "latitude": "40.19067000",
                        "longitude": "-74.70238000"
                    },
                    {
                        "id": 129146,
                        "name": "White Meadow Lake",
                        "latitude": "40.92371000",
                        "longitude": "-74.51071000"
                    },
                    {
                        "id": 129175,
                        "name": "Whitehouse Station",
                        "latitude": "40.61538000",
                        "longitude": "-74.77044000"
                    },
                    {
                        "id": 129181,
                        "name": "Whitesboro",
                        "latitude": "39.03900000",
                        "longitude": "-74.85684000"
                    },
                    {
                        "id": 129184,
                        "name": "Whitesboro-Burleigh",
                        "latitude": "39.04305000",
                        "longitude": "-74.86538000"
                    },
                    {
                        "id": 129211,
                        "name": "Whittingham",
                        "latitude": "40.32982000",
                        "longitude": "-74.44511000"
                    },
                    {
                        "id": 129238,
                        "name": "Wildwood",
                        "latitude": "38.99178000",
                        "longitude": "-74.81489000"
                    },
                    {
                        "id": 129241,
                        "name": "Wildwood Crest",
                        "latitude": "38.97484000",
                        "longitude": "-74.83350000"
                    },
                    {
                        "id": 129286,
                        "name": "Williamstown",
                        "latitude": "39.68623000",
                        "longitude": "-74.99517000"
                    },
                    {
                        "id": 129294,
                        "name": "Willingboro",
                        "latitude": "40.02789000",
                        "longitude": "-74.86905000"
                    },
                    {
                        "id": 129399,
                        "name": "Winfield",
                        "latitude": "40.64260000",
                        "longitude": "-74.28543000"
                    },
                    {
                        "id": 129491,
                        "name": "Wood-Lynne",
                        "latitude": "39.91734000",
                        "longitude": "-75.09629000"
                    },
                    {
                        "id": 129492,
                        "name": "Wood-Ridge",
                        "latitude": "40.84566000",
                        "longitude": "-74.08792000"
                    },
                    {
                        "id": 129495,
                        "name": "Woodbine",
                        "latitude": "39.24178000",
                        "longitude": "-74.81517000"
                    },
                    {
                        "id": 129501,
                        "name": "Woodbridge",
                        "latitude": "40.55760000",
                        "longitude": "-74.28459000"
                    },
                    {
                        "id": 129506,
                        "name": "Woodbury",
                        "latitude": "39.83817000",
                        "longitude": "-75.15268000"
                    },
                    {
                        "id": 129513,
                        "name": "Woodbury Heights",
                        "latitude": "39.81706000",
                        "longitude": "-75.15518000"
                    },
                    {
                        "id": 129514,
                        "name": "Woodcliff Lake",
                        "latitude": "41.02343000",
                        "longitude": "-74.06653000"
                    },
                    {
                        "id": 129532,
                        "name": "Woodland Park",
                        "latitude": "40.88982000",
                        "longitude": "-74.19487000"
                    },
                    {
                        "id": 129568,
                        "name": "Woodstown",
                        "latitude": "39.65150000",
                        "longitude": "-75.32825000"
                    },
                    {
                        "id": 129623,
                        "name": "Wyckoff",
                        "latitude": "41.00954000",
                        "longitude": "-74.17292000"
                    },
                    {
                        "id": 129665,
                        "name": "Yardville",
                        "latitude": "40.18122000",
                        "longitude": "-74.66432000"
                    },
                    {
                        "id": 129701,
                        "name": "Yorketown",
                        "latitude": "40.30789000",
                        "longitude": "-74.33765000"
                    }
                ]
            },
            {
                "id": 1423,
                "name": "New Mexico",
                "iso2": "NM",
                "latitude": "34.51994020",
                "longitude": "-105.87009010",
                "type": "state",
                "cities": [
                    {
                        "id": 111060,
                        "name": "Agua Fria",
                        "latitude": "35.65448000",
                        "longitude": "-106.02224000"
                    },
                    {
                        "id": 111094,
                        "name": "Alamo",
                        "latitude": "34.42089000",
                        "longitude": "-107.51088000"
                    },
                    {
                        "id": 111097,
                        "name": "Alamogordo",
                        "latitude": "32.89953000",
                        "longitude": "-105.96027000"
                    },
                    {
                        "id": 111130,
                        "name": "Albuquerque",
                        "latitude": "35.08449000",
                        "longitude": "-106.65114000"
                    },
                    {
                        "id": 111335,
                        "name": "Angel Fire",
                        "latitude": "36.39309000",
                        "longitude": "-105.28501000"
                    },
                    {
                        "id": 111369,
                        "name": "Anthony",
                        "latitude": "32.00399000",
                        "longitude": "-106.60583000"
                    },
                    {
                        "id": 111446,
                        "name": "Arenas Valley",
                        "latitude": "32.79396000",
                        "longitude": "-108.18421000"
                    },
                    {
                        "id": 111495,
                        "name": "Arroyo Seco",
                        "latitude": "36.51669000",
                        "longitude": "-105.56918000"
                    },
                    {
                        "id": 111497,
                        "name": "Artesia",
                        "latitude": "32.84233000",
                        "longitude": "-104.40330000"
                    },
                    {
                        "id": 111605,
                        "name": "Atoka",
                        "latitude": "32.76956000",
                        "longitude": "-104.38885000"
                    },
                    {
                        "id": 111712,
                        "name": "Aztec",
                        "latitude": "36.82223000",
                        "longitude": "-107.99285000"
                    },
                    {
                        "id": 111937,
                        "name": "Bayard",
                        "latitude": "32.76174000",
                        "longitude": "-108.13060000"
                    },
                    {
                        "id": 112054,
                        "name": "Belen",
                        "latitude": "34.66284000",
                        "longitude": "-106.77642000"
                    },
                    {
                        "id": 112220,
                        "name": "Berino",
                        "latitude": "32.07093000",
                        "longitude": "-106.62138000"
                    },
                    {
                        "id": 112242,
                        "name": "Bernalillo",
                        "latitude": "35.30004000",
                        "longitude": "-106.55114000"
                    },
                    {
                        "id": 112243,
                        "name": "Bernalillo County",
                        "latitude": "35.05131000",
                        "longitude": "-106.67017000"
                    },
                    {
                        "id": 112384,
                        "name": "Black Rock",
                        "latitude": "35.08837000",
                        "longitude": "-108.79119000"
                    },
                    {
                        "id": 112440,
                        "name": "Bloomfield",
                        "latitude": "36.71112000",
                        "longitude": "-107.98451000"
                    },
                    {
                        "id": 112512,
                        "name": "Boles Acres",
                        "latitude": "32.80703000",
                        "longitude": "-105.98610000"
                    },
                    {
                        "id": 112585,
                        "name": "Bosque Farms",
                        "latitude": "34.85478000",
                        "longitude": "-106.70530000"
                    },
                    {
                        "id": 113331,
                        "name": "Cannon Air Force Base",
                        "latitude": "34.39689000",
                        "longitude": "-103.32444000"
                    },
                    {
                        "id": 113374,
                        "name": "Capitan",
                        "latitude": "33.54536000",
                        "longitude": "-105.57220000"
                    },
                    {
                        "id": 113409,
                        "name": "Carlsbad",
                        "latitude": "32.42067000",
                        "longitude": "-104.22884000"
                    },
                    {
                        "id": 113431,
                        "name": "Carnuel",
                        "latitude": "35.06394000",
                        "longitude": "-106.45725000"
                    },
                    {
                        "id": 113448,
                        "name": "Carrizozo",
                        "latitude": "33.64174000",
                        "longitude": "-105.87721000"
                    },
                    {
                        "id": 113578,
                        "name": "Catron County",
                        "latitude": "33.91533000",
                        "longitude": "-108.40473000"
                    },
                    {
                        "id": 113717,
                        "name": "Chama",
                        "latitude": "36.90307000",
                        "longitude": "-106.57948000"
                    },
                    {
                        "id": 113740,
                        "name": "Chaparral",
                        "latitude": "32.02376000",
                        "longitude": "-106.38566000"
                    },
                    {
                        "id": 113817,
                        "name": "Chaves County",
                        "latitude": "33.36319000",
                        "longitude": "-104.46700000"
                    },
                    {
                        "id": 113958,
                        "name": "Chimayo",
                        "latitude": "36.00391000",
                        "longitude": "-105.94697000"
                    },
                    {
                        "id": 114010,
                        "name": "Church Rock",
                        "latitude": "35.53391000",
                        "longitude": "-108.59980000"
                    },
                    {
                        "id": 114017,
                        "name": "Cibola County",
                        "latitude": "34.91257000",
                        "longitude": "-107.99971000"
                    },
                    {
                        "id": 114204,
                        "name": "Clayton",
                        "latitude": "36.45169000",
                        "longitude": "-103.18410000"
                    },
                    {
                        "id": 114316,
                        "name": "Clovis",
                        "latitude": "34.40480000",
                        "longitude": "-103.20523000"
                    },
                    {
                        "id": 114411,
                        "name": "Colfax County",
                        "latitude": "36.60612000",
                        "longitude": "-104.64686000"
                    },
                    {
                        "id": 114498,
                        "name": "Columbus",
                        "latitude": "31.82760000",
                        "longitude": "-107.64002000"
                    },
                    {
                        "id": 114666,
                        "name": "Corrales",
                        "latitude": "35.23782000",
                        "longitude": "-106.60669000"
                    },
                    {
                        "id": 114868,
                        "name": "Crownpoint",
                        "latitude": "35.67808000",
                        "longitude": "-108.15118000"
                    },
                    {
                        "id": 114927,
                        "name": "Curry County",
                        "latitude": "34.57416000",
                        "longitude": "-103.34691000"
                    },
                    {
                        "id": 115104,
                        "name": "De Baca County",
                        "latitude": "34.34239000",
                        "longitude": "-104.41200000"
                    },
                    {
                        "id": 115231,
                        "name": "Deming",
                        "latitude": "32.26870000",
                        "longitude": "-107.75864000"
                    },
                    {
                        "id": 115311,
                        "name": "Dexter",
                        "latitude": "33.19733000",
                        "longitude": "-104.37302000"
                    },
                    {
                        "id": 115464,
                        "name": "Doña Ana",
                        "latitude": "32.38954000",
                        "longitude": "-106.81390000"
                    },
                    {
                        "id": 115465,
                        "name": "Doña Ana County",
                        "latitude": "32.35268000",
                        "longitude": "-106.83280000"
                    },
                    {
                        "id": 115510,
                        "name": "Dulce",
                        "latitude": "36.93362000",
                        "longitude": "-106.99893000"
                    },
                    {
                        "id": 115824,
                        "name": "Eddy County",
                        "latitude": "32.47149000",
                        "longitude": "-104.30431000"
                    },
                    {
                        "id": 115863,
                        "name": "Edgewood",
                        "latitude": "35.06144000",
                        "longitude": "-106.19141000"
                    },
                    {
                        "id": 115917,
                        "name": "El Cerro",
                        "latitude": "34.72700000",
                        "longitude": "-106.71086000"
                    },
                    {
                        "id": 115918,
                        "name": "El Cerro Mission",
                        "latitude": "34.76227000",
                        "longitude": "-106.64450000"
                    },
                    {
                        "id": 115934,
                        "name": "El Rancho",
                        "latitude": "35.88919000",
                        "longitude": "-106.07975000"
                    },
                    {
                        "id": 115939,
                        "name": "El Valle de Arroyo Seco",
                        "latitude": "35.96280000",
                        "longitude": "-106.02947000"
                    },
                    {
                        "id": 115955,
                        "name": "Eldorado at Santa Fe",
                        "latitude": "35.52642000",
                        "longitude": "-105.93474000"
                    },
                    {
                        "id": 115961,
                        "name": "Elephant Butte",
                        "latitude": "33.14868000",
                        "longitude": "-107.18475000"
                    },
                    {
                        "id": 116117,
                        "name": "Enchanted Hills",
                        "latitude": "35.33676000",
                        "longitude": "-106.59296000"
                    },
                    {
                        "id": 116188,
                        "name": "Española",
                        "latitude": "35.99113000",
                        "longitude": "-106.08058000"
                    },
                    {
                        "id": 116203,
                        "name": "Estancia",
                        "latitude": "34.75839000",
                        "longitude": "-106.05585000"
                    },
                    {
                        "id": 116230,
                        "name": "Eunice",
                        "latitude": "32.43734000",
                        "longitude": "-103.15908000"
                    },
                    {
                        "id": 116421,
                        "name": "Farmington",
                        "latitude": "36.72806000",
                        "longitude": "-108.21869000"
                    },
                    {
                        "id": 116573,
                        "name": "Flora Vista",
                        "latitude": "36.79445000",
                        "longitude": "-108.08035000"
                    },
                    {
                        "id": 116753,
                        "name": "Fort Sumner",
                        "latitude": "34.47173000",
                        "longitude": "-104.24553000"
                    },
                    {
                        "id": 117039,
                        "name": "Gallup",
                        "latitude": "35.52808000",
                        "longitude": "-108.74258000"
                    },
                    {
                        "id": 117517,
                        "name": "Grant County",
                        "latitude": "32.73901000",
                        "longitude": "-108.38225000"
                    },
                    {
                        "id": 117527,
                        "name": "Grants",
                        "latitude": "35.14760000",
                        "longitude": "-107.85261000"
                    },
                    {
                        "id": 117779,
                        "name": "Guadalupe County",
                        "latitude": "34.86333000",
                        "longitude": "-104.79070000"
                    },
                    {
                        "id": 117836,
                        "name": "Hagerman",
                        "latitude": "33.11511000",
                        "longitude": "-104.32691000"
                    },
                    {
                        "id": 118004,
                        "name": "Harding County",
                        "latitude": "35.85794000",
                        "longitude": "-103.81993000"
                    },
                    {
                        "id": 118137,
                        "name": "Hatch",
                        "latitude": "32.66536000",
                        "longitude": "-107.15307000"
                    },
                    {
                        "id": 118375,
                        "name": "Hidalgo County",
                        "latitude": "31.91416000",
                        "longitude": "-108.71482000"
                    },
                    {
                        "id": 118500,
                        "name": "Hobbs",
                        "latitude": "32.70261000",
                        "longitude": "-103.13604000"
                    },
                    {
                        "id": 118554,
                        "name": "Holloman Air Force Base",
                        "latitude": "32.84827000",
                        "longitude": "-106.09977000"
                    },
                    {
                        "id": 118822,
                        "name": "Hurley",
                        "latitude": "32.69924000",
                        "longitude": "-108.13199000"
                    },
                    {
                        "id": 119110,
                        "name": "Jal",
                        "latitude": "32.11318000",
                        "longitude": "-103.19351000"
                    },
                    {
                        "id": 119133,
                        "name": "Jarales",
                        "latitude": "34.61312000",
                        "longitude": "-106.76364000"
                    },
                    {
                        "id": 119210,
                        "name": "Jemez Pueblo",
                        "latitude": "35.61422000",
                        "longitude": "-106.72832000"
                    },
                    {
                        "id": 119419,
                        "name": "Keeler Farm",
                        "latitude": "32.31607000",
                        "longitude": "-107.76023000"
                    },
                    {
                        "id": 119655,
                        "name": "Kirtland",
                        "latitude": "36.73417000",
                        "longitude": "-108.35980000"
                    },
                    {
                        "id": 119739,
                        "name": "La Cienega",
                        "latitude": "35.56281000",
                        "longitude": "-106.13086000"
                    },
                    {
                        "id": 119759,
                        "name": "La Huerta",
                        "latitude": "32.44290000",
                        "longitude": "-104.22106000"
                    },
                    {
                        "id": 119763,
                        "name": "La Luz",
                        "latitude": "32.97787000",
                        "longitude": "-105.94193000"
                    },
                    {
                        "id": 119766,
                        "name": "La Mesilla",
                        "latitude": "35.94836000",
                        "longitude": "-106.07058000"
                    },
                    {
                        "id": 119781,
                        "name": "La Puebla",
                        "latitude": "35.98919000",
                        "longitude": "-105.99641000"
                    },
                    {
                        "id": 119790,
                        "name": "La Union",
                        "latitude": "31.95066000",
                        "longitude": "-106.66166000"
                    },
                    {
                        "id": 119850,
                        "name": "Laguna",
                        "latitude": "35.03671000",
                        "longitude": "-107.38282000"
                    },
                    {
                        "id": 120155,
                        "name": "Las Cruces",
                        "latitude": "32.31232000",
                        "longitude": "-106.77834000"
                    },
                    {
                        "id": 120159,
                        "name": "Las Maravillas",
                        "latitude": "34.73815000",
                        "longitude": "-106.66854000"
                    },
                    {
                        "id": 120164,
                        "name": "Las Vegas",
                        "latitude": "35.59393000",
                        "longitude": "-105.22390000"
                    },
                    {
                        "id": 120267,
                        "name": "Lea County",
                        "latitude": "32.79218000",
                        "longitude": "-103.41245000"
                    },
                    {
                        "id": 120305,
                        "name": "Lee Acres",
                        "latitude": "35.14866000",
                        "longitude": "-106.64697000"
                    },
                    {
                        "id": 120531,
                        "name": "Lincoln County",
                        "latitude": "33.74524000",
                        "longitude": "-105.45925000"
                    },
                    {
                        "id": 120770,
                        "name": "Lordsburg",
                        "latitude": "32.35036000",
                        "longitude": "-108.70866000"
                    },
                    {
                        "id": 120780,
                        "name": "Los Alamos",
                        "latitude": "35.88808000",
                        "longitude": "-106.30697000"
                    },
                    {
                        "id": 120781,
                        "name": "Los Alamos County",
                        "latitude": "35.86937000",
                        "longitude": "-106.30729000"
                    },
                    {
                        "id": 120787,
                        "name": "Los Chavez",
                        "latitude": "34.72571000",
                        "longitude": "-106.75726000"
                    },
                    {
                        "id": 120791,
                        "name": "Los Lunas",
                        "latitude": "34.80617000",
                        "longitude": "-106.73336000"
                    },
                    {
                        "id": 120795,
                        "name": "Los Ranchos de Albuquerque",
                        "latitude": "35.16199000",
                        "longitude": "-106.64280000"
                    },
                    {
                        "id": 120828,
                        "name": "Loving",
                        "latitude": "32.28623000",
                        "longitude": "-104.09577000"
                    },
                    {
                        "id": 120832,
                        "name": "Lovington",
                        "latitude": "32.94401000",
                        "longitude": "-103.34855000"
                    },
                    {
                        "id": 120884,
                        "name": "Luna County",
                        "latitude": "32.18215000",
                        "longitude": "-107.74977000"
                    },
                    {
                        "id": 121511,
                        "name": "McIntosh",
                        "latitude": "34.86478000",
                        "longitude": "-106.05169000"
                    },
                    {
                        "id": 121522,
                        "name": "McKinley County",
                        "latitude": "35.58061000",
                        "longitude": "-108.26193000"
                    },
                    {
                        "id": 121560,
                        "name": "Meadow Lake",
                        "latitude": "34.80144000",
                        "longitude": "-106.54363000"
                    },
                    {
                        "id": 121724,
                        "name": "Mescalero",
                        "latitude": "33.15759000",
                        "longitude": "-105.77415000"
                    },
                    {
                        "id": 121725,
                        "name": "Mesilla",
                        "latitude": "32.27009000",
                        "longitude": "-106.80084000"
                    },
                    {
                        "id": 121728,
                        "name": "Mesquite",
                        "latitude": "32.16454000",
                        "longitude": "-106.69666000"
                    },
                    {
                        "id": 121841,
                        "name": "Milan",
                        "latitude": "35.16976000",
                        "longitude": "-107.89089000"
                    },
                    {
                        "id": 122123,
                        "name": "Monterey Park",
                        "latitude": "34.75898000",
                        "longitude": "-106.64085000"
                    },
                    {
                        "id": 122219,
                        "name": "Mora",
                        "latitude": "35.97420000",
                        "longitude": "-105.33001000"
                    },
                    {
                        "id": 122220,
                        "name": "Mora County",
                        "latitude": "36.00995000",
                        "longitude": "-104.94458000"
                    },
                    {
                        "id": 122255,
                        "name": "Moriarty",
                        "latitude": "34.99005000",
                        "longitude": "-106.04919000"
                    },
                    {
                        "id": 122306,
                        "name": "Mosquero",
                        "latitude": "35.77698000",
                        "longitude": "-103.95664000"
                    },
                    {
                        "id": 122537,
                        "name": "Nambe",
                        "latitude": "35.89336000",
                        "longitude": "-105.98252000"
                    },
                    {
                        "id": 122597,
                        "name": "Navajo",
                        "latitude": "35.90001000",
                        "longitude": "-109.03398000"
                    },
                    {
                        "id": 123119,
                        "name": "North Valley",
                        "latitude": "35.17338000",
                        "longitude": "-106.62336000"
                    },
                    {
                        "id": 123386,
                        "name": "Ohkay Owingeh",
                        "latitude": "36.05082000",
                        "longitude": "-106.06897000"
                    },
                    {
                        "id": 123626,
                        "name": "Otero County",
                        "latitude": "32.61316000",
                        "longitude": "-105.74168000"
                    },
                    {
                        "id": 123821,
                        "name": "Paradise Hills",
                        "latitude": "35.20060000",
                        "longitude": "-106.70114000"
                    },
                    {
                        "id": 123979,
                        "name": "Pecos",
                        "latitude": "35.57420000",
                        "longitude": "-105.67502000"
                    },
                    {
                        "id": 124057,
                        "name": "Peralta",
                        "latitude": "34.83700000",
                        "longitude": "-106.69058000"
                    },
                    {
                        "id": 124314,
                        "name": "Placitas",
                        "latitude": "35.30698000",
                        "longitude": "-106.42475000"
                    },
                    {
                        "id": 124436,
                        "name": "Pojoaque",
                        "latitude": "35.89280000",
                        "longitude": "-106.02308000"
                    },
                    {
                        "id": 124471,
                        "name": "Ponderosa Pine",
                        "latitude": "34.97699000",
                        "longitude": "-106.32419000"
                    },
                    {
                        "id": 124550,
                        "name": "Portales",
                        "latitude": "34.18619000",
                        "longitude": "-103.33440000"
                    },
                    {
                        "id": 124784,
                        "name": "Quay County",
                        "latitude": "35.10436000",
                        "longitude": "-103.54974000"
                    },
                    {
                        "id": 124794,
                        "name": "Questa",
                        "latitude": "36.70391000",
                        "longitude": "-105.59501000"
                    },
                    {
                        "id": 124817,
                        "name": "Radium Springs",
                        "latitude": "32.50120000",
                        "longitude": "-106.92807000"
                    },
                    {
                        "id": 124860,
                        "name": "Ranchos de Taos",
                        "latitude": "36.35864000",
                        "longitude": "-105.60946000"
                    },
                    {
                        "id": 124901,
                        "name": "Raton",
                        "latitude": "36.90336000",
                        "longitude": "-104.43915000"
                    },
                    {
                        "id": 125035,
                        "name": "Reserve",
                        "latitude": "33.71311000",
                        "longitude": "-108.75784000"
                    },
                    {
                        "id": 125147,
                        "name": "Rio Arriba County",
                        "latitude": "36.50957000",
                        "longitude": "-106.69311000"
                    },
                    {
                        "id": 125150,
                        "name": "Rio Communities",
                        "latitude": "34.64959000",
                        "longitude": "-106.73403000"
                    },
                    {
                        "id": 125158,
                        "name": "Rio Rancho",
                        "latitude": "35.23338000",
                        "longitude": "-106.66447000"
                    },
                    {
                        "id": 125393,
                        "name": "Roosevelt County",
                        "latitude": "34.02127000",
                        "longitude": "-103.48018000"
                    },
                    {
                        "id": 125463,
                        "name": "Roswell",
                        "latitude": "33.39437000",
                        "longitude": "-104.52491000"
                    },
                    {
                        "id": 125504,
                        "name": "Ruidoso",
                        "latitude": "33.33175000",
                        "longitude": "-105.67304000"
                    },
                    {
                        "id": 125505,
                        "name": "Ruidoso Downs",
                        "latitude": "33.32897000",
                        "longitude": "-105.60443000"
                    },
                    {
                        "id": 125807,
                        "name": "San Felipe Pueblo",
                        "latitude": "35.43392000",
                        "longitude": "-106.44669000"
                    },
                    {
                        "id": 125821,
                        "name": "San Juan County",
                        "latitude": "36.50847000",
                        "longitude": "-108.32060000"
                    },
                    {
                        "id": 125839,
                        "name": "San Miguel",
                        "latitude": "32.15538000",
                        "longitude": "-106.73500000"
                    },
                    {
                        "id": 125841,
                        "name": "San Miguel County",
                        "latitude": "35.48029000",
                        "longitude": "-104.81585000"
                    },
                    {
                        "id": 125851,
                        "name": "San Ysidro",
                        "latitude": "32.35093000",
                        "longitude": "-106.81112000"
                    },
                    {
                        "id": 125866,
                        "name": "Sandia Heights",
                        "latitude": "35.17699000",
                        "longitude": "-106.49141000"
                    },
                    {
                        "id": 125867,
                        "name": "Sandia Knolls",
                        "latitude": "35.16393000",
                        "longitude": "-106.31141000"
                    },
                    {
                        "id": 125869,
                        "name": "Sandoval County",
                        "latitude": "35.68855000",
                        "longitude": "-106.86584000"
                    },
                    {
                        "id": 125904,
                        "name": "Santa Clara",
                        "latitude": "32.77952000",
                        "longitude": "-108.15032000"
                    },
                    {
                        "id": 125907,
                        "name": "Santa Clara Pueblo",
                        "latitude": "35.96558000",
                        "longitude": "-106.08863000"
                    },
                    {
                        "id": 125914,
                        "name": "Santa Fe",
                        "latitude": "35.68698000",
                        "longitude": "-105.93780000"
                    },
                    {
                        "id": 125915,
                        "name": "Santa Fe County",
                        "latitude": "35.50686000",
                        "longitude": "-105.97612000"
                    },
                    {
                        "id": 125923,
                        "name": "Santa Rosa",
                        "latitude": "34.93867000",
                        "longitude": "-104.68249000"
                    },
                    {
                        "id": 125926,
                        "name": "Santa Teresa",
                        "latitude": "31.85594000",
                        "longitude": "-106.63916000"
                    },
                    {
                        "id": 125931,
                        "name": "Santo Domingo Pueblo",
                        "latitude": "35.51476000",
                        "longitude": "-106.36586000"
                    },
                    {
                        "id": 126358,
                        "name": "Shiprock",
                        "latitude": "36.78555000",
                        "longitude": "-108.68703000"
                    },
                    {
                        "id": 126403,
                        "name": "Sierra County",
                        "latitude": "33.13047000",
                        "longitude": "-107.19250000"
                    },
                    {
                        "id": 126422,
                        "name": "Silver City",
                        "latitude": "32.77007000",
                        "longitude": "-108.28033000"
                    },
                    {
                        "id": 126488,
                        "name": "Skyline-Ganipa",
                        "latitude": "35.03279000",
                        "longitude": "-107.61396000"
                    },
                    {
                        "id": 126557,
                        "name": "Socorro",
                        "latitude": "34.05840000",
                        "longitude": "-106.89142000"
                    },
                    {
                        "id": 126559,
                        "name": "Socorro County",
                        "latitude": "34.00724000",
                        "longitude": "-106.93033000"
                    },
                    {
                        "id": 126740,
                        "name": "South Valley",
                        "latitude": "35.01005000",
                        "longitude": "-106.67808000"
                    },
                    {
                        "id": 126832,
                        "name": "Spencerville",
                        "latitude": "36.82000000",
                        "longitude": "-108.05813000"
                    },
                    {
                        "id": 127254,
                        "name": "Sunland Park",
                        "latitude": "31.79650000",
                        "longitude": "-106.57999000"
                    },
                    {
                        "id": 127422,
                        "name": "Taos",
                        "latitude": "36.40725000",
                        "longitude": "-105.57307000"
                    },
                    {
                        "id": 127423,
                        "name": "Taos County",
                        "latitude": "36.57830000",
                        "longitude": "-105.63097000"
                    },
                    {
                        "id": 127424,
                        "name": "Taos Pueblo",
                        "latitude": "36.43864000",
                        "longitude": "-105.54445000"
                    },
                    {
                        "id": 127549,
                        "name": "Texico",
                        "latitude": "34.38869000",
                        "longitude": "-103.05134000"
                    },
                    {
                        "id": 127598,
                        "name": "Thoreau",
                        "latitude": "35.40253000",
                        "longitude": "-108.22340000"
                    },
                    {
                        "id": 127636,
                        "name": "Tierra Amarilla",
                        "latitude": "36.70029000",
                        "longitude": "-106.54976000"
                    },
                    {
                        "id": 127712,
                        "name": "Tome",
                        "latitude": "34.74089000",
                        "longitude": "-106.72836000"
                    },
                    {
                        "id": 127743,
                        "name": "Torrance County",
                        "latitude": "34.64047000",
                        "longitude": "-105.85078000"
                    },
                    {
                        "id": 127861,
                        "name": "Truth or Consequences",
                        "latitude": "33.12840000",
                        "longitude": "-107.25281000"
                    },
                    {
                        "id": 127876,
                        "name": "Tucumcari",
                        "latitude": "35.17191000",
                        "longitude": "-103.72686000"
                    },
                    {
                        "id": 127884,
                        "name": "Tularosa",
                        "latitude": "33.07397000",
                        "longitude": "-106.01860000"
                    },
                    {
                        "id": 127932,
                        "name": "Twin Lakes",
                        "latitude": "35.70919000",
                        "longitude": "-108.77481000"
                    },
                    {
                        "id": 128002,
                        "name": "Union County",
                        "latitude": "36.48176000",
                        "longitude": "-103.47099000"
                    },
                    {
                        "id": 128034,
                        "name": "University Park",
                        "latitude": "32.28343000",
                        "longitude": "-106.75334000"
                    },
                    {
                        "id": 128043,
                        "name": "Upper Fruitland",
                        "latitude": "36.71584000",
                        "longitude": "-108.31424000"
                    },
                    {
                        "id": 128074,
                        "name": "Vado",
                        "latitude": "32.11176000",
                        "longitude": "-106.66250000"
                    },
                    {
                        "id": 128088,
                        "name": "Valencia",
                        "latitude": "34.79950000",
                        "longitude": "-106.70030000"
                    },
                    {
                        "id": 128089,
                        "name": "Valencia County",
                        "latitude": "34.71545000",
                        "longitude": "-106.80911000"
                    },
                    {
                        "id": 128604,
                        "name": "Waterflow",
                        "latitude": "36.75972000",
                        "longitude": "-108.48175000"
                    },
                    {
                        "id": 128884,
                        "name": "West Hammond",
                        "latitude": "36.68071000",
                        "longitude": "-108.04921000"
                    },
                    {
                        "id": 129158,
                        "name": "White Rock",
                        "latitude": "35.82753000",
                        "longitude": "-106.20391000"
                    },
                    {
                        "id": 129160,
                        "name": "White Sands",
                        "latitude": "32.38093000",
                        "longitude": "-106.47944000"
                    },
                    {
                        "id": 129762,
                        "name": "Zuni Pueblo",
                        "latitude": "35.07253000",
                        "longitude": "-108.85064000"
                    }
                ]
            },
            {
                "id": 1452,
                "name": "New York",
                "iso2": "NY",
                "latitude": "40.71277530",
                "longitude": "-74.00597280",
                "type": "state",
                "cities": [
                    {
                        "id": 111014,
                        "name": "Adams",
                        "latitude": "43.80923000",
                        "longitude": "-76.02409000"
                    },
                    {
                        "id": 111016,
                        "name": "Adams Center",
                        "latitude": "43.86006000",
                        "longitude": "-76.00548000"
                    },
                    {
                        "id": 111037,
                        "name": "Addison",
                        "latitude": "42.10285000",
                        "longitude": "-77.23359000"
                    },
                    {
                        "id": 111071,
                        "name": "Airmont",
                        "latitude": "41.10093000",
                        "longitude": "-74.11625000"
                    },
                    {
                        "id": 111078,
                        "name": "Akron",
                        "latitude": "43.02089000",
                        "longitude": "-78.49530000"
                    },
                    {
                        "id": 111082,
                        "name": "Alabama",
                        "latitude": "43.09645000",
                        "longitude": "-78.39086000"
                    },
                    {
                        "id": 111108,
                        "name": "Albany",
                        "latitude": "42.65258000",
                        "longitude": "-73.75623000"
                    },
                    {
                        "id": 111112,
                        "name": "Albany County",
                        "latitude": "42.60018000",
                        "longitude": "-73.97356000"
                    },
                    {
                        "id": 111119,
                        "name": "Albertson",
                        "latitude": "40.77343000",
                        "longitude": "-73.64318000"
                    },
                    {
                        "id": 111128,
                        "name": "Albion",
                        "latitude": "43.24645000",
                        "longitude": "-78.19363000"
                    },
                    {
                        "id": 111136,
                        "name": "Alden",
                        "latitude": "42.90006000",
                        "longitude": "-78.49197000"
                    },
                    {
                        "id": 111157,
                        "name": "Alexandria Bay",
                        "latitude": "44.33588000",
                        "longitude": "-75.91773000"
                    },
                    {
                        "id": 111160,
                        "name": "Alfred",
                        "latitude": "42.25424000",
                        "longitude": "-77.79055000"
                    },
                    {
                        "id": 111180,
                        "name": "Allegany",
                        "latitude": "42.09006000",
                        "longitude": "-78.49419000"
                    },
                    {
                        "id": 111182,
                        "name": "Allegany County",
                        "latitude": "42.25739000",
                        "longitude": "-78.02756000"
                    },
                    {
                        "id": 111235,
                        "name": "Altamont",
                        "latitude": "42.70063000",
                        "longitude": "-74.03374000"
                    },
                    {
                        "id": 111262,
                        "name": "Amagansett",
                        "latitude": "40.97371000",
                        "longitude": "-72.14369000"
                    },
                    {
                        "id": 111283,
                        "name": "Amherst",
                        "latitude": "42.97839000",
                        "longitude": "-78.79976000"
                    },
                    {
                        "id": 111292,
                        "name": "Amityville",
                        "latitude": "40.67899000",
                        "longitude": "-73.41707000"
                    },
                    {
                        "id": 111295,
                        "name": "Amsterdam",
                        "latitude": "42.93869000",
                        "longitude": "-74.18819000"
                    },
                    {
                        "id": 111325,
                        "name": "Andover",
                        "latitude": "42.15646000",
                        "longitude": "-77.79555000"
                    },
                    {
                        "id": 111341,
                        "name": "Angola",
                        "latitude": "42.63839000",
                        "longitude": "-79.02782000"
                    },
                    {
                        "id": 111342,
                        "name": "Angola on the Lake",
                        "latitude": "42.65478000",
                        "longitude": "-79.04893000"
                    },
                    {
                        "id": 111383,
                        "name": "Apalachin",
                        "latitude": "42.06952000",
                        "longitude": "-76.15465000"
                    },
                    {
                        "id": 111405,
                        "name": "Aquebogue",
                        "latitude": "40.94454000",
                        "longitude": "-72.62704000"
                    },
                    {
                        "id": 111419,
                        "name": "Arcade",
                        "latitude": "42.53395000",
                        "longitude": "-78.42307000"
                    },
                    {
                        "id": 111444,
                        "name": "Ardsley",
                        "latitude": "41.01065000",
                        "longitude": "-73.84375000"
                    },
                    {
                        "id": 111468,
                        "name": "Arlington",
                        "latitude": "41.69593000",
                        "longitude": "-73.89680000"
                    },
                    {
                        "id": 111478,
                        "name": "Armonk",
                        "latitude": "41.12648000",
                        "longitude": "-73.71402000"
                    },
                    {
                        "id": 111493,
                        "name": "Arrochar",
                        "latitude": "40.59844000",
                        "longitude": "-74.07264000"
                    },
                    {
                        "id": 111504,
                        "name": "Arverne",
                        "latitude": "40.59122000",
                        "longitude": "-73.79597000"
                    },
                    {
                        "id": 111562,
                        "name": "Astoria",
                        "latitude": "40.77205000",
                        "longitude": "-73.93014000"
                    },
                    {
                        "id": 111579,
                        "name": "Athens",
                        "latitude": "42.26036000",
                        "longitude": "-73.80957000"
                    },
                    {
                        "id": 111597,
                        "name": "Atlantic Beach",
                        "latitude": "40.58899000",
                        "longitude": "-73.72902000"
                    },
                    {
                        "id": 111610,
                        "name": "Attica",
                        "latitude": "42.86423000",
                        "longitude": "-78.28029000"
                    },
                    {
                        "id": 111628,
                        "name": "Auburn",
                        "latitude": "42.93173000",
                        "longitude": "-76.56605000"
                    },
                    {
                        "id": 111650,
                        "name": "Augusta",
                        "latitude": "42.97479000",
                        "longitude": "-75.50129000"
                    },
                    {
                        "id": 111680,
                        "name": "Averill Park",
                        "latitude": "42.63397000",
                        "longitude": "-73.55373000"
                    },
                    {
                        "id": 111693,
                        "name": "Avon",
                        "latitude": "42.91201000",
                        "longitude": "-77.74556000"
                    },
                    {
                        "id": 111716,
                        "name": "Babylon",
                        "latitude": "40.69566000",
                        "longitude": "-73.32568000"
                    },
                    {
                        "id": 111733,
                        "name": "Bainbridge",
                        "latitude": "42.29341000",
                        "longitude": "-75.47935000"
                    },
                    {
                        "id": 111737,
                        "name": "Baiting Hollow",
                        "latitude": "40.95621000",
                        "longitude": "-72.74427000"
                    },
                    {
                        "id": 111756,
                        "name": "Baldwin",
                        "latitude": "40.65649000",
                        "longitude": "-73.60930000"
                    },
                    {
                        "id": 111762,
                        "name": "Baldwin Harbor",
                        "latitude": "40.63955000",
                        "longitude": "-73.60846000"
                    },
                    {
                        "id": 111764,
                        "name": "Baldwinsville",
                        "latitude": "43.15868000",
                        "longitude": "-76.33271000"
                    },
                    {
                        "id": 111775,
                        "name": "Ballston Spa",
                        "latitude": "43.00091000",
                        "longitude": "-73.84901000"
                    },
                    {
                        "id": 111779,
                        "name": "Balmville",
                        "latitude": "41.53482000",
                        "longitude": "-74.01486000"
                    },
                    {
                        "id": 111819,
                        "name": "Bardonia",
                        "latitude": "41.10954000",
                        "longitude": "-73.99625000"
                    },
                    {
                        "id": 111837,
                        "name": "Barnum Island",
                        "latitude": "40.60455000",
                        "longitude": "-73.64402000"
                    },
                    {
                        "id": 111888,
                        "name": "Batavia",
                        "latitude": "42.99812000",
                        "longitude": "-78.18752000"
                    },
                    {
                        "id": 111898,
                        "name": "Bath",
                        "latitude": "42.33702000",
                        "longitude": "-77.31776000"
                    },
                    {
                        "id": 111900,
                        "name": "Bath Beach",
                        "latitude": "40.60455000",
                        "longitude": "-74.00431000"
                    },
                    {
                        "id": 111918,
                        "name": "Baxter Estates",
                        "latitude": "40.83482000",
                        "longitude": "-73.69541000"
                    },
                    {
                        "id": 111930,
                        "name": "Bay Park",
                        "latitude": "40.63316000",
                        "longitude": "-73.67041000"
                    },
                    {
                        "id": 111934,
                        "name": "Bay Shore",
                        "latitude": "40.72510000",
                        "longitude": "-73.24539000"
                    },
                    {
                        "id": 111936,
                        "name": "Bay Wood",
                        "latitude": "40.75010000",
                        "longitude": "-73.29123000"
                    },
                    {
                        "id": 111940,
                        "name": "Baychester",
                        "latitude": "40.86928000",
                        "longitude": "-73.83645000"
                    },
                    {
                        "id": 111952,
                        "name": "Bayport",
                        "latitude": "40.73843000",
                        "longitude": "-73.05067000"
                    },
                    {
                        "id": 111955,
                        "name": "Bayside",
                        "latitude": "40.76844000",
                        "longitude": "-73.77708000"
                    },
                    {
                        "id": 111961,
                        "name": "Bayville",
                        "latitude": "40.91065000",
                        "longitude": "-73.56207000"
                    },
                    {
                        "id": 111968,
                        "name": "Beacon",
                        "latitude": "41.50482000",
                        "longitude": "-73.96958000"
                    },
                    {
                        "id": 112003,
                        "name": "Beaver Dam Lake",
                        "latitude": "41.44743000",
                        "longitude": "-74.11463000"
                    },
                    {
                        "id": 112007,
                        "name": "Beaverdam Lake-Salisbury Mills",
                        "latitude": "41.44162000",
                        "longitude": "-74.11629000"
                    },
                    {
                        "id": 112025,
                        "name": "Bedford",
                        "latitude": "41.20426000",
                        "longitude": "-73.64374000"
                    },
                    {
                        "id": 112030,
                        "name": "Bedford Hills",
                        "latitude": "41.23676000",
                        "longitude": "-73.69458000"
                    },
                    {
                        "id": 112077,
                        "name": "Bellaire",
                        "latitude": "40.71399000",
                        "longitude": "-73.75402000"
                    },
                    {
                        "id": 112084,
                        "name": "Belle Harbor",
                        "latitude": "40.57594000",
                        "longitude": "-73.84819000"
                    },
                    {
                        "id": 112100,
                        "name": "Bellerose",
                        "latitude": "40.72427000",
                        "longitude": "-73.71513000"
                    },
                    {
                        "id": 112101,
                        "name": "Bellerose Terrace",
                        "latitude": "40.72066000",
                        "longitude": "-73.72596000"
                    },
                    {
                        "id": 112123,
                        "name": "Bellmore",
                        "latitude": "40.66871000",
                        "longitude": "-73.52707000"
                    },
                    {
                        "id": 112125,
                        "name": "Bellport",
                        "latitude": "40.75704000",
                        "longitude": "-72.93927000"
                    },
                    {
                        "id": 112140,
                        "name": "Belmont",
                        "latitude": "42.22312000",
                        "longitude": "-78.03445000"
                    },
                    {
                        "id": 112187,
                        "name": "Bensonhurst",
                        "latitude": "40.60177000",
                        "longitude": "-73.99403000"
                    },
                    {
                        "id": 112216,
                        "name": "Bergen",
                        "latitude": "43.08534000",
                        "longitude": "-77.94223000"
                    },
                    {
                        "id": 112217,
                        "name": "Bergen Beach",
                        "latitude": "40.62038000",
                        "longitude": "-73.90680000"
                    },
                    {
                        "id": 112293,
                        "name": "Bethpage",
                        "latitude": "40.74427000",
                        "longitude": "-73.48207000"
                    },
                    {
                        "id": 112320,
                        "name": "Big Flats",
                        "latitude": "42.13730000",
                        "longitude": "-76.93691000"
                    },
                    {
                        "id": 112346,
                        "name": "Billington Heights",
                        "latitude": "42.78423000",
                        "longitude": "-78.62642000"
                    },
                    {
                        "id": 112351,
                        "name": "Binghamton",
                        "latitude": "42.09869000",
                        "longitude": "-75.91797000"
                    },
                    {
                        "id": 112382,
                        "name": "Black River",
                        "latitude": "44.01256000",
                        "longitude": "-75.79437000"
                    },
                    {
                        "id": 112424,
                        "name": "Blasdell",
                        "latitude": "42.79728000",
                        "longitude": "-78.82337000"
                    },
                    {
                        "id": 112425,
                        "name": "Blauvelt",
                        "latitude": "41.06343000",
                        "longitude": "-73.95764000"
                    },
                    {
                        "id": 112438,
                        "name": "Bloomfield",
                        "latitude": "40.61260000",
                        "longitude": "-74.17820000"
                    },
                    {
                        "id": 112473,
                        "name": "Blue Point",
                        "latitude": "40.74399000",
                        "longitude": "-73.03455000"
                    },
                    {
                        "id": 112502,
                        "name": "Bohemia",
                        "latitude": "40.76926000",
                        "longitude": "-73.11511000"
                    },
                    {
                        "id": 112520,
                        "name": "Bolivar",
                        "latitude": "42.06673000",
                        "longitude": "-78.16779000"
                    },
                    {
                        "id": 112570,
                        "name": "Boonville",
                        "latitude": "43.48368000",
                        "longitude": "-75.33656000"
                    },
                    {
                        "id": 112580,
                        "name": "Borough Park",
                        "latitude": "40.63399000",
                        "longitude": "-73.99681000"
                    },
                    {
                        "id": 112590,
                        "name": "Boston",
                        "latitude": "42.62895000",
                        "longitude": "-78.73753000"
                    },
                    {
                        "id": 112731,
                        "name": "Brentwood",
                        "latitude": "40.78121000",
                        "longitude": "-73.24623000"
                    },
                    {
                        "id": 112740,
                        "name": "Brewerton",
                        "latitude": "43.23812000",
                        "longitude": "-76.14076000"
                    },
                    {
                        "id": 112743,
                        "name": "Brewster",
                        "latitude": "41.39732000",
                        "longitude": "-73.61707000"
                    },
                    {
                        "id": 112746,
                        "name": "Brewster Hill",
                        "latitude": "41.42398000",
                        "longitude": "-73.60429000"
                    },
                    {
                        "id": 112750,
                        "name": "Briarcliff Manor",
                        "latitude": "41.14565000",
                        "longitude": "-73.82375000"
                    },
                    {
                        "id": 112751,
                        "name": "Briarwood",
                        "latitude": "40.70935000",
                        "longitude": "-73.81529000"
                    },
                    {
                        "id": 112757,
                        "name": "Bridgehampton",
                        "latitude": "40.93788000",
                        "longitude": "-72.30092000"
                    },
                    {
                        "id": 112763,
                        "name": "Bridgeport",
                        "latitude": "43.15535000",
                        "longitude": "-75.96936000"
                    },
                    {
                        "id": 112790,
                        "name": "Brighton",
                        "latitude": "43.14756000",
                        "longitude": "-77.55055000"
                    },
                    {
                        "id": 112792,
                        "name": "Brighton Beach",
                        "latitude": "40.57788000",
                        "longitude": "-73.95958000"
                    },
                    {
                        "id": 112794,
                        "name": "Brightwaters",
                        "latitude": "40.72093000",
                        "longitude": "-73.26734000"
                    },
                    {
                        "id": 112798,
                        "name": "Brinckerhoff",
                        "latitude": "41.54398000",
                        "longitude": "-73.86819000"
                    },
                    {
                        "id": 112820,
                        "name": "Broad Channel",
                        "latitude": "40.60316000",
                        "longitude": "-73.82041000"
                    },
                    {
                        "id": 112823,
                        "name": "Broadalbin",
                        "latitude": "43.05868000",
                        "longitude": "-74.19652000"
                    },
                    {
                        "id": 112833,
                        "name": "Brockport",
                        "latitude": "43.21367000",
                        "longitude": "-77.93918000"
                    },
                    {
                        "id": 112836,
                        "name": "Brocton",
                        "latitude": "42.38867000",
                        "longitude": "-79.44116000"
                    },
                    {
                        "id": 112846,
                        "name": "Bronx",
                        "latitude": "40.82732000",
                        "longitude": "-73.92357000"
                    },
                    {
                        "id": 112847,
                        "name": "Bronxville",
                        "latitude": "40.93815000",
                        "longitude": "-73.83208000"
                    },
                    {
                        "id": 112860,
                        "name": "Brookhaven",
                        "latitude": "40.77927000",
                        "longitude": "-72.91538000"
                    },
                    {
                        "id": 112872,
                        "name": "Brooklyn",
                        "latitude": "40.65010000",
                        "longitude": "-73.94958000"
                    },
                    {
                        "id": 112875,
                        "name": "Brooklyn Heights",
                        "latitude": "40.69538000",
                        "longitude": "-73.99375000"
                    },
                    {
                        "id": 112895,
                        "name": "Brookville",
                        "latitude": "40.81316000",
                        "longitude": "-73.56735000"
                    },
                    {
                        "id": 112899,
                        "name": "Broome County",
                        "latitude": "42.16022000",
                        "longitude": "-75.81962000"
                    },
                    {
                        "id": 112933,
                        "name": "Brownsville",
                        "latitude": "40.66094000",
                        "longitude": "-73.92014000"
                    },
                    {
                        "id": 112938,
                        "name": "Brownville",
                        "latitude": "44.00700000",
                        "longitude": "-75.98409000"
                    },
                    {
                        "id": 112972,
                        "name": "Buchanan",
                        "latitude": "41.26204000",
                        "longitude": "-73.93819000"
                    },
                    {
                        "id": 113014,
                        "name": "Buffalo",
                        "latitude": "42.88645000",
                        "longitude": "-78.87837000"
                    },
                    {
                        "id": 113103,
                        "name": "Bushwick",
                        "latitude": "40.69427000",
                        "longitude": "-73.91875000"
                    },
                    {
                        "id": 113171,
                        "name": "Cairo",
                        "latitude": "42.29897000",
                        "longitude": "-73.99847000"
                    },
                    {
                        "id": 113178,
                        "name": "Calcium",
                        "latitude": "44.02173000",
                        "longitude": "-75.84604000"
                    },
                    {
                        "id": 113191,
                        "name": "Caledonia",
                        "latitude": "42.97312000",
                        "longitude": "-77.85278000"
                    },
                    {
                        "id": 113237,
                        "name": "Calverton",
                        "latitude": "40.90649000",
                        "longitude": "-72.74343000"
                    },
                    {
                        "id": 113248,
                        "name": "Cambria Heights",
                        "latitude": "40.69455000",
                        "longitude": "-73.73847000"
                    },
                    {
                        "id": 113254,
                        "name": "Cambridge",
                        "latitude": "43.02813000",
                        "longitude": "-73.38122000"
                    },
                    {
                        "id": 113267,
                        "name": "Camden",
                        "latitude": "43.33451000",
                        "longitude": "-75.74796000"
                    },
                    {
                        "id": 113284,
                        "name": "Camillus",
                        "latitude": "43.03923000",
                        "longitude": "-76.30410000"
                    },
                    {
                        "id": 113317,
                        "name": "Canajoharie",
                        "latitude": "42.90563000",
                        "longitude": "-74.57181000"
                    },
                    {
                        "id": 113318,
                        "name": "Canandaigua",
                        "latitude": "42.87423000",
                        "longitude": "-77.28804000"
                    },
                    {
                        "id": 113319,
                        "name": "Canarsie",
                        "latitude": "40.64372000",
                        "longitude": "-73.90069000"
                    },
                    {
                        "id": 113320,
                        "name": "Canastota",
                        "latitude": "43.07951000",
                        "longitude": "-75.75074000"
                    },
                    {
                        "id": 113329,
                        "name": "Canisteo",
                        "latitude": "42.27035000",
                        "longitude": "-77.60582000"
                    },
                    {
                        "id": 113347,
                        "name": "Canton",
                        "latitude": "44.59562000",
                        "longitude": "-75.16909000"
                    },
                    {
                        "id": 113397,
                        "name": "Carle Place",
                        "latitude": "40.75260000",
                        "longitude": "-73.61041000"
                    },
                    {
                        "id": 113417,
                        "name": "Carmel",
                        "latitude": "41.43009000",
                        "longitude": "-73.68013000"
                    },
                    {
                        "id": 113419,
                        "name": "Carmel Hamlet",
                        "latitude": "41.41485000",
                        "longitude": "-73.68524000"
                    },
                    {
                        "id": 113497,
                        "name": "Carthage",
                        "latitude": "43.97812000",
                        "longitude": "-75.60936000"
                    },
                    {
                        "id": 113553,
                        "name": "Castleton-on-Hudson",
                        "latitude": "42.51841000",
                        "longitude": "-73.75123000"
                    },
                    {
                        "id": 113579,
                        "name": "Catskill",
                        "latitude": "42.21731000",
                        "longitude": "-73.86457000"
                    },
                    {
                        "id": 113580,
                        "name": "Cattaraugus County",
                        "latitude": "42.24863000",
                        "longitude": "-78.67885000"
                    },
                    {
                        "id": 113594,
                        "name": "Cayuga County",
                        "latitude": "43.01033000",
                        "longitude": "-76.57436000"
                    },
                    {
                        "id": 113595,
                        "name": "Cayuga Heights",
                        "latitude": "42.46010000",
                        "longitude": "-76.48776000"
                    },
                    {
                        "id": 113596,
                        "name": "Cazenovia",
                        "latitude": "42.93007000",
                        "longitude": "-75.85269000"
                    },
                    {
                        "id": 113626,
                        "name": "Cedarhurst",
                        "latitude": "40.62288000",
                        "longitude": "-73.72430000"
                    },
                    {
                        "id": 113632,
                        "name": "Celoron",
                        "latitude": "42.10950000",
                        "longitude": "-79.28310000"
                    },
                    {
                        "id": 113645,
                        "name": "Center Moriches",
                        "latitude": "40.80038000",
                        "longitude": "-72.78982000"
                    },
                    {
                        "id": 113648,
                        "name": "Centereach",
                        "latitude": "40.85843000",
                        "longitude": "-73.09955000"
                    },
                    {
                        "id": 113650,
                        "name": "Centerport",
                        "latitude": "40.88538000",
                        "longitude": "-73.37623000"
                    },
                    {
                        "id": 113678,
                        "name": "Central Islip",
                        "latitude": "40.79065000",
                        "longitude": "-73.20178000"
                    },
                    {
                        "id": 113681,
                        "name": "Central Square",
                        "latitude": "43.28674000",
                        "longitude": "-76.14604000"
                    },
                    {
                        "id": 113682,
                        "name": "Central Valley",
                        "latitude": "41.33176000",
                        "longitude": "-74.12098000"
                    },
                    {
                        "id": 113708,
                        "name": "Chadwicks",
                        "latitude": "43.02785000",
                        "longitude": "-75.27155000"
                    },
                    {
                        "id": 113726,
                        "name": "Champlain",
                        "latitude": "44.98643000",
                        "longitude": "-73.44653000"
                    },
                    {
                        "id": 113746,
                        "name": "Chappaqua",
                        "latitude": "41.15954000",
                        "longitude": "-73.76485000"
                    },
                    {
                        "id": 113768,
                        "name": "Charleston",
                        "latitude": "40.53677000",
                        "longitude": "-74.23737000"
                    },
                    {
                        "id": 113799,
                        "name": "Chatham",
                        "latitude": "42.36425000",
                        "longitude": "-73.59484000"
                    },
                    {
                        "id": 113815,
                        "name": "Chautauqua County",
                        "latitude": "42.30294000",
                        "longitude": "-79.40576000"
                    },
                    {
                        "id": 113824,
                        "name": "Cheektowaga",
                        "latitude": "42.90339000",
                        "longitude": "-78.75475000"
                    },
                    {
                        "id": 113834,
                        "name": "Chelsea",
                        "latitude": "40.60066000",
                        "longitude": "-74.19487000"
                    },
                    {
                        "id": 113836,
                        "name": "Chemung County",
                        "latitude": "42.14125000",
                        "longitude": "-76.76003000"
                    },
                    {
                        "id": 113837,
                        "name": "Chenango Bridge",
                        "latitude": "42.16674000",
                        "longitude": "-75.86242000"
                    },
                    {
                        "id": 113838,
                        "name": "Chenango County",
                        "latitude": "42.49351000",
                        "longitude": "-75.61158000"
                    },
                    {
                        "id": 113888,
                        "name": "Chester",
                        "latitude": "41.36259000",
                        "longitude": "-74.27126000"
                    },
                    {
                        "id": 113912,
                        "name": "Chestnut Ridge",
                        "latitude": "41.08426000",
                        "longitude": "-74.05570000"
                    },
                    {
                        "id": 113981,
                        "name": "Chittenango",
                        "latitude": "43.04507000",
                        "longitude": "-75.86658000"
                    },
                    {
                        "id": 114013,
                        "name": "Churchville",
                        "latitude": "43.10423000",
                        "longitude": "-77.88445000"
                    },
                    {
                        "id": 114043,
                        "name": "City Island",
                        "latitude": "40.84732000",
                        "longitude": "-73.78652000"
                    },
                    {
                        "id": 114108,
                        "name": "Clarence",
                        "latitude": "42.97673000",
                        "longitude": "-78.59197000"
                    },
                    {
                        "id": 114109,
                        "name": "Clarence Center",
                        "latitude": "43.01061000",
                        "longitude": "-78.63753000"
                    },
                    {
                        "id": 114132,
                        "name": "Clark Mills",
                        "latitude": "43.09229000",
                        "longitude": "-75.37962000"
                    },
                    {
                        "id": 114146,
                        "name": "Clarkson",
                        "latitude": "43.23312000",
                        "longitude": "-77.92751000"
                    },
                    {
                        "id": 114202,
                        "name": "Clayton",
                        "latitude": "44.23949000",
                        "longitude": "-76.08578000"
                    },
                    {
                        "id": 114258,
                        "name": "Clifton",
                        "latitude": "40.62010000",
                        "longitude": "-74.07709000"
                    },
                    {
                        "id": 114264,
                        "name": "Clifton Springs",
                        "latitude": "42.96173000",
                        "longitude": "-77.13998000"
                    },
                    {
                        "id": 114283,
                        "name": "Clinton",
                        "latitude": "43.04840000",
                        "longitude": "-75.37850000"
                    },
                    {
                        "id": 114295,
                        "name": "Clinton County",
                        "latitude": "44.74623000",
                        "longitude": "-73.67817000"
                    },
                    {
                        "id": 114298,
                        "name": "Clintondale",
                        "latitude": "41.69482000",
                        "longitude": "-74.05125000"
                    },
                    {
                        "id": 114320,
                        "name": "Clyde",
                        "latitude": "43.08423000",
                        "longitude": "-76.86940000"
                    },
                    {
                        "id": 114322,
                        "name": "Clymer",
                        "latitude": "42.02089000",
                        "longitude": "-79.63005000"
                    },
                    {
                        "id": 114347,
                        "name": "Cobleskill",
                        "latitude": "42.67785000",
                        "longitude": "-74.48542000"
                    },
                    {
                        "id": 114375,
                        "name": "Cohoes",
                        "latitude": "42.77424000",
                        "longitude": "-73.70012000"
                    },
                    {
                        "id": 114387,
                        "name": "Cold Spring",
                        "latitude": "41.42009000",
                        "longitude": "-73.95458000"
                    },
                    {
                        "id": 114388,
                        "name": "Cold Spring Harbor",
                        "latitude": "40.87149000",
                        "longitude": "-73.45679000"
                    },
                    {
                        "id": 114416,
                        "name": "College Point",
                        "latitude": "40.78760000",
                        "longitude": "-73.84597000"
                    },
                    {
                        "id": 114452,
                        "name": "Colonie",
                        "latitude": "42.71786000",
                        "longitude": "-73.83346000"
                    },
                    {
                        "id": 114480,
                        "name": "Columbia County",
                        "latitude": "42.25008000",
                        "longitude": "-73.63185000"
                    },
                    {
                        "id": 114521,
                        "name": "Commack",
                        "latitude": "40.84288000",
                        "longitude": "-73.29289000"
                    },
                    {
                        "id": 114540,
                        "name": "Concord",
                        "latitude": "40.60816000",
                        "longitude": "-74.08431000"
                    },
                    {
                        "id": 114556,
                        "name": "Coney Island",
                        "latitude": "40.57788000",
                        "longitude": "-73.99403000"
                    },
                    {
                        "id": 114557,
                        "name": "Congers",
                        "latitude": "41.15065000",
                        "longitude": "-73.94542000"
                    },
                    {
                        "id": 114572,
                        "name": "Constantia",
                        "latitude": "43.24785000",
                        "longitude": "-76.00020000"
                    },
                    {
                        "id": 114605,
                        "name": "Cooperstown",
                        "latitude": "42.70048000",
                        "longitude": "-74.92426000"
                    },
                    {
                        "id": 114616,
                        "name": "Copiague",
                        "latitude": "40.68149000",
                        "longitude": "-73.39984000"
                    },
                    {
                        "id": 114629,
                        "name": "Coram",
                        "latitude": "40.86871000",
                        "longitude": "-73.00149000"
                    },
                    {
                        "id": 114645,
                        "name": "Corinth",
                        "latitude": "43.24452000",
                        "longitude": "-73.83234000"
                    },
                    {
                        "id": 114653,
                        "name": "Corning",
                        "latitude": "42.14285000",
                        "longitude": "-77.05469000"
                    },
                    {
                        "id": 114658,
                        "name": "Cornwall",
                        "latitude": "41.44482000",
                        "longitude": "-74.01570000"
                    },
                    {
                        "id": 114661,
                        "name": "Corona",
                        "latitude": "40.74705000",
                        "longitude": "-73.86014000"
                    },
                    {
                        "id": 114676,
                        "name": "Cortland",
                        "latitude": "42.60118000",
                        "longitude": "-76.18048000"
                    },
                    {
                        "id": 114677,
                        "name": "Cortland County",
                        "latitude": "42.59501000",
                        "longitude": "-76.07027000"
                    },
                    {
                        "id": 114678,
                        "name": "Cortland West",
                        "latitude": "42.59431000",
                        "longitude": "-76.22587000"
                    },
                    {
                        "id": 114721,
                        "name": "Country Knolls",
                        "latitude": "42.91508000",
                        "longitude": "-73.80512000"
                    },
                    {
                        "id": 114751,
                        "name": "Coxsackie",
                        "latitude": "42.35092000",
                        "longitude": "-73.80290000"
                    },
                    {
                        "id": 114834,
                        "name": "Crompond",
                        "latitude": "41.29509000",
                        "longitude": "-73.86541000"
                    },
                    {
                        "id": 114859,
                        "name": "Croton-on-Hudson",
                        "latitude": "41.20843000",
                        "longitude": "-73.89125000"
                    },
                    {
                        "id": 114866,
                        "name": "Crown Heights",
                        "latitude": "41.63732000",
                        "longitude": "-73.93792000"
                    },
                    {
                        "id": 114872,
                        "name": "Crugers",
                        "latitude": "41.23343000",
                        "longitude": "-73.92264000"
                    },
                    {
                        "id": 114887,
                        "name": "Cuba",
                        "latitude": "42.21757000",
                        "longitude": "-78.27529000"
                    },
                    {
                        "id": 114920,
                        "name": "Cumberland Head",
                        "latitude": "44.71643000",
                        "longitude": "-73.40263000"
                    },
                    {
                        "id": 114944,
                        "name": "Cutchogue",
                        "latitude": "41.01066000",
                        "longitude": "-72.48509000"
                    },
                    {
                        "id": 114956,
                        "name": "Cypress Hills",
                        "latitude": "40.67705000",
                        "longitude": "-73.89125000"
                    },
                    {
                        "id": 115027,
                        "name": "Dannemora",
                        "latitude": "44.72143000",
                        "longitude": "-73.72375000"
                    },
                    {
                        "id": 115028,
                        "name": "Dansville",
                        "latitude": "42.56090000",
                        "longitude": "-77.69611000"
                    },
                    {
                        "id": 115177,
                        "name": "Deer Park",
                        "latitude": "40.76177000",
                        "longitude": "-73.32929000"
                    },
                    {
                        "id": 115207,
                        "name": "Delaware County",
                        "latitude": "42.19809000",
                        "longitude": "-74.96647000"
                    },
                    {
                        "id": 115210,
                        "name": "Delevan",
                        "latitude": "42.48923000",
                        "longitude": "-78.48085000"
                    },
                    {
                        "id": 115212,
                        "name": "Delhi",
                        "latitude": "42.27814000",
                        "longitude": "-74.91599000"
                    },
                    {
                        "id": 115218,
                        "name": "Delmar",
                        "latitude": "42.62202000",
                        "longitude": "-73.83262000"
                    },
                    {
                        "id": 115256,
                        "name": "Depew",
                        "latitude": "42.90395000",
                        "longitude": "-78.69225000"
                    },
                    {
                        "id": 115258,
                        "name": "Deposit",
                        "latitude": "42.06008000",
                        "longitude": "-75.42768000"
                    },
                    {
                        "id": 115310,
                        "name": "Dexter",
                        "latitude": "44.00784000",
                        "longitude": "-76.04437000"
                    },
                    {
                        "id": 115358,
                        "name": "Dix Hills",
                        "latitude": "40.80482000",
                        "longitude": "-73.33623000"
                    },
                    {
                        "id": 115370,
                        "name": "Dobbs Ferry",
                        "latitude": "41.01454000",
                        "longitude": "-73.87264000"
                    },
                    {
                        "id": 115387,
                        "name": "Dolgeville",
                        "latitude": "43.10090000",
                        "longitude": "-74.77293000"
                    },
                    {
                        "id": 115396,
                        "name": "Dongan Hills",
                        "latitude": "40.58844000",
                        "longitude": "-74.09625000"
                    },
                    {
                        "id": 115439,
                        "name": "Douglaston",
                        "latitude": "40.76871000",
                        "longitude": "-73.74708000"
                    },
                    {
                        "id": 115456,
                        "name": "Dover Plains",
                        "latitude": "41.74121000",
                        "longitude": "-73.57652000"
                    },
                    {
                        "id": 115485,
                        "name": "Dryden",
                        "latitude": "42.49091000",
                        "longitude": "-76.29716000"
                    },
                    {
                        "id": 115530,
                        "name": "Dundee",
                        "latitude": "42.52340000",
                        "longitude": "-76.97663000"
                    },
                    {
                        "id": 115539,
                        "name": "Dunkirk",
                        "latitude": "42.47950000",
                        "longitude": "-79.33393000"
                    },
                    {
                        "id": 115572,
                        "name": "Durham",
                        "latitude": "42.39953000",
                        "longitude": "-74.17236000"
                    },
                    {
                        "id": 115579,
                        "name": "Dutchess County",
                        "latitude": "41.76515000",
                        "longitude": "-73.74286000"
                    },
                    {
                        "id": 115590,
                        "name": "Dyker Heights",
                        "latitude": "40.62149000",
                        "longitude": "-74.00958000"
                    },
                    {
                        "id": 115627,
                        "name": "East Atlantic Beach",
                        "latitude": "40.78982000",
                        "longitude": "-73.74708000"
                    },
                    {
                        "id": 115628,
                        "name": "East Aurora",
                        "latitude": "42.76784000",
                        "longitude": "-78.61336000"
                    },
                    {
                        "id": 115655,
                        "name": "East Elmhurst",
                        "latitude": "40.76121000",
                        "longitude": "-73.86514000"
                    },
                    {
                        "id": 115658,
                        "name": "East Farmingdale",
                        "latitude": "40.72927000",
                        "longitude": "-73.41679000"
                    },
                    {
                        "id": 115661,
                        "name": "East Flatbush",
                        "latitude": "40.65371000",
                        "longitude": "-73.93042000"
                    },
                    {
                        "id": 115667,
                        "name": "East Garden City",
                        "latitude": "40.73083000",
                        "longitude": "-73.59806000"
                    },
                    {
                        "id": 115669,
                        "name": "East Glenville",
                        "latitude": "42.89452000",
                        "longitude": "-73.92790000"
                    },
                    {
                        "id": 115672,
                        "name": "East Greenbush",
                        "latitude": "42.59091000",
                        "longitude": "-73.70179000"
                    },
                    {
                        "id": 115680,
                        "name": "East Hampton",
                        "latitude": "40.96343000",
                        "longitude": "-72.18480000"
                    },
                    {
                        "id": 115681,
                        "name": "East Hampton North",
                        "latitude": "40.97276000",
                        "longitude": "-72.18911000"
                    },
                    {
                        "id": 115683,
                        "name": "East Harlem",
                        "latitude": "40.79472000",
                        "longitude": "-73.94250000"
                    },
                    {
                        "id": 115692,
                        "name": "East Hills",
                        "latitude": "40.79371000",
                        "longitude": "-73.62707000"
                    },
                    {
                        "id": 115695,
                        "name": "East Islip",
                        "latitude": "40.73204000",
                        "longitude": "-73.18567000"
                    },
                    {
                        "id": 115696,
                        "name": "East Ithaca",
                        "latitude": "42.43952000",
                        "longitude": "-76.47855000"
                    },
                    {
                        "id": 115708,
                        "name": "East Massapequa",
                        "latitude": "40.67343000",
                        "longitude": "-73.43651000"
                    },
                    {
                        "id": 115710,
                        "name": "East Meadow",
                        "latitude": "40.71399000",
                        "longitude": "-73.55902000"
                    },
                    {
                        "id": 115717,
                        "name": "East Moriches",
                        "latitude": "40.80510000",
                        "longitude": "-72.76093000"
                    },
                    {
                        "id": 115719,
                        "name": "East New York",
                        "latitude": "40.66677000",
                        "longitude": "-73.88236000"
                    },
                    {
                        "id": 115722,
                        "name": "East Northport",
                        "latitude": "40.87676000",
                        "longitude": "-73.32456000"
                    },
                    {
                        "id": 115724,
                        "name": "East Norwich",
                        "latitude": "40.84677000",
                        "longitude": "-73.53512000"
                    },
                    {
                        "id": 115730,
                        "name": "East Patchogue",
                        "latitude": "40.76704000",
                        "longitude": "-72.99622000"
                    },
                    {
                        "id": 115743,
                        "name": "East Quogue",
                        "latitude": "40.84066000",
                        "longitude": "-72.58148000"
                    },
                    {
                        "id": 115749,
                        "name": "East Rochester",
                        "latitude": "43.10867000",
                        "longitude": "-77.48750000"
                    },
                    {
                        "id": 115750,
                        "name": "East Rockaway",
                        "latitude": "40.64205000",
                        "longitude": "-73.66957000"
                    },
                    {
                        "id": 115757,
                        "name": "East Setauket",
                        "latitude": "40.94149000",
                        "longitude": "-73.10594000"
                    },
                    {
                        "id": 115758,
                        "name": "East Shoreham",
                        "latitude": "40.94482000",
                        "longitude": "-72.87955000"
                    },
                    {
                        "id": 115763,
                        "name": "East Syracuse",
                        "latitude": "43.06534000",
                        "longitude": "-76.07853000"
                    },
                    {
                        "id": 115765,
                        "name": "East Tremont",
                        "latitude": "40.84538000",
                        "longitude": "-73.89097000"
                    },
                    {
                        "id": 115769,
                        "name": "East Village",
                        "latitude": "40.72927000",
                        "longitude": "-73.98736000"
                    },
                    {
                        "id": 115773,
                        "name": "East Williston",
                        "latitude": "40.75843000",
                        "longitude": "-73.63485000"
                    },
                    {
                        "id": 115776,
                        "name": "Eastchester",
                        "latitude": "40.95833000",
                        "longitude": "-73.80861000"
                    },
                    {
                        "id": 115796,
                        "name": "Eastport",
                        "latitude": "40.82593000",
                        "longitude": "-72.73177000"
                    },
                    {
                        "id": 115805,
                        "name": "Eatons Neck",
                        "latitude": "40.93065000",
                        "longitude": "-73.40151000"
                    },
                    {
                        "id": 115830,
                        "name": "Eden",
                        "latitude": "42.65228000",
                        "longitude": "-78.89698000"
                    },
                    {
                        "id": 115845,
                        "name": "Edgemere",
                        "latitude": "40.59622000",
                        "longitude": "-73.76763000"
                    },
                    {
                        "id": 115872,
                        "name": "Edinburg",
                        "latitude": "43.22174000",
                        "longitude": "-74.10402000"
                    },
                    {
                        "id": 115902,
                        "name": "Eggertsville",
                        "latitude": "42.96339000",
                        "longitude": "-78.80392000"
                    },
                    {
                        "id": 115947,
                        "name": "Elbridge",
                        "latitude": "43.03451000",
                        "longitude": "-76.44799000"
                    },
                    {
                        "id": 115980,
                        "name": "Elizabethtown",
                        "latitude": "44.21616000",
                        "longitude": "-73.59097000"
                    },
                    {
                        "id": 116020,
                        "name": "Ellenville",
                        "latitude": "41.71704000",
                        "longitude": "-74.39571000"
                    },
                    {
                        "id": 116047,
                        "name": "Elma Center",
                        "latitude": "42.82978000",
                        "longitude": "-78.63614000"
                    },
                    {
                        "id": 116052,
                        "name": "Elmhurst",
                        "latitude": "40.73649000",
                        "longitude": "-73.87791000"
                    },
                    {
                        "id": 116053,
                        "name": "Elmira",
                        "latitude": "42.08980000",
                        "longitude": "-76.80773000"
                    },
                    {
                        "id": 116054,
                        "name": "Elmira Heights",
                        "latitude": "42.12980000",
                        "longitude": "-76.82079000"
                    },
                    {
                        "id": 116055,
                        "name": "Elmont",
                        "latitude": "40.70094000",
                        "longitude": "-73.71291000"
                    },
                    {
                        "id": 116059,
                        "name": "Elmsford",
                        "latitude": "41.05510000",
                        "longitude": "-73.82013000"
                    },
                    {
                        "id": 116072,
                        "name": "Eltingville",
                        "latitude": "40.54538000",
                        "longitude": "-74.16570000"
                    },
                    {
                        "id": 116082,
                        "name": "Elwood",
                        "latitude": "40.84538000",
                        "longitude": "-73.33512000"
                    },
                    {
                        "id": 116095,
                        "name": "Emerson Hill",
                        "latitude": "40.60872000",
                        "longitude": "-74.09598000"
                    },
                    {
                        "id": 116120,
                        "name": "Endicott",
                        "latitude": "42.09841000",
                        "longitude": "-76.04937000"
                    },
                    {
                        "id": 116121,
                        "name": "Endwell",
                        "latitude": "42.11285000",
                        "longitude": "-76.02103000"
                    },
                    {
                        "id": 116168,
                        "name": "Erie County",
                        "latitude": "42.75824000",
                        "longitude": "-78.77966000"
                    },
                    {
                        "id": 116196,
                        "name": "Essex County",
                        "latitude": "44.11722000",
                        "longitude": "-73.77271000"
                    },
                    {
                        "id": 116341,
                        "name": "Fairmount",
                        "latitude": "43.04729000",
                        "longitude": "-76.23854000"
                    },
                    {
                        "id": 116345,
                        "name": "Fairport",
                        "latitude": "43.09867000",
                        "longitude": "-77.44194000"
                    },
                    {
                        "id": 116353,
                        "name": "Fairview",
                        "latitude": "41.72370000",
                        "longitude": "-73.91986000"
                    },
                    {
                        "id": 116367,
                        "name": "Falconer",
                        "latitude": "42.11867000",
                        "longitude": "-79.19838000"
                    },
                    {
                        "id": 116384,
                        "name": "Fallsburg",
                        "latitude": "41.73204000",
                        "longitude": "-74.60127000"
                    },
                    {
                        "id": 116395,
                        "name": "Far Rockaway",
                        "latitude": "40.60538000",
                        "longitude": "-73.75513000"
                    },
                    {
                        "id": 116411,
                        "name": "Farmingdale",
                        "latitude": "40.73260000",
                        "longitude": "-73.44540000"
                    },
                    {
                        "id": 116424,
                        "name": "Farmingville",
                        "latitude": "40.83121000",
                        "longitude": "-73.02955000"
                    },
                    {
                        "id": 116460,
                        "name": "Fayetteville",
                        "latitude": "43.02979000",
                        "longitude": "-76.00436000"
                    },
                    {
                        "id": 116524,
                        "name": "Firthcliffe",
                        "latitude": "41.43926000",
                        "longitude": "-74.04514000"
                    },
                    {
                        "id": 116532,
                        "name": "Fishkill",
                        "latitude": "41.53565000",
                        "longitude": "-73.89903000"
                    },
                    {
                        "id": 116548,
                        "name": "Flanders",
                        "latitude": "40.90343000",
                        "longitude": "-72.61759000"
                    },
                    {
                        "id": 116553,
                        "name": "Flatbush",
                        "latitude": "40.65205000",
                        "longitude": "-73.95903000"
                    },
                    {
                        "id": 116555,
                        "name": "Flatlands",
                        "latitude": "40.62122000",
                        "longitude": "-73.93486000"
                    },
                    {
                        "id": 116575,
                        "name": "Floral Park",
                        "latitude": "40.72371000",
                        "longitude": "-73.70485000"
                    },
                    {
                        "id": 116592,
                        "name": "Florida",
                        "latitude": "41.33176000",
                        "longitude": "-74.35682000"
                    },
                    {
                        "id": 116600,
                        "name": "Flower Hill",
                        "latitude": "40.80732000",
                        "longitude": "-73.68124000"
                    },
                    {
                        "id": 116629,
                        "name": "Fonda",
                        "latitude": "42.95452000",
                        "longitude": "-74.37652000"
                    },
                    {
                        "id": 116639,
                        "name": "Fordham",
                        "latitude": "40.85927000",
                        "longitude": "-73.89847000"
                    },
                    {
                        "id": 116658,
                        "name": "Forest Hills",
                        "latitude": "40.71621000",
                        "longitude": "-73.85014000"
                    },
                    {
                        "id": 116702,
                        "name": "Fort Covington Hamlet",
                        "latitude": "44.97178000",
                        "longitude": "-74.50757000"
                    },
                    {
                        "id": 116708,
                        "name": "Fort Drum",
                        "latitude": "44.05843000",
                        "longitude": "-75.76189000"
                    },
                    {
                        "id": 116709,
                        "name": "Fort Edward",
                        "latitude": "43.26702000",
                        "longitude": "-73.58456000"
                    },
                    {
                        "id": 116715,
                        "name": "Fort Hamilton",
                        "latitude": "40.61872000",
                        "longitude": "-74.03320000"
                    },
                    {
                        "id": 116732,
                        "name": "Fort Montgomery",
                        "latitude": "41.33148000",
                        "longitude": "-73.98681000"
                    },
                    {
                        "id": 116743,
                        "name": "Fort Plain",
                        "latitude": "42.93146000",
                        "longitude": "-74.62264000"
                    },
                    {
                        "id": 116748,
                        "name": "Fort Salonga",
                        "latitude": "40.91260000",
                        "longitude": "-73.30095000"
                    },
                    {
                        "id": 116758,
                        "name": "Fort Wadsworth",
                        "latitude": "40.60113000",
                        "longitude": "-74.05738000"
                    },
                    {
                        "id": 116823,
                        "name": "Frankfort",
                        "latitude": "43.03896000",
                        "longitude": "-75.07044000"
                    },
                    {
                        "id": 116861,
                        "name": "Franklin County",
                        "latitude": "44.59293000",
                        "longitude": "-74.30376000"
                    },
                    {
                        "id": 116872,
                        "name": "Franklin Square",
                        "latitude": "40.70732000",
                        "longitude": "-73.67596000"
                    },
                    {
                        "id": 116876,
                        "name": "Franklinville",
                        "latitude": "42.33701000",
                        "longitude": "-78.45808000"
                    },
                    {
                        "id": 116896,
                        "name": "Fredonia",
                        "latitude": "42.44006000",
                        "longitude": "-79.33171000"
                    },
                    {
                        "id": 116914,
                        "name": "Freeport",
                        "latitude": "40.65760000",
                        "longitude": "-73.58318000"
                    },
                    {
                        "id": 116937,
                        "name": "Fresh Meadows",
                        "latitude": "40.73482000",
                        "longitude": "-73.79347000"
                    },
                    {
                        "id": 116941,
                        "name": "Frewsburg",
                        "latitude": "42.05450000",
                        "longitude": "-79.15810000"
                    },
                    {
                        "id": 116949,
                        "name": "Friendship",
                        "latitude": "42.20646000",
                        "longitude": "-78.13751000"
                    },
                    {
                        "id": 116991,
                        "name": "Fulton",
                        "latitude": "43.32285000",
                        "longitude": "-76.41716000"
                    },
                    {
                        "id": 116997,
                        "name": "Fulton County",
                        "latitude": "43.11385000",
                        "longitude": "-74.42217000"
                    },
                    {
                        "id": 117031,
                        "name": "Galeville",
                        "latitude": "43.09007000",
                        "longitude": "-76.17298000"
                    },
                    {
                        "id": 117050,
                        "name": "Gang Mills",
                        "latitude": "42.14619000",
                        "longitude": "-77.11164000"
                    },
                    {
                        "id": 117058,
                        "name": "Garden City",
                        "latitude": "40.72677000",
                        "longitude": "-73.63430000"
                    },
                    {
                        "id": 117062,
                        "name": "Garden City Park",
                        "latitude": "40.74093000",
                        "longitude": "-73.66263000"
                    },
                    {
                        "id": 117063,
                        "name": "Garden City South",
                        "latitude": "40.71232000",
                        "longitude": "-73.66096000"
                    },
                    {
                        "id": 117077,
                        "name": "Gardnertown",
                        "latitude": "41.53509000",
                        "longitude": "-74.07014000"
                    },
                    {
                        "id": 117111,
                        "name": "Gasport",
                        "latitude": "43.19922000",
                        "longitude": "-78.57614000"
                    },
                    {
                        "id": 117120,
                        "name": "Gates-North Gates",
                        "latitude": "43.16547000",
                        "longitude": "-77.70066000"
                    },
                    {
                        "id": 117136,
                        "name": "Genesee County",
                        "latitude": "43.00093000",
                        "longitude": "-78.19371000"
                    },
                    {
                        "id": 117138,
                        "name": "Geneseo",
                        "latitude": "42.79590000",
                        "longitude": "-77.81695000"
                    },
                    {
                        "id": 117144,
                        "name": "Geneva",
                        "latitude": "42.86896000",
                        "longitude": "-76.97774000"
                    },
                    {
                        "id": 117242,
                        "name": "Glasco",
                        "latitude": "42.04370000",
                        "longitude": "-73.94736000"
                    },
                    {
                        "id": 117264,
                        "name": "Glen Cove",
                        "latitude": "40.86232000",
                        "longitude": "-73.63374000"
                    },
                    {
                        "id": 117267,
                        "name": "Glen Head",
                        "latitude": "40.83538000",
                        "longitude": "-73.62374000"
                    },
                    {
                        "id": 117269,
                        "name": "Glen Oaks",
                        "latitude": "40.74705000",
                        "longitude": "-73.71152000"
                    },
                    {
                        "id": 117283,
                        "name": "Glendale",
                        "latitude": "40.70149000",
                        "longitude": "-73.88680000"
                    },
                    {
                        "id": 117304,
                        "name": "Glens Falls",
                        "latitude": "43.30952000",
                        "longitude": "-73.64401000"
                    },
                    {
                        "id": 117305,
                        "name": "Glens Falls North",
                        "latitude": "43.33506000",
                        "longitude": "-73.68251000"
                    },
                    {
                        "id": 117317,
                        "name": "Glenwood Landing",
                        "latitude": "40.83066000",
                        "longitude": "-73.63874000"
                    },
                    {
                        "id": 117328,
                        "name": "Gloversville",
                        "latitude": "43.05285000",
                        "longitude": "-74.34375000"
                    },
                    {
                        "id": 117362,
                        "name": "Goldens Bridge",
                        "latitude": "41.29343000",
                        "longitude": "-73.67680000"
                    },
                    {
                        "id": 117399,
                        "name": "Gordon Heights",
                        "latitude": "40.85871000",
                        "longitude": "-72.97066000"
                    },
                    {
                        "id": 117409,
                        "name": "Goshen",
                        "latitude": "41.40204000",
                        "longitude": "-74.32432000"
                    },
                    {
                        "id": 117419,
                        "name": "Gouverneur",
                        "latitude": "44.33673000",
                        "longitude": "-75.46299000"
                    },
                    {
                        "id": 117422,
                        "name": "Gowanda",
                        "latitude": "42.46312000",
                        "longitude": "-78.93587000"
                    },
                    {
                        "id": 117462,
                        "name": "Grand Island",
                        "latitude": "43.03311000",
                        "longitude": "-78.96254000"
                    },
                    {
                        "id": 117485,
                        "name": "Grandyle Village",
                        "latitude": "42.99645000",
                        "longitude": "-78.95504000"
                    },
                    {
                        "id": 117503,
                        "name": "Graniteville",
                        "latitude": "40.62483000",
                        "longitude": "-74.14848000"
                    },
                    {
                        "id": 117507,
                        "name": "Grant City",
                        "latitude": "40.58205000",
                        "longitude": "-74.10486000"
                    },
                    {
                        "id": 117536,
                        "name": "Granville",
                        "latitude": "43.40785000",
                        "longitude": "-73.25955000"
                    },
                    {
                        "id": 117548,
                        "name": "Gravesend",
                        "latitude": "40.59760000",
                        "longitude": "-73.96514000"
                    },
                    {
                        "id": 117574,
                        "name": "Great Kills",
                        "latitude": "40.55427000",
                        "longitude": "-74.15153000"
                    },
                    {
                        "id": 117575,
                        "name": "Great Neck",
                        "latitude": "40.80066000",
                        "longitude": "-73.72846000"
                    },
                    {
                        "id": 117576,
                        "name": "Great Neck Estates",
                        "latitude": "40.78705000",
                        "longitude": "-73.73680000"
                    },
                    {
                        "id": 117577,
                        "name": "Great Neck Gardens",
                        "latitude": "40.79722000",
                        "longitude": "-73.72389000"
                    },
                    {
                        "id": 117578,
                        "name": "Great Neck Plaza",
                        "latitude": "40.78677000",
                        "longitude": "-73.72652000"
                    },
                    {
                        "id": 117579,
                        "name": "Great River",
                        "latitude": "40.72121000",
                        "longitude": "-73.15761000"
                    },
                    {
                        "id": 117584,
                        "name": "Greece",
                        "latitude": "43.20978000",
                        "longitude": "-77.69306000"
                    },
                    {
                        "id": 117599,
                        "name": "Green Island",
                        "latitude": "42.74424000",
                        "longitude": "-73.69151000"
                    },
                    {
                        "id": 117622,
                        "name": "Greenburgh",
                        "latitude": "41.03287000",
                        "longitude": "-73.84291000"
                    },
                    {
                        "id": 117630,
                        "name": "Greene",
                        "latitude": "42.32924000",
                        "longitude": "-75.76991000"
                    },
                    {
                        "id": 117642,
                        "name": "Greene County",
                        "latitude": "42.27652000",
                        "longitude": "-74.12271000"
                    },
                    {
                        "id": 117658,
                        "name": "Greenlawn",
                        "latitude": "40.86899000",
                        "longitude": "-73.36512000"
                    },
                    {
                        "id": 117661,
                        "name": "Greenpoint",
                        "latitude": "40.72371000",
                        "longitude": "-73.95097000"
                    },
                    {
                        "id": 117662,
                        "name": "Greenport",
                        "latitude": "41.10343000",
                        "longitude": "-72.35925000"
                    },
                    {
                        "id": 117663,
                        "name": "Greenport West",
                        "latitude": "41.10178000",
                        "longitude": "-72.37195000"
                    },
                    {
                        "id": 117679,
                        "name": "Greenvale",
                        "latitude": "40.81066000",
                        "longitude": "-73.62846000"
                    },
                    {
                        "id": 117693,
                        "name": "Greenville",
                        "latitude": "40.99315000",
                        "longitude": "-73.81986000"
                    },
                    {
                        "id": 117699,
                        "name": "Greenwich",
                        "latitude": "43.09063000",
                        "longitude": "-73.49873000"
                    },
                    {
                        "id": 117711,
                        "name": "Greenwood Lake",
                        "latitude": "41.22259000",
                        "longitude": "-74.29432000"
                    },
                    {
                        "id": 117750,
                        "name": "Groton",
                        "latitude": "42.58785000",
                        "longitude": "-76.36688000"
                    },
                    {
                        "id": 117775,
                        "name": "Grymes Hill",
                        "latitude": "40.61872000",
                        "longitude": "-74.09348000"
                    },
                    {
                        "id": 117834,
                        "name": "Hadley",
                        "latitude": "43.31729000",
                        "longitude": "-73.84818000"
                    },
                    {
                        "id": 117835,
                        "name": "Hagaman",
                        "latitude": "42.97452000",
                        "longitude": "-74.15096000"
                    },
                    {
                        "id": 117852,
                        "name": "Halesite",
                        "latitude": "40.88843000",
                        "longitude": "-73.41540000"
                    },
                    {
                        "id": 117884,
                        "name": "Hamburg",
                        "latitude": "42.71589000",
                        "longitude": "-78.82948000"
                    },
                    {
                        "id": 117893,
                        "name": "Hamilton",
                        "latitude": "42.82701000",
                        "longitude": "-75.54462000"
                    },
                    {
                        "id": 117903,
                        "name": "Hamilton County",
                        "latitude": "43.66112000",
                        "longitude": "-74.49736000"
                    },
                    {
                        "id": 117909,
                        "name": "Hamlin",
                        "latitude": "43.30312000",
                        "longitude": "-77.92112000"
                    },
                    {
                        "id": 117935,
                        "name": "Hampton Bays",
                        "latitude": "40.86899000",
                        "longitude": "-72.51759000"
                    },
                    {
                        "id": 117939,
                        "name": "Hampton Manor",
                        "latitude": "42.62091000",
                        "longitude": "-73.72845000"
                    },
                    {
                        "id": 117964,
                        "name": "Hannawa Falls",
                        "latitude": "44.61228000",
                        "longitude": "-74.97103000"
                    },
                    {
                        "id": 117990,
                        "name": "Harbor Isle",
                        "latitude": "40.60344000",
                        "longitude": "-73.66457000"
                    },
                    {
                        "id": 118023,
                        "name": "Harlem",
                        "latitude": "40.80788000",
                        "longitude": "-73.94542000"
                    },
                    {
                        "id": 118040,
                        "name": "Harriman",
                        "latitude": "41.30843000",
                        "longitude": "-74.14459000"
                    },
                    {
                        "id": 118046,
                        "name": "Harris Hill",
                        "latitude": "42.96478000",
                        "longitude": "-78.67753000"
                    },
                    {
                        "id": 118059,
                        "name": "Harrison",
                        "latitude": "40.96899000",
                        "longitude": "-73.71263000"
                    },
                    {
                        "id": 118090,
                        "name": "Hartford",
                        "latitude": "43.36368000",
                        "longitude": "-73.39372000"
                    },
                    {
                        "id": 118101,
                        "name": "Hartsdale",
                        "latitude": "41.01899000",
                        "longitude": "-73.79819000"
                    },
                    {
                        "id": 118135,
                        "name": "Hastings-on-Hudson",
                        "latitude": "40.99454000",
                        "longitude": "-73.87875000"
                    },
                    {
                        "id": 118143,
                        "name": "Hauppauge",
                        "latitude": "40.82565000",
                        "longitude": "-73.20261000"
                    },
                    {
                        "id": 118152,
                        "name": "Haverstraw",
                        "latitude": "41.19759000",
                        "longitude": "-73.96458000"
                    },
                    {
                        "id": 118153,
                        "name": "Haviland",
                        "latitude": "41.76676000",
                        "longitude": "-73.90152000"
                    },
                    {
                        "id": 118174,
                        "name": "Hawthorne",
                        "latitude": "41.10732000",
                        "longitude": "-73.79597000"
                    },
                    {
                        "id": 118215,
                        "name": "Head of the Harbor",
                        "latitude": "40.90343000",
                        "longitude": "-73.15789000"
                    },
                    {
                        "id": 118270,
                        "name": "Hempstead",
                        "latitude": "40.70621000",
                        "longitude": "-73.61874000"
                    },
                    {
                        "id": 118318,
                        "name": "Heritage Hills",
                        "latitude": "41.33954000",
                        "longitude": "-73.69735000"
                    },
                    {
                        "id": 118323,
                        "name": "Herkimer",
                        "latitude": "43.02563000",
                        "longitude": "-74.98599000"
                    },
                    {
                        "id": 118324,
                        "name": "Herkimer County",
                        "latitude": "43.41970000",
                        "longitude": "-74.96250000"
                    },
                    {
                        "id": 118337,
                        "name": "Herricks",
                        "latitude": "40.75538000",
                        "longitude": "-73.66680000"
                    },
                    {
                        "id": 118349,
                        "name": "Hewlett",
                        "latitude": "40.64316000",
                        "longitude": "-73.69569000"
                    },
                    {
                        "id": 118350,
                        "name": "Hewlett Harbor",
                        "latitude": "40.63621000",
                        "longitude": "-73.68152000"
                    },
                    {
                        "id": 118371,
                        "name": "Hicksville",
                        "latitude": "40.76843000",
                        "longitude": "-73.52513000"
                    },
                    {
                        "id": 118397,
                        "name": "Highland",
                        "latitude": "41.72093000",
                        "longitude": "-73.96014000"
                    },
                    {
                        "id": 118405,
                        "name": "Highland Falls",
                        "latitude": "41.36926000",
                        "longitude": "-73.96625000"
                    },
                    {
                        "id": 118409,
                        "name": "Highland Mills",
                        "latitude": "41.34704000",
                        "longitude": "-74.12626000"
                    },
                    {
                        "id": 118440,
                        "name": "Hillcrest",
                        "latitude": "41.12787000",
                        "longitude": "-74.04097000"
                    },
                    {
                        "id": 118465,
                        "name": "Hillside",
                        "latitude": "40.70788000",
                        "longitude": "-73.78680000"
                    },
                    {
                        "id": 118466,
                        "name": "Hillside Lake",
                        "latitude": "41.61482000",
                        "longitude": "-73.79819000"
                    },
                    {
                        "id": 118473,
                        "name": "Hilton",
                        "latitude": "43.28812000",
                        "longitude": "-77.79334000"
                    },
                    {
                        "id": 118518,
                        "name": "Holbrook",
                        "latitude": "40.81232000",
                        "longitude": "-73.07844000"
                    },
                    {
                        "id": 118520,
                        "name": "Holcomb",
                        "latitude": "42.90229000",
                        "longitude": "-77.41971000"
                    },
                    {
                        "id": 118540,
                        "name": "Holland",
                        "latitude": "42.64117000",
                        "longitude": "-78.54169000"
                    },
                    {
                        "id": 118543,
                        "name": "Holley",
                        "latitude": "43.22645000",
                        "longitude": "-78.02668000"
                    },
                    {
                        "id": 118549,
                        "name": "Hollis",
                        "latitude": "40.71344000",
                        "longitude": "-73.76708000"
                    },
                    {
                        "id": 118580,
                        "name": "Holtsville",
                        "latitude": "40.81538000",
                        "longitude": "-73.04511000"
                    },
                    {
                        "id": 118596,
                        "name": "Homer",
                        "latitude": "42.63701000",
                        "longitude": "-76.17882000"
                    },
                    {
                        "id": 118617,
                        "name": "Honeoye Falls",
                        "latitude": "42.95229000",
                        "longitude": "-77.59028000"
                    },
                    {
                        "id": 118637,
                        "name": "Hoosick Falls",
                        "latitude": "42.90119000",
                        "longitude": "-73.35150000"
                    },
                    {
                        "id": 118667,
                        "name": "Hornell",
                        "latitude": "42.32785000",
                        "longitude": "-77.66110000"
                    },
                    {
                        "id": 118673,
                        "name": "Horseheads",
                        "latitude": "42.16702000",
                        "longitude": "-76.82051000"
                    },
                    {
                        "id": 118674,
                        "name": "Horseheads North",
                        "latitude": "42.19278000",
                        "longitude": "-76.80782000"
                    },
                    {
                        "id": 118690,
                        "name": "Houghton",
                        "latitude": "42.42340000",
                        "longitude": "-78.15723000"
                    },
                    {
                        "id": 118710,
                        "name": "Howard Beach",
                        "latitude": "40.65788000",
                        "longitude": "-73.83625000"
                    },
                    {
                        "id": 118744,
                        "name": "Hudson",
                        "latitude": "42.25286000",
                        "longitude": "-73.79096000"
                    },
                    {
                        "id": 118750,
                        "name": "Hudson Falls",
                        "latitude": "43.30063000",
                        "longitude": "-73.58595000"
                    },
                    {
                        "id": 118769,
                        "name": "Huguenot",
                        "latitude": "40.53733000",
                        "longitude": "-74.19459000"
                    },
                    {
                        "id": 118802,
                        "name": "Huntington",
                        "latitude": "40.86815000",
                        "longitude": "-73.42568000"
                    },
                    {
                        "id": 118804,
                        "name": "Huntington Bay",
                        "latitude": "40.89982000",
                        "longitude": "-73.41484000"
                    },
                    {
                        "id": 118808,
                        "name": "Huntington Station",
                        "latitude": "40.85343000",
                        "longitude": "-73.41151000"
                    },
                    {
                        "id": 118813,
                        "name": "Hunts Point",
                        "latitude": "40.81260000",
                        "longitude": "-73.88402000"
                    },
                    {
                        "id": 118820,
                        "name": "Hurley",
                        "latitude": "41.92454000",
                        "longitude": "-74.06125000"
                    },
                    {
                        "id": 118850,
                        "name": "Hyde Park",
                        "latitude": "41.78482000",
                        "longitude": "-73.93319000"
                    },
                    {
                        "id": 118878,
                        "name": "Ilion",
                        "latitude": "43.01507000",
                        "longitude": "-75.03543000"
                    },
                    {
                        "id": 118963,
                        "name": "Inwood",
                        "latitude": "40.86566000",
                        "longitude": "-73.92680000"
                    },
                    {
                        "id": 118996,
                        "name": "Irondequoit",
                        "latitude": "43.21340000",
                        "longitude": "-77.57972000"
                    },
                    {
                        "id": 119010,
                        "name": "Irvington",
                        "latitude": "41.03922000",
                        "longitude": "-73.86823000"
                    },
                    {
                        "id": 119027,
                        "name": "Island Park",
                        "latitude": "40.60427000",
                        "longitude": "-73.65541000"
                    },
                    {
                        "id": 119029,
                        "name": "Islandia",
                        "latitude": "40.80426000",
                        "longitude": "-73.16900000"
                    },
                    {
                        "id": 119034,
                        "name": "Islip",
                        "latitude": "40.72982000",
                        "longitude": "-73.21039000"
                    },
                    {
                        "id": 119035,
                        "name": "Islip Terrace",
                        "latitude": "40.74315000",
                        "longitude": "-73.19262000"
                    },
                    {
                        "id": 119044,
                        "name": "Ithaca",
                        "latitude": "42.44063000",
                        "longitude": "-76.49661000"
                    },
                    {
                        "id": 119097,
                        "name": "Jackson Heights",
                        "latitude": "40.75566000",
                        "longitude": "-73.88541000"
                    },
                    {
                        "id": 119111,
                        "name": "Jamaica",
                        "latitude": "40.69149000",
                        "longitude": "-73.80569000"
                    },
                    {
                        "id": 119119,
                        "name": "Jamesport",
                        "latitude": "40.94954000",
                        "longitude": "-72.58148000"
                    },
                    {
                        "id": 119124,
                        "name": "Jamestown",
                        "latitude": "42.09700000",
                        "longitude": "-79.23533000"
                    },
                    {
                        "id": 119127,
                        "name": "Jamestown West",
                        "latitude": "42.08851000",
                        "longitude": "-79.28110000"
                    },
                    {
                        "id": 119191,
                        "name": "Jefferson County",
                        "latitude": "43.99885000",
                        "longitude": "-76.05211000"
                    },
                    {
                        "id": 119201,
                        "name": "Jefferson Heights",
                        "latitude": "42.23398000",
                        "longitude": "-73.88235000"
                    },
                    {
                        "id": 119204,
                        "name": "Jefferson Valley-Yorktown",
                        "latitude": "41.31797000",
                        "longitude": "-73.80066000"
                    },
                    {
                        "id": 119224,
                        "name": "Jericho",
                        "latitude": "40.79204000",
                        "longitude": "-73.53985000"
                    },
                    {
                        "id": 119259,
                        "name": "Johnson City",
                        "latitude": "42.11563000",
                        "longitude": "-75.95881000"
                    },
                    {
                        "id": 119284,
                        "name": "Johnstown",
                        "latitude": "43.00674000",
                        "longitude": "-74.36764000"
                    },
                    {
                        "id": 119316,
                        "name": "Jordan",
                        "latitude": "43.06534000",
                        "longitude": "-76.47299000"
                    },
                    {
                        "id": 119391,
                        "name": "Kaser",
                        "latitude": "41.12121000",
                        "longitude": "-74.06709000"
                    },
                    {
                        "id": 119394,
                        "name": "Katonah",
                        "latitude": "41.25898000",
                        "longitude": "-73.68541000"
                    },
                    {
                        "id": 119423,
                        "name": "Keeseville",
                        "latitude": "44.50505000",
                        "longitude": "-73.48013000"
                    },
                    {
                        "id": 119462,
                        "name": "Kenmore",
                        "latitude": "42.96589000",
                        "longitude": "-78.87004000"
                    },
                    {
                        "id": 119483,
                        "name": "Kensington",
                        "latitude": "40.79343000",
                        "longitude": "-73.72208000"
                    },
                    {
                        "id": 119511,
                        "name": "Kerhonkson",
                        "latitude": "41.77482000",
                        "longitude": "-74.29821000"
                    },
                    {
                        "id": 119529,
                        "name": "Keuka Park",
                        "latitude": "42.61535000",
                        "longitude": "-77.09219000"
                    },
                    {
                        "id": 119530,
                        "name": "Kew Gardens",
                        "latitude": "40.71427000",
                        "longitude": "-73.83097000"
                    },
                    {
                        "id": 119531,
                        "name": "Kew Gardens Hills",
                        "latitude": "40.73002000",
                        "longitude": "-73.82340000"
                    },
                    {
                        "id": 119550,
                        "name": "Kiantone",
                        "latitude": "42.02200000",
                        "longitude": "-79.19810000"
                    },
                    {
                        "id": 119575,
                        "name": "Kinderhook",
                        "latitude": "42.39536000",
                        "longitude": "-73.69790000"
                    },
                    {
                        "id": 119599,
                        "name": "Kings Bridge",
                        "latitude": "40.87871000",
                        "longitude": "-73.90514000"
                    },
                    {
                        "id": 119601,
                        "name": "Kings County",
                        "latitude": "40.63439000",
                        "longitude": "-73.95027000"
                    },
                    {
                        "id": 119605,
                        "name": "Kings Park",
                        "latitude": "40.88621000",
                        "longitude": "-73.25734000"
                    },
                    {
                        "id": 119608,
                        "name": "Kings Point",
                        "latitude": "40.81982000",
                        "longitude": "-73.73513000"
                    },
                    {
                        "id": 119627,
                        "name": "Kingston",
                        "latitude": "41.92704000",
                        "longitude": "-73.99736000"
                    },
                    {
                        "id": 119656,
                        "name": "Kiryas Joel",
                        "latitude": "41.34204000",
                        "longitude": "-74.16792000"
                    },
                    {
                        "id": 119813,
                        "name": "Lackawanna",
                        "latitude": "42.82561000",
                        "longitude": "-78.82337000"
                    },
                    {
                        "id": 119875,
                        "name": "Lake Carmel",
                        "latitude": "41.46148000",
                        "longitude": "-73.67096000"
                    },
                    {
                        "id": 119907,
                        "name": "Lake Erie Beach",
                        "latitude": "42.62423000",
                        "longitude": "-79.06698000"
                    },
                    {
                        "id": 119914,
                        "name": "Lake Grove",
                        "latitude": "40.85288000",
                        "longitude": "-73.11511000"
                    },
                    {
                        "id": 119926,
                        "name": "Lake Katrine",
                        "latitude": "41.98565000",
                        "longitude": "-73.98819000"
                    },
                    {
                        "id": 119935,
                        "name": "Lake Luzerne",
                        "latitude": "43.31285000",
                        "longitude": "-73.83484000"
                    },
                    {
                        "id": 119945,
                        "name": "Lake Mohegan",
                        "latitude": "41.31787000",
                        "longitude": "-73.84625000"
                    },
                    {
                        "id": 119963,
                        "name": "Lake Placid",
                        "latitude": "44.27962000",
                        "longitude": "-73.98198000"
                    },
                    {
                        "id": 119964,
                        "name": "Lake Pleasant",
                        "latitude": "43.47090000",
                        "longitude": "-74.41265000"
                    },
                    {
                        "id": 119970,
                        "name": "Lake Ronkonkoma",
                        "latitude": "40.83510000",
                        "longitude": "-73.13122000"
                    },
                    {
                        "id": 119982,
                        "name": "Lake Success",
                        "latitude": "40.77066000",
                        "longitude": "-73.71763000"
                    },
                    {
                        "id": 120016,
                        "name": "Lakeland",
                        "latitude": "43.09034000",
                        "longitude": "-76.24048000"
                    },
                    {
                        "id": 120039,
                        "name": "Lakeview",
                        "latitude": "40.68538000",
                        "longitude": "-73.65263000"
                    },
                    {
                        "id": 120049,
                        "name": "Lakewood",
                        "latitude": "42.10422000",
                        "longitude": "-79.33310000"
                    },
                    {
                        "id": 120086,
                        "name": "Lancaster",
                        "latitude": "42.90061000",
                        "longitude": "-78.67031000"
                    },
                    {
                        "id": 120128,
                        "name": "Lansing",
                        "latitude": "42.48424000",
                        "longitude": "-76.47994000"
                    },
                    {
                        "id": 120141,
                        "name": "Larchmont",
                        "latitude": "40.92788000",
                        "longitude": "-73.75180000"
                    },
                    {
                        "id": 120168,
                        "name": "Latham",
                        "latitude": "42.74702000",
                        "longitude": "-73.75901000"
                    },
                    {
                        "id": 120177,
                        "name": "Lattingtown",
                        "latitude": "40.89538000",
                        "longitude": "-73.60096000"
                    },
                    {
                        "id": 120192,
                        "name": "Laurel",
                        "latitude": "40.96954000",
                        "longitude": "-72.56203000"
                    },
                    {
                        "id": 120198,
                        "name": "Laurel Hollow",
                        "latitude": "40.85677000",
                        "longitude": "-73.46957000"
                    },
                    {
                        "id": 120204,
                        "name": "Laurelton",
                        "latitude": "40.67019000",
                        "longitude": "-73.74659000"
                    },
                    {
                        "id": 120228,
                        "name": "Lawrence",
                        "latitude": "40.61566000",
                        "longitude": "-73.72958000"
                    },
                    {
                        "id": 120263,
                        "name": "Le Roy",
                        "latitude": "42.97839000",
                        "longitude": "-77.98418000"
                    },
                    {
                        "id": 120407,
                        "name": "Levittown",
                        "latitude": "40.72593000",
                        "longitude": "-73.51429000"
                    },
                    {
                        "id": 120415,
                        "name": "Lewis County",
                        "latitude": "43.78469000",
                        "longitude": "-75.44879000"
                    },
                    {
                        "id": 120426,
                        "name": "Lewiston",
                        "latitude": "43.17256000",
                        "longitude": "-79.03588000"
                    },
                    {
                        "id": 120466,
                        "name": "Liberty",
                        "latitude": "41.80120000",
                        "longitude": "-74.74655000"
                    },
                    {
                        "id": 120478,
                        "name": "Lido Beach",
                        "latitude": "40.58899000",
                        "longitude": "-73.62541000"
                    },
                    {
                        "id": 120489,
                        "name": "Lima",
                        "latitude": "42.90479000",
                        "longitude": "-77.61139000"
                    },
                    {
                        "id": 120543,
                        "name": "Lincoln Park",
                        "latitude": "41.95065000",
                        "longitude": "-73.99403000"
                    },
                    {
                        "id": 120548,
                        "name": "Lincolndale",
                        "latitude": "41.32287000",
                        "longitude": "-73.71819000"
                    },
                    {
                        "id": 120568,
                        "name": "Lindenhurst",
                        "latitude": "40.68677000",
                        "longitude": "-73.37345000"
                    },
                    {
                        "id": 120570,
                        "name": "Lindley",
                        "latitude": "42.02841000",
                        "longitude": "-77.13969000"
                    },
                    {
                        "id": 120619,
                        "name": "Little Falls",
                        "latitude": "43.04340000",
                        "longitude": "-74.85960000"
                    },
                    {
                        "id": 120622,
                        "name": "Little Neck",
                        "latitude": "40.76289000",
                        "longitude": "-73.73225000"
                    },
                    {
                        "id": 120631,
                        "name": "Little Valley",
                        "latitude": "42.25256000",
                        "longitude": "-78.80559000"
                    },
                    {
                        "id": 120646,
                        "name": "Liverpool",
                        "latitude": "43.10646000",
                        "longitude": "-76.21770000"
                    },
                    {
                        "id": 120658,
                        "name": "Livingston County",
                        "latitude": "42.72808000",
                        "longitude": "-77.77549000"
                    },
                    {
                        "id": 120659,
                        "name": "Livingston Manor",
                        "latitude": "41.90037000",
                        "longitude": "-74.82822000"
                    },
                    {
                        "id": 120663,
                        "name": "Livonia",
                        "latitude": "42.82145000",
                        "longitude": "-77.66861000"
                    },
                    {
                        "id": 120667,
                        "name": "Lloyd Harbor",
                        "latitude": "40.90343000",
                        "longitude": "-73.45984000"
                    },
                    {
                        "id": 120681,
                        "name": "Lockport",
                        "latitude": "43.17061000",
                        "longitude": "-78.69031000"
                    },
                    {
                        "id": 120688,
                        "name": "Locust Valley",
                        "latitude": "40.87593000",
                        "longitude": "-73.59707000"
                    },
                    {
                        "id": 120737,
                        "name": "Long Beach",
                        "latitude": "40.58844000",
                        "longitude": "-73.65791000"
                    },
                    {
                        "id": 120745,
                        "name": "Long Island City",
                        "latitude": "40.74482000",
                        "longitude": "-73.94875000"
                    },
                    {
                        "id": 120772,
                        "name": "Lorenz Park",
                        "latitude": "42.26370000",
                        "longitude": "-73.76846000"
                    },
                    {
                        "id": 120850,
                        "name": "Lowville",
                        "latitude": "43.78674000",
                        "longitude": "-75.49185000"
                    },
                    {
                        "id": 120913,
                        "name": "Lynbrook",
                        "latitude": "40.65483000",
                        "longitude": "-73.67180000"
                    },
                    {
                        "id": 120917,
                        "name": "Lyncourt",
                        "latitude": "43.08146000",
                        "longitude": "-76.12576000"
                    },
                    {
                        "id": 120943,
                        "name": "Lyons",
                        "latitude": "43.06423000",
                        "longitude": "-76.99025000"
                    },
                    {
                        "id": 120954,
                        "name": "Macedon",
                        "latitude": "43.06923000",
                        "longitude": "-77.29887000"
                    },
                    {
                        "id": 121017,
                        "name": "Madison County",
                        "latitude": "42.91277000",
                        "longitude": "-75.66967000"
                    },
                    {
                        "id": 121046,
                        "name": "Mahopac",
                        "latitude": "41.37232000",
                        "longitude": "-73.73346000"
                    },
                    {
                        "id": 121066,
                        "name": "Malone",
                        "latitude": "44.84866000",
                        "longitude": "-74.29490000"
                    },
                    {
                        "id": 121074,
                        "name": "Malverne",
                        "latitude": "40.67899000",
                        "longitude": "-73.67402000"
                    },
                    {
                        "id": 121075,
                        "name": "Mamaroneck",
                        "latitude": "40.94871000",
                        "longitude": "-73.73263000"
                    },
                    {
                        "id": 121099,
                        "name": "Manchester",
                        "latitude": "42.96979000",
                        "longitude": "-77.23026000"
                    },
                    {
                        "id": 121111,
                        "name": "Manhasset",
                        "latitude": "40.79788000",
                        "longitude": "-73.69957000"
                    },
                    {
                        "id": 121112,
                        "name": "Manhasset Hills",
                        "latitude": "40.75927000",
                        "longitude": "-73.67985000"
                    },
                    {
                        "id": 121115,
                        "name": "Manhattan",
                        "latitude": "40.78343000",
                        "longitude": "-73.96625000"
                    },
                    {
                        "id": 121131,
                        "name": "Manlius",
                        "latitude": "43.00201000",
                        "longitude": "-75.97686000"
                    },
                    {
                        "id": 121140,
                        "name": "Manorhaven",
                        "latitude": "40.84316000",
                        "longitude": "-73.71485000"
                    },
                    {
                        "id": 121141,
                        "name": "Manorville",
                        "latitude": "40.87371000",
                        "longitude": "-72.80788000"
                    },
                    {
                        "id": 121191,
                        "name": "Marbletown",
                        "latitude": "41.88343000",
                        "longitude": "-74.11320000"
                    },
                    {
                        "id": 121195,
                        "name": "Marcellus",
                        "latitude": "42.98284000",
                        "longitude": "-76.34049000"
                    },
                    {
                        "id": 121227,
                        "name": "Mariners Harbor",
                        "latitude": "40.63677000",
                        "longitude": "-74.15875000"
                    },
                    {
                        "id": 121244,
                        "name": "Marion",
                        "latitude": "43.14340000",
                        "longitude": "-77.18915000"
                    },
                    {
                        "id": 121275,
                        "name": "Marlboro",
                        "latitude": "41.60565000",
                        "longitude": "-73.97153000"
                    },
                    {
                        "id": 121386,
                        "name": "Maspeth",
                        "latitude": "40.72316000",
                        "longitude": "-73.91264000"
                    },
                    {
                        "id": 121391,
                        "name": "Massapequa",
                        "latitude": "40.68066000",
                        "longitude": "-73.47429000"
                    },
                    {
                        "id": 121392,
                        "name": "Massapequa Park",
                        "latitude": "40.68038000",
                        "longitude": "-73.45512000"
                    },
                    {
                        "id": 121393,
                        "name": "Massena",
                        "latitude": "44.92810000",
                        "longitude": "-74.89186000"
                    },
                    {
                        "id": 121394,
                        "name": "Mastic",
                        "latitude": "40.80204000",
                        "longitude": "-72.84094000"
                    },
                    {
                        "id": 121395,
                        "name": "Mastic Beach",
                        "latitude": "40.76677000",
                        "longitude": "-72.85205000"
                    },
                    {
                        "id": 121413,
                        "name": "Mattituck",
                        "latitude": "40.99121000",
                        "longitude": "-72.53425000"
                    },
                    {
                        "id": 121415,
                        "name": "Mattydale",
                        "latitude": "43.09784000",
                        "longitude": "-76.14520000"
                    },
                    {
                        "id": 121431,
                        "name": "Maybrook",
                        "latitude": "41.48398000",
                        "longitude": "-74.21765000"
                    },
                    {
                        "id": 121455,
                        "name": "Mayville",
                        "latitude": "42.25395000",
                        "longitude": "-79.50449000"
                    },
                    {
                        "id": 121504,
                        "name": "McGraw",
                        "latitude": "42.59618000",
                        "longitude": "-76.09326000"
                    },
                    {
                        "id": 121526,
                        "name": "McKownville",
                        "latitude": "42.68397000",
                        "longitude": "-73.84762000"
                    },
                    {
                        "id": 121581,
                        "name": "Mechanicstown",
                        "latitude": "41.44287000",
                        "longitude": "-74.38849000"
                    },
                    {
                        "id": 121586,
                        "name": "Mechanicville",
                        "latitude": "42.90285000",
                        "longitude": "-73.68734000"
                    },
                    {
                        "id": 121594,
                        "name": "Medford",
                        "latitude": "40.81760000",
                        "longitude": "-73.00011000"
                    },
                    {
                        "id": 121605,
                        "name": "Medina",
                        "latitude": "43.22006000",
                        "longitude": "-78.38697000"
                    },
                    {
                        "id": 121630,
                        "name": "Melrose",
                        "latitude": "40.82455000",
                        "longitude": "-73.91041000"
                    },
                    {
                        "id": 121633,
                        "name": "Melrose Park",
                        "latitude": "42.90868000",
                        "longitude": "-76.54022000"
                    },
                    {
                        "id": 121635,
                        "name": "Melville",
                        "latitude": "40.79343000",
                        "longitude": "-73.41512000"
                    },
                    {
                        "id": 121645,
                        "name": "Menands",
                        "latitude": "42.69202000",
                        "longitude": "-73.72456000"
                    },
                    {
                        "id": 121704,
                        "name": "Merrick",
                        "latitude": "40.66288000",
                        "longitude": "-73.55152000"
                    },
                    {
                        "id": 121715,
                        "name": "Merritt Park",
                        "latitude": "41.53848000",
                        "longitude": "-73.87238000"
                    },
                    {
                        "id": 121743,
                        "name": "Mexico",
                        "latitude": "43.45951000",
                        "longitude": "-76.22882000"
                    },
                    {
                        "id": 121761,
                        "name": "Middle Island",
                        "latitude": "40.88427000",
                        "longitude": "-72.93733000"
                    },
                    {
                        "id": 121764,
                        "name": "Middle Village",
                        "latitude": "40.71649000",
                        "longitude": "-73.88125000"
                    },
                    {
                        "id": 121770,
                        "name": "Middleburgh",
                        "latitude": "42.59869000",
                        "longitude": "-74.33292000"
                    },
                    {
                        "id": 121775,
                        "name": "Middleport",
                        "latitude": "43.21256000",
                        "longitude": "-78.47641000"
                    },
                    {
                        "id": 121791,
                        "name": "Middletown",
                        "latitude": "41.44593000",
                        "longitude": "-74.42293000"
                    },
                    {
                        "id": 121802,
                        "name": "Midland Beach",
                        "latitude": "40.57316000",
                        "longitude": "-74.09459000"
                    },
                    {
                        "id": 121866,
                        "name": "Mill Neck",
                        "latitude": "40.88704000",
                        "longitude": "-73.55512000"
                    },
                    {
                        "id": 121873,
                        "name": "Millbrook",
                        "latitude": "41.78509000",
                        "longitude": "-73.69402000"
                    },
                    {
                        "id": 121883,
                        "name": "Miller Place",
                        "latitude": "40.95982000",
                        "longitude": "-72.99621000"
                    },
                    {
                        "id": 121916,
                        "name": "Milton",
                        "latitude": "43.03369000",
                        "longitude": "-73.85262000"
                    },
                    {
                        "id": 121932,
                        "name": "Mineola",
                        "latitude": "40.74927000",
                        "longitude": "-73.64068000"
                    },
                    {
                        "id": 121944,
                        "name": "Minetto",
                        "latitude": "43.39812000",
                        "longitude": "-76.47744000"
                    },
                    {
                        "id": 121945,
                        "name": "Mineville",
                        "latitude": "44.09283000",
                        "longitude": "-73.51818000"
                    },
                    {
                        "id": 121960,
                        "name": "Minoa",
                        "latitude": "43.07618000",
                        "longitude": "-76.00075000"
                    },
                    {
                        "id": 122021,
                        "name": "Mohawk",
                        "latitude": "43.01146000",
                        "longitude": "-75.00404000"
                    },
                    {
                        "id": 122062,
                        "name": "Monroe",
                        "latitude": "41.33065000",
                        "longitude": "-74.18681000"
                    },
                    {
                        "id": 122080,
                        "name": "Monroe County",
                        "latitude": "43.16512000",
                        "longitude": "-77.63626000"
                    },
                    {
                        "id": 122089,
                        "name": "Monsey",
                        "latitude": "41.11121000",
                        "longitude": "-74.06848000"
                    },
                    {
                        "id": 122103,
                        "name": "Montauk",
                        "latitude": "41.03594000",
                        "longitude": "-71.95451000"
                    },
                    {
                        "id": 122113,
                        "name": "Montebello",
                        "latitude": "41.13593000",
                        "longitude": "-74.11848000"
                    },
                    {
                        "id": 122135,
                        "name": "Montgomery",
                        "latitude": "41.52759000",
                        "longitude": "-74.23682000"
                    },
                    {
                        "id": 122154,
                        "name": "Montgomery County",
                        "latitude": "42.90228000",
                        "longitude": "-74.43968000"
                    },
                    {
                        "id": 122169,
                        "name": "Monticello",
                        "latitude": "41.65565000",
                        "longitude": "-74.68933000"
                    },
                    {
                        "id": 122174,
                        "name": "Montour Falls",
                        "latitude": "42.34730000",
                        "longitude": "-76.84524000"
                    },
                    {
                        "id": 122182,
                        "name": "Montrose",
                        "latitude": "41.25232000",
                        "longitude": "-73.93153000"
                    },
                    {
                        "id": 122223,
                        "name": "Moravia",
                        "latitude": "42.71257000",
                        "longitude": "-76.42160000"
                    },
                    {
                        "id": 122256,
                        "name": "Moriches",
                        "latitude": "40.80732000",
                        "longitude": "-72.82121000"
                    },
                    {
                        "id": 122258,
                        "name": "Morningside Heights",
                        "latitude": "40.81000000",
                        "longitude": "-73.96250000"
                    },
                    {
                        "id": 122272,
                        "name": "Morris Heights",
                        "latitude": "40.84982000",
                        "longitude": "-73.91986000"
                    },
                    {
                        "id": 122273,
                        "name": "Morris Park",
                        "latitude": "40.85232000",
                        "longitude": "-73.85347000"
                    },
                    {
                        "id": 122275,
                        "name": "Morrisania",
                        "latitude": "40.82927000",
                        "longitude": "-73.90653000"
                    },
                    {
                        "id": 122279,
                        "name": "Morrisonville",
                        "latitude": "44.69310000",
                        "longitude": "-73.56208000"
                    },
                    {
                        "id": 122285,
                        "name": "Morrisville",
                        "latitude": "42.89868000",
                        "longitude": "-75.64018000"
                    },
                    {
                        "id": 122313,
                        "name": "Mott Haven",
                        "latitude": "40.80899000",
                        "longitude": "-73.92291000"
                    },
                    {
                        "id": 122356,
                        "name": "Mount Ivy",
                        "latitude": "41.18676000",
                        "longitude": "-74.03486000"
                    },
                    {
                        "id": 122360,
                        "name": "Mount Kisco",
                        "latitude": "41.20426000",
                        "longitude": "-73.72708000"
                    },
                    {
                        "id": 122365,
                        "name": "Mount Morris",
                        "latitude": "42.72562000",
                        "longitude": "-77.87417000"
                    },
                    {
                        "id": 122389,
                        "name": "Mount Sinai",
                        "latitude": "40.94704000",
                        "longitude": "-73.02955000"
                    },
                    {
                        "id": 122402,
                        "name": "Mount Vernon",
                        "latitude": "40.91260000",
                        "longitude": "-73.83708000"
                    },
                    {
                        "id": 122423,
                        "name": "Mountain Lodge Park",
                        "latitude": "41.38843000",
                        "longitude": "-74.14181000"
                    },
                    {
                        "id": 122476,
                        "name": "Munsey Park",
                        "latitude": "40.79871000",
                        "longitude": "-73.67985000"
                    },
                    {
                        "id": 122477,
                        "name": "Munsons Corners",
                        "latitude": "42.58229000",
                        "longitude": "-76.20910000"
                    },
                    {
                        "id": 122516,
                        "name": "Muttontown",
                        "latitude": "40.82399000",
                        "longitude": "-73.54763000"
                    },
                    {
                        "id": 122517,
                        "name": "Myers Corner",
                        "latitude": "41.60620000",
                        "longitude": "-73.87291000"
                    },
                    {
                        "id": 122545,
                        "name": "Nanuet",
                        "latitude": "41.08871000",
                        "longitude": "-74.01347000"
                    },
                    {
                        "id": 122548,
                        "name": "Napanoch",
                        "latitude": "41.74398000",
                        "longitude": "-74.37154000"
                    },
                    {
                        "id": 122554,
                        "name": "Naples",
                        "latitude": "42.61535000",
                        "longitude": "-77.40249000"
                    },
                    {
                        "id": 122580,
                        "name": "Nassau",
                        "latitude": "42.51591000",
                        "longitude": "-73.61012000"
                    },
                    {
                        "id": 122583,
                        "name": "Nassau County",
                        "latitude": "40.73217000",
                        "longitude": "-73.58545000"
                    },
                    {
                        "id": 122612,
                        "name": "Nedrow",
                        "latitude": "42.97507000",
                        "longitude": "-76.14131000"
                    },
                    {
                        "id": 122636,
                        "name": "Neponsit",
                        "latitude": "40.57177000",
                        "longitude": "-73.86152000"
                    },
                    {
                        "id": 122639,
                        "name": "Nesconset",
                        "latitude": "40.85204000",
                        "longitude": "-73.15400000"
                    },
                    {
                        "id": 122672,
                        "name": "New Brighton",
                        "latitude": "40.64233000",
                        "longitude": "-74.09292000"
                    },
                    {
                        "id": 122682,
                        "name": "New Cassel",
                        "latitude": "40.75899000",
                        "longitude": "-73.56957000"
                    },
                    {
                        "id": 122695,
                        "name": "New City",
                        "latitude": "41.14760000",
                        "longitude": "-73.98931000"
                    },
                    {
                        "id": 122699,
                        "name": "New Dorp",
                        "latitude": "40.57399000",
                        "longitude": "-74.11598000"
                    },
                    {
                        "id": 122700,
                        "name": "New Dorp Beach",
                        "latitude": "40.56538000",
                        "longitude": "-74.10292000"
                    },
                    {
                        "id": 122712,
                        "name": "New Hartford",
                        "latitude": "43.07340000",
                        "longitude": "-75.28767000"
                    },
                    {
                        "id": 122720,
                        "name": "New Hempstead",
                        "latitude": "41.14982000",
                        "longitude": "-74.03375000"
                    },
                    {
                        "id": 122729,
                        "name": "New Hyde Park",
                        "latitude": "40.73510000",
                        "longitude": "-73.68791000"
                    },
                    {
                        "id": 122759,
                        "name": "New Paltz",
                        "latitude": "41.74759000",
                        "longitude": "-74.08681000"
                    },
                    {
                        "id": 122773,
                        "name": "New Rochelle",
                        "latitude": "40.91149000",
                        "longitude": "-73.78235000"
                    },
                    {
                        "id": 122781,
                        "name": "New Springville",
                        "latitude": "40.59344000",
                        "longitude": "-74.16320000"
                    },
                    {
                        "id": 122782,
                        "name": "New Square",
                        "latitude": "41.13956000",
                        "longitude": "-74.02942000"
                    },
                    {
                        "id": 122794,
                        "name": "New Windsor",
                        "latitude": "41.47676000",
                        "longitude": "-74.02375000"
                    },
                    {
                        "id": 122795,
                        "name": "New York City",
                        "latitude": "40.71427000",
                        "longitude": "-74.00597000"
                    },
                    {
                        "id": 122798,
                        "name": "New York Mills",
                        "latitude": "43.10535000",
                        "longitude": "-75.29128000"
                    },
                    {
                        "id": 122804,
                        "name": "Newark",
                        "latitude": "43.04673000",
                        "longitude": "-77.09525000"
                    },
                    {
                        "id": 122817,
                        "name": "Newburgh",
                        "latitude": "41.50343000",
                        "longitude": "-74.01042000"
                    },
                    {
                        "id": 122826,
                        "name": "Newfane",
                        "latitude": "43.28672000",
                        "longitude": "-78.71031000"
                    },
                    {
                        "id": 122881,
                        "name": "Niagara County",
                        "latitude": "43.17314000",
                        "longitude": "-78.69095000"
                    },
                    {
                        "id": 122882,
                        "name": "Niagara Falls",
                        "latitude": "43.09450000",
                        "longitude": "-79.05671000"
                    },
                    {
                        "id": 122906,
                        "name": "Niskayuna",
                        "latitude": "42.77980000",
                        "longitude": "-73.84568000"
                    },
                    {
                        "id": 122907,
                        "name": "Nissequogue",
                        "latitude": "40.90399000",
                        "longitude": "-73.19789000"
                    },
                    {
                        "id": 122910,
                        "name": "Niverville",
                        "latitude": "42.44092000",
                        "longitude": "-73.66095000"
                    },
                    {
                        "id": 122944,
                        "name": "Norfolk",
                        "latitude": "44.80089000",
                        "longitude": "-74.99103000"
                    },
                    {
                        "id": 122961,
                        "name": "North Amityville",
                        "latitude": "40.69760000",
                        "longitude": "-73.42512000"
                    },
                    {
                        "id": 122971,
                        "name": "North Babylon",
                        "latitude": "40.71649000",
                        "longitude": "-73.32179000"
                    },
                    {
                        "id": 122972,
                        "name": "North Ballston Spa",
                        "latitude": "43.01969000",
                        "longitude": "-73.85109000"
                    },
                    {
                        "id": 122975,
                        "name": "North Bay Shore",
                        "latitude": "40.73621000",
                        "longitude": "-73.26262000"
                    },
                    {
                        "id": 122981,
                        "name": "North Bellmore",
                        "latitude": "40.69149000",
                        "longitude": "-73.53346000"
                    },
                    {
                        "id": 122982,
                        "name": "North Bellport",
                        "latitude": "40.77427000",
                        "longitude": "-72.94288000"
                    },
                    {
                        "id": 122991,
                        "name": "North Boston",
                        "latitude": "42.68562000",
                        "longitude": "-78.77670000"
                    },
                    {
                        "id": 123001,
                        "name": "North Castle",
                        "latitude": "41.14000000",
                        "longitude": "-73.68389000"
                    },
                    {
                        "id": 123008,
                        "name": "North Collins",
                        "latitude": "42.59534000",
                        "longitude": "-78.94115000"
                    },
                    {
                        "id": 123022,
                        "name": "North Elba",
                        "latitude": "44.24338000",
                        "longitude": "-73.95431000"
                    },
                    {
                        "id": 123030,
                        "name": "North Gates",
                        "latitude": "43.17645000",
                        "longitude": "-77.70139000"
                    },
                    {
                        "id": 123032,
                        "name": "North Great River",
                        "latitude": "40.74732000",
                        "longitude": "-73.16984000"
                    },
                    {
                        "id": 123040,
                        "name": "North Hills",
                        "latitude": "40.78093000",
                        "longitude": "-73.67652000"
                    },
                    {
                        "id": 123058,
                        "name": "North Lindenhurst",
                        "latitude": "40.71427000",
                        "longitude": "-73.38151000"
                    },
                    {
                        "id": 123064,
                        "name": "North Massapequa",
                        "latitude": "40.70093000",
                        "longitude": "-73.46207000"
                    },
                    {
                        "id": 123065,
                        "name": "North Merrick",
                        "latitude": "40.69121000",
                        "longitude": "-73.56318000"
                    },
                    {
                        "id": 123071,
                        "name": "North New Hyde Park",
                        "latitude": "40.74316000",
                        "longitude": "-73.69319000"
                    },
                    {
                        "id": 123076,
                        "name": "North Patchogue",
                        "latitude": "40.78704000",
                        "longitude": "-73.00900000"
                    },
                    {
                        "id": 123103,
                        "name": "North Sea",
                        "latitude": "40.93288000",
                        "longitude": "-72.41425000"
                    },
                    {
                        "id": 123113,
                        "name": "North Syracuse",
                        "latitude": "43.13479000",
                        "longitude": "-76.12992000"
                    },
                    {
                        "id": 123115,
                        "name": "North Tonawanda",
                        "latitude": "43.03867000",
                        "longitude": "-78.86420000"
                    },
                    {
                        "id": 123120,
                        "name": "North Valley Stream",
                        "latitude": "40.68510000",
                        "longitude": "-73.70180000"
                    },
                    {
                        "id": 123124,
                        "name": "North Wantagh",
                        "latitude": "40.69343000",
                        "longitude": "-73.50763000"
                    },
                    {
                        "id": 123146,
                        "name": "Northeast Ithaca",
                        "latitude": "42.47032000",
                        "longitude": "-76.46228000"
                    },
                    {
                        "id": 123162,
                        "name": "Northport",
                        "latitude": "40.90093000",
                        "longitude": "-73.34317000"
                    },
                    {
                        "id": 123165,
                        "name": "Northumberland",
                        "latitude": "43.12730000",
                        "longitude": "-73.58817000"
                    },
                    {
                        "id": 123172,
                        "name": "Northville",
                        "latitude": "40.97010000",
                        "longitude": "-72.61898000"
                    },
                    {
                        "id": 123174,
                        "name": "Northwest Harbor",
                        "latitude": "41.00982000",
                        "longitude": "-72.22119000"
                    },
                    {
                        "id": 123178,
                        "name": "Northwest Ithaca",
                        "latitude": "42.47059000",
                        "longitude": "-76.54145000"
                    },
                    {
                        "id": 123196,
                        "name": "Norwich",
                        "latitude": "42.53118000",
                        "longitude": "-75.52351000"
                    },
                    {
                        "id": 123201,
                        "name": "Norwood",
                        "latitude": "44.75145000",
                        "longitude": "-74.99436000"
                    },
                    {
                        "id": 123213,
                        "name": "Noyack",
                        "latitude": "40.99566000",
                        "longitude": "-72.34119000"
                    },
                    {
                        "id": 123217,
                        "name": "Nunda",
                        "latitude": "42.57951000",
                        "longitude": "-77.94250000"
                    },
                    {
                        "id": 123221,
                        "name": "Nyack",
                        "latitude": "41.09065000",
                        "longitude": "-73.91791000"
                    },
                    {
                        "id": 123272,
                        "name": "Oakdale",
                        "latitude": "40.74399000",
                        "longitude": "-73.13872000"
                    },
                    {
                        "id": 123276,
                        "name": "Oakfield",
                        "latitude": "43.06589000",
                        "longitude": "-78.26974000"
                    },
                    {
                        "id": 123310,
                        "name": "Oakwood",
                        "latitude": "40.56399000",
                        "longitude": "-74.11598000"
                    },
                    {
                        "id": 123343,
                        "name": "Oceanside",
                        "latitude": "40.63871000",
                        "longitude": "-73.64013000"
                    },
                    {
                        "id": 123372,
                        "name": "Ogdensburg",
                        "latitude": "44.69423000",
                        "longitude": "-75.48634000"
                    },
                    {
                        "id": 123414,
                        "name": "Olcott",
                        "latitude": "43.33783000",
                        "longitude": "-78.71476000"
                    },
                    {
                        "id": 123415,
                        "name": "Old Bethpage",
                        "latitude": "40.76260000",
                        "longitude": "-73.45318000"
                    },
                    {
                        "id": 123417,
                        "name": "Old Brookville",
                        "latitude": "40.83204000",
                        "longitude": "-73.60485000"
                    },
                    {
                        "id": 123431,
                        "name": "Old Westbury",
                        "latitude": "40.78871000",
                        "longitude": "-73.59957000"
                    },
                    {
                        "id": 123435,
                        "name": "Olean",
                        "latitude": "42.07756000",
                        "longitude": "-78.42974000"
                    },
                    {
                        "id": 123473,
                        "name": "Oneida",
                        "latitude": "43.09257000",
                        "longitude": "-75.65129000"
                    },
                    {
                        "id": 123475,
                        "name": "Oneida County",
                        "latitude": "43.24175000",
                        "longitude": "-75.43584000"
                    },
                    {
                        "id": 123479,
                        "name": "Oneonta",
                        "latitude": "42.45286000",
                        "longitude": "-75.06377000"
                    },
                    {
                        "id": 123482,
                        "name": "Onondaga County",
                        "latitude": "43.00580000",
                        "longitude": "-76.19464000"
                    },
                    {
                        "id": 123485,
                        "name": "Ontario",
                        "latitude": "43.22090000",
                        "longitude": "-77.28304000"
                    },
                    {
                        "id": 123488,
                        "name": "Ontario County",
                        "latitude": "42.85285000",
                        "longitude": "-77.29982000"
                    },
                    {
                        "id": 123519,
                        "name": "Orange County",
                        "latitude": "41.40214000",
                        "longitude": "-74.30557000"
                    },
                    {
                        "id": 123524,
                        "name": "Orange Lake",
                        "latitude": "41.53982000",
                        "longitude": "-74.09820000"
                    },
                    {
                        "id": 123527,
                        "name": "Orangeburg",
                        "latitude": "41.04649000",
                        "longitude": "-73.94958000"
                    },
                    {
                        "id": 123538,
                        "name": "Orchard Park",
                        "latitude": "42.76756000",
                        "longitude": "-78.74392000"
                    },
                    {
                        "id": 123557,
                        "name": "Oriskany",
                        "latitude": "43.15729000",
                        "longitude": "-75.33267000"
                    },
                    {
                        "id": 123565,
                        "name": "Orleans County",
                        "latitude": "43.25070000",
                        "longitude": "-78.18901000"
                    },
                    {
                        "id": 123617,
                        "name": "Ossining",
                        "latitude": "41.16287000",
                        "longitude": "-73.86152000"
                    },
                    {
                        "id": 123623,
                        "name": "Oswego",
                        "latitude": "43.45535000",
                        "longitude": "-76.51050000"
                    },
                    {
                        "id": 123624,
                        "name": "Oswego County",
                        "latitude": "43.46389000",
                        "longitude": "-76.20868000"
                    },
                    {
                        "id": 123630,
                        "name": "Otisville",
                        "latitude": "41.47343000",
                        "longitude": "-74.53849000"
                    },
                    {
                        "id": 123635,
                        "name": "Otsego County",
                        "latitude": "42.63376000",
                        "longitude": "-75.03261000"
                    },
                    {
                        "id": 123660,
                        "name": "Owego",
                        "latitude": "42.10341000",
                        "longitude": "-76.26215000"
                    },
                    {
                        "id": 123687,
                        "name": "Oxford",
                        "latitude": "42.44202000",
                        "longitude": "-75.59769000"
                    },
                    {
                        "id": 123693,
                        "name": "Oyster Bay",
                        "latitude": "40.86565000",
                        "longitude": "-73.53207000"
                    },
                    {
                        "id": 123694,
                        "name": "Oyster Bay Cove",
                        "latitude": "40.87093000",
                        "longitude": "-73.51096000"
                    },
                    {
                        "id": 123702,
                        "name": "Ozone Park",
                        "latitude": "40.67677000",
                        "longitude": "-73.84375000"
                    },
                    {
                        "id": 123727,
                        "name": "Painted Post",
                        "latitude": "42.16202000",
                        "longitude": "-77.09414000"
                    },
                    {
                        "id": 123733,
                        "name": "Palenville",
                        "latitude": "42.17453000",
                        "longitude": "-74.02014000"
                    },
                    {
                        "id": 123776,
                        "name": "Palmyra",
                        "latitude": "43.06395000",
                        "longitude": "-77.23332000"
                    },
                    {
                        "id": 123854,
                        "name": "Park Slope",
                        "latitude": "40.67010000",
                        "longitude": "-73.98597000"
                    },
                    {
                        "id": 123856,
                        "name": "Parkchester",
                        "latitude": "40.83899000",
                        "longitude": "-73.86041000"
                    },
                    {
                        "id": 123910,
                        "name": "Patchogue",
                        "latitude": "40.76565000",
                        "longitude": "-73.01511000"
                    },
                    {
                        "id": 123932,
                        "name": "Pawling",
                        "latitude": "41.56204000",
                        "longitude": "-73.60263000"
                    },
                    {
                        "id": 123957,
                        "name": "Peach Lake",
                        "latitude": "41.36759000",
                        "longitude": "-73.57790000"
                    },
                    {
                        "id": 123968,
                        "name": "Pearl River",
                        "latitude": "41.05899000",
                        "longitude": "-74.02181000"
                    },
                    {
                        "id": 123984,
                        "name": "Peekskill",
                        "latitude": "41.29009000",
                        "longitude": "-73.92042000"
                    },
                    {
                        "id": 123992,
                        "name": "Pelham",
                        "latitude": "40.90982000",
                        "longitude": "-73.80791000"
                    },
                    {
                        "id": 123993,
                        "name": "Pelham Manor",
                        "latitude": "40.89538000",
                        "longitude": "-73.80708000"
                    },
                    {
                        "id": 124026,
                        "name": "Penn Yan",
                        "latitude": "42.66090000",
                        "longitude": "-77.05386000"
                    },
                    {
                        "id": 124072,
                        "name": "Perry",
                        "latitude": "42.71562000",
                        "longitude": "-78.00556000"
                    },
                    {
                        "id": 124093,
                        "name": "Perth",
                        "latitude": "43.01757000",
                        "longitude": "-74.19402000"
                    },
                    {
                        "id": 124098,
                        "name": "Peru",
                        "latitude": "44.57838000",
                        "longitude": "-73.52680000"
                    },
                    {
                        "id": 124120,
                        "name": "Phelps",
                        "latitude": "42.95756000",
                        "longitude": "-77.05747000"
                    },
                    {
                        "id": 124127,
                        "name": "Philadelphia",
                        "latitude": "44.15450000",
                        "longitude": "-75.70882000"
                    },
                    {
                        "id": 124142,
                        "name": "Philmont",
                        "latitude": "42.24842000",
                        "longitude": "-73.65318000"
                    },
                    {
                        "id": 124147,
                        "name": "Phoenix",
                        "latitude": "43.23118000",
                        "longitude": "-76.30076000"
                    },
                    {
                        "id": 124177,
                        "name": "Piermont",
                        "latitude": "41.04204000",
                        "longitude": "-73.91819000"
                    },
                    {
                        "id": 124216,
                        "name": "Pine Bush",
                        "latitude": "41.60815000",
                        "longitude": "-74.29904000"
                    },
                    {
                        "id": 124240,
                        "name": "Pine Plains",
                        "latitude": "41.97981000",
                        "longitude": "-73.65596000"
                    },
                    {
                        "id": 124302,
                        "name": "Pittsford",
                        "latitude": "43.09062000",
                        "longitude": "-77.51500000"
                    },
                    {
                        "id": 124317,
                        "name": "Plainedge",
                        "latitude": "40.71732000",
                        "longitude": "-73.48374000"
                    },
                    {
                        "id": 124330,
                        "name": "Plainview",
                        "latitude": "40.77649000",
                        "longitude": "-73.46735000"
                    },
                    {
                        "id": 124339,
                        "name": "Plandome",
                        "latitude": "40.80677000",
                        "longitude": "-73.70346000"
                    },
                    {
                        "id": 124340,
                        "name": "Plandome Heights",
                        "latitude": "40.80260000",
                        "longitude": "-73.70430000"
                    },
                    {
                        "id": 124356,
                        "name": "Plattekill",
                        "latitude": "41.61759000",
                        "longitude": "-74.07598000"
                    },
                    {
                        "id": 124360,
                        "name": "Plattsburgh",
                        "latitude": "44.69949000",
                        "longitude": "-73.45291000"
                    },
                    {
                        "id": 124361,
                        "name": "Plattsburgh West",
                        "latitude": "44.68315000",
                        "longitude": "-73.50295000"
                    },
                    {
                        "id": 124379,
                        "name": "Pleasant Valley",
                        "latitude": "41.74454000",
                        "longitude": "-73.82124000"
                    },
                    {
                        "id": 124388,
                        "name": "Pleasantville",
                        "latitude": "41.13287000",
                        "longitude": "-73.79263000"
                    },
                    {
                        "id": 124423,
                        "name": "Poestenkill",
                        "latitude": "42.69036000",
                        "longitude": "-73.56456000"
                    },
                    {
                        "id": 124428,
                        "name": "Point Lookout",
                        "latitude": "40.59233000",
                        "longitude": "-73.58068000"
                    },
                    {
                        "id": 124458,
                        "name": "Pomona",
                        "latitude": "41.16704000",
                        "longitude": "-74.04320000"
                    },
                    {
                        "id": 124500,
                        "name": "Port Byron",
                        "latitude": "43.03451000",
                        "longitude": "-76.62383000"
                    },
                    {
                        "id": 124503,
                        "name": "Port Chester",
                        "latitude": "41.00176000",
                        "longitude": "-73.66568000"
                    },
                    {
                        "id": 124504,
                        "name": "Port Dickinson",
                        "latitude": "42.13341000",
                        "longitude": "-75.89631000"
                    },
                    {
                        "id": 124506,
                        "name": "Port Ewen",
                        "latitude": "41.90537000",
                        "longitude": "-73.97625000"
                    },
                    {
                        "id": 124509,
                        "name": "Port Henry",
                        "latitude": "44.04839000",
                        "longitude": "-73.45985000"
                    },
                    {
                        "id": 124513,
                        "name": "Port Jefferson",
                        "latitude": "40.94649000",
                        "longitude": "-73.06927000"
                    },
                    {
                        "id": 124514,
                        "name": "Port Jefferson Station",
                        "latitude": "40.92538000",
                        "longitude": "-73.04733000"
                    },
                    {
                        "id": 124515,
                        "name": "Port Jervis",
                        "latitude": "41.37509000",
                        "longitude": "-74.69266000"
                    },
                    {
                        "id": 124520,
                        "name": "Port Morris",
                        "latitude": "40.80149000",
                        "longitude": "-73.90958000"
                    },
                    {
                        "id": 124530,
                        "name": "Port Richmond",
                        "latitude": "40.63316000",
                        "longitude": "-74.13653000"
                    },
                    {
                        "id": 124539,
                        "name": "Port Washington",
                        "latitude": "40.82566000",
                        "longitude": "-73.69819000"
                    },
                    {
                        "id": 124541,
                        "name": "Port Washington North",
                        "latitude": "40.84482000",
                        "longitude": "-73.70180000"
                    },
                    {
                        "id": 124563,
                        "name": "Portland",
                        "latitude": "42.37978000",
                        "longitude": "-79.46755000"
                    },
                    {
                        "id": 124588,
                        "name": "Potsdam",
                        "latitude": "44.66978000",
                        "longitude": "-74.98131000"
                    },
                    {
                        "id": 124602,
                        "name": "Poughkeepsie",
                        "latitude": "41.70037000",
                        "longitude": "-73.92097000"
                    },
                    {
                        "id": 124605,
                        "name": "Pound Ridge",
                        "latitude": "41.20871000",
                        "longitude": "-73.57485000"
                    },
                    {
                        "id": 124735,
                        "name": "Pulaski",
                        "latitude": "43.56701000",
                        "longitude": "-76.12770000"
                    },
                    {
                        "id": 124755,
                        "name": "Purchase",
                        "latitude": "41.04093000",
                        "longitude": "-73.71457000"
                    },
                    {
                        "id": 124768,
                        "name": "Putnam County",
                        "latitude": "41.42666000",
                        "longitude": "-73.74951000"
                    },
                    {
                        "id": 124769,
                        "name": "Putnam Lake",
                        "latitude": "41.46204000",
                        "longitude": "-73.54624000"
                    },
                    {
                        "id": 124790,
                        "name": "Queens",
                        "latitude": "40.68149000",
                        "longitude": "-73.83652000"
                    },
                    {
                        "id": 124791,
                        "name": "Queens County",
                        "latitude": "40.65749000",
                        "longitude": "-73.83875000"
                    },
                    {
                        "id": 124792,
                        "name": "Queens Village",
                        "latitude": "40.72677000",
                        "longitude": "-73.74152000"
                    },
                    {
                        "id": 124793,
                        "name": "Queensbury",
                        "latitude": "43.37729000",
                        "longitude": "-73.61317000"
                    },
                    {
                        "id": 124867,
                        "name": "Randolph",
                        "latitude": "42.16201000",
                        "longitude": "-78.97532000"
                    },
                    {
                        "id": 124889,
                        "name": "Ransomville",
                        "latitude": "43.23867000",
                        "longitude": "-78.90976000"
                    },
                    {
                        "id": 124897,
                        "name": "Rapids",
                        "latitude": "43.09839000",
                        "longitude": "-78.64086000"
                    },
                    {
                        "id": 124905,
                        "name": "Ravena",
                        "latitude": "42.46841000",
                        "longitude": "-73.81624000"
                    },
                    {
                        "id": 124948,
                        "name": "Red Hook",
                        "latitude": "41.99509000",
                        "longitude": "-73.87541000"
                    },
                    {
                        "id": 124958,
                        "name": "Red Oaks Mill",
                        "latitude": "41.65565000",
                        "longitude": "-73.87486000"
                    },
                    {
                        "id": 125002,
                        "name": "Rego Park",
                        "latitude": "40.72649000",
                        "longitude": "-73.85264000"
                    },
                    {
                        "id": 125016,
                        "name": "Remsenburg-Speonk",
                        "latitude": "40.82642000",
                        "longitude": "-72.69673000"
                    },
                    {
                        "id": 125024,
                        "name": "Rensselaer",
                        "latitude": "42.64258000",
                        "longitude": "-73.74290000"
                    },
                    {
                        "id": 125025,
                        "name": "Rensselaer County",
                        "latitude": "42.71105000",
                        "longitude": "-73.50972000"
                    },
                    {
                        "id": 125045,
                        "name": "Rhinebeck",
                        "latitude": "41.92676000",
                        "longitude": "-73.91264000"
                    },
                    {
                        "id": 125064,
                        "name": "Richfield Springs",
                        "latitude": "42.85341000",
                        "longitude": "-74.98543000"
                    },
                    {
                        "id": 125070,
                        "name": "Richland",
                        "latitude": "43.56951000",
                        "longitude": "-76.04770000"
                    },
                    {
                        "id": 125101,
                        "name": "Richmond County",
                        "latitude": "40.58344000",
                        "longitude": "-74.14959000"
                    },
                    {
                        "id": 125105,
                        "name": "Richmond Hill",
                        "latitude": "40.69983000",
                        "longitude": "-73.83125000"
                    },
                    {
                        "id": 125114,
                        "name": "Ridge",
                        "latitude": "40.89399000",
                        "longitude": "-72.89594000"
                    },
                    {
                        "id": 125132,
                        "name": "Ridgewood",
                        "latitude": "40.70010000",
                        "longitude": "-73.90569000"
                    },
                    {
                        "id": 125195,
                        "name": "Riverdale",
                        "latitude": "40.90056000",
                        "longitude": "-73.90639000"
                    },
                    {
                        "id": 125200,
                        "name": "Riverhead",
                        "latitude": "40.91704000",
                        "longitude": "-72.66204000"
                    },
                    {
                        "id": 125207,
                        "name": "Riverside",
                        "latitude": "40.88121000",
                        "longitude": "-72.67787000"
                    },
                    {
                        "id": 125267,
                        "name": "Rochester",
                        "latitude": "43.15478000",
                        "longitude": "-77.61556000"
                    },
                    {
                        "id": 125281,
                        "name": "Rock Hill",
                        "latitude": "41.62593000",
                        "longitude": "-74.59766000"
                    },
                    {
                        "id": 125291,
                        "name": "Rockaway Point",
                        "latitude": "40.56066000",
                        "longitude": "-73.91514000"
                    },
                    {
                        "id": 125310,
                        "name": "Rockland County",
                        "latitude": "41.15243000",
                        "longitude": "-74.02409000"
                    },
                    {
                        "id": 125325,
                        "name": "Rockville Centre",
                        "latitude": "40.65871000",
                        "longitude": "-73.64124000"
                    },
                    {
                        "id": 125338,
                        "name": "Rocky Point",
                        "latitude": "40.95260000",
                        "longitude": "-72.92538000"
                    },
                    {
                        "id": 125346,
                        "name": "Roessleville",
                        "latitude": "42.69508000",
                        "longitude": "-73.80707000"
                    },
                    {
                        "id": 125378,
                        "name": "Rome",
                        "latitude": "43.21285000",
                        "longitude": "-75.45573000"
                    },
                    {
                        "id": 125388,
                        "name": "Ronkonkoma",
                        "latitude": "40.81538000",
                        "longitude": "-73.11233000"
                    },
                    {
                        "id": 125391,
                        "name": "Roosevelt",
                        "latitude": "40.67871000",
                        "longitude": "-73.58902000"
                    },
                    {
                        "id": 125409,
                        "name": "Rosebank",
                        "latitude": "40.61399000",
                        "longitude": "-74.06625000"
                    },
                    {
                        "id": 125418,
                        "name": "Rosedale",
                        "latitude": "40.66205000",
                        "longitude": "-73.73541000"
                    },
                    {
                        "id": 125435,
                        "name": "Rosendale Village",
                        "latitude": "41.85038000",
                        "longitude": "-74.07379000"
                    },
                    {
                        "id": 125447,
                        "name": "Roslyn",
                        "latitude": "40.79982000",
                        "longitude": "-73.65096000"
                    },
                    {
                        "id": 125448,
                        "name": "Roslyn Estates",
                        "latitude": "40.79427000",
                        "longitude": "-73.66041000"
                    },
                    {
                        "id": 125449,
                        "name": "Roslyn Harbor",
                        "latitude": "40.81649000",
                        "longitude": "-73.63707000"
                    },
                    {
                        "id": 125450,
                        "name": "Roslyn Heights",
                        "latitude": "40.78871000",
                        "longitude": "-73.64735000"
                    },
                    {
                        "id": 125461,
                        "name": "Rossville",
                        "latitude": "40.55566000",
                        "longitude": "-74.21348000"
                    },
                    {
                        "id": 125468,
                        "name": "Rotterdam",
                        "latitude": "42.78702000",
                        "longitude": "-73.97096000"
                    },
                    {
                        "id": 125475,
                        "name": "Rouses Point",
                        "latitude": "44.99393000",
                        "longitude": "-73.36486000"
                    },
                    {
                        "id": 125562,
                        "name": "Rye",
                        "latitude": "40.98065000",
                        "longitude": "-73.68374000"
                    },
                    {
                        "id": 125563,
                        "name": "Rye Brook",
                        "latitude": "41.01926000",
                        "longitude": "-73.68346000"
                    },
                    {
                        "id": 125575,
                        "name": "Sackets Harbor",
                        "latitude": "43.94617000",
                        "longitude": "-76.11909000"
                    },
                    {
                        "id": 125584,
                        "name": "Sag Harbor",
                        "latitude": "40.99788000",
                        "longitude": "-72.29258000"
                    },
                    {
                        "id": 125609,
                        "name": "Saint Bonaventure",
                        "latitude": "42.08034000",
                        "longitude": "-78.47502000"
                    },
                    {
                        "id": 125656,
                        "name": "Saint James",
                        "latitude": "40.87899000",
                        "longitude": "-73.15678000"
                    },
                    {
                        "id": 125669,
                        "name": "Saint Johnsville",
                        "latitude": "42.99813000",
                        "longitude": "-74.68292000"
                    },
                    {
                        "id": 125723,
                        "name": "Salamanca",
                        "latitude": "42.15784000",
                        "longitude": "-78.71503000"
                    },
                    {
                        "id": 125759,
                        "name": "Salisbury",
                        "latitude": "40.74566000",
                        "longitude": "-73.56013000"
                    },
                    {
                        "id": 125854,
                        "name": "Sanborn",
                        "latitude": "43.13672000",
                        "longitude": "-78.88476000"
                    },
                    {
                        "id": 125872,
                        "name": "Sands Point",
                        "latitude": "40.85177000",
                        "longitude": "-73.71874000"
                    },
                    {
                        "id": 125936,
                        "name": "Saranac Lake",
                        "latitude": "44.32950000",
                        "longitude": "-74.13127000"
                    },
                    {
                        "id": 125943,
                        "name": "Saratoga County",
                        "latitude": "43.10738000",
                        "longitude": "-73.86390000"
                    },
                    {
                        "id": 125944,
                        "name": "Saratoga Springs",
                        "latitude": "43.08313000",
                        "longitude": "-73.78457000"
                    },
                    {
                        "id": 125959,
                        "name": "Saugerties",
                        "latitude": "42.07759000",
                        "longitude": "-73.95291000"
                    },
                    {
                        "id": 125960,
                        "name": "Saugerties South",
                        "latitude": "42.06139000",
                        "longitude": "-73.95067000"
                    },
                    {
                        "id": 125993,
                        "name": "Sayville",
                        "latitude": "40.73593000",
                        "longitude": "-73.08206000"
                    },
                    {
                        "id": 125998,
                        "name": "Scarsdale",
                        "latitude": "41.00510000",
                        "longitude": "-73.78458000"
                    },
                    {
                        "id": 126003,
                        "name": "Schenectady",
                        "latitude": "42.81424000",
                        "longitude": "-73.93957000"
                    },
                    {
                        "id": 126004,
                        "name": "Schenectady County",
                        "latitude": "42.81812000",
                        "longitude": "-74.05857000"
                    },
                    {
                        "id": 126015,
                        "name": "Schoharie",
                        "latitude": "42.66591000",
                        "longitude": "-74.30958000"
                    },
                    {
                        "id": 126016,
                        "name": "Schoharie County",
                        "latitude": "42.58822000",
                        "longitude": "-74.44212000"
                    },
                    {
                        "id": 126024,
                        "name": "Schuyler County",
                        "latitude": "42.39380000",
                        "longitude": "-76.87518000"
                    },
                    {
                        "id": 126025,
                        "name": "Schuylerville",
                        "latitude": "43.10008000",
                        "longitude": "-73.58178000"
                    },
                    {
                        "id": 126033,
                        "name": "Scotchtown",
                        "latitude": "41.48148000",
                        "longitude": "-74.36015000"
                    },
                    {
                        "id": 126034,
                        "name": "Scotia",
                        "latitude": "42.82647000",
                        "longitude": "-73.96429000"
                    },
                    {
                        "id": 126065,
                        "name": "Scottsville",
                        "latitude": "43.02590000",
                        "longitude": "-77.74528000"
                    },
                    {
                        "id": 126072,
                        "name": "Sea Cliff",
                        "latitude": "40.84899000",
                        "longitude": "-73.64485000"
                    },
                    {
                        "id": 126086,
                        "name": "Seaford",
                        "latitude": "40.66593000",
                        "longitude": "-73.48818000"
                    },
                    {
                        "id": 126094,
                        "name": "Searingtown",
                        "latitude": "40.77482000",
                        "longitude": "-73.65568000"
                    },
                    {
                        "id": 126098,
                        "name": "Seaside",
                        "latitude": "40.58316000",
                        "longitude": "-73.82819000"
                    },
                    {
                        "id": 126133,
                        "name": "Selden",
                        "latitude": "40.86649000",
                        "longitude": "-73.03566000"
                    },
                    {
                        "id": 126159,
                        "name": "Seneca County",
                        "latitude": "42.78108000",
                        "longitude": "-76.82378000"
                    },
                    {
                        "id": 126160,
                        "name": "Seneca Falls",
                        "latitude": "42.91062000",
                        "longitude": "-76.79662000"
                    },
                    {
                        "id": 126161,
                        "name": "Seneca Knolls",
                        "latitude": "43.12007000",
                        "longitude": "-76.28632000"
                    },
                    {
                        "id": 126169,
                        "name": "Setauket-East Setauket",
                        "latitude": "40.93064000",
                        "longitude": "-73.10179000"
                    },
                    {
                        "id": 126258,
                        "name": "Sheepshead Bay",
                        "latitude": "40.59122000",
                        "longitude": "-73.94458000"
                    },
                    {
                        "id": 126295,
                        "name": "Shelter Island",
                        "latitude": "41.06815000",
                        "longitude": "-72.33869000"
                    },
                    {
                        "id": 126296,
                        "name": "Shelter Island Heights",
                        "latitude": "41.08399000",
                        "longitude": "-72.35592000"
                    },
                    {
                        "id": 126308,
                        "name": "Shenorock",
                        "latitude": "41.33176000",
                        "longitude": "-73.73819000"
                    },
                    {
                        "id": 126315,
                        "name": "Sherburne",
                        "latitude": "42.67813000",
                        "longitude": "-75.49851000"
                    },
                    {
                        "id": 126338,
                        "name": "Sherrill",
                        "latitude": "43.07368000",
                        "longitude": "-75.59824000"
                    },
                    {
                        "id": 126354,
                        "name": "Shinnecock Hills",
                        "latitude": "40.89093000",
                        "longitude": "-72.46370000"
                    },
                    {
                        "id": 126361,
                        "name": "Shirley",
                        "latitude": "40.80149000",
                        "longitude": "-72.86760000"
                    },
                    {
                        "id": 126366,
                        "name": "Shokan",
                        "latitude": "41.97343000",
                        "longitude": "-74.21209000"
                    },
                    {
                        "id": 126378,
                        "name": "Shortsville",
                        "latitude": "42.95590000",
                        "longitude": "-77.22081000"
                    },
                    {
                        "id": 126387,
                        "name": "Shrub Oak",
                        "latitude": "41.32759000",
                        "longitude": "-73.81958000"
                    },
                    {
                        "id": 126397,
                        "name": "Sidney",
                        "latitude": "42.31480000",
                        "longitude": "-75.39157000"
                    },
                    {
                        "id": 126423,
                        "name": "Silver Creek",
                        "latitude": "42.54423000",
                        "longitude": "-79.16671000"
                    },
                    {
                        "id": 126477,
                        "name": "Skaneateles",
                        "latitude": "42.94701000",
                        "longitude": "-76.42910000"
                    },
                    {
                        "id": 126498,
                        "name": "Sleepy Hollow",
                        "latitude": "41.08565000",
                        "longitude": "-73.85847000"
                    },
                    {
                        "id": 126504,
                        "name": "Sloan",
                        "latitude": "42.89339000",
                        "longitude": "-78.79392000"
                    },
                    {
                        "id": 126505,
                        "name": "Sloatsburg",
                        "latitude": "41.15454000",
                        "longitude": "-74.19292000"
                    },
                    {
                        "id": 126526,
                        "name": "Smithtown",
                        "latitude": "40.85593000",
                        "longitude": "-73.20067000"
                    },
                    {
                        "id": 126564,
                        "name": "Sodus",
                        "latitude": "43.23784000",
                        "longitude": "-77.06136000"
                    },
                    {
                        "id": 126573,
                        "name": "Solvay",
                        "latitude": "43.05812000",
                        "longitude": "-76.20743000"
                    },
                    {
                        "id": 126609,
                        "name": "Sound Beach",
                        "latitude": "40.95621000",
                        "longitude": "-72.96788000"
                    },
                    {
                        "id": 126620,
                        "name": "South Beach",
                        "latitude": "40.58329000",
                        "longitude": "-74.07609000"
                    },
                    {
                        "id": 126627,
                        "name": "South Blooming Grove",
                        "latitude": "41.37337000",
                        "longitude": "-74.17843000"
                    },
                    {
                        "id": 126643,
                        "name": "South Corning",
                        "latitude": "42.12174000",
                        "longitude": "-77.03719000"
                    },
                    {
                        "id": 126653,
                        "name": "South Fallsburg",
                        "latitude": "41.72065000",
                        "longitude": "-74.63433000"
                    },
                    {
                        "id": 126654,
                        "name": "South Farmingdale",
                        "latitude": "40.72066000",
                        "longitude": "-73.44012000"
                    },
                    {
                        "id": 126655,
                        "name": "South Floral Park",
                        "latitude": "40.71427000",
                        "longitude": "-73.70013000"
                    },
                    {
                        "id": 126661,
                        "name": "South Glens Falls",
                        "latitude": "43.29924000",
                        "longitude": "-73.63512000"
                    },
                    {
                        "id": 126668,
                        "name": "South Hempstead",
                        "latitude": "40.68094000",
                        "longitude": "-73.61541000"
                    },
                    {
                        "id": 126672,
                        "name": "South Hill",
                        "latitude": "42.42924000",
                        "longitude": "-76.49494000"
                    },
                    {
                        "id": 126677,
                        "name": "South Huntington",
                        "latitude": "40.82371000",
                        "longitude": "-73.39873000"
                    },
                    {
                        "id": 126689,
                        "name": "South Lockport",
                        "latitude": "43.15006000",
                        "longitude": "-78.69670000"
                    },
                    {
                        "id": 126695,
                        "name": "South Nyack",
                        "latitude": "41.08315000",
                        "longitude": "-73.92014000"
                    },
                    {
                        "id": 126741,
                        "name": "South Valley Stream",
                        "latitude": "40.65594000",
                        "longitude": "-73.71763000"
                    },
                    {
                        "id": 126758,
                        "name": "Southampton",
                        "latitude": "40.88427000",
                        "longitude": "-72.38953000"
                    },
                    {
                        "id": 126781,
                        "name": "Southold",
                        "latitude": "41.06482000",
                        "longitude": "-72.42620000"
                    },
                    {
                        "id": 126785,
                        "name": "Southport",
                        "latitude": "42.05480000",
                        "longitude": "-76.81912000"
                    },
                    {
                        "id": 126794,
                        "name": "Spackenkill",
                        "latitude": "41.65593000",
                        "longitude": "-73.91347000"
                    },
                    {
                        "id": 126802,
                        "name": "Sparkill",
                        "latitude": "41.03121000",
                        "longitude": "-73.92708000"
                    },
                    {
                        "id": 126830,
                        "name": "Spencerport",
                        "latitude": "43.18645000",
                        "longitude": "-77.80390000"
                    },
                    {
                        "id": 126877,
                        "name": "Spring Valley",
                        "latitude": "41.11315000",
                        "longitude": "-74.04375000"
                    },
                    {
                        "id": 126903,
                        "name": "Springfield",
                        "latitude": "42.83618000",
                        "longitude": "-74.85348000"
                    },
                    {
                        "id": 126908,
                        "name": "Springfield Gardens",
                        "latitude": "40.66312000",
                        "longitude": "-73.76221000"
                    },
                    {
                        "id": 126910,
                        "name": "Springs",
                        "latitude": "41.01621000",
                        "longitude": "-72.15924000"
                    },
                    {
                        "id": 126917,
                        "name": "Springville",
                        "latitude": "42.50840000",
                        "longitude": "-78.66725000"
                    },
                    {
                        "id": 126923,
                        "name": "Spuyten Duyvil",
                        "latitude": "40.88121000",
                        "longitude": "-73.91736000"
                    },
                    {
                        "id": 126927,
                        "name": "St. Lawrence County",
                        "latitude": "44.50062000",
                        "longitude": "-75.11631000"
                    },
                    {
                        "id": 126945,
                        "name": "Stamford",
                        "latitude": "42.40730000",
                        "longitude": "-74.61432000"
                    },
                    {
                        "id": 126976,
                        "name": "Stapleton",
                        "latitude": "40.62649000",
                        "longitude": "-74.07764000"
                    },
                    {
                        "id": 126995,
                        "name": "Staten Island",
                        "latitude": "40.56233000",
                        "longitude": "-74.13986000"
                    },
                    {
                        "id": 127019,
                        "name": "Steinway",
                        "latitude": "40.77455000",
                        "longitude": "-73.90375000"
                    },
                    {
                        "id": 127039,
                        "name": "Steuben County",
                        "latitude": "42.26781000",
                        "longitude": "-77.38380000"
                    },
                    {
                        "id": 127052,
                        "name": "Stewart Manor",
                        "latitude": "40.71927000",
                        "longitude": "-73.68846000"
                    },
                    {
                        "id": 127062,
                        "name": "Stillwater",
                        "latitude": "42.93841000",
                        "longitude": "-73.65317000"
                    },
                    {
                        "id": 127085,
                        "name": "Stone Ridge",
                        "latitude": "41.85315000",
                        "longitude": "-74.13903000"
                    },
                    {
                        "id": 127096,
                        "name": "Stony Brook",
                        "latitude": "40.92565000",
                        "longitude": "-73.14094000"
                    },
                    {
                        "id": 127100,
                        "name": "Stony Point",
                        "latitude": "41.22954000",
                        "longitude": "-73.98708000"
                    },
                    {
                        "id": 127108,
                        "name": "Stottville",
                        "latitude": "42.28620000",
                        "longitude": "-73.73873000"
                    },
                    {
                        "id": 127164,
                        "name": "Suffern",
                        "latitude": "41.11482000",
                        "longitude": "-74.14959000"
                    },
                    {
                        "id": 127168,
                        "name": "Suffolk County",
                        "latitude": "40.94046000",
                        "longitude": "-72.68524000"
                    },
                    {
                        "id": 127190,
                        "name": "Sullivan County",
                        "latitude": "41.71642000",
                        "longitude": "-74.76814000"
                    },
                    {
                        "id": 127258,
                        "name": "Sunnyside",
                        "latitude": "40.73982000",
                        "longitude": "-73.93542000"
                    },
                    {
                        "id": 127276,
                        "name": "Sunset Park",
                        "latitude": "40.64548000",
                        "longitude": "-74.01241000"
                    },
                    {
                        "id": 127356,
                        "name": "Sylvan Beach",
                        "latitude": "42.46479000",
                        "longitude": "-77.10830000"
                    },
                    {
                        "id": 127362,
                        "name": "Syosset",
                        "latitude": "40.82621000",
                        "longitude": "-73.50207000"
                    },
                    {
                        "id": 127365,
                        "name": "Syracuse",
                        "latitude": "43.04812000",
                        "longitude": "-76.14742000"
                    },
                    {
                        "id": 127426,
                        "name": "Tappan",
                        "latitude": "41.02204000",
                        "longitude": "-73.94736000"
                    },
                    {
                        "id": 127436,
                        "name": "Tarrytown",
                        "latitude": "41.07621000",
                        "longitude": "-73.85875000"
                    },
                    {
                        "id": 127517,
                        "name": "Terrace Heights",
                        "latitude": "40.72149000",
                        "longitude": "-73.76930000"
                    },
                    {
                        "id": 127536,
                        "name": "Terryville",
                        "latitude": "40.90899000",
                        "longitude": "-73.06511000"
                    },
                    {
                        "id": 127554,
                        "name": "The Bronx",
                        "latitude": "40.84985000",
                        "longitude": "-73.86641000"
                    },
                    {
                        "id": 127575,
                        "name": "Thiells",
                        "latitude": "41.21065000",
                        "longitude": "-74.01764000"
                    },
                    {
                        "id": 127586,
                        "name": "Thomaston",
                        "latitude": "40.78621000",
                        "longitude": "-73.71374000"
                    },
                    {
                        "id": 127606,
                        "name": "Thornwood",
                        "latitude": "41.12343000",
                        "longitude": "-73.77902000"
                    },
                    {
                        "id": 127625,
                        "name": "Throgs Neck",
                        "latitude": "40.82260000",
                        "longitude": "-73.81958000"
                    },
                    {
                        "id": 127635,
                        "name": "Ticonderoga",
                        "latitude": "43.84867000",
                        "longitude": "-73.42345000"
                    },
                    {
                        "id": 127652,
                        "name": "Tillson",
                        "latitude": "41.82898000",
                        "longitude": "-74.06848000"
                    },
                    {
                        "id": 127669,
                        "name": "Tioga County",
                        "latitude": "42.17030000",
                        "longitude": "-76.30632000"
                    },
                    {
                        "id": 127688,
                        "name": "Tivoli",
                        "latitude": "42.05842000",
                        "longitude": "-73.90930000"
                    },
                    {
                        "id": 127713,
                        "name": "Tompkins County",
                        "latitude": "42.45202000",
                        "longitude": "-76.47366000"
                    },
                    {
                        "id": 127715,
                        "name": "Tompkinsville",
                        "latitude": "40.63812000",
                        "longitude": "-74.07795000"
                    },
                    {
                        "id": 127718,
                        "name": "Tonawanda",
                        "latitude": "43.02033000",
                        "longitude": "-78.88031000"
                    },
                    {
                        "id": 127758,
                        "name": "Town Line",
                        "latitude": "42.89061000",
                        "longitude": "-78.57780000"
                    },
                    {
                        "id": 127795,
                        "name": "Tremont",
                        "latitude": "40.84954000",
                        "longitude": "-73.90569000"
                    },
                    {
                        "id": 127819,
                        "name": "Tribes Hill",
                        "latitude": "42.95535000",
                        "longitude": "-74.28513000"
                    },
                    {
                        "id": 127851,
                        "name": "Troy",
                        "latitude": "42.72841000",
                        "longitude": "-73.69179000"
                    },
                    {
                        "id": 127857,
                        "name": "Trumansburg",
                        "latitude": "42.54229000",
                        "longitude": "-76.66606000"
                    },
                    {
                        "id": 127869,
                        "name": "Tuckahoe",
                        "latitude": "40.95038000",
                        "longitude": "-73.82736000"
                    },
                    {
                        "id": 127898,
                        "name": "Tupper Lake",
                        "latitude": "44.22395000",
                        "longitude": "-74.46406000"
                    },
                    {
                        "id": 127959,
                        "name": "Ulster County",
                        "latitude": "41.88815000",
                        "longitude": "-74.25857000"
                    },
                    {
                        "id": 127965,
                        "name": "Unadilla",
                        "latitude": "42.32536000",
                        "longitude": "-75.31240000"
                    },
                    {
                        "id": 128012,
                        "name": "Union Springs",
                        "latitude": "42.83979000",
                        "longitude": "-76.69328000"
                    },
                    {
                        "id": 128013,
                        "name": "Uniondale",
                        "latitude": "40.70038000",
                        "longitude": "-73.59291000"
                    },
                    {
                        "id": 128014,
                        "name": "Unionport",
                        "latitude": "40.82732000",
                        "longitude": "-73.85013000"
                    },
                    {
                        "id": 128028,
                        "name": "University Gardens",
                        "latitude": "40.77732000",
                        "longitude": "-73.72263000"
                    },
                    {
                        "id": 128030,
                        "name": "University Heights",
                        "latitude": "40.86010000",
                        "longitude": "-73.90930000"
                    },
                    {
                        "id": 128042,
                        "name": "Upper Brookville",
                        "latitude": "40.83871000",
                        "longitude": "-73.56513000"
                    },
                    {
                        "id": 128048,
                        "name": "Upper Nyack",
                        "latitude": "41.10704000",
                        "longitude": "-73.92014000"
                    },
                    {
                        "id": 128067,
                        "name": "Utica",
                        "latitude": "43.10090000",
                        "longitude": "-75.23266000"
                    },
                    {
                        "id": 128077,
                        "name": "Vails Gate",
                        "latitude": "41.45426000",
                        "longitude": "-74.05764000"
                    },
                    {
                        "id": 128081,
                        "name": "Valatie",
                        "latitude": "42.41342000",
                        "longitude": "-73.67317000"
                    },
                    {
                        "id": 128092,
                        "name": "Valhalla",
                        "latitude": "41.07482000",
                        "longitude": "-73.77513000"
                    },
                    {
                        "id": 128102,
                        "name": "Valley Cottage",
                        "latitude": "41.11815000",
                        "longitude": "-73.95542000"
                    },
                    {
                        "id": 128117,
                        "name": "Valley Stream",
                        "latitude": "40.66427000",
                        "longitude": "-73.70846000"
                    },
                    {
                        "id": 128136,
                        "name": "Van Nest",
                        "latitude": "40.84843000",
                        "longitude": "-73.86375000"
                    },
                    {
                        "id": 128190,
                        "name": "Vernon",
                        "latitude": "43.07951000",
                        "longitude": "-75.53934000"
                    },
                    {
                        "id": 128207,
                        "name": "Verplanck",
                        "latitude": "41.25287000",
                        "longitude": "-73.95986000"
                    },
                    {
                        "id": 128217,
                        "name": "Victor",
                        "latitude": "42.98256000",
                        "longitude": "-77.40888000"
                    },
                    {
                        "id": 128247,
                        "name": "Village Green",
                        "latitude": "43.13340000",
                        "longitude": "-76.31299000"
                    },
                    {
                        "id": 128254,
                        "name": "Village of the Branch",
                        "latitude": "40.85621000",
                        "longitude": "-73.18733000"
                    },
                    {
                        "id": 128283,
                        "name": "Viola",
                        "latitude": "41.13648000",
                        "longitude": "-74.08236000"
                    },
                    {
                        "id": 128301,
                        "name": "Volney",
                        "latitude": "43.34285000",
                        "longitude": "-76.35771000"
                    },
                    {
                        "id": 128307,
                        "name": "Voorheesville",
                        "latitude": "42.65397000",
                        "longitude": "-73.92874000"
                    },
                    {
                        "id": 128324,
                        "name": "Wading River",
                        "latitude": "40.95038000",
                        "longitude": "-72.84260000"
                    },
                    {
                        "id": 128363,
                        "name": "Wakefield",
                        "latitude": "40.89788000",
                        "longitude": "-73.85236000"
                    },
                    {
                        "id": 128368,
                        "name": "Walden",
                        "latitude": "41.56120000",
                        "longitude": "-74.18848000"
                    },
                    {
                        "id": 128410,
                        "name": "Wallkill",
                        "latitude": "41.60565000",
                        "longitude": "-74.18404000"
                    },
                    {
                        "id": 128436,
                        "name": "Walton",
                        "latitude": "42.16953000",
                        "longitude": "-75.12934000"
                    },
                    {
                        "id": 128439,
                        "name": "Walton Park",
                        "latitude": "41.30982000",
                        "longitude": "-74.22904000"
                    },
                    {
                        "id": 128445,
                        "name": "Wampsville",
                        "latitude": "43.07535000",
                        "longitude": "-75.70685000"
                    },
                    {
                        "id": 128446,
                        "name": "Wanakah",
                        "latitude": "42.74617000",
                        "longitude": "-78.90309000"
                    },
                    {
                        "id": 128452,
                        "name": "Wantagh",
                        "latitude": "40.68371000",
                        "longitude": "-73.51013000"
                    },
                    {
                        "id": 128456,
                        "name": "Wappingers Falls",
                        "latitude": "41.59648000",
                        "longitude": "-73.91097000"
                    },
                    {
                        "id": 128497,
                        "name": "Warren County",
                        "latitude": "43.56098000",
                        "longitude": "-73.84601000"
                    },
                    {
                        "id": 128503,
                        "name": "Warrensburg",
                        "latitude": "43.49674000",
                        "longitude": "-73.77623000"
                    },
                    {
                        "id": 128521,
                        "name": "Warsaw",
                        "latitude": "42.74006000",
                        "longitude": "-78.13279000"
                    },
                    {
                        "id": 128524,
                        "name": "Warwick",
                        "latitude": "41.25648000",
                        "longitude": "-74.35988000"
                    },
                    {
                        "id": 128572,
                        "name": "Washington County",
                        "latitude": "43.31370000",
                        "longitude": "-73.43076000"
                    },
                    {
                        "id": 128581,
                        "name": "Washington Heights",
                        "latitude": "40.85010000",
                        "longitude": "-73.93541000"
                    },
                    {
                        "id": 128582,
                        "name": "Washington Mills",
                        "latitude": "43.05007000",
                        "longitude": "-75.27294000"
                    },
                    {
                        "id": 128588,
                        "name": "Washingtonville",
                        "latitude": "41.42787000",
                        "longitude": "-74.16598000"
                    },
                    {
                        "id": 128597,
                        "name": "Watchtower",
                        "latitude": "41.63776000",
                        "longitude": "-74.26027000"
                    },
                    {
                        "id": 128599,
                        "name": "Water Mill",
                        "latitude": "40.91959000",
                        "longitude": "-72.34274000"
                    },
                    {
                        "id": 128606,
                        "name": "Waterford",
                        "latitude": "42.79258000",
                        "longitude": "-73.68123000"
                    },
                    {
                        "id": 128615,
                        "name": "Waterloo",
                        "latitude": "42.90479000",
                        "longitude": "-76.86274000"
                    },
                    {
                        "id": 128623,
                        "name": "Watertown",
                        "latitude": "43.97478000",
                        "longitude": "-75.91076000"
                    },
                    {
                        "id": 128628,
                        "name": "Waterville",
                        "latitude": "42.93118000",
                        "longitude": "-75.37989000"
                    },
                    {
                        "id": 128630,
                        "name": "Watervliet",
                        "latitude": "42.73008000",
                        "longitude": "-73.70123000"
                    },
                    {
                        "id": 128634,
                        "name": "Watkins Glen",
                        "latitude": "42.38063000",
                        "longitude": "-76.87329000"
                    },
                    {
                        "id": 128672,
                        "name": "Waverly",
                        "latitude": "42.01035000",
                        "longitude": "-76.52717000"
                    },
                    {
                        "id": 128673,
                        "name": "Wawarsing",
                        "latitude": "41.75898000",
                        "longitude": "-74.35738000"
                    },
                    {
                        "id": 128677,
                        "name": "Wayland",
                        "latitude": "42.56784000",
                        "longitude": "-77.58971000"
                    },
                    {
                        "id": 128701,
                        "name": "Wayne County",
                        "latitude": "43.06588000",
                        "longitude": "-76.97845000"
                    },
                    {
                        "id": 128733,
                        "name": "Webster",
                        "latitude": "43.21229000",
                        "longitude": "-77.42999000"
                    },
                    {
                        "id": 128753,
                        "name": "Weedsport",
                        "latitude": "43.04868000",
                        "longitude": "-76.56272000"
                    },
                    {
                        "id": 128793,
                        "name": "Wellsville",
                        "latitude": "42.12201000",
                        "longitude": "-77.94806000"
                    },
                    {
                        "id": 128811,
                        "name": "Wesley Hills",
                        "latitude": "41.15926000",
                        "longitude": "-74.06986000"
                    },
                    {
                        "id": 128816,
                        "name": "West Albany",
                        "latitude": "42.68313000",
                        "longitude": "-73.77845000"
                    },
                    {
                        "id": 128819,
                        "name": "West Babylon",
                        "latitude": "40.71816000",
                        "longitude": "-73.35429000"
                    },
                    {
                        "id": 128823,
                        "name": "West Bay Shore",
                        "latitude": "40.70871000",
                        "longitude": "-73.28123000"
                    },
                    {
                        "id": 128843,
                        "name": "West Carthage",
                        "latitude": "43.97423000",
                        "longitude": "-75.61519000"
                    },
                    {
                        "id": 128861,
                        "name": "West Elmira",
                        "latitude": "42.07813000",
                        "longitude": "-76.84524000"
                    },
                    {
                        "id": 128863,
                        "name": "West End",
                        "latitude": "42.46869000",
                        "longitude": "-75.09378000"
                    },
                    {
                        "id": 128879,
                        "name": "West Glens Falls",
                        "latitude": "43.30007000",
                        "longitude": "-73.68401000"
                    },
                    {
                        "id": 128891,
                        "name": "West Haverstraw",
                        "latitude": "41.20954000",
                        "longitude": "-73.98542000"
                    },
                    {
                        "id": 128894,
                        "name": "West Hempstead",
                        "latitude": "40.70482000",
                        "longitude": "-73.65013000"
                    },
                    {
                        "id": 128895,
                        "name": "West Hills",
                        "latitude": "40.81621000",
                        "longitude": "-73.43234000"
                    },
                    {
                        "id": 128901,
                        "name": "West Hurley",
                        "latitude": "41.99731000",
                        "longitude": "-74.10486000"
                    },
                    {
                        "id": 128903,
                        "name": "West Islip",
                        "latitude": "40.70621000",
                        "longitude": "-73.30623000"
                    },
                    {
                        "id": 128942,
                        "name": "West Nyack",
                        "latitude": "41.09649000",
                        "longitude": "-73.97292000"
                    },
                    {
                        "id": 128962,
                        "name": "West Point",
                        "latitude": "41.39148000",
                        "longitude": "-73.95597000"
                    },
                    {
                        "id": 128975,
                        "name": "West Sand Lake",
                        "latitude": "42.64341000",
                        "longitude": "-73.60873000"
                    },
                    {
                        "id": 128976,
                        "name": "West Sayville",
                        "latitude": "40.72788000",
                        "longitude": "-73.09761000"
                    },
                    {
                        "id": 128979,
                        "name": "West Seneca",
                        "latitude": "42.85006000",
                        "longitude": "-78.79975000"
                    },
                    {
                        "id": 129015,
                        "name": "Westbury",
                        "latitude": "40.75566000",
                        "longitude": "-73.58763000"
                    },
                    {
                        "id": 129020,
                        "name": "Westchester County",
                        "latitude": "41.15148000",
                        "longitude": "-73.75339000"
                    },
                    {
                        "id": 129022,
                        "name": "Westerleigh",
                        "latitude": "40.62121000",
                        "longitude": "-74.13181000"
                    },
                    {
                        "id": 129030,
                        "name": "Westfield",
                        "latitude": "42.32228000",
                        "longitude": "-79.57810000"
                    },
                    {
                        "id": 129035,
                        "name": "Westhampton",
                        "latitude": "40.82454000",
                        "longitude": "-72.66621000"
                    },
                    {
                        "id": 129036,
                        "name": "Westhampton Beach",
                        "latitude": "40.80316000",
                        "longitude": "-72.61454000"
                    },
                    {
                        "id": 129042,
                        "name": "Westmere",
                        "latitude": "42.69119000",
                        "longitude": "-73.86873000"
                    },
                    {
                        "id": 129066,
                        "name": "Weston Mills",
                        "latitude": "42.07590000",
                        "longitude": "-78.37252000"
                    },
                    {
                        "id": 129074,
                        "name": "Westvale",
                        "latitude": "43.04757000",
                        "longitude": "-76.22048000"
                    },
                    {
                        "id": 129111,
                        "name": "Wheatley Heights",
                        "latitude": "40.76371000",
                        "longitude": "-73.36984000"
                    },
                    {
                        "id": 129155,
                        "name": "White Plains",
                        "latitude": "41.03399000",
                        "longitude": "-73.76291000"
                    },
                    {
                        "id": 129169,
                        "name": "Whitehall",
                        "latitude": "43.55562000",
                        "longitude": "-73.40372000"
                    },
                    {
                        "id": 129183,
                        "name": "Whitesboro",
                        "latitude": "43.12201000",
                        "longitude": "-75.29156000"
                    },
                    {
                        "id": 129187,
                        "name": "Whitestone",
                        "latitude": "40.79455000",
                        "longitude": "-73.81847000"
                    },
                    {
                        "id": 129270,
                        "name": "Williamsburg",
                        "latitude": "40.71427000",
                        "longitude": "-73.95347000"
                    },
                    {
                        "id": 129274,
                        "name": "Williamson",
                        "latitude": "43.22395000",
                        "longitude": "-77.18609000"
                    },
                    {
                        "id": 129292,
                        "name": "Williamsville",
                        "latitude": "42.96395000",
                        "longitude": "-78.73781000"
                    },
                    {
                        "id": 129301,
                        "name": "Williston Park",
                        "latitude": "40.75649000",
                        "longitude": "-73.64485000"
                    },
                    {
                        "id": 129314,
                        "name": "Willowbrook",
                        "latitude": "40.60316000",
                        "longitude": "-74.13848000"
                    },
                    {
                        "id": 129331,
                        "name": "Wilson",
                        "latitude": "43.30978000",
                        "longitude": "-78.82615000"
                    },
                    {
                        "id": 129469,
                        "name": "Wolcott",
                        "latitude": "43.22062000",
                        "longitude": "-76.81496000"
                    },
                    {
                        "id": 129510,
                        "name": "Woodbury",
                        "latitude": "41.36454000",
                        "longitude": "-74.10598000"
                    },
                    {
                        "id": 129522,
                        "name": "Woodhaven",
                        "latitude": "40.68927000",
                        "longitude": "-73.85791000"
                    },
                    {
                        "id": 129537,
                        "name": "Woodlawn",
                        "latitude": "40.89816000",
                        "longitude": "-73.86736000"
                    },
                    {
                        "id": 129541,
                        "name": "Woodmere",
                        "latitude": "40.63205000",
                        "longitude": "-73.71263000"
                    },
                    {
                        "id": 129546,
                        "name": "Woodrow",
                        "latitude": "40.54344000",
                        "longitude": "-74.19764000"
                    },
                    {
                        "id": 129554,
                        "name": "Woodside",
                        "latitude": "40.74538000",
                        "longitude": "-73.90541000"
                    },
                    {
                        "id": 129565,
                        "name": "Woodstock",
                        "latitude": "42.04092000",
                        "longitude": "-74.11820000"
                    },
                    {
                        "id": 129585,
                        "name": "Worcester",
                        "latitude": "42.59146000",
                        "longitude": "-74.75043000"
                    },
                    {
                        "id": 129619,
                        "name": "Wurtsboro",
                        "latitude": "41.57676000",
                        "longitude": "-74.48710000"
                    },
                    {
                        "id": 129620,
                        "name": "Wyandanch",
                        "latitude": "40.75399000",
                        "longitude": "-73.36040000"
                    },
                    {
                        "id": 129624,
                        "name": "Wykagyl",
                        "latitude": "40.94149000",
                        "longitude": "-73.79902000"
                    },
                    {
                        "id": 129628,
                        "name": "Wynantskill",
                        "latitude": "42.69675000",
                        "longitude": "-73.64428000"
                    },
                    {
                        "id": 129640,
                        "name": "Wyoming County",
                        "latitude": "42.70238000",
                        "longitude": "-78.22444000"
                    },
                    {
                        "id": 129663,
                        "name": "Yaphank",
                        "latitude": "40.83677000",
                        "longitude": "-72.91705000"
                    },
                    {
                        "id": 129671,
                        "name": "Yates County",
                        "latitude": "42.63344000",
                        "longitude": "-77.10546000"
                    },
                    {
                        "id": 129688,
                        "name": "Yonkers",
                        "latitude": "40.93121000",
                        "longitude": "-73.89875000"
                    },
                    {
                        "id": 129704,
                        "name": "Yorkshire",
                        "latitude": "42.53006000",
                        "longitude": "-78.47280000"
                    },
                    {
                        "id": 129708,
                        "name": "Yorktown Heights",
                        "latitude": "41.27093000",
                        "longitude": "-73.77763000"
                    },
                    {
                        "id": 129710,
                        "name": "Yorkville",
                        "latitude": "43.11285000",
                        "longitude": "-75.27100000"
                    },
                    {
                        "id": 129717,
                        "name": "Youngstown",
                        "latitude": "43.24728000",
                        "longitude": "-79.05005000"
                    },
                    {
                        "id": 129748,
                        "name": "Zena",
                        "latitude": "42.01676000",
                        "longitude": "-74.07625000"
                    }
                ]
            },
            {
                "id": 1447,
                "name": "North Carolina",
                "iso2": "NC",
                "latitude": "35.75957310",
                "longitude": "-79.01929970",
                "type": "state",
                "cities": [
                    {
                        "id": 110975,
                        "name": "Aberdeen",
                        "latitude": "35.13155000",
                        "longitude": "-79.42948000"
                    },
                    {
                        "id": 111049,
                        "name": "Advance",
                        "latitude": "35.94125000",
                        "longitude": "-80.40922000"
                    },
                    {
                        "id": 111062,
                        "name": "Ahoskie",
                        "latitude": "36.28682000",
                        "longitude": "-76.98468000"
                    },
                    {
                        "id": 111087,
                        "name": "Alamance County",
                        "latitude": "36.04407000",
                        "longitude": "-79.39951000"
                    },
                    {
                        "id": 111115,
                        "name": "Albemarle",
                        "latitude": "35.35014000",
                        "longitude": "-80.20006000"
                    },
                    {
                        "id": 111148,
                        "name": "Alexander County",
                        "latitude": "35.92102000",
                        "longitude": "-81.17702000"
                    },
                    {
                        "id": 111183,
                        "name": "Alleghany County",
                        "latitude": "36.49134000",
                        "longitude": "-81.12719000"
                    },
                    {
                        "id": 111328,
                        "name": "Andrews",
                        "latitude": "35.20175000",
                        "longitude": "-83.82407000"
                    },
                    {
                        "id": 111338,
                        "name": "Angier",
                        "latitude": "35.50710000",
                        "longitude": "-78.73918000"
                    },
                    {
                        "id": 111361,
                        "name": "Anson County",
                        "latitude": "34.97383000",
                        "longitude": "-80.10273000"
                    },
                    {
                        "id": 111384,
                        "name": "Apex",
                        "latitude": "35.73265000",
                        "longitude": "-78.85029000"
                    },
                    {
                        "id": 111428,
                        "name": "Archdale",
                        "latitude": "35.91458000",
                        "longitude": "-79.97198000"
                    },
                    {
                        "id": 111432,
                        "name": "Archer Lodge",
                        "latitude": "35.69404000",
                        "longitude": "-78.37556000"
                    },
                    {
                        "id": 111519,
                        "name": "Ashe County",
                        "latitude": "36.43416000",
                        "longitude": "-81.50034000"
                    },
                    {
                        "id": 111520,
                        "name": "Asheboro",
                        "latitude": "35.70791000",
                        "longitude": "-79.81364000"
                    },
                    {
                        "id": 111522,
                        "name": "Asheville",
                        "latitude": "35.60095000",
                        "longitude": "-82.55402000"
                    },
                    {
                        "id": 111596,
                        "name": "Atlantic Beach",
                        "latitude": "34.69905000",
                        "longitude": "-76.74021000"
                    },
                    {
                        "id": 111681,
                        "name": "Avery County",
                        "latitude": "36.07661000",
                        "longitude": "-81.92247000"
                    },
                    {
                        "id": 111682,
                        "name": "Avery Creek",
                        "latitude": "35.46345000",
                        "longitude": "-82.58262000"
                    },
                    {
                        "id": 111707,
                        "name": "Ayden",
                        "latitude": "35.47266000",
                        "longitude": "-77.41552000"
                    },
                    {
                        "id": 111725,
                        "name": "Badin",
                        "latitude": "35.40597000",
                        "longitude": "-80.11672000"
                    },
                    {
                        "id": 111746,
                        "name": "Bakersville",
                        "latitude": "36.01567000",
                        "longitude": "-82.15874000"
                    },
                    {
                        "id": 111767,
                        "name": "Balfour",
                        "latitude": "35.34651000",
                        "longitude": "-82.47206000"
                    },
                    {
                        "id": 111801,
                        "name": "Banner Elk",
                        "latitude": "36.16318000",
                        "longitude": "-81.87150000"
                    },
                    {
                        "id": 111823,
                        "name": "Barker Heights",
                        "latitude": "35.31123000",
                        "longitude": "-82.44401000"
                    },
                    {
                        "id": 111939,
                        "name": "Bayboro",
                        "latitude": "35.14294000",
                        "longitude": "-76.77021000"
                    },
                    {
                        "id": 111953,
                        "name": "Bayshore",
                        "latitude": "34.28961000",
                        "longitude": "-77.78748000"
                    },
                    {
                        "id": 111985,
                        "name": "Beaufort",
                        "latitude": "34.71822000",
                        "longitude": "-76.66382000"
                    },
                    {
                        "id": 111987,
                        "name": "Beaufort County",
                        "latitude": "35.48583000",
                        "longitude": "-76.84516000"
                    },
                    {
                        "id": 112063,
                        "name": "Belhaven",
                        "latitude": "35.54017000",
                        "longitude": "-76.62299000"
                    },
                    {
                        "id": 112136,
                        "name": "Belmont",
                        "latitude": "35.24292000",
                        "longitude": "-81.03730000"
                    },
                    {
                        "id": 112157,
                        "name": "Belville",
                        "latitude": "34.23073000",
                        "longitude": "-77.96582000"
                    },
                    {
                        "id": 112182,
                        "name": "Benson",
                        "latitude": "35.38211000",
                        "longitude": "-78.54862000"
                    },
                    {
                        "id": 112189,
                        "name": "Bent Creek",
                        "latitude": "35.50900000",
                        "longitude": "-82.60790000"
                    },
                    {
                        "id": 112241,
                        "name": "Bermuda Run",
                        "latitude": "36.00375000",
                        "longitude": "-80.42200000"
                    },
                    {
                        "id": 112258,
                        "name": "Bertie County",
                        "latitude": "36.06556000",
                        "longitude": "-76.96660000"
                    },
                    {
                        "id": 112270,
                        "name": "Bessemer City",
                        "latitude": "35.28486000",
                        "longitude": "-81.28397000"
                    },
                    {
                        "id": 112278,
                        "name": "Bethel",
                        "latitude": "35.80710000",
                        "longitude": "-77.37886000"
                    },
                    {
                        "id": 112289,
                        "name": "Bethlehem",
                        "latitude": "35.82569000",
                        "longitude": "-81.30703000"
                    },
                    {
                        "id": 112297,
                        "name": "Beulaville",
                        "latitude": "34.92378000",
                        "longitude": "-77.77387000"
                    },
                    {
                        "id": 112348,
                        "name": "Biltmore Forest",
                        "latitude": "35.53372000",
                        "longitude": "-82.52846000"
                    },
                    {
                        "id": 112362,
                        "name": "Biscoe",
                        "latitude": "35.35986000",
                        "longitude": "-79.77976000"
                    },
                    {
                        "id": 112380,
                        "name": "Black Mountain",
                        "latitude": "35.61790000",
                        "longitude": "-82.32123000"
                    },
                    {
                        "id": 112398,
                        "name": "Bladen County",
                        "latitude": "34.61431000",
                        "longitude": "-78.56318000"
                    },
                    {
                        "id": 112399,
                        "name": "Bladenboro",
                        "latitude": "34.53878000",
                        "longitude": "-78.78752000"
                    },
                    {
                        "id": 112462,
                        "name": "Blowing Rock",
                        "latitude": "36.13513000",
                        "longitude": "-81.67761000"
                    },
                    {
                        "id": 112504,
                        "name": "Boiling Spring Lakes",
                        "latitude": "34.03045000",
                        "longitude": "-78.06721000"
                    },
                    {
                        "id": 112505,
                        "name": "Boiling Springs",
                        "latitude": "35.25429000",
                        "longitude": "-81.66704000"
                    },
                    {
                        "id": 112523,
                        "name": "Bolivia",
                        "latitude": "34.06767000",
                        "longitude": "-78.14833000"
                    },
                    {
                        "id": 112552,
                        "name": "Boone",
                        "latitude": "36.21679000",
                        "longitude": "-81.67455000"
                    },
                    {
                        "id": 112569,
                        "name": "Boonville",
                        "latitude": "36.23264000",
                        "longitude": "-80.70812000"
                    },
                    {
                        "id": 112737,
                        "name": "Brevard",
                        "latitude": "35.23345000",
                        "longitude": "-82.73429000"
                    },
                    {
                        "id": 112753,
                        "name": "Brices Creek",
                        "latitude": "35.05599000",
                        "longitude": "-77.08773000"
                    },
                    {
                        "id": 112821,
                        "name": "Broad Creek",
                        "latitude": "34.72072000",
                        "longitude": "-76.93633000"
                    },
                    {
                        "id": 112830,
                        "name": "Broadway",
                        "latitude": "35.45793000",
                        "longitude": "-79.05308000"
                    },
                    {
                        "id": 112840,
                        "name": "Brogden",
                        "latitude": "35.29266000",
                        "longitude": "-78.03443000"
                    },
                    {
                        "id": 112949,
                        "name": "Brunswick",
                        "latitude": "34.28684000",
                        "longitude": "-78.70113000"
                    },
                    {
                        "id": 112951,
                        "name": "Brunswick County",
                        "latitude": "34.03897000",
                        "longitude": "-78.22728000"
                    },
                    {
                        "id": 112968,
                        "name": "Bryson City",
                        "latitude": "35.43127000",
                        "longitude": "-83.44944000"
                    },
                    {
                        "id": 113025,
                        "name": "Buies Creek",
                        "latitude": "35.41322000",
                        "longitude": "-78.73557000"
                    },
                    {
                        "id": 113038,
                        "name": "Buncombe County",
                        "latitude": "35.61122000",
                        "longitude": "-82.53010000"
                    },
                    {
                        "id": 113050,
                        "name": "Burgaw",
                        "latitude": "34.55211000",
                        "longitude": "-77.92610000"
                    },
                    {
                        "id": 113057,
                        "name": "Burke County",
                        "latitude": "35.74952000",
                        "longitude": "-81.70470000"
                    },
                    {
                        "id": 113068,
                        "name": "Burlington",
                        "latitude": "36.09569000",
                        "longitude": "-79.43780000"
                    },
                    {
                        "id": 113090,
                        "name": "Burnsville",
                        "latitude": "35.91734000",
                        "longitude": "-82.30096000"
                    },
                    {
                        "id": 113121,
                        "name": "Butner",
                        "latitude": "36.13209000",
                        "longitude": "-78.75667000"
                    },
                    {
                        "id": 113131,
                        "name": "Buxton",
                        "latitude": "35.26768000",
                        "longitude": "-75.54237000"
                    },
                    {
                        "id": 113149,
                        "name": "Cabarrus County",
                        "latitude": "35.38687000",
                        "longitude": "-80.55204000"
                    },
                    {
                        "id": 113172,
                        "name": "Cajahs Mountain",
                        "latitude": "35.83485000",
                        "longitude": "-81.54148000"
                    },
                    {
                        "id": 113174,
                        "name": "Calabash",
                        "latitude": "33.89073000",
                        "longitude": "-78.56834000"
                    },
                    {
                        "id": 113185,
                        "name": "Caldwell County",
                        "latitude": "35.95297000",
                        "longitude": "-81.54655000"
                    },
                    {
                        "id": 113262,
                        "name": "Camden",
                        "latitude": "36.32849000",
                        "longitude": "-76.17188000"
                    },
                    {
                        "id": 113270,
                        "name": "Camden County",
                        "latitude": "36.34145000",
                        "longitude": "-76.16112000"
                    },
                    {
                        "id": 113341,
                        "name": "Canton",
                        "latitude": "35.53288000",
                        "longitude": "-82.83736000"
                    },
                    {
                        "id": 113364,
                        "name": "Cape Carteret",
                        "latitude": "34.69155000",
                        "longitude": "-77.06300000"
                    },
                    {
                        "id": 113435,
                        "name": "Carolina Beach",
                        "latitude": "34.03517000",
                        "longitude": "-77.89360000"
                    },
                    {
                        "id": 113436,
                        "name": "Carolina Shores",
                        "latitude": "33.90101000",
                        "longitude": "-78.58057000"
                    },
                    {
                        "id": 113442,
                        "name": "Carrboro",
                        "latitude": "35.91014000",
                        "longitude": "-79.07529000"
                    },
                    {
                        "id": 113487,
                        "name": "Carteret County",
                        "latitude": "34.86401000",
                        "longitude": "-76.53249000"
                    },
                    {
                        "id": 113493,
                        "name": "Carthage",
                        "latitude": "35.34599000",
                        "longitude": "-79.41697000"
                    },
                    {
                        "id": 113505,
                        "name": "Cary",
                        "latitude": "35.79154000",
                        "longitude": "-78.78112000"
                    },
                    {
                        "id": 113544,
                        "name": "Castle Hayne",
                        "latitude": "34.35572000",
                        "longitude": "-77.89999000"
                    },
                    {
                        "id": 113560,
                        "name": "Caswell County",
                        "latitude": "36.39335000",
                        "longitude": "-79.33359000"
                    },
                    {
                        "id": 113567,
                        "name": "Catawba County",
                        "latitude": "35.66261000",
                        "longitude": "-81.21448000"
                    },
                    {
                        "id": 113620,
                        "name": "Cedar Point",
                        "latitude": "34.68766000",
                        "longitude": "-77.07245000"
                    },
                    {
                        "id": 113706,
                        "name": "Chadbourn",
                        "latitude": "34.32211000",
                        "longitude": "-78.82697000"
                    },
                    {
                        "id": 113741,
                        "name": "Chapel Hill",
                        "latitude": "35.91320000",
                        "longitude": "-79.05584000"
                    },
                    {
                        "id": 113776,
                        "name": "Charlotte",
                        "latitude": "35.22709000",
                        "longitude": "-80.84313000"
                    },
                    {
                        "id": 113802,
                        "name": "Chatham County",
                        "latitude": "35.70258000",
                        "longitude": "-79.25535000"
                    },
                    {
                        "id": 113846,
                        "name": "Cherokee",
                        "latitude": "35.47427000",
                        "longitude": "-83.31487000"
                    },
                    {
                        "id": 113852,
                        "name": "Cherokee County",
                        "latitude": "35.13384000",
                        "longitude": "-84.06347000"
                    },
                    {
                        "id": 113870,
                        "name": "Cherryville",
                        "latitude": "35.37874000",
                        "longitude": "-81.37897000"
                    },
                    {
                        "id": 113961,
                        "name": "China Grove",
                        "latitude": "35.56931000",
                        "longitude": "-80.58173000"
                    },
                    {
                        "id": 113992,
                        "name": "Chowan County",
                        "latitude": "36.12656000",
                        "longitude": "-76.60216000"
                    },
                    {
                        "id": 114104,
                        "name": "Claremont",
                        "latitude": "35.71458000",
                        "longitude": "-81.14619000"
                    },
                    {
                        "id": 114183,
                        "name": "Clay County",
                        "latitude": "35.05719000",
                        "longitude": "-83.75021000"
                    },
                    {
                        "id": 114200,
                        "name": "Clayton",
                        "latitude": "35.65071000",
                        "longitude": "-78.45639000"
                    },
                    {
                        "id": 114233,
                        "name": "Clemmons",
                        "latitude": "36.02153000",
                        "longitude": "-80.38200000"
                    },
                    {
                        "id": 114249,
                        "name": "Cleveland County",
                        "latitude": "35.33411000",
                        "longitude": "-81.55561000"
                    },
                    {
                        "id": 114273,
                        "name": "Clinton",
                        "latitude": "34.99795000",
                        "longitude": "-78.32333000"
                    },
                    {
                        "id": 114318,
                        "name": "Clyde",
                        "latitude": "35.53344000",
                        "longitude": "-82.91069000"
                    },
                    {
                        "id": 114342,
                        "name": "Coats",
                        "latitude": "35.40794000",
                        "longitude": "-78.67196000"
                    },
                    {
                        "id": 114470,
                        "name": "Columbia",
                        "latitude": "35.91766000",
                        "longitude": "-76.25215000"
                    },
                    {
                        "id": 114493,
                        "name": "Columbus",
                        "latitude": "35.25317000",
                        "longitude": "-82.19706000"
                    },
                    {
                        "id": 114502,
                        "name": "Columbus County",
                        "latitude": "34.26540000",
                        "longitude": "-78.65507000"
                    },
                    {
                        "id": 114536,
                        "name": "Concord",
                        "latitude": "35.40888000",
                        "longitude": "-80.58158000"
                    },
                    {
                        "id": 114563,
                        "name": "Connelly Springs",
                        "latitude": "35.74291000",
                        "longitude": "-81.51343000"
                    },
                    {
                        "id": 114567,
                        "name": "Conover",
                        "latitude": "35.70652000",
                        "longitude": "-81.21869000"
                    },
                    {
                        "id": 114639,
                        "name": "Cordova",
                        "latitude": "34.91293000",
                        "longitude": "-79.82200000"
                    },
                    {
                        "id": 114647,
                        "name": "Cornelius",
                        "latitude": "35.48680000",
                        "longitude": "-80.86007000"
                    },
                    {
                        "id": 114730,
                        "name": "Cove Creek",
                        "latitude": "35.60649000",
                        "longitude": "-83.01125000"
                    },
                    {
                        "id": 114762,
                        "name": "Cramerton",
                        "latitude": "35.23875000",
                        "longitude": "-81.07508000"
                    },
                    {
                        "id": 114773,
                        "name": "Craven County",
                        "latitude": "35.11722000",
                        "longitude": "-77.08263000"
                    },
                    {
                        "id": 114788,
                        "name": "Creedmoor",
                        "latitude": "36.12237000",
                        "longitude": "-78.68611000"
                    },
                    {
                        "id": 114819,
                        "name": "Cricket",
                        "latitude": "36.17152000",
                        "longitude": "-81.19398000"
                    },
                    {
                        "id": 114898,
                        "name": "Cullowhee",
                        "latitude": "35.31371000",
                        "longitude": "-83.17653000"
                    },
                    {
                        "id": 114914,
                        "name": "Cumberland County",
                        "latitude": "35.04859000",
                        "longitude": "-78.82744000"
                    },
                    {
                        "id": 114925,
                        "name": "Currituck",
                        "latitude": "36.44988000",
                        "longitude": "-76.01548000"
                    },
                    {
                        "id": 114926,
                        "name": "Currituck County",
                        "latitude": "36.36724000",
                        "longitude": "-75.93683000"
                    },
                    {
                        "id": 114989,
                        "name": "Dallas",
                        "latitude": "35.31653000",
                        "longitude": "-81.17619000"
                    },
                    {
                        "id": 115011,
                        "name": "Dana",
                        "latitude": "35.32928000",
                        "longitude": "-82.37540000"
                    },
                    {
                        "id": 115013,
                        "name": "Danbury",
                        "latitude": "36.40930000",
                        "longitude": "-80.20588000"
                    },
                    {
                        "id": 115044,
                        "name": "Dare County",
                        "latitude": "35.78663000",
                        "longitude": "-75.78094000"
                    },
                    {
                        "id": 115062,
                        "name": "Davidson",
                        "latitude": "35.50233000",
                        "longitude": "-80.83912000"
                    },
                    {
                        "id": 115063,
                        "name": "Davidson County",
                        "latitude": "35.79328000",
                        "longitude": "-80.21269000"
                    },
                    {
                        "id": 115068,
                        "name": "Davie County",
                        "latitude": "35.92916000",
                        "longitude": "-80.54447000"
                    },
                    {
                        "id": 115246,
                        "name": "Denton",
                        "latitude": "35.63347000",
                        "longitude": "-80.11588000"
                    },
                    {
                        "id": 115250,
                        "name": "Denver",
                        "latitude": "35.53125000",
                        "longitude": "-81.02980000"
                    },
                    {
                        "id": 115371,
                        "name": "Dobson",
                        "latitude": "36.39569000",
                        "longitude": "-80.72257000"
                    },
                    {
                        "id": 115475,
                        "name": "Drexel",
                        "latitude": "35.75791000",
                        "longitude": "-81.60426000"
                    },
                    {
                        "id": 115546,
                        "name": "Dunn",
                        "latitude": "35.30627000",
                        "longitude": "-78.60890000"
                    },
                    {
                        "id": 115556,
                        "name": "Duplin County",
                        "latitude": "34.93628000",
                        "longitude": "-77.93294000"
                    },
                    {
                        "id": 115569,
                        "name": "Durham",
                        "latitude": "35.99403000",
                        "longitude": "-78.89862000"
                    },
                    {
                        "id": 115575,
                        "name": "Durham County",
                        "latitude": "36.03600000",
                        "longitude": "-78.87632000"
                    },
                    {
                        "id": 115660,
                        "name": "East Flat Rock",
                        "latitude": "35.28012000",
                        "longitude": "-82.42206000"
                    },
                    {
                        "id": 115751,
                        "name": "East Rockingham",
                        "latitude": "34.91821000",
                        "longitude": "-79.76256000"
                    },
                    {
                        "id": 115760,
                        "name": "East Spencer",
                        "latitude": "35.68181000",
                        "longitude": "-80.43228000"
                    },
                    {
                        "id": 115792,
                        "name": "Eastover",
                        "latitude": "35.10000000",
                        "longitude": "-78.80000000"
                    },
                    {
                        "id": 115828,
                        "name": "Eden",
                        "latitude": "36.48847000",
                        "longitude": "-79.76670000"
                    },
                    {
                        "id": 115834,
                        "name": "Edenton",
                        "latitude": "36.05794000",
                        "longitude": "-76.60772000"
                    },
                    {
                        "id": 115841,
                        "name": "Edgecombe County",
                        "latitude": "35.91298000",
                        "longitude": "-77.59707000"
                    },
                    {
                        "id": 115885,
                        "name": "Edneyville",
                        "latitude": "35.39401000",
                        "longitude": "-82.34095000"
                    },
                    {
                        "id": 115975,
                        "name": "Elizabeth City",
                        "latitude": "36.29460000",
                        "longitude": "-76.25105000"
                    },
                    {
                        "id": 115979,
                        "name": "Elizabethtown",
                        "latitude": "34.62934000",
                        "longitude": "-78.60529000"
                    },
                    {
                        "id": 116004,
                        "name": "Elkin",
                        "latitude": "36.24430000",
                        "longitude": "-80.84840000"
                    },
                    {
                        "id": 116021,
                        "name": "Ellerbe",
                        "latitude": "35.07126000",
                        "longitude": "-79.76144000"
                    },
                    {
                        "id": 116042,
                        "name": "Elm City",
                        "latitude": "35.80655000",
                        "longitude": "-77.86332000"
                    },
                    {
                        "id": 116064,
                        "name": "Elon",
                        "latitude": "36.10291000",
                        "longitude": "-79.50669000"
                    },
                    {
                        "id": 116066,
                        "name": "Elroy",
                        "latitude": "35.34266000",
                        "longitude": "-77.90859000"
                    },
                    {
                        "id": 116089,
                        "name": "Emerald Isle",
                        "latitude": "34.67794000",
                        "longitude": "-76.95078000"
                    },
                    {
                        "id": 116124,
                        "name": "Enfield",
                        "latitude": "36.18099000",
                        "longitude": "-77.66664000"
                    },
                    {
                        "id": 116143,
                        "name": "Enochville",
                        "latitude": "35.52986000",
                        "longitude": "-80.66812000"
                    },
                    {
                        "id": 116175,
                        "name": "Erwin",
                        "latitude": "35.32683000",
                        "longitude": "-78.67613000"
                    },
                    {
                        "id": 116217,
                        "name": "Etowah",
                        "latitude": "35.31762000",
                        "longitude": "-82.59429000"
                    },
                    {
                        "id": 116322,
                        "name": "Fairfield Harbour",
                        "latitude": "35.07655000",
                        "longitude": "-76.96356000"
                    },
                    {
                        "id": 116334,
                        "name": "Fairmont",
                        "latitude": "34.49683000",
                        "longitude": "-79.11420000"
                    },
                    {
                        "id": 116343,
                        "name": "Fairplains",
                        "latitude": "36.19847000",
                        "longitude": "-81.15286000"
                    },
                    {
                        "id": 116348,
                        "name": "Fairview",
                        "latitude": "35.51401000",
                        "longitude": "-82.39595000"
                    },
                    {
                        "id": 116426,
                        "name": "Farmville",
                        "latitude": "35.59544000",
                        "longitude": "-77.58525000"
                    },
                    {
                        "id": 116456,
                        "name": "Fayetteville",
                        "latitude": "35.05266000",
                        "longitude": "-78.87836000"
                    },
                    {
                        "id": 116461,
                        "name": "Fearrington Village",
                        "latitude": "35.80376000",
                        "longitude": "-79.09029000"
                    },
                    {
                        "id": 116551,
                        "name": "Flat Rock",
                        "latitude": "35.27123000",
                        "longitude": "-82.44151000"
                    },
                    {
                        "id": 116564,
                        "name": "Fletcher",
                        "latitude": "35.43067000",
                        "longitude": "-82.50123000"
                    },
                    {
                        "id": 116647,
                        "name": "Forest City",
                        "latitude": "35.33401000",
                        "longitude": "-81.86510000"
                    },
                    {
                        "id": 116663,
                        "name": "Forest Oaks",
                        "latitude": "35.98819000",
                        "longitude": "-79.70614000"
                    },
                    {
                        "id": 116687,
                        "name": "Forsyth County",
                        "latitude": "36.13049000",
                        "longitude": "-80.25636000"
                    },
                    {
                        "id": 116696,
                        "name": "Fort Bragg",
                        "latitude": "35.13900000",
                        "longitude": "-79.00603000"
                    },
                    {
                        "id": 116771,
                        "name": "Foscoe",
                        "latitude": "36.16179000",
                        "longitude": "-81.76566000"
                    },
                    {
                        "id": 116792,
                        "name": "Four Oaks",
                        "latitude": "35.44488000",
                        "longitude": "-78.42695000"
                    },
                    {
                        "id": 116828,
                        "name": "Franklin",
                        "latitude": "35.18232000",
                        "longitude": "-83.38154000"
                    },
                    {
                        "id": 116853,
                        "name": "Franklin County",
                        "latitude": "36.08279000",
                        "longitude": "-78.28561000"
                    },
                    {
                        "id": 116874,
                        "name": "Franklinton",
                        "latitude": "36.10182000",
                        "longitude": "-78.45805000"
                    },
                    {
                        "id": 116875,
                        "name": "Franklinville",
                        "latitude": "35.74375000",
                        "longitude": "-79.69225000"
                    },
                    {
                        "id": 116919,
                        "name": "Fremont",
                        "latitude": "35.54544000",
                        "longitude": "-77.97471000"
                    },
                    {
                        "id": 116971,
                        "name": "Fruitland",
                        "latitude": "35.39651000",
                        "longitude": "-82.39317000"
                    },
                    {
                        "id": 117000,
                        "name": "Fuquay-Varina",
                        "latitude": "35.58432000",
                        "longitude": "-78.80001000"
                    },
                    {
                        "id": 117046,
                        "name": "Gamewell",
                        "latitude": "35.86930000",
                        "longitude": "-81.59621000"
                    },
                    {
                        "id": 117092,
                        "name": "Garner",
                        "latitude": "35.71126000",
                        "longitude": "-78.61417000"
                    },
                    {
                        "id": 117113,
                        "name": "Gaston",
                        "latitude": "36.50043000",
                        "longitude": "-77.64498000"
                    },
                    {
                        "id": 117115,
                        "name": "Gaston County",
                        "latitude": "35.29437000",
                        "longitude": "-81.18025000"
                    },
                    {
                        "id": 117116,
                        "name": "Gastonia",
                        "latitude": "35.26208000",
                        "longitude": "-81.18730000"
                    },
                    {
                        "id": 117119,
                        "name": "Gates County",
                        "latitude": "36.44489000",
                        "longitude": "-76.70049000"
                    },
                    {
                        "id": 117121,
                        "name": "Gatesville",
                        "latitude": "36.40349000",
                        "longitude": "-76.75301000"
                    },
                    {
                        "id": 117194,
                        "name": "Gibsonville",
                        "latitude": "36.10569000",
                        "longitude": "-79.54225000"
                    },
                    {
                        "id": 117260,
                        "name": "Glen Alpine",
                        "latitude": "35.72902000",
                        "longitude": "-81.77927000"
                    },
                    {
                        "id": 117270,
                        "name": "Glen Raven",
                        "latitude": "36.11319000",
                        "longitude": "-79.47641000"
                    },
                    {
                        "id": 117364,
                        "name": "Goldsboro",
                        "latitude": "35.38488000",
                        "longitude": "-77.99277000"
                    },
                    {
                        "id": 117405,
                        "name": "Gorman",
                        "latitude": "36.03653000",
                        "longitude": "-78.82334000"
                    },
                    {
                        "id": 117434,
                        "name": "Graham",
                        "latitude": "36.06903000",
                        "longitude": "-79.40058000"
                    },
                    {
                        "id": 117438,
                        "name": "Graham County",
                        "latitude": "35.35016000",
                        "longitude": "-83.83356000"
                    },
                    {
                        "id": 117496,
                        "name": "Granite Falls",
                        "latitude": "35.79652000",
                        "longitude": "-81.43065000"
                    },
                    {
                        "id": 117500,
                        "name": "Granite Quarry",
                        "latitude": "35.61236000",
                        "longitude": "-80.44673000"
                    },
                    {
                        "id": 117537,
                        "name": "Granville County",
                        "latitude": "36.30402000",
                        "longitude": "-78.65302000"
                    },
                    {
                        "id": 117603,
                        "name": "Green Level",
                        "latitude": "36.12097000",
                        "longitude": "-79.34419000"
                    },
                    {
                        "id": 117638,
                        "name": "Greene County",
                        "latitude": "35.48541000",
                        "longitude": "-77.67587000"
                    },
                    {
                        "id": 117667,
                        "name": "Greensboro",
                        "latitude": "36.07264000",
                        "longitude": "-79.79198000"
                    },
                    {
                        "id": 117687,
                        "name": "Greenville",
                        "latitude": "35.61266000",
                        "longitude": "-77.36635000"
                    },
                    {
                        "id": 117733,
                        "name": "Grifton",
                        "latitude": "35.37266000",
                        "longitude": "-77.43746000"
                    },
                    {
                        "id": 117787,
                        "name": "Guilford County",
                        "latitude": "36.07945000",
                        "longitude": "-79.78901000"
                    },
                    {
                        "id": 117855,
                        "name": "Half Moon",
                        "latitude": "34.82600000",
                        "longitude": "-77.45941000"
                    },
                    {
                        "id": 117859,
                        "name": "Halifax",
                        "latitude": "36.32849000",
                        "longitude": "-77.58942000"
                    },
                    {
                        "id": 117862,
                        "name": "Halifax County",
                        "latitude": "36.25750000",
                        "longitude": "-77.65188000"
                    },
                    {
                        "id": 117907,
                        "name": "Hamlet",
                        "latitude": "34.88488000",
                        "longitude": "-79.69422000"
                    },
                    {
                        "id": 117924,
                        "name": "Hampstead",
                        "latitude": "34.36767000",
                        "longitude": "-77.71053000"
                    },
                    {
                        "id": 118014,
                        "name": "Harkers Island",
                        "latitude": "34.69516000",
                        "longitude": "-76.55937000"
                    },
                    {
                        "id": 118029,
                        "name": "Harnett County",
                        "latitude": "35.36860000",
                        "longitude": "-78.86931000"
                    },
                    {
                        "id": 118049,
                        "name": "Harrisburg",
                        "latitude": "35.32395000",
                        "longitude": "-80.65784000"
                    },
                    {
                        "id": 118147,
                        "name": "Havelock",
                        "latitude": "34.87905000",
                        "longitude": "-76.90133000"
                    },
                    {
                        "id": 118156,
                        "name": "Haw River",
                        "latitude": "36.09153000",
                        "longitude": "-79.36419000"
                    },
                    {
                        "id": 118182,
                        "name": "Hayesville",
                        "latitude": "35.04620000",
                        "longitude": "-83.81795000"
                    },
                    {
                        "id": 118191,
                        "name": "Hays",
                        "latitude": "36.24985000",
                        "longitude": "-81.11564000"
                    },
                    {
                        "id": 118198,
                        "name": "Haywood County",
                        "latitude": "35.55605000",
                        "longitude": "-82.98224000"
                    },
                    {
                        "id": 118208,
                        "name": "Hazelwood",
                        "latitude": "35.46871000",
                        "longitude": "-83.00403000"
                    },
                    {
                        "id": 118263,
                        "name": "Hemby Bridge",
                        "latitude": "35.10371000",
                        "longitude": "-80.62798000"
                    },
                    {
                        "id": 118276,
                        "name": "Henderson",
                        "latitude": "36.32959000",
                        "longitude": "-78.39916000"
                    },
                    {
                        "id": 118281,
                        "name": "Henderson County",
                        "latitude": "35.33629000",
                        "longitude": "-82.47991000"
                    },
                    {
                        "id": 118285,
                        "name": "Hendersonville",
                        "latitude": "35.31873000",
                        "longitude": "-82.46095000"
                    },
                    {
                        "id": 118342,
                        "name": "Hertford",
                        "latitude": "36.19016000",
                        "longitude": "-76.46605000"
                    },
                    {
                        "id": 118343,
                        "name": "Hertford County",
                        "latitude": "36.35863000",
                        "longitude": "-76.98066000"
                    },
                    {
                        "id": 118365,
                        "name": "Hickory",
                        "latitude": "35.73319000",
                        "longitude": "-81.34120000"
                    },
                    {
                        "id": 118386,
                        "name": "High Point",
                        "latitude": "35.95569000",
                        "longitude": "-80.00532000"
                    },
                    {
                        "id": 118430,
                        "name": "Hildebran",
                        "latitude": "35.71402000",
                        "longitude": "-81.42203000"
                    },
                    {
                        "id": 118454,
                        "name": "Hillsborough",
                        "latitude": "36.07542000",
                        "longitude": "-79.09973000"
                    },
                    {
                        "id": 118514,
                        "name": "Hoke County",
                        "latitude": "35.01736000",
                        "longitude": "-79.23711000"
                    },
                    {
                        "id": 118560,
                        "name": "Holly Ridge",
                        "latitude": "34.49544000",
                        "longitude": "-77.55497000"
                    },
                    {
                        "id": 118562,
                        "name": "Holly Springs",
                        "latitude": "35.65127000",
                        "longitude": "-78.83362000"
                    },
                    {
                        "id": 118635,
                        "name": "Hoopers Creek",
                        "latitude": "35.43900000",
                        "longitude": "-82.46679000"
                    },
                    {
                        "id": 118645,
                        "name": "Hope Mills",
                        "latitude": "34.97044000",
                        "longitude": "-78.94531000"
                    },
                    {
                        "id": 118672,
                        "name": "Horse Shoe",
                        "latitude": "35.34317000",
                        "longitude": "-82.55651000"
                    },
                    {
                        "id": 118736,
                        "name": "Hudson",
                        "latitude": "35.84846000",
                        "longitude": "-81.49593000"
                    },
                    {
                        "id": 118792,
                        "name": "Huntersville",
                        "latitude": "35.41069000",
                        "longitude": "-80.84285000"
                    },
                    {
                        "id": 118847,
                        "name": "Hyde County",
                        "latitude": "35.41004000",
                        "longitude": "-76.14850000"
                    },
                    {
                        "id": 118865,
                        "name": "Icard",
                        "latitude": "35.72735000",
                        "longitude": "-81.47065000"
                    },
                    {
                        "id": 118920,
                        "name": "Indian Trail",
                        "latitude": "35.07681000",
                        "longitude": "-80.66924000"
                    },
                    {
                        "id": 118985,
                        "name": "Iredell County",
                        "latitude": "35.80708000",
                        "longitude": "-80.87344000"
                    },
                    {
                        "id": 119067,
                        "name": "Jackson",
                        "latitude": "36.38960000",
                        "longitude": "-77.42136000"
                    },
                    {
                        "id": 119085,
                        "name": "Jackson County",
                        "latitude": "35.28739000",
                        "longitude": "-83.14083000"
                    },
                    {
                        "id": 119103,
                        "name": "Jacksonville",
                        "latitude": "34.75405000",
                        "longitude": "-77.43024000"
                    },
                    {
                        "id": 119115,
                        "name": "James City",
                        "latitude": "35.08877000",
                        "longitude": "-77.03495000"
                    },
                    {
                        "id": 119121,
                        "name": "Jamestown",
                        "latitude": "35.99430000",
                        "longitude": "-79.93531000"
                    },
                    {
                        "id": 119165,
                        "name": "Jefferson",
                        "latitude": "36.42040000",
                        "longitude": "-81.47344000"
                    },
                    {
                        "id": 119281,
                        "name": "Johnston County",
                        "latitude": "35.51761000",
                        "longitude": "-78.36564000"
                    },
                    {
                        "id": 119294,
                        "name": "Jones County",
                        "latitude": "35.02170000",
                        "longitude": "-77.35526000"
                    },
                    {
                        "id": 119310,
                        "name": "Jonesville",
                        "latitude": "36.23930000",
                        "longitude": "-80.84452000"
                    },
                    {
                        "id": 119382,
                        "name": "Kannapolis",
                        "latitude": "35.48736000",
                        "longitude": "-80.62173000"
                    },
                    {
                        "id": 119442,
                        "name": "Kenansville",
                        "latitude": "34.96239000",
                        "longitude": "-77.96221000"
                    },
                    {
                        "id": 119459,
                        "name": "Kenly",
                        "latitude": "35.59627000",
                        "longitude": "-78.12416000"
                    },
                    {
                        "id": 119515,
                        "name": "Kernersville",
                        "latitude": "36.11986000",
                        "longitude": "-80.07365000"
                    },
                    {
                        "id": 119557,
                        "name": "Kill Devil Hills",
                        "latitude": "36.03072000",
                        "longitude": "-75.67601000"
                    },
                    {
                        "id": 119576,
                        "name": "King",
                        "latitude": "36.28069000",
                        "longitude": "-80.35922000"
                    },
                    {
                        "id": 119602,
                        "name": "Kings Grant",
                        "latitude": "34.26295000",
                        "longitude": "-77.86360000"
                    },
                    {
                        "id": 119603,
                        "name": "Kings Mountain",
                        "latitude": "35.24513000",
                        "longitude": "-81.34119000"
                    },
                    {
                        "id": 119643,
                        "name": "Kinston",
                        "latitude": "35.26266000",
                        "longitude": "-77.58164000"
                    },
                    {
                        "id": 119668,
                        "name": "Kitty Hawk",
                        "latitude": "36.06461000",
                        "longitude": "-75.70573000"
                    },
                    {
                        "id": 119674,
                        "name": "Knightdale",
                        "latitude": "35.78765000",
                        "longitude": "-78.48056000"
                    },
                    {
                        "id": 119726,
                        "name": "Kure Beach",
                        "latitude": "33.99684000",
                        "longitude": "-77.90721000"
                    },
                    {
                        "id": 119750,
                        "name": "La Grange",
                        "latitude": "35.30683000",
                        "longitude": "-77.78803000"
                    },
                    {
                        "id": 119925,
                        "name": "Lake Junaluska",
                        "latitude": "35.52788000",
                        "longitude": "-82.95958000"
                    },
                    {
                        "id": 119934,
                        "name": "Lake Lure",
                        "latitude": "35.42790000",
                        "longitude": "-82.20483000"
                    },
                    {
                        "id": 119952,
                        "name": "Lake Norman of Catawba",
                        "latitude": "35.58680000",
                        "longitude": "-80.95952000"
                    },
                    {
                        "id": 119960,
                        "name": "Lake Park",
                        "latitude": "35.08626000",
                        "longitude": "-80.63507000"
                    },
                    {
                        "id": 119990,
                        "name": "Lake Waccamaw",
                        "latitude": "34.31906000",
                        "longitude": "-78.50001000"
                    },
                    {
                        "id": 120099,
                        "name": "Landis",
                        "latitude": "35.54569000",
                        "longitude": "-80.61090000"
                    },
                    {
                        "id": 120196,
                        "name": "Laurel Hill",
                        "latitude": "34.80905000",
                        "longitude": "-79.54783000"
                    },
                    {
                        "id": 120200,
                        "name": "Laurel Park",
                        "latitude": "35.31373000",
                        "longitude": "-82.49345000"
                    },
                    {
                        "id": 120210,
                        "name": "Laurinburg",
                        "latitude": "34.77405000",
                        "longitude": "-79.46282000"
                    },
                    {
                        "id": 120312,
                        "name": "Lee County",
                        "latitude": "35.47517000",
                        "longitude": "-79.17143000"
                    },
                    {
                        "id": 120350,
                        "name": "Leland",
                        "latitude": "34.25628000",
                        "longitude": "-78.04471000"
                    },
                    {
                        "id": 120372,
                        "name": "Lenoir",
                        "latitude": "35.91402000",
                        "longitude": "-81.53898000"
                    },
                    {
                        "id": 120374,
                        "name": "Lenoir County",
                        "latitude": "35.23915000",
                        "longitude": "-77.64127000"
                    },
                    {
                        "id": 120435,
                        "name": "Lewisville",
                        "latitude": "36.09708000",
                        "longitude": "-80.41922000"
                    },
                    {
                        "id": 120442,
                        "name": "Lexington",
                        "latitude": "35.82403000",
                        "longitude": "-80.25338000"
                    },
                    {
                        "id": 120462,
                        "name": "Liberty",
                        "latitude": "35.85347000",
                        "longitude": "-79.57169000"
                    },
                    {
                        "id": 120486,
                        "name": "Lillington",
                        "latitude": "35.39933000",
                        "longitude": "-78.81585000"
                    },
                    {
                        "id": 120522,
                        "name": "Lincoln County",
                        "latitude": "35.48618000",
                        "longitude": "-81.22387000"
                    },
                    {
                        "id": 120552,
                        "name": "Lincolnton",
                        "latitude": "35.47375000",
                        "longitude": "-81.25453000"
                    },
                    {
                        "id": 120684,
                        "name": "Locust",
                        "latitude": "35.25987000",
                        "longitude": "-80.42534000"
                    },
                    {
                        "id": 120734,
                        "name": "Long Beach",
                        "latitude": "33.91045000",
                        "longitude": "-78.11777000"
                    },
                    {
                        "id": 120756,
                        "name": "Longview",
                        "latitude": "35.72930000",
                        "longitude": "-81.38342000"
                    },
                    {
                        "id": 120809,
                        "name": "Louisburg",
                        "latitude": "36.09904000",
                        "longitude": "-78.30111000"
                    },
                    {
                        "id": 120834,
                        "name": "Lowell",
                        "latitude": "35.26792000",
                        "longitude": "-81.10285000"
                    },
                    {
                        "id": 120845,
                        "name": "Lowesville",
                        "latitude": "35.41708000",
                        "longitude": "-81.01119000"
                    },
                    {
                        "id": 120859,
                        "name": "Lucama",
                        "latitude": "35.64544000",
                        "longitude": "-78.00971000"
                    },
                    {
                        "id": 120880,
                        "name": "Lumberton",
                        "latitude": "34.61834000",
                        "longitude": "-79.01045000"
                    },
                    {
                        "id": 120971,
                        "name": "Macon County",
                        "latitude": "35.15038000",
                        "longitude": "-83.42210000"
                    },
                    {
                        "id": 120990,
                        "name": "Madison",
                        "latitude": "36.38542000",
                        "longitude": "-79.95949000"
                    },
                    {
                        "id": 121010,
                        "name": "Madison County",
                        "latitude": "35.85809000",
                        "longitude": "-82.70576000"
                    },
                    {
                        "id": 121033,
                        "name": "Maggie Valley",
                        "latitude": "35.51816000",
                        "longitude": "-83.09764000"
                    },
                    {
                        "id": 121049,
                        "name": "Maiden",
                        "latitude": "35.57569000",
                        "longitude": "-81.21175000"
                    },
                    {
                        "id": 121156,
                        "name": "Manteo",
                        "latitude": "35.90823000",
                        "longitude": "-75.67573000"
                    },
                    {
                        "id": 121182,
                        "name": "Mar-Mac",
                        "latitude": "35.33488000",
                        "longitude": "-78.05582000"
                    },
                    {
                        "id": 121236,
                        "name": "Marion",
                        "latitude": "35.68401000",
                        "longitude": "-82.00927000"
                    },
                    {
                        "id": 121299,
                        "name": "Mars Hill",
                        "latitude": "35.82650000",
                        "longitude": "-82.54930000"
                    },
                    {
                        "id": 121304,
                        "name": "Marshall",
                        "latitude": "35.79733000",
                        "longitude": "-82.68403000"
                    },
                    {
                        "id": 121329,
                        "name": "Marshville",
                        "latitude": "34.98849000",
                        "longitude": "-80.36701000"
                    },
                    {
                        "id": 121340,
                        "name": "Martin County",
                        "latitude": "35.84160000",
                        "longitude": "-77.10708000"
                    },
                    {
                        "id": 121353,
                        "name": "Marvin",
                        "latitude": "34.99182000",
                        "longitude": "-80.81479000"
                    },
                    {
                        "id": 121383,
                        "name": "Masonboro",
                        "latitude": "34.17934000",
                        "longitude": "-77.84748000"
                    },
                    {
                        "id": 121412,
                        "name": "Matthews",
                        "latitude": "35.11681000",
                        "longitude": "-80.72368000"
                    },
                    {
                        "id": 121425,
                        "name": "Maury",
                        "latitude": "35.48211000",
                        "longitude": "-77.58608000"
                    },
                    {
                        "id": 121429,
                        "name": "Maxton",
                        "latitude": "34.73516000",
                        "longitude": "-79.34893000"
                    },
                    {
                        "id": 121445,
                        "name": "Mayodan",
                        "latitude": "36.41236000",
                        "longitude": "-79.96699000"
                    },
                    {
                        "id": 121451,
                        "name": "Maysville",
                        "latitude": "34.90488000",
                        "longitude": "-77.23134000"
                    },
                    {
                        "id": 121495,
                        "name": "McDowell County",
                        "latitude": "35.68124000",
                        "longitude": "-82.04870000"
                    },
                    {
                        "id": 121532,
                        "name": "McLeansville",
                        "latitude": "36.10736000",
                        "longitude": "-79.65864000"
                    },
                    {
                        "id": 121577,
                        "name": "Mebane",
                        "latitude": "36.09597000",
                        "longitude": "-79.26696000"
                    },
                    {
                        "id": 121587,
                        "name": "Mecklenburg County",
                        "latitude": "35.24671000",
                        "longitude": "-80.83276000"
                    },
                    {
                        "id": 121797,
                        "name": "Midland",
                        "latitude": "35.22737000",
                        "longitude": "-80.50062000"
                    },
                    {
                        "id": 121816,
                        "name": "Midway",
                        "latitude": "35.95347000",
                        "longitude": "-80.21810000"
                    },
                    {
                        "id": 121884,
                        "name": "Millers Creek",
                        "latitude": "36.18930000",
                        "longitude": "-81.23759000"
                    },
                    {
                        "id": 121899,
                        "name": "Mills River",
                        "latitude": "35.38845000",
                        "longitude": "-82.56679000"
                    },
                    {
                        "id": 121940,
                        "name": "Mineral Springs",
                        "latitude": "34.93793000",
                        "longitude": "-80.66868000"
                    },
                    {
                        "id": 121968,
                        "name": "Mint Hill",
                        "latitude": "35.17959000",
                        "longitude": "-80.64729000"
                    },
                    {
                        "id": 122001,
                        "name": "Mitchell County",
                        "latitude": "36.01329000",
                        "longitude": "-82.16347000"
                    },
                    {
                        "id": 122013,
                        "name": "Mocksville",
                        "latitude": "35.89403000",
                        "longitude": "-80.56145000"
                    },
                    {
                        "id": 122059,
                        "name": "Monroe",
                        "latitude": "34.98543000",
                        "longitude": "-80.54951000"
                    },
                    {
                        "id": 122148,
                        "name": "Montgomery County",
                        "latitude": "35.33246000",
                        "longitude": "-79.90547000"
                    },
                    {
                        "id": 122201,
                        "name": "Moore County",
                        "latitude": "35.31072000",
                        "longitude": "-79.48131000"
                    },
                    {
                        "id": 122210,
                        "name": "Mooresville",
                        "latitude": "35.58486000",
                        "longitude": "-80.81007000"
                    },
                    {
                        "id": 122224,
                        "name": "Moravian Falls",
                        "latitude": "36.09680000",
                        "longitude": "-81.18231000"
                    },
                    {
                        "id": 122226,
                        "name": "Morehead City",
                        "latitude": "34.72294000",
                        "longitude": "-76.72604000"
                    },
                    {
                        "id": 122250,
                        "name": "Morganton",
                        "latitude": "35.74541000",
                        "longitude": "-81.68482000"
                    },
                    {
                        "id": 122284,
                        "name": "Morrisville",
                        "latitude": "35.82348000",
                        "longitude": "-78.82556000"
                    },
                    {
                        "id": 122331,
                        "name": "Mount Airy",
                        "latitude": "36.49930000",
                        "longitude": "-80.60729000"
                    },
                    {
                        "id": 122344,
                        "name": "Mount Gilead",
                        "latitude": "35.21487000",
                        "longitude": "-80.00228000"
                    },
                    {
                        "id": 122349,
                        "name": "Mount Holly",
                        "latitude": "35.29819000",
                        "longitude": "-81.01591000"
                    },
                    {
                        "id": 122369,
                        "name": "Mount Olive",
                        "latitude": "35.19655000",
                        "longitude": "-78.06638000"
                    },
                    {
                        "id": 122374,
                        "name": "Mount Pleasant",
                        "latitude": "35.39931000",
                        "longitude": "-80.43590000"
                    },
                    {
                        "id": 122416,
                        "name": "Mountain Home",
                        "latitude": "35.36956000",
                        "longitude": "-82.49290000"
                    },
                    {
                        "id": 122430,
                        "name": "Mountain View",
                        "latitude": "35.68319000",
                        "longitude": "-81.36898000"
                    },
                    {
                        "id": 122446,
                        "name": "Moyock",
                        "latitude": "36.52460000",
                        "longitude": "-76.17827000"
                    },
                    {
                        "id": 122454,
                        "name": "Mulberry",
                        "latitude": "36.23958000",
                        "longitude": "-81.18064000"
                    },
                    {
                        "id": 122481,
                        "name": "Murfreesboro",
                        "latitude": "36.44238000",
                        "longitude": "-77.09858000"
                    },
                    {
                        "id": 122485,
                        "name": "Murphy",
                        "latitude": "35.08758000",
                        "longitude": "-84.03463000"
                    },
                    {
                        "id": 122496,
                        "name": "Murraysville",
                        "latitude": "34.29572000",
                        "longitude": "-77.84748000"
                    },
                    {
                        "id": 122523,
                        "name": "Myrtle Grove",
                        "latitude": "34.13462000",
                        "longitude": "-77.88165000"
                    },
                    {
                        "id": 122534,
                        "name": "Nags Head",
                        "latitude": "35.95739000",
                        "longitude": "-75.62406000"
                    },
                    {
                        "id": 122568,
                        "name": "Nash County",
                        "latitude": "35.96722000",
                        "longitude": "-77.98648000"
                    },
                    {
                        "id": 122576,
                        "name": "Nashville",
                        "latitude": "35.97460000",
                        "longitude": "-77.96554000"
                    },
                    {
                        "id": 122603,
                        "name": "Navassa",
                        "latitude": "34.25545000",
                        "longitude": "-78.00749000"
                    },
                    {
                        "id": 122647,
                        "name": "Neuse Forest",
                        "latitude": "34.96377000",
                        "longitude": "-76.94467000"
                    },
                    {
                        "id": 122666,
                        "name": "New Bern",
                        "latitude": "35.10849000",
                        "longitude": "-77.04411000"
                    },
                    {
                        "id": 122711,
                        "name": "New Hanover County",
                        "latitude": "34.18141000",
                        "longitude": "-77.86561000"
                    },
                    {
                        "id": 122833,
                        "name": "Newland",
                        "latitude": "36.08735000",
                        "longitude": "-81.92734000"
                    },
                    {
                        "id": 122842,
                        "name": "Newport",
                        "latitude": "34.78655000",
                        "longitude": "-76.85911000"
                    },
                    {
                        "id": 122861,
                        "name": "Newton",
                        "latitude": "35.66986000",
                        "longitude": "-81.22147000"
                    },
                    {
                        "id": 122947,
                        "name": "Norlina",
                        "latitude": "36.44570000",
                        "longitude": "-78.19833000"
                    },
                    {
                        "id": 123130,
                        "name": "North Wilkesboro",
                        "latitude": "36.15847000",
                        "longitude": "-81.14758000"
                    },
                    {
                        "id": 123136,
                        "name": "Northampton County",
                        "latitude": "36.41766000",
                        "longitude": "-77.39674000"
                    },
                    {
                        "id": 123142,
                        "name": "Northchase",
                        "latitude": "34.30782000",
                        "longitude": "-77.87749000"
                    },
                    {
                        "id": 123159,
                        "name": "Northlakes",
                        "latitude": "35.78180000",
                        "longitude": "-81.37509000"
                    },
                    {
                        "id": 123197,
                        "name": "Norwood",
                        "latitude": "35.21959000",
                        "longitude": "-80.11895000"
                    },
                    {
                        "id": 123251,
                        "name": "Oak Island",
                        "latitude": "33.91656000",
                        "longitude": "-78.16111000"
                    },
                    {
                        "id": 123261,
                        "name": "Oak Ridge",
                        "latitude": "36.17347000",
                        "longitude": "-79.98893000"
                    },
                    {
                        "id": 123267,
                        "name": "Oakboro",
                        "latitude": "35.22570000",
                        "longitude": "-80.32895000"
                    },
                    {
                        "id": 123367,
                        "name": "Ogden",
                        "latitude": "34.27239000",
                        "longitude": "-77.81859000"
                    },
                    {
                        "id": 123484,
                        "name": "Onslow County",
                        "latitude": "34.76305000",
                        "longitude": "-77.39319000"
                    },
                    {
                        "id": 123516,
                        "name": "Orange County",
                        "latitude": "36.06130000",
                        "longitude": "-79.12060000"
                    },
                    {
                        "id": 123679,
                        "name": "Oxford",
                        "latitude": "36.31070000",
                        "longitude": "-78.59083000"
                    },
                    {
                        "id": 123793,
                        "name": "Pamlico County",
                        "latitude": "35.15152000",
                        "longitude": "-76.66716000"
                    },
                    {
                        "id": 123905,
                        "name": "Pasquotank County",
                        "latitude": "36.26490000",
                        "longitude": "-76.24913000"
                    },
                    {
                        "id": 124005,
                        "name": "Pembroke",
                        "latitude": "34.68016000",
                        "longitude": "-79.19504000"
                    },
                    {
                        "id": 124015,
                        "name": "Pender County",
                        "latitude": "34.51494000",
                        "longitude": "-77.88887000"
                    },
                    {
                        "id": 124065,
                        "name": "Perquimans County",
                        "latitude": "36.17720000",
                        "longitude": "-76.40767000"
                    },
                    {
                        "id": 124092,
                        "name": "Person County",
                        "latitude": "36.39011000",
                        "longitude": "-78.97171000"
                    },
                    {
                        "id": 124200,
                        "name": "Pilot Mountain",
                        "latitude": "36.38653000",
                        "longitude": "-80.46950000"
                    },
                    {
                        "id": 124231,
                        "name": "Pine Knoll Shores",
                        "latitude": "34.69738000",
                        "longitude": "-76.81327000"
                    },
                    {
                        "id": 124236,
                        "name": "Pine Level",
                        "latitude": "35.51322000",
                        "longitude": "-78.24444000"
                    },
                    {
                        "id": 124247,
                        "name": "Pinebluff",
                        "latitude": "35.10988000",
                        "longitude": "-79.47226000"
                    },
                    {
                        "id": 124250,
                        "name": "Pinehurst",
                        "latitude": "35.19543000",
                        "longitude": "-79.46948000"
                    },
                    {
                        "id": 124258,
                        "name": "Pinetops",
                        "latitude": "35.78849000",
                        "longitude": "-77.63775000"
                    },
                    {
                        "id": 124262,
                        "name": "Pineville",
                        "latitude": "35.08320000",
                        "longitude": "-80.89230000"
                    },
                    {
                        "id": 124267,
                        "name": "Piney Green",
                        "latitude": "34.71600000",
                        "longitude": "-77.32024000"
                    },
                    {
                        "id": 124288,
                        "name": "Pitt County",
                        "latitude": "35.59352000",
                        "longitude": "-77.37465000"
                    },
                    {
                        "id": 124291,
                        "name": "Pittsboro",
                        "latitude": "35.72015000",
                        "longitude": "-79.17724000"
                    },
                    {
                        "id": 124316,
                        "name": "Plain View",
                        "latitude": "35.24850000",
                        "longitude": "-78.55529000"
                    },
                    {
                        "id": 124365,
                        "name": "Pleasant Garden",
                        "latitude": "35.96208000",
                        "longitude": "-79.76225000"
                    },
                    {
                        "id": 124369,
                        "name": "Pleasant Hill",
                        "latitude": "35.87347000",
                        "longitude": "-79.48169000"
                    },
                    {
                        "id": 124399,
                        "name": "Plymouth",
                        "latitude": "35.86683000",
                        "longitude": "-76.74856000"
                    },
                    {
                        "id": 124444,
                        "name": "Polk County",
                        "latitude": "35.27929000",
                        "longitude": "-82.16967000"
                    },
                    {
                        "id": 124452,
                        "name": "Polkton",
                        "latitude": "35.00765000",
                        "longitude": "-80.20089000"
                    },
                    {
                        "id": 124683,
                        "name": "Princeton",
                        "latitude": "35.46599000",
                        "longitude": "-78.16055000"
                    },
                    {
                        "id": 124694,
                        "name": "Princeville",
                        "latitude": "35.88960000",
                        "longitude": "-77.53219000"
                    },
                    {
                        "id": 124746,
                        "name": "Pumpkin Center",
                        "latitude": "34.79155000",
                        "longitude": "-77.37246000"
                    },
                    {
                        "id": 124819,
                        "name": "Raeford",
                        "latitude": "34.98100000",
                        "longitude": "-79.22420000"
                    },
                    {
                        "id": 124831,
                        "name": "Raleigh",
                        "latitude": "35.77210000",
                        "longitude": "-78.63861000"
                    },
                    {
                        "id": 124839,
                        "name": "Ramseur",
                        "latitude": "35.73347000",
                        "longitude": "-79.65253000"
                    },
                    {
                        "id": 124864,
                        "name": "Randleman",
                        "latitude": "35.81791000",
                        "longitude": "-79.80309000"
                    },
                    {
                        "id": 124877,
                        "name": "Randolph County",
                        "latitude": "35.71033000",
                        "longitude": "-79.80616000"
                    },
                    {
                        "id": 124886,
                        "name": "Ranlo",
                        "latitude": "35.28625000",
                        "longitude": "-81.13035000"
                    },
                    {
                        "id": 124955,
                        "name": "Red Oak",
                        "latitude": "36.03849000",
                        "longitude": "-77.90637000"
                    },
                    {
                        "id": 124961,
                        "name": "Red Springs",
                        "latitude": "34.81516000",
                        "longitude": "-79.18309000"
                    },
                    {
                        "id": 125008,
                        "name": "Reidsville",
                        "latitude": "36.35486000",
                        "longitude": "-79.66447000"
                    },
                    {
                        "id": 125047,
                        "name": "Rhodhiss",
                        "latitude": "35.77402000",
                        "longitude": "-81.43120000"
                    },
                    {
                        "id": 125081,
                        "name": "Richlands",
                        "latitude": "34.89933000",
                        "longitude": "-77.54663000"
                    },
                    {
                        "id": 125099,
                        "name": "Richmond County",
                        "latitude": "35.00594000",
                        "longitude": "-79.74783000"
                    },
                    {
                        "id": 125176,
                        "name": "River Bend",
                        "latitude": "35.06905000",
                        "longitude": "-77.14690000"
                    },
                    {
                        "id": 125186,
                        "name": "River Road",
                        "latitude": "35.50683000",
                        "longitude": "-76.99078000"
                    },
                    {
                        "id": 125232,
                        "name": "Roanoke Rapids",
                        "latitude": "36.46154000",
                        "longitude": "-77.65415000"
                    },
                    {
                        "id": 125234,
                        "name": "Robbins",
                        "latitude": "35.43403000",
                        "longitude": "-79.58697000"
                    },
                    {
                        "id": 125237,
                        "name": "Robbinsville",
                        "latitude": "35.32287000",
                        "longitude": "-83.80740000"
                    },
                    {
                        "id": 125239,
                        "name": "Robersonville",
                        "latitude": "35.82516000",
                        "longitude": "-77.24913000"
                    },
                    {
                        "id": 125249,
                        "name": "Robeson County",
                        "latitude": "34.64009000",
                        "longitude": "-79.10353000"
                    },
                    {
                        "id": 125298,
                        "name": "Rockfish",
                        "latitude": "34.99266000",
                        "longitude": "-79.06614000"
                    },
                    {
                        "id": 125303,
                        "name": "Rockingham",
                        "latitude": "34.93932000",
                        "longitude": "-79.77395000"
                    },
                    {
                        "id": 125305,
                        "name": "Rockingham County",
                        "latitude": "36.39608000",
                        "longitude": "-79.77515000"
                    },
                    {
                        "id": 125329,
                        "name": "Rockwell",
                        "latitude": "35.55125000",
                        "longitude": "-80.40645000"
                    },
                    {
                        "id": 125335,
                        "name": "Rocky Mount",
                        "latitude": "35.93821000",
                        "longitude": "-77.79053000"
                    },
                    {
                        "id": 125337,
                        "name": "Rocky Point",
                        "latitude": "34.43517000",
                        "longitude": "-77.88776000"
                    },
                    {
                        "id": 125361,
                        "name": "Rolesville",
                        "latitude": "35.92321000",
                        "longitude": "-78.45750000"
                    },
                    {
                        "id": 125404,
                        "name": "Rose Hill",
                        "latitude": "34.82822000",
                        "longitude": "-78.02304000"
                    },
                    {
                        "id": 125410,
                        "name": "Roseboro",
                        "latitude": "34.95295000",
                        "longitude": "-78.50862000"
                    },
                    {
                        "id": 125478,
                        "name": "Rowan County",
                        "latitude": "35.63954000",
                        "longitude": "-80.52464000"
                    },
                    {
                        "id": 125479,
                        "name": "Rowland",
                        "latitude": "34.53655000",
                        "longitude": "-79.29143000"
                    },
                    {
                        "id": 125484,
                        "name": "Roxboro",
                        "latitude": "36.39375000",
                        "longitude": "-78.98279000"
                    },
                    {
                        "id": 125493,
                        "name": "Royal Pines",
                        "latitude": "35.47511000",
                        "longitude": "-82.51595000"
                    },
                    {
                        "id": 125516,
                        "name": "Rural Hall",
                        "latitude": "36.24042000",
                        "longitude": "-80.29338000"
                    },
                    {
                        "id": 125551,
                        "name": "Rutherford College",
                        "latitude": "35.74846000",
                        "longitude": "-81.52259000"
                    },
                    {
                        "id": 125552,
                        "name": "Rutherford County",
                        "latitude": "35.40225000",
                        "longitude": "-81.92009000"
                    },
                    {
                        "id": 125554,
                        "name": "Rutherfordton",
                        "latitude": "35.36929000",
                        "longitude": "-81.95677000"
                    },
                    {
                        "id": 125654,
                        "name": "Saint James",
                        "latitude": "33.92934000",
                        "longitude": "-78.11638000"
                    },
                    {
                        "id": 125706,
                        "name": "Saint Pauls",
                        "latitude": "34.80655000",
                        "longitude": "-78.97114000"
                    },
                    {
                        "id": 125717,
                        "name": "Saint Stephens",
                        "latitude": "35.76458000",
                        "longitude": "-81.27314000"
                    },
                    {
                        "id": 125731,
                        "name": "Salem",
                        "latitude": "35.69874000",
                        "longitude": "-81.69704000"
                    },
                    {
                        "id": 125756,
                        "name": "Salisbury",
                        "latitude": "35.67097000",
                        "longitude": "-80.47423000"
                    },
                    {
                        "id": 125780,
                        "name": "Sampson County",
                        "latitude": "34.99163000",
                        "longitude": "-78.37152000"
                    },
                    {
                        "id": 125887,
                        "name": "Sanford",
                        "latitude": "35.47988000",
                        "longitude": "-79.18030000"
                    },
                    {
                        "id": 125981,
                        "name": "Sawmills",
                        "latitude": "35.82485000",
                        "longitude": "-81.47454000"
                    },
                    {
                        "id": 125983,
                        "name": "Saxapahaw",
                        "latitude": "35.94736000",
                        "longitude": "-79.32196000"
                    },
                    {
                        "id": 126036,
                        "name": "Scotland County",
                        "latitude": "34.84090000",
                        "longitude": "-79.48043000"
                    },
                    {
                        "id": 126038,
                        "name": "Scotland Neck",
                        "latitude": "36.12960000",
                        "longitude": "-77.42025000"
                    },
                    {
                        "id": 126058,
                        "name": "Scotts Mill",
                        "latitude": "35.72666000",
                        "longitude": "-78.88390000"
                    },
                    {
                        "id": 126070,
                        "name": "Sea Breeze",
                        "latitude": "34.06323000",
                        "longitude": "-77.89137000"
                    },
                    {
                        "id": 126087,
                        "name": "Seagate",
                        "latitude": "34.20934000",
                        "longitude": "-77.84359000"
                    },
                    {
                        "id": 126139,
                        "name": "Selma",
                        "latitude": "35.53655000",
                        "longitude": "-78.28444000"
                    },
                    {
                        "id": 126173,
                        "name": "Seven Lakes",
                        "latitude": "35.27849000",
                        "longitude": "-79.56448000"
                    },
                    {
                        "id": 126212,
                        "name": "Shallotte",
                        "latitude": "33.97323000",
                        "longitude": "-78.38584000"
                    },
                    {
                        "id": 126235,
                        "name": "Sharpsburg",
                        "latitude": "35.86710000",
                        "longitude": "-77.82915000"
                    },
                    {
                        "id": 126268,
                        "name": "Shelby",
                        "latitude": "35.29235000",
                        "longitude": "-81.53565000"
                    },
                    {
                        "id": 126339,
                        "name": "Sherrills Ford",
                        "latitude": "35.62041000",
                        "longitude": "-80.98647000"
                    },
                    {
                        "id": 126415,
                        "name": "Siler City",
                        "latitude": "35.72347000",
                        "longitude": "-79.46224000"
                    },
                    {
                        "id": 126429,
                        "name": "Silver Lake",
                        "latitude": "34.14878000",
                        "longitude": "-77.91360000"
                    },
                    {
                        "id": 126482,
                        "name": "Skippers Corner",
                        "latitude": "34.34600000",
                        "longitude": "-77.90249000"
                    },
                    {
                        "id": 126518,
                        "name": "Smithfield",
                        "latitude": "35.50849000",
                        "longitude": "-78.33945000"
                    },
                    {
                        "id": 126539,
                        "name": "Sneads Ferry",
                        "latitude": "34.55267000",
                        "longitude": "-77.39718000"
                    },
                    {
                        "id": 126546,
                        "name": "Snow Hill",
                        "latitude": "35.45155000",
                        "longitude": "-77.68109000"
                    },
                    {
                        "id": 126657,
                        "name": "South Gastonia",
                        "latitude": "35.21930000",
                        "longitude": "-81.20563000"
                    },
                    {
                        "id": 126669,
                        "name": "South Henderson",
                        "latitude": "36.30820000",
                        "longitude": "-78.40666000"
                    },
                    {
                        "id": 126719,
                        "name": "South Rosemary",
                        "latitude": "36.45154000",
                        "longitude": "-77.69720000"
                    },
                    {
                        "id": 126768,
                        "name": "Southern Pines",
                        "latitude": "35.17405000",
                        "longitude": "-79.39225000"
                    },
                    {
                        "id": 126770,
                        "name": "Southern Shores",
                        "latitude": "36.13905000",
                        "longitude": "-75.73157000"
                    },
                    {
                        "id": 126779,
                        "name": "Southmont",
                        "latitude": "35.66792000",
                        "longitude": "-80.26700000"
                    },
                    {
                        "id": 126783,
                        "name": "Southport",
                        "latitude": "33.92156000",
                        "longitude": "-78.02027000"
                    },
                    {
                        "id": 126808,
                        "name": "Sparta",
                        "latitude": "36.50541000",
                        "longitude": "-81.12092000"
                    },
                    {
                        "id": 126821,
                        "name": "Spencer",
                        "latitude": "35.69236000",
                        "longitude": "-80.43478000"
                    },
                    {
                        "id": 126835,
                        "name": "Spindale",
                        "latitude": "35.36012000",
                        "longitude": "-81.92927000"
                    },
                    {
                        "id": 126863,
                        "name": "Spring Hope",
                        "latitude": "35.94515000",
                        "longitude": "-78.11193000"
                    },
                    {
                        "id": 126865,
                        "name": "Spring Lake",
                        "latitude": "35.16794000",
                        "longitude": "-78.97281000"
                    },
                    {
                        "id": 126919,
                        "name": "Spruce Pine",
                        "latitude": "35.91540000",
                        "longitude": "-82.06456000"
                    },
                    {
                        "id": 126940,
                        "name": "Stallings",
                        "latitude": "35.09070000",
                        "longitude": "-80.68618000"
                    },
                    {
                        "id": 126951,
                        "name": "Stanfield",
                        "latitude": "35.23348000",
                        "longitude": "-80.42701000"
                    },
                    {
                        "id": 126958,
                        "name": "Stanley",
                        "latitude": "35.35903000",
                        "longitude": "-81.09702000"
                    },
                    {
                        "id": 126964,
                        "name": "Stanly County",
                        "latitude": "35.31199000",
                        "longitude": "-80.25092000"
                    },
                    {
                        "id": 126998,
                        "name": "Statesville",
                        "latitude": "35.78264000",
                        "longitude": "-80.88730000"
                    },
                    {
                        "id": 127006,
                        "name": "Stedman",
                        "latitude": "35.01350000",
                        "longitude": "-78.69391000"
                    },
                    {
                        "id": 127078,
                        "name": "Stokes County",
                        "latitude": "36.40190000",
                        "longitude": "-80.23961000"
                    },
                    {
                        "id": 127079,
                        "name": "Stokesdale",
                        "latitude": "36.23708000",
                        "longitude": "-79.97948000"
                    },
                    {
                        "id": 127090,
                        "name": "Stoneville",
                        "latitude": "36.46653000",
                        "longitude": "-79.90698000"
                    },
                    {
                        "id": 127098,
                        "name": "Stony Point",
                        "latitude": "35.86347000",
                        "longitude": "-81.04730000"
                    },
                    {
                        "id": 127202,
                        "name": "Summerfield",
                        "latitude": "36.20875000",
                        "longitude": "-79.90476000"
                    },
                    {
                        "id": 127274,
                        "name": "Sunset Beach",
                        "latitude": "33.88073000",
                        "longitude": "-78.51223000"
                    },
                    {
                        "id": 127285,
                        "name": "Surf City",
                        "latitude": "34.42711000",
                        "longitude": "-77.54608000"
                    },
                    {
                        "id": 127294,
                        "name": "Surry County",
                        "latitude": "36.41468000",
                        "longitude": "-80.68749000"
                    },
                    {
                        "id": 127319,
                        "name": "Swain County",
                        "latitude": "35.48673000",
                        "longitude": "-83.49274000"
                    },
                    {
                        "id": 127322,
                        "name": "Swannanoa",
                        "latitude": "35.59789000",
                        "longitude": "-82.39984000"
                    },
                    {
                        "id": 127323,
                        "name": "Swanquarter",
                        "latitude": "35.40628000",
                        "longitude": "-76.32909000"
                    },
                    {
                        "id": 127324,
                        "name": "Swansboro",
                        "latitude": "34.68766000",
                        "longitude": "-77.11912000"
                    },
                    {
                        "id": 127344,
                        "name": "Swepsonville",
                        "latitude": "36.02125000",
                        "longitude": "-79.36141000"
                    },
                    {
                        "id": 127355,
                        "name": "Sylva",
                        "latitude": "35.37371000",
                        "longitude": "-83.22598000"
                    },
                    {
                        "id": 127368,
                        "name": "Tabor City",
                        "latitude": "34.14878000",
                        "longitude": "-78.87669000"
                    },
                    {
                        "id": 127428,
                        "name": "Tarboro",
                        "latitude": "35.89682000",
                        "longitude": "-77.53580000"
                    },
                    {
                        "id": 127465,
                        "name": "Taylorsville",
                        "latitude": "35.92180000",
                        "longitude": "-81.17647000"
                    },
                    {
                        "id": 127589,
                        "name": "Thomasville",
                        "latitude": "35.88264000",
                        "longitude": "-80.08199000"
                    },
                    {
                        "id": 127628,
                        "name": "Thurmond",
                        "latitude": "36.36652000",
                        "longitude": "-80.92841000"
                    },
                    {
                        "id": 127689,
                        "name": "Toast",
                        "latitude": "36.50041000",
                        "longitude": "-80.62645000"
                    },
                    {
                        "id": 127690,
                        "name": "Tobaccoville",
                        "latitude": "36.23819000",
                        "longitude": "-80.37144000"
                    },
                    {
                        "id": 127780,
                        "name": "Transylvania County",
                        "latitude": "35.20215000",
                        "longitude": "-82.79830000"
                    },
                    {
                        "id": 127800,
                        "name": "Trent Woods",
                        "latitude": "35.08210000",
                        "longitude": "-77.08634000"
                    },
                    {
                        "id": 127804,
                        "name": "Trenton",
                        "latitude": "35.06710000",
                        "longitude": "-77.35274000"
                    },
                    {
                        "id": 127826,
                        "name": "Trinity",
                        "latitude": "35.89458000",
                        "longitude": "-79.99087000"
                    },
                    {
                        "id": 127839,
                        "name": "Troutman",
                        "latitude": "35.70069000",
                        "longitude": "-80.88813000"
                    },
                    {
                        "id": 127845,
                        "name": "Troy",
                        "latitude": "35.35847000",
                        "longitude": "-79.89449000"
                    },
                    {
                        "id": 127862,
                        "name": "Tryon",
                        "latitude": "35.33986000",
                        "longitude": "-81.32203000"
                    },
                    {
                        "id": 127948,
                        "name": "Tyro",
                        "latitude": "35.80903000",
                        "longitude": "-80.37283000"
                    },
                    {
                        "id": 127951,
                        "name": "Tyrrell County",
                        "latitude": "35.87018000",
                        "longitude": "-76.17005000"
                    },
                    {
                        "id": 127995,
                        "name": "Union County",
                        "latitude": "34.98837000",
                        "longitude": "-80.53073000"
                    },
                    {
                        "id": 128018,
                        "name": "Unionville",
                        "latitude": "35.08737000",
                        "longitude": "-80.50896000"
                    },
                    {
                        "id": 128082,
                        "name": "Valdese",
                        "latitude": "35.74069000",
                        "longitude": "-81.56315000"
                    },
                    {
                        "id": 128112,
                        "name": "Valley Hill",
                        "latitude": "35.29845000",
                        "longitude": "-82.48318000"
                    },
                    {
                        "id": 128141,
                        "name": "Vance County",
                        "latitude": "36.36476000",
                        "longitude": "-78.40833000"
                    },
                    {
                        "id": 128149,
                        "name": "Vander",
                        "latitude": "35.03211000",
                        "longitude": "-78.79474000"
                    },
                    {
                        "id": 128323,
                        "name": "Wadesboro",
                        "latitude": "34.96821000",
                        "longitude": "-80.07673000"
                    },
                    {
                        "id": 128356,
                        "name": "Wake County",
                        "latitude": "35.79012000",
                        "longitude": "-78.65022000"
                    },
                    {
                        "id": 128357,
                        "name": "Wake Forest",
                        "latitude": "35.97987000",
                        "longitude": "-78.50972000"
                    },
                    {
                        "id": 128392,
                        "name": "Walkertown",
                        "latitude": "36.17541000",
                        "longitude": "-80.15310000"
                    },
                    {
                        "id": 128397,
                        "name": "Wallace",
                        "latitude": "34.73572000",
                        "longitude": "-77.99526000"
                    },
                    {
                        "id": 128400,
                        "name": "Wallburg",
                        "latitude": "36.01014000",
                        "longitude": "-80.13921000"
                    },
                    {
                        "id": 128415,
                        "name": "Walnut Cove",
                        "latitude": "36.29541000",
                        "longitude": "-80.14171000"
                    },
                    {
                        "id": 128451,
                        "name": "Wanchese",
                        "latitude": "35.84267000",
                        "longitude": "-75.63851000"
                    },
                    {
                        "id": 128490,
                        "name": "Warren County",
                        "latitude": "36.39659000",
                        "longitude": "-78.10690000"
                    },
                    {
                        "id": 128506,
                        "name": "Warrenton",
                        "latitude": "36.39848000",
                        "longitude": "-78.15527000"
                    },
                    {
                        "id": 128516,
                        "name": "Warsaw",
                        "latitude": "34.99933000",
                        "longitude": "-78.09110000"
                    },
                    {
                        "id": 128541,
                        "name": "Washington",
                        "latitude": "35.54655000",
                        "longitude": "-77.05217000"
                    },
                    {
                        "id": 128563,
                        "name": "Washington County",
                        "latitude": "35.83887000",
                        "longitude": "-76.56868000"
                    },
                    {
                        "id": 128596,
                        "name": "Watauga County",
                        "latitude": "36.23110000",
                        "longitude": "-81.69637000"
                    },
                    {
                        "id": 128675,
                        "name": "Waxhaw",
                        "latitude": "34.92459000",
                        "longitude": "-80.74340000"
                    },
                    {
                        "id": 128695,
                        "name": "Wayne County",
                        "latitude": "35.36378000",
                        "longitude": "-78.00415000"
                    },
                    {
                        "id": 128711,
                        "name": "Waynesville",
                        "latitude": "35.48871000",
                        "longitude": "-82.98875000"
                    },
                    {
                        "id": 128722,
                        "name": "Weaverville",
                        "latitude": "35.69705000",
                        "longitude": "-82.56069000"
                    },
                    {
                        "id": 128746,
                        "name": "Weddington",
                        "latitude": "35.02237000",
                        "longitude": "-80.76090000"
                    },
                    {
                        "id": 128766,
                        "name": "Welcome",
                        "latitude": "35.90292000",
                        "longitude": "-80.25699000"
                    },
                    {
                        "id": 128769,
                        "name": "Weldon",
                        "latitude": "36.42710000",
                        "longitude": "-77.59553000"
                    },
                    {
                        "id": 128798,
                        "name": "Wendell",
                        "latitude": "35.78099000",
                        "longitude": "-78.36972000"
                    },
                    {
                        "id": 128804,
                        "name": "Wentworth",
                        "latitude": "36.40014000",
                        "longitude": "-79.77448000"
                    },
                    {
                        "id": 128810,
                        "name": "Wesley Chapel",
                        "latitude": "35.00709000",
                        "longitude": "-80.67451000"
                    },
                    {
                        "id": 128839,
                        "name": "West Canton",
                        "latitude": "35.53788000",
                        "longitude": "-82.85819000"
                    },
                    {
                        "id": 128904,
                        "name": "West Jefferson",
                        "latitude": "36.40374000",
                        "longitude": "-81.49288000"
                    },
                    {
                        "id": 128925,
                        "name": "West Marion",
                        "latitude": "35.65790000",
                        "longitude": "-82.02539000"
                    },
                    {
                        "id": 128965,
                        "name": "West Raleigh",
                        "latitude": "35.78682000",
                        "longitude": "-78.66389000"
                    },
                    {
                        "id": 129071,
                        "name": "Westport",
                        "latitude": "35.50125000",
                        "longitude": "-80.97869000"
                    },
                    {
                        "id": 129124,
                        "name": "Whispering Pines",
                        "latitude": "35.25571000",
                        "longitude": "-79.37225000"
                    },
                    {
                        "id": 129154,
                        "name": "White Plains",
                        "latitude": "36.44569000",
                        "longitude": "-80.63340000"
                    },
                    {
                        "id": 129189,
                        "name": "Whiteville",
                        "latitude": "34.33878000",
                        "longitude": "-78.70307000"
                    },
                    {
                        "id": 129245,
                        "name": "Wilkes County",
                        "latitude": "36.20621000",
                        "longitude": "-81.16292000"
                    },
                    {
                        "id": 129247,
                        "name": "Wilkesboro",
                        "latitude": "36.14596000",
                        "longitude": "-81.16064000"
                    },
                    {
                        "id": 129282,
                        "name": "Williamston",
                        "latitude": "35.85460000",
                        "longitude": "-77.05551000"
                    },
                    {
                        "id": 129322,
                        "name": "Wilmington",
                        "latitude": "34.22573000",
                        "longitude": "-77.94471000"
                    },
                    {
                        "id": 129329,
                        "name": "Wilson",
                        "latitude": "35.72127000",
                        "longitude": "-77.91554000"
                    },
                    {
                        "id": 129335,
                        "name": "Wilson County",
                        "latitude": "35.70503000",
                        "longitude": "-77.91862000"
                    },
                    {
                        "id": 129339,
                        "name": "Wilsons Mills",
                        "latitude": "35.58405000",
                        "longitude": "-78.35583000"
                    },
                    {
                        "id": 129378,
                        "name": "Windsor",
                        "latitude": "35.99849000",
                        "longitude": "-76.94606000"
                    },
                    {
                        "id": 129400,
                        "name": "Wingate",
                        "latitude": "34.98432000",
                        "longitude": "-80.44923000"
                    },
                    {
                        "id": 129436,
                        "name": "Winston-Salem",
                        "latitude": "36.09986000",
                        "longitude": "-80.24422000"
                    },
                    {
                        "id": 129448,
                        "name": "Winterville",
                        "latitude": "35.52905000",
                        "longitude": "-77.40108000"
                    },
                    {
                        "id": 129453,
                        "name": "Winton",
                        "latitude": "36.39571000",
                        "longitude": "-76.93190000"
                    },
                    {
                        "id": 129518,
                        "name": "Woodfin",
                        "latitude": "35.63344000",
                        "longitude": "-82.58207000"
                    },
                    {
                        "id": 129611,
                        "name": "Wrightsboro",
                        "latitude": "34.28850000",
                        "longitude": "-77.92110000"
                    },
                    {
                        "id": 129616,
                        "name": "Wrightsville Beach",
                        "latitude": "34.20850000",
                        "longitude": "-77.79637000"
                    },
                    {
                        "id": 129648,
                        "name": "Yadkin County",
                        "latitude": "36.16054000",
                        "longitude": "-80.66534000"
                    },
                    {
                        "id": 129649,
                        "name": "Yadkinville",
                        "latitude": "36.13458000",
                        "longitude": "-80.65951000"
                    },
                    {
                        "id": 129659,
                        "name": "Yancey County",
                        "latitude": "35.89888000",
                        "longitude": "-82.30755000"
                    },
                    {
                        "id": 129660,
                        "name": "Yanceyville",
                        "latitude": "36.40403000",
                        "longitude": "-79.33613000"
                    },
                    {
                        "id": 129719,
                        "name": "Youngsville",
                        "latitude": "36.02487000",
                        "longitude": "-78.47444000"
                    },
                    {
                        "id": 129743,
                        "name": "Zebulon",
                        "latitude": "35.82432000",
                        "longitude": "-78.31472000"
                    }
                ]
            },
            {
                "id": 1418,
                "name": "North Dakota",
                "iso2": "ND",
                "latitude": "47.55149260",
                "longitude": "-101.00201190",
                "type": "state",
                "cities": [
                    {
                        "id": 111026,
                        "name": "Adams County",
                        "latitude": "46.09684000",
                        "longitude": "-102.52853000"
                    },
                    {
                        "id": 111287,
                        "name": "Amidon",
                        "latitude": "46.48223000",
                        "longitude": "-103.32185000"
                    },
                    {
                        "id": 111543,
                        "name": "Ashley",
                        "latitude": "46.03414000",
                        "longitude": "-99.37150000"
                    },
                    {
                        "id": 111826,
                        "name": "Barnes County",
                        "latitude": "46.93611000",
                        "longitude": "-98.07158000"
                    },
                    {
                        "id": 111962,
                        "name": "Beach",
                        "latitude": "46.91807000",
                        "longitude": "-104.00437000"
                    },
                    {
                        "id": 112052,
                        "name": "Belcourt",
                        "latitude": "48.83917000",
                        "longitude": "-99.74487000"
                    },
                    {
                        "id": 112058,
                        "name": "Belfield",
                        "latitude": "46.88529000",
                        "longitude": "-103.19962000"
                    },
                    {
                        "id": 112186,
                        "name": "Benson County",
                        "latitude": "48.06939000",
                        "longitude": "-99.36603000"
                    },
                    {
                        "id": 112296,
                        "name": "Beulah",
                        "latitude": "47.26334000",
                        "longitude": "-101.77795000"
                    },
                    {
                        "id": 112345,
                        "name": "Billings County",
                        "latitude": "47.02345000",
                        "longitude": "-103.37643000"
                    },
                    {
                        "id": 112367,
                        "name": "Bismarck",
                        "latitude": "46.80833000",
                        "longitude": "-100.78374000"
                    },
                    {
                        "id": 112598,
                        "name": "Bottineau",
                        "latitude": "48.82723000",
                        "longitude": "-100.44570000"
                    },
                    {
                        "id": 112599,
                        "name": "Bottineau County",
                        "latitude": "48.79216000",
                        "longitude": "-100.83333000"
                    },
                    {
                        "id": 112621,
                        "name": "Bowbells",
                        "latitude": "48.80308000",
                        "longitude": "-102.24600000"
                    },
                    {
                        "id": 112632,
                        "name": "Bowman",
                        "latitude": "46.18306000",
                        "longitude": "-103.39491000"
                    },
                    {
                        "id": 112633,
                        "name": "Bowman County",
                        "latitude": "46.11261000",
                        "longitude": "-103.52067000"
                    },
                    {
                        "id": 113058,
                        "name": "Burke County",
                        "latitude": "48.79100000",
                        "longitude": "-102.51826000"
                    },
                    {
                        "id": 113060,
                        "name": "Burleigh County",
                        "latitude": "46.97739000",
                        "longitude": "-100.46873000"
                    },
                    {
                        "id": 113075,
                        "name": "Burlington",
                        "latitude": "48.27529000",
                        "longitude": "-101.42878000"
                    },
                    {
                        "id": 113326,
                        "name": "Cando",
                        "latitude": "48.48667000",
                        "longitude": "-99.20986000"
                    },
                    {
                        "id": 113446,
                        "name": "Carrington",
                        "latitude": "47.44972000",
                        "longitude": "-99.12622000"
                    },
                    {
                        "id": 113475,
                        "name": "Carson",
                        "latitude": "46.41778000",
                        "longitude": "-101.56487000"
                    },
                    {
                        "id": 113533,
                        "name": "Cass County",
                        "latitude": "46.93297000",
                        "longitude": "-97.24804000"
                    },
                    {
                        "id": 113536,
                        "name": "Casselton",
                        "latitude": "46.90053000",
                        "longitude": "-97.21120000"
                    },
                    {
                        "id": 113581,
                        "name": "Cavalier",
                        "latitude": "48.79388000",
                        "longitude": "-97.62231000"
                    },
                    {
                        "id": 113582,
                        "name": "Cavalier County",
                        "latitude": "48.77230000",
                        "longitude": "-98.46486000"
                    },
                    {
                        "id": 113639,
                        "name": "Center",
                        "latitude": "47.11638000",
                        "longitude": "-101.29959000"
                    },
                    {
                        "id": 114606,
                        "name": "Cooperstown",
                        "latitude": "47.44444000",
                        "longitude": "-98.12398000"
                    },
                    {
                        "id": 114844,
                        "name": "Crosby",
                        "latitude": "48.91420000",
                        "longitude": "-103.29491000"
                    },
                    {
                        "id": 115298,
                        "name": "Devils Lake",
                        "latitude": "48.11278000",
                        "longitude": "-98.86512000"
                    },
                    {
                        "id": 115323,
                        "name": "Dickey County",
                        "latitude": "46.11012000",
                        "longitude": "-98.50467000"
                    },
                    {
                        "id": 115326,
                        "name": "Dickinson",
                        "latitude": "46.87918000",
                        "longitude": "-102.78962000"
                    },
                    {
                        "id": 115357,
                        "name": "Divide County",
                        "latitude": "48.81489000",
                        "longitude": "-103.48735000"
                    },
                    {
                        "id": 115548,
                        "name": "Dunn County",
                        "latitude": "47.35675000",
                        "longitude": "-102.61824000"
                    },
                    {
                        "id": 115823,
                        "name": "Eddy County",
                        "latitude": "47.71759000",
                        "longitude": "-98.90158000"
                    },
                    {
                        "id": 116017,
                        "name": "Ellendale",
                        "latitude": "46.00275000",
                        "longitude": "-98.52705000"
                    },
                    {
                        "id": 116107,
                        "name": "Emmons County",
                        "latitude": "46.28502000",
                        "longitude": "-100.23878000"
                    },
                    {
                        "id": 116396,
                        "name": "Fargo",
                        "latitude": "46.87719000",
                        "longitude": "-96.78980000"
                    },
                    {
                        "id": 116501,
                        "name": "Fessenden",
                        "latitude": "47.64917000",
                        "longitude": "-99.62929000"
                    },
                    {
                        "id": 116516,
                        "name": "Finley",
                        "latitude": "47.51416000",
                        "longitude": "-97.83593000"
                    },
                    {
                        "id": 116676,
                        "name": "Forman",
                        "latitude": "46.10774000",
                        "longitude": "-97.63649000"
                    },
                    {
                        "id": 116756,
                        "name": "Fort Totten",
                        "latitude": "47.98000000",
                        "longitude": "-98.99290000"
                    },
                    {
                        "id": 116766,
                        "name": "Fort Yates",
                        "latitude": "46.08694000",
                        "longitude": "-100.63013000"
                    },
                    {
                        "id": 116777,
                        "name": "Foster County",
                        "latitude": "47.45708000",
                        "longitude": "-98.88302000"
                    },
                    {
                        "id": 117103,
                        "name": "Garrison",
                        "latitude": "47.65222000",
                        "longitude": "-101.41572000"
                    },
                    {
                        "id": 117359,
                        "name": "Golden Valley County",
                        "latitude": "46.94022000",
                        "longitude": "-103.84670000"
                    },
                    {
                        "id": 117431,
                        "name": "Grafton",
                        "latitude": "48.41221000",
                        "longitude": "-97.41063000"
                    },
                    {
                        "id": 117457,
                        "name": "Grand Forks",
                        "latitude": "47.92526000",
                        "longitude": "-97.03285000"
                    },
                    {
                        "id": 117458,
                        "name": "Grand Forks Air Force Base",
                        "latitude": "47.95493000",
                        "longitude": "-97.38664000"
                    },
                    {
                        "id": 117459,
                        "name": "Grand Forks County",
                        "latitude": "47.92192000",
                        "longitude": "-97.45693000"
                    },
                    {
                        "id": 117518,
                        "name": "Grant County",
                        "latitude": "46.35828000",
                        "longitude": "-101.63971000"
                    },
                    {
                        "id": 117734,
                        "name": "Griggs County",
                        "latitude": "47.45729000",
                        "longitude": "-98.23704000"
                    },
                    {
                        "id": 118114,
                        "name": "Harvey",
                        "latitude": "47.76972000",
                        "longitude": "-99.93540000"
                    },
                    {
                        "id": 118210,
                        "name": "Hazen",
                        "latitude": "47.29445000",
                        "longitude": "-101.62266000"
                    },
                    {
                        "id": 118346,
                        "name": "Hettinger",
                        "latitude": "46.00139000",
                        "longitude": "-102.63682000"
                    },
                    {
                        "id": 118347,
                        "name": "Hettinger County",
                        "latitude": "46.43253000",
                        "longitude": "-102.46036000"
                    },
                    {
                        "id": 118450,
                        "name": "Hillsboro",
                        "latitude": "47.40387000",
                        "longitude": "-97.06203000"
                    },
                    {
                        "id": 118661,
                        "name": "Horace",
                        "latitude": "46.75886000",
                        "longitude": "-96.90370000"
                    },
                    {
                        "id": 119123,
                        "name": "Jamestown",
                        "latitude": "46.91054000",
                        "longitude": "-98.70844000"
                    },
                    {
                        "id": 119461,
                        "name": "Kenmare",
                        "latitude": "48.67475000",
                        "longitude": "-102.08266000"
                    },
                    {
                        "id": 119552,
                        "name": "Kidder County",
                        "latitude": "46.98014000",
                        "longitude": "-99.78009000"
                    },
                    {
                        "id": 119558,
                        "name": "Killdeer",
                        "latitude": "47.37196000",
                        "longitude": "-102.75408000"
                    },
                    {
                        "id": 120057,
                        "name": "Lakota",
                        "latitude": "48.04278000",
                        "longitude": "-98.33621000"
                    },
                    {
                        "id": 119803,
                        "name": "LaMoure County",
                        "latitude": "46.45691000",
                        "longitude": "-98.53546000"
                    },
                    {
                        "id": 120109,
                        "name": "Langdon",
                        "latitude": "48.76000000",
                        "longitude": "-98.36817000"
                    },
                    {
                        "id": 120146,
                        "name": "Larimore",
                        "latitude": "47.90666000",
                        "longitude": "-97.62675000"
                    },
                    {
                        "id": 120510,
                        "name": "Lincoln",
                        "latitude": "46.76249000",
                        "longitude": "-100.70040000"
                    },
                    {
                        "id": 120590,
                        "name": "Linton",
                        "latitude": "46.26666000",
                        "longitude": "-100.23289000"
                    },
                    {
                        "id": 120600,
                        "name": "Lisbon",
                        "latitude": "46.44163000",
                        "longitude": "-97.68121000"
                    },
                    {
                        "id": 120701,
                        "name": "Logan County",
                        "latitude": "46.45736000",
                        "longitude": "-99.47747000"
                    },
                    {
                        "id": 121106,
                        "name": "Mandan",
                        "latitude": "46.82666000",
                        "longitude": "-100.88958000"
                    },
                    {
                        "id": 121136,
                        "name": "Manning",
                        "latitude": "47.23001000",
                        "longitude": "-102.77019000"
                    },
                    {
                        "id": 121454,
                        "name": "Mayville",
                        "latitude": "47.49804000",
                        "longitude": "-97.32454000"
                    },
                    {
                        "id": 121472,
                        "name": "McClusky",
                        "latitude": "47.48583000",
                        "longitude": "-100.44318000"
                    },
                    {
                        "id": 121510,
                        "name": "McHenry County",
                        "latitude": "48.23458000",
                        "longitude": "-100.63628000"
                    },
                    {
                        "id": 121515,
                        "name": "McIntosh County",
                        "latitude": "46.11179000",
                        "longitude": "-99.44120000"
                    },
                    {
                        "id": 121521,
                        "name": "McKenzie County",
                        "latitude": "47.74015000",
                        "longitude": "-103.39527000"
                    },
                    {
                        "id": 121530,
                        "name": "McLean County",
                        "latitude": "47.60696000",
                        "longitude": "-101.32183000"
                    },
                    {
                        "id": 121608,
                        "name": "Medora",
                        "latitude": "46.91390000",
                        "longitude": "-103.52435000"
                    },
                    {
                        "id": 121681,
                        "name": "Mercer County",
                        "latitude": "47.30922000",
                        "longitude": "-101.83153000"
                    },
                    {
                        "id": 121959,
                        "name": "Minnewaukan",
                        "latitude": "48.07139000",
                        "longitude": "-99.25236000"
                    },
                    {
                        "id": 121966,
                        "name": "Minot",
                        "latitude": "48.23251000",
                        "longitude": "-101.29627000"
                    },
                    {
                        "id": 121967,
                        "name": "Minot Air Force Base",
                        "latitude": "48.42087000",
                        "longitude": "-101.33914000"
                    },
                    {
                        "id": 122018,
                        "name": "Mohall",
                        "latitude": "48.76336000",
                        "longitude": "-101.51322000"
                    },
                    {
                        "id": 122297,
                        "name": "Morton County",
                        "latitude": "46.71606000",
                        "longitude": "-101.28117000"
                    },
                    {
                        "id": 122312,
                        "name": "Mott",
                        "latitude": "46.37250000",
                        "longitude": "-102.32711000"
                    },
                    {
                        "id": 122440,
                        "name": "Mountrail County",
                        "latitude": "48.20133000",
                        "longitude": "-102.35565000"
                    },
                    {
                        "id": 122559,
                        "name": "Napoleon",
                        "latitude": "46.50831000",
                        "longitude": "-99.77122000"
                    },
                    {
                        "id": 122628,
                        "name": "Nelson County",
                        "latitude": "47.92169000",
                        "longitude": "-98.19204000"
                    },
                    {
                        "id": 122774,
                        "name": "New Rockford",
                        "latitude": "47.68000000",
                        "longitude": "-99.13790000"
                    },
                    {
                        "id": 122787,
                        "name": "New Town",
                        "latitude": "47.98085000",
                        "longitude": "-102.49018000"
                    },
                    {
                        "id": 123275,
                        "name": "Oakes",
                        "latitude": "46.13858000",
                        "longitude": "-98.09038000"
                    },
                    {
                        "id": 123443,
                        "name": "Oliver County",
                        "latitude": "47.11528000",
                        "longitude": "-101.34036000"
                    },
                    {
                        "id": 123853,
                        "name": "Park River",
                        "latitude": "48.39860000",
                        "longitude": "-97.74120000"
                    },
                    {
                        "id": 123889,
                        "name": "Parshall",
                        "latitude": "47.95335000",
                        "longitude": "-102.13489000"
                    },
                    {
                        "id": 124003,
                        "name": "Pembina County",
                        "latitude": "48.76752000",
                        "longitude": "-97.55183000"
                    },
                    {
                        "id": 124174,
                        "name": "Pierce County",
                        "latitude": "48.24960000",
                        "longitude": "-99.97182000"
                    },
                    {
                        "id": 124844,
                        "name": "Ramsey County",
                        "latitude": "48.26893000",
                        "longitude": "-98.72014000"
                    },
                    {
                        "id": 124888,
                        "name": "Ransom County",
                        "latitude": "46.45616000",
                        "longitude": "-97.65745000"
                    },
                    {
                        "id": 125029,
                        "name": "Renville County",
                        "latitude": "48.71907000",
                        "longitude": "-101.65778000"
                    },
                    {
                        "id": 125076,
                        "name": "Richland County",
                        "latitude": "46.26466000",
                        "longitude": "-96.94828000"
                    },
                    {
                        "id": 125362,
                        "name": "Rolette County",
                        "latitude": "48.77245000",
                        "longitude": "-99.84099000"
                    },
                    {
                        "id": 125364,
                        "name": "Rolla",
                        "latitude": "48.85778000",
                        "longitude": "-99.61792000"
                    },
                    {
                        "id": 125503,
                        "name": "Rugby",
                        "latitude": "48.36889000",
                        "longitude": "-99.99625000"
                    },
                    {
                        "id": 125950,
                        "name": "Sargent County",
                        "latitude": "46.10794000",
                        "longitude": "-97.63072000"
                    },
                    {
                        "id": 126288,
                        "name": "Sheldon",
                        "latitude": "46.58580000",
                        "longitude": "-97.49120000"
                    },
                    {
                        "id": 126293,
                        "name": "Shell Valley",
                        "latitude": "48.79806000",
                        "longitude": "-99.86486000"
                    },
                    {
                        "id": 126326,
                        "name": "Sheridan County",
                        "latitude": "47.57541000",
                        "longitude": "-100.34566000"
                    },
                    {
                        "id": 126460,
                        "name": "Sioux County",
                        "latitude": "46.11265000",
                        "longitude": "-101.04034000"
                    },
                    {
                        "id": 126507,
                        "name": "Slope County",
                        "latitude": "46.44722000",
                        "longitude": "-103.45990000"
                    },
                    {
                        "id": 126961,
                        "name": "Stanley",
                        "latitude": "48.31724000",
                        "longitude": "-102.39045000"
                    },
                    {
                        "id": 126970,
                        "name": "Stanton",
                        "latitude": "47.32111000",
                        "longitude": "-101.38155000"
                    },
                    {
                        "id": 126985,
                        "name": "Stark County",
                        "latitude": "46.81068000",
                        "longitude": "-102.65513000"
                    },
                    {
                        "id": 127009,
                        "name": "Steele",
                        "latitude": "46.85471000",
                        "longitude": "-99.91594000"
                    },
                    {
                        "id": 127011,
                        "name": "Steele County",
                        "latitude": "47.45615000",
                        "longitude": "-97.72467000"
                    },
                    {
                        "id": 127154,
                        "name": "Stutsman County",
                        "latitude": "46.97925000",
                        "longitude": "-98.95883000"
                    },
                    {
                        "id": 127291,
                        "name": "Surrey",
                        "latitude": "48.23640000",
                        "longitude": "-101.13349000"
                    },
                    {
                        "id": 127591,
                        "name": "Thompson",
                        "latitude": "47.77359000",
                        "longitude": "-97.10980000"
                    },
                    {
                        "id": 127668,
                        "name": "Tioga",
                        "latitude": "48.39724000",
                        "longitude": "-102.93824000"
                    },
                    {
                        "id": 127761,
                        "name": "Towner",
                        "latitude": "48.34583000",
                        "longitude": "-100.40541000"
                    },
                    {
                        "id": 127762,
                        "name": "Towner County",
                        "latitude": "48.68554000",
                        "longitude": "-99.24580000"
                    },
                    {
                        "id": 127778,
                        "name": "Traill County",
                        "latitude": "47.45418000",
                        "longitude": "-97.16158000"
                    },
                    {
                        "id": 128101,
                        "name": "Valley City",
                        "latitude": "46.92331000",
                        "longitude": "-98.00315000"
                    },
                    {
                        "id": 128165,
                        "name": "Velva",
                        "latitude": "48.05612000",
                        "longitude": "-100.92932000"
                    },
                    {
                        "id": 128335,
                        "name": "Wahpeton",
                        "latitude": "46.26524000",
                        "longitude": "-96.60591000"
                    },
                    {
                        "id": 128427,
                        "name": "Walsh County",
                        "latitude": "48.36946000",
                        "longitude": "-97.72137000"
                    },
                    {
                        "id": 128459,
                        "name": "Ward County",
                        "latitude": "48.22175000",
                        "longitude": "-101.54183000"
                    },
                    {
                        "id": 128535,
                        "name": "Washburn",
                        "latitude": "47.28916000",
                        "longitude": "-101.02903000"
                    },
                    {
                        "id": 128632,
                        "name": "Watford City",
                        "latitude": "47.80224000",
                        "longitude": "-103.28325000"
                    },
                    {
                        "id": 128787,
                        "name": "Wells County",
                        "latitude": "47.58753000",
                        "longitude": "-99.66095000"
                    },
                    {
                        "id": 128869,
                        "name": "West Fargo",
                        "latitude": "46.87497000",
                        "longitude": "-96.90036000"
                    },
                    {
                        "id": 129264,
                        "name": "Williams County",
                        "latitude": "48.34368000",
                        "longitude": "-103.48021000"
                    },
                    {
                        "id": 129299,
                        "name": "Williston",
                        "latitude": "48.14697000",
                        "longitude": "-103.61797000"
                    }
                ]
            },
            {
                "id": 1431,
                "name": "Northern Mariana Islands",
                "iso2": "MP",
                "latitude": "15.09790000",
                "longitude": "145.67390000",
                "type": "outlying area",
                "cities": []
            },
            {
                "id": 4851,
                "name": "Ohio",
                "iso2": "OH",
                "latitude": "40.41728710",
                "longitude": "-82.90712300",
                "type": "state",
                "cities": [
                    {
                        "id": 141096,
                        "name": "Ada",
                        "latitude": "40.76950000",
                        "longitude": "-83.82271000"
                    },
                    {
                        "id": 141097,
                        "name": "Adams County",
                        "latitude": "38.84551000",
                        "longitude": "-83.47215000"
                    },
                    {
                        "id": 141098,
                        "name": "Akron",
                        "latitude": "41.08144000",
                        "longitude": "-81.51901000"
                    },
                    {
                        "id": 141099,
                        "name": "Allen County",
                        "latitude": "40.77152000",
                        "longitude": "-84.10578000"
                    },
                    {
                        "id": 141100,
                        "name": "Alliance",
                        "latitude": "40.91534000",
                        "longitude": "-81.10593000"
                    },
                    {
                        "id": 141101,
                        "name": "Amberley",
                        "latitude": "39.20478000",
                        "longitude": "-84.42800000"
                    },
                    {
                        "id": 141102,
                        "name": "Amelia",
                        "latitude": "39.02840000",
                        "longitude": "-84.21771000"
                    },
                    {
                        "id": 141103,
                        "name": "Amherst",
                        "latitude": "41.39782000",
                        "longitude": "-82.22238000"
                    },
                    {
                        "id": 141104,
                        "name": "Andover",
                        "latitude": "41.60672000",
                        "longitude": "-80.57230000"
                    },
                    {
                        "id": 141105,
                        "name": "Anna",
                        "latitude": "40.39449000",
                        "longitude": "-84.17272000"
                    },
                    {
                        "id": 141106,
                        "name": "Ansonia",
                        "latitude": "40.21449000",
                        "longitude": "-84.63690000"
                    },
                    {
                        "id": 141107,
                        "name": "Antwerp",
                        "latitude": "41.18144000",
                        "longitude": "-84.74051000"
                    },
                    {
                        "id": 141108,
                        "name": "Apple Creek",
                        "latitude": "40.75172000",
                        "longitude": "-81.83930000"
                    },
                    {
                        "id": 141109,
                        "name": "Apple Valley",
                        "latitude": "40.43890000",
                        "longitude": "-82.35391000"
                    },
                    {
                        "id": 141110,
                        "name": "Arcanum",
                        "latitude": "39.99005000",
                        "longitude": "-84.55329000"
                    },
                    {
                        "id": 141111,
                        "name": "Archbold",
                        "latitude": "41.52144000",
                        "longitude": "-84.30717000"
                    },
                    {
                        "id": 141112,
                        "name": "Arlington",
                        "latitude": "40.89366000",
                        "longitude": "-83.65021000"
                    },
                    {
                        "id": 141113,
                        "name": "Ashland",
                        "latitude": "40.86867000",
                        "longitude": "-82.31822000"
                    },
                    {
                        "id": 141114,
                        "name": "Ashland County",
                        "latitude": "40.84602000",
                        "longitude": "-82.27069000"
                    },
                    {
                        "id": 141115,
                        "name": "Ashley",
                        "latitude": "40.40895000",
                        "longitude": "-82.95546000"
                    },
                    {
                        "id": 141116,
                        "name": "Ashtabula",
                        "latitude": "41.86505000",
                        "longitude": "-80.78981000"
                    },
                    {
                        "id": 141117,
                        "name": "Ashtabula County",
                        "latitude": "41.89638000",
                        "longitude": "-80.75901000"
                    },
                    {
                        "id": 141118,
                        "name": "Ashville",
                        "latitude": "39.71562000",
                        "longitude": "-82.95296000"
                    },
                    {
                        "id": 141119,
                        "name": "Athens",
                        "latitude": "39.32924000",
                        "longitude": "-82.10126000"
                    },
                    {
                        "id": 141120,
                        "name": "Athens County",
                        "latitude": "39.33386000",
                        "longitude": "-82.04513000"
                    },
                    {
                        "id": 141121,
                        "name": "Auglaize County",
                        "latitude": "40.56091000",
                        "longitude": "-84.22174000"
                    },
                    {
                        "id": 141122,
                        "name": "Aurora",
                        "latitude": "41.31755000",
                        "longitude": "-81.34539000"
                    },
                    {
                        "id": 141123,
                        "name": "Austintown",
                        "latitude": "41.10172000",
                        "longitude": "-80.76452000"
                    },
                    {
                        "id": 141124,
                        "name": "Avon",
                        "latitude": "41.45171000",
                        "longitude": "-82.03542000"
                    },
                    {
                        "id": 141125,
                        "name": "Avon Center",
                        "latitude": "41.45976000",
                        "longitude": "-82.01959000"
                    },
                    {
                        "id": 141126,
                        "name": "Avon Lake",
                        "latitude": "41.50532000",
                        "longitude": "-82.02820000"
                    },
                    {
                        "id": 141127,
                        "name": "Bainbridge",
                        "latitude": "41.38644000",
                        "longitude": "-81.33955000"
                    },
                    {
                        "id": 141128,
                        "name": "Ballville",
                        "latitude": "41.32783000",
                        "longitude": "-83.13214000"
                    },
                    {
                        "id": 141129,
                        "name": "Baltimore",
                        "latitude": "39.84534000",
                        "longitude": "-82.60072000"
                    },
                    {
                        "id": 141130,
                        "name": "Barberton",
                        "latitude": "41.01283000",
                        "longitude": "-81.60512000"
                    },
                    {
                        "id": 141131,
                        "name": "Barnesville",
                        "latitude": "39.98813000",
                        "longitude": "-81.17650000"
                    },
                    {
                        "id": 141132,
                        "name": "Batavia",
                        "latitude": "39.07701000",
                        "longitude": "-84.17688000"
                    },
                    {
                        "id": 141133,
                        "name": "Bay Village",
                        "latitude": "41.48477000",
                        "longitude": "-81.92208000"
                    },
                    {
                        "id": 141134,
                        "name": "Beach City",
                        "latitude": "40.65312000",
                        "longitude": "-81.58096000"
                    },
                    {
                        "id": 141135,
                        "name": "Beachwood",
                        "latitude": "41.46450000",
                        "longitude": "-81.50873000"
                    },
                    {
                        "id": 141136,
                        "name": "Beavercreek",
                        "latitude": "39.70923000",
                        "longitude": "-84.06327000"
                    },
                    {
                        "id": 141137,
                        "name": "Beckett Ridge",
                        "latitude": "39.34700000",
                        "longitude": "-84.43522000"
                    },
                    {
                        "id": 141138,
                        "name": "Bedford",
                        "latitude": "41.39311000",
                        "longitude": "-81.53651000"
                    },
                    {
                        "id": 141139,
                        "name": "Bedford Heights",
                        "latitude": "41.41700000",
                        "longitude": "-81.52734000"
                    },
                    {
                        "id": 141140,
                        "name": "Beechwood Trails",
                        "latitude": "40.02367000",
                        "longitude": "-82.65072000"
                    },
                    {
                        "id": 141141,
                        "name": "Bellaire",
                        "latitude": "40.01618000",
                        "longitude": "-80.74231000"
                    },
                    {
                        "id": 141142,
                        "name": "Bellbrook",
                        "latitude": "39.63562000",
                        "longitude": "-84.07077000"
                    },
                    {
                        "id": 141143,
                        "name": "Bellefontaine",
                        "latitude": "40.36116000",
                        "longitude": "-83.75966000"
                    },
                    {
                        "id": 141144,
                        "name": "Bellevue",
                        "latitude": "41.27366000",
                        "longitude": "-82.84158000"
                    },
                    {
                        "id": 141145,
                        "name": "Bellville",
                        "latitude": "40.62006000",
                        "longitude": "-82.51072000"
                    },
                    {
                        "id": 141146,
                        "name": "Belmont County",
                        "latitude": "40.01580000",
                        "longitude": "-80.98854000"
                    },
                    {
                        "id": 141147,
                        "name": "Belpre",
                        "latitude": "39.27396000",
                        "longitude": "-81.57290000"
                    },
                    {
                        "id": 141148,
                        "name": "Berea",
                        "latitude": "41.36616000",
                        "longitude": "-81.85430000"
                    },
                    {
                        "id": 141149,
                        "name": "Bethel",
                        "latitude": "38.96368000",
                        "longitude": "-84.08077000"
                    },
                    {
                        "id": 141150,
                        "name": "Bethesda",
                        "latitude": "40.01618000",
                        "longitude": "-81.07260000"
                    },
                    {
                        "id": 141151,
                        "name": "Beverly",
                        "latitude": "39.54785000",
                        "longitude": "-81.63957000"
                    },
                    {
                        "id": 141152,
                        "name": "Bexley",
                        "latitude": "39.96895000",
                        "longitude": "-82.93768000"
                    },
                    {
                        "id": 141153,
                        "name": "Blacklick Estates",
                        "latitude": "39.90506000",
                        "longitude": "-82.86434000"
                    },
                    {
                        "id": 141154,
                        "name": "Blanchester",
                        "latitude": "39.29312000",
                        "longitude": "-83.98882000"
                    },
                    {
                        "id": 141155,
                        "name": "Blue Ash",
                        "latitude": "39.23200000",
                        "longitude": "-84.37827000"
                    },
                    {
                        "id": 141156,
                        "name": "Bluffton",
                        "latitude": "40.89533000",
                        "longitude": "-83.88883000"
                    },
                    {
                        "id": 141157,
                        "name": "Boardman",
                        "latitude": "41.02423000",
                        "longitude": "-80.66285000"
                    },
                    {
                        "id": 141158,
                        "name": "Bolindale",
                        "latitude": "41.20728000",
                        "longitude": "-80.77758000"
                    },
                    {
                        "id": 141159,
                        "name": "Boston Heights",
                        "latitude": "41.26478000",
                        "longitude": "-81.51317000"
                    },
                    {
                        "id": 141160,
                        "name": "Botkins",
                        "latitude": "40.46783000",
                        "longitude": "-84.18050000"
                    },
                    {
                        "id": 141161,
                        "name": "Bowling Green",
                        "latitude": "41.37477000",
                        "longitude": "-83.65132000"
                    },
                    {
                        "id": 141162,
                        "name": "Bradford",
                        "latitude": "40.13227000",
                        "longitude": "-84.43078000"
                    },
                    {
                        "id": 141163,
                        "name": "Bradner",
                        "latitude": "41.32422000",
                        "longitude": "-83.43854000"
                    },
                    {
                        "id": 141164,
                        "name": "Bratenahl",
                        "latitude": "41.54255000",
                        "longitude": "-81.62624000"
                    },
                    {
                        "id": 141165,
                        "name": "Brecksville",
                        "latitude": "41.31978000",
                        "longitude": "-81.62679000"
                    },
                    {
                        "id": 141166,
                        "name": "Bremen",
                        "latitude": "39.70173000",
                        "longitude": "-82.42682000"
                    },
                    {
                        "id": 141167,
                        "name": "Brewster",
                        "latitude": "40.70700000",
                        "longitude": "-81.59818000"
                    },
                    {
                        "id": 141168,
                        "name": "Bridgeport",
                        "latitude": "40.06979000",
                        "longitude": "-80.74008000"
                    },
                    {
                        "id": 141169,
                        "name": "Bridgetown",
                        "latitude": "39.15311000",
                        "longitude": "-84.63717000"
                    },
                    {
                        "id": 141170,
                        "name": "Brilliant",
                        "latitude": "40.26479000",
                        "longitude": "-80.62619000"
                    },
                    {
                        "id": 141171,
                        "name": "Brimfield",
                        "latitude": "41.10006000",
                        "longitude": "-81.34650000"
                    },
                    {
                        "id": 141172,
                        "name": "Broadview Heights",
                        "latitude": "41.31394000",
                        "longitude": "-81.68513000"
                    },
                    {
                        "id": 141173,
                        "name": "Brook Park",
                        "latitude": "41.39838000",
                        "longitude": "-81.80458000"
                    },
                    {
                        "id": 141174,
                        "name": "Brookfield Center",
                        "latitude": "41.24061000",
                        "longitude": "-80.55785000"
                    },
                    {
                        "id": 141175,
                        "name": "Brooklyn",
                        "latitude": "41.43977000",
                        "longitude": "-81.73541000"
                    },
                    {
                        "id": 141176,
                        "name": "Brooklyn Heights",
                        "latitude": "41.42533000",
                        "longitude": "-81.68818000"
                    },
                    {
                        "id": 141177,
                        "name": "Brookville",
                        "latitude": "39.83672000",
                        "longitude": "-84.41134000"
                    },
                    {
                        "id": 141178,
                        "name": "Brown County",
                        "latitude": "38.93405000",
                        "longitude": "-83.86743000"
                    },
                    {
                        "id": 141179,
                        "name": "Brunswick",
                        "latitude": "41.23811000",
                        "longitude": "-81.84180000"
                    },
                    {
                        "id": 141180,
                        "name": "Bryan",
                        "latitude": "41.47477000",
                        "longitude": "-84.55245000"
                    },
                    {
                        "id": 141181,
                        "name": "Buckeye Lake",
                        "latitude": "39.93368000",
                        "longitude": "-82.47238000"
                    },
                    {
                        "id": 141182,
                        "name": "Bucyrus",
                        "latitude": "40.80839000",
                        "longitude": "-82.97546000"
                    },
                    {
                        "id": 141183,
                        "name": "Burlington",
                        "latitude": "38.40730000",
                        "longitude": "-82.53571000"
                    },
                    {
                        "id": 141184,
                        "name": "Burton",
                        "latitude": "41.47061000",
                        "longitude": "-81.14510000"
                    },
                    {
                        "id": 141185,
                        "name": "Butler County",
                        "latitude": "39.43865000",
                        "longitude": "-84.57566000"
                    },
                    {
                        "id": 141186,
                        "name": "Byesville",
                        "latitude": "39.96979000",
                        "longitude": "-81.53651000"
                    },
                    {
                        "id": 141187,
                        "name": "Cadiz",
                        "latitude": "40.27285000",
                        "longitude": "-80.99676000"
                    },
                    {
                        "id": 141188,
                        "name": "Calcutta",
                        "latitude": "40.67340000",
                        "longitude": "-80.57646000"
                    },
                    {
                        "id": 141189,
                        "name": "Caldwell",
                        "latitude": "39.74785000",
                        "longitude": "-81.51651000"
                    },
                    {
                        "id": 141190,
                        "name": "Cambridge",
                        "latitude": "40.03118000",
                        "longitude": "-81.58846000"
                    },
                    {
                        "id": 141191,
                        "name": "Camden",
                        "latitude": "39.62894000",
                        "longitude": "-84.64856000"
                    },
                    {
                        "id": 141192,
                        "name": "Campbell",
                        "latitude": "41.07839000",
                        "longitude": "-80.59924000"
                    },
                    {
                        "id": 141193,
                        "name": "Canal Fulton",
                        "latitude": "40.88978000",
                        "longitude": "-81.59762000"
                    },
                    {
                        "id": 141194,
                        "name": "Canal Winchester",
                        "latitude": "39.84284000",
                        "longitude": "-82.80462000"
                    },
                    {
                        "id": 141195,
                        "name": "Canfield",
                        "latitude": "41.02506000",
                        "longitude": "-80.76091000"
                    },
                    {
                        "id": 141196,
                        "name": "Canton",
                        "latitude": "40.79895000",
                        "longitude": "-81.37845000"
                    },
                    {
                        "id": 141197,
                        "name": "Cardington",
                        "latitude": "40.50062000",
                        "longitude": "-82.89351000"
                    },
                    {
                        "id": 141198,
                        "name": "Carey",
                        "latitude": "40.95256000",
                        "longitude": "-83.38242000"
                    },
                    {
                        "id": 141199,
                        "name": "Carlisle",
                        "latitude": "39.58200000",
                        "longitude": "-84.32022000"
                    },
                    {
                        "id": 141200,
                        "name": "Carroll County",
                        "latitude": "40.57959000",
                        "longitude": "-81.08972000"
                    },
                    {
                        "id": 141201,
                        "name": "Carrollton",
                        "latitude": "40.57284000",
                        "longitude": "-81.08565000"
                    },
                    {
                        "id": 141202,
                        "name": "Cedarville",
                        "latitude": "39.74423000",
                        "longitude": "-83.80854000"
                    },
                    {
                        "id": 141203,
                        "name": "Celina",
                        "latitude": "40.54894000",
                        "longitude": "-84.57023000"
                    },
                    {
                        "id": 141204,
                        "name": "Centerburg",
                        "latitude": "40.30451000",
                        "longitude": "-82.69628000"
                    },
                    {
                        "id": 141205,
                        "name": "Centerville",
                        "latitude": "39.62839000",
                        "longitude": "-84.15938000"
                    },
                    {
                        "id": 141206,
                        "name": "Chagrin Falls",
                        "latitude": "41.43616000",
                        "longitude": "-81.38650000"
                    },
                    {
                        "id": 141207,
                        "name": "Champaign County",
                        "latitude": "40.13767000",
                        "longitude": "-83.76950000"
                    },
                    {
                        "id": 141208,
                        "name": "Champion Heights",
                        "latitude": "41.28999000",
                        "longitude": "-80.84595000"
                    },
                    {
                        "id": 141209,
                        "name": "Chardon",
                        "latitude": "41.61422000",
                        "longitude": "-81.14899000"
                    },
                    {
                        "id": 141210,
                        "name": "Chauncey",
                        "latitude": "39.39785000",
                        "longitude": "-82.12931000"
                    },
                    {
                        "id": 141211,
                        "name": "Cherry Grove",
                        "latitude": "39.07256000",
                        "longitude": "-84.32188000"
                    },
                    {
                        "id": 141212,
                        "name": "Chesterland",
                        "latitude": "41.52227000",
                        "longitude": "-81.33789000"
                    },
                    {
                        "id": 141213,
                        "name": "Cheviot",
                        "latitude": "39.15700000",
                        "longitude": "-84.61328000"
                    },
                    {
                        "id": 141214,
                        "name": "Chillicothe",
                        "latitude": "39.33312000",
                        "longitude": "-82.98240000"
                    },
                    {
                        "id": 141215,
                        "name": "Choctaw Lake",
                        "latitude": "39.96006000",
                        "longitude": "-83.48492000"
                    },
                    {
                        "id": 141216,
                        "name": "Churchill",
                        "latitude": "41.16200000",
                        "longitude": "-80.66480000"
                    },
                    {
                        "id": 141217,
                        "name": "Cincinnati",
                        "latitude": "39.12711000",
                        "longitude": "-84.51439000"
                    },
                    {
                        "id": 141218,
                        "name": "Circleville",
                        "latitude": "39.60062000",
                        "longitude": "-82.94601000"
                    },
                    {
                        "id": 141219,
                        "name": "Clark County",
                        "latitude": "39.91678000",
                        "longitude": "-83.78390000"
                    },
                    {
                        "id": 141220,
                        "name": "Clark-Fulton",
                        "latitude": "41.46402000",
                        "longitude": "-81.70979000"
                    },
                    {
                        "id": 141221,
                        "name": "Clayton",
                        "latitude": "39.86311000",
                        "longitude": "-84.36050000"
                    },
                    {
                        "id": 141222,
                        "name": "Clermont County",
                        "latitude": "39.04743000",
                        "longitude": "-84.15192000"
                    },
                    {
                        "id": 141223,
                        "name": "Cleveland",
                        "latitude": "41.49950000",
                        "longitude": "-81.69541000"
                    },
                    {
                        "id": 141224,
                        "name": "Cleveland Heights",
                        "latitude": "41.52005000",
                        "longitude": "-81.55624000"
                    },
                    {
                        "id": 141225,
                        "name": "Cleves",
                        "latitude": "39.16172000",
                        "longitude": "-84.74912000"
                    },
                    {
                        "id": 141226,
                        "name": "Clinton",
                        "latitude": "40.92672000",
                        "longitude": "-81.63040000"
                    },
                    {
                        "id": 141227,
                        "name": "Clinton County",
                        "latitude": "39.41498000",
                        "longitude": "-83.80838000"
                    },
                    {
                        "id": 141228,
                        "name": "Clyde",
                        "latitude": "41.30422000",
                        "longitude": "-82.97519000"
                    },
                    {
                        "id": 141229,
                        "name": "Coal Grove",
                        "latitude": "38.50341000",
                        "longitude": "-82.64711000"
                    },
                    {
                        "id": 141230,
                        "name": "Coldwater",
                        "latitude": "40.47977000",
                        "longitude": "-84.62829000"
                    },
                    {
                        "id": 141231,
                        "name": "Collinwood",
                        "latitude": "41.55838000",
                        "longitude": "-81.56929000"
                    },
                    {
                        "id": 141232,
                        "name": "Columbiana",
                        "latitude": "40.88839000",
                        "longitude": "-80.69396000"
                    },
                    {
                        "id": 141233,
                        "name": "Columbiana County",
                        "latitude": "40.76843000",
                        "longitude": "-80.77719000"
                    },
                    {
                        "id": 141234,
                        "name": "Columbus",
                        "latitude": "39.96118000",
                        "longitude": "-82.99879000"
                    },
                    {
                        "id": 141235,
                        "name": "Columbus Grove",
                        "latitude": "40.91950000",
                        "longitude": "-84.05689000"
                    },
                    {
                        "id": 141236,
                        "name": "Commercial Point",
                        "latitude": "39.76840000",
                        "longitude": "-83.05713000"
                    },
                    {
                        "id": 141237,
                        "name": "Conneaut",
                        "latitude": "41.94756000",
                        "longitude": "-80.55424000"
                    },
                    {
                        "id": 141238,
                        "name": "Continental",
                        "latitude": "41.10033000",
                        "longitude": "-84.26634000"
                    },
                    {
                        "id": 141239,
                        "name": "Convoy",
                        "latitude": "40.91672000",
                        "longitude": "-84.70274000"
                    },
                    {
                        "id": 141240,
                        "name": "Copley",
                        "latitude": "41.09894000",
                        "longitude": "-81.64457000"
                    },
                    {
                        "id": 141241,
                        "name": "Cortland",
                        "latitude": "41.33033000",
                        "longitude": "-80.72536000"
                    },
                    {
                        "id": 141242,
                        "name": "Coshocton",
                        "latitude": "40.27202000",
                        "longitude": "-81.85958000"
                    },
                    {
                        "id": 141243,
                        "name": "Coshocton County",
                        "latitude": "40.30164000",
                        "longitude": "-81.92001000"
                    },
                    {
                        "id": 141244,
                        "name": "Covedale",
                        "latitude": "39.12117000",
                        "longitude": "-84.60633000"
                    },
                    {
                        "id": 141245,
                        "name": "Covington",
                        "latitude": "40.11727000",
                        "longitude": "-84.35384000"
                    },
                    {
                        "id": 141246,
                        "name": "Craig Beach",
                        "latitude": "41.11700000",
                        "longitude": "-80.98342000"
                    },
                    {
                        "id": 141247,
                        "name": "Crawford County",
                        "latitude": "40.85077000",
                        "longitude": "-82.91978000"
                    },
                    {
                        "id": 141248,
                        "name": "Crestline",
                        "latitude": "40.78756000",
                        "longitude": "-82.73657000"
                    },
                    {
                        "id": 141249,
                        "name": "Creston",
                        "latitude": "40.98700000",
                        "longitude": "-81.89375000"
                    },
                    {
                        "id": 141250,
                        "name": "Cridersville",
                        "latitude": "40.65422000",
                        "longitude": "-84.15078000"
                    },
                    {
                        "id": 141251,
                        "name": "Crooksville",
                        "latitude": "39.76896000",
                        "longitude": "-82.09209000"
                    },
                    {
                        "id": 141252,
                        "name": "Crystal Lakes",
                        "latitude": "39.88923000",
                        "longitude": "-84.02660000"
                    },
                    {
                        "id": 141253,
                        "name": "Curtice",
                        "latitude": "41.61838000",
                        "longitude": "-83.36771000"
                    },
                    {
                        "id": 141254,
                        "name": "Cuyahoga County",
                        "latitude": "41.47875000",
                        "longitude": "-81.67786000"
                    },
                    {
                        "id": 141255,
                        "name": "Cuyahoga Falls",
                        "latitude": "41.13394000",
                        "longitude": "-81.48456000"
                    },
                    {
                        "id": 141256,
                        "name": "Dalton",
                        "latitude": "40.79894000",
                        "longitude": "-81.69541000"
                    },
                    {
                        "id": 141257,
                        "name": "Danville",
                        "latitude": "40.44756000",
                        "longitude": "-82.26016000"
                    },
                    {
                        "id": 141258,
                        "name": "Darke County",
                        "latitude": "40.13323000",
                        "longitude": "-84.61931000"
                    },
                    {
                        "id": 141259,
                        "name": "Day Heights",
                        "latitude": "39.17395000",
                        "longitude": "-84.22633000"
                    },
                    {
                        "id": 141260,
                        "name": "Dayton",
                        "latitude": "39.75895000",
                        "longitude": "-84.19161000"
                    },
                    {
                        "id": 141261,
                        "name": "De Graff",
                        "latitude": "40.31200000",
                        "longitude": "-83.91577000"
                    },
                    {
                        "id": 141262,
                        "name": "Deer Park",
                        "latitude": "39.20534000",
                        "longitude": "-84.39466000"
                    },
                    {
                        "id": 141263,
                        "name": "Defiance",
                        "latitude": "41.28449000",
                        "longitude": "-84.35578000"
                    },
                    {
                        "id": 141264,
                        "name": "Defiance County",
                        "latitude": "41.32392000",
                        "longitude": "-84.49050000"
                    },
                    {
                        "id": 141265,
                        "name": "Delaware",
                        "latitude": "40.29867000",
                        "longitude": "-83.06797000"
                    },
                    {
                        "id": 141266,
                        "name": "Delaware County",
                        "latitude": "40.27839000",
                        "longitude": "-83.00489000"
                    },
                    {
                        "id": 141267,
                        "name": "Delhi Hills",
                        "latitude": "39.09284000",
                        "longitude": "-84.61272000"
                    },
                    {
                        "id": 141268,
                        "name": "Delphos",
                        "latitude": "40.84338000",
                        "longitude": "-84.34162000"
                    },
                    {
                        "id": 141269,
                        "name": "Delta",
                        "latitude": "41.57366000",
                        "longitude": "-84.00522000"
                    },
                    {
                        "id": 141270,
                        "name": "Dennison",
                        "latitude": "40.39340000",
                        "longitude": "-81.33372000"
                    },
                    {
                        "id": 141271,
                        "name": "Dent",
                        "latitude": "39.18589000",
                        "longitude": "-84.65134000"
                    },
                    {
                        "id": 141272,
                        "name": "Deshler",
                        "latitude": "41.20755000",
                        "longitude": "-83.89911000"
                    },
                    {
                        "id": 141273,
                        "name": "Detroit-Shoreway",
                        "latitude": "41.47772000",
                        "longitude": "-81.72991000"
                    },
                    {
                        "id": 141274,
                        "name": "Devola",
                        "latitude": "39.47369000",
                        "longitude": "-81.47901000"
                    },
                    {
                        "id": 141275,
                        "name": "Dillonvale",
                        "latitude": "39.21811000",
                        "longitude": "-84.40216000"
                    },
                    {
                        "id": 141276,
                        "name": "Dover",
                        "latitude": "40.52062000",
                        "longitude": "-81.47401000"
                    },
                    {
                        "id": 141277,
                        "name": "Doylestown",
                        "latitude": "40.97005000",
                        "longitude": "-81.69652000"
                    },
                    {
                        "id": 141278,
                        "name": "Dresden",
                        "latitude": "40.12146000",
                        "longitude": "-82.01069000"
                    },
                    {
                        "id": 141279,
                        "name": "Drexel",
                        "latitude": "39.74645000",
                        "longitude": "-84.28661000"
                    },
                    {
                        "id": 141280,
                        "name": "Dry Ridge",
                        "latitude": "39.25922000",
                        "longitude": "-84.61911000"
                    },
                    {
                        "id": 141281,
                        "name": "Dry Run",
                        "latitude": "39.10423000",
                        "longitude": "-84.33049000"
                    },
                    {
                        "id": 141282,
                        "name": "Dublin",
                        "latitude": "40.09923000",
                        "longitude": "-83.11408000"
                    },
                    {
                        "id": 141283,
                        "name": "Dunlap",
                        "latitude": "39.29228000",
                        "longitude": "-84.61800000"
                    },
                    {
                        "id": 141284,
                        "name": "East Canton",
                        "latitude": "40.78728000",
                        "longitude": "-81.28261000"
                    },
                    {
                        "id": 141285,
                        "name": "East Cleveland",
                        "latitude": "41.53311000",
                        "longitude": "-81.57901000"
                    },
                    {
                        "id": 141286,
                        "name": "East Liverpool",
                        "latitude": "40.61868000",
                        "longitude": "-80.57729000"
                    },
                    {
                        "id": 141287,
                        "name": "East Palestine",
                        "latitude": "40.83395000",
                        "longitude": "-80.54035000"
                    },
                    {
                        "id": 141288,
                        "name": "Eastlake",
                        "latitude": "41.65394000",
                        "longitude": "-81.45039000"
                    },
                    {
                        "id": 141289,
                        "name": "Eaton",
                        "latitude": "39.74394000",
                        "longitude": "-84.63662000"
                    },
                    {
                        "id": 141290,
                        "name": "Eaton Estates",
                        "latitude": "41.30894000",
                        "longitude": "-82.00570000"
                    },
                    {
                        "id": 141291,
                        "name": "Edgerton",
                        "latitude": "41.44866000",
                        "longitude": "-84.74801000"
                    },
                    {
                        "id": 141292,
                        "name": "Edgewood",
                        "latitude": "41.87283000",
                        "longitude": "-80.77286000"
                    },
                    {
                        "id": 141293,
                        "name": "Elida",
                        "latitude": "40.78866000",
                        "longitude": "-84.20384000"
                    },
                    {
                        "id": 141294,
                        "name": "Elmore",
                        "latitude": "41.47616000",
                        "longitude": "-83.29576000"
                    },
                    {
                        "id": 141295,
                        "name": "Elmwood Place",
                        "latitude": "39.18728000",
                        "longitude": "-84.48800000"
                    },
                    {
                        "id": 141296,
                        "name": "Elyria",
                        "latitude": "41.36838000",
                        "longitude": "-82.10765000"
                    },
                    {
                        "id": 141297,
                        "name": "Englewood",
                        "latitude": "39.87756000",
                        "longitude": "-84.30217000"
                    },
                    {
                        "id": 141298,
                        "name": "Enon",
                        "latitude": "39.87812000",
                        "longitude": "-83.93688000"
                    },
                    {
                        "id": 141299,
                        "name": "Erie County",
                        "latitude": "41.43209000",
                        "longitude": "-82.69958000"
                    },
                    {
                        "id": 141300,
                        "name": "Etna",
                        "latitude": "39.95729000",
                        "longitude": "-82.68183000"
                    },
                    {
                        "id": 141301,
                        "name": "Euclid",
                        "latitude": "41.59310000",
                        "longitude": "-81.52679000"
                    },
                    {
                        "id": 141302,
                        "name": "Evendale",
                        "latitude": "39.25617000",
                        "longitude": "-84.41800000"
                    },
                    {
                        "id": 141303,
                        "name": "Fairborn",
                        "latitude": "39.82089000",
                        "longitude": "-84.01938000"
                    },
                    {
                        "id": 141304,
                        "name": "Fairfax",
                        "latitude": "39.14534000",
                        "longitude": "-84.39327000"
                    },
                    {
                        "id": 141305,
                        "name": "Fairfield",
                        "latitude": "39.34589000",
                        "longitude": "-84.56050000"
                    },
                    {
                        "id": 141306,
                        "name": "Fairfield Beach",
                        "latitude": "39.91590000",
                        "longitude": "-82.47516000"
                    },
                    {
                        "id": 141307,
                        "name": "Fairfield County",
                        "latitude": "39.75160000",
                        "longitude": "-82.63059000"
                    },
                    {
                        "id": 141308,
                        "name": "Fairlawn",
                        "latitude": "41.12783000",
                        "longitude": "-81.60984000"
                    },
                    {
                        "id": 141309,
                        "name": "Fairport Harbor",
                        "latitude": "41.75004000",
                        "longitude": "-81.27399000"
                    },
                    {
                        "id": 141310,
                        "name": "Fairview Park",
                        "latitude": "41.44144000",
                        "longitude": "-81.86430000"
                    },
                    {
                        "id": 141311,
                        "name": "Farmersville",
                        "latitude": "39.67950000",
                        "longitude": "-84.42911000"
                    },
                    {
                        "id": 141312,
                        "name": "Fayette",
                        "latitude": "41.67338000",
                        "longitude": "-84.32689000"
                    },
                    {
                        "id": 141313,
                        "name": "Fayette County",
                        "latitude": "39.55988000",
                        "longitude": "-83.45610000"
                    },
                    {
                        "id": 141314,
                        "name": "Findlay",
                        "latitude": "41.04422000",
                        "longitude": "-83.64993000"
                    },
                    {
                        "id": 141315,
                        "name": "Finneytown",
                        "latitude": "39.20034000",
                        "longitude": "-84.52050000"
                    },
                    {
                        "id": 141316,
                        "name": "Five Points",
                        "latitude": "39.56867000",
                        "longitude": "-84.19299000"
                    },
                    {
                        "id": 141317,
                        "name": "Forest",
                        "latitude": "40.80172000",
                        "longitude": "-83.51048000"
                    },
                    {
                        "id": 141318,
                        "name": "Forest Park",
                        "latitude": "39.29034000",
                        "longitude": "-84.50411000"
                    },
                    {
                        "id": 141319,
                        "name": "Forestville",
                        "latitude": "39.07506000",
                        "longitude": "-84.34494000"
                    },
                    {
                        "id": 141320,
                        "name": "Fort Loramie",
                        "latitude": "40.35144000",
                        "longitude": "-84.37384000"
                    },
                    {
                        "id": 141321,
                        "name": "Fort McKinley",
                        "latitude": "39.79756000",
                        "longitude": "-84.25355000"
                    },
                    {
                        "id": 141322,
                        "name": "Fort Recovery",
                        "latitude": "40.41282000",
                        "longitude": "-84.77635000"
                    },
                    {
                        "id": 141323,
                        "name": "Fort Shawnee",
                        "latitude": "40.68672000",
                        "longitude": "-84.13773000"
                    },
                    {
                        "id": 141324,
                        "name": "Fostoria",
                        "latitude": "41.15700000",
                        "longitude": "-83.41687000"
                    },
                    {
                        "id": 141325,
                        "name": "Frankfort",
                        "latitude": "39.40145000",
                        "longitude": "-83.18074000"
                    },
                    {
                        "id": 141326,
                        "name": "Franklin",
                        "latitude": "39.55895000",
                        "longitude": "-84.30411000"
                    },
                    {
                        "id": 141327,
                        "name": "Franklin County",
                        "latitude": "39.96952000",
                        "longitude": "-83.00935000"
                    },
                    {
                        "id": 141328,
                        "name": "Franklin Furnace",
                        "latitude": "38.64508000",
                        "longitude": "-82.84878000"
                    },
                    {
                        "id": 141329,
                        "name": "Frazeysburg",
                        "latitude": "40.11729000",
                        "longitude": "-82.11931000"
                    },
                    {
                        "id": 141330,
                        "name": "Fredericktown",
                        "latitude": "40.48117000",
                        "longitude": "-82.54072000"
                    },
                    {
                        "id": 141331,
                        "name": "Fremont",
                        "latitude": "41.35033000",
                        "longitude": "-83.12186000"
                    },
                    {
                        "id": 141332,
                        "name": "Fruit Hill",
                        "latitude": "39.07562000",
                        "longitude": "-84.36438000"
                    },
                    {
                        "id": 141333,
                        "name": "Fulton County",
                        "latitude": "41.60180000",
                        "longitude": "-84.13007000"
                    },
                    {
                        "id": 141334,
                        "name": "Gahanna",
                        "latitude": "40.01923000",
                        "longitude": "-82.87934000"
                    },
                    {
                        "id": 141335,
                        "name": "Galion",
                        "latitude": "40.73367000",
                        "longitude": "-82.78990000"
                    },
                    {
                        "id": 141336,
                        "name": "Gallia County",
                        "latitude": "38.82467000",
                        "longitude": "-82.31691000"
                    },
                    {
                        "id": 141337,
                        "name": "Gallipolis",
                        "latitude": "38.80980000",
                        "longitude": "-82.20237000"
                    },
                    {
                        "id": 141338,
                        "name": "Gambier",
                        "latitude": "40.37562000",
                        "longitude": "-82.39710000"
                    },
                    {
                        "id": 141339,
                        "name": "Garfield Heights",
                        "latitude": "41.41700000",
                        "longitude": "-81.60596000"
                    },
                    {
                        "id": 141340,
                        "name": "Garrettsville",
                        "latitude": "41.28422000",
                        "longitude": "-81.09649000"
                    },
                    {
                        "id": 141341,
                        "name": "Gates Mills",
                        "latitude": "41.51755000",
                        "longitude": "-81.40345000"
                    },
                    {
                        "id": 141342,
                        "name": "Geauga County",
                        "latitude": "41.49954000",
                        "longitude": "-81.17865000"
                    },
                    {
                        "id": 141343,
                        "name": "Geneva",
                        "latitude": "41.80505000",
                        "longitude": "-80.94815000"
                    },
                    {
                        "id": 141344,
                        "name": "Geneva-on-the-Lake",
                        "latitude": "41.85950000",
                        "longitude": "-80.95398000"
                    },
                    {
                        "id": 141345,
                        "name": "Genoa",
                        "latitude": "41.51811000",
                        "longitude": "-83.35909000"
                    },
                    {
                        "id": 141346,
                        "name": "Georgetown",
                        "latitude": "38.86451000",
                        "longitude": "-83.90409000"
                    },
                    {
                        "id": 141347,
                        "name": "Germantown",
                        "latitude": "39.62617000",
                        "longitude": "-84.36939000"
                    },
                    {
                        "id": 141348,
                        "name": "Gibsonburg",
                        "latitude": "41.38450000",
                        "longitude": "-83.32048000"
                    },
                    {
                        "id": 141349,
                        "name": "Girard",
                        "latitude": "41.15395000",
                        "longitude": "-80.70147000"
                    },
                    {
                        "id": 141350,
                        "name": "Glandorf",
                        "latitude": "41.02894000",
                        "longitude": "-84.07911000"
                    },
                    {
                        "id": 141351,
                        "name": "Glendale",
                        "latitude": "39.27061000",
                        "longitude": "-84.45939000"
                    },
                    {
                        "id": 141352,
                        "name": "Glenmoor",
                        "latitude": "40.66617000",
                        "longitude": "-80.62313000"
                    },
                    {
                        "id": 141353,
                        "name": "Glenville",
                        "latitude": "41.53338000",
                        "longitude": "-81.61735000"
                    },
                    {
                        "id": 141354,
                        "name": "Glouster",
                        "latitude": "39.50313000",
                        "longitude": "-82.08459000"
                    },
                    {
                        "id": 141355,
                        "name": "Gnadenhutten",
                        "latitude": "40.35840000",
                        "longitude": "-81.43428000"
                    },
                    {
                        "id": 141356,
                        "name": "Golf Manor",
                        "latitude": "39.18728000",
                        "longitude": "-84.44633000"
                    },
                    {
                        "id": 141357,
                        "name": "Goshen",
                        "latitude": "39.23339000",
                        "longitude": "-84.16132000"
                    },
                    {
                        "id": 141358,
                        "name": "Grafton",
                        "latitude": "41.27255000",
                        "longitude": "-82.05459000"
                    },
                    {
                        "id": 141359,
                        "name": "Grandview",
                        "latitude": "39.19422000",
                        "longitude": "-84.72439000"
                    },
                    {
                        "id": 141360,
                        "name": "Grandview Heights",
                        "latitude": "39.97979000",
                        "longitude": "-83.04074000"
                    },
                    {
                        "id": 141361,
                        "name": "Granville",
                        "latitude": "40.06812000",
                        "longitude": "-82.51960000"
                    },
                    {
                        "id": 141362,
                        "name": "Granville South",
                        "latitude": "40.05207000",
                        "longitude": "-82.54166000"
                    },
                    {
                        "id": 141363,
                        "name": "Green",
                        "latitude": "40.94589000",
                        "longitude": "-81.48317000"
                    },
                    {
                        "id": 141364,
                        "name": "Green Meadows",
                        "latitude": "39.86895000",
                        "longitude": "-83.94438000"
                    },
                    {
                        "id": 141365,
                        "name": "Green Springs",
                        "latitude": "41.25616000",
                        "longitude": "-83.05158000"
                    },
                    {
                        "id": 141366,
                        "name": "Greene County",
                        "latitude": "39.69148000",
                        "longitude": "-83.88989000"
                    },
                    {
                        "id": 141367,
                        "name": "Greenfield",
                        "latitude": "39.35201000",
                        "longitude": "-83.38269000"
                    },
                    {
                        "id": 141368,
                        "name": "Greenhills",
                        "latitude": "39.26811000",
                        "longitude": "-84.52300000"
                    },
                    {
                        "id": 141369,
                        "name": "Greensburg",
                        "latitude": "40.93172000",
                        "longitude": "-81.46484000"
                    },
                    {
                        "id": 141370,
                        "name": "Greentown",
                        "latitude": "40.92756000",
                        "longitude": "-81.40261000"
                    },
                    {
                        "id": 141371,
                        "name": "Greenville",
                        "latitude": "40.10283000",
                        "longitude": "-84.63301000"
                    },
                    {
                        "id": 141372,
                        "name": "Greenwich",
                        "latitude": "41.03005000",
                        "longitude": "-82.51573000"
                    },
                    {
                        "id": 141373,
                        "name": "Groesbeck",
                        "latitude": "39.22311000",
                        "longitude": "-84.58689000"
                    },
                    {
                        "id": 141374,
                        "name": "Grove City",
                        "latitude": "39.88145000",
                        "longitude": "-83.09296000"
                    },
                    {
                        "id": 141375,
                        "name": "Groveport",
                        "latitude": "39.87840000",
                        "longitude": "-82.88379000"
                    },
                    {
                        "id": 141376,
                        "name": "Guernsey County",
                        "latitude": "40.05205000",
                        "longitude": "-81.49426000"
                    },
                    {
                        "id": 141377,
                        "name": "Hamilton",
                        "latitude": "39.39950000",
                        "longitude": "-84.56134000"
                    },
                    {
                        "id": 141378,
                        "name": "Hamilton County",
                        "latitude": "39.19553000",
                        "longitude": "-84.54277000"
                    },
                    {
                        "id": 141379,
                        "name": "Hancock County",
                        "latitude": "41.00194000",
                        "longitude": "-83.66654000"
                    },
                    {
                        "id": 141380,
                        "name": "Hanover",
                        "latitude": "40.07979000",
                        "longitude": "-82.26098000"
                    },
                    {
                        "id": 141381,
                        "name": "Harbor Hills",
                        "latitude": "39.93673000",
                        "longitude": "-82.43515000"
                    },
                    {
                        "id": 141382,
                        "name": "Hardin County",
                        "latitude": "40.66151000",
                        "longitude": "-83.65944000"
                    },
                    {
                        "id": 141383,
                        "name": "Harrison",
                        "latitude": "39.26200000",
                        "longitude": "-84.81995000"
                    },
                    {
                        "id": 141384,
                        "name": "Harrison County",
                        "latitude": "40.29384000",
                        "longitude": "-81.09114000"
                    },
                    {
                        "id": 141385,
                        "name": "Hartville",
                        "latitude": "40.96367000",
                        "longitude": "-81.33122000"
                    },
                    {
                        "id": 141386,
                        "name": "Haskins",
                        "latitude": "41.46477000",
                        "longitude": "-83.70605000"
                    },
                    {
                        "id": 141387,
                        "name": "Heath",
                        "latitude": "40.02284000",
                        "longitude": "-82.44460000"
                    },
                    {
                        "id": 141388,
                        "name": "Hebron",
                        "latitude": "39.96173000",
                        "longitude": "-82.49127000"
                    },
                    {
                        "id": 141389,
                        "name": "Henry County",
                        "latitude": "41.33389000",
                        "longitude": "-84.06823000"
                    },
                    {
                        "id": 141390,
                        "name": "Hicksville",
                        "latitude": "41.29311000",
                        "longitude": "-84.76190000"
                    },
                    {
                        "id": 141391,
                        "name": "Highland County",
                        "latitude": "39.18474000",
                        "longitude": "-83.60097000"
                    },
                    {
                        "id": 141392,
                        "name": "Highland Heights",
                        "latitude": "41.55200000",
                        "longitude": "-81.47845000"
                    },
                    {
                        "id": 141393,
                        "name": "Highpoint",
                        "latitude": "39.28839000",
                        "longitude": "-84.35022000"
                    },
                    {
                        "id": 141394,
                        "name": "Hilliard",
                        "latitude": "40.03340000",
                        "longitude": "-83.15825000"
                    },
                    {
                        "id": 141395,
                        "name": "Hillsboro",
                        "latitude": "39.20229000",
                        "longitude": "-83.61159000"
                    },
                    {
                        "id": 141396,
                        "name": "Hiram",
                        "latitude": "41.31256000",
                        "longitude": "-81.14371000"
                    },
                    {
                        "id": 141397,
                        "name": "Hocking County",
                        "latitude": "39.49702000",
                        "longitude": "-82.47925000"
                    },
                    {
                        "id": 141398,
                        "name": "Holgate",
                        "latitude": "41.24894000",
                        "longitude": "-84.13300000"
                    },
                    {
                        "id": 141399,
                        "name": "Holiday Valley",
                        "latitude": "39.85617000",
                        "longitude": "-83.96854000"
                    },
                    {
                        "id": 141400,
                        "name": "Holland",
                        "latitude": "41.62172000",
                        "longitude": "-83.71160000"
                    },
                    {
                        "id": 141401,
                        "name": "Holmes County",
                        "latitude": "40.56120000",
                        "longitude": "-81.92936000"
                    },
                    {
                        "id": 141402,
                        "name": "Hough",
                        "latitude": "41.51200000",
                        "longitude": "-81.63652000"
                    },
                    {
                        "id": 141403,
                        "name": "Howland Center",
                        "latitude": "41.25117000",
                        "longitude": "-80.74536000"
                    },
                    {
                        "id": 141404,
                        "name": "Hubbard",
                        "latitude": "41.15645000",
                        "longitude": "-80.56924000"
                    },
                    {
                        "id": 141405,
                        "name": "Huber Heights",
                        "latitude": "39.84395000",
                        "longitude": "-84.12466000"
                    },
                    {
                        "id": 141406,
                        "name": "Huber Ridge",
                        "latitude": "40.08867000",
                        "longitude": "-82.91657000"
                    },
                    {
                        "id": 141407,
                        "name": "Hudson",
                        "latitude": "41.24006000",
                        "longitude": "-81.44067000"
                    },
                    {
                        "id": 141408,
                        "name": "Hunter",
                        "latitude": "39.49284000",
                        "longitude": "-84.28966000"
                    },
                    {
                        "id": 141409,
                        "name": "Huron",
                        "latitude": "41.39505000",
                        "longitude": "-82.55517000"
                    },
                    {
                        "id": 141410,
                        "name": "Huron County",
                        "latitude": "41.14615000",
                        "longitude": "-82.59841000"
                    },
                    {
                        "id": 141411,
                        "name": "Independence",
                        "latitude": "41.36866000",
                        "longitude": "-81.63790000"
                    },
                    {
                        "id": 141412,
                        "name": "Ironton",
                        "latitude": "38.53675000",
                        "longitude": "-82.68294000"
                    },
                    {
                        "id": 141413,
                        "name": "Jackson",
                        "latitude": "39.05202000",
                        "longitude": "-82.63655000"
                    },
                    {
                        "id": 141414,
                        "name": "Jackson Center",
                        "latitude": "40.43949000",
                        "longitude": "-84.04022000"
                    },
                    {
                        "id": 141415,
                        "name": "Jackson County",
                        "latitude": "39.01967000",
                        "longitude": "-82.61838000"
                    },
                    {
                        "id": 141416,
                        "name": "Jamestown",
                        "latitude": "39.65812000",
                        "longitude": "-83.73492000"
                    },
                    {
                        "id": 141417,
                        "name": "Jefferson",
                        "latitude": "41.73867000",
                        "longitude": "-80.76981000"
                    },
                    {
                        "id": 141418,
                        "name": "Jefferson County",
                        "latitude": "40.38502000",
                        "longitude": "-80.76097000"
                    },
                    {
                        "id": 141419,
                        "name": "Jeffersonville",
                        "latitude": "39.65367000",
                        "longitude": "-83.56381000"
                    },
                    {
                        "id": 141420,
                        "name": "Johnstown",
                        "latitude": "40.15367000",
                        "longitude": "-82.68517000"
                    },
                    {
                        "id": 141421,
                        "name": "Kalida",
                        "latitude": "40.98283000",
                        "longitude": "-84.19939000"
                    },
                    {
                        "id": 141422,
                        "name": "Kent",
                        "latitude": "41.15367000",
                        "longitude": "-81.35789000"
                    },
                    {
                        "id": 141423,
                        "name": "Kenton",
                        "latitude": "40.64700000",
                        "longitude": "-83.60965000"
                    },
                    {
                        "id": 141424,
                        "name": "Kenwood",
                        "latitude": "39.21061000",
                        "longitude": "-84.36716000"
                    },
                    {
                        "id": 141425,
                        "name": "Kettering",
                        "latitude": "39.68950000",
                        "longitude": "-84.16883000"
                    },
                    {
                        "id": 141426,
                        "name": "Kings Mills",
                        "latitude": "39.35561000",
                        "longitude": "-84.24855000"
                    },
                    {
                        "id": 141427,
                        "name": "Kingston",
                        "latitude": "39.47395000",
                        "longitude": "-82.91073000"
                    },
                    {
                        "id": 141428,
                        "name": "Kirtland",
                        "latitude": "41.62894000",
                        "longitude": "-81.36150000"
                    },
                    {
                        "id": 141429,
                        "name": "Knox County",
                        "latitude": "40.39877000",
                        "longitude": "-82.42153000"
                    },
                    {
                        "id": 141430,
                        "name": "La Croft",
                        "latitude": "40.64590000",
                        "longitude": "-80.59785000"
                    },
                    {
                        "id": 141431,
                        "name": "Lagrange",
                        "latitude": "41.23728000",
                        "longitude": "-82.11987000"
                    },
                    {
                        "id": 141432,
                        "name": "Lake County",
                        "latitude": "41.71393000",
                        "longitude": "-81.24527000"
                    },
                    {
                        "id": 141433,
                        "name": "Lake Darby",
                        "latitude": "39.95728000",
                        "longitude": "-83.22880000"
                    },
                    {
                        "id": 141434,
                        "name": "Lake Lakengren",
                        "latitude": "39.68843000",
                        "longitude": "-84.69347000"
                    },
                    {
                        "id": 141435,
                        "name": "Lake Mohawk",
                        "latitude": "40.66673000",
                        "longitude": "-81.19927000"
                    },
                    {
                        "id": 141436,
                        "name": "Lakemore",
                        "latitude": "41.02089000",
                        "longitude": "-81.43595000"
                    },
                    {
                        "id": 141437,
                        "name": "Lakeview",
                        "latitude": "40.48477000",
                        "longitude": "-83.92300000"
                    },
                    {
                        "id": 141438,
                        "name": "Lakewood",
                        "latitude": "41.48199000",
                        "longitude": "-81.79819000"
                    },
                    {
                        "id": 141439,
                        "name": "Lancaster",
                        "latitude": "39.71368000",
                        "longitude": "-82.59933000"
                    },
                    {
                        "id": 141440,
                        "name": "Landen",
                        "latitude": "39.31200000",
                        "longitude": "-84.28299000"
                    },
                    {
                        "id": 141441,
                        "name": "Lawrence County",
                        "latitude": "38.59847000",
                        "longitude": "-82.53675000"
                    },
                    {
                        "id": 141442,
                        "name": "Leavittsburg",
                        "latitude": "41.24783000",
                        "longitude": "-80.87703000"
                    },
                    {
                        "id": 141443,
                        "name": "Lebanon",
                        "latitude": "39.43534000",
                        "longitude": "-84.20299000"
                    },
                    {
                        "id": 141444,
                        "name": "Leesburg",
                        "latitude": "39.34506000",
                        "longitude": "-83.55297000"
                    },
                    {
                        "id": 141445,
                        "name": "Leetonia",
                        "latitude": "40.87728000",
                        "longitude": "-80.75536000"
                    },
                    {
                        "id": 141446,
                        "name": "Leipsic",
                        "latitude": "41.09838000",
                        "longitude": "-83.98467000"
                    },
                    {
                        "id": 141447,
                        "name": "Lewis Center",
                        "latitude": "40.19840000",
                        "longitude": "-83.01018000"
                    },
                    {
                        "id": 141448,
                        "name": "Lewisburg",
                        "latitude": "39.84616000",
                        "longitude": "-84.53967000"
                    },
                    {
                        "id": 141449,
                        "name": "Lexington",
                        "latitude": "40.67867000",
                        "longitude": "-82.58239000"
                    },
                    {
                        "id": 141450,
                        "name": "Liberty Center",
                        "latitude": "41.44338000",
                        "longitude": "-84.00883000"
                    },
                    {
                        "id": 141451,
                        "name": "Licking County",
                        "latitude": "40.09161000",
                        "longitude": "-82.48315000"
                    },
                    {
                        "id": 141452,
                        "name": "Lima",
                        "latitude": "40.74255000",
                        "longitude": "-84.10523000"
                    },
                    {
                        "id": 141453,
                        "name": "Lincoln Heights",
                        "latitude": "39.23895000",
                        "longitude": "-84.45550000"
                    },
                    {
                        "id": 141454,
                        "name": "Lincoln Village",
                        "latitude": "39.95479000",
                        "longitude": "-83.13074000"
                    },
                    {
                        "id": 141455,
                        "name": "Lisbon",
                        "latitude": "39.86089000",
                        "longitude": "-83.63520000"
                    },
                    {
                        "id": 141456,
                        "name": "Lithopolis",
                        "latitude": "39.80284000",
                        "longitude": "-82.80628000"
                    },
                    {
                        "id": 141457,
                        "name": "Lockland",
                        "latitude": "39.22922000",
                        "longitude": "-84.45772000"
                    },
                    {
                        "id": 141458,
                        "name": "Lodi",
                        "latitude": "41.03339000",
                        "longitude": "-82.01209000"
                    },
                    {
                        "id": 141459,
                        "name": "Logan",
                        "latitude": "39.54007000",
                        "longitude": "-82.40710000"
                    },
                    {
                        "id": 141460,
                        "name": "Logan County",
                        "latitude": "40.38845000",
                        "longitude": "-83.76587000"
                    },
                    {
                        "id": 141461,
                        "name": "Logan Elm Village",
                        "latitude": "39.56978000",
                        "longitude": "-82.95185000"
                    },
                    {
                        "id": 141462,
                        "name": "London",
                        "latitude": "39.88645000",
                        "longitude": "-83.44825000"
                    },
                    {
                        "id": 141463,
                        "name": "Lorain",
                        "latitude": "41.45282000",
                        "longitude": "-82.18237000"
                    },
                    {
                        "id": 141464,
                        "name": "Lorain County",
                        "latitude": "41.45252000",
                        "longitude": "-82.15147000"
                    },
                    {
                        "id": 141465,
                        "name": "Lordstown",
                        "latitude": "41.16561000",
                        "longitude": "-80.85758000"
                    },
                    {
                        "id": 141466,
                        "name": "Loudonville",
                        "latitude": "40.63534000",
                        "longitude": "-82.23321000"
                    },
                    {
                        "id": 141467,
                        "name": "Louisville",
                        "latitude": "40.83728000",
                        "longitude": "-81.25955000"
                    },
                    {
                        "id": 141468,
                        "name": "Loveland",
                        "latitude": "39.26895000",
                        "longitude": "-84.26383000"
                    },
                    {
                        "id": 141469,
                        "name": "Loveland Park",
                        "latitude": "39.29978000",
                        "longitude": "-84.26327000"
                    },
                    {
                        "id": 141470,
                        "name": "Lowellville",
                        "latitude": "41.03534000",
                        "longitude": "-80.53646000"
                    },
                    {
                        "id": 141471,
                        "name": "Lucas County",
                        "latitude": "41.68419000",
                        "longitude": "-83.46826000"
                    },
                    {
                        "id": 141472,
                        "name": "Lucasville",
                        "latitude": "38.87952000",
                        "longitude": "-82.99684000"
                    },
                    {
                        "id": 141473,
                        "name": "Luckey",
                        "latitude": "41.45061000",
                        "longitude": "-83.48743000"
                    },
                    {
                        "id": 141474,
                        "name": "Lynchburg",
                        "latitude": "39.24173000",
                        "longitude": "-83.79131000"
                    },
                    {
                        "id": 141475,
                        "name": "Lyndhurst",
                        "latitude": "41.52005000",
                        "longitude": "-81.48873000"
                    },
                    {
                        "id": 141476,
                        "name": "Macedonia",
                        "latitude": "41.31367000",
                        "longitude": "-81.50845000"
                    },
                    {
                        "id": 141477,
                        "name": "Mack",
                        "latitude": "39.15811000",
                        "longitude": "-84.64967000"
                    },
                    {
                        "id": 141478,
                        "name": "Madeira",
                        "latitude": "39.19089000",
                        "longitude": "-84.36355000"
                    },
                    {
                        "id": 141479,
                        "name": "Madison",
                        "latitude": "41.77116000",
                        "longitude": "-81.04982000"
                    },
                    {
                        "id": 141480,
                        "name": "Madison County",
                        "latitude": "39.89403000",
                        "longitude": "-83.40020000"
                    },
                    {
                        "id": 141481,
                        "name": "Mahoning County",
                        "latitude": "41.01464000",
                        "longitude": "-80.77629000"
                    },
                    {
                        "id": 141482,
                        "name": "Malvern",
                        "latitude": "40.69173000",
                        "longitude": "-81.18121000"
                    },
                    {
                        "id": 141483,
                        "name": "Manchester",
                        "latitude": "38.68813000",
                        "longitude": "-83.60936000"
                    },
                    {
                        "id": 141484,
                        "name": "Mansfield",
                        "latitude": "40.75839000",
                        "longitude": "-82.51545000"
                    },
                    {
                        "id": 141485,
                        "name": "Mantua",
                        "latitude": "41.28394000",
                        "longitude": "-81.22399000"
                    },
                    {
                        "id": 141486,
                        "name": "Maple Heights",
                        "latitude": "41.41533000",
                        "longitude": "-81.56596000"
                    },
                    {
                        "id": 141487,
                        "name": "Mariemont",
                        "latitude": "39.14506000",
                        "longitude": "-84.37438000"
                    },
                    {
                        "id": 141488,
                        "name": "Marietta",
                        "latitude": "39.41535000",
                        "longitude": "-81.45484000"
                    },
                    {
                        "id": 141489,
                        "name": "Marion",
                        "latitude": "40.58867000",
                        "longitude": "-83.12852000"
                    },
                    {
                        "id": 141490,
                        "name": "Marion County",
                        "latitude": "40.58719000",
                        "longitude": "-83.16087000"
                    },
                    {
                        "id": 141491,
                        "name": "Martins Ferry",
                        "latitude": "40.09591000",
                        "longitude": "-80.72453000"
                    },
                    {
                        "id": 141492,
                        "name": "Marysville",
                        "latitude": "40.23645000",
                        "longitude": "-83.36714000"
                    },
                    {
                        "id": 141493,
                        "name": "Mason",
                        "latitude": "39.36006000",
                        "longitude": "-84.30994000"
                    },
                    {
                        "id": 141494,
                        "name": "Massillon",
                        "latitude": "40.79672000",
                        "longitude": "-81.52151000"
                    },
                    {
                        "id": 141495,
                        "name": "Masury",
                        "latitude": "41.21117000",
                        "longitude": "-80.53785000"
                    },
                    {
                        "id": 141496,
                        "name": "Maumee",
                        "latitude": "41.56283000",
                        "longitude": "-83.65382000"
                    },
                    {
                        "id": 141497,
                        "name": "Mayfield",
                        "latitude": "41.55200000",
                        "longitude": "-81.43928000"
                    },
                    {
                        "id": 141498,
                        "name": "Mayfield Heights",
                        "latitude": "41.51922000",
                        "longitude": "-81.45790000"
                    },
                    {
                        "id": 141499,
                        "name": "McArthur",
                        "latitude": "39.24646000",
                        "longitude": "-82.47849000"
                    },
                    {
                        "id": 141500,
                        "name": "McComb",
                        "latitude": "41.10755000",
                        "longitude": "-83.79271000"
                    },
                    {
                        "id": 141501,
                        "name": "McConnelsville",
                        "latitude": "39.64868000",
                        "longitude": "-81.85319000"
                    },
                    {
                        "id": 141502,
                        "name": "McDonald",
                        "latitude": "41.16367000",
                        "longitude": "-80.72424000"
                    },
                    {
                        "id": 141503,
                        "name": "McKinley Heights",
                        "latitude": "41.18367000",
                        "longitude": "-80.71730000"
                    },
                    {
                        "id": 141504,
                        "name": "Mechanicsburg",
                        "latitude": "40.07200000",
                        "longitude": "-83.55631000"
                    },
                    {
                        "id": 141505,
                        "name": "Medina",
                        "latitude": "41.13839000",
                        "longitude": "-81.86375000"
                    },
                    {
                        "id": 141506,
                        "name": "Medina County",
                        "latitude": "41.11759000",
                        "longitude": "-81.89971000"
                    },
                    {
                        "id": 141507,
                        "name": "Meigs County",
                        "latitude": "39.08224000",
                        "longitude": "-82.02290000"
                    },
                    {
                        "id": 141508,
                        "name": "Mentor",
                        "latitude": "41.66616000",
                        "longitude": "-81.33955000"
                    },
                    {
                        "id": 141509,
                        "name": "Mentor-on-the-Lake",
                        "latitude": "41.70504000",
                        "longitude": "-81.36039000"
                    },
                    {
                        "id": 141510,
                        "name": "Mercer County",
                        "latitude": "40.54001000",
                        "longitude": "-84.62936000"
                    },
                    {
                        "id": 141511,
                        "name": "Miami County",
                        "latitude": "40.05345000",
                        "longitude": "-84.22885000"
                    },
                    {
                        "id": 141512,
                        "name": "Miami Heights",
                        "latitude": "39.16506000",
                        "longitude": "-84.72050000"
                    },
                    {
                        "id": 141513,
                        "name": "Miamisburg",
                        "latitude": "39.64284000",
                        "longitude": "-84.28661000"
                    },
                    {
                        "id": 141514,
                        "name": "Miamitown",
                        "latitude": "39.21589000",
                        "longitude": "-84.70411000"
                    },
                    {
                        "id": 141515,
                        "name": "Middleburg Heights",
                        "latitude": "41.36144000",
                        "longitude": "-81.81291000"
                    },
                    {
                        "id": 141516,
                        "name": "Middlefield",
                        "latitude": "41.46200000",
                        "longitude": "-81.07371000"
                    },
                    {
                        "id": 141517,
                        "name": "Middleport",
                        "latitude": "39.00175000",
                        "longitude": "-82.04875000"
                    },
                    {
                        "id": 141518,
                        "name": "Middletown",
                        "latitude": "39.51506000",
                        "longitude": "-84.39828000"
                    },
                    {
                        "id": 141519,
                        "name": "Milan",
                        "latitude": "41.29755000",
                        "longitude": "-82.60545000"
                    },
                    {
                        "id": 141520,
                        "name": "Milford",
                        "latitude": "39.17534000",
                        "longitude": "-84.29438000"
                    },
                    {
                        "id": 141521,
                        "name": "Millbury",
                        "latitude": "41.56616000",
                        "longitude": "-83.42465000"
                    },
                    {
                        "id": 141522,
                        "name": "Millersburg",
                        "latitude": "40.55451000",
                        "longitude": "-81.91792000"
                    },
                    {
                        "id": 141523,
                        "name": "Millersport",
                        "latitude": "39.90006000",
                        "longitude": "-82.53405000"
                    },
                    {
                        "id": 141524,
                        "name": "Mineral Ridge",
                        "latitude": "41.14006000",
                        "longitude": "-80.76897000"
                    },
                    {
                        "id": 141525,
                        "name": "Minerva",
                        "latitude": "40.72978000",
                        "longitude": "-81.10538000"
                    },
                    {
                        "id": 141526,
                        "name": "Minerva Park",
                        "latitude": "40.07645000",
                        "longitude": "-82.94379000"
                    },
                    {
                        "id": 141527,
                        "name": "Mingo Junction",
                        "latitude": "40.32174000",
                        "longitude": "-80.60980000"
                    },
                    {
                        "id": 141528,
                        "name": "Minster",
                        "latitude": "40.39310000",
                        "longitude": "-84.37606000"
                    },
                    {
                        "id": 141529,
                        "name": "Mogadore",
                        "latitude": "41.04645000",
                        "longitude": "-81.39789000"
                    },
                    {
                        "id": 141530,
                        "name": "Monfort Heights",
                        "latitude": "39.18839000",
                        "longitude": "-84.59522000"
                    },
                    {
                        "id": 141531,
                        "name": "Monroe",
                        "latitude": "39.44034000",
                        "longitude": "-84.36216000"
                    },
                    {
                        "id": 141532,
                        "name": "Monroe County",
                        "latitude": "39.72735000",
                        "longitude": "-81.08292000"
                    },
                    {
                        "id": 141533,
                        "name": "Monroeville",
                        "latitude": "41.24422000",
                        "longitude": "-82.69629000"
                    },
                    {
                        "id": 141534,
                        "name": "Montgomery",
                        "latitude": "39.22811000",
                        "longitude": "-84.35411000"
                    },
                    {
                        "id": 141535,
                        "name": "Montgomery County",
                        "latitude": "39.75459000",
                        "longitude": "-84.29068000"
                    },
                    {
                        "id": 141536,
                        "name": "Montpelier",
                        "latitude": "41.58450000",
                        "longitude": "-84.60551000"
                    },
                    {
                        "id": 141537,
                        "name": "Montrose-Ghent",
                        "latitude": "41.15380000",
                        "longitude": "-81.64378000"
                    },
                    {
                        "id": 141538,
                        "name": "Moraine",
                        "latitude": "39.70617000",
                        "longitude": "-84.21938000"
                    },
                    {
                        "id": 141539,
                        "name": "Moreland Hills",
                        "latitude": "41.44783000",
                        "longitude": "-81.42762000"
                    },
                    {
                        "id": 141540,
                        "name": "Morgan County",
                        "latitude": "39.62037000",
                        "longitude": "-81.85266000"
                    },
                    {
                        "id": 141541,
                        "name": "Morgandale",
                        "latitude": "41.26561000",
                        "longitude": "-80.78286000"
                    },
                    {
                        "id": 141542,
                        "name": "Morrow",
                        "latitude": "39.35450000",
                        "longitude": "-84.12716000"
                    },
                    {
                        "id": 141543,
                        "name": "Morrow County",
                        "latitude": "40.52409000",
                        "longitude": "-82.79407000"
                    },
                    {
                        "id": 141544,
                        "name": "Mount Carmel",
                        "latitude": "39.10589000",
                        "longitude": "-84.30410000"
                    },
                    {
                        "id": 141545,
                        "name": "Mount Gilead",
                        "latitude": "40.54923000",
                        "longitude": "-82.82740000"
                    },
                    {
                        "id": 141546,
                        "name": "Mount Healthy",
                        "latitude": "39.23367000",
                        "longitude": "-84.54578000"
                    },
                    {
                        "id": 141547,
                        "name": "Mount Healthy Heights",
                        "latitude": "39.27033000",
                        "longitude": "-84.56800000"
                    },
                    {
                        "id": 141548,
                        "name": "Mount Orab",
                        "latitude": "39.02757000",
                        "longitude": "-83.91965000"
                    },
                    {
                        "id": 141549,
                        "name": "Mount Repose",
                        "latitude": "39.20062000",
                        "longitude": "-84.22438000"
                    },
                    {
                        "id": 141550,
                        "name": "Mount Sterling",
                        "latitude": "39.71951000",
                        "longitude": "-83.26519000"
                    },
                    {
                        "id": 141551,
                        "name": "Mount Vernon",
                        "latitude": "40.39340000",
                        "longitude": "-82.48572000"
                    },
                    {
                        "id": 141552,
                        "name": "Mulberry",
                        "latitude": "39.19339000",
                        "longitude": "-84.24216000"
                    },
                    {
                        "id": 141553,
                        "name": "Munroe Falls",
                        "latitude": "41.14450000",
                        "longitude": "-81.43983000"
                    },
                    {
                        "id": 141554,
                        "name": "Muskingum County",
                        "latitude": "39.96542000",
                        "longitude": "-81.94438000"
                    },
                    {
                        "id": 141555,
                        "name": "Napoleon",
                        "latitude": "41.39227000",
                        "longitude": "-84.12522000"
                    },
                    {
                        "id": 141556,
                        "name": "Navarre",
                        "latitude": "40.72450000",
                        "longitude": "-81.52207000"
                    },
                    {
                        "id": 141557,
                        "name": "Nelsonville",
                        "latitude": "39.45868000",
                        "longitude": "-82.23182000"
                    },
                    {
                        "id": 141558,
                        "name": "New Albany",
                        "latitude": "40.08117000",
                        "longitude": "-82.80879000"
                    },
                    {
                        "id": 141559,
                        "name": "New Boston",
                        "latitude": "38.75230000",
                        "longitude": "-82.93684000"
                    },
                    {
                        "id": 141560,
                        "name": "New Bremen",
                        "latitude": "40.43699000",
                        "longitude": "-84.37967000"
                    },
                    {
                        "id": 141561,
                        "name": "New Burlington",
                        "latitude": "39.25950000",
                        "longitude": "-84.55717000"
                    },
                    {
                        "id": 141562,
                        "name": "New California",
                        "latitude": "40.15617000",
                        "longitude": "-83.23658000"
                    },
                    {
                        "id": 141563,
                        "name": "New Carlisle",
                        "latitude": "39.93617000",
                        "longitude": "-84.02549000"
                    },
                    {
                        "id": 141564,
                        "name": "New Concord",
                        "latitude": "39.99368000",
                        "longitude": "-81.73402000"
                    },
                    {
                        "id": 141565,
                        "name": "New Franklin",
                        "latitude": "40.94172000",
                        "longitude": "-81.54151000"
                    },
                    {
                        "id": 141566,
                        "name": "New Lebanon",
                        "latitude": "39.74533000",
                        "longitude": "-84.38495000"
                    },
                    {
                        "id": 141567,
                        "name": "New Lexington",
                        "latitude": "39.71396000",
                        "longitude": "-82.20848000"
                    },
                    {
                        "id": 141568,
                        "name": "New London",
                        "latitude": "41.08505000",
                        "longitude": "-82.39989000"
                    },
                    {
                        "id": 141569,
                        "name": "New Matamoras",
                        "latitude": "39.52452000",
                        "longitude": "-81.06705000"
                    },
                    {
                        "id": 141570,
                        "name": "New Miami",
                        "latitude": "39.43478000",
                        "longitude": "-84.53689000"
                    },
                    {
                        "id": 141571,
                        "name": "New Middletown",
                        "latitude": "40.96117000",
                        "longitude": "-80.55757000"
                    },
                    {
                        "id": 141572,
                        "name": "New Paris",
                        "latitude": "39.85699000",
                        "longitude": "-84.79329000"
                    },
                    {
                        "id": 141573,
                        "name": "New Philadelphia",
                        "latitude": "40.48979000",
                        "longitude": "-81.44567000"
                    },
                    {
                        "id": 141574,
                        "name": "New Richmond",
                        "latitude": "38.94868000",
                        "longitude": "-84.27994000"
                    },
                    {
                        "id": 141575,
                        "name": "New Vienna",
                        "latitude": "39.32367000",
                        "longitude": "-83.69103000"
                    },
                    {
                        "id": 141576,
                        "name": "New Waterford",
                        "latitude": "40.84506000",
                        "longitude": "-80.61452000"
                    },
                    {
                        "id": 141577,
                        "name": "Newark",
                        "latitude": "40.05812000",
                        "longitude": "-82.40126000"
                    },
                    {
                        "id": 141578,
                        "name": "Newburgh Heights",
                        "latitude": "41.45005000",
                        "longitude": "-81.66346000"
                    },
                    {
                        "id": 141579,
                        "name": "Newcomerstown",
                        "latitude": "40.27229000",
                        "longitude": "-81.60595000"
                    },
                    {
                        "id": 141580,
                        "name": "Newport",
                        "latitude": "39.39091000",
                        "longitude": "-81.22678000"
                    },
                    {
                        "id": 141581,
                        "name": "Newton Falls",
                        "latitude": "41.18839000",
                        "longitude": "-80.97815000"
                    },
                    {
                        "id": 141582,
                        "name": "Newtown",
                        "latitude": "39.12450000",
                        "longitude": "-84.36161000"
                    },
                    {
                        "id": 141583,
                        "name": "Niles",
                        "latitude": "41.18284000",
                        "longitude": "-80.76536000"
                    },
                    {
                        "id": 141584,
                        "name": "Noble County",
                        "latitude": "39.76596000",
                        "longitude": "-81.45556000"
                    },
                    {
                        "id": 141585,
                        "name": "North Baltimore",
                        "latitude": "41.18283000",
                        "longitude": "-83.67827000"
                    },
                    {
                        "id": 141586,
                        "name": "North Canton",
                        "latitude": "40.87589000",
                        "longitude": "-81.40234000"
                    },
                    {
                        "id": 141587,
                        "name": "North College Hill",
                        "latitude": "39.21839000",
                        "longitude": "-84.55078000"
                    },
                    {
                        "id": 141588,
                        "name": "North Fork Village",
                        "latitude": "39.33590000",
                        "longitude": "-83.02907000"
                    },
                    {
                        "id": 141589,
                        "name": "North Kingsville",
                        "latitude": "41.90589000",
                        "longitude": "-80.69036000"
                    },
                    {
                        "id": 141590,
                        "name": "North Lewisburg",
                        "latitude": "40.22311000",
                        "longitude": "-83.55743000"
                    },
                    {
                        "id": 141591,
                        "name": "North Madison",
                        "latitude": "41.80200000",
                        "longitude": "-81.04899000"
                    },
                    {
                        "id": 141592,
                        "name": "North Olmsted",
                        "latitude": "41.41560000",
                        "longitude": "-81.92347000"
                    },
                    {
                        "id": 141593,
                        "name": "North Randall",
                        "latitude": "41.43478000",
                        "longitude": "-81.52568000"
                    },
                    {
                        "id": 141594,
                        "name": "North Ridgeville",
                        "latitude": "41.38949000",
                        "longitude": "-82.01903000"
                    },
                    {
                        "id": 141595,
                        "name": "North Royalton",
                        "latitude": "41.31366000",
                        "longitude": "-81.72457000"
                    },
                    {
                        "id": 141596,
                        "name": "North Zanesville",
                        "latitude": "39.97868000",
                        "longitude": "-82.00347000"
                    },
                    {
                        "id": 141597,
                        "name": "Northbrook",
                        "latitude": "39.24645000",
                        "longitude": "-84.58356000"
                    },
                    {
                        "id": 141598,
                        "name": "Northfield",
                        "latitude": "41.34505000",
                        "longitude": "-81.52845000"
                    },
                    {
                        "id": 141599,
                        "name": "Northgate",
                        "latitude": "39.25283000",
                        "longitude": "-84.59245000"
                    },
                    {
                        "id": 141600,
                        "name": "Northridge",
                        "latitude": "39.80756000",
                        "longitude": "-84.19689000"
                    },
                    {
                        "id": 141601,
                        "name": "Northwood",
                        "latitude": "40.47283000",
                        "longitude": "-83.73243000"
                    },
                    {
                        "id": 141602,
                        "name": "Norton",
                        "latitude": "41.02922000",
                        "longitude": "-81.63818000"
                    },
                    {
                        "id": 141603,
                        "name": "Norwalk",
                        "latitude": "41.24255000",
                        "longitude": "-82.61573000"
                    },
                    {
                        "id": 141604,
                        "name": "Norwood",
                        "latitude": "39.15561000",
                        "longitude": "-84.45966000"
                    },
                    {
                        "id": 141605,
                        "name": "Oak Harbor",
                        "latitude": "41.50672000",
                        "longitude": "-83.14659000"
                    },
                    {
                        "id": 141606,
                        "name": "Oak Hill",
                        "latitude": "38.89396000",
                        "longitude": "-82.57349000"
                    },
                    {
                        "id": 141607,
                        "name": "Oakwood",
                        "latitude": "39.72534000",
                        "longitude": "-84.17411000"
                    },
                    {
                        "id": 141608,
                        "name": "Oberlin",
                        "latitude": "41.29394000",
                        "longitude": "-82.21738000"
                    },
                    {
                        "id": 141609,
                        "name": "Obetz",
                        "latitude": "39.87895000",
                        "longitude": "-82.95074000"
                    },
                    {
                        "id": 141610,
                        "name": "Olmsted Falls",
                        "latitude": "41.37505000",
                        "longitude": "-81.90819000"
                    },
                    {
                        "id": 141611,
                        "name": "Ontario",
                        "latitude": "40.75950000",
                        "longitude": "-82.59017000"
                    },
                    {
                        "id": 141612,
                        "name": "Orange",
                        "latitude": "41.44978000",
                        "longitude": "-81.48067000"
                    },
                    {
                        "id": 141613,
                        "name": "Oregon",
                        "latitude": "41.64366000",
                        "longitude": "-83.48688000"
                    },
                    {
                        "id": 141614,
                        "name": "Orrville",
                        "latitude": "40.84367000",
                        "longitude": "-81.76402000"
                    },
                    {
                        "id": 141615,
                        "name": "Orwell",
                        "latitude": "41.53506000",
                        "longitude": "-80.86814000"
                    },
                    {
                        "id": 141616,
                        "name": "Ottawa",
                        "latitude": "41.01922000",
                        "longitude": "-84.04717000"
                    },
                    {
                        "id": 141617,
                        "name": "Ottawa County",
                        "latitude": "41.49675000",
                        "longitude": "-82.94128000"
                    },
                    {
                        "id": 141618,
                        "name": "Ottawa Hills",
                        "latitude": "41.66422000",
                        "longitude": "-83.64327000"
                    },
                    {
                        "id": 141619,
                        "name": "Oxford",
                        "latitude": "39.50700000",
                        "longitude": "-84.74523000"
                    },
                    {
                        "id": 141620,
                        "name": "Painesville",
                        "latitude": "41.72449000",
                        "longitude": "-81.24566000"
                    },
                    {
                        "id": 141621,
                        "name": "Pandora",
                        "latitude": "40.94811000",
                        "longitude": "-83.96105000"
                    },
                    {
                        "id": 141622,
                        "name": "Park Layne",
                        "latitude": "39.88645000",
                        "longitude": "-84.03966000"
                    },
                    {
                        "id": 141623,
                        "name": "Parma",
                        "latitude": "41.40477000",
                        "longitude": "-81.72291000"
                    },
                    {
                        "id": 141624,
                        "name": "Parma Heights",
                        "latitude": "41.39005000",
                        "longitude": "-81.75958000"
                    },
                    {
                        "id": 141625,
                        "name": "Pataskala",
                        "latitude": "39.99562000",
                        "longitude": "-82.67433000"
                    },
                    {
                        "id": 141626,
                        "name": "Paulding",
                        "latitude": "41.13811000",
                        "longitude": "-84.58051000"
                    },
                    {
                        "id": 141627,
                        "name": "Paulding County",
                        "latitude": "41.11662000",
                        "longitude": "-84.58020000"
                    },
                    {
                        "id": 141628,
                        "name": "Payne",
                        "latitude": "41.07755000",
                        "longitude": "-84.72718000"
                    },
                    {
                        "id": 141629,
                        "name": "Peebles",
                        "latitude": "38.94896000",
                        "longitude": "-83.40575000"
                    },
                    {
                        "id": 141630,
                        "name": "Pemberville",
                        "latitude": "41.41089000",
                        "longitude": "-83.46104000"
                    },
                    {
                        "id": 141631,
                        "name": "Pepper Pike",
                        "latitude": "41.47839000",
                        "longitude": "-81.46373000"
                    },
                    {
                        "id": 141632,
                        "name": "Perry",
                        "latitude": "41.76033000",
                        "longitude": "-81.14093000"
                    },
                    {
                        "id": 141633,
                        "name": "Perry County",
                        "latitude": "39.73715000",
                        "longitude": "-82.23614000"
                    },
                    {
                        "id": 141634,
                        "name": "Perry Heights",
                        "latitude": "40.79534000",
                        "longitude": "-81.47345000"
                    },
                    {
                        "id": 141635,
                        "name": "Perrysburg",
                        "latitude": "41.55700000",
                        "longitude": "-83.62716000"
                    },
                    {
                        "id": 141636,
                        "name": "Pickaway County",
                        "latitude": "39.64194000",
                        "longitude": "-83.02439000"
                    },
                    {
                        "id": 141637,
                        "name": "Pickerington",
                        "latitude": "39.88423000",
                        "longitude": "-82.75350000"
                    },
                    {
                        "id": 141638,
                        "name": "Pike County",
                        "latitude": "39.07737000",
                        "longitude": "-83.06685000"
                    },
                    {
                        "id": 141639,
                        "name": "Piketon",
                        "latitude": "39.06813000",
                        "longitude": "-83.01434000"
                    },
                    {
                        "id": 141640,
                        "name": "Pioneer",
                        "latitude": "41.68005000",
                        "longitude": "-84.55301000"
                    },
                    {
                        "id": 141641,
                        "name": "Piqua",
                        "latitude": "40.14477000",
                        "longitude": "-84.24244000"
                    },
                    {
                        "id": 141642,
                        "name": "Plain City",
                        "latitude": "40.10756000",
                        "longitude": "-83.26742000"
                    },
                    {
                        "id": 141643,
                        "name": "Pleasant Grove",
                        "latitude": "39.95201000",
                        "longitude": "-81.95902000"
                    },
                    {
                        "id": 141644,
                        "name": "Pleasant Hill",
                        "latitude": "40.05172000",
                        "longitude": "-84.34439000"
                    },
                    {
                        "id": 141645,
                        "name": "Pleasant Run",
                        "latitude": "39.29978000",
                        "longitude": "-84.56356000"
                    },
                    {
                        "id": 141646,
                        "name": "Pleasant Run Farm",
                        "latitude": "39.30311000",
                        "longitude": "-84.54800000"
                    },
                    {
                        "id": 141647,
                        "name": "Plymouth",
                        "latitude": "40.99561000",
                        "longitude": "-82.66712000"
                    },
                    {
                        "id": 141648,
                        "name": "Poland",
                        "latitude": "41.02423000",
                        "longitude": "-80.61480000"
                    },
                    {
                        "id": 141649,
                        "name": "Pomeroy",
                        "latitude": "39.02758000",
                        "longitude": "-82.03375000"
                    },
                    {
                        "id": 141650,
                        "name": "Port Clinton",
                        "latitude": "41.51200000",
                        "longitude": "-82.93769000"
                    },
                    {
                        "id": 141651,
                        "name": "Portage County",
                        "latitude": "41.16768000",
                        "longitude": "-81.19740000"
                    },
                    {
                        "id": 141652,
                        "name": "Portage Lakes",
                        "latitude": "41.00728000",
                        "longitude": "-81.52706000"
                    },
                    {
                        "id": 141653,
                        "name": "Portsmouth",
                        "latitude": "38.73174000",
                        "longitude": "-82.99767000"
                    },
                    {
                        "id": 141654,
                        "name": "Powell",
                        "latitude": "40.15784000",
                        "longitude": "-83.07519000"
                    },
                    {
                        "id": 141655,
                        "name": "Powhatan Point",
                        "latitude": "39.86008000",
                        "longitude": "-80.81537000"
                    },
                    {
                        "id": 141656,
                        "name": "Preble County",
                        "latitude": "39.74157000",
                        "longitude": "-84.64802000"
                    },
                    {
                        "id": 141657,
                        "name": "Prospect",
                        "latitude": "40.45034000",
                        "longitude": "-83.18853000"
                    },
                    {
                        "id": 141658,
                        "name": "Putnam County",
                        "latitude": "41.02208000",
                        "longitude": "-84.13173000"
                    },
                    {
                        "id": 141659,
                        "name": "Ravenna",
                        "latitude": "41.15756000",
                        "longitude": "-81.24205000"
                    },
                    {
                        "id": 141660,
                        "name": "Reading",
                        "latitude": "39.22367000",
                        "longitude": "-84.44216000"
                    },
                    {
                        "id": 141661,
                        "name": "Reminderville",
                        "latitude": "41.34589000",
                        "longitude": "-81.39511000"
                    },
                    {
                        "id": 141662,
                        "name": "Reno",
                        "latitude": "39.37285000",
                        "longitude": "-81.39567000"
                    },
                    {
                        "id": 141663,
                        "name": "Reynoldsburg",
                        "latitude": "39.95479000",
                        "longitude": "-82.81212000"
                    },
                    {
                        "id": 141664,
                        "name": "Richfield",
                        "latitude": "41.23978000",
                        "longitude": "-81.63818000"
                    },
                    {
                        "id": 141665,
                        "name": "Richland County",
                        "latitude": "40.77468000",
                        "longitude": "-82.53648000"
                    },
                    {
                        "id": 141666,
                        "name": "Richmond Heights",
                        "latitude": "41.55283000",
                        "longitude": "-81.51012000"
                    },
                    {
                        "id": 141667,
                        "name": "Richville",
                        "latitude": "40.75117000",
                        "longitude": "-81.47790000"
                    },
                    {
                        "id": 141668,
                        "name": "Richwood",
                        "latitude": "40.42645000",
                        "longitude": "-83.29686000"
                    },
                    {
                        "id": 141669,
                        "name": "Ripley",
                        "latitude": "38.74563000",
                        "longitude": "-83.84492000"
                    },
                    {
                        "id": 141670,
                        "name": "Rittman",
                        "latitude": "40.97811000",
                        "longitude": "-81.78208000"
                    },
                    {
                        "id": 141671,
                        "name": "Riverside",
                        "latitude": "39.77978000",
                        "longitude": "-84.12410000"
                    },
                    {
                        "id": 141672,
                        "name": "Roaming Shores",
                        "latitude": "41.64311000",
                        "longitude": "-80.82342000"
                    },
                    {
                        "id": 141673,
                        "name": "Rockford",
                        "latitude": "40.68783000",
                        "longitude": "-84.64663000"
                    },
                    {
                        "id": 141674,
                        "name": "Rocky River",
                        "latitude": "41.47560000",
                        "longitude": "-81.83930000"
                    },
                    {
                        "id": 141675,
                        "name": "Rosemount",
                        "latitude": "38.78619000",
                        "longitude": "-82.97906000"
                    },
                    {
                        "id": 141676,
                        "name": "Roseville",
                        "latitude": "39.80729000",
                        "longitude": "-82.07125000"
                    },
                    {
                        "id": 141677,
                        "name": "Ross",
                        "latitude": "39.31228000",
                        "longitude": "-84.65050000"
                    },
                    {
                        "id": 141678,
                        "name": "Ross County",
                        "latitude": "39.33763000",
                        "longitude": "-83.05703000"
                    },
                    {
                        "id": 141679,
                        "name": "Rossford",
                        "latitude": "41.60977000",
                        "longitude": "-83.56438000"
                    },
                    {
                        "id": 141680,
                        "name": "Rossmoyne",
                        "latitude": "39.21367000",
                        "longitude": "-84.38688000"
                    },
                    {
                        "id": 141681,
                        "name": "Russells Point",
                        "latitude": "40.47116000",
                        "longitude": "-83.89272000"
                    },
                    {
                        "id": 141682,
                        "name": "Sabina",
                        "latitude": "39.48867000",
                        "longitude": "-83.63687000"
                    },
                    {
                        "id": 141683,
                        "name": "Saint Bernard",
                        "latitude": "39.16700000",
                        "longitude": "-84.49855000"
                    },
                    {
                        "id": 141684,
                        "name": "Saint Clairsville",
                        "latitude": "40.08063000",
                        "longitude": "-80.90009000"
                    },
                    {
                        "id": 141685,
                        "name": "Saint Henry",
                        "latitude": "40.41755000",
                        "longitude": "-84.63968000"
                    },
                    {
                        "id": 141686,
                        "name": "Saint Marys",
                        "latitude": "40.54227000",
                        "longitude": "-84.38940000"
                    },
                    {
                        "id": 141687,
                        "name": "Saint Paris",
                        "latitude": "40.12839000",
                        "longitude": "-83.95966000"
                    },
                    {
                        "id": 141688,
                        "name": "Salem",
                        "latitude": "40.90089000",
                        "longitude": "-80.85675000"
                    },
                    {
                        "id": 141689,
                        "name": "Salem Heights",
                        "latitude": "39.07173000",
                        "longitude": "-84.37827000"
                    },
                    {
                        "id": 141690,
                        "name": "Salineville",
                        "latitude": "40.62256000",
                        "longitude": "-80.83786000"
                    },
                    {
                        "id": 141691,
                        "name": "Sandusky",
                        "latitude": "41.44894000",
                        "longitude": "-82.70796000"
                    },
                    {
                        "id": 141692,
                        "name": "Sandusky County",
                        "latitude": "41.35742000",
                        "longitude": "-83.14391000"
                    },
                    {
                        "id": 141693,
                        "name": "Sawyerwood",
                        "latitude": "41.03783000",
                        "longitude": "-81.44095000"
                    },
                    {
                        "id": 141694,
                        "name": "Scioto County",
                        "latitude": "38.80396000",
                        "longitude": "-82.99283000"
                    },
                    {
                        "id": 141695,
                        "name": "Sciotodale",
                        "latitude": "38.75480000",
                        "longitude": "-82.86878000"
                    },
                    {
                        "id": 141696,
                        "name": "Sebring",
                        "latitude": "40.92284000",
                        "longitude": "-81.01898000"
                    },
                    {
                        "id": 141697,
                        "name": "Seneca County",
                        "latitude": "41.12388000",
                        "longitude": "-83.12771000"
                    },
                    {
                        "id": 141698,
                        "name": "Seven Hills",
                        "latitude": "41.39533000",
                        "longitude": "-81.67624000"
                    },
                    {
                        "id": 141699,
                        "name": "Seville",
                        "latitude": "41.01006000",
                        "longitude": "-81.86236000"
                    },
                    {
                        "id": 141700,
                        "name": "Shadyside",
                        "latitude": "39.97091000",
                        "longitude": "-80.75064000"
                    },
                    {
                        "id": 141701,
                        "name": "Shaker Heights",
                        "latitude": "41.47394000",
                        "longitude": "-81.53707000"
                    },
                    {
                        "id": 141702,
                        "name": "Sharonville",
                        "latitude": "39.26811000",
                        "longitude": "-84.41327000"
                    },
                    {
                        "id": 141703,
                        "name": "Shawnee Hills",
                        "latitude": "39.65284000",
                        "longitude": "-83.78687000"
                    },
                    {
                        "id": 141704,
                        "name": "Sheffield",
                        "latitude": "41.42115000",
                        "longitude": "-82.09626000"
                    },
                    {
                        "id": 141705,
                        "name": "Sheffield Lake",
                        "latitude": "41.48754000",
                        "longitude": "-82.10154000"
                    },
                    {
                        "id": 141706,
                        "name": "Shelby",
                        "latitude": "40.88145000",
                        "longitude": "-82.66184000"
                    },
                    {
                        "id": 141707,
                        "name": "Shelby County",
                        "latitude": "40.33153000",
                        "longitude": "-84.20473000"
                    },
                    {
                        "id": 141708,
                        "name": "Sherwood",
                        "latitude": "39.08478000",
                        "longitude": "-84.36077000"
                    },
                    {
                        "id": 141709,
                        "name": "Shiloh",
                        "latitude": "39.81867000",
                        "longitude": "-84.22855000"
                    },
                    {
                        "id": 141710,
                        "name": "Shreve",
                        "latitude": "40.68145000",
                        "longitude": "-82.02181000"
                    },
                    {
                        "id": 141711,
                        "name": "Sidney",
                        "latitude": "40.28422000",
                        "longitude": "-84.15550000"
                    },
                    {
                        "id": 141712,
                        "name": "Silver Lake",
                        "latitude": "41.15895000",
                        "longitude": "-81.45428000"
                    },
                    {
                        "id": 141713,
                        "name": "Silverton",
                        "latitude": "39.19284000",
                        "longitude": "-84.40050000"
                    },
                    {
                        "id": 141714,
                        "name": "Sixteen Mile Stand",
                        "latitude": "39.27284000",
                        "longitude": "-84.32744000"
                    },
                    {
                        "id": 141715,
                        "name": "Skyline Acres",
                        "latitude": "39.22867000",
                        "longitude": "-84.56689000"
                    },
                    {
                        "id": 141716,
                        "name": "Smithville",
                        "latitude": "40.86228000",
                        "longitude": "-81.86180000"
                    },
                    {
                        "id": 141717,
                        "name": "Solon",
                        "latitude": "41.38978000",
                        "longitude": "-81.44123000"
                    },
                    {
                        "id": 141718,
                        "name": "Somerset",
                        "latitude": "39.80701000",
                        "longitude": "-82.29709000"
                    },
                    {
                        "id": 141719,
                        "name": "South Amherst",
                        "latitude": "41.35588000",
                        "longitude": "-82.25377000"
                    },
                    {
                        "id": 141720,
                        "name": "South Bloomfield",
                        "latitude": "39.71840000",
                        "longitude": "-82.98685000"
                    },
                    {
                        "id": 141721,
                        "name": "South Canal",
                        "latitude": "41.17728000",
                        "longitude": "-80.98676000"
                    },
                    {
                        "id": 141722,
                        "name": "South Charleston",
                        "latitude": "39.82534000",
                        "longitude": "-83.63437000"
                    },
                    {
                        "id": 141723,
                        "name": "South Euclid",
                        "latitude": "41.52311000",
                        "longitude": "-81.51846000"
                    },
                    {
                        "id": 141724,
                        "name": "South Lebanon",
                        "latitude": "39.37089000",
                        "longitude": "-84.21327000"
                    },
                    {
                        "id": 141725,
                        "name": "South Point",
                        "latitude": "38.41786000",
                        "longitude": "-82.58627000"
                    },
                    {
                        "id": 141726,
                        "name": "South Russell",
                        "latitude": "41.43144000",
                        "longitude": "-81.36539000"
                    },
                    {
                        "id": 141727,
                        "name": "South Zanesville",
                        "latitude": "39.89923000",
                        "longitude": "-82.00625000"
                    },
                    {
                        "id": 141728,
                        "name": "Spencerville",
                        "latitude": "40.70894000",
                        "longitude": "-84.35356000"
                    },
                    {
                        "id": 141729,
                        "name": "Springboro",
                        "latitude": "39.55228000",
                        "longitude": "-84.23327000"
                    },
                    {
                        "id": 141730,
                        "name": "Springdale",
                        "latitude": "39.28700000",
                        "longitude": "-84.48522000"
                    },
                    {
                        "id": 141731,
                        "name": "Springfield",
                        "latitude": "39.92423000",
                        "longitude": "-83.80882000"
                    },
                    {
                        "id": 141732,
                        "name": "Stark County",
                        "latitude": "40.81389000",
                        "longitude": "-81.36564000"
                    },
                    {
                        "id": 141733,
                        "name": "Steubenville",
                        "latitude": "40.36979000",
                        "longitude": "-80.63396000"
                    },
                    {
                        "id": 141734,
                        "name": "Stony Prairie",
                        "latitude": "41.35144000",
                        "longitude": "-83.15520000"
                    },
                    {
                        "id": 141735,
                        "name": "Stow",
                        "latitude": "41.15950000",
                        "longitude": "-81.44039000"
                    },
                    {
                        "id": 141736,
                        "name": "Strasburg",
                        "latitude": "40.59478000",
                        "longitude": "-81.52679000"
                    },
                    {
                        "id": 141737,
                        "name": "Streetsboro",
                        "latitude": "41.23922000",
                        "longitude": "-81.34594000"
                    },
                    {
                        "id": 141738,
                        "name": "Strongsville",
                        "latitude": "41.31450000",
                        "longitude": "-81.83569000"
                    },
                    {
                        "id": 141739,
                        "name": "Struthers",
                        "latitude": "41.05256000",
                        "longitude": "-80.60785000"
                    },
                    {
                        "id": 141740,
                        "name": "Stryker",
                        "latitude": "41.50366000",
                        "longitude": "-84.41412000"
                    },
                    {
                        "id": 141741,
                        "name": "Sugarcreek",
                        "latitude": "40.50312000",
                        "longitude": "-81.64096000"
                    },
                    {
                        "id": 141742,
                        "name": "Sugarcreek Police Dept",
                        "latitude": "40.50253000",
                        "longitude": "-81.64176000"
                    },
                    {
                        "id": 141743,
                        "name": "Summerside",
                        "latitude": "39.10478000",
                        "longitude": "-84.28827000"
                    },
                    {
                        "id": 141744,
                        "name": "Summit County",
                        "latitude": "41.12598000",
                        "longitude": "-81.53217000"
                    },
                    {
                        "id": 141745,
                        "name": "Sunbury",
                        "latitude": "40.24256000",
                        "longitude": "-82.85907000"
                    },
                    {
                        "id": 141746,
                        "name": "Swanton",
                        "latitude": "41.58866000",
                        "longitude": "-83.89105000"
                    },
                    {
                        "id": 141747,
                        "name": "Sylvania",
                        "latitude": "41.71894000",
                        "longitude": "-83.71299000"
                    },
                    {
                        "id": 141748,
                        "name": "Tallmadge",
                        "latitude": "41.10145000",
                        "longitude": "-81.44178000"
                    },
                    {
                        "id": 141749,
                        "name": "Terrace Park",
                        "latitude": "39.15923000",
                        "longitude": "-84.30716000"
                    },
                    {
                        "id": 141750,
                        "name": "The Plains",
                        "latitude": "39.36896000",
                        "longitude": "-82.13237000"
                    },
                    {
                        "id": 141751,
                        "name": "The Village of Indian Hill",
                        "latitude": "39.17949000",
                        "longitude": "-84.33517000"
                    },
                    {
                        "id": 141752,
                        "name": "Thornport",
                        "latitude": "39.91312000",
                        "longitude": "-82.41099000"
                    },
                    {
                        "id": 141753,
                        "name": "Tiffin",
                        "latitude": "41.11450000",
                        "longitude": "-83.17797000"
                    },
                    {
                        "id": 141754,
                        "name": "Tiltonsville",
                        "latitude": "40.16674000",
                        "longitude": "-80.69980000"
                    },
                    {
                        "id": 141755,
                        "name": "Tipp City",
                        "latitude": "39.95839000",
                        "longitude": "-84.17216000"
                    },
                    {
                        "id": 141756,
                        "name": "Toledo",
                        "latitude": "41.66394000",
                        "longitude": "-83.55521000"
                    },
                    {
                        "id": 141757,
                        "name": "Toronto",
                        "latitude": "40.46423000",
                        "longitude": "-80.60091000"
                    },
                    {
                        "id": 141758,
                        "name": "Trenton",
                        "latitude": "39.48089000",
                        "longitude": "-84.45772000"
                    },
                    {
                        "id": 141759,
                        "name": "Trotwood",
                        "latitude": "39.79728000",
                        "longitude": "-84.31133000"
                    },
                    {
                        "id": 141760,
                        "name": "Troy",
                        "latitude": "40.03950000",
                        "longitude": "-84.20328000"
                    },
                    {
                        "id": 141761,
                        "name": "Trumbull County",
                        "latitude": "41.31717000",
                        "longitude": "-80.76116000"
                    },
                    {
                        "id": 141762,
                        "name": "Turpin Hills",
                        "latitude": "39.11006000",
                        "longitude": "-84.37994000"
                    },
                    {
                        "id": 141763,
                        "name": "Tuscarawas",
                        "latitude": "40.39479000",
                        "longitude": "-81.40706000"
                    },
                    {
                        "id": 141764,
                        "name": "Tuscarawas County",
                        "latitude": "40.44096000",
                        "longitude": "-81.47377000"
                    },
                    {
                        "id": 141765,
                        "name": "Twinsburg",
                        "latitude": "41.31256000",
                        "longitude": "-81.44011000"
                    },
                    {
                        "id": 141766,
                        "name": "Uhrichsville",
                        "latitude": "40.39312000",
                        "longitude": "-81.34650000"
                    },
                    {
                        "id": 141767,
                        "name": "Union",
                        "latitude": "39.89783000",
                        "longitude": "-84.30633000"
                    },
                    {
                        "id": 141768,
                        "name": "Union City",
                        "latitude": "40.19938000",
                        "longitude": "-84.80353000"
                    },
                    {
                        "id": 141769,
                        "name": "Union County",
                        "latitude": "40.29940000",
                        "longitude": "-83.37158000"
                    },
                    {
                        "id": 141770,
                        "name": "Uniontown",
                        "latitude": "40.97506000",
                        "longitude": "-81.40817000"
                    },
                    {
                        "id": 141771,
                        "name": "University Heights",
                        "latitude": "41.49783000",
                        "longitude": "-81.53735000"
                    },
                    {
                        "id": 141772,
                        "name": "Upper Arlington",
                        "latitude": "39.99451000",
                        "longitude": "-83.06241000"
                    },
                    {
                        "id": 141773,
                        "name": "Upper Sandusky",
                        "latitude": "40.82728000",
                        "longitude": "-83.28131000"
                    },
                    {
                        "id": 141774,
                        "name": "Urbana",
                        "latitude": "40.10839000",
                        "longitude": "-83.75243000"
                    },
                    {
                        "id": 141775,
                        "name": "Urbancrest",
                        "latitude": "39.89756000",
                        "longitude": "-83.08685000"
                    },
                    {
                        "id": 141776,
                        "name": "Utica",
                        "latitude": "40.23423000",
                        "longitude": "-82.45127000"
                    },
                    {
                        "id": 141777,
                        "name": "Valley View",
                        "latitude": "41.38783000",
                        "longitude": "-81.60457000"
                    },
                    {
                        "id": 141778,
                        "name": "Van Wert",
                        "latitude": "40.86949000",
                        "longitude": "-84.58412000"
                    },
                    {
                        "id": 141779,
                        "name": "Van Wert County",
                        "latitude": "40.85540000",
                        "longitude": "-84.58610000"
                    },
                    {
                        "id": 141780,
                        "name": "Vandalia",
                        "latitude": "39.89061000",
                        "longitude": "-84.19883000"
                    },
                    {
                        "id": 141781,
                        "name": "Vermilion",
                        "latitude": "41.42199000",
                        "longitude": "-82.36461000"
                    },
                    {
                        "id": 141782,
                        "name": "Vermilion-on-the-Lake",
                        "latitude": "41.42838000",
                        "longitude": "-82.32377000"
                    },
                    {
                        "id": 141783,
                        "name": "Versailles",
                        "latitude": "40.22255000",
                        "longitude": "-84.48440000"
                    },
                    {
                        "id": 141784,
                        "name": "Vinton County",
                        "latitude": "39.25099000",
                        "longitude": "-82.48535000"
                    },
                    {
                        "id": 141785,
                        "name": "Wadsworth",
                        "latitude": "41.02561000",
                        "longitude": "-81.72985000"
                    },
                    {
                        "id": 141786,
                        "name": "Wakeman",
                        "latitude": "41.25450000",
                        "longitude": "-82.39961000"
                    },
                    {
                        "id": 141787,
                        "name": "Walbridge",
                        "latitude": "41.58783000",
                        "longitude": "-83.49327000"
                    },
                    {
                        "id": 141788,
                        "name": "Walton Hills",
                        "latitude": "41.36561000",
                        "longitude": "-81.56123000"
                    },
                    {
                        "id": 141789,
                        "name": "Wapakoneta",
                        "latitude": "40.56783000",
                        "longitude": "-84.19356000"
                    },
                    {
                        "id": 141790,
                        "name": "Warren",
                        "latitude": "41.23756000",
                        "longitude": "-80.81842000"
                    },
                    {
                        "id": 141791,
                        "name": "Warren County",
                        "latitude": "39.42758000",
                        "longitude": "-84.16676000"
                    },
                    {
                        "id": 141792,
                        "name": "Warrensville Heights",
                        "latitude": "41.43505000",
                        "longitude": "-81.53623000"
                    },
                    {
                        "id": 141793,
                        "name": "Washington County",
                        "latitude": "39.45532000",
                        "longitude": "-81.49525000"
                    },
                    {
                        "id": 141794,
                        "name": "Washington Court House",
                        "latitude": "39.53645000",
                        "longitude": "-83.43908000"
                    },
                    {
                        "id": 141795,
                        "name": "Waterville",
                        "latitude": "41.50089000",
                        "longitude": "-83.71827000"
                    },
                    {
                        "id": 141796,
                        "name": "Wauseon",
                        "latitude": "41.54922000",
                        "longitude": "-84.14161000"
                    },
                    {
                        "id": 141797,
                        "name": "Waverly",
                        "latitude": "39.12673000",
                        "longitude": "-82.98546000"
                    },
                    {
                        "id": 141798,
                        "name": "Wayne County",
                        "latitude": "40.82887000",
                        "longitude": "-81.88803000"
                    },
                    {
                        "id": 141799,
                        "name": "Waynesville",
                        "latitude": "39.52978000",
                        "longitude": "-84.08660000"
                    },
                    {
                        "id": 141800,
                        "name": "Wellington",
                        "latitude": "41.16894000",
                        "longitude": "-82.21794000"
                    },
                    {
                        "id": 141801,
                        "name": "Wellston",
                        "latitude": "39.12341000",
                        "longitude": "-82.53294000"
                    },
                    {
                        "id": 141802,
                        "name": "Wellsville",
                        "latitude": "40.60284000",
                        "longitude": "-80.64896000"
                    },
                    {
                        "id": 141803,
                        "name": "West Alexandria",
                        "latitude": "39.74450000",
                        "longitude": "-84.53217000"
                    },
                    {
                        "id": 141804,
                        "name": "West Carrollton City",
                        "latitude": "39.67228000",
                        "longitude": "-84.25216000"
                    },
                    {
                        "id": 141805,
                        "name": "West Hill",
                        "latitude": "41.23283000",
                        "longitude": "-80.51924000"
                    },
                    {
                        "id": 141806,
                        "name": "West Jefferson",
                        "latitude": "39.94478000",
                        "longitude": "-83.26880000"
                    },
                    {
                        "id": 141807,
                        "name": "West Lafayette",
                        "latitude": "40.27535000",
                        "longitude": "-81.75096000"
                    },
                    {
                        "id": 141808,
                        "name": "West Liberty",
                        "latitude": "40.25228000",
                        "longitude": "-83.75577000"
                    },
                    {
                        "id": 141809,
                        "name": "West Milton",
                        "latitude": "39.96255000",
                        "longitude": "-84.32800000"
                    },
                    {
                        "id": 141810,
                        "name": "West Portsmouth",
                        "latitude": "38.75841000",
                        "longitude": "-83.02906000"
                    },
                    {
                        "id": 141811,
                        "name": "West Salem",
                        "latitude": "40.97144000",
                        "longitude": "-82.10987000"
                    },
                    {
                        "id": 141812,
                        "name": "West Union",
                        "latitude": "38.79452000",
                        "longitude": "-83.54519000"
                    },
                    {
                        "id": 141813,
                        "name": "West Unity",
                        "latitude": "41.58616000",
                        "longitude": "-84.43495000"
                    },
                    {
                        "id": 141814,
                        "name": "Westerville",
                        "latitude": "40.12617000",
                        "longitude": "-82.92907000"
                    },
                    {
                        "id": 141815,
                        "name": "Westfield Center",
                        "latitude": "41.02644000",
                        "longitude": "-81.93320000"
                    },
                    {
                        "id": 141816,
                        "name": "Westlake",
                        "latitude": "41.45532000",
                        "longitude": "-81.91792000"
                    },
                    {
                        "id": 141817,
                        "name": "Weston",
                        "latitude": "41.34477000",
                        "longitude": "-83.79716000"
                    },
                    {
                        "id": 141818,
                        "name": "Wetherington",
                        "latitude": "39.36367000",
                        "longitude": "-84.37744000"
                    },
                    {
                        "id": 141819,
                        "name": "Wheelersburg",
                        "latitude": "38.73035000",
                        "longitude": "-82.85545000"
                    },
                    {
                        "id": 141820,
                        "name": "White Oak",
                        "latitude": "39.21311000",
                        "longitude": "-84.59939000"
                    },
                    {
                        "id": 141821,
                        "name": "Whitehall",
                        "latitude": "39.96673000",
                        "longitude": "-82.88546000"
                    },
                    {
                        "id": 141822,
                        "name": "Whitehouse",
                        "latitude": "41.51894000",
                        "longitude": "-83.80383000"
                    },
                    {
                        "id": 141823,
                        "name": "Wickliffe",
                        "latitude": "41.60533000",
                        "longitude": "-81.45345000"
                    },
                    {
                        "id": 141824,
                        "name": "Wilberforce",
                        "latitude": "39.71617000",
                        "longitude": "-83.87771000"
                    },
                    {
                        "id": 141825,
                        "name": "Willard",
                        "latitude": "41.05311000",
                        "longitude": "-82.72629000"
                    },
                    {
                        "id": 141826,
                        "name": "Williams County",
                        "latitude": "41.56029000",
                        "longitude": "-84.58814000"
                    },
                    {
                        "id": 141827,
                        "name": "Williamsburg",
                        "latitude": "39.05423000",
                        "longitude": "-84.05299000"
                    },
                    {
                        "id": 141828,
                        "name": "Williamsport",
                        "latitude": "39.58590000",
                        "longitude": "-83.12046000"
                    },
                    {
                        "id": 141829,
                        "name": "Willoughby",
                        "latitude": "41.63977000",
                        "longitude": "-81.40650000"
                    },
                    {
                        "id": 141830,
                        "name": "Willoughby Hills",
                        "latitude": "41.59838000",
                        "longitude": "-81.41845000"
                    },
                    {
                        "id": 141831,
                        "name": "Willowick",
                        "latitude": "41.63310000",
                        "longitude": "-81.46873000"
                    },
                    {
                        "id": 141832,
                        "name": "Wilmington",
                        "latitude": "39.44534000",
                        "longitude": "-83.82854000"
                    },
                    {
                        "id": 141833,
                        "name": "Winchester",
                        "latitude": "38.94174000",
                        "longitude": "-83.65075000"
                    },
                    {
                        "id": 141834,
                        "name": "Windham",
                        "latitude": "41.23506000",
                        "longitude": "-81.04926000"
                    },
                    {
                        "id": 141835,
                        "name": "Wintersville",
                        "latitude": "40.37535000",
                        "longitude": "-80.70369000"
                    },
                    {
                        "id": 141836,
                        "name": "Withamsville",
                        "latitude": "39.06228000",
                        "longitude": "-84.28827000"
                    },
                    {
                        "id": 141837,
                        "name": "Wolfhurst",
                        "latitude": "40.06924000",
                        "longitude": "-80.78370000"
                    },
                    {
                        "id": 141838,
                        "name": "Wood County",
                        "latitude": "41.36169000",
                        "longitude": "-83.62299000"
                    },
                    {
                        "id": 141839,
                        "name": "Woodlawn",
                        "latitude": "39.25200000",
                        "longitude": "-84.47022000"
                    },
                    {
                        "id": 141840,
                        "name": "Woodsfield",
                        "latitude": "39.76257000",
                        "longitude": "-81.11538000"
                    },
                    {
                        "id": 141841,
                        "name": "Woodville",
                        "latitude": "41.45144000",
                        "longitude": "-83.36576000"
                    },
                    {
                        "id": 141842,
                        "name": "Wooster",
                        "latitude": "40.80517000",
                        "longitude": "-81.93646000"
                    },
                    {
                        "id": 141843,
                        "name": "Worthington",
                        "latitude": "40.09312000",
                        "longitude": "-83.01796000"
                    },
                    {
                        "id": 141844,
                        "name": "Wright-Patterson AFB",
                        "latitude": "39.81113000",
                        "longitude": "-84.05731000"
                    },
                    {
                        "id": 141845,
                        "name": "Wyandot County",
                        "latitude": "40.84237000",
                        "longitude": "-83.30437000"
                    },
                    {
                        "id": 141846,
                        "name": "Wyoming",
                        "latitude": "39.23117000",
                        "longitude": "-84.46578000"
                    },
                    {
                        "id": 141847,
                        "name": "Xenia",
                        "latitude": "39.68478000",
                        "longitude": "-83.92965000"
                    },
                    {
                        "id": 141848,
                        "name": "Yellow Springs",
                        "latitude": "39.80645000",
                        "longitude": "-83.88687000"
                    },
                    {
                        "id": 141849,
                        "name": "Yorkville",
                        "latitude": "40.15452000",
                        "longitude": "-80.71036000"
                    },
                    {
                        "id": 141850,
                        "name": "Youngstown",
                        "latitude": "41.09978000",
                        "longitude": "-80.64952000"
                    },
                    {
                        "id": 141851,
                        "name": "Zanesville",
                        "latitude": "39.94035000",
                        "longitude": "-82.01319000"
                    }
                ]
            },
            {
                "id": 1421,
                "name": "Oklahoma",
                "iso2": "OK",
                "latitude": "35.46756020",
                "longitude": "-97.51642760",
                "type": "state",
                "cities": [
                    {
                        "id": 111005,
                        "name": "Ada",
                        "latitude": "34.77453000",
                        "longitude": "-96.67834000"
                    },
                    {
                        "id": 111009,
                        "name": "Adair County",
                        "latitude": "35.88393000",
                        "longitude": "-94.65868000"
                    },
                    {
                        "id": 111052,
                        "name": "Afton",
                        "latitude": "36.69369000",
                        "longitude": "-94.96302000"
                    },
                    {
                        "id": 111158,
                        "name": "Alfalfa County",
                        "latitude": "36.73098000",
                        "longitude": "-98.32400000"
                    },
                    {
                        "id": 111252,
                        "name": "Altus",
                        "latitude": "34.63813000",
                        "longitude": "-99.33398000"
                    },
                    {
                        "id": 111256,
                        "name": "Alva",
                        "latitude": "36.80499000",
                        "longitude": "-98.66718000"
                    },
                    {
                        "id": 111298,
                        "name": "Anadarko",
                        "latitude": "35.07256000",
                        "longitude": "-98.24366000"
                    },
                    {
                        "id": 111374,
                        "name": "Antlers",
                        "latitude": "34.23121000",
                        "longitude": "-95.62025000"
                    },
                    {
                        "id": 111379,
                        "name": "Apache",
                        "latitude": "34.89368000",
                        "longitude": "-98.36589000"
                    },
                    {
                        "id": 111412,
                        "name": "Arapaho",
                        "latitude": "35.57783000",
                        "longitude": "-98.96453000"
                    },
                    {
                        "id": 111442,
                        "name": "Ardmore",
                        "latitude": "34.17426000",
                        "longitude": "-97.14363000"
                    },
                    {
                        "id": 111459,
                        "name": "Arkoma",
                        "latitude": "35.35454000",
                        "longitude": "-94.43410000"
                    },
                    {
                        "id": 111483,
                        "name": "Arnett",
                        "latitude": "36.13504000",
                        "longitude": "-99.77484000"
                    },
                    {
                        "id": 111603,
                        "name": "Atoka",
                        "latitude": "34.38593000",
                        "longitude": "-96.12833000"
                    },
                    {
                        "id": 111606,
                        "name": "Atoka County",
                        "latitude": "34.37372000",
                        "longitude": "-96.03783000"
                    },
                    {
                        "id": 111833,
                        "name": "Barnsdall",
                        "latitude": "36.56202000",
                        "longitude": "-96.16167000"
                    },
                    {
                        "id": 111860,
                        "name": "Bartlesville",
                        "latitude": "36.74731000",
                        "longitude": "-95.98082000"
                    },
                    {
                        "id": 111994,
                        "name": "Beaver",
                        "latitude": "36.81614000",
                        "longitude": "-100.51987000"
                    },
                    {
                        "id": 111998,
                        "name": "Beaver County",
                        "latitude": "36.74971000",
                        "longitude": "-100.47678000"
                    },
                    {
                        "id": 112016,
                        "name": "Beckham County",
                        "latitude": "35.26871000",
                        "longitude": "-99.68192000"
                    },
                    {
                        "id": 112045,
                        "name": "Beggs",
                        "latitude": "35.74260000",
                        "longitude": "-96.07027000"
                    },
                    {
                        "id": 112273,
                        "name": "Bethany",
                        "latitude": "35.51867000",
                        "longitude": "-97.63226000"
                    },
                    {
                        "id": 112283,
                        "name": "Bethel Acres",
                        "latitude": "35.30868000",
                        "longitude": "-97.02558000"
                    },
                    {
                        "id": 112370,
                        "name": "Bixby",
                        "latitude": "35.94204000",
                        "longitude": "-95.88332000"
                    },
                    {
                        "id": 112396,
                        "name": "Blackwell",
                        "latitude": "36.80448000",
                        "longitude": "-97.28282000"
                    },
                    {
                        "id": 112405,
                        "name": "Blaine County",
                        "latitude": "35.87525000",
                        "longitude": "-98.43346000"
                    },
                    {
                        "id": 112417,
                        "name": "Blanchard",
                        "latitude": "35.13784000",
                        "longitude": "-97.65809000"
                    },
                    {
                        "id": 112509,
                        "name": "Boise City",
                        "latitude": "36.72947000",
                        "longitude": "-102.51324000"
                    },
                    {
                        "id": 112513,
                        "name": "Boley",
                        "latitude": "35.49341000",
                        "longitude": "-96.48362000"
                    },
                    {
                        "id": 112702,
                        "name": "Bray",
                        "latitude": "34.63786000",
                        "longitude": "-97.81753000"
                    },
                    {
                        "id": 112816,
                        "name": "Bristow",
                        "latitude": "35.83063000",
                        "longitude": "-96.39112000"
                    },
                    {
                        "id": 112841,
                        "name": "Broken Arrow",
                        "latitude": "36.05260000",
                        "longitude": "-95.79082000"
                    },
                    {
                        "id": 112842,
                        "name": "Broken Bow",
                        "latitude": "34.02928000",
                        "longitude": "-94.73910000"
                    },
                    {
                        "id": 112961,
                        "name": "Bryan County",
                        "latitude": "33.96230000",
                        "longitude": "-96.25975000"
                    },
                    {
                        "id": 113008,
                        "name": "Buffalo",
                        "latitude": "36.83559000",
                        "longitude": "-99.63040000"
                    },
                    {
                        "id": 113088,
                        "name": "Burns Flat",
                        "latitude": "35.34894000",
                        "longitude": "-99.17036000"
                    },
                    {
                        "id": 113104,
                        "name": "Bushyhead",
                        "latitude": "36.46148000",
                        "longitude": "-95.49414000"
                    },
                    {
                        "id": 113137,
                        "name": "Byng",
                        "latitude": "34.86120000",
                        "longitude": "-96.66557000"
                    },
                    {
                        "id": 113155,
                        "name": "Cache",
                        "latitude": "34.62952000",
                        "longitude": "-98.62867000"
                    },
                    {
                        "id": 113159,
                        "name": "Caddo",
                        "latitude": "34.12676000",
                        "longitude": "-96.26332000"
                    },
                    {
                        "id": 113160,
                        "name": "Caddo County",
                        "latitude": "35.17438000",
                        "longitude": "-98.37515000"
                    },
                    {
                        "id": 113195,
                        "name": "Calera",
                        "latitude": "33.93454000",
                        "longitude": "-96.42860000"
                    },
                    {
                        "id": 113315,
                        "name": "Canadian County",
                        "latitude": "35.54244000",
                        "longitude": "-97.98238000"
                    },
                    {
                        "id": 113425,
                        "name": "Carnegie",
                        "latitude": "35.10367000",
                        "longitude": "-98.60367000"
                    },
                    {
                        "id": 113482,
                        "name": "Carter County",
                        "latitude": "34.25086000",
                        "longitude": "-97.28579000"
                    },
                    {
                        "id": 113576,
                        "name": "Catoosa",
                        "latitude": "36.18899000",
                        "longitude": "-95.74582000"
                    },
                    {
                        "id": 113677,
                        "name": "Central High",
                        "latitude": "34.62313000",
                        "longitude": "-98.08976000"
                    },
                    {
                        "id": 113729,
                        "name": "Chandler",
                        "latitude": "35.70173000",
                        "longitude": "-96.88086000"
                    },
                    {
                        "id": 113823,
                        "name": "Checotah",
                        "latitude": "35.47010000",
                        "longitude": "-95.52304000"
                    },
                    {
                        "id": 113830,
                        "name": "Chelsea",
                        "latitude": "36.53565000",
                        "longitude": "-95.43247000"
                    },
                    {
                        "id": 113847,
                        "name": "Cherokee",
                        "latitude": "36.75447000",
                        "longitude": "-98.35674000"
                    },
                    {
                        "id": 113853,
                        "name": "Cherokee County",
                        "latitude": "35.90663000",
                        "longitude": "-94.99966000"
                    },
                    {
                        "id": 113925,
                        "name": "Cheyenne",
                        "latitude": "35.61394000",
                        "longitude": "-99.67149000"
                    },
                    {
                        "id": 113941,
                        "name": "Chickasha",
                        "latitude": "35.05257000",
                        "longitude": "-97.93643000"
                    },
                    {
                        "id": 113985,
                        "name": "Choctaw",
                        "latitude": "35.49756000",
                        "longitude": "-97.26892000"
                    },
                    {
                        "id": 113988,
                        "name": "Choctaw County",
                        "latitude": "34.02662000",
                        "longitude": "-95.55214000"
                    },
                    {
                        "id": 113990,
                        "name": "Chouteau",
                        "latitude": "36.18593000",
                        "longitude": "-95.34302000"
                    },
                    {
                        "id": 114024,
                        "name": "Cimarron County",
                        "latitude": "36.74831000",
                        "longitude": "-102.51771000"
                    },
                    {
                        "id": 114107,
                        "name": "Claremore",
                        "latitude": "36.31260000",
                        "longitude": "-95.61609000"
                    },
                    {
                        "id": 114237,
                        "name": "Cleora",
                        "latitude": "36.57897000",
                        "longitude": "-94.97107000"
                    },
                    {
                        "id": 114245,
                        "name": "Cleveland",
                        "latitude": "36.31032000",
                        "longitude": "-96.46584000"
                    },
                    {
                        "id": 114250,
                        "name": "Cleveland County",
                        "latitude": "35.20302000",
                        "longitude": "-97.32641000"
                    },
                    {
                        "id": 114276,
                        "name": "Clinton",
                        "latitude": "35.51561000",
                        "longitude": "-98.96731000"
                    },
                    {
                        "id": 114328,
                        "name": "Coal County",
                        "latitude": "34.58819000",
                        "longitude": "-96.29786000"
                    },
                    {
                        "id": 114336,
                        "name": "Coalgate",
                        "latitude": "34.53815000",
                        "longitude": "-96.21861000"
                    },
                    {
                        "id": 114378,
                        "name": "Colbert",
                        "latitude": "33.85316000",
                        "longitude": "-96.50249000"
                    },
                    {
                        "id": 114436,
                        "name": "Collinsville",
                        "latitude": "36.36454000",
                        "longitude": "-95.83888000"
                    },
                    {
                        "id": 114510,
                        "name": "Comanche",
                        "latitude": "34.36897000",
                        "longitude": "-97.96392000"
                    },
                    {
                        "id": 114513,
                        "name": "Comanche County",
                        "latitude": "34.66210000",
                        "longitude": "-98.47166000"
                    },
                    {
                        "id": 114523,
                        "name": "Commerce",
                        "latitude": "36.93340000",
                        "longitude": "-94.87301000"
                    },
                    {
                        "id": 114615,
                        "name": "Copeland",
                        "latitude": "36.65591000",
                        "longitude": "-94.82829000"
                    },
                    {
                        "id": 114636,
                        "name": "Cordell",
                        "latitude": "35.29061000",
                        "longitude": "-98.98841000"
                    },
                    {
                        "id": 114697,
                        "name": "Cotton County",
                        "latitude": "34.29024000",
                        "longitude": "-98.37223000"
                    },
                    {
                        "id": 114746,
                        "name": "Coweta",
                        "latitude": "35.95177000",
                        "longitude": "-95.65081000"
                    },
                    {
                        "id": 114757,
                        "name": "Craig County",
                        "latitude": "36.76176000",
                        "longitude": "-95.20850000"
                    },
                    {
                        "id": 114789,
                        "name": "Creek County",
                        "latitude": "35.90268000",
                        "longitude": "-96.37094000"
                    },
                    {
                        "id": 114794,
                        "name": "Crescent",
                        "latitude": "35.95254000",
                        "longitude": "-97.59477000"
                    },
                    {
                        "id": 114931,
                        "name": "Cushing",
                        "latitude": "35.98506000",
                        "longitude": "-96.76697000"
                    },
                    {
                        "id": 114935,
                        "name": "Custer County",
                        "latitude": "35.63886000",
                        "longitude": "-99.00150000"
                    },
                    {
                        "id": 114959,
                        "name": "Cyril",
                        "latitude": "34.89646000",
                        "longitude": "-98.20060000"
                    },
                    {
                        "id": 115072,
                        "name": "Davis",
                        "latitude": "34.50453000",
                        "longitude": "-97.11946000"
                    },
                    {
                        "id": 115187,
                        "name": "Del City",
                        "latitude": "35.44201000",
                        "longitude": "-97.44087000"
                    },
                    {
                        "id": 115204,
                        "name": "Delaware County",
                        "latitude": "36.40820000",
                        "longitude": "-94.80265000"
                    },
                    {
                        "id": 115302,
                        "name": "Dewey",
                        "latitude": "36.79592000",
                        "longitude": "-95.93554000"
                    },
                    {
                        "id": 115303,
                        "name": "Dewey County",
                        "latitude": "35.98766000",
                        "longitude": "-99.00789000"
                    },
                    {
                        "id": 115330,
                        "name": "Dickson",
                        "latitude": "34.18732000",
                        "longitude": "-96.98446000"
                    },
                    {
                        "id": 115482,
                        "name": "Drumright",
                        "latitude": "35.98840000",
                        "longitude": "-96.60113000"
                    },
                    {
                        "id": 115521,
                        "name": "Duncan",
                        "latitude": "34.50230000",
                        "longitude": "-97.95781000"
                    },
                    {
                        "id": 115567,
                        "name": "Durant",
                        "latitude": "33.99399000",
                        "longitude": "-96.37082000"
                    },
                    {
                        "id": 115877,
                        "name": "Edmond",
                        "latitude": "35.65283000",
                        "longitude": "-97.47810000"
                    },
                    {
                        "id": 115935,
                        "name": "El Reno",
                        "latitude": "35.53227000",
                        "longitude": "-97.95505000"
                    },
                    {
                        "id": 115964,
                        "name": "Elgin",
                        "latitude": "34.78035000",
                        "longitude": "-98.29227000"
                    },
                    {
                        "id": 115983,
                        "name": "Elk City",
                        "latitude": "35.41199000",
                        "longitude": "-99.40426000"
                    },
                    {
                        "id": 116031,
                        "name": "Ellis County",
                        "latitude": "36.21836000",
                        "longitude": "-99.75460000"
                    },
                    {
                        "id": 116138,
                        "name": "Enid",
                        "latitude": "36.39559000",
                        "longitude": "-97.87839000"
                    },
                    {
                        "id": 116163,
                        "name": "Erick",
                        "latitude": "35.21533000",
                        "longitude": "-99.86649000"
                    },
                    {
                        "id": 116225,
                        "name": "Eufaula",
                        "latitude": "35.28722000",
                        "longitude": "-95.58250000"
                    },
                    {
                        "id": 116302,
                        "name": "Fairfax",
                        "latitude": "36.57366000",
                        "longitude": "-96.70420000"
                    },
                    {
                        "id": 116329,
                        "name": "Fairland",
                        "latitude": "36.75118000",
                        "longitude": "-94.84746000"
                    },
                    {
                        "id": 116350,
                        "name": "Fairview",
                        "latitude": "36.26892000",
                        "longitude": "-98.47980000"
                    },
                    {
                        "id": 116565,
                        "name": "Fletcher",
                        "latitude": "34.82312000",
                        "longitude": "-98.24422000"
                    },
                    {
                        "id": 116665,
                        "name": "Forest Park",
                        "latitude": "35.50423000",
                        "longitude": "-97.44615000"
                    },
                    {
                        "id": 116713,
                        "name": "Fort Gibson",
                        "latitude": "35.79760000",
                        "longitude": "-95.25052000"
                    },
                    {
                        "id": 116886,
                        "name": "Frederick",
                        "latitude": "34.39203000",
                        "longitude": "-99.01841000"
                    },
                    {
                        "id": 117082,
                        "name": "Garfield County",
                        "latitude": "36.37906000",
                        "longitude": "-97.78272000"
                    },
                    {
                        "id": 117104,
                        "name": "Garvin County",
                        "latitude": "34.70457000",
                        "longitude": "-97.30932000"
                    },
                    {
                        "id": 117130,
                        "name": "Geary",
                        "latitude": "35.63116000",
                        "longitude": "-98.31729000"
                    },
                    {
                        "id": 117176,
                        "name": "Geronimo",
                        "latitude": "34.48119000",
                        "longitude": "-98.38311000"
                    },
                    {
                        "id": 117302,
                        "name": "Glenpool",
                        "latitude": "35.95537000",
                        "longitude": "-96.00888000"
                    },
                    {
                        "id": 117365,
                        "name": "Goldsby",
                        "latitude": "35.14118000",
                        "longitude": "-97.47698000"
                    },
                    {
                        "id": 117392,
                        "name": "Goodwell",
                        "latitude": "36.59530000",
                        "longitude": "-101.63655000"
                    },
                    {
                        "id": 117427,
                        "name": "Grady County",
                        "latitude": "35.01694000",
                        "longitude": "-97.88411000"
                    },
                    {
                        "id": 117491,
                        "name": "Granite",
                        "latitude": "34.96228000",
                        "longitude": "-99.38064000"
                    },
                    {
                        "id": 117510,
                        "name": "Grant County",
                        "latitude": "36.79614000",
                        "longitude": "-97.78616000"
                    },
                    {
                        "id": 117714,
                        "name": "Greer County",
                        "latitude": "34.93570000",
                        "longitude": "-99.56080000"
                    },
                    {
                        "id": 117754,
                        "name": "Grove",
                        "latitude": "36.59369000",
                        "longitude": "-94.76912000"
                    },
                    {
                        "id": 117812,
                        "name": "Guthrie",
                        "latitude": "35.87894000",
                        "longitude": "-97.42532000"
                    },
                    {
                        "id": 117818,
                        "name": "Guymon",
                        "latitude": "36.68280000",
                        "longitude": "-101.48155000"
                    },
                    {
                        "id": 117867,
                        "name": "Hall Park",
                        "latitude": "35.23701000",
                        "longitude": "-97.40642000"
                    },
                    {
                        "id": 118028,
                        "name": "Harmon County",
                        "latitude": "34.74412000",
                        "longitude": "-99.84628000"
                    },
                    {
                        "id": 118034,
                        "name": "Harper County",
                        "latitude": "36.78873000",
                        "longitude": "-99.66736000"
                    },
                    {
                        "id": 118038,
                        "name": "Harrah",
                        "latitude": "35.48951000",
                        "longitude": "-97.16364000"
                    },
                    {
                        "id": 118103,
                        "name": "Hartshorne",
                        "latitude": "34.84510000",
                        "longitude": "-95.55748000"
                    },
                    {
                        "id": 118123,
                        "name": "Haskell",
                        "latitude": "35.82038000",
                        "longitude": "-95.67415000"
                    },
                    {
                        "id": 118125,
                        "name": "Haskell County",
                        "latitude": "35.22482000",
                        "longitude": "-95.11660000"
                    },
                    {
                        "id": 118218,
                        "name": "Healdton",
                        "latitude": "34.23315000",
                        "longitude": "-97.48780000"
                    },
                    {
                        "id": 118226,
                        "name": "Heavener",
                        "latitude": "34.88927000",
                        "longitude": "-94.60078000"
                    },
                    {
                        "id": 118250,
                        "name": "Helena",
                        "latitude": "36.54614000",
                        "longitude": "-98.27007000"
                    },
                    {
                        "id": 118292,
                        "name": "Hennessey",
                        "latitude": "36.10920000",
                        "longitude": "-97.89867000"
                    },
                    {
                        "id": 118307,
                        "name": "Henryetta",
                        "latitude": "35.43983000",
                        "longitude": "-95.98194000"
                    },
                    {
                        "id": 118488,
                        "name": "Hinton",
                        "latitude": "35.47144000",
                        "longitude": "-98.35562000"
                    },
                    {
                        "id": 118496,
                        "name": "Hobart",
                        "latitude": "35.02950000",
                        "longitude": "-99.09313000"
                    },
                    {
                        "id": 118526,
                        "name": "Holdenville",
                        "latitude": "35.08036000",
                        "longitude": "-96.39918000"
                    },
                    {
                        "id": 118547,
                        "name": "Hollis",
                        "latitude": "34.68839000",
                        "longitude": "-99.91205000"
                    },
                    {
                        "id": 118609,
                        "name": "Hominy",
                        "latitude": "36.41424000",
                        "longitude": "-96.39530000"
                    },
                    {
                        "id": 118628,
                        "name": "Hooker",
                        "latitude": "36.86003000",
                        "longitude": "-101.21350000"
                    },
                    {
                        "id": 118758,
                        "name": "Hughes County",
                        "latitude": "35.04834000",
                        "longitude": "-96.25024000"
                    },
                    {
                        "id": 118765,
                        "name": "Hugo",
                        "latitude": "34.01066000",
                        "longitude": "-95.50968000"
                    },
                    {
                        "id": 118868,
                        "name": "Idabel",
                        "latitude": "33.89566000",
                        "longitude": "-94.82633000"
                    },
                    {
                        "id": 118948,
                        "name": "Inola",
                        "latitude": "36.15121000",
                        "longitude": "-95.50942000"
                    },
                    {
                        "id": 119086,
                        "name": "Jackson County",
                        "latitude": "34.58797000",
                        "longitude": "-99.41476000"
                    },
                    {
                        "id": 119153,
                        "name": "Jay",
                        "latitude": "36.42119000",
                        "longitude": "-94.79690000"
                    },
                    {
                        "id": 119185,
                        "name": "Jefferson County",
                        "latitude": "34.11101000",
                        "longitude": "-97.83585000"
                    },
                    {
                        "id": 119217,
                        "name": "Jenks",
                        "latitude": "36.02287000",
                        "longitude": "-95.96833000"
                    },
                    {
                        "id": 119282,
                        "name": "Johnston County",
                        "latitude": "34.31649000",
                        "longitude": "-96.66066000"
                    },
                    {
                        "id": 119291,
                        "name": "Jones",
                        "latitude": "35.56589000",
                        "longitude": "-97.28698000"
                    },
                    {
                        "id": 119344,
                        "name": "Justice",
                        "latitude": "36.29287000",
                        "longitude": "-95.56664000"
                    },
                    {
                        "id": 119401,
                        "name": "Kay County",
                        "latitude": "36.81801000",
                        "longitude": "-97.14392000"
                    },
                    {
                        "id": 119430,
                        "name": "Kellyville",
                        "latitude": "35.94370000",
                        "longitude": "-96.21361000"
                    },
                    {
                        "id": 119503,
                        "name": "Kenwood",
                        "latitude": "36.31453000",
                        "longitude": "-94.98579000"
                    },
                    {
                        "id": 119553,
                        "name": "Kiefer",
                        "latitude": "35.94482000",
                        "longitude": "-96.06528000"
                    },
                    {
                        "id": 119592,
                        "name": "Kingfisher",
                        "latitude": "35.86143000",
                        "longitude": "-97.93172000"
                    },
                    {
                        "id": 119593,
                        "name": "Kingfisher County",
                        "latitude": "35.94539000",
                        "longitude": "-97.94211000"
                    },
                    {
                        "id": 119622,
                        "name": "Kingston",
                        "latitude": "33.99871000",
                        "longitude": "-96.71972000"
                    },
                    {
                        "id": 119647,
                        "name": "Kiowa County",
                        "latitude": "34.91637000",
                        "longitude": "-98.98087000"
                    },
                    {
                        "id": 119704,
                        "name": "Konawa",
                        "latitude": "34.95953000",
                        "longitude": "-96.75280000"
                    },
                    {
                        "id": 119715,
                        "name": "Krebs",
                        "latitude": "34.92787000",
                        "longitude": "-95.71582000"
                    },
                    {
                        "id": 120116,
                        "name": "Langston",
                        "latitude": "35.94505000",
                        "longitude": "-97.25531000"
                    },
                    {
                        "id": 120173,
                        "name": "Latimer County",
                        "latitude": "34.87606000",
                        "longitude": "-95.25042000"
                    },
                    {
                        "id": 120218,
                        "name": "Laverne",
                        "latitude": "36.70975000",
                        "longitude": "-99.89346000"
                    },
                    {
                        "id": 120250,
                        "name": "Lawton",
                        "latitude": "34.60869000",
                        "longitude": "-98.39033000"
                    },
                    {
                        "id": 120259,
                        "name": "Le Flore County",
                        "latitude": "34.90030000",
                        "longitude": "-94.70339000"
                    },
                    {
                        "id": 120445,
                        "name": "Lexington",
                        "latitude": "35.01479000",
                        "longitude": "-97.33558000"
                    },
                    {
                        "id": 120523,
                        "name": "Lincoln County",
                        "latitude": "35.70300000",
                        "longitude": "-96.88092000"
                    },
                    {
                        "id": 120572,
                        "name": "Lindsay",
                        "latitude": "34.83480000",
                        "longitude": "-97.60253000"
                    },
                    {
                        "id": 120687,
                        "name": "Locust Grove",
                        "latitude": "36.20009000",
                        "longitude": "-95.16774000"
                    },
                    {
                        "id": 120698,
                        "name": "Logan County",
                        "latitude": "35.91934000",
                        "longitude": "-97.44332000"
                    },
                    {
                        "id": 120726,
                        "name": "Lone Grove",
                        "latitude": "34.17537000",
                        "longitude": "-97.26279000"
                    },
                    {
                        "id": 120755,
                        "name": "Longtown",
                        "latitude": "35.24538000",
                        "longitude": "-95.51276000"
                    },
                    {
                        "id": 120820,
                        "name": "Love County",
                        "latitude": "33.94986000",
                        "longitude": "-97.24418000"
                    },
                    {
                        "id": 120894,
                        "name": "Luther",
                        "latitude": "35.66173000",
                        "longitude": "-97.19559000"
                    },
                    {
                        "id": 120983,
                        "name": "Madill",
                        "latitude": "34.09038000",
                        "longitude": "-96.77167000"
                    },
                    {
                        "id": 121053,
                        "name": "Major County",
                        "latitude": "36.31164000",
                        "longitude": "-98.53595000"
                    },
                    {
                        "id": 121110,
                        "name": "Mangum",
                        "latitude": "34.87200000",
                        "longitude": "-99.50426000"
                    },
                    {
                        "id": 121133,
                        "name": "Mannford",
                        "latitude": "36.13341000",
                        "longitude": "-96.35446000"
                    },
                    {
                        "id": 121217,
                        "name": "Marietta",
                        "latitude": "33.93704000",
                        "longitude": "-97.11668000"
                    },
                    {
                        "id": 121285,
                        "name": "Marlow",
                        "latitude": "34.64813000",
                        "longitude": "-97.95809000"
                    },
                    {
                        "id": 121314,
                        "name": "Marshall County",
                        "latitude": "34.02449000",
                        "longitude": "-96.76913000"
                    },
                    {
                        "id": 121416,
                        "name": "Maud",
                        "latitude": "35.13036000",
                        "longitude": "-96.77585000"
                    },
                    {
                        "id": 121435,
                        "name": "Mayes County",
                        "latitude": "36.30188000",
                        "longitude": "-95.23085000"
                    },
                    {
                        "id": 121452,
                        "name": "Maysville",
                        "latitude": "34.81730000",
                        "longitude": "-97.40586000"
                    },
                    {
                        "id": 121462,
                        "name": "McAlester",
                        "latitude": "34.93343000",
                        "longitude": "-95.76971000"
                    },
                    {
                        "id": 121469,
                        "name": "McClain County",
                        "latitude": "35.00934000",
                        "longitude": "-97.44430000"
                    },
                    {
                        "id": 121481,
                        "name": "McCord",
                        "latitude": "36.67847000",
                        "longitude": "-97.04000000"
                    },
                    {
                        "id": 121490,
                        "name": "McCurtain County",
                        "latitude": "34.11529000",
                        "longitude": "-94.77133000"
                    },
                    {
                        "id": 121514,
                        "name": "McIntosh County",
                        "latitude": "35.37366000",
                        "longitude": "-95.66684000"
                    },
                    {
                        "id": 121536,
                        "name": "McLoud",
                        "latitude": "35.43590000",
                        "longitude": "-97.09142000"
                    },
                    {
                        "id": 121591,
                        "name": "Medford",
                        "latitude": "36.80697000",
                        "longitude": "-97.73366000"
                    },
                    {
                        "id": 121612,
                        "name": "Meeker",
                        "latitude": "35.50340000",
                        "longitude": "-96.90280000"
                    },
                    {
                        "id": 121691,
                        "name": "Meridian",
                        "latitude": "34.42731000",
                        "longitude": "-97.97809000"
                    },
                    {
                        "id": 121747,
                        "name": "Miami",
                        "latitude": "36.87451000",
                        "longitude": "-94.87746000"
                    },
                    {
                        "id": 121824,
                        "name": "Midwest City",
                        "latitude": "35.44951000",
                        "longitude": "-97.39670000"
                    },
                    {
                        "id": 121927,
                        "name": "Minco",
                        "latitude": "35.31284000",
                        "longitude": "-97.94449000"
                    },
                    {
                        "id": 122200,
                        "name": "Moore",
                        "latitude": "35.33951000",
                        "longitude": "-97.48670000"
                    },
                    {
                        "id": 122206,
                        "name": "Mooreland",
                        "latitude": "36.43920000",
                        "longitude": "-99.20482000"
                    },
                    {
                        "id": 122266,
                        "name": "Morris",
                        "latitude": "35.60760000",
                        "longitude": "-95.86027000"
                    },
                    {
                        "id": 122325,
                        "name": "Mounds",
                        "latitude": "35.87648000",
                        "longitude": "-96.06111000"
                    },
                    {
                        "id": 122456,
                        "name": "Muldrow",
                        "latitude": "35.40620000",
                        "longitude": "-94.59883000"
                    },
                    {
                        "id": 122494,
                        "name": "Murray County",
                        "latitude": "34.48233000",
                        "longitude": "-97.06792000"
                    },
                    {
                        "id": 122512,
                        "name": "Muskogee",
                        "latitude": "35.74788000",
                        "longitude": "-95.36969000"
                    },
                    {
                        "id": 122513,
                        "name": "Muskogee County",
                        "latitude": "35.61613000",
                        "longitude": "-95.37953000"
                    },
                    {
                        "id": 122515,
                        "name": "Mustang",
                        "latitude": "35.38423000",
                        "longitude": "-97.72449000"
                    },
                    {
                        "id": 122820,
                        "name": "Newcastle",
                        "latitude": "35.24729000",
                        "longitude": "-97.59976000"
                    },
                    {
                        "id": 122832,
                        "name": "Newkirk",
                        "latitude": "36.88225000",
                        "longitude": "-97.05337000"
                    },
                    {
                        "id": 122891,
                        "name": "Nichols Hills",
                        "latitude": "35.55089000",
                        "longitude": "-97.54893000"
                    },
                    {
                        "id": 122897,
                        "name": "Nicoma Park",
                        "latitude": "35.49117000",
                        "longitude": "-97.32309000"
                    },
                    {
                        "id": 122903,
                        "name": "Ninnekah",
                        "latitude": "34.94785000",
                        "longitude": "-97.92393000"
                    },
                    {
                        "id": 122916,
                        "name": "Noble",
                        "latitude": "35.13924000",
                        "longitude": "-97.39475000"
                    },
                    {
                        "id": 122917,
                        "name": "Noble County",
                        "latitude": "36.38860000",
                        "longitude": "-97.23051000"
                    },
                    {
                        "id": 122949,
                        "name": "Norman",
                        "latitude": "35.22257000",
                        "longitude": "-97.43948000"
                    },
                    {
                        "id": 123209,
                        "name": "Nowata",
                        "latitude": "36.70065000",
                        "longitude": "-95.63803000"
                    },
                    {
                        "id": 123210,
                        "name": "Nowata County",
                        "latitude": "36.79848000",
                        "longitude": "-95.61740000"
                    },
                    {
                        "id": 123279,
                        "name": "Oakhurst",
                        "latitude": "36.07537000",
                        "longitude": "-96.06444000"
                    },
                    {
                        "id": 123287,
                        "name": "Oakland",
                        "latitude": "34.10010000",
                        "longitude": "-96.79389000"
                    },
                    {
                        "id": 123389,
                        "name": "Oilton",
                        "latitude": "36.08451000",
                        "longitude": "-96.58363000"
                    },
                    {
                        "id": 123395,
                        "name": "Okarche",
                        "latitude": "35.72588000",
                        "longitude": "-97.97644000"
                    },
                    {
                        "id": 123400,
                        "name": "Okeene",
                        "latitude": "36.11615000",
                        "longitude": "-98.31702000"
                    },
                    {
                        "id": 123401,
                        "name": "Okemah",
                        "latitude": "35.43259000",
                        "longitude": "-96.30501000"
                    },
                    {
                        "id": 123403,
                        "name": "Okfuskee County",
                        "latitude": "35.46546000",
                        "longitude": "-96.32280000"
                    },
                    {
                        "id": 123404,
                        "name": "Oklahoma City",
                        "latitude": "35.46756000",
                        "longitude": "-97.51643000"
                    },
                    {
                        "id": 123405,
                        "name": "Oklahoma County",
                        "latitude": "35.55152000",
                        "longitude": "-97.40720000"
                    },
                    {
                        "id": 123406,
                        "name": "Okmulgee",
                        "latitude": "35.62344000",
                        "longitude": "-95.96055000"
                    },
                    {
                        "id": 123407,
                        "name": "Okmulgee County",
                        "latitude": "35.64666000",
                        "longitude": "-95.96431000"
                    },
                    {
                        "id": 123492,
                        "name": "Oologah",
                        "latitude": "36.44704000",
                        "longitude": "-95.70832000"
                    },
                    {
                        "id": 123591,
                        "name": "Osage County",
                        "latitude": "36.62919000",
                        "longitude": "-96.39849000"
                    },
                    {
                        "id": 123639,
                        "name": "Ottawa County",
                        "latitude": "36.83551000",
                        "longitude": "-94.81044000"
                    },
                    {
                        "id": 123658,
                        "name": "Owasso",
                        "latitude": "36.26954000",
                        "longitude": "-95.85471000"
                    },
                    {
                        "id": 123797,
                        "name": "Panama",
                        "latitude": "35.16732000",
                        "longitude": "-94.67245000"
                    },
                    {
                        "id": 123847,
                        "name": "Park Hill",
                        "latitude": "35.86120000",
                        "longitude": "-94.95884000"
                    },
                    {
                        "id": 123925,
                        "name": "Pauls Valley",
                        "latitude": "34.74008000",
                        "longitude": "-97.22225000"
                    },
                    {
                        "id": 123930,
                        "name": "Pawhuska",
                        "latitude": "36.66784000",
                        "longitude": "-96.33723000"
                    },
                    {
                        "id": 123934,
                        "name": "Pawnee",
                        "latitude": "36.33783000",
                        "longitude": "-96.80392000"
                    },
                    {
                        "id": 123937,
                        "name": "Pawnee County",
                        "latitude": "36.31693000",
                        "longitude": "-96.69930000"
                    },
                    {
                        "id": 123946,
                        "name": "Payne County",
                        "latitude": "36.07732000",
                        "longitude": "-96.97577000"
                    },
                    {
                        "id": 124062,
                        "name": "Perkins",
                        "latitude": "35.97394000",
                        "longitude": "-97.03364000"
                    },
                    {
                        "id": 124069,
                        "name": "Perry",
                        "latitude": "36.28949000",
                        "longitude": "-97.28810000"
                    },
                    {
                        "id": 124167,
                        "name": "Piedmont",
                        "latitude": "35.64200000",
                        "longitude": "-97.74643000"
                    },
                    {
                        "id": 124270,
                        "name": "Pink",
                        "latitude": "35.26063000",
                        "longitude": "-97.11975000"
                    },
                    {
                        "id": 124295,
                        "name": "Pittsburg County",
                        "latitude": "34.92391000",
                        "longitude": "-95.74840000"
                    },
                    {
                        "id": 124419,
                        "name": "Pocola",
                        "latitude": "35.23121000",
                        "longitude": "-94.47800000"
                    },
                    {
                        "id": 124464,
                        "name": "Ponca City",
                        "latitude": "36.70698000",
                        "longitude": "-97.08559000"
                    },
                    {
                        "id": 124478,
                        "name": "Pontotoc County",
                        "latitude": "34.72800000",
                        "longitude": "-96.68444000"
                    },
                    {
                        "id": 124579,
                        "name": "Poteau",
                        "latitude": "35.05371000",
                        "longitude": "-94.62356000"
                    },
                    {
                        "id": 124590,
                        "name": "Pottawatomie County",
                        "latitude": "35.20672000",
                        "longitude": "-96.94830000"
                    },
                    {
                        "id": 124622,
                        "name": "Prague",
                        "latitude": "35.48674000",
                        "longitude": "-96.68502000"
                    },
                    {
                        "id": 124726,
                        "name": "Pryor",
                        "latitude": "36.30843000",
                        "longitude": "-95.31691000"
                    },
                    {
                        "id": 124727,
                        "name": "Pryor Creek",
                        "latitude": "36.30862000",
                        "longitude": "-95.31777000"
                    },
                    {
                        "id": 124753,
                        "name": "Purcell",
                        "latitude": "35.01368000",
                        "longitude": "-97.36114000"
                    },
                    {
                        "id": 124759,
                        "name": "Pushmataha County",
                        "latitude": "34.41620000",
                        "longitude": "-95.37579000"
                    },
                    {
                        "id": 124804,
                        "name": "Quinton",
                        "latitude": "35.12288000",
                        "longitude": "-95.37109000"
                    },
                    {
                        "id": 125144,
                        "name": "Ringling",
                        "latitude": "34.17843000",
                        "longitude": "-97.59253000"
                    },
                    {
                        "id": 125347,
                        "name": "Roger Mills County",
                        "latitude": "35.68839000",
                        "longitude": "-99.69569000"
                    },
                    {
                        "id": 125352,
                        "name": "Rogers County",
                        "latitude": "36.37157000",
                        "longitude": "-95.60436000"
                    },
                    {
                        "id": 125359,
                        "name": "Roland",
                        "latitude": "35.42120000",
                        "longitude": "-94.51466000"
                    },
                    {
                        "id": 125522,
                        "name": "Rush Springs",
                        "latitude": "34.78257000",
                        "longitude": "-97.95698000"
                    },
                    {
                        "id": 125745,
                        "name": "Salina",
                        "latitude": "36.29287000",
                        "longitude": "-95.15330000"
                    },
                    {
                        "id": 125762,
                        "name": "Sallisaw",
                        "latitude": "35.46037000",
                        "longitude": "-94.78745000"
                    },
                    {
                        "id": 125861,
                        "name": "Sand Springs",
                        "latitude": "36.13981000",
                        "longitude": "-96.10889000"
                    },
                    {
                        "id": 125933,
                        "name": "Sapulpa",
                        "latitude": "35.99870000",
                        "longitude": "-96.11417000"
                    },
                    {
                        "id": 125989,
                        "name": "Sayre",
                        "latitude": "35.29116000",
                        "longitude": "-99.64010000"
                    },
                    {
                        "id": 126145,
                        "name": "Seminole",
                        "latitude": "35.22452000",
                        "longitude": "-96.67057000"
                    },
                    {
                        "id": 126149,
                        "name": "Seminole County",
                        "latitude": "35.16749000",
                        "longitude": "-96.61552000"
                    },
                    {
                        "id": 126165,
                        "name": "Sequoyah County",
                        "latitude": "35.49535000",
                        "longitude": "-94.75524000"
                    },
                    {
                        "id": 126241,
                        "name": "Shattuck",
                        "latitude": "36.27614000",
                        "longitude": "-99.88276000"
                    },
                    {
                        "id": 126250,
                        "name": "Shawnee",
                        "latitude": "35.32729000",
                        "longitude": "-96.92530000"
                    },
                    {
                        "id": 126478,
                        "name": "Skiatook",
                        "latitude": "36.36842000",
                        "longitude": "-96.00138000"
                    },
                    {
                        "id": 126494,
                        "name": "Slaughterville",
                        "latitude": "35.08729000",
                        "longitude": "-97.33503000"
                    },
                    {
                        "id": 126549,
                        "name": "Snyder",
                        "latitude": "34.65896000",
                        "longitude": "-98.95174000"
                    },
                    {
                        "id": 126822,
                        "name": "Spencer",
                        "latitude": "35.52284000",
                        "longitude": "-97.37726000"
                    },
                    {
                        "id": 126833,
                        "name": "Sperry",
                        "latitude": "36.29731000",
                        "longitude": "-95.99139000"
                    },
                    {
                        "id": 126840,
                        "name": "Spiro",
                        "latitude": "35.24121000",
                        "longitude": "-94.61994000"
                    },
                    {
                        "id": 127022,
                        "name": "Stephens County",
                        "latitude": "34.48559000",
                        "longitude": "-97.85148000"
                    },
                    {
                        "id": 127057,
                        "name": "Stigler",
                        "latitude": "35.25371000",
                        "longitude": "-95.12302000"
                    },
                    {
                        "id": 127060,
                        "name": "Stillwater",
                        "latitude": "36.11561000",
                        "longitude": "-97.05837000"
                    },
                    {
                        "id": 127064,
                        "name": "Stilwell",
                        "latitude": "35.81453000",
                        "longitude": "-94.62856000"
                    },
                    {
                        "id": 127123,
                        "name": "Stratford",
                        "latitude": "34.79675000",
                        "longitude": "-96.95946000"
                    },
                    {
                        "id": 127139,
                        "name": "Stroud",
                        "latitude": "35.74868000",
                        "longitude": "-96.65807000"
                    },
                    {
                        "id": 127195,
                        "name": "Sulphur",
                        "latitude": "34.50787000",
                        "longitude": "-96.96835000"
                    },
                    {
                        "id": 127377,
                        "name": "Tahlequah",
                        "latitude": "35.91537000",
                        "longitude": "-94.96996000"
                    },
                    {
                        "id": 127388,
                        "name": "Talihina",
                        "latitude": "34.75149000",
                        "longitude": "-95.04802000"
                    },
                    {
                        "id": 127398,
                        "name": "Taloga",
                        "latitude": "36.03865000",
                        "longitude": "-98.96371000"
                    },
                    {
                        "id": 127478,
                        "name": "Tecumseh",
                        "latitude": "35.25785000",
                        "longitude": "-96.93669000"
                    },
                    {
                        "id": 127543,
                        "name": "Texanna",
                        "latitude": "35.34732000",
                        "longitude": "-95.43692000"
                    },
                    {
                        "id": 127548,
                        "name": "Texas County",
                        "latitude": "36.74791000",
                        "longitude": "-101.49001000"
                    },
                    {
                        "id": 127564,
                        "name": "The Village",
                        "latitude": "35.56089000",
                        "longitude": "-97.55143000"
                    },
                    {
                        "id": 127578,
                        "name": "Thomas",
                        "latitude": "35.74422000",
                        "longitude": "-98.74758000"
                    },
                    {
                        "id": 127650,
                        "name": "Tillman County",
                        "latitude": "34.37285000",
                        "longitude": "-98.92424000"
                    },
                    {
                        "id": 127682,
                        "name": "Tishomingo",
                        "latitude": "34.23621000",
                        "longitude": "-96.67861000"
                    },
                    {
                        "id": 127721,
                        "name": "Tonkawa",
                        "latitude": "36.67837000",
                        "longitude": "-97.31004000"
                    },
                    {
                        "id": 127888,
                        "name": "Tulsa",
                        "latitude": "36.15398000",
                        "longitude": "-95.99277000"
                    },
                    {
                        "id": 127889,
                        "name": "Tulsa County",
                        "latitude": "36.12108000",
                        "longitude": "-95.94148000"
                    },
                    {
                        "id": 127899,
                        "name": "Turley",
                        "latitude": "36.24204000",
                        "longitude": "-95.97583000"
                    },
                    {
                        "id": 127918,
                        "name": "Tuttle",
                        "latitude": "35.29089000",
                        "longitude": "-97.81227000"
                    },
                    {
                        "id": 127981,
                        "name": "Union City",
                        "latitude": "35.39172000",
                        "longitude": "-97.94144000"
                    },
                    {
                        "id": 128181,
                        "name": "Verdigris",
                        "latitude": "36.23482000",
                        "longitude": "-95.69109000"
                    },
                    {
                        "id": 128214,
                        "name": "Vian",
                        "latitude": "35.49843000",
                        "longitude": "-94.96967000"
                    },
                    {
                        "id": 128277,
                        "name": "Vinita",
                        "latitude": "36.63869000",
                        "longitude": "-95.15413000"
                    },
                    {
                        "id": 128329,
                        "name": "Wagoner",
                        "latitude": "35.95954000",
                        "longitude": "-95.36941000"
                    },
                    {
                        "id": 128330,
                        "name": "Wagoner County",
                        "latitude": "35.96110000",
                        "longitude": "-95.52118000"
                    },
                    {
                        "id": 128429,
                        "name": "Walters",
                        "latitude": "34.35981000",
                        "longitude": "-98.30783000"
                    },
                    {
                        "id": 128473,
                        "name": "Warner",
                        "latitude": "35.49426000",
                        "longitude": "-95.30552000"
                    },
                    {
                        "id": 128475,
                        "name": "Warr Acres",
                        "latitude": "35.52256000",
                        "longitude": "-97.61893000"
                    },
                    {
                        "id": 128564,
                        "name": "Washington County",
                        "latitude": "36.71524000",
                        "longitude": "-95.90437000"
                    },
                    {
                        "id": 128589,
                        "name": "Washita County",
                        "latitude": "35.29038000",
                        "longitude": "-98.99223000"
                    },
                    {
                        "id": 128636,
                        "name": "Watonga",
                        "latitude": "35.84477000",
                        "longitude": "-98.41313000"
                    },
                    {
                        "id": 128651,
                        "name": "Waukomis",
                        "latitude": "36.28031000",
                        "longitude": "-97.89811000"
                    },
                    {
                        "id": 128659,
                        "name": "Waurika",
                        "latitude": "34.16704000",
                        "longitude": "-97.99754000"
                    },
                    {
                        "id": 128717,
                        "name": "Weatherford",
                        "latitude": "35.52616000",
                        "longitude": "-98.70757000"
                    },
                    {
                        "id": 129077,
                        "name": "Westville",
                        "latitude": "35.99258000",
                        "longitude": "-94.56800000"
                    },
                    {
                        "id": 129091,
                        "name": "Wetumka",
                        "latitude": "35.23759000",
                        "longitude": "-96.24167000"
                    },
                    {
                        "id": 129096,
                        "name": "Wewoka",
                        "latitude": "35.15869000",
                        "longitude": "-96.49335000"
                    },
                    {
                        "id": 129227,
                        "name": "Wilburton",
                        "latitude": "34.91871000",
                        "longitude": "-95.30914000"
                    },
                    {
                        "id": 129330,
                        "name": "Wilson",
                        "latitude": "34.16204000",
                        "longitude": "-97.42586000"
                    },
                    {
                        "id": 129463,
                        "name": "Wister",
                        "latitude": "34.96732000",
                        "longitude": "-94.72467000"
                    },
                    {
                        "id": 129549,
                        "name": "Woods County",
                        "latitude": "36.76694000",
                        "longitude": "-98.86512000"
                    },
                    {
                        "id": 129575,
                        "name": "Woodward",
                        "latitude": "36.43365000",
                        "longitude": "-99.39039000"
                    },
                    {
                        "id": 129577,
                        "name": "Woodward County",
                        "latitude": "36.42267000",
                        "longitude": "-99.26497000"
                    },
                    {
                        "id": 129633,
                        "name": "Wynnewood",
                        "latitude": "34.64342000",
                        "longitude": "-97.16447000"
                    },
                    {
                        "id": 129654,
                        "name": "Yale",
                        "latitude": "36.11423000",
                        "longitude": "-96.69919000"
                    },
                    {
                        "id": 129730,
                        "name": "Yukon",
                        "latitude": "35.50672000",
                        "longitude": "-97.76254000"
                    }
                ]
            },
            {
                "id": 1415,
                "name": "Oregon",
                "iso2": "OR",
                "latitude": "43.80413340",
                "longitude": "-120.55420120",
                "type": "state",
                "cities": [
                    {
                        "id": 111111,
                        "name": "Albany",
                        "latitude": "44.63651000",
                        "longitude": "-123.10593000"
                    },
                    {
                        "id": 111214,
                        "name": "Aloha",
                        "latitude": "45.49428000",
                        "longitude": "-122.86705000"
                    },
                    {
                        "id": 111236,
                        "name": "Altamont",
                        "latitude": "42.20681000",
                        "longitude": "-121.73722000"
                    },
                    {
                        "id": 111290,
                        "name": "Amity",
                        "latitude": "45.11567000",
                        "longitude": "-123.20733000"
                    },
                    {
                        "id": 111540,
                        "name": "Ashland",
                        "latitude": "42.19458000",
                        "longitude": "-122.70948000"
                    },
                    {
                        "id": 111563,
                        "name": "Astoria",
                        "latitude": "46.18788000",
                        "longitude": "-123.83125000"
                    },
                    {
                        "id": 111572,
                        "name": "Athena",
                        "latitude": "45.81180000",
                        "longitude": "-118.49053000"
                    },
                    {
                        "id": 111655,
                        "name": "Aumsville",
                        "latitude": "44.84095000",
                        "longitude": "-122.87092000"
                    },
                    {
                        "id": 111740,
                        "name": "Baker City",
                        "latitude": "44.77487000",
                        "longitude": "-117.83438000"
                    },
                    {
                        "id": 111743,
                        "name": "Baker County",
                        "latitude": "44.70923000",
                        "longitude": "-117.67534000"
                    },
                    {
                        "id": 111790,
                        "name": "Bandon",
                        "latitude": "43.11900000",
                        "longitude": "-124.40845000"
                    },
                    {
                        "id": 111797,
                        "name": "Banks",
                        "latitude": "45.61872000",
                        "longitude": "-123.11428000"
                    },
                    {
                        "id": 111874,
                        "name": "Barview",
                        "latitude": "43.35428000",
                        "longitude": "-124.31317000"
                    },
                    {
                        "id": 111923,
                        "name": "Bay City",
                        "latitude": "45.52260000",
                        "longitude": "-123.88930000"
                    },
                    {
                        "id": 112005,
                        "name": "Beavercreek",
                        "latitude": "45.28790000",
                        "longitude": "-122.53564000"
                    },
                    {
                        "id": 112010,
                        "name": "Beaverton",
                        "latitude": "45.48706000",
                        "longitude": "-122.80371000"
                    },
                    {
                        "id": 112166,
                        "name": "Bend",
                        "latitude": "44.05817000",
                        "longitude": "-121.31531000"
                    },
                    {
                        "id": 112206,
                        "name": "Benton County",
                        "latitude": "44.49176000",
                        "longitude": "-123.42931000"
                    },
                    {
                        "id": 112276,
                        "name": "Bethany",
                        "latitude": "45.55789000",
                        "longitude": "-122.86760000"
                    },
                    {
                        "id": 112489,
                        "name": "Boardman",
                        "latitude": "45.83986000",
                        "longitude": "-119.70058000"
                    },
                    {
                        "id": 112862,
                        "name": "Brookings",
                        "latitude": "42.05261000",
                        "longitude": "-124.28398000"
                    },
                    {
                        "id": 112935,
                        "name": "Brownsville",
                        "latitude": "44.39346000",
                        "longitude": "-122.98481000"
                    },
                    {
                        "id": 113041,
                        "name": "Bunker Hill",
                        "latitude": "43.35595000",
                        "longitude": "-124.20483000"
                    },
                    {
                        "id": 113087,
                        "name": "Burns",
                        "latitude": "43.58626000",
                        "longitude": "-119.05410000"
                    },
                    {
                        "id": 113322,
                        "name": "Canby",
                        "latitude": "45.26290000",
                        "longitude": "-122.69259000"
                    },
                    {
                        "id": 113332,
                        "name": "Cannon Beach",
                        "latitude": "45.89177000",
                        "longitude": "-123.96153000"
                    },
                    {
                        "id": 113355,
                        "name": "Canyon City",
                        "latitude": "44.38960000",
                        "longitude": "-118.95023000"
                    },
                    {
                        "id": 113361,
                        "name": "Canyonville",
                        "latitude": "42.92734000",
                        "longitude": "-123.28117000"
                    },
                    {
                        "id": 113412,
                        "name": "Carlton",
                        "latitude": "45.29428000",
                        "longitude": "-123.17649000"
                    },
                    {
                        "id": 113516,
                        "name": "Cascade Locks",
                        "latitude": "45.66984000",
                        "longitude": "-121.89064000"
                    },
                    {
                        "id": 113586,
                        "name": "Cave Junction",
                        "latitude": "42.16289000",
                        "longitude": "-123.64812000"
                    },
                    {
                        "id": 113615,
                        "name": "Cedar Hills",
                        "latitude": "45.50484000",
                        "longitude": "-122.79843000"
                    },
                    {
                        "id": 113618,
                        "name": "Cedar Mill",
                        "latitude": "45.52484000",
                        "longitude": "-122.81093000"
                    },
                    {
                        "id": 113680,
                        "name": "Central Point",
                        "latitude": "42.37596000",
                        "longitude": "-122.91643000"
                    },
                    {
                        "id": 113842,
                        "name": "Chenoweth",
                        "latitude": "45.62762000",
                        "longitude": "-121.24341000"
                    },
                    {
                        "id": 114090,
                        "name": "Clackamas",
                        "latitude": "45.40762000",
                        "longitude": "-122.57037000"
                    },
                    {
                        "id": 114091,
                        "name": "Clackamas County",
                        "latitude": "45.18816000",
                        "longitude": "-122.22094000"
                    },
                    {
                        "id": 114160,
                        "name": "Clatskanie",
                        "latitude": "46.10122000",
                        "longitude": "-123.20679000"
                    },
                    {
                        "id": 114161,
                        "name": "Clatsop County",
                        "latitude": "46.01747000",
                        "longitude": "-123.71677000"
                    },
                    {
                        "id": 114348,
                        "name": "Coburg",
                        "latitude": "44.13707000",
                        "longitude": "-123.06648000"
                    },
                    {
                        "id": 114476,
                        "name": "Columbia City",
                        "latitude": "45.89011000",
                        "longitude": "-122.80705000"
                    },
                    {
                        "id": 114483,
                        "name": "Columbia County",
                        "latitude": "45.94377000",
                        "longitude": "-123.08805000"
                    },
                    {
                        "id": 114549,
                        "name": "Condon",
                        "latitude": "45.23430000",
                        "longitude": "-120.18503000"
                    },
                    {
                        "id": 114610,
                        "name": "Coos Bay",
                        "latitude": "43.36650000",
                        "longitude": "-124.21789000"
                    },
                    {
                        "id": 114612,
                        "name": "Coos County",
                        "latitude": "43.18501000",
                        "longitude": "-124.09333000"
                    },
                    {
                        "id": 114623,
                        "name": "Coquille",
                        "latitude": "43.17705000",
                        "longitude": "-124.18761000"
                    },
                    {
                        "id": 114648,
                        "name": "Cornelius",
                        "latitude": "45.51984000",
                        "longitude": "-123.05983000"
                    },
                    {
                        "id": 114680,
                        "name": "Corvallis",
                        "latitude": "44.56457000",
                        "longitude": "-123.26204000"
                    },
                    {
                        "id": 114693,
                        "name": "Cottage Grove",
                        "latitude": "43.79762000",
                        "longitude": "-123.05952000"
                    },
                    {
                        "id": 114813,
                        "name": "Creswell",
                        "latitude": "43.91790000",
                        "longitude": "-123.02453000"
                    },
                    {
                        "id": 114836,
                        "name": "Crook County",
                        "latitude": "44.14219000",
                        "longitude": "-120.35658000"
                    },
                    {
                        "id": 114899,
                        "name": "Culp Creek",
                        "latitude": "43.70346000",
                        "longitude": "-122.84757000"
                    },
                    {
                        "id": 114903,
                        "name": "Culver",
                        "latitude": "44.52568000",
                        "longitude": "-121.21310000"
                    },
                    {
                        "id": 114928,
                        "name": "Curry County",
                        "latitude": "42.46661000",
                        "longitude": "-124.21534000"
                    },
                    {
                        "id": 114992,
                        "name": "Dallas",
                        "latitude": "44.91928000",
                        "longitude": "-123.31705000"
                    },
                    {
                        "id": 115010,
                        "name": "Damascus",
                        "latitude": "45.41762000",
                        "longitude": "-122.45898000"
                    },
                    {
                        "id": 115099,
                        "name": "Dayton",
                        "latitude": "45.22067000",
                        "longitude": "-123.07621000"
                    },
                    {
                        "id": 115257,
                        "name": "Depoe Bay",
                        "latitude": "44.80845000",
                        "longitude": "-124.06317000"
                    },
                    {
                        "id": 115277,
                        "name": "Deschutes County",
                        "latitude": "43.91488000",
                        "longitude": "-121.22789000"
                    },
                    {
                        "id": 115278,
                        "name": "Deschutes River Woods",
                        "latitude": "43.99151000",
                        "longitude": "-121.35836000"
                    },
                    {
                        "id": 115393,
                        "name": "Donald",
                        "latitude": "45.22234000",
                        "longitude": "-122.83926000"
                    },
                    {
                        "id": 115435,
                        "name": "Douglas County",
                        "latitude": "43.28536000",
                        "longitude": "-123.17942000"
                    },
                    {
                        "id": 115467,
                        "name": "Drain",
                        "latitude": "43.65873000",
                        "longitude": "-123.31870000"
                    },
                    {
                        "id": 115531,
                        "name": "Dundee",
                        "latitude": "45.27817000",
                        "longitude": "-123.01094000"
                    },
                    {
                        "id": 115536,
                        "name": "Dunes City",
                        "latitude": "43.88318000",
                        "longitude": "-124.11512000"
                    },
                    {
                        "id": 115574,
                        "name": "Durham",
                        "latitude": "45.40206000",
                        "longitude": "-122.75287000"
                    },
                    {
                        "id": 115609,
                        "name": "Eagle Point",
                        "latitude": "42.47263000",
                        "longitude": "-122.80282000"
                    },
                    {
                        "id": 115968,
                        "name": "Elgin",
                        "latitude": "45.56486000",
                        "longitude": "-117.91743000"
                    },
                    {
                        "id": 116150,
                        "name": "Enterprise",
                        "latitude": "45.42626000",
                        "longitude": "-117.27878000"
                    },
                    {
                        "id": 116202,
                        "name": "Estacada",
                        "latitude": "45.28957000",
                        "longitude": "-122.33370000"
                    },
                    {
                        "id": 116226,
                        "name": "Eugene",
                        "latitude": "44.05207000",
                        "longitude": "-123.08675000"
                    },
                    {
                        "id": 116356,
                        "name": "Fairview",
                        "latitude": "45.53845000",
                        "longitude": "-122.43398000"
                    },
                    {
                        "id": 116586,
                        "name": "Florence",
                        "latitude": "43.98262000",
                        "longitude": "-124.09984000"
                    },
                    {
                        "id": 116653,
                        "name": "Forest Grove",
                        "latitude": "45.51984000",
                        "longitude": "-123.11066000"
                    },
                    {
                        "id": 116772,
                        "name": "Fossil",
                        "latitude": "44.99819000",
                        "longitude": "-120.21614000"
                    },
                    {
                        "id": 116789,
                        "name": "Four Corners",
                        "latitude": "44.92790000",
                        "longitude": "-122.98371000"
                    },
                    {
                        "id": 116969,
                        "name": "Fruitdale",
                        "latitude": "42.42206000",
                        "longitude": "-123.30811000"
                    },
                    {
                        "id": 117066,
                        "name": "Garden Home-Whitford",
                        "latitude": "45.46400000",
                        "longitude": "-122.75891000"
                    },
                    {
                        "id": 117129,
                        "name": "Gearhart",
                        "latitude": "46.02427000",
                        "longitude": "-123.91125000"
                    },
                    {
                        "id": 117178,
                        "name": "Gervais",
                        "latitude": "45.10818000",
                        "longitude": "-122.89760000"
                    },
                    {
                        "id": 117218,
                        "name": "Gilliam County",
                        "latitude": "45.37806000",
                        "longitude": "-120.21087000"
                    },
                    {
                        "id": 117239,
                        "name": "Gladstone",
                        "latitude": "45.38068000",
                        "longitude": "-122.59481000"
                    },
                    {
                        "id": 117320,
                        "name": "Glide",
                        "latitude": "43.30151000",
                        "longitude": "-123.10118000"
                    },
                    {
                        "id": 117340,
                        "name": "Gold Beach",
                        "latitude": "42.40733000",
                        "longitude": "-124.42177000"
                    },
                    {
                        "id": 117343,
                        "name": "Gold Hill",
                        "latitude": "42.43179000",
                        "longitude": "-123.05060000"
                    },
                    {
                        "id": 117474,
                        "name": "Grand Ronde",
                        "latitude": "45.06011000",
                        "longitude": "-123.60928000"
                    },
                    {
                        "id": 117520,
                        "name": "Grant County",
                        "latitude": "44.49125000",
                        "longitude": "-119.00738000"
                    },
                    {
                        "id": 117528,
                        "name": "Grants Pass",
                        "latitude": "42.43933000",
                        "longitude": "-123.33067000"
                    },
                    {
                        "id": 117589,
                        "name": "Green",
                        "latitude": "43.16039000",
                        "longitude": "-123.36785000"
                    },
                    {
                        "id": 117722,
                        "name": "Gresham",
                        "latitude": "45.49818000",
                        "longitude": "-122.43148000"
                    },
                    {
                        "id": 117983,
                        "name": "Happy Valley",
                        "latitude": "45.44679000",
                        "longitude": "-122.53037000"
                    },
                    {
                        "id": 117987,
                        "name": "Harbor",
                        "latitude": "42.05317000",
                        "longitude": "-124.26759000"
                    },
                    {
                        "id": 118030,
                        "name": "Harney County",
                        "latitude": "43.06402000",
                        "longitude": "-118.96787000"
                    },
                    {
                        "id": 118053,
                        "name": "Harrisburg",
                        "latitude": "44.27401000",
                        "longitude": "-123.17065000"
                    },
                    {
                        "id": 118183,
                        "name": "Hayesville",
                        "latitude": "44.98595000",
                        "longitude": "-122.98287000"
                    },
                    {
                        "id": 118310,
                        "name": "Heppner",
                        "latitude": "45.35318000",
                        "longitude": "-119.55780000"
                    },
                    {
                        "id": 118327,
                        "name": "Hermiston",
                        "latitude": "45.84041000",
                        "longitude": "-119.28946000"
                    },
                    {
                        "id": 118452,
                        "name": "Hillsboro",
                        "latitude": "45.52289000",
                        "longitude": "-122.98983000"
                    },
                    {
                        "id": 118480,
                        "name": "Hines",
                        "latitude": "43.56404000",
                        "longitude": "-119.08105000"
                    },
                    {
                        "id": 118626,
                        "name": "Hood River",
                        "latitude": "45.70540000",
                        "longitude": "-121.52146000"
                    },
                    {
                        "id": 118627,
                        "name": "Hood River County",
                        "latitude": "45.51911000",
                        "longitude": "-121.65111000"
                    },
                    {
                        "id": 118731,
                        "name": "Hubbard",
                        "latitude": "45.18234000",
                        "longitude": "-122.80787000"
                    },
                    {
                        "id": 118897,
                        "name": "Independence",
                        "latitude": "44.85123000",
                        "longitude": "-123.18677000"
                    },
                    {
                        "id": 119002,
                        "name": "Irrigon",
                        "latitude": "45.89569000",
                        "longitude": "-119.49141000"
                    },
                    {
                        "id": 119023,
                        "name": "Island City",
                        "latitude": "45.34097000",
                        "longitude": "-118.04466000"
                    },
                    {
                        "id": 119095,
                        "name": "Jackson County",
                        "latitude": "42.43215000",
                        "longitude": "-122.72843000"
                    },
                    {
                        "id": 119105,
                        "name": "Jacksonville",
                        "latitude": "42.31346000",
                        "longitude": "-122.96699000"
                    },
                    {
                        "id": 119172,
                        "name": "Jefferson",
                        "latitude": "44.71957000",
                        "longitude": "-123.01037000"
                    },
                    {
                        "id": 119197,
                        "name": "Jefferson County",
                        "latitude": "44.62941000",
                        "longitude": "-121.17541000"
                    },
                    {
                        "id": 119221,
                        "name": "Jennings Lodge",
                        "latitude": "45.39123000",
                        "longitude": "-122.61259000"
                    },
                    {
                        "id": 119251,
                        "name": "John Day",
                        "latitude": "44.41599000",
                        "longitude": "-118.95301000"
                    },
                    {
                        "id": 119318,
                        "name": "Joseph",
                        "latitude": "45.35432000",
                        "longitude": "-117.22961000"
                    },
                    {
                        "id": 119321,
                        "name": "Josephine County",
                        "latitude": "42.36546000",
                        "longitude": "-123.55558000"
                    },
                    {
                        "id": 119335,
                        "name": "Junction City",
                        "latitude": "44.21929000",
                        "longitude": "-123.20565000"
                    },
                    {
                        "id": 119426,
                        "name": "Keizer",
                        "latitude": "44.99012000",
                        "longitude": "-123.02621000"
                    },
                    {
                        "id": 119498,
                        "name": "Kenton",
                        "latitude": "45.58178000",
                        "longitude": "-122.68149000"
                    },
                    {
                        "id": 119580,
                        "name": "King City",
                        "latitude": "45.40262000",
                        "longitude": "-122.80399000"
                    },
                    {
                        "id": 119670,
                        "name": "Klamath County",
                        "latitude": "42.68634000",
                        "longitude": "-121.65013000"
                    },
                    {
                        "id": 119671,
                        "name": "Klamath Falls",
                        "latitude": "42.22487000",
                        "longitude": "-121.78167000"
                    },
                    {
                        "id": 119748,
                        "name": "La Grande",
                        "latitude": "45.32458000",
                        "longitude": "-118.08772000"
                    },
                    {
                        "id": 119772,
                        "name": "La Pine",
                        "latitude": "43.67040000",
                        "longitude": "-121.50364000"
                    },
                    {
                        "id": 119837,
                        "name": "Lafayette",
                        "latitude": "45.24428000",
                        "longitude": "-123.11483000"
                    },
                    {
                        "id": 119899,
                        "name": "Lake County",
                        "latitude": "42.79339000",
                        "longitude": "-120.38747000"
                    },
                    {
                        "id": 119955,
                        "name": "Lake Oswego",
                        "latitude": "45.42067000",
                        "longitude": "-122.67065000"
                    },
                    {
                        "id": 120034,
                        "name": "Lakeside",
                        "latitude": "43.57567000",
                        "longitude": "-124.17511000"
                    },
                    {
                        "id": 120041,
                        "name": "Lakeview",
                        "latitude": "42.18877000",
                        "longitude": "-120.34579000"
                    },
                    {
                        "id": 120106,
                        "name": "Lane County",
                        "latitude": "43.94155000",
                        "longitude": "-122.87655000"
                    },
                    {
                        "id": 120294,
                        "name": "Lebanon",
                        "latitude": "44.53651000",
                        "longitude": "-122.90703000"
                    },
                    {
                        "id": 120377,
                        "name": "Lents",
                        "latitude": "45.47984000",
                        "longitude": "-122.56731000"
                    },
                    {
                        "id": 120514,
                        "name": "Lincoln Beach",
                        "latitude": "44.85039000",
                        "longitude": "-124.04678000"
                    },
                    {
                        "id": 120515,
                        "name": "Lincoln City",
                        "latitude": "44.95816000",
                        "longitude": "-124.01789000"
                    },
                    {
                        "id": 120536,
                        "name": "Lincoln County",
                        "latitude": "44.64568000",
                        "longitude": "-123.90770000"
                    },
                    {
                        "id": 120584,
                        "name": "Linn County",
                        "latitude": "44.48857000",
                        "longitude": "-122.53419000"
                    },
                    {
                        "id": 120838,
                        "name": "Lowell",
                        "latitude": "43.91846000",
                        "longitude": "-122.78368000"
                    },
                    {
                        "id": 120944,
                        "name": "Lyons",
                        "latitude": "44.77457000",
                        "longitude": "-122.61509000"
                    },
                    {
                        "id": 121028,
                        "name": "Madras",
                        "latitude": "44.63345000",
                        "longitude": "-121.12949000"
                    },
                    {
                        "id": 121061,
                        "name": "Malheur County",
                        "latitude": "43.19341000",
                        "longitude": "-117.62307000"
                    },
                    {
                        "id": 121262,
                        "name": "Marion County",
                        "latitude": "44.90319000",
                        "longitude": "-122.58473000"
                    },
                    {
                        "id": 121541,
                        "name": "McMinnville",
                        "latitude": "45.21012000",
                        "longitude": "-123.19872000"
                    },
                    {
                        "id": 121596,
                        "name": "Medford",
                        "latitude": "42.32652000",
                        "longitude": "-122.87559000"
                    },
                    {
                        "id": 121701,
                        "name": "Merlin",
                        "latitude": "42.51734000",
                        "longitude": "-123.41979000"
                    },
                    {
                        "id": 121739,
                        "name": "Metzger",
                        "latitude": "45.44651000",
                        "longitude": "-122.75899000"
                    },
                    {
                        "id": 121862,
                        "name": "Mill City",
                        "latitude": "44.75401000",
                        "longitude": "-122.47814000"
                    },
                    {
                        "id": 121887,
                        "name": "Millersburg",
                        "latitude": "44.68095000",
                        "longitude": "-123.06148000"
                    },
                    {
                        "id": 121922,
                        "name": "Milton-Freewater",
                        "latitude": "45.93263000",
                        "longitude": "-118.38774000"
                    },
                    {
                        "id": 121925,
                        "name": "Milwaukie",
                        "latitude": "45.44623000",
                        "longitude": "-122.63926000"
                    },
                    {
                        "id": 121981,
                        "name": "Mission",
                        "latitude": "45.67041000",
                        "longitude": "-118.68359000"
                    },
                    {
                        "id": 122026,
                        "name": "Molalla",
                        "latitude": "45.14734000",
                        "longitude": "-122.57703000"
                    },
                    {
                        "id": 122044,
                        "name": "Monmouth",
                        "latitude": "44.84845000",
                        "longitude": "-123.23399000"
                    },
                    {
                        "id": 122259,
                        "name": "Moro",
                        "latitude": "45.48401000",
                        "longitude": "-120.73117000"
                    },
                    {
                        "id": 122290,
                        "name": "Morrow County",
                        "latitude": "45.41883000",
                        "longitude": "-119.58430000"
                    },
                    {
                        "id": 122332,
                        "name": "Mount Angel",
                        "latitude": "45.06790000",
                        "longitude": "-122.80009000"
                    },
                    {
                        "id": 122352,
                        "name": "Mount Hood Village",
                        "latitude": "45.35540000",
                        "longitude": "-121.98064000"
                    },
                    {
                        "id": 122458,
                        "name": "Mulino",
                        "latitude": "45.22151000",
                        "longitude": "-122.58203000"
                    },
                    {
                        "id": 122463,
                        "name": "Multnomah County",
                        "latitude": "45.54687000",
                        "longitude": "-122.41534000"
                    },
                    {
                        "id": 122521,
                        "name": "Myrtle Creek",
                        "latitude": "43.02012000",
                        "longitude": "-123.29312000"
                    },
                    {
                        "id": 122524,
                        "name": "Myrtle Point",
                        "latitude": "43.06483000",
                        "longitude": "-124.13899000"
                    },
                    {
                        "id": 122728,
                        "name": "New Hope",
                        "latitude": "42.36234000",
                        "longitude": "-123.36784000"
                    },
                    {
                        "id": 122808,
                        "name": "Newberg",
                        "latitude": "45.30012000",
                        "longitude": "-122.97316000"
                    },
                    {
                        "id": 122851,
                        "name": "Newport",
                        "latitude": "44.63678000",
                        "longitude": "-124.05345000"
                    },
                    {
                        "id": 122984,
                        "name": "North Bend",
                        "latitude": "43.40650000",
                        "longitude": "-124.22428000"
                    },
                    {
                        "id": 123081,
                        "name": "North Plains",
                        "latitude": "45.59706000",
                        "longitude": "-122.99344000"
                    },
                    {
                        "id": 123086,
                        "name": "North Portland",
                        "latitude": "45.61039000",
                        "longitude": "-122.70343000"
                    },
                    {
                        "id": 123223,
                        "name": "Nyssa",
                        "latitude": "43.87683000",
                        "longitude": "-116.99488000"
                    },
                    {
                        "id": 123240,
                        "name": "Oak Grove",
                        "latitude": "45.41679000",
                        "longitude": "-122.64009000"
                    },
                    {
                        "id": 123249,
                        "name": "Oak Hills",
                        "latitude": "45.54123000",
                        "longitude": "-122.84121000"
                    },
                    {
                        "id": 123304,
                        "name": "Oakridge",
                        "latitude": "43.74651000",
                        "longitude": "-122.46172000"
                    },
                    {
                        "id": 123314,
                        "name": "Oatfield",
                        "latitude": "45.41418000",
                        "longitude": "-122.60007000"
                    },
                    {
                        "id": 123354,
                        "name": "Odell",
                        "latitude": "45.62706000",
                        "longitude": "-121.54313000"
                    },
                    {
                        "id": 123487,
                        "name": "Ontario",
                        "latitude": "44.02655000",
                        "longitude": "-116.96294000"
                    },
                    {
                        "id": 123548,
                        "name": "Oregon City",
                        "latitude": "45.35734000",
                        "longitude": "-122.60676000"
                    },
                    {
                        "id": 123708,
                        "name": "Pacific City",
                        "latitude": "45.20233000",
                        "longitude": "-123.96289000"
                    },
                    {
                        "id": 124018,
                        "name": "Pendleton",
                        "latitude": "45.67207000",
                        "longitude": "-118.78860000"
                    },
                    {
                        "id": 124144,
                        "name": "Philomath",
                        "latitude": "44.54012000",
                        "longitude": "-123.36760000"
                    },
                    {
                        "id": 124149,
                        "name": "Phoenix",
                        "latitude": "42.27541000",
                        "longitude": "-122.81809000"
                    },
                    {
                        "id": 124202,
                        "name": "Pilot Rock",
                        "latitude": "45.48318000",
                        "longitude": "-118.82998000"
                    },
                    {
                        "id": 124451,
                        "name": "Polk County",
                        "latitude": "44.90348000",
                        "longitude": "-123.41337000"
                    },
                    {
                        "id": 124526,
                        "name": "Port Orford",
                        "latitude": "42.74566000",
                        "longitude": "-124.49733000"
                    },
                    {
                        "id": 124565,
                        "name": "Portland",
                        "latitude": "45.52345000",
                        "longitude": "-122.67621000"
                    },
                    {
                        "id": 124697,
                        "name": "Prineville",
                        "latitude": "44.29985000",
                        "longitude": "-120.83447000"
                    },
                    {
                        "id": 124826,
                        "name": "Rainier",
                        "latitude": "46.08900000",
                        "longitude": "-122.93594000"
                    },
                    {
                        "id": 124833,
                        "name": "Raleigh Hills",
                        "latitude": "45.48067000",
                        "longitude": "-122.76204000"
                    },
                    {
                        "id": 124978,
                        "name": "Redmond",
                        "latitude": "44.27262000",
                        "longitude": "-121.17392000"
                    },
                    {
                        "id": 124985,
                        "name": "Redwood",
                        "latitude": "42.42206000",
                        "longitude": "-123.38728000"
                    },
                    {
                        "id": 124995,
                        "name": "Reedsport",
                        "latitude": "43.70234000",
                        "longitude": "-124.09678000"
                    },
                    {
                        "id": 125113,
                        "name": "Riddle",
                        "latitude": "42.95095000",
                        "longitude": "-123.36423000"
                    },
                    {
                        "id": 125290,
                        "name": "Rockaway Beach",
                        "latitude": "45.61344000",
                        "longitude": "-123.94291000"
                    },
                    {
                        "id": 125294,
                        "name": "Rockcreek",
                        "latitude": "45.55012000",
                        "longitude": "-122.87705000"
                    },
                    {
                        "id": 125357,
                        "name": "Rogue River",
                        "latitude": "42.43595000",
                        "longitude": "-123.17200000"
                    },
                    {
                        "id": 125406,
                        "name": "Rose Lodge",
                        "latitude": "45.01039000",
                        "longitude": "-123.88039000"
                    },
                    {
                        "id": 125414,
                        "name": "Roseburg",
                        "latitude": "43.21650000",
                        "longitude": "-123.34174000"
                    },
                    {
                        "id": 125415,
                        "name": "Roseburg North",
                        "latitude": "43.26452000",
                        "longitude": "-123.30331000"
                    },
                    {
                        "id": 125649,
                        "name": "Saint Helens",
                        "latitude": "45.86400000",
                        "longitude": "-122.80649000"
                    },
                    {
                        "id": 125740,
                        "name": "Salem",
                        "latitude": "44.94290000",
                        "longitude": "-123.03510000"
                    },
                    {
                        "id": 125880,
                        "name": "Sandy",
                        "latitude": "45.39734000",
                        "longitude": "-122.26148000"
                    },
                    {
                        "id": 125996,
                        "name": "Scappoose",
                        "latitude": "45.75428000",
                        "longitude": "-122.87760000"
                    },
                    {
                        "id": 126100,
                        "name": "Seaside",
                        "latitude": "45.99316000",
                        "longitude": "-123.92264000"
                    },
                    {
                        "id": 126203,
                        "name": "Shady Cove",
                        "latitude": "42.61068000",
                        "longitude": "-122.81254000"
                    },
                    {
                        "id": 126322,
                        "name": "Sheridan",
                        "latitude": "45.09928000",
                        "longitude": "-123.39483000"
                    },
                    {
                        "id": 126335,
                        "name": "Sherman County",
                        "latitude": "45.40521000",
                        "longitude": "-120.68932000"
                    },
                    {
                        "id": 126342,
                        "name": "Sherwood",
                        "latitude": "45.35651000",
                        "longitude": "-122.84010000"
                    },
                    {
                        "id": 126416,
                        "name": "Siletz",
                        "latitude": "44.72178000",
                        "longitude": "-123.92011000"
                    },
                    {
                        "id": 126442,
                        "name": "Silverton",
                        "latitude": "45.00512000",
                        "longitude": "-122.78315000"
                    },
                    {
                        "id": 126468,
                        "name": "Sisters",
                        "latitude": "44.29095000",
                        "longitude": "-121.54921000"
                    },
                    {
                        "id": 126688,
                        "name": "South Lebanon",
                        "latitude": "44.50623000",
                        "longitude": "-122.90314000"
                    },
                    {
                        "id": 126907,
                        "name": "Springfield",
                        "latitude": "44.04624000",
                        "longitude": "-123.02203000"
                    },
                    {
                        "id": 126935,
                        "name": "Stafford",
                        "latitude": "45.35734000",
                        "longitude": "-122.72259000"
                    },
                    {
                        "id": 126952,
                        "name": "Stanfield",
                        "latitude": "45.78041000",
                        "longitude": "-119.21724000"
                    },
                    {
                        "id": 127002,
                        "name": "Stayton",
                        "latitude": "44.80068000",
                        "longitude": "-122.79453000"
                    },
                    {
                        "id": 127159,
                        "name": "Sublimity",
                        "latitude": "44.82957000",
                        "longitude": "-122.79453000"
                    },
                    {
                        "id": 127270,
                        "name": "Sunriver",
                        "latitude": "43.88401000",
                        "longitude": "-121.43864000"
                    },
                    {
                        "id": 127307,
                        "name": "Sutherlin",
                        "latitude": "43.39012000",
                        "longitude": "-123.31258000"
                    },
                    {
                        "id": 127337,
                        "name": "Sweet Home",
                        "latitude": "44.39762000",
                        "longitude": "-122.73620000"
                    },
                    {
                        "id": 127386,
                        "name": "Talent",
                        "latitude": "42.24568000",
                        "longitude": "-122.78865000"
                    },
                    {
                        "id": 127413,
                        "name": "Tangent",
                        "latitude": "44.54123000",
                        "longitude": "-123.10815000"
                    },
                    {
                        "id": 127524,
                        "name": "Terrebonne",
                        "latitude": "44.35290000",
                        "longitude": "-121.17781000"
                    },
                    {
                        "id": 127557,
                        "name": "The Dalles",
                        "latitude": "45.59456000",
                        "longitude": "-121.17868000"
                    },
                    {
                        "id": 127621,
                        "name": "Three Rivers",
                        "latitude": "43.82012000",
                        "longitude": "-121.46919000"
                    },
                    {
                        "id": 127643,
                        "name": "Tigard",
                        "latitude": "45.43123000",
                        "longitude": "-122.77149000"
                    },
                    {
                        "id": 127648,
                        "name": "Tillamook",
                        "latitude": "45.45640000",
                        "longitude": "-123.84553000"
                    },
                    {
                        "id": 127649,
                        "name": "Tillamook County",
                        "latitude": "45.45645000",
                        "longitude": "-123.75877000"
                    },
                    {
                        "id": 127700,
                        "name": "Toledo",
                        "latitude": "44.62151000",
                        "longitude": "-123.93845000"
                    },
                    {
                        "id": 127816,
                        "name": "Tri-City",
                        "latitude": "42.98456000",
                        "longitude": "-123.31173000"
                    },
                    {
                        "id": 127838,
                        "name": "Troutdale",
                        "latitude": "45.53929000",
                        "longitude": "-122.38731000"
                    },
                    {
                        "id": 127865,
                        "name": "Tualatin",
                        "latitude": "45.38401000",
                        "longitude": "-122.76399000"
                    },
                    {
                        "id": 127902,
                        "name": "Turner",
                        "latitude": "44.84318000",
                        "longitude": "-122.95287000"
                    },
                    {
                        "id": 127962,
                        "name": "Umatilla",
                        "latitude": "45.91735000",
                        "longitude": "-119.34252000"
                    },
                    {
                        "id": 127963,
                        "name": "Umatilla County",
                        "latitude": "45.59190000",
                        "longitude": "-118.73683000"
                    },
                    {
                        "id": 127978,
                        "name": "Union",
                        "latitude": "45.20847000",
                        "longitude": "-117.86521000"
                    },
                    {
                        "id": 128003,
                        "name": "Union County",
                        "latitude": "45.31035000",
                        "longitude": "-118.00900000"
                    },
                    {
                        "id": 128086,
                        "name": "Vale",
                        "latitude": "43.98211000",
                        "longitude": "-117.23823000"
                    },
                    {
                        "id": 128168,
                        "name": "Veneta",
                        "latitude": "44.04873000",
                        "longitude": "-123.35093000"
                    },
                    {
                        "id": 128197,
                        "name": "Vernonia",
                        "latitude": "45.85872000",
                        "longitude": "-123.19289000"
                    },
                    {
                        "id": 128376,
                        "name": "Waldport",
                        "latitude": "44.42679000",
                        "longitude": "-124.06873000"
                    },
                    {
                        "id": 128411,
                        "name": "Wallowa County",
                        "latitude": "45.57983000",
                        "longitude": "-117.18107000"
                    },
                    {
                        "id": 128471,
                        "name": "Warm Springs",
                        "latitude": "44.76345000",
                        "longitude": "-121.26616000"
                    },
                    {
                        "id": 128485,
                        "name": "Warren",
                        "latitude": "45.81900000",
                        "longitude": "-122.84899000"
                    },
                    {
                        "id": 128508,
                        "name": "Warrenton",
                        "latitude": "46.16510000",
                        "longitude": "-123.92376000"
                    },
                    {
                        "id": 128529,
                        "name": "Wasco County",
                        "latitude": "45.16005000",
                        "longitude": "-121.16815000"
                    },
                    {
                        "id": 128580,
                        "name": "Washington County",
                        "latitude": "45.56007000",
                        "longitude": "-123.09849000"
                    },
                    {
                        "id": 128889,
                        "name": "West Haven",
                        "latitude": "45.51762000",
                        "longitude": "-122.76954000"
                    },
                    {
                        "id": 128890,
                        "name": "West Haven-Sylvan",
                        "latitude": "45.51613000",
                        "longitude": "-122.76809000"
                    },
                    {
                        "id": 128919,
                        "name": "West Linn",
                        "latitude": "45.36568000",
                        "longitude": "-122.61231000"
                    },
                    {
                        "id": 128983,
                        "name": "West Slope",
                        "latitude": "45.49873000",
                        "longitude": "-122.76454000"
                    },
                    {
                        "id": 129119,
                        "name": "Wheeler County",
                        "latitude": "44.72606000",
                        "longitude": "-120.02746000"
                    },
                    {
                        "id": 129131,
                        "name": "White City",
                        "latitude": "42.43735000",
                        "longitude": "-122.85893000"
                    },
                    {
                        "id": 129256,
                        "name": "Willamina",
                        "latitude": "45.07873000",
                        "longitude": "-123.48594000"
                    },
                    {
                        "id": 129262,
                        "name": "Williams",
                        "latitude": "42.21873000",
                        "longitude": "-123.27394000"
                    },
                    {
                        "id": 129341,
                        "name": "Wilsonville",
                        "latitude": "45.29984000",
                        "longitude": "-122.77371000"
                    },
                    {
                        "id": 129433,
                        "name": "Winston",
                        "latitude": "43.12234000",
                        "longitude": "-123.41257000"
                    },
                    {
                        "id": 129490,
                        "name": "Wood Village",
                        "latitude": "45.53429000",
                        "longitude": "-122.41870000"
                    },
                    {
                        "id": 129504,
                        "name": "Woodburn",
                        "latitude": "45.14373000",
                        "longitude": "-122.85537000"
                    },
                    {
                        "id": 129657,
                        "name": "Yamhill",
                        "latitude": "45.34150000",
                        "longitude": "-123.18733000"
                    },
                    {
                        "id": 129658,
                        "name": "Yamhill County",
                        "latitude": "45.23260000",
                        "longitude": "-123.30815000"
                    },
                    {
                        "id": 129687,
                        "name": "Yoncalla",
                        "latitude": "43.59845000",
                        "longitude": "-123.28342000"
                    }
                ]
            },
            {
                "id": 1448,
                "name": "Palmyra Atoll",
                "iso2": "UM-95",
                "latitude": "5.88850260",
                "longitude": "-162.07866560",
                "type": "islands \/ groups of islands",
                "cities": []
            },
            {
                "id": 1422,
                "name": "Pennsylvania",
                "iso2": "PA",
                "latitude": "41.20332160",
                "longitude": "-77.19452470",
                "type": "state",
                "cities": [
                    {
                        "id": 110971,
                        "name": "Abbottstown",
                        "latitude": "39.88649000",
                        "longitude": "-76.98470000"
                    },
                    {
                        "id": 111019,
                        "name": "Adams County",
                        "latitude": "39.87145000",
                        "longitude": "-77.21789000"
                    },
                    {
                        "id": 111030,
                        "name": "Adamstown",
                        "latitude": "40.24120000",
                        "longitude": "-76.05633000"
                    },
                    {
                        "id": 111079,
                        "name": "Akron",
                        "latitude": "40.15676000",
                        "longitude": "-76.20217000"
                    },
                    {
                        "id": 111129,
                        "name": "Albion",
                        "latitude": "41.89061000",
                        "longitude": "-80.36645000"
                    },
                    {
                        "id": 111131,
                        "name": "Alburtis",
                        "latitude": "40.51093000",
                        "longitude": "-75.60297000"
                    },
                    {
                        "id": 111135,
                        "name": "Aldan",
                        "latitude": "39.92150000",
                        "longitude": "-75.28796000"
                    },
                    {
                        "id": 111174,
                        "name": "Aliquippa",
                        "latitude": "40.63673000",
                        "longitude": "-80.24006000"
                    },
                    {
                        "id": 111185,
                        "name": "Allegheny County",
                        "latitude": "40.46883000",
                        "longitude": "-79.98119000"
                    },
                    {
                        "id": 111186,
                        "name": "Alleghenyville",
                        "latitude": "40.23426000",
                        "longitude": "-75.98855000"
                    },
                    {
                        "id": 111199,
                        "name": "Allentown",
                        "latitude": "40.60843000",
                        "longitude": "-75.49018000"
                    },
                    {
                        "id": 111202,
                        "name": "Allison Park",
                        "latitude": "40.55951000",
                        "longitude": "-79.95867000"
                    },
                    {
                        "id": 111212,
                        "name": "Almedia",
                        "latitude": "41.01453000",
                        "longitude": "-76.38105000"
                    },
                    {
                        "id": 111248,
                        "name": "Altoona",
                        "latitude": "40.51868000",
                        "longitude": "-78.39474000"
                    },
                    {
                        "id": 111264,
                        "name": "Ambler",
                        "latitude": "40.15455000",
                        "longitude": "-75.22157000"
                    },
                    {
                        "id": 111267,
                        "name": "Ambridge",
                        "latitude": "40.58923000",
                        "longitude": "-80.22506000"
                    },
                    {
                        "id": 111291,
                        "name": "Amity Gardens",
                        "latitude": "40.27426000",
                        "longitude": "-75.73519000"
                    },
                    {
                        "id": 111307,
                        "name": "Ancient Oaks",
                        "latitude": "40.54732000",
                        "longitude": "-75.58935000"
                    },
                    {
                        "id": 111357,
                        "name": "Annville",
                        "latitude": "40.32954000",
                        "longitude": "-76.51524000"
                    },
                    {
                        "id": 111387,
                        "name": "Apollo",
                        "latitude": "40.58145000",
                        "longitude": "-79.56643000"
                    },
                    {
                        "id": 111427,
                        "name": "Archbald",
                        "latitude": "41.49480000",
                        "longitude": "-75.53685000"
                    },
                    {
                        "id": 111443,
                        "name": "Ardmore",
                        "latitude": "40.00678000",
                        "longitude": "-75.28546000"
                    },
                    {
                        "id": 111473,
                        "name": "Arlington Heights",
                        "latitude": "40.99009000",
                        "longitude": "-75.21629000"
                    },
                    {
                        "id": 111480,
                        "name": "Armstrong County",
                        "latitude": "40.81229000",
                        "longitude": "-79.46454000"
                    },
                    {
                        "id": 111487,
                        "name": "Arnold",
                        "latitude": "40.58007000",
                        "longitude": "-79.76672000"
                    },
                    {
                        "id": 111537,
                        "name": "Ashland",
                        "latitude": "40.78175000",
                        "longitude": "-76.34578000"
                    },
                    {
                        "id": 111544,
                        "name": "Ashley",
                        "latitude": "41.21036000",
                        "longitude": "-75.89659000"
                    },
                    {
                        "id": 111555,
                        "name": "Aspinwall",
                        "latitude": "40.49146000",
                        "longitude": "-79.90477000"
                    },
                    {
                        "id": 111571,
                        "name": "Atglen",
                        "latitude": "39.94927000",
                        "longitude": "-75.97356000"
                    },
                    {
                        "id": 111580,
                        "name": "Athens",
                        "latitude": "41.95730000",
                        "longitude": "-76.51800000"
                    },
                    {
                        "id": 111640,
                        "name": "Audubon",
                        "latitude": "40.12788000",
                        "longitude": "-75.43185000"
                    },
                    {
                        "id": 111674,
                        "name": "Avalon",
                        "latitude": "40.50090000",
                        "longitude": "-80.06756000"
                    },
                    {
                        "id": 111685,
                        "name": "Avis",
                        "latitude": "41.18479000",
                        "longitude": "-77.31386000"
                    },
                    {
                        "id": 111688,
                        "name": "Avoca",
                        "latitude": "41.33980000",
                        "longitude": "-75.73630000"
                    },
                    {
                        "id": 111694,
                        "name": "Avon",
                        "latitude": "40.34565000",
                        "longitude": "-76.38996000"
                    },
                    {
                        "id": 111699,
                        "name": "Avondale",
                        "latitude": "39.82344000",
                        "longitude": "-75.78327000"
                    },
                    {
                        "id": 111703,
                        "name": "Avonia",
                        "latitude": "42.04561000",
                        "longitude": "-80.26979000"
                    },
                    {
                        "id": 111718,
                        "name": "Back Mountain",
                        "latitude": "41.33591000",
                        "longitude": "-75.99631000"
                    },
                    {
                        "id": 111723,
                        "name": "Baden",
                        "latitude": "40.63507000",
                        "longitude": "-80.22812000"
                    },
                    {
                        "id": 111729,
                        "name": "Baidland",
                        "latitude": "40.19479000",
                        "longitude": "-79.97088000"
                    },
                    {
                        "id": 111734,
                        "name": "Bainbridge",
                        "latitude": "40.09093000",
                        "longitude": "-76.66747000"
                    },
                    {
                        "id": 111745,
                        "name": "Bakerstown",
                        "latitude": "40.65090000",
                        "longitude": "-79.93644000"
                    },
                    {
                        "id": 111748,
                        "name": "Bala-Cynwyd",
                        "latitude": "40.00761000",
                        "longitude": "-75.23407000"
                    },
                    {
                        "id": 111757,
                        "name": "Baldwin",
                        "latitude": "40.33813000",
                        "longitude": "-79.97894000"
                    },
                    {
                        "id": 111777,
                        "name": "Bally",
                        "latitude": "40.40232000",
                        "longitude": "-75.58713000"
                    },
                    {
                        "id": 111793,
                        "name": "Bangor",
                        "latitude": "40.86565000",
                        "longitude": "-75.20657000"
                    },
                    {
                        "id": 111828,
                        "name": "Barnesboro",
                        "latitude": "40.66257000",
                        "longitude": "-78.78003000"
                    },
                    {
                        "id": 111899,
                        "name": "Bath",
                        "latitude": "40.72565000",
                        "longitude": "-75.39407000"
                    },
                    {
                        "id": 111978,
                        "name": "Bear Rocks",
                        "latitude": "40.12285000",
                        "longitude": "-79.46170000"
                    },
                    {
                        "id": 111993,
                        "name": "Beaver",
                        "latitude": "40.69534000",
                        "longitude": "-80.30478000"
                    },
                    {
                        "id": 111997,
                        "name": "Beaver County",
                        "latitude": "40.68226000",
                        "longitude": "-80.34929000"
                    },
                    {
                        "id": 112004,
                        "name": "Beaver Falls",
                        "latitude": "40.75201000",
                        "longitude": "-80.31923000"
                    },
                    {
                        "id": 112006,
                        "name": "Beaverdale",
                        "latitude": "40.32202000",
                        "longitude": "-78.69696000"
                    },
                    {
                        "id": 112026,
                        "name": "Bedford",
                        "latitude": "40.01869000",
                        "longitude": "-78.50391000"
                    },
                    {
                        "id": 112029,
                        "name": "Bedford County",
                        "latitude": "40.00656000",
                        "longitude": "-78.49032000"
                    },
                    {
                        "id": 112032,
                        "name": "Bedminster",
                        "latitude": "40.42594000",
                        "longitude": "-75.17906000"
                    },
                    {
                        "id": 112038,
                        "name": "Beech Mountain Lakes",
                        "latitude": "41.04158000",
                        "longitude": "-75.93545000"
                    },
                    {
                        "id": 112057,
                        "name": "Belfast",
                        "latitude": "40.78065000",
                        "longitude": "-75.27796000"
                    },
                    {
                        "id": 112067,
                        "name": "Bell Acres",
                        "latitude": "40.59007000",
                        "longitude": "-80.16645000"
                    },
                    {
                        "id": 112093,
                        "name": "Belle Vernon",
                        "latitude": "40.12507000",
                        "longitude": "-79.86644000"
                    },
                    {
                        "id": 112099,
                        "name": "Bellefonte",
                        "latitude": "40.91339000",
                        "longitude": "-77.77833000"
                    },
                    {
                        "id": 112107,
                        "name": "Belleville",
                        "latitude": "40.60507000",
                        "longitude": "-77.72555000"
                    },
                    {
                        "id": 112114,
                        "name": "Bellevue",
                        "latitude": "40.49396000",
                        "longitude": "-80.05172000"
                    },
                    {
                        "id": 112132,
                        "name": "Bellwood",
                        "latitude": "40.60340000",
                        "longitude": "-78.32474000"
                    },
                    {
                        "id": 112141,
                        "name": "Belmont",
                        "latitude": "40.28730000",
                        "longitude": "-78.88947000"
                    },
                    {
                        "id": 112161,
                        "name": "Ben Avon",
                        "latitude": "40.50812000",
                        "longitude": "-80.08311000"
                    },
                    {
                        "id": 112190,
                        "name": "Bentleyville",
                        "latitude": "40.11674000",
                        "longitude": "-80.00839000"
                    },
                    {
                        "id": 112232,
                        "name": "Berks County",
                        "latitude": "40.41630000",
                        "longitude": "-75.92600000"
                    },
                    {
                        "id": 112236,
                        "name": "Berlin",
                        "latitude": "39.92064000",
                        "longitude": "-78.95780000"
                    },
                    {
                        "id": 112263,
                        "name": "Berwick",
                        "latitude": "41.05453000",
                        "longitude": "-76.23327000"
                    },
                    {
                        "id": 112265,
                        "name": "Berwyn",
                        "latitude": "40.04483000",
                        "longitude": "-75.43881000"
                    },
                    {
                        "id": 112269,
                        "name": "Bessemer",
                        "latitude": "40.97478000",
                        "longitude": "-80.49368000"
                    },
                    {
                        "id": 112287,
                        "name": "Bethel Park",
                        "latitude": "40.32757000",
                        "longitude": "-80.03950000"
                    },
                    {
                        "id": 112291,
                        "name": "Bethlehem",
                        "latitude": "40.62593000",
                        "longitude": "-75.37046000"
                    },
                    {
                        "id": 112314,
                        "name": "Big Bass Lake",
                        "latitude": "41.25383000",
                        "longitude": "-75.47644000"
                    },
                    {
                        "id": 112317,
                        "name": "Big Beaver",
                        "latitude": "40.82451000",
                        "longitude": "-80.36284000"
                    },
                    {
                        "id": 112341,
                        "name": "Biglerville",
                        "latitude": "39.93037000",
                        "longitude": "-77.24804000"
                    },
                    {
                        "id": 112356,
                        "name": "Birchwood Lakes",
                        "latitude": "41.25454000",
                        "longitude": "-74.91850000"
                    },
                    {
                        "id": 112357,
                        "name": "Birdsboro",
                        "latitude": "40.26454000",
                        "longitude": "-75.80409000"
                    },
                    {
                        "id": 112379,
                        "name": "Black Lick",
                        "latitude": "40.47250000",
                        "longitude": "-79.18688000"
                    },
                    {
                        "id": 112411,
                        "name": "Blair County",
                        "latitude": "40.48100000",
                        "longitude": "-78.34860000"
                    },
                    {
                        "id": 112413,
                        "name": "Blairsville",
                        "latitude": "40.43118000",
                        "longitude": "-79.26087000"
                    },
                    {
                        "id": 112415,
                        "name": "Blakely",
                        "latitude": "41.48091000",
                        "longitude": "-75.59463000"
                    },
                    {
                        "id": 112423,
                        "name": "Blandon",
                        "latitude": "40.44120000",
                        "longitude": "-75.88687000"
                    },
                    {
                        "id": 112426,
                        "name": "Blawnox",
                        "latitude": "40.49340000",
                        "longitude": "-79.86061000"
                    },
                    {
                        "id": 112439,
                        "name": "Bloomfield",
                        "latitude": "40.46090000",
                        "longitude": "-79.95089000"
                    },
                    {
                        "id": 112454,
                        "name": "Bloomsburg",
                        "latitude": "41.00370000",
                        "longitude": "-76.45495000"
                    },
                    {
                        "id": 112455,
                        "name": "Blossburg",
                        "latitude": "41.67952000",
                        "longitude": "-77.06386000"
                    },
                    {
                        "id": 112463,
                        "name": "Blue Ball",
                        "latitude": "40.11871000",
                        "longitude": "-76.04717000"
                    },
                    {
                        "id": 112464,
                        "name": "Blue Bell",
                        "latitude": "40.15233000",
                        "longitude": "-75.26629000"
                    },
                    {
                        "id": 112488,
                        "name": "Boalsburg",
                        "latitude": "40.77562000",
                        "longitude": "-77.79250000"
                    },
                    {
                        "id": 112507,
                        "name": "Boiling Springs",
                        "latitude": "40.14981000",
                        "longitude": "-77.12831000"
                    },
                    {
                        "id": 112541,
                        "name": "Bonneauville",
                        "latitude": "39.81204000",
                        "longitude": "-77.13721000"
                    },
                    {
                        "id": 112574,
                        "name": "Boothwyn",
                        "latitude": "39.83011000",
                        "longitude": "-75.44158000"
                    },
                    {
                        "id": 112592,
                        "name": "Boswell",
                        "latitude": "40.16147000",
                        "longitude": "-79.02892000"
                    },
                    {
                        "id": 112634,
                        "name": "Bowmansville",
                        "latitude": "40.19676000",
                        "longitude": "-76.01744000"
                    },
                    {
                        "id": 112645,
                        "name": "Boyertown",
                        "latitude": "40.33371000",
                        "longitude": "-75.63741000"
                    },
                    {
                        "id": 112656,
                        "name": "Brackenridge",
                        "latitude": "40.60812000",
                        "longitude": "-79.74116000"
                    },
                    {
                        "id": 112659,
                        "name": "Braddock",
                        "latitude": "40.40340000",
                        "longitude": "-79.86838000"
                    },
                    {
                        "id": 112661,
                        "name": "Braddock Hills",
                        "latitude": "40.41729000",
                        "longitude": "-79.86505000"
                    },
                    {
                        "id": 112666,
                        "name": "Bradford",
                        "latitude": "41.95590000",
                        "longitude": "-78.64392000"
                    },
                    {
                        "id": 112669,
                        "name": "Bradford County",
                        "latitude": "41.78867000",
                        "longitude": "-76.51545000"
                    },
                    {
                        "id": 112670,
                        "name": "Bradford Woods",
                        "latitude": "40.63757000",
                        "longitude": "-80.08172000"
                    },
                    {
                        "id": 112719,
                        "name": "Breinigsville",
                        "latitude": "40.53676000",
                        "longitude": "-75.63130000"
                    },
                    {
                        "id": 112732,
                        "name": "Brentwood",
                        "latitude": "40.37063000",
                        "longitude": "-79.97477000"
                    },
                    {
                        "id": 112735,
                        "name": "Bressler",
                        "latitude": "40.22953000",
                        "longitude": "-76.81997000"
                    },
                    {
                        "id": 112754,
                        "name": "Brickerville",
                        "latitude": "40.22593000",
                        "longitude": "-76.30246000"
                    },
                    {
                        "id": 112764,
                        "name": "Bridgeport",
                        "latitude": "40.10511000",
                        "longitude": "-75.34518000"
                    },
                    {
                        "id": 112773,
                        "name": "Bridgeville",
                        "latitude": "40.35618000",
                        "longitude": "-80.11006000"
                    },
                    {
                        "id": 112808,
                        "name": "Bristol",
                        "latitude": "40.10067000",
                        "longitude": "-74.85183000"
                    },
                    {
                        "id": 112818,
                        "name": "Brittany Farms-Highlands",
                        "latitude": "40.26901000",
                        "longitude": "-75.21401000"
                    },
                    {
                        "id": 112835,
                        "name": "Brockway",
                        "latitude": "41.24923000",
                        "longitude": "-78.79947000"
                    },
                    {
                        "id": 112839,
                        "name": "Brodheadsville",
                        "latitude": "40.92454000",
                        "longitude": "-75.39379000"
                    },
                    {
                        "id": 112858,
                        "name": "Brookhaven",
                        "latitude": "39.86928000",
                        "longitude": "-75.38241000"
                    },
                    {
                        "id": 112896,
                        "name": "Brookville",
                        "latitude": "41.16117000",
                        "longitude": "-79.08309000"
                    },
                    {
                        "id": 112898,
                        "name": "Broomall",
                        "latitude": "39.98150000",
                        "longitude": "-75.35658000"
                    },
                    {
                        "id": 112927,
                        "name": "Brownstown",
                        "latitude": "40.12371000",
                        "longitude": "-76.21384000"
                    },
                    {
                        "id": 112934,
                        "name": "Brownsville",
                        "latitude": "40.02369000",
                        "longitude": "-79.88394000"
                    },
                    {
                        "id": 112936,
                        "name": "Browntown",
                        "latitude": "41.30980000",
                        "longitude": "-75.78742000"
                    },
                    {
                        "id": 112965,
                        "name": "Bryn Athyn",
                        "latitude": "40.13150000",
                        "longitude": "-75.06739000"
                    },
                    {
                        "id": 112966,
                        "name": "Bryn Mawr",
                        "latitude": "40.01983000",
                        "longitude": "-75.30463000"
                    },
                    {
                        "id": 112991,
                        "name": "Bucks County",
                        "latitude": "40.33694000",
                        "longitude": "-75.10687000"
                    },
                    {
                        "id": 113051,
                        "name": "Burgettstown",
                        "latitude": "40.38201000",
                        "longitude": "-80.39284000"
                    },
                    {
                        "id": 113085,
                        "name": "Burnham",
                        "latitude": "40.63868000",
                        "longitude": "-77.56861000"
                    },
                    {
                        "id": 113111,
                        "name": "Butler",
                        "latitude": "40.86118000",
                        "longitude": "-79.89533000"
                    },
                    {
                        "id": 113120,
                        "name": "Butler County",
                        "latitude": "40.91172000",
                        "longitude": "-79.91299000"
                    },
                    {
                        "id": 113217,
                        "name": "California",
                        "latitude": "40.06563000",
                        "longitude": "-79.89171000"
                    },
                    {
                        "id": 113228,
                        "name": "Caln",
                        "latitude": "39.99094000",
                        "longitude": "-75.78022000"
                    },
                    {
                        "id": 113229,
                        "name": "Calumet",
                        "latitude": "40.21090000",
                        "longitude": "-79.48532000"
                    },
                    {
                        "id": 113247,
                        "name": "Cambria County",
                        "latitude": "40.49529000",
                        "longitude": "-78.71370000"
                    },
                    {
                        "id": 113258,
                        "name": "Cambridge Springs",
                        "latitude": "41.80367000",
                        "longitude": "-80.05644000"
                    },
                    {
                        "id": 113278,
                        "name": "Cameron County",
                        "latitude": "41.43680000",
                        "longitude": "-78.20378000"
                    },
                    {
                        "id": 113287,
                        "name": "Camp Hill",
                        "latitude": "40.23981000",
                        "longitude": "-76.91997000"
                    },
                    {
                        "id": 113306,
                        "name": "Campbelltown",
                        "latitude": "40.27759000",
                        "longitude": "-76.58525000"
                    },
                    {
                        "id": 113336,
                        "name": "Canonsburg",
                        "latitude": "40.26257000",
                        "longitude": "-80.18728000"
                    },
                    {
                        "id": 113349,
                        "name": "Canton",
                        "latitude": "41.65646000",
                        "longitude": "-76.85329000"
                    },
                    {
                        "id": 113382,
                        "name": "Carbon County",
                        "latitude": "40.91818000",
                        "longitude": "-75.70882000"
                    },
                    {
                        "id": 113389,
                        "name": "Carbondale",
                        "latitude": "41.57369000",
                        "longitude": "-75.50185000"
                    },
                    {
                        "id": 113405,
                        "name": "Carlisle",
                        "latitude": "40.20148000",
                        "longitude": "-77.18887000"
                    },
                    {
                        "id": 113426,
                        "name": "Carnegie",
                        "latitude": "40.40868000",
                        "longitude": "-80.08339000"
                    },
                    {
                        "id": 113430,
                        "name": "Carnot-Moon",
                        "latitude": "40.51856000",
                        "longitude": "-80.21736000"
                    },
                    {
                        "id": 113462,
                        "name": "Carroll Valley",
                        "latitude": "39.74926000",
                        "longitude": "-77.38304000"
                    },
                    {
                        "id": 113541,
                        "name": "Castanea",
                        "latitude": "41.12479000",
                        "longitude": "-77.42970000"
                    },
                    {
                        "id": 113551,
                        "name": "Castle Shannon",
                        "latitude": "40.36479000",
                        "longitude": "-80.02228000"
                    },
                    {
                        "id": 113565,
                        "name": "Catasauqua",
                        "latitude": "40.65482000",
                        "longitude": "-75.47463000"
                    },
                    {
                        "id": 113568,
                        "name": "Catawissa",
                        "latitude": "40.95203000",
                        "longitude": "-76.45967000"
                    },
                    {
                        "id": 113599,
                        "name": "Cecil-Bishop",
                        "latitude": "40.31819000",
                        "longitude": "-80.19331000"
                    },
                    {
                        "id": 113633,
                        "name": "Cementon",
                        "latitude": "40.68926000",
                        "longitude": "-75.50768000"
                    },
                    {
                        "id": 113641,
                        "name": "Center City",
                        "latitude": "39.95120000",
                        "longitude": "-75.15923000"
                    },
                    {
                        "id": 113661,
                        "name": "Centerville",
                        "latitude": "40.04535000",
                        "longitude": "-79.97561000"
                    },
                    {
                        "id": 113670,
                        "name": "Central City",
                        "latitude": "40.11063000",
                        "longitude": "-78.80197000"
                    },
                    {
                        "id": 113689,
                        "name": "Centre County",
                        "latitude": "40.91934000",
                        "longitude": "-77.81995000"
                    },
                    {
                        "id": 113690,
                        "name": "Centre Hall",
                        "latitude": "40.84756000",
                        "longitude": "-77.68611000"
                    },
                    {
                        "id": 113704,
                        "name": "Cetronia",
                        "latitude": "40.58676000",
                        "longitude": "-75.52963000"
                    },
                    {
                        "id": 113712,
                        "name": "Chalfont",
                        "latitude": "40.28844000",
                        "longitude": "-75.20906000"
                    },
                    {
                        "id": 113722,
                        "name": "Chambersburg",
                        "latitude": "39.93759000",
                        "longitude": "-77.66110000"
                    },
                    {
                        "id": 113753,
                        "name": "Charleroi",
                        "latitude": "40.13785000",
                        "longitude": "-79.89810000"
                    },
                    {
                        "id": 113871,
                        "name": "Cherryville",
                        "latitude": "40.75398000",
                        "longitude": "-75.53852000"
                    },
                    {
                        "id": 113884,
                        "name": "Chester",
                        "latitude": "39.84967000",
                        "longitude": "-75.35707000"
                    },
                    {
                        "id": 113897,
                        "name": "Chester County",
                        "latitude": "39.97314000",
                        "longitude": "-75.74845000"
                    },
                    {
                        "id": 113898,
                        "name": "Chester Heights",
                        "latitude": "39.89011000",
                        "longitude": "-75.47548000"
                    },
                    {
                        "id": 113899,
                        "name": "Chester Springs",
                        "latitude": "40.09510000",
                        "longitude": "-75.61687000"
                    },
                    {
                        "id": 113900,
                        "name": "Chesterbrook",
                        "latitude": "40.07566000",
                        "longitude": "-75.45908000"
                    },
                    {
                        "id": 113913,
                        "name": "Cheswick",
                        "latitude": "40.54173000",
                        "longitude": "-79.79922000"
                    },
                    {
                        "id": 113922,
                        "name": "Chevy Chase Heights",
                        "latitude": "40.63673000",
                        "longitude": "-79.14420000"
                    },
                    {
                        "id": 113946,
                        "name": "Chicora",
                        "latitude": "40.94812000",
                        "longitude": "-79.74283000"
                    },
                    {
                        "id": 113965,
                        "name": "Chinchilla",
                        "latitude": "41.47508000",
                        "longitude": "-75.67713000"
                    },
                    {
                        "id": 113999,
                        "name": "Christiana",
                        "latitude": "39.95483000",
                        "longitude": "-75.99689000"
                    },
                    {
                        "id": 114008,
                        "name": "Church Hill",
                        "latitude": "40.68201000",
                        "longitude": "-77.59861000"
                    },
                    {
                        "id": 114011,
                        "name": "Churchill",
                        "latitude": "40.43840000",
                        "longitude": "-79.84310000"
                    },
                    {
                        "id": 114014,
                        "name": "Churchville",
                        "latitude": "40.18622000",
                        "longitude": "-75.01878000"
                    },
                    {
                        "id": 114096,
                        "name": "Clairton",
                        "latitude": "40.29229000",
                        "longitude": "-79.88171000"
                    },
                    {
                        "id": 114117,
                        "name": "Clarion",
                        "latitude": "41.21479000",
                        "longitude": "-79.38532000"
                    },
                    {
                        "id": 114118,
                        "name": "Clarion County",
                        "latitude": "41.19239000",
                        "longitude": "-79.42096000"
                    },
                    {
                        "id": 114141,
                        "name": "Clarks Green",
                        "latitude": "41.49286000",
                        "longitude": "-75.69964000"
                    },
                    {
                        "id": 114142,
                        "name": "Clarks Summit",
                        "latitude": "41.48869000",
                        "longitude": "-75.70852000"
                    },
                    {
                        "id": 114168,
                        "name": "Clay",
                        "latitude": "40.21843000",
                        "longitude": "-76.25551000"
                    },
                    {
                        "id": 114195,
                        "name": "Claysburg",
                        "latitude": "40.29674000",
                        "longitude": "-78.44974000"
                    },
                    {
                        "id": 114216,
                        "name": "Clearfield",
                        "latitude": "41.02728000",
                        "longitude": "-78.43919000"
                    },
                    {
                        "id": 114218,
                        "name": "Clearfield County",
                        "latitude": "41.00019000",
                        "longitude": "-78.47411000"
                    },
                    {
                        "id": 114236,
                        "name": "Cleona",
                        "latitude": "40.33731000",
                        "longitude": "-76.47552000"
                    },
                    {
                        "id": 114263,
                        "name": "Clifton Heights",
                        "latitude": "39.92928000",
                        "longitude": "-75.29630000"
                    },
                    {
                        "id": 114296,
                        "name": "Clinton County",
                        "latitude": "41.23405000",
                        "longitude": "-77.63811000"
                    },
                    {
                        "id": 114323,
                        "name": "Clymer",
                        "latitude": "40.66812000",
                        "longitude": "-79.01170000"
                    },
                    {
                        "id": 114334,
                        "name": "Coaldale",
                        "latitude": "40.82287000",
                        "longitude": "-75.90687000"
                    },
                    {
                        "id": 114341,
                        "name": "Coatesville",
                        "latitude": "39.98316000",
                        "longitude": "-75.82384000"
                    },
                    {
                        "id": 114353,
                        "name": "Cochranton",
                        "latitude": "41.52005000",
                        "longitude": "-80.04839000"
                    },
                    {
                        "id": 114420,
                        "name": "Collegeville",
                        "latitude": "40.18566000",
                        "longitude": "-75.45157000"
                    },
                    {
                        "id": 114427,
                        "name": "Collingdale",
                        "latitude": "39.91178000",
                        "longitude": "-75.27713000"
                    },
                    {
                        "id": 114432,
                        "name": "Collinsburg",
                        "latitude": "40.22424000",
                        "longitude": "-79.76838000"
                    },
                    {
                        "id": 114450,
                        "name": "Colonial Park",
                        "latitude": "40.30064000",
                        "longitude": "-76.80969000"
                    },
                    {
                        "id": 114453,
                        "name": "Colony Park",
                        "latitude": "40.34683000",
                        "longitude": "-75.98240000"
                    },
                    {
                        "id": 114473,
                        "name": "Columbia",
                        "latitude": "40.03371000",
                        "longitude": "-76.50441000"
                    },
                    {
                        "id": 114481,
                        "name": "Columbia County",
                        "latitude": "41.04865000",
                        "longitude": "-76.40515000"
                    },
                    {
                        "id": 114508,
                        "name": "Colwyn",
                        "latitude": "39.91234000",
                        "longitude": "-75.25379000"
                    },
                    {
                        "id": 114532,
                        "name": "Conashaugh Lakes",
                        "latitude": "41.30593000",
                        "longitude": "-74.98962000"
                    },
                    {
                        "id": 114554,
                        "name": "Conemaugh",
                        "latitude": "40.32674000",
                        "longitude": "-78.90808000"
                    },
                    {
                        "id": 114555,
                        "name": "Conestoga",
                        "latitude": "39.94066000",
                        "longitude": "-76.34635000"
                    },
                    {
                        "id": 114560,
                        "name": "Conneaut Lakeshore",
                        "latitude": "41.62711000",
                        "longitude": "-80.31008000"
                    },
                    {
                        "id": 114562,
                        "name": "Connellsville",
                        "latitude": "40.01785000",
                        "longitude": "-79.58948000"
                    },
                    {
                        "id": 114571,
                        "name": "Conshohocken",
                        "latitude": "40.07928000",
                        "longitude": "-75.30157000"
                    },
                    {
                        "id": 114586,
                        "name": "Conway",
                        "latitude": "40.65979000",
                        "longitude": "-80.23923000"
                    },
                    {
                        "id": 114590,
                        "name": "Conyngham",
                        "latitude": "40.99203000",
                        "longitude": "-76.05659000"
                    },
                    {
                        "id": 114604,
                        "name": "Coopersburg",
                        "latitude": "40.51149000",
                        "longitude": "-75.39046000"
                    },
                    {
                        "id": 114618,
                        "name": "Coplay",
                        "latitude": "40.67010000",
                        "longitude": "-75.49546000"
                    },
                    {
                        "id": 114630,
                        "name": "Coraopolis",
                        "latitude": "40.51840000",
                        "longitude": "-80.16672000"
                    },
                    {
                        "id": 114659,
                        "name": "Cornwall",
                        "latitude": "40.27370000",
                        "longitude": "-76.40607000"
                    },
                    {
                        "id": 114660,
                        "name": "Cornwells Heights",
                        "latitude": "40.07678000",
                        "longitude": "-74.94878000"
                    },
                    {
                        "id": 114669,
                        "name": "Corry",
                        "latitude": "41.92033000",
                        "longitude": "-79.64033000"
                    },
                    {
                        "id": 114709,
                        "name": "Coudersport",
                        "latitude": "41.77479000",
                        "longitude": "-78.02056000"
                    },
                    {
                        "id": 114754,
                        "name": "Crafton",
                        "latitude": "40.43507000",
                        "longitude": "-80.06617000"
                    },
                    {
                        "id": 114763,
                        "name": "Cranberry Township",
                        "latitude": "40.68496000",
                        "longitude": "-80.10714000"
                    },
                    {
                        "id": 114782,
                        "name": "Crawford County",
                        "latitude": "41.68470000",
                        "longitude": "-80.10628000"
                    },
                    {
                        "id": 114800,
                        "name": "Cresson",
                        "latitude": "40.45979000",
                        "longitude": "-78.59168000"
                    },
                    {
                        "id": 114801,
                        "name": "Cressona",
                        "latitude": "40.62676000",
                        "longitude": "-76.19272000"
                    },
                    {
                        "id": 114870,
                        "name": "Croydon",
                        "latitude": "40.08733000",
                        "longitude": "-74.90350000"
                    },
                    {
                        "id": 114919,
                        "name": "Cumberland County",
                        "latitude": "40.16363000",
                        "longitude": "-77.26555000"
                    },
                    {
                        "id": 114929,
                        "name": "Curtisville",
                        "latitude": "40.64229000",
                        "longitude": "-79.85089000"
                    },
                    {
                        "id": 114930,
                        "name": "Curwensville",
                        "latitude": "40.97561000",
                        "longitude": "-78.52502000"
                    },
                    {
                        "id": 114991,
                        "name": "Dallas",
                        "latitude": "41.33619000",
                        "longitude": "-75.96325000"
                    },
                    {
                        "id": 114999,
                        "name": "Dallastown",
                        "latitude": "39.89954000",
                        "longitude": "-76.64025000"
                    },
                    {
                        "id": 115003,
                        "name": "Dalton",
                        "latitude": "41.53424000",
                        "longitude": "-75.73603000"
                    },
                    {
                        "id": 115037,
                        "name": "Danville",
                        "latitude": "40.96342000",
                        "longitude": "-76.61273000"
                    },
                    {
                        "id": 115041,
                        "name": "Darby",
                        "latitude": "39.91845000",
                        "longitude": "-75.25907000"
                    },
                    {
                        "id": 115056,
                        "name": "Dauphin County",
                        "latitude": "40.41544000",
                        "longitude": "-76.77947000"
                    },
                    {
                        "id": 115066,
                        "name": "Davidsville",
                        "latitude": "40.22702000",
                        "longitude": "-78.93641000"
                    },
                    {
                        "id": 115208,
                        "name": "Delaware County",
                        "latitude": "39.91681000",
                        "longitude": "-75.39890000"
                    },
                    {
                        "id": 115219,
                        "name": "Delmont",
                        "latitude": "40.41312000",
                        "longitude": "-79.57032000"
                    },
                    {
                        "id": 115252,
                        "name": "Denver",
                        "latitude": "40.23315000",
                        "longitude": "-76.13717000"
                    },
                    {
                        "id": 115266,
                        "name": "Derry",
                        "latitude": "40.33396000",
                        "longitude": "-79.29976000"
                    },
                    {
                        "id": 115300,
                        "name": "Devon",
                        "latitude": "40.04928000",
                        "longitude": "-75.42908000"
                    },
                    {
                        "id": 115301,
                        "name": "Dewart",
                        "latitude": "41.10925000",
                        "longitude": "-76.87663000"
                    },
                    {
                        "id": 115332,
                        "name": "Dickson City",
                        "latitude": "41.47147000",
                        "longitude": "-75.60769000"
                    },
                    {
                        "id": 115346,
                        "name": "Dillsburg",
                        "latitude": "40.11093000",
                        "longitude": "-77.03498000"
                    },
                    {
                        "id": 115401,
                        "name": "Donora",
                        "latitude": "40.17340000",
                        "longitude": "-79.85755000"
                    },
                    {
                        "id": 115412,
                        "name": "Dormont",
                        "latitude": "40.39590000",
                        "longitude": "-80.03311000"
                    },
                    {
                        "id": 115413,
                        "name": "Dorneyville",
                        "latitude": "40.57510000",
                        "longitude": "-75.51963000"
                    },
                    {
                        "id": 115451,
                        "name": "Dover",
                        "latitude": "40.00176000",
                        "longitude": "-76.85025000"
                    },
                    {
                        "id": 115462,
                        "name": "Downingtown",
                        "latitude": "40.00650000",
                        "longitude": "-75.70327000"
                    },
                    {
                        "id": 115463,
                        "name": "Doylestown",
                        "latitude": "40.31011000",
                        "longitude": "-75.12989000"
                    },
                    {
                        "id": 115470,
                        "name": "Dravosburg",
                        "latitude": "40.35063000",
                        "longitude": "-79.88616000"
                    },
                    {
                        "id": 115472,
                        "name": "Dresher",
                        "latitude": "40.14094000",
                        "longitude": "-75.16684000"
                    },
                    {
                        "id": 115477,
                        "name": "Drexel Hill",
                        "latitude": "39.94706000",
                        "longitude": "-75.29213000"
                    },
                    {
                        "id": 115495,
                        "name": "Dublin",
                        "latitude": "40.37177000",
                        "longitude": "-75.20156000"
                    },
                    {
                        "id": 115487,
                        "name": "DuBois",
                        "latitude": "41.11923000",
                        "longitude": "-78.76003000"
                    },
                    {
                        "id": 115499,
                        "name": "Duboistown",
                        "latitude": "41.22258000",
                        "longitude": "-77.03691000"
                    },
                    {
                        "id": 115519,
                        "name": "Dunbar",
                        "latitude": "39.97785000",
                        "longitude": "-79.61448000"
                    },
                    {
                        "id": 115523,
                        "name": "Duncannon",
                        "latitude": "40.39814000",
                        "longitude": "-77.02303000"
                    },
                    {
                        "id": 115524,
                        "name": "Duncansville",
                        "latitude": "40.42341000",
                        "longitude": "-78.43390000"
                    },
                    {
                        "id": 115545,
                        "name": "Dunmore",
                        "latitude": "41.41980000",
                        "longitude": "-75.63241000"
                    },
                    {
                        "id": 115552,
                        "name": "Dunnstown",
                        "latitude": "41.14590000",
                        "longitude": "-77.42137000"
                    },
                    {
                        "id": 115558,
                        "name": "Dupont",
                        "latitude": "41.32508000",
                        "longitude": "-75.74547000"
                    },
                    {
                        "id": 115561,
                        "name": "Duquesne",
                        "latitude": "40.38146000",
                        "longitude": "-79.85977000"
                    },
                    {
                        "id": 115576,
                        "name": "Duryea",
                        "latitude": "41.34397000",
                        "longitude": "-75.73853000"
                    },
                    {
                        "id": 115614,
                        "name": "Eagleview",
                        "latitude": "40.05938000",
                        "longitude": "-75.68076000"
                    },
                    {
                        "id": 115615,
                        "name": "Eagleville",
                        "latitude": "40.15955000",
                        "longitude": "-75.40824000"
                    },
                    {
                        "id": 115620,
                        "name": "Earlston",
                        "latitude": "40.00619000",
                        "longitude": "-78.37001000"
                    },
                    {
                        "id": 115629,
                        "name": "East Bangor",
                        "latitude": "40.87954000",
                        "longitude": "-75.18379000"
                    },
                    {
                        "id": 115631,
                        "name": "East Berlin",
                        "latitude": "39.93760000",
                        "longitude": "-76.97859000"
                    },
                    {
                        "id": 115633,
                        "name": "East Berwick",
                        "latitude": "41.06203000",
                        "longitude": "-76.22243000"
                    },
                    {
                        "id": 115648,
                        "name": "East Conemaugh",
                        "latitude": "40.34868000",
                        "longitude": "-78.88364000"
                    },
                    {
                        "id": 115654,
                        "name": "East Earl",
                        "latitude": "40.11010000",
                        "longitude": "-76.03272000"
                    },
                    {
                        "id": 115673,
                        "name": "East Greenville",
                        "latitude": "40.40649000",
                        "longitude": "-75.50185000"
                    },
                    {
                        "id": 115702,
                        "name": "East Lansdowne",
                        "latitude": "39.94567000",
                        "longitude": "-75.26129000"
                    },
                    {
                        "id": 115709,
                        "name": "East McKeesport",
                        "latitude": "40.38312000",
                        "longitude": "-79.80644000"
                    },
                    {
                        "id": 115735,
                        "name": "East Petersburg",
                        "latitude": "40.10010000",
                        "longitude": "-76.35413000"
                    },
                    {
                        "id": 115736,
                        "name": "East Pittsburgh",
                        "latitude": "40.39562000",
                        "longitude": "-79.83866000"
                    },
                    {
                        "id": 115761,
                        "name": "East Stroudsburg",
                        "latitude": "40.99954000",
                        "longitude": "-75.18129000"
                    },
                    {
                        "id": 115767,
                        "name": "East Uniontown",
                        "latitude": "39.89980000",
                        "longitude": "-79.69782000"
                    },
                    {
                        "id": 115770,
                        "name": "East Washington",
                        "latitude": "40.17368000",
                        "longitude": "-80.23756000"
                    },
                    {
                        "id": 115775,
                        "name": "East York",
                        "latitude": "39.97371000",
                        "longitude": "-76.68636000"
                    },
                    {
                        "id": 115782,
                        "name": "Eastlawn Gardens",
                        "latitude": "40.75065000",
                        "longitude": "-75.29573000"
                    },
                    {
                        "id": 115789,
                        "name": "Easton",
                        "latitude": "40.68843000",
                        "longitude": "-75.22073000"
                    },
                    {
                        "id": 115812,
                        "name": "Ebensburg",
                        "latitude": "40.48507000",
                        "longitude": "-78.72474000"
                    },
                    {
                        "id": 115817,
                        "name": "Economy",
                        "latitude": "40.60007000",
                        "longitude": "-80.22478000"
                    },
                    {
                        "id": 115822,
                        "name": "Eddington",
                        "latitude": "40.08456000",
                        "longitude": "-74.94489000"
                    },
                    {
                        "id": 115825,
                        "name": "Eddystone",
                        "latitude": "39.86011000",
                        "longitude": "-75.34436000"
                    },
                    {
                        "id": 115862,
                        "name": "Edgewood",
                        "latitude": "40.43201000",
                        "longitude": "-79.88144000"
                    },
                    {
                        "id": 115865,
                        "name": "Edgeworth",
                        "latitude": "40.55118000",
                        "longitude": "-80.19284000"
                    },
                    {
                        "id": 115868,
                        "name": "Edinboro",
                        "latitude": "41.87422000",
                        "longitude": "-80.13172000"
                    },
                    {
                        "id": 115895,
                        "name": "Edwardsville",
                        "latitude": "41.26953000",
                        "longitude": "-75.91631000"
                    },
                    {
                        "id": 115900,
                        "name": "Effort",
                        "latitude": "40.93926000",
                        "longitude": "-75.43491000"
                    },
                    {
                        "id": 115905,
                        "name": "Egypt",
                        "latitude": "40.68010000",
                        "longitude": "-75.52991000"
                    },
                    {
                        "id": 115969,
                        "name": "Elim",
                        "latitude": "40.29785000",
                        "longitude": "-78.94253000"
                    },
                    {
                        "id": 115973,
                        "name": "Elizabeth",
                        "latitude": "40.26924000",
                        "longitude": "-79.88977000"
                    },
                    {
                        "id": 115981,
                        "name": "Elizabethtown",
                        "latitude": "40.15287000",
                        "longitude": "-76.60275000"
                    },
                    {
                        "id": 115982,
                        "name": "Elizabethville",
                        "latitude": "40.54897000",
                        "longitude": "-76.81192000"
                    },
                    {
                        "id": 115985,
                        "name": "Elk County",
                        "latitude": "41.42523000",
                        "longitude": "-78.64909000"
                    },
                    {
                        "id": 116007,
                        "name": "Elkland",
                        "latitude": "41.98618000",
                        "longitude": "-77.31081000"
                    },
                    {
                        "id": 116036,
                        "name": "Ellport",
                        "latitude": "40.86395000",
                        "longitude": "-80.25895000"
                    },
                    {
                        "id": 116041,
                        "name": "Ellwood City",
                        "latitude": "40.86173000",
                        "longitude": "-80.28645000"
                    },
                    {
                        "id": 116074,
                        "name": "Elverson",
                        "latitude": "40.15676000",
                        "longitude": "-75.83271000"
                    },
                    {
                        "id": 116087,
                        "name": "Elysburg",
                        "latitude": "40.86453000",
                        "longitude": "-76.55246000"
                    },
                    {
                        "id": 116091,
                        "name": "Emerald Lakes",
                        "latitude": "41.08842000",
                        "longitude": "-75.41963000"
                    },
                    {
                        "id": 116098,
                        "name": "Emigsville",
                        "latitude": "40.02176000",
                        "longitude": "-76.72802000"
                    },
                    {
                        "id": 116101,
                        "name": "Emmaus",
                        "latitude": "40.53954000",
                        "longitude": "-75.49685000"
                    },
                    {
                        "id": 116113,
                        "name": "Emporium",
                        "latitude": "41.51145000",
                        "longitude": "-78.23529000"
                    },
                    {
                        "id": 116114,
                        "name": "Emsworth",
                        "latitude": "40.51007000",
                        "longitude": "-80.09450000"
                    },
                    {
                        "id": 116137,
                        "name": "Enhaut",
                        "latitude": "40.23176000",
                        "longitude": "-76.82692000"
                    },
                    {
                        "id": 116140,
                        "name": "Enlow",
                        "latitude": "40.45423000",
                        "longitude": "-80.23311000"
                    },
                    {
                        "id": 116144,
                        "name": "Enola",
                        "latitude": "40.29009000",
                        "longitude": "-76.93386000"
                    },
                    {
                        "id": 116155,
                        "name": "Ephrata",
                        "latitude": "40.17982000",
                        "longitude": "-76.17884000"
                    },
                    {
                        "id": 116166,
                        "name": "Erie",
                        "latitude": "42.12922000",
                        "longitude": "-80.08506000"
                    },
                    {
                        "id": 116169,
                        "name": "Erie County",
                        "latitude": "42.11748000",
                        "longitude": "-80.09811000"
                    },
                    {
                        "id": 116190,
                        "name": "Espy",
                        "latitude": "41.00620000",
                        "longitude": "-76.40994000"
                    },
                    {
                        "id": 116216,
                        "name": "Etna",
                        "latitude": "40.50424000",
                        "longitude": "-79.94894000"
                    },
                    {
                        "id": 116247,
                        "name": "Evans City",
                        "latitude": "40.76923000",
                        "longitude": "-80.06284000"
                    },
                    {
                        "id": 116249,
                        "name": "Evansburg",
                        "latitude": "40.18094000",
                        "longitude": "-75.42907000"
                    },
                    {
                        "id": 116259,
                        "name": "Everett",
                        "latitude": "40.01147000",
                        "longitude": "-78.37335000"
                    },
                    {
                        "id": 116272,
                        "name": "Exeter",
                        "latitude": "41.32064000",
                        "longitude": "-75.81908000"
                    },
                    {
                        "id": 116277,
                        "name": "Exton",
                        "latitude": "40.02900000",
                        "longitude": "-75.62077000"
                    },
                    {
                        "id": 116280,
                        "name": "Factoryville",
                        "latitude": "41.56313000",
                        "longitude": "-75.78269000"
                    },
                    {
                        "id": 116296,
                        "name": "Fairchance",
                        "latitude": "39.82480000",
                        "longitude": "-79.75449000"
                    },
                    {
                        "id": 116300,
                        "name": "Fairdale",
                        "latitude": "39.88702000",
                        "longitude": "-79.96811000"
                    },
                    {
                        "id": 116327,
                        "name": "Fairhope",
                        "latitude": "40.11368000",
                        "longitude": "-79.83977000"
                    },
                    {
                        "id": 116332,
                        "name": "Fairless Hills",
                        "latitude": "40.17955000",
                        "longitude": "-74.85516000"
                    },
                    {
                        "id": 116354,
                        "name": "Fairview",
                        "latitude": "42.03145000",
                        "longitude": "-80.25534000"
                    },
                    {
                        "id": 116361,
                        "name": "Fairview-Ferndale",
                        "latitude": "40.78037000",
                        "longitude": "-76.57528000"
                    },
                    {
                        "id": 116383,
                        "name": "Falls Creek",
                        "latitude": "41.14506000",
                        "longitude": "-78.80447000"
                    },
                    {
                        "id": 116430,
                        "name": "Farrell",
                        "latitude": "41.21228000",
                        "longitude": "-80.49674000"
                    },
                    {
                        "id": 116437,
                        "name": "Faxon",
                        "latitude": "41.24841000",
                        "longitude": "-76.97719000"
                    },
                    {
                        "id": 116452,
                        "name": "Fayette County",
                        "latitude": "39.91990000",
                        "longitude": "-79.64737000"
                    },
                    {
                        "id": 116458,
                        "name": "Fayetteville",
                        "latitude": "39.91120000",
                        "longitude": "-77.54999000"
                    },
                    {
                        "id": 116462,
                        "name": "Feasterville",
                        "latitude": "40.14400000",
                        "longitude": "-75.00517000"
                    },
                    {
                        "id": 116468,
                        "name": "Fellsburg",
                        "latitude": "40.18313000",
                        "longitude": "-79.82421000"
                    },
                    {
                        "id": 116488,
                        "name": "Ferndale",
                        "latitude": "40.28896000",
                        "longitude": "-78.91475000"
                    },
                    {
                        "id": 116492,
                        "name": "Fernway",
                        "latitude": "40.69479000",
                        "longitude": "-80.13089000"
                    },
                    {
                        "id": 116541,
                        "name": "Fivepointville",
                        "latitude": "40.18287000",
                        "longitude": "-76.05106000"
                    },
                    {
                        "id": 116558,
                        "name": "Fleetwood",
                        "latitude": "40.45398000",
                        "longitude": "-75.81798000"
                    },
                    {
                        "id": 116563,
                        "name": "Flemington",
                        "latitude": "41.12646000",
                        "longitude": "-77.47165000"
                    },
                    {
                        "id": 116599,
                        "name": "Flourtown",
                        "latitude": "40.10344000",
                        "longitude": "-75.21240000"
                    },
                    {
                        "id": 116615,
                        "name": "Flying Hills",
                        "latitude": "40.27676000",
                        "longitude": "-75.91410000"
                    },
                    {
                        "id": 116618,
                        "name": "Folcroft",
                        "latitude": "39.89095000",
                        "longitude": "-75.28380000"
                    },
                    {
                        "id": 116625,
                        "name": "Folsom",
                        "latitude": "39.88983000",
                        "longitude": "-75.32519000"
                    },
                    {
                        "id": 116634,
                        "name": "Ford City",
                        "latitude": "40.77229000",
                        "longitude": "-79.52977000"
                    },
                    {
                        "id": 116649,
                        "name": "Forest City",
                        "latitude": "41.65147000",
                        "longitude": "-75.46657000"
                    },
                    {
                        "id": 116650,
                        "name": "Forest County",
                        "latitude": "41.51307000",
                        "longitude": "-79.23601000"
                    },
                    {
                        "id": 116659,
                        "name": "Forest Hills",
                        "latitude": "40.41979000",
                        "longitude": "-79.85005000"
                    },
                    {
                        "id": 116762,
                        "name": "Fort Washington",
                        "latitude": "40.14178000",
                        "longitude": "-75.20906000"
                    },
                    {
                        "id": 116770,
                        "name": "Forty Fort",
                        "latitude": "41.27897000",
                        "longitude": "-75.87825000"
                    },
                    {
                        "id": 116775,
                        "name": "Foster Brook",
                        "latitude": "41.97506000",
                        "longitude": "-78.61725000"
                    },
                    {
                        "id": 116781,
                        "name": "Fountain Hill",
                        "latitude": "40.60149000",
                        "longitude": "-75.39518000"
                    },
                    {
                        "id": 116799,
                        "name": "Fox Chapel",
                        "latitude": "40.51340000",
                        "longitude": "-79.87977000"
                    },
                    {
                        "id": 116800,
                        "name": "Fox Chase",
                        "latitude": "40.39557000",
                        "longitude": "-75.96216000"
                    },
                    {
                        "id": 116808,
                        "name": "Fox Run",
                        "latitude": "40.70229000",
                        "longitude": "-80.08284000"
                    },
                    {
                        "id": 116810,
                        "name": "Frackville",
                        "latitude": "40.78398000",
                        "longitude": "-76.23022000"
                    },
                    {
                        "id": 116840,
                        "name": "Franklin",
                        "latitude": "41.39784000",
                        "longitude": "-79.83144000"
                    },
                    {
                        "id": 116862,
                        "name": "Franklin County",
                        "latitude": "39.92742000",
                        "longitude": "-77.72127000"
                    },
                    {
                        "id": 116870,
                        "name": "Franklin Park",
                        "latitude": "40.58340000",
                        "longitude": "-80.08784000"
                    },
                    {
                        "id": 116892,
                        "name": "Fredericksburg",
                        "latitude": "40.44370000",
                        "longitude": "-76.42829000"
                    },
                    {
                        "id": 116902,
                        "name": "Freedom",
                        "latitude": "40.68562000",
                        "longitude": "-80.25173000"
                    },
                    {
                        "id": 116906,
                        "name": "Freeland",
                        "latitude": "41.01675000",
                        "longitude": "-75.89714000"
                    },
                    {
                        "id": 116909,
                        "name": "Freemansburg",
                        "latitude": "40.62649000",
                        "longitude": "-75.34574000"
                    },
                    {
                        "id": 116915,
                        "name": "Freeport",
                        "latitude": "40.67395000",
                        "longitude": "-79.68477000"
                    },
                    {
                        "id": 116945,
                        "name": "Friedens",
                        "latitude": "40.05008000",
                        "longitude": "-78.99836000"
                    },
                    {
                        "id": 153782,
                        "name": "Friedensburg",
                        "latitude": "40.60711070",
                        "longitude": "-76.25163920"
                    },
                    {
                        "id": 116982,
                        "name": "Fullerton",
                        "latitude": "40.63176000",
                        "longitude": "-75.47324000"
                    },
                    {
                        "id": 116998,
                        "name": "Fulton County",
                        "latitude": "39.92534000",
                        "longitude": "-78.11268000"
                    },
                    {
                        "id": 117030,
                        "name": "Galeton",
                        "latitude": "41.73312000",
                        "longitude": "-77.64193000"
                    },
                    {
                        "id": 117038,
                        "name": "Gallitzin",
                        "latitude": "40.48229000",
                        "longitude": "-78.55168000"
                    },
                    {
                        "id": 117052,
                        "name": "Gap",
                        "latitude": "39.98732000",
                        "longitude": "-76.02051000"
                    },
                    {
                        "id": 117068,
                        "name": "Garden View",
                        "latitude": "41.25424000",
                        "longitude": "-77.04608000"
                    },
                    {
                        "id": 117117,
                        "name": "Gastonville",
                        "latitude": "40.25729000",
                        "longitude": "-79.99588000"
                    },
                    {
                        "id": 117132,
                        "name": "Geistown",
                        "latitude": "40.29091000",
                        "longitude": "-78.86891000"
                    },
                    {
                        "id": 117158,
                        "name": "Georgetown",
                        "latitude": "39.93760000",
                        "longitude": "-76.08329000"
                    },
                    {
                        "id": 117179,
                        "name": "Gettysburg",
                        "latitude": "39.83093000",
                        "longitude": "-77.23110000"
                    },
                    {
                        "id": 117192,
                        "name": "Gibsonia",
                        "latitude": "40.63007000",
                        "longitude": "-79.96950000"
                    },
                    {
                        "id": 117207,
                        "name": "Gilbertsville",
                        "latitude": "40.32010000",
                        "longitude": "-75.61018000"
                    },
                    {
                        "id": 117228,
                        "name": "Girard",
                        "latitude": "42.00033000",
                        "longitude": "-80.31812000"
                    },
                    {
                        "id": 117229,
                        "name": "Girardville",
                        "latitude": "40.79148000",
                        "longitude": "-76.28356000"
                    },
                    {
                        "id": 117254,
                        "name": "Glassport",
                        "latitude": "40.32479000",
                        "longitude": "-79.89227000"
                    },
                    {
                        "id": 117268,
                        "name": "Glen Lyon",
                        "latitude": "41.17508000",
                        "longitude": "-76.07465000"
                    },
                    {
                        "id": 117272,
                        "name": "Glen Rock",
                        "latitude": "39.79316000",
                        "longitude": "-76.73025000"
                    },
                    {
                        "id": 117301,
                        "name": "Glenolden",
                        "latitude": "39.90011000",
                        "longitude": "-75.28907000"
                    },
                    {
                        "id": 117306,
                        "name": "Glenshaw",
                        "latitude": "40.53285000",
                        "longitude": "-79.96755000"
                    },
                    {
                        "id": 117307,
                        "name": "Glenside",
                        "latitude": "40.10233000",
                        "longitude": "-75.15212000"
                    },
                    {
                        "id": 117344,
                        "name": "Gold Key Lake",
                        "latitude": "41.30593000",
                        "longitude": "-74.93850000"
                    },
                    {
                        "id": 117526,
                        "name": "Grantley",
                        "latitude": "39.94038000",
                        "longitude": "-76.72913000"
                    },
                    {
                        "id": 117608,
                        "name": "Green Tree",
                        "latitude": "40.41174000",
                        "longitude": "-80.04561000"
                    },
                    {
                        "id": 117625,
                        "name": "Greencastle",
                        "latitude": "39.79037000",
                        "longitude": "-77.72777000"
                    },
                    {
                        "id": 117643,
                        "name": "Greene County",
                        "latitude": "39.85380000",
                        "longitude": "-80.22287000"
                    },
                    {
                        "id": 117655,
                        "name": "Greenfields",
                        "latitude": "40.35990000",
                        "longitude": "-75.95199000"
                    },
                    {
                        "id": 117660,
                        "name": "Greenock",
                        "latitude": "40.31229000",
                        "longitude": "-79.80671000"
                    },
                    {
                        "id": 117672,
                        "name": "Greensburg",
                        "latitude": "40.30146000",
                        "longitude": "-79.53893000"
                    },
                    {
                        "id": 117694,
                        "name": "Greenville",
                        "latitude": "41.40450000",
                        "longitude": "-80.39118000"
                    },
                    {
                        "id": 117707,
                        "name": "Greenwood",
                        "latitude": "40.53590000",
                        "longitude": "-78.35751000"
                    },
                    {
                        "id": 117736,
                        "name": "Grill",
                        "latitude": "40.29870000",
                        "longitude": "-75.94049000"
                    },
                    {
                        "id": 117756,
                        "name": "Grove City",
                        "latitude": "41.15784000",
                        "longitude": "-80.08867000"
                    },
                    {
                        "id": 117785,
                        "name": "Guilford",
                        "latitude": "39.91541000",
                        "longitude": "-77.60105000"
                    },
                    {
                        "id": 117788,
                        "name": "Guilford Siding",
                        "latitude": "39.86537000",
                        "longitude": "-77.61249000"
                    },
                    {
                        "id": 117858,
                        "name": "Halfway House",
                        "latitude": "40.28204000",
                        "longitude": "-75.64324000"
                    },
                    {
                        "id": 117868,
                        "name": "Hallam",
                        "latitude": "40.00482000",
                        "longitude": "-76.60413000"
                    },
                    {
                        "id": 117874,
                        "name": "Hallstead",
                        "latitude": "41.96119000",
                        "longitude": "-75.74324000"
                    },
                    {
                        "id": 117885,
                        "name": "Hamburg",
                        "latitude": "40.55565000",
                        "longitude": "-75.98188000"
                    },
                    {
                        "id": 117968,
                        "name": "Hanover",
                        "latitude": "39.80066000",
                        "longitude": "-76.98304000"
                    },
                    {
                        "id": 118020,
                        "name": "Harleigh",
                        "latitude": "40.98064000",
                        "longitude": "-75.97131000"
                    },
                    {
                        "id": 118025,
                        "name": "Harleysville",
                        "latitude": "40.27955000",
                        "longitude": "-75.38712000"
                    },
                    {
                        "id": 118050,
                        "name": "Harrisburg",
                        "latitude": "40.27370000",
                        "longitude": "-76.88442000"
                    },
                    {
                        "id": 118116,
                        "name": "Harveys Lake",
                        "latitude": "41.38341000",
                        "longitude": "-76.02465000"
                    },
                    {
                        "id": 118130,
                        "name": "Hasson Heights",
                        "latitude": "41.44895000",
                        "longitude": "-79.67700000"
                    },
                    {
                        "id": 118134,
                        "name": "Hastings",
                        "latitude": "40.66507000",
                        "longitude": "-78.71225000"
                    },
                    {
                        "id": 118136,
                        "name": "Hatboro",
                        "latitude": "40.17428000",
                        "longitude": "-75.10684000"
                    },
                    {
                        "id": 118139,
                        "name": "Hatfield",
                        "latitude": "40.27983000",
                        "longitude": "-75.29934000"
                    },
                    {
                        "id": 118169,
                        "name": "Hawley",
                        "latitude": "41.47592000",
                        "longitude": "-75.18212000"
                    },
                    {
                        "id": 118213,
                        "name": "Hazleton",
                        "latitude": "40.95842000",
                        "longitude": "-75.97465000"
                    },
                    {
                        "id": 118239,
                        "name": "Hebron",
                        "latitude": "40.33898000",
                        "longitude": "-76.39940000"
                    },
                    {
                        "id": 118245,
                        "name": "Heidelberg",
                        "latitude": "40.39229000",
                        "longitude": "-80.09089000"
                    },
                    {
                        "id": 118259,
                        "name": "Hellertown",
                        "latitude": "40.57954000",
                        "longitude": "-75.34073000"
                    },
                    {
                        "id": 118266,
                        "name": "Hemlock Farms",
                        "latitude": "41.32676000",
                        "longitude": "-75.03656000"
                    },
                    {
                        "id": 118329,
                        "name": "Hermitage",
                        "latitude": "41.23339000",
                        "longitude": "-80.44868000"
                    },
                    {
                        "id": 118341,
                        "name": "Hershey",
                        "latitude": "40.28592000",
                        "longitude": "-76.65025000"
                    },
                    {
                        "id": 118414,
                        "name": "Highland Park",
                        "latitude": "40.62091000",
                        "longitude": "-77.56805000"
                    },
                    {
                        "id": 118423,
                        "name": "Highspire",
                        "latitude": "40.21092000",
                        "longitude": "-76.79108000"
                    },
                    {
                        "id": 118442,
                        "name": "Hilldale",
                        "latitude": "41.28925000",
                        "longitude": "-75.83631000"
                    },
                    {
                        "id": 118443,
                        "name": "Hiller",
                        "latitude": "40.01035000",
                        "longitude": "-79.90088000"
                    },
                    {
                        "id": 118515,
                        "name": "Hokendauqua",
                        "latitude": "40.66204000",
                        "longitude": "-75.49102000"
                    },
                    {
                        "id": 118545,
                        "name": "Hollidaysburg",
                        "latitude": "40.42729000",
                        "longitude": "-78.38890000"
                    },
                    {
                        "id": 118588,
                        "name": "Homeacre-Lyndora",
                        "latitude": "40.87206000",
                        "longitude": "-79.92060000"
                    },
                    {
                        "id": 118598,
                        "name": "Homer City",
                        "latitude": "40.54340000",
                        "longitude": "-79.16226000"
                    },
                    {
                        "id": 118602,
                        "name": "Homestead",
                        "latitude": "40.40590000",
                        "longitude": "-79.91199000"
                    },
                    {
                        "id": 118606,
                        "name": "Hometown",
                        "latitude": "40.82370000",
                        "longitude": "-75.98020000"
                    },
                    {
                        "id": 118618,
                        "name": "Honesdale",
                        "latitude": "41.57676000",
                        "longitude": "-75.25879000"
                    },
                    {
                        "id": 118619,
                        "name": "Honey Brook",
                        "latitude": "40.09427000",
                        "longitude": "-75.91133000"
                    },
                    {
                        "id": 118659,
                        "name": "Hopwood",
                        "latitude": "39.87702000",
                        "longitude": "-79.70199000"
                    },
                    {
                        "id": 118677,
                        "name": "Horsham",
                        "latitude": "40.17844000",
                        "longitude": "-75.12851000"
                    },
                    {
                        "id": 118696,
                        "name": "Houserville",
                        "latitude": "40.82395000",
                        "longitude": "-77.82889000"
                    },
                    {
                        "id": 118700,
                        "name": "Houston",
                        "latitude": "40.24646000",
                        "longitude": "-80.21145000"
                    },
                    {
                        "id": 118745,
                        "name": "Hudson",
                        "latitude": "41.27480000",
                        "longitude": "-75.83603000"
                    },
                    {
                        "id": 118761,
                        "name": "Hughestown",
                        "latitude": "41.32702000",
                        "longitude": "-75.77325000"
                    },
                    {
                        "id": 118763,
                        "name": "Hughesville",
                        "latitude": "41.24119000",
                        "longitude": "-76.72385000"
                    },
                    {
                        "id": 118782,
                        "name": "Hummels Wharf",
                        "latitude": "40.83175000",
                        "longitude": "-76.83580000"
                    },
                    {
                        "id": 118783,
                        "name": "Hummelstown",
                        "latitude": "40.26537000",
                        "longitude": "-76.70830000"
                    },
                    {
                        "id": 118796,
                        "name": "Huntingdon",
                        "latitude": "40.48480000",
                        "longitude": "-78.01028000"
                    },
                    {
                        "id": 118797,
                        "name": "Huntingdon County",
                        "latitude": "40.41693000",
                        "longitude": "-77.98121000"
                    },
                    {
                        "id": 118846,
                        "name": "Hyde",
                        "latitude": "41.00256000",
                        "longitude": "-78.46252000"
                    },
                    {
                        "id": 118851,
                        "name": "Hyde Park",
                        "latitude": "40.37732000",
                        "longitude": "-75.92521000"
                    },
                    {
                        "id": 118882,
                        "name": "Imperial",
                        "latitude": "40.44951000",
                        "longitude": "-80.24450000"
                    },
                    {
                        "id": 118911,
                        "name": "Indian Mountain Lake",
                        "latitude": "41.00314000",
                        "longitude": "-75.50824000"
                    },
                    {
                        "id": 118922,
                        "name": "Indiana",
                        "latitude": "40.62146000",
                        "longitude": "-79.15253000"
                    },
                    {
                        "id": 118923,
                        "name": "Indiana County",
                        "latitude": "40.65205000",
                        "longitude": "-79.08755000"
                    },
                    {
                        "id": 118930,
                        "name": "Industry",
                        "latitude": "40.64451000",
                        "longitude": "-80.41618000"
                    },
                    {
                        "id": 118941,
                        "name": "Ingram",
                        "latitude": "40.44618000",
                        "longitude": "-80.06755000"
                    },
                    {
                        "id": 118942,
                        "name": "Inkerman",
                        "latitude": "41.29897000",
                        "longitude": "-75.81269000"
                    },
                    {
                        "id": 118949,
                        "name": "Intercourse",
                        "latitude": "40.03760000",
                        "longitude": "-76.10495000"
                    },
                    {
                        "id": 119012,
                        "name": "Irwin",
                        "latitude": "40.32451000",
                        "longitude": "-79.70115000"
                    },
                    {
                        "id": 119052,
                        "name": "Ivyland",
                        "latitude": "40.20789000",
                        "longitude": "-75.07267000"
                    },
                    {
                        "id": 119107,
                        "name": "Jacksonwald",
                        "latitude": "40.32454000",
                        "longitude": "-75.84965000"
                    },
                    {
                        "id": 119108,
                        "name": "Jacobus",
                        "latitude": "39.88316000",
                        "longitude": "-76.71052000"
                    },
                    {
                        "id": 119159,
                        "name": "Jeannette",
                        "latitude": "40.32812000",
                        "longitude": "-79.61532000"
                    },
                    {
                        "id": 119192,
                        "name": "Jefferson County",
                        "latitude": "41.12815000",
                        "longitude": "-78.99942000"
                    },
                    {
                        "id": 119202,
                        "name": "Jefferson Hills",
                        "latitude": "40.29118000",
                        "longitude": "-79.93199000"
                    },
                    {
                        "id": 119216,
                        "name": "Jenkintown",
                        "latitude": "40.09594000",
                        "longitude": "-75.12517000"
                    },
                    {
                        "id": 119226,
                        "name": "Jermyn",
                        "latitude": "41.53091000",
                        "longitude": "-75.54546000"
                    },
                    {
                        "id": 119228,
                        "name": "Jerome",
                        "latitude": "40.20896000",
                        "longitude": "-78.98364000"
                    },
                    {
                        "id": 119233,
                        "name": "Jersey Shore",
                        "latitude": "41.20202000",
                        "longitude": "-77.26442000"
                    },
                    {
                        "id": 119238,
                        "name": "Jessup",
                        "latitude": "41.46869000",
                        "longitude": "-75.56213000"
                    },
                    {
                        "id": 119247,
                        "name": "Jim Thorpe",
                        "latitude": "40.87592000",
                        "longitude": "-75.73241000"
                    },
                    {
                        "id": 119274,
                        "name": "Johnsonburg",
                        "latitude": "41.49062000",
                        "longitude": "-78.67503000"
                    },
                    {
                        "id": 119285,
                        "name": "Johnstown",
                        "latitude": "40.32674000",
                        "longitude": "-78.92197000"
                    },
                    {
                        "id": 119308,
                        "name": "Jonestown",
                        "latitude": "40.41370000",
                        "longitude": "-76.47830000"
                    },
                    {
                        "id": 119340,
                        "name": "Juniata County",
                        "latitude": "40.53106000",
                        "longitude": "-77.40216000"
                    },
                    {
                        "id": 119376,
                        "name": "Kane",
                        "latitude": "41.66284000",
                        "longitude": "-78.81114000"
                    },
                    {
                        "id": 119455,
                        "name": "Kenhorst",
                        "latitude": "40.31065000",
                        "longitude": "-75.93938000"
                    },
                    {
                        "id": 119458,
                        "name": "Kenilworth",
                        "latitude": "40.23149000",
                        "longitude": "-75.63408000"
                    },
                    {
                        "id": 119460,
                        "name": "Kenmar",
                        "latitude": "41.25341000",
                        "longitude": "-76.95941000"
                    },
                    {
                        "id": 119474,
                        "name": "Kennett Square",
                        "latitude": "39.84678000",
                        "longitude": "-75.71160000"
                    },
                    {
                        "id": 119590,
                        "name": "King of Prussia",
                        "latitude": "40.08927000",
                        "longitude": "-75.39602000"
                    },
                    {
                        "id": 119628,
                        "name": "Kingston",
                        "latitude": "41.26175000",
                        "longitude": "-75.89686000"
                    },
                    {
                        "id": 119661,
                        "name": "Kittanning",
                        "latitude": "40.81645000",
                        "longitude": "-79.52199000"
                    },
                    {
                        "id": 119683,
                        "name": "Knox",
                        "latitude": "41.23451000",
                        "longitude": "-79.53727000"
                    },
                    {
                        "id": 119723,
                        "name": "Kulpmont",
                        "latitude": "40.79342000",
                        "longitude": "-76.47245000"
                    },
                    {
                        "id": 119724,
                        "name": "Kulpsville",
                        "latitude": "40.24288000",
                        "longitude": "-75.33656000"
                    },
                    {
                        "id": 119728,
                        "name": "Kutztown",
                        "latitude": "40.51732000",
                        "longitude": "-75.77742000"
                    },
                    {
                        "id": 119814,
                        "name": "Lackawanna County",
                        "latitude": "41.43679000",
                        "longitude": "-75.60920000"
                    },
                    {
                        "id": 119843,
                        "name": "Lafayette Hill",
                        "latitude": "40.09245000",
                        "longitude": "-75.25330000"
                    },
                    {
                        "id": 119845,
                        "name": "Laflin",
                        "latitude": "41.28897000",
                        "longitude": "-75.80547000"
                    },
                    {
                        "id": 119885,
                        "name": "Lake City",
                        "latitude": "42.01422000",
                        "longitude": "-80.34534000"
                    },
                    {
                        "id": 119920,
                        "name": "Lake Heritage",
                        "latitude": "39.80954000",
                        "longitude": "-77.18387000"
                    },
                    {
                        "id": 119929,
                        "name": "Lake Latonka",
                        "latitude": "41.29039000",
                        "longitude": "-80.18129000"
                    },
                    {
                        "id": 119940,
                        "name": "Lake Meade",
                        "latitude": "39.98510000",
                        "longitude": "-77.03720000"
                    },
                    {
                        "id": 120001,
                        "name": "Lake Wynonah",
                        "latitude": "40.59926000",
                        "longitude": "-76.16383000"
                    },
                    {
                        "id": 120021,
                        "name": "Lakemont",
                        "latitude": "40.47285000",
                        "longitude": "-78.38835000"
                    },
                    {
                        "id": 120077,
                        "name": "Lampeter",
                        "latitude": "39.99010000",
                        "longitude": "-76.23968000"
                    },
                    {
                        "id": 120087,
                        "name": "Lancaster",
                        "latitude": "40.03788000",
                        "longitude": "-76.30551000"
                    },
                    {
                        "id": 120093,
                        "name": "Lancaster County",
                        "latitude": "40.04244000",
                        "longitude": "-76.24770000"
                    },
                    {
                        "id": 120100,
                        "name": "Landisville",
                        "latitude": "40.09537000",
                        "longitude": "-76.40996000"
                    },
                    {
                        "id": 120110,
                        "name": "Langhorne",
                        "latitude": "40.17455000",
                        "longitude": "-74.92267000"
                    },
                    {
                        "id": 120111,
                        "name": "Langhorne Manor",
                        "latitude": "40.16705000",
                        "longitude": "-74.91767000"
                    },
                    {
                        "id": 120121,
                        "name": "Lansdale",
                        "latitude": "40.24150000",
                        "longitude": "-75.28379000"
                    },
                    {
                        "id": 120123,
                        "name": "Lansdowne",
                        "latitude": "39.93817000",
                        "longitude": "-75.27185000"
                    },
                    {
                        "id": 120124,
                        "name": "Lansford",
                        "latitude": "40.83176000",
                        "longitude": "-75.88242000"
                    },
                    {
                        "id": 120135,
                        "name": "Laporte",
                        "latitude": "41.42397000",
                        "longitude": "-76.49411000"
                    },
                    {
                        "id": 120149,
                        "name": "Larksville",
                        "latitude": "41.24508000",
                        "longitude": "-75.93075000"
                    },
                    {
                        "id": 120175,
                        "name": "Latrobe",
                        "latitude": "40.32118000",
                        "longitude": "-79.37948000"
                    },
                    {
                        "id": 120202,
                        "name": "Laureldale",
                        "latitude": "40.38815000",
                        "longitude": "-75.91798000"
                    },
                    {
                        "id": 120212,
                        "name": "Laurys Station",
                        "latitude": "40.72315000",
                        "longitude": "-75.53018000"
                    },
                    {
                        "id": 120224,
                        "name": "Lawnton",
                        "latitude": "40.25842000",
                        "longitude": "-76.80386000"
                    },
                    {
                        "id": 120237,
                        "name": "Lawrence County",
                        "latitude": "40.99127000",
                        "longitude": "-80.33419000"
                    },
                    {
                        "id": 120239,
                        "name": "Lawrence Park",
                        "latitude": "42.15228000",
                        "longitude": "-80.02311000"
                    },
                    {
                        "id": 120248,
                        "name": "Lawson Heights",
                        "latitude": "40.29174000",
                        "longitude": "-79.38920000"
                    },
                    {
                        "id": 120293,
                        "name": "Lebanon",
                        "latitude": "40.34093000",
                        "longitude": "-76.41135000"
                    },
                    {
                        "id": 120295,
                        "name": "Lebanon County",
                        "latitude": "40.36723000",
                        "longitude": "-76.45771000"
                    },
                    {
                        "id": 120297,
                        "name": "Lebanon South",
                        "latitude": "40.32804000",
                        "longitude": "-76.40644000"
                    },
                    {
                        "id": 120319,
                        "name": "Leechburg",
                        "latitude": "40.62701000",
                        "longitude": "-79.60560000"
                    },
                    {
                        "id": 120327,
                        "name": "Leesport",
                        "latitude": "40.44704000",
                        "longitude": "-75.96632000"
                    },
                    {
                        "id": 120330,
                        "name": "Leetsdale",
                        "latitude": "40.56312000",
                        "longitude": "-80.20839000"
                    },
                    {
                        "id": 120335,
                        "name": "Lehigh County",
                        "latitude": "40.61271000",
                        "longitude": "-75.59237000"
                    },
                    {
                        "id": 120336,
                        "name": "Lehighton",
                        "latitude": "40.83370000",
                        "longitude": "-75.71380000"
                    },
                    {
                        "id": 120348,
                        "name": "Leith-Hatfield",
                        "latitude": "39.87744000",
                        "longitude": "-79.73133000"
                    },
                    {
                        "id": 120361,
                        "name": "Lemont",
                        "latitude": "40.81062000",
                        "longitude": "-77.81833000"
                    },
                    {
                        "id": 120364,
                        "name": "Lemoyne",
                        "latitude": "40.24120000",
                        "longitude": "-76.89414000"
                    },
                    {
                        "id": 120367,
                        "name": "Lenape Heights",
                        "latitude": "40.76423000",
                        "longitude": "-79.52060000"
                    },
                    {
                        "id": 120380,
                        "name": "Leola",
                        "latitude": "40.08787000",
                        "longitude": "-76.18495000"
                    },
                    {
                        "id": 120402,
                        "name": "Level Green",
                        "latitude": "40.39340000",
                        "longitude": "-79.72032000"
                    },
                    {
                        "id": 120408,
                        "name": "Levittown",
                        "latitude": "40.15511000",
                        "longitude": "-74.82877000"
                    },
                    {
                        "id": 120421,
                        "name": "Lewisburg",
                        "latitude": "40.96453000",
                        "longitude": "-76.88441000"
                    },
                    {
                        "id": 120432,
                        "name": "Lewistown",
                        "latitude": "40.59924000",
                        "longitude": "-77.57138000"
                    },
                    {
                        "id": 120467,
                        "name": "Liberty",
                        "latitude": "40.32535000",
                        "longitude": "-79.85616000"
                    },
                    {
                        "id": 120479,
                        "name": "Light Street",
                        "latitude": "41.03620000",
                        "longitude": "-76.42356000"
                    },
                    {
                        "id": 120482,
                        "name": "Ligonier",
                        "latitude": "40.24313000",
                        "longitude": "-79.23753000"
                    },
                    {
                        "id": 120488,
                        "name": "Lima",
                        "latitude": "39.91733000",
                        "longitude": "-75.44047000"
                    },
                    {
                        "id": 120491,
                        "name": "Limerick",
                        "latitude": "40.23093000",
                        "longitude": "-75.52212000"
                    },
                    {
                        "id": 120507,
                        "name": "Lincoln",
                        "latitude": "40.31896000",
                        "longitude": "-79.85477000"
                    },
                    {
                        "id": 120544,
                        "name": "Lincoln Park",
                        "latitude": "40.31481000",
                        "longitude": "-75.98549000"
                    },
                    {
                        "id": 120579,
                        "name": "Linglestown",
                        "latitude": "40.33398000",
                        "longitude": "-76.78914000"
                    },
                    {
                        "id": 120586,
                        "name": "Linntown",
                        "latitude": "40.95897000",
                        "longitude": "-76.89913000"
                    },
                    {
                        "id": 120593,
                        "name": "Linwood",
                        "latitude": "39.82650000",
                        "longitude": "-75.42547000"
                    },
                    {
                        "id": 120594,
                        "name": "Lionville",
                        "latitude": "40.05372000",
                        "longitude": "-75.65993000"
                    },
                    {
                        "id": 120612,
                        "name": "Lititz",
                        "latitude": "40.15732000",
                        "longitude": "-76.30690000"
                    },
                    {
                        "id": 120634,
                        "name": "Littlestown",
                        "latitude": "39.74454000",
                        "longitude": "-77.08804000"
                    },
                    {
                        "id": 120674,
                        "name": "Lock Haven",
                        "latitude": "41.13701000",
                        "longitude": "-77.44693000"
                    },
                    {
                        "id": 120709,
                        "name": "Loganville",
                        "latitude": "39.85566000",
                        "longitude": "-76.70747000"
                    },
                    {
                        "id": 120769,
                        "name": "Lorane",
                        "latitude": "40.28843000",
                        "longitude": "-75.85465000"
                    },
                    {
                        "id": 120775,
                        "name": "Loretto",
                        "latitude": "40.50313000",
                        "longitude": "-78.63030000"
                    },
                    {
                        "id": 120839,
                        "name": "Lower Allen",
                        "latitude": "40.22648000",
                        "longitude": "-76.90053000"
                    },
                    {
                        "id": 120840,
                        "name": "Lower Burrell",
                        "latitude": "40.55312000",
                        "longitude": "-79.75727000"
                    },
                    {
                        "id": 120854,
                        "name": "Loyalhanna",
                        "latitude": "40.32257000",
                        "longitude": "-79.36226000"
                    },
                    {
                        "id": 120903,
                        "name": "Luzerne",
                        "latitude": "41.28564000",
                        "longitude": "-75.90103000"
                    },
                    {
                        "id": 120904,
                        "name": "Luzerne County",
                        "latitude": "41.17701000",
                        "longitude": "-75.98903000"
                    },
                    {
                        "id": 120905,
                        "name": "Lycoming County",
                        "latitude": "41.34338000",
                        "longitude": "-77.06451000"
                    },
                    {
                        "id": 120907,
                        "name": "Lykens",
                        "latitude": "40.56675000",
                        "longitude": "-76.70052000"
                    },
                    {
                        "id": 120932,
                        "name": "Lynnwood-Pricedale",
                        "latitude": "40.13071000",
                        "longitude": "-79.85135000"
                    },
                    {
                        "id": 120974,
                        "name": "Macungie",
                        "latitude": "40.51593000",
                        "longitude": "-75.55519000"
                    },
                    {
                        "id": 121040,
                        "name": "Mahanoy City",
                        "latitude": "40.81259000",
                        "longitude": "-76.14160000"
                    },
                    {
                        "id": 121073,
                        "name": "Malvern",
                        "latitude": "40.03622000",
                        "longitude": "-75.51381000"
                    },
                    {
                        "id": 121100,
                        "name": "Manchester",
                        "latitude": "40.06315000",
                        "longitude": "-76.71830000"
                    },
                    {
                        "id": 121118,
                        "name": "Manheim",
                        "latitude": "40.16343000",
                        "longitude": "-76.39496000"
                    },
                    {
                        "id": 121139,
                        "name": "Manor",
                        "latitude": "40.33396000",
                        "longitude": "-79.67004000"
                    },
                    {
                        "id": 121147,
                        "name": "Mansfield",
                        "latitude": "41.80730000",
                        "longitude": "-77.07747000"
                    },
                    {
                        "id": 121166,
                        "name": "Maple Glen",
                        "latitude": "40.17928000",
                        "longitude": "-75.18045000"
                    },
                    {
                        "id": 121200,
                        "name": "Marcus Hook",
                        "latitude": "39.81928000",
                        "longitude": "-75.41853000"
                    },
                    {
                        "id": 121210,
                        "name": "Marianne",
                        "latitude": "41.24645000",
                        "longitude": "-79.42893000"
                    },
                    {
                        "id": 121214,
                        "name": "Marienville",
                        "latitude": "41.46895000",
                        "longitude": "-79.12310000"
                    },
                    {
                        "id": 121218,
                        "name": "Marietta",
                        "latitude": "40.05704000",
                        "longitude": "-76.55219000"
                    },
                    {
                        "id": 121298,
                        "name": "Mars",
                        "latitude": "40.69590000",
                        "longitude": "-80.01173000"
                    },
                    {
                        "id": 121322,
                        "name": "Marshallton",
                        "latitude": "40.78675000",
                        "longitude": "-76.53940000"
                    },
                    {
                        "id": 121347,
                        "name": "Martinsburg",
                        "latitude": "40.31119000",
                        "longitude": "-78.32418000"
                    },
                    {
                        "id": 121359,
                        "name": "Marysville",
                        "latitude": "40.34259000",
                        "longitude": "-76.92997000"
                    },
                    {
                        "id": 121384,
                        "name": "Masontown",
                        "latitude": "39.84674000",
                        "longitude": "-79.89978000"
                    },
                    {
                        "id": 121398,
                        "name": "Matamoras",
                        "latitude": "41.36870000",
                        "longitude": "-74.70016000"
                    },
                    {
                        "id": 121437,
                        "name": "Mayfield",
                        "latitude": "41.53814000",
                        "longitude": "-75.53602000"
                    },
                    {
                        "id": 121453,
                        "name": "Maytown",
                        "latitude": "40.07537000",
                        "longitude": "-76.58219000"
                    },
                    {
                        "id": 121461,
                        "name": "McAdoo",
                        "latitude": "40.90127000",
                        "longitude": "-75.99106000"
                    },
                    {
                        "id": 121477,
                        "name": "McConnellsburg",
                        "latitude": "39.93259000",
                        "longitude": "-77.99889000"
                    },
                    {
                        "id": 121478,
                        "name": "McConnellstown",
                        "latitude": "40.45257000",
                        "longitude": "-78.08167000"
                    },
                    {
                        "id": 121491,
                        "name": "McDonald",
                        "latitude": "40.37090000",
                        "longitude": "-80.23478000"
                    },
                    {
                        "id": 121503,
                        "name": "McGovern",
                        "latitude": "40.22896000",
                        "longitude": "-80.21645000"
                    },
                    {
                        "id": 121516,
                        "name": "McKean County",
                        "latitude": "41.80775000",
                        "longitude": "-78.56903000"
                    },
                    {
                        "id": 121518,
                        "name": "McKees Rocks",
                        "latitude": "40.46562000",
                        "longitude": "-80.06561000"
                    },
                    {
                        "id": 121519,
                        "name": "McKeesport",
                        "latitude": "40.34785000",
                        "longitude": "-79.86422000"
                    },
                    {
                        "id": 121543,
                        "name": "McMurray",
                        "latitude": "40.27785000",
                        "longitude": "-80.08394000"
                    },
                    {
                        "id": 121551,
                        "name": "McSherrystown",
                        "latitude": "39.80732000",
                        "longitude": "-77.01137000"
                    },
                    {
                        "id": 121570,
                        "name": "Meadowood",
                        "latitude": "40.84201000",
                        "longitude": "-79.89394000"
                    },
                    {
                        "id": 121575,
                        "name": "Meadville",
                        "latitude": "41.64144000",
                        "longitude": "-80.15145000"
                    },
                    {
                        "id": 121580,
                        "name": "Mechanicsburg",
                        "latitude": "40.21426000",
                        "longitude": "-77.00859000"
                    },
                    {
                        "id": 121585,
                        "name": "Mechanicsville",
                        "latitude": "40.96648000",
                        "longitude": "-76.58662000"
                    },
                    {
                        "id": 121598,
                        "name": "Media",
                        "latitude": "39.91678000",
                        "longitude": "-75.38769000"
                    },
                    {
                        "id": 121674,
                        "name": "Mercer",
                        "latitude": "41.22700000",
                        "longitude": "-80.23979000"
                    },
                    {
                        "id": 121680,
                        "name": "Mercer County",
                        "latitude": "41.30218000",
                        "longitude": "-80.25770000"
                    },
                    {
                        "id": 121683,
                        "name": "Mercersburg",
                        "latitude": "39.82787000",
                        "longitude": "-77.90333000"
                    },
                    {
                        "id": 121693,
                        "name": "Meridian",
                        "latitude": "40.84840000",
                        "longitude": "-79.96200000"
                    },
                    {
                        "id": 121745,
                        "name": "Meyersdale",
                        "latitude": "39.81369000",
                        "longitude": "-79.02475000"
                    },
                    {
                        "id": 121769,
                        "name": "Middleburg",
                        "latitude": "40.78592000",
                        "longitude": "-77.04720000"
                    },
                    {
                        "id": 121792,
                        "name": "Middletown",
                        "latitude": "40.19981000",
                        "longitude": "-76.73108000"
                    },
                    {
                        "id": 121799,
                        "name": "Midland",
                        "latitude": "40.63257000",
                        "longitude": "-80.44645000"
                    },
                    {
                        "id": 121818,
                        "name": "Midway",
                        "latitude": "39.80843000",
                        "longitude": "-77.00276000"
                    },
                    {
                        "id": 121825,
                        "name": "Mifflin County",
                        "latitude": "40.61041000",
                        "longitude": "-77.61704000"
                    },
                    {
                        "id": 121826,
                        "name": "Mifflinburg",
                        "latitude": "40.91758000",
                        "longitude": "-77.04775000"
                    },
                    {
                        "id": 121827,
                        "name": "Mifflintown",
                        "latitude": "40.56980000",
                        "longitude": "-77.39693000"
                    },
                    {
                        "id": 121828,
                        "name": "Mifflinville",
                        "latitude": "41.03231000",
                        "longitude": "-76.30799000"
                    },
                    {
                        "id": 121845,
                        "name": "Milesburg",
                        "latitude": "40.94173000",
                        "longitude": "-77.78500000"
                    },
                    {
                        "id": 121857,
                        "name": "Milford",
                        "latitude": "41.32232000",
                        "longitude": "-74.80239000"
                    },
                    {
                        "id": 121865,
                        "name": "Mill Hall",
                        "latitude": "41.10729000",
                        "longitude": "-77.48443000"
                    },
                    {
                        "id": 121870,
                        "name": "Millbourne",
                        "latitude": "39.96345000",
                        "longitude": "-75.25018000"
                    },
                    {
                        "id": 121886,
                        "name": "Millersburg",
                        "latitude": "40.53953000",
                        "longitude": "-76.96081000"
                    },
                    {
                        "id": 121889,
                        "name": "Millersville",
                        "latitude": "39.99788000",
                        "longitude": "-76.35413000"
                    },
                    {
                        "id": 121903,
                        "name": "Millvale",
                        "latitude": "40.48007000",
                        "longitude": "-79.97839000"
                    },
                    {
                        "id": 121910,
                        "name": "Milroy",
                        "latitude": "40.71396000",
                        "longitude": "-77.59055000"
                    },
                    {
                        "id": 121917,
                        "name": "Milton",
                        "latitude": "41.01203000",
                        "longitude": "-76.84774000"
                    },
                    {
                        "id": 121943,
                        "name": "Minersville",
                        "latitude": "40.69065000",
                        "longitude": "-76.26217000"
                    },
                    {
                        "id": 122022,
                        "name": "Mohnton",
                        "latitude": "40.28593000",
                        "longitude": "-75.98438000"
                    },
                    {
                        "id": 122032,
                        "name": "Monaca",
                        "latitude": "40.68729000",
                        "longitude": "-80.27145000"
                    },
                    {
                        "id": 122038,
                        "name": "Monessen",
                        "latitude": "40.14841000",
                        "longitude": "-79.88783000"
                    },
                    {
                        "id": 122055,
                        "name": "Monongahela",
                        "latitude": "40.20313000",
                        "longitude": "-79.92616000"
                    },
                    {
                        "id": 122081,
                        "name": "Monroe County",
                        "latitude": "41.05807000",
                        "longitude": "-75.33948000"
                    },
                    {
                        "id": 122086,
                        "name": "Monroeville",
                        "latitude": "40.42118000",
                        "longitude": "-79.78810000"
                    },
                    {
                        "id": 122092,
                        "name": "Mont Alto",
                        "latitude": "39.84426000",
                        "longitude": "-77.55832000"
                    },
                    {
                        "id": 122136,
                        "name": "Montgomery",
                        "latitude": "41.17036000",
                        "longitude": "-76.87691000"
                    },
                    {
                        "id": 122155,
                        "name": "Montgomery County",
                        "latitude": "40.21083000",
                        "longitude": "-75.36730000"
                    },
                    {
                        "id": 122157,
                        "name": "Montgomeryville",
                        "latitude": "40.24733000",
                        "longitude": "-75.24379000"
                    },
                    {
                        "id": 122173,
                        "name": "Montour County",
                        "latitude": "41.02792000",
                        "longitude": "-76.65856000"
                    },
                    {
                        "id": 122175,
                        "name": "Montoursville",
                        "latitude": "41.25425000",
                        "longitude": "-76.92052000"
                    },
                    {
                        "id": 122183,
                        "name": "Montrose",
                        "latitude": "41.83397000",
                        "longitude": "-75.87714000"
                    },
                    {
                        "id": 122216,
                        "name": "Moosic",
                        "latitude": "41.35341000",
                        "longitude": "-75.73825000"
                    },
                    {
                        "id": 149547,
                        "name": "Morningside",
                        "latitude": "40.48140510",
                        "longitude": "-79.93442840"
                    },
                    {
                        "id": 122286,
                        "name": "Morrisville",
                        "latitude": "40.21150000",
                        "longitude": "-74.78794000"
                    },
                    {
                        "id": 122292,
                        "name": "Morton",
                        "latitude": "39.90983000",
                        "longitude": "-75.32352000"
                    },
                    {
                        "id": 122299,
                        "name": "Moscow",
                        "latitude": "41.33675000",
                        "longitude": "-75.51852000"
                    },
                    {
                        "id": 122337,
                        "name": "Mount Carmel",
                        "latitude": "40.79703000",
                        "longitude": "-76.41190000"
                    },
                    {
                        "id": 122340,
                        "name": "Mount Cobb",
                        "latitude": "41.41342000",
                        "longitude": "-75.49324000"
                    },
                    {
                        "id": 122351,
                        "name": "Mount Holly Springs",
                        "latitude": "40.11842000",
                        "longitude": "-77.18998000"
                    },
                    {
                        "id": 122358,
                        "name": "Mount Joy",
                        "latitude": "40.10982000",
                        "longitude": "-76.50330000"
                    },
                    {
                        "id": 122362,
                        "name": "Mount Lebanon",
                        "latitude": "40.35535000",
                        "longitude": "-80.04950000"
                    },
                    {
                        "id": 122370,
                        "name": "Mount Oliver",
                        "latitude": "40.41424000",
                        "longitude": "-79.98783000"
                    },
                    {
                        "id": 122373,
                        "name": "Mount Penn",
                        "latitude": "40.32815000",
                        "longitude": "-75.89076000"
                    },
                    {
                        "id": 122380,
                        "name": "Mount Pleasant",
                        "latitude": "40.14896000",
                        "longitude": "-79.54115000"
                    },
                    {
                        "id": 122384,
                        "name": "Mount Pocono",
                        "latitude": "41.12203000",
                        "longitude": "-75.36463000"
                    },
                    {
                        "id": 122392,
                        "name": "Mount Union",
                        "latitude": "40.38452000",
                        "longitude": "-77.88222000"
                    },
                    {
                        "id": 122407,
                        "name": "Mount Wolf",
                        "latitude": "40.06315000",
                        "longitude": "-76.70386000"
                    },
                    {
                        "id": 122427,
                        "name": "Mountain Top",
                        "latitude": "41.16953000",
                        "longitude": "-75.87742000"
                    },
                    {
                        "id": 122437,
                        "name": "Mountainhome",
                        "latitude": "41.17370000",
                        "longitude": "-75.27102000"
                    },
                    {
                        "id": 122441,
                        "name": "Mountville",
                        "latitude": "40.03926000",
                        "longitude": "-76.43080000"
                    },
                    {
                        "id": 122449,
                        "name": "Muhlenberg Park",
                        "latitude": "40.38482000",
                        "longitude": "-75.94132000"
                    },
                    {
                        "id": 122466,
                        "name": "Muncy",
                        "latitude": "41.20564000",
                        "longitude": "-76.78552000"
                    },
                    {
                        "id": 122469,
                        "name": "Mundys Corner",
                        "latitude": "40.44479000",
                        "longitude": "-78.84113000"
                    },
                    {
                        "id": 122473,
                        "name": "Munhall",
                        "latitude": "40.39229000",
                        "longitude": "-79.90005000"
                    },
                    {
                        "id": 122500,
                        "name": "Murrysville",
                        "latitude": "40.42840000",
                        "longitude": "-79.69755000"
                    },
                    {
                        "id": 122507,
                        "name": "Muse",
                        "latitude": "40.29285000",
                        "longitude": "-80.20034000"
                    },
                    {
                        "id": 122518,
                        "name": "Myerstown",
                        "latitude": "40.37454000",
                        "longitude": "-76.30273000"
                    },
                    {
                        "id": 122541,
                        "name": "Nanticoke",
                        "latitude": "41.20536000",
                        "longitude": "-76.00492000"
                    },
                    {
                        "id": 122544,
                        "name": "Nanty Glo",
                        "latitude": "40.47229000",
                        "longitude": "-78.83336000"
                    },
                    {
                        "id": 122563,
                        "name": "Narberth",
                        "latitude": "40.00845000",
                        "longitude": "-75.26046000"
                    },
                    {
                        "id": 122606,
                        "name": "Nazareth",
                        "latitude": "40.74038000",
                        "longitude": "-75.30962000"
                    },
                    {
                        "id": 122640,
                        "name": "Nescopeck",
                        "latitude": "41.05203000",
                        "longitude": "-76.22077000"
                    },
                    {
                        "id": 122642,
                        "name": "Nesquehoning",
                        "latitude": "40.86453000",
                        "longitude": "-75.81103000"
                    },
                    {
                        "id": 122661,
                        "name": "New Beaver",
                        "latitude": "40.87645000",
                        "longitude": "-80.37062000"
                    },
                    {
                        "id": 122665,
                        "name": "New Berlinville",
                        "latitude": "40.34537000",
                        "longitude": "-75.63296000"
                    },
                    {
                        "id": 122667,
                        "name": "New Bloomfield",
                        "latitude": "40.41981000",
                        "longitude": "-77.18637000"
                    },
                    {
                        "id": 122673,
                        "name": "New Brighton",
                        "latitude": "40.73034000",
                        "longitude": "-80.31006000"
                    },
                    {
                        "id": 122675,
                        "name": "New Britain",
                        "latitude": "40.29900000",
                        "longitude": "-75.18101000"
                    },
                    {
                        "id": 122688,
                        "name": "New Castle",
                        "latitude": "41.00367000",
                        "longitude": "-80.34701000"
                    },
                    {
                        "id": 122691,
                        "name": "New Castle Northwest",
                        "latitude": "41.02208000",
                        "longitude": "-80.35682000"
                    },
                    {
                        "id": 122696,
                        "name": "New Columbia",
                        "latitude": "41.04092000",
                        "longitude": "-76.86691000"
                    },
                    {
                        "id": 122697,
                        "name": "New Cumberland",
                        "latitude": "40.23231000",
                        "longitude": "-76.88470000"
                    },
                    {
                        "id": 122702,
                        "name": "New Eagle",
                        "latitude": "40.20785000",
                        "longitude": "-79.94699000"
                    },
                    {
                        "id": 122707,
                        "name": "New Freedom",
                        "latitude": "39.73788000",
                        "longitude": "-76.70136000"
                    },
                    {
                        "id": 122721,
                        "name": "New Holland",
                        "latitude": "40.10176000",
                        "longitude": "-76.08523000"
                    },
                    {
                        "id": 122727,
                        "name": "New Hope",
                        "latitude": "40.36427000",
                        "longitude": "-74.95128000"
                    },
                    {
                        "id": 122733,
                        "name": "New Kensington",
                        "latitude": "40.56979000",
                        "longitude": "-79.76477000"
                    },
                    {
                        "id": 122757,
                        "name": "New Oxford",
                        "latitude": "39.86371000",
                        "longitude": "-77.05581000"
                    },
                    {
                        "id": 122762,
                        "name": "New Philadelphia",
                        "latitude": "40.71953000",
                        "longitude": "-76.11577000"
                    },
                    {
                        "id": 122783,
                        "name": "New Stanton",
                        "latitude": "40.21924000",
                        "longitude": "-79.60948000"
                    },
                    {
                        "id": 122792,
                        "name": "New Wilmington",
                        "latitude": "41.12228000",
                        "longitude": "-80.33284000"
                    },
                    {
                        "id": 122835,
                        "name": "Newmanstown",
                        "latitude": "40.34954000",
                        "longitude": "-76.21328000"
                    },
                    {
                        "id": 122848,
                        "name": "Newport",
                        "latitude": "40.47786000",
                        "longitude": "-77.13054000"
                    },
                    {
                        "id": 122874,
                        "name": "Newtown",
                        "latitude": "40.22928000",
                        "longitude": "-74.93683000"
                    },
                    {
                        "id": 122876,
                        "name": "Newtown Grant",
                        "latitude": "40.26011000",
                        "longitude": "-74.95489000"
                    },
                    {
                        "id": 122877,
                        "name": "Newville",
                        "latitude": "40.17314000",
                        "longitude": "-77.39860000"
                    },
                    {
                        "id": 122914,
                        "name": "Nixon",
                        "latitude": "40.78340000",
                        "longitude": "-79.92950000"
                    },
                    {
                        "id": 122957,
                        "name": "Norristown",
                        "latitude": "40.12150000",
                        "longitude": "-75.33990000"
                    },
                    {
                        "id": 122964,
                        "name": "North Apollo",
                        "latitude": "40.59618000",
                        "longitude": "-79.55560000"
                    },
                    {
                        "id": 122980,
                        "name": "North Belle Vernon",
                        "latitude": "40.12924000",
                        "longitude": "-79.86810000"
                    },
                    {
                        "id": 122992,
                        "name": "North Braddock",
                        "latitude": "40.39896000",
                        "longitude": "-79.84088000"
                    },
                    {
                        "id": 123002,
                        "name": "North Catasauqua",
                        "latitude": "40.65982000",
                        "longitude": "-75.47685000"
                    },
                    {
                        "id": 123004,
                        "name": "North Charleroi",
                        "latitude": "40.15118000",
                        "longitude": "-79.90755000"
                    },
                    {
                        "id": 123018,
                        "name": "North East",
                        "latitude": "42.21561000",
                        "longitude": "-79.83422000"
                    },
                    {
                        "id": 123122,
                        "name": "North Versailles",
                        "latitude": "40.37979000",
                        "longitude": "-79.80949000"
                    },
                    {
                        "id": 123123,
                        "name": "North Wales",
                        "latitude": "40.21094000",
                        "longitude": "-75.27823000"
                    },
                    {
                        "id": 123125,
                        "name": "North Warren",
                        "latitude": "41.87423000",
                        "longitude": "-79.15227000"
                    },
                    {
                        "id": 123133,
                        "name": "North York",
                        "latitude": "39.97815000",
                        "longitude": "-76.73302000"
                    },
                    {
                        "id": 123135,
                        "name": "Northampton",
                        "latitude": "40.68621000",
                        "longitude": "-75.49685000"
                    },
                    {
                        "id": 123138,
                        "name": "Northampton County",
                        "latitude": "40.75423000",
                        "longitude": "-75.30742000"
                    },
                    {
                        "id": 123147,
                        "name": "Northern Cambria",
                        "latitude": "40.65923000",
                        "longitude": "-78.78169000"
                    },
                    {
                        "id": 123166,
                        "name": "Northumberland",
                        "latitude": "40.89175000",
                        "longitude": "-76.79747000"
                    },
                    {
                        "id": 123168,
                        "name": "Northumberland County",
                        "latitude": "40.85198000",
                        "longitude": "-76.70932000"
                    },
                    {
                        "id": 123175,
                        "name": "Northwest Harborcreek",
                        "latitude": "42.14944000",
                        "longitude": "-79.99463000"
                    },
                    {
                        "id": 123198,
                        "name": "Norwood",
                        "latitude": "39.89178000",
                        "longitude": "-75.29963000"
                    },
                    {
                        "id": 123247,
                        "name": "Oak Hills",
                        "latitude": "40.82479000",
                        "longitude": "-79.91311000"
                    },
                    {
                        "id": 123273,
                        "name": "Oakdale",
                        "latitude": "40.39812000",
                        "longitude": "-80.18561000"
                    },
                    {
                        "id": 123292,
                        "name": "Oakland",
                        "latitude": "40.30646000",
                        "longitude": "-78.88752000"
                    },
                    {
                        "id": 123302,
                        "name": "Oakmont",
                        "latitude": "40.52173000",
                        "longitude": "-79.84227000"
                    },
                    {
                        "id": 123311,
                        "name": "Oakwood",
                        "latitude": "41.01062000",
                        "longitude": "-80.37951000"
                    },
                    {
                        "id": 123385,
                        "name": "Ohioville",
                        "latitude": "40.67923000",
                        "longitude": "-80.49479000"
                    },
                    {
                        "id": 123387,
                        "name": "Oil City",
                        "latitude": "41.43395000",
                        "longitude": "-79.70644000"
                    },
                    {
                        "id": 123419,
                        "name": "Old Forge",
                        "latitude": "41.37119000",
                        "longitude": "-75.73491000"
                    },
                    {
                        "id": 123424,
                        "name": "Old Orchard",
                        "latitude": "40.65788000",
                        "longitude": "-75.26212000"
                    },
                    {
                        "id": 123436,
                        "name": "Oley",
                        "latitude": "40.38759000",
                        "longitude": "-75.78964000"
                    },
                    {
                        "id": 123442,
                        "name": "Oliver",
                        "latitude": "39.91869000",
                        "longitude": "-79.71782000"
                    },
                    {
                        "id": 123462,
                        "name": "Olyphant",
                        "latitude": "41.46841000",
                        "longitude": "-75.60297000"
                    },
                    {
                        "id": 123534,
                        "name": "Orchard Hills",
                        "latitude": "40.58618000",
                        "longitude": "-79.53143000"
                    },
                    {
                        "id": 123550,
                        "name": "Oreland",
                        "latitude": "40.11844000",
                        "longitude": "-75.17768000"
                    },
                    {
                        "id": 123585,
                        "name": "Orwigsburg",
                        "latitude": "40.65481000",
                        "longitude": "-76.10077000"
                    },
                    {
                        "id": 123606,
                        "name": "Osceola Mills",
                        "latitude": "40.85006000",
                        "longitude": "-78.27057000"
                    },
                    {
                        "id": 123680,
                        "name": "Oxford",
                        "latitude": "39.78539000",
                        "longitude": "-75.97883000"
                    },
                    {
                        "id": 123756,
                        "name": "Palmdale",
                        "latitude": "40.29787000",
                        "longitude": "-76.61858000"
                    },
                    {
                        "id": 123761,
                        "name": "Palmer Heights",
                        "latitude": "40.68732000",
                        "longitude": "-75.26240000"
                    },
                    {
                        "id": 123763,
                        "name": "Palmerton",
                        "latitude": "40.80140000",
                        "longitude": "-75.61190000"
                    },
                    {
                        "id": 123777,
                        "name": "Palmyra",
                        "latitude": "40.30898000",
                        "longitude": "-76.59330000"
                    },
                    {
                        "id": 123780,
                        "name": "Palo Alto",
                        "latitude": "40.68731000",
                        "longitude": "-76.17216000"
                    },
                    {
                        "id": 123812,
                        "name": "Paoli",
                        "latitude": "40.04205000",
                        "longitude": "-75.47631000"
                    },
                    {
                        "id": 123817,
                        "name": "Paradise",
                        "latitude": "40.00982000",
                        "longitude": "-76.12857000"
                    },
                    {
                        "id": 123846,
                        "name": "Park Forest Village",
                        "latitude": "40.80673000",
                        "longitude": "-77.91695000"
                    },
                    {
                        "id": 123869,
                        "name": "Parkesburg",
                        "latitude": "39.95872000",
                        "longitude": "-75.91939000"
                    },
                    {
                        "id": 123875,
                        "name": "Parkside",
                        "latitude": "39.86428000",
                        "longitude": "-75.37853000"
                    },
                    {
                        "id": 123879,
                        "name": "Parkville",
                        "latitude": "39.78121000",
                        "longitude": "-76.96331000"
                    },
                    {
                        "id": 123918,
                        "name": "Patton",
                        "latitude": "40.63396000",
                        "longitude": "-78.65030000"
                    },
                    {
                        "id": 123940,
                        "name": "Paxtang",
                        "latitude": "40.25898000",
                        "longitude": "-76.83192000"
                    },
                    {
                        "id": 123943,
                        "name": "Paxtonia",
                        "latitude": "40.31731000",
                        "longitude": "-76.79442000"
                    },
                    {
                        "id": 124011,
                        "name": "Pen Argyl",
                        "latitude": "40.86871000",
                        "longitude": "-75.25490000"
                    },
                    {
                        "id": 124012,
                        "name": "Penbrook",
                        "latitude": "40.27537000",
                        "longitude": "-76.84803000"
                    },
                    {
                        "id": 124022,
                        "name": "Penn Estates",
                        "latitude": "41.03750000",
                        "longitude": "-75.23956000"
                    },
                    {
                        "id": 124023,
                        "name": "Penn Hills",
                        "latitude": "40.50118000",
                        "longitude": "-79.83922000"
                    },
                    {
                        "id": 124025,
                        "name": "Penn Wynne",
                        "latitude": "39.98622000",
                        "longitude": "-75.27546000"
                    },
                    {
                        "id": 124027,
                        "name": "Penndel",
                        "latitude": "40.15205000",
                        "longitude": "-74.91656000"
                    },
                    {
                        "id": 124036,
                        "name": "Pennsburg",
                        "latitude": "40.39093000",
                        "longitude": "-75.49212000"
                    },
                    {
                        "id": 124037,
                        "name": "Pennside",
                        "latitude": "40.33732000",
                        "longitude": "-75.87854000"
                    },
                    {
                        "id": 124038,
                        "name": "Pennsport",
                        "latitude": "39.92761000",
                        "longitude": "-75.15045000"
                    },
                    {
                        "id": 124040,
                        "name": "Pennville",
                        "latitude": "39.78954000",
                        "longitude": "-76.99804000"
                    },
                    {
                        "id": 124044,
                        "name": "Penryn",
                        "latitude": "40.20509000",
                        "longitude": "-76.36829000"
                    },
                    {
                        "id": 124061,
                        "name": "Perkasie",
                        "latitude": "40.37205000",
                        "longitude": "-75.29268000"
                    },
                    {
                        "id": 124082,
                        "name": "Perry County",
                        "latitude": "40.39841000",
                        "longitude": "-77.26230000"
                    },
                    {
                        "id": 124086,
                        "name": "Perryopolis",
                        "latitude": "40.08702000",
                        "longitude": "-79.75060000"
                    },
                    {
                        "id": 124126,
                        "name": "Philadelphia",
                        "latitude": "39.95233000",
                        "longitude": "-75.16379000"
                    },
                    {
                        "id": 124128,
                        "name": "Philadelphia County",
                        "latitude": "40.00764000",
                        "longitude": "-75.13396000"
                    },
                    {
                        "id": 124131,
                        "name": "Philipsburg",
                        "latitude": "40.89645000",
                        "longitude": "-78.22057000"
                    },
                    {
                        "id": 124151,
                        "name": "Phoenixville",
                        "latitude": "40.13038000",
                        "longitude": "-75.51491000"
                    },
                    {
                        "id": 124193,
                        "name": "Pike County",
                        "latitude": "41.33199000",
                        "longitude": "-75.03383000"
                    },
                    {
                        "id": 124221,
                        "name": "Pine Grove",
                        "latitude": "40.54842000",
                        "longitude": "-76.38468000"
                    },
                    {
                        "id": 124223,
                        "name": "Pine Grove Mills",
                        "latitude": "40.73367000",
                        "longitude": "-77.88556000"
                    },
                    {
                        "id": 124244,
                        "name": "Pine Ridge",
                        "latitude": "41.14598000",
                        "longitude": "-74.99116000"
                    },
                    {
                        "id": 124285,
                        "name": "Pitcairn",
                        "latitude": "40.40312000",
                        "longitude": "-79.77810000"
                    },
                    {
                        "id": 124296,
                        "name": "Pittsburgh",
                        "latitude": "40.44062000",
                        "longitude": "-79.99589000"
                    },
                    {
                        "id": 124304,
                        "name": "Pittston",
                        "latitude": "41.32591000",
                        "longitude": "-75.78936000"
                    },
                    {
                        "id": 124323,
                        "name": "Plains",
                        "latitude": "41.27536000",
                        "longitude": "-75.85020000"
                    },
                    {
                        "id": 124364,
                        "name": "Pleasant Gap",
                        "latitude": "40.86812000",
                        "longitude": "-77.74667000"
                    },
                    {
                        "id": 124371,
                        "name": "Pleasant Hill",
                        "latitude": "40.33620000",
                        "longitude": "-76.44163000"
                    },
                    {
                        "id": 124374,
                        "name": "Pleasant Hills",
                        "latitude": "40.33563000",
                        "longitude": "-79.96061000"
                    },
                    {
                        "id": 124392,
                        "name": "Plum",
                        "latitude": "40.50035000",
                        "longitude": "-79.74949000"
                    },
                    {
                        "id": 124398,
                        "name": "Plumsteadville",
                        "latitude": "40.38733000",
                        "longitude": "-75.14656000"
                    },
                    {
                        "id": 124407,
                        "name": "Plymouth",
                        "latitude": "41.24036000",
                        "longitude": "-75.94464000"
                    },
                    {
                        "id": 124411,
                        "name": "Plymouth Meeting",
                        "latitude": "40.10233000",
                        "longitude": "-75.27435000"
                    },
                    {
                        "id": 124421,
                        "name": "Pocono Pines",
                        "latitude": "41.10675000",
                        "longitude": "-75.45435000"
                    },
                    {
                        "id": 124422,
                        "name": "Pocono Ranch Lands",
                        "latitude": "41.16454000",
                        "longitude": "-74.95212000"
                    },
                    {
                        "id": 124429,
                        "name": "Point Marion",
                        "latitude": "39.73897000",
                        "longitude": "-79.89867000"
                    },
                    {
                        "id": 124491,
                        "name": "Port Allegany",
                        "latitude": "41.81090000",
                        "longitude": "-78.27974000"
                    },
                    {
                        "id": 124501,
                        "name": "Port Carbon",
                        "latitude": "40.69648000",
                        "longitude": "-76.16883000"
                    },
                    {
                        "id": 124538,
                        "name": "Port Vue",
                        "latitude": "40.33590000",
                        "longitude": "-79.86977000"
                    },
                    {
                        "id": 124545,
                        "name": "Portage",
                        "latitude": "40.38868000",
                        "longitude": "-78.67224000"
                    },
                    {
                        "id": 124592,
                        "name": "Potter County",
                        "latitude": "41.74492000",
                        "longitude": "-77.89581000"
                    },
                    {
                        "id": 124598,
                        "name": "Pottsgrove",
                        "latitude": "40.26482000",
                        "longitude": "-75.61185000"
                    },
                    {
                        "id": 124599,
                        "name": "Pottstown",
                        "latitude": "40.24537000",
                        "longitude": "-75.64963000"
                    },
                    {
                        "id": 124601,
                        "name": "Pottsville",
                        "latitude": "40.68565000",
                        "longitude": "-76.19550000"
                    },
                    {
                        "id": 124702,
                        "name": "Progress",
                        "latitude": "40.28509000",
                        "longitude": "-76.83136000"
                    },
                    {
                        "id": 124707,
                        "name": "Prospect",
                        "latitude": "40.90451000",
                        "longitude": "-80.04645000"
                    },
                    {
                        "id": 124709,
                        "name": "Prospect Park",
                        "latitude": "39.88789000",
                        "longitude": "-75.30824000"
                    },
                    {
                        "id": 124751,
                        "name": "Punxsutawney",
                        "latitude": "40.94368000",
                        "longitude": "-78.97087000"
                    },
                    {
                        "id": 124772,
                        "name": "Pymatuning Central",
                        "latitude": "41.58546000",
                        "longitude": "-80.47960000"
                    },
                    {
                        "id": 124778,
                        "name": "Quakertown",
                        "latitude": "40.44177000",
                        "longitude": "-75.34157000"
                    },
                    {
                        "id": 124781,
                        "name": "Quarryville",
                        "latitude": "39.89705000",
                        "longitude": "-76.16357000"
                    },
                    {
                        "id": 124818,
                        "name": "Radnor",
                        "latitude": "40.04622000",
                        "longitude": "-75.35991000"
                    },
                    {
                        "id": 124883,
                        "name": "Rankin",
                        "latitude": "40.41257000",
                        "longitude": "-79.87922000"
                    },
                    {
                        "id": 124902,
                        "name": "Raubsville",
                        "latitude": "40.63566000",
                        "longitude": "-75.19295000"
                    },
                    {
                        "id": 124931,
                        "name": "Reading",
                        "latitude": "40.33565000",
                        "longitude": "-75.92687000"
                    },
                    {
                        "id": 124934,
                        "name": "Reamstown",
                        "latitude": "40.21148000",
                        "longitude": "-76.12328000"
                    },
                    {
                        "id": 124947,
                        "name": "Red Hill",
                        "latitude": "40.37288000",
                        "longitude": "-75.48101000"
                    },
                    {
                        "id": 124953,
                        "name": "Red Lion",
                        "latitude": "39.90093000",
                        "longitude": "-76.60580000"
                    },
                    {
                        "id": 125009,
                        "name": "Reiffton",
                        "latitude": "40.31981000",
                        "longitude": "-75.87354000"
                    },
                    {
                        "id": 125011,
                        "name": "Reinholds",
                        "latitude": "40.26676000",
                        "longitude": "-76.11550000"
                    },
                    {
                        "id": 125018,
                        "name": "Rennerdale",
                        "latitude": "40.39840000",
                        "longitude": "-80.14145000"
                    },
                    {
                        "id": 125022,
                        "name": "Renovo",
                        "latitude": "41.32646000",
                        "longitude": "-77.75082000"
                    },
                    {
                        "id": 125031,
                        "name": "Republic",
                        "latitude": "39.96258000",
                        "longitude": "-79.87671000"
                    },
                    {
                        "id": 125041,
                        "name": "Reynolds Heights",
                        "latitude": "41.34506000",
                        "longitude": "-80.39423000"
                    },
                    {
                        "id": 125042,
                        "name": "Reynoldsville",
                        "latitude": "41.09701000",
                        "longitude": "-78.88864000"
                    },
                    {
                        "id": 125044,
                        "name": "Rheems",
                        "latitude": "40.13009000",
                        "longitude": "-76.57052000"
                    },
                    {
                        "id": 125060,
                        "name": "Richboro",
                        "latitude": "40.21511000",
                        "longitude": "-75.01072000"
                    },
                    {
                        "id": 125071,
                        "name": "Richland",
                        "latitude": "40.35926000",
                        "longitude": "-76.25828000"
                    },
                    {
                        "id": 125083,
                        "name": "Richlandtown",
                        "latitude": "40.47010000",
                        "longitude": "-75.32046000"
                    },
                    {
                        "id": 125133,
                        "name": "Ridgway",
                        "latitude": "41.42034000",
                        "longitude": "-78.72864000"
                    },
                    {
                        "id": 125134,
                        "name": "Ridley Park",
                        "latitude": "39.88122000",
                        "longitude": "-75.32380000"
                    },
                    {
                        "id": 125189,
                        "name": "River View Park",
                        "latitude": "40.39259000",
                        "longitude": "-75.95882000"
                    },
                    {
                        "id": 125208,
                        "name": "Riverside",
                        "latitude": "40.95536000",
                        "longitude": "-76.62885000"
                    },
                    {
                        "id": 125233,
                        "name": "Roaring Spring",
                        "latitude": "40.33591000",
                        "longitude": "-78.39085000"
                    },
                    {
                        "id": 125250,
                        "name": "Robesonia",
                        "latitude": "40.35176000",
                        "longitude": "-76.13439000"
                    },
                    {
                        "id": 125268,
                        "name": "Rochester",
                        "latitude": "40.70229000",
                        "longitude": "-80.28645000"
                    },
                    {
                        "id": 125312,
                        "name": "Rockledge",
                        "latitude": "40.08122000",
                        "longitude": "-75.08962000"
                    },
                    {
                        "id": 125438,
                        "name": "Roseto",
                        "latitude": "40.88065000",
                        "longitude": "-75.21462000"
                    },
                    {
                        "id": 125466,
                        "name": "Rothsville",
                        "latitude": "40.15121000",
                        "longitude": "-76.25107000"
                    },
                    {
                        "id": 125497,
                        "name": "Royalton",
                        "latitude": "40.18731000",
                        "longitude": "-76.72997000"
                    },
                    {
                        "id": 125498,
                        "name": "Royersford",
                        "latitude": "40.18427000",
                        "longitude": "-75.53796000"
                    },
                    {
                        "id": 125535,
                        "name": "Russell",
                        "latitude": "41.94145000",
                        "longitude": "-79.13505000"
                    },
                    {
                        "id": 125541,
                        "name": "Russellton",
                        "latitude": "40.61146000",
                        "longitude": "-79.83700000"
                    },
                    {
                        "id": 125550,
                        "name": "Rutherford",
                        "latitude": "40.26898000",
                        "longitude": "-76.76803000"
                    },
                    {
                        "id": 125620,
                        "name": "Saint Clair",
                        "latitude": "40.72065000",
                        "longitude": "-76.19105000"
                    },
                    {
                        "id": 125678,
                        "name": "Saint Lawrence",
                        "latitude": "40.32704000",
                        "longitude": "-75.87187000"
                    },
                    {
                        "id": 125694,
                        "name": "Saint Marys",
                        "latitude": "41.42784000",
                        "longitude": "-78.56086000"
                    },
                    {
                        "id": 125761,
                        "name": "Salix",
                        "latitude": "40.30008000",
                        "longitude": "-78.76530000"
                    },
                    {
                        "id": 125775,
                        "name": "Salunga",
                        "latitude": "40.10093000",
                        "longitude": "-76.42469000"
                    },
                    {
                        "id": 125852,
                        "name": "Sanatoga",
                        "latitude": "40.24510000",
                        "longitude": "-75.59518000"
                    },
                    {
                        "id": 125858,
                        "name": "Sand Hill",
                        "latitude": "40.35954000",
                        "longitude": "-76.43163000"
                    },
                    {
                        "id": 125879,
                        "name": "Sandy",
                        "latitude": "41.10784000",
                        "longitude": "-78.77114000"
                    },
                    {
                        "id": 125979,
                        "name": "Saw Creek",
                        "latitude": "41.11259000",
                        "longitude": "-75.05073000"
                    },
                    {
                        "id": 125985,
                        "name": "Saxonburg",
                        "latitude": "40.75395000",
                        "longitude": "-79.81005000"
                    },
                    {
                        "id": 125987,
                        "name": "Saylorsburg",
                        "latitude": "40.89565000",
                        "longitude": "-75.32352000"
                    },
                    {
                        "id": 125990,
                        "name": "Sayre",
                        "latitude": "41.97896000",
                        "longitude": "-76.51550000"
                    },
                    {
                        "id": 126010,
                        "name": "Schlusser",
                        "latitude": "40.24175000",
                        "longitude": "-77.17693000"
                    },
                    {
                        "id": 126011,
                        "name": "Schnecksville",
                        "latitude": "40.67514000",
                        "longitude": "-75.62044000"
                    },
                    {
                        "id": 126012,
                        "name": "Schoeneck",
                        "latitude": "40.24148000",
                        "longitude": "-76.17411000"
                    },
                    {
                        "id": 126026,
                        "name": "Schuylkill County",
                        "latitude": "40.70580000",
                        "longitude": "-76.21595000"
                    },
                    {
                        "id": 126027,
                        "name": "Schuylkill Haven",
                        "latitude": "40.63065000",
                        "longitude": "-76.17105000"
                    },
                    {
                        "id": 126028,
                        "name": "Schwenksville",
                        "latitude": "40.25621000",
                        "longitude": "-75.46379000"
                    },
                    {
                        "id": 126035,
                        "name": "Scotland",
                        "latitude": "39.96870000",
                        "longitude": "-77.58721000"
                    },
                    {
                        "id": 126056,
                        "name": "Scottdale",
                        "latitude": "40.10035000",
                        "longitude": "-79.58698000"
                    },
                    {
                        "id": 126067,
                        "name": "Scranton",
                        "latitude": "41.40916000",
                        "longitude": "-75.66490000"
                    },
                    {
                        "id": 126134,
                        "name": "Selinsgrove",
                        "latitude": "40.79897000",
                        "longitude": "-76.86219000"
                    },
                    {
                        "id": 126136,
                        "name": "Sellersville",
                        "latitude": "40.35399000",
                        "longitude": "-75.30490000"
                    },
                    {
                        "id": 126158,
                        "name": "Seneca",
                        "latitude": "41.37867000",
                        "longitude": "-79.70394000"
                    },
                    {
                        "id": 126172,
                        "name": "Seven Fields",
                        "latitude": "40.69173000",
                        "longitude": "-80.06256000"
                    },
                    {
                        "id": 126191,
                        "name": "Sewickley",
                        "latitude": "40.53646000",
                        "longitude": "-80.18450000"
                    },
                    {
                        "id": 126214,
                        "name": "Shamokin",
                        "latitude": "40.78897000",
                        "longitude": "-76.55885000"
                    },
                    {
                        "id": 126215,
                        "name": "Shamokin Dam",
                        "latitude": "40.84870000",
                        "longitude": "-76.81969000"
                    },
                    {
                        "id": 126223,
                        "name": "Shanor-Northvue",
                        "latitude": "40.91045000",
                        "longitude": "-79.91562000"
                    },
                    {
                        "id": 126229,
                        "name": "Sharon",
                        "latitude": "41.23311000",
                        "longitude": "-80.49340000"
                    },
                    {
                        "id": 126231,
                        "name": "Sharon Hill",
                        "latitude": "39.90650000",
                        "longitude": "-75.27157000"
                    },
                    {
                        "id": 126236,
                        "name": "Sharpsburg",
                        "latitude": "40.49451000",
                        "longitude": "-79.92644000"
                    },
                    {
                        "id": 126237,
                        "name": "Sharpsville",
                        "latitude": "41.25922000",
                        "longitude": "-80.47201000"
                    },
                    {
                        "id": 126243,
                        "name": "Shavertown",
                        "latitude": "41.31980000",
                        "longitude": "-75.93798000"
                    },
                    {
                        "id": 126261,
                        "name": "Sheffield",
                        "latitude": "41.70395000",
                        "longitude": "-79.03560000"
                    },
                    {
                        "id": 126304,
                        "name": "Shenandoah",
                        "latitude": "40.82037000",
                        "longitude": "-76.20077000"
                    },
                    {
                        "id": 126307,
                        "name": "Shenandoah Heights",
                        "latitude": "40.82759000",
                        "longitude": "-76.20688000"
                    },
                    {
                        "id": 126347,
                        "name": "Shillington",
                        "latitude": "40.30787000",
                        "longitude": "-75.96549000"
                    },
                    {
                        "id": 126349,
                        "name": "Shiloh",
                        "latitude": "39.97815000",
                        "longitude": "-76.79719000"
                    },
                    {
                        "id": 126352,
                        "name": "Shinglehouse",
                        "latitude": "41.96368000",
                        "longitude": "-78.19084000"
                    },
                    {
                        "id": 126357,
                        "name": "Shippensburg",
                        "latitude": "40.05065000",
                        "longitude": "-77.52026000"
                    },
                    {
                        "id": 126359,
                        "name": "Shiremanstown",
                        "latitude": "40.22342000",
                        "longitude": "-76.95359000"
                    },
                    {
                        "id": 126365,
                        "name": "Shoemakersville",
                        "latitude": "40.50093000",
                        "longitude": "-75.96993000"
                    },
                    {
                        "id": 126384,
                        "name": "Shrewsbury",
                        "latitude": "39.76871000",
                        "longitude": "-76.67969000"
                    },
                    {
                        "id": 126405,
                        "name": "Sierra View",
                        "latitude": "41.01207000",
                        "longitude": "-75.45900000"
                    },
                    {
                        "id": 126448,
                        "name": "Simpson",
                        "latitude": "41.59175000",
                        "longitude": "-75.48518000"
                    },
                    {
                        "id": 126455,
                        "name": "Sinking Spring",
                        "latitude": "40.32731000",
                        "longitude": "-76.01105000"
                    },
                    {
                        "id": 126481,
                        "name": "Skippack",
                        "latitude": "40.22288000",
                        "longitude": "-75.39879000"
                    },
                    {
                        "id": 126487,
                        "name": "Skyline View",
                        "latitude": "40.33926000",
                        "longitude": "-76.72553000"
                    },
                    {
                        "id": 126492,
                        "name": "Slatington",
                        "latitude": "40.74843000",
                        "longitude": "-75.61185000"
                    },
                    {
                        "id": 126503,
                        "name": "Slippery Rock",
                        "latitude": "41.06395000",
                        "longitude": "-80.05645000"
                    },
                    {
                        "id": 126509,
                        "name": "Smethport",
                        "latitude": "41.81117000",
                        "longitude": "-78.44474000"
                    },
                    {
                        "id": 126551,
                        "name": "Snyder County",
                        "latitude": "40.76984000",
                        "longitude": "-77.07019000"
                    },
                    {
                        "id": 126584,
                        "name": "Somerset",
                        "latitude": "40.00841000",
                        "longitude": "-79.07808000"
                    },
                    {
                        "id": 126589,
                        "name": "Somerset County",
                        "latitude": "39.97244000",
                        "longitude": "-79.02827000"
                    },
                    {
                        "id": 126607,
                        "name": "Souderton",
                        "latitude": "40.31177000",
                        "longitude": "-75.32518000"
                    },
                    {
                        "id": 126640,
                        "name": "South Coatesville",
                        "latitude": "39.97427000",
                        "longitude": "-75.81995000"
                    },
                    {
                        "id": 126642,
                        "name": "South Connellsville",
                        "latitude": "39.99674000",
                        "longitude": "-79.58587000"
                    },
                    {
                        "id": 126663,
                        "name": "South Greensburg",
                        "latitude": "40.27840000",
                        "longitude": "-79.54476000"
                    },
                    {
                        "id": 126704,
                        "name": "South Park Township",
                        "latitude": "40.29864000",
                        "longitude": "-79.99405000"
                    },
                    {
                        "id": 126715,
                        "name": "South Pottstown",
                        "latitude": "40.23954000",
                        "longitude": "-75.65102000"
                    },
                    {
                        "id": 126734,
                        "name": "South Temple",
                        "latitude": "40.40000000",
                        "longitude": "-75.90000000"
                    },
                    {
                        "id": 126738,
                        "name": "South Uniontown",
                        "latitude": "39.89285000",
                        "longitude": "-79.74699000"
                    },
                    {
                        "id": 126744,
                        "name": "South Waverly",
                        "latitude": "41.99757000",
                        "longitude": "-76.53717000"
                    },
                    {
                        "id": 126750,
                        "name": "South Williamsport",
                        "latitude": "41.23202000",
                        "longitude": "-76.99913000"
                    },
                    {
                        "id": 126780,
                        "name": "Southmont",
                        "latitude": "40.31063000",
                        "longitude": "-78.93864000"
                    },
                    {
                        "id": 126789,
                        "name": "Southwest Greensburg",
                        "latitude": "40.29118000",
                        "longitude": "-79.54698000"
                    },
                    {
                        "id": 126797,
                        "name": "Spangler",
                        "latitude": "40.64285000",
                        "longitude": "-78.77280000"
                    },
                    {
                        "id": 126819,
                        "name": "Speers",
                        "latitude": "40.12452000",
                        "longitude": "-79.87977000"
                    },
                    {
                        "id": 126837,
                        "name": "Spinnerstown",
                        "latitude": "40.43899000",
                        "longitude": "-75.43712000"
                    },
                    {
                        "id": 126852,
                        "name": "Spring City",
                        "latitude": "40.17677000",
                        "longitude": "-75.54769000"
                    },
                    {
                        "id": 126857,
                        "name": "Spring Grove",
                        "latitude": "39.87454000",
                        "longitude": "-76.86581000"
                    },
                    {
                        "id": 126864,
                        "name": "Spring House",
                        "latitude": "40.18539000",
                        "longitude": "-75.22768000"
                    },
                    {
                        "id": 126870,
                        "name": "Spring Mount",
                        "latitude": "40.27566000",
                        "longitude": "-75.45657000"
                    },
                    {
                        "id": 126873,
                        "name": "Spring Ridge",
                        "latitude": "40.35287000",
                        "longitude": "-75.98994000"
                    },
                    {
                        "id": 126887,
                        "name": "Springdale",
                        "latitude": "40.54090000",
                        "longitude": "-79.78394000"
                    },
                    {
                        "id": 126894,
                        "name": "Springfield",
                        "latitude": "39.93067000",
                        "longitude": "-75.32019000"
                    },
                    {
                        "id": 126920,
                        "name": "Spry",
                        "latitude": "39.91843000",
                        "longitude": "-76.68497000"
                    },
                    {
                        "id": 126992,
                        "name": "State College",
                        "latitude": "40.79339000",
                        "longitude": "-77.86000000"
                    },
                    {
                        "id": 126993,
                        "name": "State Line",
                        "latitude": "39.72482000",
                        "longitude": "-77.72444000"
                    },
                    {
                        "id": 127013,
                        "name": "Steelton",
                        "latitude": "40.23537000",
                        "longitude": "-76.84136000"
                    },
                    {
                        "id": 127053,
                        "name": "Stewartstown",
                        "latitude": "39.75371000",
                        "longitude": "-76.59136000"
                    },
                    {
                        "id": 127058,
                        "name": "Stiles",
                        "latitude": "40.66537000",
                        "longitude": "-75.50824000"
                    },
                    {
                        "id": 127086,
                        "name": "Stoneboro",
                        "latitude": "41.33922000",
                        "longitude": "-80.10506000"
                    },
                    {
                        "id": 127097,
                        "name": "Stony Creek Mills",
                        "latitude": "40.34565000",
                        "longitude": "-75.86993000"
                    },
                    {
                        "id": 127101,
                        "name": "Stonybrook",
                        "latitude": "39.98704000",
                        "longitude": "-76.64413000"
                    },
                    {
                        "id": 127104,
                        "name": "Stormstown",
                        "latitude": "40.79339000",
                        "longitude": "-78.01667000"
                    },
                    {
                        "id": 127113,
                        "name": "Stowe",
                        "latitude": "40.25260000",
                        "longitude": "-75.67741000"
                    },
                    {
                        "id": 127119,
                        "name": "Strasburg",
                        "latitude": "39.98316000",
                        "longitude": "-76.18412000"
                    },
                    {
                        "id": 127140,
                        "name": "Stroudsburg",
                        "latitude": "40.98676000",
                        "longitude": "-75.19462000"
                    },
                    {
                        "id": 127148,
                        "name": "Sturgeon",
                        "latitude": "40.38479000",
                        "longitude": "-80.21089000"
                    },
                    {
                        "id": 127174,
                        "name": "Sugarcreek",
                        "latitude": "41.42145000",
                        "longitude": "-79.88117000"
                    },
                    {
                        "id": 127191,
                        "name": "Sullivan County",
                        "latitude": "41.44616000",
                        "longitude": "-76.51214000"
                    },
                    {
                        "id": 127218,
                        "name": "Summit Hill",
                        "latitude": "40.82481000",
                        "longitude": "-75.87103000"
                    },
                    {
                        "id": 127239,
                        "name": "Sun Valley",
                        "latitude": "40.98203000",
                        "longitude": "-75.46602000"
                    },
                    {
                        "id": 127245,
                        "name": "Sunbury",
                        "latitude": "40.86259000",
                        "longitude": "-76.79441000"
                    },
                    {
                        "id": 127268,
                        "name": "Sunrise Lake",
                        "latitude": "41.30981000",
                        "longitude": "-74.96656000"
                    },
                    {
                        "id": 127297,
                        "name": "Susquehanna",
                        "latitude": "41.94341000",
                        "longitude": "-75.59963000"
                    },
                    {
                        "id": 127298,
                        "name": "Susquehanna County",
                        "latitude": "41.82133000",
                        "longitude": "-75.80068000"
                    },
                    {
                        "id": 127299,
                        "name": "Susquehanna Trails",
                        "latitude": "39.75872000",
                        "longitude": "-76.36802000"
                    },
                    {
                        "id": 127330,
                        "name": "Swarthmore",
                        "latitude": "39.90206000",
                        "longitude": "-75.34991000"
                    },
                    {
                        "id": 127333,
                        "name": "Swartzville",
                        "latitude": "40.23315000",
                        "longitude": "-76.07828000"
                    },
                    {
                        "id": 127348,
                        "name": "Swissvale",
                        "latitude": "40.42368000",
                        "longitude": "-79.88283000"
                    },
                    {
                        "id": 127350,
                        "name": "Swoyersville",
                        "latitude": "41.29175000",
                        "longitude": "-75.87464000"
                    },
                    {
                        "id": 127353,
                        "name": "Sykesville",
                        "latitude": "41.05034000",
                        "longitude": "-78.82225000"
                    },
                    {
                        "id": 127370,
                        "name": "Tacony",
                        "latitude": "40.03122000",
                        "longitude": "-75.04434000"
                    },
                    {
                        "id": 127404,
                        "name": "Tamaqua",
                        "latitude": "40.79731000",
                        "longitude": "-75.96937000"
                    },
                    {
                        "id": 127419,
                        "name": "Tannersville",
                        "latitude": "41.04009000",
                        "longitude": "-75.30574000"
                    },
                    {
                        "id": 127429,
                        "name": "Tarentum",
                        "latitude": "40.60146000",
                        "longitude": "-79.75977000"
                    },
                    {
                        "id": 127437,
                        "name": "Tatamy",
                        "latitude": "40.74093000",
                        "longitude": "-75.25712000"
                    },
                    {
                        "id": 127449,
                        "name": "Taylor",
                        "latitude": "41.39480000",
                        "longitude": "-75.70658000"
                    },
                    {
                        "id": 127487,
                        "name": "Telford",
                        "latitude": "40.32205000",
                        "longitude": "-75.32795000"
                    },
                    {
                        "id": 127500,
                        "name": "Temple",
                        "latitude": "40.40870000",
                        "longitude": "-75.92160000"
                    },
                    {
                        "id": 127522,
                        "name": "Terre Hill",
                        "latitude": "40.15732000",
                        "longitude": "-76.05050000"
                    },
                    {
                        "id": 127560,
                        "name": "The Hideout",
                        "latitude": "41.42736000",
                        "longitude": "-75.35255000"
                    },
                    {
                        "id": 127595,
                        "name": "Thompsonville",
                        "latitude": "40.29090000",
                        "longitude": "-80.10811000"
                    },
                    {
                        "id": 127599,
                        "name": "Thorndale",
                        "latitude": "39.99288000",
                        "longitude": "-75.74522000"
                    },
                    {
                        "id": 127626,
                        "name": "Throop",
                        "latitude": "41.45147000",
                        "longitude": "-75.61185000"
                    },
                    {
                        "id": 127665,
                        "name": "Tinicum",
                        "latitude": "40.44844000",
                        "longitude": "-75.10767000"
                    },
                    {
                        "id": 127670,
                        "name": "Tioga County",
                        "latitude": "41.77216000",
                        "longitude": "-77.25426000"
                    },
                    {
                        "id": 127671,
                        "name": "Tionesta",
                        "latitude": "41.49534000",
                        "longitude": "-79.45588000"
                    },
                    {
                        "id": 127677,
                        "name": "Tipton",
                        "latitude": "40.63590000",
                        "longitude": "-78.29585000"
                    },
                    {
                        "id": 127686,
                        "name": "Titusville",
                        "latitude": "41.62700000",
                        "longitude": "-79.67366000"
                    },
                    {
                        "id": 127696,
                        "name": "Toftrees",
                        "latitude": "40.82604000",
                        "longitude": "-77.88110000"
                    },
                    {
                        "id": 127737,
                        "name": "Topton",
                        "latitude": "40.50343000",
                        "longitude": "-75.70130000"
                    },
                    {
                        "id": 127748,
                        "name": "Toughkenamon",
                        "latitude": "39.83150000",
                        "longitude": "-75.75744000"
                    },
                    {
                        "id": 127750,
                        "name": "Towamensing Trails",
                        "latitude": "41.00787000",
                        "longitude": "-75.58463000"
                    },
                    {
                        "id": 127752,
                        "name": "Towanda",
                        "latitude": "41.76758000",
                        "longitude": "-76.44272000"
                    },
                    {
                        "id": 127754,
                        "name": "Tower City",
                        "latitude": "40.58925000",
                        "longitude": "-76.55246000"
                    },
                    {
                        "id": 127776,
                        "name": "Trafford",
                        "latitude": "40.38562000",
                        "longitude": "-79.75893000"
                    },
                    {
                        "id": 127779,
                        "name": "Trainer",
                        "latitude": "39.82761000",
                        "longitude": "-75.41436000"
                    },
                    {
                        "id": 127782,
                        "name": "Trappe",
                        "latitude": "40.19899000",
                        "longitude": "-75.47629000"
                    },
                    {
                        "id": 127791,
                        "name": "Treasure Lake",
                        "latitude": "41.17339000",
                        "longitude": "-78.71586000"
                    },
                    {
                        "id": 127796,
                        "name": "Tremont",
                        "latitude": "40.62842000",
                        "longitude": "-76.38718000"
                    },
                    {
                        "id": 127813,
                        "name": "Trevorton",
                        "latitude": "40.78120000",
                        "longitude": "-76.67302000"
                    },
                    {
                        "id": 127814,
                        "name": "Trevose",
                        "latitude": "40.13928000",
                        "longitude": "-74.98100000"
                    },
                    {
                        "id": 127815,
                        "name": "Trexlertown",
                        "latitude": "40.54815000",
                        "longitude": "-75.60574000"
                    },
                    {
                        "id": 127833,
                        "name": "Trooper",
                        "latitude": "40.14983000",
                        "longitude": "-75.40185000"
                    },
                    {
                        "id": 127852,
                        "name": "Troy",
                        "latitude": "41.78591000",
                        "longitude": "-76.78801000"
                    },
                    {
                        "id": 127854,
                        "name": "Trucksville",
                        "latitude": "41.30397000",
                        "longitude": "-75.93214000"
                    },
                    {
                        "id": 127887,
                        "name": "Tullytown",
                        "latitude": "40.13928000",
                        "longitude": "-74.81461000"
                    },
                    {
                        "id": 127894,
                        "name": "Tunkhannock",
                        "latitude": "41.53869000",
                        "longitude": "-75.94659000"
                    },
                    {
                        "id": 127907,
                        "name": "Turtle Creek",
                        "latitude": "40.40590000",
                        "longitude": "-79.82505000"
                    },
                    {
                        "id": 127950,
                        "name": "Tyrone",
                        "latitude": "40.67062000",
                        "longitude": "-78.23862000"
                    },
                    {
                        "id": 127986,
                        "name": "Union City",
                        "latitude": "41.89950000",
                        "longitude": "-79.84533000"
                    },
                    {
                        "id": 128000,
                        "name": "Union County",
                        "latitude": "40.96297000",
                        "longitude": "-77.06225000"
                    },
                    {
                        "id": 128016,
                        "name": "Uniontown",
                        "latitude": "39.90008000",
                        "longitude": "-79.71643000"
                    },
                    {
                        "id": 128037,
                        "name": "Upland",
                        "latitude": "39.85261000",
                        "longitude": "-75.38269000"
                    },
                    {
                        "id": 128051,
                        "name": "Upper Saint Clair",
                        "latitude": "40.33590000",
                        "longitude": "-80.08339000"
                    },
                    {
                        "id": 128111,
                        "name": "Valley Green",
                        "latitude": "40.15731000",
                        "longitude": "-76.79275000"
                    },
                    {
                        "id": 128118,
                        "name": "Valley View",
                        "latitude": "39.95010000",
                        "longitude": "-76.70108000"
                    },
                    {
                        "id": 128152,
                        "name": "Vandergrift",
                        "latitude": "40.60284000",
                        "longitude": "-79.56477000"
                    },
                    {
                        "id": 128166,
                        "name": "Venango County",
                        "latitude": "41.40097000",
                        "longitude": "-79.75795000"
                    },
                    {
                        "id": 128204,
                        "name": "Verona",
                        "latitude": "40.50646000",
                        "longitude": "-79.84310000"
                    },
                    {
                        "id": 128211,
                        "name": "Versailles",
                        "latitude": "40.31563000",
                        "longitude": "-79.83116000"
                    },
                    {
                        "id": 128248,
                        "name": "Village Green-Green Ridge",
                        "latitude": "39.86363000",
                        "longitude": "-75.42548000"
                    },
                    {
                        "id": 128251,
                        "name": "Village Shires",
                        "latitude": "40.20316000",
                        "longitude": "-74.97045000"
                    },
                    {
                        "id": 128267,
                        "name": "Vinco",
                        "latitude": "40.40507000",
                        "longitude": "-78.85558000"
                    },
                    {
                        "id": 128402,
                        "name": "Wallenpaupack Lake Estates",
                        "latitude": "41.39898000",
                        "longitude": "-75.27402000"
                    },
                    {
                        "id": 128424,
                        "name": "Walnutport",
                        "latitude": "40.75426000",
                        "longitude": "-75.59880000"
                    },
                    {
                        "id": 128472,
                        "name": "Warminster Heights",
                        "latitude": "40.18705000",
                        "longitude": "-75.08156000"
                    },
                    {
                        "id": 128483,
                        "name": "Warren",
                        "latitude": "41.84395000",
                        "longitude": "-79.14504000"
                    },
                    {
                        "id": 128498,
                        "name": "Warren County",
                        "latitude": "41.81457000",
                        "longitude": "-79.27414000"
                    },
                    {
                        "id": 128549,
                        "name": "Washington",
                        "latitude": "40.17396000",
                        "longitude": "-80.24617000"
                    },
                    {
                        "id": 128573,
                        "name": "Washington County",
                        "latitude": "40.18940000",
                        "longitude": "-80.24824000"
                    },
                    {
                        "id": 128607,
                        "name": "Waterford",
                        "latitude": "41.94283000",
                        "longitude": "-79.98450000"
                    },
                    {
                        "id": 128640,
                        "name": "Watsontown",
                        "latitude": "41.08453000",
                        "longitude": "-76.86385000"
                    },
                    {
                        "id": 128680,
                        "name": "Waymart",
                        "latitude": "41.58036000",
                        "longitude": "-75.40824000"
                    },
                    {
                        "id": 128687,
                        "name": "Wayne",
                        "latitude": "40.04400000",
                        "longitude": "-75.38769000"
                    },
                    {
                        "id": 128702,
                        "name": "Wayne County",
                        "latitude": "41.64873000",
                        "longitude": "-75.30326000"
                    },
                    {
                        "id": 128704,
                        "name": "Wayne Heights",
                        "latitude": "39.74371000",
                        "longitude": "-77.55388000"
                    },
                    {
                        "id": 128707,
                        "name": "Waynesboro",
                        "latitude": "39.75593000",
                        "longitude": "-77.57777000"
                    },
                    {
                        "id": 128710,
                        "name": "Waynesburg",
                        "latitude": "39.89646000",
                        "longitude": "-80.17923000"
                    },
                    {
                        "id": 128719,
                        "name": "Weatherly",
                        "latitude": "40.94175000",
                        "longitude": "-75.82964000"
                    },
                    {
                        "id": 128757,
                        "name": "Weigelstown",
                        "latitude": "39.98371000",
                        "longitude": "-76.82247000"
                    },
                    {
                        "id": 128762,
                        "name": "Weissport East",
                        "latitude": "40.83697000",
                        "longitude": "-75.68643000"
                    },
                    {
                        "id": 128788,
                        "name": "Wellsboro",
                        "latitude": "41.74868000",
                        "longitude": "-77.30053000"
                    },
                    {
                        "id": 128806,
                        "name": "Wernersville",
                        "latitude": "40.33009000",
                        "longitude": "-76.08050000"
                    },
                    {
                        "id": 128807,
                        "name": "Wescosville",
                        "latitude": "40.56676000",
                        "longitude": "-75.55296000"
                    },
                    {
                        "id": 128812,
                        "name": "Wesleyville",
                        "latitude": "42.14033000",
                        "longitude": "-80.01506000"
                    },
                    {
                        "id": 128845,
                        "name": "West Chester",
                        "latitude": "39.96097000",
                        "longitude": "-75.60804000"
                    },
                    {
                        "id": 128851,
                        "name": "West Conshohocken",
                        "latitude": "40.06983000",
                        "longitude": "-75.31630000"
                    },
                    {
                        "id": 128859,
                        "name": "West Easton",
                        "latitude": "40.67871000",
                        "longitude": "-75.23684000"
                    },
                    {
                        "id": 128866,
                        "name": "West Fairview",
                        "latitude": "40.27509000",
                        "longitude": "-76.91553000"
                    },
                    {
                        "id": 128881,
                        "name": "West Grove",
                        "latitude": "39.82205000",
                        "longitude": "-75.82744000"
                    },
                    {
                        "id": 128883,
                        "name": "West Hamburg",
                        "latitude": "40.54759000",
                        "longitude": "-76.00216000"
                    },
                    {
                        "id": 128892,
                        "name": "West Hazleton",
                        "latitude": "40.95870000",
                        "longitude": "-75.99604000"
                    },
                    {
                        "id": 128896,
                        "name": "West Hills",
                        "latitude": "40.82423000",
                        "longitude": "-79.54310000"
                    },
                    {
                        "id": 128900,
                        "name": "West Homestead",
                        "latitude": "40.39396000",
                        "longitude": "-79.91199000"
                    },
                    {
                        "id": 128907,
                        "name": "West Kittanning",
                        "latitude": "40.81034000",
                        "longitude": "-79.52949000"
                    },
                    {
                        "id": 128914,
                        "name": "West Lawn",
                        "latitude": "40.32981000",
                        "longitude": "-75.99438000"
                    },
                    {
                        "id": 128915,
                        "name": "West Leechburg",
                        "latitude": "40.62229000",
                        "longitude": "-79.61282000"
                    },
                    {
                        "id": 128926,
                        "name": "West Mayfield",
                        "latitude": "40.78006000",
                        "longitude": "-80.33840000"
                    },
                    {
                        "id": 128931,
                        "name": "West Mifflin",
                        "latitude": "40.36340000",
                        "longitude": "-79.86644000"
                    },
                    {
                        "id": 128940,
                        "name": "West Newton",
                        "latitude": "40.20979000",
                        "longitude": "-79.76699000"
                    },
                    {
                        "id": 128941,
                        "name": "West Norriton",
                        "latitude": "40.12955000",
                        "longitude": "-75.37852000"
                    },
                    {
                        "id": 128955,
                        "name": "West Pittston",
                        "latitude": "41.32758000",
                        "longitude": "-75.79297000"
                    },
                    {
                        "id": 128967,
                        "name": "West Reading",
                        "latitude": "40.33370000",
                        "longitude": "-75.94743000"
                    },
                    {
                        "id": 128999,
                        "name": "West View",
                        "latitude": "40.52229000",
                        "longitude": "-80.03422000"
                    },
                    {
                        "id": 129006,
                        "name": "West Wyoming",
                        "latitude": "41.31980000",
                        "longitude": "-75.84603000"
                    },
                    {
                        "id": 129007,
                        "name": "West Wyomissing",
                        "latitude": "40.32454000",
                        "longitude": "-75.99077000"
                    },
                    {
                        "id": 129010,
                        "name": "West York",
                        "latitude": "39.95260000",
                        "longitude": "-76.75136000"
                    },
                    {
                        "id": 129031,
                        "name": "Westfield",
                        "latitude": "41.91924000",
                        "longitude": "-77.53887000"
                    },
                    {
                        "id": 129050,
                        "name": "Westmont",
                        "latitude": "40.31563000",
                        "longitude": "-78.95169000"
                    },
                    {
                        "id": 129056,
                        "name": "Westmoreland County",
                        "latitude": "40.31073000",
                        "longitude": "-79.46696000"
                    },
                    {
                        "id": 129101,
                        "name": "Wharton",
                        "latitude": "39.92678000",
                        "longitude": "-75.15712000"
                    },
                    {
                        "id": 129125,
                        "name": "Whitaker",
                        "latitude": "40.39840000",
                        "longitude": "-79.88977000"
                    },
                    {
                        "id": 129141,
                        "name": "White Haven",
                        "latitude": "41.06064000",
                        "longitude": "-75.77408000"
                    },
                    {
                        "id": 129150,
                        "name": "White Oak",
                        "latitude": "40.33757000",
                        "longitude": "-79.80921000"
                    },
                    {
                        "id": 129170,
                        "name": "Whitehall",
                        "latitude": "40.36118000",
                        "longitude": "-79.99089000"
                    },
                    {
                        "id": 129173,
                        "name": "Whitehall Township",
                        "latitude": "40.66676000",
                        "longitude": "-75.49991000"
                    },
                    {
                        "id": 129194,
                        "name": "Whitfield",
                        "latitude": "40.33593000",
                        "longitude": "-76.00605000"
                    },
                    {
                        "id": 129202,
                        "name": "Whitman",
                        "latitude": "39.91678000",
                        "longitude": "-75.15546000"
                    },
                    {
                        "id": 129220,
                        "name": "Wickerham Manor-Fisher",
                        "latitude": "40.17749000",
                        "longitude": "-79.90684000"
                    },
                    {
                        "id": 129246,
                        "name": "Wilkes-Barre",
                        "latitude": "41.24591000",
                        "longitude": "-75.88131000"
                    },
                    {
                        "id": 129249,
                        "name": "Wilkinsburg",
                        "latitude": "40.44174000",
                        "longitude": "-79.88199000"
                    },
                    {
                        "id": 129271,
                        "name": "Williamsburg",
                        "latitude": "40.46202000",
                        "longitude": "-78.19973000"
                    },
                    {
                        "id": 129281,
                        "name": "Williamsport",
                        "latitude": "41.24119000",
                        "longitude": "-77.00108000"
                    },
                    {
                        "id": 129290,
                        "name": "Williamstown",
                        "latitude": "40.58009000",
                        "longitude": "-76.61774000"
                    },
                    {
                        "id": 129306,
                        "name": "Willow Grove",
                        "latitude": "40.14400000",
                        "longitude": "-75.11573000"
                    },
                    {
                        "id": 129311,
                        "name": "Willow Street",
                        "latitude": "39.97927000",
                        "longitude": "-76.27635000"
                    },
                    {
                        "id": 129319,
                        "name": "Wilmerding",
                        "latitude": "40.39090000",
                        "longitude": "-79.81005000"
                    },
                    {
                        "id": 129332,
                        "name": "Wilson",
                        "latitude": "40.68399000",
                        "longitude": "-75.24184000"
                    },
                    {
                        "id": 129363,
                        "name": "Wind Gap",
                        "latitude": "40.84815000",
                        "longitude": "-75.29157000"
                    },
                    {
                        "id": 129366,
                        "name": "Windber",
                        "latitude": "40.23980000",
                        "longitude": "-78.83502000"
                    },
                    {
                        "id": 129380,
                        "name": "Windsor",
                        "latitude": "39.91621000",
                        "longitude": "-76.58441000"
                    },
                    {
                        "id": 129475,
                        "name": "Wolfdale",
                        "latitude": "40.19285000",
                        "longitude": "-80.28784000"
                    },
                    {
                        "id": 129482,
                        "name": "Womelsdorf",
                        "latitude": "40.36176000",
                        "longitude": "-76.18411000"
                    },
                    {
                        "id": 129497,
                        "name": "Woodbourne",
                        "latitude": "40.19233000",
                        "longitude": "-74.88878000"
                    },
                    {
                        "id": 129529,
                        "name": "Woodland Heights",
                        "latitude": "41.40978000",
                        "longitude": "-79.71172000"
                    },
                    {
                        "id": 129539,
                        "name": "Woodlyn",
                        "latitude": "39.87233000",
                        "longitude": "-75.33713000"
                    },
                    {
                        "id": 129555,
                        "name": "Woodside",
                        "latitude": "40.22178000",
                        "longitude": "-74.87544000"
                    },
                    {
                        "id": 129590,
                        "name": "Wormleysburg",
                        "latitude": "40.26287000",
                        "longitude": "-76.91386000"
                    },
                    {
                        "id": 129600,
                        "name": "Woxall",
                        "latitude": "40.31066000",
                        "longitude": "-75.44879000"
                    },
                    {
                        "id": 129615,
                        "name": "Wrightsville",
                        "latitude": "40.02565000",
                        "longitude": "-76.52997000"
                    },
                    {
                        "id": 129629,
                        "name": "Wyncote",
                        "latitude": "40.09455000",
                        "longitude": "-75.14879000"
                    },
                    {
                        "id": 129631,
                        "name": "Wyndmoor",
                        "latitude": "40.08122000",
                        "longitude": "-75.18934000"
                    },
                    {
                        "id": 129638,
                        "name": "Wyoming",
                        "latitude": "41.31175000",
                        "longitude": "-75.83742000"
                    },
                    {
                        "id": 129641,
                        "name": "Wyoming County",
                        "latitude": "41.51833000",
                        "longitude": "-76.01655000"
                    },
                    {
                        "id": 129642,
                        "name": "Wyomissing",
                        "latitude": "40.32954000",
                        "longitude": "-75.96521000"
                    },
                    {
                        "id": 129643,
                        "name": "Wyomissing Hills",
                        "latitude": "40.33759000",
                        "longitude": "-75.97966000"
                    },
                    {
                        "id": 129664,
                        "name": "Yardley",
                        "latitude": "40.24566000",
                        "longitude": "-74.84600000"
                    },
                    {
                        "id": 129675,
                        "name": "Yeadon",
                        "latitude": "39.93900000",
                        "longitude": "-75.25546000"
                    },
                    {
                        "id": 129676,
                        "name": "Yeagertown",
                        "latitude": "40.64313000",
                        "longitude": "-77.58055000"
                    },
                    {
                        "id": 129685,
                        "name": "Yoe",
                        "latitude": "39.90899000",
                        "longitude": "-76.63691000"
                    },
                    {
                        "id": 129692,
                        "name": "York",
                        "latitude": "39.96260000",
                        "longitude": "-76.72774000"
                    },
                    {
                        "id": 129699,
                        "name": "York County",
                        "latitude": "39.91996000",
                        "longitude": "-76.72651000"
                    },
                    {
                        "id": 129702,
                        "name": "Yorklyn",
                        "latitude": "39.99232000",
                        "longitude": "-76.64635000"
                    },
                    {
                        "id": 129720,
                        "name": "Youngsville",
                        "latitude": "41.85228000",
                        "longitude": "-79.31866000"
                    },
                    {
                        "id": 129722,
                        "name": "Youngwood",
                        "latitude": "40.24035000",
                        "longitude": "-79.57671000"
                    },
                    {
                        "id": 129746,
                        "name": "Zelienople",
                        "latitude": "40.79451000",
                        "longitude": "-80.13673000"
                    },
                    {
                        "id": 129758,
                        "name": "Zion",
                        "latitude": "40.91423000",
                        "longitude": "-77.68472000"
                    }
                ]
            },
            {
                "id": 1449,
                "name": "Puerto Rico",
                "iso2": "PR",
                "latitude": "18.22083300",
                "longitude": "-66.59014900",
                "type": "outlying area",
                "cities": [
                    {
                        "id": 142982,
                        "name": "Adjuntas",
                        "latitude": "18.16277778",
                        "longitude": "-66.72222222"
                    },
                    {
                        "id": 142983,
                        "name": "Aguada",
                        "latitude": "18.37944444",
                        "longitude": "-67.18833333"
                    },
                    {
                        "id": 142984,
                        "name": "Aguadilla",
                        "latitude": "18.42745000",
                        "longitude": "-67.15407000"
                    },
                    {
                        "id": 142985,
                        "name": "Aguas Buenas",
                        "latitude": "18.25694400",
                        "longitude": "-66.10305600"
                    },
                    {
                        "id": 142986,
                        "name": "Aguas Claras",
                        "latitude": "18.24417000",
                        "longitude": "-65.66278000"
                    },
                    {
                        "id": 142987,
                        "name": "Aguilita",
                        "latitude": "18.02333333",
                        "longitude": "-66.53472222"
                    },
                    {
                        "id": 142988,
                        "name": "Aibonito",
                        "latitude": "18.14000000",
                        "longitude": "-66.26611100"
                    },
                    {
                        "id": 142993,
                        "name": "Añasco",
                        "latitude": "18.31611111",
                        "longitude": "-67.13972222"
                    },
                    {
                        "id": 142989,
                        "name": "Animas",
                        "latitude": "18.44555556",
                        "longitude": "-66.63500000"
                    },
                    {
                        "id": 142990,
                        "name": "Antón Ruiz",
                        "latitude": "18.18527778",
                        "longitude": "-65.80861111"
                    },
                    {
                        "id": 142991,
                        "name": "Arecibo",
                        "latitude": "18.47055556",
                        "longitude": "-66.72083333"
                    },
                    {
                        "id": 142992,
                        "name": "Arroyo",
                        "latitude": "17.96583300",
                        "longitude": "-66.06138900"
                    },
                    {
                        "id": 142994,
                        "name": "Bairoa",
                        "latitude": "18.25916667",
                        "longitude": "-66.04055556"
                    },
                    {
                        "id": 142995,
                        "name": "Bajadero",
                        "latitude": "18.42666667",
                        "longitude": "-66.68333333"
                    },
                    {
                        "id": 142996,
                        "name": "Bajandas",
                        "latitude": "18.16278000",
                        "longitude": "-65.78167000"
                    },
                    {
                        "id": 142997,
                        "name": "Barahona",
                        "latitude": "18.35138889",
                        "longitude": "-66.44555556"
                    },
                    {
                        "id": 142998,
                        "name": "Barceloneta",
                        "latitude": "18.45633000",
                        "longitude": "-66.54128000"
                    },
                    {
                        "id": 142999,
                        "name": "Barranquitas",
                        "latitude": "18.20357000",
                        "longitude": "-66.31211000"
                    },
                    {
                        "id": 143000,
                        "name": "Bartolo",
                        "latitude": "18.36138889",
                        "longitude": "-65.83861111"
                    },
                    {
                        "id": 143001,
                        "name": "Bayamon",
                        "latitude": "18.17777778",
                        "longitude": "-66.11333333"
                    },
                    {
                        "id": 143002,
                        "name": "Benitez",
                        "latitude": "18.27361111",
                        "longitude": "-65.87916667"
                    },
                    {
                        "id": 143003,
                        "name": "Betances",
                        "latitude": "18.02861111",
                        "longitude": "-67.13500000"
                    },
                    {
                        "id": 143004,
                        "name": "Boqueron",
                        "latitude": "18.20750000",
                        "longitude": "-65.84861111"
                    },
                    {
                        "id": 143005,
                        "name": "Boquerón Cabo Rojo",
                        "latitude": "18.02691000",
                        "longitude": "-67.16907000"
                    },
                    {
                        "id": 143006,
                        "name": "Brenas",
                        "latitude": "18.46722222",
                        "longitude": "-66.34111111"
                    },
                    {
                        "id": 143007,
                        "name": "Buena Vista",
                        "latitude": "17.99638889",
                        "longitude": "-66.05194444"
                    },
                    {
                        "id": 143008,
                        "name": "Bufalo",
                        "latitude": "18.41833333",
                        "longitude": "-66.57333333"
                    },
                    {
                        "id": 143009,
                        "name": "Caban",
                        "latitude": "18.44333333",
                        "longitude": "-67.13611111"
                    },
                    {
                        "id": 143010,
                        "name": "Cabo Rojo",
                        "latitude": "18.08666667",
                        "longitude": "-67.14583333"
                    },
                    {
                        "id": 143011,
                        "name": "Cabo Rojo Municipio",
                        "latitude": "18.05635000",
                        "longitude": "-67.14685000"
                    },
                    {
                        "id": 143012,
                        "name": "Cacao",
                        "latitude": "18.44028000",
                        "longitude": "-66.93861000"
                    },
                    {
                        "id": 143013,
                        "name": "Caguas",
                        "latitude": "18.23333333",
                        "longitude": "-66.03333333"
                    },
                    {
                        "id": 143014,
                        "name": "Campanilla",
                        "latitude": "18.42138889",
                        "longitude": "-66.23694444"
                    },
                    {
                        "id": 143015,
                        "name": "Campo Rico",
                        "latitude": "18.33722222",
                        "longitude": "-65.89805556"
                    },
                    {
                        "id": 143016,
                        "name": "Camuy",
                        "latitude": "18.48388900",
                        "longitude": "-66.84500000"
                    },
                    {
                        "id": 143017,
                        "name": "Candelaria",
                        "latitude": "18.40416667",
                        "longitude": "-66.20888889"
                    },
                    {
                        "id": 143018,
                        "name": "Candelaria Arenas",
                        "latitude": "18.41722222",
                        "longitude": "-66.21750000"
                    },
                    {
                        "id": 143019,
                        "name": "Candelero Arriba",
                        "latitude": "18.10560000",
                        "longitude": "-65.83420000"
                    },
                    {
                        "id": 143020,
                        "name": "Canóvanas",
                        "latitude": "18.37916700",
                        "longitude": "-65.90138900"
                    },
                    {
                        "id": 143021,
                        "name": "Capitanejo",
                        "latitude": "18.01454000",
                        "longitude": "-66.53372000"
                    },
                    {
                        "id": 143022,
                        "name": "Carolina",
                        "latitude": "18.38888889",
                        "longitude": "-65.96666667"
                    },
                    {
                        "id": 143023,
                        "name": "Carrizales",
                        "latitude": "18.48194444",
                        "longitude": "-66.79000000"
                    },
                    {
                        "id": 143024,
                        "name": "Cataño",
                        "latitude": "18.44134000",
                        "longitude": "-66.11822000"
                    },
                    {
                        "id": 143025,
                        "name": "Cayey",
                        "latitude": "18.11500000",
                        "longitude": "-66.16139000"
                    },
                    {
                        "id": 143026,
                        "name": "Cayuco",
                        "latitude": "18.29194000",
                        "longitude": "-66.73528000"
                    },
                    {
                        "id": 143027,
                        "name": "Ceiba",
                        "latitude": "18.44638889",
                        "longitude": "-66.35083333"
                    },
                    {
                        "id": 143028,
                        "name": "Ceiba Municipio",
                        "latitude": "18.26051000",
                        "longitude": "-65.67183000"
                    },
                    {
                        "id": 143029,
                        "name": "Celada",
                        "latitude": "18.27166667",
                        "longitude": "-65.96611111"
                    },
                    {
                        "id": 143030,
                        "name": "Central Aguirre",
                        "latitude": "17.95472000",
                        "longitude": "-66.22611000"
                    },
                    {
                        "id": 143031,
                        "name": "Ciales",
                        "latitude": "18.33611100",
                        "longitude": "-66.46888900"
                    },
                    {
                        "id": 143032,
                        "name": "Ciales Municipio",
                        "latitude": "18.29162000",
                        "longitude": "-66.51628000"
                    },
                    {
                        "id": 143033,
                        "name": "Cidra",
                        "latitude": "18.17583333",
                        "longitude": "-66.16138889"
                    },
                    {
                        "id": 143034,
                        "name": "Coamo",
                        "latitude": "18.08000000",
                        "longitude": "-66.35805556"
                    },
                    {
                        "id": 143035,
                        "name": "Coco",
                        "latitude": "18.00722222",
                        "longitude": "-66.25944444"
                    },
                    {
                        "id": 143036,
                        "name": "Comerío",
                        "latitude": "18.21801000",
                        "longitude": "-66.22600000"
                    },
                    {
                        "id": 143037,
                        "name": "Comerío Municipio",
                        "latitude": "18.22718000",
                        "longitude": "-66.22183000"
                    },
                    {
                        "id": 143038,
                        "name": "Comunas",
                        "latitude": "18.08722222",
                        "longitude": "-65.84388889"
                    },
                    {
                        "id": 143039,
                        "name": "Coquí",
                        "latitude": "17.97416667",
                        "longitude": "-66.22722222"
                    },
                    {
                        "id": 143040,
                        "name": "Corazón",
                        "latitude": "17.99277778",
                        "longitude": "-66.08500000"
                    },
                    {
                        "id": 143041,
                        "name": "Corcovado",
                        "latitude": "18.45861111",
                        "longitude": "-66.77638889"
                    },
                    {
                        "id": 143042,
                        "name": "Corozal",
                        "latitude": "18.34166667",
                        "longitude": "-66.31694444"
                    },
                    {
                        "id": 143043,
                        "name": "Corozal Municipio",
                        "latitude": "18.30912000",
                        "longitude": "-66.32600000"
                    },
                    {
                        "id": 143044,
                        "name": "Coto Laurel",
                        "latitude": "18.04969000",
                        "longitude": "-66.55128000"
                    },
                    {
                        "id": 143045,
                        "name": "Coto Norte",
                        "latitude": "18.43078000",
                        "longitude": "-66.43989000"
                    },
                    {
                        "id": 143046,
                        "name": "Culebra",
                        "latitude": "18.31666667",
                        "longitude": "-65.29027778"
                    },
                    {
                        "id": 143047,
                        "name": "Culebra barrio-pueblo",
                        "latitude": "18.30646950",
                        "longitude": "-65.30258000"
                    },
                    {
                        "id": 143048,
                        "name": "Daguao",
                        "latitude": "18.22638889",
                        "longitude": "-65.68333333"
                    },
                    {
                        "id": 143049,
                        "name": "Dorado",
                        "latitude": "18.45888900",
                        "longitude": "-66.26777800"
                    },
                    {
                        "id": 143050,
                        "name": "Dorado Municipio",
                        "latitude": "18.43967000",
                        "longitude": "-66.28295000"
                    },
                    {
                        "id": 143051,
                        "name": "El Mangó",
                        "latitude": "18.23416667",
                        "longitude": "-65.87972222"
                    },
                    {
                        "id": 143052,
                        "name": "El Negro",
                        "latitude": "18.03750000",
                        "longitude": "-65.85138889"
                    },
                    {
                        "id": 143053,
                        "name": "El Ojo",
                        "latitude": "18.00388889",
                        "longitude": "-66.39166667"
                    },
                    {
                        "id": 143054,
                        "name": "Emajagua",
                        "latitude": "18.00055556",
                        "longitude": "-65.88277778"
                    },
                    {
                        "id": 143055,
                        "name": "Esperanza",
                        "latitude": "18.09722222",
                        "longitude": "-65.47083333"
                    },
                    {
                        "id": 143056,
                        "name": "Espino",
                        "latitude": "18.27638889",
                        "longitude": "-67.11944444"
                    },
                    {
                        "id": 143057,
                        "name": "Estancias de Florida",
                        "latitude": "18.36666667",
                        "longitude": "-66.56972222"
                    },
                    {
                        "id": 143058,
                        "name": "Fajardo",
                        "latitude": "18.32579000",
                        "longitude": "-65.65238000"
                    },
                    {
                        "id": 143059,
                        "name": "Fajardo Municipio",
                        "latitude": "18.31051000",
                        "longitude": "-65.67600000"
                    },
                    {
                        "id": 143060,
                        "name": "Florida",
                        "latitude": "18.36495300",
                        "longitude": "-66.56616100"
                    },
                    {
                        "id": 143061,
                        "name": "Franquez",
                        "latitude": "18.34027778",
                        "longitude": "-66.42777778"
                    },
                    {
                        "id": 143062,
                        "name": "Fuig",
                        "latitude": "17.98777778",
                        "longitude": "-66.91611111"
                    },
                    {
                        "id": 143063,
                        "name": "G. L. Garcia",
                        "latitude": "18.12750000",
                        "longitude": "-66.10416667"
                    },
                    {
                        "id": 143064,
                        "name": "Galateo",
                        "latitude": "18.36250000",
                        "longitude": "-66.25888889"
                    },
                    {
                        "id": 143065,
                        "name": "Garrochales",
                        "latitude": "18.45361111",
                        "longitude": "-66.56638889"
                    },
                    {
                        "id": 143073,
                        "name": "Guánica",
                        "latitude": "17.97166667",
                        "longitude": "-66.90805556"
                    },
                    {
                        "id": 143074,
                        "name": "Guánica Municipio",
                        "latitude": "17.98830000",
                        "longitude": "-66.91212000"
                    },
                    {
                        "id": 143066,
                        "name": "Guayabal",
                        "latitude": "18.08138889",
                        "longitude": "-66.50138889"
                    },
                    {
                        "id": 143067,
                        "name": "Guayama",
                        "latitude": "17.99361111",
                        "longitude": "-66.13083333"
                    },
                    {
                        "id": 143068,
                        "name": "Guayama Municipio",
                        "latitude": "18.01663000",
                        "longitude": "-66.13072000"
                    },
                    {
                        "id": 143069,
                        "name": "Guayanilla",
                        "latitude": "18.01916667",
                        "longitude": "-66.79194444"
                    },
                    {
                        "id": 143070,
                        "name": "Guaynabo",
                        "latitude": "18.36666667",
                        "longitude": "-66.10000000"
                    },
                    {
                        "id": 143071,
                        "name": "Gurabo",
                        "latitude": "18.25440000",
                        "longitude": "-65.97294000"
                    },
                    {
                        "id": 143072,
                        "name": "Gurabo Municipio",
                        "latitude": "18.27162000",
                        "longitude": "-65.97183000"
                    },
                    {
                        "id": 143075,
                        "name": "H. Rivera Colon",
                        "latitude": "18.34777778",
                        "longitude": "-66.27388889"
                    },
                    {
                        "id": 143076,
                        "name": "Hatillo",
                        "latitude": "18.48633000",
                        "longitude": "-66.82545000"
                    },
                    {
                        "id": 143077,
                        "name": "Hatillo Municipio",
                        "latitude": "18.40773000",
                        "longitude": "-66.79323000"
                    },
                    {
                        "id": 143078,
                        "name": "Hato Arriba",
                        "latitude": "18.35583333",
                        "longitude": "-67.03416667"
                    },
                    {
                        "id": 143079,
                        "name": "Hato Candal",
                        "latitude": "18.37444444",
                        "longitude": "-65.78722222"
                    },
                    {
                        "id": 143080,
                        "name": "Hormigueros",
                        "latitude": "18.13968000",
                        "longitude": "-67.12740000"
                    },
                    {
                        "id": 143081,
                        "name": "Hormigueros Municipio",
                        "latitude": "18.14162000",
                        "longitude": "-67.11629000"
                    },
                    {
                        "id": 143082,
                        "name": "Humacao",
                        "latitude": "18.14972200",
                        "longitude": "-65.82750000"
                    },
                    {
                        "id": 143083,
                        "name": "Imbery",
                        "latitude": "18.43694444",
                        "longitude": "-66.55250000"
                    },
                    {
                        "id": 143084,
                        "name": "Indios",
                        "latitude": "17.99416667",
                        "longitude": "-66.81944444"
                    },
                    {
                        "id": 143085,
                        "name": "Ingenio",
                        "latitude": "18.44222222",
                        "longitude": "-66.22611111"
                    },
                    {
                        "id": 143086,
                        "name": "Isabel Segunda",
                        "latitude": "18.14916667",
                        "longitude": "-65.44277778"
                    },
                    {
                        "id": 143087,
                        "name": "Isabela",
                        "latitude": "18.51305556",
                        "longitude": "-67.07000000"
                    },
                    {
                        "id": 143088,
                        "name": "Jagual",
                        "latitude": "18.16166667",
                        "longitude": "-65.99555556"
                    },
                    {
                        "id": 143089,
                        "name": "Jauca",
                        "latitude": "17.96916667",
                        "longitude": "-66.36583333"
                    },
                    {
                        "id": 143090,
                        "name": "Jayuya",
                        "latitude": "18.21861100",
                        "longitude": "-66.59166700"
                    },
                    {
                        "id": 143091,
                        "name": "Jobos",
                        "latitude": "17.95527778",
                        "longitude": "-66.16555556"
                    },
                    {
                        "id": 143092,
                        "name": "Juana Díaz",
                        "latitude": "18.05246000",
                        "longitude": "-66.50656000"
                    },
                    {
                        "id": 143093,
                        "name": "Juana Díaz Municipio",
                        "latitude": "18.04802000",
                        "longitude": "-66.49267000"
                    },
                    {
                        "id": 143094,
                        "name": "Juncal",
                        "latitude": "18.31388889",
                        "longitude": "-66.91916667"
                    },
                    {
                        "id": 143095,
                        "name": "Juncos",
                        "latitude": "18.22750000",
                        "longitude": "-65.92111100"
                    },
                    {
                        "id": 143096,
                        "name": "La Alianza",
                        "latitude": "18.39750000",
                        "longitude": "-66.60250000"
                    },
                    {
                        "id": 143097,
                        "name": "La Dolores",
                        "latitude": "18.37555556",
                        "longitude": "-65.85583333"
                    },
                    {
                        "id": 143098,
                        "name": "La Fermina",
                        "latitude": "18.17417000",
                        "longitude": "-65.85139000"
                    },
                    {
                        "id": 143099,
                        "name": "La Luisa",
                        "latitude": "18.44888889",
                        "longitude": "-66.51000000"
                    },
                    {
                        "id": 143100,
                        "name": "La Parguera",
                        "latitude": "17.97497000",
                        "longitude": "-67.04657000"
                    },
                    {
                        "id": 143101,
                        "name": "La Playa",
                        "latitude": "18.28750000",
                        "longitude": "-67.18694444"
                    },
                    {
                        "id": 143102,
                        "name": "La Plena",
                        "latitude": "18.04663000",
                        "longitude": "-66.20461000"
                    },
                    {
                        "id": 143103,
                        "name": "Lajas",
                        "latitude": "18.05193889",
                        "longitude": "-67.05971944"
                    },
                    {
                        "id": 143104,
                        "name": "Lajas Municipio",
                        "latitude": "18.01330000",
                        "longitude": "-67.03990000"
                    },
                    {
                        "id": 143105,
                        "name": "Lamboglia",
                        "latitude": "17.98136000",
                        "longitude": "-65.98572000"
                    },
                    {
                        "id": 143106,
                        "name": "Lares",
                        "latitude": "18.29467000",
                        "longitude": "-66.87712000"
                    },
                    {
                        "id": 143107,
                        "name": "Las Marias",
                        "latitude": "18.29333333",
                        "longitude": "-67.14638889"
                    },
                    {
                        "id": 143108,
                        "name": "Las Marías Municipio",
                        "latitude": "18.25087000",
                        "longitude": "-66.99240000"
                    },
                    {
                        "id": 143109,
                        "name": "Las Ochenta",
                        "latitude": "17.98469000",
                        "longitude": "-66.31795000"
                    },
                    {
                        "id": 143110,
                        "name": "Las Ollas",
                        "latitude": "18.03305556",
                        "longitude": "-66.42444444"
                    },
                    {
                        "id": 143111,
                        "name": "Las Piedras",
                        "latitude": "18.18301000",
                        "longitude": "-65.86627000"
                    },
                    {
                        "id": 143112,
                        "name": "Las Piedras Municipio",
                        "latitude": "18.18829000",
                        "longitude": "-65.87044000"
                    },
                    {
                        "id": 143113,
                        "name": "Levittown",
                        "latitude": "18.44861111",
                        "longitude": "-66.18027778"
                    },
                    {
                        "id": 143114,
                        "name": "Liborio Negron Torres",
                        "latitude": "18.04305556",
                        "longitude": "-66.94250000"
                    },
                    {
                        "id": 143115,
                        "name": "Lluveras",
                        "latitude": "18.03833333",
                        "longitude": "-66.90472222"
                    },
                    {
                        "id": 143118,
                        "name": "Loíza",
                        "latitude": "18.43134000",
                        "longitude": "-65.88016000"
                    },
                    {
                        "id": 143116,
                        "name": "Lomas",
                        "latitude": "18.26861111",
                        "longitude": "-65.90888889"
                    },
                    {
                        "id": 143117,
                        "name": "Los Llanos",
                        "latitude": "18.05527778",
                        "longitude": "-66.40583333"
                    },
                    {
                        "id": 143119,
                        "name": "Luis Lloréns Torres",
                        "latitude": "18.05691000",
                        "longitude": "-66.52684000"
                    },
                    {
                        "id": 143120,
                        "name": "Luis M. Cintron",
                        "latitude": "18.29972222",
                        "longitude": "-65.63861111"
                    },
                    {
                        "id": 143121,
                        "name": "Luquillo",
                        "latitude": "18.37250000",
                        "longitude": "-65.71666667"
                    },
                    {
                        "id": 143122,
                        "name": "Luquillo Municipio",
                        "latitude": "18.33967000",
                        "longitude": "-65.72461000"
                    },
                    {
                        "id": 143123,
                        "name": "Luyando",
                        "latitude": "18.36444444",
                        "longitude": "-67.15750000"
                    },
                    {
                        "id": 143124,
                        "name": "Magas Arriba",
                        "latitude": "18.01750000",
                        "longitude": "-66.76916667"
                    },
                    {
                        "id": 143125,
                        "name": "Manatí",
                        "latitude": "18.43250000",
                        "longitude": "-66.48444444"
                    },
                    {
                        "id": 143126,
                        "name": "Maria Antonia",
                        "latitude": "17.97833333",
                        "longitude": "-66.88944444"
                    },
                    {
                        "id": 143127,
                        "name": "Mariano Colón",
                        "latitude": "18.02333333",
                        "longitude": "-66.33250000"
                    },
                    {
                        "id": 143128,
                        "name": "Maricao",
                        "latitude": "18.18083300",
                        "longitude": "-66.98000000"
                    },
                    {
                        "id": 143129,
                        "name": "Maricao Municipio",
                        "latitude": "18.17301000",
                        "longitude": "-66.94546000"
                    },
                    {
                        "id": 143130,
                        "name": "Martorell",
                        "latitude": "18.07472000",
                        "longitude": "-65.89861000"
                    },
                    {
                        "id": 143131,
                        "name": "Marueño",
                        "latitude": "18.05772000",
                        "longitude": "-66.65603000"
                    },
                    {
                        "id": 143132,
                        "name": "Maunabo",
                        "latitude": "18.00719000",
                        "longitude": "-65.89933000"
                    },
                    {
                        "id": 143133,
                        "name": "Maunabo Municipio",
                        "latitude": "18.01691000",
                        "longitude": "-65.92738000"
                    },
                    {
                        "id": 143134,
                        "name": "Mayagüez",
                        "latitude": "18.20111111",
                        "longitude": "-67.13972222"
                    },
                    {
                        "id": 143135,
                        "name": "Miranda",
                        "latitude": "18.38666667",
                        "longitude": "-66.38388889"
                    },
                    {
                        "id": 143136,
                        "name": "Moca",
                        "latitude": "18.39467000",
                        "longitude": "-67.11324000"
                    },
                    {
                        "id": 143137,
                        "name": "Moca Municipio",
                        "latitude": "18.38550000",
                        "longitude": "-67.08435000"
                    },
                    {
                        "id": 143138,
                        "name": "Monserrate",
                        "latitude": "18.43694000",
                        "longitude": "-66.35639000"
                    },
                    {
                        "id": 143139,
                        "name": "Monte Grande",
                        "latitude": "18.08750000",
                        "longitude": "-67.10750000"
                    },
                    {
                        "id": 143140,
                        "name": "Mora",
                        "latitude": "18.46305556",
                        "longitude": "-67.03277778"
                    },
                    {
                        "id": 143141,
                        "name": "Morovis",
                        "latitude": "18.33333333",
                        "longitude": "-66.41666667"
                    },
                    {
                        "id": 143142,
                        "name": "Mucarabones",
                        "latitude": "18.39083333",
                        "longitude": "-66.21611111"
                    },
                    {
                        "id": 143143,
                        "name": "Naguabo",
                        "latitude": "18.21944444",
                        "longitude": "-65.73666667"
                    },
                    {
                        "id": 143144,
                        "name": "Naguabo Municipio",
                        "latitude": "18.23135000",
                        "longitude": "-65.75988000"
                    },
                    {
                        "id": 143145,
                        "name": "Naranjito",
                        "latitude": "18.30083300",
                        "longitude": "-66.24500000"
                    },
                    {
                        "id": 143146,
                        "name": "Naranjito Municipio",
                        "latitude": "18.28968000",
                        "longitude": "-66.25517000"
                    },
                    {
                        "id": 143147,
                        "name": "Olimpo",
                        "latitude": "18.00194444",
                        "longitude": "-66.10833333"
                    },
                    {
                        "id": 143148,
                        "name": "Orocovis",
                        "latitude": "18.22694400",
                        "longitude": "-66.39111100"
                    },
                    {
                        "id": 143149,
                        "name": "Orocovis Municipio",
                        "latitude": "18.21885000",
                        "longitude": "-66.43712000"
                    },
                    {
                        "id": 143174,
                        "name": "Pájaros",
                        "latitude": "18.37592060",
                        "longitude": "-66.18625500"
                    },
                    {
                        "id": 143150,
                        "name": "Pajonal",
                        "latitude": "18.38222222",
                        "longitude": "-66.55583333"
                    },
                    {
                        "id": 143151,
                        "name": "Palmarejo",
                        "latitude": "18.04027778",
                        "longitude": "-67.07694444"
                    },
                    {
                        "id": 143152,
                        "name": "Palmas",
                        "latitude": "17.98722222",
                        "longitude": "-66.02555556"
                    },
                    {
                        "id": 143153,
                        "name": "Palmer",
                        "latitude": "18.37055556",
                        "longitude": "-65.77416667"
                    },
                    {
                        "id": 143154,
                        "name": "Palo Seco",
                        "latitude": "18.00747000",
                        "longitude": "-65.93683000"
                    },
                    {
                        "id": 143155,
                        "name": "Palomas",
                        "latitude": "18.01361111",
                        "longitude": "-66.87333333"
                    },
                    {
                        "id": 143156,
                        "name": "Parcelas La Milagrosa",
                        "latitude": "18.17083333",
                        "longitude": "-66.18833333"
                    },
                    {
                        "id": 143157,
                        "name": "Parcelas Nuevas",
                        "latitude": "18.14027778",
                        "longitude": "-66.17250000"
                    },
                    {
                        "id": 143158,
                        "name": "Parcelas Peñuelas",
                        "latitude": "17.99888889",
                        "longitude": "-66.34138889"
                    },
                    {
                        "id": 143159,
                        "name": "Pastos",
                        "latitude": "18.11777778",
                        "longitude": "-66.25888889"
                    },
                    {
                        "id": 143160,
                        "name": "Patillas",
                        "latitude": "18.00635000",
                        "longitude": "-66.01572000"
                    },
                    {
                        "id": 143161,
                        "name": "Patillas Municipio",
                        "latitude": "18.04163000",
                        "longitude": "-66.01766000"
                    },
                    {
                        "id": 143162,
                        "name": "Peña Pobre",
                        "latitude": "18.21555556",
                        "longitude": "-65.82222222"
                    },
                    {
                        "id": 143163,
                        "name": "Peñuelas",
                        "latitude": "18.05937500",
                        "longitude": "-66.72254400"
                    },
                    {
                        "id": 143164,
                        "name": "Piedra Gorda",
                        "latitude": "18.43416667",
                        "longitude": "-66.88777778"
                    },
                    {
                        "id": 143165,
                        "name": "Playa Fortuna",
                        "latitude": "18.37972222",
                        "longitude": "-65.74527778"
                    },
                    {
                        "id": 143166,
                        "name": "Playita",
                        "latitude": "17.96055556",
                        "longitude": "-66.28972222"
                    },
                    {
                        "id": 143167,
                        "name": "Playita Cortada",
                        "latitude": "17.98500000",
                        "longitude": "-66.43916667"
                    },
                    {
                        "id": 143168,
                        "name": "Pole Ojea",
                        "latitude": "17.97500000",
                        "longitude": "-67.18527778"
                    },
                    {
                        "id": 143169,
                        "name": "Ponce",
                        "latitude": "18.00000000",
                        "longitude": "-66.61666667"
                    },
                    {
                        "id": 143170,
                        "name": "Potala Pastillo",
                        "latitude": "17.99138889",
                        "longitude": "-66.49666667"
                    },
                    {
                        "id": 143171,
                        "name": "Pueblito del Rio",
                        "latitude": "18.22805556",
                        "longitude": "-65.86305556"
                    },
                    {
                        "id": 143172,
                        "name": "Puerto Real",
                        "latitude": "18.07500000",
                        "longitude": "-67.18722222"
                    },
                    {
                        "id": 143173,
                        "name": "Punta Santiago",
                        "latitude": "18.16638889",
                        "longitude": "-65.74833333"
                    },
                    {
                        "id": 143175,
                        "name": "Quebrada",
                        "latitude": "18.35666667",
                        "longitude": "-66.83222222"
                    },
                    {
                        "id": 143176,
                        "name": "Quebradillas",
                        "latitude": "18.47388889",
                        "longitude": "-66.93861111"
                    },
                    {
                        "id": 143177,
                        "name": "Quebradillas Municipio",
                        "latitude": "18.43967000",
                        "longitude": "-66.92462000"
                    },
                    {
                        "id": 143178,
                        "name": "Rafael Capo",
                        "latitude": "18.40722222",
                        "longitude": "-66.78222222"
                    },
                    {
                        "id": 143179,
                        "name": "Rafael Gonzalez",
                        "latitude": "18.42750000",
                        "longitude": "-66.78694444"
                    },
                    {
                        "id": 143180,
                        "name": "Rafael Hernandez",
                        "latitude": "18.47138889",
                        "longitude": "-67.07916667"
                    },
                    {
                        "id": 143181,
                        "name": "Ramos",
                        "latitude": "18.33972222",
                        "longitude": "-65.71277778"
                    },
                    {
                        "id": 143182,
                        "name": "Rincón",
                        "latitude": "18.34023000",
                        "longitude": "-67.24990000"
                    },
                    {
                        "id": 143183,
                        "name": "Rincón Municipio",
                        "latitude": "18.33967000",
                        "longitude": "-67.23713000"
                    },
                    {
                        "id": 143186,
                        "name": "Río Blanco",
                        "latitude": "18.21833333",
                        "longitude": "-65.78861111"
                    },
                    {
                        "id": 143187,
                        "name": "Río Cañas Abajo",
                        "latitude": "18.03833333",
                        "longitude": "-66.46777778"
                    },
                    {
                        "id": 143188,
                        "name": "Río Grande",
                        "latitude": "18.38023000",
                        "longitude": "-65.83127000"
                    },
                    {
                        "id": 143189,
                        "name": "Río Grande Municipio",
                        "latitude": "18.34162000",
                        "longitude": "-65.81766000"
                    },
                    {
                        "id": 143184,
                        "name": "Rio Lajas",
                        "latitude": "18.39719150",
                        "longitude": "-66.26453900"
                    },
                    {
                        "id": 143190,
                        "name": "Río Piedras",
                        "latitude": "18.39972222",
                        "longitude": "-66.05000000"
                    },
                    {
                        "id": 143185,
                        "name": "Rosa Sanchez",
                        "latitude": "18.06166667",
                        "longitude": "-65.91361111"
                    },
                    {
                        "id": 143191,
                        "name": "Sabana",
                        "latitude": "18.46083333",
                        "longitude": "-66.35861111"
                    },
                    {
                        "id": 143192,
                        "name": "Sabana Eneas",
                        "latitude": "18.08611111",
                        "longitude": "-67.08111111"
                    },
                    {
                        "id": 143193,
                        "name": "Sabana Grande",
                        "latitude": "18.07972222",
                        "longitude": "-66.96083333"
                    },
                    {
                        "id": 143194,
                        "name": "Sabana Grande Municipio",
                        "latitude": "18.09385000",
                        "longitude": "-66.94962000"
                    },
                    {
                        "id": 143195,
                        "name": "Sabana Hoyos",
                        "latitude": "18.43388889",
                        "longitude": "-66.61388889"
                    },
                    {
                        "id": 143196,
                        "name": "Sabana Seca",
                        "latitude": "18.42694444",
                        "longitude": "-66.18472222"
                    },
                    {
                        "id": 143197,
                        "name": "Salinas",
                        "latitude": "18.01746000",
                        "longitude": "-66.25378000"
                    },
                    {
                        "id": 143198,
                        "name": "San Antonio",
                        "latitude": "18.45166667",
                        "longitude": "-66.94972222"
                    },
                    {
                        "id": 143199,
                        "name": "San Germán Municipio",
                        "latitude": "18.11468000",
                        "longitude": "-67.03573000"
                    },
                    {
                        "id": 143200,
                        "name": "San Isidro",
                        "latitude": "18.39222222",
                        "longitude": "-65.88555556"
                    },
                    {
                        "id": 143201,
                        "name": "San José",
                        "latitude": "18.39833333",
                        "longitude": "-66.25583333"
                    },
                    {
                        "id": 143202,
                        "name": "San Juan",
                        "latitude": "18.45000000",
                        "longitude": "-66.06666667"
                    },
                    {
                        "id": 143203,
                        "name": "San Lorenzo",
                        "latitude": "18.18988900",
                        "longitude": "-65.96869400"
                    },
                    {
                        "id": 143204,
                        "name": "San Sebastián",
                        "latitude": "18.33722222",
                        "longitude": "-66.99055556"
                    },
                    {
                        "id": 143205,
                        "name": "Santa Barbara",
                        "latitude": "18.39361111",
                        "longitude": "-65.91888889"
                    },
                    {
                        "id": 143206,
                        "name": "Santa Clara",
                        "latitude": "18.21861111",
                        "longitude": "-66.12888889"
                    },
                    {
                        "id": 143207,
                        "name": "Santa Isabel",
                        "latitude": "17.96611100",
                        "longitude": "-66.40500000"
                    },
                    {
                        "id": 143208,
                        "name": "Santa Isabel Municipio",
                        "latitude": "17.99663000",
                        "longitude": "-66.38711000"
                    },
                    {
                        "id": 143209,
                        "name": "Santo Domingo",
                        "latitude": "18.06333333",
                        "longitude": "-66.75250000"
                    },
                    {
                        "id": 143210,
                        "name": "Santurce",
                        "latitude": "18.44083333",
                        "longitude": "-66.04722222"
                    },
                    {
                        "id": 143211,
                        "name": "Stella",
                        "latitude": "18.32194444",
                        "longitude": "-67.24694444"
                    },
                    {
                        "id": 143213,
                        "name": "Suárez",
                        "latitude": "18.43027778",
                        "longitude": "-65.85361111"
                    },
                    {
                        "id": 143212,
                        "name": "Sumidero",
                        "latitude": "18.21861111",
                        "longitude": "-66.12888889"
                    },
                    {
                        "id": 143214,
                        "name": "Tallaboa",
                        "latitude": "17.99500000",
                        "longitude": "-66.71638889"
                    },
                    {
                        "id": 143215,
                        "name": "Tallaboa Alta",
                        "latitude": "18.05111111",
                        "longitude": "-66.70027778"
                    },
                    {
                        "id": 143216,
                        "name": "Tiburones",
                        "latitude": "18.43166667",
                        "longitude": "-66.58083333"
                    },
                    {
                        "id": 143217,
                        "name": "Tierras Nuevas Poniente",
                        "latitude": "18.46189000",
                        "longitude": "-66.48850000"
                    },
                    {
                        "id": 143218,
                        "name": "Toa Alta",
                        "latitude": "18.38828000",
                        "longitude": "-66.24822000"
                    },
                    {
                        "id": 143219,
                        "name": "Toa Alta Municipio",
                        "latitude": "18.36606000",
                        "longitude": "-66.25378000"
                    },
                    {
                        "id": 143220,
                        "name": "Toa Baja",
                        "latitude": "18.44388900",
                        "longitude": "-66.25972200"
                    },
                    {
                        "id": 143221,
                        "name": "Trujillo Alto",
                        "latitude": "18.36277800",
                        "longitude": "-66.01750000"
                    },
                    {
                        "id": 143222,
                        "name": "Trujillo Alto Municipio",
                        "latitude": "18.34162000",
                        "longitude": "-66.00517000"
                    },
                    {
                        "id": 143223,
                        "name": "Utuado",
                        "latitude": "18.27301000",
                        "longitude": "-66.69962000"
                    },
                    {
                        "id": 143224,
                        "name": "Utuado barrio-pueblo",
                        "latitude": "18.26580000",
                        "longitude": "-66.70640000"
                    },
                    {
                        "id": 143232,
                        "name": "Vázquez",
                        "latitude": "18.06583333",
                        "longitude": "-66.23861111"
                    },
                    {
                        "id": 143225,
                        "name": "Vega Alta",
                        "latitude": "18.41217000",
                        "longitude": "-66.33128000"
                    },
                    {
                        "id": 143226,
                        "name": "Vega Alta Municipio",
                        "latitude": "18.41050000",
                        "longitude": "-66.33295000"
                    },
                    {
                        "id": 143227,
                        "name": "Vega Baja",
                        "latitude": "18.44611111",
                        "longitude": "-66.38750000"
                    },
                    {
                        "id": 143228,
                        "name": "Vieques",
                        "latitude": "18.42500000",
                        "longitude": "-65.83305556"
                    },
                    {
                        "id": 143229,
                        "name": "Vieques Municipality",
                        "latitude": "18.12913000",
                        "longitude": "-65.43710000"
                    },
                    {
                        "id": 143230,
                        "name": "Villalba",
                        "latitude": "18.12722200",
                        "longitude": "-66.49222200"
                    },
                    {
                        "id": 143231,
                        "name": "Villalba Municipio",
                        "latitude": "18.12913000",
                        "longitude": "-66.47739000"
                    },
                    {
                        "id": 143233,
                        "name": "Yabucoa",
                        "latitude": "18.05052000",
                        "longitude": "-65.87933000"
                    },
                    {
                        "id": 143234,
                        "name": "Yabucoa Municipio",
                        "latitude": "18.07302000",
                        "longitude": "-65.88711000"
                    },
                    {
                        "id": 143235,
                        "name": "Yauco",
                        "latitude": "18.03694444",
                        "longitude": "-66.85027778"
                    },
                    {
                        "id": 143236,
                        "name": "Yaurel",
                        "latitude": "18.02694444",
                        "longitude": "-66.05722222"
                    }
                ]
            },
            {
                "id": 1461,
                "name": "Rhode Island",
                "iso2": "RI",
                "latitude": "41.58009450",
                "longitude": "-71.47742910",
                "type": "state",
                "cities": [
                    {
                        "id": 111512,
                        "name": "Ashaway",
                        "latitude": "41.42343000",
                        "longitude": "-71.78562000"
                    },
                    {
                        "id": 111848,
                        "name": "Barrington",
                        "latitude": "41.74066000",
                        "longitude": "-71.30866000"
                    },
                    {
                        "id": 112667,
                        "name": "Bradford",
                        "latitude": "41.39899000",
                        "longitude": "-71.73701000"
                    },
                    {
                        "id": 112812,
                        "name": "Bristol",
                        "latitude": "41.67705000",
                        "longitude": "-71.26616000"
                    },
                    {
                        "id": 112815,
                        "name": "Bristol County",
                        "latitude": "41.70554000",
                        "longitude": "-71.28612000"
                    },
                    {
                        "id": 113673,
                        "name": "Central Falls",
                        "latitude": "41.89066000",
                        "longitude": "-71.39228000"
                    },
                    {
                        "id": 113773,
                        "name": "Charlestown",
                        "latitude": "41.38316000",
                        "longitude": "-71.64173000"
                    },
                    {
                        "id": 113843,
                        "name": "Chepachet",
                        "latitude": "41.91510000",
                        "longitude": "-71.67146000"
                    },
                    {
                        "id": 114732,
                        "name": "Coventry",
                        "latitude": "41.70010000",
                        "longitude": "-71.68284000"
                    },
                    {
                        "id": 114772,
                        "name": "Cranston",
                        "latitude": "41.77982000",
                        "longitude": "-71.43728000"
                    },
                    {
                        "id": 114909,
                        "name": "Cumberland",
                        "latitude": "41.96677000",
                        "longitude": "-71.43284000"
                    },
                    {
                        "id": 114921,
                        "name": "Cumberland Hill",
                        "latitude": "41.97454000",
                        "longitude": "-71.46700000"
                    },
                    {
                        "id": 115674,
                        "name": "East Greenwich",
                        "latitude": "41.66038000",
                        "longitude": "-71.45589000"
                    },
                    {
                        "id": 115741,
                        "name": "East Providence",
                        "latitude": "41.81371000",
                        "longitude": "-71.37005000"
                    },
                    {
                        "id": 116273,
                        "name": "Exeter",
                        "latitude": "41.57760000",
                        "longitude": "-71.53756000"
                    },
                    {
                        "id": 116774,
                        "name": "Foster",
                        "latitude": "41.85371000",
                        "longitude": "-71.75812000"
                    },
                    {
                        "id": 117695,
                        "name": "Greenville",
                        "latitude": "41.87121000",
                        "longitude": "-71.55201000"
                    },
                    {
                        "id": 118076,
                        "name": "Harrisville",
                        "latitude": "41.96565000",
                        "longitude": "-71.67451000"
                    },
                    {
                        "id": 118646,
                        "name": "Hope Valley",
                        "latitude": "41.50760000",
                        "longitude": "-71.71618000"
                    },
                    {
                        "id": 118658,
                        "name": "Hopkinton",
                        "latitude": "41.46121000",
                        "longitude": "-71.77757000"
                    },
                    {
                        "id": 119125,
                        "name": "Jamestown",
                        "latitude": "41.49705000",
                        "longitude": "-71.36728000"
                    },
                    {
                        "id": 119279,
                        "name": "Johnston",
                        "latitude": "41.82186000",
                        "longitude": "-71.50675000"
                    },
                    {
                        "id": 119493,
                        "name": "Kent County",
                        "latitude": "41.67334000",
                        "longitude": "-71.57895000"
                    },
                    {
                        "id": 119629,
                        "name": "Kingston",
                        "latitude": "41.48038000",
                        "longitude": "-71.52256000"
                    },
                    {
                        "id": 120513,
                        "name": "Lincoln",
                        "latitude": "41.92111000",
                        "longitude": "-71.43500000"
                    },
                    {
                        "id": 121636,
                        "name": "Melville",
                        "latitude": "41.58705000",
                        "longitude": "-71.28338000"
                    },
                    {
                        "id": 121793,
                        "name": "Middletown",
                        "latitude": "41.54566000",
                        "longitude": "-71.29144000"
                    },
                    {
                        "id": 122564,
                        "name": "Narragansett",
                        "latitude": "41.45010000",
                        "longitude": "-71.44950000"
                    },
                    {
                        "id": 122565,
                        "name": "Narragansett Pier",
                        "latitude": "41.43232000",
                        "longitude": "-71.45644000"
                    },
                    {
                        "id": 122778,
                        "name": "New Shoreham",
                        "latitude": "41.17233000",
                        "longitude": "-71.55783000"
                    },
                    {
                        "id": 122849,
                        "name": "Newport",
                        "latitude": "41.49010000",
                        "longitude": "-71.31283000"
                    },
                    {
                        "id": 122854,
                        "name": "Newport County",
                        "latitude": "41.49980000",
                        "longitude": "-71.28100000"
                    },
                    {
                        "id": 122855,
                        "name": "Newport East",
                        "latitude": "41.51579000",
                        "longitude": "-71.28752000"
                    },
                    {
                        "id": 123048,
                        "name": "North Kingstown",
                        "latitude": "41.55010000",
                        "longitude": "-71.46617000"
                    },
                    {
                        "id": 123089,
                        "name": "North Providence",
                        "latitude": "41.85010000",
                        "longitude": "-71.46617000"
                    },
                    {
                        "id": 123102,
                        "name": "North Scituate",
                        "latitude": "41.83177000",
                        "longitude": "-71.58729000"
                    },
                    {
                        "id": 123108,
                        "name": "North Smithfield",
                        "latitude": "41.96677000",
                        "longitude": "-71.54951000"
                    },
                    {
                        "id": 123903,
                        "name": "Pascoag",
                        "latitude": "41.95565000",
                        "longitude": "-71.70229000"
                    },
                    {
                        "id": 123939,
                        "name": "Pawtucket",
                        "latitude": "41.87871000",
                        "longitude": "-71.38256000"
                    },
                    {
                        "id": 124571,
                        "name": "Portsmouth",
                        "latitude": "41.60232000",
                        "longitude": "-71.25033000"
                    },
                    {
                        "id": 124716,
                        "name": "Providence",
                        "latitude": "41.82399000",
                        "longitude": "-71.41283000"
                    },
                    {
                        "id": 124719,
                        "name": "Providence County",
                        "latitude": "41.87136000",
                        "longitude": "-71.57860000"
                    },
                    {
                        "id": 126520,
                        "name": "Smithfield",
                        "latitude": "41.92204000",
                        "longitude": "-71.54951000"
                    },
                    {
                        "id": 126683,
                        "name": "South Kingstown",
                        "latitude": "41.44718000",
                        "longitude": "-71.52494000"
                    },
                    {
                        "id": 127687,
                        "name": "Tiverton",
                        "latitude": "41.62594000",
                        "longitude": "-71.21338000"
                    },
                    {
                        "id": 128108,
                        "name": "Valley Falls",
                        "latitude": "41.90677000",
                        "longitude": "-71.39061000"
                    },
                    {
                        "id": 128364,
                        "name": "Wakefield-Peacedale",
                        "latitude": "41.44606000",
                        "longitude": "-71.50040000"
                    },
                    {
                        "id": 128484,
                        "name": "Warren",
                        "latitude": "41.73038000",
                        "longitude": "-71.28255000"
                    },
                    {
                        "id": 128525,
                        "name": "Warwick",
                        "latitude": "41.70010000",
                        "longitude": "-71.41617000"
                    },
                    {
                        "id": 128574,
                        "name": "Washington County",
                        "latitude": "41.39649000",
                        "longitude": "-71.61966000"
                    },
                    {
                        "id": 128880,
                        "name": "West Greenwich",
                        "latitude": "41.63700000",
                        "longitude": "-71.66004000"
                    },
                    {
                        "id": 129002,
                        "name": "West Warwick",
                        "latitude": "41.69689000",
                        "longitude": "-71.52194000"
                    },
                    {
                        "id": 129023,
                        "name": "Westerly",
                        "latitude": "41.37760000",
                        "longitude": "-71.82729000"
                    },
                    {
                        "id": 129582,
                        "name": "Woonsocket",
                        "latitude": "42.00288000",
                        "longitude": "-71.51478000"
                    }
                ]
            },
            {
                "id": 1443,
                "name": "South Carolina",
                "iso2": "SC",
                "latitude": "33.83608100",
                "longitude": "-81.16372450",
                "type": "state",
                "cities": [
                    {
                        "id": 110967,
                        "name": "Abbeville",
                        "latitude": "34.17817000",
                        "longitude": "-82.37901000"
                    },
                    {
                        "id": 110969,
                        "name": "Abbeville County",
                        "latitude": "34.22257000",
                        "longitude": "-82.45871000"
                    },
                    {
                        "id": 111066,
                        "name": "Aiken",
                        "latitude": "33.56042000",
                        "longitude": "-81.71955000"
                    },
                    {
                        "id": 111067,
                        "name": "Aiken County",
                        "latitude": "33.54437000",
                        "longitude": "-81.63474000"
                    },
                    {
                        "id": 111193,
                        "name": "Allendale",
                        "latitude": "33.00793000",
                        "longitude": "-81.30844000"
                    },
                    {
                        "id": 111197,
                        "name": "Allendale County",
                        "latitude": "32.98811000",
                        "longitude": "-81.35820000"
                    },
                    {
                        "id": 111311,
                        "name": "Anderson",
                        "latitude": "34.50344000",
                        "longitude": "-82.65013000"
                    },
                    {
                        "id": 111317,
                        "name": "Anderson County",
                        "latitude": "34.51909000",
                        "longitude": "-82.63788000"
                    },
                    {
                        "id": 111329,
                        "name": "Andrews",
                        "latitude": "33.45128000",
                        "longitude": "-79.56090000"
                    },
                    {
                        "id": 111422,
                        "name": "Arcadia",
                        "latitude": "34.95818000",
                        "longitude": "-81.99066000"
                    },
                    {
                        "id": 111451,
                        "name": "Arial",
                        "latitude": "34.84595000",
                        "longitude": "-82.64152000"
                    },
                    {
                        "id": 111706,
                        "name": "Awendaw",
                        "latitude": "33.03767000",
                        "longitude": "-79.61313000"
                    },
                    {
                        "id": 111786,
                        "name": "Bamberg",
                        "latitude": "33.29710000",
                        "longitude": "-81.03482000"
                    },
                    {
                        "id": 111787,
                        "name": "Bamberg County",
                        "latitude": "33.21477000",
                        "longitude": "-81.05423000"
                    },
                    {
                        "id": 111838,
                        "name": "Barnwell",
                        "latitude": "33.24487000",
                        "longitude": "-81.35872000"
                    },
                    {
                        "id": 111839,
                        "name": "Barnwell County",
                        "latitude": "33.26606000",
                        "longitude": "-81.43502000"
                    },
                    {
                        "id": 111890,
                        "name": "Batesburg",
                        "latitude": "33.90792000",
                        "longitude": "-81.54733000"
                    },
                    {
                        "id": 111891,
                        "name": "Batesburg-Leesville",
                        "latitude": "33.91014000",
                        "longitude": "-81.53733000"
                    },
                    {
                        "id": 111986,
                        "name": "Beaufort",
                        "latitude": "32.43158000",
                        "longitude": "-80.66983000"
                    },
                    {
                        "id": 111988,
                        "name": "Beaufort County",
                        "latitude": "32.35706000",
                        "longitude": "-80.69217000"
                    },
                    {
                        "id": 112148,
                        "name": "Belton",
                        "latitude": "34.52289000",
                        "longitude": "-82.49429000"
                    },
                    {
                        "id": 112152,
                        "name": "Belvedere",
                        "latitude": "33.53097000",
                        "longitude": "-81.94484000"
                    },
                    {
                        "id": 112175,
                        "name": "Bennettsville",
                        "latitude": "34.61738000",
                        "longitude": "-79.68478000"
                    },
                    {
                        "id": 112214,
                        "name": "Berea",
                        "latitude": "34.88540000",
                        "longitude": "-82.45596000"
                    },
                    {
                        "id": 112224,
                        "name": "Berkeley County",
                        "latitude": "33.19768000",
                        "longitude": "-79.95099000"
                    },
                    {
                        "id": 112365,
                        "name": "Bishopville",
                        "latitude": "34.21821000",
                        "longitude": "-80.24841000"
                    },
                    {
                        "id": 112389,
                        "name": "Blacksburg",
                        "latitude": "35.12124000",
                        "longitude": "-81.51592000"
                    },
                    {
                        "id": 112394,
                        "name": "Blackville",
                        "latitude": "33.35793000",
                        "longitude": "-81.27066000"
                    },
                    {
                        "id": 112483,
                        "name": "Bluffton",
                        "latitude": "32.23715000",
                        "longitude": "-80.86039000"
                    },
                    {
                        "id": 112487,
                        "name": "Blythewood",
                        "latitude": "34.21432000",
                        "longitude": "-80.97398000"
                    },
                    {
                        "id": 112506,
                        "name": "Boiling Springs",
                        "latitude": "35.04651000",
                        "longitude": "-81.98177000"
                    },
                    {
                        "id": 112540,
                        "name": "Bonneau Beach",
                        "latitude": "33.31989000",
                        "longitude": "-80.00036000"
                    },
                    {
                        "id": 112849,
                        "name": "Brookdale",
                        "latitude": "33.50682000",
                        "longitude": "-80.82342000"
                    },
                    {
                        "id": 113009,
                        "name": "Buffalo",
                        "latitude": "34.72569000",
                        "longitude": "-81.68343000"
                    },
                    {
                        "id": 113081,
                        "name": "Burnettown",
                        "latitude": "33.51541000",
                        "longitude": "-81.84900000"
                    },
                    {
                        "id": 113096,
                        "name": "Burton",
                        "latitude": "32.43575000",
                        "longitude": "-80.72400000"
                    },
                    {
                        "id": 113206,
                        "name": "Calhoun County",
                        "latitude": "33.67486000",
                        "longitude": "-80.78028000"
                    },
                    {
                        "id": 113211,
                        "name": "Calhoun Falls",
                        "latitude": "34.09234000",
                        "longitude": "-82.59569000"
                    },
                    {
                        "id": 113264,
                        "name": "Camden",
                        "latitude": "34.24654000",
                        "longitude": "-80.60702000"
                    },
                    {
                        "id": 113327,
                        "name": "Cane Savannah",
                        "latitude": "33.90182000",
                        "longitude": "-80.45036000"
                    },
                    {
                        "id": 113566,
                        "name": "Catawba",
                        "latitude": "34.85292000",
                        "longitude": "-80.91119000"
                    },
                    {
                        "id": 113591,
                        "name": "Cayce",
                        "latitude": "33.96571000",
                        "longitude": "-81.07398000"
                    },
                    {
                        "id": 113656,
                        "name": "Centerville",
                        "latitude": "34.53205000",
                        "longitude": "-82.70402000"
                    },
                    {
                        "id": 113665,
                        "name": "Central",
                        "latitude": "34.72427000",
                        "longitude": "-82.78125000"
                    },
                    {
                        "id": 113743,
                        "name": "Chapin",
                        "latitude": "34.16598000",
                        "longitude": "-81.34982000"
                    },
                    {
                        "id": 113765,
                        "name": "Charleston",
                        "latitude": "32.77657000",
                        "longitude": "-79.93092000"
                    },
                    {
                        "id": 113769,
                        "name": "Charleston County",
                        "latitude": "32.74917000",
                        "longitude": "-79.94202000"
                    },
                    {
                        "id": 113844,
                        "name": "Cheraw",
                        "latitude": "34.69766000",
                        "longitude": "-79.88340000"
                    },
                    {
                        "id": 113854,
                        "name": "Cherokee County",
                        "latitude": "35.04820000",
                        "longitude": "-81.62039000"
                    },
                    {
                        "id": 113869,
                        "name": "Cherryvale",
                        "latitude": "33.95571000",
                        "longitude": "-80.45814000"
                    },
                    {
                        "id": 113885,
                        "name": "Chester",
                        "latitude": "34.70486000",
                        "longitude": "-81.21426000"
                    },
                    {
                        "id": 113895,
                        "name": "Chester County",
                        "latitude": "34.69206000",
                        "longitude": "-81.15953000"
                    },
                    {
                        "id": 113902,
                        "name": "Chesterfield",
                        "latitude": "34.73599000",
                        "longitude": "-80.08812000"
                    },
                    {
                        "id": 113906,
                        "name": "Chesterfield County",
                        "latitude": "34.63978000",
                        "longitude": "-80.15872000"
                    },
                    {
                        "id": 114044,
                        "name": "City View",
                        "latitude": "34.86151000",
                        "longitude": "-82.43151000"
                    },
                    {
                        "id": 114113,
                        "name": "Clarendon County",
                        "latitude": "33.66581000",
                        "longitude": "-80.21640000"
                    },
                    {
                        "id": 114224,
                        "name": "Clearwater",
                        "latitude": "33.49680000",
                        "longitude": "-81.89206000"
                    },
                    {
                        "id": 114234,
                        "name": "Clemson",
                        "latitude": "34.68344000",
                        "longitude": "-82.83737000"
                    },
                    {
                        "id": 114277,
                        "name": "Clinton",
                        "latitude": "34.47263000",
                        "longitude": "-81.88066000"
                    },
                    {
                        "id": 114307,
                        "name": "Clover",
                        "latitude": "35.11125000",
                        "longitude": "-81.22646000"
                    },
                    {
                        "id": 114421,
                        "name": "Colleton County",
                        "latitude": "32.84343000",
                        "longitude": "-80.64968000"
                    },
                    {
                        "id": 114471,
                        "name": "Columbia",
                        "latitude": "34.00071000",
                        "longitude": "-81.03481000"
                    },
                    {
                        "id": 114583,
                        "name": "Conway",
                        "latitude": "33.83600000",
                        "longitude": "-79.04781000"
                    },
                    {
                        "id": 114750,
                        "name": "Cowpens",
                        "latitude": "35.01679000",
                        "longitude": "-81.80399000"
                    },
                    {
                        "id": 115007,
                        "name": "Dalzell",
                        "latitude": "34.01682000",
                        "longitude": "-80.43008000"
                    },
                    {
                        "id": 115049,
                        "name": "Darlington",
                        "latitude": "34.29988000",
                        "longitude": "-79.87617000"
                    },
                    {
                        "id": 115051,
                        "name": "Darlington County",
                        "latitude": "34.33235000",
                        "longitude": "-79.95769000"
                    },
                    {
                        "id": 115239,
                        "name": "Denmark",
                        "latitude": "33.32265000",
                        "longitude": "-81.14232000"
                    },
                    {
                        "id": 115249,
                        "name": "Dentsville",
                        "latitude": "34.06404000",
                        "longitude": "-80.95815000"
                    },
                    {
                        "id": 115342,
                        "name": "Dillon",
                        "latitude": "34.41655000",
                        "longitude": "-79.37116000"
                    },
                    {
                        "id": 115344,
                        "name": "Dillon County",
                        "latitude": "34.39152000",
                        "longitude": "-79.37893000"
                    },
                    {
                        "id": 115411,
                        "name": "Dorchester County",
                        "latitude": "33.07949000",
                        "longitude": "-80.40556000"
                    },
                    {
                        "id": 115506,
                        "name": "Due West",
                        "latitude": "34.33345000",
                        "longitude": "-82.38790000"
                    },
                    {
                        "id": 115522,
                        "name": "Duncan",
                        "latitude": "34.93790000",
                        "longitude": "-82.14511000"
                    },
                    {
                        "id": 115533,
                        "name": "Dunean",
                        "latitude": "34.82484000",
                        "longitude": "-82.41929000"
                    },
                    {
                        "id": 115625,
                        "name": "Easley",
                        "latitude": "34.82984000",
                        "longitude": "-82.60152000"
                    },
                    {
                        "id": 115666,
                        "name": "East Gaffney",
                        "latitude": "35.08013000",
                        "longitude": "-81.63287000"
                    },
                    {
                        "id": 115762,
                        "name": "East Sumter",
                        "latitude": "33.92544000",
                        "longitude": "-80.29619000"
                    },
                    {
                        "id": 115842,
                        "name": "Edgefield",
                        "latitude": "33.78958000",
                        "longitude": "-81.92956000"
                    },
                    {
                        "id": 115843,
                        "name": "Edgefield County",
                        "latitude": "33.77229000",
                        "longitude": "-81.96658000"
                    },
                    {
                        "id": 115876,
                        "name": "Edisto",
                        "latitude": "33.47654000",
                        "longitude": "-80.89870000"
                    },
                    {
                        "id": 115963,
                        "name": "Elgin",
                        "latitude": "34.67293000",
                        "longitude": "-80.71896000"
                    },
                    {
                        "id": 116211,
                        "name": "Estill",
                        "latitude": "32.75489000",
                        "longitude": "-81.24205000"
                    },
                    {
                        "id": 116239,
                        "name": "Eureka Mill",
                        "latitude": "34.71764000",
                        "longitude": "-81.19370000"
                    },
                    {
                        "id": 116301,
                        "name": "Fairfax",
                        "latitude": "32.95905000",
                        "longitude": "-81.23650000"
                    },
                    {
                        "id": 116319,
                        "name": "Fairfield County",
                        "latitude": "34.39511000",
                        "longitude": "-81.12123000"
                    },
                    {
                        "id": 116324,
                        "name": "Fairforest",
                        "latitude": "34.95651000",
                        "longitude": "-82.01011000"
                    },
                    {
                        "id": 116539,
                        "name": "Five Forks",
                        "latitude": "34.80484000",
                        "longitude": "-82.22956000"
                    },
                    {
                        "id": 116580,
                        "name": "Florence",
                        "latitude": "34.19543000",
                        "longitude": "-79.76256000"
                    },
                    {
                        "id": 116587,
                        "name": "Florence County",
                        "latitude": "34.02439000",
                        "longitude": "-79.70282000"
                    },
                    {
                        "id": 116623,
                        "name": "Folly Beach",
                        "latitude": "32.65518000",
                        "longitude": "-79.94037000"
                    },
                    {
                        "id": 116645,
                        "name": "Forest Acres",
                        "latitude": "34.01932000",
                        "longitude": "-80.98981000"
                    },
                    {
                        "id": 116668,
                        "name": "Forestbrook",
                        "latitude": "33.72239000",
                        "longitude": "-78.95809000"
                    },
                    {
                        "id": 116730,
                        "name": "Fort Mill",
                        "latitude": "35.00737000",
                        "longitude": "-80.94508000"
                    },
                    {
                        "id": 116783,
                        "name": "Fountain Inn",
                        "latitude": "34.68901000",
                        "longitude": "-82.19567000"
                    },
                    {
                        "id": 117005,
                        "name": "Gadsden",
                        "latitude": "33.84571000",
                        "longitude": "-80.76592000"
                    },
                    {
                        "id": 117007,
                        "name": "Gaffney",
                        "latitude": "35.07179000",
                        "longitude": "-81.64982000"
                    },
                    {
                        "id": 117051,
                        "name": "Gantt",
                        "latitude": "34.80012000",
                        "longitude": "-82.42429000"
                    },
                    {
                        "id": 117056,
                        "name": "Garden City",
                        "latitude": "33.59295000",
                        "longitude": "-79.00865000"
                    },
                    {
                        "id": 117114,
                        "name": "Gaston",
                        "latitude": "33.81710000",
                        "longitude": "-81.10093000"
                    },
                    {
                        "id": 117159,
                        "name": "Georgetown",
                        "latitude": "33.37683000",
                        "longitude": "-79.29450000"
                    },
                    {
                        "id": 117166,
                        "name": "Georgetown County",
                        "latitude": "33.41275000",
                        "longitude": "-79.29934000"
                    },
                    {
                        "id": 117329,
                        "name": "Gloverville",
                        "latitude": "33.52597000",
                        "longitude": "-81.83011000"
                    },
                    {
                        "id": 117350,
                        "name": "Golden Grove",
                        "latitude": "34.73401000",
                        "longitude": "-82.44374000"
                    },
                    {
                        "id": 117394,
                        "name": "Goose Creek",
                        "latitude": "32.98101000",
                        "longitude": "-80.03259000"
                    },
                    {
                        "id": 117502,
                        "name": "Graniteville",
                        "latitude": "33.56375000",
                        "longitude": "-81.80789000"
                    },
                    {
                        "id": 117571,
                        "name": "Great Falls",
                        "latitude": "34.57514000",
                        "longitude": "-80.90202000"
                    },
                    {
                        "id": 117688,
                        "name": "Greenville",
                        "latitude": "34.85262000",
                        "longitude": "-82.39401000"
                    },
                    {
                        "id": 117697,
                        "name": "Greenville County",
                        "latitude": "34.89431000",
                        "longitude": "-82.37072000"
                    },
                    {
                        "id": 117706,
                        "name": "Greenwood",
                        "latitude": "34.19540000",
                        "longitude": "-82.16179000"
                    },
                    {
                        "id": 117710,
                        "name": "Greenwood County",
                        "latitude": "34.15383000",
                        "longitude": "-82.12593000"
                    },
                    {
                        "id": 117713,
                        "name": "Greer",
                        "latitude": "34.93873000",
                        "longitude": "-82.22706000"
                    },
                    {
                        "id": 117929,
                        "name": "Hampton",
                        "latitude": "32.87794000",
                        "longitude": "-81.12761000"
                    },
                    {
                        "id": 117937,
                        "name": "Hampton County",
                        "latitude": "32.77628000",
                        "longitude": "-81.14070000"
                    },
                    {
                        "id": 117942,
                        "name": "Hanahan",
                        "latitude": "32.91851000",
                        "longitude": "-80.02203000"
                    },
                    {
                        "id": 117994,
                        "name": "Hardeeville",
                        "latitude": "32.28714000",
                        "longitude": "-81.08067000"
                    },
                    {
                        "id": 118104,
                        "name": "Hartsville",
                        "latitude": "34.37404000",
                        "longitude": "-80.07340000"
                    },
                    {
                        "id": 118474,
                        "name": "Hilton Head",
                        "latitude": "32.21632000",
                        "longitude": "-80.75261000"
                    },
                    {
                        "id": 118475,
                        "name": "Hilton Head Island",
                        "latitude": "32.19382000",
                        "longitude": "-80.73816000"
                    },
                    {
                        "id": 118557,
                        "name": "Holly Hill",
                        "latitude": "33.32266000",
                        "longitude": "-80.41370000"
                    },
                    {
                        "id": 118566,
                        "name": "Hollywood",
                        "latitude": "32.73434000",
                        "longitude": "-80.24177000"
                    },
                    {
                        "id": 118591,
                        "name": "Homeland Park",
                        "latitude": "34.47066000",
                        "longitude": "-82.67069000"
                    },
                    {
                        "id": 118616,
                        "name": "Honea Path",
                        "latitude": "34.44650000",
                        "longitude": "-82.39151000"
                    },
                    {
                        "id": 118651,
                        "name": "Hopkins",
                        "latitude": "33.90432000",
                        "longitude": "-80.87703000"
                    },
                    {
                        "id": 118669,
                        "name": "Horry County",
                        "latitude": "33.90448000",
                        "longitude": "-78.97615000"
                    },
                    {
                        "id": 118900,
                        "name": "India Hook",
                        "latitude": "35.00737000",
                        "longitude": "-81.02174000"
                    },
                    {
                        "id": 118945,
                        "name": "Inman",
                        "latitude": "35.04706000",
                        "longitude": "-82.09011000"
                    },
                    {
                        "id": 118946,
                        "name": "Inman Mills",
                        "latitude": "35.04151000",
                        "longitude": "-82.10428000"
                    },
                    {
                        "id": 118987,
                        "name": "Irmo",
                        "latitude": "34.08598000",
                        "longitude": "-81.18315000"
                    },
                    {
                        "id": 119011,
                        "name": "Irwin",
                        "latitude": "34.69376000",
                        "longitude": "-80.82229000"
                    },
                    {
                        "id": 119032,
                        "name": "Isle of Palms",
                        "latitude": "32.78684000",
                        "longitude": "-79.79480000"
                    },
                    {
                        "id": 119047,
                        "name": "Iva",
                        "latitude": "34.30650000",
                        "longitude": "-82.66374000"
                    },
                    {
                        "id": 119069,
                        "name": "Jackson",
                        "latitude": "33.32542000",
                        "longitude": "-81.78789000"
                    },
                    {
                        "id": 119117,
                        "name": "James Island",
                        "latitude": "32.72374000",
                        "longitude": "-79.96284000"
                    },
                    {
                        "id": 119149,
                        "name": "Jasper County",
                        "latitude": "32.42195000",
                        "longitude": "-81.02327000"
                    },
                    {
                        "id": 119250,
                        "name": "Joanna",
                        "latitude": "34.41491000",
                        "longitude": "-81.81240000"
                    },
                    {
                        "id": 119276,
                        "name": "Johnsonville",
                        "latitude": "33.81794000",
                        "longitude": "-79.44922000"
                    },
                    {
                        "id": 119277,
                        "name": "Johnston",
                        "latitude": "33.83208000",
                        "longitude": "-81.80094000"
                    },
                    {
                        "id": 119327,
                        "name": "Judson",
                        "latitude": "34.83317000",
                        "longitude": "-82.42762000"
                    },
                    {
                        "id": 119520,
                        "name": "Kershaw",
                        "latitude": "34.55182000",
                        "longitude": "-80.58368000"
                    },
                    {
                        "id": 119521,
                        "name": "Kershaw County",
                        "latitude": "34.33876000",
                        "longitude": "-80.59026000"
                    },
                    {
                        "id": 119551,
                        "name": "Kiawah Island",
                        "latitude": "32.60824000",
                        "longitude": "-80.08482000"
                    },
                    {
                        "id": 119634,
                        "name": "Kingstree",
                        "latitude": "33.66766000",
                        "longitude": "-79.83063000"
                    },
                    {
                        "id": 119827,
                        "name": "Ladson",
                        "latitude": "32.98573000",
                        "longitude": "-80.10981000"
                    },
                    {
                        "id": 119881,
                        "name": "Lake City",
                        "latitude": "33.87100000",
                        "longitude": "-79.75535000"
                    },
                    {
                        "id": 119949,
                        "name": "Lake Murray of Richland",
                        "latitude": "34.12048000",
                        "longitude": "-81.26450000"
                    },
                    {
                        "id": 119975,
                        "name": "Lake Secession",
                        "latitude": "34.28455000",
                        "longitude": "-82.59457000"
                    },
                    {
                        "id": 120000,
                        "name": "Lake Wylie",
                        "latitude": "35.10848000",
                        "longitude": "-81.04285000"
                    },
                    {
                        "id": 120045,
                        "name": "Lakewood",
                        "latitude": "33.84683000",
                        "longitude": "-80.35008000"
                    },
                    {
                        "id": 120081,
                        "name": "Lancaster",
                        "latitude": "34.72043000",
                        "longitude": "-80.77090000"
                    },
                    {
                        "id": 120090,
                        "name": "Lancaster County",
                        "latitude": "34.68670000",
                        "longitude": "-80.70543000"
                    },
                    {
                        "id": 120094,
                        "name": "Lancaster Mill",
                        "latitude": "34.70931000",
                        "longitude": "-80.79479000"
                    },
                    {
                        "id": 120104,
                        "name": "Landrum",
                        "latitude": "35.17511000",
                        "longitude": "-82.18928000"
                    },
                    {
                        "id": 120113,
                        "name": "Langley",
                        "latitude": "33.51791000",
                        "longitude": "-81.84400000"
                    },
                    {
                        "id": 120176,
                        "name": "Latta",
                        "latitude": "34.33710000",
                        "longitude": "-79.43116000"
                    },
                    {
                        "id": 120194,
                        "name": "Laurel Bay",
                        "latitude": "32.45019000",
                        "longitude": "-80.78483000"
                    },
                    {
                        "id": 120206,
                        "name": "Laurens",
                        "latitude": "34.49901000",
                        "longitude": "-82.01426000"
                    },
                    {
                        "id": 120209,
                        "name": "Laurens County",
                        "latitude": "34.48357000",
                        "longitude": "-82.00593000"
                    },
                    {
                        "id": 120313,
                        "name": "Lee County",
                        "latitude": "34.16329000",
                        "longitude": "-80.25452000"
                    },
                    {
                        "id": 120329,
                        "name": "Leesville",
                        "latitude": "33.91653000",
                        "longitude": "-81.51344000"
                    },
                    {
                        "id": 120398,
                        "name": "Lesslie",
                        "latitude": "34.89070000",
                        "longitude": "-80.95647000"
                    },
                    {
                        "id": 120443,
                        "name": "Lexington",
                        "latitude": "33.98154000",
                        "longitude": "-81.23621000"
                    },
                    {
                        "id": 120453,
                        "name": "Lexington County",
                        "latitude": "33.90233000",
                        "longitude": "-81.27219000"
                    },
                    {
                        "id": 120464,
                        "name": "Liberty",
                        "latitude": "34.78789000",
                        "longitude": "-82.69236000"
                    },
                    {
                        "id": 120553,
                        "name": "Lincolnville",
                        "latitude": "33.00684000",
                        "longitude": "-80.15537000"
                    },
                    {
                        "id": 120623,
                        "name": "Little River",
                        "latitude": "33.87323000",
                        "longitude": "-78.61418000"
                    },
                    {
                        "id": 120776,
                        "name": "Loris",
                        "latitude": "34.05628000",
                        "longitude": "-78.89030000"
                    },
                    {
                        "id": 120873,
                        "name": "Lugoff",
                        "latitude": "34.22737000",
                        "longitude": "-80.68925000"
                    },
                    {
                        "id": 120909,
                        "name": "Lyman",
                        "latitude": "34.94817000",
                        "longitude": "-82.12733000"
                    },
                    {
                        "id": 121134,
                        "name": "Manning",
                        "latitude": "33.69516000",
                        "longitude": "-80.21091000"
                    },
                    {
                        "id": 121238,
                        "name": "Marion",
                        "latitude": "34.17822000",
                        "longitude": "-79.40061000"
                    },
                    {
                        "id": 121257,
                        "name": "Marion County",
                        "latitude": "34.08006000",
                        "longitude": "-79.36251000"
                    },
                    {
                        "id": 121276,
                        "name": "Marlboro County",
                        "latitude": "34.60199000",
                        "longitude": "-79.67863000"
                    },
                    {
                        "id": 121420,
                        "name": "Mauldin",
                        "latitude": "34.77873000",
                        "longitude": "-82.31012000"
                    },
                    {
                        "id": 121444,
                        "name": "Mayo",
                        "latitude": "35.08401000",
                        "longitude": "-81.85983000"
                    },
                    {
                        "id": 121473,
                        "name": "McColl",
                        "latitude": "34.66877000",
                        "longitude": "-79.54533000"
                    },
                    {
                        "id": 121483,
                        "name": "McCormick",
                        "latitude": "33.91346000",
                        "longitude": "-82.29346000"
                    },
                    {
                        "id": 121484,
                        "name": "McCormick County",
                        "latitude": "33.89955000",
                        "longitude": "-82.30988000"
                    },
                    {
                        "id": 121615,
                        "name": "Meggett",
                        "latitude": "32.71796000",
                        "longitude": "-80.23899000"
                    },
                    {
                        "id": 122034,
                        "name": "Monarch Mill",
                        "latitude": "34.71610000",
                        "longitude": "-81.58500000"
                    },
                    {
                        "id": 122035,
                        "name": "Moncks Corner",
                        "latitude": "33.19632000",
                        "longitude": "-80.01429000"
                    },
                    {
                        "id": 122376,
                        "name": "Mount Pleasant",
                        "latitude": "32.79407000",
                        "longitude": "-79.86259000"
                    },
                    {
                        "id": 122462,
                        "name": "Mullins",
                        "latitude": "34.20572000",
                        "longitude": "-79.25449000"
                    },
                    {
                        "id": 122489,
                        "name": "Murphys Estates",
                        "latitude": "33.60125000",
                        "longitude": "-81.94428000"
                    },
                    {
                        "id": 122497,
                        "name": "Murrells Inlet",
                        "latitude": "33.55100000",
                        "longitude": "-79.04143000"
                    },
                    {
                        "id": 122520,
                        "name": "Myrtle Beach",
                        "latitude": "33.68906000",
                        "longitude": "-78.88669000"
                    },
                    {
                        "id": 122704,
                        "name": "New Ellenton",
                        "latitude": "33.42153000",
                        "longitude": "-81.68567000"
                    },
                    {
                        "id": 122811,
                        "name": "Newberry",
                        "latitude": "34.27458000",
                        "longitude": "-81.61872000"
                    },
                    {
                        "id": 122813,
                        "name": "Newberry County",
                        "latitude": "34.28981000",
                        "longitude": "-81.60012000"
                    },
                    {
                        "id": 122844,
                        "name": "Newport",
                        "latitude": "34.98986000",
                        "longitude": "-81.10091000"
                    },
                    {
                        "id": 122902,
                        "name": "Ninety Six",
                        "latitude": "34.17513000",
                        "longitude": "-82.02401000"
                    },
                    {
                        "id": 122969,
                        "name": "North Augusta",
                        "latitude": "33.50180000",
                        "longitude": "-81.96512000"
                    },
                    {
                        "id": 123005,
                        "name": "North Charleston",
                        "latitude": "32.85462000",
                        "longitude": "-79.97481000"
                    },
                    {
                        "id": 123036,
                        "name": "North Hartsville",
                        "latitude": "34.39377000",
                        "longitude": "-80.06951000"
                    },
                    {
                        "id": 123070,
                        "name": "North Myrtle Beach",
                        "latitude": "33.81601000",
                        "longitude": "-78.68002000"
                    },
                    {
                        "id": 123156,
                        "name": "Northlake",
                        "latitude": "34.56622000",
                        "longitude": "-82.68402000"
                    },
                    {
                        "id": 123241,
                        "name": "Oak Grove",
                        "latitude": "33.98090000",
                        "longitude": "-81.14286000"
                    },
                    {
                        "id": 123286,
                        "name": "Oakland",
                        "latitude": "33.98293000",
                        "longitude": "-80.48842000"
                    },
                    {
                        "id": 123349,
                        "name": "Oconee County",
                        "latitude": "34.75351000",
                        "longitude": "-83.06588000"
                    },
                    {
                        "id": 123526,
                        "name": "Orangeburg",
                        "latitude": "33.49182000",
                        "longitude": "-80.85565000"
                    },
                    {
                        "id": 123528,
                        "name": "Orangeburg County",
                        "latitude": "33.43899000",
                        "longitude": "-80.80030000"
                    },
                    {
                        "id": 123712,
                        "name": "Pacolet",
                        "latitude": "34.89902000",
                        "longitude": "-81.76177000"
                    },
                    {
                        "id": 123721,
                        "name": "Pageland",
                        "latitude": "34.77321000",
                        "longitude": "-80.39173000"
                    },
                    {
                        "id": 123795,
                        "name": "Pamplico",
                        "latitude": "33.99600000",
                        "longitude": "-79.57006000"
                    },
                    {
                        "id": 123859,
                        "name": "Parker",
                        "latitude": "34.85067000",
                        "longitude": "-82.45346000"
                    },
                    {
                        "id": 124017,
                        "name": "Pendleton",
                        "latitude": "34.65177000",
                        "longitude": "-82.78375000"
                    },
                    {
                        "id": 124155,
                        "name": "Pickens",
                        "latitude": "34.88345000",
                        "longitude": "-82.70736000"
                    },
                    {
                        "id": 124158,
                        "name": "Pickens County",
                        "latitude": "34.88752000",
                        "longitude": "-82.72532000"
                    },
                    {
                        "id": 124166,
                        "name": "Piedmont",
                        "latitude": "34.70234000",
                        "longitude": "-82.46457000"
                    },
                    {
                        "id": 124256,
                        "name": "Pineridge",
                        "latitude": "33.91043000",
                        "longitude": "-81.10454000"
                    },
                    {
                        "id": 124531,
                        "name": "Port Royal",
                        "latitude": "32.37908000",
                        "longitude": "-80.69261000"
                    },
                    {
                        "id": 124610,
                        "name": "Powdersville",
                        "latitude": "34.79178000",
                        "longitude": "-82.49291000"
                    },
                    {
                        "id": 124699,
                        "name": "Privateer",
                        "latitude": "33.83321000",
                        "longitude": "-80.41425000"
                    },
                    {
                        "id": 124712,
                        "name": "Prosperity",
                        "latitude": "34.20931000",
                        "longitude": "-81.53316000"
                    },
                    {
                        "id": 124906,
                        "name": "Ravenel",
                        "latitude": "32.76323000",
                        "longitude": "-80.25010000"
                    },
                    {
                        "id": 124936,
                        "name": "Red Bank",
                        "latitude": "33.93209000",
                        "longitude": "-81.23843000"
                    },
                    {
                        "id": 124946,
                        "name": "Red Hill",
                        "latitude": "33.82073000",
                        "longitude": "-79.01892000"
                    },
                    {
                        "id": 125075,
                        "name": "Richland County",
                        "latitude": "34.02180000",
                        "longitude": "-80.90304000"
                    },
                    {
                        "id": 125124,
                        "name": "Ridgeland",
                        "latitude": "32.48074000",
                        "longitude": "-80.98039000"
                    },
                    {
                        "id": 125129,
                        "name": "Ridgeville",
                        "latitude": "33.09572000",
                        "longitude": "-80.31537000"
                    },
                    {
                        "id": 125280,
                        "name": "Rock Hill",
                        "latitude": "34.92487000",
                        "longitude": "-81.02508000"
                    },
                    {
                        "id": 125344,
                        "name": "Roebuck",
                        "latitude": "34.87957000",
                        "longitude": "-81.96621000"
                    },
                    {
                        "id": 125597,
                        "name": "Saint Andrews",
                        "latitude": "34.04543000",
                        "longitude": "-81.12926000"
                    },
                    {
                        "id": 125642,
                        "name": "Saint George",
                        "latitude": "33.18600000",
                        "longitude": "-80.57565000"
                    },
                    {
                        "id": 125696,
                        "name": "Saint Matthews",
                        "latitude": "33.66488000",
                        "longitude": "-80.77787000"
                    },
                    {
                        "id": 125716,
                        "name": "Saint Stephen",
                        "latitude": "33.40433000",
                        "longitude": "-79.92174000"
                    },
                    {
                        "id": 125772,
                        "name": "Saluda",
                        "latitude": "34.00152000",
                        "longitude": "-81.77205000"
                    },
                    {
                        "id": 125774,
                        "name": "Saluda County",
                        "latitude": "34.00614000",
                        "longitude": "-81.72692000"
                    },
                    {
                        "id": 125890,
                        "name": "Sangaree",
                        "latitude": "33.03545000",
                        "longitude": "-80.12787000"
                    },
                    {
                        "id": 125897,
                        "name": "Sans Souci",
                        "latitude": "34.87790000",
                        "longitude": "-82.42401000"
                    },
                    {
                        "id": 125984,
                        "name": "Saxon",
                        "latitude": "34.96123000",
                        "longitude": "-81.96733000"
                    },
                    {
                        "id": 126082,
                        "name": "Seabrook Island",
                        "latitude": "32.57713000",
                        "longitude": "-80.17065000"
                    },
                    {
                        "id": 126156,
                        "name": "Seneca",
                        "latitude": "34.68566000",
                        "longitude": "-82.95320000"
                    },
                    {
                        "id": 126174,
                        "name": "Seven Oaks",
                        "latitude": "34.04876000",
                        "longitude": "-81.14648000"
                    },
                    {
                        "id": 126291,
                        "name": "Shell Point",
                        "latitude": "32.38353000",
                        "longitude": "-80.73594000"
                    },
                    {
                        "id": 126452,
                        "name": "Simpsonville",
                        "latitude": "34.73706000",
                        "longitude": "-82.25428000"
                    },
                    {
                        "id": 126491,
                        "name": "Slater-Marietta",
                        "latitude": "35.03472000",
                        "longitude": "-82.49265000"
                    },
                    {
                        "id": 126554,
                        "name": "Socastee",
                        "latitude": "33.68350000",
                        "longitude": "-78.99837000"
                    },
                    {
                        "id": 126641,
                        "name": "South Congaree",
                        "latitude": "33.91099000",
                        "longitude": "-81.13565000"
                    },
                    {
                        "id": 126732,
                        "name": "South Sumter",
                        "latitude": "33.90571000",
                        "longitude": "-80.34619000"
                    },
                    {
                        "id": 126769,
                        "name": "Southern Shops",
                        "latitude": "34.98595000",
                        "longitude": "-81.99455000"
                    },
                    {
                        "id": 126814,
                        "name": "Spartanburg",
                        "latitude": "34.94957000",
                        "longitude": "-81.93205000"
                    },
                    {
                        "id": 126815,
                        "name": "Spartanburg County",
                        "latitude": "34.93126000",
                        "longitude": "-81.99068000"
                    },
                    {
                        "id": 126886,
                        "name": "Springdale",
                        "latitude": "33.95932000",
                        "longitude": "-81.10898000"
                    },
                    {
                        "id": 126994,
                        "name": "Stateburg",
                        "latitude": "33.95765000",
                        "longitude": "-80.53481000"
                    },
                    {
                        "id": 127192,
                        "name": "Sullivans Island",
                        "latitude": "32.76323000",
                        "longitude": "-79.83675000"
                    },
                    {
                        "id": 127210,
                        "name": "Summerville",
                        "latitude": "33.01850000",
                        "longitude": "-80.17565000"
                    },
                    {
                        "id": 127227,
                        "name": "Sumter",
                        "latitude": "33.92044000",
                        "longitude": "-80.34147000"
                    },
                    {
                        "id": 127231,
                        "name": "Sumter County",
                        "latitude": "33.91617000",
                        "longitude": "-80.38232000"
                    },
                    {
                        "id": 127288,
                        "name": "Surfside Beach",
                        "latitude": "33.60600000",
                        "longitude": "-78.97309000"
                    },
                    {
                        "id": 127461,
                        "name": "Taylors",
                        "latitude": "34.92039000",
                        "longitude": "-82.29623000"
                    },
                    {
                        "id": 127482,
                        "name": "Tega Cay",
                        "latitude": "35.02431000",
                        "longitude": "-81.02785000"
                    },
                    {
                        "id": 127645,
                        "name": "Tigerville",
                        "latitude": "35.06845000",
                        "longitude": "-82.36845000"
                    },
                    {
                        "id": 127662,
                        "name": "Timmonsville",
                        "latitude": "34.13488000",
                        "longitude": "-79.93979000"
                    },
                    {
                        "id": 127783,
                        "name": "Travelers Rest",
                        "latitude": "34.96762000",
                        "longitude": "-82.44345000"
                    },
                    {
                        "id": 127974,
                        "name": "Union",
                        "latitude": "34.71541000",
                        "longitude": "-81.62371000"
                    },
                    {
                        "id": 127996,
                        "name": "Union County",
                        "latitude": "34.68928000",
                        "longitude": "-81.61942000"
                    },
                    {
                        "id": 128065,
                        "name": "Utica",
                        "latitude": "34.67816000",
                        "longitude": "-82.93154000"
                    },
                    {
                        "id": 128107,
                        "name": "Valley Falls",
                        "latitude": "35.01595000",
                        "longitude": "-81.97483000"
                    },
                    {
                        "id": 128156,
                        "name": "Varnville",
                        "latitude": "32.85044000",
                        "longitude": "-81.07927000"
                    },
                    {
                        "id": 128320,
                        "name": "Wade Hampton",
                        "latitude": "34.90373000",
                        "longitude": "-82.33317000"
                    },
                    {
                        "id": 128382,
                        "name": "Walhalla",
                        "latitude": "34.76482000",
                        "longitude": "-83.06404000"
                    },
                    {
                        "id": 128428,
                        "name": "Walterboro",
                        "latitude": "32.90517000",
                        "longitude": "-80.66677000"
                    },
                    {
                        "id": 128464,
                        "name": "Ware Shoals",
                        "latitude": "34.39845000",
                        "longitude": "-82.24679000"
                    },
                    {
                        "id": 128509,
                        "name": "Warrenville",
                        "latitude": "33.55097000",
                        "longitude": "-81.80400000"
                    },
                    {
                        "id": 128643,
                        "name": "Watts Mills",
                        "latitude": "34.51641000",
                        "longitude": "-81.98580000"
                    },
                    {
                        "id": 128748,
                        "name": "Wedgefield",
                        "latitude": "33.89266000",
                        "longitude": "-80.51814000"
                    },
                    {
                        "id": 128749,
                        "name": "Wedgewood",
                        "latitude": "33.88377000",
                        "longitude": "-80.51258000"
                    },
                    {
                        "id": 128767,
                        "name": "Welcome",
                        "latitude": "34.82651000",
                        "longitude": "-82.43901000"
                    },
                    {
                        "id": 128775,
                        "name": "Wellford",
                        "latitude": "34.95095000",
                        "longitude": "-82.10594000"
                    },
                    {
                        "id": 128848,
                        "name": "West Columbia",
                        "latitude": "33.99349000",
                        "longitude": "-81.07398000"
                    },
                    {
                        "id": 129045,
                        "name": "Westminster",
                        "latitude": "34.66482000",
                        "longitude": "-83.09654000"
                    },
                    {
                        "id": 129205,
                        "name": "Whitmire",
                        "latitude": "34.50291000",
                        "longitude": "-81.61149000"
                    },
                    {
                        "id": 129252,
                        "name": "Wilkinson Heights",
                        "latitude": "33.50210000",
                        "longitude": "-80.83315000"
                    },
                    {
                        "id": 129272,
                        "name": "Williamsburg County",
                        "latitude": "33.61993000",
                        "longitude": "-79.72771000"
                    },
                    {
                        "id": 129283,
                        "name": "Williamston",
                        "latitude": "34.61845000",
                        "longitude": "-82.47791000"
                    },
                    {
                        "id": 129297,
                        "name": "Williston",
                        "latitude": "33.40265000",
                        "longitude": "-81.42011000"
                    },
                    {
                        "id": 129419,
                        "name": "Winnsboro",
                        "latitude": "34.38070000",
                        "longitude": "-81.08648000"
                    },
                    {
                        "id": 129421,
                        "name": "Winnsboro Mills",
                        "latitude": "34.36181000",
                        "longitude": "-81.08537000"
                    },
                    {
                        "id": 129517,
                        "name": "Woodfield",
                        "latitude": "34.05932000",
                        "longitude": "-80.93092000"
                    },
                    {
                        "id": 129547,
                        "name": "Woodruff",
                        "latitude": "34.73957000",
                        "longitude": "-82.03705000"
                    },
                    {
                        "id": 129691,
                        "name": "York",
                        "latitude": "34.99430000",
                        "longitude": "-81.24202000"
                    },
                    {
                        "id": 129695,
                        "name": "York County",
                        "latitude": "34.97475000",
                        "longitude": "-81.18442000"
                    }
                ]
            },
            {
                "id": 1445,
                "name": "South Dakota",
                "iso2": "SD",
                "latitude": "43.96951480",
                "longitude": "-99.90181310",
                "type": "state",
                "cities": [
                    {
                        "id": 110977,
                        "name": "Aberdeen",
                        "latitude": "45.46470000",
                        "longitude": "-98.48648000"
                    },
                    {
                        "id": 111156,
                        "name": "Alexandria",
                        "latitude": "43.65359000",
                        "longitude": "-97.78285000"
                    },
                    {
                        "id": 111479,
                        "name": "Armour",
                        "latitude": "43.31860000",
                        "longitude": "-98.34675000"
                    },
                    {
                        "id": 111664,
                        "name": "Aurora County",
                        "latitude": "43.71801000",
                        "longitude": "-98.56155000"
                    },
                    {
                        "id": 111782,
                        "name": "Baltic",
                        "latitude": "43.76136000",
                        "longitude": "-96.74033000"
                    },
                    {
                        "id": 111970,
                        "name": "Beadle County",
                        "latitude": "44.41448000",
                        "longitude": "-98.27811000"
                    },
                    {
                        "id": 112081,
                        "name": "Belle Fourche",
                        "latitude": "44.67137000",
                        "longitude": "-103.85215000"
                    },
                    {
                        "id": 112174,
                        "name": "Bennett County",
                        "latitude": "43.19492000",
                        "longitude": "-101.66397000"
                    },
                    {
                        "id": 112215,
                        "name": "Beresford",
                        "latitude": "43.08054000",
                        "longitude": "-96.77366000"
                    },
                    {
                        "id": 112368,
                        "name": "Bison",
                        "latitude": "45.52026000",
                        "longitude": "-102.46127000"
                    },
                    {
                        "id": 112388,
                        "name": "Blackhawk",
                        "latitude": "44.15110000",
                        "longitude": "-103.30796000"
                    },
                    {
                        "id": 112528,
                        "name": "Bon Homme County",
                        "latitude": "42.98837000",
                        "longitude": "-97.88463000"
                    },
                    {
                        "id": 112636,
                        "name": "Box Elder",
                        "latitude": "44.11249000",
                        "longitude": "-103.06823000"
                    },
                    {
                        "id": 112691,
                        "name": "Brandon",
                        "latitude": "43.59470000",
                        "longitude": "-96.57199000"
                    },
                    {
                        "id": 112819,
                        "name": "Britton",
                        "latitude": "45.79162000",
                        "longitude": "-97.75094000"
                    },
                    {
                        "id": 112861,
                        "name": "Brookings",
                        "latitude": "44.31136000",
                        "longitude": "-96.79839000"
                    },
                    {
                        "id": 112863,
                        "name": "Brookings County",
                        "latitude": "44.36968000",
                        "longitude": "-96.79042000"
                    },
                    {
                        "id": 112913,
                        "name": "Brown County",
                        "latitude": "45.58972000",
                        "longitude": "-98.35161000"
                    },
                    {
                        "id": 112945,
                        "name": "Brule County",
                        "latitude": "43.71806000",
                        "longitude": "-99.08094000"
                    },
                    {
                        "id": 113015,
                        "name": "Buffalo",
                        "latitude": "45.58416000",
                        "longitude": "-103.54603000"
                    },
                    {
                        "id": 113019,
                        "name": "Buffalo County",
                        "latitude": "44.07635000",
                        "longitude": "-99.20496000"
                    },
                    {
                        "id": 113055,
                        "name": "Burke",
                        "latitude": "43.18250000",
                        "longitude": "-99.29205000"
                    },
                    {
                        "id": 113127,
                        "name": "Butte County",
                        "latitude": "44.90583000",
                        "longitude": "-103.50802000"
                    },
                    {
                        "id": 113302,
                        "name": "Campbell County",
                        "latitude": "45.77113000",
                        "longitude": "-100.05163000"
                    },
                    {
                        "id": 113350,
                        "name": "Canton",
                        "latitude": "43.30081000",
                        "longitude": "-96.59282000"
                    },
                    {
                        "id": 113718,
                        "name": "Chamberlain",
                        "latitude": "43.81083000",
                        "longitude": "-99.33066000"
                    },
                    {
                        "id": 113758,
                        "name": "Charles Mix County",
                        "latitude": "43.20791000",
                        "longitude": "-98.58789000"
                    },
                    {
                        "id": 114120,
                        "name": "Clark",
                        "latitude": "44.87774000",
                        "longitude": "-97.73314000"
                    },
                    {
                        "id": 114127,
                        "name": "Clark County",
                        "latitude": "44.85825000",
                        "longitude": "-97.72950000"
                    },
                    {
                        "id": 114190,
                        "name": "Clay County",
                        "latitude": "42.91465000",
                        "longitude": "-96.97566000"
                    },
                    {
                        "id": 114210,
                        "name": "Clear Lake",
                        "latitude": "44.74580000",
                        "longitude": "-96.68256000"
                    },
                    {
                        "id": 114363,
                        "name": "Codington County",
                        "latitude": "44.97785000",
                        "longitude": "-97.18862000"
                    },
                    {
                        "id": 114451,
                        "name": "Colonial Pine Hills",
                        "latitude": "44.00777000",
                        "longitude": "-103.31546000"
                    },
                    {
                        "id": 114671,
                        "name": "Corson County",
                        "latitude": "45.70860000",
                        "longitude": "-101.19687000"
                    },
                    {
                        "id": 114839,
                        "name": "Crooks",
                        "latitude": "43.66470000",
                        "longitude": "-96.81089000"
                    },
                    {
                        "id": 114934,
                        "name": "Custer",
                        "latitude": "43.76665000",
                        "longitude": "-103.59881000"
                    },
                    {
                        "id": 114940,
                        "name": "Custer County",
                        "latitude": "43.67763000",
                        "longitude": "-103.45154000"
                    },
                    {
                        "id": 114978,
                        "name": "Dakota Dunes",
                        "latitude": "42.48749000",
                        "longitude": "-96.48642000"
                    },
                    {
                        "id": 115079,
                        "name": "Davison County",
                        "latitude": "43.67474000",
                        "longitude": "-98.14600000"
                    },
                    {
                        "id": 115089,
                        "name": "Day County",
                        "latitude": "45.36715000",
                        "longitude": "-97.60741000"
                    },
                    {
                        "id": 115114,
                        "name": "De Smet",
                        "latitude": "44.38747000",
                        "longitude": "-97.55035000"
                    },
                    {
                        "id": 115142,
                        "name": "Deadwood",
                        "latitude": "44.37665000",
                        "longitude": "-103.72964000"
                    },
                    {
                        "id": 115214,
                        "name": "Dell Rapids",
                        "latitude": "43.82608000",
                        "longitude": "-96.70616000"
                    },
                    {
                        "id": 115294,
                        "name": "Deuel County",
                        "latitude": "44.76006000",
                        "longitude": "-96.66797000"
                    },
                    {
                        "id": 115304,
                        "name": "Dewey County",
                        "latitude": "45.15662000",
                        "longitude": "-100.87186000"
                    },
                    {
                        "id": 115431,
                        "name": "Douglas County",
                        "latitude": "43.38692000",
                        "longitude": "-98.36610000"
                    },
                    {
                        "id": 115559,
                        "name": "Dupree",
                        "latitude": "45.04748000",
                        "longitude": "-101.60099000"
                    },
                    {
                        "id": 115599,
                        "name": "Eagle Butte",
                        "latitude": "45.00248000",
                        "longitude": "-101.23349000"
                    },
                    {
                        "id": 115883,
                        "name": "Edmunds County",
                        "latitude": "45.41880000",
                        "longitude": "-99.21533000"
                    },
                    {
                        "id": 115990,
                        "name": "Elk Point",
                        "latitude": "42.68333000",
                        "longitude": "-96.68365000"
                    },
                    {
                        "id": 116375,
                        "name": "Fall River County",
                        "latitude": "43.23939000",
                        "longitude": "-103.52756000"
                    },
                    {
                        "id": 116433,
                        "name": "Faulk County",
                        "latitude": "45.07101000",
                        "longitude": "-99.14525000"
                    },
                    {
                        "id": 116435,
                        "name": "Faulkton",
                        "latitude": "45.03497000",
                        "longitude": "-99.12400000"
                    },
                    {
                        "id": 116549,
                        "name": "Flandreau",
                        "latitude": "44.04942000",
                        "longitude": "-96.59532000"
                    },
                    {
                        "id": 116742,
                        "name": "Fort Pierre",
                        "latitude": "44.35359000",
                        "longitude": "-100.37374000"
                    },
                    {
                        "id": 116755,
                        "name": "Fort Thompson",
                        "latitude": "44.06860000",
                        "longitude": "-99.43788000"
                    },
                    {
                        "id": 116908,
                        "name": "Freeman",
                        "latitude": "43.35249000",
                        "longitude": "-97.43729000"
                    },
                    {
                        "id": 117097,
                        "name": "Garretson",
                        "latitude": "43.71747000",
                        "longitude": "-96.50282000"
                    },
                    {
                        "id": 117180,
                        "name": "Gettysburg",
                        "latitude": "45.01165000",
                        "longitude": "-99.95567000"
                    },
                    {
                        "id": 117514,
                        "name": "Grant County",
                        "latitude": "45.17194000",
                        "longitude": "-96.76769000"
                    },
                    {
                        "id": 117717,
                        "name": "Gregory",
                        "latitude": "43.23222000",
                        "longitude": "-99.43038000"
                    },
                    {
                        "id": 117718,
                        "name": "Gregory County",
                        "latitude": "43.19238000",
                        "longitude": "-99.18561000"
                    },
                    {
                        "id": 117751,
                        "name": "Groton",
                        "latitude": "45.44746000",
                        "longitude": "-98.09871000"
                    },
                    {
                        "id": 117823,
                        "name": "Haakon County",
                        "latitude": "44.29443000",
                        "longitude": "-101.53999000"
                    },
                    {
                        "id": 117911,
                        "name": "Hamlin County",
                        "latitude": "44.67376000",
                        "longitude": "-97.18833000"
                    },
                    {
                        "id": 117959,
                        "name": "Hand County",
                        "latitude": "44.54778000",
                        "longitude": "-99.00494000"
                    },
                    {
                        "id": 117979,
                        "name": "Hanson County",
                        "latitude": "43.67482000",
                        "longitude": "-97.78734000"
                    },
                    {
                        "id": 118005,
                        "name": "Harding County",
                        "latitude": "45.58035000",
                        "longitude": "-103.49577000"
                    },
                    {
                        "id": 118051,
                        "name": "Harrisburg",
                        "latitude": "43.43137000",
                        "longitude": "-96.69727000"
                    },
                    {
                        "id": 118093,
                        "name": "Hartford",
                        "latitude": "43.62303000",
                        "longitude": "-96.94255000"
                    },
                    {
                        "id": 118195,
                        "name": "Hayti",
                        "latitude": "44.65719000",
                        "longitude": "-97.20507000"
                    },
                    {
                        "id": 118422,
                        "name": "Highmore",
                        "latitude": "44.52137000",
                        "longitude": "-99.44150000"
                    },
                    {
                        "id": 118683,
                        "name": "Hot Springs",
                        "latitude": "43.43165000",
                        "longitude": "-103.47436000"
                    },
                    {
                        "id": 118709,
                        "name": "Howard",
                        "latitude": "44.01081000",
                        "longitude": "-97.52674000"
                    },
                    {
                        "id": 118759,
                        "name": "Hughes County",
                        "latitude": "44.38903000",
                        "longitude": "-99.99605000"
                    },
                    {
                        "id": 118824,
                        "name": "Huron",
                        "latitude": "44.36332000",
                        "longitude": "-98.21426000"
                    },
                    {
                        "id": 118837,
                        "name": "Hutchinson County",
                        "latitude": "43.33485000",
                        "longitude": "-97.75442000"
                    },
                    {
                        "id": 118848,
                        "name": "Hyde County",
                        "latitude": "44.54736000",
                        "longitude": "-99.48711000"
                    },
                    {
                        "id": 118983,
                        "name": "Ipswich",
                        "latitude": "45.44442000",
                        "longitude": "-99.02928000"
                    },
                    {
                        "id": 119096,
                        "name": "Jackson County",
                        "latitude": "43.69421000",
                        "longitude": "-101.62813000"
                    },
                    {
                        "id": 119223,
                        "name": "Jerauld County",
                        "latitude": "44.06635000",
                        "longitude": "-98.62973000"
                    },
                    {
                        "id": 119297,
                        "name": "Jones County",
                        "latitude": "43.96061000",
                        "longitude": "-100.68972000"
                    },
                    {
                        "id": 119350,
                        "name": "Kadoka",
                        "latitude": "43.83388000",
                        "longitude": "-101.50987000"
                    },
                    {
                        "id": 119464,
                        "name": "Kennebec",
                        "latitude": "43.90360000",
                        "longitude": "-99.86178000"
                    },
                    {
                        "id": 119611,
                        "name": "Kingsbury County",
                        "latitude": "44.36959000",
                        "longitude": "-97.49148000"
                    },
                    {
                        "id": 119863,
                        "name": "Lake Andes",
                        "latitude": "43.15638000",
                        "longitude": "-98.54147000"
                    },
                    {
                        "id": 119895,
                        "name": "Lake County",
                        "latitude": "44.02204000",
                        "longitude": "-97.12938000"
                    },
                    {
                        "id": 120238,
                        "name": "Lawrence County",
                        "latitude": "44.35863000",
                        "longitude": "-103.79222000"
                    },
                    {
                        "id": 120270,
                        "name": "Lead",
                        "latitude": "44.35221000",
                        "longitude": "-103.76520000"
                    },
                    {
                        "id": 120357,
                        "name": "Lemmon",
                        "latitude": "45.94083000",
                        "longitude": "-102.15932000"
                    },
                    {
                        "id": 120370,
                        "name": "Lennox",
                        "latitude": "43.35415000",
                        "longitude": "-96.89200000"
                    },
                    {
                        "id": 120381,
                        "name": "Leola",
                        "latitude": "45.72275000",
                        "longitude": "-98.94094000"
                    },
                    {
                        "id": 120528,
                        "name": "Lincoln County",
                        "latitude": "43.27892000",
                        "longitude": "-96.72182000"
                    },
                    {
                        "id": 120911,
                        "name": "Lyman County",
                        "latitude": "43.89582000",
                        "longitude": "-99.84738000"
                    },
                    {
                        "id": 121000,
                        "name": "Madison",
                        "latitude": "44.00608000",
                        "longitude": "-97.11395000"
                    },
                    {
                        "id": 121321,
                        "name": "Marshall County",
                        "latitude": "45.75867000",
                        "longitude": "-97.59850000"
                    },
                    {
                        "id": 121336,
                        "name": "Martin",
                        "latitude": "43.17250000",
                        "longitude": "-101.73265000"
                    },
                    {
                        "id": 121480,
                        "name": "McCook County",
                        "latitude": "43.67431000",
                        "longitude": "-97.36844000"
                    },
                    {
                        "id": 121512,
                        "name": "McIntosh",
                        "latitude": "45.92139000",
                        "longitude": "-101.34958000"
                    },
                    {
                        "id": 121547,
                        "name": "McPherson County",
                        "latitude": "45.76637000",
                        "longitude": "-99.22146000"
                    },
                    {
                        "id": 121558,
                        "name": "Meade County",
                        "latitude": "44.56684000",
                        "longitude": "-102.71687000"
                    },
                    {
                        "id": 121625,
                        "name": "Mellette County",
                        "latitude": "43.58127000",
                        "longitude": "-100.75999000"
                    },
                    {
                        "id": 121842,
                        "name": "Milbank",
                        "latitude": "45.21913000",
                        "longitude": "-96.63562000"
                    },
                    {
                        "id": 121879,
                        "name": "Miller",
                        "latitude": "44.51831000",
                        "longitude": "-98.98843000"
                    },
                    {
                        "id": 121933,
                        "name": "Miner County",
                        "latitude": "44.02195000",
                        "longitude": "-97.61025000"
                    },
                    {
                        "id": 121953,
                        "name": "Minnehaha County",
                        "latitude": "43.67418000",
                        "longitude": "-96.79144000"
                    },
                    {
                        "id": 121982,
                        "name": "Mission",
                        "latitude": "43.30584000",
                        "longitude": "-100.65819000"
                    },
                    {
                        "id": 121997,
                        "name": "Mitchell",
                        "latitude": "43.70943000",
                        "longitude": "-98.02980000"
                    },
                    {
                        "id": 122012,
                        "name": "Mobridge",
                        "latitude": "45.53722000",
                        "longitude": "-100.42791000"
                    },
                    {
                        "id": 122197,
                        "name": "Moody County",
                        "latitude": "44.02201000",
                        "longitude": "-96.67092000"
                    },
                    {
                        "id": 122323,
                        "name": "Mound City",
                        "latitude": "45.72527000",
                        "longitude": "-100.06845000"
                    },
                    {
                        "id": 122479,
                        "name": "Murdo",
                        "latitude": "43.88832000",
                        "longitude": "-100.71291000"
                    },
                    {
                        "id": 123016,
                        "name": "North Eagle Butte",
                        "latitude": "45.00415000",
                        "longitude": "-101.23376000"
                    },
                    {
                        "id": 123106,
                        "name": "North Sioux City",
                        "latitude": "42.52722000",
                        "longitude": "-96.48309000"
                    },
                    {
                        "id": 123109,
                        "name": "North Spearfish",
                        "latitude": "44.50665000",
                        "longitude": "-103.89215000"
                    },
                    {
                        "id": 123374,
                        "name": "Oglala",
                        "latitude": "43.18859000",
                        "longitude": "-102.73962000"
                    },
                    {
                        "id": 123375,
                        "name": "Oglala Lakota County",
                        "latitude": "43.33559000",
                        "longitude": "-102.55162000"
                    },
                    {
                        "id": 123448,
                        "name": "Olivet",
                        "latitude": "43.24082000",
                        "longitude": "-97.67534000"
                    },
                    {
                        "id": 123480,
                        "name": "Onida",
                        "latitude": "44.70804000",
                        "longitude": "-100.05984000"
                    },
                    {
                        "id": 123862,
                        "name": "Parker",
                        "latitude": "43.39748000",
                        "longitude": "-97.13645000"
                    },
                    {
                        "id": 123876,
                        "name": "Parkston",
                        "latitude": "43.39888000",
                        "longitude": "-97.98368000"
                    },
                    {
                        "id": 124031,
                        "name": "Pennington County",
                        "latitude": "44.00373000",
                        "longitude": "-102.82383000"
                    },
                    {
                        "id": 124064,
                        "name": "Perkins County",
                        "latitude": "45.49051000",
                        "longitude": "-102.47563000"
                    },
                    {
                        "id": 124129,
                        "name": "Philip",
                        "latitude": "44.03943000",
                        "longitude": "-101.66514000"
                    },
                    {
                        "id": 124178,
                        "name": "Pierre",
                        "latitude": "44.36832000",
                        "longitude": "-100.35097000"
                    },
                    {
                        "id": 124243,
                        "name": "Pine Ridge",
                        "latitude": "43.02554000",
                        "longitude": "-102.55627000"
                    },
                    {
                        "id": 124341,
                        "name": "Plankinton",
                        "latitude": "43.71555000",
                        "longitude": "-98.48509000"
                    },
                    {
                        "id": 124351,
                        "name": "Platte",
                        "latitude": "43.38694000",
                        "longitude": "-98.84453000"
                    },
                    {
                        "id": 124490,
                        "name": "Porcupine",
                        "latitude": "43.23971000",
                        "longitude": "-102.33099000"
                    },
                    {
                        "id": 124593,
                        "name": "Potter County",
                        "latitude": "45.06450000",
                        "longitude": "-99.95725000"
                    },
                    {
                        "id": 124894,
                        "name": "Rapid City",
                        "latitude": "44.08054000",
                        "longitude": "-103.23101000"
                    },
                    {
                        "id": 124895,
                        "name": "Rapid Valley",
                        "latitude": "44.06249000",
                        "longitude": "-103.14629000"
                    },
                    {
                        "id": 124968,
                        "name": "Redfield",
                        "latitude": "44.87581000",
                        "longitude": "-98.51871000"
                    },
                    {
                        "id": 125242,
                        "name": "Roberts County",
                        "latitude": "45.62965000",
                        "longitude": "-96.94612000"
                    },
                    {
                        "id": 125412,
                        "name": "Rosebud",
                        "latitude": "43.23278000",
                        "longitude": "-100.85348000"
                    },
                    {
                        "id": 125737,
                        "name": "Salem",
                        "latitude": "43.72415000",
                        "longitude": "-97.38895000"
                    },
                    {
                        "id": 125855,
                        "name": "Sanborn County",
                        "latitude": "44.02345000",
                        "longitude": "-98.09139000"
                    },
                    {
                        "id": 126130,
                        "name": "Selby",
                        "latitude": "45.50638000",
                        "longitude": "-100.03207000"
                    },
                    {
                        "id": 126462,
                        "name": "Sioux Falls",
                        "latitude": "43.54997000",
                        "longitude": "-96.70033000"
                    },
                    {
                        "id": 126466,
                        "name": "Sisseton",
                        "latitude": "45.66468000",
                        "longitude": "-97.04980000"
                    },
                    {
                        "id": 126816,
                        "name": "Spearfish",
                        "latitude": "44.49082000",
                        "longitude": "-103.85937000"
                    },
                    {
                        "id": 126836,
                        "name": "Spink County",
                        "latitude": "44.93802000",
                        "longitude": "-98.34619000"
                    },
                    {
                        "id": 126905,
                        "name": "Springfield",
                        "latitude": "42.85417000",
                        "longitude": "-97.89729000"
                    },
                    {
                        "id": 126962,
                        "name": "Stanley County",
                        "latitude": "44.41232000",
                        "longitude": "-100.73594000"
                    },
                    {
                        "id": 127152,
                        "name": "Sturgis",
                        "latitude": "44.40971000",
                        "longitude": "-103.50908000"
                    },
                    {
                        "id": 127193,
                        "name": "Sully County",
                        "latitude": "44.71558000",
                        "longitude": "-100.13220000"
                    },
                    {
                        "id": 127207,
                        "name": "Summerset",
                        "latitude": "44.18998000",
                        "longitude": "-103.34384000"
                    },
                    {
                        "id": 127473,
                        "name": "Tea",
                        "latitude": "43.44637000",
                        "longitude": "-96.83588000"
                    },
                    {
                        "id": 127656,
                        "name": "Timber Lake",
                        "latitude": "45.42915000",
                        "longitude": "-101.07403000"
                    },
                    {
                        "id": 127694,
                        "name": "Todd County",
                        "latitude": "43.19337000",
                        "longitude": "-100.71841000"
                    },
                    {
                        "id": 127832,
                        "name": "Tripp County",
                        "latitude": "43.34587000",
                        "longitude": "-99.88400000"
                    },
                    {
                        "id": 127904,
                        "name": "Turner County",
                        "latitude": "43.31087000",
                        "longitude": "-97.14866000"
                    },
                    {
                        "id": 127945,
                        "name": "Tyndall",
                        "latitude": "42.99333000",
                        "longitude": "-97.86285000"
                    },
                    {
                        "id": 128001,
                        "name": "Union County",
                        "latitude": "42.83249000",
                        "longitude": "-96.65609000"
                    },
                    {
                        "id": 128185,
                        "name": "Vermillion",
                        "latitude": "42.77944000",
                        "longitude": "-96.92921000"
                    },
                    {
                        "id": 128300,
                        "name": "Volga",
                        "latitude": "44.32358000",
                        "longitude": "-96.92645000"
                    },
                    {
                        "id": 128328,
                        "name": "Wagner",
                        "latitude": "43.07972000",
                        "longitude": "-98.29313000"
                    },
                    {
                        "id": 128441,
                        "name": "Walworth County",
                        "latitude": "45.42995000",
                        "longitude": "-100.03156000"
                    },
                    {
                        "id": 128625,
                        "name": "Watertown",
                        "latitude": "44.89941000",
                        "longitude": "-97.11507000"
                    },
                    {
                        "id": 128734,
                        "name": "Webster",
                        "latitude": "45.33218000",
                        "longitude": "-97.52009000"
                    },
                    {
                        "id": 128813,
                        "name": "Wessington Springs",
                        "latitude": "44.07916000",
                        "longitude": "-98.56954000"
                    },
                    {
                        "id": 129156,
                        "name": "White River",
                        "latitude": "43.56805000",
                        "longitude": "-100.74542000"
                    },
                    {
                        "id": 129412,
                        "name": "Winner",
                        "latitude": "43.37667000",
                        "longitude": "-99.85901000"
                    },
                    {
                        "id": 129583,
                        "name": "Woonsocket",
                        "latitude": "44.05360000",
                        "longitude": "-98.27564000"
                    },
                    {
                        "id": 129661,
                        "name": "Yankton",
                        "latitude": "42.87111000",
                        "longitude": "-97.39728000"
                    },
                    {
                        "id": 129662,
                        "name": "Yankton County",
                        "latitude": "43.00897000",
                        "longitude": "-97.39475000"
                    },
                    {
                        "id": 129753,
                        "name": "Ziebach County",
                        "latitude": "44.98041000",
                        "longitude": "-101.66586000"
                    }
                ]
            },
            {
                "id": 1454,
                "name": "Tennessee",
                "iso2": "TN",
                "latitude": "35.51749130",
                "longitude": "-86.58044730",
                "type": "state",
                "cities": [
                    {
                        "id": 111031,
                        "name": "Adamsville",
                        "latitude": "35.23591000",
                        "longitude": "-88.39060000"
                    },
                    {
                        "id": 111091,
                        "name": "Alamo",
                        "latitude": "35.78479000",
                        "longitude": "-89.11729000"
                    },
                    {
                        "id": 111132,
                        "name": "Alcoa",
                        "latitude": "35.78953000",
                        "longitude": "-83.97379000"
                    },
                    {
                        "id": 111168,
                        "name": "Algood",
                        "latitude": "36.19589000",
                        "longitude": "-85.44858000"
                    },
                    {
                        "id": 111234,
                        "name": "Altamont",
                        "latitude": "35.42952000",
                        "longitude": "-85.72303000"
                    },
                    {
                        "id": 111318,
                        "name": "Anderson County",
                        "latitude": "36.11844000",
                        "longitude": "-84.19846000"
                    },
                    {
                        "id": 111385,
                        "name": "Apison",
                        "latitude": "35.02396000",
                        "longitude": "-85.02384000"
                    },
                    {
                        "id": 111441,
                        "name": "Ardmore",
                        "latitude": "34.99203000",
                        "longitude": "-86.84667000"
                    },
                    {
                        "id": 111462,
                        "name": "Arlington",
                        "latitude": "35.29620000",
                        "longitude": "-89.66147000"
                    },
                    {
                        "id": 111541,
                        "name": "Ashland City",
                        "latitude": "36.27422000",
                        "longitude": "-87.06417000"
                    },
                    {
                        "id": 111575,
                        "name": "Athens",
                        "latitude": "35.44285000",
                        "longitude": "-84.59299000"
                    },
                    {
                        "id": 111604,
                        "name": "Atoka",
                        "latitude": "35.44119000",
                        "longitude": "-89.77814000"
                    },
                    {
                        "id": 111802,
                        "name": "Banner Hill",
                        "latitude": "36.13066000",
                        "longitude": "-82.42458000"
                    },
                    {
                        "id": 111861,
                        "name": "Bartlett",
                        "latitude": "35.20453000",
                        "longitude": "-89.87398000"
                    },
                    {
                        "id": 111914,
                        "name": "Baxter",
                        "latitude": "36.15367000",
                        "longitude": "-85.64359000"
                    },
                    {
                        "id": 111973,
                        "name": "Bean Station",
                        "latitude": "36.34370000",
                        "longitude": "-83.28406000"
                    },
                    {
                        "id": 112028,
                        "name": "Bedford County",
                        "latitude": "35.51380000",
                        "longitude": "-86.45889000"
                    },
                    {
                        "id": 112087,
                        "name": "Belle Meade",
                        "latitude": "36.09589000",
                        "longitude": "-86.85694000"
                    },
                    {
                        "id": 112126,
                        "name": "Bells",
                        "latitude": "35.71118000",
                        "longitude": "-89.08756000"
                    },
                    {
                        "id": 112196,
                        "name": "Benton",
                        "latitude": "35.17424000",
                        "longitude": "-84.65355000"
                    },
                    {
                        "id": 112202,
                        "name": "Benton County",
                        "latitude": "36.06978000",
                        "longitude": "-88.06827000"
                    },
                    {
                        "id": 112402,
                        "name": "Blaine",
                        "latitude": "36.15425000",
                        "longitude": "-83.70407000"
                    },
                    {
                        "id": 112428,
                        "name": "Bledsoe County",
                        "latitude": "35.59642000",
                        "longitude": "-85.20516000"
                    },
                    {
                        "id": 112446,
                        "name": "Bloomingdale",
                        "latitude": "36.58455000",
                        "longitude": "-82.48932000"
                    },
                    {
                        "id": 112458,
                        "name": "Blount County",
                        "latitude": "35.68724000",
                        "longitude": "-83.92553000"
                    },
                    {
                        "id": 112461,
                        "name": "Blountville",
                        "latitude": "36.53316000",
                        "longitude": "-82.32681000"
                    },
                    {
                        "id": 112481,
                        "name": "Bluff City",
                        "latitude": "36.47427000",
                        "longitude": "-82.26097000"
                    },
                    {
                        "id": 112518,
                        "name": "Bolivar",
                        "latitude": "35.25619000",
                        "longitude": "-88.98784000"
                    },
                    {
                        "id": 112527,
                        "name": "Bon Aqua Junction",
                        "latitude": "35.92784000",
                        "longitude": "-87.31084000"
                    },
                    {
                        "id": 112664,
                        "name": "Bradford",
                        "latitude": "36.07645000",
                        "longitude": "-88.81006000"
                    },
                    {
                        "id": 112676,
                        "name": "Bradley County",
                        "latitude": "35.15411000",
                        "longitude": "-84.85960000"
                    },
                    {
                        "id": 112729,
                        "name": "Brentwood",
                        "latitude": "36.03312000",
                        "longitude": "-86.78278000"
                    },
                    {
                        "id": 112734,
                        "name": "Brentwood Estates",
                        "latitude": "36.02506000",
                        "longitude": "-86.77917000"
                    },
                    {
                        "id": 112788,
                        "name": "Brighton",
                        "latitude": "35.48397000",
                        "longitude": "-89.72508000"
                    },
                    {
                        "id": 112803,
                        "name": "Bristol",
                        "latitude": "36.59511000",
                        "longitude": "-82.18874000"
                    },
                    {
                        "id": 112931,
                        "name": "Brownsville",
                        "latitude": "35.59397000",
                        "longitude": "-89.26229000"
                    },
                    {
                        "id": 112943,
                        "name": "Bruceton",
                        "latitude": "36.03812000",
                        "longitude": "-88.24449000"
                    },
                    {
                        "id": 113086,
                        "name": "Burns",
                        "latitude": "36.05339000",
                        "longitude": "-87.31251000"
                    },
                    {
                        "id": 113141,
                        "name": "Byrdstown",
                        "latitude": "36.57451000",
                        "longitude": "-85.12884000"
                    },
                    {
                        "id": 113265,
                        "name": "Camden",
                        "latitude": "36.05895000",
                        "longitude": "-88.09782000"
                    },
                    {
                        "id": 113299,
                        "name": "Campbell County",
                        "latitude": "36.40351000",
                        "longitude": "-84.14938000"
                    },
                    {
                        "id": 113333,
                        "name": "Cannon County",
                        "latitude": "35.80868000",
                        "longitude": "-86.06174000"
                    },
                    {
                        "id": 113456,
                        "name": "Carroll County",
                        "latitude": "35.97317000",
                        "longitude": "-88.45026000"
                    },
                    {
                        "id": 113483,
                        "name": "Carter County",
                        "latitude": "36.29272000",
                        "longitude": "-82.12743000"
                    },
                    {
                        "id": 113494,
                        "name": "Carthage",
                        "latitude": "36.25228000",
                        "longitude": "-85.95165000"
                    },
                    {
                        "id": 113507,
                        "name": "Caryville",
                        "latitude": "36.29897000",
                        "longitude": "-84.22326000"
                    },
                    {
                        "id": 113630,
                        "name": "Celina",
                        "latitude": "36.55006000",
                        "longitude": "-85.50525000"
                    },
                    {
                        "id": 113655,
                        "name": "Centerville",
                        "latitude": "35.77896000",
                        "longitude": "-87.46696000"
                    },
                    {
                        "id": 113664,
                        "name": "Central",
                        "latitude": "36.32622000",
                        "longitude": "-82.28958000"
                    },
                    {
                        "id": 113742,
                        "name": "Chapel Hill",
                        "latitude": "35.62646000",
                        "longitude": "-86.69333000"
                    },
                    {
                        "id": 113777,
                        "name": "Charlotte",
                        "latitude": "36.17728000",
                        "longitude": "-87.33973000"
                    },
                    {
                        "id": 113811,
                        "name": "Chattanooga",
                        "latitude": "35.04563000",
                        "longitude": "-85.30968000"
                    },
                    {
                        "id": 113819,
                        "name": "Cheatham County",
                        "latitude": "36.26117000",
                        "longitude": "-87.08678000"
                    },
                    {
                        "id": 113896,
                        "name": "Chester County",
                        "latitude": "35.42175000",
                        "longitude": "-88.61346000"
                    },
                    {
                        "id": 113998,
                        "name": "Christiana",
                        "latitude": "35.71007000",
                        "longitude": "-86.39944000"
                    },
                    {
                        "id": 114007,
                        "name": "Church Hill",
                        "latitude": "36.52232000",
                        "longitude": "-82.71349000"
                    },
                    {
                        "id": 114094,
                        "name": "Claiborne County",
                        "latitude": "36.48585000",
                        "longitude": "-83.66042000"
                    },
                    {
                        "id": 114154,
                        "name": "Clarksville",
                        "latitude": "36.52977000",
                        "longitude": "-87.35945000"
                    },
                    {
                        "id": 114184,
                        "name": "Clay County",
                        "latitude": "36.55116000",
                        "longitude": "-85.54386000"
                    },
                    {
                        "id": 114244,
                        "name": "Cleveland",
                        "latitude": "35.15952000",
                        "longitude": "-84.87661000"
                    },
                    {
                        "id": 114255,
                        "name": "Clifton",
                        "latitude": "35.38702000",
                        "longitude": "-87.99531000"
                    },
                    {
                        "id": 114275,
                        "name": "Clinton",
                        "latitude": "36.10341000",
                        "longitude": "-84.13186000"
                    },
                    {
                        "id": 114335,
                        "name": "Coalfield",
                        "latitude": "36.02897000",
                        "longitude": "-84.42076000"
                    },
                    {
                        "id": 114354,
                        "name": "Cocke County",
                        "latitude": "35.92542000",
                        "longitude": "-83.12116000"
                    },
                    {
                        "id": 114369,
                        "name": "Coffee County",
                        "latitude": "35.49062000",
                        "longitude": "-86.07476000"
                    },
                    {
                        "id": 114418,
                        "name": "Collegedale",
                        "latitude": "35.05313000",
                        "longitude": "-85.05023000"
                    },
                    {
                        "id": 114424,
                        "name": "Collierville",
                        "latitude": "35.04204000",
                        "longitude": "-89.66453000"
                    },
                    {
                        "id": 114448,
                        "name": "Colonial Heights",
                        "latitude": "36.48510000",
                        "longitude": "-82.50320000"
                    },
                    {
                        "id": 114472,
                        "name": "Columbia",
                        "latitude": "35.61507000",
                        "longitude": "-87.03528000"
                    },
                    {
                        "id": 114548,
                        "name": "Condon",
                        "latitude": "36.18119000",
                        "longitude": "-83.79380000"
                    },
                    {
                        "id": 114595,
                        "name": "Cookeville",
                        "latitude": "36.16284000",
                        "longitude": "-85.50164000"
                    },
                    {
                        "id": 114609,
                        "name": "Coopertown",
                        "latitude": "36.43755000",
                        "longitude": "-86.96722000"
                    },
                    {
                        "id": 114650,
                        "name": "Cornersville",
                        "latitude": "35.36146000",
                        "longitude": "-86.83972000"
                    },
                    {
                        "id": 114738,
                        "name": "Covington",
                        "latitude": "35.56425000",
                        "longitude": "-89.64647000"
                    },
                    {
                        "id": 114744,
                        "name": "Cowan",
                        "latitude": "35.16453000",
                        "longitude": "-86.01054000"
                    },
                    {
                        "id": 114831,
                        "name": "Crockett County",
                        "latitude": "35.81354000",
                        "longitude": "-89.13953000"
                    },
                    {
                        "id": 114852,
                        "name": "Cross Plains",
                        "latitude": "36.54866000",
                        "longitude": "-86.69611000"
                    },
                    {
                        "id": 114856,
                        "name": "Crossville",
                        "latitude": "35.94896000",
                        "longitude": "-85.02690000"
                    },
                    {
                        "id": 114873,
                        "name": "Crump",
                        "latitude": "35.22175000",
                        "longitude": "-88.31809000"
                    },
                    {
                        "id": 114916,
                        "name": "Cumberland County",
                        "latitude": "35.95039000",
                        "longitude": "-84.99835000"
                    },
                    {
                        "id": 115018,
                        "name": "Dandridge",
                        "latitude": "36.01537000",
                        "longitude": "-83.41489000"
                    },
                    {
                        "id": 115064,
                        "name": "Davidson County",
                        "latitude": "36.17069000",
                        "longitude": "-86.77753000"
                    },
                    {
                        "id": 115092,
                        "name": "Dayton",
                        "latitude": "35.49396000",
                        "longitude": "-85.01245000"
                    },
                    {
                        "id": 115154,
                        "name": "Decatur",
                        "latitude": "35.51479000",
                        "longitude": "-84.79022000"
                    },
                    {
                        "id": 115161,
                        "name": "Decatur County",
                        "latitude": "35.60302000",
                        "longitude": "-88.10877000"
                    },
                    {
                        "id": 115164,
                        "name": "Decaturville",
                        "latitude": "35.58424000",
                        "longitude": "-88.11948000"
                    },
                    {
                        "id": 115165,
                        "name": "Decherd",
                        "latitude": "35.20980000",
                        "longitude": "-86.07943000"
                    },
                    {
                        "id": 115131,
                        "name": "DeKalb County",
                        "latitude": "35.97986000",
                        "longitude": "-85.83275000"
                    },
                    {
                        "id": 115331,
                        "name": "Dickson",
                        "latitude": "36.07700000",
                        "longitude": "-87.38779000"
                    },
                    {
                        "id": 115333,
                        "name": "Dickson County",
                        "latitude": "36.14905000",
                        "longitude": "-87.35666000"
                    },
                    {
                        "id": 115382,
                        "name": "Dodson Branch",
                        "latitude": "36.31256000",
                        "longitude": "-85.53220000"
                    },
                    {
                        "id": 115447,
                        "name": "Dover",
                        "latitude": "36.48783000",
                        "longitude": "-87.83836000"
                    },
                    {
                        "id": 115471,
                        "name": "Dresden",
                        "latitude": "36.29145000",
                        "longitude": "-88.70811000"
                    },
                    {
                        "id": 115542,
                        "name": "Dunlap",
                        "latitude": "35.37146000",
                        "longitude": "-85.39052000"
                    },
                    {
                        "id": 115585,
                        "name": "Dyer",
                        "latitude": "36.06673000",
                        "longitude": "-88.99395000"
                    },
                    {
                        "id": 115587,
                        "name": "Dyer County",
                        "latitude": "36.05906000",
                        "longitude": "-89.41377000"
                    },
                    {
                        "id": 115588,
                        "name": "Dyersburg",
                        "latitude": "36.03452000",
                        "longitude": "-89.38563000"
                    },
                    {
                        "id": 115613,
                        "name": "Eagleton Village",
                        "latitude": "35.79508000",
                        "longitude": "-83.93185000"
                    },
                    {
                        "id": 115635,
                        "name": "East Brainerd",
                        "latitude": "34.99591000",
                        "longitude": "-85.15023000"
                    },
                    {
                        "id": 115644,
                        "name": "East Chattanooga",
                        "latitude": "35.06535000",
                        "longitude": "-85.24912000"
                    },
                    {
                        "id": 115646,
                        "name": "East Cleveland",
                        "latitude": "35.16091000",
                        "longitude": "-84.85772000"
                    },
                    {
                        "id": 115747,
                        "name": "East Ridge",
                        "latitude": "35.01424000",
                        "longitude": "-85.25190000"
                    },
                    {
                        "id": 115976,
                        "name": "Elizabethton",
                        "latitude": "36.34872000",
                        "longitude": "-82.21069000"
                    },
                    {
                        "id": 116130,
                        "name": "Englewood",
                        "latitude": "35.42452000",
                        "longitude": "-84.48743000"
                    },
                    {
                        "id": 116170,
                        "name": "Erin",
                        "latitude": "36.31839000",
                        "longitude": "-87.69474000"
                    },
                    {
                        "id": 116176,
                        "name": "Erwin",
                        "latitude": "36.14511000",
                        "longitude": "-82.41681000"
                    },
                    {
                        "id": 116213,
                        "name": "Estill Springs",
                        "latitude": "35.27064000",
                        "longitude": "-86.12804000"
                    },
                    {
                        "id": 116218,
                        "name": "Etowah",
                        "latitude": "35.32341000",
                        "longitude": "-84.52493000"
                    },
                    {
                        "id": 116321,
                        "name": "Fairfield Glade",
                        "latitude": "36.00035000",
                        "longitude": "-84.88634000"
                    },
                    {
                        "id": 116339,
                        "name": "Fairmount",
                        "latitude": "35.18146000",
                        "longitude": "-85.32357000"
                    },
                    {
                        "id": 116349,
                        "name": "Fairview",
                        "latitude": "35.98201000",
                        "longitude": "-87.12140000"
                    },
                    {
                        "id": 116370,
                        "name": "Fall Branch",
                        "latitude": "36.41816000",
                        "longitude": "-82.62376000"
                    },
                    {
                        "id": 116377,
                        "name": "Falling Water",
                        "latitude": "35.20312000",
                        "longitude": "-85.25357000"
                    },
                    {
                        "id": 116429,
                        "name": "Farragut",
                        "latitude": "35.88452000",
                        "longitude": "-84.15353000"
                    },
                    {
                        "id": 116448,
                        "name": "Fayette County",
                        "latitude": "35.19708000",
                        "longitude": "-89.41437000"
                    },
                    {
                        "id": 116457,
                        "name": "Fayetteville",
                        "latitude": "35.15203000",
                        "longitude": "-86.57055000"
                    },
                    {
                        "id": 116476,
                        "name": "Fentress County",
                        "latitude": "36.38049000",
                        "longitude": "-84.93246000"
                    },
                    {
                        "id": 116513,
                        "name": "Fincastle",
                        "latitude": "36.40980000",
                        "longitude": "-84.04770000"
                    },
                    {
                        "id": 116656,
                        "name": "Forest Hills",
                        "latitude": "36.06839000",
                        "longitude": "-86.84417000"
                    },
                    {
                        "id": 116829,
                        "name": "Franklin",
                        "latitude": "35.92506000",
                        "longitude": "-86.86889000"
                    },
                    {
                        "id": 116854,
                        "name": "Franklin County",
                        "latitude": "35.15496000",
                        "longitude": "-86.09218000"
                    },
                    {
                        "id": 117013,
                        "name": "Gainesboro",
                        "latitude": "36.35561000",
                        "longitude": "-85.65887000"
                    },
                    {
                        "id": 117033,
                        "name": "Gallatin",
                        "latitude": "36.38838000",
                        "longitude": "-86.44666000"
                    },
                    {
                        "id": 117125,
                        "name": "Gatlinburg",
                        "latitude": "35.71453000",
                        "longitude": "-83.51189000"
                    },
                    {
                        "id": 117173,
                        "name": "Germantown",
                        "latitude": "35.08676000",
                        "longitude": "-89.81009000"
                    },
                    {
                        "id": 117190,
                        "name": "Gibson County",
                        "latitude": "35.99661000",
                        "longitude": "-88.93262000"
                    },
                    {
                        "id": 117210,
                        "name": "Giles County",
                        "latitude": "35.20215000",
                        "longitude": "-87.03478000"
                    },
                    {
                        "id": 117257,
                        "name": "Gleason",
                        "latitude": "36.21367000",
                        "longitude": "-88.61255000"
                    },
                    {
                        "id": 117386,
                        "name": "Goodlettsville",
                        "latitude": "36.32311000",
                        "longitude": "-86.71333000"
                    },
                    {
                        "id": 117400,
                        "name": "Gordonsville",
                        "latitude": "36.17256000",
                        "longitude": "-85.92971000"
                    },
                    {
                        "id": 117441,
                        "name": "Grainger County",
                        "latitude": "36.27625000",
                        "longitude": "-83.50962000"
                    },
                    {
                        "id": 117552,
                        "name": "Gray",
                        "latitude": "36.41983000",
                        "longitude": "-82.47654000"
                    },
                    {
                        "id": 117567,
                        "name": "Graysville",
                        "latitude": "35.44701000",
                        "longitude": "-85.08440000"
                    },
                    {
                        "id": 117598,
                        "name": "Green Hill",
                        "latitude": "36.22283000",
                        "longitude": "-86.54944000"
                    },
                    {
                        "id": 117615,
                        "name": "Greenback",
                        "latitude": "35.66119000",
                        "longitude": "-84.17214000"
                    },
                    {
                        "id": 117620,
                        "name": "Greenbrier",
                        "latitude": "36.42755000",
                        "longitude": "-86.80472000"
                    },
                    {
                        "id": 117639,
                        "name": "Greene County",
                        "latitude": "36.17536000",
                        "longitude": "-82.84582000"
                    },
                    {
                        "id": 117644,
                        "name": "Greeneville",
                        "latitude": "36.16316000",
                        "longitude": "-82.83099000"
                    },
                    {
                        "id": 117648,
                        "name": "Greenfield",
                        "latitude": "36.15340000",
                        "longitude": "-88.80062000"
                    },
                    {
                        "id": 117739,
                        "name": "Grimsley",
                        "latitude": "36.26701000",
                        "longitude": "-84.98440000"
                    },
                    {
                        "id": 117767,
                        "name": "Gruetli-Laager",
                        "latitude": "35.37230000",
                        "longitude": "-85.61803000"
                    },
                    {
                        "id": 117770,
                        "name": "Grundy County",
                        "latitude": "35.38837000",
                        "longitude": "-85.72258000"
                    },
                    {
                        "id": 117873,
                        "name": "Halls",
                        "latitude": "35.87563000",
                        "longitude": "-89.39618000"
                    },
                    {
                        "id": 117880,
                        "name": "Hamblen County",
                        "latitude": "36.21715000",
                        "longitude": "-83.26666000"
                    },
                    {
                        "id": 117898,
                        "name": "Hamilton County",
                        "latitude": "35.18086000",
                        "longitude": "-85.16479000"
                    },
                    {
                        "id": 117954,
                        "name": "Hancock County",
                        "latitude": "36.52365000",
                        "longitude": "-83.22183000"
                    },
                    {
                        "id": 117995,
                        "name": "Hardeman County",
                        "latitude": "35.20687000",
                        "longitude": "-88.99308000"
                    },
                    {
                        "id": 118001,
                        "name": "Hardin County",
                        "latitude": "35.19868000",
                        "longitude": "-88.18448000"
                    },
                    {
                        "id": 118039,
                        "name": "Harriman",
                        "latitude": "35.93396000",
                        "longitude": "-84.55244000"
                    },
                    {
                        "id": 118055,
                        "name": "Harrison",
                        "latitude": "35.11368000",
                        "longitude": "-85.13801000"
                    },
                    {
                        "id": 118079,
                        "name": "Harrogate",
                        "latitude": "36.58230000",
                        "longitude": "-83.65686000"
                    },
                    {
                        "id": 118105,
                        "name": "Hartsville",
                        "latitude": "36.39088000",
                        "longitude": "-86.16721000"
                    },
                    {
                        "id": 118166,
                        "name": "Hawkins County",
                        "latitude": "36.44117000",
                        "longitude": "-82.94468000"
                    },
                    {
                        "id": 118199,
                        "name": "Haywood County",
                        "latitude": "35.58322000",
                        "longitude": "-89.28384000"
                    },
                    {
                        "id": 118277,
                        "name": "Henderson",
                        "latitude": "35.43924000",
                        "longitude": "-88.64144000"
                    },
                    {
                        "id": 118282,
                        "name": "Henderson County",
                        "latitude": "35.65426000",
                        "longitude": "-88.38799000"
                    },
                    {
                        "id": 118286,
                        "name": "Hendersonville",
                        "latitude": "36.30477000",
                        "longitude": "-86.62000000"
                    },
                    {
                        "id": 118302,
                        "name": "Henry County",
                        "latitude": "36.33183000",
                        "longitude": "-88.30122000"
                    },
                    {
                        "id": 118364,
                        "name": "Hickman County",
                        "latitude": "35.80325000",
                        "longitude": "-87.47331000"
                    },
                    {
                        "id": 118370,
                        "name": "Hickory Withe",
                        "latitude": "35.24398000",
                        "longitude": "-89.58869000"
                    },
                    {
                        "id": 118512,
                        "name": "Hohenwald",
                        "latitude": "35.54785000",
                        "longitude": "-87.55196000"
                    },
                    {
                        "id": 118648,
                        "name": "Hopewell",
                        "latitude": "35.23479000",
                        "longitude": "-84.88800000"
                    },
                    {
                        "id": 118704,
                        "name": "Houston County",
                        "latitude": "36.28597000",
                        "longitude": "-87.71704000"
                    },
                    {
                        "id": 118776,
                        "name": "Humboldt",
                        "latitude": "35.81979000",
                        "longitude": "-88.91590000"
                    },
                    {
                        "id": 118785,
                        "name": "Humphreys County",
                        "latitude": "36.04082000",
                        "longitude": "-87.77563000"
                    },
                    {
                        "id": 118788,
                        "name": "Hunter",
                        "latitude": "36.37178000",
                        "longitude": "-82.15874000"
                    },
                    {
                        "id": 118795,
                        "name": "Huntingdon",
                        "latitude": "36.00062000",
                        "longitude": "-88.42811000"
                    },
                    {
                        "id": 118817,
                        "name": "Huntsville",
                        "latitude": "36.40980000",
                        "longitude": "-84.49049000"
                    },
                    {
                        "id": 119058,
                        "name": "Jacksboro",
                        "latitude": "36.33008000",
                        "longitude": "-84.18382000"
                    },
                    {
                        "id": 119068,
                        "name": "Jackson",
                        "latitude": "35.61452000",
                        "longitude": "-88.81395000"
                    },
                    {
                        "id": 119087,
                        "name": "Jackson County",
                        "latitude": "36.35921000",
                        "longitude": "-85.67315000"
                    },
                    {
                        "id": 119122,
                        "name": "Jamestown",
                        "latitude": "36.42757000",
                        "longitude": "-84.93189000"
                    },
                    {
                        "id": 119143,
                        "name": "Jasper",
                        "latitude": "35.07424000",
                        "longitude": "-85.62608000"
                    },
                    {
                        "id": 119174,
                        "name": "Jefferson City",
                        "latitude": "36.12231000",
                        "longitude": "-83.49240000"
                    },
                    {
                        "id": 119186,
                        "name": "Jefferson County",
                        "latitude": "36.05099000",
                        "longitude": "-83.44631000"
                    },
                    {
                        "id": 119209,
                        "name": "Jellico",
                        "latitude": "36.58786000",
                        "longitude": "-84.12687000"
                    },
                    {
                        "id": 119257,
                        "name": "Johnson City",
                        "latitude": "36.31344000",
                        "longitude": "-82.35347000"
                    },
                    {
                        "id": 119267,
                        "name": "Johnson County",
                        "latitude": "36.45494000",
                        "longitude": "-81.85175000"
                    },
                    {
                        "id": 119275,
                        "name": "Johnsonville",
                        "latitude": "36.06006000",
                        "longitude": "-87.95281000"
                    },
                    {
                        "id": 119304,
                        "name": "Jonesborough",
                        "latitude": "36.29427000",
                        "longitude": "-82.47348000"
                    },
                    {
                        "id": 119497,
                        "name": "Kenton",
                        "latitude": "36.20229000",
                        "longitude": "-89.01229000"
                    },
                    {
                        "id": 119565,
                        "name": "Kimball",
                        "latitude": "35.04786000",
                        "longitude": "-85.67191000"
                    },
                    {
                        "id": 119619,
                        "name": "Kingsport",
                        "latitude": "36.54843000",
                        "longitude": "-82.56182000"
                    },
                    {
                        "id": 119621,
                        "name": "Kingston",
                        "latitude": "35.88091000",
                        "longitude": "-84.50854000"
                    },
                    {
                        "id": 119632,
                        "name": "Kingston Springs",
                        "latitude": "36.10200000",
                        "longitude": "-87.11501000"
                    },
                    {
                        "id": 119687,
                        "name": "Knox County",
                        "latitude": "35.99322000",
                        "longitude": "-83.93709000"
                    },
                    {
                        "id": 119694,
                        "name": "Knoxville",
                        "latitude": "35.96064000",
                        "longitude": "-83.92074000"
                    },
                    {
                        "id": 119792,
                        "name": "La Vergne",
                        "latitude": "36.01562000",
                        "longitude": "-86.58194000"
                    },
                    {
                        "id": 119833,
                        "name": "Lafayette",
                        "latitude": "36.52116000",
                        "longitude": "-86.02637000"
                    },
                    {
                        "id": 119800,
                        "name": "LaFollette",
                        "latitude": "36.38286000",
                        "longitude": "-84.11993000"
                    },
                    {
                        "id": 119890,
                        "name": "Lake County",
                        "latitude": "36.33538000",
                        "longitude": "-89.49347000"
                    },
                    {
                        "id": 119984,
                        "name": "Lake Tansi",
                        "latitude": "35.87285000",
                        "longitude": "-85.05440000"
                    },
                    {
                        "id": 120014,
                        "name": "Lakeland",
                        "latitude": "35.23064000",
                        "longitude": "-89.74036000"
                    },
                    {
                        "id": 120036,
                        "name": "Lakesite",
                        "latitude": "35.20868000",
                        "longitude": "-85.12690000"
                    },
                    {
                        "id": 120046,
                        "name": "Lakewood",
                        "latitude": "36.24311000",
                        "longitude": "-86.63555000"
                    },
                    {
                        "id": 120181,
                        "name": "Lauderdale County",
                        "latitude": "35.76101000",
                        "longitude": "-89.63144000"
                    },
                    {
                        "id": 120236,
                        "name": "Lawrence County",
                        "latitude": "35.21727000",
                        "longitude": "-87.39559000"
                    },
                    {
                        "id": 120242,
                        "name": "Lawrenceburg",
                        "latitude": "35.24230000",
                        "longitude": "-87.33474000"
                    },
                    {
                        "id": 120287,
                        "name": "Lebanon",
                        "latitude": "36.20811000",
                        "longitude": "-86.29110000"
                    },
                    {
                        "id": 120373,
                        "name": "Lenoir City",
                        "latitude": "35.79730000",
                        "longitude": "-84.25603000"
                    },
                    {
                        "id": 120412,
                        "name": "Lewis County",
                        "latitude": "35.52728000",
                        "longitude": "-87.49310000"
                    },
                    {
                        "id": 120419,
                        "name": "Lewisburg",
                        "latitude": "35.44924000",
                        "longitude": "-86.78889000"
                    },
                    {
                        "id": 120444,
                        "name": "Lexington",
                        "latitude": "35.65090000",
                        "longitude": "-88.39338000"
                    },
                    {
                        "id": 120524,
                        "name": "Lincoln County",
                        "latitude": "35.14052000",
                        "longitude": "-86.58894000"
                    },
                    {
                        "id": 120561,
                        "name": "Linden",
                        "latitude": "35.61729000",
                        "longitude": "-87.83947000"
                    },
                    {
                        "id": 120649,
                        "name": "Livingston",
                        "latitude": "36.38340000",
                        "longitude": "-85.32302000"
                    },
                    {
                        "id": 120728,
                        "name": "Lone Oak",
                        "latitude": "35.20063000",
                        "longitude": "-85.36413000"
                    },
                    {
                        "id": 120766,
                        "name": "Lookout Mountain",
                        "latitude": "34.99424000",
                        "longitude": "-85.34940000"
                    },
                    {
                        "id": 120774,
                        "name": "Loretto",
                        "latitude": "35.07786000",
                        "longitude": "-87.43974000"
                    },
                    {
                        "id": 120799,
                        "name": "Loudon",
                        "latitude": "35.73285000",
                        "longitude": "-84.33381000"
                    },
                    {
                        "id": 120800,
                        "name": "Loudon County",
                        "latitude": "35.73478000",
                        "longitude": "-84.31187000"
                    },
                    {
                        "id": 120815,
                        "name": "Louisville",
                        "latitude": "35.82175000",
                        "longitude": "-84.04796000"
                    },
                    {
                        "id": 120897,
                        "name": "Luttrell",
                        "latitude": "36.19953000",
                        "longitude": "-83.74185000"
                    },
                    {
                        "id": 120915,
                        "name": "Lynchburg",
                        "latitude": "35.28314000",
                        "longitude": "-86.37416000"
                    },
                    {
                        "id": 120972,
                        "name": "Macon County",
                        "latitude": "36.53203000",
                        "longitude": "-86.00727000"
                    },
                    {
                        "id": 121011,
                        "name": "Madison County",
                        "latitude": "35.60814000",
                        "longitude": "-88.83847000"
                    },
                    {
                        "id": 121026,
                        "name": "Madisonville",
                        "latitude": "35.51980000",
                        "longitude": "-84.36353000"
                    },
                    {
                        "id": 121093,
                        "name": "Manchester",
                        "latitude": "35.48174000",
                        "longitude": "-86.08860000"
                    },
                    {
                        "id": 121258,
                        "name": "Marion County",
                        "latitude": "35.12935000",
                        "longitude": "-85.62203000"
                    },
                    {
                        "id": 121315,
                        "name": "Marshall County",
                        "latitude": "35.46886000",
                        "longitude": "-86.76502000"
                    },
                    {
                        "id": 121335,
                        "name": "Martin",
                        "latitude": "36.34340000",
                        "longitude": "-88.85034000"
                    },
                    {
                        "id": 121364,
                        "name": "Maryville",
                        "latitude": "35.75647000",
                        "longitude": "-83.97046000"
                    },
                    {
                        "id": 121367,
                        "name": "Mascot",
                        "latitude": "36.06120000",
                        "longitude": "-83.74573000"
                    },
                    {
                        "id": 121371,
                        "name": "Mason",
                        "latitude": "35.41175000",
                        "longitude": "-89.53285000"
                    },
                    {
                        "id": 121426,
                        "name": "Maury County",
                        "latitude": "35.61694000",
                        "longitude": "-87.07701000"
                    },
                    {
                        "id": 121441,
                        "name": "Maynardville",
                        "latitude": "36.25064000",
                        "longitude": "-83.79741000"
                    },
                    {
                        "id": 121498,
                        "name": "McEwen",
                        "latitude": "36.10784000",
                        "longitude": "-87.63307000"
                    },
                    {
                        "id": 121520,
                        "name": "McKenzie",
                        "latitude": "36.13256000",
                        "longitude": "-88.51866000"
                    },
                    {
                        "id": 121539,
                        "name": "McMinn County",
                        "latitude": "35.42475000",
                        "longitude": "-84.61747000"
                    },
                    {
                        "id": 121540,
                        "name": "McMinnville",
                        "latitude": "35.68340000",
                        "longitude": "-85.76998000"
                    },
                    {
                        "id": 121544,
                        "name": "McNairy County",
                        "latitude": "35.17545000",
                        "longitude": "-88.56364000"
                    },
                    {
                        "id": 121602,
                        "name": "Medina",
                        "latitude": "35.80285000",
                        "longitude": "-88.77478000"
                    },
                    {
                        "id": 121618,
                        "name": "Meigs County",
                        "latitude": "35.51283000",
                        "longitude": "-84.81339000"
                    },
                    {
                        "id": 121639,
                        "name": "Memphis",
                        "latitude": "35.14953000",
                        "longitude": "-90.04898000"
                    },
                    {
                        "id": 121763,
                        "name": "Middle Valley",
                        "latitude": "35.19590000",
                        "longitude": "-85.18468000"
                    },
                    {
                        "id": 121810,
                        "name": "Midtown",
                        "latitude": "35.87952000",
                        "longitude": "-84.56410000"
                    },
                    {
                        "id": 121817,
                        "name": "Midway",
                        "latitude": "36.30011000",
                        "longitude": "-82.42375000"
                    },
                    {
                        "id": 121836,
                        "name": "Milan",
                        "latitude": "35.91979000",
                        "longitude": "-88.75895000"
                    },
                    {
                        "id": 121888,
                        "name": "Millersville",
                        "latitude": "36.37116000",
                        "longitude": "-86.71000000"
                    },
                    {
                        "id": 121891,
                        "name": "Millington",
                        "latitude": "35.34147000",
                        "longitude": "-89.89731000"
                    },
                    {
                        "id": 122076,
                        "name": "Monroe County",
                        "latitude": "35.44265000",
                        "longitude": "-84.25279000"
                    },
                    {
                        "id": 122112,
                        "name": "Monteagle",
                        "latitude": "35.24008000",
                        "longitude": "-85.83970000"
                    },
                    {
                        "id": 122118,
                        "name": "Monterey",
                        "latitude": "36.14756000",
                        "longitude": "-85.26830000"
                    },
                    {
                        "id": 122149,
                        "name": "Montgomery County",
                        "latitude": "36.49686000",
                        "longitude": "-87.38289000"
                    },
                    {
                        "id": 122202,
                        "name": "Moore County",
                        "latitude": "35.28462000",
                        "longitude": "-86.35877000"
                    },
                    {
                        "id": 122242,
                        "name": "Morgan County",
                        "latitude": "36.13502000",
                        "longitude": "-84.64920000"
                    },
                    {
                        "id": 122281,
                        "name": "Morristown",
                        "latitude": "36.21398000",
                        "longitude": "-83.29489000"
                    },
                    {
                        "id": 122304,
                        "name": "Mosheim",
                        "latitude": "36.18954000",
                        "longitude": "-82.95849000"
                    },
                    {
                        "id": 122336,
                        "name": "Mount Carmel",
                        "latitude": "36.54538000",
                        "longitude": "-82.66099000"
                    },
                    {
                        "id": 122359,
                        "name": "Mount Juliet",
                        "latitude": "36.20005000",
                        "longitude": "-86.51861000"
                    },
                    {
                        "id": 122375,
                        "name": "Mount Pleasant",
                        "latitude": "35.53424000",
                        "longitude": "-87.20695000"
                    },
                    {
                        "id": 122412,
                        "name": "Mountain City",
                        "latitude": "36.47456000",
                        "longitude": "-81.80484000"
                    },
                    {
                        "id": 122443,
                        "name": "Mowbray Mountain",
                        "latitude": "35.27536000",
                        "longitude": "-85.22246000"
                    },
                    {
                        "id": 122471,
                        "name": "Munford",
                        "latitude": "35.44925000",
                        "longitude": "-89.81508000"
                    },
                    {
                        "id": 122482,
                        "name": "Murfreesboro",
                        "latitude": "35.84562000",
                        "longitude": "-86.39027000"
                    },
                    {
                        "id": 122577,
                        "name": "Nashville",
                        "latitude": "36.16589000",
                        "longitude": "-86.78444000"
                    },
                    {
                        "id": 122725,
                        "name": "New Hope",
                        "latitude": "35.00508000",
                        "longitude": "-85.65830000"
                    },
                    {
                        "id": 122732,
                        "name": "New Johnsonville",
                        "latitude": "36.02117000",
                        "longitude": "-87.96698000"
                    },
                    {
                        "id": 122750,
                        "name": "New Market",
                        "latitude": "36.10398000",
                        "longitude": "-83.55268000"
                    },
                    {
                        "id": 122780,
                        "name": "New South Memphis",
                        "latitude": "35.08676000",
                        "longitude": "-90.05676000"
                    },
                    {
                        "id": 122785,
                        "name": "New Tazewell",
                        "latitude": "36.44258000",
                        "longitude": "-83.59963000"
                    },
                    {
                        "id": 122789,
                        "name": "New Union",
                        "latitude": "35.53258000",
                        "longitude": "-86.08082000"
                    },
                    {
                        "id": 122809,
                        "name": "Newbern",
                        "latitude": "36.11285000",
                        "longitude": "-89.26174000"
                    },
                    {
                        "id": 122843,
                        "name": "Newport",
                        "latitude": "35.96704000",
                        "longitude": "-83.18766000"
                    },
                    {
                        "id": 122933,
                        "name": "Nolensville",
                        "latitude": "35.95229000",
                        "longitude": "-86.66944000"
                    },
                    {
                        "id": 122955,
                        "name": "Norris",
                        "latitude": "36.19563000",
                        "longitude": "-84.06797000"
                    },
                    {
                        "id": 123237,
                        "name": "Oak Grove",
                        "latitude": "36.41177000",
                        "longitude": "-82.42459000"
                    },
                    {
                        "id": 123244,
                        "name": "Oak Hill",
                        "latitude": "36.08784000",
                        "longitude": "-86.78305000"
                    },
                    {
                        "id": 123262,
                        "name": "Oak Ridge",
                        "latitude": "36.01036000",
                        "longitude": "-84.26964000"
                    },
                    {
                        "id": 123285,
                        "name": "Oakland",
                        "latitude": "35.22898000",
                        "longitude": "-89.51508000"
                    },
                    {
                        "id": 123317,
                        "name": "Obion",
                        "latitude": "36.25896000",
                        "longitude": "-89.19174000"
                    },
                    {
                        "id": 123318,
                        "name": "Obion County",
                        "latitude": "36.35825000",
                        "longitude": "-89.14880000"
                    },
                    {
                        "id": 123444,
                        "name": "Oliver Springs",
                        "latitude": "36.04452000",
                        "longitude": "-84.34437000"
                    },
                    {
                        "id": 123446,
                        "name": "Olivet",
                        "latitude": "35.21425000",
                        "longitude": "-88.20031000"
                    },
                    {
                        "id": 123472,
                        "name": "Oneida",
                        "latitude": "36.49813000",
                        "longitude": "-84.51272000"
                    },
                    {
                        "id": 123654,
                        "name": "Overton County",
                        "latitude": "36.34500000",
                        "longitude": "-85.28808000"
                    },
                    {
                        "id": 123833,
                        "name": "Paris",
                        "latitude": "36.30200000",
                        "longitude": "-88.32671000"
                    },
                    {
                        "id": 123838,
                        "name": "Park City",
                        "latitude": "35.08203000",
                        "longitude": "-86.57111000"
                    },
                    {
                        "id": 123892,
                        "name": "Parsons",
                        "latitude": "35.64979000",
                        "longitude": "-88.12670000"
                    },
                    {
                        "id": 123985,
                        "name": "Pegram",
                        "latitude": "36.10061000",
                        "longitude": "-87.05112000"
                    },
                    {
                        "id": 124081,
                        "name": "Perry County",
                        "latitude": "35.64263000",
                        "longitude": "-87.85897000"
                    },
                    {
                        "id": 124159,
                        "name": "Pickett County",
                        "latitude": "36.55841000",
                        "longitude": "-85.07499000"
                    },
                    {
                        "id": 124183,
                        "name": "Pigeon Forge",
                        "latitude": "35.78842000",
                        "longitude": "-83.55433000"
                    },
                    {
                        "id": 124199,
                        "name": "Pikeville",
                        "latitude": "35.60562000",
                        "longitude": "-85.18885000"
                    },
                    {
                        "id": 124220,
                        "name": "Pine Crest",
                        "latitude": "36.29927000",
                        "longitude": "-82.31792000"
                    },
                    {
                        "id": 124276,
                        "name": "Piperton",
                        "latitude": "35.04509000",
                        "longitude": "-89.62175000"
                    },
                    {
                        "id": 124332,
                        "name": "Plainview",
                        "latitude": "36.17731000",
                        "longitude": "-83.79534000"
                    },
                    {
                        "id": 124380,
                        "name": "Pleasant View",
                        "latitude": "36.39422000",
                        "longitude": "-87.03667000"
                    },
                    {
                        "id": 124445,
                        "name": "Polk County",
                        "latitude": "35.11990000",
                        "longitude": "-84.52330000"
                    },
                    {
                        "id": 124558,
                        "name": "Portland",
                        "latitude": "36.58171000",
                        "longitude": "-86.51638000"
                    },
                    {
                        "id": 124614,
                        "name": "Powells Crossroads",
                        "latitude": "35.18952000",
                        "longitude": "-85.48580000"
                    },
                    {
                        "id": 124733,
                        "name": "Pulaski",
                        "latitude": "35.19980000",
                        "longitude": "-87.03084000"
                    },
                    {
                        "id": 124764,
                        "name": "Putnam County",
                        "latitude": "36.14083000",
                        "longitude": "-85.49519000"
                    },
                    {
                        "id": 124937,
                        "name": "Red Bank",
                        "latitude": "35.11229000",
                        "longitude": "-85.29413000"
                    },
                    {
                        "id": 124941,
                        "name": "Red Boiling Springs",
                        "latitude": "36.53339000",
                        "longitude": "-85.84998000"
                    },
                    {
                        "id": 125043,
                        "name": "Rhea County",
                        "latitude": "35.60871000",
                        "longitude": "-84.92440000"
                    },
                    {
                        "id": 125126,
                        "name": "Ridgely",
                        "latitude": "36.26340000",
                        "longitude": "-89.48785000"
                    },
                    {
                        "id": 125128,
                        "name": "Ridgetop",
                        "latitude": "36.39505000",
                        "longitude": "-86.77944000"
                    },
                    {
                        "id": 125163,
                        "name": "Ripley",
                        "latitude": "35.74536000",
                        "longitude": "-89.52980000"
                    },
                    {
                        "id": 125223,
                        "name": "Roan Mountain",
                        "latitude": "36.19623000",
                        "longitude": "-82.07040000"
                    },
                    {
                        "id": 125224,
                        "name": "Roane County",
                        "latitude": "35.84786000",
                        "longitude": "-84.52324000"
                    },
                    {
                        "id": 125246,
                        "name": "Robertson County",
                        "latitude": "36.52546000",
                        "longitude": "-86.87057000"
                    },
                    {
                        "id": 125332,
                        "name": "Rockwood",
                        "latitude": "35.86563000",
                        "longitude": "-84.68494000"
                    },
                    {
                        "id": 125340,
                        "name": "Rocky Top",
                        "latitude": "36.21786000",
                        "longitude": "-84.15465000"
                    },
                    {
                        "id": 125356,
                        "name": "Rogersville",
                        "latitude": "36.40732000",
                        "longitude": "-83.00544000"
                    },
                    {
                        "id": 125517,
                        "name": "Rural Hill",
                        "latitude": "36.11673000",
                        "longitude": "-86.47916000"
                    },
                    {
                        "id": 125548,
                        "name": "Rutherford",
                        "latitude": "36.12757000",
                        "longitude": "-88.98590000"
                    },
                    {
                        "id": 125553,
                        "name": "Rutherford County",
                        "latitude": "35.84270000",
                        "longitude": "-86.41674000"
                    },
                    {
                        "id": 125559,
                        "name": "Rutledge",
                        "latitude": "36.28092000",
                        "longitude": "-83.51490000"
                    },
                    {
                        "id": 125725,
                        "name": "Sale Creek",
                        "latitude": "35.38229000",
                        "longitude": "-85.10884000"
                    },
                    {
                        "id": 125976,
                        "name": "Savannah",
                        "latitude": "35.22480000",
                        "longitude": "-88.24920000"
                    },
                    {
                        "id": 126049,
                        "name": "Scott County",
                        "latitude": "36.42854000",
                        "longitude": "-84.50352000"
                    },
                    {
                        "id": 126142,
                        "name": "Selmer",
                        "latitude": "35.17008000",
                        "longitude": "-88.59227000"
                    },
                    {
                        "id": 126163,
                        "name": "Sequatchie County",
                        "latitude": "35.37115000",
                        "longitude": "-85.41059000"
                    },
                    {
                        "id": 126181,
                        "name": "Sevier County",
                        "latitude": "35.78466000",
                        "longitude": "-83.52418000"
                    },
                    {
                        "id": 126183,
                        "name": "Sevierville",
                        "latitude": "35.86815000",
                        "longitude": "-83.56184000"
                    },
                    {
                        "id": 126185,
                        "name": "Sewanee",
                        "latitude": "35.20314000",
                        "longitude": "-85.92109000"
                    },
                    {
                        "id": 126194,
                        "name": "Seymour",
                        "latitude": "35.89064000",
                        "longitude": "-83.72462000"
                    },
                    {
                        "id": 126200,
                        "name": "Shackle Island",
                        "latitude": "36.37060000",
                        "longitude": "-86.61666000"
                    },
                    {
                        "id": 126277,
                        "name": "Shelby County",
                        "latitude": "35.18400000",
                        "longitude": "-89.89560000"
                    },
                    {
                        "id": 126284,
                        "name": "Shelbyville",
                        "latitude": "35.48341000",
                        "longitude": "-86.46027000"
                    },
                    {
                        "id": 126412,
                        "name": "Signal Mountain",
                        "latitude": "35.12257000",
                        "longitude": "-85.34385000"
                    },
                    {
                        "id": 126514,
                        "name": "Smith County",
                        "latitude": "36.25053000",
                        "longitude": "-85.95671000"
                    },
                    {
                        "id": 126530,
                        "name": "Smithville",
                        "latitude": "35.96062000",
                        "longitude": "-85.81415000"
                    },
                    {
                        "id": 126536,
                        "name": "Smyrna",
                        "latitude": "35.98284000",
                        "longitude": "-86.51860000"
                    },
                    {
                        "id": 126540,
                        "name": "Sneedville",
                        "latitude": "36.52981000",
                        "longitude": "-83.21740000"
                    },
                    {
                        "id": 126563,
                        "name": "Soddy-Daisy",
                        "latitude": "35.23590000",
                        "longitude": "-85.19079000"
                    },
                    {
                        "id": 126593,
                        "name": "Somerville",
                        "latitude": "35.24370000",
                        "longitude": "-89.35007000"
                    },
                    {
                        "id": 126635,
                        "name": "South Carthage",
                        "latitude": "36.24200000",
                        "longitude": "-85.95193000"
                    },
                    {
                        "id": 126639,
                        "name": "South Cleveland",
                        "latitude": "35.14119000",
                        "longitude": "-84.87217000"
                    },
                    {
                        "id": 126656,
                        "name": "South Fulton",
                        "latitude": "36.50089000",
                        "longitude": "-88.87534000"
                    },
                    {
                        "id": 126710,
                        "name": "South Pittsburg",
                        "latitude": "35.01230000",
                        "longitude": "-85.70441000"
                    },
                    {
                        "id": 126810,
                        "name": "Sparta",
                        "latitude": "35.92590000",
                        "longitude": "-85.46414000"
                    },
                    {
                        "id": 126823,
                        "name": "Spencer",
                        "latitude": "35.74729000",
                        "longitude": "-85.46664000"
                    },
                    {
                        "id": 126851,
                        "name": "Spring City",
                        "latitude": "35.69201000",
                        "longitude": "-84.86078000"
                    },
                    {
                        "id": 126862,
                        "name": "Spring Hill",
                        "latitude": "35.75118000",
                        "longitude": "-86.93000000"
                    },
                    {
                        "id": 126895,
                        "name": "Springfield",
                        "latitude": "36.50921000",
                        "longitude": "-86.88500000"
                    },
                    {
                        "id": 126922,
                        "name": "Spurgeon",
                        "latitude": "36.43955000",
                        "longitude": "-82.45570000"
                    },
                    {
                        "id": 127051,
                        "name": "Stewart County",
                        "latitude": "36.50110000",
                        "longitude": "-87.83846000"
                    },
                    {
                        "id": 127187,
                        "name": "Sullivan County",
                        "latitude": "36.51292000",
                        "longitude": "-82.30414000"
                    },
                    {
                        "id": 127225,
                        "name": "Sumner County",
                        "latitude": "36.46941000",
                        "longitude": "-86.46036000"
                    },
                    {
                        "id": 127289,
                        "name": "Surgoinsville",
                        "latitude": "36.47093000",
                        "longitude": "-82.85183000"
                    },
                    {
                        "id": 127341,
                        "name": "Sweetwater",
                        "latitude": "35.60146000",
                        "longitude": "-84.46104000"
                    },
                    {
                        "id": 127468,
                        "name": "Tazewell",
                        "latitude": "36.45425000",
                        "longitude": "-83.56935000"
                    },
                    {
                        "id": 127490,
                        "name": "Tellico Village",
                        "latitude": "35.68321000",
                        "longitude": "-84.25518000"
                    },
                    {
                        "id": 127510,
                        "name": "Tennessee Ridge",
                        "latitude": "36.31200000",
                        "longitude": "-87.77336000"
                    },
                    {
                        "id": 127593,
                        "name": "Thompson's Station",
                        "latitude": "35.80201000",
                        "longitude": "-86.91139000"
                    },
                    {
                        "id": 127622,
                        "name": "Three Way",
                        "latitude": "35.77590000",
                        "longitude": "-88.85950000"
                    },
                    {
                        "id": 127679,
                        "name": "Tipton County",
                        "latitude": "35.49687000",
                        "longitude": "-89.75924000"
                    },
                    {
                        "id": 127681,
                        "name": "Tiptonville",
                        "latitude": "36.37840000",
                        "longitude": "-89.47202000"
                    },
                    {
                        "id": 127772,
                        "name": "Tracy City",
                        "latitude": "35.26036000",
                        "longitude": "-85.73608000"
                    },
                    {
                        "id": 127805,
                        "name": "Trenton",
                        "latitude": "35.98062000",
                        "longitude": "-88.94145000"
                    },
                    {
                        "id": 127837,
                        "name": "Trousdale County",
                        "latitude": "36.39204000",
                        "longitude": "-86.15675000"
                    },
                    {
                        "id": 127847,
                        "name": "Troy",
                        "latitude": "36.33868000",
                        "longitude": "-89.16396000"
                    },
                    {
                        "id": 127886,
                        "name": "Tullahoma",
                        "latitude": "35.36202000",
                        "longitude": "-86.20943000"
                    },
                    {
                        "id": 127913,
                        "name": "Tusculum",
                        "latitude": "36.17510000",
                        "longitude": "-82.75876000"
                    },
                    {
                        "id": 127969,
                        "name": "Unicoi",
                        "latitude": "36.19539000",
                        "longitude": "-82.34958000"
                    },
                    {
                        "id": 127970,
                        "name": "Unicoi County",
                        "latitude": "36.11082000",
                        "longitude": "-82.43224000"
                    },
                    {
                        "id": 127982,
                        "name": "Union City",
                        "latitude": "36.42423000",
                        "longitude": "-89.05701000"
                    },
                    {
                        "id": 127997,
                        "name": "Union County",
                        "latitude": "36.28787000",
                        "longitude": "-83.83751000"
                    },
                    {
                        "id": 128019,
                        "name": "Unionville",
                        "latitude": "35.62174000",
                        "longitude": "-86.59250000"
                    },
                    {
                        "id": 128130,
                        "name": "Van Buren County",
                        "latitude": "35.69598000",
                        "longitude": "-85.45261000"
                    },
                    {
                        "id": 128305,
                        "name": "Vonore",
                        "latitude": "35.59008000",
                        "longitude": "-84.24186000"
                    },
                    {
                        "id": 128367,
                        "name": "Walden",
                        "latitude": "35.16479000",
                        "longitude": "-85.30135000"
                    },
                    {
                        "id": 153923,
                        "name": "Walling",
                        "latitude": "35.80835596",
                        "longitude": "-85.59817379"
                    },
                    {
                        "id": 128421,
                        "name": "Walnut Hill",
                        "latitude": "36.56983000",
                        "longitude": "-82.25680000"
                    },
                    {
                        "id": 128491,
                        "name": "Warren County",
                        "latitude": "35.67868000",
                        "longitude": "-85.77850000"
                    },
                    {
                        "id": 128523,
                        "name": "Wartburg",
                        "latitude": "36.10480000",
                        "longitude": "-84.59716000"
                    },
                    {
                        "id": 128565,
                        "name": "Washington County",
                        "latitude": "36.29330000",
                        "longitude": "-82.49743000"
                    },
                    {
                        "id": 128619,
                        "name": "Watertown",
                        "latitude": "36.10034000",
                        "longitude": "-86.13193000"
                    },
                    {
                        "id": 128666,
                        "name": "Waverly",
                        "latitude": "36.08395000",
                        "longitude": "-87.79475000"
                    },
                    {
                        "id": 128696,
                        "name": "Wayne County",
                        "latitude": "35.23992000",
                        "longitude": "-87.78801000"
                    },
                    {
                        "id": 128708,
                        "name": "Waynesboro",
                        "latitude": "35.31952000",
                        "longitude": "-87.76225000"
                    },
                    {
                        "id": 128714,
                        "name": "Weakley County",
                        "latitude": "36.29830000",
                        "longitude": "-88.71774000"
                    },
                    {
                        "id": 129053,
                        "name": "Westmoreland",
                        "latitude": "36.56199000",
                        "longitude": "-86.24804000"
                    },
                    {
                        "id": 129127,
                        "name": "White Bluff",
                        "latitude": "36.10756000",
                        "longitude": "-87.22084000"
                    },
                    {
                        "id": 129137,
                        "name": "White County",
                        "latitude": "35.92635000",
                        "longitude": "-85.45518000"
                    },
                    {
                        "id": 129143,
                        "name": "White House",
                        "latitude": "36.47032000",
                        "longitude": "-86.65138000"
                    },
                    {
                        "id": 129152,
                        "name": "White Pine",
                        "latitude": "36.10759000",
                        "longitude": "-83.28683000"
                    },
                    {
                        "id": 129190,
                        "name": "Whiteville",
                        "latitude": "35.32647000",
                        "longitude": "-89.14951000"
                    },
                    {
                        "id": 129212,
                        "name": "Whitwell",
                        "latitude": "35.20146000",
                        "longitude": "-85.51913000"
                    },
                    {
                        "id": 129239,
                        "name": "Wildwood",
                        "latitude": "35.80370000",
                        "longitude": "-83.87129000"
                    },
                    {
                        "id": 129242,
                        "name": "Wildwood Lake",
                        "latitude": "35.09202000",
                        "longitude": "-84.85439000"
                    },
                    {
                        "id": 129277,
                        "name": "Williamson County",
                        "latitude": "35.89378000",
                        "longitude": "-86.89860000"
                    },
                    {
                        "id": 129336,
                        "name": "Wilson County",
                        "latitude": "36.15486000",
                        "longitude": "-86.29763000"
                    },
                    {
                        "id": 129355,
                        "name": "Winchester",
                        "latitude": "35.18592000",
                        "longitude": "-86.11221000"
                    },
                    {
                        "id": 129507,
                        "name": "Woodbury",
                        "latitude": "35.82757000",
                        "longitude": "-86.07166000"
                    }
                ]
            },
            {
                "id": 1407,
                "name": "Texas",
                "iso2": "TX",
                "latitude": "31.96859880",
                "longitude": "-99.90181310",
                "type": "state",
                "cities": [
                    {
                        "id": 110981,
                        "name": "Abernathy",
                        "latitude": "33.83230000",
                        "longitude": "-101.84295000"
                    },
                    {
                        "id": 110983,
                        "name": "Abilene",
                        "latitude": "32.44874000",
                        "longitude": "-99.73314000"
                    },
                    {
                        "id": 110988,
                        "name": "Abram",
                        "latitude": "26.19980000",
                        "longitude": "-98.41113000"
                    },
                    {
                        "id": 111034,
                        "name": "Addison",
                        "latitude": "32.96179000",
                        "longitude": "-96.82917000"
                    },
                    {
                        "id": 111059,
                        "name": "Agua Dulce",
                        "latitude": "31.65511000",
                        "longitude": "-106.13887000"
                    },
                    {
                        "id": 111092,
                        "name": "Alamo",
                        "latitude": "26.18369000",
                        "longitude": "-98.12306000"
                    },
                    {
                        "id": 111096,
                        "name": "Alamo Heights",
                        "latitude": "29.48495000",
                        "longitude": "-98.46585000"
                    },
                    {
                        "id": 111104,
                        "name": "Albany",
                        "latitude": "32.72345000",
                        "longitude": "-99.29730000"
                    },
                    {
                        "id": 111140,
                        "name": "Aldine",
                        "latitude": "29.93245000",
                        "longitude": "-95.38021000"
                    },
                    {
                        "id": 111141,
                        "name": "Aledo",
                        "latitude": "32.69596000",
                        "longitude": "-97.60225000"
                    },
                    {
                        "id": 111171,
                        "name": "Alice",
                        "latitude": "27.75225000",
                        "longitude": "-98.06972000"
                    },
                    {
                        "id": 111173,
                        "name": "Alief",
                        "latitude": "29.71106000",
                        "longitude": "-95.59633000"
                    },
                    {
                        "id": 111187,
                        "name": "Allen",
                        "latitude": "33.10317000",
                        "longitude": "-96.67055000"
                    },
                    {
                        "id": 111224,
                        "name": "Alpine",
                        "latitude": "30.35862000",
                        "longitude": "-103.66206000"
                    },
                    {
                        "id": 111240,
                        "name": "Alto",
                        "latitude": "31.65045000",
                        "longitude": "-95.07272000"
                    },
                    {
                        "id": 111244,
                        "name": "Alton",
                        "latitude": "26.28729000",
                        "longitude": "-98.31335000"
                    },
                    {
                        "id": 111246,
                        "name": "Alton North (historical)",
                        "latitude": "26.29535000",
                        "longitude": "-98.30446000"
                    },
                    {
                        "id": 111257,
                        "name": "Alvarado",
                        "latitude": "32.40653000",
                        "longitude": "-97.21168000"
                    },
                    {
                        "id": 111258,
                        "name": "Alvin",
                        "latitude": "29.42385000",
                        "longitude": "-95.24410000"
                    },
                    {
                        "id": 111259,
                        "name": "Alvord",
                        "latitude": "33.35845000",
                        "longitude": "-97.69475000"
                    },
                    {
                        "id": 111263,
                        "name": "Amarillo",
                        "latitude": "35.22200000",
                        "longitude": "-101.83130000"
                    },
                    {
                        "id": 111276,
                        "name": "Ames",
                        "latitude": "30.05383000",
                        "longitude": "-94.74353000"
                    },
                    {
                        "id": 111301,
                        "name": "Anahuac",
                        "latitude": "29.77300000",
                        "longitude": "-94.68270000"
                    },
                    {
                        "id": 111312,
                        "name": "Anderson",
                        "latitude": "30.48715000",
                        "longitude": "-95.98690000"
                    },
                    {
                        "id": 111319,
                        "name": "Anderson County",
                        "latitude": "31.81333000",
                        "longitude": "-95.65255000"
                    },
                    {
                        "id": 111320,
                        "name": "Anderson Mill",
                        "latitude": "30.45492000",
                        "longitude": "-97.80584000"
                    },
                    {
                        "id": 111331,
                        "name": "Andrews",
                        "latitude": "32.31872000",
                        "longitude": "-102.54572000"
                    },
                    {
                        "id": 111333,
                        "name": "Andrews County",
                        "latitude": "32.30503000",
                        "longitude": "-102.63781000"
                    },
                    {
                        "id": 111336,
                        "name": "Angelina County",
                        "latitude": "31.25476000",
                        "longitude": "-94.61185000"
                    },
                    {
                        "id": 111339,
                        "name": "Angleton",
                        "latitude": "29.16941000",
                        "longitude": "-95.43188000"
                    },
                    {
                        "id": 111347,
                        "name": "Anna",
                        "latitude": "33.34900000",
                        "longitude": "-96.54860000"
                    },
                    {
                        "id": 111354,
                        "name": "Annetta",
                        "latitude": "32.70930000",
                        "longitude": "-97.67614000"
                    },
                    {
                        "id": 111360,
                        "name": "Anson",
                        "latitude": "32.75650000",
                        "longitude": "-99.89621000"
                    },
                    {
                        "id": 111370,
                        "name": "Anthony",
                        "latitude": "31.99927000",
                        "longitude": "-106.60555000"
                    },
                    {
                        "id": 111375,
                        "name": "Anton",
                        "latitude": "33.81120000",
                        "longitude": "-102.16379000"
                    },
                    {
                        "id": 111410,
                        "name": "Aransas County",
                        "latitude": "28.01501000",
                        "longitude": "-97.07382000"
                    },
                    {
                        "id": 111411,
                        "name": "Aransas Pass",
                        "latitude": "27.90947000",
                        "longitude": "-97.14999000"
                    },
                    {
                        "id": 111430,
                        "name": "Archer City",
                        "latitude": "33.59566000",
                        "longitude": "-98.62561000"
                    },
                    {
                        "id": 111431,
                        "name": "Archer County",
                        "latitude": "33.61525000",
                        "longitude": "-98.68765000"
                    },
                    {
                        "id": 111437,
                        "name": "Arcola",
                        "latitude": "29.49607000",
                        "longitude": "-95.46578000"
                    },
                    {
                        "id": 111450,
                        "name": "Argyle",
                        "latitude": "33.12123000",
                        "longitude": "-97.18335000"
                    },
                    {
                        "id": 111464,
                        "name": "Arlington",
                        "latitude": "32.73569000",
                        "longitude": "-97.10807000"
                    },
                    {
                        "id": 111481,
                        "name": "Armstrong County",
                        "latitude": "34.96493000",
                        "longitude": "-101.35740000"
                    },
                    {
                        "id": 111521,
                        "name": "Asherton",
                        "latitude": "28.44193000",
                        "longitude": "-99.76033000"
                    },
                    {
                        "id": 111554,
                        "name": "Aspermont",
                        "latitude": "33.13343000",
                        "longitude": "-100.22733000"
                    },
                    {
                        "id": 111565,
                        "name": "Atascocita",
                        "latitude": "29.99883000",
                        "longitude": "-95.17660000"
                    },
                    {
                        "id": 111566,
                        "name": "Atascosa County",
                        "latitude": "28.89352000",
                        "longitude": "-98.52713000"
                    },
                    {
                        "id": 111576,
                        "name": "Athens",
                        "latitude": "32.20487000",
                        "longitude": "-95.85552000"
                    },
                    {
                        "id": 111591,
                        "name": "Atlanta",
                        "latitude": "33.11374000",
                        "longitude": "-94.16435000"
                    },
                    {
                        "id": 111618,
                        "name": "Aubrey",
                        "latitude": "33.30428000",
                        "longitude": "-96.98612000"
                    },
                    {
                        "id": 111658,
                        "name": "Aurora",
                        "latitude": "33.06068000",
                        "longitude": "-97.50336000"
                    },
                    {
                        "id": 111668,
                        "name": "Austin",
                        "latitude": "30.26715000",
                        "longitude": "-97.74306000"
                    },
                    {
                        "id": 111670,
                        "name": "Austin County",
                        "latitude": "29.88702000",
                        "longitude": "-96.27791000"
                    },
                    {
                        "id": 111710,
                        "name": "Azle",
                        "latitude": "32.89513000",
                        "longitude": "-97.54586000"
                    },
                    {
                        "id": 111719,
                        "name": "Bacliff",
                        "latitude": "29.50690000",
                        "longitude": "-94.99243000"
                    },
                    {
                        "id": 111730,
                        "name": "Bailey County",
                        "latitude": "34.06852000",
                        "longitude": "-102.82987000"
                    },
                    {
                        "id": 111736,
                        "name": "Baird",
                        "latitude": "32.39402000",
                        "longitude": "-99.39424000"
                    },
                    {
                        "id": 111749,
                        "name": "Balch Springs",
                        "latitude": "32.72874000",
                        "longitude": "-96.62277000"
                    },
                    {
                        "id": 111750,
                        "name": "Balcones Heights",
                        "latitude": "29.48801000",
                        "longitude": "-98.55169000"
                    },
                    {
                        "id": 111773,
                        "name": "Ballinger",
                        "latitude": "31.73821000",
                        "longitude": "-99.94731000"
                    },
                    {
                        "id": 111788,
                        "name": "Bandera",
                        "latitude": "29.72661000",
                        "longitude": "-99.07365000"
                    },
                    {
                        "id": 111789,
                        "name": "Bandera County",
                        "latitude": "29.74721000",
                        "longitude": "-99.24624000"
                    },
                    {
                        "id": 111796,
                        "name": "Bangs",
                        "latitude": "31.71710000",
                        "longitude": "-99.13255000"
                    },
                    {
                        "id": 111844,
                        "name": "Barrett",
                        "latitude": "29.87995000",
                        "longitude": "-95.06298000"
                    },
                    {
                        "id": 111862,
                        "name": "Bartlett",
                        "latitude": "30.79491000",
                        "longitude": "-97.42556000"
                    },
                    {
                        "id": 111868,
                        "name": "Barton Creek",
                        "latitude": "30.28521000",
                        "longitude": "-97.86917000"
                    },
                    {
                        "id": 111870,
                        "name": "Bartonville",
                        "latitude": "33.07318000",
                        "longitude": "-97.13168000"
                    },
                    {
                        "id": 111884,
                        "name": "Bastrop",
                        "latitude": "30.11049000",
                        "longitude": "-97.31527000"
                    },
                    {
                        "id": 111885,
                        "name": "Bastrop County",
                        "latitude": "30.10361000",
                        "longitude": "-97.31201000"
                    },
                    {
                        "id": 111895,
                        "name": "Batesville",
                        "latitude": "28.95108000",
                        "longitude": "-99.61783000"
                    },
                    {
                        "id": 111921,
                        "name": "Bay City",
                        "latitude": "28.98276000",
                        "longitude": "-95.96940000"
                    },
                    {
                        "id": 111943,
                        "name": "Baylor County",
                        "latitude": "33.61649000",
                        "longitude": "-99.21351000"
                    },
                    {
                        "id": 111950,
                        "name": "Bayou Vista",
                        "latitude": "29.32635000",
                        "longitude": "-94.93853000"
                    },
                    {
                        "id": 111958,
                        "name": "Baytown",
                        "latitude": "29.73550000",
                        "longitude": "-94.97743000"
                    },
                    {
                        "id": 111963,
                        "name": "Beach City",
                        "latitude": "29.66217000",
                        "longitude": "-94.88992000"
                    },
                    {
                        "id": 111989,
                        "name": "Beaumont",
                        "latitude": "30.08605000",
                        "longitude": "-94.10185000"
                    },
                    {
                        "id": 112021,
                        "name": "Bedford",
                        "latitude": "32.84402000",
                        "longitude": "-97.14307000"
                    },
                    {
                        "id": 112033,
                        "name": "Bee Cave",
                        "latitude": "30.30854000",
                        "longitude": "-97.94501000"
                    },
                    {
                        "id": 112034,
                        "name": "Bee County",
                        "latitude": "28.41739000",
                        "longitude": "-97.74119000"
                    },
                    {
                        "id": 112044,
                        "name": "Beeville",
                        "latitude": "28.40095000",
                        "longitude": "-97.74974000"
                    },
                    {
                        "id": 112069,
                        "name": "Bell County",
                        "latitude": "31.03767000",
                        "longitude": "-97.47820000"
                    },
                    {
                        "id": 112075,
                        "name": "Bellaire",
                        "latitude": "29.70579000",
                        "longitude": "-95.45883000"
                    },
                    {
                        "id": 112122,
                        "name": "Bellmead",
                        "latitude": "31.59405000",
                        "longitude": "-97.10889000"
                    },
                    {
                        "id": 112127,
                        "name": "Bells",
                        "latitude": "33.61038000",
                        "longitude": "-96.41082000"
                    },
                    {
                        "id": 112129,
                        "name": "Bellville",
                        "latitude": "29.95023000",
                        "longitude": "-96.25719000"
                    },
                    {
                        "id": 112149,
                        "name": "Belton",
                        "latitude": "31.05601000",
                        "longitude": "-97.46445000"
                    },
                    {
                        "id": 112164,
                        "name": "Benavides",
                        "latitude": "27.59892000",
                        "longitude": "-98.40807000"
                    },
                    {
                        "id": 112165,
                        "name": "Benbrook",
                        "latitude": "32.67319000",
                        "longitude": "-97.46058000"
                    },
                    {
                        "id": 112169,
                        "name": "Benjamin",
                        "latitude": "33.58398000",
                        "longitude": "-99.79231000"
                    },
                    {
                        "id": 112256,
                        "name": "Berryville",
                        "latitude": "32.08849000",
                        "longitude": "-95.47190000"
                    },
                    {
                        "id": 112259,
                        "name": "Bertram",
                        "latitude": "30.74380000",
                        "longitude": "-98.05558000"
                    },
                    {
                        "id": 112299,
                        "name": "Beverly",
                        "latitude": "31.52517000",
                        "longitude": "-97.14195000"
                    },
                    {
                        "id": 112304,
                        "name": "Beverly Hills",
                        "latitude": "31.52156000",
                        "longitude": "-97.15389000"
                    },
                    {
                        "id": 112307,
                        "name": "Bevil Oaks",
                        "latitude": "30.15021000",
                        "longitude": "-94.26963000"
                    },
                    {
                        "id": 112308,
                        "name": "Bexar County",
                        "latitude": "29.44896000",
                        "longitude": "-98.52002000"
                    },
                    {
                        "id": 112324,
                        "name": "Big Lake",
                        "latitude": "31.19154000",
                        "longitude": "-101.46039000"
                    },
                    {
                        "id": 112333,
                        "name": "Big Sandy",
                        "latitude": "32.58375000",
                        "longitude": "-95.10883000"
                    },
                    {
                        "id": 112335,
                        "name": "Big Spring",
                        "latitude": "32.25040000",
                        "longitude": "-101.47874000"
                    },
                    {
                        "id": 112363,
                        "name": "Bishop",
                        "latitude": "27.58614000",
                        "longitude": "-97.79916000"
                    },
                    {
                        "id": 112418,
                        "name": "Blanco",
                        "latitude": "30.09799000",
                        "longitude": "-98.42141000"
                    },
                    {
                        "id": 112419,
                        "name": "Blanco County",
                        "latitude": "30.26638000",
                        "longitude": "-98.39987000"
                    },
                    {
                        "id": 112450,
                        "name": "Bloomington",
                        "latitude": "28.64777000",
                        "longitude": "-96.89249000"
                    },
                    {
                        "id": 112456,
                        "name": "Blossom",
                        "latitude": "33.66150000",
                        "longitude": "-95.38579000"
                    },
                    {
                        "id": 112472,
                        "name": "Blue Mound",
                        "latitude": "32.85652000",
                        "longitude": "-97.33891000"
                    },
                    {
                        "id": 112497,
                        "name": "Boerne",
                        "latitude": "29.79466000",
                        "longitude": "-98.73197000"
                    },
                    {
                        "id": 112500,
                        "name": "Bogata",
                        "latitude": "33.47067000",
                        "longitude": "-95.21384000"
                    },
                    {
                        "id": 112515,
                        "name": "Boling",
                        "latitude": "29.26441000",
                        "longitude": "-95.94384000"
                    },
                    {
                        "id": 112522,
                        "name": "Bolivar Peninsula",
                        "latitude": "29.47829000",
                        "longitude": "-94.57991000"
                    },
                    {
                        "id": 112535,
                        "name": "Bonham",
                        "latitude": "33.57733000",
                        "longitude": "-96.17831000"
                    },
                    {
                        "id": 112551,
                        "name": "Booker",
                        "latitude": "36.45336000",
                        "longitude": "-100.53737000"
                    },
                    {
                        "id": 112575,
                        "name": "Borden County",
                        "latitude": "32.74369000",
                        "longitude": "-101.43175000"
                    },
                    {
                        "id": 112577,
                        "name": "Borger",
                        "latitude": "35.66782000",
                        "longitude": "-101.39739000"
                    },
                    {
                        "id": 112584,
                        "name": "Bosque County",
                        "latitude": "31.90040000",
                        "longitude": "-97.63435000"
                    },
                    {
                        "id": 112619,
                        "name": "Bovina",
                        "latitude": "34.51368000",
                        "longitude": "-102.88300000"
                    },
                    {
                        "id": 112624,
                        "name": "Bowie",
                        "latitude": "33.55900000",
                        "longitude": "-97.84865000"
                    },
                    {
                        "id": 112625,
                        "name": "Bowie County",
                        "latitude": "33.44576000",
                        "longitude": "-94.42332000"
                    },
                    {
                        "id": 112641,
                        "name": "Boyd",
                        "latitude": "33.07873000",
                        "longitude": "-97.56530000"
                    },
                    {
                        "id": 112657,
                        "name": "Brackettville",
                        "latitude": "29.31051000",
                        "longitude": "-100.41786000"
                    },
                    {
                        "id": 112678,
                        "name": "Brady",
                        "latitude": "31.13517000",
                        "longitude": "-99.33506000"
                    },
                    {
                        "id": 112704,
                        "name": "Brazoria",
                        "latitude": "29.04441000",
                        "longitude": "-95.56911000"
                    },
                    {
                        "id": 112705,
                        "name": "Brazoria County",
                        "latitude": "29.16783000",
                        "longitude": "-95.43426000"
                    },
                    {
                        "id": 112706,
                        "name": "Brazos County",
                        "latitude": "30.66080000",
                        "longitude": "-96.30239000"
                    },
                    {
                        "id": 112710,
                        "name": "Breckenridge",
                        "latitude": "32.75568000",
                        "longitude": "-98.90229000"
                    },
                    {
                        "id": 112724,
                        "name": "Brenham",
                        "latitude": "30.16688000",
                        "longitude": "-96.39774000"
                    },
                    {
                        "id": 112745,
                        "name": "Brewster County",
                        "latitude": "29.81195000",
                        "longitude": "-103.25176000"
                    },
                    {
                        "id": 112748,
                        "name": "Briar",
                        "latitude": "32.99512000",
                        "longitude": "-97.54280000"
                    },
                    {
                        "id": 112749,
                        "name": "Briarcliff",
                        "latitude": "30.40742000",
                        "longitude": "-98.04446000"
                    },
                    {
                        "id": 112756,
                        "name": "Bridge City",
                        "latitude": "30.02077000",
                        "longitude": "-93.84573000"
                    },
                    {
                        "id": 112759,
                        "name": "Bridgeport",
                        "latitude": "33.21012000",
                        "longitude": "-97.75476000"
                    },
                    {
                        "id": 112801,
                        "name": "Briscoe County",
                        "latitude": "34.53026000",
                        "longitude": "-101.20859000"
                    },
                    {
                        "id": 112884,
                        "name": "Brooks County",
                        "latitude": "27.03157000",
                        "longitude": "-98.21872000"
                    },
                    {
                        "id": 112885,
                        "name": "Brookshire",
                        "latitude": "29.78606000",
                        "longitude": "-95.95107000"
                    },
                    {
                        "id": 112888,
                        "name": "Brookside Village",
                        "latitude": "29.58690000",
                        "longitude": "-95.32522000"
                    },
                    {
                        "id": 112910,
                        "name": "Brown County",
                        "latitude": "31.77426000",
                        "longitude": "-98.99979000"
                    },
                    {
                        "id": 112917,
                        "name": "Brownfield",
                        "latitude": "33.18120000",
                        "longitude": "-102.27435000"
                    },
                    {
                        "id": 112923,
                        "name": "Brownsboro",
                        "latitude": "32.30237000",
                        "longitude": "-95.61357000"
                    },
                    {
                        "id": 112932,
                        "name": "Brownsville",
                        "latitude": "25.90175000",
                        "longitude": "-97.49748000"
                    },
                    {
                        "id": 112940,
                        "name": "Brownwood",
                        "latitude": "31.70932000",
                        "longitude": "-98.99116000"
                    },
                    {
                        "id": 112944,
                        "name": "Bruceville-Eddy",
                        "latitude": "31.30517000",
                        "longitude": "-97.25167000"
                    },
                    {
                        "id": 112956,
                        "name": "Brushy Creek",
                        "latitude": "30.51353000",
                        "longitude": "-97.73973000"
                    },
                    {
                        "id": 112959,
                        "name": "Bryan",
                        "latitude": "30.67436000",
                        "longitude": "-96.36996000"
                    },
                    {
                        "id": 112976,
                        "name": "Buchanan Dam",
                        "latitude": "30.73990000",
                        "longitude": "-98.43114000"
                    },
                    {
                        "id": 112993,
                        "name": "Buda",
                        "latitude": "30.08521000",
                        "longitude": "-97.84028000"
                    },
                    {
                        "id": 113010,
                        "name": "Buffalo",
                        "latitude": "31.46379000",
                        "longitude": "-96.05802000"
                    },
                    {
                        "id": 113030,
                        "name": "Bullard",
                        "latitude": "32.13988000",
                        "longitude": "-95.32023000"
                    },
                    {
                        "id": 113035,
                        "name": "Bulverde",
                        "latitude": "29.74383000",
                        "longitude": "-98.45307000"
                    },
                    {
                        "id": 113036,
                        "name": "Buna",
                        "latitude": "30.43298000",
                        "longitude": "-93.96240000"
                    },
                    {
                        "id": 113042,
                        "name": "Bunker Hill Village",
                        "latitude": "29.76745000",
                        "longitude": "-95.52994000"
                    },
                    {
                        "id": 113053,
                        "name": "Burkburnett",
                        "latitude": "34.09787000",
                        "longitude": "-98.57061000"
                    },
                    {
                        "id": 113061,
                        "name": "Burleson",
                        "latitude": "32.54208000",
                        "longitude": "-97.32085000"
                    },
                    {
                        "id": 113062,
                        "name": "Burleson County",
                        "latitude": "30.49248000",
                        "longitude": "-96.62146000"
                    },
                    {
                        "id": 113078,
                        "name": "Burnet",
                        "latitude": "30.75824000",
                        "longitude": "-98.22836000"
                    },
                    {
                        "id": 113079,
                        "name": "Burnet County",
                        "latitude": "30.78830000",
                        "longitude": "-98.18245000"
                    },
                    {
                        "id": 113100,
                        "name": "Bushland",
                        "latitude": "35.19200000",
                        "longitude": "-102.06464000"
                    },
                    {
                        "id": 113157,
                        "name": "Cactus",
                        "latitude": "36.05226000",
                        "longitude": "-102.00240000"
                    },
                    {
                        "id": 113161,
                        "name": "Caddo Mills",
                        "latitude": "33.06567000",
                        "longitude": "-96.22776000"
                    },
                    {
                        "id": 113180,
                        "name": "Caldwell",
                        "latitude": "30.53132000",
                        "longitude": "-96.69303000"
                    },
                    {
                        "id": 113186,
                        "name": "Caldwell County",
                        "latitude": "29.83712000",
                        "longitude": "-97.62000000"
                    },
                    {
                        "id": 113207,
                        "name": "Calhoun County",
                        "latitude": "28.43911000",
                        "longitude": "-96.61507000"
                    },
                    {
                        "id": 113223,
                        "name": "Callahan County",
                        "latitude": "32.29766000",
                        "longitude": "-99.37349000"
                    },
                    {
                        "id": 113233,
                        "name": "Calvert",
                        "latitude": "30.97797000",
                        "longitude": "-96.67386000"
                    },
                    {
                        "id": 113275,
                        "name": "Cameron",
                        "latitude": "30.85325000",
                        "longitude": "-96.97693000"
                    },
                    {
                        "id": 113277,
                        "name": "Cameron County",
                        "latitude": "26.15150000",
                        "longitude": "-97.45286000"
                    },
                    {
                        "id": 113280,
                        "name": "Cameron Park",
                        "latitude": "25.96452000",
                        "longitude": "-97.47665000"
                    },
                    {
                        "id": 113282,
                        "name": "Cameron Park Colonia",
                        "latitude": "25.97147000",
                        "longitude": "-97.47832000"
                    },
                    {
                        "id": 113286,
                        "name": "Camp County",
                        "latitude": "32.97322000",
                        "longitude": "-94.97848000"
                    },
                    {
                        "id": 113294,
                        "name": "Camp Swift",
                        "latitude": "30.19077000",
                        "longitude": "-97.29221000"
                    },
                    {
                        "id": 113314,
                        "name": "Canadian",
                        "latitude": "35.91282000",
                        "longitude": "-100.38208000"
                    },
                    {
                        "id": 113342,
                        "name": "Canton",
                        "latitude": "32.55652000",
                        "longitude": "-95.86330000"
                    },
                    {
                        "id": 113353,
                        "name": "Canutillo",
                        "latitude": "31.91149000",
                        "longitude": "-106.60027000"
                    },
                    {
                        "id": 113354,
                        "name": "Canyon",
                        "latitude": "34.98033000",
                        "longitude": "-101.91880000"
                    },
                    {
                        "id": 113358,
                        "name": "Canyon Lake",
                        "latitude": "29.87522000",
                        "longitude": "-98.26251000"
                    },
                    {
                        "id": 113447,
                        "name": "Carrizo Springs",
                        "latitude": "28.52193000",
                        "longitude": "-99.86061000"
                    },
                    {
                        "id": 113470,
                        "name": "Carrollton",
                        "latitude": "32.95373000",
                        "longitude": "-96.89028000"
                    },
                    {
                        "id": 113479,
                        "name": "Carson County",
                        "latitude": "35.40351000",
                        "longitude": "-101.35418000"
                    },
                    {
                        "id": 113495,
                        "name": "Carthage",
                        "latitude": "32.15738000",
                        "longitude": "-94.33742000"
                    },
                    {
                        "id": 113528,
                        "name": "Cass County",
                        "latitude": "33.07754000",
                        "longitude": "-94.34359000"
                    },
                    {
                        "id": 113545,
                        "name": "Castle Hills",
                        "latitude": "29.52329000",
                        "longitude": "-98.51641000"
                    },
                    {
                        "id": 113556,
                        "name": "Castro County",
                        "latitude": "34.52996000",
                        "longitude": "-102.26167000"
                    },
                    {
                        "id": 113558,
                        "name": "Castroville",
                        "latitude": "29.35579000",
                        "longitude": "-98.87864000"
                    },
                    {
                        "id": 113614,
                        "name": "Cedar Hill",
                        "latitude": "32.58847000",
                        "longitude": "-96.95612000"
                    },
                    {
                        "id": 113619,
                        "name": "Cedar Park",
                        "latitude": "30.50520000",
                        "longitude": "-97.82029000"
                    },
                    {
                        "id": 113631,
                        "name": "Celina",
                        "latitude": "33.32456000",
                        "longitude": "-96.78444000"
                    },
                    {
                        "id": 113636,
                        "name": "Center",
                        "latitude": "31.79545000",
                        "longitude": "-94.17909000"
                    },
                    {
                        "id": 113657,
                        "name": "Centerville",
                        "latitude": "31.25796000",
                        "longitude": "-95.97829000"
                    },
                    {
                        "id": 113675,
                        "name": "Central Gardens",
                        "latitude": "29.99549000",
                        "longitude": "-94.01406000"
                    },
                    {
                        "id": 114960,
                        "name": "César Chávez",
                        "latitude": "26.30340000",
                        "longitude": "-98.11529000"
                    },
                    {
                        "id": 113721,
                        "name": "Chambers County",
                        "latitude": "29.70826000",
                        "longitude": "-94.67138000"
                    },
                    {
                        "id": 113730,
                        "name": "Chandler",
                        "latitude": "32.30793000",
                        "longitude": "-95.47996000"
                    },
                    {
                        "id": 113736,
                        "name": "Channelview",
                        "latitude": "29.77606000",
                        "longitude": "-95.11465000"
                    },
                    {
                        "id": 113737,
                        "name": "Channing",
                        "latitude": "35.68365000",
                        "longitude": "-102.33020000"
                    },
                    {
                        "id": 113778,
                        "name": "Charlotte",
                        "latitude": "28.86192000",
                        "longitude": "-98.70641000"
                    },
                    {
                        "id": 113855,
                        "name": "Cherokee County",
                        "latitude": "31.83695000",
                        "longitude": "-95.16518000"
                    },
                    {
                        "id": 113942,
                        "name": "Chico",
                        "latitude": "33.29595000",
                        "longitude": "-97.79892000"
                    },
                    {
                        "id": 113950,
                        "name": "Childress",
                        "latitude": "34.42645000",
                        "longitude": "-100.20400000"
                    },
                    {
                        "id": 113951,
                        "name": "Childress County",
                        "latitude": "34.52920000",
                        "longitude": "-100.20757000"
                    },
                    {
                        "id": 113959,
                        "name": "China",
                        "latitude": "30.04799000",
                        "longitude": "-94.33574000"
                    },
                    {
                        "id": 113962,
                        "name": "China Grove",
                        "latitude": "29.38885000",
                        "longitude": "-98.34890000"
                    },
                    {
                        "id": 114018,
                        "name": "Cibolo",
                        "latitude": "29.56162000",
                        "longitude": "-98.22696000"
                    },
                    {
                        "id": 114022,
                        "name": "Cienegas Terrace",
                        "latitude": "29.36745000",
                        "longitude": "-100.94371000"
                    },
                    {
                        "id": 114026,
                        "name": "Cinco Ranch",
                        "latitude": "29.73884000",
                        "longitude": "-95.75800000"
                    },
                    {
                        "id": 114029,
                        "name": "Circle D-KC Estates",
                        "latitude": "30.16100000",
                        "longitude": "-97.23473000"
                    },
                    {
                        "id": 114031,
                        "name": "Cisco",
                        "latitude": "32.38819000",
                        "longitude": "-98.97923000"
                    },
                    {
                        "id": 114035,
                        "name": "Citrus City",
                        "latitude": "26.32646000",
                        "longitude": "-98.38530000"
                    },
                    {
                        "id": 114112,
                        "name": "Clarendon",
                        "latitude": "34.93783000",
                        "longitude": "-100.88820000"
                    },
                    {
                        "id": 114155,
                        "name": "Clarksville",
                        "latitude": "33.61066000",
                        "longitude": "-95.05272000"
                    },
                    {
                        "id": 114162,
                        "name": "Claude",
                        "latitude": "35.11172000",
                        "longitude": "-101.36322000"
                    },
                    {
                        "id": 114185,
                        "name": "Clay County",
                        "latitude": "33.78553000",
                        "longitude": "-98.20850000"
                    },
                    {
                        "id": 114214,
                        "name": "Clear Lake Shores",
                        "latitude": "29.54745000",
                        "longitude": "-95.03215000"
                    },
                    {
                        "id": 114229,
                        "name": "Cleburne",
                        "latitude": "32.34764000",
                        "longitude": "-97.38668000"
                    },
                    {
                        "id": 114246,
                        "name": "Cleveland",
                        "latitude": "30.34132000",
                        "longitude": "-95.08549000"
                    },
                    {
                        "id": 114256,
                        "name": "Clifton",
                        "latitude": "31.78238000",
                        "longitude": "-97.57669000"
                    },
                    {
                        "id": 114266,
                        "name": "Clint",
                        "latitude": "31.59234000",
                        "longitude": "-106.22414000"
                    },
                    {
                        "id": 114312,
                        "name": "Cloverleaf",
                        "latitude": "29.77828000",
                        "longitude": "-95.17188000"
                    },
                    {
                        "id": 114317,
                        "name": "Clute",
                        "latitude": "29.02469000",
                        "longitude": "-95.39883000"
                    },
                    {
                        "id": 114319,
                        "name": "Clyde",
                        "latitude": "32.40596000",
                        "longitude": "-99.49369000"
                    },
                    {
                        "id": 114352,
                        "name": "Cochran County",
                        "latitude": "33.60414000",
                        "longitude": "-102.82846000"
                    },
                    {
                        "id": 114356,
                        "name": "Cockrell Hill",
                        "latitude": "32.73624000",
                        "longitude": "-96.88695000"
                    },
                    {
                        "id": 114377,
                        "name": "Coke County",
                        "latitude": "31.88853000",
                        "longitude": "-100.52991000"
                    },
                    {
                        "id": 114390,
                        "name": "Coldspring",
                        "latitude": "30.59242000",
                        "longitude": "-95.12938000"
                    },
                    {
                        "id": 114398,
                        "name": "Coleman",
                        "latitude": "31.82737000",
                        "longitude": "-99.42645000"
                    },
                    {
                        "id": 114400,
                        "name": "Coleman County",
                        "latitude": "31.77321000",
                        "longitude": "-99.45364000"
                    },
                    {
                        "id": 114417,
                        "name": "College Station",
                        "latitude": "30.62798000",
                        "longitude": "-96.33441000"
                    },
                    {
                        "id": 114422,
                        "name": "Colleyville",
                        "latitude": "32.88096000",
                        "longitude": "-97.15501000"
                    },
                    {
                        "id": 114426,
                        "name": "Collin County",
                        "latitude": "33.18791000",
                        "longitude": "-96.57237000"
                    },
                    {
                        "id": 114430,
                        "name": "Collingsworth County",
                        "latitude": "34.96488000",
                        "longitude": "-100.27007000"
                    },
                    {
                        "id": 114437,
                        "name": "Collinsville",
                        "latitude": "33.56150000",
                        "longitude": "-96.91111000"
                    },
                    {
                        "id": 114456,
                        "name": "Colorado City",
                        "latitude": "32.38817000",
                        "longitude": "-100.86456000"
                    },
                    {
                        "id": 114457,
                        "name": "Colorado County",
                        "latitude": "29.62082000",
                        "longitude": "-96.52628000"
                    },
                    {
                        "id": 114495,
                        "name": "Columbus",
                        "latitude": "29.70662000",
                        "longitude": "-96.53969000"
                    },
                    {
                        "id": 114509,
                        "name": "Comal County",
                        "latitude": "29.80818000",
                        "longitude": "-98.27825000"
                    },
                    {
                        "id": 114511,
                        "name": "Comanche",
                        "latitude": "31.89737000",
                        "longitude": "-98.60366000"
                    },
                    {
                        "id": 114514,
                        "name": "Comanche County",
                        "latitude": "31.94798000",
                        "longitude": "-98.55826000"
                    },
                    {
                        "id": 114516,
                        "name": "Combes",
                        "latitude": "26.24869000",
                        "longitude": "-97.73388000"
                    },
                    {
                        "id": 114517,
                        "name": "Combine",
                        "latitude": "32.58847000",
                        "longitude": "-96.50860000"
                    },
                    {
                        "id": 114520,
                        "name": "Comfort",
                        "latitude": "29.96771000",
                        "longitude": "-98.90503000"
                    },
                    {
                        "id": 114524,
                        "name": "Commerce",
                        "latitude": "33.24706000",
                        "longitude": "-95.89997000"
                    },
                    {
                        "id": 114533,
                        "name": "Concho County",
                        "latitude": "31.32650000",
                        "longitude": "-99.86396000"
                    },
                    {
                        "id": 114570,
                        "name": "Conroe",
                        "latitude": "30.31188000",
                        "longitude": "-95.45605000"
                    },
                    {
                        "id": 114578,
                        "name": "Converse",
                        "latitude": "29.51801000",
                        "longitude": "-98.31612000"
                    },
                    {
                        "id": 114594,
                        "name": "Cooke County",
                        "latitude": "33.63919000",
                        "longitude": "-97.21262000"
                    },
                    {
                        "id": 114601,
                        "name": "Cooper",
                        "latitude": "31.24324000",
                        "longitude": "-95.58217000"
                    },
                    {
                        "id": 114619,
                        "name": "Coppell",
                        "latitude": "32.95457000",
                        "longitude": "-97.01501000"
                    },
                    {
                        "id": 114620,
                        "name": "Copper Canyon",
                        "latitude": "33.09595000",
                        "longitude": "-97.09668000"
                    },
                    {
                        "id": 114621,
                        "name": "Copperas Cove",
                        "latitude": "31.12406000",
                        "longitude": "-97.90308000"
                    },
                    {
                        "id": 114644,
                        "name": "Corinth",
                        "latitude": "33.15401000",
                        "longitude": "-97.06473000"
                    },
                    {
                        "id": 114665,
                        "name": "Corpus Christi",
                        "latitude": "27.80058000",
                        "longitude": "-97.39638000"
                    },
                    {
                        "id": 114668,
                        "name": "Corrigan",
                        "latitude": "30.99686000",
                        "longitude": "-94.82715000"
                    },
                    {
                        "id": 114670,
                        "name": "Corsicana",
                        "latitude": "32.09543000",
                        "longitude": "-96.46887000"
                    },
                    {
                        "id": 114683,
                        "name": "Coryell County",
                        "latitude": "31.39091000",
                        "longitude": "-97.79920000"
                    },
                    {
                        "id": 114695,
                        "name": "Cottle County",
                        "latitude": "34.07765000",
                        "longitude": "-100.27874000"
                    },
                    {
                        "id": 114706,
                        "name": "Cottonwood Shores",
                        "latitude": "30.55575000",
                        "longitude": "-98.32391000"
                    },
                    {
                        "id": 114708,
                        "name": "Cotulla",
                        "latitude": "28.43693000",
                        "longitude": "-99.23503000"
                    },
                    {
                        "id": 114765,
                        "name": "Crandall",
                        "latitude": "32.62791000",
                        "longitude": "-96.45582000"
                    },
                    {
                        "id": 114769,
                        "name": "Crane",
                        "latitude": "31.39736000",
                        "longitude": "-102.35014000"
                    },
                    {
                        "id": 114770,
                        "name": "Crane County",
                        "latitude": "31.42850000",
                        "longitude": "-102.51557000"
                    },
                    {
                        "id": 114829,
                        "name": "Crockett",
                        "latitude": "31.31824000",
                        "longitude": "-95.45661000"
                    },
                    {
                        "id": 114832,
                        "name": "Crockett County",
                        "latitude": "30.72298000",
                        "longitude": "-101.41215000"
                    },
                    {
                        "id": 114842,
                        "name": "Crosby",
                        "latitude": "29.91189000",
                        "longitude": "-95.06215000"
                    },
                    {
                        "id": 114845,
                        "name": "Crosby County",
                        "latitude": "33.61462000",
                        "longitude": "-101.29996000"
                    },
                    {
                        "id": 114846,
                        "name": "Crosbyton",
                        "latitude": "33.66008000",
                        "longitude": "-101.23793000"
                    },
                    {
                        "id": 114851,
                        "name": "Cross Mountain",
                        "latitude": "29.64550000",
                        "longitude": "-98.65947000"
                    },
                    {
                        "id": 114862,
                        "name": "Crowell",
                        "latitude": "33.98397000",
                        "longitude": "-99.72482000"
                    },
                    {
                        "id": 114864,
                        "name": "Crowley",
                        "latitude": "32.57903000",
                        "longitude": "-97.36252000"
                    },
                    {
                        "id": 114876,
                        "name": "Crystal City",
                        "latitude": "28.67748000",
                        "longitude": "-99.82811000"
                    },
                    {
                        "id": 114892,
                        "name": "Cuero",
                        "latitude": "29.09387000",
                        "longitude": "-97.28916000"
                    },
                    {
                        "id": 114893,
                        "name": "Culberson County",
                        "latitude": "31.44716000",
                        "longitude": "-104.51742000"
                    },
                    {
                        "id": 114943,
                        "name": "Cut and Shoot",
                        "latitude": "30.33327000",
                        "longitude": "-95.35799000"
                    },
                    {
                        "id": 114953,
                        "name": "Cypress",
                        "latitude": "29.96911000",
                        "longitude": "-95.69717000"
                    },
                    {
                        "id": 114972,
                        "name": "Daingerfield",
                        "latitude": "33.03179000",
                        "longitude": "-94.72187000"
                    },
                    {
                        "id": 114986,
                        "name": "Dalhart",
                        "latitude": "36.05948000",
                        "longitude": "-102.51325000"
                    },
                    {
                        "id": 114987,
                        "name": "Dallam County",
                        "latitude": "36.27789000",
                        "longitude": "-102.60222000"
                    },
                    {
                        "id": 114990,
                        "name": "Dallas",
                        "latitude": "32.78306000",
                        "longitude": "-96.80667000"
                    },
                    {
                        "id": 114997,
                        "name": "Dallas County",
                        "latitude": "32.76663000",
                        "longitude": "-96.77787000"
                    },
                    {
                        "id": 115005,
                        "name": "Dalworthington Gardens",
                        "latitude": "32.70291000",
                        "longitude": "-97.15529000"
                    },
                    {
                        "id": 115014,
                        "name": "Danbury",
                        "latitude": "29.22830000",
                        "longitude": "-95.34494000"
                    },
                    {
                        "id": 115085,
                        "name": "Dawson County",
                        "latitude": "32.74253000",
                        "longitude": "-101.94768000"
                    },
                    {
                        "id": 115093,
                        "name": "Dayton",
                        "latitude": "30.04661000",
                        "longitude": "-94.88520000"
                    },
                    {
                        "id": 115107,
                        "name": "De Kalb",
                        "latitude": "33.50873000",
                        "longitude": "-94.61632000"
                    },
                    {
                        "id": 115109,
                        "name": "De Leon",
                        "latitude": "32.11097000",
                        "longitude": "-98.53588000"
                    },
                    {
                        "id": 115143,
                        "name": "Deaf Smith County",
                        "latitude": "34.96602000",
                        "longitude": "-102.60494000"
                    },
                    {
                        "id": 115155,
                        "name": "Decatur",
                        "latitude": "33.23428000",
                        "longitude": "-97.58614000"
                    },
                    {
                        "id": 115125,
                        "name": "DeCordova",
                        "latitude": "32.42986000",
                        "longitude": "-97.69503000"
                    },
                    {
                        "id": 115175,
                        "name": "Deer Park",
                        "latitude": "29.70523000",
                        "longitude": "-95.12382000"
                    },
                    {
                        "id": 115195,
                        "name": "Del Rio",
                        "latitude": "29.36273000",
                        "longitude": "-100.89676000"
                    },
                    {
                        "id": 115224,
                        "name": "Delta County",
                        "latitude": "33.38629000",
                        "longitude": "-95.67227000"
                    },
                    {
                        "id": 115237,
                        "name": "Denison",
                        "latitude": "33.75566000",
                        "longitude": "-96.53666000"
                    },
                    {
                        "id": 115247,
                        "name": "Denton",
                        "latitude": "33.21484000",
                        "longitude": "-97.13307000"
                    },
                    {
                        "id": 115248,
                        "name": "Denton County",
                        "latitude": "33.20526000",
                        "longitude": "-97.11697000"
                    },
                    {
                        "id": 115254,
                        "name": "Denver City",
                        "latitude": "32.96455000",
                        "longitude": "-102.82910000"
                    },
                    {
                        "id": 115138,
                        "name": "DeSoto",
                        "latitude": "32.58986000",
                        "longitude": "-96.85695000"
                    },
                    {
                        "id": 115299,
                        "name": "Devine",
                        "latitude": "29.13996000",
                        "longitude": "-98.90531000"
                    },
                    {
                        "id": 115306,
                        "name": "Deweyville",
                        "latitude": "30.29771000",
                        "longitude": "-93.74350000"
                    },
                    {
                        "id": 115141,
                        "name": "DeWitt County",
                        "latitude": "29.08208000",
                        "longitude": "-97.35678000"
                    },
                    {
                        "id": 115319,
                        "name": "Diboll",
                        "latitude": "31.18713000",
                        "longitude": "-94.78104000"
                    },
                    {
                        "id": 115320,
                        "name": "Dickens",
                        "latitude": "33.62175000",
                        "longitude": "-100.83652000"
                    },
                    {
                        "id": 115321,
                        "name": "Dickens County",
                        "latitude": "33.61661000",
                        "longitude": "-100.77886000"
                    },
                    {
                        "id": 115325,
                        "name": "Dickinson",
                        "latitude": "29.46079000",
                        "longitude": "-95.05132000"
                    },
                    {
                        "id": 115339,
                        "name": "Dilley",
                        "latitude": "28.66748000",
                        "longitude": "-99.17059000"
                    },
                    {
                        "id": 115348,
                        "name": "Dimmit County",
                        "latitude": "28.42254000",
                        "longitude": "-99.75673000"
                    },
                    {
                        "id": 115349,
                        "name": "Dimmitt",
                        "latitude": "34.55090000",
                        "longitude": "-102.31186000"
                    },
                    {
                        "id": 115384,
                        "name": "Doffing",
                        "latitude": "26.27452000",
                        "longitude": "-98.38585000"
                    },
                    {
                        "id": 115399,
                        "name": "Donley County",
                        "latitude": "34.96542000",
                        "longitude": "-100.81399000"
                    },
                    {
                        "id": 115400,
                        "name": "Donna",
                        "latitude": "26.17035000",
                        "longitude": "-98.05195000"
                    },
                    {
                        "id": 115403,
                        "name": "Doolittle",
                        "latitude": "26.35337000",
                        "longitude": "-98.11666000"
                    },
                    {
                        "id": 115416,
                        "name": "Double Oak",
                        "latitude": "33.06512000",
                        "longitude": "-97.11057000"
                    },
                    {
                        "id": 115479,
                        "name": "Dripping Springs",
                        "latitude": "30.19021000",
                        "longitude": "-98.08668000"
                    },
                    {
                        "id": 115492,
                        "name": "Dublin",
                        "latitude": "32.08514000",
                        "longitude": "-98.34199000"
                    },
                    {
                        "id": 115515,
                        "name": "Dumas",
                        "latitude": "35.86559000",
                        "longitude": "-101.97324000"
                    },
                    {
                        "id": 115525,
                        "name": "Duncanville",
                        "latitude": "32.65180000",
                        "longitude": "-96.90834000"
                    },
                    {
                        "id": 115581,
                        "name": "Duval County",
                        "latitude": "27.68133000",
                        "longitude": "-98.50891000"
                    },
                    {
                        "id": 115603,
                        "name": "Eagle Lake",
                        "latitude": "29.58968000",
                        "longitude": "-96.33358000"
                    },
                    {
                        "id": 115606,
                        "name": "Eagle Mountain",
                        "latitude": "32.89346000",
                        "longitude": "-97.44446000"
                    },
                    {
                        "id": 115608,
                        "name": "Eagle Pass",
                        "latitude": "28.70914000",
                        "longitude": "-100.49952000"
                    },
                    {
                        "id": 115622,
                        "name": "Early",
                        "latitude": "31.74210000",
                        "longitude": "-98.94561000"
                    },
                    {
                        "id": 115624,
                        "name": "Earth",
                        "latitude": "34.23314000",
                        "longitude": "-102.41075000"
                    },
                    {
                        "id": 115632,
                        "name": "East Bernard",
                        "latitude": "29.53107000",
                        "longitude": "-96.07107000"
                    },
                    {
                        "id": 115780,
                        "name": "Eastland",
                        "latitude": "32.40152000",
                        "longitude": "-98.81756000"
                    },
                    {
                        "id": 115781,
                        "name": "Eastland County",
                        "latitude": "32.32707000",
                        "longitude": "-98.83232000"
                    },
                    {
                        "id": 115819,
                        "name": "Ector County",
                        "latitude": "31.86916000",
                        "longitude": "-102.54276000"
                    },
                    {
                        "id": 115820,
                        "name": "Edcouch",
                        "latitude": "26.29396000",
                        "longitude": "-97.96056000"
                    },
                    {
                        "id": 115829,
                        "name": "Eden",
                        "latitude": "31.21628000",
                        "longitude": "-99.84563000"
                    },
                    {
                        "id": 115839,
                        "name": "Edgecliff Village",
                        "latitude": "32.65763000",
                        "longitude": "-97.34279000"
                    },
                    {
                        "id": 115860,
                        "name": "Edgewood",
                        "latitude": "32.69818000",
                        "longitude": "-95.88524000"
                    },
                    {
                        "id": 115870,
                        "name": "Edinburg",
                        "latitude": "26.30174000",
                        "longitude": "-98.16334000"
                    },
                    {
                        "id": 115884,
                        "name": "Edna",
                        "latitude": "28.97859000",
                        "longitude": "-96.64609000"
                    },
                    {
                        "id": 115891,
                        "name": "Edwards County",
                        "latitude": "29.98263000",
                        "longitude": "-100.30474000"
                    },
                    {
                        "id": 115908,
                        "name": "Eidson Road",
                        "latitude": "28.67720000",
                        "longitude": "-100.48702000"
                    },
                    {
                        "id": 115912,
                        "name": "El Campo",
                        "latitude": "29.19664000",
                        "longitude": "-96.26969000"
                    },
                    {
                        "id": 115913,
                        "name": "El Cenizo",
                        "latitude": "27.35224000",
                        "longitude": "-99.49254000"
                    },
                    {
                        "id": 115926,
                        "name": "El Lago",
                        "latitude": "29.56356000",
                        "longitude": "-95.04521000"
                    },
                    {
                        "id": 115930,
                        "name": "El Paso",
                        "latitude": "31.75872000",
                        "longitude": "-106.48693000"
                    },
                    {
                        "id": 115932,
                        "name": "El Paso County",
                        "latitude": "31.76855000",
                        "longitude": "-106.23483000"
                    },
                    {
                        "id": 115954,
                        "name": "Eldorado",
                        "latitude": "30.86017000",
                        "longitude": "-100.60093000"
                    },
                    {
                        "id": 115959,
                        "name": "Electra",
                        "latitude": "34.02926000",
                        "longitude": "-98.91896000"
                    },
                    {
                        "id": 115965,
                        "name": "Elgin",
                        "latitude": "30.34965000",
                        "longitude": "-97.37027000"
                    },
                    {
                        "id": 115997,
                        "name": "Elkhart",
                        "latitude": "31.62517000",
                        "longitude": "-95.57940000"
                    },
                    {
                        "id": 116032,
                        "name": "Ellis County",
                        "latitude": "32.34843000",
                        "longitude": "-96.79448000"
                    },
                    {
                        "id": 116043,
                        "name": "Elm Creek",
                        "latitude": "28.77442000",
                        "longitude": "-100.49174000"
                    },
                    {
                        "id": 116048,
                        "name": "Elmendorf",
                        "latitude": "29.25607000",
                        "longitude": "-98.33279000"
                    },
                    {
                        "id": 116068,
                        "name": "Elsa",
                        "latitude": "26.29340000",
                        "longitude": "-97.99306000"
                    },
                    {
                        "id": 116108,
                        "name": "Emory",
                        "latitude": "32.87457000",
                        "longitude": "-95.76552000"
                    },
                    {
                        "id": 116115,
                        "name": "Encantada-Ranchito-El Calaboz",
                        "latitude": "26.03344000",
                        "longitude": "-97.63307000"
                    },
                    {
                        "id": 116141,
                        "name": "Ennis",
                        "latitude": "32.32931000",
                        "longitude": "-96.62527000"
                    },
                    {
                        "id": 116161,
                        "name": "Erath County",
                        "latitude": "32.23626000",
                        "longitude": "-98.21797000"
                    },
                    {
                        "id": 116183,
                        "name": "Escobares",
                        "latitude": "26.41062000",
                        "longitude": "-98.96253000"
                    },
                    {
                        "id": 116228,
                        "name": "Euless",
                        "latitude": "32.83707000",
                        "longitude": "-97.08195000"
                    },
                    {
                        "id": 116243,
                        "name": "Evadale",
                        "latitude": "30.35493000",
                        "longitude": "-94.07268000"
                    },
                    {
                        "id": 116266,
                        "name": "Everman",
                        "latitude": "32.63097000",
                        "longitude": "-97.28918000"
                    },
                    {
                        "id": 116279,
                        "name": "Fabens",
                        "latitude": "31.50234000",
                        "longitude": "-106.15859000"
                    },
                    {
                        "id": 116287,
                        "name": "Fair Oaks Ranch",
                        "latitude": "29.74578000",
                        "longitude": "-98.64336000"
                    },
                    {
                        "id": 116298,
                        "name": "Fairchilds",
                        "latitude": "29.43135000",
                        "longitude": "-95.78023000"
                    },
                    {
                        "id": 116311,
                        "name": "Fairfield",
                        "latitude": "31.72461000",
                        "longitude": "-96.16525000"
                    },
                    {
                        "id": 116351,
                        "name": "Fairview",
                        "latitude": "33.15790000",
                        "longitude": "-96.63166000"
                    },
                    {
                        "id": 116366,
                        "name": "Falcon Lake Estates",
                        "latitude": "26.87282000",
                        "longitude": "-99.25531000"
                    },
                    {
                        "id": 116368,
                        "name": "Falfurrias",
                        "latitude": "27.22699000",
                        "longitude": "-98.14417000"
                    },
                    {
                        "id": 116382,
                        "name": "Falls County",
                        "latitude": "31.25327000",
                        "longitude": "-96.93585000"
                    },
                    {
                        "id": 116391,
                        "name": "Fannett",
                        "latitude": "29.92605000",
                        "longitude": "-94.25074000"
                    },
                    {
                        "id": 116393,
                        "name": "Fannin County",
                        "latitude": "33.59381000",
                        "longitude": "-96.10683000"
                    },
                    {
                        "id": 116403,
                        "name": "Farmers Branch",
                        "latitude": "32.92651000",
                        "longitude": "-96.89612000"
                    },
                    {
                        "id": 116406,
                        "name": "Farmersville",
                        "latitude": "33.16345000",
                        "longitude": "-96.35998000"
                    },
                    {
                        "id": 116431,
                        "name": "Farwell",
                        "latitude": "34.38341000",
                        "longitude": "-103.03800000"
                    },
                    {
                        "id": 116432,
                        "name": "Fate",
                        "latitude": "32.94151000",
                        "longitude": "-96.38137000"
                    },
                    {
                        "id": 116449,
                        "name": "Fayette County",
                        "latitude": "29.87679000",
                        "longitude": "-96.91976000"
                    },
                    {
                        "id": 116494,
                        "name": "Ferris",
                        "latitude": "32.53403000",
                        "longitude": "-96.66555000"
                    },
                    {
                        "id": 116506,
                        "name": "Fifth Street",
                        "latitude": "29.59829000",
                        "longitude": "-95.55133000"
                    },
                    {
                        "id": 116528,
                        "name": "Fisher County",
                        "latitude": "32.74282000",
                        "longitude": "-100.40217000"
                    },
                    {
                        "id": 116556,
                        "name": "Flatonia",
                        "latitude": "29.68773000",
                        "longitude": "-97.10860000"
                    },
                    {
                        "id": 116581,
                        "name": "Florence",
                        "latitude": "30.84130000",
                        "longitude": "-97.79363000"
                    },
                    {
                        "id": 116590,
                        "name": "Floresville",
                        "latitude": "29.13358000",
                        "longitude": "-98.15612000"
                    },
                    {
                        "id": 116601,
                        "name": "Flower Mound",
                        "latitude": "33.01457000",
                        "longitude": "-97.09696000"
                    },
                    {
                        "id": 116611,
                        "name": "Floyd County",
                        "latitude": "34.07242000",
                        "longitude": "-101.30323000"
                    },
                    {
                        "id": 116612,
                        "name": "Floydada",
                        "latitude": "33.98452000",
                        "longitude": "-101.33766000"
                    },
                    {
                        "id": 116616,
                        "name": "Foard County",
                        "latitude": "33.97462000",
                        "longitude": "-99.77798000"
                    },
                    {
                        "id": 116655,
                        "name": "Forest Hill",
                        "latitude": "32.67208000",
                        "longitude": "-97.26918000"
                    },
                    {
                        "id": 116677,
                        "name": "Forney",
                        "latitude": "32.74818000",
                        "longitude": "-96.47193000"
                    },
                    {
                        "id": 116692,
                        "name": "Fort Bend County",
                        "latitude": "29.52749000",
                        "longitude": "-95.77089000"
                    },
                    {
                        "id": 116694,
                        "name": "Fort Bliss",
                        "latitude": "31.81357000",
                        "longitude": "-106.41224000"
                    },
                    {
                        "id": 116700,
                        "name": "Fort Clark Springs",
                        "latitude": "29.30607000",
                        "longitude": "-100.42202000"
                    },
                    {
                        "id": 116703,
                        "name": "Fort Davis",
                        "latitude": "30.58821000",
                        "longitude": "-103.89463000"
                    },
                    {
                        "id": 116716,
                        "name": "Fort Hancock",
                        "latitude": "31.29846000",
                        "longitude": "-105.84525000"
                    },
                    {
                        "id": 116717,
                        "name": "Fort Hood",
                        "latitude": "31.13489000",
                        "longitude": "-97.77561000"
                    },
                    {
                        "id": 116752,
                        "name": "Fort Stockton",
                        "latitude": "30.89404000",
                        "longitude": "-102.87932000"
                    },
                    {
                        "id": 116764,
                        "name": "Fort Worth",
                        "latitude": "32.72541000",
                        "longitude": "-97.32085000"
                    },
                    {
                        "id": 116788,
                        "name": "Four Corners",
                        "latitude": "29.66857000",
                        "longitude": "-95.65772000"
                    },
                    {
                        "id": 116830,
                        "name": "Franklin",
                        "latitude": "31.02602000",
                        "longitude": "-96.48524000"
                    },
                    {
                        "id": 116855,
                        "name": "Franklin County",
                        "latitude": "33.17555000",
                        "longitude": "-95.21842000"
                    },
                    {
                        "id": 116877,
                        "name": "Frankston",
                        "latitude": "32.05266000",
                        "longitude": "-95.50635000"
                    },
                    {
                        "id": 116890,
                        "name": "Fredericksburg",
                        "latitude": "30.27520000",
                        "longitude": "-98.87198000"
                    },
                    {
                        "id": 116911,
                        "name": "Freeport",
                        "latitude": "28.95414000",
                        "longitude": "-95.35966000"
                    },
                    {
                        "id": 116916,
                        "name": "Freer",
                        "latitude": "27.88280000",
                        "longitude": "-98.61779000"
                    },
                    {
                        "id": 116917,
                        "name": "Freestone County",
                        "latitude": "31.70489000",
                        "longitude": "-96.14909000"
                    },
                    {
                        "id": 116938,
                        "name": "Fresno",
                        "latitude": "29.53885000",
                        "longitude": "-95.44744000"
                    },
                    {
                        "id": 116952,
                        "name": "Friendswood",
                        "latitude": "29.52940000",
                        "longitude": "-95.20104000"
                    },
                    {
                        "id": 116953,
                        "name": "Frio County",
                        "latitude": "28.86782000",
                        "longitude": "-99.10827000"
                    },
                    {
                        "id": 116954,
                        "name": "Friona",
                        "latitude": "34.64173000",
                        "longitude": "-102.72410000"
                    },
                    {
                        "id": 116955,
                        "name": "Frisco",
                        "latitude": "33.15067000",
                        "longitude": "-96.82361000"
                    },
                    {
                        "id": 116958,
                        "name": "Fritch",
                        "latitude": "35.63977000",
                        "longitude": "-101.60323000"
                    },
                    {
                        "id": 116984,
                        "name": "Fulshear",
                        "latitude": "29.68996000",
                        "longitude": "-95.89968000"
                    },
                    {
                        "id": 116989,
                        "name": "Fulton",
                        "latitude": "28.06140000",
                        "longitude": "-97.04110000"
                    },
                    {
                        "id": 117011,
                        "name": "Gail",
                        "latitude": "32.77038000",
                        "longitude": "-101.44541000"
                    },
                    {
                        "id": 117012,
                        "name": "Gaines County",
                        "latitude": "32.74073000",
                        "longitude": "-102.63518000"
                    },
                    {
                        "id": 117017,
                        "name": "Gainesville",
                        "latitude": "33.62594000",
                        "longitude": "-97.13335000"
                    },
                    {
                        "id": 117025,
                        "name": "Galena Park",
                        "latitude": "29.73356000",
                        "longitude": "-95.23021000"
                    },
                    {
                        "id": 117042,
                        "name": "Galveston",
                        "latitude": "29.30135000",
                        "longitude": "-94.79770000"
                    },
                    {
                        "id": 117044,
                        "name": "Galveston County",
                        "latitude": "29.29767000",
                        "longitude": "-94.81087000"
                    },
                    {
                        "id": 117047,
                        "name": "Ganado",
                        "latitude": "29.04054000",
                        "longitude": "-96.51358000"
                    },
                    {
                        "id": 117060,
                        "name": "Garden City",
                        "latitude": "31.86402000",
                        "longitude": "-101.48123000"
                    },
                    {
                        "id": 117067,
                        "name": "Garden Ridge",
                        "latitude": "29.63467000",
                        "longitude": "-98.30529000"
                    },
                    {
                        "id": 117071,
                        "name": "Gardendale",
                        "latitude": "32.02040000",
                        "longitude": "-102.38015000"
                    },
                    {
                        "id": 117080,
                        "name": "Garfield",
                        "latitude": "30.18744000",
                        "longitude": "-97.55778000"
                    },
                    {
                        "id": 117088,
                        "name": "Garland",
                        "latitude": "32.91262000",
                        "longitude": "-96.63888000"
                    },
                    {
                        "id": 117108,
                        "name": "Garza County",
                        "latitude": "33.17988000",
                        "longitude": "-101.29842000"
                    },
                    {
                        "id": 117122,
                        "name": "Gatesville",
                        "latitude": "31.43516000",
                        "longitude": "-97.74391000"
                    },
                    {
                        "id": 117154,
                        "name": "George West",
                        "latitude": "28.33250000",
                        "longitude": "-98.11751000"
                    },
                    {
                        "id": 117160,
                        "name": "Georgetown",
                        "latitude": "30.63269000",
                        "longitude": "-97.67723000"
                    },
                    {
                        "id": 117177,
                        "name": "Geronimo",
                        "latitude": "29.66300000",
                        "longitude": "-97.96695000"
                    },
                    {
                        "id": 117181,
                        "name": "Gholson",
                        "latitude": "31.70100000",
                        "longitude": "-97.21640000"
                    },
                    {
                        "id": 117195,
                        "name": "Giddings",
                        "latitude": "30.18272000",
                        "longitude": "-96.93637000"
                    },
                    {
                        "id": 117215,
                        "name": "Gillespie County",
                        "latitude": "30.31806000",
                        "longitude": "-98.94648000"
                    },
                    {
                        "id": 117221,
                        "name": "Gilmer",
                        "latitude": "32.72875000",
                        "longitude": "-94.94244000"
                    },
                    {
                        "id": 117235,
                        "name": "Gladewater",
                        "latitude": "32.53653000",
                        "longitude": "-94.94272000"
                    },
                    {
                        "id": 117252,
                        "name": "Glasscock County",
                        "latitude": "31.86946000",
                        "longitude": "-101.52080000"
                    },
                    {
                        "id": 117274,
                        "name": "Glen Rose",
                        "latitude": "32.23459000",
                        "longitude": "-97.75531000"
                    },
                    {
                        "id": 117298,
                        "name": "Glenn Heights",
                        "latitude": "32.54875000",
                        "longitude": "-96.85667000"
                    },
                    {
                        "id": 117335,
                        "name": "Godley",
                        "latitude": "32.44903000",
                        "longitude": "-97.52669000"
                    },
                    {
                        "id": 117366,
                        "name": "Goldthwaite",
                        "latitude": "31.44989000",
                        "longitude": "-98.57088000"
                    },
                    {
                        "id": 117368,
                        "name": "Goliad",
                        "latitude": "28.66833000",
                        "longitude": "-97.38833000"
                    },
                    {
                        "id": 117369,
                        "name": "Goliad County",
                        "latitude": "28.65710000",
                        "longitude": "-97.42649000"
                    },
                    {
                        "id": 117371,
                        "name": "Gonzales",
                        "latitude": "29.50163000",
                        "longitude": "-97.45249000"
                    },
                    {
                        "id": 117373,
                        "name": "Gonzales County",
                        "latitude": "29.45673000",
                        "longitude": "-97.49252000"
                    },
                    {
                        "id": 117406,
                        "name": "Gorman",
                        "latitude": "32.21375000",
                        "longitude": "-98.67061000"
                    },
                    {
                        "id": 117435,
                        "name": "Graham",
                        "latitude": "33.10706000",
                        "longitude": "-98.58950000"
                    },
                    {
                        "id": 117445,
                        "name": "Granbury",
                        "latitude": "32.44208000",
                        "longitude": "-97.79420000"
                    },
                    {
                        "id": 117471,
                        "name": "Grand Prairie",
                        "latitude": "32.74596000",
                        "longitude": "-96.99778000"
                    },
                    {
                        "id": 117475,
                        "name": "Grand Saline",
                        "latitude": "32.67346000",
                        "longitude": "-95.70941000"
                    },
                    {
                        "id": 117480,
                        "name": "Grandview",
                        "latitude": "32.27042000",
                        "longitude": "-97.17918000"
                    },
                    {
                        "id": 117486,
                        "name": "Granger",
                        "latitude": "30.71769000",
                        "longitude": "-97.44278000"
                    },
                    {
                        "id": 117501,
                        "name": "Granite Shoals",
                        "latitude": "30.58908000",
                        "longitude": "-98.38392000"
                    },
                    {
                        "id": 117538,
                        "name": "Grape Creek",
                        "latitude": "31.57932000",
                        "longitude": "-100.54760000"
                    },
                    {
                        "id": 117539,
                        "name": "Grapeland",
                        "latitude": "31.49185000",
                        "longitude": "-95.47856000"
                    },
                    {
                        "id": 117540,
                        "name": "Grapevine",
                        "latitude": "32.93429000",
                        "longitude": "-97.07807000"
                    },
                    {
                        "id": 117554,
                        "name": "Gray County",
                        "latitude": "35.40116000",
                        "longitude": "-100.81256000"
                    },
                    {
                        "id": 117563,
                        "name": "Grayson County",
                        "latitude": "33.62681000",
                        "longitude": "-96.67772000"
                    },
                    {
                        "id": 117583,
                        "name": "Greatwood",
                        "latitude": "29.55413000",
                        "longitude": "-95.67578000"
                    },
                    {
                        "id": 117612,
                        "name": "Green Valley Farms",
                        "latitude": "26.12202000",
                        "longitude": "-97.56054000"
                    },
                    {
                        "id": 117689,
                        "name": "Greenville",
                        "latitude": "33.13845000",
                        "longitude": "-96.11081000"
                    },
                    {
                        "id": 117715,
                        "name": "Gregg County",
                        "latitude": "32.48047000",
                        "longitude": "-94.81695000"
                    },
                    {
                        "id": 117716,
                        "name": "Gregory",
                        "latitude": "27.92224000",
                        "longitude": "-97.28999000"
                    },
                    {
                        "id": 117738,
                        "name": "Grimes County",
                        "latitude": "30.54347000",
                        "longitude": "-95.98550000"
                    },
                    {
                        "id": 117742,
                        "name": "Groesbeck",
                        "latitude": "31.52434000",
                        "longitude": "-96.53387000"
                    },
                    {
                        "id": 117761,
                        "name": "Groves",
                        "latitude": "29.94827000",
                        "longitude": "-93.91712000"
                    },
                    {
                        "id": 117762,
                        "name": "Groveton",
                        "latitude": "31.05491000",
                        "longitude": "-95.12577000"
                    },
                    {
                        "id": 117774,
                        "name": "Gruver",
                        "latitude": "36.26503000",
                        "longitude": "-101.40627000"
                    },
                    {
                        "id": 117778,
                        "name": "Guadalupe County",
                        "latitude": "29.58305000",
                        "longitude": "-97.94858000"
                    },
                    {
                        "id": 117800,
                        "name": "Gun Barrel City",
                        "latitude": "32.33459000",
                        "longitude": "-96.15136000"
                    },
                    {
                        "id": 117805,
                        "name": "Gunter",
                        "latitude": "33.44789000",
                        "longitude": "-96.74749000"
                    },
                    {
                        "id": 117813,
                        "name": "Guthrie",
                        "latitude": "33.62064000",
                        "longitude": "-100.32289000"
                    },
                    {
                        "id": 117827,
                        "name": "Hackberry",
                        "latitude": "33.15234000",
                        "longitude": "-96.91778000"
                    },
                    {
                        "id": 117847,
                        "name": "Hale Center",
                        "latitude": "34.06424000",
                        "longitude": "-101.84379000"
                    },
                    {
                        "id": 117849,
                        "name": "Hale County",
                        "latitude": "34.07051000",
                        "longitude": "-101.82688000"
                    },
                    {
                        "id": 117866,
                        "name": "Hall County",
                        "latitude": "34.53078000",
                        "longitude": "-100.68113000"
                    },
                    {
                        "id": 117870,
                        "name": "Hallettsville",
                        "latitude": "29.44385000",
                        "longitude": "-96.94109000"
                    },
                    {
                        "id": 117876,
                        "name": "Hallsville",
                        "latitude": "32.50432000",
                        "longitude": "-94.57409000"
                    },
                    {
                        "id": 117878,
                        "name": "Haltom City",
                        "latitude": "32.79957000",
                        "longitude": "-97.26918000"
                    },
                    {
                        "id": 117890,
                        "name": "Hamilton",
                        "latitude": "31.70377000",
                        "longitude": "-98.12392000"
                    },
                    {
                        "id": 117899,
                        "name": "Hamilton County",
                        "latitude": "31.70480000",
                        "longitude": "-98.11073000"
                    },
                    {
                        "id": 117910,
                        "name": "Hamlin",
                        "latitude": "32.88483000",
                        "longitude": "-100.12649000"
                    },
                    {
                        "id": 117977,
                        "name": "Hansford County",
                        "latitude": "36.27745000",
                        "longitude": "-101.35454000"
                    },
                    {
                        "id": 117996,
                        "name": "Hardeman County",
                        "latitude": "34.29029000",
                        "longitude": "-99.74572000"
                    },
                    {
                        "id": 118002,
                        "name": "Hardin County",
                        "latitude": "30.33237000",
                        "longitude": "-94.39022000"
                    },
                    {
                        "id": 118013,
                        "name": "Harker Heights",
                        "latitude": "31.08351000",
                        "longitude": "-97.65974000"
                    },
                    {
                        "id": 118026,
                        "name": "Harlingen",
                        "latitude": "26.19063000",
                        "longitude": "-97.69610000"
                    },
                    {
                        "id": 118032,
                        "name": "Harper",
                        "latitude": "30.29992000",
                        "longitude": "-99.24421000"
                    },
                    {
                        "id": 118045,
                        "name": "Harris County",
                        "latitude": "29.85728000",
                        "longitude": "-95.39234000"
                    },
                    {
                        "id": 118065,
                        "name": "Harrison County",
                        "latitude": "32.54813000",
                        "longitude": "-94.37149000"
                    },
                    {
                        "id": 118081,
                        "name": "Hart",
                        "latitude": "34.38507000",
                        "longitude": "-102.11574000"
                    },
                    {
                        "id": 118100,
                        "name": "Hartley County",
                        "latitude": "35.84002000",
                        "longitude": "-102.60289000"
                    },
                    {
                        "id": 118124,
                        "name": "Haskell",
                        "latitude": "33.15760000",
                        "longitude": "-99.73370000"
                    },
                    {
                        "id": 118126,
                        "name": "Haskell County",
                        "latitude": "33.17823000",
                        "longitude": "-99.73030000"
                    },
                    {
                        "id": 118128,
                        "name": "Haslet",
                        "latitude": "32.97485000",
                        "longitude": "-97.34780000"
                    },
                    {
                        "id": 118165,
                        "name": "Hawkins",
                        "latitude": "32.58847000",
                        "longitude": "-95.20411000"
                    },
                    {
                        "id": 118192,
                        "name": "Hays County",
                        "latitude": "30.05815000",
                        "longitude": "-98.03106000"
                    },
                    {
                        "id": 118221,
                        "name": "Hearne",
                        "latitude": "30.87852000",
                        "longitude": "-96.59303000"
                    },
                    {
                        "id": 118222,
                        "name": "Heath",
                        "latitude": "32.83651000",
                        "longitude": "-96.47499000"
                    },
                    {
                        "id": 118227,
                        "name": "Hebbronville",
                        "latitude": "27.30688000",
                        "longitude": "-98.68032000"
                    },
                    {
                        "id": 118242,
                        "name": "Hedwig Village",
                        "latitude": "29.77745000",
                        "longitude": "-95.51716000"
                    },
                    {
                        "id": 118244,
                        "name": "Heidelberg",
                        "latitude": "26.19702000",
                        "longitude": "-97.88028000"
                    },
                    {
                        "id": 118261,
                        "name": "Helotes",
                        "latitude": "29.57801000",
                        "longitude": "-98.68975000"
                    },
                    {
                        "id": 118267,
                        "name": "Hemphill",
                        "latitude": "31.34074000",
                        "longitude": "-93.84685000"
                    },
                    {
                        "id": 118268,
                        "name": "Hemphill County",
                        "latitude": "35.83757000",
                        "longitude": "-100.27047000"
                    },
                    {
                        "id": 118269,
                        "name": "Hempstead",
                        "latitude": "30.09744000",
                        "longitude": "-96.07829000"
                    },
                    {
                        "id": 118273,
                        "name": "Henderson",
                        "latitude": "32.15322000",
                        "longitude": "-94.79938000"
                    },
                    {
                        "id": 118283,
                        "name": "Henderson County",
                        "latitude": "32.21189000",
                        "longitude": "-95.85356000"
                    },
                    {
                        "id": 118295,
                        "name": "Henrietta",
                        "latitude": "33.81732000",
                        "longitude": "-98.19532000"
                    },
                    {
                        "id": 118315,
                        "name": "Hereford",
                        "latitude": "34.81521000",
                        "longitude": "-102.39932000"
                    },
                    {
                        "id": 118348,
                        "name": "Hewitt",
                        "latitude": "31.46239000",
                        "longitude": "-97.19584000"
                    },
                    {
                        "id": 118367,
                        "name": "Hickory Creek",
                        "latitude": "33.12234000",
                        "longitude": "-97.04306000"
                    },
                    {
                        "id": 118372,
                        "name": "Hico",
                        "latitude": "31.98293000",
                        "longitude": "-98.03365000"
                    },
                    {
                        "id": 118373,
                        "name": "Hidalgo",
                        "latitude": "26.10035000",
                        "longitude": "-98.26307000"
                    },
                    {
                        "id": 118374,
                        "name": "Hidalgo County",
                        "latitude": "26.39672000",
                        "longitude": "-98.18107000"
                    },
                    {
                        "id": 118382,
                        "name": "Hideaway",
                        "latitude": "32.49042000",
                        "longitude": "-95.45746000"
                    },
                    {
                        "id": 118410,
                        "name": "Highland Park",
                        "latitude": "32.83346000",
                        "longitude": "-96.79195000"
                    },
                    {
                        "id": 118416,
                        "name": "Highland Village",
                        "latitude": "33.09179000",
                        "longitude": "-97.04668000"
                    },
                    {
                        "id": 118417,
                        "name": "Highlands",
                        "latitude": "29.81884000",
                        "longitude": "-95.05604000"
                    },
                    {
                        "id": 118435,
                        "name": "Hill Country Village",
                        "latitude": "29.58245000",
                        "longitude": "-98.49085000"
                    },
                    {
                        "id": 118436,
                        "name": "Hill County",
                        "latitude": "31.99068000",
                        "longitude": "-97.13243000"
                    },
                    {
                        "id": 118449,
                        "name": "Hillsboro",
                        "latitude": "32.01099000",
                        "longitude": "-97.13001000"
                    },
                    {
                        "id": 118469,
                        "name": "Hilltop Lakes",
                        "latitude": "31.07935000",
                        "longitude": "-96.20385000"
                    },
                    {
                        "id": 118492,
                        "name": "Hitchcock",
                        "latitude": "29.34829000",
                        "longitude": "-95.01604000"
                    },
                    {
                        "id": 118505,
                        "name": "Hockley County",
                        "latitude": "33.60764000",
                        "longitude": "-102.34320000"
                    },
                    {
                        "id": 118534,
                        "name": "Holiday Lakes",
                        "latitude": "29.20969000",
                        "longitude": "-95.51689000"
                    },
                    {
                        "id": 118537,
                        "name": "Holland",
                        "latitude": "30.87824000",
                        "longitude": "-97.40167000"
                    },
                    {
                        "id": 118544,
                        "name": "Holliday",
                        "latitude": "33.81621000",
                        "longitude": "-98.69506000"
                    },
                    {
                        "id": 118559,
                        "name": "Holly Lake Ranch",
                        "latitude": "32.71336000",
                        "longitude": "-95.19756000"
                    },
                    {
                        "id": 118568,
                        "name": "Hollywood Park",
                        "latitude": "29.60050000",
                        "longitude": "-98.48724000"
                    },
                    {
                        "id": 118603,
                        "name": "Homestead Meadows North",
                        "latitude": "31.84963000",
                        "longitude": "-106.17285000"
                    },
                    {
                        "id": 118604,
                        "name": "Homestead Meadows South",
                        "latitude": "31.81097000",
                        "longitude": "-106.16427000"
                    },
                    {
                        "id": 118615,
                        "name": "Hondo",
                        "latitude": "29.34746000",
                        "longitude": "-99.14142000"
                    },
                    {
                        "id": 118620,
                        "name": "Honey Grove",
                        "latitude": "33.58344000",
                        "longitude": "-95.90997000"
                    },
                    {
                        "id": 118625,
                        "name": "Hood County",
                        "latitude": "32.42993000",
                        "longitude": "-97.83227000"
                    },
                    {
                        "id": 118630,
                        "name": "Hooks",
                        "latitude": "33.46623000",
                        "longitude": "-94.28853000"
                    },
                    {
                        "id": 118654,
                        "name": "Hopkins County",
                        "latitude": "33.14956000",
                        "longitude": "-95.56395000"
                    },
                    {
                        "id": 118664,
                        "name": "Horizon City",
                        "latitude": "31.69261000",
                        "longitude": "-106.20748000"
                    },
                    {
                        "id": 118668,
                        "name": "Hornsby Bend",
                        "latitude": "30.24743000",
                        "longitude": "-97.58333000"
                    },
                    {
                        "id": 118675,
                        "name": "Horseshoe Bay",
                        "latitude": "30.54429000",
                        "longitude": "-98.37394000"
                    },
                    {
                        "id": 118699,
                        "name": "Houston",
                        "latitude": "29.76328000",
                        "longitude": "-95.36327000"
                    },
                    {
                        "id": 118705,
                        "name": "Houston County",
                        "latitude": "31.31773000",
                        "longitude": "-95.42268000"
                    },
                    {
                        "id": 118718,
                        "name": "Howard County",
                        "latitude": "32.30617000",
                        "longitude": "-101.43551000"
                    },
                    {
                        "id": 118721,
                        "name": "Howe",
                        "latitude": "33.50872000",
                        "longitude": "-96.61221000"
                    },
                    {
                        "id": 118730,
                        "name": "Hubbard",
                        "latitude": "31.84849000",
                        "longitude": "-96.79721000"
                    },
                    {
                        "id": 118737,
                        "name": "Hudson",
                        "latitude": "31.32268000",
                        "longitude": "-94.77826000"
                    },
                    {
                        "id": 118748,
                        "name": "Hudson Bend",
                        "latitude": "30.41714000",
                        "longitude": "-97.92918000"
                    },
                    {
                        "id": 118752,
                        "name": "Hudson Oaks",
                        "latitude": "32.75707000",
                        "longitude": "-97.70670000"
                    },
                    {
                        "id": 118754,
                        "name": "Hudspeth County",
                        "latitude": "31.45618000",
                        "longitude": "-105.38646000"
                    },
                    {
                        "id": 118760,
                        "name": "Hughes Springs",
                        "latitude": "32.99846000",
                        "longitude": "-94.63076000"
                    },
                    {
                        "id": 118774,
                        "name": "Humble",
                        "latitude": "29.99883000",
                        "longitude": "-95.26216000"
                    },
                    {
                        "id": 118786,
                        "name": "Hunt County",
                        "latitude": "33.12360000",
                        "longitude": "-96.08545000"
                    },
                    {
                        "id": 118791,
                        "name": "Hunters Creek Village",
                        "latitude": "29.77051000",
                        "longitude": "-95.49550000"
                    },
                    {
                        "id": 118798,
                        "name": "Huntington",
                        "latitude": "31.27769000",
                        "longitude": "-94.57659000"
                    },
                    {
                        "id": 118818,
                        "name": "Huntsville",
                        "latitude": "30.72353000",
                        "longitude": "-95.55078000"
                    },
                    {
                        "id": 118829,
                        "name": "Hurst",
                        "latitude": "32.82346000",
                        "longitude": "-97.17057000"
                    },
                    {
                        "id": 118834,
                        "name": "Hutchins",
                        "latitude": "32.64930000",
                        "longitude": "-96.71305000"
                    },
                    {
                        "id": 118838,
                        "name": "Hutchinson County",
                        "latitude": "35.84003000",
                        "longitude": "-101.35470000"
                    },
                    {
                        "id": 118840,
                        "name": "Hutto",
                        "latitude": "30.54270000",
                        "longitude": "-97.54667000"
                    },
                    {
                        "id": 118873,
                        "name": "Idalou",
                        "latitude": "33.66647000",
                        "longitude": "-101.68294000"
                    },
                    {
                        "id": 118907,
                        "name": "Indian Hills",
                        "latitude": "26.21285000",
                        "longitude": "-97.91639000"
                    },
                    {
                        "id": 118932,
                        "name": "Inez",
                        "latitude": "28.90388000",
                        "longitude": "-96.78804000"
                    },
                    {
                        "id": 118936,
                        "name": "Ingleside",
                        "latitude": "27.87780000",
                        "longitude": "-97.21166000"
                    },
                    {
                        "id": 118940,
                        "name": "Ingram",
                        "latitude": "30.07743000",
                        "longitude": "-99.24032000"
                    },
                    {
                        "id": 118977,
                        "name": "Iowa Colony",
                        "latitude": "29.48246000",
                        "longitude": "-95.41550000"
                    },
                    {
                        "id": 118981,
                        "name": "Iowa Park",
                        "latitude": "33.95148000",
                        "longitude": "-98.66867000"
                    },
                    {
                        "id": 118984,
                        "name": "Iraan",
                        "latitude": "30.91405000",
                        "longitude": "-101.89791000"
                    },
                    {
                        "id": 118986,
                        "name": "Irion County",
                        "latitude": "31.30392000",
                        "longitude": "-100.98242000"
                    },
                    {
                        "id": 119005,
                        "name": "Irving",
                        "latitude": "32.81402000",
                        "longitude": "-96.94889000"
                    },
                    {
                        "id": 119038,
                        "name": "Italy",
                        "latitude": "32.18404000",
                        "longitude": "-96.88472000"
                    },
                    {
                        "id": 119039,
                        "name": "Itasca",
                        "latitude": "32.15959000",
                        "longitude": "-97.15001000"
                    },
                    {
                        "id": 119055,
                        "name": "Jacinto City",
                        "latitude": "29.76745000",
                        "longitude": "-95.23382000"
                    },
                    {
                        "id": 119056,
                        "name": "Jack County",
                        "latitude": "33.23346000",
                        "longitude": "-98.17246000"
                    },
                    {
                        "id": 119059,
                        "name": "Jacksboro",
                        "latitude": "33.21845000",
                        "longitude": "-98.15866000"
                    },
                    {
                        "id": 119088,
                        "name": "Jackson County",
                        "latitude": "28.95424000",
                        "longitude": "-96.57768000"
                    },
                    {
                        "id": 119104,
                        "name": "Jacksonville",
                        "latitude": "31.96378000",
                        "longitude": "-95.27050000"
                    },
                    {
                        "id": 119113,
                        "name": "Jamaica Beach",
                        "latitude": "29.18968000",
                        "longitude": "-94.97965000"
                    },
                    {
                        "id": 119134,
                        "name": "Jarrell",
                        "latitude": "30.82491000",
                        "longitude": "-97.60445000"
                    },
                    {
                        "id": 119144,
                        "name": "Jasper",
                        "latitude": "30.92020000",
                        "longitude": "-93.99658000"
                    },
                    {
                        "id": 119150,
                        "name": "Jasper County",
                        "latitude": "30.74396000",
                        "longitude": "-94.02509000"
                    },
                    {
                        "id": 119156,
                        "name": "Jayton",
                        "latitude": "33.24815000",
                        "longitude": "-100.57373000"
                    },
                    {
                        "id": 119161,
                        "name": "Jeff Davis County",
                        "latitude": "30.71548000",
                        "longitude": "-104.14002000"
                    },
                    {
                        "id": 119166,
                        "name": "Jefferson",
                        "latitude": "32.75736000",
                        "longitude": "-94.34519000"
                    },
                    {
                        "id": 119187,
                        "name": "Jefferson County",
                        "latitude": "29.85373000",
                        "longitude": "-94.15344000"
                    },
                    {
                        "id": 119234,
                        "name": "Jersey Village",
                        "latitude": "29.88772000",
                        "longitude": "-95.56300000"
                    },
                    {
                        "id": 119244,
                        "name": "Jewett",
                        "latitude": "31.36157000",
                        "longitude": "-96.14413000"
                    },
                    {
                        "id": 119246,
                        "name": "Jim Hogg County",
                        "latitude": "27.04340000",
                        "longitude": "-98.69731000"
                    },
                    {
                        "id": 119248,
                        "name": "Jim Wells County",
                        "latitude": "27.73130000",
                        "longitude": "-98.08994000"
                    },
                    {
                        "id": 119258,
                        "name": "Johnson City",
                        "latitude": "30.27687000",
                        "longitude": "-98.41197000"
                    },
                    {
                        "id": 119268,
                        "name": "Johnson County",
                        "latitude": "32.37901000",
                        "longitude": "-97.36633000"
                    },
                    {
                        "id": 119290,
                        "name": "Jollyville",
                        "latitude": "30.44270000",
                        "longitude": "-97.77501000"
                    },
                    {
                        "id": 119295,
                        "name": "Jones County",
                        "latitude": "32.73990000",
                        "longitude": "-99.87874000"
                    },
                    {
                        "id": 119298,
                        "name": "Jones Creek",
                        "latitude": "28.96858000",
                        "longitude": "-95.45522000"
                    },
                    {
                        "id": 119307,
                        "name": "Jonestown",
                        "latitude": "30.49547000",
                        "longitude": "-97.92335000"
                    },
                    {
                        "id": 119320,
                        "name": "Josephine",
                        "latitude": "33.06123000",
                        "longitude": "-96.30720000"
                    },
                    {
                        "id": 119322,
                        "name": "Joshua",
                        "latitude": "32.46153000",
                        "longitude": "-97.38807000"
                    },
                    {
                        "id": 119324,
                        "name": "Jourdanton",
                        "latitude": "28.91803000",
                        "longitude": "-98.54641000"
                    },
                    {
                        "id": 119331,
                        "name": "Junction",
                        "latitude": "30.48936000",
                        "longitude": "-99.77201000"
                    },
                    {
                        "id": 119346,
                        "name": "Justin",
                        "latitude": "33.08484000",
                        "longitude": "-97.29613000"
                    },
                    {
                        "id": 119389,
                        "name": "Karnes City",
                        "latitude": "28.88498000",
                        "longitude": "-97.90084000"
                    },
                    {
                        "id": 119390,
                        "name": "Karnes County",
                        "latitude": "28.90574000",
                        "longitude": "-97.85940000"
                    },
                    {
                        "id": 119395,
                        "name": "Katy",
                        "latitude": "29.78579000",
                        "longitude": "-95.82440000"
                    },
                    {
                        "id": 119397,
                        "name": "Kaufman",
                        "latitude": "32.58902000",
                        "longitude": "-96.30887000"
                    },
                    {
                        "id": 119398,
                        "name": "Kaufman County",
                        "latitude": "32.59930000",
                        "longitude": "-96.28780000"
                    },
                    {
                        "id": 119420,
                        "name": "Keene",
                        "latitude": "32.39681000",
                        "longitude": "-97.32390000"
                    },
                    {
                        "id": 119428,
                        "name": "Keller",
                        "latitude": "32.93457000",
                        "longitude": "-97.25168000"
                    },
                    {
                        "id": 119433,
                        "name": "Kemah",
                        "latitude": "29.54273000",
                        "longitude": "-95.02048000"
                    },
                    {
                        "id": 119435,
                        "name": "Kemp",
                        "latitude": "32.44264000",
                        "longitude": "-96.22998000"
                    },
                    {
                        "id": 119438,
                        "name": "Kempner",
                        "latitude": "31.08101000",
                        "longitude": "-98.00252000"
                    },
                    {
                        "id": 119446,
                        "name": "Kendall County",
                        "latitude": "29.94469000",
                        "longitude": "-98.71156000"
                    },
                    {
                        "id": 119453,
                        "name": "Kenedy",
                        "latitude": "28.81915000",
                        "longitude": "-97.84861000"
                    },
                    {
                        "id": 119454,
                        "name": "Kenedy County",
                        "latitude": "26.92802000",
                        "longitude": "-97.63646000"
                    },
                    {
                        "id": 119468,
                        "name": "Kennedale",
                        "latitude": "32.64680000",
                        "longitude": "-97.22585000"
                    },
                    {
                        "id": 119494,
                        "name": "Kent County",
                        "latitude": "33.18142000",
                        "longitude": "-100.77757000"
                    },
                    {
                        "id": 119510,
                        "name": "Kerens",
                        "latitude": "32.13321000",
                        "longitude": "-96.22775000"
                    },
                    {
                        "id": 119513,
                        "name": "Kermit",
                        "latitude": "31.85763000",
                        "longitude": "-103.09267000"
                    },
                    {
                        "id": 119517,
                        "name": "Kerr County",
                        "latitude": "30.06148000",
                        "longitude": "-99.35016000"
                    },
                    {
                        "id": 119518,
                        "name": "Kerrville",
                        "latitude": "30.04743000",
                        "longitude": "-99.14032000"
                    },
                    {
                        "id": 119556,
                        "name": "Kilgore",
                        "latitude": "32.38626000",
                        "longitude": "-94.87577000"
                    },
                    {
                        "id": 119559,
                        "name": "Killeen",
                        "latitude": "31.11712000",
                        "longitude": "-97.72780000"
                    },
                    {
                        "id": 119572,
                        "name": "Kimble County",
                        "latitude": "30.48678000",
                        "longitude": "-99.74870000"
                    },
                    {
                        "id": 119581,
                        "name": "King County",
                        "latitude": "33.61648000",
                        "longitude": "-100.25585000"
                    },
                    {
                        "id": 119616,
                        "name": "Kingsland",
                        "latitude": "30.65824000",
                        "longitude": "-98.44058000"
                    },
                    {
                        "id": 119636,
                        "name": "Kingsville",
                        "latitude": "27.51587000",
                        "longitude": "-97.85611000"
                    },
                    {
                        "id": 119638,
                        "name": "Kingwood Area",
                        "latitude": "30.03355000",
                        "longitude": "-95.26104000"
                    },
                    {
                        "id": 119640,
                        "name": "Kinney County",
                        "latitude": "29.35021000",
                        "longitude": "-100.41795000"
                    },
                    {
                        "id": 119649,
                        "name": "Kirby",
                        "latitude": "29.46329000",
                        "longitude": "-98.38557000"
                    },
                    {
                        "id": 119650,
                        "name": "Kirbyville",
                        "latitude": "30.66048000",
                        "longitude": "-93.89268000"
                    },
                    {
                        "id": 119672,
                        "name": "Kleberg County",
                        "latitude": "27.42671000",
                        "longitude": "-97.66839000"
                    },
                    {
                        "id": 119684,
                        "name": "Knox City",
                        "latitude": "33.41815000",
                        "longitude": "-99.81898000"
                    },
                    {
                        "id": 119688,
                        "name": "Knox County",
                        "latitude": "33.60613000",
                        "longitude": "-99.74143000"
                    },
                    {
                        "id": 119713,
                        "name": "Kountze",
                        "latitude": "30.37160000",
                        "longitude": "-94.31241000"
                    },
                    {
                        "id": 119719,
                        "name": "Krugerville",
                        "latitude": "33.28151000",
                        "longitude": "-96.99056000"
                    },
                    {
                        "id": 119720,
                        "name": "Krum",
                        "latitude": "33.26151000",
                        "longitude": "-97.23807000"
                    },
                    {
                        "id": 119729,
                        "name": "Kyle",
                        "latitude": "29.98911000",
                        "longitude": "-97.87723000"
                    },
                    {
                        "id": 119735,
                        "name": "La Blanca",
                        "latitude": "26.29285000",
                        "longitude": "-98.03778000"
                    },
                    {
                        "id": 119740,
                        "name": "La Coste",
                        "latitude": "29.31079000",
                        "longitude": "-98.81003000"
                    },
                    {
                        "id": 119747,
                        "name": "La Feria",
                        "latitude": "26.15896000",
                        "longitude": "-97.82389000"
                    },
                    {
                        "id": 119751,
                        "name": "La Grange",
                        "latitude": "29.90550000",
                        "longitude": "-96.87665000"
                    },
                    {
                        "id": 119754,
                        "name": "La Grulla",
                        "latitude": "26.26951000",
                        "longitude": "-98.64725000"
                    },
                    {
                        "id": 119758,
                        "name": "La Homa",
                        "latitude": "26.25007000",
                        "longitude": "-98.36363000"
                    },
                    {
                        "id": 119761,
                        "name": "La Joya",
                        "latitude": "26.24702000",
                        "longitude": "-98.48141000"
                    },
                    {
                        "id": 119764,
                        "name": "La Marque",
                        "latitude": "29.36857000",
                        "longitude": "-94.97131000"
                    },
                    {
                        "id": 119770,
                        "name": "La Paloma",
                        "latitude": "26.04591000",
                        "longitude": "-97.66749000"
                    },
                    {
                        "id": 119776,
                        "name": "La Porte",
                        "latitude": "29.66578000",
                        "longitude": "-95.01937000"
                    },
                    {
                        "id": 119780,
                        "name": "La Pryor",
                        "latitude": "28.94108000",
                        "longitude": "-99.84978000"
                    },
                    {
                        "id": 119787,
                        "name": "La Salle County",
                        "latitude": "28.34507000",
                        "longitude": "-99.09966000"
                    },
                    {
                        "id": 119794,
                        "name": "La Vernia",
                        "latitude": "29.35635000",
                        "longitude": "-98.11556000"
                    },
                    {
                        "id": 119795,
                        "name": "La Villa",
                        "latitude": "26.29868000",
                        "longitude": "-97.92861000"
                    },
                    {
                        "id": 119815,
                        "name": "Lackland Air Force Base",
                        "latitude": "29.38663000",
                        "longitude": "-98.61797000"
                    },
                    {
                        "id": 119821,
                        "name": "Lacy-Lakeview",
                        "latitude": "31.62933000",
                        "longitude": "-97.10278000"
                    },
                    {
                        "id": 119847,
                        "name": "Lago Vista",
                        "latitude": "30.46020000",
                        "longitude": "-97.98835000"
                    },
                    {
                        "id": 119853,
                        "name": "Laguna Heights",
                        "latitude": "26.08008000",
                        "longitude": "-97.25386000"
                    },
                    {
                        "id": 119856,
                        "name": "Laguna Park",
                        "latitude": "31.85932000",
                        "longitude": "-97.37974000"
                    },
                    {
                        "id": 119857,
                        "name": "Laguna Vista",
                        "latitude": "26.10091000",
                        "longitude": "-97.29025000"
                    },
                    {
                        "id": 119872,
                        "name": "Lake Brownwood",
                        "latitude": "31.83570000",
                        "longitude": "-99.00783000"
                    },
                    {
                        "id": 119902,
                        "name": "Lake Dallas",
                        "latitude": "33.11929000",
                        "longitude": "-97.02556000"
                    },
                    {
                        "id": 119904,
                        "name": "Lake Dunlap",
                        "latitude": "29.67578000",
                        "longitude": "-98.07223000"
                    },
                    {
                        "id": 119924,
                        "name": "Lake Jackson",
                        "latitude": "29.03386000",
                        "longitude": "-95.43439000"
                    },
                    {
                        "id": 119927,
                        "name": "Lake Kiowa",
                        "latitude": "33.57705000",
                        "longitude": "-97.01306000"
                    },
                    {
                        "id": 119998,
                        "name": "Lake Worth",
                        "latitude": "32.80485000",
                        "longitude": "-97.44502000"
                    },
                    {
                        "id": 120010,
                        "name": "Lakehills",
                        "latitude": "29.60467000",
                        "longitude": "-98.94309000"
                    },
                    {
                        "id": 120030,
                        "name": "Lakeside",
                        "latitude": "32.82235000",
                        "longitude": "-97.49335000"
                    },
                    {
                        "id": 120044,
                        "name": "Lakeway",
                        "latitude": "30.36377000",
                        "longitude": "-97.97959000"
                    },
                    {
                        "id": 120064,
                        "name": "Lamar County",
                        "latitude": "33.66726000",
                        "longitude": "-95.57120000"
                    },
                    {
                        "id": 120066,
                        "name": "Lamb County",
                        "latitude": "34.06862000",
                        "longitude": "-102.35171000"
                    },
                    {
                        "id": 120071,
                        "name": "Lamesa",
                        "latitude": "32.73760000",
                        "longitude": "-101.95099000"
                    },
                    {
                        "id": 120075,
                        "name": "Lampasas",
                        "latitude": "31.06378000",
                        "longitude": "-98.18170000"
                    },
                    {
                        "id": 120076,
                        "name": "Lampasas County",
                        "latitude": "31.19619000",
                        "longitude": "-98.24145000"
                    },
                    {
                        "id": 120082,
                        "name": "Lancaster",
                        "latitude": "32.59208000",
                        "longitude": "-96.75611000"
                    },
                    {
                        "id": 120130,
                        "name": "Lantana",
                        "latitude": "33.09073000",
                        "longitude": "-97.12416000"
                    },
                    {
                        "id": 120142,
                        "name": "Laredo",
                        "latitude": "27.50641000",
                        "longitude": "-99.50754000"
                    },
                    {
                        "id": 120157,
                        "name": "Las Lomas",
                        "latitude": "26.36479000",
                        "longitude": "-98.77530000"
                    },
                    {
                        "id": 120160,
                        "name": "Las Palmas II",
                        "latitude": "26.20171000",
                        "longitude": "-97.73760000"
                    },
                    {
                        "id": 120161,
                        "name": "Las Quintas Fronterizas",
                        "latitude": "28.69053000",
                        "longitude": "-100.46869000"
                    },
                    {
                        "id": 120162,
                        "name": "Las Quintas Fronterizas Colonia",
                        "latitude": "28.69137000",
                        "longitude": "-100.46924000"
                    },
                    {
                        "id": 120165,
                        "name": "Lasara",
                        "latitude": "26.46479000",
                        "longitude": "-97.91111000"
                    },
                    {
                        "id": 120186,
                        "name": "Laughlin Air Force Base",
                        "latitude": "29.35663000",
                        "longitude": "-100.78353000"
                    },
                    {
                        "id": 120203,
                        "name": "Laureles",
                        "latitude": "26.10924000",
                        "longitude": "-97.49415000"
                    },
                    {
                        "id": 120214,
                        "name": "Lavaca County",
                        "latitude": "29.38435000",
                        "longitude": "-96.93015000"
                    },
                    {
                        "id": 120219,
                        "name": "Lavon",
                        "latitude": "33.02762000",
                        "longitude": "-96.43415000"
                    },
                    {
                        "id": 120274,
                        "name": "League City",
                        "latitude": "29.50745000",
                        "longitude": "-95.09493000"
                    },
                    {
                        "id": 120277,
                        "name": "Leakey",
                        "latitude": "29.72884000",
                        "longitude": "-99.76145000"
                    },
                    {
                        "id": 120279,
                        "name": "Leander",
                        "latitude": "30.57881000",
                        "longitude": "-97.85307000"
                    },
                    {
                        "id": 120314,
                        "name": "Lee County",
                        "latitude": "30.31068000",
                        "longitude": "-96.96570000"
                    },
                    {
                        "id": 120385,
                        "name": "Leon County",
                        "latitude": "31.29651000",
                        "longitude": "-95.99569000"
                    },
                    {
                        "id": 120386,
                        "name": "Leon Valley",
                        "latitude": "29.49523000",
                        "longitude": "-98.61863000"
                    },
                    {
                        "id": 120388,
                        "name": "Leonard",
                        "latitude": "33.37955000",
                        "longitude": "-96.24748000"
                    },
                    {
                        "id": 120405,
                        "name": "Levelland",
                        "latitude": "33.58732000",
                        "longitude": "-102.37796000"
                    },
                    {
                        "id": 120436,
                        "name": "Lewisville",
                        "latitude": "33.04623000",
                        "longitude": "-96.99417000"
                    },
                    {
                        "id": 120446,
                        "name": "Lexington",
                        "latitude": "30.41910000",
                        "longitude": "-97.01165000"
                    },
                    {
                        "id": 120465,
                        "name": "Liberty",
                        "latitude": "30.05799000",
                        "longitude": "-94.79548000"
                    },
                    {
                        "id": 120469,
                        "name": "Liberty City",
                        "latitude": "32.44543000",
                        "longitude": "-94.94855000"
                    },
                    {
                        "id": 120472,
                        "name": "Liberty County",
                        "latitude": "30.15161000",
                        "longitude": "-94.81221000"
                    },
                    {
                        "id": 120474,
                        "name": "Liberty Hill",
                        "latitude": "30.66491000",
                        "longitude": "-97.92252000"
                    },
                    {
                        "id": 120495,
                        "name": "Limestone County",
                        "latitude": "31.54546000",
                        "longitude": "-96.58053000"
                    },
                    {
                        "id": 120559,
                        "name": "Lindale",
                        "latitude": "32.51570000",
                        "longitude": "-95.40940000"
                    },
                    {
                        "id": 120562,
                        "name": "Linden",
                        "latitude": "33.01235000",
                        "longitude": "-94.36547000"
                    },
                    {
                        "id": 120573,
                        "name": "Lindsay",
                        "latitude": "33.63594000",
                        "longitude": "-97.22279000"
                    },
                    {
                        "id": 120596,
                        "name": "Lipscomb County",
                        "latitude": "36.27771000",
                        "longitude": "-100.27312000"
                    },
                    {
                        "id": 120616,
                        "name": "Little Elm",
                        "latitude": "33.16262000",
                        "longitude": "-96.93751000"
                    },
                    {
                        "id": 120625,
                        "name": "Little River-Academy",
                        "latitude": "30.98629000",
                        "longitude": "-97.35861000"
                    },
                    {
                        "id": 120632,
                        "name": "Littlefield",
                        "latitude": "33.91731000",
                        "longitude": "-102.32490000"
                    },
                    {
                        "id": 120639,
                        "name": "Live Oak",
                        "latitude": "29.56523000",
                        "longitude": "-98.33640000"
                    },
                    {
                        "id": 120641,
                        "name": "Live Oak County",
                        "latitude": "28.35137000",
                        "longitude": "-98.12479000"
                    },
                    {
                        "id": 120650,
                        "name": "Livingston",
                        "latitude": "30.71103000",
                        "longitude": "-94.93299000"
                    },
                    {
                        "id": 120664,
                        "name": "Llano",
                        "latitude": "30.75935000",
                        "longitude": "-98.67504000"
                    },
                    {
                        "id": 120665,
                        "name": "Llano County",
                        "latitude": "30.70574000",
                        "longitude": "-98.68410000"
                    },
                    {
                        "id": 120666,
                        "name": "Llano Grande",
                        "latitude": "26.12980000",
                        "longitude": "-97.96806000"
                    },
                    {
                        "id": 120677,
                        "name": "Lockhart",
                        "latitude": "29.88494000",
                        "longitude": "-97.67000000"
                    },
                    {
                        "id": 120678,
                        "name": "Lockney",
                        "latitude": "34.12452000",
                        "longitude": "-101.44155000"
                    },
                    {
                        "id": 120730,
                        "name": "Lone Star",
                        "latitude": "32.94402000",
                        "longitude": "-94.70715000"
                    },
                    {
                        "id": 120757,
                        "name": "Longview",
                        "latitude": "32.50070000",
                        "longitude": "-94.74049000"
                    },
                    {
                        "id": 120768,
                        "name": "Lopezville",
                        "latitude": "26.23813000",
                        "longitude": "-98.15973000"
                    },
                    {
                        "id": 120771,
                        "name": "Lorena",
                        "latitude": "31.38656000",
                        "longitude": "-97.21556000"
                    },
                    {
                        "id": 120773,
                        "name": "Lorenzo",
                        "latitude": "33.67064000",
                        "longitude": "-101.53516000"
                    },
                    {
                        "id": 120788,
                        "name": "Los Fresnos",
                        "latitude": "26.07174000",
                        "longitude": "-97.47637000"
                    },
                    {
                        "id": 120790,
                        "name": "Los Indios",
                        "latitude": "26.04924000",
                        "longitude": "-97.74499000"
                    },
                    {
                        "id": 120797,
                        "name": "Lost Creek",
                        "latitude": "30.29548000",
                        "longitude": "-97.84445000"
                    },
                    {
                        "id": 120829,
                        "name": "Loving County",
                        "latitude": "31.84923000",
                        "longitude": "-103.57996000"
                    },
                    {
                        "id": 120849,
                        "name": "Lowry Crossing",
                        "latitude": "33.15484000",
                        "longitude": "-96.54721000"
                    },
                    {
                        "id": 120856,
                        "name": "Lubbock",
                        "latitude": "33.57786000",
                        "longitude": "-101.85517000"
                    },
                    {
                        "id": 120857,
                        "name": "Lubbock County",
                        "latitude": "33.61021000",
                        "longitude": "-101.82055000"
                    },
                    {
                        "id": 120860,
                        "name": "Lucas",
                        "latitude": "33.08429000",
                        "longitude": "-96.57666000"
                    },
                    {
                        "id": 120872,
                        "name": "Lufkin",
                        "latitude": "31.33824000",
                        "longitude": "-94.72910000"
                    },
                    {
                        "id": 120877,
                        "name": "Luling",
                        "latitude": "29.68051000",
                        "longitude": "-97.64750000"
                    },
                    {
                        "id": 120881,
                        "name": "Lumberton",
                        "latitude": "30.26577000",
                        "longitude": "-94.19963000"
                    },
                    {
                        "id": 120906,
                        "name": "Lyford",
                        "latitude": "26.41229000",
                        "longitude": "-97.78972000"
                    },
                    {
                        "id": 120928,
                        "name": "Lynn County",
                        "latitude": "33.17682000",
                        "longitude": "-101.81612000"
                    },
                    {
                        "id": 120946,
                        "name": "Lytle",
                        "latitude": "29.23329000",
                        "longitude": "-98.79641000"
                    },
                    {
                        "id": 120948,
                        "name": "Mabank",
                        "latitude": "32.36653000",
                        "longitude": "-96.10081000"
                    },
                    {
                        "id": 121012,
                        "name": "Madison County",
                        "latitude": "30.96554000",
                        "longitude": "-95.92841000"
                    },
                    {
                        "id": 121027,
                        "name": "Madisonville",
                        "latitude": "30.94991000",
                        "longitude": "-95.91162000"
                    },
                    {
                        "id": 121038,
                        "name": "Magnolia",
                        "latitude": "30.20938000",
                        "longitude": "-95.75078000"
                    },
                    {
                        "id": 121058,
                        "name": "Malakoff",
                        "latitude": "32.16960000",
                        "longitude": "-96.01247000"
                    },
                    {
                        "id": 121088,
                        "name": "Manchaca",
                        "latitude": "30.14077000",
                        "longitude": "-97.83306000"
                    },
                    {
                        "id": 121138,
                        "name": "Manor",
                        "latitude": "30.34076000",
                        "longitude": "-97.55695000"
                    },
                    {
                        "id": 121145,
                        "name": "Mansfield",
                        "latitude": "32.56319000",
                        "longitude": "-97.14168000"
                    },
                    {
                        "id": 121161,
                        "name": "Manvel",
                        "latitude": "29.46274000",
                        "longitude": "-95.35799000"
                    },
                    {
                        "id": 121187,
                        "name": "Marble Falls",
                        "latitude": "30.57841000",
                        "longitude": "-98.27507000"
                    },
                    {
                        "id": 121204,
                        "name": "Marfa",
                        "latitude": "30.30973000",
                        "longitude": "-104.02134000"
                    },
                    {
                        "id": 121239,
                        "name": "Marion",
                        "latitude": "29.57134000",
                        "longitude": "-98.14029000"
                    },
                    {
                        "id": 121259,
                        "name": "Marion County",
                        "latitude": "32.79798000",
                        "longitude": "-94.35722000"
                    },
                    {
                        "id": 121269,
                        "name": "Markham",
                        "latitude": "28.96026000",
                        "longitude": "-96.06524000"
                    },
                    {
                        "id": 121283,
                        "name": "Marlin",
                        "latitude": "31.30629000",
                        "longitude": "-96.89804000"
                    },
                    {
                        "id": 121305,
                        "name": "Marshall",
                        "latitude": "32.54487000",
                        "longitude": "-94.36742000"
                    },
                    {
                        "id": 121332,
                        "name": "Mart",
                        "latitude": "31.54239000",
                        "longitude": "-96.83360000"
                    },
                    {
                        "id": 121342,
                        "name": "Martin County",
                        "latitude": "32.30603000",
                        "longitude": "-101.95122000"
                    },
                    {
                        "id": 121343,
                        "name": "Martindale",
                        "latitude": "29.84550000",
                        "longitude": "-97.84084000"
                    },
                    {
                        "id": 121372,
                        "name": "Mason",
                        "latitude": "30.74879000",
                        "longitude": "-99.23061000"
                    },
                    {
                        "id": 121378,
                        "name": "Mason County",
                        "latitude": "30.71772000",
                        "longitude": "-99.22613000"
                    },
                    {
                        "id": 121396,
                        "name": "Matador",
                        "latitude": "34.01202000",
                        "longitude": "-100.82208000"
                    },
                    {
                        "id": 121397,
                        "name": "Matagorda County",
                        "latitude": "28.78565000",
                        "longitude": "-96.00398000"
                    },
                    {
                        "id": 121405,
                        "name": "Mathis",
                        "latitude": "28.09446000",
                        "longitude": "-97.82805000"
                    },
                    {
                        "id": 121417,
                        "name": "Maud",
                        "latitude": "33.33290000",
                        "longitude": "-94.34270000"
                    },
                    {
                        "id": 121424,
                        "name": "Mauriceville",
                        "latitude": "30.20354000",
                        "longitude": "-93.86628000"
                    },
                    {
                        "id": 121428,
                        "name": "Maverick County",
                        "latitude": "28.74259000",
                        "longitude": "-100.31451000"
                    },
                    {
                        "id": 121463,
                        "name": "McAllen",
                        "latitude": "26.20341000",
                        "longitude": "-98.23001000"
                    },
                    {
                        "id": 121466,
                        "name": "McCamey",
                        "latitude": "31.13598000",
                        "longitude": "-102.22430000"
                    },
                    {
                        "id": 121488,
                        "name": "McCulloch County",
                        "latitude": "31.19887000",
                        "longitude": "-99.34748000"
                    },
                    {
                        "id": 121506,
                        "name": "McGregor",
                        "latitude": "31.44406000",
                        "longitude": "-97.40918000"
                    },
                    {
                        "id": 121525,
                        "name": "McKinney",
                        "latitude": "33.19762000",
                        "longitude": "-96.61527000"
                    },
                    {
                        "id": 121533,
                        "name": "McLendon-Chisholm",
                        "latitude": "32.84235000",
                        "longitude": "-96.38054000"
                    },
                    {
                        "id": 121534,
                        "name": "McLennan County",
                        "latitude": "31.55238000",
                        "longitude": "-97.20179000"
                    },
                    {
                        "id": 121542,
                        "name": "McMullen County",
                        "latitude": "28.35269000",
                        "longitude": "-98.56784000"
                    },
                    {
                        "id": 121549,
                        "name": "McQueeney",
                        "latitude": "29.59217000",
                        "longitude": "-98.03334000"
                    },
                    {
                        "id": 121569,
                        "name": "Meadowlakes",
                        "latitude": "30.56245000",
                        "longitude": "-98.29867000"
                    },
                    {
                        "id": 121571,
                        "name": "Meadows Place",
                        "latitude": "29.65134000",
                        "longitude": "-95.58800000"
                    },
                    {
                        "id": 121603,
                        "name": "Medina",
                        "latitude": "29.79661000",
                        "longitude": "-99.24643000"
                    },
                    {
                        "id": 121607,
                        "name": "Medina County",
                        "latitude": "29.35570000",
                        "longitude": "-99.11013000"
                    },
                    {
                        "id": 121624,
                        "name": "Melissa",
                        "latitude": "33.28595000",
                        "longitude": "-96.57277000"
                    },
                    {
                        "id": 121642,
                        "name": "Memphis",
                        "latitude": "34.72478000",
                        "longitude": "-100.53401000"
                    },
                    {
                        "id": 121646,
                        "name": "Menard",
                        "latitude": "30.91767000",
                        "longitude": "-99.78646000"
                    },
                    {
                        "id": 121647,
                        "name": "Menard County",
                        "latitude": "30.88978000",
                        "longitude": "-99.82064000"
                    },
                    {
                        "id": 121668,
                        "name": "Mentone",
                        "latitude": "31.70513000",
                        "longitude": "-103.59935000"
                    },
                    {
                        "id": 121673,
                        "name": "Mercedes",
                        "latitude": "26.14980000",
                        "longitude": "-97.91361000"
                    },
                    {
                        "id": 121692,
                        "name": "Meridian",
                        "latitude": "31.92321000",
                        "longitude": "-97.65669000"
                    },
                    {
                        "id": 121700,
                        "name": "Merkel",
                        "latitude": "32.47068000",
                        "longitude": "-100.01287000"
                    },
                    {
                        "id": 121719,
                        "name": "Mertzon",
                        "latitude": "31.26183000",
                        "longitude": "-100.81733000"
                    },
                    {
                        "id": 121726,
                        "name": "Mesquite",
                        "latitude": "32.76680000",
                        "longitude": "-96.59916000"
                    },
                    {
                        "id": 121740,
                        "name": "Mexia",
                        "latitude": "31.67989000",
                        "longitude": "-96.48220000"
                    },
                    {
                        "id": 121749,
                        "name": "Miami",
                        "latitude": "35.69143000",
                        "longitude": "-100.63819000"
                    },
                    {
                        "id": 121800,
                        "name": "Midland",
                        "latitude": "31.99735000",
                        "longitude": "-102.07791000"
                    },
                    {
                        "id": 121805,
                        "name": "Midland County",
                        "latitude": "31.86917000",
                        "longitude": "-102.03162000"
                    },
                    {
                        "id": 121807,
                        "name": "Midlothian",
                        "latitude": "32.48236000",
                        "longitude": "-96.99445000"
                    },
                    {
                        "id": 121822,
                        "name": "Midway North",
                        "latitude": "26.18776000",
                        "longitude": "-98.01708000"
                    },
                    {
                        "id": 121823,
                        "name": "Midway South",
                        "latitude": "26.15694000",
                        "longitude": "-98.02011000"
                    },
                    {
                        "id": 121831,
                        "name": "Mila Doce",
                        "latitude": "26.22618000",
                        "longitude": "-97.95889000"
                    },
                    {
                        "id": 121833,
                        "name": "Milam",
                        "latitude": "31.43240000",
                        "longitude": "-93.84574000"
                    },
                    {
                        "id": 121834,
                        "name": "Milam County",
                        "latitude": "30.78634000",
                        "longitude": "-96.97685000"
                    },
                    {
                        "id": 121897,
                        "name": "Mills County",
                        "latitude": "31.49519000",
                        "longitude": "-98.59546000"
                    },
                    {
                        "id": 121931,
                        "name": "Mineola",
                        "latitude": "32.66319000",
                        "longitude": "-95.48829000"
                    },
                    {
                        "id": 121941,
                        "name": "Mineral Wells",
                        "latitude": "32.80846000",
                        "longitude": "-98.11282000"
                    },
                    {
                        "id": 121980,
                        "name": "Mission",
                        "latitude": "26.21591000",
                        "longitude": "-98.32529000"
                    },
                    {
                        "id": 121983,
                        "name": "Mission Bend",
                        "latitude": "29.69384000",
                        "longitude": "-95.66495000"
                    },
                    {
                        "id": 121993,
                        "name": "Missouri City",
                        "latitude": "29.61857000",
                        "longitude": "-95.53772000"
                    },
                    {
                        "id": 122003,
                        "name": "Mitchell County",
                        "latitude": "32.30621000",
                        "longitude": "-100.92123000"
                    },
                    {
                        "id": 122033,
                        "name": "Monahans",
                        "latitude": "31.59430000",
                        "longitude": "-102.89265000"
                    },
                    {
                        "id": 122093,
                        "name": "Mont Belvieu",
                        "latitude": "29.84772000",
                        "longitude": "-94.89076000"
                    },
                    {
                        "id": 122095,
                        "name": "Montague",
                        "latitude": "33.66483000",
                        "longitude": "-97.72059000"
                    },
                    {
                        "id": 122099,
                        "name": "Montague County",
                        "latitude": "33.67563000",
                        "longitude": "-97.72465000"
                    },
                    {
                        "id": 122108,
                        "name": "Monte Alto",
                        "latitude": "26.37312000",
                        "longitude": "-97.97167000"
                    },
                    {
                        "id": 122150,
                        "name": "Montgomery County",
                        "latitude": "30.30021000",
                        "longitude": "-95.50301000"
                    },
                    {
                        "id": 122196,
                        "name": "Moody",
                        "latitude": "31.30823000",
                        "longitude": "-97.36140000"
                    },
                    {
                        "id": 122203,
                        "name": "Moore County",
                        "latitude": "35.83769000",
                        "longitude": "-101.89292000"
                    },
                    {
                        "id": 122249,
                        "name": "Morgans Point Resort",
                        "latitude": "31.14823000",
                        "longitude": "-97.46334000"
                    },
                    {
                        "id": 122270,
                        "name": "Morris County",
                        "latitude": "33.11348000",
                        "longitude": "-94.73265000"
                    },
                    {
                        "id": 122294,
                        "name": "Morton",
                        "latitude": "33.72510000",
                        "longitude": "-102.75938000"
                    },
                    {
                        "id": 122311,
                        "name": "Motley County",
                        "latitude": "34.07409000",
                        "longitude": "-100.77983000"
                    },
                    {
                        "id": 122377,
                        "name": "Mount Pleasant",
                        "latitude": "33.15679000",
                        "longitude": "-94.96827000"
                    },
                    {
                        "id": 122399,
                        "name": "Mount Vernon",
                        "latitude": "33.18873000",
                        "longitude": "-95.22133000"
                    },
                    {
                        "id": 122447,
                        "name": "Muenster",
                        "latitude": "33.65177000",
                        "longitude": "-97.37641000"
                    },
                    {
                        "id": 122457,
                        "name": "Muleshoe",
                        "latitude": "34.22647000",
                        "longitude": "-102.72383000"
                    },
                    {
                        "id": 122467,
                        "name": "Munday",
                        "latitude": "33.44926000",
                        "longitude": "-99.62286000"
                    },
                    {
                        "id": 122475,
                        "name": "Muniz",
                        "latitude": "26.25646000",
                        "longitude": "-98.08945000"
                    },
                    {
                        "id": 122483,
                        "name": "Murillo Colonia",
                        "latitude": "26.25646000",
                        "longitude": "-98.11334000"
                    },
                    {
                        "id": 122486,
                        "name": "Murphy",
                        "latitude": "33.01512000",
                        "longitude": "-96.61305000"
                    },
                    {
                        "id": 122532,
                        "name": "Nacogdoches",
                        "latitude": "31.60351000",
                        "longitude": "-94.65549000"
                    },
                    {
                        "id": 122533,
                        "name": "Nacogdoches County",
                        "latitude": "31.61598000",
                        "longitude": "-94.61587000"
                    },
                    {
                        "id": 122553,
                        "name": "Naples",
                        "latitude": "33.20318000",
                        "longitude": "-94.68021000"
                    },
                    {
                        "id": 122567,
                        "name": "Nash",
                        "latitude": "33.44235000",
                        "longitude": "-94.13075000"
                    },
                    {
                        "id": 122581,
                        "name": "Nassau Bay",
                        "latitude": "29.54468000",
                        "longitude": "-95.09104000"
                    },
                    {
                        "id": 122586,
                        "name": "Natalia",
                        "latitude": "29.18968000",
                        "longitude": "-98.86253000"
                    },
                    {
                        "id": 122601,
                        "name": "Navarro County",
                        "latitude": "32.04693000",
                        "longitude": "-96.47249000"
                    },
                    {
                        "id": 122602,
                        "name": "Navasota",
                        "latitude": "30.38798000",
                        "longitude": "-96.08773000"
                    },
                    {
                        "id": 122610,
                        "name": "Nederland",
                        "latitude": "29.97438000",
                        "longitude": "-93.99240000"
                    },
                    {
                        "id": 122615,
                        "name": "Needville",
                        "latitude": "29.39941000",
                        "longitude": "-95.83773000"
                    },
                    {
                        "id": 122649,
                        "name": "Nevada",
                        "latitude": "33.04234000",
                        "longitude": "-96.37387000"
                    },
                    {
                        "id": 122668,
                        "name": "New Boston",
                        "latitude": "33.45984000",
                        "longitude": "-94.41548000"
                    },
                    {
                        "id": 122670,
                        "name": "New Braunfels",
                        "latitude": "29.70300000",
                        "longitude": "-98.12445000"
                    },
                    {
                        "id": 122784,
                        "name": "New Summerfield",
                        "latitude": "31.98072000",
                        "longitude": "-95.09383000"
                    },
                    {
                        "id": 122786,
                        "name": "New Territory",
                        "latitude": "29.59412000",
                        "longitude": "-95.68078000"
                    },
                    {
                        "id": 122790,
                        "name": "New Waverly",
                        "latitude": "30.53770000",
                        "longitude": "-95.48328000"
                    },
                    {
                        "id": 122801,
                        "name": "Newark",
                        "latitude": "33.00124000",
                        "longitude": "-97.48447000"
                    },
                    {
                        "id": 122862,
                        "name": "Newton",
                        "latitude": "30.84853000",
                        "longitude": "-93.75740000"
                    },
                    {
                        "id": 122872,
                        "name": "Newton County",
                        "latitude": "30.78631000",
                        "longitude": "-93.74474000"
                    },
                    {
                        "id": 122913,
                        "name": "Nixon",
                        "latitude": "29.26746000",
                        "longitude": "-97.76444000"
                    },
                    {
                        "id": 122923,
                        "name": "Nocona",
                        "latitude": "33.78677000",
                        "longitude": "-97.72586000"
                    },
                    {
                        "id": 122931,
                        "name": "Nolan County",
                        "latitude": "32.30349000",
                        "longitude": "-100.40605000"
                    },
                    {
                        "id": 122932,
                        "name": "Nolanville",
                        "latitude": "31.07879000",
                        "longitude": "-97.60557000"
                    },
                    {
                        "id": 122959,
                        "name": "North Alamo",
                        "latitude": "26.21730000",
                        "longitude": "-98.12890000"
                    },
                    {
                        "id": 123093,
                        "name": "North Richland Hills",
                        "latitude": "32.83430000",
                        "longitude": "-97.22890000"
                    },
                    {
                        "id": 123143,
                        "name": "Northcliff",
                        "latitude": "29.62106000",
                        "longitude": "-98.22473000"
                    },
                    {
                        "id": 123144,
                        "name": "Northcrest",
                        "latitude": "31.63655000",
                        "longitude": "-97.09972000"
                    },
                    {
                        "id": 123157,
                        "name": "Northlake",
                        "latitude": "33.12734000",
                        "longitude": "-97.26557000"
                    },
                    {
                        "id": 123215,
                        "name": "Nueces County",
                        "latitude": "27.73506000",
                        "longitude": "-97.51632000"
                    },
                    {
                        "id": 123218,
                        "name": "Nurillo",
                        "latitude": "26.26702000",
                        "longitude": "-98.12140000"
                    },
                    {
                        "id": 123231,
                        "name": "Oak Cliff Place",
                        "latitude": "29.92712000",
                        "longitude": "-95.62672000"
                    },
                    {
                        "id": 123253,
                        "name": "Oak Leaf",
                        "latitude": "32.52042000",
                        "longitude": "-96.85472000"
                    },
                    {
                        "id": 123259,
                        "name": "Oak Point",
                        "latitude": "33.19012000",
                        "longitude": "-96.99167000"
                    },
                    {
                        "id": 123263,
                        "name": "Oak Ridge North",
                        "latitude": "30.16022000",
                        "longitude": "-95.44438000"
                    },
                    {
                        "id": 123264,
                        "name": "Oak Trail Shores",
                        "latitude": "32.48875000",
                        "longitude": "-97.83420000"
                    },
                    {
                        "id": 123345,
                        "name": "Ochiltree County",
                        "latitude": "36.27841000",
                        "longitude": "-100.81565000"
                    },
                    {
                        "id": 123355,
                        "name": "Odem",
                        "latitude": "27.95057000",
                        "longitude": "-97.58222000"
                    },
                    {
                        "id": 123360,
                        "name": "Odessa",
                        "latitude": "31.84568000",
                        "longitude": "-102.36764000"
                    },
                    {
                        "id": 123426,
                        "name": "Old River-Winfree",
                        "latitude": "29.86828000",
                        "longitude": "-94.83270000"
                    },
                    {
                        "id": 123433,
                        "name": "Oldham County",
                        "latitude": "35.40502000",
                        "longitude": "-102.60287000"
                    },
                    {
                        "id": 123438,
                        "name": "Olivarez",
                        "latitude": "26.22841000",
                        "longitude": "-97.99223000"
                    },
                    {
                        "id": 123452,
                        "name": "Olmito",
                        "latitude": "26.02174000",
                        "longitude": "-97.53415000"
                    },
                    {
                        "id": 123453,
                        "name": "Olmos Park",
                        "latitude": "29.47884000",
                        "longitude": "-98.48752000"
                    },
                    {
                        "id": 123457,
                        "name": "Olney",
                        "latitude": "33.37066000",
                        "longitude": "-98.75284000"
                    },
                    {
                        "id": 123458,
                        "name": "Olton",
                        "latitude": "34.18341000",
                        "longitude": "-102.13463000"
                    },
                    {
                        "id": 123467,
                        "name": "Onalaska",
                        "latitude": "30.80575000",
                        "longitude": "-95.11633000"
                    },
                    {
                        "id": 123481,
                        "name": "Onion Creek",
                        "latitude": "30.13660000",
                        "longitude": "-97.78417000"
                    },
                    {
                        "id": 123505,
                        "name": "Orange",
                        "latitude": "30.09299000",
                        "longitude": "-93.73655000"
                    },
                    {
                        "id": 123517,
                        "name": "Orange County",
                        "latitude": "30.12131000",
                        "longitude": "-93.89390000"
                    },
                    {
                        "id": 123523,
                        "name": "Orange Grove",
                        "latitude": "27.95668000",
                        "longitude": "-97.93694000"
                    },
                    {
                        "id": 123544,
                        "name": "Ore City",
                        "latitude": "32.80014000",
                        "longitude": "-94.72076000"
                    },
                    {
                        "id": 123653,
                        "name": "Overton",
                        "latitude": "32.27460000",
                        "longitude": "-94.97855000"
                    },
                    {
                        "id": 123657,
                        "name": "Ovilla",
                        "latitude": "32.52653000",
                        "longitude": "-96.88639000"
                    },
                    {
                        "id": 123695,
                        "name": "Oyster Creek",
                        "latitude": "29.00302000",
                        "longitude": "-95.33188000"
                    },
                    {
                        "id": 123701,
                        "name": "Ozona",
                        "latitude": "30.71017000",
                        "longitude": "-101.20067000"
                    },
                    {
                        "id": 123716,
                        "name": "Paducah",
                        "latitude": "34.01230000",
                        "longitude": "-100.30206000"
                    },
                    {
                        "id": 123726,
                        "name": "Paint Rock",
                        "latitude": "31.50849000",
                        "longitude": "-99.92008000"
                    },
                    {
                        "id": 123730,
                        "name": "Palacios",
                        "latitude": "28.70805000",
                        "longitude": "-96.21747000"
                    },
                    {
                        "id": 123737,
                        "name": "Palestine",
                        "latitude": "31.76212000",
                        "longitude": "-95.63079000"
                    },
                    {
                        "id": 123755,
                        "name": "Palm Valley",
                        "latitude": "26.20174000",
                        "longitude": "-97.75416000"
                    },
                    {
                        "id": 123758,
                        "name": "Palmer",
                        "latitude": "32.43125000",
                        "longitude": "-96.66777000"
                    },
                    {
                        "id": 123768,
                        "name": "Palmhurst",
                        "latitude": "26.25841000",
                        "longitude": "-98.31807000"
                    },
                    {
                        "id": 123770,
                        "name": "Palmview",
                        "latitude": "26.23341000",
                        "longitude": "-98.37085000"
                    },
                    {
                        "id": 123771,
                        "name": "Palmview South",
                        "latitude": "26.21563000",
                        "longitude": "-98.37863000"
                    },
                    {
                        "id": 123784,
                        "name": "Palo Pinto",
                        "latitude": "32.76735000",
                        "longitude": "-98.29866000"
                    },
                    {
                        "id": 123785,
                        "name": "Palo Pinto County",
                        "latitude": "32.75318000",
                        "longitude": "-98.31302000"
                    },
                    {
                        "id": 123786,
                        "name": "Paloma Creek",
                        "latitude": "33.22530000",
                        "longitude": "-96.93742000"
                    },
                    {
                        "id": 123787,
                        "name": "Paloma Creek South",
                        "latitude": "33.21136000",
                        "longitude": "-96.93554000"
                    },
                    {
                        "id": 123794,
                        "name": "Pampa",
                        "latitude": "35.53616000",
                        "longitude": "-100.95987000"
                    },
                    {
                        "id": 123801,
                        "name": "Panhandle",
                        "latitude": "35.34560000",
                        "longitude": "-101.38044000"
                    },
                    {
                        "id": 123804,
                        "name": "Panola County",
                        "latitude": "32.16236000",
                        "longitude": "-94.30565000"
                    },
                    {
                        "id": 123806,
                        "name": "Panorama Village",
                        "latitude": "30.38104000",
                        "longitude": "-95.49355000"
                    },
                    {
                        "id": 123807,
                        "name": "Pantego",
                        "latitude": "32.71430000",
                        "longitude": "-97.15640000"
                    },
                    {
                        "id": 123834,
                        "name": "Paris",
                        "latitude": "33.66094000",
                        "longitude": "-95.55551000"
                    },
                    {
                        "id": 123860,
                        "name": "Parker",
                        "latitude": "33.05540000",
                        "longitude": "-96.62194000"
                    },
                    {
                        "id": 123865,
                        "name": "Parker County",
                        "latitude": "32.77765000",
                        "longitude": "-97.80510000"
                    },
                    {
                        "id": 123886,
                        "name": "Parmer County",
                        "latitude": "34.53010000",
                        "longitude": "-102.78452000"
                    },
                    {
                        "id": 123896,
                        "name": "Pasadena",
                        "latitude": "29.69106000",
                        "longitude": "-95.20910000"
                    },
                    {
                        "id": 123919,
                        "name": "Patton Village",
                        "latitude": "30.19299000",
                        "longitude": "-95.16882000"
                    },
                    {
                        "id": 123970,
                        "name": "Pearland",
                        "latitude": "29.56357000",
                        "longitude": "-95.28605000"
                    },
                    {
                        "id": 123972,
                        "name": "Pearsall",
                        "latitude": "28.89219000",
                        "longitude": "-99.09503000"
                    },
                    {
                        "id": 123975,
                        "name": "Pecan Acres",
                        "latitude": "32.97013000",
                        "longitude": "-97.47474000"
                    },
                    {
                        "id": 123976,
                        "name": "Pecan Grove",
                        "latitude": "29.62607000",
                        "longitude": "-95.73162000"
                    },
                    {
                        "id": 123977,
                        "name": "Pecan Plantation",
                        "latitude": "32.36042000",
                        "longitude": "-97.67558000"
                    },
                    {
                        "id": 123980,
                        "name": "Pecos",
                        "latitude": "31.42291000",
                        "longitude": "-103.49323000"
                    },
                    {
                        "id": 123981,
                        "name": "Pecos County",
                        "latitude": "30.78106000",
                        "longitude": "-102.72357000"
                    },
                    {
                        "id": 123995,
                        "name": "Pelican Bay",
                        "latitude": "32.92096000",
                        "longitude": "-97.51836000"
                    },
                    {
                        "id": 124021,
                        "name": "Penitas",
                        "latitude": "26.23063000",
                        "longitude": "-98.44474000"
                    },
                    {
                        "id": 124058,
                        "name": "Perezville",
                        "latitude": "26.22452000",
                        "longitude": "-98.40057000"
                    },
                    {
                        "id": 124087,
                        "name": "Perryton",
                        "latitude": "36.40003000",
                        "longitude": "-100.80265000"
                    },
                    {
                        "id": 124109,
                        "name": "Petersburg",
                        "latitude": "33.86952000",
                        "longitude": "-101.59739000"
                    },
                    {
                        "id": 124117,
                        "name": "Pflugerville",
                        "latitude": "30.43937000",
                        "longitude": "-97.62000000"
                    },
                    {
                        "id": 124118,
                        "name": "Pharr",
                        "latitude": "26.19480000",
                        "longitude": "-98.18362000"
                    },
                    {
                        "id": 124201,
                        "name": "Pilot Point",
                        "latitude": "33.39650000",
                        "longitude": "-96.96056000"
                    },
                    {
                        "id": 124227,
                        "name": "Pine Island",
                        "latitude": "30.05800000",
                        "longitude": "-96.03746000"
                    },
                    {
                        "id": 124251,
                        "name": "Pinehurst",
                        "latitude": "30.17105000",
                        "longitude": "-95.68245000"
                    },
                    {
                        "id": 124265,
                        "name": "Pinewood Estates",
                        "latitude": "30.16438000",
                        "longitude": "-94.32158000"
                    },
                    {
                        "id": 124268,
                        "name": "Piney Point Village",
                        "latitude": "29.75995000",
                        "longitude": "-95.51716000"
                    },
                    {
                        "id": 124293,
                        "name": "Pittsburg",
                        "latitude": "32.99540000",
                        "longitude": "-94.96577000"
                    },
                    {
                        "id": 124324,
                        "name": "Plains",
                        "latitude": "33.18871000",
                        "longitude": "-102.82799000"
                    },
                    {
                        "id": 124331,
                        "name": "Plainview",
                        "latitude": "34.18479000",
                        "longitude": "-101.70684000"
                    },
                    {
                        "id": 124343,
                        "name": "Plano",
                        "latitude": "33.01984000",
                        "longitude": "-96.69889000"
                    },
                    {
                        "id": 124363,
                        "name": "Pleak",
                        "latitude": "29.48913000",
                        "longitude": "-95.80773000"
                    },
                    {
                        "id": 124383,
                        "name": "Pleasanton",
                        "latitude": "28.96719000",
                        "longitude": "-98.47863000"
                    },
                    {
                        "id": 124394,
                        "name": "Plum Grove",
                        "latitude": "32.19570000",
                        "longitude": "-96.98945000"
                    },
                    {
                        "id": 124446,
                        "name": "Polk County",
                        "latitude": "30.79272000",
                        "longitude": "-94.83002000"
                    },
                    {
                        "id": 124467,
                        "name": "Ponder",
                        "latitude": "33.18290000",
                        "longitude": "-97.28724000"
                    },
                    {
                        "id": 124495,
                        "name": "Port Aransas",
                        "latitude": "27.83392000",
                        "longitude": "-97.06110000"
                    },
                    {
                        "id": 124496,
                        "name": "Port Arthur",
                        "latitude": "29.88519000",
                        "longitude": "-93.94233000"
                    },
                    {
                        "id": 124512,
                        "name": "Port Isabel",
                        "latitude": "26.07341000",
                        "longitude": "-97.20858000"
                    },
                    {
                        "id": 124517,
                        "name": "Port Lavaca",
                        "latitude": "28.61500000",
                        "longitude": "-96.62609000"
                    },
                    {
                        "id": 124521,
                        "name": "Port Neches",
                        "latitude": "29.99132000",
                        "longitude": "-93.95851000"
                    },
                    {
                        "id": 124523,
                        "name": "Port O'Connor",
                        "latitude": "28.44834000",
                        "longitude": "-96.40581000"
                    },
                    {
                        "id": 124554,
                        "name": "Porter Heights",
                        "latitude": "30.15188000",
                        "longitude": "-95.32188000"
                    },
                    {
                        "id": 124557,
                        "name": "Portland",
                        "latitude": "27.87725000",
                        "longitude": "-97.32388000"
                    },
                    {
                        "id": 124576,
                        "name": "Post",
                        "latitude": "33.19122000",
                        "longitude": "-101.37900000"
                    },
                    {
                        "id": 124580,
                        "name": "Poteet",
                        "latitude": "29.04052000",
                        "longitude": "-98.56807000"
                    },
                    {
                        "id": 124581,
                        "name": "Poth",
                        "latitude": "29.06969000",
                        "longitude": "-98.08195000"
                    },
                    {
                        "id": 124587,
                        "name": "Potosi",
                        "latitude": "32.32930000",
                        "longitude": "-99.65647000"
                    },
                    {
                        "id": 124594,
                        "name": "Potter County",
                        "latitude": "35.40127000",
                        "longitude": "-101.89400000"
                    },
                    {
                        "id": 124597,
                        "name": "Pottsboro",
                        "latitude": "33.75927000",
                        "longitude": "-96.66944000"
                    },
                    {
                        "id": 124609,
                        "name": "Powderly",
                        "latitude": "33.81122000",
                        "longitude": "-95.52440000"
                    },
                    {
                        "id": 124631,
                        "name": "Prairie View",
                        "latitude": "30.09327000",
                        "longitude": "-95.98773000"
                    },
                    {
                        "id": 124639,
                        "name": "Premont",
                        "latitude": "27.36059000",
                        "longitude": "-98.12362000"
                    },
                    {
                        "id": 124647,
                        "name": "Presidio",
                        "latitude": "29.56074000",
                        "longitude": "-104.37215000"
                    },
                    {
                        "id": 124648,
                        "name": "Presidio County",
                        "latitude": "29.99980000",
                        "longitude": "-104.24052000"
                    },
                    {
                        "id": 124654,
                        "name": "Preston",
                        "latitude": "33.88232000",
                        "longitude": "-96.63305000"
                    },
                    {
                        "id": 124670,
                        "name": "Primera",
                        "latitude": "26.22591000",
                        "longitude": "-97.75805000"
                    },
                    {
                        "id": 124684,
                        "name": "Princeton",
                        "latitude": "33.18012000",
                        "longitude": "-96.49804000"
                    },
                    {
                        "id": 124701,
                        "name": "Progreso",
                        "latitude": "26.09230000",
                        "longitude": "-97.95722000"
                    },
                    {
                        "id": 124711,
                        "name": "Prosper",
                        "latitude": "33.23623000",
                        "longitude": "-96.80111000"
                    },
                    {
                        "id": 124718,
                        "name": "Providence",
                        "latitude": "33.23340000",
                        "longitude": "-96.96158000"
                    },
                    {
                        "id": 124775,
                        "name": "Quail Creek",
                        "latitude": "28.77640000",
                        "longitude": "-97.08232000"
                    },
                    {
                        "id": 124779,
                        "name": "Quanah",
                        "latitude": "34.29785000",
                        "longitude": "-99.74037000"
                    },
                    {
                        "id": 124787,
                        "name": "Queen City",
                        "latitude": "33.14874000",
                        "longitude": "-94.15019000"
                    },
                    {
                        "id": 124802,
                        "name": "Quinlan",
                        "latitude": "32.91040000",
                        "longitude": "-96.13553000"
                    },
                    {
                        "id": 124807,
                        "name": "Quitman",
                        "latitude": "32.79596000",
                        "longitude": "-95.45106000"
                    },
                    {
                        "id": 124828,
                        "name": "Rains County",
                        "latitude": "32.87034000",
                        "longitude": "-95.79338000"
                    },
                    {
                        "id": 124834,
                        "name": "Ralls",
                        "latitude": "33.67425000",
                        "longitude": "-101.38766000"
                    },
                    {
                        "id": 124847,
                        "name": "Rancho Alegre",
                        "latitude": "27.74169000",
                        "longitude": "-98.09473000"
                    },
                    {
                        "id": 124859,
                        "name": "Rancho Viejo",
                        "latitude": "26.03952000",
                        "longitude": "-97.55638000"
                    },
                    {
                        "id": 124862,
                        "name": "Randall County",
                        "latitude": "34.96585000",
                        "longitude": "-101.89695000"
                    },
                    {
                        "id": 124882,
                        "name": "Ranger",
                        "latitude": "32.46985000",
                        "longitude": "-98.67895000"
                    },
                    {
                        "id": 124884,
                        "name": "Rankin",
                        "latitude": "31.22265000",
                        "longitude": "-101.93791000"
                    },
                    {
                        "id": 124887,
                        "name": "Ransom Canyon",
                        "latitude": "33.53342000",
                        "longitude": "-101.67961000"
                    },
                    {
                        "id": 124921,
                        "name": "Raymondville",
                        "latitude": "26.48146000",
                        "longitude": "-97.78305000"
                    },
                    {
                        "id": 124932,
                        "name": "Reagan County",
                        "latitude": "31.36619000",
                        "longitude": "-101.52301000"
                    },
                    {
                        "id": 124933,
                        "name": "Real County",
                        "latitude": "29.83174000",
                        "longitude": "-99.82217000"
                    },
                    {
                        "id": 124952,
                        "name": "Red Lick",
                        "latitude": "33.46485000",
                        "longitude": "-94.17103000"
                    },
                    {
                        "id": 124956,
                        "name": "Red Oak",
                        "latitude": "32.51764000",
                        "longitude": "-96.80444000"
                    },
                    {
                        "id": 124959,
                        "name": "Red River County",
                        "latitude": "33.62068000",
                        "longitude": "-95.05036000"
                    },
                    {
                        "id": 124975,
                        "name": "Redland",
                        "latitude": "31.40435000",
                        "longitude": "-94.72132000"
                    },
                    {
                        "id": 124982,
                        "name": "Redwater",
                        "latitude": "33.35818000",
                        "longitude": "-94.25436000"
                    },
                    {
                        "id": 124984,
                        "name": "Redwood",
                        "latitude": "29.81022000",
                        "longitude": "-97.91139000"
                    },
                    {
                        "id": 124998,
                        "name": "Reeves County",
                        "latitude": "31.32318000",
                        "longitude": "-103.69317000"
                    },
                    {
                        "id": 125000,
                        "name": "Refugio",
                        "latitude": "28.30528000",
                        "longitude": "-97.27527000"
                    },
                    {
                        "id": 125001,
                        "name": "Refugio County",
                        "latitude": "28.32158000",
                        "longitude": "-97.15952000"
                    },
                    {
                        "id": 125017,
                        "name": "Rendon",
                        "latitude": "32.57625000",
                        "longitude": "-97.24140000"
                    },
                    {
                        "id": 125019,
                        "name": "Reno",
                        "latitude": "33.66316000",
                        "longitude": "-95.46245000"
                    },
                    {
                        "id": 125048,
                        "name": "Rhome",
                        "latitude": "33.05346000",
                        "longitude": "-97.47197000"
                    },
                    {
                        "id": 125051,
                        "name": "Ricardo",
                        "latitude": "27.42143000",
                        "longitude": "-97.85111000"
                    },
                    {
                        "id": 125058,
                        "name": "Richardson",
                        "latitude": "32.94818000",
                        "longitude": "-96.72972000"
                    },
                    {
                        "id": 125079,
                        "name": "Richland Hills",
                        "latitude": "32.81596000",
                        "longitude": "-97.22807000"
                    },
                    {
                        "id": 125087,
                        "name": "Richmond",
                        "latitude": "29.58218000",
                        "longitude": "-95.76078000"
                    },
                    {
                        "id": 125111,
                        "name": "Richwood",
                        "latitude": "29.05608000",
                        "longitude": "-95.40994000"
                    },
                    {
                        "id": 125135,
                        "name": "Riesel",
                        "latitude": "31.47489000",
                        "longitude": "-96.92333000"
                    },
                    {
                        "id": 125149,
                        "name": "Rio Bravo",
                        "latitude": "27.36419000",
                        "longitude": "-99.48004000"
                    },
                    {
                        "id": 125154,
                        "name": "Rio Grande City",
                        "latitude": "26.37979000",
                        "longitude": "-98.82030000"
                    },
                    {
                        "id": 125156,
                        "name": "Rio Hondo",
                        "latitude": "26.23535000",
                        "longitude": "-97.58193000"
                    },
                    {
                        "id": 125183,
                        "name": "River Oaks",
                        "latitude": "32.77707000",
                        "longitude": "-97.39446000"
                    },
                    {
                        "id": 125227,
                        "name": "Roanoke",
                        "latitude": "33.00401000",
                        "longitude": "-97.22585000"
                    },
                    {
                        "id": 125240,
                        "name": "Robert Lee",
                        "latitude": "31.89237000",
                        "longitude": "-100.48482000"
                    },
                    {
                        "id": 125243,
                        "name": "Roberts County",
                        "latitude": "35.83849000",
                        "longitude": "-100.81344000"
                    },
                    {
                        "id": 125247,
                        "name": "Robertson County",
                        "latitude": "31.02704000",
                        "longitude": "-96.51279000"
                    },
                    {
                        "id": 125254,
                        "name": "Robinson",
                        "latitude": "31.46767000",
                        "longitude": "-97.11472000"
                    },
                    {
                        "id": 125256,
                        "name": "Robstown",
                        "latitude": "27.79030000",
                        "longitude": "-97.66888000"
                    },
                    {
                        "id": 125257,
                        "name": "Roby",
                        "latitude": "32.74483000",
                        "longitude": "-100.37761000"
                    },
                    {
                        "id": 125295,
                        "name": "Rockdale",
                        "latitude": "30.65548000",
                        "longitude": "-97.00137000"
                    },
                    {
                        "id": 125316,
                        "name": "Rockport",
                        "latitude": "28.02077000",
                        "longitude": "-97.05601000"
                    },
                    {
                        "id": 125319,
                        "name": "Rocksprings",
                        "latitude": "30.01576000",
                        "longitude": "-100.20536000"
                    },
                    {
                        "id": 125326,
                        "name": "Rockwall",
                        "latitude": "32.93123000",
                        "longitude": "-96.45971000"
                    },
                    {
                        "id": 125327,
                        "name": "Rockwall County",
                        "latitude": "32.89773000",
                        "longitude": "-96.40777000"
                    },
                    {
                        "id": 125349,
                        "name": "Rogers",
                        "latitude": "30.93157000",
                        "longitude": "-97.22666000"
                    },
                    {
                        "id": 125369,
                        "name": "Rollingwood",
                        "latitude": "30.27687000",
                        "longitude": "-97.79112000"
                    },
                    {
                        "id": 125372,
                        "name": "Roma",
                        "latitude": "26.40526000",
                        "longitude": "-99.01581000"
                    },
                    {
                        "id": 125373,
                        "name": "Roma-Los Saenz",
                        "latitude": "26.40506000",
                        "longitude": "-99.01586000"
                    },
                    {
                        "id": 125374,
                        "name": "Roman Forest",
                        "latitude": "30.17910000",
                        "longitude": "-95.16243000"
                    },
                    {
                        "id": 125400,
                        "name": "Roscoe",
                        "latitude": "32.44595000",
                        "longitude": "-100.53872000"
                    },
                    {
                        "id": 125411,
                        "name": "Rosebud",
                        "latitude": "31.07296000",
                        "longitude": "-96.97860000"
                    },
                    {
                        "id": 125433,
                        "name": "Rosenberg",
                        "latitude": "29.55718000",
                        "longitude": "-95.80856000"
                    },
                    {
                        "id": 125443,
                        "name": "Rosharon",
                        "latitude": "29.35218000",
                        "longitude": "-95.46022000"
                    },
                    {
                        "id": 125445,
                        "name": "Rosita North",
                        "latitude": "28.65644000",
                        "longitude": "-100.42218000"
                    },
                    {
                        "id": 125446,
                        "name": "Rosita South",
                        "latitude": "28.62375000",
                        "longitude": "-100.42837000"
                    },
                    {
                        "id": 125464,
                        "name": "Rotan",
                        "latitude": "32.85205000",
                        "longitude": "-100.46566000"
                    },
                    {
                        "id": 125473,
                        "name": "Round Rock",
                        "latitude": "30.50826000",
                        "longitude": "-97.67890000"
                    },
                    {
                        "id": 125481,
                        "name": "Rowlett",
                        "latitude": "32.90290000",
                        "longitude": "-96.56388000"
                    },
                    {
                        "id": 125499,
                        "name": "Royse City",
                        "latitude": "32.97512000",
                        "longitude": "-96.33248000"
                    },
                    {
                        "id": 125510,
                        "name": "Runaway Bay",
                        "latitude": "33.16789000",
                        "longitude": "-97.87837000"
                    },
                    {
                        "id": 125511,
                        "name": "Runge",
                        "latitude": "28.88331000",
                        "longitude": "-97.71305000"
                    },
                    {
                        "id": 125512,
                        "name": "Runnels County",
                        "latitude": "31.83110000",
                        "longitude": "-99.97623000"
                    },
                    {
                        "id": 125528,
                        "name": "Rusk",
                        "latitude": "31.79601000",
                        "longitude": "-95.15022000"
                    },
                    {
                        "id": 125529,
                        "name": "Rusk County",
                        "latitude": "32.10772000",
                        "longitude": "-94.76188000"
                    },
                    {
                        "id": 125568,
                        "name": "Sabinal",
                        "latitude": "29.31746000",
                        "longitude": "-99.46644000"
                    },
                    {
                        "id": 125569,
                        "name": "Sabine County",
                        "latitude": "31.34320000",
                        "longitude": "-93.85180000"
                    },
                    {
                        "id": 125574,
                        "name": "Sachse",
                        "latitude": "32.97623000",
                        "longitude": "-96.59527000"
                    },
                    {
                        "id": 125587,
                        "name": "Saginaw",
                        "latitude": "32.86013000",
                        "longitude": "-97.36391000"
                    },
                    {
                        "id": 125645,
                        "name": "Saint Hedwig",
                        "latitude": "29.41440000",
                        "longitude": "-98.20001000"
                    },
                    {
                        "id": 125659,
                        "name": "Saint Jo",
                        "latitude": "33.69483000",
                        "longitude": "-97.52252000"
                    },
                    {
                        "id": 125702,
                        "name": "Saint Paul",
                        "latitude": "33.04123000",
                        "longitude": "-96.55027000"
                    },
                    {
                        "id": 125722,
                        "name": "Salado",
                        "latitude": "30.94713000",
                        "longitude": "-97.53862000"
                    },
                    {
                        "id": 125777,
                        "name": "Sam Rayburn",
                        "latitude": "31.06408000",
                        "longitude": "-94.03575000"
                    },
                    {
                        "id": 125784,
                        "name": "San Angelo",
                        "latitude": "31.46377000",
                        "longitude": "-100.43704000"
                    },
                    {
                        "id": 125787,
                        "name": "San Antonio",
                        "latitude": "29.42412000",
                        "longitude": "-98.49363000"
                    },
                    {
                        "id": 125789,
                        "name": "San Augustine",
                        "latitude": "31.52990000",
                        "longitude": "-94.10603000"
                    },
                    {
                        "id": 125790,
                        "name": "San Augustine County",
                        "latitude": "31.39422000",
                        "longitude": "-94.16819000"
                    },
                    {
                        "id": 125791,
                        "name": "San Benito",
                        "latitude": "26.13258000",
                        "longitude": "-97.63110000"
                    },
                    {
                        "id": 125796,
                        "name": "San Carlos",
                        "latitude": "26.29563000",
                        "longitude": "-98.07195000"
                    },
                    {
                        "id": 125801,
                        "name": "San Diego",
                        "latitude": "27.76391000",
                        "longitude": "-98.23890000"
                    },
                    {
                        "id": 125806,
                        "name": "San Elizario",
                        "latitude": "31.58511000",
                        "longitude": "-106.27276000"
                    },
                    {
                        "id": 125812,
                        "name": "San Jacinto County",
                        "latitude": "30.57953000",
                        "longitude": "-95.16690000"
                    },
                    {
                        "id": 125817,
                        "name": "San Juan",
                        "latitude": "26.18924000",
                        "longitude": "-98.15529000"
                    },
                    {
                        "id": 125825,
                        "name": "San Leon",
                        "latitude": "29.48329000",
                        "longitude": "-94.92215000"
                    },
                    {
                        "id": 125832,
                        "name": "San Marcos",
                        "latitude": "29.88327000",
                        "longitude": "-97.94139000"
                    },
                    {
                        "id": 125844,
                        "name": "San Patricio County",
                        "latitude": "28.00878000",
                        "longitude": "-97.51827000"
                    },
                    {
                        "id": 125848,
                        "name": "San Saba",
                        "latitude": "31.19572000",
                        "longitude": "-98.71810000"
                    },
                    {
                        "id": 125849,
                        "name": "San Saba County",
                        "latitude": "31.15520000",
                        "longitude": "-98.81758000"
                    },
                    {
                        "id": 125864,
                        "name": "Sanderson",
                        "latitude": "30.14241000",
                        "longitude": "-102.39403000"
                    },
                    {
                        "id": 125891,
                        "name": "Sanger",
                        "latitude": "33.36317000",
                        "longitude": "-97.17390000"
                    },
                    {
                        "id": 125898,
                        "name": "Sansom Park",
                        "latitude": "32.80596000",
                        "longitude": "-97.40307000"
                    },
                    {
                        "id": 125900,
                        "name": "Santa Anna",
                        "latitude": "31.74209000",
                        "longitude": "-99.32173000"
                    },
                    {
                        "id": 125913,
                        "name": "Santa Fe",
                        "latitude": "29.37801000",
                        "longitude": "-95.10576000"
                    },
                    {
                        "id": 125921,
                        "name": "Santa Rosa",
                        "latitude": "26.25674000",
                        "longitude": "-97.82500000"
                    },
                    {
                        "id": 125951,
                        "name": "Sarita",
                        "latitude": "27.22171000",
                        "longitude": "-97.78916000"
                    },
                    {
                        "id": 125977,
                        "name": "Savannah",
                        "latitude": "33.22603000",
                        "longitude": "-96.90786000"
                    },
                    {
                        "id": 126000,
                        "name": "Scenic Oaks",
                        "latitude": "29.71078000",
                        "longitude": "-98.67586000"
                    },
                    {
                        "id": 126006,
                        "name": "Schertz",
                        "latitude": "29.55217000",
                        "longitude": "-98.26973000"
                    },
                    {
                        "id": 126008,
                        "name": "Schleicher County",
                        "latitude": "30.89745000",
                        "longitude": "-100.53855000"
                    },
                    {
                        "id": 126020,
                        "name": "Schulenburg",
                        "latitude": "29.68190000",
                        "longitude": "-96.90304000"
                    },
                    {
                        "id": 126029,
                        "name": "Scissors",
                        "latitude": "26.13980000",
                        "longitude": "-98.05389000"
                    },
                    {
                        "id": 126069,
                        "name": "Scurry County",
                        "latitude": "32.74632000",
                        "longitude": "-100.91641000"
                    },
                    {
                        "id": 126079,
                        "name": "Seabrook",
                        "latitude": "29.56412000",
                        "longitude": "-95.02548000"
                    },
                    {
                        "id": 126084,
                        "name": "Seadrift",
                        "latitude": "28.41528000",
                        "longitude": "-96.71359000"
                    },
                    {
                        "id": 126088,
                        "name": "Seagoville",
                        "latitude": "32.63958000",
                        "longitude": "-96.53832000"
                    },
                    {
                        "id": 126089,
                        "name": "Seagraves",
                        "latitude": "32.94427000",
                        "longitude": "-102.56491000"
                    },
                    {
                        "id": 126091,
                        "name": "Sealy",
                        "latitude": "29.78079000",
                        "longitude": "-96.15718000"
                    },
                    {
                        "id": 126106,
                        "name": "Sebastian",
                        "latitude": "26.34285000",
                        "longitude": "-97.79027000"
                    },
                    {
                        "id": 126128,
                        "name": "Seguin",
                        "latitude": "29.56884000",
                        "longitude": "-97.96473000"
                    },
                    {
                        "id": 126140,
                        "name": "Selma",
                        "latitude": "29.58439000",
                        "longitude": "-98.30585000"
                    },
                    {
                        "id": 126146,
                        "name": "Seminole",
                        "latitude": "32.71899000",
                        "longitude": "-102.64491000"
                    },
                    {
                        "id": 126166,
                        "name": "Serenada",
                        "latitude": "30.69936000",
                        "longitude": "-97.69195000"
                    },
                    {
                        "id": 126170,
                        "name": "Seth Ward",
                        "latitude": "34.21174000",
                        "longitude": "-101.69017000"
                    },
                    {
                        "id": 126175,
                        "name": "Seven Points",
                        "latitude": "32.32042000",
                        "longitude": "-96.21303000"
                    },
                    {
                        "id": 126195,
                        "name": "Seymour",
                        "latitude": "33.59426000",
                        "longitude": "-99.26035000"
                    },
                    {
                        "id": 126199,
                        "name": "Shackelford County",
                        "latitude": "32.73597000",
                        "longitude": "-99.35407000"
                    },
                    {
                        "id": 126205,
                        "name": "Shady Hollow",
                        "latitude": "30.16493000",
                        "longitude": "-97.86223000"
                    },
                    {
                        "id": 126206,
                        "name": "Shady Shores",
                        "latitude": "33.16512000",
                        "longitude": "-97.02945000"
                    },
                    {
                        "id": 126213,
                        "name": "Shallowater",
                        "latitude": "33.68897000",
                        "longitude": "-101.99823000"
                    },
                    {
                        "id": 126216,
                        "name": "Shamrock",
                        "latitude": "35.21422000",
                        "longitude": "-100.24901000"
                    },
                    {
                        "id": 126242,
                        "name": "Shavano Park",
                        "latitude": "29.58495000",
                        "longitude": "-98.55252000"
                    },
                    {
                        "id": 126278,
                        "name": "Shelby County",
                        "latitude": "31.79241000",
                        "longitude": "-94.14502000"
                    },
                    {
                        "id": 126285,
                        "name": "Sheldon",
                        "latitude": "29.86800000",
                        "longitude": "-95.12826000"
                    },
                    {
                        "id": 126301,
                        "name": "Shenandoah",
                        "latitude": "30.18022000",
                        "longitude": "-95.45577000"
                    },
                    {
                        "id": 126309,
                        "name": "Shepherd",
                        "latitude": "30.49798000",
                        "longitude": "-94.99660000"
                    },
                    {
                        "id": 126330,
                        "name": "Sherman",
                        "latitude": "33.63566000",
                        "longitude": "-96.60888000"
                    },
                    {
                        "id": 126334,
                        "name": "Sherman County",
                        "latitude": "36.27771000",
                        "longitude": "-101.89348000"
                    },
                    {
                        "id": 126344,
                        "name": "Sherwood Shores",
                        "latitude": "33.85232000",
                        "longitude": "-96.81778000"
                    },
                    {
                        "id": 126350,
                        "name": "Shiner",
                        "latitude": "29.42913000",
                        "longitude": "-97.17054000"
                    },
                    {
                        "id": 126367,
                        "name": "Shoreacres",
                        "latitude": "29.62023000",
                        "longitude": "-95.00993000"
                    },
                    {
                        "id": 126400,
                        "name": "Sienna Plantation",
                        "latitude": "29.48607000",
                        "longitude": "-95.50800000"
                    },
                    {
                        "id": 126401,
                        "name": "Sierra Blanca",
                        "latitude": "31.17457000",
                        "longitude": "-105.35718000"
                    },
                    {
                        "id": 126408,
                        "name": "Siesta Acres",
                        "latitude": "28.75799000",
                        "longitude": "-100.49019000"
                    },
                    {
                        "id": 126410,
                        "name": "Siesta Shores",
                        "latitude": "26.85810000",
                        "longitude": "-99.25365000"
                    },
                    {
                        "id": 126418,
                        "name": "Silsbee",
                        "latitude": "30.34910000",
                        "longitude": "-94.17796000"
                    },
                    {
                        "id": 126443,
                        "name": "Silverton",
                        "latitude": "34.47423000",
                        "longitude": "-101.30461000"
                    },
                    {
                        "id": 126456,
                        "name": "Sinton",
                        "latitude": "28.03668000",
                        "longitude": "-97.50916000"
                    },
                    {
                        "id": 126493,
                        "name": "Slaton",
                        "latitude": "33.43731000",
                        "longitude": "-101.64349000"
                    },
                    {
                        "id": 126515,
                        "name": "Smith County",
                        "latitude": "32.37504000",
                        "longitude": "-95.26918000"
                    },
                    {
                        "id": 126529,
                        "name": "Smithville",
                        "latitude": "30.00855000",
                        "longitude": "-97.15943000"
                    },
                    {
                        "id": 126550,
                        "name": "Snyder",
                        "latitude": "32.71789000",
                        "longitude": "-100.91762000"
                    },
                    {
                        "id": 126558,
                        "name": "Socorro",
                        "latitude": "31.65456000",
                        "longitude": "-106.30331000"
                    },
                    {
                        "id": 126560,
                        "name": "Socorro Mission Number 1 Colonia",
                        "latitude": "31.63622000",
                        "longitude": "-106.29054000"
                    },
                    {
                        "id": 126581,
                        "name": "Somerset",
                        "latitude": "29.22635000",
                        "longitude": "-98.65780000"
                    },
                    {
                        "id": 126592,
                        "name": "Somervell County",
                        "latitude": "32.22229000",
                        "longitude": "-97.77434000"
                    },
                    {
                        "id": 126594,
                        "name": "Somerville",
                        "latitude": "30.34604000",
                        "longitude": "-96.52830000"
                    },
                    {
                        "id": 126601,
                        "name": "Sonora",
                        "latitude": "30.56685000",
                        "longitude": "-100.64343000"
                    },
                    {
                        "id": 126610,
                        "name": "Sour Lake",
                        "latitude": "30.14021000",
                        "longitude": "-94.41102000"
                    },
                    {
                        "id": 126611,
                        "name": "South Alamo",
                        "latitude": "26.15702000",
                        "longitude": "-98.10862000"
                    },
                    {
                        "id": 126676,
                        "name": "South Houston",
                        "latitude": "29.66301000",
                        "longitude": "-95.23549000"
                    },
                    {
                        "id": 126700,
                        "name": "South Padre Island",
                        "latitude": "26.10369000",
                        "longitude": "-97.16469000"
                    },
                    {
                        "id": 126712,
                        "name": "South Point",
                        "latitude": "25.86869000",
                        "longitude": "-97.38359000"
                    },
                    {
                        "id": 126777,
                        "name": "Southlake",
                        "latitude": "32.94124000",
                        "longitude": "-97.13418000"
                    },
                    {
                        "id": 126778,
                        "name": "Southmayd",
                        "latitude": "33.63038000",
                        "longitude": "-96.76916000"
                    },
                    {
                        "id": 126788,
                        "name": "Southside Place",
                        "latitude": "29.70606000",
                        "longitude": "-95.43688000"
                    },
                    {
                        "id": 126804,
                        "name": "Sparks",
                        "latitude": "31.67261000",
                        "longitude": "-106.23970000"
                    },
                    {
                        "id": 126817,
                        "name": "Spearman",
                        "latitude": "36.19837000",
                        "longitude": "-101.19238000"
                    },
                    {
                        "id": 126841,
                        "name": "Splendora",
                        "latitude": "30.23299000",
                        "longitude": "-95.16104000"
                    },
                    {
                        "id": 126849,
                        "name": "Spring",
                        "latitude": "30.07994000",
                        "longitude": "-95.41716000"
                    },
                    {
                        "id": 126874,
                        "name": "Spring Valley",
                        "latitude": "29.78967000",
                        "longitude": "-95.50355000"
                    },
                    {
                        "id": 126911,
                        "name": "Springtown",
                        "latitude": "32.96596000",
                        "longitude": "-97.68364000"
                    },
                    {
                        "id": 126921,
                        "name": "Spur",
                        "latitude": "33.47648000",
                        "longitude": "-100.85569000"
                    },
                    {
                        "id": 126932,
                        "name": "Stafford",
                        "latitude": "29.61607000",
                        "longitude": "-95.55772000"
                    },
                    {
                        "id": 126943,
                        "name": "Stamford",
                        "latitude": "32.94539000",
                        "longitude": "-99.80287000"
                    },
                    {
                        "id": 126971,
                        "name": "Stanton",
                        "latitude": "32.12929000",
                        "longitude": "-101.78846000"
                    },
                    {
                        "id": 126990,
                        "name": "Starr County",
                        "latitude": "26.56215000",
                        "longitude": "-98.73840000"
                    },
                    {
                        "id": 127023,
                        "name": "Stephens County",
                        "latitude": "32.73586000",
                        "longitude": "-98.83617000"
                    },
                    {
                        "id": 127025,
                        "name": "Stephenville",
                        "latitude": "32.22070000",
                        "longitude": "-98.20226000"
                    },
                    {
                        "id": 127032,
                        "name": "Sterling City",
                        "latitude": "31.83625000",
                        "longitude": "-100.98483000"
                    },
                    {
                        "id": 127033,
                        "name": "Sterling County",
                        "latitude": "31.82788000",
                        "longitude": "-101.05001000"
                    },
                    {
                        "id": 127065,
                        "name": "Stinnett",
                        "latitude": "35.82698000",
                        "longitude": "-101.44294000"
                    },
                    {
                        "id": 127070,
                        "name": "Stockdale",
                        "latitude": "29.23691000",
                        "longitude": "-97.96000000"
                    },
                    {
                        "id": 127093,
                        "name": "Stonewall County",
                        "latitude": "33.17912000",
                        "longitude": "-100.25331000"
                    },
                    {
                        "id": 127115,
                        "name": "Stowell",
                        "latitude": "29.78994000",
                        "longitude": "-94.38324000"
                    },
                    {
                        "id": 127128,
                        "name": "Stratford",
                        "latitude": "36.33614000",
                        "longitude": "-102.07212000"
                    },
                    {
                        "id": 127173,
                        "name": "Sugar Land",
                        "latitude": "29.61968000",
                        "longitude": "-95.63495000"
                    },
                    {
                        "id": 127185,
                        "name": "Sullivan City",
                        "latitude": "26.27757000",
                        "longitude": "-98.56363000"
                    },
                    {
                        "id": 127197,
                        "name": "Sulphur Springs",
                        "latitude": "33.13845000",
                        "longitude": "-95.60107000"
                    },
                    {
                        "id": 127250,
                        "name": "Sundown",
                        "latitude": "33.45621000",
                        "longitude": "-102.48936000"
                    },
                    {
                        "id": 127264,
                        "name": "Sunnyvale",
                        "latitude": "32.79652000",
                        "longitude": "-96.56082000"
                    },
                    {
                        "id": 127266,
                        "name": "Sunray",
                        "latitude": "36.01670000",
                        "longitude": "-101.82462000"
                    },
                    {
                        "id": 127315,
                        "name": "Sutton County",
                        "latitude": "30.49829000",
                        "longitude": "-100.53819000"
                    },
                    {
                        "id": 127335,
                        "name": "Sweeny",
                        "latitude": "29.03886000",
                        "longitude": "-95.69856000"
                    },
                    {
                        "id": 127342,
                        "name": "Sweetwater",
                        "latitude": "32.47095000",
                        "longitude": "-100.40594000"
                    },
                    {
                        "id": 127347,
                        "name": "Swisher County",
                        "latitude": "34.53039000",
                        "longitude": "-101.73503000"
                    },
                    {
                        "id": 127372,
                        "name": "Taft",
                        "latitude": "27.97891000",
                        "longitude": "-97.39860000"
                    },
                    {
                        "id": 127376,
                        "name": "Taft Southwest (historical)",
                        "latitude": "27.97391000",
                        "longitude": "-97.40305000"
                    },
                    {
                        "id": 127379,
                        "name": "Tahoka",
                        "latitude": "33.16676000",
                        "longitude": "-101.79377000"
                    },
                    {
                        "id": 127399,
                        "name": "Talty",
                        "latitude": "32.68319000",
                        "longitude": "-96.38554000"
                    },
                    {
                        "id": 127435,
                        "name": "Tarrant County",
                        "latitude": "32.77156000",
                        "longitude": "-97.29124000"
                    },
                    {
                        "id": 127440,
                        "name": "Tatum",
                        "latitude": "32.31599000",
                        "longitude": "-94.51659000"
                    },
                    {
                        "id": 127446,
                        "name": "Taylor",
                        "latitude": "30.57076000",
                        "longitude": "-97.40944000"
                    },
                    {
                        "id": 127454,
                        "name": "Taylor County",
                        "latitude": "32.30147000",
                        "longitude": "-99.89012000"
                    },
                    {
                        "id": 127459,
                        "name": "Taylor Lake Village",
                        "latitude": "29.57523000",
                        "longitude": "-95.05021000"
                    },
                    {
                        "id": 127474,
                        "name": "Teague",
                        "latitude": "31.62711000",
                        "longitude": "-96.28386000"
                    },
                    {
                        "id": 127498,
                        "name": "Temple",
                        "latitude": "31.09823000",
                        "longitude": "-97.34278000"
                    },
                    {
                        "id": 127508,
                        "name": "Tenaha",
                        "latitude": "31.94378000",
                        "longitude": "-94.24409000"
                    },
                    {
                        "id": 127526,
                        "name": "Terrell",
                        "latitude": "32.73596000",
                        "longitude": "-96.27526000"
                    },
                    {
                        "id": 127528,
                        "name": "Terrell County",
                        "latitude": "30.22496000",
                        "longitude": "-102.07649000"
                    },
                    {
                        "id": 127529,
                        "name": "Terrell Hills",
                        "latitude": "29.47495000",
                        "longitude": "-98.45085000"
                    },
                    {
                        "id": 127532,
                        "name": "Terry County",
                        "latitude": "33.17381000",
                        "longitude": "-102.33520000"
                    },
                    {
                        "id": 127545,
                        "name": "Texarkana",
                        "latitude": "33.42513000",
                        "longitude": "-94.04769000"
                    },
                    {
                        "id": 127546,
                        "name": "Texas City",
                        "latitude": "29.38385000",
                        "longitude": "-94.90270000"
                    },
                    {
                        "id": 127555,
                        "name": "The Colony",
                        "latitude": "33.08901000",
                        "longitude": "-96.88639000"
                    },
                    {
                        "id": 127561,
                        "name": "The Hills",
                        "latitude": "30.34798000",
                        "longitude": "-97.98501000"
                    },
                    {
                        "id": 127566,
                        "name": "The Woodlands",
                        "latitude": "30.15799000",
                        "longitude": "-95.48938000"
                    },
                    {
                        "id": 127600,
                        "name": "Thorndale",
                        "latitude": "30.61381000",
                        "longitude": "-97.20555000"
                    },
                    {
                        "id": 127617,
                        "name": "Three Rivers",
                        "latitude": "28.46027000",
                        "longitude": "-98.18251000"
                    },
                    {
                        "id": 127623,
                        "name": "Throckmorton",
                        "latitude": "33.17872000",
                        "longitude": "-99.17758000"
                    },
                    {
                        "id": 127624,
                        "name": "Throckmorton County",
                        "latitude": "33.17749000",
                        "longitude": "-99.21237000"
                    },
                    {
                        "id": 127646,
                        "name": "Tiki Island",
                        "latitude": "29.29709000",
                        "longitude": "-94.91709000"
                    },
                    {
                        "id": 127647,
                        "name": "Tilden",
                        "latitude": "28.46194000",
                        "longitude": "-98.54918000"
                    },
                    {
                        "id": 127661,
                        "name": "Timberwood Park",
                        "latitude": "29.70578000",
                        "longitude": "-98.47835000"
                    },
                    {
                        "id": 127664,
                        "name": "Timpson",
                        "latitude": "31.90378000",
                        "longitude": "-94.39520000"
                    },
                    {
                        "id": 127684,
                        "name": "Titus County",
                        "latitude": "33.21660000",
                        "longitude": "-94.96567000"
                    },
                    {
                        "id": 127706,
                        "name": "Tom Bean",
                        "latitude": "33.52011000",
                        "longitude": "-96.48387000"
                    },
                    {
                        "id": 127707,
                        "name": "Tom Green County",
                        "latitude": "31.40440000",
                        "longitude": "-100.46207000"
                    },
                    {
                        "id": 127710,
                        "name": "Tomball",
                        "latitude": "30.09716000",
                        "longitude": "-95.61605000"
                    },
                    {
                        "id": 127727,
                        "name": "Tool",
                        "latitude": "32.26792000",
                        "longitude": "-96.17025000"
                    },
                    {
                        "id": 127740,
                        "name": "Tornillo",
                        "latitude": "31.44540000",
                        "longitude": "-106.08831000"
                    },
                    {
                        "id": 127787,
                        "name": "Travis County",
                        "latitude": "30.33469000",
                        "longitude": "-97.78195000"
                    },
                    {
                        "id": 127788,
                        "name": "Travis Ranch",
                        "latitude": "32.80356000",
                        "longitude": "-96.47347000"
                    },
                    {
                        "id": 127827,
                        "name": "Trinity",
                        "latitude": "30.94519000",
                        "longitude": "-95.37550000"
                    },
                    {
                        "id": 127828,
                        "name": "Trinity County",
                        "latitude": "31.08882000",
                        "longitude": "-95.13551000"
                    },
                    {
                        "id": 127834,
                        "name": "Trophy Club",
                        "latitude": "32.99790000",
                        "longitude": "-97.18362000"
                    },
                    {
                        "id": 127835,
                        "name": "Troup",
                        "latitude": "32.14460000",
                        "longitude": "-95.12050000"
                    },
                    {
                        "id": 127846,
                        "name": "Troy",
                        "latitude": "31.20684000",
                        "longitude": "-97.30278000"
                    },
                    {
                        "id": 127885,
                        "name": "Tulia",
                        "latitude": "34.53589000",
                        "longitude": "-101.75852000"
                    },
                    {
                        "id": 127938,
                        "name": "Tye",
                        "latitude": "32.45762000",
                        "longitude": "-99.87148000"
                    },
                    {
                        "id": 127940,
                        "name": "Tyler",
                        "latitude": "32.35126000",
                        "longitude": "-95.30106000"
                    },
                    {
                        "id": 127942,
                        "name": "Tyler County",
                        "latitude": "30.77123000",
                        "longitude": "-94.37659000"
                    },
                    {
                        "id": 127954,
                        "name": "Uhland",
                        "latitude": "29.95772000",
                        "longitude": "-97.78611000"
                    },
                    {
                        "id": 128022,
                        "name": "Universal City",
                        "latitude": "29.54801000",
                        "longitude": "-98.29112000"
                    },
                    {
                        "id": 128033,
                        "name": "University Park",
                        "latitude": "32.85013000",
                        "longitude": "-96.80028000"
                    },
                    {
                        "id": 128052,
                        "name": "Upshur County",
                        "latitude": "32.73628000",
                        "longitude": "-94.94148000"
                    },
                    {
                        "id": 128057,
                        "name": "Upton County",
                        "latitude": "31.36873000",
                        "longitude": "-102.04304000"
                    },
                    {
                        "id": 128068,
                        "name": "Uvalde",
                        "latitude": "29.20968000",
                        "longitude": "-99.78617000"
                    },
                    {
                        "id": 128069,
                        "name": "Uvalde County",
                        "latitude": "29.35734000",
                        "longitude": "-99.76221000"
                    },
                    {
                        "id": 128070,
                        "name": "Uvalde Estates",
                        "latitude": "29.16524000",
                        "longitude": "-99.83228000"
                    },
                    {
                        "id": 128079,
                        "name": "Val Verde County",
                        "latitude": "29.89296000",
                        "longitude": "-101.15172000"
                    },
                    {
                        "id": 128080,
                        "name": "Val Verde Park",
                        "latitude": "29.37495000",
                        "longitude": "-100.83176000"
                    },
                    {
                        "id": 128113,
                        "name": "Valley Mills",
                        "latitude": "31.65933000",
                        "longitude": "-97.47224000"
                    },
                    {
                        "id": 128124,
                        "name": "Van",
                        "latitude": "32.52486000",
                        "longitude": "-95.63718000"
                    },
                    {
                        "id": 128125,
                        "name": "Van Alstyne",
                        "latitude": "33.42150000",
                        "longitude": "-96.57721000"
                    },
                    {
                        "id": 128133,
                        "name": "Van Horn",
                        "latitude": "31.04029000",
                        "longitude": "-104.83073000"
                    },
                    {
                        "id": 128138,
                        "name": "Van Vleck",
                        "latitude": "29.01775000",
                        "longitude": "-95.88940000"
                    },
                    {
                        "id": 128139,
                        "name": "Van Zandt County",
                        "latitude": "32.56372000",
                        "longitude": "-95.83651000"
                    },
                    {
                        "id": 128162,
                        "name": "Vega",
                        "latitude": "35.24283000",
                        "longitude": "-102.42826000"
                    },
                    {
                        "id": 128177,
                        "name": "Venus",
                        "latitude": "32.43347000",
                        "longitude": "-97.10251000"
                    },
                    {
                        "id": 128189,
                        "name": "Vernon",
                        "latitude": "34.15536000",
                        "longitude": "-99.26628000"
                    },
                    {
                        "id": 128220,
                        "name": "Victoria",
                        "latitude": "28.80527000",
                        "longitude": "-97.00360000"
                    },
                    {
                        "id": 128223,
                        "name": "Victoria County",
                        "latitude": "28.79635000",
                        "longitude": "-96.97153000"
                    },
                    {
                        "id": 128229,
                        "name": "Vidor",
                        "latitude": "30.13160000",
                        "longitude": "-94.01545000"
                    },
                    {
                        "id": 128282,
                        "name": "Vinton",
                        "latitude": "31.95121000",
                        "longitude": "-106.60249000"
                    },
                    {
                        "id": 128304,
                        "name": "Von Ormy",
                        "latitude": "29.28913000",
                        "longitude": "-98.64446000"
                    },
                    {
                        "id": 128316,
                        "name": "Waco",
                        "latitude": "31.54933000",
                        "longitude": "-97.14667000"
                    },
                    {
                        "id": 128358,
                        "name": "Wake Village",
                        "latitude": "33.42679000",
                        "longitude": "-94.10630000"
                    },
                    {
                        "id": 128388,
                        "name": "Walker County",
                        "latitude": "30.73905000",
                        "longitude": "-95.57228000"
                    },
                    {
                        "id": 128403,
                        "name": "Waller",
                        "latitude": "30.05661000",
                        "longitude": "-95.92690000"
                    },
                    {
                        "id": 128405,
                        "name": "Waller County",
                        "latitude": "30.01081000",
                        "longitude": "-95.98765000"
                    },
                    {
                        "id": 128409,
                        "name": "Wallis",
                        "latitude": "29.63135000",
                        "longitude": "-96.06524000"
                    },
                    {
                        "id": 128458,
                        "name": "Ward County",
                        "latitude": "31.50947000",
                        "longitude": "-103.10243000"
                    },
                    {
                        "id": 128566,
                        "name": "Washington County",
                        "latitude": "30.21453000",
                        "longitude": "-96.40344000"
                    },
                    {
                        "id": 128594,
                        "name": "Waskom",
                        "latitude": "32.47876000",
                        "longitude": "-94.05963000"
                    },
                    {
                        "id": 128595,
                        "name": "Watauga",
                        "latitude": "32.85791000",
                        "longitude": "-97.25474000"
                    },
                    {
                        "id": 128674,
                        "name": "Waxahachie",
                        "latitude": "32.38653000",
                        "longitude": "-96.84833000"
                    },
                    {
                        "id": 128718,
                        "name": "Weatherford",
                        "latitude": "32.75930000",
                        "longitude": "-97.79725000"
                    },
                    {
                        "id": 128726,
                        "name": "Webb County",
                        "latitude": "27.76106000",
                        "longitude": "-99.33157000"
                    },
                    {
                        "id": 128730,
                        "name": "Webster",
                        "latitude": "29.53773000",
                        "longitude": "-95.11826000"
                    },
                    {
                        "id": 128758,
                        "name": "Weimar",
                        "latitude": "29.70301000",
                        "longitude": "-96.78053000"
                    },
                    {
                        "id": 128780,
                        "name": "Wellington",
                        "latitude": "34.85617000",
                        "longitude": "-100.21373000"
                    },
                    {
                        "id": 128785,
                        "name": "Wells Branch",
                        "latitude": "30.44604000",
                        "longitude": "-97.67945000"
                    },
                    {
                        "id": 128808,
                        "name": "Weslaco",
                        "latitude": "26.15952000",
                        "longitude": "-97.99084000"
                    },
                    {
                        "id": 128815,
                        "name": "West",
                        "latitude": "31.80238000",
                        "longitude": "-97.09167000"
                    },
                    {
                        "id": 128849,
                        "name": "West Columbia",
                        "latitude": "29.14386000",
                        "longitude": "-95.64522000"
                    },
                    {
                        "id": 128909,
                        "name": "West Lake Hills",
                        "latitude": "30.29798000",
                        "longitude": "-97.80195000"
                    },
                    {
                        "id": 128921,
                        "name": "West Livingston",
                        "latitude": "30.69825000",
                        "longitude": "-95.00188000"
                    },
                    {
                        "id": 128944,
                        "name": "West Odessa",
                        "latitude": "31.84235000",
                        "longitude": "-102.49876000"
                    },
                    {
                        "id": 128945,
                        "name": "West Orange",
                        "latitude": "30.08215000",
                        "longitude": "-93.75822000"
                    },
                    {
                        "id": 128980,
                        "name": "West Sharyland",
                        "latitude": "26.27257000",
                        "longitude": "-98.32863000"
                    },
                    {
                        "id": 128988,
                        "name": "West Tawakoni",
                        "latitude": "32.89373000",
                        "longitude": "-96.02941000"
                    },
                    {
                        "id": 128995,
                        "name": "West University Place",
                        "latitude": "29.71801000",
                        "longitude": "-95.43383000"
                    },
                    {
                        "id": 129024,
                        "name": "Western Lake",
                        "latitude": "32.62338000",
                        "longitude": "-97.81155000"
                    },
                    {
                        "id": 129039,
                        "name": "Westlake",
                        "latitude": "32.99124000",
                        "longitude": "-97.19501000"
                    },
                    {
                        "id": 129065,
                        "name": "Weston Lakes",
                        "latitude": "29.68324000",
                        "longitude": "-95.93571000"
                    },
                    {
                        "id": 129080,
                        "name": "Westway",
                        "latitude": "31.95871000",
                        "longitude": "-106.57805000"
                    },
                    {
                        "id": 129089,
                        "name": "Westworth",
                        "latitude": "32.75735000",
                        "longitude": "-97.41085000"
                    },
                    {
                        "id": 129102,
                        "name": "Wharton",
                        "latitude": "29.31164000",
                        "longitude": "-96.10274000"
                    },
                    {
                        "id": 129104,
                        "name": "Wharton County",
                        "latitude": "29.27786000",
                        "longitude": "-96.22210000"
                    },
                    {
                        "id": 129115,
                        "name": "Wheeler",
                        "latitude": "35.44533000",
                        "longitude": "-100.27096000"
                    },
                    {
                        "id": 129118,
                        "name": "Wheeler County",
                        "latitude": "35.40128000",
                        "longitude": "-100.26965000"
                    },
                    {
                        "id": 129149,
                        "name": "White Oak",
                        "latitude": "32.52792000",
                        "longitude": "-94.86133000"
                    },
                    {
                        "id": 129161,
                        "name": "White Settlement",
                        "latitude": "32.75957000",
                        "longitude": "-97.45835000"
                    },
                    {
                        "id": 129174,
                        "name": "Whitehouse",
                        "latitude": "32.22682000",
                        "longitude": "-95.22550000"
                    },
                    {
                        "id": 129182,
                        "name": "Whitesboro",
                        "latitude": "33.65622000",
                        "longitude": "-96.90695000"
                    },
                    {
                        "id": 129192,
                        "name": "Whitewright",
                        "latitude": "33.51289000",
                        "longitude": "-96.39248000"
                    },
                    {
                        "id": 129208,
                        "name": "Whitney",
                        "latitude": "31.95182000",
                        "longitude": "-97.32140000"
                    },
                    {
                        "id": 129216,
                        "name": "Wichita County",
                        "latitude": "33.98798000",
                        "longitude": "-98.70361000"
                    },
                    {
                        "id": 129218,
                        "name": "Wichita Falls",
                        "latitude": "33.91371000",
                        "longitude": "-98.49339000"
                    },
                    {
                        "id": 129224,
                        "name": "Wilbarger County",
                        "latitude": "34.08072000",
                        "longitude": "-99.24108000"
                    },
                    {
                        "id": 129230,
                        "name": "Wild Peach Village",
                        "latitude": "29.08358000",
                        "longitude": "-95.63384000"
                    },
                    {
                        "id": 129240,
                        "name": "Wildwood",
                        "latitude": "30.52409000",
                        "longitude": "-94.44158000"
                    },
                    {
                        "id": 129255,
                        "name": "Willacy County",
                        "latitude": "26.47701000",
                        "longitude": "-97.59182000"
                    },
                    {
                        "id": 129278,
                        "name": "Williamson County",
                        "latitude": "30.64804000",
                        "longitude": "-97.60076000"
                    },
                    {
                        "id": 129295,
                        "name": "Willis",
                        "latitude": "30.42493000",
                        "longitude": "-95.47994000"
                    },
                    {
                        "id": 129308,
                        "name": "Willow Park",
                        "latitude": "32.76263000",
                        "longitude": "-97.65058000"
                    },
                    {
                        "id": 129317,
                        "name": "Wills Point",
                        "latitude": "32.70930000",
                        "longitude": "-96.00830000"
                    },
                    {
                        "id": 129318,
                        "name": "Wilmer",
                        "latitude": "32.58902000",
                        "longitude": "-96.68527000"
                    },
                    {
                        "id": 129337,
                        "name": "Wilson County",
                        "latitude": "29.17401000",
                        "longitude": "-98.08657000"
                    },
                    {
                        "id": 129349,
                        "name": "Wimberley",
                        "latitude": "29.99744000",
                        "longitude": "-98.09862000"
                    },
                    {
                        "id": 129367,
                        "name": "Windcrest",
                        "latitude": "29.51551000",
                        "longitude": "-98.38029000"
                    },
                    {
                        "id": 129368,
                        "name": "Windemere",
                        "latitude": "30.45909000",
                        "longitude": "-97.64917000"
                    },
                    {
                        "id": 129401,
                        "name": "Wink",
                        "latitude": "31.75124000",
                        "longitude": "-103.15989000"
                    },
                    {
                        "id": 129402,
                        "name": "Winkler County",
                        "latitude": "31.85005000",
                        "longitude": "-103.04817000"
                    },
                    {
                        "id": 129417,
                        "name": "Winnie",
                        "latitude": "29.82022000",
                        "longitude": "-94.38408000"
                    },
                    {
                        "id": 129420,
                        "name": "Winnsboro",
                        "latitude": "32.95734000",
                        "longitude": "-95.29022000"
                    },
                    {
                        "id": 129444,
                        "name": "Winters",
                        "latitude": "31.95653000",
                        "longitude": "-99.96231000"
                    },
                    {
                        "id": 129460,
                        "name": "Wise County",
                        "latitude": "33.21590000",
                        "longitude": "-97.65445000"
                    },
                    {
                        "id": 129476,
                        "name": "Wolfe City",
                        "latitude": "33.37067000",
                        "longitude": "-96.06886000"
                    },
                    {
                        "id": 129479,
                        "name": "Wolfforth",
                        "latitude": "33.50592000",
                        "longitude": "-102.00906000"
                    },
                    {
                        "id": 129484,
                        "name": "Wood County",
                        "latitude": "32.78641000",
                        "longitude": "-95.38206000"
                    },
                    {
                        "id": 129498,
                        "name": "Woodbranch",
                        "latitude": "30.18105000",
                        "longitude": "-95.18882000"
                    },
                    {
                        "id": 129515,
                        "name": "Woodcreek",
                        "latitude": "30.02827000",
                        "longitude": "-98.11112000"
                    },
                    {
                        "id": 129553,
                        "name": "Woodsboro",
                        "latitude": "28.23834000",
                        "longitude": "-97.31999000"
                    },
                    {
                        "id": 129572,
                        "name": "Woodville",
                        "latitude": "30.77520000",
                        "longitude": "-94.41548000"
                    },
                    {
                        "id": 129578,
                        "name": "Woodway",
                        "latitude": "31.50600000",
                        "longitude": "-97.20501000"
                    },
                    {
                        "id": 129595,
                        "name": "Wortham",
                        "latitude": "31.78794000",
                        "longitude": "-96.46248000"
                    },
                    {
                        "id": 129625,
                        "name": "Wyldwood",
                        "latitude": "30.12938000",
                        "longitude": "-97.47277000"
                    },
                    {
                        "id": 129626,
                        "name": "Wylie",
                        "latitude": "33.01512000",
                        "longitude": "-96.53888000"
                    },
                    {
                        "id": 129683,
                        "name": "Yoakum",
                        "latitude": "29.28775000",
                        "longitude": "-97.15193000"
                    },
                    {
                        "id": 129684,
                        "name": "Yoakum County",
                        "latitude": "33.17297000",
                        "longitude": "-102.82780000"
                    },
                    {
                        "id": 129706,
                        "name": "Yorktown",
                        "latitude": "28.98109000",
                        "longitude": "-97.50277000"
                    },
                    {
                        "id": 129714,
                        "name": "Young County",
                        "latitude": "33.17670000",
                        "longitude": "-98.68777000"
                    },
                    {
                        "id": 129739,
                        "name": "Zapata",
                        "latitude": "26.90726000",
                        "longitude": "-99.27143000"
                    },
                    {
                        "id": 129740,
                        "name": "Zapata County",
                        "latitude": "27.00078000",
                        "longitude": "-99.16861000"
                    },
                    {
                        "id": 129741,
                        "name": "Zavala County",
                        "latitude": "28.86621000",
                        "longitude": "-99.76060000"
                    }
                ]
            },
            {
                "id": 1432,
                "name": "United States Minor Outlying Islands",
                "iso2": "UM",
                "latitude": "19.28231920",
                "longitude": "166.64704700",
                "type": "outlying area",
                "cities": []
            },
            {
                "id": 1413,
                "name": "United States Virgin Islands",
                "iso2": "VI",
                "latitude": "18.33576500",
                "longitude": "-64.89633500",
                "type": "outlying area",
                "cities": []
            },
            {
                "id": 1414,
                "name": "Utah",
                "iso2": "UT",
                "latitude": "39.32098010",
                "longitude": "-111.09373110",
                "type": "state",
                "cities": [
                    {
                        "id": 111225,
                        "name": "Alpine",
                        "latitude": "40.45328000",
                        "longitude": "-111.77799000"
                    },
                    {
                        "id": 111273,
                        "name": "American Fork",
                        "latitude": "40.37690000",
                        "longitude": "-111.79576000"
                    },
                    {
                        "id": 111663,
                        "name": "Aurora",
                        "latitude": "38.92219000",
                        "longitude": "-111.93409000"
                    },
                    {
                        "id": 111770,
                        "name": "Ballard",
                        "latitude": "40.28940000",
                        "longitude": "-109.94320000"
                    },
                    {
                        "id": 111995,
                        "name": "Beaver",
                        "latitude": "38.27691000",
                        "longitude": "-112.64105000"
                    },
                    {
                        "id": 111999,
                        "name": "Beaver County",
                        "latitude": "38.35771000",
                        "longitude": "-113.23576000"
                    },
                    {
                        "id": 112170,
                        "name": "Benjamin",
                        "latitude": "40.09829000",
                        "longitude": "-111.73132000"
                    },
                    {
                        "id": 112185,
                        "name": "Benson",
                        "latitude": "41.78743000",
                        "longitude": "-111.93022000"
                    },
                    {
                        "id": 112422,
                        "name": "Blanding",
                        "latitude": "37.62433000",
                        "longitude": "-109.47966000"
                    },
                    {
                        "id": 112482,
                        "name": "Bluffdale",
                        "latitude": "40.48967000",
                        "longitude": "-111.93882000"
                    },
                    {
                        "id": 112610,
                        "name": "Bountiful",
                        "latitude": "40.88939000",
                        "longitude": "-111.88077000"
                    },
                    {
                        "id": 112637,
                        "name": "Box Elder County",
                        "latitude": "41.52097000",
                        "longitude": "-113.08209000"
                    },
                    {
                        "id": 112784,
                        "name": "Brigham City",
                        "latitude": "41.51021000",
                        "longitude": "-112.01550000"
                    },
                    {
                        "id": 113156,
                        "name": "Cache County",
                        "latitude": "41.72237000",
                        "longitude": "-111.74356000"
                    },
                    {
                        "id": 113360,
                        "name": "Canyon Rim",
                        "latitude": "40.70661000",
                        "longitude": "-111.82188000"
                    },
                    {
                        "id": 113383,
                        "name": "Carbon County",
                        "latitude": "39.64817000",
                        "longitude": "-110.58898000"
                    },
                    {
                        "id": 113391,
                        "name": "Carbonville",
                        "latitude": "39.61996000",
                        "longitude": "-110.83433000"
                    },
                    {
                        "id": 113543,
                        "name": "Castle Dale",
                        "latitude": "39.21219000",
                        "longitude": "-111.01961000"
                    },
                    {
                        "id": 113603,
                        "name": "Cedar City",
                        "latitude": "37.67748000",
                        "longitude": "-113.06189000"
                    },
                    {
                        "id": 113616,
                        "name": "Cedar Hills",
                        "latitude": "40.41412000",
                        "longitude": "-111.75854000"
                    },
                    {
                        "id": 113649,
                        "name": "Centerfield",
                        "latitude": "39.12524000",
                        "longitude": "-111.81909000"
                    },
                    {
                        "id": 113662,
                        "name": "Centerville",
                        "latitude": "40.91800000",
                        "longitude": "-111.87216000"
                    },
                    {
                        "id": 114217,
                        "name": "Clearfield",
                        "latitude": "41.11078000",
                        "longitude": "-112.02605000"
                    },
                    {
                        "id": 114288,
                        "name": "Clinton",
                        "latitude": "41.13967000",
                        "longitude": "-112.05050000"
                    },
                    {
                        "id": 114339,
                        "name": "Coalville",
                        "latitude": "40.91773000",
                        "longitude": "-111.39936000"
                    },
                    {
                        "id": 114705,
                        "name": "Cottonwood Heights",
                        "latitude": "40.61967000",
                        "longitude": "-111.81021000"
                    },
                    {
                        "id": 114969,
                        "name": "Daggett County",
                        "latitude": "40.88727000",
                        "longitude": "-109.50765000"
                    },
                    {
                        "id": 115022,
                        "name": "Daniel",
                        "latitude": "40.47079000",
                        "longitude": "-111.41463000"
                    },
                    {
                        "id": 115075,
                        "name": "Davis County",
                        "latitude": "40.99061000",
                        "longitude": "-112.11124000"
                    },
                    {
                        "id": 115223,
                        "name": "Delta",
                        "latitude": "39.35218000",
                        "longitude": "-112.57717000"
                    },
                    {
                        "id": 115469,
                        "name": "Draper",
                        "latitude": "40.52467000",
                        "longitude": "-111.86382000"
                    },
                    {
                        "id": 115502,
                        "name": "Duchesne",
                        "latitude": "40.16329000",
                        "longitude": "-110.40293000"
                    },
                    {
                        "id": 115503,
                        "name": "Duchesne County",
                        "latitude": "40.29751000",
                        "longitude": "-110.42476000"
                    },
                    {
                        "id": 115607,
                        "name": "Eagle Mountain",
                        "latitude": "40.31412000",
                        "longitude": "-112.00688000"
                    },
                    {
                        "id": 115642,
                        "name": "East Carbon City",
                        "latitude": "39.54774000",
                        "longitude": "-110.41488000"
                    },
                    {
                        "id": 115712,
                        "name": "East Millcreek",
                        "latitude": "40.69995000",
                        "longitude": "-111.81049000"
                    },
                    {
                        "id": 115992,
                        "name": "Elk Ridge",
                        "latitude": "40.01134000",
                        "longitude": "-111.67687000"
                    },
                    {
                        "id": 116083,
                        "name": "Elwood",
                        "latitude": "41.69048000",
                        "longitude": "-112.14106000"
                    },
                    {
                        "id": 116096,
                        "name": "Emery County",
                        "latitude": "38.99677000",
                        "longitude": "-110.70067000"
                    },
                    {
                        "id": 116142,
                        "name": "Enoch",
                        "latitude": "37.77331000",
                        "longitude": "-113.02439000"
                    },
                    {
                        "id": 116151,
                        "name": "Enterprise",
                        "latitude": "37.57359000",
                        "longitude": "-113.71913000"
                    },
                    {
                        "id": 116154,
                        "name": "Ephraim",
                        "latitude": "39.35968000",
                        "longitude": "-111.58631000"
                    },
                    {
                        "id": 116162,
                        "name": "Erda",
                        "latitude": "40.61272000",
                        "longitude": "-112.30439000"
                    },
                    {
                        "id": 116357,
                        "name": "Fairview",
                        "latitude": "39.62635000",
                        "longitude": "-111.43963000"
                    },
                    {
                        "id": 116422,
                        "name": "Farmington",
                        "latitude": "40.98050000",
                        "longitude": "-111.88744000"
                    },
                    {
                        "id": 116428,
                        "name": "Farr West",
                        "latitude": "41.29717000",
                        "longitude": "-112.02772000"
                    },
                    {
                        "id": 116496,
                        "name": "Ferron",
                        "latitude": "39.09358000",
                        "longitude": "-111.13322000"
                    },
                    {
                        "id": 116509,
                        "name": "Fillmore",
                        "latitude": "38.96885000",
                        "longitude": "-112.32355000"
                    },
                    {
                        "id": 116780,
                        "name": "Fountain Green",
                        "latitude": "39.62996000",
                        "longitude": "-111.63520000"
                    },
                    {
                        "id": 116814,
                        "name": "Francis",
                        "latitude": "40.61051000",
                        "longitude": "-111.28074000"
                    },
                    {
                        "id": 116967,
                        "name": "Fruit Heights",
                        "latitude": "41.03217000",
                        "longitude": "-111.90216000"
                    },
                    {
                        "id": 117085,
                        "name": "Garfield County",
                        "latitude": "37.85492000",
                        "longitude": "-111.44313000"
                    },
                    {
                        "id": 117090,
                        "name": "Garland",
                        "latitude": "41.74104000",
                        "longitude": "-112.16162000"
                    },
                    {
                        "id": 117149,
                        "name": "Genola",
                        "latitude": "39.99634000",
                        "longitude": "-111.84327000"
                    },
                    {
                        "id": 117455,
                        "name": "Grand County",
                        "latitude": "38.98174000",
                        "longitude": "-109.56971000"
                    },
                    {
                        "id": 117492,
                        "name": "Granite",
                        "latitude": "40.57300000",
                        "longitude": "-111.80604000"
                    },
                    {
                        "id": 117531,
                        "name": "Grantsville",
                        "latitude": "40.59994000",
                        "longitude": "-112.46440000"
                    },
                    {
                        "id": 117803,
                        "name": "Gunnison",
                        "latitude": "39.15524000",
                        "longitude": "-111.81826000"
                    },
                    {
                        "id": 118077,
                        "name": "Harrisville",
                        "latitude": "41.28133000",
                        "longitude": "-111.98828000"
                    },
                    {
                        "id": 118229,
                        "name": "Heber City",
                        "latitude": "40.50690000",
                        "longitude": "-111.41324000"
                    },
                    {
                        "id": 118262,
                        "name": "Helper",
                        "latitude": "39.68413000",
                        "longitude": "-110.85461000"
                    },
                    {
                        "id": 118338,
                        "name": "Herriman",
                        "latitude": "40.51411000",
                        "longitude": "-112.03299000"
                    },
                    {
                        "id": 118400,
                        "name": "Highland",
                        "latitude": "40.42548000",
                        "longitude": "-111.79447000"
                    },
                    {
                        "id": 118429,
                        "name": "Hildale",
                        "latitude": "37.00360000",
                        "longitude": "-112.96688000"
                    },
                    {
                        "id": 118433,
                        "name": "Hill Air Force Base",
                        "latitude": "41.11118000",
                        "longitude": "-111.97712000"
                    },
                    {
                        "id": 118536,
                        "name": "Holladay",
                        "latitude": "40.66884000",
                        "longitude": "-111.82466000"
                    },
                    {
                        "id": 118621,
                        "name": "Honeyville",
                        "latitude": "41.63854000",
                        "longitude": "-112.07939000"
                    },
                    {
                        "id": 118633,
                        "name": "Hooper",
                        "latitude": "41.16383000",
                        "longitude": "-112.12244000"
                    },
                    {
                        "id": 118803,
                        "name": "Huntington",
                        "latitude": "39.32664000",
                        "longitude": "-110.96461000"
                    },
                    {
                        "id": 118828,
                        "name": "Hurricane",
                        "latitude": "37.17526000",
                        "longitude": "-113.28995000"
                    },
                    {
                        "id": 118853,
                        "name": "Hyde Park",
                        "latitude": "41.79882000",
                        "longitude": "-111.81911000"
                    },
                    {
                        "id": 118857,
                        "name": "Hyrum",
                        "latitude": "41.63410000",
                        "longitude": "-111.85217000"
                    },
                    {
                        "id": 118991,
                        "name": "Iron County",
                        "latitude": "37.85917000",
                        "longitude": "-113.28927000"
                    },
                    {
                        "id": 119051,
                        "name": "Ivins",
                        "latitude": "37.16859000",
                        "longitude": "-113.67941000"
                    },
                    {
                        "id": 119325,
                        "name": "Juab County",
                        "latitude": "39.70262000",
                        "longitude": "-112.78477000"
                    },
                    {
                        "id": 119332,
                        "name": "Junction",
                        "latitude": "38.23748000",
                        "longitude": "-112.21993000"
                    },
                    {
                        "id": 119370,
                        "name": "Kamas",
                        "latitude": "40.64301000",
                        "longitude": "-111.28074000"
                    },
                    {
                        "id": 119372,
                        "name": "Kanab",
                        "latitude": "37.04749000",
                        "longitude": "-112.52631000"
                    },
                    {
                        "id": 119378,
                        "name": "Kane County",
                        "latitude": "37.28507000",
                        "longitude": "-111.88785000"
                    },
                    {
                        "id": 119403,
                        "name": "Kaysville",
                        "latitude": "41.03522000",
                        "longitude": "-111.93855000"
                    },
                    {
                        "id": 119411,
                        "name": "Kearns",
                        "latitude": "40.65995000",
                        "longitude": "-111.99633000"
                    },
                    {
                        "id": 119807,
                        "name": "LaVerkin",
                        "latitude": "37.20109000",
                        "longitude": "-113.26967000"
                    },
                    {
                        "id": 120254,
                        "name": "Layton",
                        "latitude": "41.06022000",
                        "longitude": "-111.97105000"
                    },
                    {
                        "id": 120333,
                        "name": "Lehi",
                        "latitude": "40.39162000",
                        "longitude": "-111.85077000"
                    },
                    {
                        "id": 120429,
                        "name": "Lewiston",
                        "latitude": "41.97576000",
                        "longitude": "-111.85634000"
                    },
                    {
                        "id": 120468,
                        "name": "Liberty",
                        "latitude": "41.33355000",
                        "longitude": "-111.86355000"
                    },
                    {
                        "id": 120571,
                        "name": "Lindon",
                        "latitude": "40.34329000",
                        "longitude": "-111.72076000"
                    },
                    {
                        "id": 120615,
                        "name": "Little Cottonwood Creek Valley",
                        "latitude": "40.60439000",
                        "longitude": "-111.82938000"
                    },
                    {
                        "id": 120668,
                        "name": "Loa",
                        "latitude": "38.40276000",
                        "longitude": "-111.64296000"
                    },
                    {
                        "id": 120695,
                        "name": "Logan",
                        "latitude": "41.73549000",
                        "longitude": "-111.83439000"
                    },
                    {
                        "id": 121030,
                        "name": "Maeser",
                        "latitude": "40.47718000",
                        "longitude": "-109.58681000"
                    },
                    {
                        "id": 121034,
                        "name": "Magna",
                        "latitude": "40.70911000",
                        "longitude": "-112.10161000"
                    },
                    {
                        "id": 121120,
                        "name": "Manila",
                        "latitude": "40.98801000",
                        "longitude": "-109.72265000"
                    },
                    {
                        "id": 121157,
                        "name": "Manti",
                        "latitude": "39.26830000",
                        "longitude": "-111.63686000"
                    },
                    {
                        "id": 121176,
                        "name": "Mapleton",
                        "latitude": "40.13023000",
                        "longitude": "-111.57853000"
                    },
                    {
                        "id": 121297,
                        "name": "Marriott-Slaterville",
                        "latitude": "41.25161000",
                        "longitude": "-112.02550000"
                    },
                    {
                        "id": 121655,
                        "name": "Mendon",
                        "latitude": "41.70993000",
                        "longitude": "-111.97773000"
                    },
                    {
                        "id": 121811,
                        "name": "Midvale",
                        "latitude": "40.61106000",
                        "longitude": "-111.89994000"
                    },
                    {
                        "id": 121819,
                        "name": "Midway",
                        "latitude": "40.51218000",
                        "longitude": "-111.47435000"
                    },
                    {
                        "id": 121859,
                        "name": "Milford",
                        "latitude": "38.39691000",
                        "longitude": "-113.01079000"
                    },
                    {
                        "id": 121869,
                        "name": "Millard County",
                        "latitude": "39.07381000",
                        "longitude": "-113.10046000"
                    },
                    {
                        "id": 121875,
                        "name": "Millcreek",
                        "latitude": "40.68689000",
                        "longitude": "-111.87549000"
                    },
                    {
                        "id": 121906,
                        "name": "Millville",
                        "latitude": "41.68160000",
                        "longitude": "-111.82300000"
                    },
                    {
                        "id": 122006,
                        "name": "Moab",
                        "latitude": "38.57332000",
                        "longitude": "-109.54984000"
                    },
                    {
                        "id": 122031,
                        "name": "Mona",
                        "latitude": "39.81607000",
                        "longitude": "-111.85549000"
                    },
                    {
                        "id": 122064,
                        "name": "Monroe",
                        "latitude": "38.62997000",
                        "longitude": "-112.12076000"
                    },
                    {
                        "id": 122171,
                        "name": "Monticello",
                        "latitude": "37.87138000",
                        "longitude": "-109.34289000"
                    },
                    {
                        "id": 122234,
                        "name": "Morgan",
                        "latitude": "41.03606000",
                        "longitude": "-111.67688000"
                    },
                    {
                        "id": 122245,
                        "name": "Morgan County",
                        "latitude": "41.08932000",
                        "longitude": "-111.57312000"
                    },
                    {
                        "id": 122262,
                        "name": "Moroni",
                        "latitude": "39.52496000",
                        "longitude": "-111.59047000"
                    },
                    {
                        "id": 122372,
                        "name": "Mount Olympus",
                        "latitude": "40.68550000",
                        "longitude": "-111.78854000"
                    },
                    {
                        "id": 122381,
                        "name": "Mount Pleasant",
                        "latitude": "39.54691000",
                        "longitude": "-111.45547000"
                    },
                    {
                        "id": 122413,
                        "name": "Mountain Green",
                        "latitude": "41.14300000",
                        "longitude": "-111.79160000"
                    },
                    {
                        "id": 122492,
                        "name": "Murray",
                        "latitude": "40.66689000",
                        "longitude": "-111.88799000"
                    },
                    {
                        "id": 122555,
                        "name": "Naples",
                        "latitude": "40.42691000",
                        "longitude": "-109.49930000"
                    },
                    {
                        "id": 122635,
                        "name": "Nephi",
                        "latitude": "39.71023000",
                        "longitude": "-111.83632000"
                    },
                    {
                        "id": 122884,
                        "name": "Nibley",
                        "latitude": "41.67438000",
                        "longitude": "-111.83300000"
                    },
                    {
                        "id": 123060,
                        "name": "North Logan",
                        "latitude": "41.76937000",
                        "longitude": "-111.80467000"
                    },
                    {
                        "id": 123074,
                        "name": "North Ogden",
                        "latitude": "41.30716000",
                        "longitude": "-111.96022000"
                    },
                    {
                        "id": 123099,
                        "name": "North Salt Lake",
                        "latitude": "40.84856000",
                        "longitude": "-111.90688000"
                    },
                    {
                        "id": 123300,
                        "name": "Oakley",
                        "latitude": "40.71467000",
                        "longitude": "-111.30074000"
                    },
                    {
                        "id": 123369,
                        "name": "Ogden",
                        "latitude": "41.22300000",
                        "longitude": "-111.97383000"
                    },
                    {
                        "id": 123501,
                        "name": "Oquirrh",
                        "latitude": "40.63050000",
                        "longitude": "-112.03383000"
                    },
                    {
                        "id": 123531,
                        "name": "Orangeville",
                        "latitude": "39.22719000",
                        "longitude": "-111.05350000"
                    },
                    {
                        "id": 123551,
                        "name": "Orem",
                        "latitude": "40.29690000",
                        "longitude": "-111.69465000"
                    },
                    {
                        "id": 123800,
                        "name": "Panguitch",
                        "latitude": "37.82276000",
                        "longitude": "-112.43576000"
                    },
                    {
                        "id": 123840,
                        "name": "Park City",
                        "latitude": "40.64606000",
                        "longitude": "-111.49797000"
                    },
                    {
                        "id": 123888,
                        "name": "Parowan",
                        "latitude": "37.84220000",
                        "longitude": "-112.82800000"
                    },
                    {
                        "id": 123950,
                        "name": "Payson",
                        "latitude": "40.04440000",
                        "longitude": "-111.73215000"
                    },
                    {
                        "id": 124073,
                        "name": "Perry",
                        "latitude": "41.46494000",
                        "longitude": "-112.03245000"
                    },
                    {
                        "id": 124307,
                        "name": "Piute County",
                        "latitude": "38.33645000",
                        "longitude": "-112.12695000"
                    },
                    {
                        "id": 124315,
                        "name": "Plain City",
                        "latitude": "41.29800000",
                        "longitude": "-112.08605000"
                    },
                    {
                        "id": 124367,
                        "name": "Pleasant Grove",
                        "latitude": "40.36412000",
                        "longitude": "-111.73854000"
                    },
                    {
                        "id": 124381,
                        "name": "Pleasant View",
                        "latitude": "41.31828000",
                        "longitude": "-111.99216000"
                    },
                    {
                        "id": 124663,
                        "name": "Price",
                        "latitude": "39.59941000",
                        "longitude": "-110.81071000"
                    },
                    {
                        "id": 124717,
                        "name": "Providence",
                        "latitude": "41.70632000",
                        "longitude": "-111.81717000"
                    },
                    {
                        "id": 124721,
                        "name": "Provo",
                        "latitude": "40.23384000",
                        "longitude": "-111.65853000"
                    },
                    {
                        "id": 124870,
                        "name": "Randolph",
                        "latitude": "41.66578000",
                        "longitude": "-111.18214000"
                    },
                    {
                        "id": 125056,
                        "name": "Rich County",
                        "latitude": "41.63232000",
                        "longitude": "-111.24445000"
                    },
                    {
                        "id": 125063,
                        "name": "Richfield",
                        "latitude": "38.77247000",
                        "longitude": "-112.08409000"
                    },
                    {
                        "id": 125097,
                        "name": "Richmond",
                        "latitude": "41.92271000",
                        "longitude": "-111.81356000"
                    },
                    {
                        "id": 125181,
                        "name": "River Heights",
                        "latitude": "41.72160000",
                        "longitude": "-111.82133000"
                    },
                    {
                        "id": 125197,
                        "name": "Riverdale",
                        "latitude": "41.17689000",
                        "longitude": "-112.00383000"
                    },
                    {
                        "id": 125215,
                        "name": "Riverton",
                        "latitude": "40.52189000",
                        "longitude": "-111.93910000"
                    },
                    {
                        "id": 125392,
                        "name": "Roosevelt",
                        "latitude": "40.29940000",
                        "longitude": "-109.98876000"
                    },
                    {
                        "id": 125487,
                        "name": "Roy",
                        "latitude": "41.16161000",
                        "longitude": "-112.02633000"
                    },
                    {
                        "id": 125644,
                        "name": "Saint George",
                        "latitude": "37.10415000",
                        "longitude": "-113.58412000"
                    },
                    {
                        "id": 125739,
                        "name": "Salem",
                        "latitude": "40.05301000",
                        "longitude": "-111.67354000"
                    },
                    {
                        "id": 125746,
                        "name": "Salina",
                        "latitude": "38.95774000",
                        "longitude": "-111.85993000"
                    },
                    {
                        "id": 125767,
                        "name": "Salt Lake City",
                        "latitude": "40.76078000",
                        "longitude": "-111.89105000"
                    },
                    {
                        "id": 125768,
                        "name": "Salt Lake County",
                        "latitude": "40.66758000",
                        "longitude": "-111.92403000"
                    },
                    {
                        "id": 125822,
                        "name": "San Juan County",
                        "latitude": "37.62601000",
                        "longitude": "-109.80457000"
                    },
                    {
                        "id": 125881,
                        "name": "Sandy",
                        "latitude": "40.59161000",
                        "longitude": "-111.88410000"
                    },
                    {
                        "id": 125882,
                        "name": "Sandy Hills",
                        "latitude": "40.58106000",
                        "longitude": "-111.85077000"
                    },
                    {
                        "id": 125896,
                        "name": "Sanpete County",
                        "latitude": "39.37396000",
                        "longitude": "-111.57634000"
                    },
                    {
                        "id": 125905,
                        "name": "Santa Clara",
                        "latitude": "37.13304000",
                        "longitude": "-113.65413000"
                    },
                    {
                        "id": 125929,
                        "name": "Santaquin",
                        "latitude": "39.97551000",
                        "longitude": "-111.78521000"
                    },
                    {
                        "id": 125945,
                        "name": "Saratoga Springs",
                        "latitude": "40.34912000",
                        "longitude": "-111.90466000"
                    },
                    {
                        "id": 126182,
                        "name": "Sevier County",
                        "latitude": "38.74764000",
                        "longitude": "-111.80464000"
                    },
                    {
                        "id": 126438,
                        "name": "Silver Summit",
                        "latitude": "40.74144000",
                        "longitude": "-111.48775000"
                    },
                    {
                        "id": 126521,
                        "name": "Smithfield",
                        "latitude": "41.83826000",
                        "longitude": "-111.83272000"
                    },
                    {
                        "id": 126552,
                        "name": "Snyderville",
                        "latitude": "40.69439000",
                        "longitude": "-111.54381000"
                    },
                    {
                        "id": 126680,
                        "name": "South Jordan",
                        "latitude": "40.56217000",
                        "longitude": "-111.92966000"
                    },
                    {
                        "id": 126681,
                        "name": "South Jordan Heights",
                        "latitude": "40.56384000",
                        "longitude": "-111.94938000"
                    },
                    {
                        "id": 126696,
                        "name": "South Ogden",
                        "latitude": "41.19189000",
                        "longitude": "-111.97133000"
                    },
                    {
                        "id": 126722,
                        "name": "South Salt Lake",
                        "latitude": "40.71884000",
                        "longitude": "-111.88827000"
                    },
                    {
                        "id": 126745,
                        "name": "South Weber",
                        "latitude": "41.13244000",
                        "longitude": "-111.93022000"
                    },
                    {
                        "id": 126749,
                        "name": "South Willard",
                        "latitude": "41.36327000",
                        "longitude": "-112.03578000"
                    },
                    {
                        "id": 126798,
                        "name": "Spanish Fork",
                        "latitude": "40.11496000",
                        "longitude": "-111.65492000"
                    },
                    {
                        "id": 126853,
                        "name": "Spring City",
                        "latitude": "39.48246000",
                        "longitude": "-111.49602000"
                    },
                    {
                        "id": 126855,
                        "name": "Spring Glen",
                        "latitude": "39.65941000",
                        "longitude": "-110.85349000"
                    },
                    {
                        "id": 126918,
                        "name": "Springville",
                        "latitude": "40.16523000",
                        "longitude": "-111.61075000"
                    },
                    {
                        "id": 126965,
                        "name": "Stansbury park",
                        "latitude": "40.63772000",
                        "longitude": "-112.29606000"
                    },
                    {
                        "id": 127217,
                        "name": "Summit County",
                        "latitude": "40.86815000",
                        "longitude": "-110.95567000"
                    },
                    {
                        "id": 127219,
                        "name": "Summit Park",
                        "latitude": "40.74578000",
                        "longitude": "-111.61159000"
                    },
                    {
                        "id": 127273,
                        "name": "Sunset",
                        "latitude": "41.13633000",
                        "longitude": "-112.03105000"
                    },
                    {
                        "id": 127367,
                        "name": "Syracuse",
                        "latitude": "41.08939000",
                        "longitude": "-112.06467000"
                    },
                    {
                        "id": 127466,
                        "name": "Taylorsville",
                        "latitude": "40.66772000",
                        "longitude": "-111.93883000"
                    },
                    {
                        "id": 127725,
                        "name": "Tooele",
                        "latitude": "40.53078000",
                        "longitude": "-112.29828000"
                    },
                    {
                        "id": 127726,
                        "name": "Tooele County",
                        "latitude": "40.44875000",
                        "longitude": "-113.13106000"
                    },
                    {
                        "id": 127738,
                        "name": "Toquerville",
                        "latitude": "37.25332000",
                        "longitude": "-113.28467000"
                    },
                    {
                        "id": 127797,
                        "name": "Tremonton",
                        "latitude": "41.71187000",
                        "longitude": "-112.16551000"
                    },
                    {
                        "id": 127956,
                        "name": "Uintah",
                        "latitude": "41.14411000",
                        "longitude": "-111.92327000"
                    },
                    {
                        "id": 127957,
                        "name": "Uintah County",
                        "latitude": "40.12495000",
                        "longitude": "-109.51839000"
                    },
                    {
                        "id": 128064,
                        "name": "Utah County",
                        "latitude": "40.11995000",
                        "longitude": "-111.67031000"
                    },
                    {
                        "id": 128187,
                        "name": "Vernal",
                        "latitude": "40.45552000",
                        "longitude": "-109.52875000"
                    },
                    {
                        "id": 128272,
                        "name": "Vineyard",
                        "latitude": "40.29704000",
                        "longitude": "-111.74670000"
                    },
                    {
                        "id": 128526,
                        "name": "Wasatch County",
                        "latitude": "40.33035000",
                        "longitude": "-111.16847000"
                    },
                    {
                        "id": 128551,
                        "name": "Washington",
                        "latitude": "37.13054000",
                        "longitude": "-113.50829000"
                    },
                    {
                        "id": 128578,
                        "name": "Washington County",
                        "latitude": "37.28036000",
                        "longitude": "-113.50494000"
                    },
                    {
                        "id": 128586,
                        "name": "Washington Terrace",
                        "latitude": "41.17272000",
                        "longitude": "-111.97661000"
                    },
                    {
                        "id": 128703,
                        "name": "Wayne County",
                        "latitude": "38.32436000",
                        "longitude": "-110.90367000"
                    },
                    {
                        "id": 128729,
                        "name": "Weber County",
                        "latitude": "41.26988000",
                        "longitude": "-111.91327000"
                    },
                    {
                        "id": 128779,
                        "name": "Wellington",
                        "latitude": "39.54247000",
                        "longitude": "-110.73543000"
                    },
                    {
                        "id": 128794,
                        "name": "Wellsville",
                        "latitude": "41.63854000",
                        "longitude": "-111.93383000"
                    },
                    {
                        "id": 128801,
                        "name": "Wendover",
                        "latitude": "40.73715000",
                        "longitude": "-114.03751000"
                    },
                    {
                        "id": 128829,
                        "name": "West Bountiful",
                        "latitude": "40.89383000",
                        "longitude": "-111.90188000"
                    },
                    {
                        "id": 128888,
                        "name": "West Haven",
                        "latitude": "41.20300000",
                        "longitude": "-112.05105000"
                    },
                    {
                        "id": 128905,
                        "name": "West Jordan",
                        "latitude": "40.60967000",
                        "longitude": "-111.93910000"
                    },
                    {
                        "id": 128937,
                        "name": "West Mountain",
                        "latitude": "40.06079000",
                        "longitude": "-111.78827000"
                    },
                    {
                        "id": 128963,
                        "name": "West Point",
                        "latitude": "41.11828000",
                        "longitude": "-112.08411000"
                    },
                    {
                        "id": 128997,
                        "name": "West Valley City",
                        "latitude": "40.69161000",
                        "longitude": "-112.00105000"
                    },
                    {
                        "id": 129132,
                        "name": "White City",
                        "latitude": "40.56578000",
                        "longitude": "-111.86438000"
                    },
                    {
                        "id": 129258,
                        "name": "Willard",
                        "latitude": "41.40911000",
                        "longitude": "-112.03606000"
                    },
                    {
                        "id": 129471,
                        "name": "Wolf Creek",
                        "latitude": "41.33327000",
                        "longitude": "-111.82716000"
                    },
                    {
                        "id": 129531,
                        "name": "Woodland Hills",
                        "latitude": "40.01532000",
                        "longitude": "-111.64868000"
                    },
                    {
                        "id": 129551,
                        "name": "Woods Cross",
                        "latitude": "40.87161000",
                        "longitude": "-111.89216000"
                    }
                ]
            },
            {
                "id": 1409,
                "name": "Vermont",
                "iso2": "VT",
                "latitude": "44.55880280",
                "longitude": "-72.57784150",
                "type": "state",
                "cities": [
                    {
                        "id": 111039,
                        "name": "Addison",
                        "latitude": "44.08867000",
                        "longitude": "-73.30262000"
                    },
                    {
                        "id": 111040,
                        "name": "Addison County",
                        "latitude": "44.03091000",
                        "longitude": "-73.14094000"
                    },
                    {
                        "id": 111469,
                        "name": "Arlington",
                        "latitude": "43.07480000",
                        "longitude": "-73.15400000"
                    },
                    {
                        "id": 111842,
                        "name": "Barre",
                        "latitude": "44.19701000",
                        "longitude": "-72.50205000"
                    },
                    {
                        "id": 112124,
                        "name": "Bellows Falls",
                        "latitude": "43.13341000",
                        "longitude": "-72.44398000"
                    },
                    {
                        "id": 112177,
                        "name": "Bennington",
                        "latitude": "42.87813000",
                        "longitude": "-73.19677000"
                    },
                    {
                        "id": 112178,
                        "name": "Bennington County",
                        "latitude": "43.03546000",
                        "longitude": "-73.09295000"
                    },
                    {
                        "id": 112690,
                        "name": "Brandon",
                        "latitude": "43.79812000",
                        "longitude": "-73.08761000"
                    },
                    {
                        "id": 112699,
                        "name": "Brattleboro",
                        "latitude": "42.85092000",
                        "longitude": "-72.55787000"
                    },
                    {
                        "id": 112780,
                        "name": "Bridport",
                        "latitude": "43.98506000",
                        "longitude": "-73.31262000"
                    },
                    {
                        "id": 112810,
                        "name": "Bristol",
                        "latitude": "44.13339000",
                        "longitude": "-73.07901000"
                    },
                    {
                        "id": 113072,
                        "name": "Burlington",
                        "latitude": "44.47588000",
                        "longitude": "-73.21207000"
                    },
                    {
                        "id": 113193,
                        "name": "Caledonia County",
                        "latitude": "44.46472000",
                        "longitude": "-72.10219000"
                    },
                    {
                        "id": 113552,
                        "name": "Castleton",
                        "latitude": "43.61062000",
                        "longitude": "-73.17983000"
                    },
                    {
                        "id": 113780,
                        "name": "Charlotte",
                        "latitude": "44.30977000",
                        "longitude": "-73.26096000"
                    },
                    {
                        "id": 113835,
                        "name": "Chelsea",
                        "latitude": "43.98979000",
                        "longitude": "-72.44760000"
                    },
                    {
                        "id": 113891,
                        "name": "Chester",
                        "latitude": "43.26285000",
                        "longitude": "-72.59509000"
                    },
                    {
                        "id": 113982,
                        "name": "Chittenden",
                        "latitude": "43.70784000",
                        "longitude": "-72.94816000"
                    },
                    {
                        "id": 113983,
                        "name": "Chittenden County",
                        "latitude": "44.46098000",
                        "longitude": "-73.08092000"
                    },
                    {
                        "id": 114111,
                        "name": "Clarendon",
                        "latitude": "43.51618000",
                        "longitude": "-72.96983000"
                    },
                    {
                        "id": 114384,
                        "name": "Colchester",
                        "latitude": "44.54394000",
                        "longitude": "-73.14791000"
                    },
                    {
                        "id": 115017,
                        "name": "Danby",
                        "latitude": "43.34618000",
                        "longitude": "-72.99538000"
                    },
                    {
                        "id": 115452,
                        "name": "Dover",
                        "latitude": "42.94369000",
                        "longitude": "-72.80399000"
                    },
                    {
                        "id": 116146,
                        "name": "Enosburg Falls",
                        "latitude": "44.90699000",
                        "longitude": "-72.80652000"
                    },
                    {
                        "id": 116197,
                        "name": "Essex County",
                        "latitude": "44.72779000",
                        "longitude": "-71.73605000"
                    },
                    {
                        "id": 116199,
                        "name": "Essex Junction",
                        "latitude": "44.49061000",
                        "longitude": "-73.11096000"
                    },
                    {
                        "id": 116283,
                        "name": "Fair Haven",
                        "latitude": "43.59479000",
                        "longitude": "-73.26567000"
                    },
                    {
                        "id": 116495,
                        "name": "Ferrisburgh",
                        "latitude": "44.20561000",
                        "longitude": "-73.24623000"
                    },
                    {
                        "id": 116863,
                        "name": "Franklin County",
                        "latitude": "44.85748000",
                        "longitude": "-72.91200000"
                    },
                    {
                        "id": 117464,
                        "name": "Grand Isle County",
                        "latitude": "44.79683000",
                        "longitude": "-73.29483000"
                    },
                    {
                        "id": 117783,
                        "name": "Guildhall",
                        "latitude": "44.56506000",
                        "longitude": "-71.55981000"
                    },
                    {
                        "id": 118010,
                        "name": "Hardwick",
                        "latitude": "44.50478000",
                        "longitude": "-72.36816000"
                    },
                    {
                        "id": 118092,
                        "name": "Hartford",
                        "latitude": "43.66063000",
                        "longitude": "-72.33842000"
                    },
                    {
                        "id": 118481,
                        "name": "Hinesburg",
                        "latitude": "44.32922000",
                        "longitude": "-73.11068000"
                    },
                    {
                        "id": 118852,
                        "name": "Hyde Park",
                        "latitude": "44.59394000",
                        "longitude": "-72.61651000"
                    },
                    {
                        "id": 119112,
                        "name": "Jamaica",
                        "latitude": "43.10036000",
                        "longitude": "-72.77843000"
                    },
                    {
                        "id": 119225,
                        "name": "Jericho",
                        "latitude": "44.50394000",
                        "longitude": "-72.99763000"
                    },
                    {
                        "id": 119255,
                        "name": "Johnson",
                        "latitude": "44.63561000",
                        "longitude": "-72.68040000"
                    },
                    {
                        "id": 120072,
                        "name": "Lamoille County",
                        "latitude": "44.60576000",
                        "longitude": "-72.64145000"
                    },
                    {
                        "id": 120338,
                        "name": "Leicester",
                        "latitude": "43.86673000",
                        "longitude": "-73.10789000"
                    },
                    {
                        "id": 120508,
                        "name": "Lincoln",
                        "latitude": "44.10589000",
                        "longitude": "-72.99706000"
                    },
                    {
                        "id": 120724,
                        "name": "Londonderry",
                        "latitude": "43.22646000",
                        "longitude": "-72.80649000"
                    },
                    {
                        "id": 120888,
                        "name": "Lunenburg",
                        "latitude": "44.46311000",
                        "longitude": "-71.68203000"
                    },
                    {
                        "id": 120924,
                        "name": "Lyndon",
                        "latitude": "44.51422000",
                        "longitude": "-72.01093000"
                    },
                    {
                        "id": 120925,
                        "name": "Lyndonville",
                        "latitude": "44.53367000",
                        "longitude": "-72.00315000"
                    },
                    {
                        "id": 121103,
                        "name": "Manchester Center",
                        "latitude": "43.17702000",
                        "longitude": "-73.05705000"
                    },
                    {
                        "id": 121654,
                        "name": "Mendon",
                        "latitude": "43.65198000",
                        "longitude": "-72.92780000"
                    },
                    {
                        "id": 121773,
                        "name": "Middlebury (village)",
                        "latitude": "44.01553000",
                        "longitude": "-73.16937000"
                    },
                    {
                        "id": 121919,
                        "name": "Milton",
                        "latitude": "44.63977000",
                        "longitude": "-73.11041000"
                    },
                    {
                        "id": 122137,
                        "name": "Montgomery",
                        "latitude": "44.90255000",
                        "longitude": "-72.63818000"
                    },
                    {
                        "id": 122177,
                        "name": "Montpelier",
                        "latitude": "44.26006000",
                        "longitude": "-72.57539000"
                    },
                    {
                        "id": 122232,
                        "name": "Moretown",
                        "latitude": "44.25089000",
                        "longitude": "-72.76095000"
                    },
                    {
                        "id": 122283,
                        "name": "Morristown",
                        "latitude": "44.55727000",
                        "longitude": "-72.62373000"
                    },
                    {
                        "id": 122287,
                        "name": "Morrisville",
                        "latitude": "44.56172000",
                        "longitude": "-72.59845000"
                    },
                    {
                        "id": 122350,
                        "name": "Mount Holly",
                        "latitude": "43.45229000",
                        "longitude": "-72.82482000"
                    },
                    {
                        "id": 122827,
                        "name": "Newfane",
                        "latitude": "42.98564000",
                        "longitude": "-72.65593000"
                    },
                    {
                        "id": 122850,
                        "name": "Newport",
                        "latitude": "44.93644000",
                        "longitude": "-72.20510000"
                    },
                    {
                        "id": 122986,
                        "name": "North Bennington",
                        "latitude": "42.93036000",
                        "longitude": "-73.24261000"
                    },
                    {
                        "id": 123038,
                        "name": "North Hero",
                        "latitude": "44.83125000",
                        "longitude": "-73.27323000"
                    },
                    {
                        "id": 123154,
                        "name": "Northfield",
                        "latitude": "44.15117000",
                        "longitude": "-72.65650000"
                    },
                    {
                        "id": 123520,
                        "name": "Orange County",
                        "latitude": "44.00560000",
                        "longitude": "-72.37661000"
                    },
                    {
                        "id": 123566,
                        "name": "Orleans County",
                        "latitude": "44.82881000",
                        "longitude": "-72.24381000"
                    },
                    {
                        "id": 123931,
                        "name": "Pawlet",
                        "latitude": "43.34674000",
                        "longitude": "-73.17622000"
                    },
                    {
                        "id": 124604,
                        "name": "Poultney",
                        "latitude": "43.51701000",
                        "longitude": "-73.23622000"
                    },
                    {
                        "id": 124619,
                        "name": "Pownal",
                        "latitude": "42.76564000",
                        "longitude": "-73.23594000"
                    },
                    {
                        "id": 124868,
                        "name": "Randolph",
                        "latitude": "43.92507000",
                        "longitude": "-72.66594000"
                    },
                    {
                        "id": 125065,
                        "name": "Richford",
                        "latitude": "44.99699000",
                        "longitude": "-72.67124000"
                    },
                    {
                        "id": 125304,
                        "name": "Rockingham",
                        "latitude": "43.18758000",
                        "longitude": "-72.48898000"
                    },
                    {
                        "id": 125557,
                        "name": "Rutland",
                        "latitude": "43.61062000",
                        "longitude": "-72.97261000"
                    },
                    {
                        "id": 125558,
                        "name": "Rutland County",
                        "latitude": "43.58009000",
                        "longitude": "-73.03661000"
                    },
                    {
                        "id": 125596,
                        "name": "Saint Albans",
                        "latitude": "44.81088000",
                        "longitude": "-73.08319000"
                    },
                    {
                        "id": 125668,
                        "name": "Saint Johnsbury",
                        "latitude": "44.41922000",
                        "longitude": "-72.01509000"
                    },
                    {
                        "id": 125760,
                        "name": "Salisbury",
                        "latitude": "43.89645000",
                        "longitude": "-73.09984000"
                    },
                    {
                        "id": 126616,
                        "name": "South Barre",
                        "latitude": "44.17701000",
                        "longitude": "-72.50566000"
                    },
                    {
                        "id": 126634,
                        "name": "South Burlington",
                        "latitude": "44.46699000",
                        "longitude": "-73.17096000"
                    },
                    {
                        "id": 126904,
                        "name": "Springfield",
                        "latitude": "43.29841000",
                        "longitude": "-72.48231000"
                    },
                    {
                        "id": 126925,
                        "name": "St Johnsbury",
                        "latitude": "44.42526000",
                        "longitude": "-72.01512000"
                    },
                    {
                        "id": 126988,
                        "name": "Starksboro",
                        "latitude": "44.22728000",
                        "longitude": "-73.05734000"
                    },
                    {
                        "id": 127114,
                        "name": "Stowe",
                        "latitude": "44.46533000",
                        "longitude": "-72.68456000"
                    },
                    {
                        "id": 127327,
                        "name": "Swanton",
                        "latitude": "44.91810000",
                        "longitude": "-73.12430000"
                    },
                    {
                        "id": 127767,
                        "name": "Townshend",
                        "latitude": "43.04730000",
                        "longitude": "-72.66759000"
                    },
                    {
                        "id": 128182,
                        "name": "Vergennes",
                        "latitude": "44.16728000",
                        "longitude": "-73.25401000"
                    },
                    {
                        "id": 128550,
                        "name": "Washington",
                        "latitude": "44.10562000",
                        "longitude": "-72.43260000"
                    },
                    {
                        "id": 128575,
                        "name": "Washington County",
                        "latitude": "44.27342000",
                        "longitude": "-72.61490000"
                    },
                    {
                        "id": 128603,
                        "name": "Waterbury",
                        "latitude": "44.33783000",
                        "longitude": "-72.75623000"
                    },
                    {
                        "id": 128834,
                        "name": "West Brattleboro",
                        "latitude": "42.85592000",
                        "longitude": "-72.60315000"
                    },
                    {
                        "id": 128970,
                        "name": "West Rutland",
                        "latitude": "43.59312000",
                        "longitude": "-73.04511000"
                    },
                    {
                        "id": 129157,
                        "name": "White River Junction",
                        "latitude": "43.64896000",
                        "longitude": "-72.31926000"
                    },
                    {
                        "id": 129232,
                        "name": "Wilder",
                        "latitude": "43.67285000",
                        "longitude": "-72.30870000"
                    },
                    {
                        "id": 129289,
                        "name": "Williamstown",
                        "latitude": "44.12173000",
                        "longitude": "-72.54149000"
                    },
                    {
                        "id": 129298,
                        "name": "Williston",
                        "latitude": "44.43755000",
                        "longitude": "-73.06818000"
                    },
                    {
                        "id": 129374,
                        "name": "Windham County",
                        "latitude": "42.99059000",
                        "longitude": "-72.71384000"
                    },
                    {
                        "id": 129384,
                        "name": "Windsor",
                        "latitude": "43.48035000",
                        "longitude": "-72.38481000"
                    },
                    {
                        "id": 129388,
                        "name": "Windsor County",
                        "latitude": "43.58000000",
                        "longitude": "-72.58624000"
                    },
                    {
                        "id": 129427,
                        "name": "Winooski",
                        "latitude": "44.49144000",
                        "longitude": "-73.18568000"
                    },
                    {
                        "id": 129566,
                        "name": "Woodstock",
                        "latitude": "43.62424000",
                        "longitude": "-72.51843000"
                    }
                ]
            },
            {
                "id": 1427,
                "name": "Virginia",
                "iso2": "VA",
                "latitude": "37.43157340",
                "longitude": "-78.65689420",
                "type": "state",
                "cities": [
                    {
                        "id": 110984,
                        "name": "Abingdon",
                        "latitude": "36.70983000",
                        "longitude": "-81.97735000"
                    },
                    {
                        "id": 110994,
                        "name": "Accomac",
                        "latitude": "37.71957000",
                        "longitude": "-75.66548000"
                    },
                    {
                        "id": 110995,
                        "name": "Accomack County",
                        "latitude": "37.76494000",
                        "longitude": "-75.75656000"
                    },
                    {
                        "id": 111050,
                        "name": "Adwolf",
                        "latitude": "36.78928000",
                        "longitude": "-81.58206000"
                    },
                    {
                        "id": 111116,
                        "name": "Albemarle County",
                        "latitude": "38.02289000",
                        "longitude": "-78.55654000"
                    },
                    {
                        "id": 111151,
                        "name": "Alexandria",
                        "latitude": "38.80484000",
                        "longitude": "-77.04692000"
                    },
                    {
                        "id": 111184,
                        "name": "Alleghany County",
                        "latitude": "37.78760000",
                        "longitude": "-80.00699000"
                    },
                    {
                        "id": 111238,
                        "name": "Altavista",
                        "latitude": "37.11181000",
                        "longitude": "-79.28558000"
                    },
                    {
                        "id": 111269,
                        "name": "Amelia County",
                        "latitude": "37.33603000",
                        "longitude": "-77.97614000"
                    },
                    {
                        "id": 111270,
                        "name": "Amelia Court House",
                        "latitude": "37.34293000",
                        "longitude": "-77.98056000"
                    },
                    {
                        "id": 111281,
                        "name": "Amherst",
                        "latitude": "37.58514000",
                        "longitude": "-79.05141000"
                    },
                    {
                        "id": 111286,
                        "name": "Amherst County",
                        "latitude": "37.60477000",
                        "longitude": "-79.14511000"
                    },
                    {
                        "id": 111349,
                        "name": "Annandale",
                        "latitude": "38.83039000",
                        "longitude": "-77.19637000"
                    },
                    {
                        "id": 111390,
                        "name": "Appalachia",
                        "latitude": "36.90676000",
                        "longitude": "-82.78183000"
                    },
                    {
                        "id": 111392,
                        "name": "Apple Mountain Lake",
                        "latitude": "38.92428000",
                        "longitude": "-78.10139000"
                    },
                    {
                        "id": 111401,
                        "name": "Appomattox",
                        "latitude": "37.35709000",
                        "longitude": "-78.82529000"
                    },
                    {
                        "id": 111402,
                        "name": "Appomattox County",
                        "latitude": "37.37229000",
                        "longitude": "-78.81212000"
                    },
                    {
                        "id": 111406,
                        "name": "Aquia Harbour",
                        "latitude": "38.46262000",
                        "longitude": "-77.38887000"
                    },
                    {
                        "id": 111463,
                        "name": "Arlington",
                        "latitude": "38.88101000",
                        "longitude": "-77.10428000"
                    },
                    {
                        "id": 111471,
                        "name": "Arlington County",
                        "latitude": "38.87862000",
                        "longitude": "-77.10096000"
                    },
                    {
                        "id": 111514,
                        "name": "Ashburn",
                        "latitude": "39.04372000",
                        "longitude": "-77.48749000"
                    },
                    {
                        "id": 111532,
                        "name": "Ashland",
                        "latitude": "37.75903000",
                        "longitude": "-77.47998000"
                    },
                    {
                        "id": 111585,
                        "name": "Atkins",
                        "latitude": "36.86734000",
                        "longitude": "-81.42344000"
                    },
                    {
                        "id": 111652,
                        "name": "Augusta County",
                        "latitude": "38.16452000",
                        "longitude": "-79.13383000"
                    },
                    {
                        "id": 111731,
                        "name": "Baileys Crossroads",
                        "latitude": "38.85039000",
                        "longitude": "-77.12970000"
                    },
                    {
                        "id": 111881,
                        "name": "Bassett",
                        "latitude": "36.75930000",
                        "longitude": "-79.99032000"
                    },
                    {
                        "id": 111886,
                        "name": "Basye",
                        "latitude": "38.80706000",
                        "longitude": "-78.79224000"
                    },
                    {
                        "id": 111902,
                        "name": "Bath County",
                        "latitude": "38.05869000",
                        "longitude": "-79.74109000"
                    },
                    {
                        "id": 111972,
                        "name": "Bealeton",
                        "latitude": "38.57179000",
                        "longitude": "-77.76388000"
                    },
                    {
                        "id": 112020,
                        "name": "Bedford",
                        "latitude": "37.33431000",
                        "longitude": "-79.52309000"
                    },
                    {
                        "id": 112027,
                        "name": "Bedford County",
                        "latitude": "37.31494000",
                        "longitude": "-79.52422000"
                    },
                    {
                        "id": 112085,
                        "name": "Belle Haven",
                        "latitude": "38.78539000",
                        "longitude": "-77.06303000"
                    },
                    {
                        "id": 112130,
                        "name": "Bellwood",
                        "latitude": "37.42181000",
                        "longitude": "-77.43748000"
                    },
                    {
                        "id": 112137,
                        "name": "Belmont",
                        "latitude": "39.06483000",
                        "longitude": "-77.50999000"
                    },
                    {
                        "id": 112144,
                        "name": "Belmont Estates",
                        "latitude": "38.45271000",
                        "longitude": "-78.91979000"
                    },
                    {
                        "id": 112181,
                        "name": "Bensley",
                        "latitude": "37.44681000",
                        "longitude": "-77.44332000"
                    },
                    {
                        "id": 112255,
                        "name": "Berryville",
                        "latitude": "39.15177000",
                        "longitude": "-77.98222000"
                    },
                    {
                        "id": 112337,
                        "name": "Big Stone Gap",
                        "latitude": "36.88176000",
                        "longitude": "-82.74710000"
                    },
                    {
                        "id": 112390,
                        "name": "Blacksburg",
                        "latitude": "37.22957000",
                        "longitude": "-80.41394000"
                    },
                    {
                        "id": 112392,
                        "name": "Blackstone",
                        "latitude": "37.08043000",
                        "longitude": "-77.99723000"
                    },
                    {
                        "id": 112420,
                        "name": "Bland",
                        "latitude": "37.10206000",
                        "longitude": "-81.11620000"
                    },
                    {
                        "id": 112421,
                        "name": "Bland County",
                        "latitude": "37.13397000",
                        "longitude": "-81.13028000"
                    },
                    {
                        "id": 112476,
                        "name": "Blue Ridge",
                        "latitude": "37.37847000",
                        "longitude": "-79.80698000"
                    },
                    {
                        "id": 112478,
                        "name": "Bluefield",
                        "latitude": "37.25262000",
                        "longitude": "-81.27121000"
                    },
                    {
                        "id": 112526,
                        "name": "Bon Air",
                        "latitude": "37.52487000",
                        "longitude": "-77.55777000"
                    },
                    {
                        "id": 112593,
                        "name": "Boswell's Corner",
                        "latitude": "38.50541000",
                        "longitude": "-77.37263000"
                    },
                    {
                        "id": 112594,
                        "name": "Botetourt County",
                        "latitude": "37.55712000",
                        "longitude": "-79.81233000"
                    },
                    {
                        "id": 112631,
                        "name": "Bowling Green",
                        "latitude": "38.04958000",
                        "longitude": "-77.34665000"
                    },
                    {
                        "id": 112644,
                        "name": "Boydton",
                        "latitude": "36.66764000",
                        "longitude": "-78.38750000"
                    },
                    {
                        "id": 112654,
                        "name": "Bracey",
                        "latitude": "36.59959000",
                        "longitude": "-78.14305000"
                    },
                    {
                        "id": 112683,
                        "name": "Brambleton",
                        "latitude": "38.98205000",
                        "longitude": "-77.53860000"
                    },
                    {
                        "id": 112687,
                        "name": "Brandermill",
                        "latitude": "37.43209000",
                        "longitude": "-77.64971000"
                    },
                    {
                        "id": 112774,
                        "name": "Bridgewater",
                        "latitude": "38.38207000",
                        "longitude": "-78.97670000"
                    },
                    {
                        "id": 112795,
                        "name": "Brightwood",
                        "latitude": "38.42152000",
                        "longitude": "-78.19361000"
                    },
                    {
                        "id": 112804,
                        "name": "Bristol",
                        "latitude": "36.59649000",
                        "longitude": "-82.18847000"
                    },
                    {
                        "id": 112824,
                        "name": "Broadlands",
                        "latitude": "39.01816000",
                        "longitude": "-77.52027000"
                    },
                    {
                        "id": 112831,
                        "name": "Broadway",
                        "latitude": "38.61317000",
                        "longitude": "-78.79891000"
                    },
                    {
                        "id": 112879,
                        "name": "Brookneal",
                        "latitude": "37.05014000",
                        "longitude": "-78.94418000"
                    },
                    {
                        "id": 112952,
                        "name": "Brunswick County",
                        "latitude": "36.76478000",
                        "longitude": "-77.85902000"
                    },
                    {
                        "id": 112970,
                        "name": "Buchanan",
                        "latitude": "37.52736000",
                        "longitude": "-79.67976000"
                    },
                    {
                        "id": 112974,
                        "name": "Buchanan County",
                        "latitude": "37.26663000",
                        "longitude": "-82.03603000"
                    },
                    {
                        "id": 112980,
                        "name": "Buckhall",
                        "latitude": "38.73178000",
                        "longitude": "-77.43110000"
                    },
                    {
                        "id": 112985,
                        "name": "Buckingham",
                        "latitude": "37.55015000",
                        "longitude": "-78.55556000"
                    },
                    {
                        "id": 112986,
                        "name": "Buckingham County",
                        "latitude": "37.57224000",
                        "longitude": "-78.52871000"
                    },
                    {
                        "id": 113001,
                        "name": "Buena Vista",
                        "latitude": "37.73430000",
                        "longitude": "-79.35392000"
                    },
                    {
                        "id": 113026,
                        "name": "Bull Run",
                        "latitude": "38.78373000",
                        "longitude": "-77.52055000"
                    },
                    {
                        "id": 113027,
                        "name": "Bull Run Mountain Estates",
                        "latitude": "38.90372000",
                        "longitude": "-77.66166000"
                    },
                    {
                        "id": 113054,
                        "name": "Burke",
                        "latitude": "38.79345000",
                        "longitude": "-77.27165000"
                    },
                    {
                        "id": 113301,
                        "name": "Campbell County",
                        "latitude": "37.20564000",
                        "longitude": "-79.09635000"
                    },
                    {
                        "id": 113311,
                        "name": "Cana",
                        "latitude": "36.58958000",
                        "longitude": "-80.67173000"
                    },
                    {
                        "id": 113365,
                        "name": "Cape Charles",
                        "latitude": "37.27008000",
                        "longitude": "-76.01649000"
                    },
                    {
                        "id": 113379,
                        "name": "Captains Cove",
                        "latitude": "37.98996000",
                        "longitude": "-75.42272000"
                    },
                    {
                        "id": 113438,
                        "name": "Caroline County",
                        "latitude": "38.02682000",
                        "longitude": "-77.34696000"
                    },
                    {
                        "id": 113457,
                        "name": "Carroll County",
                        "latitude": "36.73154000",
                        "longitude": "-80.73390000"
                    },
                    {
                        "id": 113469,
                        "name": "Carrollton",
                        "latitude": "36.94682000",
                        "longitude": "-76.56051000"
                    },
                    {
                        "id": 113554,
                        "name": "Castlewood",
                        "latitude": "36.89010000",
                        "longitude": "-82.27959000"
                    },
                    {
                        "id": 113588,
                        "name": "Cave Spring",
                        "latitude": "37.22764000",
                        "longitude": "-80.01282000"
                    },
                    {
                        "id": 113602,
                        "name": "Cedar Bluff",
                        "latitude": "37.08761000",
                        "longitude": "-81.75900000"
                    },
                    {
                        "id": 113674,
                        "name": "Central Garage",
                        "latitude": "37.74403000",
                        "longitude": "-77.13164000"
                    },
                    {
                        "id": 113695,
                        "name": "Centreville",
                        "latitude": "38.84039000",
                        "longitude": "-77.42888000"
                    },
                    {
                        "id": 113719,
                        "name": "Chamberlayne",
                        "latitude": "37.62653000",
                        "longitude": "-77.42859000"
                    },
                    {
                        "id": 113738,
                        "name": "Chantilly",
                        "latitude": "38.89428000",
                        "longitude": "-77.43110000"
                    },
                    {
                        "id": 113755,
                        "name": "Charles City",
                        "latitude": "37.34348000",
                        "longitude": "-77.07303000"
                    },
                    {
                        "id": 113756,
                        "name": "Charles City County",
                        "latitude": "37.35435000",
                        "longitude": "-77.05913000"
                    },
                    {
                        "id": 113782,
                        "name": "Charlotte County",
                        "latitude": "37.01161000",
                        "longitude": "-78.66164000"
                    },
                    {
                        "id": 113783,
                        "name": "Charlotte Court House",
                        "latitude": "37.05654000",
                        "longitude": "-78.63833000"
                    },
                    {
                        "id": 113787,
                        "name": "Charlottesville",
                        "latitude": "38.02931000",
                        "longitude": "-78.47668000"
                    },
                    {
                        "id": 113791,
                        "name": "Chase City",
                        "latitude": "36.79931000",
                        "longitude": "-78.45833000"
                    },
                    {
                        "id": 113796,
                        "name": "Chatham",
                        "latitude": "36.82569000",
                        "longitude": "-79.39808000"
                    },
                    {
                        "id": 113803,
                        "name": "Chatmoss",
                        "latitude": "36.65680000",
                        "longitude": "-79.81226000"
                    },
                    {
                        "id": 113861,
                        "name": "Cherry Hill",
                        "latitude": "38.56984000",
                        "longitude": "-77.26693000"
                    },
                    {
                        "id": 113874,
                        "name": "Chesapeake",
                        "latitude": "36.81904000",
                        "longitude": "-76.27494000"
                    },
                    {
                        "id": 113886,
                        "name": "Chester",
                        "latitude": "37.35682000",
                        "longitude": "-77.44165000"
                    },
                    {
                        "id": 113907,
                        "name": "Chesterfield County",
                        "latitude": "37.37852000",
                        "longitude": "-77.58694000"
                    },
                    {
                        "id": 113908,
                        "name": "Chesterfield Court House",
                        "latitude": "37.37709000",
                        "longitude": "-77.50499000"
                    },
                    {
                        "id": 113952,
                        "name": "Chilhowie",
                        "latitude": "36.79845000",
                        "longitude": "-81.68234000"
                    },
                    {
                        "id": 113966,
                        "name": "Chincoteague",
                        "latitude": "37.93318000",
                        "longitude": "-75.37881000"
                    },
                    {
                        "id": 114000,
                        "name": "Christiansburg",
                        "latitude": "37.12985000",
                        "longitude": "-80.40894000"
                    },
                    {
                        "id": 114047,
                        "name": "City of Alexandria",
                        "latitude": "38.80484000",
                        "longitude": "-77.04692000"
                    },
                    {
                        "id": 114049,
                        "name": "City of Bedford",
                        "latitude": "37.33431000",
                        "longitude": "-79.52309000"
                    },
                    {
                        "id": 114050,
                        "name": "City of Bristol",
                        "latitude": "36.59649000",
                        "longitude": "-82.18847000"
                    },
                    {
                        "id": 114051,
                        "name": "City of Buena Vista",
                        "latitude": "37.73430000",
                        "longitude": "-79.35392000"
                    },
                    {
                        "id": 114052,
                        "name": "City of Charlottesville",
                        "latitude": "38.02931000",
                        "longitude": "-78.47668000"
                    },
                    {
                        "id": 114053,
                        "name": "City of Chesapeake",
                        "latitude": "36.68765000",
                        "longitude": "-76.31216000"
                    },
                    {
                        "id": 114054,
                        "name": "City of Colonial Heights",
                        "latitude": "37.24404000",
                        "longitude": "-77.41026000"
                    },
                    {
                        "id": 114055,
                        "name": "City of Covington",
                        "latitude": "37.79346000",
                        "longitude": "-79.99395000"
                    },
                    {
                        "id": 114056,
                        "name": "City of Danville",
                        "latitude": "36.58597000",
                        "longitude": "-79.39502000"
                    },
                    {
                        "id": 114057,
                        "name": "City of Emporia",
                        "latitude": "36.68598000",
                        "longitude": "-77.54248000"
                    },
                    {
                        "id": 114058,
                        "name": "City of Fairfax",
                        "latitude": "38.84622000",
                        "longitude": "-77.30637000"
                    },
                    {
                        "id": 114059,
                        "name": "City of Falls Church",
                        "latitude": "38.88233000",
                        "longitude": "-77.17109000"
                    },
                    {
                        "id": 114060,
                        "name": "City of Franklin",
                        "latitude": "36.67765000",
                        "longitude": "-76.92246000"
                    },
                    {
                        "id": 114061,
                        "name": "City of Fredericksburg",
                        "latitude": "38.30318000",
                        "longitude": "-77.46054000"
                    },
                    {
                        "id": 114062,
                        "name": "City of Galax",
                        "latitude": "36.66124000",
                        "longitude": "-80.92397000"
                    },
                    {
                        "id": 114063,
                        "name": "City of Hampton",
                        "latitude": "37.06265000",
                        "longitude": "-76.33300000"
                    },
                    {
                        "id": 114064,
                        "name": "City of Harrisonburg",
                        "latitude": "38.44957000",
                        "longitude": "-78.86892000"
                    },
                    {
                        "id": 114065,
                        "name": "City of Hopewell",
                        "latitude": "37.30432000",
                        "longitude": "-77.28720000"
                    },
                    {
                        "id": 114066,
                        "name": "City of Lexington",
                        "latitude": "37.77309000",
                        "longitude": "-79.45244000"
                    },
                    {
                        "id": 114067,
                        "name": "City of Lynchburg",
                        "latitude": "37.41375000",
                        "longitude": "-79.14225000"
                    },
                    {
                        "id": 114068,
                        "name": "City of Manassas",
                        "latitude": "38.75095000",
                        "longitude": "-77.47527000"
                    },
                    {
                        "id": 114069,
                        "name": "City of Manassas Park",
                        "latitude": "38.78400000",
                        "longitude": "-77.46971000"
                    },
                    {
                        "id": 114070,
                        "name": "City of Martinsville",
                        "latitude": "36.69153000",
                        "longitude": "-79.87254000"
                    },
                    {
                        "id": 114072,
                        "name": "City of Newport News",
                        "latitude": "37.06265000",
                        "longitude": "-76.50801000"
                    },
                    {
                        "id": 114073,
                        "name": "City of Norfolk",
                        "latitude": "36.89126000",
                        "longitude": "-76.26188000"
                    },
                    {
                        "id": 114074,
                        "name": "City of Norton",
                        "latitude": "36.93343000",
                        "longitude": "-82.62905000"
                    },
                    {
                        "id": 114075,
                        "name": "City of Petersburg",
                        "latitude": "37.22793000",
                        "longitude": "-77.40193000"
                    },
                    {
                        "id": 114076,
                        "name": "City of Poquoson",
                        "latitude": "37.12237000",
                        "longitude": "-76.34578000"
                    },
                    {
                        "id": 114077,
                        "name": "City of Portsmouth",
                        "latitude": "36.83649000",
                        "longitude": "-76.30795000"
                    },
                    {
                        "id": 114078,
                        "name": "City of Radford",
                        "latitude": "37.13179000",
                        "longitude": "-80.57645000"
                    },
                    {
                        "id": 114079,
                        "name": "City of Richmond",
                        "latitude": "37.55376000",
                        "longitude": "-77.46026000"
                    },
                    {
                        "id": 114080,
                        "name": "City of Roanoke",
                        "latitude": "37.27097000",
                        "longitude": "-79.94143000"
                    },
                    {
                        "id": 114082,
                        "name": "City of Salem",
                        "latitude": "37.29347000",
                        "longitude": "-80.05476000"
                    },
                    {
                        "id": 114084,
                        "name": "City of Staunton",
                        "latitude": "38.14931000",
                        "longitude": "-79.05963000"
                    },
                    {
                        "id": 114085,
                        "name": "City of Suffolk",
                        "latitude": "36.70848000",
                        "longitude": "-76.60801000"
                    },
                    {
                        "id": 114086,
                        "name": "City of Virginia Beach",
                        "latitude": "36.73765000",
                        "longitude": "-76.00521000"
                    },
                    {
                        "id": 114087,
                        "name": "City of Waynesboro",
                        "latitude": "38.06847000",
                        "longitude": "-78.88947000"
                    },
                    {
                        "id": 114088,
                        "name": "City of Williamsburg",
                        "latitude": "37.27070000",
                        "longitude": "-76.70746000"
                    },
                    {
                        "id": 114089,
                        "name": "City of Winchester",
                        "latitude": "39.18566000",
                        "longitude": "-78.16333000"
                    },
                    {
                        "id": 114137,
                        "name": "Clarke County",
                        "latitude": "39.11226000",
                        "longitude": "-77.99673000"
                    },
                    {
                        "id": 114157,
                        "name": "Clarksville",
                        "latitude": "36.62403000",
                        "longitude": "-78.55694000"
                    },
                    {
                        "id": 114194,
                        "name": "Claypool Hill",
                        "latitude": "37.06261000",
                        "longitude": "-81.75178000"
                    },
                    {
                        "id": 114262,
                        "name": "Clifton Forge",
                        "latitude": "37.81624000",
                        "longitude": "-79.82449000"
                    },
                    {
                        "id": 114300,
                        "name": "Clintwood",
                        "latitude": "37.15011000",
                        "longitude": "-82.45598000"
                    },
                    {
                        "id": 114310,
                        "name": "Cloverdale",
                        "latitude": "37.36514000",
                        "longitude": "-79.90560000"
                    },
                    {
                        "id": 114365,
                        "name": "Coeburn",
                        "latitude": "36.94399000",
                        "longitude": "-82.46404000"
                    },
                    {
                        "id": 114438,
                        "name": "Collinsville",
                        "latitude": "36.71514000",
                        "longitude": "-79.91532000"
                    },
                    {
                        "id": 114447,
                        "name": "Colonial Beach",
                        "latitude": "38.25457000",
                        "longitude": "-76.96358000"
                    },
                    {
                        "id": 114449,
                        "name": "Colonial Heights",
                        "latitude": "37.26804000",
                        "longitude": "-77.40726000"
                    },
                    {
                        "id": 114537,
                        "name": "Concord",
                        "latitude": "37.34264000",
                        "longitude": "-78.97502000"
                    },
                    {
                        "id": 114725,
                        "name": "Countryside",
                        "latitude": "39.04094000",
                        "longitude": "-77.41360000"
                    },
                    {
                        "id": 114728,
                        "name": "Courtland",
                        "latitude": "36.71626000",
                        "longitude": "-77.06802000"
                    },
                    {
                        "id": 114739,
                        "name": "Covington",
                        "latitude": "37.79346000",
                        "longitude": "-79.99395000"
                    },
                    {
                        "id": 114758,
                        "name": "Craig County",
                        "latitude": "37.48125000",
                        "longitude": "-80.21234000"
                    },
                    {
                        "id": 114818,
                        "name": "Crewe",
                        "latitude": "37.17321000",
                        "longitude": "-78.12333000"
                    },
                    {
                        "id": 114820,
                        "name": "Crimora",
                        "latitude": "38.15402000",
                        "longitude": "-78.85030000"
                    },
                    {
                        "id": 114871,
                        "name": "Crozet",
                        "latitude": "38.06958000",
                        "longitude": "-78.70058000"
                    },
                    {
                        "id": 114900,
                        "name": "Culpeper",
                        "latitude": "38.47318000",
                        "longitude": "-77.99666000"
                    },
                    {
                        "id": 114901,
                        "name": "Culpeper County",
                        "latitude": "38.48606000",
                        "longitude": "-77.95589000"
                    },
                    {
                        "id": 114908,
                        "name": "Cumberland",
                        "latitude": "37.49598000",
                        "longitude": "-78.24527000"
                    },
                    {
                        "id": 114917,
                        "name": "Cumberland County",
                        "latitude": "37.51210000",
                        "longitude": "-78.24496000"
                    },
                    {
                        "id": 114970,
                        "name": "Dahlgren",
                        "latitude": "38.33124000",
                        "longitude": "-77.05109000"
                    },
                    {
                        "id": 114981,
                        "name": "Dale City",
                        "latitude": "38.63706000",
                        "longitude": "-77.31109000"
                    },
                    {
                        "id": 114984,
                        "name": "Daleville",
                        "latitude": "37.40986000",
                        "longitude": "-79.91254000"
                    },
                    {
                        "id": 115039,
                        "name": "Danville",
                        "latitude": "36.58597000",
                        "longitude": "-79.39502000"
                    },
                    {
                        "id": 115094,
                        "name": "Dayton",
                        "latitude": "38.41485000",
                        "longitude": "-78.93864000"
                    },
                    {
                        "id": 115228,
                        "name": "Deltaville",
                        "latitude": "37.55486000",
                        "longitude": "-76.33689000"
                    },
                    {
                        "id": 115322,
                        "name": "Dickenson County",
                        "latitude": "37.12574000",
                        "longitude": "-82.35035000"
                    },
                    {
                        "id": 115352,
                        "name": "Dinwiddie County",
                        "latitude": "37.07590000",
                        "longitude": "-77.63236000"
                    },
                    {
                        "id": 115405,
                        "name": "Dooms",
                        "latitude": "38.10902000",
                        "longitude": "-78.85752000"
                    },
                    {
                        "id": 115468,
                        "name": "Dranesville",
                        "latitude": "39.00067000",
                        "longitude": "-77.34582000"
                    },
                    {
                        "id": 115484,
                        "name": "Dryden",
                        "latitude": "36.77759000",
                        "longitude": "-82.94155000"
                    },
                    {
                        "id": 115493,
                        "name": "Dublin",
                        "latitude": "37.10568000",
                        "longitude": "-80.68534000"
                    },
                    {
                        "id": 115511,
                        "name": "Dulles Town Center",
                        "latitude": "39.03761000",
                        "longitude": "-77.41582000"
                    },
                    {
                        "id": 115516,
                        "name": "Dumbarton",
                        "latitude": "37.60376000",
                        "longitude": "-77.49137000"
                    },
                    {
                        "id": 115517,
                        "name": "Dumfries",
                        "latitude": "38.56762000",
                        "longitude": "-77.32804000"
                    },
                    {
                        "id": 115549,
                        "name": "Dunn Loring",
                        "latitude": "38.89344000",
                        "longitude": "-77.22165000"
                    },
                    {
                        "id": 115679,
                        "name": "East Hampton",
                        "latitude": "37.03737000",
                        "longitude": "-76.33161000"
                    },
                    {
                        "id": 115690,
                        "name": "East Highland Park",
                        "latitude": "37.58098000",
                        "longitude": "-77.40693000"
                    },
                    {
                        "id": 115704,
                        "name": "East Lexington",
                        "latitude": "37.79291000",
                        "longitude": "-79.42532000"
                    },
                    {
                        "id": 115798,
                        "name": "Eastville",
                        "latitude": "37.35264000",
                        "longitude": "-75.94576000"
                    },
                    {
                        "id": 115871,
                        "name": "Edinburg",
                        "latitude": "38.82095000",
                        "longitude": "-78.56585000"
                    },
                    {
                        "id": 116014,
                        "name": "Elkton",
                        "latitude": "38.40790000",
                        "longitude": "-78.62363000"
                    },
                    {
                        "id": 116109,
                        "name": "Emory",
                        "latitude": "36.77289000",
                        "longitude": "-81.83623000"
                    },
                    {
                        "id": 116112,
                        "name": "Emporia",
                        "latitude": "36.68598000",
                        "longitude": "-77.54248000"
                    },
                    {
                        "id": 116145,
                        "name": "Enon",
                        "latitude": "37.33070000",
                        "longitude": "-77.32276000"
                    },
                    {
                        "id": 116193,
                        "name": "Essex County",
                        "latitude": "37.93906000",
                        "longitude": "-76.94090000"
                    },
                    {
                        "id": 116220,
                        "name": "Ettrick",
                        "latitude": "37.24015000",
                        "longitude": "-77.42998000"
                    },
                    {
                        "id": 116275,
                        "name": "Exmore",
                        "latitude": "37.53180000",
                        "longitude": "-75.82299000"
                    },
                    {
                        "id": 116303,
                        "name": "Fairfax",
                        "latitude": "38.84622000",
                        "longitude": "-77.30637000"
                    },
                    {
                        "id": 116307,
                        "name": "Fairfax County",
                        "latitude": "38.83469000",
                        "longitude": "-77.27622000"
                    },
                    {
                        "id": 116308,
                        "name": "Fairfax Station",
                        "latitude": "38.80095000",
                        "longitude": "-77.32554000"
                    },
                    {
                        "id": 116330,
                        "name": "Fairlawn",
                        "latitude": "37.14846000",
                        "longitude": "-80.57839000"
                    },
                    {
                        "id": 116380,
                        "name": "Falls Church",
                        "latitude": "38.88233000",
                        "longitude": "-77.17109000"
                    },
                    {
                        "id": 116387,
                        "name": "Falmouth",
                        "latitude": "38.32402000",
                        "longitude": "-77.46832000"
                    },
                    {
                        "id": 116427,
                        "name": "Farmville",
                        "latitude": "37.30210000",
                        "longitude": "-78.39194000"
                    },
                    {
                        "id": 116436,
                        "name": "Fauquier County",
                        "latitude": "38.73855000",
                        "longitude": "-77.80927000"
                    },
                    {
                        "id": 116497,
                        "name": "Ferrum",
                        "latitude": "36.92292000",
                        "longitude": "-80.01337000"
                    },
                    {
                        "id": 116514,
                        "name": "Fincastle",
                        "latitude": "37.49930000",
                        "longitude": "-79.87726000"
                    },
                    {
                        "id": 116530,
                        "name": "Fishersville",
                        "latitude": "38.09902000",
                        "longitude": "-78.96919000"
                    },
                    {
                        "id": 116596,
                        "name": "Floris",
                        "latitude": "38.93706000",
                        "longitude": "-77.41277000"
                    },
                    {
                        "id": 116605,
                        "name": "Floyd",
                        "latitude": "36.91124000",
                        "longitude": "-80.32005000"
                    },
                    {
                        "id": 116609,
                        "name": "Floyd County",
                        "latitude": "36.93149000",
                        "longitude": "-80.36255000"
                    },
                    {
                        "id": 116614,
                        "name": "Fluvanna County",
                        "latitude": "37.84187000",
                        "longitude": "-78.27745000"
                    },
                    {
                        "id": 116644,
                        "name": "Forest",
                        "latitude": "37.36375000",
                        "longitude": "-79.28975000"
                    },
                    {
                        "id": 116691,
                        "name": "Fort Belvoir",
                        "latitude": "38.71190000",
                        "longitude": "-77.14589000"
                    },
                    {
                        "id": 116718,
                        "name": "Fort Hunt",
                        "latitude": "38.73289000",
                        "longitude": "-77.05803000"
                    },
                    {
                        "id": 116724,
                        "name": "Fort Lee",
                        "latitude": "37.24694000",
                        "longitude": "-77.33442000"
                    },
                    {
                        "id": 116816,
                        "name": "Franconia",
                        "latitude": "38.78206000",
                        "longitude": "-77.14637000"
                    },
                    {
                        "id": 116831,
                        "name": "Franklin",
                        "latitude": "36.67765000",
                        "longitude": "-76.92246000"
                    },
                    {
                        "id": 116856,
                        "name": "Franklin County",
                        "latitude": "36.99194000",
                        "longitude": "-79.88104000"
                    },
                    {
                        "id": 116889,
                        "name": "Frederick County",
                        "latitude": "39.20456000",
                        "longitude": "-78.26258000"
                    },
                    {
                        "id": 116891,
                        "name": "Fredericksburg",
                        "latitude": "38.30318000",
                        "longitude": "-77.46054000"
                    },
                    {
                        "id": 116960,
                        "name": "Front Royal",
                        "latitude": "38.91817000",
                        "longitude": "-78.19444000"
                    },
                    {
                        "id": 117018,
                        "name": "Gainesville",
                        "latitude": "38.79567000",
                        "longitude": "-77.61388000"
                    },
                    {
                        "id": 117020,
                        "name": "Galax",
                        "latitude": "36.66124000",
                        "longitude": "-80.92397000"
                    },
                    {
                        "id": 117118,
                        "name": "Gate City",
                        "latitude": "36.63788000",
                        "longitude": "-82.58099000"
                    },
                    {
                        "id": 117211,
                        "name": "Giles County",
                        "latitude": "37.31403000",
                        "longitude": "-80.70374000"
                    },
                    {
                        "id": 117232,
                        "name": "Glade Spring",
                        "latitude": "36.79122000",
                        "longitude": "-81.77123000"
                    },
                    {
                        "id": 117248,
                        "name": "Glasgow",
                        "latitude": "37.63402000",
                        "longitude": "-79.45031000"
                    },
                    {
                        "id": 117259,
                        "name": "Glen Allen",
                        "latitude": "37.66598000",
                        "longitude": "-77.50637000"
                    },
                    {
                        "id": 117325,
                        "name": "Gloucester County",
                        "latitude": "37.40121000",
                        "longitude": "-76.52297000"
                    },
                    {
                        "id": 117326,
                        "name": "Gloucester Courthouse",
                        "latitude": "37.40986000",
                        "longitude": "-76.52662000"
                    },
                    {
                        "id": 117327,
                        "name": "Gloucester Point",
                        "latitude": "37.25403000",
                        "longitude": "-76.49689000"
                    },
                    {
                        "id": 117375,
                        "name": "Goochland",
                        "latitude": "37.68431000",
                        "longitude": "-77.88527000"
                    },
                    {
                        "id": 117376,
                        "name": "Goochland County",
                        "latitude": "37.72198000",
                        "longitude": "-77.91636000"
                    },
                    {
                        "id": 117401,
                        "name": "Gordonsville",
                        "latitude": "38.13736000",
                        "longitude": "-78.18778000"
                    },
                    {
                        "id": 117564,
                        "name": "Grayson County",
                        "latitude": "36.65659000",
                        "longitude": "-81.22505000"
                    },
                    {
                        "id": 117572,
                        "name": "Great Falls",
                        "latitude": "38.99817000",
                        "longitude": "-77.28832000"
                    },
                    {
                        "id": 117617,
                        "name": "Greenbriar",
                        "latitude": "38.87345000",
                        "longitude": "-77.40082000"
                    },
                    {
                        "id": 117640,
                        "name": "Greene County",
                        "latitude": "38.29760000",
                        "longitude": "-78.46688000"
                    },
                    {
                        "id": 117673,
                        "name": "Greensville County",
                        "latitude": "36.67585000",
                        "longitude": "-77.55958000"
                    },
                    {
                        "id": 117726,
                        "name": "Gretna",
                        "latitude": "36.95375000",
                        "longitude": "-79.35891000"
                    },
                    {
                        "id": 117753,
                        "name": "Grottoes",
                        "latitude": "38.26735000",
                        "longitude": "-78.82586000"
                    },
                    {
                        "id": 117763,
                        "name": "Groveton",
                        "latitude": "38.76734000",
                        "longitude": "-77.08470000"
                    },
                    {
                        "id": 117768,
                        "name": "Grundy",
                        "latitude": "37.27789000",
                        "longitude": "-82.09902000"
                    },
                    {
                        "id": 117860,
                        "name": "Halifax",
                        "latitude": "36.76597000",
                        "longitude": "-78.92834000"
                    },
                    {
                        "id": 117863,
                        "name": "Halifax County",
                        "latitude": "36.76695000",
                        "longitude": "-78.93662000"
                    },
                    {
                        "id": 117919,
                        "name": "Hampden Sydney",
                        "latitude": "37.24237000",
                        "longitude": "-78.45972000"
                    },
                    {
                        "id": 117931,
                        "name": "Hampton",
                        "latitude": "37.02987000",
                        "longitude": "-76.34522000"
                    },
                    {
                        "id": 117969,
                        "name": "Hanover",
                        "latitude": "37.76653000",
                        "longitude": "-77.37026000"
                    },
                    {
                        "id": 117974,
                        "name": "Hanover County",
                        "latitude": "37.76015000",
                        "longitude": "-77.49087000"
                    },
                    {
                        "id": 118070,
                        "name": "Harrisonburg",
                        "latitude": "38.44957000",
                        "longitude": "-78.86892000"
                    },
                    {
                        "id": 118184,
                        "name": "Hayfield",
                        "latitude": "38.75178000",
                        "longitude": "-77.13581000"
                    },
                    {
                        "id": 118187,
                        "name": "Haymarket",
                        "latitude": "38.81206000",
                        "longitude": "-77.63638000"
                    },
                    {
                        "id": 118225,
                        "name": "Heathsville",
                        "latitude": "37.91763000",
                        "longitude": "-76.47217000"
                    },
                    {
                        "id": 118294,
                        "name": "Henrico County",
                        "latitude": "37.45771000",
                        "longitude": "-77.29646000"
                    },
                    {
                        "id": 118303,
                        "name": "Henry County",
                        "latitude": "36.68470000",
                        "longitude": "-79.98152000"
                    },
                    {
                        "id": 118306,
                        "name": "Henry Fork",
                        "latitude": "36.96625000",
                        "longitude": "-79.87031000"
                    },
                    {
                        "id": 118336,
                        "name": "Herndon",
                        "latitude": "38.96955000",
                        "longitude": "-77.38610000"
                    },
                    {
                        "id": 118404,
                        "name": "Highland County",
                        "latitude": "38.36233000",
                        "longitude": "-79.56854000"
                    },
                    {
                        "id": 118415,
                        "name": "Highland Springs",
                        "latitude": "37.54598000",
                        "longitude": "-77.32776000"
                    },
                    {
                        "id": 118468,
                        "name": "Hillsville",
                        "latitude": "36.76263000",
                        "longitude": "-80.73479000"
                    },
                    {
                        "id": 118546,
                        "name": "Hollins",
                        "latitude": "37.34125000",
                        "longitude": "-79.94310000"
                    },
                    {
                        "id": 118564,
                        "name": "Hollymead",
                        "latitude": "38.11708000",
                        "longitude": "-78.44168000"
                    },
                    {
                        "id": 118612,
                        "name": "Honaker",
                        "latitude": "37.01622000",
                        "longitude": "-81.97429000"
                    },
                    {
                        "id": 118649,
                        "name": "Hopewell",
                        "latitude": "37.30432000",
                        "longitude": "-77.28720000"
                    },
                    {
                        "id": 118671,
                        "name": "Horse Pasture",
                        "latitude": "36.62847000",
                        "longitude": "-79.95087000"
                    },
                    {
                        "id": 118799,
                        "name": "Huntington",
                        "latitude": "38.79234000",
                        "longitude": "-77.07081000"
                    },
                    {
                        "id": 118832,
                        "name": "Hurt",
                        "latitude": "37.09264000",
                        "longitude": "-79.29641000"
                    },
                    {
                        "id": 118845,
                        "name": "Hybla Valley",
                        "latitude": "38.74761000",
                        "longitude": "-77.08303000"
                    },
                    {
                        "id": 118876,
                        "name": "Idylwood",
                        "latitude": "38.89511000",
                        "longitude": "-77.21165000"
                    },
                    {
                        "id": 118894,
                        "name": "Independence",
                        "latitude": "36.62245000",
                        "longitude": "-81.15309000"
                    },
                    {
                        "id": 118899,
                        "name": "Independent Hill",
                        "latitude": "38.63595000",
                        "longitude": "-77.43776000"
                    },
                    {
                        "id": 119033,
                        "name": "Isle of Wight County",
                        "latitude": "36.90673000",
                        "longitude": "-76.70913000"
                    },
                    {
                        "id": 119116,
                        "name": "James City County",
                        "latitude": "37.31332000",
                        "longitude": "-76.77376000"
                    },
                    {
                        "id": 119167,
                        "name": "Jefferson",
                        "latitude": "38.86456000",
                        "longitude": "-77.18776000"
                    },
                    {
                        "id": 119289,
                        "name": "Jolivue",
                        "latitude": "38.10985000",
                        "longitude": "-79.07308000"
                    },
                    {
                        "id": 119311,
                        "name": "Jonesville",
                        "latitude": "36.68898000",
                        "longitude": "-83.11100000"
                    },
                    {
                        "id": 119443,
                        "name": "Kenbridge",
                        "latitude": "36.96209000",
                        "longitude": "-78.12500000"
                    },
                    {
                        "id": 119563,
                        "name": "Kilmarnock",
                        "latitude": "37.71041000",
                        "longitude": "-76.37967000"
                    },
                    {
                        "id": 119588,
                        "name": "King and Queen County",
                        "latitude": "37.71862000",
                        "longitude": "-76.89527000"
                    },
                    {
                        "id": 119589,
                        "name": "King and Queen Court House",
                        "latitude": "37.66986000",
                        "longitude": "-76.87746000"
                    },
                    {
                        "id": 119584,
                        "name": "King George",
                        "latitude": "38.26818000",
                        "longitude": "-77.18442000"
                    },
                    {
                        "id": 119585,
                        "name": "King George County",
                        "latitude": "38.27374000",
                        "longitude": "-77.15651000"
                    },
                    {
                        "id": 119586,
                        "name": "King William",
                        "latitude": "37.68736000",
                        "longitude": "-77.01358000"
                    },
                    {
                        "id": 119587,
                        "name": "King William County",
                        "latitude": "37.70660000",
                        "longitude": "-77.08839000"
                    },
                    {
                        "id": 119604,
                        "name": "Kings Park",
                        "latitude": "38.80622000",
                        "longitude": "-77.24332000"
                    },
                    {
                        "id": 119606,
                        "name": "Kings Park West",
                        "latitude": "38.81443000",
                        "longitude": "-77.29582000"
                    },
                    {
                        "id": 119868,
                        "name": "Lake Barcroft",
                        "latitude": "38.84789000",
                        "longitude": "-77.15581000"
                    },
                    {
                        "id": 119947,
                        "name": "Lake Monticello",
                        "latitude": "37.92320000",
                        "longitude": "-78.33473000"
                    },
                    {
                        "id": 119968,
                        "name": "Lake Ridge",
                        "latitude": "38.68789000",
                        "longitude": "-77.29776000"
                    },
                    {
                        "id": 120031,
                        "name": "Lakeside",
                        "latitude": "37.60765000",
                        "longitude": "-77.47693000"
                    },
                    {
                        "id": 120091,
                        "name": "Lancaster County",
                        "latitude": "37.70171000",
                        "longitude": "-76.42023000"
                    },
                    {
                        "id": 120191,
                        "name": "Laurel",
                        "latitude": "37.64292000",
                        "longitude": "-77.50887000"
                    },
                    {
                        "id": 120197,
                        "name": "Laurel Hill",
                        "latitude": "38.71663000",
                        "longitude": "-77.23686000"
                    },
                    {
                        "id": 120245,
                        "name": "Lawrenceville",
                        "latitude": "36.75765000",
                        "longitude": "-77.84694000"
                    },
                    {
                        "id": 120253,
                        "name": "Laymantown",
                        "latitude": "37.36569000",
                        "longitude": "-79.85754000"
                    },
                    {
                        "id": 120288,
                        "name": "Lebanon",
                        "latitude": "36.90094000",
                        "longitude": "-82.08013000"
                    },
                    {
                        "id": 120315,
                        "name": "Lee County",
                        "latitude": "36.70545000",
                        "longitude": "-83.12853000"
                    },
                    {
                        "id": 120326,
                        "name": "Leesburg",
                        "latitude": "39.11566000",
                        "longitude": "-77.56360000"
                    },
                    {
                        "id": 120447,
                        "name": "Lexington",
                        "latitude": "37.78402000",
                        "longitude": "-79.44282000"
                    },
                    {
                        "id": 120549,
                        "name": "Lincolnia",
                        "latitude": "38.81845000",
                        "longitude": "-77.14331000"
                    },
                    {
                        "id": 120591,
                        "name": "Linton Hall",
                        "latitude": "38.75984000",
                        "longitude": "-77.57499000"
                    },
                    {
                        "id": 120669,
                        "name": "Loch Lomond",
                        "latitude": "38.78623000",
                        "longitude": "-77.47804000"
                    },
                    {
                        "id": 120777,
                        "name": "Lorton",
                        "latitude": "38.70428000",
                        "longitude": "-77.22776000"
                    },
                    {
                        "id": 120801,
                        "name": "Loudoun County",
                        "latitude": "39.09068000",
                        "longitude": "-77.63572000"
                    },
                    {
                        "id": 120802,
                        "name": "Loudoun Valley Estates",
                        "latitude": "38.98081000",
                        "longitude": "-77.50790000"
                    },
                    {
                        "id": 120805,
                        "name": "Louisa",
                        "latitude": "38.02514000",
                        "longitude": "-78.00416000"
                    },
                    {
                        "id": 120806,
                        "name": "Louisa County",
                        "latitude": "37.97821000",
                        "longitude": "-77.96298000"
                    },
                    {
                        "id": 120827,
                        "name": "Lovettsville",
                        "latitude": "39.27260000",
                        "longitude": "-77.63666000"
                    },
                    {
                        "id": 120830,
                        "name": "Lovingston",
                        "latitude": "37.75986000",
                        "longitude": "-78.87086000"
                    },
                    {
                        "id": 120844,
                        "name": "Lowes Island",
                        "latitude": "39.05983000",
                        "longitude": "-77.35221000"
                    },
                    {
                        "id": 120886,
                        "name": "Lunenburg",
                        "latitude": "36.96098000",
                        "longitude": "-78.26555000"
                    },
                    {
                        "id": 120889,
                        "name": "Lunenburg County",
                        "latitude": "36.94621000",
                        "longitude": "-78.24057000"
                    },
                    {
                        "id": 120890,
                        "name": "Luray",
                        "latitude": "38.66540000",
                        "longitude": "-78.45945000"
                    },
                    {
                        "id": 120916,
                        "name": "Lynchburg",
                        "latitude": "37.41375000",
                        "longitude": "-79.14225000"
                    },
                    {
                        "id": 120920,
                        "name": "Lyndhurst",
                        "latitude": "38.02930000",
                        "longitude": "-78.94502000"
                    },
                    {
                        "id": 120991,
                        "name": "Madison",
                        "latitude": "38.38041000",
                        "longitude": "-78.25750000"
                    },
                    {
                        "id": 121013,
                        "name": "Madison County",
                        "latitude": "38.41369000",
                        "longitude": "-78.27924000"
                    },
                    {
                        "id": 121020,
                        "name": "Madison Heights",
                        "latitude": "37.43098000",
                        "longitude": "-79.12308000"
                    },
                    {
                        "id": 121082,
                        "name": "Manassas",
                        "latitude": "38.75095000",
                        "longitude": "-77.47527000"
                    },
                    {
                        "id": 121083,
                        "name": "Manassas Park",
                        "latitude": "38.78400000",
                        "longitude": "-77.46971000"
                    },
                    {
                        "id": 121160,
                        "name": "Mantua",
                        "latitude": "38.85372000",
                        "longitude": "-77.25943000"
                    },
                    {
                        "id": 121241,
                        "name": "Marion",
                        "latitude": "36.83484000",
                        "longitude": "-81.51484000"
                    },
                    {
                        "id": 121306,
                        "name": "Marshall",
                        "latitude": "38.86484000",
                        "longitude": "-77.85777000"
                    },
                    {
                        "id": 121350,
                        "name": "Martinsville",
                        "latitude": "36.69153000",
                        "longitude": "-79.87254000"
                    },
                    {
                        "id": 121389,
                        "name": "Massanetta Springs",
                        "latitude": "38.40040000",
                        "longitude": "-78.83419000"
                    },
                    {
                        "id": 121390,
                        "name": "Massanutten",
                        "latitude": "38.40957000",
                        "longitude": "-78.73780000"
                    },
                    {
                        "id": 121403,
                        "name": "Mathews",
                        "latitude": "37.43708000",
                        "longitude": "-76.31994000"
                    },
                    {
                        "id": 121404,
                        "name": "Mathews County",
                        "latitude": "37.41731000",
                        "longitude": "-76.27129000"
                    },
                    {
                        "id": 121406,
                        "name": "Matoaca",
                        "latitude": "37.23043000",
                        "longitude": "-77.47749000"
                    },
                    {
                        "id": 121527,
                        "name": "McLean",
                        "latitude": "38.93428000",
                        "longitude": "-77.17748000"
                    },
                    {
                        "id": 121566,
                        "name": "Meadowbrook",
                        "latitude": "37.44882000",
                        "longitude": "-77.47353000"
                    },
                    {
                        "id": 121583,
                        "name": "Mechanicsville",
                        "latitude": "37.60876000",
                        "longitude": "-77.37331000"
                    },
                    {
                        "id": 121588,
                        "name": "Mecklenburg County",
                        "latitude": "36.68036000",
                        "longitude": "-78.36273000"
                    },
                    {
                        "id": 121706,
                        "name": "Merrifield",
                        "latitude": "38.87428000",
                        "longitude": "-77.22693000"
                    },
                    {
                        "id": 121709,
                        "name": "Merrimac",
                        "latitude": "37.18957000",
                        "longitude": "-80.42561000"
                    },
                    {
                        "id": 121778,
                        "name": "Middlesex County",
                        "latitude": "37.59737000",
                        "longitude": "-76.57814000"
                    },
                    {
                        "id": 121789,
                        "name": "Middletown",
                        "latitude": "39.02761000",
                        "longitude": "-78.28056000"
                    },
                    {
                        "id": 122105,
                        "name": "Montclair",
                        "latitude": "38.61095000",
                        "longitude": "-77.33971000"
                    },
                    {
                        "id": 122119,
                        "name": "Monterey",
                        "latitude": "38.41234000",
                        "longitude": "-79.58060000"
                    },
                    {
                        "id": 122151,
                        "name": "Montgomery County",
                        "latitude": "37.17404000",
                        "longitude": "-80.38700000"
                    },
                    {
                        "id": 122179,
                        "name": "Montrose",
                        "latitude": "37.52070000",
                        "longitude": "-77.37831000"
                    },
                    {
                        "id": 122186,
                        "name": "Montross",
                        "latitude": "38.09513000",
                        "longitude": "-76.82746000"
                    },
                    {
                        "id": 122310,
                        "name": "Motley",
                        "latitude": "37.06959000",
                        "longitude": "-79.34114000"
                    },
                    {
                        "id": 122346,
                        "name": "Mount Hermon",
                        "latitude": "36.67847000",
                        "longitude": "-79.42225000"
                    },
                    {
                        "id": 122357,
                        "name": "Mount Jackson",
                        "latitude": "38.74595000",
                        "longitude": "-78.64224000"
                    },
                    {
                        "id": 122404,
                        "name": "Mount Vernon",
                        "latitude": "38.71919000",
                        "longitude": "-77.10726000"
                    },
                    {
                        "id": 122426,
                        "name": "Mountain Road",
                        "latitude": "36.75958000",
                        "longitude": "-78.98696000"
                    },
                    {
                        "id": 122566,
                        "name": "Narrows",
                        "latitude": "37.33151000",
                        "longitude": "-80.81119000"
                    },
                    {
                        "id": 122623,
                        "name": "Nellysford",
                        "latitude": "37.89042000",
                        "longitude": "-78.87224000"
                    },
                    {
                        "id": 122627,
                        "name": "Nelson County",
                        "latitude": "37.78741000",
                        "longitude": "-78.88676000"
                    },
                    {
                        "id": 122659,
                        "name": "New Baltimore",
                        "latitude": "38.76734000",
                        "longitude": "-77.72833000"
                    },
                    {
                        "id": 122686,
                        "name": "New Castle",
                        "latitude": "37.50013000",
                        "longitude": "-80.11088000"
                    },
                    {
                        "id": 122734,
                        "name": "New Kent",
                        "latitude": "37.51765000",
                        "longitude": "-76.97886000"
                    },
                    {
                        "id": 122735,
                        "name": "New Kent County",
                        "latitude": "37.50514000",
                        "longitude": "-76.99713000"
                    },
                    {
                        "id": 122751,
                        "name": "New Market",
                        "latitude": "38.64790000",
                        "longitude": "-78.67141000"
                    },
                    {
                        "id": 122830,
                        "name": "Newington",
                        "latitude": "38.73845000",
                        "longitude": "-77.18498000"
                    },
                    {
                        "id": 122856,
                        "name": "Newport News",
                        "latitude": "37.08339000",
                        "longitude": "-76.46965000"
                    },
                    {
                        "id": 122928,
                        "name": "Nokesville",
                        "latitude": "38.69873000",
                        "longitude": "-77.57971000"
                    },
                    {
                        "id": 122941,
                        "name": "Norfolk",
                        "latitude": "36.84681000",
                        "longitude": "-76.28522000"
                    },
                    {
                        "id": 123105,
                        "name": "North Shore",
                        "latitude": "37.08209000",
                        "longitude": "-79.65836000"
                    },
                    {
                        "id": 123110,
                        "name": "North Springfield",
                        "latitude": "38.80428000",
                        "longitude": "-77.20470000"
                    },
                    {
                        "id": 123137,
                        "name": "Northampton County",
                        "latitude": "37.30078000",
                        "longitude": "-75.92854000"
                    },
                    {
                        "id": 123167,
                        "name": "Northumberland County",
                        "latitude": "37.88244000",
                        "longitude": "-76.47171000"
                    },
                    {
                        "id": 123183,
                        "name": "Norton",
                        "latitude": "36.93343000",
                        "longitude": "-82.62905000"
                    },
                    {
                        "id": 123206,
                        "name": "Nottoway County",
                        "latitude": "37.14306000",
                        "longitude": "-78.05126000"
                    },
                    {
                        "id": 123238,
                        "name": "Oak Grove",
                        "latitude": "38.98400000",
                        "longitude": "-77.40388000"
                    },
                    {
                        "id": 123246,
                        "name": "Oak Hill",
                        "latitude": "38.92580000",
                        "longitude": "-77.40156000"
                    },
                    {
                        "id": 123305,
                        "name": "Oakton",
                        "latitude": "38.88095000",
                        "longitude": "-77.30082000"
                    },
                    {
                        "id": 123322,
                        "name": "Occoquan",
                        "latitude": "38.68373000",
                        "longitude": "-77.26026000"
                    },
                    {
                        "id": 123469,
                        "name": "Onancock",
                        "latitude": "37.71180000",
                        "longitude": "-75.74910000"
                    },
                    {
                        "id": 123506,
                        "name": "Orange",
                        "latitude": "38.24541000",
                        "longitude": "-78.11083000"
                    },
                    {
                        "id": 123518,
                        "name": "Orange County",
                        "latitude": "38.24624000",
                        "longitude": "-78.01349000"
                    },
                    {
                        "id": 123718,
                        "name": "Page County",
                        "latitude": "38.61998000",
                        "longitude": "-78.48413000"
                    },
                    {
                        "id": 123773,
                        "name": "Palmyra",
                        "latitude": "37.86097000",
                        "longitude": "-78.26334000"
                    },
                    {
                        "id": 123802,
                        "name": "Pannill Fork",
                        "latitude": "36.70903000",
                        "longitude": "-80.01310000"
                    },
                    {
                        "id": 123809,
                        "name": "Pantops",
                        "latitude": "38.03379000",
                        "longitude": "-78.45507000"
                    },
                    {
                        "id": 123909,
                        "name": "Passapatanzy",
                        "latitude": "38.29735000",
                        "longitude": "-77.31415000"
                    },
                    {
                        "id": 123912,
                        "name": "Patrick County",
                        "latitude": "36.67833000",
                        "longitude": "-80.28435000"
                    },
                    {
                        "id": 123913,
                        "name": "Patrick Springs",
                        "latitude": "36.64180000",
                        "longitude": "-80.19505000"
                    },
                    {
                        "id": 123962,
                        "name": "Pearisburg",
                        "latitude": "37.32673000",
                        "longitude": "-80.73702000"
                    },
                    {
                        "id": 124006,
                        "name": "Pembroke",
                        "latitude": "37.31957000",
                        "longitude": "-80.63895000"
                    },
                    {
                        "id": 124032,
                        "name": "Pennington Gap",
                        "latitude": "36.75842000",
                        "longitude": "-83.02711000"
                    },
                    {
                        "id": 124105,
                        "name": "Petersburg",
                        "latitude": "37.22793000",
                        "longitude": "-77.40193000"
                    },
                    {
                        "id": 124205,
                        "name": "Pimmit Hills",
                        "latitude": "38.91289000",
                        "longitude": "-77.20081000"
                    },
                    {
                        "id": 124306,
                        "name": "Pittsylvania County",
                        "latitude": "36.82133000",
                        "longitude": "-79.39711000"
                    },
                    {
                        "id": 124393,
                        "name": "Plum Creek",
                        "latitude": "37.12984000",
                        "longitude": "-80.50060000"
                    },
                    {
                        "id": 124489,
                        "name": "Poquoson",
                        "latitude": "37.12237000",
                        "longitude": "-76.34578000"
                    },
                    {
                        "id": 124569,
                        "name": "Portsmouth",
                        "latitude": "36.83543000",
                        "longitude": "-76.29827000"
                    },
                    {
                        "id": 124572,
                        "name": "Portsmouth Heights",
                        "latitude": "36.82098000",
                        "longitude": "-76.36883000"
                    },
                    {
                        "id": 124584,
                        "name": "Potomac Mills",
                        "latitude": "38.64595000",
                        "longitude": "-77.29415000"
                    },
                    {
                        "id": 124618,
                        "name": "Powhatan County",
                        "latitude": "37.55020000",
                        "longitude": "-77.91519000"
                    },
                    {
                        "id": 124665,
                        "name": "Prices Fork",
                        "latitude": "37.20985000",
                        "longitude": "-80.49005000"
                    },
                    {
                        "id": 124672,
                        "name": "Prince Edward County",
                        "latitude": "37.22430000",
                        "longitude": "-78.44108000"
                    },
                    {
                        "id": 124674,
                        "name": "Prince George",
                        "latitude": "37.22043000",
                        "longitude": "-77.28803000"
                    },
                    {
                        "id": 124675,
                        "name": "Prince George County",
                        "latitude": "37.18653000",
                        "longitude": "-77.22413000"
                    },
                    {
                        "id": 124677,
                        "name": "Prince William County",
                        "latitude": "38.70167000",
                        "longitude": "-77.47766000"
                    },
                    {
                        "id": 124734,
                        "name": "Pulaski",
                        "latitude": "37.04790000",
                        "longitude": "-80.77979000"
                    },
                    {
                        "id": 124742,
                        "name": "Pulaski County",
                        "latitude": "37.06361000",
                        "longitude": "-80.71434000"
                    },
                    {
                        "id": 124754,
                        "name": "Purcellville",
                        "latitude": "39.13677000",
                        "longitude": "-77.71472000"
                    },
                    {
                        "id": 124780,
                        "name": "Quantico Station",
                        "latitude": "38.52263000",
                        "longitude": "-77.31834000"
                    },
                    {
                        "id": 124816,
                        "name": "Radford",
                        "latitude": "37.13179000",
                        "longitude": "-80.57645000"
                    },
                    {
                        "id": 124898,
                        "name": "Rappahannock County",
                        "latitude": "38.68471000",
                        "longitude": "-78.15925000"
                    },
                    {
                        "id": 124904,
                        "name": "Raven",
                        "latitude": "37.08706000",
                        "longitude": "-81.85512000"
                    },
                    {
                        "id": 124911,
                        "name": "Ravensworth",
                        "latitude": "38.80400000",
                        "longitude": "-77.22054000"
                    },
                    {
                        "id": 125036,
                        "name": "Reston",
                        "latitude": "38.96872000",
                        "longitude": "-77.34110000"
                    },
                    {
                        "id": 125082,
                        "name": "Richlands",
                        "latitude": "37.09317000",
                        "longitude": "-81.79373000"
                    },
                    {
                        "id": 125088,
                        "name": "Richmond",
                        "latitude": "37.55376000",
                        "longitude": "-77.46026000"
                    },
                    {
                        "id": 125100,
                        "name": "Richmond County",
                        "latitude": "37.93705000",
                        "longitude": "-76.72968000"
                    },
                    {
                        "id": 125228,
                        "name": "Roanoke",
                        "latitude": "37.27097000",
                        "longitude": "-79.94143000"
                    },
                    {
                        "id": 125231,
                        "name": "Roanoke County",
                        "latitude": "37.20907000",
                        "longitude": "-80.05085000"
                    },
                    {
                        "id": 125292,
                        "name": "Rockbridge County",
                        "latitude": "37.81461000",
                        "longitude": "-79.44758000"
                    },
                    {
                        "id": 125306,
                        "name": "Rockingham County",
                        "latitude": "38.51213000",
                        "longitude": "-78.87576000"
                    },
                    {
                        "id": 125336,
                        "name": "Rocky Mount",
                        "latitude": "36.99764000",
                        "longitude": "-79.89198000"
                    },
                    {
                        "id": 125405,
                        "name": "Rose Hill",
                        "latitude": "38.78872000",
                        "longitude": "-77.11276000"
                    },
                    {
                        "id": 125452,
                        "name": "Rosslyn",
                        "latitude": "38.89678000",
                        "longitude": "-77.07248000"
                    },
                    {
                        "id": 125502,
                        "name": "Ruckersville",
                        "latitude": "38.23319000",
                        "longitude": "-78.36917000"
                    },
                    {
                        "id": 125518,
                        "name": "Rural Retreat",
                        "latitude": "36.89373000",
                        "longitude": "-81.27593000"
                    },
                    {
                        "id": 125524,
                        "name": "Rushmere",
                        "latitude": "37.06681000",
                        "longitude": "-76.67635000"
                    },
                    {
                        "id": 125539,
                        "name": "Russell County",
                        "latitude": "36.93376000",
                        "longitude": "-82.09564000"
                    },
                    {
                        "id": 125546,
                        "name": "Rustburg",
                        "latitude": "37.27681000",
                        "longitude": "-79.10085000"
                    },
                    {
                        "id": 125734,
                        "name": "Salem",
                        "latitude": "37.29347000",
                        "longitude": "-80.05476000"
                    },
                    {
                        "id": 125771,
                        "name": "Saltville",
                        "latitude": "36.88150000",
                        "longitude": "-81.76206000"
                    },
                    {
                        "id": 125773,
                        "name": "Saluda",
                        "latitude": "37.60597000",
                        "longitude": "-76.59495000"
                    },
                    {
                        "id": 125873,
                        "name": "Sandston",
                        "latitude": "37.52348000",
                        "longitude": "-77.31581000"
                    },
                    {
                        "id": 126050,
                        "name": "Scott County",
                        "latitude": "36.71422000",
                        "longitude": "-82.60298000"
                    },
                    {
                        "id": 126171,
                        "name": "Seven Corners",
                        "latitude": "38.87206000",
                        "longitude": "-77.15526000"
                    },
                    {
                        "id": 126252,
                        "name": "Shawnee Land",
                        "latitude": "39.19149000",
                        "longitude": "-78.34556000"
                    },
                    {
                        "id": 126254,
                        "name": "Shawsville",
                        "latitude": "37.16847000",
                        "longitude": "-80.25532000"
                    },
                    {
                        "id": 126303,
                        "name": "Shenandoah",
                        "latitude": "38.48512000",
                        "longitude": "-78.62502000"
                    },
                    {
                        "id": 126305,
                        "name": "Shenandoah County",
                        "latitude": "38.85839000",
                        "longitude": "-78.57060000"
                    },
                    {
                        "id": 126306,
                        "name": "Shenandoah Farms",
                        "latitude": "38.98178000",
                        "longitude": "-78.07555000"
                    },
                    {
                        "id": 126377,
                        "name": "Short Pump",
                        "latitude": "37.65042000",
                        "longitude": "-77.61249000"
                    },
                    {
                        "id": 126519,
                        "name": "Smithfield",
                        "latitude": "36.98237000",
                        "longitude": "-76.63107000"
                    },
                    {
                        "id": 126537,
                        "name": "Smyth County",
                        "latitude": "36.84388000",
                        "longitude": "-81.53702000"
                    },
                    {
                        "id": 126628,
                        "name": "South Boston",
                        "latitude": "36.69875000",
                        "longitude": "-78.90140000"
                    },
                    {
                        "id": 126671,
                        "name": "South Hill",
                        "latitude": "36.72653000",
                        "longitude": "-78.12889000"
                    },
                    {
                        "id": 126716,
                        "name": "South Riding",
                        "latitude": "38.92094000",
                        "longitude": "-77.50388000"
                    },
                    {
                        "id": 126731,
                        "name": "South Suffolk",
                        "latitude": "36.71709000",
                        "longitude": "-76.59023000"
                    },
                    {
                        "id": 126759,
                        "name": "Southampton County",
                        "latitude": "36.72040000",
                        "longitude": "-77.10609000"
                    },
                    {
                        "id": 126767,
                        "name": "Southern Gateway",
                        "latitude": "38.34507000",
                        "longitude": "-77.50352000"
                    },
                    {
                        "id": 126847,
                        "name": "Spotsylvania County",
                        "latitude": "38.18502000",
                        "longitude": "-77.65597000"
                    },
                    {
                        "id": 126848,
                        "name": "Spotsylvania Courthouse",
                        "latitude": "38.19791000",
                        "longitude": "-77.58777000"
                    },
                    {
                        "id": 126896,
                        "name": "Springfield",
                        "latitude": "38.78928000",
                        "longitude": "-77.18720000"
                    },
                    {
                        "id": 126916,
                        "name": "Springville",
                        "latitude": "37.19651000",
                        "longitude": "-81.40288000"
                    },
                    {
                        "id": 126933,
                        "name": "Stafford",
                        "latitude": "38.42207000",
                        "longitude": "-77.40832000"
                    },
                    {
                        "id": 126937,
                        "name": "Stafford County",
                        "latitude": "38.42070000",
                        "longitude": "-77.45743000"
                    },
                    {
                        "id": 126948,
                        "name": "Stanardsville",
                        "latitude": "38.29735000",
                        "longitude": "-78.44001000"
                    },
                    {
                        "id": 126959,
                        "name": "Stanley",
                        "latitude": "38.57540000",
                        "longitude": "-78.50251000"
                    },
                    {
                        "id": 126963,
                        "name": "Stanleytown",
                        "latitude": "36.74430000",
                        "longitude": "-79.96282000"
                    },
                    {
                        "id": 127001,
                        "name": "Staunton",
                        "latitude": "38.14991000",
                        "longitude": "-79.07320000"
                    },
                    {
                        "id": 127020,
                        "name": "Stephens City",
                        "latitude": "39.08344000",
                        "longitude": "-78.21806000"
                    },
                    {
                        "id": 127027,
                        "name": "Sterling",
                        "latitude": "39.00622000",
                        "longitude": "-77.42860000"
                    },
                    {
                        "id": 127120,
                        "name": "Strasburg",
                        "latitude": "38.98872000",
                        "longitude": "-78.35862000"
                    },
                    {
                        "id": 127144,
                        "name": "Stuart",
                        "latitude": "36.64097000",
                        "longitude": "-80.26561000"
                    },
                    {
                        "id": 127145,
                        "name": "Stuarts Draft",
                        "latitude": "38.03014000",
                        "longitude": "-79.03364000"
                    },
                    {
                        "id": 127163,
                        "name": "Sudley",
                        "latitude": "38.79289000",
                        "longitude": "-77.49749000"
                    },
                    {
                        "id": 127166,
                        "name": "Suffolk",
                        "latitude": "36.72836000",
                        "longitude": "-76.58496000"
                    },
                    {
                        "id": 127175,
                        "name": "Sugarland Run",
                        "latitude": "39.03761000",
                        "longitude": "-77.37526000"
                    },
                    {
                        "id": 127292,
                        "name": "Surry",
                        "latitude": "37.13793000",
                        "longitude": "-76.83524000"
                    },
                    {
                        "id": 127295,
                        "name": "Surry County",
                        "latitude": "37.11691000",
                        "longitude": "-76.88831000"
                    },
                    {
                        "id": 127300,
                        "name": "Sussex",
                        "latitude": "36.91515000",
                        "longitude": "-77.27914000"
                    },
                    {
                        "id": 127304,
                        "name": "Sussex County",
                        "latitude": "36.92175000",
                        "longitude": "-77.26179000"
                    },
                    {
                        "id": 127425,
                        "name": "Tappahannock",
                        "latitude": "37.92541000",
                        "longitude": "-76.85913000"
                    },
                    {
                        "id": 127469,
                        "name": "Tazewell",
                        "latitude": "37.11484000",
                        "longitude": "-81.51955000"
                    },
                    {
                        "id": 127470,
                        "name": "Tazewell County",
                        "latitude": "37.12497000",
                        "longitude": "-81.56066000"
                    },
                    {
                        "id": 127658,
                        "name": "Timberlake",
                        "latitude": "37.32070000",
                        "longitude": "-79.25753000"
                    },
                    {
                        "id": 127660,
                        "name": "Timberville",
                        "latitude": "38.63901000",
                        "longitude": "-78.77391000"
                    },
                    {
                        "id": 127818,
                        "name": "Triangle",
                        "latitude": "38.54679000",
                        "longitude": "-77.33665000"
                    },
                    {
                        "id": 127868,
                        "name": "Tuckahoe",
                        "latitude": "37.59015000",
                        "longitude": "-77.55638000"
                    },
                    {
                        "id": 127933,
                        "name": "Twin Lakes",
                        "latitude": "38.24927000",
                        "longitude": "-78.44378000"
                    },
                    {
                        "id": 127952,
                        "name": "Tysons Corner",
                        "latitude": "38.91872000",
                        "longitude": "-77.23109000"
                    },
                    {
                        "id": 128006,
                        "name": "Union Hall",
                        "latitude": "37.01875000",
                        "longitude": "-79.68642000"
                    },
                    {
                        "id": 128026,
                        "name": "University Center",
                        "latitude": "39.05705000",
                        "longitude": "-77.44415000"
                    },
                    {
                        "id": 128202,
                        "name": "Verona",
                        "latitude": "38.20208000",
                        "longitude": "-79.00836000"
                    },
                    {
                        "id": 128221,
                        "name": "Victoria",
                        "latitude": "36.99487000",
                        "longitude": "-78.22722000"
                    },
                    {
                        "id": 128234,
                        "name": "Vienna",
                        "latitude": "38.90122000",
                        "longitude": "-77.26526000"
                    },
                    {
                        "id": 128281,
                        "name": "Vinton",
                        "latitude": "37.28097000",
                        "longitude": "-79.89698000"
                    },
                    {
                        "id": 128288,
                        "name": "Virginia Beach",
                        "latitude": "36.85293000",
                        "longitude": "-75.97799000"
                    },
                    {
                        "id": 128469,
                        "name": "Warm Springs",
                        "latitude": "38.04624000",
                        "longitude": "-79.79061000"
                    },
                    {
                        "id": 128492,
                        "name": "Warren County",
                        "latitude": "38.90878000",
                        "longitude": "-78.20746000"
                    },
                    {
                        "id": 128507,
                        "name": "Warrenton",
                        "latitude": "38.71345000",
                        "longitude": "-77.79527000"
                    },
                    {
                        "id": 128518,
                        "name": "Warsaw",
                        "latitude": "37.95874000",
                        "longitude": "-76.75801000"
                    },
                    {
                        "id": 128543,
                        "name": "Washington",
                        "latitude": "38.71345000",
                        "longitude": "-78.15944000"
                    },
                    {
                        "id": 128567,
                        "name": "Washington County",
                        "latitude": "36.72448000",
                        "longitude": "-81.95966000"
                    },
                    {
                        "id": 128644,
                        "name": "Wattsville",
                        "latitude": "37.93401000",
                        "longitude": "-75.49965000"
                    },
                    {
                        "id": 128667,
                        "name": "Waverly",
                        "latitude": "37.03598000",
                        "longitude": "-77.09524000"
                    },
                    {
                        "id": 128709,
                        "name": "Waynesboro",
                        "latitude": "38.06847000",
                        "longitude": "-78.88947000"
                    },
                    {
                        "id": 128728,
                        "name": "Weber City",
                        "latitude": "37.75514000",
                        "longitude": "-78.28389000"
                    },
                    {
                        "id": 128867,
                        "name": "West Falls Church",
                        "latitude": "38.89094000",
                        "longitude": "-77.18443000"
                    },
                    {
                        "id": 128877,
                        "name": "West Gate",
                        "latitude": "38.78289000",
                        "longitude": "-77.49749000"
                    },
                    {
                        "id": 128924,
                        "name": "West Lynchburg",
                        "latitude": "37.40320000",
                        "longitude": "-79.17808000"
                    },
                    {
                        "id": 128960,
                        "name": "West Point",
                        "latitude": "37.53153000",
                        "longitude": "-76.79635000"
                    },
                    {
                        "id": 128984,
                        "name": "West Springfield",
                        "latitude": "38.77261000",
                        "longitude": "-77.22109000"
                    },
                    {
                        "id": 129055,
                        "name": "Westmoreland County",
                        "latitude": "38.11282000",
                        "longitude": "-76.79991000"
                    },
                    {
                        "id": 129099,
                        "name": "Weyers Cave",
                        "latitude": "38.28846000",
                        "longitude": "-78.91308000"
                    },
                    {
                        "id": 129268,
                        "name": "Williamsburg",
                        "latitude": "37.27070000",
                        "longitude": "-76.70746000"
                    },
                    {
                        "id": 129356,
                        "name": "Winchester",
                        "latitude": "39.18566000",
                        "longitude": "-78.16333000"
                    },
                    {
                        "id": 129381,
                        "name": "Windsor",
                        "latitude": "36.80848000",
                        "longitude": "-76.74412000"
                    },
                    {
                        "id": 129459,
                        "name": "Wise",
                        "latitude": "36.97593000",
                        "longitude": "-82.57571000"
                    },
                    {
                        "id": 129461,
                        "name": "Wise County",
                        "latitude": "36.97522000",
                        "longitude": "-82.62124000"
                    },
                    {
                        "id": 129474,
                        "name": "Wolf Trap",
                        "latitude": "38.93983000",
                        "longitude": "-77.28609000"
                    },
                    {
                        "id": 129500,
                        "name": "Woodbridge",
                        "latitude": "38.65817000",
                        "longitude": "-77.24970000"
                    },
                    {
                        "id": 129505,
                        "name": "Woodburn",
                        "latitude": "38.84745000",
                        "longitude": "-77.23605000"
                    },
                    {
                        "id": 129525,
                        "name": "Woodlake",
                        "latitude": "37.42106000",
                        "longitude": "-77.67931000"
                    },
                    {
                        "id": 129535,
                        "name": "Woodlawn",
                        "latitude": "36.72235000",
                        "longitude": "-80.82285000"
                    },
                    {
                        "id": 129562,
                        "name": "Woodstock",
                        "latitude": "38.88178000",
                        "longitude": "-78.50584000"
                    },
                    {
                        "id": 129630,
                        "name": "Wyndham",
                        "latitude": "37.69848000",
                        "longitude": "-77.61249000"
                    },
                    {
                        "id": 129644,
                        "name": "Wythe County",
                        "latitude": "36.91713000",
                        "longitude": "-81.07859000"
                    },
                    {
                        "id": 129645,
                        "name": "Wytheville",
                        "latitude": "36.94845000",
                        "longitude": "-81.08481000"
                    },
                    {
                        "id": 129696,
                        "name": "York County",
                        "latitude": "37.22541000",
                        "longitude": "-76.52046000"
                    },
                    {
                        "id": 129703,
                        "name": "Yorkshire",
                        "latitude": "38.79317000",
                        "longitude": "-77.44777000"
                    },
                    {
                        "id": 129705,
                        "name": "Yorktown",
                        "latitude": "37.23876000",
                        "longitude": "-76.50967000"
                    }
                ]
            },
            {
                "id": 1405,
                "name": "Wake Island",
                "iso2": "UM-79",
                "latitude": "19.27961900",
                "longitude": "166.64993480",
                "type": "islands \/ groups of islands",
                "cities": []
            },
            {
                "id": 1462,
                "name": "Washington",
                "iso2": "WA",
                "latitude": "47.75107410",
                "longitude": "-120.74013850",
                "type": "state",
                "cities": [
                    {
                        "id": 110979,
                        "name": "Aberdeen",
                        "latitude": "46.97537000",
                        "longitude": "-123.81572000"
                    },
                    {
                        "id": 111027,
                        "name": "Adams County",
                        "latitude": "46.98338000",
                        "longitude": "-118.56050000"
                    },
                    {
                        "id": 111063,
                        "name": "Ahtanum",
                        "latitude": "46.55957000",
                        "longitude": "-120.62201000"
                    },
                    {
                        "id": 111072,
                        "name": "Airway Heights",
                        "latitude": "47.64461000",
                        "longitude": "-117.59327000"
                    },
                    {
                        "id": 111138,
                        "name": "Alderton",
                        "latitude": "47.16955000",
                        "longitude": "-122.22928000"
                    },
                    {
                        "id": 111139,
                        "name": "Alderwood Manor",
                        "latitude": "47.82204000",
                        "longitude": "-122.28207000"
                    },
                    {
                        "id": 111164,
                        "name": "Algona",
                        "latitude": "47.27899000",
                        "longitude": "-122.25206000"
                    },
                    {
                        "id": 111205,
                        "name": "Allyn",
                        "latitude": "47.38565000",
                        "longitude": "-122.82764000"
                    },
                    {
                        "id": 111266,
                        "name": "Amboy",
                        "latitude": "45.91011000",
                        "longitude": "-122.44649000"
                    },
                    {
                        "id": 111278,
                        "name": "Ames Lake",
                        "latitude": "47.63288000",
                        "longitude": "-121.96623000"
                    },
                    {
                        "id": 111297,
                        "name": "Anacortes",
                        "latitude": "48.51260000",
                        "longitude": "-122.61267000"
                    },
                    {
                        "id": 111470,
                        "name": "Arlington",
                        "latitude": "48.19871000",
                        "longitude": "-122.12514000"
                    },
                    {
                        "id": 111474,
                        "name": "Arlington Heights",
                        "latitude": "48.20205000",
                        "longitude": "-122.06208000"
                    },
                    {
                        "id": 111501,
                        "name": "Artondale",
                        "latitude": "47.29954000",
                        "longitude": "-122.62069000"
                    },
                    {
                        "id": 111550,
                        "name": "Asotin",
                        "latitude": "46.33933000",
                        "longitude": "-117.04821000"
                    },
                    {
                        "id": 111551,
                        "name": "Asotin County",
                        "latitude": "46.19186000",
                        "longitude": "-117.20307000"
                    },
                    {
                        "id": 111632,
                        "name": "Auburn",
                        "latitude": "47.30732000",
                        "longitude": "-122.22845000"
                    },
                    {
                        "id": 111654,
                        "name": "Ault Field",
                        "latitude": "48.33812000",
                        "longitude": "-122.67441000"
                    },
                    {
                        "id": 111735,
                        "name": "Bainbridge Island",
                        "latitude": "47.62621000",
                        "longitude": "-122.52124000"
                    },
                    {
                        "id": 111795,
                        "name": "Bangor Trident Base",
                        "latitude": "47.72274000",
                        "longitude": "-122.71446000"
                    },
                    {
                        "id": 111813,
                        "name": "Barberton",
                        "latitude": "45.69317000",
                        "longitude": "-122.59899000"
                    },
                    {
                        "id": 111879,
                        "name": "Basin City",
                        "latitude": "46.59403000",
                        "longitude": "-119.15223000"
                    },
                    {
                        "id": 111907,
                        "name": "Battle Ground",
                        "latitude": "45.78095000",
                        "longitude": "-122.53343000"
                    },
                    {
                        "id": 112055,
                        "name": "Belfair",
                        "latitude": "47.45065000",
                        "longitude": "-122.82737000"
                    },
                    {
                        "id": 112117,
                        "name": "Bellevue",
                        "latitude": "47.61038000",
                        "longitude": "-122.20068000"
                    },
                    {
                        "id": 112120,
                        "name": "Bellingham",
                        "latitude": "48.75955000",
                        "longitude": "-122.48822000"
                    },
                    {
                        "id": 112198,
                        "name": "Benton City",
                        "latitude": "46.26319000",
                        "longitude": "-119.48780000"
                    },
                    {
                        "id": 112207,
                        "name": "Benton County",
                        "latitude": "46.23978000",
                        "longitude": "-119.51120000"
                    },
                    {
                        "id": 112282,
                        "name": "Bethel",
                        "latitude": "47.49398000",
                        "longitude": "-122.63125000"
                    },
                    {
                        "id": 112326,
                        "name": "Big Lake",
                        "latitude": "48.40288000",
                        "longitude": "-122.24127000"
                    },
                    {
                        "id": 112353,
                        "name": "Birch Bay",
                        "latitude": "48.91789000",
                        "longitude": "-122.74462000"
                    },
                    {
                        "id": 112374,
                        "name": "Black Diamond",
                        "latitude": "47.30871000",
                        "longitude": "-122.00317000"
                    },
                    {
                        "id": 112404,
                        "name": "Blaine",
                        "latitude": "48.99372000",
                        "longitude": "-122.74712000"
                    },
                    {
                        "id": 112547,
                        "name": "Bonney Lake",
                        "latitude": "47.17705000",
                        "longitude": "-122.18651000"
                    },
                    {
                        "id": 112595,
                        "name": "Bothell",
                        "latitude": "47.76232000",
                        "longitude": "-122.20540000"
                    },
                    {
                        "id": 112596,
                        "name": "Bothell East",
                        "latitude": "47.80631000",
                        "longitude": "-122.18427000"
                    },
                    {
                        "id": 112597,
                        "name": "Bothell West",
                        "latitude": "47.80527000",
                        "longitude": "-122.24064000"
                    },
                    {
                        "id": 112607,
                        "name": "Boulevard Park",
                        "latitude": "47.48927000",
                        "longitude": "-122.31512000"
                    },
                    {
                        "id": 112723,
                        "name": "Bremerton",
                        "latitude": "47.56732000",
                        "longitude": "-122.63264000"
                    },
                    {
                        "id": 112744,
                        "name": "Brewster",
                        "latitude": "48.09598000",
                        "longitude": "-119.78062000"
                    },
                    {
                        "id": 112768,
                        "name": "Bridgeport",
                        "latitude": "48.00820000",
                        "longitude": "-119.67116000"
                    },
                    {
                        "id": 112782,
                        "name": "Brier",
                        "latitude": "47.78454000",
                        "longitude": "-122.27429000"
                    },
                    {
                        "id": 112922,
                        "name": "Browns Point",
                        "latitude": "47.30038000",
                        "longitude": "-122.44124000"
                    },
                    {
                        "id": 112955,
                        "name": "Brush Prairie",
                        "latitude": "45.73289000",
                        "longitude": "-122.54649000"
                    },
                    {
                        "id": 112964,
                        "name": "Bryant",
                        "latitude": "48.23899000",
                        "longitude": "-122.15792000"
                    },
                    {
                        "id": 112967,
                        "name": "Bryn Mawr-Skyway",
                        "latitude": "47.49430000",
                        "longitude": "-122.24092000"
                    },
                    {
                        "id": 112988,
                        "name": "Buckley",
                        "latitude": "47.16316000",
                        "longitude": "-122.02678000"
                    },
                    {
                        "id": 113039,
                        "name": "Bunk Foss",
                        "latitude": "47.96171000",
                        "longitude": "-122.09441000"
                    },
                    {
                        "id": 113048,
                        "name": "Burbank",
                        "latitude": "46.19986000",
                        "longitude": "-119.01306000"
                    },
                    {
                        "id": 113052,
                        "name": "Burien",
                        "latitude": "47.47038000",
                        "longitude": "-122.34679000"
                    },
                    {
                        "id": 113064,
                        "name": "Burley",
                        "latitude": "47.41787000",
                        "longitude": "-122.63097000"
                    },
                    {
                        "id": 113076,
                        "name": "Burlington",
                        "latitude": "48.47566000",
                        "longitude": "-122.32544000"
                    },
                    {
                        "id": 113240,
                        "name": "Camano",
                        "latitude": "48.17399000",
                        "longitude": "-122.52821000"
                    },
                    {
                        "id": 113243,
                        "name": "Camas",
                        "latitude": "45.58706000",
                        "longitude": "-122.39954000"
                    },
                    {
                        "id": 113338,
                        "name": "Canterwood",
                        "latitude": "47.37510000",
                        "longitude": "-122.58930000"
                    },
                    {
                        "id": 113424,
                        "name": "Carnation",
                        "latitude": "47.64788000",
                        "longitude": "-121.91401000"
                    },
                    {
                        "id": 113476,
                        "name": "Carson",
                        "latitude": "45.72539000",
                        "longitude": "-121.81924000"
                    },
                    {
                        "id": 113517,
                        "name": "Cascade Valley",
                        "latitude": "47.13459000",
                        "longitude": "-119.32808000"
                    },
                    {
                        "id": 113522,
                        "name": "Cashmere",
                        "latitude": "47.52235000",
                        "longitude": "-120.46980000"
                    },
                    {
                        "id": 113550,
                        "name": "Castle Rock",
                        "latitude": "46.27511000",
                        "longitude": "-122.90761000"
                    },
                    {
                        "id": 113569,
                        "name": "Cathcart",
                        "latitude": "47.84788000",
                        "longitude": "-122.09929000"
                    },
                    {
                        "id": 113571,
                        "name": "Cathlamet",
                        "latitude": "46.20317000",
                        "longitude": "-123.38318000"
                    },
                    {
                        "id": 113679,
                        "name": "Central Park",
                        "latitude": "46.97343000",
                        "longitude": "-123.69239000"
                    },
                    {
                        "id": 113687,
                        "name": "Centralia",
                        "latitude": "46.71621000",
                        "longitude": "-122.95430000"
                    },
                    {
                        "id": 113825,
                        "name": "Chehalis",
                        "latitude": "46.66205000",
                        "longitude": "-122.96402000"
                    },
                    {
                        "id": 113826,
                        "name": "Chelan",
                        "latitude": "47.84097000",
                        "longitude": "-120.01646000"
                    },
                    {
                        "id": 113827,
                        "name": "Chelan County",
                        "latitude": "47.86910000",
                        "longitude": "-120.61891000"
                    },
                    {
                        "id": 113840,
                        "name": "Cheney",
                        "latitude": "47.48739000",
                        "longitude": "-117.57576000"
                    },
                    {
                        "id": 113924,
                        "name": "Chewelah",
                        "latitude": "48.27629000",
                        "longitude": "-117.71552000"
                    },
                    {
                        "id": 113944,
                        "name": "Chico",
                        "latitude": "47.61148000",
                        "longitude": "-122.71042000"
                    },
                    {
                        "id": 114083,
                        "name": "City of Sammamish",
                        "latitude": "47.60444000",
                        "longitude": "-122.03768000"
                    },
                    {
                        "id": 114097,
                        "name": "Clallam County",
                        "latitude": "48.11044000",
                        "longitude": "-123.93432000"
                    },
                    {
                        "id": 114131,
                        "name": "Clark County",
                        "latitude": "45.77927000",
                        "longitude": "-122.48259000"
                    },
                    {
                        "id": 114150,
                        "name": "Clarkston",
                        "latitude": "46.41629000",
                        "longitude": "-117.04557000"
                    },
                    {
                        "id": 114151,
                        "name": "Clarkston Heights-Vineland",
                        "latitude": "46.38742000",
                        "longitude": "-117.08300000"
                    },
                    {
                        "id": 114207,
                        "name": "Cle Elum",
                        "latitude": "47.19540000",
                        "longitude": "-120.93925000"
                    },
                    {
                        "id": 114212,
                        "name": "Clear Lake",
                        "latitude": "48.46427000",
                        "longitude": "-122.23404000"
                    },
                    {
                        "id": 114221,
                        "name": "Clearview",
                        "latitude": "47.83371000",
                        "longitude": "-122.12596000"
                    },
                    {
                        "id": 114321,
                        "name": "Clyde Hill",
                        "latitude": "47.63177000",
                        "longitude": "-122.21790000"
                    },
                    {
                        "id": 114409,
                        "name": "Colfax",
                        "latitude": "46.88017000",
                        "longitude": "-117.36435000"
                    },
                    {
                        "id": 114415,
                        "name": "College Place",
                        "latitude": "46.04930000",
                        "longitude": "-118.38830000"
                    },
                    {
                        "id": 114484,
                        "name": "Columbia County",
                        "latitude": "46.29755000",
                        "longitude": "-117.90788000"
                    },
                    {
                        "id": 114506,
                        "name": "Colville",
                        "latitude": "48.54657000",
                        "longitude": "-117.90554000"
                    },
                    {
                        "id": 114561,
                        "name": "Connell",
                        "latitude": "46.66347000",
                        "longitude": "-118.86111000"
                    },
                    {
                        "id": 114685,
                        "name": "Cosmopolis",
                        "latitude": "46.95537000",
                        "longitude": "-123.77378000"
                    },
                    {
                        "id": 114694,
                        "name": "Cottage Lake",
                        "latitude": "47.74427000",
                        "longitude": "-122.07735000"
                    },
                    {
                        "id": 114710,
                        "name": "Coulee Dam",
                        "latitude": "47.96543000",
                        "longitude": "-118.97613000"
                    },
                    {
                        "id": 114720,
                        "name": "Country Homes",
                        "latitude": "47.74850000",
                        "longitude": "-117.40439000"
                    },
                    {
                        "id": 114727,
                        "name": "Coupeville",
                        "latitude": "48.21982000",
                        "longitude": "-122.68628000"
                    },
                    {
                        "id": 114741,
                        "name": "Covington",
                        "latitude": "47.35818000",
                        "longitude": "-122.12216000"
                    },
                    {
                        "id": 114749,
                        "name": "Cowlitz County",
                        "latitude": "46.19329000",
                        "longitude": "-122.68078000"
                    },
                    {
                        "id": 114828,
                        "name": "Crocker",
                        "latitude": "47.08091000",
                        "longitude": "-122.10383000"
                    },
                    {
                        "id": 115000,
                        "name": "Dallesport",
                        "latitude": "45.61734000",
                        "longitude": "-121.17952000"
                    },
                    {
                        "id": 115054,
                        "name": "Darrington",
                        "latitude": "48.25539000",
                        "longitude": "-121.60151000"
                    },
                    {
                        "id": 115060,
                        "name": "Davenport",
                        "latitude": "47.65405000",
                        "longitude": "-118.14997000"
                    },
                    {
                        "id": 115101,
                        "name": "Dayton",
                        "latitude": "46.32375000",
                        "longitude": "-117.97244000"
                    },
                    {
                        "id": 115179,
                        "name": "Deer Park",
                        "latitude": "47.95434000",
                        "longitude": "-117.47689000"
                    },
                    {
                        "id": 115272,
                        "name": "Des Moines",
                        "latitude": "47.40177000",
                        "longitude": "-122.32429000"
                    },
                    {
                        "id": 115279,
                        "name": "Desert Aire",
                        "latitude": "46.67930000",
                        "longitude": "-119.91727000"
                    },
                    {
                        "id": 115354,
                        "name": "Dishman",
                        "latitude": "47.66007000",
                        "longitude": "-117.27596000"
                    },
                    {
                        "id": 115389,
                        "name": "Dollar Corner",
                        "latitude": "45.78012000",
                        "longitude": "-122.60010000"
                    },
                    {
                        "id": 115436,
                        "name": "Douglas County",
                        "latitude": "47.73607000",
                        "longitude": "-119.69172000"
                    },
                    {
                        "id": 115489,
                        "name": "DuPont",
                        "latitude": "47.09676000",
                        "longitude": "-122.63124000"
                    },
                    {
                        "id": 115582,
                        "name": "Duvall",
                        "latitude": "47.74232000",
                        "longitude": "-121.98568000"
                    },
                    {
                        "id": 115691,
                        "name": "East Hill-Meridian",
                        "latitude": "47.41052000",
                        "longitude": "-122.17369000"
                    },
                    {
                        "id": 115738,
                        "name": "East Port Orchard",
                        "latitude": "47.52343000",
                        "longitude": "-122.62430000"
                    },
                    {
                        "id": 115745,
                        "name": "East Renton Highlands",
                        "latitude": "47.48482000",
                        "longitude": "-122.11234000"
                    },
                    {
                        "id": 115771,
                        "name": "East Wenatchee",
                        "latitude": "47.41568000",
                        "longitude": "-120.29313000"
                    },
                    {
                        "id": 115772,
                        "name": "East Wenatchee Bench",
                        "latitude": "47.42568000",
                        "longitude": "-120.28118000"
                    },
                    {
                        "id": 115777,
                        "name": "Eastgate",
                        "latitude": "47.57266000",
                        "longitude": "-122.14578000"
                    },
                    {
                        "id": 115784,
                        "name": "Eastmont",
                        "latitude": "47.89740000",
                        "longitude": "-122.18154000"
                    },
                    {
                        "id": 115809,
                        "name": "Eatonville",
                        "latitude": "46.86733000",
                        "longitude": "-122.26650000"
                    },
                    {
                        "id": 115864,
                        "name": "Edgewood",
                        "latitude": "47.25010000",
                        "longitude": "-122.29373000"
                    },
                    {
                        "id": 115878,
                        "name": "Edmonds",
                        "latitude": "47.81065000",
                        "longitude": "-122.37736000"
                    },
                    {
                        "id": 115960,
                        "name": "Electric City",
                        "latitude": "47.93237000",
                        "longitude": "-119.03808000"
                    },
                    {
                        "id": 115989,
                        "name": "Elk Plain",
                        "latitude": "47.05316000",
                        "longitude": "-122.39762000"
                    },
                    {
                        "id": 116018,
                        "name": "Ellensburg",
                        "latitude": "46.99651000",
                        "longitude": "-120.54785000"
                    },
                    {
                        "id": 116046,
                        "name": "Elma",
                        "latitude": "47.00343000",
                        "longitude": "-123.40877000"
                    },
                    {
                        "id": 116123,
                        "name": "Enetai",
                        "latitude": "47.58482000",
                        "longitude": "-122.59875000"
                    },
                    {
                        "id": 116152,
                        "name": "Entiat",
                        "latitude": "47.67596000",
                        "longitude": "-120.20841000"
                    },
                    {
                        "id": 116153,
                        "name": "Enumclaw",
                        "latitude": "47.20427000",
                        "longitude": "-121.99150000"
                    },
                    {
                        "id": 116156,
                        "name": "Ephrata",
                        "latitude": "47.31764000",
                        "longitude": "-119.55365000"
                    },
                    {
                        "id": 116171,
                        "name": "Erlands Point-Kitsap Lake",
                        "latitude": "47.59719000",
                        "longitude": "-122.70225000"
                    },
                    {
                        "id": 116189,
                        "name": "Esperance",
                        "latitude": "47.78899000",
                        "longitude": "-122.35541000"
                    },
                    {
                        "id": 116260,
                        "name": "Everett",
                        "latitude": "47.97898000",
                        "longitude": "-122.20208000"
                    },
                    {
                        "id": 116267,
                        "name": "Everson",
                        "latitude": "48.92012000",
                        "longitude": "-122.34266000"
                    },
                    {
                        "id": 116297,
                        "name": "Fairchild Air Force Base",
                        "latitude": "47.61879000",
                        "longitude": "-117.64826000"
                    },
                    {
                        "id": 116363,
                        "name": "Fairwood",
                        "latitude": "47.44843000",
                        "longitude": "-122.15734000"
                    },
                    {
                        "id": 116371,
                        "name": "Fall City",
                        "latitude": "47.56732000",
                        "longitude": "-121.88873000"
                    },
                    {
                        "id": 116465,
                        "name": "Federal Way",
                        "latitude": "47.32232000",
                        "longitude": "-122.31262000"
                    },
                    {
                        "id": 116467,
                        "name": "Felida",
                        "latitude": "45.70956000",
                        "longitude": "-122.70732000"
                    },
                    {
                        "id": 116484,
                        "name": "Fern Prairie",
                        "latitude": "45.63651000",
                        "longitude": "-122.39870000"
                    },
                    {
                        "id": 116490,
                        "name": "Ferndale",
                        "latitude": "48.84650000",
                        "longitude": "-122.59101000"
                    },
                    {
                        "id": 116498,
                        "name": "Ferry County",
                        "latitude": "48.47007000",
                        "longitude": "-118.51649000"
                    },
                    {
                        "id": 116504,
                        "name": "Fife",
                        "latitude": "47.23927000",
                        "longitude": "-122.35707000"
                    },
                    {
                        "id": 116505,
                        "name": "Fife Heights",
                        "latitude": "47.25899000",
                        "longitude": "-122.34568000"
                    },
                    {
                        "id": 116517,
                        "name": "Finley",
                        "latitude": "46.15402000",
                        "longitude": "-119.03390000"
                    },
                    {
                        "id": 116519,
                        "name": "Fircrest",
                        "latitude": "47.23954000",
                        "longitude": "-122.51596000"
                    },
                    {
                        "id": 116538,
                        "name": "Five Corners",
                        "latitude": "45.68456000",
                        "longitude": "-122.57510000"
                    },
                    {
                        "id": 116617,
                        "name": "Fobes Hill",
                        "latitude": "47.94899000",
                        "longitude": "-122.11985000"
                    },
                    {
                        "id": 116641,
                        "name": "Fords Prairie",
                        "latitude": "46.73510000",
                        "longitude": "-122.98902000"
                    },
                    {
                        "id": 116675,
                        "name": "Forks",
                        "latitude": "47.95036000",
                        "longitude": "-124.38549000"
                    },
                    {
                        "id": 116802,
                        "name": "Fox Island",
                        "latitude": "47.25149000",
                        "longitude": "-122.62902000"
                    },
                    {
                        "id": 116865,
                        "name": "Franklin County",
                        "latitude": "46.53477000",
                        "longitude": "-118.89889000"
                    },
                    {
                        "id": 116893,
                        "name": "Frederickson",
                        "latitude": "47.09621000",
                        "longitude": "-122.35873000"
                    },
                    {
                        "id": 116907,
                        "name": "Freeland",
                        "latitude": "48.00954000",
                        "longitude": "-122.52598000"
                    },
                    {
                        "id": 116943,
                        "name": "Friday Harbor",
                        "latitude": "48.53427000",
                        "longitude": "-123.01712000"
                    },
                    {
                        "id": 117087,
                        "name": "Garfield County",
                        "latitude": "46.43156000",
                        "longitude": "-117.54519000"
                    },
                    {
                        "id": 117099,
                        "name": "Garrett",
                        "latitude": "46.05208000",
                        "longitude": "-118.40275000"
                    },
                    {
                        "id": 117145,
                        "name": "Geneva",
                        "latitude": "48.74567000",
                        "longitude": "-122.40183000"
                    },
                    {
                        "id": 117199,
                        "name": "Gig Harbor",
                        "latitude": "47.32926000",
                        "longitude": "-122.58013000"
                    },
                    {
                        "id": 117258,
                        "name": "Gleed",
                        "latitude": "46.65818000",
                        "longitude": "-120.61340000"
                    },
                    {
                        "id": 117339,
                        "name": "Gold Bar",
                        "latitude": "47.85677000",
                        "longitude": "-121.69706000"
                    },
                    {
                        "id": 117360,
                        "name": "Goldendale",
                        "latitude": "45.82068000",
                        "longitude": "-120.82173000"
                    },
                    {
                        "id": 117436,
                        "name": "Graham",
                        "latitude": "47.05288000",
                        "longitude": "-122.29428000"
                    },
                    {
                        "id": 117454,
                        "name": "Grand Coulee",
                        "latitude": "47.94154000",
                        "longitude": "-119.00335000"
                    },
                    {
                        "id": 117469,
                        "name": "Grand Mound",
                        "latitude": "46.78788000",
                        "longitude": "-123.01125000"
                    },
                    {
                        "id": 117481,
                        "name": "Grandview",
                        "latitude": "46.25097000",
                        "longitude": "-119.90170000"
                    },
                    {
                        "id": 117489,
                        "name": "Granger",
                        "latitude": "46.34207000",
                        "longitude": "-120.18727000"
                    },
                    {
                        "id": 117498,
                        "name": "Granite Falls",
                        "latitude": "48.08399000",
                        "longitude": "-121.96874000"
                    },
                    {
                        "id": 117521,
                        "name": "Grant County",
                        "latitude": "47.20566000",
                        "longitude": "-119.45177000"
                    },
                    {
                        "id": 117558,
                        "name": "Grays Harbor County",
                        "latitude": "47.14445000",
                        "longitude": "-123.82847000"
                    },
                    {
                        "id": 117980,
                        "name": "Hansville",
                        "latitude": "47.91870000",
                        "longitude": "-122.55431000"
                    },
                    {
                        "id": 118203,
                        "name": "Hazel Dell",
                        "latitude": "45.67151000",
                        "longitude": "-122.66288000"
                    },
                    {
                        "id": 118399,
                        "name": "Highland",
                        "latitude": "46.13152000",
                        "longitude": "-119.11418000"
                    },
                    {
                        "id": 118498,
                        "name": "Hobart",
                        "latitude": "47.42177000",
                        "longitude": "-121.97289000"
                    },
                    {
                        "id": 118504,
                        "name": "Hockinson",
                        "latitude": "45.73789000",
                        "longitude": "-122.48704000"
                    },
                    {
                        "id": 118585,
                        "name": "Home",
                        "latitude": "47.27482000",
                        "longitude": "-122.76375000"
                    },
                    {
                        "id": 118660,
                        "name": "Hoquiam",
                        "latitude": "46.98092000",
                        "longitude": "-123.88933000"
                    },
                    {
                        "id": 118927,
                        "name": "Indianola",
                        "latitude": "47.74704000",
                        "longitude": "-122.52569000"
                    },
                    {
                        "id": 118938,
                        "name": "Inglewood-Finn Hill",
                        "latitude": "47.72049000",
                        "longitude": "-122.23167000"
                    },
                    {
                        "id": 119024,
                        "name": "Island County",
                        "latitude": "48.20820000",
                        "longitude": "-122.66922000"
                    },
                    {
                        "id": 119036,
                        "name": "Issaquah",
                        "latitude": "47.53010000",
                        "longitude": "-122.03262000"
                    },
                    {
                        "id": 119198,
                        "name": "Jefferson County",
                        "latitude": "47.77655000",
                        "longitude": "-123.57431000"
                    },
                    {
                        "id": 119287,
                        "name": "Joint Base Lewis McChord",
                        "latitude": "47.10787000",
                        "longitude": "-122.57694000"
                    },
                    {
                        "id": 119359,
                        "name": "Kalama",
                        "latitude": "46.00845000",
                        "longitude": "-122.84455000"
                    },
                    {
                        "id": 119432,
                        "name": "Kelso",
                        "latitude": "46.14678000",
                        "longitude": "-122.90844000"
                    },
                    {
                        "id": 119463,
                        "name": "Kenmore",
                        "latitude": "47.75732000",
                        "longitude": "-122.24401000"
                    },
                    {
                        "id": 119475,
                        "name": "Kennewick",
                        "latitude": "46.21125000",
                        "longitude": "-119.13723000"
                    },
                    {
                        "id": 119487,
                        "name": "Kent",
                        "latitude": "47.38093000",
                        "longitude": "-122.23484000"
                    },
                    {
                        "id": 119527,
                        "name": "Kettle Falls",
                        "latitude": "48.61074000",
                        "longitude": "-118.05582000"
                    },
                    {
                        "id": 119538,
                        "name": "Key Center",
                        "latitude": "47.34065000",
                        "longitude": "-122.74541000"
                    },
                    {
                        "id": 119582,
                        "name": "King County",
                        "latitude": "47.49084000",
                        "longitude": "-121.83583000"
                    },
                    {
                        "id": 119614,
                        "name": "Kingsgate",
                        "latitude": "47.72704000",
                        "longitude": "-122.17957000"
                    },
                    {
                        "id": 119630,
                        "name": "Kingston",
                        "latitude": "47.79850000",
                        "longitude": "-122.49806000"
                    },
                    {
                        "id": 119652,
                        "name": "Kirkland",
                        "latitude": "47.68149000",
                        "longitude": "-122.20874000"
                    },
                    {
                        "id": 119660,
                        "name": "Kitsap County",
                        "latitude": "47.63983000",
                        "longitude": "-122.64900000"
                    },
                    {
                        "id": 119664,
                        "name": "Kittitas",
                        "latitude": "46.98318000",
                        "longitude": "-120.41701000"
                    },
                    {
                        "id": 119665,
                        "name": "Kittitas County",
                        "latitude": "47.12417000",
                        "longitude": "-120.67972000"
                    },
                    {
                        "id": 119669,
                        "name": "Klahanie",
                        "latitude": "47.43121000",
                        "longitude": "-122.43652000"
                    },
                    {
                        "id": 119673,
                        "name": "Klickitat County",
                        "latitude": "45.87378000",
                        "longitude": "-120.78926000"
                    },
                    {
                        "id": 119738,
                        "name": "La Center",
                        "latitude": "45.86234000",
                        "longitude": "-122.67038000"
                    },
                    {
                        "id": 119812,
                        "name": "Lacey",
                        "latitude": "47.03426000",
                        "longitude": "-122.82319000"
                    },
                    {
                        "id": 119912,
                        "name": "Lake Forest Park",
                        "latitude": "47.75676000",
                        "longitude": "-122.28096000"
                    },
                    {
                        "id": 119938,
                        "name": "Lake Marcel-Stillwater",
                        "latitude": "47.69263000",
                        "longitude": "-121.91513000"
                    },
                    {
                        "id": 119948,
                        "name": "Lake Morton-Berrydale",
                        "latitude": "47.33251000",
                        "longitude": "-122.10286000"
                    },
                    {
                        "id": 119978,
                        "name": "Lake Shore",
                        "latitude": "45.69067000",
                        "longitude": "-122.69093000"
                    },
                    {
                        "id": 119980,
                        "name": "Lake Stevens",
                        "latitude": "48.01510000",
                        "longitude": "-122.06374000"
                    },
                    {
                        "id": 119981,
                        "name": "Lake Stickney",
                        "latitude": "47.87655000",
                        "longitude": "-122.26214000"
                    },
                    {
                        "id": 120018,
                        "name": "Lakeland North",
                        "latitude": "47.33343000",
                        "longitude": "-122.27695000"
                    },
                    {
                        "id": 120019,
                        "name": "Lakeland South",
                        "latitude": "47.27843000",
                        "longitude": "-122.28326000"
                    },
                    {
                        "id": 120052,
                        "name": "Lakewood",
                        "latitude": "47.17176000",
                        "longitude": "-122.51846000"
                    },
                    {
                        "id": 120114,
                        "name": "Langley",
                        "latitude": "48.04009000",
                        "longitude": "-122.40626000"
                    },
                    {
                        "id": 120140,
                        "name": "Larch Way",
                        "latitude": "47.84290000",
                        "longitude": "-122.25275000"
                    },
                    {
                        "id": 120268,
                        "name": "Lea Hill",
                        "latitude": "47.32621000",
                        "longitude": "-122.18151000"
                    },
                    {
                        "id": 120281,
                        "name": "Leavenworth",
                        "latitude": "47.59623000",
                        "longitude": "-120.66148000"
                    },
                    {
                        "id": 120417,
                        "name": "Lewis County",
                        "latitude": "46.57773000",
                        "longitude": "-122.39241000"
                    },
                    {
                        "id": 120437,
                        "name": "Lewisville",
                        "latitude": "45.80984000",
                        "longitude": "-122.52315000"
                    },
                    {
                        "id": 120475,
                        "name": "Liberty Lake",
                        "latitude": "47.67591000",
                        "longitude": "-117.11821000"
                    },
                    {
                        "id": 120537,
                        "name": "Lincoln County",
                        "latitude": "47.57619000",
                        "longitude": "-118.41879000"
                    },
                    {
                        "id": 120673,
                        "name": "Lochsloy",
                        "latitude": "48.05149000",
                        "longitude": "-122.03208000"
                    },
                    {
                        "id": 120692,
                        "name": "Lofall",
                        "latitude": "47.81204000",
                        "longitude": "-122.65821000"
                    },
                    {
                        "id": 120739,
                        "name": "Long Beach",
                        "latitude": "46.35232000",
                        "longitude": "-124.05432000"
                    },
                    {
                        "id": 120752,
                        "name": "Longbranch",
                        "latitude": "47.20898000",
                        "longitude": "-122.75680000"
                    },
                    {
                        "id": 120758,
                        "name": "Longview",
                        "latitude": "46.13817000",
                        "longitude": "-122.93817000"
                    },
                    {
                        "id": 120759,
                        "name": "Longview Heights",
                        "latitude": "46.18039000",
                        "longitude": "-122.95706000"
                    },
                    {
                        "id": 120919,
                        "name": "Lynden",
                        "latitude": "48.94650000",
                        "longitude": "-122.45211000"
                    },
                    {
                        "id": 120931,
                        "name": "Lynnwood",
                        "latitude": "47.82093000",
                        "longitude": "-122.31513000"
                    },
                    {
                        "id": 120951,
                        "name": "Mabton",
                        "latitude": "46.21485000",
                        "longitude": "-119.99671000"
                    },
                    {
                        "id": 120957,
                        "name": "Machias",
                        "latitude": "47.98149000",
                        "longitude": "-122.04596000"
                    },
                    {
                        "id": 121069,
                        "name": "Maltby",
                        "latitude": "47.80510000",
                        "longitude": "-122.11318000"
                    },
                    {
                        "id": 121102,
                        "name": "Manchester",
                        "latitude": "47.55566000",
                        "longitude": "-122.54507000"
                    },
                    {
                        "id": 121151,
                        "name": "Manson",
                        "latitude": "47.88486000",
                        "longitude": "-120.15841000"
                    },
                    {
                        "id": 121168,
                        "name": "Maple Heights-Lake Desire",
                        "latitude": "47.44413000",
                        "longitude": "-122.09736000"
                    },
                    {
                        "id": 121173,
                        "name": "Maple Valley",
                        "latitude": "47.39272000",
                        "longitude": "-122.04641000"
                    },
                    {
                        "id": 121180,
                        "name": "Maplewood",
                        "latitude": "47.40176000",
                        "longitude": "-122.55707000"
                    },
                    {
                        "id": 121219,
                        "name": "Marietta",
                        "latitude": "48.78705000",
                        "longitude": "-122.58045000"
                    },
                    {
                        "id": 121220,
                        "name": "Marietta-Alderwood",
                        "latitude": "48.78965000",
                        "longitude": "-122.55369000"
                    },
                    {
                        "id": 121333,
                        "name": "Martha Lake",
                        "latitude": "47.85093000",
                        "longitude": "-122.23930000"
                    },
                    {
                        "id": 121361,
                        "name": "Marysville",
                        "latitude": "48.05176000",
                        "longitude": "-122.17708000"
                    },
                    {
                        "id": 121382,
                        "name": "Mason County",
                        "latitude": "47.35048000",
                        "longitude": "-123.18309000"
                    },
                    {
                        "id": 121409,
                        "name": "Mattawa",
                        "latitude": "46.73791000",
                        "longitude": "-119.90282000"
                    },
                    {
                        "id": 121468,
                        "name": "McChord Air Force Base",
                        "latitude": "47.13397000",
                        "longitude": "-122.49157000"
                    },
                    {
                        "id": 121470,
                        "name": "McCleary",
                        "latitude": "47.05315000",
                        "longitude": "-123.26543000"
                    },
                    {
                        "id": 121538,
                        "name": "McMillin",
                        "latitude": "47.13982000",
                        "longitude": "-122.23651000"
                    },
                    {
                        "id": 121553,
                        "name": "Mead",
                        "latitude": "47.76739000",
                        "longitude": "-117.35494000"
                    },
                    {
                        "id": 121559,
                        "name": "Meadow Glade",
                        "latitude": "45.75845000",
                        "longitude": "-122.56038000"
                    },
                    {
                        "id": 121568,
                        "name": "Meadowdale",
                        "latitude": "47.85287000",
                        "longitude": "-122.33347000"
                    },
                    {
                        "id": 121600,
                        "name": "Medical Lake",
                        "latitude": "47.57294000",
                        "longitude": "-117.68216000"
                    },
                    {
                        "id": 121606,
                        "name": "Medina",
                        "latitude": "47.62093000",
                        "longitude": "-122.22762000"
                    },
                    {
                        "id": 121682,
                        "name": "Mercer Island",
                        "latitude": "47.57065000",
                        "longitude": "-122.22207000"
                    },
                    {
                        "id": 121801,
                        "name": "Midland",
                        "latitude": "47.16704000",
                        "longitude": "-122.40484000"
                    },
                    {
                        "id": 121863,
                        "name": "Mill Creek",
                        "latitude": "47.86010000",
                        "longitude": "-122.20430000"
                    },
                    {
                        "id": 121864,
                        "name": "Mill Creek East",
                        "latitude": "47.83602000",
                        "longitude": "-122.18766000"
                    },
                    {
                        "id": 121867,
                        "name": "Mill Plain",
                        "latitude": "45.64290000",
                        "longitude": "-122.49398000"
                    },
                    {
                        "id": 121907,
                        "name": "Millwood",
                        "latitude": "47.68128000",
                        "longitude": "-117.28271000"
                    },
                    {
                        "id": 121921,
                        "name": "Milton",
                        "latitude": "47.24816000",
                        "longitude": "-122.31290000"
                    },
                    {
                        "id": 121952,
                        "name": "Minnehaha",
                        "latitude": "45.65901000",
                        "longitude": "-122.64871000"
                    },
                    {
                        "id": 121975,
                        "name": "Mirrormont",
                        "latitude": "47.46232000",
                        "longitude": "-121.99567000"
                    },
                    {
                        "id": 122065,
                        "name": "Monroe",
                        "latitude": "47.85538000",
                        "longitude": "-121.97096000"
                    },
                    {
                        "id": 122083,
                        "name": "Monroe North",
                        "latitude": "47.88225000",
                        "longitude": "-121.98729000"
                    },
                    {
                        "id": 122124,
                        "name": "Montesano",
                        "latitude": "46.98121000",
                        "longitude": "-123.60266000"
                    },
                    {
                        "id": 122295,
                        "name": "Morton",
                        "latitude": "46.55844000",
                        "longitude": "-122.27510000"
                    },
                    {
                        "id": 122302,
                        "name": "Moses Lake",
                        "latitude": "47.13014000",
                        "longitude": "-119.27808000"
                    },
                    {
                        "id": 122303,
                        "name": "Moses Lake North",
                        "latitude": "47.19433000",
                        "longitude": "-119.31719000"
                    },
                    {
                        "id": 122403,
                        "name": "Mount Vernon",
                        "latitude": "48.42122000",
                        "longitude": "-122.33405000"
                    },
                    {
                        "id": 122405,
                        "name": "Mount Vista",
                        "latitude": "45.73428000",
                        "longitude": "-122.63288000"
                    },
                    {
                        "id": 122439,
                        "name": "Mountlake Terrace",
                        "latitude": "47.78815000",
                        "longitude": "-122.30874000"
                    },
                    {
                        "id": 122450,
                        "name": "Mukilteo",
                        "latitude": "47.94454000",
                        "longitude": "-122.30458000"
                    },
                    {
                        "id": 122549,
                        "name": "Napavine",
                        "latitude": "46.57455000",
                        "longitude": "-122.90818000"
                    },
                    {
                        "id": 122605,
                        "name": "Navy Yard City",
                        "latitude": "47.55343000",
                        "longitude": "-122.66458000"
                    },
                    {
                        "id": 122823,
                        "name": "Newcastle",
                        "latitude": "47.53899000",
                        "longitude": "-122.15568000"
                    },
                    {
                        "id": 122852,
                        "name": "Newport",
                        "latitude": "48.17963000",
                        "longitude": "-117.04326000"
                    },
                    {
                        "id": 122936,
                        "name": "Nooksack",
                        "latitude": "48.92762000",
                        "longitude": "-122.32155000"
                    },
                    {
                        "id": 122952,
                        "name": "Normandy Park",
                        "latitude": "47.43621000",
                        "longitude": "-122.34068000"
                    },
                    {
                        "id": 122985,
                        "name": "North Bend",
                        "latitude": "47.49566000",
                        "longitude": "-121.78678000"
                    },
                    {
                        "id": 123011,
                        "name": "North Creek",
                        "latitude": "47.81954000",
                        "longitude": "-122.17624000"
                    },
                    {
                        "id": 123028,
                        "name": "North Fort Lewis",
                        "latitude": "47.12131000",
                        "longitude": "-122.59452000"
                    },
                    {
                        "id": 123090,
                        "name": "North Puyallup",
                        "latitude": "47.20677000",
                        "longitude": "-122.28234000"
                    },
                    {
                        "id": 123132,
                        "name": "North Yelm",
                        "latitude": "46.96315000",
                        "longitude": "-122.60290000"
                    },
                    {
                        "id": 123242,
                        "name": "Oak Harbor",
                        "latitude": "48.29316000",
                        "longitude": "-122.64322000"
                    },
                    {
                        "id": 123332,
                        "name": "Ocean Park",
                        "latitude": "46.49177000",
                        "longitude": "-124.05208000"
                    },
                    {
                        "id": 123336,
                        "name": "Ocean Shores",
                        "latitude": "46.97370000",
                        "longitude": "-124.15629000"
                    },
                    {
                        "id": 123393,
                        "name": "Okanogan",
                        "latitude": "48.36126000",
                        "longitude": "-119.58339000"
                    },
                    {
                        "id": 123394,
                        "name": "Okanogan County",
                        "latitude": "48.54885000",
                        "longitude": "-119.74079000"
                    },
                    {
                        "id": 123459,
                        "name": "Olympia",
                        "latitude": "47.03787000",
                        "longitude": "-122.90070000"
                    },
                    {
                        "id": 123464,
                        "name": "Omak",
                        "latitude": "48.41099000",
                        "longitude": "-119.52755000"
                    },
                    {
                        "id": 123499,
                        "name": "Opportunity",
                        "latitude": "47.64995000",
                        "longitude": "-117.23991000"
                    },
                    {
                        "id": 123539,
                        "name": "Orchards",
                        "latitude": "45.66651000",
                        "longitude": "-122.56093000"
                    },
                    {
                        "id": 123579,
                        "name": "Oroville",
                        "latitude": "48.93905000",
                        "longitude": "-119.43562000"
                    },
                    {
                        "id": 123582,
                        "name": "Orting",
                        "latitude": "47.09788000",
                        "longitude": "-122.20428000"
                    },
                    {
                        "id": 123627,
                        "name": "Othello",
                        "latitude": "46.82597000",
                        "longitude": "-119.17529000"
                    },
                    {
                        "id": 123629,
                        "name": "Otis Orchards-East Farms",
                        "latitude": "47.70988000",
                        "longitude": "-117.07975000"
                    },
                    {
                        "id": 123707,
                        "name": "Pacific",
                        "latitude": "47.26455000",
                        "longitude": "-122.25012000"
                    },
                    {
                        "id": 123709,
                        "name": "Pacific County",
                        "latitude": "46.55128000",
                        "longitude": "-123.77886000"
                    },
                    {
                        "id": 123792,
                        "name": "Palouse",
                        "latitude": "46.91017000",
                        "longitude": "-117.07573000"
                    },
                    {
                        "id": 123872,
                        "name": "Parkland",
                        "latitude": "47.15538000",
                        "longitude": "-122.43401000"
                    },
                    {
                        "id": 123883,
                        "name": "Parkwood",
                        "latitude": "47.53315000",
                        "longitude": "-122.61014000"
                    },
                    {
                        "id": 123901,
                        "name": "Pasco",
                        "latitude": "46.23958000",
                        "longitude": "-119.10057000"
                    },
                    {
                        "id": 123955,
                        "name": "Peaceful Valley",
                        "latitude": "48.93815000",
                        "longitude": "-122.14733000"
                    },
                    {
                        "id": 124013,
                        "name": "Pend Oreille County",
                        "latitude": "48.53230000",
                        "longitude": "-117.27397000"
                    },
                    {
                        "id": 124160,
                        "name": "Picnic Point",
                        "latitude": "47.88111000",
                        "longitude": "-122.32840000"
                    },
                    {
                        "id": 124161,
                        "name": "Picnic Point-North Lynnwood",
                        "latitude": "47.86278000",
                        "longitude": "-122.29497000"
                    },
                    {
                        "id": 124175,
                        "name": "Pierce County",
                        "latitude": "47.03764000",
                        "longitude": "-122.13735000"
                    },
                    {
                        "id": 124433,
                        "name": "Point Roberts",
                        "latitude": "48.98538000",
                        "longitude": "-123.07797000"
                    },
                    {
                        "id": 124456,
                        "name": "Pomeroy",
                        "latitude": "46.47487000",
                        "longitude": "-117.60269000"
                    },
                    {
                        "id": 124493,
                        "name": "Port Angeles",
                        "latitude": "48.11815000",
                        "longitude": "-123.43074000"
                    },
                    {
                        "id": 124494,
                        "name": "Port Angeles East",
                        "latitude": "48.10667000",
                        "longitude": "-123.37172000"
                    },
                    {
                        "id": 124508,
                        "name": "Port Hadlock-Irondale",
                        "latitude": "48.03273000",
                        "longitude": "-122.78529000"
                    },
                    {
                        "id": 124518,
                        "name": "Port Ludlow",
                        "latitude": "47.92537000",
                        "longitude": "-122.68349000"
                    },
                    {
                        "id": 124525,
                        "name": "Port Orchard",
                        "latitude": "47.54037000",
                        "longitude": "-122.63625000"
                    },
                    {
                        "id": 124537,
                        "name": "Port Townsend",
                        "latitude": "48.11704000",
                        "longitude": "-122.76045000"
                    },
                    {
                        "id": 124603,
                        "name": "Poulsbo",
                        "latitude": "47.73593000",
                        "longitude": "-122.64654000"
                    },
                    {
                        "id": 124629,
                        "name": "Prairie Heights",
                        "latitude": "47.14933000",
                        "longitude": "-122.10530000"
                    },
                    {
                        "id": 124630,
                        "name": "Prairie Ridge",
                        "latitude": "47.13760000",
                        "longitude": "-122.14873000"
                    },
                    {
                        "id": 124714,
                        "name": "Prosser",
                        "latitude": "46.20680000",
                        "longitude": "-119.76892000"
                    },
                    {
                        "id": 124744,
                        "name": "Pullman",
                        "latitude": "46.73127000",
                        "longitude": "-117.17962000"
                    },
                    {
                        "id": 124757,
                        "name": "Purdy",
                        "latitude": "47.38899000",
                        "longitude": "-122.62541000"
                    },
                    {
                        "id": 124771,
                        "name": "Puyallup",
                        "latitude": "47.18538000",
                        "longitude": "-122.29290000"
                    },
                    {
                        "id": 124800,
                        "name": "Quincy",
                        "latitude": "47.23430000",
                        "longitude": "-119.85255000"
                    },
                    {
                        "id": 124827,
                        "name": "Rainier",
                        "latitude": "46.88815000",
                        "longitude": "-122.68846000"
                    },
                    {
                        "id": 124909,
                        "name": "Ravensdale",
                        "latitude": "47.35232000",
                        "longitude": "-121.98373000"
                    },
                    {
                        "id": 124920,
                        "name": "Raymond",
                        "latitude": "46.68649000",
                        "longitude": "-123.73294000"
                    },
                    {
                        "id": 124979,
                        "name": "Redmond",
                        "latitude": "47.67399000",
                        "longitude": "-122.12151000"
                    },
                    {
                        "id": 125026,
                        "name": "Renton",
                        "latitude": "47.48288000",
                        "longitude": "-122.21707000"
                    },
                    {
                        "id": 125032,
                        "name": "Republic",
                        "latitude": "48.64822000",
                        "longitude": "-118.73781000"
                    },
                    {
                        "id": 125072,
                        "name": "Richland",
                        "latitude": "46.28569000",
                        "longitude": "-119.28446000"
                    },
                    {
                        "id": 125121,
                        "name": "Ridgefield",
                        "latitude": "45.81511000",
                        "longitude": "-122.74260000"
                    },
                    {
                        "id": 125174,
                        "name": "Ritzville",
                        "latitude": "47.12755000",
                        "longitude": "-118.37999000"
                    },
                    {
                        "id": 125191,
                        "name": "Riverbend",
                        "latitude": "47.46649000",
                        "longitude": "-121.75039000"
                    },
                    {
                        "id": 125213,
                        "name": "Riverton",
                        "latitude": "47.48427000",
                        "longitude": "-122.29457000"
                    },
                    {
                        "id": 125270,
                        "name": "Rochester",
                        "latitude": "46.82177000",
                        "longitude": "-123.09625000"
                    },
                    {
                        "id": 125339,
                        "name": "Rocky Point",
                        "latitude": "47.59287000",
                        "longitude": "-122.66848000"
                    },
                    {
                        "id": 125420,
                        "name": "Rosedale",
                        "latitude": "47.33149000",
                        "longitude": "-122.65235000"
                    },
                    {
                        "id": 125488,
                        "name": "Royal City",
                        "latitude": "46.90097000",
                        "longitude": "-119.63059000"
                    },
                    {
                        "id": 125765,
                        "name": "Salmon Creek",
                        "latitude": "45.71067000",
                        "longitude": "-122.64899000"
                    },
                    {
                        "id": 125778,
                        "name": "Sammamish",
                        "latitude": "47.64177000",
                        "longitude": "-122.08040000"
                    },
                    {
                        "id": 125823,
                        "name": "San Juan County",
                        "latitude": "48.53116000",
                        "longitude": "-123.02490000"
                    },
                    {
                        "id": 126077,
                        "name": "Seabeck",
                        "latitude": "47.63954000",
                        "longitude": "-122.82849000"
                    },
                    {
                        "id": 126076,
                        "name": "SeaTac",
                        "latitude": "47.44846000",
                        "longitude": "-122.29217000"
                    },
                    {
                        "id": 126104,
                        "name": "Seattle",
                        "latitude": "47.60621000",
                        "longitude": "-122.33207000"
                    },
                    {
                        "id": 126122,
                        "name": "Sedro-Woolley",
                        "latitude": "48.50389000",
                        "longitude": "-122.23611000"
                    },
                    {
                        "id": 126129,
                        "name": "Selah",
                        "latitude": "46.65402000",
                        "longitude": "-120.53007000"
                    },
                    {
                        "id": 126164,
                        "name": "Sequim",
                        "latitude": "48.07963000",
                        "longitude": "-123.10234000"
                    },
                    {
                        "id": 126299,
                        "name": "Shelton",
                        "latitude": "47.21509000",
                        "longitude": "-123.10071000"
                    },
                    {
                        "id": 126368,
                        "name": "Shoreline",
                        "latitude": "47.75565000",
                        "longitude": "-122.34152000"
                    },
                    {
                        "id": 126424,
                        "name": "Silver Firs",
                        "latitude": "47.86602000",
                        "longitude": "-122.15510000"
                    },
                    {
                        "id": 126439,
                        "name": "Silverdale",
                        "latitude": "47.64454000",
                        "longitude": "-122.69487000"
                    },
                    {
                        "id": 126464,
                        "name": "Sisco Heights",
                        "latitude": "48.11538000",
                        "longitude": "-122.09708000"
                    },
                    {
                        "id": 126474,
                        "name": "Skagit County",
                        "latitude": "48.48215000",
                        "longitude": "-121.80227000"
                    },
                    {
                        "id": 126476,
                        "name": "Skamania County",
                        "latitude": "46.02276000",
                        "longitude": "-121.91510000"
                    },
                    {
                        "id": 126533,
                        "name": "Smokey Point",
                        "latitude": "48.15232000",
                        "longitude": "-122.18264000"
                    },
                    {
                        "id": 126542,
                        "name": "Snohomish",
                        "latitude": "47.91288000",
                        "longitude": "-122.09818000"
                    },
                    {
                        "id": 126543,
                        "name": "Snohomish County",
                        "latitude": "48.04602000",
                        "longitude": "-121.72218000"
                    },
                    {
                        "id": 126544,
                        "name": "Snoqualmie",
                        "latitude": "47.52871000",
                        "longitude": "-121.82539000"
                    },
                    {
                        "id": 126553,
                        "name": "Soap Lake",
                        "latitude": "47.38931000",
                        "longitude": "-119.49059000"
                    },
                    {
                        "id": 126625,
                        "name": "South Bend",
                        "latitude": "46.66315000",
                        "longitude": "-123.80461000"
                    },
                    {
                        "id": 126673,
                        "name": "South Hill",
                        "latitude": "47.14121000",
                        "longitude": "-122.27012000"
                    },
                    {
                        "id": 126746,
                        "name": "South Wenatchee",
                        "latitude": "47.39012000",
                        "longitude": "-120.28958000"
                    },
                    {
                        "id": 126793,
                        "name": "Southworth",
                        "latitude": "47.51204000",
                        "longitude": "-122.50180000"
                    },
                    {
                        "id": 126796,
                        "name": "Spanaway",
                        "latitude": "47.10399000",
                        "longitude": "-122.43457000"
                    },
                    {
                        "id": 126842,
                        "name": "Spokane",
                        "latitude": "47.65966000",
                        "longitude": "-117.42908000"
                    },
                    {
                        "id": 126843,
                        "name": "Spokane County",
                        "latitude": "47.62064000",
                        "longitude": "-117.40401000"
                    },
                    {
                        "id": 126844,
                        "name": "Spokane Valley",
                        "latitude": "47.67323000",
                        "longitude": "-117.23937000"
                    },
                    {
                        "id": 126974,
                        "name": "Stanwood",
                        "latitude": "48.24121000",
                        "longitude": "-122.37071000"
                    },
                    {
                        "id": 127017,
                        "name": "Steilacoom",
                        "latitude": "47.16982000",
                        "longitude": "-122.60263000"
                    },
                    {
                        "id": 127042,
                        "name": "Stevens County",
                        "latitude": "48.39906000",
                        "longitude": "-117.85514000"
                    },
                    {
                        "id": 127045,
                        "name": "Stevenson",
                        "latitude": "45.69567000",
                        "longitude": "-121.88452000"
                    },
                    {
                        "id": 127162,
                        "name": "Sudden Valley",
                        "latitude": "48.72289000",
                        "longitude": "-122.34655000"
                    },
                    {
                        "id": 127198,
                        "name": "Sultan",
                        "latitude": "47.86260000",
                        "longitude": "-121.81651000"
                    },
                    {
                        "id": 127199,
                        "name": "Sumas",
                        "latitude": "49.00012000",
                        "longitude": "-122.26488000"
                    },
                    {
                        "id": 127215,
                        "name": "Summit",
                        "latitude": "47.16177000",
                        "longitude": "-122.35707000"
                    },
                    {
                        "id": 127220,
                        "name": "Summit View",
                        "latitude": "47.13632000",
                        "longitude": "-122.35202000"
                    },
                    {
                        "id": 127223,
                        "name": "Sumner",
                        "latitude": "47.20316000",
                        "longitude": "-122.24040000"
                    },
                    {
                        "id": 127260,
                        "name": "Sunnyside",
                        "latitude": "46.32374000",
                        "longitude": "-120.00865000"
                    },
                    {
                        "id": 127263,
                        "name": "Sunnyslope",
                        "latitude": "47.47290000",
                        "longitude": "-120.33674000"
                    },
                    {
                        "id": 127284,
                        "name": "Suquamish",
                        "latitude": "47.73121000",
                        "longitude": "-122.55236000"
                    },
                    {
                        "id": 127369,
                        "name": "Tacoma",
                        "latitude": "47.25288000",
                        "longitude": "-122.44429000"
                    },
                    {
                        "id": 127416,
                        "name": "Tanglewilde",
                        "latitude": "47.05150000",
                        "longitude": "-122.78241000"
                    },
                    {
                        "id": 127417,
                        "name": "Tanglewilde-Thompson Place",
                        "latitude": "47.05116000",
                        "longitude": "-122.78081000"
                    },
                    {
                        "id": 127418,
                        "name": "Tanner",
                        "latitude": "47.47538000",
                        "longitude": "-121.74622000"
                    },
                    {
                        "id": 127509,
                        "name": "Tenino",
                        "latitude": "46.85677000",
                        "longitude": "-122.85291000"
                    },
                    {
                        "id": 127518,
                        "name": "Terrace Heights",
                        "latitude": "46.60624000",
                        "longitude": "-120.43979000"
                    },
                    {
                        "id": 127613,
                        "name": "Three Lakes",
                        "latitude": "47.94482000",
                        "longitude": "-122.01152000"
                    },
                    {
                        "id": 127631,
                        "name": "Thurston County",
                        "latitude": "46.92950000",
                        "longitude": "-122.83208000"
                    },
                    {
                        "id": 127639,
                        "name": "Tieton",
                        "latitude": "46.70207000",
                        "longitude": "-120.75535000"
                    },
                    {
                        "id": 127717,
                        "name": "Tonasket",
                        "latitude": "48.70515000",
                        "longitude": "-119.43950000"
                    },
                    {
                        "id": 127734,
                        "name": "Toppenish",
                        "latitude": "46.37735000",
                        "longitude": "-120.30867000"
                    },
                    {
                        "id": 127760,
                        "name": "Town and Country",
                        "latitude": "47.72739000",
                        "longitude": "-117.42161000"
                    },
                    {
                        "id": 127773,
                        "name": "Tracyton",
                        "latitude": "47.60898000",
                        "longitude": "-122.65514000"
                    },
                    {
                        "id": 127811,
                        "name": "Trentwood",
                        "latitude": "47.69656000",
                        "longitude": "-117.21076000"
                    },
                    {
                        "id": 127879,
                        "name": "Tukwila",
                        "latitude": "47.47399000",
                        "longitude": "-122.26096000"
                    },
                    {
                        "id": 127880,
                        "name": "Tulalip",
                        "latitude": "48.06843000",
                        "longitude": "-122.29181000"
                    },
                    {
                        "id": 127881,
                        "name": "Tulalip Bay",
                        "latitude": "48.03732000",
                        "longitude": "-122.31014000"
                    },
                    {
                        "id": 127890,
                        "name": "Tumwater",
                        "latitude": "47.00732000",
                        "longitude": "-122.90931000"
                    },
                    {
                        "id": 128004,
                        "name": "Union Gap",
                        "latitude": "46.55735000",
                        "longitude": "-120.47506000"
                    },
                    {
                        "id": 128007,
                        "name": "Union Hill-Novelty Hill",
                        "latitude": "47.67887000",
                        "longitude": "-122.02833000"
                    },
                    {
                        "id": 128036,
                        "name": "University Place",
                        "latitude": "47.23565000",
                        "longitude": "-122.55040000"
                    },
                    {
                        "id": 128144,
                        "name": "Vancouver",
                        "latitude": "45.63873000",
                        "longitude": "-122.66149000"
                    },
                    {
                        "id": 128157,
                        "name": "Vashon",
                        "latitude": "47.44732000",
                        "longitude": "-122.45985000"
                    },
                    {
                        "id": 128167,
                        "name": "Venersborg",
                        "latitude": "45.77373000",
                        "longitude": "-122.42454000"
                    },
                    {
                        "id": 128178,
                        "name": "Veradale",
                        "latitude": "47.64995000",
                        "longitude": "-117.20738000"
                    },
                    {
                        "id": 128332,
                        "name": "Wahkiakum County",
                        "latitude": "46.29125000",
                        "longitude": "-123.43316000"
                    },
                    {
                        "id": 128354,
                        "name": "Waitsburg",
                        "latitude": "46.27042000",
                        "longitude": "-118.15329000"
                    },
                    {
                        "id": 128393,
                        "name": "Walla Walla",
                        "latitude": "46.06458000",
                        "longitude": "-118.34302000"
                    },
                    {
                        "id": 128394,
                        "name": "Walla Walla County",
                        "latitude": "46.22980000",
                        "longitude": "-118.47845000"
                    },
                    {
                        "id": 128395,
                        "name": "Walla Walla East",
                        "latitude": "46.05184000",
                        "longitude": "-118.30403000"
                    },
                    {
                        "id": 128404,
                        "name": "Waller",
                        "latitude": "47.20066000",
                        "longitude": "-122.36929000"
                    },
                    {
                        "id": 128420,
                        "name": "Walnut Grove",
                        "latitude": "45.66789000",
                        "longitude": "-122.59899000"
                    },
                    {
                        "id": 128453,
                        "name": "Wapato",
                        "latitude": "46.44763000",
                        "longitude": "-120.42034000"
                    },
                    {
                        "id": 128460,
                        "name": "Warden",
                        "latitude": "46.96764000",
                        "longitude": "-119.03973000"
                    },
                    {
                        "id": 128467,
                        "name": "Warm Beach",
                        "latitude": "48.17065000",
                        "longitude": "-122.36460000"
                    },
                    {
                        "id": 128591,
                        "name": "Washougal",
                        "latitude": "45.58262000",
                        "longitude": "-122.35342000"
                    },
                    {
                        "id": 128629,
                        "name": "Waterville",
                        "latitude": "47.64708000",
                        "longitude": "-120.07118000"
                    },
                    {
                        "id": 128653,
                        "name": "Wauna",
                        "latitude": "47.37899000",
                        "longitude": "-122.64263000"
                    },
                    {
                        "id": 128797,
                        "name": "Wenatchee",
                        "latitude": "47.42346000",
                        "longitude": "-120.31035000"
                    },
                    {
                        "id": 128847,
                        "name": "West Clarkston-Highland",
                        "latitude": "46.40287000",
                        "longitude": "-117.06395000"
                    },
                    {
                        "id": 128910,
                        "name": "West Lake Sammamish",
                        "latitude": "47.57760000",
                        "longitude": "-122.10123000"
                    },
                    {
                        "id": 128911,
                        "name": "West Lake Stevens",
                        "latitude": "47.99343000",
                        "longitude": "-122.10180000"
                    },
                    {
                        "id": 128923,
                        "name": "West Longview",
                        "latitude": "46.16789000",
                        "longitude": "-122.99900000"
                    },
                    {
                        "id": 128951,
                        "name": "West Pasco",
                        "latitude": "46.24541000",
                        "longitude": "-119.18279000"
                    },
                    {
                        "id": 128968,
                        "name": "West Richland",
                        "latitude": "46.30430000",
                        "longitude": "-119.36141000"
                    },
                    {
                        "id": 128981,
                        "name": "West Side Highway",
                        "latitude": "46.18399000",
                        "longitude": "-122.91715000"
                    },
                    {
                        "id": 128996,
                        "name": "West Valley",
                        "latitude": "46.59207000",
                        "longitude": "-120.60507000"
                    },
                    {
                        "id": 129003,
                        "name": "West Wenatchee",
                        "latitude": "47.44374000",
                        "longitude": "-120.35341000"
                    },
                    {
                        "id": 129073,
                        "name": "Westport",
                        "latitude": "46.89009000",
                        "longitude": "-124.10406000"
                    },
                    {
                        "id": 129105,
                        "name": "Whatcom County",
                        "latitude": "48.82975000",
                        "longitude": "-121.87283000"
                    },
                    {
                        "id": 129129,
                        "name": "White Center",
                        "latitude": "47.51732000",
                        "longitude": "-122.35485000"
                    },
                    {
                        "id": 129159,
                        "name": "White Salmon",
                        "latitude": "45.72762000",
                        "longitude": "-121.48646000"
                    },
                    {
                        "id": 129204,
                        "name": "Whitman County",
                        "latitude": "46.90117000",
                        "longitude": "-117.52299000"
                    },
                    {
                        "id": 129234,
                        "name": "Wilderness Rim",
                        "latitude": "47.44697000",
                        "longitude": "-121.76857000"
                    },
                    {
                        "id": 129403,
                        "name": "Winlock",
                        "latitude": "46.49122000",
                        "longitude": "-122.93790000"
                    },
                    {
                        "id": 129480,
                        "name": "Wollochet",
                        "latitude": "47.26871000",
                        "longitude": "-122.58402000"
                    },
                    {
                        "id": 129523,
                        "name": "Woodinville",
                        "latitude": "47.75427000",
                        "longitude": "-122.16346000"
                    },
                    {
                        "id": 129527,
                        "name": "Woodland",
                        "latitude": "45.90456000",
                        "longitude": "-122.74399000"
                    },
                    {
                        "id": 129550,
                        "name": "Woods Creek",
                        "latitude": "47.87871000",
                        "longitude": "-121.89846000"
                    },
                    {
                        "id": 129579,
                        "name": "Woodway",
                        "latitude": "47.79621000",
                        "longitude": "-122.38291000"
                    },
                    {
                        "id": 129647,
                        "name": "Yacolt",
                        "latitude": "45.86595000",
                        "longitude": "-122.40621000"
                    },
                    {
                        "id": 129650,
                        "name": "Yakima",
                        "latitude": "46.60207000",
                        "longitude": "-120.50590000"
                    },
                    {
                        "id": 129651,
                        "name": "Yakima County",
                        "latitude": "46.45685000",
                        "longitude": "-120.73870000"
                    },
                    {
                        "id": 129669,
                        "name": "Yarrow Point",
                        "latitude": "47.64621000",
                        "longitude": "-122.21735000"
                    },
                    {
                        "id": 129681,
                        "name": "Yelm",
                        "latitude": "46.94204000",
                        "longitude": "-122.60596000"
                    },
                    {
                        "id": 129754,
                        "name": "Zillah",
                        "latitude": "46.40207000",
                        "longitude": "-120.26200000"
                    }
                ]
            },
            {
                "id": 1429,
                "name": "West Virginia",
                "iso2": "WV",
                "latitude": "38.59762620",
                "longitude": "-80.45490260",
                "type": "state",
                "cities": [
                    {
                        "id": 111137,
                        "name": "Alderson",
                        "latitude": "37.72595000",
                        "longitude": "-80.64202000"
                    },
                    {
                        "id": 111253,
                        "name": "Alum Creek",
                        "latitude": "38.28676000",
                        "longitude": "-81.80513000"
                    },
                    {
                        "id": 111363,
                        "name": "Ansted",
                        "latitude": "38.13622000",
                        "longitude": "-81.09955000"
                    },
                    {
                        "id": 111814,
                        "name": "Barbour County",
                        "latitude": "39.13293000",
                        "longitude": "-80.00303000"
                    },
                    {
                        "id": 111817,
                        "name": "Barboursville",
                        "latitude": "38.40953000",
                        "longitude": "-82.29459000"
                    },
                    {
                        "id": 111840,
                        "name": "Barrackville",
                        "latitude": "39.50370000",
                        "longitude": "-80.16675000"
                    },
                    {
                        "id": 111992,
                        "name": "Beaver",
                        "latitude": "37.74781000",
                        "longitude": "-81.14352000"
                    },
                    {
                        "id": 112017,
                        "name": "Beckley",
                        "latitude": "37.77817000",
                        "longitude": "-81.18816000"
                    },
                    {
                        "id": 112064,
                        "name": "Belington",
                        "latitude": "39.02510000",
                        "longitude": "-79.93563000"
                    },
                    {
                        "id": 112079,
                        "name": "Belle",
                        "latitude": "38.23205000",
                        "longitude": "-81.53762000"
                    },
                    {
                        "id": 112211,
                        "name": "Benwood",
                        "latitude": "40.01813000",
                        "longitude": "-80.73425000"
                    },
                    {
                        "id": 112225,
                        "name": "Berkeley County",
                        "latitude": "39.46407000",
                        "longitude": "-78.02754000"
                    },
                    {
                        "id": 112228,
                        "name": "Berkeley Springs",
                        "latitude": "39.62480000",
                        "longitude": "-78.22472000"
                    },
                    {
                        "id": 112275,
                        "name": "Bethany",
                        "latitude": "40.20563000",
                        "longitude": "-80.55674000"
                    },
                    {
                        "id": 112290,
                        "name": "Bethlehem",
                        "latitude": "39.39203000",
                        "longitude": "-80.28064000"
                    },
                    {
                        "id": 112429,
                        "name": "Blennerhassett",
                        "latitude": "39.26369000",
                        "longitude": "-81.62929000"
                    },
                    {
                        "id": 112479,
                        "name": "Bluefield",
                        "latitude": "37.26984000",
                        "longitude": "-81.22232000"
                    },
                    {
                        "id": 112480,
                        "name": "Bluewell",
                        "latitude": "37.31262000",
                        "longitude": "-81.25982000"
                    },
                    {
                        "id": 112491,
                        "name": "Boaz",
                        "latitude": "39.36146000",
                        "longitude": "-81.50207000"
                    },
                    {
                        "id": 112519,
                        "name": "Bolivar",
                        "latitude": "39.32343000",
                        "longitude": "-77.75277000"
                    },
                    {
                        "id": 112557,
                        "name": "Boone County",
                        "latitude": "38.02300000",
                        "longitude": "-81.71121000"
                    },
                    {
                        "id": 112671,
                        "name": "Bradley",
                        "latitude": "37.86539000",
                        "longitude": "-81.19399000"
                    },
                    {
                        "id": 112701,
                        "name": "Braxton County",
                        "latitude": "38.69987000",
                        "longitude": "-80.71929000"
                    },
                    {
                        "id": 112760,
                        "name": "Bridgeport",
                        "latitude": "39.28648000",
                        "longitude": "-80.25620000"
                    },
                    {
                        "id": 112852,
                        "name": "Brooke County",
                        "latitude": "40.27381000",
                        "longitude": "-80.57642000"
                    },
                    {
                        "id": 112859,
                        "name": "Brookhaven",
                        "latitude": "39.61175000",
                        "longitude": "-79.90451000"
                    },
                    {
                        "id": 112954,
                        "name": "Brush Fork",
                        "latitude": "37.28095000",
                        "longitude": "-81.25593000"
                    },
                    {
                        "id": 112981,
                        "name": "Buckhannon",
                        "latitude": "38.99399000",
                        "longitude": "-80.23203000"
                    },
                    {
                        "id": 113011,
                        "name": "Buffalo",
                        "latitude": "38.61759000",
                        "longitude": "-81.98180000"
                    },
                    {
                        "id": 113151,
                        "name": "Cabell County",
                        "latitude": "38.42030000",
                        "longitude": "-82.24172000"
                    },
                    {
                        "id": 113208,
                        "name": "Calhoun County",
                        "latitude": "38.84450000",
                        "longitude": "-81.11757000"
                    },
                    {
                        "id": 113699,
                        "name": "Ceredo",
                        "latitude": "38.39647000",
                        "longitude": "-82.55877000"
                    },
                    {
                        "id": 113745,
                        "name": "Chapmanville",
                        "latitude": "37.97371000",
                        "longitude": "-82.01735000"
                    },
                    {
                        "id": 113759,
                        "name": "Charles Town",
                        "latitude": "39.28899000",
                        "longitude": "-77.85972000"
                    },
                    {
                        "id": 113766,
                        "name": "Charleston",
                        "latitude": "38.34982000",
                        "longitude": "-81.63262000"
                    },
                    {
                        "id": 113818,
                        "name": "Cheat Lake",
                        "latitude": "39.67202000",
                        "longitude": "-79.85339000"
                    },
                    {
                        "id": 113873,
                        "name": "Chesapeake",
                        "latitude": "38.22344000",
                        "longitude": "-81.53623000"
                    },
                    {
                        "id": 113890,
                        "name": "Chester",
                        "latitude": "40.61312000",
                        "longitude": "-80.56285000"
                    },
                    {
                        "id": 114144,
                        "name": "Clarksburg",
                        "latitude": "39.28065000",
                        "longitude": "-80.34453000"
                    },
                    {
                        "id": 114167,
                        "name": "Clay",
                        "latitude": "38.46038000",
                        "longitude": "-81.08511000"
                    },
                    {
                        "id": 114186,
                        "name": "Clay County",
                        "latitude": "38.46253000",
                        "longitude": "-81.07509000"
                    },
                    {
                        "id": 114235,
                        "name": "Clendenin",
                        "latitude": "38.48871000",
                        "longitude": "-81.34817000"
                    },
                    {
                        "id": 114326,
                        "name": "Coal City",
                        "latitude": "37.67900000",
                        "longitude": "-81.21038000"
                    },
                    {
                        "id": 114330,
                        "name": "Coal Fork",
                        "latitude": "38.31760000",
                        "longitude": "-81.52095000"
                    },
                    {
                        "id": 114753,
                        "name": "Crab Orchard",
                        "latitude": "37.74067000",
                        "longitude": "-81.23066000"
                    },
                    {
                        "id": 114760,
                        "name": "Craigsville",
                        "latitude": "38.33067000",
                        "longitude": "-80.65315000"
                    },
                    {
                        "id": 114850,
                        "name": "Cross Lanes",
                        "latitude": "38.42037000",
                        "longitude": "-81.79068000"
                    },
                    {
                        "id": 114897,
                        "name": "Culloden",
                        "latitude": "38.42009000",
                        "longitude": "-82.05542000"
                    },
                    {
                        "id": 115023,
                        "name": "Daniels",
                        "latitude": "37.74327000",
                        "longitude": "-81.12408000"
                    },
                    {
                        "id": 115288,
                        "name": "Despard",
                        "latitude": "39.28870000",
                        "longitude": "-80.30592000"
                    },
                    {
                        "id": 115374,
                        "name": "Doddridge County",
                        "latitude": "39.26917000",
                        "longitude": "-80.70697000"
                    },
                    {
                        "id": 115520,
                        "name": "Dunbar",
                        "latitude": "38.36065000",
                        "longitude": "-81.73735000"
                    },
                    {
                        "id": 115958,
                        "name": "Eleanor",
                        "latitude": "38.53759000",
                        "longitude": "-81.93236000"
                    },
                    {
                        "id": 115971,
                        "name": "Elizabeth",
                        "latitude": "39.06341000",
                        "longitude": "-81.39512000"
                    },
                    {
                        "id": 116006,
                        "name": "Elkins",
                        "latitude": "38.92594000",
                        "longitude": "-79.84673000"
                    },
                    {
                        "id": 116015,
                        "name": "Elkview",
                        "latitude": "38.44288000",
                        "longitude": "-81.48040000"
                    },
                    {
                        "id": 116331,
                        "name": "Fairlea",
                        "latitude": "37.78068000",
                        "longitude": "-80.45702000"
                    },
                    {
                        "id": 116335,
                        "name": "Fairmont",
                        "latitude": "39.48508000",
                        "longitude": "-80.14258000"
                    },
                    {
                        "id": 116450,
                        "name": "Fayette County",
                        "latitude": "38.02878000",
                        "longitude": "-81.08119000"
                    },
                    {
                        "id": 116459,
                        "name": "Fayetteville",
                        "latitude": "38.05289000",
                        "longitude": "-81.10399000"
                    },
                    {
                        "id": 116622,
                        "name": "Follansbee",
                        "latitude": "40.32757000",
                        "longitude": "-80.59591000"
                    },
                    {
                        "id": 116688,
                        "name": "Fort Ashby",
                        "latitude": "39.50315000",
                        "longitude": "-78.76863000"
                    },
                    {
                        "id": 116832,
                        "name": "Franklin",
                        "latitude": "38.64289000",
                        "longitude": "-79.33115000"
                    },
                    {
                        "id": 117205,
                        "name": "Gilbert Creek",
                        "latitude": "37.57594000",
                        "longitude": "-81.89484000"
                    },
                    {
                        "id": 117223,
                        "name": "Gilmer County",
                        "latitude": "38.92406000",
                        "longitude": "-80.85708000"
                    },
                    {
                        "id": 117282,
                        "name": "Glendale",
                        "latitude": "39.94924000",
                        "longitude": "-80.75425000"
                    },
                    {
                        "id": 117310,
                        "name": "Glenville",
                        "latitude": "38.93426000",
                        "longitude": "-80.83760000"
                    },
                    {
                        "id": 117428,
                        "name": "Grafton",
                        "latitude": "39.34092000",
                        "longitude": "-80.01897000"
                    },
                    {
                        "id": 117511,
                        "name": "Grant County",
                        "latitude": "39.10513000",
                        "longitude": "-79.19557000"
                    },
                    {
                        "id": 117530,
                        "name": "Grantsville",
                        "latitude": "38.92342000",
                        "longitude": "-81.09595000"
                    },
                    {
                        "id": 117533,
                        "name": "Granville",
                        "latitude": "39.64591000",
                        "longitude": "-79.98729000"
                    },
                    {
                        "id": 117621,
                        "name": "Greenbrier County",
                        "latitude": "37.94693000",
                        "longitude": "-80.45295000"
                    },
                    {
                        "id": 117908,
                        "name": "Hamlin",
                        "latitude": "38.27870000",
                        "longitude": "-82.10292000"
                    },
                    {
                        "id": 117921,
                        "name": "Hampshire County",
                        "latitude": "39.31707000",
                        "longitude": "-78.61417000"
                    },
                    {
                        "id": 117958,
                        "name": "Hancock County",
                        "latitude": "40.52185000",
                        "longitude": "-80.57389000"
                    },
                    {
                        "id": 118011,
                        "name": "Hardy County",
                        "latitude": "39.00750000",
                        "longitude": "-78.85792000"
                    },
                    {
                        "id": 118066,
                        "name": "Harrison County",
                        "latitude": "39.28353000",
                        "longitude": "-80.37987000"
                    },
                    {
                        "id": 118073,
                        "name": "Harrisville",
                        "latitude": "39.20952000",
                        "longitude": "-81.05178000"
                    },
                    {
                        "id": 118489,
                        "name": "Hinton",
                        "latitude": "37.67401000",
                        "longitude": "-80.88925000"
                    },
                    {
                        "id": 118639,
                        "name": "Hooverson Heights",
                        "latitude": "40.32479000",
                        "longitude": "-80.57757000"
                    },
                    {
                        "id": 118800,
                        "name": "Huntington",
                        "latitude": "38.41925000",
                        "longitude": "-82.44515000"
                    },
                    {
                        "id": 118827,
                        "name": "Hurricane",
                        "latitude": "38.43259000",
                        "longitude": "-82.02014000"
                    },
                    {
                        "id": 118962,
                        "name": "Inwood",
                        "latitude": "39.35788000",
                        "longitude": "-78.04000000"
                    },
                    {
                        "id": 119089,
                        "name": "Jackson County",
                        "latitude": "38.83447000",
                        "longitude": "-81.67479000"
                    },
                    {
                        "id": 119188,
                        "name": "Jefferson County",
                        "latitude": "39.30762000",
                        "longitude": "-77.86274000"
                    },
                    {
                        "id": 119374,
                        "name": "Kanawha County",
                        "latitude": "38.33657000",
                        "longitude": "-81.52812000"
                    },
                    {
                        "id": 119478,
                        "name": "Kenova",
                        "latitude": "38.39897000",
                        "longitude": "-82.57821000"
                    },
                    {
                        "id": 119545,
                        "name": "Keyser",
                        "latitude": "39.44093000",
                        "longitude": "-78.97392000"
                    },
                    {
                        "id": 119637,
                        "name": "Kingwood",
                        "latitude": "39.47176000",
                        "longitude": "-79.68339000"
                    },
                    {
                        "id": 120215,
                        "name": "Lavalette",
                        "latitude": "38.32286000",
                        "longitude": "-82.44682000"
                    },
                    {
                        "id": 120395,
                        "name": "Lesage",
                        "latitude": "38.50647000",
                        "longitude": "-82.29848000"
                    },
                    {
                        "id": 120413,
                        "name": "Lewis County",
                        "latitude": "38.99587000",
                        "longitude": "-80.50216000"
                    },
                    {
                        "id": 120420,
                        "name": "Lewisburg",
                        "latitude": "37.80179000",
                        "longitude": "-80.44563000"
                    },
                    {
                        "id": 120525,
                        "name": "Lincoln County",
                        "latitude": "38.17536000",
                        "longitude": "-82.07039000"
                    },
                    {
                        "id": 120693,
                        "name": "Logan",
                        "latitude": "37.84871000",
                        "longitude": "-81.99346000"
                    },
                    {
                        "id": 120699,
                        "name": "Logan County",
                        "latitude": "37.83153000",
                        "longitude": "-81.93534000"
                    },
                    {
                        "id": 120858,
                        "name": "Lubeck",
                        "latitude": "39.23535000",
                        "longitude": "-81.63124000"
                    },
                    {
                        "id": 120950,
                        "name": "Mabscott",
                        "latitude": "37.77095000",
                        "longitude": "-81.20843000"
                    },
                    {
                        "id": 120952,
                        "name": "MacArthur",
                        "latitude": "37.75845000",
                        "longitude": "-81.21260000"
                    },
                    {
                        "id": 120993,
                        "name": "Madison",
                        "latitude": "38.06705000",
                        "longitude": "-81.81929000"
                    },
                    {
                        "id": 121063,
                        "name": "Mallory",
                        "latitude": "37.73066000",
                        "longitude": "-81.83790000"
                    },
                    {
                        "id": 121137,
                        "name": "Mannington",
                        "latitude": "39.53092000",
                        "longitude": "-80.34342000"
                    },
                    {
                        "id": 121260,
                        "name": "Marion County",
                        "latitude": "39.51000000",
                        "longitude": "-80.24340000"
                    },
                    {
                        "id": 121284,
                        "name": "Marlinton",
                        "latitude": "38.22345000",
                        "longitude": "-80.09451000"
                    },
                    {
                        "id": 121290,
                        "name": "Marmet",
                        "latitude": "38.24538000",
                        "longitude": "-81.56706000"
                    },
                    {
                        "id": 121316,
                        "name": "Marshall County",
                        "latitude": "39.86061000",
                        "longitude": "-80.66339000"
                    },
                    {
                        "id": 121346,
                        "name": "Martinsburg",
                        "latitude": "39.45621000",
                        "longitude": "-77.96389000"
                    },
                    {
                        "id": 121379,
                        "name": "Mason County",
                        "latitude": "38.76974000",
                        "longitude": "-82.02654000"
                    },
                    {
                        "id": 121496,
                        "name": "McDowell County",
                        "latitude": "37.37850000",
                        "longitude": "-81.65358000"
                    },
                    {
                        "id": 121537,
                        "name": "McMechen",
                        "latitude": "39.98813000",
                        "longitude": "-80.73147000"
                    },
                    {
                        "id": 121676,
                        "name": "Mercer County",
                        "latitude": "37.40552000",
                        "longitude": "-81.11144000"
                    },
                    {
                        "id": 121767,
                        "name": "Middlebourne",
                        "latitude": "39.49230000",
                        "longitude": "-80.90372000"
                    },
                    {
                        "id": 121914,
                        "name": "Milton",
                        "latitude": "38.43453000",
                        "longitude": "-82.13236000"
                    },
                    {
                        "id": 121934,
                        "name": "Mineral County",
                        "latitude": "39.41472000",
                        "longitude": "-78.94375000"
                    },
                    {
                        "id": 121942,
                        "name": "Mineral Wells",
                        "latitude": "39.19035000",
                        "longitude": "-81.53207000"
                    },
                    {
                        "id": 121946,
                        "name": "Mingo County",
                        "latitude": "37.72640000",
                        "longitude": "-82.13476000"
                    },
                    {
                        "id": 122054,
                        "name": "Monongah",
                        "latitude": "39.46258000",
                        "longitude": "-80.21814000"
                    },
                    {
                        "id": 122056,
                        "name": "Monongalia County",
                        "latitude": "39.63028000",
                        "longitude": "-80.04654000"
                    },
                    {
                        "id": 122077,
                        "name": "Monroe County",
                        "latitude": "37.56037000",
                        "longitude": "-80.55055000"
                    },
                    {
                        "id": 122132,
                        "name": "Montgomery",
                        "latitude": "38.18038000",
                        "longitude": "-81.32845000"
                    },
                    {
                        "id": 122205,
                        "name": "Moorefield",
                        "latitude": "39.06233000",
                        "longitude": "-78.96947000"
                    },
                    {
                        "id": 122243,
                        "name": "Morgan County",
                        "latitude": "39.56043000",
                        "longitude": "-78.25773000"
                    },
                    {
                        "id": 122253,
                        "name": "Morgantown",
                        "latitude": "39.62953000",
                        "longitude": "-79.95590000"
                    },
                    {
                        "id": 122327,
                        "name": "Moundsville",
                        "latitude": "39.92035000",
                        "longitude": "-80.74314000"
                    },
                    {
                        "id": 122343,
                        "name": "Mount Gay-Shamrock",
                        "latitude": "37.83857000",
                        "longitude": "-82.02970000"
                    },
                    {
                        "id": 122353,
                        "name": "Mount Hope",
                        "latitude": "37.89539000",
                        "longitude": "-81.16427000"
                    },
                    {
                        "id": 122460,
                        "name": "Mullens",
                        "latitude": "37.58317000",
                        "longitude": "-81.38038000"
                    },
                    {
                        "id": 122698,
                        "name": "New Cumberland",
                        "latitude": "40.49673000",
                        "longitude": "-80.60674000"
                    },
                    {
                        "id": 122715,
                        "name": "New Haven",
                        "latitude": "38.98647000",
                        "longitude": "-81.97347000"
                    },
                    {
                        "id": 122753,
                        "name": "New Martinsville",
                        "latitude": "39.64452000",
                        "longitude": "-80.85760000"
                    },
                    {
                        "id": 122824,
                        "name": "Newell",
                        "latitude": "40.61840000",
                        "longitude": "-80.60424000"
                    },
                    {
                        "id": 122888,
                        "name": "Nicholas County",
                        "latitude": "38.29170000",
                        "longitude": "-80.79933000"
                    },
                    {
                        "id": 122909,
                        "name": "Nitro",
                        "latitude": "38.41481000",
                        "longitude": "-81.84402000"
                    },
                    {
                        "id": 123220,
                        "name": "Nutter Fort",
                        "latitude": "39.26342000",
                        "longitude": "-80.31981000"
                    },
                    {
                        "id": 123245,
                        "name": "Oak Hill",
                        "latitude": "37.97233000",
                        "longitude": "-81.14871000"
                    },
                    {
                        "id": 123339,
                        "name": "Oceana",
                        "latitude": "37.69206000",
                        "longitude": "-81.62400000"
                    },
                    {
                        "id": 123384,
                        "name": "Ohio County",
                        "latitude": "40.09692000",
                        "longitude": "-80.61906000"
                    },
                    {
                        "id": 123714,
                        "name": "Paden City",
                        "latitude": "39.60285000",
                        "longitude": "-80.93677000"
                    },
                    {
                        "id": 123868,
                        "name": "Parkersburg",
                        "latitude": "39.26674000",
                        "longitude": "-81.56151000"
                    },
                    {
                        "id": 123893,
                        "name": "Parsons",
                        "latitude": "39.09649000",
                        "longitude": "-79.68090000"
                    },
                    {
                        "id": 123952,
                        "name": "Pea Ridge",
                        "latitude": "38.41397000",
                        "longitude": "-82.31987000"
                    },
                    {
                        "id": 124020,
                        "name": "Pendleton County",
                        "latitude": "38.68073000",
                        "longitude": "-79.35089000"
                    },
                    {
                        "id": 124035,
                        "name": "Pennsboro",
                        "latitude": "39.28508000",
                        "longitude": "-80.96844000"
                    },
                    {
                        "id": 124104,
                        "name": "Petersburg",
                        "latitude": "38.99261000",
                        "longitude": "-79.12392000"
                    },
                    {
                        "id": 124130,
                        "name": "Philippi",
                        "latitude": "39.15232000",
                        "longitude": "-80.04036000"
                    },
                    {
                        "id": 124208,
                        "name": "Pinch",
                        "latitude": "38.40871000",
                        "longitude": "-81.48179000"
                    },
                    {
                        "id": 124263,
                        "name": "Pineville",
                        "latitude": "37.58317000",
                        "longitude": "-81.53705000"
                    },
                    {
                        "id": 124378,
                        "name": "Pleasant Valley",
                        "latitude": "39.45536000",
                        "longitude": "-80.14175000"
                    },
                    {
                        "id": 124385,
                        "name": "Pleasants County",
                        "latitude": "39.37094000",
                        "longitude": "-81.16063000"
                    },
                    {
                        "id": 124415,
                        "name": "Pocahontas County",
                        "latitude": "38.33180000",
                        "longitude": "-80.00775000"
                    },
                    {
                        "id": 124430,
                        "name": "Point Pleasant",
                        "latitude": "38.84453000",
                        "longitude": "-82.13709000"
                    },
                    {
                        "id": 124659,
                        "name": "Preston County",
                        "latitude": "39.46930000",
                        "longitude": "-79.66816000"
                    },
                    {
                        "id": 124685,
                        "name": "Princeton",
                        "latitude": "37.36623000",
                        "longitude": "-81.10259000"
                    },
                    {
                        "id": 124713,
                        "name": "Prosperity",
                        "latitude": "37.83650000",
                        "longitude": "-81.20177000"
                    },
                    {
                        "id": 124765,
                        "name": "Putnam County",
                        "latitude": "38.50862000",
                        "longitude": "-81.90899000"
                    },
                    {
                        "id": 124825,
                        "name": "Rainelle",
                        "latitude": "37.96873000",
                        "longitude": "-80.76703000"
                    },
                    {
                        "id": 124832,
                        "name": "Raleigh County",
                        "latitude": "37.77136000",
                        "longitude": "-81.24863000"
                    },
                    {
                        "id": 124861,
                        "name": "Rand",
                        "latitude": "38.28260000",
                        "longitude": "-81.56234000"
                    },
                    {
                        "id": 124878,
                        "name": "Randolph County",
                        "latitude": "38.77472000",
                        "longitude": "-79.87580000"
                    },
                    {
                        "id": 124890,
                        "name": "Ranson",
                        "latitude": "39.29510000",
                        "longitude": "-77.86055000"
                    },
                    {
                        "id": 124910,
                        "name": "Ravenswood",
                        "latitude": "38.94814000",
                        "longitude": "-81.76096000"
                    },
                    {
                        "id": 154482,
                        "name": "Red House",
                        "latitude": "38.54178110",
                        "longitude": "-81.90411860"
                    },
                    {
                        "id": 125112,
                        "name": "Richwood",
                        "latitude": "38.22484000",
                        "longitude": "-80.53314000"
                    },
                    {
                        "id": 125164,
                        "name": "Ripley",
                        "latitude": "38.81870000",
                        "longitude": "-81.71069000"
                    },
                    {
                        "id": 125173,
                        "name": "Ritchie County",
                        "latitude": "39.17827000",
                        "longitude": "-81.06295000"
                    },
                    {
                        "id": 125225,
                        "name": "Roane County",
                        "latitude": "38.71403000",
                        "longitude": "-81.34835000"
                    },
                    {
                        "id": 125383,
                        "name": "Romney",
                        "latitude": "39.34204000",
                        "longitude": "-78.75668000"
                    },
                    {
                        "id": 125387,
                        "name": "Ronceverte",
                        "latitude": "37.74984000",
                        "longitude": "-80.46285000"
                    },
                    {
                        "id": 125594,
                        "name": "Saint Albans",
                        "latitude": "38.38565000",
                        "longitude": "-81.83624000"
                    },
                    {
                        "id": 125693,
                        "name": "Saint Marys",
                        "latitude": "39.39174000",
                        "longitude": "-81.20511000"
                    },
                    {
                        "id": 125733,
                        "name": "Salem",
                        "latitude": "39.28287000",
                        "longitude": "-80.55899000"
                    },
                    {
                        "id": 126208,
                        "name": "Shady Spring",
                        "latitude": "37.70567000",
                        "longitude": "-81.09843000"
                    },
                    {
                        "id": 126222,
                        "name": "Shannondale",
                        "latitude": "39.21705000",
                        "longitude": "-77.80749000"
                    },
                    {
                        "id": 126311,
                        "name": "Shepherdstown",
                        "latitude": "39.43010000",
                        "longitude": "-77.80416000"
                    },
                    {
                        "id": 126355,
                        "name": "Shinnston",
                        "latitude": "39.39564000",
                        "longitude": "-80.30009000"
                    },
                    {
                        "id": 126467,
                        "name": "Sissonville",
                        "latitude": "38.52815000",
                        "longitude": "-81.63096000"
                    },
                    {
                        "id": 126469,
                        "name": "Sistersville",
                        "latitude": "39.56424000",
                        "longitude": "-80.99594000"
                    },
                    {
                        "id": 126603,
                        "name": "Sophia",
                        "latitude": "37.70761000",
                        "longitude": "-81.25066000"
                    },
                    {
                        "id": 126636,
                        "name": "South Charleston",
                        "latitude": "38.36843000",
                        "longitude": "-81.69957000"
                    },
                    {
                        "id": 126824,
                        "name": "Spencer",
                        "latitude": "38.80203000",
                        "longitude": "-81.35095000"
                    },
                    {
                        "id": 126947,
                        "name": "Stanaford",
                        "latitude": "37.81595000",
                        "longitude": "-81.15232000"
                    },
                    {
                        "id": 126980,
                        "name": "Star City",
                        "latitude": "39.65841000",
                        "longitude": "-79.98645000"
                    },
                    {
                        "id": 127094,
                        "name": "Stonewood",
                        "latitude": "39.25092000",
                        "longitude": "-80.31231000"
                    },
                    {
                        "id": 127206,
                        "name": "Summers County",
                        "latitude": "37.65587000",
                        "longitude": "-80.85857000"
                    },
                    {
                        "id": 127208,
                        "name": "Summersville",
                        "latitude": "38.28122000",
                        "longitude": "-80.85260000"
                    },
                    {
                        "id": 127311,
                        "name": "Sutton",
                        "latitude": "38.66454000",
                        "longitude": "-80.70982000"
                    },
                    {
                        "id": 127455,
                        "name": "Taylor County",
                        "latitude": "39.33599000",
                        "longitude": "-80.04618000"
                    },
                    {
                        "id": 127477,
                        "name": "Teays Valley",
                        "latitude": "38.45009000",
                        "longitude": "-81.92930000"
                    },
                    {
                        "id": 127514,
                        "name": "Terra Alta",
                        "latitude": "39.44565000",
                        "longitude": "-79.54644000"
                    },
                    {
                        "id": 127739,
                        "name": "Tornado",
                        "latitude": "38.34287000",
                        "longitude": "-81.84430000"
                    },
                    {
                        "id": 127871,
                        "name": "Tucker County",
                        "latitude": "39.11360000",
                        "longitude": "-79.56497000"
                    },
                    {
                        "id": 127943,
                        "name": "Tyler County",
                        "latitude": "39.46528000",
                        "longitude": "-80.88483000"
                    },
                    {
                        "id": 127976,
                        "name": "Union",
                        "latitude": "37.59151000",
                        "longitude": "-80.54368000"
                    },
                    {
                        "id": 128053,
                        "name": "Upshur County",
                        "latitude": "38.89783000",
                        "longitude": "-80.23342000"
                    },
                    {
                        "id": 128233,
                        "name": "Vienna",
                        "latitude": "39.32702000",
                        "longitude": "-81.54846000"
                    },
                    {
                        "id": 128544,
                        "name": "Washington",
                        "latitude": "39.26119000",
                        "longitude": "-81.67180000"
                    },
                    {
                        "id": 128681,
                        "name": "Wayne",
                        "latitude": "38.22147000",
                        "longitude": "-82.44237000"
                    },
                    {
                        "id": 128697,
                        "name": "Wayne County",
                        "latitude": "38.14595000",
                        "longitude": "-82.42695000"
                    },
                    {
                        "id": 128740,
                        "name": "Webster County",
                        "latitude": "38.49474000",
                        "longitude": "-80.42187000"
                    },
                    {
                        "id": 128745,
                        "name": "Webster Springs",
                        "latitude": "38.47927000",
                        "longitude": "-80.41342000"
                    },
                    {
                        "id": 128759,
                        "name": "Weirton",
                        "latitude": "40.41896000",
                        "longitude": "-80.58952000"
                    },
                    {
                        "id": 128760,
                        "name": "Weirton Heights",
                        "latitude": "40.40840000",
                        "longitude": "-80.53924000"
                    },
                    {
                        "id": 128765,
                        "name": "Welch",
                        "latitude": "37.43289000",
                        "longitude": "-81.58455000"
                    },
                    {
                        "id": 128789,
                        "name": "Wellsburg",
                        "latitude": "40.27201000",
                        "longitude": "-80.60952000"
                    },
                    {
                        "id": 128918,
                        "name": "West Liberty",
                        "latitude": "40.16979000",
                        "longitude": "-80.59369000"
                    },
                    {
                        "id": 128994,
                        "name": "West Union",
                        "latitude": "39.29647000",
                        "longitude": "-80.77705000"
                    },
                    {
                        "id": 129060,
                        "name": "Weston",
                        "latitude": "39.03843000",
                        "longitude": "-80.46731000"
                    },
                    {
                        "id": 129068,
                        "name": "Westover",
                        "latitude": "39.63453000",
                        "longitude": "-79.96979000"
                    },
                    {
                        "id": 129093,
                        "name": "Wetzel County",
                        "latitude": "39.60526000",
                        "longitude": "-80.63910000"
                    },
                    {
                        "id": 129121,
                        "name": "Wheeling",
                        "latitude": "40.06396000",
                        "longitude": "-80.72091000"
                    },
                    {
                        "id": 129162,
                        "name": "White Sulphur Springs",
                        "latitude": "37.79651000",
                        "longitude": "-80.29757000"
                    },
                    {
                        "id": 129243,
                        "name": "Wiley Ford",
                        "latitude": "39.61453000",
                        "longitude": "-78.77502000"
                    },
                    {
                        "id": 129273,
                        "name": "Williamson",
                        "latitude": "37.67427000",
                        "longitude": "-82.27736000"
                    },
                    {
                        "id": 129287,
                        "name": "Williamstown",
                        "latitude": "39.40063000",
                        "longitude": "-81.44818000"
                    },
                    {
                        "id": 129396,
                        "name": "Winfield",
                        "latitude": "38.53314000",
                        "longitude": "-81.89347000"
                    },
                    {
                        "id": 129455,
                        "name": "Wirt County",
                        "latitude": "39.02242000",
                        "longitude": "-81.37862000"
                    },
                    {
                        "id": 129485,
                        "name": "Wood County",
                        "latitude": "39.21113000",
                        "longitude": "-81.51497000"
                    },
                    {
                        "id": 129639,
                        "name": "Wyoming County",
                        "latitude": "37.60961000",
                        "longitude": "-81.54918000"
                    }
                ]
            },
            {
                "id": 1441,
                "name": "Wisconsin",
                "iso2": "WI",
                "latitude": "43.78443970",
                "longitude": "-88.78786780",
                "type": "state",
                "cities": [
                    {
                        "id": 110970,
                        "name": "Abbotsford",
                        "latitude": "44.94636000",
                        "longitude": "-90.31597000"
                    },
                    {
                        "id": 111015,
                        "name": "Adams",
                        "latitude": "43.95608000",
                        "longitude": "-89.81818000"
                    },
                    {
                        "id": 111023,
                        "name": "Adams County",
                        "latitude": "43.96963000",
                        "longitude": "-89.77064000"
                    },
                    {
                        "id": 111038,
                        "name": "Addison",
                        "latitude": "43.42278000",
                        "longitude": "-88.37454000"
                    },
                    {
                        "id": 111109,
                        "name": "Albany",
                        "latitude": "42.70778000",
                        "longitude": "-89.43706000"
                    },
                    {
                        "id": 111162,
                        "name": "Algoma",
                        "latitude": "44.60889000",
                        "longitude": "-87.43259000"
                    },
                    {
                        "id": 111203,
                        "name": "Allouez",
                        "latitude": "44.47749000",
                        "longitude": "-88.01621000"
                    },
                    {
                        "id": 111211,
                        "name": "Alma",
                        "latitude": "44.31997000",
                        "longitude": "-91.91488000"
                    },
                    {
                        "id": 111241,
                        "name": "Alto",
                        "latitude": "43.67665000",
                        "longitude": "-88.79511000"
                    },
                    {
                        "id": 111249,
                        "name": "Altoona",
                        "latitude": "44.80468000",
                        "longitude": "-91.44321000"
                    },
                    {
                        "id": 111275,
                        "name": "Amery",
                        "latitude": "45.30691000",
                        "longitude": "-92.36214000"
                    },
                    {
                        "id": 111284,
                        "name": "Amherst",
                        "latitude": "44.45081000",
                        "longitude": "-89.28484000"
                    },
                    {
                        "id": 111371,
                        "name": "Antigo",
                        "latitude": "45.14025000",
                        "longitude": "-89.15234000"
                    },
                    {
                        "id": 111397,
                        "name": "Appleton",
                        "latitude": "44.26193000",
                        "longitude": "-88.41538000"
                    },
                    {
                        "id": 111424,
                        "name": "Arcadia",
                        "latitude": "44.25274000",
                        "longitude": "-91.50154000"
                    },
                    {
                        "id": 111525,
                        "name": "Ashford",
                        "latitude": "43.58694000",
                        "longitude": "-88.37066000"
                    },
                    {
                        "id": 111539,
                        "name": "Ashland",
                        "latitude": "46.59244000",
                        "longitude": "-90.88380000"
                    },
                    {
                        "id": 111542,
                        "name": "Ashland County",
                        "latitude": "46.50974000",
                        "longitude": "-90.71960000"
                    },
                    {
                        "id": 111549,
                        "name": "Ashwaubenon",
                        "latitude": "44.48221000",
                        "longitude": "-88.07010000"
                    },
                    {
                        "id": 111581,
                        "name": "Athens",
                        "latitude": "45.03302000",
                        "longitude": "-90.07402000"
                    },
                    {
                        "id": 111651,
                        "name": "Augusta",
                        "latitude": "44.68024000",
                        "longitude": "-91.11988000"
                    },
                    {
                        "id": 111711,
                        "name": "Aztalan",
                        "latitude": "43.07278000",
                        "longitude": "-88.86233000"
                    },
                    {
                        "id": 111758,
                        "name": "Baldwin",
                        "latitude": "44.96663000",
                        "longitude": "-92.37436000"
                    },
                    {
                        "id": 111780,
                        "name": "Balsam Lake",
                        "latitude": "45.45218000",
                        "longitude": "-92.45464000"
                    },
                    {
                        "id": 111794,
                        "name": "Bangor",
                        "latitude": "43.89302000",
                        "longitude": "-90.99041000"
                    },
                    {
                        "id": 111808,
                        "name": "Baraboo",
                        "latitude": "43.47109000",
                        "longitude": "-89.74429000"
                    },
                    {
                        "id": 111831,
                        "name": "Barneveld",
                        "latitude": "43.01555000",
                        "longitude": "-89.89540000"
                    },
                    {
                        "id": 111850,
                        "name": "Barron",
                        "latitude": "45.40135000",
                        "longitude": "-91.84906000"
                    },
                    {
                        "id": 111851,
                        "name": "Barron County",
                        "latitude": "45.42372000",
                        "longitude": "-91.84831000"
                    },
                    {
                        "id": 111865,
                        "name": "Barton",
                        "latitude": "43.44361000",
                        "longitude": "-88.18065000"
                    },
                    {
                        "id": 111942,
                        "name": "Bayfield County",
                        "latitude": "46.63544000",
                        "longitude": "-91.18068000"
                    },
                    {
                        "id": 111956,
                        "name": "Bayside",
                        "latitude": "43.18056000",
                        "longitude": "-87.90064000"
                    },
                    {
                        "id": 112001,
                        "name": "Beaver Dam",
                        "latitude": "43.45777000",
                        "longitude": "-88.83733000"
                    },
                    {
                        "id": 112060,
                        "name": "Belgium",
                        "latitude": "43.49972000",
                        "longitude": "-87.85037000"
                    },
                    {
                        "id": 112091,
                        "name": "Belle Plaine",
                        "latitude": "44.71526000",
                        "longitude": "-88.66621000"
                    },
                    {
                        "id": 112108,
                        "name": "Belleville",
                        "latitude": "42.85972000",
                        "longitude": "-89.53818000"
                    },
                    {
                        "id": 112115,
                        "name": "Bellevue",
                        "latitude": "44.44416000",
                        "longitude": "-87.92010000"
                    },
                    {
                        "id": 112146,
                        "name": "Beloit",
                        "latitude": "42.50835000",
                        "longitude": "-89.03178000"
                    },
                    {
                        "id": 112239,
                        "name": "Berlin",
                        "latitude": "43.96804000",
                        "longitude": "-88.94345000"
                    },
                    {
                        "id": 112298,
                        "name": "Bevent",
                        "latitude": "44.77053000",
                        "longitude": "-89.38956000"
                    },
                    {
                        "id": 112318,
                        "name": "Big Bend",
                        "latitude": "42.88140000",
                        "longitude": "-88.20676000"
                    },
                    {
                        "id": 112372,
                        "name": "Black Creek",
                        "latitude": "44.47749000",
                        "longitude": "-88.45066000"
                    },
                    {
                        "id": 112375,
                        "name": "Black Earth",
                        "latitude": "43.13722000",
                        "longitude": "-89.74679000"
                    },
                    {
                        "id": 112383,
                        "name": "Black River Falls",
                        "latitude": "44.29468000",
                        "longitude": "-90.85153000"
                    },
                    {
                        "id": 112410,
                        "name": "Blair",
                        "latitude": "44.29440000",
                        "longitude": "-91.23516000"
                    },
                    {
                        "id": 112432,
                        "name": "Bloomer",
                        "latitude": "45.10024000",
                        "longitude": "-91.48877000"
                    },
                    {
                        "id": 112503,
                        "name": "Bohners Lake",
                        "latitude": "42.62307000",
                        "longitude": "-88.28037000"
                    },
                    {
                        "id": 112533,
                        "name": "Bonduel",
                        "latitude": "44.74027000",
                        "longitude": "-88.44482000"
                    },
                    {
                        "id": 112583,
                        "name": "Boscobel",
                        "latitude": "43.13443000",
                        "longitude": "-90.70540000"
                    },
                    {
                        "id": 112640,
                        "name": "Boyceville",
                        "latitude": "45.04357000",
                        "longitude": "-92.04101000"
                    },
                    {
                        "id": 112752,
                        "name": "Brice Prairie",
                        "latitude": "43.93857000",
                        "longitude": "-91.29986000"
                    },
                    {
                        "id": 112796,
                        "name": "Brillion",
                        "latitude": "44.17721000",
                        "longitude": "-88.06427000"
                    },
                    {
                        "id": 112811,
                        "name": "Bristol",
                        "latitude": "42.55891000",
                        "longitude": "-88.04925000"
                    },
                    {
                        "id": 112838,
                        "name": "Brodhead",
                        "latitude": "42.61834000",
                        "longitude": "-89.37623000"
                    },
                    {
                        "id": 112855,
                        "name": "Brookfield",
                        "latitude": "43.06057000",
                        "longitude": "-88.10648000"
                    },
                    {
                        "id": 112873,
                        "name": "Brooklyn",
                        "latitude": "42.85361000",
                        "longitude": "-89.37040000"
                    },
                    {
                        "id": 112902,
                        "name": "Brothertown",
                        "latitude": "43.96805000",
                        "longitude": "-88.30899000"
                    },
                    {
                        "id": 112914,
                        "name": "Brown County",
                        "latitude": "44.47433000",
                        "longitude": "-87.99287000"
                    },
                    {
                        "id": 112915,
                        "name": "Brown Deer",
                        "latitude": "43.16334000",
                        "longitude": "-87.96453000"
                    },
                    {
                        "id": 112920,
                        "name": "Browns Lake",
                        "latitude": "42.69252000",
                        "longitude": "-88.23120000"
                    },
                    {
                        "id": 112958,
                        "name": "Brussels",
                        "latitude": "44.73611000",
                        "longitude": "-87.62093000"
                    },
                    {
                        "id": 113020,
                        "name": "Buffalo County",
                        "latitude": "44.37983000",
                        "longitude": "-91.75447000"
                    },
                    {
                        "id": 113073,
                        "name": "Burlington",
                        "latitude": "42.67807000",
                        "longitude": "-88.27620000"
                    },
                    {
                        "id": 113080,
                        "name": "Burnett County",
                        "latitude": "45.86272000",
                        "longitude": "-92.36757000"
                    },
                    {
                        "id": 113112,
                        "name": "Butler",
                        "latitude": "43.10584000",
                        "longitude": "-88.06953000"
                    },
                    {
                        "id": 113166,
                        "name": "Cadott",
                        "latitude": "44.94802000",
                        "longitude": "-91.15070000"
                    },
                    {
                        "id": 113192,
                        "name": "Caledonia",
                        "latitude": "42.80780000",
                        "longitude": "-87.92425000"
                    },
                    {
                        "id": 113231,
                        "name": "Calumet County",
                        "latitude": "44.08160000",
                        "longitude": "-88.21806000"
                    },
                    {
                        "id": 113255,
                        "name": "Cambridge",
                        "latitude": "43.00361000",
                        "longitude": "-89.01650000"
                    },
                    {
                        "id": 113276,
                        "name": "Cameron",
                        "latitude": "45.40857000",
                        "longitude": "-91.74406000"
                    },
                    {
                        "id": 113288,
                        "name": "Camp Lake",
                        "latitude": "42.53474000",
                        "longitude": "-88.14370000"
                    },
                    {
                        "id": 113304,
                        "name": "Campbellsport",
                        "latitude": "43.59777000",
                        "longitude": "-88.27899000"
                    },
                    {
                        "id": 113523,
                        "name": "Cashton",
                        "latitude": "43.74191000",
                        "longitude": "-90.77930000"
                    },
                    {
                        "id": 113574,
                        "name": "Cato",
                        "latitude": "44.14277000",
                        "longitude": "-87.86120000"
                    },
                    {
                        "id": 113612,
                        "name": "Cedar Grove",
                        "latitude": "43.56972000",
                        "longitude": "-87.82342000"
                    },
                    {
                        "id": 113624,
                        "name": "Cedarburg",
                        "latitude": "43.29667000",
                        "longitude": "-87.98759000"
                    },
                    {
                        "id": 113915,
                        "name": "Chetek",
                        "latitude": "45.31413000",
                        "longitude": "-91.65100000"
                    },
                    {
                        "id": 113956,
                        "name": "Chilton",
                        "latitude": "44.02888000",
                        "longitude": "-88.16288000"
                    },
                    {
                        "id": 113975,
                        "name": "Chippewa County",
                        "latitude": "45.06940000",
                        "longitude": "-91.27989000"
                    },
                    {
                        "id": 113976,
                        "name": "Chippewa Falls",
                        "latitude": "44.93691000",
                        "longitude": "-91.39293000"
                    },
                    {
                        "id": 114128,
                        "name": "Clark County",
                        "latitude": "44.73471000",
                        "longitude": "-90.61208000"
                    },
                    {
                        "id": 114211,
                        "name": "Clear Lake",
                        "latitude": "45.25191000",
                        "longitude": "-92.27130000"
                    },
                    {
                        "id": 114247,
                        "name": "Cleveland",
                        "latitude": "43.91499000",
                        "longitude": "-87.74731000"
                    },
                    {
                        "id": 114286,
                        "name": "Clinton",
                        "latitude": "42.55779000",
                        "longitude": "-88.86511000"
                    },
                    {
                        "id": 114299,
                        "name": "Clintonville",
                        "latitude": "44.62053000",
                        "longitude": "-88.76232000"
                    },
                    {
                        "id": 114380,
                        "name": "Colby",
                        "latitude": "44.90997000",
                        "longitude": "-90.31569000"
                    },
                    {
                        "id": 114407,
                        "name": "Colfax",
                        "latitude": "44.99746000",
                        "longitude": "-91.72712000"
                    },
                    {
                        "id": 114482,
                        "name": "Columbia County",
                        "latitude": "43.46660000",
                        "longitude": "-89.33373000"
                    },
                    {
                        "id": 114497,
                        "name": "Columbus",
                        "latitude": "43.33805000",
                        "longitude": "-89.01539000"
                    },
                    {
                        "id": 114518,
                        "name": "Combined Locks",
                        "latitude": "44.26582000",
                        "longitude": "-88.31427000"
                    },
                    {
                        "id": 114528,
                        "name": "Como",
                        "latitude": "42.61224000",
                        "longitude": "-88.48232000"
                    },
                    {
                        "id": 114542,
                        "name": "Concord",
                        "latitude": "43.06945000",
                        "longitude": "-88.59871000"
                    },
                    {
                        "id": 114607,
                        "name": "Cooperstown",
                        "latitude": "44.31277000",
                        "longitude": "-87.77453000"
                    },
                    {
                        "id": 114649,
                        "name": "Cornell",
                        "latitude": "45.16719000",
                        "longitude": "-91.14931000"
                    },
                    {
                        "id": 114692,
                        "name": "Cottage Grove",
                        "latitude": "43.07611000",
                        "longitude": "-89.19956000"
                    },
                    {
                        "id": 114766,
                        "name": "Crandon",
                        "latitude": "45.57191000",
                        "longitude": "-88.90289000"
                    },
                    {
                        "id": 114783,
                        "name": "Crawford County",
                        "latitude": "43.23946000",
                        "longitude": "-90.93105000"
                    },
                    {
                        "id": 114853,
                        "name": "Cross Plains",
                        "latitude": "43.11444000",
                        "longitude": "-89.65568000"
                    },
                    {
                        "id": 114888,
                        "name": "Cuba City",
                        "latitude": "42.60555000",
                        "longitude": "-90.42985000"
                    },
                    {
                        "id": 114889,
                        "name": "Cudahy",
                        "latitude": "42.95974000",
                        "longitude": "-87.86147000"
                    },
                    {
                        "id": 114910,
                        "name": "Cumberland",
                        "latitude": "45.53218000",
                        "longitude": "-92.01935000"
                    },
                    {
                        "id": 114973,
                        "name": "Dakota",
                        "latitude": "43.99025000",
                        "longitude": "-89.35651000"
                    },
                    {
                        "id": 115019,
                        "name": "Dane",
                        "latitude": "43.25055000",
                        "longitude": "-89.50151000"
                    },
                    {
                        "id": 115020,
                        "name": "Dane County",
                        "latitude": "43.06735000",
                        "longitude": "-89.41832000"
                    },
                    {
                        "id": 115048,
                        "name": "Darien",
                        "latitude": "42.60168000",
                        "longitude": "-88.70760000"
                    },
                    {
                        "id": 115050,
                        "name": "Darlington",
                        "latitude": "42.68306000",
                        "longitude": "-90.11763000"
                    },
                    {
                        "id": 115105,
                        "name": "De Forest",
                        "latitude": "43.24777000",
                        "longitude": "-89.34373000"
                    },
                    {
                        "id": 115112,
                        "name": "De Pere",
                        "latitude": "44.44888000",
                        "longitude": "-88.06038000"
                    },
                    {
                        "id": 115158,
                        "name": "Decatur",
                        "latitude": "42.63433000",
                        "longitude": "-89.41155000"
                    },
                    {
                        "id": 115183,
                        "name": "Deerfield",
                        "latitude": "43.05194000",
                        "longitude": "-89.07567000"
                    },
                    {
                        "id": 115196,
                        "name": "Delafield",
                        "latitude": "43.06084000",
                        "longitude": "-88.40371000"
                    },
                    {
                        "id": 115201,
                        "name": "Delavan",
                        "latitude": "42.63307000",
                        "longitude": "-88.64371000"
                    },
                    {
                        "id": 115202,
                        "name": "Delavan Lake",
                        "latitude": "42.58418000",
                        "longitude": "-88.63260000"
                    },
                    {
                        "id": 115241,
                        "name": "Denmark",
                        "latitude": "44.34777000",
                        "longitude": "-87.82732000"
                    },
                    {
                        "id": 115324,
                        "name": "Dickeyville",
                        "latitude": "42.62722000",
                        "longitude": "-90.59207000"
                    },
                    {
                        "id": 115380,
                        "name": "Dodge County",
                        "latitude": "43.41630000",
                        "longitude": "-88.70752000"
                    },
                    {
                        "id": 115381,
                        "name": "Dodgeville",
                        "latitude": "42.96027000",
                        "longitude": "-90.13012000"
                    },
                    {
                        "id": 115406,
                        "name": "Door County",
                        "latitude": "44.83834000",
                        "longitude": "-87.35779000"
                    },
                    {
                        "id": 115432,
                        "name": "Douglas County",
                        "latitude": "46.46411000",
                        "longitude": "-91.89940000"
                    },
                    {
                        "id": 115441,
                        "name": "Dousman",
                        "latitude": "43.01418000",
                        "longitude": "-88.47260000"
                    },
                    {
                        "id": 115547,
                        "name": "Dunn County",
                        "latitude": "44.94659000",
                        "longitude": "-91.89641000"
                    },
                    {
                        "id": 115564,
                        "name": "Durand",
                        "latitude": "44.62635000",
                        "longitude": "-91.96573000"
                    },
                    {
                        "id": 115596,
                        "name": "Eagle",
                        "latitude": "42.87946000",
                        "longitude": "-88.47427000"
                    },
                    {
                        "id": 115605,
                        "name": "Eagle Lake",
                        "latitude": "42.70696000",
                        "longitude": "-88.12814000"
                    },
                    {
                        "id": 115611,
                        "name": "Eagle River",
                        "latitude": "45.91718000",
                        "longitude": "-89.24430000"
                    },
                    {
                        "id": 115766,
                        "name": "East Troy",
                        "latitude": "42.78529000",
                        "longitude": "-88.40510000"
                    },
                    {
                        "id": 115790,
                        "name": "Easton",
                        "latitude": "43.83803000",
                        "longitude": "-89.80679000"
                    },
                    {
                        "id": 115810,
                        "name": "Eau Claire",
                        "latitude": "44.81135000",
                        "longitude": "-91.49849000"
                    },
                    {
                        "id": 115811,
                        "name": "Eau Claire County",
                        "latitude": "44.72677000",
                        "longitude": "-91.28600000"
                    },
                    {
                        "id": 115835,
                        "name": "Edgar",
                        "latitude": "44.92719000",
                        "longitude": "-89.96346000"
                    },
                    {
                        "id": 115850,
                        "name": "Edgerton",
                        "latitude": "42.83528000",
                        "longitude": "-89.06761000"
                    },
                    {
                        "id": 115953,
                        "name": "Eldorado",
                        "latitude": "43.82471000",
                        "longitude": "-88.62178000"
                    },
                    {
                        "id": 116002,
                        "name": "Elkhorn",
                        "latitude": "42.67279000",
                        "longitude": "-88.54454000"
                    },
                    {
                        "id": 116039,
                        "name": "Ellsworth",
                        "latitude": "44.73219000",
                        "longitude": "-92.48741000"
                    },
                    {
                        "id": 116044,
                        "name": "Elm Grove",
                        "latitude": "43.04307000",
                        "longitude": "-88.07898000"
                    },
                    {
                        "id": 116067,
                        "name": "Elroy",
                        "latitude": "43.74080000",
                        "longitude": "-90.27235000"
                    },
                    {
                        "id": 116254,
                        "name": "Evansville",
                        "latitude": "42.78028000",
                        "longitude": "-89.29928000"
                    },
                    {
                        "id": 116262,
                        "name": "Evergreen",
                        "latitude": "44.84247000",
                        "longitude": "-89.63762000"
                    },
                    {
                        "id": 116372,
                        "name": "Fall Creek",
                        "latitude": "44.76357000",
                        "longitude": "-91.27710000"
                    },
                    {
                        "id": 116374,
                        "name": "Fall River",
                        "latitude": "43.38443000",
                        "longitude": "-89.04511000"
                    },
                    {
                        "id": 116472,
                        "name": "Fennimore",
                        "latitude": "42.98360000",
                        "longitude": "-90.65540000"
                    },
                    {
                        "id": 116535,
                        "name": "Fitchburg",
                        "latitude": "42.96083000",
                        "longitude": "-89.46984000"
                    },
                    {
                        "id": 116584,
                        "name": "Florence",
                        "latitude": "45.92218000",
                        "longitude": "-88.25180000"
                    },
                    {
                        "id": 116588,
                        "name": "Florence County",
                        "latitude": "45.84845000",
                        "longitude": "-88.39816000"
                    },
                    {
                        "id": 116627,
                        "name": "Fond du Lac",
                        "latitude": "43.77500000",
                        "longitude": "-88.43883000"
                    },
                    {
                        "id": 116628,
                        "name": "Fond du Lac County",
                        "latitude": "43.75359000",
                        "longitude": "-88.48826000"
                    },
                    {
                        "id": 116630,
                        "name": "Fontana",
                        "latitude": "42.55141000",
                        "longitude": "-88.57510000"
                    },
                    {
                        "id": 116651,
                        "name": "Forest County",
                        "latitude": "45.66726000",
                        "longitude": "-88.77038000"
                    },
                    {
                        "id": 116689,
                        "name": "Fort Atkinson",
                        "latitude": "42.92889000",
                        "longitude": "-88.83705000"
                    },
                    {
                        "id": 116804,
                        "name": "Fox Lake",
                        "latitude": "43.56554000",
                        "longitude": "-88.90650000"
                    },
                    {
                        "id": 116806,
                        "name": "Fox Point",
                        "latitude": "43.15751000",
                        "longitude": "-87.90175000"
                    },
                    {
                        "id": 116841,
                        "name": "Franklin",
                        "latitude": "42.88863000",
                        "longitude": "-88.03842000"
                    },
                    {
                        "id": 116878,
                        "name": "Franksville",
                        "latitude": "42.76002000",
                        "longitude": "-87.91341000"
                    },
                    {
                        "id": 116884,
                        "name": "Frederic",
                        "latitude": "45.65912000",
                        "longitude": "-92.46714000"
                    },
                    {
                        "id": 116897,
                        "name": "Fredonia",
                        "latitude": "43.47056000",
                        "longitude": "-87.95065000"
                    },
                    {
                        "id": 116930,
                        "name": "French Island",
                        "latitude": "43.85830000",
                        "longitude": "-91.26042000"
                    },
                    {
                        "id": 116950,
                        "name": "Friendship",
                        "latitude": "43.97053000",
                        "longitude": "-89.81679000"
                    },
                    {
                        "id": 117029,
                        "name": "Galesville",
                        "latitude": "44.08163000",
                        "longitude": "-91.34904000"
                    },
                    {
                        "id": 117148,
                        "name": "Genoa City",
                        "latitude": "42.49835000",
                        "longitude": "-88.32815000"
                    },
                    {
                        "id": 117174,
                        "name": "Germantown",
                        "latitude": "43.22862000",
                        "longitude": "-88.11037000"
                    },
                    {
                        "id": 117216,
                        "name": "Gillett",
                        "latitude": "44.88999000",
                        "longitude": "-88.30732000"
                    },
                    {
                        "id": 117284,
                        "name": "Glendale",
                        "latitude": "43.13529000",
                        "longitude": "-87.93564000"
                    },
                    {
                        "id": 117295,
                        "name": "Glenmore",
                        "latitude": "44.38583000",
                        "longitude": "-87.92732000"
                    },
                    {
                        "id": 117316,
                        "name": "Glenwood City",
                        "latitude": "45.05857000",
                        "longitude": "-92.17241000"
                    },
                    {
                        "id": 117432,
                        "name": "Grafton",
                        "latitude": "43.31973000",
                        "longitude": "-87.95342000"
                    },
                    {
                        "id": 117515,
                        "name": "Grant County",
                        "latitude": "42.86749000",
                        "longitude": "-90.70622000"
                    },
                    {
                        "id": 117529,
                        "name": "Grantsburg",
                        "latitude": "45.77634000",
                        "longitude": "-92.68270000"
                    },
                    {
                        "id": 117591,
                        "name": "Green Bay",
                        "latitude": "44.51916000",
                        "longitude": "-88.01983000"
                    },
                    {
                        "id": 117593,
                        "name": "Green County",
                        "latitude": "42.67999000",
                        "longitude": "-89.60221000"
                    },
                    {
                        "id": 117601,
                        "name": "Green Lake",
                        "latitude": "43.84415000",
                        "longitude": "-88.96011000"
                    },
                    {
                        "id": 117602,
                        "name": "Green Lake County",
                        "latitude": "43.80038000",
                        "longitude": "-89.04486000"
                    },
                    {
                        "id": 117627,
                        "name": "Greendale",
                        "latitude": "42.94057000",
                        "longitude": "-87.99592000"
                    },
                    {
                        "id": 117653,
                        "name": "Greenfield",
                        "latitude": "42.96140000",
                        "longitude": "-88.01259000"
                    },
                    {
                        "id": 117708,
                        "name": "Greenwood",
                        "latitude": "44.77024000",
                        "longitude": "-90.59931000"
                    },
                    {
                        "id": 117851,
                        "name": "Hales Corners",
                        "latitude": "42.93751000",
                        "longitude": "-88.04870000"
                    },
                    {
                        "id": 117914,
                        "name": "Hammond",
                        "latitude": "44.97886000",
                        "longitude": "-92.43575000"
                    },
                    {
                        "id": 118061,
                        "name": "Harrison",
                        "latitude": "44.22776000",
                        "longitude": "-88.33591000"
                    },
                    {
                        "id": 118091,
                        "name": "Hartford",
                        "latitude": "43.31778000",
                        "longitude": "-88.37899000"
                    },
                    {
                        "id": 118097,
                        "name": "Hartland",
                        "latitude": "43.10501000",
                        "longitude": "-88.34204000"
                    },
                    {
                        "id": 118196,
                        "name": "Hayward",
                        "latitude": "46.01301000",
                        "longitude": "-91.48462000"
                    },
                    {
                        "id": 118205,
                        "name": "Hazel Green",
                        "latitude": "42.53278000",
                        "longitude": "-90.43457000"
                    },
                    {
                        "id": 118428,
                        "name": "Hilbert",
                        "latitude": "44.14027000",
                        "longitude": "-88.16399000"
                    },
                    {
                        "id": 118451,
                        "name": "Hillsboro",
                        "latitude": "43.65220000",
                        "longitude": "-90.34402000"
                    },
                    {
                        "id": 118499,
                        "name": "Hobart",
                        "latitude": "44.49925000",
                        "longitude": "-88.14986000"
                    },
                    {
                        "id": 118569,
                        "name": "Holmen",
                        "latitude": "43.96330000",
                        "longitude": "-91.25625000"
                    },
                    {
                        "id": 118663,
                        "name": "Horicon",
                        "latitude": "43.45138000",
                        "longitude": "-88.63121000"
                    },
                    {
                        "id": 118679,
                        "name": "Hortonville",
                        "latitude": "44.33470000",
                        "longitude": "-88.63816000"
                    },
                    {
                        "id": 118708,
                        "name": "Howard",
                        "latitude": "44.54360000",
                        "longitude": "-88.08816000"
                    },
                    {
                        "id": 118720,
                        "name": "Howards Grove",
                        "latitude": "43.83388000",
                        "longitude": "-87.82009000"
                    },
                    {
                        "id": 118746,
                        "name": "Hudson",
                        "latitude": "44.97469000",
                        "longitude": "-92.75687000"
                    },
                    {
                        "id": 118821,
                        "name": "Hurley",
                        "latitude": "46.44967000",
                        "longitude": "-90.18656000"
                    },
                    {
                        "id": 118833,
                        "name": "Hustisford",
                        "latitude": "43.34611000",
                        "longitude": "-88.60066000"
                    },
                    {
                        "id": 118896,
                        "name": "Independence",
                        "latitude": "44.35691000",
                        "longitude": "-91.42043000"
                    },
                    {
                        "id": 118967,
                        "name": "Iola",
                        "latitude": "44.50803000",
                        "longitude": "-89.13067000"
                    },
                    {
                        "id": 118979,
                        "name": "Iowa County",
                        "latitude": "43.00048000",
                        "longitude": "-90.13543000"
                    },
                    {
                        "id": 118990,
                        "name": "Iron County",
                        "latitude": "46.31706000",
                        "longitude": "-90.26445000"
                    },
                    {
                        "id": 119053,
                        "name": "Ixonia",
                        "latitude": "43.14389000",
                        "longitude": "-88.59732000"
                    },
                    {
                        "id": 119072,
                        "name": "Jackson",
                        "latitude": "43.32389000",
                        "longitude": "-88.16676000"
                    },
                    {
                        "id": 119093,
                        "name": "Jackson County",
                        "latitude": "44.31913000",
                        "longitude": "-90.80518000"
                    },
                    {
                        "id": 119131,
                        "name": "Janesville",
                        "latitude": "42.68279000",
                        "longitude": "-89.01872000"
                    },
                    {
                        "id": 119171,
                        "name": "Jefferson",
                        "latitude": "43.00556000",
                        "longitude": "-88.80733000"
                    },
                    {
                        "id": 119193,
                        "name": "Jefferson County",
                        "latitude": "43.02082000",
                        "longitude": "-88.77587000"
                    },
                    {
                        "id": 119272,
                        "name": "Johnson Creek",
                        "latitude": "43.07611000",
                        "longitude": "-88.77427000"
                    },
                    {
                        "id": 119337,
                        "name": "Juneau",
                        "latitude": "43.40555000",
                        "longitude": "-88.70510000"
                    },
                    {
                        "id": 119339,
                        "name": "Juneau County",
                        "latitude": "43.92444000",
                        "longitude": "-90.11402000"
                    },
                    {
                        "id": 119399,
                        "name": "Kaukauna",
                        "latitude": "44.27804000",
                        "longitude": "-88.27205000"
                    },
                    {
                        "id": 119476,
                        "name": "Kenosha",
                        "latitude": "42.58474000",
                        "longitude": "-87.82119000"
                    },
                    {
                        "id": 119477,
                        "name": "Kenosha County",
                        "latitude": "42.57280000",
                        "longitude": "-87.83981000"
                    },
                    {
                        "id": 119522,
                        "name": "Keshena",
                        "latitude": "44.88387000",
                        "longitude": "-88.63372000"
                    },
                    {
                        "id": 119533,
                        "name": "Kewaskum",
                        "latitude": "43.52083000",
                        "longitude": "-88.22899000"
                    },
                    {
                        "id": 119534,
                        "name": "Kewaunee",
                        "latitude": "44.45833000",
                        "longitude": "-87.50314000"
                    },
                    {
                        "id": 119535,
                        "name": "Kewaunee County",
                        "latitude": "44.48279000",
                        "longitude": "-87.51434000"
                    },
                    {
                        "id": 119554,
                        "name": "Kiel",
                        "latitude": "43.91249000",
                        "longitude": "-88.03565000"
                    },
                    {
                        "id": 119570,
                        "name": "Kimberly",
                        "latitude": "44.27221000",
                        "longitude": "-88.33900000"
                    },
                    {
                        "id": 119577,
                        "name": "King",
                        "latitude": "44.33748000",
                        "longitude": "-89.14178000"
                    },
                    {
                        "id": 119701,
                        "name": "Kohler",
                        "latitude": "43.73916000",
                        "longitude": "-87.78175000"
                    },
                    {
                        "id": 119717,
                        "name": "Kronenwetter",
                        "latitude": "44.82219000",
                        "longitude": "-89.59040000"
                    },
                    {
                        "id": 119744,
                        "name": "La Crosse",
                        "latitude": "43.80136000",
                        "longitude": "-91.23958000"
                    },
                    {
                        "id": 119745,
                        "name": "La Crosse County",
                        "latitude": "43.90653000",
                        "longitude": "-91.11522000"
                    },
                    {
                        "id": 119810,
                        "name": "Lac du Flambeau",
                        "latitude": "45.96967000",
                        "longitude": "-89.89210000"
                    },
                    {
                        "id": 119830,
                        "name": "Ladysmith",
                        "latitude": "45.46302000",
                        "longitude": "-91.10404000"
                    },
                    {
                        "id": 119842,
                        "name": "Lafayette County",
                        "latitude": "42.66050000",
                        "longitude": "-90.13172000"
                    },
                    {
                        "id": 119903,
                        "name": "Lake Delton",
                        "latitude": "43.60109000",
                        "longitude": "-89.79374000"
                    },
                    {
                        "id": 119913,
                        "name": "Lake Geneva",
                        "latitude": "42.59168000",
                        "longitude": "-88.43343000"
                    },
                    {
                        "id": 119915,
                        "name": "Lake Hallie",
                        "latitude": "44.87579000",
                        "longitude": "-91.44071000"
                    },
                    {
                        "id": 119928,
                        "name": "Lake Koshkonong",
                        "latitude": "42.90973000",
                        "longitude": "-88.91955000"
                    },
                    {
                        "id": 119943,
                        "name": "Lake Mills",
                        "latitude": "43.08139000",
                        "longitude": "-88.91177000"
                    },
                    {
                        "id": 119951,
                        "name": "Lake Nebagamon",
                        "latitude": "46.51494000",
                        "longitude": "-91.69991000"
                    },
                    {
                        "id": 119969,
                        "name": "Lake Ripley",
                        "latitude": "43.00583000",
                        "longitude": "-88.98622000"
                    },
                    {
                        "id": 119992,
                        "name": "Lake Wazeecha",
                        "latitude": "44.37108000",
                        "longitude": "-89.75651000"
                    },
                    {
                        "id": 119995,
                        "name": "Lake Wisconsin",
                        "latitude": "43.37360000",
                        "longitude": "-89.57568000"
                    },
                    {
                        "id": 119996,
                        "name": "Lake Wissota",
                        "latitude": "44.92635000",
                        "longitude": "-91.30099000"
                    },
                    {
                        "id": 120065,
                        "name": "Lamartine",
                        "latitude": "43.73332000",
                        "longitude": "-88.56872000"
                    },
                    {
                        "id": 120088,
                        "name": "Lancaster",
                        "latitude": "42.84749000",
                        "longitude": "-90.71068000"
                    },
                    {
                        "id": 120112,
                        "name": "Langlade County",
                        "latitude": "45.26236000",
                        "longitude": "-89.07191000"
                    },
                    {
                        "id": 120120,
                        "name": "Lannon",
                        "latitude": "43.14612000",
                        "longitude": "-88.16620000"
                    },
                    {
                        "id": 120332,
                        "name": "Legend Lake",
                        "latitude": "44.89095000",
                        "longitude": "-88.54406000"
                    },
                    {
                        "id": 120529,
                        "name": "Lincoln County",
                        "latitude": "45.33746000",
                        "longitude": "-89.73461000"
                    },
                    {
                        "id": 120614,
                        "name": "Little Chute",
                        "latitude": "44.27999000",
                        "longitude": "-88.31844000"
                    },
                    {
                        "id": 120629,
                        "name": "Little Round Lake",
                        "latitude": "45.96495000",
                        "longitude": "-91.36795000"
                    },
                    {
                        "id": 120690,
                        "name": "Lodi",
                        "latitude": "43.31388000",
                        "longitude": "-89.52651000"
                    },
                    {
                        "id": 120715,
                        "name": "Lomira",
                        "latitude": "43.59138000",
                        "longitude": "-88.44371000"
                    },
                    {
                        "id": 120853,
                        "name": "Loyal",
                        "latitude": "44.73691000",
                        "longitude": "-90.49597000"
                    },
                    {
                        "id": 120867,
                        "name": "Luck",
                        "latitude": "45.57607000",
                        "longitude": "-92.48270000"
                    },
                    {
                        "id": 120901,
                        "name": "Luxemburg",
                        "latitude": "44.53861000",
                        "longitude": "-87.70398000"
                    },
                    {
                        "id": 120999,
                        "name": "Madison",
                        "latitude": "43.07305000",
                        "longitude": "-89.40123000"
                    },
                    {
                        "id": 121050,
                        "name": "Maine",
                        "latitude": "45.02716000",
                        "longitude": "-89.69039000"
                    },
                    {
                        "id": 121086,
                        "name": "Manawa",
                        "latitude": "44.46443000",
                        "longitude": "-88.91983000"
                    },
                    {
                        "id": 121101,
                        "name": "Manchester",
                        "latitude": "43.69054000",
                        "longitude": "-89.04845000"
                    },
                    {
                        "id": 121127,
                        "name": "Manitowoc",
                        "latitude": "44.08861000",
                        "longitude": "-87.65758000"
                    },
                    {
                        "id": 121128,
                        "name": "Manitowoc County",
                        "latitude": "44.09054000",
                        "longitude": "-87.69974000"
                    },
                    {
                        "id": 121165,
                        "name": "Maple Bluff",
                        "latitude": "43.11833000",
                        "longitude": "-89.37956000"
                    },
                    {
                        "id": 121185,
                        "name": "Marathon",
                        "latitude": "44.92913000",
                        "longitude": "-89.84040000"
                    },
                    {
                        "id": 121186,
                        "name": "Marathon County",
                        "latitude": "44.89829000",
                        "longitude": "-89.75906000"
                    },
                    {
                        "id": 121228,
                        "name": "Marinette",
                        "latitude": "45.09998000",
                        "longitude": "-87.63066000"
                    },
                    {
                        "id": 121229,
                        "name": "Marinette County",
                        "latitude": "45.35090000",
                        "longitude": "-88.00222000"
                    },
                    {
                        "id": 121245,
                        "name": "Marion",
                        "latitude": "44.67081000",
                        "longitude": "-88.88927000"
                    },
                    {
                        "id": 121268,
                        "name": "Markesan",
                        "latitude": "43.70720000",
                        "longitude": "-88.99011000"
                    },
                    {
                        "id": 121294,
                        "name": "Marquette County",
                        "latitude": "43.81958000",
                        "longitude": "-89.39875000"
                    },
                    {
                        "id": 121309,
                        "name": "Marshall",
                        "latitude": "43.16833000",
                        "longitude": "-89.06678000"
                    },
                    {
                        "id": 121327,
                        "name": "Marshfield",
                        "latitude": "44.66885000",
                        "longitude": "-90.17180000"
                    },
                    {
                        "id": 121427,
                        "name": "Mauston",
                        "latitude": "43.79719000",
                        "longitude": "-90.07735000"
                    },
                    {
                        "id": 121456,
                        "name": "Mayville",
                        "latitude": "43.49416000",
                        "longitude": "-88.54482000"
                    },
                    {
                        "id": 121460,
                        "name": "Mazomanie",
                        "latitude": "43.17666000",
                        "longitude": "-89.79485000"
                    },
                    {
                        "id": 121499,
                        "name": "McFarland",
                        "latitude": "43.01250000",
                        "longitude": "-89.28984000"
                    },
                    {
                        "id": 121595,
                        "name": "Medford",
                        "latitude": "45.13858000",
                        "longitude": "-90.34014000"
                    },
                    {
                        "id": 121649,
                        "name": "Menasha",
                        "latitude": "44.20221000",
                        "longitude": "-88.44650000"
                    },
                    {
                        "id": 121664,
                        "name": "Menominee County",
                        "latitude": "45.00437000",
                        "longitude": "-88.71001000"
                    },
                    {
                        "id": 121665,
                        "name": "Menomonee Falls",
                        "latitude": "43.17890000",
                        "longitude": "-88.11731000"
                    },
                    {
                        "id": 121666,
                        "name": "Menomonie",
                        "latitude": "44.87552000",
                        "longitude": "-91.91934000"
                    },
                    {
                        "id": 121669,
                        "name": "Mequon",
                        "latitude": "43.21555000",
                        "longitude": "-88.03001000"
                    },
                    {
                        "id": 121707,
                        "name": "Merrill",
                        "latitude": "45.18052000",
                        "longitude": "-89.68346000"
                    },
                    {
                        "id": 121718,
                        "name": "Merton",
                        "latitude": "43.14667000",
                        "longitude": "-88.30676000"
                    },
                    {
                        "id": 121783,
                        "name": "Middleton",
                        "latitude": "43.09722000",
                        "longitude": "-89.50429000"
                    },
                    {
                        "id": 121858,
                        "name": "Milford",
                        "latitude": "43.10083000",
                        "longitude": "-88.84677000"
                    },
                    {
                        "id": 121918,
                        "name": "Milton",
                        "latitude": "42.77556000",
                        "longitude": "-88.94400000"
                    },
                    {
                        "id": 121923,
                        "name": "Milwaukee",
                        "latitude": "43.03890000",
                        "longitude": "-87.90647000"
                    },
                    {
                        "id": 121924,
                        "name": "Milwaukee County",
                        "latitude": "43.02172000",
                        "longitude": "-87.92908000"
                    },
                    {
                        "id": 121938,
                        "name": "Mineral Point",
                        "latitude": "42.86000000",
                        "longitude": "-90.17985000"
                    },
                    {
                        "id": 121977,
                        "name": "Mishicot",
                        "latitude": "44.23916000",
                        "longitude": "-87.64119000"
                    },
                    {
                        "id": 122036,
                        "name": "Mondovi",
                        "latitude": "44.56774000",
                        "longitude": "-91.67099000"
                    },
                    {
                        "id": 122052,
                        "name": "Monona",
                        "latitude": "43.06222000",
                        "longitude": "-89.33401000"
                    },
                    {
                        "id": 122063,
                        "name": "Monroe",
                        "latitude": "42.60112000",
                        "longitude": "-89.63845000"
                    },
                    {
                        "id": 122082,
                        "name": "Monroe County",
                        "latitude": "43.94575000",
                        "longitude": "-90.61787000"
                    },
                    {
                        "id": 122117,
                        "name": "Montello",
                        "latitude": "43.79137000",
                        "longitude": "-89.31984000"
                    },
                    {
                        "id": 122170,
                        "name": "Monticello",
                        "latitude": "42.74556000",
                        "longitude": "-89.59484000"
                    },
                    {
                        "id": 122305,
                        "name": "Mosinee",
                        "latitude": "44.79302000",
                        "longitude": "-89.70318000"
                    },
                    {
                        "id": 122354,
                        "name": "Mount Horeb",
                        "latitude": "43.00861000",
                        "longitude": "-89.73846000"
                    },
                    {
                        "id": 122366,
                        "name": "Mount Morris",
                        "latitude": "44.11442000",
                        "longitude": "-89.19067000"
                    },
                    {
                        "id": 122382,
                        "name": "Mount Pleasant",
                        "latitude": "42.69743000",
                        "longitude": "-87.85577000"
                    },
                    {
                        "id": 122451,
                        "name": "Mukwonago",
                        "latitude": "42.86668000",
                        "longitude": "-88.33343000"
                    },
                    {
                        "id": 122504,
                        "name": "Muscoda",
                        "latitude": "43.18499000",
                        "longitude": "-90.44318000"
                    },
                    {
                        "id": 122508,
                        "name": "Muskego",
                        "latitude": "42.90585000",
                        "longitude": "-88.13898000"
                    },
                    {
                        "id": 122569,
                        "name": "Nashotah",
                        "latitude": "43.09779000",
                        "longitude": "-88.40232000"
                    },
                    {
                        "id": 122579,
                        "name": "Nashville",
                        "latitude": "45.52274000",
                        "longitude": "-89.02484000"
                    },
                    {
                        "id": 122616,
                        "name": "Neenah",
                        "latitude": "44.18582000",
                        "longitude": "-88.46261000"
                    },
                    {
                        "id": 122618,
                        "name": "Neillsville",
                        "latitude": "44.55996000",
                        "longitude": "-90.59625000"
                    },
                    {
                        "id": 122619,
                        "name": "Nekoosa",
                        "latitude": "44.31246000",
                        "longitude": "-89.90429000"
                    },
                    {
                        "id": 122664,
                        "name": "New Berlin",
                        "latitude": "42.97640000",
                        "longitude": "-88.10842000"
                    },
                    {
                        "id": 122708,
                        "name": "New Glarus",
                        "latitude": "42.81445000",
                        "longitude": "-89.63512000"
                    },
                    {
                        "id": 122722,
                        "name": "New Holstein",
                        "latitude": "43.94999000",
                        "longitude": "-88.08426000"
                    },
                    {
                        "id": 122738,
                        "name": "New Lisbon",
                        "latitude": "43.87914000",
                        "longitude": "-90.16541000"
                    },
                    {
                        "id": 122745,
                        "name": "New London",
                        "latitude": "44.39276000",
                        "longitude": "-88.73983000"
                    },
                    {
                        "id": 122770,
                        "name": "New Richmond",
                        "latitude": "45.12302000",
                        "longitude": "-92.53659000"
                    },
                    {
                        "id": 122815,
                        "name": "Newburg",
                        "latitude": "43.43167000",
                        "longitude": "-88.04648000"
                    },
                    {
                        "id": 122880,
                        "name": "Niagara",
                        "latitude": "45.77135000",
                        "longitude": "-87.99485000"
                    },
                    {
                        "id": 123026,
                        "name": "North Fond du Lac",
                        "latitude": "43.81138000",
                        "longitude": "-88.48344000"
                    },
                    {
                        "id": 123043,
                        "name": "North Hudson",
                        "latitude": "44.99302000",
                        "longitude": "-92.75687000"
                    },
                    {
                        "id": 123049,
                        "name": "North La Crosse",
                        "latitude": "43.84635000",
                        "longitude": "-91.24819000"
                    },
                    {
                        "id": 123088,
                        "name": "North Prairie",
                        "latitude": "42.93446000",
                        "longitude": "-88.40537000"
                    },
                    {
                        "id": 123232,
                        "name": "Oak Creek",
                        "latitude": "42.88585000",
                        "longitude": "-87.86314000"
                    },
                    {
                        "id": 123277,
                        "name": "Oakfield",
                        "latitude": "43.68610000",
                        "longitude": "-88.54650000"
                    },
                    {
                        "id": 123350,
                        "name": "Oconomowoc",
                        "latitude": "43.11167000",
                        "longitude": "-88.49927000"
                    },
                    {
                        "id": 123351,
                        "name": "Oconto",
                        "latitude": "44.88721000",
                        "longitude": "-87.86455000"
                    },
                    {
                        "id": 123352,
                        "name": "Oconto County",
                        "latitude": "44.99851000",
                        "longitude": "-88.22056000"
                    },
                    {
                        "id": 123353,
                        "name": "Oconto Falls",
                        "latitude": "44.87388000",
                        "longitude": "-88.14288000"
                    },
                    {
                        "id": 123396,
                        "name": "Okauchee Lake",
                        "latitude": "43.12334000",
                        "longitude": "-88.44065000"
                    },
                    {
                        "id": 123466,
                        "name": "Omro",
                        "latitude": "44.03943000",
                        "longitude": "-88.74428000"
                    },
                    {
                        "id": 123468,
                        "name": "Onalaska",
                        "latitude": "43.88441000",
                        "longitude": "-91.23514000"
                    },
                    {
                        "id": 123474,
                        "name": "Oneida",
                        "latitude": "44.49860000",
                        "longitude": "-88.18288000"
                    },
                    {
                        "id": 123476,
                        "name": "Oneida County",
                        "latitude": "45.70559000",
                        "longitude": "-89.52171000"
                    },
                    {
                        "id": 123493,
                        "name": "Oostburg",
                        "latitude": "43.62277000",
                        "longitude": "-87.79453000"
                    },
                    {
                        "id": 123547,
                        "name": "Oregon",
                        "latitude": "42.92611000",
                        "longitude": "-89.38456000"
                    },
                    {
                        "id": 123553,
                        "name": "Orfordville",
                        "latitude": "42.62751000",
                        "longitude": "-89.25317000"
                    },
                    {
                        "id": 123602,
                        "name": "Osceola",
                        "latitude": "45.32052000",
                        "longitude": "-92.70493000"
                    },
                    {
                        "id": 123609,
                        "name": "Oshkosh",
                        "latitude": "44.02471000",
                        "longitude": "-88.54261000"
                    },
                    {
                        "id": 123615,
                        "name": "Osseo",
                        "latitude": "44.57218000",
                        "longitude": "-91.22738000"
                    },
                    {
                        "id": 123648,
                        "name": "Outagamie County",
                        "latitude": "44.41609000",
                        "longitude": "-88.46493000"
                    },
                    {
                        "id": 123700,
                        "name": "Ozaukee County",
                        "latitude": "43.40305000",
                        "longitude": "-87.89063000"
                    },
                    {
                        "id": 123713,
                        "name": "Paddock Lake",
                        "latitude": "42.57752000",
                        "longitude": "-88.10509000"
                    },
                    {
                        "id": 123778,
                        "name": "Palmyra",
                        "latitude": "42.87779000",
                        "longitude": "-88.58621000"
                    },
                    {
                        "id": 123828,
                        "name": "Pardeeville",
                        "latitude": "43.53776000",
                        "longitude": "-89.30012000"
                    },
                    {
                        "id": 123844,
                        "name": "Park Falls",
                        "latitude": "45.93440000",
                        "longitude": "-90.44155000"
                    },
                    {
                        "id": 123998,
                        "name": "Pell Lake",
                        "latitude": "42.53807000",
                        "longitude": "-88.35093000"
                    },
                    {
                        "id": 124053,
                        "name": "Pepin County",
                        "latitude": "44.48265000",
                        "longitude": "-92.14969000"
                    },
                    {
                        "id": 124099,
                        "name": "Peshtigo",
                        "latitude": "45.05443000",
                        "longitude": "-87.74927000"
                    },
                    {
                        "id": 124115,
                        "name": "Pewaukee",
                        "latitude": "43.08057000",
                        "longitude": "-88.26120000"
                    },
                    {
                        "id": 124134,
                        "name": "Phillips",
                        "latitude": "45.69663000",
                        "longitude": "-90.40043000"
                    },
                    {
                        "id": 124173,
                        "name": "Pierce County",
                        "latitude": "44.71963000",
                        "longitude": "-92.42249000"
                    },
                    {
                        "id": 124301,
                        "name": "Pittsfield",
                        "latitude": "44.59944000",
                        "longitude": "-88.24510000"
                    },
                    {
                        "id": 124357,
                        "name": "Platteville",
                        "latitude": "42.73416000",
                        "longitude": "-90.47846000"
                    },
                    {
                        "id": 124375,
                        "name": "Pleasant Prairie",
                        "latitude": "42.55308000",
                        "longitude": "-87.93341000"
                    },
                    {
                        "id": 124391,
                        "name": "Plover",
                        "latitude": "44.45636000",
                        "longitude": "-89.54401000"
                    },
                    {
                        "id": 124408,
                        "name": "Plymouth",
                        "latitude": "43.74861000",
                        "longitude": "-87.97704000"
                    },
                    {
                        "id": 124450,
                        "name": "Polk County",
                        "latitude": "45.46142000",
                        "longitude": "-92.44139000"
                    },
                    {
                        "id": 124505,
                        "name": "Port Edwards",
                        "latitude": "44.35080000",
                        "longitude": "-89.86540000"
                    },
                    {
                        "id": 124540,
                        "name": "Port Washington",
                        "latitude": "43.38722000",
                        "longitude": "-87.87564000"
                    },
                    {
                        "id": 124546,
                        "name": "Portage",
                        "latitude": "43.53915000",
                        "longitude": "-89.46262000"
                    },
                    {
                        "id": 124547,
                        "name": "Portage County",
                        "latitude": "44.47604000",
                        "longitude": "-89.50142000"
                    },
                    {
                        "id": 124564,
                        "name": "Portland",
                        "latitude": "43.76886000",
                        "longitude": "-90.85819000"
                    },
                    {
                        "id": 124595,
                        "name": "Potter Lake",
                        "latitude": "42.82168000",
                        "longitude": "-88.34898000"
                    },
                    {
                        "id": 124616,
                        "name": "Powers Lake",
                        "latitude": "42.55363000",
                        "longitude": "-88.29454000"
                    },
                    {
                        "id": 124621,
                        "name": "Poynette",
                        "latitude": "43.39026000",
                        "longitude": "-89.40290000"
                    },
                    {
                        "id": 124633,
                        "name": "Prairie du Chien",
                        "latitude": "43.05165000",
                        "longitude": "-91.14124000"
                    },
                    {
                        "id": 124634,
                        "name": "Prairie du Sac",
                        "latitude": "43.28693000",
                        "longitude": "-89.72401000"
                    },
                    {
                        "id": 124644,
                        "name": "Prescott",
                        "latitude": "44.74886000",
                        "longitude": "-92.80215000"
                    },
                    {
                        "id": 124664,
                        "name": "Price County",
                        "latitude": "45.68038000",
                        "longitude": "-90.36137000"
                    },
                    {
                        "id": 124691,
                        "name": "Princeton",
                        "latitude": "43.85081000",
                        "longitude": "-89.12178000"
                    },
                    {
                        "id": 124736,
                        "name": "Pulaski",
                        "latitude": "44.67222000",
                        "longitude": "-88.24260000"
                    },
                    {
                        "id": 124813,
                        "name": "Racine",
                        "latitude": "42.72613000",
                        "longitude": "-87.78285000"
                    },
                    {
                        "id": 124814,
                        "name": "Racine County",
                        "latitude": "42.72987000",
                        "longitude": "-87.81235000"
                    },
                    {
                        "id": 124869,
                        "name": "Randolph",
                        "latitude": "43.53915000",
                        "longitude": "-89.00678000"
                    },
                    {
                        "id": 124880,
                        "name": "Random Lake",
                        "latitude": "43.55222000",
                        "longitude": "-87.96176000"
                    },
                    {
                        "id": 124970,
                        "name": "Redgranite",
                        "latitude": "44.04192000",
                        "longitude": "-89.09845000"
                    },
                    {
                        "id": 124994,
                        "name": "Reedsburg",
                        "latitude": "43.53248000",
                        "longitude": "-90.00263000"
                    },
                    {
                        "id": 124996,
                        "name": "Reedsville",
                        "latitude": "44.15360000",
                        "longitude": "-87.95676000"
                    },
                    {
                        "id": 125046,
                        "name": "Rhinelander",
                        "latitude": "45.63662000",
                        "longitude": "-89.41208000"
                    },
                    {
                        "id": 125050,
                        "name": "Rib Mountain",
                        "latitude": "44.91275000",
                        "longitude": "-89.67540000"
                    },
                    {
                        "id": 125055,
                        "name": "Rice Lake",
                        "latitude": "45.50607000",
                        "longitude": "-91.73823000"
                    },
                    {
                        "id": 125062,
                        "name": "Richfield",
                        "latitude": "43.25612000",
                        "longitude": "-88.19398000"
                    },
                    {
                        "id": 125073,
                        "name": "Richland Center",
                        "latitude": "43.33471000",
                        "longitude": "-90.38679000"
                    },
                    {
                        "id": 125077,
                        "name": "Richland County",
                        "latitude": "43.37564000",
                        "longitude": "-90.42948000"
                    },
                    {
                        "id": 125095,
                        "name": "Richmond",
                        "latitude": "42.71473000",
                        "longitude": "-88.74927000"
                    },
                    {
                        "id": 125146,
                        "name": "Rio",
                        "latitude": "43.44776000",
                        "longitude": "-89.23984000"
                    },
                    {
                        "id": 125167,
                        "name": "Ripon",
                        "latitude": "43.84220000",
                        "longitude": "-88.83594000"
                    },
                    {
                        "id": 125178,
                        "name": "River Falls",
                        "latitude": "44.86136000",
                        "longitude": "-92.62381000"
                    },
                    {
                        "id": 125182,
                        "name": "River Hills",
                        "latitude": "43.17418000",
                        "longitude": "-87.92425000"
                    },
                    {
                        "id": 125241,
                        "name": "Roberts",
                        "latitude": "44.98386000",
                        "longitude": "-92.55603000"
                    },
                    {
                        "id": 125269,
                        "name": "Rochester",
                        "latitude": "42.74141000",
                        "longitude": "-88.22426000"
                    },
                    {
                        "id": 125274,
                        "name": "Rock County",
                        "latitude": "42.67122000",
                        "longitude": "-89.07158000"
                    },
                    {
                        "id": 125379,
                        "name": "Rome",
                        "latitude": "44.22060000",
                        "longitude": "-89.80843000"
                    },
                    {
                        "id": 125434,
                        "name": "Rosendale",
                        "latitude": "43.80776000",
                        "longitude": "-88.67483000"
                    },
                    {
                        "id": 125465,
                        "name": "Rothschild",
                        "latitude": "44.88719000",
                        "longitude": "-89.62012000"
                    },
                    {
                        "id": 125486,
                        "name": "Roxbury",
                        "latitude": "43.24943000",
                        "longitude": "-89.67540000"
                    },
                    {
                        "id": 125530,
                        "name": "Rusk County",
                        "latitude": "45.47513000",
                        "longitude": "-91.13312000"
                    },
                    {
                        "id": 125556,
                        "name": "Rutland",
                        "latitude": "42.87889000",
                        "longitude": "-89.35012000"
                    },
                    {
                        "id": 125628,
                        "name": "Saint Croix County",
                        "latitude": "45.03407000",
                        "longitude": "-92.45278000"
                    },
                    {
                        "id": 125629,
                        "name": "Saint Croix Falls",
                        "latitude": "45.40996000",
                        "longitude": "-92.63965000"
                    },
                    {
                        "id": 125634,
                        "name": "Saint Francis",
                        "latitude": "42.96752000",
                        "longitude": "-87.87758000"
                    },
                    {
                        "id": 125709,
                        "name": "Saint Peter",
                        "latitude": "43.83638000",
                        "longitude": "-88.34149000"
                    },
                    {
                        "id": 125738,
                        "name": "Salem",
                        "latitude": "42.55474000",
                        "longitude": "-88.11092000"
                    },
                    {
                        "id": 125963,
                        "name": "Sauk City",
                        "latitude": "43.27082000",
                        "longitude": "-89.72207000"
                    },
                    {
                        "id": 125964,
                        "name": "Sauk County",
                        "latitude": "43.42678000",
                        "longitude": "-89.94837000"
                    },
                    {
                        "id": 125967,
                        "name": "Saukville",
                        "latitude": "43.38167000",
                        "longitude": "-87.94065000"
                    },
                    {
                        "id": 125982,
                        "name": "Sawyer County",
                        "latitude": "45.87997000",
                        "longitude": "-91.14467000"
                    },
                    {
                        "id": 126013,
                        "name": "Schofield",
                        "latitude": "44.90969000",
                        "longitude": "-89.60457000"
                    },
                    {
                        "id": 126197,
                        "name": "Seymour",
                        "latitude": "44.51499000",
                        "longitude": "-88.33038000"
                    },
                    {
                        "id": 126230,
                        "name": "Sharon",
                        "latitude": "42.50252000",
                        "longitude": "-88.72899000"
                    },
                    {
                        "id": 126247,
                        "name": "Shawano",
                        "latitude": "44.78221000",
                        "longitude": "-88.60899000"
                    },
                    {
                        "id": 126248,
                        "name": "Shawano County",
                        "latitude": "44.78915000",
                        "longitude": "-88.76544000"
                    },
                    {
                        "id": 126255,
                        "name": "Sheboygan",
                        "latitude": "43.75083000",
                        "longitude": "-87.71453000"
                    },
                    {
                        "id": 126256,
                        "name": "Sheboygan County",
                        "latitude": "43.75622000",
                        "longitude": "-87.79999000"
                    },
                    {
                        "id": 126257,
                        "name": "Sheboygan Falls",
                        "latitude": "43.73197000",
                        "longitude": "-87.82213000"
                    },
                    {
                        "id": 126290,
                        "name": "Shell Lake",
                        "latitude": "45.73939000",
                        "longitude": "-91.92545000"
                    },
                    {
                        "id": 126341,
                        "name": "Sherwood",
                        "latitude": "44.17360000",
                        "longitude": "-88.25983000"
                    },
                    {
                        "id": 126372,
                        "name": "Shorewood",
                        "latitude": "43.08918000",
                        "longitude": "-87.88758000"
                    },
                    {
                        "id": 126374,
                        "name": "Shorewood Hills",
                        "latitude": "43.07750000",
                        "longitude": "-89.44568000"
                    },
                    {
                        "id": 126388,
                        "name": "Shullsburg",
                        "latitude": "42.57334000",
                        "longitude": "-90.23096000"
                    },
                    {
                        "id": 126430,
                        "name": "Silver Lake",
                        "latitude": "44.05526000",
                        "longitude": "-89.22623000"
                    },
                    {
                        "id": 126463,
                        "name": "Siren",
                        "latitude": "45.78578000",
                        "longitude": "-92.38103000"
                    },
                    {
                        "id": 126502,
                        "name": "Slinger",
                        "latitude": "43.33361000",
                        "longitude": "-88.28621000"
                    },
                    {
                        "id": 126576,
                        "name": "Somers",
                        "latitude": "42.64030000",
                        "longitude": "-87.91036000"
                    },
                    {
                        "id": 126585,
                        "name": "Somerset",
                        "latitude": "45.12441000",
                        "longitude": "-92.67354000"
                    },
                    {
                        "id": 126693,
                        "name": "South Milwaukee",
                        "latitude": "42.91057000",
                        "longitude": "-87.86064000"
                    },
                    {
                        "id": 126813,
                        "name": "Sparta",
                        "latitude": "43.94413000",
                        "longitude": "-90.81291000"
                    },
                    {
                        "id": 126827,
                        "name": "Spencer",
                        "latitude": "44.75774000",
                        "longitude": "-90.29680000"
                    },
                    {
                        "id": 126845,
                        "name": "Spooner",
                        "latitude": "45.82245000",
                        "longitude": "-91.88934000"
                    },
                    {
                        "id": 126856,
                        "name": "Spring Green",
                        "latitude": "43.17527000",
                        "longitude": "-90.06790000"
                    },
                    {
                        "id": 126879,
                        "name": "Spring Valley",
                        "latitude": "44.84524000",
                        "longitude": "-92.23880000"
                    },
                    {
                        "id": 126960,
                        "name": "Stanley",
                        "latitude": "44.95997000",
                        "longitude": "-90.93708000"
                    },
                    {
                        "id": 127043,
                        "name": "Stevens Point",
                        "latitude": "44.52358000",
                        "longitude": "-89.57456000"
                    },
                    {
                        "id": 127110,
                        "name": "Stoughton",
                        "latitude": "42.91695000",
                        "longitude": "-89.21789000"
                    },
                    {
                        "id": 127126,
                        "name": "Stratford",
                        "latitude": "44.80108000",
                        "longitude": "-90.07930000"
                    },
                    {
                        "id": 127141,
                        "name": "Strum",
                        "latitude": "44.54969000",
                        "longitude": "-91.39266000"
                    },
                    {
                        "id": 127149,
                        "name": "Sturgeon Bay",
                        "latitude": "44.83416000",
                        "longitude": "-87.37704000"
                    },
                    {
                        "id": 127153,
                        "name": "Sturtevant",
                        "latitude": "42.69807000",
                        "longitude": "-87.89452000"
                    },
                    {
                        "id": 127156,
                        "name": "Suamico",
                        "latitude": "44.63194000",
                        "longitude": "-88.03927000"
                    },
                    {
                        "id": 127237,
                        "name": "Sun Prairie",
                        "latitude": "43.18360000",
                        "longitude": "-89.21373000"
                    },
                    {
                        "id": 127279,
                        "name": "Superior",
                        "latitude": "46.72077000",
                        "longitude": "-92.10408000"
                    },
                    {
                        "id": 127302,
                        "name": "Sussex",
                        "latitude": "43.13390000",
                        "longitude": "-88.22204000"
                    },
                    {
                        "id": 127381,
                        "name": "Tainter Lake",
                        "latitude": "44.98913000",
                        "longitude": "-91.84767000"
                    },
                    {
                        "id": 127457,
                        "name": "Taylor County",
                        "latitude": "45.21153000",
                        "longitude": "-90.50125000"
                    },
                    {
                        "id": 127569,
                        "name": "Theresa",
                        "latitude": "43.51722000",
                        "longitude": "-88.45121000"
                    },
                    {
                        "id": 127576,
                        "name": "Thiensville",
                        "latitude": "43.23751000",
                        "longitude": "-87.97870000"
                    },
                    {
                        "id": 127607,
                        "name": "Thorp",
                        "latitude": "44.96108000",
                        "longitude": "-90.79986000"
                    },
                    {
                        "id": 127634,
                        "name": "Tichigan",
                        "latitude": "42.82890000",
                        "longitude": "-88.19759000"
                    },
                    {
                        "id": 127708,
                        "name": "Tomah",
                        "latitude": "43.97858000",
                        "longitude": "-90.50402000"
                    },
                    {
                        "id": 127709,
                        "name": "Tomahawk",
                        "latitude": "45.47108000",
                        "longitude": "-89.72986000"
                    },
                    {
                        "id": 127798,
                        "name": "Trempealeau",
                        "latitude": "44.00552000",
                        "longitude": "-91.44209000"
                    },
                    {
                        "id": 127799,
                        "name": "Trempealeau County",
                        "latitude": "44.30395000",
                        "longitude": "-91.35846000"
                    },
                    {
                        "id": 127908,
                        "name": "Turtle Lake",
                        "latitude": "45.39440000",
                        "longitude": "-92.14241000"
                    },
                    {
                        "id": 127929,
                        "name": "Twin Lakes",
                        "latitude": "42.53113000",
                        "longitude": "-88.24815000"
                    },
                    {
                        "id": 127936,
                        "name": "Two Rivers",
                        "latitude": "44.15388000",
                        "longitude": "-87.56925000"
                    },
                    {
                        "id": 128005,
                        "name": "Union Grove",
                        "latitude": "42.68807000",
                        "longitude": "-88.05147000"
                    },
                    {
                        "id": 128193,
                        "name": "Vernon County",
                        "latitude": "43.59386000",
                        "longitude": "-90.83438000"
                    },
                    {
                        "id": 128205,
                        "name": "Verona",
                        "latitude": "42.99083000",
                        "longitude": "-89.53318000"
                    },
                    {
                        "id": 128240,
                        "name": "Vilas County",
                        "latitude": "46.05289000",
                        "longitude": "-89.51477000"
                    },
                    {
                        "id": 128292,
                        "name": "Viroqua",
                        "latitude": "43.55692000",
                        "longitude": "-90.88874000"
                    },
                    {
                        "id": 128380,
                        "name": "Wales",
                        "latitude": "43.00445000",
                        "longitude": "-88.37676000"
                    },
                    {
                        "id": 128440,
                        "name": "Walworth",
                        "latitude": "42.53113000",
                        "longitude": "-88.59955000"
                    },
                    {
                        "id": 128442,
                        "name": "Walworth County",
                        "latitude": "42.66848000",
                        "longitude": "-88.54192000"
                    },
                    {
                        "id": 128534,
                        "name": "Washburn",
                        "latitude": "46.67327000",
                        "longitude": "-90.89491000"
                    },
                    {
                        "id": 128536,
                        "name": "Washburn County",
                        "latitude": "45.89918000",
                        "longitude": "-91.79123000"
                    },
                    {
                        "id": 128576,
                        "name": "Washington County",
                        "latitude": "43.36847000",
                        "longitude": "-88.23078000"
                    },
                    {
                        "id": 128608,
                        "name": "Waterford",
                        "latitude": "42.76307000",
                        "longitude": "-88.21426000"
                    },
                    {
                        "id": 128616,
                        "name": "Waterloo",
                        "latitude": "43.18388000",
                        "longitude": "-88.98844000"
                    },
                    {
                        "id": 128624,
                        "name": "Watertown",
                        "latitude": "43.19472000",
                        "longitude": "-88.72899000"
                    },
                    {
                        "id": 128649,
                        "name": "Waukesha",
                        "latitude": "43.01168000",
                        "longitude": "-88.23148000"
                    },
                    {
                        "id": 128650,
                        "name": "Waukesha County",
                        "latitude": "43.01819000",
                        "longitude": "-88.30453000"
                    },
                    {
                        "id": 128654,
                        "name": "Waunakee",
                        "latitude": "43.19194000",
                        "longitude": "-89.45567000"
                    },
                    {
                        "id": 128655,
                        "name": "Waupaca",
                        "latitude": "44.35803000",
                        "longitude": "-89.08595000"
                    },
                    {
                        "id": 128656,
                        "name": "Waupaca County",
                        "latitude": "44.47043000",
                        "longitude": "-88.96482000"
                    },
                    {
                        "id": 128657,
                        "name": "Waupun",
                        "latitude": "43.63332000",
                        "longitude": "-88.72955000"
                    },
                    {
                        "id": 128660,
                        "name": "Wausau",
                        "latitude": "44.95914000",
                        "longitude": "-89.63012000"
                    },
                    {
                        "id": 128661,
                        "name": "Waushara County",
                        "latitude": "44.11312000",
                        "longitude": "-89.24288000"
                    },
                    {
                        "id": 128662,
                        "name": "Wautoma",
                        "latitude": "44.07470000",
                        "longitude": "-89.28790000"
                    },
                    {
                        "id": 128663,
                        "name": "Wauwatosa",
                        "latitude": "43.04946000",
                        "longitude": "-88.00759000"
                    },
                    {
                        "id": 128817,
                        "name": "West Allis",
                        "latitude": "43.01668000",
                        "longitude": "-88.00703000"
                    },
                    {
                        "id": 128820,
                        "name": "West Baraboo",
                        "latitude": "43.47443000",
                        "longitude": "-89.77040000"
                    },
                    {
                        "id": 128825,
                        "name": "West Bend",
                        "latitude": "43.42528000",
                        "longitude": "-88.18343000"
                    },
                    {
                        "id": 128933,
                        "name": "West Milwaukee",
                        "latitude": "43.01251000",
                        "longitude": "-87.97259000"
                    },
                    {
                        "id": 128973,
                        "name": "West Salem",
                        "latitude": "43.89913000",
                        "longitude": "-91.08125000"
                    },
                    {
                        "id": 129016,
                        "name": "Westby",
                        "latitude": "43.65692000",
                        "longitude": "-90.85430000"
                    },
                    {
                        "id": 129032,
                        "name": "Westfield",
                        "latitude": "43.88359000",
                        "longitude": "-89.49346000"
                    },
                    {
                        "id": 129063,
                        "name": "Weston",
                        "latitude": "44.89080000",
                        "longitude": "-89.54762000"
                    },
                    {
                        "id": 129098,
                        "name": "Weyauwega",
                        "latitude": "44.32137000",
                        "longitude": "-88.93372000"
                    },
                    {
                        "id": 129167,
                        "name": "Whitefish Bay",
                        "latitude": "43.11334000",
                        "longitude": "-87.90009000"
                    },
                    {
                        "id": 129171,
                        "name": "Whitehall",
                        "latitude": "44.36746000",
                        "longitude": "-91.31655000"
                    },
                    {
                        "id": 129191,
                        "name": "Whitewater",
                        "latitude": "42.83362000",
                        "longitude": "-88.73233000"
                    },
                    {
                        "id": 129197,
                        "name": "Whiting",
                        "latitude": "44.49358000",
                        "longitude": "-89.55873000"
                    },
                    {
                        "id": 129263,
                        "name": "Williams Bay",
                        "latitude": "42.57807000",
                        "longitude": "-88.54093000"
                    },
                    {
                        "id": 129364,
                        "name": "Wind Lake",
                        "latitude": "42.82946000",
                        "longitude": "-88.15870000"
                    },
                    {
                        "id": 129365,
                        "name": "Wind Point",
                        "latitude": "42.78446000",
                        "longitude": "-87.76619000"
                    },
                    {
                        "id": 129385,
                        "name": "Windsor",
                        "latitude": "43.21833000",
                        "longitude": "-89.34151000"
                    },
                    {
                        "id": 129409,
                        "name": "Winnebago County",
                        "latitude": "44.06888000",
                        "longitude": "-88.64466000"
                    },
                    {
                        "id": 129410,
                        "name": "Winneconne",
                        "latitude": "44.11082000",
                        "longitude": "-88.71261000"
                    },
                    {
                        "id": 129457,
                        "name": "Wisconsin Dells",
                        "latitude": "43.62748000",
                        "longitude": "-89.77096000"
                    },
                    {
                        "id": 129458,
                        "name": "Wisconsin Rapids",
                        "latitude": "44.38358000",
                        "longitude": "-89.81735000"
                    },
                    {
                        "id": 129464,
                        "name": "Wittenberg",
                        "latitude": "44.82720000",
                        "longitude": "-89.16956000"
                    },
                    {
                        "id": 129486,
                        "name": "Wood County",
                        "latitude": "44.45532000",
                        "longitude": "-90.04158000"
                    },
                    {
                        "id": 129573,
                        "name": "Woodville",
                        "latitude": "44.95302000",
                        "longitude": "-92.29130000"
                    },
                    {
                        "id": 129612,
                        "name": "Wrightstown",
                        "latitude": "44.32582000",
                        "longitude": "-88.16288000"
                    }
                ]
            },
            {
                "id": 1442,
                "name": "Wyoming",
                "iso2": "WY",
                "latitude": "43.07596780",
                "longitude": "-107.29028390",
                "type": "state",
                "cities": [
                    {
                        "id": 111054,
                        "name": "Afton",
                        "latitude": "42.72493000",
                        "longitude": "-110.93187000"
                    },
                    {
                        "id": 111113,
                        "name": "Albany County",
                        "latitude": "41.65447000",
                        "longitude": "-105.72391000"
                    },
                    {
                        "id": 111366,
                        "name": "Antelope Valley-Crestview",
                        "latitude": "44.22488000",
                        "longitude": "-105.47409000"
                    },
                    {
                        "id": 111414,
                        "name": "Arapahoe",
                        "latitude": "42.96218000",
                        "longitude": "-108.48983000"
                    },
                    {
                        "id": 111807,
                        "name": "Bar Nunn",
                        "latitude": "42.91358000",
                        "longitude": "-106.34336000"
                    },
                    {
                        "id": 111878,
                        "name": "Basin",
                        "latitude": "44.37996000",
                        "longitude": "-108.03899000"
                    },
                    {
                        "id": 112322,
                        "name": "Big Horn County",
                        "latitude": "44.52682000",
                        "longitude": "-107.99521000"
                    },
                    {
                        "id": 113016,
                        "name": "Buffalo",
                        "latitude": "44.34831000",
                        "longitude": "-106.69894000"
                    },
                    {
                        "id": 113303,
                        "name": "Campbell County",
                        "latitude": "44.24839000",
                        "longitude": "-105.54831000"
                    },
                    {
                        "id": 113385,
                        "name": "Carbon County",
                        "latitude": "41.69459000",
                        "longitude": "-106.93061000"
                    },
                    {
                        "id": 113524,
                        "name": "Casper",
                        "latitude": "42.86663000",
                        "longitude": "-106.31308000"
                    },
                    {
                        "id": 113926,
                        "name": "Cheyenne",
                        "latitude": "41.13998000",
                        "longitude": "-104.82025000"
                    },
                    {
                        "id": 114364,
                        "name": "Cody",
                        "latitude": "44.52634000",
                        "longitude": "-109.05653000"
                    },
                    {
                        "id": 114580,
                        "name": "Converse County",
                        "latitude": "42.97233000",
                        "longitude": "-105.50706000"
                    },
                    {
                        "id": 114837,
                        "name": "Crook County",
                        "latitude": "44.58860000",
                        "longitude": "-104.56994000"
                    },
                    {
                        "id": 115424,
                        "name": "Douglas",
                        "latitude": "42.75969000",
                        "longitude": "-105.38221000"
                    },
                    {
                        "id": 116214,
                        "name": "Ethete",
                        "latitude": "43.02496000",
                        "longitude": "-108.77262000"
                    },
                    {
                        "id": 116252,
                        "name": "Evanston",
                        "latitude": "41.26828000",
                        "longitude": "-110.96324000"
                    },
                    {
                        "id": 116255,
                        "name": "Evansville",
                        "latitude": "42.85997000",
                        "longitude": "-106.26836000"
                    },
                    {
                        "id": 116760,
                        "name": "Fort Washakie",
                        "latitude": "43.00635000",
                        "longitude": "-108.88235000"
                    },
                    {
                        "id": 116801,
                        "name": "Fox Farm-College",
                        "latitude": "41.11203000",
                        "longitude": "-104.78546000"
                    },
                    {
                        "id": 116928,
                        "name": "Fremont County",
                        "latitude": "43.04053000",
                        "longitude": "-108.63042000"
                    },
                    {
                        "id": 117217,
                        "name": "Gillette",
                        "latitude": "44.29109000",
                        "longitude": "-105.50222000"
                    },
                    {
                        "id": 117303,
                        "name": "Glenrock",
                        "latitude": "42.86136000",
                        "longitude": "-105.87223000"
                    },
                    {
                        "id": 117411,
                        "name": "Goshen County",
                        "latitude": "42.08794000",
                        "longitude": "-104.35326000"
                    },
                    {
                        "id": 117606,
                        "name": "Green River",
                        "latitude": "41.52858000",
                        "longitude": "-109.46625000"
                    },
                    {
                        "id": 117728,
                        "name": "Greybull",
                        "latitude": "44.48912000",
                        "longitude": "-108.05621000"
                    },
                    {
                        "id": 117781,
                        "name": "Guernsey",
                        "latitude": "42.26969000",
                        "longitude": "-104.74163000"
                    },
                    {
                        "id": 118495,
                        "name": "Hoback",
                        "latitude": "43.28187000",
                        "longitude": "-110.78381000"
                    },
                    {
                        "id": 118684,
                        "name": "Hot Springs County",
                        "latitude": "43.71893000",
                        "longitude": "-108.44210000"
                    },
                    {
                        "id": 119074,
                        "name": "Jackson",
                        "latitude": "43.47993000",
                        "longitude": "-110.76243000"
                    },
                    {
                        "id": 119271,
                        "name": "Johnson County",
                        "latitude": "44.03877000",
                        "longitude": "-106.58463000"
                    },
                    {
                        "id": 119434,
                        "name": "Kemmerer",
                        "latitude": "41.79245000",
                        "longitude": "-110.53767000"
                    },
                    {
                        "id": 120096,
                        "name": "Lander",
                        "latitude": "42.83301000",
                        "longitude": "-108.73067000"
                    },
                    {
                        "id": 120138,
                        "name": "Laramie",
                        "latitude": "41.31137000",
                        "longitude": "-105.59110000"
                    },
                    {
                        "id": 120139,
                        "name": "Laramie County",
                        "latitude": "41.30707000",
                        "longitude": "-104.68962000"
                    },
                    {
                        "id": 120538,
                        "name": "Lincoln County",
                        "latitude": "42.26404000",
                        "longitude": "-110.65597000"
                    },
                    {
                        "id": 120824,
                        "name": "Lovell",
                        "latitude": "44.83745000",
                        "longitude": "-108.38956000"
                    },
                    {
                        "id": 120892,
                        "name": "Lusk",
                        "latitude": "42.76247000",
                        "longitude": "-104.45217000"
                    },
                    {
                        "id": 120910,
                        "name": "Lyman",
                        "latitude": "41.32745000",
                        "longitude": "-110.29293000"
                    },
                    {
                        "id": 121190,
                        "name": "Marbleton",
                        "latitude": "42.55355000",
                        "longitude": "-110.10932000"
                    },
                    {
                        "id": 121896,
                        "name": "Mills",
                        "latitude": "42.84052000",
                        "longitude": "-106.36586000"
                    },
                    {
                        "id": 122199,
                        "name": "Moorcroft",
                        "latitude": "44.26331000",
                        "longitude": "-104.95025000"
                    },
                    {
                        "id": 122215,
                        "name": "Moose Wilson Road",
                        "latitude": "43.52521000",
                        "longitude": "-110.84466000"
                    },
                    {
                        "id": 122433,
                        "name": "Mountain View",
                        "latitude": "41.26884000",
                        "longitude": "-110.33988000"
                    },
                    {
                        "id": 122594,
                        "name": "Natrona County",
                        "latitude": "42.96224000",
                        "longitude": "-106.79849000"
                    },
                    {
                        "id": 122822,
                        "name": "Newcastle",
                        "latitude": "43.85470000",
                        "longitude": "-104.20494000"
                    },
                    {
                        "id": 122904,
                        "name": "Niobrara County",
                        "latitude": "43.05650000",
                        "longitude": "-104.47538000"
                    },
                    {
                        "id": 123097,
                        "name": "North Rock Springs",
                        "latitude": "41.64358000",
                        "longitude": "-109.26568000"
                    },
                    {
                        "id": 123843,
                        "name": "Park County",
                        "latitude": "44.52057000",
                        "longitude": "-109.58853000"
                    },
                    {
                        "id": 124215,
                        "name": "Pine Bluffs",
                        "latitude": "41.18193000",
                        "longitude": "-104.06912000"
                    },
                    {
                        "id": 124249,
                        "name": "Pinedale",
                        "latitude": "42.86661000",
                        "longitude": "-109.86099000"
                    },
                    {
                        "id": 124355,
                        "name": "Platte County",
                        "latitude": "42.13305000",
                        "longitude": "-104.96582000"
                    },
                    {
                        "id": 124611,
                        "name": "Powell",
                        "latitude": "44.75384000",
                        "longitude": "-108.75735000"
                    },
                    {
                        "id": 124820,
                        "name": "Rafter J Ranch",
                        "latitude": "43.42604000",
                        "longitude": "-110.79909000"
                    },
                    {
                        "id": 124846,
                        "name": "Ranchettes",
                        "latitude": "41.21859000",
                        "longitude": "-104.79025000"
                    },
                    {
                        "id": 124912,
                        "name": "Rawlins",
                        "latitude": "41.79107000",
                        "longitude": "-107.23866000"
                    },
                    {
                        "id": 125214,
                        "name": "Riverton",
                        "latitude": "43.02496000",
                        "longitude": "-108.38010000"
                    },
                    {
                        "id": 125287,
                        "name": "Rock Springs",
                        "latitude": "41.58746000",
                        "longitude": "-109.20290000"
                    },
                    {
                        "id": 125942,
                        "name": "Saratoga",
                        "latitude": "41.45496000",
                        "longitude": "-106.80643000"
                    },
                    {
                        "id": 126323,
                        "name": "Sheridan",
                        "latitude": "44.79719000",
                        "longitude": "-106.95618000"
                    },
                    {
                        "id": 126328,
                        "name": "Sheridan County",
                        "latitude": "44.79004000",
                        "longitude": "-106.87948000"
                    },
                    {
                        "id": 126500,
                        "name": "Sleepy Hollow",
                        "latitude": "44.24109000",
                        "longitude": "-105.42222000"
                    },
                    {
                        "id": 126662,
                        "name": "South Greeley",
                        "latitude": "41.09693000",
                        "longitude": "-104.80636000"
                    },
                    {
                        "id": 126703,
                        "name": "South Park",
                        "latitude": "43.42215000",
                        "longitude": "-110.79326000"
                    },
                    {
                        "id": 126982,
                        "name": "Star Valley Ranch",
                        "latitude": "42.97139000",
                        "longitude": "-110.95556000"
                    },
                    {
                        "id": 127158,
                        "name": "Sublette County",
                        "latitude": "42.76691000",
                        "longitude": "-109.91471000"
                    },
                    {
                        "id": 127248,
                        "name": "Sundance",
                        "latitude": "44.40637000",
                        "longitude": "-104.37578000"
                    },
                    {
                        "id": 127343,
                        "name": "Sweetwater County",
                        "latitude": "41.65950000",
                        "longitude": "-108.87942000"
                    },
                    {
                        "id": 127539,
                        "name": "Teton County",
                        "latitude": "43.93476000",
                        "longitude": "-110.58974000"
                    },
                    {
                        "id": 127572,
                        "name": "Thermopolis",
                        "latitude": "43.64607000",
                        "longitude": "-108.21204000"
                    },
                    {
                        "id": 127745,
                        "name": "Torrington",
                        "latitude": "42.06246000",
                        "longitude": "-104.18439000"
                    },
                    {
                        "id": 127955,
                        "name": "Uinta County",
                        "latitude": "41.28756000",
                        "longitude": "-110.54759000"
                    },
                    {
                        "id": 128056,
                        "name": "Upton",
                        "latitude": "44.09970000",
                        "longitude": "-104.62802000"
                    },
                    {
                        "id": 128532,
                        "name": "Washakie County",
                        "latitude": "43.90500000",
                        "longitude": "-107.68286000"
                    },
                    {
                        "id": 129064,
                        "name": "Weston County",
                        "latitude": "43.84049000",
                        "longitude": "-104.56783000"
                    },
                    {
                        "id": 129109,
                        "name": "Wheatland",
                        "latitude": "42.05407000",
                        "longitude": "-104.95295000"
                    },
                    {
                        "id": 129333,
                        "name": "Wilson",
                        "latitude": "43.50076000",
                        "longitude": "-110.87521000"
                    },
                    {
                        "id": 129589,
                        "name": "Worland",
                        "latitude": "44.01690000",
                        "longitude": "-107.95537000"
                    },
                    {
                        "id": 129606,
                        "name": "Wright",
                        "latitude": "43.75124000",
                        "longitude": "-105.49201000"
                    }
                ]
            }
        ]
    },
    {
        "id": 234,
        "name": "United States Minor Outlying Islands",
        "iso3": "UMI",
        "iso2": "UM",
        "numeric_code": "581",
        "phonecode": "1",
        "capital": "",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".us",
        "native": "United States Minor Outlying Islands",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Northern America",
        "subregion_id": 6,
        "nationality": "American",
        "timezones": [
            {
                "zoneName": "Pacific\/Midway",
                "gmtOffset": -39600,
                "gmtOffsetName": "UTC-11:00",
                "abbreviation": "SST",
                "tzName": "Samoa Standard Time"
            },
            {
                "zoneName": "Pacific\/Wake",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "WAKT",
                "tzName": "Wake Island Time"
            }
        ],
        "translations": {
            "br": "Inizi Minor A-bell Stadoù-Unanet",
            "ko": "미국령 군소 제도",
            "pt-BR": "Ilhas Menores Distantes dos Estados Unidos",
            "pt": "Ilhas Menores Distantes dos Estados Unidos",
            "nl": "Kleine afgelegen eilanden van de Verenigde Staten",
            "hr": "Mali udaljeni otoci SAD-a",
            "fa": "جزایر کوچک حاشیه‌ای ایالات متحده آمریکا",
            "de": "Kleinere Inselbesitzungen der Vereinigten Staaten",
            "es": "Islas Ultramarinas Menores de Estados Unidos",
            "fr": "Îles mineures éloignées des États-Unis",
            "ja": "合衆国領有小離島",
            "it": "Isole minori esterne degli Stati Uniti d'America",
            "zh-CN": "美国本土外小岛屿",
            "tr": "Abd Küçük Harici Adalari",
            "ru": "Малые отдаленные острова Соединенных Штатов",
            "uk": "Малі віддалені острови Сполучених Штатів",
            "pl": "Mniejsze Wyspy Zewnętrzne Stanów Zjednoczonych"
        },
        "latitude": "0.00000000",
        "longitude": "0.00000000",
        "emoji": "🇺🇲",
        "emojiU": "U+1F1FA U+1F1F2",
        "states": [
            {
                "id": 5212,
                "name": "Baker Island",
                "iso2": "81",
                "latitude": "0.19362660",
                "longitude": "-176.47690800",
                "type": "island",
                "cities": []
            },
            {
                "id": 5213,
                "name": "Howland Island",
                "iso2": "84",
                "latitude": "0.81132190",
                "longitude": "-176.61827360",
                "type": "island",
                "cities": []
            },
            {
                "id": 5214,
                "name": "Jarvis Island",
                "iso2": "86",
                "latitude": "-0.37435030",
                "longitude": "-159.99672060",
                "type": "island",
                "cities": []
            },
            {
                "id": 5215,
                "name": "Johnston Atoll",
                "iso2": "67",
                "latitude": "16.72950350",
                "longitude": "-169.53364770",
                "type": "island",
                "cities": []
            },
            {
                "id": 5216,
                "name": "Kingman Reef",
                "iso2": "89",
                "latitude": "6.38333300",
                "longitude": "-162.41666700",
                "type": "island",
                "cities": []
            },
            {
                "id": 5217,
                "name": "Midway Islands",
                "iso2": "71",
                "latitude": "28.20721680",
                "longitude": "-177.37349260",
                "type": "island",
                "cities": []
            },
            {
                "id": 5218,
                "name": "Navassa Island",
                "iso2": "76",
                "latitude": "18.41006890",
                "longitude": "-75.01146120",
                "type": "island",
                "cities": []
            },
            {
                "id": 5219,
                "name": "Palmyra Atoll",
                "iso2": "95",
                "latitude": "5.88850260",
                "longitude": "-162.07866560",
                "type": "island",
                "cities": []
            },
            {
                "id": 5220,
                "name": "Wake Island",
                "iso2": "79",
                "latitude": "19.27961900",
                "longitude": "166.64993480",
                "type": "island",
                "cities": []
            }
        ]
    },
    {
        "id": 235,
        "name": "Uruguay",
        "iso3": "URY",
        "iso2": "UY",
        "numeric_code": "858",
        "phonecode": "598",
        "capital": "Montevideo",
        "currency": "UYU",
        "currency_name": "Uruguayan peso",
        "currency_symbol": "$",
        "tld": ".uy",
        "native": "Uruguay",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Uruguayan",
        "timezones": [
            {
                "zoneName": "America\/Montevideo",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "UYT",
                "tzName": "Uruguay Standard Time"
            }
        ],
        "translations": {
            "br": "Uruguay",
            "ko": "우루과이",
            "pt-BR": "Uruguai",
            "pt": "Uruguai",
            "nl": "Uruguay",
            "hr": "Urugvaj",
            "fa": "اروگوئه",
            "de": "Uruguay",
            "es": "Uruguay",
            "fr": "Uruguay",
            "ja": "ウルグアイ",
            "it": "Uruguay",
            "zh-CN": "乌拉圭",
            "tr": "Uruguay",
            "ru": "Уругвай",
            "uk": "Уругвай",
            "pl": "Urugwaj"
        },
        "latitude": "-33.00000000",
        "longitude": "-56.00000000",
        "emoji": "🇺🇾",
        "emojiU": "U+1F1FA U+1F1FE",
        "states": [
            {
                "id": 3205,
                "name": "Artigas",
                "iso2": "AR",
                "latitude": "-30.61751120",
                "longitude": "-56.95945590",
                "type": "department",
                "cities": [
                    {
                        "id": 129777,
                        "name": "Artigas",
                        "latitude": "-30.40000000",
                        "longitude": "-56.46667000"
                    },
                    {
                        "id": 129779,
                        "name": "Baltasar Brum",
                        "latitude": "-30.71905000",
                        "longitude": "-57.32596000"
                    },
                    {
                        "id": 129782,
                        "name": "Bella Unión",
                        "latitude": "-30.25966000",
                        "longitude": "-57.59919000"
                    },
                    {
                        "id": 129820,
                        "name": "Las Piedras",
                        "latitude": "-30.26204000",
                        "longitude": "-57.58174000"
                    },
                    {
                        "id": 129881,
                        "name": "Tomás Gomensoro",
                        "latitude": "-30.42870000",
                        "longitude": "-57.43609000"
                    }
                ]
            },
            {
                "id": 3213,
                "name": "Canelones",
                "iso2": "CA",
                "latitude": "-34.54087170",
                "longitude": "-55.93076000",
                "type": "department",
                "cities": [
                    {
                        "id": 129774,
                        "name": "Aguas Corrientes",
                        "latitude": "-34.52194000",
                        "longitude": "-56.39361000"
                    },
                    {
                        "id": 129778,
                        "name": "Atlántida",
                        "latitude": "-34.77190000",
                        "longitude": "-55.75840000"
                    },
                    {
                        "id": 129780,
                        "name": "Barra de Carrasco",
                        "latitude": "-34.87722000",
                        "longitude": "-56.02972000"
                    },
                    {
                        "id": 129781,
                        "name": "Barros Blancos",
                        "latitude": "-34.75240000",
                        "longitude": "-56.00259000"
                    },
                    {
                        "id": 129785,
                        "name": "Canelones",
                        "latitude": "-34.52278000",
                        "longitude": "-56.27778000"
                    },
                    {
                        "id": 129794,
                        "name": "Colonia Nicolich",
                        "latitude": "-34.81516000",
                        "longitude": "-56.02435000"
                    },
                    {
                        "id": 129802,
                        "name": "Empalme Olmos",
                        "latitude": "-34.69753000",
                        "longitude": "-55.89268000"
                    },
                    {
                        "id": 129809,
                        "name": "Joaquín Suárez",
                        "latitude": "-34.73501000",
                        "longitude": "-56.03470000"
                    },
                    {
                        "id": 129814,
                        "name": "Juanicó",
                        "latitude": "-34.59454000",
                        "longitude": "-56.25334000"
                    },
                    {
                        "id": 129815,
                        "name": "La Floresta",
                        "latitude": "-34.75572000",
                        "longitude": "-55.68141000"
                    },
                    {
                        "id": 129818,
                        "name": "La Paz",
                        "latitude": "-34.76031000",
                        "longitude": "-56.22590000"
                    },
                    {
                        "id": 129819,
                        "name": "Las Piedras",
                        "latitude": "-34.73020000",
                        "longitude": "-56.21915000"
                    },
                    {
                        "id": 129821,
                        "name": "Las Toscas",
                        "latitude": "-34.73333000",
                        "longitude": "-55.71667000"
                    },
                    {
                        "id": 129824,
                        "name": "Los Cerrillos",
                        "latitude": "-34.60500000",
                        "longitude": "-56.35639000"
                    },
                    {
                        "id": 129829,
                        "name": "Migues",
                        "latitude": "-34.48759000",
                        "longitude": "-55.62793000"
                    },
                    {
                        "id": 129832,
                        "name": "Montes",
                        "latitude": "-34.49339000",
                        "longitude": "-55.56219000"
                    },
                    {
                        "id": 129841,
                        "name": "Pando",
                        "latitude": "-34.71716000",
                        "longitude": "-55.95840000"
                    },
                    {
                        "id": 129842,
                        "name": "Paso de Carrasco",
                        "latitude": "-34.86028000",
                        "longitude": "-56.05222000"
                    },
                    {
                        "id": 129847,
                        "name": "Progreso",
                        "latitude": "-34.66737000",
                        "longitude": "-56.21758000"
                    },
                    {
                        "id": 129858,
                        "name": "San Antonio",
                        "latitude": "-34.45130000",
                        "longitude": "-56.08036000"
                    },
                    {
                        "id": 129859,
                        "name": "San Bautista",
                        "latitude": "-34.44016000",
                        "longitude": "-55.95861000"
                    },
                    {
                        "id": 129862,
                        "name": "San Jacinto",
                        "latitude": "-34.54465000",
                        "longitude": "-55.87151000"
                    },
                    {
                        "id": 129865,
                        "name": "San Ramón",
                        "latitude": "-34.29155000",
                        "longitude": "-55.95571000"
                    },
                    {
                        "id": 129869,
                        "name": "Santa Lucía",
                        "latitude": "-34.45333000",
                        "longitude": "-56.39056000"
                    },
                    {
                        "id": 129870,
                        "name": "Santa Rosa",
                        "latitude": "-34.49819000",
                        "longitude": "-56.03795000"
                    },
                    {
                        "id": 129874,
                        "name": "Sauce",
                        "latitude": "-34.65191000",
                        "longitude": "-56.06431000"
                    },
                    {
                        "id": 129875,
                        "name": "Soca",
                        "latitude": "-34.68432000",
                        "longitude": "-55.70200000"
                    },
                    {
                        "id": 129878,
                        "name": "Tala",
                        "latitude": "-34.34349000",
                        "longitude": "-55.76375000"
                    },
                    {
                        "id": 129880,
                        "name": "Toledo",
                        "latitude": "-34.73807000",
                        "longitude": "-56.09469000"
                    }
                ]
            },
            {
                "id": 3211,
                "name": "Cerro Largo",
                "iso2": "CL",
                "latitude": "-32.44110320",
                "longitude": "-54.35217530",
                "type": "department",
                "cities": [
                    {
                        "id": 129773,
                        "name": "Aceguá",
                        "latitude": "-31.87178000",
                        "longitude": "-54.16351000"
                    },
                    {
                        "id": 129808,
                        "name": "Isidoro Noblía",
                        "latitude": "-31.96218000",
                        "longitude": "-54.12309000"
                    },
                    {
                        "id": 129827,
                        "name": "Melo",
                        "latitude": "-32.37028000",
                        "longitude": "-54.16750000"
                    },
                    {
                        "id": 129856,
                        "name": "Río Branco",
                        "latitude": "-32.59802000",
                        "longitude": "-53.38583000"
                    },
                    {
                        "id": 129885,
                        "name": "Tupambaé",
                        "latitude": "-32.83333000",
                        "longitude": "-54.76667000"
                    }
                ]
            },
            {
                "id": 3208,
                "name": "Colonia",
                "iso2": "CO",
                "latitude": "-34.12946780",
                "longitude": "-57.66051840",
                "type": "department",
                "cities": [
                    {
                        "id": 129789,
                        "name": "Carmelo",
                        "latitude": "-34.00023000",
                        "longitude": "-58.28402000"
                    },
                    {
                        "id": 129795,
                        "name": "Colonia del Sacramento",
                        "latitude": "-34.46262000",
                        "longitude": "-57.83976000"
                    },
                    {
                        "id": 129804,
                        "name": "Florencio Sánchez",
                        "latitude": "-33.87785000",
                        "longitude": "-57.37166000"
                    },
                    {
                        "id": 129813,
                        "name": "Juan L. Lacaze",
                        "latitude": "-34.41888000",
                        "longitude": "-57.45285000"
                    },
                    {
                        "id": 129834,
                        "name": "Nueva Helvecia",
                        "latitude": "-34.30000000",
                        "longitude": "-57.23333000"
                    },
                    {
                        "id": 129835,
                        "name": "Nueva Palmira",
                        "latitude": "-33.87031000",
                        "longitude": "-58.41176000"
                    },
                    {
                        "id": 129837,
                        "name": "Ombúes de Lavalle",
                        "latitude": "-33.93783000",
                        "longitude": "-57.80959000"
                    },
                    {
                        "id": 129855,
                        "name": "Rosario",
                        "latitude": "-34.31667000",
                        "longitude": "-57.35000000"
                    },
                    {
                        "id": 129879,
                        "name": "Tarariras",
                        "latitude": "-34.26555000",
                        "longitude": "-57.61866000"
                    }
                ]
            },
            {
                "id": 3209,
                "name": "Durazno",
                "iso2": "DU",
                "latitude": "-33.02324540",
                "longitude": "-56.02846440",
                "type": "department",
                "cities": [
                    {
                        "id": 129784,
                        "name": "Blanquillo",
                        "latitude": "-32.76667000",
                        "longitude": "-55.63333000"
                    },
                    {
                        "id": 129788,
                        "name": "Carlos Reyles",
                        "latitude": "-33.05658000",
                        "longitude": "-56.47652000"
                    },
                    {
                        "id": 129800,
                        "name": "Durazno",
                        "latitude": "-33.38056000",
                        "longitude": "-56.52361000"
                    },
                    {
                        "id": 129817,
                        "name": "La Paloma",
                        "latitude": "-32.72689000",
                        "longitude": "-55.58270000"
                    },
                    {
                        "id": 129866,
                        "name": "Santa Bernardina",
                        "latitude": "-33.35360000",
                        "longitude": "-56.52498000"
                    },
                    {
                        "id": 129873,
                        "name": "Sarandí del Yi",
                        "latitude": "-33.35000000",
                        "longitude": "-55.63333000"
                    },
                    {
                        "id": 129892,
                        "name": "Villa del Carmen",
                        "latitude": "-33.23943000",
                        "longitude": "-56.00936000"
                    }
                ]
            },
            {
                "id": 3203,
                "name": "Flores",
                "iso2": "FS",
                "latitude": "-33.57337530",
                "longitude": "-56.89450280",
                "type": "department",
                "cities": [
                    {
                        "id": 129884,
                        "name": "Trinidad",
                        "latitude": "-33.51650000",
                        "longitude": "-56.89957000"
                    }
                ]
            },
            {
                "id": 3217,
                "name": "Florida",
                "iso2": "FD",
                "latitude": "28.03594950",
                "longitude": "-82.45792890",
                "type": "department",
                "cities": [
                    {
                        "id": 129771,
                        "name": "25 de Agosto",
                        "latitude": "-34.41167000",
                        "longitude": "-56.40222000"
                    },
                    {
                        "id": 129772,
                        "name": "25 de Mayo",
                        "latitude": "-34.18917000",
                        "longitude": "-56.33944000"
                    },
                    {
                        "id": 129776,
                        "name": "Alejandro Gallinal",
                        "latitude": "-33.86252000",
                        "longitude": "-55.54264000"
                    },
                    {
                        "id": 129786,
                        "name": "Cardal",
                        "latitude": "-34.29056000",
                        "longitude": "-56.38889000"
                    },
                    {
                        "id": 129791,
                        "name": "Casupá",
                        "latitude": "-34.09994000",
                        "longitude": "-55.64811000"
                    },
                    {
                        "id": 129805,
                        "name": "Florida",
                        "latitude": "-34.09556000",
                        "longitude": "-56.21417000"
                    },
                    {
                        "id": 129872,
                        "name": "Sarandí Grande",
                        "latitude": "-33.73333000",
                        "longitude": "-56.33333000"
                    }
                ]
            },
            {
                "id": 3215,
                "name": "Lavalleja",
                "iso2": "LA",
                "latitude": "-33.92261750",
                "longitude": "-54.97657940",
                "type": "department",
                "cities": [
                    {
                        "id": 129810,
                        "name": "José Batlle y Ordóñez",
                        "latitude": "-33.46667000",
                        "longitude": "-55.11667000"
                    },
                    {
                        "id": 129812,
                        "name": "José Pedro Varela",
                        "latitude": "-33.45451000",
                        "longitude": "-54.53586000"
                    },
                    {
                        "id": 129826,
                        "name": "Mariscala",
                        "latitude": "-34.04085000",
                        "longitude": "-54.77732000"
                    },
                    {
                        "id": 129830,
                        "name": "Minas",
                        "latitude": "-34.37589000",
                        "longitude": "-55.23771000"
                    },
                    {
                        "id": 129876,
                        "name": "Solís de Mataojo",
                        "latitude": "-34.59951000",
                        "longitude": "-55.46808000"
                    }
                ]
            },
            {
                "id": 3206,
                "name": "Maldonado",
                "iso2": "MA",
                "latitude": "-34.55979320",
                "longitude": "-54.86285520",
                "type": "department",
                "cities": [
                    {
                        "id": 129775,
                        "name": "Aiguá",
                        "latitude": "-34.20498000",
                        "longitude": "-54.75665000"
                    },
                    {
                        "id": 129825,
                        "name": "Maldonado",
                        "latitude": "-34.90000000",
                        "longitude": "-54.95000000"
                    },
                    {
                        "id": 129840,
                        "name": "Pan de Azúcar",
                        "latitude": "-34.77870000",
                        "longitude": "-55.23582000"
                    },
                    {
                        "id": 129846,
                        "name": "Piriápolis",
                        "latitude": "-34.86287000",
                        "longitude": "-55.27471000"
                    },
                    {
                        "id": 129848,
                        "name": "Punta del Este",
                        "latitude": "-34.94747000",
                        "longitude": "-54.93382000"
                    },
                    {
                        "id": 129860,
                        "name": "San Carlos",
                        "latitude": "-34.79123000",
                        "longitude": "-54.91824000"
                    }
                ]
            },
            {
                "id": 3218,
                "name": "Montevideo",
                "iso2": "MO",
                "latitude": "-34.81815870",
                "longitude": "-56.21382560",
                "type": "department",
                "cities": [
                    {
                        "id": 153689,
                        "name": "Aires Puros",
                        "latitude": "-34.85200000",
                        "longitude": "-56.18300000"
                    },
                    {
                        "id": 153690,
                        "name": "Arroyo Seco",
                        "latitude": "-34.80400000",
                        "longitude": "-56.27700000"
                    },
                    {
                        "id": 153691,
                        "name": "Atahualpa",
                        "latitude": "-34.80900000",
                        "longitude": "-56.23000000"
                    },
                    {
                        "id": 153692,
                        "name": "Bañados de Carrasco",
                        "latitude": "-34.82100000",
                        "longitude": "-56.06700000"
                    },
                    {
                        "id": 153693,
                        "name": "Barra de Carrasco",
                        "latitude": "-34.88400000",
                        "longitude": "-56.04700000"
                    },
                    {
                        "id": 153694,
                        "name": "Barrio Sur",
                        "latitude": "-34.90800000",
                        "longitude": "-56.19400000"
                    },
                    {
                        "id": 153695,
                        "name": "Bella Italia",
                        "latitude": "-34.85600000",
                        "longitude": "-56.15500000"
                    },
                    {
                        "id": 149276,
                        "name": "Bella Vista",
                        "latitude": "-34.87527778",
                        "longitude": "-56.18666667"
                    },
                    {
                        "id": 149277,
                        "name": "Belvedere",
                        "latitude": "-34.85155556",
                        "longitude": "-56.21611111"
                    },
                    {
                        "id": 149278,
                        "name": "Buceo",
                        "latitude": "-34.90000000",
                        "longitude": "-56.13305556"
                    },
                    {
                        "id": 153696,
                        "name": "Capurro",
                        "latitude": "-34.90500000",
                        "longitude": "-56.21700000"
                    },
                    {
                        "id": 149280,
                        "name": "Carrasco",
                        "latitude": "-34.88333333",
                        "longitude": "-56.06666667"
                    },
                    {
                        "id": 153697,
                        "name": "Carrasco Norte",
                        "latitude": "-34.86800000",
                        "longitude": "-56.04300000"
                    },
                    {
                        "id": 149281,
                        "name": "Casabó",
                        "latitude": "-34.86388889",
                        "longitude": "-56.34111111"
                    },
                    {
                        "id": 153698,
                        "name": "Casavalle",
                        "latitude": "-34.84300000",
                        "longitude": "-56.20300000"
                    },
                    {
                        "id": 149282,
                        "name": "Centro",
                        "latitude": "-34.90361111",
                        "longitude": "-56.18833333"
                    },
                    {
                        "id": 153699,
                        "name": "Cerrito",
                        "latitude": "-34.81500000",
                        "longitude": "-56.22500000"
                    },
                    {
                        "id": 149307,
                        "name": "Cerro",
                        "latitude": "-34.88444444",
                        "longitude": "-56.25138889"
                    },
                    {
                        "id": 153700,
                        "name": "Ciudad Vieja",
                        "latitude": "-34.90800000",
                        "longitude": "-56.20400000"
                    },
                    {
                        "id": 153701,
                        "name": "Colón",
                        "latitude": "-34.86500000",
                        "longitude": "-56.18000000"
                    },
                    {
                        "id": 149286,
                        "name": "Conciliación",
                        "latitude": "-34.82361111",
                        "longitude": "-56.23194444"
                    },
                    {
                        "id": 149287,
                        "name": "Cordón",
                        "latitude": "-34.90000000",
                        "longitude": "-56.17858333"
                    },
                    {
                        "id": 149288,
                        "name": "Flor de Maroñas",
                        "latitude": "-34.85055556",
                        "longitude": "-56.12472222"
                    },
                    {
                        "id": 153702,
                        "name": "Goes",
                        "latitude": "-34.87500000",
                        "longitude": "-56.19200000"
                    },
                    {
                        "id": 149289,
                        "name": "Ituzaingó",
                        "latitude": "-34.84750000",
                        "longitude": "-56.14361111"
                    },
                    {
                        "id": 153703,
                        "name": "Jacinto Vera",
                        "latitude": "-34.88300000",
                        "longitude": "-56.16600000"
                    },
                    {
                        "id": 153704,
                        "name": "Jardines del Hipódromo",
                        "latitude": "-34.88100000",
                        "longitude": "-56.15300000"
                    },
                    {
                        "id": 153705,
                        "name": "La Blanqueada",
                        "latitude": "-34.89700000",
                        "longitude": "-56.18500000"
                    },
                    {
                        "id": 153706,
                        "name": "La Comercial",
                        "latitude": "-34.89400000",
                        "longitude": "-56.19700000"
                    },
                    {
                        "id": 153707,
                        "name": "La Figurita",
                        "latitude": "-34.88600000",
                        "longitude": "-56.20300000"
                    },
                    {
                        "id": 153708,
                        "name": "La Teja",
                        "latitude": "-34.86200000",
                        "longitude": "-56.23600000"
                    },
                    {
                        "id": 149290,
                        "name": "La Unión",
                        "latitude": "-34.87861111",
                        "longitude": "-56.13583333"
                    },
                    {
                        "id": 153709,
                        "name": "Larrañaga",
                        "latitude": "-34.86100000",
                        "longitude": "-56.16300000"
                    },
                    {
                        "id": 153710,
                        "name": "Las Acacias",
                        "latitude": "-34.85500000",
                        "longitude": "-56.17000000"
                    },
                    {
                        "id": 153711,
                        "name": "Lezica",
                        "latitude": "-34.84600000",
                        "longitude": "-56.22300000"
                    },
                    {
                        "id": 149291,
                        "name": "Malvín",
                        "latitude": "-34.89352778",
                        "longitude": "-56.09994444"
                    },
                    {
                        "id": 153712,
                        "name": "Malvín Norte",
                        "latitude": "-34.87800000",
                        "longitude": "-56.08300000"
                    },
                    {
                        "id": 149292,
                        "name": "Manga",
                        "latitude": "-34.80722222",
                        "longitude": "-56.13805556"
                    },
                    {
                        "id": 153713,
                        "name": "Marconi",
                        "latitude": "-34.86200000",
                        "longitude": "-56.14700000"
                    },
                    {
                        "id": 149293,
                        "name": "Maroñas",
                        "latitude": "-34.86338889",
                        "longitude": "-56.12963889"
                    },
                    {
                        "id": 153714,
                        "name": "Melilla",
                        "latitude": "-34.83700000",
                        "longitude": "-56.25900000"
                    },
                    {
                        "id": 153715,
                        "name": "Mercado Modelo",
                        "latitude": "-34.85600000",
                        "longitude": "-56.20200000"
                    },
                    {
                        "id": 129833,
                        "name": "Montevideo",
                        "latitude": "-34.90328000",
                        "longitude": "-56.18816000"
                    },
                    {
                        "id": 149294,
                        "name": "Nuevo París",
                        "latitude": "-34.83333333",
                        "longitude": "-56.25000000"
                    },
                    {
                        "id": 129838,
                        "name": "Pajas Blancas",
                        "latitude": "-34.80167000",
                        "longitude": "-56.33417000"
                    },
                    {
                        "id": 153716,
                        "name": "Palermo",
                        "latitude": "-34.90300000",
                        "longitude": "-56.18200000"
                    },
                    {
                        "id": 153717,
                        "name": "Parque Batlle",
                        "latitude": "-34.90000000",
                        "longitude": "-56.18000000"
                    },
                    {
                        "id": 153718,
                        "name": "Parque Rodó",
                        "latitude": "-34.90800000",
                        "longitude": "-56.17100000"
                    },
                    {
                        "id": 153719,
                        "name": "Paso de la Arena",
                        "latitude": "-34.86100000",
                        "longitude": "-56.23900000"
                    },
                    {
                        "id": 149295,
                        "name": "Paso Molino",
                        "latitude": "-34.85000000",
                        "longitude": "-56.21666667"
                    },
                    {
                        "id": 149296,
                        "name": "Peñarol",
                        "latitude": "-34.82519444",
                        "longitude": "-56.19916667"
                    },
                    {
                        "id": 153720,
                        "name": "Perez Castellanos",
                        "latitude": "-34.84300000",
                        "longitude": "-56.21300000"
                    },
                    {
                        "id": 149297,
                        "name": "Piedras Blancas",
                        "latitude": "-34.82361111",
                        "longitude": "-56.14027778"
                    },
                    {
                        "id": 149298,
                        "name": "Pocitos",
                        "latitude": "-34.90833333",
                        "longitude": "-56.15000000"
                    },
                    {
                        "id": 153721,
                        "name": "Prado",
                        "latitude": "-34.85600000",
                        "longitude": "-56.20400000"
                    },
                    {
                        "id": 149299,
                        "name": "Punta Carretas",
                        "latitude": "-34.92188889",
                        "longitude": "-56.15944444"
                    },
                    {
                        "id": 153723,
                        "name": "Punta de Rieles",
                        "latitude": "-34.84700000",
                        "longitude": "-56.25200000"
                    },
                    {
                        "id": 153722,
                        "name": "Punta Espinillo",
                        "latitude": "-34.83500000",
                        "longitude": "-56.28600000"
                    },
                    {
                        "id": 149300,
                        "name": "Punta Gorda",
                        "latitude": "-34.88647222",
                        "longitude": "-56.08983333"
                    },
                    {
                        "id": 149301,
                        "name": "Reducto",
                        "latitude": "-34.87831944",
                        "longitude": "-56.18957778"
                    },
                    {
                        "id": 129871,
                        "name": "Santiago Vázquez",
                        "latitude": "-34.79028000",
                        "longitude": "-56.35000000"
                    },
                    {
                        "id": 149302,
                        "name": "Sayago",
                        "latitude": "-34.83583333",
                        "longitude": "-56.21250000"
                    },
                    {
                        "id": 149303,
                        "name": "Tres Cruces",
                        "latitude": "-34.89583333",
                        "longitude": "-56.16805556"
                    },
                    {
                        "id": 153724,
                        "name": "Tres Ombues",
                        "latitude": "-34.76600000",
                        "longitude": "-56.33000000"
                    },
                    {
                        "id": 149304,
                        "name": "Villa Española",
                        "latitude": "-34.86388889",
                        "longitude": "-56.14472222"
                    },
                    {
                        "id": 149305,
                        "name": "Villa García",
                        "latitude": "-34.78111000",
                        "longitude": "-56.05333000"
                    },
                    {
                        "id": 149306,
                        "name": "Villa Muñoz",
                        "latitude": "-34.88781389",
                        "longitude": "-56.17701389"
                    }
                ]
            },
            {
                "id": 3212,
                "name": "Paysandú",
                "iso2": "PA",
                "latitude": "-32.06673660",
                "longitude": "-57.33647890",
                "type": "department",
                "cities": [
                    {
                        "id": 129803,
                        "name": "Estación Porvenir",
                        "latitude": "-32.37085000",
                        "longitude": "-57.85371000"
                    },
                    {
                        "id": 129807,
                        "name": "Guichón",
                        "latitude": "-32.35846000",
                        "longitude": "-57.19778000"
                    },
                    {
                        "id": 129844,
                        "name": "Paysandú",
                        "latitude": "-32.31710000",
                        "longitude": "-58.08072000"
                    },
                    {
                        "id": 129845,
                        "name": "Piedras Coloradas",
                        "latitude": "-32.37183000",
                        "longitude": "-57.60901000"
                    },
                    {
                        "id": 129850,
                        "name": "Quebracho",
                        "latitude": "-31.93526000",
                        "longitude": "-57.90140000"
                    },
                    {
                        "id": 129861,
                        "name": "San Félix",
                        "latitude": "-32.34631000",
                        "longitude": "-58.10094000"
                    }
                ]
            },
            {
                "id": 3210,
                "name": "Río Negro",
                "iso2": "RN",
                "latitude": "-32.76763560",
                "longitude": "-57.42952070",
                "type": "department",
                "cities": [
                    {
                        "id": 129806,
                        "name": "Fray Bentos",
                        "latitude": "-33.11651000",
                        "longitude": "-58.31067000"
                    },
                    {
                        "id": 129836,
                        "name": "Nuevo Berlín",
                        "latitude": "-32.97974000",
                        "longitude": "-58.05858000"
                    },
                    {
                        "id": 129863,
                        "name": "San Javier",
                        "latitude": "-32.66523000",
                        "longitude": "-58.13320000"
                    },
                    {
                        "id": 129893,
                        "name": "Young",
                        "latitude": "-32.69844000",
                        "longitude": "-57.62693000"
                    }
                ]
            },
            {
                "id": 3207,
                "name": "Rivera",
                "iso2": "RV",
                "latitude": "-31.48174210",
                "longitude": "-55.24357590",
                "type": "department",
                "cities": [
                    {
                        "id": 129831,
                        "name": "Minas de Corrales",
                        "latitude": "-31.57375000",
                        "longitude": "-55.47075000"
                    },
                    {
                        "id": 129852,
                        "name": "Rivera",
                        "latitude": "-30.90534000",
                        "longitude": "-55.55076000"
                    },
                    {
                        "id": 129882,
                        "name": "Tranqueras",
                        "latitude": "-31.20000000",
                        "longitude": "-55.75000000"
                    },
                    {
                        "id": 129888,
                        "name": "Vichadero",
                        "latitude": "-31.77794000",
                        "longitude": "-54.69183000"
                    }
                ]
            },
            {
                "id": 3216,
                "name": "Rocha",
                "iso2": "RO",
                "latitude": "-33.96900810",
                "longitude": "-54.02148500",
                "type": "department",
                "cities": [
                    {
                        "id": 129790,
                        "name": "Castillos",
                        "latitude": "-34.19871000",
                        "longitude": "-53.85919000"
                    },
                    {
                        "id": 129792,
                        "name": "Cebollatí",
                        "latitude": "-33.26703000",
                        "longitude": "-53.79425000"
                    },
                    {
                        "id": 129793,
                        "name": "Chui",
                        "latitude": "-33.69792000",
                        "longitude": "-53.45926000"
                    },
                    {
                        "id": 129798,
                        "name": "Dieciocho de Julio",
                        "latitude": "-33.68216000",
                        "longitude": "-53.55325000"
                    },
                    {
                        "id": 129816,
                        "name": "La Paloma",
                        "latitude": "-34.66268000",
                        "longitude": "-54.16452000"
                    },
                    {
                        "id": 129822,
                        "name": "Lascano",
                        "latitude": "-33.67235000",
                        "longitude": "-54.20650000"
                    },
                    {
                        "id": 129853,
                        "name": "Rocha",
                        "latitude": "-34.48333000",
                        "longitude": "-54.33333000"
                    },
                    {
                        "id": 129886,
                        "name": "Velázquez",
                        "latitude": "-34.03631000",
                        "longitude": "-54.28054000"
                    }
                ]
            },
            {
                "id": 3220,
                "name": "Salto",
                "iso2": "SA",
                "latitude": "-31.38802800",
                "longitude": "-57.96124550",
                "type": "department",
                "cities": [
                    {
                        "id": 129783,
                        "name": "Belén",
                        "latitude": "-30.78716000",
                        "longitude": "-57.77577000"
                    },
                    {
                        "id": 129857,
                        "name": "Salto",
                        "latitude": "-31.38333000",
                        "longitude": "-57.96667000"
                    },
                    {
                        "id": 129889,
                        "name": "Villa Constitución",
                        "latitude": "-31.06913000",
                        "longitude": "-57.84946000"
                    }
                ]
            },
            {
                "id": 3204,
                "name": "San José",
                "iso2": "SJ",
                "latitude": "37.34929680",
                "longitude": "-121.90560490",
                "type": "department",
                "cities": [
                    {
                        "id": 129797,
                        "name": "Delta del Tigre",
                        "latitude": "-34.76488000",
                        "longitude": "-56.36450000"
                    },
                    {
                        "id": 129801,
                        "name": "Ecilda Paullier",
                        "latitude": "-34.35778000",
                        "longitude": "-57.04883000"
                    },
                    {
                        "id": 129823,
                        "name": "Libertad",
                        "latitude": "-34.63459000",
                        "longitude": "-56.61739000"
                    },
                    {
                        "id": 129849,
                        "name": "Puntas de Valdéz",
                        "latitude": "-34.58550000",
                        "longitude": "-56.70097000"
                    },
                    {
                        "id": 129851,
                        "name": "Rafael Perazza",
                        "latitude": "-34.52335000",
                        "longitude": "-56.79710000"
                    },
                    {
                        "id": 129854,
                        "name": "Rodríguez",
                        "latitude": "-34.38100000",
                        "longitude": "-56.53797000"
                    },
                    {
                        "id": 129864,
                        "name": "San José de Mayo",
                        "latitude": "-34.33750000",
                        "longitude": "-56.71361000"
                    }
                ]
            },
            {
                "id": 3219,
                "name": "Soriano",
                "iso2": "SO",
                "latitude": "-33.51027920",
                "longitude": "-57.74981030",
                "type": "department",
                "cities": [
                    {
                        "id": 129787,
                        "name": "Cardona",
                        "latitude": "-33.87049000",
                        "longitude": "-57.36954000"
                    },
                    {
                        "id": 129799,
                        "name": "Dolores",
                        "latitude": "-33.53009000",
                        "longitude": "-58.21701000"
                    },
                    {
                        "id": 129811,
                        "name": "José Enrique Rodó",
                        "latitude": "-33.69618000",
                        "longitude": "-57.53153000"
                    },
                    {
                        "id": 129828,
                        "name": "Mercedes",
                        "latitude": "-33.25240000",
                        "longitude": "-58.03047000"
                    },
                    {
                        "id": 129839,
                        "name": "Palmitas",
                        "latitude": "-33.50719000",
                        "longitude": "-57.80079000"
                    },
                    {
                        "id": 129867,
                        "name": "Santa Catalina",
                        "latitude": "-33.79100000",
                        "longitude": "-57.48824000"
                    },
                    {
                        "id": 129891,
                        "name": "Villa Soriano",
                        "latitude": "-33.39811000",
                        "longitude": "-58.32177000"
                    }
                ]
            },
            {
                "id": 3221,
                "name": "Tacuarembó",
                "iso2": "TA",
                "latitude": "-31.72068370",
                "longitude": "-55.98598870",
                "type": "department",
                "cities": [
                    {
                        "id": 129796,
                        "name": "Curtina",
                        "latitude": "-32.15000000",
                        "longitude": "-56.11667000"
                    },
                    {
                        "id": 129843,
                        "name": "Paso de los Toros",
                        "latitude": "-32.81667000",
                        "longitude": "-56.51667000"
                    },
                    {
                        "id": 129877,
                        "name": "Tacuarembó",
                        "latitude": "-31.71694000",
                        "longitude": "-55.98111000"
                    }
                ]
            },
            {
                "id": 3214,
                "name": "Treinta y Tres",
                "iso2": "TT",
                "latitude": "-33.06850860",
                "longitude": "-54.28586270",
                "type": "department",
                "cities": [
                    {
                        "id": 129868,
                        "name": "Santa Clara de Olimar",
                        "latitude": "-32.92254000",
                        "longitude": "-54.94447000"
                    },
                    {
                        "id": 129883,
                        "name": "Treinta y Tres",
                        "latitude": "-33.23333000",
                        "longitude": "-54.38333000"
                    },
                    {
                        "id": 129887,
                        "name": "Vergara",
                        "latitude": "-32.94419000",
                        "longitude": "-53.93810000"
                    },
                    {
                        "id": 129890,
                        "name": "Villa Sara",
                        "latitude": "-33.25340000",
                        "longitude": "-54.41947000"
                    }
                ]
            }
        ]
    },
    {
        "id": 236,
        "name": "Uzbekistan",
        "iso3": "UZB",
        "iso2": "UZ",
        "numeric_code": "860",
        "phonecode": "998",
        "capital": "Tashkent",
        "currency": "UZS",
        "currency_name": "Uzbekistani soʻm",
        "currency_symbol": "лв",
        "tld": ".uz",
        "native": "O‘zbekiston",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Central Asia",
        "subregion_id": 10,
        "nationality": "Uzbekistani, Uzbek",
        "timezones": [
            {
                "zoneName": "Asia\/Samarkand",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "UZT",
                "tzName": "Uzbekistan Time"
            },
            {
                "zoneName": "Asia\/Tashkent",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "UZT",
                "tzName": "Uzbekistan Time"
            }
        ],
        "translations": {
            "br": "Ouzbekistan",
            "ko": "우즈베키스탄",
            "pt-BR": "Uzbequistão",
            "pt": "Usbequistão",
            "nl": "Oezbekistan",
            "hr": "Uzbekistan",
            "fa": "ازبکستان",
            "de": "Usbekistan",
            "es": "Uzbekistán",
            "fr": "Ouzbékistan",
            "ja": "ウズベキスタン",
            "it": "Uzbekistan",
            "zh-CN": "乌兹别克斯坦",
            "tr": "Özbekistan",
            "ru": "Узбекистан",
            "uk": "Узбекистан",
            "pl": "Uzbekistan"
        },
        "latitude": "41.00000000",
        "longitude": "64.00000000",
        "emoji": "🇺🇿",
        "emojiU": "U+1F1FA U+1F1FF",
        "states": [
            {
                "id": 2540,
                "name": "Andijan",
                "iso2": "AN",
                "latitude": "40.76859410",
                "longitude": "72.23637900",
                "type": "region",
                "cities": [
                    {
                        "id": 129894,
                        "name": "Andijon",
                        "latitude": "40.78206000",
                        "longitude": "72.34424000"
                    },
                    {
                        "id": 129895,
                        "name": "Andijon Tumani",
                        "latitude": "40.80000000",
                        "longitude": "72.41667000"
                    },
                    {
                        "id": 129897,
                        "name": "Asaka",
                        "latitude": "40.64153000",
                        "longitude": "72.23868000"
                    },
                    {
                        "id": 129898,
                        "name": "Asaka Tumani",
                        "latitude": "40.66667000",
                        "longitude": "72.25000000"
                    },
                    {
                        "id": 129899,
                        "name": "Baliqchi Tumani",
                        "latitude": "40.86667000",
                        "longitude": "72.00000000"
                    },
                    {
                        "id": 129908,
                        "name": "Bo‘z Tumani",
                        "latitude": "40.66667000",
                        "longitude": "71.91667000"
                    },
                    {
                        "id": 129910,
                        "name": "Buloqboshi Tumani",
                        "latitude": "40.61667000",
                        "longitude": "72.46667000"
                    },
                    {
                        "id": 129937,
                        "name": "Izboskan Tumani",
                        "latitude": "40.91667000",
                        "longitude": "72.25000000"
                    },
                    {
                        "id": 129938,
                        "name": "Jalolkuduk Tumani",
                        "latitude": "40.75000000",
                        "longitude": "72.66667000"
                    },
                    {
                        "id": 129946,
                        "name": "Khŭjaobod Tumani",
                        "latitude": "40.66667000",
                        "longitude": "72.58333000"
                    },
                    {
                        "id": 129956,
                        "name": "Marhamat",
                        "latitude": "40.48048000",
                        "longitude": "72.31388000"
                    },
                    {
                        "id": 129957,
                        "name": "Marhamat Tumani",
                        "latitude": "40.50000000",
                        "longitude": "72.31667000"
                    },
                    {
                        "id": 129971,
                        "name": "Oltinkŭl Tumani",
                        "latitude": "40.80000000",
                        "longitude": "72.16667000"
                    },
                    {
                        "id": 129973,
                        "name": "Pakhtaobod Tumani",
                        "latitude": "40.93333000",
                        "longitude": "72.50000000"
                    },
                    {
                        "id": 129976,
                        "name": "Paxtaobod",
                        "latitude": "40.92936000",
                        "longitude": "72.49687000"
                    },
                    {
                        "id": 129987,
                        "name": "Qo‘rg‘ontepa",
                        "latitude": "40.73192000",
                        "longitude": "72.76177000"
                    },
                    {
                        "id": 129990,
                        "name": "Qŭrghontepa Tumani",
                        "latitude": "40.75000000",
                        "longitude": "72.83333000"
                    },
                    {
                        "id": 129996,
                        "name": "Shahrikhon Tumani",
                        "latitude": "40.71667000",
                        "longitude": "72.06667000"
                    },
                    {
                        "id": 129998,
                        "name": "Shahrixon",
                        "latitude": "40.71331000",
                        "longitude": "72.05706000"
                    },
                    {
                        "id": 130012,
                        "name": "Ulug‘nor Tumani",
                        "latitude": "40.75000000",
                        "longitude": "71.70000000"
                    },
                    {
                        "id": 130018,
                        "name": "Xo‘jaobod",
                        "latitude": "40.66886000",
                        "longitude": "72.56002000"
                    }
                ]
            },
            {
                "id": 2541,
                "name": "Bukhara",
                "iso2": "BU",
                "latitude": "40.25041620",
                "longitude": "63.20321510",
                "type": "region",
                "cities": [
                    {
                        "id": 129909,
                        "name": "Bukhara",
                        "latitude": "39.77472000",
                        "longitude": "64.42861000"
                    },
                    {
                        "id": 129925,
                        "name": "Galaosiyo",
                        "latitude": "39.85778000",
                        "longitude": "64.44833000"
                    },
                    {
                        "id": 129926,
                        "name": "Gazli",
                        "latitude": "40.13333000",
                        "longitude": "63.45000000"
                    },
                    {
                        "id": 129927,
                        "name": "Ghijduwon",
                        "latitude": "40.10000000",
                        "longitude": "64.68333000"
                    },
                    {
                        "id": 129942,
                        "name": "Karakul’",
                        "latitude": "39.53333000",
                        "longitude": "63.83333000"
                    },
                    {
                        "id": 129950,
                        "name": "Kogon",
                        "latitude": "39.72278000",
                        "longitude": "64.55167000"
                    },
                    {
                        "id": 129968,
                        "name": "Olot",
                        "latitude": "39.41500000",
                        "longitude": "63.80333000"
                    },
                    {
                        "id": 129978,
                        "name": "Peshku Tumani",
                        "latitude": "40.41667000",
                        "longitude": "63.83333000"
                    },
                    {
                        "id": 129984,
                        "name": "Qorako’l",
                        "latitude": "39.49944000",
                        "longitude": "63.85389000"
                    },
                    {
                        "id": 129985,
                        "name": "Qorovulbozor",
                        "latitude": "39.50056000",
                        "longitude": "64.79361000"
                    },
                    {
                        "id": 129993,
                        "name": "Romiton",
                        "latitude": "39.92944000",
                        "longitude": "64.37944000"
                    },
                    {
                        "id": 129999,
                        "name": "Shofirkon",
                        "latitude": "40.12000000",
                        "longitude": "64.50139000"
                    },
                    {
                        "id": 130016,
                        "name": "Wobkent",
                        "latitude": "40.03028000",
                        "longitude": "64.51500000"
                    },
                    {
                        "id": 130017,
                        "name": "Wobkent Tumani",
                        "latitude": "40.00000000",
                        "longitude": "64.50000000"
                    }
                ]
            },
            {
                "id": 2538,
                "name": "Fergana",
                "iso2": "FA",
                "latitude": "40.45680810",
                "longitude": "71.28742090",
                "type": "region",
                "cities": [
                    {
                        "id": 129903,
                        "name": "Beshariq",
                        "latitude": "40.43583000",
                        "longitude": "70.61028000"
                    },
                    {
                        "id": 129923,
                        "name": "Fergana",
                        "latitude": "40.38421000",
                        "longitude": "71.78432000"
                    },
                    {
                        "id": 129932,
                        "name": "Hamza",
                        "latitude": "40.42762000",
                        "longitude": "71.50534000"
                    },
                    {
                        "id": 129948,
                        "name": "Kirguli",
                        "latitude": "40.43553000",
                        "longitude": "71.76721000"
                    },
                    {
                        "id": 129955,
                        "name": "Marg‘ilon",
                        "latitude": "40.47237000",
                        "longitude": "71.72463000"
                    },
                    {
                        "id": 129969,
                        "name": "Oltiariq",
                        "latitude": "40.39194000",
                        "longitude": "71.47417000"
                    },
                    {
                        "id": 129986,
                        "name": "Qo‘qon",
                        "latitude": "40.52861000",
                        "longitude": "70.94250000"
                    },
                    {
                        "id": 129988,
                        "name": "Quva",
                        "latitude": "40.52204000",
                        "longitude": "72.07292000"
                    },
                    {
                        "id": 129989,
                        "name": "Quvasoy",
                        "latitude": "40.29721000",
                        "longitude": "71.98026000"
                    },
                    {
                        "id": 129992,
                        "name": "Rishton",
                        "latitude": "40.35667000",
                        "longitude": "71.28472000"
                    },
                    {
                        "id": 130000,
                        "name": "Shohimardon",
                        "latitude": "39.98322000",
                        "longitude": "71.80512000"
                    },
                    {
                        "id": 130004,
                        "name": "So‘x Tumani",
                        "latitude": "40.04417000",
                        "longitude": "71.09417000"
                    },
                    {
                        "id": 130008,
                        "name": "Toshloq",
                        "latitude": "40.47722000",
                        "longitude": "71.76778000"
                    },
                    {
                        "id": 130019,
                        "name": "Yangi Marg‘ilon",
                        "latitude": "40.42722000",
                        "longitude": "71.71889000"
                    },
                    {
                        "id": 130025,
                        "name": "Yaypan",
                        "latitude": "40.37583000",
                        "longitude": "70.81556000"
                    }
                ]
            },
            {
                "id": 2545,
                "name": "Jizzakh",
                "iso2": "JI",
                "latitude": "40.47064150",
                "longitude": "67.57085360",
                "type": "region",
                "cities": [
                    {
                        "id": 129919,
                        "name": "Dashtobod",
                        "latitude": "40.12694000",
                        "longitude": "68.49444000"
                    },
                    {
                        "id": 129922,
                        "name": "Dŭstlik",
                        "latitude": "40.52472000",
                        "longitude": "68.03583000"
                    },
                    {
                        "id": 129924,
                        "name": "Gagarin",
                        "latitude": "40.66194000",
                        "longitude": "68.17222000"
                    },
                    {
                        "id": 129939,
                        "name": "Jizzax",
                        "latitude": "40.11583000",
                        "longitude": "67.84222000"
                    },
                    {
                        "id": 129975,
                        "name": "Paxtakor",
                        "latitude": "40.31528000",
                        "longitude": "67.95444000"
                    },
                    {
                        "id": 130027,
                        "name": "Zomin",
                        "latitude": "39.96056000",
                        "longitude": "68.39583000"
                    }
                ]
            },
            {
                "id": 2548,
                "name": "Karakalpakstan",
                "iso2": "QR",
                "latitude": "43.80413340",
                "longitude": "59.44579880",
                "type": "republic",
                "cities": [
                    {
                        "id": 129902,
                        "name": "Beruniy",
                        "latitude": "41.69111000",
                        "longitude": "60.75250000"
                    },
                    {
                        "id": 129944,
                        "name": "Kegeyli Shahar",
                        "latitude": "42.77667000",
                        "longitude": "59.60778000"
                    },
                    {
                        "id": 129947,
                        "name": "Khŭjayli",
                        "latitude": "42.40043000",
                        "longitude": "59.46005000"
                    },
                    {
                        "id": 129954,
                        "name": "Manghit",
                        "latitude": "42.11556000",
                        "longitude": "60.05972000"
                    },
                    {
                        "id": 129959,
                        "name": "Mŭynoq",
                        "latitude": "43.76833000",
                        "longitude": "59.02139000"
                    },
                    {
                        "id": 129963,
                        "name": "Novyy Turtkul’",
                        "latitude": "41.55000000",
                        "longitude": "61.01667000"
                    },
                    {
                        "id": 129964,
                        "name": "Nukus",
                        "latitude": "42.45306000",
                        "longitude": "59.61028000"
                    },
                    {
                        "id": 129970,
                        "name": "Oltinko‘l",
                        "latitude": "43.06874000",
                        "longitude": "58.90372000"
                    }
                ]
            },
            {
                "id": 2537,
                "name": "Namangan",
                "iso2": "NG",
                "latitude": "41.05100370",
                "longitude": "71.09731700",
                "type": "region",
                "cities": [
                    {
                        "id": 129917,
                        "name": "Chortoq",
                        "latitude": "41.06924000",
                        "longitude": "71.82372000"
                    },
                    {
                        "id": 129918,
                        "name": "Chust",
                        "latitude": "41.00329000",
                        "longitude": "71.23791000"
                    },
                    {
                        "id": 129933,
                        "name": "Haqqulobod",
                        "latitude": "40.91667000",
                        "longitude": "72.11667000"
                    },
                    {
                        "id": 129952,
                        "name": "Kosonsoy",
                        "latitude": "41.24944000",
                        "longitude": "71.54738000"
                    },
                    {
                        "id": 129960,
                        "name": "Namangan",
                        "latitude": "40.99830000",
                        "longitude": "71.67257000"
                    },
                    {
                        "id": 129980,
                        "name": "Pop",
                        "latitude": "40.87361000",
                        "longitude": "71.10889000"
                    },
                    {
                        "id": 130009,
                        "name": "To‘rqao‘rg‘on",
                        "latitude": "40.99984000",
                        "longitude": "71.51162000"
                    },
                    {
                        "id": 130007,
                        "name": "Toshbuloq",
                        "latitude": "40.91617000",
                        "longitude": "71.57819000"
                    },
                    {
                        "id": 130011,
                        "name": "Uchqŭrghon Shahri",
                        "latitude": "41.11371000",
                        "longitude": "72.07915000"
                    },
                    {
                        "id": 130015,
                        "name": "Uychi",
                        "latitude": "41.08073000",
                        "longitude": "71.92331000"
                    },
                    {
                        "id": 130021,
                        "name": "Yangiqo‘rg‘on",
                        "latitude": "41.19474000",
                        "longitude": "71.72385000"
                    }
                ]
            },
            {
                "id": 2542,
                "name": "Navoiy",
                "iso2": "NW",
                "latitude": "42.69885750",
                "longitude": "64.63376850",
                "type": "region",
                "cities": [
                    {
                        "id": 129961,
                        "name": "Navoiy",
                        "latitude": "40.08444000",
                        "longitude": "65.37917000"
                    },
                    {
                        "id": 129965,
                        "name": "Nurota",
                        "latitude": "40.56139000",
                        "longitude": "65.68861000"
                    },
                    {
                        "id": 129983,
                        "name": "Qiziltepa",
                        "latitude": "40.03306000",
                        "longitude": "64.85000000"
                    },
                    {
                        "id": 130022,
                        "name": "Yangirabot",
                        "latitude": "40.02539000",
                        "longitude": "65.96095000"
                    }
                ]
            },
            {
                "id": 2543,
                "name": "Qashqadaryo",
                "iso2": "QA",
                "latitude": "38.89862310",
                "longitude": "66.04635340",
                "type": "region",
                "cities": [
                    {
                        "id": 129904,
                        "name": "Beshkent",
                        "latitude": "38.82139000",
                        "longitude": "65.65306000"
                    },
                    {
                        "id": 129916,
                        "name": "Chiroqchi",
                        "latitude": "39.03361000",
                        "longitude": "66.57222000"
                    },
                    {
                        "id": 129931,
                        "name": "G‘uzor",
                        "latitude": "38.62083000",
                        "longitude": "66.24806000"
                    },
                    {
                        "id": 129949,
                        "name": "Kitob",
                        "latitude": "39.08425000",
                        "longitude": "66.83318000"
                    },
                    {
                        "id": 129951,
                        "name": "Koson",
                        "latitude": "39.03750000",
                        "longitude": "65.58500000"
                    },
                    {
                        "id": 129958,
                        "name": "Muborak",
                        "latitude": "39.25528000",
                        "longitude": "65.15278000"
                    },
                    {
                        "id": 129962,
                        "name": "Nishon Tumani",
                        "latitude": "38.69395000",
                        "longitude": "65.67512000"
                    },
                    {
                        "id": 129981,
                        "name": "Qarshi",
                        "latitude": "38.86056000",
                        "longitude": "65.78905000"
                    },
                    {
                        "id": 129997,
                        "name": "Shahrisabz",
                        "latitude": "39.05778000",
                        "longitude": "66.83417000"
                    }
                ]
            },
            {
                "id": 2544,
                "name": "Samarqand",
                "iso2": "SA",
                "latitude": "39.62701200",
                "longitude": "66.97497310",
                "type": "region",
                "cities": [
                    {
                        "id": 129911,
                        "name": "Bulung’ur",
                        "latitude": "39.76472000",
                        "longitude": "67.27139000"
                    },
                    {
                        "id": 129912,
                        "name": "Charxin",
                        "latitude": "39.69667000",
                        "longitude": "66.76861000"
                    },
                    {
                        "id": 129913,
                        "name": "Chelak",
                        "latitude": "39.92028000",
                        "longitude": "66.86111000"
                    },
                    {
                        "id": 129920,
                        "name": "Daxbet",
                        "latitude": "39.76389000",
                        "longitude": "66.91250000"
                    },
                    {
                        "id": 129935,
                        "name": "Ishtixon",
                        "latitude": "39.96639000",
                        "longitude": "66.48611000"
                    },
                    {
                        "id": 129940,
                        "name": "Jomboy",
                        "latitude": "39.69889000",
                        "longitude": "67.09333000"
                    },
                    {
                        "id": 129941,
                        "name": "Juma",
                        "latitude": "39.71611000",
                        "longitude": "66.66417000"
                    },
                    {
                        "id": 129943,
                        "name": "Kattaqo‘rg‘on",
                        "latitude": "39.89889000",
                        "longitude": "66.25611000"
                    },
                    {
                        "id": 129972,
                        "name": "Oqtosh",
                        "latitude": "39.92139000",
                        "longitude": "65.92528000"
                    },
                    {
                        "id": 129977,
                        "name": "Payshanba",
                        "latitude": "40.00778000",
                        "longitude": "66.23694000"
                    },
                    {
                        "id": 129995,
                        "name": "Samarkand",
                        "latitude": "39.65417000",
                        "longitude": "66.95972000"
                    },
                    {
                        "id": 130014,
                        "name": "Urgut",
                        "latitude": "39.40222000",
                        "longitude": "67.24306000"
                    }
                ]
            },
            {
                "id": 2547,
                "name": "Sirdaryo",
                "iso2": "SI",
                "latitude": "40.38638080",
                "longitude": "68.71549750",
                "type": "region",
                "cities": [
                    {
                        "id": 129928,
                        "name": "Guliston",
                        "latitude": "40.48972000",
                        "longitude": "68.78417000"
                    },
                    {
                        "id": 130003,
                        "name": "Sirdaryo",
                        "latitude": "40.84361000",
                        "longitude": "68.66167000"
                    },
                    {
                        "id": 130023,
                        "name": "Yangiyer",
                        "latitude": "40.27500000",
                        "longitude": "68.82250000"
                    }
                ]
            },
            {
                "id": 2546,
                "name": "Surxondaryo",
                "iso2": "SU",
                "latitude": "37.94090050",
                "longitude": "67.57085360",
                "type": "region",
                "cities": [
                    {
                        "id": 129906,
                        "name": "Boysun",
                        "latitude": "38.20835000",
                        "longitude": "67.20664000"
                    },
                    {
                        "id": 129921,
                        "name": "Denov",
                        "latitude": "38.26746000",
                        "longitude": "67.89886000"
                    },
                    {
                        "id": 130002,
                        "name": "Sho‘rchi",
                        "latitude": "37.99944000",
                        "longitude": "67.78750000"
                    },
                    {
                        "id": 130006,
                        "name": "Tirmiz",
                        "latitude": "37.22417000",
                        "longitude": "67.27833000"
                    }
                ]
            },
            {
                "id": 2536,
                "name": "Tashkent",
                "iso2": "TK",
                "latitude": "41.29949580",
                "longitude": "69.24007340",
                "type": "city",
                "cities": [
                    {
                        "id": 129901,
                        "name": "Bektemir",
                        "latitude": "41.20972000",
                        "longitude": "69.33417000"
                    },
                    {
                        "id": 130005,
                        "name": "Tashkent",
                        "latitude": "41.26465000",
                        "longitude": "69.21627000"
                    }
                ]
            },
            {
                "id": 2549,
                "name": "Tashkent",
                "iso2": "TO",
                "latitude": "41.22132340",
                "longitude": "69.85974060",
                "type": "region",
                "cities": [
                    {
                        "id": 129896,
                        "name": "Angren",
                        "latitude": "41.01667000",
                        "longitude": "70.14361000"
                    },
                    {
                        "id": 129900,
                        "name": "Bekobod",
                        "latitude": "40.22083000",
                        "longitude": "69.26972000"
                    },
                    {
                        "id": 129907,
                        "name": "Bo‘ka",
                        "latitude": "40.81108000",
                        "longitude": "69.19417000"
                    },
                    {
                        "id": 129914,
                        "name": "Chinoz",
                        "latitude": "40.93633000",
                        "longitude": "68.76128000"
                    },
                    {
                        "id": 129915,
                        "name": "Chirchiq",
                        "latitude": "41.46889000",
                        "longitude": "69.58222000"
                    },
                    {
                        "id": 129930,
                        "name": "G‘azalkent",
                        "latitude": "41.55806000",
                        "longitude": "69.77083000"
                    },
                    {
                        "id": 129936,
                        "name": "Iskandar",
                        "latitude": "41.55389000",
                        "longitude": "69.70083000"
                    },
                    {
                        "id": 129953,
                        "name": "Kyzyldzhar",
                        "latitude": "41.56667000",
                        "longitude": "70.01667000"
                    },
                    {
                        "id": 129966,
                        "name": "Ohangaron",
                        "latitude": "40.90639000",
                        "longitude": "69.63833000"
                    },
                    {
                        "id": 129967,
                        "name": "Olmaliq",
                        "latitude": "40.84472000",
                        "longitude": "69.59833000"
                    },
                    {
                        "id": 129974,
                        "name": "Parkent",
                        "latitude": "41.29444000",
                        "longitude": "69.67639000"
                    },
                    {
                        "id": 129979,
                        "name": "Piskent",
                        "latitude": "40.89722000",
                        "longitude": "69.35056000"
                    },
                    {
                        "id": 129982,
                        "name": "Qibray",
                        "latitude": "41.38972000",
                        "longitude": "69.46500000"
                    },
                    {
                        "id": 129994,
                        "name": "Salor",
                        "latitude": "41.37222000",
                        "longitude": "69.38167000"
                    },
                    {
                        "id": 130010,
                        "name": "Tŭytepa",
                        "latitude": "41.03210000",
                        "longitude": "69.36253000"
                    },
                    {
                        "id": 130028,
                        "name": "Ŭrtaowul",
                        "latitude": "41.18667000",
                        "longitude": "69.14528000"
                    },
                    {
                        "id": 130020,
                        "name": "Yangiobod",
                        "latitude": "41.11919000",
                        "longitude": "70.09406000"
                    },
                    {
                        "id": 130024,
                        "name": "Yangiyŭl",
                        "latitude": "41.11202000",
                        "longitude": "69.04710000"
                    },
                    {
                        "id": 130026,
                        "name": "Zafar",
                        "latitude": "40.98333000",
                        "longitude": "68.90000000"
                    }
                ]
            },
            {
                "id": 2539,
                "name": "Xorazm",
                "iso2": "XO",
                "latitude": "41.35653360",
                "longitude": "60.85666860",
                "type": "region",
                "cities": [
                    {
                        "id": 129905,
                        "name": "Boghot Tumani",
                        "latitude": "41.31495000",
                        "longitude": "60.85327000"
                    },
                    {
                        "id": 129929,
                        "name": "Gurlan",
                        "latitude": "41.84472000",
                        "longitude": "60.39194000"
                    },
                    {
                        "id": 129934,
                        "name": "Hazorasp",
                        "latitude": "41.31944000",
                        "longitude": "61.07417000"
                    },
                    {
                        "id": 129945,
                        "name": "Khiwa",
                        "latitude": "41.37833000",
                        "longitude": "60.36389000"
                    },
                    {
                        "id": 129991,
                        "name": "Qŭshkŭpir",
                        "latitude": "41.53500000",
                        "longitude": "60.34556000"
                    },
                    {
                        "id": 130001,
                        "name": "Showot",
                        "latitude": "41.65583000",
                        "longitude": "60.30250000"
                    },
                    {
                        "id": 130013,
                        "name": "Urganch",
                        "latitude": "41.55000000",
                        "longitude": "60.63333000"
                    }
                ]
            }
        ]
    },
    {
        "id": 237,
        "name": "Vanuatu",
        "iso3": "VUT",
        "iso2": "VU",
        "numeric_code": "548",
        "phonecode": "678",
        "capital": "Port Vila",
        "currency": "VUV",
        "currency_name": "Vanuatu vatu",
        "currency_symbol": "VT",
        "tld": ".vu",
        "native": "Vanuatu",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Melanesia",
        "subregion_id": 20,
        "nationality": "Ni-Vanuatu, Vanuatuan",
        "timezones": [
            {
                "zoneName": "Pacific\/Efate",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "VUT",
                "tzName": "Vanuatu Time"
            }
        ],
        "translations": {
            "br": "Vanuatu",
            "ko": "바누아투",
            "pt-BR": "Vanuatu",
            "pt": "Vanuatu",
            "nl": "Vanuatu",
            "hr": "Vanuatu",
            "fa": "وانواتو",
            "de": "Vanuatu",
            "es": "Vanuatu",
            "fr": "Vanuatu",
            "ja": "バヌアツ",
            "it": "Vanuatu",
            "zh-CN": "瓦努阿图",
            "tr": "Vanuatu",
            "ru": "Вануату",
            "uk": "Вануату",
            "pl": "Vanuatu"
        },
        "latitude": "-16.00000000",
        "longitude": "167.00000000",
        "emoji": "🇻🇺",
        "emojiU": "U+1F1FB U+1F1FA",
        "states": [
            {
                "id": 4775,
                "name": "Malampa",
                "iso2": "MAP",
                "latitude": "-16.40114050",
                "longitude": "167.60778650",
                "type": "province",
                "cities": [
                    {
                        "id": 130637,
                        "name": "Lakatoro",
                        "latitude": "-16.09992000",
                        "longitude": "167.41636000"
                    },
                    {
                        "id": 130639,
                        "name": "Norsup",
                        "latitude": "-16.06536000",
                        "longitude": "167.39714000"
                    }
                ]
            },
            {
                "id": 4773,
                "name": "Penama",
                "iso2": "PAM",
                "latitude": "-15.37957580",
                "longitude": "167.90531820",
                "type": "province",
                "cities": []
            },
            {
                "id": 4776,
                "name": "Sanma",
                "iso2": "SAM",
                "latitude": "-15.48400170",
                "longitude": "166.91820970",
                "type": "province",
                "cities": [
                    {
                        "id": 130638,
                        "name": "Luganville",
                        "latitude": "-15.51989000",
                        "longitude": "167.16235000"
                    },
                    {
                        "id": 130640,
                        "name": "Port-Olry",
                        "latitude": "-15.04175000",
                        "longitude": "167.07265000"
                    }
                ]
            },
            {
                "id": 4774,
                "name": "Shefa",
                "iso2": "SEE",
                "latitude": "32.80576500",
                "longitude": "35.16997100",
                "type": "province",
                "cities": [
                    {
                        "id": 130641,
                        "name": "Port-Vila",
                        "latitude": "-17.73648000",
                        "longitude": "168.31366000"
                    }
                ]
            },
            {
                "id": 4777,
                "name": "Tafea",
                "iso2": "TAE",
                "latitude": "-18.72378270",
                "longitude": "169.06450560",
                "type": "province",
                "cities": [
                    {
                        "id": 130636,
                        "name": "Isangel",
                        "latitude": "-19.54167000",
                        "longitude": "169.28167000"
                    }
                ]
            },
            {
                "id": 4772,
                "name": "Torba",
                "iso2": "TOB",
                "latitude": "37.07653000",
                "longitude": "27.45657300",
                "type": "province",
                "cities": [
                    {
                        "id": 130642,
                        "name": "Sola",
                        "latitude": "-13.87611000",
                        "longitude": "167.55167000"
                    }
                ]
            }
        ]
    },
    {
        "id": 238,
        "name": "Vatican City State (Holy See)",
        "iso3": "VAT",
        "iso2": "VA",
        "numeric_code": "336",
        "phonecode": "379",
        "capital": "Vatican City",
        "currency": "EUR",
        "currency_name": "Euro",
        "currency_symbol": "€",
        "tld": ".va",
        "native": "Vaticano",
        "region": "Europe",
        "region_id": 4,
        "subregion": "Southern Europe",
        "subregion_id": 16,
        "nationality": "Vatican",
        "timezones": [
            {
                "zoneName": "Europe\/Vatican",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "br": "Vatikan",
            "ko": "바티칸 시국",
            "pt-BR": "Vaticano",
            "pt": "Vaticano",
            "nl": "Heilige Stoel",
            "hr": "Sveta Stolica",
            "fa": "سریر مقدس",
            "de": "Heiliger Stuhl",
            "es": "Santa Sede",
            "fr": "voir Saint",
            "ja": "聖座",
            "it": "Santa Sede",
            "zh-CN": "梵蒂冈",
            "tr": "Vatikan",
            "ru": "Город-государство Ватикан (Святой Престол)",
            "uk": "Держава-місто Ватикан (Святий Престол)",
            "pl": "Państwo Watykańskie (Stolica Apostolska)"
        },
        "latitude": "41.90000000",
        "longitude": "12.45000000",
        "emoji": "🇻🇦",
        "emojiU": "U+1F1FB U+1F1E6",
        "states": []
    },
    {
        "id": 239,
        "name": "Venezuela",
        "iso3": "VEN",
        "iso2": "VE",
        "numeric_code": "862",
        "phonecode": "58",
        "capital": "Caracas",
        "currency": "VES",
        "currency_name": "Bolívar",
        "currency_symbol": "Bs",
        "tld": ".ve",
        "native": "Venezuela",
        "region": "Americas",
        "region_id": 2,
        "subregion": "South America",
        "subregion_id": 8,
        "nationality": "Venezuelan",
        "timezones": [
            {
                "zoneName": "America\/Caracas",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "VET",
                "tzName": "Venezuelan Standard Time"
            }
        ],
        "translations": {
            "br": "Venezuela",
            "ko": "베네수엘라",
            "pt-BR": "Venezuela",
            "pt": "Venezuela",
            "nl": "Venezuela",
            "hr": "Venezuela",
            "fa": "ونزوئلا",
            "de": "Venezuela",
            "es": "Venezuela",
            "fr": "Venezuela",
            "ja": "ベネズエラ・ボリバル共和国",
            "it": "Venezuela",
            "zh-CN": "委内瑞拉",
            "tr": "Venezuela",
            "ru": "Венесуэла",
            "uk": "Венесуела",
            "pl": "Wenezuela"
        },
        "latitude": "8.00000000",
        "longitude": "-66.00000000",
        "emoji": "🇻🇪",
        "emojiU": "U+1F1FB U+1F1EA",
        "states": [
            {
                "id": 2044,
                "name": "Amazonas",
                "iso2": "Z",
                "latitude": "-3.41684270",
                "longitude": "-65.85606460",
                "type": "state",
                "cities": [
                    {
                        "id": 130106,
                        "name": "Maroa",
                        "latitude": "2.71880000",
                        "longitude": "-67.56046000"
                    },
                    {
                        "id": 130110,
                        "name": "Municipio Autónomo Alto Orinoco",
                        "latitude": "2.73456000",
                        "longitude": "-64.83032000"
                    },
                    {
                        "id": 130131,
                        "name": "Puerto Ayacucho",
                        "latitude": "5.66049000",
                        "longitude": "-67.58343000"
                    },
                    {
                        "id": 130142,
                        "name": "San Carlos de Río Negro",
                        "latitude": "1.92027000",
                        "longitude": "-67.06089000"
                    },
                    {
                        "id": 130146,
                        "name": "San Fernando de Atabapo",
                        "latitude": "4.04564000",
                        "longitude": "-67.69934000"
                    },
                    {
                        "id": 130149,
                        "name": "San Juan de Manapiare",
                        "latitude": "5.32665000",
                        "longitude": "-66.05402000"
                    }
                ]
            },
            {
                "id": 2050,
                "name": "Anzoátegui",
                "iso2": "B",
                "latitude": "8.59130730",
                "longitude": "-63.95861110",
                "type": "state",
                "cities": [
                    {
                        "id": 130041,
                        "name": "Anaco",
                        "latitude": "9.42958000",
                        "longitude": "-64.46428000"
                    },
                    {
                        "id": 130042,
                        "name": "Aragua de Barcelona",
                        "latitude": "9.45588000",
                        "longitude": "-64.82928000"
                    },
                    {
                        "id": 130044,
                        "name": "Barcelona",
                        "latitude": "10.13625000",
                        "longitude": "-64.68618000"
                    },
                    {
                        "id": 130054,
                        "name": "Cantaura",
                        "latitude": "9.30571000",
                        "longitude": "-64.35841000"
                    },
                    {
                        "id": 130078,
                        "name": "El Tigre",
                        "latitude": "8.88902000",
                        "longitude": "-64.25270000"
                    },
                    {
                        "id": 130113,
                        "name": "Municipio José Gregorio Monagas",
                        "latitude": "7.73874000",
                        "longitude": "-64.71876000"
                    },
                    {
                        "id": 130127,
                        "name": "Onoto",
                        "latitude": "9.59714000",
                        "longitude": "-65.19350000"
                    },
                    {
                        "id": 130133,
                        "name": "Puerto La Cruz",
                        "latitude": "10.21382000",
                        "longitude": "-64.63280000"
                    },
                    {
                        "id": 130134,
                        "name": "Puerto Píritu",
                        "latitude": "10.05896000",
                        "longitude": "-65.03698000"
                    },
                    {
                        "id": 130148,
                        "name": "San José de Guanipa",
                        "latitude": "8.88724000",
                        "longitude": "-64.16512000"
                    }
                ]
            },
            {
                "id": 4856,
                "name": "Apure",
                "iso2": "C",
                "latitude": "6.92694830",
                "longitude": "-68.52471490",
                "type": "state",
                "cities": [
                    {
                        "id": 153351,
                        "name": "San Fernando de Apure",
                        "latitude": "7.87266930",
                        "longitude": "-67.48193280"
                    }
                ]
            },
            {
                "id": 2047,
                "name": "Aragua",
                "iso2": "D",
                "latitude": "10.06357580",
                "longitude": "-67.28478750",
                "type": "state",
                "cities": [
                    {
                        "id": 130052,
                        "name": "Cagua",
                        "latitude": "10.18634000",
                        "longitude": "-67.45935000"
                    },
                    {
                        "id": 130077,
                        "name": "El Limón",
                        "latitude": "10.30589000",
                        "longitude": "-67.63212000"
                    },
                    {
                        "id": 130093,
                        "name": "La Victoria",
                        "latitude": "10.22677000",
                        "longitude": "-67.33122000"
                    },
                    {
                        "id": 130096,
                        "name": "Las Tejerías",
                        "latitude": "10.25416000",
                        "longitude": "-67.17333000"
                    },
                    {
                        "id": 130104,
                        "name": "Maracay",
                        "latitude": "10.23535000",
                        "longitude": "-67.59113000"
                    },
                    {
                        "id": 130128,
                        "name": "Palo Negro",
                        "latitude": "10.17389000",
                        "longitude": "-67.54194000"
                    },
                    {
                        "id": 130151,
                        "name": "San Mateo",
                        "latitude": "10.21302000",
                        "longitude": "-67.42365000"
                    },
                    {
                        "id": 130153,
                        "name": "Santa Rita",
                        "latitude": "10.20540000",
                        "longitude": "-67.55948000"
                    },
                    {
                        "id": 130162,
                        "name": "Turmero",
                        "latitude": "10.22856000",
                        "longitude": "-67.47421000"
                    },
                    {
                        "id": 130169,
                        "name": "Villa de Cura",
                        "latitude": "10.03863000",
                        "longitude": "-67.48938000"
                    }
                ]
            },
            {
                "id": 2049,
                "name": "Barinas",
                "iso2": "E",
                "latitude": "8.62314980",
                "longitude": "-70.23710450",
                "type": "state",
                "cities": [
                    {
                        "id": 130040,
                        "name": "Alto Barinas",
                        "latitude": "8.59310000",
                        "longitude": "-70.22610000"
                    },
                    {
                        "id": 130045,
                        "name": "Barinas",
                        "latitude": "8.62261000",
                        "longitude": "-70.20749000"
                    },
                    {
                        "id": 130046,
                        "name": "Barinitas",
                        "latitude": "8.76171000",
                        "longitude": "-70.41199000"
                    },
                    {
                        "id": 130111,
                        "name": "Municipio Barinas",
                        "latitude": "8.61497000",
                        "longitude": "-70.19852000"
                    }
                ]
            },
            {
                "id": 2039,
                "name": "Bolívar",
                "iso2": "F",
                "latitude": "37.61448380",
                "longitude": "-93.41047490",
                "type": "state",
                "cities": [
                    {
                        "id": 130067,
                        "name": "Ciudad Bolívar",
                        "latitude": "8.12923000",
                        "longitude": "-63.54086000"
                    },
                    {
                        "id": 130068,
                        "name": "Ciudad Guayana",
                        "latitude": "8.35122000",
                        "longitude": "-62.64102000"
                    },
                    {
                        "id": 130119,
                        "name": "Municipio Padre Pedro Chien",
                        "latitude": "8.02455000",
                        "longitude": "-61.88187000"
                    },
                    {
                        "id": 130152,
                        "name": "Santa Elena de Uairén",
                        "latitude": "4.60226000",
                        "longitude": "-61.11025000"
                    },
                    {
                        "id": 130164,
                        "name": "Upata",
                        "latitude": "8.01620000",
                        "longitude": "-62.40561000"
                    }
                ]
            },
            {
                "id": 2040,
                "name": "Carabobo",
                "iso2": "G",
                "latitude": "10.11764330",
                "longitude": "-68.04775090",
                "type": "state",
                "cities": [
                    {
                        "id": 130081,
                        "name": "Guacara",
                        "latitude": "10.22609000",
                        "longitude": "-67.87700000"
                    },
                    {
                        "id": 130085,
                        "name": "Güigüe",
                        "latitude": "10.08344000",
                        "longitude": "-67.77799000"
                    },
                    {
                        "id": 130098,
                        "name": "Los Guayos",
                        "latitude": "10.18932000",
                        "longitude": "-67.93828000"
                    },
                    {
                        "id": 130105,
                        "name": "Mariara",
                        "latitude": "10.29532000",
                        "longitude": "-67.71770000"
                    },
                    {
                        "id": 130108,
                        "name": "Morón",
                        "latitude": "10.48715000",
                        "longitude": "-68.20078000"
                    },
                    {
                        "id": 130132,
                        "name": "Puerto Cabello",
                        "latitude": "10.47306000",
                        "longitude": "-68.01250000"
                    },
                    {
                        "id": 130147,
                        "name": "San Joaquín",
                        "latitude": "10.26061000",
                        "longitude": "-67.79348000"
                    },
                    {
                        "id": 130156,
                        "name": "Tacarigua",
                        "latitude": "10.08621000",
                        "longitude": "-67.91982000"
                    },
                    {
                        "id": 130158,
                        "name": "Tocuyito",
                        "latitude": "10.11347000",
                        "longitude": "-68.06783000"
                    },
                    {
                        "id": 130165,
                        "name": "Valencia",
                        "latitude": "10.16202000",
                        "longitude": "-68.00765000"
                    }
                ]
            },
            {
                "id": 2034,
                "name": "Cojedes",
                "iso2": "H",
                "latitude": "9.38166820",
                "longitude": "-68.33392750",
                "type": "state",
                "cities": [
                    {
                        "id": 130141,
                        "name": "San Carlos",
                        "latitude": "9.66124000",
                        "longitude": "-68.58268000"
                    },
                    {
                        "id": 130157,
                        "name": "Tinaquillo",
                        "latitude": "9.91861000",
                        "longitude": "-68.30472000"
                    }
                ]
            },
            {
                "id": 2051,
                "name": "Delta Amacuro",
                "iso2": "Y",
                "latitude": "8.84993070",
                "longitude": "-61.14031960",
                "type": "state",
                "cities": [
                    {
                        "id": 130161,
                        "name": "Tucupita",
                        "latitude": "9.05806000",
                        "longitude": "-62.05000000"
                    }
                ]
            },
            {
                "id": 4855,
                "name": "Distrito Capital",
                "iso2": "A",
                "latitude": "41.26148460",
                "longitude": "-95.93108070",
                "type": "capital district",
                "cities": [
                    {
                        "id": 149261,
                        "name": "Caracas",
                        "latitude": "10.50000000",
                        "longitude": "-66.93333333"
                    }
                ]
            },
            {
                "id": 2035,
                "name": "Falcón",
                "iso2": "I",
                "latitude": "11.18106740",
                "longitude": "-69.85974060",
                "type": "state",
                "cities": [
                    {
                        "id": 130065,
                        "name": "Chichiriviche",
                        "latitude": "10.92872000",
                        "longitude": "-68.27283000"
                    },
                    {
                        "id": 130071,
                        "name": "Coro",
                        "latitude": "11.40450000",
                        "longitude": "-69.67344000"
                    },
                    {
                        "id": 130116,
                        "name": "Municipio Los Taques",
                        "latitude": "11.82308000",
                        "longitude": "-70.25353000"
                    },
                    {
                        "id": 130118,
                        "name": "Municipio Miranda",
                        "latitude": "11.31667000",
                        "longitude": "-69.86667000"
                    },
                    {
                        "id": 130135,
                        "name": "Punta Cardón",
                        "latitude": "11.65806000",
                        "longitude": "-70.21500000"
                    },
                    {
                        "id": 130136,
                        "name": "Punto Fijo",
                        "latitude": "11.69152000",
                        "longitude": "-70.19918000"
                    },
                    {
                        "id": 130160,
                        "name": "Tucacas",
                        "latitude": "10.79006000",
                        "longitude": "-68.32564000"
                    }
                ]
            },
            {
                "id": 2045,
                "name": "Guárico",
                "iso2": "J",
                "latitude": "8.74893090",
                "longitude": "-66.23671720",
                "type": "state",
                "cities": [
                    {
                        "id": 130039,
                        "name": "Altagracia de Orituco",
                        "latitude": "9.86005000",
                        "longitude": "-66.38139000"
                    },
                    {
                        "id": 130053,
                        "name": "Calabozo",
                        "latitude": "8.92416000",
                        "longitude": "-67.42929000"
                    },
                    {
                        "id": 130150,
                        "name": "San Juan de los Morros",
                        "latitude": "9.91152000",
                        "longitude": "-67.35381000"
                    },
                    {
                        "id": 130167,
                        "name": "Valle de La Pascua",
                        "latitude": "9.21554000",
                        "longitude": "-66.00734000"
                    },
                    {
                        "id": 130171,
                        "name": "Zaraza",
                        "latitude": "9.35029000",
                        "longitude": "-65.32452000"
                    }
                ]
            },
            {
                "id": 2055,
                "name": "La Guaira",
                "iso2": "X",
                "latitude": "29.30522680",
                "longitude": "-94.79138540",
                "type": "state",
                "cities": [
                    {
                        "id": 130055,
                        "name": "Caraballeda",
                        "latitude": "10.61216000",
                        "longitude": "-66.85192000"
                    },
                    {
                        "id": 130060,
                        "name": "Catia La Mar",
                        "latitude": "10.60545000",
                        "longitude": "-67.03238000"
                    },
                    {
                        "id": 130092,
                        "name": "La Guaira",
                        "latitude": "10.60156000",
                        "longitude": "-66.93293000"
                    },
                    {
                        "id": 130102,
                        "name": "Maiquetía",
                        "latitude": "10.59450000",
                        "longitude": "-66.95624000"
                    }
                ]
            },
            {
                "id": 2038,
                "name": "Lara",
                "iso2": "K",
                "latitude": "33.98221650",
                "longitude": "-118.13227470",
                "type": "state",
                "cities": [
                    {
                        "id": 130047,
                        "name": "Barquisimeto",
                        "latitude": "10.06470000",
                        "longitude": "-69.35703000"
                    },
                    {
                        "id": 130051,
                        "name": "Cabudare",
                        "latitude": "10.02658000",
                        "longitude": "-69.26203000"
                    },
                    {
                        "id": 130057,
                        "name": "Carora",
                        "latitude": "10.17283000",
                        "longitude": "-70.08100000"
                    },
                    {
                        "id": 130079,
                        "name": "El Tocuyo",
                        "latitude": "9.78709000",
                        "longitude": "-69.79294000"
                    },
                    {
                        "id": 130099,
                        "name": "Los Rastrojos",
                        "latitude": "10.02588000",
                        "longitude": "-69.24166000"
                    },
                    {
                        "id": 130137,
                        "name": "Quíbor",
                        "latitude": "9.92866000",
                        "longitude": "-69.62010000"
                    }
                ]
            },
            {
                "id": 2053,
                "name": "Mérida",
                "iso2": "L",
                "latitude": "20.96737020",
                "longitude": "-89.59258570",
                "type": "state",
                "cities": [
                    {
                        "id": 130074,
                        "name": "Ejido",
                        "latitude": "8.54665000",
                        "longitude": "-71.24087000"
                    },
                    {
                        "id": 130080,
                        "name": "El Vigía",
                        "latitude": "8.61350000",
                        "longitude": "-71.65702000"
                    },
                    {
                        "id": 130124,
                        "name": "Mérida",
                        "latitude": "8.58972000",
                        "longitude": "-71.15611000"
                    },
                    {
                        "id": 130109,
                        "name": "Mucumpiz",
                        "latitude": "8.41667000",
                        "longitude": "-71.13333000"
                    },
                    {
                        "id": 130115,
                        "name": "Municipio Libertador",
                        "latitude": "8.33333000",
                        "longitude": "-71.11667000"
                    }
                ]
            },
            {
                "id": 2037,
                "name": "Miranda",
                "iso2": "M",
                "latitude": "42.35193830",
                "longitude": "-71.52907660",
                "type": "state",
                "cities": [
                    {
                        "id": 130048,
                        "name": "Baruta",
                        "latitude": "10.43424000",
                        "longitude": "-66.87558000"
                    },
                    {
                        "id": 130058,
                        "name": "Carrizal",
                        "latitude": "10.34985000",
                        "longitude": "-66.98632000"
                    },
                    {
                        "id": 130061,
                        "name": "Caucaguita",
                        "latitude": "10.35782000",
                        "longitude": "-66.80252000"
                    },
                    {
                        "id": 130062,
                        "name": "Caucagüito",
                        "latitude": "10.48666000",
                        "longitude": "-66.73799000"
                    },
                    {
                        "id": 130063,
                        "name": "Chacao",
                        "latitude": "10.49581000",
                        "longitude": "-66.85367000"
                    },
                    {
                        "id": 130064,
                        "name": "Charallave",
                        "latitude": "10.24247000",
                        "longitude": "-66.85723000"
                    },
                    {
                        "id": 130073,
                        "name": "Cúa",
                        "latitude": "10.16245000",
                        "longitude": "-66.88248000"
                    },
                    {
                        "id": 130075,
                        "name": "El Cafetal",
                        "latitude": "10.46541000",
                        "longitude": "-66.82951000"
                    },
                    {
                        "id": 130076,
                        "name": "El Hatillo",
                        "latitude": "10.42411000",
                        "longitude": "-66.82581000"
                    },
                    {
                        "id": 130083,
                        "name": "Guarenas",
                        "latitude": "10.47027000",
                        "longitude": "-66.61934000"
                    },
                    {
                        "id": 130084,
                        "name": "Guatire",
                        "latitude": "10.47400000",
                        "longitude": "-66.54241000"
                    },
                    {
                        "id": 130089,
                        "name": "La Dolorita",
                        "latitude": "10.48830000",
                        "longitude": "-66.78608000"
                    },
                    {
                        "id": 130097,
                        "name": "Los Dos Caminos",
                        "latitude": "10.49389000",
                        "longitude": "-66.82863000"
                    },
                    {
                        "id": 130100,
                        "name": "Los Teques",
                        "latitude": "10.34447000",
                        "longitude": "-67.04325000"
                    },
                    {
                        "id": 130126,
                        "name": "Ocumare del Tuy",
                        "latitude": "10.11820000",
                        "longitude": "-66.77513000"
                    },
                    {
                        "id": 130129,
                        "name": "Petare",
                        "latitude": "10.47679000",
                        "longitude": "-66.80786000"
                    },
                    {
                        "id": 130139,
                        "name": "San Antonio de Los Altos",
                        "latitude": "10.38853000",
                        "longitude": "-66.95179000"
                    },
                    {
                        "id": 130155,
                        "name": "Santa Teresa del Tuy",
                        "latitude": "10.23291000",
                        "longitude": "-66.66474000"
                    }
                ]
            },
            {
                "id": 2054,
                "name": "Monagas",
                "iso2": "N",
                "latitude": "9.32416520",
                "longitude": "-63.01475780",
                "type": "state",
                "cities": [
                    {
                        "id": 130056,
                        "name": "Caripito",
                        "latitude": "10.11135000",
                        "longitude": "-63.09985000"
                    },
                    {
                        "id": 130107,
                        "name": "Maturín",
                        "latitude": "9.74569000",
                        "longitude": "-63.18323000"
                    },
                    {
                        "id": 130117,
                        "name": "Municipio Maturín",
                        "latitude": "9.40000000",
                        "longitude": "-63.03333000"
                    },
                    {
                        "id": 130122,
                        "name": "Municipio Uracoa",
                        "latitude": "8.99960000",
                        "longitude": "-62.35164000"
                    }
                ]
            },
            {
                "id": 2052,
                "name": "Nueva Esparta",
                "iso2": "O",
                "latitude": "10.99707230",
                "longitude": "-63.91132960",
                "type": "state",
                "cities": [
                    {
                        "id": 130087,
                        "name": "Juan Griego",
                        "latitude": "11.08172000",
                        "longitude": "-63.96549000"
                    },
                    {
                        "id": 130088,
                        "name": "La Asunción",
                        "latitude": "11.03333000",
                        "longitude": "-63.86278000"
                    },
                    {
                        "id": 130130,
                        "name": "Porlamar",
                        "latitude": "10.95771000",
                        "longitude": "-63.86971000"
                    }
                ]
            },
            {
                "id": 2036,
                "name": "Portuguesa",
                "iso2": "P",
                "latitude": "9.09439990",
                "longitude": "-69.09702300",
                "type": "state",
                "cities": [
                    {
                        "id": 130038,
                        "name": "Acarigua",
                        "latitude": "9.55451000",
                        "longitude": "-69.19564000"
                    },
                    {
                        "id": 130043,
                        "name": "Araure",
                        "latitude": "9.58144000",
                        "longitude": "-69.23851000"
                    },
                    {
                        "id": 130082,
                        "name": "Guanare",
                        "latitude": "9.04183000",
                        "longitude": "-69.74206000"
                    },
                    {
                        "id": 130168,
                        "name": "Villa Bruzual",
                        "latitude": "9.33186000",
                        "longitude": "-69.11968000"
                    }
                ]
            },
            {
                "id": 2056,
                "name": "Sucre",
                "iso2": "R",
                "latitude": "-19.03534500",
                "longitude": "-65.25921280",
                "type": "state",
                "cities": [
                    {
                        "id": 130059,
                        "name": "Carúpano",
                        "latitude": "10.66516000",
                        "longitude": "-63.25387000"
                    },
                    {
                        "id": 130072,
                        "name": "Cumaná",
                        "latitude": "10.45397000",
                        "longitude": "-64.18256000"
                    },
                    {
                        "id": 130086,
                        "name": "Güiria",
                        "latitude": "10.57721000",
                        "longitude": "-62.29841000"
                    },
                    {
                        "id": 130123,
                        "name": "Municipio Valdez",
                        "latitude": "10.57945000",
                        "longitude": "-62.30029000"
                    }
                ]
            },
            {
                "id": 2048,
                "name": "Táchira",
                "iso2": "S",
                "latitude": "7.91370010",
                "longitude": "-72.14161320",
                "type": "state",
                "cities": [
                    {
                        "id": 130070,
                        "name": "Colón",
                        "latitude": "8.03125000",
                        "longitude": "-72.26053000"
                    },
                    {
                        "id": 130090,
                        "name": "La Fría",
                        "latitude": "8.21523000",
                        "longitude": "-72.24888000"
                    },
                    {
                        "id": 130091,
                        "name": "La Grita",
                        "latitude": "8.13316000",
                        "longitude": "-71.98390000"
                    },
                    {
                        "id": 130114,
                        "name": "Municipio José María Vargas",
                        "latitude": "8.03514000",
                        "longitude": "-72.05675000"
                    },
                    {
                        "id": 130138,
                        "name": "Rubio",
                        "latitude": "7.70131000",
                        "longitude": "-72.35569000"
                    },
                    {
                        "id": 130140,
                        "name": "San Antonio del Táchira",
                        "latitude": "7.81454000",
                        "longitude": "-72.44310000"
                    },
                    {
                        "id": 130144,
                        "name": "San Cristóbal",
                        "latitude": "7.76694000",
                        "longitude": "-72.22500000"
                    },
                    {
                        "id": 130163,
                        "name": "Táriba",
                        "latitude": "7.81880000",
                        "longitude": "-72.22427000"
                    }
                ]
            },
            {
                "id": 2043,
                "name": "Trujillo",
                "iso2": "T",
                "latitude": "9.49634600",
                "longitude": "-71.20194830",
                "type": "state",
                "cities": [
                    {
                        "id": 130049,
                        "name": "Boconó",
                        "latitude": "9.25385000",
                        "longitude": "-70.25105000"
                    },
                    {
                        "id": 130120,
                        "name": "Municipio Pampanito",
                        "latitude": "9.41147000",
                        "longitude": "-70.49592000"
                    },
                    {
                        "id": 130121,
                        "name": "Municipio San Rafael de Carvajal",
                        "latitude": "9.30756000",
                        "longitude": "-70.58965000"
                    },
                    {
                        "id": 130159,
                        "name": "Trujillo",
                        "latitude": "9.36583000",
                        "longitude": "-70.43694000"
                    },
                    {
                        "id": 130166,
                        "name": "Valera",
                        "latitude": "9.31778000",
                        "longitude": "-70.60361000"
                    }
                ]
            },
            {
                "id": 2046,
                "name": "Venezuela",
                "iso2": "W",
                "latitude": "10.93770530",
                "longitude": "-65.35695730",
                "type": "federal dependency",
                "cities": []
            },
            {
                "id": 2041,
                "name": "Yaracuy",
                "iso2": "U",
                "latitude": "10.33938900",
                "longitude": "-68.81088490",
                "type": "state",
                "cities": [
                    {
                        "id": 130066,
                        "name": "Chivacoa",
                        "latitude": "10.15951000",
                        "longitude": "-68.89453000"
                    },
                    {
                        "id": 130112,
                        "name": "Municipio Independencia",
                        "latitude": "10.33472000",
                        "longitude": "-68.75555000"
                    },
                    {
                        "id": 130125,
                        "name": "Nirgua",
                        "latitude": "10.15039000",
                        "longitude": "-68.56478000"
                    },
                    {
                        "id": 130145,
                        "name": "San Felipe",
                        "latitude": "10.33991000",
                        "longitude": "-68.74247000"
                    },
                    {
                        "id": 130170,
                        "name": "Yaritagua",
                        "latitude": "10.08081000",
                        "longitude": "-69.12420000"
                    }
                ]
            },
            {
                "id": 2042,
                "name": "Zulia",
                "iso2": "V",
                "latitude": "10.29102370",
                "longitude": "-72.14161320",
                "type": "state",
                "cities": [
                    {
                        "id": 130050,
                        "name": "Cabimas",
                        "latitude": "10.39907000",
                        "longitude": "-71.45206000"
                    },
                    {
                        "id": 130069,
                        "name": "Ciudad Ojeda",
                        "latitude": "10.20161000",
                        "longitude": "-71.31480000"
                    },
                    {
                        "id": 130094,
                        "name": "La Villa del Rosario",
                        "latitude": "10.32580000",
                        "longitude": "-72.31343000"
                    },
                    {
                        "id": 130095,
                        "name": "Lagunillas",
                        "latitude": "10.13008000",
                        "longitude": "-71.25946000"
                    },
                    {
                        "id": 130101,
                        "name": "Machiques",
                        "latitude": "10.06077000",
                        "longitude": "-72.55212000"
                    },
                    {
                        "id": 130103,
                        "name": "Maracaibo",
                        "latitude": "10.66663000",
                        "longitude": "-71.61245000"
                    },
                    {
                        "id": 130143,
                        "name": "San Carlos del Zulia",
                        "latitude": "9.00098000",
                        "longitude": "-71.92683000"
                    },
                    {
                        "id": 130154,
                        "name": "Santa Rita",
                        "latitude": "10.53642000",
                        "longitude": "-71.51104000"
                    }
                ]
            }
        ]
    },
    {
        "id": 240,
        "name": "Vietnam",
        "iso3": "VNM",
        "iso2": "VN",
        "numeric_code": "704",
        "phonecode": "84",
        "capital": "Hanoi",
        "currency": "VND",
        "currency_name": "Vietnamese đồng",
        "currency_symbol": "₫",
        "tld": ".vn",
        "native": "Việt Nam",
        "region": "Asia",
        "region_id": 3,
        "subregion": "South-Eastern Asia",
        "subregion_id": 13,
        "nationality": "Vietnamese",
        "timezones": [
            {
                "zoneName": "Asia\/Ho_Chi_Minh",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "ICT",
                "tzName": "Indochina Time"
            }
        ],
        "translations": {
            "br": "Viêt Nam",
            "ko": "베트남",
            "pt-BR": "Vietnã",
            "pt": "Vietname",
            "nl": "Vietnam",
            "hr": "Vijetnam",
            "fa": "ویتنام",
            "de": "Vietnam",
            "es": "Vietnam",
            "fr": "Viêt Nam",
            "ja": "ベトナム",
            "it": "Vietnam",
            "zh-CN": "越南",
            "tr": "Vietnam",
            "ru": "Вьетнам",
            "uk": "В'єтнам",
            "pl": "Wietnam"
        },
        "latitude": "16.16666666",
        "longitude": "107.83333333",
        "emoji": "🇻🇳",
        "emojiU": "U+1F1FB U+1F1F3",
        "states": [
            {
                "id": 3794,
                "name": "An Giang",
                "iso2": "44",
                "latitude": "10.52158360",
                "longitude": "105.12589550",
                "type": "province",
                "cities": [
                    {
                        "id": 130185,
                        "name": "Cho Dok",
                        "latitude": "10.70000000",
                        "longitude": "105.11667000"
                    },
                    {
                        "id": 130211,
                        "name": "Huyện An Phú",
                        "latitude": "10.84274000",
                        "longitude": "105.08990000"
                    },
                    {
                        "id": 130248,
                        "name": "Huyện Châu Phú",
                        "latitude": "10.57166000",
                        "longitude": "105.16991000"
                    },
                    {
                        "id": 130262,
                        "name": "Huyện Chợ Mới",
                        "latitude": "10.47730000",
                        "longitude": "105.49092000"
                    },
                    {
                        "id": 130401,
                        "name": "Huyện Phú Tân",
                        "latitude": "10.65716000",
                        "longitude": "105.28459000"
                    },
                    {
                        "id": 130461,
                        "name": "Huyện Tri Tôn",
                        "latitude": "10.41416000",
                        "longitude": "104.96136000"
                    },
                    {
                        "id": 130569,
                        "name": "Long Xuyên",
                        "latitude": "10.38639000",
                        "longitude": "105.43518000"
                    },
                    {
                        "id": 130570,
                        "name": "Long Xuyên City",
                        "latitude": "10.36857000",
                        "longitude": "105.42340000"
                    }
                ]
            },
            {
                "id": 3770,
                "name": "Bà Rịa-Vũng Tàu",
                "iso2": "43",
                "latitude": "10.54173970",
                "longitude": "107.24299760",
                "type": "province",
                "cities": [
                    {
                        "id": 130189,
                        "name": "Côn Sơn",
                        "latitude": "8.68641000",
                        "longitude": "106.60824000"
                    },
                    {
                        "id": 130255,
                        "name": "Huyện Châu Đức",
                        "latitude": "10.65805000",
                        "longitude": "107.25098000"
                    },
                    {
                        "id": 130539,
                        "name": "Huyện Đất Đỏ",
                        "latitude": "10.48025000",
                        "longitude": "107.27879000"
                    },
                    {
                        "id": 130487,
                        "name": "Huyện Tân Thành",
                        "latitude": "10.57381000",
                        "longitude": "107.10189000"
                    },
                    {
                        "id": 130510,
                        "name": "Huyện Xuyên Mộc",
                        "latitude": "10.63048000",
                        "longitude": "107.46568000"
                    },
                    {
                        "id": 130604,
                        "name": "Thành Phố Vũng Tàu",
                        "latitude": "10.40239000",
                        "longitude": "107.14239000"
                    },
                    {
                        "id": 130613,
                        "name": "Thị Xã Phú Mỹ",
                        "latitude": "10.56815000",
                        "longitude": "107.12999000"
                    },
                    {
                        "id": 130626,
                        "name": "Vũng Tàu",
                        "latitude": "10.34599000",
                        "longitude": "107.08426000"
                    }
                ]
            },
            {
                "id": 3815,
                "name": "Bắc Giang",
                "iso2": "54",
                "latitude": "21.28199210",
                "longitude": "106.19747690",
                "type": "province",
                "cities": [
                    {
                        "id": 130177,
                        "name": "Bắc Giang",
                        "latitude": "21.27307000",
                        "longitude": "106.19460000"
                    },
                    {
                        "id": 130353,
                        "name": "Huyện Lục Nam",
                        "latitude": "21.27548000",
                        "longitude": "106.46519000"
                    },
                    {
                        "id": 130354,
                        "name": "Huyện Lục Ngạn",
                        "latitude": "21.43719000",
                        "longitude": "106.65845000"
                    },
                    {
                        "id": 130521,
                        "name": "Huyện Yên Thế",
                        "latitude": "21.51667000",
                        "longitude": "106.11689000"
                    }
                ]
            },
            {
                "id": 3822,
                "name": "Bắc Kạn",
                "iso2": "53",
                "latitude": "22.30329230",
                "longitude": "105.87600400",
                "type": "province",
                "cities": [
                    {
                        "id": 130178,
                        "name": "Bắc Kạn",
                        "latitude": "22.14701000",
                        "longitude": "105.83481000"
                    },
                    {
                        "id": 130213,
                        "name": "Huyện Ba Bể",
                        "latitude": "22.41667000",
                        "longitude": "105.75000000"
                    },
                    {
                        "id": 130228,
                        "name": "Huyện Bạch Thông",
                        "latitude": "22.25758000",
                        "longitude": "105.83295000"
                    },
                    {
                        "id": 130263,
                        "name": "Huyện Chợ Đồn",
                        "latitude": "22.18681000",
                        "longitude": "105.57280000"
                    },
                    {
                        "id": 130374,
                        "name": "Huyện Na Rì",
                        "latitude": "22.17883000",
                        "longitude": "106.11221000"
                    },
                    {
                        "id": 130387,
                        "name": "Huyện Ngân Sơn",
                        "latitude": "22.42962000",
                        "longitude": "106.01030000"
                    },
                    {
                        "id": 130608,
                        "name": "Thị Xã Bắc Kạn",
                        "latitude": "22.14130000",
                        "longitude": "105.83867000"
                    }
                ]
            },
            {
                "id": 3804,
                "name": "Bạc Liêu",
                "iso2": "55",
                "latitude": "9.29400270",
                "longitude": "105.72156630",
                "type": "province",
                "cities": [
                    {
                        "id": 130175,
                        "name": "Bạc Liêu",
                        "latitude": "9.29414000",
                        "longitude": "105.72776000"
                    },
                    {
                        "id": 130289,
                        "name": "Huyện Giá Rai",
                        "latitude": "9.27162000",
                        "longitude": "105.40017000"
                    },
                    {
                        "id": 130318,
                        "name": "Huyện Hồng Dân",
                        "latitude": "9.53822000",
                        "longitude": "105.42242000"
                    }
                ]
            },
            {
                "id": 3791,
                "name": "Bắc Ninh",
                "iso2": "56",
                "latitude": "21.12144400",
                "longitude": "106.11105010",
                "type": "province",
                "cities": [
                    {
                        "id": 130179,
                        "name": "Bắc Ninh",
                        "latitude": "21.18608000",
                        "longitude": "106.07631000"
                    },
                    {
                        "id": 130186,
                        "name": "Cung Kiệm",
                        "latitude": "21.18697000",
                        "longitude": "106.16076000"
                    },
                    {
                        "id": 130285,
                        "name": "Huyện Gia Bình",
                        "latitude": "21.07795000",
                        "longitude": "106.20903000"
                    },
                    {
                        "id": 130441,
                        "name": "Huyện Thuận Thành",
                        "latitude": "21.04085000",
                        "longitude": "106.07515000"
                    },
                    {
                        "id": 130455,
                        "name": "Huyện Tiên Du",
                        "latitude": "21.12195000",
                        "longitude": "106.03995000"
                    },
                    {
                        "id": 130518,
                        "name": "Huyện Yên Phong",
                        "latitude": "21.20676000",
                        "longitude": "105.99427000"
                    }
                ]
            },
            {
                "id": 3796,
                "name": "Bến Tre",
                "iso2": "50",
                "latitude": "10.24335560",
                "longitude": "106.37555100",
                "type": "province",
                "cities": [
                    {
                        "id": 130635,
                        "name": "Ấp Tân Ngãi",
                        "latitude": "10.23333000",
                        "longitude": "106.28333000"
                    },
                    {
                        "id": 130180,
                        "name": "Bến Tre",
                        "latitude": "10.24147000",
                        "longitude": "106.37585000"
                    },
                    {
                        "id": 130215,
                        "name": "Huyện Ba Tri",
                        "latitude": "10.06627000",
                        "longitude": "106.60554000"
                    },
                    {
                        "id": 130226,
                        "name": "Huyện Bình Đại",
                        "latitude": "10.19354000",
                        "longitude": "106.64455000"
                    },
                    {
                        "id": 130250,
                        "name": "Huyện Châu Thành",
                        "latitude": "10.29212000",
                        "longitude": "106.30827000"
                    },
                    {
                        "id": 130261,
                        "name": "Huyện Chợ Lách",
                        "latitude": "10.22674000",
                        "longitude": "106.17077000"
                    },
                    {
                        "id": 130291,
                        "name": "Huyện Giồng Trôm",
                        "latitude": "10.15909000",
                        "longitude": "106.47004000"
                    },
                    {
                        "id": 130449,
                        "name": "Huyện Thạnh Phú",
                        "latitude": "9.92993000",
                        "longitude": "106.54316000"
                    }
                ]
            },
            {
                "id": 3785,
                "name": "Bình Dương",
                "iso2": "57",
                "latitude": "11.32540240",
                "longitude": "106.47701700",
                "type": "province",
                "cities": [
                    {
                        "id": 130198,
                        "name": "Dĩ An",
                        "latitude": "10.90682000",
                        "longitude": "106.76940000"
                    },
                    {
                        "id": 130616,
                        "name": "Thủ Dầu Một",
                        "latitude": "10.98040000",
                        "longitude": "106.65190000"
                    }
                ]
            },
            {
                "id": 3830,
                "name": "Bình Định",
                "iso2": "31",
                "latitude": "14.16653240",
                "longitude": "108.90268300",
                "type": "province",
                "cities": [
                    {
                        "id": 130209,
                        "name": "Huyện An Lão",
                        "latitude": "14.55676000",
                        "longitude": "108.80100000"
                    },
                    {
                        "id": 130298,
                        "name": "Huyện Hoài Nhơn",
                        "latitude": "14.50535000",
                        "longitude": "109.02315000"
                    },
                    {
                        "id": 130397,
                        "name": "Huyện Phù Mỹ",
                        "latitude": "14.22304000",
                        "longitude": "109.08611000"
                    },
                    {
                        "id": 130490,
                        "name": "Huyện Tây Sơn",
                        "latitude": "13.94306000",
                        "longitude": "108.87999000"
                    },
                    {
                        "id": 130476,
                        "name": "Huyện Tuy Phước",
                        "latitude": "13.84564000",
                        "longitude": "109.15275000"
                    },
                    {
                        "id": 130503,
                        "name": "Huyện Vĩnh Thạnh",
                        "latitude": "14.21100000",
                        "longitude": "108.74389000"
                    },
                    {
                        "id": 130584,
                        "name": "Qui Nhon",
                        "latitude": "13.77648000",
                        "longitude": "109.22367000"
                    }
                ]
            },
            {
                "id": 3797,
                "name": "Bình Phước",
                "iso2": "58",
                "latitude": "11.75118940",
                "longitude": "106.72346390",
                "type": "province",
                "cities": [
                    {
                        "id": 130174,
                        "name": "Bình Long",
                        "latitude": "11.64711000",
                        "longitude": "106.60586000"
                    },
                    {
                        "id": 130197,
                        "name": "Don Luan",
                        "latitude": "11.53495000",
                        "longitude": "106.88324000"
                    },
                    {
                        "id": 130227,
                        "name": "Huyện Bù Đốp",
                        "latitude": "12.00374000",
                        "longitude": "106.81545000"
                    },
                    {
                        "id": 130256,
                        "name": "Huyện Chơn Thành",
                        "latitude": "11.46283000",
                        "longitude": "106.66655000"
                    },
                    {
                        "id": 130547,
                        "name": "Huyện Đồng Phú",
                        "latitude": "11.50071000",
                        "longitude": "107.01192000"
                    },
                    {
                        "id": 130319,
                        "name": "Huyện Hớn Quản",
                        "latitude": "11.59718000",
                        "longitude": "106.62739000"
                    },
                    {
                        "id": 130614,
                        "name": "Thị Xã Phước Long",
                        "latitude": "11.81142000",
                        "longitude": "106.99670000"
                    }
                ]
            },
            {
                "id": 3787,
                "name": "Bình Thuận",
                "iso2": "40",
                "latitude": "11.09037030",
                "longitude": "108.07207810",
                "type": "province",
                "cities": [
                    {
                        "id": 130233,
                        "name": "Huyện Bắc Bình",
                        "latitude": "11.27571000",
                        "longitude": "108.38506000"
                    },
                    {
                        "id": 130304,
                        "name": "Huyện Hàm Tân",
                        "latitude": "10.76856000",
                        "longitude": "107.64233000"
                    },
                    {
                        "id": 130302,
                        "name": "Huyện Hàm Thuận Bắc",
                        "latitude": "11.14703000",
                        "longitude": "108.08172000"
                    },
                    {
                        "id": 130303,
                        "name": "Huyện Hàm Thuận Nam",
                        "latitude": "10.92101000",
                        "longitude": "107.93325000"
                    },
                    {
                        "id": 130479,
                        "name": "Huyện Tánh Linh",
                        "latitude": "11.11367000",
                        "longitude": "107.68427000"
                    },
                    {
                        "id": 130475,
                        "name": "Huyện Tuy Phong",
                        "latitude": "11.34746000",
                        "longitude": "108.70466000"
                    },
                    {
                        "id": 130567,
                        "name": "La Gi",
                        "latitude": "10.65993000",
                        "longitude": "107.77206000"
                    },
                    {
                        "id": 130579,
                        "name": "Phan Thiết",
                        "latitude": "10.92889000",
                        "longitude": "108.10208000"
                    },
                    {
                        "id": 130601,
                        "name": "Thành Phố Phan Thiết",
                        "latitude": "10.93700000",
                        "longitude": "108.15778000"
                    }
                ]
            },
            {
                "id": 3778,
                "name": "Cà Mau",
                "iso2": "59",
                "latitude": "9.15267280",
                "longitude": "105.19607950",
                "type": "province",
                "cities": [
                    {
                        "id": 130187,
                        "name": "Cà Mau",
                        "latitude": "9.17682000",
                        "longitude": "105.15242000"
                    },
                    {
                        "id": 130267,
                        "name": "Huyện Cái Nước",
                        "latitude": "9.00094000",
                        "longitude": "105.04201000"
                    },
                    {
                        "id": 130540,
                        "name": "Huyện Đầm Dơi",
                        "latitude": "8.96029000",
                        "longitude": "105.24107000"
                    },
                    {
                        "id": 130204,
                        "name": "Huyen Nam Can",
                        "latitude": "8.81531000",
                        "longitude": "105.05574000"
                    },
                    {
                        "id": 130453,
                        "name": "Huyện Thới Bình",
                        "latitude": "9.35790000",
                        "longitude": "105.16023000"
                    }
                ]
            },
            {
                "id": 4925,
                "name": "Cần Thơ",
                "iso2": "CT",
                "latitude": "10.03418510",
                "longitude": "105.72255070",
                "type": "municipality",
                "cities": [
                    {
                        "id": 148322,
                        "name": "Cần Thơ",
                        "latitude": "10.11667000",
                        "longitude": "105.50000000"
                    },
                    {
                        "id": 148323,
                        "name": "Cờ Đỏ",
                        "latitude": "10.09472222",
                        "longitude": "105.43194444"
                    },
                    {
                        "id": 148324,
                        "name": "Thới Lai",
                        "latitude": "10.06305556",
                        "longitude": "105.56083333"
                    },
                    {
                        "id": 148325,
                        "name": "Vĩnh Thạnh",
                        "latitude": "10.21916667",
                        "longitude": "105.40111111"
                    }
                ]
            },
            {
                "id": 3782,
                "name": "Cao Bằng",
                "iso2": "04",
                "latitude": "22.63568900",
                "longitude": "106.25221430",
                "type": "province",
                "cities": [
                    {
                        "id": 130183,
                        "name": "Cao Bằng",
                        "latitude": "22.66568000",
                        "longitude": "106.25786000"
                    },
                    {
                        "id": 130229,
                        "name": "Huyện Bảo Lac",
                        "latitude": "22.90085000",
                        "longitude": "105.73332000"
                    },
                    {
                        "id": 130231,
                        "name": "Huyện Bảo Lâm",
                        "latitude": "22.87041000",
                        "longitude": "105.48780000"
                    },
                    {
                        "id": 130313,
                        "name": "Huyện Hạ Lang",
                        "latitude": "22.70933000",
                        "longitude": "106.67657000"
                    },
                    {
                        "id": 130300,
                        "name": "Huyện Hà Quảng",
                        "latitude": "22.90763000",
                        "longitude": "106.12487000"
                    },
                    {
                        "id": 130386,
                        "name": "Huyện Nguyên Bình",
                        "latitude": "22.62400000",
                        "longitude": "105.93248000"
                    },
                    {
                        "id": 130206,
                        "name": "Huyen Phuc Hoa",
                        "latitude": "22.53840000",
                        "longitude": "106.51039000"
                    },
                    {
                        "id": 130446,
                        "name": "Huyện Thạch An",
                        "latitude": "22.47654000",
                        "longitude": "106.34237000"
                    },
                    {
                        "id": 130444,
                        "name": "Huyện Thông Nông",
                        "latitude": "22.80735000",
                        "longitude": "105.95846000"
                    },
                    {
                        "id": 130466,
                        "name": "Huyện Trà Lĩnh",
                        "latitude": "22.80961000",
                        "longitude": "106.32543000"
                    },
                    {
                        "id": 130469,
                        "name": "Huyện Trùng Khánh",
                        "latitude": "22.83333000",
                        "longitude": "106.56074000"
                    }
                ]
            },
            {
                "id": 3806,
                "name": "Đà Nẵng",
                "iso2": "DN",
                "latitude": "16.05440680",
                "longitude": "108.20216670",
                "type": "municipality",
                "cities": [
                    {
                        "id": 130195,
                        "name": "Da Nang",
                        "latitude": "16.06778000",
                        "longitude": "108.22083000"
                    }
                ]
            },
            {
                "id": 3829,
                "name": "Đắk Lắk",
                "iso2": "33",
                "latitude": "12.71001160",
                "longitude": "108.23775190",
                "type": "province",
                "cities": [
                    {
                        "id": 130173,
                        "name": "Buôn Ma Thuột",
                        "latitude": "12.66747000",
                        "longitude": "108.03775000"
                    },
                    {
                        "id": 130217,
                        "name": "Huyện Buôn Đôn",
                        "latitude": "12.90396000",
                        "longitude": "107.73870000"
                    },
                    {
                        "id": 130283,
                        "name": "Huyện Ea H'Leo",
                        "latitude": "13.31814000",
                        "longitude": "108.07148000"
                    },
                    {
                        "id": 130284,
                        "name": "Huyện Ea Súp",
                        "latitude": "13.18279000",
                        "longitude": "107.79954000"
                    }
                ]
            },
            {
                "id": 3823,
                "name": "Đắk Nông",
                "iso2": "72",
                "latitude": "12.26464760",
                "longitude": "107.60980600",
                "type": "province",
                "cities": [
                    {
                        "id": 130269,
                        "name": "Huyện Cư Jút",
                        "latitude": "12.69591000",
                        "longitude": "107.76316000"
                    },
                    {
                        "id": 130544,
                        "name": "Huyện Đắk R’Lấp",
                        "latitude": "11.87990000",
                        "longitude": "107.52244000"
                    },
                    {
                        "id": 130333,
                        "name": "Huyện Krông Nô",
                        "latitude": "12.36285000",
                        "longitude": "107.83445000"
                    }
                ]
            },
            {
                "id": 3773,
                "name": "Điện Biên",
                "iso2": "71",
                "latitude": "21.80423090",
                "longitude": "103.10765250",
                "type": "province",
                "cities": [
                    {
                        "id": 130196,
                        "name": "Dien Bien Phu",
                        "latitude": "21.38602000",
                        "longitude": "103.02301000"
                    },
                    {
                        "id": 130528,
                        "name": "Huyện Điện Biên Đông",
                        "latitude": "21.25266000",
                        "longitude": "103.26900000"
                    },
                    {
                        "id": 130365,
                        "name": "Huyện Mường Nhé",
                        "latitude": "22.10353000",
                        "longitude": "102.58465000"
                    },
                    {
                        "id": 130493,
                        "name": "Huyện Tủa Chùa",
                        "latitude": "21.95357000",
                        "longitude": "103.37332000"
                    },
                    {
                        "id": 130478,
                        "name": "Huyện Tuần Giáo",
                        "latitude": "21.69481000",
                        "longitude": "103.41758000"
                    },
                    {
                        "id": 130611,
                        "name": "Thị Xã Mưòng Lay",
                        "latitude": "22.03374000",
                        "longitude": "103.12331000"
                    }
                ]
            },
            {
                "id": 3821,
                "name": "Đồng Nai",
                "iso2": "39",
                "latitude": "11.06863050",
                "longitude": "107.16759760",
                "type": "province",
                "cities": [
                    {
                        "id": 130172,
                        "name": "Biên Hòa",
                        "latitude": "10.94469000",
                        "longitude": "106.82432000"
                    },
                    {
                        "id": 130546,
                        "name": "Huyện Định Quán",
                        "latitude": "11.21866000",
                        "longitude": "107.33959000"
                    },
                    {
                        "id": 130344,
                        "name": "Huyện Long Thành",
                        "latitude": "10.76162000",
                        "longitude": "107.02688000"
                    },
                    {
                        "id": 130485,
                        "name": "Huyện Tân Phú",
                        "latitude": "11.39867000",
                        "longitude": "107.39976000"
                    },
                    {
                        "id": 130452,
                        "name": "Huyện Thống Nhất",
                        "latitude": "10.97764000",
                        "longitude": "107.15909000"
                    },
                    {
                        "id": 130471,
                        "name": "Huyện Trảng Bom",
                        "latitude": "10.96624000",
                        "longitude": "107.03614000"
                    },
                    {
                        "id": 130498,
                        "name": "Huyện Vĩnh Cửu",
                        "latitude": "11.25725000",
                        "longitude": "107.02773000"
                    }
                ]
            },
            {
                "id": 3769,
                "name": "Đồng Tháp",
                "iso2": "45",
                "latitude": "10.49379890",
                "longitude": "105.68817880",
                "type": "province",
                "cities": [
                    {
                        "id": 130184,
                        "name": "Cao Lãnh",
                        "latitude": "10.46017000",
                        "longitude": "105.63294000"
                    },
                    {
                        "id": 130253,
                        "name": "Huyện Châu Thành",
                        "latitude": "10.22543000",
                        "longitude": "105.82380000"
                    },
                    {
                        "id": 130340,
                        "name": "Huyện Lai Vung",
                        "latitude": "10.24051000",
                        "longitude": "105.66327000"
                    },
                    {
                        "id": 130351,
                        "name": "Huyện Lấp Vò",
                        "latitude": "10.35918000",
                        "longitude": "105.60611000"
                    },
                    {
                        "id": 130430,
                        "name": "Huyện Tam Nông",
                        "latitude": "10.72761000",
                        "longitude": "105.52522000"
                    },
                    {
                        "id": 130483,
                        "name": "Huyện Tân Hồng",
                        "latitude": "10.87089000",
                        "longitude": "105.49104000"
                    },
                    {
                        "id": 130435,
                        "name": "Huyện Thanh Bình",
                        "latitude": "10.60137000",
                        "longitude": "105.47811000"
                    },
                    {
                        "id": 130443,
                        "name": "Huyện Tháp Mười",
                        "latitude": "10.54398000",
                        "longitude": "105.81875000"
                    },
                    {
                        "id": 130589,
                        "name": "Sa Dec",
                        "latitude": "10.29085000",
                        "longitude": "105.75635000"
                    },
                    {
                        "id": 130590,
                        "name": "Sa Dec city",
                        "latitude": "10.30550000",
                        "longitude": "105.74757000"
                    },
                    {
                        "id": 130607,
                        "name": "Thị Trấn Tân Thành",
                        "latitude": "10.25616000",
                        "longitude": "105.59280000"
                    }
                ]
            },
            {
                "id": 3813,
                "name": "Gia Lai",
                "iso2": "30",
                "latitude": "13.80789430",
                "longitude": "108.10937500",
                "type": "province",
                "cities": [
                    {
                        "id": 130258,
                        "name": "Huyện Chư Păh",
                        "latitude": "14.15941000",
                        "longitude": "107.98411000"
                    },
                    {
                        "id": 130257,
                        "name": "Huyện Chư Prông",
                        "latitude": "13.59976000",
                        "longitude": "107.81099000"
                    },
                    {
                        "id": 130259,
                        "name": "Huyện Chư Sê",
                        "latitude": "13.74254000",
                        "longitude": "108.08663000"
                    },
                    {
                        "id": 130549,
                        "name": "Huyện Đức Cơ",
                        "latitude": "13.78454000",
                        "longitude": "107.66970000"
                    },
                    {
                        "id": 130320,
                        "name": "Huyện Ia Grai",
                        "latitude": "13.98937000",
                        "longitude": "107.73740000"
                    },
                    {
                        "id": 130322,
                        "name": "Huyện KBang",
                        "latitude": "14.30506000",
                        "longitude": "108.49779000"
                    },
                    {
                        "id": 130335,
                        "name": "Huyện Kông Chro",
                        "latitude": "13.73519000",
                        "longitude": "108.59697000"
                    },
                    {
                        "id": 130334,
                        "name": "Huyện Krông Pa",
                        "latitude": "13.23152000",
                        "longitude": "108.65494000"
                    },
                    {
                        "id": 130358,
                        "name": "Huyện Mang Yang",
                        "latitude": "13.92840000",
                        "longitude": "108.30246000"
                    },
                    {
                        "id": 130583,
                        "name": "Pleiku",
                        "latitude": "13.98333000",
                        "longitude": "108.00000000"
                    }
                ]
            },
            {
                "id": 3779,
                "name": "Hà Giang",
                "iso2": "03",
                "latitude": "22.80255880",
                "longitude": "104.97844940",
                "type": "province",
                "cities": [
                    {
                        "id": 130555,
                        "name": "Hà Giang",
                        "latitude": "22.82333000",
                        "longitude": "104.98357000"
                    },
                    {
                        "id": 130235,
                        "name": "Huyện Bắc Mê",
                        "latitude": "22.75477000",
                        "longitude": "105.29023000"
                    },
                    {
                        "id": 130236,
                        "name": "Huyện Bắc Quang",
                        "latitude": "22.42301000",
                        "longitude": "104.91831000"
                    },
                    {
                        "id": 130548,
                        "name": "Huyện Đồng Văn",
                        "latitude": "23.25449000",
                        "longitude": "105.27626000"
                    },
                    {
                        "id": 130406,
                        "name": "Huyện Quang Bình",
                        "latitude": "22.41507000",
                        "longitude": "104.66018000"
                    },
                    {
                        "id": 130508,
                        "name": "Huyện Vị Xuyên",
                        "latitude": "22.73096000",
                        "longitude": "104.90827000"
                    },
                    {
                        "id": 130511,
                        "name": "Huyện Xín Mần",
                        "latitude": "22.64148000",
                        "longitude": "104.52089000"
                    },
                    {
                        "id": 130516,
                        "name": "Huyện Yên Minh",
                        "latitude": "23.06992000",
                        "longitude": "105.17865000"
                    }
                ]
            },
            {
                "id": 3802,
                "name": "Hà Nam",
                "iso2": "63",
                "latitude": "20.58351960",
                "longitude": "105.92299000",
                "type": "province",
                "cities": [
                    {
                        "id": 130223,
                        "name": "Huyện Bình Lục",
                        "latitude": "20.50126000",
                        "longitude": "106.02959000"
                    },
                    {
                        "id": 130280,
                        "name": "Huyện Duy Tiên",
                        "latitude": "20.62803000",
                        "longitude": "105.96193000"
                    },
                    {
                        "id": 130326,
                        "name": "Huyện Kim Bảng",
                        "latitude": "20.57254000",
                        "longitude": "105.85043000"
                    },
                    {
                        "id": 130347,
                        "name": "Huyện Lý Nhân",
                        "latitude": "20.56422000",
                        "longitude": "106.09455000"
                    },
                    {
                        "id": 130437,
                        "name": "Huyện Thanh Liêm",
                        "latitude": "20.46249000",
                        "longitude": "105.92100000"
                    },
                    {
                        "id": 130582,
                        "name": "Phủ Lý",
                        "latitude": "20.54531000",
                        "longitude": "105.91221000"
                    }
                ]
            },
            {
                "id": 3810,
                "name": "Hà Nội",
                "iso2": "HN",
                "latitude": "21.02776440",
                "longitude": "105.83415980",
                "type": "municipality",
                "cities": [
                    {
                        "id": 130201,
                        "name": "Ba Đình",
                        "latitude": "21.03482330",
                        "longitude": "105.80854700"
                    },
                    {
                        "id": 154453,
                        "name": "Ba Vì",
                        "latitude": "21.15590590",
                        "longitude": "105.21463610"
                    },
                    {
                        "id": 130412,
                        "name": "Bắc Từ Liêm",
                        "latitude": "21.07148680",
                        "longitude": "105.71992260"
                    },
                    {
                        "id": 130558,
                        "name": "Cầu Giấy",
                        "latitude": "21.03022160",
                        "longitude": "105.74947330"
                    },
                    {
                        "id": 154454,
                        "name": "Chương Mỹ",
                        "latitude": "20.87863440",
                        "longitude": "105.57313240"
                    },
                    {
                        "id": 154455,
                        "name": "Đan Phượng",
                        "latitude": "21.12073370",
                        "longitude": "105.59910760"
                    },
                    {
                        "id": 154456,
                        "name": "Đông Anh",
                        "latitude": "21.13683310",
                        "longitude": "105.74753240"
                    },
                    {
                        "id": 130586,
                        "name": "Đống Đa",
                        "latitude": "21.01466010",
                        "longitude": "105.79955140"
                    },
                    {
                        "id": 154457,
                        "name": "Gia Lâm",
                        "latitude": "21.02405790",
                        "longitude": "105.78534730"
                    },
                    {
                        "id": 130587,
                        "name": "Hà Đông",
                        "latitude": "20.95394960",
                        "longitude": "105.71369010"
                    },
                    {
                        "id": 130595,
                        "name": "Hai Bà Trưng",
                        "latitude": "21.00675970",
                        "longitude": "105.84126630"
                    },
                    {
                        "id": 154458,
                        "name": "Hoài Đức",
                        "latitude": "21.02300260",
                        "longitude": "105.61219450"
                    },
                    {
                        "id": 154446,
                        "name": "Hoàn Kiếm ",
                        "latitude": "21.03044570",
                        "longitude": "105.83358610"
                    },
                    {
                        "id": 154447,
                        "name": "Hoàng Mai",
                        "latitude": "20.97404710",
                        "longitude": "105.81704700"
                    },
                    {
                        "id": 154448,
                        "name": "Long Biên",
                        "latitude": "21.03803170",
                        "longitude": "105.84909840"
                    },
                    {
                        "id": 154459,
                        "name": "Mê Linh",
                        "latitude": "21.18078460",
                        "longitude": "105.62112980"
                    },
                    {
                        "id": 154460,
                        "name": "Mỹ Đức",
                        "latitude": "20.69745440",
                        "longitude": "105.56582850"
                    },
                    {
                        "id": 154449,
                        "name": "Nam Từ Liêm",
                        "latitude": "21.01789090",
                        "longitude": "105.72108680"
                    },
                    {
                        "id": 154461,
                        "name": "Phú Xuyên",
                        "latitude": "20.72900540",
                        "longitude": "105.81491120"
                    },
                    {
                        "id": 154462,
                        "name": "Phúc Thọ",
                        "latitude": "21.10993100",
                        "longitude": "105.50059130"
                    },
                    {
                        "id": 154463,
                        "name": "Quốc Oai",
                        "latitude": "20.97845600",
                        "longitude": "105.43800930"
                    },
                    {
                        "id": 154464,
                        "name": "Sóc Sơn",
                        "latitude": "21.28139310",
                        "longitude": "105.66618880"
                    },
                    {
                        "id": 154452,
                        "name": "Sơn Tây",
                        "latitude": "21.09683340",
                        "longitude": "105.39385950"
                    },
                    {
                        "id": 154450,
                        "name": "Tây Hồ ",
                        "latitude": "21.06882190",
                        "longitude": "105.77920430"
                    },
                    {
                        "id": 154465,
                        "name": "Thạch Thất",
                        "latitude": "21.02408830",
                        "longitude": "105.35102500"
                    },
                    {
                        "id": 154466,
                        "name": "Thanh Oai",
                        "latitude": "20.86002700",
                        "longitude": "105.70158360"
                    },
                    {
                        "id": 154467,
                        "name": "Thanh Trì",
                        "latitude": "20.94176020",
                        "longitude": "105.76821790"
                    },
                    {
                        "id": 154451,
                        "name": "Thanh Xuân",
                        "latitude": "20.99482550",
                        "longitude": "105.79696040"
                    },
                    {
                        "id": 154468,
                        "name": "Thường Tín",
                        "latitude": "20.83223420",
                        "longitude": "105.79192130"
                    },
                    {
                        "id": 154469,
                        "name": "Ứng Hòa",
                        "latitude": "20.71097910",
                        "longitude": "105.63648520"
                    }
                ]
            },
            {
                "id": 3816,
                "name": "Hà Tĩnh",
                "iso2": "23",
                "latitude": "18.35595370",
                "longitude": "105.88774940",
                "type": "province",
                "cities": [
                    {
                        "id": 130557,
                        "name": "Hà Tĩnh",
                        "latitude": "18.34282000",
                        "longitude": "105.90569000"
                    },
                    {
                        "id": 130277,
                        "name": "Huyện Cẩm Xuyên",
                        "latitude": "18.19059000",
                        "longitude": "106.00186000"
                    },
                    {
                        "id": 130243,
                        "name": "Huyện Can Lộc",
                        "latitude": "18.44414000",
                        "longitude": "105.76350000"
                    },
                    {
                        "id": 130525,
                        "name": "Huyện Ðức Thọ",
                        "latitude": "18.49699000",
                        "longitude": "105.61016000"
                    },
                    {
                        "id": 130337,
                        "name": "Huyện Kỳ Anh",
                        "latitude": "18.05805000",
                        "longitude": "106.24580000"
                    },
                    {
                        "id": 130382,
                        "name": "Huyện Nghi Xuân",
                        "latitude": "18.62419000",
                        "longitude": "105.76829000"
                    },
                    {
                        "id": 130447,
                        "name": "Huyện Thạch Hà",
                        "latitude": "18.35091000",
                        "longitude": "105.81123000"
                    }
                ]
            },
            {
                "id": 3827,
                "name": "Hải Dương",
                "iso2": "61",
                "latitude": "20.93734130",
                "longitude": "106.31455420",
                "type": "province",
                "cities": [
                    {
                        "id": 130562,
                        "name": "Hải Dương",
                        "latitude": "20.94099000",
                        "longitude": "106.33302000"
                    },
                    {
                        "id": 130221,
                        "name": "Huyện Bình Giang",
                        "latitude": "20.87586000",
                        "longitude": "106.19138000"
                    },
                    {
                        "id": 130274,
                        "name": "Huyện Cẩm Giàng",
                        "latitude": "20.95000000",
                        "longitude": "106.21667000"
                    },
                    {
                        "id": 130286,
                        "name": "Huyện Gia Lộc",
                        "latitude": "20.85164000",
                        "longitude": "106.29130000"
                    },
                    {
                        "id": 130329,
                        "name": "Huyện Kinh Môn",
                        "latitude": "21.01634000",
                        "longitude": "106.50384000"
                    },
                    {
                        "id": 130376,
                        "name": "Huyện Nam Sách",
                        "latitude": "21.00484000",
                        "longitude": "106.34042000"
                    },
                    {
                        "id": 130438,
                        "name": "Huyện Thanh Miện",
                        "latitude": "20.77953000",
                        "longitude": "106.22218000"
                    },
                    {
                        "id": 130609,
                        "name": "Thị Xã Chí Linh",
                        "latitude": "21.13722000",
                        "longitude": "106.39638000"
                    }
                ]
            },
            {
                "id": 3783,
                "name": "Hải Phòng",
                "iso2": "HP",
                "latitude": "20.84491150",
                "longitude": "106.68808410",
                "type": "province",
                "cities": [
                    {
                        "id": 130188,
                        "name": "Cát Bà",
                        "latitude": "20.72779000",
                        "longitude": "107.04819000"
                    },
                    {
                        "id": 130200,
                        "name": "Haiphong",
                        "latitude": "20.86481000",
                        "longitude": "106.68345000"
                    }
                ]
            },
            {
                "id": 3777,
                "name": "Hậu Giang",
                "iso2": "73",
                "latitude": "9.75789800",
                "longitude": "105.64125270",
                "type": "province",
                "cities": [
                    {
                        "id": 130254,
                        "name": "Huyện Châu Thành A",
                        "latitude": "9.93056000",
                        "longitude": "105.64194000"
                    },
                    {
                        "id": 130627,
                        "name": "Vị Thanh",
                        "latitude": "9.78449000",
                        "longitude": "105.47012000"
                    }
                ]
            },
            {
                "id": 3811,
                "name": "Hồ Chí Minh",
                "iso2": "SG",
                "latitude": "10.82309890",
                "longitude": "106.62966380",
                "type": "province",
                "cities": [
                    {
                        "id": 130191,
                        "name": "Cần Giờ",
                        "latitude": "10.41115000",
                        "longitude": "106.95474000"
                    },
                    {
                        "id": 130194,
                        "name": "Củ Chi",
                        "latitude": "10.97333000",
                        "longitude": "106.49325000"
                    },
                    {
                        "id": 130202,
                        "name": "Ho Chi Minh City",
                        "latitude": "10.82302000",
                        "longitude": "106.62965000"
                    }
                ]
            },
            {
                "id": 3799,
                "name": "Hòa Bình",
                "iso2": "14",
                "latitude": "20.68612650",
                "longitude": "105.31311850",
                "type": "province",
                "cities": [
                    {
                        "id": 130559,
                        "name": "Hòa Bình",
                        "latitude": "20.81717000",
                        "longitude": "105.33759000"
                    },
                    {
                        "id": 130245,
                        "name": "Huyện Cao Phong",
                        "latitude": "20.69532000",
                        "longitude": "105.33559000"
                    },
                    {
                        "id": 130338,
                        "name": "Huyện Kỳ Sơn",
                        "latitude": "20.89631000",
                        "longitude": "105.39659000"
                    },
                    {
                        "id": 130350,
                        "name": "Huyện Lạc Thủy",
                        "latitude": "20.49794000",
                        "longitude": "105.74092000"
                    },
                    {
                        "id": 130349,
                        "name": "Huyện Lương Sơn",
                        "latitude": "20.87650000",
                        "longitude": "105.51219000"
                    },
                    {
                        "id": 130484,
                        "name": "Huyện Tân Lạc",
                        "latitude": "20.60557000",
                        "longitude": "105.23399000"
                    }
                ]
            },
            {
                "id": 3768,
                "name": "Hưng Yên",
                "iso2": "66",
                "latitude": "20.85257110",
                "longitude": "106.01699710",
                "type": "province",
                "cities": [
                    {
                        "id": 130560,
                        "name": "Hưng Yên",
                        "latitude": "20.64637000",
                        "longitude": "106.05112000"
                    },
                    {
                        "id": 130523,
                        "name": "Huyện Ân Thi",
                        "latitude": "20.81086000",
                        "longitude": "106.09995000"
                    },
                    {
                        "id": 130323,
                        "name": "Huyện Khoái Châu",
                        "latitude": "20.82170000",
                        "longitude": "105.97455000"
                    },
                    {
                        "id": 130328,
                        "name": "Huyện Kim Động",
                        "latitude": "20.74645000",
                        "longitude": "106.03632000"
                    },
                    {
                        "id": 130369,
                        "name": "Huyện Mỹ Hào",
                        "latitude": "20.93210000",
                        "longitude": "106.10630000"
                    },
                    {
                        "id": 130396,
                        "name": "Huyện Phù Cừ",
                        "latitude": "20.70997000",
                        "longitude": "106.19744000"
                    },
                    {
                        "id": 130456,
                        "name": "Huyện Tiên Lữ",
                        "latitude": "20.68490000",
                        "longitude": "106.12513000"
                    }
                ]
            },
            {
                "id": 3793,
                "name": "Khánh Hòa",
                "iso2": "34",
                "latitude": "12.25850980",
                "longitude": "109.05260760",
                "type": "province",
                "cities": [
                    {
                        "id": 130182,
                        "name": "Cam Ranh",
                        "latitude": "11.92144000",
                        "longitude": "109.15913000"
                    },
                    {
                        "id": 130278,
                        "name": "Huyện Diên Khánh",
                        "latitude": "12.27341000",
                        "longitude": "109.03890000"
                    },
                    {
                        "id": 130324,
                        "name": "Huyện Khánh Sơn",
                        "latitude": "12.02858000",
                        "longitude": "108.90814000"
                    },
                    {
                        "id": 130325,
                        "name": "Huyện Khánh Vĩnh",
                        "latitude": "12.30593000",
                        "longitude": "108.83073000"
                    },
                    {
                        "id": 130506,
                        "name": "Huyện Vạn Ninh",
                        "latitude": "12.72344000",
                        "longitude": "109.24586000"
                    },
                    {
                        "id": 130576,
                        "name": "Nha Trang",
                        "latitude": "12.24507000",
                        "longitude": "109.19432000"
                    },
                    {
                        "id": 130598,
                        "name": "Thành Phố Cam Ranh",
                        "latitude": "11.90707000",
                        "longitude": "109.14861000"
                    },
                    {
                        "id": 130600,
                        "name": "Thành Phố Nha Trang",
                        "latitude": "12.25458000",
                        "longitude": "109.16655000"
                    },
                    {
                        "id": 130612,
                        "name": "Thị Xã Ninh Hòa",
                        "latitude": "12.53796000",
                        "longitude": "109.06057000"
                    }
                ]
            },
            {
                "id": 3800,
                "name": "Kiên Giang",
                "iso2": "47",
                "latitude": "9.82495870",
                "longitude": "105.12589550",
                "type": "province",
                "cities": [
                    {
                        "id": 130199,
                        "name": "Dương Đông",
                        "latitude": "10.21716000",
                        "longitude": "103.95929000"
                    },
                    {
                        "id": 130556,
                        "name": "Hà Tiên",
                        "latitude": "10.38310000",
                        "longitude": "104.48753000"
                    },
                    {
                        "id": 130208,
                        "name": "Huyện An Biên",
                        "latitude": "9.81291000",
                        "longitude": "105.05230000"
                    },
                    {
                        "id": 130210,
                        "name": "Huyện An Minh",
                        "latitude": "9.66704000",
                        "longitude": "104.94848000"
                    },
                    {
                        "id": 130249,
                        "name": "Huyện Châu Thành",
                        "latitude": "9.94372000",
                        "longitude": "105.16868000"
                    },
                    {
                        "id": 130290,
                        "name": "Huyện Giồng Riềng",
                        "latitude": "9.91224000",
                        "longitude": "105.37311000"
                    },
                    {
                        "id": 130295,
                        "name": "Huyện Gò Quao",
                        "latitude": "9.74027000",
                        "longitude": "105.29766000"
                    },
                    {
                        "id": 130307,
                        "name": "Huyện Hòn Đất",
                        "latitude": "10.22908000",
                        "longitude": "104.95280000"
                    },
                    {
                        "id": 130330,
                        "name": "Huyện Kiên Hải",
                        "latitude": "9.83971000",
                        "longitude": "104.61560000"
                    },
                    {
                        "id": 130400,
                        "name": "Huyện Phú Quốc",
                        "latitude": "10.25516000",
                        "longitude": "104.01455000"
                    },
                    {
                        "id": 130481,
                        "name": "Huyện Tân Hiệp",
                        "latitude": "10.09540000",
                        "longitude": "105.25936000"
                    },
                    {
                        "id": 130502,
                        "name": "Huyện Vĩnh Thuận",
                        "latitude": "9.53306000",
                        "longitude": "105.24490000"
                    },
                    {
                        "id": 130564,
                        "name": "Kien Luong Town",
                        "latitude": "10.24892000",
                        "longitude": "104.59000000"
                    },
                    {
                        "id": 130588,
                        "name": "Rạch Giá",
                        "latitude": "10.01245000",
                        "longitude": "105.08091000"
                    }
                ]
            },
            {
                "id": 3772,
                "name": "Kon Tum",
                "iso2": "28",
                "latitude": "14.34974030",
                "longitude": "108.00046060",
                "type": "province",
                "cities": [
                    {
                        "id": 130542,
                        "name": "Huyện Đắk Glei",
                        "latitude": "15.11358000",
                        "longitude": "107.75093000"
                    },
                    {
                        "id": 130543,
                        "name": "Huyện Đắk Hà",
                        "latitude": "14.60326000",
                        "longitude": "107.98547000"
                    },
                    {
                        "id": 130545,
                        "name": "Huyện Đắk Tô",
                        "latitude": "14.70087000",
                        "longitude": "107.80816000"
                    },
                    {
                        "id": 130321,
                        "name": "Huyện Ia H'Drai",
                        "latitude": "14.06032000",
                        "longitude": "107.46243000"
                    },
                    {
                        "id": 130332,
                        "name": "Huyện Kon Plông",
                        "latitude": "14.75620000",
                        "longitude": "108.32057000"
                    },
                    {
                        "id": 130388,
                        "name": "Huyện Ngọc Hồi",
                        "latitude": "14.71940000",
                        "longitude": "107.62636000"
                    },
                    {
                        "id": 130419,
                        "name": "Huyện Sa Thầy",
                        "latitude": "14.32050000",
                        "longitude": "107.59862000"
                    },
                    {
                        "id": 130565,
                        "name": "Kon Tum",
                        "latitude": "14.35451000",
                        "longitude": "108.00759000"
                    }
                ]
            },
            {
                "id": 3825,
                "name": "Lai Châu",
                "iso2": "01",
                "latitude": "22.38622270",
                "longitude": "103.47026310",
                "type": "province",
                "cities": [
                    {
                        "id": 130361,
                        "name": "Huyện Mưòng Tè",
                        "latitude": "22.37443000",
                        "longitude": "102.73835000"
                    },
                    {
                        "id": 130431,
                        "name": "Huyện Tam Đường",
                        "latitude": "22.35391000",
                        "longitude": "103.59342000"
                    },
                    {
                        "id": 130433,
                        "name": "Huyện Than Uyên",
                        "latitude": "21.91424000",
                        "longitude": "103.82857000"
                    }
                ]
            },
            {
                "id": 3818,
                "name": "Lâm Đồng",
                "iso2": "35",
                "latitude": "11.57527910",
                "longitude": "108.14286690",
                "type": "province",
                "cities": [
                    {
                        "id": 130176,
                        "name": "Bảo Lộc",
                        "latitude": "11.54798000",
                        "longitude": "107.80772000"
                    },
                    {
                        "id": 130632,
                        "name": "Đam Rong",
                        "latitude": "12.05409000",
                        "longitude": "108.14941000"
                    },
                    {
                        "id": 130633,
                        "name": "Đinh Văn",
                        "latitude": "11.78624000",
                        "longitude": "108.24282000"
                    },
                    {
                        "id": 130634,
                        "name": "Đưc Trọng",
                        "latitude": "11.73559000",
                        "longitude": "108.37330000"
                    },
                    {
                        "id": 130630,
                        "name": "Ðà Lạt",
                        "latitude": "11.94646000",
                        "longitude": "108.44193000"
                    },
                    {
                        "id": 130230,
                        "name": "Huyện Bảo Lâm",
                        "latitude": "11.71163000",
                        "longitude": "107.75338000"
                    },
                    {
                        "id": 130536,
                        "name": "Huyện Đạ Huoai",
                        "latitude": "11.42465000",
                        "longitude": "107.63825000"
                    },
                    {
                        "id": 130537,
                        "name": "Huyện Đạ Tẻh",
                        "latitude": "11.58446000",
                        "longitude": "107.52792000"
                    },
                    {
                        "id": 130535,
                        "name": "Huyện Đơn Dương",
                        "latitude": "11.75308000",
                        "longitude": "108.55397000"
                    },
                    {
                        "id": 130553,
                        "name": "Huyện Đức Trọng",
                        "latitude": "11.62686000",
                        "longitude": "108.35330000"
                    },
                    {
                        "id": 130346,
                        "name": "Huyện Lâm Hà",
                        "latitude": "11.81890000",
                        "longitude": "108.21215000"
                    }
                ]
            },
            {
                "id": 3792,
                "name": "Lạng Sơn",
                "iso2": "09",
                "latitude": "21.85370800",
                "longitude": "106.76151900",
                "type": "province",
                "cities": [
                    {
                        "id": 130237,
                        "name": "Huyện Bắc Sơn",
                        "latitude": "21.83801000",
                        "longitude": "106.27690000"
                    },
                    {
                        "id": 130220,
                        "name": "Huyện Bình Gia",
                        "latitude": "22.07281000",
                        "longitude": "106.30410000"
                    },
                    {
                        "id": 130244,
                        "name": "Huyện Cao Lộc",
                        "latitude": "21.89857000",
                        "longitude": "106.85435000"
                    },
                    {
                        "id": 130246,
                        "name": "Huyện Chi Lăng",
                        "latitude": "21.67602000",
                        "longitude": "106.62925000"
                    },
                    {
                        "id": 130531,
                        "name": "Huyện Đình Lập",
                        "latitude": "21.54210000",
                        "longitude": "107.12925000"
                    },
                    {
                        "id": 130308,
                        "name": "Huyện Hũu Lũng",
                        "latitude": "21.54474000",
                        "longitude": "106.34386000"
                    },
                    {
                        "id": 130507,
                        "name": "Huyện Vặn Quan",
                        "latitude": "21.83333000",
                        "longitude": "106.54942000"
                    },
                    {
                        "id": 130572,
                        "name": "Lạng Sơn",
                        "latitude": "21.85264000",
                        "longitude": "106.76101000"
                    }
                ]
            },
            {
                "id": 3817,
                "name": "Lào Cai",
                "iso2": "02",
                "latitude": "22.48094310",
                "longitude": "103.97549590",
                "type": "province",
                "cities": [
                    {
                        "id": 130234,
                        "name": "Huyện Bắc Hà",
                        "latitude": "22.50998000",
                        "longitude": "104.30769000"
                    },
                    {
                        "id": 130232,
                        "name": "Huyện Bảo Yên",
                        "latitude": "22.26109000",
                        "longitude": "104.46424000"
                    },
                    {
                        "id": 130219,
                        "name": "Huyện Bát Xát",
                        "latitude": "22.56767000",
                        "longitude": "103.71339000"
                    },
                    {
                        "id": 130362,
                        "name": "Huyện Mường Khương",
                        "latitude": "22.67111000",
                        "longitude": "104.11772000"
                    },
                    {
                        "id": 130418,
                        "name": "Huyện Sa Pa",
                        "latitude": "22.33769000",
                        "longitude": "103.84037000"
                    },
                    {
                        "id": 130420,
                        "name": "Huyện Si Ma Cai",
                        "latitude": "22.67161000",
                        "longitude": "104.27326000"
                    },
                    {
                        "id": 130495,
                        "name": "Huyện Văn Bàn",
                        "latitude": "22.07002000",
                        "longitude": "104.18122000"
                    },
                    {
                        "id": 130571,
                        "name": "Lào Cai",
                        "latitude": "22.48556000",
                        "longitude": "103.97066000"
                    },
                    {
                        "id": 130568,
                        "name": "Lao Chải",
                        "latitude": "22.31377000",
                        "longitude": "103.86844000"
                    },
                    {
                        "id": 130591,
                        "name": "Sa Pa",
                        "latitude": "22.34023000",
                        "longitude": "103.84415000"
                    }
                ]
            },
            {
                "id": 3808,
                "name": "Long An",
                "iso2": "41",
                "latitude": "10.56071680",
                "longitude": "106.64976230",
                "type": "province",
                "cities": [
                    {
                        "id": 130190,
                        "name": "Cần Giuộc",
                        "latitude": "10.60857000",
                        "longitude": "106.67135000"
                    },
                    {
                        "id": 130240,
                        "name": "Huyện Bến Lức",
                        "latitude": "10.68858000",
                        "longitude": "106.45484000"
                    },
                    {
                        "id": 130271,
                        "name": "Huyện Cần Đước",
                        "latitude": "10.54148000",
                        "longitude": "106.59636000"
                    },
                    {
                        "id": 130270,
                        "name": "Huyện Cần Giuộc",
                        "latitude": "10.57742000",
                        "longitude": "106.67279000"
                    },
                    {
                        "id": 130251,
                        "name": "Huyện Châu Thành",
                        "latitude": "10.45214000",
                        "longitude": "106.49015000"
                    },
                    {
                        "id": 130551,
                        "name": "Huyện Đức Hòa",
                        "latitude": "10.87838000",
                        "longitude": "106.42422000"
                    },
                    {
                        "id": 130550,
                        "name": "Huyện Đức Huệ",
                        "latitude": "10.86473000",
                        "longitude": "106.25914000"
                    },
                    {
                        "id": 130368,
                        "name": "Huyện Mộc Hóa",
                        "latitude": "10.75166000",
                        "longitude": "106.01729000"
                    },
                    {
                        "id": 130482,
                        "name": "Huyện Tân Hưng",
                        "latitude": "10.83380000",
                        "longitude": "105.68848000"
                    },
                    {
                        "id": 130488,
                        "name": "Huyện Tân Thạnh",
                        "latitude": "10.60351000",
                        "longitude": "105.96576000"
                    },
                    {
                        "id": 130489,
                        "name": "Huyện Tân Trụ",
                        "latitude": "10.53182000",
                        "longitude": "106.51644000"
                    },
                    {
                        "id": 130448,
                        "name": "Huyện Thạnh Hóa",
                        "latitude": "10.66667000",
                        "longitude": "106.16667000"
                    },
                    {
                        "id": 130454,
                        "name": "Huyện Thủ Thừa",
                        "latitude": "10.65639000",
                        "longitude": "106.34580000"
                    },
                    {
                        "id": 130499,
                        "name": "Huyện Vĩnh Hưng",
                        "latitude": "10.88299000",
                        "longitude": "105.80364000"
                    },
                    {
                        "id": 130620,
                        "name": "Tân An",
                        "latitude": "10.53589000",
                        "longitude": "106.41366000"
                    }
                ]
            },
            {
                "id": 3789,
                "name": "Nam Định",
                "iso2": "67",
                "latitude": "20.43882250",
                "longitude": "106.16210530",
                "type": "province",
                "cities": [
                    {
                        "id": 130287,
                        "name": "Huyện Giao Thủy",
                        "latitude": "20.25706000",
                        "longitude": "106.46245000"
                    },
                    {
                        "id": 130315,
                        "name": "Huyện Hải Hậu",
                        "latitude": "20.15057000",
                        "longitude": "106.27161000"
                    },
                    {
                        "id": 130370,
                        "name": "Huyện Mỹ Lộc",
                        "latitude": "20.46079000",
                        "longitude": "106.12319000"
                    },
                    {
                        "id": 130377,
                        "name": "Huyện Nam Trực",
                        "latitude": "20.34106000",
                        "longitude": "106.20821000"
                    },
                    {
                        "id": 130384,
                        "name": "Huyện Nghĩa Hưng",
                        "latitude": "20.10598000",
                        "longitude": "106.17345000"
                    },
                    {
                        "id": 130474,
                        "name": "Huyện Trực Ninh",
                        "latitude": "20.25690000",
                        "longitude": "106.24582000"
                    },
                    {
                        "id": 130509,
                        "name": "Huyện Vụ Bản",
                        "latitude": "20.37705000",
                        "longitude": "106.09707000"
                    },
                    {
                        "id": 130526,
                        "name": "Huyện Ý Yên",
                        "latitude": "20.31669000",
                        "longitude": "106.02327000"
                    },
                    {
                        "id": 130575,
                        "name": "Nam Định",
                        "latitude": "20.43389000",
                        "longitude": "106.17729000"
                    }
                ]
            },
            {
                "id": 3780,
                "name": "Nghệ An",
                "iso2": "22",
                "latitude": "19.23424890",
                "longitude": "104.92003650",
                "type": "province",
                "cities": [
                    {
                        "id": 130212,
                        "name": "Huyện Anh Sơn",
                        "latitude": "18.92902000",
                        "longitude": "105.08294000"
                    },
                    {
                        "id": 130264,
                        "name": "Huyện Con Cuông",
                        "latitude": "19.03898000",
                        "longitude": "104.80353000"
                    },
                    {
                        "id": 130279,
                        "name": "Huyện Diễn Châu",
                        "latitude": "18.98892000",
                        "longitude": "105.57625000"
                    },
                    {
                        "id": 130532,
                        "name": "Huyện Đô Lương",
                        "latitude": "18.89259000",
                        "longitude": "105.34027000"
                    },
                    {
                        "id": 130310,
                        "name": "Huyện Hưng Nguyên",
                        "latitude": "18.67811000",
                        "longitude": "105.62523000"
                    },
                    {
                        "id": 130339,
                        "name": "Huyện Kỳ Sơn",
                        "latitude": "19.42397000",
                        "longitude": "104.22199000"
                    },
                    {
                        "id": 130378,
                        "name": "Huyện Nam Đàn",
                        "latitude": "18.67041000",
                        "longitude": "105.52575000"
                    },
                    {
                        "id": 130381,
                        "name": "Huyện Nghi Lộc",
                        "latitude": "18.83131000",
                        "longitude": "105.62411000"
                    },
                    {
                        "id": 130385,
                        "name": "Huyện Nghĩa Đàn",
                        "latitude": "19.38234000",
                        "longitude": "105.44072000"
                    },
                    {
                        "id": 130411,
                        "name": "Huyện Quế Phong",
                        "latitude": "19.70177000",
                        "longitude": "104.87913000"
                    },
                    {
                        "id": 130413,
                        "name": "Huyện Quỳ Châu",
                        "latitude": "19.55707000",
                        "longitude": "105.09173000"
                    },
                    {
                        "id": 130414,
                        "name": "Huyện Quỳ Hợp",
                        "latitude": "19.32514000",
                        "longitude": "105.16009000"
                    },
                    {
                        "id": 130415,
                        "name": "Huyện Quỳnh Lưu",
                        "latitude": "19.22717000",
                        "longitude": "105.64354000"
                    },
                    {
                        "id": 130436,
                        "name": "Huyện Thanh Chương",
                        "latitude": "18.73929000",
                        "longitude": "105.24053000"
                    },
                    {
                        "id": 130492,
                        "name": "Huyện Tương Dương",
                        "latitude": "19.30979000",
                        "longitude": "104.57788000"
                    },
                    {
                        "id": 130520,
                        "name": "Huyện Yên Thành",
                        "latitude": "19.02724000",
                        "longitude": "105.43649000"
                    },
                    {
                        "id": 130622,
                        "name": "Vinh",
                        "latitude": "18.67337000",
                        "longitude": "105.69232000"
                    },
                    {
                        "id": 130629,
                        "name": "Yên Vinh",
                        "latitude": "18.66667000",
                        "longitude": "105.66667000"
                    }
                ]
            },
            {
                "id": 3786,
                "name": "Ninh Bình",
                "iso2": "18",
                "latitude": "20.25061490",
                "longitude": "105.97445360",
                "type": "province",
                "cities": [
                    {
                        "id": 130297,
                        "name": "Huyện Hoa Lư",
                        "latitude": "20.25391000",
                        "longitude": "105.90789000"
                    },
                    {
                        "id": 130327,
                        "name": "Huyện Kim Sơn",
                        "latitude": "20.06034000",
                        "longitude": "106.09863000"
                    },
                    {
                        "id": 130390,
                        "name": "Huyện Nho Quan",
                        "latitude": "20.27606000",
                        "longitude": "105.75442000"
                    },
                    {
                        "id": 130513,
                        "name": "Huyện Yên Khánh",
                        "latitude": "20.19017000",
                        "longitude": "106.09605000"
                    },
                    {
                        "id": 130517,
                        "name": "Huyện Yên Mô",
                        "latitude": "20.12984000",
                        "longitude": "106.00199000"
                    },
                    {
                        "id": 130577,
                        "name": "Ninh Bình",
                        "latitude": "20.25809000",
                        "longitude": "105.97965000"
                    }
                ]
            },
            {
                "id": 3788,
                "name": "Ninh Thuận",
                "iso2": "36",
                "latitude": "11.67387670",
                "longitude": "108.86295720",
                "type": "province",
                "cities": [
                    {
                        "id": 130578,
                        "name": "Phan Rang-Tháp Chàm",
                        "latitude": "11.56432000",
                        "longitude": "108.98858000"
                    }
                ]
            },
            {
                "id": 3801,
                "name": "Phú Thọ",
                "iso2": "68",
                "latitude": "21.26844300",
                "longitude": "105.20455730",
                "type": "province",
                "cities": [
                    {
                        "id": 130275,
                        "name": "Huyện Cẩm Khê",
                        "latitude": "21.40683000",
                        "longitude": "105.09845000"
                    },
                    {
                        "id": 130530,
                        "name": "Huyện Đoan Hùng",
                        "latitude": "21.61776000",
                        "longitude": "105.16110000"
                    },
                    {
                        "id": 130312,
                        "name": "Huyện Hạ Hòa",
                        "latitude": "21.57763000",
                        "longitude": "104.99464000"
                    },
                    {
                        "id": 130203,
                        "name": "Huyen Lam Thao",
                        "latitude": "21.29971000",
                        "longitude": "105.31119000"
                    },
                    {
                        "id": 130434,
                        "name": "Huyện Thanh Ba",
                        "latitude": "21.47816000",
                        "longitude": "105.15881000"
                    },
                    {
                        "id": 130515,
                        "name": "Huyện Yên Lập",
                        "latitude": "21.35569000",
                        "longitude": "105.00493000"
                    },
                    {
                        "id": 130603,
                        "name": "Thành Phố Việt Trì",
                        "latitude": "21.32958000",
                        "longitude": "105.39217000"
                    },
                    {
                        "id": 130615,
                        "name": "Thị xã Phú Thọ",
                        "latitude": "21.41664000",
                        "longitude": "105.23636000"
                    },
                    {
                        "id": 130623,
                        "name": "Việt Trì",
                        "latitude": "21.32274000",
                        "longitude": "105.40198000"
                    }
                ]
            },
            {
                "id": 3824,
                "name": "Phú Yên",
                "iso2": "32",
                "latitude": "13.08818610",
                "longitude": "109.09287640",
                "type": "province",
                "cities": [
                    {
                        "id": 130425,
                        "name": "Huyện Sơn Hòa",
                        "latitude": "13.15868000",
                        "longitude": "108.97281000"
                    },
                    {
                        "id": 130421,
                        "name": "Huyện Sông Hinh",
                        "latitude": "12.91667000",
                        "longitude": "108.91667000"
                    },
                    {
                        "id": 130593,
                        "name": "Sông Cầu",
                        "latitude": "13.45560000",
                        "longitude": "109.22348000"
                    },
                    {
                        "id": 130618,
                        "name": "Tuy Hòa",
                        "latitude": "13.09546000",
                        "longitude": "109.32094000"
                    }
                ]
            },
            {
                "id": 3809,
                "name": "Quảng Bình",
                "iso2": "24",
                "latitude": "17.61027150",
                "longitude": "106.34874740",
                "type": "province",
                "cities": [
                    {
                        "id": 130352,
                        "name": "Huyện Lệ Thủy",
                        "latitude": "17.11239000",
                        "longitude": "106.70471000"
                    },
                    {
                        "id": 130407,
                        "name": "Huyện Quảng Ninh",
                        "latitude": "17.27067000",
                        "longitude": "106.51387000"
                    },
                    {
                        "id": 130408,
                        "name": "Huyện Quảng Trạch",
                        "latitude": "17.83447000",
                        "longitude": "106.36705000"
                    },
                    {
                        "id": 130477,
                        "name": "Huyện Tuyên Hóa",
                        "latitude": "17.91323000",
                        "longitude": "106.02678000"
                    },
                    {
                        "id": 130566,
                        "name": "Kwang Binh",
                        "latitude": "17.46885000",
                        "longitude": "106.62226000"
                    }
                ]
            },
            {
                "id": 3776,
                "name": "Quảng Nam",
                "iso2": "27",
                "latitude": "15.53935380",
                "longitude": "108.01910200",
                "type": "province",
                "cities": [
                    {
                        "id": 130563,
                        "name": "Hội An",
                        "latitude": "15.87944000",
                        "longitude": "108.33500000"
                    },
                    {
                        "id": 130281,
                        "name": "Huyện Duy Xuyên",
                        "latitude": "15.78970000",
                        "longitude": "108.20247000"
                    },
                    {
                        "id": 130538,
                        "name": "Huyện Đại Lộc",
                        "latitude": "15.83721000",
                        "longitude": "107.97894000"
                    },
                    {
                        "id": 130529,
                        "name": "Huyện Điện Bàn",
                        "latitude": "15.89917000",
                        "longitude": "108.22470000"
                    },
                    {
                        "id": 130296,
                        "name": "Huyện Hiệp Đức",
                        "latitude": "15.53857000",
                        "longitude": "108.09539000"
                    },
                    {
                        "id": 130375,
                        "name": "Huyện Nam Giang",
                        "latitude": "15.63201000",
                        "longitude": "107.60267000"
                    },
                    {
                        "id": 130394,
                        "name": "Huyện Núi Thành",
                        "latitude": "15.43345000",
                        "longitude": "108.57438000"
                    },
                    {
                        "id": 130403,
                        "name": "Huyện Phước Sơn",
                        "latitude": "15.38806000",
                        "longitude": "107.85766000"
                    },
                    {
                        "id": 130457,
                        "name": "Huyện Tiên Phước",
                        "latitude": "15.47090000",
                        "longitude": "108.28257000"
                    },
                    {
                        "id": 130467,
                        "name": "Huyện Trà My",
                        "latitude": "15.25000000",
                        "longitude": "108.08333000"
                    },
                    {
                        "id": 130596,
                        "name": "Tam Kỳ",
                        "latitude": "15.57364000",
                        "longitude": "108.47403000"
                    }
                ]
            },
            {
                "id": 3828,
                "name": "Quảng Ngãi",
                "iso2": "29",
                "latitude": "15.12138730",
                "longitude": "108.80441450",
                "type": "province",
                "cities": [
                    {
                        "id": 130216,
                        "name": "Huyện Ba Tơ",
                        "latitude": "14.73973000",
                        "longitude": "108.69326000"
                    },
                    {
                        "id": 130224,
                        "name": "Huyện Bình Sơn",
                        "latitude": "15.31899000",
                        "longitude": "108.76383000"
                    },
                    {
                        "id": 130552,
                        "name": "Huyện Đức Phổ",
                        "latitude": "14.78000000",
                        "longitude": "108.97857000"
                    },
                    {
                        "id": 130348,
                        "name": "Huyện Lý Sơn",
                        "latitude": "15.40608000",
                        "longitude": "109.09707000"
                    },
                    {
                        "id": 130359,
                        "name": "Huyện Minh Long",
                        "latitude": "14.95375000",
                        "longitude": "108.67724000"
                    },
                    {
                        "id": 130366,
                        "name": "Huyện Mộ Đức",
                        "latitude": "14.95515000",
                        "longitude": "108.88841000"
                    },
                    {
                        "id": 130383,
                        "name": "Huyện Nghĩa Hành",
                        "latitude": "14.98712000",
                        "longitude": "108.80036000"
                    },
                    {
                        "id": 130424,
                        "name": "Huyện Sơn Hà",
                        "latitude": "14.98427000",
                        "longitude": "108.53643000"
                    },
                    {
                        "id": 130426,
                        "name": "Huyện Sơn Tây",
                        "latitude": "14.96392000",
                        "longitude": "108.36419000"
                    },
                    {
                        "id": 130427,
                        "name": "Huyện Sơn Tịnh",
                        "latitude": "15.19090000",
                        "longitude": "108.74295000"
                    },
                    {
                        "id": 130464,
                        "name": "Huyện Trà Bồng",
                        "latitude": "15.23752000",
                        "longitude": "108.52633000"
                    },
                    {
                        "id": 130491,
                        "name": "Huyện Tư Nghĩa",
                        "latitude": "15.09499000",
                        "longitude": "108.77053000"
                    },
                    {
                        "id": 130585,
                        "name": "Quảng Ngãi",
                        "latitude": "15.12047000",
                        "longitude": "108.79232000"
                    }
                ]
            },
            {
                "id": 3814,
                "name": "Quảng Ninh",
                "iso2": "13",
                "latitude": "21.00638200",
                "longitude": "107.29251440",
                "type": "province",
                "cities": [
                    {
                        "id": 130192,
                        "name": "Cẩm Phả",
                        "latitude": "21.01004000",
                        "longitude": "107.27345000"
                    },
                    {
                        "id": 130193,
                        "name": "Cẩm Phả Mines",
                        "latitude": "21.01667000",
                        "longitude": "107.30000000"
                    },
                    {
                        "id": 130561,
                        "name": "Hạ Long",
                        "latitude": "20.95045000",
                        "longitude": "107.07336000"
                    },
                    {
                        "id": 130214,
                        "name": "Huyện Ba Chẽ",
                        "latitude": "21.29503000",
                        "longitude": "107.19298000"
                    },
                    {
                        "id": 130222,
                        "name": "Huyện Bình Liêu",
                        "latitude": "21.54389000",
                        "longitude": "107.44047000"
                    },
                    {
                        "id": 130268,
                        "name": "Huyện Cô Tô",
                        "latitude": "21.05418000",
                        "longitude": "107.80698000"
                    },
                    {
                        "id": 130541,
                        "name": "Huyện Đầm Hà",
                        "latitude": "21.39689000",
                        "longitude": "107.56175000"
                    },
                    {
                        "id": 130534,
                        "name": "Huyện Đông Triều",
                        "latitude": "21.11043000",
                        "longitude": "106.59662000"
                    },
                    {
                        "id": 130314,
                        "name": "Huyện Hải Hà",
                        "latitude": "21.49537000",
                        "longitude": "107.66790000"
                    },
                    {
                        "id": 130299,
                        "name": "Huyện Hoành Bồ",
                        "latitude": "21.11888000",
                        "longitude": "107.03149000"
                    },
                    {
                        "id": 130458,
                        "name": "Huyện Tiên Yên",
                        "latitude": "21.37571000",
                        "longitude": "107.37468000"
                    },
                    {
                        "id": 130494,
                        "name": "Huyện Vân Đồn",
                        "latitude": "21.04921000",
                        "longitude": "107.50971000"
                    },
                    {
                        "id": 130573,
                        "name": "Móng Cái",
                        "latitude": "21.52471000",
                        "longitude": "107.96619000"
                    },
                    {
                        "id": 130602,
                        "name": "Thành Phố Uông Bí",
                        "latitude": "21.03433000",
                        "longitude": "106.77049000"
                    }
                ]
            },
            {
                "id": 3803,
                "name": "Quảng Trị",
                "iso2": "25",
                "latitude": "16.74030740",
                "longitude": "107.18546790",
                "type": "province",
                "cities": [
                    {
                        "id": 130631,
                        "name": "Ðông Hà",
                        "latitude": "16.81625000",
                        "longitude": "107.10031000"
                    },
                    {
                        "id": 130242,
                        "name": "Huyện Cam Lộ",
                        "latitude": "16.79335000",
                        "longitude": "106.96175000"
                    },
                    {
                        "id": 130527,
                        "name": "Huyện Đa Krông",
                        "latitude": "16.55543000",
                        "longitude": "106.97208000"
                    },
                    {
                        "id": 130288,
                        "name": "Huyện Gio Linh",
                        "latitude": "16.91667000",
                        "longitude": "107.00000000"
                    },
                    {
                        "id": 130316,
                        "name": "Huyện Hải Lăng",
                        "latitude": "16.67574000",
                        "longitude": "107.23388000"
                    },
                    {
                        "id": 130311,
                        "name": "Huyện Hướng Hóa",
                        "latitude": "16.70132000",
                        "longitude": "106.67036000"
                    },
                    {
                        "id": 130462,
                        "name": "Huyện Triệu Phong",
                        "latitude": "16.78132000",
                        "longitude": "107.16034000"
                    },
                    {
                        "id": 130500,
                        "name": "Huyện Vĩnh Linh",
                        "latitude": "17.01600000",
                        "longitude": "106.93384000"
                    }
                ]
            },
            {
                "id": 3819,
                "name": "Sóc Trăng",
                "iso2": "52",
                "latitude": "9.60252100",
                "longitude": "105.97390490",
                "type": "province",
                "cities": [
                    {
                        "id": 130336,
                        "name": "Huyện Kế Sách",
                        "latitude": "9.81771000",
                        "longitude": "105.94190000"
                    },
                    {
                        "id": 130343,
                        "name": "Huyện Long Phú",
                        "latitude": "9.63715000",
                        "longitude": "106.08226000"
                    },
                    {
                        "id": 130371,
                        "name": "Huyện Mỹ Tú",
                        "latitude": "9.60849000",
                        "longitude": "105.80681000"
                    },
                    {
                        "id": 130372,
                        "name": "Huyện Mỹ Xuyên",
                        "latitude": "9.44200000",
                        "longitude": "105.88546000"
                    },
                    {
                        "id": 130205,
                        "name": "Huyen Nga Nam",
                        "latitude": "9.56127000",
                        "longitude": "105.59476000"
                    },
                    {
                        "id": 130450,
                        "name": "Huyện Thạnh Trị",
                        "latitude": "9.46939000",
                        "longitude": "105.71196000"
                    },
                    {
                        "id": 130592,
                        "name": "Sóc Trăng",
                        "latitude": "9.59995000",
                        "longitude": "105.97193000"
                    }
                ]
            },
            {
                "id": 3812,
                "name": "Sơn La",
                "iso2": "05",
                "latitude": "21.10222840",
                "longitude": "103.72891670",
                "type": "province",
                "cities": [
                    {
                        "id": 130238,
                        "name": "Huyện Bắc Yên",
                        "latitude": "21.25042000",
                        "longitude": "104.38501000"
                    },
                    {
                        "id": 130356,
                        "name": "Huyện Mai Sơn",
                        "latitude": "21.15884000",
                        "longitude": "104.04821000"
                    },
                    {
                        "id": 130367,
                        "name": "Huyện Mộc Châu",
                        "latitude": "21.83333000",
                        "longitude": "104.75000000"
                    },
                    {
                        "id": 130363,
                        "name": "Huyện Mường La",
                        "latitude": "21.52960000",
                        "longitude": "104.11113000"
                    },
                    {
                        "id": 130398,
                        "name": "Huyện Phù Yên",
                        "latitude": "21.21412000",
                        "longitude": "104.68993000"
                    },
                    {
                        "id": 130416,
                        "name": "Huyện Quỳnh Nhai",
                        "latitude": "21.77224000",
                        "longitude": "103.64920000"
                    },
                    {
                        "id": 130422,
                        "name": "Huyện Sông Mã",
                        "latitude": "21.06971000",
                        "longitude": "103.68727000"
                    },
                    {
                        "id": 130440,
                        "name": "Huyện Thuận Châu",
                        "latitude": "21.42319000",
                        "longitude": "103.64408000"
                    },
                    {
                        "id": 130512,
                        "name": "Huyện Yên Châu",
                        "latitude": "21.00500000",
                        "longitude": "104.33264000"
                    },
                    {
                        "id": 130594,
                        "name": "Sơn La",
                        "latitude": "21.32560000",
                        "longitude": "103.91882000"
                    }
                ]
            },
            {
                "id": 3826,
                "name": "Tây Ninh",
                "iso2": "37",
                "latitude": "11.33515540",
                "longitude": "106.10988540",
                "type": "province",
                "cities": [
                    {
                        "id": 130239,
                        "name": "Huyện Bến Cầu",
                        "latitude": "11.12889000",
                        "longitude": "106.14296000"
                    },
                    {
                        "id": 130282,
                        "name": "Huyện Dương Minh Châu",
                        "latitude": "11.31833000",
                        "longitude": "106.25697000"
                    },
                    {
                        "id": 130294,
                        "name": "Huyện Gò Dầu",
                        "latitude": "11.15737000",
                        "longitude": "106.27307000"
                    },
                    {
                        "id": 130306,
                        "name": "Huyện Hòa Thành",
                        "latitude": "11.26706000",
                        "longitude": "106.14486000"
                    },
                    {
                        "id": 130480,
                        "name": "Huyện Tân Châu",
                        "latitude": "11.58739000",
                        "longitude": "106.28270000"
                    },
                    {
                        "id": 130472,
                        "name": "Huyện Trảng Bàng",
                        "latitude": "11.05720000",
                        "longitude": "106.37539000"
                    },
                    {
                        "id": 130581,
                        "name": "Phú Khương",
                        "latitude": "11.28333000",
                        "longitude": "106.13333000"
                    },
                    {
                        "id": 130621,
                        "name": "Tây Ninh",
                        "latitude": "11.31004000",
                        "longitude": "106.09828000"
                    }
                ]
            },
            {
                "id": 3775,
                "name": "Thái Bình",
                "iso2": "20",
                "latitude": "20.44634710",
                "longitude": "106.33658280",
                "type": "province",
                "cities": [
                    {
                        "id": 130524,
                        "name": "Huyện Ðông Hưng",
                        "latitude": "20.54388000",
                        "longitude": "106.34090000"
                    },
                    {
                        "id": 130309,
                        "name": "Huyện Hưng Hà",
                        "latitude": "20.59464000",
                        "longitude": "106.21230000"
                    },
                    {
                        "id": 130331,
                        "name": "Huyện Kiến Xương",
                        "latitude": "20.40081000",
                        "longitude": "106.42032000"
                    },
                    {
                        "id": 130417,
                        "name": "Huyện Quỳnh Phụ",
                        "latitude": "20.65095000",
                        "longitude": "106.36359000"
                    },
                    {
                        "id": 130442,
                        "name": "Huyện Thái Thụy",
                        "latitude": "20.53916000",
                        "longitude": "106.51688000"
                    },
                    {
                        "id": 130459,
                        "name": "Huyện Tiền Hải",
                        "latitude": "20.38465000",
                        "longitude": "106.52882000"
                    },
                    {
                        "id": 130504,
                        "name": "Huyện Vũ Thư",
                        "latitude": "20.43732000",
                        "longitude": "106.26529000"
                    },
                    {
                        "id": 130605,
                        "name": "Thái Bình",
                        "latitude": "20.45000000",
                        "longitude": "106.34002000"
                    }
                ]
            },
            {
                "id": 3807,
                "name": "Thái Nguyên",
                "iso2": "69",
                "latitude": "21.56715590",
                "longitude": "105.82520380",
                "type": "province",
                "cities": [
                    {
                        "id": 130606,
                        "name": "Thái Nguyên",
                        "latitude": "21.59422000",
                        "longitude": "105.84817000"
                    }
                ]
            },
            {
                "id": 3771,
                "name": "Thanh Hóa",
                "iso2": "21",
                "latitude": "19.80669200",
                "longitude": "105.78518160",
                "type": "province",
                "cities": [
                    {
                        "id": 130181,
                        "name": "Bỉm Sơn",
                        "latitude": "20.07806000",
                        "longitude": "105.86028000"
                    },
                    {
                        "id": 130218,
                        "name": "Huyện Bá Thước",
                        "latitude": "20.35767000",
                        "longitude": "105.25301000"
                    },
                    {
                        "id": 130276,
                        "name": "Huyện Cẩm Thủy",
                        "latitude": "20.19586000",
                        "longitude": "105.46817000"
                    },
                    {
                        "id": 130533,
                        "name": "Huyện Đông Sơn",
                        "latitude": "19.79742000",
                        "longitude": "105.72465000"
                    },
                    {
                        "id": 130301,
                        "name": "Huyện Hà Trung",
                        "latitude": "20.02654000",
                        "longitude": "105.81931000"
                    },
                    {
                        "id": 130317,
                        "name": "Huyện Hậu Lộc",
                        "latitude": "19.93337000",
                        "longitude": "105.88894000"
                    },
                    {
                        "id": 130341,
                        "name": "Huyện Lang Chánh",
                        "latitude": "20.15926000",
                        "longitude": "105.15071000"
                    },
                    {
                        "id": 130364,
                        "name": "Huyện Mường Lát",
                        "latitude": "20.52763000",
                        "longitude": "104.62941000"
                    },
                    {
                        "id": 130380,
                        "name": "Huyện Nga Sơn",
                        "latitude": "20.01561000",
                        "longitude": "105.98975000"
                    },
                    {
                        "id": 130389,
                        "name": "Huyện Ngọc Lặc",
                        "latitude": "20.06777000",
                        "longitude": "105.37386000"
                    },
                    {
                        "id": 130391,
                        "name": "Huyện Như Thanh",
                        "latitude": "19.57798000",
                        "longitude": "105.55616000"
                    },
                    {
                        "id": 130392,
                        "name": "Huyện Như Xuân",
                        "latitude": "19.62527000",
                        "longitude": "105.38856000"
                    },
                    {
                        "id": 130393,
                        "name": "Huyện Nông Cống",
                        "latitude": "19.61376000",
                        "longitude": "105.68279000"
                    },
                    {
                        "id": 130404,
                        "name": "Huyện Quan Hóa",
                        "latitude": "20.47565000",
                        "longitude": "104.95335000"
                    },
                    {
                        "id": 130405,
                        "name": "Huyện Quan Sơn",
                        "latitude": "20.25758000",
                        "longitude": "104.83416000"
                    },
                    {
                        "id": 130409,
                        "name": "Huyện Quảng Xương",
                        "latitude": "19.70252000",
                        "longitude": "105.79298000"
                    },
                    {
                        "id": 130439,
                        "name": "Huyện Thiệu Hóa",
                        "latitude": "19.89713000",
                        "longitude": "105.68144000"
                    },
                    {
                        "id": 130451,
                        "name": "Huyện Thọ Xuân",
                        "latitude": "19.93114000",
                        "longitude": "105.48284000"
                    },
                    {
                        "id": 130445,
                        "name": "Huyện Thường Xuân",
                        "latitude": "19.93684000",
                        "longitude": "105.24109000"
                    },
                    {
                        "id": 130463,
                        "name": "Huyện Triệu Sơn",
                        "latitude": "19.82578000",
                        "longitude": "105.58293000"
                    },
                    {
                        "id": 130501,
                        "name": "Huyện Vĩnh Lộc",
                        "latitude": "20.03482000",
                        "longitude": "105.65755000"
                    },
                    {
                        "id": 130522,
                        "name": "Huyện Yên Định",
                        "latitude": "19.98666000",
                        "longitude": "105.61482000"
                    },
                    {
                        "id": 130597,
                        "name": "Thanh Hóa",
                        "latitude": "19.80000000",
                        "longitude": "105.76667000"
                    }
                ]
            },
            {
                "id": 3798,
                "name": "Thừa Thiên-Huế",
                "iso2": "26",
                "latitude": "16.46739700",
                "longitude": "107.59053260",
                "type": "province",
                "cities": [
                    {
                        "id": 130554,
                        "name": "Huế",
                        "latitude": "16.46190000",
                        "longitude": "107.59546000"
                    },
                    {
                        "id": 130207,
                        "name": "Huyện A Lưới",
                        "latitude": "16.23422000",
                        "longitude": "107.30650000"
                    },
                    {
                        "id": 130379,
                        "name": "Huyện Nam Đông",
                        "latitude": "16.12396000",
                        "longitude": "107.69270000"
                    },
                    {
                        "id": 130395,
                        "name": "Huyện Phong Điền",
                        "latitude": "16.48769000",
                        "longitude": "107.28889000"
                    },
                    {
                        "id": 130399,
                        "name": "Huyện Phú Lộc",
                        "latitude": "16.27066000",
                        "longitude": "107.88545000"
                    },
                    {
                        "id": 130402,
                        "name": "Huyện Phú Vang",
                        "latitude": "16.47007000",
                        "longitude": "107.71458000"
                    },
                    {
                        "id": 130410,
                        "name": "Huyện Quảng Ðiền",
                        "latitude": "16.57941000",
                        "longitude": "107.49370000"
                    }
                ]
            },
            {
                "id": 3781,
                "name": "Tiền Giang",
                "iso2": "46",
                "latitude": "10.44933240",
                "longitude": "106.34205040",
                "type": "province",
                "cities": [
                    {
                        "id": 130266,
                        "name": "Huyện Cái Bè",
                        "latitude": "10.38824000",
                        "longitude": "105.94620000"
                    },
                    {
                        "id": 130241,
                        "name": "Huyện Cai Lậy",
                        "latitude": "10.38943000",
                        "longitude": "106.06774000"
                    },
                    {
                        "id": 130252,
                        "name": "Huyện Châu Thành",
                        "latitude": "10.38600000",
                        "longitude": "106.27311000"
                    },
                    {
                        "id": 130260,
                        "name": "Huyện Chợ Gạo",
                        "latitude": "10.37373000",
                        "longitude": "106.44341000"
                    },
                    {
                        "id": 130293,
                        "name": "Huyện Gò Công Đông",
                        "latitude": "10.36784000",
                        "longitude": "106.74592000"
                    },
                    {
                        "id": 130292,
                        "name": "Huyện Gò Công Tây",
                        "latitude": "10.34527000",
                        "longitude": "106.59851000"
                    },
                    {
                        "id": 130486,
                        "name": "Huyện Tân Phước",
                        "latitude": "10.51489000",
                        "longitude": "106.23312000"
                    },
                    {
                        "id": 130574,
                        "name": "Mỹ Tho",
                        "latitude": "10.36004000",
                        "longitude": "106.35996000"
                    },
                    {
                        "id": 130599,
                        "name": "Thành Phố Mỹ Tho",
                        "latitude": "10.36221000",
                        "longitude": "106.36824000"
                    },
                    {
                        "id": 130610,
                        "name": "Thị Xã Gò Công",
                        "latitude": "10.40005000",
                        "longitude": "106.65847000"
                    }
                ]
            },
            {
                "id": 3805,
                "name": "Trà Vinh",
                "iso2": "51",
                "latitude": "9.81274100",
                "longitude": "106.29929120",
                "type": "province",
                "cities": [
                    {
                        "id": 130265,
                        "name": "Huyện Càng Long",
                        "latitude": "9.95883000",
                        "longitude": "106.21395000"
                    },
                    {
                        "id": 130272,
                        "name": "Huyện Cầu Kè",
                        "latitude": "9.86738000",
                        "longitude": "106.07916000"
                    },
                    {
                        "id": 130273,
                        "name": "Huyện Cầu Ngang",
                        "latitude": "9.77186000",
                        "longitude": "106.43654000"
                    },
                    {
                        "id": 130460,
                        "name": "Huyện Tiểu Cần",
                        "latitude": "9.80350000",
                        "longitude": "106.20594000"
                    },
                    {
                        "id": 130465,
                        "name": "Huyện Trà Cú",
                        "latitude": "9.69706000",
                        "longitude": "106.29423000"
                    },
                    {
                        "id": 130617,
                        "name": "Trà Vinh",
                        "latitude": "9.94719000",
                        "longitude": "106.34225000"
                    }
                ]
            },
            {
                "id": 3795,
                "name": "Tuyên Quang",
                "iso2": "07",
                "latitude": "21.77672460",
                "longitude": "105.22801960",
                "type": "province",
                "cities": [
                    {
                        "id": 130247,
                        "name": "Huyện Chiêm Hóa",
                        "latitude": "22.17895000",
                        "longitude": "105.27671000"
                    },
                    {
                        "id": 130305,
                        "name": "Huyện Hàm Yên",
                        "latitude": "22.10935000",
                        "longitude": "105.01630000"
                    },
                    {
                        "id": 130345,
                        "name": "Huyện Lâm Bình",
                        "latitude": "22.46411000",
                        "longitude": "105.21903000"
                    },
                    {
                        "id": 130373,
                        "name": "Huyện Na Hang",
                        "latitude": "22.47522000",
                        "longitude": "105.48380000"
                    },
                    {
                        "id": 130423,
                        "name": "Huyện Sơn Dương",
                        "latitude": "21.63623000",
                        "longitude": "105.38901000"
                    },
                    {
                        "id": 130519,
                        "name": "Huyện Yên Sơn",
                        "latitude": "21.88363000",
                        "longitude": "105.27656000"
                    },
                    {
                        "id": 130619,
                        "name": "Tuyên Quang",
                        "latitude": "21.82356000",
                        "longitude": "105.21424000"
                    }
                ]
            },
            {
                "id": 3790,
                "name": "Vĩnh Long",
                "iso2": "49",
                "latitude": "10.23957400",
                "longitude": "105.95719280",
                "type": "province",
                "cities": [
                    {
                        "id": 130342,
                        "name": "Huyện Long Hồ",
                        "latitude": "10.21640000",
                        "longitude": "105.98483000"
                    },
                    {
                        "id": 130357,
                        "name": "Huyện Mang Thít",
                        "latitude": "10.18731000",
                        "longitude": "106.07472000"
                    },
                    {
                        "id": 130428,
                        "name": "Huyện Tam Bình",
                        "latitude": "10.08127000",
                        "longitude": "105.95352000"
                    },
                    {
                        "id": 130468,
                        "name": "Huyện Trà Ôn",
                        "latitude": "9.97522000",
                        "longitude": "106.00957000"
                    },
                    {
                        "id": 130505,
                        "name": "Huyện Vũng Liêm",
                        "latitude": "10.08717000",
                        "longitude": "106.16038000"
                    },
                    {
                        "id": 130624,
                        "name": "Vĩnh Long",
                        "latitude": "10.25369000",
                        "longitude": "105.97220000"
                    }
                ]
            },
            {
                "id": 3774,
                "name": "Vĩnh Phúc",
                "iso2": "70",
                "latitude": "21.36088050",
                "longitude": "105.54743730",
                "type": "province",
                "cities": [
                    {
                        "id": 130225,
                        "name": "Huyện Bình Xuyên",
                        "latitude": "21.30561000",
                        "longitude": "105.66225000"
                    },
                    {
                        "id": 130429,
                        "name": "Huyện Tam Dương",
                        "latitude": "21.36189000",
                        "longitude": "105.55690000"
                    },
                    {
                        "id": 130432,
                        "name": "Huyện Tam Đảo",
                        "latitude": "21.45690000",
                        "longitude": "105.59460000"
                    },
                    {
                        "id": 130514,
                        "name": "Huyện Yên Lạc",
                        "latitude": "21.21845000",
                        "longitude": "105.57586000"
                    },
                    {
                        "id": 130625,
                        "name": "Vĩnh Yên",
                        "latitude": "21.30891000",
                        "longitude": "105.60489000"
                    }
                ]
            },
            {
                "id": 3784,
                "name": "Yên Bái",
                "iso2": "06",
                "latitude": "21.71676890",
                "longitude": "104.89858780",
                "type": "province",
                "cities": [
                    {
                        "id": 130355,
                        "name": "Huyện Lục Yên",
                        "latitude": "22.10235000",
                        "longitude": "104.72538000"
                    },
                    {
                        "id": 130360,
                        "name": "Huyện Mù Cang Chải",
                        "latitude": "21.78815000",
                        "longitude": "104.11998000"
                    },
                    {
                        "id": 130470,
                        "name": "Huyện Trạm Tấu",
                        "latitude": "21.48553000",
                        "longitude": "104.42756000"
                    },
                    {
                        "id": 130473,
                        "name": "Huyện Trấn Yên",
                        "latitude": "21.66586000",
                        "longitude": "104.79702000"
                    },
                    {
                        "id": 130496,
                        "name": "Huyện Văn Chấn",
                        "latitude": "21.55722000",
                        "longitude": "104.64038000"
                    },
                    {
                        "id": 130497,
                        "name": "Huyện Văn Yên",
                        "latitude": "21.90022000",
                        "longitude": "104.56669000"
                    },
                    {
                        "id": 130628,
                        "name": "Yên Bái",
                        "latitude": "21.72288000",
                        "longitude": "104.91130000"
                    }
                ]
            }
        ]
    },
    {
        "id": 241,
        "name": "Virgin Islands (British)",
        "iso3": "VGB",
        "iso2": "VG",
        "numeric_code": "092",
        "phonecode": "1",
        "capital": "Road Town",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".vg",
        "native": "British Virgin Islands",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "British Virgin Island",
        "timezones": [
            {
                "zoneName": "America\/Tortola",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Inizi Gwerc'h Breizhveurat",
            "ko": "영국령 버진아일랜드",
            "pt-BR": "Ilhas Virgens Britânicas",
            "pt": "Ilhas Virgens Britânicas",
            "nl": "Britse Maagdeneilanden",
            "hr": "Britanski Djevičanski Otoci",
            "fa": "جزایر ویرجین بریتانیا",
            "de": "Britische Jungferninseln",
            "es": "Islas Vírgenes del Reino Unido",
            "fr": "Îles Vierges britanniques",
            "ja": "イギリス領ヴァージン諸島",
            "it": "Isole Vergini Britanniche",
            "zh-CN": "圣文森特和格林纳丁斯",
            "tr": "Britanya Virjin Adalari",
            "ru": "Виргинские острова (Британские)",
            "uk": "Віргінські острови (Британські)",
            "pl": "Wyspy Dziewicze (Brytyjskie)"
        },
        "latitude": "18.43138300",
        "longitude": "-64.62305000",
        "emoji": "🇻🇬",
        "emojiU": "U+1F1FB U+1F1EC",
        "states": []
    },
    {
        "id": 242,
        "name": "Virgin Islands (US)",
        "iso3": "VIR",
        "iso2": "VI",
        "numeric_code": "850",
        "phonecode": "1",
        "capital": "Charlotte Amalie",
        "currency": "USD",
        "currency_name": "United States dollar",
        "currency_symbol": "$",
        "tld": ".vi",
        "native": "United States Virgin Islands",
        "region": "Americas",
        "region_id": 2,
        "subregion": "Caribbean",
        "subregion_id": 7,
        "nationality": "U.S. Virgin Island",
        "timezones": [
            {
                "zoneName": "America\/St_Thomas",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "br": "Inizi Gwerc'h ar Stadoù-Unanet",
            "ko": "미국령 버진아일랜드",
            "pt-BR": "Ilhas Virgens Americanas",
            "pt": "Ilhas Virgens Americanas",
            "nl": "Verenigde Staten Maagdeneilanden",
            "fa": "جزایر ویرجین آمریکا",
            "de": "Amerikanische Jungferninseln",
            "es": "Islas Vírgenes de los Estados Unidos",
            "fr": "Îles Vierges des États-Unis",
            "ja": "アメリカ領ヴァージン諸島",
            "it": "Isole Vergini americane",
            "zh-CN": "维尔京群岛（美国）",
            "tr": "Abd Virjin Adalari",
            "ru": "Виргинские острова (США)",
            "uk": "Віргінські острови (США)",
            "pl": "Wyspy Dziewicze (USA)"
        },
        "latitude": "18.34000000",
        "longitude": "-64.93000000",
        "emoji": "🇻🇮",
        "emojiU": "U+1F1FB U+1F1EE",
        "states": [
            {
                "id": 5074,
                "name": "Saint Croix",
                "iso2": "SC",
                "latitude": "17.72935200",
                "longitude": "-64.73437050",
                "type": "district",
                "cities": [
                    {
                        "id": 149573,
                        "name": "Christiansted",
                        "latitude": "17.74403640",
                        "longitude": "-64.71060860"
                    },
                    {
                        "id": 149574,
                        "name": "East End",
                        "latitude": "17.75238820",
                        "longitude": "-64.67030100"
                    },
                    {
                        "id": 149575,
                        "name": "Frederiksted",
                        "latitude": "17.71246910",
                        "longitude": "-64.88671920"
                    },
                    {
                        "id": 149572,
                        "name": "Good Hope",
                        "latitude": "17.72234420",
                        "longitude": "-64.71724940"
                    },
                    {
                        "id": 149576,
                        "name": "Northcentral",
                        "latitude": "17.75011450",
                        "longitude": "-64.82384910"
                    },
                    {
                        "id": 149577,
                        "name": "Northwest",
                        "latitude": "17.73827820",
                        "longitude": "-64.89063470"
                    },
                    {
                        "id": 149578,
                        "name": "Sion Farm",
                        "latitude": "17.75432760",
                        "longitude": "-64.77946110"
                    },
                    {
                        "id": 149579,
                        "name": "Southcentral",
                        "latitude": "17.70649170",
                        "longitude": "-64.81448650"
                    },
                    {
                        "id": 149580,
                        "name": "Southwest",
                        "latitude": "17.69177870",
                        "longitude": "-64.93559390"
                    }
                ]
            },
            {
                "id": 5073,
                "name": "Saint John",
                "iso2": "SJ",
                "latitude": "18.33561690",
                "longitude": "-64.80028000",
                "type": "district",
                "cities": [
                    {
                        "id": 149568,
                        "name": "Central",
                        "latitude": "18.33568380",
                        "longitude": "-64.79470780"
                    },
                    {
                        "id": 149569,
                        "name": "Coral Bay",
                        "latitude": "18.34800890",
                        "longitude": "-64.72196820"
                    },
                    {
                        "id": 149570,
                        "name": "Cruz Bay",
                        "latitude": "18.31820370",
                        "longitude": "-64.80242110"
                    },
                    {
                        "id": 149571,
                        "name": "East End",
                        "latitude": "18.34036470",
                        "longitude": "-64.68062660"
                    }
                ]
            },
            {
                "id": 5072,
                "name": "Saint Thomas",
                "iso2": "ST",
                "latitude": "18.34284590",
                "longitude": "-65.07701800",
                "type": "district",
                "cities": [
                    {
                        "id": 149561,
                        "name": "Charlotte Amalie",
                        "latitude": "18.34127610",
                        "longitude": "-64.94838690"
                    },
                    {
                        "id": 149562,
                        "name": "East End",
                        "latitude": "18.32901620",
                        "longitude": "-64.87047310"
                    },
                    {
                        "id": 149563,
                        "name": "Northside",
                        "latitude": "18.37380810",
                        "longitude": "-64.95589090"
                    },
                    {
                        "id": 149564,
                        "name": "Southside",
                        "latitude": "18.30529120",
                        "longitude": "-64.91724450"
                    },
                    {
                        "id": 149565,
                        "name": "Tutu",
                        "latitude": "18.33884270",
                        "longitude": "-64.89530720"
                    },
                    {
                        "id": 149566,
                        "name": "Water Island",
                        "latitude": "18.32086530",
                        "longitude": "-64.96932630"
                    },
                    {
                        "id": 149567,
                        "name": "West End",
                        "latitude": "18.37243670",
                        "longitude": "-65.06490130"
                    }
                ]
            }
        ]
    },
    {
        "id": 243,
        "name": "Wallis and Futuna Islands",
        "iso3": "WLF",
        "iso2": "WF",
        "numeric_code": "876",
        "phonecode": "681",
        "capital": "Mata Utu",
        "currency": "XPF",
        "currency_name": "CFP franc",
        "currency_symbol": "₣",
        "tld": ".wf",
        "native": "Wallis et Futuna",
        "region": "Oceania",
        "region_id": 5,
        "subregion": "Polynesia",
        "subregion_id": 22,
        "nationality": "Wallis and Futuna, Wallisian or Futunan",
        "timezones": [
            {
                "zoneName": "Pacific\/Wallis",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "WFT",
                "tzName": "Wallis & Futuna Time"
            }
        ],
        "translations": {
            "br": "Wallis ha Futuna",
            "ko": "왈리스 푸투나",
            "pt-BR": "Wallis e Futuna",
            "pt": "Wallis e Futuna",
            "nl": "Wallis en Futuna",
            "hr": "Wallis i Fortuna",
            "fa": "والیس و فوتونا",
            "de": "Wallis und Futuna",
            "es": "Wallis y Futuna",
            "fr": "Wallis-et-Futuna",
            "ja": "ウォリス・フツナ",
            "it": "Wallis e Futuna",
            "zh-CN": "瓦利斯群岛和富图纳群岛",
            "tr": "Wallis Ve Futuna",
            "ru": "Острова Уоллис и Футуна",
            "uk": "Острови Уолліс і Футуна",
            "pl": "Wyspy Wallis i Futuna"
        },
        "latitude": "-13.30000000",
        "longitude": "-176.20000000",
        "emoji": "🇼🇫",
        "emojiU": "U+1F1FC U+1F1EB",
        "states": []
    },
    {
        "id": 244,
        "name": "Western Sahara",
        "iso3": "ESH",
        "iso2": "EH",
        "numeric_code": "732",
        "phonecode": "212",
        "capital": "El-Aaiun",
        "currency": "MAD",
        "currency_name": "Moroccan dirham",
        "currency_symbol": "MAD",
        "tld": ".eh",
        "native": "الصحراء الغربية",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Northern Africa",
        "subregion_id": 1,
        "nationality": "Sahrawi, Sahrawian, Sahraouian",
        "timezones": [
            {
                "zoneName": "Africa\/El_Aaiun",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WEST",
                "tzName": "Western European Summer Time"
            }
        ],
        "translations": {
            "br": "Sahara ar C'hornôg",
            "ko": "서사하라",
            "pt-BR": "Saara Ocidental",
            "pt": "Saara Ocidental",
            "nl": "Westelijke Sahara",
            "hr": "Zapadna Sahara",
            "fa": "جمهوری دموکراتیک عربی صحرا",
            "de": "Westsahara",
            "es": "Sahara Occidental",
            "fr": "Sahara Occidental",
            "ja": "西サハラ",
            "it": "Sahara Occidentale",
            "zh-CN": "西撒哈拉",
            "tr": "Bati Sahra",
            "ru": "Западная Сахара",
            "uk": "Західна Сахара",
            "pl": "Sahara Zachodnia"
        },
        "latitude": "24.50000000",
        "longitude": "-13.00000000",
        "emoji": "🇪🇭",
        "emojiU": "U+1F1EA U+1F1ED",
        "states": []
    },
    {
        "id": 245,
        "name": "Yemen",
        "iso3": "YEM",
        "iso2": "YE",
        "numeric_code": "887",
        "phonecode": "967",
        "capital": "Sanaa",
        "currency": "YER",
        "currency_name": "Yemeni rial",
        "currency_symbol": "﷼",
        "tld": ".ye",
        "native": "اليَمَن",
        "region": "Asia",
        "region_id": 3,
        "subregion": "Western Asia",
        "subregion_id": 11,
        "nationality": "Yemeni",
        "timezones": [
            {
                "zoneName": "Asia\/Aden",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "br": "Yemen",
            "ko": "예멘",
            "pt-BR": "Iêmen",
            "pt": "Iémen",
            "nl": "Jemen",
            "hr": "Jemen",
            "fa": "یمن",
            "de": "Jemen",
            "es": "Yemen",
            "fr": "Yémen",
            "ja": "イエメン",
            "it": "Yemen",
            "zh-CN": "也门",
            "tr": "Yemen",
            "ru": "Йемен",
            "uk": "Ємен",
            "pl": "Jemen"
        },
        "latitude": "15.00000000",
        "longitude": "48.00000000",
        "emoji": "🇾🇪",
        "emojiU": "U+1F1FE U+1F1EA",
        "states": [
            {
                "id": 1242,
                "name": "'Adan",
                "iso2": "AD",
                "latitude": "12.82574810",
                "longitude": "44.79438040",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130669,
                        "name": "Aden",
                        "latitude": "12.77944000",
                        "longitude": "45.03667000"
                    },
                    {
                        "id": 130683,
                        "name": "Al Buraiqeh",
                        "latitude": "12.80377000",
                        "longitude": "44.77615000"
                    },
                    {
                        "id": 130719,
                        "name": "Al Mansura",
                        "latitude": "12.85320000",
                        "longitude": "44.97240000"
                    },
                    {
                        "id": 130735,
                        "name": "Al Mualla",
                        "latitude": "12.65843000",
                        "longitude": "43.42743000"
                    },
                    {
                        "id": 130789,
                        "name": "Ash Shaikh Outhman",
                        "latitude": "12.88640000",
                        "longitude": "45.01560000"
                    },
                    {
                        "id": 130801,
                        "name": "Attawahi",
                        "latitude": "12.77410000",
                        "longitude": "44.99410000"
                    },
                    {
                        "id": 130830,
                        "name": "Craiter",
                        "latitude": "12.77310000",
                        "longitude": "45.03810000"
                    },
                    {
                        "id": 130831,
                        "name": "Dar Sad",
                        "latitude": "12.90700000",
                        "longitude": "44.97840000"
                    }
                ]
            },
            {
                "id": 1250,
                "name": "'Amran",
                "iso2": "AM",
                "latitude": "16.25692140",
                "longitude": "43.94367880",
                "type": "governorate",
                "cities": [
                    {
                        "id": 131013,
                        "name": "‘Amrān",
                        "latitude": "15.65940000",
                        "longitude": "43.94385000"
                    },
                    {
                        "id": 130679,
                        "name": "Al Ashah",
                        "latitude": "16.32400000",
                        "longitude": "43.78740000"
                    },
                    {
                        "id": 130709,
                        "name": "Al Madan",
                        "latitude": "16.23280000",
                        "longitude": "43.63900000"
                    },
                    {
                        "id": 130745,
                        "name": "Al Qaflah",
                        "latitude": "16.33859000",
                        "longitude": "43.70361000"
                    },
                    {
                        "id": 130779,
                        "name": "As Sawd",
                        "latitude": "15.81340000",
                        "longitude": "43.77700000"
                    },
                    {
                        "id": 130784,
                        "name": "As Sudah",
                        "latitude": "15.96640000",
                        "longitude": "43.77560000"
                    },
                    {
                        "id": 130818,
                        "name": "Bani Suraim",
                        "latitude": "16.12530000",
                        "longitude": "43.96020000"
                    },
                    {
                        "id": 130836,
                        "name": "Dhi Bin",
                        "latitude": "16.02760000",
                        "longitude": "44.15150000"
                    },
                    {
                        "id": 130847,
                        "name": "Habur Zulaymah",
                        "latitude": "16.03500000",
                        "longitude": "43.73380000"
                    },
                    {
                        "id": 130855,
                        "name": "Harf Sufyan",
                        "latitude": "16.41389000",
                        "longitude": "43.98571000"
                    },
                    {
                        "id": 130866,
                        "name": "Hooth",
                        "latitude": "16.28397000",
                        "longitude": "43.97811000"
                    },
                    {
                        "id": 130872,
                        "name": "Iyal Surayh",
                        "latitude": "15.71460000",
                        "longitude": "43.99740000"
                    },
                    {
                        "id": 130875,
                        "name": "Jabal Iyal Yazid",
                        "latitude": "15.77170000",
                        "longitude": "43.90510000"
                    },
                    {
                        "id": 130886,
                        "name": "Khamir",
                        "latitude": "15.97653000",
                        "longitude": "43.93371000"
                    },
                    {
                        "id": 130889,
                        "name": "Kharif",
                        "latitude": "15.84700000",
                        "longitude": "44.08220000"
                    },
                    {
                        "id": 130915,
                        "name": "Maswar",
                        "latitude": "15.59860000",
                        "longitude": "43.69250000"
                    },
                    {
                        "id": 130953,
                        "name": "Raydah",
                        "latitude": "15.74056000",
                        "longitude": "44.05634000"
                    },
                    {
                        "id": 130975,
                        "name": "Shahārah",
                        "latitude": "16.18000000",
                        "longitude": "43.70942000"
                    },
                    {
                        "id": 130983,
                        "name": "Suwayr",
                        "latitude": "16.06110000",
                        "longitude": "43.62120000"
                    },
                    {
                        "id": 130990,
                        "name": "Thula",
                        "latitude": "15.60100000",
                        "longitude": "43.82520000"
                    }
                ]
            },
            {
                "id": 1237,
                "name": "Abyan",
                "iso2": "AB",
                "latitude": "13.63434130",
                "longitude": "46.05632120",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130673,
                        "name": "Ahwar",
                        "latitude": "13.68530000",
                        "longitude": "46.75560000"
                    },
                    {
                        "id": 130714,
                        "name": "Al Mahfad",
                        "latitude": "13.97050000",
                        "longitude": "46.75600000"
                    },
                    {
                        "id": 130752,
                        "name": "Al Wade'a",
                        "latitude": "13.71360000",
                        "longitude": "46.01220000"
                    },
                    {
                        "id": 130880,
                        "name": "Jawf al Maqbābah",
                        "latitude": "13.83783000",
                        "longitude": "45.83488000"
                    },
                    {
                        "id": 130881,
                        "name": "Jayshan",
                        "latitude": "14.16620000",
                        "longitude": "46.17230000"
                    },
                    {
                        "id": 130887,
                        "name": "Khanfir",
                        "latitude": "13.42049000",
                        "longitude": "45.68707000"
                    },
                    {
                        "id": 130900,
                        "name": "Lawdar",
                        "latitude": "13.80590000",
                        "longitude": "45.80080000"
                    },
                    {
                        "id": 130928,
                        "name": "Mudiyah",
                        "latitude": "13.90960000",
                        "longitude": "46.21960000"
                    },
                    {
                        "id": 130952,
                        "name": "Rasad",
                        "latitude": "13.72310000",
                        "longitude": "45.28140000"
                    },
                    {
                        "id": 130967,
                        "name": "Sarar",
                        "latitude": "13.58300000",
                        "longitude": "45.35080000"
                    },
                    {
                        "id": 130981,
                        "name": "Sibah",
                        "latitude": "13.80910000",
                        "longitude": "45.40230000"
                    },
                    {
                        "id": 131008,
                        "name": "Zingibar",
                        "latitude": "13.13420000",
                        "longitude": "45.43040000"
                    },
                    {
                        "id": 131009,
                        "name": "Zinjibār",
                        "latitude": "13.12871000",
                        "longitude": "45.38073000"
                    }
                ]
            },
            {
                "id": 1240,
                "name": "Al Bayda'",
                "iso2": "BA",
                "latitude": "14.35886620",
                "longitude": "45.44980650",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130676,
                        "name": "Al A'rsh",
                        "latitude": "14.36560000",
                        "longitude": "44.77780000"
                    },
                    {
                        "id": 130680,
                        "name": "Al Bayda",
                        "latitude": "13.98523000",
                        "longitude": "45.57272000"
                    },
                    {
                        "id": 130681,
                        "name": "Al Bayda City",
                        "latitude": "13.98490000",
                        "longitude": "45.55660000"
                    },
                    {
                        "id": 130682,
                        "name": "Al Bayḑā’",
                        "latitude": "13.93666000",
                        "longitude": "45.54822000"
                    },
                    {
                        "id": 130717,
                        "name": "Al Malagim",
                        "latitude": "14.36540000",
                        "longitude": "45.38510000"
                    },
                    {
                        "id": 130750,
                        "name": "Al Quraishyah",
                        "latitude": "14.60500000",
                        "longitude": "44.88960000"
                    },
                    {
                        "id": 130769,
                        "name": "Ar Ryashyyah",
                        "latitude": "14.24240000",
                        "longitude": "44.77540000"
                    },
                    {
                        "id": 130778,
                        "name": "As Sawadiyah",
                        "latitude": "14.45198000",
                        "longitude": "45.36973000"
                    },
                    {
                        "id": 130781,
                        "name": "As Sawma'ah",
                        "latitude": "14.16670000",
                        "longitude": "45.83110000"
                    },
                    {
                        "id": 130791,
                        "name": "Ash Sharafayn",
                        "latitude": "14.30697000",
                        "longitude": "45.12634000"
                    },
                    {
                        "id": 130796,
                        "name": "At Taffah",
                        "latitude": "14.19830000",
                        "longitude": "45.35810000"
                    },
                    {
                        "id": 130804,
                        "name": "Az Zahir",
                        "latitude": "13.99180000",
                        "longitude": "45.42180000"
                    },
                    {
                        "id": 130837,
                        "name": "Dhi Na'im",
                        "latitude": "14.11110000",
                        "longitude": "45.46420000"
                    },
                    {
                        "id": 130916,
                        "name": "Maswarah",
                        "latitude": "14.40270000",
                        "longitude": "45.70330000"
                    },
                    {
                        "id": 130930,
                        "name": "Mukayras",
                        "latitude": "14.03200000",
                        "longitude": "45.79640000"
                    },
                    {
                        "id": 130934,
                        "name": "Na'man",
                        "latitude": "14.59390000",
                        "longitude": "45.52860000"
                    },
                    {
                        "id": 130936,
                        "name": "Nati'",
                        "latitude": "14.55390000",
                        "longitude": "45.58500000"
                    },
                    {
                        "id": 130947,
                        "name": "Radā‘",
                        "latitude": "14.34000000",
                        "longitude": "44.90874000"
                    },
                    {
                        "id": 130946,
                        "name": "Radman Al Awad",
                        "latitude": "14.48360000",
                        "longitude": "45.27440000"
                    },
                    {
                        "id": 130959,
                        "name": "Sabah",
                        "latitude": "14.27590000",
                        "longitude": "44.67000000"
                    },
                    {
                        "id": 130998,
                        "name": "Wald Rabi'",
                        "latitude": "14.55574000",
                        "longitude": "44.90596000"
                    }
                ]
            },
            {
                "id": 1241,
                "name": "Al Hudaydah",
                "iso2": "HU",
                "latitude": "15.30530720",
                "longitude": "43.01948970",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130665,
                        "name": "Ad Dahi",
                        "latitude": "15.22320000",
                        "longitude": "43.19350000"
                    },
                    {
                        "id": 130667,
                        "name": "Ad Durayhimi",
                        "latitude": "14.60460000",
                        "longitude": "43.07180000"
                    },
                    {
                        "id": 130686,
                        "name": "Al Garrahi",
                        "latitude": "14.10580000",
                        "longitude": "43.40940000"
                    },
                    {
                        "id": 130692,
                        "name": "Al Hajjaylah",
                        "latitude": "14.99070000",
                        "longitude": "43.58230000"
                    },
                    {
                        "id": 130693,
                        "name": "Al Hali",
                        "latitude": "14.82500000",
                        "longitude": "43.00140000"
                    },
                    {
                        "id": 130695,
                        "name": "Al Hawak",
                        "latitude": "14.76010000",
                        "longitude": "42.99780000"
                    },
                    {
                        "id": 130757,
                        "name": "Al Ḩudaydah",
                        "latitude": "14.79781000",
                        "longitude": "42.95452000"
                    },
                    {
                        "id": 130720,
                        "name": "Al Mansuriyah",
                        "latitude": "14.69030000",
                        "longitude": "43.36820000"
                    },
                    {
                        "id": 130722,
                        "name": "Al Marawi'ah",
                        "latitude": "14.83460000",
                        "longitude": "43.19650000"
                    },
                    {
                        "id": 130731,
                        "name": "Al Mighlaf",
                        "latitude": "15.31110000",
                        "longitude": "43.18360000"
                    },
                    {
                        "id": 130733,
                        "name": "Al Mina",
                        "latitude": "14.80775000",
                        "longitude": "42.93732000"
                    },
                    {
                        "id": 130740,
                        "name": "Al Munirah",
                        "latitude": "15.35280000",
                        "longitude": "42.90620000"
                    },
                    {
                        "id": 130748,
                        "name": "Al Qanawis",
                        "latitude": "15.49206000",
                        "longitude": "43.13782000"
                    },
                    {
                        "id": 130762,
                        "name": "Alluheyah",
                        "latitude": "15.63628000",
                        "longitude": "42.87157000"
                    },
                    {
                        "id": 130777,
                        "name": "As Salif",
                        "latitude": "15.22882000",
                        "longitude": "42.72542000"
                    },
                    {
                        "id": 130785,
                        "name": "As Sukhnah",
                        "latitude": "14.74840000",
                        "longitude": "43.33420000"
                    },
                    {
                        "id": 130799,
                        "name": "At Tuhayat",
                        "latitude": "14.10994000",
                        "longitude": "43.15979000"
                    },
                    {
                        "id": 130805,
                        "name": "Az Zaydīyah",
                        "latitude": "15.29586000",
                        "longitude": "43.06452000"
                    },
                    {
                        "id": 130806,
                        "name": "Az Zuhrah",
                        "latitude": "15.71730000",
                        "longitude": "43.06370000"
                    },
                    {
                        "id": 130829,
                        "name": "Bājil",
                        "latitude": "15.07561000",
                        "longitude": "43.17350000"
                    },
                    {
                        "id": 130823,
                        "name": "Bayt al Faqīh",
                        "latitude": "14.48738000",
                        "longitude": "43.27815000"
                    },
                    {
                        "id": 130828,
                        "name": "Bura",
                        "latitude": "14.89820000",
                        "longitude": "43.47530000"
                    },
                    {
                        "id": 130863,
                        "name": "Hays",
                        "latitude": "13.93320000",
                        "longitude": "43.49840000"
                    },
                    {
                        "id": 130877,
                        "name": "Jabal Ra's",
                        "latitude": "14.03090000",
                        "longitude": "43.62780000"
                    },
                    {
                        "id": 130884,
                        "name": "Kamaran",
                        "latitude": "15.36050000",
                        "longitude": "42.58540000"
                    },
                    {
                        "id": 131006,
                        "name": "Zabīd",
                        "latitude": "14.27742000",
                        "longitude": "43.36841000"
                    }
                ]
            },
            {
                "id": 1243,
                "name": "Al Jawf",
                "iso2": "JA",
                "latitude": "16.79018190",
                "longitude": "45.29938620",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130758,
                        "name": "Al ‘Inān",
                        "latitude": "16.72189000",
                        "longitude": "44.31252000"
                    },
                    {
                        "id": 130688,
                        "name": "Al Ghayl",
                        "latitude": "16.09140000",
                        "longitude": "44.68520000"
                    },
                    {
                        "id": 130698,
                        "name": "Al Hazm",
                        "latitude": "16.03780000",
                        "longitude": "44.95850000"
                    },
                    {
                        "id": 130699,
                        "name": "Al Humaydat",
                        "latitude": "16.46670000",
                        "longitude": "44.42990000"
                    },
                    {
                        "id": 130706,
                        "name": "Al Khalq",
                        "latitude": "16.06810000",
                        "longitude": "44.79700000"
                    },
                    {
                        "id": 130725,
                        "name": "Al Maslub",
                        "latitude": "16.09610000",
                        "longitude": "44.56670000"
                    },
                    {
                        "id": 130726,
                        "name": "Al Matammah",
                        "latitude": "16.19840000",
                        "longitude": "44.39020000"
                    },
                    {
                        "id": 130727,
                        "name": "Al Maton",
                        "latitude": "16.28720000",
                        "longitude": "44.63890000"
                    },
                    {
                        "id": 130803,
                        "name": "Az Zahir",
                        "latitude": "16.33080000",
                        "longitude": "44.52440000"
                    },
                    {
                        "id": 130821,
                        "name": "Barţ al ‘Anān",
                        "latitude": "16.91972000",
                        "longitude": "44.51882000"
                    },
                    {
                        "id": 130885,
                        "name": "Khabb wa ash Sha'af",
                        "latitude": "16.59750000",
                        "longitude": "45.78530000"
                    },
                    {
                        "id": 130888,
                        "name": "Kharab Al Marashi",
                        "latitude": "16.61070000",
                        "longitude": "44.22550000"
                    },
                    {
                        "id": 130950,
                        "name": "Rajuzah",
                        "latitude": "16.63420000",
                        "longitude": "44.50420000"
                    }
                ]
            },
            {
                "id": 1251,
                "name": "Al Mahrah",
                "iso2": "MR",
                "latitude": "16.52384230",
                "longitude": "51.68342750",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130687,
                        "name": "Al Ghaydah",
                        "latitude": "16.26180000",
                        "longitude": "52.08160000"
                    },
                    {
                        "id": 130689,
                        "name": "Al Ghayz̧ah",
                        "latitude": "16.20787000",
                        "longitude": "52.17605000"
                    },
                    {
                        "id": 130724,
                        "name": "Al Masilah",
                        "latitude": "15.63990000",
                        "longitude": "50.64450000"
                    },
                    {
                        "id": 130857,
                        "name": "Hat",
                        "latitude": "17.80310000",
                        "longitude": "51.67500000"
                    },
                    {
                        "id": 130859,
                        "name": "Hawf",
                        "latitude": "16.69530000",
                        "longitude": "52.81820000"
                    },
                    {
                        "id": 130870,
                        "name": "Huswain",
                        "latitude": "15.72300000",
                        "longitude": "51.91240000"
                    },
                    {
                        "id": 130908,
                        "name": "Man'ar",
                        "latitude": "16.55050000",
                        "longitude": "50.98790000"
                    },
                    {
                        "id": 130943,
                        "name": "Qishn",
                        "latitude": "15.69990000",
                        "longitude": "51.32400000"
                    },
                    {
                        "id": 130968,
                        "name": "Sayhut",
                        "latitude": "15.53450000",
                        "longitude": "51.28690000"
                    },
                    {
                        "id": 130974,
                        "name": "Shahan",
                        "latitude": "17.59230000",
                        "longitude": "52.59400000"
                    }
                ]
            },
            {
                "id": 1235,
                "name": "Al Mahwit",
                "iso2": "MW",
                "latitude": "15.39632290",
                "longitude": "43.56069460",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130705,
                        "name": "Al Khabt",
                        "latitude": "15.48170000",
                        "longitude": "43.36770000"
                    },
                    {
                        "id": 130715,
                        "name": "Al Mahwait",
                        "latitude": "15.41170000",
                        "longitude": "43.56630000"
                    },
                    {
                        "id": 130729,
                        "name": "Al Maḩwīt",
                        "latitude": "15.47007000",
                        "longitude": "43.54481000"
                    },
                    {
                        "id": 130768,
                        "name": "Ar Rujum",
                        "latitude": "15.41010000",
                        "longitude": "43.66060000"
                    },
                    {
                        "id": 130808,
                        "name": "Aţ Ţawīlah",
                        "latitude": "15.44165000",
                        "longitude": "43.77484000"
                    },
                    {
                        "id": 130817,
                        "name": "Bani Sa'd",
                        "latitude": "15.23550000",
                        "longitude": "43.51560000"
                    },
                    {
                        "id": 130868,
                        "name": "Hufash",
                        "latitude": "15.37470000",
                        "longitude": "43.42650000"
                    },
                    {
                        "id": 130925,
                        "name": "Milhan",
                        "latitude": "15.32240000",
                        "longitude": "43.33180000"
                    },
                    {
                        "id": 130980,
                        "name": "Shibām Kawkabān",
                        "latitude": "15.50277000",
                        "longitude": "43.84237000"
                    }
                ]
            },
            {
                "id": 1232,
                "name": "Amanat Al Asimah",
                "iso2": "SA",
                "latitude": "15.36944510",
                "longitude": "44.19100660",
                "type": "municipality",
                "cities": []
            },
            {
                "id": 1246,
                "name": "Dhamar",
                "iso2": "DH",
                "latitude": "14.71953440",
                "longitude": "44.24790150",
                "type": "governorate",
                "cities": [
                    {
                        "id": 131014,
                        "name": "‘Ans",
                        "latitude": "14.43606000",
                        "longitude": "44.38889000"
                    },
                    {
                        "id": 130691,
                        "name": "Al Hada",
                        "latitude": "14.80760000",
                        "longitude": "44.56790000"
                    },
                    {
                        "id": 130718,
                        "name": "Al Manar",
                        "latitude": "14.65300000",
                        "longitude": "44.11640000"
                    },
                    {
                        "id": 130761,
                        "name": "Al-Medy Village قرية المدي",
                        "latitude": "14.40152000",
                        "longitude": "43.79178000"
                    },
                    {
                        "id": 130833,
                        "name": "Dawran Aness",
                        "latitude": "14.82880000",
                        "longitude": "44.11430000"
                    },
                    {
                        "id": 130834,
                        "name": "Dhamār",
                        "latitude": "14.54274000",
                        "longitude": "44.40514000"
                    },
                    {
                        "id": 130873,
                        "name": "Jabal Ash sharq",
                        "latitude": "14.72960000",
                        "longitude": "43.90620000"
                    },
                    {
                        "id": 130878,
                        "name": "Jahran",
                        "latitude": "14.73310000",
                        "longitude": "44.31430000"
                    },
                    {
                        "id": 130904,
                        "name": "Maghirib Ans",
                        "latitude": "14.46530000",
                        "longitude": "44.12330000"
                    },
                    {
                        "id": 130919,
                        "name": "Mayfa'at Anss",
                        "latitude": "14.51520000",
                        "longitude": "44.61060000"
                    },
                    {
                        "id": 130994,
                        "name": "Utmah",
                        "latitude": "14.47380000",
                        "longitude": "43.94830000"
                    },
                    {
                        "id": 131000,
                        "name": "Wusab Al Ali",
                        "latitude": "14.33440000",
                        "longitude": "43.79470000"
                    },
                    {
                        "id": 131001,
                        "name": "Wusab As Safil",
                        "latitude": "14.25480000",
                        "longitude": "43.63250000"
                    }
                ]
            },
            {
                "id": 1238,
                "name": "Hadhramaut",
                "iso2": "HD",
                "latitude": "16.93041350",
                "longitude": "49.36531490",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130666,
                        "name": "Ad Dis",
                        "latitude": "15.09490000",
                        "longitude": "50.01590000"
                    },
                    {
                        "id": 130668,
                        "name": "Ad Dīs ash Sharqīyah",
                        "latitude": "14.90840000",
                        "longitude": "49.94847000"
                    },
                    {
                        "id": 130670,
                        "name": "Adh Dhlia'ah",
                        "latitude": "15.01390000",
                        "longitude": "47.89720000"
                    },
                    {
                        "id": 130678,
                        "name": "Al Abr",
                        "latitude": "15.91370000",
                        "longitude": "47.22880000"
                    },
                    {
                        "id": 130755,
                        "name": "Al Ḩamdī",
                        "latitude": "15.94727000",
                        "longitude": "48.77965000"
                    },
                    {
                        "id": 130737,
                        "name": "Al Mukalla",
                        "latitude": "14.72920000",
                        "longitude": "48.91990000"
                    },
                    {
                        "id": 130738,
                        "name": "Al Mukalla City",
                        "latitude": "14.62033000",
                        "longitude": "49.24800000"
                    },
                    {
                        "id": 130744,
                        "name": "Al Qaf",
                        "latitude": "17.42870000",
                        "longitude": "48.94050000"
                    },
                    {
                        "id": 130749,
                        "name": "Al Qatn",
                        "latitude": "15.92320000",
                        "longitude": "48.21460000"
                    },
                    {
                        "id": 130763,
                        "name": "Amd",
                        "latitude": "15.34860000",
                        "longitude": "47.92860000"
                    },
                    {
                        "id": 130767,
                        "name": "Ar Raydah Wa Qusayar",
                        "latitude": "15.18410000",
                        "longitude": "50.31330000"
                    },
                    {
                        "id": 130780,
                        "name": "As Sawm",
                        "latitude": "15.99800000",
                        "longitude": "49.66860000"
                    },
                    {
                        "id": 130793,
                        "name": "Ash Shihr",
                        "latitude": "14.97230000",
                        "longitude": "49.55260000"
                    },
                    {
                        "id": 130797,
                        "name": "At Taḩāluf",
                        "latitude": "15.93786000",
                        "longitude": "48.78641000"
                    },
                    {
                        "id": 130827,
                        "name": "Brom Mayfa",
                        "latitude": "14.34230000",
                        "longitude": "48.72810000"
                    },
                    {
                        "id": 130832,
                        "name": "Daw'an",
                        "latitude": "15.05070000",
                        "longitude": "48.30720000"
                    },
                    {
                        "id": 130843,
                        "name": "Ghayl Ba Wazir",
                        "latitude": "14.87780000",
                        "longitude": "49.02450000"
                    },
                    {
                        "id": 130844,
                        "name": "Ghayl Bin Yamin",
                        "latitude": "15.38960000",
                        "longitude": "49.28540000"
                    },
                    {
                        "id": 130849,
                        "name": "Hagr As Sai'ar",
                        "latitude": "16.30560000",
                        "longitude": "47.95370000"
                    },
                    {
                        "id": 130851,
                        "name": "Hajr",
                        "latitude": "14.47080000",
                        "longitude": "48.27740000"
                    },
                    {
                        "id": 130869,
                        "name": "Huraidhah",
                        "latitude": "15.55425000",
                        "longitude": "48.17505000"
                    },
                    {
                        "id": 130893,
                        "name": "Kilmia",
                        "latitude": "12.18576000",
                        "longitude": "52.23332000"
                    },
                    {
                        "id": 130929,
                        "name": "Mukalla",
                        "latitude": "14.54248000",
                        "longitude": "49.12424000"
                    },
                    {
                        "id": 130951,
                        "name": "Rakhyah",
                        "latitude": "15.46180000",
                        "longitude": "47.77280000"
                    },
                    {
                        "id": 130955,
                        "name": "Rumah",
                        "latitude": "17.81450000",
                        "longitude": "51.07590000"
                    },
                    {
                        "id": 130961,
                        "name": "Sah",
                        "latitude": "15.53420000",
                        "longitude": "48.89550000"
                    },
                    {
                        "id": 130969,
                        "name": "Sayun",
                        "latitude": "15.98310000",
                        "longitude": "48.83150000"
                    },
                    {
                        "id": 130979,
                        "name": "Shibam",
                        "latitude": "15.87030000",
                        "longitude": "48.65340000"
                    },
                    {
                        "id": 130984,
                        "name": "Suḩayl Shibām",
                        "latitude": "15.91448000",
                        "longitude": "48.63864000"
                    },
                    {
                        "id": 130986,
                        "name": "Tarim",
                        "latitude": "16.06600000",
                        "longitude": "49.02290000"
                    },
                    {
                        "id": 130989,
                        "name": "Thamud",
                        "latitude": "17.60310000",
                        "longitude": "49.73610000"
                    },
                    {
                        "id": 130997,
                        "name": "Wadi Al Ayn",
                        "latitude": "15.74033000",
                        "longitude": "48.14747000"
                    },
                    {
                        "id": 131002,
                        "name": "Yabuth",
                        "latitude": "14.71820000",
                        "longitude": "47.73580000"
                    },
                    {
                        "id": 131007,
                        "name": "Zamakh wa Manwakh",
                        "latitude": "17.20320000",
                        "longitude": "47.70330000"
                    }
                ]
            },
            {
                "id": 1244,
                "name": "Hajjah",
                "iso2": "HJ",
                "latitude": "16.11806310",
                "longitude": "43.32946600",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130664,
                        "name": "Abs",
                        "latitude": "16.02150000",
                        "longitude": "43.04850000"
                    },
                    {
                        "id": 130671,
                        "name": "Aflah Al Yaman",
                        "latitude": "15.97890000",
                        "longitude": "43.41110000"
                    },
                    {
                        "id": 130672,
                        "name": "Aflah Ash Shawm",
                        "latitude": "16.05280000",
                        "longitude": "43.41200000"
                    },
                    {
                        "id": 130703,
                        "name": "Al Jamimah",
                        "latitude": "16.02840000",
                        "longitude": "43.52970000"
                    },
                    {
                        "id": 130712,
                        "name": "Al Maghrabah",
                        "latitude": "15.89370000",
                        "longitude": "43.60910000"
                    },
                    {
                        "id": 130713,
                        "name": "Al Mahabishah",
                        "latitude": "15.92870000",
                        "longitude": "43.44800000"
                    },
                    {
                        "id": 130730,
                        "name": "Al Miftah",
                        "latitude": "15.96100000",
                        "longitude": "43.51470000"
                    },
                    {
                        "id": 130787,
                        "name": "Ash Shaghadirah",
                        "latitude": "15.60610000",
                        "longitude": "43.49920000"
                    },
                    {
                        "id": 130788,
                        "name": "Ash Shahil",
                        "latitude": "15.85530000",
                        "longitude": "43.45160000"
                    },
                    {
                        "id": 130795,
                        "name": "Aslem",
                        "latitude": "16.06000000",
                        "longitude": "43.29390000"
                    },
                    {
                        "id": 130811,
                        "name": "Bakil Al Mir",
                        "latitude": "16.50690000",
                        "longitude": "43.36150000"
                    },
                    {
                        "id": 130819,
                        "name": "Banī al ‘Awwām",
                        "latitude": "15.58119000",
                        "longitude": "43.58727000"
                    },
                    {
                        "id": 130812,
                        "name": "Bani Al Awam",
                        "latitude": "15.58100000",
                        "longitude": "43.60790000"
                    },
                    {
                        "id": 130816,
                        "name": "Bani Qa'is",
                        "latitude": "15.63460000",
                        "longitude": "43.33720000"
                    },
                    {
                        "id": 130850,
                        "name": "Hajjah",
                        "latitude": "15.68160000",
                        "longitude": "43.44996000"
                    },
                    {
                        "id": 130854,
                        "name": "Harad District",
                        "latitude": "16.40447000",
                        "longitude": "43.07739000"
                    },
                    {
                        "id": 130862,
                        "name": "Hayran",
                        "latitude": "16.25080000",
                        "longitude": "43.05990000"
                    },
                    {
                        "id": 130890,
                        "name": "Khayran Al Muharraq",
                        "latitude": "16.08964000",
                        "longitude": "43.35755000"
                    },
                    {
                        "id": 130895,
                        "name": "Ku'aydinah",
                        "latitude": "15.81830000",
                        "longitude": "43.35990000"
                    },
                    {
                        "id": 130896,
                        "name": "Kuhlan Affar",
                        "latitude": "15.75540000",
                        "longitude": "43.69700000"
                    },
                    {
                        "id": 130897,
                        "name": "Kuhlan Ash Sharaf",
                        "latitude": "16.02310000",
                        "longitude": "43.48630000"
                    },
                    {
                        "id": 130898,
                        "name": "Kushar",
                        "latitude": "16.17090000",
                        "longitude": "43.47200000"
                    },
                    {
                        "id": 130903,
                        "name": "Mabyan",
                        "latitude": "15.77170000",
                        "longitude": "43.55100000"
                    },
                    {
                        "id": 130924,
                        "name": "Midi",
                        "latitude": "16.19202000",
                        "longitude": "42.88913000"
                    },
                    {
                        "id": 130931,
                        "name": "Mustaba",
                        "latitude": "16.27360000",
                        "longitude": "43.26850000"
                    },
                    {
                        "id": 130935,
                        "name": "Najrah",
                        "latitude": "15.65270000",
                        "longitude": "43.54520000"
                    },
                    {
                        "id": 130939,
                        "name": "Qafl Shamer",
                        "latitude": "15.90870000",
                        "longitude": "43.36400000"
                    },
                    {
                        "id": 130941,
                        "name": "Qarah",
                        "latitude": "16.40190000",
                        "longitude": "43.47400000"
                    },
                    {
                        "id": 130978,
                        "name": "Sharas",
                        "latitude": "15.72860000",
                        "longitude": "43.65460000"
                    },
                    {
                        "id": 130996,
                        "name": "Wadhrah",
                        "latitude": "15.71420000",
                        "longitude": "43.46670000"
                    },
                    {
                        "id": 130999,
                        "name": "Washḩah",
                        "latitude": "16.32158000",
                        "longitude": "43.37555000"
                    }
                ]
            },
            {
                "id": 1233,
                "name": "Ibb",
                "iso2": "IB",
                "latitude": "14.14157170",
                "longitude": "44.24790150",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130759,
                        "name": "Al ‘Udayn",
                        "latitude": "13.96112000",
                        "longitude": "43.96608000"
                    },
                    {
                        "id": 130685,
                        "name": "Al Dhihar",
                        "latitude": "13.97900000",
                        "longitude": "44.15260000"
                    },
                    {
                        "id": 130716,
                        "name": "Al Makhādir",
                        "latitude": "14.13965000",
                        "longitude": "44.20330000"
                    },
                    {
                        "id": 130723,
                        "name": "Al Mashannah",
                        "latitude": "13.95730000",
                        "longitude": "44.17000000"
                    },
                    {
                        "id": 130746,
                        "name": "Al Qafr",
                        "latitude": "14.31290000",
                        "longitude": "44.03000000"
                    },
                    {
                        "id": 130764,
                        "name": "An Nādirah",
                        "latitude": "14.07398000",
                        "longitude": "44.49925000"
                    },
                    {
                        "id": 130765,
                        "name": "Ar Radmah",
                        "latitude": "14.21200000",
                        "longitude": "44.56420000"
                    },
                    {
                        "id": 130772,
                        "name": "As Sabrah",
                        "latitude": "13.84270000",
                        "longitude": "44.33860000"
                    },
                    {
                        "id": 130773,
                        "name": "As Saddah",
                        "latitude": "14.16610000",
                        "longitude": "44.37510000"
                    },
                    {
                        "id": 130782,
                        "name": "As Sayyani",
                        "latitude": "13.82240000",
                        "longitude": "44.21180000"
                    },
                    {
                        "id": 130786,
                        "name": "Ash Sha'ir",
                        "latitude": "14.03180000",
                        "longitude": "44.36190000"
                    },
                    {
                        "id": 130810,
                        "name": "Ba'dan",
                        "latitude": "13.98870000",
                        "longitude": "44.32360000"
                    },
                    {
                        "id": 130839,
                        "name": "Dhī as Sufāl",
                        "latitude": "13.82137000",
                        "longitude": "44.07775000"
                    },
                    {
                        "id": 130841,
                        "name": "Far Al Udayn",
                        "latitude": "13.95780000",
                        "longitude": "43.78270000"
                    },
                    {
                        "id": 130864,
                        "name": "Hazm Al Udayn",
                        "latitude": "14.16984000",
                        "longitude": "43.93814000"
                    },
                    {
                        "id": 130867,
                        "name": "Hubaysh",
                        "latitude": "14.11600000",
                        "longitude": "44.08240000"
                    },
                    {
                        "id": 130871,
                        "name": "Ibb",
                        "latitude": "13.96667000",
                        "longitude": "44.18333000"
                    },
                    {
                        "id": 130882,
                        "name": "Jiblah",
                        "latitude": "13.91480000",
                        "longitude": "44.12130000"
                    },
                    {
                        "id": 130927,
                        "name": "Mudhaykhirah",
                        "latitude": "13.86608000",
                        "longitude": "43.96866000"
                    },
                    {
                        "id": 131005,
                        "name": "Yarīm",
                        "latitude": "14.25388000",
                        "longitude": "44.31176000"
                    }
                ]
            },
            {
                "id": 1245,
                "name": "Lahij",
                "iso2": "LA",
                "latitude": "13.14895880",
                "longitude": "44.85054950",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130675,
                        "name": "Al  Hawtah",
                        "latitude": "13.06240000",
                        "longitude": "44.88160000"
                    },
                    {
                        "id": 130754,
                        "name": "Al Ḩabīlayn",
                        "latitude": "13.52002000",
                        "longitude": "44.85076000"
                    },
                    {
                        "id": 130690,
                        "name": "Al Had",
                        "latitude": "13.97830000",
                        "longitude": "45.25530000"
                    },
                    {
                        "id": 130710,
                        "name": "Al Madaribah Wa Al Arah",
                        "latitude": "12.85690000",
                        "longitude": "43.99060000"
                    },
                    {
                        "id": 130711,
                        "name": "Al Maflahy",
                        "latitude": "13.77670000",
                        "longitude": "45.10880000"
                    },
                    {
                        "id": 130721,
                        "name": "Al Maqatirah",
                        "latitude": "13.13720000",
                        "longitude": "44.14040000"
                    },
                    {
                        "id": 130732,
                        "name": "Al Milah",
                        "latitude": "13.32020000",
                        "longitude": "44.92670000"
                    },
                    {
                        "id": 130741,
                        "name": "Al Musaymir",
                        "latitude": "13.42910000",
                        "longitude": "44.59140000"
                    },
                    {
                        "id": 130743,
                        "name": "Al Qabbaytah",
                        "latitude": "13.32750000",
                        "longitude": "44.50250000"
                    },
                    {
                        "id": 130846,
                        "name": "Habil Jabr",
                        "latitude": "13.59210000",
                        "longitude": "45.07370000"
                    },
                    {
                        "id": 130852,
                        "name": "Halimayn",
                        "latitude": "13.70880000",
                        "longitude": "44.94430000"
                    },
                    {
                        "id": 130901,
                        "name": "Laḩij",
                        "latitude": "13.05667000",
                        "longitude": "44.88194000"
                    },
                    {
                        "id": 130945,
                        "name": "Radfan",
                        "latitude": "13.46670000",
                        "longitude": "44.99000000"
                    },
                    {
                        "id": 130991,
                        "name": "Tuban",
                        "latitude": "13.09210000",
                        "longitude": "44.87840000"
                    },
                    {
                        "id": 130992,
                        "name": "Tur Al Bahah",
                        "latitude": "13.04269000",
                        "longitude": "44.41154000"
                    },
                    {
                        "id": 131003,
                        "name": "Yafa'a",
                        "latitude": "13.86200000",
                        "longitude": "45.20140000"
                    },
                    {
                        "id": 131004,
                        "name": "Yahr",
                        "latitude": "13.72270000",
                        "longitude": "45.13050000"
                    }
                ]
            },
            {
                "id": 1234,
                "name": "Ma'rib",
                "iso2": "MA",
                "latitude": "15.51588800",
                "longitude": "45.44980650",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130677,
                        "name": "Al Abdiyah",
                        "latitude": "14.71700000",
                        "longitude": "45.39340000"
                    },
                    {
                        "id": 130704,
                        "name": "Al Jubah",
                        "latitude": "15.12490000",
                        "longitude": "45.28680000"
                    },
                    {
                        "id": 130824,
                        "name": "Bidbadah",
                        "latitude": "15.39810000",
                        "longitude": "44.74730000"
                    },
                    {
                        "id": 131012,
                        "name": "Ḩarīb",
                        "latitude": "14.93045000",
                        "longitude": "45.36820000"
                    },
                    {
                        "id": 130856,
                        "name": "Harib Al Qaramish",
                        "latitude": "15.47350000",
                        "longitude": "44.61530000"
                    },
                    {
                        "id": 130876,
                        "name": "Jabal Murad",
                        "latitude": "15.04740000",
                        "longitude": "45.18870000"
                    },
                    {
                        "id": 130902,
                        "name": "Ma'rib",
                        "latitude": "15.46253000",
                        "longitude": "45.32581000"
                    },
                    {
                        "id": 130905,
                        "name": "Mahliyah",
                        "latitude": "14.68210000",
                        "longitude": "45.18320000"
                    },
                    {
                        "id": 130907,
                        "name": "Majzar",
                        "latitude": "15.82770000",
                        "longitude": "44.79410000"
                    },
                    {
                        "id": 130912,
                        "name": "Marib",
                        "latitude": "15.62130000",
                        "longitude": "46.01110000"
                    },
                    {
                        "id": 130913,
                        "name": "Marib City",
                        "latitude": "15.41560000",
                        "longitude": "45.30340000"
                    },
                    {
                        "id": 130921,
                        "name": "Medghal",
                        "latitude": "15.63840000",
                        "longitude": "45.00380000"
                    },
                    {
                        "id": 130948,
                        "name": "Raghwan",
                        "latitude": "15.79020000",
                        "longitude": "45.06940000"
                    },
                    {
                        "id": 130949,
                        "name": "Rahabah",
                        "latitude": "14.95100000",
                        "longitude": "45.08850000"
                    },
                    {
                        "id": 130982,
                        "name": "Sirwah",
                        "latitude": "15.43690000",
                        "longitude": "45.01150000"
                    }
                ]
            },
            {
                "id": 1248,
                "name": "Raymah",
                "iso2": "RA",
                "latitude": "14.62776820",
                "longitude": "43.71424840",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130701,
                        "name": "Al Jabin",
                        "latitude": "14.68990000",
                        "longitude": "43.61960000"
                    },
                    {
                        "id": 130702,
                        "name": "Al Jafariyah",
                        "latitude": "14.51960000",
                        "longitude": "43.58170000"
                    },
                    {
                        "id": 130776,
                        "name": "As Salafiyah",
                        "latitude": "14.68660000",
                        "longitude": "43.82160000"
                    },
                    {
                        "id": 130826,
                        "name": "Bilad At Ta'am",
                        "latitude": "14.83820000",
                        "longitude": "43.60780000"
                    },
                    {
                        "id": 130899,
                        "name": "Kusmah",
                        "latitude": "14.54740000",
                        "longitude": "43.68330000"
                    },
                    {
                        "id": 130920,
                        "name": "Mazhar",
                        "latitude": "14.57090000",
                        "longitude": "43.76070000"
                    }
                ]
            },
            {
                "id": 1249,
                "name": "Saada",
                "iso2": "SD",
                "latitude": "16.84765280",
                "longitude": "43.94367880",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130684,
                        "name": "Al Dhaher",
                        "latitude": "16.73140000",
                        "longitude": "43.27530000"
                    },
                    {
                        "id": 130694,
                        "name": "Al Hashwah",
                        "latitude": "16.88840000",
                        "longitude": "44.27380000"
                    },
                    {
                        "id": 130774,
                        "name": "As Safra",
                        "latitude": "17.01420000",
                        "longitude": "43.85660000"
                    },
                    {
                        "id": 130792,
                        "name": "Ash Shawātī",
                        "latitude": "16.78314000",
                        "longitude": "43.81265000"
                    },
                    {
                        "id": 130820,
                        "name": "Baqim",
                        "latitude": "17.37810000",
                        "longitude": "43.46350000"
                    },
                    {
                        "id": 130842,
                        "name": "Ghamr",
                        "latitude": "16.98301000",
                        "longitude": "43.31608000"
                    },
                    {
                        "id": 130860,
                        "name": "Haydan",
                        "latitude": "16.72870000",
                        "longitude": "43.48490000"
                    },
                    {
                        "id": 130894,
                        "name": "Kitaf wa Al Boqe'e",
                        "latitude": "17.08080000",
                        "longitude": "44.39620000"
                    },
                    {
                        "id": 130906,
                        "name": "Majz",
                        "latitude": "17.09230000",
                        "longitude": "43.51040000"
                    },
                    {
                        "id": 130926,
                        "name": "Monabbih",
                        "latitude": "17.16930000",
                        "longitude": "43.27910000"
                    },
                    {
                        "id": 130942,
                        "name": "Qatabir",
                        "latitude": "17.33680000",
                        "longitude": "43.33110000"
                    },
                    {
                        "id": 130956,
                        "name": "Rāziḩ",
                        "latitude": "16.93704000",
                        "longitude": "43.26080000"
                    },
                    {
                        "id": 130957,
                        "name": "Sa'dah",
                        "latitude": "16.94021000",
                        "longitude": "43.76393000"
                    },
                    {
                        "id": 131010,
                        "name": "Şa‘dah",
                        "latitude": "16.91733000",
                        "longitude": "43.76000000"
                    },
                    {
                        "id": 130972,
                        "name": "Saḩār",
                        "latitude": "16.88522000",
                        "longitude": "43.68306000"
                    },
                    {
                        "id": 130966,
                        "name": "Saqayn",
                        "latitude": "16.86010000",
                        "longitude": "43.47160000"
                    },
                    {
                        "id": 130973,
                        "name": "Shada'a",
                        "latitude": "16.89130000",
                        "longitude": "43.18710000"
                    }
                ]
            },
            {
                "id": 1236,
                "name": "Sana'a",
                "iso2": "SN",
                "latitude": "15.31689130",
                "longitude": "44.47480180",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130696,
                        "name": "Al Haymah Ad Dakhiliyah",
                        "latitude": "15.27220000",
                        "longitude": "43.83930000"
                    },
                    {
                        "id": 130697,
                        "name": "Al Haymah Al Kharijiyah",
                        "latitude": "15.02670000",
                        "longitude": "43.85000000"
                    },
                    {
                        "id": 130700,
                        "name": "Al Husn",
                        "latitude": "15.02060000",
                        "longitude": "44.50440000"
                    },
                    {
                        "id": 130707,
                        "name": "Al Khāniq",
                        "latitude": "15.50253000",
                        "longitude": "44.18158000"
                    },
                    {
                        "id": 130770,
                        "name": "Arhab",
                        "latitude": "15.79950000",
                        "longitude": "44.24660000"
                    },
                    {
                        "id": 130802,
                        "name": "Attyal",
                        "latitude": "15.32931000",
                        "longitude": "44.57739000"
                    },
                    {
                        "id": 130813,
                        "name": "Bani Dhabyan",
                        "latitude": "15.04810000",
                        "longitude": "44.87180000"
                    },
                    {
                        "id": 130814,
                        "name": "Bani Hushaysh",
                        "latitude": "15.45050000",
                        "longitude": "44.37820000"
                    },
                    {
                        "id": 130815,
                        "name": "Bani Matar",
                        "latitude": "15.21500000",
                        "longitude": "44.04980000"
                    },
                    {
                        "id": 130825,
                        "name": "Bilad Ar Rus",
                        "latitude": "15.03510000",
                        "longitude": "44.25140000"
                    },
                    {
                        "id": 130853,
                        "name": "Hamdān",
                        "latitude": "15.50662000",
                        "longitude": "44.06030000"
                    },
                    {
                        "id": 130883,
                        "name": "Jihanah",
                        "latitude": "15.19190000",
                        "longitude": "44.51950000"
                    },
                    {
                        "id": 130892,
                        "name": "Khwlan",
                        "latitude": "15.27490000",
                        "longitude": "44.76860000"
                    },
                    {
                        "id": 130909,
                        "name": "Manakhah",
                        "latitude": "15.07170000",
                        "longitude": "43.68620000"
                    },
                    {
                        "id": 130937,
                        "name": "Nihm",
                        "latitude": "15.75160000",
                        "longitude": "44.57460000"
                    },
                    {
                        "id": 130958,
                        "name": "Sa'fan",
                        "latitude": "15.07120000",
                        "longitude": "43.58270000"
                    },
                    {
                        "id": 130971,
                        "name": "Saḩar",
                        "latitude": "15.31637000",
                        "longitude": "44.30880000"
                    },
                    {
                        "id": 130964,
                        "name": "Sanaa",
                        "latitude": "15.35472000",
                        "longitude": "44.20667000"
                    },
                    {
                        "id": 130965,
                        "name": "Sanhan",
                        "latitude": "15.22520000",
                        "longitude": "44.30570000"
                    },
                    {
                        "id": 130970,
                        "name": "Sayyān",
                        "latitude": "15.17177000",
                        "longitude": "44.32442000"
                    }
                ]
            },
            {
                "id": 1247,
                "name": "Shabwah",
                "iso2": "SH",
                "latitude": "14.75463030",
                "longitude": "46.51626200",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130674,
                        "name": "Ain",
                        "latitude": "14.95030000",
                        "longitude": "45.60040000"
                    },
                    {
                        "id": 130760,
                        "name": "Al ‘Āqir",
                        "latitude": "14.56816000",
                        "longitude": "45.91156000"
                    },
                    {
                        "id": 130751,
                        "name": "Al Talh",
                        "latitude": "15.08260000",
                        "longitude": "47.35140000"
                    },
                    {
                        "id": 130663,
                        "name": "AL-khashā upper",
                        "latitude": "14.34044000",
                        "longitude": "46.71365000"
                    },
                    {
                        "id": 130766,
                        "name": "Ar Rawdah",
                        "latitude": "14.49560000",
                        "longitude": "47.27460000"
                    },
                    {
                        "id": 130771,
                        "name": "Arma",
                        "latitude": "15.41270000",
                        "longitude": "47.23450000"
                    },
                    {
                        "id": 130775,
                        "name": "As Said",
                        "latitude": "14.27660000",
                        "longitude": "46.86930000"
                    },
                    {
                        "id": 130800,
                        "name": "Ataq",
                        "latitude": "14.53767000",
                        "longitude": "46.83187000"
                    },
                    {
                        "id": 130822,
                        "name": "Bayhan",
                        "latitude": "14.76190000",
                        "longitude": "45.74820000"
                    },
                    {
                        "id": 130835,
                        "name": "Dhar",
                        "latitude": "15.50360000",
                        "longitude": "47.60580000"
                    },
                    {
                        "id": 130845,
                        "name": "Habban",
                        "latitude": "14.28780000",
                        "longitude": "47.13610000"
                    },
                    {
                        "id": 130858,
                        "name": "Hatib",
                        "latitude": "14.18020000",
                        "longitude": "46.44390000"
                    },
                    {
                        "id": 130879,
                        "name": "Jardan",
                        "latitude": "15.19000000",
                        "longitude": "46.73380000"
                    },
                    {
                        "id": 130891,
                        "name": "Khimār",
                        "latitude": "14.31980000",
                        "longitude": "46.73922000"
                    },
                    {
                        "id": 130918,
                        "name": "Mayfa'a",
                        "latitude": "14.39780000",
                        "longitude": "47.74040000"
                    },
                    {
                        "id": 130922,
                        "name": "Merkhah Al Ulya",
                        "latitude": "14.48470000",
                        "longitude": "45.92990000"
                    },
                    {
                        "id": 130923,
                        "name": "Merkhah As Sufla",
                        "latitude": "14.69990000",
                        "longitude": "46.15630000"
                    },
                    {
                        "id": 130938,
                        "name": "Nisab",
                        "latitude": "14.52570000",
                        "longitude": "46.44770000"
                    },
                    {
                        "id": 130954,
                        "name": "Rudum",
                        "latitude": "14.03759000",
                        "longitude": "47.83824000"
                    },
                    {
                        "id": 130993,
                        "name": "Usaylan",
                        "latitude": "15.17030000",
                        "longitude": "46.02740000"
                    }
                ]
            },
            {
                "id": 1239,
                "name": "Socotra",
                "iso2": "SU",
                "latitude": "12.46342050",
                "longitude": "53.82373850",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130848,
                        "name": "Hadibu",
                        "latitude": "12.64881000",
                        "longitude": "54.01895000"
                    },
                    {
                        "id": 130865,
                        "name": "Hidaybu",
                        "latitude": "12.50250000",
                        "longitude": "54.00820000"
                    },
                    {
                        "id": 130940,
                        "name": "Qalansīyah",
                        "latitude": "12.68958000",
                        "longitude": "53.48709000"
                    },
                    {
                        "id": 130944,
                        "name": "Qulensya Wa Abd Al Kuri",
                        "latitude": "12.55479000",
                        "longitude": "53.58671000"
                    }
                ]
            },
            {
                "id": 1231,
                "name": "Ta'izz",
                "iso2": "TA",
                "latitude": "13.57758860",
                "longitude": "44.01779890",
                "type": "governorate",
                "cities": [
                    {
                        "id": 130708,
                        "name": "Al Ma'afer",
                        "latitude": "13.37420000",
                        "longitude": "43.92620000"
                    },
                    {
                        "id": 130728,
                        "name": "Al Mawasit",
                        "latitude": "13.30420000",
                        "longitude": "44.10050000"
                    },
                    {
                        "id": 130734,
                        "name": "Al Misrakh",
                        "latitude": "13.47020000",
                        "longitude": "44.03770000"
                    },
                    {
                        "id": 130736,
                        "name": "Al Mudhaffar",
                        "latitude": "13.58310000",
                        "longitude": "43.99270000"
                    },
                    {
                        "id": 130739,
                        "name": "Al Mukhā’",
                        "latitude": "13.51998000",
                        "longitude": "43.42798000"
                    },
                    {
                        "id": 130747,
                        "name": "Al Qahirah",
                        "latitude": "13.58490000",
                        "longitude": "44.01010000"
                    },
                    {
                        "id": 130753,
                        "name": "Al Wazi'iyah",
                        "latitude": "13.18460000",
                        "longitude": "43.72980000"
                    },
                    {
                        "id": 130783,
                        "name": "As Silw",
                        "latitude": "13.34590000",
                        "longitude": "44.20720000"
                    },
                    {
                        "id": 130790,
                        "name": "Ash Shamayatayn",
                        "latitude": "13.18220000",
                        "longitude": "43.98000000"
                    },
                    {
                        "id": 130798,
                        "name": "At Ta‘izzīyah",
                        "latitude": "13.69479000",
                        "longitude": "44.00941000"
                    },
                    {
                        "id": 130838,
                        "name": "Dhubab",
                        "latitude": "12.96590000",
                        "longitude": "43.47240000"
                    },
                    {
                        "id": 130840,
                        "name": "Dimnat Khadir",
                        "latitude": "13.43860000",
                        "longitude": "44.25420000"
                    },
                    {
                        "id": 130861,
                        "name": "Hayfan",
                        "latitude": "13.29060000",
                        "longitude": "44.26070000"
                    },
                    {
                        "id": 130874,
                        "name": "Jabal Habashy",
                        "latitude": "13.46650000",
                        "longitude": "43.88100000"
                    },
                    {
                        "id": 130911,
                        "name": "Maqbanah",
                        "latitude": "13.62120000",
                        "longitude": "43.66740000"
                    },
                    {
                        "id": 130914,
                        "name": "Mashra'a Wa Hadnan",
                        "latitude": "13.54170000",
                        "longitude": "43.99830000"
                    },
                    {
                        "id": 130932,
                        "name": "Māwīyah",
                        "latitude": "13.58461000",
                        "longitude": "44.31912000"
                    },
                    {
                        "id": 130917,
                        "name": "Mawza",
                        "latitude": "13.37820000",
                        "longitude": "43.61450000"
                    },
                    {
                        "id": 130960,
                        "name": "Sabir Al Mawadim",
                        "latitude": "13.53180000",
                        "longitude": "44.04620000"
                    },
                    {
                        "id": 130962,
                        "name": "Salh",
                        "latitude": "13.58390000",
                        "longitude": "44.04020000"
                    },
                    {
                        "id": 130963,
                        "name": "Sama",
                        "latitude": "13.38090000",
                        "longitude": "44.11660000"
                    },
                    {
                        "id": 130976,
                        "name": "Shara'b Ar Rawnah",
                        "latitude": "13.73360000",
                        "longitude": "43.76720000"
                    },
                    {
                        "id": 130977,
                        "name": "Shara'b As Salam",
                        "latitude": "13.78320000",
                        "longitude": "43.88610000"
                    },
                    {
                        "id": 130988,
                        "name": "Ta‘izz",
                        "latitude": "13.57952000",
                        "longitude": "44.02091000"
                    },
                    {
                        "id": 130995,
                        "name": "Village of Alamrah",
                        "latitude": "13.74318000",
                        "longitude": "43.72992000"
                    }
                ]
            }
        ]
    },
    {
        "id": 246,
        "name": "Zambia",
        "iso3": "ZMB",
        "iso2": "ZM",
        "numeric_code": "894",
        "phonecode": "260",
        "capital": "Lusaka",
        "currency": "ZMW",
        "currency_name": "Zambian kwacha",
        "currency_symbol": "ZK",
        "tld": ".zm",
        "native": "Zambia",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Southern Africa",
        "subregion_id": 5,
        "nationality": "Zambian",
        "timezones": [
            {
                "zoneName": "Africa\/Lusaka",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "br": "Zambia",
            "ko": "잠비아",
            "pt-BR": "Zâmbia",
            "pt": "Zâmbia",
            "nl": "Zambia",
            "hr": "Zambija",
            "fa": "زامبیا",
            "de": "Sambia",
            "es": "Zambia",
            "fr": "Zambie",
            "ja": "ザンビア",
            "it": "Zambia",
            "zh-CN": "赞比亚",
            "tr": "Zambiya",
            "ru": "Замбия",
            "uk": "Замбія",
            "pl": "Zambia"
        },
        "latitude": "-15.00000000",
        "longitude": "30.00000000",
        "emoji": "🇿🇲",
        "emojiU": "U+1F1FF U+1F1F2",
        "states": [
            {
                "id": 1986,
                "name": "Central",
                "iso2": "02",
                "latitude": "-13.85846200",
                "longitude": "25.73495040",
                "type": "province",
                "cities": [
                    {
                        "id": 131332,
                        "name": "Chibombo",
                        "latitude": "-14.65685000",
                        "longitude": "28.07057000"
                    },
                    {
                        "id": 131333,
                        "name": "Chibombo District",
                        "latitude": "-14.65808000",
                        "longitude": "28.07376000"
                    },
                    {
                        "id": 131345,
                        "name": "Kabwe",
                        "latitude": "-14.44690000",
                        "longitude": "28.44644000"
                    },
                    {
                        "id": 131352,
                        "name": "Kapiri Mposhi",
                        "latitude": "-13.97147000",
                        "longitude": "28.66985000"
                    },
                    {
                        "id": 131371,
                        "name": "Mkushi",
                        "latitude": "-13.62015000",
                        "longitude": "29.39390000"
                    },
                    {
                        "id": 131380,
                        "name": "Mumbwa",
                        "latitude": "-14.98293000",
                        "longitude": "27.06190000"
                    },
                    {
                        "id": 131393,
                        "name": "Serenje",
                        "latitude": "-13.23251000",
                        "longitude": "30.23522000"
                    }
                ]
            },
            {
                "id": 1984,
                "name": "Copperbelt",
                "iso2": "08",
                "latitude": "-13.05700730",
                "longitude": "27.54958460",
                "type": "province",
                "cities": [
                    {
                        "id": 131331,
                        "name": "Chambishi",
                        "latitude": "-12.63247000",
                        "longitude": "28.05367000"
                    },
                    {
                        "id": 131334,
                        "name": "Chililabombwe",
                        "latitude": "-12.36475000",
                        "longitude": "27.82286000"
                    },
                    {
                        "id": 131335,
                        "name": "Chingola",
                        "latitude": "-12.52897000",
                        "longitude": "27.88382000"
                    },
                    {
                        "id": 131336,
                        "name": "Chingola District",
                        "latitude": "-12.48478000",
                        "longitude": "27.66313000"
                    },
                    {
                        "id": 131349,
                        "name": "Kalulushi",
                        "latitude": "-12.84151000",
                        "longitude": "28.09479000"
                    },
                    {
                        "id": 131356,
                        "name": "Kataba",
                        "latitude": "-11.88333000",
                        "longitude": "29.78333000"
                    },
                    {
                        "id": 131358,
                        "name": "Kitwe",
                        "latitude": "-12.80243000",
                        "longitude": "28.21323000"
                    },
                    {
                        "id": 131362,
                        "name": "Luanshya",
                        "latitude": "-13.13667000",
                        "longitude": "28.41661000"
                    },
                    {
                        "id": 131375,
                        "name": "Mpongwe",
                        "latitude": "-13.50914000",
                        "longitude": "28.15504000"
                    },
                    {
                        "id": 131378,
                        "name": "Mufulira",
                        "latitude": "-12.54982000",
                        "longitude": "28.24071000"
                    },
                    {
                        "id": 131388,
                        "name": "Ndola",
                        "latitude": "-12.95867000",
                        "longitude": "28.63659000"
                    }
                ]
            },
            {
                "id": 1991,
                "name": "Eastern",
                "iso2": "03",
                "latitude": "23.16696880",
                "longitude": "49.36531490",
                "type": "province",
                "cities": [
                    {
                        "id": 131329,
                        "name": "Chadiza",
                        "latitude": "-14.06779000",
                        "longitude": "32.43917000"
                    },
                    {
                        "id": 131338,
                        "name": "Chipata",
                        "latitude": "-13.63333000",
                        "longitude": "32.65000000"
                    },
                    {
                        "id": 131364,
                        "name": "Lundazi",
                        "latitude": "-12.29292000",
                        "longitude": "33.17820000"
                    },
                    {
                        "id": 131389,
                        "name": "Nyimba",
                        "latitude": "-14.55656000",
                        "longitude": "30.81490000"
                    },
                    {
                        "id": 131390,
                        "name": "Petauke",
                        "latitude": "-14.24117000",
                        "longitude": "31.31975000"
                    }
                ]
            },
            {
                "id": 1987,
                "name": "Luapula",
                "iso2": "04",
                "latitude": "-11.56483100",
                "longitude": "29.04599270",
                "type": "province",
                "cities": [
                    {
                        "id": 131357,
                        "name": "Kawambwa",
                        "latitude": "-9.79150000",
                        "longitude": "29.07913000"
                    },
                    {
                        "id": 131368,
                        "name": "Mansa",
                        "latitude": "-11.19976000",
                        "longitude": "28.89431000"
                    },
                    {
                        "id": 131382,
                        "name": "Mwense",
                        "latitude": "-10.38447000",
                        "longitude": "28.69800000"
                    },
                    {
                        "id": 131387,
                        "name": "Nchelenge",
                        "latitude": "-9.34506000",
                        "longitude": "28.73396000"
                    },
                    {
                        "id": 131391,
                        "name": "Samfya",
                        "latitude": "-11.36491000",
                        "longitude": "29.55652000"
                    }
                ]
            },
            {
                "id": 1988,
                "name": "Lusaka",
                "iso2": "09",
                "latitude": "-15.36571290",
                "longitude": "29.23207840",
                "type": "province",
                "cities": [
                    {
                        "id": 131340,
                        "name": "Chongwe",
                        "latitude": "-15.32916000",
                        "longitude": "28.68204000"
                    },
                    {
                        "id": 131346,
                        "name": "Kafue",
                        "latitude": "-15.76911000",
                        "longitude": "28.18136000"
                    },
                    {
                        "id": 131361,
                        "name": "Luangwa",
                        "latitude": "-15.61667000",
                        "longitude": "30.41667000"
                    },
                    {
                        "id": 131365,
                        "name": "Lusaka",
                        "latitude": "-15.40669000",
                        "longitude": "28.28713000"
                    }
                ]
            },
            {
                "id": 1989,
                "name": "Muchinga",
                "iso2": "10",
                "latitude": "-15.38219300",
                "longitude": "28.26158000",
                "type": "province",
                "cities": [
                    {
                        "id": 131330,
                        "name": "Chama",
                        "latitude": "-11.21303000",
                        "longitude": "33.15210000"
                    },
                    {
                        "id": 131337,
                        "name": "Chinsali",
                        "latitude": "-10.54142000",
                        "longitude": "32.08162000"
                    },
                    {
                        "id": 131342,
                        "name": "Isoka",
                        "latitude": "-10.16062000",
                        "longitude": "32.63353000"
                    },
                    {
                        "id": 131374,
                        "name": "Mpika",
                        "latitude": "-11.83431000",
                        "longitude": "31.45287000"
                    },
                    {
                        "id": 131385,
                        "name": "Nakonde",
                        "latitude": "-9.34213000",
                        "longitude": "32.74500000"
                    }
                ]
            },
            {
                "id": 1982,
                "name": "Northern",
                "iso2": "05",
                "latitude": "8.88550270",
                "longitude": "80.27673270",
                "type": "province",
                "cities": [
                    {
                        "id": 131353,
                        "name": "Kaputa",
                        "latitude": "-8.46887000",
                        "longitude": "29.66193000"
                    },
                    {
                        "id": 131354,
                        "name": "Kasama",
                        "latitude": "-10.21289000",
                        "longitude": "31.18084000"
                    },
                    {
                        "id": 131366,
                        "name": "Luwingu",
                        "latitude": "-10.26210000",
                        "longitude": "29.92712000"
                    },
                    {
                        "id": 131370,
                        "name": "Mbala",
                        "latitude": "-8.84024000",
                        "longitude": "31.36587000"
                    },
                    {
                        "id": 131376,
                        "name": "Mporokoso",
                        "latitude": "-9.37273000",
                        "longitude": "30.12501000"
                    },
                    {
                        "id": 131377,
                        "name": "Mpulungu",
                        "latitude": "-8.76234000",
                        "longitude": "31.11405000"
                    },
                    {
                        "id": 131381,
                        "name": "Mungwi",
                        "latitude": "-10.17320000",
                        "longitude": "31.36942000"
                    }
                ]
            },
            {
                "id": 1985,
                "name": "Northwestern",
                "iso2": "06",
                "latitude": "-13.00502580",
                "longitude": "24.90422080",
                "type": "province",
                "cities": [
                    {
                        "id": 131344,
                        "name": "Kabompo",
                        "latitude": "-13.59268000",
                        "longitude": "24.20081000"
                    },
                    {
                        "id": 131348,
                        "name": "Kalengwa",
                        "latitude": "-13.46586000",
                        "longitude": "25.00271000"
                    },
                    {
                        "id": 131350,
                        "name": "Kansanshi",
                        "latitude": "-12.09514000",
                        "longitude": "26.42727000"
                    },
                    {
                        "id": 131355,
                        "name": "Kasempa",
                        "latitude": "-13.45836000",
                        "longitude": "25.83380000"
                    },
                    {
                        "id": 131379,
                        "name": "Mufumbwe",
                        "latitude": "-13.68333000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 131383,
                        "name": "Mwinilunga",
                        "latitude": "-11.73584000",
                        "longitude": "24.42926000"
                    },
                    {
                        "id": 131398,
                        "name": "Solwezi",
                        "latitude": "-12.16880000",
                        "longitude": "26.38938000"
                    },
                    {
                        "id": 131399,
                        "name": "Zambezi",
                        "latitude": "-13.54323000",
                        "longitude": "23.10467000"
                    }
                ]
            },
            {
                "id": 1990,
                "name": "Southern",
                "iso2": "07",
                "latitude": "6.23737500",
                "longitude": "80.54384500",
                "type": "province",
                "cities": [
                    {
                        "id": 131339,
                        "name": "Choma",
                        "latitude": "-16.80889000",
                        "longitude": "26.98750000"
                    },
                    {
                        "id": 131341,
                        "name": "Gwembe",
                        "latitude": "-16.49755000",
                        "longitude": "27.60691000"
                    },
                    {
                        "id": 131343,
                        "name": "Itezhi-Tezhi District",
                        "latitude": "-15.74092000",
                        "longitude": "26.04146000"
                    },
                    {
                        "id": 131360,
                        "name": "Livingstone",
                        "latitude": "-17.84194000",
                        "longitude": "25.85425000"
                    },
                    {
                        "id": 131367,
                        "name": "Maamba",
                        "latitude": "-17.36667000",
                        "longitude": "27.15000000"
                    },
                    {
                        "id": 131369,
                        "name": "Mazabuka",
                        "latitude": "-15.85601000",
                        "longitude": "27.74800000"
                    },
                    {
                        "id": 131373,
                        "name": "Monze",
                        "latitude": "-16.28333000",
                        "longitude": "27.48333000"
                    },
                    {
                        "id": 131384,
                        "name": "Nakambala",
                        "latitude": "-15.83244000",
                        "longitude": "27.77994000"
                    },
                    {
                        "id": 131386,
                        "name": "Namwala",
                        "latitude": "-15.75042000",
                        "longitude": "26.43839000"
                    },
                    {
                        "id": 131395,
                        "name": "Siavonga",
                        "latitude": "-16.53818000",
                        "longitude": "28.70876000"
                    },
                    {
                        "id": 131396,
                        "name": "Siavonga District",
                        "latitude": "-16.26742000",
                        "longitude": "28.55036000"
                    },
                    {
                        "id": 131397,
                        "name": "Sinazongwe",
                        "latitude": "-17.26140000",
                        "longitude": "27.46179000"
                    }
                ]
            },
            {
                "id": 1983,
                "name": "Western",
                "iso2": "01",
                "latitude": "6.90160860",
                "longitude": "80.00877460",
                "type": "province",
                "cities": [
                    {
                        "id": 131347,
                        "name": "Kalabo",
                        "latitude": "-14.99307000",
                        "longitude": "22.67926000"
                    },
                    {
                        "id": 131351,
                        "name": "Kaoma",
                        "latitude": "-14.78333000",
                        "longitude": "24.80000000"
                    },
                    {
                        "id": 131359,
                        "name": "Limulunga",
                        "latitude": "-15.09691000",
                        "longitude": "23.13757000"
                    },
                    {
                        "id": 131363,
                        "name": "Lukulu",
                        "latitude": "-14.37067000",
                        "longitude": "23.24196000"
                    },
                    {
                        "id": 131372,
                        "name": "Mongu",
                        "latitude": "-15.24835000",
                        "longitude": "23.12741000"
                    },
                    {
                        "id": 131392,
                        "name": "Senanga",
                        "latitude": "-16.11667000",
                        "longitude": "23.26667000"
                    },
                    {
                        "id": 131394,
                        "name": "Sesheke",
                        "latitude": "-17.47593000",
                        "longitude": "24.29684000"
                    }
                ]
            }
        ]
    },
    {
        "id": 247,
        "name": "Zimbabwe",
        "iso3": "ZWE",
        "iso2": "ZW",
        "numeric_code": "716",
        "phonecode": "263",
        "capital": "Harare",
        "currency": "ZWL",
        "currency_name": "Zimbabwe Dollar",
        "currency_symbol": "$",
        "tld": ".zw",
        "native": "Zimbabwe",
        "region": "Africa",
        "region_id": 1,
        "subregion": "Eastern Africa",
        "subregion_id": 4,
        "nationality": "Zimbabwean",
        "timezones": [
            {
                "zoneName": "Africa\/Harare",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "br": "Zimbabwe",
            "ko": "짐바브웨",
            "pt-BR": "Zimbabwe",
            "pt": "Zimbabué",
            "nl": "Zimbabwe",
            "hr": "Zimbabve",
            "fa": "زیمباوه",
            "de": "Simbabwe",
            "es": "Zimbabue",
            "fr": "Zimbabwe",
            "ja": "ジンバブエ",
            "it": "Zimbabwe",
            "zh-CN": "津巴布韦",
            "tr": "Zimbabve",
            "ru": "Зимбабве",
            "uk": "Зімбабве",
            "pl": "Zimbabwe"
        },
        "latitude": "-20.00000000",
        "longitude": "30.00000000",
        "emoji": "🇿🇼",
        "emojiU": "U+1F1FF U+1F1FC",
        "states": [
            {
                "id": 1956,
                "name": "Bulawayo",
                "iso2": "BU",
                "latitude": "-20.14895050",
                "longitude": "28.53310380",
                "type": "province",
                "cities": [
                    {
                        "id": 131411,
                        "name": "Bulawayo",
                        "latitude": "-20.15000000",
                        "longitude": "28.58333000"
                    }
                ]
            },
            {
                "id": 1958,
                "name": "Harare",
                "iso2": "HA",
                "latitude": "-17.82162880",
                "longitude": "31.04922590",
                "type": "province",
                "cities": [
                    {
                        "id": 131425,
                        "name": "Chitungwiza",
                        "latitude": "-18.01274000",
                        "longitude": "31.07555000"
                    },
                    {
                        "id": 131431,
                        "name": "Epworth",
                        "latitude": "-17.89000000",
                        "longitude": "31.14750000"
                    },
                    {
                        "id": 131443,
                        "name": "Harare",
                        "latitude": "-17.82772000",
                        "longitude": "31.05337000"
                    }
                ]
            },
            {
                "id": 1959,
                "name": "Manicaland",
                "iso2": "MA",
                "latitude": "-18.92163860",
                "longitude": "32.17460500",
                "type": "province",
                "cities": [
                    {
                        "id": 131410,
                        "name": "Buhera District",
                        "latitude": "-19.45658000",
                        "longitude": "31.93156000"
                    },
                    {
                        "id": 131417,
                        "name": "Chimanimani",
                        "latitude": "-19.80000000",
                        "longitude": "32.86667000"
                    },
                    {
                        "id": 131418,
                        "name": "Chimanimani District",
                        "latitude": "-19.78295000",
                        "longitude": "32.73338000"
                    },
                    {
                        "id": 131420,
                        "name": "Chipinge",
                        "latitude": "-20.18833000",
                        "longitude": "32.62365000"
                    },
                    {
                        "id": 131421,
                        "name": "Chipinge District",
                        "latitude": "-20.54959000",
                        "longitude": "32.43110000"
                    },
                    {
                        "id": 131430,
                        "name": "Dorowa Mining Lease",
                        "latitude": "-19.06667000",
                        "longitude": "31.75000000"
                    },
                    {
                        "id": 131444,
                        "name": "Headlands",
                        "latitude": "-18.27733000",
                        "longitude": "32.05150000"
                    },
                    {
                        "id": 131464,
                        "name": "Makoni District",
                        "latitude": "-18.33550000",
                        "longitude": "32.14650000"
                    },
                    {
                        "id": 131480,
                        "name": "Mutare",
                        "latitude": "-18.97070000",
                        "longitude": "32.67086000"
                    },
                    {
                        "id": 131481,
                        "name": "Mutare District",
                        "latitude": "-19.25512000",
                        "longitude": "32.44327000"
                    },
                    {
                        "id": 131482,
                        "name": "Mutasa District",
                        "latitude": "-18.66283000",
                        "longitude": "32.74547000"
                    },
                    {
                        "id": 131489,
                        "name": "Nyanga",
                        "latitude": "-18.21667000",
                        "longitude": "32.75000000"
                    },
                    {
                        "id": 131490,
                        "name": "Nyanga District",
                        "latitude": "-17.92951000",
                        "longitude": "32.76561000"
                    },
                    {
                        "id": 131491,
                        "name": "Nyazura",
                        "latitude": "-18.70587000",
                        "longitude": "32.16796000"
                    },
                    {
                        "id": 131492,
                        "name": "Odzi",
                        "latitude": "-18.96167000",
                        "longitude": "32.40557000"
                    },
                    {
                        "id": 131493,
                        "name": "Penhalonga",
                        "latitude": "-18.89112000",
                        "longitude": "32.69781000"
                    },
                    {
                        "id": 131497,
                        "name": "Rusape",
                        "latitude": "-18.52785000",
                        "longitude": "32.12843000"
                    }
                ]
            },
            {
                "id": 1955,
                "name": "Mashonaland Central",
                "iso2": "MC",
                "latitude": "-16.76442950",
                "longitude": "31.07937050",
                "type": "province",
                "cities": [
                    {
                        "id": 131405,
                        "name": "Bindura",
                        "latitude": "-17.30192000",
                        "longitude": "31.33056000"
                    },
                    {
                        "id": 131406,
                        "name": "Bindura District",
                        "latitude": "-17.21230000",
                        "longitude": "31.30300000"
                    },
                    {
                        "id": 131412,
                        "name": "Centenary",
                        "latitude": "-16.72289000",
                        "longitude": "31.11462000"
                    },
                    {
                        "id": 131413,
                        "name": "Centenary District",
                        "latitude": "-16.41667000",
                        "longitude": "31.16667000"
                    },
                    {
                        "id": 131428,
                        "name": "Concession",
                        "latitude": "-17.38333000",
                        "longitude": "30.95000000"
                    },
                    {
                        "id": 131434,
                        "name": "Glendale",
                        "latitude": "-17.35514000",
                        "longitude": "31.06718000"
                    },
                    {
                        "id": 131437,
                        "name": "Guruve District",
                        "latitude": "-16.37206000",
                        "longitude": "30.60607000"
                    },
                    {
                        "id": 131472,
                        "name": "Mazowe",
                        "latitude": "-17.50404000",
                        "longitude": "30.97388000"
                    },
                    {
                        "id": 131473,
                        "name": "Mazowe District",
                        "latitude": "-17.28080000",
                        "longitude": "30.93231000"
                    },
                    {
                        "id": 131476,
                        "name": "Mount Darwin",
                        "latitude": "-16.77251000",
                        "longitude": "31.58381000"
                    },
                    {
                        "id": 131485,
                        "name": "Mvurwi",
                        "latitude": "-17.03333000",
                        "longitude": "30.85000000"
                    },
                    {
                        "id": 131498,
                        "name": "Rushinga District",
                        "latitude": "-16.60792000",
                        "longitude": "32.31434000"
                    },
                    {
                        "id": 131500,
                        "name": "Shamva",
                        "latitude": "-17.31159000",
                        "longitude": "31.57561000"
                    },
                    {
                        "id": 131501,
                        "name": "Shamva District",
                        "latitude": "-17.12366000",
                        "longitude": "31.64146000"
                    }
                ]
            },
            {
                "id": 1951,
                "name": "Mashonaland East",
                "iso2": "ME",
                "latitude": "-18.58716420",
                "longitude": "31.26263660",
                "type": "province",
                "cities": [
                    {
                        "id": 131401,
                        "name": "Beatrice",
                        "latitude": "-18.25283000",
                        "longitude": "30.84730000"
                    },
                    {
                        "id": 131426,
                        "name": "Chivhu",
                        "latitude": "-19.02112000",
                        "longitude": "30.89218000"
                    },
                    {
                        "id": 131436,
                        "name": "Goromonzi District",
                        "latitude": "-17.80695000",
                        "longitude": "31.36372000"
                    },
                    {
                        "id": 131462,
                        "name": "Macheke",
                        "latitude": "-18.13901000",
                        "longitude": "31.84933000"
                    },
                    {
                        "id": 131466,
                        "name": "Marondera",
                        "latitude": "-18.18527000",
                        "longitude": "31.55193000"
                    },
                    {
                        "id": 131467,
                        "name": "Marondera District",
                        "latitude": "-18.29214000",
                        "longitude": "31.51252000"
                    },
                    {
                        "id": 131477,
                        "name": "Mudzi District",
                        "latitude": "-17.04711000",
                        "longitude": "32.65279000"
                    },
                    {
                        "id": 131478,
                        "name": "Murehwa",
                        "latitude": "-17.64322000",
                        "longitude": "31.78400000"
                    },
                    {
                        "id": 131479,
                        "name": "Murehwa District",
                        "latitude": "-17.80057000",
                        "longitude": "31.83083000"
                    },
                    {
                        "id": 131483,
                        "name": "Mutoko",
                        "latitude": "-17.39699000",
                        "longitude": "32.22677000"
                    },
                    {
                        "id": 131499,
                        "name": "Ruwa",
                        "latitude": "-17.88972000",
                        "longitude": "31.24472000"
                    }
                ]
            },
            {
                "id": 1953,
                "name": "Mashonaland West",
                "iso2": "MW",
                "latitude": "-17.48510290",
                "longitude": "29.78892480",
                "type": "province",
                "cities": [
                    {
                        "id": 131400,
                        "name": "Banket",
                        "latitude": "-17.38333000",
                        "longitude": "30.40000000"
                    },
                    {
                        "id": 131414,
                        "name": "Chakari",
                        "latitude": "-18.06294000",
                        "longitude": "29.89246000"
                    },
                    {
                        "id": 131415,
                        "name": "Chegutu",
                        "latitude": "-18.13021000",
                        "longitude": "30.14074000"
                    },
                    {
                        "id": 131416,
                        "name": "Chegutu District",
                        "latitude": "-18.13097000",
                        "longitude": "30.40046000"
                    },
                    {
                        "id": 131419,
                        "name": "Chinhoyi",
                        "latitude": "-17.36667000",
                        "longitude": "30.20000000"
                    },
                    {
                        "id": 131424,
                        "name": "Chirundu",
                        "latitude": "-16.03333000",
                        "longitude": "28.85000000"
                    },
                    {
                        "id": 131445,
                        "name": "Hurungwe District",
                        "latitude": "-16.41301000",
                        "longitude": "29.58580000"
                    },
                    {
                        "id": 131451,
                        "name": "Kadoma",
                        "latitude": "-18.33328000",
                        "longitude": "29.91534000"
                    },
                    {
                        "id": 131452,
                        "name": "Kadoma District",
                        "latitude": "-18.34049000",
                        "longitude": "29.82831000"
                    },
                    {
                        "id": 131454,
                        "name": "Kariba",
                        "latitude": "-16.51667000",
                        "longitude": "28.80000000"
                    },
                    {
                        "id": 131455,
                        "name": "Kariba District",
                        "latitude": "-16.91011000",
                        "longitude": "28.65983000"
                    },
                    {
                        "id": 131456,
                        "name": "Karoi",
                        "latitude": "-16.80993000",
                        "longitude": "29.69247000"
                    },
                    {
                        "id": 131463,
                        "name": "Makonde District",
                        "latitude": "-17.16667000",
                        "longitude": "30.08333000"
                    },
                    {
                        "id": 131475,
                        "name": "Mhangura",
                        "latitude": "-16.89387000",
                        "longitude": "30.16828000"
                    },
                    {
                        "id": 131488,
                        "name": "Norton",
                        "latitude": "-17.88333000",
                        "longitude": "30.70000000"
                    },
                    {
                        "id": 131495,
                        "name": "Raffingora",
                        "latitude": "-17.03333000",
                        "longitude": "30.43333000"
                    }
                ]
            },
            {
                "id": 1960,
                "name": "Masvingo",
                "iso2": "MV",
                "latitude": "-20.62415090",
                "longitude": "31.26263660",
                "type": "province",
                "cities": [
                    {
                        "id": 131404,
                        "name": "Bikita District",
                        "latitude": "-20.13752000",
                        "longitude": "31.93156000"
                    },
                    {
                        "id": 131422,
                        "name": "Chiredzi",
                        "latitude": "-21.05000000",
                        "longitude": "31.66667000"
                    },
                    {
                        "id": 131423,
                        "name": "Chiredzi District",
                        "latitude": "-21.28585000",
                        "longitude": "31.77039000"
                    },
                    {
                        "id": 131427,
                        "name": "Chivi District",
                        "latitude": "-20.50000000",
                        "longitude": "30.58333000"
                    },
                    {
                        "id": 131438,
                        "name": "Gutu District",
                        "latitude": "-19.60884000",
                        "longitude": "31.25059000"
                    },
                    {
                        "id": 131468,
                        "name": "Mashava",
                        "latitude": "-20.03665000",
                        "longitude": "30.48225000"
                    },
                    {
                        "id": 131469,
                        "name": "Masvingo",
                        "latitude": "-20.06373000",
                        "longitude": "30.82766000"
                    },
                    {
                        "id": 131470,
                        "name": "Masvingo District",
                        "latitude": "-20.31481000",
                        "longitude": "30.90008000"
                    },
                    {
                        "id": 131486,
                        "name": "Mwenezi District",
                        "latitude": "-21.35838000",
                        "longitude": "30.70668000"
                    },
                    {
                        "id": 131507,
                        "name": "Zvishavane",
                        "latitude": "-20.32674000",
                        "longitude": "30.06648000"
                    }
                ]
            },
            {
                "id": 1954,
                "name": "Matabeleland North",
                "iso2": "MN",
                "latitude": "-18.53315660",
                "longitude": "27.54958460",
                "type": "province",
                "cities": [
                    {
                        "id": 131407,
                        "name": "Binga",
                        "latitude": "-17.62027000",
                        "longitude": "27.34139000"
                    },
                    {
                        "id": 131408,
                        "name": "Binga District",
                        "latitude": "-17.80460000",
                        "longitude": "27.70088000"
                    },
                    {
                        "id": 131409,
                        "name": "Bubi District",
                        "latitude": "-19.52508000",
                        "longitude": "28.67998000"
                    },
                    {
                        "id": 131429,
                        "name": "Dete",
                        "latitude": "-18.61667000",
                        "longitude": "26.86667000"
                    },
                    {
                        "id": 131446,
                        "name": "Hwange",
                        "latitude": "-18.36446000",
                        "longitude": "26.49877000"
                    },
                    {
                        "id": 131447,
                        "name": "Hwange District",
                        "latitude": "-18.75000000",
                        "longitude": "26.50000000"
                    },
                    {
                        "id": 131450,
                        "name": "Inyati",
                        "latitude": "-19.67563000",
                        "longitude": "28.84687000"
                    },
                    {
                        "id": 131453,
                        "name": "Kamativi Mine",
                        "latitude": "-18.31563000",
                        "longitude": "27.05729000"
                    },
                    {
                        "id": 131460,
                        "name": "Lupane",
                        "latitude": "-18.93149000",
                        "longitude": "27.80696000"
                    },
                    {
                        "id": 131461,
                        "name": "Lupane District",
                        "latitude": "-18.83608000",
                        "longitude": "27.99098000"
                    },
                    {
                        "id": 131487,
                        "name": "Nkayi District",
                        "latitude": "-18.92472000",
                        "longitude": "28.71221000"
                    },
                    {
                        "id": 131506,
                        "name": "Victoria Falls",
                        "latitude": "-17.93285000",
                        "longitude": "25.83066000"
                    }
                ]
            },
            {
                "id": 1952,
                "name": "Matabeleland South",
                "iso2": "MS",
                "latitude": "-21.05233700",
                "longitude": "29.04599270",
                "type": "province",
                "cities": [
                    {
                        "id": 131402,
                        "name": "Beitbridge",
                        "latitude": "-22.21667000",
                        "longitude": "30.00000000"
                    },
                    {
                        "id": 131403,
                        "name": "Beitbridge District",
                        "latitude": "-21.89829000",
                        "longitude": "30.07409000"
                    },
                    {
                        "id": 131432,
                        "name": "Esigodini",
                        "latitude": "-20.28979000",
                        "longitude": "28.92261000"
                    },
                    {
                        "id": 131433,
                        "name": "Filabusi",
                        "latitude": "-20.53333000",
                        "longitude": "29.28502000"
                    },
                    {
                        "id": 131439,
                        "name": "Gwanda",
                        "latitude": "-20.93622000",
                        "longitude": "29.00698000"
                    },
                    {
                        "id": 131440,
                        "name": "Gwanda District",
                        "latitude": "-21.20929000",
                        "longitude": "29.17557000"
                    },
                    {
                        "id": 131448,
                        "name": "Insiza",
                        "latitude": "-19.78333000",
                        "longitude": "29.20000000"
                    },
                    {
                        "id": 131449,
                        "name": "Insiza District",
                        "latitude": "-20.26431000",
                        "longitude": "29.47392000"
                    },
                    {
                        "id": 131465,
                        "name": "Mangwe District",
                        "latitude": "-20.95545000",
                        "longitude": "27.98292000"
                    },
                    {
                        "id": 131471,
                        "name": "Matobo",
                        "latitude": "-20.95545000",
                        "longitude": "28.49463000"
                    },
                    {
                        "id": 131494,
                        "name": "Plumtree",
                        "latitude": "-20.48333000",
                        "longitude": "27.81667000"
                    },
                    {
                        "id": 131505,
                        "name": "Umzingwane District",
                        "latitude": "-20.34704000",
                        "longitude": "28.94994000"
                    }
                ]
            },
            {
                "id": 1957,
                "name": "Midlands",
                "iso2": "MI",
                "latitude": "-19.05520090",
                "longitude": "29.60354950",
                "type": "province",
                "cities": [
                    {
                        "id": 131435,
                        "name": "Gokwe",
                        "latitude": "-18.20476000",
                        "longitude": "28.93490000"
                    },
                    {
                        "id": 131441,
                        "name": "Gweru",
                        "latitude": "-19.45000000",
                        "longitude": "29.81667000"
                    },
                    {
                        "id": 131442,
                        "name": "Gweru District",
                        "latitude": "-19.45665000",
                        "longitude": "29.64495000"
                    },
                    {
                        "id": 131457,
                        "name": "Kwekwe",
                        "latitude": "-18.92809000",
                        "longitude": "29.81486000"
                    },
                    {
                        "id": 131458,
                        "name": "Kwekwe District",
                        "latitude": "-18.75000000",
                        "longitude": "29.50000000"
                    },
                    {
                        "id": 131459,
                        "name": "Lalapanzi",
                        "latitude": "-19.33225000",
                        "longitude": "30.17768000"
                    },
                    {
                        "id": 131474,
                        "name": "Mberengwa District",
                        "latitude": "-20.72579000",
                        "longitude": "30.00962000"
                    },
                    {
                        "id": 131484,
                        "name": "Mvuma",
                        "latitude": "-19.27924000",
                        "longitude": "30.52828000"
                    },
                    {
                        "id": 131496,
                        "name": "Redcliff",
                        "latitude": "-19.03333000",
                        "longitude": "29.78333000"
                    },
                    {
                        "id": 131502,
                        "name": "Shangani",
                        "latitude": "-19.78333000",
                        "longitude": "29.36667000"
                    },
                    {
                        "id": 131503,
                        "name": "Shurugwi",
                        "latitude": "-19.67016000",
                        "longitude": "30.00589000"
                    },
                    {
                        "id": 131504,
                        "name": "Shurugwi District",
                        "latitude": "-19.75000000",
                        "longitude": "30.16667000"
                    },
                    {
                        "id": 131508,
                        "name": "Zvishavane District",
                        "latitude": "-20.30345000",
                        "longitude": "30.07514000"
                    }
                ]
            }
        ]
    }
]
